/**
* plotly.js v1.57.1
* Copyright 2012-2020, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/
(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Plotly = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
  'use strict';
  
  var Lib = _dereq_('../src/lib');
  var rules = {
      "X,X div": "direction:ltr;font-family:'Open Sans', verdana, arial, sans-serif;margin:0;padding:0;",
      "X input,X button": "font-family:'Open Sans', verdana, arial, sans-serif;",
      "X input:focus,X button:focus": "outline:none;",
      "X a": "text-decoration:none;",
      "X a:hover": "text-decoration:none;",
      "X .crisp": "shape-rendering:crispEdges;",
      "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
      "X svg": "overflow:hidden;",
      "X svg a": "fill:#447adb;",
      "X svg a:hover": "fill:#3c6dc5;",
      "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
      "X .main-svg .draglayer": "pointer-events:all;",
      "X .cursor-default": "cursor:default;",
      "X .cursor-pointer": "cursor:pointer;",
      "X .cursor-crosshair": "cursor:crosshair;",
      "X .cursor-move": "cursor:move;",
      "X .cursor-col-resize": "cursor:col-resize;",
      "X .cursor-row-resize": "cursor:row-resize;",
      "X .cursor-ns-resize": "cursor:ns-resize;",
      "X .cursor-ew-resize": "cursor:ew-resize;",
      "X .cursor-sw-resize": "cursor:sw-resize;",
      "X .cursor-s-resize": "cursor:s-resize;",
      "X .cursor-se-resize": "cursor:se-resize;",
      "X .cursor-w-resize": "cursor:w-resize;",
      "X .cursor-e-resize": "cursor:e-resize;",
      "X .cursor-nw-resize": "cursor:nw-resize;",
      "X .cursor-n-resize": "cursor:n-resize;",
      "X .cursor-ne-resize": "cursor:ne-resize;",
      "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
      "X .modebar": "position:absolute;top:2px;right:2px;",
      "X .ease-bg": "-webkit-transition:background-color 0.3s ease 0s;-moz-transition:background-color 0.3s ease 0s;-ms-transition:background-color 0.3s ease 0s;-o-transition:background-color 0.3s ease 0s;transition:background-color 0.3s ease 0s;",
      "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity 0.3s ease 0s;-moz-transition:opacity 0.3s ease 0s;-ms-transition:opacity 0.3s ease 0s;-o-transition:opacity 0.3s ease 0s;transition:opacity 0.3s ease 0s;",
      "X:hover .modebar--hover .modebar-group": "opacity:1;",
      "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
      "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
      "X .modebar-btn svg": "position:relative;top:2px;",
      "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
      "X .modebar.vertical svg": "top:-1px;",
      "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
      "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
      "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
      "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
      "X [data-title]:before": "content:'';position:absolute;background:transparent;border:6px solid transparent;z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;",
      "X [data-title]:after": "content:attr(data-title);background:#69738a;color:white;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
      "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
      "X .vertical [data-title]:before": "border:6px solid transparent;border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
      "X .select-outline": "fill:none;stroke-width:1;shape-rendering:crispEdges;",
      "X .select-outline-1": "stroke:white;",
      "X .select-outline-2": "stroke:black;stroke-dasharray:2px 2px;",
      Y: "font-family:'Open Sans', verdana, arial, sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;",
      "Y p": "margin:0;",
      "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,0.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
      "Y .notifier-close": "color:#fff;opacity:0.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
      "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
  };
  
  for(var selector in rules) {
      var fullSelector = selector.replace(/^,/,' ,')
          .replace(/X/g, '.js-plotly-plot .plotly')
          .replace(/Y/g, '.plotly-notifier');
      Lib.addStyleRule(fullSelector, rules[selector]);
  }
  
  },{"../src/lib":750}],2:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/transforms/aggregate');
  
  },{"../src/transforms/aggregate":1336}],3:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/bar');
  
  },{"../src/traces/bar":900}],4:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/barpolar');
  
  },{"../src/traces/barpolar":913}],5:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/box');
  
  },{"../src/traces/box":923}],6:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/components/calendars');
  
  },{"../src/components/calendars":613}],7:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/candlestick');
  
  },{"../src/traces/candlestick":932}],8:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/carpet');
  
  },{"../src/traces/carpet":951}],9:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/choropleth');
  
  },{"../src/traces/choropleth":965}],10:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/choroplethmapbox');
  
  },{"../src/traces/choroplethmapbox":972}],11:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/cone');
  
  },{"../src/traces/cone":978}],12:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/contour');
  
  },{"../src/traces/contour":993}],13:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/contourcarpet');
  
  },{"../src/traces/contourcarpet":1004}],14:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/core');
  
  },{"../src/core":727}],15:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/densitymapbox');
  
  },{"../src/traces/densitymapbox":1012}],16:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/transforms/filter');
  
  },{"../src/transforms/filter":1337}],17:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/funnel');
  
  },{"../src/traces/funnel":1022}],18:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/funnelarea');
  
  },{"../src/traces/funnelarea":1031}],19:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/transforms/groupby');
  
  },{"../src/transforms/groupby":1338}],20:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/heatmap');
  
  },{"../src/traces/heatmap":1044}],21:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/heatmapgl');
  
  },{"../src/traces/heatmapgl":1054}],22:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/histogram');
  
  },{"../src/traces/histogram":1066}],23:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/histogram2d');
  
  },{"../src/traces/histogram2d":1072}],24:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/histogram2dcontour');
  
  },{"../src/traces/histogram2dcontour":1076}],25:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/image');
  
  },{"../src/traces/image":1084}],26:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Plotly = _dereq_('./core');
  
  // traces
  Plotly.register([
      _dereq_('./bar'),
      _dereq_('./box'),
      _dereq_('./heatmap'),
      _dereq_('./histogram'),
      _dereq_('./histogram2d'),
      _dereq_('./histogram2dcontour'),
      _dereq_('./contour'),
      _dereq_('./scatterternary'),
      _dereq_('./violin'),
      _dereq_('./funnel'),
      _dereq_('./waterfall'),
      _dereq_('./image'),
  
      _dereq_('./pie'),
      _dereq_('./sunburst'),
      _dereq_('./treemap'),
      _dereq_('./funnelarea'),
  
      _dereq_('./scatter3d'),
      _dereq_('./surface'),
      _dereq_('./isosurface'),
      _dereq_('./volume'),
      _dereq_('./mesh3d'),
      _dereq_('./cone'),
      _dereq_('./streamtube'),
  
      _dereq_('./scattergeo'),
      _dereq_('./choropleth'),
  
      _dereq_('./scattergl'),
      _dereq_('./splom'),
  
      _dereq_('./pointcloud'),
      _dereq_('./heatmapgl'),
  
      _dereq_('./parcoords'),
  
      _dereq_('./parcats'),
  
      _dereq_('./scattermapbox'),
      _dereq_('./choroplethmapbox'),
      _dereq_('./densitymapbox'),
  
      _dereq_('./sankey'),
      _dereq_('./indicator'),
  
      _dereq_('./table'),
  
      _dereq_('./carpet'),
      _dereq_('./scattercarpet'),
      _dereq_('./contourcarpet'),
  
      _dereq_('./ohlc'),
      _dereq_('./candlestick'),
  
      _dereq_('./scatterpolar'),
      _dereq_('./scatterpolargl'),
      _dereq_('./barpolar')
  ]);
  
  // transforms
  //
  // Please note that all *transform* methods are executed before
  // all *calcTransform* methods - which could possibly lead to
  // unexpected results when applying multiple transforms of different types
  // to a given trace.
  //
  // For more info, see:
  // https://github.com/plotly/plotly.js/pull/978#pullrequestreview-2403353
  //
  Plotly.register([
      _dereq_('./aggregate'),
      _dereq_('./filter'),
      _dereq_('./groupby'),
      _dereq_('./sort')
  ]);
  
  // components
  Plotly.register([
      _dereq_('./calendars')
  ]);
  
  module.exports = Plotly;
  
  },{"./aggregate":2,"./bar":3,"./barpolar":4,"./box":5,"./calendars":6,"./candlestick":7,"./carpet":8,"./choropleth":9,"./choroplethmapbox":10,"./cone":11,"./contour":12,"./contourcarpet":13,"./core":14,"./densitymapbox":15,"./filter":16,"./funnel":17,"./funnelarea":18,"./groupby":19,"./heatmap":20,"./heatmapgl":21,"./histogram":22,"./histogram2d":23,"./histogram2dcontour":24,"./image":25,"./indicator":27,"./isosurface":28,"./mesh3d":29,"./ohlc":30,"./parcats":31,"./parcoords":32,"./pie":33,"./pointcloud":34,"./sankey":35,"./scatter3d":36,"./scattercarpet":37,"./scattergeo":38,"./scattergl":39,"./scattermapbox":40,"./scatterpolar":41,"./scatterpolargl":42,"./scatterternary":43,"./sort":44,"./splom":45,"./streamtube":46,"./sunburst":47,"./surface":48,"./table":49,"./treemap":50,"./violin":51,"./volume":52,"./waterfall":53}],27:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/indicator');
  
  },{"../src/traces/indicator":1092}],28:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/isosurface');
  
  },{"../src/traces/isosurface":1098}],29:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/mesh3d');
  
  },{"../src/traces/mesh3d":1103}],30:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/ohlc');
  
  },{"../src/traces/ohlc":1108}],31:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/parcats');
  
  },{"../src/traces/parcats":1117}],32:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/parcoords');
  
  },{"../src/traces/parcoords":1127}],33:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/pie');
  
  },{"../src/traces/pie":1138}],34:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/pointcloud');
  
  },{"../src/traces/pointcloud":1147}],35:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/sankey');
  
  },{"../src/traces/sankey":1153}],36:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/scatter3d');
  
  },{"../src/traces/scatter3d":1191}],37:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/scattercarpet');
  
  },{"../src/traces/scattercarpet":1198}],38:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/scattergeo');
  
  },{"../src/traces/scattergeo":1206}],39:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/scattergl');
  
  },{"../src/traces/scattergl":1219}],40:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/scattermapbox');
  
  },{"../src/traces/scattermapbox":1229}],41:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/scatterpolar');
  
  },{"../src/traces/scatterpolar":1237}],42:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/scatterpolargl');
  
  },{"../src/traces/scatterpolargl":1244}],43:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/scatterternary');
  
  },{"../src/traces/scatterternary":1252}],44:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/transforms/sort');
  
  },{"../src/transforms/sort":1340}],45:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/splom');
  
  },{"../src/traces/splom":1261}],46:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/streamtube');
  
  },{"../src/traces/streamtube":1269}],47:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/sunburst');
  
  },{"../src/traces/sunburst":1277}],48:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/surface');
  
  },{"../src/traces/surface":1286}],49:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/table');
  
  },{"../src/traces/table":1294}],50:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/treemap');
  
  },{"../src/traces/treemap":1303}],51:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/violin');
  
  },{"../src/traces/violin":1315}],52:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/volume');
  
  },{"../src/traces/volume":1323}],53:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = _dereq_('../src/traces/waterfall');
  
  },{"../src/traces/waterfall":1331}],54:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createViewController
  
  var createTurntable = _dereq_('turntable-camera-controller')
  var createOrbit     = _dereq_('orbit-camera-controller')
  var createMatrix    = _dereq_('matrix-camera-controller')
  
  function ViewController(controllers, mode) {
    this._controllerNames = Object.keys(controllers)
    this._controllerList = this._controllerNames.map(function(n) {
      return controllers[n]
    })
    this._mode   = mode
    this._active = controllers[mode]
    if(!this._active) {
      this._mode   = 'turntable'
      this._active = controllers.turntable
    }
    this.modes = this._controllerNames
    this.computedMatrix = this._active.computedMatrix
    this.computedEye    = this._active.computedEye
    this.computedUp     = this._active.computedUp
    this.computedCenter = this._active.computedCenter
    this.computedRadius = this._active.computedRadius
  }
  
  var proto = ViewController.prototype
  
  var COMMON_METHODS = [
    ['flush', 1],
    ['idle', 1],
    ['lookAt', 4],
    ['rotate', 4],
    ['pan', 4],
    ['translate', 4],
    ['setMatrix', 2],
    ['setDistanceLimits', 2],
    ['setDistance', 2]
  ]
  
  COMMON_METHODS.forEach(function(method) {
    var name = method[0]
    var argNames = []
    for(var i=0; i<method[1]; ++i) {
      argNames.push('a'+i)
    }
    var code = 'var cc=this._controllerList;for(var i=0;i<cc.length;++i){cc[i].'+method[0]+'('+argNames.join()+')}'
    proto[name] = Function.apply(null, argNames.concat(code))
  })
  
  proto.recalcMatrix = function(t) {
    this._active.recalcMatrix(t)
  }
  
  proto.getDistance = function(t) {
    return this._active.getDistance(t)
  }
  proto.getDistanceLimits = function(out) {
    return this._active.getDistanceLimits(out)
  }
  
  proto.lastT = function() {
    return this._active.lastT()
  }
  
  proto.setMode = function(mode) {
    if(mode === this._mode) {
      return
    }
    var idx = this._controllerNames.indexOf(mode)
    if(idx < 0) {
      return
    }
    var prev  = this._active
    var next  = this._controllerList[idx]
    var lastT = Math.max(prev.lastT(), next.lastT())
  
    prev.recalcMatrix(lastT)
    next.setMatrix(lastT, prev.computedMatrix)
    
    this._active = next
    this._mode   = mode
  
    //Update matrix properties
    this.computedMatrix = this._active.computedMatrix
    this.computedEye    = this._active.computedEye
    this.computedUp     = this._active.computedUp
    this.computedCenter = this._active.computedCenter
    this.computedRadius = this._active.computedRadius
  }
  
  proto.getMode = function() {
    return this._mode
  }
  
  function createViewController(options) {
    options = options || {}
  
    var eye       = options.eye    || [0,0,1]
    var center    = options.center || [0,0,0]
    var up        = options.up     || [0,1,0]
    var limits    = options.distanceLimits || [0, Infinity]
    var mode      = options.mode   || 'turntable'
  
    var turntable = createTurntable()
    var orbit     = createOrbit()
    var matrix    = createMatrix()
  
    turntable.setDistanceLimits(limits[0], limits[1])
    turntable.lookAt(0, eye, center, up)
    orbit.setDistanceLimits(limits[0], limits[1])
    orbit.lookAt(0, eye, center, up)
    matrix.setDistanceLimits(limits[0], limits[1])
    matrix.lookAt(0, eye, center, up)
  
    return new ViewController({
      turntable: turntable,
      orbit: orbit,
      matrix: matrix
    }, mode)
  }
  },{"matrix-camera-controller":454,"orbit-camera-controller":475,"turntable-camera-controller":553}],55:[function(_dereq_,module,exports){
  (function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-array'), _dereq_('d3-collection'), _dereq_('d3-shape'), _dereq_('elementary-circuits-directed-graph')) :
    typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-shape', 'elementary-circuits-directed-graph'], factory) :
    (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,null));
  }(this, (function (exports,d3Array,d3Collection,d3Shape,findCircuits) { 'use strict';
  
    findCircuits = findCircuits && findCircuits.hasOwnProperty('default') ? findCircuits['default'] : findCircuits;
  
    // For a given link, return the target node's depth
    function targetDepth(d) {
      return d.target.depth;
    }
  
    // The depth of a node when the nodeAlign (align) is set to 'left'
    function left(node) {
      return node.depth;
    }
  
    // The depth of a node when the nodeAlign (align) is set to 'right'
    function right(node, n) {
      return n - 1 - node.height;
    }
  
    // The depth of a node when the nodeAlign (align) is set to 'justify'
    function justify(node, n) {
      return node.sourceLinks.length ? node.depth : n - 1;
    }
  
    // The depth of a node when the nodeAlign (align) is set to 'center'
    function center(node) {
      return node.targetLinks.length ? node.depth : node.sourceLinks.length ? d3Array.min(node.sourceLinks, targetDepth) - 1 : 0;
    }
  
    // returns a function, using the parameter given to the sankey setting
    function constant(x) {
      return function () {
        return x;
      };
    }
  
    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  
    /// https://github.com/tomshanley/d3-sankeyCircular-circular
  
    // sort links' breadth (ie top to bottom in a column), based on their source nodes' breadths
    function ascendingSourceBreadth(a, b) {
      return ascendingBreadth(a.source, b.source) || a.index - b.index;
    }
  
    // sort links' breadth (ie top to bottom in a column), based on their target nodes' breadths
    function ascendingTargetBreadth(a, b) {
      return ascendingBreadth(a.target, b.target) || a.index - b.index;
    }
  
    // sort nodes' breadth (ie top to bottom in a column)
    // if both nodes have circular links, or both don't have circular links, then sort by the top (y0) of the node
    // else push nodes that have top circular links to the top, and nodes that have bottom circular links to the bottom
    function ascendingBreadth(a, b) {
      if (a.partOfCycle === b.partOfCycle) {
        return a.y0 - b.y0;
      } else {
        if (a.circularLinkType === 'top' || b.circularLinkType === 'bottom') {
          return -1;
        } else {
          return 1;
        }
      }
    }
  
    // return the value of a node or link
    function value(d) {
      return d.value;
    }
  
    // return the vertical center of a node
    function nodeCenter(node) {
      return (node.y0 + node.y1) / 2;
    }
  
    // return the vertical center of a link's source node
    function linkSourceCenter(link) {
      return nodeCenter(link.source);
    }
  
    // return the vertical center of a link's target node
    function linkTargetCenter(link) {
      return nodeCenter(link.target);
    }
  
    // Return the default value for ID for node, d.index
    function defaultId(d) {
      return d.index;
    }
  
    // Return the default object the graph's nodes, graph.nodes
    function defaultNodes(graph) {
      return graph.nodes;
    }
  
    // Return the default object the graph's nodes, graph.links
    function defaultLinks(graph) {
      return graph.links;
    }
  
    // Return the node from the collection that matches the provided ID, or throw an error if no match
    function find(nodeById, id) {
      var node = nodeById.get(id);
      if (!node) throw new Error('missing: ' + id);
      return node;
    }
  
    function getNodeID(node, id) {
      return id(node);
    }
  
    // The main sankeyCircular functions
  
    // Some constants for circular link calculations
    var verticalMargin = 25;
    var baseRadius = 10;
    var scale = 0.3; //Possibly let user control this, although anything over 0.5 starts to get too cramped
  
    function sankeyCircular () {
      // Set the default values
      var x0 = 0,
          y0 = 0,
          x1 = 1,
          y1 = 1,
          // extent
      dx = 24,
          // nodeWidth
      py,
          // nodePadding, for vertical postioning
      id = defaultId,
          align = justify,
          nodes = defaultNodes,
          links = defaultLinks,
          iterations = 32,
          circularLinkGap = 2,
          paddingRatio,
          sortNodes = null;
  
      function sankeyCircular() {
        var graph = {
          nodes: nodes.apply(null, arguments),
          links: links.apply(null, arguments)
  
          // Process the graph's nodes and links, setting their positions
  
          // 1.  Associate the nodes with their respective links, and vice versa
        };computeNodeLinks(graph);
  
        // 2.  Determine which links result in a circular path in the graph
        identifyCircles(graph, id, sortNodes);
  
        // 4. Calculate the nodes' values, based on the values of the incoming and outgoing links
        computeNodeValues(graph);
  
        // 5.  Calculate the nodes' depth based on the incoming and outgoing links
        //     Sets the nodes':
        //     - depth:  the depth in the graph
        //     - column: the depth (0, 1, 2, etc), as is relates to visual position from left to right
        //     - x0, x1: the x coordinates, as is relates to visual position from left to right
        computeNodeDepths(graph);
  
        // 3.  Determine how the circular links will be drawn,
        //     either travelling back above the main chart ("top")
        //     or below the main chart ("bottom")
        selectCircularLinkTypes(graph, id);
  
        // 6.  Calculate the nodes' and links' vertical position within their respective column
        //     Also readjusts sankeyCircular size if circular links are needed, and node x's
        computeNodeBreadths(graph, iterations, id);
        computeLinkBreadths(graph);
  
        // 7.  Sort links per node, based on the links' source/target nodes' breadths
        // 8.  Adjust nodes that overlap links that span 2+ columns
        var linkSortingIterations = 4; //Possibly let user control this number, like the iterations over node placement
        for (var iteration = 0; iteration < linkSortingIterations; iteration++) {
  
          sortSourceLinks(graph, y1, id);
          sortTargetLinks(graph, y1, id);
          resolveNodeLinkOverlaps(graph, y0, y1, id);
          sortSourceLinks(graph, y1, id);
          sortTargetLinks(graph, y1, id);
        }
  
        // 8.1  Adjust node and link positions back to fill height of chart area if compressed
        fillHeight(graph, y0, y1);
  
        // 9. Calculate visually appealling path for the circular paths, and create the "d" string
        addCircularPathData(graph, circularLinkGap, y1, id);
  
        return graph;
      } // end of sankeyCircular function
  
  
      // Set the sankeyCircular parameters
      // nodeID, nodeAlign, nodeWidth, nodePadding, nodes, links, size, extent, iterations, nodePaddingRatio, circularLinkGap
      sankeyCircular.nodeId = function (_) {
        return arguments.length ? (id = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : id;
      };
  
      sankeyCircular.nodeAlign = function (_) {
        return arguments.length ? (align = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : align;
      };
  
      sankeyCircular.nodeWidth = function (_) {
        return arguments.length ? (dx = +_, sankeyCircular) : dx;
      };
  
      sankeyCircular.nodePadding = function (_) {
        return arguments.length ? (py = +_, sankeyCircular) : py;
      };
  
      sankeyCircular.nodes = function (_) {
        return arguments.length ? (nodes = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : nodes;
      };
  
      sankeyCircular.links = function (_) {
        return arguments.length ? (links = typeof _ === 'function' ? _ : constant(_), sankeyCircular) : links;
      };
  
      sankeyCircular.size = function (_) {
        return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankeyCircular) : [x1 - x0, y1 - y0];
      };
  
      sankeyCircular.extent = function (_) {
        return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankeyCircular) : [[x0, y0], [x1, y1]];
      };
  
      sankeyCircular.iterations = function (_) {
        return arguments.length ? (iterations = +_, sankeyCircular) : iterations;
      };
  
      sankeyCircular.circularLinkGap = function (_) {
        return arguments.length ? (circularLinkGap = +_, sankeyCircular) : circularLinkGap;
      };
  
      sankeyCircular.nodePaddingRatio = function (_) {
        return arguments.length ? (paddingRatio = +_, sankeyCircular) : paddingRatio;
      };
  
      sankeyCircular.sortNodes = function (_) {
        return arguments.length ? (sortNodes = _, sankeyCircular) : sortNodes;
      };
  
      sankeyCircular.update = function (graph) {
        // 5.  Calculate the nodes' depth based on the incoming and outgoing links
        //     Sets the nodes':
        //     - depth:  the depth in the graph
        //     - column: the depth (0, 1, 2, etc), as is relates to visual position from left to right
        //     - x0, x1: the x coordinates, as is relates to visual position from left to right
        // computeNodeDepths(graph)
  
        // 3.  Determine how the circular links will be drawn,
        //     either travelling back above the main chart ("top")
        //     or below the main chart ("bottom")
        selectCircularLinkTypes(graph, id);
  
        // 6.  Calculate the nodes' and links' vertical position within their respective column
        //     Also readjusts sankeyCircular size if circular links are needed, and node x's
        // computeNodeBreadths(graph, iterations, id)
        computeLinkBreadths(graph);
  
        // Force position of circular link type based on position
        graph.links.forEach(function (link) {
          if (link.circular) {
            link.circularLinkType = link.y0 + link.y1 < y1 ? 'top' : 'bottom';
  
            link.source.circularLinkType = link.circularLinkType;
            link.target.circularLinkType = link.circularLinkType;
          }
        });
  
        sortSourceLinks(graph, y1, id, false); // Sort links but do not move nodes
        sortTargetLinks(graph, y1, id);
  
        // 7.  Sort links per node, based on the links' source/target nodes' breadths
        // 8.  Adjust nodes that overlap links that span 2+ columns
        // var linkSortingIterations = 4; //Possibly let user control this number, like the iterations over node placement
        // for (var iteration = 0; iteration < linkSortingIterations; iteration++) {
        //
        //   sortSourceLinks(graph, y1, id)
        //   sortTargetLinks(graph, y1, id)
        //   resolveNodeLinkOverlaps(graph, y0, y1, id)
        //   sortSourceLinks(graph, y1, id)
        //   sortTargetLinks(graph, y1, id)
        //
        // }
  
        // 8.1  Adjust node and link positions back to fill height of chart area if compressed
        // fillHeight(graph, y0, y1)
  
        // 9. Calculate visually appealling path for the circular paths, and create the "d" string
        addCircularPathData(graph, circularLinkGap, y1, id);
        return graph;
      };
  
      // Populate the sourceLinks and targetLinks for each node.
      // Also, if the source and target are not objects, assume they are indices.
      function computeNodeLinks(graph) {
        graph.nodes.forEach(function (node, i) {
          node.index = i;
          node.sourceLinks = [];
          node.targetLinks = [];
        });
        var nodeById = d3Collection.map(graph.nodes, id);
        graph.links.forEach(function (link, i) {
          link.index = i;
          var source = link.source;
          var target = link.target;
          if ((typeof source === "undefined" ? "undefined" : _typeof(source)) !== 'object') {
            source = link.source = find(nodeById, source);
          }
          if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== 'object') {
            target = link.target = find(nodeById, target);
          }
          source.sourceLinks.push(link);
          target.targetLinks.push(link);
        });
        return graph;
      }
  
      // Compute the value (size) and cycleness of each node by summing the associated links.
      function computeNodeValues(graph) {
        graph.nodes.forEach(function (node) {
          node.partOfCycle = false;
          node.value = Math.max(d3Array.sum(node.sourceLinks, value), d3Array.sum(node.targetLinks, value));
          node.sourceLinks.forEach(function (link) {
            if (link.circular) {
              node.partOfCycle = true;
              node.circularLinkType = link.circularLinkType;
            }
          });
          node.targetLinks.forEach(function (link) {
            if (link.circular) {
              node.partOfCycle = true;
              node.circularLinkType = link.circularLinkType;
            }
          });
        });
      }
  
      function getCircleMargins(graph) {
        var totalTopLinksWidth = 0,
            totalBottomLinksWidth = 0,
            totalRightLinksWidth = 0,
            totalLeftLinksWidth = 0;
  
        var maxColumn = d3Array.max(graph.nodes, function (node) {
          return node.column;
        });
  
        graph.links.forEach(function (link) {
          if (link.circular) {
            if (link.circularLinkType == 'top') {
              totalTopLinksWidth = totalTopLinksWidth + link.width;
            } else {
              totalBottomLinksWidth = totalBottomLinksWidth + link.width;
            }
  
            if (link.target.column == 0) {
              totalLeftLinksWidth = totalLeftLinksWidth + link.width;
            }
  
            if (link.source.column == maxColumn) {
              totalRightLinksWidth = totalRightLinksWidth + link.width;
            }
          }
        });
  
        //account for radius of curves and padding between links
        totalTopLinksWidth = totalTopLinksWidth > 0 ? totalTopLinksWidth + verticalMargin + baseRadius : totalTopLinksWidth;
        totalBottomLinksWidth = totalBottomLinksWidth > 0 ? totalBottomLinksWidth + verticalMargin + baseRadius : totalBottomLinksWidth;
        totalRightLinksWidth = totalRightLinksWidth > 0 ? totalRightLinksWidth + verticalMargin + baseRadius : totalRightLinksWidth;
        totalLeftLinksWidth = totalLeftLinksWidth > 0 ? totalLeftLinksWidth + verticalMargin + baseRadius : totalLeftLinksWidth;
  
        return { "top": totalTopLinksWidth, "bottom": totalBottomLinksWidth, "left": totalLeftLinksWidth, "right": totalRightLinksWidth };
      }
  
      // Update the x0, y0, x1 and y1 for the sankeyCircular, to allow space for any circular links
      function scaleSankeySize(graph, margin) {
  
        var maxColumn = d3Array.max(graph.nodes, function (node) {
          return node.column;
        });
  
        var currentWidth = x1 - x0;
        var currentHeight = y1 - y0;
  
        var newWidth = currentWidth + margin.right + margin.left;
        var newHeight = currentHeight + margin.top + margin.bottom;
  
        var scaleX = currentWidth / newWidth;
        var scaleY = currentHeight / newHeight;
  
        x0 = x0 * scaleX + margin.left;
        x1 = margin.right == 0 ? x1 : x1 * scaleX;
        y0 = y0 * scaleY + margin.top;
        y1 = y1 * scaleY;
  
        graph.nodes.forEach(function (node) {
          node.x0 = x0 + node.column * ((x1 - x0 - dx) / maxColumn);
          node.x1 = node.x0 + dx;
        });
  
        return scaleY;
      }
  
      // Iteratively assign the depth for each node.
      // Nodes are assigned the maximum depth of incoming neighbors plus one;
      // nodes with no incoming links are assigned depth zero, while
      // nodes with no outgoing links are assigned the maximum depth.
      function computeNodeDepths(graph) {
        var nodes, next, x;
  
        for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
          nodes.forEach(function (node) {
            node.depth = x;
            node.sourceLinks.forEach(function (link) {
              if (next.indexOf(link.target) < 0 && !link.circular) {
                next.push(link.target);
              }
            });
          });
        }
  
        for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
          nodes.forEach(function (node) {
            node.height = x;
            node.targetLinks.forEach(function (link) {
              if (next.indexOf(link.source) < 0 && !link.circular) {
                next.push(link.source);
              }
            });
          });
        }
  
        // assign column numbers, and get max value
        graph.nodes.forEach(function (node) {
          node.column = Math.floor(align.call(null, node, x));
        });
      }
  
      // Assign nodes' breadths, and then shift nodes that overlap (resolveCollisions)
      function computeNodeBreadths(graph, iterations, id) {
        var columns = d3Collection.nest().key(function (d) {
          return d.column;
        }).sortKeys(d3Array.ascending).entries(graph.nodes).map(function (d) {
          return d.values;
        });
  
        initializeNodeBreadth(id);
        resolveCollisions();
  
        for (var alpha = 1, n = iterations; n > 0; --n) {
          relaxLeftAndRight(alpha *= 0.99, id);
          resolveCollisions();
        }
  
        function initializeNodeBreadth(id) {
  
          //override py if nodePadding has been set
          if (paddingRatio) {
            var padding = Infinity;
            columns.forEach(function (nodes) {
              var thisPadding = y1 * paddingRatio / (nodes.length + 1);
              padding = thisPadding < padding ? thisPadding : padding;
            });
            py = padding;
          }
  
          var ky = d3Array.min(columns, function (nodes) {
            return (y1 - y0 - (nodes.length - 1) * py) / d3Array.sum(nodes, value);
          });
  
          //calculate the widths of the links
          ky = ky * scale;
  
          graph.links.forEach(function (link) {
            link.width = link.value * ky;
          });
  
          //determine how much to scale down the chart, based on circular links
          var margin = getCircleMargins(graph);
          var ratio = scaleSankeySize(graph, margin);
  
          //re-calculate widths
          ky = ky * ratio;
  
          graph.links.forEach(function (link) {
            link.width = link.value * ky;
          });
  
          columns.forEach(function (nodes) {
            var nodesLength = nodes.length;
            nodes.forEach(function (node, i) {
              if (node.depth == columns.length - 1 && nodesLength == 1) {
                node.y0 = y1 / 2 - node.value * ky;
                node.y1 = node.y0 + node.value * ky;
              } else if (node.depth == 0 && nodesLength == 1) {
                node.y0 = y1 / 2 - node.value * ky;
                node.y1 = node.y0 + node.value * ky;
              } else if (node.partOfCycle) {
                if (numberOfNonSelfLinkingCycles(node, id) == 0) {
                  node.y0 = y1 / 2 + i;
                  node.y1 = node.y0 + node.value * ky;
                } else if (node.circularLinkType == 'top') {
                  node.y0 = y0 + i;
                  node.y1 = node.y0 + node.value * ky;
                } else {
                  node.y0 = y1 - node.value * ky - i;
                  node.y1 = node.y0 + node.value * ky;
                }
              } else {
                if (margin.top == 0 || margin.bottom == 0) {
                  node.y0 = (y1 - y0) / nodesLength * i;
                  node.y1 = node.y0 + node.value * ky;
                } else {
                  node.y0 = (y1 - y0) / 2 - nodesLength / 2 + i;
                  node.y1 = node.y0 + node.value * ky;
                }
              }
            });
          });
        }
  
        // For each node in each column, check the node's vertical position in relation to its targets and sources vertical position
        // and shift up/down to be closer to the vertical middle of those targets and sources
        function relaxLeftAndRight(alpha, id) {
          var columnsLength = columns.length;
  
          columns.forEach(function (nodes) {
            var n = nodes.length;
            var depth = nodes[0].depth;
  
            nodes.forEach(function (node) {
              // check the node is not an orphan
              var nodeHeight;
              if (node.sourceLinks.length || node.targetLinks.length) {
                if (node.partOfCycle && numberOfNonSelfLinkingCycles(node, id) > 0) ; else if (depth == 0 && n == 1) {
                  nodeHeight = node.y1 - node.y0;
  
                  node.y0 = y1 / 2 - nodeHeight / 2;
                  node.y1 = y1 / 2 + nodeHeight / 2;
                } else if (depth == columnsLength - 1 && n == 1) {
                  nodeHeight = node.y1 - node.y0;
  
                  node.y0 = y1 / 2 - nodeHeight / 2;
                  node.y1 = y1 / 2 + nodeHeight / 2;
                } else {
                  var avg = 0;
  
                  var avgTargetY = d3Array.mean(node.sourceLinks, linkTargetCenter);
                  var avgSourceY = d3Array.mean(node.targetLinks, linkSourceCenter);
  
                  if (avgTargetY && avgSourceY) {
                    avg = (avgTargetY + avgSourceY) / 2;
                  } else {
                    avg = avgTargetY || avgSourceY;
                  }
  
                  var dy = (avg - nodeCenter(node)) * alpha;
                  // positive if it node needs to move down
                  node.y0 += dy;
                  node.y1 += dy;
                }
              }
            });
          });
        }
  
        // For each column, check if nodes are overlapping, and if so, shift up/down
        function resolveCollisions() {
          columns.forEach(function (nodes) {
            var node,
                dy,
                y = y0,
                n = nodes.length,
                i;
  
            // Push any overlapping nodes down.
            nodes.sort(ascendingBreadth);
  
            for (i = 0; i < n; ++i) {
              node = nodes[i];
              dy = y - node.y0;
  
              if (dy > 0) {
                node.y0 += dy;
                node.y1 += dy;
              }
              y = node.y1 + py;
            }
  
            // If the bottommost node goes outside the bounds, push it back up.
            dy = y - py - y1;
            if (dy > 0) {
              y = node.y0 -= dy, node.y1 -= dy;
  
              // Push any overlapping nodes back up.
              for (i = n - 2; i >= 0; --i) {
                node = nodes[i];
                dy = node.y1 + py - y;
                if (dy > 0) node.y0 -= dy, node.y1 -= dy;
                y = node.y0;
              }
            }
          });
        }
      }
  
      // Assign the links y0 and y1 based on source/target nodes position,
      // plus the link's relative position to other links to the same node
      function computeLinkBreadths(graph) {
        graph.nodes.forEach(function (node) {
          node.sourceLinks.sort(ascendingTargetBreadth);
          node.targetLinks.sort(ascendingSourceBreadth);
        });
        graph.nodes.forEach(function (node) {
          var y0 = node.y0;
          var y1 = y0;
  
          // start from the bottom of the node for cycle links
          var y0cycle = node.y1;
          var y1cycle = y0cycle;
  
          node.sourceLinks.forEach(function (link) {
            if (link.circular) {
              link.y0 = y0cycle - link.width / 2;
              y0cycle = y0cycle - link.width;
            } else {
              link.y0 = y0 + link.width / 2;
              y0 += link.width;
            }
          });
          node.targetLinks.forEach(function (link) {
            if (link.circular) {
              link.y1 = y1cycle - link.width / 2;
              y1cycle = y1cycle - link.width;
            } else {
              link.y1 = y1 + link.width / 2;
              y1 += link.width;
            }
          });
        });
      }
  
      return sankeyCircular;
    }
  
    /// /////////////////////////////////////////////////////////////////////////////////
    // Cycle functions
    // portion of code to detect circular links based on Colin Fergus' bl.ock https://gist.github.com/cfergus/3956043
  
    // Identify circles in the link objects
    function identifyCircles(graph, id, sortNodes) {
      var circularLinkID = 0;
      if (sortNodes === null) {
  
        // Building adjacency graph
        var adjList = [];
        for (var i = 0; i < graph.links.length; i++) {
          var link = graph.links[i];
          var source = link.source.index;
          var target = link.target.index;
          if (!adjList[source]) adjList[source] = [];
          if (!adjList[target]) adjList[target] = [];
  
          // Add links if not already in set
          if (adjList[source].indexOf(target) === -1) adjList[source].push(target);
        }
  
        // Find all elementary circuits
        var cycles = findCircuits(adjList);
  
        // Sort by circuits length
        cycles.sort(function (a, b) {
          return a.length - b.length;
        });
  
        var circularLinks = {};
        for (i = 0; i < cycles.length; i++) {
          var cycle = cycles[i];
          var last = cycle.slice(-2);
          if (!circularLinks[last[0]]) circularLinks[last[0]] = {};
          circularLinks[last[0]][last[1]] = true;
        }
  
        graph.links.forEach(function (link) {
          var target = link.target.index;
          var source = link.source.index;
          // If self-linking or a back-edge
          if (target === source || circularLinks[source] && circularLinks[source][target]) {
            link.circular = true;
            link.circularLinkID = circularLinkID;
            circularLinkID = circularLinkID + 1;
          } else {
            link.circular = false;
          }
        });
      } else {
        graph.links.forEach(function (link) {
          if (link.source[sortNodes] < link.target[sortNodes]) {
            link.circular = false;
          } else {
            link.circular = true;
            link.circularLinkID = circularLinkID;
            circularLinkID = circularLinkID + 1;
          }
        });
      }
    }
  
    // Assign a circular link type (top or bottom), based on:
    // - if the source/target node already has circular links, then use the same type
    // - if not, choose the type with fewer links
    function selectCircularLinkTypes(graph, id) {
      var numberOfTops = 0;
      var numberOfBottoms = 0;
      graph.links.forEach(function (link) {
        if (link.circular) {
          // if either souce or target has type already use that
          if (link.source.circularLinkType || link.target.circularLinkType) {
            // default to source type if available
            link.circularLinkType = link.source.circularLinkType ? link.source.circularLinkType : link.target.circularLinkType;
          } else {
            link.circularLinkType = numberOfTops < numberOfBottoms ? 'top' : 'bottom';
          }
  
          if (link.circularLinkType == 'top') {
            numberOfTops = numberOfTops + 1;
          } else {
            numberOfBottoms = numberOfBottoms + 1;
          }
  
          graph.nodes.forEach(function (node) {
            if (getNodeID(node, id) == getNodeID(link.source, id) || getNodeID(node, id) == getNodeID(link.target, id)) {
              node.circularLinkType = link.circularLinkType;
            }
          });
        }
      });
  
      //correct self-linking links to be same direction as node
      graph.links.forEach(function (link) {
        if (link.circular) {
          //if both source and target node are same type, then link should have same type
          if (link.source.circularLinkType == link.target.circularLinkType) {
            link.circularLinkType = link.source.circularLinkType;
          }
          //if link is selflinking, then link should have same type as node
          if (selfLinking(link, id)) {
            link.circularLinkType = link.source.circularLinkType;
          }
        }
      });
    }
  
    // Return the angle between a straight line between the source and target of the link, and the vertical plane of the node
    function linkAngle(link) {
      var adjacent = Math.abs(link.y1 - link.y0);
      var opposite = Math.abs(link.target.x0 - link.source.x1);
  
      return Math.atan(opposite / adjacent);
    }
  
    // Check if two circular links potentially overlap
    function circularLinksCross(link1, link2) {
      if (link1.source.column < link2.target.column) {
        return false;
      } else if (link1.target.column > link2.source.column) {
        return false;
      } else {
        return true;
      }
    }
  
    // Return the number of circular links for node, not including self linking links
    function numberOfNonSelfLinkingCycles(node, id) {
      var sourceCount = 0;
      node.sourceLinks.forEach(function (l) {
        sourceCount = l.circular && !selfLinking(l, id) ? sourceCount + 1 : sourceCount;
      });
  
      var targetCount = 0;
      node.targetLinks.forEach(function (l) {
        targetCount = l.circular && !selfLinking(l, id) ? targetCount + 1 : targetCount;
      });
  
      return sourceCount + targetCount;
    }
  
    // Check if a circular link is the only circular link for both its source and target node
    function onlyCircularLink(link) {
      var nodeSourceLinks = link.source.sourceLinks;
      var sourceCount = 0;
      nodeSourceLinks.forEach(function (l) {
        sourceCount = l.circular ? sourceCount + 1 : sourceCount;
      });
  
      var nodeTargetLinks = link.target.targetLinks;
      var targetCount = 0;
      nodeTargetLinks.forEach(function (l) {
        targetCount = l.circular ? targetCount + 1 : targetCount;
      });
  
      if (sourceCount > 1 || targetCount > 1) {
        return false;
      } else {
        return true;
      }
    }
  
    // creates vertical buffer values per set of top/bottom links
    function calcVerticalBuffer(links, circularLinkGap, id) {
      links.sort(sortLinkColumnAscending);
      links.forEach(function (link, i) {
        var buffer = 0;
  
        if (selfLinking(link, id) && onlyCircularLink(link)) {
          link.circularPathData.verticalBuffer = buffer + link.width / 2;
        } else {
          var j = 0;
          for (j; j < i; j++) {
            if (circularLinksCross(links[i], links[j])) {
              var bufferOverThisLink = links[j].circularPathData.verticalBuffer + links[j].width / 2 + circularLinkGap;
              buffer = bufferOverThisLink > buffer ? bufferOverThisLink : buffer;
            }
          }
  
          link.circularPathData.verticalBuffer = buffer + link.width / 2;
        }
      });
  
      return links;
    }
  
    // calculate the optimum path for a link to reduce overlaps
    function addCircularPathData(graph, circularLinkGap, y1, id) {
      //var baseRadius = 10
      var buffer = 5;
      //var verticalMargin = 25
  
      var minY = d3Array.min(graph.links, function (link) {
        return link.source.y0;
      });
  
      // create object for circular Path Data
      graph.links.forEach(function (link) {
        if (link.circular) {
          link.circularPathData = {};
        }
      });
  
      // calc vertical offsets per top/bottom links
      var topLinks = graph.links.filter(function (l) {
        return l.circularLinkType == 'top';
      });
      /* topLinks = */calcVerticalBuffer(topLinks, circularLinkGap, id);
  
      var bottomLinks = graph.links.filter(function (l) {
        return l.circularLinkType == 'bottom';
      });
      /* bottomLinks = */calcVerticalBuffer(bottomLinks, circularLinkGap, id);
  
      // add the base data for each link
      graph.links.forEach(function (link) {
        if (link.circular) {
          link.circularPathData.arcRadius = link.width + baseRadius;
          link.circularPathData.leftNodeBuffer = buffer;
          link.circularPathData.rightNodeBuffer = buffer;
          link.circularPathData.sourceWidth = link.source.x1 - link.source.x0;
          link.circularPathData.sourceX = link.source.x0 + link.circularPathData.sourceWidth;
          link.circularPathData.targetX = link.target.x0;
          link.circularPathData.sourceY = link.y0;
          link.circularPathData.targetY = link.y1;
  
          // for self linking paths, and that the only circular link in/out of that node
          if (selfLinking(link, id) && onlyCircularLink(link)) {
            link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2;
            link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2;
            link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2;
            link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2;
  
            if (link.circularLinkType == 'bottom') {
              link.circularPathData.verticalFullExtent = link.source.y1 + verticalMargin + link.circularPathData.verticalBuffer;
              link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
              link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
            } else {
              // top links
              link.circularPathData.verticalFullExtent = link.source.y0 - verticalMargin - link.circularPathData.verticalBuffer;
              link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
              link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
            }
          } else {
            // else calculate normally
            // add left extent coordinates, based on links with same source column and circularLink type
            var thisColumn = link.source.column;
            var thisCircularLinkType = link.circularLinkType;
            var sameColumnLinks = graph.links.filter(function (l) {
              return l.source.column == thisColumn && l.circularLinkType == thisCircularLinkType;
            });
  
            if (link.circularLinkType == 'bottom') {
              sameColumnLinks.sort(sortLinkSourceYDescending);
            } else {
              sameColumnLinks.sort(sortLinkSourceYAscending);
            }
  
            var radiusOffset = 0;
            sameColumnLinks.forEach(function (l, i) {
              if (l.circularLinkID == link.circularLinkID) {
                link.circularPathData.leftSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
                link.circularPathData.leftLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
              }
              radiusOffset = radiusOffset + l.width;
            });
  
            // add right extent coordinates, based on links with same target column and circularLink type
            thisColumn = link.target.column;
            sameColumnLinks = graph.links.filter(function (l) {
              return l.target.column == thisColumn && l.circularLinkType == thisCircularLinkType;
            });
            if (link.circularLinkType == 'bottom') {
              sameColumnLinks.sort(sortLinkTargetYDescending);
            } else {
              sameColumnLinks.sort(sortLinkTargetYAscending);
            }
  
            radiusOffset = 0;
            sameColumnLinks.forEach(function (l, i) {
              if (l.circularLinkID == link.circularLinkID) {
                link.circularPathData.rightSmallArcRadius = baseRadius + link.width / 2 + radiusOffset;
                link.circularPathData.rightLargeArcRadius = baseRadius + link.width / 2 + i * circularLinkGap + radiusOffset;
              }
              radiusOffset = radiusOffset + l.width;
            });
  
            // bottom links
            if (link.circularLinkType == 'bottom') {
              link.circularPathData.verticalFullExtent = Math.max(y1, link.source.y1, link.target.y1) + verticalMargin + link.circularPathData.verticalBuffer;
              link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.leftLargeArcRadius;
              link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent - link.circularPathData.rightLargeArcRadius;
            } else {
              // top links
              link.circularPathData.verticalFullExtent = minY - verticalMargin - link.circularPathData.verticalBuffer;
              link.circularPathData.verticalLeftInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.leftLargeArcRadius;
              link.circularPathData.verticalRightInnerExtent = link.circularPathData.verticalFullExtent + link.circularPathData.rightLargeArcRadius;
            }
          }
  
          // all links
          link.circularPathData.leftInnerExtent = link.circularPathData.sourceX + link.circularPathData.leftNodeBuffer;
          link.circularPathData.rightInnerExtent = link.circularPathData.targetX - link.circularPathData.rightNodeBuffer;
          link.circularPathData.leftFullExtent = link.circularPathData.sourceX + link.circularPathData.leftLargeArcRadius + link.circularPathData.leftNodeBuffer;
          link.circularPathData.rightFullExtent = link.circularPathData.targetX - link.circularPathData.rightLargeArcRadius - link.circularPathData.rightNodeBuffer;
        }
  
        if (link.circular) {
          link.path = createCircularPathString(link);
        } else {
          var normalPath = d3Shape.linkHorizontal().source(function (d) {
            var x = d.source.x0 + (d.source.x1 - d.source.x0);
            var y = d.y0;
            return [x, y];
          }).target(function (d) {
            var x = d.target.x0;
            var y = d.y1;
            return [x, y];
          });
          link.path = normalPath(link);
        }
      });
    }
  
    // create a d path using the addCircularPathData
    function createCircularPathString(link) {
      var pathString = '';
      // 'pathData' is assigned a value but never used
      // var pathData = {}
  
      if (link.circularLinkType == 'top') {
        pathString =
        // start at the right of the source node
        'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
        // line right to buffer point
        'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
        // Arc around: Centre of arc X and  //Centre of arc Y
        'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 0 ' +
        // End of arc X //End of arc Y
        link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY - link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
        // line up to buffer point
        'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
        // Arc around: Centre of arc X and  //Centre of arc Y
        'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 0 ' +
        // End of arc X //End of arc Y
        link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
        // line left to buffer point
        'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
        // Arc around: Centre of arc X and  //Centre of arc Y
        'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 0 ' +
        // End of arc X //End of arc Y
        link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
        // line down
        'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY - link.circularPathData.rightSmallArcRadius) + ' ' +
        // Arc around: Centre of arc X and  //Centre of arc Y
        'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 0 ' +
        // End of arc X //End of arc Y
        link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
        // line to end
        'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
      } else {
        // bottom path
        pathString =
        // start at the right of the source node
        'M' + link.circularPathData.sourceX + ' ' + link.circularPathData.sourceY + ' ' +
        // line right to buffer point
        'L' + link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.sourceY + ' ' +
        // Arc around: Centre of arc X and  //Centre of arc Y
        'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftSmallArcRadius + ' 0 0 1 ' +
        // End of arc X //End of arc Y
        link.circularPathData.leftFullExtent + ' ' + (link.circularPathData.sourceY + link.circularPathData.leftSmallArcRadius) + ' ' + // End of arc X
        // line down to buffer point
        'L' + link.circularPathData.leftFullExtent + ' ' + link.circularPathData.verticalLeftInnerExtent + ' ' +
        // Arc around: Centre of arc X and  //Centre of arc Y
        'A' + link.circularPathData.leftLargeArcRadius + ' ' + link.circularPathData.leftLargeArcRadius + ' 0 0 1 ' +
        // End of arc X //End of arc Y
        link.circularPathData.leftInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' + // End of arc X
        // line left to buffer point
        'L' + link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.verticalFullExtent + ' ' +
        // Arc around: Centre of arc X and  //Centre of arc Y
        'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightLargeArcRadius + ' 0 0 1 ' +
        // End of arc X //End of arc Y
        link.circularPathData.rightFullExtent + ' ' + link.circularPathData.verticalRightInnerExtent + ' ' + // End of arc X
        // line up
        'L' + link.circularPathData.rightFullExtent + ' ' + (link.circularPathData.targetY + link.circularPathData.rightSmallArcRadius) + ' ' +
        // Arc around: Centre of arc X and  //Centre of arc Y
        'A' + link.circularPathData.rightLargeArcRadius + ' ' + link.circularPathData.rightSmallArcRadius + ' 0 0 1 ' +
        // End of arc X //End of arc Y
        link.circularPathData.rightInnerExtent + ' ' + link.circularPathData.targetY + ' ' + // End of arc X
        // line to end
        'L' + link.circularPathData.targetX + ' ' + link.circularPathData.targetY;
      }
  
      return pathString;
    }
  
    // sort links based on the distance between the source and tartget node columns
    // if the same, then use Y position of the source node
    function sortLinkColumnAscending(link1, link2) {
      if (linkColumnDistance(link1) == linkColumnDistance(link2)) {
        return link1.circularLinkType == 'bottom' ? sortLinkSourceYDescending(link1, link2) : sortLinkSourceYAscending(link1, link2);
      } else {
        return linkColumnDistance(link2) - linkColumnDistance(link1);
      }
    }
  
    // sort ascending links by their source vertical position, y0
    function sortLinkSourceYAscending(link1, link2) {
      return link1.y0 - link2.y0;
    }
  
    // sort descending links by their source vertical position, y0
    function sortLinkSourceYDescending(link1, link2) {
      return link2.y0 - link1.y0;
    }
  
    // sort ascending links by their target vertical position, y1
    function sortLinkTargetYAscending(link1, link2) {
      return link1.y1 - link2.y1;
    }
  
    // sort descending links by their target vertical position, y1
    function sortLinkTargetYDescending(link1, link2) {
      return link2.y1 - link1.y1;
    }
  
    // return the distance between the link's target and source node, in terms of the nodes' column
    function linkColumnDistance(link) {
      return link.target.column - link.source.column;
    }
  
    // return the distance between the link's target and source node, in terms of the nodes' X coordinate
    function linkXLength(link) {
      return link.target.x0 - link.source.x1;
    }
  
    // Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
    // * approx, based on a straight line from target to source, when in fact the path is a bezier
    function linkPerpendicularYToLinkSource(longerLink, shorterLink) {
      // get the angle for the longer link
      var angle = linkAngle(longerLink);
  
      // get the adjacent length to the other link's x position
      var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);
  
      // add or subtract from longer link1's original y1, depending on the slope
      var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 + heightFromY1ToPependicular : longerLink.y1 - heightFromY1ToPependicular;
  
      return yPerpendicular;
    }
  
    // Return the Y coordinate on the longerLink path * which is perpendicular shorterLink's source.
    // * approx, based on a straight line from target to source, when in fact the path is a bezier
    function linkPerpendicularYToLinkTarget(longerLink, shorterLink) {
      // get the angle for the longer link
      var angle = linkAngle(longerLink);
  
      // get the adjacent length to the other link's x position
      var heightFromY1ToPependicular = linkXLength(shorterLink) / Math.tan(angle);
  
      // add or subtract from longer link's original y1, depending on the slope
      var yPerpendicular = incline(longerLink) == 'up' ? longerLink.y1 - heightFromY1ToPependicular : longerLink.y1 + heightFromY1ToPependicular;
  
      return yPerpendicular;
    }
  
    // Move any nodes that overlap links which span 2+ columns
    function resolveNodeLinkOverlaps(graph, y0, y1, id) {
  
      graph.links.forEach(function (link) {
        if (link.circular) {
          return;
        }
  
        if (link.target.column - link.source.column > 1) {
          var columnToTest = link.source.column + 1;
          var maxColumnToTest = link.target.column - 1;
  
          var i = 1;
          var numberOfColumnsToTest = maxColumnToTest - columnToTest + 1;
  
          for (i = 1; columnToTest <= maxColumnToTest; columnToTest++, i++) {
            graph.nodes.forEach(function (node) {
              if (node.column == columnToTest) {
                var t = i / (numberOfColumnsToTest + 1);
  
                // Find all the points of a cubic bezier curve in javascript
                // https://stackoverflow.com/questions/15397596/find-all-the-points-of-a-cubic-bezier-curve-in-javascript
  
                var B0_t = Math.pow(1 - t, 3);
                var B1_t = 3 * t * Math.pow(1 - t, 2);
                var B2_t = 3 * Math.pow(t, 2) * (1 - t);
                var B3_t = Math.pow(t, 3);
  
                var py_t = B0_t * link.y0 + B1_t * link.y0 + B2_t * link.y1 + B3_t * link.y1;
  
                var linkY0AtColumn = py_t - link.width / 2;
                var linkY1AtColumn = py_t + link.width / 2;
                var dy;
  
                // If top of link overlaps node, push node up
                if (linkY0AtColumn > node.y0 && linkY0AtColumn < node.y1) {
  
                  dy = node.y1 - linkY0AtColumn + 10;
                  dy = node.circularLinkType == 'bottom' ? dy : -dy;
  
                  node = adjustNodeHeight(node, dy, y0, y1);
  
                  // check if other nodes need to move up too
                  graph.nodes.forEach(function (otherNode) {
                    // don't need to check itself or nodes at different columns
                    if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                      return;
                    }
                    if (nodesOverlap(node, otherNode)) {
                      adjustNodeHeight(otherNode, dy, y0, y1);
                    }
                  });
                } else if (linkY1AtColumn > node.y0 && linkY1AtColumn < node.y1) {
                  // If bottom of link overlaps node, push node down
                  dy = linkY1AtColumn - node.y0 + 10;
  
                  node = adjustNodeHeight(node, dy, y0, y1);
  
                  // check if other nodes need to move down too
                  graph.nodes.forEach(function (otherNode) {
                    // don't need to check itself or nodes at different columns
                    if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                      return;
                    }
                    if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
                      adjustNodeHeight(otherNode, dy, y0, y1);
                    }
                  });
                } else if (linkY0AtColumn < node.y0 && linkY1AtColumn > node.y1) {
                  // if link completely overlaps node
                  dy = linkY1AtColumn - node.y0 + 10;
  
                  node = adjustNodeHeight(node, dy, y0, y1);
  
                  graph.nodes.forEach(function (otherNode) {
                    // don't need to check itself or nodes at different columns
                    if (getNodeID(otherNode, id) == getNodeID(node, id) || otherNode.column != node.column) {
                      return;
                    }
                    if (otherNode.y0 < node.y1 && otherNode.y1 > node.y1) {
                      adjustNodeHeight(otherNode, dy, y0, y1);
                    }
                  });
                }
              }
            });
          }
        }
      });
    }
  
    // check if two nodes overlap
    function nodesOverlap(nodeA, nodeB) {
      // test if nodeA top partially overlaps nodeB
      if (nodeA.y0 > nodeB.y0 && nodeA.y0 < nodeB.y1) {
        return true;
      } else if (nodeA.y1 > nodeB.y0 && nodeA.y1 < nodeB.y1) {
        // test if nodeA bottom partially overlaps nodeB
        return true;
      } else if (nodeA.y0 < nodeB.y0 && nodeA.y1 > nodeB.y1) {
        // test if nodeA covers nodeB
        return true;
      } else {
        return false;
      }
    }
  
    // update a node, and its associated links, vertical positions (y0, y1)
    function adjustNodeHeight(node, dy, sankeyY0, sankeyY1) {
      if (node.y0 + dy >= sankeyY0 && node.y1 + dy <= sankeyY1) {
        node.y0 = node.y0 + dy;
        node.y1 = node.y1 + dy;
  
        node.targetLinks.forEach(function (l) {
          l.y1 = l.y1 + dy;
        });
  
        node.sourceLinks.forEach(function (l) {
          l.y0 = l.y0 + dy;
        });
      }
      return node;
    }
  
    // sort and set the links' y0 for each node
    function sortSourceLinks(graph, y1, id, moveNodes) {
      graph.nodes.forEach(function (node) {
        // move any nodes up which are off the bottom
        if (moveNodes && node.y + (node.y1 - node.y0) > y1) {
          node.y = node.y - (node.y + (node.y1 - node.y0) - y1);
        }
  
        var nodesSourceLinks = graph.links.filter(function (l) {
          return getNodeID(l.source, id) == getNodeID(node, id);
        });
  
        var nodeSourceLinksLength = nodesSourceLinks.length;
  
        // if more than 1 link then sort
        if (nodeSourceLinksLength > 1) {
          nodesSourceLinks.sort(function (link1, link2) {
            // if both are not circular...
            if (!link1.circular && !link2.circular) {
              // if the target nodes are the same column, then sort by the link's target y
              if (link1.target.column == link2.target.column) {
                return link1.y1 - link2.y1;
              } else if (!sameInclines(link1, link2)) {
                // if the links slope in different directions, then sort by the link's target y
                return link1.y1 - link2.y1;
  
                // if the links slope in same directions, then sort by any overlap
              } else {
                if (link1.target.column > link2.target.column) {
                  var link2Adj = linkPerpendicularYToLinkTarget(link2, link1);
                  return link1.y1 - link2Adj;
                }
                if (link2.target.column > link1.target.column) {
                  var link1Adj = linkPerpendicularYToLinkTarget(link1, link2);
                  return link1Adj - link2.y1;
                }
              }
            }
  
            // if only one is circular, the move top links up, or bottom links down
            if (link1.circular && !link2.circular) {
              return link1.circularLinkType == 'top' ? -1 : 1;
            } else if (link2.circular && !link1.circular) {
              return link2.circularLinkType == 'top' ? 1 : -1;
            }
  
            // if both links are circular...
            if (link1.circular && link2.circular) {
              // ...and they both loop the same way (both top)
              if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
                // ...and they both connect to a target with same column, then sort by the target's y
                if (link1.target.column === link2.target.column) {
                  return link1.target.y1 - link2.target.y1;
                } else {
                  // ...and they connect to different column targets, then sort by how far back they
                  return link2.target.column - link1.target.column;
                }
              } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
                // ...and they both loop the same way (both bottom)
                // ...and they both connect to a target with same column, then sort by the target's y
                if (link1.target.column === link2.target.column) {
                  return link2.target.y1 - link1.target.y1;
                } else {
                  // ...and they connect to different column targets, then sort by how far back they
                  return link1.target.column - link2.target.column;
                }
              } else {
                // ...and they loop around different ways, the move top up and bottom down
                return link1.circularLinkType == 'top' ? -1 : 1;
              }
            }
          });
        }
  
        // update y0 for links
        var ySourceOffset = node.y0;
  
        nodesSourceLinks.forEach(function (link) {
          link.y0 = ySourceOffset + link.width / 2;
          ySourceOffset = ySourceOffset + link.width;
        });
  
        // correct any circular bottom links so they are at the bottom of the node
        nodesSourceLinks.forEach(function (link, i) {
          if (link.circularLinkType == 'bottom') {
            var j = i + 1;
            var offsetFromBottom = 0;
            // sum the widths of any links that are below this link
            for (j; j < nodeSourceLinksLength; j++) {
              offsetFromBottom = offsetFromBottom + nodesSourceLinks[j].width;
            }
            link.y0 = node.y1 - offsetFromBottom - link.width / 2;
          }
        });
      });
    }
  
    // sort and set the links' y1 for each node
    function sortTargetLinks(graph, y1, id) {
      graph.nodes.forEach(function (node) {
        var nodesTargetLinks = graph.links.filter(function (l) {
          return getNodeID(l.target, id) == getNodeID(node, id);
        });
  
        var nodesTargetLinksLength = nodesTargetLinks.length;
  
        if (nodesTargetLinksLength > 1) {
          nodesTargetLinks.sort(function (link1, link2) {
            // if both are not circular, the base on the source y position
            if (!link1.circular && !link2.circular) {
              if (link1.source.column == link2.source.column) {
                return link1.y0 - link2.y0;
              } else if (!sameInclines(link1, link2)) {
                return link1.y0 - link2.y0;
              } else {
                // get the angle of the link to the further source node (ie the smaller column)
                if (link2.source.column < link1.source.column) {
                  var link2Adj = linkPerpendicularYToLinkSource(link2, link1);
  
                  return link1.y0 - link2Adj;
                }
                if (link1.source.column < link2.source.column) {
                  var link1Adj = linkPerpendicularYToLinkSource(link1, link2);
  
                  return link1Adj - link2.y0;
                }
              }
            }
  
            // if only one is circular, the move top links up, or bottom links down
            if (link1.circular && !link2.circular) {
              return link1.circularLinkType == 'top' ? -1 : 1;
            } else if (link2.circular && !link1.circular) {
              return link2.circularLinkType == 'top' ? 1 : -1;
            }
  
            // if both links are circular...
            if (link1.circular && link2.circular) {
              // ...and they both loop the same way (both top)
              if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'top') {
                // ...and they both connect to a target with same column, then sort by the target's y
                if (link1.source.column === link2.source.column) {
                  return link1.source.y1 - link2.source.y1;
                } else {
                  // ...and they connect to different column targets, then sort by how far back they
                  return link1.source.column - link2.source.column;
                }
              } else if (link1.circularLinkType === link2.circularLinkType && link1.circularLinkType == 'bottom') {
                // ...and they both loop the same way (both bottom)
                // ...and they both connect to a target with same column, then sort by the target's y
                if (link1.source.column === link2.source.column) {
                  return link1.source.y1 - link2.source.y1;
                } else {
                  // ...and they connect to different column targets, then sort by how far back they
                  return link2.source.column - link1.source.column;
                }
              } else {
                // ...and they loop around different ways, the move top up and bottom down
                return link1.circularLinkType == 'top' ? -1 : 1;
              }
            }
          });
        }
  
        // update y1 for links
        var yTargetOffset = node.y0;
  
        nodesTargetLinks.forEach(function (link) {
          link.y1 = yTargetOffset + link.width / 2;
          yTargetOffset = yTargetOffset + link.width;
        });
  
        // correct any circular bottom links so they are at the bottom of the node
        nodesTargetLinks.forEach(function (link, i) {
          if (link.circularLinkType == 'bottom') {
            var j = i + 1;
            var offsetFromBottom = 0;
            // sum the widths of any links that are below this link
            for (j; j < nodesTargetLinksLength; j++) {
              offsetFromBottom = offsetFromBottom + nodesTargetLinks[j].width;
            }
            link.y1 = node.y1 - offsetFromBottom - link.width / 2;
          }
        });
      });
    }
  
    // test if links both slope up, or both slope down
    function sameInclines(link1, link2) {
      return incline(link1) == incline(link2);
    }
  
    // returns the slope of a link, from source to target
    // up => slopes up from source to target
    // down => slopes down from source to target
    function incline(link) {
      return link.y0 - link.y1 > 0 ? 'up' : 'down';
    }
  
    // check if link is self linking, ie links a node to the same node
    function selfLinking(link, id) {
      return getNodeID(link.source, id) == getNodeID(link.target, id);
    }
  
    function fillHeight(graph, y0, y1) {
  
      var nodes = graph.nodes;
      var links = graph.links;
  
      var top = false;
      var bottom = false;
  
      links.forEach(function (link) {
        if (link.circularLinkType == "top") {
          top = true;
        } else if (link.circularLinkType == "bottom") {
          bottom = true;
        }
      });
  
      if (top == false || bottom == false) {
        var minY0 = d3Array.min(nodes, function (node) {
          return node.y0;
        });
        var maxY1 = d3Array.max(nodes, function (node) {
          return node.y1;
        });
        var currentHeight = maxY1 - minY0;
        var chartHeight = y1 - y0;
        var ratio = chartHeight / currentHeight;
  
        nodes.forEach(function (node) {
          var nodeHeight = (node.y1 - node.y0) * ratio;
          node.y0 = (node.y0 - minY0) * ratio;
          node.y1 = node.y0 + nodeHeight;
        });
  
        links.forEach(function (link) {
          link.y0 = (link.y0 - minY0) * ratio;
          link.y1 = (link.y1 - minY0) * ratio;
          link.width = link.width * ratio;
        });
      }
    }
  
    exports.sankeyCircular = sankeyCircular;
    exports.sankeyCenter = center;
    exports.sankeyLeft = left;
    exports.sankeyRight = right;
    exports.sankeyJustify = justify;
  
    Object.defineProperty(exports, '__esModule', { value: true });
  
  })));
  
  },{"d3-array":156,"d3-collection":157,"d3-shape":165,"elementary-circuits-directed-graph":179}],56:[function(_dereq_,module,exports){
  // https://github.com/d3/d3-sankey Version 0.7.2. Copyright 2019 Mike Bostock.
  (function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-array'), _dereq_('d3-collection'), _dereq_('d3-shape')) :
    typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-shape'], factory) :
    (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3));
  }(this, (function (exports,d3Array,d3Collection,d3Shape) { 'use strict';
  
  function targetDepth(d) {
    return d.target.depth;
  }
  
  function left(node) {
    return node.depth;
  }
  
  function right(node, n) {
    return n - 1 - node.height;
  }
  
  function justify(node, n) {
    return node.sourceLinks.length ? node.depth : n - 1;
  }
  
  function center(node) {
    return node.targetLinks.length ? node.depth
        : node.sourceLinks.length ? d3Array.min(node.sourceLinks, targetDepth) - 1
        : 0;
  }
  
  function constant(x) {
    return function() {
      return x;
    };
  }
  
  function ascendingSourceBreadth(a, b) {
    return ascendingBreadth(a.source, b.source) || a.index - b.index;
  }
  
  function ascendingTargetBreadth(a, b) {
    return ascendingBreadth(a.target, b.target) || a.index - b.index;
  }
  
  function ascendingBreadth(a, b) {
    return a.y0 - b.y0;
  }
  
  function value(d) {
    return d.value;
  }
  
  function nodeCenter(node) {
    return (node.y0 + node.y1) / 2;
  }
  
  function weightedSource(link) {
    return nodeCenter(link.source) * link.value;
  }
  
  function weightedTarget(link) {
    return nodeCenter(link.target) * link.value;
  }
  
  function defaultId(d) {
    return d.index;
  }
  
  function defaultNodes(graph) {
    return graph.nodes;
  }
  
  function defaultLinks(graph) {
    return graph.links;
  }
  
  function find(nodeById, id) {
    var node = nodeById.get(id);
    if (!node) throw new Error("missing: " + id);
    return node;
  }
  
  var sankey = function() {
    var x0 = 0, y0 = 0, x1 = 1, y1 = 1, // extent
        dx = 24, // nodeWidth
        py = 8, // nodePadding
        id = defaultId,
        align = justify,
        nodes = defaultNodes,
        links = defaultLinks,
        iterations = 32,
        maxPaddedSpace = 2 / 3; // Defined as a fraction of the total available space
  
    function sankey() {
      var graph = {nodes: nodes.apply(null, arguments), links: links.apply(null, arguments)};
      computeNodeLinks(graph);
      computeNodeValues(graph);
      computeNodeDepths(graph);
      computeNodeBreadths(graph, iterations);
      computeLinkBreadths(graph);
      return graph;
    }
  
    sankey.update = function(graph) {
      computeLinkBreadths(graph);
      return graph;
    };
  
    sankey.nodeId = function(_) {
      return arguments.length ? (id = typeof _ === "function" ? _ : constant(_), sankey) : id;
    };
  
    sankey.nodeAlign = function(_) {
      return arguments.length ? (align = typeof _ === "function" ? _ : constant(_), sankey) : align;
    };
  
    sankey.nodeWidth = function(_) {
      return arguments.length ? (dx = +_, sankey) : dx;
    };
  
    sankey.nodePadding = function(_) {
      return arguments.length ? (py = +_, sankey) : py;
    };
  
    sankey.nodes = function(_) {
      return arguments.length ? (nodes = typeof _ === "function" ? _ : constant(_), sankey) : nodes;
    };
  
    sankey.links = function(_) {
      return arguments.length ? (links = typeof _ === "function" ? _ : constant(_), sankey) : links;
    };
  
    sankey.size = function(_) {
      return arguments.length ? (x0 = y0 = 0, x1 = +_[0], y1 = +_[1], sankey) : [x1 - x0, y1 - y0];
    };
  
    sankey.extent = function(_) {
      return arguments.length ? (x0 = +_[0][0], x1 = +_[1][0], y0 = +_[0][1], y1 = +_[1][1], sankey) : [[x0, y0], [x1, y1]];
    };
  
    sankey.iterations = function(_) {
      return arguments.length ? (iterations = +_, sankey) : iterations;
    };
  
    // Populate the sourceLinks and targetLinks for each node.
    // Also, if the source and target are not objects, assume they are indices.
    function computeNodeLinks(graph) {
      graph.nodes.forEach(function(node, i) {
        node.index = i;
        node.sourceLinks = [];
        node.targetLinks = [];
      });
  
      var nodeById = d3Collection.map(graph.nodes, id);
      graph.links.forEach(function(link, i) {
        link.index = i;
        var source = link.source, target = link.target;
        if (typeof source !== "object") source = link.source = find(nodeById, source);
        if (typeof target !== "object") target = link.target = find(nodeById, target);
        source.sourceLinks.push(link);
        target.targetLinks.push(link);
      });
    }
  
    // Compute the value (size) of each node by summing the associated links.
    function computeNodeValues(graph) {
      graph.nodes.forEach(function(node) {
        node.value = Math.max(
          d3Array.sum(node.sourceLinks, value),
          d3Array.sum(node.targetLinks, value)
        );
      });
    }
  
    // Iteratively assign the depth (x-position) for each node.
    // Nodes are assigned the maximum depth of incoming neighbors plus one;
    // nodes with no incoming links are assigned depth zero, while
    // nodes with no outgoing links are assigned the maximum depth.
    function computeNodeDepths(graph) {
      var nodes, next, x;
  
      for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
        nodes.forEach(function(node) {
          node.depth = x;
          node.sourceLinks.forEach(function(link) {
            if (next.indexOf(link.target) < 0) {
              next.push(link.target);
            }
          });
        });
      }
  
      for (nodes = graph.nodes, next = [], x = 0; nodes.length; ++x, nodes = next, next = []) {
        nodes.forEach(function(node) {
          node.height = x;
          node.targetLinks.forEach(function(link) {
            if (next.indexOf(link.source) < 0) {
              next.push(link.source);
            }
          });
        });
      }
  
      var kx = (x1 - x0 - dx) / (x - 1);
      graph.nodes.forEach(function(node) {
        node.x1 = (node.x0 = x0 + Math.max(0, Math.min(x - 1, Math.floor(align.call(null, node, x)))) * kx) + dx;
      });
    }
  
    function computeNodeBreadths(graph) {
      var columns = d3Collection.nest()
          .key(function(d) { return d.x0; })
          .sortKeys(d3Array.ascending)
          .entries(graph.nodes)
          .map(function(d) { return d.values; });
  
      //
      initializeNodeBreadth();
      resolveCollisions();
      for (var alpha = 1, n = iterations; n > 0; --n) {
        relaxRightToLeft(alpha *= 0.99);
        resolveCollisions();
        relaxLeftToRight(alpha);
        resolveCollisions();
      }
  
      function initializeNodeBreadth() {
        var L = d3Array.max(columns, function(nodes) {
          return nodes.length;
        });
        var maxNodePadding = maxPaddedSpace * (y1 - y0) / (L - 1);
        if(py > maxNodePadding) py = maxNodePadding;
        var ky = d3Array.min(columns, function(nodes) {
          return (y1 - y0 - (nodes.length - 1) * py) / d3Array.sum(nodes, value);
        });
  
        columns.forEach(function(nodes) {
          nodes.forEach(function(node, i) {
            node.y1 = (node.y0 = i) + node.value * ky;
          });
        });
  
        graph.links.forEach(function(link) {
          link.width = link.value * ky;
        });
      }
  
      function relaxLeftToRight(alpha) {
        columns.forEach(function(nodes) {
          nodes.forEach(function(node) {
            if (node.targetLinks.length) {
              var dy = (d3Array.sum(node.targetLinks, weightedSource) / d3Array.sum(node.targetLinks, value) - nodeCenter(node)) * alpha;
              node.y0 += dy, node.y1 += dy;
            }
          });
        });
      }
  
      function relaxRightToLeft(alpha) {
        columns.slice().reverse().forEach(function(nodes) {
          nodes.forEach(function(node) {
            if (node.sourceLinks.length) {
              var dy = (d3Array.sum(node.sourceLinks, weightedTarget) / d3Array.sum(node.sourceLinks, value) - nodeCenter(node)) * alpha;
              node.y0 += dy, node.y1 += dy;
            }
          });
        });
      }
  
      function resolveCollisions() {
        columns.forEach(function(nodes) {
          var node,
              dy,
              y = y0,
              n = nodes.length,
              i;
  
          // Push any overlapping nodes down.
          nodes.sort(ascendingBreadth);
          for (i = 0; i < n; ++i) {
            node = nodes[i];
            dy = y - node.y0;
            if (dy > 0) node.y0 += dy, node.y1 += dy;
            y = node.y1 + py;
          }
  
          // If the bottommost node goes outside the bounds, push it back up.
          dy = y - py - y1;
          if (dy > 0) {
            y = (node.y0 -= dy), node.y1 -= dy;
  
            // Push any overlapping nodes back up.
            for (i = n - 2; i >= 0; --i) {
              node = nodes[i];
              dy = node.y1 + py - y;
              if (dy > 0) node.y0 -= dy, node.y1 -= dy;
              y = node.y0;
            }
          }
        });
      }
    }
  
    function computeLinkBreadths(graph) {
      graph.nodes.forEach(function(node) {
        node.sourceLinks.sort(ascendingTargetBreadth);
        node.targetLinks.sort(ascendingSourceBreadth);
      });
      graph.nodes.forEach(function(node) {
        var y0 = node.y0, y1 = y0;
        node.sourceLinks.forEach(function(link) {
          link.y0 = y0 + link.width / 2, y0 += link.width;
        });
        node.targetLinks.forEach(function(link) {
          link.y1 = y1 + link.width / 2, y1 += link.width;
        });
      });
    }
  
    return sankey;
  };
  
  function horizontalSource(d) {
    return [d.source.x1, d.y0];
  }
  
  function horizontalTarget(d) {
    return [d.target.x0, d.y1];
  }
  
  var sankeyLinkHorizontal = function() {
    return d3Shape.linkHorizontal()
        .source(horizontalSource)
        .target(horizontalTarget);
  };
  
  exports.sankey = sankey;
  exports.sankeyCenter = center;
  exports.sankeyLeft = left;
  exports.sankeyRight = right;
  exports.sankeyJustify = justify;
  exports.sankeyLinkHorizontal = sankeyLinkHorizontal;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  })));
  
  },{"d3-array":156,"d3-collection":157,"d3-shape":165}],57:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = _dereq_('./quad')
  
  },{"./quad":58}],58:[function(_dereq_,module,exports){
  /**
   * @module  point-cluster/quad
   *
   * Bucket based quad tree clustering
   */
  
  'use strict'
  
  var search = _dereq_('binary-search-bounds')
  var clamp = _dereq_('clamp')
  var rect = _dereq_('parse-rect')
  var getBounds = _dereq_('array-bounds')
  var pick = _dereq_('pick-by-alias')
  var defined = _dereq_('defined')
  var flatten = _dereq_('flatten-vertex-data')
  var isObj = _dereq_('is-obj')
  var dtype = _dereq_('dtype')
  var log2 = _dereq_('math-log2')
  
  var MAX_GROUP_ID = 1073741824
  
  module.exports = function cluster (srcPoints, options) {
    if (!options) { options = {} }
  
    srcPoints = flatten(srcPoints, 'float64')
  
    options = pick(options, {
      bounds: 'range bounds dataBox databox',
      maxDepth: 'depth maxDepth maxdepth level maxLevel maxlevel levels',
      dtype: 'type dtype format out dst output destination'
      // sort: 'sortBy sortby sort',
      // pick: 'pick levelPoint',
      // nodeSize: 'node nodeSize minNodeSize minSize size'
    })
  
    // let nodeSize = defined(options.nodeSize, 1)
    var maxDepth = defined(options.maxDepth, 255)
    var bounds = defined(options.bounds, getBounds(srcPoints, 2))
    if (bounds[0] === bounds[2]) { bounds[2]++ }
    if (bounds[1] === bounds[3]) { bounds[3]++ }
  
    var points = normalize(srcPoints, bounds)
  
    // init variables
    var n = srcPoints.length >>> 1
    var ids
    if (!options.dtype) { options.dtype = 'array' }
  
    if (typeof options.dtype === 'string') {
      ids = new (dtype(options.dtype))(n)
    }
    else if (options.dtype) {
      ids = options.dtype
      if (Array.isArray(ids)) { ids.length = n }
    }
    for (var i = 0; i < n; ++i) {
      ids[i] = i
    }
  
    // representative point indexes for levels
    var levels = []
  
    // starting indexes of subranges in sub levels, levels.length * 4
    var sublevels = []
  
    // unique group ids, sorted in z-curve fashion within levels by shifting bits
    var groups = []
  
    // level offsets in `ids`
    var offsets = []
  
  
    // sort points
    sort(0, 0, 1, ids, 0, 1)
  
  
    // return reordered ids with provided methods
    // save level offsets in output buffer
    var offset = 0
    for (var level = 0; level < levels.length; level++) {
      var levelItems = levels[level]
      if (ids.set) { ids.set(levelItems, offset) }
      else {
        for (var i$1 = 0, l = levelItems.length; i$1 < l; i$1++) {
          ids[i$1 + offset] = levelItems[i$1]
        }
      }
      var nextOffset = offset + levels[level].length
      offsets[level] = [offset, nextOffset]
      offset = nextOffset
    }
  
    ids.range = range
  
    return ids
  
  
  
    // FIXME: it is possible to create one typed array heap and reuse that to avoid memory blow
    function sort (x, y, diam, ids, level, group) {
      if (!ids.length) { return null }
  
      // save first point as level representative
      var levelItems = levels[level] || (levels[level] = [])
      var levelGroups = groups[level] || (groups[level] = [])
      var sublevel = sublevels[level] || (sublevels[level] = [])
      var offset = levelItems.length
  
      level++
  
      // max depth reached - put all items into a first group
      // alternatively - if group id overflow - avoid proceeding
      if (level > maxDepth || group > MAX_GROUP_ID) {
        for (var i = 0; i < ids.length; i++) {
          levelItems.push(ids[i])
          levelGroups.push(group)
          sublevel.push(null, null, null, null)
        }
  
        return offset
      }
  
      levelItems.push(ids[0])
      levelGroups.push(group)
  
      if (ids.length <= 1) {
        sublevel.push(null, null, null, null)
        return offset
      }
  
  
      var d2 = diam * .5
      var cx = x + d2, cy = y + d2
  
      // distribute points by 4 buckets
      var lolo = [], lohi = [], hilo = [], hihi = []
  
      for (var i$1 = 1, l = ids.length; i$1 < l; i$1++) {
        var idx = ids[i$1],
          x$1 = points[idx * 2],
          y$1 = points[idx * 2 + 1]
        x$1 < cx ? (y$1 < cy ? lolo.push(idx) : lohi.push(idx)) : (y$1 < cy ? hilo.push(idx) : hihi.push(idx))
      }
  
      group <<= 2
  
      sublevel.push(
        sort(x, y, d2, lolo, level, group),
        sort(x, cy, d2, lohi, level, group + 1),
        sort(cx, y, d2, hilo, level, group + 2),
        sort(cx, cy, d2, hihi, level, group + 3)
      )
  
      return offset
    }
  
    // get all points within the passed range
    function range () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];
  
      var options
  
      if (isObj(args[args.length - 1])) {
        var arg = args.pop()
  
        // detect if that was a rect object
        if (!args.length && (arg.x != null || arg.l != null || arg.left != null)) {
          args = [arg]
          options = {}
        }
  
        options = pick(arg, {
          level: 'level maxLevel',
          d: 'd diam diameter r radius px pxSize pixel pixelSize maxD size minSize',
          lod: 'lod details ranges offsets'
        })
      }
      else {
        options = {}
      }
  
      if (!args.length) { args = bounds }
  
      var box = rect.apply( void 0, args )
  
      var ref = [
        Math.min(box.x, box.x + box.width),
        Math.min(box.y, box.y + box.height),
        Math.max(box.x, box.x + box.width),
        Math.max(box.y, box.y + box.height)
      ];
      var minX = ref[0];
      var minY = ref[1];
      var maxX = ref[2];
      var maxY = ref[3];
  
      var ref$1 = normalize([minX, minY, maxX, maxY], bounds );
      var nminX = ref$1[0];
      var nminY = ref$1[1];
      var nmaxX = ref$1[2];
      var nmaxY = ref$1[3];
  
      var maxLevel = defined(options.level, levels.length)
  
      // limit maxLevel by px size
      if (options.d != null) {
        var d
        if (typeof options.d === 'number') { d = [options.d, options.d] }
        else if (options.d.length) { d = options.d }
  
        maxLevel = Math.min(
          Math.max(
            Math.ceil(-log2(Math.abs(d[0]) / (bounds[2] - bounds[0]))),
            Math.ceil(-log2(Math.abs(d[1]) / (bounds[3] - bounds[1])))
          ),
          maxLevel
        )
      }
      maxLevel = Math.min(maxLevel, levels.length)
  
      // return levels of details
      if (options.lod) {
        return lod(nminX, nminY, nmaxX, nmaxY, maxLevel)
      }
  
  
  
      // do selection ids
      var selection = []
  
      // FIXME: probably we can do LOD here beforehead
      select( 0, 0, 1, 0, 0, 1)
  
      function select ( lox, loy, d, level, from, to ) {
        if (from === null || to === null) { return }
  
        var hix = lox + d
        var hiy = loy + d
  
        // if box does not intersect level - ignore
        if ( nminX > hix || nminY > hiy || nmaxX < lox || nmaxY < loy ) { return }
        if ( level >= maxLevel ) { return }
        if ( from === to ) { return }
  
        // if points fall into box range - take it
        var levelItems = levels[level]
  
        if (to === undefined) { to = levelItems.length }
  
        for (var i = from; i < to; i++) {
          var id = levelItems[i]
  
          var px = srcPoints[ id * 2 ]
          var py = srcPoints[ id * 2 + 1 ]
  
          if ( px >= minX && px <= maxX && py >= minY && py <= maxY ) {selection.push(id)
          }
        }
  
        // for every subsection do select
        var offsets = sublevels[ level ]
        var off0 = offsets[ from * 4 + 0 ]
        var off1 = offsets[ from * 4 + 1 ]
        var off2 = offsets[ from * 4 + 2 ]
        var off3 = offsets[ from * 4 + 3 ]
        var end = nextOffset(offsets, from + 1)
  
        var d2 = d * .5
        var nextLevel = level + 1
        select( lox, loy, d2, nextLevel, off0, off1 || off2 || off3 || end)
        select( lox, loy + d2, d2, nextLevel, off1, off2 || off3 || end)
        select( lox + d2, loy, d2, nextLevel, off2, off3 || end)
        select( lox + d2, loy + d2, d2, nextLevel, off3, end)
      }
  
      function nextOffset(offsets, from) {
        var offset = null, i = 0
        while(offset === null) {
          offset = offsets[ from * 4 + i ]
          i++
          if (i > offsets.length) { return null }
        }
        return offset
      }
  
      return selection
    }
  
    // get range offsets within levels to render lods appropriate for zoom level
    // TODO: it is possible to store minSize of a point to optimize neede level calc
    function lod (lox, loy, hix, hiy, maxLevel) {
      var ranges = []
  
      for (var level = 0; level < maxLevel; level++) {
        var levelGroups = groups[level]
        var from = offsets[level][0]
  
        var levelGroupStart = group(lox, loy, level)
        var levelGroupEnd = group(hix, hiy, level)
  
        // FIXME: utilize sublevels to speed up search range here
        var startOffset = search.ge(levelGroups, levelGroupStart)
        var endOffset = search.gt(levelGroups, levelGroupEnd, startOffset, levelGroups.length - 1)
  
        ranges[level] = [startOffset + from, endOffset + from]
      }
  
      return ranges
    }
  
    // get group id closest to the x,y coordinate, corresponding to a level
    function group (x, y, level) {
      var group = 1
  
      var cx = .5, cy = .5
      var diam = .5
  
      for (var i = 0; i < level; i++) {
        group <<= 2
  
        group += x < cx ? (y < cy ? 0 : 1) : (y < cy ? 2 : 3)
  
        diam *= .5
  
        cx += x < cx ? -diam : diam
        cy += y < cy ? -diam : diam
      }
  
      return group
    }
  }
  
  
  // normalize points by bounds
  function normalize (pts, bounds) {
    var lox = bounds[0];
    var loy = bounds[1];
    var hix = bounds[2];
    var hiy = bounds[3];
    var scaleX = 1.0 / (hix - lox)
    var scaleY = 1.0 / (hiy - loy)
    var result = new Array(pts.length)
  
    for (var i = 0, n = pts.length / 2; i < n; i++) {
      result[2*i] = clamp((pts[2*i] - lox) * scaleX, 0, 1)
      result[2*i+1] = clamp((pts[2*i+1] - loy) * scaleY, 0, 1)
    }
  
    return result
  }
  
  },{"array-bounds":70,"binary-search-bounds":96,"clamp":120,"defined":170,"dtype":175,"flatten-vertex-data":244,"is-obj":442,"math-log2":453,"parse-rect":478,"pick-by-alias":485}],59:[function(_dereq_,module,exports){
  "use strict";
  Object.defineProperty(exports, "__esModule", { value: true });
  var meta_1 = _dereq_("@turf/meta");
  // Note: change RADIUS => earthRadius
  var RADIUS = 6378137;
  /**
   * Takes one or more features and returns their area in square meters.
   *
   * @name area
   * @param {GeoJSON} geojson input GeoJSON feature(s)
   * @returns {number} area in square meters
   * @example
   * var polygon = turf.polygon([[[125, -15], [113, -22], [154, -27], [144, -15], [125, -15]]]);
   *
   * var area = turf.area(polygon);
   *
   * //addToMap
   * var addToMap = [polygon]
   * polygon.properties.area = area
   */
  function area(geojson) {
      return meta_1.geomReduce(geojson, function (value, geom) {
          return value + calculateArea(geom);
      }, 0);
  }
  exports.default = area;
  /**
   * Calculate Area
   *
   * @private
   * @param {Geometry} geom GeoJSON Geometries
   * @returns {number} area
   */
  function calculateArea(geom) {
      var total = 0;
      var i;
      switch (geom.type) {
          case "Polygon":
              return polygonArea(geom.coordinates);
          case "MultiPolygon":
              for (i = 0; i < geom.coordinates.length; i++) {
                  total += polygonArea(geom.coordinates[i]);
              }
              return total;
          case "Point":
          case "MultiPoint":
          case "LineString":
          case "MultiLineString":
              return 0;
      }
      return 0;
  }
  function polygonArea(coords) {
      var total = 0;
      if (coords && coords.length > 0) {
          total += Math.abs(ringArea(coords[0]));
          for (var i = 1; i < coords.length; i++) {
              total -= Math.abs(ringArea(coords[i]));
          }
      }
      return total;
  }
  /**
   * @private
   * Calculate the approximate area of the polygon were it projected onto the earth.
   * Note that this area will be positive if ring is oriented clockwise, otherwise it will be negative.
   *
   * Reference:
   * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for Polygons on a Sphere",
   * JPL Publication 07-03, Jet Propulsion
   * Laboratory, Pasadena, CA, June 2007 http://trs-new.jpl.nasa.gov/dspace/handle/2014/40409
   *
   * @param {Array<Array<number>>} coords Ring Coordinates
   * @returns {number} The approximate signed geodesic area of the polygon in square meters.
   */
  function ringArea(coords) {
      var p1;
      var p2;
      var p3;
      var lowerIndex;
      var middleIndex;
      var upperIndex;
      var i;
      var total = 0;
      var coordsLength = coords.length;
      if (coordsLength > 2) {
          for (i = 0; i < coordsLength; i++) {
              if (i === coordsLength - 2) {
                  lowerIndex = coordsLength - 2;
                  middleIndex = coordsLength - 1;
                  upperIndex = 0;
              }
              else if (i === coordsLength - 1) {
                  lowerIndex = coordsLength - 1;
                  middleIndex = 0;
                  upperIndex = 1;
              }
              else {
                  lowerIndex = i;
                  middleIndex = i + 1;
                  upperIndex = i + 2;
              }
              p1 = coords[lowerIndex];
              p2 = coords[middleIndex];
              p3 = coords[upperIndex];
              total += (rad(p3[0]) - rad(p1[0])) * Math.sin(rad(p2[1]));
          }
          total = total * RADIUS * RADIUS / 2;
      }
      return total;
  }
  function rad(num) {
      return num * Math.PI / 180;
  }
  
  },{"@turf/meta":63}],60:[function(_dereq_,module,exports){
  "use strict";
  Object.defineProperty(exports, "__esModule", { value: true });
  var meta_1 = _dereq_("@turf/meta");
  /**
   * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
   *
   * @name bbox
   * @param {GeoJSON} geojson any GeoJSON object
   * @returns {BBox} bbox extent in [minX, minY, maxX, maxY] order
   * @example
   * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]]);
   * var bbox = turf.bbox(line);
   * var bboxPolygon = turf.bboxPolygon(bbox);
   *
   * //addToMap
   * var addToMap = [line, bboxPolygon]
   */
  function bbox(geojson) {
      var result = [Infinity, Infinity, -Infinity, -Infinity];
      meta_1.coordEach(geojson, function (coord) {
          if (result[0] > coord[0]) {
              result[0] = coord[0];
          }
          if (result[1] > coord[1]) {
              result[1] = coord[1];
          }
          if (result[2] < coord[0]) {
              result[2] = coord[0];
          }
          if (result[3] < coord[1]) {
              result[3] = coord[1];
          }
      });
      return result;
  }
  exports.default = bbox;
  
  },{"@turf/meta":63}],61:[function(_dereq_,module,exports){
  "use strict";
  Object.defineProperty(exports, "__esModule", { value: true });
  var meta_1 = _dereq_("@turf/meta");
  var helpers_1 = _dereq_("@turf/helpers");
  /**
   * Takes one or more features and calculates the centroid using the mean of all vertices.
   * This lessens the effect of small islands and artifacts when calculating the centroid of a set of polygons.
   *
   * @name centroid
   * @param {GeoJSON} geojson GeoJSON to be centered
   * @param {Object} [options={}] Optional Parameters
   * @param {Object} [options.properties={}] an Object that is used as the {@link Feature}'s properties
   * @returns {Feature<Point>} the centroid of the input features
   * @example
   * var polygon = turf.polygon([[[-81, 41], [-88, 36], [-84, 31], [-80, 33], [-77, 39], [-81, 41]]]);
   *
   * var centroid = turf.centroid(polygon);
   *
   * //addToMap
   * var addToMap = [polygon, centroid]
   */
  function centroid(geojson, options) {
      if (options === void 0) { options = {}; }
      var xSum = 0;
      var ySum = 0;
      var len = 0;
      meta_1.coordEach(geojson, function (coord) {
          xSum += coord[0];
          ySum += coord[1];
          len++;
      });
      return helpers_1.point([xSum / len, ySum / len], options.properties);
  }
  exports.default = centroid;
  
  },{"@turf/helpers":62,"@turf/meta":63}],62:[function(_dereq_,module,exports){
  "use strict";
  Object.defineProperty(exports, "__esModule", { value: true });
  /**
   * @module helpers
   */
  /**
   * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
   *
   * @memberof helpers
   * @type {number}
   */
  exports.earthRadius = 6371008.8;
  /**
   * Unit of measurement factors using a spherical (non-ellipsoid) earth radius.
   *
   * @memberof helpers
   * @type {Object}
   */
  exports.factors = {
      centimeters: exports.earthRadius * 100,
      centimetres: exports.earthRadius * 100,
      degrees: exports.earthRadius / 111325,
      feet: exports.earthRadius * 3.28084,
      inches: exports.earthRadius * 39.370,
      kilometers: exports.earthRadius / 1000,
      kilometres: exports.earthRadius / 1000,
      meters: exports.earthRadius,
      metres: exports.earthRadius,
      miles: exports.earthRadius / 1609.344,
      millimeters: exports.earthRadius * 1000,
      millimetres: exports.earthRadius * 1000,
      nauticalmiles: exports.earthRadius / 1852,
      radians: 1,
      yards: exports.earthRadius / 1.0936,
  };
  /**
   * Units of measurement factors based on 1 meter.
   *
   * @memberof helpers
   * @type {Object}
   */
  exports.unitsFactors = {
      centimeters: 100,
      centimetres: 100,
      degrees: 1 / 111325,
      feet: 3.28084,
      inches: 39.370,
      kilometers: 1 / 1000,
      kilometres: 1 / 1000,
      meters: 1,
      metres: 1,
      miles: 1 / 1609.344,
      millimeters: 1000,
      millimetres: 1000,
      nauticalmiles: 1 / 1852,
      radians: 1 / exports.earthRadius,
      yards: 1 / 1.0936,
  };
  /**
   * Area of measurement factors based on 1 square meter.
   *
   * @memberof helpers
   * @type {Object}
   */
  exports.areaFactors = {
      acres: 0.000247105,
      centimeters: 10000,
      centimetres: 10000,
      feet: 10.763910417,
      inches: 1550.003100006,
      kilometers: 0.000001,
      kilometres: 0.000001,
      meters: 1,
      metres: 1,
      miles: 3.86e-7,
      millimeters: 1000000,
      millimetres: 1000000,
      yards: 1.195990046,
  };
  /**
   * Wraps a GeoJSON {@link Geometry} in a GeoJSON {@link Feature}.
   *
   * @name feature
   * @param {Geometry} geometry input geometry
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the Feature
   * @returns {Feature} a GeoJSON Feature
   * @example
   * var geometry = {
   *   "type": "Point",
   *   "coordinates": [110, 50]
   * };
   *
   * var feature = turf.feature(geometry);
   *
   * //=feature
   */
  function feature(geom, properties, options) {
      if (options === void 0) { options = {}; }
      var feat = { type: "Feature" };
      if (options.id === 0 || options.id) {
          feat.id = options.id;
      }
      if (options.bbox) {
          feat.bbox = options.bbox;
      }
      feat.properties = properties || {};
      feat.geometry = geom;
      return feat;
  }
  exports.feature = feature;
  /**
   * Creates a GeoJSON {@link Geometry} from a Geometry string type & coordinates.
   * For GeometryCollection type use `helpers.geometryCollection`
   *
   * @name geometry
   * @param {string} type Geometry Type
   * @param {Array<any>} coordinates Coordinates
   * @param {Object} [options={}] Optional Parameters
   * @returns {Geometry} a GeoJSON Geometry
   * @example
   * var type = "Point";
   * var coordinates = [110, 50];
   * var geometry = turf.geometry(type, coordinates);
   * // => geometry
   */
  function geometry(type, coordinates, options) {
      if (options === void 0) { options = {}; }
      switch (type) {
          case "Point": return point(coordinates).geometry;
          case "LineString": return lineString(coordinates).geometry;
          case "Polygon": return polygon(coordinates).geometry;
          case "MultiPoint": return multiPoint(coordinates).geometry;
          case "MultiLineString": return multiLineString(coordinates).geometry;
          case "MultiPolygon": return multiPolygon(coordinates).geometry;
          default: throw new Error(type + " is invalid");
      }
  }
  exports.geometry = geometry;
  /**
   * Creates a {@link Point} {@link Feature} from a Position.
   *
   * @name point
   * @param {Array<number>} coordinates longitude, latitude position (each in decimal degrees)
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the Feature
   * @returns {Feature<Point>} a Point feature
   * @example
   * var point = turf.point([-75.343, 39.984]);
   *
   * //=point
   */
  function point(coordinates, properties, options) {
      if (options === void 0) { options = {}; }
      var geom = {
          type: "Point",
          coordinates: coordinates,
      };
      return feature(geom, properties, options);
  }
  exports.point = point;
  /**
   * Creates a {@link Point} {@link FeatureCollection} from an Array of Point coordinates.
   *
   * @name points
   * @param {Array<Array<number>>} coordinates an array of Points
   * @param {Object} [properties={}] Translate these properties to each Feature
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
   * associated with the FeatureCollection
   * @param {string|number} [options.id] Identifier associated with the FeatureCollection
   * @returns {FeatureCollection<Point>} Point Feature
   * @example
   * var points = turf.points([
   *   [-75, 39],
   *   [-80, 45],
   *   [-78, 50]
   * ]);
   *
   * //=points
   */
  function points(coordinates, properties, options) {
      if (options === void 0) { options = {}; }
      return featureCollection(coordinates.map(function (coords) {
          return point(coords, properties);
      }), options);
  }
  exports.points = points;
  /**
   * Creates a {@link Polygon} {@link Feature} from an Array of LinearRings.
   *
   * @name polygon
   * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the Feature
   * @returns {Feature<Polygon>} Polygon Feature
   * @example
   * var polygon = turf.polygon([[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]], { name: 'poly1' });
   *
   * //=polygon
   */
  function polygon(coordinates, properties, options) {
      if (options === void 0) { options = {}; }
      for (var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++) {
          var ring = coordinates_1[_i];
          if (ring.length < 4) {
              throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
          }
          for (var j = 0; j < ring[ring.length - 1].length; j++) {
              // Check if first point of Polygon contains two numbers
              if (ring[ring.length - 1][j] !== ring[0][j]) {
                  throw new Error("First and last Position are not equivalent.");
              }
          }
      }
      var geom = {
          type: "Polygon",
          coordinates: coordinates,
      };
      return feature(geom, properties, options);
  }
  exports.polygon = polygon;
  /**
   * Creates a {@link Polygon} {@link FeatureCollection} from an Array of Polygon coordinates.
   *
   * @name polygons
   * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygon coordinates
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the FeatureCollection
   * @returns {FeatureCollection<Polygon>} Polygon FeatureCollection
   * @example
   * var polygons = turf.polygons([
   *   [[[-5, 52], [-4, 56], [-2, 51], [-7, 54], [-5, 52]]],
   *   [[[-15, 42], [-14, 46], [-12, 41], [-17, 44], [-15, 42]]],
   * ]);
   *
   * //=polygons
   */
  function polygons(coordinates, properties, options) {
      if (options === void 0) { options = {}; }
      return featureCollection(coordinates.map(function (coords) {
          return polygon(coords, properties);
      }), options);
  }
  exports.polygons = polygons;
  /**
   * Creates a {@link LineString} {@link Feature} from an Array of Positions.
   *
   * @name lineString
   * @param {Array<Array<number>>} coordinates an array of Positions
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the Feature
   * @returns {Feature<LineString>} LineString Feature
   * @example
   * var linestring1 = turf.lineString([[-24, 63], [-23, 60], [-25, 65], [-20, 69]], {name: 'line 1'});
   * var linestring2 = turf.lineString([[-14, 43], [-13, 40], [-15, 45], [-10, 49]], {name: 'line 2'});
   *
   * //=linestring1
   * //=linestring2
   */
  function lineString(coordinates, properties, options) {
      if (options === void 0) { options = {}; }
      if (coordinates.length < 2) {
          throw new Error("coordinates must be an array of two or more positions");
      }
      var geom = {
          type: "LineString",
          coordinates: coordinates,
      };
      return feature(geom, properties, options);
  }
  exports.lineString = lineString;
  /**
   * Creates a {@link LineString} {@link FeatureCollection} from an Array of LineString coordinates.
   *
   * @name lineStrings
   * @param {Array<Array<Array<number>>>} coordinates an array of LinearRings
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north]
   * associated with the FeatureCollection
   * @param {string|number} [options.id] Identifier associated with the FeatureCollection
   * @returns {FeatureCollection<LineString>} LineString FeatureCollection
   * @example
   * var linestrings = turf.lineStrings([
   *   [[-24, 63], [-23, 60], [-25, 65], [-20, 69]],
   *   [[-14, 43], [-13, 40], [-15, 45], [-10, 49]]
   * ]);
   *
   * //=linestrings
   */
  function lineStrings(coordinates, properties, options) {
      if (options === void 0) { options = {}; }
      return featureCollection(coordinates.map(function (coords) {
          return lineString(coords, properties);
      }), options);
  }
  exports.lineStrings = lineStrings;
  /**
   * Takes one or more {@link Feature|Features} and creates a {@link FeatureCollection}.
   *
   * @name featureCollection
   * @param {Feature[]} features input features
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the Feature
   * @returns {FeatureCollection} FeatureCollection of Features
   * @example
   * var locationA = turf.point([-75.343, 39.984], {name: 'Location A'});
   * var locationB = turf.point([-75.833, 39.284], {name: 'Location B'});
   * var locationC = turf.point([-75.534, 39.123], {name: 'Location C'});
   *
   * var collection = turf.featureCollection([
   *   locationA,
   *   locationB,
   *   locationC
   * ]);
   *
   * //=collection
   */
  function featureCollection(features, options) {
      if (options === void 0) { options = {}; }
      var fc = { type: "FeatureCollection" };
      if (options.id) {
          fc.id = options.id;
      }
      if (options.bbox) {
          fc.bbox = options.bbox;
      }
      fc.features = features;
      return fc;
  }
  exports.featureCollection = featureCollection;
  /**
   * Creates a {@link Feature<MultiLineString>} based on a
   * coordinate array. Properties can be added optionally.
   *
   * @name multiLineString
   * @param {Array<Array<Array<number>>>} coordinates an array of LineStrings
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the Feature
   * @returns {Feature<MultiLineString>} a MultiLineString feature
   * @throws {Error} if no coordinates are passed
   * @example
   * var multiLine = turf.multiLineString([[[0,0],[10,10]]]);
   *
   * //=multiLine
   */
  function multiLineString(coordinates, properties, options) {
      if (options === void 0) { options = {}; }
      var geom = {
          type: "MultiLineString",
          coordinates: coordinates,
      };
      return feature(geom, properties, options);
  }
  exports.multiLineString = multiLineString;
  /**
   * Creates a {@link Feature<MultiPoint>} based on a
   * coordinate array. Properties can be added optionally.
   *
   * @name multiPoint
   * @param {Array<Array<number>>} coordinates an array of Positions
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the Feature
   * @returns {Feature<MultiPoint>} a MultiPoint feature
   * @throws {Error} if no coordinates are passed
   * @example
   * var multiPt = turf.multiPoint([[0,0],[10,10]]);
   *
   * //=multiPt
   */
  function multiPoint(coordinates, properties, options) {
      if (options === void 0) { options = {}; }
      var geom = {
          type: "MultiPoint",
          coordinates: coordinates,
      };
      return feature(geom, properties, options);
  }
  exports.multiPoint = multiPoint;
  /**
   * Creates a {@link Feature<MultiPolygon>} based on a
   * coordinate array. Properties can be added optionally.
   *
   * @name multiPolygon
   * @param {Array<Array<Array<Array<number>>>>} coordinates an array of Polygons
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the Feature
   * @returns {Feature<MultiPolygon>} a multipolygon feature
   * @throws {Error} if no coordinates are passed
   * @example
   * var multiPoly = turf.multiPolygon([[[[0,0],[0,10],[10,10],[10,0],[0,0]]]]);
   *
   * //=multiPoly
   *
   */
  function multiPolygon(coordinates, properties, options) {
      if (options === void 0) { options = {}; }
      var geom = {
          type: "MultiPolygon",
          coordinates: coordinates,
      };
      return feature(geom, properties, options);
  }
  exports.multiPolygon = multiPolygon;
  /**
   * Creates a {@link Feature<GeometryCollection>} based on a
   * coordinate array. Properties can be added optionally.
   *
   * @name geometryCollection
   * @param {Array<Geometry>} geometries an array of GeoJSON Geometries
   * @param {Object} [properties={}] an Object of key-value pairs to add as properties
   * @param {Object} [options={}] Optional Parameters
   * @param {Array<number>} [options.bbox] Bounding Box Array [west, south, east, north] associated with the Feature
   * @param {string|number} [options.id] Identifier associated with the Feature
   * @returns {Feature<GeometryCollection>} a GeoJSON GeometryCollection Feature
   * @example
   * var pt = turf.geometry("Point", [100, 0]);
   * var line = turf.geometry("LineString", [[101, 0], [102, 1]]);
   * var collection = turf.geometryCollection([pt, line]);
   *
   * // => collection
   */
  function geometryCollection(geometries, properties, options) {
      if (options === void 0) { options = {}; }
      var geom = {
          type: "GeometryCollection",
          geometries: geometries,
      };
      return feature(geom, properties, options);
  }
  exports.geometryCollection = geometryCollection;
  /**
   * Round number to precision
   *
   * @param {number} num Number
   * @param {number} [precision=0] Precision
   * @returns {number} rounded number
   * @example
   * turf.round(120.4321)
   * //=120
   *
   * turf.round(120.4321, 2)
   * //=120.43
   */
  function round(num, precision) {
      if (precision === void 0) { precision = 0; }
      if (precision && !(precision >= 0)) {
          throw new Error("precision must be a positive number");
      }
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(num * multiplier) / multiplier;
  }
  exports.round = round;
  /**
   * Convert a distance measurement (assuming a spherical Earth) from radians to a more friendly unit.
   * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
   *
   * @name radiansToLength
   * @param {number} radians in radians across the sphere
   * @param {string} [units="kilometers"] can be degrees, radians, miles, or kilometers inches, yards, metres,
   * meters, kilometres, kilometers.
   * @returns {number} distance
   */
  function radiansToLength(radians, units) {
      if (units === void 0) { units = "kilometers"; }
      var factor = exports.factors[units];
      if (!factor) {
          throw new Error(units + " units is invalid");
      }
      return radians * factor;
  }
  exports.radiansToLength = radiansToLength;
  /**
   * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into radians
   * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
   *
   * @name lengthToRadians
   * @param {number} distance in real units
   * @param {string} [units="kilometers"] can be degrees, radians, miles, or kilometers inches, yards, metres,
   * meters, kilometres, kilometers.
   * @returns {number} radians
   */
  function lengthToRadians(distance, units) {
      if (units === void 0) { units = "kilometers"; }
      var factor = exports.factors[units];
      if (!factor) {
          throw new Error(units + " units is invalid");
      }
      return distance / factor;
  }
  exports.lengthToRadians = lengthToRadians;
  /**
   * Convert a distance measurement (assuming a spherical Earth) from a real-world unit into degrees
   * Valid units: miles, nauticalmiles, inches, yards, meters, metres, centimeters, kilometres, feet
   *
   * @name lengthToDegrees
   * @param {number} distance in real units
   * @param {string} [units="kilometers"] can be degrees, radians, miles, or kilometers inches, yards, metres,
   * meters, kilometres, kilometers.
   * @returns {number} degrees
   */
  function lengthToDegrees(distance, units) {
      return radiansToDegrees(lengthToRadians(distance, units));
  }
  exports.lengthToDegrees = lengthToDegrees;
  /**
   * Converts any bearing angle from the north line direction (positive clockwise)
   * and returns an angle between 0-360 degrees (positive clockwise), 0 being the north line
   *
   * @name bearingToAzimuth
   * @param {number} bearing angle, between -180 and +180 degrees
   * @returns {number} angle between 0 and 360 degrees
   */
  function bearingToAzimuth(bearing) {
      var angle = bearing % 360;
      if (angle < 0) {
          angle += 360;
      }
      return angle;
  }
  exports.bearingToAzimuth = bearingToAzimuth;
  /**
   * Converts an angle in radians to degrees
   *
   * @name radiansToDegrees
   * @param {number} radians angle in radians
   * @returns {number} degrees between 0 and 360 degrees
   */
  function radiansToDegrees(radians) {
      var degrees = radians % (2 * Math.PI);
      return degrees * 180 / Math.PI;
  }
  exports.radiansToDegrees = radiansToDegrees;
  /**
   * Converts an angle in degrees to radians
   *
   * @name degreesToRadians
   * @param {number} degrees angle between 0 and 360 degrees
   * @returns {number} angle in radians
   */
  function degreesToRadians(degrees) {
      var radians = degrees % 360;
      return radians * Math.PI / 180;
  }
  exports.degreesToRadians = degreesToRadians;
  /**
   * Converts a length to the requested unit.
   * Valid units: miles, nauticalmiles, inches, yards, meters, metres, kilometers, centimeters, feet
   *
   * @param {number} length to be converted
   * @param {Units} [originalUnit="kilometers"] of the length
   * @param {Units} [finalUnit="kilometers"] returned unit
   * @returns {number} the converted length
   */
  function convertLength(length, originalUnit, finalUnit) {
      if (originalUnit === void 0) { originalUnit = "kilometers"; }
      if (finalUnit === void 0) { finalUnit = "kilometers"; }
      if (!(length >= 0)) {
          throw new Error("length must be a positive number");
      }
      return radiansToLength(lengthToRadians(length, originalUnit), finalUnit);
  }
  exports.convertLength = convertLength;
  /**
   * Converts a area to the requested unit.
   * Valid units: kilometers, kilometres, meters, metres, centimetres, millimeters, acres, miles, yards, feet, inches
   * @param {number} area to be converted
   * @param {Units} [originalUnit="meters"] of the distance
   * @param {Units} [finalUnit="kilometers"] returned unit
   * @returns {number} the converted distance
   */
  function convertArea(area, originalUnit, finalUnit) {
      if (originalUnit === void 0) { originalUnit = "meters"; }
      if (finalUnit === void 0) { finalUnit = "kilometers"; }
      if (!(area >= 0)) {
          throw new Error("area must be a positive number");
      }
      var startFactor = exports.areaFactors[originalUnit];
      if (!startFactor) {
          throw new Error("invalid original units");
      }
      var finalFactor = exports.areaFactors[finalUnit];
      if (!finalFactor) {
          throw new Error("invalid final units");
      }
      return (area / startFactor) * finalFactor;
  }
  exports.convertArea = convertArea;
  /**
   * isNumber
   *
   * @param {*} num Number to validate
   * @returns {boolean} true/false
   * @example
   * turf.isNumber(123)
   * //=true
   * turf.isNumber('foo')
   * //=false
   */
  function isNumber(num) {
      return !isNaN(num) && num !== null && !Array.isArray(num) && !/^\s*$/.test(num);
  }
  exports.isNumber = isNumber;
  /**
   * isObject
   *
   * @param {*} input variable to validate
   * @returns {boolean} true/false
   * @example
   * turf.isObject({elevation: 10})
   * //=true
   * turf.isObject('foo')
   * //=false
   */
  function isObject(input) {
      return (!!input) && (input.constructor === Object);
  }
  exports.isObject = isObject;
  /**
   * Validate BBox
   *
   * @private
   * @param {Array<number>} bbox BBox to validate
   * @returns {void}
   * @throws Error if BBox is not valid
   * @example
   * validateBBox([-180, -40, 110, 50])
   * //=OK
   * validateBBox([-180, -40])
   * //=Error
   * validateBBox('Foo')
   * //=Error
   * validateBBox(5)
   * //=Error
   * validateBBox(null)
   * //=Error
   * validateBBox(undefined)
   * //=Error
   */
  function validateBBox(bbox) {
      if (!bbox) {
          throw new Error("bbox is required");
      }
      if (!Array.isArray(bbox)) {
          throw new Error("bbox must be an Array");
      }
      if (bbox.length !== 4 && bbox.length !== 6) {
          throw new Error("bbox must be an Array of 4 or 6 numbers");
      }
      bbox.forEach(function (num) {
          if (!isNumber(num)) {
              throw new Error("bbox must only contain numbers");
          }
      });
  }
  exports.validateBBox = validateBBox;
  /**
   * Validate Id
   *
   * @private
   * @param {string|number} id Id to validate
   * @returns {void}
   * @throws Error if Id is not valid
   * @example
   * validateId([-180, -40, 110, 50])
   * //=Error
   * validateId([-180, -40])
   * //=Error
   * validateId('Foo')
   * //=OK
   * validateId(5)
   * //=OK
   * validateId(null)
   * //=Error
   * validateId(undefined)
   * //=Error
   */
  function validateId(id) {
      if (!id) {
          throw new Error("id is required");
      }
      if (["string", "number"].indexOf(typeof id) === -1) {
          throw new Error("id must be a number or a string");
      }
  }
  exports.validateId = validateId;
  // Deprecated methods
  function radians2degrees() {
      throw new Error("method has been renamed to `radiansToDegrees`");
  }
  exports.radians2degrees = radians2degrees;
  function degrees2radians() {
      throw new Error("method has been renamed to `degreesToRadians`");
  }
  exports.degrees2radians = degrees2radians;
  function distanceToDegrees() {
      throw new Error("method has been renamed to `lengthToDegrees`");
  }
  exports.distanceToDegrees = distanceToDegrees;
  function distanceToRadians() {
      throw new Error("method has been renamed to `lengthToRadians`");
  }
  exports.distanceToRadians = distanceToRadians;
  function radiansToDistance() {
      throw new Error("method has been renamed to `radiansToLength`");
  }
  exports.radiansToDistance = radiansToDistance;
  function bearingToAngle() {
      throw new Error("method has been renamed to `bearingToAzimuth`");
  }
  exports.bearingToAngle = bearingToAngle;
  function convertDistance() {
      throw new Error("method has been renamed to `convertLength`");
  }
  exports.convertDistance = convertDistance;
  
  },{}],63:[function(_dereq_,module,exports){
  'use strict';
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  var helpers = _dereq_('@turf/helpers');
  
  /**
   * Callback for coordEach
   *
   * @callback coordEachCallback
   * @param {Array<number>} currentCoord The current coordinate being processed.
   * @param {number} coordIndex The current index of the coordinate being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
   * @param {number} geometryIndex The current index of the Geometry being processed.
   */
  
  /**
   * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
   *
   * @name coordEach
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
   * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
   * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
   * @returns {void}
   * @example
   * var features = turf.featureCollection([
   *   turf.point([26, 37], {"foo": "bar"}),
   *   turf.point([36, 53], {"hello": "world"})
   * ]);
   *
   * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
   *   //=currentCoord
   *   //=coordIndex
   *   //=featureIndex
   *   //=multiFeatureIndex
   *   //=geometryIndex
   * });
   */
  function coordEach(geojson, callback, excludeWrapCoord) {
      // Handles null Geometry -- Skips this GeoJSON
      if (geojson === null) return;
      var j, k, l, geometry, stopG, coords,
          geometryMaybeCollection,
          wrapShrink = 0,
          coordIndex = 0,
          isGeometryCollection,
          type = geojson.type,
          isFeatureCollection = type === 'FeatureCollection',
          isFeature = type === 'Feature',
          stop = isFeatureCollection ? geojson.features.length : 1;
  
      // This logic may look a little weird. The reason why it is that way
      // is because it's trying to be fast. GeoJSON supports multiple kinds
      // of objects at its root: FeatureCollection, Features, Geometries.
      // This function has the responsibility of handling all of them, and that
      // means that some of the `for` loops you see below actually just don't apply
      // to certain inputs. For instance, if you give this just a
      // Point geometry, then both loops are short-circuited and all we do
      // is gradually rename the input until it's called 'geometry'.
      //
      // This also aims to allocate as few resources as possible: just a
      // few numbers and booleans, rather than any temporary arrays as would
      // be required with the normalization approach.
      for (var featureIndex = 0; featureIndex < stop; featureIndex++) {
          geometryMaybeCollection = (isFeatureCollection ? geojson.features[featureIndex].geometry :
              (isFeature ? geojson.geometry : geojson));
          isGeometryCollection = (geometryMaybeCollection) ? geometryMaybeCollection.type === 'GeometryCollection' : false;
          stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
  
          for (var geomIndex = 0; geomIndex < stopG; geomIndex++) {
              var multiFeatureIndex = 0;
              var geometryIndex = 0;
              geometry = isGeometryCollection ?
                  geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
  
              // Handles null Geometry -- Skips this geometry
              if (geometry === null) continue;
              coords = geometry.coordinates;
              var geomType = geometry.type;
  
              wrapShrink = (excludeWrapCoord && (geomType === 'Polygon' || geomType === 'MultiPolygon')) ? 1 : 0;
  
              switch (geomType) {
              case null:
                  break;
              case 'Point':
                  if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                  coordIndex++;
                  multiFeatureIndex++;
                  break;
              case 'LineString':
              case 'MultiPoint':
                  for (j = 0; j < coords.length; j++) {
                      if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                      coordIndex++;
                      if (geomType === 'MultiPoint') multiFeatureIndex++;
                  }
                  if (geomType === 'LineString') multiFeatureIndex++;
                  break;
              case 'Polygon':
              case 'MultiLineString':
                  for (j = 0; j < coords.length; j++) {
                      for (k = 0; k < coords[j].length - wrapShrink; k++) {
                          if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                          coordIndex++;
                      }
                      if (geomType === 'MultiLineString') multiFeatureIndex++;
                      if (geomType === 'Polygon') geometryIndex++;
                  }
                  if (geomType === 'Polygon') multiFeatureIndex++;
                  break;
              case 'MultiPolygon':
                  for (j = 0; j < coords.length; j++) {
                      geometryIndex = 0;
                      for (k = 0; k < coords[j].length; k++) {
                          for (l = 0; l < coords[j][k].length - wrapShrink; l++) {
                              if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                              coordIndex++;
                          }
                          geometryIndex++;
                      }
                      multiFeatureIndex++;
                  }
                  break;
              case 'GeometryCollection':
                  for (j = 0; j < geometry.geometries.length; j++)
                      if (coordEach(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                  break;
              default:
                  throw new Error('Unknown Geometry Type');
              }
          }
      }
  }
  
  /**
   * Callback for coordReduce
   *
   * The first time the callback function is called, the values provided as arguments depend
   * on whether the reduce method has an initialValue argument.
   *
   * If an initialValue is provided to the reduce method:
   *  - The previousValue argument is initialValue.
   *  - The currentValue argument is the value of the first element present in the array.
   *
   * If an initialValue is not provided:
   *  - The previousValue argument is the value of the first element present in the array.
   *  - The currentValue argument is the value of the second element present in the array.
   *
   * @callback coordReduceCallback
   * @param {*} previousValue The accumulated value previously returned in the last invocation
   * of the callback, or initialValue, if supplied.
   * @param {Array<number>} currentCoord The current coordinate being processed.
   * @param {number} coordIndex The current index of the coordinate being processed.
   * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
   * @param {number} featureIndex The current index of the Feature being processed.
   * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
   * @param {number} geometryIndex The current index of the Geometry being processed.
   */
  
  /**
   * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
   *
   * @name coordReduce
   * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
   * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
   * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
   * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
   * @returns {*} The value that results from the reduction.
   * @example
   * var features = turf.featureCollection([
   *   turf.point([26, 37], {"foo": "bar"}),
   *   turf.point([36, 53], {"hello": "world"})
   * ]);
   *
   * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
   *   //=previousValue
   *   //=currentCoord
   *   //=coordIndex
   *   //=featureIndex
   *   //=multiFeatureIndex
   *   //=geometryIndex
   *   return currentCoord;
   * });
   */
  function coordReduce(geojson, callback, initialValue, excludeWrapCoord) {
      var previousValue = initialValue;
      coordEach(geojson, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
          if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
          else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
      }, excludeWrapCoord);
      return previousValue;
  }
  
  /**
   * Callback for propEach
   *
   * @callback propEachCallback
   * @param {Object} currentProperties The current Properties being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   */
  
  /**
   * Iterate over properties in any GeoJSON object, similar to Array.forEach()
   *
   * @name propEach
   * @param {FeatureCollection|Feature} geojson any GeoJSON object
   * @param {Function} callback a method that takes (currentProperties, featureIndex)
   * @returns {void}
   * @example
   * var features = turf.featureCollection([
   *     turf.point([26, 37], {foo: 'bar'}),
   *     turf.point([36, 53], {hello: 'world'})
   * ]);
   *
   * turf.propEach(features, function (currentProperties, featureIndex) {
   *   //=currentProperties
   *   //=featureIndex
   * });
   */
  function propEach(geojson, callback) {
      var i;
      switch (geojson.type) {
      case 'FeatureCollection':
          for (i = 0; i < geojson.features.length; i++) {
              if (callback(geojson.features[i].properties, i) === false) break;
          }
          break;
      case 'Feature':
          callback(geojson.properties, 0);
          break;
      }
  }
  
  
  /**
   * Callback for propReduce
   *
   * The first time the callback function is called, the values provided as arguments depend
   * on whether the reduce method has an initialValue argument.
   *
   * If an initialValue is provided to the reduce method:
   *  - The previousValue argument is initialValue.
   *  - The currentValue argument is the value of the first element present in the array.
   *
   * If an initialValue is not provided:
   *  - The previousValue argument is the value of the first element present in the array.
   *  - The currentValue argument is the value of the second element present in the array.
   *
   * @callback propReduceCallback
   * @param {*} previousValue The accumulated value previously returned in the last invocation
   * of the callback, or initialValue, if supplied.
   * @param {*} currentProperties The current Properties being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   */
  
  /**
   * Reduce properties in any GeoJSON object into a single value,
   * similar to how Array.reduce works. However, in this case we lazily run
   * the reduction, so an array of all properties is unnecessary.
   *
   * @name propReduce
   * @param {FeatureCollection|Feature} geojson any GeoJSON object
   * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
   * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
   * @returns {*} The value that results from the reduction.
   * @example
   * var features = turf.featureCollection([
   *     turf.point([26, 37], {foo: 'bar'}),
   *     turf.point([36, 53], {hello: 'world'})
   * ]);
   *
   * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
   *   //=previousValue
   *   //=currentProperties
   *   //=featureIndex
   *   return currentProperties
   * });
   */
  function propReduce(geojson, callback, initialValue) {
      var previousValue = initialValue;
      propEach(geojson, function (currentProperties, featureIndex) {
          if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
          else previousValue = callback(previousValue, currentProperties, featureIndex);
      });
      return previousValue;
  }
  
  /**
   * Callback for featureEach
   *
   * @callback featureEachCallback
   * @param {Feature<any>} currentFeature The current Feature being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   */
  
  /**
   * Iterate over features in any GeoJSON object, similar to
   * Array.forEach.
   *
   * @name featureEach
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
   * @param {Function} callback a method that takes (currentFeature, featureIndex)
   * @returns {void}
   * @example
   * var features = turf.featureCollection([
   *   turf.point([26, 37], {foo: 'bar'}),
   *   turf.point([36, 53], {hello: 'world'})
   * ]);
   *
   * turf.featureEach(features, function (currentFeature, featureIndex) {
   *   //=currentFeature
   *   //=featureIndex
   * });
   */
  function featureEach(geojson, callback) {
      if (geojson.type === 'Feature') {
          callback(geojson, 0);
      } else if (geojson.type === 'FeatureCollection') {
          for (var i = 0; i < geojson.features.length; i++) {
              if (callback(geojson.features[i], i) === false) break;
          }
      }
  }
  
  /**
   * Callback for featureReduce
   *
   * The first time the callback function is called, the values provided as arguments depend
   * on whether the reduce method has an initialValue argument.
   *
   * If an initialValue is provided to the reduce method:
   *  - The previousValue argument is initialValue.
   *  - The currentValue argument is the value of the first element present in the array.
   *
   * If an initialValue is not provided:
   *  - The previousValue argument is the value of the first element present in the array.
   *  - The currentValue argument is the value of the second element present in the array.
   *
   * @callback featureReduceCallback
   * @param {*} previousValue The accumulated value previously returned in the last invocation
   * of the callback, or initialValue, if supplied.
   * @param {Feature} currentFeature The current Feature being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   */
  
  /**
   * Reduce features in any GeoJSON object, similar to Array.reduce().
   *
   * @name featureReduce
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
   * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
   * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
   * @returns {*} The value that results from the reduction.
   * @example
   * var features = turf.featureCollection([
   *   turf.point([26, 37], {"foo": "bar"}),
   *   turf.point([36, 53], {"hello": "world"})
   * ]);
   *
   * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
   *   //=previousValue
   *   //=currentFeature
   *   //=featureIndex
   *   return currentFeature
   * });
   */
  function featureReduce(geojson, callback, initialValue) {
      var previousValue = initialValue;
      featureEach(geojson, function (currentFeature, featureIndex) {
          if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
          else previousValue = callback(previousValue, currentFeature, featureIndex);
      });
      return previousValue;
  }
  
  /**
   * Get all coordinates from any GeoJSON object.
   *
   * @name coordAll
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
   * @returns {Array<Array<number>>} coordinate position array
   * @example
   * var features = turf.featureCollection([
   *   turf.point([26, 37], {foo: 'bar'}),
   *   turf.point([36, 53], {hello: 'world'})
   * ]);
   *
   * var coords = turf.coordAll(features);
   * //= [[26, 37], [36, 53]]
   */
  function coordAll(geojson) {
      var coords = [];
      coordEach(geojson, function (coord) {
          coords.push(coord);
      });
      return coords;
  }
  
  /**
   * Callback for geomEach
   *
   * @callback geomEachCallback
   * @param {Geometry} currentGeometry The current Geometry being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   * @param {Object} featureProperties The current Feature Properties being processed.
   * @param {Array<number>} featureBBox The current Feature BBox being processed.
   * @param {number|string} featureId The current Feature Id being processed.
   */
  
  /**
   * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
   *
   * @name geomEach
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
   * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
   * @returns {void}
   * @example
   * var features = turf.featureCollection([
   *     turf.point([26, 37], {foo: 'bar'}),
   *     turf.point([36, 53], {hello: 'world'})
   * ]);
   *
   * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
   *   //=currentGeometry
   *   //=featureIndex
   *   //=featureProperties
   *   //=featureBBox
   *   //=featureId
   * });
   */
  function geomEach(geojson, callback) {
      var i, j, g, geometry, stopG,
          geometryMaybeCollection,
          isGeometryCollection,
          featureProperties,
          featureBBox,
          featureId,
          featureIndex = 0,
          isFeatureCollection = geojson.type === 'FeatureCollection',
          isFeature = geojson.type === 'Feature',
          stop = isFeatureCollection ? geojson.features.length : 1;
  
      // This logic may look a little weird. The reason why it is that way
      // is because it's trying to be fast. GeoJSON supports multiple kinds
      // of objects at its root: FeatureCollection, Features, Geometries.
      // This function has the responsibility of handling all of them, and that
      // means that some of the `for` loops you see below actually just don't apply
      // to certain inputs. For instance, if you give this just a
      // Point geometry, then both loops are short-circuited and all we do
      // is gradually rename the input until it's called 'geometry'.
      //
      // This also aims to allocate as few resources as possible: just a
      // few numbers and booleans, rather than any temporary arrays as would
      // be required with the normalization approach.
      for (i = 0; i < stop; i++) {
  
          geometryMaybeCollection = (isFeatureCollection ? geojson.features[i].geometry :
              (isFeature ? geojson.geometry : geojson));
          featureProperties = (isFeatureCollection ? geojson.features[i].properties :
              (isFeature ? geojson.properties : {}));
          featureBBox = (isFeatureCollection ? geojson.features[i].bbox :
              (isFeature ? geojson.bbox : undefined));
          featureId = (isFeatureCollection ? geojson.features[i].id :
              (isFeature ? geojson.id : undefined));
          isGeometryCollection = (geometryMaybeCollection) ? geometryMaybeCollection.type === 'GeometryCollection' : false;
          stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
  
          for (g = 0; g < stopG; g++) {
              geometry = isGeometryCollection ?
                  geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
  
              // Handle null Geometry
              if (geometry === null) {
                  if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                  continue;
              }
              switch (geometry.type) {
              case 'Point':
              case 'LineString':
              case 'MultiPoint':
              case 'Polygon':
              case 'MultiLineString':
              case 'MultiPolygon': {
                  if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                  break;
              }
              case 'GeometryCollection': {
                  for (j = 0; j < geometry.geometries.length; j++) {
                      if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                  }
                  break;
              }
              default:
                  throw new Error('Unknown Geometry Type');
              }
          }
          // Only increase `featureIndex` per each feature
          featureIndex++;
      }
  }
  
  /**
   * Callback for geomReduce
   *
   * The first time the callback function is called, the values provided as arguments depend
   * on whether the reduce method has an initialValue argument.
   *
   * If an initialValue is provided to the reduce method:
   *  - The previousValue argument is initialValue.
   *  - The currentValue argument is the value of the first element present in the array.
   *
   * If an initialValue is not provided:
   *  - The previousValue argument is the value of the first element present in the array.
   *  - The currentValue argument is the value of the second element present in the array.
   *
   * @callback geomReduceCallback
   * @param {*} previousValue The accumulated value previously returned in the last invocation
   * of the callback, or initialValue, if supplied.
   * @param {Geometry} currentGeometry The current Geometry being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   * @param {Object} featureProperties The current Feature Properties being processed.
   * @param {Array<number>} featureBBox The current Feature BBox being processed.
   * @param {number|string} featureId The current Feature Id being processed.
   */
  
  /**
   * Reduce geometry in any GeoJSON object, similar to Array.reduce().
   *
   * @name geomReduce
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
   * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
   * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
   * @returns {*} The value that results from the reduction.
   * @example
   * var features = turf.featureCollection([
   *     turf.point([26, 37], {foo: 'bar'}),
   *     turf.point([36, 53], {hello: 'world'})
   * ]);
   *
   * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
   *   //=previousValue
   *   //=currentGeometry
   *   //=featureIndex
   *   //=featureProperties
   *   //=featureBBox
   *   //=featureId
   *   return currentGeometry
   * });
   */
  function geomReduce(geojson, callback, initialValue) {
      var previousValue = initialValue;
      geomEach(geojson, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
          if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
          else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
      });
      return previousValue;
  }
  
  /**
   * Callback for flattenEach
   *
   * @callback flattenEachCallback
   * @param {Feature} currentFeature The current flattened feature being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
   */
  
  /**
   * Iterate over flattened features in any GeoJSON object, similar to
   * Array.forEach.
   *
   * @name flattenEach
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
   * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
   * @example
   * var features = turf.featureCollection([
   *     turf.point([26, 37], {foo: 'bar'}),
   *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
   * ]);
   *
   * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
   *   //=currentFeature
   *   //=featureIndex
   *   //=multiFeatureIndex
   * });
   */
  function flattenEach(geojson, callback) {
      geomEach(geojson, function (geometry, featureIndex, properties, bbox, id) {
          // Callback for single geometry
          var type = (geometry === null) ? null : geometry.type;
          switch (type) {
          case null:
          case 'Point':
          case 'LineString':
          case 'Polygon':
              if (callback(helpers.feature(geometry, properties, {bbox: bbox, id: id}), featureIndex, 0) === false) return false;
              return;
          }
  
          var geomType;
  
          // Callback for multi-geometry
          switch (type) {
          case 'MultiPoint':
              geomType = 'Point';
              break;
          case 'MultiLineString':
              geomType = 'LineString';
              break;
          case 'MultiPolygon':
              geomType = 'Polygon';
              break;
          }
  
          for (var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++) {
              var coordinate = geometry.coordinates[multiFeatureIndex];
              var geom = {
                  type: geomType,
                  coordinates: coordinate
              };
              if (callback(helpers.feature(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
          }
      });
  }
  
  /**
   * Callback for flattenReduce
   *
   * The first time the callback function is called, the values provided as arguments depend
   * on whether the reduce method has an initialValue argument.
   *
   * If an initialValue is provided to the reduce method:
   *  - The previousValue argument is initialValue.
   *  - The currentValue argument is the value of the first element present in the array.
   *
   * If an initialValue is not provided:
   *  - The previousValue argument is the value of the first element present in the array.
   *  - The currentValue argument is the value of the second element present in the array.
   *
   * @callback flattenReduceCallback
   * @param {*} previousValue The accumulated value previously returned in the last invocation
   * of the callback, or initialValue, if supplied.
   * @param {Feature} currentFeature The current Feature being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
   */
  
  /**
   * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
   *
   * @name flattenReduce
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
   * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
   * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
   * @returns {*} The value that results from the reduction.
   * @example
   * var features = turf.featureCollection([
   *     turf.point([26, 37], {foo: 'bar'}),
   *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
   * ]);
   *
   * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
   *   //=previousValue
   *   //=currentFeature
   *   //=featureIndex
   *   //=multiFeatureIndex
   *   return currentFeature
   * });
   */
  function flattenReduce(geojson, callback, initialValue) {
      var previousValue = initialValue;
      flattenEach(geojson, function (currentFeature, featureIndex, multiFeatureIndex) {
          if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
          else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
      });
      return previousValue;
  }
  
  /**
   * Callback for segmentEach
   *
   * @callback segmentEachCallback
   * @param {Feature<LineString>} currentSegment The current Segment being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
   * @param {number} geometryIndex The current index of the Geometry being processed.
   * @param {number} segmentIndex The current index of the Segment being processed.
   * @returns {void}
   */
  
  /**
   * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
   * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
   *
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
   * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
   * @returns {void}
   * @example
   * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
   *
   * // Iterate over GeoJSON by 2-vertex segments
   * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
   *   //=currentSegment
   *   //=featureIndex
   *   //=multiFeatureIndex
   *   //=geometryIndex
   *   //=segmentIndex
   * });
   *
   * // Calculate the total number of segments
   * var total = 0;
   * turf.segmentEach(polygon, function () {
   *     total++;
   * });
   */
  function segmentEach(geojson, callback) {
      flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
          var segmentIndex = 0;
  
          // Exclude null Geometries
          if (!feature.geometry) return;
          // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
          var type = feature.geometry.type;
          if (type === 'Point' || type === 'MultiPoint') return;
  
          // Generate 2-vertex line segments
          var previousCoords;
          var previousFeatureIndex = 0;
          var previousMultiIndex = 0;
          var prevGeomIndex = 0;
          if (coordEach(feature, function (currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
              // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
              if (previousCoords === undefined || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                  previousCoords = currentCoord;
                  previousFeatureIndex = featureIndex;
                  previousMultiIndex = multiPartIndexCoord;
                  prevGeomIndex = geometryIndex;
                  segmentIndex = 0;
                  return;
              }
              var currentSegment = helpers.lineString([previousCoords, currentCoord], feature.properties);
              if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
              segmentIndex++;
              previousCoords = currentCoord;
          }) === false) return false;
      });
  }
  
  /**
   * Callback for segmentReduce
   *
   * The first time the callback function is called, the values provided as arguments depend
   * on whether the reduce method has an initialValue argument.
   *
   * If an initialValue is provided to the reduce method:
   *  - The previousValue argument is initialValue.
   *  - The currentValue argument is the value of the first element present in the array.
   *
   * If an initialValue is not provided:
   *  - The previousValue argument is the value of the first element present in the array.
   *  - The currentValue argument is the value of the second element present in the array.
   *
   * @callback segmentReduceCallback
   * @param {*} previousValue The accumulated value previously returned in the last invocation
   * of the callback, or initialValue, if supplied.
   * @param {Feature<LineString>} currentSegment The current Segment being processed.
   * @param {number} featureIndex The current index of the Feature being processed.
   * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
   * @param {number} geometryIndex The current index of the Geometry being processed.
   * @param {number} segmentIndex The current index of the Segment being processed.
   */
  
  /**
   * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
   * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
   *
   * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
   * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
   * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
   * @returns {void}
   * @example
   * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
   *
   * // Iterate over GeoJSON by 2-vertex segments
   * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
   *   //= previousSegment
   *   //= currentSegment
   *   //= featureIndex
   *   //= multiFeatureIndex
   *   //= geometryIndex
   *   //= segmentInex
   *   return currentSegment
   * });
   *
   * // Calculate the total number of segments
   * var initialValue = 0
   * var total = turf.segmentReduce(polygon, function (previousValue) {
   *     previousValue++;
   *     return previousValue;
   * }, initialValue);
   */
  function segmentReduce(geojson, callback, initialValue) {
      var previousValue = initialValue;
      var started = false;
      segmentEach(geojson, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
          if (started === false && initialValue === undefined) previousValue = currentSegment;
          else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
          started = true;
      });
      return previousValue;
  }
  
  /**
   * Callback for lineEach
   *
   * @callback lineEachCallback
   * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
   * @param {number} featureIndex The current index of the Feature being processed
   * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
   * @param {number} geometryIndex The current index of the Geometry being processed
   */
  
  /**
   * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
   * similar to Array.forEach.
   *
   * @name lineEach
   * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
   * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
   * @example
   * var multiLine = turf.multiLineString([
   *   [[26, 37], [35, 45]],
   *   [[36, 53], [38, 50], [41, 55]]
   * ]);
   *
   * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
   *   //=currentLine
   *   //=featureIndex
   *   //=multiFeatureIndex
   *   //=geometryIndex
   * });
   */
  function lineEach(geojson, callback) {
      // validation
      if (!geojson) throw new Error('geojson is required');
  
      flattenEach(geojson, function (feature, featureIndex, multiFeatureIndex) {
          if (feature.geometry === null) return;
          var type = feature.geometry.type;
          var coords = feature.geometry.coordinates;
          switch (type) {
          case 'LineString':
              if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
              break;
          case 'Polygon':
              for (var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++) {
                  if (callback(helpers.lineString(coords[geometryIndex], feature.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
              }
              break;
          }
      });
  }
  
  /**
   * Callback for lineReduce
   *
   * The first time the callback function is called, the values provided as arguments depend
   * on whether the reduce method has an initialValue argument.
   *
   * If an initialValue is provided to the reduce method:
   *  - The previousValue argument is initialValue.
   *  - The currentValue argument is the value of the first element present in the array.
   *
   * If an initialValue is not provided:
   *  - The previousValue argument is the value of the first element present in the array.
   *  - The currentValue argument is the value of the second element present in the array.
   *
   * @callback lineReduceCallback
   * @param {*} previousValue The accumulated value previously returned in the last invocation
   * of the callback, or initialValue, if supplied.
   * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
   * @param {number} featureIndex The current index of the Feature being processed
   * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
   * @param {number} geometryIndex The current index of the Geometry being processed
   */
  
  /**
   * Reduce features in any GeoJSON object, similar to Array.reduce().
   *
   * @name lineReduce
   * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
   * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
   * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
   * @returns {*} The value that results from the reduction.
   * @example
   * var multiPoly = turf.multiPolygon([
   *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
   *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
   * ]);
   *
   * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
   *   //=previousValue
   *   //=currentLine
   *   //=featureIndex
   *   //=multiFeatureIndex
   *   //=geometryIndex
   *   return currentLine
   * });
   */
  function lineReduce(geojson, callback, initialValue) {
      var previousValue = initialValue;
      lineEach(geojson, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
          if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
          else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
      });
      return previousValue;
  }
  
  /**
   * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
   *
   * Negative indexes are permitted.
   * Point & MultiPoint will always return null.
   *
   * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
   * @param {Object} [options={}] Optional parameters
   * @param {number} [options.featureIndex=0] Feature Index
   * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
   * @param {number} [options.geometryIndex=0] Geometry Index
   * @param {number} [options.segmentIndex=0] Segment Index
   * @param {Object} [options.properties={}] Translate Properties to output LineString
   * @param {BBox} [options.bbox={}] Translate BBox to output LineString
   * @param {number|string} [options.id={}] Translate Id to output LineString
   * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
   * @example
   * var multiLine = turf.multiLineString([
   *     [[10, 10], [50, 30], [30, 40]],
   *     [[-10, -10], [-50, -30], [-30, -40]]
   * ]);
   *
   * // First Segment (defaults are 0)
   * turf.findSegment(multiLine);
   * // => Feature<LineString<[[10, 10], [50, 30]]>>
   *
   * // First Segment of 2nd Multi Feature
   * turf.findSegment(multiLine, {multiFeatureIndex: 1});
   * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
   *
   * // Last Segment of Last Multi Feature
   * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
   * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
   */
  function findSegment(geojson, options) {
      // Optional Parameters
      options = options || {};
      if (!helpers.isObject(options)) throw new Error('options is invalid');
      var featureIndex = options.featureIndex || 0;
      var multiFeatureIndex = options.multiFeatureIndex || 0;
      var geometryIndex = options.geometryIndex || 0;
      var segmentIndex = options.segmentIndex || 0;
  
      // Find FeatureIndex
      var properties = options.properties;
      var geometry;
  
      switch (geojson.type) {
      case 'FeatureCollection':
          if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
          properties = properties || geojson.features[featureIndex].properties;
          geometry = geojson.features[featureIndex].geometry;
          break;
      case 'Feature':
          properties = properties || geojson.properties;
          geometry = geojson.geometry;
          break;
      case 'Point':
      case 'MultiPoint':
          return null;
      case 'LineString':
      case 'Polygon':
      case 'MultiLineString':
      case 'MultiPolygon':
          geometry = geojson;
          break;
      default:
          throw new Error('geojson is invalid');
      }
  
      // Find SegmentIndex
      if (geometry === null) return null;
      var coords = geometry.coordinates;
      switch (geometry.type) {
      case 'Point':
      case 'MultiPoint':
          return null;
      case 'LineString':
          if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
          return helpers.lineString([coords[segmentIndex], coords[segmentIndex + 1]], properties, options);
      case 'Polygon':
          if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
          if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
          return helpers.lineString([coords[geometryIndex][segmentIndex], coords[geometryIndex][segmentIndex + 1]], properties, options);
      case 'MultiLineString':
          if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
          if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
          return helpers.lineString([coords[multiFeatureIndex][segmentIndex], coords[multiFeatureIndex][segmentIndex + 1]], properties, options);
      case 'MultiPolygon':
          if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
          if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
          if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
          return helpers.lineString([coords[multiFeatureIndex][geometryIndex][segmentIndex], coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]], properties, options);
      }
      throw new Error('geojson is invalid');
  }
  
  /**
   * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
   *
   * Negative indexes are permitted.
   *
   * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
   * @param {Object} [options={}] Optional parameters
   * @param {number} [options.featureIndex=0] Feature Index
   * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
   * @param {number} [options.geometryIndex=0] Geometry Index
   * @param {number} [options.coordIndex=0] Coord Index
   * @param {Object} [options.properties={}] Translate Properties to output Point
   * @param {BBox} [options.bbox={}] Translate BBox to output Point
   * @param {number|string} [options.id={}] Translate Id to output Point
   * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
   * @example
   * var multiLine = turf.multiLineString([
   *     [[10, 10], [50, 30], [30, 40]],
   *     [[-10, -10], [-50, -30], [-30, -40]]
   * ]);
   *
   * // First Segment (defaults are 0)
   * turf.findPoint(multiLine);
   * // => Feature<Point<[10, 10]>>
   *
   * // First Segment of the 2nd Multi-Feature
   * turf.findPoint(multiLine, {multiFeatureIndex: 1});
   * // => Feature<Point<[-10, -10]>>
   *
   * // Last Segment of last Multi-Feature
   * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
   * // => Feature<Point<[-30, -40]>>
   */
  function findPoint(geojson, options) {
      // Optional Parameters
      options = options || {};
      if (!helpers.isObject(options)) throw new Error('options is invalid');
      var featureIndex = options.featureIndex || 0;
      var multiFeatureIndex = options.multiFeatureIndex || 0;
      var geometryIndex = options.geometryIndex || 0;
      var coordIndex = options.coordIndex || 0;
  
      // Find FeatureIndex
      var properties = options.properties;
      var geometry;
  
      switch (geojson.type) {
      case 'FeatureCollection':
          if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
          properties = properties || geojson.features[featureIndex].properties;
          geometry = geojson.features[featureIndex].geometry;
          break;
      case 'Feature':
          properties = properties || geojson.properties;
          geometry = geojson.geometry;
          break;
      case 'Point':
      case 'MultiPoint':
          return null;
      case 'LineString':
      case 'Polygon':
      case 'MultiLineString':
      case 'MultiPolygon':
          geometry = geojson;
          break;
      default:
          throw new Error('geojson is invalid');
      }
  
      // Find Coord Index
      if (geometry === null) return null;
      var coords = geometry.coordinates;
      switch (geometry.type) {
      case 'Point':
          return helpers.point(coords, properties, options);
      case 'MultiPoint':
          if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
          return helpers.point(coords[multiFeatureIndex], properties, options);
      case 'LineString':
          if (coordIndex < 0) coordIndex = coords.length + coordIndex;
          return helpers.point(coords[coordIndex], properties, options);
      case 'Polygon':
          if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
          if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
          return helpers.point(coords[geometryIndex][coordIndex], properties, options);
      case 'MultiLineString':
          if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
          if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
          return helpers.point(coords[multiFeatureIndex][coordIndex], properties, options);
      case 'MultiPolygon':
          if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
          if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
          if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
          return helpers.point(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
      }
      throw new Error('geojson is invalid');
  }
  
  exports.coordEach = coordEach;
  exports.coordReduce = coordReduce;
  exports.propEach = propEach;
  exports.propReduce = propReduce;
  exports.featureEach = featureEach;
  exports.featureReduce = featureReduce;
  exports.coordAll = coordAll;
  exports.geomEach = geomEach;
  exports.geomReduce = geomReduce;
  exports.flattenEach = flattenEach;
  exports.flattenReduce = flattenReduce;
  exports.segmentEach = segmentEach;
  exports.segmentReduce = segmentReduce;
  exports.lineEach = lineEach;
  exports.lineReduce = lineReduce;
  exports.findSegment = findSegment;
  exports.findPoint = findPoint;
  
  },{"@turf/helpers":62}],64:[function(_dereq_,module,exports){
  'use strict'
  
  var weakMap      = typeof WeakMap === 'undefined' ? _dereq_('weak-map') : WeakMap
  var createBuffer = _dereq_('gl-buffer')
  var createVAO    = _dereq_('gl-vao')
  
  var TriangleCache = new weakMap()
  
  function createABigTriangle(gl) {
  
    var triangleVAO = TriangleCache.get(gl)
    var handle = triangleVAO && (triangleVAO._triangleBuffer.handle || triangleVAO._triangleBuffer.buffer)
    if(!handle || !gl.isBuffer(handle)) {
      var buf = createBuffer(gl, new Float32Array([-1, -1, -1, 4, 4, -1]))
      triangleVAO = createVAO(gl, [
        { buffer: buf,
          type: gl.FLOAT,
          size: 2
        }
      ])
      triangleVAO._triangleBuffer = buf
      TriangleCache.set(gl, triangleVAO)
    }
    triangleVAO.bind()
    gl.drawArrays(gl.TRIANGLES, 0, 3)
    triangleVAO.unbind()
  }
  
  module.exports = createABigTriangle
  
  },{"gl-buffer":258,"gl-vao":332,"weak-map":574}],65:[function(_dereq_,module,exports){
  
  module.exports = absolutize
  
  /**
   * redefine `path` with absolute coordinates
   *
   * @param {Array} path
   * @return {Array}
   */
  
  function absolutize(path){
    var startX = 0
    var startY = 0
    var x = 0
    var y = 0
  
    return path.map(function(seg){
      seg = seg.slice()
      var type = seg[0]
      var command = type.toUpperCase()
  
      // is relative
      if (type != command) {
        seg[0] = command
        switch (type) {
          case 'a':
            seg[6] += x
            seg[7] += y
            break
          case 'v':
            seg[1] += y
            break
          case 'h':
            seg[1] += x
            break
          default:
            for (var i = 1; i < seg.length;) {
              seg[i++] += x
              seg[i++] += y
            }
        }
      }
  
      // update cursor state
      switch (command) {
        case 'Z':
          x = startX
          y = startY
          break
        case 'H':
          x = seg[1]
          break
        case 'V':
          y = seg[1]
          break
        case 'M':
          x = startX = seg[1]
          y = startY = seg[2]
          break
        default:
          x = seg[seg.length - 2]
          y = seg[seg.length - 1]
      }
  
      return seg
    })
  }
  
  },{}],66:[function(_dereq_,module,exports){
  var padLeft = _dereq_('pad-left')
  
  module.exports = addLineNumbers
  function addLineNumbers (string, start, delim) {
    start = typeof start === 'number' ? start : 1
    delim = delim || ': '
  
    var lines = string.split(/\r?\n/)
    var totalDigits = String(lines.length + start - 1).length
    return lines.map(function (line, i) {
      var c = i + start
      var digits = String(c).length
      var prefix = padLeft(c, totalDigits - digits)
      return prefix + delim + line
    }).join('\n')
  }
  
  },{"pad-left":476}],67:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = affineHull
  
  var orient = _dereq_('robust-orientation')
  
  function linearlyIndependent(points, d) {
    var nhull = new Array(d+1)
    for(var i=0; i<points.length; ++i) {
      nhull[i] = points[i]
    }
    for(var i=0; i<=points.length; ++i) {
      for(var j=points.length; j<=d; ++j) {
        var x = new Array(d)
        for(var k=0; k<d; ++k) {
          x[k] = Math.pow(j+1-i, k)
        }
        nhull[j] = x
      }
      var o = orient.apply(void 0, nhull)
      if(o) {
        return true
      }
    }
    return false
  }
  
  function affineHull(points) {
    var n = points.length
    if(n === 0) {
      return []
    }
    if(n === 1) {
      return [0]
    }
    var d = points[0].length
    var frame = [ points[0] ]
    var index = [ 0 ]
    for(var i=1; i<n; ++i) {
      frame.push(points[i])
      if(!linearlyIndependent(frame, d)) {
        frame.pop()
        continue
      }
      index.push(i)
      if(index.length === d+1) {
        return index
      }
    }
    return index
  }
  },{"robust-orientation":520}],68:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = alphaComplex
  
  var delaunay = _dereq_('delaunay-triangulate')
  var circumradius = _dereq_('circumradius')
  
  function alphaComplex(alpha, points) {
    return delaunay(points).filter(function(cell) {
      var simplex = new Array(cell.length)
      for(var i=0; i<cell.length; ++i) {
        simplex[i] = points[cell[i]]
      }
      return circumradius(simplex) * alpha < 1
    })
  }
  },{"circumradius":119,"delaunay-triangulate":171}],69:[function(_dereq_,module,exports){
  module.exports = alphaShape
  
  var ac = _dereq_('alpha-complex')
  var bnd = _dereq_('simplicial-complex-boundary')
  
  function alphaShape(alpha, points) {
    return bnd(ac(alpha, points))
  }
  },{"alpha-complex":68,"simplicial-complex-boundary":527}],70:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = normalize;
  
  function normalize (arr, dim) {
    if (!arr || arr.length == null) throw Error('Argument should be an array')
  
    if (dim == null) dim = 1
    else dim = Math.floor(dim)
  
    var bounds = Array(dim * 2)
  
    for (var offset = 0; offset < dim; offset++) {
      var max = -Infinity, min = Infinity, i = offset, l = arr.length;
  
      for (; i < l; i+=dim) {
        if (arr[i] > max) max = arr[i];
        if (arr[i] < min) min = arr[i];
      }
  
      bounds[offset] = min
      bounds[dim + offset] = max
    }
  
    return bounds;
  }
  
  },{}],71:[function(_dereq_,module,exports){
  'use strict'
  
  var getBounds = _dereq_('array-bounds')
  
  module.exports = normalize;
  
  function normalize (arr, dim, bounds) {
    if (!arr || arr.length == null) throw Error('Argument should be an array')
  
    if (dim == null) dim = 1
    if (bounds == null) bounds = getBounds(arr, dim)
  
    for (var offset = 0; offset < dim; offset++) {
      var max = bounds[dim + offset], min = bounds[offset], i = offset, l = arr.length;
  
      if (max === Infinity && min === -Infinity) {
        for (i = offset; i < l; i+=dim) {
          arr[i] = arr[i] === max ? 1 : arr[i] === min ? 0 : .5
        }
      }
      else if (max === Infinity) {
        for (i = offset; i < l; i+=dim) {
          arr[i] = arr[i] === max ? 1 : 0
        }
      }
      else if (min === -Infinity) {
        for (i = offset; i < l; i+=dim) {
          arr[i] = arr[i] === min ? 0 : 1
        }
      }
      else {
        var range = max - min
        for (i = offset; i < l; i+=dim) {
          if (!isNaN(arr[i])) {
            arr[i] = range === 0 ? .5 : (arr[i] - min) / range
          }
        }
      }
    }
  
    return arr;
  }
  
  },{"array-bounds":70}],72:[function(_dereq_,module,exports){
  
  module.exports = function newArray(start, end) {
      var n0 = typeof start === 'number',
          n1 = typeof end === 'number'
  
      if (n0 && !n1) {
          end = start
          start = 0
      } else if (!n0 && !n1) {
          start = 0
          end = 0
      }
  
      start = start|0
      end = end|0
      var len = end-start
      if (len<0)
          throw new Error('array length must be positive')
      
      var a = new Array(len)
      for (var i=0, c=start; i<len; i++, c++)
          a[i] = c
      return a
  }
  },{}],73:[function(_dereq_,module,exports){
  (function (global){
  'use strict';
  
  var objectAssign = _dereq_('object-assign');
  
  // compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
  // original notice:
  
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   */
  function compare(a, b) {
    if (a === b) {
      return 0;
    }
  
    var x = a.length;
    var y = b.length;
  
    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
      }
    }
  
    if (x < y) {
      return -1;
    }
    if (y < x) {
      return 1;
    }
    return 0;
  }
  function isBuffer(b) {
    if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
      return global.Buffer.isBuffer(b);
    }
    return !!(b != null && b._isBuffer);
  }
  
  // based on node assert, original notice:
  // NB: The URL to the CommonJS spec is kept just for tradition.
  //     node-assert has evolved a lot since then, both in API and behavior.
  
  // http://wiki.commonjs.org/wiki/Unit_Testing/1.0
  //
  // THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
  //
  // Originally from narwhal.js (http://narwhaljs.org)
  // Copyright (c) 2009 Thomas Robinson <280north.com>
  //
  // Permission is hereby granted, free of charge, to any person obtaining a copy
  // of this software and associated documentation files (the 'Software'), to
  // deal in the Software without restriction, including without limitation the
  // rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
  // sell copies of the Software, and to permit persons to whom the Software is
  // furnished to do so, subject to the following conditions:
  //
  // The above copyright notice and this permission notice shall be included in
  // all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  // IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  // FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  // AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
  // ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
  // WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  
  var util = _dereq_('util/');
  var hasOwn = Object.prototype.hasOwnProperty;
  var pSlice = Array.prototype.slice;
  var functionsHaveNames = (function () {
    return function foo() {}.name === 'foo';
  }());
  function pToString (obj) {
    return Object.prototype.toString.call(obj);
  }
  function isView(arrbuf) {
    if (isBuffer(arrbuf)) {
      return false;
    }
    if (typeof global.ArrayBuffer !== 'function') {
      return false;
    }
    if (typeof ArrayBuffer.isView === 'function') {
      return ArrayBuffer.isView(arrbuf);
    }
    if (!arrbuf) {
      return false;
    }
    if (arrbuf instanceof DataView) {
      return true;
    }
    if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
      return true;
    }
    return false;
  }
  // 1. The assert module provides functions that throw
  // AssertionError's when particular conditions are not met. The
  // assert module must conform to the following interface.
  
  var assert = module.exports = ok;
  
  // 2. The AssertionError is defined in assert.
  // new assert.AssertionError({ message: message,
  //                             actual: actual,
  //                             expected: expected })
  
  var regex = /\s*function\s+([^\(\s]*)\s*/;
  // based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
  function getName(func) {
    if (!util.isFunction(func)) {
      return;
    }
    if (functionsHaveNames) {
      return func.name;
    }
    var str = func.toString();
    var match = str.match(regex);
    return match && match[1];
  }
  assert.AssertionError = function AssertionError(options) {
    this.name = 'AssertionError';
    this.actual = options.actual;
    this.expected = options.expected;
    this.operator = options.operator;
    if (options.message) {
      this.message = options.message;
      this.generatedMessage = false;
    } else {
      this.message = getMessage(this);
      this.generatedMessage = true;
    }
    var stackStartFunction = options.stackStartFunction || fail;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, stackStartFunction);
    } else {
      // non v8 browsers so we can have a stacktrace
      var err = new Error();
      if (err.stack) {
        var out = err.stack;
  
        // try to strip useless frames
        var fn_name = getName(stackStartFunction);
        var idx = out.indexOf('\n' + fn_name);
        if (idx >= 0) {
          // once we have located the function frame
          // we need to strip out everything before it (and its line)
          var next_line = out.indexOf('\n', idx + 1);
          out = out.substring(next_line + 1);
        }
  
        this.stack = out;
      }
    }
  };
  
  // assert.AssertionError instanceof Error
  util.inherits(assert.AssertionError, Error);
  
  function truncate(s, n) {
    if (typeof s === 'string') {
      return s.length < n ? s : s.slice(0, n);
    } else {
      return s;
    }
  }
  function inspect(something) {
    if (functionsHaveNames || !util.isFunction(something)) {
      return util.inspect(something);
    }
    var rawname = getName(something);
    var name = rawname ? ': ' + rawname : '';
    return '[Function' +  name + ']';
  }
  function getMessage(self) {
    return truncate(inspect(self.actual), 128) + ' ' +
           self.operator + ' ' +
           truncate(inspect(self.expected), 128);
  }
  
  // At present only the three keys mentioned above are used and
  // understood by the spec. Implementations or sub modules can pass
  // other keys to the AssertionError's constructor - they will be
  // ignored.
  
  // 3. All of the following functions must throw an AssertionError
  // when a corresponding condition is not met, with a message that
  // may be undefined if not provided.  All assertion methods provide
  // both the actual and expected values to the assertion error for
  // display purposes.
  
  function fail(actual, expected, message, operator, stackStartFunction) {
    throw new assert.AssertionError({
      message: message,
      actual: actual,
      expected: expected,
      operator: operator,
      stackStartFunction: stackStartFunction
    });
  }
  
  // EXTENSION! allows for well behaved errors defined elsewhere.
  assert.fail = fail;
  
  // 4. Pure assertion tests whether a value is truthy, as determined
  // by !!guard.
  // assert.ok(guard, message_opt);
  // This statement is equivalent to assert.equal(true, !!guard,
  // message_opt);. To test strictly for the value true, use
  // assert.strictEqual(true, guard, message_opt);.
  
  function ok(value, message) {
    if (!value) fail(value, true, message, '==', assert.ok);
  }
  assert.ok = ok;
  
  // 5. The equality assertion tests shallow, coercive equality with
  // ==.
  // assert.equal(actual, expected, message_opt);
  
  assert.equal = function equal(actual, expected, message) {
    if (actual != expected) fail(actual, expected, message, '==', assert.equal);
  };
  
  // 6. The non-equality assertion tests for whether two objects are not equal
  // with != assert.notEqual(actual, expected, message_opt);
  
  assert.notEqual = function notEqual(actual, expected, message) {
    if (actual == expected) {
      fail(actual, expected, message, '!=', assert.notEqual);
    }
  };
  
  // 7. The equivalence assertion tests a deep equality relation.
  // assert.deepEqual(actual, expected, message_opt);
  
  assert.deepEqual = function deepEqual(actual, expected, message) {
    if (!_deepEqual(actual, expected, false)) {
      fail(actual, expected, message, 'deepEqual', assert.deepEqual);
    }
  };
  
  assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (!_deepEqual(actual, expected, true)) {
      fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
    }
  };
  
  function _deepEqual(actual, expected, strict, memos) {
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) {
      return true;
    } else if (isBuffer(actual) && isBuffer(expected)) {
      return compare(actual, expected) === 0;
  
    // 7.2. If the expected value is a Date object, the actual value is
    // equivalent if it is also a Date object that refers to the same time.
    } else if (util.isDate(actual) && util.isDate(expected)) {
      return actual.getTime() === expected.getTime();
  
    // 7.3 If the expected value is a RegExp object, the actual value is
    // equivalent if it is also a RegExp object with the same source and
    // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
    } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
      return actual.source === expected.source &&
             actual.global === expected.global &&
             actual.multiline === expected.multiline &&
             actual.lastIndex === expected.lastIndex &&
             actual.ignoreCase === expected.ignoreCase;
  
    // 7.4. Other pairs that do not both pass typeof value == 'object',
    // equivalence is determined by ==.
    } else if ((actual === null || typeof actual !== 'object') &&
               (expected === null || typeof expected !== 'object')) {
      return strict ? actual === expected : actual == expected;
  
    // If both values are instances of typed arrays, wrap their underlying
    // ArrayBuffers in a Buffer each to increase performance
    // This optimization requires the arrays to have the same type as checked by
    // Object.prototype.toString (aka pToString). Never perform binary
    // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
    // bit patterns are not identical.
    } else if (isView(actual) && isView(expected) &&
               pToString(actual) === pToString(expected) &&
               !(actual instanceof Float32Array ||
                 actual instanceof Float64Array)) {
      return compare(new Uint8Array(actual.buffer),
                     new Uint8Array(expected.buffer)) === 0;
  
    // 7.5 For all other Object pairs, including Array objects, equivalence is
    // determined by having the same number of owned properties (as verified
    // with Object.prototype.hasOwnProperty.call), the same set of keys
    // (although not necessarily the same order), equivalent values for every
    // corresponding key, and an identical 'prototype' property. Note: this
    // accounts for both named and indexed properties on Arrays.
    } else if (isBuffer(actual) !== isBuffer(expected)) {
      return false;
    } else {
      memos = memos || {actual: [], expected: []};
  
      var actualIndex = memos.actual.indexOf(actual);
      if (actualIndex !== -1) {
        if (actualIndex === memos.expected.indexOf(expected)) {
          return true;
        }
      }
  
      memos.actual.push(actual);
      memos.expected.push(expected);
  
      return objEquiv(actual, expected, strict, memos);
    }
  }
  
  function isArguments(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
  }
  
  function objEquiv(a, b, strict, actualVisitedObjects) {
    if (a === null || a === undefined || b === null || b === undefined)
      return false;
    // if one is a primitive, the other must be same
    if (util.isPrimitive(a) || util.isPrimitive(b))
      return a === b;
    if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
      return false;
    var aIsArgs = isArguments(a);
    var bIsArgs = isArguments(b);
    if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
      return false;
    if (aIsArgs) {
      a = pSlice.call(a);
      b = pSlice.call(b);
      return _deepEqual(a, b, strict);
    }
    var ka = objectKeys(a);
    var kb = objectKeys(b);
    var key, i;
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length !== kb.length)
      return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for (i = ka.length - 1; i >= 0; i--) {
      if (ka[i] !== kb[i])
        return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for (i = ka.length - 1; i >= 0; i--) {
      key = ka[i];
      if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
        return false;
    }
    return true;
  }
  
  // 8. The non-equivalence assertion tests for any deep inequality.
  // assert.notDeepEqual(actual, expected, message_opt);
  
  assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (_deepEqual(actual, expected, false)) {
      fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
    }
  };
  
  assert.notDeepStrictEqual = notDeepStrictEqual;
  function notDeepStrictEqual(actual, expected, message) {
    if (_deepEqual(actual, expected, true)) {
      fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
    }
  }
  
  
  // 9. The strict equality assertion tests strict equality, as determined by ===.
  // assert.strictEqual(actual, expected, message_opt);
  
  assert.strictEqual = function strictEqual(actual, expected, message) {
    if (actual !== expected) {
      fail(actual, expected, message, '===', assert.strictEqual);
    }
  };
  
  // 10. The strict non-equality assertion tests for strict inequality, as
  // determined by !==.  assert.notStrictEqual(actual, expected, message_opt);
  
  assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (actual === expected) {
      fail(actual, expected, message, '!==', assert.notStrictEqual);
    }
  };
  
  function expectedException(actual, expected) {
    if (!actual || !expected) {
      return false;
    }
  
    if (Object.prototype.toString.call(expected) == '[object RegExp]') {
      return expected.test(actual);
    }
  
    try {
      if (actual instanceof expected) {
        return true;
      }
    } catch (e) {
      // Ignore.  The instanceof check doesn't work for arrow functions.
    }
  
    if (Error.isPrototypeOf(expected)) {
      return false;
    }
  
    return expected.call({}, actual) === true;
  }
  
  function _tryBlock(block) {
    var error;
    try {
      block();
    } catch (e) {
      error = e;
    }
    return error;
  }
  
  function _throws(shouldThrow, block, expected, message) {
    var actual;
  
    if (typeof block !== 'function') {
      throw new TypeError('"block" argument must be a function');
    }
  
    if (typeof expected === 'string') {
      message = expected;
      expected = null;
    }
  
    actual = _tryBlock(block);
  
    message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
              (message ? ' ' + message : '.');
  
    if (shouldThrow && !actual) {
      fail(actual, expected, 'Missing expected exception' + message);
    }
  
    var userProvidedMessage = typeof message === 'string';
    var isUnwantedException = !shouldThrow && util.isError(actual);
    var isUnexpectedException = !shouldThrow && actual && !expected;
  
    if ((isUnwantedException &&
        userProvidedMessage &&
        expectedException(actual, expected)) ||
        isUnexpectedException) {
      fail(actual, expected, 'Got unwanted exception' + message);
    }
  
    if ((shouldThrow && actual && expected &&
        !expectedException(actual, expected)) || (!shouldThrow && actual)) {
      throw actual;
    }
  }
  
  // 11. Expected to throw an error:
  // assert.throws(block, Error_opt, message_opt);
  
  assert.throws = function(block, /*optional*/error, /*optional*/message) {
    _throws(true, block, error, message);
  };
  
  // EXTENSION! This is annoying to write outside this module.
  assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
    _throws(false, block, error, message);
  };
  
  assert.ifError = function(err) { if (err) throw err; };
  
  // Expose a strict only variant of assert
  function strict(value, message) {
    if (!value) fail(value, true, message, '==', strict);
  }
  assert.strict = objectAssign(strict, assert, {
    equal: assert.strictEqual,
    deepEqual: assert.deepStrictEqual,
    notEqual: assert.notStrictEqual,
    notDeepEqual: assert.notDeepStrictEqual
  });
  assert.strict.strict = assert.strict;
  
  var objectKeys = Object.keys || function (obj) {
    var keys = [];
    for (var key in obj) {
      if (hasOwn.call(obj, key)) keys.push(key);
    }
    return keys;
  };
  
  }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{"object-assign":473,"util/":76}],74:[function(_dereq_,module,exports){
  if (typeof Object.create === 'function') {
    // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
    };
  } else {
    // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
  
  },{}],75:[function(_dereq_,module,exports){
  module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object'
      && typeof arg.copy === 'function'
      && typeof arg.fill === 'function'
      && typeof arg.readUInt8 === 'function';
  }
  },{}],76:[function(_dereq_,module,exports){
  (function (process,global){
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
  var formatRegExp = /%[sdj%]/g;
  exports.format = function(f) {
    if (!isString(f)) {
      var objects = [];
      for (var i = 0; i < arguments.length; i++) {
        objects.push(inspect(arguments[i]));
      }
      return objects.join(' ');
    }
  
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace(formatRegExp, function(x) {
      if (x === '%%') return '%';
      if (i >= len) return x;
      switch (x) {
        case '%s': return String(args[i++]);
        case '%d': return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
        default:
          return x;
      }
    });
    for (var x = args[i]; i < len; x = args[++i]) {
      if (isNull(x) || !isObject(x)) {
        str += ' ' + x;
      } else {
        str += ' ' + inspect(x);
      }
    }
    return str;
  };
  
  
  // Mark that a method should not be used.
  // Returns a modified function which warns once by default.
  // If --no-deprecation is set, then it is a no-op.
  exports.deprecate = function(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if (isUndefined(global.process)) {
      return function() {
        return exports.deprecate(fn, msg).apply(this, arguments);
      };
    }
  
    if (process.noDeprecation === true) {
      return fn;
    }
  
    var warned = false;
    function deprecated() {
      if (!warned) {
        if (process.throwDeprecation) {
          throw new Error(msg);
        } else if (process.traceDeprecation) {
          console.trace(msg);
        } else {
          console.error(msg);
        }
        warned = true;
      }
      return fn.apply(this, arguments);
    }
  
    return deprecated;
  };
  
  
  var debugs = {};
  var debugEnviron;
  exports.debuglog = function(set) {
    if (isUndefined(debugEnviron))
      debugEnviron = process.env.NODE_DEBUG || '';
    set = set.toUpperCase();
    if (!debugs[set]) {
      if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
        var pid = process.pid;
        debugs[set] = function() {
          var msg = exports.format.apply(exports, arguments);
          console.error('%s %d: %s', set, pid, msg);
        };
      } else {
        debugs[set] = function() {};
      }
    }
    return debugs[set];
  };
  
  
  /**
   * Echos the value of a value. Trys to print the value out
   * in the best way possible given the different types.
   *
   * @param {Object} obj The object to print out.
   * @param {Object} opts Optional options object that alters the output.
   */
  /* legacy: obj, showHidden, depth, colors*/
  function inspect(obj, opts) {
    // default options
    var ctx = {
      seen: [],
      stylize: stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if (isBoolean(opts)) {
      // legacy...
      ctx.showHidden = opts;
    } else if (opts) {
      // got an "options" object
      exports._extend(ctx, opts);
    }
    // set default options
    if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if (isUndefined(ctx.depth)) ctx.depth = 2;
    if (isUndefined(ctx.colors)) ctx.colors = false;
    if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = stylizeWithColor;
    return formatValue(ctx, obj, ctx.depth);
  }
  exports.inspect = inspect;
  
  
  // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
  inspect.colors = {
    'bold' : [1, 22],
    'italic' : [3, 23],
    'underline' : [4, 24],
    'inverse' : [7, 27],
    'white' : [37, 39],
    'grey' : [90, 39],
    'black' : [30, 39],
    'blue' : [34, 39],
    'cyan' : [36, 39],
    'green' : [32, 39],
    'magenta' : [35, 39],
    'red' : [31, 39],
    'yellow' : [33, 39]
  };
  
  // Don't use 'blue' not visible on cmd.exe
  inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
  };
  
  
  function stylizeWithColor(str, styleType) {
    var style = inspect.styles[styleType];
  
    if (style) {
      return '\u001b[' + inspect.colors[style][0] + 'm' + str +
             '\u001b[' + inspect.colors[style][1] + 'm';
    } else {
      return str;
    }
  }
  
  
  function stylizeNoColor(str, styleType) {
    return str;
  }
  
  
  function arrayToHash(array) {
    var hash = {};
  
    array.forEach(function(val, idx) {
      hash[val] = true;
    });
  
    return hash;
  }
  
  
  function formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect &&
        value &&
        isFunction(value.inspect) &&
        // Filter out the util module, it's inspect function is special
        value.inspect !== exports.inspect &&
        // Also filter out any prototype objects using the circular check.
        !(value.constructor && value.constructor.prototype === value)) {
      var ret = value.inspect(recurseTimes, ctx);
      if (!isString(ret)) {
        ret = formatValue(ctx, ret, recurseTimes);
      }
      return ret;
    }
  
    // Primitive types cannot have properties
    var primitive = formatPrimitive(ctx, value);
    if (primitive) {
      return primitive;
    }
  
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = arrayToHash(keys);
  
    if (ctx.showHidden) {
      keys = Object.getOwnPropertyNames(value);
    }
  
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if (isError(value)
        && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
      return formatError(value);
    }
  
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
      if (isFunction(value)) {
        var name = value.name ? ': ' + value.name : '';
        return ctx.stylize('[Function' + name + ']', 'special');
      }
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      }
      if (isDate(value)) {
        return ctx.stylize(Date.prototype.toString.call(value), 'date');
      }
      if (isError(value)) {
        return formatError(value);
      }
    }
  
    var base = '', array = false, braces = ['{', '}'];
  
    // Make Array say that they are Array
    if (isArray(value)) {
      array = true;
      braces = ['[', ']'];
    }
  
    // Make functions say that they are functions
    if (isFunction(value)) {
      var n = value.name ? ': ' + value.name : '';
      base = ' [Function' + n + ']';
    }
  
    // Make RegExps say that they are RegExps
    if (isRegExp(value)) {
      base = ' ' + RegExp.prototype.toString.call(value);
    }
  
    // Make dates with properties first say the date
    if (isDate(value)) {
      base = ' ' + Date.prototype.toUTCString.call(value);
    }
  
    // Make error with message first say the error
    if (isError(value)) {
      base = ' ' + formatError(value);
    }
  
    if (keys.length === 0 && (!array || value.length == 0)) {
      return braces[0] + base + braces[1];
    }
  
    if (recurseTimes < 0) {
      if (isRegExp(value)) {
        return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
      } else {
        return ctx.stylize('[Object]', 'special');
      }
    }
  
    ctx.seen.push(value);
  
    var output;
    if (array) {
      output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    } else {
      output = keys.map(function(key) {
        return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
      });
    }
  
    ctx.seen.pop();
  
    return reduceToSingleString(output, base, braces);
  }
  
  
  function formatPrimitive(ctx, value) {
    if (isUndefined(value))
      return ctx.stylize('undefined', 'undefined');
    if (isString(value)) {
      var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                               .replace(/'/g, "\\'")
                                               .replace(/\\"/g, '"') + '\'';
      return ctx.stylize(simple, 'string');
    }
    if (isNumber(value))
      return ctx.stylize('' + value, 'number');
    if (isBoolean(value))
      return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if (isNull(value))
      return ctx.stylize('null', 'null');
  }
  
  
  function formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
  }
  
  
  function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for (var i = 0, l = value.length; i < l; ++i) {
      if (hasOwnProperty(value, String(i))) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
            String(i), true));
      } else {
        output.push('');
      }
    }
    keys.forEach(function(key) {
      if (!key.match(/^\d+$/)) {
        output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
            key, true));
      }
    });
    return output;
  }
  
  
  function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
    if (desc.get) {
      if (desc.set) {
        str = ctx.stylize('[Getter/Setter]', 'special');
      } else {
        str = ctx.stylize('[Getter]', 'special');
      }
    } else {
      if (desc.set) {
        str = ctx.stylize('[Setter]', 'special');
      }
    }
    if (!hasOwnProperty(visibleKeys, key)) {
      name = '[' + key + ']';
    }
    if (!str) {
      if (ctx.seen.indexOf(desc.value) < 0) {
        if (isNull(recurseTimes)) {
          str = formatValue(ctx, desc.value, null);
        } else {
          str = formatValue(ctx, desc.value, recurseTimes - 1);
        }
        if (str.indexOf('\n') > -1) {
          if (array) {
            str = str.split('\n').map(function(line) {
              return '  ' + line;
            }).join('\n').substr(2);
          } else {
            str = '\n' + str.split('\n').map(function(line) {
              return '   ' + line;
            }).join('\n');
          }
        }
      } else {
        str = ctx.stylize('[Circular]', 'special');
      }
    }
    if (isUndefined(name)) {
      if (array && key.match(/^\d+$/)) {
        return str;
      }
      name = JSON.stringify('' + key);
      if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
        name = name.substr(1, name.length - 2);
        name = ctx.stylize(name, 'name');
      } else {
        name = name.replace(/'/g, "\\'")
                   .replace(/\\"/g, '"')
                   .replace(/(^"|"$)/g, "'");
        name = ctx.stylize(name, 'string');
      }
    }
  
    return name + ': ' + str;
  }
  
  
  function reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
      numLinesEst++;
      if (cur.indexOf('\n') >= 0) numLinesEst++;
      return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
  
    if (length > 60) {
      return braces[0] +
             (base === '' ? '' : base + '\n ') +
             ' ' +
             output.join(',\n  ') +
             ' ' +
             braces[1];
    }
  
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
  }
  
  
  // NOTE: These type checking functions intentionally don't use `instanceof`
  // because it is fragile and can be easily faked with `Object.create()`.
  function isArray(ar) {
    return Array.isArray(ar);
  }
  exports.isArray = isArray;
  
  function isBoolean(arg) {
    return typeof arg === 'boolean';
  }
  exports.isBoolean = isBoolean;
  
  function isNull(arg) {
    return arg === null;
  }
  exports.isNull = isNull;
  
  function isNullOrUndefined(arg) {
    return arg == null;
  }
  exports.isNullOrUndefined = isNullOrUndefined;
  
  function isNumber(arg) {
    return typeof arg === 'number';
  }
  exports.isNumber = isNumber;
  
  function isString(arg) {
    return typeof arg === 'string';
  }
  exports.isString = isString;
  
  function isSymbol(arg) {
    return typeof arg === 'symbol';
  }
  exports.isSymbol = isSymbol;
  
  function isUndefined(arg) {
    return arg === void 0;
  }
  exports.isUndefined = isUndefined;
  
  function isRegExp(re) {
    return isObject(re) && objectToString(re) === '[object RegExp]';
  }
  exports.isRegExp = isRegExp;
  
  function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
  }
  exports.isObject = isObject;
  
  function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
  }
  exports.isDate = isDate;
  
  function isError(e) {
    return isObject(e) &&
        (objectToString(e) === '[object Error]' || e instanceof Error);
  }
  exports.isError = isError;
  
  function isFunction(arg) {
    return typeof arg === 'function';
  }
  exports.isFunction = isFunction;
  
  function isPrimitive(arg) {
    return arg === null ||
           typeof arg === 'boolean' ||
           typeof arg === 'number' ||
           typeof arg === 'string' ||
           typeof arg === 'symbol' ||  // ES6 symbol
           typeof arg === 'undefined';
  }
  exports.isPrimitive = isPrimitive;
  
  exports.isBuffer = _dereq_('./support/isBuffer');
  
  function objectToString(o) {
    return Object.prototype.toString.call(o);
  }
  
  
  function pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
  }
  
  
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
                'Oct', 'Nov', 'Dec'];
  
  // 26 Feb 16:19:34
  function timestamp() {
    var d = new Date();
    var time = [pad(d.getHours()),
                pad(d.getMinutes()),
                pad(d.getSeconds())].join(':');
    return [d.getDate(), months[d.getMonth()], time].join(' ');
  }
  
  
  // log is just a thin wrapper to console.log that prepends a timestamp
  exports.log = function() {
    console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
  };
  
  
  /**
   * Inherit the prototype methods from one constructor into another.
   *
   * The Function.prototype.inherits from lang.js rewritten as a standalone
   * function (not on Function.prototype). NOTE: If this file is to be loaded
   * during bootstrapping this function needs to be rewritten using some native
   * functions as prototype setup using normal JavaScript does not work as
   * expected during bootstrapping (see mirror.js in r114903).
   *
   * @param {function} ctor Constructor function which needs to inherit the
   *     prototype.
   * @param {function} superCtor Constructor function to inherit prototype from.
   */
  exports.inherits = _dereq_('inherits');
  
  exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !isObject(add)) return origin;
  
    var keys = Object.keys(add);
    var i = keys.length;
    while (i--) {
      origin[keys[i]] = add[keys[i]];
    }
    return origin;
  };
  
  function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }
  
  }).call(this,_dereq_('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{"./support/isBuffer":75,"_process":500,"inherits":74}],77:[function(_dereq_,module,exports){
  module.exports = function _atob(str) {
    return atob(str)
  }
  
  },{}],78:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = barycentric
  
  var solve = _dereq_('robust-linear-solve')
  
  function reduce(x) {
    var r = 0
    for(var i=0; i<x.length; ++i) {
      r += x[i]
    }
    return r
  }
  
  function barycentric(simplex, point) {
    var d = point.length
    var A = new Array(d+1)
    for(var i=0; i<d; ++i) {
      var row = new Array(d+1)
      for(var j=0; j<=d; ++j) {
        row[j] = simplex[j][i]
      }
      A[i] = row
    }
    A[d] = new Array(d+1)
    for(var i=0; i<=d; ++i) {
      A[d][i] = 1
    }
  
    var b = new Array(d+1)
    for(var i=0; i<d; ++i) {
      b[i] = point[i]
    }
    b[d] = 1.0
  
    var x = solve(A, b)
    var w = reduce(x[d+1])
    
    if(w === 0) {
      w = 1.0
    }
    var y = new Array(d+1)
    for(var i=0; i<=d; ++i) {
      y[i] = reduce(x[i]) / w
    }
    return y
  }
  },{"robust-linear-solve":519}],79:[function(_dereq_,module,exports){
  'use strict'
  
  exports.byteLength = byteLength
  exports.toByteArray = toByteArray
  exports.fromByteArray = fromByteArray
  
  var lookup = []
  var revLookup = []
  var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
  
  var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  for (var i = 0, len = code.length; i < len; ++i) {
    lookup[i] = code[i]
    revLookup[code.charCodeAt(i)] = i
  }
  
  // Support decoding URL-safe base64 strings, as Node.js does.
  // See: https://en.wikipedia.org/wiki/Base64#URL_applications
  revLookup['-'.charCodeAt(0)] = 62
  revLookup['_'.charCodeAt(0)] = 63
  
  function getLens (b64) {
    var len = b64.length
  
    if (len % 4 > 0) {
      throw new Error('Invalid string. Length must be a multiple of 4')
    }
  
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=')
    if (validLen === -1) validLen = len
  
    var placeHoldersLen = validLen === len
      ? 0
      : 4 - (validLen % 4)
  
    return [validLen, placeHoldersLen]
  }
  
  // base64 is 4/3 + up to two characters of the original data
  function byteLength (b64) {
    var lens = getLens(b64)
    var validLen = lens[0]
    var placeHoldersLen = lens[1]
    return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
  }
  
  function _byteLength (b64, validLen, placeHoldersLen) {
    return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
  }
  
  function toByteArray (b64) {
    var tmp
    var lens = getLens(b64)
    var validLen = lens[0]
    var placeHoldersLen = lens[1]
  
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
  
    var curByte = 0
  
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0
      ? validLen - 4
      : validLen
  
    var i
    for (i = 0; i < len; i += 4) {
      tmp =
        (revLookup[b64.charCodeAt(i)] << 18) |
        (revLookup[b64.charCodeAt(i + 1)] << 12) |
        (revLookup[b64.charCodeAt(i + 2)] << 6) |
        revLookup[b64.charCodeAt(i + 3)]
      arr[curByte++] = (tmp >> 16) & 0xFF
      arr[curByte++] = (tmp >> 8) & 0xFF
      arr[curByte++] = tmp & 0xFF
    }
  
    if (placeHoldersLen === 2) {
      tmp =
        (revLookup[b64.charCodeAt(i)] << 2) |
        (revLookup[b64.charCodeAt(i + 1)] >> 4)
      arr[curByte++] = tmp & 0xFF
    }
  
    if (placeHoldersLen === 1) {
      tmp =
        (revLookup[b64.charCodeAt(i)] << 10) |
        (revLookup[b64.charCodeAt(i + 1)] << 4) |
        (revLookup[b64.charCodeAt(i + 2)] >> 2)
      arr[curByte++] = (tmp >> 8) & 0xFF
      arr[curByte++] = tmp & 0xFF
    }
  
    return arr
  }
  
  function tripletToBase64 (num) {
    return lookup[num >> 18 & 0x3F] +
      lookup[num >> 12 & 0x3F] +
      lookup[num >> 6 & 0x3F] +
      lookup[num & 0x3F]
  }
  
  function encodeChunk (uint8, start, end) {
    var tmp
    var output = []
    for (var i = start; i < end; i += 3) {
      tmp =
        ((uint8[i] << 16) & 0xFF0000) +
        ((uint8[i + 1] << 8) & 0xFF00) +
        (uint8[i + 2] & 0xFF)
      output.push(tripletToBase64(tmp))
    }
    return output.join('')
  }
  
  function fromByteArray (uint8) {
    var tmp
    var len = uint8.length
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    var parts = []
    var maxChunkLength = 16383 // must be multiple of 3
  
    // go through the array every three bytes, we'll deal with trailing stuff later
    for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
      parts.push(encodeChunk(
        uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
      ))
    }
  
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
      tmp = uint8[len - 1]
      parts.push(
        lookup[tmp >> 2] +
        lookup[(tmp << 4) & 0x3F] +
        '=='
      )
    } else if (extraBytes === 2) {
      tmp = (uint8[len - 2] << 8) + uint8[len - 1]
      parts.push(
        lookup[tmp >> 10] +
        lookup[(tmp >> 4) & 0x3F] +
        lookup[(tmp << 2) & 0x3F] +
        '='
      )
    }
  
    return parts.join('')
  }
  
  },{}],80:[function(_dereq_,module,exports){
  'use strict'
  
  var rationalize = _dereq_('./lib/rationalize')
  
  module.exports = add
  
  function add(a, b) {
    return rationalize(
      a[0].mul(b[1]).add(b[0].mul(a[1])),
      a[1].mul(b[1]))
  }
  
  },{"./lib/rationalize":90}],81:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = cmp
  
  function cmp(a, b) {
      return a[0].mul(b[1]).cmp(b[0].mul(a[1]))
  }
  
  },{}],82:[function(_dereq_,module,exports){
  'use strict'
  
  var rationalize = _dereq_('./lib/rationalize')
  
  module.exports = div
  
  function div(a, b) {
    return rationalize(a[0].mul(b[1]), a[1].mul(b[0]))
  }
  
  },{"./lib/rationalize":90}],83:[function(_dereq_,module,exports){
  'use strict'
  
  var isRat = _dereq_('./is-rat')
  var isBN = _dereq_('./lib/is-bn')
  var num2bn = _dereq_('./lib/num-to-bn')
  var str2bn = _dereq_('./lib/str-to-bn')
  var rationalize = _dereq_('./lib/rationalize')
  var div = _dereq_('./div')
  
  module.exports = makeRational
  
  function makeRational(numer, denom) {
    if(isRat(numer)) {
      if(denom) {
        return div(numer, makeRational(denom))
      }
      return [numer[0].clone(), numer[1].clone()]
    }
    var shift = 0
    var a, b
    if(isBN(numer)) {
      a = numer.clone()
    } else if(typeof numer === 'string') {
      a = str2bn(numer)
    } else if(numer === 0) {
      return [num2bn(0), num2bn(1)]
    } else if(numer === Math.floor(numer)) {
      a = num2bn(numer)
    } else {
      while(numer !== Math.floor(numer)) {
        numer = numer * Math.pow(2, 256)
        shift -= 256
      }
      a = num2bn(numer)
    }
    if(isRat(denom)) {
      a.mul(denom[1])
      b = denom[0].clone()
    } else if(isBN(denom)) {
      b = denom.clone()
    } else if(typeof denom === 'string') {
      b = str2bn(denom)
    } else if(!denom) {
      b = num2bn(1)
    } else if(denom === Math.floor(denom)) {
      b = num2bn(denom)
    } else {
      while(denom !== Math.floor(denom)) {
        denom = denom * Math.pow(2, 256)
        shift += 256
      }
      b = num2bn(denom)
    }
    if(shift > 0) {
      a = a.ushln(shift)
    } else if(shift < 0) {
      b = b.ushln(-shift)
    }
    return rationalize(a, b)
  }
  
  },{"./div":82,"./is-rat":84,"./lib/is-bn":88,"./lib/num-to-bn":89,"./lib/rationalize":90,"./lib/str-to-bn":91}],84:[function(_dereq_,module,exports){
  'use strict'
  
  var isBN = _dereq_('./lib/is-bn')
  
  module.exports = isRat
  
  function isRat(x) {
    return Array.isArray(x) && x.length === 2 && isBN(x[0]) && isBN(x[1])
  }
  
  },{"./lib/is-bn":88}],85:[function(_dereq_,module,exports){
  'use strict'
  
  var BN = _dereq_('bn.js')
  
  module.exports = sign
  
  function sign (x) {
    return x.cmp(new BN(0))
  }
  
  },{"bn.js":99}],86:[function(_dereq_,module,exports){
  'use strict'
  
  var sign = _dereq_('./bn-sign')
  
  module.exports = bn2num
  
  //TODO: Make this better
  function bn2num(b) {
    var l = b.length
    var words = b.words
    var out = 0
    if (l === 1) {
      out = words[0]
    } else if (l === 2) {
      out = words[0] + (words[1] * 0x4000000)
    } else {
      for (var i = 0; i < l; i++) {
        var w = words[i]
        out += w * Math.pow(0x4000000, i)
      }
    }
    return sign(b) * out
  }
  
  },{"./bn-sign":85}],87:[function(_dereq_,module,exports){
  'use strict'
  
  var db = _dereq_('double-bits')
  var ctz = _dereq_('bit-twiddle').countTrailingZeros
  
  module.exports = ctzNumber
  
  //Counts the number of trailing zeros
  function ctzNumber(x) {
    var l = ctz(db.lo(x))
    if(l < 32) {
      return l
    }
    var h = ctz(db.hi(x))
    if(h > 20) {
      return 52
    }
    return h + 32
  }
  
  },{"bit-twiddle":97,"double-bits":173}],88:[function(_dereq_,module,exports){
  'use strict'
  
  var BN = _dereq_('bn.js')
  
  module.exports = isBN
  
  //Test if x is a bignumber
  //FIXME: obviously this is the wrong way to do it
  function isBN(x) {
    return x && typeof x === 'object' && Boolean(x.words)
  }
  
  },{"bn.js":99}],89:[function(_dereq_,module,exports){
  'use strict'
  
  var BN = _dereq_('bn.js')
  var db = _dereq_('double-bits')
  
  module.exports = num2bn
  
  function num2bn(x) {
    var e = db.exponent(x)
    if(e < 52) {
      return new BN(x)
    } else {
      return (new BN(x * Math.pow(2, 52-e))).ushln(e-52)
    }
  }
  
  },{"bn.js":99,"double-bits":173}],90:[function(_dereq_,module,exports){
  'use strict'
  
  var num2bn = _dereq_('./num-to-bn')
  var sign = _dereq_('./bn-sign')
  
  module.exports = rationalize
  
  function rationalize(numer, denom) {
    var snumer = sign(numer)
    var sdenom = sign(denom)
    if(snumer === 0) {
      return [num2bn(0), num2bn(1)]
    }
    if(sdenom === 0) {
      return [num2bn(0), num2bn(0)]
    }
    if(sdenom < 0) {
      numer = numer.neg()
      denom = denom.neg()
    }
    var d = numer.gcd(denom)
    if(d.cmpn(1)) {
      return [ numer.div(d), denom.div(d) ]
    }
    return [ numer, denom ]
  }
  
  },{"./bn-sign":85,"./num-to-bn":89}],91:[function(_dereq_,module,exports){
  'use strict'
  
  var BN = _dereq_('bn.js')
  
  module.exports = str2BN
  
  function str2BN(x) {
    return new BN(x)
  }
  
  },{"bn.js":99}],92:[function(_dereq_,module,exports){
  'use strict'
  
  var rationalize = _dereq_('./lib/rationalize')
  
  module.exports = mul
  
  function mul(a, b) {
    return rationalize(a[0].mul(b[0]), a[1].mul(b[1]))
  }
  
  },{"./lib/rationalize":90}],93:[function(_dereq_,module,exports){
  'use strict'
  
  var bnsign = _dereq_('./lib/bn-sign')
  
  module.exports = sign
  
  function sign(x) {
    return bnsign(x[0]) * bnsign(x[1])
  }
  
  },{"./lib/bn-sign":85}],94:[function(_dereq_,module,exports){
  'use strict'
  
  var rationalize = _dereq_('./lib/rationalize')
  
  module.exports = sub
  
  function sub(a, b) {
    return rationalize(a[0].mul(b[1]).sub(a[1].mul(b[0])), a[1].mul(b[1]))
  }
  
  },{"./lib/rationalize":90}],95:[function(_dereq_,module,exports){
  'use strict'
  
  var bn2num = _dereq_('./lib/bn-to-num')
  var ctz = _dereq_('./lib/ctz')
  
  module.exports = roundRat
  
  // Round a rational to the closest float
  function roundRat (f) {
    var a = f[0]
    var b = f[1]
    if (a.cmpn(0) === 0) {
      return 0
    }
    var h = a.abs().divmod(b.abs())
    var iv = h.div
    var x = bn2num(iv)
    var ir = h.mod
    var sgn = (a.negative !== b.negative) ? -1 : 1
    if (ir.cmpn(0) === 0) {
      return sgn * x
    }
    if (x) {
      var s = ctz(x) + 4
      var y = bn2num(ir.ushln(s).divRound(b))
      return sgn * (x + y * Math.pow(2, -s))
    } else {
      var ybits = b.bitLength() - ir.bitLength() + 53
      var y = bn2num(ir.ushln(ybits).divRound(b))
      if (ybits < 1023) {
        return sgn * y * Math.pow(2, -ybits)
      }
      y *= Math.pow(2, -1023)
      return sgn * y * Math.pow(2, 1023 - ybits)
    }
  }
  
  },{"./lib/bn-to-num":86,"./lib/ctz":87}],96:[function(_dereq_,module,exports){
  "use strict"
  
  function compileSearch(funcName, predicate, reversed, extraArgs, earlyOut) {
    var code = [
      "function ", funcName, "(a,l,h,", extraArgs.join(","),  "){",
      earlyOut ? "" : "var i=", (reversed ? "l-1" : "h+1"),
      ";while(l<=h){var m=(l+h)>>>1,x=a[m]"]
    if(earlyOut) {
      if(predicate.indexOf("c") < 0) {
        code.push(";if(x===y){return m}else if(x<=y){")
      } else {
        code.push(";var p=c(x,y);if(p===0){return m}else if(p<=0){")
      }
    } else {
      code.push(";if(", predicate, "){i=m;")
    }
    if(reversed) {
      code.push("l=m+1}else{h=m-1}")
    } else {
      code.push("h=m-1}else{l=m+1}")
    }
    code.push("}")
    if(earlyOut) {
      code.push("return -1};")
    } else {
      code.push("return i};")
    }
    return code.join("")
  }
  
  function compileBoundsSearch(predicate, reversed, suffix, earlyOut) {
    var result = new Function([
    compileSearch("A", "x" + predicate + "y", reversed, ["y"], earlyOut),
    compileSearch("P", "c(x,y)" + predicate + "0", reversed, ["y", "c"], earlyOut),
  "function dispatchBsearch", suffix, "(a,y,c,l,h){\
  if(typeof(c)==='function'){\
  return P(a,(l===void 0)?0:l|0,(h===void 0)?a.length-1:h|0,y,c)\
  }else{\
  return A(a,(c===void 0)?0:c|0,(l===void 0)?a.length-1:l|0,y)\
  }}\
  return dispatchBsearch", suffix].join(""))
    return result()
  }
  
  module.exports = {
    ge: compileBoundsSearch(">=", false,  "GE"),
    gt: compileBoundsSearch(">",  false,  "GT"),
    lt: compileBoundsSearch("<",  true,   "LT"),
    le: compileBoundsSearch("<=", true,   "LE"),
    eq: compileBoundsSearch("-",  true,   "EQ", true)
  }
  
  },{}],97:[function(_dereq_,module,exports){
  /**
   * Bit twiddling hacks for JavaScript.
   *
   * Author: Mikola Lysenko
   *
   * Ported from Stanford bit twiddling hack library:
   *    http://graphics.stanford.edu/~seander/bithacks.html
   */
  
  "use strict"; "use restrict";
  
  //Number of bits in an integer
  var INT_BITS = 32;
  
  //Constants
  exports.INT_BITS  = INT_BITS;
  exports.INT_MAX   =  0x7fffffff;
  exports.INT_MIN   = -1<<(INT_BITS-1);
  
  //Returns -1, 0, +1 depending on sign of x
  exports.sign = function(v) {
    return (v > 0) - (v < 0);
  }
  
  //Computes absolute value of integer
  exports.abs = function(v) {
    var mask = v >> (INT_BITS-1);
    return (v ^ mask) - mask;
  }
  
  //Computes minimum of integers x and y
  exports.min = function(x, y) {
    return y ^ ((x ^ y) & -(x < y));
  }
  
  //Computes maximum of integers x and y
  exports.max = function(x, y) {
    return x ^ ((x ^ y) & -(x < y));
  }
  
  //Checks if a number is a power of two
  exports.isPow2 = function(v) {
    return !(v & (v-1)) && (!!v);
  }
  
  //Computes log base 2 of v
  exports.log2 = function(v) {
    var r, shift;
    r =     (v > 0xFFFF) << 4; v >>>= r;
    shift = (v > 0xFF  ) << 3; v >>>= shift; r |= shift;
    shift = (v > 0xF   ) << 2; v >>>= shift; r |= shift;
    shift = (v > 0x3   ) << 1; v >>>= shift; r |= shift;
    return r | (v >> 1);
  }
  
  //Computes log base 10 of v
  exports.log10 = function(v) {
    return  (v >= 1000000000) ? 9 : (v >= 100000000) ? 8 : (v >= 10000000) ? 7 :
            (v >= 1000000) ? 6 : (v >= 100000) ? 5 : (v >= 10000) ? 4 :
            (v >= 1000) ? 3 : (v >= 100) ? 2 : (v >= 10) ? 1 : 0;
  }
  
  //Counts number of bits
  exports.popCount = function(v) {
    v = v - ((v >>> 1) & 0x55555555);
    v = (v & 0x33333333) + ((v >>> 2) & 0x33333333);
    return ((v + (v >>> 4) & 0xF0F0F0F) * 0x1010101) >>> 24;
  }
  
  //Counts number of trailing zeros
  function countTrailingZeros(v) {
    var c = 32;
    v &= -v;
    if (v) c--;
    if (v & 0x0000FFFF) c -= 16;
    if (v & 0x00FF00FF) c -= 8;
    if (v & 0x0F0F0F0F) c -= 4;
    if (v & 0x33333333) c -= 2;
    if (v & 0x55555555) c -= 1;
    return c;
  }
  exports.countTrailingZeros = countTrailingZeros;
  
  //Rounds to next power of 2
  exports.nextPow2 = function(v) {
    v += v === 0;
    --v;
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v + 1;
  }
  
  //Rounds down to previous power of 2
  exports.prevPow2 = function(v) {
    v |= v >>> 1;
    v |= v >>> 2;
    v |= v >>> 4;
    v |= v >>> 8;
    v |= v >>> 16;
    return v - (v>>>1);
  }
  
  //Computes parity of word
  exports.parity = function(v) {
    v ^= v >>> 16;
    v ^= v >>> 8;
    v ^= v >>> 4;
    v &= 0xf;
    return (0x6996 >>> v) & 1;
  }
  
  var REVERSE_TABLE = new Array(256);
  
  (function(tab) {
    for(var i=0; i<256; ++i) {
      var v = i, r = i, s = 7;
      for (v >>>= 1; v; v >>>= 1) {
        r <<= 1;
        r |= v & 1;
        --s;
      }
      tab[i] = (r << s) & 0xff;
    }
  })(REVERSE_TABLE);
  
  //Reverse bits in a 32 bit word
  exports.reverse = function(v) {
    return  (REVERSE_TABLE[ v         & 0xff] << 24) |
            (REVERSE_TABLE[(v >>> 8)  & 0xff] << 16) |
            (REVERSE_TABLE[(v >>> 16) & 0xff] << 8)  |
             REVERSE_TABLE[(v >>> 24) & 0xff];
  }
  
  //Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
  exports.interleave2 = function(x, y) {
    x &= 0xFFFF;
    x = (x | (x << 8)) & 0x00FF00FF;
    x = (x | (x << 4)) & 0x0F0F0F0F;
    x = (x | (x << 2)) & 0x33333333;
    x = (x | (x << 1)) & 0x55555555;
  
    y &= 0xFFFF;
    y = (y | (y << 8)) & 0x00FF00FF;
    y = (y | (y << 4)) & 0x0F0F0F0F;
    y = (y | (y << 2)) & 0x33333333;
    y = (y | (y << 1)) & 0x55555555;
  
    return x | (y << 1);
  }
  
  //Extracts the nth interleaved component
  exports.deinterleave2 = function(v, n) {
    v = (v >>> n) & 0x55555555;
    v = (v | (v >>> 1))  & 0x33333333;
    v = (v | (v >>> 2))  & 0x0F0F0F0F;
    v = (v | (v >>> 4))  & 0x00FF00FF;
    v = (v | (v >>> 16)) & 0x000FFFF;
    return (v << 16) >> 16;
  }
  
  
  //Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
  exports.interleave3 = function(x, y, z) {
    x &= 0x3FF;
    x  = (x | (x<<16)) & 4278190335;
    x  = (x | (x<<8))  & 251719695;
    x  = (x | (x<<4))  & 3272356035;
    x  = (x | (x<<2))  & 1227133513;
  
    y &= 0x3FF;
    y  = (y | (y<<16)) & 4278190335;
    y  = (y | (y<<8))  & 251719695;
    y  = (y | (y<<4))  & 3272356035;
    y  = (y | (y<<2))  & 1227133513;
    x |= (y << 1);
    
    z &= 0x3FF;
    z  = (z | (z<<16)) & 4278190335;
    z  = (z | (z<<8))  & 251719695;
    z  = (z | (z<<4))  & 3272356035;
    z  = (z | (z<<2))  & 1227133513;
    
    return x | (z << 2);
  }
  
  //Extracts nth interleaved component of a 3-tuple
  exports.deinterleave3 = function(v, n) {
    v = (v >>> n)       & 1227133513;
    v = (v | (v>>>2))   & 3272356035;
    v = (v | (v>>>4))   & 251719695;
    v = (v | (v>>>8))   & 4278190335;
    v = (v | (v>>>16))  & 0x3FF;
    return (v<<22)>>22;
  }
  
  //Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
  exports.nextCombination = function(v) {
    var t = v | (v - 1);
    return (t + 1) | (((~t & -~t) - 1) >>> (countTrailingZeros(v) + 1));
  }
  
  
  },{}],98:[function(_dereq_,module,exports){
  'use strict'
  
  var clamp = _dereq_('clamp')
  
  module.exports = calcSDF
  
  var INF = 1e20;
  
  function calcSDF(src, options) {
      if (!options) options = {}
  
      var cutoff = options.cutoff == null ? 0.25 : options.cutoff
      var radius = options.radius == null ? 8 : options.radius
      var channel = options.channel || 0
      var w, h, size, data, intData, stride, ctx, canvas, imgData, i, l
  
      // handle image container
      if (ArrayBuffer.isView(src) || Array.isArray(src)) {
          if (!options.width || !options.height) throw Error('For raw data width and height should be provided by options')
          w = options.width, h = options.height
          data = src
  
          if (!options.stride) stride = Math.floor(src.length / w / h)
          else stride = options.stride
      }
      else {
          if (window.HTMLCanvasElement && src instanceof window.HTMLCanvasElement) {
              canvas = src
              ctx = canvas.getContext('2d')
              w = canvas.width, h = canvas.height
              imgData = ctx.getImageData(0, 0, w, h)
              data = imgData.data
              stride = 4
          }
          else if (window.CanvasRenderingContext2D && src instanceof window.CanvasRenderingContext2D) {
              canvas = src.canvas
              ctx = src
              w = canvas.width, h = canvas.height
              imgData = ctx.getImageData(0, 0, w, h)
              data = imgData.data
              stride = 4
          }
          else if (window.ImageData && src instanceof window.ImageData) {
              imgData = src
              w = src.width, h = src.height
              data = imgData.data
              stride = 4
          }
      }
  
      size = Math.max(w, h)
  
      //convert int data to floats
      if ((window.Uint8ClampedArray && data instanceof window.Uint8ClampedArray) || (window.Uint8Array && data instanceof window.Uint8Array)) {
          intData = data
          data = Array(w*h)
  
          for (i = 0, l = intData.length; i < l; i++) {
              data[i] = intData[i*stride + channel] / 255
          }
      }
      else {
          if (stride !== 1) throw Error('Raw data can have only 1 value per pixel')
      }
  
      // temporary arrays for the distance transform
      var gridOuter = Array(w * h)
      var gridInner = Array(w * h)
      var f = Array(size)
      var d = Array(size)
      var z = Array(size + 1)
      var v = Array(size)
  
      for (i = 0, l = w * h; i < l; i++) {
          var a = data[i]
          gridOuter[i] = a === 1 ? 0 : a === 0 ? INF : Math.pow(Math.max(0, 0.5 - a), 2)
          gridInner[i] = a === 1 ? INF : a === 0 ? 0 : Math.pow(Math.max(0, a - 0.5), 2)
      }
  
      edt(gridOuter, w, h, f, d, v, z)
      edt(gridInner, w, h, f, d, v, z)
  
      var dist = window.Float32Array ? new Float32Array(w * h) : new Array(w * h)
  
      for (i = 0, l = w*h; i < l; i++) {
          dist[i] = clamp(1 - ( (gridOuter[i] - gridInner[i]) / radius + cutoff), 0, 1)
      }
  
      return dist
  }
  
  // 2D Euclidean distance transform by Felzenszwalb & Huttenlocher https://cs.brown.edu/~pff/dt/
  function edt(data, width, height, f, d, v, z) {
      for (var x = 0; x < width; x++) {
          for (var y = 0; y < height; y++) {
              f[y] = data[y * width + x]
          }
          edt1d(f, d, v, z, height)
          for (y = 0; y < height; y++) {
              data[y * width + x] = d[y]
          }
      }
      for (y = 0; y < height; y++) {
          for (x = 0; x < width; x++) {
              f[x] = data[y * width + x]
          }
          edt1d(f, d, v, z, width)
          for (x = 0; x < width; x++) {
              data[y * width + x] = Math.sqrt(d[x])
          }
      }
  }
  
  // 1D squared distance transform
  function edt1d(f, d, v, z, n) {
      v[0] = 0;
      z[0] = -INF
      z[1] = +INF
  
      for (var q = 1, k = 0; q < n; q++) {
          var s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k])
          while (s <= z[k]) {
              k--
              s = ((f[q] + q * q) - (f[v[k]] + v[k] * v[k])) / (2 * q - 2 * v[k])
          }
          k++
          v[k] = q
          z[k] = s
          z[k + 1] = +INF
      }
  
      for (q = 0, k = 0; q < n; q++) {
          while (z[k + 1] < q) k++
          d[q] = (q - v[k]) * (q - v[k]) + f[v[k]]
      }
  }
  
  },{"clamp":120}],99:[function(_dereq_,module,exports){
  (function (module, exports) {
    'use strict';
  
    // Utils
    function assert (val, msg) {
      if (!val) throw new Error(msg || 'Assertion failed');
    }
  
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits (ctor, superCtor) {
      ctor.super_ = superCtor;
      var TempCtor = function () {};
      TempCtor.prototype = superCtor.prototype;
      ctor.prototype = new TempCtor();
      ctor.prototype.constructor = ctor;
    }
  
    // BN
  
    function BN (number, base, endian) {
      if (BN.isBN(number)) {
        return number;
      }
  
      this.negative = 0;
      this.words = null;
      this.length = 0;
  
      // Reduction context
      this.red = null;
  
      if (number !== null) {
        if (base === 'le' || base === 'be') {
          endian = base;
          base = 10;
        }
  
        this._init(number || 0, base || 10, endian || 'be');
      }
    }
    if (typeof module === 'object') {
      module.exports = BN;
    } else {
      exports.BN = BN;
    }
  
    BN.BN = BN;
    BN.wordSize = 26;
  
    var Buffer;
    try {
      Buffer = _dereq_('buffer').Buffer;
    } catch (e) {
    }
  
    BN.isBN = function isBN (num) {
      if (num instanceof BN) {
        return true;
      }
  
      return num !== null && typeof num === 'object' &&
        num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
  
    BN.max = function max (left, right) {
      if (left.cmp(right) > 0) return left;
      return right;
    };
  
    BN.min = function min (left, right) {
      if (left.cmp(right) < 0) return left;
      return right;
    };
  
    BN.prototype._init = function init (number, base, endian) {
      if (typeof number === 'number') {
        return this._initNumber(number, base, endian);
      }
  
      if (typeof number === 'object') {
        return this._initArray(number, base, endian);
      }
  
      if (base === 'hex') {
        base = 16;
      }
      assert(base === (base | 0) && base >= 2 && base <= 36);
  
      number = number.toString().replace(/\s+/g, '');
      var start = 0;
      if (number[0] === '-') {
        start++;
      }
  
      if (base === 16) {
        this._parseHex(number, start);
      } else {
        this._parseBase(number, base, start);
      }
  
      if (number[0] === '-') {
        this.negative = 1;
      }
  
      this.strip();
  
      if (endian !== 'le') return;
  
      this._initArray(this.toArray(), base, endian);
    };
  
    BN.prototype._initNumber = function _initNumber (number, base, endian) {
      if (number < 0) {
        this.negative = 1;
        number = -number;
      }
      if (number < 0x4000000) {
        this.words = [ number & 0x3ffffff ];
        this.length = 1;
      } else if (number < 0x10000000000000) {
        this.words = [
          number & 0x3ffffff,
          (number / 0x4000000) & 0x3ffffff
        ];
        this.length = 2;
      } else {
        assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
        this.words = [
          number & 0x3ffffff,
          (number / 0x4000000) & 0x3ffffff,
          1
        ];
        this.length = 3;
      }
  
      if (endian !== 'le') return;
  
      // Reverse the bytes
      this._initArray(this.toArray(), base, endian);
    };
  
    BN.prototype._initArray = function _initArray (number, base, endian) {
      // Perhaps a Uint8Array
      assert(typeof number.length === 'number');
      if (number.length <= 0) {
        this.words = [ 0 ];
        this.length = 1;
        return this;
      }
  
      this.length = Math.ceil(number.length / 3);
      this.words = new Array(this.length);
      for (var i = 0; i < this.length; i++) {
        this.words[i] = 0;
      }
  
      var j, w;
      var off = 0;
      if (endian === 'be') {
        for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
          w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
          this.words[j] |= (w << off) & 0x3ffffff;
          this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
          off += 24;
          if (off >= 26) {
            off -= 26;
            j++;
          }
        }
      } else if (endian === 'le') {
        for (i = 0, j = 0; i < number.length; i += 3) {
          w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
          this.words[j] |= (w << off) & 0x3ffffff;
          this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
          off += 24;
          if (off >= 26) {
            off -= 26;
            j++;
          }
        }
      }
      return this.strip();
    };
  
    function parseHex (str, start, end) {
      var r = 0;
      var len = Math.min(str.length, end);
      for (var i = start; i < len; i++) {
        var c = str.charCodeAt(i) - 48;
  
        r <<= 4;
  
        // 'a' - 'f'
        if (c >= 49 && c <= 54) {
          r |= c - 49 + 0xa;
  
        // 'A' - 'F'
        } else if (c >= 17 && c <= 22) {
          r |= c - 17 + 0xa;
  
        // '0' - '9'
        } else {
          r |= c & 0xf;
        }
      }
      return r;
    }
  
    BN.prototype._parseHex = function _parseHex (number, start) {
      // Create possibly bigger array to ensure that it fits the number
      this.length = Math.ceil((number.length - start) / 6);
      this.words = new Array(this.length);
      for (var i = 0; i < this.length; i++) {
        this.words[i] = 0;
      }
  
      var j, w;
      // Scan 24-bit chunks and add them to the number
      var off = 0;
      for (i = number.length - 6, j = 0; i >= start; i -= 6) {
        w = parseHex(number, i, i + 6);
        this.words[j] |= (w << off) & 0x3ffffff;
        // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
        this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
      if (i + 6 !== start) {
        w = parseHex(number, start, i + 6);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] |= w >>> (26 - off) & 0x3fffff;
      }
      this.strip();
    };
  
    function parseBase (str, start, end, mul) {
      var r = 0;
      var len = Math.min(str.length, end);
      for (var i = start; i < len; i++) {
        var c = str.charCodeAt(i) - 48;
  
        r *= mul;
  
        // 'a'
        if (c >= 49) {
          r += c - 49 + 0xa;
  
        // 'A'
        } else if (c >= 17) {
          r += c - 17 + 0xa;
  
        // '0' - '9'
        } else {
          r += c;
        }
      }
      return r;
    }
  
    BN.prototype._parseBase = function _parseBase (number, base, start) {
      // Initialize as zero
      this.words = [ 0 ];
      this.length = 1;
  
      // Find length of limb in base
      for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
        limbLen++;
      }
      limbLen--;
      limbPow = (limbPow / base) | 0;
  
      var total = number.length - start;
      var mod = total % limbLen;
      var end = Math.min(total, total - mod) + start;
  
      var word = 0;
      for (var i = start; i < end; i += limbLen) {
        word = parseBase(number, i, i + limbLen, base);
  
        this.imuln(limbPow);
        if (this.words[0] + word < 0x4000000) {
          this.words[0] += word;
        } else {
          this._iaddn(word);
        }
      }
  
      if (mod !== 0) {
        var pow = 1;
        word = parseBase(number, i, number.length, base);
  
        for (i = 0; i < mod; i++) {
          pow *= base;
        }
  
        this.imuln(pow);
        if (this.words[0] + word < 0x4000000) {
          this.words[0] += word;
        } else {
          this._iaddn(word);
        }
      }
    };
  
    BN.prototype.copy = function copy (dest) {
      dest.words = new Array(this.length);
      for (var i = 0; i < this.length; i++) {
        dest.words[i] = this.words[i];
      }
      dest.length = this.length;
      dest.negative = this.negative;
      dest.red = this.red;
    };
  
    BN.prototype.clone = function clone () {
      var r = new BN(null);
      this.copy(r);
      return r;
    };
  
    BN.prototype._expand = function _expand (size) {
      while (this.length < size) {
        this.words[this.length++] = 0;
      }
      return this;
    };
  
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip () {
      while (this.length > 1 && this.words[this.length - 1] === 0) {
        this.length--;
      }
      return this._normSign();
    };
  
    BN.prototype._normSign = function _normSign () {
      // -0 = 0
      if (this.length === 1 && this.words[0] === 0) {
        this.negative = 0;
      }
      return this;
    };
  
    BN.prototype.inspect = function inspect () {
      return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
  
    /*
  
    var zeros = [];
    var groupSizes = [];
    var groupBases = [];
  
    var s = '';
    var i = -1;
    while (++i < BN.wordSize) {
      zeros[i] = s;
      s += '0';
    }
    groupSizes[0] = 0;
    groupSizes[1] = 0;
    groupBases[0] = 0;
    groupBases[1] = 0;
    var base = 2 - 1;
    while (++base < 36 + 1) {
      var groupSize = 0;
      var groupBase = 1;
      while (groupBase < (1 << BN.wordSize) / base) {
        groupBase *= base;
        groupSize += 1;
      }
      groupSizes[base] = groupSize;
      groupBases[base] = groupBase;
    }
  
    */
  
    var zeros = [
      '',
      '0',
      '00',
      '000',
      '0000',
      '00000',
      '000000',
      '0000000',
      '00000000',
      '000000000',
      '0000000000',
      '00000000000',
      '000000000000',
      '0000000000000',
      '00000000000000',
      '000000000000000',
      '0000000000000000',
      '00000000000000000',
      '000000000000000000',
      '0000000000000000000',
      '00000000000000000000',
      '000000000000000000000',
      '0000000000000000000000',
      '00000000000000000000000',
      '000000000000000000000000',
      '0000000000000000000000000'
    ];
  
    var groupSizes = [
      0, 0,
      25, 16, 12, 11, 10, 9, 8,
      8, 7, 7, 7, 7, 6, 6,
      6, 6, 6, 6, 6, 5, 5,
      5, 5, 5, 5, 5, 5, 5,
      5, 5, 5, 5, 5, 5, 5
    ];
  
    var groupBases = [
      0, 0,
      33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
      43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
      16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
      6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
      24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
    ];
  
    BN.prototype.toString = function toString (base, padding) {
      base = base || 10;
      padding = padding | 0 || 1;
  
      var out;
      if (base === 16 || base === 'hex') {
        out = '';
        var off = 0;
        var carry = 0;
        for (var i = 0; i < this.length; i++) {
          var w = this.words[i];
          var word = (((w << off) | carry) & 0xffffff).toString(16);
          carry = (w >>> (24 - off)) & 0xffffff;
          if (carry !== 0 || i !== this.length - 1) {
            out = zeros[6 - word.length] + word + out;
          } else {
            out = word + out;
          }
          off += 2;
          if (off >= 26) {
            off -= 26;
            i--;
          }
        }
        if (carry !== 0) {
          out = carry.toString(16) + out;
        }
        while (out.length % padding !== 0) {
          out = '0' + out;
        }
        if (this.negative !== 0) {
          out = '-' + out;
        }
        return out;
      }
  
      if (base === (base | 0) && base >= 2 && base <= 36) {
        // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
        var groupSize = groupSizes[base];
        // var groupBase = Math.pow(base, groupSize);
        var groupBase = groupBases[base];
        out = '';
        var c = this.clone();
        c.negative = 0;
        while (!c.isZero()) {
          var r = c.modn(groupBase).toString(base);
          c = c.idivn(groupBase);
  
          if (!c.isZero()) {
            out = zeros[groupSize - r.length] + r + out;
          } else {
            out = r + out;
          }
        }
        if (this.isZero()) {
          out = '0' + out;
        }
        while (out.length % padding !== 0) {
          out = '0' + out;
        }
        if (this.negative !== 0) {
          out = '-' + out;
        }
        return out;
      }
  
      assert(false, 'Base should be between 2 and 36');
    };
  
    BN.prototype.toNumber = function toNumber () {
      var ret = this.words[0];
      if (this.length === 2) {
        ret += this.words[1] * 0x4000000;
      } else if (this.length === 3 && this.words[2] === 0x01) {
        // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + (this.words[1] * 0x4000000);
      } else if (this.length > 2) {
        assert(false, 'Number can only safely store up to 53 bits');
      }
      return (this.negative !== 0) ? -ret : ret;
    };
  
    BN.prototype.toJSON = function toJSON () {
      return this.toString(16);
    };
  
    BN.prototype.toBuffer = function toBuffer (endian, length) {
      assert(typeof Buffer !== 'undefined');
      return this.toArrayLike(Buffer, endian, length);
    };
  
    BN.prototype.toArray = function toArray (endian, length) {
      return this.toArrayLike(Array, endian, length);
    };
  
    BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
      var byteLength = this.byteLength();
      var reqLength = length || Math.max(1, byteLength);
      assert(byteLength <= reqLength, 'byte array longer than desired length');
      assert(reqLength > 0, 'Requested array length <= 0');
  
      this.strip();
      var littleEndian = endian === 'le';
      var res = new ArrayType(reqLength);
  
      var b, i;
      var q = this.clone();
      if (!littleEndian) {
        // Assume big-endian
        for (i = 0; i < reqLength - byteLength; i++) {
          res[i] = 0;
        }
  
        for (i = 0; !q.isZero(); i++) {
          b = q.andln(0xff);
          q.iushrn(8);
  
          res[reqLength - i - 1] = b;
        }
      } else {
        for (i = 0; !q.isZero(); i++) {
          b = q.andln(0xff);
          q.iushrn(8);
  
          res[i] = b;
        }
  
        for (; i < reqLength; i++) {
          res[i] = 0;
        }
      }
  
      return res;
    };
  
    if (Math.clz32) {
      BN.prototype._countBits = function _countBits (w) {
        return 32 - Math.clz32(w);
      };
    } else {
      BN.prototype._countBits = function _countBits (w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
          r += 13;
          t >>>= 13;
        }
        if (t >= 0x40) {
          r += 7;
          t >>>= 7;
        }
        if (t >= 0x8) {
          r += 4;
          t >>>= 4;
        }
        if (t >= 0x02) {
          r += 2;
          t >>>= 2;
        }
        return r + t;
      };
    }
  
    BN.prototype._zeroBits = function _zeroBits (w) {
      // Short-cut
      if (w === 0) return 26;
  
      var t = w;
      var r = 0;
      if ((t & 0x1fff) === 0) {
        r += 13;
        t >>>= 13;
      }
      if ((t & 0x7f) === 0) {
        r += 7;
        t >>>= 7;
      }
      if ((t & 0xf) === 0) {
        r += 4;
        t >>>= 4;
      }
      if ((t & 0x3) === 0) {
        r += 2;
        t >>>= 2;
      }
      if ((t & 0x1) === 0) {
        r++;
      }
      return r;
    };
  
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength () {
      var w = this.words[this.length - 1];
      var hi = this._countBits(w);
      return (this.length - 1) * 26 + hi;
    };
  
    function toBitArray (num) {
      var w = new Array(num.bitLength());
  
      for (var bit = 0; bit < w.length; bit++) {
        var off = (bit / 26) | 0;
        var wbit = bit % 26;
  
        w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
      }
  
      return w;
    }
  
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits () {
      if (this.isZero()) return 0;
  
      var r = 0;
      for (var i = 0; i < this.length; i++) {
        var b = this._zeroBits(this.words[i]);
        r += b;
        if (b !== 26) break;
      }
      return r;
    };
  
    BN.prototype.byteLength = function byteLength () {
      return Math.ceil(this.bitLength() / 8);
    };
  
    BN.prototype.toTwos = function toTwos (width) {
      if (this.negative !== 0) {
        return this.abs().inotn(width).iaddn(1);
      }
      return this.clone();
    };
  
    BN.prototype.fromTwos = function fromTwos (width) {
      if (this.testn(width - 1)) {
        return this.notn(width).iaddn(1).ineg();
      }
      return this.clone();
    };
  
    BN.prototype.isNeg = function isNeg () {
      return this.negative !== 0;
    };
  
    // Return negative clone of `this`
    BN.prototype.neg = function neg () {
      return this.clone().ineg();
    };
  
    BN.prototype.ineg = function ineg () {
      if (!this.isZero()) {
        this.negative ^= 1;
      }
  
      return this;
    };
  
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor (num) {
      while (this.length < num.length) {
        this.words[this.length++] = 0;
      }
  
      for (var i = 0; i < num.length; i++) {
        this.words[i] = this.words[i] | num.words[i];
      }
  
      return this.strip();
    };
  
    BN.prototype.ior = function ior (num) {
      assert((this.negative | num.negative) === 0);
      return this.iuor(num);
    };
  
    // Or `num` with `this`
    BN.prototype.or = function or (num) {
      if (this.length > num.length) return this.clone().ior(num);
      return num.clone().ior(this);
    };
  
    BN.prototype.uor = function uor (num) {
      if (this.length > num.length) return this.clone().iuor(num);
      return num.clone().iuor(this);
    };
  
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand (num) {
      // b = min-length(num, this)
      var b;
      if (this.length > num.length) {
        b = num;
      } else {
        b = this;
      }
  
      for (var i = 0; i < b.length; i++) {
        this.words[i] = this.words[i] & num.words[i];
      }
  
      this.length = b.length;
  
      return this.strip();
    };
  
    BN.prototype.iand = function iand (num) {
      assert((this.negative | num.negative) === 0);
      return this.iuand(num);
    };
  
    // And `num` with `this`
    BN.prototype.and = function and (num) {
      if (this.length > num.length) return this.clone().iand(num);
      return num.clone().iand(this);
    };
  
    BN.prototype.uand = function uand (num) {
      if (this.length > num.length) return this.clone().iuand(num);
      return num.clone().iuand(this);
    };
  
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor (num) {
      // a.length > b.length
      var a;
      var b;
      if (this.length > num.length) {
        a = this;
        b = num;
      } else {
        a = num;
        b = this;
      }
  
      for (var i = 0; i < b.length; i++) {
        this.words[i] = a.words[i] ^ b.words[i];
      }
  
      if (this !== a) {
        for (; i < a.length; i++) {
          this.words[i] = a.words[i];
        }
      }
  
      this.length = a.length;
  
      return this.strip();
    };
  
    BN.prototype.ixor = function ixor (num) {
      assert((this.negative | num.negative) === 0);
      return this.iuxor(num);
    };
  
    // Xor `num` with `this`
    BN.prototype.xor = function xor (num) {
      if (this.length > num.length) return this.clone().ixor(num);
      return num.clone().ixor(this);
    };
  
    BN.prototype.uxor = function uxor (num) {
      if (this.length > num.length) return this.clone().iuxor(num);
      return num.clone().iuxor(this);
    };
  
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn (width) {
      assert(typeof width === 'number' && width >= 0);
  
      var bytesNeeded = Math.ceil(width / 26) | 0;
      var bitsLeft = width % 26;
  
      // Extend the buffer with leading zeroes
      this._expand(bytesNeeded);
  
      if (bitsLeft > 0) {
        bytesNeeded--;
      }
  
      // Handle complete words
      for (var i = 0; i < bytesNeeded; i++) {
        this.words[i] = ~this.words[i] & 0x3ffffff;
      }
  
      // Handle the residue
      if (bitsLeft > 0) {
        this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
      }
  
      // And remove leading zeroes
      return this.strip();
    };
  
    BN.prototype.notn = function notn (width) {
      return this.clone().inotn(width);
    };
  
    // Set `bit` of `this`
    BN.prototype.setn = function setn (bit, val) {
      assert(typeof bit === 'number' && bit >= 0);
  
      var off = (bit / 26) | 0;
      var wbit = bit % 26;
  
      this._expand(off + 1);
  
      if (val) {
        this.words[off] = this.words[off] | (1 << wbit);
      } else {
        this.words[off] = this.words[off] & ~(1 << wbit);
      }
  
      return this.strip();
    };
  
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd (num) {
      var r;
  
      // negative + positive
      if (this.negative !== 0 && num.negative === 0) {
        this.negative = 0;
        r = this.isub(num);
        this.negative ^= 1;
        return this._normSign();
  
      // positive + negative
      } else if (this.negative === 0 && num.negative !== 0) {
        num.negative = 0;
        r = this.isub(num);
        num.negative = 1;
        return r._normSign();
      }
  
      // a.length > b.length
      var a, b;
      if (this.length > num.length) {
        a = this;
        b = num;
      } else {
        a = num;
        b = this;
      }
  
      var carry = 0;
      for (var i = 0; i < b.length; i++) {
        r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
        this.words[i] = r & 0x3ffffff;
        carry = r >>> 26;
      }
      for (; carry !== 0 && i < a.length; i++) {
        r = (a.words[i] | 0) + carry;
        this.words[i] = r & 0x3ffffff;
        carry = r >>> 26;
      }
  
      this.length = a.length;
      if (carry !== 0) {
        this.words[this.length] = carry;
        this.length++;
      // Copy the rest of the words
      } else if (a !== this) {
        for (; i < a.length; i++) {
          this.words[i] = a.words[i];
        }
      }
  
      return this;
    };
  
    // Add `num` to `this`
    BN.prototype.add = function add (num) {
      var res;
      if (num.negative !== 0 && this.negative === 0) {
        num.negative = 0;
        res = this.sub(num);
        num.negative ^= 1;
        return res;
      } else if (num.negative === 0 && this.negative !== 0) {
        this.negative = 0;
        res = num.sub(this);
        this.negative = 1;
        return res;
      }
  
      if (this.length > num.length) return this.clone().iadd(num);
  
      return num.clone().iadd(this);
    };
  
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub (num) {
      // this - (-num) = this + num
      if (num.negative !== 0) {
        num.negative = 0;
        var r = this.iadd(num);
        num.negative = 1;
        return r._normSign();
  
      // -this - num = -(this + num)
      } else if (this.negative !== 0) {
        this.negative = 0;
        this.iadd(num);
        this.negative = 1;
        return this._normSign();
      }
  
      // At this point both numbers are positive
      var cmp = this.cmp(num);
  
      // Optimization - zeroify
      if (cmp === 0) {
        this.negative = 0;
        this.length = 1;
        this.words[0] = 0;
        return this;
      }
  
      // a > b
      var a, b;
      if (cmp > 0) {
        a = this;
        b = num;
      } else {
        a = num;
        b = this;
      }
  
      var carry = 0;
      for (var i = 0; i < b.length; i++) {
        r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
        carry = r >> 26;
        this.words[i] = r & 0x3ffffff;
      }
      for (; carry !== 0 && i < a.length; i++) {
        r = (a.words[i] | 0) + carry;
        carry = r >> 26;
        this.words[i] = r & 0x3ffffff;
      }
  
      // Copy rest of the words
      if (carry === 0 && i < a.length && a !== this) {
        for (; i < a.length; i++) {
          this.words[i] = a.words[i];
        }
      }
  
      this.length = Math.max(this.length, i);
  
      if (a !== this) {
        this.negative = 1;
      }
  
      return this.strip();
    };
  
    // Subtract `num` from `this`
    BN.prototype.sub = function sub (num) {
      return this.clone().isub(num);
    };
  
    function smallMulTo (self, num, out) {
      out.negative = num.negative ^ self.negative;
      var len = (self.length + num.length) | 0;
      out.length = len;
      len = (len - 1) | 0;
  
      // Peel one iteration (compiler can't do it, because of code complexity)
      var a = self.words[0] | 0;
      var b = num.words[0] | 0;
      var r = a * b;
  
      var lo = r & 0x3ffffff;
      var carry = (r / 0x4000000) | 0;
      out.words[0] = lo;
  
      for (var k = 1; k < len; k++) {
        // Sum all words with the same `i + j = k` and accumulate `ncarry`,
        // note that ncarry could be >= 0x3ffffff
        var ncarry = carry >>> 26;
        var rword = carry & 0x3ffffff;
        var maxJ = Math.min(k, num.length - 1);
        for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
          var i = (k - j) | 0;
          a = self.words[i] | 0;
          b = num.words[j] | 0;
          r = a * b + rword;
          ncarry += (r / 0x4000000) | 0;
          rword = r & 0x3ffffff;
        }
        out.words[k] = rword | 0;
        carry = ncarry | 0;
      }
      if (carry !== 0) {
        out.words[k] = carry | 0;
      } else {
        out.length--;
      }
  
      return out.strip();
    }
  
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo (self, num, out) {
      var a = self.words;
      var b = num.words;
      var o = out.words;
      var c = 0;
      var lo;
      var mid;
      var hi;
      var a0 = a[0] | 0;
      var al0 = a0 & 0x1fff;
      var ah0 = a0 >>> 13;
      var a1 = a[1] | 0;
      var al1 = a1 & 0x1fff;
      var ah1 = a1 >>> 13;
      var a2 = a[2] | 0;
      var al2 = a2 & 0x1fff;
      var ah2 = a2 >>> 13;
      var a3 = a[3] | 0;
      var al3 = a3 & 0x1fff;
      var ah3 = a3 >>> 13;
      var a4 = a[4] | 0;
      var al4 = a4 & 0x1fff;
      var ah4 = a4 >>> 13;
      var a5 = a[5] | 0;
      var al5 = a5 & 0x1fff;
      var ah5 = a5 >>> 13;
      var a6 = a[6] | 0;
      var al6 = a6 & 0x1fff;
      var ah6 = a6 >>> 13;
      var a7 = a[7] | 0;
      var al7 = a7 & 0x1fff;
      var ah7 = a7 >>> 13;
      var a8 = a[8] | 0;
      var al8 = a8 & 0x1fff;
      var ah8 = a8 >>> 13;
      var a9 = a[9] | 0;
      var al9 = a9 & 0x1fff;
      var ah9 = a9 >>> 13;
      var b0 = b[0] | 0;
      var bl0 = b0 & 0x1fff;
      var bh0 = b0 >>> 13;
      var b1 = b[1] | 0;
      var bl1 = b1 & 0x1fff;
      var bh1 = b1 >>> 13;
      var b2 = b[2] | 0;
      var bl2 = b2 & 0x1fff;
      var bh2 = b2 >>> 13;
      var b3 = b[3] | 0;
      var bl3 = b3 & 0x1fff;
      var bh3 = b3 >>> 13;
      var b4 = b[4] | 0;
      var bl4 = b4 & 0x1fff;
      var bh4 = b4 >>> 13;
      var b5 = b[5] | 0;
      var bl5 = b5 & 0x1fff;
      var bh5 = b5 >>> 13;
      var b6 = b[6] | 0;
      var bl6 = b6 & 0x1fff;
      var bh6 = b6 >>> 13;
      var b7 = b[7] | 0;
      var bl7 = b7 & 0x1fff;
      var bh7 = b7 >>> 13;
      var b8 = b[8] | 0;
      var bl8 = b8 & 0x1fff;
      var bh8 = b8 >>> 13;
      var b9 = b[9] | 0;
      var bl9 = b9 & 0x1fff;
      var bh9 = b9 >>> 13;
  
      out.negative = self.negative ^ num.negative;
      out.length = 19;
      /* k = 0 */
      lo = Math.imul(al0, bl0);
      mid = Math.imul(al0, bh0);
      mid = (mid + Math.imul(ah0, bl0)) | 0;
      hi = Math.imul(ah0, bh0);
      var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
      w0 &= 0x3ffffff;
      /* k = 1 */
      lo = Math.imul(al1, bl0);
      mid = Math.imul(al1, bh0);
      mid = (mid + Math.imul(ah1, bl0)) | 0;
      hi = Math.imul(ah1, bh0);
      lo = (lo + Math.imul(al0, bl1)) | 0;
      mid = (mid + Math.imul(al0, bh1)) | 0;
      mid = (mid + Math.imul(ah0, bl1)) | 0;
      hi = (hi + Math.imul(ah0, bh1)) | 0;
      var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
      w1 &= 0x3ffffff;
      /* k = 2 */
      lo = Math.imul(al2, bl0);
      mid = Math.imul(al2, bh0);
      mid = (mid + Math.imul(ah2, bl0)) | 0;
      hi = Math.imul(ah2, bh0);
      lo = (lo + Math.imul(al1, bl1)) | 0;
      mid = (mid + Math.imul(al1, bh1)) | 0;
      mid = (mid + Math.imul(ah1, bl1)) | 0;
      hi = (hi + Math.imul(ah1, bh1)) | 0;
      lo = (lo + Math.imul(al0, bl2)) | 0;
      mid = (mid + Math.imul(al0, bh2)) | 0;
      mid = (mid + Math.imul(ah0, bl2)) | 0;
      hi = (hi + Math.imul(ah0, bh2)) | 0;
      var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
      w2 &= 0x3ffffff;
      /* k = 3 */
      lo = Math.imul(al3, bl0);
      mid = Math.imul(al3, bh0);
      mid = (mid + Math.imul(ah3, bl0)) | 0;
      hi = Math.imul(ah3, bh0);
      lo = (lo + Math.imul(al2, bl1)) | 0;
      mid = (mid + Math.imul(al2, bh1)) | 0;
      mid = (mid + Math.imul(ah2, bl1)) | 0;
      hi = (hi + Math.imul(ah2, bh1)) | 0;
      lo = (lo + Math.imul(al1, bl2)) | 0;
      mid = (mid + Math.imul(al1, bh2)) | 0;
      mid = (mid + Math.imul(ah1, bl2)) | 0;
      hi = (hi + Math.imul(ah1, bh2)) | 0;
      lo = (lo + Math.imul(al0, bl3)) | 0;
      mid = (mid + Math.imul(al0, bh3)) | 0;
      mid = (mid + Math.imul(ah0, bl3)) | 0;
      hi = (hi + Math.imul(ah0, bh3)) | 0;
      var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
      w3 &= 0x3ffffff;
      /* k = 4 */
      lo = Math.imul(al4, bl0);
      mid = Math.imul(al4, bh0);
      mid = (mid + Math.imul(ah4, bl0)) | 0;
      hi = Math.imul(ah4, bh0);
      lo = (lo + Math.imul(al3, bl1)) | 0;
      mid = (mid + Math.imul(al3, bh1)) | 0;
      mid = (mid + Math.imul(ah3, bl1)) | 0;
      hi = (hi + Math.imul(ah3, bh1)) | 0;
      lo = (lo + Math.imul(al2, bl2)) | 0;
      mid = (mid + Math.imul(al2, bh2)) | 0;
      mid = (mid + Math.imul(ah2, bl2)) | 0;
      hi = (hi + Math.imul(ah2, bh2)) | 0;
      lo = (lo + Math.imul(al1, bl3)) | 0;
      mid = (mid + Math.imul(al1, bh3)) | 0;
      mid = (mid + Math.imul(ah1, bl3)) | 0;
      hi = (hi + Math.imul(ah1, bh3)) | 0;
      lo = (lo + Math.imul(al0, bl4)) | 0;
      mid = (mid + Math.imul(al0, bh4)) | 0;
      mid = (mid + Math.imul(ah0, bl4)) | 0;
      hi = (hi + Math.imul(ah0, bh4)) | 0;
      var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
      w4 &= 0x3ffffff;
      /* k = 5 */
      lo = Math.imul(al5, bl0);
      mid = Math.imul(al5, bh0);
      mid = (mid + Math.imul(ah5, bl0)) | 0;
      hi = Math.imul(ah5, bh0);
      lo = (lo + Math.imul(al4, bl1)) | 0;
      mid = (mid + Math.imul(al4, bh1)) | 0;
      mid = (mid + Math.imul(ah4, bl1)) | 0;
      hi = (hi + Math.imul(ah4, bh1)) | 0;
      lo = (lo + Math.imul(al3, bl2)) | 0;
      mid = (mid + Math.imul(al3, bh2)) | 0;
      mid = (mid + Math.imul(ah3, bl2)) | 0;
      hi = (hi + Math.imul(ah3, bh2)) | 0;
      lo = (lo + Math.imul(al2, bl3)) | 0;
      mid = (mid + Math.imul(al2, bh3)) | 0;
      mid = (mid + Math.imul(ah2, bl3)) | 0;
      hi = (hi + Math.imul(ah2, bh3)) | 0;
      lo = (lo + Math.imul(al1, bl4)) | 0;
      mid = (mid + Math.imul(al1, bh4)) | 0;
      mid = (mid + Math.imul(ah1, bl4)) | 0;
      hi = (hi + Math.imul(ah1, bh4)) | 0;
      lo = (lo + Math.imul(al0, bl5)) | 0;
      mid = (mid + Math.imul(al0, bh5)) | 0;
      mid = (mid + Math.imul(ah0, bl5)) | 0;
      hi = (hi + Math.imul(ah0, bh5)) | 0;
      var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
      w5 &= 0x3ffffff;
      /* k = 6 */
      lo = Math.imul(al6, bl0);
      mid = Math.imul(al6, bh0);
      mid = (mid + Math.imul(ah6, bl0)) | 0;
      hi = Math.imul(ah6, bh0);
      lo = (lo + Math.imul(al5, bl1)) | 0;
      mid = (mid + Math.imul(al5, bh1)) | 0;
      mid = (mid + Math.imul(ah5, bl1)) | 0;
      hi = (hi + Math.imul(ah5, bh1)) | 0;
      lo = (lo + Math.imul(al4, bl2)) | 0;
      mid = (mid + Math.imul(al4, bh2)) | 0;
      mid = (mid + Math.imul(ah4, bl2)) | 0;
      hi = (hi + Math.imul(ah4, bh2)) | 0;
      lo = (lo + Math.imul(al3, bl3)) | 0;
      mid = (mid + Math.imul(al3, bh3)) | 0;
      mid = (mid + Math.imul(ah3, bl3)) | 0;
      hi = (hi + Math.imul(ah3, bh3)) | 0;
      lo = (lo + Math.imul(al2, bl4)) | 0;
      mid = (mid + Math.imul(al2, bh4)) | 0;
      mid = (mid + Math.imul(ah2, bl4)) | 0;
      hi = (hi + Math.imul(ah2, bh4)) | 0;
      lo = (lo + Math.imul(al1, bl5)) | 0;
      mid = (mid + Math.imul(al1, bh5)) | 0;
      mid = (mid + Math.imul(ah1, bl5)) | 0;
      hi = (hi + Math.imul(ah1, bh5)) | 0;
      lo = (lo + Math.imul(al0, bl6)) | 0;
      mid = (mid + Math.imul(al0, bh6)) | 0;
      mid = (mid + Math.imul(ah0, bl6)) | 0;
      hi = (hi + Math.imul(ah0, bh6)) | 0;
      var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
      w6 &= 0x3ffffff;
      /* k = 7 */
      lo = Math.imul(al7, bl0);
      mid = Math.imul(al7, bh0);
      mid = (mid + Math.imul(ah7, bl0)) | 0;
      hi = Math.imul(ah7, bh0);
      lo = (lo + Math.imul(al6, bl1)) | 0;
      mid = (mid + Math.imul(al6, bh1)) | 0;
      mid = (mid + Math.imul(ah6, bl1)) | 0;
      hi = (hi + Math.imul(ah6, bh1)) | 0;
      lo = (lo + Math.imul(al5, bl2)) | 0;
      mid = (mid + Math.imul(al5, bh2)) | 0;
      mid = (mid + Math.imul(ah5, bl2)) | 0;
      hi = (hi + Math.imul(ah5, bh2)) | 0;
      lo = (lo + Math.imul(al4, bl3)) | 0;
      mid = (mid + Math.imul(al4, bh3)) | 0;
      mid = (mid + Math.imul(ah4, bl3)) | 0;
      hi = (hi + Math.imul(ah4, bh3)) | 0;
      lo = (lo + Math.imul(al3, bl4)) | 0;
      mid = (mid + Math.imul(al3, bh4)) | 0;
      mid = (mid + Math.imul(ah3, bl4)) | 0;
      hi = (hi + Math.imul(ah3, bh4)) | 0;
      lo = (lo + Math.imul(al2, bl5)) | 0;
      mid = (mid + Math.imul(al2, bh5)) | 0;
      mid = (mid + Math.imul(ah2, bl5)) | 0;
      hi = (hi + Math.imul(ah2, bh5)) | 0;
      lo = (lo + Math.imul(al1, bl6)) | 0;
      mid = (mid + Math.imul(al1, bh6)) | 0;
      mid = (mid + Math.imul(ah1, bl6)) | 0;
      hi = (hi + Math.imul(ah1, bh6)) | 0;
      lo = (lo + Math.imul(al0, bl7)) | 0;
      mid = (mid + Math.imul(al0, bh7)) | 0;
      mid = (mid + Math.imul(ah0, bl7)) | 0;
      hi = (hi + Math.imul(ah0, bh7)) | 0;
      var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
      w7 &= 0x3ffffff;
      /* k = 8 */
      lo = Math.imul(al8, bl0);
      mid = Math.imul(al8, bh0);
      mid = (mid + Math.imul(ah8, bl0)) | 0;
      hi = Math.imul(ah8, bh0);
      lo = (lo + Math.imul(al7, bl1)) | 0;
      mid = (mid + Math.imul(al7, bh1)) | 0;
      mid = (mid + Math.imul(ah7, bl1)) | 0;
      hi = (hi + Math.imul(ah7, bh1)) | 0;
      lo = (lo + Math.imul(al6, bl2)) | 0;
      mid = (mid + Math.imul(al6, bh2)) | 0;
      mid = (mid + Math.imul(ah6, bl2)) | 0;
      hi = (hi + Math.imul(ah6, bh2)) | 0;
      lo = (lo + Math.imul(al5, bl3)) | 0;
      mid = (mid + Math.imul(al5, bh3)) | 0;
      mid = (mid + Math.imul(ah5, bl3)) | 0;
      hi = (hi + Math.imul(ah5, bh3)) | 0;
      lo = (lo + Math.imul(al4, bl4)) | 0;
      mid = (mid + Math.imul(al4, bh4)) | 0;
      mid = (mid + Math.imul(ah4, bl4)) | 0;
      hi = (hi + Math.imul(ah4, bh4)) | 0;
      lo = (lo + Math.imul(al3, bl5)) | 0;
      mid = (mid + Math.imul(al3, bh5)) | 0;
      mid = (mid + Math.imul(ah3, bl5)) | 0;
      hi = (hi + Math.imul(ah3, bh5)) | 0;
      lo = (lo + Math.imul(al2, bl6)) | 0;
      mid = (mid + Math.imul(al2, bh6)) | 0;
      mid = (mid + Math.imul(ah2, bl6)) | 0;
      hi = (hi + Math.imul(ah2, bh6)) | 0;
      lo = (lo + Math.imul(al1, bl7)) | 0;
      mid = (mid + Math.imul(al1, bh7)) | 0;
      mid = (mid + Math.imul(ah1, bl7)) | 0;
      hi = (hi + Math.imul(ah1, bh7)) | 0;
      lo = (lo + Math.imul(al0, bl8)) | 0;
      mid = (mid + Math.imul(al0, bh8)) | 0;
      mid = (mid + Math.imul(ah0, bl8)) | 0;
      hi = (hi + Math.imul(ah0, bh8)) | 0;
      var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
      w8 &= 0x3ffffff;
      /* k = 9 */
      lo = Math.imul(al9, bl0);
      mid = Math.imul(al9, bh0);
      mid = (mid + Math.imul(ah9, bl0)) | 0;
      hi = Math.imul(ah9, bh0);
      lo = (lo + Math.imul(al8, bl1)) | 0;
      mid = (mid + Math.imul(al8, bh1)) | 0;
      mid = (mid + Math.imul(ah8, bl1)) | 0;
      hi = (hi + Math.imul(ah8, bh1)) | 0;
      lo = (lo + Math.imul(al7, bl2)) | 0;
      mid = (mid + Math.imul(al7, bh2)) | 0;
      mid = (mid + Math.imul(ah7, bl2)) | 0;
      hi = (hi + Math.imul(ah7, bh2)) | 0;
      lo = (lo + Math.imul(al6, bl3)) | 0;
      mid = (mid + Math.imul(al6, bh3)) | 0;
      mid = (mid + Math.imul(ah6, bl3)) | 0;
      hi = (hi + Math.imul(ah6, bh3)) | 0;
      lo = (lo + Math.imul(al5, bl4)) | 0;
      mid = (mid + Math.imul(al5, bh4)) | 0;
      mid = (mid + Math.imul(ah5, bl4)) | 0;
      hi = (hi + Math.imul(ah5, bh4)) | 0;
      lo = (lo + Math.imul(al4, bl5)) | 0;
      mid = (mid + Math.imul(al4, bh5)) | 0;
      mid = (mid + Math.imul(ah4, bl5)) | 0;
      hi = (hi + Math.imul(ah4, bh5)) | 0;
      lo = (lo + Math.imul(al3, bl6)) | 0;
      mid = (mid + Math.imul(al3, bh6)) | 0;
      mid = (mid + Math.imul(ah3, bl6)) | 0;
      hi = (hi + Math.imul(ah3, bh6)) | 0;
      lo = (lo + Math.imul(al2, bl7)) | 0;
      mid = (mid + Math.imul(al2, bh7)) | 0;
      mid = (mid + Math.imul(ah2, bl7)) | 0;
      hi = (hi + Math.imul(ah2, bh7)) | 0;
      lo = (lo + Math.imul(al1, bl8)) | 0;
      mid = (mid + Math.imul(al1, bh8)) | 0;
      mid = (mid + Math.imul(ah1, bl8)) | 0;
      hi = (hi + Math.imul(ah1, bh8)) | 0;
      lo = (lo + Math.imul(al0, bl9)) | 0;
      mid = (mid + Math.imul(al0, bh9)) | 0;
      mid = (mid + Math.imul(ah0, bl9)) | 0;
      hi = (hi + Math.imul(ah0, bh9)) | 0;
      var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
      w9 &= 0x3ffffff;
      /* k = 10 */
      lo = Math.imul(al9, bl1);
      mid = Math.imul(al9, bh1);
      mid = (mid + Math.imul(ah9, bl1)) | 0;
      hi = Math.imul(ah9, bh1);
      lo = (lo + Math.imul(al8, bl2)) | 0;
      mid = (mid + Math.imul(al8, bh2)) | 0;
      mid = (mid + Math.imul(ah8, bl2)) | 0;
      hi = (hi + Math.imul(ah8, bh2)) | 0;
      lo = (lo + Math.imul(al7, bl3)) | 0;
      mid = (mid + Math.imul(al7, bh3)) | 0;
      mid = (mid + Math.imul(ah7, bl3)) | 0;
      hi = (hi + Math.imul(ah7, bh3)) | 0;
      lo = (lo + Math.imul(al6, bl4)) | 0;
      mid = (mid + Math.imul(al6, bh4)) | 0;
      mid = (mid + Math.imul(ah6, bl4)) | 0;
      hi = (hi + Math.imul(ah6, bh4)) | 0;
      lo = (lo + Math.imul(al5, bl5)) | 0;
      mid = (mid + Math.imul(al5, bh5)) | 0;
      mid = (mid + Math.imul(ah5, bl5)) | 0;
      hi = (hi + Math.imul(ah5, bh5)) | 0;
      lo = (lo + Math.imul(al4, bl6)) | 0;
      mid = (mid + Math.imul(al4, bh6)) | 0;
      mid = (mid + Math.imul(ah4, bl6)) | 0;
      hi = (hi + Math.imul(ah4, bh6)) | 0;
      lo = (lo + Math.imul(al3, bl7)) | 0;
      mid = (mid + Math.imul(al3, bh7)) | 0;
      mid = (mid + Math.imul(ah3, bl7)) | 0;
      hi = (hi + Math.imul(ah3, bh7)) | 0;
      lo = (lo + Math.imul(al2, bl8)) | 0;
      mid = (mid + Math.imul(al2, bh8)) | 0;
      mid = (mid + Math.imul(ah2, bl8)) | 0;
      hi = (hi + Math.imul(ah2, bh8)) | 0;
      lo = (lo + Math.imul(al1, bl9)) | 0;
      mid = (mid + Math.imul(al1, bh9)) | 0;
      mid = (mid + Math.imul(ah1, bl9)) | 0;
      hi = (hi + Math.imul(ah1, bh9)) | 0;
      var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
      w10 &= 0x3ffffff;
      /* k = 11 */
      lo = Math.imul(al9, bl2);
      mid = Math.imul(al9, bh2);
      mid = (mid + Math.imul(ah9, bl2)) | 0;
      hi = Math.imul(ah9, bh2);
      lo = (lo + Math.imul(al8, bl3)) | 0;
      mid = (mid + Math.imul(al8, bh3)) | 0;
      mid = (mid + Math.imul(ah8, bl3)) | 0;
      hi = (hi + Math.imul(ah8, bh3)) | 0;
      lo = (lo + Math.imul(al7, bl4)) | 0;
      mid = (mid + Math.imul(al7, bh4)) | 0;
      mid = (mid + Math.imul(ah7, bl4)) | 0;
      hi = (hi + Math.imul(ah7, bh4)) | 0;
      lo = (lo + Math.imul(al6, bl5)) | 0;
      mid = (mid + Math.imul(al6, bh5)) | 0;
      mid = (mid + Math.imul(ah6, bl5)) | 0;
      hi = (hi + Math.imul(ah6, bh5)) | 0;
      lo = (lo + Math.imul(al5, bl6)) | 0;
      mid = (mid + Math.imul(al5, bh6)) | 0;
      mid = (mid + Math.imul(ah5, bl6)) | 0;
      hi = (hi + Math.imul(ah5, bh6)) | 0;
      lo = (lo + Math.imul(al4, bl7)) | 0;
      mid = (mid + Math.imul(al4, bh7)) | 0;
      mid = (mid + Math.imul(ah4, bl7)) | 0;
      hi = (hi + Math.imul(ah4, bh7)) | 0;
      lo = (lo + Math.imul(al3, bl8)) | 0;
      mid = (mid + Math.imul(al3, bh8)) | 0;
      mid = (mid + Math.imul(ah3, bl8)) | 0;
      hi = (hi + Math.imul(ah3, bh8)) | 0;
      lo = (lo + Math.imul(al2, bl9)) | 0;
      mid = (mid + Math.imul(al2, bh9)) | 0;
      mid = (mid + Math.imul(ah2, bl9)) | 0;
      hi = (hi + Math.imul(ah2, bh9)) | 0;
      var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
      w11 &= 0x3ffffff;
      /* k = 12 */
      lo = Math.imul(al9, bl3);
      mid = Math.imul(al9, bh3);
      mid = (mid + Math.imul(ah9, bl3)) | 0;
      hi = Math.imul(ah9, bh3);
      lo = (lo + Math.imul(al8, bl4)) | 0;
      mid = (mid + Math.imul(al8, bh4)) | 0;
      mid = (mid + Math.imul(ah8, bl4)) | 0;
      hi = (hi + Math.imul(ah8, bh4)) | 0;
      lo = (lo + Math.imul(al7, bl5)) | 0;
      mid = (mid + Math.imul(al7, bh5)) | 0;
      mid = (mid + Math.imul(ah7, bl5)) | 0;
      hi = (hi + Math.imul(ah7, bh5)) | 0;
      lo = (lo + Math.imul(al6, bl6)) | 0;
      mid = (mid + Math.imul(al6, bh6)) | 0;
      mid = (mid + Math.imul(ah6, bl6)) | 0;
      hi = (hi + Math.imul(ah6, bh6)) | 0;
      lo = (lo + Math.imul(al5, bl7)) | 0;
      mid = (mid + Math.imul(al5, bh7)) | 0;
      mid = (mid + Math.imul(ah5, bl7)) | 0;
      hi = (hi + Math.imul(ah5, bh7)) | 0;
      lo = (lo + Math.imul(al4, bl8)) | 0;
      mid = (mid + Math.imul(al4, bh8)) | 0;
      mid = (mid + Math.imul(ah4, bl8)) | 0;
      hi = (hi + Math.imul(ah4, bh8)) | 0;
      lo = (lo + Math.imul(al3, bl9)) | 0;
      mid = (mid + Math.imul(al3, bh9)) | 0;
      mid = (mid + Math.imul(ah3, bl9)) | 0;
      hi = (hi + Math.imul(ah3, bh9)) | 0;
      var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
      w12 &= 0x3ffffff;
      /* k = 13 */
      lo = Math.imul(al9, bl4);
      mid = Math.imul(al9, bh4);
      mid = (mid + Math.imul(ah9, bl4)) | 0;
      hi = Math.imul(ah9, bh4);
      lo = (lo + Math.imul(al8, bl5)) | 0;
      mid = (mid + Math.imul(al8, bh5)) | 0;
      mid = (mid + Math.imul(ah8, bl5)) | 0;
      hi = (hi + Math.imul(ah8, bh5)) | 0;
      lo = (lo + Math.imul(al7, bl6)) | 0;
      mid = (mid + Math.imul(al7, bh6)) | 0;
      mid = (mid + Math.imul(ah7, bl6)) | 0;
      hi = (hi + Math.imul(ah7, bh6)) | 0;
      lo = (lo + Math.imul(al6, bl7)) | 0;
      mid = (mid + Math.imul(al6, bh7)) | 0;
      mid = (mid + Math.imul(ah6, bl7)) | 0;
      hi = (hi + Math.imul(ah6, bh7)) | 0;
      lo = (lo + Math.imul(al5, bl8)) | 0;
      mid = (mid + Math.imul(al5, bh8)) | 0;
      mid = (mid + Math.imul(ah5, bl8)) | 0;
      hi = (hi + Math.imul(ah5, bh8)) | 0;
      lo = (lo + Math.imul(al4, bl9)) | 0;
      mid = (mid + Math.imul(al4, bh9)) | 0;
      mid = (mid + Math.imul(ah4, bl9)) | 0;
      hi = (hi + Math.imul(ah4, bh9)) | 0;
      var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
      w13 &= 0x3ffffff;
      /* k = 14 */
      lo = Math.imul(al9, bl5);
      mid = Math.imul(al9, bh5);
      mid = (mid + Math.imul(ah9, bl5)) | 0;
      hi = Math.imul(ah9, bh5);
      lo = (lo + Math.imul(al8, bl6)) | 0;
      mid = (mid + Math.imul(al8, bh6)) | 0;
      mid = (mid + Math.imul(ah8, bl6)) | 0;
      hi = (hi + Math.imul(ah8, bh6)) | 0;
      lo = (lo + Math.imul(al7, bl7)) | 0;
      mid = (mid + Math.imul(al7, bh7)) | 0;
      mid = (mid + Math.imul(ah7, bl7)) | 0;
      hi = (hi + Math.imul(ah7, bh7)) | 0;
      lo = (lo + Math.imul(al6, bl8)) | 0;
      mid = (mid + Math.imul(al6, bh8)) | 0;
      mid = (mid + Math.imul(ah6, bl8)) | 0;
      hi = (hi + Math.imul(ah6, bh8)) | 0;
      lo = (lo + Math.imul(al5, bl9)) | 0;
      mid = (mid + Math.imul(al5, bh9)) | 0;
      mid = (mid + Math.imul(ah5, bl9)) | 0;
      hi = (hi + Math.imul(ah5, bh9)) | 0;
      var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
      w14 &= 0x3ffffff;
      /* k = 15 */
      lo = Math.imul(al9, bl6);
      mid = Math.imul(al9, bh6);
      mid = (mid + Math.imul(ah9, bl6)) | 0;
      hi = Math.imul(ah9, bh6);
      lo = (lo + Math.imul(al8, bl7)) | 0;
      mid = (mid + Math.imul(al8, bh7)) | 0;
      mid = (mid + Math.imul(ah8, bl7)) | 0;
      hi = (hi + Math.imul(ah8, bh7)) | 0;
      lo = (lo + Math.imul(al7, bl8)) | 0;
      mid = (mid + Math.imul(al7, bh8)) | 0;
      mid = (mid + Math.imul(ah7, bl8)) | 0;
      hi = (hi + Math.imul(ah7, bh8)) | 0;
      lo = (lo + Math.imul(al6, bl9)) | 0;
      mid = (mid + Math.imul(al6, bh9)) | 0;
      mid = (mid + Math.imul(ah6, bl9)) | 0;
      hi = (hi + Math.imul(ah6, bh9)) | 0;
      var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
      w15 &= 0x3ffffff;
      /* k = 16 */
      lo = Math.imul(al9, bl7);
      mid = Math.imul(al9, bh7);
      mid = (mid + Math.imul(ah9, bl7)) | 0;
      hi = Math.imul(ah9, bh7);
      lo = (lo + Math.imul(al8, bl8)) | 0;
      mid = (mid + Math.imul(al8, bh8)) | 0;
      mid = (mid + Math.imul(ah8, bl8)) | 0;
      hi = (hi + Math.imul(ah8, bh8)) | 0;
      lo = (lo + Math.imul(al7, bl9)) | 0;
      mid = (mid + Math.imul(al7, bh9)) | 0;
      mid = (mid + Math.imul(ah7, bl9)) | 0;
      hi = (hi + Math.imul(ah7, bh9)) | 0;
      var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
      w16 &= 0x3ffffff;
      /* k = 17 */
      lo = Math.imul(al9, bl8);
      mid = Math.imul(al9, bh8);
      mid = (mid + Math.imul(ah9, bl8)) | 0;
      hi = Math.imul(ah9, bh8);
      lo = (lo + Math.imul(al8, bl9)) | 0;
      mid = (mid + Math.imul(al8, bh9)) | 0;
      mid = (mid + Math.imul(ah8, bl9)) | 0;
      hi = (hi + Math.imul(ah8, bh9)) | 0;
      var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
      w17 &= 0x3ffffff;
      /* k = 18 */
      lo = Math.imul(al9, bl9);
      mid = Math.imul(al9, bh9);
      mid = (mid + Math.imul(ah9, bl9)) | 0;
      hi = Math.imul(ah9, bh9);
      var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
      c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
      w18 &= 0x3ffffff;
      o[0] = w0;
      o[1] = w1;
      o[2] = w2;
      o[3] = w3;
      o[4] = w4;
      o[5] = w5;
      o[6] = w6;
      o[7] = w7;
      o[8] = w8;
      o[9] = w9;
      o[10] = w10;
      o[11] = w11;
      o[12] = w12;
      o[13] = w13;
      o[14] = w14;
      o[15] = w15;
      o[16] = w16;
      o[17] = w17;
      o[18] = w18;
      if (c !== 0) {
        o[19] = c;
        out.length++;
      }
      return out;
    };
  
    // Polyfill comb
    if (!Math.imul) {
      comb10MulTo = smallMulTo;
    }
  
    function bigMulTo (self, num, out) {
      out.negative = num.negative ^ self.negative;
      out.length = self.length + num.length;
  
      var carry = 0;
      var hncarry = 0;
      for (var k = 0; k < out.length - 1; k++) {
        // Sum all words with the same `i + j = k` and accumulate `ncarry`,
        // note that ncarry could be >= 0x3ffffff
        var ncarry = hncarry;
        hncarry = 0;
        var rword = carry & 0x3ffffff;
        var maxJ = Math.min(k, num.length - 1);
        for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
          var i = k - j;
          var a = self.words[i] | 0;
          var b = num.words[j] | 0;
          var r = a * b;
  
          var lo = r & 0x3ffffff;
          ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
          lo = (lo + rword) | 0;
          rword = lo & 0x3ffffff;
          ncarry = (ncarry + (lo >>> 26)) | 0;
  
          hncarry += ncarry >>> 26;
          ncarry &= 0x3ffffff;
        }
        out.words[k] = rword;
        carry = ncarry;
        ncarry = hncarry;
      }
      if (carry !== 0) {
        out.words[k] = carry;
      } else {
        out.length--;
      }
  
      return out.strip();
    }
  
    function jumboMulTo (self, num, out) {
      var fftm = new FFTM();
      return fftm.mulp(self, num, out);
    }
  
    BN.prototype.mulTo = function mulTo (num, out) {
      var res;
      var len = this.length + num.length;
      if (this.length === 10 && num.length === 10) {
        res = comb10MulTo(this, num, out);
      } else if (len < 63) {
        res = smallMulTo(this, num, out);
      } else if (len < 1024) {
        res = bigMulTo(this, num, out);
      } else {
        res = jumboMulTo(this, num, out);
      }
  
      return res;
    };
  
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
  
    function FFTM (x, y) {
      this.x = x;
      this.y = y;
    }
  
    FFTM.prototype.makeRBT = function makeRBT (N) {
      var t = new Array(N);
      var l = BN.prototype._countBits(N) - 1;
      for (var i = 0; i < N; i++) {
        t[i] = this.revBin(i, l, N);
      }
  
      return t;
    };
  
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin (x, l, N) {
      if (x === 0 || x === N - 1) return x;
  
      var rb = 0;
      for (var i = 0; i < l; i++) {
        rb |= (x & 1) << (l - i - 1);
        x >>= 1;
      }
  
      return rb;
    };
  
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
      for (var i = 0; i < N; i++) {
        rtws[i] = rws[rbt[i]];
        itws[i] = iws[rbt[i]];
      }
    };
  
    FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
      this.permute(rbt, rws, iws, rtws, itws, N);
  
      for (var s = 1; s < N; s <<= 1) {
        var l = s << 1;
  
        var rtwdf = Math.cos(2 * Math.PI / l);
        var itwdf = Math.sin(2 * Math.PI / l);
  
        for (var p = 0; p < N; p += l) {
          var rtwdf_ = rtwdf;
          var itwdf_ = itwdf;
  
          for (var j = 0; j < s; j++) {
            var re = rtws[p + j];
            var ie = itws[p + j];
  
            var ro = rtws[p + j + s];
            var io = itws[p + j + s];
  
            var rx = rtwdf_ * ro - itwdf_ * io;
  
            io = rtwdf_ * io + itwdf_ * ro;
            ro = rx;
  
            rtws[p + j] = re + ro;
            itws[p + j] = ie + io;
  
            rtws[p + j + s] = re - ro;
            itws[p + j + s] = ie - io;
  
            /* jshint maxdepth : false */
            if (j !== l) {
              rx = rtwdf * rtwdf_ - itwdf * itwdf_;
  
              itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
              rtwdf_ = rx;
            }
          }
        }
      }
    };
  
    FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
      var N = Math.max(m, n) | 1;
      var odd = N & 1;
      var i = 0;
      for (N = N / 2 | 0; N; N = N >>> 1) {
        i++;
      }
  
      return 1 << i + 1 + odd;
    };
  
    FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
      if (N <= 1) return;
  
      for (var i = 0; i < N / 2; i++) {
        var t = rws[i];
  
        rws[i] = rws[N - i - 1];
        rws[N - i - 1] = t;
  
        t = iws[i];
  
        iws[i] = -iws[N - i - 1];
        iws[N - i - 1] = -t;
      }
    };
  
    FFTM.prototype.normalize13b = function normalize13b (ws, N) {
      var carry = 0;
      for (var i = 0; i < N / 2; i++) {
        var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
          Math.round(ws[2 * i] / N) +
          carry;
  
        ws[i] = w & 0x3ffffff;
  
        if (w < 0x4000000) {
          carry = 0;
        } else {
          carry = w / 0x4000000 | 0;
        }
      }
  
      return ws;
    };
  
    FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
      var carry = 0;
      for (var i = 0; i < len; i++) {
        carry = carry + (ws[i] | 0);
  
        rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
        rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
      }
  
      // Pad with zeroes
      for (i = 2 * len; i < N; ++i) {
        rws[i] = 0;
      }
  
      assert(carry === 0);
      assert((carry & ~0x1fff) === 0);
    };
  
    FFTM.prototype.stub = function stub (N) {
      var ph = new Array(N);
      for (var i = 0; i < N; i++) {
        ph[i] = 0;
      }
  
      return ph;
    };
  
    FFTM.prototype.mulp = function mulp (x, y, out) {
      var N = 2 * this.guessLen13b(x.length, y.length);
  
      var rbt = this.makeRBT(N);
  
      var _ = this.stub(N);
  
      var rws = new Array(N);
      var rwst = new Array(N);
      var iwst = new Array(N);
  
      var nrws = new Array(N);
      var nrwst = new Array(N);
      var niwst = new Array(N);
  
      var rmws = out.words;
      rmws.length = N;
  
      this.convert13b(x.words, x.length, rws, N);
      this.convert13b(y.words, y.length, nrws, N);
  
      this.transform(rws, _, rwst, iwst, N, rbt);
      this.transform(nrws, _, nrwst, niwst, N, rbt);
  
      for (var i = 0; i < N; i++) {
        var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
        iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
        rwst[i] = rx;
      }
  
      this.conjugate(rwst, iwst, N);
      this.transform(rwst, iwst, rmws, _, N, rbt);
      this.conjugate(rmws, _, N);
      this.normalize13b(rmws, N);
  
      out.negative = x.negative ^ y.negative;
      out.length = x.length + y.length;
      return out.strip();
    };
  
    // Multiply `this` by `num`
    BN.prototype.mul = function mul (num) {
      var out = new BN(null);
      out.words = new Array(this.length + num.length);
      return this.mulTo(num, out);
    };
  
    // Multiply employing FFT
    BN.prototype.mulf = function mulf (num) {
      var out = new BN(null);
      out.words = new Array(this.length + num.length);
      return jumboMulTo(this, num, out);
    };
  
    // In-place Multiplication
    BN.prototype.imul = function imul (num) {
      return this.clone().mulTo(num, this);
    };
  
    BN.prototype.imuln = function imuln (num) {
      assert(typeof num === 'number');
      assert(num < 0x4000000);
  
      // Carry
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = (this.words[i] | 0) * num;
        var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
        carry >>= 26;
        carry += (w / 0x4000000) | 0;
        // NOTE: lo is 27bit maximum
        carry += lo >>> 26;
        this.words[i] = lo & 0x3ffffff;
      }
  
      if (carry !== 0) {
        this.words[i] = carry;
        this.length++;
      }
  
      return this;
    };
  
    BN.prototype.muln = function muln (num) {
      return this.clone().imuln(num);
    };
  
    // `this` * `this`
    BN.prototype.sqr = function sqr () {
      return this.mul(this);
    };
  
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr () {
      return this.imul(this.clone());
    };
  
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow (num) {
      var w = toBitArray(num);
      if (w.length === 0) return new BN(1);
  
      // Skip leading zeroes
      var res = this;
      for (var i = 0; i < w.length; i++, res = res.sqr()) {
        if (w[i] !== 0) break;
      }
  
      if (++i < w.length) {
        for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
          if (w[i] === 0) continue;
  
          res = res.mul(q);
        }
      }
  
      return res;
    };
  
    // Shift-left in-place
    BN.prototype.iushln = function iushln (bits) {
      assert(typeof bits === 'number' && bits >= 0);
      var r = bits % 26;
      var s = (bits - r) / 26;
      var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
      var i;
  
      if (r !== 0) {
        var carry = 0;
  
        for (i = 0; i < this.length; i++) {
          var newCarry = this.words[i] & carryMask;
          var c = ((this.words[i] | 0) - newCarry) << r;
          this.words[i] = c | carry;
          carry = newCarry >>> (26 - r);
        }
  
        if (carry) {
          this.words[i] = carry;
          this.length++;
        }
      }
  
      if (s !== 0) {
        for (i = this.length - 1; i >= 0; i--) {
          this.words[i + s] = this.words[i];
        }
  
        for (i = 0; i < s; i++) {
          this.words[i] = 0;
        }
  
        this.length += s;
      }
  
      return this.strip();
    };
  
    BN.prototype.ishln = function ishln (bits) {
      // TODO(indutny): implement me
      assert(this.negative === 0);
      return this.iushln(bits);
    };
  
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn (bits, hint, extended) {
      assert(typeof bits === 'number' && bits >= 0);
      var h;
      if (hint) {
        h = (hint - (hint % 26)) / 26;
      } else {
        h = 0;
      }
  
      var r = bits % 26;
      var s = Math.min((bits - r) / 26, this.length);
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      var maskedWords = extended;
  
      h -= s;
      h = Math.max(0, h);
  
      // Extended mode, copy masked part
      if (maskedWords) {
        for (var i = 0; i < s; i++) {
          maskedWords.words[i] = this.words[i];
        }
        maskedWords.length = s;
      }
  
      if (s === 0) {
        // No-op, we should not move anything at all
      } else if (this.length > s) {
        this.length -= s;
        for (i = 0; i < this.length; i++) {
          this.words[i] = this.words[i + s];
        }
      } else {
        this.words[0] = 0;
        this.length = 1;
      }
  
      var carry = 0;
      for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
        var word = this.words[i] | 0;
        this.words[i] = (carry << (26 - r)) | (word >>> r);
        carry = word & mask;
      }
  
      // Push carried bits as a mask
      if (maskedWords && carry !== 0) {
        maskedWords.words[maskedWords.length++] = carry;
      }
  
      if (this.length === 0) {
        this.words[0] = 0;
        this.length = 1;
      }
  
      return this.strip();
    };
  
    BN.prototype.ishrn = function ishrn (bits, hint, extended) {
      // TODO(indutny): implement me
      assert(this.negative === 0);
      return this.iushrn(bits, hint, extended);
    };
  
    // Shift-left
    BN.prototype.shln = function shln (bits) {
      return this.clone().ishln(bits);
    };
  
    BN.prototype.ushln = function ushln (bits) {
      return this.clone().iushln(bits);
    };
  
    // Shift-right
    BN.prototype.shrn = function shrn (bits) {
      return this.clone().ishrn(bits);
    };
  
    BN.prototype.ushrn = function ushrn (bits) {
      return this.clone().iushrn(bits);
    };
  
    // Test if n bit is set
    BN.prototype.testn = function testn (bit) {
      assert(typeof bit === 'number' && bit >= 0);
      var r = bit % 26;
      var s = (bit - r) / 26;
      var q = 1 << r;
  
      // Fast case: bit is much higher than all existing words
      if (this.length <= s) return false;
  
      // Check bit and return
      var w = this.words[s];
  
      return !!(w & q);
    };
  
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn (bits) {
      assert(typeof bits === 'number' && bits >= 0);
      var r = bits % 26;
      var s = (bits - r) / 26;
  
      assert(this.negative === 0, 'imaskn works only with positive numbers');
  
      if (this.length <= s) {
        return this;
      }
  
      if (r !== 0) {
        s++;
      }
      this.length = Math.min(s, this.length);
  
      if (r !== 0) {
        var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
        this.words[this.length - 1] &= mask;
      }
  
      return this.strip();
    };
  
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn (bits) {
      return this.clone().imaskn(bits);
    };
  
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn (num) {
      assert(typeof num === 'number');
      assert(num < 0x4000000);
      if (num < 0) return this.isubn(-num);
  
      // Possible sign change
      if (this.negative !== 0) {
        if (this.length === 1 && (this.words[0] | 0) < num) {
          this.words[0] = num - (this.words[0] | 0);
          this.negative = 0;
          return this;
        }
  
        this.negative = 0;
        this.isubn(num);
        this.negative = 1;
        return this;
      }
  
      // Add without checks
      return this._iaddn(num);
    };
  
    BN.prototype._iaddn = function _iaddn (num) {
      this.words[0] += num;
  
      // Carry
      for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
        this.words[i] -= 0x4000000;
        if (i === this.length - 1) {
          this.words[i + 1] = 1;
        } else {
          this.words[i + 1]++;
        }
      }
      this.length = Math.max(this.length, i + 1);
  
      return this;
    };
  
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn (num) {
      assert(typeof num === 'number');
      assert(num < 0x4000000);
      if (num < 0) return this.iaddn(-num);
  
      if (this.negative !== 0) {
        this.negative = 0;
        this.iaddn(num);
        this.negative = 1;
        return this;
      }
  
      this.words[0] -= num;
  
      if (this.length === 1 && this.words[0] < 0) {
        this.words[0] = -this.words[0];
        this.negative = 1;
      } else {
        // Carry
        for (var i = 0; i < this.length && this.words[i] < 0; i++) {
          this.words[i] += 0x4000000;
          this.words[i + 1] -= 1;
        }
      }
  
      return this.strip();
    };
  
    BN.prototype.addn = function addn (num) {
      return this.clone().iaddn(num);
    };
  
    BN.prototype.subn = function subn (num) {
      return this.clone().isubn(num);
    };
  
    BN.prototype.iabs = function iabs () {
      this.negative = 0;
  
      return this;
    };
  
    BN.prototype.abs = function abs () {
      return this.clone().iabs();
    };
  
    BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
      var len = num.length + shift;
      var i;
  
      this._expand(len);
  
      var w;
      var carry = 0;
      for (i = 0; i < num.length; i++) {
        w = (this.words[i + shift] | 0) + carry;
        var right = (num.words[i] | 0) * mul;
        w -= right & 0x3ffffff;
        carry = (w >> 26) - ((right / 0x4000000) | 0);
        this.words[i + shift] = w & 0x3ffffff;
      }
      for (; i < this.length - shift; i++) {
        w = (this.words[i + shift] | 0) + carry;
        carry = w >> 26;
        this.words[i + shift] = w & 0x3ffffff;
      }
  
      if (carry === 0) return this.strip();
  
      // Subtraction overflow
      assert(carry === -1);
      carry = 0;
      for (i = 0; i < this.length; i++) {
        w = -(this.words[i] | 0) + carry;
        carry = w >> 26;
        this.words[i] = w & 0x3ffffff;
      }
      this.negative = 1;
  
      return this.strip();
    };
  
    BN.prototype._wordDiv = function _wordDiv (num, mode) {
      var shift = this.length - num.length;
  
      var a = this.clone();
      var b = num;
  
      // Normalize
      var bhi = b.words[b.length - 1] | 0;
      var bhiBits = this._countBits(bhi);
      shift = 26 - bhiBits;
      if (shift !== 0) {
        b = b.ushln(shift);
        a.iushln(shift);
        bhi = b.words[b.length - 1] | 0;
      }
  
      // Initialize quotient
      var m = a.length - b.length;
      var q;
  
      if (mode !== 'mod') {
        q = new BN(null);
        q.length = m + 1;
        q.words = new Array(q.length);
        for (var i = 0; i < q.length; i++) {
          q.words[i] = 0;
        }
      }
  
      var diff = a.clone()._ishlnsubmul(b, 1, m);
      if (diff.negative === 0) {
        a = diff;
        if (q) {
          q.words[m] = 1;
        }
      }
  
      for (var j = m - 1; j >= 0; j--) {
        var qj = (a.words[b.length + j] | 0) * 0x4000000 +
          (a.words[b.length + j - 1] | 0);
  
        // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
        // (0x7ffffff)
        qj = Math.min((qj / bhi) | 0, 0x3ffffff);
  
        a._ishlnsubmul(b, qj, j);
        while (a.negative !== 0) {
          qj--;
          a.negative = 0;
          a._ishlnsubmul(b, 1, j);
          if (!a.isZero()) {
            a.negative ^= 1;
          }
        }
        if (q) {
          q.words[j] = qj;
        }
      }
      if (q) {
        q.strip();
      }
      a.strip();
  
      // Denormalize
      if (mode !== 'div' && shift !== 0) {
        a.iushrn(shift);
      }
  
      return {
        div: q || null,
        mod: a
      };
    };
  
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod (num, mode, positive) {
      assert(!num.isZero());
  
      if (this.isZero()) {
        return {
          div: new BN(0),
          mod: new BN(0)
        };
      }
  
      var div, mod, res;
      if (this.negative !== 0 && num.negative === 0) {
        res = this.neg().divmod(num, mode);
  
        if (mode !== 'mod') {
          div = res.div.neg();
        }
  
        if (mode !== 'div') {
          mod = res.mod.neg();
          if (positive && mod.negative !== 0) {
            mod.iadd(num);
          }
        }
  
        return {
          div: div,
          mod: mod
        };
      }
  
      if (this.negative === 0 && num.negative !== 0) {
        res = this.divmod(num.neg(), mode);
  
        if (mode !== 'mod') {
          div = res.div.neg();
        }
  
        return {
          div: div,
          mod: res.mod
        };
      }
  
      if ((this.negative & num.negative) !== 0) {
        res = this.neg().divmod(num.neg(), mode);
  
        if (mode !== 'div') {
          mod = res.mod.neg();
          if (positive && mod.negative !== 0) {
            mod.isub(num);
          }
        }
  
        return {
          div: res.div,
          mod: mod
        };
      }
  
      // Both numbers are positive at this point
  
      // Strip both numbers to approximate shift value
      if (num.length > this.length || this.cmp(num) < 0) {
        return {
          div: new BN(0),
          mod: this
        };
      }
  
      // Very short reduction
      if (num.length === 1) {
        if (mode === 'div') {
          return {
            div: this.divn(num.words[0]),
            mod: null
          };
        }
  
        if (mode === 'mod') {
          return {
            div: null,
            mod: new BN(this.modn(num.words[0]))
          };
        }
  
        return {
          div: this.divn(num.words[0]),
          mod: new BN(this.modn(num.words[0]))
        };
      }
  
      return this._wordDiv(num, mode);
    };
  
    // Find `this` / `num`
    BN.prototype.div = function div (num) {
      return this.divmod(num, 'div', false).div;
    };
  
    // Find `this` % `num`
    BN.prototype.mod = function mod (num) {
      return this.divmod(num, 'mod', false).mod;
    };
  
    BN.prototype.umod = function umod (num) {
      return this.divmod(num, 'mod', true).mod;
    };
  
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound (num) {
      var dm = this.divmod(num);
  
      // Fast case - exact division
      if (dm.mod.isZero()) return dm.div;
  
      var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
  
      var half = num.ushrn(1);
      var r2 = num.andln(1);
      var cmp = mod.cmp(half);
  
      // Round down
      if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
  
      // Round up
      return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
  
    BN.prototype.modn = function modn (num) {
      assert(num <= 0x3ffffff);
      var p = (1 << 26) % num;
  
      var acc = 0;
      for (var i = this.length - 1; i >= 0; i--) {
        acc = (p * acc + (this.words[i] | 0)) % num;
      }
  
      return acc;
    };
  
    // In-place division by number
    BN.prototype.idivn = function idivn (num) {
      assert(num <= 0x3ffffff);
  
      var carry = 0;
      for (var i = this.length - 1; i >= 0; i--) {
        var w = (this.words[i] | 0) + carry * 0x4000000;
        this.words[i] = (w / num) | 0;
        carry = w % num;
      }
  
      return this.strip();
    };
  
    BN.prototype.divn = function divn (num) {
      return this.clone().idivn(num);
    };
  
    BN.prototype.egcd = function egcd (p) {
      assert(p.negative === 0);
      assert(!p.isZero());
  
      var x = this;
      var y = p.clone();
  
      if (x.negative !== 0) {
        x = x.umod(p);
      } else {
        x = x.clone();
      }
  
      // A * x + B * y = x
      var A = new BN(1);
      var B = new BN(0);
  
      // C * x + D * y = y
      var C = new BN(0);
      var D = new BN(1);
  
      var g = 0;
  
      while (x.isEven() && y.isEven()) {
        x.iushrn(1);
        y.iushrn(1);
        ++g;
      }
  
      var yp = y.clone();
      var xp = x.clone();
  
      while (!x.isZero()) {
        for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
        if (i > 0) {
          x.iushrn(i);
          while (i-- > 0) {
            if (A.isOdd() || B.isOdd()) {
              A.iadd(yp);
              B.isub(xp);
            }
  
            A.iushrn(1);
            B.iushrn(1);
          }
        }
  
        for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
        if (j > 0) {
          y.iushrn(j);
          while (j-- > 0) {
            if (C.isOdd() || D.isOdd()) {
              C.iadd(yp);
              D.isub(xp);
            }
  
            C.iushrn(1);
            D.iushrn(1);
          }
        }
  
        if (x.cmp(y) >= 0) {
          x.isub(y);
          A.isub(C);
          B.isub(D);
        } else {
          y.isub(x);
          C.isub(A);
          D.isub(B);
        }
      }
  
      return {
        a: C,
        b: D,
        gcd: y.iushln(g)
      };
    };
  
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp (p) {
      assert(p.negative === 0);
      assert(!p.isZero());
  
      var a = this;
      var b = p.clone();
  
      if (a.negative !== 0) {
        a = a.umod(p);
      } else {
        a = a.clone();
      }
  
      var x1 = new BN(1);
      var x2 = new BN(0);
  
      var delta = b.clone();
  
      while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
        for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
        if (i > 0) {
          a.iushrn(i);
          while (i-- > 0) {
            if (x1.isOdd()) {
              x1.iadd(delta);
            }
  
            x1.iushrn(1);
          }
        }
  
        for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
        if (j > 0) {
          b.iushrn(j);
          while (j-- > 0) {
            if (x2.isOdd()) {
              x2.iadd(delta);
            }
  
            x2.iushrn(1);
          }
        }
  
        if (a.cmp(b) >= 0) {
          a.isub(b);
          x1.isub(x2);
        } else {
          b.isub(a);
          x2.isub(x1);
        }
      }
  
      var res;
      if (a.cmpn(1) === 0) {
        res = x1;
      } else {
        res = x2;
      }
  
      if (res.cmpn(0) < 0) {
        res.iadd(p);
      }
  
      return res;
    };
  
    BN.prototype.gcd = function gcd (num) {
      if (this.isZero()) return num.abs();
      if (num.isZero()) return this.abs();
  
      var a = this.clone();
      var b = num.clone();
      a.negative = 0;
      b.negative = 0;
  
      // Remove common factor of two
      for (var shift = 0; a.isEven() && b.isEven(); shift++) {
        a.iushrn(1);
        b.iushrn(1);
      }
  
      do {
        while (a.isEven()) {
          a.iushrn(1);
        }
        while (b.isEven()) {
          b.iushrn(1);
        }
  
        var r = a.cmp(b);
        if (r < 0) {
          // Swap `a` and `b` to make `a` always bigger than `b`
          var t = a;
          a = b;
          b = t;
        } else if (r === 0 || b.cmpn(1) === 0) {
          break;
        }
  
        a.isub(b);
      } while (true);
  
      return b.iushln(shift);
    };
  
    // Invert number in the field F(num)
    BN.prototype.invm = function invm (num) {
      return this.egcd(num).a.umod(num);
    };
  
    BN.prototype.isEven = function isEven () {
      return (this.words[0] & 1) === 0;
    };
  
    BN.prototype.isOdd = function isOdd () {
      return (this.words[0] & 1) === 1;
    };
  
    // And first word and num
    BN.prototype.andln = function andln (num) {
      return this.words[0] & num;
    };
  
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn (bit) {
      assert(typeof bit === 'number');
      var r = bit % 26;
      var s = (bit - r) / 26;
      var q = 1 << r;
  
      // Fast case: bit is much higher than all existing words
      if (this.length <= s) {
        this._expand(s + 1);
        this.words[s] |= q;
        return this;
      }
  
      // Add bit and propagate, if needed
      var carry = q;
      for (var i = s; carry !== 0 && i < this.length; i++) {
        var w = this.words[i] | 0;
        w += carry;
        carry = w >>> 26;
        w &= 0x3ffffff;
        this.words[i] = w;
      }
      if (carry !== 0) {
        this.words[i] = carry;
        this.length++;
      }
      return this;
    };
  
    BN.prototype.isZero = function isZero () {
      return this.length === 1 && this.words[0] === 0;
    };
  
    BN.prototype.cmpn = function cmpn (num) {
      var negative = num < 0;
  
      if (this.negative !== 0 && !negative) return -1;
      if (this.negative === 0 && negative) return 1;
  
      this.strip();
  
      var res;
      if (this.length > 1) {
        res = 1;
      } else {
        if (negative) {
          num = -num;
        }
  
        assert(num <= 0x3ffffff, 'Number is too big');
  
        var w = this.words[0] | 0;
        res = w === num ? 0 : w < num ? -1 : 1;
      }
      if (this.negative !== 0) return -res | 0;
      return res;
    };
  
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp (num) {
      if (this.negative !== 0 && num.negative === 0) return -1;
      if (this.negative === 0 && num.negative !== 0) return 1;
  
      var res = this.ucmp(num);
      if (this.negative !== 0) return -res | 0;
      return res;
    };
  
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp (num) {
      // At this point both numbers have the same sign
      if (this.length > num.length) return 1;
      if (this.length < num.length) return -1;
  
      var res = 0;
      for (var i = this.length - 1; i >= 0; i--) {
        var a = this.words[i] | 0;
        var b = num.words[i] | 0;
  
        if (a === b) continue;
        if (a < b) {
          res = -1;
        } else if (a > b) {
          res = 1;
        }
        break;
      }
      return res;
    };
  
    BN.prototype.gtn = function gtn (num) {
      return this.cmpn(num) === 1;
    };
  
    BN.prototype.gt = function gt (num) {
      return this.cmp(num) === 1;
    };
  
    BN.prototype.gten = function gten (num) {
      return this.cmpn(num) >= 0;
    };
  
    BN.prototype.gte = function gte (num) {
      return this.cmp(num) >= 0;
    };
  
    BN.prototype.ltn = function ltn (num) {
      return this.cmpn(num) === -1;
    };
  
    BN.prototype.lt = function lt (num) {
      return this.cmp(num) === -1;
    };
  
    BN.prototype.lten = function lten (num) {
      return this.cmpn(num) <= 0;
    };
  
    BN.prototype.lte = function lte (num) {
      return this.cmp(num) <= 0;
    };
  
    BN.prototype.eqn = function eqn (num) {
      return this.cmpn(num) === 0;
    };
  
    BN.prototype.eq = function eq (num) {
      return this.cmp(num) === 0;
    };
  
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red (num) {
      return new Red(num);
    };
  
    BN.prototype.toRed = function toRed (ctx) {
      assert(!this.red, 'Already a number in reduction context');
      assert(this.negative === 0, 'red works only with positives');
      return ctx.convertTo(this)._forceRed(ctx);
    };
  
    BN.prototype.fromRed = function fromRed () {
      assert(this.red, 'fromRed works only with numbers in reduction context');
      return this.red.convertFrom(this);
    };
  
    BN.prototype._forceRed = function _forceRed (ctx) {
      this.red = ctx;
      return this;
    };
  
    BN.prototype.forceRed = function forceRed (ctx) {
      assert(!this.red, 'Already a number in reduction context');
      return this._forceRed(ctx);
    };
  
    BN.prototype.redAdd = function redAdd (num) {
      assert(this.red, 'redAdd works only with red numbers');
      return this.red.add(this, num);
    };
  
    BN.prototype.redIAdd = function redIAdd (num) {
      assert(this.red, 'redIAdd works only with red numbers');
      return this.red.iadd(this, num);
    };
  
    BN.prototype.redSub = function redSub (num) {
      assert(this.red, 'redSub works only with red numbers');
      return this.red.sub(this, num);
    };
  
    BN.prototype.redISub = function redISub (num) {
      assert(this.red, 'redISub works only with red numbers');
      return this.red.isub(this, num);
    };
  
    BN.prototype.redShl = function redShl (num) {
      assert(this.red, 'redShl works only with red numbers');
      return this.red.shl(this, num);
    };
  
    BN.prototype.redMul = function redMul (num) {
      assert(this.red, 'redMul works only with red numbers');
      this.red._verify2(this, num);
      return this.red.mul(this, num);
    };
  
    BN.prototype.redIMul = function redIMul (num) {
      assert(this.red, 'redMul works only with red numbers');
      this.red._verify2(this, num);
      return this.red.imul(this, num);
    };
  
    BN.prototype.redSqr = function redSqr () {
      assert(this.red, 'redSqr works only with red numbers');
      this.red._verify1(this);
      return this.red.sqr(this);
    };
  
    BN.prototype.redISqr = function redISqr () {
      assert(this.red, 'redISqr works only with red numbers');
      this.red._verify1(this);
      return this.red.isqr(this);
    };
  
    // Square root over p
    BN.prototype.redSqrt = function redSqrt () {
      assert(this.red, 'redSqrt works only with red numbers');
      this.red._verify1(this);
      return this.red.sqrt(this);
    };
  
    BN.prototype.redInvm = function redInvm () {
      assert(this.red, 'redInvm works only with red numbers');
      this.red._verify1(this);
      return this.red.invm(this);
    };
  
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg () {
      assert(this.red, 'redNeg works only with red numbers');
      this.red._verify1(this);
      return this.red.neg(this);
    };
  
    BN.prototype.redPow = function redPow (num) {
      assert(this.red && !num.red, 'redPow(normalNum)');
      this.red._verify1(this);
      return this.red.pow(this, num);
    };
  
    // Prime numbers with efficient reduction
    var primes = {
      k256: null,
      p224: null,
      p192: null,
      p25519: null
    };
  
    // Pseudo-Mersenne prime
    function MPrime (name, p) {
      // P = 2 ^ N - K
      this.name = name;
      this.p = new BN(p, 16);
      this.n = this.p.bitLength();
      this.k = new BN(1).iushln(this.n).isub(this.p);
  
      this.tmp = this._tmp();
    }
  
    MPrime.prototype._tmp = function _tmp () {
      var tmp = new BN(null);
      tmp.words = new Array(Math.ceil(this.n / 13));
      return tmp;
    };
  
    MPrime.prototype.ireduce = function ireduce (num) {
      // Assumes that `num` is less than `P^2`
      // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
      var r = num;
      var rlen;
  
      do {
        this.split(r, this.tmp);
        r = this.imulK(r);
        r = r.iadd(this.tmp);
        rlen = r.bitLength();
      } while (rlen > this.n);
  
      var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
      if (cmp === 0) {
        r.words[0] = 0;
        r.length = 1;
      } else if (cmp > 0) {
        r.isub(this.p);
      } else {
        r.strip();
      }
  
      return r;
    };
  
    MPrime.prototype.split = function split (input, out) {
      input.iushrn(this.n, 0, out);
    };
  
    MPrime.prototype.imulK = function imulK (num) {
      return num.imul(this.k);
    };
  
    function K256 () {
      MPrime.call(
        this,
        'k256',
        'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
  
    K256.prototype.split = function split (input, output) {
      // 256 = 9 * 26 + 22
      var mask = 0x3fffff;
  
      var outLen = Math.min(input.length, 9);
      for (var i = 0; i < outLen; i++) {
        output.words[i] = input.words[i];
      }
      output.length = outLen;
  
      if (input.length <= 9) {
        input.words[0] = 0;
        input.length = 1;
        return;
      }
  
      // Shift by 9 limbs
      var prev = input.words[9];
      output.words[output.length++] = prev & mask;
  
      for (i = 10; i < input.length; i++) {
        var next = input.words[i] | 0;
        input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
        prev = next;
      }
      prev >>>= 22;
      input.words[i - 10] = prev;
      if (prev === 0 && input.length > 10) {
        input.length -= 10;
      } else {
        input.length -= 9;
      }
    };
  
    K256.prototype.imulK = function imulK (num) {
      // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
      num.words[num.length] = 0;
      num.words[num.length + 1] = 0;
      num.length += 2;
  
      // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
      var lo = 0;
      for (var i = 0; i < num.length; i++) {
        var w = num.words[i] | 0;
        lo += w * 0x3d1;
        num.words[i] = lo & 0x3ffffff;
        lo = w * 0x40 + ((lo / 0x4000000) | 0);
      }
  
      // Fast length reduction
      if (num.words[num.length - 1] === 0) {
        num.length--;
        if (num.words[num.length - 1] === 0) {
          num.length--;
        }
      }
      return num;
    };
  
    function P224 () {
      MPrime.call(
        this,
        'p224',
        'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
  
    function P192 () {
      MPrime.call(
        this,
        'p192',
        'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
  
    function P25519 () {
      // 2 ^ 255 - 19
      MPrime.call(
        this,
        '25519',
        '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
  
    P25519.prototype.imulK = function imulK (num) {
      // K = 0x13
      var carry = 0;
      for (var i = 0; i < num.length; i++) {
        var hi = (num.words[i] | 0) * 0x13 + carry;
        var lo = hi & 0x3ffffff;
        hi >>>= 26;
  
        num.words[i] = lo;
        carry = hi;
      }
      if (carry !== 0) {
        num.words[num.length++] = carry;
      }
      return num;
    };
  
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime (name) {
      // Cached version of prime
      if (primes[name]) return primes[name];
  
      var prime;
      if (name === 'k256') {
        prime = new K256();
      } else if (name === 'p224') {
        prime = new P224();
      } else if (name === 'p192') {
        prime = new P192();
      } else if (name === 'p25519') {
        prime = new P25519();
      } else {
        throw new Error('Unknown prime ' + name);
      }
      primes[name] = prime;
  
      return prime;
    };
  
    //
    // Base reduction engine
    //
    function Red (m) {
      if (typeof m === 'string') {
        var prime = BN._prime(m);
        this.m = prime.p;
        this.prime = prime;
      } else {
        assert(m.gtn(1), 'modulus must be greater than 1');
        this.m = m;
        this.prime = null;
      }
    }
  
    Red.prototype._verify1 = function _verify1 (a) {
      assert(a.negative === 0, 'red works only with positives');
      assert(a.red, 'red works only with red numbers');
    };
  
    Red.prototype._verify2 = function _verify2 (a, b) {
      assert((a.negative | b.negative) === 0, 'red works only with positives');
      assert(a.red && a.red === b.red,
        'red works only with red numbers');
    };
  
    Red.prototype.imod = function imod (a) {
      if (this.prime) return this.prime.ireduce(a)._forceRed(this);
      return a.umod(this.m)._forceRed(this);
    };
  
    Red.prototype.neg = function neg (a) {
      if (a.isZero()) {
        return a.clone();
      }
  
      return this.m.sub(a)._forceRed(this);
    };
  
    Red.prototype.add = function add (a, b) {
      this._verify2(a, b);
  
      var res = a.add(b);
      if (res.cmp(this.m) >= 0) {
        res.isub(this.m);
      }
      return res._forceRed(this);
    };
  
    Red.prototype.iadd = function iadd (a, b) {
      this._verify2(a, b);
  
      var res = a.iadd(b);
      if (res.cmp(this.m) >= 0) {
        res.isub(this.m);
      }
      return res;
    };
  
    Red.prototype.sub = function sub (a, b) {
      this._verify2(a, b);
  
      var res = a.sub(b);
      if (res.cmpn(0) < 0) {
        res.iadd(this.m);
      }
      return res._forceRed(this);
    };
  
    Red.prototype.isub = function isub (a, b) {
      this._verify2(a, b);
  
      var res = a.isub(b);
      if (res.cmpn(0) < 0) {
        res.iadd(this.m);
      }
      return res;
    };
  
    Red.prototype.shl = function shl (a, num) {
      this._verify1(a);
      return this.imod(a.ushln(num));
    };
  
    Red.prototype.imul = function imul (a, b) {
      this._verify2(a, b);
      return this.imod(a.imul(b));
    };
  
    Red.prototype.mul = function mul (a, b) {
      this._verify2(a, b);
      return this.imod(a.mul(b));
    };
  
    Red.prototype.isqr = function isqr (a) {
      return this.imul(a, a.clone());
    };
  
    Red.prototype.sqr = function sqr (a) {
      return this.mul(a, a);
    };
  
    Red.prototype.sqrt = function sqrt (a) {
      if (a.isZero()) return a.clone();
  
      var mod3 = this.m.andln(3);
      assert(mod3 % 2 === 1);
  
      // Fast case
      if (mod3 === 3) {
        var pow = this.m.add(new BN(1)).iushrn(2);
        return this.pow(a, pow);
      }
  
      // Tonelli-Shanks algorithm (Totally unoptimized and slow)
      //
      // Find Q and S, that Q * 2 ^ S = (P - 1)
      var q = this.m.subn(1);
      var s = 0;
      while (!q.isZero() && q.andln(1) === 0) {
        s++;
        q.iushrn(1);
      }
      assert(!q.isZero());
  
      var one = new BN(1).toRed(this);
      var nOne = one.redNeg();
  
      // Find quadratic non-residue
      // NOTE: Max is such because of generalized Riemann hypothesis.
      var lpow = this.m.subn(1).iushrn(1);
      var z = this.m.bitLength();
      z = new BN(2 * z * z).toRed(this);
  
      while (this.pow(z, lpow).cmp(nOne) !== 0) {
        z.redIAdd(nOne);
      }
  
      var c = this.pow(z, q);
      var r = this.pow(a, q.addn(1).iushrn(1));
      var t = this.pow(a, q);
      var m = s;
      while (t.cmp(one) !== 0) {
        var tmp = t;
        for (var i = 0; tmp.cmp(one) !== 0; i++) {
          tmp = tmp.redSqr();
        }
        assert(i < m);
        var b = this.pow(c, new BN(1).iushln(m - i - 1));
  
        r = r.redMul(b);
        c = b.redSqr();
        t = t.redMul(c);
        m = i;
      }
  
      return r;
    };
  
    Red.prototype.invm = function invm (a) {
      var inv = a._invmp(this.m);
      if (inv.negative !== 0) {
        inv.negative = 0;
        return this.imod(inv).redNeg();
      } else {
        return this.imod(inv);
      }
    };
  
    Red.prototype.pow = function pow (a, num) {
      if (num.isZero()) return new BN(1).toRed(this);
      if (num.cmpn(1) === 0) return a.clone();
  
      var windowSize = 4;
      var wnd = new Array(1 << windowSize);
      wnd[0] = new BN(1).toRed(this);
      wnd[1] = a;
      for (var i = 2; i < wnd.length; i++) {
        wnd[i] = this.mul(wnd[i - 1], a);
      }
  
      var res = wnd[0];
      var current = 0;
      var currentLen = 0;
      var start = num.bitLength() % 26;
      if (start === 0) {
        start = 26;
      }
  
      for (i = num.length - 1; i >= 0; i--) {
        var word = num.words[i];
        for (var j = start - 1; j >= 0; j--) {
          var bit = (word >> j) & 1;
          if (res !== wnd[0]) {
            res = this.sqr(res);
          }
  
          if (bit === 0 && current === 0) {
            currentLen = 0;
            continue;
          }
  
          current <<= 1;
          current |= bit;
          currentLen++;
          if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
  
          res = this.mul(res, wnd[current]);
          currentLen = 0;
          current = 0;
        }
        start = 26;
      }
  
      return res;
    };
  
    Red.prototype.convertTo = function convertTo (num) {
      var r = num.umod(this.m);
  
      return r === num ? r.clone() : r;
    };
  
    Red.prototype.convertFrom = function convertFrom (num) {
      var res = num.clone();
      res.red = null;
      return res;
    };
  
    //
    // Montgomery method engine
    //
  
    BN.mont = function mont (num) {
      return new Mont(num);
    };
  
    function Mont (m) {
      Red.call(this, m);
  
      this.shift = this.m.bitLength();
      if (this.shift % 26 !== 0) {
        this.shift += 26 - (this.shift % 26);
      }
  
      this.r = new BN(1).iushln(this.shift);
      this.r2 = this.imod(this.r.sqr());
      this.rinv = this.r._invmp(this.m);
  
      this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
      this.minv = this.minv.umod(this.r);
      this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
  
    Mont.prototype.convertTo = function convertTo (num) {
      return this.imod(num.ushln(this.shift));
    };
  
    Mont.prototype.convertFrom = function convertFrom (num) {
      var r = this.imod(num.mul(this.rinv));
      r.red = null;
      return r;
    };
  
    Mont.prototype.imul = function imul (a, b) {
      if (a.isZero() || b.isZero()) {
        a.words[0] = 0;
        a.length = 1;
        return a;
      }
  
      var t = a.imul(b);
      var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
      var u = t.isub(c).iushrn(this.shift);
      var res = u;
  
      if (u.cmp(this.m) >= 0) {
        res = u.isub(this.m);
      } else if (u.cmpn(0) < 0) {
        res = u.iadd(this.m);
      }
  
      return res._forceRed(this);
    };
  
    Mont.prototype.mul = function mul (a, b) {
      if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
  
      var t = a.mul(b);
      var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
      var u = t.isub(c).iushrn(this.shift);
      var res = u;
      if (u.cmp(this.m) >= 0) {
        res = u.isub(this.m);
      } else if (u.cmpn(0) < 0) {
        res = u.iadd(this.m);
      }
  
      return res._forceRed(this);
    };
  
    Mont.prototype.invm = function invm (a) {
      // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
      var res = this.imod(a._invmp(this.m).mul(this.r2));
      return res._forceRed(this);
    };
  })(typeof module === 'undefined' || module, this);
  
  },{"buffer":108}],100:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = boundary
  
  function boundary (cells) {
    var i, j, k
    var n = cells.length
    var sz = 0
    for (i = 0; i < n; ++i) {
      sz += cells[i].length
    }
    var result = new Array(sz)
    var ptr = 0
    for (i = 0; i < n; ++i) {
      var c = cells[i]
      var d = c.length
      for (j = 0; j < d; ++j) {
        var b = result[ptr++] = new Array(d - 1)
        var p = 0
        for (k = 0; k < d; ++k) {
          if (k === j) {
            continue
          }
          b[p++] = c[k]
        }
        if (j & 1) {
          var tmp = b[1]
          b[1] = b[0]
          b[0] = tmp
        }
      }
    }
    return result
  }
  
  },{}],101:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = boxIntersectWrapper
  
  var pool = _dereq_('typedarray-pool')
  var sweep = _dereq_('./lib/sweep')
  var boxIntersectIter = _dereq_('./lib/intersect')
  
  function boxEmpty(d, box) {
    for(var j=0; j<d; ++j) {
      if(!(box[j] <= box[j+d])) {
        return true
      }
    }
    return false
  }
  
  //Unpack boxes into a flat typed array, remove empty boxes
  function convertBoxes(boxes, d, data, ids) {
    var ptr = 0
    var count = 0
    for(var i=0, n=boxes.length; i<n; ++i) {
      var b = boxes[i]
      if(boxEmpty(d, b)) {
        continue
      }
      for(var j=0; j<2*d; ++j) {
        data[ptr++] = b[j]
      }
      ids[count++] = i
    }
    return count
  }
  
  //Perform type conversions, check bounds
  function boxIntersect(red, blue, visit, full) {
    var n = red.length
    var m = blue.length
  
    //If either array is empty, then we can skip this whole thing
    if(n <= 0 || m <= 0) {
      return
    }
  
    //Compute dimension, if it is 0 then we skip
    var d = (red[0].length)>>>1
    if(d <= 0) {
      return
    }
  
    var retval
  
    //Convert red boxes
    var redList  = pool.mallocDouble(2*d*n)
    var redIds   = pool.mallocInt32(n)
    n = convertBoxes(red, d, redList, redIds)
  
    if(n > 0) {
      if(d === 1 && full) {
        //Special case: 1d complete
        sweep.init(n)
        retval = sweep.sweepComplete(
          d, visit, 
          0, n, redList, redIds,
          0, n, redList, redIds)
      } else {
  
        //Convert blue boxes
        var blueList = pool.mallocDouble(2*d*m)
        var blueIds  = pool.mallocInt32(m)
        m = convertBoxes(blue, d, blueList, blueIds)
  
        if(m > 0) {
          sweep.init(n+m)
  
          if(d === 1) {
            //Special case: 1d bipartite
            retval = sweep.sweepBipartite(
              d, visit, 
              0, n, redList,  redIds,
              0, m, blueList, blueIds)
          } else {
            //General case:  d>1
            retval = boxIntersectIter(
              d, visit,    full,
              n, redList,  redIds,
              m, blueList, blueIds)
          }
  
          pool.free(blueList)
          pool.free(blueIds)
        }
      }
  
      pool.free(redList)
      pool.free(redIds)
    }
  
    return retval
  }
  
  
  var RESULT
  
  function appendItem(i,j) {
    RESULT.push([i,j])
  }
  
  function intersectFullArray(x) {
    RESULT = []
    boxIntersect(x, x, appendItem, true)
    return RESULT
  }
  
  function intersectBipartiteArray(x, y) {
    RESULT = []
    boxIntersect(x, y, appendItem, false)
    return RESULT
  }
  
  //User-friendly wrapper, handle full input and no-visitor cases
  function boxIntersectWrapper(arg0, arg1, arg2) {
    var result
    switch(arguments.length) {
      case 1:
        return intersectFullArray(arg0)
      case 2:
        if(typeof arg1 === 'function') {
          return boxIntersect(arg0, arg0, arg1, true)
        } else {
          return intersectBipartiteArray(arg0, arg1)
        }
      case 3:
        return boxIntersect(arg0, arg1, arg2, false)
      default:
        throw new Error('box-intersect: Invalid arguments')
    }
  }
  },{"./lib/intersect":103,"./lib/sweep":107,"typedarray-pool":567}],102:[function(_dereq_,module,exports){
  'use strict'
  
  var DIMENSION   = 'd'
  var AXIS        = 'ax'
  var VISIT       = 'vv'
  var FLIP        = 'fp'
  
  var ELEM_SIZE   = 'es'
  
  var RED_START   = 'rs'
  var RED_END     = 're'
  var RED_BOXES   = 'rb'
  var RED_INDEX   = 'ri'
  var RED_PTR     = 'rp'
  
  var BLUE_START  = 'bs'
  var BLUE_END    = 'be'
  var BLUE_BOXES  = 'bb'
  var BLUE_INDEX  = 'bi'
  var BLUE_PTR    = 'bp'
  
  var RETVAL      = 'rv'
  
  var INNER_LABEL = 'Q'
  
  var ARGS = [
    DIMENSION,
    AXIS,
    VISIT,
    RED_START,
    RED_END,
    RED_BOXES,
    RED_INDEX,
    BLUE_START,
    BLUE_END,
    BLUE_BOXES,
    BLUE_INDEX
  ]
  
  function generateBruteForce(redMajor, flip, full) {
    var funcName = 'bruteForce' + 
      (redMajor ? 'Red' : 'Blue') + 
      (flip ? 'Flip' : '') +
      (full ? 'Full' : '')
  
    var code = ['function ', funcName, '(', ARGS.join(), '){',
      'var ', ELEM_SIZE, '=2*', DIMENSION, ';']
  
    var redLoop = 
      'for(var i=' + RED_START + ',' + RED_PTR + '=' + ELEM_SIZE + '*' + RED_START + ';' +
          'i<' + RED_END +';' +
          '++i,' + RED_PTR + '+=' + ELEM_SIZE + '){' +
          'var x0=' + RED_BOXES + '[' + AXIS + '+' + RED_PTR + '],' +
              'x1=' + RED_BOXES + '[' + AXIS + '+' + RED_PTR + '+' + DIMENSION + '],' +
              'xi=' + RED_INDEX + '[i];'
  
    var blueLoop = 
      'for(var j=' + BLUE_START + ',' + BLUE_PTR + '=' + ELEM_SIZE + '*' + BLUE_START + ';' +
          'j<' + BLUE_END + ';' +
          '++j,' + BLUE_PTR + '+=' + ELEM_SIZE + '){' +
          'var y0=' + BLUE_BOXES + '[' + AXIS + '+' + BLUE_PTR + '],' +
              (full ? 'y1=' + BLUE_BOXES + '[' + AXIS + '+' + BLUE_PTR + '+' + DIMENSION + '],' : '') +
              'yi=' + BLUE_INDEX + '[j];'
  
    if(redMajor) {
      code.push(redLoop, INNER_LABEL, ':', blueLoop)
    } else {
      code.push(blueLoop, INNER_LABEL, ':', redLoop)
    }
  
    if(full) {
      code.push('if(y1<x0||x1<y0)continue;')
    } else if(flip) {
      code.push('if(y0<=x0||x1<y0)continue;')
    } else {
      code.push('if(y0<x0||x1<y0)continue;')
    }
  
    code.push('for(var k='+AXIS+'+1;k<'+DIMENSION+';++k){'+
      'var r0='+RED_BOXES+'[k+'+RED_PTR+'],'+
          'r1='+RED_BOXES+'[k+'+DIMENSION+'+'+RED_PTR+'],'+
          'b0='+BLUE_BOXES+'[k+'+BLUE_PTR+'],'+
          'b1='+BLUE_BOXES+'[k+'+DIMENSION+'+'+BLUE_PTR+'];'+
        'if(r1<b0||b1<r0)continue ' + INNER_LABEL + ';}' +
        'var ' + RETVAL + '=' + VISIT + '(')
  
    if(flip) {
      code.push('yi,xi')
    } else {
      code.push('xi,yi')
    }
  
    code.push(');if(' + RETVAL + '!==void 0)return ' + RETVAL + ';}}}')
  
    return {
      name: funcName, 
      code: code.join('')
    }
  }
  
  function bruteForcePlanner(full) {
    var funcName = 'bruteForce' + (full ? 'Full' : 'Partial')
    var prefix = []
    var fargs = ARGS.slice()
    if(!full) {
      fargs.splice(3, 0, FLIP)
    }
  
    var code = ['function ' + funcName + '(' + fargs.join() + '){']
  
    function invoke(redMajor, flip) {
      var res = generateBruteForce(redMajor, flip, full)
      prefix.push(res.code)
      code.push('return ' + res.name + '(' + ARGS.join() + ');')
    }
  
    code.push('if(' + RED_END + '-' + RED_START + '>' +
                      BLUE_END + '-' + BLUE_START + '){')
  
    if(full) {
      invoke(true, false)
      code.push('}else{')
      invoke(false, false)
    } else {
      code.push('if(' + FLIP + '){')
      invoke(true, true)
      code.push('}else{')
      invoke(true, false)
      code.push('}}else{if(' + FLIP + '){')
      invoke(false, true)
      code.push('}else{')
      invoke(false, false)
      code.push('}')
    }
    code.push('}}return ' + funcName)
  
    var codeStr = prefix.join('') + code.join('')
    var proc = new Function(codeStr)
    return proc()
  }
  
  
  exports.partial = bruteForcePlanner(false)
  exports.full    = bruteForcePlanner(true)
  },{}],103:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = boxIntersectIter
  
  var pool = _dereq_('typedarray-pool')
  var bits = _dereq_('bit-twiddle')
  var bruteForce = _dereq_('./brute')
  var bruteForcePartial = bruteForce.partial
  var bruteForceFull = bruteForce.full
  var sweep = _dereq_('./sweep')
  var findMedian = _dereq_('./median')
  var genPartition = _dereq_('./partition')
  
  //Twiddle parameters
  var BRUTE_FORCE_CUTOFF    = 128       //Cut off for brute force search
  var SCAN_CUTOFF           = (1<<22)   //Cut off for two way scan
  var SCAN_COMPLETE_CUTOFF  = (1<<22)  
  
  //Partition functions
  var partitionInteriorContainsInterval = genPartition(
    '!(lo>=p0)&&!(p1>=hi)', 
    ['p0', 'p1'])
  
  var partitionStartEqual = genPartition(
    'lo===p0',
    ['p0'])
  
  var partitionStartLessThan = genPartition(
    'lo<p0',
    ['p0'])
  
  var partitionEndLessThanEqual = genPartition(
    'hi<=p0',
    ['p0'])
  
  var partitionContainsPoint = genPartition(
    'lo<=p0&&p0<=hi',
    ['p0'])
  
  var partitionContainsPointProper = genPartition(
    'lo<p0&&p0<=hi',
    ['p0'])
  
  //Frame size for iterative loop
  var IFRAME_SIZE = 6
  var DFRAME_SIZE = 2
  
  //Data for box statck
  var INIT_CAPACITY = 1024
  var BOX_ISTACK  = pool.mallocInt32(INIT_CAPACITY)
  var BOX_DSTACK  = pool.mallocDouble(INIT_CAPACITY)
  
  //Initialize iterative loop queue
  function iterInit(d, count) {
    var levels = (8 * bits.log2(count+1) * (d+1))|0
    var maxInts = bits.nextPow2(IFRAME_SIZE*levels)
    if(BOX_ISTACK.length < maxInts) {
      pool.free(BOX_ISTACK)
      BOX_ISTACK = pool.mallocInt32(maxInts)
    }
    var maxDoubles = bits.nextPow2(DFRAME_SIZE*levels)
    if(BOX_DSTACK.length < maxDoubles) {
      pool.free(BOX_DSTACK)
      BOX_DSTACK = pool.mallocDouble(maxDoubles)
    }
  }
  
  //Append item to queue
  function iterPush(ptr,
    axis, 
    redStart, redEnd, 
    blueStart, blueEnd, 
    state, 
    lo, hi) {
  
    var iptr = IFRAME_SIZE * ptr
    BOX_ISTACK[iptr]   = axis
    BOX_ISTACK[iptr+1] = redStart
    BOX_ISTACK[iptr+2] = redEnd
    BOX_ISTACK[iptr+3] = blueStart
    BOX_ISTACK[iptr+4] = blueEnd
    BOX_ISTACK[iptr+5] = state
  
    var dptr = DFRAME_SIZE * ptr
    BOX_DSTACK[dptr]   = lo
    BOX_DSTACK[dptr+1] = hi
  }
  
  //Special case:  Intersect single point with list of intervals
  function onePointPartial(
    d, axis, visit, flip,
    redStart, redEnd, red, redIndex,
    blueOffset, blue, blueId) {
  
    var elemSize = 2 * d
    var bluePtr  = blueOffset * elemSize
    var blueX    = blue[bluePtr + axis]
  
  red_loop:
    for(var i=redStart, redPtr=redStart*elemSize; i<redEnd; ++i, redPtr+=elemSize) {
      var r0 = red[redPtr+axis]
      var r1 = red[redPtr+axis+d]
      if(blueX < r0 || r1 < blueX) {
        continue
      }
      if(flip && blueX === r0) {
        continue
      }
      var redId = redIndex[i]
      for(var j=axis+1; j<d; ++j) {
        var r0 = red[redPtr+j]
        var r1 = red[redPtr+j+d]
        var b0 = blue[bluePtr+j]
        var b1 = blue[bluePtr+j+d]
        if(r1 < b0 || b1 < r0) {
          continue red_loop
        }
      }
      var retval
      if(flip) {
        retval = visit(blueId, redId)
      } else {
        retval = visit(redId, blueId)
      }
      if(retval !== void 0) {
        return retval
      }
    }
  }
  
  //Special case:  Intersect one point with list of intervals
  function onePointFull(
    d, axis, visit,
    redStart, redEnd, red, redIndex,
    blueOffset, blue, blueId) {
  
    var elemSize = 2 * d
    var bluePtr  = blueOffset * elemSize
    var blueX    = blue[bluePtr + axis]
  
  red_loop:
    for(var i=redStart, redPtr=redStart*elemSize; i<redEnd; ++i, redPtr+=elemSize) {
      var redId = redIndex[i]
      if(redId === blueId) {
        continue
      }
      var r0 = red[redPtr+axis]
      var r1 = red[redPtr+axis+d]
      if(blueX < r0 || r1 < blueX) {
        continue
      }
      for(var j=axis+1; j<d; ++j) {
        var r0 = red[redPtr+j]
        var r1 = red[redPtr+j+d]
        var b0 = blue[bluePtr+j]
        var b1 = blue[bluePtr+j+d]
        if(r1 < b0 || b1 < r0) {
          continue red_loop
        }
      }
      var retval = visit(redId, blueId)
      if(retval !== void 0) {
        return retval
      }
    }
  }
  
  //The main box intersection routine
  function boxIntersectIter(
    d, visit, initFull,
    xSize, xBoxes, xIndex,
    ySize, yBoxes, yIndex) {
  
    //Reserve memory for stack
    iterInit(d, xSize + ySize)
  
    var top  = 0
    var elemSize = 2 * d
    var retval
  
    iterPush(top++,
        0,
        0, xSize,
        0, ySize,
        initFull ? 16 : 0, 
        -Infinity, Infinity)
    if(!initFull) {
      iterPush(top++,
        0,
        0, ySize,
        0, xSize,
        1, 
        -Infinity, Infinity)
    }
  
    while(top > 0) {
      top  -= 1
  
      var iptr = top * IFRAME_SIZE
      var axis      = BOX_ISTACK[iptr]
      var redStart  = BOX_ISTACK[iptr+1]
      var redEnd    = BOX_ISTACK[iptr+2]
      var blueStart = BOX_ISTACK[iptr+3]
      var blueEnd   = BOX_ISTACK[iptr+4]
      var state     = BOX_ISTACK[iptr+5]
  
      var dptr = top * DFRAME_SIZE
      var lo        = BOX_DSTACK[dptr]
      var hi        = BOX_DSTACK[dptr+1]
  
      //Unpack state info
      var flip      = (state & 1)
      var full      = !!(state & 16)
  
      //Unpack indices
      var red       = xBoxes
      var redIndex  = xIndex
      var blue      = yBoxes
      var blueIndex = yIndex
      if(flip) {
        red         = yBoxes
        redIndex    = yIndex
        blue        = xBoxes
        blueIndex   = xIndex
      }
  
      if(state & 2) {
        redEnd = partitionStartLessThan(
          d, axis,
          redStart, redEnd, red, redIndex,
          hi)
        if(redStart >= redEnd) {
          continue
        }
      }
      if(state & 4) {
        redStart = partitionEndLessThanEqual(
          d, axis,
          redStart, redEnd, red, redIndex,
          lo)
        if(redStart >= redEnd) {
          continue
        }
      }
      
      var redCount  = redEnd  - redStart
      var blueCount = blueEnd - blueStart
  
      if(full) {
        if(d * redCount * (redCount + blueCount) < SCAN_COMPLETE_CUTOFF) {
          retval = sweep.scanComplete(
            d, axis, visit, 
            redStart, redEnd, red, redIndex,
            blueStart, blueEnd, blue, blueIndex)
          if(retval !== void 0) {
            return retval
          }
          continue
        }
      } else {
        if(d * Math.min(redCount, blueCount) < BRUTE_FORCE_CUTOFF) {
          //If input small, then use brute force
          retval = bruteForcePartial(
              d, axis, visit, flip,
              redStart,  redEnd,  red,  redIndex,
              blueStart, blueEnd, blue, blueIndex)
          if(retval !== void 0) {
            return retval
          }
          continue
        } else if(d * redCount * blueCount < SCAN_CUTOFF) {
          //If input medium sized, then use sweep and prune
          retval = sweep.scanBipartite(
            d, axis, visit, flip, 
            redStart, redEnd, red, redIndex,
            blueStart, blueEnd, blue, blueIndex)
          if(retval !== void 0) {
            return retval
          }
          continue
        }
      }
      
      //First, find all red intervals whose interior contains (lo,hi)
      var red0 = partitionInteriorContainsInterval(
        d, axis, 
        redStart, redEnd, red, redIndex,
        lo, hi)
  
      //Lower dimensional case
      if(redStart < red0) {
  
        if(d * (red0 - redStart) < BRUTE_FORCE_CUTOFF) {
          //Special case for small inputs: use brute force
          retval = bruteForceFull(
            d, axis+1, visit,
            redStart, red0, red, redIndex,
            blueStart, blueEnd, blue, blueIndex)
          if(retval !== void 0) {
            return retval
          }
        } else if(axis === d-2) {
          if(flip) {
            retval = sweep.sweepBipartite(
              d, visit,
              blueStart, blueEnd, blue, blueIndex,
              redStart, red0, red, redIndex)
          } else {
            retval = sweep.sweepBipartite(
              d, visit,
              redStart, red0, red, redIndex,
              blueStart, blueEnd, blue, blueIndex)
          }
          if(retval !== void 0) {
            return retval
          }
        } else {
          iterPush(top++,
            axis+1,
            redStart, red0,
            blueStart, blueEnd,
            flip,
            -Infinity, Infinity)
          iterPush(top++,
            axis+1,
            blueStart, blueEnd,
            redStart, red0,
            flip^1,
            -Infinity, Infinity)
        }
      }
  
      //Divide and conquer phase
      if(red0 < redEnd) {
  
        //Cut blue into 3 parts:
        //
        //  Points < mid point
        //  Points = mid point
        //  Points > mid point
        //
        var blue0 = findMedian(
          d, axis, 
          blueStart, blueEnd, blue, blueIndex)
        var mid = blue[elemSize * blue0 + axis]
        var blue1 = partitionStartEqual(
          d, axis,
          blue0, blueEnd, blue, blueIndex,
          mid)
  
        //Right case
        if(blue1 < blueEnd) {
          iterPush(top++,
            axis,
            red0, redEnd,
            blue1, blueEnd,
            (flip|4) + (full ? 16 : 0),
            mid, hi)
        }
  
        //Left case
        if(blueStart < blue0) {
          iterPush(top++,
            axis,
            red0, redEnd,
            blueStart, blue0,
            (flip|2) + (full ? 16 : 0),
            lo, mid)
        }
  
        //Center case (the hard part)
        if(blue0 + 1 === blue1) {
          //Optimization: Range with exactly 1 point, use a brute force scan
          if(full) {
            retval = onePointFull(
              d, axis, visit,
              red0, redEnd, red, redIndex,
              blue0, blue, blueIndex[blue0])
          } else {
            retval = onePointPartial(
              d, axis, visit, flip,
              red0, redEnd, red, redIndex,
              blue0, blue, blueIndex[blue0])
          }
          if(retval !== void 0) {
            return retval
          }
        } else if(blue0 < blue1) {
          var red1
          if(full) {
            //If full intersection, need to handle special case
            red1 = partitionContainsPoint(
              d, axis,
              red0, redEnd, red, redIndex,
              mid)
            if(red0 < red1) {
              var redX = partitionStartEqual(
                d, axis,
                red0, red1, red, redIndex,
                mid)
              if(axis === d-2) {
                //Degenerate sweep intersection:
                //  [red0, redX] with [blue0, blue1]
                if(red0 < redX) {
                  retval = sweep.sweepComplete(
                    d, visit,
                    red0, redX, red, redIndex,
                    blue0, blue1, blue, blueIndex)
                  if(retval !== void 0) {
                    return retval
                  }
                }
  
                //Normal sweep intersection:
                //  [redX, red1] with [blue0, blue1]
                if(redX < red1) {
                  retval = sweep.sweepBipartite(
                    d, visit,
                    redX, red1, red, redIndex,
                    blue0, blue1, blue, blueIndex)
                  if(retval !== void 0) {
                    return retval
                  }
                }
              } else {
                if(red0 < redX) {
                  iterPush(top++,
                    axis+1,
                    red0, redX,
                    blue0, blue1,
                    16,
                    -Infinity, Infinity)
                }
                if(redX < red1) {
                  iterPush(top++,
                    axis+1,
                    redX, red1,
                    blue0, blue1,
                    0,
                    -Infinity, Infinity)
                  iterPush(top++,
                    axis+1,
                    blue0, blue1,
                    redX, red1,
                    1,
                    -Infinity, Infinity)
                }
              }
            }
          } else {
            if(flip) {
              red1 = partitionContainsPointProper(
                d, axis,
                red0, redEnd, red, redIndex,
                mid)
            } else {
              red1 = partitionContainsPoint(
                d, axis,
                red0, redEnd, red, redIndex,
                mid)
            }
            if(red0 < red1) {
              if(axis === d-2) {
                if(flip) {
                  retval = sweep.sweepBipartite(
                    d, visit,
                    blue0, blue1, blue, blueIndex,
                    red0, red1, red, redIndex)
                } else {
                  retval = sweep.sweepBipartite(
                    d, visit,
                    red0, red1, red, redIndex,
                    blue0, blue1, blue, blueIndex)
                }
              } else {
                iterPush(top++,
                  axis+1,
                  red0, red1,
                  blue0, blue1,
                  flip,
                  -Infinity, Infinity)
                iterPush(top++,
                  axis+1,
                  blue0, blue1,
                  red0, red1,
                  flip^1,
                  -Infinity, Infinity)
              }
            }
          }
        }
      }
    }
  }
  },{"./brute":102,"./median":104,"./partition":105,"./sweep":107,"bit-twiddle":97,"typedarray-pool":567}],104:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = findMedian
  
  var genPartition = _dereq_('./partition')
  
  var partitionStartLessThan = genPartition('lo<p0', ['p0'])
  
  var PARTITION_THRESHOLD = 8   //Cut off for using insertion sort in findMedian
  
  //Base case for median finding:  Use insertion sort
  function insertionSort(d, axis, start, end, boxes, ids) {
    var elemSize = 2 * d
    var boxPtr = elemSize * (start+1) + axis
    for(var i=start+1; i<end; ++i, boxPtr+=elemSize) {
      var x = boxes[boxPtr]
      for(var j=i, ptr=elemSize*(i-1); 
          j>start && boxes[ptr+axis] > x; 
          --j, ptr-=elemSize) {
        //Swap
        var aPtr = ptr
        var bPtr = ptr+elemSize
        for(var k=0; k<elemSize; ++k, ++aPtr, ++bPtr) {
          var y = boxes[aPtr]
          boxes[aPtr] = boxes[bPtr]
          boxes[bPtr] = y
        }
        var tmp = ids[j]
        ids[j] = ids[j-1]
        ids[j-1] = tmp
      }
    }
  }
  
  //Find median using quick select algorithm
  //  takes O(n) time with high probability
  function findMedian(d, axis, start, end, boxes, ids) {
    if(end <= start+1) {
      return start
    }
  
    var lo       = start
    var hi       = end
    var mid      = ((end + start) >>> 1)
    var elemSize = 2*d
    var pivot    = mid
    var value    = boxes[elemSize*mid+axis]
    
    while(lo < hi) {
      if(hi - lo < PARTITION_THRESHOLD) {
        insertionSort(d, axis, lo, hi, boxes, ids)
        value = boxes[elemSize*mid+axis]
        break
      }
      
      //Select pivot using median-of-3
      var count  = hi - lo
      var pivot0 = (Math.random()*count+lo)|0
      var value0 = boxes[elemSize*pivot0 + axis]
      var pivot1 = (Math.random()*count+lo)|0
      var value1 = boxes[elemSize*pivot1 + axis]
      var pivot2 = (Math.random()*count+lo)|0
      var value2 = boxes[elemSize*pivot2 + axis]
      if(value0 <= value1) {
        if(value2 >= value1) {
          pivot = pivot1
          value = value1
        } else if(value0 >= value2) {
          pivot = pivot0
          value = value0
        } else {
          pivot = pivot2
          value = value2
        }
      } else {
        if(value1 >= value2) {
          pivot = pivot1
          value = value1
        } else if(value2 >= value0) {
          pivot = pivot0
          value = value0
        } else {
          pivot = pivot2
          value = value2
        }
      }
  
      //Swap pivot to end of array
      var aPtr = elemSize * (hi-1)
      var bPtr = elemSize * pivot
      for(var i=0; i<elemSize; ++i, ++aPtr, ++bPtr) {
        var x = boxes[aPtr]
        boxes[aPtr] = boxes[bPtr]
        boxes[bPtr] = x
      }
      var y = ids[hi-1]
      ids[hi-1] = ids[pivot]
      ids[pivot] = y
  
      //Partition using pivot
      pivot = partitionStartLessThan(
        d, axis, 
        lo, hi-1, boxes, ids,
        value)
  
      //Swap pivot back
      var aPtr = elemSize * (hi-1)
      var bPtr = elemSize * pivot
      for(var i=0; i<elemSize; ++i, ++aPtr, ++bPtr) {
        var x = boxes[aPtr]
        boxes[aPtr] = boxes[bPtr]
        boxes[bPtr] = x
      }
      var y = ids[hi-1]
      ids[hi-1] = ids[pivot]
      ids[pivot] = y
  
      //Swap pivot to last pivot
      if(mid < pivot) {
        hi = pivot-1
        while(lo < hi && 
          boxes[elemSize*(hi-1)+axis] === value) {
          hi -= 1
        }
        hi += 1
      } else if(pivot < mid) {
        lo = pivot + 1
        while(lo < hi &&
          boxes[elemSize*lo+axis] === value) {
          lo += 1
        }
      } else {
        break
      }
    }
  
    //Make sure pivot is at start
    return partitionStartLessThan(
      d, axis, 
      start, mid, boxes, ids,
      boxes[elemSize*mid+axis])
  }
  },{"./partition":105}],105:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = genPartition
  
  var code = 'for(var j=2*a,k=j*c,l=k,m=c,n=b,o=a+b,p=c;d>p;++p,k+=j){var _;if($)if(m===p)m+=1,l+=j;else{for(var s=0;j>s;++s){var t=e[k+s];e[k+s]=e[l],e[l++]=t}var u=f[p];f[p]=f[m],f[m++]=u}}return m'
  
  function genPartition(predicate, args) {
    var fargs ='abcdef'.split('').concat(args)
    var reads = []
    if(predicate.indexOf('lo') >= 0) {
      reads.push('lo=e[k+n]')
    }
    if(predicate.indexOf('hi') >= 0) {
      reads.push('hi=e[k+o]')
    }
    fargs.push(
      code.replace('_', reads.join())
          .replace('$', predicate))
    return Function.apply(void 0, fargs)
  }
  },{}],106:[function(_dereq_,module,exports){
  'use strict';
  
  //This code is extracted from ndarray-sort
  //It is inlined here as a temporary workaround
  
  module.exports = wrapper;
  
  var INSERT_SORT_CUTOFF = 32
  
  function wrapper(data, n0) {
    if (n0 <= 4*INSERT_SORT_CUTOFF) {
      insertionSort(0, n0 - 1, data);
    } else {
      quickSort(0, n0 - 1, data);
    }
  }
  
  function insertionSort(left, right, data) {
    var ptr = 2*(left+1)
    for(var i=left+1; i<=right; ++i) {
      var a = data[ptr++]
      var b = data[ptr++]
      var j = i
      var jptr = ptr-2
      while(j-- > left) {
        var x = data[jptr-2]
        var y = data[jptr-1]
        if(x < a) {
          break
        } else if(x === a && y < b) {
          break
        }
        data[jptr]   = x
        data[jptr+1] = y
        jptr -= 2
      }
      data[jptr]   = a
      data[jptr+1] = b
    }
  }
  
  function swap(i, j, data) {
    i *= 2
    j *= 2
    var x = data[i]
    var y = data[i+1]
    data[i] = data[j]
    data[i+1] = data[j+1]
    data[j] = x
    data[j+1] = y
  }
  
  function move(i, j, data) {
    i *= 2
    j *= 2
    data[i] = data[j]
    data[i+1] = data[j+1]
  }
  
  function rotate(i, j, k, data) {
    i *= 2
    j *= 2
    k *= 2
    var x = data[i]
    var y = data[i+1]
    data[i] = data[j]
    data[i+1] = data[j+1]
    data[j] = data[k]
    data[j+1] = data[k+1]
    data[k] = x
    data[k+1] = y
  }
  
  function shufflePivot(i, j, px, py, data) {
    i *= 2
    j *= 2
    data[i] = data[j]
    data[j] = px
    data[i+1] = data[j+1]
    data[j+1] = py
  }
  
  function compare(i, j, data) {
    i *= 2
    j *= 2
    var x = data[i],
        y = data[j]
    if(x < y) {
      return false
    } else if(x === y) {
      return data[i+1] > data[j+1]
    }
    return true
  }
  
  function comparePivot(i, y, b, data) {
    i *= 2
    var x = data[i]
    if(x < y) {
      return true
    } else if(x === y) {
      return data[i+1] < b
    }
    return false
  }
  
  function quickSort(left, right, data) {
    var sixth = (right - left + 1) / 6 | 0, 
        index1 = left + sixth, 
        index5 = right - sixth, 
        index3 = left + right >> 1, 
        index2 = index3 - sixth, 
        index4 = index3 + sixth, 
        el1 = index1, 
        el2 = index2, 
        el3 = index3, 
        el4 = index4, 
        el5 = index5, 
        less = left + 1, 
        great = right - 1, 
        tmp = 0
    if(compare(el1, el2, data)) {
      tmp = el1
      el1 = el2
      el2 = tmp
    }
    if(compare(el4, el5, data)) {
      tmp = el4
      el4 = el5
      el5 = tmp
    }
    if(compare(el1, el3, data)) {
      tmp = el1
      el1 = el3
      el3 = tmp
    }
    if(compare(el2, el3, data)) {
      tmp = el2
      el2 = el3
      el3 = tmp
    }
    if(compare(el1, el4, data)) {
      tmp = el1
      el1 = el4
      el4 = tmp
    }
    if(compare(el3, el4, data)) {
      tmp = el3
      el3 = el4
      el4 = tmp
    }
    if(compare(el2, el5, data)) {
      tmp = el2
      el2 = el5
      el5 = tmp
    }
    if(compare(el2, el3, data)) {
      tmp = el2
      el2 = el3
      el3 = tmp
    }
    if(compare(el4, el5, data)) {
      tmp = el4
      el4 = el5
      el5 = tmp
    }
  
    var pivot1X = data[2*el2]
    var pivot1Y = data[2*el2+1]
    var pivot2X = data[2*el4]
    var pivot2Y = data[2*el4+1]
  
    var ptr0 = 2 * el1;
    var ptr2 = 2 * el3;
    var ptr4 = 2 * el5;
    var ptr5 = 2 * index1;
    var ptr6 = 2 * index3;
    var ptr7 = 2 * index5;
    for (var i1 = 0; i1 < 2; ++i1) {
      var x = data[ptr0+i1];
      var y = data[ptr2+i1];
      var z = data[ptr4+i1];
      data[ptr5+i1] = x;
      data[ptr6+i1] = y;
      data[ptr7+i1] = z;
    }
  
    move(index2, left, data)
    move(index4, right, data)
    for (var k = less; k <= great; ++k) {
      if (comparePivot(k, pivot1X, pivot1Y, data)) {
        if (k !== less) {
          swap(k, less, data)
        }
        ++less;
      } else {
        if (!comparePivot(k, pivot2X, pivot2Y, data)) {
          while (true) {
            if (!comparePivot(great, pivot2X, pivot2Y, data)) {
              if (--great < k) {
                break;
              }
              continue;
            } else {
              if (comparePivot(great, pivot1X, pivot1Y, data)) {
                rotate(k, less, great, data)
                ++less;
                --great;
              } else {
                swap(k, great, data)
                --great;
              }
              break;
            }
          }
        }
      }
    }
    shufflePivot(left, less-1, pivot1X, pivot1Y, data)
    shufflePivot(right, great+1, pivot2X, pivot2Y, data)
    if (less - 2 - left <= INSERT_SORT_CUTOFF) {
      insertionSort(left, less - 2, data);
    } else {
      quickSort(left, less - 2, data);
    }
    if (right - (great + 2) <= INSERT_SORT_CUTOFF) {
      insertionSort(great + 2, right, data);
    } else {
      quickSort(great + 2, right, data);
    }
    if (great - less <= INSERT_SORT_CUTOFF) {
      insertionSort(less, great, data);
    } else {
      quickSort(less, great, data);
    }
  }
  },{}],107:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = {
    init:           sqInit,
    sweepBipartite: sweepBipartite,
    sweepComplete:  sweepComplete,
    scanBipartite:  scanBipartite,
    scanComplete:   scanComplete
  }
  
  var pool  = _dereq_('typedarray-pool')
  var bits  = _dereq_('bit-twiddle')
  var isort = _dereq_('./sort')
  
  //Flag for blue
  var BLUE_FLAG = (1<<28)
  
  //1D sweep event queue stuff (use pool to save space)
  var INIT_CAPACITY      = 1024
  var RED_SWEEP_QUEUE    = pool.mallocInt32(INIT_CAPACITY)
  var RED_SWEEP_INDEX    = pool.mallocInt32(INIT_CAPACITY)
  var BLUE_SWEEP_QUEUE   = pool.mallocInt32(INIT_CAPACITY)
  var BLUE_SWEEP_INDEX   = pool.mallocInt32(INIT_CAPACITY)
  var COMMON_SWEEP_QUEUE = pool.mallocInt32(INIT_CAPACITY)
  var COMMON_SWEEP_INDEX = pool.mallocInt32(INIT_CAPACITY)
  var SWEEP_EVENTS       = pool.mallocDouble(INIT_CAPACITY * 8)
  
  //Reserves memory for the 1D sweep data structures
  function sqInit(count) {
    var rcount = bits.nextPow2(count)
    if(RED_SWEEP_QUEUE.length < rcount) {
      pool.free(RED_SWEEP_QUEUE)
      RED_SWEEP_QUEUE = pool.mallocInt32(rcount)
    }
    if(RED_SWEEP_INDEX.length < rcount) {
      pool.free(RED_SWEEP_INDEX)
      RED_SWEEP_INDEX = pool.mallocInt32(rcount)
    }
    if(BLUE_SWEEP_QUEUE.length < rcount) {
      pool.free(BLUE_SWEEP_QUEUE)
      BLUE_SWEEP_QUEUE = pool.mallocInt32(rcount)
    }
    if(BLUE_SWEEP_INDEX.length < rcount) {
      pool.free(BLUE_SWEEP_INDEX)
      BLUE_SWEEP_INDEX = pool.mallocInt32(rcount)
    }
    if(COMMON_SWEEP_QUEUE.length < rcount) {
      pool.free(COMMON_SWEEP_QUEUE)
      COMMON_SWEEP_QUEUE = pool.mallocInt32(rcount)
    }
    if(COMMON_SWEEP_INDEX.length < rcount) {
      pool.free(COMMON_SWEEP_INDEX)
      COMMON_SWEEP_INDEX = pool.mallocInt32(rcount)
    }
    var eventLength = 8 * rcount
    if(SWEEP_EVENTS.length < eventLength) {
      pool.free(SWEEP_EVENTS)
      SWEEP_EVENTS = pool.mallocDouble(eventLength)
    }
  }
  
  //Remove an item from the active queue in O(1)
  function sqPop(queue, index, count, item) {
    var idx = index[item]
    var top = queue[count-1]
    queue[idx] = top
    index[top] = idx
  }
  
  //Insert an item into the active queue in O(1)
  function sqPush(queue, index, count, item) {
    queue[count] = item
    index[item]  = count
  }
  
  //Recursion base case: use 1D sweep algorithm
  function sweepBipartite(
      d, visit,
      redStart,  redEnd, red, redIndex,
      blueStart, blueEnd, blue, blueIndex) {
  
    //store events as pairs [coordinate, idx]
    //
    //  red create:  -(idx+1)
    //  red destroy: idx
    //  blue create: -(idx+BLUE_FLAG)
    //  blue destroy: idx+BLUE_FLAG
    //
    var ptr      = 0
    var elemSize = 2*d
    var istart   = d-1
    var iend     = elemSize-1
  
    for(var i=redStart; i<redEnd; ++i) {
      var idx = redIndex[i]
      var redOffset = elemSize*i
      SWEEP_EVENTS[ptr++] = red[redOffset+istart]
      SWEEP_EVENTS[ptr++] = -(idx+1)
      SWEEP_EVENTS[ptr++] = red[redOffset+iend]
      SWEEP_EVENTS[ptr++] = idx
    }
  
    for(var i=blueStart; i<blueEnd; ++i) {
      var idx = blueIndex[i]+BLUE_FLAG
      var blueOffset = elemSize*i
      SWEEP_EVENTS[ptr++] = blue[blueOffset+istart]
      SWEEP_EVENTS[ptr++] = -idx
      SWEEP_EVENTS[ptr++] = blue[blueOffset+iend]
      SWEEP_EVENTS[ptr++] = idx
    }
  
    //process events from left->right
    var n = ptr >>> 1
    isort(SWEEP_EVENTS, n)
    
    var redActive  = 0
    var blueActive = 0
    for(var i=0; i<n; ++i) {
      var e = SWEEP_EVENTS[2*i+1]|0
      if(e >= BLUE_FLAG) {
        //blue destroy event
        e = (e-BLUE_FLAG)|0
        sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, e)
      } else if(e >= 0) {
        //red destroy event
        sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e)
      } else if(e <= -BLUE_FLAG) {
        //blue create event
        e = (-e-BLUE_FLAG)|0
        for(var j=0; j<redActive; ++j) {
          var retval = visit(RED_SWEEP_QUEUE[j], e)
          if(retval !== void 0) {
            return retval
          }
        }
        sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, e)
      } else {
        //red create event
        e = (-e-1)|0
        for(var j=0; j<blueActive; ++j) {
          var retval = visit(e, BLUE_SWEEP_QUEUE[j])
          if(retval !== void 0) {
            return retval
          }
        }
        sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, e)
      }
    }
  }
  
  //Complete sweep
  function sweepComplete(d, visit, 
    redStart, redEnd, red, redIndex,
    blueStart, blueEnd, blue, blueIndex) {
  
    var ptr      = 0
    var elemSize = 2*d
    var istart   = d-1
    var iend     = elemSize-1
  
    for(var i=redStart; i<redEnd; ++i) {
      var idx = (redIndex[i]+1)<<1
      var redOffset = elemSize*i
      SWEEP_EVENTS[ptr++] = red[redOffset+istart]
      SWEEP_EVENTS[ptr++] = -idx
      SWEEP_EVENTS[ptr++] = red[redOffset+iend]
      SWEEP_EVENTS[ptr++] = idx
    }
  
    for(var i=blueStart; i<blueEnd; ++i) {
      var idx = (blueIndex[i]+1)<<1
      var blueOffset = elemSize*i
      SWEEP_EVENTS[ptr++] = blue[blueOffset+istart]
      SWEEP_EVENTS[ptr++] = (-idx)|1
      SWEEP_EVENTS[ptr++] = blue[blueOffset+iend]
      SWEEP_EVENTS[ptr++] = idx|1
    }
  
    //process events from left->right
    var n = ptr >>> 1
    isort(SWEEP_EVENTS, n)
    
    var redActive    = 0
    var blueActive   = 0
    var commonActive = 0
    for(var i=0; i<n; ++i) {
      var e     = SWEEP_EVENTS[2*i+1]|0
      var color = e&1
      if(i < n-1 && (e>>1) === (SWEEP_EVENTS[2*i+3]>>1)) {
        color = 2
        i += 1
      }
      
      if(e < 0) {
        //Create event
        var id = -(e>>1) - 1
  
        //Intersect with common
        for(var j=0; j<commonActive; ++j) {
          var retval = visit(COMMON_SWEEP_QUEUE[j], id)
          if(retval !== void 0) {
            return retval
          }
        }
  
        if(color !== 0) {
          //Intersect with red
          for(var j=0; j<redActive; ++j) {
            var retval = visit(RED_SWEEP_QUEUE[j], id)
            if(retval !== void 0) {
              return retval
            }
          }
        }
  
        if(color !== 1) {
          //Intersect with blue
          for(var j=0; j<blueActive; ++j) {
            var retval = visit(BLUE_SWEEP_QUEUE[j], id)
            if(retval !== void 0) {
              return retval
            }
          }
        }
  
        if(color === 0) {
          //Red
          sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, id)
        } else if(color === 1) {
          //Blue
          sqPush(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive++, id)
        } else if(color === 2) {
          //Both
          sqPush(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive++, id)
        }
      } else {
        //Destroy event
        var id = (e>>1) - 1
        if(color === 0) {
          //Red
          sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, id)
        } else if(color === 1) {
          //Blue
          sqPop(BLUE_SWEEP_QUEUE, BLUE_SWEEP_INDEX, blueActive--, id)
        } else if(color === 2) {
          //Both
          sqPop(COMMON_SWEEP_QUEUE, COMMON_SWEEP_INDEX, commonActive--, id)
        }
      }
    }
  }
  
  //Sweep and prune/scanline algorithm:
  //  Scan along axis, detect intersections
  //  Brute force all boxes along axis
  function scanBipartite(
    d, axis, visit, flip,
    redStart,  redEnd, red, redIndex,
    blueStart, blueEnd, blue, blueIndex) {
    
    var ptr      = 0
    var elemSize = 2*d
    var istart   = axis
    var iend     = axis+d
  
    var redShift  = 1
    var blueShift = 1
    if(flip) {
      blueShift = BLUE_FLAG
    } else {
      redShift  = BLUE_FLAG
    }
  
    for(var i=redStart; i<redEnd; ++i) {
      var idx = i + redShift
      var redOffset = elemSize*i
      SWEEP_EVENTS[ptr++] = red[redOffset+istart]
      SWEEP_EVENTS[ptr++] = -idx
      SWEEP_EVENTS[ptr++] = red[redOffset+iend]
      SWEEP_EVENTS[ptr++] = idx
    }
    for(var i=blueStart; i<blueEnd; ++i) {
      var idx = i + blueShift
      var blueOffset = elemSize*i
      SWEEP_EVENTS[ptr++] = blue[blueOffset+istart]
      SWEEP_EVENTS[ptr++] = -idx
    }
  
    //process events from left->right
    var n = ptr >>> 1
    isort(SWEEP_EVENTS, n)
    
    var redActive    = 0
    for(var i=0; i<n; ++i) {
      var e = SWEEP_EVENTS[2*i+1]|0
      if(e < 0) {
        var idx   = -e
        var isRed = false
        if(idx >= BLUE_FLAG) {
          isRed = !flip
          idx -= BLUE_FLAG 
        } else {
          isRed = !!flip
          idx -= 1
        }
        if(isRed) {
          sqPush(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive++, idx)
        } else {
          var blueId  = blueIndex[idx]
          var bluePtr = elemSize * idx
          
          var b0 = blue[bluePtr+axis+1]
          var b1 = blue[bluePtr+axis+1+d]
  
  red_loop:
          for(var j=0; j<redActive; ++j) {
            var oidx   = RED_SWEEP_QUEUE[j]
            var redPtr = elemSize * oidx
  
            if(b1 < red[redPtr+axis+1] || 
               red[redPtr+axis+1+d] < b0) {
              continue
            }
  
            for(var k=axis+2; k<d; ++k) {
              if(blue[bluePtr + k + d] < red[redPtr + k] || 
                 red[redPtr + k + d] < blue[bluePtr + k]) {
                continue red_loop
              }
            }
  
            var redId  = redIndex[oidx]
            var retval
            if(flip) {
              retval = visit(blueId, redId)
            } else {
              retval = visit(redId, blueId)
            }
            if(retval !== void 0) {
              return retval 
            }
          }
        }
      } else {
        sqPop(RED_SWEEP_QUEUE, RED_SWEEP_INDEX, redActive--, e - redShift)
      }
    }
  }
  
  function scanComplete(
    d, axis, visit,
    redStart,  redEnd, red, redIndex,
    blueStart, blueEnd, blue, blueIndex) {
  
    var ptr      = 0
    var elemSize = 2*d
    var istart   = axis
    var iend     = axis+d
  
    for(var i=redStart; i<redEnd; ++i) {
      var idx = i + BLUE_FLAG
      var redOffset = elemSize*i
      SWEEP_EVENTS[ptr++] = red[redOffset+istart]
      SWEEP_EVENTS[ptr++] = -idx
      SWEEP_EVENTS[ptr++] = red[redOffset+iend]
      SWEEP_EVENTS[ptr++] = idx
    }
    for(var i=blueStart; i<blueEnd; ++i) {
      var idx = i + 1
      var blueOffset = elemSize*i
      SWEEP_EVENTS[ptr++] = blue[blueOffset+istart]
      SWEEP_EVENTS[ptr++] = -idx
    }
  
    //process events from left->right
    var n = ptr >>> 1
    isort(SWEEP_EVENTS, n)
    
    var redActive    = 0
    for(var i=0; i<n; ++i) {
      var e = SWEEP_EVENTS[2*i+1]|0
      if(e < 0) {
        var idx   = -e
        if(idx >= BLUE_FLAG) {
          RED_SWEEP_QUEUE[redActive++] = idx - BLUE_FLAG
        } else {
          idx -= 1
          var blueId  = blueIndex[idx]
          var bluePtr = elemSize * idx
  
          var b0 = blue[bluePtr+axis+1]
          var b1 = blue[bluePtr+axis+1+d]
  
  red_loop:
          for(var j=0; j<redActive; ++j) {
            var oidx   = RED_SWEEP_QUEUE[j]
            var redId  = redIndex[oidx]
  
            if(redId === blueId) {
              break
            }
  
            var redPtr = elemSize * oidx
            if(b1 < red[redPtr+axis+1] || 
              red[redPtr+axis+1+d] < b0) {
              continue
            }
            for(var k=axis+2; k<d; ++k) {
              if(blue[bluePtr + k + d] < red[redPtr + k] || 
                 red[redPtr + k + d]   < blue[bluePtr + k]) {
                continue red_loop
              }
            }
  
            var retval = visit(redId, blueId)
            if(retval !== void 0) {
              return retval 
            }
          }
        }
      } else {
        var idx = e - BLUE_FLAG
        for(var j=redActive-1; j>=0; --j) {
          if(RED_SWEEP_QUEUE[j] === idx) {
            for(var k=j+1; k<redActive; ++k) {
              RED_SWEEP_QUEUE[k-1] = RED_SWEEP_QUEUE[k]
            }
            break
          }
        }
        --redActive
      }
    }
  }
  },{"./sort":106,"bit-twiddle":97,"typedarray-pool":567}],108:[function(_dereq_,module,exports){
  
  },{}],109:[function(_dereq_,module,exports){
  arguments[4][108][0].apply(exports,arguments)
  },{"dup":108}],110:[function(_dereq_,module,exports){
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
  var objectCreate = Object.create || objectCreatePolyfill
  var objectKeys = Object.keys || objectKeysPolyfill
  var bind = Function.prototype.bind || functionBindPolyfill
  
  function EventEmitter() {
    if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
      this._events = objectCreate(null);
      this._eventsCount = 0;
    }
  
    this._maxListeners = this._maxListeners || undefined;
  }
  module.exports = EventEmitter;
  
  // Backwards-compat with node 0.10.x
  EventEmitter.EventEmitter = EventEmitter;
  
  EventEmitter.prototype._events = undefined;
  EventEmitter.prototype._maxListeners = undefined;
  
  // By default EventEmitters will print a warning if more than 10 listeners are
  // added to it. This is a useful default which helps finding memory leaks.
  var defaultMaxListeners = 10;
  
  var hasDefineProperty;
  try {
    var o = {};
    if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
    hasDefineProperty = o.x === 0;
  } catch (err) { hasDefineProperty = false }
  if (hasDefineProperty) {
    Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
      enumerable: true,
      get: function() {
        return defaultMaxListeners;
      },
      set: function(arg) {
        // check whether the input is a positive number (whose value is zero or
        // greater and not a NaN).
        if (typeof arg !== 'number' || arg < 0 || arg !== arg)
          throw new TypeError('"defaultMaxListeners" must be a positive number');
        defaultMaxListeners = arg;
      }
    });
  } else {
    EventEmitter.defaultMaxListeners = defaultMaxListeners;
  }
  
  // Obviously not all Emitters should be limited to 10. This function allows
  // that to be increased. Set to zero for unlimited.
  EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || isNaN(n))
      throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
  };
  
  function $getMaxListeners(that) {
    if (that._maxListeners === undefined)
      return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
  }
  
  EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $getMaxListeners(this);
  };
  
  // These standalone emit* functions are used to optimize calling of event
  // handlers for fast cases because emit() itself often has a variable number of
  // arguments and can be deoptimized because of that. These functions always have
  // the same number of arguments and thus do not get deoptimized, so the code
  // inside them can execute faster.
  function emitNone(handler, isFn, self) {
    if (isFn)
      handler.call(self);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self);
    }
  }
  function emitOne(handler, isFn, self, arg1) {
    if (isFn)
      handler.call(self, arg1);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self, arg1);
    }
  }
  function emitTwo(handler, isFn, self, arg1, arg2) {
    if (isFn)
      handler.call(self, arg1, arg2);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self, arg1, arg2);
    }
  }
  function emitThree(handler, isFn, self, arg1, arg2, arg3) {
    if (isFn)
      handler.call(self, arg1, arg2, arg3);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].call(self, arg1, arg2, arg3);
    }
  }
  
  function emitMany(handler, isFn, self, args) {
    if (isFn)
      handler.apply(self, args);
    else {
      var len = handler.length;
      var listeners = arrayClone(handler, len);
      for (var i = 0; i < len; ++i)
        listeners[i].apply(self, args);
    }
  }
  
  EventEmitter.prototype.emit = function emit(type) {
    var er, handler, len, args, i, events;
    var doError = (type === 'error');
  
    events = this._events;
    if (events)
      doError = (doError && events.error == null);
    else if (!doError)
      return false;
  
    // If there is no 'error' event listener then throw.
    if (doError) {
      if (arguments.length > 1)
        er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Unhandled "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
      return false;
    }
  
    handler = events[type];
  
    if (!handler)
      return false;
  
    var isFn = typeof handler === 'function';
    len = arguments.length;
    switch (len) {
        // fast cases
      case 1:
        emitNone(handler, isFn, this);
        break;
      case 2:
        emitOne(handler, isFn, this, arguments[1]);
        break;
      case 3:
        emitTwo(handler, isFn, this, arguments[1], arguments[2]);
        break;
      case 4:
        emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
        break;
        // slower
      default:
        args = new Array(len - 1);
        for (i = 1; i < len; i++)
          args[i - 1] = arguments[i];
        emitMany(handler, isFn, this, args);
    }
  
    return true;
  };
  
  function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
  
    if (typeof listener !== 'function')
      throw new TypeError('"listener" argument must be a function');
  
    events = target._events;
    if (!events) {
      events = target._events = objectCreate(null);
      target._eventsCount = 0;
    } else {
      // To avoid recursion in the case that type === "newListener"! Before
      // adding it to the listeners, first emit "newListener".
      if (events.newListener) {
        target.emit('newListener', type,
            listener.listener ? listener.listener : listener);
  
        // Re-assign `events` because a newListener handler could have caused the
        // this._events to be assigned to a new object
        events = target._events;
      }
      existing = events[type];
    }
  
    if (!existing) {
      // Optimize the case of one listener. Don't need the extra array object.
      existing = events[type] = listener;
      ++target._eventsCount;
    } else {
      if (typeof existing === 'function') {
        // Adding the second element, need to change to array.
        existing = events[type] =
            prepend ? [listener, existing] : [existing, listener];
      } else {
        // If we've already got an array, just append.
        if (prepend) {
          existing.unshift(listener);
        } else {
          existing.push(listener);
        }
      }
  
      // Check for listener leak
      if (!existing.warned) {
        m = $getMaxListeners(target);
        if (m && m > 0 && existing.length > m) {
          existing.warned = true;
          var w = new Error('Possible EventEmitter memory leak detected. ' +
              existing.length + ' "' + String(type) + '" listeners ' +
              'added. Use emitter.setMaxListeners() to ' +
              'increase limit.');
          w.name = 'MaxListenersExceededWarning';
          w.emitter = target;
          w.type = type;
          w.count = existing.length;
          if (typeof console === 'object' && console.warn) {
            console.warn('%s: %s', w.name, w.message);
          }
        }
      }
    }
  
    return target;
  }
  
  EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
  };
  
  EventEmitter.prototype.on = EventEmitter.prototype.addListener;
  
  EventEmitter.prototype.prependListener =
      function prependListener(type, listener) {
        return _addListener(this, type, listener, true);
      };
  
  function onceWrapper() {
    if (!this.fired) {
      this.target.removeListener(this.type, this.wrapFn);
      this.fired = true;
      switch (arguments.length) {
        case 0:
          return this.listener.call(this.target);
        case 1:
          return this.listener.call(this.target, arguments[0]);
        case 2:
          return this.listener.call(this.target, arguments[0], arguments[1]);
        case 3:
          return this.listener.call(this.target, arguments[0], arguments[1],
              arguments[2]);
        default:
          var args = new Array(arguments.length);
          for (var i = 0; i < args.length; ++i)
            args[i] = arguments[i];
          this.listener.apply(this.target, args);
      }
    }
  }
  
  function _onceWrap(target, type, listener) {
    var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
    var wrapped = bind.call(onceWrapper, state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
  }
  
  EventEmitter.prototype.once = function once(type, listener) {
    if (typeof listener !== 'function')
      throw new TypeError('"listener" argument must be a function');
    this.on(type, _onceWrap(this, type, listener));
    return this;
  };
  
  EventEmitter.prototype.prependOnceListener =
      function prependOnceListener(type, listener) {
        if (typeof listener !== 'function')
          throw new TypeError('"listener" argument must be a function');
        this.prependListener(type, _onceWrap(this, type, listener));
        return this;
      };
  
  // Emits a 'removeListener' event if and only if the listener was removed.
  EventEmitter.prototype.removeListener =
      function removeListener(type, listener) {
        var list, events, position, i, originalListener;
  
        if (typeof listener !== 'function')
          throw new TypeError('"listener" argument must be a function');
  
        events = this._events;
        if (!events)
          return this;
  
        list = events[type];
        if (!list)
          return this;
  
        if (list === listener || list.listener === listener) {
          if (--this._eventsCount === 0)
            this._events = objectCreate(null);
          else {
            delete events[type];
            if (events.removeListener)
              this.emit('removeListener', type, list.listener || listener);
          }
        } else if (typeof list !== 'function') {
          position = -1;
  
          for (i = list.length - 1; i >= 0; i--) {
            if (list[i] === listener || list[i].listener === listener) {
              originalListener = list[i].listener;
              position = i;
              break;
            }
          }
  
          if (position < 0)
            return this;
  
          if (position === 0)
            list.shift();
          else
            spliceOne(list, position);
  
          if (list.length === 1)
            events[type] = list[0];
  
          if (events.removeListener)
            this.emit('removeListener', type, originalListener || listener);
        }
  
        return this;
      };
  
  EventEmitter.prototype.removeAllListeners =
      function removeAllListeners(type) {
        var listeners, events, i;
  
        events = this._events;
        if (!events)
          return this;
  
        // not listening for removeListener, no need to emit
        if (!events.removeListener) {
          if (arguments.length === 0) {
            this._events = objectCreate(null);
            this._eventsCount = 0;
          } else if (events[type]) {
            if (--this._eventsCount === 0)
              this._events = objectCreate(null);
            else
              delete events[type];
          }
          return this;
        }
  
        // emit removeListener for all listeners on all events
        if (arguments.length === 0) {
          var keys = objectKeys(events);
          var key;
          for (i = 0; i < keys.length; ++i) {
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
          }
          this.removeAllListeners('removeListener');
          this._events = objectCreate(null);
          this._eventsCount = 0;
          return this;
        }
  
        listeners = events[type];
  
        if (typeof listeners === 'function') {
          this.removeListener(type, listeners);
        } else if (listeners) {
          // LIFO order
          for (i = listeners.length - 1; i >= 0; i--) {
            this.removeListener(type, listeners[i]);
          }
        }
  
        return this;
      };
  
  function _listeners(target, type, unwrap) {
    var events = target._events;
  
    if (!events)
      return [];
  
    var evlistener = events[type];
    if (!evlistener)
      return [];
  
    if (typeof evlistener === 'function')
      return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
  }
  
  EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
  };
  
  EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
  };
  
  EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') {
      return emitter.listenerCount(type);
    } else {
      return listenerCount.call(emitter, type);
    }
  };
  
  EventEmitter.prototype.listenerCount = listenerCount;
  function listenerCount(type) {
    var events = this._events;
  
    if (events) {
      var evlistener = events[type];
  
      if (typeof evlistener === 'function') {
        return 1;
      } else if (evlistener) {
        return evlistener.length;
      }
    }
  
    return 0;
  }
  
  EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
  };
  
  // About 1.5x faster than the two-arg version of Array#splice().
  function spliceOne(list, index) {
    for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
      list[i] = list[k];
    list.pop();
  }
  
  function arrayClone(arr, n) {
    var copy = new Array(n);
    for (var i = 0; i < n; ++i)
      copy[i] = arr[i];
    return copy;
  }
  
  function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for (var i = 0; i < ret.length; ++i) {
      ret[i] = arr[i].listener || arr[i];
    }
    return ret;
  }
  
  function objectCreatePolyfill(proto) {
    var F = function() {};
    F.prototype = proto;
    return new F;
  }
  function objectKeysPolyfill(obj) {
    var keys = [];
    for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
      keys.push(k);
    }
    return k;
  }
  function functionBindPolyfill(context) {
    var fn = this;
    return function () {
      return fn.apply(context, arguments);
    };
  }
  
  },{}],111:[function(_dereq_,module,exports){
  (function (Buffer){
  /*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   */
  /* eslint-disable no-proto */
  
  'use strict'
  
  var base64 = _dereq_('base64-js')
  var ieee754 = _dereq_('ieee754')
  
  exports.Buffer = Buffer
  exports.SlowBuffer = SlowBuffer
  exports.INSPECT_MAX_BYTES = 50
  
  var K_MAX_LENGTH = 0x7fffffff
  exports.kMaxLength = K_MAX_LENGTH
  
  /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Print warning and recommend using `buffer` v4.x which has an Object
   *               implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * We report that the browser does not support typed arrays if the are not subclassable
   * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
   * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
   * for __proto__ and has a buggy typed array implementation.
   */
  Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()
  
  if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
      typeof console.error === 'function') {
    console.error(
      'This browser lacks typed array (Uint8Array) support which is required by ' +
      '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
    )
  }
  
  function typedArraySupport () {
    // Can typed array instances can be augmented?
    try {
      var arr = new Uint8Array(1)
      arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
      return arr.foo() === 42
    } catch (e) {
      return false
    }
  }
  
  Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function () {
      if (!Buffer.isBuffer(this)) return undefined
      return this.buffer
    }
  })
  
  Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function () {
      if (!Buffer.isBuffer(this)) return undefined
      return this.byteOffset
    }
  })
  
  function createBuffer (length) {
    if (length > K_MAX_LENGTH) {
      throw new RangeError('The value "' + length + '" is invalid for option "size"')
    }
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length)
    buf.__proto__ = Buffer.prototype
    return buf
  }
  
  /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */
  
  function Buffer (arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
      if (typeof encodingOrOffset === 'string') {
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        )
      }
      return allocUnsafe(arg)
    }
    return from(arg, encodingOrOffset, length)
  }
  
  // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
  if (typeof Symbol !== 'undefined' && Symbol.species != null &&
      Buffer[Symbol.species] === Buffer) {
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true,
      enumerable: false,
      writable: false
    })
  }
  
  Buffer.poolSize = 8192 // not used by this implementation
  
  function from (value, encodingOrOffset, length) {
    if (typeof value === 'string') {
      return fromString(value, encodingOrOffset)
    }
  
    if (ArrayBuffer.isView(value)) {
      return fromArrayLike(value)
    }
  
    if (value == null) {
      throw TypeError(
        'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
        'or Array-like Object. Received type ' + (typeof value)
      )
    }
  
    if (isInstance(value, ArrayBuffer) ||
        (value && isInstance(value.buffer, ArrayBuffer))) {
      return fromArrayBuffer(value, encodingOrOffset, length)
    }
  
    if (typeof value === 'number') {
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      )
    }
  
    var valueOf = value.valueOf && value.valueOf()
    if (valueOf != null && valueOf !== value) {
      return Buffer.from(valueOf, encodingOrOffset, length)
    }
  
    var b = fromObject(value)
    if (b) return b
  
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
        typeof value[Symbol.toPrimitive] === 'function') {
      return Buffer.from(
        value[Symbol.toPrimitive]('string'), encodingOrOffset, length
      )
    }
  
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }
  
  /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/
  Buffer.from = function (value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length)
  }
  
  // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
  // https://github.com/feross/buffer/pull/148
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  
  function assertSize (size) {
    if (typeof size !== 'number') {
      throw new TypeError('"size" argument must be of type number')
    } else if (size < 0) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"')
    }
  }
  
  function alloc (size, fill, encoding) {
    assertSize(size)
    if (size <= 0) {
      return createBuffer(size)
    }
    if (fill !== undefined) {
      // Only pay attention to encoding if it's a string. This
      // prevents accidentally sending in a number that would
      // be interpretted as a start offset.
      return typeof encoding === 'string'
        ? createBuffer(size).fill(fill, encoding)
        : createBuffer(size).fill(fill)
    }
    return createBuffer(size)
  }
  
  /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/
  Buffer.alloc = function (size, fill, encoding) {
    return alloc(size, fill, encoding)
  }
  
  function allocUnsafe (size) {
    assertSize(size)
    return createBuffer(size < 0 ? 0 : checked(size) | 0)
  }
  
  /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */
  Buffer.allocUnsafe = function (size) {
    return allocUnsafe(size)
  }
  /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */
  Buffer.allocUnsafeSlow = function (size) {
    return allocUnsafe(size)
  }
  
  function fromString (string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') {
      encoding = 'utf8'
    }
  
    if (!Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  
    var length = byteLength(string, encoding) | 0
    var buf = createBuffer(length)
  
    var actual = buf.write(string, encoding)
  
    if (actual !== length) {
      // Writing a hex string, for example, that contains invalid characters will
      // cause everything after the first invalid character to be ignored. (e.g.
      // 'abxxcd' will be treated as 'ab')
      buf = buf.slice(0, actual)
    }
  
    return buf
  }
  
  function fromArrayLike (array) {
    var length = array.length < 0 ? 0 : checked(array.length) | 0
    var buf = createBuffer(length)
    for (var i = 0; i < length; i += 1) {
      buf[i] = array[i] & 255
    }
    return buf
  }
  
  function fromArrayBuffer (array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('"offset" is outside of buffer bounds')
    }
  
    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('"length" is outside of buffer bounds')
    }
  
    var buf
    if (byteOffset === undefined && length === undefined) {
      buf = new Uint8Array(array)
    } else if (length === undefined) {
      buf = new Uint8Array(array, byteOffset)
    } else {
      buf = new Uint8Array(array, byteOffset, length)
    }
  
    // Return an augmented `Uint8Array` instance
    buf.__proto__ = Buffer.prototype
    return buf
  }
  
  function fromObject (obj) {
    if (Buffer.isBuffer(obj)) {
      var len = checked(obj.length) | 0
      var buf = createBuffer(len)
  
      if (buf.length === 0) {
        return buf
      }
  
      obj.copy(buf, 0, 0, len)
      return buf
    }
  
    if (obj.length !== undefined) {
      if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
        return createBuffer(0)
      }
      return fromArrayLike(obj)
    }
  
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
      return fromArrayLike(obj.data)
    }
  }
  
  function checked (length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) {
      throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                           'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
    }
    return length | 0
  }
  
  function SlowBuffer (length) {
    if (+length != length) { // eslint-disable-line eqeqeq
      length = 0
    }
    return Buffer.alloc(+length)
  }
  
  Buffer.isBuffer = function isBuffer (b) {
    return b != null && b._isBuffer === true &&
      b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
  }
  
  Buffer.compare = function compare (a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      )
    }
  
    if (a === b) return 0
  
    var x = a.length
    var y = b.length
  
    for (var i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i]
        y = b[i]
        break
      }
    }
  
    if (x < y) return -1
    if (y < x) return 1
    return 0
  }
  
  Buffer.isEncoding = function isEncoding (encoding) {
    switch (String(encoding).toLowerCase()) {
      case 'hex':
      case 'utf8':
      case 'utf-8':
      case 'ascii':
      case 'latin1':
      case 'binary':
      case 'base64':
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return true
      default:
        return false
    }
  }
  
  Buffer.concat = function concat (list, length) {
    if (!Array.isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
  
    if (list.length === 0) {
      return Buffer.alloc(0)
    }
  
    var i
    if (length === undefined) {
      length = 0
      for (i = 0; i < list.length; ++i) {
        length += list[i].length
      }
    }
  
    var buffer = Buffer.allocUnsafe(length)
    var pos = 0
    for (i = 0; i < list.length; ++i) {
      var buf = list[i]
      if (isInstance(buf, Uint8Array)) {
        buf = Buffer.from(buf)
      }
      if (!Buffer.isBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers')
      }
      buf.copy(buffer, pos)
      pos += buf.length
    }
    return buffer
  }
  
  function byteLength (string, encoding) {
    if (Buffer.isBuffer(string)) {
      return string.length
    }
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
      return string.byteLength
    }
    if (typeof string !== 'string') {
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
        'Received type ' + typeof string
      )
    }
  
    var len = string.length
    var mustMatch = (arguments.length > 2 && arguments[2] === true)
    if (!mustMatch && len === 0) return 0
  
    // Use a for loop to avoid recursion
    var loweredCase = false
    for (;;) {
      switch (encoding) {
        case 'ascii':
        case 'latin1':
        case 'binary':
          return len
        case 'utf8':
        case 'utf-8':
          return utf8ToBytes(string).length
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return len * 2
        case 'hex':
          return len >>> 1
        case 'base64':
          return base64ToBytes(string).length
        default:
          if (loweredCase) {
            return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
          }
          encoding = ('' + encoding).toLowerCase()
          loweredCase = true
      }
    }
  }
  Buffer.byteLength = byteLength
  
  function slowToString (encoding, start, end) {
    var loweredCase = false
  
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
  
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) {
      start = 0
    }
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) {
      return ''
    }
  
    if (end === undefined || end > this.length) {
      end = this.length
    }
  
    if (end <= 0) {
      return ''
    }
  
    // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0
    start >>>= 0
  
    if (end <= start) {
      return ''
    }
  
    if (!encoding) encoding = 'utf8'
  
    while (true) {
      switch (encoding) {
        case 'hex':
          return hexSlice(this, start, end)
  
        case 'utf8':
        case 'utf-8':
          return utf8Slice(this, start, end)
  
        case 'ascii':
          return asciiSlice(this, start, end)
  
        case 'latin1':
        case 'binary':
          return latin1Slice(this, start, end)
  
        case 'base64':
          return base64Slice(this, start, end)
  
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return utf16leSlice(this, start, end)
  
        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
          encoding = (encoding + '').toLowerCase()
          loweredCase = true
      }
    }
  }
  
  // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
  // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
  // reliably in a browserify context because there could be multiple different
  // copies of the 'buffer' package in use. This method works even for Buffer
  // instances that were created from another copy of the `buffer` package.
  // See: https://github.com/feross/buffer/issues/154
  Buffer.prototype._isBuffer = true
  
  function swap (b, n, m) {
    var i = b[n]
    b[n] = b[m]
    b[m] = i
  }
  
  Buffer.prototype.swap16 = function swap16 () {
    var len = this.length
    if (len % 2 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 16-bits')
    }
    for (var i = 0; i < len; i += 2) {
      swap(this, i, i + 1)
    }
    return this
  }
  
  Buffer.prototype.swap32 = function swap32 () {
    var len = this.length
    if (len % 4 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 32-bits')
    }
    for (var i = 0; i < len; i += 4) {
      swap(this, i, i + 3)
      swap(this, i + 1, i + 2)
    }
    return this
  }
  
  Buffer.prototype.swap64 = function swap64 () {
    var len = this.length
    if (len % 8 !== 0) {
      throw new RangeError('Buffer size must be a multiple of 64-bits')
    }
    for (var i = 0; i < len; i += 8) {
      swap(this, i, i + 7)
      swap(this, i + 1, i + 6)
      swap(this, i + 2, i + 5)
      swap(this, i + 3, i + 4)
    }
    return this
  }
  
  Buffer.prototype.toString = function toString () {
    var length = this.length
    if (length === 0) return ''
    if (arguments.length === 0) return utf8Slice(this, 0, length)
    return slowToString.apply(this, arguments)
  }
  
  Buffer.prototype.toLocaleString = Buffer.prototype.toString
  
  Buffer.prototype.equals = function equals (b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
    if (this === b) return true
    return Buffer.compare(this, b) === 0
  }
  
  Buffer.prototype.inspect = function inspect () {
    var str = ''
    var max = exports.INSPECT_MAX_BYTES
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
    if (this.length > max) str += ' ... '
    return '<Buffer ' + str + '>'
  }
  
  Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) {
      target = Buffer.from(target, target.offset, target.byteLength)
    }
    if (!Buffer.isBuffer(target)) {
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. ' +
        'Received type ' + (typeof target)
      )
    }
  
    if (start === undefined) {
      start = 0
    }
    if (end === undefined) {
      end = target ? target.length : 0
    }
    if (thisStart === undefined) {
      thisStart = 0
    }
    if (thisEnd === undefined) {
      thisEnd = this.length
    }
  
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError('out of range index')
    }
  
    if (thisStart >= thisEnd && start >= end) {
      return 0
    }
    if (thisStart >= thisEnd) {
      return -1
    }
    if (start >= end) {
      return 1
    }
  
    start >>>= 0
    end >>>= 0
    thisStart >>>= 0
    thisEnd >>>= 0
  
    if (this === target) return 0
  
    var x = thisEnd - thisStart
    var y = end - start
    var len = Math.min(x, y)
  
    var thisCopy = this.slice(thisStart, thisEnd)
    var targetCopy = target.slice(start, end)
  
    for (var i = 0; i < len; ++i) {
      if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i]
        y = targetCopy[i]
        break
      }
    }
  
    if (x < y) return -1
    if (y < x) return 1
    return 0
  }
  
  // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
  // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
  //
  // Arguments:
  // - buffer - a Buffer to search
  // - val - a string, Buffer, or number
  // - byteOffset - an index into `buffer`; will be clamped to an int32
  // - encoding - an optional encoding, relevant is val is a string
  // - dir - true for indexOf, false for lastIndexOf
  function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1
  
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
      encoding = byteOffset
      byteOffset = 0
    } else if (byteOffset > 0x7fffffff) {
      byteOffset = 0x7fffffff
    } else if (byteOffset < -0x80000000) {
      byteOffset = -0x80000000
    }
    byteOffset = +byteOffset // Coerce to Number.
    if (numberIsNaN(byteOffset)) {
      // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
      byteOffset = dir ? 0 : (buffer.length - 1)
    }
  
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset
    if (byteOffset >= buffer.length) {
      if (dir) return -1
      else byteOffset = buffer.length - 1
    } else if (byteOffset < 0) {
      if (dir) byteOffset = 0
      else return -1
    }
  
    // Normalize val
    if (typeof val === 'string') {
      val = Buffer.from(val, encoding)
    }
  
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
      // Special case: looking for empty string/buffer always fails
      if (val.length === 0) {
        return -1
      }
      return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
    } else if (typeof val === 'number') {
      val = val & 0xFF // Search for a byte value [0-255]
      if (typeof Uint8Array.prototype.indexOf === 'function') {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
        }
      }
      return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
    }
  
    throw new TypeError('val must be string, number or Buffer')
  }
  
  function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
    var indexSize = 1
    var arrLength = arr.length
    var valLength = val.length
  
    if (encoding !== undefined) {
      encoding = String(encoding).toLowerCase()
      if (encoding === 'ucs2' || encoding === 'ucs-2' ||
          encoding === 'utf16le' || encoding === 'utf-16le') {
        if (arr.length < 2 || val.length < 2) {
          return -1
        }
        indexSize = 2
        arrLength /= 2
        valLength /= 2
        byteOffset /= 2
      }
    }
  
    function read (buf, i) {
      if (indexSize === 1) {
        return buf[i]
      } else {
        return buf.readUInt16BE(i * indexSize)
      }
    }
  
    var i
    if (dir) {
      var foundIndex = -1
      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1) foundIndex = i
          if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
        } else {
          if (foundIndex !== -1) i -= i - foundIndex
          foundIndex = -1
        }
      }
    } else {
      if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
      for (i = byteOffset; i >= 0; i--) {
        var found = true
        for (var j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val, j)) {
            found = false
            break
          }
        }
        if (found) return i
      }
    }
  
    return -1
  }
  
  Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1
  }
  
  Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
  }
  
  Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
  }
  
  function hexWrite (buf, string, offset, length) {
    offset = Number(offset) || 0
    var remaining = buf.length - offset
    if (!length) {
      length = remaining
    } else {
      length = Number(length)
      if (length > remaining) {
        length = remaining
      }
    }
  
    var strLen = string.length
  
    if (length > strLen / 2) {
      length = strLen / 2
    }
    for (var i = 0; i < length; ++i) {
      var parsed = parseInt(string.substr(i * 2, 2), 16)
      if (numberIsNaN(parsed)) return i
      buf[offset + i] = parsed
    }
    return i
  }
  
  function utf8Write (buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
  }
  
  function asciiWrite (buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length)
  }
  
  function latin1Write (buf, string, offset, length) {
    return asciiWrite(buf, string, offset, length)
  }
  
  function base64Write (buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length)
  }
  
  function ucs2Write (buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
  }
  
  Buffer.prototype.write = function write (string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
      encoding = 'utf8'
      length = this.length
      offset = 0
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
      encoding = offset
      length = this.length
      offset = 0
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
      offset = offset >>> 0
      if (isFinite(length)) {
        length = length >>> 0
        if (encoding === undefined) encoding = 'utf8'
      } else {
        encoding = length
        length = undefined
      }
    } else {
      throw new Error(
        'Buffer.write(string, encoding, offset[, length]) is no longer supported'
      )
    }
  
    var remaining = this.length - offset
    if (length === undefined || length > remaining) length = remaining
  
    if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
      throw new RangeError('Attempt to write outside buffer bounds')
    }
  
    if (!encoding) encoding = 'utf8'
  
    var loweredCase = false
    for (;;) {
      switch (encoding) {
        case 'hex':
          return hexWrite(this, string, offset, length)
  
        case 'utf8':
        case 'utf-8':
          return utf8Write(this, string, offset, length)
  
        case 'ascii':
          return asciiWrite(this, string, offset, length)
  
        case 'latin1':
        case 'binary':
          return latin1Write(this, string, offset, length)
  
        case 'base64':
          // Warning: maxLength not taken into account in base64Write
          return base64Write(this, string, offset, length)
  
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
          return ucs2Write(this, string, offset, length)
  
        default:
          if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
          encoding = ('' + encoding).toLowerCase()
          loweredCase = true
      }
    }
  }
  
  Buffer.prototype.toJSON = function toJSON () {
    return {
      type: 'Buffer',
      data: Array.prototype.slice.call(this._arr || this, 0)
    }
  }
  
  function base64Slice (buf, start, end) {
    if (start === 0 && end === buf.length) {
      return base64.fromByteArray(buf)
    } else {
      return base64.fromByteArray(buf.slice(start, end))
    }
  }
  
  function utf8Slice (buf, start, end) {
    end = Math.min(buf.length, end)
    var res = []
  
    var i = start
    while (i < end) {
      var firstByte = buf[i]
      var codePoint = null
      var bytesPerSequence = (firstByte > 0xEF) ? 4
        : (firstByte > 0xDF) ? 3
          : (firstByte > 0xBF) ? 2
            : 1
  
      if (i + bytesPerSequence <= end) {
        var secondByte, thirdByte, fourthByte, tempCodePoint
  
        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 0x80) {
              codePoint = firstByte
            }
            break
          case 2:
            secondByte = buf[i + 1]
            if ((secondByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
              if (tempCodePoint > 0x7F) {
                codePoint = tempCodePoint
              }
            }
            break
          case 3:
            secondByte = buf[i + 1]
            thirdByte = buf[i + 2]
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
              if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
                codePoint = tempCodePoint
              }
            }
            break
          case 4:
            secondByte = buf[i + 1]
            thirdByte = buf[i + 2]
            fourthByte = buf[i + 3]
            if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
              tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
              if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
                codePoint = tempCodePoint
              }
            }
        }
      }
  
      if (codePoint === null) {
        // we did not generate a valid codePoint so insert a
        // replacement char (U+FFFD) and advance only 1 byte
        codePoint = 0xFFFD
        bytesPerSequence = 1
      } else if (codePoint > 0xFFFF) {
        // encode to utf16 (surrogate pair dance)
        codePoint -= 0x10000
        res.push(codePoint >>> 10 & 0x3FF | 0xD800)
        codePoint = 0xDC00 | codePoint & 0x3FF
      }
  
      res.push(codePoint)
      i += bytesPerSequence
    }
  
    return decodeCodePointsArray(res)
  }
  
  // Based on http://stackoverflow.com/a/22747272/680742, the browser with
  // the lowest limit is Chrome, with 0x10000 args.
  // We go 1 magnitude less, for safety
  var MAX_ARGUMENTS_LENGTH = 0x1000
  
  function decodeCodePointsArray (codePoints) {
    var len = codePoints.length
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    }
  
    // Decode in chunks to avoid "call stack size exceeded".
    var res = ''
    var i = 0
    while (i < len) {
      res += String.fromCharCode.apply(
        String,
        codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
      )
    }
    return res
  }
  
  function asciiSlice (buf, start, end) {
    var ret = ''
    end = Math.min(buf.length, end)
  
    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i] & 0x7F)
    }
    return ret
  }
  
  function latin1Slice (buf, start, end) {
    var ret = ''
    end = Math.min(buf.length, end)
  
    for (var i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i])
    }
    return ret
  }
  
  function hexSlice (buf, start, end) {
    var len = buf.length
  
    if (!start || start < 0) start = 0
    if (!end || end < 0 || end > len) end = len
  
    var out = ''
    for (var i = start; i < end; ++i) {
      out += toHex(buf[i])
    }
    return out
  }
  
  function utf16leSlice (buf, start, end) {
    var bytes = buf.slice(start, end)
    var res = ''
    for (var i = 0; i < bytes.length; i += 2) {
      res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
    }
    return res
  }
  
  Buffer.prototype.slice = function slice (start, end) {
    var len = this.length
    start = ~~start
    end = end === undefined ? len : ~~end
  
    if (start < 0) {
      start += len
      if (start < 0) start = 0
    } else if (start > len) {
      start = len
    }
  
    if (end < 0) {
      end += len
      if (end < 0) end = 0
    } else if (end > len) {
      end = len
    }
  
    if (end < start) end = start
  
    var newBuf = this.subarray(start, end)
    // Return an augmented `Uint8Array` instance
    newBuf.__proto__ = Buffer.prototype
    return newBuf
  }
  
  /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */
  function checkOffset (offset, ext, length) {
    if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
  }
  
  Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
    offset = offset >>> 0
    byteLength = byteLength >>> 0
    if (!noAssert) checkOffset(offset, byteLength, this.length)
  
    var val = this[offset]
    var mul = 1
    var i = 0
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul
    }
  
    return val
  }
  
  Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
    offset = offset >>> 0
    byteLength = byteLength >>> 0
    if (!noAssert) {
      checkOffset(offset, byteLength, this.length)
    }
  
    var val = this[offset + --byteLength]
    var mul = 1
    while (byteLength > 0 && (mul *= 0x100)) {
      val += this[offset + --byteLength] * mul
    }
  
    return val
  }
  
  Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 1, this.length)
    return this[offset]
  }
  
  Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 2, this.length)
    return this[offset] | (this[offset + 1] << 8)
  }
  
  Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 2, this.length)
    return (this[offset] << 8) | this[offset + 1]
  }
  
  Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 4, this.length)
  
    return ((this[offset]) |
        (this[offset + 1] << 8) |
        (this[offset + 2] << 16)) +
        (this[offset + 3] * 0x1000000)
  }
  
  Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 4, this.length)
  
    return (this[offset] * 0x1000000) +
      ((this[offset + 1] << 16) |
      (this[offset + 2] << 8) |
      this[offset + 3])
  }
  
  Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
    offset = offset >>> 0
    byteLength = byteLength >>> 0
    if (!noAssert) checkOffset(offset, byteLength, this.length)
  
    var val = this[offset]
    var mul = 1
    var i = 0
    while (++i < byteLength && (mul *= 0x100)) {
      val += this[offset + i] * mul
    }
    mul *= 0x80
  
    if (val >= mul) val -= Math.pow(2, 8 * byteLength)
  
    return val
  }
  
  Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
    offset = offset >>> 0
    byteLength = byteLength >>> 0
    if (!noAssert) checkOffset(offset, byteLength, this.length)
  
    var i = byteLength
    var mul = 1
    var val = this[offset + --i]
    while (i > 0 && (mul *= 0x100)) {
      val += this[offset + --i] * mul
    }
    mul *= 0x80
  
    if (val >= mul) val -= Math.pow(2, 8 * byteLength)
  
    return val
  }
  
  Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 1, this.length)
    if (!(this[offset] & 0x80)) return (this[offset])
    return ((0xff - this[offset] + 1) * -1)
  }
  
  Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 2, this.length)
    var val = this[offset] | (this[offset + 1] << 8)
    return (val & 0x8000) ? val | 0xFFFF0000 : val
  }
  
  Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 2, this.length)
    var val = this[offset + 1] | (this[offset] << 8)
    return (val & 0x8000) ? val | 0xFFFF0000 : val
  }
  
  Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 4, this.length)
  
    return (this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16) |
      (this[offset + 3] << 24)
  }
  
  Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 4, this.length)
  
    return (this[offset] << 24) |
      (this[offset + 1] << 16) |
      (this[offset + 2] << 8) |
      (this[offset + 3])
  }
  
  Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 4, this.length)
    return ieee754.read(this, offset, true, 23, 4)
  }
  
  Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 4, this.length)
    return ieee754.read(this, offset, false, 23, 4)
  }
  
  Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 8, this.length)
    return ieee754.read(this, offset, true, 52, 8)
  }
  
  Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
    offset = offset >>> 0
    if (!noAssert) checkOffset(offset, 8, this.length)
    return ieee754.read(this, offset, false, 52, 8)
  }
  
  function checkInt (buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
    if (offset + ext > buf.length) throw new RangeError('Index out of range')
  }
  
  Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
    value = +value
    offset = offset >>> 0
    byteLength = byteLength >>> 0
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1
      checkInt(this, value, offset, byteLength, maxBytes, 0)
    }
  
    var mul = 1
    var i = 0
    this[offset] = value & 0xFF
    while (++i < byteLength && (mul *= 0x100)) {
      this[offset + i] = (value / mul) & 0xFF
    }
  
    return offset + byteLength
  }
  
  Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
    value = +value
    offset = offset >>> 0
    byteLength = byteLength >>> 0
    if (!noAssert) {
      var maxBytes = Math.pow(2, 8 * byteLength) - 1
      checkInt(this, value, offset, byteLength, maxBytes, 0)
    }
  
    var i = byteLength - 1
    var mul = 1
    this[offset + i] = value & 0xFF
    while (--i >= 0 && (mul *= 0x100)) {
      this[offset + i] = (value / mul) & 0xFF
    }
  
    return offset + byteLength
  }
  
  Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
    this[offset] = (value & 0xff)
    return offset + 1
  }
  
  Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    return offset + 2
  }
  
  Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
    return offset + 2
  }
  
  Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
    return offset + 4
  }
  
  Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
    return offset + 4
  }
  
  Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) {
      var limit = Math.pow(2, (8 * byteLength) - 1)
  
      checkInt(this, value, offset, byteLength, limit - 1, -limit)
    }
  
    var i = 0
    var mul = 1
    var sub = 0
    this[offset] = value & 0xFF
    while (++i < byteLength && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
        sub = 1
      }
      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
    }
  
    return offset + byteLength
  }
  
  Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) {
      var limit = Math.pow(2, (8 * byteLength) - 1)
  
      checkInt(this, value, offset, byteLength, limit - 1, -limit)
    }
  
    var i = byteLength - 1
    var mul = 1
    var sub = 0
    this[offset + i] = value & 0xFF
    while (--i >= 0 && (mul *= 0x100)) {
      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
        sub = 1
      }
      this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
    }
  
    return offset + byteLength
  }
  
  Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
    if (value < 0) value = 0xff + value + 1
    this[offset] = (value & 0xff)
    return offset + 1
  }
  
  Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    return offset + 2
  }
  
  Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
    return offset + 2
  }
  
  Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
    return offset + 4
  }
  
  Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
    if (value < 0) value = 0xffffffff + value + 1
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
    return offset + 4
  }
  
  function checkIEEE754 (buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range')
    if (offset < 0) throw new RangeError('Index out of range')
  }
  
  function writeFloat (buf, value, offset, littleEndian, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
    }
    ieee754.write(buf, value, offset, littleEndian, 23, 4)
    return offset + 4
  }
  
  Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert)
  }
  
  Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert)
  }
  
  function writeDouble (buf, value, offset, littleEndian, noAssert) {
    value = +value
    offset = offset >>> 0
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
    }
    ieee754.write(buf, value, offset, littleEndian, 52, 8)
    return offset + 8
  }
  
  Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert)
  }
  
  Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert)
  }
  
  // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
  Buffer.prototype.copy = function copy (target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
    if (!start) start = 0
    if (!end && end !== 0) end = this.length
    if (targetStart >= target.length) targetStart = target.length
    if (!targetStart) targetStart = 0
    if (end > 0 && end < start) end = start
  
    // Copy 0 bytes; we're done
    if (end === start) return 0
    if (target.length === 0 || this.length === 0) return 0
  
    // Fatal error conditions
    if (targetStart < 0) {
      throw new RangeError('targetStart out of bounds')
    }
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
    if (end < 0) throw new RangeError('sourceEnd out of bounds')
  
    // Are we oob?
    if (end > this.length) end = this.length
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start
    }
  
    var len = end - start
  
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
      // Use built-in when available, missing from IE11
      this.copyWithin(targetStart, start, end)
    } else if (this === target && start < targetStart && targetStart < end) {
      // descending copy from end
      for (var i = len - 1; i >= 0; --i) {
        target[i + targetStart] = this[i + start]
      }
    } else {
      Uint8Array.prototype.set.call(
        target,
        this.subarray(start, end),
        targetStart
      )
    }
  
    return len
  }
  
  // Usage:
  //    buffer.fill(number[, offset[, end]])
  //    buffer.fill(buffer[, offset[, end]])
  //    buffer.fill(string[, offset[, end]][, encoding])
  Buffer.prototype.fill = function fill (val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
      if (typeof start === 'string') {
        encoding = start
        start = 0
        end = this.length
      } else if (typeof end === 'string') {
        encoding = end
        end = this.length
      }
      if (encoding !== undefined && typeof encoding !== 'string') {
        throw new TypeError('encoding must be a string')
      }
      if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
        throw new TypeError('Unknown encoding: ' + encoding)
      }
      if (val.length === 1) {
        var code = val.charCodeAt(0)
        if ((encoding === 'utf8' && code < 128) ||
            encoding === 'latin1') {
          // Fast path: If `val` fits into a single byte, use that numeric value.
          val = code
        }
      }
    } else if (typeof val === 'number') {
      val = val & 255
    }
  
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError('Out of range index')
    }
  
    if (end <= start) {
      return this
    }
  
    start = start >>> 0
    end = end === undefined ? this.length : end >>> 0
  
    if (!val) val = 0
  
    var i
    if (typeof val === 'number') {
      for (i = start; i < end; ++i) {
        this[i] = val
      }
    } else {
      var bytes = Buffer.isBuffer(val)
        ? val
        : Buffer.from(val, encoding)
      var len = bytes.length
      if (len === 0) {
        throw new TypeError('The value "' + val +
          '" is invalid for argument "value"')
      }
      for (i = 0; i < end - start; ++i) {
        this[i + start] = bytes[i % len]
      }
    }
  
    return this
  }
  
  // HELPER FUNCTIONS
  // ================
  
  var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g
  
  function base64clean (str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0]
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '')
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return ''
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while (str.length % 4 !== 0) {
      str = str + '='
    }
    return str
  }
  
  function toHex (n) {
    if (n < 16) return '0' + n.toString(16)
    return n.toString(16)
  }
  
  function utf8ToBytes (string, units) {
    units = units || Infinity
    var codePoint
    var length = string.length
    var leadSurrogate = null
    var bytes = []
  
    for (var i = 0; i < length; ++i) {
      codePoint = string.charCodeAt(i)
  
      // is surrogate component
      if (codePoint > 0xD7FF && codePoint < 0xE000) {
        // last char was a lead
        if (!leadSurrogate) {
          // no lead yet
          if (codePoint > 0xDBFF) {
            // unexpected trail
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
            continue
          } else if (i + 1 === length) {
            // unpaired lead
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
            continue
          }
  
          // valid lead
          leadSurrogate = codePoint
  
          continue
        }
  
        // 2 leads in a row
        if (codePoint < 0xDC00) {
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          leadSurrogate = codePoint
          continue
        }
  
        // valid surrogate pair
        codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
      } else if (leadSurrogate) {
        // valid bmp char, but last char was a lead
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
      }
  
      leadSurrogate = null
  
      // encode utf8
      if (codePoint < 0x80) {
        if ((units -= 1) < 0) break
        bytes.push(codePoint)
      } else if (codePoint < 0x800) {
        if ((units -= 2) < 0) break
        bytes.push(
          codePoint >> 0x6 | 0xC0,
          codePoint & 0x3F | 0x80
        )
      } else if (codePoint < 0x10000) {
        if ((units -= 3) < 0) break
        bytes.push(
          codePoint >> 0xC | 0xE0,
          codePoint >> 0x6 & 0x3F | 0x80,
          codePoint & 0x3F | 0x80
        )
      } else if (codePoint < 0x110000) {
        if ((units -= 4) < 0) break
        bytes.push(
          codePoint >> 0x12 | 0xF0,
          codePoint >> 0xC & 0x3F | 0x80,
          codePoint >> 0x6 & 0x3F | 0x80,
          codePoint & 0x3F | 0x80
        )
      } else {
        throw new Error('Invalid code point')
      }
    }
  
    return bytes
  }
  
  function asciiToBytes (str) {
    var byteArray = []
    for (var i = 0; i < str.length; ++i) {
      // Node's code seems to be doing this and not & 0x7F..
      byteArray.push(str.charCodeAt(i) & 0xFF)
    }
    return byteArray
  }
  
  function utf16leToBytes (str, units) {
    var c, hi, lo
    var byteArray = []
    for (var i = 0; i < str.length; ++i) {
      if ((units -= 2) < 0) break
  
      c = str.charCodeAt(i)
      hi = c >> 8
      lo = c % 256
      byteArray.push(lo)
      byteArray.push(hi)
    }
  
    return byteArray
  }
  
  function base64ToBytes (str) {
    return base64.toByteArray(base64clean(str))
  }
  
  function blitBuffer (src, dst, offset, length) {
    for (var i = 0; i < length; ++i) {
      if ((i + offset >= dst.length) || (i >= src.length)) break
      dst[i + offset] = src[i]
    }
    return i
  }
  
  // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
  // the `instanceof` check but they should be treated as of that type.
  // See: https://github.com/feross/buffer/issues/166
  function isInstance (obj, type) {
    return obj instanceof type ||
      (obj != null && obj.constructor != null && obj.constructor.name != null &&
        obj.constructor.name === type.name)
  }
  function numberIsNaN (obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
  }
  
  }).call(this,_dereq_("buffer").Buffer)
  },{"base64-js":79,"buffer":111,"ieee754":416}],112:[function(_dereq_,module,exports){
  'use strict'
  
  var monotoneTriangulate = _dereq_('./lib/monotone')
  var makeIndex = _dereq_('./lib/triangulation')
  var delaunayFlip = _dereq_('./lib/delaunay')
  var filterTriangulation = _dereq_('./lib/filter')
  
  module.exports = cdt2d
  
  function canonicalizeEdge(e) {
    return [Math.min(e[0], e[1]), Math.max(e[0], e[1])]
  }
  
  function compareEdge(a, b) {
    return a[0]-b[0] || a[1]-b[1]
  }
  
  function canonicalizeEdges(edges) {
    return edges.map(canonicalizeEdge).sort(compareEdge)
  }
  
  function getDefault(options, property, dflt) {
    if(property in options) {
      return options[property]
    }
    return dflt
  }
  
  function cdt2d(points, edges, options) {
  
    if(!Array.isArray(edges)) {
      options = edges || {}
      edges = []
    } else {
      options = options || {}
      edges = edges || []
    }
  
    //Parse out options
    var delaunay = !!getDefault(options, 'delaunay', true)
    var interior = !!getDefault(options, 'interior', true)
    var exterior = !!getDefault(options, 'exterior', true)
    var infinity = !!getDefault(options, 'infinity', false)
  
    //Handle trivial case
    if((!interior && !exterior) || points.length === 0) {
      return []
    }
  
    //Construct initial triangulation
    var cells = monotoneTriangulate(points, edges)
  
    //If delaunay refinement needed, then improve quality by edge flipping
    if(delaunay || interior !== exterior || infinity) {
  
      //Index all of the cells to support fast neighborhood queries
      var triangulation = makeIndex(points.length, canonicalizeEdges(edges))
      for(var i=0; i<cells.length; ++i) {
        var f = cells[i]
        triangulation.addTriangle(f[0], f[1], f[2])
      }
  
      //Run edge flipping
      if(delaunay) {
        delaunayFlip(points, triangulation)
      }
  
      //Filter points
      if(!exterior) {
        return filterTriangulation(triangulation, -1)
      } else if(!interior) {
        return filterTriangulation(triangulation,  1, infinity)
      } else if(infinity) {
        return filterTriangulation(triangulation, 0, infinity)
      } else {
        return triangulation.cells()
      }
      
    } else {
      return cells
    }
  }
  
  },{"./lib/delaunay":113,"./lib/filter":114,"./lib/monotone":115,"./lib/triangulation":116}],113:[function(_dereq_,module,exports){
  'use strict'
  
  var inCircle = _dereq_('robust-in-sphere')[4]
  var bsearch = _dereq_('binary-search-bounds')
  
  module.exports = delaunayRefine
  
  function testFlip(points, triangulation, stack, a, b, x) {
    var y = triangulation.opposite(a, b)
  
    //Test boundary edge
    if(y < 0) {
      return
    }
  
    //Swap edge if order flipped
    if(b < a) {
      var tmp = a
      a = b
      b = tmp
      tmp = x
      x = y
      y = tmp
    }
  
    //Test if edge is constrained
    if(triangulation.isConstraint(a, b)) {
      return
    }
  
    //Test if edge is delaunay
    if(inCircle(points[a], points[b], points[x], points[y]) < 0) {
      stack.push(a, b)
    }
  }
  
  //Assume edges are sorted lexicographically
  function delaunayRefine(points, triangulation) {
    var stack = []
  
    var numPoints = points.length
    var stars = triangulation.stars
    for(var a=0; a<numPoints; ++a) {
      var star = stars[a]
      for(var j=1; j<star.length; j+=2) {
        var b = star[j]
  
        //If order is not consistent, then skip edge
        if(b < a) {
          continue
        }
  
        //Check if edge is constrained
        if(triangulation.isConstraint(a, b)) {
          continue
        }
  
        //Find opposite edge
        var x = star[j-1], y = -1
        for(var k=1; k<star.length; k+=2) {
          if(star[k-1] === b) {
            y = star[k]
            break
          }
        }
  
        //If this is a boundary edge, don't flip it
        if(y < 0) {
          continue
        }
  
        //If edge is in circle, flip it
        if(inCircle(points[a], points[b], points[x], points[y]) < 0) {
          stack.push(a, b)
        }
      }
    }
  
    while(stack.length > 0) {
      var b = stack.pop()
      var a = stack.pop()
  
      //Find opposite pairs
      var x = -1, y = -1
      var star = stars[a]
      for(var i=1; i<star.length; i+=2) {
        var s = star[i-1]
        var t = star[i]
        if(s === b) {
          y = t
        } else if(t === b) {
          x = s
        }
      }
  
      //If x/y are both valid then skip edge
      if(x < 0 || y < 0) {
        continue
      }
  
      //If edge is now delaunay, then don't flip it
      if(inCircle(points[a], points[b], points[x], points[y]) >= 0) {
        continue
      }
  
      //Flip the edge
      triangulation.flip(a, b)
  
      //Test flipping neighboring edges
      testFlip(points, triangulation, stack, x, a, y)
      testFlip(points, triangulation, stack, a, y, x)
      testFlip(points, triangulation, stack, y, b, x)
      testFlip(points, triangulation, stack, b, x, y)
    }
  }
  
  },{"binary-search-bounds":96,"robust-in-sphere":518}],114:[function(_dereq_,module,exports){
  'use strict'
  
  var bsearch = _dereq_('binary-search-bounds')
  
  module.exports = classifyFaces
  
  function FaceIndex(cells, neighbor, constraint, flags, active, next, boundary) {
    this.cells       = cells
    this.neighbor    = neighbor
    this.flags       = flags
    this.constraint  = constraint
    this.active      = active
    this.next        = next
    this.boundary    = boundary
  }
  
  var proto = FaceIndex.prototype
  
  function compareCell(a, b) {
    return a[0] - b[0] ||
           a[1] - b[1] ||
           a[2] - b[2]
  }
  
  proto.locate = (function() {
    var key = [0,0,0]
    return function(a, b, c) {
      var x = a, y = b, z = c
      if(b < c) {
        if(b < a) {
          x = b
          y = c
          z = a
        }
      } else if(c < a) {
        x = c
        y = a
        z = b
      }
      if(x < 0) {
        return -1
      }
      key[0] = x
      key[1] = y
      key[2] = z
      return bsearch.eq(this.cells, key, compareCell)
    }
  })()
  
  function indexCells(triangulation, infinity) {
    //First get cells and canonicalize
    var cells = triangulation.cells()
    var nc = cells.length
    for(var i=0; i<nc; ++i) {
      var c = cells[i]
      var x = c[0], y = c[1], z = c[2]
      if(y < z) {
        if(y < x) {
          c[0] = y
          c[1] = z
          c[2] = x
        }
      } else if(z < x) {
        c[0] = z
        c[1] = x
        c[2] = y
      }
    }
    cells.sort(compareCell)
  
    //Initialize flag array
    var flags = new Array(nc)
    for(var i=0; i<flags.length; ++i) {
      flags[i] = 0
    }
  
    //Build neighbor index, initialize queues
    var active = []
    var next   = []
    var neighbor = new Array(3*nc)
    var constraint = new Array(3*nc)
    var boundary = null
    if(infinity) {
      boundary = []
    }
    var index = new FaceIndex(
      cells,
      neighbor,
      constraint,
      flags,
      active,
      next,
      boundary)
    for(var i=0; i<nc; ++i) {
      var c = cells[i]
      for(var j=0; j<3; ++j) {
        var x = c[j], y = c[(j+1)%3]
        var a = neighbor[3*i+j] = index.locate(y, x, triangulation.opposite(y, x))
        var b = constraint[3*i+j] = triangulation.isConstraint(x, y)
        if(a < 0) {
          if(b) {
            next.push(i)
          } else {
            active.push(i)
            flags[i] = 1
          }
          if(infinity) {
            boundary.push([y, x, -1])
          }
        }
      }
    }
    return index
  }
  
  function filterCells(cells, flags, target) {
    var ptr = 0
    for(var i=0; i<cells.length; ++i) {
      if(flags[i] === target) {
        cells[ptr++] = cells[i]
      }
    }
    cells.length = ptr
    return cells
  }
  
  function classifyFaces(triangulation, target, infinity) {
    var index = indexCells(triangulation, infinity)
  
    if(target === 0) {
      if(infinity) {
        return index.cells.concat(index.boundary)
      } else {
        return index.cells
      }
    }
  
    var side = 1
    var active = index.active
    var next = index.next
    var flags = index.flags
    var cells = index.cells
    var constraint = index.constraint
    var neighbor = index.neighbor
  
    while(active.length > 0 || next.length > 0) {
      while(active.length > 0) {
        var t = active.pop()
        if(flags[t] === -side) {
          continue
        }
        flags[t] = side
        var c = cells[t]
        for(var j=0; j<3; ++j) {
          var f = neighbor[3*t+j]
          if(f >= 0 && flags[f] === 0) {
            if(constraint[3*t+j]) {
              next.push(f)
            } else {
              active.push(f)
              flags[f] = side
            }
          }
        }
      }
  
      //Swap arrays and loop
      var tmp = next
      next = active
      active = tmp
      next.length = 0
      side = -side
    }
  
    var result = filterCells(cells, flags, target)
    if(infinity) {
      return result.concat(index.boundary)
    }
    return result
  }
  
  },{"binary-search-bounds":96}],115:[function(_dereq_,module,exports){
  'use strict'
  
  var bsearch = _dereq_('binary-search-bounds')
  var orient = _dereq_('robust-orientation')[3]
  
  var EVENT_POINT = 0
  var EVENT_END   = 1
  var EVENT_START = 2
  
  module.exports = monotoneTriangulate
  
  //A partial convex hull fragment, made of two unimonotone polygons
  function PartialHull(a, b, idx, lowerIds, upperIds) {
    this.a = a
    this.b = b
    this.idx = idx
    this.lowerIds = lowerIds
    this.upperIds = upperIds
  }
  
  //An event in the sweep line procedure
  function Event(a, b, type, idx) {
    this.a    = a
    this.b    = b
    this.type = type
    this.idx  = idx
  }
  
  //This is used to compare events for the sweep line procedure
  // Points are:
  //  1. sorted lexicographically
  //  2. sorted by type  (point < end < start)
  //  3. segments sorted by winding order
  //  4. sorted by index
  function compareEvent(a, b) {
    var d =
      (a.a[0] - b.a[0]) ||
      (a.a[1] - b.a[1]) ||
      (a.type - b.type)
    if(d) { return d }
    if(a.type !== EVENT_POINT) {
      d = orient(a.a, a.b, b.b)
      if(d) { return d }
    }
    return a.idx - b.idx
  }
  
  function testPoint(hull, p) {
    return orient(hull.a, hull.b, p)
  }
  
  function addPoint(cells, hulls, points, p, idx) {
    var lo = bsearch.lt(hulls, p, testPoint)
    var hi = bsearch.gt(hulls, p, testPoint)
    for(var i=lo; i<hi; ++i) {
      var hull = hulls[i]
  
      //Insert p into lower hull
      var lowerIds = hull.lowerIds
      var m = lowerIds.length
      while(m > 1 && orient(
          points[lowerIds[m-2]],
          points[lowerIds[m-1]],
          p) > 0) {
        cells.push(
          [lowerIds[m-1],
           lowerIds[m-2],
           idx])
        m -= 1
      }
      lowerIds.length = m
      lowerIds.push(idx)
  
      //Insert p into upper hull
      var upperIds = hull.upperIds
      var m = upperIds.length
      while(m > 1 && orient(
          points[upperIds[m-2]],
          points[upperIds[m-1]],
          p) < 0) {
        cells.push(
          [upperIds[m-2],
           upperIds[m-1],
           idx])
        m -= 1
      }
      upperIds.length = m
      upperIds.push(idx)
    }
  }
  
  function findSplit(hull, edge) {
    var d
    if(hull.a[0] < edge.a[0]) {
      d = orient(hull.a, hull.b, edge.a)
    } else {
      d = orient(edge.b, edge.a, hull.a)
    }
    if(d) { return d }
    if(edge.b[0] < hull.b[0]) {
      d = orient(hull.a, hull.b, edge.b)
    } else {
      d = orient(edge.b, edge.a, hull.b)
    }
    return d || hull.idx - edge.idx
  }
  
  function splitHulls(hulls, points, event) {
    var splitIdx = bsearch.le(hulls, event, findSplit)
    var hull = hulls[splitIdx]
    var upperIds = hull.upperIds
    var x = upperIds[upperIds.length-1]
    hull.upperIds = [x]
    hulls.splice(splitIdx+1, 0,
      new PartialHull(event.a, event.b, event.idx, [x], upperIds))
  }
  
  
  function mergeHulls(hulls, points, event) {
    //Swap pointers for merge search
    var tmp = event.a
    event.a = event.b
    event.b = tmp
    var mergeIdx = bsearch.eq(hulls, event, findSplit)
    var upper = hulls[mergeIdx]
    var lower = hulls[mergeIdx-1]
    lower.upperIds = upper.upperIds
    hulls.splice(mergeIdx, 1)
  }
  
  
  function monotoneTriangulate(points, edges) {
  
    var numPoints = points.length
    var numEdges = edges.length
  
    var events = []
  
    //Create point events
    for(var i=0; i<numPoints; ++i) {
      events.push(new Event(
        points[i],
        null,
        EVENT_POINT,
        i))
    }
  
    //Create edge events
    for(var i=0; i<numEdges; ++i) {
      var e = edges[i]
      var a = points[e[0]]
      var b = points[e[1]]
      if(a[0] < b[0]) {
        events.push(
          new Event(a, b, EVENT_START, i),
          new Event(b, a, EVENT_END, i))
      } else if(a[0] > b[0]) {
        events.push(
          new Event(b, a, EVENT_START, i),
          new Event(a, b, EVENT_END, i))
      }
    }
  
    //Sort events
    events.sort(compareEvent)
  
    //Initialize hull
    var minX = events[0].a[0] - (1 + Math.abs(events[0].a[0])) * Math.pow(2, -52)
    var hull = [ new PartialHull([minX, 1], [minX, 0], -1, [], [], [], []) ]
  
    //Process events in order
    var cells = []
    for(var i=0, numEvents=events.length; i<numEvents; ++i) {
      var event = events[i]
      var type = event.type
      if(type === EVENT_POINT) {
        addPoint(cells, hull, points, event.a, event.idx)
      } else if(type === EVENT_START) {
        splitHulls(hull, points, event)
      } else {
        mergeHulls(hull, points, event)
      }
    }
  
    //Return triangulation
    return cells
  }
  
  },{"binary-search-bounds":96,"robust-orientation":520}],116:[function(_dereq_,module,exports){
  'use strict'
  
  var bsearch = _dereq_('binary-search-bounds')
  
  module.exports = createTriangulation
  
  function Triangulation(stars, edges) {
    this.stars = stars
    this.edges = edges
  }
  
  var proto = Triangulation.prototype
  
  function removePair(list, j, k) {
    for(var i=1, n=list.length; i<n; i+=2) {
      if(list[i-1] === j && list[i] === k) {
        list[i-1] = list[n-2]
        list[i] = list[n-1]
        list.length = n - 2
        return
      }
    }
  }
  
  proto.isConstraint = (function() {
    var e = [0,0]
    function compareLex(a, b) {
      return a[0] - b[0] || a[1] - b[1]
    }
    return function(i, j) {
      e[0] = Math.min(i,j)
      e[1] = Math.max(i,j)
      return bsearch.eq(this.edges, e, compareLex) >= 0
    }
  })()
  
  proto.removeTriangle = function(i, j, k) {
    var stars = this.stars
    removePair(stars[i], j, k)
    removePair(stars[j], k, i)
    removePair(stars[k], i, j)
  }
  
  proto.addTriangle = function(i, j, k) {
    var stars = this.stars
    stars[i].push(j, k)
    stars[j].push(k, i)
    stars[k].push(i, j)
  }
  
  proto.opposite = function(j, i) {
    var list = this.stars[i]
    for(var k=1, n=list.length; k<n; k+=2) {
      if(list[k] === j) {
        return list[k-1]
      }
    }
    return -1
  }
  
  proto.flip = function(i, j) {
    var a = this.opposite(i, j)
    var b = this.opposite(j, i)
    this.removeTriangle(i, j, a)
    this.removeTriangle(j, i, b)
    this.addTriangle(i, b, a)
    this.addTriangle(j, a, b)
  }
  
  proto.edges = function() {
    var stars = this.stars
    var result = []
    for(var i=0, n=stars.length; i<n; ++i) {
      var list = stars[i]
      for(var j=0, m=list.length; j<m; j+=2) {
        result.push([list[j], list[j+1]])
      }
    }
    return result
  }
  
  proto.cells = function() {
    var stars = this.stars
    var result = []
    for(var i=0, n=stars.length; i<n; ++i) {
      var list = stars[i]
      for(var j=0, m=list.length; j<m; j+=2) {
        var s = list[j]
        var t = list[j+1]
        if(i < Math.min(s, t)) {
          result.push([i, s, t])
        }
      }
    }
    return result
  }
  
  function createTriangulation(numVerts, edges) {
    var stars = new Array(numVerts)
    for(var i=0; i<numVerts; ++i) {
      stars[i] = []
    }
    return new Triangulation(stars, edges)
  }
  
  },{"binary-search-bounds":96}],117:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = orientation
  
  function orientation(s) {
    var p = 1
    for(var i=1; i<s.length; ++i) {
      for(var j=0; j<i; ++j) {
        if(s[i] < s[j]) {
          p = -p
        } else if(s[j] === s[i]) {
          return 0
        }
      }
    }
    return p
  }
  
  },{}],118:[function(_dereq_,module,exports){
  "use strict"
  
  var dup = _dereq_("dup")
  var solve = _dereq_("robust-linear-solve")
  
  function dot(a, b) {
    var s = 0.0
    var d = a.length
    for(var i=0; i<d; ++i) {
      s += a[i] * b[i]
    }
    return s
  }
  
  function barycentricCircumcenter(points) {
    var N = points.length
    if(N === 0) {
      return []
    }
    
    var D = points[0].length
    var A = dup([points.length+1, points.length+1], 1.0)
    var b = dup([points.length+1], 1.0)
    A[N][N] = 0.0
    for(var i=0; i<N; ++i) {
      for(var j=0; j<=i; ++j) {
        A[j][i] = A[i][j] = 2.0 * dot(points[i], points[j])
      }
      b[i] = dot(points[i], points[i])
    }
    var x = solve(A, b)
  
    var denom = 0.0
    var h = x[N+1]
    for(var i=0; i<h.length; ++i) {
      denom += h[i]
    }
  
    var y = new Array(N)
    for(var i=0; i<N; ++i) {
      var h = x[i]
      var numer = 0.0
      for(var j=0; j<h.length; ++j) {
        numer += h[j]
      }
      y[i] =  numer / denom
    }
  
    return y
  }
  
  function circumcenter(points) {
    if(points.length === 0) {
      return []
    }
    var D = points[0].length
    var result = dup([D])
    var weights = barycentricCircumcenter(points)
    for(var i=0; i<points.length; ++i) {
      for(var j=0; j<D; ++j) {
        result[j] += points[i][j] * weights[i]
      }
    }
    return result
  }
  
  circumcenter.barycenetric = barycentricCircumcenter
  module.exports = circumcenter
  },{"dup":176,"robust-linear-solve":519}],119:[function(_dereq_,module,exports){
  module.exports = circumradius
  
  var circumcenter = _dereq_('circumcenter')
  
  function circumradius(points) {
    var center = circumcenter(points)
    var avgDist = 0.0
    for(var i=0; i<points.length; ++i) {
      var p = points[i]
      for(var j=0; j<center.length; ++j) {
        avgDist += Math.pow(p[j] - center[j], 2)
      }
    }
    return Math.sqrt(avgDist / points.length)
  }
  },{"circumcenter":118}],120:[function(_dereq_,module,exports){
  module.exports = clamp
  
  function clamp(value, min, max) {
    return min < max
      ? (value < min ? min : value > max ? max : value)
      : (value < max ? max : value > min ? min : value)
  }
  
  },{}],121:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = cleanPSLG
  
  var UnionFind = _dereq_('union-find')
  var boxIntersect = _dereq_('box-intersect')
  var segseg = _dereq_('robust-segment-intersect')
  var rat = _dereq_('big-rat')
  var ratCmp = _dereq_('big-rat/cmp')
  var ratToFloat = _dereq_('big-rat/to-float')
  var ratVec = _dereq_('rat-vec')
  var nextafter = _dereq_('nextafter')
  
  var solveIntersection = _dereq_('./lib/rat-seg-intersect')
  
  // Bounds on a rational number when rounded to a float
  function boundRat (r) {
    var f = ratToFloat(r)
    return [
      nextafter(f, -Infinity),
      nextafter(f, Infinity)
    ]
  }
  
  // Convert a list of edges in a pslg to bounding boxes
  function boundEdges (points, edges) {
    var bounds = new Array(edges.length)
    for (var i = 0; i < edges.length; ++i) {
      var e = edges[i]
      var a = points[e[0]]
      var b = points[e[1]]
      bounds[i] = [
        nextafter(Math.min(a[0], b[0]), -Infinity),
        nextafter(Math.min(a[1], b[1]), -Infinity),
        nextafter(Math.max(a[0], b[0]), Infinity),
        nextafter(Math.max(a[1], b[1]), Infinity)
      ]
    }
    return bounds
  }
  
  // Convert a list of points into bounding boxes by duplicating coords
  function boundPoints (points) {
    var bounds = new Array(points.length)
    for (var i = 0; i < points.length; ++i) {
      var p = points[i]
      bounds[i] = [
        nextafter(p[0], -Infinity),
        nextafter(p[1], -Infinity),
        nextafter(p[0], Infinity),
        nextafter(p[1], Infinity)
      ]
    }
    return bounds
  }
  
  // Find all pairs of crossing edges in a pslg (given edge bounds)
  function getCrossings (points, edges, edgeBounds) {
    var result = []
    boxIntersect(edgeBounds, function (i, j) {
      var e = edges[i]
      var f = edges[j]
      if (e[0] === f[0] || e[0] === f[1] ||
        e[1] === f[0] || e[1] === f[1]) {
        return
      }
      var a = points[e[0]]
      var b = points[e[1]]
      var c = points[f[0]]
      var d = points[f[1]]
      if (segseg(a, b, c, d)) {
        result.push([i, j])
      }
    })
    return result
  }
  
  // Find all pairs of crossing vertices in a pslg (given edge/vert bounds)
  function getTJunctions (points, edges, edgeBounds, vertBounds) {
    var result = []
    boxIntersect(edgeBounds, vertBounds, function (i, v) {
      var e = edges[i]
      if (e[0] === v || e[1] === v) {
        return
      }
      var p = points[v]
      var a = points[e[0]]
      var b = points[e[1]]
      if (segseg(a, b, p, p)) {
        result.push([i, v])
      }
    })
    return result
  }
  
  // Cut edges along crossings/tjunctions
  function cutEdges (floatPoints, edges, crossings, junctions, useColor) {
    var i, e
  
    // Convert crossings into tjunctions by constructing rational points
    var ratPoints = floatPoints.map(function(p) {
        return [
            rat(p[0]),
            rat(p[1])
        ]
    })
    for (i = 0; i < crossings.length; ++i) {
      var crossing = crossings[i]
      e = crossing[0]
      var f = crossing[1]
      var ee = edges[e]
      var ef = edges[f]
      var x = solveIntersection(
        ratVec(floatPoints[ee[0]]),
        ratVec(floatPoints[ee[1]]),
        ratVec(floatPoints[ef[0]]),
        ratVec(floatPoints[ef[1]]))
      if (!x) {
        // Segments are parallel, should already be handled by t-junctions
        continue
      }
      var idx = floatPoints.length
      floatPoints.push([ratToFloat(x[0]), ratToFloat(x[1])])
      ratPoints.push(x)
      junctions.push([e, idx], [f, idx])
    }
  
    // Sort tjunctions
    junctions.sort(function (a, b) {
      if (a[0] !== b[0]) {
        return a[0] - b[0]
      }
      var u = ratPoints[a[1]]
      var v = ratPoints[b[1]]
      return ratCmp(u[0], v[0]) || ratCmp(u[1], v[1])
    })
  
    // Split edges along junctions
    for (i = junctions.length - 1; i >= 0; --i) {
      var junction = junctions[i]
      e = junction[0]
  
      var edge = edges[e]
      var s = edge[0]
      var t = edge[1]
  
      // Check if edge is not lexicographically sorted
      var a = floatPoints[s]
      var b = floatPoints[t]
      if (((a[0] - b[0]) || (a[1] - b[1])) < 0) {
        var tmp = s
        s = t
        t = tmp
      }
  
      // Split leading edge
      edge[0] = s
      var last = edge[1] = junction[1]
  
      // If we are grouping edges by color, remember to track data
      var color
      if (useColor) {
        color = edge[2]
      }
  
      // Split other edges
      while (i > 0 && junctions[i - 1][0] === e) {
        var junction = junctions[--i]
        var next = junction[1]
        if (useColor) {
          edges.push([last, next, color])
        } else {
          edges.push([last, next])
        }
        last = next
      }
  
      // Add final edge
      if (useColor) {
        edges.push([last, t, color])
      } else {
        edges.push([last, t])
      }
    }
  
    // Return constructed rational points
    return ratPoints
  }
  
  // Merge overlapping points
  function dedupPoints (floatPoints, ratPoints, floatBounds) {
    var numPoints = ratPoints.length
    var uf = new UnionFind(numPoints)
  
    // Compute rational bounds
    var bounds = []
    for (var i = 0; i < ratPoints.length; ++i) {
      var p = ratPoints[i]
      var xb = boundRat(p[0])
      var yb = boundRat(p[1])
      bounds.push([
        nextafter(xb[0], -Infinity),
        nextafter(yb[0], -Infinity),
        nextafter(xb[1], Infinity),
        nextafter(yb[1], Infinity)
      ])
    }
  
    // Link all points with over lapping boxes
    boxIntersect(bounds, function (i, j) {
      uf.link(i, j)
    })
  
    // Do 1 pass over points to combine points in label sets
    var noDupes = true
    var labels = new Array(numPoints)
    for (var i = 0; i < numPoints; ++i) {
      var j = uf.find(i)
      if (j !== i) {
        // Clear no-dupes flag, zero out label
        noDupes = false
        // Make each point the top-left point from its cell
        floatPoints[j] = [
          Math.min(floatPoints[i][0], floatPoints[j][0]),
          Math.min(floatPoints[i][1], floatPoints[j][1])
        ]
      }
    }
  
    // If no duplicates, return null to signal termination
    if (noDupes) {
      return null
    }
  
    var ptr = 0
    for (var i = 0; i < numPoints; ++i) {
      var j = uf.find(i)
      if (j === i) {
        labels[i] = ptr
        floatPoints[ptr++] = floatPoints[i]
      } else {
        labels[i] = -1
      }
    }
  
    floatPoints.length = ptr
  
    // Do a second pass to fix up missing labels
    for (var i = 0; i < numPoints; ++i) {
      if (labels[i] < 0) {
        labels[i] = labels[uf.find(i)]
      }
    }
  
    // Return resulting union-find data structure
    return labels
  }
  
  function compareLex2 (a, b) { return (a[0] - b[0]) || (a[1] - b[1]) }
  function compareLex3 (a, b) {
    var d = (a[0] - b[0]) || (a[1] - b[1])
    if (d) {
      return d
    }
    if (a[2] < b[2]) {
      return -1
    } else if (a[2] > b[2]) {
      return 1
    }
    return 0
  }
  
  // Remove duplicate edge labels
  function dedupEdges (edges, labels, useColor) {
    if (edges.length === 0) {
      return
    }
    if (labels) {
      for (var i = 0; i < edges.length; ++i) {
        var e = edges[i]
        var a = labels[e[0]]
        var b = labels[e[1]]
        e[0] = Math.min(a, b)
        e[1] = Math.max(a, b)
      }
    } else {
      for (var i = 0; i < edges.length; ++i) {
        var e = edges[i]
        var a = e[0]
        var b = e[1]
        e[0] = Math.min(a, b)
        e[1] = Math.max(a, b)
      }
    }
    if (useColor) {
      edges.sort(compareLex3)
    } else {
      edges.sort(compareLex2)
    }
    var ptr = 1
    for (var i = 1; i < edges.length; ++i) {
      var prev = edges[i - 1]
      var next = edges[i]
      if (next[0] === prev[0] && next[1] === prev[1] &&
        (!useColor || next[2] === prev[2])) {
        continue
      }
      edges[ptr++] = next
    }
    edges.length = ptr
  }
  
  function preRound (points, edges, useColor) {
    var labels = dedupPoints(points, [], boundPoints(points))
    dedupEdges(edges, labels, useColor)
    return !!labels
  }
  
  // Repeat until convergence
  function snapRound (points, edges, useColor) {
    // 1. find edge crossings
    var edgeBounds = boundEdges(points, edges)
    var crossings = getCrossings(points, edges, edgeBounds)
  
    // 2. find t-junctions
    var vertBounds = boundPoints(points)
    var tjunctions = getTJunctions(points, edges, edgeBounds, vertBounds)
  
    // 3. cut edges, construct rational points
    var ratPoints = cutEdges(points, edges, crossings, tjunctions, useColor)
  
    // 4. dedupe verts
    var labels = dedupPoints(points, ratPoints, vertBounds)
  
    // 5. dedupe edges
    dedupEdges(edges, labels, useColor)
  
    // 6. check termination
    if (!labels) {
      return (crossings.length > 0 || tjunctions.length > 0)
    }
  
    // More iterations necessary
    return true
  }
  
  // Main loop, runs PSLG clean up until completion
  function cleanPSLG (points, edges, colors) {
    // If using colors, augment edges with color data
    var prevEdges
    if (colors) {
      prevEdges = edges
      var augEdges = new Array(edges.length)
      for (var i = 0; i < edges.length; ++i) {
        var e = edges[i]
        augEdges[i] = [e[0], e[1], colors[i]]
      }
      edges = augEdges
    }
  
    // First round: remove duplicate edges and points
    var modified = preRound(points, edges, !!colors)
  
    // Run snap rounding until convergence
    while (snapRound(points, edges, !!colors)) {
      modified = true
    }
  
    // Strip color tags
    if (!!colors && modified) {
      prevEdges.length = 0
      colors.length = 0
      for (var i = 0; i < edges.length; ++i) {
        var e = edges[i]
        prevEdges.push([e[0], e[1]])
        colors.push(e[2])
      }
    }
  
    return modified
  }
  
  },{"./lib/rat-seg-intersect":122,"big-rat":83,"big-rat/cmp":81,"big-rat/to-float":95,"box-intersect":101,"nextafter":470,"rat-vec":504,"robust-segment-intersect":523,"union-find":568}],122:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = solveIntersection
  
  var ratMul = _dereq_('big-rat/mul')
  var ratDiv = _dereq_('big-rat/div')
  var ratSub = _dereq_('big-rat/sub')
  var ratSign = _dereq_('big-rat/sign')
  var rvSub = _dereq_('rat-vec/sub')
  var rvAdd = _dereq_('rat-vec/add')
  var rvMuls = _dereq_('rat-vec/muls')
  
  function ratPerp (a, b) {
    return ratSub(ratMul(a[0], b[1]), ratMul(a[1], b[0]))
  }
  
  // Solve for intersection
  //  x = a + t (b-a)
  //  (x - c) ^ (d-c) = 0
  //  (t * (b-a) + (a-c) ) ^ (d-c) = 0
  //  t * (b-a)^(d-c) = (d-c)^(a-c)
  //  t = (d-c)^(a-c) / (b-a)^(d-c)
  
  function solveIntersection (a, b, c, d) {
    var ba = rvSub(b, a)
    var dc = rvSub(d, c)
  
    var baXdc = ratPerp(ba, dc)
  
    if (ratSign(baXdc) === 0) {
      return null
    }
  
    var ac = rvSub(a, c)
    var dcXac = ratPerp(dc, ac)
  
    var t = ratDiv(dcXac, baXdc)
    var s = rvMuls(ba, t)
    var r = rvAdd(a, s)
  
    return r
  }
  
  },{"big-rat/div":82,"big-rat/mul":92,"big-rat/sign":93,"big-rat/sub":94,"rat-vec/add":503,"rat-vec/muls":505,"rat-vec/sub":506}],123:[function(_dereq_,module,exports){
  /** @module  color-id */
  
  'use strict'
  
  var clamp = _dereq_('clamp')
  
  module.exports = toNumber
  module.exports.to = toNumber
  module.exports.from = fromNumber
  
  function toNumber (rgba, normalized) {
    if(normalized == null) normalized = true
  
    var r = rgba[0], g = rgba[1], b = rgba[2], a = rgba[3]
  
    if (a == null) a = normalized ? 1 : 255
  
    if (normalized) {
      r *= 255
      g *= 255
      b *= 255
      a *= 255
    }
  
    r = clamp(r, 0, 255) & 0xFF
    g = clamp(g, 0, 255) & 0xFF
    b = clamp(b, 0, 255) & 0xFF
    a = clamp(a, 0, 255) & 0xFF
  
    //hi-order shift converts to -1, so we can't use <<24
    var n = (r * 0x01000000) + (g << 16) + (b << 8) + (a)
  
    return n
  }
  
  function fromNumber (n, normalized) {
    n = +n
  
    var r = n >>> 24
    var g = (n & 0x00ff0000) >>> 16
    var b = (n & 0x0000ff00) >>> 8
    var a = n & 0x000000ff
  
    if (normalized === false) return [r, g, b, a]
  
    return [r/255, g/255, b/255, a/255]
  }
  
  },{"clamp":120}],124:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
  };
  
  },{}],125:[function(_dereq_,module,exports){
  /** @module  color-normalize */
  
  'use strict'
  
  var rgba = _dereq_('color-rgba')
  var clamp = _dereq_('clamp')
  var dtype = _dereq_('dtype')
  
  module.exports = function normalize (color, type) {
    if (type === 'float' || !type) type = 'array'
    if (type === 'uint') type = 'uint8'
    if (type === 'uint_clamped') type = 'uint8_clamped'
    var Ctor = dtype(type)
    var output = new Ctor(4)
  
    var normalize = type !== 'uint8' && type !== 'uint8_clamped'
  
    // attempt to parse non-array arguments
    if (!color.length || typeof color === 'string') {
      color = rgba(color)
      color[0] /= 255
      color[1] /= 255
      color[2] /= 255
    }
  
    // 0, 1 are possible contradictory values for Arrays:
    // [1,1,1] input gives [1,1,1] output instead of [1/255,1/255,1/255], which may be collision if input is meant to be uint.
    // converting [1,1,1] to [1/255,1/255,1/255] in case of float input gives larger mistake since [1,1,1] float is frequent edge value, whereas [0,1,1], [1,1,1] etc. uint inputs are relatively rare
    if (isInt(color)) {
      output[0] = color[0]
      output[1] = color[1]
      output[2] = color[2]
      output[3] = color[3] != null ? color[3] : 255
  
      if (normalize) {
        output[0] /= 255
        output[1] /= 255
        output[2] /= 255
        output[3] /= 255
      }
  
      return output
    }
  
    if (!normalize) {
      output[0] = clamp(Math.floor(color[0] * 255), 0, 255)
      output[1] = clamp(Math.floor(color[1] * 255), 0, 255)
      output[2] = clamp(Math.floor(color[2] * 255), 0, 255)
      output[3] = color[3] == null ? 255 : clamp(Math.floor(color[3] * 255), 0, 255)
    } else {
      output[0] = color[0]
      output[1] = color[1]
      output[2] = color[2]
      output[3] = color[3] != null ? color[3] : 1
    }
  
    return output
  }
  
  function isInt(color) {
    if (color instanceof Uint8Array || color instanceof Uint8ClampedArray) return true
  
    if (Array.isArray(color) &&
      (color[0] > 1 || color[0] === 0) &&
      (color[1] > 1 || color[1] === 0) &&
      (color[2] > 1 || color[2] === 0) &&
      (!color[3] || color[3] > 1)
    ) return true
  
    return false
  }
  
  },{"clamp":120,"color-rgba":127,"dtype":175}],126:[function(_dereq_,module,exports){
  (function (global){
  /**
   * @module color-parse
   */
  
  'use strict'
  
  var names = _dereq_('color-name')
  var isObject = _dereq_('is-plain-obj')
  var defined = _dereq_('defined')
  
  module.exports = parse
  
  /**
   * Base hues
   * http://dev.w3.org/csswg/css-color/#typedef-named-hue
   */
  //FIXME: use external hue detector
  var baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
  }
  
  /**
   * Parse color from the string passed
   *
   * @return {Object} A space indicator `space`, an array `values` and `alpha`
   */
  function parse (cstr) {
    var m, parts = [], alpha = 1, space
  
    if (typeof cstr === 'string') {
      //keyword
      if (names[cstr]) {
        parts = names[cstr].slice()
        space = 'rgb'
      }
  
      //reserved words
      else if (cstr === 'transparent') {
        alpha = 0
        space = 'rgb'
        parts = [0,0,0]
      }
  
      //hex
      else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
        var base = cstr.slice(1)
        var size = base.length
        var isShort = size <= 4
        alpha = 1
  
        if (isShort) {
          parts = [
            parseInt(base[0] + base[0], 16),
            parseInt(base[1] + base[1], 16),
            parseInt(base[2] + base[2], 16)
          ]
          if (size === 4) {
            alpha = parseInt(base[3] + base[3], 16) / 255
          }
        }
        else {
          parts = [
            parseInt(base[0] + base[1], 16),
            parseInt(base[2] + base[3], 16),
            parseInt(base[4] + base[5], 16)
          ]
          if (size === 8) {
            alpha = parseInt(base[6] + base[7], 16) / 255
          }
        }
  
        if (!parts[0]) parts[0] = 0
        if (!parts[1]) parts[1] = 0
        if (!parts[2]) parts[2] = 0
  
        space = 'rgb'
      }
  
      //color space
      else if (m = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
        var name = m[1]
        var isRGB = name === 'rgb'
        var base = name.replace(/a$/, '')
        space = base
        var size = base === 'cmyk' ? 4 : base === 'gray' ? 1 : 3
        parts = m[2].trim()
          .split(/\s*,\s*/)
          .map(function (x, i) {
            //<percentage>
            if (/%$/.test(x)) {
              //alpha
              if (i === size)	return parseFloat(x) / 100
              //rgb
              if (base === 'rgb') return parseFloat(x) * 255 / 100
              return parseFloat(x)
            }
            //hue
            else if (base[i] === 'h') {
              //<deg>
              if (/deg$/.test(x)) {
                return parseFloat(x)
              }
              //<base-hue>
              else if (baseHues[x] !== undefined) {
                return baseHues[x]
              }
            }
            return parseFloat(x)
          })
  
        if (name === base) parts.push(1)
        alpha = (isRGB) ? 1 : (parts[size] === undefined) ? 1 : parts[size]
        parts = parts.slice(0, size)
      }
  
      //named channels case
      else if (cstr.length > 10 && /[0-9](?:\s|\/)/.test(cstr)) {
        parts = cstr.match(/([0-9]+)/g).map(function (value) {
          return parseFloat(value)
        })
  
        space = cstr.match(/([a-z])/ig).join('').toLowerCase()
      }
    }
  
    //numeric case
    else if (!isNaN(cstr)) {
      space = 'rgb'
      parts = [cstr >>> 16, (cstr & 0x00ff00) >>> 8, cstr & 0x0000ff]
    }
  
    //object case - detects css cases of rgb and hsl
    else if (isObject(cstr)) {
      var r = defined(cstr.r, cstr.red, cstr.R, null)
  
      if (r !== null) {
        space = 'rgb'
        parts = [
          r,
          defined(cstr.g, cstr.green, cstr.G),
          defined(cstr.b, cstr.blue, cstr.B)
        ]
      }
      else {
        space = 'hsl'
        parts = [
          defined(cstr.h, cstr.hue, cstr.H),
          defined(cstr.s, cstr.saturation, cstr.S),
          defined(cstr.l, cstr.lightness, cstr.L, cstr.b, cstr.brightness)
        ]
      }
  
      alpha = defined(cstr.a, cstr.alpha, cstr.opacity, 1)
  
      if (cstr.opacity != null) alpha /= 100
    }
  
    //array
    else if (Array.isArray(cstr) || global.ArrayBuffer && ArrayBuffer.isView && ArrayBuffer.isView(cstr)) {
      parts = [cstr[0], cstr[1], cstr[2]]
      space = 'rgb'
      alpha = cstr.length === 4 ? cstr[3] : 1
    }
  
    return {
      space: space,
      values: parts,
      alpha: alpha
    }
  }
  
  }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{"color-name":124,"defined":170,"is-plain-obj":443}],127:[function(_dereq_,module,exports){
  /** @module  color-rgba */
  
  'use strict'
  
  var parse = _dereq_('color-parse')
  var hsl = _dereq_('color-space/hsl')
  var clamp = _dereq_('clamp')
  
  module.exports = function rgba (color) {
    var values, i, l
  
    //attempt to parse non-array arguments
    var parsed = parse(color)
  
    if (!parsed.space) return []
  
    values = Array(3)
    values[0] = clamp(parsed.values[0], 0, 255)
    values[1] = clamp(parsed.values[1], 0, 255)
    values[2] = clamp(parsed.values[2], 0, 255)
  
    if (parsed.space[0] === 'h') {
      values = hsl.rgb(values)
    }
  
    values.push(clamp(parsed.alpha, 0, 1))
  
    return values
  }
  
  },{"clamp":120,"color-parse":126,"color-space/hsl":128}],128:[function(_dereq_,module,exports){
  /**
   * @module color-space/hsl
   */
  'use strict'
  
  var rgb = _dereq_('./rgb');
  
  module.exports = {
    name: 'hsl',
    min: [0,0,0],
    max: [360,100,100],
    channel: ['hue', 'saturation', 'lightness'],
    alias: ['HSL'],
  
    rgb: function(hsl) {
      var h = hsl[0] / 360,
          s = hsl[1] / 100,
          l = hsl[2] / 100,
          t1, t2, t3, rgb, val;
  
      if (s === 0) {
        val = l * 255;
        return [val, val, val];
      }
  
      if (l < 0.5) {
        t2 = l * (1 + s);
      }
      else {
        t2 = l + s - l * s;
      }
      t1 = 2 * l - t2;
  
      rgb = [0, 0, 0];
      for (var i = 0; i < 3; i++) {
        t3 = h + 1 / 3 * - (i - 1);
        if (t3 < 0) {
          t3++;
        }
        else if (t3 > 1) {
          t3--;
        }
  
        if (6 * t3 < 1) {
          val = t1 + (t2 - t1) * 6 * t3;
        }
        else if (2 * t3 < 1) {
          val = t2;
        }
        else if (3 * t3 < 2) {
          val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        }
        else {
          val = t1;
        }
  
        rgb[i] = val * 255;
      }
  
      return rgb;
    }
  };
  
  
  //extend rgb
  rgb.hsl = function(rgb) {
    var r = rgb[0]/255,
        g = rgb[1]/255,
        b = rgb[2]/255,
        min = Math.min(r, g, b),
        max = Math.max(r, g, b),
        delta = max - min,
        h, s, l;
  
    if (max === min) {
      h = 0;
    }
    else if (r === max) {
      h = (g - b) / delta;
    }
    else if (g === max) {
      h = 2 + (b - r) / delta;
    }
    else if (b === max) {
      h = 4 + (r - g)/ delta;
    }
  
    h = Math.min(h * 60, 360);
  
    if (h < 0) {
      h += 360;
    }
  
    l = (min + max) / 2;
  
    if (max === min) {
      s = 0;
    }
    else if (l <= 0.5) {
      s = delta / (max + min);
    }
    else {
      s = delta / (2 - max - min);
    }
  
    return [h, s * 100, l * 100];
  };
  
  },{"./rgb":129}],129:[function(_dereq_,module,exports){
  /**
   * RGB space.
   *
   * @module  color-space/rgb
   */
  'use strict'
  
  module.exports = {
    name: 'rgb',
    min: [0,0,0],
    max: [255,255,255],
    channel: ['red', 'green', 'blue'],
    alias: ['RGB']
  };
  
  },{}],130:[function(_dereq_,module,exports){
  module.exports={
    "jet":[{"index":0,"rgb":[0,0,131]},{"index":0.125,"rgb":[0,60,170]},{"index":0.375,"rgb":[5,255,255]},{"index":0.625,"rgb":[255,255,0]},{"index":0.875,"rgb":[250,0,0]},{"index":1,"rgb":[128,0,0]}],
  
    "hsv":[{"index":0,"rgb":[255,0,0]},{"index":0.169,"rgb":[253,255,2]},{"index":0.173,"rgb":[247,255,2]},{"index":0.337,"rgb":[0,252,4]},{"index":0.341,"rgb":[0,252,10]},{"index":0.506,"rgb":[1,249,255]},{"index":0.671,"rgb":[2,0,253]},{"index":0.675,"rgb":[8,0,253]},{"index":0.839,"rgb":[255,0,251]},{"index":0.843,"rgb":[255,0,245]},{"index":1,"rgb":[255,0,6]}],
  
    "hot":[{"index":0,"rgb":[0,0,0]},{"index":0.3,"rgb":[230,0,0]},{"index":0.6,"rgb":[255,210,0]},{"index":1,"rgb":[255,255,255]}],
  
    "cool":[{"index":0,"rgb":[0,255,255]},{"index":1,"rgb":[255,0,255]}],
  
    "spring":[{"index":0,"rgb":[255,0,255]},{"index":1,"rgb":[255,255,0]}],
  
    "summer":[{"index":0,"rgb":[0,128,102]},{"index":1,"rgb":[255,255,102]}],
  
    "autumn":[{"index":0,"rgb":[255,0,0]},{"index":1,"rgb":[255,255,0]}],
  
    "winter":[{"index":0,"rgb":[0,0,255]},{"index":1,"rgb":[0,255,128]}],
  
    "bone":[{"index":0,"rgb":[0,0,0]},{"index":0.376,"rgb":[84,84,116]},{"index":0.753,"rgb":[169,200,200]},{"index":1,"rgb":[255,255,255]}],
  
    "copper":[{"index":0,"rgb":[0,0,0]},{"index":0.804,"rgb":[255,160,102]},{"index":1,"rgb":[255,199,127]}],
  
    "greys":[{"index":0,"rgb":[0,0,0]},{"index":1,"rgb":[255,255,255]}],
  
    "yignbu":[{"index":0,"rgb":[8,29,88]},{"index":0.125,"rgb":[37,52,148]},{"index":0.25,"rgb":[34,94,168]},{"index":0.375,"rgb":[29,145,192]},{"index":0.5,"rgb":[65,182,196]},{"index":0.625,"rgb":[127,205,187]},{"index":0.75,"rgb":[199,233,180]},{"index":0.875,"rgb":[237,248,217]},{"index":1,"rgb":[255,255,217]}],
  
    "greens":[{"index":0,"rgb":[0,68,27]},{"index":0.125,"rgb":[0,109,44]},{"index":0.25,"rgb":[35,139,69]},{"index":0.375,"rgb":[65,171,93]},{"index":0.5,"rgb":[116,196,118]},{"index":0.625,"rgb":[161,217,155]},{"index":0.75,"rgb":[199,233,192]},{"index":0.875,"rgb":[229,245,224]},{"index":1,"rgb":[247,252,245]}],
  
    "yiorrd":[{"index":0,"rgb":[128,0,38]},{"index":0.125,"rgb":[189,0,38]},{"index":0.25,"rgb":[227,26,28]},{"index":0.375,"rgb":[252,78,42]},{"index":0.5,"rgb":[253,141,60]},{"index":0.625,"rgb":[254,178,76]},{"index":0.75,"rgb":[254,217,118]},{"index":0.875,"rgb":[255,237,160]},{"index":1,"rgb":[255,255,204]}],
  
    "bluered":[{"index":0,"rgb":[0,0,255]},{"index":1,"rgb":[255,0,0]}],
  
    "rdbu":[{"index":0,"rgb":[5,10,172]},{"index":0.35,"rgb":[106,137,247]},{"index":0.5,"rgb":[190,190,190]},{"index":0.6,"rgb":[220,170,132]},{"index":0.7,"rgb":[230,145,90]},{"index":1,"rgb":[178,10,28]}],
  
    "picnic":[{"index":0,"rgb":[0,0,255]},{"index":0.1,"rgb":[51,153,255]},{"index":0.2,"rgb":[102,204,255]},{"index":0.3,"rgb":[153,204,255]},{"index":0.4,"rgb":[204,204,255]},{"index":0.5,"rgb":[255,255,255]},{"index":0.6,"rgb":[255,204,255]},{"index":0.7,"rgb":[255,153,255]},{"index":0.8,"rgb":[255,102,204]},{"index":0.9,"rgb":[255,102,102]},{"index":1,"rgb":[255,0,0]}],
  
    "rainbow":[{"index":0,"rgb":[150,0,90]},{"index":0.125,"rgb":[0,0,200]},{"index":0.25,"rgb":[0,25,255]},{"index":0.375,"rgb":[0,152,255]},{"index":0.5,"rgb":[44,255,150]},{"index":0.625,"rgb":[151,255,0]},{"index":0.75,"rgb":[255,234,0]},{"index":0.875,"rgb":[255,111,0]},{"index":1,"rgb":[255,0,0]}],
  
    "portland":[{"index":0,"rgb":[12,51,131]},{"index":0.25,"rgb":[10,136,186]},{"index":0.5,"rgb":[242,211,56]},{"index":0.75,"rgb":[242,143,56]},{"index":1,"rgb":[217,30,30]}],
  
    "blackbody":[{"index":0,"rgb":[0,0,0]},{"index":0.2,"rgb":[230,0,0]},{"index":0.4,"rgb":[230,210,0]},{"index":0.7,"rgb":[255,255,255]},{"index":1,"rgb":[160,200,255]}],
  
    "earth":[{"index":0,"rgb":[0,0,130]},{"index":0.1,"rgb":[0,180,180]},{"index":0.2,"rgb":[40,210,40]},{"index":0.4,"rgb":[230,230,50]},{"index":0.6,"rgb":[120,70,20]},{"index":1,"rgb":[255,255,255]}],
  
    "electric":[{"index":0,"rgb":[0,0,0]},{"index":0.15,"rgb":[30,0,100]},{"index":0.4,"rgb":[120,0,100]},{"index":0.6,"rgb":[160,90,0]},{"index":0.8,"rgb":[230,200,0]},{"index":1,"rgb":[255,250,220]}],
  
    "alpha": [{"index":0, "rgb": [255,255,255,0]},{"index":1, "rgb": [255,255,255,1]}],
  
    "viridis": [{"index":0,"rgb":[68,1,84]},{"index":0.13,"rgb":[71,44,122]},{"index":0.25,"rgb":[59,81,139]},{"index":0.38,"rgb":[44,113,142]},{"index":0.5,"rgb":[33,144,141]},{"index":0.63,"rgb":[39,173,129]},{"index":0.75,"rgb":[92,200,99]},{"index":0.88,"rgb":[170,220,50]},{"index":1,"rgb":[253,231,37]}],
  
    "inferno": [{"index":0,"rgb":[0,0,4]},{"index":0.13,"rgb":[31,12,72]},{"index":0.25,"rgb":[85,15,109]},{"index":0.38,"rgb":[136,34,106]},{"index":0.5,"rgb":[186,54,85]},{"index":0.63,"rgb":[227,89,51]},{"index":0.75,"rgb":[249,140,10]},{"index":0.88,"rgb":[249,201,50]},{"index":1,"rgb":[252,255,164]}],
  
    "magma": [{"index":0,"rgb":[0,0,4]},{"index":0.13,"rgb":[28,16,68]},{"index":0.25,"rgb":[79,18,123]},{"index":0.38,"rgb":[129,37,129]},{"index":0.5,"rgb":[181,54,122]},{"index":0.63,"rgb":[229,80,100]},{"index":0.75,"rgb":[251,135,97]},{"index":0.88,"rgb":[254,194,135]},{"index":1,"rgb":[252,253,191]}],
  
    "plasma": [{"index":0,"rgb":[13,8,135]},{"index":0.13,"rgb":[75,3,161]},{"index":0.25,"rgb":[125,3,168]},{"index":0.38,"rgb":[168,34,150]},{"index":0.5,"rgb":[203,70,121]},{"index":0.63,"rgb":[229,107,93]},{"index":0.75,"rgb":[248,148,65]},{"index":0.88,"rgb":[253,195,40]},{"index":1,"rgb":[240,249,33]}],
  
    "warm": [{"index":0,"rgb":[125,0,179]},{"index":0.13,"rgb":[172,0,187]},{"index":0.25,"rgb":[219,0,170]},{"index":0.38,"rgb":[255,0,130]},{"index":0.5,"rgb":[255,63,74]},{"index":0.63,"rgb":[255,123,0]},{"index":0.75,"rgb":[234,176,0]},{"index":0.88,"rgb":[190,228,0]},{"index":1,"rgb":[147,255,0]}],
  
    "cool": [{"index":0,"rgb":[125,0,179]},{"index":0.13,"rgb":[116,0,218]},{"index":0.25,"rgb":[98,74,237]},{"index":0.38,"rgb":[68,146,231]},{"index":0.5,"rgb":[0,204,197]},{"index":0.63,"rgb":[0,247,146]},{"index":0.75,"rgb":[0,255,88]},{"index":0.88,"rgb":[40,255,8]},{"index":1,"rgb":[147,255,0]}],
  
    "rainbow-soft": [{"index":0,"rgb":[125,0,179]},{"index":0.1,"rgb":[199,0,180]},{"index":0.2,"rgb":[255,0,121]},{"index":0.3,"rgb":[255,108,0]},{"index":0.4,"rgb":[222,194,0]},{"index":0.5,"rgb":[150,255,0]},{"index":0.6,"rgb":[0,255,55]},{"index":0.7,"rgb":[0,246,150]},{"index":0.8,"rgb":[50,167,222]},{"index":0.9,"rgb":[103,51,235]},{"index":1,"rgb":[124,0,186]}],
  
    "bathymetry": [{"index":0,"rgb":[40,26,44]},{"index":0.13,"rgb":[59,49,90]},{"index":0.25,"rgb":[64,76,139]},{"index":0.38,"rgb":[63,110,151]},{"index":0.5,"rgb":[72,142,158]},{"index":0.63,"rgb":[85,174,163]},{"index":0.75,"rgb":[120,206,163]},{"index":0.88,"rgb":[187,230,172]},{"index":1,"rgb":[253,254,204]}],
  
    "cdom": [{"index":0,"rgb":[47,15,62]},{"index":0.13,"rgb":[87,23,86]},{"index":0.25,"rgb":[130,28,99]},{"index":0.38,"rgb":[171,41,96]},{"index":0.5,"rgb":[206,67,86]},{"index":0.63,"rgb":[230,106,84]},{"index":0.75,"rgb":[242,149,103]},{"index":0.88,"rgb":[249,193,135]},{"index":1,"rgb":[254,237,176]}],
  
    "chlorophyll": [{"index":0,"rgb":[18,36,20]},{"index":0.13,"rgb":[25,63,41]},{"index":0.25,"rgb":[24,91,59]},{"index":0.38,"rgb":[13,119,72]},{"index":0.5,"rgb":[18,148,80]},{"index":0.63,"rgb":[80,173,89]},{"index":0.75,"rgb":[132,196,122]},{"index":0.88,"rgb":[175,221,162]},{"index":1,"rgb":[215,249,208]}],
  
    "density": [{"index":0,"rgb":[54,14,36]},{"index":0.13,"rgb":[89,23,80]},{"index":0.25,"rgb":[110,45,132]},{"index":0.38,"rgb":[120,77,178]},{"index":0.5,"rgb":[120,113,213]},{"index":0.63,"rgb":[115,151,228]},{"index":0.75,"rgb":[134,185,227]},{"index":0.88,"rgb":[177,214,227]},{"index":1,"rgb":[230,241,241]}],
  
    "freesurface-blue": [{"index":0,"rgb":[30,4,110]},{"index":0.13,"rgb":[47,14,176]},{"index":0.25,"rgb":[41,45,236]},{"index":0.38,"rgb":[25,99,212]},{"index":0.5,"rgb":[68,131,200]},{"index":0.63,"rgb":[114,156,197]},{"index":0.75,"rgb":[157,181,203]},{"index":0.88,"rgb":[200,208,216]},{"index":1,"rgb":[241,237,236]}],
  
    "freesurface-red": [{"index":0,"rgb":[60,9,18]},{"index":0.13,"rgb":[100,17,27]},{"index":0.25,"rgb":[142,20,29]},{"index":0.38,"rgb":[177,43,27]},{"index":0.5,"rgb":[192,87,63]},{"index":0.63,"rgb":[205,125,105]},{"index":0.75,"rgb":[216,162,148]},{"index":0.88,"rgb":[227,199,193]},{"index":1,"rgb":[241,237,236]}],
  
    "oxygen": [{"index":0,"rgb":[64,5,5]},{"index":0.13,"rgb":[106,6,15]},{"index":0.25,"rgb":[144,26,7]},{"index":0.38,"rgb":[168,64,3]},{"index":0.5,"rgb":[188,100,4]},{"index":0.63,"rgb":[206,136,11]},{"index":0.75,"rgb":[220,174,25]},{"index":0.88,"rgb":[231,215,44]},{"index":1,"rgb":[248,254,105]}],
  
    "par": [{"index":0,"rgb":[51,20,24]},{"index":0.13,"rgb":[90,32,35]},{"index":0.25,"rgb":[129,44,34]},{"index":0.38,"rgb":[159,68,25]},{"index":0.5,"rgb":[182,99,19]},{"index":0.63,"rgb":[199,134,22]},{"index":0.75,"rgb":[212,171,35]},{"index":0.88,"rgb":[221,210,54]},{"index":1,"rgb":[225,253,75]}],
  
    "phase": [{"index":0,"rgb":[145,105,18]},{"index":0.13,"rgb":[184,71,38]},{"index":0.25,"rgb":[186,58,115]},{"index":0.38,"rgb":[160,71,185]},{"index":0.5,"rgb":[110,97,218]},{"index":0.63,"rgb":[50,123,164]},{"index":0.75,"rgb":[31,131,110]},{"index":0.88,"rgb":[77,129,34]},{"index":1,"rgb":[145,105,18]}],
  
    "salinity": [{"index":0,"rgb":[42,24,108]},{"index":0.13,"rgb":[33,50,162]},{"index":0.25,"rgb":[15,90,145]},{"index":0.38,"rgb":[40,118,137]},{"index":0.5,"rgb":[59,146,135]},{"index":0.63,"rgb":[79,175,126]},{"index":0.75,"rgb":[120,203,104]},{"index":0.88,"rgb":[193,221,100]},{"index":1,"rgb":[253,239,154]}],
  
    "temperature": [{"index":0,"rgb":[4,35,51]},{"index":0.13,"rgb":[23,51,122]},{"index":0.25,"rgb":[85,59,157]},{"index":0.38,"rgb":[129,79,143]},{"index":0.5,"rgb":[175,95,130]},{"index":0.63,"rgb":[222,112,101]},{"index":0.75,"rgb":[249,146,66]},{"index":0.88,"rgb":[249,196,65]},{"index":1,"rgb":[232,250,91]}],
  
    "turbidity": [{"index":0,"rgb":[34,31,27]},{"index":0.13,"rgb":[65,50,41]},{"index":0.25,"rgb":[98,69,52]},{"index":0.38,"rgb":[131,89,57]},{"index":0.5,"rgb":[161,112,59]},{"index":0.63,"rgb":[185,140,66]},{"index":0.75,"rgb":[202,174,88]},{"index":0.88,"rgb":[216,209,126]},{"index":1,"rgb":[233,246,171]}],
  
    "velocity-blue": [{"index":0,"rgb":[17,32,64]},{"index":0.13,"rgb":[35,52,116]},{"index":0.25,"rgb":[29,81,156]},{"index":0.38,"rgb":[31,113,162]},{"index":0.5,"rgb":[50,144,169]},{"index":0.63,"rgb":[87,173,176]},{"index":0.75,"rgb":[149,196,189]},{"index":0.88,"rgb":[203,221,211]},{"index":1,"rgb":[254,251,230]}],
  
    "velocity-green": [{"index":0,"rgb":[23,35,19]},{"index":0.13,"rgb":[24,64,38]},{"index":0.25,"rgb":[11,95,45]},{"index":0.38,"rgb":[39,123,35]},{"index":0.5,"rgb":[95,146,12]},{"index":0.63,"rgb":[152,165,18]},{"index":0.75,"rgb":[201,186,69]},{"index":0.88,"rgb":[233,216,137]},{"index":1,"rgb":[255,253,205]}],
  
    "cubehelix": [{"index":0,"rgb":[0,0,0]},{"index":0.07,"rgb":[22,5,59]},{"index":0.13,"rgb":[60,4,105]},{"index":0.2,"rgb":[109,1,135]},{"index":0.27,"rgb":[161,0,147]},{"index":0.33,"rgb":[210,2,142]},{"index":0.4,"rgb":[251,11,123]},{"index":0.47,"rgb":[255,29,97]},{"index":0.53,"rgb":[255,54,69]},{"index":0.6,"rgb":[255,85,46]},{"index":0.67,"rgb":[255,120,34]},{"index":0.73,"rgb":[255,157,37]},{"index":0.8,"rgb":[241,191,57]},{"index":0.87,"rgb":[224,220,93]},{"index":0.93,"rgb":[218,241,142]},{"index":1,"rgb":[227,253,198]}]
  };
  
  },{}],131:[function(_dereq_,module,exports){
  /*
   * Ben Postlethwaite
   * January 2013
   * License MIT
   */
  'use strict';
  
  var colorScale = _dereq_('./colorScale');
  var lerp = _dereq_('lerp')
  
  module.exports = createColormap;
  
  function createColormap (spec) {
      /*
       * Default Options
       */
      var indicies, fromrgba, torgba,
          nsteps, cmap, colormap, format,
          nshades, colors, alpha, i;
  
      if ( !spec ) spec = {};
  
      nshades = (spec.nshades || 72) - 1;
      format = spec.format || 'hex';
  
      colormap = spec.colormap;
      if (!colormap) colormap = 'jet';
  
      if (typeof colormap === 'string') {
          colormap = colormap.toLowerCase();
  
          if (!colorScale[colormap]) {
              throw Error(colormap + ' not a supported colorscale');
          }
  
          cmap = colorScale[colormap];
  
      } else if (Array.isArray(colormap)) {
          cmap = colormap.slice();
  
      } else {
          throw Error('unsupported colormap option', colormap);
      }
  
      if (cmap.length > nshades + 1) {
          throw new Error(
              colormap+' map requires nshades to be at least size '+cmap.length
          );
      }
  
      if (!Array.isArray(spec.alpha)) {
  
          if (typeof spec.alpha === 'number') {
              alpha = [spec.alpha, spec.alpha];
  
          } else {
              alpha = [1, 1];
          }
  
      } else if (spec.alpha.length !== 2) {
          alpha = [1, 1];
  
      } else {
          alpha = spec.alpha.slice();
      }
  
      // map index points from 0..1 to 0..n-1
      indicies = cmap.map(function(c) {
          return Math.round(c.index * nshades);
      });
  
      // Add alpha channel to the map
      alpha[0] = Math.min(Math.max(alpha[0], 0), 1);
      alpha[1] = Math.min(Math.max(alpha[1], 0), 1);
  
      var steps = cmap.map(function(c, i) {
          var index = cmap[i].index
  
          var rgba = cmap[i].rgb.slice();
  
          // if user supplies their own map use it
          if (rgba.length === 4 && rgba[3] >= 0 && rgba[3] <= 1) {
              return rgba
          }
          rgba[3] = alpha[0] + (alpha[1] - alpha[0])*index;
  
          return rgba
      })
  
  
      /*
       * map increasing linear values between indicies to
       * linear steps in colorvalues
       */
      var colors = []
      for (i = 0; i < indicies.length-1; ++i) {
          nsteps = indicies[i+1] - indicies[i];
          fromrgba = steps[i];
          torgba = steps[i+1];
  
          for (var j = 0; j < nsteps; j++) {
              var amt = j / nsteps
              colors.push([
                  Math.round(lerp(fromrgba[0], torgba[0], amt)),
                  Math.round(lerp(fromrgba[1], torgba[1], amt)),
                  Math.round(lerp(fromrgba[2], torgba[2], amt)),
                  lerp(fromrgba[3], torgba[3], amt)
              ])
          }
      }
  
      //add 1 step as last value
      colors.push(cmap[cmap.length - 1].rgb.concat(alpha[1]))
  
      if (format === 'hex') colors = colors.map( rgb2hex );
      else if (format === 'rgbaString') colors = colors.map( rgbaStr );
      else if (format === 'float') colors = colors.map( rgb2float );
  
      return colors;
  };
  
  function rgb2float (rgba) {
      return [
          rgba[0] / 255,
          rgba[1] / 255,
          rgba[2] / 255,
          rgba[3]
      ]
  }
  
  function rgb2hex (rgba) {
      var dig, hex = '#';
      for (var i = 0; i < 3; ++i) {
          dig = rgba[i];
          dig = dig.toString(16);
          hex += ('00' + dig).substr( dig.length );
      }
      return hex;
  }
  
  function rgbaStr (rgba) {
      return 'rgba(' + rgba.join(',') + ')';
  }
  
  },{"./colorScale":130,"lerp":446}],132:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = compareAngle
  
  var orient = _dereq_("robust-orientation")
  var sgn = _dereq_("signum")
  var twoSum = _dereq_("two-sum")
  var robustProduct = _dereq_("robust-product")
  var robustSum = _dereq_("robust-sum")
  
  function testInterior(a, b, c) {
    var x0 = twoSum(a[0], -b[0])
    var y0 = twoSum(a[1], -b[1])
    var x1 = twoSum(c[0], -b[0])
    var y1 = twoSum(c[1], -b[1])
  
    var d = robustSum(
      robustProduct(x0, x1),
      robustProduct(y0, y1))
  
    return d[d.length-1] >= 0
  }
  
  function compareAngle(a, b, c, d) {
    var bcd = orient(b, c, d)
    if(bcd === 0) {
      //Handle degenerate cases
      var sabc = sgn(orient(a, b, c))
      var sabd = sgn(orient(a, b, d))
      if(sabc === sabd) {
        if(sabc === 0) {
          var ic = testInterior(a, b, c)
          var id = testInterior(a, b, d)
          if(ic === id) {
            return 0
          } else if(ic) {
            return 1
          } else {
            return -1
          }
        }
        return 0
      } else if(sabd === 0) {
        if(sabc > 0) {
          return -1
        } else if(testInterior(a, b, d)) {
          return -1
        } else {
          return 1
        }
      } else if(sabc === 0) {
        if(sabd > 0) {
          return 1
        } else if(testInterior(a, b, c)) {
          return 1
        } else {
          return -1
        }
      }
      return sgn(sabd - sabc)
    }
    var abc = orient(a, b, c)
    if(abc > 0) {
      if(bcd > 0 && orient(a, b, d) > 0) {
        return 1
      }
      return -1
    } else if(abc < 0) {
      if(bcd > 0 || orient(a, b, d) > 0) {
        return 1
      }
      return -1
    } else {
      var abd = orient(a, b, d)
      if(abd > 0) {
        return 1
      } else {
        if(testInterior(a, b, c)) {
          return 1
        } else {
          return -1
        }
      }
    }
  }
  },{"robust-orientation":520,"robust-product":521,"robust-sum":525,"signum":526,"two-sum":555}],133:[function(_dereq_,module,exports){
  module.exports = compareCells
  
  var min = Math.min
  
  function compareInt(a, b) {
    return a - b
  }
  
  function compareCells(a, b) {
    var n = a.length
      , t = a.length - b.length
    if(t) {
      return t
    }
    switch(n) {
      case 0:
        return 0
      case 1:
        return a[0] - b[0]
      case 2:
        return (a[0]+a[1]-b[0]-b[1]) ||
               min(a[0],a[1]) - min(b[0],b[1])
      case 3:
        var l1 = a[0]+a[1]
          , m1 = b[0]+b[1]
        t = l1+a[2] - (m1+b[2])
        if(t) {
          return t
        }
        var l0 = min(a[0], a[1])
          , m0 = min(b[0], b[1])
        return min(l0, a[2]) - min(m0, b[2]) ||
               min(l0+a[2], l1) - min(m0+b[2], m1)
      case 4:
        var aw=a[0], ax=a[1], ay=a[2], az=a[3]
          , bw=b[0], bx=b[1], by=b[2], bz=b[3]
        return (aw+ax+ay+az)-(bw+bx+by+bz) ||
               min(aw,ax,ay,az)-min(bw,bx,by,bz,bw) ||
               min(aw+ax,aw+ay,aw+az,ax+ay,ax+az,ay+az) -
                 min(bw+bx,bw+by,bw+bz,bx+by,bx+bz,by+bz) ||
               min(aw+ax+ay,aw+ax+az,aw+ay+az,ax+ay+az) -
                 min(bw+bx+by,bw+bx+bz,bw+by+bz,bx+by+bz)
      default:
        var as = a.slice().sort(compareInt)
        var bs = b.slice().sort(compareInt)
        for(var i=0; i<n; ++i) {
          t = as[i] - bs[i]
          if(t) {
            return t
          }
        }
        return 0
    }
  }
  
  },{}],134:[function(_dereq_,module,exports){
  'use strict'
  
  var compareCells = _dereq_('compare-cell')
  var parity = _dereq_('cell-orientation')
  
  module.exports = compareOrientedCells
  
  function compareOrientedCells(a, b) {
    return compareCells(a, b) || parity(a) - parity(b)
  }
  
  },{"cell-orientation":117,"compare-cell":133}],135:[function(_dereq_,module,exports){
  "use strict"
  
  var convexHull1d = _dereq_('./lib/ch1d')
  var convexHull2d = _dereq_('./lib/ch2d')
  var convexHullnd = _dereq_('./lib/chnd')
  
  module.exports = convexHull
  
  function convexHull(points) {
    var n = points.length
    if(n === 0) {
      return []
    } else if(n === 1) {
      return [[0]]
    }
    var d = points[0].length
    if(d === 0) {
      return []
    } else if(d === 1) {
      return convexHull1d(points)
    } else if(d === 2) {
      return convexHull2d(points)
    }
    return convexHullnd(points, d)
  }
  },{"./lib/ch1d":136,"./lib/ch2d":137,"./lib/chnd":138}],136:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = convexHull1d
  
  function convexHull1d(points) {
    var lo = 0
    var hi = 0
    for(var i=1; i<points.length; ++i) {
      if(points[i][0] < points[lo][0]) {
        lo = i
      }
      if(points[i][0] > points[hi][0]) {
        hi = i
      }
    }
    if(lo < hi) {
      return [[lo], [hi]]
    } else if(lo > hi) {
      return [[hi], [lo]]
    } else {
      return [[lo]]
    }
  }
  },{}],137:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = convexHull2D
  
  var monotoneHull = _dereq_('monotone-convex-hull-2d')
  
  function convexHull2D(points) {
    var hull = monotoneHull(points)
    var h = hull.length
    if(h <= 2) {
      return []
    }
    var edges = new Array(h)
    var a = hull[h-1]
    for(var i=0; i<h; ++i) {
      var b = hull[i]
      edges[i] = [a,b]
      a = b
    }
    return edges
  }
  
  },{"monotone-convex-hull-2d":456}],138:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = convexHullnD
  
  var ich = _dereq_('incremental-convex-hull')
  var aff = _dereq_('affine-hull')
  
  function permute(points, front) {
    var n = points.length
    var npoints = new Array(n)
    for(var i=0; i<front.length; ++i) {
      npoints[i] = points[front[i]]
    }
    var ptr = front.length
    for(var i=0; i<n; ++i) {
      if(front.indexOf(i) < 0) {
        npoints[ptr++] = points[i]
      }
    }
    return npoints
  }
  
  function invPermute(cells, front) {
    var nc = cells.length
    var nf = front.length
    for(var i=0; i<nc; ++i) {
      var c = cells[i]
      for(var j=0; j<c.length; ++j) {
        var x = c[j]
        if(x < nf) {
          c[j] = front[x]
        } else {
          x = x - nf
          for(var k=0; k<nf; ++k) {
            if(x >= front[k]) {
              x += 1
            }
          }
          c[j] = x
        }
      }
    }
    return cells
  }
  
  function convexHullnD(points, d) {
    try {
      return ich(points, true)
    } catch(e) {
      //If point set is degenerate, try to find a basis and rerun it
      var ah = aff(points)
      if(ah.length <= d) {
        //No basis, no try
        return []
      }
      var npoints = permute(points, ah)
      var nhull   = ich(npoints, true)
      return invPermute(nhull, ah)
    }
  }
  },{"affine-hull":67,"incremental-convex-hull":433}],139:[function(_dereq_,module,exports){
  module.exports = {
    AFG: 'afghan',
    ALA: '\\b\\wland',
    ALB: 'albania',
    DZA: 'algeria',
    ASM: '^(?=.*americ).*samoa',
    AND: 'andorra',
    AGO: 'angola',
    AIA: 'anguill?a',
    ATA: 'antarctica',
    ATG: 'antigua',
    ARG: 'argentin',
    ARM: 'armenia',
    ABW: '^(?!.*bonaire).*\\baruba',
    AUS: 'australia',
    AUT: '^(?!.*hungary).*austria|\\baustri.*\\bemp',
    AZE: 'azerbaijan',
    BHS: 'bahamas',
    BHR: 'bahrain',
    BGD: 'bangladesh|^(?=.*east).*paki?stan',
    BRB: 'barbados',
    BLR: 'belarus|byelo',
    BEL: '^(?!.*luxem).*belgium',
    BLZ: 'belize|^(?=.*british).*honduras',
    BEN: 'benin|dahome',
    BMU: 'bermuda',
    BTN: 'bhutan',
    BOL: 'bolivia',
    BES: '^(?=.*bonaire).*eustatius|^(?=.*carib).*netherlands|\\bbes.?islands',
    BIH: 'herzegovina|bosnia',
    BWA: 'botswana|bechuana',
    BVT: 'bouvet',
    BRA: 'brazil',
    IOT: 'british.?indian.?ocean',
    BRN: 'brunei',
    BGR: 'bulgaria',
    BFA: 'burkina|\\bfaso|upper.?volta',
    BDI: 'burundi',
    CPV: 'verde',
    KHM: 'cambodia|kampuchea|khmer',
    CMR: 'cameroon',
    CAN: 'canada',
    CYM: 'cayman',
    CAF: '\\bcentral.african.republic',
    TCD: '\\bchad',
    CHL: '\\bchile',
    CHN: '^(?!.*\\bmac)(?!.*\\bhong)(?!.*\\btai)(?!.*\\brep).*china|^(?=.*peo)(?=.*rep).*china',
    CXR: 'christmas',
    CCK: '\\bcocos|keeling',
    COL: 'colombia',
    COM: 'comoro',
    COG: '^(?!.*\\bdem)(?!.*\\bd[\\.]?r)(?!.*kinshasa)(?!.*zaire)(?!.*belg)(?!.*l.opoldville)(?!.*free).*\\bcongo',
    COK: '\\bcook',
    CRI: 'costa.?rica',
    CIV: 'ivoire|ivory',
    HRV: 'croatia',
    CUB: '\\bcuba',
    CUW: '^(?!.*bonaire).*\\bcura(c|ç)ao',
    CYP: 'cyprus',
    CSK: 'czechoslovakia',
    CZE: '^(?=.*rep).*czech|czechia|bohemia',
    COD: '\\bdem.*congo|congo.*\\bdem|congo.*\\bd[\\.]?r|\\bd[\\.]?r.*congo|belgian.?congo|congo.?free.?state|kinshasa|zaire|l.opoldville|drc|droc|rdc',
    DNK: 'denmark',
    DJI: 'djibouti',
    DMA: 'dominica(?!n)',
    DOM: 'dominican.rep',
    ECU: 'ecuador',
    EGY: 'egypt',
    SLV: 'el.?salvador',
    GNQ: 'guine.*eq|eq.*guine|^(?=.*span).*guinea',
    ERI: 'eritrea',
    EST: 'estonia',
    ETH: 'ethiopia|abyssinia',
    FLK: 'falkland|malvinas',
    FRO: 'faroe|faeroe',
    FJI: 'fiji',
    FIN: 'finland',
    FRA: '^(?!.*\\bdep)(?!.*martinique).*france|french.?republic|\\bgaul',
    GUF: '^(?=.*french).*guiana',
    PYF: 'french.?polynesia|tahiti',
    ATF: 'french.?southern',
    GAB: 'gabon',
    GMB: 'gambia',
    GEO: '^(?!.*south).*georgia',
    DDR: 'german.?democratic.?republic|democratic.?republic.*germany|east.germany',
    DEU: '^(?!.*east).*germany|^(?=.*\\bfed.*\\brep).*german',
    GHA: 'ghana|gold.?coast',
    GIB: 'gibraltar',
    GRC: 'greece|hellenic|hellas',
    GRL: 'greenland',
    GRD: 'grenada',
    GLP: 'guadeloupe',
    GUM: '\\bguam',
    GTM: 'guatemala',
    GGY: 'guernsey',
    GIN: '^(?!.*eq)(?!.*span)(?!.*bissau)(?!.*portu)(?!.*new).*guinea',
    GNB: 'bissau|^(?=.*portu).*guinea',
    GUY: 'guyana|british.?guiana',
    HTI: 'haiti',
    HMD: 'heard.*mcdonald',
    VAT: 'holy.?see|vatican|papal.?st',
    HND: '^(?!.*brit).*honduras',
    HKG: 'hong.?kong',
    HUN: '^(?!.*austr).*hungary',
    ISL: 'iceland',
    IND: 'india(?!.*ocea)',
    IDN: 'indonesia',
    IRN: '\\biran|persia',
    IRQ: '\\biraq|mesopotamia',
    IRL: '(^ireland)|(^republic.*ireland)',
    IMN: '^(?=.*isle).*\\bman',
    ISR: 'israel',
    ITA: 'italy',
    JAM: 'jamaica',
    JPN: 'japan',
    JEY: 'jersey',
    JOR: 'jordan',
    KAZ: 'kazak',
    KEN: 'kenya|british.?east.?africa|east.?africa.?prot',
    KIR: 'kiribati',
    PRK: '^(?=.*democrat|people|north|d.*p.*.r).*\\bkorea|dprk|korea.*(d.*p.*r)',
    KWT: 'kuwait',
    KGZ: 'kyrgyz|kirghiz',
    LAO: '\\blaos?\\b',
    LVA: 'latvia',
    LBN: 'lebanon',
    LSO: 'lesotho|basuto',
    LBR: 'liberia',
    LBY: 'libya',
    LIE: 'liechtenstein',
    LTU: 'lithuania',
    LUX: '^(?!.*belg).*luxem',
    MAC: 'maca(o|u)',
    MDG: 'madagascar|malagasy',
    MWI: 'malawi|nyasa',
    MYS: 'malaysia',
    MDV: 'maldive',
    MLI: '\\bmali\\b',
    MLT: '\\bmalta',
    MHL: 'marshall',
    MTQ: 'martinique',
    MRT: 'mauritania',
    MUS: 'mauritius',
    MYT: '\\bmayotte',
    MEX: '\\bmexic',
    FSM: 'fed.*micronesia|micronesia.*fed',
    MCO: 'monaco',
    MNG: 'mongolia',
    MNE: '^(?!.*serbia).*montenegro',
    MSR: 'montserrat',
    MAR: 'morocco|\\bmaroc',
    MOZ: 'mozambique',
    MMR: 'myanmar|burma',
    NAM: 'namibia',
    NRU: 'nauru',
    NPL: 'nepal',
    NLD: '^(?!.*\\bant)(?!.*\\bcarib).*netherlands',
    ANT: '^(?=.*\\bant).*(nether|dutch)',
    NCL: 'new.?caledonia',
    NZL: 'new.?zealand',
    NIC: 'nicaragua',
    NER: '\\bniger(?!ia)',
    NGA: 'nigeria',
    NIU: 'niue',
    NFK: 'norfolk',
    MNP: 'mariana',
    NOR: 'norway',
    OMN: '\\boman|trucial',
    PAK: '^(?!.*east).*paki?stan',
    PLW: 'palau',
    PSE: 'palestin|\\bgaza|west.?bank',
    PAN: 'panama',
    PNG: 'papua|new.?guinea',
    PRY: 'paraguay',
    PER: 'peru',
    PHL: 'philippines',
    PCN: 'pitcairn',
    POL: 'poland',
    PRT: 'portugal',
    PRI: 'puerto.?rico',
    QAT: 'qatar',
    KOR: '^(?!.*d.*p.*r)(?!.*democrat)(?!.*people)(?!.*north).*\\bkorea(?!.*d.*p.*r)',
    MDA: 'moldov|b(a|e)ssarabia',
    REU: 'r(e|é)union',
    ROU: 'r(o|u|ou)mania',
    RUS: '\\brussia|soviet.?union|u\\.?s\\.?s\\.?r|socialist.?republics',
    RWA: 'rwanda',
    BLM: 'barth(e|é)lemy',
    SHN: 'helena',
    KNA: 'kitts|\\bnevis',
    LCA: '\\blucia',
    MAF: '^(?=.*collectivity).*martin|^(?=.*france).*martin(?!ique)|^(?=.*french).*martin(?!ique)',
    SPM: 'miquelon',
    VCT: 'vincent',
    WSM: '^(?!.*amer).*samoa',
    SMR: 'san.?marino',
    STP: '\\bs(a|ã)o.?tom(e|é)',
    SAU: '\\bsa\\w*.?arabia',
    SEN: 'senegal',
    SRB: '^(?!.*monte).*serbia',
    SYC: 'seychell',
    SLE: 'sierra',
    SGP: 'singapore',
    SXM: '^(?!.*martin)(?!.*saba).*maarten',
    SVK: '^(?!.*cze).*slovak',
    SVN: 'slovenia',
    SLB: 'solomon',
    SOM: 'somali',
    ZAF: 'south.africa|s\\\\..?africa',
    SGS: 'south.?georgia|sandwich',
    SSD: '\\bs\\w*.?sudan',
    ESP: 'spain',
    LKA: 'sri.?lanka|ceylon',
    SDN: '^(?!.*\\bs(?!u)).*sudan',
    SUR: 'surinam|dutch.?guiana',
    SJM: 'svalbard',
    SWZ: 'swaziland',
    SWE: 'sweden',
    CHE: 'switz|swiss',
    SYR: 'syria',
    TWN: 'taiwan|taipei|formosa|^(?!.*peo)(?=.*rep).*china',
    TJK: 'tajik',
    THA: 'thailand|\\bsiam',
    MKD: 'macedonia|fyrom',
    TLS: '^(?=.*leste).*timor|^(?=.*east).*timor',
    TGO: 'togo',
    TKL: 'tokelau',
    TON: 'tonga',
    TTO: 'trinidad|tobago',
    TUN: 'tunisia',
    TUR: 'turkey',
    TKM: 'turkmen',
    TCA: 'turks',
    TUV: 'tuvalu',
    UGA: 'uganda',
    UKR: 'ukrain',
    ARE: 'emirates|^u\\.?a\\.?e\\.?$|united.?arab.?em',
    GBR: 'united.?kingdom|britain|^u\\.?k\\.?$',
    TZA: 'tanzania',
    USA: 'united.?states\\b(?!.*islands)|\\bu\\.?s\\.?a\\.?\\b|^\\s*u\\.?s\\.?\\b(?!.*islands)',
    UMI: 'minor.?outlying.?is',
    URY: 'uruguay',
    UZB: 'uzbek',
    VUT: 'vanuatu|new.?hebrides',
    VEN: 'venezuela',
    VNM: '^(?!.*republic).*viet.?nam|^(?=.*socialist).*viet.?nam',
    VGB: '^(?=.*\\bu\\.?\\s?k).*virgin|^(?=.*brit).*virgin|^(?=.*kingdom).*virgin',
    VIR: '^(?=.*\\bu\\.?\\s?s).*virgin|^(?=.*states).*virgin',
    WLF: 'futuna|wallis',
    ESH: 'western.sahara',
    YEM: '^(?!.*arab)(?!.*north)(?!.*sana)(?!.*peo)(?!.*dem)(?!.*south)(?!.*aden)(?!.*\\bp\\.?d\\.?r).*yemen',
    YMD: '^(?=.*peo).*yemen|^(?!.*rep)(?=.*dem).*yemen|^(?=.*south).*yemen|^(?=.*aden).*yemen|^(?=.*\\bp\\.?d\\.?r).*yemen',
    YUG: 'yugoslavia',
    ZMB: 'zambia|northern.?rhodesia',
    EAZ: 'zanzibar',
    ZWE: 'zimbabwe|^(?!.*northern).*rhodesia'
  }
  
  },{}],140:[function(_dereq_,module,exports){
  module.exports=[
    "xx-small",
    "x-small",
    "small",
    "medium",
    "large",
    "x-large",
    "xx-large",
    "larger",
    "smaller"
  ]
  
  },{}],141:[function(_dereq_,module,exports){
  module.exports=[
    "normal",
    "condensed",
    "semi-condensed",
    "extra-condensed",
    "ultra-condensed",
    "expanded",
    "semi-expanded",
    "extra-expanded",
    "ultra-expanded"
  ]
  
  },{}],142:[function(_dereq_,module,exports){
  module.exports=[
    "normal",
    "italic",
    "oblique"
  ]
  
  },{}],143:[function(_dereq_,module,exports){
  module.exports=[
    "normal",
    "bold",
    "bolder",
    "lighter",
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900"
  ]
  
  },{}],144:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = {
    parse: _dereq_('./parse'),
    stringify: _dereq_('./stringify')
  }
  
  },{"./parse":146,"./stringify":147}],145:[function(_dereq_,module,exports){
  'use strict'
  
  var sizes = _dereq_('css-font-size-keywords')
  
  module.exports = {
    isSize: function isSize(value) {
      return /^[\d\.]/.test(value)
        || value.indexOf('/') !== -1
        || sizes.indexOf(value) !== -1
    }
  }
  
  },{"css-font-size-keywords":140}],146:[function(_dereq_,module,exports){
  'use strict'
  
  var unquote = _dereq_('unquote')
  var globalKeywords = _dereq_('css-global-keywords')
  var systemFontKeywords = _dereq_('css-system-font-keywords')
  var fontWeightKeywords = _dereq_('css-font-weight-keywords')
  var fontStyleKeywords = _dereq_('css-font-style-keywords')
  var fontStretchKeywords = _dereq_('css-font-stretch-keywords')
  var splitBy = _dereq_('string-split-by')
  var isSize = _dereq_('./lib/util').isSize
  
  
  module.exports = parseFont
  
  
  var cache = parseFont.cache = {}
  
  
  function parseFont (value) {
    if (typeof value !== 'string') throw new Error('Font argument must be a string.')
  
    if (cache[value]) return cache[value]
  
    if (value === '') {
      throw new Error('Cannot parse an empty string.')
    }
  
    if (systemFontKeywords.indexOf(value) !== -1) {
      return cache[value] = {system: value}
    }
  
    var font = {
      style: 'normal',
      variant: 'normal',
      weight: 'normal',
      stretch: 'normal',
      lineHeight: 'normal',
      size: '1rem',
      family: ['serif']
    }
  
    var tokens = splitBy(value, /\s+/)
    var token
  
    while (token = tokens.shift()) {
      if (globalKeywords.indexOf(token) !== -1) {
        ['style', 'variant', 'weight', 'stretch'].forEach(function(prop) {
          font[prop] = token
        })
  
        return cache[value] = font
      }
  
      if (fontStyleKeywords.indexOf(token) !== -1) {
        font.style = token
        continue
      }
  
      if (token === 'normal' || token === 'small-caps') {
        font.variant = token
        continue
      }
  
      if (fontStretchKeywords.indexOf(token) !== -1) {
        font.stretch = token
        continue
      }
  
      if (fontWeightKeywords.indexOf(token) !== -1) {
        font.weight = token
        continue
      }
  
  
      if (isSize(token)) {
        var parts = splitBy(token, '/')
        font.size = parts[0]
        if (parts[1] != null) {
          font.lineHeight = parseLineHeight(parts[1])
        }
        else if (tokens[0] === '/') {
          tokens.shift()
          font.lineHeight = parseLineHeight(tokens.shift())
         }
  
        if (!tokens.length) {
          throw new Error('Missing required font-family.')
        }
        font.family = splitBy(tokens.join(' '), /\s*,\s*/).map(unquote)
  
        return cache[value] = font
      }
  
      throw new Error('Unknown or unsupported font token: ' + token)
    }
  
    throw new Error('Missing required font-size.')
  }
  
  
  function parseLineHeight(value) {
    var parsed = parseFloat(value)
    if (parsed.toString() === value) {
      return parsed
    }
    return value
  }
  
  },{"./lib/util":145,"css-font-stretch-keywords":141,"css-font-style-keywords":142,"css-font-weight-keywords":143,"css-global-keywords":148,"css-system-font-keywords":149,"string-split-by":540,"unquote":570}],147:[function(_dereq_,module,exports){
  'use strict'
  
  var pick = _dereq_('pick-by-alias')
  var isSize = _dereq_('./lib/util').isSize
  
  var globals = a2o(_dereq_('css-global-keywords'))
  var systems = a2o(_dereq_('css-system-font-keywords'))
  var weights = a2o(_dereq_('css-font-weight-keywords'))
  var styles = a2o(_dereq_('css-font-style-keywords'))
  var stretches = a2o(_dereq_('css-font-stretch-keywords'))
  
  var variants = {'normal': 1, 'small-caps': 1}
  var fams = {
    'serif': 1,
    'sans-serif': 1,
    'monospace': 1,
    'cursive': 1,
    'fantasy': 1,
    'system-ui': 1
  }
  
  var defaults = {
    style: 'normal',
    variant: 'normal',
    weight: 'normal',
    stretch: 'normal',
    size: '1rem',
    lineHeight: 'normal',
    family: 'serif'
  }
  
  module.exports = function stringifyFont (o) {
    o = pick(o, {
      style: 'style fontstyle fontStyle font-style slope distinction',
      variant: 'variant font-variant fontVariant fontvariant var capitalization',
      weight: 'weight w font-weight fontWeight fontweight',
      stretch: 'stretch font-stretch fontStretch fontstretch width',
      size: 'size s font-size fontSize fontsize height em emSize',
      lineHeight: 'lh line-height lineHeight lineheight leading',
      family: 'font family fontFamily font-family fontfamily type typeface face',
      system: 'system reserved default global',
    })
  
    if (o.system) {
      if (o.system) verify(o.system, systems)
      return o.system
    }
  
    verify(o.style, styles)
    verify(o.variant, variants)
    verify(o.weight, weights)
    verify(o.stretch, stretches)
  
    // default root value is medium, but by default it's inherited
    if (o.size == null) o.size = defaults.size
    if (typeof o.size === 'number') o.size += 'px'
  
    if (!isSize) throw Error('Bad size value `' + o.size + '`')
  
    // many user-agents use serif, we don't detect that for consistency
    if (!o.family) o.family = defaults.family
    if (Array.isArray(o.family)) {
      if (!o.family.length) o.family = [defaults.family]
      o.family = o.family.map(function (f) {
        return fams[f] ? f : '"' + f + '"'
      }).join(', ')
    }
  
    // [ [ <'font-style'> || <font-variant-css21> || <'font-weight'> || <'font-stretch'> ]? <'font-size'> [ / <'line-height'> ]? <'font-family'> ]
    var result = []
  
    result.push(o.style)
    if (o.variant !== o.style) result.push(o.variant)
  
    if (o.weight !== o.variant &&
      o.weight !== o.style) result.push(o.weight)
  
    if (o.stretch !== o.weight &&
      o.stretch !== o.variant &&
      o.stretch !== o.style) result.push(o.stretch)
  
    result.push(o.size + (o.lineHeight == null || o.lineHeight === 'normal' || (o.lineHeight + '' === '1')  ? '' : ('/' + o.lineHeight)))
    result.push(o.family)
  
    return result.filter(Boolean).join(' ')
  }
  
  function verify (value, values) {
    if (value && !values[value] && !globals[value]) throw Error('Unknown keyword `' + value +'`')
  
    return value
  }
  
  
  // ['a', 'b'] -> {a: true, b: true}
  function a2o (a) {
    var o = {}
    for (var i = 0; i < a.length; i++) {
      o[a[i]] = 1
    }
    return o
  }
  
  },{"./lib/util":145,"css-font-stretch-keywords":141,"css-font-style-keywords":142,"css-font-weight-keywords":143,"css-global-keywords":148,"css-system-font-keywords":149,"pick-by-alias":485}],148:[function(_dereq_,module,exports){
  module.exports=[
    "inherit",
    "initial",
    "unset"
  ]
  
  },{}],149:[function(_dereq_,module,exports){
  module.exports=[
    "caption",
    "icon",
    "menu",
    "message-box",
    "small-caption",
    "status-bar"
  ]
  
  },{}],150:[function(_dereq_,module,exports){
  "use strict"
  
  function dcubicHermite(p0, v0, p1, v1, t, f) {
    var dh00 = 6*t*t-6*t,
        dh10 = 3*t*t-4*t + 1,
        dh01 = -6*t*t+6*t,
        dh11 = 3*t*t-2*t
    if(p0.length) {
      if(!f) {
        f = new Array(p0.length)
      }
      for(var i=p0.length-1; i>=0; --i) {
        f[i] = dh00*p0[i] + dh10*v0[i] + dh01*p1[i] + dh11*v1[i]
      }
      return f
    }
    return dh00*p0 + dh10*v0 + dh01*p1[i] + dh11*v1
  }
  
  function cubicHermite(p0, v0, p1, v1, t, f) {
    var ti  = (t-1), t2 = t*t, ti2 = ti*ti,
        h00 = (1+2*t)*ti2,
        h10 = t*ti2,
        h01 = t2*(3-2*t),
        h11 = t2*ti
    if(p0.length) {
      if(!f) {
        f = new Array(p0.length)
      }
      for(var i=p0.length-1; i>=0; --i) {
        f[i] = h00*p0[i] + h10*v0[i] + h01*p1[i] + h11*v1[i]
      }
      return f
    }
    return h00*p0 + h10*v0 + h01*p1 + h11*v1
  }
  
  module.exports = cubicHermite
  module.exports.derivative = dcubicHermite
  },{}],151:[function(_dereq_,module,exports){
  "use strict"
  
  var createThunk = _dereq_("./lib/thunk.js")
  
  function Procedure() {
    this.argTypes = []
    this.shimArgs = []
    this.arrayArgs = []
    this.arrayBlockIndices = []
    this.scalarArgs = []
    this.offsetArgs = []
    this.offsetArgIndex = []
    this.indexArgs = []
    this.shapeArgs = []
    this.funcName = ""
    this.pre = null
    this.body = null
    this.post = null
    this.debug = false
  }
  
  function compileCwise(user_args) {
    //Create procedure
    var proc = new Procedure()
    
    //Parse blocks
    proc.pre    = user_args.pre
    proc.body   = user_args.body
    proc.post   = user_args.post
  
    //Parse arguments
    var proc_args = user_args.args.slice(0)
    proc.argTypes = proc_args
    for(var i=0; i<proc_args.length; ++i) {
      var arg_type = proc_args[i]
      if(arg_type === "array" || (typeof arg_type === "object" && arg_type.blockIndices)) {
        proc.argTypes[i] = "array"
        proc.arrayArgs.push(i)
        proc.arrayBlockIndices.push(arg_type.blockIndices ? arg_type.blockIndices : 0)
        proc.shimArgs.push("array" + i)
        if(i < proc.pre.args.length && proc.pre.args[i].count>0) {
          throw new Error("cwise: pre() block may not reference array args")
        }
        if(i < proc.post.args.length && proc.post.args[i].count>0) {
          throw new Error("cwise: post() block may not reference array args")
        }
      } else if(arg_type === "scalar") {
        proc.scalarArgs.push(i)
        proc.shimArgs.push("scalar" + i)
      } else if(arg_type === "index") {
        proc.indexArgs.push(i)
        if(i < proc.pre.args.length && proc.pre.args[i].count > 0) {
          throw new Error("cwise: pre() block may not reference array index")
        }
        if(i < proc.body.args.length && proc.body.args[i].lvalue) {
          throw new Error("cwise: body() block may not write to array index")
        }
        if(i < proc.post.args.length && proc.post.args[i].count > 0) {
          throw new Error("cwise: post() block may not reference array index")
        }
      } else if(arg_type === "shape") {
        proc.shapeArgs.push(i)
        if(i < proc.pre.args.length && proc.pre.args[i].lvalue) {
          throw new Error("cwise: pre() block may not write to array shape")
        }
        if(i < proc.body.args.length && proc.body.args[i].lvalue) {
          throw new Error("cwise: body() block may not write to array shape")
        }
        if(i < proc.post.args.length && proc.post.args[i].lvalue) {
          throw new Error("cwise: post() block may not write to array shape")
        }
      } else if(typeof arg_type === "object" && arg_type.offset) {
        proc.argTypes[i] = "offset"
        proc.offsetArgs.push({ array: arg_type.array, offset:arg_type.offset })
        proc.offsetArgIndex.push(i)
      } else {
        throw new Error("cwise: Unknown argument type " + proc_args[i])
      }
    }
    
    //Make sure at least one array argument was specified
    if(proc.arrayArgs.length <= 0) {
      throw new Error("cwise: No array arguments specified")
    }
    
    //Make sure arguments are correct
    if(proc.pre.args.length > proc_args.length) {
      throw new Error("cwise: Too many arguments in pre() block")
    }
    if(proc.body.args.length > proc_args.length) {
      throw new Error("cwise: Too many arguments in body() block")
    }
    if(proc.post.args.length > proc_args.length) {
      throw new Error("cwise: Too many arguments in post() block")
    }
  
    //Check debug flag
    proc.debug = !!user_args.printCode || !!user_args.debug
    
    //Retrieve name
    proc.funcName = user_args.funcName || "cwise"
    
    //Read in block size
    proc.blockSize = user_args.blockSize || 64
  
    return createThunk(proc)
  }
  
  module.exports = compileCwise
  
  },{"./lib/thunk.js":153}],152:[function(_dereq_,module,exports){
  "use strict"
  
  var uniq = _dereq_("uniq")
  
  // This function generates very simple loops analogous to how you typically traverse arrays (the outermost loop corresponds to the slowest changing index, the innermost loop to the fastest changing index)
  // TODO: If two arrays have the same strides (and offsets) there is potential for decreasing the number of "pointers" and related variables. The drawback is that the type signature would become more specific and that there would thus be less potential for caching, but it might still be worth it, especially when dealing with large numbers of arguments.
  function innerFill(order, proc, body) {
    var dimension = order.length
      , nargs = proc.arrayArgs.length
      , has_index = proc.indexArgs.length>0
      , code = []
      , vars = []
      , idx=0, pidx=0, i, j
    for(i=0; i<dimension; ++i) { // Iteration variables
      vars.push(["i",i,"=0"].join(""))
    }
    //Compute scan deltas
    for(j=0; j<nargs; ++j) {
      for(i=0; i<dimension; ++i) {
        pidx = idx
        idx = order[i]
        if(i === 0) { // The innermost/fastest dimension's delta is simply its stride
          vars.push(["d",j,"s",i,"=t",j,"p",idx].join(""))
        } else { // For other dimensions the delta is basically the stride minus something which essentially "rewinds" the previous (more inner) dimension
          vars.push(["d",j,"s",i,"=(t",j,"p",idx,"-s",pidx,"*t",j,"p",pidx,")"].join(""))
        }
      }
    }
    if (vars.length > 0) {
      code.push("var " + vars.join(","))
    }  
    //Scan loop
    for(i=dimension-1; i>=0; --i) { // Start at largest stride and work your way inwards
      idx = order[i]
      code.push(["for(i",i,"=0;i",i,"<s",idx,";++i",i,"){"].join(""))
    }
    //Push body of inner loop
    code.push(body)
    //Advance scan pointers
    for(i=0; i<dimension; ++i) {
      pidx = idx
      idx = order[i]
      for(j=0; j<nargs; ++j) {
        code.push(["p",j,"+=d",j,"s",i].join(""))
      }
      if(has_index) {
        if(i > 0) {
          code.push(["index[",pidx,"]-=s",pidx].join(""))
        }
        code.push(["++index[",idx,"]"].join(""))
      }
      code.push("}")
    }
    return code.join("\n")
  }
  
  // Generate "outer" loops that loop over blocks of data, applying "inner" loops to the blocks by manipulating the local variables in such a way that the inner loop only "sees" the current block.
  // TODO: If this is used, then the previous declaration (done by generateCwiseOp) of s* is essentially unnecessary.
  //       I believe the s* are not used elsewhere (in particular, I don't think they're used in the pre/post parts and "shape" is defined independently), so it would be possible to make defining the s* dependent on what loop method is being used.
  function outerFill(matched, order, proc, body) {
    var dimension = order.length
      , nargs = proc.arrayArgs.length
      , blockSize = proc.blockSize
      , has_index = proc.indexArgs.length > 0
      , code = []
    for(var i=0; i<nargs; ++i) {
      code.push(["var offset",i,"=p",i].join(""))
    }
    //Generate loops for unmatched dimensions
    // The order in which these dimensions are traversed is fairly arbitrary (from small stride to large stride, for the first argument)
    // TODO: It would be nice if the order in which these loops are placed would also be somehow "optimal" (at the very least we should check that it really doesn't hurt us if they're not).
    for(var i=matched; i<dimension; ++i) {
      code.push(["for(var j"+i+"=SS[", order[i], "]|0;j", i, ">0;){"].join("")) // Iterate back to front
      code.push(["if(j",i,"<",blockSize,"){"].join("")) // Either decrease j by blockSize (s = blockSize), or set it to zero (after setting s = j).
      code.push(["s",order[i],"=j",i].join(""))
      code.push(["j",i,"=0"].join(""))
      code.push(["}else{s",order[i],"=",blockSize].join(""))
      code.push(["j",i,"-=",blockSize,"}"].join(""))
      if(has_index) {
        code.push(["index[",order[i],"]=j",i].join(""))
      }
    }
    for(var i=0; i<nargs; ++i) {
      var indexStr = ["offset"+i]
      for(var j=matched; j<dimension; ++j) {
        indexStr.push(["j",j,"*t",i,"p",order[j]].join(""))
      }
      code.push(["p",i,"=(",indexStr.join("+"),")"].join(""))
    }
    code.push(innerFill(order, proc, body))
    for(var i=matched; i<dimension; ++i) {
      code.push("}")
    }
    return code.join("\n")
  }
  
  //Count the number of compatible inner orders
  // This is the length of the longest common prefix of the arrays in orders.
  // Each array in orders lists the dimensions of the correspond ndarray in order of increasing stride.
  // This is thus the maximum number of dimensions that can be efficiently traversed by simple nested loops for all arrays.
  function countMatches(orders) {
    var matched = 0, dimension = orders[0].length
    while(matched < dimension) {
      for(var j=1; j<orders.length; ++j) {
        if(orders[j][matched] !== orders[0][matched]) {
          return matched
        }
      }
      ++matched
    }
    return matched
  }
  
  //Processes a block according to the given data types
  // Replaces variable names by different ones, either "local" ones (that are then ferried in and out of the given array) or ones matching the arguments that the function performing the ultimate loop will accept.
  function processBlock(block, proc, dtypes) {
    var code = block.body
    var pre = []
    var post = []
    for(var i=0; i<block.args.length; ++i) {
      var carg = block.args[i]
      if(carg.count <= 0) {
        continue
      }
      var re = new RegExp(carg.name, "g")
      var ptrStr = ""
      var arrNum = proc.arrayArgs.indexOf(i)
      switch(proc.argTypes[i]) {
        case "offset":
          var offArgIndex = proc.offsetArgIndex.indexOf(i)
          var offArg = proc.offsetArgs[offArgIndex]
          arrNum = offArg.array
          ptrStr = "+q" + offArgIndex // Adds offset to the "pointer" in the array
        case "array":
          ptrStr = "p" + arrNum + ptrStr
          var localStr = "l" + i
          var arrStr = "a" + arrNum
          if (proc.arrayBlockIndices[arrNum] === 0) { // Argument to body is just a single value from this array
            if(carg.count === 1) { // Argument/array used only once(?)
              if(dtypes[arrNum] === "generic") {
                if(carg.lvalue) {
                  pre.push(["var ", localStr, "=", arrStr, ".get(", ptrStr, ")"].join("")) // Is this necessary if the argument is ONLY used as an lvalue? (keep in mind that we can have a += something, so we would actually need to check carg.rvalue)
                  code = code.replace(re, localStr)
                  post.push([arrStr, ".set(", ptrStr, ",", localStr,")"].join(""))
                } else {
                  code = code.replace(re, [arrStr, ".get(", ptrStr, ")"].join(""))
                }
              } else {
                code = code.replace(re, [arrStr, "[", ptrStr, "]"].join(""))
              }
            } else if(dtypes[arrNum] === "generic") {
              pre.push(["var ", localStr, "=", arrStr, ".get(", ptrStr, ")"].join("")) // TODO: Could we optimize by checking for carg.rvalue?
              code = code.replace(re, localStr)
              if(carg.lvalue) {
                post.push([arrStr, ".set(", ptrStr, ",", localStr,")"].join(""))
              }
            } else {
              pre.push(["var ", localStr, "=", arrStr, "[", ptrStr, "]"].join("")) // TODO: Could we optimize by checking for carg.rvalue?
              code = code.replace(re, localStr)
              if(carg.lvalue) {
                post.push([arrStr, "[", ptrStr, "]=", localStr].join(""))
              }
            }
          } else { // Argument to body is a "block"
            var reStrArr = [carg.name], ptrStrArr = [ptrStr]
            for(var j=0; j<Math.abs(proc.arrayBlockIndices[arrNum]); j++) {
              reStrArr.push("\\s*\\[([^\\]]+)\\]")
              ptrStrArr.push("$" + (j+1) + "*t" + arrNum + "b" + j) // Matched index times stride
            }
            re = new RegExp(reStrArr.join(""), "g")
            ptrStr = ptrStrArr.join("+")
            if(dtypes[arrNum] === "generic") {
              /*if(carg.lvalue) {
                pre.push(["var ", localStr, "=", arrStr, ".get(", ptrStr, ")"].join("")) // Is this necessary if the argument is ONLY used as an lvalue? (keep in mind that we can have a += something, so we would actually need to check carg.rvalue)
                code = code.replace(re, localStr)
                post.push([arrStr, ".set(", ptrStr, ",", localStr,")"].join(""))
              } else {
                code = code.replace(re, [arrStr, ".get(", ptrStr, ")"].join(""))
              }*/
              throw new Error("cwise: Generic arrays not supported in combination with blocks!")
            } else {
              // This does not produce any local variables, even if variables are used multiple times. It would be possible to do so, but it would complicate things quite a bit.
              code = code.replace(re, [arrStr, "[", ptrStr, "]"].join(""))
            }
          }
        break
        case "scalar":
          code = code.replace(re, "Y" + proc.scalarArgs.indexOf(i))
        break
        case "index":
          code = code.replace(re, "index")
        break
        case "shape":
          code = code.replace(re, "shape")
        break
      }
    }
    return [pre.join("\n"), code, post.join("\n")].join("\n").trim()
  }
  
  function typeSummary(dtypes) {
    var summary = new Array(dtypes.length)
    var allEqual = true
    for(var i=0; i<dtypes.length; ++i) {
      var t = dtypes[i]
      var digits = t.match(/\d+/)
      if(!digits) {
        digits = ""
      } else {
        digits = digits[0]
      }
      if(t.charAt(0) === 0) {
        summary[i] = "u" + t.charAt(1) + digits
      } else {
        summary[i] = t.charAt(0) + digits
      }
      if(i > 0) {
        allEqual = allEqual && summary[i] === summary[i-1]
      }
    }
    if(allEqual) {
      return summary[0]
    }
    return summary.join("")
  }
  
  //Generates a cwise operator
  function generateCWiseOp(proc, typesig) {
  
    //Compute dimension
    // Arrays get put first in typesig, and there are two entries per array (dtype and order), so this gets the number of dimensions in the first array arg.
    var dimension = (typesig[1].length - Math.abs(proc.arrayBlockIndices[0]))|0
    var orders = new Array(proc.arrayArgs.length)
    var dtypes = new Array(proc.arrayArgs.length)
    for(var i=0; i<proc.arrayArgs.length; ++i) {
      dtypes[i] = typesig[2*i]
      orders[i] = typesig[2*i+1]
    }
    
    //Determine where block and loop indices start and end
    var blockBegin = [], blockEnd = [] // These indices are exposed as blocks
    var loopBegin = [], loopEnd = [] // These indices are iterated over
    var loopOrders = [] // orders restricted to the loop indices
    for(var i=0; i<proc.arrayArgs.length; ++i) {
      if (proc.arrayBlockIndices[i]<0) {
        loopBegin.push(0)
        loopEnd.push(dimension)
        blockBegin.push(dimension)
        blockEnd.push(dimension+proc.arrayBlockIndices[i])
      } else {
        loopBegin.push(proc.arrayBlockIndices[i]) // Non-negative
        loopEnd.push(proc.arrayBlockIndices[i]+dimension)
        blockBegin.push(0)
        blockEnd.push(proc.arrayBlockIndices[i])
      }
      var newOrder = []
      for(var j=0; j<orders[i].length; j++) {
        if (loopBegin[i]<=orders[i][j] && orders[i][j]<loopEnd[i]) {
          newOrder.push(orders[i][j]-loopBegin[i]) // If this is a loop index, put it in newOrder, subtracting loopBegin, to make sure that all loopOrders are using a common set of indices.
        }
      }
      loopOrders.push(newOrder)
    }
  
    //First create arguments for procedure
    var arglist = ["SS"] // SS is the overall shape over which we iterate
    var code = ["'use strict'"]
    var vars = []
    
    for(var j=0; j<dimension; ++j) {
      vars.push(["s", j, "=SS[", j, "]"].join("")) // The limits for each dimension.
    }
    for(var i=0; i<proc.arrayArgs.length; ++i) {
      arglist.push("a"+i) // Actual data array
      arglist.push("t"+i) // Strides
      arglist.push("p"+i) // Offset in the array at which the data starts (also used for iterating over the data)
      
      for(var j=0; j<dimension; ++j) { // Unpack the strides into vars for looping
        vars.push(["t",i,"p",j,"=t",i,"[",loopBegin[i]+j,"]"].join(""))
      }
      
      for(var j=0; j<Math.abs(proc.arrayBlockIndices[i]); ++j) { // Unpack the strides into vars for block iteration
        vars.push(["t",i,"b",j,"=t",i,"[",blockBegin[i]+j,"]"].join(""))
      }
    }
    for(var i=0; i<proc.scalarArgs.length; ++i) {
      arglist.push("Y" + i)
    }
    if(proc.shapeArgs.length > 0) {
      vars.push("shape=SS.slice(0)") // Makes the shape over which we iterate available to the user defined functions (so you can use width/height for example)
    }
    if(proc.indexArgs.length > 0) {
      // Prepare an array to keep track of the (logical) indices, initialized to dimension zeroes.
      var zeros = new Array(dimension)
      for(var i=0; i<dimension; ++i) {
        zeros[i] = "0"
      }
      vars.push(["index=[", zeros.join(","), "]"].join(""))
    }
    for(var i=0; i<proc.offsetArgs.length; ++i) { // Offset arguments used for stencil operations
      var off_arg = proc.offsetArgs[i]
      var init_string = []
      for(var j=0; j<off_arg.offset.length; ++j) {
        if(off_arg.offset[j] === 0) {
          continue
        } else if(off_arg.offset[j] === 1) {
          init_string.push(["t", off_arg.array, "p", j].join(""))      
        } else {
          init_string.push([off_arg.offset[j], "*t", off_arg.array, "p", j].join(""))
        }
      }
      if(init_string.length === 0) {
        vars.push("q" + i + "=0")
      } else {
        vars.push(["q", i, "=", init_string.join("+")].join(""))
      }
    }
  
    //Prepare this variables
    var thisVars = uniq([].concat(proc.pre.thisVars)
                        .concat(proc.body.thisVars)
                        .concat(proc.post.thisVars))
    vars = vars.concat(thisVars)
    if (vars.length > 0) {
      code.push("var " + vars.join(","))
    }
    for(var i=0; i<proc.arrayArgs.length; ++i) {
      code.push("p"+i+"|=0")
    }
    
    //Inline prelude
    if(proc.pre.body.length > 3) {
      code.push(processBlock(proc.pre, proc, dtypes))
    }
  
    //Process body
    var body = processBlock(proc.body, proc, dtypes)
    var matched = countMatches(loopOrders)
    if(matched < dimension) {
      code.push(outerFill(matched, loopOrders[0], proc, body)) // TODO: Rather than passing loopOrders[0], it might be interesting to look at passing an order that represents the majority of the arguments for example.
    } else {
      code.push(innerFill(loopOrders[0], proc, body))
    }
  
    //Inline epilog
    if(proc.post.body.length > 3) {
      code.push(processBlock(proc.post, proc, dtypes))
    }
    
    if(proc.debug) {
      console.log("-----Generated cwise routine for ", typesig, ":\n" + code.join("\n") + "\n----------")
    }
    
    var loopName = [(proc.funcName||"unnamed"), "_cwise_loop_", orders[0].join("s"),"m",matched,typeSummary(dtypes)].join("")
    var f = new Function(["function ",loopName,"(", arglist.join(","),"){", code.join("\n"),"} return ", loopName].join(""))
    return f()
  }
  module.exports = generateCWiseOp
  
  },{"uniq":569}],153:[function(_dereq_,module,exports){
  "use strict"
  
  // The function below is called when constructing a cwise function object, and does the following:
  // A function object is constructed which accepts as argument a compilation function and returns another function.
  // It is this other function that is eventually returned by createThunk, and this function is the one that actually
  // checks whether a certain pattern of arguments has already been used before and compiles new loops as needed.
  // The compilation passed to the first function object is used for compiling new functions.
  // Once this function object is created, it is called with compile as argument, where the first argument of compile
  // is bound to "proc" (essentially containing a preprocessed version of the user arguments to cwise).
  // So createThunk roughly works like this:
  // function createThunk(proc) {
  //   var thunk = function(compileBound) {
  //     var CACHED = {}
  //     return function(arrays and scalars) {
  //       if (dtype and order of arrays in CACHED) {
  //         var func = CACHED[dtype and order of arrays]
  //       } else {
  //         var func = CACHED[dtype and order of arrays] = compileBound(dtype and order of arrays)
  //       }
  //       return func(arrays and scalars)
  //     }
  //   }
  //   return thunk(compile.bind1(proc))
  // }
  
  var compile = _dereq_("./compile.js")
  
  function createThunk(proc) {
    var code = ["'use strict'", "var CACHED={}"]
    var vars = []
    var thunkName = proc.funcName + "_cwise_thunk"
    
    //Build thunk
    code.push(["return function ", thunkName, "(", proc.shimArgs.join(","), "){"].join(""))
    var typesig = []
    var string_typesig = []
    var proc_args = [["array",proc.arrayArgs[0],".shape.slice(", // Slice shape so that we only retain the shape over which we iterate (which gets passed to the cwise operator as SS).
                      Math.max(0,proc.arrayBlockIndices[0]),proc.arrayBlockIndices[0]<0?(","+proc.arrayBlockIndices[0]+")"):")"].join("")]
    var shapeLengthConditions = [], shapeConditions = []
    // Process array arguments
    for(var i=0; i<proc.arrayArgs.length; ++i) {
      var j = proc.arrayArgs[i]
      vars.push(["t", j, "=array", j, ".dtype,",
                 "r", j, "=array", j, ".order"].join(""))
      typesig.push("t" + j)
      typesig.push("r" + j)
      string_typesig.push("t"+j)
      string_typesig.push("r"+j+".join()")
      proc_args.push("array" + j + ".data")
      proc_args.push("array" + j + ".stride")
      proc_args.push("array" + j + ".offset|0")
      if (i>0) { // Gather conditions to check for shape equality (ignoring block indices)
        shapeLengthConditions.push("array" + proc.arrayArgs[0] + ".shape.length===array" + j + ".shape.length+" + (Math.abs(proc.arrayBlockIndices[0])-Math.abs(proc.arrayBlockIndices[i])))
        shapeConditions.push("array" + proc.arrayArgs[0] + ".shape[shapeIndex+" + Math.max(0,proc.arrayBlockIndices[0]) + "]===array" + j + ".shape[shapeIndex+" + Math.max(0,proc.arrayBlockIndices[i]) + "]")
      }
    }
    // Check for shape equality
    if (proc.arrayArgs.length > 1) {
      code.push("if (!(" + shapeLengthConditions.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same dimensionality!')")
      code.push("for(var shapeIndex=array" + proc.arrayArgs[0] + ".shape.length-" + Math.abs(proc.arrayBlockIndices[0]) + "; shapeIndex-->0;) {")
      code.push("if (!(" + shapeConditions.join(" && ") + ")) throw new Error('cwise: Arrays do not all have the same shape!')")
      code.push("}")
    }
    // Process scalar arguments
    for(var i=0; i<proc.scalarArgs.length; ++i) {
      proc_args.push("scalar" + proc.scalarArgs[i])
    }
    // Check for cached function (and if not present, generate it)
    vars.push(["type=[", string_typesig.join(","), "].join()"].join(""))
    vars.push("proc=CACHED[type]")
    code.push("var " + vars.join(","))
    
    code.push(["if(!proc){",
               "CACHED[type]=proc=compile([", typesig.join(","), "])}",
               "return proc(", proc_args.join(","), ")}"].join(""))
  
    if(proc.debug) {
      console.log("-----Generated thunk:\n" + code.join("\n") + "\n----------")
    }
    
    //Compile thunk
    var thunk = new Function("compile", code.join("\n"))
    return thunk(compile.bind(undefined, proc))
  }
  
  module.exports = createThunk
  
  },{"./compile.js":152}],154:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue             = _dereq_("type/value/is")
    , ensureValue         = _dereq_("type/value/ensure")
    , ensurePlainFunction = _dereq_("type/plain-function/ensure")
    , copy                = _dereq_("es5-ext/object/copy")
    , normalizeOptions    = _dereq_("es5-ext/object/normalize-options")
    , map                 = _dereq_("es5-ext/object/map");
  
  var bind = Function.prototype.bind
    , defineProperty = Object.defineProperty
    , hasOwnProperty = Object.prototype.hasOwnProperty
    , define;
  
  define = function (name, desc, options) {
    var value = ensureValue(desc) && ensurePlainFunction(desc.value), dgs;
    dgs = copy(desc);
    delete dgs.writable;
    delete dgs.value;
    dgs.get = function () {
      if (!options.overwriteDefinition && hasOwnProperty.call(this, name)) return value;
      desc.value = bind.call(value, options.resolveContext ? options.resolveContext(this) : this);
      defineProperty(this, name, desc);
      return this[name];
    };
    return dgs;
  };
  
  module.exports = function (props/*, options*/) {
    var options = normalizeOptions(arguments[1]);
    if (isValue(options.resolveContext)) ensurePlainFunction(options.resolveContext);
    return map(props, function (desc, name) { return define(name, desc, options); });
  };
  
  },{"es5-ext/object/copy":196,"es5-ext/object/map":204,"es5-ext/object/normalize-options":205,"type/plain-function/ensure":561,"type/value/ensure":565,"type/value/is":566}],155:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue         = _dereq_("type/value/is")
    , isPlainFunction = _dereq_("type/plain-function/is")
    , assign          = _dereq_("es5-ext/object/assign")
    , normalizeOpts   = _dereq_("es5-ext/object/normalize-options")
    , contains        = _dereq_("es5-ext/string/#/contains");
  
  var d = (module.exports = function (dscr, value/*, options*/) {
    var c, e, w, options, desc;
    if (arguments.length < 2 || typeof dscr !== "string") {
      options = value;
      value = dscr;
      dscr = null;
    } else {
      options = arguments[2];
    }
    if (isValue(dscr)) {
      c = contains.call(dscr, "c");
      e = contains.call(dscr, "e");
      w = contains.call(dscr, "w");
    } else {
      c = w = true;
      e = false;
    }
  
    desc = { value: value, configurable: c, enumerable: e, writable: w };
    return !options ? desc : assign(normalizeOpts(options), desc);
  });
  
  d.gs = function (dscr, get, set/*, options*/) {
    var c, e, options, desc;
    if (typeof dscr !== "string") {
      options = set;
      set = get;
      get = dscr;
      dscr = null;
    } else {
      options = arguments[3];
    }
    if (!isValue(get)) {
      get = undefined;
    } else if (!isPlainFunction(get)) {
      options = get;
      get = set = undefined;
    } else if (!isValue(set)) {
      set = undefined;
    } else if (!isPlainFunction(set)) {
      options = set;
      set = undefined;
    }
    if (isValue(dscr)) {
      c = contains.call(dscr, "c");
      e = contains.call(dscr, "e");
    } else {
      c = true;
      e = false;
    }
  
    desc = { get: get, set: set, configurable: c, enumerable: e };
    return !options ? desc : assign(normalizeOpts(options), desc);
  };
  
  },{"es5-ext/object/assign":193,"es5-ext/object/normalize-options":205,"es5-ext/string/#/contains":212,"type/plain-function/is":562,"type/value/is":566}],156:[function(_dereq_,module,exports){
  // https://d3js.org/d3-array/ v1.2.4 Copyright 2018 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.d3 = global.d3 || {})));
  }(this, (function (exports) { 'use strict';
  
  function ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  
  function bisector(compare) {
    if (compare.length === 1) compare = ascendingComparator(compare);
    return {
      left: function(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1;
          else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid;
          else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  
  function ascendingComparator(f) {
    return function(d, x) {
      return ascending(f(d), x);
    };
  }
  
  var ascendingBisect = bisector(ascending);
  var bisectRight = ascendingBisect.right;
  var bisectLeft = ascendingBisect.left;
  
  function pairs(array, f) {
    if (f == null) f = pair;
    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = f(p, p = array[++i]);
    return pairs;
  }
  
  function pair(a, b) {
    return [a, b];
  }
  
  function cross(values0, values1, reduce) {
    var n0 = values0.length,
        n1 = values1.length,
        values = new Array(n0 * n1),
        i0,
        i1,
        i,
        value0;
  
    if (reduce == null) reduce = pair;
  
    for (i0 = i = 0; i0 < n0; ++i0) {
      for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
        values[i] = reduce(value0, values1[i1]);
      }
    }
  
    return values;
  }
  
  function descending(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  }
  
  function number(x) {
    return x === null ? NaN : +x;
  }
  
  function variance(values, valueof) {
    var n = values.length,
        m = 0,
        i = -1,
        mean = 0,
        value,
        delta,
        sum = 0;
  
    if (valueof == null) {
      while (++i < n) {
        if (!isNaN(value = number(values[i]))) {
          delta = value - mean;
          mean += delta / ++m;
          sum += delta * (value - mean);
        }
      }
    }
  
    else {
      while (++i < n) {
        if (!isNaN(value = number(valueof(values[i], i, values)))) {
          delta = value - mean;
          mean += delta / ++m;
          sum += delta * (value - mean);
        }
      }
    }
  
    if (m > 1) return sum / (m - 1);
  }
  
  function deviation(array, f) {
    var v = variance(array, f);
    return v ? Math.sqrt(v) : v;
  }
  
  function extent(values, valueof) {
    var n = values.length,
        i = -1,
        value,
        min,
        max;
  
    if (valueof == null) {
      while (++i < n) { // Find the first comparable value.
        if ((value = values[i]) != null && value >= value) {
          min = max = value;
          while (++i < n) { // Compare the remaining values.
            if ((value = values[i]) != null) {
              if (min > value) min = value;
              if (max < value) max = value;
            }
          }
        }
      }
    }
  
    else {
      while (++i < n) { // Find the first comparable value.
        if ((value = valueof(values[i], i, values)) != null && value >= value) {
          min = max = value;
          while (++i < n) { // Compare the remaining values.
            if ((value = valueof(values[i], i, values)) != null) {
              if (min > value) min = value;
              if (max < value) max = value;
            }
          }
        }
      }
    }
  
    return [min, max];
  }
  
  var array = Array.prototype;
  
  var slice = array.slice;
  var map = array.map;
  
  function constant(x) {
    return function() {
      return x;
    };
  }
  
  function identity(x) {
    return x;
  }
  
  function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
  
    var i = -1,
        n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
        range = new Array(n);
  
    while (++i < n) {
      range[i] = start + i * step;
    }
  
    return range;
  }
  
  var e10 = Math.sqrt(50),
      e5 = Math.sqrt(10),
      e2 = Math.sqrt(2);
  
  function ticks(start, stop, count) {
    var reverse,
        i = -1,
        n,
        ticks,
        step;
  
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [start];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
  
    if (step > 0) {
      start = Math.ceil(start / step);
      stop = Math.floor(stop / step);
      ticks = new Array(n = Math.ceil(stop - start + 1));
      while (++i < n) ticks[i] = (start + i) * step;
    } else {
      start = Math.floor(start * step);
      stop = Math.ceil(stop * step);
      ticks = new Array(n = Math.ceil(start - stop + 1));
      while (++i < n) ticks[i] = (start - i) / step;
    }
  
    if (reverse) ticks.reverse();
  
    return ticks;
  }
  
  function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count),
        power = Math.floor(Math.log(step) / Math.LN10),
        error = step / Math.pow(10, power);
    return power >= 0
        ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
        : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
  }
  
  function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count),
        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
        error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
  }
  
  function sturges(values) {
    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
  }
  
  function histogram() {
    var value = identity,
        domain = extent,
        threshold = sturges;
  
    function histogram(data) {
      var i,
          n = data.length,
          x,
          values = new Array(n);
  
      for (i = 0; i < n; ++i) {
        values[i] = value(data[i], i, data);
      }
  
      var xz = domain(values),
          x0 = xz[0],
          x1 = xz[1],
          tz = threshold(values, x0, x1);
  
      // Convert number of thresholds into uniform thresholds.
      if (!Array.isArray(tz)) {
        tz = tickStep(x0, x1, tz);
        tz = range(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
      }
  
      // Remove any thresholds outside the domain.
      var m = tz.length;
      while (tz[0] <= x0) tz.shift(), --m;
      while (tz[m - 1] > x1) tz.pop(), --m;
  
      var bins = new Array(m + 1),
          bin;
  
      // Initialize bins.
      for (i = 0; i <= m; ++i) {
        bin = bins[i] = [];
        bin.x0 = i > 0 ? tz[i - 1] : x0;
        bin.x1 = i < m ? tz[i] : x1;
      }
  
      // Assign data to bins by value, ignoring any outside the domain.
      for (i = 0; i < n; ++i) {
        x = values[i];
        if (x0 <= x && x <= x1) {
          bins[bisectRight(tz, x, 0, m)].push(data[i]);
        }
      }
  
      return bins;
    }
  
    histogram.value = function(_) {
      return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
    };
  
    histogram.domain = function(_) {
      return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
    };
  
    histogram.thresholds = function(_) {
      return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
    };
  
    return histogram;
  }
  
  function quantile(values, p, valueof) {
    if (valueof == null) valueof = number;
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n,
        i = (n - 1) * p,
        i0 = Math.floor(i),
        value0 = +valueof(values[i0], i0, values),
        value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
  }
  
  function freedmanDiaconis(values, min, max) {
    values = map.call(values, number).sort(ascending);
    return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
  }
  
  function scott(values, min, max) {
    return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
  }
  
  function max(values, valueof) {
    var n = values.length,
        i = -1,
        value,
        max;
  
    if (valueof == null) {
      while (++i < n) { // Find the first comparable value.
        if ((value = values[i]) != null && value >= value) {
          max = value;
          while (++i < n) { // Compare the remaining values.
            if ((value = values[i]) != null && value > max) {
              max = value;
            }
          }
        }
      }
    }
  
    else {
      while (++i < n) { // Find the first comparable value.
        if ((value = valueof(values[i], i, values)) != null && value >= value) {
          max = value;
          while (++i < n) { // Compare the remaining values.
            if ((value = valueof(values[i], i, values)) != null && value > max) {
              max = value;
            }
          }
        }
      }
    }
  
    return max;
  }
  
  function mean(values, valueof) {
    var n = values.length,
        m = n,
        i = -1,
        value,
        sum = 0;
  
    if (valueof == null) {
      while (++i < n) {
        if (!isNaN(value = number(values[i]))) sum += value;
        else --m;
      }
    }
  
    else {
      while (++i < n) {
        if (!isNaN(value = number(valueof(values[i], i, values)))) sum += value;
        else --m;
      }
    }
  
    if (m) return sum / m;
  }
  
  function median(values, valueof) {
    var n = values.length,
        i = -1,
        value,
        numbers = [];
  
    if (valueof == null) {
      while (++i < n) {
        if (!isNaN(value = number(values[i]))) {
          numbers.push(value);
        }
      }
    }
  
    else {
      while (++i < n) {
        if (!isNaN(value = number(valueof(values[i], i, values)))) {
          numbers.push(value);
        }
      }
    }
  
    return quantile(numbers.sort(ascending), 0.5);
  }
  
  function merge(arrays) {
    var n = arrays.length,
        m,
        i = -1,
        j = 0,
        merged,
        array;
  
    while (++i < n) j += arrays[i].length;
    merged = new Array(j);
  
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
  
    return merged;
  }
  
  function min(values, valueof) {
    var n = values.length,
        i = -1,
        value,
        min;
  
    if (valueof == null) {
      while (++i < n) { // Find the first comparable value.
        if ((value = values[i]) != null && value >= value) {
          min = value;
          while (++i < n) { // Compare the remaining values.
            if ((value = values[i]) != null && min > value) {
              min = value;
            }
          }
        }
      }
    }
  
    else {
      while (++i < n) { // Find the first comparable value.
        if ((value = valueof(values[i], i, values)) != null && value >= value) {
          min = value;
          while (++i < n) { // Compare the remaining values.
            if ((value = valueof(values[i], i, values)) != null && min > value) {
              min = value;
            }
          }
        }
      }
    }
  
    return min;
  }
  
  function permute(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  }
  
  function scan(values, compare) {
    if (!(n = values.length)) return;
    var n,
        i = 0,
        j = 0,
        xi,
        xj = values[j];
  
    if (compare == null) compare = ascending;
  
    while (++i < n) {
      if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
        xj = xi, j = i;
      }
    }
  
    if (compare(xj, xj) === 0) return j;
  }
  
  function shuffle(array, i0, i1) {
    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
        t,
        i;
  
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0];
      array[m + i0] = array[i + i0];
      array[i + i0] = t;
    }
  
    return array;
  }
  
  function sum(values, valueof) {
    var n = values.length,
        i = -1,
        value,
        sum = 0;
  
    if (valueof == null) {
      while (++i < n) {
        if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
      }
    }
  
    else {
      while (++i < n) {
        if (value = +valueof(values[i], i, values)) sum += value;
      }
    }
  
    return sum;
  }
  
  function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  }
  
  function length(d) {
    return d.length;
  }
  
  function zip() {
    return transpose(arguments);
  }
  
  exports.bisect = bisectRight;
  exports.bisectRight = bisectRight;
  exports.bisectLeft = bisectLeft;
  exports.ascending = ascending;
  exports.bisector = bisector;
  exports.cross = cross;
  exports.descending = descending;
  exports.deviation = deviation;
  exports.extent = extent;
  exports.histogram = histogram;
  exports.thresholdFreedmanDiaconis = freedmanDiaconis;
  exports.thresholdScott = scott;
  exports.thresholdSturges = sturges;
  exports.max = max;
  exports.mean = mean;
  exports.median = median;
  exports.merge = merge;
  exports.min = min;
  exports.pairs = pairs;
  exports.permute = permute;
  exports.quantile = quantile;
  exports.range = range;
  exports.scan = scan;
  exports.shuffle = shuffle;
  exports.sum = sum;
  exports.ticks = ticks;
  exports.tickIncrement = tickIncrement;
  exports.tickStep = tickStep;
  exports.transpose = transpose;
  exports.variance = variance;
  exports.zip = zip;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  })));
  
  },{}],157:[function(_dereq_,module,exports){
  // https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.d3 = global.d3 || {})));
  }(this, (function (exports) { 'use strict';
  
  var prefix = "$";
  
  function Map() {}
  
  Map.prototype = map.prototype = {
    constructor: Map,
    has: function(key) {
      return (prefix + key) in this;
    },
    get: function(key) {
      return this[prefix + key];
    },
    set: function(key, value) {
      this[prefix + key] = value;
      return this;
    },
    remove: function(key) {
      var property = prefix + key;
      return property in this && delete this[property];
    },
    clear: function() {
      for (var property in this) if (property[0] === prefix) delete this[property];
    },
    keys: function() {
      var keys = [];
      for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
      return keys;
    },
    values: function() {
      var values = [];
      for (var property in this) if (property[0] === prefix) values.push(this[property]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
      return entries;
    },
    size: function() {
      var size = 0;
      for (var property in this) if (property[0] === prefix) ++size;
      return size;
    },
    empty: function() {
      for (var property in this) if (property[0] === prefix) return false;
      return true;
    },
    each: function(f) {
      for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
    }
  };
  
  function map(object, f) {
    var map = new Map;
  
    // Copy constructor.
    if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
  
    // Index array by numeric index or specified key function.
    else if (Array.isArray(object)) {
      var i = -1,
          n = object.length,
          o;
  
      if (f == null) while (++i < n) map.set(i, object[i]);
      else while (++i < n) map.set(f(o = object[i], i, object), o);
    }
  
    // Convert object to map.
    else if (object) for (var key in object) map.set(key, object[key]);
  
    return map;
  }
  
  function nest() {
    var keys = [],
        sortKeys = [],
        sortValues,
        rollup,
        nest;
  
    function apply(array, depth, createResult, setResult) {
      if (depth >= keys.length) {
        if (sortValues != null) array.sort(sortValues);
        return rollup != null ? rollup(array) : array;
      }
  
      var i = -1,
          n = array.length,
          key = keys[depth++],
          keyValue,
          value,
          valuesByKey = map(),
          values,
          result = createResult();
  
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
          values.push(value);
        } else {
          valuesByKey.set(keyValue, [value]);
        }
      }
  
      valuesByKey.each(function(values, key) {
        setResult(result, key, apply(values, depth, createResult, setResult));
      });
  
      return result;
    }
  
    function entries(map$$1, depth) {
      if (++depth > keys.length) return map$$1;
      var array, sortKey = sortKeys[depth - 1];
      if (rollup != null && depth >= keys.length) array = map$$1.entries();
      else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
      return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
    }
  
    return nest = {
      object: function(array) { return apply(array, 0, createObject, setObject); },
      map: function(array) { return apply(array, 0, createMap, setMap); },
      entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
      key: function(d) { keys.push(d); return nest; },
      sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
      sortValues: function(order) { sortValues = order; return nest; },
      rollup: function(f) { rollup = f; return nest; }
    };
  }
  
  function createObject() {
    return {};
  }
  
  function setObject(object, key, value) {
    object[key] = value;
  }
  
  function createMap() {
    return map();
  }
  
  function setMap(map$$1, key, value) {
    map$$1.set(key, value);
  }
  
  function Set() {}
  
  var proto = map.prototype;
  
  Set.prototype = set.prototype = {
    constructor: Set,
    has: proto.has,
    add: function(value) {
      value += "";
      this[prefix + value] = value;
      return this;
    },
    remove: proto.remove,
    clear: proto.clear,
    values: proto.keys,
    size: proto.size,
    empty: proto.empty,
    each: proto.each
  };
  
  function set(object, f) {
    var set = new Set;
  
    // Copy constructor.
    if (object instanceof Set) object.each(function(value) { set.add(value); });
  
    // Otherwise, assume it’s an array.
    else if (object) {
      var i = -1, n = object.length;
      if (f == null) while (++i < n) set.add(object[i]);
      else while (++i < n) set.add(f(object[i], i, object));
    }
  
    return set;
  }
  
  function keys(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  }
  
  function values(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  }
  
  function entries(map) {
    var entries = [];
    for (var key in map) entries.push({key: key, value: map[key]});
    return entries;
  }
  
  exports.nest = nest;
  exports.set = set;
  exports.map = map;
  exports.keys = keys;
  exports.values = values;
  exports.entries = entries;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  })));
  
  },{}],158:[function(_dereq_,module,exports){
  // https://d3js.org/d3-color/ v1.4.1 Copyright 2020 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}));
  }(this, function (exports) { 'use strict';
  
  function define(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
  }
  
  function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for (var key in definition) prototype[key] = definition[key];
    return prototype;
  }
  
  function Color() {}
  
  var darker = 0.7;
  var brighter = 1 / darker;
  
  var reI = "\\s*([+-]?\\d+)\\s*",
      reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
      reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
      reHex = /^#([0-9a-f]{3,8})$/,
      reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
      reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
      reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
      reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
      reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
      reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
  
  var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
  };
  
  define(Color, color, {
    copy: function(channels) {
      return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
      return this.rgb().displayable();
    },
    hex: color_formatHex, // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
  });
  
  function color_formatHex() {
    return this.rgb().formatHex();
  }
  
  function color_formatHsl() {
    return hslConvert(this).formatHsl();
  }
  
  function color_formatRgb() {
    return this.rgb().formatRgb();
  }
  
  function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
        : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
        : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
        : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
        : null) // invalid hex
        : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
        : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
        : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
        : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
        : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
        : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
        : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
        : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
        : null;
  }
  
  function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
  }
  
  function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
  }
  
  function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
  }
  
  function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
  }
  
  function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
  }
  
  define(Rgb, rgb, extend(Color, {
    brighter: function(k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
      return this;
    },
    displayable: function() {
      return (-0.5 <= this.r && this.r < 255.5)
          && (-0.5 <= this.g && this.g < 255.5)
          && (-0.5 <= this.b && this.b < 255.5)
          && (0 <= this.opacity && this.opacity <= 1);
    },
    hex: rgb_formatHex, // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
  }));
  
  function rgb_formatHex() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
  }
  
  function rgb_formatRgb() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
  
  function hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
  }
  
  function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
  }
  
  function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255,
        g = o.g / 255,
        b = o.b / 255,
        min = Math.min(r, g, b),
        max = Math.max(r, g, b),
        h = NaN,
        s = max - min,
        l = (max + min) / 2;
    if (s) {
      if (r === max) h = (g - b) / s + (g < b) * 6;
      else if (g === max) h = (b - r) / s + 2;
      else h = (r - g) / s + 4;
      s /= l < 0.5 ? max + min : 2 - max - min;
      h *= 60;
    } else {
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new Hsl(h, s, l, o.opacity);
  }
  
  function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
  }
  
  function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
  }
  
  define(Hsl, hsl, extend(Color, {
    brighter: function(k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
      var h = this.h % 360 + (this.h < 0) * 360,
          s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
          l = this.l,
          m2 = l + (l < 0.5 ? l : 1 - l) * s,
          m1 = 2 * l - m2;
      return new Rgb(
        hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
        hsl2rgb(h, m1, m2),
        hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
        this.opacity
      );
    },
    displayable: function() {
      return (0 <= this.s && this.s <= 1 || isNaN(this.s))
          && (0 <= this.l && this.l <= 1)
          && (0 <= this.opacity && this.opacity <= 1);
    },
    formatHsl: function() {
      var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
      return (a === 1 ? "hsl(" : "hsla(")
          + (this.h || 0) + ", "
          + (this.s || 0) * 100 + "%, "
          + (this.l || 0) * 100 + "%"
          + (a === 1 ? ")" : ", " + a + ")");
    }
  }));
  
  /* From FvD 13.37, CSS Color Module Level 3 */
  function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60
        : h < 180 ? m2
        : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
        : m1) * 255;
  }
  
  var deg2rad = Math.PI / 180;
  var rad2deg = 180 / Math.PI;
  
  // https://observablehq.com/@mbostock/lab-and-rgb
  var K = 18,
      Xn = 0.96422,
      Yn = 1,
      Zn = 0.82521,
      t0 = 4 / 29,
      t1 = 6 / 29,
      t2 = 3 * t1 * t1,
      t3 = t1 * t1 * t1;
  
  function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof Rgb)) o = rgbConvert(o);
    var r = rgb2lrgb(o.r),
        g = rgb2lrgb(o.g),
        b = rgb2lrgb(o.b),
        y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y; else {
      x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
      z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
  }
  
  function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
  }
  
  function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
  }
  
  function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
  }
  
  define(Lab, lab, extend(Color, {
    brighter: function(k) {
      return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker: function(k) {
      return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb: function() {
      var y = (this.l + 16) / 116,
          x = isNaN(this.a) ? y : y + this.a / 500,
          z = isNaN(this.b) ? y : y - this.b / 200;
      x = Xn * lab2xyz(x);
      y = Yn * lab2xyz(y);
      z = Zn * lab2xyz(z);
      return new Rgb(
        lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
        lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
        lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
        this.opacity
      );
    }
  }));
  
  function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
  }
  
  function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
  }
  
  function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
  }
  
  function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
  }
  
  function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * rad2deg;
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
  }
  
  function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
  }
  
  function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
  }
  
  function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
  }
  
  function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * deg2rad;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  
  define(Hcl, hcl, extend(Color, {
    brighter: function(k) {
      return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker: function(k) {
      return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb: function() {
      return hcl2lab(this).rgb();
    }
  }));
  
  var A = -0.14861,
      B = +1.78277,
      C = -0.29227,
      D = -0.90649,
      E = +1.97294,
      ED = E * D,
      EB = E * B,
      BC_DA = B * C - D * A;
  
  function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Rgb)) o = rgbConvert(o);
    var r = o.r / 255,
        g = o.g / 255,
        b = o.b / 255,
        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
        bl = b - l,
        k = (E * (g - l) - C * bl) / D,
        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
        h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
  }
  
  function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
  }
  
  function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
  }
  
  define(Cubehelix, cubehelix, extend(Color, {
    brighter: function(k) {
      k = k == null ? brighter : Math.pow(brighter, k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
      k = k == null ? darker : Math.pow(darker, k);
      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
      var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
          l = +this.l,
          a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
          cosh = Math.cos(h),
          sinh = Math.sin(h);
      return new Rgb(
        255 * (l + a * (A * cosh + B * sinh)),
        255 * (l + a * (C * cosh + D * sinh)),
        255 * (l + a * (E * cosh)),
        this.opacity
      );
    }
  }));
  
  exports.color = color;
  exports.cubehelix = cubehelix;
  exports.gray = gray;
  exports.hcl = hcl;
  exports.hsl = hsl;
  exports.lab = lab;
  exports.lch = lch;
  exports.rgb = rgb;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{}],159:[function(_dereq_,module,exports){
  // https://d3js.org/d3-dispatch/ v1.0.6 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}));
  }(this, function (exports) { 'use strict';
  
  var noop = {value: function() {}};
  
  function dispatch() {
    for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
      if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
      _[t] = [];
    }
    return new Dispatch(_);
  }
  
  function Dispatch(_) {
    this._ = _;
  }
  
  function parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
      var name = "", i = t.indexOf(".");
      if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
      if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
      return {type: t, name: name};
    });
  }
  
  Dispatch.prototype = dispatch.prototype = {
    constructor: Dispatch,
    on: function(typename, callback) {
      var _ = this._,
          T = parseTypenames(typename + "", _),
          t,
          i = -1,
          n = T.length;
  
      // If no callback was specified, return the callback of the given type and name.
      if (arguments.length < 2) {
        while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
        return;
      }
  
      // If a type was specified, set the callback for the given type and name.
      // Otherwise, if a null callback was specified, remove callbacks of the given name.
      if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
      while (++i < n) {
        if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
        else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
      }
  
      return this;
    },
    copy: function() {
      var copy = {}, _ = this._;
      for (var t in _) copy[t] = _[t].slice();
      return new Dispatch(copy);
    },
    call: function(type, that) {
      if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
      for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
      for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
    }
  };
  
  function get(type, name) {
    for (var i = 0, n = type.length, c; i < n; ++i) {
      if ((c = type[i]).name === name) {
        return c.value;
      }
    }
  }
  
  function set(type, name, callback) {
    for (var i = 0, n = type.length; i < n; ++i) {
      if (type[i].name === name) {
        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
      }
    }
    if (callback != null) type.push({name: name, value: callback});
    return type;
  }
  
  exports.dispatch = dispatch;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{}],160:[function(_dereq_,module,exports){
  // https://d3js.org/d3-force/ v1.2.1 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-quadtree'), _dereq_('d3-collection'), _dereq_('d3-dispatch'), _dereq_('d3-timer')) :
  typeof define === 'function' && define.amd ? define(['exports', 'd3-quadtree', 'd3-collection', 'd3-dispatch', 'd3-timer'], factory) :
  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3));
  }(this, (function (exports,d3Quadtree,d3Collection,d3Dispatch,d3Timer) { 'use strict';
  
  function center(x, y) {
    var nodes;
  
    if (x == null) x = 0;
    if (y == null) y = 0;
  
    function force() {
      var i,
          n = nodes.length,
          node,
          sx = 0,
          sy = 0;
  
      for (i = 0; i < n; ++i) {
        node = nodes[i], sx += node.x, sy += node.y;
      }
  
      for (sx = sx / n - x, sy = sy / n - y, i = 0; i < n; ++i) {
        node = nodes[i], node.x -= sx, node.y -= sy;
      }
    }
  
    force.initialize = function(_) {
      nodes = _;
    };
  
    force.x = function(_) {
      return arguments.length ? (x = +_, force) : x;
    };
  
    force.y = function(_) {
      return arguments.length ? (y = +_, force) : y;
    };
  
    return force;
  }
  
  function constant(x) {
    return function() {
      return x;
    };
  }
  
  function jiggle() {
    return (Math.random() - 0.5) * 1e-6;
  }
  
  function x(d) {
    return d.x + d.vx;
  }
  
  function y(d) {
    return d.y + d.vy;
  }
  
  function collide(radius) {
    var nodes,
        radii,
        strength = 1,
        iterations = 1;
  
    if (typeof radius !== "function") radius = constant(radius == null ? 1 : +radius);
  
    function force() {
      var i, n = nodes.length,
          tree,
          node,
          xi,
          yi,
          ri,
          ri2;
  
      for (var k = 0; k < iterations; ++k) {
        tree = d3Quadtree.quadtree(nodes, x, y).visitAfter(prepare);
        for (i = 0; i < n; ++i) {
          node = nodes[i];
          ri = radii[node.index], ri2 = ri * ri;
          xi = node.x + node.vx;
          yi = node.y + node.vy;
          tree.visit(apply);
        }
      }
  
      function apply(quad, x0, y0, x1, y1) {
        var data = quad.data, rj = quad.r, r = ri + rj;
        if (data) {
          if (data.index > node.index) {
            var x = xi - data.x - data.vx,
                y = yi - data.y - data.vy,
                l = x * x + y * y;
            if (l < r * r) {
              if (x === 0) x = jiggle(), l += x * x;
              if (y === 0) y = jiggle(), l += y * y;
              l = (r - (l = Math.sqrt(l))) / l * strength;
              node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
              node.vy += (y *= l) * r;
              data.vx -= x * (r = 1 - r);
              data.vy -= y * r;
            }
          }
          return;
        }
        return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
      }
    }
  
    function prepare(quad) {
      if (quad.data) return quad.r = radii[quad.data.index];
      for (var i = quad.r = 0; i < 4; ++i) {
        if (quad[i] && quad[i].r > quad.r) {
          quad.r = quad[i].r;
        }
      }
    }
  
    function initialize() {
      if (!nodes) return;
      var i, n = nodes.length, node;
      radii = new Array(n);
      for (i = 0; i < n; ++i) node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
  
    force.initialize = function(_) {
      nodes = _;
      initialize();
    };
  
    force.iterations = function(_) {
      return arguments.length ? (iterations = +_, force) : iterations;
    };
  
    force.strength = function(_) {
      return arguments.length ? (strength = +_, force) : strength;
    };
  
    force.radius = function(_) {
      return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
    };
  
    return force;
  }
  
  function index(d) {
    return d.index;
  }
  
  function find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("missing: " + nodeId);
    return node;
  }
  
  function link(links) {
    var id = index,
        strength = defaultStrength,
        strengths,
        distance = constant(30),
        distances,
        nodes,
        count,
        bias,
        iterations = 1;
  
    if (links == null) links = [];
  
    function defaultStrength(link) {
      return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
  
    function force(alpha) {
      for (var k = 0, n = links.length; k < iterations; ++k) {
        for (var i = 0, link, source, target, x, y, l, b; i < n; ++i) {
          link = links[i], source = link.source, target = link.target;
          x = target.x + target.vx - source.x - source.vx || jiggle();
          y = target.y + target.vy - source.y - source.vy || jiggle();
          l = Math.sqrt(x * x + y * y);
          l = (l - distances[i]) / l * alpha * strengths[i];
          x *= l, y *= l;
          target.vx -= x * (b = bias[i]);
          target.vy -= y * b;
          source.vx += x * (b = 1 - b);
          source.vy += y * b;
        }
      }
    }
  
    function initialize() {
      if (!nodes) return;
  
      var i,
          n = nodes.length,
          m = links.length,
          nodeById = d3Collection.map(nodes, id),
          link;
  
      for (i = 0, count = new Array(n); i < m; ++i) {
        link = links[i], link.index = i;
        if (typeof link.source !== "object") link.source = find(nodeById, link.source);
        if (typeof link.target !== "object") link.target = find(nodeById, link.target);
        count[link.source.index] = (count[link.source.index] || 0) + 1;
        count[link.target.index] = (count[link.target.index] || 0) + 1;
      }
  
      for (i = 0, bias = new Array(m); i < m; ++i) {
        link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
      }
  
      strengths = new Array(m), initializeStrength();
      distances = new Array(m), initializeDistance();
    }
  
    function initializeStrength() {
      if (!nodes) return;
  
      for (var i = 0, n = links.length; i < n; ++i) {
        strengths[i] = +strength(links[i], i, links);
      }
    }
  
    function initializeDistance() {
      if (!nodes) return;
  
      for (var i = 0, n = links.length; i < n; ++i) {
        distances[i] = +distance(links[i], i, links);
      }
    }
  
    force.initialize = function(_) {
      nodes = _;
      initialize();
    };
  
    force.links = function(_) {
      return arguments.length ? (links = _, initialize(), force) : links;
    };
  
    force.id = function(_) {
      return arguments.length ? (id = _, force) : id;
    };
  
    force.iterations = function(_) {
      return arguments.length ? (iterations = +_, force) : iterations;
    };
  
    force.strength = function(_) {
      return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initializeStrength(), force) : strength;
    };
  
    force.distance = function(_) {
      return arguments.length ? (distance = typeof _ === "function" ? _ : constant(+_), initializeDistance(), force) : distance;
    };
  
    return force;
  }
  
  function x$1(d) {
    return d.x;
  }
  
  function y$1(d) {
    return d.y;
  }
  
  var initialRadius = 10,
      initialAngle = Math.PI * (3 - Math.sqrt(5));
  
  function simulation(nodes) {
    var simulation,
        alpha = 1,
        alphaMin = 0.001,
        alphaDecay = 1 - Math.pow(alphaMin, 1 / 300),
        alphaTarget = 0,
        velocityDecay = 0.6,
        forces = d3Collection.map(),
        stepper = d3Timer.timer(step),
        event = d3Dispatch.dispatch("tick", "end");
  
    if (nodes == null) nodes = [];
  
    function step() {
      tick();
      event.call("tick", simulation);
      if (alpha < alphaMin) {
        stepper.stop();
        event.call("end", simulation);
      }
    }
  
    function tick(iterations) {
      var i, n = nodes.length, node;
  
      if (iterations === undefined) iterations = 1;
  
      for (var k = 0; k < iterations; ++k) {
        alpha += (alphaTarget - alpha) * alphaDecay;
  
        forces.each(function (force) {
          force(alpha);
        });
  
        for (i = 0; i < n; ++i) {
          node = nodes[i];
          if (node.fx == null) node.x += node.vx *= velocityDecay;
          else node.x = node.fx, node.vx = 0;
          if (node.fy == null) node.y += node.vy *= velocityDecay;
          else node.y = node.fy, node.vy = 0;
        }
      }
  
      return simulation;
    }
  
    function initializeNodes() {
      for (var i = 0, n = nodes.length, node; i < n; ++i) {
        node = nodes[i], node.index = i;
        if (node.fx != null) node.x = node.fx;
        if (node.fy != null) node.y = node.fy;
        if (isNaN(node.x) || isNaN(node.y)) {
          var radius = initialRadius * Math.sqrt(i), angle = i * initialAngle;
          node.x = radius * Math.cos(angle);
          node.y = radius * Math.sin(angle);
        }
        if (isNaN(node.vx) || isNaN(node.vy)) {
          node.vx = node.vy = 0;
        }
      }
    }
  
    function initializeForce(force) {
      if (force.initialize) force.initialize(nodes);
      return force;
    }
  
    initializeNodes();
  
    return simulation = {
      tick: tick,
  
      restart: function() {
        return stepper.restart(step), simulation;
      },
  
      stop: function() {
        return stepper.stop(), simulation;
      },
  
      nodes: function(_) {
        return arguments.length ? (nodes = _, initializeNodes(), forces.each(initializeForce), simulation) : nodes;
      },
  
      alpha: function(_) {
        return arguments.length ? (alpha = +_, simulation) : alpha;
      },
  
      alphaMin: function(_) {
        return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
      },
  
      alphaDecay: function(_) {
        return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
      },
  
      alphaTarget: function(_) {
        return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
      },
  
      velocityDecay: function(_) {
        return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
      },
  
      force: function(name, _) {
        return arguments.length > 1 ? ((_ == null ? forces.remove(name) : forces.set(name, initializeForce(_))), simulation) : forces.get(name);
      },
  
      find: function(x, y, radius) {
        var i = 0,
            n = nodes.length,
            dx,
            dy,
            d2,
            node,
            closest;
  
        if (radius == null) radius = Infinity;
        else radius *= radius;
  
        for (i = 0; i < n; ++i) {
          node = nodes[i];
          dx = x - node.x;
          dy = y - node.y;
          d2 = dx * dx + dy * dy;
          if (d2 < radius) closest = node, radius = d2;
        }
  
        return closest;
      },
  
      on: function(name, _) {
        return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
      }
    };
  }
  
  function manyBody() {
    var nodes,
        node,
        alpha,
        strength = constant(-30),
        strengths,
        distanceMin2 = 1,
        distanceMax2 = Infinity,
        theta2 = 0.81;
  
    function force(_) {
      var i, n = nodes.length, tree = d3Quadtree.quadtree(nodes, x$1, y$1).visitAfter(accumulate);
      for (alpha = _, i = 0; i < n; ++i) node = nodes[i], tree.visit(apply);
    }
  
    function initialize() {
      if (!nodes) return;
      var i, n = nodes.length, node;
      strengths = new Array(n);
      for (i = 0; i < n; ++i) node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
  
    function accumulate(quad) {
      var strength = 0, q, c, weight = 0, x, y, i;
  
      // For internal nodes, accumulate forces from child quadrants.
      if (quad.length) {
        for (x = y = i = 0; i < 4; ++i) {
          if ((q = quad[i]) && (c = Math.abs(q.value))) {
            strength += q.value, weight += c, x += c * q.x, y += c * q.y;
          }
        }
        quad.x = x / weight;
        quad.y = y / weight;
      }
  
      // For leaf nodes, accumulate forces from coincident quadrants.
      else {
        q = quad;
        q.x = q.data.x;
        q.y = q.data.y;
        do strength += strengths[q.data.index];
        while (q = q.next);
      }
  
      quad.value = strength;
    }
  
    function apply(quad, x1, _, x2) {
      if (!quad.value) return true;
  
      var x = quad.x - node.x,
          y = quad.y - node.y,
          w = x2 - x1,
          l = x * x + y * y;
  
      // Apply the Barnes-Hut approximation if possible.
      // Limit forces for very close nodes; randomize direction if coincident.
      if (w * w / theta2 < l) {
        if (l < distanceMax2) {
          if (x === 0) x = jiggle(), l += x * x;
          if (y === 0) y = jiggle(), l += y * y;
          if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
          node.vx += x * quad.value * alpha / l;
          node.vy += y * quad.value * alpha / l;
        }
        return true;
      }
  
      // Otherwise, process points directly.
      else if (quad.length || l >= distanceMax2) return;
  
      // Limit forces for very close nodes; randomize direction if coincident.
      if (quad.data !== node || quad.next) {
        if (x === 0) x = jiggle(), l += x * x;
        if (y === 0) y = jiggle(), l += y * y;
        if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
      }
  
      do if (quad.data !== node) {
        w = strengths[quad.data.index] * alpha / l;
        node.vx += x * w;
        node.vy += y * w;
      } while (quad = quad.next);
    }
  
    force.initialize = function(_) {
      nodes = _;
      initialize();
    };
  
    force.strength = function(_) {
      return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
    };
  
    force.distanceMin = function(_) {
      return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
  
    force.distanceMax = function(_) {
      return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
  
    force.theta = function(_) {
      return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
  
    return force;
  }
  
  function radial(radius, x, y) {
    var nodes,
        strength = constant(0.1),
        strengths,
        radiuses;
  
    if (typeof radius !== "function") radius = constant(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
  
    function force(alpha) {
      for (var i = 0, n = nodes.length; i < n; ++i) {
        var node = nodes[i],
            dx = node.x - x || 1e-6,
            dy = node.y - y || 1e-6,
            r = Math.sqrt(dx * dx + dy * dy),
            k = (radiuses[i] - r) * strengths[i] * alpha / r;
        node.vx += dx * k;
        node.vy += dy * k;
      }
    }
  
    function initialize() {
      if (!nodes) return;
      var i, n = nodes.length;
      strengths = new Array(n);
      radiuses = new Array(n);
      for (i = 0; i < n; ++i) {
        radiuses[i] = +radius(nodes[i], i, nodes);
        strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
      }
    }
  
    force.initialize = function(_) {
      nodes = _, initialize();
    };
  
    force.strength = function(_) {
      return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
    };
  
    force.radius = function(_) {
      return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), initialize(), force) : radius;
    };
  
    force.x = function(_) {
      return arguments.length ? (x = +_, force) : x;
    };
  
    force.y = function(_) {
      return arguments.length ? (y = +_, force) : y;
    };
  
    return force;
  }
  
  function x$2(x) {
    var strength = constant(0.1),
        nodes,
        strengths,
        xz;
  
    if (typeof x !== "function") x = constant(x == null ? 0 : +x);
  
    function force(alpha) {
      for (var i = 0, n = nodes.length, node; i < n; ++i) {
        node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
      }
    }
  
    function initialize() {
      if (!nodes) return;
      var i, n = nodes.length;
      strengths = new Array(n);
      xz = new Array(n);
      for (i = 0; i < n; ++i) {
        strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
      }
    }
  
    force.initialize = function(_) {
      nodes = _;
      initialize();
    };
  
    force.strength = function(_) {
      return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
    };
  
    force.x = function(_) {
      return arguments.length ? (x = typeof _ === "function" ? _ : constant(+_), initialize(), force) : x;
    };
  
    return force;
  }
  
  function y$2(y) {
    var strength = constant(0.1),
        nodes,
        strengths,
        yz;
  
    if (typeof y !== "function") y = constant(y == null ? 0 : +y);
  
    function force(alpha) {
      for (var i = 0, n = nodes.length, node; i < n; ++i) {
        node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
      }
    }
  
    function initialize() {
      if (!nodes) return;
      var i, n = nodes.length;
      strengths = new Array(n);
      yz = new Array(n);
      for (i = 0; i < n; ++i) {
        strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
      }
    }
  
    force.initialize = function(_) {
      nodes = _;
      initialize();
    };
  
    force.strength = function(_) {
      return arguments.length ? (strength = typeof _ === "function" ? _ : constant(+_), initialize(), force) : strength;
    };
  
    force.y = function(_) {
      return arguments.length ? (y = typeof _ === "function" ? _ : constant(+_), initialize(), force) : y;
    };
  
    return force;
  }
  
  exports.forceCenter = center;
  exports.forceCollide = collide;
  exports.forceLink = link;
  exports.forceManyBody = manyBody;
  exports.forceRadial = radial;
  exports.forceSimulation = simulation;
  exports.forceX = x$2;
  exports.forceY = y$2;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  })));
  
  },{"d3-collection":157,"d3-dispatch":159,"d3-quadtree":164,"d3-timer":168}],161:[function(_dereq_,module,exports){
  // https://d3js.org/d3-hierarchy/ v1.1.9 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}));
  }(this, function (exports) { 'use strict';
  
  function defaultSeparation(a, b) {
    return a.parent === b.parent ? 1 : 2;
  }
  
  function meanX(children) {
    return children.reduce(meanXReduce, 0) / children.length;
  }
  
  function meanXReduce(x, c) {
    return x + c.x;
  }
  
  function maxY(children) {
    return 1 + children.reduce(maxYReduce, 0);
  }
  
  function maxYReduce(y, c) {
    return Math.max(y, c.y);
  }
  
  function leafLeft(node) {
    var children;
    while (children = node.children) node = children[0];
    return node;
  }
  
  function leafRight(node) {
    var children;
    while (children = node.children) node = children[children.length - 1];
    return node;
  }
  
  function cluster() {
    var separation = defaultSeparation,
        dx = 1,
        dy = 1,
        nodeSize = false;
  
    function cluster(root) {
      var previousNode,
          x = 0;
  
      // First walk, computing the initial x & y values.
      root.eachAfter(function(node) {
        var children = node.children;
        if (children) {
          node.x = meanX(children);
          node.y = maxY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
  
      var left = leafLeft(root),
          right = leafRight(root),
          x0 = left.x - separation(left, right) / 2,
          x1 = right.x + separation(right, left) / 2;
  
      // Second walk, normalizing x & y to the desired size.
      return root.eachAfter(nodeSize ? function(node) {
        node.x = (node.x - root.x) * dx;
        node.y = (root.y - node.y) * dy;
      } : function(node) {
        node.x = (node.x - x0) / (x1 - x0) * dx;
        node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
      });
    }
  
    cluster.separation = function(x) {
      return arguments.length ? (separation = x, cluster) : separation;
    };
  
    cluster.size = function(x) {
      return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
    };
  
    cluster.nodeSize = function(x) {
      return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
    };
  
    return cluster;
  }
  
  function count(node) {
    var sum = 0,
        children = node.children,
        i = children && children.length;
    if (!i) sum = 1;
    else while (--i >= 0) sum += children[i].value;
    node.value = sum;
  }
  
  function node_count() {
    return this.eachAfter(count);
  }
  
  function node_each(callback) {
    var node = this, current, next = [node], children, i, n;
    do {
      current = next.reverse(), next = [];
      while (node = current.pop()) {
        callback(node), children = node.children;
        if (children) for (i = 0, n = children.length; i < n; ++i) {
          next.push(children[i]);
        }
      }
    } while (next.length);
    return this;
  }
  
  function node_eachBefore(callback) {
    var node = this, nodes = [node], children, i;
    while (node = nodes.pop()) {
      callback(node), children = node.children;
      if (children) for (i = children.length - 1; i >= 0; --i) {
        nodes.push(children[i]);
      }
    }
    return this;
  }
  
  function node_eachAfter(callback) {
    var node = this, nodes = [node], next = [], children, i, n;
    while (node = nodes.pop()) {
      next.push(node), children = node.children;
      if (children) for (i = 0, n = children.length; i < n; ++i) {
        nodes.push(children[i]);
      }
    }
    while (node = next.pop()) {
      callback(node);
    }
    return this;
  }
  
  function node_sum(value) {
    return this.eachAfter(function(node) {
      var sum = +value(node.data) || 0,
          children = node.children,
          i = children && children.length;
      while (--i >= 0) sum += children[i].value;
      node.value = sum;
    });
  }
  
  function node_sort(compare) {
    return this.eachBefore(function(node) {
      if (node.children) {
        node.children.sort(compare);
      }
    });
  }
  
  function node_path(end) {
    var start = this,
        ancestor = leastCommonAncestor(start, end),
        nodes = [start];
    while (start !== ancestor) {
      start = start.parent;
      nodes.push(start);
    }
    var k = nodes.length;
    while (end !== ancestor) {
      nodes.splice(k, 0, end);
      end = end.parent;
    }
    return nodes;
  }
  
  function leastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = a.ancestors(),
        bNodes = b.ancestors(),
        c = null;
    a = aNodes.pop();
    b = bNodes.pop();
    while (a === b) {
      c = a;
      a = aNodes.pop();
      b = bNodes.pop();
    }
    return c;
  }
  
  function node_ancestors() {
    var node = this, nodes = [node];
    while (node = node.parent) {
      nodes.push(node);
    }
    return nodes;
  }
  
  function node_descendants() {
    var nodes = [];
    this.each(function(node) {
      nodes.push(node);
    });
    return nodes;
  }
  
  function node_leaves() {
    var leaves = [];
    this.eachBefore(function(node) {
      if (!node.children) {
        leaves.push(node);
      }
    });
    return leaves;
  }
  
  function node_links() {
    var root = this, links = [];
    root.each(function(node) {
      if (node !== root) { // Don’t include the root’s parent, if any.
        links.push({source: node.parent, target: node});
      }
    });
    return links;
  }
  
  function hierarchy(data, children) {
    var root = new Node(data),
        valued = +data.value && (root.value = data.value),
        node,
        nodes = [root],
        child,
        childs,
        i,
        n;
  
    if (children == null) children = defaultChildren;
  
    while (node = nodes.pop()) {
      if (valued) node.value = +node.data.value;
      if ((childs = children(node.data)) && (n = childs.length)) {
        node.children = new Array(n);
        for (i = n - 1; i >= 0; --i) {
          nodes.push(child = node.children[i] = new Node(childs[i]));
          child.parent = node;
          child.depth = node.depth + 1;
        }
      }
    }
  
    return root.eachBefore(computeHeight);
  }
  
  function node_copy() {
    return hierarchy(this).eachBefore(copyData);
  }
  
  function defaultChildren(d) {
    return d.children;
  }
  
  function copyData(node) {
    node.data = node.data.data;
  }
  
  function computeHeight(node) {
    var height = 0;
    do node.height = height;
    while ((node = node.parent) && (node.height < ++height));
  }
  
  function Node(data) {
    this.data = data;
    this.depth =
    this.height = 0;
    this.parent = null;
  }
  
  Node.prototype = hierarchy.prototype = {
    constructor: Node,
    count: node_count,
    each: node_each,
    eachAfter: node_eachAfter,
    eachBefore: node_eachBefore,
    sum: node_sum,
    sort: node_sort,
    path: node_path,
    ancestors: node_ancestors,
    descendants: node_descendants,
    leaves: node_leaves,
    links: node_links,
    copy: node_copy
  };
  
  var slice = Array.prototype.slice;
  
  function shuffle(array) {
    var m = array.length,
        t,
        i;
  
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m];
      array[m] = array[i];
      array[i] = t;
    }
  
    return array;
  }
  
  function enclose(circles) {
    var i = 0, n = (circles = shuffle(slice.call(circles))).length, B = [], p, e;
  
    while (i < n) {
      p = circles[i];
      if (e && enclosesWeak(e, p)) ++i;
      else e = encloseBasis(B = extendBasis(B, p)), i = 0;
    }
  
    return e;
  }
  
  function extendBasis(B, p) {
    var i, j;
  
    if (enclosesWeakAll(p, B)) return [p];
  
    // If we get here then B must have at least one element.
    for (i = 0; i < B.length; ++i) {
      if (enclosesNot(p, B[i])
          && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
        return [B[i], p];
      }
    }
  
    // If we get here then B must have at least two elements.
    for (i = 0; i < B.length - 1; ++i) {
      for (j = i + 1; j < B.length; ++j) {
        if (enclosesNot(encloseBasis2(B[i], B[j]), p)
            && enclosesNot(encloseBasis2(B[i], p), B[j])
            && enclosesNot(encloseBasis2(B[j], p), B[i])
            && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
          return [B[i], B[j], p];
        }
      }
    }
  
    // If we get here then something is very wrong.
    throw new Error;
  }
  
  function enclosesNot(a, b) {
    var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
    return dr < 0 || dr * dr < dx * dx + dy * dy;
  }
  
  function enclosesWeak(a, b) {
    var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
  }
  
  function enclosesWeakAll(a, B) {
    for (var i = 0; i < B.length; ++i) {
      if (!enclosesWeak(a, B[i])) {
        return false;
      }
    }
    return true;
  }
  
  function encloseBasis(B) {
    switch (B.length) {
      case 1: return encloseBasis1(B[0]);
      case 2: return encloseBasis2(B[0], B[1]);
      case 3: return encloseBasis3(B[0], B[1], B[2]);
    }
  }
  
  function encloseBasis1(a) {
    return {
      x: a.x,
      y: a.y,
      r: a.r
    };
  }
  
  function encloseBasis2(a, b) {
    var x1 = a.x, y1 = a.y, r1 = a.r,
        x2 = b.x, y2 = b.y, r2 = b.r,
        x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
        l = Math.sqrt(x21 * x21 + y21 * y21);
    return {
      x: (x1 + x2 + x21 / l * r21) / 2,
      y: (y1 + y2 + y21 / l * r21) / 2,
      r: (l + r1 + r2) / 2
    };
  }
  
  function encloseBasis3(a, b, c) {
    var x1 = a.x, y1 = a.y, r1 = a.r,
        x2 = b.x, y2 = b.y, r2 = b.r,
        x3 = c.x, y3 = c.y, r3 = c.r,
        a2 = x1 - x2,
        a3 = x1 - x3,
        b2 = y1 - y2,
        b3 = y1 - y3,
        c2 = r2 - r1,
        c3 = r3 - r1,
        d1 = x1 * x1 + y1 * y1 - r1 * r1,
        d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
        d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
        ab = a3 * b2 - a2 * b3,
        xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
        xb = (b3 * c2 - b2 * c3) / ab,
        ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
        yb = (a2 * c3 - a3 * c2) / ab,
        A = xb * xb + yb * yb - 1,
        B = 2 * (r1 + xa * xb + ya * yb),
        C = xa * xa + ya * ya - r1 * r1,
        r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
    return {
      x: x1 + xa + xb * r,
      y: y1 + ya + yb * r,
      r: r
    };
  }
  
  function place(b, a, c) {
    var dx = b.x - a.x, x, a2,
        dy = b.y - a.y, y, b2,
        d2 = dx * dx + dy * dy;
    if (d2) {
      a2 = a.r + c.r, a2 *= a2;
      b2 = b.r + c.r, b2 *= b2;
      if (a2 > b2) {
        x = (d2 + b2 - a2) / (2 * d2);
        y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
        c.x = b.x - x * dx - y * dy;
        c.y = b.y - x * dy + y * dx;
      } else {
        x = (d2 + a2 - b2) / (2 * d2);
        y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
        c.x = a.x + x * dx - y * dy;
        c.y = a.y + x * dy + y * dx;
      }
    } else {
      c.x = a.x + c.r;
      c.y = a.y;
    }
  }
  
  function intersects(a, b) {
    var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
    return dr > 0 && dr * dr > dx * dx + dy * dy;
  }
  
  function score(node) {
    var a = node._,
        b = node.next._,
        ab = a.r + b.r,
        dx = (a.x * b.r + b.x * a.r) / ab,
        dy = (a.y * b.r + b.y * a.r) / ab;
    return dx * dx + dy * dy;
  }
  
  function Node$1(circle) {
    this._ = circle;
    this.next = null;
    this.previous = null;
  }
  
  function packEnclose(circles) {
    if (!(n = circles.length)) return 0;
  
    var a, b, c, n, aa, ca, i, j, k, sj, sk;
  
    // Place the first circle.
    a = circles[0], a.x = 0, a.y = 0;
    if (!(n > 1)) return a.r;
  
    // Place the second circle.
    b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
    if (!(n > 2)) return a.r + b.r;
  
    // Place the third circle.
    place(b, a, c = circles[2]);
  
    // Initialize the front-chain using the first three circles a, b and c.
    a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
    a.next = c.previous = b;
    b.next = a.previous = c;
    c.next = b.previous = a;
  
    // Attempt to place each remaining circle…
    pack: for (i = 3; i < n; ++i) {
      place(a._, b._, c = circles[i]), c = new Node$1(c);
  
      // Find the closest intersecting circle on the front-chain, if any.
      // “Closeness” is determined by linear distance along the front-chain.
      // “Ahead” or “behind” is likewise determined by linear distance.
      j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
      do {
        if (sj <= sk) {
          if (intersects(j._, c._)) {
            b = j, a.next = b, b.previous = a, --i;
            continue pack;
          }
          sj += j._.r, j = j.next;
        } else {
          if (intersects(k._, c._)) {
            a = k, a.next = b, b.previous = a, --i;
            continue pack;
          }
          sk += k._.r, k = k.previous;
        }
      } while (j !== k.next);
  
      // Success! Insert the new circle c between a and b.
      c.previous = a, c.next = b, a.next = b.previous = b = c;
  
      // Compute the new closest circle pair to the centroid.
      aa = score(a);
      while ((c = c.next) !== b) {
        if ((ca = score(c)) < aa) {
          a = c, aa = ca;
        }
      }
      b = a.next;
    }
  
    // Compute the enclosing circle of the front chain.
    a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
  
    // Translate the circles to put the enclosing circle around the origin.
    for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
  
    return c.r;
  }
  
  function siblings(circles) {
    packEnclose(circles);
    return circles;
  }
  
  function optional(f) {
    return f == null ? null : required(f);
  }
  
  function required(f) {
    if (typeof f !== "function") throw new Error;
    return f;
  }
  
  function constantZero() {
    return 0;
  }
  
  function constant(x) {
    return function() {
      return x;
    };
  }
  
  function defaultRadius(d) {
    return Math.sqrt(d.value);
  }
  
  function index() {
    var radius = null,
        dx = 1,
        dy = 1,
        padding = constantZero;
  
    function pack(root) {
      root.x = dx / 2, root.y = dy / 2;
      if (radius) {
        root.eachBefore(radiusLeaf(radius))
            .eachAfter(packChildren(padding, 0.5))
            .eachBefore(translateChild(1));
      } else {
        root.eachBefore(radiusLeaf(defaultRadius))
            .eachAfter(packChildren(constantZero, 1))
            .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
            .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
      }
      return root;
    }
  
    pack.radius = function(x) {
      return arguments.length ? (radius = optional(x), pack) : radius;
    };
  
    pack.size = function(x) {
      return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
    };
  
    pack.padding = function(x) {
      return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
    };
  
    return pack;
  }
  
  function radiusLeaf(radius) {
    return function(node) {
      if (!node.children) {
        node.r = Math.max(0, +radius(node) || 0);
      }
    };
  }
  
  function packChildren(padding, k) {
    return function(node) {
      if (children = node.children) {
        var children,
            i,
            n = children.length,
            r = padding(node) * k || 0,
            e;
  
        if (r) for (i = 0; i < n; ++i) children[i].r += r;
        e = packEnclose(children);
        if (r) for (i = 0; i < n; ++i) children[i].r -= r;
        node.r = e + r;
      }
    };
  }
  
  function translateChild(k) {
    return function(node) {
      var parent = node.parent;
      node.r *= k;
      if (parent) {
        node.x = parent.x + k * node.x;
        node.y = parent.y + k * node.y;
      }
    };
  }
  
  function roundNode(node) {
    node.x0 = Math.round(node.x0);
    node.y0 = Math.round(node.y0);
    node.x1 = Math.round(node.x1);
    node.y1 = Math.round(node.y1);
  }
  
  function treemapDice(parent, x0, y0, x1, y1) {
    var nodes = parent.children,
        node,
        i = -1,
        n = nodes.length,
        k = parent.value && (x1 - x0) / parent.value;
  
    while (++i < n) {
      node = nodes[i], node.y0 = y0, node.y1 = y1;
      node.x0 = x0, node.x1 = x0 += node.value * k;
    }
  }
  
  function partition() {
    var dx = 1,
        dy = 1,
        padding = 0,
        round = false;
  
    function partition(root) {
      var n = root.height + 1;
      root.x0 =
      root.y0 = padding;
      root.x1 = dx;
      root.y1 = dy / n;
      root.eachBefore(positionNode(dy, n));
      if (round) root.eachBefore(roundNode);
      return root;
    }
  
    function positionNode(dy, n) {
      return function(node) {
        if (node.children) {
          treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
        }
        var x0 = node.x0,
            y0 = node.y0,
            x1 = node.x1 - padding,
            y1 = node.y1 - padding;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        node.x0 = x0;
        node.y0 = y0;
        node.x1 = x1;
        node.y1 = y1;
      };
    }
  
    partition.round = function(x) {
      return arguments.length ? (round = !!x, partition) : round;
    };
  
    partition.size = function(x) {
      return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
    };
  
    partition.padding = function(x) {
      return arguments.length ? (padding = +x, partition) : padding;
    };
  
    return partition;
  }
  
  var keyPrefix = "$", // Protect against keys like “__proto__”.
      preroot = {depth: -1},
      ambiguous = {};
  
  function defaultId(d) {
    return d.id;
  }
  
  function defaultParentId(d) {
    return d.parentId;
  }
  
  function stratify() {
    var id = defaultId,
        parentId = defaultParentId;
  
    function stratify(data) {
      var d,
          i,
          n = data.length,
          root,
          parent,
          node,
          nodes = new Array(n),
          nodeId,
          nodeKey,
          nodeByKey = {};
  
      for (i = 0; i < n; ++i) {
        d = data[i], node = nodes[i] = new Node(d);
        if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
          nodeKey = keyPrefix + (node.id = nodeId);
          nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
        }
      }
  
      for (i = 0; i < n; ++i) {
        node = nodes[i], nodeId = parentId(data[i], i, data);
        if (nodeId == null || !(nodeId += "")) {
          if (root) throw new Error("multiple roots");
          root = node;
        } else {
          parent = nodeByKey[keyPrefix + nodeId];
          if (!parent) throw new Error("missing: " + nodeId);
          if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
          if (parent.children) parent.children.push(node);
          else parent.children = [node];
          node.parent = parent;
        }
      }
  
      if (!root) throw new Error("no root");
      root.parent = preroot;
      root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
      root.parent = null;
      if (n > 0) throw new Error("cycle");
  
      return root;
    }
  
    stratify.id = function(x) {
      return arguments.length ? (id = required(x), stratify) : id;
    };
  
    stratify.parentId = function(x) {
      return arguments.length ? (parentId = required(x), stratify) : parentId;
    };
  
    return stratify;
  }
  
  function defaultSeparation$1(a, b) {
    return a.parent === b.parent ? 1 : 2;
  }
  
  // function radialSeparation(a, b) {
  //   return (a.parent === b.parent ? 1 : 2) / a.depth;
  // }
  
  // This function is used to traverse the left contour of a subtree (or
  // subforest). It returns the successor of v on this contour. This successor is
  // either given by the leftmost child of v or by the thread of v. The function
  // returns null if and only if v is on the highest level of its subtree.
  function nextLeft(v) {
    var children = v.children;
    return children ? children[0] : v.t;
  }
  
  // This function works analogously to nextLeft.
  function nextRight(v) {
    var children = v.children;
    return children ? children[children.length - 1] : v.t;
  }
  
  // Shifts the current subtree rooted at w+. This is done by increasing
  // prelim(w+) and mod(w+) by shift.
  function moveSubtree(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  
  // All other shifts, applied to the smaller subtrees between w- and w+, are
  // performed by this function. To prepare the shifts, we have to adjust
  // change(w+), shift(w+), and change(w-).
  function executeShifts(v) {
    var shift = 0,
        change = 0,
        children = v.children,
        i = children.length,
        w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  
  // If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
  // returns the specified (default) ancestor.
  function nextAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  
  function TreeNode(node, i) {
    this._ = node;
    this.parent = null;
    this.children = null;
    this.A = null; // default ancestor
    this.a = this; // ancestor
    this.z = 0; // prelim
    this.m = 0; // mod
    this.c = 0; // change
    this.s = 0; // shift
    this.t = null; // thread
    this.i = i; // number
  }
  
  TreeNode.prototype = Object.create(Node.prototype);
  
  function treeRoot(root) {
    var tree = new TreeNode(root, 0),
        node,
        nodes = [tree],
        child,
        children,
        i,
        n;
  
    while (node = nodes.pop()) {
      if (children = node._.children) {
        node.children = new Array(n = children.length);
        for (i = n - 1; i >= 0; --i) {
          nodes.push(child = node.children[i] = new TreeNode(children[i], i));
          child.parent = node;
        }
      }
    }
  
    (tree.parent = new TreeNode(null, 0)).children = [tree];
    return tree;
  }
  
  // Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
  function tree() {
    var separation = defaultSeparation$1,
        dx = 1,
        dy = 1,
        nodeSize = null;
  
    function tree(root) {
      var t = treeRoot(root);
  
      // Compute the layout using Buchheim et al.’s algorithm.
      t.eachAfter(firstWalk), t.parent.m = -t.z;
      t.eachBefore(secondWalk);
  
      // If a fixed node size is specified, scale x and y.
      if (nodeSize) root.eachBefore(sizeNode);
  
      // If a fixed tree size is specified, scale x and y based on the extent.
      // Compute the left-most, right-most, and depth-most nodes for extents.
      else {
        var left = root,
            right = root,
            bottom = root;
        root.eachBefore(function(node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var s = left === right ? 1 : separation(left, right) / 2,
            tx = s - left.x,
            kx = dx / (right.x + s + tx),
            ky = dy / (bottom.depth || 1);
        root.eachBefore(function(node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
  
      return root;
    }
  
    // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
    // applied recursively to the children of v, as well as the function
    // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
    // node v is placed to the midpoint of its outermost children.
    function firstWalk(v) {
      var children = v.children,
          siblings = v.parent.children,
          w = v.i ? siblings[v.i - 1] : null;
      if (children) {
        executeShifts(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
  
    // Computes all real x-coordinates by summing up the modifiers recursively.
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
  
    // The core of the algorithm. Here, a new subtree is combined with the
    // previous subtrees. Threads are used to traverse the inside and outside
    // contours of the left and right subtree up to the highest common level. The
    // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
    // superscript o means outside and i means inside, the subscript - means left
    // subtree and + means right subtree. For summing up the modifiers along the
    // contour, we use respective variables si+, si-, so-, and so+. Whenever two
    // nodes of the inside contours conflict, we compute the left one of the
    // greatest uncommon ancestors using the function ANCESTOR and call MOVE
    // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
    // Finally, we add a new thread (if necessary).
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v,
            vop = v,
            vim = w,
            vom = vip.parent.children[0],
            sip = vip.m,
            sop = vop.m,
            sim = vim.m,
            som = vom.m,
            shift;
        while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
          vom = nextLeft(vom);
          vop = nextRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !nextRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !nextLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
  
    function sizeNode(node) {
      node.x *= dx;
      node.y = node.depth * dy;
    }
  
    tree.separation = function(x) {
      return arguments.length ? (separation = x, tree) : separation;
    };
  
    tree.size = function(x) {
      return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
    };
  
    tree.nodeSize = function(x) {
      return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
    };
  
    return tree;
  }
  
  function treemapSlice(parent, x0, y0, x1, y1) {
    var nodes = parent.children,
        node,
        i = -1,
        n = nodes.length,
        k = parent.value && (y1 - y0) / parent.value;
  
    while (++i < n) {
      node = nodes[i], node.x0 = x0, node.x1 = x1;
      node.y0 = y0, node.y1 = y0 += node.value * k;
    }
  }
  
  var phi = (1 + Math.sqrt(5)) / 2;
  
  function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
    var rows = [],
        nodes = parent.children,
        row,
        nodeValue,
        i0 = 0,
        i1 = 0,
        n = nodes.length,
        dx, dy,
        value = parent.value,
        sumValue,
        minValue,
        maxValue,
        newRatio,
        minRatio,
        alpha,
        beta;
  
    while (i0 < n) {
      dx = x1 - x0, dy = y1 - y0;
  
      // Find the next non-empty node.
      do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
      minValue = maxValue = sumValue;
      alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
      beta = sumValue * sumValue * alpha;
      minRatio = Math.max(maxValue / beta, beta / minValue);
  
      // Keep adding nodes while the aspect ratio maintains or improves.
      for (; i1 < n; ++i1) {
        sumValue += nodeValue = nodes[i1].value;
        if (nodeValue < minValue) minValue = nodeValue;
        if (nodeValue > maxValue) maxValue = nodeValue;
        beta = sumValue * sumValue * alpha;
        newRatio = Math.max(maxValue / beta, beta / minValue);
        if (newRatio > minRatio) { sumValue -= nodeValue; break; }
        minRatio = newRatio;
      }
  
      // Position and record the row orientation.
      rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
      if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
      else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
      value -= sumValue, i0 = i1;
    }
  
    return rows;
  }
  
  var squarify = (function custom(ratio) {
  
    function squarify(parent, x0, y0, x1, y1) {
      squarifyRatio(ratio, parent, x0, y0, x1, y1);
    }
  
    squarify.ratio = function(x) {
      return custom((x = +x) > 1 ? x : 1);
    };
  
    return squarify;
  })(phi);
  
  function index$1() {
    var tile = squarify,
        round = false,
        dx = 1,
        dy = 1,
        paddingStack = [0],
        paddingInner = constantZero,
        paddingTop = constantZero,
        paddingRight = constantZero,
        paddingBottom = constantZero,
        paddingLeft = constantZero;
  
    function treemap(root) {
      root.x0 =
      root.y0 = 0;
      root.x1 = dx;
      root.y1 = dy;
      root.eachBefore(positionNode);
      paddingStack = [0];
      if (round) root.eachBefore(roundNode);
      return root;
    }
  
    function positionNode(node) {
      var p = paddingStack[node.depth],
          x0 = node.x0 + p,
          y0 = node.y0 + p,
          x1 = node.x1 - p,
          y1 = node.y1 - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      node.x0 = x0;
      node.y0 = y0;
      node.x1 = x1;
      node.y1 = y1;
      if (node.children) {
        p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
        x0 += paddingLeft(node) - p;
        y0 += paddingTop(node) - p;
        x1 -= paddingRight(node) - p;
        y1 -= paddingBottom(node) - p;
        if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
        if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
        tile(node, x0, y0, x1, y1);
      }
    }
  
    treemap.round = function(x) {
      return arguments.length ? (round = !!x, treemap) : round;
    };
  
    treemap.size = function(x) {
      return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
    };
  
    treemap.tile = function(x) {
      return arguments.length ? (tile = required(x), treemap) : tile;
    };
  
    treemap.padding = function(x) {
      return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
    };
  
    treemap.paddingInner = function(x) {
      return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
    };
  
    treemap.paddingOuter = function(x) {
      return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
    };
  
    treemap.paddingTop = function(x) {
      return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
    };
  
    treemap.paddingRight = function(x) {
      return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
    };
  
    treemap.paddingBottom = function(x) {
      return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
    };
  
    treemap.paddingLeft = function(x) {
      return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
    };
  
    return treemap;
  }
  
  function binary(parent, x0, y0, x1, y1) {
    var nodes = parent.children,
        i, n = nodes.length,
        sum, sums = new Array(n + 1);
  
    for (sums[0] = sum = i = 0; i < n; ++i) {
      sums[i + 1] = sum += nodes[i].value;
    }
  
    partition(0, n, parent.value, x0, y0, x1, y1);
  
    function partition(i, j, value, x0, y0, x1, y1) {
      if (i >= j - 1) {
        var node = nodes[i];
        node.x0 = x0, node.y0 = y0;
        node.x1 = x1, node.y1 = y1;
        return;
      }
  
      var valueOffset = sums[i],
          valueTarget = (value / 2) + valueOffset,
          k = i + 1,
          hi = j - 1;
  
      while (k < hi) {
        var mid = k + hi >>> 1;
        if (sums[mid] < valueTarget) k = mid + 1;
        else hi = mid;
      }
  
      if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;
  
      var valueLeft = sums[k] - valueOffset,
          valueRight = value - valueLeft;
  
      if ((x1 - x0) > (y1 - y0)) {
        var xk = (x0 * valueRight + x1 * valueLeft) / value;
        partition(i, k, valueLeft, x0, y0, xk, y1);
        partition(k, j, valueRight, xk, y0, x1, y1);
      } else {
        var yk = (y0 * valueRight + y1 * valueLeft) / value;
        partition(i, k, valueLeft, x0, y0, x1, yk);
        partition(k, j, valueRight, x0, yk, x1, y1);
      }
    }
  }
  
  function sliceDice(parent, x0, y0, x1, y1) {
    (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
  }
  
  var resquarify = (function custom(ratio) {
  
    function resquarify(parent, x0, y0, x1, y1) {
      if ((rows = parent._squarify) && (rows.ratio === ratio)) {
        var rows,
            row,
            nodes,
            i,
            j = -1,
            n,
            m = rows.length,
            value = parent.value;
  
        while (++j < m) {
          row = rows[j], nodes = row.children;
          for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
          if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
          else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
          value -= row.value;
        }
      } else {
        parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
        rows.ratio = ratio;
      }
    }
  
    resquarify.ratio = function(x) {
      return custom((x = +x) > 1 ? x : 1);
    };
  
    return resquarify;
  })(phi);
  
  exports.cluster = cluster;
  exports.hierarchy = hierarchy;
  exports.pack = index;
  exports.packEnclose = enclose;
  exports.packSiblings = siblings;
  exports.partition = partition;
  exports.stratify = stratify;
  exports.tree = tree;
  exports.treemap = index$1;
  exports.treemapBinary = binary;
  exports.treemapDice = treemapDice;
  exports.treemapResquarify = resquarify;
  exports.treemapSlice = treemapSlice;
  exports.treemapSliceDice = sliceDice;
  exports.treemapSquarify = squarify;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{}],162:[function(_dereq_,module,exports){
  // https://d3js.org/d3-interpolate/ v1.4.0 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-color')) :
  typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
  }(this, function (exports, d3Color) { 'use strict';
  
  function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0
        + (4 - 6 * t2 + 3 * t3) * v1
        + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
        + t3 * v3) / 6;
  }
  
  function basis$1(values) {
    var n = values.length - 1;
    return function(t) {
      var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
          v1 = values[i],
          v2 = values[i + 1],
          v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
          v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
      return basis((t - i / n) * n, v0, v1, v2, v3);
    };
  }
  
  function basisClosed(values) {
    var n = values.length;
    return function(t) {
      var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
          v0 = values[(i + n - 1) % n],
          v1 = values[i % n],
          v2 = values[(i + 1) % n],
          v3 = values[(i + 2) % n];
      return basis((t - i / n) * n, v0, v1, v2, v3);
    };
  }
  
  function constant(x) {
    return function() {
      return x;
    };
  }
  
  function linear(a, d) {
    return function(t) {
      return a + t * d;
    };
  }
  
  function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
      return Math.pow(a + t * b, y);
    };
  }
  
  function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
  }
  
  function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
      return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
    };
  }
  
  function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : constant(isNaN(a) ? b : a);
  }
  
  var rgb = (function rgbGamma(y) {
    var color = gamma(y);
  
    function rgb(start, end) {
      var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
          g = color(start.g, end.g),
          b = color(start.b, end.b),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.r = r(t);
        start.g = g(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
      };
    }
  
    rgb.gamma = rgbGamma;
  
    return rgb;
  })(1);
  
  function rgbSpline(spline) {
    return function(colors) {
      var n = colors.length,
          r = new Array(n),
          g = new Array(n),
          b = new Array(n),
          i, color;
      for (i = 0; i < n; ++i) {
        color = d3Color.rgb(colors[i]);
        r[i] = color.r || 0;
        g[i] = color.g || 0;
        b[i] = color.b || 0;
      }
      r = spline(r);
      g = spline(g);
      b = spline(b);
      color.opacity = 1;
      return function(t) {
        color.r = r(t);
        color.g = g(t);
        color.b = b(t);
        return color + "";
      };
    };
  }
  
  var rgbBasis = rgbSpline(basis$1);
  var rgbBasisClosed = rgbSpline(basisClosed);
  
  function numberArray(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0,
        c = b.slice(),
        i;
    return function(t) {
      for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
      return c;
    };
  }
  
  function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
  }
  
  function array(a, b) {
    return (isNumberArray(b) ? numberArray : genericArray)(a, b);
  }
  
  function genericArray(a, b) {
    var nb = b ? b.length : 0,
        na = a ? Math.min(nb, a.length) : 0,
        x = new Array(na),
        c = new Array(nb),
        i;
  
    for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
    for (; i < nb; ++i) c[i] = b[i];
  
    return function(t) {
      for (i = 0; i < na; ++i) c[i] = x[i](t);
      return c;
    };
  }
  
  function date(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
      return d.setTime(a * (1 - t) + b * t), d;
    };
  }
  
  function number(a, b) {
    return a = +a, b = +b, function(t) {
      return a * (1 - t) + b * t;
    };
  }
  
  function object(a, b) {
    var i = {},
        c = {},
        k;
  
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
  
    for (k in b) {
      if (k in a) {
        i[k] = value(a[k], b[k]);
      } else {
        c[k] = b[k];
      }
    }
  
    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }
  
  var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
      reB = new RegExp(reA.source, "g");
  
  function zero(b) {
    return function() {
      return b;
    };
  }
  
  function one(b) {
    return function(t) {
      return b(t) + "";
    };
  }
  
  function string(a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
        am, // current match in a
        bm, // current match in b
        bs, // string preceding current number in b, if any
        i = -1, // index in s
        s = [], // string constants and placeholders
        q = []; // number interpolators
  
    // Coerce inputs to strings.
    a = a + "", b = b + "";
  
    // Interpolate pairs of numbers in a & b.
    while ((am = reA.exec(a))
        && (bm = reB.exec(b))) {
      if ((bs = bm.index) > bi) { // a string precedes the next number in b
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
        if (s[i]) s[i] += bm; // coalesce with previous string
        else s[++i] = bm;
      } else { // interpolate non-matching numbers
        s[++i] = null;
        q.push({i: i, x: number(am, bm)});
      }
      bi = reB.lastIndex;
    }
  
    // Add remains of b.
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
  
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? (q[0]
        ? one(q[0].x)
        : zero(b))
        : (b = q.length, function(t) {
            for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
            return s.join("");
          });
  }
  
  function value(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? constant(b)
        : (t === "number" ? number
        : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
        : b instanceof d3Color.color ? rgb
        : b instanceof Date ? date
        : isNumberArray(b) ? numberArray
        : Array.isArray(b) ? genericArray
        : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
        : number)(a, b);
  }
  
  function discrete(range) {
    var n = range.length;
    return function(t) {
      return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
  }
  
  function hue$1(a, b) {
    var i = hue(+a, +b);
    return function(t) {
      var x = i(t);
      return x - 360 * Math.floor(x / 360);
    };
  }
  
  function round(a, b) {
    return a = +a, b = +b, function(t) {
      return Math.round(a * (1 - t) + b * t);
    };
  }
  
  var degrees = 180 / Math.PI;
  
  var identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
  };
  
  function decompose(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
      translateX: e,
      translateY: f,
      rotate: Math.atan2(b, a) * degrees,
      skewX: Math.atan(skewX) * degrees,
      scaleX: scaleX,
      scaleY: scaleY
    };
  }
  
  var cssNode,
      cssRoot,
      cssView,
      svgNode;
  
  function parseCss(value) {
    if (value === "none") return identity;
    if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
    cssNode.style.transform = value;
    value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
    cssRoot.removeChild(cssNode);
    value = value.slice(7, -1).split(",");
    return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
  }
  
  function parseSvg(value) {
    if (value == null) return identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
    value = value.matrix;
    return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
  }
  
  function interpolateTransform(parse, pxComma, pxParen, degParen) {
  
    function pop(s) {
      return s.length ? s.pop() + " " : "";
    }
  
    function translate(xa, ya, xb, yb, s, q) {
      if (xa !== xb || ya !== yb) {
        var i = s.push("translate(", null, pxComma, null, pxParen);
        q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
      } else if (xb || yb) {
        s.push("translate(" + xb + pxComma + yb + pxParen);
      }
    }
  
    function rotate(a, b, s, q) {
      if (a !== b) {
        if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
        q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
      } else if (b) {
        s.push(pop(s) + "rotate(" + b + degParen);
      }
    }
  
    function skewX(a, b, s, q) {
      if (a !== b) {
        q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
      } else if (b) {
        s.push(pop(s) + "skewX(" + b + degParen);
      }
    }
  
    function scale(xa, ya, xb, yb, s, q) {
      if (xa !== xb || ya !== yb) {
        var i = s.push(pop(s) + "scale(", null, ",", null, ")");
        q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
      } else if (xb !== 1 || yb !== 1) {
        s.push(pop(s) + "scale(" + xb + "," + yb + ")");
      }
    }
  
    return function(a, b) {
      var s = [], // string constants and placeholders
          q = []; // number interpolators
      a = parse(a), b = parse(b);
      translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
      rotate(a.rotate, b.rotate, s, q);
      skewX(a.skewX, b.skewX, s, q);
      scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
      a = b = null; // gc
      return function(t) {
        var i = -1, n = q.length, o;
        while (++i < n) s[(o = q[i]).i] = o.x(t);
        return s.join("");
      };
    };
  }
  
  var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
  var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
  
  var rho = Math.SQRT2,
      rho2 = 2,
      rho4 = 4,
      epsilon2 = 1e-12;
  
  function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  
  function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  
  function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  
  // p0 = [ux0, uy0, w0]
  // p1 = [ux1, uy1, w1]
  function zoom(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
        ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
        dx = ux1 - ux0,
        dy = uy1 - uy0,
        d2 = dx * dx + dy * dy,
        i,
        S;
  
    // Special case for u0 ≅ u1.
    if (d2 < epsilon2) {
      S = Math.log(w1 / w0) / rho;
      i = function(t) {
        return [
          ux0 + t * dx,
          uy0 + t * dy,
          w0 * Math.exp(rho * t * S)
        ];
      };
    }
  
    // General case.
    else {
      var d1 = Math.sqrt(d2),
          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / rho;
      i = function(t) {
        var s = t * S,
            coshr0 = cosh(r0),
            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
        return [
          ux0 + u * dx,
          uy0 + u * dy,
          w0 * coshr0 / cosh(rho * s + r0)
        ];
      };
    }
  
    i.duration = S * 1000;
  
    return i;
  }
  
  function hsl(hue) {
    return function(start, end) {
      var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(t);
        start.opacity = opacity(t);
        return start + "";
      };
    }
  }
  
  var hsl$1 = hsl(hue);
  var hslLong = hsl(nogamma);
  
  function lab(start, end) {
    var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
        a = nogamma(start.a, end.a),
        b = nogamma(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.l = l(t);
      start.a = a(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  
  function hcl(hue) {
    return function(start, end) {
      var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
          c = nogamma(start.c, end.c),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.c = c(t);
        start.l = l(t);
        start.opacity = opacity(t);
        return start + "";
      };
    }
  }
  
  var hcl$1 = hcl(hue);
  var hclLong = hcl(nogamma);
  
  function cubehelix(hue) {
    return (function cubehelixGamma(y) {
      y = +y;
  
      function cubehelix(start, end) {
        var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
            s = nogamma(start.s, end.s),
            l = nogamma(start.l, end.l),
            opacity = nogamma(start.opacity, end.opacity);
        return function(t) {
          start.h = h(t);
          start.s = s(t);
          start.l = l(Math.pow(t, y));
          start.opacity = opacity(t);
          return start + "";
        };
      }
  
      cubehelix.gamma = cubehelixGamma;
  
      return cubehelix;
    })(1);
  }
  
  var cubehelix$1 = cubehelix(hue);
  var cubehelixLong = cubehelix(nogamma);
  
  function piecewise(interpolate, values) {
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while (i < n) I[i] = interpolate(v, v = values[++i]);
    return function(t) {
      var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
      return I[i](t - i);
    };
  }
  
  function quantize(interpolator, n) {
    var samples = new Array(n);
    for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
    return samples;
  }
  
  exports.interpolate = value;
  exports.interpolateArray = array;
  exports.interpolateBasis = basis$1;
  exports.interpolateBasisClosed = basisClosed;
  exports.interpolateCubehelix = cubehelix$1;
  exports.interpolateCubehelixLong = cubehelixLong;
  exports.interpolateDate = date;
  exports.interpolateDiscrete = discrete;
  exports.interpolateHcl = hcl$1;
  exports.interpolateHclLong = hclLong;
  exports.interpolateHsl = hsl$1;
  exports.interpolateHslLong = hslLong;
  exports.interpolateHue = hue$1;
  exports.interpolateLab = lab;
  exports.interpolateNumber = number;
  exports.interpolateNumberArray = numberArray;
  exports.interpolateObject = object;
  exports.interpolateRgb = rgb;
  exports.interpolateRgbBasis = rgbBasis;
  exports.interpolateRgbBasisClosed = rgbBasisClosed;
  exports.interpolateRound = round;
  exports.interpolateString = string;
  exports.interpolateTransformCss = interpolateTransformCss;
  exports.interpolateTransformSvg = interpolateTransformSvg;
  exports.interpolateZoom = zoom;
  exports.piecewise = piecewise;
  exports.quantize = quantize;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{"d3-color":158}],163:[function(_dereq_,module,exports){
  // https://d3js.org/d3-path/ v1.0.9 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}));
  }(this, function (exports) { 'use strict';
  
  var pi = Math.PI,
      tau = 2 * pi,
      epsilon = 1e-6,
      tauEpsilon = tau - epsilon;
  
  function Path() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
  }
  
  function path() {
    return new Path;
  }
  
  Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function(x, y) {
      this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
      if (this._x1 !== null) {
        this._x1 = this._x0, this._y1 = this._y0;
        this._ += "Z";
      }
    },
    lineTo: function(x, y) {
      this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
      this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
      this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
      x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
      var x0 = this._x1,
          y0 = this._y1,
          x21 = x2 - x1,
          y21 = y2 - y1,
          x01 = x0 - x1,
          y01 = y0 - y1,
          l01_2 = x01 * x01 + y01 * y01;
  
      // Is the radius negative? Error.
      if (r < 0) throw new Error("negative radius: " + r);
  
      // Is this path empty? Move to (x1,y1).
      if (this._x1 === null) {
        this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
      }
  
      // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
      else if (!(l01_2 > epsilon));
  
      // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
      // Equivalently, is (x1,y1) coincident with (x2,y2)?
      // Or, is the radius zero? Line to (x1,y1).
      else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
        this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
      }
  
      // Otherwise, draw an arc!
      else {
        var x20 = x2 - x0,
            y20 = y2 - y0,
            l21_2 = x21 * x21 + y21 * y21,
            l20_2 = x20 * x20 + y20 * y20,
            l21 = Math.sqrt(l21_2),
            l01 = Math.sqrt(l01_2),
            l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
            t01 = l / l01,
            t21 = l / l21;
  
        // If the start tangent is not coincident with (x0,y0), line to.
        if (Math.abs(t01 - 1) > epsilon) {
          this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
        }
  
        this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
      }
    },
    arc: function(x, y, r, a0, a1, ccw) {
      x = +x, y = +y, r = +r, ccw = !!ccw;
      var dx = r * Math.cos(a0),
          dy = r * Math.sin(a0),
          x0 = x + dx,
          y0 = y + dy,
          cw = 1 ^ ccw,
          da = ccw ? a0 - a1 : a1 - a0;
  
      // Is the radius negative? Error.
      if (r < 0) throw new Error("negative radius: " + r);
  
      // Is this path empty? Move to (x0,y0).
      if (this._x1 === null) {
        this._ += "M" + x0 + "," + y0;
      }
  
      // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
      else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
        this._ += "L" + x0 + "," + y0;
      }
  
      // Is this arc empty? We’re done.
      if (!r) return;
  
      // Does the angle go the wrong way? Flip the direction.
      if (da < 0) da = da % tau + tau;
  
      // Is this a complete circle? Draw two arcs to complete the circle.
      if (da > tauEpsilon) {
        this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
      }
  
      // Is this arc non-empty? Draw an arc!
      else if (da > epsilon) {
        this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
      }
    },
    rect: function(x, y, w, h) {
      this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
    },
    toString: function() {
      return this._;
    }
  };
  
  exports.path = path;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{}],164:[function(_dereq_,module,exports){
  // https://d3js.org/d3-quadtree/ v1.0.7 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}));
  }(this, function (exports) { 'use strict';
  
  function tree_add(d) {
    var x = +this._x.call(null, d),
        y = +this._y.call(null, d);
    return add(this.cover(x, y), x, y, d);
  }
  
  function add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
  
    var parent,
        node = tree._root,
        leaf = {data: d},
        x0 = tree._x0,
        y0 = tree._y0,
        x1 = tree._x1,
        y1 = tree._y1,
        xm,
        ym,
        xp,
        yp,
        right,
        bottom,
        i,
        j;
  
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
  
    // Find the existing leaf for the new point, or add it.
    while (node.length) {
      if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
      if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
      if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
  
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
  
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
      parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
      if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
      if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
    } while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | (xp >= xm)));
    return parent[j] = node, parent[i] = leaf, tree;
  }
  
  function addAll(data) {
    var d, i, n = data.length,
        x,
        y,
        xz = new Array(n),
        yz = new Array(n),
        x0 = Infinity,
        y0 = Infinity,
        x1 = -Infinity,
        y1 = -Infinity;
  
    // Compute the points and their extent.
    for (i = 0; i < n; ++i) {
      if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
      xz[i] = x;
      yz[i] = y;
      if (x < x0) x0 = x;
      if (x > x1) x1 = x;
      if (y < y0) y0 = y;
      if (y > y1) y1 = y;
    }
  
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
  
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
  
    // Add the new points.
    for (i = 0; i < n; ++i) {
      add(this, xz[i], yz[i], data[i]);
    }
  
    return this;
  }
  
  function tree_cover(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
  
    var x0 = this._x0,
        y0 = this._y0,
        x1 = this._x1,
        y1 = this._y1;
  
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
      x1 = (x0 = Math.floor(x)) + 1;
      y1 = (y0 = Math.floor(y)) + 1;
    }
  
    // Otherwise, double repeatedly to cover.
    else {
      var z = x1 - x0,
          node = this._root,
          parent,
          i;
  
      while (x0 > x || x >= x1 || y0 > y || y >= y1) {
        i = (y < y0) << 1 | (x < x0);
        parent = new Array(4), parent[i] = node, node = parent, z *= 2;
        switch (i) {
          case 0: x1 = x0 + z, y1 = y0 + z; break;
          case 1: x0 = x1 - z, y1 = y0 + z; break;
          case 2: x1 = x0 + z, y0 = y1 - z; break;
          case 3: x0 = x1 - z, y0 = y1 - z; break;
        }
      }
  
      if (this._root && this._root.length) this._root = node;
    }
  
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
  }
  
  function tree_data() {
    var data = [];
    this.visit(function(node) {
      if (!node.length) do data.push(node.data); while (node = node.next)
    });
    return data;
  }
  
  function tree_extent(_) {
    return arguments.length
        ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1])
        : isNaN(this._x0) ? undefined : [[this._x0, this._y0], [this._x1, this._y1]];
  }
  
  function Quad(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
  }
  
  function tree_find(x, y, radius) {
    var data,
        x0 = this._x0,
        y0 = this._y0,
        x1,
        y1,
        x2,
        y2,
        x3 = this._x1,
        y3 = this._y1,
        quads = [],
        node = this._root,
        q,
        i;
  
    if (node) quads.push(new Quad(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
      x0 = x - radius, y0 = y - radius;
      x3 = x + radius, y3 = y + radius;
      radius *= radius;
    }
  
    while (q = quads.pop()) {
  
      // Stop searching if this quadrant can’t contain a closer node.
      if (!(node = q.node)
          || (x1 = q.x0) > x3
          || (y1 = q.y0) > y3
          || (x2 = q.x1) < x0
          || (y2 = q.y1) < y0) continue;
  
      // Bisect the current quadrant.
      if (node.length) {
        var xm = (x1 + x2) / 2,
            ym = (y1 + y2) / 2;
  
        quads.push(
          new Quad(node[3], xm, ym, x2, y2),
          new Quad(node[2], x1, ym, xm, y2),
          new Quad(node[1], xm, y1, x2, ym),
          new Quad(node[0], x1, y1, xm, ym)
        );
  
        // Visit the closest quadrant first.
        if (i = (y >= ym) << 1 | (x >= xm)) {
          q = quads[quads.length - 1];
          quads[quads.length - 1] = quads[quads.length - 1 - i];
          quads[quads.length - 1 - i] = q;
        }
      }
  
      // Visit this point. (Visiting coincident points isn’t necessary!)
      else {
        var dx = x - +this._x.call(null, node.data),
            dy = y - +this._y.call(null, node.data),
            d2 = dx * dx + dy * dy;
        if (d2 < radius) {
          var d = Math.sqrt(radius = d2);
          x0 = x - d, y0 = y - d;
          x3 = x + d, y3 = y + d;
          data = node.data;
        }
      }
    }
  
    return data;
  }
  
  function tree_remove(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
  
    var parent,
        node = this._root,
        retainer,
        previous,
        next,
        x0 = this._x0,
        y0 = this._y0,
        x1 = this._x1,
        y1 = this._y1,
        x,
        y,
        xm,
        ym,
        right,
        bottom,
        i,
        j;
  
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
  
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while (true) {
      if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm; else x1 = xm;
      if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym; else y1 = ym;
      if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
      if (!node.length) break;
      if (parent[(i + 1) & 3] || parent[(i + 2) & 3] || parent[(i + 3) & 3]) retainer = parent, j = i;
    }
  
    // Find the point to remove.
    while (node.data !== d) if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
  
    // If there are multiple coincident points, remove just the point.
    if (previous) return (next ? previous.next = next : delete previous.next), this;
  
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
  
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
  
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3])
        && node === (parent[3] || parent[2] || parent[1] || parent[0])
        && !node.length) {
      if (retainer) retainer[j] = node;
      else this._root = node;
    }
  
    return this;
  }
  
  function removeAll(data) {
    for (var i = 0, n = data.length; i < n; ++i) this.remove(data[i]);
    return this;
  }
  
  function tree_root() {
    return this._root;
  }
  
  function tree_size() {
    var size = 0;
    this.visit(function(node) {
      if (!node.length) do ++size; while (node = node.next)
    });
    return size;
  }
  
  function tree_visit(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new Quad(node, this._x0, this._y0, this._x1, this._y1));
    while (q = quads.pop()) {
      if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
      }
    }
    return this;
  }
  
  function tree_visitAfter(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new Quad(this._root, this._x0, this._y0, this._x1, this._y1));
    while (q = quads.pop()) {
      var node = q.node;
      if (node.length) {
        var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[0]) quads.push(new Quad(child, x0, y0, xm, ym));
        if (child = node[1]) quads.push(new Quad(child, xm, y0, x1, ym));
        if (child = node[2]) quads.push(new Quad(child, x0, ym, xm, y1));
        if (child = node[3]) quads.push(new Quad(child, xm, ym, x1, y1));
      }
      next.push(q);
    }
    while (q = next.pop()) {
      callback(q.node, q.x0, q.y0, q.x1, q.y1);
    }
    return this;
  }
  
  function defaultX(d) {
    return d[0];
  }
  
  function tree_x(_) {
    return arguments.length ? (this._x = _, this) : this._x;
  }
  
  function defaultY(d) {
    return d[1];
  }
  
  function tree_y(_) {
    return arguments.length ? (this._y = _, this) : this._y;
  }
  
  function quadtree(nodes, x, y) {
    var tree = new Quadtree(x == null ? defaultX : x, y == null ? defaultY : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
  }
  
  function Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
  }
  
  function leaf_copy(leaf) {
    var copy = {data: leaf.data}, next = copy;
    while (leaf = leaf.next) next = next.next = {data: leaf.data};
    return copy;
  }
  
  var treeProto = quadtree.prototype = Quadtree.prototype;
  
  treeProto.copy = function() {
    var copy = new Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1),
        node = this._root,
        nodes,
        child;
  
    if (!node) return copy;
  
    if (!node.length) return copy._root = leaf_copy(node), copy;
  
    nodes = [{source: node, target: copy._root = new Array(4)}];
    while (node = nodes.pop()) {
      for (var i = 0; i < 4; ++i) {
        if (child = node.source[i]) {
          if (child.length) nodes.push({source: child, target: node.target[i] = new Array(4)});
          else node.target[i] = leaf_copy(child);
        }
      }
    }
  
    return copy;
  };
  
  treeProto.add = tree_add;
  treeProto.addAll = addAll;
  treeProto.cover = tree_cover;
  treeProto.data = tree_data;
  treeProto.extent = tree_extent;
  treeProto.find = tree_find;
  treeProto.remove = tree_remove;
  treeProto.removeAll = removeAll;
  treeProto.root = tree_root;
  treeProto.size = tree_size;
  treeProto.visit = tree_visit;
  treeProto.visitAfter = tree_visitAfter;
  treeProto.x = tree_x;
  treeProto.y = tree_y;
  
  exports.quadtree = quadtree;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{}],165:[function(_dereq_,module,exports){
  // https://d3js.org/d3-shape/ v1.3.7 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-path')) :
  typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
  }(this, function (exports, d3Path) { 'use strict';
  
  function constant(x) {
    return function constant() {
      return x;
    };
  }
  
  var abs = Math.abs;
  var atan2 = Math.atan2;
  var cos = Math.cos;
  var max = Math.max;
  var min = Math.min;
  var sin = Math.sin;
  var sqrt = Math.sqrt;
  
  var epsilon = 1e-12;
  var pi = Math.PI;
  var halfPi = pi / 2;
  var tau = 2 * pi;
  
  function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
  }
  
  function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
  }
  
  function arcInnerRadius(d) {
    return d.innerRadius;
  }
  
  function arcOuterRadius(d) {
    return d.outerRadius;
  }
  
  function arcStartAngle(d) {
    return d.startAngle;
  }
  
  function arcEndAngle(d) {
    return d.endAngle;
  }
  
  function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
  }
  
  function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0,
        x32 = x3 - x2, y32 = y3 - y2,
        t = y32 * x10 - x32 * y10;
    if (t * t < epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [x0 + t * x10, y0 + t * y10];
  }
  
  // Compute perpendicular offset line of length rc.
  // http://mathworld.wolfram.com/Circle-LineIntersection.html
  function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1,
        y01 = y0 - y1,
        lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
        ox = lo * y01,
        oy = -lo * x01,
        x11 = x0 + ox,
        y11 = y0 + oy,
        x10 = x1 + ox,
        y10 = y1 + oy,
        x00 = (x11 + x10) / 2,
        y00 = (y11 + y10) / 2,
        dx = x10 - x11,
        dy = y10 - y11,
        d2 = dx * dx + dy * dy,
        r = r1 - rc,
        D = x11 * y10 - x10 * y11,
        d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
        cx0 = (D * dy - dx * d) / d2,
        cy0 = (-D * dx - dy * d) / d2,
        cx1 = (D * dy + dx * d) / d2,
        cy1 = (-D * dx + dy * d) / d2,
        dx0 = cx0 - x00,
        dy0 = cy0 - y00,
        dx1 = cx1 - x00,
        dy1 = cy1 - y00;
  
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
  
    return {
      cx: cx0,
      cy: cy0,
      x01: -ox,
      y01: -oy,
      x11: cx0 * (r1 / r - 1),
      y11: cy0 * (r1 / r - 1)
    };
  }
  
  function arc() {
    var innerRadius = arcInnerRadius,
        outerRadius = arcOuterRadius,
        cornerRadius = constant(0),
        padRadius = null,
        startAngle = arcStartAngle,
        endAngle = arcEndAngle,
        padAngle = arcPadAngle,
        context = null;
  
    function arc() {
      var buffer,
          r,
          r0 = +innerRadius.apply(this, arguments),
          r1 = +outerRadius.apply(this, arguments),
          a0 = startAngle.apply(this, arguments) - halfPi,
          a1 = endAngle.apply(this, arguments) - halfPi,
          da = abs(a1 - a0),
          cw = a1 > a0;
  
      if (!context) context = buffer = d3Path.path();
  
      // Ensure that the outer radius is always larger than the inner radius.
      if (r1 < r0) r = r1, r1 = r0, r0 = r;
  
      // Is it a point?
      if (!(r1 > epsilon)) context.moveTo(0, 0);
  
      // Or is it a circle or annulus?
      else if (da > tau - epsilon) {
        context.moveTo(r1 * cos(a0), r1 * sin(a0));
        context.arc(0, 0, r1, a0, a1, !cw);
        if (r0 > epsilon) {
          context.moveTo(r0 * cos(a1), r0 * sin(a1));
          context.arc(0, 0, r0, a1, a0, cw);
        }
      }
  
      // Or is it a circular or annular sector?
      else {
        var a01 = a0,
            a11 = a1,
            a00 = a0,
            a10 = a1,
            da0 = da,
            da1 = da,
            ap = padAngle.apply(this, arguments) / 2,
            rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
            rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
            rc0 = rc,
            rc1 = rc,
            t0,
            t1;
  
        // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
        if (rp > epsilon) {
          var p0 = asin(rp / r0 * sin(ap)),
              p1 = asin(rp / r1 * sin(ap));
          if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
          else da0 = 0, a00 = a10 = (a0 + a1) / 2;
          if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
          else da1 = 0, a01 = a11 = (a0 + a1) / 2;
        }
  
        var x01 = r1 * cos(a01),
            y01 = r1 * sin(a01),
            x10 = r0 * cos(a10),
            y10 = r0 * sin(a10);
  
        // Apply rounded corners?
        if (rc > epsilon) {
          var x11 = r1 * cos(a11),
              y11 = r1 * sin(a11),
              x00 = r0 * cos(a00),
              y00 = r0 * sin(a00),
              oc;
  
          // Restrict the corner radius according to the sector angle.
          if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
            var ax = x01 - oc[0],
                ay = y01 - oc[1],
                bx = x11 - oc[0],
                by = y11 - oc[1],
                kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
                lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = min(rc, (r0 - lc) / (kc - 1));
            rc1 = min(rc, (r1 - lc) / (kc + 1));
          }
        }
  
        // Is the sector collapsed to a line?
        if (!(da1 > epsilon)) context.moveTo(x01, y01);
  
        // Does the sector’s outer ring have rounded corners?
        else if (rc1 > epsilon) {
          t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
          t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
  
          context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
  
          // Have the corners merged?
          if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
  
          // Otherwise, draw the two corners and the ring.
          else {
            context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
            context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
            context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
          }
        }
  
        // Or is the outer ring just a circular arc?
        else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
  
        // Is there no inner ring, and it’s a circular sector?
        // Or perhaps it’s an annular sector collapsed due to padding?
        if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
  
        // Does the sector’s inner ring (or point) have rounded corners?
        else if (rc0 > epsilon) {
          t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
          t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
  
          context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
  
          // Have the corners merged?
          if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
  
          // Otherwise, draw the two corners and the ring.
          else {
            context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
            context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
            context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
          }
        }
  
        // Or is the inner ring just a circular arc?
        else context.arc(0, 0, r0, a10, a00, cw);
      }
  
      context.closePath();
  
      if (buffer) return context = null, buffer + "" || null;
    }
  
    arc.centroid = function() {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
          a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
      return [cos(a) * r, sin(a) * r];
    };
  
    arc.innerRadius = function(_) {
      return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
    };
  
    arc.outerRadius = function(_) {
      return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
    };
  
    arc.cornerRadius = function(_) {
      return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
    };
  
    arc.padRadius = function(_) {
      return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
    };
  
    arc.startAngle = function(_) {
      return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
    };
  
    arc.endAngle = function(_) {
      return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
    };
  
    arc.padAngle = function(_) {
      return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
    };
  
    arc.context = function(_) {
      return arguments.length ? ((context = _ == null ? null : _), arc) : context;
    };
  
    return arc;
  }
  
  function Linear(context) {
    this._context = context;
  }
  
  Linear.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._point = 0;
    },
    lineEnd: function() {
      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
        case 1: this._point = 2; // proceed
        default: this._context.lineTo(x, y); break;
      }
    }
  };
  
  function curveLinear(context) {
    return new Linear(context);
  }
  
  function x(p) {
    return p[0];
  }
  
  function y(p) {
    return p[1];
  }
  
  function line() {
    var x$1 = x,
        y$1 = y,
        defined = constant(true),
        context = null,
        curve = curveLinear,
        output = null;
  
    function line(data) {
      var i,
          n = data.length,
          d,
          defined0 = false,
          buffer;
  
      if (context == null) output = curve(buffer = d3Path.path());
  
      for (i = 0; i <= n; ++i) {
        if (!(i < n && defined(d = data[i], i, data)) === defined0) {
          if (defined0 = !defined0) output.lineStart();
          else output.lineEnd();
        }
        if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
      }
  
      if (buffer) return output = null, buffer + "" || null;
    }
  
    line.x = function(_) {
      return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line) : x$1;
    };
  
    line.y = function(_) {
      return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line) : y$1;
    };
  
    line.defined = function(_) {
      return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
    };
  
    line.curve = function(_) {
      return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
  
    line.context = function(_) {
      return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
  
    return line;
  }
  
  function area() {
    var x0 = x,
        x1 = null,
        y0 = constant(0),
        y1 = y,
        defined = constant(true),
        context = null,
        curve = curveLinear,
        output = null;
  
    function area(data) {
      var i,
          j,
          k,
          n = data.length,
          d,
          defined0 = false,
          buffer,
          x0z = new Array(n),
          y0z = new Array(n);
  
      if (context == null) output = curve(buffer = d3Path.path());
  
      for (i = 0; i <= n; ++i) {
        if (!(i < n && defined(d = data[i], i, data)) === defined0) {
          if (defined0 = !defined0) {
            j = i;
            output.areaStart();
            output.lineStart();
          } else {
            output.lineEnd();
            output.lineStart();
            for (k = i - 1; k >= j; --k) {
              output.point(x0z[k], y0z[k]);
            }
            output.lineEnd();
            output.areaEnd();
          }
        }
        if (defined0) {
          x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
          output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
        }
      }
  
      if (buffer) return output = null, buffer + "" || null;
    }
  
    function arealine() {
      return line().defined(defined).curve(curve).context(context);
    }
  
    area.x = function(_) {
      return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), x1 = null, area) : x0;
    };
  
    area.x0 = function(_) {
      return arguments.length ? (x0 = typeof _ === "function" ? _ : constant(+_), area) : x0;
    };
  
    area.x1 = function(_) {
      return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : x1;
    };
  
    area.y = function(_) {
      return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), y1 = null, area) : y0;
    };
  
    area.y0 = function(_) {
      return arguments.length ? (y0 = typeof _ === "function" ? _ : constant(+_), area) : y0;
    };
  
    area.y1 = function(_) {
      return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant(+_), area) : y1;
    };
  
    area.lineX0 =
    area.lineY0 = function() {
      return arealine().x(x0).y(y0);
    };
  
    area.lineY1 = function() {
      return arealine().x(x0).y(y1);
    };
  
    area.lineX1 = function() {
      return arealine().x(x1).y(y0);
    };
  
    area.defined = function(_) {
      return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), area) : defined;
    };
  
    area.curve = function(_) {
      return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
  
    area.context = function(_) {
      return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
  
    return area;
  }
  
  function descending(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  }
  
  function identity(d) {
    return d;
  }
  
  function pie() {
    var value = identity,
        sortValues = descending,
        sort = null,
        startAngle = constant(0),
        endAngle = constant(tau),
        padAngle = constant(0);
  
    function pie(data) {
      var i,
          n = data.length,
          j,
          k,
          sum = 0,
          index = new Array(n),
          arcs = new Array(n),
          a0 = +startAngle.apply(this, arguments),
          da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
          a1,
          p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
          pa = p * (da < 0 ? -1 : 1),
          v;
  
      for (i = 0; i < n; ++i) {
        if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
          sum += v;
        }
      }
  
      // Optionally sort the arcs by previously-computed values or by data.
      if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
      else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
  
      // Compute the arcs! They are stored in the original data's order.
      for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
        j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
          data: data[j],
          index: i,
          value: v,
          startAngle: a0,
          endAngle: a1,
          padAngle: p
        };
      }
  
      return arcs;
    }
  
    pie.value = function(_) {
      return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
    };
  
    pie.sortValues = function(_) {
      return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
  
    pie.sort = function(_) {
      return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
  
    pie.startAngle = function(_) {
      return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
    };
  
    pie.endAngle = function(_) {
      return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
    };
  
    pie.padAngle = function(_) {
      return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
    };
  
    return pie;
  }
  
  var curveRadialLinear = curveRadial(curveLinear);
  
  function Radial(curve) {
    this._curve = curve;
  }
  
  Radial.prototype = {
    areaStart: function() {
      this._curve.areaStart();
    },
    areaEnd: function() {
      this._curve.areaEnd();
    },
    lineStart: function() {
      this._curve.lineStart();
    },
    lineEnd: function() {
      this._curve.lineEnd();
    },
    point: function(a, r) {
      this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
  };
  
  function curveRadial(curve) {
  
    function radial(context) {
      return new Radial(curve(context));
    }
  
    radial._curve = curve;
  
    return radial;
  }
  
  function lineRadial(l) {
    var c = l.curve;
  
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
  
    l.curve = function(_) {
      return arguments.length ? c(curveRadial(_)) : c()._curve;
    };
  
    return l;
  }
  
  function lineRadial$1() {
    return lineRadial(line().curve(curveRadialLinear));
  }
  
  function areaRadial() {
    var a = area().curve(curveRadialLinear),
        c = a.curve,
        x0 = a.lineX0,
        x1 = a.lineX1,
        y0 = a.lineY0,
        y1 = a.lineY1;
  
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() { return lineRadial(x0()); }, delete a.lineX0;
    a.lineEndAngle = function() { return lineRadial(x1()); }, delete a.lineX1;
    a.lineInnerRadius = function() { return lineRadial(y0()); }, delete a.lineY0;
    a.lineOuterRadius = function() { return lineRadial(y1()); }, delete a.lineY1;
  
    a.curve = function(_) {
      return arguments.length ? c(curveRadial(_)) : c()._curve;
    };
  
    return a;
  }
  
  function pointRadial(x, y) {
    return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
  }
  
  var slice = Array.prototype.slice;
  
  function linkSource(d) {
    return d.source;
  }
  
  function linkTarget(d) {
    return d.target;
  }
  
  function link(curve) {
    var source = linkSource,
        target = linkTarget,
        x$1 = x,
        y$1 = y,
        context = null;
  
    function link() {
      var buffer, argv = slice.call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
      if (!context) context = buffer = d3Path.path();
      curve(context, +x$1.apply(this, (argv[0] = s, argv)), +y$1.apply(this, argv), +x$1.apply(this, (argv[0] = t, argv)), +y$1.apply(this, argv));
      if (buffer) return context = null, buffer + "" || null;
    }
  
    link.source = function(_) {
      return arguments.length ? (source = _, link) : source;
    };
  
    link.target = function(_) {
      return arguments.length ? (target = _, link) : target;
    };
  
    link.x = function(_) {
      return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), link) : x$1;
    };
  
    link.y = function(_) {
      return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), link) : y$1;
    };
  
    link.context = function(_) {
      return arguments.length ? ((context = _ == null ? null : _), link) : context;
    };
  
    return link;
  }
  
  function curveHorizontal(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
  }
  
  function curveVertical(context, x0, y0, x1, y1) {
    context.moveTo(x0, y0);
    context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
  }
  
  function curveRadial$1(context, x0, y0, x1, y1) {
    var p0 = pointRadial(x0, y0),
        p1 = pointRadial(x0, y0 = (y0 + y1) / 2),
        p2 = pointRadial(x1, y0),
        p3 = pointRadial(x1, y1);
    context.moveTo(p0[0], p0[1]);
    context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
  }
  
  function linkHorizontal() {
    return link(curveHorizontal);
  }
  
  function linkVertical() {
    return link(curveVertical);
  }
  
  function linkRadial() {
    var l = link(curveRadial$1);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
  }
  
  var circle = {
    draw: function(context, size) {
      var r = Math.sqrt(size / pi);
      context.moveTo(r, 0);
      context.arc(0, 0, r, 0, tau);
    }
  };
  
  var cross = {
    draw: function(context, size) {
      var r = Math.sqrt(size / 5) / 2;
      context.moveTo(-3 * r, -r);
      context.lineTo(-r, -r);
      context.lineTo(-r, -3 * r);
      context.lineTo(r, -3 * r);
      context.lineTo(r, -r);
      context.lineTo(3 * r, -r);
      context.lineTo(3 * r, r);
      context.lineTo(r, r);
      context.lineTo(r, 3 * r);
      context.lineTo(-r, 3 * r);
      context.lineTo(-r, r);
      context.lineTo(-3 * r, r);
      context.closePath();
    }
  };
  
  var tan30 = Math.sqrt(1 / 3),
      tan30_2 = tan30 * 2;
  
  var diamond = {
    draw: function(context, size) {
      var y = Math.sqrt(size / tan30_2),
          x = y * tan30;
      context.moveTo(0, -y);
      context.lineTo(x, 0);
      context.lineTo(0, y);
      context.lineTo(-x, 0);
      context.closePath();
    }
  };
  
  var ka = 0.89081309152928522810,
      kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10),
      kx = Math.sin(tau / 10) * kr,
      ky = -Math.cos(tau / 10) * kr;
  
  var star = {
    draw: function(context, size) {
      var r = Math.sqrt(size * ka),
          x = kx * r,
          y = ky * r;
      context.moveTo(0, -r);
      context.lineTo(x, y);
      for (var i = 1; i < 5; ++i) {
        var a = tau * i / 5,
            c = Math.cos(a),
            s = Math.sin(a);
        context.lineTo(s * r, -c * r);
        context.lineTo(c * x - s * y, s * x + c * y);
      }
      context.closePath();
    }
  };
  
  var square = {
    draw: function(context, size) {
      var w = Math.sqrt(size),
          x = -w / 2;
      context.rect(x, x, w, w);
    }
  };
  
  var sqrt3 = Math.sqrt(3);
  
  var triangle = {
    draw: function(context, size) {
      var y = -Math.sqrt(size / (sqrt3 * 3));
      context.moveTo(0, y * 2);
      context.lineTo(-sqrt3 * y, -y);
      context.lineTo(sqrt3 * y, -y);
      context.closePath();
    }
  };
  
  var c = -0.5,
      s = Math.sqrt(3) / 2,
      k = 1 / Math.sqrt(12),
      a = (k / 2 + 1) * 3;
  
  var wye = {
    draw: function(context, size) {
      var r = Math.sqrt(size / a),
          x0 = r / 2,
          y0 = r * k,
          x1 = x0,
          y1 = r * k + r,
          x2 = -x1,
          y2 = y1;
      context.moveTo(x0, y0);
      context.lineTo(x1, y1);
      context.lineTo(x2, y2);
      context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
      context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
      context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
      context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
      context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
      context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
      context.closePath();
    }
  };
  
  var symbols = [
    circle,
    cross,
    diamond,
    square,
    star,
    triangle,
    wye
  ];
  
  function symbol() {
    var type = constant(circle),
        size = constant(64),
        context = null;
  
    function symbol() {
      var buffer;
      if (!context) context = buffer = d3Path.path();
      type.apply(this, arguments).draw(context, +size.apply(this, arguments));
      if (buffer) return context = null, buffer + "" || null;
    }
  
    symbol.type = function(_) {
      return arguments.length ? (type = typeof _ === "function" ? _ : constant(_), symbol) : type;
    };
  
    symbol.size = function(_) {
      return arguments.length ? (size = typeof _ === "function" ? _ : constant(+_), symbol) : size;
    };
  
    symbol.context = function(_) {
      return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
  
    return symbol;
  }
  
  function noop() {}
  
  function point(that, x, y) {
    that._context.bezierCurveTo(
      (2 * that._x0 + that._x1) / 3,
      (2 * that._y0 + that._y1) / 3,
      (that._x0 + 2 * that._x1) / 3,
      (that._y0 + 2 * that._y1) / 3,
      (that._x0 + 4 * that._x1 + x) / 6,
      (that._y0 + 4 * that._y1 + y) / 6
    );
  }
  
  function Basis(context) {
    this._context = context;
  }
  
  Basis.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 =
      this._y0 = this._y1 = NaN;
      this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 3: point(this, this._x1, this._y1); // proceed
        case 2: this._context.lineTo(this._x1, this._y1); break;
      }
      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
        case 1: this._point = 2; break;
        case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
        default: point(this, x, y); break;
      }
      this._x0 = this._x1, this._x1 = x;
      this._y0 = this._y1, this._y1 = y;
    }
  };
  
  function basis(context) {
    return new Basis(context);
  }
  
  function BasisClosed(context) {
    this._context = context;
  }
  
  BasisClosed.prototype = {
    areaStart: noop,
    areaEnd: noop,
    lineStart: function() {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
      this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
      this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 1: {
          this._context.moveTo(this._x2, this._y2);
          this._context.closePath();
          break;
        }
        case 2: {
          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
          this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
          this._context.closePath();
          break;
        }
        case 3: {
          this.point(this._x2, this._y2);
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          break;
        }
      }
    },
    point: function(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
        case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
        case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
        default: point(this, x, y); break;
      }
      this._x0 = this._x1, this._x1 = x;
      this._y0 = this._y1, this._y1 = y;
    }
  };
  
  function basisClosed(context) {
    return new BasisClosed(context);
  }
  
  function BasisOpen(context) {
    this._context = context;
  }
  
  BasisOpen.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 =
      this._y0 = this._y1 = NaN;
      this._point = 0;
    },
    lineEnd: function() {
      if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0: this._point = 1; break;
        case 1: this._point = 2; break;
        case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
        case 3: this._point = 4; // proceed
        default: point(this, x, y); break;
      }
      this._x0 = this._x1, this._x1 = x;
      this._y0 = this._y1, this._y1 = y;
    }
  };
  
  function basisOpen(context) {
    return new BasisOpen(context);
  }
  
  function Bundle(context, beta) {
    this._basis = new Basis(context);
    this._beta = beta;
  }
  
  Bundle.prototype = {
    lineStart: function() {
      this._x = [];
      this._y = [];
      this._basis.lineStart();
    },
    lineEnd: function() {
      var x = this._x,
          y = this._y,
          j = x.length - 1;
  
      if (j > 0) {
        var x0 = x[0],
            y0 = y[0],
            dx = x[j] - x0,
            dy = y[j] - y0,
            i = -1,
            t;
  
        while (++i <= j) {
          t = i / j;
          this._basis.point(
            this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
            this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
          );
        }
      }
  
      this._x = this._y = null;
      this._basis.lineEnd();
    },
    point: function(x, y) {
      this._x.push(+x);
      this._y.push(+y);
    }
  };
  
  var bundle = (function custom(beta) {
  
    function bundle(context) {
      return beta === 1 ? new Basis(context) : new Bundle(context, beta);
    }
  
    bundle.beta = function(beta) {
      return custom(+beta);
    };
  
    return bundle;
  })(0.85);
  
  function point$1(that, x, y) {
    that._context.bezierCurveTo(
      that._x1 + that._k * (that._x2 - that._x0),
      that._y1 + that._k * (that._y2 - that._y0),
      that._x2 + that._k * (that._x1 - x),
      that._y2 + that._k * (that._y1 - y),
      that._x2,
      that._y2
    );
  }
  
  function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
  }
  
  Cardinal.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._x2 =
      this._y0 = this._y1 = this._y2 = NaN;
      this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 2: this._context.lineTo(this._x2, this._y2); break;
        case 3: point$1(this, this._x1, this._y1); break;
      }
      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
        case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
        case 2: this._point = 3; // proceed
        default: point$1(this, x, y); break;
      }
      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  
  var cardinal = (function custom(tension) {
  
    function cardinal(context) {
      return new Cardinal(context, tension);
    }
  
    cardinal.tension = function(tension) {
      return custom(+tension);
    };
  
    return cardinal;
  })(0);
  
  function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
  }
  
  CardinalClosed.prototype = {
    areaStart: noop,
    areaEnd: noop,
    lineStart: function() {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
      this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
      this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 1: {
          this._context.moveTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
        case 2: {
          this._context.lineTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
        case 3: {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
      }
    },
    point: function(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
        case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
        case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
        default: point$1(this, x, y); break;
      }
      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  
  var cardinalClosed = (function custom(tension) {
  
    function cardinal(context) {
      return new CardinalClosed(context, tension);
    }
  
    cardinal.tension = function(tension) {
      return custom(+tension);
    };
  
    return cardinal;
  })(0);
  
  function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
  }
  
  CardinalOpen.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._x2 =
      this._y0 = this._y1 = this._y2 = NaN;
      this._point = 0;
    },
    lineEnd: function() {
      if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0: this._point = 1; break;
        case 1: this._point = 2; break;
        case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
        case 3: this._point = 4; // proceed
        default: point$1(this, x, y); break;
      }
      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  
  var cardinalOpen = (function custom(tension) {
  
    function cardinal(context) {
      return new CardinalOpen(context, tension);
    }
  
    cardinal.tension = function(tension) {
      return custom(+tension);
    };
  
    return cardinal;
  })(0);
  
  function point$2(that, x, y) {
    var x1 = that._x1,
        y1 = that._y1,
        x2 = that._x2,
        y2 = that._y2;
  
    if (that._l01_a > epsilon) {
      var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
          n = 3 * that._l01_a * (that._l01_a + that._l12_a);
      x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
      y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
  
    if (that._l23_a > epsilon) {
      var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
          m = 3 * that._l23_a * (that._l23_a + that._l12_a);
      x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
      y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
  
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
  }
  
  function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
  }
  
  CatmullRom.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._x2 =
      this._y0 = this._y1 = this._y2 = NaN;
      this._l01_a = this._l12_a = this._l23_a =
      this._l01_2a = this._l12_2a = this._l23_2a =
      this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 2: this._context.lineTo(this._x2, this._y2); break;
        case 3: this.point(this._x2, this._y2); break;
      }
      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function(x, y) {
      x = +x, y = +y;
  
      if (this._point) {
        var x23 = this._x2 - x,
            y23 = this._y2 - y;
        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
      }
  
      switch (this._point) {
        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
        case 1: this._point = 2; break;
        case 2: this._point = 3; // proceed
        default: point$2(this, x, y); break;
      }
  
      this._l01_a = this._l12_a, this._l12_a = this._l23_a;
      this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  
  var catmullRom = (function custom(alpha) {
  
    function catmullRom(context) {
      return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
    }
  
    catmullRom.alpha = function(alpha) {
      return custom(+alpha);
    };
  
    return catmullRom;
  })(0.5);
  
  function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
  }
  
  CatmullRomClosed.prototype = {
    areaStart: noop,
    areaEnd: noop,
    lineStart: function() {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
      this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
      this._l01_a = this._l12_a = this._l23_a =
      this._l01_2a = this._l12_2a = this._l23_2a =
      this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 1: {
          this._context.moveTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
        case 2: {
          this._context.lineTo(this._x3, this._y3);
          this._context.closePath();
          break;
        }
        case 3: {
          this.point(this._x3, this._y3);
          this.point(this._x4, this._y4);
          this.point(this._x5, this._y5);
          break;
        }
      }
    },
    point: function(x, y) {
      x = +x, y = +y;
  
      if (this._point) {
        var x23 = this._x2 - x,
            y23 = this._y2 - y;
        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
      }
  
      switch (this._point) {
        case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
        case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
        case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
        default: point$2(this, x, y); break;
      }
  
      this._l01_a = this._l12_a, this._l12_a = this._l23_a;
      this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  
  var catmullRomClosed = (function custom(alpha) {
  
    function catmullRom(context) {
      return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
    }
  
    catmullRom.alpha = function(alpha) {
      return custom(+alpha);
    };
  
    return catmullRom;
  })(0.5);
  
  function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
  }
  
  CatmullRomOpen.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._x2 =
      this._y0 = this._y1 = this._y2 = NaN;
      this._l01_a = this._l12_a = this._l23_a =
      this._l01_2a = this._l12_2a = this._l23_2a =
      this._point = 0;
    },
    lineEnd: function() {
      if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function(x, y) {
      x = +x, y = +y;
  
      if (this._point) {
        var x23 = this._x2 - x,
            y23 = this._y2 - y;
        this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
      }
  
      switch (this._point) {
        case 0: this._point = 1; break;
        case 1: this._point = 2; break;
        case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
        case 3: this._point = 4; // proceed
        default: point$2(this, x, y); break;
      }
  
      this._l01_a = this._l12_a, this._l12_a = this._l23_a;
      this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
      this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
      this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
  };
  
  var catmullRomOpen = (function custom(alpha) {
  
    function catmullRom(context) {
      return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
    }
  
    catmullRom.alpha = function(alpha) {
      return custom(+alpha);
    };
  
    return catmullRom;
  })(0.5);
  
  function LinearClosed(context) {
    this._context = context;
  }
  
  LinearClosed.prototype = {
    areaStart: noop,
    areaEnd: noop,
    lineStart: function() {
      this._point = 0;
    },
    lineEnd: function() {
      if (this._point) this._context.closePath();
    },
    point: function(x, y) {
      x = +x, y = +y;
      if (this._point) this._context.lineTo(x, y);
      else this._point = 1, this._context.moveTo(x, y);
    }
  };
  
  function linearClosed(context) {
    return new LinearClosed(context);
  }
  
  function sign(x) {
    return x < 0 ? -1 : 1;
  }
  
  // Calculate the slopes of the tangents (Hermite-type interpolation) based on
  // the following paper: Steffen, M. 1990. A Simple Method for Monotonic
  // Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
  // NOV(II), P. 443, 1990.
  function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0,
        h1 = x2 - that._x1,
        s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
        s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
        p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
  }
  
  // Calculate a one-sided slope.
  function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
  }
  
  // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
  // "you can express cubic Hermite interpolation in terms of cubic Bézier curves
  // with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
  function point$3(that, t0, t1) {
    var x0 = that._x0,
        y0 = that._y0,
        x1 = that._x1,
        y1 = that._y1,
        dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
  }
  
  function MonotoneX(context) {
    this._context = context;
  }
  
  MonotoneX.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 =
      this._y0 = this._y1 =
      this._t0 = NaN;
      this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 2: this._context.lineTo(this._x1, this._y1); break;
        case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
      }
      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
      this._line = 1 - this._line;
    },
    point: function(x, y) {
      var t1 = NaN;
  
      x = +x, y = +y;
      if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
      switch (this._point) {
        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
        case 1: this._point = 2; break;
        case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
        default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
      }
  
      this._x0 = this._x1, this._x1 = x;
      this._y0 = this._y1, this._y1 = y;
      this._t0 = t1;
    }
  };
  
  function MonotoneY(context) {
    this._context = new ReflectContext(context);
  }
  
  (MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
  };
  
  function ReflectContext(context) {
    this._context = context;
  }
  
  ReflectContext.prototype = {
    moveTo: function(x, y) { this._context.moveTo(y, x); },
    closePath: function() { this._context.closePath(); },
    lineTo: function(x, y) { this._context.lineTo(y, x); },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
  };
  
  function monotoneX(context) {
    return new MonotoneX(context);
  }
  
  function monotoneY(context) {
    return new MonotoneY(context);
  }
  
  function Natural(context) {
    this._context = context;
  }
  
  Natural.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x = [];
      this._y = [];
    },
    lineEnd: function() {
      var x = this._x,
          y = this._y,
          n = x.length;
  
      if (n) {
        this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
        if (n === 2) {
          this._context.lineTo(x[1], y[1]);
        } else {
          var px = controlPoints(x),
              py = controlPoints(y);
          for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
            this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
          }
        }
      }
  
      if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
      this._line = 1 - this._line;
      this._x = this._y = null;
    },
    point: function(x, y) {
      this._x.push(+x);
      this._y.push(+y);
    }
  };
  
  // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
  function controlPoints(x) {
    var i,
        n = x.length - 1,
        m,
        a = new Array(n),
        b = new Array(n),
        r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
    return [a, b];
  }
  
  function natural(context) {
    return new Natural(context);
  }
  
  function Step(context, t) {
    this._context = context;
    this._t = t;
  }
  
  Step.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x = this._y = NaN;
      this._point = 0;
    },
    lineEnd: function() {
      if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
      if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
      if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
      x = +x, y = +y;
      switch (this._point) {
        case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
        case 1: this._point = 2; // proceed
        default: {
          if (this._t <= 0) {
            this._context.lineTo(this._x, y);
            this._context.lineTo(x, y);
          } else {
            var x1 = this._x * (1 - this._t) + x * this._t;
            this._context.lineTo(x1, this._y);
            this._context.lineTo(x1, y);
          }
          break;
        }
      }
      this._x = x, this._y = y;
    }
  };
  
  function step(context) {
    return new Step(context, 0.5);
  }
  
  function stepBefore(context) {
    return new Step(context, 0);
  }
  
  function stepAfter(context) {
    return new Step(context, 1);
  }
  
  function none(series, order) {
    if (!((n = series.length) > 1)) return;
    for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
      s0 = s1, s1 = series[order[i]];
      for (j = 0; j < m; ++j) {
        s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
      }
    }
  }
  
  function none$1(series) {
    var n = series.length, o = new Array(n);
    while (--n >= 0) o[n] = n;
    return o;
  }
  
  function stackValue(d, key) {
    return d[key];
  }
  
  function stack() {
    var keys = constant([]),
        order = none$1,
        offset = none,
        value = stackValue;
  
    function stack(data) {
      var kz = keys.apply(this, arguments),
          i,
          m = data.length,
          n = kz.length,
          sz = new Array(n),
          oz;
  
      for (i = 0; i < n; ++i) {
        for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
          si[j] = sij = [0, +value(data[j], ki, j, data)];
          sij.data = data[j];
        }
        si.key = ki;
      }
  
      for (i = 0, oz = order(sz); i < n; ++i) {
        sz[oz[i]].index = i;
      }
  
      offset(sz, oz);
      return sz;
    }
  
    stack.keys = function(_) {
      return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice.call(_)), stack) : keys;
    };
  
    stack.value = function(_) {
      return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
    };
  
    stack.order = function(_) {
      return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant(slice.call(_)), stack) : order;
    };
  
    stack.offset = function(_) {
      return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
    };
  
    return stack;
  }
  
  function expand(series, order) {
    if (!((n = series.length) > 0)) return;
    for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
      for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
      if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
    }
    none(series, order);
  }
  
  function diverging(series, order) {
    if (!((n = series.length) > 0)) return;
    for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
      for (yp = yn = 0, i = 0; i < n; ++i) {
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
          d[0] = yp, d[1] = yp += dy;
        } else if (dy < 0) {
          d[1] = yn, d[0] = yn += dy;
        } else {
          d[0] = 0, d[1] = dy;
        }
      }
    }
  }
  
  function silhouette(series, order) {
    if (!((n = series.length) > 0)) return;
    for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
      for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
      s0[j][1] += s0[j][0] = -y / 2;
    }
    none(series, order);
  }
  
  function wiggle(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
      for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
        var si = series[order[i]],
            sij0 = si[j][1] || 0,
            sij1 = si[j - 1][1] || 0,
            s3 = (sij0 - sij1) / 2;
        for (var k = 0; k < i; ++k) {
          var sk = series[order[k]],
              skj0 = sk[j][1] || 0,
              skj1 = sk[j - 1][1] || 0;
          s3 += skj0 - skj1;
        }
        s1 += sij0, s2 += s3 * sij0;
      }
      s0[j - 1][1] += s0[j - 1][0] = y;
      if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    none(series, order);
  }
  
  function appearance(series) {
    var peaks = series.map(peak);
    return none$1(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
  }
  
  function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
  }
  
  function ascending(series) {
    var sums = series.map(sum);
    return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
  }
  
  function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while (++i < n) if (v = +series[i][1]) s += v;
    return s;
  }
  
  function descending$1(series) {
    return ascending(series).reverse();
  }
  
  function insideOut(series) {
    var n = series.length,
        i,
        j,
        sums = series.map(sum),
        order = appearance(series),
        top = 0,
        bottom = 0,
        tops = [],
        bottoms = [];
  
    for (i = 0; i < n; ++i) {
      j = order[i];
      if (top < bottom) {
        top += sums[j];
        tops.push(j);
      } else {
        bottom += sums[j];
        bottoms.push(j);
      }
    }
  
    return bottoms.reverse().concat(tops);
  }
  
  function reverse(series) {
    return none$1(series).reverse();
  }
  
  exports.arc = arc;
  exports.area = area;
  exports.areaRadial = areaRadial;
  exports.curveBasis = basis;
  exports.curveBasisClosed = basisClosed;
  exports.curveBasisOpen = basisOpen;
  exports.curveBundle = bundle;
  exports.curveCardinal = cardinal;
  exports.curveCardinalClosed = cardinalClosed;
  exports.curveCardinalOpen = cardinalOpen;
  exports.curveCatmullRom = catmullRom;
  exports.curveCatmullRomClosed = catmullRomClosed;
  exports.curveCatmullRomOpen = catmullRomOpen;
  exports.curveLinear = curveLinear;
  exports.curveLinearClosed = linearClosed;
  exports.curveMonotoneX = monotoneX;
  exports.curveMonotoneY = monotoneY;
  exports.curveNatural = natural;
  exports.curveStep = step;
  exports.curveStepAfter = stepAfter;
  exports.curveStepBefore = stepBefore;
  exports.line = line;
  exports.lineRadial = lineRadial$1;
  exports.linkHorizontal = linkHorizontal;
  exports.linkRadial = linkRadial;
  exports.linkVertical = linkVertical;
  exports.pie = pie;
  exports.pointRadial = pointRadial;
  exports.radialArea = areaRadial;
  exports.radialLine = lineRadial$1;
  exports.stack = stack;
  exports.stackOffsetDiverging = diverging;
  exports.stackOffsetExpand = expand;
  exports.stackOffsetNone = none;
  exports.stackOffsetSilhouette = silhouette;
  exports.stackOffsetWiggle = wiggle;
  exports.stackOrderAppearance = appearance;
  exports.stackOrderAscending = ascending;
  exports.stackOrderDescending = descending$1;
  exports.stackOrderInsideOut = insideOut;
  exports.stackOrderNone = none$1;
  exports.stackOrderReverse = reverse;
  exports.symbol = symbol;
  exports.symbolCircle = circle;
  exports.symbolCross = cross;
  exports.symbolDiamond = diamond;
  exports.symbolSquare = square;
  exports.symbolStar = star;
  exports.symbolTriangle = triangle;
  exports.symbolWye = wye;
  exports.symbols = symbols;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{"d3-path":163}],166:[function(_dereq_,module,exports){
  // https://d3js.org/d3-time-format/ v2.2.3 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, _dereq_('d3-time')) :
  typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
  }(this, function (exports, d3Time) { 'use strict';
  
  function localDate(d) {
    if (0 <= d.y && d.y < 100) {
      var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
      date.setFullYear(d.y);
      return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
  }
  
  function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
      var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
      date.setUTCFullYear(d.y);
      return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
  }
  
  function newDate(y, m, d) {
    return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
  }
  
  function formatLocale(locale) {
    var locale_dateTime = locale.dateTime,
        locale_date = locale.date,
        locale_time = locale.time,
        locale_periods = locale.periods,
        locale_weekdays = locale.days,
        locale_shortWeekdays = locale.shortDays,
        locale_months = locale.months,
        locale_shortMonths = locale.shortMonths;
  
    var periodRe = formatRe(locale_periods),
        periodLookup = formatLookup(locale_periods),
        weekdayRe = formatRe(locale_weekdays),
        weekdayLookup = formatLookup(locale_weekdays),
        shortWeekdayRe = formatRe(locale_shortWeekdays),
        shortWeekdayLookup = formatLookup(locale_shortWeekdays),
        monthRe = formatRe(locale_months),
        monthLookup = formatLookup(locale_months),
        shortMonthRe = formatRe(locale_shortMonths),
        shortMonthLookup = formatLookup(locale_shortMonths);
  
    var formats = {
      "a": formatShortWeekday,
      "A": formatWeekday,
      "b": formatShortMonth,
      "B": formatMonth,
      "c": null,
      "d": formatDayOfMonth,
      "e": formatDayOfMonth,
      "f": formatMicroseconds,
      "H": formatHour24,
      "I": formatHour12,
      "j": formatDayOfYear,
      "L": formatMilliseconds,
      "m": formatMonthNumber,
      "M": formatMinutes,
      "p": formatPeriod,
      "q": formatQuarter,
      "Q": formatUnixTimestamp,
      "s": formatUnixTimestampSeconds,
      "S": formatSeconds,
      "u": formatWeekdayNumberMonday,
      "U": formatWeekNumberSunday,
      "V": formatWeekNumberISO,
      "w": formatWeekdayNumberSunday,
      "W": formatWeekNumberMonday,
      "x": null,
      "X": null,
      "y": formatYear,
      "Y": formatFullYear,
      "Z": formatZone,
      "%": formatLiteralPercent
    };
  
    var utcFormats = {
      "a": formatUTCShortWeekday,
      "A": formatUTCWeekday,
      "b": formatUTCShortMonth,
      "B": formatUTCMonth,
      "c": null,
      "d": formatUTCDayOfMonth,
      "e": formatUTCDayOfMonth,
      "f": formatUTCMicroseconds,
      "H": formatUTCHour24,
      "I": formatUTCHour12,
      "j": formatUTCDayOfYear,
      "L": formatUTCMilliseconds,
      "m": formatUTCMonthNumber,
      "M": formatUTCMinutes,
      "p": formatUTCPeriod,
      "q": formatUTCQuarter,
      "Q": formatUnixTimestamp,
      "s": formatUnixTimestampSeconds,
      "S": formatUTCSeconds,
      "u": formatUTCWeekdayNumberMonday,
      "U": formatUTCWeekNumberSunday,
      "V": formatUTCWeekNumberISO,
      "w": formatUTCWeekdayNumberSunday,
      "W": formatUTCWeekNumberMonday,
      "x": null,
      "X": null,
      "y": formatUTCYear,
      "Y": formatUTCFullYear,
      "Z": formatUTCZone,
      "%": formatLiteralPercent
    };
  
    var parses = {
      "a": parseShortWeekday,
      "A": parseWeekday,
      "b": parseShortMonth,
      "B": parseMonth,
      "c": parseLocaleDateTime,
      "d": parseDayOfMonth,
      "e": parseDayOfMonth,
      "f": parseMicroseconds,
      "H": parseHour24,
      "I": parseHour24,
      "j": parseDayOfYear,
      "L": parseMilliseconds,
      "m": parseMonthNumber,
      "M": parseMinutes,
      "p": parsePeriod,
      "q": parseQuarter,
      "Q": parseUnixTimestamp,
      "s": parseUnixTimestampSeconds,
      "S": parseSeconds,
      "u": parseWeekdayNumberMonday,
      "U": parseWeekNumberSunday,
      "V": parseWeekNumberISO,
      "w": parseWeekdayNumberSunday,
      "W": parseWeekNumberMonday,
      "x": parseLocaleDate,
      "X": parseLocaleTime,
      "y": parseYear,
      "Y": parseFullYear,
      "Z": parseZone,
      "%": parseLiteralPercent
    };
  
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
  
    function newFormat(specifier, formats) {
      return function(date) {
        var string = [],
            i = -1,
            j = 0,
            n = specifier.length,
            c,
            pad,
            format;
  
        if (!(date instanceof Date)) date = new Date(+date);
  
        while (++i < n) {
          if (specifier.charCodeAt(i) === 37) {
            string.push(specifier.slice(j, i));
            if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
            else pad = c === "e" ? " " : "0";
            if (format = formats[c]) c = format(date, pad);
            string.push(c);
            j = i + 1;
          }
        }
  
        string.push(specifier.slice(j, i));
        return string.join("");
      };
    }
  
    function newParse(specifier, Z) {
      return function(string) {
        var d = newDate(1900, undefined, 1),
            i = parseSpecifier(d, specifier, string += "", 0),
            week, day;
        if (i != string.length) return null;
  
        // If a UNIX timestamp is specified, return it.
        if ("Q" in d) return new Date(d.Q);
        if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
  
        // If this is utcParse, never use the local timezone.
        if (Z && !("Z" in d)) d.Z = 0;
  
        // The am-pm flag is 0 for AM, and 1 for PM.
        if ("p" in d) d.H = d.H % 12 + d.p * 12;
  
        // If the month was not specified, inherit from the quarter.
        if (d.m === undefined) d.m = "q" in d ? d.q : 0;
  
        // Convert day-of-week and week-of-year to day-of-year.
        if ("V" in d) {
          if (d.V < 1 || d.V > 53) return null;
          if (!("w" in d)) d.w = 1;
          if ("Z" in d) {
            week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
            week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
            week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
            d.y = week.getUTCFullYear();
            d.m = week.getUTCMonth();
            d.d = week.getUTCDate() + (d.w + 6) % 7;
          } else {
            week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
            week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
            week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
            d.y = week.getFullYear();
            d.m = week.getMonth();
            d.d = week.getDate() + (d.w + 6) % 7;
          }
        } else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
          day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
          d.m = 0;
          d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
        }
  
        // If a time zone is specified, all fields are interpreted as UTC and then
        // offset according to the specified time zone.
        if ("Z" in d) {
          d.H += d.Z / 100 | 0;
          d.M += d.Z % 100;
          return utcDate(d);
        }
  
        // Otherwise, all fields are in local time.
        return localDate(d);
      };
    }
  
    function parseSpecifier(d, specifier, string, j) {
      var i = 0,
          n = specifier.length,
          m = string.length,
          c,
          parse;
  
      while (i < n) {
        if (j >= m) return -1;
        c = specifier.charCodeAt(i++);
        if (c === 37) {
          c = specifier.charAt(i++);
          parse = parses[c in pads ? specifier.charAt(i++) : c];
          if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }
  
      return j;
    }
  
    function parsePeriod(d, string, i) {
      var n = periodRe.exec(string.slice(i));
      return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
  
    function parseShortWeekday(d, string, i) {
      var n = shortWeekdayRe.exec(string.slice(i));
      return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
  
    function parseWeekday(d, string, i) {
      var n = weekdayRe.exec(string.slice(i));
      return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
  
    function parseShortMonth(d, string, i) {
      var n = shortMonthRe.exec(string.slice(i));
      return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
  
    function parseMonth(d, string, i) {
      var n = monthRe.exec(string.slice(i));
      return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
    }
  
    function parseLocaleDateTime(d, string, i) {
      return parseSpecifier(d, locale_dateTime, string, i);
    }
  
    function parseLocaleDate(d, string, i) {
      return parseSpecifier(d, locale_date, string, i);
    }
  
    function parseLocaleTime(d, string, i) {
      return parseSpecifier(d, locale_time, string, i);
    }
  
    function formatShortWeekday(d) {
      return locale_shortWeekdays[d.getDay()];
    }
  
    function formatWeekday(d) {
      return locale_weekdays[d.getDay()];
    }
  
    function formatShortMonth(d) {
      return locale_shortMonths[d.getMonth()];
    }
  
    function formatMonth(d) {
      return locale_months[d.getMonth()];
    }
  
    function formatPeriod(d) {
      return locale_periods[+(d.getHours() >= 12)];
    }
  
    function formatQuarter(d) {
      return 1 + ~~(d.getMonth() / 3);
    }
  
    function formatUTCShortWeekday(d) {
      return locale_shortWeekdays[d.getUTCDay()];
    }
  
    function formatUTCWeekday(d) {
      return locale_weekdays[d.getUTCDay()];
    }
  
    function formatUTCShortMonth(d) {
      return locale_shortMonths[d.getUTCMonth()];
    }
  
    function formatUTCMonth(d) {
      return locale_months[d.getUTCMonth()];
    }
  
    function formatUTCPeriod(d) {
      return locale_periods[+(d.getUTCHours() >= 12)];
    }
  
    function formatUTCQuarter(d) {
      return 1 + ~~(d.getUTCMonth() / 3);
    }
  
    return {
      format: function(specifier) {
        var f = newFormat(specifier += "", formats);
        f.toString = function() { return specifier; };
        return f;
      },
      parse: function(specifier) {
        var p = newParse(specifier += "", false);
        p.toString = function() { return specifier; };
        return p;
      },
      utcFormat: function(specifier) {
        var f = newFormat(specifier += "", utcFormats);
        f.toString = function() { return specifier; };
        return f;
      },
      utcParse: function(specifier) {
        var p = newParse(specifier += "", true);
        p.toString = function() { return specifier; };
        return p;
      }
    };
  }
  
  var pads = {"-": "", "_": " ", "0": "0"},
      numberRe = /^\s*\d+/, // note: ignores next directive
      percentRe = /^%/,
      requoteRe = /[\\^$*+?|[\]().{}]/g;
  
  function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "",
        string = (sign ? -value : value) + "",
        length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }
  
  function requote(s) {
    return s.replace(requoteRe, "\\$&");
  }
  
  function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
  }
  
  function formatLookup(names) {
    var map = {}, i = -1, n = names.length;
    while (++i < n) map[names[i].toLowerCase()] = i;
    return map;
  }
  
  function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
  }
  
  function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
  }
  
  function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
  }
  
  function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
  }
  
  function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
  }
  
  function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
  }
  
  function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
  }
  
  function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
  }
  
  function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
  }
  
  function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
  }
  
  function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
  }
  
  function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
  }
  
  function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
  }
  
  function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
  }
  
  function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
  }
  
  function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
  }
  
  function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
  }
  
  function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  
  function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
  }
  
  function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
  }
  
  function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
  }
  
  function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
  }
  
  function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
  }
  
  function formatDayOfYear(d, p) {
    return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
  }
  
  function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
  }
  
  function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
  }
  
  function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
  }
  
  function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
  }
  
  function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
  }
  
  function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
  }
  
  function formatWeekNumberSunday(d, p) {
    return pad(d3Time.timeSunday.count(d3Time.timeYear(d) - 1, d), p, 2);
  }
  
  function formatWeekNumberISO(d, p) {
    var day = d.getDay();
    d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
    return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
  }
  
  function formatWeekdayNumberSunday(d) {
    return d.getDay();
  }
  
  function formatWeekNumberMonday(d, p) {
    return pad(d3Time.timeMonday.count(d3Time.timeYear(d) - 1, d), p, 2);
  }
  
  function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
  }
  
  function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
  }
  
  function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+"))
        + pad(z / 60 | 0, "0", 2)
        + pad(z % 60, "0", 2);
  }
  
  function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
  }
  
  function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
  }
  
  function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
  }
  
  function formatUTCDayOfYear(d, p) {
    return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
  }
  
  function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
  }
  
  function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
  }
  
  function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
  }
  
  function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
  }
  
  function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
  }
  
  function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
  }
  
  function formatUTCWeekNumberSunday(d, p) {
    return pad(d3Time.utcSunday.count(d3Time.utcYear(d) - 1, d), p, 2);
  }
  
  function formatUTCWeekNumberISO(d, p) {
    var day = d.getUTCDay();
    d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
    return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
  }
  
  function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
  }
  
  function formatUTCWeekNumberMonday(d, p) {
    return pad(d3Time.utcMonday.count(d3Time.utcYear(d) - 1, d), p, 2);
  }
  
  function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
  }
  
  function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
  }
  
  function formatUTCZone() {
    return "+0000";
  }
  
  function formatLiteralPercent() {
    return "%";
  }
  
  function formatUnixTimestamp(d) {
    return +d;
  }
  
  function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
  }
  
  var locale;
  
  defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: ["AM", "PM"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  });
  
  function defaultLocale(definition) {
    locale = formatLocale(definition);
    exports.timeFormat = locale.format;
    exports.timeParse = locale.parse;
    exports.utcFormat = locale.utcFormat;
    exports.utcParse = locale.utcParse;
    return locale;
  }
  
  var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
  
  function formatIsoNative(date) {
    return date.toISOString();
  }
  
  var formatIso = Date.prototype.toISOString
      ? formatIsoNative
      : exports.utcFormat(isoSpecifier);
  
  function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  }
  
  var parseIso = +new Date("2000-01-01T00:00:00.000Z")
      ? parseIsoNative
      : exports.utcParse(isoSpecifier);
  
  exports.isoFormat = formatIso;
  exports.isoParse = parseIso;
  exports.timeFormatDefaultLocale = defaultLocale;
  exports.timeFormatLocale = formatLocale;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{"d3-time":167}],167:[function(_dereq_,module,exports){
  // https://d3js.org/d3-time/ v1.1.0 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}));
  }(this, function (exports) { 'use strict';
  
  var t0 = new Date,
      t1 = new Date;
  
  function newInterval(floori, offseti, count, field) {
  
    function interval(date) {
      return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
  
    interval.floor = function(date) {
      return floori(date = new Date(+date)), date;
    };
  
    interval.ceil = function(date) {
      return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
  
    interval.round = function(date) {
      var d0 = interval(date),
          d1 = interval.ceil(date);
      return date - d0 < d1 - date ? d0 : d1;
    };
  
    interval.offset = function(date, step) {
      return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
  
    interval.range = function(start, stop, step) {
      var range = [], previous;
      start = interval.ceil(start);
      step = step == null ? 1 : Math.floor(step);
      if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
      do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
      while (previous < start && start < stop);
      return range;
    };
  
    interval.filter = function(test) {
      return newInterval(function(date) {
        if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
      }, function(date, step) {
        if (date >= date) {
          if (step < 0) while (++step <= 0) {
            while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
          } else while (--step >= 0) {
            while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
          }
        }
      });
    };
  
    if (count) {
      interval.count = function(start, end) {
        t0.setTime(+start), t1.setTime(+end);
        floori(t0), floori(t1);
        return Math.floor(count(t0, t1));
      };
  
      interval.every = function(step) {
        step = Math.floor(step);
        return !isFinite(step) || !(step > 0) ? null
            : !(step > 1) ? interval
            : interval.filter(field
                ? function(d) { return field(d) % step === 0; }
                : function(d) { return interval.count(0, d) % step === 0; });
      };
    }
  
    return interval;
  }
  
  var millisecond = newInterval(function() {
    // noop
  }, function(date, step) {
    date.setTime(+date + step);
  }, function(start, end) {
    return end - start;
  });
  
  // An optimized implementation for this simple case.
  millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return newInterval(function(date) {
      date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
      date.setTime(+date + step * k);
    }, function(start, end) {
      return (end - start) / k;
    });
  };
  var milliseconds = millisecond.range;
  
  var durationSecond = 1e3;
  var durationMinute = 6e4;
  var durationHour = 36e5;
  var durationDay = 864e5;
  var durationWeek = 6048e5;
  
  var second = newInterval(function(date) {
    date.setTime(date - date.getMilliseconds());
  }, function(date, step) {
    date.setTime(+date + step * durationSecond);
  }, function(start, end) {
    return (end - start) / durationSecond;
  }, function(date) {
    return date.getUTCSeconds();
  });
  var seconds = second.range;
  
  var minute = newInterval(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
  }, function(date, step) {
    date.setTime(+date + step * durationMinute);
  }, function(start, end) {
    return (end - start) / durationMinute;
  }, function(date) {
    return date.getMinutes();
  });
  var minutes = minute.range;
  
  var hour = newInterval(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
  }, function(date, step) {
    date.setTime(+date + step * durationHour);
  }, function(start, end) {
    return (end - start) / durationHour;
  }, function(date) {
    return date.getHours();
  });
  var hours = hour.range;
  
  var day = newInterval(function(date) {
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
  }, function(date) {
    return date.getDate() - 1;
  });
  var days = day.range;
  
  function weekday(i) {
    return newInterval(function(date) {
      date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
      date.setHours(0, 0, 0, 0);
    }, function(date, step) {
      date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
      return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
    });
  }
  
  var sunday = weekday(0);
  var monday = weekday(1);
  var tuesday = weekday(2);
  var wednesday = weekday(3);
  var thursday = weekday(4);
  var friday = weekday(5);
  var saturday = weekday(6);
  
  var sundays = sunday.range;
  var mondays = monday.range;
  var tuesdays = tuesday.range;
  var wednesdays = wednesday.range;
  var thursdays = thursday.range;
  var fridays = friday.range;
  var saturdays = saturday.range;
  
  var month = newInterval(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setMonth(date.getMonth() + step);
  }, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
  }, function(date) {
    return date.getMonth();
  });
  var months = month.range;
  
  var year = newInterval(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
  }, function(start, end) {
    return end.getFullYear() - start.getFullYear();
  }, function(date) {
    return date.getFullYear();
  });
  
  // An optimized implementation for this simple case.
  year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
      date.setFullYear(Math.floor(date.getFullYear() / k) * k);
      date.setMonth(0, 1);
      date.setHours(0, 0, 0, 0);
    }, function(date, step) {
      date.setFullYear(date.getFullYear() + step * k);
    });
  };
  var years = year.range;
  
  var utcMinute = newInterval(function(date) {
    date.setUTCSeconds(0, 0);
  }, function(date, step) {
    date.setTime(+date + step * durationMinute);
  }, function(start, end) {
    return (end - start) / durationMinute;
  }, function(date) {
    return date.getUTCMinutes();
  });
  var utcMinutes = utcMinute.range;
  
  var utcHour = newInterval(function(date) {
    date.setUTCMinutes(0, 0, 0);
  }, function(date, step) {
    date.setTime(+date + step * durationHour);
  }, function(start, end) {
    return (end - start) / durationHour;
  }, function(date) {
    return date.getUTCHours();
  });
  var utcHours = utcHour.range;
  
  var utcDay = newInterval(function(date) {
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
  }, function(start, end) {
    return (end - start) / durationDay;
  }, function(date) {
    return date.getUTCDate() - 1;
  });
  var utcDays = utcDay.range;
  
  function utcWeekday(i) {
    return newInterval(function(date) {
      date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
      date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
      date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
      return (end - start) / durationWeek;
    });
  }
  
  var utcSunday = utcWeekday(0);
  var utcMonday = utcWeekday(1);
  var utcTuesday = utcWeekday(2);
  var utcWednesday = utcWeekday(3);
  var utcThursday = utcWeekday(4);
  var utcFriday = utcWeekday(5);
  var utcSaturday = utcWeekday(6);
  
  var utcSundays = utcSunday.range;
  var utcMondays = utcMonday.range;
  var utcTuesdays = utcTuesday.range;
  var utcWednesdays = utcWednesday.range;
  var utcThursdays = utcThursday.range;
  var utcFridays = utcFriday.range;
  var utcSaturdays = utcSaturday.range;
  
  var utcMonth = newInterval(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
  }, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
  }, function(date) {
    return date.getUTCMonth();
  });
  var utcMonths = utcMonth.range;
  
  var utcYear = newInterval(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
  }, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
  }, function(date) {
    return date.getUTCFullYear();
  });
  
  // An optimized implementation for this simple case.
  utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
      date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
      date.setUTCMonth(0, 1);
      date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
      date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
  };
  var utcYears = utcYear.range;
  
  exports.timeDay = day;
  exports.timeDays = days;
  exports.timeFriday = friday;
  exports.timeFridays = fridays;
  exports.timeHour = hour;
  exports.timeHours = hours;
  exports.timeInterval = newInterval;
  exports.timeMillisecond = millisecond;
  exports.timeMilliseconds = milliseconds;
  exports.timeMinute = minute;
  exports.timeMinutes = minutes;
  exports.timeMonday = monday;
  exports.timeMondays = mondays;
  exports.timeMonth = month;
  exports.timeMonths = months;
  exports.timeSaturday = saturday;
  exports.timeSaturdays = saturdays;
  exports.timeSecond = second;
  exports.timeSeconds = seconds;
  exports.timeSunday = sunday;
  exports.timeSundays = sundays;
  exports.timeThursday = thursday;
  exports.timeThursdays = thursdays;
  exports.timeTuesday = tuesday;
  exports.timeTuesdays = tuesdays;
  exports.timeWednesday = wednesday;
  exports.timeWednesdays = wednesdays;
  exports.timeWeek = sunday;
  exports.timeWeeks = sundays;
  exports.timeYear = year;
  exports.timeYears = years;
  exports.utcDay = utcDay;
  exports.utcDays = utcDays;
  exports.utcFriday = utcFriday;
  exports.utcFridays = utcFridays;
  exports.utcHour = utcHour;
  exports.utcHours = utcHours;
  exports.utcMillisecond = millisecond;
  exports.utcMilliseconds = milliseconds;
  exports.utcMinute = utcMinute;
  exports.utcMinutes = utcMinutes;
  exports.utcMonday = utcMonday;
  exports.utcMondays = utcMondays;
  exports.utcMonth = utcMonth;
  exports.utcMonths = utcMonths;
  exports.utcSaturday = utcSaturday;
  exports.utcSaturdays = utcSaturdays;
  exports.utcSecond = second;
  exports.utcSeconds = seconds;
  exports.utcSunday = utcSunday;
  exports.utcSundays = utcSundays;
  exports.utcThursday = utcThursday;
  exports.utcThursdays = utcThursdays;
  exports.utcTuesday = utcTuesday;
  exports.utcTuesdays = utcTuesdays;
  exports.utcWednesday = utcWednesday;
  exports.utcWednesdays = utcWednesdays;
  exports.utcWeek = utcSunday;
  exports.utcWeeks = utcSundays;
  exports.utcYear = utcYear;
  exports.utcYears = utcYears;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{}],168:[function(_dereq_,module,exports){
  // https://d3js.org/d3-timer/ v1.0.10 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.d3 = global.d3 || {}));
  }(this, function (exports) { 'use strict';
  
  var frame = 0, // is an animation frame pending?
      timeout = 0, // is a timeout pending?
      interval = 0, // are any timers active?
      pokeDelay = 1000, // how frequently we check for clock skew
      taskHead,
      taskTail,
      clockLast = 0,
      clockNow = 0,
      clockSkew = 0,
      clock = typeof performance === "object" && performance.now ? performance : Date,
      setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
  
  function now() {
    return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
  }
  
  function clearNow() {
    clockNow = 0;
  }
  
  function Timer() {
    this._call =
    this._time =
    this._next = null;
  }
  
  Timer.prototype = timer.prototype = {
    constructor: Timer,
    restart: function(callback, delay, time) {
      if (typeof callback !== "function") throw new TypeError("callback is not a function");
      time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
      if (!this._next && taskTail !== this) {
        if (taskTail) taskTail._next = this;
        else taskHead = this;
        taskTail = this;
      }
      this._call = callback;
      this._time = time;
      sleep();
    },
    stop: function() {
      if (this._call) {
        this._call = null;
        this._time = Infinity;
        sleep();
      }
    }
  };
  
  function timer(callback, delay, time) {
    var t = new Timer;
    t.restart(callback, delay, time);
    return t;
  }
  
  function timerFlush() {
    now(); // Get the current time, if not already set.
    ++frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = taskHead, e;
    while (t) {
      if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
      t = t._next;
    }
    --frame;
  }
  
  function wake() {
    clockNow = (clockLast = clock.now()) + clockSkew;
    frame = timeout = 0;
    try {
      timerFlush();
    } finally {
      frame = 0;
      nap();
      clockNow = 0;
    }
  }
  
  function poke() {
    var now = clock.now(), delay = now - clockLast;
    if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
  }
  
  function nap() {
    var t0, t1 = taskHead, t2, time = Infinity;
    while (t1) {
      if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
      } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : taskHead = t2;
      }
    }
    taskTail = t0;
    sleep(time);
  }
  
  function sleep(time) {
    if (frame) return; // Soonest alarm already set, or will be.
    if (timeout) timeout = clearTimeout(timeout);
    var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
      if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
      if (interval) interval = clearInterval(interval);
    } else {
      if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
      frame = 1, setFrame(wake);
    }
  }
  
  function timeout$1(callback, delay, time) {
    var t = new Timer;
    delay = delay == null ? 0 : +delay;
    t.restart(function(elapsed) {
      t.stop();
      callback(elapsed + delay);
    }, delay, time);
    return t;
  }
  
  function interval$1(callback, delay, time) {
    var t = new Timer, total = delay;
    if (delay == null) return t.restart(callback, delay, time), t;
    delay = +delay, time = time == null ? now() : +time;
    t.restart(function tick(elapsed) {
      elapsed += total;
      t.restart(tick, total += delay, time);
      callback(elapsed);
    }, delay, time);
    return t;
  }
  
  exports.interval = interval$1;
  exports.now = now;
  exports.timeout = timeout$1;
  exports.timer = timer;
  exports.timerFlush = timerFlush;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{}],169:[function(_dereq_,module,exports){
  !function() {
    var d3 = {
      version: "3.5.17"
    };
    var d3_arraySlice = [].slice, d3_array = function(list) {
      return d3_arraySlice.call(list);
    };
    var d3_document = this.document;
    function d3_documentElement(node) {
      return node && (node.ownerDocument || node.document || node).documentElement;
    }
    function d3_window(node) {
      return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
    }
    if (d3_document) {
      try {
        d3_array(d3_document.documentElement.childNodes)[0].nodeType;
      } catch (e) {
        d3_array = function(list) {
          var i = list.length, array = new Array(i);
          while (i--) array[i] = list[i];
          return array;
        };
      }
    }
    if (!Date.now) Date.now = function() {
      return +new Date();
    };
    if (d3_document) {
      try {
        d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
      } catch (error) {
        var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
        d3_element_prototype.setAttribute = function(name, value) {
          d3_element_setAttribute.call(this, name, value + "");
        };
        d3_element_prototype.setAttributeNS = function(space, local, value) {
          d3_element_setAttributeNS.call(this, space, local, value + "");
        };
        d3_style_prototype.setProperty = function(name, value, priority) {
          d3_style_setProperty.call(this, name, value + "", priority);
        };
      }
    }
    d3.ascending = d3_ascending;
    function d3_ascending(a, b) {
      return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
    }
    d3.descending = function(a, b) {
      return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
    };
    d3.min = function(array, f) {
      var i = -1, n = array.length, a, b;
      if (arguments.length === 1) {
        while (++i < n) if ((b = array[i]) != null && b >= b) {
          a = b;
          break;
        }
        while (++i < n) if ((b = array[i]) != null && a > b) a = b;
      } else {
        while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
          a = b;
          break;
        }
        while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
      }
      return a;
    };
    d3.max = function(array, f) {
      var i = -1, n = array.length, a, b;
      if (arguments.length === 1) {
        while (++i < n) if ((b = array[i]) != null && b >= b) {
          a = b;
          break;
        }
        while (++i < n) if ((b = array[i]) != null && b > a) a = b;
      } else {
        while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
          a = b;
          break;
        }
        while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
      }
      return a;
    };
    d3.extent = function(array, f) {
      var i = -1, n = array.length, a, b, c;
      if (arguments.length === 1) {
        while (++i < n) if ((b = array[i]) != null && b >= b) {
          a = c = b;
          break;
        }
        while (++i < n) if ((b = array[i]) != null) {
          if (a > b) a = b;
          if (c < b) c = b;
        }
      } else {
        while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
          a = c = b;
          break;
        }
        while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
          if (a > b) a = b;
          if (c < b) c = b;
        }
      }
      return [ a, c ];
    };
    function d3_number(x) {
      return x === null ? NaN : +x;
    }
    function d3_numeric(x) {
      return !isNaN(x);
    }
    d3.sum = function(array, f) {
      var s = 0, n = array.length, a, i = -1;
      if (arguments.length === 1) {
        while (++i < n) if (d3_numeric(a = +array[i])) s += a;
      } else {
        while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
      }
      return s;
    };
    d3.mean = function(array, f) {
      var s = 0, n = array.length, a, i = -1, j = n;
      if (arguments.length === 1) {
        while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
      } else {
        while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
      }
      if (j) return s / j;
    };
    d3.quantile = function(values, p) {
      var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
      return e ? v + e * (values[h] - v) : v;
    };
    d3.median = function(array, f) {
      var numbers = [], n = array.length, a, i = -1;
      if (arguments.length === 1) {
        while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
      } else {
        while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
      }
      if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
    };
    d3.variance = function(array, f) {
      var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
      if (arguments.length === 1) {
        while (++i < n) {
          if (d3_numeric(a = d3_number(array[i]))) {
            d = a - m;
            m += d / ++j;
            s += d * (a - m);
          }
        }
      } else {
        while (++i < n) {
          if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
            d = a - m;
            m += d / ++j;
            s += d * (a - m);
          }
        }
      }
      if (j > 1) return s / (j - 1);
    };
    d3.deviation = function() {
      var v = d3.variance.apply(this, arguments);
      return v ? Math.sqrt(v) : v;
    };
    function d3_bisector(compare) {
      return {
        left: function(a, x, lo, hi) {
          if (arguments.length < 3) lo = 0;
          if (arguments.length < 4) hi = a.length;
          while (lo < hi) {
            var mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
          }
          return lo;
        },
        right: function(a, x, lo, hi) {
          if (arguments.length < 3) lo = 0;
          if (arguments.length < 4) hi = a.length;
          while (lo < hi) {
            var mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
          }
          return lo;
        }
      };
    }
    var d3_bisect = d3_bisector(d3_ascending);
    d3.bisectLeft = d3_bisect.left;
    d3.bisect = d3.bisectRight = d3_bisect.right;
    d3.bisector = function(f) {
      return d3_bisector(f.length === 1 ? function(d, x) {
        return d3_ascending(f(d), x);
      } : f);
    };
    d3.shuffle = function(array, i0, i1) {
      if ((m = arguments.length) < 3) {
        i1 = array.length;
        if (m < 2) i0 = 0;
      }
      var m = i1 - i0, t, i;
      while (m) {
        i = Math.random() * m-- | 0;
        t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
      }
      return array;
    };
    d3.permute = function(array, indexes) {
      var i = indexes.length, permutes = new Array(i);
      while (i--) permutes[i] = array[indexes[i]];
      return permutes;
    };
    d3.pairs = function(array) {
      var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
      while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
      return pairs;
    };
    d3.transpose = function(matrix) {
      if (!(n = matrix.length)) return [];
      for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
        for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
          row[j] = matrix[j][i];
        }
      }
      return transpose;
    };
    function d3_transposeLength(d) {
      return d.length;
    }
    d3.zip = function() {
      return d3.transpose(arguments);
    };
    d3.keys = function(map) {
      var keys = [];
      for (var key in map) keys.push(key);
      return keys;
    };
    d3.values = function(map) {
      var values = [];
      for (var key in map) values.push(map[key]);
      return values;
    };
    d3.entries = function(map) {
      var entries = [];
      for (var key in map) entries.push({
        key: key,
        value: map[key]
      });
      return entries;
    };
    d3.merge = function(arrays) {
      var n = arrays.length, m, i = -1, j = 0, merged, array;
      while (++i < n) j += arrays[i].length;
      merged = new Array(j);
      while (--n >= 0) {
        array = arrays[n];
        m = array.length;
        while (--m >= 0) {
          merged[--j] = array[m];
        }
      }
      return merged;
    };
    var abs = Math.abs;
    d3.range = function(start, stop, step) {
      if (arguments.length < 3) {
        step = 1;
        if (arguments.length < 2) {
          stop = start;
          start = 0;
        }
      }
      if ((stop - start) / step === Infinity) throw new Error("infinite range");
      var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
      start *= k, stop *= k, step *= k;
      if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
      return range;
    };
    function d3_range_integerScale(x) {
      var k = 1;
      while (x * k % 1) k *= 10;
      return k;
    }
    function d3_class(ctor, properties) {
      for (var key in properties) {
        Object.defineProperty(ctor.prototype, key, {
          value: properties[key],
          enumerable: false
        });
      }
    }
    d3.map = function(object, f) {
      var map = new d3_Map();
      if (object instanceof d3_Map) {
        object.forEach(function(key, value) {
          map.set(key, value);
        });
      } else if (Array.isArray(object)) {
        var i = -1, n = object.length, o;
        if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
      } else {
        for (var key in object) map.set(key, object[key]);
      }
      return map;
    };
    function d3_Map() {
      this._ = Object.create(null);
    }
    var d3_map_proto = "__proto__", d3_map_zero = "\x00";
    d3_class(d3_Map, {
      has: d3_map_has,
      get: function(key) {
        return this._[d3_map_escape(key)];
      },
      set: function(key, value) {
        return this._[d3_map_escape(key)] = value;
      },
      remove: d3_map_remove,
      keys: d3_map_keys,
      values: function() {
        var values = [];
        for (var key in this._) values.push(this._[key]);
        return values;
      },
      entries: function() {
        var entries = [];
        for (var key in this._) entries.push({
          key: d3_map_unescape(key),
          value: this._[key]
        });
        return entries;
      },
      size: d3_map_size,
      empty: d3_map_empty,
      forEach: function(f) {
        for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
      }
    });
    function d3_map_escape(key) {
      return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
    }
    function d3_map_unescape(key) {
      return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
    }
    function d3_map_has(key) {
      return d3_map_escape(key) in this._;
    }
    function d3_map_remove(key) {
      return (key = d3_map_escape(key)) in this._ && delete this._[key];
    }
    function d3_map_keys() {
      var keys = [];
      for (var key in this._) keys.push(d3_map_unescape(key));
      return keys;
    }
    function d3_map_size() {
      var size = 0;
      for (var key in this._) ++size;
      return size;
    }
    function d3_map_empty() {
      for (var key in this._) return false;
      return true;
    }
    d3.nest = function() {
      var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
      function map(mapType, array, depth) {
        if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
        var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
        while (++i < n) {
          if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
            values.push(object);
          } else {
            valuesByKey.set(keyValue, [ object ]);
          }
        }
        if (mapType) {
          object = mapType();
          setter = function(keyValue, values) {
            object.set(keyValue, map(mapType, values, depth));
          };
        } else {
          object = {};
          setter = function(keyValue, values) {
            object[keyValue] = map(mapType, values, depth);
          };
        }
        valuesByKey.forEach(setter);
        return object;
      }
      function entries(map, depth) {
        if (depth >= keys.length) return map;
        var array = [], sortKey = sortKeys[depth++];
        map.forEach(function(key, keyMap) {
          array.push({
            key: key,
            values: entries(keyMap, depth)
          });
        });
        return sortKey ? array.sort(function(a, b) {
          return sortKey(a.key, b.key);
        }) : array;
      }
      nest.map = function(array, mapType) {
        return map(mapType, array, 0);
      };
      nest.entries = function(array) {
        return entries(map(d3.map, array, 0), 0);
      };
      nest.key = function(d) {
        keys.push(d);
        return nest;
      };
      nest.sortKeys = function(order) {
        sortKeys[keys.length - 1] = order;
        return nest;
      };
      nest.sortValues = function(order) {
        sortValues = order;
        return nest;
      };
      nest.rollup = function(f) {
        rollup = f;
        return nest;
      };
      return nest;
    };
    d3.set = function(array) {
      var set = new d3_Set();
      if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
      return set;
    };
    function d3_Set() {
      this._ = Object.create(null);
    }
    d3_class(d3_Set, {
      has: d3_map_has,
      add: function(key) {
        this._[d3_map_escape(key += "")] = true;
        return key;
      },
      remove: d3_map_remove,
      values: d3_map_keys,
      size: d3_map_size,
      empty: d3_map_empty,
      forEach: function(f) {
        for (var key in this._) f.call(this, d3_map_unescape(key));
      }
    });
    d3.behavior = {};
    function d3_identity(d) {
      return d;
    }
    d3.rebind = function(target, source) {
      var i = 1, n = arguments.length, method;
      while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
      return target;
    };
    function d3_rebind(target, source, method) {
      return function() {
        var value = method.apply(source, arguments);
        return value === source ? target : value;
      };
    }
    function d3_vendorSymbol(object, name) {
      if (name in object) return name;
      name = name.charAt(0).toUpperCase() + name.slice(1);
      for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
        var prefixName = d3_vendorPrefixes[i] + name;
        if (prefixName in object) return prefixName;
      }
    }
    var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
    function d3_noop() {}
    d3.dispatch = function() {
      var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
      while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
      return dispatch;
    };
    function d3_dispatch() {}
    d3_dispatch.prototype.on = function(type, listener) {
      var i = type.indexOf("."), name = "";
      if (i >= 0) {
        name = type.slice(i + 1);
        type = type.slice(0, i);
      }
      if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
      if (arguments.length === 2) {
        if (listener == null) for (type in this) {
          if (this.hasOwnProperty(type)) this[type].on(name, null);
        }
        return this;
      }
    };
    function d3_dispatch_event(dispatch) {
      var listeners = [], listenerByName = new d3_Map();
      function event() {
        var z = listeners, i = -1, n = z.length, l;
        while (++i < n) if (l = z[i].on) l.apply(this, arguments);
        return dispatch;
      }
      event.on = function(name, listener) {
        var l = listenerByName.get(name), i;
        if (arguments.length < 2) return l && l.on;
        if (l) {
          l.on = null;
          listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
          listenerByName.remove(name);
        }
        if (listener) listeners.push(listenerByName.set(name, {
          on: listener
        }));
        return dispatch;
      };
      return event;
    }
    d3.event = null;
    function d3_eventPreventDefault() {
      d3.event.preventDefault();
    }
    function d3_eventSource() {
      var e = d3.event, s;
      while (s = e.sourceEvent) e = s;
      return e;
    }
    function d3_eventDispatch(target) {
      var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
      while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
      dispatch.of = function(thiz, argumentz) {
        return function(e1) {
          try {
            var e0 = e1.sourceEvent = d3.event;
            e1.target = target;
            d3.event = e1;
            dispatch[e1.type].apply(thiz, argumentz);
          } finally {
            d3.event = e0;
          }
        };
      };
      return dispatch;
    }
    d3.requote = function(s) {
      return s.replace(d3_requote_re, "\\$&");
    };
    var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
    var d3_subclass = {}.__proto__ ? function(object, prototype) {
      object.__proto__ = prototype;
    } : function(object, prototype) {
      for (var property in prototype) object[property] = prototype[property];
    };
    function d3_selection(groups) {
      d3_subclass(groups, d3_selectionPrototype);
      return groups;
    }
    var d3_select = function(s, n) {
      return n.querySelector(s);
    }, d3_selectAll = function(s, n) {
      return n.querySelectorAll(s);
    }, d3_selectMatches = function(n, s) {
      var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
      d3_selectMatches = function(n, s) {
        return d3_selectMatcher.call(n, s);
      };
      return d3_selectMatches(n, s);
    };
    if (typeof Sizzle === "function") {
      d3_select = function(s, n) {
        return Sizzle(s, n)[0] || null;
      };
      d3_selectAll = Sizzle;
      d3_selectMatches = Sizzle.matchesSelector;
    }
    d3.selection = function() {
      return d3.select(d3_document.documentElement);
    };
    var d3_selectionPrototype = d3.selection.prototype = [];
    d3_selectionPrototype.select = function(selector) {
      var subgroups = [], subgroup, subnode, group, node;
      selector = d3_selection_selector(selector);
      for (var j = -1, m = this.length; ++j < m; ) {
        subgroups.push(subgroup = []);
        subgroup.parentNode = (group = this[j]).parentNode;
        for (var i = -1, n = group.length; ++i < n; ) {
          if (node = group[i]) {
            subgroup.push(subnode = selector.call(node, node.__data__, i, j));
            if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
          } else {
            subgroup.push(null);
          }
        }
      }
      return d3_selection(subgroups);
    };
    function d3_selection_selector(selector) {
      return typeof selector === "function" ? selector : function() {
        return d3_select(selector, this);
      };
    }
    d3_selectionPrototype.selectAll = function(selector) {
      var subgroups = [], subgroup, node;
      selector = d3_selection_selectorAll(selector);
      for (var j = -1, m = this.length; ++j < m; ) {
        for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
          if (node = group[i]) {
            subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
            subgroup.parentNode = node;
          }
        }
      }
      return d3_selection(subgroups);
    };
    function d3_selection_selectorAll(selector) {
      return typeof selector === "function" ? selector : function() {
        return d3_selectAll(selector, this);
      };
    }
    var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
    var d3_nsPrefix = {
      svg: "http://www.w3.org/2000/svg",
      xhtml: d3_nsXhtml,
      xlink: "http://www.w3.org/1999/xlink",
      xml: "http://www.w3.org/XML/1998/namespace",
      xmlns: "http://www.w3.org/2000/xmlns/"
    };
    d3.ns = {
      prefix: d3_nsPrefix,
      qualify: function(name) {
        var i = name.indexOf(":"), prefix = name;
        if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
        return d3_nsPrefix.hasOwnProperty(prefix) ? {
          space: d3_nsPrefix[prefix],
          local: name
        } : name;
      }
    };
    d3_selectionPrototype.attr = function(name, value) {
      if (arguments.length < 2) {
        if (typeof name === "string") {
          var node = this.node();
          name = d3.ns.qualify(name);
          return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
        }
        for (value in name) this.each(d3_selection_attr(value, name[value]));
        return this;
      }
      return this.each(d3_selection_attr(name, value));
    };
    function d3_selection_attr(name, value) {
      name = d3.ns.qualify(name);
      function attrNull() {
        this.removeAttribute(name);
      }
      function attrNullNS() {
        this.removeAttributeNS(name.space, name.local);
      }
      function attrConstant() {
        this.setAttribute(name, value);
      }
      function attrConstantNS() {
        this.setAttributeNS(name.space, name.local, value);
      }
      function attrFunction() {
        var x = value.apply(this, arguments);
        if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
      }
      function attrFunctionNS() {
        var x = value.apply(this, arguments);
        if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
      }
      return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
    }
    function d3_collapse(s) {
      return s.trim().replace(/\s+/g, " ");
    }
    d3_selectionPrototype.classed = function(name, value) {
      if (arguments.length < 2) {
        if (typeof name === "string") {
          var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
          if (value = node.classList) {
            while (++i < n) if (!value.contains(name[i])) return false;
          } else {
            value = node.getAttribute("class");
            while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
          }
          return true;
        }
        for (value in name) this.each(d3_selection_classed(value, name[value]));
        return this;
      }
      return this.each(d3_selection_classed(name, value));
    };
    function d3_selection_classedRe(name) {
      return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
    }
    function d3_selection_classes(name) {
      return (name + "").trim().split(/^|\s+/);
    }
    function d3_selection_classed(name, value) {
      name = d3_selection_classes(name).map(d3_selection_classedName);
      var n = name.length;
      function classedConstant() {
        var i = -1;
        while (++i < n) name[i](this, value);
      }
      function classedFunction() {
        var i = -1, x = value.apply(this, arguments);
        while (++i < n) name[i](this, x);
      }
      return typeof value === "function" ? classedFunction : classedConstant;
    }
    function d3_selection_classedName(name) {
      var re = d3_selection_classedRe(name);
      return function(node, value) {
        if (c = node.classList) return value ? c.add(name) : c.remove(name);
        var c = node.getAttribute("class") || "";
        if (value) {
          re.lastIndex = 0;
          if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
        } else {
          node.setAttribute("class", d3_collapse(c.replace(re, " ")));
        }
      };
    }
    d3_selectionPrototype.style = function(name, value, priority) {
      var n = arguments.length;
      if (n < 3) {
        if (typeof name !== "string") {
          if (n < 2) value = "";
          for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
          return this;
        }
        if (n < 2) {
          var node = this.node();
          return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
        }
        priority = "";
      }
      return this.each(d3_selection_style(name, value, priority));
    };
    function d3_selection_style(name, value, priority) {
      function styleNull() {
        this.style.removeProperty(name);
      }
      function styleConstant() {
        this.style.setProperty(name, value, priority);
      }
      function styleFunction() {
        var x = value.apply(this, arguments);
        if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
      }
      return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
    }
    d3_selectionPrototype.property = function(name, value) {
      if (arguments.length < 2) {
        if (typeof name === "string") return this.node()[name];
        for (value in name) this.each(d3_selection_property(value, name[value]));
        return this;
      }
      return this.each(d3_selection_property(name, value));
    };
    function d3_selection_property(name, value) {
      function propertyNull() {
        delete this[name];
      }
      function propertyConstant() {
        this[name] = value;
      }
      function propertyFunction() {
        var x = value.apply(this, arguments);
        if (x == null) delete this[name]; else this[name] = x;
      }
      return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
    }
    d3_selectionPrototype.text = function(value) {
      return arguments.length ? this.each(typeof value === "function" ? function() {
        var v = value.apply(this, arguments);
        this.textContent = v == null ? "" : v;
      } : value == null ? function() {
        this.textContent = "";
      } : function() {
        this.textContent = value;
      }) : this.node().textContent;
    };
    d3_selectionPrototype.html = function(value) {
      return arguments.length ? this.each(typeof value === "function" ? function() {
        var v = value.apply(this, arguments);
        this.innerHTML = v == null ? "" : v;
      } : value == null ? function() {
        this.innerHTML = "";
      } : function() {
        this.innerHTML = value;
      }) : this.node().innerHTML;
    };
    d3_selectionPrototype.append = function(name) {
      name = d3_selection_creator(name);
      return this.select(function() {
        return this.appendChild(name.apply(this, arguments));
      });
    };
    function d3_selection_creator(name) {
      function create() {
        var document = this.ownerDocument, namespace = this.namespaceURI;
        return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
      }
      function createNS() {
        return this.ownerDocument.createElementNS(name.space, name.local);
      }
      return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
    }
    d3_selectionPrototype.insert = function(name, before) {
      name = d3_selection_creator(name);
      before = d3_selection_selector(before);
      return this.select(function() {
        return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
      });
    };
    d3_selectionPrototype.remove = function() {
      return this.each(d3_selectionRemove);
    };
    function d3_selectionRemove() {
      var parent = this.parentNode;
      if (parent) parent.removeChild(this);
    }
    d3_selectionPrototype.data = function(value, key) {
      var i = -1, n = this.length, group, node;
      if (!arguments.length) {
        value = new Array(n = (group = this[0]).length);
        while (++i < n) {
          if (node = group[i]) {
            value[i] = node.__data__;
          }
        }
        return value;
      }
      function bind(group, groupData) {
        var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
        if (key) {
          var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
          for (i = -1; ++i < n; ) {
            if (node = group[i]) {
              if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
                exitNodes[i] = node;
              } else {
                nodeByKeyValue.set(keyValue, node);
              }
              keyValues[i] = keyValue;
            }
          }
          for (i = -1; ++i < m; ) {
            if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
              enterNodes[i] = d3_selection_dataNode(nodeData);
            } else if (node !== true) {
              updateNodes[i] = node;
              node.__data__ = nodeData;
            }
            nodeByKeyValue.set(keyValue, true);
          }
          for (i = -1; ++i < n; ) {
            if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
              exitNodes[i] = group[i];
            }
          }
        } else {
          for (i = -1; ++i < n0; ) {
            node = group[i];
            nodeData = groupData[i];
            if (node) {
              node.__data__ = nodeData;
              updateNodes[i] = node;
            } else {
              enterNodes[i] = d3_selection_dataNode(nodeData);
            }
          }
          for (;i < m; ++i) {
            enterNodes[i] = d3_selection_dataNode(groupData[i]);
          }
          for (;i < n; ++i) {
            exitNodes[i] = group[i];
          }
        }
        enterNodes.update = updateNodes;
        enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
        enter.push(enterNodes);
        update.push(updateNodes);
        exit.push(exitNodes);
      }
      var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
      if (typeof value === "function") {
        while (++i < n) {
          bind(group = this[i], value.call(group, group.parentNode.__data__, i));
        }
      } else {
        while (++i < n) {
          bind(group = this[i], value);
        }
      }
      update.enter = function() {
        return enter;
      };
      update.exit = function() {
        return exit;
      };
      return update;
    };
    function d3_selection_dataNode(data) {
      return {
        __data__: data
      };
    }
    d3_selectionPrototype.datum = function(value) {
      return arguments.length ? this.property("__data__", value) : this.property("__data__");
    };
    d3_selectionPrototype.filter = function(filter) {
      var subgroups = [], subgroup, group, node;
      if (typeof filter !== "function") filter = d3_selection_filter(filter);
      for (var j = 0, m = this.length; j < m; j++) {
        subgroups.push(subgroup = []);
        subgroup.parentNode = (group = this[j]).parentNode;
        for (var i = 0, n = group.length; i < n; i++) {
          if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
            subgroup.push(node);
          }
        }
      }
      return d3_selection(subgroups);
    };
    function d3_selection_filter(selector) {
      return function() {
        return d3_selectMatches(this, selector);
      };
    }
    d3_selectionPrototype.order = function() {
      for (var j = -1, m = this.length; ++j < m; ) {
        for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
          if (node = group[i]) {
            if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
            next = node;
          }
        }
      }
      return this;
    };
    d3_selectionPrototype.sort = function(comparator) {
      comparator = d3_selection_sortComparator.apply(this, arguments);
      for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
      return this.order();
    };
    function d3_selection_sortComparator(comparator) {
      if (!arguments.length) comparator = d3_ascending;
      return function(a, b) {
        return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
      };
    }
    d3_selectionPrototype.each = function(callback) {
      return d3_selection_each(this, function(node, i, j) {
        callback.call(node, node.__data__, i, j);
      });
    };
    function d3_selection_each(groups, callback) {
      for (var j = 0, m = groups.length; j < m; j++) {
        for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
          if (node = group[i]) callback(node, i, j);
        }
      }
      return groups;
    }
    d3_selectionPrototype.call = function(callback) {
      var args = d3_array(arguments);
      callback.apply(args[0] = this, args);
      return this;
    };
    d3_selectionPrototype.empty = function() {
      return !this.node();
    };
    d3_selectionPrototype.node = function() {
      for (var j = 0, m = this.length; j < m; j++) {
        for (var group = this[j], i = 0, n = group.length; i < n; i++) {
          var node = group[i];
          if (node) return node;
        }
      }
      return null;
    };
    d3_selectionPrototype.size = function() {
      var n = 0;
      d3_selection_each(this, function() {
        ++n;
      });
      return n;
    };
    function d3_selection_enter(selection) {
      d3_subclass(selection, d3_selection_enterPrototype);
      return selection;
    }
    var d3_selection_enterPrototype = [];
    d3.selection.enter = d3_selection_enter;
    d3.selection.enter.prototype = d3_selection_enterPrototype;
    d3_selection_enterPrototype.append = d3_selectionPrototype.append;
    d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
    d3_selection_enterPrototype.node = d3_selectionPrototype.node;
    d3_selection_enterPrototype.call = d3_selectionPrototype.call;
    d3_selection_enterPrototype.size = d3_selectionPrototype.size;
    d3_selection_enterPrototype.select = function(selector) {
      var subgroups = [], subgroup, subnode, upgroup, group, node;
      for (var j = -1, m = this.length; ++j < m; ) {
        upgroup = (group = this[j]).update;
        subgroups.push(subgroup = []);
        subgroup.parentNode = group.parentNode;
        for (var i = -1, n = group.length; ++i < n; ) {
          if (node = group[i]) {
            subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
            subnode.__data__ = node.__data__;
          } else {
            subgroup.push(null);
          }
        }
      }
      return d3_selection(subgroups);
    };
    d3_selection_enterPrototype.insert = function(name, before) {
      if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
      return d3_selectionPrototype.insert.call(this, name, before);
    };
    function d3_selection_enterInsertBefore(enter) {
      var i0, j0;
      return function(d, i, j) {
        var group = enter[j].update, n = group.length, node;
        if (j != j0) j0 = j, i0 = 0;
        if (i >= i0) i0 = i + 1;
        while (!(node = group[i0]) && ++i0 < n) ;
        return node;
      };
    }
    d3.select = function(node) {
      var group;
      if (typeof node === "string") {
        group = [ d3_select(node, d3_document) ];
        group.parentNode = d3_document.documentElement;
      } else {
        group = [ node ];
        group.parentNode = d3_documentElement(node);
      }
      return d3_selection([ group ]);
    };
    d3.selectAll = function(nodes) {
      var group;
      if (typeof nodes === "string") {
        group = d3_array(d3_selectAll(nodes, d3_document));
        group.parentNode = d3_document.documentElement;
      } else {
        group = d3_array(nodes);
        group.parentNode = null;
      }
      return d3_selection([ group ]);
    };
    d3_selectionPrototype.on = function(type, listener, capture) {
      var n = arguments.length;
      if (n < 3) {
        if (typeof type !== "string") {
          if (n < 2) listener = false;
          for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
          return this;
        }
        if (n < 2) return (n = this.node()["__on" + type]) && n._;
        capture = false;
      }
      return this.each(d3_selection_on(type, listener, capture));
    };
    function d3_selection_on(type, listener, capture) {
      var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
      if (i > 0) type = type.slice(0, i);
      var filter = d3_selection_onFilters.get(type);
      if (filter) type = filter, wrap = d3_selection_onFilter;
      function onRemove() {
        var l = this[name];
        if (l) {
          this.removeEventListener(type, l, l.$);
          delete this[name];
        }
      }
      function onAdd() {
        var l = wrap(listener, d3_array(arguments));
        onRemove.call(this);
        this.addEventListener(type, this[name] = l, l.$ = capture);
        l._ = listener;
      }
      function removeAll() {
        var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
        for (var name in this) {
          if (match = name.match(re)) {
            var l = this[name];
            this.removeEventListener(match[1], l, l.$);
            delete this[name];
          }
        }
      }
      return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
    }
    var d3_selection_onFilters = d3.map({
      mouseenter: "mouseover",
      mouseleave: "mouseout"
    });
    if (d3_document) {
      d3_selection_onFilters.forEach(function(k) {
        if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
      });
    }
    function d3_selection_onListener(listener, argumentz) {
      return function(e) {
        var o = d3.event;
        d3.event = e;
        argumentz[0] = this.__data__;
        try {
          listener.apply(this, argumentz);
        } finally {
          d3.event = o;
        }
      };
    }
    function d3_selection_onFilter(listener, argumentz) {
      var l = d3_selection_onListener(listener, argumentz);
      return function(e) {
        var target = this, related = e.relatedTarget;
        if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
          l.call(target, e);
        }
      };
    }
    var d3_event_dragSelect, d3_event_dragId = 0;
    function d3_event_dragSuppress(node) {
      var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
      if (d3_event_dragSelect == null) {
        d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
      }
      if (d3_event_dragSelect) {
        var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
        style[d3_event_dragSelect] = "none";
      }
      return function(suppressClick) {
        w.on(name, null);
        if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
        if (suppressClick) {
          var off = function() {
            w.on(click, null);
          };
          w.on(click, function() {
            d3_eventPreventDefault();
            off();
          }, true);
          setTimeout(off, 0);
        }
      };
    }
    d3.mouse = function(container) {
      return d3_mousePoint(container, d3_eventSource());
    };
    var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
    function d3_mousePoint(container, e) {
      if (e.changedTouches) e = e.changedTouches[0];
      var svg = container.ownerSVGElement || container;
      if (svg.createSVGPoint) {
        var point = svg.createSVGPoint();
        if (d3_mouse_bug44083 < 0) {
          var window = d3_window(container);
          if (window.scrollX || window.scrollY) {
            svg = d3.select("body").append("svg").style({
              position: "absolute",
              top: 0,
              left: 0,
              margin: 0,
              padding: 0,
              border: "none"
            }, "important");
            var ctm = svg[0][0].getScreenCTM();
            d3_mouse_bug44083 = !(ctm.f || ctm.e);
            svg.remove();
          }
        }
        if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
        point.y = e.clientY;
        point = point.matrixTransform(container.getScreenCTM().inverse());
        return [ point.x, point.y ];
      }
      var rect = container.getBoundingClientRect();
      return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
    }
    d3.touch = function(container, touches, identifier) {
      if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
      if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
        if ((touch = touches[i]).identifier === identifier) {
          return d3_mousePoint(container, touch);
        }
      }
    };
    d3.behavior.drag = function() {
      var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
      function drag() {
        this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
      }
      function dragstart(id, position, subject, move, end) {
        return function() {
          var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
          if (origin) {
            dragOffset = origin.apply(that, arguments);
            dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
          } else {
            dragOffset = [ 0, 0 ];
          }
          dispatch({
            type: "dragstart"
          });
          function moved() {
            var position1 = position(parent, dragId), dx, dy;
            if (!position1) return;
            dx = position1[0] - position0[0];
            dy = position1[1] - position0[1];
            dragged |= dx | dy;
            position0 = position1;
            dispatch({
              type: "drag",
              x: position1[0] + dragOffset[0],
              y: position1[1] + dragOffset[1],
              dx: dx,
              dy: dy
            });
          }
          function ended() {
            if (!position(parent, dragId)) return;
            dragSubject.on(move + dragName, null).on(end + dragName, null);
            dragRestore(dragged);
            dispatch({
              type: "dragend"
            });
          }
        };
      }
      drag.origin = function(x) {
        if (!arguments.length) return origin;
        origin = x;
        return drag;
      };
      return d3.rebind(drag, event, "on");
    };
    function d3_behavior_dragTouchId() {
      return d3.event.changedTouches[0].identifier;
    }
    d3.touches = function(container, touches) {
      if (arguments.length < 2) touches = d3_eventSource().touches;
      return touches ? d3_array(touches).map(function(touch) {
        var point = d3_mousePoint(container, touch);
        point.identifier = touch.identifier;
        return point;
      }) : [];
    };
    var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
    function d3_sgn(x) {
      return x > 0 ? 1 : x < 0 ? -1 : 0;
    }
    function d3_cross2d(a, b, c) {
      return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
    }
    function d3_acos(x) {
      return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
    }
    function d3_asin(x) {
      return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
    }
    function d3_sinh(x) {
      return ((x = Math.exp(x)) - 1 / x) / 2;
    }
    function d3_cosh(x) {
      return ((x = Math.exp(x)) + 1 / x) / 2;
    }
    function d3_tanh(x) {
      return ((x = Math.exp(2 * x)) - 1) / (x + 1);
    }
    function d3_haversin(x) {
      return (x = Math.sin(x / 2)) * x;
    }
    var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
    d3.interpolateZoom = function(p0, p1) {
      var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
      if (d2 < ε2) {
        S = Math.log(w1 / w0) / ρ;
        i = function(t) {
          return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
        };
      } else {
        var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
        S = (r1 - r0) / ρ;
        i = function(t) {
          var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
          return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
        };
      }
      i.duration = S * 1e3;
      return i;
    };
    d3.behavior.zoom = function() {
      var view = {
        x: 0,
        y: 0,
        k: 1
      }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
      if (!d3_behavior_zoomWheel) {
        d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
          return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
        }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
          return d3.event.wheelDelta;
        }, "mousewheel") : (d3_behavior_zoomDelta = function() {
          return -d3.event.detail;
        }, "MozMousePixelScroll");
      }
      function zoom(g) {
        g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
      }
      zoom.event = function(g) {
        g.each(function() {
          var dispatch = event.of(this, arguments), view1 = view;
          if (d3_transitionInheritId) {
            d3.select(this).transition().each("start.zoom", function() {
              view = this.__chart__ || {
                x: 0,
                y: 0,
                k: 1
              };
              zoomstarted(dispatch);
            }).tween("zoom:zoom", function() {
              var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
              return function(t) {
                var l = i(t), k = dx / l[2];
                this.__chart__ = view = {
                  x: cx - l[0] * k,
                  y: cy - l[1] * k,
                  k: k
                };
                zoomed(dispatch);
              };
            }).each("interrupt.zoom", function() {
              zoomended(dispatch);
            }).each("end.zoom", function() {
              zoomended(dispatch);
            });
          } else {
            this.__chart__ = view;
            zoomstarted(dispatch);
            zoomed(dispatch);
            zoomended(dispatch);
          }
        });
      };
      zoom.translate = function(_) {
        if (!arguments.length) return [ view.x, view.y ];
        view = {
          x: +_[0],
          y: +_[1],
          k: view.k
        };
        rescale();
        return zoom;
      };
      zoom.scale = function(_) {
        if (!arguments.length) return view.k;
        view = {
          x: view.x,
          y: view.y,
          k: null
        };
        scaleTo(+_);
        rescale();
        return zoom;
      };
      zoom.scaleExtent = function(_) {
        if (!arguments.length) return scaleExtent;
        scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
        return zoom;
      };
      zoom.center = function(_) {
        if (!arguments.length) return center;
        center = _ && [ +_[0], +_[1] ];
        return zoom;
      };
      zoom.size = function(_) {
        if (!arguments.length) return size;
        size = _ && [ +_[0], +_[1] ];
        return zoom;
      };
      zoom.duration = function(_) {
        if (!arguments.length) return duration;
        duration = +_;
        return zoom;
      };
      zoom.x = function(z) {
        if (!arguments.length) return x1;
        x1 = z;
        x0 = z.copy();
        view = {
          x: 0,
          y: 0,
          k: 1
        };
        return zoom;
      };
      zoom.y = function(z) {
        if (!arguments.length) return y1;
        y1 = z;
        y0 = z.copy();
        view = {
          x: 0,
          y: 0,
          k: 1
        };
        return zoom;
      };
      function location(p) {
        return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
      }
      function point(l) {
        return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
      }
      function scaleTo(s) {
        view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
      }
      function translateTo(p, l) {
        l = point(l);
        view.x += p[0] - l[0];
        view.y += p[1] - l[1];
      }
      function zoomTo(that, p, l, k) {
        that.__chart__ = {
          x: view.x,
          y: view.y,
          k: view.k
        };
        scaleTo(Math.pow(2, k));
        translateTo(center0 = p, l);
        that = d3.select(that);
        if (duration > 0) that = that.transition().duration(duration);
        that.call(zoom.event);
      }
      function rescale() {
        if (x1) x1.domain(x0.range().map(function(x) {
          return (x - view.x) / view.k;
        }).map(x0.invert));
        if (y1) y1.domain(y0.range().map(function(y) {
          return (y - view.y) / view.k;
        }).map(y0.invert));
      }
      function zoomstarted(dispatch) {
        if (!zooming++) dispatch({
          type: "zoomstart"
        });
      }
      function zoomed(dispatch) {
        rescale();
        dispatch({
          type: "zoom",
          scale: view.k,
          translate: [ view.x, view.y ]
        });
      }
      function zoomended(dispatch) {
        if (!--zooming) dispatch({
          type: "zoomend"
        }), center0 = null;
      }
      function mousedowned() {
        var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
        d3_selection_interrupt.call(that);
        zoomstarted(dispatch);
        function moved() {
          dragged = 1;
          translateTo(d3.mouse(that), location0);
          zoomed(dispatch);
        }
        function ended() {
          subject.on(mousemove, null).on(mouseup, null);
          dragRestore(dragged);
          zoomended(dispatch);
        }
      }
      function touchstarted() {
        var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
        started();
        zoomstarted(dispatch);
        subject.on(mousedown, null).on(touchstart, started);
        function relocate() {
          var touches = d3.touches(that);
          scale0 = view.k;
          touches.forEach(function(t) {
            if (t.identifier in locations0) locations0[t.identifier] = location(t);
          });
          return touches;
        }
        function started() {
          var target = d3.event.target;
          d3.select(target).on(touchmove, moved).on(touchend, ended);
          targets.push(target);
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            locations0[changed[i].identifier] = null;
          }
          var touches = relocate(), now = Date.now();
          if (touches.length === 1) {
            if (now - touchtime < 500) {
              var p = touches[0];
              zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
              d3_eventPreventDefault();
            }
            touchtime = now;
          } else if (touches.length > 1) {
            var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
            distance0 = dx * dx + dy * dy;
          }
        }
        function moved() {
          var touches = d3.touches(that), p0, l0, p1, l1;
          d3_selection_interrupt.call(that);
          for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
            p1 = touches[i];
            if (l1 = locations0[p1.identifier]) {
              if (l0) break;
              p0 = p1, l0 = l1;
            }
          }
          if (l1) {
            var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
            p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
            l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
            scaleTo(scale1 * scale0);
          }
          touchtime = null;
          translateTo(p0, l0);
          zoomed(dispatch);
        }
        function ended() {
          if (d3.event.touches.length) {
            var changed = d3.event.changedTouches;
            for (var i = 0, n = changed.length; i < n; ++i) {
              delete locations0[changed[i].identifier];
            }
            for (var identifier in locations0) {
              return void relocate();
            }
          }
          d3.selectAll(targets).on(zoomName, null);
          subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
          dragRestore();
          zoomended(dispatch);
        }
      }
      function mousewheeled() {
        var dispatch = event.of(this, arguments);
        if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
        translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
        mousewheelTimer = setTimeout(function() {
          mousewheelTimer = null;
          zoomended(dispatch);
        }, 50);
        d3_eventPreventDefault();
        scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
        translateTo(center0, translate0);
        zoomed(dispatch);
      }
      function dblclicked() {
        var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
        zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
      }
      return d3.rebind(zoom, event, "on");
    };
    var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
    d3.color = d3_color;
    function d3_color() {}
    d3_color.prototype.toString = function() {
      return this.rgb() + "";
    };
    d3.hsl = d3_hsl;
    function d3_hsl(h, s, l) {
      return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
    }
    var d3_hslPrototype = d3_hsl.prototype = new d3_color();
    d3_hslPrototype.brighter = function(k) {
      k = Math.pow(.7, arguments.length ? k : 1);
      return new d3_hsl(this.h, this.s, this.l / k);
    };
    d3_hslPrototype.darker = function(k) {
      k = Math.pow(.7, arguments.length ? k : 1);
      return new d3_hsl(this.h, this.s, k * this.l);
    };
    d3_hslPrototype.rgb = function() {
      return d3_hsl_rgb(this.h, this.s, this.l);
    };
    function d3_hsl_rgb(h, s, l) {
      var m1, m2;
      h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
      s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
      l = l < 0 ? 0 : l > 1 ? 1 : l;
      m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
      m1 = 2 * l - m2;
      function v(h) {
        if (h > 360) h -= 360; else if (h < 0) h += 360;
        if (h < 60) return m1 + (m2 - m1) * h / 60;
        if (h < 180) return m2;
        if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
        return m1;
      }
      function vv(h) {
        return Math.round(v(h) * 255);
      }
      return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
    }
    d3.hcl = d3_hcl;
    function d3_hcl(h, c, l) {
      return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
    }
    var d3_hclPrototype = d3_hcl.prototype = new d3_color();
    d3_hclPrototype.brighter = function(k) {
      return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
    };
    d3_hclPrototype.darker = function(k) {
      return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
    };
    d3_hclPrototype.rgb = function() {
      return d3_hcl_lab(this.h, this.c, this.l).rgb();
    };
    function d3_hcl_lab(h, c, l) {
      if (isNaN(h)) h = 0;
      if (isNaN(c)) c = 0;
      return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
    }
    d3.lab = d3_lab;
    function d3_lab(l, a, b) {
      return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
    }
    var d3_lab_K = 18;
    var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
    var d3_labPrototype = d3_lab.prototype = new d3_color();
    d3_labPrototype.brighter = function(k) {
      return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
    };
    d3_labPrototype.darker = function(k) {
      return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
    };
    d3_labPrototype.rgb = function() {
      return d3_lab_rgb(this.l, this.a, this.b);
    };
    function d3_lab_rgb(l, a, b) {
      var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
      x = d3_lab_xyz(x) * d3_lab_X;
      y = d3_lab_xyz(y) * d3_lab_Y;
      z = d3_lab_xyz(z) * d3_lab_Z;
      return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
    }
    function d3_lab_hcl(l, a, b) {
      return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
    }
    function d3_lab_xyz(x) {
      return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
    }
    function d3_xyz_lab(x) {
      return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
    }
    function d3_xyz_rgb(r) {
      return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
    }
    d3.rgb = d3_rgb;
    function d3_rgb(r, g, b) {
      return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
    }
    function d3_rgbNumber(value) {
      return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
    }
    function d3_rgbString(value) {
      return d3_rgbNumber(value) + "";
    }
    var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
    d3_rgbPrototype.brighter = function(k) {
      k = Math.pow(.7, arguments.length ? k : 1);
      var r = this.r, g = this.g, b = this.b, i = 30;
      if (!r && !g && !b) return new d3_rgb(i, i, i);
      if (r && r < i) r = i;
      if (g && g < i) g = i;
      if (b && b < i) b = i;
      return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
    };
    d3_rgbPrototype.darker = function(k) {
      k = Math.pow(.7, arguments.length ? k : 1);
      return new d3_rgb(k * this.r, k * this.g, k * this.b);
    };
    d3_rgbPrototype.hsl = function() {
      return d3_rgb_hsl(this.r, this.g, this.b);
    };
    d3_rgbPrototype.toString = function() {
      return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
    };
    function d3_rgb_hex(v) {
      return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
    }
    function d3_rgb_parse(format, rgb, hsl) {
      var r = 0, g = 0, b = 0, m1, m2, color;
      m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
      if (m1) {
        m2 = m1[2].split(",");
        switch (m1[1]) {
         case "hsl":
          {
            return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
          }
  
         case "rgb":
          {
            return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
          }
        }
      }
      if (color = d3_rgb_names.get(format)) {
        return rgb(color.r, color.g, color.b);
      }
      if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
        if (format.length === 4) {
          r = (color & 3840) >> 4;
          r = r >> 4 | r;
          g = color & 240;
          g = g >> 4 | g;
          b = color & 15;
          b = b << 4 | b;
        } else if (format.length === 7) {
          r = (color & 16711680) >> 16;
          g = (color & 65280) >> 8;
          b = color & 255;
        }
      }
      return rgb(r, g, b);
    }
    function d3_rgb_hsl(r, g, b) {
      var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
      if (d) {
        s = l < .5 ? d / (max + min) : d / (2 - max - min);
        if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
        h *= 60;
      } else {
        h = NaN;
        s = l > 0 && l < 1 ? 0 : h;
      }
      return new d3_hsl(h, s, l);
    }
    function d3_rgb_lab(r, g, b) {
      r = d3_rgb_xyz(r);
      g = d3_rgb_xyz(g);
      b = d3_rgb_xyz(b);
      var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
      return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
    }
    function d3_rgb_xyz(r) {
      return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
    }
    function d3_rgb_parseNumber(c) {
      var f = parseFloat(c);
      return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
    }
    var d3_rgb_names = d3.map({
      aliceblue: 15792383,
      antiquewhite: 16444375,
      aqua: 65535,
      aquamarine: 8388564,
      azure: 15794175,
      beige: 16119260,
      bisque: 16770244,
      black: 0,
      blanchedalmond: 16772045,
      blue: 255,
      blueviolet: 9055202,
      brown: 10824234,
      burlywood: 14596231,
      cadetblue: 6266528,
      chartreuse: 8388352,
      chocolate: 13789470,
      coral: 16744272,
      cornflowerblue: 6591981,
      cornsilk: 16775388,
      crimson: 14423100,
      cyan: 65535,
      darkblue: 139,
      darkcyan: 35723,
      darkgoldenrod: 12092939,
      darkgray: 11119017,
      darkgreen: 25600,
      darkgrey: 11119017,
      darkkhaki: 12433259,
      darkmagenta: 9109643,
      darkolivegreen: 5597999,
      darkorange: 16747520,
      darkorchid: 10040012,
      darkred: 9109504,
      darksalmon: 15308410,
      darkseagreen: 9419919,
      darkslateblue: 4734347,
      darkslategray: 3100495,
      darkslategrey: 3100495,
      darkturquoise: 52945,
      darkviolet: 9699539,
      deeppink: 16716947,
      deepskyblue: 49151,
      dimgray: 6908265,
      dimgrey: 6908265,
      dodgerblue: 2003199,
      firebrick: 11674146,
      floralwhite: 16775920,
      forestgreen: 2263842,
      fuchsia: 16711935,
      gainsboro: 14474460,
      ghostwhite: 16316671,
      gold: 16766720,
      goldenrod: 14329120,
      gray: 8421504,
      green: 32768,
      greenyellow: 11403055,
      grey: 8421504,
      honeydew: 15794160,
      hotpink: 16738740,
      indianred: 13458524,
      indigo: 4915330,
      ivory: 16777200,
      khaki: 15787660,
      lavender: 15132410,
      lavenderblush: 16773365,
      lawngreen: 8190976,
      lemonchiffon: 16775885,
      lightblue: 11393254,
      lightcoral: 15761536,
      lightcyan: 14745599,
      lightgoldenrodyellow: 16448210,
      lightgray: 13882323,
      lightgreen: 9498256,
      lightgrey: 13882323,
      lightpink: 16758465,
      lightsalmon: 16752762,
      lightseagreen: 2142890,
      lightskyblue: 8900346,
      lightslategray: 7833753,
      lightslategrey: 7833753,
      lightsteelblue: 11584734,
      lightyellow: 16777184,
      lime: 65280,
      limegreen: 3329330,
      linen: 16445670,
      magenta: 16711935,
      maroon: 8388608,
      mediumaquamarine: 6737322,
      mediumblue: 205,
      mediumorchid: 12211667,
      mediumpurple: 9662683,
      mediumseagreen: 3978097,
      mediumslateblue: 8087790,
      mediumspringgreen: 64154,
      mediumturquoise: 4772300,
      mediumvioletred: 13047173,
      midnightblue: 1644912,
      mintcream: 16121850,
      mistyrose: 16770273,
      moccasin: 16770229,
      navajowhite: 16768685,
      navy: 128,
      oldlace: 16643558,
      olive: 8421376,
      olivedrab: 7048739,
      orange: 16753920,
      orangered: 16729344,
      orchid: 14315734,
      palegoldenrod: 15657130,
      palegreen: 10025880,
      paleturquoise: 11529966,
      palevioletred: 14381203,
      papayawhip: 16773077,
      peachpuff: 16767673,
      peru: 13468991,
      pink: 16761035,
      plum: 14524637,
      powderblue: 11591910,
      purple: 8388736,
      rebeccapurple: 6697881,
      red: 16711680,
      rosybrown: 12357519,
      royalblue: 4286945,
      saddlebrown: 9127187,
      salmon: 16416882,
      sandybrown: 16032864,
      seagreen: 3050327,
      seashell: 16774638,
      sienna: 10506797,
      silver: 12632256,
      skyblue: 8900331,
      slateblue: 6970061,
      slategray: 7372944,
      slategrey: 7372944,
      snow: 16775930,
      springgreen: 65407,
      steelblue: 4620980,
      tan: 13808780,
      teal: 32896,
      thistle: 14204888,
      tomato: 16737095,
      turquoise: 4251856,
      violet: 15631086,
      wheat: 16113331,
      white: 16777215,
      whitesmoke: 16119285,
      yellow: 16776960,
      yellowgreen: 10145074
    });
    d3_rgb_names.forEach(function(key, value) {
      d3_rgb_names.set(key, d3_rgbNumber(value));
    });
    function d3_functor(v) {
      return typeof v === "function" ? v : function() {
        return v;
      };
    }
    d3.functor = d3_functor;
    d3.xhr = d3_xhrType(d3_identity);
    function d3_xhrType(response) {
      return function(url, mimeType, callback) {
        if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
        mimeType = null;
        return d3_xhr(url, mimeType, response, callback);
      };
    }
    function d3_xhr(url, mimeType, response, callback) {
      var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
      if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
      "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
        request.readyState > 3 && respond();
      };
      function respond() {
        var status = request.status, result;
        if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
          try {
            result = response.call(xhr, request);
          } catch (e) {
            dispatch.error.call(xhr, e);
            return;
          }
          dispatch.load.call(xhr, result);
        } else {
          dispatch.error.call(xhr, request);
        }
      }
      request.onprogress = function(event) {
        var o = d3.event;
        d3.event = event;
        try {
          dispatch.progress.call(xhr, request);
        } finally {
          d3.event = o;
        }
      };
      xhr.header = function(name, value) {
        name = (name + "").toLowerCase();
        if (arguments.length < 2) return headers[name];
        if (value == null) delete headers[name]; else headers[name] = value + "";
        return xhr;
      };
      xhr.mimeType = function(value) {
        if (!arguments.length) return mimeType;
        mimeType = value == null ? null : value + "";
        return xhr;
      };
      xhr.responseType = function(value) {
        if (!arguments.length) return responseType;
        responseType = value;
        return xhr;
      };
      xhr.response = function(value) {
        response = value;
        return xhr;
      };
      [ "get", "post" ].forEach(function(method) {
        xhr[method] = function() {
          return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
        };
      });
      xhr.send = function(method, data, callback) {
        if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
        request.open(method, url, true);
        if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
        if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
        if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
        if (responseType != null) request.responseType = responseType;
        if (callback != null) xhr.on("error", callback).on("load", function(request) {
          callback(null, request);
        });
        dispatch.beforesend.call(xhr, request);
        request.send(data == null ? null : data);
        return xhr;
      };
      xhr.abort = function() {
        request.abort();
        return xhr;
      };
      d3.rebind(xhr, dispatch, "on");
      return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
    }
    function d3_xhr_fixCallback(callback) {
      return callback.length === 1 ? function(error, request) {
        callback(error == null ? request : null);
      } : callback;
    }
    function d3_xhrHasResponse(request) {
      var type = request.responseType;
      return type && type !== "text" ? request.response : request.responseText;
    }
    d3.dsv = function(delimiter, mimeType) {
      var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
      function dsv(url, row, callback) {
        if (arguments.length < 3) callback = row, row = null;
        var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
        xhr.row = function(_) {
          return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
        };
        return xhr;
      }
      function response(request) {
        return dsv.parse(request.responseText);
      }
      function typedResponse(f) {
        return function(request) {
          return dsv.parse(request.responseText, f);
        };
      }
      dsv.parse = function(text, f) {
        var o;
        return dsv.parseRows(text, function(row, i) {
          if (o) return o(row, i - 1);
          var a = new Function("d", "return {" + row.map(function(name, i) {
            return JSON.stringify(name) + ": d[" + i + "]";
          }).join(",") + "}");
          o = f ? function(row, i) {
            return f(a(row), i);
          } : a;
        });
      };
      dsv.parseRows = function(text, f) {
        var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
        function token() {
          if (I >= N) return EOF;
          if (eol) return eol = false, EOL;
          var j = I;
          if (text.charCodeAt(j) === 34) {
            var i = j;
            while (i++ < N) {
              if (text.charCodeAt(i) === 34) {
                if (text.charCodeAt(i + 1) !== 34) break;
                ++i;
              }
            }
            I = i + 2;
            var c = text.charCodeAt(i + 1);
            if (c === 13) {
              eol = true;
              if (text.charCodeAt(i + 2) === 10) ++I;
            } else if (c === 10) {
              eol = true;
            }
            return text.slice(j + 1, i).replace(/""/g, '"');
          }
          while (I < N) {
            var c = text.charCodeAt(I++), k = 1;
            if (c === 10) eol = true; else if (c === 13) {
              eol = true;
              if (text.charCodeAt(I) === 10) ++I, ++k;
            } else if (c !== delimiterCode) continue;
            return text.slice(j, I - k);
          }
          return text.slice(j);
        }
        while ((t = token()) !== EOF) {
          var a = [];
          while (t !== EOL && t !== EOF) {
            a.push(t);
            t = token();
          }
          if (f && (a = f(a, n++)) == null) continue;
          rows.push(a);
        }
        return rows;
      };
      dsv.format = function(rows) {
        if (Array.isArray(rows[0])) return dsv.formatRows(rows);
        var fieldSet = new d3_Set(), fields = [];
        rows.forEach(function(row) {
          for (var field in row) {
            if (!fieldSet.has(field)) {
              fields.push(fieldSet.add(field));
            }
          }
        });
        return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
          return fields.map(function(field) {
            return formatValue(row[field]);
          }).join(delimiter);
        })).join("\n");
      };
      dsv.formatRows = function(rows) {
        return rows.map(formatRow).join("\n");
      };
      function formatRow(row) {
        return row.map(formatValue).join(delimiter);
      }
      function formatValue(text) {
        return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
      }
      return dsv;
    };
    d3.csv = d3.dsv(",", "text/csv");
    d3.tsv = d3.dsv("	", "text/tab-separated-values");
    var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
      setTimeout(callback, 17);
    };
    d3.timer = function() {
      d3_timer.apply(this, arguments);
    };
    function d3_timer(callback, delay, then) {
      var n = arguments.length;
      if (n < 2) delay = 0;
      if (n < 3) then = Date.now();
      var time = then + delay, timer = {
        c: callback,
        t: time,
        n: null
      };
      if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
      d3_timer_queueTail = timer;
      if (!d3_timer_interval) {
        d3_timer_timeout = clearTimeout(d3_timer_timeout);
        d3_timer_interval = 1;
        d3_timer_frame(d3_timer_step);
      }
      return timer;
    }
    function d3_timer_step() {
      var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
      if (delay > 24) {
        if (isFinite(delay)) {
          clearTimeout(d3_timer_timeout);
          d3_timer_timeout = setTimeout(d3_timer_step, delay);
        }
        d3_timer_interval = 0;
      } else {
        d3_timer_interval = 1;
        d3_timer_frame(d3_timer_step);
      }
    }
    d3.timer.flush = function() {
      d3_timer_mark();
      d3_timer_sweep();
    };
    function d3_timer_mark() {
      var now = Date.now(), timer = d3_timer_queueHead;
      while (timer) {
        if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
        timer = timer.n;
      }
      return now;
    }
    function d3_timer_sweep() {
      var t0, t1 = d3_timer_queueHead, time = Infinity;
      while (t1) {
        if (t1.c) {
          if (t1.t < time) time = t1.t;
          t1 = (t0 = t1).n;
        } else {
          t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
        }
      }
      d3_timer_queueTail = t0;
      return time;
    }
    function d3_format_precision(x, p) {
      return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
    }
    d3.round = function(x, n) {
      return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
    };
    var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
    d3.formatPrefix = function(value, precision) {
      var i = 0;
      if (value = +value) {
        if (value < 0) value *= -1;
        if (precision) value = d3.round(value, d3_format_precision(value, precision));
        i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
        i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
      }
      return d3_formatPrefixes[8 + i / 3];
    };
    function d3_formatPrefix(d, i) {
      var k = Math.pow(10, abs(8 - i) * 3);
      return {
        scale: i > 8 ? function(d) {
          return d / k;
        } : function(d) {
          return d * k;
        },
        symbol: d
      };
    }
    function d3_locale_numberFormat(locale) {
      var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
        var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
        while (i > 0 && g > 0) {
          if (length + g + 1 > width) g = Math.max(1, width - length);
          t.push(value.substring(i -= g, i + g));
          if ((length += g + 1) > width) break;
          g = locale_grouping[j = (j + 1) % locale_grouping.length];
        }
        return t.reverse().join(locale_thousands);
      } : d3_identity;
      return function(specifier) {
        var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
        if (precision) precision = +precision.substring(1);
        if (zfill || fill === "0" && align === "=") {
          zfill = fill = "0";
          align = "=";
        }
        switch (type) {
         case "n":
          comma = true;
          type = "g";
          break;
  
         case "%":
          scale = 100;
          suffix = "%";
          type = "f";
          break;
  
         case "p":
          scale = 100;
          suffix = "%";
          type = "r";
          break;
  
         case "b":
         case "o":
         case "x":
         case "X":
          if (symbol === "#") prefix = "0" + type.toLowerCase();
  
         case "c":
          exponent = false;
  
         case "d":
          integer = true;
          precision = 0;
          break;
  
         case "s":
          scale = -1;
          type = "r";
          break;
        }
        if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
        if (type == "r" && !precision) type = "g";
        if (precision != null) {
          if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
        }
        type = d3_format_types.get(type) || d3_format_typeDefault;
        var zcomma = zfill && comma;
        return function(value) {
          var fullSuffix = suffix;
          if (integer && value % 1) return "";
          var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
          if (scale < 0) {
            var unit = d3.formatPrefix(value, precision);
            value = unit.scale(value);
            fullSuffix = unit.symbol + suffix;
          } else {
            value *= scale;
          }
          value = type(value, precision);
          var i = value.lastIndexOf("."), before, after;
          if (i < 0) {
            var j = exponent ? value.lastIndexOf("e") : -1;
            if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
          } else {
            before = value.substring(0, i);
            after = locale_decimal + value.substring(i + 1);
          }
          if (!zfill && comma) before = formatGroup(before, Infinity);
          var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
          if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
          negative += prefix;
          value = before + after;
          return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
        };
      };
    }
    var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
    var d3_format_types = d3.map({
      b: function(x) {
        return x.toString(2);
      },
      c: function(x) {
        return String.fromCharCode(x);
      },
      o: function(x) {
        return x.toString(8);
      },
      x: function(x) {
        return x.toString(16);
      },
      X: function(x) {
        return x.toString(16).toUpperCase();
      },
      g: function(x, p) {
        return x.toPrecision(p);
      },
      e: function(x, p) {
        return x.toExponential(p);
      },
      f: function(x, p) {
        return x.toFixed(p);
      },
      r: function(x, p) {
        return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
      }
    });
    function d3_format_typeDefault(x) {
      return x + "";
    }
    var d3_time = d3.time = {}, d3_date = Date;
    function d3_date_utc() {
      this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
    }
    d3_date_utc.prototype = {
      getDate: function() {
        return this._.getUTCDate();
      },
      getDay: function() {
        return this._.getUTCDay();
      },
      getFullYear: function() {
        return this._.getUTCFullYear();
      },
      getHours: function() {
        return this._.getUTCHours();
      },
      getMilliseconds: function() {
        return this._.getUTCMilliseconds();
      },
      getMinutes: function() {
        return this._.getUTCMinutes();
      },
      getMonth: function() {
        return this._.getUTCMonth();
      },
      getSeconds: function() {
        return this._.getUTCSeconds();
      },
      getTime: function() {
        return this._.getTime();
      },
      getTimezoneOffset: function() {
        return 0;
      },
      valueOf: function() {
        return this._.valueOf();
      },
      setDate: function() {
        d3_time_prototype.setUTCDate.apply(this._, arguments);
      },
      setDay: function() {
        d3_time_prototype.setUTCDay.apply(this._, arguments);
      },
      setFullYear: function() {
        d3_time_prototype.setUTCFullYear.apply(this._, arguments);
      },
      setHours: function() {
        d3_time_prototype.setUTCHours.apply(this._, arguments);
      },
      setMilliseconds: function() {
        d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
      },
      setMinutes: function() {
        d3_time_prototype.setUTCMinutes.apply(this._, arguments);
      },
      setMonth: function() {
        d3_time_prototype.setUTCMonth.apply(this._, arguments);
      },
      setSeconds: function() {
        d3_time_prototype.setUTCSeconds.apply(this._, arguments);
      },
      setTime: function() {
        d3_time_prototype.setTime.apply(this._, arguments);
      }
    };
    var d3_time_prototype = Date.prototype;
    function d3_time_interval(local, step, number) {
      function round(date) {
        var d0 = local(date), d1 = offset(d0, 1);
        return date - d0 < d1 - date ? d0 : d1;
      }
      function ceil(date) {
        step(date = local(new d3_date(date - 1)), 1);
        return date;
      }
      function offset(date, k) {
        step(date = new d3_date(+date), k);
        return date;
      }
      function range(t0, t1, dt) {
        var time = ceil(t0), times = [];
        if (dt > 1) {
          while (time < t1) {
            if (!(number(time) % dt)) times.push(new Date(+time));
            step(time, 1);
          }
        } else {
          while (time < t1) times.push(new Date(+time)), step(time, 1);
        }
        return times;
      }
      function range_utc(t0, t1, dt) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date_utc();
          utc._ = t0;
          return range(utc, t1, dt);
        } finally {
          d3_date = Date;
        }
      }
      local.floor = local;
      local.round = round;
      local.ceil = ceil;
      local.offset = offset;
      local.range = range;
      var utc = local.utc = d3_time_interval_utc(local);
      utc.floor = utc;
      utc.round = d3_time_interval_utc(round);
      utc.ceil = d3_time_interval_utc(ceil);
      utc.offset = d3_time_interval_utc(offset);
      utc.range = range_utc;
      return local;
    }
    function d3_time_interval_utc(method) {
      return function(date, k) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date_utc();
          utc._ = date;
          return method(utc, k)._;
        } finally {
          d3_date = Date;
        }
      };
    }
    d3_time.year = d3_time_interval(function(date) {
      date = d3_time.day(date);
      date.setMonth(0, 1);
      return date;
    }, function(date, offset) {
      date.setFullYear(date.getFullYear() + offset);
    }, function(date) {
      return date.getFullYear();
    });
    d3_time.years = d3_time.year.range;
    d3_time.years.utc = d3_time.year.utc.range;
    d3_time.day = d3_time_interval(function(date) {
      var day = new d3_date(2e3, 0);
      day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      return day;
    }, function(date, offset) {
      date.setDate(date.getDate() + offset);
    }, function(date) {
      return date.getDate() - 1;
    });
    d3_time.days = d3_time.day.range;
    d3_time.days.utc = d3_time.day.utc.range;
    d3_time.dayOfYear = function(date) {
      var year = d3_time.year(date);
      return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
    };
    [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
      i = 7 - i;
      var interval = d3_time[day] = d3_time_interval(function(date) {
        (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
        return date;
      }, function(date, offset) {
        date.setDate(date.getDate() + Math.floor(offset) * 7);
      }, function(date) {
        var day = d3_time.year(date).getDay();
        return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
      });
      d3_time[day + "s"] = interval.range;
      d3_time[day + "s"].utc = interval.utc.range;
      d3_time[day + "OfYear"] = function(date) {
        var day = d3_time.year(date).getDay();
        return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
      };
    });
    d3_time.week = d3_time.sunday;
    d3_time.weeks = d3_time.sunday.range;
    d3_time.weeks.utc = d3_time.sunday.utc.range;
    d3_time.weekOfYear = d3_time.sundayOfYear;
    function d3_locale_timeFormat(locale) {
      var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
      function d3_time_format(template) {
        var n = template.length;
        function format(date) {
          var string = [], i = -1, j = 0, c, p, f;
          while (++i < n) {
            if (template.charCodeAt(i) === 37) {
              string.push(template.slice(j, i));
              if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
              if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
              string.push(c);
              j = i + 1;
            }
          }
          string.push(template.slice(j, i));
          return string.join("");
        }
        format.parse = function(string) {
          var d = {
            y: 1900,
            m: 0,
            d: 1,
            H: 0,
            M: 0,
            S: 0,
            L: 0,
            Z: null
          }, i = d3_time_parse(d, template, string, 0);
          if (i != string.length) return null;
          if ("p" in d) d.H = d.H % 12 + d.p * 12;
          var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
          if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
            if (!("w" in d)) d.w = "W" in d ? 1 : 0;
            date.setFullYear(d.y, 0, 1);
            date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
          } else date.setFullYear(d.y, d.m, d.d);
          date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
          return localZ ? date._ : date;
        };
        format.toString = function() {
          return template;
        };
        return format;
      }
      function d3_time_parse(date, template, string, j) {
        var c, p, t, i = 0, n = template.length, m = string.length;
        while (i < n) {
          if (j >= m) return -1;
          c = template.charCodeAt(i++);
          if (c === 37) {
            t = template.charAt(i++);
            p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
            if (!p || (j = p(date, string, j)) < 0) return -1;
          } else if (c != string.charCodeAt(j++)) {
            return -1;
          }
        }
        return j;
      }
      d3_time_format.utc = function(template) {
        var local = d3_time_format(template);
        function format(date) {
          try {
            d3_date = d3_date_utc;
            var utc = new d3_date();
            utc._ = date;
            return local(utc);
          } finally {
            d3_date = Date;
          }
        }
        format.parse = function(string) {
          try {
            d3_date = d3_date_utc;
            var date = local.parse(string);
            return date && date._;
          } finally {
            d3_date = Date;
          }
        };
        format.toString = local.toString;
        return format;
      };
      d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
      var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
      locale_periods.forEach(function(p, i) {
        d3_time_periodLookup.set(p.toLowerCase(), i);
      });
      var d3_time_formats = {
        a: function(d) {
          return locale_shortDays[d.getDay()];
        },
        A: function(d) {
          return locale_days[d.getDay()];
        },
        b: function(d) {
          return locale_shortMonths[d.getMonth()];
        },
        B: function(d) {
          return locale_months[d.getMonth()];
        },
        c: d3_time_format(locale_dateTime),
        d: function(d, p) {
          return d3_time_formatPad(d.getDate(), p, 2);
        },
        e: function(d, p) {
          return d3_time_formatPad(d.getDate(), p, 2);
        },
        H: function(d, p) {
          return d3_time_formatPad(d.getHours(), p, 2);
        },
        I: function(d, p) {
          return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
        },
        j: function(d, p) {
          return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
        },
        L: function(d, p) {
          return d3_time_formatPad(d.getMilliseconds(), p, 3);
        },
        m: function(d, p) {
          return d3_time_formatPad(d.getMonth() + 1, p, 2);
        },
        M: function(d, p) {
          return d3_time_formatPad(d.getMinutes(), p, 2);
        },
        p: function(d) {
          return locale_periods[+(d.getHours() >= 12)];
        },
        S: function(d, p) {
          return d3_time_formatPad(d.getSeconds(), p, 2);
        },
        U: function(d, p) {
          return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
        },
        w: function(d) {
          return d.getDay();
        },
        W: function(d, p) {
          return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
        },
        x: d3_time_format(locale_date),
        X: d3_time_format(locale_time),
        y: function(d, p) {
          return d3_time_formatPad(d.getFullYear() % 100, p, 2);
        },
        Y: function(d, p) {
          return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
        },
        Z: d3_time_zone,
        "%": function() {
          return "%";
        }
      };
      var d3_time_parsers = {
        a: d3_time_parseWeekdayAbbrev,
        A: d3_time_parseWeekday,
        b: d3_time_parseMonthAbbrev,
        B: d3_time_parseMonth,
        c: d3_time_parseLocaleFull,
        d: d3_time_parseDay,
        e: d3_time_parseDay,
        H: d3_time_parseHour24,
        I: d3_time_parseHour24,
        j: d3_time_parseDayOfYear,
        L: d3_time_parseMilliseconds,
        m: d3_time_parseMonthNumber,
        M: d3_time_parseMinutes,
        p: d3_time_parseAmPm,
        S: d3_time_parseSeconds,
        U: d3_time_parseWeekNumberSunday,
        w: d3_time_parseWeekdayNumber,
        W: d3_time_parseWeekNumberMonday,
        x: d3_time_parseLocaleDate,
        X: d3_time_parseLocaleTime,
        y: d3_time_parseYear,
        Y: d3_time_parseFullYear,
        Z: d3_time_parseZone,
        "%": d3_time_parseLiteralPercent
      };
      function d3_time_parseWeekdayAbbrev(date, string, i) {
        d3_time_dayAbbrevRe.lastIndex = 0;
        var n = d3_time_dayAbbrevRe.exec(string.slice(i));
        return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
      }
      function d3_time_parseWeekday(date, string, i) {
        d3_time_dayRe.lastIndex = 0;
        var n = d3_time_dayRe.exec(string.slice(i));
        return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
      }
      function d3_time_parseMonthAbbrev(date, string, i) {
        d3_time_monthAbbrevRe.lastIndex = 0;
        var n = d3_time_monthAbbrevRe.exec(string.slice(i));
        return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
      }
      function d3_time_parseMonth(date, string, i) {
        d3_time_monthRe.lastIndex = 0;
        var n = d3_time_monthRe.exec(string.slice(i));
        return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
      }
      function d3_time_parseLocaleFull(date, string, i) {
        return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
      }
      function d3_time_parseLocaleDate(date, string, i) {
        return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
      }
      function d3_time_parseLocaleTime(date, string, i) {
        return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
      }
      function d3_time_parseAmPm(date, string, i) {
        var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
        return n == null ? -1 : (date.p = n, i);
      }
      return d3_time_format;
    }
    var d3_time_formatPads = {
      "-": "",
      _: " ",
      "0": "0"
    }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
    function d3_time_formatPad(value, fill, width) {
      var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
      return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
    }
    function d3_time_formatRe(names) {
      return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
    }
    function d3_time_formatLookup(names) {
      var map = new d3_Map(), i = -1, n = names.length;
      while (++i < n) map.set(names[i].toLowerCase(), i);
      return map;
    }
    function d3_time_parseWeekdayNumber(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 1));
      return n ? (date.w = +n[0], i + n[0].length) : -1;
    }
    function d3_time_parseWeekNumberSunday(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i));
      return n ? (date.U = +n[0], i + n[0].length) : -1;
    }
    function d3_time_parseWeekNumberMonday(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i));
      return n ? (date.W = +n[0], i + n[0].length) : -1;
    }
    function d3_time_parseFullYear(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 4));
      return n ? (date.y = +n[0], i + n[0].length) : -1;
    }
    function d3_time_parseYear(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 2));
      return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
    }
    function d3_time_parseZone(date, string, i) {
      return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
      i + 5) : -1;
    }
    function d3_time_expandYear(d) {
      return d + (d > 68 ? 1900 : 2e3);
    }
    function d3_time_parseMonthNumber(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 2));
      return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
    }
    function d3_time_parseDay(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 2));
      return n ? (date.d = +n[0], i + n[0].length) : -1;
    }
    function d3_time_parseDayOfYear(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 3));
      return n ? (date.j = +n[0], i + n[0].length) : -1;
    }
    function d3_time_parseHour24(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 2));
      return n ? (date.H = +n[0], i + n[0].length) : -1;
    }
    function d3_time_parseMinutes(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 2));
      return n ? (date.M = +n[0], i + n[0].length) : -1;
    }
    function d3_time_parseSeconds(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 2));
      return n ? (date.S = +n[0], i + n[0].length) : -1;
    }
    function d3_time_parseMilliseconds(date, string, i) {
      d3_time_numberRe.lastIndex = 0;
      var n = d3_time_numberRe.exec(string.slice(i, i + 3));
      return n ? (date.L = +n[0], i + n[0].length) : -1;
    }
    function d3_time_zone(d) {
      var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
      return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
    }
    function d3_time_parseLiteralPercent(date, string, i) {
      d3_time_percentRe.lastIndex = 0;
      var n = d3_time_percentRe.exec(string.slice(i, i + 1));
      return n ? i + n[0].length : -1;
    }
    function d3_time_formatMulti(formats) {
      var n = formats.length, i = -1;
      while (++i < n) formats[i][0] = this(formats[i][0]);
      return function(date) {
        var i = 0, f = formats[i];
        while (!f[1](date)) f = formats[++i];
        return f[0](date);
      };
    }
    d3.locale = function(locale) {
      return {
        numberFormat: d3_locale_numberFormat(locale),
        timeFormat: d3_locale_timeFormat(locale)
      };
    };
    var d3_locale_enUS = d3.locale({
      decimal: ".",
      thousands: ",",
      grouping: [ 3 ],
      currency: [ "$", "" ],
      dateTime: "%a %b %e %X %Y",
      date: "%m/%d/%Y",
      time: "%H:%M:%S",
      periods: [ "AM", "PM" ],
      days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
      shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
      months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
      shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
    });
    d3.format = d3_locale_enUS.numberFormat;
    d3.geo = {};
    function d3_adder() {}
    d3_adder.prototype = {
      s: 0,
      t: 0,
      add: function(y) {
        d3_adderSum(y, this.t, d3_adderTemp);
        d3_adderSum(d3_adderTemp.s, this.s, this);
        if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
      },
      reset: function() {
        this.s = this.t = 0;
      },
      valueOf: function() {
        return this.s;
      }
    };
    var d3_adderTemp = new d3_adder();
    function d3_adderSum(a, b, o) {
      var x = o.s = a + b, bv = x - a, av = x - bv;
      o.t = a - av + (b - bv);
    }
    d3.geo.stream = function(object, listener) {
      if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
        d3_geo_streamObjectType[object.type](object, listener);
      } else {
        d3_geo_streamGeometry(object, listener);
      }
    };
    function d3_geo_streamGeometry(geometry, listener) {
      if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
        d3_geo_streamGeometryType[geometry.type](geometry, listener);
      }
    }
    var d3_geo_streamObjectType = {
      Feature: function(feature, listener) {
        d3_geo_streamGeometry(feature.geometry, listener);
      },
      FeatureCollection: function(object, listener) {
        var features = object.features, i = -1, n = features.length;
        while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
      }
    };
    var d3_geo_streamGeometryType = {
      Sphere: function(object, listener) {
        listener.sphere();
      },
      Point: function(object, listener) {
        object = object.coordinates;
        listener.point(object[0], object[1], object[2]);
      },
      MultiPoint: function(object, listener) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
      },
      LineString: function(object, listener) {
        d3_geo_streamLine(object.coordinates, listener, 0);
      },
      MultiLineString: function(object, listener) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
      },
      Polygon: function(object, listener) {
        d3_geo_streamPolygon(object.coordinates, listener);
      },
      MultiPolygon: function(object, listener) {
        var coordinates = object.coordinates, i = -1, n = coordinates.length;
        while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
      },
      GeometryCollection: function(object, listener) {
        var geometries = object.geometries, i = -1, n = geometries.length;
        while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
      }
    };
    function d3_geo_streamLine(coordinates, listener, closed) {
      var i = -1, n = coordinates.length - closed, coordinate;
      listener.lineStart();
      while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
      listener.lineEnd();
    }
    function d3_geo_streamPolygon(coordinates, listener) {
      var i = -1, n = coordinates.length;
      listener.polygonStart();
      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
      listener.polygonEnd();
    }
    d3.geo.area = function(object) {
      d3_geo_areaSum = 0;
      d3.geo.stream(object, d3_geo_area);
      return d3_geo_areaSum;
    };
    var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
    var d3_geo_area = {
      sphere: function() {
        d3_geo_areaSum += 4 * π;
      },
      point: d3_noop,
      lineStart: d3_noop,
      lineEnd: d3_noop,
      polygonStart: function() {
        d3_geo_areaRingSum.reset();
        d3_geo_area.lineStart = d3_geo_areaRingStart;
      },
      polygonEnd: function() {
        var area = 2 * d3_geo_areaRingSum;
        d3_geo_areaSum += area < 0 ? 4 * π + area : area;
        d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
      }
    };
    function d3_geo_areaRingStart() {
      var λ00, φ00, λ0, cosφ0, sinφ0;
      d3_geo_area.point = function(λ, φ) {
        d3_geo_area.point = nextPoint;
        λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
        sinφ0 = Math.sin(φ);
      };
      function nextPoint(λ, φ) {
        λ *= d3_radians;
        φ = φ * d3_radians / 2 + π / 4;
        var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
        d3_geo_areaRingSum.add(Math.atan2(v, u));
        λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
      }
      d3_geo_area.lineEnd = function() {
        nextPoint(λ00, φ00);
      };
    }
    function d3_geo_cartesian(spherical) {
      var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
      return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
    }
    function d3_geo_cartesianDot(a, b) {
      return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
    }
    function d3_geo_cartesianCross(a, b) {
      return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
    }
    function d3_geo_cartesianAdd(a, b) {
      a[0] += b[0];
      a[1] += b[1];
      a[2] += b[2];
    }
    function d3_geo_cartesianScale(vector, k) {
      return [ vector[0] * k, vector[1] * k, vector[2] * k ];
    }
    function d3_geo_cartesianNormalize(d) {
      var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
      d[0] /= l;
      d[1] /= l;
      d[2] /= l;
    }
    function d3_geo_spherical(cartesian) {
      return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
    }
    function d3_geo_sphericalEqual(a, b) {
      return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
    }
    d3.geo.bounds = function() {
      var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
      var bound = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          bound.point = ringPoint;
          bound.lineStart = ringStart;
          bound.lineEnd = ringEnd;
          dλSum = 0;
          d3_geo_area.polygonStart();
        },
        polygonEnd: function() {
          d3_geo_area.polygonEnd();
          bound.point = point;
          bound.lineStart = lineStart;
          bound.lineEnd = lineEnd;
          if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
          range[0] = λ0, range[1] = λ1;
        }
      };
      function point(λ, φ) {
        ranges.push(range = [ λ0 = λ, λ1 = λ ]);
        if (φ < φ0) φ0 = φ;
        if (φ > φ1) φ1 = φ;
      }
      function linePoint(λ, φ) {
        var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
        if (p0) {
          var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
          d3_geo_cartesianNormalize(inflection);
          inflection = d3_geo_spherical(inflection);
          var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
          if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
            var φi = inflection[1] * d3_degrees;
            if (φi > φ1) φ1 = φi;
          } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
            var φi = -inflection[1] * d3_degrees;
            if (φi < φ0) φ0 = φi;
          } else {
            if (φ < φ0) φ0 = φ;
            if (φ > φ1) φ1 = φ;
          }
          if (antimeridian) {
            if (λ < λ_) {
              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
            } else {
              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
            }
          } else {
            if (λ1 >= λ0) {
              if (λ < λ0) λ0 = λ;
              if (λ > λ1) λ1 = λ;
            } else {
              if (λ > λ_) {
                if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
              } else {
                if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
              }
            }
          }
        } else {
          point(λ, φ);
        }
        p0 = p, λ_ = λ;
      }
      function lineStart() {
        bound.point = linePoint;
      }
      function lineEnd() {
        range[0] = λ0, range[1] = λ1;
        bound.point = point;
        p0 = null;
      }
      function ringPoint(λ, φ) {
        if (p0) {
          var dλ = λ - λ_;
          dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
        } else λ__ = λ, φ__ = φ;
        d3_geo_area.point(λ, φ);
        linePoint(λ, φ);
      }
      function ringStart() {
        d3_geo_area.lineStart();
      }
      function ringEnd() {
        ringPoint(λ__, φ__);
        d3_geo_area.lineEnd();
        if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
        range[0] = λ0, range[1] = λ1;
        p0 = null;
      }
      function angle(λ0, λ1) {
        return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
      }
      function compareRanges(a, b) {
        return a[0] - b[0];
      }
      function withinRange(x, range) {
        return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
      }
      return function(feature) {
        φ1 = λ1 = -(λ0 = φ0 = Infinity);
        ranges = [];
        d3.geo.stream(feature, bound);
        var n = ranges.length;
        if (n) {
          ranges.sort(compareRanges);
          for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
            b = ranges[i];
            if (withinRange(b[0], a) || withinRange(b[1], a)) {
              if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
              if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
            } else {
              merged.push(a = b);
            }
          }
          var best = -Infinity, dλ;
          for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
            b = merged[i];
            if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
          }
        }
        ranges = range = null;
        return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
      };
    }();
    d3.geo.centroid = function(object) {
      d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
      d3.geo.stream(object, d3_geo_centroid);
      var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
      if (m < ε2) {
        x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
        if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
        m = x * x + y * y + z * z;
        if (m < ε2) return [ NaN, NaN ];
      }
      return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
    };
    var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
    var d3_geo_centroid = {
      sphere: d3_noop,
      point: d3_geo_centroidPoint,
      lineStart: d3_geo_centroidLineStart,
      lineEnd: d3_geo_centroidLineEnd,
      polygonStart: function() {
        d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
      },
      polygonEnd: function() {
        d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
      }
    };
    function d3_geo_centroidPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
    }
    function d3_geo_centroidPointXYZ(x, y, z) {
      ++d3_geo_centroidW0;
      d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
      d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
      d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
    }
    function d3_geo_centroidLineStart() {
      var x0, y0, z0;
      d3_geo_centroid.point = function(λ, φ) {
        λ *= d3_radians;
        var cosφ = Math.cos(φ *= d3_radians);
        x0 = cosφ * Math.cos(λ);
        y0 = cosφ * Math.sin(λ);
        z0 = Math.sin(φ);
        d3_geo_centroid.point = nextPoint;
        d3_geo_centroidPointXYZ(x0, y0, z0);
      };
      function nextPoint(λ, φ) {
        λ *= d3_radians;
        var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
        d3_geo_centroidW1 += w;
        d3_geo_centroidX1 += w * (x0 + (x0 = x));
        d3_geo_centroidY1 += w * (y0 + (y0 = y));
        d3_geo_centroidZ1 += w * (z0 + (z0 = z));
        d3_geo_centroidPointXYZ(x0, y0, z0);
      }
    }
    function d3_geo_centroidLineEnd() {
      d3_geo_centroid.point = d3_geo_centroidPoint;
    }
    function d3_geo_centroidRingStart() {
      var λ00, φ00, x0, y0, z0;
      d3_geo_centroid.point = function(λ, φ) {
        λ00 = λ, φ00 = φ;
        d3_geo_centroid.point = nextPoint;
        λ *= d3_radians;
        var cosφ = Math.cos(φ *= d3_radians);
        x0 = cosφ * Math.cos(λ);
        y0 = cosφ * Math.sin(λ);
        z0 = Math.sin(φ);
        d3_geo_centroidPointXYZ(x0, y0, z0);
      };
      d3_geo_centroid.lineEnd = function() {
        nextPoint(λ00, φ00);
        d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
        d3_geo_centroid.point = d3_geo_centroidPoint;
      };
      function nextPoint(λ, φ) {
        λ *= d3_radians;
        var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
        d3_geo_centroidX2 += v * cx;
        d3_geo_centroidY2 += v * cy;
        d3_geo_centroidZ2 += v * cz;
        d3_geo_centroidW1 += w;
        d3_geo_centroidX1 += w * (x0 + (x0 = x));
        d3_geo_centroidY1 += w * (y0 + (y0 = y));
        d3_geo_centroidZ1 += w * (z0 + (z0 = z));
        d3_geo_centroidPointXYZ(x0, y0, z0);
      }
    }
    function d3_geo_compose(a, b) {
      function compose(x, y) {
        return x = a(x, y), b(x[0], x[1]);
      }
      if (a.invert && b.invert) compose.invert = function(x, y) {
        return x = b.invert(x, y), x && a.invert(x[0], x[1]);
      };
      return compose;
    }
    function d3_true() {
      return true;
    }
    function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
      var subject = [], clip = [];
      segments.forEach(function(segment) {
        if ((n = segment.length - 1) <= 0) return;
        var n, p0 = segment[0], p1 = segment[n];
        if (d3_geo_sphericalEqual(p0, p1)) {
          listener.lineStart();
          for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
          listener.lineEnd();
          return;
        }
        var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
        a.o = b;
        subject.push(a);
        clip.push(b);
        a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
        b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
        a.o = b;
        subject.push(a);
        clip.push(b);
      });
      clip.sort(compare);
      d3_geo_clipPolygonLinkCircular(subject);
      d3_geo_clipPolygonLinkCircular(clip);
      if (!subject.length) return;
      for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
        clip[i].e = entry = !entry;
      }
      var start = subject[0], points, point;
      while (1) {
        var current = start, isSubject = true;
        while (current.v) if ((current = current.n) === start) return;
        points = current.z;
        listener.lineStart();
        do {
          current.v = current.o.v = true;
          if (current.e) {
            if (isSubject) {
              for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
            } else {
              interpolate(current.x, current.n.x, 1, listener);
            }
            current = current.n;
          } else {
            if (isSubject) {
              points = current.p.z;
              for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
            } else {
              interpolate(current.x, current.p.x, -1, listener);
            }
            current = current.p;
          }
          current = current.o;
          points = current.z;
          isSubject = !isSubject;
        } while (!current.v);
        listener.lineEnd();
      }
    }
    function d3_geo_clipPolygonLinkCircular(array) {
      if (!(n = array.length)) return;
      var n, i = 0, a = array[0], b;
      while (++i < n) {
        a.n = b = array[i];
        b.p = a;
        a = b;
      }
      a.n = b = array[0];
      b.p = a;
    }
    function d3_geo_clipPolygonIntersection(point, points, other, entry) {
      this.x = point;
      this.z = points;
      this.o = other;
      this.e = entry;
      this.v = false;
      this.n = this.p = null;
    }
    function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
      return function(rotate, listener) {
        var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
        var clip = {
          point: point,
          lineStart: lineStart,
          lineEnd: lineEnd,
          polygonStart: function() {
            clip.point = pointRing;
            clip.lineStart = ringStart;
            clip.lineEnd = ringEnd;
            segments = [];
            polygon = [];
          },
          polygonEnd: function() {
            clip.point = point;
            clip.lineStart = lineStart;
            clip.lineEnd = lineEnd;
            segments = d3.merge(segments);
            var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
            if (segments.length) {
              if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
              d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
            } else if (clipStartInside) {
              if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
            }
            if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
            segments = polygon = null;
          },
          sphere: function() {
            listener.polygonStart();
            listener.lineStart();
            interpolate(null, null, 1, listener);
            listener.lineEnd();
            listener.polygonEnd();
          }
        };
        function point(λ, φ) {
          var point = rotate(λ, φ);
          if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
        }
        function pointLine(λ, φ) {
          var point = rotate(λ, φ);
          line.point(point[0], point[1]);
        }
        function lineStart() {
          clip.point = pointLine;
          line.lineStart();
        }
        function lineEnd() {
          clip.point = point;
          line.lineEnd();
        }
        var segments;
        var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
        function pointRing(λ, φ) {
          ring.push([ λ, φ ]);
          var point = rotate(λ, φ);
          ringListener.point(point[0], point[1]);
        }
        function ringStart() {
          ringListener.lineStart();
          ring = [];
        }
        function ringEnd() {
          pointRing(ring[0][0], ring[0][1]);
          ringListener.lineEnd();
          var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
          ring.pop();
          polygon.push(ring);
          ring = null;
          if (!n) return;
          if (clean & 1) {
            segment = ringSegments[0];
            var n = segment.length - 1, i = -1, point;
            if (n > 0) {
              if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
              listener.lineStart();
              while (++i < n) listener.point((point = segment[i])[0], point[1]);
              listener.lineEnd();
            }
            return;
          }
          if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
          segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
        }
        return clip;
      };
    }
    function d3_geo_clipSegmentLength1(segment) {
      return segment.length > 1;
    }
    function d3_geo_clipBufferListener() {
      var lines = [], line;
      return {
        lineStart: function() {
          lines.push(line = []);
        },
        point: function(λ, φ) {
          line.push([ λ, φ ]);
        },
        lineEnd: d3_noop,
        buffer: function() {
          var buffer = lines;
          lines = [];
          line = null;
          return buffer;
        },
        rejoin: function() {
          if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
        }
      };
    }
    function d3_geo_clipSort(a, b) {
      return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
    }
    var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
    function d3_geo_clipAntimeridianLine(listener) {
      var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
      return {
        lineStart: function() {
          listener.lineStart();
          clean = 1;
        },
        point: function(λ1, φ1) {
          var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
          if (abs(dλ - π) < ε) {
            listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
            listener.point(sλ0, φ0);
            listener.lineEnd();
            listener.lineStart();
            listener.point(sλ1, φ0);
            listener.point(λ1, φ0);
            clean = 0;
          } else if (sλ0 !== sλ1 && dλ >= π) {
            if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
            if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
            φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
            listener.point(sλ0, φ0);
            listener.lineEnd();
            listener.lineStart();
            listener.point(sλ1, φ0);
            clean = 0;
          }
          listener.point(λ0 = λ1, φ0 = φ1);
          sλ0 = sλ1;
        },
        lineEnd: function() {
          listener.lineEnd();
          λ0 = φ0 = NaN;
        },
        clean: function() {
          return 2 - clean;
        }
      };
    }
    function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
      var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
      return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
    }
    function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
      var φ;
      if (from == null) {
        φ = direction * halfπ;
        listener.point(-π, φ);
        listener.point(0, φ);
        listener.point(π, φ);
        listener.point(π, 0);
        listener.point(π, -φ);
        listener.point(0, -φ);
        listener.point(-π, -φ);
        listener.point(-π, 0);
        listener.point(-π, φ);
      } else if (abs(from[0] - to[0]) > ε) {
        var s = from[0] < to[0] ? π : -π;
        φ = direction * s / 2;
        listener.point(-s, φ);
        listener.point(0, φ);
        listener.point(s, φ);
      } else {
        listener.point(to[0], to[1]);
      }
    }
    function d3_geo_pointInPolygon(point, polygon) {
      var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
      d3_geo_areaRingSum.reset();
      for (var i = 0, n = polygon.length; i < n; ++i) {
        var ring = polygon[i], m = ring.length;
        if (!m) continue;
        var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
        while (true) {
          if (j === m) j = 0;
          point = ring[j];
          var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
          d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
          polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
          if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
            var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
            d3_geo_cartesianNormalize(arc);
            var intersection = d3_geo_cartesianCross(meridianNormal, arc);
            d3_geo_cartesianNormalize(intersection);
            var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
            if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
              winding += antimeridian ^ dλ >= 0 ? 1 : -1;
            }
          }
          if (!j++) break;
          λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
        }
      }
      return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
    }
    function d3_geo_clipCircle(radius) {
      var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
      return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
      function visible(λ, φ) {
        return Math.cos(λ) * Math.cos(φ) > cr;
      }
      function clipLine(listener) {
        var point0, c0, v0, v00, clean;
        return {
          lineStart: function() {
            v00 = v0 = false;
            clean = 1;
          },
          point: function(λ, φ) {
            var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
            if (!point0 && (v00 = v0 = v)) listener.lineStart();
            if (v !== v0) {
              point2 = intersect(point0, point1);
              if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
                point1[0] += ε;
                point1[1] += ε;
                v = visible(point1[0], point1[1]);
              }
            }
            if (v !== v0) {
              clean = 0;
              if (v) {
                listener.lineStart();
                point2 = intersect(point1, point0);
                listener.point(point2[0], point2[1]);
              } else {
                point2 = intersect(point0, point1);
                listener.point(point2[0], point2[1]);
                listener.lineEnd();
              }
              point0 = point2;
            } else if (notHemisphere && point0 && smallRadius ^ v) {
              var t;
              if (!(c & c0) && (t = intersect(point1, point0, true))) {
                clean = 0;
                if (smallRadius) {
                  listener.lineStart();
                  listener.point(t[0][0], t[0][1]);
                  listener.point(t[1][0], t[1][1]);
                  listener.lineEnd();
                } else {
                  listener.point(t[1][0], t[1][1]);
                  listener.lineEnd();
                  listener.lineStart();
                  listener.point(t[0][0], t[0][1]);
                }
              }
            }
            if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
              listener.point(point1[0], point1[1]);
            }
            point0 = point1, v0 = v, c0 = c;
          },
          lineEnd: function() {
            if (v0) listener.lineEnd();
            point0 = null;
          },
          clean: function() {
            return clean | (v00 && v0) << 1;
          }
        };
      }
      function intersect(a, b, two) {
        var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
        var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
        if (!determinant) return !two && a;
        var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
        d3_geo_cartesianAdd(A, B);
        var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
        if (t2 < 0) return;
        var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
        d3_geo_cartesianAdd(q, A);
        q = d3_geo_spherical(q);
        if (!two) return q;
        var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
        if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
        var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
        if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
        if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
          var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
          d3_geo_cartesianAdd(q1, A);
          return [ q, d3_geo_spherical(q1) ];
        }
      }
      function code(λ, φ) {
        var r = smallRadius ? radius : π - radius, code = 0;
        if (λ < -r) code |= 1; else if (λ > r) code |= 2;
        if (φ < -r) code |= 4; else if (φ > r) code |= 8;
        return code;
      }
    }
    function d3_geom_clipLine(x0, y0, x1, y1) {
      return function(line) {
        var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
        r = x0 - ax;
        if (!dx && r > 0) return;
        r /= dx;
        if (dx < 0) {
          if (r < t0) return;
          if (r < t1) t1 = r;
        } else if (dx > 0) {
          if (r > t1) return;
          if (r > t0) t0 = r;
        }
        r = x1 - ax;
        if (!dx && r < 0) return;
        r /= dx;
        if (dx < 0) {
          if (r > t1) return;
          if (r > t0) t0 = r;
        } else if (dx > 0) {
          if (r < t0) return;
          if (r < t1) t1 = r;
        }
        r = y0 - ay;
        if (!dy && r > 0) return;
        r /= dy;
        if (dy < 0) {
          if (r < t0) return;
          if (r < t1) t1 = r;
        } else if (dy > 0) {
          if (r > t1) return;
          if (r > t0) t0 = r;
        }
        r = y1 - ay;
        if (!dy && r < 0) return;
        r /= dy;
        if (dy < 0) {
          if (r > t1) return;
          if (r > t0) t0 = r;
        } else if (dy > 0) {
          if (r < t0) return;
          if (r < t1) t1 = r;
        }
        if (t0 > 0) line.a = {
          x: ax + t0 * dx,
          y: ay + t0 * dy
        };
        if (t1 < 1) line.b = {
          x: ax + t1 * dx,
          y: ay + t1 * dy
        };
        return line;
      };
    }
    var d3_geo_clipExtentMAX = 1e9;
    d3.geo.clipExtent = function() {
      var x0, y0, x1, y1, stream, clip, clipExtent = {
        stream: function(output) {
          if (stream) stream.valid = false;
          stream = clip(output);
          stream.valid = true;
          return stream;
        },
        extent: function(_) {
          if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
          clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
          if (stream) stream.valid = false, stream = null;
          return clipExtent;
        }
      };
      return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
    };
    function d3_geo_clipExtent(x0, y0, x1, y1) {
      return function(listener) {
        var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
        var clip = {
          point: point,
          lineStart: lineStart,
          lineEnd: lineEnd,
          polygonStart: function() {
            listener = bufferListener;
            segments = [];
            polygon = [];
            clean = true;
          },
          polygonEnd: function() {
            listener = listener_;
            segments = d3.merge(segments);
            var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
            if (inside || visible) {
              listener.polygonStart();
              if (inside) {
                listener.lineStart();
                interpolate(null, null, 1, listener);
                listener.lineEnd();
              }
              if (visible) {
                d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
              }
              listener.polygonEnd();
            }
            segments = polygon = ring = null;
          }
        };
        function insidePolygon(p) {
          var wn = 0, n = polygon.length, y = p[1];
          for (var i = 0; i < n; ++i) {
            for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
              b = v[j];
              if (a[1] <= y) {
                if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
              } else {
                if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
              }
              a = b;
            }
          }
          return wn !== 0;
        }
        function interpolate(from, to, direction, listener) {
          var a = 0, a1 = 0;
          if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
            do {
              listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
            } while ((a = (a + direction + 4) % 4) !== a1);
          } else {
            listener.point(to[0], to[1]);
          }
        }
        function pointVisible(x, y) {
          return x0 <= x && x <= x1 && y0 <= y && y <= y1;
        }
        function point(x, y) {
          if (pointVisible(x, y)) listener.point(x, y);
        }
        var x__, y__, v__, x_, y_, v_, first, clean;
        function lineStart() {
          clip.point = linePoint;
          if (polygon) polygon.push(ring = []);
          first = true;
          v_ = false;
          x_ = y_ = NaN;
        }
        function lineEnd() {
          if (segments) {
            linePoint(x__, y__);
            if (v__ && v_) bufferListener.rejoin();
            segments.push(bufferListener.buffer());
          }
          clip.point = point;
          if (v_) listener.lineEnd();
        }
        function linePoint(x, y) {
          x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
          y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
          var v = pointVisible(x, y);
          if (polygon) ring.push([ x, y ]);
          if (first) {
            x__ = x, y__ = y, v__ = v;
            first = false;
            if (v) {
              listener.lineStart();
              listener.point(x, y);
            }
          } else {
            if (v && v_) listener.point(x, y); else {
              var l = {
                a: {
                  x: x_,
                  y: y_
                },
                b: {
                  x: x,
                  y: y
                }
              };
              if (clipLine(l)) {
                if (!v_) {
                  listener.lineStart();
                  listener.point(l.a.x, l.a.y);
                }
                listener.point(l.b.x, l.b.y);
                if (!v) listener.lineEnd();
                clean = false;
              } else if (v) {
                listener.lineStart();
                listener.point(x, y);
                clean = false;
              }
            }
          }
          x_ = x, y_ = y, v_ = v;
        }
        return clip;
      };
      function corner(p, direction) {
        return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
      }
      function compare(a, b) {
        return comparePoints(a.x, b.x);
      }
      function comparePoints(a, b) {
        var ca = corner(a, 1), cb = corner(b, 1);
        return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
      }
    }
    function d3_geo_conic(projectAt) {
      var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
      p.parallels = function(_) {
        if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
        return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
      };
      return p;
    }
    function d3_geo_conicEqualArea(φ0, φ1) {
      var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
      function forward(λ, φ) {
        var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
        return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
      }
      forward.invert = function(x, y) {
        var ρ0_y = ρ0 - y;
        return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
      };
      return forward;
    }
    (d3.geo.conicEqualArea = function() {
      return d3_geo_conic(d3_geo_conicEqualArea);
    }).raw = d3_geo_conicEqualArea;
    d3.geo.albers = function() {
      return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
    };
    d3.geo.albersUsa = function() {
      var lower48 = d3.geo.albers();
      var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
      var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
      var point, pointStream = {
        point: function(x, y) {
          point = [ x, y ];
        }
      }, lower48Point, alaskaPoint, hawaiiPoint;
      function albersUsa(coordinates) {
        var x = coordinates[0], y = coordinates[1];
        point = null;
        (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
        return point;
      }
      albersUsa.invert = function(coordinates) {
        var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
        return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
      };
      albersUsa.stream = function(stream) {
        var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
        return {
          point: function(x, y) {
            lower48Stream.point(x, y);
            alaskaStream.point(x, y);
            hawaiiStream.point(x, y);
          },
          sphere: function() {
            lower48Stream.sphere();
            alaskaStream.sphere();
            hawaiiStream.sphere();
          },
          lineStart: function() {
            lower48Stream.lineStart();
            alaskaStream.lineStart();
            hawaiiStream.lineStart();
          },
          lineEnd: function() {
            lower48Stream.lineEnd();
            alaskaStream.lineEnd();
            hawaiiStream.lineEnd();
          },
          polygonStart: function() {
            lower48Stream.polygonStart();
            alaskaStream.polygonStart();
            hawaiiStream.polygonStart();
          },
          polygonEnd: function() {
            lower48Stream.polygonEnd();
            alaskaStream.polygonEnd();
            hawaiiStream.polygonEnd();
          }
        };
      };
      albersUsa.precision = function(_) {
        if (!arguments.length) return lower48.precision();
        lower48.precision(_);
        alaska.precision(_);
        hawaii.precision(_);
        return albersUsa;
      };
      albersUsa.scale = function(_) {
        if (!arguments.length) return lower48.scale();
        lower48.scale(_);
        alaska.scale(_ * .35);
        hawaii.scale(_);
        return albersUsa.translate(lower48.translate());
      };
      albersUsa.translate = function(_) {
        if (!arguments.length) return lower48.translate();
        var k = lower48.scale(), x = +_[0], y = +_[1];
        lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
        alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
        hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
        return albersUsa;
      };
      return albersUsa.scale(1070);
    };
    var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
      point: d3_noop,
      lineStart: d3_noop,
      lineEnd: d3_noop,
      polygonStart: function() {
        d3_geo_pathAreaPolygon = 0;
        d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
      },
      polygonEnd: function() {
        d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
        d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
      }
    };
    function d3_geo_pathAreaRingStart() {
      var x00, y00, x0, y0;
      d3_geo_pathArea.point = function(x, y) {
        d3_geo_pathArea.point = nextPoint;
        x00 = x0 = x, y00 = y0 = y;
      };
      function nextPoint(x, y) {
        d3_geo_pathAreaPolygon += y0 * x - x0 * y;
        x0 = x, y0 = y;
      }
      d3_geo_pathArea.lineEnd = function() {
        nextPoint(x00, y00);
      };
    }
    var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
    var d3_geo_pathBounds = {
      point: d3_geo_pathBoundsPoint,
      lineStart: d3_noop,
      lineEnd: d3_noop,
      polygonStart: d3_noop,
      polygonEnd: d3_noop
    };
    function d3_geo_pathBoundsPoint(x, y) {
      if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
      if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
      if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
      if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
    }
    function d3_geo_pathBuffer() {
      var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
      var stream = {
        point: point,
        lineStart: function() {
          stream.point = pointLineStart;
        },
        lineEnd: lineEnd,
        polygonStart: function() {
          stream.lineEnd = lineEndPolygon;
        },
        polygonEnd: function() {
          stream.lineEnd = lineEnd;
          stream.point = point;
        },
        pointRadius: function(_) {
          pointCircle = d3_geo_pathBufferCircle(_);
          return stream;
        },
        result: function() {
          if (buffer.length) {
            var result = buffer.join("");
            buffer = [];
            return result;
          }
        }
      };
      function point(x, y) {
        buffer.push("M", x, ",", y, pointCircle);
      }
      function pointLineStart(x, y) {
        buffer.push("M", x, ",", y);
        stream.point = pointLine;
      }
      function pointLine(x, y) {
        buffer.push("L", x, ",", y);
      }
      function lineEnd() {
        stream.point = point;
      }
      function lineEndPolygon() {
        buffer.push("Z");
      }
      return stream;
    }
    function d3_geo_pathBufferCircle(radius) {
      return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
    }
    var d3_geo_pathCentroid = {
      point: d3_geo_pathCentroidPoint,
      lineStart: d3_geo_pathCentroidLineStart,
      lineEnd: d3_geo_pathCentroidLineEnd,
      polygonStart: function() {
        d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
      },
      polygonEnd: function() {
        d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
        d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
        d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
      }
    };
    function d3_geo_pathCentroidPoint(x, y) {
      d3_geo_centroidX0 += x;
      d3_geo_centroidY0 += y;
      ++d3_geo_centroidZ0;
    }
    function d3_geo_pathCentroidLineStart() {
      var x0, y0;
      d3_geo_pathCentroid.point = function(x, y) {
        d3_geo_pathCentroid.point = nextPoint;
        d3_geo_pathCentroidPoint(x0 = x, y0 = y);
      };
      function nextPoint(x, y) {
        var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
        d3_geo_centroidX1 += z * (x0 + x) / 2;
        d3_geo_centroidY1 += z * (y0 + y) / 2;
        d3_geo_centroidZ1 += z;
        d3_geo_pathCentroidPoint(x0 = x, y0 = y);
      }
    }
    function d3_geo_pathCentroidLineEnd() {
      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
    }
    function d3_geo_pathCentroidRingStart() {
      var x00, y00, x0, y0;
      d3_geo_pathCentroid.point = function(x, y) {
        d3_geo_pathCentroid.point = nextPoint;
        d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
      };
      function nextPoint(x, y) {
        var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
        d3_geo_centroidX1 += z * (x0 + x) / 2;
        d3_geo_centroidY1 += z * (y0 + y) / 2;
        d3_geo_centroidZ1 += z;
        z = y0 * x - x0 * y;
        d3_geo_centroidX2 += z * (x0 + x);
        d3_geo_centroidY2 += z * (y0 + y);
        d3_geo_centroidZ2 += z * 3;
        d3_geo_pathCentroidPoint(x0 = x, y0 = y);
      }
      d3_geo_pathCentroid.lineEnd = function() {
        nextPoint(x00, y00);
      };
    }
    function d3_geo_pathContext(context) {
      var pointRadius = 4.5;
      var stream = {
        point: point,
        lineStart: function() {
          stream.point = pointLineStart;
        },
        lineEnd: lineEnd,
        polygonStart: function() {
          stream.lineEnd = lineEndPolygon;
        },
        polygonEnd: function() {
          stream.lineEnd = lineEnd;
          stream.point = point;
        },
        pointRadius: function(_) {
          pointRadius = _;
          return stream;
        },
        result: d3_noop
      };
      function point(x, y) {
        context.moveTo(x + pointRadius, y);
        context.arc(x, y, pointRadius, 0, τ);
      }
      function pointLineStart(x, y) {
        context.moveTo(x, y);
        stream.point = pointLine;
      }
      function pointLine(x, y) {
        context.lineTo(x, y);
      }
      function lineEnd() {
        stream.point = point;
      }
      function lineEndPolygon() {
        context.closePath();
      }
      return stream;
    }
    function d3_geo_resample(project) {
      var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
      function resample(stream) {
        return (maxDepth ? resampleRecursive : resampleNone)(stream);
      }
      function resampleNone(stream) {
        return d3_geo_transformPoint(stream, function(x, y) {
          x = project(x, y);
          stream.point(x[0], x[1]);
        });
      }
      function resampleRecursive(stream) {
        var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
        var resample = {
          point: point,
          lineStart: lineStart,
          lineEnd: lineEnd,
          polygonStart: function() {
            stream.polygonStart();
            resample.lineStart = ringStart;
          },
          polygonEnd: function() {
            stream.polygonEnd();
            resample.lineStart = lineStart;
          }
        };
        function point(x, y) {
          x = project(x, y);
          stream.point(x[0], x[1]);
        }
        function lineStart() {
          x0 = NaN;
          resample.point = linePoint;
          stream.lineStart();
        }
        function linePoint(λ, φ) {
          var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
          stream.point(x0, y0);
        }
        function lineEnd() {
          resample.point = point;
          stream.lineEnd();
        }
        function ringStart() {
          lineStart();
          resample.point = ringPoint;
          resample.lineEnd = ringEnd;
        }
        function ringPoint(λ, φ) {
          linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
          resample.point = linePoint;
        }
        function ringEnd() {
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
          resample.lineEnd = lineEnd;
          lineEnd();
        }
        return resample;
      }
      function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
        var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
        if (d2 > 4 * δ2 && depth--) {
          var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
          if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
            resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
            stream.point(x2, y2);
            resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
          }
        }
      }
      resample.precision = function(_) {
        if (!arguments.length) return Math.sqrt(δ2);
        maxDepth = (δ2 = _ * _) > 0 && 16;
        return resample;
      };
      return resample;
    }
    d3.geo.path = function() {
      var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
      function path(object) {
        if (object) {
          if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
          if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
          d3.geo.stream(object, cacheStream);
        }
        return contextStream.result();
      }
      path.area = function(object) {
        d3_geo_pathAreaSum = 0;
        d3.geo.stream(object, projectStream(d3_geo_pathArea));
        return d3_geo_pathAreaSum;
      };
      path.centroid = function(object) {
        d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
        d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
        return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
      };
      path.bounds = function(object) {
        d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
        d3.geo.stream(object, projectStream(d3_geo_pathBounds));
        return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
      };
      path.projection = function(_) {
        if (!arguments.length) return projection;
        projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
        return reset();
      };
      path.context = function(_) {
        if (!arguments.length) return context;
        contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
        if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
        return reset();
      };
      path.pointRadius = function(_) {
        if (!arguments.length) return pointRadius;
        pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
        return path;
      };
      function reset() {
        cacheStream = null;
        return path;
      }
      return path.projection(d3.geo.albersUsa()).context(null);
    };
    function d3_geo_pathProjectStream(project) {
      var resample = d3_geo_resample(function(x, y) {
        return project([ x * d3_degrees, y * d3_degrees ]);
      });
      return function(stream) {
        return d3_geo_projectionRadians(resample(stream));
      };
    }
    d3.geo.transform = function(methods) {
      return {
        stream: function(stream) {
          var transform = new d3_geo_transform(stream);
          for (var k in methods) transform[k] = methods[k];
          return transform;
        }
      };
    };
    function d3_geo_transform(stream) {
      this.stream = stream;
    }
    d3_geo_transform.prototype = {
      point: function(x, y) {
        this.stream.point(x, y);
      },
      sphere: function() {
        this.stream.sphere();
      },
      lineStart: function() {
        this.stream.lineStart();
      },
      lineEnd: function() {
        this.stream.lineEnd();
      },
      polygonStart: function() {
        this.stream.polygonStart();
      },
      polygonEnd: function() {
        this.stream.polygonEnd();
      }
    };
    function d3_geo_transformPoint(stream, point) {
      return {
        point: point,
        sphere: function() {
          stream.sphere();
        },
        lineStart: function() {
          stream.lineStart();
        },
        lineEnd: function() {
          stream.lineEnd();
        },
        polygonStart: function() {
          stream.polygonStart();
        },
        polygonEnd: function() {
          stream.polygonEnd();
        }
      };
    }
    d3.geo.projection = d3_geo_projection;
    d3.geo.projectionMutator = d3_geo_projectionMutator;
    function d3_geo_projection(project) {
      return d3_geo_projectionMutator(function() {
        return project;
      })();
    }
    function d3_geo_projectionMutator(projectAt) {
      var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
        x = project(x, y);
        return [ x[0] * k + δx, δy - x[1] * k ];
      }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
      function projection(point) {
        point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
        return [ point[0] * k + δx, δy - point[1] * k ];
      }
      function invert(point) {
        point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
        return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
      }
      projection.stream = function(output) {
        if (stream) stream.valid = false;
        stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
        stream.valid = true;
        return stream;
      };
      projection.clipAngle = function(_) {
        if (!arguments.length) return clipAngle;
        preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
        return invalidate();
      };
      projection.clipExtent = function(_) {
        if (!arguments.length) return clipExtent;
        clipExtent = _;
        postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
        return invalidate();
      };
      projection.scale = function(_) {
        if (!arguments.length) return k;
        k = +_;
        return reset();
      };
      projection.translate = function(_) {
        if (!arguments.length) return [ x, y ];
        x = +_[0];
        y = +_[1];
        return reset();
      };
      projection.center = function(_) {
        if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
        λ = _[0] % 360 * d3_radians;
        φ = _[1] % 360 * d3_radians;
        return reset();
      };
      projection.rotate = function(_) {
        if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
        δλ = _[0] % 360 * d3_radians;
        δφ = _[1] % 360 * d3_radians;
        δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
        return reset();
      };
      d3.rebind(projection, projectResample, "precision");
      function reset() {
        projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
        var center = project(λ, φ);
        δx = x - center[0] * k;
        δy = y + center[1] * k;
        return invalidate();
      }
      function invalidate() {
        if (stream) stream.valid = false, stream = null;
        return projection;
      }
      return function() {
        project = projectAt.apply(this, arguments);
        projection.invert = project.invert && invert;
        return reset();
      };
    }
    function d3_geo_projectionRadians(stream) {
      return d3_geo_transformPoint(stream, function(x, y) {
        stream.point(x * d3_radians, y * d3_radians);
      });
    }
    function d3_geo_equirectangular(λ, φ) {
      return [ λ, φ ];
    }
    (d3.geo.equirectangular = function() {
      return d3_geo_projection(d3_geo_equirectangular);
    }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
    d3.geo.rotation = function(rotate) {
      rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
      function forward(coordinates) {
        coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
        return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
      }
      forward.invert = function(coordinates) {
        coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
        return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
      };
      return forward;
    };
    function d3_geo_identityRotation(λ, φ) {
      return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
    }
    d3_geo_identityRotation.invert = d3_geo_equirectangular;
    function d3_geo_rotation(δλ, δφ, δγ) {
      return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
    }
    function d3_geo_forwardRotationλ(δλ) {
      return function(λ, φ) {
        return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
      };
    }
    function d3_geo_rotationλ(δλ) {
      var rotation = d3_geo_forwardRotationλ(δλ);
      rotation.invert = d3_geo_forwardRotationλ(-δλ);
      return rotation;
    }
    function d3_geo_rotationφγ(δφ, δγ) {
      var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
      function rotation(λ, φ) {
        var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
        return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
      }
      rotation.invert = function(λ, φ) {
        var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
        return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
      };
      return rotation;
    }
    d3.geo.circle = function() {
      var origin = [ 0, 0 ], angle, precision = 6, interpolate;
      function circle() {
        var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
        interpolate(null, null, 1, {
          point: function(x, y) {
            ring.push(x = rotate(x, y));
            x[0] *= d3_degrees, x[1] *= d3_degrees;
          }
        });
        return {
          type: "Polygon",
          coordinates: [ ring ]
        };
      }
      circle.origin = function(x) {
        if (!arguments.length) return origin;
        origin = x;
        return circle;
      };
      circle.angle = function(x) {
        if (!arguments.length) return angle;
        interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
        return circle;
      };
      circle.precision = function(_) {
        if (!arguments.length) return precision;
        interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
        return circle;
      };
      return circle.angle(90);
    };
    function d3_geo_circleInterpolate(radius, precision) {
      var cr = Math.cos(radius), sr = Math.sin(radius);
      return function(from, to, direction, listener) {
        var step = direction * precision;
        if (from != null) {
          from = d3_geo_circleAngle(cr, from);
          to = d3_geo_circleAngle(cr, to);
          if (direction > 0 ? from < to : from > to) from += direction * τ;
        } else {
          from = radius + direction * τ;
          to = radius - .5 * step;
        }
        for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
          listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
        }
      };
    }
    function d3_geo_circleAngle(cr, point) {
      var a = d3_geo_cartesian(point);
      a[0] -= cr;
      d3_geo_cartesianNormalize(a);
      var angle = d3_acos(-a[1]);
      return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
    }
    d3.geo.distance = function(a, b) {
      var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
      return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
    };
    d3.geo.graticule = function() {
      var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
      function graticule() {
        return {
          type: "MultiLineString",
          coordinates: lines()
        };
      }
      function lines() {
        return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
          return abs(x % DX) > ε;
        }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
          return abs(y % DY) > ε;
        }).map(y));
      }
      graticule.lines = function() {
        return lines().map(function(coordinates) {
          return {
            type: "LineString",
            coordinates: coordinates
          };
        });
      };
      graticule.outline = function() {
        return {
          type: "Polygon",
          coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
        };
      };
      graticule.extent = function(_) {
        if (!arguments.length) return graticule.minorExtent();
        return graticule.majorExtent(_).minorExtent(_);
      };
      graticule.majorExtent = function(_) {
        if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
        X0 = +_[0][0], X1 = +_[1][0];
        Y0 = +_[0][1], Y1 = +_[1][1];
        if (X0 > X1) _ = X0, X0 = X1, X1 = _;
        if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
        return graticule.precision(precision);
      };
      graticule.minorExtent = function(_) {
        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
        x0 = +_[0][0], x1 = +_[1][0];
        y0 = +_[0][1], y1 = +_[1][1];
        if (x0 > x1) _ = x0, x0 = x1, x1 = _;
        if (y0 > y1) _ = y0, y0 = y1, y1 = _;
        return graticule.precision(precision);
      };
      graticule.step = function(_) {
        if (!arguments.length) return graticule.minorStep();
        return graticule.majorStep(_).minorStep(_);
      };
      graticule.majorStep = function(_) {
        if (!arguments.length) return [ DX, DY ];
        DX = +_[0], DY = +_[1];
        return graticule;
      };
      graticule.minorStep = function(_) {
        if (!arguments.length) return [ dx, dy ];
        dx = +_[0], dy = +_[1];
        return graticule;
      };
      graticule.precision = function(_) {
        if (!arguments.length) return precision;
        precision = +_;
        x = d3_geo_graticuleX(y0, y1, 90);
        y = d3_geo_graticuleY(x0, x1, precision);
        X = d3_geo_graticuleX(Y0, Y1, 90);
        Y = d3_geo_graticuleY(X0, X1, precision);
        return graticule;
      };
      return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
    };
    function d3_geo_graticuleX(y0, y1, dy) {
      var y = d3.range(y0, y1 - ε, dy).concat(y1);
      return function(x) {
        return y.map(function(y) {
          return [ x, y ];
        });
      };
    }
    function d3_geo_graticuleY(x0, x1, dx) {
      var x = d3.range(x0, x1 - ε, dx).concat(x1);
      return function(y) {
        return x.map(function(x) {
          return [ x, y ];
        });
      };
    }
    function d3_source(d) {
      return d.source;
    }
    function d3_target(d) {
      return d.target;
    }
    d3.geo.greatArc = function() {
      var source = d3_source, source_, target = d3_target, target_;
      function greatArc() {
        return {
          type: "LineString",
          coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
        };
      }
      greatArc.distance = function() {
        return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
      };
      greatArc.source = function(_) {
        if (!arguments.length) return source;
        source = _, source_ = typeof _ === "function" ? null : _;
        return greatArc;
      };
      greatArc.target = function(_) {
        if (!arguments.length) return target;
        target = _, target_ = typeof _ === "function" ? null : _;
        return greatArc;
      };
      greatArc.precision = function() {
        return arguments.length ? greatArc : 0;
      };
      return greatArc;
    };
    d3.geo.interpolate = function(source, target) {
      return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
    };
    function d3_geo_interpolate(x0, y0, x1, y1) {
      var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
      var interpolate = d ? function(t) {
        var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
        return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
      } : function() {
        return [ x0 * d3_degrees, y0 * d3_degrees ];
      };
      interpolate.distance = d;
      return interpolate;
    }
    d3.geo.length = function(object) {
      d3_geo_lengthSum = 0;
      d3.geo.stream(object, d3_geo_length);
      return d3_geo_lengthSum;
    };
    var d3_geo_lengthSum;
    var d3_geo_length = {
      sphere: d3_noop,
      point: d3_noop,
      lineStart: d3_geo_lengthLineStart,
      lineEnd: d3_noop,
      polygonStart: d3_noop,
      polygonEnd: d3_noop
    };
    function d3_geo_lengthLineStart() {
      var λ0, sinφ0, cosφ0;
      d3_geo_length.point = function(λ, φ) {
        λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
        d3_geo_length.point = nextPoint;
      };
      d3_geo_length.lineEnd = function() {
        d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
      };
      function nextPoint(λ, φ) {
        var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
        d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
      }
    }
    function d3_geo_azimuthal(scale, angle) {
      function azimuthal(λ, φ) {
        var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
        return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
      }
      azimuthal.invert = function(x, y) {
        var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
        return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
      };
      return azimuthal;
    }
    var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
      return Math.sqrt(2 / (1 + cosλcosφ));
    }, function(ρ) {
      return 2 * Math.asin(ρ / 2);
    });
    (d3.geo.azimuthalEqualArea = function() {
      return d3_geo_projection(d3_geo_azimuthalEqualArea);
    }).raw = d3_geo_azimuthalEqualArea;
    var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
      var c = Math.acos(cosλcosφ);
      return c && c / Math.sin(c);
    }, d3_identity);
    (d3.geo.azimuthalEquidistant = function() {
      return d3_geo_projection(d3_geo_azimuthalEquidistant);
    }).raw = d3_geo_azimuthalEquidistant;
    function d3_geo_conicConformal(φ0, φ1) {
      var cosφ0 = Math.cos(φ0), t = function(φ) {
        return Math.tan(π / 4 + φ / 2);
      }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
      if (!n) return d3_geo_mercator;
      function forward(λ, φ) {
        if (F > 0) {
          if (φ < -halfπ + ε) φ = -halfπ + ε;
        } else {
          if (φ > halfπ - ε) φ = halfπ - ε;
        }
        var ρ = F / Math.pow(t(φ), n);
        return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
      }
      forward.invert = function(x, y) {
        var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
        return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
      };
      return forward;
    }
    (d3.geo.conicConformal = function() {
      return d3_geo_conic(d3_geo_conicConformal);
    }).raw = d3_geo_conicConformal;
    function d3_geo_conicEquidistant(φ0, φ1) {
      var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
      if (abs(n) < ε) return d3_geo_equirectangular;
      function forward(λ, φ) {
        var ρ = G - φ;
        return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
      }
      forward.invert = function(x, y) {
        var ρ0_y = G - y;
        return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
      };
      return forward;
    }
    (d3.geo.conicEquidistant = function() {
      return d3_geo_conic(d3_geo_conicEquidistant);
    }).raw = d3_geo_conicEquidistant;
    var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
      return 1 / cosλcosφ;
    }, Math.atan);
    (d3.geo.gnomonic = function() {
      return d3_geo_projection(d3_geo_gnomonic);
    }).raw = d3_geo_gnomonic;
    function d3_geo_mercator(λ, φ) {
      return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
    }
    d3_geo_mercator.invert = function(x, y) {
      return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
    };
    function d3_geo_mercatorProjection(project) {
      var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
      m.scale = function() {
        var v = scale.apply(m, arguments);
        return v === m ? clipAuto ? m.clipExtent(null) : m : v;
      };
      m.translate = function() {
        var v = translate.apply(m, arguments);
        return v === m ? clipAuto ? m.clipExtent(null) : m : v;
      };
      m.clipExtent = function(_) {
        var v = clipExtent.apply(m, arguments);
        if (v === m) {
          if (clipAuto = _ == null) {
            var k = π * scale(), t = translate();
            clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
          }
        } else if (clipAuto) {
          v = null;
        }
        return v;
      };
      return m.clipExtent(null);
    }
    (d3.geo.mercator = function() {
      return d3_geo_mercatorProjection(d3_geo_mercator);
    }).raw = d3_geo_mercator;
    var d3_geo_orthographic = d3_geo_azimuthal(function() {
      return 1;
    }, Math.asin);
    (d3.geo.orthographic = function() {
      return d3_geo_projection(d3_geo_orthographic);
    }).raw = d3_geo_orthographic;
    var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
      return 1 / (1 + cosλcosφ);
    }, function(ρ) {
      return 2 * Math.atan(ρ);
    });
    (d3.geo.stereographic = function() {
      return d3_geo_projection(d3_geo_stereographic);
    }).raw = d3_geo_stereographic;
    function d3_geo_transverseMercator(λ, φ) {
      return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
    }
    d3_geo_transverseMercator.invert = function(x, y) {
      return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
    };
    (d3.geo.transverseMercator = function() {
      var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
      projection.center = function(_) {
        return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
      };
      projection.rotate = function(_) {
        return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
        [ _[0], _[1], _[2] - 90 ]);
      };
      return rotate([ 0, 0, 90 ]);
    }).raw = d3_geo_transverseMercator;
    d3.geom = {};
    function d3_geom_pointX(d) {
      return d[0];
    }
    function d3_geom_pointY(d) {
      return d[1];
    }
    d3.geom.hull = function(vertices) {
      var x = d3_geom_pointX, y = d3_geom_pointY;
      if (arguments.length) return hull(vertices);
      function hull(data) {
        if (data.length < 3) return [];
        var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
        for (i = 0; i < n; i++) {
          points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
        }
        points.sort(d3_geom_hullOrder);
        for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
        var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
        var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
        for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
        for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
        return polygon;
      }
      hull.x = function(_) {
        return arguments.length ? (x = _, hull) : x;
      };
      hull.y = function(_) {
        return arguments.length ? (y = _, hull) : y;
      };
      return hull;
    };
    function d3_geom_hullUpper(points) {
      var n = points.length, hull = [ 0, 1 ], hs = 2;
      for (var i = 2; i < n; i++) {
        while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
        hull[hs++] = i;
      }
      return hull.slice(0, hs);
    }
    function d3_geom_hullOrder(a, b) {
      return a[0] - b[0] || a[1] - b[1];
    }
    d3.geom.polygon = function(coordinates) {
      d3_subclass(coordinates, d3_geom_polygonPrototype);
      return coordinates;
    };
    var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
    d3_geom_polygonPrototype.area = function() {
      var i = -1, n = this.length, a, b = this[n - 1], area = 0;
      while (++i < n) {
        a = b;
        b = this[i];
        area += a[1] * b[0] - a[0] * b[1];
      }
      return area * .5;
    };
    d3_geom_polygonPrototype.centroid = function(k) {
      var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
      if (!arguments.length) k = -1 / (6 * this.area());
      while (++i < n) {
        a = b;
        b = this[i];
        c = a[0] * b[1] - b[0] * a[1];
        x += (a[0] + b[0]) * c;
        y += (a[1] + b[1]) * c;
      }
      return [ x * k, y * k ];
    };
    d3_geom_polygonPrototype.clip = function(subject) {
      var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
      while (++i < n) {
        input = subject.slice();
        subject.length = 0;
        b = this[i];
        c = input[(m = input.length - closed) - 1];
        j = -1;
        while (++j < m) {
          d = input[j];
          if (d3_geom_polygonInside(d, a, b)) {
            if (!d3_geom_polygonInside(c, a, b)) {
              subject.push(d3_geom_polygonIntersect(c, d, a, b));
            }
            subject.push(d);
          } else if (d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          c = d;
        }
        if (closed) subject.push(subject[0]);
        a = b;
      }
      return subject;
    };
    function d3_geom_polygonInside(p, a, b) {
      return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
    }
    function d3_geom_polygonIntersect(c, d, a, b) {
      var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
      return [ x1 + ua * x21, y1 + ua * y21 ];
    }
    function d3_geom_polygonClosed(coordinates) {
      var a = coordinates[0], b = coordinates[coordinates.length - 1];
      return !(a[0] - b[0] || a[1] - b[1]);
    }
    var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
    function d3_geom_voronoiBeach() {
      d3_geom_voronoiRedBlackNode(this);
      this.edge = this.site = this.circle = null;
    }
    function d3_geom_voronoiCreateBeach(site) {
      var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
      beach.site = site;
      return beach;
    }
    function d3_geom_voronoiDetachBeach(beach) {
      d3_geom_voronoiDetachCircle(beach);
      d3_geom_voronoiBeaches.remove(beach);
      d3_geom_voronoiBeachPool.push(beach);
      d3_geom_voronoiRedBlackNode(beach);
    }
    function d3_geom_voronoiRemoveBeach(beach) {
      var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
        x: x,
        y: y
      }, previous = beach.P, next = beach.N, disappearing = [ beach ];
      d3_geom_voronoiDetachBeach(beach);
      var lArc = previous;
      while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
        previous = lArc.P;
        disappearing.unshift(lArc);
        d3_geom_voronoiDetachBeach(lArc);
        lArc = previous;
      }
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachCircle(lArc);
      var rArc = next;
      while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
        next = rArc.N;
        disappearing.push(rArc);
        d3_geom_voronoiDetachBeach(rArc);
        rArc = next;
      }
      disappearing.push(rArc);
      d3_geom_voronoiDetachCircle(rArc);
      var nArcs = disappearing.length, iArc;
      for (iArc = 1; iArc < nArcs; ++iArc) {
        rArc = disappearing[iArc];
        lArc = disappearing[iArc - 1];
        d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
      }
      lArc = disappearing[0];
      rArc = disappearing[nArcs - 1];
      rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
    }
    function d3_geom_voronoiAddBeach(site) {
      var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
      while (node) {
        dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
        if (dxl > ε) node = node.L; else {
          dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
          if (dxr > ε) {
            if (!node.R) {
              lArc = node;
              break;
            }
            node = node.R;
          } else {
            if (dxl > -ε) {
              lArc = node.P;
              rArc = node;
            } else if (dxr > -ε) {
              lArc = node;
              rArc = node.N;
            } else {
              lArc = rArc = node;
            }
            break;
          }
        }
      }
      var newArc = d3_geom_voronoiCreateBeach(site);
      d3_geom_voronoiBeaches.insert(lArc, newArc);
      if (!lArc && !rArc) return;
      if (lArc === rArc) {
        d3_geom_voronoiDetachCircle(lArc);
        rArc = d3_geom_voronoiCreateBeach(lArc.site);
        d3_geom_voronoiBeaches.insert(newArc, rArc);
        newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
        d3_geom_voronoiAttachCircle(lArc);
        d3_geom_voronoiAttachCircle(rArc);
        return;
      }
      if (!rArc) {
        newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
        return;
      }
      d3_geom_voronoiDetachCircle(lArc);
      d3_geom_voronoiDetachCircle(rArc);
      var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
        x: (cy * hb - by * hc) / d + ax,
        y: (bx * hc - cx * hb) / d + ay
      };
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
      newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
      rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
    }
    function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
      var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
      if (!pby2) return rfocx;
      var lArc = arc.P;
      if (!lArc) return -Infinity;
      site = lArc.site;
      var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
      if (!plby2) return lfocx;
      var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
      if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
      return (rfocx + lfocx) / 2;
    }
    function d3_geom_voronoiRightBreakPoint(arc, directrix) {
      var rArc = arc.N;
      if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
      var site = arc.site;
      return site.y === directrix ? site.x : Infinity;
    }
    function d3_geom_voronoiCell(site) {
      this.site = site;
      this.edges = [];
    }
    d3_geom_voronoiCell.prototype.prepare = function() {
      var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
      while (iHalfEdge--) {
        edge = halfEdges[iHalfEdge].edge;
        if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
      }
      halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
      return halfEdges.length;
    };
    function d3_geom_voronoiCloseCells(extent) {
      var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
      while (iCell--) {
        cell = cells[iCell];
        if (!cell || !cell.prepare()) continue;
        halfEdges = cell.edges;
        nHalfEdges = halfEdges.length;
        iHalfEdge = 0;
        while (iHalfEdge < nHalfEdges) {
          end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
          start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
          if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
            halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
              x: x0,
              y: abs(x2 - x0) < ε ? y2 : y1
            } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
              x: abs(y2 - y1) < ε ? x2 : x1,
              y: y1
            } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
              x: x1,
              y: abs(x2 - x1) < ε ? y2 : y0
            } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
              x: abs(y2 - y0) < ε ? x2 : x0,
              y: y0
            } : null), cell.site, null));
            ++nHalfEdges;
          }
        }
      }
    }
    function d3_geom_voronoiHalfEdgeOrder(a, b) {
      return b.angle - a.angle;
    }
    function d3_geom_voronoiCircle() {
      d3_geom_voronoiRedBlackNode(this);
      this.x = this.y = this.arc = this.site = this.cy = null;
    }
    function d3_geom_voronoiAttachCircle(arc) {
      var lArc = arc.P, rArc = arc.N;
      if (!lArc || !rArc) return;
      var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
      if (lSite === rSite) return;
      var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
      var d = 2 * (ax * cy - ay * cx);
      if (d >= -ε2) return;
      var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
      var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
      circle.arc = arc;
      circle.site = cSite;
      circle.x = x + bx;
      circle.y = cy + Math.sqrt(x * x + y * y);
      circle.cy = cy;
      arc.circle = circle;
      var before = null, node = d3_geom_voronoiCircles._;
      while (node) {
        if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
          if (node.L) node = node.L; else {
            before = node.P;
            break;
          }
        } else {
          if (node.R) node = node.R; else {
            before = node;
            break;
          }
        }
      }
      d3_geom_voronoiCircles.insert(before, circle);
      if (!before) d3_geom_voronoiFirstCircle = circle;
    }
    function d3_geom_voronoiDetachCircle(arc) {
      var circle = arc.circle;
      if (circle) {
        if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
        d3_geom_voronoiCircles.remove(circle);
        d3_geom_voronoiCirclePool.push(circle);
        d3_geom_voronoiRedBlackNode(circle);
        arc.circle = null;
      }
    }
    function d3_geom_voronoiClipEdges(extent) {
      var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
      while (i--) {
        e = edges[i];
        if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
          e.a = e.b = null;
          edges.splice(i, 1);
        }
      }
    }
    function d3_geom_voronoiConnectEdge(edge, extent) {
      var vb = edge.b;
      if (vb) return true;
      var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
      if (ry === ly) {
        if (fx < x0 || fx >= x1) return;
        if (lx > rx) {
          if (!va) va = {
            x: fx,
            y: y0
          }; else if (va.y >= y1) return;
          vb = {
            x: fx,
            y: y1
          };
        } else {
          if (!va) va = {
            x: fx,
            y: y1
          }; else if (va.y < y0) return;
          vb = {
            x: fx,
            y: y0
          };
        }
      } else {
        fm = (lx - rx) / (ry - ly);
        fb = fy - fm * fx;
        if (fm < -1 || fm > 1) {
          if (lx > rx) {
            if (!va) va = {
              x: (y0 - fb) / fm,
              y: y0
            }; else if (va.y >= y1) return;
            vb = {
              x: (y1 - fb) / fm,
              y: y1
            };
          } else {
            if (!va) va = {
              x: (y1 - fb) / fm,
              y: y1
            }; else if (va.y < y0) return;
            vb = {
              x: (y0 - fb) / fm,
              y: y0
            };
          }
        } else {
          if (ly < ry) {
            if (!va) va = {
              x: x0,
              y: fm * x0 + fb
            }; else if (va.x >= x1) return;
            vb = {
              x: x1,
              y: fm * x1 + fb
            };
          } else {
            if (!va) va = {
              x: x1,
              y: fm * x1 + fb
            }; else if (va.x < x0) return;
            vb = {
              x: x0,
              y: fm * x0 + fb
            };
          }
        }
      }
      edge.a = va;
      edge.b = vb;
      return true;
    }
    function d3_geom_voronoiEdge(lSite, rSite) {
      this.l = lSite;
      this.r = rSite;
      this.a = this.b = null;
    }
    function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
      var edge = new d3_geom_voronoiEdge(lSite, rSite);
      d3_geom_voronoiEdges.push(edge);
      if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
      if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
      d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
      d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
      return edge;
    }
    function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
      var edge = new d3_geom_voronoiEdge(lSite, null);
      edge.a = va;
      edge.b = vb;
      d3_geom_voronoiEdges.push(edge);
      return edge;
    }
    function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
      if (!edge.a && !edge.b) {
        edge.a = vertex;
        edge.l = lSite;
        edge.r = rSite;
      } else if (edge.l === rSite) {
        edge.b = vertex;
      } else {
        edge.a = vertex;
      }
    }
    function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
      var va = edge.a, vb = edge.b;
      this.edge = edge;
      this.site = lSite;
      this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
    }
    d3_geom_voronoiHalfEdge.prototype = {
      start: function() {
        return this.edge.l === this.site ? this.edge.a : this.edge.b;
      },
      end: function() {
        return this.edge.l === this.site ? this.edge.b : this.edge.a;
      }
    };
    function d3_geom_voronoiRedBlackTree() {
      this._ = null;
    }
    function d3_geom_voronoiRedBlackNode(node) {
      node.U = node.C = node.L = node.R = node.P = node.N = null;
    }
    d3_geom_voronoiRedBlackTree.prototype = {
      insert: function(after, node) {
        var parent, grandpa, uncle;
        if (after) {
          node.P = after;
          node.N = after.N;
          if (after.N) after.N.P = node;
          after.N = node;
          if (after.R) {
            after = after.R;
            while (after.L) after = after.L;
            after.L = node;
          } else {
            after.R = node;
          }
          parent = after;
        } else if (this._) {
          after = d3_geom_voronoiRedBlackFirst(this._);
          node.P = null;
          node.N = after;
          after.P = after.L = node;
          parent = after;
        } else {
          node.P = node.N = null;
          this._ = node;
          parent = null;
        }
        node.L = node.R = null;
        node.U = parent;
        node.C = true;
        after = node;
        while (parent && parent.C) {
          grandpa = parent.U;
          if (parent === grandpa.L) {
            uncle = grandpa.R;
            if (uncle && uncle.C) {
              parent.C = uncle.C = false;
              grandpa.C = true;
              after = grandpa;
            } else {
              if (after === parent.R) {
                d3_geom_voronoiRedBlackRotateLeft(this, parent);
                after = parent;
                parent = after.U;
              }
              parent.C = false;
              grandpa.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, grandpa);
            }
          } else {
            uncle = grandpa.L;
            if (uncle && uncle.C) {
              parent.C = uncle.C = false;
              grandpa.C = true;
              after = grandpa;
            } else {
              if (after === parent.L) {
                d3_geom_voronoiRedBlackRotateRight(this, parent);
                after = parent;
                parent = after.U;
              }
              parent.C = false;
              grandpa.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
            }
          }
          parent = after.U;
        }
        this._.C = false;
      },
      remove: function(node) {
        if (node.N) node.N.P = node.P;
        if (node.P) node.P.N = node.N;
        node.N = node.P = null;
        var parent = node.U, sibling, left = node.L, right = node.R, next, red;
        if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
        if (parent) {
          if (parent.L === node) parent.L = next; else parent.R = next;
        } else {
          this._ = next;
        }
        if (left && right) {
          red = next.C;
          next.C = node.C;
          next.L = left;
          left.U = next;
          if (next !== right) {
            parent = next.U;
            next.U = node.U;
            node = next.R;
            parent.L = node;
            next.R = right;
            right.U = next;
          } else {
            next.U = parent;
            parent = next;
            node = next.R;
          }
        } else {
          red = node.C;
          node = next;
        }
        if (node) node.U = parent;
        if (red) return;
        if (node && node.C) {
          node.C = false;
          return;
        }
        do {
          if (node === this._) break;
          if (node === parent.L) {
            sibling = parent.R;
            if (sibling.C) {
              sibling.C = false;
              parent.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              sibling = parent.R;
            }
            if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
              if (!sibling.R || !sibling.R.C) {
                sibling.L.C = false;
                sibling.C = true;
                d3_geom_voronoiRedBlackRotateRight(this, sibling);
                sibling = parent.R;
              }
              sibling.C = parent.C;
              parent.C = sibling.R.C = false;
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              node = this._;
              break;
            }
          } else {
            sibling = parent.L;
            if (sibling.C) {
              sibling.C = false;
              parent.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              sibling = parent.L;
            }
            if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
              if (!sibling.L || !sibling.L.C) {
                sibling.R.C = false;
                sibling.C = true;
                d3_geom_voronoiRedBlackRotateLeft(this, sibling);
                sibling = parent.L;
              }
              sibling.C = parent.C;
              parent.C = sibling.L.C = false;
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              node = this._;
              break;
            }
          }
          sibling.C = true;
          node = parent;
          parent = parent.U;
        } while (!node.C);
        if (node) node.C = false;
      }
    };
    function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
      var p = node, q = node.R, parent = p.U;
      if (parent) {
        if (parent.L === p) parent.L = q; else parent.R = q;
      } else {
        tree._ = q;
      }
      q.U = parent;
      p.U = q;
      p.R = q.L;
      if (p.R) p.R.U = p;
      q.L = p;
    }
    function d3_geom_voronoiRedBlackRotateRight(tree, node) {
      var p = node, q = node.L, parent = p.U;
      if (parent) {
        if (parent.L === p) parent.L = q; else parent.R = q;
      } else {
        tree._ = q;
      }
      q.U = parent;
      p.U = q;
      p.L = q.R;
      if (p.L) p.L.U = p;
      q.R = p;
    }
    function d3_geom_voronoiRedBlackFirst(node) {
      while (node.L) node = node.L;
      return node;
    }
    function d3_geom_voronoi(sites, bbox) {
      var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
      d3_geom_voronoiEdges = [];
      d3_geom_voronoiCells = new Array(sites.length);
      d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
      d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
      while (true) {
        circle = d3_geom_voronoiFirstCircle;
        if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
          if (site.x !== x0 || site.y !== y0) {
            d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
            d3_geom_voronoiAddBeach(site);
            x0 = site.x, y0 = site.y;
          }
          site = sites.pop();
        } else if (circle) {
          d3_geom_voronoiRemoveBeach(circle.arc);
        } else {
          break;
        }
      }
      if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
      var diagram = {
        cells: d3_geom_voronoiCells,
        edges: d3_geom_voronoiEdges
      };
      d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
      return diagram;
    }
    function d3_geom_voronoiVertexOrder(a, b) {
      return b.y - a.y || b.x - a.x;
    }
    d3.geom.voronoi = function(points) {
      var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
      if (points) return voronoi(points);
      function voronoi(data) {
        var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
        d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
          var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
            var s = e.start();
            return [ s.x, s.y ];
          }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
          polygon.point = data[i];
        });
        return polygons;
      }
      function sites(data) {
        return data.map(function(d, i) {
          return {
            x: Math.round(fx(d, i) / ε) * ε,
            y: Math.round(fy(d, i) / ε) * ε,
            i: i
          };
        });
      }
      voronoi.links = function(data) {
        return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
          return edge.l && edge.r;
        }).map(function(edge) {
          return {
            source: data[edge.l.i],
            target: data[edge.r.i]
          };
        });
      };
      voronoi.triangles = function(data) {
        var triangles = [];
        d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
          var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
          while (++j < m) {
            e0 = e1;
            s0 = s1;
            e1 = edges[j].edge;
            s1 = e1.l === site ? e1.r : e1.l;
            if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
              triangles.push([ data[i], data[s0.i], data[s1.i] ]);
            }
          }
        });
        return triangles;
      };
      voronoi.x = function(_) {
        return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
      };
      voronoi.y = function(_) {
        return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
      };
      voronoi.clipExtent = function(_) {
        if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
        clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
        return voronoi;
      };
      voronoi.size = function(_) {
        if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
        return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
      };
      return voronoi;
    };
    var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
    function d3_geom_voronoiTriangleArea(a, b, c) {
      return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
    }
    d3.geom.delaunay = function(vertices) {
      return d3.geom.voronoi().triangles(vertices);
    };
    d3.geom.quadtree = function(points, x1, y1, x2, y2) {
      var x = d3_geom_pointX, y = d3_geom_pointY, compat;
      if (compat = arguments.length) {
        x = d3_geom_quadtreeCompatX;
        y = d3_geom_quadtreeCompatY;
        if (compat === 3) {
          y2 = y1;
          x2 = x1;
          y1 = x1 = 0;
        }
        return quadtree(points);
      }
      function quadtree(data) {
        var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
        if (x1 != null) {
          x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
        } else {
          x2_ = y2_ = -(x1_ = y1_ = Infinity);
          xs = [], ys = [];
          n = data.length;
          if (compat) for (i = 0; i < n; ++i) {
            d = data[i];
            if (d.x < x1_) x1_ = d.x;
            if (d.y < y1_) y1_ = d.y;
            if (d.x > x2_) x2_ = d.x;
            if (d.y > y2_) y2_ = d.y;
            xs.push(d.x);
            ys.push(d.y);
          } else for (i = 0; i < n; ++i) {
            var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
            if (x_ < x1_) x1_ = x_;
            if (y_ < y1_) y1_ = y_;
            if (x_ > x2_) x2_ = x_;
            if (y_ > y2_) y2_ = y_;
            xs.push(x_);
            ys.push(y_);
          }
        }
        var dx = x2_ - x1_, dy = y2_ - y1_;
        if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
        function insert(n, d, x, y, x1, y1, x2, y2) {
          if (isNaN(x) || isNaN(y)) return;
          if (n.leaf) {
            var nx = n.x, ny = n.y;
            if (nx != null) {
              if (abs(nx - x) + abs(ny - y) < .01) {
                insertChild(n, d, x, y, x1, y1, x2, y2);
              } else {
                var nPoint = n.point;
                n.x = n.y = n.point = null;
                insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
                insertChild(n, d, x, y, x1, y1, x2, y2);
              }
            } else {
              n.x = x, n.y = y, n.point = d;
            }
          } else {
            insertChild(n, d, x, y, x1, y1, x2, y2);
          }
        }
        function insertChild(n, d, x, y, x1, y1, x2, y2) {
          var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
          n.leaf = false;
          n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
          if (right) x1 = xm; else x2 = xm;
          if (below) y1 = ym; else y2 = ym;
          insert(n, d, x, y, x1, y1, x2, y2);
        }
        var root = d3_geom_quadtreeNode();
        root.add = function(d) {
          insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
        };
        root.visit = function(f) {
          d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
        };
        root.find = function(point) {
          return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
        };
        i = -1;
        if (x1 == null) {
          while (++i < n) {
            insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
          }
          --i;
        } else data.forEach(root.add);
        xs = ys = data = d = null;
        return root;
      }
      quadtree.x = function(_) {
        return arguments.length ? (x = _, quadtree) : x;
      };
      quadtree.y = function(_) {
        return arguments.length ? (y = _, quadtree) : y;
      };
      quadtree.extent = function(_) {
        if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
        if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
        y2 = +_[1][1];
        return quadtree;
      };
      quadtree.size = function(_) {
        if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
        if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
        return quadtree;
      };
      return quadtree;
    };
    function d3_geom_quadtreeCompatX(d) {
      return d.x;
    }
    function d3_geom_quadtreeCompatY(d) {
      return d.y;
    }
    function d3_geom_quadtreeNode() {
      return {
        leaf: true,
        nodes: [],
        point: null,
        x: null,
        y: null
      };
    }
    function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
      if (!f(node, x1, y1, x2, y2)) {
        var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
        if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
        if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
        if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
        if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
      }
    }
    function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
      var minDistance2 = Infinity, closestPoint;
      (function find(node, x1, y1, x2, y2) {
        if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
        if (point = node.point) {
          var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
          if (distance2 < minDistance2) {
            var distance = Math.sqrt(minDistance2 = distance2);
            x0 = x - distance, y0 = y - distance;
            x3 = x + distance, y3 = y + distance;
            closestPoint = point;
          }
        }
        var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
        for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
          if (node = children[i & 3]) switch (i & 3) {
           case 0:
            find(node, x1, y1, xm, ym);
            break;
  
           case 1:
            find(node, xm, y1, x2, ym);
            break;
  
           case 2:
            find(node, x1, ym, xm, y2);
            break;
  
           case 3:
            find(node, xm, ym, x2, y2);
            break;
          }
        }
      })(root, x0, y0, x3, y3);
      return closestPoint;
    }
    d3.interpolateRgb = d3_interpolateRgb;
    function d3_interpolateRgb(a, b) {
      a = d3.rgb(a);
      b = d3.rgb(b);
      var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
      return function(t) {
        return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
      };
    }
    d3.interpolateObject = d3_interpolateObject;
    function d3_interpolateObject(a, b) {
      var i = {}, c = {}, k;
      for (k in a) {
        if (k in b) {
          i[k] = d3_interpolate(a[k], b[k]);
        } else {
          c[k] = a[k];
        }
      }
      for (k in b) {
        if (!(k in a)) {
          c[k] = b[k];
        }
      }
      return function(t) {
        for (k in i) c[k] = i[k](t);
        return c;
      };
    }
    d3.interpolateNumber = d3_interpolateNumber;
    function d3_interpolateNumber(a, b) {
      a = +a, b = +b;
      return function(t) {
        return a * (1 - t) + b * t;
      };
    }
    d3.interpolateString = d3_interpolateString;
    function d3_interpolateString(a, b) {
      var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
      a = a + "", b = b + "";
      while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
        if ((bs = bm.index) > bi) {
          bs = b.slice(bi, bs);
          if (s[i]) s[i] += bs; else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
          if (s[i]) s[i] += bm; else s[++i] = bm;
        } else {
          s[++i] = null;
          q.push({
            i: i,
            x: d3_interpolateNumber(am, bm)
          });
        }
        bi = d3_interpolate_numberB.lastIndex;
      }
      if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; else s[++i] = bs;
      }
      return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
        return b(t) + "";
      }) : function() {
        return b;
      } : (b = q.length, function(t) {
        for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
        return s.join("");
      });
    }
    var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
    d3.interpolate = d3_interpolate;
    function d3_interpolate(a, b) {
      var i = d3.interpolators.length, f;
      while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
      return f;
    }
    d3.interpolators = [ function(a, b) {
      var t = typeof b;
      return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
    } ];
    d3.interpolateArray = d3_interpolateArray;
    function d3_interpolateArray(a, b) {
      var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
      for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
      for (;i < na; ++i) c[i] = a[i];
      for (;i < nb; ++i) c[i] = b[i];
      return function(t) {
        for (i = 0; i < n0; ++i) c[i] = x[i](t);
        return c;
      };
    }
    var d3_ease_default = function() {
      return d3_identity;
    };
    var d3_ease = d3.map({
      linear: d3_ease_default,
      poly: d3_ease_poly,
      quad: function() {
        return d3_ease_quad;
      },
      cubic: function() {
        return d3_ease_cubic;
      },
      sin: function() {
        return d3_ease_sin;
      },
      exp: function() {
        return d3_ease_exp;
      },
      circle: function() {
        return d3_ease_circle;
      },
      elastic: d3_ease_elastic,
      back: d3_ease_back,
      bounce: function() {
        return d3_ease_bounce;
      }
    });
    var d3_ease_mode = d3.map({
      "in": d3_identity,
      out: d3_ease_reverse,
      "in-out": d3_ease_reflect,
      "out-in": function(f) {
        return d3_ease_reflect(d3_ease_reverse(f));
      }
    });
    d3.ease = function(name) {
      var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
      t = d3_ease.get(t) || d3_ease_default;
      m = d3_ease_mode.get(m) || d3_identity;
      return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
    };
    function d3_ease_clamp(f) {
      return function(t) {
        return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
      };
    }
    function d3_ease_reverse(f) {
      return function(t) {
        return 1 - f(1 - t);
      };
    }
    function d3_ease_reflect(f) {
      return function(t) {
        return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
      };
    }
    function d3_ease_quad(t) {
      return t * t;
    }
    function d3_ease_cubic(t) {
      return t * t * t;
    }
    function d3_ease_cubicInOut(t) {
      if (t <= 0) return 0;
      if (t >= 1) return 1;
      var t2 = t * t, t3 = t2 * t;
      return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
    }
    function d3_ease_poly(e) {
      return function(t) {
        return Math.pow(t, e);
      };
    }
    function d3_ease_sin(t) {
      return 1 - Math.cos(t * halfπ);
    }
    function d3_ease_exp(t) {
      return Math.pow(2, 10 * (t - 1));
    }
    function d3_ease_circle(t) {
      return 1 - Math.sqrt(1 - t * t);
    }
    function d3_ease_elastic(a, p) {
      var s;
      if (arguments.length < 2) p = .45;
      if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
      return function(t) {
        return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
      };
    }
    function d3_ease_back(s) {
      if (!s) s = 1.70158;
      return function(t) {
        return t * t * ((s + 1) * t - s);
      };
    }
    function d3_ease_bounce(t) {
      return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
    }
    d3.interpolateHcl = d3_interpolateHcl;
    function d3_interpolateHcl(a, b) {
      a = d3.hcl(a);
      b = d3.hcl(b);
      var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
      if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
      if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
      return function(t) {
        return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
      };
    }
    d3.interpolateHsl = d3_interpolateHsl;
    function d3_interpolateHsl(a, b) {
      a = d3.hsl(a);
      b = d3.hsl(b);
      var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
      if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
      if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
      return function(t) {
        return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
      };
    }
    d3.interpolateLab = d3_interpolateLab;
    function d3_interpolateLab(a, b) {
      a = d3.lab(a);
      b = d3.lab(b);
      var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
      return function(t) {
        return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
      };
    }
    d3.interpolateRound = d3_interpolateRound;
    function d3_interpolateRound(a, b) {
      b -= a;
      return function(t) {
        return Math.round(a + b * t);
      };
    }
    d3.transform = function(string) {
      var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
      return (d3.transform = function(string) {
        if (string != null) {
          g.setAttribute("transform", string);
          var t = g.transform.baseVal.consolidate();
        }
        return new d3_transform(t ? t.matrix : d3_transformIdentity);
      })(string);
    };
    function d3_transform(m) {
      var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
      if (r0[0] * r1[1] < r1[0] * r0[1]) {
        r0[0] *= -1;
        r0[1] *= -1;
        kx *= -1;
        kz *= -1;
      }
      this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
      this.translate = [ m.e, m.f ];
      this.scale = [ kx, ky ];
      this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
    }
    d3_transform.prototype.toString = function() {
      return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
    };
    function d3_transformDot(a, b) {
      return a[0] * b[0] + a[1] * b[1];
    }
    function d3_transformNormalize(a) {
      var k = Math.sqrt(d3_transformDot(a, a));
      if (k) {
        a[0] /= k;
        a[1] /= k;
      }
      return k;
    }
    function d3_transformCombine(a, b, k) {
      a[0] += k * b[0];
      a[1] += k * b[1];
      return a;
    }
    var d3_transformIdentity = {
      a: 1,
      b: 0,
      c: 0,
      d: 1,
      e: 0,
      f: 0
    };
    d3.interpolateTransform = d3_interpolateTransform;
    function d3_interpolateTransformPop(s) {
      return s.length ? s.pop() + "," : "";
    }
    function d3_interpolateTranslate(ta, tb, s, q) {
      if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
        var i = s.push("translate(", null, ",", null, ")");
        q.push({
          i: i - 4,
          x: d3_interpolateNumber(ta[0], tb[0])
        }, {
          i: i - 2,
          x: d3_interpolateNumber(ta[1], tb[1])
        });
      } else if (tb[0] || tb[1]) {
        s.push("translate(" + tb + ")");
      }
    }
    function d3_interpolateRotate(ra, rb, s, q) {
      if (ra !== rb) {
        if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
        q.push({
          i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
          x: d3_interpolateNumber(ra, rb)
        });
      } else if (rb) {
        s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
      }
    }
    function d3_interpolateSkew(wa, wb, s, q) {
      if (wa !== wb) {
        q.push({
          i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
          x: d3_interpolateNumber(wa, wb)
        });
      } else if (wb) {
        s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
      }
    }
    function d3_interpolateScale(ka, kb, s, q) {
      if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
        var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
        q.push({
          i: i - 4,
          x: d3_interpolateNumber(ka[0], kb[0])
        }, {
          i: i - 2,
          x: d3_interpolateNumber(ka[1], kb[1])
        });
      } else if (kb[0] !== 1 || kb[1] !== 1) {
        s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
      }
    }
    function d3_interpolateTransform(a, b) {
      var s = [], q = [];
      a = d3.transform(a), b = d3.transform(b);
      d3_interpolateTranslate(a.translate, b.translate, s, q);
      d3_interpolateRotate(a.rotate, b.rotate, s, q);
      d3_interpolateSkew(a.skew, b.skew, s, q);
      d3_interpolateScale(a.scale, b.scale, s, q);
      a = b = null;
      return function(t) {
        var i = -1, n = q.length, o;
        while (++i < n) s[(o = q[i]).i] = o.x(t);
        return s.join("");
      };
    }
    function d3_uninterpolateNumber(a, b) {
      b = (b -= a = +a) || 1 / b;
      return function(x) {
        return (x - a) / b;
      };
    }
    function d3_uninterpolateClamp(a, b) {
      b = (b -= a = +a) || 1 / b;
      return function(x) {
        return Math.max(0, Math.min(1, (x - a) / b));
      };
    }
    d3.layout = {};
    d3.layout.bundle = function() {
      return function(links) {
        var paths = [], i = -1, n = links.length;
        while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
        return paths;
      };
    };
    function d3_layout_bundlePath(link) {
      var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
      while (start !== lca) {
        start = start.parent;
        points.push(start);
      }
      var k = points.length;
      while (end !== lca) {
        points.splice(k, 0, end);
        end = end.parent;
      }
      return points;
    }
    function d3_layout_bundleAncestors(node) {
      var ancestors = [], parent = node.parent;
      while (parent != null) {
        ancestors.push(node);
        node = parent;
        parent = parent.parent;
      }
      ancestors.push(node);
      return ancestors;
    }
    function d3_layout_bundleLeastCommonAncestor(a, b) {
      if (a === b) return a;
      var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
      while (aNode === bNode) {
        sharedNode = aNode;
        aNode = aNodes.pop();
        bNode = bNodes.pop();
      }
      return sharedNode;
    }
    d3.layout.chord = function() {
      var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
      function relayout() {
        var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
        chords = [];
        groups = [];
        k = 0, i = -1;
        while (++i < n) {
          x = 0, j = -1;
          while (++j < n) {
            x += matrix[i][j];
          }
          groupSums.push(x);
          subgroupIndex.push(d3.range(n));
          k += x;
        }
        if (sortGroups) {
          groupIndex.sort(function(a, b) {
            return sortGroups(groupSums[a], groupSums[b]);
          });
        }
        if (sortSubgroups) {
          subgroupIndex.forEach(function(d, i) {
            d.sort(function(a, b) {
              return sortSubgroups(matrix[i][a], matrix[i][b]);
            });
          });
        }
        k = (τ - padding * n) / k;
        x = 0, i = -1;
        while (++i < n) {
          x0 = x, j = -1;
          while (++j < n) {
            var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
            subgroups[di + "-" + dj] = {
              index: di,
              subindex: dj,
              startAngle: a0,
              endAngle: a1,
              value: v
            };
          }
          groups[di] = {
            index: di,
            startAngle: x0,
            endAngle: x,
            value: groupSums[di]
          };
          x += padding;
        }
        i = -1;
        while (++i < n) {
          j = i - 1;
          while (++j < n) {
            var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
            if (source.value || target.value) {
              chords.push(source.value < target.value ? {
                source: target,
                target: source
              } : {
                source: source,
                target: target
              });
            }
          }
        }
        if (sortChords) resort();
      }
      function resort() {
        chords.sort(function(a, b) {
          return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
        });
      }
      chord.matrix = function(x) {
        if (!arguments.length) return matrix;
        n = (matrix = x) && matrix.length;
        chords = groups = null;
        return chord;
      };
      chord.padding = function(x) {
        if (!arguments.length) return padding;
        padding = x;
        chords = groups = null;
        return chord;
      };
      chord.sortGroups = function(x) {
        if (!arguments.length) return sortGroups;
        sortGroups = x;
        chords = groups = null;
        return chord;
      };
      chord.sortSubgroups = function(x) {
        if (!arguments.length) return sortSubgroups;
        sortSubgroups = x;
        chords = null;
        return chord;
      };
      chord.sortChords = function(x) {
        if (!arguments.length) return sortChords;
        sortChords = x;
        if (chords) resort();
        return chord;
      };
      chord.chords = function() {
        if (!chords) relayout();
        return chords;
      };
      chord.groups = function() {
        if (!groups) relayout();
        return groups;
      };
      return chord;
    };
    d3.layout.force = function() {
      var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
      function repulse(node) {
        return function(quad, x1, _, x2) {
          if (quad.point !== node) {
            var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
            if (dw * dw / theta2 < dn) {
              if (dn < chargeDistance2) {
                var k = quad.charge / dn;
                node.px -= dx * k;
                node.py -= dy * k;
              }
              return true;
            }
            if (quad.point && dn && dn < chargeDistance2) {
              var k = quad.pointCharge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
          }
          return !quad.charge;
        };
      }
      force.tick = function() {
        if ((alpha *= .99) < .005) {
          timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
          return true;
        }
        var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
        for (i = 0; i < m; ++i) {
          o = links[i];
          s = o.source;
          t = o.target;
          x = t.x - s.x;
          y = t.y - s.y;
          if (l = x * x + y * y) {
            l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
            x *= l;
            y *= l;
            t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
            t.y -= y * k;
            s.x += x * (k = 1 - k);
            s.y += y * k;
          }
        }
        if (k = alpha * gravity) {
          x = size[0] / 2;
          y = size[1] / 2;
          i = -1;
          if (k) while (++i < n) {
            o = nodes[i];
            o.x += (x - o.x) * k;
            o.y += (y - o.y) * k;
          }
        }
        if (charge) {
          d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
          i = -1;
          while (++i < n) {
            if (!(o = nodes[i]).fixed) {
              q.visit(repulse(o));
            }
          }
        }
        i = -1;
        while (++i < n) {
          o = nodes[i];
          if (o.fixed) {
            o.x = o.px;
            o.y = o.py;
          } else {
            o.x -= (o.px - (o.px = o.x)) * friction;
            o.y -= (o.py - (o.py = o.y)) * friction;
          }
        }
        event.tick({
          type: "tick",
          alpha: alpha
        });
      };
      force.nodes = function(x) {
        if (!arguments.length) return nodes;
        nodes = x;
        return force;
      };
      force.links = function(x) {
        if (!arguments.length) return links;
        links = x;
        return force;
      };
      force.size = function(x) {
        if (!arguments.length) return size;
        size = x;
        return force;
      };
      force.linkDistance = function(x) {
        if (!arguments.length) return linkDistance;
        linkDistance = typeof x === "function" ? x : +x;
        return force;
      };
      force.distance = force.linkDistance;
      force.linkStrength = function(x) {
        if (!arguments.length) return linkStrength;
        linkStrength = typeof x === "function" ? x : +x;
        return force;
      };
      force.friction = function(x) {
        if (!arguments.length) return friction;
        friction = +x;
        return force;
      };
      force.charge = function(x) {
        if (!arguments.length) return charge;
        charge = typeof x === "function" ? x : +x;
        return force;
      };
      force.chargeDistance = function(x) {
        if (!arguments.length) return Math.sqrt(chargeDistance2);
        chargeDistance2 = x * x;
        return force;
      };
      force.gravity = function(x) {
        if (!arguments.length) return gravity;
        gravity = +x;
        return force;
      };
      force.theta = function(x) {
        if (!arguments.length) return Math.sqrt(theta2);
        theta2 = x * x;
        return force;
      };
      force.alpha = function(x) {
        if (!arguments.length) return alpha;
        x = +x;
        if (alpha) {
          if (x > 0) {
            alpha = x;
          } else {
            timer.c = null, timer.t = NaN, timer = null;
            event.end({
              type: "end",
              alpha: alpha = 0
            });
          }
        } else if (x > 0) {
          event.start({
            type: "start",
            alpha: alpha = x
          });
          timer = d3_timer(force.tick);
        }
        return force;
      };
      force.start = function() {
        var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
        for (i = 0; i < n; ++i) {
          (o = nodes[i]).index = i;
          o.weight = 0;
        }
        for (i = 0; i < m; ++i) {
          o = links[i];
          if (typeof o.source == "number") o.source = nodes[o.source];
          if (typeof o.target == "number") o.target = nodes[o.target];
          ++o.source.weight;
          ++o.target.weight;
        }
        for (i = 0; i < n; ++i) {
          o = nodes[i];
          if (isNaN(o.x)) o.x = position("x", w);
          if (isNaN(o.y)) o.y = position("y", h);
          if (isNaN(o.px)) o.px = o.x;
          if (isNaN(o.py)) o.py = o.y;
        }
        distances = [];
        if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
        strengths = [];
        if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
        charges = [];
        if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
        function position(dimension, size) {
          if (!neighbors) {
            neighbors = new Array(n);
            for (j = 0; j < n; ++j) {
              neighbors[j] = [];
            }
            for (j = 0; j < m; ++j) {
              var o = links[j];
              neighbors[o.source.index].push(o.target);
              neighbors[o.target.index].push(o.source);
            }
          }
          var candidates = neighbors[i], j = -1, l = candidates.length, x;
          while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
          return Math.random() * size;
        }
        return force.resume();
      };
      force.resume = function() {
        return force.alpha(.1);
      };
      force.stop = function() {
        return force.alpha(0);
      };
      force.drag = function() {
        if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
        if (!arguments.length) return drag;
        this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
      };
      function dragmove(d) {
        d.px = d3.event.x, d.py = d3.event.y;
        force.resume();
      }
      return d3.rebind(force, event, "on");
    };
    function d3_layout_forceDragstart(d) {
      d.fixed |= 2;
    }
    function d3_layout_forceDragend(d) {
      d.fixed &= ~6;
    }
    function d3_layout_forceMouseover(d) {
      d.fixed |= 4;
      d.px = d.x, d.py = d.y;
    }
    function d3_layout_forceMouseout(d) {
      d.fixed &= ~4;
    }
    function d3_layout_forceAccumulate(quad, alpha, charges) {
      var cx = 0, cy = 0;
      quad.charge = 0;
      if (!quad.leaf) {
        var nodes = quad.nodes, n = nodes.length, i = -1, c;
        while (++i < n) {
          c = nodes[i];
          if (c == null) continue;
          d3_layout_forceAccumulate(c, alpha, charges);
          quad.charge += c.charge;
          cx += c.charge * c.cx;
          cy += c.charge * c.cy;
        }
      }
      if (quad.point) {
        if (!quad.leaf) {
          quad.point.x += Math.random() - .5;
          quad.point.y += Math.random() - .5;
        }
        var k = alpha * charges[quad.point.index];
        quad.charge += quad.pointCharge = k;
        cx += k * quad.point.x;
        cy += k * quad.point.y;
      }
      quad.cx = cx / quad.charge;
      quad.cy = cy / quad.charge;
    }
    var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
    d3.layout.hierarchy = function() {
      var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
      function hierarchy(root) {
        var stack = [ root ], nodes = [], node;
        root.depth = 0;
        while ((node = stack.pop()) != null) {
          nodes.push(node);
          if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
            var n, childs, child;
            while (--n >= 0) {
              stack.push(child = childs[n]);
              child.parent = node;
              child.depth = node.depth + 1;
            }
            if (value) node.value = 0;
            node.children = childs;
          } else {
            if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
            delete node.children;
          }
        }
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var childs, parent;
          if (sort && (childs = node.children)) childs.sort(sort);
          if (value && (parent = node.parent)) parent.value += node.value;
        });
        return nodes;
      }
      hierarchy.sort = function(x) {
        if (!arguments.length) return sort;
        sort = x;
        return hierarchy;
      };
      hierarchy.children = function(x) {
        if (!arguments.length) return children;
        children = x;
        return hierarchy;
      };
      hierarchy.value = function(x) {
        if (!arguments.length) return value;
        value = x;
        return hierarchy;
      };
      hierarchy.revalue = function(root) {
        if (value) {
          d3_layout_hierarchyVisitBefore(root, function(node) {
            if (node.children) node.value = 0;
          });
          d3_layout_hierarchyVisitAfter(root, function(node) {
            var parent;
            if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
            if (parent = node.parent) parent.value += node.value;
          });
        }
        return root;
      };
      return hierarchy;
    };
    function d3_layout_hierarchyRebind(object, hierarchy) {
      d3.rebind(object, hierarchy, "sort", "children", "value");
      object.nodes = object;
      object.links = d3_layout_hierarchyLinks;
      return object;
    }
    function d3_layout_hierarchyVisitBefore(node, callback) {
      var nodes = [ node ];
      while ((node = nodes.pop()) != null) {
        callback(node);
        if ((children = node.children) && (n = children.length)) {
          var n, children;
          while (--n >= 0) nodes.push(children[n]);
        }
      }
    }
    function d3_layout_hierarchyVisitAfter(node, callback) {
      var nodes = [ node ], nodes2 = [];
      while ((node = nodes.pop()) != null) {
        nodes2.push(node);
        if ((children = node.children) && (n = children.length)) {
          var i = -1, n, children;
          while (++i < n) nodes.push(children[i]);
        }
      }
      while ((node = nodes2.pop()) != null) {
        callback(node);
      }
    }
    function d3_layout_hierarchyChildren(d) {
      return d.children;
    }
    function d3_layout_hierarchyValue(d) {
      return d.value;
    }
    function d3_layout_hierarchySort(a, b) {
      return b.value - a.value;
    }
    function d3_layout_hierarchyLinks(nodes) {
      return d3.merge(nodes.map(function(parent) {
        return (parent.children || []).map(function(child) {
          return {
            source: parent,
            target: child
          };
        });
      }));
    }
    d3.layout.partition = function() {
      var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
      function position(node, x, dx, dy) {
        var children = node.children;
        node.x = x;
        node.y = node.depth * dy;
        node.dx = dx;
        node.dy = dy;
        if (children && (n = children.length)) {
          var i = -1, n, c, d;
          dx = node.value ? dx / node.value : 0;
          while (++i < n) {
            position(c = children[i], x, d = c.value * dx, dy);
            x += d;
          }
        }
      }
      function depth(node) {
        var children = node.children, d = 0;
        if (children && (n = children.length)) {
          var i = -1, n;
          while (++i < n) d = Math.max(d, depth(children[i]));
        }
        return 1 + d;
      }
      function partition(d, i) {
        var nodes = hierarchy.call(this, d, i);
        position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
        return nodes;
      }
      partition.size = function(x) {
        if (!arguments.length) return size;
        size = x;
        return partition;
      };
      return d3_layout_hierarchyRebind(partition, hierarchy);
    };
    d3.layout.pie = function() {
      var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
      function pie(data) {
        var n = data.length, values = data.map(function(d, i) {
          return +value.call(pie, d, i);
        }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
        if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
          return values[j] - values[i];
        } : function(i, j) {
          return sort(data[i], data[j]);
        });
        index.forEach(function(i) {
          arcs[i] = {
            data: data[i],
            value: v = values[i],
            startAngle: a,
            endAngle: a += v * k + pa,
            padAngle: p
          };
        });
        return arcs;
      }
      pie.value = function(_) {
        if (!arguments.length) return value;
        value = _;
        return pie;
      };
      pie.sort = function(_) {
        if (!arguments.length) return sort;
        sort = _;
        return pie;
      };
      pie.startAngle = function(_) {
        if (!arguments.length) return startAngle;
        startAngle = _;
        return pie;
      };
      pie.endAngle = function(_) {
        if (!arguments.length) return endAngle;
        endAngle = _;
        return pie;
      };
      pie.padAngle = function(_) {
        if (!arguments.length) return padAngle;
        padAngle = _;
        return pie;
      };
      return pie;
    };
    var d3_layout_pieSortByValue = {};
    d3.layout.stack = function() {
      var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
      function stack(data, index) {
        if (!(n = data.length)) return data;
        var series = data.map(function(d, i) {
          return values.call(stack, d, i);
        });
        var points = series.map(function(d) {
          return d.map(function(v, i) {
            return [ x.call(stack, v, i), y.call(stack, v, i) ];
          });
        });
        var orders = order.call(stack, points, index);
        series = d3.permute(series, orders);
        points = d3.permute(points, orders);
        var offsets = offset.call(stack, points, index);
        var m = series[0].length, n, i, j, o;
        for (j = 0; j < m; ++j) {
          out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
          for (i = 1; i < n; ++i) {
            out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
          }
        }
        return data;
      }
      stack.values = function(x) {
        if (!arguments.length) return values;
        values = x;
        return stack;
      };
      stack.order = function(x) {
        if (!arguments.length) return order;
        order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
        return stack;
      };
      stack.offset = function(x) {
        if (!arguments.length) return offset;
        offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
        return stack;
      };
      stack.x = function(z) {
        if (!arguments.length) return x;
        x = z;
        return stack;
      };
      stack.y = function(z) {
        if (!arguments.length) return y;
        y = z;
        return stack;
      };
      stack.out = function(z) {
        if (!arguments.length) return out;
        out = z;
        return stack;
      };
      return stack;
    };
    function d3_layout_stackX(d) {
      return d.x;
    }
    function d3_layout_stackY(d) {
      return d.y;
    }
    function d3_layout_stackOut(d, y0, y) {
      d.y0 = y0;
      d.y = y;
    }
    var d3_layout_stackOrders = d3.map({
      "inside-out": function(data) {
        var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
          return max[a] - max[b];
        }), top = 0, bottom = 0, tops = [], bottoms = [];
        for (i = 0; i < n; ++i) {
          j = index[i];
          if (top < bottom) {
            top += sums[j];
            tops.push(j);
          } else {
            bottom += sums[j];
            bottoms.push(j);
          }
        }
        return bottoms.reverse().concat(tops);
      },
      reverse: function(data) {
        return d3.range(data.length).reverse();
      },
      "default": d3_layout_stackOrderDefault
    });
    var d3_layout_stackOffsets = d3.map({
      silhouette: function(data) {
        var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
        for (j = 0; j < m; ++j) {
          for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
          if (o > max) max = o;
          sums.push(o);
        }
        for (j = 0; j < m; ++j) {
          y0[j] = (max - sums[j]) / 2;
        }
        return y0;
      },
      wiggle: function(data) {
        var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
        y0[0] = o = o0 = 0;
        for (j = 1; j < m; ++j) {
          for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
          for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
            for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
              s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
            }
            s2 += s3 * data[i][j][1];
          }
          y0[j] = o -= s1 ? s2 / s1 * dx : 0;
          if (o < o0) o0 = o;
        }
        for (j = 0; j < m; ++j) y0[j] -= o0;
        return y0;
      },
      expand: function(data) {
        var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
        for (j = 0; j < m; ++j) {
          for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
          if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
        }
        for (j = 0; j < m; ++j) y0[j] = 0;
        return y0;
      },
      zero: d3_layout_stackOffsetZero
    });
    function d3_layout_stackOrderDefault(data) {
      return d3.range(data.length);
    }
    function d3_layout_stackOffsetZero(data) {
      var j = -1, m = data[0].length, y0 = [];
      while (++j < m) y0[j] = 0;
      return y0;
    }
    function d3_layout_stackMaxIndex(array) {
      var i = 1, j = 0, v = array[0][1], k, n = array.length;
      for (;i < n; ++i) {
        if ((k = array[i][1]) > v) {
          j = i;
          v = k;
        }
      }
      return j;
    }
    function d3_layout_stackReduceSum(d) {
      return d.reduce(d3_layout_stackSum, 0);
    }
    function d3_layout_stackSum(p, d) {
      return p + d[1];
    }
    d3.layout.histogram = function() {
      var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
      function histogram(data, i) {
        var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
        while (++i < m) {
          bin = bins[i] = [];
          bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
          bin.y = 0;
        }
        if (m > 0) {
          i = -1;
          while (++i < n) {
            x = values[i];
            if (x >= range[0] && x <= range[1]) {
              bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
              bin.y += k;
              bin.push(data[i]);
            }
          }
        }
        return bins;
      }
      histogram.value = function(x) {
        if (!arguments.length) return valuer;
        valuer = x;
        return histogram;
      };
      histogram.range = function(x) {
        if (!arguments.length) return ranger;
        ranger = d3_functor(x);
        return histogram;
      };
      histogram.bins = function(x) {
        if (!arguments.length) return binner;
        binner = typeof x === "number" ? function(range) {
          return d3_layout_histogramBinFixed(range, x);
        } : d3_functor(x);
        return histogram;
      };
      histogram.frequency = function(x) {
        if (!arguments.length) return frequency;
        frequency = !!x;
        return histogram;
      };
      return histogram;
    };
    function d3_layout_histogramBinSturges(range, values) {
      return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
    }
    function d3_layout_histogramBinFixed(range, n) {
      var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
      while (++x <= n) f[x] = m * x + b;
      return f;
    }
    function d3_layout_histogramRange(values) {
      return [ d3.min(values), d3.max(values) ];
    }
    d3.layout.pack = function() {
      var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
      function pack(d, i) {
        var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
          return radius;
        };
        root.x = root.y = 0;
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r = +r(d.value);
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        if (padding) {
          var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
          d3_layout_hierarchyVisitAfter(root, function(d) {
            d.r += dr;
          });
          d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
          d3_layout_hierarchyVisitAfter(root, function(d) {
            d.r -= dr;
          });
        }
        d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
        return nodes;
      }
      pack.size = function(_) {
        if (!arguments.length) return size;
        size = _;
        return pack;
      };
      pack.radius = function(_) {
        if (!arguments.length) return radius;
        radius = _ == null || typeof _ === "function" ? _ : +_;
        return pack;
      };
      pack.padding = function(_) {
        if (!arguments.length) return padding;
        padding = +_;
        return pack;
      };
      return d3_layout_hierarchyRebind(pack, hierarchy);
    };
    function d3_layout_packSort(a, b) {
      return a.value - b.value;
    }
    function d3_layout_packInsert(a, b) {
      var c = a._pack_next;
      a._pack_next = b;
      b._pack_prev = a;
      b._pack_next = c;
      c._pack_prev = b;
    }
    function d3_layout_packSplice(a, b) {
      a._pack_next = b;
      b._pack_prev = a;
    }
    function d3_layout_packIntersects(a, b) {
      var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
      return .999 * dr * dr > dx * dx + dy * dy;
    }
    function d3_layout_packSiblings(node) {
      if (!(nodes = node.children) || !(n = nodes.length)) return;
      var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
      function bound(node) {
        xMin = Math.min(node.x - node.r, xMin);
        xMax = Math.max(node.x + node.r, xMax);
        yMin = Math.min(node.y - node.r, yMin);
        yMax = Math.max(node.y + node.r, yMax);
      }
      nodes.forEach(d3_layout_packLink);
      a = nodes[0];
      a.x = -a.r;
      a.y = 0;
      bound(a);
      if (n > 1) {
        b = nodes[1];
        b.x = b.r;
        b.y = 0;
        bound(b);
        if (n > 2) {
          c = nodes[2];
          d3_layout_packPlace(a, b, c);
          bound(c);
          d3_layout_packInsert(a, c);
          a._pack_prev = c;
          d3_layout_packInsert(c, b);
          b = a._pack_next;
          for (i = 3; i < n; i++) {
            d3_layout_packPlace(a, b, c = nodes[i]);
            var isect = 0, s1 = 1, s2 = 1;
            for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
              if (d3_layout_packIntersects(j, c)) {
                isect = 1;
                break;
              }
            }
            if (isect == 1) {
              for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
                if (d3_layout_packIntersects(k, c)) {
                  break;
                }
              }
            }
            if (isect) {
              if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
              i--;
            } else {
              d3_layout_packInsert(a, c);
              b = c;
              bound(c);
            }
          }
        }
      }
      var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
      for (i = 0; i < n; i++) {
        c = nodes[i];
        c.x -= cx;
        c.y -= cy;
        cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
      }
      node.r = cr;
      nodes.forEach(d3_layout_packUnlink);
    }
    function d3_layout_packLink(node) {
      node._pack_next = node._pack_prev = node;
    }
    function d3_layout_packUnlink(node) {
      delete node._pack_next;
      delete node._pack_prev;
    }
    function d3_layout_packTransform(node, x, y, k) {
      var children = node.children;
      node.x = x += k * node.x;
      node.y = y += k * node.y;
      node.r *= k;
      if (children) {
        var i = -1, n = children.length;
        while (++i < n) d3_layout_packTransform(children[i], x, y, k);
      }
    }
    function d3_layout_packPlace(a, b, c) {
      var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
      if (db && (dx || dy)) {
        var da = b.r + c.r, dc = dx * dx + dy * dy;
        da *= da;
        db *= db;
        var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
        c.x = a.x + x * dx + y * dy;
        c.y = a.y + x * dy - y * dx;
      } else {
        c.x = a.x + db;
        c.y = a.y;
      }
    }
    d3.layout.tree = function() {
      var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
      function tree(d, i) {
        var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
        d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
        d3_layout_hierarchyVisitBefore(root1, secondWalk);
        if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
          var left = root0, right = root0, bottom = root0;
          d3_layout_hierarchyVisitBefore(root0, function(node) {
            if (node.x < left.x) left = node;
            if (node.x > right.x) right = node;
            if (node.depth > bottom.depth) bottom = node;
          });
          var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
          d3_layout_hierarchyVisitBefore(root0, function(node) {
            node.x = (node.x + tx) * kx;
            node.y = node.depth * ky;
          });
        }
        return nodes;
      }
      function wrapTree(root0) {
        var root1 = {
          A: null,
          children: [ root0 ]
        }, queue = [ root1 ], node1;
        while ((node1 = queue.pop()) != null) {
          for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
            queue.push((children[i] = child = {
              _: children[i],
              parent: node1,
              children: (child = children[i].children) && child.slice() || [],
              A: null,
              a: null,
              z: 0,
              m: 0,
              c: 0,
              s: 0,
              t: null,
              i: i
            }).a = child);
          }
        }
        return root1.children[0];
      }
      function firstWalk(v) {
        var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
        if (children.length) {
          d3_layout_treeShift(v);
          var midpoint = (children[0].z + children[children.length - 1].z) / 2;
          if (w) {
            v.z = w.z + separation(v._, w._);
            v.m = v.z - midpoint;
          } else {
            v.z = midpoint;
          }
        } else if (w) {
          v.z = w.z + separation(v._, w._);
        }
        v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
      }
      function secondWalk(v) {
        v._.x = v.z + v.parent.m;
        v.m += v.parent.m;
      }
      function apportion(v, w, ancestor) {
        if (w) {
          var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
          while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
            vom = d3_layout_treeLeft(vom);
            vop = d3_layout_treeRight(vop);
            vop.a = v;
            shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
            if (shift > 0) {
              d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
              sip += shift;
              sop += shift;
            }
            sim += vim.m;
            sip += vip.m;
            som += vom.m;
            sop += vop.m;
          }
          if (vim && !d3_layout_treeRight(vop)) {
            vop.t = vim;
            vop.m += sim - sop;
          }
          if (vip && !d3_layout_treeLeft(vom)) {
            vom.t = vip;
            vom.m += sip - som;
            ancestor = v;
          }
        }
        return ancestor;
      }
      function sizeNode(node) {
        node.x *= size[0];
        node.y = node.depth * size[1];
      }
      tree.separation = function(x) {
        if (!arguments.length) return separation;
        separation = x;
        return tree;
      };
      tree.size = function(x) {
        if (!arguments.length) return nodeSize ? null : size;
        nodeSize = (size = x) == null ? sizeNode : null;
        return tree;
      };
      tree.nodeSize = function(x) {
        if (!arguments.length) return nodeSize ? size : null;
        nodeSize = (size = x) == null ? null : sizeNode;
        return tree;
      };
      return d3_layout_hierarchyRebind(tree, hierarchy);
    };
    function d3_layout_treeSeparation(a, b) {
      return a.parent == b.parent ? 1 : 2;
    }
    function d3_layout_treeLeft(v) {
      var children = v.children;
      return children.length ? children[0] : v.t;
    }
    function d3_layout_treeRight(v) {
      var children = v.children, n;
      return (n = children.length) ? children[n - 1] : v.t;
    }
    function d3_layout_treeMove(wm, wp, shift) {
      var change = shift / (wp.i - wm.i);
      wp.c -= change;
      wp.s += shift;
      wm.c += change;
      wp.z += shift;
      wp.m += shift;
    }
    function d3_layout_treeShift(v) {
      var shift = 0, change = 0, children = v.children, i = children.length, w;
      while (--i >= 0) {
        w = children[i];
        w.z += shift;
        w.m += shift;
        shift += w.s + (change += w.c);
      }
    }
    function d3_layout_treeAncestor(vim, v, ancestor) {
      return vim.a.parent === v.parent ? vim.a : ancestor;
    }
    d3.layout.cluster = function() {
      var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
      function cluster(d, i) {
        var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var children = node.children;
          if (children && children.length) {
            node.x = d3_layout_clusterX(children);
            node.y = d3_layout_clusterY(children);
          } else {
            node.x = previousNode ? x += separation(node, previousNode) : 0;
            node.y = 0;
            previousNode = node;
          }
        });
        var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
        d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
          node.x = (node.x - root.x) * size[0];
          node.y = (root.y - node.y) * size[1];
        } : function(node) {
          node.x = (node.x - x0) / (x1 - x0) * size[0];
          node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
        });
        return nodes;
      }
      cluster.separation = function(x) {
        if (!arguments.length) return separation;
        separation = x;
        return cluster;
      };
      cluster.size = function(x) {
        if (!arguments.length) return nodeSize ? null : size;
        nodeSize = (size = x) == null;
        return cluster;
      };
      cluster.nodeSize = function(x) {
        if (!arguments.length) return nodeSize ? size : null;
        nodeSize = (size = x) != null;
        return cluster;
      };
      return d3_layout_hierarchyRebind(cluster, hierarchy);
    };
    function d3_layout_clusterY(children) {
      return 1 + d3.max(children, function(child) {
        return child.y;
      });
    }
    function d3_layout_clusterX(children) {
      return children.reduce(function(x, child) {
        return x + child.x;
      }, 0) / children.length;
    }
    function d3_layout_clusterLeft(node) {
      var children = node.children;
      return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
    }
    function d3_layout_clusterRight(node) {
      var children = node.children, n;
      return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
    }
    d3.layout.treemap = function() {
      var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
      function scale(children, k) {
        var i = -1, n = children.length, child, area;
        while (++i < n) {
          area = (child = children[i]).value * (k < 0 ? 0 : k);
          child.area = isNaN(area) || area <= 0 ? 0 : area;
        }
      }
      function squarify(node) {
        var children = node.children;
        if (children && children.length) {
          var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
          scale(remaining, rect.dx * rect.dy / node.value);
          row.area = 0;
          while ((n = remaining.length) > 0) {
            row.push(child = remaining[n - 1]);
            row.area += child.area;
            if (mode !== "squarify" || (score = worst(row, u)) <= best) {
              remaining.pop();
              best = score;
            } else {
              row.area -= row.pop().area;
              position(row, u, rect, false);
              u = Math.min(rect.dx, rect.dy);
              row.length = row.area = 0;
              best = Infinity;
            }
          }
          if (row.length) {
            position(row, u, rect, true);
            row.length = row.area = 0;
          }
          children.forEach(squarify);
        }
      }
      function stickify(node) {
        var children = node.children;
        if (children && children.length) {
          var rect = pad(node), remaining = children.slice(), child, row = [];
          scale(remaining, rect.dx * rect.dy / node.value);
          row.area = 0;
          while (child = remaining.pop()) {
            row.push(child);
            row.area += child.area;
            if (child.z != null) {
              position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
              row.length = row.area = 0;
            }
          }
          children.forEach(stickify);
        }
      }
      function worst(row, u) {
        var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
        while (++i < n) {
          if (!(r = row[i].area)) continue;
          if (r < rmin) rmin = r;
          if (r > rmax) rmax = r;
        }
        s *= s;
        u *= u;
        return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
      }
      function position(row, u, rect, flush) {
        var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
        if (u == rect.dx) {
          if (flush || v > rect.dy) v = rect.dy;
          while (++i < n) {
            o = row[i];
            o.x = x;
            o.y = y;
            o.dy = v;
            x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
          }
          o.z = true;
          o.dx += rect.x + rect.dx - x;
          rect.y += v;
          rect.dy -= v;
        } else {
          if (flush || v > rect.dx) v = rect.dx;
          while (++i < n) {
            o = row[i];
            o.x = x;
            o.y = y;
            o.dx = v;
            y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
          }
          o.z = false;
          o.dy += rect.y + rect.dy - y;
          rect.x += v;
          rect.dx -= v;
        }
      }
      function treemap(d) {
        var nodes = stickies || hierarchy(d), root = nodes[0];
        root.x = root.y = 0;
        if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
        if (stickies) hierarchy.revalue(root);
        scale([ root ], root.dx * root.dy / root.value);
        (stickies ? stickify : squarify)(root);
        if (sticky) stickies = nodes;
        return nodes;
      }
      treemap.size = function(x) {
        if (!arguments.length) return size;
        size = x;
        return treemap;
      };
      treemap.padding = function(x) {
        if (!arguments.length) return padding;
        function padFunction(node) {
          var p = x.call(treemap, node, node.depth);
          return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
        }
        function padConstant(node) {
          return d3_layout_treemapPad(node, x);
        }
        var type;
        pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
        padConstant) : padConstant;
        return treemap;
      };
      treemap.round = function(x) {
        if (!arguments.length) return round != Number;
        round = x ? Math.round : Number;
        return treemap;
      };
      treemap.sticky = function(x) {
        if (!arguments.length) return sticky;
        sticky = x;
        stickies = null;
        return treemap;
      };
      treemap.ratio = function(x) {
        if (!arguments.length) return ratio;
        ratio = x;
        return treemap;
      };
      treemap.mode = function(x) {
        if (!arguments.length) return mode;
        mode = x + "";
        return treemap;
      };
      return d3_layout_hierarchyRebind(treemap, hierarchy);
    };
    function d3_layout_treemapPadNull(node) {
      return {
        x: node.x,
        y: node.y,
        dx: node.dx,
        dy: node.dy
      };
    }
    function d3_layout_treemapPad(node, padding) {
      var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
      if (dx < 0) {
        x += dx / 2;
        dx = 0;
      }
      if (dy < 0) {
        y += dy / 2;
        dy = 0;
      }
      return {
        x: x,
        y: y,
        dx: dx,
        dy: dy
      };
    }
    d3.random = {
      normal: function(µ, σ) {
        var n = arguments.length;
        if (n < 2) σ = 1;
        if (n < 1) µ = 0;
        return function() {
          var x, y, r;
          do {
            x = Math.random() * 2 - 1;
            y = Math.random() * 2 - 1;
            r = x * x + y * y;
          } while (!r || r > 1);
          return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
        };
      },
      logNormal: function() {
        var random = d3.random.normal.apply(d3, arguments);
        return function() {
          return Math.exp(random());
        };
      },
      bates: function(m) {
        var random = d3.random.irwinHall(m);
        return function() {
          return random() / m;
        };
      },
      irwinHall: function(m) {
        return function() {
          for (var s = 0, j = 0; j < m; j++) s += Math.random();
          return s;
        };
      }
    };
    d3.scale = {};
    function d3_scaleExtent(domain) {
      var start = domain[0], stop = domain[domain.length - 1];
      return start < stop ? [ start, stop ] : [ stop, start ];
    }
    function d3_scaleRange(scale) {
      return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
    }
    function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
      var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
      return function(x) {
        return i(u(x));
      };
    }
    function d3_scale_nice(domain, nice) {
      var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
      if (x1 < x0) {
        dx = i0, i0 = i1, i1 = dx;
        dx = x0, x0 = x1, x1 = dx;
      }
      domain[i0] = nice.floor(x0);
      domain[i1] = nice.ceil(x1);
      return domain;
    }
    function d3_scale_niceStep(step) {
      return step ? {
        floor: function(x) {
          return Math.floor(x / step) * step;
        },
        ceil: function(x) {
          return Math.ceil(x / step) * step;
        }
      } : d3_scale_niceIdentity;
    }
    var d3_scale_niceIdentity = {
      floor: d3_identity,
      ceil: d3_identity
    };
    function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
      var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
      if (domain[k] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
      }
      while (++j <= k) {
        u.push(uninterpolate(domain[j - 1], domain[j]));
        i.push(interpolate(range[j - 1], range[j]));
      }
      return function(x) {
        var j = d3.bisect(domain, x, 1, k) - 1;
        return i[j](u[j](x));
      };
    }
    d3.scale.linear = function() {
      return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
    };
    function d3_scale_linear(domain, range, interpolate, clamp) {
      var output, input;
      function rescale() {
        var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
        output = linear(domain, range, uninterpolate, interpolate);
        input = linear(range, domain, uninterpolate, d3_interpolate);
        return scale;
      }
      function scale(x) {
        return output(x);
      }
      scale.invert = function(y) {
        return input(y);
      };
      scale.domain = function(x) {
        if (!arguments.length) return domain;
        domain = x.map(Number);
        return rescale();
      };
      scale.range = function(x) {
        if (!arguments.length) return range;
        range = x;
        return rescale();
      };
      scale.rangeRound = function(x) {
        return scale.range(x).interpolate(d3_interpolateRound);
      };
      scale.clamp = function(x) {
        if (!arguments.length) return clamp;
        clamp = x;
        return rescale();
      };
      scale.interpolate = function(x) {
        if (!arguments.length) return interpolate;
        interpolate = x;
        return rescale();
      };
      scale.ticks = function(m) {
        return d3_scale_linearTicks(domain, m);
      };
      scale.tickFormat = function(m, format) {
        return d3_scale_linearTickFormat(domain, m, format);
      };
      scale.nice = function(m) {
        d3_scale_linearNice(domain, m);
        return rescale();
      };
      scale.copy = function() {
        return d3_scale_linear(domain, range, interpolate, clamp);
      };
      return rescale();
    }
    function d3_scale_linearRebind(scale, linear) {
      return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
    }
    function d3_scale_linearNice(domain, m) {
      d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
      d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
      return domain;
    }
    function d3_scale_linearTickRange(domain, m) {
      if (m == null) m = 10;
      var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
      if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
      extent[0] = Math.ceil(extent[0] / step) * step;
      extent[1] = Math.floor(extent[1] / step) * step + step * .5;
      extent[2] = step;
      return extent;
    }
    function d3_scale_linearTicks(domain, m) {
      return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
    }
    function d3_scale_linearTickFormat(domain, m, format) {
      var range = d3_scale_linearTickRange(domain, m);
      if (format) {
        var match = d3_format_re.exec(format);
        match.shift();
        if (match[8] === "s") {
          var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
          if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
          match[8] = "f";
          format = d3.format(match.join(""));
          return function(d) {
            return format(prefix.scale(d)) + prefix.symbol;
          };
        }
        if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
        format = match.join("");
      } else {
        format = ",." + d3_scale_linearPrecision(range[2]) + "f";
      }
      return d3.format(format);
    }
    var d3_scale_linearFormatSignificant = {
      s: 1,
      g: 1,
      p: 1,
      r: 1,
      e: 1
    };
    function d3_scale_linearPrecision(value) {
      return -Math.floor(Math.log(value) / Math.LN10 + .01);
    }
    function d3_scale_linearFormatPrecision(type, range) {
      var p = d3_scale_linearPrecision(range[2]);
      return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
    }
    d3.scale.log = function() {
      return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
    };
    function d3_scale_log(linear, base, positive, domain) {
      function log(x) {
        return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
      }
      function pow(x) {
        return positive ? Math.pow(base, x) : -Math.pow(base, -x);
      }
      function scale(x) {
        return linear(log(x));
      }
      scale.invert = function(x) {
        return pow(linear.invert(x));
      };
      scale.domain = function(x) {
        if (!arguments.length) return domain;
        positive = x[0] >= 0;
        linear.domain((domain = x.map(Number)).map(log));
        return scale;
      };
      scale.base = function(_) {
        if (!arguments.length) return base;
        base = +_;
        linear.domain(domain.map(log));
        return scale;
      };
      scale.nice = function() {
        var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
        linear.domain(niced);
        domain = niced.map(pow);
        return scale;
      };
      scale.ticks = function() {
        var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
        if (isFinite(j - i)) {
          if (positive) {
            for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
            ticks.push(pow(i));
          } else {
            ticks.push(pow(i));
            for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
          }
          for (i = 0; ticks[i] < u; i++) {}
          for (j = ticks.length; ticks[j - 1] > v; j--) {}
          ticks = ticks.slice(i, j);
        }
        return ticks;
      };
      scale.tickFormat = function(n, format) {
        if (!arguments.length) return d3_scale_logFormat;
        if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
        var k = Math.max(1, base * n / scale.ticks().length);
        return function(d) {
          var i = d / pow(Math.round(log(d)));
          if (i * base < base - .5) i *= base;
          return i <= k ? format(d) : "";
        };
      };
      scale.copy = function() {
        return d3_scale_log(linear.copy(), base, positive, domain);
      };
      return d3_scale_linearRebind(scale, linear);
    }
    var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
      floor: function(x) {
        return -Math.ceil(-x);
      },
      ceil: function(x) {
        return -Math.floor(-x);
      }
    };
    d3.scale.pow = function() {
      return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
    };
    function d3_scale_pow(linear, exponent, domain) {
      var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
      function scale(x) {
        return linear(powp(x));
      }
      scale.invert = function(x) {
        return powb(linear.invert(x));
      };
      scale.domain = function(x) {
        if (!arguments.length) return domain;
        linear.domain((domain = x.map(Number)).map(powp));
        return scale;
      };
      scale.ticks = function(m) {
        return d3_scale_linearTicks(domain, m);
      };
      scale.tickFormat = function(m, format) {
        return d3_scale_linearTickFormat(domain, m, format);
      };
      scale.nice = function(m) {
        return scale.domain(d3_scale_linearNice(domain, m));
      };
      scale.exponent = function(x) {
        if (!arguments.length) return exponent;
        powp = d3_scale_powPow(exponent = x);
        powb = d3_scale_powPow(1 / exponent);
        linear.domain(domain.map(powp));
        return scale;
      };
      scale.copy = function() {
        return d3_scale_pow(linear.copy(), exponent, domain);
      };
      return d3_scale_linearRebind(scale, linear);
    }
    function d3_scale_powPow(e) {
      return function(x) {
        return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
      };
    }
    d3.scale.sqrt = function() {
      return d3.scale.pow().exponent(.5);
    };
    d3.scale.ordinal = function() {
      return d3_scale_ordinal([], {
        t: "range",
        a: [ [] ]
      });
    };
    function d3_scale_ordinal(domain, ranger) {
      var index, range, rangeBand;
      function scale(x) {
        return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
      }
      function steps(start, step) {
        return d3.range(domain.length).map(function(i) {
          return start + step * i;
        });
      }
      scale.domain = function(x) {
        if (!arguments.length) return domain;
        domain = [];
        index = new d3_Map();
        var i = -1, n = x.length, xi;
        while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
        return scale[ranger.t].apply(scale, ranger.a);
      };
      scale.range = function(x) {
        if (!arguments.length) return range;
        range = x;
        rangeBand = 0;
        ranger = {
          t: "range",
          a: arguments
        };
        return scale;
      };
      scale.rangePoints = function(x, padding) {
        if (arguments.length < 2) padding = 0;
        var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
        0) : (stop - start) / (domain.length - 1 + padding);
        range = steps(start + step * padding / 2, step);
        rangeBand = 0;
        ranger = {
          t: "rangePoints",
          a: arguments
        };
        return scale;
      };
      scale.rangeRoundPoints = function(x, padding) {
        if (arguments.length < 2) padding = 0;
        var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
        0) : (stop - start) / (domain.length - 1 + padding) | 0;
        range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
        rangeBand = 0;
        ranger = {
          t: "rangeRoundPoints",
          a: arguments
        };
        return scale;
      };
      scale.rangeBands = function(x, padding, outerPadding) {
        if (arguments.length < 2) padding = 0;
        if (arguments.length < 3) outerPadding = padding;
        var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
        range = steps(start + step * outerPadding, step);
        if (reverse) range.reverse();
        rangeBand = step * (1 - padding);
        ranger = {
          t: "rangeBands",
          a: arguments
        };
        return scale;
      };
      scale.rangeRoundBands = function(x, padding, outerPadding) {
        if (arguments.length < 2) padding = 0;
        if (arguments.length < 3) outerPadding = padding;
        var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
        range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
        if (reverse) range.reverse();
        rangeBand = Math.round(step * (1 - padding));
        ranger = {
          t: "rangeRoundBands",
          a: arguments
        };
        return scale;
      };
      scale.rangeBand = function() {
        return rangeBand;
      };
      scale.rangeExtent = function() {
        return d3_scaleExtent(ranger.a[0]);
      };
      scale.copy = function() {
        return d3_scale_ordinal(domain, ranger);
      };
      return scale.domain(domain);
    }
    d3.scale.category10 = function() {
      return d3.scale.ordinal().range(d3_category10);
    };
    d3.scale.category20 = function() {
      return d3.scale.ordinal().range(d3_category20);
    };
    d3.scale.category20b = function() {
      return d3.scale.ordinal().range(d3_category20b);
    };
    d3.scale.category20c = function() {
      return d3.scale.ordinal().range(d3_category20c);
    };
    var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
    var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
    var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
    var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
    d3.scale.quantile = function() {
      return d3_scale_quantile([], []);
    };
    function d3_scale_quantile(domain, range) {
      var thresholds;
      function rescale() {
        var k = 0, q = range.length;
        thresholds = [];
        while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
        return scale;
      }
      function scale(x) {
        if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
      }
      scale.domain = function(x) {
        if (!arguments.length) return domain;
        domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
        return rescale();
      };
      scale.range = function(x) {
        if (!arguments.length) return range;
        range = x;
        return rescale();
      };
      scale.quantiles = function() {
        return thresholds;
      };
      scale.invertExtent = function(y) {
        y = range.indexOf(y);
        return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
      };
      scale.copy = function() {
        return d3_scale_quantile(domain, range);
      };
      return rescale();
    }
    d3.scale.quantize = function() {
      return d3_scale_quantize(0, 1, [ 0, 1 ]);
    };
    function d3_scale_quantize(x0, x1, range) {
      var kx, i;
      function scale(x) {
        return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
      }
      function rescale() {
        kx = range.length / (x1 - x0);
        i = range.length - 1;
        return scale;
      }
      scale.domain = function(x) {
        if (!arguments.length) return [ x0, x1 ];
        x0 = +x[0];
        x1 = +x[x.length - 1];
        return rescale();
      };
      scale.range = function(x) {
        if (!arguments.length) return range;
        range = x;
        return rescale();
      };
      scale.invertExtent = function(y) {
        y = range.indexOf(y);
        y = y < 0 ? NaN : y / kx + x0;
        return [ y, y + 1 / kx ];
      };
      scale.copy = function() {
        return d3_scale_quantize(x0, x1, range);
      };
      return rescale();
    }
    d3.scale.threshold = function() {
      return d3_scale_threshold([ .5 ], [ 0, 1 ]);
    };
    function d3_scale_threshold(domain, range) {
      function scale(x) {
        if (x <= x) return range[d3.bisect(domain, x)];
      }
      scale.domain = function(_) {
        if (!arguments.length) return domain;
        domain = _;
        return scale;
      };
      scale.range = function(_) {
        if (!arguments.length) return range;
        range = _;
        return scale;
      };
      scale.invertExtent = function(y) {
        y = range.indexOf(y);
        return [ domain[y - 1], domain[y] ];
      };
      scale.copy = function() {
        return d3_scale_threshold(domain, range);
      };
      return scale;
    }
    d3.scale.identity = function() {
      return d3_scale_identity([ 0, 1 ]);
    };
    function d3_scale_identity(domain) {
      function identity(x) {
        return +x;
      }
      identity.invert = identity;
      identity.domain = identity.range = function(x) {
        if (!arguments.length) return domain;
        domain = x.map(identity);
        return identity;
      };
      identity.ticks = function(m) {
        return d3_scale_linearTicks(domain, m);
      };
      identity.tickFormat = function(m, format) {
        return d3_scale_linearTickFormat(domain, m, format);
      };
      identity.copy = function() {
        return d3_scale_identity(domain);
      };
      return identity;
    }
    d3.svg = {};
    function d3_zero() {
      return 0;
    }
    d3.svg.arc = function() {
      var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
      function arc() {
        var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
        if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
        if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
        var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
        if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
          rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
          if (!cw) p1 *= -1;
          if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
          if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
        }
        if (r1) {
          x0 = r1 * Math.cos(a0 + p1);
          y0 = r1 * Math.sin(a0 + p1);
          x1 = r1 * Math.cos(a1 - p1);
          y1 = r1 * Math.sin(a1 - p1);
          var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
          if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
            var h1 = (a0 + a1) / 2;
            x0 = r1 * Math.cos(h1);
            y0 = r1 * Math.sin(h1);
            x1 = y1 = null;
          }
        } else {
          x0 = y0 = 0;
        }
        if (r0) {
          x2 = r0 * Math.cos(a1 - p0);
          y2 = r0 * Math.sin(a1 - p0);
          x3 = r0 * Math.cos(a0 + p0);
          y3 = r0 * Math.sin(a0 + p0);
          var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
          if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
            var h0 = (a0 + a1) / 2;
            x2 = r0 * Math.cos(h0);
            y2 = r0 * Math.sin(h0);
            x3 = y3 = null;
          }
        } else {
          x2 = y2 = 0;
        }
        if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
          cr = r0 < r1 ^ cw ? 0 : 1;
          var rc1 = rc, rc0 = rc;
          if (da < π) {
            var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
            rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
          }
          if (x1 != null) {
            var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
            if (rc === rc1) {
              path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
            } else {
              path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
            }
          } else {
            path.push("M", x0, ",", y0);
          }
          if (x3 != null) {
            var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
            if (rc === rc0) {
              path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
            } else {
              path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
            }
          } else {
            path.push("L", x2, ",", y2);
          }
        } else {
          path.push("M", x0, ",", y0);
          if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
          path.push("L", x2, ",", y2);
          if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
        }
        path.push("Z");
        return path.join("");
      }
      function circleSegment(r1, cw) {
        return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
      }
      arc.innerRadius = function(v) {
        if (!arguments.length) return innerRadius;
        innerRadius = d3_functor(v);
        return arc;
      };
      arc.outerRadius = function(v) {
        if (!arguments.length) return outerRadius;
        outerRadius = d3_functor(v);
        return arc;
      };
      arc.cornerRadius = function(v) {
        if (!arguments.length) return cornerRadius;
        cornerRadius = d3_functor(v);
        return arc;
      };
      arc.padRadius = function(v) {
        if (!arguments.length) return padRadius;
        padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
        return arc;
      };
      arc.startAngle = function(v) {
        if (!arguments.length) return startAngle;
        startAngle = d3_functor(v);
        return arc;
      };
      arc.endAngle = function(v) {
        if (!arguments.length) return endAngle;
        endAngle = d3_functor(v);
        return arc;
      };
      arc.padAngle = function(v) {
        if (!arguments.length) return padAngle;
        padAngle = d3_functor(v);
        return arc;
      };
      arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
        return [ Math.cos(a) * r, Math.sin(a) * r ];
      };
      return arc;
    };
    var d3_svg_arcAuto = "auto";
    function d3_svg_arcInnerRadius(d) {
      return d.innerRadius;
    }
    function d3_svg_arcOuterRadius(d) {
      return d.outerRadius;
    }
    function d3_svg_arcStartAngle(d) {
      return d.startAngle;
    }
    function d3_svg_arcEndAngle(d) {
      return d.endAngle;
    }
    function d3_svg_arcPadAngle(d) {
      return d && d.padAngle;
    }
    function d3_svg_arcSweep(x0, y0, x1, y1) {
      return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
    }
    function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
      var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
      if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
      return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
    }
    function d3_svg_line(projection) {
      var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
      function line(data) {
        var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
        function segment() {
          segments.push("M", interpolate(projection(points), tension));
        }
        while (++i < n) {
          if (defined.call(this, d = data[i], i)) {
            points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
          } else if (points.length) {
            segment();
            points = [];
          }
        }
        if (points.length) segment();
        return segments.length ? segments.join("") : null;
      }
      line.x = function(_) {
        if (!arguments.length) return x;
        x = _;
        return line;
      };
      line.y = function(_) {
        if (!arguments.length) return y;
        y = _;
        return line;
      };
      line.defined = function(_) {
        if (!arguments.length) return defined;
        defined = _;
        return line;
      };
      line.interpolate = function(_) {
        if (!arguments.length) return interpolateKey;
        if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
        return line;
      };
      line.tension = function(_) {
        if (!arguments.length) return tension;
        tension = _;
        return line;
      };
      return line;
    }
    d3.svg.line = function() {
      return d3_svg_line(d3_identity);
    };
    var d3_svg_lineInterpolators = d3.map({
      linear: d3_svg_lineLinear,
      "linear-closed": d3_svg_lineLinearClosed,
      step: d3_svg_lineStep,
      "step-before": d3_svg_lineStepBefore,
      "step-after": d3_svg_lineStepAfter,
      basis: d3_svg_lineBasis,
      "basis-open": d3_svg_lineBasisOpen,
      "basis-closed": d3_svg_lineBasisClosed,
      bundle: d3_svg_lineBundle,
      cardinal: d3_svg_lineCardinal,
      "cardinal-open": d3_svg_lineCardinalOpen,
      "cardinal-closed": d3_svg_lineCardinalClosed,
      monotone: d3_svg_lineMonotone
    });
    d3_svg_lineInterpolators.forEach(function(key, value) {
      value.key = key;
      value.closed = /-closed$/.test(key);
    });
    function d3_svg_lineLinear(points) {
      return points.length > 1 ? points.join("L") : points + "Z";
    }
    function d3_svg_lineLinearClosed(points) {
      return points.join("L") + "Z";
    }
    function d3_svg_lineStep(points) {
      var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
      while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
      if (n > 1) path.push("H", p[0]);
      return path.join("");
    }
    function d3_svg_lineStepBefore(points) {
      var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
      while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
      return path.join("");
    }
    function d3_svg_lineStepAfter(points) {
      var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
      while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
      return path.join("");
    }
    function d3_svg_lineCardinalOpen(points, tension) {
      return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
    }
    function d3_svg_lineCardinalClosed(points, tension) {
      return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
      points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
    }
    function d3_svg_lineCardinal(points, tension) {
      return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
    }
    function d3_svg_lineHermite(points, tangents) {
      if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
        return d3_svg_lineLinear(points);
      }
      var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
      if (quad) {
        path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
        p0 = points[1];
        pi = 2;
      }
      if (tangents.length > 1) {
        t = tangents[1];
        p = points[pi];
        pi++;
        path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
        for (var i = 2; i < tangents.length; i++, pi++) {
          p = points[pi];
          t = tangents[i];
          path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
        }
      }
      if (quad) {
        var lp = points[pi];
        path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
      }
      return path;
    }
    function d3_svg_lineCardinalTangents(points, tension) {
      var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
      while (++i < n) {
        p0 = p1;
        p1 = p2;
        p2 = points[i];
        tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
      }
      return tangents;
    }
    function d3_svg_lineBasis(points) {
      if (points.length < 3) return d3_svg_lineLinear(points);
      var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
      points.push(points[n - 1]);
      while (++i <= n) {
        pi = points[i];
        px.shift();
        px.push(pi[0]);
        py.shift();
        py.push(pi[1]);
        d3_svg_lineBasisBezier(path, px, py);
      }
      points.pop();
      path.push("L", pi);
      return path.join("");
    }
    function d3_svg_lineBasisOpen(points) {
      if (points.length < 4) return d3_svg_lineLinear(points);
      var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
      while (++i < 3) {
        pi = points[i];
        px.push(pi[0]);
        py.push(pi[1]);
      }
      path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
      --i;
      while (++i < n) {
        pi = points[i];
        px.shift();
        px.push(pi[0]);
        py.shift();
        py.push(pi[1]);
        d3_svg_lineBasisBezier(path, px, py);
      }
      return path.join("");
    }
    function d3_svg_lineBasisClosed(points) {
      var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
      while (++i < 4) {
        pi = points[i % n];
        px.push(pi[0]);
        py.push(pi[1]);
      }
      path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
      --i;
      while (++i < m) {
        pi = points[i % n];
        px.shift();
        px.push(pi[0]);
        py.shift();
        py.push(pi[1]);
        d3_svg_lineBasisBezier(path, px, py);
      }
      return path.join("");
    }
    function d3_svg_lineBundle(points, tension) {
      var n = points.length - 1;
      if (n) {
        var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
        while (++i <= n) {
          p = points[i];
          t = i / n;
          p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
          p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
        }
      }
      return d3_svg_lineBasis(points);
    }
    function d3_svg_lineDot4(a, b) {
      return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
    }
    var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
    function d3_svg_lineBasisBezier(path, x, y) {
      path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
    }
    function d3_svg_lineSlope(p0, p1) {
      return (p1[1] - p0[1]) / (p1[0] - p0[0]);
    }
    function d3_svg_lineFiniteDifferences(points) {
      var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
      while (++i < j) {
        m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
      }
      m[i] = d;
      return m;
    }
    function d3_svg_lineMonotoneTangents(points) {
      var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
      while (++i < j) {
        d = d3_svg_lineSlope(points[i], points[i + 1]);
        if (abs(d) < ε) {
          m[i] = m[i + 1] = 0;
        } else {
          a = m[i] / d;
          b = m[i + 1] / d;
          s = a * a + b * b;
          if (s > 9) {
            s = d * 3 / Math.sqrt(s);
            m[i] = s * a;
            m[i + 1] = s * b;
          }
        }
      }
      i = -1;
      while (++i <= j) {
        s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
        tangents.push([ s || 0, m[i] * s || 0 ]);
      }
      return tangents;
    }
    function d3_svg_lineMonotone(points) {
      return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
    }
    d3.svg.line.radial = function() {
      var line = d3_svg_line(d3_svg_lineRadial);
      line.radius = line.x, delete line.x;
      line.angle = line.y, delete line.y;
      return line;
    };
    function d3_svg_lineRadial(points) {
      var point, i = -1, n = points.length, r, a;
      while (++i < n) {
        point = points[i];
        r = point[0];
        a = point[1] - halfπ;
        point[0] = r * Math.cos(a);
        point[1] = r * Math.sin(a);
      }
      return points;
    }
    function d3_svg_area(projection) {
      var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
      function area(data) {
        var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
          return x;
        } : d3_functor(x1), fy1 = y0 === y1 ? function() {
          return y;
        } : d3_functor(y1), x, y;
        function segment() {
          segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
        }
        while (++i < n) {
          if (defined.call(this, d = data[i], i)) {
            points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
            points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
          } else if (points0.length) {
            segment();
            points0 = [];
            points1 = [];
          }
        }
        if (points0.length) segment();
        return segments.length ? segments.join("") : null;
      }
      area.x = function(_) {
        if (!arguments.length) return x1;
        x0 = x1 = _;
        return area;
      };
      area.x0 = function(_) {
        if (!arguments.length) return x0;
        x0 = _;
        return area;
      };
      area.x1 = function(_) {
        if (!arguments.length) return x1;
        x1 = _;
        return area;
      };
      area.y = function(_) {
        if (!arguments.length) return y1;
        y0 = y1 = _;
        return area;
      };
      area.y0 = function(_) {
        if (!arguments.length) return y0;
        y0 = _;
        return area;
      };
      area.y1 = function(_) {
        if (!arguments.length) return y1;
        y1 = _;
        return area;
      };
      area.defined = function(_) {
        if (!arguments.length) return defined;
        defined = _;
        return area;
      };
      area.interpolate = function(_) {
        if (!arguments.length) return interpolateKey;
        if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
        interpolateReverse = interpolate.reverse || interpolate;
        L = interpolate.closed ? "M" : "L";
        return area;
      };
      area.tension = function(_) {
        if (!arguments.length) return tension;
        tension = _;
        return area;
      };
      return area;
    }
    d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
    d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
    d3.svg.area = function() {
      return d3_svg_area(d3_identity);
    };
    d3.svg.area.radial = function() {
      var area = d3_svg_area(d3_svg_lineRadial);
      area.radius = area.x, delete area.x;
      area.innerRadius = area.x0, delete area.x0;
      area.outerRadius = area.x1, delete area.x1;
      area.angle = area.y, delete area.y;
      area.startAngle = area.y0, delete area.y0;
      area.endAngle = area.y1, delete area.y1;
      return area;
    };
    d3.svg.chord = function() {
      var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
      function chord(d, i) {
        var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
        return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
      }
      function subgroup(self, f, d, i) {
        var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
        return {
          r: r,
          a0: a0,
          a1: a1,
          p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
          p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
        };
      }
      function equals(a, b) {
        return a.a0 == b.a0 && a.a1 == b.a1;
      }
      function arc(r, p, a) {
        return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
      }
      function curve(r0, p0, r1, p1) {
        return "Q 0,0 " + p1;
      }
      chord.radius = function(v) {
        if (!arguments.length) return radius;
        radius = d3_functor(v);
        return chord;
      };
      chord.source = function(v) {
        if (!arguments.length) return source;
        source = d3_functor(v);
        return chord;
      };
      chord.target = function(v) {
        if (!arguments.length) return target;
        target = d3_functor(v);
        return chord;
      };
      chord.startAngle = function(v) {
        if (!arguments.length) return startAngle;
        startAngle = d3_functor(v);
        return chord;
      };
      chord.endAngle = function(v) {
        if (!arguments.length) return endAngle;
        endAngle = d3_functor(v);
        return chord;
      };
      return chord;
    };
    function d3_svg_chordRadius(d) {
      return d.radius;
    }
    d3.svg.diagonal = function() {
      var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
      function diagonal(d, i) {
        var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
          x: p0.x,
          y: m
        }, {
          x: p3.x,
          y: m
        }, p3 ];
        p = p.map(projection);
        return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
      }
      diagonal.source = function(x) {
        if (!arguments.length) return source;
        source = d3_functor(x);
        return diagonal;
      };
      diagonal.target = function(x) {
        if (!arguments.length) return target;
        target = d3_functor(x);
        return diagonal;
      };
      diagonal.projection = function(x) {
        if (!arguments.length) return projection;
        projection = x;
        return diagonal;
      };
      return diagonal;
    };
    function d3_svg_diagonalProjection(d) {
      return [ d.x, d.y ];
    }
    d3.svg.diagonal.radial = function() {
      var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
      diagonal.projection = function(x) {
        return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
      };
      return diagonal;
    };
    function d3_svg_diagonalRadialProjection(projection) {
      return function() {
        var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
        return [ r * Math.cos(a), r * Math.sin(a) ];
      };
    }
    d3.svg.symbol = function() {
      var type = d3_svg_symbolType, size = d3_svg_symbolSize;
      function symbol(d, i) {
        return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
      }
      symbol.type = function(x) {
        if (!arguments.length) return type;
        type = d3_functor(x);
        return symbol;
      };
      symbol.size = function(x) {
        if (!arguments.length) return size;
        size = d3_functor(x);
        return symbol;
      };
      return symbol;
    };
    function d3_svg_symbolSize() {
      return 64;
    }
    function d3_svg_symbolType() {
      return "circle";
    }
    function d3_svg_symbolCircle(size) {
      var r = Math.sqrt(size / π);
      return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
    }
    var d3_svg_symbols = d3.map({
      circle: d3_svg_symbolCircle,
      cross: function(size) {
        var r = Math.sqrt(size / 5) / 2;
        return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
      },
      diamond: function(size) {
        var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
        return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
      },
      square: function(size) {
        var r = Math.sqrt(size) / 2;
        return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
      },
      "triangle-down": function(size) {
        var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
        return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
      },
      "triangle-up": function(size) {
        var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
        return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
      }
    });
    d3.svg.symbolTypes = d3_svg_symbols.keys();
    var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
    d3_selectionPrototype.transition = function(name) {
      var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
        time: Date.now(),
        ease: d3_ease_cubicInOut,
        delay: 0,
        duration: 250
      };
      for (var j = -1, m = this.length; ++j < m; ) {
        subgroups.push(subgroup = []);
        for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
          if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
          subgroup.push(node);
        }
      }
      return d3_transition(subgroups, ns, id);
    };
    d3_selectionPrototype.interrupt = function(name) {
      return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
    };
    var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
    function d3_selection_interruptNS(ns) {
      return function() {
        var lock, activeId, active;
        if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
          active.timer.c = null;
          active.timer.t = NaN;
          if (--lock.count) delete lock[activeId]; else delete this[ns];
          lock.active += .5;
          active.event && active.event.interrupt.call(this, this.__data__, active.index);
        }
      };
    }
    function d3_transition(groups, ns, id) {
      d3_subclass(groups, d3_transitionPrototype);
      groups.namespace = ns;
      groups.id = id;
      return groups;
    }
    var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
    d3_transitionPrototype.call = d3_selectionPrototype.call;
    d3_transitionPrototype.empty = d3_selectionPrototype.empty;
    d3_transitionPrototype.node = d3_selectionPrototype.node;
    d3_transitionPrototype.size = d3_selectionPrototype.size;
    d3.transition = function(selection, name) {
      return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
    };
    d3.transition.prototype = d3_transitionPrototype;
    d3_transitionPrototype.select = function(selector) {
      var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
      selector = d3_selection_selector(selector);
      for (var j = -1, m = this.length; ++j < m; ) {
        subgroups.push(subgroup = []);
        for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
          if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
            if ("__data__" in node) subnode.__data__ = node.__data__;
            d3_transitionNode(subnode, i, ns, id, node[ns][id]);
            subgroup.push(subnode);
          } else {
            subgroup.push(null);
          }
        }
      }
      return d3_transition(subgroups, ns, id);
    };
    d3_transitionPrototype.selectAll = function(selector) {
      var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
      selector = d3_selection_selectorAll(selector);
      for (var j = -1, m = this.length; ++j < m; ) {
        for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
          if (node = group[i]) {
            transition = node[ns][id];
            subnodes = selector.call(node, node.__data__, i, j);
            subgroups.push(subgroup = []);
            for (var k = -1, o = subnodes.length; ++k < o; ) {
              if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
              subgroup.push(subnode);
            }
          }
        }
      }
      return d3_transition(subgroups, ns, id);
    };
    d3_transitionPrototype.filter = function(filter) {
      var subgroups = [], subgroup, group, node;
      if (typeof filter !== "function") filter = d3_selection_filter(filter);
      for (var j = 0, m = this.length; j < m; j++) {
        subgroups.push(subgroup = []);
        for (var group = this[j], i = 0, n = group.length; i < n; i++) {
          if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
            subgroup.push(node);
          }
        }
      }
      return d3_transition(subgroups, this.namespace, this.id);
    };
    d3_transitionPrototype.tween = function(name, tween) {
      var id = this.id, ns = this.namespace;
      if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
      return d3_selection_each(this, tween == null ? function(node) {
        node[ns][id].tween.remove(name);
      } : function(node) {
        node[ns][id].tween.set(name, tween);
      });
    };
    function d3_transition_tween(groups, name, value, tween) {
      var id = groups.id, ns = groups.namespace;
      return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
        node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
      } : (value = tween(value), function(node) {
        node[ns][id].tween.set(name, value);
      }));
    }
    d3_transitionPrototype.attr = function(nameNS, value) {
      if (arguments.length < 2) {
        for (value in nameNS) this.attr(value, nameNS[value]);
        return this;
      }
      var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
      function attrNull() {
        this.removeAttribute(name);
      }
      function attrNullNS() {
        this.removeAttributeNS(name.space, name.local);
      }
      function attrTween(b) {
        return b == null ? attrNull : (b += "", function() {
          var a = this.getAttribute(name), i;
          return a !== b && (i = interpolate(a, b), function(t) {
            this.setAttribute(name, i(t));
          });
        });
      }
      function attrTweenNS(b) {
        return b == null ? attrNullNS : (b += "", function() {
          var a = this.getAttributeNS(name.space, name.local), i;
          return a !== b && (i = interpolate(a, b), function(t) {
            this.setAttributeNS(name.space, name.local, i(t));
          });
        });
      }
      return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
    };
    d3_transitionPrototype.attrTween = function(nameNS, tween) {
      var name = d3.ns.qualify(nameNS);
      function attrTween(d, i) {
        var f = tween.call(this, d, i, this.getAttribute(name));
        return f && function(t) {
          this.setAttribute(name, f(t));
        };
      }
      function attrTweenNS(d, i) {
        var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
        return f && function(t) {
          this.setAttributeNS(name.space, name.local, f(t));
        };
      }
      return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
    };
    d3_transitionPrototype.style = function(name, value, priority) {
      var n = arguments.length;
      if (n < 3) {
        if (typeof name !== "string") {
          if (n < 2) value = "";
          for (priority in name) this.style(priority, name[priority], value);
          return this;
        }
        priority = "";
      }
      function styleNull() {
        this.style.removeProperty(name);
      }
      function styleString(b) {
        return b == null ? styleNull : (b += "", function() {
          var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
          return a !== b && (i = d3_interpolate(a, b), function(t) {
            this.style.setProperty(name, i(t), priority);
          });
        });
      }
      return d3_transition_tween(this, "style." + name, value, styleString);
    };
    d3_transitionPrototype.styleTween = function(name, tween, priority) {
      if (arguments.length < 3) priority = "";
      function styleTween(d, i) {
        var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
        return f && function(t) {
          this.style.setProperty(name, f(t), priority);
        };
      }
      return this.tween("style." + name, styleTween);
    };
    d3_transitionPrototype.text = function(value) {
      return d3_transition_tween(this, "text", value, d3_transition_text);
    };
    function d3_transition_text(b) {
      if (b == null) b = "";
      return function() {
        this.textContent = b;
      };
    }
    d3_transitionPrototype.remove = function() {
      var ns = this.namespace;
      return this.each("end.transition", function() {
        var p;
        if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
      });
    };
    d3_transitionPrototype.ease = function(value) {
      var id = this.id, ns = this.namespace;
      if (arguments.length < 1) return this.node()[ns][id].ease;
      if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
      return d3_selection_each(this, function(node) {
        node[ns][id].ease = value;
      });
    };
    d3_transitionPrototype.delay = function(value) {
      var id = this.id, ns = this.namespace;
      if (arguments.length < 1) return this.node()[ns][id].delay;
      return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
        node[ns][id].delay = +value.call(node, node.__data__, i, j);
      } : (value = +value, function(node) {
        node[ns][id].delay = value;
      }));
    };
    d3_transitionPrototype.duration = function(value) {
      var id = this.id, ns = this.namespace;
      if (arguments.length < 1) return this.node()[ns][id].duration;
      return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
        node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
      } : (value = Math.max(1, value), function(node) {
        node[ns][id].duration = value;
      }));
    };
    d3_transitionPrototype.each = function(type, listener) {
      var id = this.id, ns = this.namespace;
      if (arguments.length < 2) {
        var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
        try {
          d3_transitionInheritId = id;
          d3_selection_each(this, function(node, i, j) {
            d3_transitionInherit = node[ns][id];
            type.call(node, node.__data__, i, j);
          });
        } finally {
          d3_transitionInherit = inherit;
          d3_transitionInheritId = inheritId;
        }
      } else {
        d3_selection_each(this, function(node) {
          var transition = node[ns][id];
          (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
        });
      }
      return this;
    };
    d3_transitionPrototype.transition = function() {
      var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
      for (var j = 0, m = this.length; j < m; j++) {
        subgroups.push(subgroup = []);
        for (var group = this[j], i = 0, n = group.length; i < n; i++) {
          if (node = group[i]) {
            transition = node[ns][id0];
            d3_transitionNode(node, i, ns, id1, {
              time: transition.time,
              ease: transition.ease,
              delay: transition.delay + transition.duration,
              duration: transition.duration
            });
          }
          subgroup.push(node);
        }
      }
      return d3_transition(subgroups, ns, id1);
    };
    function d3_transitionNamespace(name) {
      return name == null ? "__transition__" : "__transition_" + name + "__";
    }
    function d3_transitionNode(node, i, ns, id, inherit) {
      var lock = node[ns] || (node[ns] = {
        active: 0,
        count: 0
      }), transition = lock[id], time, timer, duration, ease, tweens;
      function schedule(elapsed) {
        var delay = transition.delay;
        timer.t = delay + time;
        if (delay <= elapsed) return start(elapsed - delay);
        timer.c = start;
      }
      function start(elapsed) {
        var activeId = lock.active, active = lock[activeId];
        if (active) {
          active.timer.c = null;
          active.timer.t = NaN;
          --lock.count;
          delete lock[activeId];
          active.event && active.event.interrupt.call(node, node.__data__, active.index);
        }
        for (var cancelId in lock) {
          if (+cancelId < id) {
            var cancel = lock[cancelId];
            cancel.timer.c = null;
            cancel.timer.t = NaN;
            --lock.count;
            delete lock[cancelId];
          }
        }
        timer.c = tick;
        d3_timer(function() {
          if (timer.c && tick(elapsed || 1)) {
            timer.c = null;
            timer.t = NaN;
          }
          return 1;
        }, 0, time);
        lock.active = id;
        transition.event && transition.event.start.call(node, node.__data__, i);
        tweens = [];
        transition.tween.forEach(function(key, value) {
          if (value = value.call(node, node.__data__, i)) {
            tweens.push(value);
          }
        });
        ease = transition.ease;
        duration = transition.duration;
      }
      function tick(elapsed) {
        var t = elapsed / duration, e = ease(t), n = tweens.length;
        while (n > 0) {
          tweens[--n].call(node, e);
        }
        if (t >= 1) {
          transition.event && transition.event.end.call(node, node.__data__, i);
          if (--lock.count) delete lock[id]; else delete node[ns];
          return 1;
        }
      }
      if (!transition) {
        time = inherit.time;
        timer = d3_timer(schedule, 0, time);
        transition = lock[id] = {
          tween: new d3_Map(),
          time: time,
          timer: timer,
          delay: inherit.delay,
          duration: inherit.duration,
          ease: inherit.ease,
          index: i
        };
        inherit = null;
        ++lock.count;
      }
    }
    d3.svg.axis = function() {
      var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
      function axis(g) {
        g.each(function() {
          var g = d3.select(this);
          var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
          var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
          var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
          d3.transition(path));
          tickEnter.append("line");
          tickEnter.append("text");
          var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
          if (orient === "bottom" || orient === "top") {
            tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
            text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
            pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
          } else {
            tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
            text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
            pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
          }
          lineEnter.attr(y2, sign * innerTickSize);
          textEnter.attr(y1, sign * tickSpacing);
          lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
          textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
          if (scale1.rangeBand) {
            var x = scale1, dx = x.rangeBand() / 2;
            scale0 = scale1 = function(d) {
              return x(d) + dx;
            };
          } else if (scale0.rangeBand) {
            scale0 = scale1;
          } else {
            tickExit.call(tickTransform, scale1, scale0);
          }
          tickEnter.call(tickTransform, scale0, scale1);
          tickUpdate.call(tickTransform, scale1, scale1);
        });
      }
      axis.scale = function(x) {
        if (!arguments.length) return scale;
        scale = x;
        return axis;
      };
      axis.orient = function(x) {
        if (!arguments.length) return orient;
        orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
        return axis;
      };
      axis.ticks = function() {
        if (!arguments.length) return tickArguments_;
        tickArguments_ = d3_array(arguments);
        return axis;
      };
      axis.tickValues = function(x) {
        if (!arguments.length) return tickValues;
        tickValues = x;
        return axis;
      };
      axis.tickFormat = function(x) {
        if (!arguments.length) return tickFormat_;
        tickFormat_ = x;
        return axis;
      };
      axis.tickSize = function(x) {
        var n = arguments.length;
        if (!n) return innerTickSize;
        innerTickSize = +x;
        outerTickSize = +arguments[n - 1];
        return axis;
      };
      axis.innerTickSize = function(x) {
        if (!arguments.length) return innerTickSize;
        innerTickSize = +x;
        return axis;
      };
      axis.outerTickSize = function(x) {
        if (!arguments.length) return outerTickSize;
        outerTickSize = +x;
        return axis;
      };
      axis.tickPadding = function(x) {
        if (!arguments.length) return tickPadding;
        tickPadding = +x;
        return axis;
      };
      axis.tickSubdivide = function() {
        return arguments.length && axis;
      };
      return axis;
    };
    var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
      top: 1,
      right: 1,
      bottom: 1,
      left: 1
    };
    function d3_svg_axisX(selection, x0, x1) {
      selection.attr("transform", function(d) {
        var v0 = x0(d);
        return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
      });
    }
    function d3_svg_axisY(selection, y0, y1) {
      selection.attr("transform", function(d) {
        var v0 = y0(d);
        return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
      });
    }
    d3.svg.brush = function() {
      var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
      function brush(g) {
        g.each(function() {
          var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
          var background = g.selectAll(".background").data([ 0 ]);
          background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
          g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
          var resize = g.selectAll(".resize").data(resizes, d3_identity);
          resize.exit().remove();
          resize.enter().append("g").attr("class", function(d) {
            return "resize " + d;
          }).style("cursor", function(d) {
            return d3_svg_brushCursor[d];
          }).append("rect").attr("x", function(d) {
            return /[ew]$/.test(d) ? -3 : null;
          }).attr("y", function(d) {
            return /^[ns]/.test(d) ? -3 : null;
          }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
          resize.style("display", brush.empty() ? "none" : null);
          var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
          if (x) {
            range = d3_scaleRange(x);
            backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
            redrawX(gUpdate);
          }
          if (y) {
            range = d3_scaleRange(y);
            backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
            redrawY(gUpdate);
          }
          redraw(gUpdate);
        });
      }
      brush.event = function(g) {
        g.each(function() {
          var event_ = event.of(this, arguments), extent1 = {
            x: xExtent,
            y: yExtent,
            i: xExtentDomain,
            j: yExtentDomain
          }, extent0 = this.__chart__ || extent1;
          this.__chart__ = extent1;
          if (d3_transitionInheritId) {
            d3.select(this).transition().each("start.brush", function() {
              xExtentDomain = extent0.i;
              yExtentDomain = extent0.j;
              xExtent = extent0.x;
              yExtent = extent0.y;
              event_({
                type: "brushstart"
              });
            }).tween("brush:brush", function() {
              var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
              xExtentDomain = yExtentDomain = null;
              return function(t) {
                xExtent = extent1.x = xi(t);
                yExtent = extent1.y = yi(t);
                event_({
                  type: "brush",
                  mode: "resize"
                });
              };
            }).each("end.brush", function() {
              xExtentDomain = extent1.i;
              yExtentDomain = extent1.j;
              event_({
                type: "brush",
                mode: "resize"
              });
              event_({
                type: "brushend"
              });
            });
          } else {
            event_({
              type: "brushstart"
            });
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          }
        });
      };
      function redraw(g) {
        g.selectAll(".resize").attr("transform", function(d) {
          return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
        });
      }
      function redrawX(g) {
        g.select(".extent").attr("x", xExtent[0]);
        g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
      }
      function redrawY(g) {
        g.select(".extent").attr("y", yExtent[0]);
        g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
      }
      function brushstart() {
        var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
        var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
        if (d3.event.changedTouches) {
          w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
        } else {
          w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
        }
        g.interrupt().selectAll("*").interrupt();
        if (dragging) {
          origin[0] = xExtent[0] - origin[0];
          origin[1] = yExtent[0] - origin[1];
        } else if (resizing) {
          var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
          offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
          origin[0] = xExtent[ex];
          origin[1] = yExtent[ey];
        } else if (d3.event.altKey) center = origin.slice();
        g.style("pointer-events", "none").selectAll(".resize").style("display", null);
        d3.select("body").style("cursor", eventTarget.style("cursor"));
        event_({
          type: "brushstart"
        });
        brushmove();
        function keydown() {
          if (d3.event.keyCode == 32) {
            if (!dragging) {
              center = null;
              origin[0] -= xExtent[1];
              origin[1] -= yExtent[1];
              dragging = 2;
            }
            d3_eventPreventDefault();
          }
        }
        function keyup() {
          if (d3.event.keyCode == 32 && dragging == 2) {
            origin[0] += xExtent[1];
            origin[1] += yExtent[1];
            dragging = 0;
            d3_eventPreventDefault();
          }
        }
        function brushmove() {
          var point = d3.mouse(target), moved = false;
          if (offset) {
            point[0] += offset[0];
            point[1] += offset[1];
          }
          if (!dragging) {
            if (d3.event.altKey) {
              if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
              origin[0] = xExtent[+(point[0] < center[0])];
              origin[1] = yExtent[+(point[1] < center[1])];
            } else center = null;
          }
          if (resizingX && move1(point, x, 0)) {
            redrawX(g);
            moved = true;
          }
          if (resizingY && move1(point, y, 1)) {
            redrawY(g);
            moved = true;
          }
          if (moved) {
            redraw(g);
            event_({
              type: "brush",
              mode: dragging ? "move" : "resize"
            });
          }
        }
        function move1(point, scale, i) {
          var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
          if (dragging) {
            r0 -= position;
            r1 -= size + position;
          }
          min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
          if (dragging) {
            max = (min += position) + size;
          } else {
            if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
            if (position < min) {
              max = min;
              min = position;
            } else {
              max = position;
            }
          }
          if (extent[0] != min || extent[1] != max) {
            if (i) yExtentDomain = null; else xExtentDomain = null;
            extent[0] = min;
            extent[1] = max;
            return true;
          }
        }
        function brushend() {
          brushmove();
          g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
          d3.select("body").style("cursor", null);
          w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
          dragRestore();
          event_({
            type: "brushend"
          });
        }
      }
      brush.x = function(z) {
        if (!arguments.length) return x;
        x = z;
        resizes = d3_svg_brushResizes[!x << 1 | !y];
        return brush;
      };
      brush.y = function(z) {
        if (!arguments.length) return y;
        y = z;
        resizes = d3_svg_brushResizes[!x << 1 | !y];
        return brush;
      };
      brush.clamp = function(z) {
        if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
        if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
        return brush;
      };
      brush.extent = function(z) {
        var x0, x1, y0, y1, t;
        if (!arguments.length) {
          if (x) {
            if (xExtentDomain) {
              x0 = xExtentDomain[0], x1 = xExtentDomain[1];
            } else {
              x0 = xExtent[0], x1 = xExtent[1];
              if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
              if (x1 < x0) t = x0, x0 = x1, x1 = t;
            }
          }
          if (y) {
            if (yExtentDomain) {
              y0 = yExtentDomain[0], y1 = yExtentDomain[1];
            } else {
              y0 = yExtent[0], y1 = yExtent[1];
              if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
              if (y1 < y0) t = y0, y0 = y1, y1 = t;
            }
          }
          return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
        }
        if (x) {
          x0 = z[0], x1 = z[1];
          if (y) x0 = x0[0], x1 = x1[0];
          xExtentDomain = [ x0, x1 ];
          if (x.invert) x0 = x(x0), x1 = x(x1);
          if (x1 < x0) t = x0, x0 = x1, x1 = t;
          if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
        }
        if (y) {
          y0 = z[0], y1 = z[1];
          if (x) y0 = y0[1], y1 = y1[1];
          yExtentDomain = [ y0, y1 ];
          if (y.invert) y0 = y(y0), y1 = y(y1);
          if (y1 < y0) t = y0, y0 = y1, y1 = t;
          if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
        }
        return brush;
      };
      brush.clear = function() {
        if (!brush.empty()) {
          xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
          xExtentDomain = yExtentDomain = null;
        }
        return brush;
      };
      brush.empty = function() {
        return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
      };
      return d3.rebind(brush, event, "on");
    };
    var d3_svg_brushCursor = {
      n: "ns-resize",
      e: "ew-resize",
      s: "ns-resize",
      w: "ew-resize",
      nw: "nwse-resize",
      ne: "nesw-resize",
      se: "nwse-resize",
      sw: "nesw-resize"
    };
    var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
    var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
    var d3_time_formatUtc = d3_time_format.utc;
    var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
    d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
    function d3_time_formatIsoNative(date) {
      return date.toISOString();
    }
    d3_time_formatIsoNative.parse = function(string) {
      var date = new Date(string);
      return isNaN(date) ? null : date;
    };
    d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
    d3_time.second = d3_time_interval(function(date) {
      return new d3_date(Math.floor(date / 1e3) * 1e3);
    }, function(date, offset) {
      date.setTime(date.getTime() + Math.floor(offset) * 1e3);
    }, function(date) {
      return date.getSeconds();
    });
    d3_time.seconds = d3_time.second.range;
    d3_time.seconds.utc = d3_time.second.utc.range;
    d3_time.minute = d3_time_interval(function(date) {
      return new d3_date(Math.floor(date / 6e4) * 6e4);
    }, function(date, offset) {
      date.setTime(date.getTime() + Math.floor(offset) * 6e4);
    }, function(date) {
      return date.getMinutes();
    });
    d3_time.minutes = d3_time.minute.range;
    d3_time.minutes.utc = d3_time.minute.utc.range;
    d3_time.hour = d3_time_interval(function(date) {
      var timezone = date.getTimezoneOffset() / 60;
      return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
    }, function(date, offset) {
      date.setTime(date.getTime() + Math.floor(offset) * 36e5);
    }, function(date) {
      return date.getHours();
    });
    d3_time.hours = d3_time.hour.range;
    d3_time.hours.utc = d3_time.hour.utc.range;
    d3_time.month = d3_time_interval(function(date) {
      date = d3_time.day(date);
      date.setDate(1);
      return date;
    }, function(date, offset) {
      date.setMonth(date.getMonth() + offset);
    }, function(date) {
      return date.getMonth();
    });
    d3_time.months = d3_time.month.range;
    d3_time.months.utc = d3_time.month.utc.range;
    function d3_time_scale(linear, methods, format) {
      function scale(x) {
        return linear(x);
      }
      scale.invert = function(x) {
        return d3_time_scaleDate(linear.invert(x));
      };
      scale.domain = function(x) {
        if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
        linear.domain(x);
        return scale;
      };
      function tickMethod(extent, count) {
        var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
        return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
          return d / 31536e6;
        }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
      }
      scale.nice = function(interval, skip) {
        var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
        if (method) interval = method[0], skip = method[1];
        function skipped(date) {
          return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
        }
        return scale.domain(d3_scale_nice(domain, skip > 1 ? {
          floor: function(date) {
            while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
            return date;
          },
          ceil: function(date) {
            while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
            return date;
          }
        } : interval));
      };
      scale.ticks = function(interval, skip) {
        var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
          range: interval
        }, skip ];
        if (method) interval = method[0], skip = method[1];
        return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
      };
      scale.tickFormat = function() {
        return format;
      };
      scale.copy = function() {
        return d3_time_scale(linear.copy(), methods, format);
      };
      return d3_scale_linearRebind(scale, linear);
    }
    function d3_time_scaleDate(t) {
      return new Date(t);
    }
    var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
    var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
    var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
      return d.getMilliseconds();
    } ], [ ":%S", function(d) {
      return d.getSeconds();
    } ], [ "%I:%M", function(d) {
      return d.getMinutes();
    } ], [ "%I %p", function(d) {
      return d.getHours();
    } ], [ "%a %d", function(d) {
      return d.getDay() && d.getDate() != 1;
    } ], [ "%b %d", function(d) {
      return d.getDate() != 1;
    } ], [ "%B", function(d) {
      return d.getMonth();
    } ], [ "%Y", d3_true ] ]);
    var d3_time_scaleMilliseconds = {
      range: function(start, stop, step) {
        return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
      },
      floor: d3_identity,
      ceil: d3_identity
    };
    d3_time_scaleLocalMethods.year = d3_time.year;
    d3_time.scale = function() {
      return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
    };
    var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
      return [ m[0].utc, m[1] ];
    });
    var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
      return d.getUTCMilliseconds();
    } ], [ ":%S", function(d) {
      return d.getUTCSeconds();
    } ], [ "%I:%M", function(d) {
      return d.getUTCMinutes();
    } ], [ "%I %p", function(d) {
      return d.getUTCHours();
    } ], [ "%a %d", function(d) {
      return d.getUTCDay() && d.getUTCDate() != 1;
    } ], [ "%b %d", function(d) {
      return d.getUTCDate() != 1;
    } ], [ "%B", function(d) {
      return d.getUTCMonth();
    } ], [ "%Y", d3_true ] ]);
    d3_time_scaleUtcMethods.year = d3_time.year.utc;
    d3_time.scale.utc = function() {
      return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
    };
    d3.text = d3_xhrType(function(request) {
      return request.responseText;
    });
    d3.json = function(url, callback) {
      return d3_xhr(url, "application/json", d3_json, callback);
    };
    function d3_json(request) {
      return JSON.parse(request.responseText);
    }
    d3.html = function(url, callback) {
      return d3_xhr(url, "text/html", d3_html, callback);
    };
    function d3_html(request) {
      var range = d3_document.createRange();
      range.selectNode(d3_document.body);
      return range.createContextualFragment(request.responseText);
    }
    d3.xml = d3_xhrType(function(request) {
      return request.responseXML;
    });
    if (typeof define === "function" && define.amd) this.d3 = d3, define(d3); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
  }.apply(self);
  },{}],170:[function(_dereq_,module,exports){
  module.exports = function () {
      for (var i = 0; i < arguments.length; i++) {
          if (arguments[i] !== undefined) return arguments[i];
      }
  };
  
  },{}],171:[function(_dereq_,module,exports){
  "use strict"
  
  var ch = _dereq_("incremental-convex-hull")
  var uniq = _dereq_("uniq")
  
  module.exports = triangulate
  
  function LiftedPoint(p, i) {
    this.point = p
    this.index = i
  }
  
  function compareLifted(a, b) {
    var ap = a.point
    var bp = b.point
    var d = ap.length
    for(var i=0; i<d; ++i) {
      var s = bp[i] - ap[i]
      if(s) {
        return s
      }
    }
    return 0
  }
  
  function triangulate1D(n, points, includePointAtInfinity) {
    if(n === 1) {
      if(includePointAtInfinity) {
        return [ [-1, 0] ]
      } else {
        return []
      }
    }
    var lifted = points.map(function(p, i) {
      return [ p[0], i ]
    })
    lifted.sort(function(a,b) {
      return a[0] - b[0]
    })
    var cells = new Array(n - 1)
    for(var i=1; i<n; ++i) {
      var a = lifted[i-1]
      var b = lifted[i]
      cells[i-1] = [ a[1], b[1] ]
    }
    if(includePointAtInfinity) {
      cells.push(
        [ -1, cells[0][1], ],
        [ cells[n-1][1], -1 ])
    }
    return cells
  }
  
  function triangulate(points, includePointAtInfinity) {
    var n = points.length
    if(n === 0) {
      return []
    }
    
    var d = points[0].length
    if(d < 1) {
      return []
    }
  
    //Special case:  For 1D we can just sort the points
    if(d === 1) {
      return triangulate1D(n, points, includePointAtInfinity)
    }
    
    //Lift points, sort
    var lifted = new Array(n)
    var upper = 1.0
    for(var i=0; i<n; ++i) {
      var p = points[i]
      var x = new Array(d+1)
      var l = 0.0
      for(var j=0; j<d; ++j) {
        var v = p[j]
        x[j] = v
        l += v * v
      }
      x[d] = l
      lifted[i] = new LiftedPoint(x, i)
      upper = Math.max(l, upper)
    }
    uniq(lifted, compareLifted)
    
    //Double points
    n = lifted.length
  
    //Create new list of points
    var dpoints = new Array(n + d + 1)
    var dindex = new Array(n + d + 1)
  
    //Add steiner points at top
    var u = (d+1) * (d+1) * upper
    var y = new Array(d+1)
    for(var i=0; i<=d; ++i) {
      y[i] = 0.0
    }
    y[d] = u
  
    dpoints[0] = y.slice()
    dindex[0] = -1
  
    for(var i=0; i<=d; ++i) {
      var x = y.slice()
      x[i] = 1
      dpoints[i+1] = x
      dindex[i+1] = -1
    }
  
    //Copy rest of the points over
    for(var i=0; i<n; ++i) {
      var h = lifted[i]
      dpoints[i + d + 1] = h.point
      dindex[i + d + 1] =  h.index
    }
  
    //Construct convex hull
    var hull = ch(dpoints, false)
    if(includePointAtInfinity) {
      hull = hull.filter(function(cell) {
        var count = 0
        for(var j=0; j<=d; ++j) {
          var v = dindex[cell[j]]
          if(v < 0) {
            if(++count >= 2) {
              return false
            }
          }
          cell[j] = v
        }
        return true
      })
    } else {
      hull = hull.filter(function(cell) {
        for(var i=0; i<=d; ++i) {
          var v = dindex[cell[i]]
          if(v < 0) {
            return false
          }
          cell[i] = v
        }
        return true
      })
    }
  
    if(d & 1) {
      for(var i=0; i<hull.length; ++i) {
        var h = hull[i]
        var x = h[0]
        h[0] = h[1]
        h[1] = x
      }
    }
  
    return hull
  }
  },{"incremental-convex-hull":433,"uniq":569}],172:[function(_dereq_,module,exports){
  'use strict'
  
  
  module.exports = kerning
  
  
  var canvas = kerning.canvas = document.createElement('canvas')
  var ctx = canvas.getContext('2d')
  var asciiPairs = createPairs([32, 126])
  
  kerning.createPairs = createPairs
  kerning.ascii = asciiPairs
  
  
  function kerning (family, o) {
    if (Array.isArray(family)) family = family.join(', ')
  
    var table = {}, pairs, fs = 16, threshold = .05
  
    if (o) {
      if (o.length === 2 && typeof o[0] === 'number') {
        pairs = createPairs(o)
      }
      else if (Array.isArray(o)) {
        pairs = o
      }
      else {
        if (o.o) pairs = createPairs(o.o)
        else if (o.pairs) pairs = o.pairs
  
        if (o.fontSize) fs = o.fontSize
        if (o.threshold != null) threshold = o.threshold
      }
    }
  
    if (!pairs) pairs = asciiPairs
  
    ctx.font = fs + 'px ' + family
  
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i]
      var width = ctx.measureText(pair[0]).width + ctx.measureText(pair[1]).width
      var kerningWidth = ctx.measureText(pair).width
      if (Math.abs(width - kerningWidth) > fs * threshold) {
        var emWidth = (kerningWidth - width) / fs
        table[pair] = emWidth * 1000
      }
    }
  
    return table
  }
  
  
  function createPairs (range) {
    var pairs = []
  
      for (var i = range[0]; i <= range[1]; i++) {
      var leftChar = String.fromCharCode(i)
      for (var j = range[0]; j < range[1]; j++) {
        var rightChar = String.fromCharCode(j)
        var pair = leftChar + rightChar
  
        pairs.push(pair)
      }
    }
  
    return pairs
  }
  
  },{}],173:[function(_dereq_,module,exports){
  (function (Buffer){
  var hasTypedArrays = false
  if(typeof Float64Array !== "undefined") {
    var DOUBLE_VIEW = new Float64Array(1)
      , UINT_VIEW   = new Uint32Array(DOUBLE_VIEW.buffer)
    DOUBLE_VIEW[0] = 1.0
    hasTypedArrays = true
    if(UINT_VIEW[1] === 0x3ff00000) {
      //Use little endian
      module.exports = function doubleBitsLE(n) {
        DOUBLE_VIEW[0] = n
        return [ UINT_VIEW[0], UINT_VIEW[1] ]
      }
      function toDoubleLE(lo, hi) {
        UINT_VIEW[0] = lo
        UINT_VIEW[1] = hi
        return DOUBLE_VIEW[0]
      }
      module.exports.pack = toDoubleLE
      function lowUintLE(n) {
        DOUBLE_VIEW[0] = n
        return UINT_VIEW[0]
      }
      module.exports.lo = lowUintLE
      function highUintLE(n) {
        DOUBLE_VIEW[0] = n
        return UINT_VIEW[1]
      }
      module.exports.hi = highUintLE
    } else if(UINT_VIEW[0] === 0x3ff00000) {
      //Use big endian
      module.exports = function doubleBitsBE(n) {
        DOUBLE_VIEW[0] = n
        return [ UINT_VIEW[1], UINT_VIEW[0] ]
      }
      function toDoubleBE(lo, hi) {
        UINT_VIEW[1] = lo
        UINT_VIEW[0] = hi
        return DOUBLE_VIEW[0]
      }
      module.exports.pack = toDoubleBE
      function lowUintBE(n) {
        DOUBLE_VIEW[0] = n
        return UINT_VIEW[1]
      }
      module.exports.lo = lowUintBE
      function highUintBE(n) {
        DOUBLE_VIEW[0] = n
        return UINT_VIEW[0]
      }
      module.exports.hi = highUintBE
    } else {
      hasTypedArrays = false
    }
  }
  if(!hasTypedArrays) {
    var buffer = new Buffer(8)
    module.exports = function doubleBits(n) {
      buffer.writeDoubleLE(n, 0, true)
      return [ buffer.readUInt32LE(0, true), buffer.readUInt32LE(4, true) ]
    }
    function toDouble(lo, hi) {
      buffer.writeUInt32LE(lo, 0, true)
      buffer.writeUInt32LE(hi, 4, true)
      return buffer.readDoubleLE(0, true)
    }
    module.exports.pack = toDouble  
    function lowUint(n) {
      buffer.writeDoubleLE(n, 0, true)
      return buffer.readUInt32LE(0, true)
    }
    module.exports.lo = lowUint
    function highUint(n) {
      buffer.writeDoubleLE(n, 0, true)
      return buffer.readUInt32LE(4, true)
    }
    module.exports.hi = highUint
  }
  
  module.exports.sign = function(n) {
    return module.exports.hi(n) >>> 31
  }
  
  module.exports.exponent = function(n) {
    var b = module.exports.hi(n)
    return ((b<<1) >>> 21) - 1023
  }
  
  module.exports.fraction = function(n) {
    var lo = module.exports.lo(n)
    var hi = module.exports.hi(n)
    var b = hi & ((1<<20) - 1)
    if(hi & 0x7ff00000) {
      b += (1<<20)
    }
    return [lo, b]
  }
  
  module.exports.denormalized = function(n) {
    var hi = module.exports.hi(n)
    return !(hi & 0x7ff00000)
  }
  }).call(this,_dereq_("buffer").Buffer)
  },{"buffer":111}],174:[function(_dereq_,module,exports){
  var abs = _dereq_('abs-svg-path')
  var normalize = _dereq_('normalize-svg-path')
  
  var methods = {
    'M': 'moveTo',
    'C': 'bezierCurveTo'
  }
  
  module.exports = function(context, segments) {
    context.beginPath()
  
    // Make path easy to reproduce.
    normalize(abs(segments)).forEach(
      function(segment) {
        var command = segment[0]
        var args = segment.slice(1)
  
        // Convert the path command to a context method.
        context[methods[command]].apply(context, args)
      }
    )
  
    context.closePath()
  }
  
  },{"abs-svg-path":65,"normalize-svg-path":471}],175:[function(_dereq_,module,exports){
  module.exports = function(dtype) {
    switch (dtype) {
      case 'int8':
        return Int8Array
      case 'int16':
        return Int16Array
      case 'int32':
        return Int32Array
      case 'uint8':
        return Uint8Array
      case 'uint16':
        return Uint16Array
      case 'uint32':
        return Uint32Array
      case 'float32':
        return Float32Array
      case 'float64':
        return Float64Array
      case 'array':
        return Array
      case 'uint8_clamped':
        return Uint8ClampedArray
    }
  }
  
  },{}],176:[function(_dereq_,module,exports){
  "use strict"
  
  function dupe_array(count, value, i) {
    var c = count[i]|0
    if(c <= 0) {
      return []
    }
    var result = new Array(c), j
    if(i === count.length-1) {
      for(j=0; j<c; ++j) {
        result[j] = value
      }
    } else {
      for(j=0; j<c; ++j) {
        result[j] = dupe_array(count, value, i+1)
      }
    }
    return result
  }
  
  function dupe_number(count, value) {
    var result, i
    result = new Array(count)
    for(i=0; i<count; ++i) {
      result[i] = value
    }
    return result
  }
  
  function dupe(count, value) {
    if(typeof value === "undefined") {
      value = 0
    }
    switch(typeof count) {
      case "number":
        if(count > 0) {
          return dupe_number(count|0, value)
        }
      break
      case "object":
        if(typeof (count.length) === "number") {
          return dupe_array(count, value, 0)
        }
      break
    }
    return []
  }
  
  module.exports = dupe
  },{}],177:[function(_dereq_,module,exports){
  'use strict';
  
  module.exports = earcut;
  module.exports.default = earcut;
  
  function earcut(data, holeIndices, dim) {
  
      dim = dim || 2;
  
      var hasHoles = holeIndices && holeIndices.length,
          outerLen = hasHoles ? holeIndices[0] * dim : data.length,
          outerNode = linkedList(data, 0, outerLen, dim, true),
          triangles = [];
  
      if (!outerNode || outerNode.next === outerNode.prev) return triangles;
  
      var minX, minY, maxX, maxY, x, y, invSize;
  
      if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
  
      // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
      if (data.length > 80 * dim) {
          minX = maxX = data[0];
          minY = maxY = data[1];
  
          for (var i = dim; i < outerLen; i += dim) {
              x = data[i];
              y = data[i + 1];
              if (x < minX) minX = x;
              if (y < minY) minY = y;
              if (x > maxX) maxX = x;
              if (y > maxY) maxY = y;
          }
  
          // minX, minY and invSize are later used to transform coords into integers for z-order calculation
          invSize = Math.max(maxX - minX, maxY - minY);
          invSize = invSize !== 0 ? 1 / invSize : 0;
      }
  
      earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
  
      return triangles;
  }
  
  // create a circular doubly linked list from polygon points in the specified winding order
  function linkedList(data, start, end, dim, clockwise) {
      var i, last;
  
      if (clockwise === (signedArea(data, start, end, dim) > 0)) {
          for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
      } else {
          for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
      }
  
      if (last && equals(last, last.next)) {
          removeNode(last);
          last = last.next;
      }
  
      return last;
  }
  
  // eliminate colinear or duplicate points
  function filterPoints(start, end) {
      if (!start) return start;
      if (!end) end = start;
  
      var p = start,
          again;
      do {
          again = false;
  
          if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
              removeNode(p);
              p = end = p.prev;
              if (p === p.next) break;
              again = true;
  
          } else {
              p = p.next;
          }
      } while (again || p !== end);
  
      return end;
  }
  
  // main ear slicing loop which triangulates a polygon (given as a linked list)
  function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
      if (!ear) return;
  
      // interlink polygon nodes in z-order
      if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
  
      var stop = ear,
          prev, next;
  
      // iterate through ears, slicing them one by one
      while (ear.prev !== ear.next) {
          prev = ear.prev;
          next = ear.next;
  
          if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
              // cut off the triangle
              triangles.push(prev.i / dim);
              triangles.push(ear.i / dim);
              triangles.push(next.i / dim);
  
              removeNode(ear);
  
              // skipping the next vertex leads to less sliver triangles
              ear = next.next;
              stop = next.next;
  
              continue;
          }
  
          ear = next;
  
          // if we looped through the whole remaining polygon and can't find any more ears
          if (ear === stop) {
              // try filtering points and slicing again
              if (!pass) {
                  earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
  
              // if this didn't work, try curing all small self-intersections locally
              } else if (pass === 1) {
                  ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                  earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
  
              // as a last resort, try splitting the remaining polygon into two
              } else if (pass === 2) {
                  splitEarcut(ear, triangles, dim, minX, minY, invSize);
              }
  
              break;
          }
      }
  }
  
  // check whether a polygon node forms a valid ear with adjacent nodes
  function isEar(ear) {
      var a = ear.prev,
          b = ear,
          c = ear.next;
  
      if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
  
      // now make sure we don't have other points inside the potential ear
      var p = ear.next.next;
  
      while (p !== ear.prev) {
          if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
              area(p.prev, p, p.next) >= 0) return false;
          p = p.next;
      }
  
      return true;
  }
  
  function isEarHashed(ear, minX, minY, invSize) {
      var a = ear.prev,
          b = ear,
          c = ear.next;
  
      if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
  
      // triangle bbox; min & max are calculated like this for speed
      var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
          minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
          maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
          maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);
  
      // z-order range for the current triangle bbox;
      var minZ = zOrder(minTX, minTY, minX, minY, invSize),
          maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
  
      var p = ear.prevZ,
          n = ear.nextZ;
  
      // look for points inside the triangle in both directions
      while (p && p.z >= minZ && n && n.z <= maxZ) {
          if (p !== ear.prev && p !== ear.next &&
              pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
              area(p.prev, p, p.next) >= 0) return false;
          p = p.prevZ;
  
          if (n !== ear.prev && n !== ear.next &&
              pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
              area(n.prev, n, n.next) >= 0) return false;
          n = n.nextZ;
      }
  
      // look for remaining points in decreasing z-order
      while (p && p.z >= minZ) {
          if (p !== ear.prev && p !== ear.next &&
              pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
              area(p.prev, p, p.next) >= 0) return false;
          p = p.prevZ;
      }
  
      // look for remaining points in increasing z-order
      while (n && n.z <= maxZ) {
          if (n !== ear.prev && n !== ear.next &&
              pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
              area(n.prev, n, n.next) >= 0) return false;
          n = n.nextZ;
      }
  
      return true;
  }
  
  // go through all polygon nodes and cure small local self-intersections
  function cureLocalIntersections(start, triangles, dim) {
      var p = start;
      do {
          var a = p.prev,
              b = p.next.next;
  
          if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
  
              triangles.push(a.i / dim);
              triangles.push(p.i / dim);
              triangles.push(b.i / dim);
  
              // remove two nodes involved
              removeNode(p);
              removeNode(p.next);
  
              p = start = b;
          }
          p = p.next;
      } while (p !== start);
  
      return filterPoints(p);
  }
  
  // try splitting polygon into two and triangulate them independently
  function splitEarcut(start, triangles, dim, minX, minY, invSize) {
      // look for a valid diagonal that divides the polygon into two
      var a = start;
      do {
          var b = a.next.next;
          while (b !== a.prev) {
              if (a.i !== b.i && isValidDiagonal(a, b)) {
                  // split the polygon in two by the diagonal
                  var c = splitPolygon(a, b);
  
                  // filter colinear points around the cuts
                  a = filterPoints(a, a.next);
                  c = filterPoints(c, c.next);
  
                  // run earcut on each half
                  earcutLinked(a, triangles, dim, minX, minY, invSize);
                  earcutLinked(c, triangles, dim, minX, minY, invSize);
                  return;
              }
              b = b.next;
          }
          a = a.next;
      } while (a !== start);
  }
  
  // link every hole into the outer loop, producing a single-ring polygon without holes
  function eliminateHoles(data, holeIndices, outerNode, dim) {
      var queue = [],
          i, len, start, end, list;
  
      for (i = 0, len = holeIndices.length; i < len; i++) {
          start = holeIndices[i] * dim;
          end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
          list = linkedList(data, start, end, dim, false);
          if (list === list.next) list.steiner = true;
          queue.push(getLeftmost(list));
      }
  
      queue.sort(compareX);
  
      // process holes from left to right
      for (i = 0; i < queue.length; i++) {
          eliminateHole(queue[i], outerNode);
          outerNode = filterPoints(outerNode, outerNode.next);
      }
  
      return outerNode;
  }
  
  function compareX(a, b) {
      return a.x - b.x;
  }
  
  // find a bridge between vertices that connects hole with an outer ring and and link it
  function eliminateHole(hole, outerNode) {
      outerNode = findHoleBridge(hole, outerNode);
      if (outerNode) {
          var b = splitPolygon(outerNode, hole);
  
          // filter collinear points around the cuts
          filterPoints(outerNode, outerNode.next);
          filterPoints(b, b.next);
      }
  }
  
  // David Eberly's algorithm for finding a bridge between hole and outer polygon
  function findHoleBridge(hole, outerNode) {
      var p = outerNode,
          hx = hole.x,
          hy = hole.y,
          qx = -Infinity,
          m;
  
      // find a segment intersected by a ray from the hole's leftmost point to the left;
      // segment's endpoint with lesser x will be potential connection point
      do {
          if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
              var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
              if (x <= hx && x > qx) {
                  qx = x;
                  if (x === hx) {
                      if (hy === p.y) return p;
                      if (hy === p.next.y) return p.next;
                  }
                  m = p.x < p.next.x ? p : p.next;
              }
          }
          p = p.next;
      } while (p !== outerNode);
  
      if (!m) return null;
  
      if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
  
      // look for points inside the triangle of hole point, segment intersection and endpoint;
      // if there are no points found, we have a valid connection;
      // otherwise choose the point of the minimum angle with the ray as connection point
  
      var stop = m,
          mx = m.x,
          my = m.y,
          tanMin = Infinity,
          tan;
  
      p = m;
  
      do {
          if (hx >= p.x && p.x >= mx && hx !== p.x &&
                  pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
  
              tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
  
              if (locallyInside(p, hole) &&
                  (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
                  m = p;
                  tanMin = tan;
              }
          }
  
          p = p.next;
      } while (p !== stop);
  
      return m;
  }
  
  // whether sector in vertex m contains sector in vertex p in the same coordinates
  function sectorContainsSector(m, p) {
      return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
  }
  
  // interlink polygon nodes in z-order
  function indexCurve(start, minX, minY, invSize) {
      var p = start;
      do {
          if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
          p.prevZ = p.prev;
          p.nextZ = p.next;
          p = p.next;
      } while (p !== start);
  
      p.prevZ.nextZ = null;
      p.prevZ = null;
  
      sortLinked(p);
  }
  
  // Simon Tatham's linked list merge sort algorithm
  // http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
  function sortLinked(list) {
      var i, p, q, e, tail, numMerges, pSize, qSize,
          inSize = 1;
  
      do {
          p = list;
          list = null;
          tail = null;
          numMerges = 0;
  
          while (p) {
              numMerges++;
              q = p;
              pSize = 0;
              for (i = 0; i < inSize; i++) {
                  pSize++;
                  q = q.nextZ;
                  if (!q) break;
              }
              qSize = inSize;
  
              while (pSize > 0 || (qSize > 0 && q)) {
  
                  if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                      e = p;
                      p = p.nextZ;
                      pSize--;
                  } else {
                      e = q;
                      q = q.nextZ;
                      qSize--;
                  }
  
                  if (tail) tail.nextZ = e;
                  else list = e;
  
                  e.prevZ = tail;
                  tail = e;
              }
  
              p = q;
          }
  
          tail.nextZ = null;
          inSize *= 2;
  
      } while (numMerges > 1);
  
      return list;
  }
  
  // z-order of a point given coords and inverse of the longer side of data bbox
  function zOrder(x, y, minX, minY, invSize) {
      // coords are transformed into non-negative 15-bit integer range
      x = 32767 * (x - minX) * invSize;
      y = 32767 * (y - minY) * invSize;
  
      x = (x | (x << 8)) & 0x00FF00FF;
      x = (x | (x << 4)) & 0x0F0F0F0F;
      x = (x | (x << 2)) & 0x33333333;
      x = (x | (x << 1)) & 0x55555555;
  
      y = (y | (y << 8)) & 0x00FF00FF;
      y = (y | (y << 4)) & 0x0F0F0F0F;
      y = (y | (y << 2)) & 0x33333333;
      y = (y | (y << 1)) & 0x55555555;
  
      return x | (y << 1);
  }
  
  // find the leftmost node of a polygon ring
  function getLeftmost(start) {
      var p = start,
          leftmost = start;
      do {
          if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
          p = p.next;
      } while (p !== start);
  
      return leftmost;
  }
  
  // check if a point lies within a convex triangle
  function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
      return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
             (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
             (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
  }
  
  // check if a diagonal between two polygon nodes is valid (lies in polygon interior)
  function isValidDiagonal(a, b) {
      return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
             (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
              (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
              equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
  }
  
  // signed area of a triangle
  function area(p, q, r) {
      return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
  }
  
  // check if two points are equal
  function equals(p1, p2) {
      return p1.x === p2.x && p1.y === p2.y;
  }
  
  // check if two segments intersect
  function intersects(p1, q1, p2, q2) {
      var o1 = sign(area(p1, q1, p2));
      var o2 = sign(area(p1, q1, q2));
      var o3 = sign(area(p2, q2, p1));
      var o4 = sign(area(p2, q2, q1));
  
      if (o1 !== o2 && o3 !== o4) return true; // general case
  
      if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
      if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
      if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
      if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
  
      return false;
  }
  
  // for collinear points p, q, r, check if point q lies on segment pr
  function onSegment(p, q, r) {
      return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
  }
  
  function sign(num) {
      return num > 0 ? 1 : num < 0 ? -1 : 0;
  }
  
  // check if a polygon diagonal intersects any polygon segments
  function intersectsPolygon(a, b) {
      var p = a;
      do {
          if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
                  intersects(p, p.next, a, b)) return true;
          p = p.next;
      } while (p !== a);
  
      return false;
  }
  
  // check if a polygon diagonal is locally inside the polygon
  function locallyInside(a, b) {
      return area(a.prev, a, a.next) < 0 ?
          area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
          area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
  }
  
  // check if the middle point of a polygon diagonal is inside the polygon
  function middleInside(a, b) {
      var p = a,
          inside = false,
          px = (a.x + b.x) / 2,
          py = (a.y + b.y) / 2;
      do {
          if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
                  (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
              inside = !inside;
          p = p.next;
      } while (p !== a);
  
      return inside;
  }
  
  // link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
  // if one belongs to the outer ring and another to a hole, it merges it into a single ring
  function splitPolygon(a, b) {
      var a2 = new Node(a.i, a.x, a.y),
          b2 = new Node(b.i, b.x, b.y),
          an = a.next,
          bp = b.prev;
  
      a.next = b;
      b.prev = a;
  
      a2.next = an;
      an.prev = a2;
  
      b2.next = a2;
      a2.prev = b2;
  
      bp.next = b2;
      b2.prev = bp;
  
      return b2;
  }
  
  // create a node and optionally link it with previous one (in a circular doubly linked list)
  function insertNode(i, x, y, last) {
      var p = new Node(i, x, y);
  
      if (!last) {
          p.prev = p;
          p.next = p;
  
      } else {
          p.next = last.next;
          p.prev = last;
          last.next.prev = p;
          last.next = p;
      }
      return p;
  }
  
  function removeNode(p) {
      p.next.prev = p.prev;
      p.prev.next = p.next;
  
      if (p.prevZ) p.prevZ.nextZ = p.nextZ;
      if (p.nextZ) p.nextZ.prevZ = p.prevZ;
  }
  
  function Node(i, x, y) {
      // vertex index in coordinates array
      this.i = i;
  
      // vertex coordinates
      this.x = x;
      this.y = y;
  
      // previous and next vertex nodes in a polygon ring
      this.prev = null;
      this.next = null;
  
      // z-order curve value
      this.z = null;
  
      // previous and next nodes in z-order
      this.prevZ = null;
      this.nextZ = null;
  
      // indicates whether this is a steiner point
      this.steiner = false;
  }
  
  // return a percentage difference between the polygon area and its triangulation area;
  // used to verify correctness of triangulation
  earcut.deviation = function (data, holeIndices, dim, triangles) {
      var hasHoles = holeIndices && holeIndices.length;
      var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
  
      var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
      if (hasHoles) {
          for (var i = 0, len = holeIndices.length; i < len; i++) {
              var start = holeIndices[i] * dim;
              var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
              polygonArea -= Math.abs(signedArea(data, start, end, dim));
          }
      }
  
      var trianglesArea = 0;
      for (i = 0; i < triangles.length; i += 3) {
          var a = triangles[i] * dim;
          var b = triangles[i + 1] * dim;
          var c = triangles[i + 2] * dim;
          trianglesArea += Math.abs(
              (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
              (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
      }
  
      return polygonArea === 0 && trianglesArea === 0 ? 0 :
          Math.abs((trianglesArea - polygonArea) / polygonArea);
  };
  
  function signedArea(data, start, end, dim) {
      var sum = 0;
      for (var i = start, j = end - dim; i < end; i += dim) {
          sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
          j = i;
      }
      return sum;
  }
  
  // turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
  earcut.flatten = function (data) {
      var dim = data[0][0].length,
          result = {vertices: [], holes: [], dimensions: dim},
          holeIndex = 0;
  
      for (var i = 0; i < data.length; i++) {
          for (var j = 0; j < data[i].length; j++) {
              for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
          }
          if (i > 0) {
              holeIndex += data[i - 1].length;
              result.holes.push(holeIndex);
          }
      }
      return result;
  };
  
  },{}],178:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = edgeToAdjacency
  
  var uniq = _dereq_("uniq")
  
  function edgeToAdjacency(edges, numVertices) {
    var numEdges = edges.length
    if(typeof numVertices !== "number") {
      numVertices = 0
      for(var i=0; i<numEdges; ++i) {
        var e = edges[i]
        numVertices = Math.max(numVertices, e[0], e[1])
      }
      numVertices = (numVertices|0) + 1
    }
    numVertices = numVertices|0
    var adj = new Array(numVertices)
    for(var i=0; i<numVertices; ++i) {
      adj[i] = []
    }
    for(var i=0; i<numEdges; ++i) {
      var e = edges[i]
      adj[e[0]].push(e[1])
      adj[e[1]].push(e[0])
    }
    for(var j=0; j<numVertices; ++j) {
      uniq(adj[j], function(a, b) {
        return a - b
      })
    }
    return adj
  }
  },{"uniq":569}],179:[function(_dereq_,module,exports){
  var tarjan = _dereq_('strongly-connected-components');
  
  module.exports = function findCircuits(edges, cb) {
      var circuits = []; // Output
  
      var stack = [];
      var blocked = [];
      var B = {};
      var Ak = [];
      var s;
  
      function unblock(u) {
          blocked[u] = false;
          if(B.hasOwnProperty(u)) {
              Object.keys(B[u]).forEach(function(w) {
                  delete B[u][w];
                  if(blocked[w]) {unblock(w);}
              });
          }
      }
  
      function circuit(v) {
          var found = false;
  
          stack.push(v);
          blocked[v] = true;
  
          // L1
          var i;
          var w;
          for(i = 0; i < Ak[v].length; i++) {
              w = Ak[v][i];
              if(w === s) {
                  output(s, stack);
                  found = true;
              } else if(!blocked[w]) {
                  found = circuit(w);
              }
          }
  
          // L2
          if(found) {
              unblock(v);
          } else {
              for(i = 0; i < Ak[v].length; i++) {
                  w = Ak[v][i];
                  var entry = B[w];
  
                  if(!entry) {
                      entry = {};
                      B[w] = entry;
                  }
  
                  entry[w] = true;
              }
          }
          stack.pop();
          return found;
      }
  
      function output(start, stack) {
          var cycle = [].concat(stack).concat(start);
          if(cb) {
              cb(circuit);
          } else {
              circuits.push(cycle);
          }
      }
  
      function subgraph(minId) {
        // Remove edges with indice smaller than minId
          for(var i = 0; i < edges.length; i++) {
              if(i < minId) edges[i] = [];
              edges[i] = edges[i].filter(function(i) {
                  return i >= minId;
              });
          }
      }
  
      function adjacencyStructureSCC(from) {
          // Make subgraph starting from vertex minId
          subgraph(from);
          var g = edges;
  
          // Find strongly connected components using Tarjan algorithm
          var sccs = tarjan(g);
  
          // Filter out trivial connected components (ie. made of one node)
          var ccs = sccs.components.filter(function(scc) {
              return scc.length > 1;
          });
  
          // Find least vertex
          var leastVertex = Infinity;
          var leastVertexComponent;
          for(var i = 0; i < ccs.length; i++) {
              for(var j = 0; j < ccs[i].length; j++) {
                  if(ccs[i][j] < leastVertex) {
                      leastVertex = ccs[i][j];
                      leastVertexComponent = i;
                  }
              }
          }
  
          var cc = ccs[leastVertexComponent];
  
          if(!cc) return false;
  
          // Return the adjacency list of first component
          var adjList = edges.map(function(l, index) {
              if(cc.indexOf(index) === -1) return [];
              return l.filter(function(i) {
                  return cc.indexOf(i) !== -1;
              });
          });
  
          return {
              leastVertex: leastVertex,
              adjList: adjList
          };
      }
  
      s = 0;
      var n = edges.length;
      while(s < n) {
          // find strong component with least vertex in
          // subgraph starting from vertex `s`
          var p = adjacencyStructureSCC(s);
  
          // Its least vertex
          s = p.leastVertex;
          // Its adjacency list
          Ak = p.adjList;
  
          if(Ak) {
              for(var i = 0; i < Ak.length; i++) {
                  for(var j = 0; j < Ak[i].length; j++) {
                      var vertexId = Ak[i][j];
                      blocked[+vertexId] = false;
                      B[vertexId] = {};
                  }
              }
              circuit(s);
              s = s + 1;
          } else {
              s = n;
          }
  
      }
  
      if(cb) {
          return;
      } else {
          return circuits;
      }
  };
  
  },{"strongly-connected-components":541}],180:[function(_dereq_,module,exports){
  // Inspired by Google Closure:
  // http://closure-library.googlecode.com/svn/docs/
  // closure_goog_array_array.js.html#goog.array.clear
  
  "use strict";
  
  var value = _dereq_("../../object/valid-value");
  
  module.exports = function () {
    value(this).length = 0;
    return this;
  };
  
  },{"../../object/valid-value":211}],181:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./is-implemented")() ? Array.from : _dereq_("./shim");
  
  },{"./is-implemented":182,"./shim":183}],182:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function () {
    var from = Array.from, arr, result;
    if (typeof from !== "function") return false;
    arr = ["raz", "dwa"];
    result = from(arr);
    return Boolean(result && result !== arr && result[1] === "dwa");
  };
  
  },{}],183:[function(_dereq_,module,exports){
  "use strict";
  
  var iteratorSymbol = _dereq_("es6-symbol").iterator
    , isArguments    = _dereq_("../../function/is-arguments")
    , isFunction     = _dereq_("../../function/is-function")
    , toPosInt       = _dereq_("../../number/to-pos-integer")
    , callable       = _dereq_("../../object/valid-callable")
    , validValue     = _dereq_("../../object/valid-value")
    , isValue        = _dereq_("../../object/is-value")
    , isString       = _dereq_("../../string/is-string")
    , isArray        = Array.isArray
    , call           = Function.prototype.call
    , desc           = { configurable: true, enumerable: true, writable: true, value: null }
    , defineProperty = Object.defineProperty;
  
  // eslint-disable-next-line complexity, max-lines-per-function
  module.exports = function (arrayLike/*, mapFn, thisArg*/) {
    var mapFn = arguments[1]
      , thisArg = arguments[2]
      , Context
      , i
      , j
      , arr
      , length
      , code
      , iterator
      , result
      , getIterator
      , value;
  
    arrayLike = Object(validValue(arrayLike));
  
    if (isValue(mapFn)) callable(mapFn);
    if (!this || this === Array || !isFunction(this)) {
      // Result: Plain array
      if (!mapFn) {
        if (isArguments(arrayLike)) {
          // Source: Arguments
          length = arrayLike.length;
          if (length !== 1) return Array.apply(null, arrayLike);
          arr = new Array(1);
          arr[0] = arrayLike[0];
          return arr;
        }
        if (isArray(arrayLike)) {
          // Source: Array
          arr = new Array((length = arrayLike.length));
          for (i = 0; i < length; ++i) arr[i] = arrayLike[i];
          return arr;
        }
      }
      arr = [];
    } else {
      // Result: Non plain array
      Context = this;
    }
  
    if (!isArray(arrayLike)) {
      if ((getIterator = arrayLike[iteratorSymbol]) !== undefined) {
        // Source: Iterator
        iterator = callable(getIterator).call(arrayLike);
        if (Context) arr = new Context();
        result = iterator.next();
        i = 0;
        while (!result.done) {
          value = mapFn ? call.call(mapFn, thisArg, result.value, i) : result.value;
          if (Context) {
            desc.value = value;
            defineProperty(arr, i, desc);
          } else {
            arr[i] = value;
          }
          result = iterator.next();
          ++i;
        }
        length = i;
      } else if (isString(arrayLike)) {
        // Source: String
        length = arrayLike.length;
        if (Context) arr = new Context();
        for (i = 0, j = 0; i < length; ++i) {
          value = arrayLike[i];
          if (i + 1 < length) {
            code = value.charCodeAt(0);
            // eslint-disable-next-line max-depth
            if (code >= 0xd800 && code <= 0xdbff) value += arrayLike[++i];
          }
          value = mapFn ? call.call(mapFn, thisArg, value, j) : value;
          if (Context) {
            desc.value = value;
            defineProperty(arr, j, desc);
          } else {
            arr[j] = value;
          }
          ++j;
        }
        length = j;
      }
    }
    if (length === undefined) {
      // Source: array or array-like
      length = toPosInt(arrayLike.length);
      if (Context) arr = new Context(length);
      for (i = 0; i < length; ++i) {
        value = mapFn ? call.call(mapFn, thisArg, arrayLike[i], i) : arrayLike[i];
        if (Context) {
          desc.value = value;
          defineProperty(arr, i, desc);
        } else {
          arr[i] = value;
        }
      }
    }
    if (Context) {
      desc.value = null;
      arr.length = length;
    }
    return arr;
  };
  
  },{"../../function/is-arguments":184,"../../function/is-function":185,"../../number/to-pos-integer":191,"../../object/is-value":200,"../../object/valid-callable":209,"../../object/valid-value":211,"../../string/is-string":215,"es6-symbol":225}],184:[function(_dereq_,module,exports){
  "use strict";
  
  var objToString = Object.prototype.toString
    , id = objToString.call((function () { return arguments; })());
  
  module.exports = function (value) { return objToString.call(value) === id; };
  
  },{}],185:[function(_dereq_,module,exports){
  "use strict";
  
  var objToString = Object.prototype.toString
    , isFunctionStringTag = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);
  
  module.exports = function (value) {
    return typeof value === "function" && isFunctionStringTag(objToString.call(value));
  };
  
  },{}],186:[function(_dereq_,module,exports){
  "use strict";
  
  // eslint-disable-next-line no-empty-function
  module.exports = function () {};
  
  },{}],187:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./is-implemented")() ? Math.sign : _dereq_("./shim");
  
  },{"./is-implemented":188,"./shim":189}],188:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function () {
    var sign = Math.sign;
    if (typeof sign !== "function") return false;
    return sign(10) === 1 && sign(-20) === -1;
  };
  
  },{}],189:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function (value) {
    value = Number(value);
    if (isNaN(value) || value === 0) return value;
    return value > 0 ? 1 : -1;
  };
  
  },{}],190:[function(_dereq_,module,exports){
  "use strict";
  
  var sign  = _dereq_("../math/sign")
    , abs   = Math.abs
    , floor = Math.floor;
  
  module.exports = function (value) {
    if (isNaN(value)) return 0;
    value = Number(value);
    if (value === 0 || !isFinite(value)) return value;
    return sign(value) * floor(abs(value));
  };
  
  },{"../math/sign":187}],191:[function(_dereq_,module,exports){
  "use strict";
  
  var toInteger = _dereq_("./to-integer")
    , max       = Math.max;
  
  module.exports = function (value) { return max(0, toInteger(value)); };
  
  },{"./to-integer":190}],192:[function(_dereq_,module,exports){
  // Internal method, used by iteration functions.
  // Calls a function for each key-value pair found in object
  // Optionally takes compareFn to iterate object in specific order
  
  "use strict";
  
  var callable                = _dereq_("./valid-callable")
    , value                   = _dereq_("./valid-value")
    , bind                    = Function.prototype.bind
    , call                    = Function.prototype.call
    , keys                    = Object.keys
    , objPropertyIsEnumerable = Object.prototype.propertyIsEnumerable;
  
  module.exports = function (method, defVal) {
    return function (obj, cb/*, thisArg, compareFn*/) {
      var list, thisArg = arguments[2], compareFn = arguments[3];
      obj = Object(value(obj));
      callable(cb);
  
      list = keys(obj);
      if (compareFn) {
        list.sort(typeof compareFn === "function" ? bind.call(compareFn, obj) : undefined);
      }
      if (typeof method !== "function") method = list[method];
      return call.call(method, list, function (key, index) {
        if (!objPropertyIsEnumerable.call(obj, key)) return defVal;
        return call.call(cb, thisArg, obj[key], key, obj, index);
      });
    };
  };
  
  },{"./valid-callable":209,"./valid-value":211}],193:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./is-implemented")() ? Object.assign : _dereq_("./shim");
  
  },{"./is-implemented":194,"./shim":195}],194:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function () {
    var assign = Object.assign, obj;
    if (typeof assign !== "function") return false;
    obj = { foo: "raz" };
    assign(obj, { bar: "dwa" }, { trzy: "trzy" });
    return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
  };
  
  },{}],195:[function(_dereq_,module,exports){
  "use strict";
  
  var keys  = _dereq_("../keys")
    , value = _dereq_("../valid-value")
    , max   = Math.max;
  
  module.exports = function (dest, src/*, …srcn*/) {
    var error, i, length = max(arguments.length, 2), assign;
    dest = Object(value(dest));
    assign = function (key) {
      try {
        dest[key] = src[key];
      } catch (e) {
        if (!error) error = e;
      }
    };
    for (i = 1; i < length; ++i) {
      src = arguments[i];
      keys(src).forEach(assign);
    }
    if (error !== undefined) throw error;
    return dest;
  };
  
  },{"../keys":201,"../valid-value":211}],196:[function(_dereq_,module,exports){
  "use strict";
  
  var aFrom  = _dereq_("../array/from")
    , assign = _dereq_("./assign")
    , value  = _dereq_("./valid-value");
  
  module.exports = function (obj/*, propertyNames, options*/) {
    var copy = Object(value(obj)), propertyNames = arguments[1], options = Object(arguments[2]);
    if (copy !== obj && !propertyNames) return copy;
    var result = {};
    if (propertyNames) {
      aFrom(propertyNames, function (propertyName) {
        if (options.ensure || propertyName in obj) result[propertyName] = obj[propertyName];
      });
    } else {
      assign(result, obj);
    }
    return result;
  };
  
  },{"../array/from":181,"./assign":193,"./valid-value":211}],197:[function(_dereq_,module,exports){
  // Workaround for http://code.google.com/p/v8/issues/detail?id=2804
  
  "use strict";
  
  var create = Object.create, shim;
  
  if (!_dereq_("./set-prototype-of/is-implemented")()) {
    shim = _dereq_("./set-prototype-of/shim");
  }
  
  module.exports = (function () {
    var nullObject, polyProps, desc;
    if (!shim) return create;
    if (shim.level !== 1) return create;
  
    nullObject = {};
    polyProps = {};
    desc = { configurable: false, enumerable: false, writable: true, value: undefined };
    Object.getOwnPropertyNames(Object.prototype).forEach(function (name) {
      if (name === "__proto__") {
        polyProps[name] = {
          configurable: true,
          enumerable: false,
          writable: true,
          value: undefined
        };
        return;
      }
      polyProps[name] = desc;
    });
    Object.defineProperties(nullObject, polyProps);
  
    Object.defineProperty(shim, "nullPolyfill", {
      configurable: false,
      enumerable: false,
      writable: false,
      value: nullObject
    });
  
    return function (prototype, props) {
      return create(prototype === null ? nullObject : prototype, props);
    };
  })();
  
  },{"./set-prototype-of/is-implemented":207,"./set-prototype-of/shim":208}],198:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./_iterate")("forEach");
  
  },{"./_iterate":192}],199:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue = _dereq_("./is-value");
  
  var map = { function: true, object: true };
  
  module.exports = function (value) { return (isValue(value) && map[typeof value]) || false; };
  
  },{"./is-value":200}],200:[function(_dereq_,module,exports){
  "use strict";
  
  var _undefined = _dereq_("../function/noop")(); // Support ES3 engines
  
  module.exports = function (val) { return val !== _undefined && val !== null; };
  
  },{"../function/noop":186}],201:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./is-implemented")() ? Object.keys : _dereq_("./shim");
  
  },{"./is-implemented":202,"./shim":203}],202:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function () {
    try {
      Object.keys("primitive");
      return true;
    } catch (e) {
      return false;
    }
  };
  
  },{}],203:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue = _dereq_("../is-value");
  
  var keys = Object.keys;
  
  module.exports = function (object) { return keys(isValue(object) ? Object(object) : object); };
  
  },{"../is-value":200}],204:[function(_dereq_,module,exports){
  "use strict";
  
  var callable = _dereq_("./valid-callable")
    , forEach  = _dereq_("./for-each")
    , call     = Function.prototype.call;
  
  module.exports = function (obj, cb/*, thisArg*/) {
    var result = {}, thisArg = arguments[2];
    callable(cb);
    forEach(obj, function (value, key, targetObj, index) {
      result[key] = call.call(cb, thisArg, value, key, targetObj, index);
    });
    return result;
  };
  
  },{"./for-each":198,"./valid-callable":209}],205:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue = _dereq_("./is-value");
  
  var forEach = Array.prototype.forEach, create = Object.create;
  
  var process = function (src, obj) {
    var key;
    for (key in src) obj[key] = src[key];
  };
  
  // eslint-disable-next-line no-unused-vars
  module.exports = function (opts1/*, …options*/) {
    var result = create(null);
    forEach.call(arguments, function (options) {
      if (!isValue(options)) return;
      process(Object(options), result);
    });
    return result;
  };
  
  },{"./is-value":200}],206:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./is-implemented")() ? Object.setPrototypeOf : _dereq_("./shim");
  
  },{"./is-implemented":207,"./shim":208}],207:[function(_dereq_,module,exports){
  "use strict";
  
  var create = Object.create, getPrototypeOf = Object.getPrototypeOf, plainObject = {};
  
  module.exports = function (/* CustomCreate*/) {
    var setPrototypeOf = Object.setPrototypeOf, customCreate = arguments[0] || create;
    if (typeof setPrototypeOf !== "function") return false;
    return getPrototypeOf(setPrototypeOf(customCreate(null), plainObject)) === plainObject;
  };
  
  },{}],208:[function(_dereq_,module,exports){
  /* eslint no-proto: "off" */
  
  // Big thanks to @WebReflection for sorting this out
  // https://gist.github.com/WebReflection/5593554
  
  "use strict";
  
  var isObject         = _dereq_("../is-object")
    , value            = _dereq_("../valid-value")
    , objIsPrototypeOf = Object.prototype.isPrototypeOf
    , defineProperty   = Object.defineProperty
    , nullDesc         = { configurable: true, enumerable: false, writable: true, value: undefined }
    , validate;
  
  validate = function (obj, prototype) {
    value(obj);
    if (prototype === null || isObject(prototype)) return obj;
    throw new TypeError("Prototype must be null or an object");
  };
  
  module.exports = (function (status) {
    var fn, set;
    if (!status) return null;
    if (status.level === 2) {
      if (status.set) {
        set = status.set;
        fn = function (obj, prototype) {
          set.call(validate(obj, prototype), prototype);
          return obj;
        };
      } else {
        fn = function (obj, prototype) {
          validate(obj, prototype).__proto__ = prototype;
          return obj;
        };
      }
    } else {
      fn = function self(obj, prototype) {
        var isNullBase;
        validate(obj, prototype);
        isNullBase = objIsPrototypeOf.call(self.nullPolyfill, obj);
        if (isNullBase) delete self.nullPolyfill.__proto__;
        if (prototype === null) prototype = self.nullPolyfill;
        obj.__proto__ = prototype;
        if (isNullBase) defineProperty(self.nullPolyfill, "__proto__", nullDesc);
        return obj;
      };
    }
    return Object.defineProperty(fn, "level", {
      configurable: false,
      enumerable: false,
      writable: false,
      value: status.level
    });
  })(
    (function () {
      var tmpObj1 = Object.create(null)
        , tmpObj2 = {}
        , set
        , desc = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");
  
      if (desc) {
        try {
          set = desc.set; // Opera crashes at this point
          set.call(tmpObj1, tmpObj2);
        } catch (ignore) {}
        if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { set: set, level: 2 };
      }
  
      tmpObj1.__proto__ = tmpObj2;
      if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 2 };
  
      tmpObj1 = {};
      tmpObj1.__proto__ = tmpObj2;
      if (Object.getPrototypeOf(tmpObj1) === tmpObj2) return { level: 1 };
  
      return false;
    })()
  );
  
  _dereq_("../create");
  
  },{"../create":197,"../is-object":199,"../valid-value":211}],209:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function (fn) {
    if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
    return fn;
  };
  
  },{}],210:[function(_dereq_,module,exports){
  "use strict";
  
  var isObject = _dereq_("./is-object");
  
  module.exports = function (value) {
    if (!isObject(value)) throw new TypeError(value + " is not an Object");
    return value;
  };
  
  },{"./is-object":199}],211:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue = _dereq_("./is-value");
  
  module.exports = function (value) {
    if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
    return value;
  };
  
  },{"./is-value":200}],212:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./is-implemented")() ? String.prototype.contains : _dereq_("./shim");
  
  },{"./is-implemented":213,"./shim":214}],213:[function(_dereq_,module,exports){
  "use strict";
  
  var str = "razdwatrzy";
  
  module.exports = function () {
    if (typeof str.contains !== "function") return false;
    return str.contains("dwa") === true && str.contains("foo") === false;
  };
  
  },{}],214:[function(_dereq_,module,exports){
  "use strict";
  
  var indexOf = String.prototype.indexOf;
  
  module.exports = function (searchString/*, position*/) {
    return indexOf.call(this, searchString, arguments[1]) > -1;
  };
  
  },{}],215:[function(_dereq_,module,exports){
  "use strict";
  
  var objToString = Object.prototype.toString, id = objToString.call("");
  
  module.exports = function (value) {
    return (
      typeof value === "string" ||
      (value &&
        typeof value === "object" &&
        (value instanceof String || objToString.call(value) === id)) ||
      false
    );
  };
  
  },{}],216:[function(_dereq_,module,exports){
  "use strict";
  
  var generated = Object.create(null), random = Math.random;
  
  module.exports = function () {
    var str;
    do {
      str = random().toString(36).slice(2);
    } while (generated[str]);
    return str;
  };
  
  },{}],217:[function(_dereq_,module,exports){
  "use strict";
  
  var setPrototypeOf = _dereq_("es5-ext/object/set-prototype-of")
    , contains       = _dereq_("es5-ext/string/#/contains")
    , d              = _dereq_("d")
    , Symbol         = _dereq_("es6-symbol")
    , Iterator       = _dereq_("./");
  
  var defineProperty = Object.defineProperty, ArrayIterator;
  
  ArrayIterator = module.exports = function (arr, kind) {
    if (!(this instanceof ArrayIterator)) throw new TypeError("Constructor requires 'new'");
    Iterator.call(this, arr);
    if (!kind) kind = "value";
    else if (contains.call(kind, "key+value")) kind = "key+value";
    else if (contains.call(kind, "key")) kind = "key";
    else kind = "value";
    defineProperty(this, "__kind__", d("", kind));
  };
  if (setPrototypeOf) setPrototypeOf(ArrayIterator, Iterator);
  
  // Internal %ArrayIteratorPrototype% doesn't expose its constructor
  delete ArrayIterator.prototype.constructor;
  
  ArrayIterator.prototype = Object.create(Iterator.prototype, {
    _resolve: d(function (i) {
      if (this.__kind__ === "value") return this.__list__[i];
      if (this.__kind__ === "key+value") return [i, this.__list__[i]];
      return i;
    })
  });
  defineProperty(ArrayIterator.prototype, Symbol.toStringTag, d("c", "Array Iterator"));
  
  },{"./":220,"d":155,"es5-ext/object/set-prototype-of":206,"es5-ext/string/#/contains":212,"es6-symbol":225}],218:[function(_dereq_,module,exports){
  "use strict";
  
  var isArguments = _dereq_("es5-ext/function/is-arguments")
    , callable    = _dereq_("es5-ext/object/valid-callable")
    , isString    = _dereq_("es5-ext/string/is-string")
    , get         = _dereq_("./get");
  
  var isArray = Array.isArray, call = Function.prototype.call, some = Array.prototype.some;
  
  module.exports = function (iterable, cb /*, thisArg*/) {
    var mode, thisArg = arguments[2], result, doBreak, broken, i, length, char, code;
    if (isArray(iterable) || isArguments(iterable)) mode = "array";
    else if (isString(iterable)) mode = "string";
    else iterable = get(iterable);
  
    callable(cb);
    doBreak = function () {
      broken = true;
    };
    if (mode === "array") {
      some.call(iterable, function (value) {
        call.call(cb, thisArg, value, doBreak);
        return broken;
      });
      return;
    }
    if (mode === "string") {
      length = iterable.length;
      for (i = 0; i < length; ++i) {
        char = iterable[i];
        if (i + 1 < length) {
          code = char.charCodeAt(0);
          if (code >= 0xd800 && code <= 0xdbff) char += iterable[++i];
        }
        call.call(cb, thisArg, char, doBreak);
        if (broken) break;
      }
      return;
    }
    result = iterable.next();
  
    while (!result.done) {
      call.call(cb, thisArg, result.value, doBreak);
      if (broken) return;
      result = iterable.next();
    }
  };
  
  },{"./get":219,"es5-ext/function/is-arguments":184,"es5-ext/object/valid-callable":209,"es5-ext/string/is-string":215}],219:[function(_dereq_,module,exports){
  "use strict";
  
  var isArguments    = _dereq_("es5-ext/function/is-arguments")
    , isString       = _dereq_("es5-ext/string/is-string")
    , ArrayIterator  = _dereq_("./array")
    , StringIterator = _dereq_("./string")
    , iterable       = _dereq_("./valid-iterable")
    , iteratorSymbol = _dereq_("es6-symbol").iterator;
  
  module.exports = function (obj) {
    if (typeof iterable(obj)[iteratorSymbol] === "function") return obj[iteratorSymbol]();
    if (isArguments(obj)) return new ArrayIterator(obj);
    if (isString(obj)) return new StringIterator(obj);
    return new ArrayIterator(obj);
  };
  
  },{"./array":217,"./string":222,"./valid-iterable":223,"es5-ext/function/is-arguments":184,"es5-ext/string/is-string":215,"es6-symbol":225}],220:[function(_dereq_,module,exports){
  "use strict";
  
  var clear    = _dereq_("es5-ext/array/#/clear")
    , assign   = _dereq_("es5-ext/object/assign")
    , callable = _dereq_("es5-ext/object/valid-callable")
    , value    = _dereq_("es5-ext/object/valid-value")
    , d        = _dereq_("d")
    , autoBind = _dereq_("d/auto-bind")
    , Symbol   = _dereq_("es6-symbol");
  
  var defineProperty = Object.defineProperty, defineProperties = Object.defineProperties, Iterator;
  
  module.exports = Iterator = function (list, context) {
    if (!(this instanceof Iterator)) throw new TypeError("Constructor requires 'new'");
    defineProperties(this, {
      __list__: d("w", value(list)),
      __context__: d("w", context),
      __nextIndex__: d("w", 0)
    });
    if (!context) return;
    callable(context.on);
    context.on("_add", this._onAdd);
    context.on("_delete", this._onDelete);
    context.on("_clear", this._onClear);
  };
  
  // Internal %IteratorPrototype% doesn't expose its constructor
  delete Iterator.prototype.constructor;
  
  defineProperties(
    Iterator.prototype,
    assign(
      {
        _next: d(function () {
          var i;
          if (!this.__list__) return undefined;
          if (this.__redo__) {
            i = this.__redo__.shift();
            if (i !== undefined) return i;
          }
          if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
          this._unBind();
          return undefined;
        }),
        next: d(function () {
          return this._createResult(this._next());
        }),
        _createResult: d(function (i) {
          if (i === undefined) return { done: true, value: undefined };
          return { done: false, value: this._resolve(i) };
        }),
        _resolve: d(function (i) {
          return this.__list__[i];
        }),
        _unBind: d(function () {
          this.__list__ = null;
          delete this.__redo__;
          if (!this.__context__) return;
          this.__context__.off("_add", this._onAdd);
          this.__context__.off("_delete", this._onDelete);
          this.__context__.off("_clear", this._onClear);
          this.__context__ = null;
        }),
        toString: d(function () {
          return "[object " + (this[Symbol.toStringTag] || "Object") + "]";
        })
      },
      autoBind({
        _onAdd: d(function (index) {
          if (index >= this.__nextIndex__) return;
          ++this.__nextIndex__;
          if (!this.__redo__) {
            defineProperty(this, "__redo__", d("c", [index]));
            return;
          }
          this.__redo__.forEach(function (redo, i) {
            if (redo >= index) this.__redo__[i] = ++redo;
          }, this);
          this.__redo__.push(index);
        }),
        _onDelete: d(function (index) {
          var i;
          if (index >= this.__nextIndex__) return;
          --this.__nextIndex__;
          if (!this.__redo__) return;
          i = this.__redo__.indexOf(index);
          if (i !== -1) this.__redo__.splice(i, 1);
          this.__redo__.forEach(function (redo, j) {
            if (redo > index) this.__redo__[j] = --redo;
          }, this);
        }),
        _onClear: d(function () {
          if (this.__redo__) clear.call(this.__redo__);
          this.__nextIndex__ = 0;
        })
      })
    )
  );
  
  defineProperty(
    Iterator.prototype,
    Symbol.iterator,
    d(function () {
      return this;
    })
  );
  
  },{"d":155,"d/auto-bind":154,"es5-ext/array/#/clear":180,"es5-ext/object/assign":193,"es5-ext/object/valid-callable":209,"es5-ext/object/valid-value":211,"es6-symbol":225}],221:[function(_dereq_,module,exports){
  "use strict";
  
  var isArguments = _dereq_("es5-ext/function/is-arguments")
    , isValue     = _dereq_("es5-ext/object/is-value")
    , isString    = _dereq_("es5-ext/string/is-string");
  
  var iteratorSymbol = _dereq_("es6-symbol").iterator
    , isArray        = Array.isArray;
  
  module.exports = function (value) {
    if (!isValue(value)) return false;
    if (isArray(value)) return true;
    if (isString(value)) return true;
    if (isArguments(value)) return true;
    return typeof value[iteratorSymbol] === "function";
  };
  
  },{"es5-ext/function/is-arguments":184,"es5-ext/object/is-value":200,"es5-ext/string/is-string":215,"es6-symbol":225}],222:[function(_dereq_,module,exports){
  // Thanks @mathiasbynens
  // http://mathiasbynens.be/notes/javascript-unicode#iterating-over-symbols
  
  "use strict";
  
  var setPrototypeOf = _dereq_("es5-ext/object/set-prototype-of")
    , d              = _dereq_("d")
    , Symbol         = _dereq_("es6-symbol")
    , Iterator       = _dereq_("./");
  
  var defineProperty = Object.defineProperty, StringIterator;
  
  StringIterator = module.exports = function (str) {
    if (!(this instanceof StringIterator)) throw new TypeError("Constructor requires 'new'");
    str = String(str);
    Iterator.call(this, str);
    defineProperty(this, "__length__", d("", str.length));
  };
  if (setPrototypeOf) setPrototypeOf(StringIterator, Iterator);
  
  // Internal %ArrayIteratorPrototype% doesn't expose its constructor
  delete StringIterator.prototype.constructor;
  
  StringIterator.prototype = Object.create(Iterator.prototype, {
    _next: d(function () {
      if (!this.__list__) return undefined;
      if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
      this._unBind();
      return undefined;
    }),
    _resolve: d(function (i) {
      var char = this.__list__[i], code;
      if (this.__nextIndex__ === this.__length__) return char;
      code = char.charCodeAt(0);
      if (code >= 0xd800 && code <= 0xdbff) return char + this.__list__[this.__nextIndex__++];
      return char;
    })
  });
  defineProperty(StringIterator.prototype, Symbol.toStringTag, d("c", "String Iterator"));
  
  },{"./":220,"d":155,"es5-ext/object/set-prototype-of":206,"es6-symbol":225}],223:[function(_dereq_,module,exports){
  "use strict";
  
  var isIterable = _dereq_("./is-iterable");
  
  module.exports = function (value) {
    if (!isIterable(value)) throw new TypeError(value + " is not iterable");
    return value;
  };
  
  },{"./is-iterable":221}],224:[function(_dereq_,module,exports){
  (function (process,global){
  /*!
   * @overview es6-promise - a tiny implementation of Promises/A+.
   * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
   * @license   Licensed under MIT license
   *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
   * @version   v4.2.8+1e68dce6
   */
  
  (function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.ES6Promise = factory());
  }(this, (function () { 'use strict';
  
  function objectOrFunction(x) {
    var type = typeof x;
    return x !== null && (type === 'object' || type === 'function');
  }
  
  function isFunction(x) {
    return typeof x === 'function';
  }
  
  
  
  var _isArray = void 0;
  if (Array.isArray) {
    _isArray = Array.isArray;
  } else {
    _isArray = function (x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    };
  }
  
  var isArray = _isArray;
  
  var len = 0;
  var vertxNext = void 0;
  var customSchedulerFn = void 0;
  
  var asap = function asap(callback, arg) {
    queue[len] = callback;
    queue[len + 1] = arg;
    len += 2;
    if (len === 2) {
      // If len is 2, that means that we need to schedule an async flush.
      // If additional callbacks are queued before the queue is flushed, they
      // will be processed by this flush that we are scheduling.
      if (customSchedulerFn) {
        customSchedulerFn(flush);
      } else {
        scheduleFlush();
      }
    }
  };
  
  function setScheduler(scheduleFn) {
    customSchedulerFn = scheduleFn;
  }
  
  function setAsap(asapFn) {
    asap = asapFn;
  }
  
  var browserWindow = typeof window !== 'undefined' ? window : undefined;
  var browserGlobal = browserWindow || {};
  var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
  var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
  
  // test for web worker but not in IE10
  var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
  
  // node
  function useNextTick() {
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // see https://github.com/cujojs/when/issues/410 for details
    return function () {
      return process.nextTick(flush);
    };
  }
  
  // vertx
  function useVertxTimer() {
    if (typeof vertxNext !== 'undefined') {
      return function () {
        vertxNext(flush);
      };
    }
  
    return useSetTimeout();
  }
  
  function useMutationObserver() {
    var iterations = 0;
    var observer = new BrowserMutationObserver(flush);
    var node = document.createTextNode('');
    observer.observe(node, { characterData: true });
  
    return function () {
      node.data = iterations = ++iterations % 2;
    };
  }
  
  // web worker
  function useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    return function () {
      return channel.port2.postMessage(0);
    };
  }
  
  function useSetTimeout() {
    // Store setTimeout reference so es6-promise will be unaffected by
    // other code modifying setTimeout (like sinon.useFakeTimers())
    var globalSetTimeout = setTimeout;
    return function () {
      return globalSetTimeout(flush, 1);
    };
  }
  
  var queue = new Array(1000);
  function flush() {
    for (var i = 0; i < len; i += 2) {
      var callback = queue[i];
      var arg = queue[i + 1];
  
      callback(arg);
  
      queue[i] = undefined;
      queue[i + 1] = undefined;
    }
  
    len = 0;
  }
  
  function attemptVertx() {
    try {
      var vertx = Function('return this')().require('vertx');
      vertxNext = vertx.runOnLoop || vertx.runOnContext;
      return useVertxTimer();
    } catch (e) {
      return useSetTimeout();
    }
  }
  
  var scheduleFlush = void 0;
  // Decide what async method to use to triggering processing of queued callbacks:
  if (isNode) {
    scheduleFlush = useNextTick();
  } else if (BrowserMutationObserver) {
    scheduleFlush = useMutationObserver();
  } else if (isWorker) {
    scheduleFlush = useMessageChannel();
  } else if (browserWindow === undefined && typeof _dereq_ === 'function') {
    scheduleFlush = attemptVertx();
  } else {
    scheduleFlush = useSetTimeout();
  }
  
  function then(onFulfillment, onRejection) {
    var parent = this;
  
    var child = new this.constructor(noop);
  
    if (child[PROMISE_ID] === undefined) {
      makePromise(child);
    }
  
    var _state = parent._state;
  
  
    if (_state) {
      var callback = arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    } else {
      subscribe(parent, child, onFulfillment, onRejection);
    }
  
    return child;
  }
  
  /**
    `Promise.resolve` returns a promise that will become resolved with the
    passed `value`. It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      resolve(1);
    });
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.resolve(1);
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    @method resolve
    @static
    @param {Any} value value that the returned promise will be resolved with
    Useful for tooling.
    @return {Promise} a promise that will become fulfilled with the given
    `value`
  */
  function resolve$1(object) {
    /*jshint validthis:true */
    var Constructor = this;
  
    if (object && typeof object === 'object' && object.constructor === Constructor) {
      return object;
    }
  
    var promise = new Constructor(noop);
    resolve(promise, object);
    return promise;
  }
  
  var PROMISE_ID = Math.random().toString(36).substring(2);
  
  function noop() {}
  
  var PENDING = void 0;
  var FULFILLED = 1;
  var REJECTED = 2;
  
  function selfFulfillment() {
    return new TypeError("You cannot resolve a promise with itself");
  }
  
  function cannotReturnOwn() {
    return new TypeError('A promises callback cannot return that same promise.');
  }
  
  function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
    try {
      then$$1.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
      return e;
    }
  }
  
  function handleForeignThenable(promise, thenable, then$$1) {
    asap(function (promise) {
      var sealed = false;
      var error = tryThen(then$$1, thenable, function (value) {
        if (sealed) {
          return;
        }
        sealed = true;
        if (thenable !== value) {
          resolve(promise, value);
        } else {
          fulfill(promise, value);
        }
      }, function (reason) {
        if (sealed) {
          return;
        }
        sealed = true;
  
        reject(promise, reason);
      }, 'Settle: ' + (promise._label || ' unknown promise'));
  
      if (!sealed && error) {
        sealed = true;
        reject(promise, error);
      }
    }, promise);
  }
  
  function handleOwnThenable(promise, thenable) {
    if (thenable._state === FULFILLED) {
      fulfill(promise, thenable._result);
    } else if (thenable._state === REJECTED) {
      reject(promise, thenable._result);
    } else {
      subscribe(thenable, undefined, function (value) {
        return resolve(promise, value);
      }, function (reason) {
        return reject(promise, reason);
      });
    }
  }
  
  function handleMaybeThenable(promise, maybeThenable, then$$1) {
    if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
      handleOwnThenable(promise, maybeThenable);
    } else {
      if (then$$1 === undefined) {
        fulfill(promise, maybeThenable);
      } else if (isFunction(then$$1)) {
        handleForeignThenable(promise, maybeThenable, then$$1);
      } else {
        fulfill(promise, maybeThenable);
      }
    }
  }
  
  function resolve(promise, value) {
    if (promise === value) {
      reject(promise, selfFulfillment());
    } else if (objectOrFunction(value)) {
      var then$$1 = void 0;
      try {
        then$$1 = value.then;
      } catch (error) {
        reject(promise, error);
        return;
      }
      handleMaybeThenable(promise, value, then$$1);
    } else {
      fulfill(promise, value);
    }
  }
  
  function publishRejection(promise) {
    if (promise._onerror) {
      promise._onerror(promise._result);
    }
  
    publish(promise);
  }
  
  function fulfill(promise, value) {
    if (promise._state !== PENDING) {
      return;
    }
  
    promise._result = value;
    promise._state = FULFILLED;
  
    if (promise._subscribers.length !== 0) {
      asap(publish, promise);
    }
  }
  
  function reject(promise, reason) {
    if (promise._state !== PENDING) {
      return;
    }
    promise._state = REJECTED;
    promise._result = reason;
  
    asap(publishRejection, promise);
  }
  
  function subscribe(parent, child, onFulfillment, onRejection) {
    var _subscribers = parent._subscribers;
    var length = _subscribers.length;
  
  
    parent._onerror = null;
  
    _subscribers[length] = child;
    _subscribers[length + FULFILLED] = onFulfillment;
    _subscribers[length + REJECTED] = onRejection;
  
    if (length === 0 && parent._state) {
      asap(publish, parent);
    }
  }
  
  function publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;
  
    if (subscribers.length === 0) {
      return;
    }
  
    var child = void 0,
        callback = void 0,
        detail = promise._result;
  
    for (var i = 0; i < subscribers.length; i += 3) {
      child = subscribers[i];
      callback = subscribers[i + settled];
  
      if (child) {
        invokeCallback(settled, child, callback, detail);
      } else {
        callback(detail);
      }
    }
  
    promise._subscribers.length = 0;
  }
  
  function invokeCallback(settled, promise, callback, detail) {
    var hasCallback = isFunction(callback),
        value = void 0,
        error = void 0,
        succeeded = true;
  
    if (hasCallback) {
      try {
        value = callback(detail);
      } catch (e) {
        succeeded = false;
        error = e;
      }
  
      if (promise === value) {
        reject(promise, cannotReturnOwn());
        return;
      }
    } else {
      value = detail;
    }
  
    if (promise._state !== PENDING) {
      // noop
    } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (succeeded === false) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
  }
  
  function initializePromise(promise, resolver) {
    try {
      resolver(function resolvePromise(value) {
        resolve(promise, value);
      }, function rejectPromise(reason) {
        reject(promise, reason);
      });
    } catch (e) {
      reject(promise, e);
    }
  }
  
  var id = 0;
  function nextId() {
    return id++;
  }
  
  function makePromise(promise) {
    promise[PROMISE_ID] = id++;
    promise._state = undefined;
    promise._result = undefined;
    promise._subscribers = [];
  }
  
  function validationError() {
    return new Error('Array Methods must be provided an Array');
  }
  
  var Enumerator = function () {
    function Enumerator(Constructor, input) {
      this._instanceConstructor = Constructor;
      this.promise = new Constructor(noop);
  
      if (!this.promise[PROMISE_ID]) {
        makePromise(this.promise);
      }
  
      if (isArray(input)) {
        this.length = input.length;
        this._remaining = input.length;
  
        this._result = new Array(this.length);
  
        if (this.length === 0) {
          fulfill(this.promise, this._result);
        } else {
          this.length = this.length || 0;
          this._enumerate(input);
          if (this._remaining === 0) {
            fulfill(this.promise, this._result);
          }
        }
      } else {
        reject(this.promise, validationError());
      }
    }
  
    Enumerator.prototype._enumerate = function _enumerate(input) {
      for (var i = 0; this._state === PENDING && i < input.length; i++) {
        this._eachEntry(input[i], i);
      }
    };
  
    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
      var c = this._instanceConstructor;
      var resolve$$1 = c.resolve;
  
  
      if (resolve$$1 === resolve$1) {
        var _then = void 0;
        var error = void 0;
        var didError = false;
        try {
          _then = entry.then;
        } catch (e) {
          didError = true;
          error = e;
        }
  
        if (_then === then && entry._state !== PENDING) {
          this._settledAt(entry._state, i, entry._result);
        } else if (typeof _then !== 'function') {
          this._remaining--;
          this._result[i] = entry;
        } else if (c === Promise$1) {
          var promise = new c(noop);
          if (didError) {
            reject(promise, error);
          } else {
            handleMaybeThenable(promise, entry, _then);
          }
          this._willSettleAt(promise, i);
        } else {
          this._willSettleAt(new c(function (resolve$$1) {
            return resolve$$1(entry);
          }), i);
        }
      } else {
        this._willSettleAt(resolve$$1(entry), i);
      }
    };
  
    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
      var promise = this.promise;
  
  
      if (promise._state === PENDING) {
        this._remaining--;
  
        if (state === REJECTED) {
          reject(promise, value);
        } else {
          this._result[i] = value;
        }
      }
  
      if (this._remaining === 0) {
        fulfill(promise, this._result);
      }
    };
  
    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
      var enumerator = this;
  
      subscribe(promise, undefined, function (value) {
        return enumerator._settledAt(FULFILLED, i, value);
      }, function (reason) {
        return enumerator._settledAt(REJECTED, i, reason);
      });
    };
  
    return Enumerator;
  }();
  
  /**
    `Promise.all` accepts an array of promises, and returns a new promise which
    is fulfilled with an array of fulfillment values for the passed promises, or
    rejected with the reason of the first passed promise to be rejected. It casts all
    elements of the passed iterable to promises as it runs this algorithm.
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = resolve(2);
    let promise3 = resolve(3);
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // The array here would be [ 1, 2, 3 ];
    });
    ```
  
    If any of the `promises` given to `all` are rejected, the first promise
    that is rejected will be given as an argument to the returned promises's
    rejection handler. For example:
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = reject(new Error("2"));
    let promise3 = reject(new Error("3"));
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // Code here never runs because there are rejected promises!
    }, function(error) {
      // error.message === "2"
    });
    ```
  
    @method all
    @static
    @param {Array} entries array of promises
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise} promise that is fulfilled when all `promises` have been
    fulfilled, or rejected if any of them become rejected.
    @static
  */
  function all(entries) {
    return new Enumerator(this, entries).promise;
  }
  
  /**
    `Promise.race` returns a new promise which is settled in the same way as the
    first passed promise to settle.
  
    Example:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 2');
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // result === 'promise 2' because it was resolved before promise1
      // was resolved.
    });
    ```
  
    `Promise.race` is deterministic in that only the state of the first
    settled promise matters. For example, even if other promises given to the
    `promises` array argument are resolved, but the first settled promise has
    become rejected before the other promises became fulfilled, the returned
    promise will become rejected:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        reject(new Error('promise 2'));
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // Code here never runs
    }, function(reason){
      // reason.message === 'promise 2' because promise 2 became rejected before
      // promise 1 became fulfilled
    });
    ```
  
    An example real-world use case is implementing timeouts:
  
    ```javascript
    Promise.race([ajax('foo.json'), timeout(5000)])
    ```
  
    @method race
    @static
    @param {Array} promises array of promises to observe
    Useful for tooling.
    @return {Promise} a promise which settles in the same way as the first passed
    promise to settle.
  */
  function race(entries) {
    /*jshint validthis:true */
    var Constructor = this;
  
    if (!isArray(entries)) {
      return new Constructor(function (_, reject) {
        return reject(new TypeError('You must pass an array to race.'));
      });
    } else {
      return new Constructor(function (resolve, reject) {
        var length = entries.length;
        for (var i = 0; i < length; i++) {
          Constructor.resolve(entries[i]).then(resolve, reject);
        }
      });
    }
  }
  
  /**
    `Promise.reject` returns a promise rejected with the passed `reason`.
    It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      reject(new Error('WHOOPS'));
    });
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.reject(new Error('WHOOPS'));
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    @method reject
    @static
    @param {Any} reason value that the returned promise will be rejected with.
    Useful for tooling.
    @return {Promise} a promise rejected with the given `reason`.
  */
  function reject$1(reason) {
    /*jshint validthis:true */
    var Constructor = this;
    var promise = new Constructor(noop);
    reject(promise, reason);
    return promise;
  }
  
  function needsResolver() {
    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
  }
  
  function needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
  }
  
  /**
    Promise objects represent the eventual result of an asynchronous operation. The
    primary way of interacting with a promise is through its `then` method, which
    registers callbacks to receive either a promise's eventual value or the reason
    why the promise cannot be fulfilled.
  
    Terminology
    -----------
  
    - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
    - `thenable` is an object or function that defines a `then` method.
    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
    - `exception` is a value that is thrown using the throw statement.
    - `reason` is a value that indicates why a promise was rejected.
    - `settled` the final resting state of a promise, fulfilled or rejected.
  
    A promise can be in one of three states: pending, fulfilled, or rejected.
  
    Promises that are fulfilled have a fulfillment value and are in the fulfilled
    state.  Promises that are rejected have a rejection reason and are in the
    rejected state.  A fulfillment value is never a thenable.
  
    Promises can also be said to *resolve* a value.  If this value is also a
    promise, then the original promise's settled state will match the value's
    settled state.  So a promise that *resolves* a promise that rejects will
    itself reject, and a promise that *resolves* a promise that fulfills will
    itself fulfill.
  
  
    Basic Usage:
    ------------
  
    ```js
    let promise = new Promise(function(resolve, reject) {
      // on success
      resolve(value);
  
      // on failure
      reject(reason);
    });
  
    promise.then(function(value) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Advanced Usage:
    ---------------
  
    Promises shine when abstracting away asynchronous interactions such as
    `XMLHttpRequest`s.
  
    ```js
    function getJSON(url) {
      return new Promise(function(resolve, reject){
        let xhr = new XMLHttpRequest();
  
        xhr.open('GET', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'json';
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send();
  
        function handler() {
          if (this.readyState === this.DONE) {
            if (this.status === 200) {
              resolve(this.response);
            } else {
              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
            }
          }
        };
      });
    }
  
    getJSON('/posts.json').then(function(json) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Unlike callbacks, promises are great composable primitives.
  
    ```js
    Promise.all([
      getJSON('/posts'),
      getJSON('/comments')
    ]).then(function(values){
      values[0] // => postsJSON
      values[1] // => commentsJSON
  
      return values;
    });
    ```
  
    @class Promise
    @param {Function} resolver
    Useful for tooling.
    @constructor
  */
  
  var Promise$1 = function () {
    function Promise(resolver) {
      this[PROMISE_ID] = nextId();
      this._result = this._state = undefined;
      this._subscribers = [];
  
      if (noop !== resolver) {
        typeof resolver !== 'function' && needsResolver();
        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
      }
    }
  
    /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
     ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
     Chaining
    --------
     The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
     ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
     findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
     ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
     Assimilation
    ------------
     Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
     If the assimliated promise rejects, then the downstream promise will also reject.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
     Simple Example
    --------------
     Synchronous Example
     ```javascript
    let result;
     try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
     Advanced Example
    --------------
     Synchronous Example
     ```javascript
    let author, books;
     try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
     function foundBooks(books) {
     }
     function failure(reason) {
     }
     findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
     @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
    */
  
    /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
    ```js
    function findAuthor(){
    throw new Error('couldn't find that author');
    }
    // synchronous
    try {
    findAuthor();
    } catch(reason) {
    // something went wrong
    }
    // async with promises
    findAuthor().catch(function(reason){
    // something went wrong
    });
    ```
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
    */
  
  
    Promise.prototype.catch = function _catch(onRejection) {
      return this.then(null, onRejection);
    };
  
    /**
      `finally` will be invoked regardless of the promise's fate just as native
      try/catch/finally behaves
    
      Synchronous example:
    
      ```js
      findAuthor() {
        if (Math.random() > 0.5) {
          throw new Error();
        }
        return new Author();
      }
    
      try {
        return findAuthor(); // succeed or fail
      } catch(error) {
        return findOtherAuther();
      } finally {
        // always runs
        // doesn't affect the return value
      }
      ```
    
      Asynchronous example:
    
      ```js
      findAuthor().catch(function(reason){
        return findOtherAuther();
      }).finally(function(){
        // author was either found, or not
      });
      ```
    
      @method finally
      @param {Function} callback
      @return {Promise}
    */
  
  
    Promise.prototype.finally = function _finally(callback) {
      var promise = this;
      var constructor = promise.constructor;
  
      if (isFunction(callback)) {
        return promise.then(function (value) {
          return constructor.resolve(callback()).then(function () {
            return value;
          });
        }, function (reason) {
          return constructor.resolve(callback()).then(function () {
            throw reason;
          });
        });
      }
  
      return promise.then(callback, callback);
    };
  
    return Promise;
  }();
  
  Promise$1.prototype.then = then;
  Promise$1.all = all;
  Promise$1.race = race;
  Promise$1.resolve = resolve$1;
  Promise$1.reject = reject$1;
  Promise$1._setScheduler = setScheduler;
  Promise$1._setAsap = setAsap;
  Promise$1._asap = asap;
  
  /*global self*/
  function polyfill() {
    var local = void 0;
  
    if (typeof global !== 'undefined') {
      local = global;
    } else if (typeof self !== 'undefined') {
      local = self;
    } else {
      try {
        local = Function('return this')();
      } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
      }
    }
  
    var P = local.Promise;
  
    if (P) {
      var promiseToString = null;
      try {
        promiseToString = Object.prototype.toString.call(P.resolve());
      } catch (e) {
        // silently ignored
      }
  
      if (promiseToString === '[object Promise]' && !P.cast) {
        return;
      }
    }
  
    local.Promise = Promise$1;
  }
  
  // Strange compat..
  Promise$1.polyfill = polyfill;
  Promise$1.Promise = Promise$1;
  
  return Promise$1;
  
  })));
  
  
  
  
  
  }).call(this,_dereq_('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{"_process":500}],225:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./is-implemented")()
    ? _dereq_("ext/global-this").Symbol
    : _dereq_("./polyfill");
  
  },{"./is-implemented":226,"./polyfill":231,"ext/global-this":238}],226:[function(_dereq_,module,exports){
  "use strict";
  
  var global     = _dereq_("ext/global-this")
    , validTypes = { object: true, symbol: true };
  
  module.exports = function () {
    var Symbol = global.Symbol;
    var symbol;
    if (typeof Symbol !== "function") return false;
    symbol = Symbol("test symbol");
    try { String(symbol); }
    catch (e) { return false; }
  
    // Return 'true' also for polyfills
    if (!validTypes[typeof Symbol.iterator]) return false;
    if (!validTypes[typeof Symbol.toPrimitive]) return false;
    if (!validTypes[typeof Symbol.toStringTag]) return false;
  
    return true;
  };
  
  },{"ext/global-this":238}],227:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function (value) {
    if (!value) return false;
    if (typeof value === "symbol") return true;
    if (!value.constructor) return false;
    if (value.constructor.name !== "Symbol") return false;
    return value[value.constructor.toStringTag] === "Symbol";
  };
  
  },{}],228:[function(_dereq_,module,exports){
  "use strict";
  
  var d = _dereq_("d");
  
  var create = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;
  
  var created = create(null);
  module.exports = function (desc) {
    var postfix = 0, name, ie11BugWorkaround;
    while (created[desc + (postfix || "")]) ++postfix;
    desc += postfix || "";
    created[desc] = true;
    name = "@@" + desc;
    defineProperty(
      objPrototype,
      name,
      d.gs(null, function (value) {
        // For IE11 issue see:
        // https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
        //    ie11-broken-getters-on-dom-objects
        // https://github.com/medikoo/es6-symbol/issues/12
        if (ie11BugWorkaround) return;
        ie11BugWorkaround = true;
        defineProperty(this, name, d(value));
        ie11BugWorkaround = false;
      })
    );
    return name;
  };
  
  },{"d":155}],229:[function(_dereq_,module,exports){
  "use strict";
  
  var d            = _dereq_("d")
    , NativeSymbol = _dereq_("ext/global-this").Symbol;
  
  module.exports = function (SymbolPolyfill) {
    return Object.defineProperties(SymbolPolyfill, {
      // To ensure proper interoperability with other native functions (e.g. Array.from)
      // fallback to eventual native implementation of given symbol
      hasInstance: d(
        "", (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill("hasInstance")
      ),
      isConcatSpreadable: d(
        "",
        (NativeSymbol && NativeSymbol.isConcatSpreadable) ||
          SymbolPolyfill("isConcatSpreadable")
      ),
      iterator: d("", (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill("iterator")),
      match: d("", (NativeSymbol && NativeSymbol.match) || SymbolPolyfill("match")),
      replace: d("", (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill("replace")),
      search: d("", (NativeSymbol && NativeSymbol.search) || SymbolPolyfill("search")),
      species: d("", (NativeSymbol && NativeSymbol.species) || SymbolPolyfill("species")),
      split: d("", (NativeSymbol && NativeSymbol.split) || SymbolPolyfill("split")),
      toPrimitive: d(
        "", (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill("toPrimitive")
      ),
      toStringTag: d(
        "", (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill("toStringTag")
      ),
      unscopables: d(
        "", (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill("unscopables")
      )
    });
  };
  
  },{"d":155,"ext/global-this":238}],230:[function(_dereq_,module,exports){
  "use strict";
  
  var d              = _dereq_("d")
    , validateSymbol = _dereq_("../../../validate-symbol");
  
  var registry = Object.create(null);
  
  module.exports = function (SymbolPolyfill) {
    return Object.defineProperties(SymbolPolyfill, {
      for: d(function (key) {
        if (registry[key]) return registry[key];
        return (registry[key] = SymbolPolyfill(String(key)));
      }),
      keyFor: d(function (symbol) {
        var key;
        validateSymbol(symbol);
        for (key in registry) {
          if (registry[key] === symbol) return key;
        }
        return undefined;
      })
    });
  };
  
  },{"../../../validate-symbol":232,"d":155}],231:[function(_dereq_,module,exports){
  // ES2015 Symbol polyfill for environments that do not (or partially) support it
  
  "use strict";
  
  var d                    = _dereq_("d")
    , validateSymbol       = _dereq_("./validate-symbol")
    , NativeSymbol         = _dereq_("ext/global-this").Symbol
    , generateName         = _dereq_("./lib/private/generate-name")
    , setupStandardSymbols = _dereq_("./lib/private/setup/standard-symbols")
    , setupSymbolRegistry  = _dereq_("./lib/private/setup/symbol-registry");
  
  var create = Object.create
    , defineProperties = Object.defineProperties
    , defineProperty = Object.defineProperty;
  
  var SymbolPolyfill, HiddenSymbol, isNativeSafe;
  
  if (typeof NativeSymbol === "function") {
    try {
      String(NativeSymbol());
      isNativeSafe = true;
    } catch (ignore) {}
  } else {
    NativeSymbol = null;
  }
  
  // Internal constructor (not one exposed) for creating Symbol instances.
  // This one is used to ensure that `someSymbol instanceof Symbol` always return false
  HiddenSymbol = function Symbol(description) {
    if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
    return SymbolPolyfill(description);
  };
  
  // Exposed `Symbol` constructor
  // (returns instances of HiddenSymbol)
  module.exports = SymbolPolyfill = function Symbol(description) {
    var symbol;
    if (this instanceof Symbol) throw new TypeError("Symbol is not a constructor");
    if (isNativeSafe) return NativeSymbol(description);
    symbol = create(HiddenSymbol.prototype);
    description = description === undefined ? "" : String(description);
    return defineProperties(symbol, {
      __description__: d("", description),
      __name__: d("", generateName(description))
    });
  };
  
  setupStandardSymbols(SymbolPolyfill);
  setupSymbolRegistry(SymbolPolyfill);
  
  // Internal tweaks for real symbol producer
  defineProperties(HiddenSymbol.prototype, {
    constructor: d(SymbolPolyfill),
    toString: d("", function () { return this.__name__; })
  });
  
  // Proper implementation of methods exposed on Symbol.prototype
  // They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
  defineProperties(SymbolPolyfill.prototype, {
    toString: d(function () { return "Symbol (" + validateSymbol(this).__description__ + ")"; }),
    valueOf: d(function () { return validateSymbol(this); })
  });
  defineProperty(
    SymbolPolyfill.prototype,
    SymbolPolyfill.toPrimitive,
    d("", function () {
      var symbol = validateSymbol(this);
      if (typeof symbol === "symbol") return symbol;
      return symbol.toString();
    })
  );
  defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d("c", "Symbol"));
  
  // Proper implementaton of toPrimitive and toStringTag for returned symbol instances
  defineProperty(
    HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
    d("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag])
  );
  
  // Note: It's important to define `toPrimitive` as last one, as some implementations
  // implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
  // And that may invoke error in definition flow:
  // See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
  defineProperty(
    HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
    d("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive])
  );
  
  },{"./lib/private/generate-name":228,"./lib/private/setup/standard-symbols":229,"./lib/private/setup/symbol-registry":230,"./validate-symbol":232,"d":155,"ext/global-this":238}],232:[function(_dereq_,module,exports){
  "use strict";
  
  var isSymbol = _dereq_("./is-symbol");
  
  module.exports = function (value) {
    if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
    return value;
  };
  
  },{"./is-symbol":227}],233:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./is-implemented")() ? WeakMap : _dereq_("./polyfill");
  
  },{"./is-implemented":234,"./polyfill":236}],234:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function () {
    var weakMap, obj;
  
    if (typeof WeakMap !== "function") return false;
    try {
      // WebKit doesn't support arguments and crashes
      weakMap = new WeakMap([[obj = {}, "one"], [{}, "two"], [{}, "three"]]);
    } catch (e) {
      return false;
    }
    if (String(weakMap) !== "[object WeakMap]") return false;
    if (typeof weakMap.set !== "function") return false;
    if (weakMap.set({}, 1) !== weakMap) return false;
    if (typeof weakMap.delete !== "function") return false;
    if (typeof weakMap.has !== "function") return false;
    if (weakMap.get(obj) !== "one") return false;
  
    return true;
  };
  
  },{}],235:[function(_dereq_,module,exports){
  // Exports true if environment provides native `WeakMap` implementation, whatever that is.
  
  "use strict";
  
  module.exports = (function () {
    if (typeof WeakMap !== "function") return false;
    return Object.prototype.toString.call(new WeakMap()) === "[object WeakMap]";
  }());
  
  },{}],236:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue           = _dereq_("es5-ext/object/is-value")
    , setPrototypeOf    = _dereq_("es5-ext/object/set-prototype-of")
    , object            = _dereq_("es5-ext/object/valid-object")
    , ensureValue       = _dereq_("es5-ext/object/valid-value")
    , randomUniq        = _dereq_("es5-ext/string/random-uniq")
    , d                 = _dereq_("d")
    , getIterator       = _dereq_("es6-iterator/get")
    , forOf             = _dereq_("es6-iterator/for-of")
    , toStringTagSymbol = _dereq_("es6-symbol").toStringTag
    , isNative          = _dereq_("./is-native-implemented")
  
    , isArray = Array.isArray, defineProperty = Object.defineProperty
    , objHasOwnProperty = Object.prototype.hasOwnProperty, getPrototypeOf = Object.getPrototypeOf
    , WeakMapPoly;
  
  module.exports = WeakMapPoly = function (/* Iterable*/) {
    var iterable = arguments[0], self;
  
    if (!(this instanceof WeakMapPoly)) throw new TypeError("Constructor requires 'new'");
    self = isNative && setPrototypeOf && (WeakMap !== WeakMapPoly)
      ? setPrototypeOf(new WeakMap(), getPrototypeOf(this)) : this;
  
    if (isValue(iterable)) {
      if (!isArray(iterable)) iterable = getIterator(iterable);
    }
    defineProperty(self, "__weakMapData__", d("c", "$weakMap$" + randomUniq()));
    if (!iterable) return self;
    forOf(iterable, function (val) {
      ensureValue(val);
      self.set(val[0], val[1]);
    });
    return self;
  };
  
  if (isNative) {
    if (setPrototypeOf) setPrototypeOf(WeakMapPoly, WeakMap);
    WeakMapPoly.prototype = Object.create(WeakMap.prototype, { constructor: d(WeakMapPoly) });
  }
  
  Object.defineProperties(WeakMapPoly.prototype, {
    delete: d(function (key) {
      if (objHasOwnProperty.call(object(key), this.__weakMapData__)) {
        delete key[this.__weakMapData__];
        return true;
      }
      return false;
    }),
    get: d(function (key) {
      if (!objHasOwnProperty.call(object(key), this.__weakMapData__)) return undefined;
      return key[this.__weakMapData__];
    }),
    has: d(function (key) {
      return objHasOwnProperty.call(object(key), this.__weakMapData__);
    }),
    set: d(function (key, value) {
      defineProperty(object(key), this.__weakMapData__, d("c", value));
      return this;
    }),
    toString: d(function () {
      return "[object WeakMap]";
    })
  });
  defineProperty(WeakMapPoly.prototype, toStringTagSymbol, d("c", "WeakMap"));
  
  },{"./is-native-implemented":235,"d":155,"es5-ext/object/is-value":200,"es5-ext/object/set-prototype-of":206,"es5-ext/object/valid-object":210,"es5-ext/object/valid-value":211,"es5-ext/string/random-uniq":216,"es6-iterator/for-of":218,"es6-iterator/get":219,"es6-symbol":225}],237:[function(_dereq_,module,exports){
  var naiveFallback = function () {
    if (typeof self === "object" && self) return self;
    if (typeof window === "object" && window) return window;
    throw new Error("Unable to resolve global `this`");
  };
  
  module.exports = (function () {
    if (this) return this;
  
    // Unexpected strict mode (may happen if e.g. bundled into ESM module)
  
    // Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
    // In all ES5+ engines global object inherits from Object.prototype
    // (if you approached one that doesn't please report)
    try {
      Object.defineProperty(Object.prototype, "__global__", {
        get: function () { return this; },
        configurable: true
      });
    } catch (error) {
      // Unfortunate case of Object.prototype being sealed (via preventExtensions, seal or freeze)
      return naiveFallback();
    }
    try {
      // Safari case (window.__global__ is resolved with global context, but __global__ does not)
      if (!__global__) return naiveFallback();
      return __global__;
    } finally {
      delete Object.prototype.__global__;
    }
  })();
  
  },{}],238:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = _dereq_("./is-implemented")() ? globalThis : _dereq_("./implementation");
  
  },{"./implementation":237,"./is-implemented":239}],239:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function () {
    if (typeof globalThis !== "object") return false;
    if (!globalThis) return false;
    return globalThis.Array === Array;
  };
  
  },{}],240:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = extractPlanes
  
  function extractPlanes(M, zNear, zFar) {
    var z  = zNear || 0.0
    var zf = zFar || 1.0
    return [
      [ M[12] + M[0], M[13] + M[1], M[14] + M[2], M[15] + M[3] ],
      [ M[12] - M[0], M[13] - M[1], M[14] - M[2], M[15] - M[3] ],
      [ M[12] + M[4], M[13] + M[5], M[14] + M[6], M[15] + M[7] ],
      [ M[12] - M[4], M[13] - M[5], M[14] - M[6], M[15] - M[7] ],
      [ z*M[12] + M[8], z*M[13] + M[9], z*M[14] + M[10], z*M[15] + M[11] ],
      [ zf*M[12] - M[8], zf*M[13] - M[9], zf*M[14] - M[10], zf*M[15] - M[11] ]
    ]
  }
  },{}],241:[function(_dereq_,module,exports){
  /**
   * inspired by is-number <https://github.com/jonschlinkert/is-number>
   * but significantly simplified and sped up by ignoring number and string constructors
   * ie these return false:
   *   new Number(1)
   *   new String('1')
   */
  
  'use strict';
  
  var allBlankCharCodes = _dereq_('is-string-blank');
  
  module.exports = function(n) {
      var type = typeof n;
      if(type === 'string') {
          var original = n;
          n = +n;
          // whitespace strings cast to zero - filter them out
          if(n===0 && allBlankCharCodes(original)) return false;
      }
      else if(type !== 'number') return false;
  
      return n - n < 1;
  };
  
  },{"is-string-blank":444}],242:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createFilteredVector
  
  var cubicHermite = _dereq_('cubic-hermite')
  var bsearch = _dereq_('binary-search-bounds')
  
  function clamp(lo, hi, x) {
    return Math.min(hi, Math.max(lo, x))
  }
  
  function FilteredVector(state0, velocity0, t0) {
    this.dimension  = state0.length
    this.bounds     = [ new Array(this.dimension), new Array(this.dimension) ]
    for(var i=0; i<this.dimension; ++i) {
      this.bounds[0][i] = -Infinity
      this.bounds[1][i] = Infinity
    }
    this._state     = state0.slice().reverse()
    this._velocity  = velocity0.slice().reverse()
    this._time      = [ t0 ]
    this._scratch   = [ state0.slice(), state0.slice(), state0.slice(), state0.slice(), state0.slice() ]
  }
  
  var proto = FilteredVector.prototype
  
  proto.flush = function(t) {
    var idx = bsearch.gt(this._time, t) - 1
    if(idx <= 0) {
      return
    }
    this._time.splice(0, idx)
    this._state.splice(0, idx * this.dimension)
    this._velocity.splice(0, idx * this.dimension)
  }
  
  proto.curve = function(t) {
    var time      = this._time
    var n         = time.length
    var idx       = bsearch.le(time, t)
    var result    = this._scratch[0]
    var state     = this._state
    var velocity  = this._velocity
    var d         = this.dimension
    var bounds    = this.bounds
    if(idx < 0) {
      var ptr = d-1
      for(var i=0; i<d; ++i, --ptr) {
        result[i] = state[ptr]
      }
    } else if(idx >= n-1) {
      var ptr = state.length-1
      var tf = t - time[n-1]
      for(var i=0; i<d; ++i, --ptr) {
        result[i] = state[ptr] + tf * velocity[ptr]
      }
    } else {
      var ptr = d * (idx+1) - 1
      var t0  = time[idx]
      var t1  = time[idx+1]
      var dt  = (t1 - t0) || 1.0
      var x0  = this._scratch[1]
      var x1  = this._scratch[2]
      var v0  = this._scratch[3]
      var v1  = this._scratch[4]
      var steady = true
      for(var i=0; i<d; ++i, --ptr) {
        x0[i] = state[ptr]
        v0[i] = velocity[ptr] * dt
        x1[i] = state[ptr+d]
        v1[i] = velocity[ptr+d] * dt
        steady = steady && (x0[i] === x1[i] && v0[i] === v1[i] && v0[i] === 0.0)
      }
      if(steady) {
        for(var i=0; i<d; ++i) {
          result[i] = x0[i]
        }
      } else {
        cubicHermite(x0, v0, x1, v1, (t-t0)/dt, result)
      }
    }
    var lo = bounds[0]
    var hi = bounds[1]
    for(var i=0; i<d; ++i) {
      result[i] = clamp(lo[i], hi[i], result[i])
    }
    return result
  }
  
  proto.dcurve = function(t) {
    var time     = this._time
    var n        = time.length
    var idx      = bsearch.le(time, t)
    var result   = this._scratch[0]
    var state    = this._state
    var velocity = this._velocity
    var d        = this.dimension
    if(idx >= n-1) {
      var ptr = state.length-1
      var tf = t - time[n-1]
      for(var i=0; i<d; ++i, --ptr) {
        result[i] = velocity[ptr]
      }
    } else {
      var ptr = d * (idx+1) - 1
      var t0 = time[idx]
      var t1 = time[idx+1]
      var dt = (t1 - t0) || 1.0
      var x0 = this._scratch[1]
      var x1 = this._scratch[2]
      var v0 = this._scratch[3]
      var v1 = this._scratch[4]
      var steady = true
      for(var i=0; i<d; ++i, --ptr) {
        x0[i] = state[ptr]
        v0[i] = velocity[ptr] * dt
        x1[i] = state[ptr+d]
        v1[i] = velocity[ptr+d] * dt
        steady = steady && (x0[i] === x1[i] && v0[i] === v1[i] && v0[i] === 0.0)
      }
      if(steady) {
        for(var i=0; i<d; ++i) {
          result[i] = 0.0
        }
      } else {
        cubicHermite.derivative(x0, v0, x1, v1, (t-t0)/dt, result)
        for(var i=0; i<d; ++i) {
          result[i] /= dt
        }
      }
    }
    return result
  }
  
  proto.lastT = function() {
    var time = this._time
    return time[time.length-1]
  }
  
  proto.stable = function() {
    var velocity = this._velocity
    var ptr = velocity.length
    for(var i=this.dimension-1; i>=0; --i) {
      if(velocity[--ptr]) {
        return false
      }
    }
    return true
  }
  
  proto.jump = function(t) {
    var t0 = this.lastT()
    var d  = this.dimension
    if(t < t0 || arguments.length !== d+1) {
      return
    }
    var state     = this._state
    var velocity  = this._velocity
    var ptr       = state.length-this.dimension
    var bounds    = this.bounds
    var lo        = bounds[0]
    var hi        = bounds[1]
    this._time.push(t0, t)
    for(var j=0; j<2; ++j) {
      for(var i=0; i<d; ++i) {
        state.push(state[ptr++])
        velocity.push(0)
      }
    }
    this._time.push(t)
    for(var i=d; i>0; --i) {
      state.push(clamp(lo[i-1], hi[i-1], arguments[i]))
      velocity.push(0)
    }
  }
  
  proto.push = function(t) {
    var t0 = this.lastT()
    var d  = this.dimension
    if(t < t0 || arguments.length !== d+1) {
      return
    }
    var state     = this._state
    var velocity  = this._velocity
    var ptr       = state.length-this.dimension
    var dt        = t - t0
    var bounds    = this.bounds
    var lo        = bounds[0]
    var hi        = bounds[1]
    var sf        = (dt > 1e-6) ? 1/dt : 0
    this._time.push(t)
    for(var i=d; i>0; --i) {
      var xc = clamp(lo[i-1], hi[i-1], arguments[i])
      state.push(xc)
      velocity.push((xc - state[ptr++]) * sf)
    }
  }
  
  proto.set = function(t) {
    var d = this.dimension
    if(t < this.lastT() || arguments.length !== d+1) {
      return
    }
    var state     = this._state
    var velocity  = this._velocity
    var bounds    = this.bounds
    var lo        = bounds[0]
    var hi        = bounds[1]
    this._time.push(t)
    for(var i=d; i>0; --i) {
      state.push(clamp(lo[i-1], hi[i-1], arguments[i]))
      velocity.push(0)
    }
  }
  
  proto.move = function(t) {
    var t0 = this.lastT()
    var d  = this.dimension
    if(t <= t0 || arguments.length !== d+1) {
      return
    }
    var state    = this._state
    var velocity = this._velocity
    var statePtr = state.length - this.dimension
    var bounds   = this.bounds
    var lo       = bounds[0]
    var hi       = bounds[1]
    var dt       = t - t0
    var sf       = (dt > 1e-6) ? 1/dt : 0.0
    this._time.push(t)
    for(var i=d; i>0; --i) {
      var dx = arguments[i]
      state.push(clamp(lo[i-1], hi[i-1], state[statePtr++] + dx))
      velocity.push(dx * sf)
    }
  }
  
  proto.idle = function(t) {
    var t0 = this.lastT()
    if(t < t0) {
      return
    }
    var d        = this.dimension
    var state    = this._state
    var velocity = this._velocity
    var statePtr = state.length-d
    var bounds   = this.bounds
    var lo       = bounds[0]
    var hi       = bounds[1]
    var dt       = t - t0
    this._time.push(t)
    for(var i=d-1; i>=0; --i) {
      state.push(clamp(lo[i], hi[i], state[statePtr] + dt * velocity[statePtr]))
      velocity.push(0)
      statePtr += 1
    }
  }
  
  function getZero(d) {
    var result = new Array(d)
    for(var i=0; i<d; ++i) {
      result[i] = 0.0
    }
    return result
  }
  
  function createFilteredVector(initState, initVelocity, initTime) {
    switch(arguments.length) {
      case 0:
        return new FilteredVector([0], [0], 0)
      case 1:
        if(typeof initState === 'number') {
          var zero = getZero(initState)
          return new FilteredVector(zero, zero, 0)
        } else {
          return new FilteredVector(initState, getZero(initState.length), 0)
        }
      case 2:
        if(typeof initVelocity === 'number') {
          var zero = getZero(initState.length)
          return new FilteredVector(initState, zero, +initVelocity)
        } else {
          initTime = 0
        }
      case 3:
        if(initState.length !== initVelocity.length) {
          throw new Error('state and velocity lengths must match')
        }
        return new FilteredVector(initState, initVelocity, initTime)
    }
  }
  
  },{"binary-search-bounds":243,"cubic-hermite":150}],243:[function(_dereq_,module,exports){
  "use strict"
  
  function compileSearch(funcName, predicate, reversed, extraArgs, useNdarray, earlyOut) {
    var code = [
      "function ", funcName, "(a,l,h,", extraArgs.join(","),  "){",
  earlyOut ? "" : "var i=", (reversed ? "l-1" : "h+1"),
  ";while(l<=h){\
  var m=(l+h)>>>1,x=a", useNdarray ? ".get(m)" : "[m]"]
    if(earlyOut) {
      if(predicate.indexOf("c") < 0) {
        code.push(";if(x===y){return m}else if(x<=y){")
      } else {
        code.push(";var p=c(x,y);if(p===0){return m}else if(p<=0){")
      }
    } else {
      code.push(";if(", predicate, "){i=m;")
    }
    if(reversed) {
      code.push("l=m+1}else{h=m-1}")
    } else {
      code.push("h=m-1}else{l=m+1}")
    }
    code.push("}")
    if(earlyOut) {
      code.push("return -1};")
    } else {
      code.push("return i};")
    }
    return code.join("")
  }
  
  function compileBoundsSearch(predicate, reversed, suffix, earlyOut) {
    var result = new Function([
    compileSearch("A", "x" + predicate + "y", reversed, ["y"], false, earlyOut),
    compileSearch("B", "x" + predicate + "y", reversed, ["y"], true, earlyOut),
    compileSearch("P", "c(x,y)" + predicate + "0", reversed, ["y", "c"], false, earlyOut),
    compileSearch("Q", "c(x,y)" + predicate + "0", reversed, ["y", "c"], true, earlyOut),
  "function dispatchBsearch", suffix, "(a,y,c,l,h){\
  if(a.shape){\
  if(typeof(c)==='function'){\
  return Q(a,(l===undefined)?0:l|0,(h===undefined)?a.shape[0]-1:h|0,y,c)\
  }else{\
  return B(a,(c===undefined)?0:c|0,(l===undefined)?a.shape[0]-1:l|0,y)\
  }}else{\
  if(typeof(c)==='function'){\
  return P(a,(l===undefined)?0:l|0,(h===undefined)?a.length-1:h|0,y,c)\
  }else{\
  return A(a,(c===undefined)?0:c|0,(l===undefined)?a.length-1:l|0,y)\
  }}}\
  return dispatchBsearch", suffix].join(""))
    return result()
  }
  
  module.exports = {
    ge: compileBoundsSearch(">=", false, "GE"),
    gt: compileBoundsSearch(">", false, "GT"),
    lt: compileBoundsSearch("<", true, "LT"),
    le: compileBoundsSearch("<=", true, "LE"),
    eq: compileBoundsSearch("-", true, "EQ", true)
  }
  
  },{}],244:[function(_dereq_,module,exports){
  /*eslint new-cap:0*/
  var dtype = _dereq_('dtype')
  
  module.exports = flattenVertexData
  
  function flattenVertexData (data, output, offset) {
    if (!data) throw new TypeError('must specify data as first parameter')
    offset = +(offset || 0) | 0
  
    if (Array.isArray(data) && (data[0] && typeof data[0][0] === 'number')) {
      var dim = data[0].length
      var length = data.length * dim
      var i, j, k, l
  
      // no output specified, create a new typed array
      if (!output || typeof output === 'string') {
        output = new (dtype(output || 'float32'))(length + offset)
      }
  
      var dstLength = output.length - offset
      if (length !== dstLength) {
        throw new Error('source length ' + length + ' (' + dim + 'x' + data.length + ')' +
          ' does not match destination length ' + dstLength)
      }
  
      for (i = 0, k = offset; i < data.length; i++) {
        for (j = 0; j < dim; j++) {
          output[k++] = data[i][j] === null ? NaN : data[i][j]
        }
      }
    } else {
      if (!output || typeof output === 'string') {
        // no output, create a new one
        var Ctor = dtype(output || 'float32')
  
        // handle arrays separately due to possible nulls
        if (Array.isArray(data) || output === 'array') {
          output = new Ctor(data.length + offset)
          for (i = 0, k = offset, l = output.length; k < l; k++, i++) {
            output[k] = data[i] === null ? NaN : data[i]
          }
        } else {
          if (offset === 0) {
            output = new Ctor(data)
          } else {
            output = new Ctor(data.length + offset)
  
            output.set(data, offset)
          }
        }
      } else {
        // store output in existing array
        output.set(data, offset)
      }
    }
  
    return output
  }
  
  },{"dtype":175}],245:[function(_dereq_,module,exports){
  'use strict'
  
  var stringifyFont = _dereq_('css-font/stringify')
  var defaultChars = [32, 126]
  
  module.exports = atlas
  
  function atlas(options) {
    options = options || {}
  
    var shape  = options.shape ? options.shape : options.canvas ? [options.canvas.width, options.canvas.height] : [512, 512]
    var canvas = options.canvas || document.createElement('canvas')
    var font   = options.font
    var step   = typeof options.step === 'number' ? [options.step, options.step] : options.step || [32, 32]
    var chars  = options.chars || defaultChars
  
    if (font && typeof font !== 'string') font = stringifyFont(font)
  
    if (!Array.isArray(chars)) {
      chars = String(chars).split('')
    } else
    if (chars.length === 2
      && typeof chars[0] === 'number'
      && typeof chars[1] === 'number'
    ) {
      var newchars = []
  
      for (var i = chars[0], j = 0; i <= chars[1]; i++) {
        newchars[j++] = String.fromCharCode(i)
      }
  
      chars = newchars
    }
  
    shape = shape.slice()
    canvas.width  = shape[0]
    canvas.height = shape[1]
  
    var ctx = canvas.getContext('2d')
  
    ctx.fillStyle = '#000'
    ctx.fillRect(0, 0, canvas.width, canvas.height)
  
    ctx.font = font
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'
    ctx.fillStyle = '#fff'
  
    var x = step[0] / 2
    var y = step[1] / 2
    for (var i = 0; i < chars.length; i++) {
      ctx.fillText(chars[i], x, y)
      if ((x += step[0]) > shape[0] - step[0]/2) (x = step[0]/2), (y += step[1])
    }
  
    return canvas
  }
  
  },{"css-font/stringify":147}],246:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = measure
  
  measure.canvas = document.createElement('canvas')
  measure.cache = {}
  
  function measure (font, o) {
    if (!o) o = {}
  
    if (typeof font === 'string' || Array.isArray(font)) {
      o.family = font
    }
  
    var family = Array.isArray(o.family) ? o.family.join(', ') : o.family
    if (!family) throw Error('`family` must be defined')
  
    var fs = o.size || o.fontSize || o.em || 48
    var weight = o.weight || o.fontWeight || ''
    var style = o.style || o.fontStyle || ''
    var font = [style, weight, fs].join(' ') + 'px ' + family
    var origin = o.origin || 'top'
  
    if (measure.cache[family]) {
      // return more precise values if cache has them
      if (fs <= measure.cache[family].em) {
        return applyOrigin(measure.cache[family], origin)
      }
    }
  
    var canvas = o.canvas || measure.canvas
    var ctx = canvas.getContext('2d')
    var chars = {
      upper: o.upper !== undefined ? o.upper : 'H',
      lower: o.lower !== undefined ? o.lower : 'x',
      descent: o.descent !== undefined ? o.descent : 'p',
      ascent: o.ascent !== undefined ? o.ascent : 'h',
      tittle: o.tittle !== undefined ? o.tittle : 'i',
      overshoot: o.overshoot !== undefined ? o.overshoot : 'O'
    }
    var l = Math.ceil(fs * 1.5)
    canvas.height = l
    canvas.width = l * .5
    ctx.font = font
  
    var char = 'H'
    var result = {
      top: 0
    }
  
    // measure line-height
    ctx.clearRect(0, 0, l, l)
    ctx.textBaseline = 'top'
    ctx.fillStyle = 'black'
    ctx.fillText(char, 0, 0)
    var topPx = firstTop(ctx.getImageData(0, 0, l, l))
    ctx.clearRect(0, 0, l, l)
    ctx.textBaseline = 'bottom'
    ctx.fillText(char, 0, l)
    var bottomPx = firstTop(ctx.getImageData(0, 0, l, l))
    result.lineHeight =
    result.bottom = l - bottomPx + topPx
  
    // measure baseline
    ctx.clearRect(0, 0, l, l)
    ctx.textBaseline = 'alphabetic'
    ctx.fillText(char, 0, l)
    var baselinePx = firstTop(ctx.getImageData(0, 0, l, l))
    var baseline = l - baselinePx - 1 + topPx
    result.baseline =
    result.alphabetic = baseline
  
    // measure median
    ctx.clearRect(0, 0, l, l)
    ctx.textBaseline = 'middle'
    ctx.fillText(char, 0, l * .5)
    var medianPx = firstTop(ctx.getImageData(0, 0, l, l))
    result.median =
    result.middle = l - medianPx - 1 + topPx - l * .5
  
    // measure hanging
    ctx.clearRect(0, 0, l, l)
    ctx.textBaseline = 'hanging'
    ctx.fillText(char, 0, l * .5)
    var hangingPx = firstTop(ctx.getImageData(0, 0, l, l))
    result.hanging = l - hangingPx - 1 + topPx - l * .5
  
    // measure ideographic
    ctx.clearRect(0, 0, l, l)
    ctx.textBaseline = 'ideographic'
    ctx.fillText(char, 0, l)
    var ideographicPx = firstTop(ctx.getImageData(0, 0, l, l))
    result.ideographic = l - ideographicPx - 1 + topPx
  
    // measure cap
    if (chars.upper) {
      ctx.clearRect(0, 0, l, l)
      ctx.textBaseline = 'top'
      ctx.fillText(chars.upper, 0, 0)
      result.upper = firstTop(ctx.getImageData(0, 0, l, l))
      result.capHeight = (result.baseline - result.upper)
    }
  
    // measure x
    if (chars.lower) {
      ctx.clearRect(0, 0, l, l)
      ctx.textBaseline = 'top'
      ctx.fillText(chars.lower, 0, 0)
      result.lower = firstTop(ctx.getImageData(0, 0, l, l))
      result.xHeight = (result.baseline - result.lower)
    }
  
    // measure tittle
    if (chars.tittle) {
      ctx.clearRect(0, 0, l, l)
      ctx.textBaseline = 'top'
      ctx.fillText(chars.tittle, 0, 0)
      result.tittle = firstTop(ctx.getImageData(0, 0, l, l))
    }
  
    // measure ascent
    if (chars.ascent) {
      ctx.clearRect(0, 0, l, l)
      ctx.textBaseline = 'top'
      ctx.fillText(chars.ascent, 0, 0)
      result.ascent = firstTop(ctx.getImageData(0, 0, l, l))
    }
  
    // measure descent
    if (chars.descent) {
      ctx.clearRect(0, 0, l, l)
      ctx.textBaseline = 'top'
      ctx.fillText(chars.descent, 0, 0)
      result.descent = firstBottom(ctx.getImageData(0, 0, l, l))
    }
  
    // measure overshoot
    if (chars.overshoot) {
      ctx.clearRect(0, 0, l, l)
      ctx.textBaseline = 'top'
      ctx.fillText(chars.overshoot, 0, 0)
      var overshootPx = firstBottom(ctx.getImageData(0, 0, l, l))
      result.overshoot = overshootPx - baseline
    }
  
    // normalize result
    for (var name in result) {
      result[name] /= fs
    }
  
    result.em = fs
    measure.cache[family] = result
  
    return applyOrigin(result, origin)
  }
  
  function applyOrigin(obj, origin) {
    var res = {}
    if (typeof origin === 'string') origin = obj[origin]
    for (var name in obj) {
      if (name === 'em') continue
      res[name] = obj[name] - origin
    }
    return res
  }
  
  function firstTop(iData) {
    var l = iData.height
    var data = iData.data
    for (var i = 3; i < data.length; i+=4) {
      if (data[i] !== 0) {
        return Math.floor((i - 3) *.25 / l)
      }
    }
  }
  
  function firstBottom(iData) {
    var l = iData.height
    var data = iData.data
    for (var i = data.length - 1; i > 0; i -= 4) {
      if (data[i] !== 0) {
        return Math.floor((i - 3) *.25 / l)
      }
    }
  }
  
  },{}],247:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = createRBTree
  
  var RED   = 0
  var BLACK = 1
  
  function RBNode(color, key, value, left, right, count) {
    this._color = color
    this.key = key
    this.value = value
    this.left = left
    this.right = right
    this._count = count
  }
  
  function cloneNode(node) {
    return new RBNode(node._color, node.key, node.value, node.left, node.right, node._count)
  }
  
  function repaint(color, node) {
    return new RBNode(color, node.key, node.value, node.left, node.right, node._count)
  }
  
  function recount(node) {
    node._count = 1 + (node.left ? node.left._count : 0) + (node.right ? node.right._count : 0)
  }
  
  function RedBlackTree(compare, root) {
    this._compare = compare
    this.root = root
  }
  
  var proto = RedBlackTree.prototype
  
  Object.defineProperty(proto, "keys", {
    get: function() {
      var result = []
      this.forEach(function(k,v) {
        result.push(k)
      })
      return result
    }
  })
  
  Object.defineProperty(proto, "values", {
    get: function() {
      var result = []
      this.forEach(function(k,v) {
        result.push(v)
      })
      return result
    }
  })
  
  //Returns the number of nodes in the tree
  Object.defineProperty(proto, "length", {
    get: function() {
      if(this.root) {
        return this.root._count
      }
      return 0
    }
  })
  
  //Insert a new item into the tree
  proto.insert = function(key, value) {
    var cmp = this._compare
    //Find point to insert new node at
    var n = this.root
    var n_stack = []
    var d_stack = []
    while(n) {
      var d = cmp(key, n.key)
      n_stack.push(n)
      d_stack.push(d)
      if(d <= 0) {
        n = n.left
      } else {
        n = n.right
      }
    }
    //Rebuild path to leaf node
    n_stack.push(new RBNode(RED, key, value, null, null, 1))
    for(var s=n_stack.length-2; s>=0; --s) {
      var n = n_stack[s]
      if(d_stack[s] <= 0) {
        n_stack[s] = new RBNode(n._color, n.key, n.value, n_stack[s+1], n.right, n._count+1)
      } else {
        n_stack[s] = new RBNode(n._color, n.key, n.value, n.left, n_stack[s+1], n._count+1)
      }
    }
    //Rebalance tree using rotations
    //console.log("start insert", key, d_stack)
    for(var s=n_stack.length-1; s>1; --s) {
      var p = n_stack[s-1]
      var n = n_stack[s]
      if(p._color === BLACK || n._color === BLACK) {
        break
      }
      var pp = n_stack[s-2]
      if(pp.left === p) {
        if(p.left === n) {
          var y = pp.right
          if(y && y._color === RED) {
            //console.log("LLr")
            p._color = BLACK
            pp.right = repaint(BLACK, y)
            pp._color = RED
            s -= 1
          } else {
            //console.log("LLb")
            pp._color = RED
            pp.left = p.right
            p._color = BLACK
            p.right = pp
            n_stack[s-2] = p
            n_stack[s-1] = n
            recount(pp)
            recount(p)
            if(s >= 3) {
              var ppp = n_stack[s-3]
              if(ppp.left === pp) {
                ppp.left = p
              } else {
                ppp.right = p
              }
            }
            break
          }
        } else {
          var y = pp.right
          if(y && y._color === RED) {
            //console.log("LRr")
            p._color = BLACK
            pp.right = repaint(BLACK, y)
            pp._color = RED
            s -= 1
          } else {
            //console.log("LRb")
            p.right = n.left
            pp._color = RED
            pp.left = n.right
            n._color = BLACK
            n.left = p
            n.right = pp
            n_stack[s-2] = n
            n_stack[s-1] = p
            recount(pp)
            recount(p)
            recount(n)
            if(s >= 3) {
              var ppp = n_stack[s-3]
              if(ppp.left === pp) {
                ppp.left = n
              } else {
                ppp.right = n
              }
            }
            break
          }
        }
      } else {
        if(p.right === n) {
          var y = pp.left
          if(y && y._color === RED) {
            //console.log("RRr", y.key)
            p._color = BLACK
            pp.left = repaint(BLACK, y)
            pp._color = RED
            s -= 1
          } else {
            //console.log("RRb")
            pp._color = RED
            pp.right = p.left
            p._color = BLACK
            p.left = pp
            n_stack[s-2] = p
            n_stack[s-1] = n
            recount(pp)
            recount(p)
            if(s >= 3) {
              var ppp = n_stack[s-3]
              if(ppp.right === pp) {
                ppp.right = p
              } else {
                ppp.left = p
              }
            }
            break
          }
        } else {
          var y = pp.left
          if(y && y._color === RED) {
            //console.log("RLr")
            p._color = BLACK
            pp.left = repaint(BLACK, y)
            pp._color = RED
            s -= 1
          } else {
            //console.log("RLb")
            p.left = n.right
            pp._color = RED
            pp.right = n.left
            n._color = BLACK
            n.right = p
            n.left = pp
            n_stack[s-2] = n
            n_stack[s-1] = p
            recount(pp)
            recount(p)
            recount(n)
            if(s >= 3) {
              var ppp = n_stack[s-3]
              if(ppp.right === pp) {
                ppp.right = n
              } else {
                ppp.left = n
              }
            }
            break
          }
        }
      }
    }
    //Return new tree
    n_stack[0]._color = BLACK
    return new RedBlackTree(cmp, n_stack[0])
  }
  
  
  //Visit all nodes inorder
  function doVisitFull(visit, node) {
    if(node.left) {
      var v = doVisitFull(visit, node.left)
      if(v) { return v }
    }
    var v = visit(node.key, node.value)
    if(v) { return v }
    if(node.right) {
      return doVisitFull(visit, node.right)
    }
  }
  
  //Visit half nodes in order
  function doVisitHalf(lo, compare, visit, node) {
    var l = compare(lo, node.key)
    if(l <= 0) {
      if(node.left) {
        var v = doVisitHalf(lo, compare, visit, node.left)
        if(v) { return v }
      }
      var v = visit(node.key, node.value)
      if(v) { return v }
    }
    if(node.right) {
      return doVisitHalf(lo, compare, visit, node.right)
    }
  }
  
  //Visit all nodes within a range
  function doVisit(lo, hi, compare, visit, node) {
    var l = compare(lo, node.key)
    var h = compare(hi, node.key)
    var v
    if(l <= 0) {
      if(node.left) {
        v = doVisit(lo, hi, compare, visit, node.left)
        if(v) { return v }
      }
      if(h > 0) {
        v = visit(node.key, node.value)
        if(v) { return v }
      }
    }
    if(h > 0 && node.right) {
      return doVisit(lo, hi, compare, visit, node.right)
    }
  }
  
  
  proto.forEach = function rbTreeForEach(visit, lo, hi) {
    if(!this.root) {
      return
    }
    switch(arguments.length) {
      case 1:
        return doVisitFull(visit, this.root)
      break
  
      case 2:
        return doVisitHalf(lo, this._compare, visit, this.root)
      break
  
      case 3:
        if(this._compare(lo, hi) >= 0) {
          return
        }
        return doVisit(lo, hi, this._compare, visit, this.root)
      break
    }
  }
  
  //First item in list
  Object.defineProperty(proto, "begin", {
    get: function() {
      var stack = []
      var n = this.root
      while(n) {
        stack.push(n)
        n = n.left
      }
      return new RedBlackTreeIterator(this, stack)
    }
  })
  
  //Last item in list
  Object.defineProperty(proto, "end", {
    get: function() {
      var stack = []
      var n = this.root
      while(n) {
        stack.push(n)
        n = n.right
      }
      return new RedBlackTreeIterator(this, stack)
    }
  })
  
  //Find the ith item in the tree
  proto.at = function(idx) {
    if(idx < 0) {
      return new RedBlackTreeIterator(this, [])
    }
    var n = this.root
    var stack = []
    while(true) {
      stack.push(n)
      if(n.left) {
        if(idx < n.left._count) {
          n = n.left
          continue
        }
        idx -= n.left._count
      }
      if(!idx) {
        return new RedBlackTreeIterator(this, stack)
      }
      idx -= 1
      if(n.right) {
        if(idx >= n.right._count) {
          break
        }
        n = n.right
      } else {
        break
      }
    }
    return new RedBlackTreeIterator(this, [])
  }
  
  proto.ge = function(key) {
    var cmp = this._compare
    var n = this.root
    var stack = []
    var last_ptr = 0
    while(n) {
      var d = cmp(key, n.key)
      stack.push(n)
      if(d <= 0) {
        last_ptr = stack.length
      }
      if(d <= 0) {
        n = n.left
      } else {
        n = n.right
      }
    }
    stack.length = last_ptr
    return new RedBlackTreeIterator(this, stack)
  }
  
  proto.gt = function(key) {
    var cmp = this._compare
    var n = this.root
    var stack = []
    var last_ptr = 0
    while(n) {
      var d = cmp(key, n.key)
      stack.push(n)
      if(d < 0) {
        last_ptr = stack.length
      }
      if(d < 0) {
        n = n.left
      } else {
        n = n.right
      }
    }
    stack.length = last_ptr
    return new RedBlackTreeIterator(this, stack)
  }
  
  proto.lt = function(key) {
    var cmp = this._compare
    var n = this.root
    var stack = []
    var last_ptr = 0
    while(n) {
      var d = cmp(key, n.key)
      stack.push(n)
      if(d > 0) {
        last_ptr = stack.length
      }
      if(d <= 0) {
        n = n.left
      } else {
        n = n.right
      }
    }
    stack.length = last_ptr
    return new RedBlackTreeIterator(this, stack)
  }
  
  proto.le = function(key) {
    var cmp = this._compare
    var n = this.root
    var stack = []
    var last_ptr = 0
    while(n) {
      var d = cmp(key, n.key)
      stack.push(n)
      if(d >= 0) {
        last_ptr = stack.length
      }
      if(d < 0) {
        n = n.left
      } else {
        n = n.right
      }
    }
    stack.length = last_ptr
    return new RedBlackTreeIterator(this, stack)
  }
  
  //Finds the item with key if it exists
  proto.find = function(key) {
    var cmp = this._compare
    var n = this.root
    var stack = []
    while(n) {
      var d = cmp(key, n.key)
      stack.push(n)
      if(d === 0) {
        return new RedBlackTreeIterator(this, stack)
      }
      if(d <= 0) {
        n = n.left
      } else {
        n = n.right
      }
    }
    return new RedBlackTreeIterator(this, [])
  }
  
  //Removes item with key from tree
  proto.remove = function(key) {
    var iter = this.find(key)
    if(iter) {
      return iter.remove()
    }
    return this
  }
  
  //Returns the item at `key`
  proto.get = function(key) {
    var cmp = this._compare
    var n = this.root
    while(n) {
      var d = cmp(key, n.key)
      if(d === 0) {
        return n.value
      }
      if(d <= 0) {
        n = n.left
      } else {
        n = n.right
      }
    }
    return
  }
  
  //Iterator for red black tree
  function RedBlackTreeIterator(tree, stack) {
    this.tree = tree
    this._stack = stack
  }
  
  var iproto = RedBlackTreeIterator.prototype
  
  //Test if iterator is valid
  Object.defineProperty(iproto, "valid", {
    get: function() {
      return this._stack.length > 0
    }
  })
  
  //Node of the iterator
  Object.defineProperty(iproto, "node", {
    get: function() {
      if(this._stack.length > 0) {
        return this._stack[this._stack.length-1]
      }
      return null
    },
    enumerable: true
  })
  
  //Makes a copy of an iterator
  iproto.clone = function() {
    return new RedBlackTreeIterator(this.tree, this._stack.slice())
  }
  
  //Swaps two nodes
  function swapNode(n, v) {
    n.key = v.key
    n.value = v.value
    n.left = v.left
    n.right = v.right
    n._color = v._color
    n._count = v._count
  }
  
  //Fix up a double black node in a tree
  function fixDoubleBlack(stack) {
    var n, p, s, z
    for(var i=stack.length-1; i>=0; --i) {
      n = stack[i]
      if(i === 0) {
        n._color = BLACK
        return
      }
      //console.log("visit node:", n.key, i, stack[i].key, stack[i-1].key)
      p = stack[i-1]
      if(p.left === n) {
        //console.log("left child")
        s = p.right
        if(s.right && s.right._color === RED) {
          //console.log("case 1: right sibling child red")
          s = p.right = cloneNode(s)
          z = s.right = cloneNode(s.right)
          p.right = s.left
          s.left = p
          s.right = z
          s._color = p._color
          n._color = BLACK
          p._color = BLACK
          z._color = BLACK
          recount(p)
          recount(s)
          if(i > 1) {
            var pp = stack[i-2]
            if(pp.left === p) {
              pp.left = s
            } else {
              pp.right = s
            }
          }
          stack[i-1] = s
          return
        } else if(s.left && s.left._color === RED) {
          //console.log("case 1: left sibling child red")
          s = p.right = cloneNode(s)
          z = s.left = cloneNode(s.left)
          p.right = z.left
          s.left = z.right
          z.left = p
          z.right = s
          z._color = p._color
          p._color = BLACK
          s._color = BLACK
          n._color = BLACK
          recount(p)
          recount(s)
          recount(z)
          if(i > 1) {
            var pp = stack[i-2]
            if(pp.left === p) {
              pp.left = z
            } else {
              pp.right = z
            }
          }
          stack[i-1] = z
          return
        }
        if(s._color === BLACK) {
          if(p._color === RED) {
            //console.log("case 2: black sibling, red parent", p.right.value)
            p._color = BLACK
            p.right = repaint(RED, s)
            return
          } else {
            //console.log("case 2: black sibling, black parent", p.right.value)
            p.right = repaint(RED, s)
            continue  
          }
        } else {
          //console.log("case 3: red sibling")
          s = cloneNode(s)
          p.right = s.left
          s.left = p
          s._color = p._color
          p._color = RED
          recount(p)
          recount(s)
          if(i > 1) {
            var pp = stack[i-2]
            if(pp.left === p) {
              pp.left = s
            } else {
              pp.right = s
            }
          }
          stack[i-1] = s
          stack[i] = p
          if(i+1 < stack.length) {
            stack[i+1] = n
          } else {
            stack.push(n)
          }
          i = i+2
        }
      } else {
        //console.log("right child")
        s = p.left
        if(s.left && s.left._color === RED) {
          //console.log("case 1: left sibling child red", p.value, p._color)
          s = p.left = cloneNode(s)
          z = s.left = cloneNode(s.left)
          p.left = s.right
          s.right = p
          s.left = z
          s._color = p._color
          n._color = BLACK
          p._color = BLACK
          z._color = BLACK
          recount(p)
          recount(s)
          if(i > 1) {
            var pp = stack[i-2]
            if(pp.right === p) {
              pp.right = s
            } else {
              pp.left = s
            }
          }
          stack[i-1] = s
          return
        } else if(s.right && s.right._color === RED) {
          //console.log("case 1: right sibling child red")
          s = p.left = cloneNode(s)
          z = s.right = cloneNode(s.right)
          p.left = z.right
          s.right = z.left
          z.right = p
          z.left = s
          z._color = p._color
          p._color = BLACK
          s._color = BLACK
          n._color = BLACK
          recount(p)
          recount(s)
          recount(z)
          if(i > 1) {
            var pp = stack[i-2]
            if(pp.right === p) {
              pp.right = z
            } else {
              pp.left = z
            }
          }
          stack[i-1] = z
          return
        }
        if(s._color === BLACK) {
          if(p._color === RED) {
            //console.log("case 2: black sibling, red parent")
            p._color = BLACK
            p.left = repaint(RED, s)
            return
          } else {
            //console.log("case 2: black sibling, black parent")
            p.left = repaint(RED, s)
            continue  
          }
        } else {
          //console.log("case 3: red sibling")
          s = cloneNode(s)
          p.left = s.right
          s.right = p
          s._color = p._color
          p._color = RED
          recount(p)
          recount(s)
          if(i > 1) {
            var pp = stack[i-2]
            if(pp.right === p) {
              pp.right = s
            } else {
              pp.left = s
            }
          }
          stack[i-1] = s
          stack[i] = p
          if(i+1 < stack.length) {
            stack[i+1] = n
          } else {
            stack.push(n)
          }
          i = i+2
        }
      }
    }
  }
  
  //Removes item at iterator from tree
  iproto.remove = function() {
    var stack = this._stack
    if(stack.length === 0) {
      return this.tree
    }
    //First copy path to node
    var cstack = new Array(stack.length)
    var n = stack[stack.length-1]
    cstack[cstack.length-1] = new RBNode(n._color, n.key, n.value, n.left, n.right, n._count)
    for(var i=stack.length-2; i>=0; --i) {
      var n = stack[i]
      if(n.left === stack[i+1]) {
        cstack[i] = new RBNode(n._color, n.key, n.value, cstack[i+1], n.right, n._count)
      } else {
        cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i+1], n._count)
      }
    }
  
    //Get node
    n = cstack[cstack.length-1]
    //console.log("start remove: ", n.value)
  
    //If not leaf, then swap with previous node
    if(n.left && n.right) {
      //console.log("moving to leaf")
  
      //First walk to previous leaf
      var split = cstack.length
      n = n.left
      while(n.right) {
        cstack.push(n)
        n = n.right
      }
      //Copy path to leaf
      var v = cstack[split-1]
      cstack.push(new RBNode(n._color, v.key, v.value, n.left, n.right, n._count))
      cstack[split-1].key = n.key
      cstack[split-1].value = n.value
  
      //Fix up stack
      for(var i=cstack.length-2; i>=split; --i) {
        n = cstack[i]
        cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i+1], n._count)
      }
      cstack[split-1].left = cstack[split]
    }
    //console.log("stack=", cstack.map(function(v) { return v.value }))
  
    //Remove leaf node
    n = cstack[cstack.length-1]
    if(n._color === RED) {
      //Easy case: removing red leaf
      //console.log("RED leaf")
      var p = cstack[cstack.length-2]
      if(p.left === n) {
        p.left = null
      } else if(p.right === n) {
        p.right = null
      }
      cstack.pop()
      for(var i=0; i<cstack.length; ++i) {
        cstack[i]._count--
      }
      return new RedBlackTree(this.tree._compare, cstack[0])
    } else {
      if(n.left || n.right) {
        //Second easy case:  Single child black parent
        //console.log("BLACK single child")
        if(n.left) {
          swapNode(n, n.left)
        } else if(n.right) {
          swapNode(n, n.right)
        }
        //Child must be red, so repaint it black to balance color
        n._color = BLACK
        for(var i=0; i<cstack.length-1; ++i) {
          cstack[i]._count--
        }
        return new RedBlackTree(this.tree._compare, cstack[0])
      } else if(cstack.length === 1) {
        //Third easy case: root
        //console.log("ROOT")
        return new RedBlackTree(this.tree._compare, null)
      } else {
        //Hard case: Repaint n, and then do some nasty stuff
        //console.log("BLACK leaf no children")
        for(var i=0; i<cstack.length; ++i) {
          cstack[i]._count--
        }
        var parent = cstack[cstack.length-2]
        fixDoubleBlack(cstack)
        //Fix up links
        if(parent.left === n) {
          parent.left = null
        } else {
          parent.right = null
        }
      }
    }
    return new RedBlackTree(this.tree._compare, cstack[0])
  }
  
  //Returns key
  Object.defineProperty(iproto, "key", {
    get: function() {
      if(this._stack.length > 0) {
        return this._stack[this._stack.length-1].key
      }
      return
    },
    enumerable: true
  })
  
  //Returns value
  Object.defineProperty(iproto, "value", {
    get: function() {
      if(this._stack.length > 0) {
        return this._stack[this._stack.length-1].value
      }
      return
    },
    enumerable: true
  })
  
  
  //Returns the position of this iterator in the sorted list
  Object.defineProperty(iproto, "index", {
    get: function() {
      var idx = 0
      var stack = this._stack
      if(stack.length === 0) {
        var r = this.tree.root
        if(r) {
          return r._count
        }
        return 0
      } else if(stack[stack.length-1].left) {
        idx = stack[stack.length-1].left._count
      }
      for(var s=stack.length-2; s>=0; --s) {
        if(stack[s+1] === stack[s].right) {
          ++idx
          if(stack[s].left) {
            idx += stack[s].left._count
          }
        }
      }
      return idx
    },
    enumerable: true
  })
  
  //Advances iterator to next element in list
  iproto.next = function() {
    var stack = this._stack
    if(stack.length === 0) {
      return
    }
    var n = stack[stack.length-1]
    if(n.right) {
      n = n.right
      while(n) {
        stack.push(n)
        n = n.left
      }
    } else {
      stack.pop()
      while(stack.length > 0 && stack[stack.length-1].right === n) {
        n = stack[stack.length-1]
        stack.pop()
      }
    }
  }
  
  //Checks if iterator is at end of tree
  Object.defineProperty(iproto, "hasNext", {
    get: function() {
      var stack = this._stack
      if(stack.length === 0) {
        return false
      }
      if(stack[stack.length-1].right) {
        return true
      }
      for(var s=stack.length-1; s>0; --s) {
        if(stack[s-1].left === stack[s]) {
          return true
        }
      }
      return false
    }
  })
  
  //Update value
  iproto.update = function(value) {
    var stack = this._stack
    if(stack.length === 0) {
      throw new Error("Can't update empty node!")
    }
    var cstack = new Array(stack.length)
    var n = stack[stack.length-1]
    cstack[cstack.length-1] = new RBNode(n._color, n.key, value, n.left, n.right, n._count)
    for(var i=stack.length-2; i>=0; --i) {
      n = stack[i]
      if(n.left === stack[i+1]) {
        cstack[i] = new RBNode(n._color, n.key, n.value, cstack[i+1], n.right, n._count)
      } else {
        cstack[i] = new RBNode(n._color, n.key, n.value, n.left, cstack[i+1], n._count)
      }
    }
    return new RedBlackTree(this.tree._compare, cstack[0])
  }
  
  //Moves iterator backward one element
  iproto.prev = function() {
    var stack = this._stack
    if(stack.length === 0) {
      return
    }
    var n = stack[stack.length-1]
    if(n.left) {
      n = n.left
      while(n) {
        stack.push(n)
        n = n.right
      }
    } else {
      stack.pop()
      while(stack.length > 0 && stack[stack.length-1].left === n) {
        n = stack[stack.length-1]
        stack.pop()
      }
    }
  }
  
  //Checks if iterator is at start of tree
  Object.defineProperty(iproto, "hasPrev", {
    get: function() {
      var stack = this._stack
      if(stack.length === 0) {
        return false
      }
      if(stack[stack.length-1].left) {
        return true
      }
      for(var s=stack.length-1; s>0; --s) {
        if(stack[s-1].right === stack[s]) {
          return true
        }
      }
      return false
    }
  })
  
  //Default comparison function
  function defaultCompare(a, b) {
    if(a < b) {
      return -1
    }
    if(a > b) {
      return 1
    }
    return 0
  }
  
  //Build a tree
  function createRBTree(compare) {
    return new RedBlackTree(compare || defaultCompare, null)
  }
  },{}],248:[function(_dereq_,module,exports){
  // transliterated from the python snippet here:
  // http://en.wikipedia.org/wiki/Lanczos_approximation
  
  var g = 7;
  var p = [
      0.99999999999980993,
      676.5203681218851,
      -1259.1392167224028,
      771.32342877765313,
      -176.61502916214059,
      12.507343278686905,
      -0.13857109526572012,
      9.9843695780195716e-6,
      1.5056327351493116e-7
  ];
  
  var g_ln = 607/128;
  var p_ln = [
      0.99999999999999709182,
      57.156235665862923517,
      -59.597960355475491248,
      14.136097974741747174,
      -0.49191381609762019978,
      0.33994649984811888699e-4,
      0.46523628927048575665e-4,
      -0.98374475304879564677e-4,
      0.15808870322491248884e-3,
      -0.21026444172410488319e-3,
      0.21743961811521264320e-3,
      -0.16431810653676389022e-3,
      0.84418223983852743293e-4,
      -0.26190838401581408670e-4,
      0.36899182659531622704e-5
  ];
  
  // Spouge approximation (suitable for large arguments)
  function lngamma(z) {
  
      if(z < 0) return Number('0/0');
      var x = p_ln[0];
      for(var i = p_ln.length - 1; i > 0; --i) x += p_ln[i] / (z + i);
      var t = z + g_ln + 0.5;
      return .5*Math.log(2*Math.PI)+(z+.5)*Math.log(t)-t+Math.log(x)-Math.log(z);
  }
  
  module.exports = function gamma (z) {
      if (z < 0.5) {
          return Math.PI / (Math.sin(Math.PI * z) * gamma(1 - z));
      }
      else if(z > 100) return Math.exp(lngamma(z));
      else {
          z -= 1;
          var x = p[0];
          for (var i = 1; i < g + 2; i++) {
              x += p[i] / (z + i);
          }
          var t = z + g + 0.5;
  
          return Math.sqrt(2 * Math.PI)
              * Math.pow(t, z + 0.5)
              * Math.exp(-t)
              * x
          ;
      }
  };
  
  module.exports.log = lngamma;
  
  },{}],249:[function(_dereq_,module,exports){
  module.exports = getCanvasContext
  function getCanvasContext (type, opts) {
    if (typeof type !== 'string') {
      throw new TypeError('must specify type string')
    }
  
    opts = opts || {}
  
    if (typeof document === 'undefined' && !opts.canvas) {
      return null // check for Node
    }
  
    var canvas = opts.canvas || document.createElement('canvas')
    if (typeof opts.width === 'number') {
      canvas.width = opts.width
    }
    if (typeof opts.height === 'number') {
      canvas.height = opts.height
    }
  
    var attribs = opts
    var gl
    try {
      var names = [ type ]
      // prefix GL contexts
      if (type.indexOf('webgl') === 0) {
        names.push('experimental-' + type)
      }
  
      for (var i = 0; i < names.length; i++) {
        gl = canvas.getContext(names[i], attribs)
        if (gl) return gl
      }
    } catch (e) {
      gl = null
    }
    return (gl || null) // ensure null on fail
  }
  
  },{}],250:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createAxes
  
  var createText        = _dereq_('./lib/text.js')
  var createLines       = _dereq_('./lib/lines.js')
  var createBackground  = _dereq_('./lib/background.js')
  var getCubeProperties = _dereq_('./lib/cube.js')
  var Ticks             = _dereq_('./lib/ticks.js')
  
  var identity = new Float32Array([
    1, 0, 0, 0,
    0, 1, 0, 0,
    0, 0, 1, 0,
    0, 0, 0, 1])
  
  function copyVec3(a, b) {
    a[0] = b[0]
    a[1] = b[1]
    a[2] = b[2]
    return a
  }
  
  function Axes(gl) {
    this.gl             = gl
  
    this.pixelRatio     = 1
  
    this.bounds         = [ [-10, -10, -10],
                            [ 10,  10,  10] ]
    this.ticks          = [ [], [], [] ]
    this.autoTicks      = true
    this.tickSpacing    = [ 1, 1, 1 ]
  
    this.tickEnable     = [ true, true, true ]
    this.tickFont       = [ 'sans-serif', 'sans-serif', 'sans-serif' ]
    this.tickSize       = [ 12, 12, 12 ]
    this.tickAngle      = [ 0, 0, 0 ]
    this.tickAlign      = [ 'auto', 'auto', 'auto' ]
    this.tickColor      = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
    this.tickPad        = [ 10, 10, 10 ]
  
    this.lastCubeProps  = {
      cubeEdges: [0,0,0],
      axis:      [0,0,0]
    }
  
    this.labels         = [ 'x', 'y', 'z' ]
    this.labelEnable    = [ true, true, true ]
    this.labelFont      = 'sans-serif'
    this.labelSize      = [ 20, 20, 20 ]
    this.labelAngle     = [ 0, 0, 0 ]
    this.labelAlign     = [ 'auto', 'auto', 'auto' ]
    this.labelColor     = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
    this.labelPad       = [ 10, 10, 10 ]
  
    this.lineEnable     = [ true, true, true ]
    this.lineMirror     = [ false, false, false ]
    this.lineWidth      = [ 1, 1, 1 ]
    this.lineColor      = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
  
    this.lineTickEnable = [ true, true, true ]
    this.lineTickMirror = [ false, false, false ]
    this.lineTickLength = [ 0, 0, 0 ]
    this.lineTickWidth  = [ 1, 1, 1 ]
    this.lineTickColor  = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
  
    this.gridEnable     = [ true, true, true ]
    this.gridWidth      = [ 1, 1, 1 ]
    this.gridColor      = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
  
    this.zeroEnable     = [ true, true, true ]
    this.zeroLineColor  = [ [0,0,0,1], [0,0,0,1], [0,0,0,1] ]
    this.zeroLineWidth  = [ 2, 2, 2 ]
  
    this.backgroundEnable = [ false, false, false ]
    this.backgroundColor  = [ [0.8, 0.8, 0.8, 0.5],
                              [0.8, 0.8, 0.8, 0.5],
                              [0.8, 0.8, 0.8, 0.5] ]
  
    this._firstInit = true
    this._text  = null
    this._lines = null
    this._background = createBackground(gl)
  }
  
  var proto = Axes.prototype
  
  proto.update = function(options) {
    options = options || {}
  
    //Option parsing helper functions
    function parseOption(nest, cons, name) {
      if(name in options) {
        var opt = options[name]
        var prev = this[name]
        var next
        if(nest ? (Array.isArray(opt) && Array.isArray(opt[0])) :
                   Array.isArray(opt) ) {
          this[name] = next = [ cons(opt[0]), cons(opt[1]), cons(opt[2]) ]
        } else {
          this[name] = next = [ cons(opt), cons(opt), cons(opt) ]
        }
        for(var i=0; i<3; ++i) {
          if(next[i] !== prev[i]) {
            return true
          }
        }
      }
      return false
    }
  
    var NUMBER  = parseOption.bind(this, false, Number)
    var BOOLEAN = parseOption.bind(this, false, Boolean)
    var STRING  = parseOption.bind(this, false, String)
    var COLOR   = parseOption.bind(this, true, function(v) {
      if(Array.isArray(v)) {
        if(v.length === 3) {
          return [ +v[0], +v[1], +v[2], 1.0 ]
        } else if(v.length === 4) {
          return [ +v[0], +v[1], +v[2], +v[3] ]
        }
      }
      return [ 0, 0, 0, 1 ]
    })
  
    //Tick marks and bounds
    var nextTicks
    var ticksUpdate   = false
    var boundsChanged = false
    if('bounds' in options) {
      var bounds = options.bounds
  i_loop:
      for(var i=0; i<2; ++i) {
        for(var j=0; j<3; ++j) {
          if(bounds[i][j] !== this.bounds[i][j]) {
            boundsChanged = true
          }
          this.bounds[i][j] = bounds[i][j]
        }
      }
    }
    if('ticks' in options) {
      nextTicks      = options.ticks
      ticksUpdate    = true
      this.autoTicks = false
      for(var i=0; i<3; ++i) {
        this.tickSpacing[i] = 0.0
      }
    } else if(NUMBER('tickSpacing')) {
      this.autoTicks  = true
      boundsChanged   = true
    }
  
    if(this._firstInit) {
      if(!('ticks' in options || 'tickSpacing' in options)) {
        this.autoTicks = true
      }
  
      //Force tick recomputation on first update
      boundsChanged   = true
      ticksUpdate     = true
      this._firstInit = false
    }
  
    if(boundsChanged && this.autoTicks) {
      nextTicks = Ticks.create(this.bounds, this.tickSpacing)
      ticksUpdate = true
    }
  
    //Compare next ticks to previous ticks, only update if needed
    if(ticksUpdate) {
      for(var i=0; i<3; ++i) {
        nextTicks[i].sort(function(a,b) {
          return a.x-b.x
        })
      }
      if(Ticks.equal(nextTicks, this.ticks)) {
        ticksUpdate = false
      } else {
        this.ticks = nextTicks
      }
    }
  
    //Parse tick properties
    BOOLEAN('tickEnable')
    if(STRING('tickFont')) {
      ticksUpdate = true  //If font changes, must rebuild vbo
    }
    NUMBER('tickSize')
    NUMBER('tickAngle')
    NUMBER('tickPad')
    COLOR('tickColor')
  
    //Axis labels
    var labelUpdate = STRING('labels')
    if(STRING('labelFont')) {
      labelUpdate = true
    }
    BOOLEAN('labelEnable')
    NUMBER('labelSize')
    NUMBER('labelPad')
    COLOR('labelColor')
  
    //Axis lines
    BOOLEAN('lineEnable')
    BOOLEAN('lineMirror')
    NUMBER('lineWidth')
    COLOR('lineColor')
  
    //Axis line ticks
    BOOLEAN('lineTickEnable')
    BOOLEAN('lineTickMirror')
    NUMBER('lineTickLength')
    NUMBER('lineTickWidth')
    COLOR('lineTickColor')
  
    //Grid lines
    BOOLEAN('gridEnable')
    NUMBER('gridWidth')
    COLOR('gridColor')
  
    //Zero line
    BOOLEAN('zeroEnable')
    COLOR('zeroLineColor')
    NUMBER('zeroLineWidth')
  
    //Background
    BOOLEAN('backgroundEnable')
    COLOR('backgroundColor')
  
    //Update text if necessary
    if(!this._text) {
      this._text = createText(
        this.gl,
        this.bounds,
        this.labels,
        this.labelFont,
        this.ticks,
        this.tickFont)
    } else if(this._text && (labelUpdate || ticksUpdate)) {
      this._text.update(
        this.bounds,
        this.labels,
        this.labelFont,
        this.ticks,
        this.tickFont)
    }
  
    //Update lines if necessary
    if(this._lines && ticksUpdate) {
      this._lines.dispose()
      this._lines = null
    }
    if(!this._lines) {
      this._lines = createLines(this.gl, this.bounds, this.ticks)
    }
  }
  
  function OffsetInfo() {
    this.primalOffset = [0,0,0]
    this.primalMinor  = [0,0,0]
    this.mirrorOffset = [0,0,0]
    this.mirrorMinor  = [0,0,0]
  }
  
  var LINE_OFFSET = [ new OffsetInfo(), new OffsetInfo(), new OffsetInfo() ]
  
  function computeLineOffset(result, i, bounds, cubeEdges, cubeAxis) {
    var primalOffset = result.primalOffset
    var primalMinor  = result.primalMinor
    var dualOffset   = result.mirrorOffset
    var dualMinor    = result.mirrorMinor
    var e = cubeEdges[i]
  
    //Calculate offsets
    for(var j=0; j<3; ++j) {
      if(i === j) {
        continue
      }
      var a = primalOffset,
          b = dualOffset,
          c = primalMinor,
          d = dualMinor
      if(e & (1<<j)) {
        a = dualOffset
        b = primalOffset
        c = dualMinor
        d = primalMinor
      }
      a[j] = bounds[0][j]
      b[j] = bounds[1][j]
      if(cubeAxis[j] > 0) {
        c[j] = -1
        d[j] = 0
      } else {
        c[j] = 0
        d[j] = +1
      }
    }
  }
  
  var CUBE_ENABLE = [0,0,0]
  var DEFAULT_PARAMS = {
    model:      identity,
    view:       identity,
    projection: identity,
    _ortho:      false
  }
  
  proto.isOpaque = function() {
    return true
  }
  
  proto.isTransparent = function() {
    return false
  }
  
  proto.drawTransparent = function(params) {}
  
  var ALIGN_OPTION_AUTO = 0 // i.e. as defined in the shader the text would rotate to stay upwards range: [-90,90]
  
  var PRIMAL_MINOR  = [0,0,0]
  var MIRROR_MINOR  = [0,0,0]
  var PRIMAL_OFFSET = [0,0,0]
  
  proto.draw = function(params) {
    params = params || DEFAULT_PARAMS
  
    var gl = this.gl
  
    //Geometry for camera and axes
    var model       = params.model || identity
    var view        = params.view || identity
    var projection  = params.projection || identity
    var bounds      = this.bounds
    var isOrtho     = params._ortho || false
  
    //Unpack axis info
    var cubeParams  = getCubeProperties(model, view, projection, bounds, isOrtho)
    var cubeEdges   = cubeParams.cubeEdges
    var cubeAxis    = cubeParams.axis
  
    var cx = view[12]
    var cy = view[13]
    var cz = view[14]
    var cw = view[15]
  
    var orthoFix = (isOrtho) ? 2 : 1 // double up padding for orthographic ticks & labels
    var pixelScaleF = orthoFix * this.pixelRatio * (projection[3]*cx + projection[7]*cy + projection[11]*cz + projection[15]*cw) / gl.drawingBufferHeight
  
    for(var i=0; i<3; ++i) {
      this.lastCubeProps.cubeEdges[i] = cubeEdges[i]
      this.lastCubeProps.axis[i] = cubeAxis[i]
    }
  
    //Compute axis info
    var lineOffset  = LINE_OFFSET
    for(var i=0; i<3; ++i) {
      computeLineOffset(
        LINE_OFFSET[i],
        i,
        this.bounds,
        cubeEdges,
        cubeAxis)
    }
  
    //Set up state parameters
    var gl = this.gl
  
    //Draw background first
    var cubeEnable = CUBE_ENABLE
    for(var i=0; i<3; ++i) {
      if(this.backgroundEnable[i]) {
        cubeEnable[i] = cubeAxis[i]
      } else {
        cubeEnable[i] = 0
      }
    }
  
    this._background.draw(
      model,
      view,
      projection,
      bounds,
      cubeEnable,
      this.backgroundColor)
  
    //Draw lines
    this._lines.bind(
      model,
      view,
      projection,
      this)
  
    //First draw grid lines and zero lines
    for(var i=0; i<3; ++i) {
      var x = [0,0,0]
      if(cubeAxis[i] > 0) {
        x[i] = bounds[1][i]
      } else {
        x[i] = bounds[0][i]
      }
  
      //Draw grid lines
      for(var j=0; j<2; ++j) {
        var u = (i + 1 + j) % 3
        var v = (i + 1 + (j^1)) % 3
        if(this.gridEnable[u]) {
          this._lines.drawGrid(u, v, this.bounds, x, this.gridColor[u], this.gridWidth[u]*this.pixelRatio)
        }
      }
  
      //Draw zero lines (need to do this AFTER all grid lines are drawn)
      for(var j=0; j<2; ++j) {
        var u = (i + 1 + j) % 3
        var v = (i + 1 + (j^1)) % 3
        if(this.zeroEnable[v]) {
          //Check if zero line in bounds
          if(Math.min(bounds[0][v], bounds[1][v]) <= 0 && Math.max(bounds[0][v], bounds[1][v]) >= 0) {
            this._lines.drawZero(u, v, this.bounds, x, this.zeroLineColor[v], this.zeroLineWidth[v]*this.pixelRatio)
          }
        }
      }
    }
  
    //Then draw axis lines and tick marks
    for(var i=0; i<3; ++i) {
  
      //Draw axis lines
      if(this.lineEnable[i]) {
        this._lines.drawAxisLine(i, this.bounds, lineOffset[i].primalOffset, this.lineColor[i], this.lineWidth[i]*this.pixelRatio)
      }
      if(this.lineMirror[i]) {
        this._lines.drawAxisLine(i, this.bounds, lineOffset[i].mirrorOffset, this.lineColor[i], this.lineWidth[i]*this.pixelRatio)
      }
  
      //Compute minor axes
      var primalMinor = copyVec3(PRIMAL_MINOR, lineOffset[i].primalMinor)
      var mirrorMinor = copyVec3(MIRROR_MINOR, lineOffset[i].mirrorMinor)
      var tickLength  = this.lineTickLength
      for(var j=0; j<3; ++j) {
        var scaleFactor = pixelScaleF / model[5*j]
        primalMinor[j] *= tickLength[j] * scaleFactor
        mirrorMinor[j] *= tickLength[j] * scaleFactor
      }
  
  
  
      //Draw axis line ticks
      if(this.lineTickEnable[i]) {
        this._lines.drawAxisTicks(i, lineOffset[i].primalOffset, primalMinor, this.lineTickColor[i], this.lineTickWidth[i]*this.pixelRatio)
      }
      if(this.lineTickMirror[i]) {
        this._lines.drawAxisTicks(i, lineOffset[i].mirrorOffset, mirrorMinor, this.lineTickColor[i], this.lineTickWidth[i]*this.pixelRatio)
      }
    }
    this._lines.unbind()
  
    //Draw text sprites
    this._text.bind(
      model,
      view,
      projection,
      this.pixelRatio)
  
    var alignOpt // options in shader are from this list {-1, 0, 1, 2, 3, ..., n}
    // -1: backward compatible
    //  0: raw data
    //  1: auto align, free angles
    //  2: auto align, horizontal or vertical
    //3-n: auto align, round to n directions e.g. 12 -> round to angles with 30-degree steps
  
    var hv_ratio = 0.5 // can have an effect on the ratio between horizontals and verticals when using option 2
  
    var enableAlign
    var alignDir
  
    function alignTo(i) {
      alignDir = [0,0,0]
      alignDir[i] = 1
    }
  
    function solveTickAlignments(i, minor, major) {
  
      var i1 = (i + 1) % 3
      var i2 = (i + 2) % 3
  
      var A = minor[i1]
      var B = minor[i2]
      var C = major[i1]
      var D = major[i2]
  
           if ((A > 0) && (D > 0)) { alignTo(i1); return; }
      else if ((A > 0) && (D < 0)) { alignTo(i1); return; }
      else if ((A < 0) && (D > 0)) { alignTo(i1); return; }
      else if ((A < 0) && (D < 0)) { alignTo(i1); return; }
      else if ((B > 0) && (C > 0)) { alignTo(i2); return; }
      else if ((B > 0) && (C < 0)) { alignTo(i2); return; }
      else if ((B < 0) && (C > 0)) { alignTo(i2); return; }
      else if ((B < 0) && (C < 0)) { alignTo(i2); return; }
    }
  
    for(var i=0; i<3; ++i) {
  
      var minor      = lineOffset[i].primalMinor
      var major      = lineOffset[i].mirrorMinor
  
      var offset     = copyVec3(PRIMAL_OFFSET, lineOffset[i].primalOffset)
  
      for(var j=0; j<3; ++j) {
        if(this.lineTickEnable[i]) {
          offset[j] += pixelScaleF * minor[j] * Math.max(this.lineTickLength[j], 0)  / model[5*j]
        }
      }
  
      var axis = [0,0,0]
      axis[i] = 1
  
      //Draw tick text
      if(this.tickEnable[i]) {
  
        if(this.tickAngle[i] === -3600) {
          this.tickAngle[i] = 0
          this.tickAlign[i] = 'auto'
        } else {
          this.tickAlign[i] = -1
        }
  
        enableAlign = 1;
  
        alignOpt = [this.tickAlign[i], hv_ratio, enableAlign]
        if(alignOpt[0] === 'auto') alignOpt[0] = ALIGN_OPTION_AUTO
        else alignOpt[0] = parseInt('' + alignOpt[0])
  
        alignDir = [0,0,0]
        solveTickAlignments(i, minor, major)
  
        //Add tick padding
        for(var j=0; j<3; ++j) {
          offset[j] += pixelScaleF * minor[j] * this.tickPad[j] / model[5*j]
        }
  
        //Draw axis
        this._text.drawTicks(
          i,
          this.tickSize[i],
          this.tickAngle[i],
          offset,
          this.tickColor[i],
          axis,
          alignDir,
          alignOpt)
      }
  
      //Draw labels
      if(this.labelEnable[i]) {
  
        enableAlign = 0
        alignDir = [0,0,0]
        if(this.labels[i].length > 4) { // for large label axis enable alignDir to axis
          alignTo(i)
          enableAlign = 1
        }
  
        alignOpt = [this.labelAlign[i], hv_ratio, enableAlign]
        if(alignOpt[0] === 'auto') alignOpt[0] = ALIGN_OPTION_AUTO
        else alignOpt[0] = parseInt('' + alignOpt[0])
  
        //Add label padding
        for(var j=0; j<3; ++j) {
          offset[j] += pixelScaleF * minor[j] * this.labelPad[j] / model[5*j]
        }
        offset[i] += 0.5 * (bounds[0][i] + bounds[1][i])
  
        //Draw axis
        this._text.drawLabel(
          i,
          this.labelSize[i],
          this.labelAngle[i],
          offset,
          this.labelColor[i],
          [0,0,0],
          alignDir,
          alignOpt)
      }
    }
  
    this._text.unbind()
  }
  
  proto.dispose = function() {
    this._text.dispose()
    this._lines.dispose()
    this._background.dispose()
    this._lines = null
    this._text = null
    this._background = null
    this.gl = null
  }
  
  function createAxes(gl, options) {
    var axes = new Axes(gl)
    axes.update(options)
    return axes
  }
  
  },{"./lib/background.js":251,"./lib/cube.js":252,"./lib/lines.js":253,"./lib/text.js":255,"./lib/ticks.js":256}],251:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createBackgroundCube
  
  var createBuffer = _dereq_('gl-buffer')
  var createVAO    = _dereq_('gl-vao')
  var createShader = _dereq_('./shaders').bg
  
  function BackgroundCube(gl, buffer, vao, shader) {
    this.gl = gl
    this.buffer = buffer
    this.vao = vao
    this.shader = shader
  }
  
  var proto = BackgroundCube.prototype
  
  proto.draw = function(model, view, projection, bounds, enable, colors) {
    var needsBG = false
    for(var i=0; i<3; ++i) {
      needsBG = needsBG || enable[i]
    }
    if(!needsBG) {
      return
    }
  
    var gl = this.gl
  
    gl.enable(gl.POLYGON_OFFSET_FILL)
    gl.polygonOffset(1, 2)
  
    this.shader.bind()
    this.shader.uniforms = {
      model: model,
      view: view,
      projection: projection,
      bounds: bounds,
      enable: enable,
      colors: colors
    }
    this.vao.bind()
    this.vao.draw(this.gl.TRIANGLES, 36)
    this.vao.unbind()
  
    gl.disable(gl.POLYGON_OFFSET_FILL)
  }
  
  proto.dispose = function() {
    this.vao.dispose()
    this.buffer.dispose()
    this.shader.dispose()
  }
  
  function createBackgroundCube(gl) {
    //Create cube vertices
    var vertices = []
    var indices  = []
    var ptr = 0
    for(var d=0; d<3; ++d) {
      var u = (d+1) % 3
      var v = (d+2) % 3
      var x = [0,0,0]
      var c = [0,0,0]
      for(var s=-1; s<=1; s+=2) {
        indices.push(ptr,   ptr+2, ptr+1,
                     ptr+1, ptr+2, ptr+3)
        x[d] = s
        c[d] = s
        for(var i=-1; i<=1; i+=2) {
          x[u] = i
          for(var j=-1; j<=1; j+=2) {
            x[v] = j
            vertices.push(x[0], x[1], x[2],
                          c[0], c[1], c[2])
            ptr += 1
          }
        }
        //Swap u and v
        var tt = u
        u = v
        v = tt
      }
    }
  
    //Allocate buffer and vertex array
    var buffer = createBuffer(gl, new Float32Array(vertices))
    var elements = createBuffer(gl, new Uint16Array(indices), gl.ELEMENT_ARRAY_BUFFER)
    var vao = createVAO(gl, [
        {
          buffer: buffer,
          type: gl.FLOAT,
          size: 3,
          offset: 0,
          stride: 24
        },
        {
          buffer: buffer,
          type: gl.FLOAT,
          size: 3,
          offset: 12,
          stride: 24
        }
      ], elements)
  
    //Create shader object
    var shader = createShader(gl)
    shader.attributes.position.location = 0
    shader.attributes.normal.location = 1
  
    return new BackgroundCube(gl, buffer, vao, shader)
  }
  
  },{"./shaders":254,"gl-buffer":258,"gl-vao":332}],252:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = getCubeEdges
  
  var bits      = _dereq_('bit-twiddle')
  var multiply  = _dereq_('gl-mat4/multiply')
  var splitPoly = _dereq_('split-polygon')
  var orient    = _dereq_('robust-orientation')
  
  var mvp        = new Array(16)
  var pCubeVerts = new Array(8)
  var cubeVerts  = new Array(8)
  var x          = new Array(3)
  var zero3      = [0,0,0]
  
  ;(function() {
    for(var i=0; i<8; ++i) {
      pCubeVerts[i] =[1,1,1,1]
      cubeVerts[i] = [1,1,1]
    }
  })()
  
  
  function transformHg(result, x, mat) {
    for(var i=0; i<4; ++i) {
      result[i] = mat[12+i]
      for(var j=0; j<3; ++j) {
        result[i] += x[j]*mat[4*j+i]
      }
    }
  }
  
  var FRUSTUM_PLANES = [
    [ 0, 0, 1, 0, 0],
    [ 0, 0,-1, 1, 0],
    [ 0,-1, 0, 1, 0],
    [ 0, 1, 0, 1, 0],
    [-1, 0, 0, 1, 0],
    [ 1, 0, 0, 1, 0]
  ]
  
  function polygonArea(p) {
    for(var i=0; i<FRUSTUM_PLANES.length; ++i) {
      p = splitPoly.positive(p, FRUSTUM_PLANES[i])
      if(p.length < 3) {
        return 0
      }
    }
  
    var base = p[0]
    var ax = base[0] / base[3]
    var ay = base[1] / base[3]
    var area = 0.0
    for(var i=1; i+1<p.length; ++i) {
      var b = p[i]
      var c = p[i+1]
  
      var bx = b[0]/b[3]
      var by = b[1]/b[3]
      var cx = c[0]/c[3]
      var cy = c[1]/c[3]
  
      var ux = bx - ax
      var uy = by - ay
  
      var vx = cx - ax
      var vy = cy - ay
  
      area += Math.abs(ux * vy - uy * vx)
    }
  
    return area
  }
  
  var CUBE_EDGES = [1,1,1]
  var CUBE_AXIS  = [0,0,0]
  var CUBE_RESULT = {
    cubeEdges: CUBE_EDGES,
    axis: CUBE_AXIS
  }
  
  function getCubeEdges(model, view, projection, bounds, ortho) {
  
    //Concatenate matrices
    multiply(mvp, view, model)
    multiply(mvp, projection, mvp)
  
    //First project cube vertices
    var ptr = 0
    for(var i=0; i<2; ++i) {
      x[2] = bounds[i][2]
      for(var j=0; j<2; ++j) {
        x[1] = bounds[j][1]
        for(var k=0; k<2; ++k) {
          x[0] = bounds[k][0]
          transformHg(pCubeVerts[ptr], x, mvp)
          ptr += 1
        }
      }
    }
  
    //Classify camera against cube faces
    var closest = -1
  
    for(var i=0; i<8; ++i) {
      var w = pCubeVerts[i][3]
      for(var l=0; l<3; ++l) {
        cubeVerts[i][l] = pCubeVerts[i][l] / w
      }
  
      if(ortho) cubeVerts[i][2] *= -1;
  
      if(w < 0) {
        if(closest < 0) {
          closest = i
        } else if(cubeVerts[i][2] < cubeVerts[closest][2]) {
          closest = i
        }
      }
    }
  
    if(closest < 0) {
      closest = 0
      for(var d=0; d<3; ++d) {
        var u = (d+2) % 3
        var v = (d+1) % 3
        var o0 = -1
        var o1 = -1
        for(var s=0; s<2; ++s) {
          var f0 = (s<<d)
          var f1 = f0 + (s << u) + ((1-s) << v)
          var f2 = f0 + ((1-s) << u) + (s << v)
          if(orient(cubeVerts[f0], cubeVerts[f1], cubeVerts[f2], zero3) < 0) {
            continue
          }
          if(s) {
            o0 = 1
          } else {
            o1 = 1
          }
        }
        if(o0 < 0 || o1 < 0) {
          if(o1 > o0) {
            closest |= 1<<d
          }
          continue
        }
        for(var s=0; s<2; ++s) {
          var f0 = (s<<d)
          var f1 = f0 + (s << u) + ((1-s) << v)
          var f2 = f0 + ((1-s) << u) + (s << v)
          var o = polygonArea([
              pCubeVerts[f0],
              pCubeVerts[f1],
              pCubeVerts[f2],
              pCubeVerts[f0+(1<<u)+(1<<v)]])
          if(s) {
            o0 = o
          } else {
            o1 = o
          }
        }
        if(o1 > o0) {
          closest |= 1<<d
          continue
        }
      }
    }
  
    var farthest = 7^closest
  
    //Find lowest vertex which is not closest closest
    var bottom = -1
    for(var i=0; i<8; ++i) {
      if(i === closest || i === farthest) {
        continue
      }
      if(bottom < 0) {
        bottom = i
      } else if(cubeVerts[bottom][1] > cubeVerts[i][1]) {
        bottom = i
      }
    }
  
    //Find left/right neighbors of bottom vertex
    var left = -1
    for(var i=0; i<3; ++i) {
      var idx = bottom ^ (1<<i)
      if(idx === closest || idx === farthest) {
        continue
      }
      if(left < 0) {
        left = idx
      }
      var v = cubeVerts[idx]
      if(v[0] < cubeVerts[left][0]) {
        left = idx
      }
    }
    var right = -1
    for(var i=0; i<3; ++i) {
      var idx = bottom ^ (1<<i)
      if(idx === closest || idx === farthest || idx === left) {
        continue
      }
      if(right < 0) {
        right = idx
      }
      var v = cubeVerts[idx]
      if(v[0] > cubeVerts[right][0]) {
        right = idx
      }
    }
  
    //Determine edge axis coordinates
    var cubeEdges = CUBE_EDGES
    cubeEdges[0] = cubeEdges[1] = cubeEdges[2] = 0
    cubeEdges[bits.log2(left^bottom)] = bottom&left
    cubeEdges[bits.log2(bottom^right)] = bottom&right
    var top = right ^ 7
    if(top === closest || top === farthest) {
      top = left ^ 7
      cubeEdges[bits.log2(right^top)] = top&right
    } else {
      cubeEdges[bits.log2(left^top)] = top&left
    }
  
    //Determine visible faces
    var axis = CUBE_AXIS
    var cutCorner = closest
    for(var d=0; d<3; ++d) {
      if(cutCorner & (1<<d)) {
        axis[d] = -1
      } else {
        axis[d] = 1
      }
    }
  
    //Return result
    return CUBE_RESULT
  }
  },{"bit-twiddle":97,"gl-mat4/multiply":280,"robust-orientation":520,"split-polygon":538}],253:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports    = createLines
  
  var createBuffer  = _dereq_('gl-buffer')
  var createVAO     = _dereq_('gl-vao')
  var createShader  = _dereq_('./shaders').line
  
  var MAJOR_AXIS = [0,0,0]
  var MINOR_AXIS = [0,0,0]
  var SCREEN_AXIS = [0,0,0]
  var OFFSET_VEC = [0,0,0]
  var SHAPE = [1,1]
  
  function zeroVec(a) {
    a[0] = a[1] = a[2] = 0
    return a
  }
  
  function copyVec(a,b) {
    a[0] = b[0]
    a[1] = b[1]
    a[2] = b[2]
    return a
  }
  
  function Lines(gl, vertBuffer, vao, shader, tickCount, tickOffset, gridCount, gridOffset) {
    this.gl         = gl
    this.vertBuffer = vertBuffer
    this.vao        = vao
    this.shader     = shader
    this.tickCount  = tickCount
    this.tickOffset = tickOffset
    this.gridCount  = gridCount
    this.gridOffset = gridOffset
  }
  
  var proto = Lines.prototype
  
  proto.bind = function(model, view, projection) {
    this.shader.bind()
    this.shader.uniforms.model = model
    this.shader.uniforms.view = view
    this.shader.uniforms.projection = projection
  
    SHAPE[0] = this.gl.drawingBufferWidth
    SHAPE[1] = this.gl.drawingBufferHeight
  
    this.shader.uniforms.screenShape = SHAPE
    this.vao.bind()
  }
  
  proto.unbind = function() {
    this.vao.unbind()
  }
  
  proto.drawAxisLine = function(j, bounds, offset, color, lineWidth) {
    var minorAxis = zeroVec(MINOR_AXIS)
    this.shader.uniforms.majorAxis = MINOR_AXIS
  
    minorAxis[j] = bounds[1][j] - bounds[0][j]
    this.shader.uniforms.minorAxis = minorAxis
  
    var noffset = copyVec(OFFSET_VEC, offset)
    noffset[j] += bounds[0][j]
    this.shader.uniforms.offset = noffset
  
    this.shader.uniforms.lineWidth = lineWidth
  
    this.shader.uniforms.color = color
  
    var screenAxis = zeroVec(SCREEN_AXIS)
    screenAxis[(j+2)%3] = 1
    this.shader.uniforms.screenAxis = screenAxis
    this.vao.draw(this.gl.TRIANGLES, 6)
  
    var screenAxis = zeroVec(SCREEN_AXIS)
    screenAxis[(j+1)%3] = 1
    this.shader.uniforms.screenAxis = screenAxis
    this.vao.draw(this.gl.TRIANGLES, 6)
  }
  
  proto.drawAxisTicks = function(j, offset, minorAxis, color, lineWidth) {
    if(!this.tickCount[j]) {
      return
    }
  
    var majorAxis = zeroVec(MAJOR_AXIS)
    majorAxis[j]  = 1
    this.shader.uniforms.majorAxis = majorAxis
    this.shader.uniforms.offset    = offset
    this.shader.uniforms.minorAxis = minorAxis
    this.shader.uniforms.color     = color
    this.shader.uniforms.lineWidth = lineWidth
  
    var screenAxis = zeroVec(SCREEN_AXIS)
    screenAxis[j] = 1
    this.shader.uniforms.screenAxis = screenAxis
    this.vao.draw(this.gl.TRIANGLES, this.tickCount[j], this.tickOffset[j])
  }
  
  
  proto.drawGrid = function(i, j, bounds, offset, color, lineWidth) {
    if(!this.gridCount[i]) {
      return
    }
  
    var minorAxis = zeroVec(MINOR_AXIS)
    minorAxis[j]  = bounds[1][j] - bounds[0][j]
    this.shader.uniforms.minorAxis = minorAxis
  
    var noffset = copyVec(OFFSET_VEC, offset)
    noffset[j] += bounds[0][j]
    this.shader.uniforms.offset = noffset
  
    var majorAxis = zeroVec(MAJOR_AXIS)
    majorAxis[i]  = 1
    this.shader.uniforms.majorAxis = majorAxis
  
    var screenAxis = zeroVec(SCREEN_AXIS)
    screenAxis[i] = 1
    this.shader.uniforms.screenAxis = screenAxis
    this.shader.uniforms.lineWidth = lineWidth
  
    this.shader.uniforms.color = color
    this.vao.draw(this.gl.TRIANGLES, this.gridCount[i], this.gridOffset[i])
  }
  
  proto.drawZero = function(j, i, bounds, offset, color, lineWidth) {
    var minorAxis = zeroVec(MINOR_AXIS)
    this.shader.uniforms.majorAxis = minorAxis
  
    minorAxis[j] = bounds[1][j] - bounds[0][j]
    this.shader.uniforms.minorAxis = minorAxis
  
    var noffset = copyVec(OFFSET_VEC, offset)
    noffset[j] += bounds[0][j]
    this.shader.uniforms.offset = noffset
  
    var screenAxis = zeroVec(SCREEN_AXIS)
    screenAxis[i] = 1
    this.shader.uniforms.screenAxis = screenAxis
    this.shader.uniforms.lineWidth = lineWidth
  
    this.shader.uniforms.color = color
    this.vao.draw(this.gl.TRIANGLES, 6)
  }
  
  proto.dispose = function() {
    this.vao.dispose()
    this.vertBuffer.dispose()
    this.shader.dispose()
  }
  
  function createLines(gl, bounds, ticks) {
    var vertices    = []
    var tickOffset  = [0,0,0]
    var tickCount   = [0,0,0]
  
    //Create grid lines for each axis/direction
    var gridOffset = [0,0,0]
    var gridCount  = [0,0,0]
  
    //Add zero line
    vertices.push(
      0,0,1,   0,1,1,   0,0,-1,
      0,0,-1,  0,1,1,   0,1,-1)
  
    for(var i=0; i<3; ++i) {
      //Axis tick marks
      var start = ((vertices.length / 3)|0)
      for(var j=0; j<ticks[i].length; ++j) {
        var x = +ticks[i][j].x
        vertices.push(
          x,0,1,   x,1,1,   x,0,-1,
          x,0,-1,  x,1,1,   x,1,-1)
      }
      var end = ((vertices.length / 3)|0)
      tickOffset[i] = start
      tickCount[i]  = end - start
  
      //Grid lines
      var start = ((vertices.length / 3)|0)
      for(var k=0; k<ticks[i].length; ++k) {
        var x = +ticks[i][k].x
        vertices.push(
          x,0,1,   x,1,1,   x,0,-1,
          x,0,-1,  x,1,1,   x,1,-1)
      }
      var end = ((vertices.length / 3)|0)
      gridOffset[i] = start
      gridCount[i]  = end - start
    }
  
    //Create cube VAO
    var vertBuf = createBuffer(gl, new Float32Array(vertices))
    var vao = createVAO(gl, [
      { "buffer": vertBuf,
        "type": gl.FLOAT,
        "size": 3,
        "stride": 0,
        "offset": 0
      }
    ])
    var shader = createShader(gl)
    shader.attributes.position.location = 0
    return new Lines(gl, vertBuf, vao, shader, tickCount, tickOffset, gridCount, gridOffset)
  }
  
  },{"./shaders":254,"gl-buffer":258,"gl-vao":332}],254:[function(_dereq_,module,exports){
  'use strict'
  
  var glslify = _dereq_('glslify')
  var createShader = _dereq_('gl-shader')
  
  var lineVert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, majorAxis, minorAxis, screenAxis;\nuniform float lineWidth;\nuniform vec2 screenShape;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nvoid main() {\n  vec3 major = position.x * majorAxis;\n  vec3 minor = position.y * minorAxis;\n\n  vec3 vPosition = major + minor + offset;\n  vec3 pPosition = project(vPosition);\n  vec3 offset = project(vPosition + screenAxis * position.z);\n\n  vec2 screen = normalize((offset - pPosition).xy * screenShape) / screenShape;\n\n  gl_Position = vec4(pPosition + vec3(0.5 * screen * lineWidth, 0), 1.0);\n}\n"])
  var lineFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"])
  exports.line = function(gl) {
    return createShader(gl, lineVert, lineFrag, null, [
      {name: 'position', type: 'vec3'}
    ])
  }
  
  var textVert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\nuniform vec3 offset, axis, alignDir, alignOpt;\nuniform float scale, angle, pixelScale;\nuniform vec2 resolution;\n\nvec3 project(vec3 p) {\n  vec4 pp = projection * view * model * vec4(p, 1.0);\n  return pp.xyz / max(pp.w, 0.0001);\n}\n\nfloat computeViewAngle(vec3 a, vec3 b) {\n  vec3 A = project(a);\n  vec3 B = project(b);\n\n  return atan(\n    (B.y - A.y) * resolution.y,\n    (B.x - A.x) * resolution.x\n  );\n}\n\nconst float PI = 3.141592;\nconst float TWO_PI = 2.0 * PI;\nconst float HALF_PI = 0.5 * PI;\nconst float ONE_AND_HALF_PI = 1.5 * PI;\n\nint option = int(floor(alignOpt.x + 0.001));\nfloat hv_ratio =       alignOpt.y;\nbool enableAlign =    (alignOpt.z != 0.0);\n\nfloat mod_angle(float a) {\n  return mod(a, PI);\n}\n\nfloat positive_angle(float a) {\n  return mod_angle((a < 0.0) ?\n    a + TWO_PI :\n    a\n  );\n}\n\nfloat look_upwards(float a) {\n  float b = positive_angle(a);\n  return ((b > HALF_PI) && (b <= ONE_AND_HALF_PI)) ?\n    b - PI :\n    b;\n}\n\nfloat look_horizontal_or_vertical(float a, float ratio) {\n  // ratio controls the ratio between being horizontal to (vertical + horizontal)\n  // if ratio is set to 0.5 then it is 50%, 50%.\n  // when using a higher ratio e.g. 0.75 the result would\n  // likely be more horizontal than vertical.\n\n  float b = positive_angle(a);\n\n  return\n    (b < (      ratio) * HALF_PI) ? 0.0 :\n    (b < (2.0 - ratio) * HALF_PI) ? -HALF_PI :\n    (b < (2.0 + ratio) * HALF_PI) ? 0.0 :\n    (b < (4.0 - ratio) * HALF_PI) ? HALF_PI :\n                                    0.0;\n}\n\nfloat roundTo(float a, float b) {\n  return float(b * floor((a + 0.5 * b) / b));\n}\n\nfloat look_round_n_directions(float a, int n) {\n  float b = positive_angle(a);\n  float div = TWO_PI / float(n);\n  float c = roundTo(b, div);\n  return look_upwards(c);\n}\n\nfloat applyAlignOption(float rawAngle, float delta) {\n  return\n    (option >  2) ? look_round_n_directions(rawAngle + delta, option) :       // option 3-n: round to n directions\n    (option == 2) ? look_horizontal_or_vertical(rawAngle + delta, hv_ratio) : // horizontal or vertical\n    (option == 1) ? rawAngle + delta :       // use free angle, and flip to align with one direction of the axis\n    (option == 0) ? look_upwards(rawAngle) : // use free angle, and stay upwards\n    (option ==-1) ? 0.0 :                    // useful for backward compatibility, all texts remains horizontal\n                    rawAngle;                // otherwise return back raw input angle\n}\n\nbool isAxisTitle = (axis.x == 0.0) &&\n                   (axis.y == 0.0) &&\n                   (axis.z == 0.0);\n\nvoid main() {\n  //Compute world offset\n  float axisDistance = position.z;\n  vec3 dataPosition = axisDistance * axis + offset;\n\n  float beta = angle; // i.e. user defined attributes for each tick\n\n  float axisAngle;\n  float clipAngle;\n  float flip;\n\n  if (enableAlign) {\n    axisAngle = (isAxisTitle) ? HALF_PI :\n                      computeViewAngle(dataPosition, dataPosition + axis);\n    clipAngle = computeViewAngle(dataPosition, dataPosition + alignDir);\n\n    axisAngle += (sin(axisAngle) < 0.0) ? PI : 0.0;\n    clipAngle += (sin(clipAngle) < 0.0) ? PI : 0.0;\n\n    flip = (dot(vec2(cos(axisAngle), sin(axisAngle)),\n                vec2(sin(clipAngle),-cos(clipAngle))) > 0.0) ? 1.0 : 0.0;\n\n    beta += applyAlignOption(clipAngle, flip * PI);\n  }\n\n  //Compute plane offset\n  vec2 planeCoord = position.xy * pixelScale;\n\n  mat2 planeXform = scale * mat2(\n     cos(beta), sin(beta),\n    -sin(beta), cos(beta)\n  );\n\n  vec2 viewOffset = 2.0 * planeXform * planeCoord / resolution;\n\n  //Compute clip position\n  vec3 clipPosition = project(dataPosition);\n\n  //Apply text offset in clip coordinates\n  clipPosition += vec3(viewOffset, 0.0);\n\n  //Done\n  gl_Position = vec4(clipPosition, 1.0);\n}"])
  var textFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = color;\n}"])
  exports.text = function(gl) {
    return createShader(gl, textVert, textFrag, null, [
      {name: 'position', type: 'vec3'}
    ])
  }
  
  var bgVert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec3 normal;\n\nuniform mat4 model, view, projection;\nuniform vec3 enable;\nuniform vec3 bounds[2];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n\n  vec3 signAxis = sign(bounds[1] - bounds[0]);\n\n  vec3 realNormal = signAxis * normal;\n\n  if(dot(realNormal, enable) > 0.0) {\n    vec3 minRange = min(bounds[0], bounds[1]);\n    vec3 maxRange = max(bounds[0], bounds[1]);\n    vec3 nPosition = mix(minRange, maxRange, 0.5 * (position + 1.0));\n    gl_Position = projection * view * model * vec4(nPosition, 1.0);\n  } else {\n    gl_Position = vec4(0,0,0,0);\n  }\n\n  colorChannel = abs(realNormal);\n}"])
  var bgFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec4 colors[3];\n\nvarying vec3 colorChannel;\n\nvoid main() {\n  gl_FragColor = colorChannel.x * colors[0] +\n                 colorChannel.y * colors[1] +\n                 colorChannel.z * colors[2];\n}"])
  exports.bg = function(gl) {
    return createShader(gl, bgVert, bgFrag, null, [
      {name: 'position', type: 'vec3'},
      {name: 'normal', type: 'vec3'}
    ])
  }
  
  },{"gl-shader":312,"glslify":413}],255:[function(_dereq_,module,exports){
  (function (process){
  "use strict"
  
  module.exports = createTextSprites
  
  var createBuffer  = _dereq_('gl-buffer')
  var createVAO     = _dereq_('gl-vao')
  var vectorizeText = _dereq_('vectorize-text')
  var createShader  = _dereq_('./shaders').text
  
  var globals = window || process.global || {}
  var __TEXT_CACHE  = globals.__TEXT_CACHE || {}
  globals.__TEXT_CACHE = {}
  
  //Vertex buffer format for text is:
  //
  /// [x,y,z] = Spatial coordinate
  //
  
  var VERTEX_SIZE = 3
  
  function TextSprites(
    gl,
    shader,
    buffer,
    vao) {
    this.gl           = gl
    this.shader       = shader
    this.buffer       = buffer
    this.vao          = vao
    this.tickOffset   =
    this.tickCount    =
    this.labelOffset  =
    this.labelCount   = null
  }
  
  var proto = TextSprites.prototype
  
  //Bind textures for rendering
  var SHAPE = [0,0]
  proto.bind = function(model, view, projection, pixelScale) {
    this.vao.bind()
    this.shader.bind()
    var uniforms = this.shader.uniforms
    uniforms.model = model
    uniforms.view = view
    uniforms.projection = projection
    uniforms.pixelScale = pixelScale
    SHAPE[0] = this.gl.drawingBufferWidth
    SHAPE[1] = this.gl.drawingBufferHeight
    this.shader.uniforms.resolution = SHAPE
  }
  
  proto.unbind = function() {
    this.vao.unbind()
  }
  
  proto.update = function(bounds, labels, labelFont, ticks, tickFont) {
    var data = []
  
    function addItem(t, text, font, size, lineSpacing, styletags) {
      var fontcache = __TEXT_CACHE[font]
      if(!fontcache) {
        fontcache = __TEXT_CACHE[font] = {}
      }
      var mesh = fontcache[text]
      if(!mesh) {
        mesh = fontcache[text] = tryVectorizeText(text, {
          triangles: true,
          font: font,
          textAlign: 'center',
          textBaseline: 'middle',
          lineSpacing: lineSpacing,
          styletags: styletags
        })
      }
      var scale = (size || 12) / 12
      var positions = mesh.positions
      var cells = mesh.cells
      for(var i=0, nc=cells.length; i<nc; ++i) {
        var c = cells[i]
        for(var j=2; j>=0; --j) {
          var p = positions[c[j]]
          data.push(scale*p[0], -scale*p[1], t)
        }
      }
    }
  
    //Generate sprites for all 3 axes, store data in texture atlases
    var tickOffset  = [0,0,0]
    var tickCount   = [0,0,0]
    var labelOffset = [0,0,0]
    var labelCount  = [0,0,0]
    var lineSpacing = 1.25
    var styletags = {
      breaklines:true,
      bolds: true,
      italics: true,
      subscripts:true,
      superscripts:true
    }
    for(var d=0; d<3; ++d) {
  
      //Generate label
      labelOffset[d] = (data.length/VERTEX_SIZE)|0
      addItem(
        0.5*(bounds[0][d]+bounds[1][d]),
        labels[d],
        labelFont[d],
        12, // labelFontSize
        lineSpacing,
        styletags
      )
      labelCount[d] = ((data.length/VERTEX_SIZE)|0) - labelOffset[d]
  
      //Generate sprites for tick marks
      tickOffset[d] = (data.length/VERTEX_SIZE)|0
      for(var i=0; i<ticks[d].length; ++i) {
        if(!ticks[d][i].text) {
          continue
        }
        addItem(
          ticks[d][i].x,
          ticks[d][i].text,
          ticks[d][i].font || tickFont,
          ticks[d][i].fontSize || 12,
          lineSpacing,
          styletags
        )
      }
      tickCount[d] = ((data.length/VERTEX_SIZE)|0) - tickOffset[d]
    }
  
    this.buffer.update(data)
    this.tickOffset = tickOffset
    this.tickCount = tickCount
    this.labelOffset = labelOffset
    this.labelCount = labelCount
  }
  
  //Draws the tick marks for an axis
  proto.drawTicks = function(d, scale, angle, offset, color, axis, alignDir, alignOpt) {
    if(!this.tickCount[d]) {
      return
    }
  
    this.shader.uniforms.axis = axis
    this.shader.uniforms.color = color
    this.shader.uniforms.angle = angle
    this.shader.uniforms.scale = scale
    this.shader.uniforms.offset = offset
    this.shader.uniforms.alignDir = alignDir
    this.shader.uniforms.alignOpt = alignOpt
    this.vao.draw(this.gl.TRIANGLES, this.tickCount[d], this.tickOffset[d])
  }
  
  //Draws the text label for an axis
  proto.drawLabel = function(d, scale, angle, offset, color, axis, alignDir, alignOpt) {
    if(!this.labelCount[d]) {
      return
    }
  
    this.shader.uniforms.axis = axis
    this.shader.uniforms.color = color
    this.shader.uniforms.angle = angle
    this.shader.uniforms.scale = scale
    this.shader.uniforms.offset = offset
    this.shader.uniforms.alignDir = alignDir
    this.shader.uniforms.alignOpt = alignOpt
    this.vao.draw(this.gl.TRIANGLES, this.labelCount[d], this.labelOffset[d])
  }
  
  //Releases all resources attached to this object
  proto.dispose = function() {
    this.shader.dispose()
    this.vao.dispose()
    this.buffer.dispose()
  }
  
  function tryVectorizeText(text, options) {
    try {
      return vectorizeText(text, options)
    } catch(e) {
      console.warn('error vectorizing text:"' + text + '" error:', e)
      return {
        cells: [],
        positions: []
      }
    }
  }
  
  function createTextSprites(
      gl,
      bounds,
      labels,
      labelFont,
      ticks,
      tickFont) {
  
    var buffer = createBuffer(gl)
    var vao = createVAO(gl, [
      { "buffer": buffer,
        "size": 3
      }
    ])
  
    var shader = createShader(gl)
    shader.attributes.position.location = 0
  
    var result = new TextSprites(
      gl,
      shader,
      buffer,
      vao)
  
    result.update(bounds, labels, labelFont, ticks, tickFont)
  
    return result
  }
  
  }).call(this,_dereq_('_process'))
  },{"./shaders":254,"_process":500,"gl-buffer":258,"gl-vao":332,"vectorize-text":572}],256:[function(_dereq_,module,exports){
  'use strict'
  
  exports.create   = defaultTicks
  exports.equal    = ticksEqual
  
  function prettyPrint(spacing, i) {
    var stepStr = spacing + ""
    var u = stepStr.indexOf(".")
    var sigFigs = 0
    if(u >= 0) {
      sigFigs = stepStr.length - u - 1
    }
    var shift = Math.pow(10, sigFigs)
    var x = Math.round(spacing * i * shift)
    var xstr = x + ""
    if(xstr.indexOf("e") >= 0) {
      return xstr
    }
    var xi = x / shift, xf = x % shift
    if(x < 0) {
      xi = -Math.ceil(xi)|0
      xf = (-xf)|0
    } else {
      xi = Math.floor(xi)|0
      xf = xf|0
    }
    var xis = "" + xi 
    if(x < 0) {
      xis = "-" + xis
    }
    if(sigFigs) {
      var xs = "" + xf
      while(xs.length < sigFigs) {
        xs = "0" + xs
      }
      return xis + "." + xs
    } else {
      return xis
    }
  }
  
  function defaultTicks(bounds, tickSpacing) {
    var array = []
    for(var d=0; d<3; ++d) {
      var ticks = []
      var m = 0.5*(bounds[0][d]+bounds[1][d])
      for(var t=0; t*tickSpacing[d]<=bounds[1][d]; ++t) {
        ticks.push({x: t*tickSpacing[d], text: prettyPrint(tickSpacing[d], t)})
      }
      for(var t=-1; t*tickSpacing[d]>=bounds[0][d]; --t) {
        ticks.push({x: t*tickSpacing[d], text: prettyPrint(tickSpacing[d], t)})
      }
      array.push(ticks)
    }
    return array
  }
  
  function ticksEqual(ticksA, ticksB) {
    for(var i=0; i<3; ++i) {
      if(ticksA[i].length !== ticksB[i].length) {
        return false
      }
      for(var j=0; j<ticksA[i].length; ++j) {
        var a = ticksA[i][j]
        var b = ticksB[i][j]
        if(
          a.x !== b.x ||
          a.text !== b.text ||
          a.font !== b.font ||
          a.fontColor !== b.fontColor ||
          a.fontSize !== b.fontSize ||
          a.dx !== b.dx ||
          a.dy !== b.dy
        ) {
          return false
        }
      }
    }
    return true
  }
  },{}],257:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = axesProperties
  
  var getPlanes   = _dereq_("extract-frustum-planes")
  var splitPoly   = _dereq_("split-polygon")
  var cubeParams  = _dereq_("./lib/cube.js")
  var m4mul       = _dereq_("gl-mat4/multiply")
  var m4transpose = _dereq_("gl-mat4/transpose")
  var v4transformMat4 = _dereq_("gl-vec4/transformMat4")
  
  var identity    = new Float32Array([
      1, 0, 0, 0,
      0, 1, 0, 0,
      0, 0, 1, 0,
      0, 0, 0, 1
    ])
  
  var mvp         = new Float32Array(16)
  
  function AxesRange3D(lo, hi, pixelsPerDataUnit) {
    this.lo = lo
    this.hi = hi
    this.pixelsPerDataUnit = pixelsPerDataUnit
  }
  
  var SCRATCH_P = [0,0,0,1]
  var SCRATCH_Q = [0,0,0,1]
  
  function gradient(result, M, v, width, height) {
    for(var i=0; i<3; ++i) {
      var p = SCRATCH_P
      var q = SCRATCH_Q
      for(var j=0; j<3; ++j) {
        q[j] = p[j] = v[j]
      }
      q[3] = p[3] = 1
  
      q[i] += 1
      v4transformMat4(q, q, M)
      if(q[3] < 0) {
        result[i] = Infinity
      }
  
      p[i] -= 1
      v4transformMat4(p, p, M)
      if(p[3] < 0) {
        result[i] = Infinity
      }
  
      var dx = (p[0]/p[3] - q[0]/q[3]) * width
      var dy = (p[1]/p[3] - q[1]/q[3]) * height
  
      result[i] = 0.25 * Math.sqrt(dx*dx + dy*dy)
    }
    return result
  }
  
  var RANGES = [
    new AxesRange3D(Infinity, -Infinity, Infinity),
    new AxesRange3D(Infinity, -Infinity, Infinity),
    new AxesRange3D(Infinity, -Infinity, Infinity)
  ]
  
  var SCRATCH_X = [0,0,0]
  
  function axesProperties(axes, camera, width, height, params) {
    var model       = camera.model || identity
    var view        = camera.view || identity
    var projection  = camera.projection || identity
    var isOrtho     = camera._ortho || false
    var bounds      = axes.bounds
    var params      = params || cubeParams(model, view, projection, bounds, isOrtho)
    var axis        = params.axis
  
    m4mul(mvp, view, model)
    m4mul(mvp, projection, mvp)
  
    //Calculate the following properties for each axis:
    //
    // * lo - start of visible range for each axis in tick coordinates
    // * hi - end of visible range for each axis in tick coordinates
    // * ticksPerPixel - pixel density of tick marks for the axis
    //
    var ranges = RANGES
    for(var i=0; i<3; ++i) {
      ranges[i].lo = Infinity
      ranges[i].hi = -Infinity
      ranges[i].pixelsPerDataUnit = Infinity
    }
  
    //Compute frustum planes, intersect with box
    var frustum = getPlanes(m4transpose(mvp, mvp))
    m4transpose(mvp, mvp)
  
    //Loop over vertices of viewable box
    for(var d=0; d<3; ++d) {
      var u = (d+1)%3
      var v = (d+2)%3
      var x = SCRATCH_X
  i_loop:
      for(var i=0; i<2; ++i) {
        var poly = []
  
        if((axis[d] < 0) === !!i) {
          continue
        }
  
        x[d] = bounds[i][d]
        for(var j=0; j<2; ++j) {
          x[u] = bounds[j^i][u]
          for(var k=0; k<2; ++k) {
            x[v] = bounds[k^j^i][v]
            poly.push(x.slice())
          }
        }
  
        var Q = (isOrtho) ? 5 : 4
        for(var j=Q; j===Q; ++j) { // Note: using only near plane here (& for orthographic projection we use the far).
          if(poly.length === 0) {
            continue i_loop
          }
          poly = splitPoly.positive(poly, frustum[j])
        }
  
        //Loop over vertices of polygon to find extremal points
        for(var j=0; j<poly.length; ++j) {
          var v = poly[j]
          var grad = gradient(SCRATCH_X, mvp, v, width, height)
          for(var k=0; k<3; ++k) {
            ranges[k].lo = Math.min(ranges[k].lo, v[k])
            ranges[k].hi = Math.max(ranges[k].hi, v[k])
            if(k !== d) {
              ranges[k].pixelsPerDataUnit = Math.min(ranges[k].pixelsPerDataUnit, Math.abs(grad[k]))
            }
          }
        }
      }
    }
  
    return ranges
  }
  
  },{"./lib/cube.js":252,"extract-frustum-planes":240,"gl-mat4/multiply":280,"gl-mat4/transpose":289,"gl-vec4/transformMat4":403,"split-polygon":538}],258:[function(_dereq_,module,exports){
  "use strict"
  
  var pool = _dereq_("typedarray-pool")
  var ops = _dereq_("ndarray-ops")
  var ndarray = _dereq_("ndarray")
  
  var SUPPORTED_TYPES = [
    "uint8",
    "uint8_clamped",
    "uint16",
    "uint32",
    "int8",
    "int16",
    "int32",
    "float32" ]
  
  function GLBuffer(gl, type, handle, length, usage) {
    this.gl = gl
    this.type = type
    this.handle = handle
    this.length = length
    this.usage = usage
  }
  
  var proto = GLBuffer.prototype
  
  proto.bind = function() {
    this.gl.bindBuffer(this.type, this.handle)
  }
  
  proto.unbind = function() {
    this.gl.bindBuffer(this.type, null)
  }
  
  proto.dispose = function() {
    this.gl.deleteBuffer(this.handle)
  }
  
  function updateTypeArray(gl, type, len, usage, data, offset) {
    var dataLen = data.length * data.BYTES_PER_ELEMENT
    if(offset < 0) {
      gl.bufferData(type, data, usage)
      return dataLen
    }
    if(dataLen + offset > len) {
      throw new Error("gl-buffer: If resizing buffer, must not specify offset")
    }
    gl.bufferSubData(type, offset, data)
    return len
  }
  
  function makeScratchTypeArray(array, dtype) {
    var res = pool.malloc(array.length, dtype)
    var n = array.length
    for(var i=0; i<n; ++i) {
      res[i] = array[i]
    }
    return res
  }
  
  function isPacked(shape, stride) {
    var n = 1
    for(var i=stride.length-1; i>=0; --i) {
      if(stride[i] !== n) {
        return false
      }
      n *= shape[i]
    }
    return true
  }
  
  proto.update = function(array, offset) {
    if(typeof offset !== "number") {
      offset = -1
    }
    this.bind()
    if(typeof array === "object" && typeof array.shape !== "undefined") { //ndarray
      var dtype = array.dtype
      if(SUPPORTED_TYPES.indexOf(dtype) < 0) {
        dtype = "float32"
      }
      if(this.type === this.gl.ELEMENT_ARRAY_BUFFER) {
        var ext = gl.getExtension('OES_element_index_uint')
        if(ext && dtype !== "uint16") {
          dtype = "uint32"
        } else {
          dtype = "uint16"
        }
      }
      if(dtype === array.dtype && isPacked(array.shape, array.stride)) {
        if(array.offset === 0 && array.data.length === array.shape[0]) {
          this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, array.data, offset)
        } else {
          this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, array.data.subarray(array.offset, array.shape[0]), offset)
        }
      } else {
        var tmp = pool.malloc(array.size, dtype)
        var ndt = ndarray(tmp, array.shape)
        ops.assign(ndt, array)
        if(offset < 0) {
          this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, tmp, offset)
        } else {
          this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, tmp.subarray(0, array.size), offset)
        }
        pool.free(tmp)
      }
    } else if(Array.isArray(array)) { //Vanilla array
      var t
      if(this.type === this.gl.ELEMENT_ARRAY_BUFFER) {
        t = makeScratchTypeArray(array, "uint16")
      } else {
        t = makeScratchTypeArray(array, "float32")
      }
      if(offset < 0) {
        this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, t, offset)
      } else {
        this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, t.subarray(0, array.length), offset)
      }
      pool.free(t)
    } else if(typeof array === "object" && typeof array.length === "number") { //Typed array
      this.length = updateTypeArray(this.gl, this.type, this.length, this.usage, array, offset)
    } else if(typeof array === "number" || array === undefined) { //Number/default
      if(offset >= 0) {
        throw new Error("gl-buffer: Cannot specify offset when resizing buffer")
      }
      array = array | 0
      if(array <= 0) {
        array = 1
      }
      this.gl.bufferData(this.type, array|0, this.usage)
      this.length = array
    } else { //Error, case should not happen
      throw new Error("gl-buffer: Invalid data type")
    }
  }
  
  function createBuffer(gl, data, type, usage) {
    type = type || gl.ARRAY_BUFFER
    usage = usage || gl.DYNAMIC_DRAW
    if(type !== gl.ARRAY_BUFFER && type !== gl.ELEMENT_ARRAY_BUFFER) {
      throw new Error("gl-buffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER")
    }
    if(usage !== gl.DYNAMIC_DRAW && usage !== gl.STATIC_DRAW && usage !== gl.STREAM_DRAW) {
      throw new Error("gl-buffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW")
    }
    var handle = gl.createBuffer()
    var result = new GLBuffer(gl, type, handle, 0, usage)
    result.update(data)
    return result
  }
  
  module.exports = createBuffer
  
  },{"ndarray":469,"ndarray-ops":464,"typedarray-pool":567}],259:[function(_dereq_,module,exports){
  "use strict";
  
  var vec3 = _dereq_('gl-vec3');
  
  module.exports = function(vectorfield, bounds) {
    var positions = vectorfield.positions;
    var vectors = vectorfield.vectors;
    var geo = {
      positions: [],
      vertexIntensity: [],
      vertexIntensityBounds: vectorfield.vertexIntensityBounds,
      vectors: [],
      cells: [],
      coneOffset: vectorfield.coneOffset,
      colormap: vectorfield.colormap
    };
  
    if (vectorfield.positions.length === 0) {
      if (bounds) {
        bounds[0] = [0,0,0];
        bounds[1] = [0,0,0];
      }
      return geo;
    }
  
    // Compute bounding box for the dataset.
    // Compute maximum velocity for the dataset to use for scaling the cones.
    var maxNorm = 0;
    var minX = Infinity, maxX = -Infinity;
    var minY = Infinity, maxY = -Infinity;
    var minZ = Infinity, maxZ = -Infinity;
    var p2 = null;
    var u2 = null;
    var positionVectors = [];
    var vectorScale = Infinity;
    var skipIt = false;
    for (var i = 0; i < positions.length; i++) {
      var p = positions[i];
      minX = Math.min(p[0], minX);
      maxX = Math.max(p[0], maxX);
      minY = Math.min(p[1], minY);
      maxY = Math.max(p[1], maxY);
      minZ = Math.min(p[2], minZ);
      maxZ = Math.max(p[2], maxZ);
      var u = vectors[i];
  
      if (vec3.length(u) > maxNorm) {
        maxNorm = vec3.length(u);
      }
      if (i) {
        // Find vector scale [w/ units of time] using "successive" positions
        // (not "adjacent" with would be O(n^2)),
        //
        // The vector scale corresponds to the minimum "time" to travel across two
        // two adjacent positions at the average velocity of those two adjacent positions
  
        var q = (2 * vec3.distance(p2, p) / (vec3.length(u2) + vec3.length(u)));
        if(q) {
          vectorScale = Math.min(vectorScale, q);
          skipIt = false;
        } else {
          skipIt = true;
        }
      }
      if(!skipIt) {
        p2 = p;
        u2 = u;
      }
      positionVectors.push(u);
    }
    var minV = [minX, minY, minZ];
    var maxV = [maxX, maxY, maxZ];
    if (bounds) {
      bounds[0] = minV;
      bounds[1] = maxV;
    }
    if (maxNorm === 0) {
      maxNorm = 1;
    }
  
    // Inverted max norm would map vector with norm maxNorm to 1 coord space units in length
    var invertedMaxNorm = 1 / maxNorm;
  
    if (!isFinite(vectorScale)) {
      vectorScale = 1.0;
    }
    geo.vectorScale = vectorScale;
  
    var coneScale = vectorfield.coneSize || 0.5;
  
    if (vectorfield.absoluteConeSize) {
      coneScale = vectorfield.absoluteConeSize * invertedMaxNorm;
    }
  
    geo.coneScale = coneScale;
  
    // Build the cone model.
    for (var i = 0, j = 0; i < positions.length; i++) {
      var p = positions[i];
      var x = p[0], y = p[1], z = p[2];
      var d = positionVectors[i];
      var intensity = vec3.length(d) * invertedMaxNorm;
      for (var k = 0, l = 8; k < l; k++) {
        geo.positions.push([x, y, z, j++]);
        geo.positions.push([x, y, z, j++]);
        geo.positions.push([x, y, z, j++]);
        geo.positions.push([x, y, z, j++]);
        geo.positions.push([x, y, z, j++]);
        geo.positions.push([x, y, z, j++]);
  
        geo.vectors.push(d);
        geo.vectors.push(d);
        geo.vectors.push(d);
        geo.vectors.push(d);
        geo.vectors.push(d);
        geo.vectors.push(d);
  
        geo.vertexIntensity.push(intensity, intensity, intensity);
        geo.vertexIntensity.push(intensity, intensity, intensity);
  
        var m = geo.positions.length;
        geo.cells.push([m-6, m-5, m-4], [m-3, m-2, m-1]);
      }
    }
  
    return geo;
  };
  
  var shaders = _dereq_('./lib/shaders');
  module.exports.createMesh = _dereq_('./create_mesh');
  module.exports.createConeMesh = function(gl, params) {
    return module.exports.createMesh(gl, params, {
      shaders: shaders,
      traceType: 'cone'
    });
  }
  
  },{"./create_mesh":260,"./lib/shaders":261,"gl-vec3":351}],260:[function(_dereq_,module,exports){
  'use strict'
  
  var createShader  = _dereq_('gl-shader')
  var createBuffer  = _dereq_('gl-buffer')
  var createVAO     = _dereq_('gl-vao')
  var createTexture = _dereq_('gl-texture2d')
  var multiply      = _dereq_('gl-mat4/multiply')
  var invert        = _dereq_('gl-mat4/invert')
  var ndarray       = _dereq_('ndarray')
  var colormap      = _dereq_('colormap')
  
  var IDENTITY = [
    1,0,0,0,
    0,1,0,0,
    0,0,1,0,
    0,0,0,1]
  
  function VectorMesh(gl
    , texture
    , triShader
    , pickShader
    , trianglePositions
    , triangleVectors
    , triangleIds
    , triangleColors
    , triangleUVs
    , triangleVAO
    , traceType) {
  
    this.gl                = gl
    this.pixelRatio         = 1
    this.cells             = []
    this.positions         = []
    this.intensity         = []
    this.texture           = texture
    this.dirty             = true
  
    this.triShader         = triShader
    this.pickShader        = pickShader
  
    this.trianglePositions = trianglePositions
    this.triangleVectors   = triangleVectors
    this.triangleColors    = triangleColors
    this.triangleUVs       = triangleUVs
    this.triangleIds       = triangleIds
    this.triangleVAO       = triangleVAO
    this.triangleCount     = 0
  
    this.pickId            = 1
    this.bounds            = [
      [ Infinity, Infinity, Infinity],
      [-Infinity,-Infinity,-Infinity] ]
    this.clipBounds        = [
      [-Infinity,-Infinity,-Infinity],
      [ Infinity, Infinity, Infinity] ]
  
    this.lightPosition = [1e5, 1e5, 0]
    this.ambientLight  = 0.8
    this.diffuseLight  = 0.8
    this.specularLight = 2.0
    this.roughness     = 0.5
    this.fresnel       = 1.5
  
    this.opacity       = 1
  
    this.traceType     = traceType
    this.tubeScale     = 1 // used in streamtube
    this.coneScale     = 2 // used in cone
    this.vectorScale   = 1 // used in cone
    this.coneOffset    = 0.25 // used in cone
  
    this._model       = IDENTITY
    this._view        = IDENTITY
    this._projection  = IDENTITY
    this._resolution  = [1,1]
  }
  
  var proto = VectorMesh.prototype
  
  proto.isOpaque = function() {
    return this.opacity >= 1
  }
  
  proto.isTransparent = function() {
    return this.opacity < 1
  }
  
  proto.pickSlots = 1
  
  proto.setPickBase = function(id) {
    this.pickId = id
  }
  
  function genColormap(param) {
    var colors = colormap({
        colormap: param
      , nshades:  256
      , format:  'rgba'
    })
  
    var result = new Uint8Array(256*4)
    for(var i=0; i<256; ++i) {
      var c = colors[i]
      for(var j=0; j<3; ++j) {
        result[4*i+j] = c[j]
      }
      result[4*i+3] = c[3]*255
    }
  
    return ndarray(result, [256,256,4], [4,0,1])
  }
  
  function takeZComponent(array) {
    var n = array.length
    var result = new Array(n)
    for(var i=0; i<n; ++i) {
      result[i] = array[i][2]
    }
    return result
  }
  
  proto.update = function(params) {
    params = params || {}
    var gl = this.gl
  
    this.dirty = true
  
    if('lightPosition' in params) {
      this.lightPosition = params.lightPosition
    }
    if('opacity' in params) {
      this.opacity = params.opacity
    }
    if('ambient' in params) {
      this.ambientLight  = params.ambient
    }
    if('diffuse' in params) {
      this.diffuseLight = params.diffuse
    }
    if('specular' in params) {
      this.specularLight = params.specular
    }
    if('roughness' in params) {
      this.roughness = params.roughness
    }
    if('fresnel' in params) {
      this.fresnel = params.fresnel
    }
  
    // use in streamtube
    if (params.tubeScale !== undefined) {
      this.tubeScale = params.tubeScale
    }
  
    // used in cone
    if (params.vectorScale !== undefined) {
      this.vectorScale = params.vectorScale
    }
    if (params.coneScale !== undefined) {
      this.coneScale = params.coneScale
    }
    if (params.coneOffset !== undefined) {
      this.coneOffset = params.coneOffset
    }
  
    if (params.colormap) {
      this.texture.shape = [256,256]
      this.texture.minFilter = gl.LINEAR_MIPMAP_LINEAR
      this.texture.magFilter = gl.LINEAR
      this.texture.setPixels(genColormap(params.colormap))
      this.texture.generateMipmap()
    }
  
    var cells = params.cells
    var positions = params.positions
    var vectors = params.vectors
  
    if(!positions || !cells || !vectors) {
      return
    }
  
    var tPos = []
    var tVec = []
    var tCol = []
    var tUVs = []
    var tIds = []
  
    //Save geometry data for picking calculations
    this.cells     = cells
    this.positions = positions
    this.vectors   = vectors
  
    //Compute colors
    var meshColor       = params.meshColor || [1,1,1,1]
  
    //UVs
    var vertexIntensity = params.vertexIntensity
  
    var intensityLo     = Infinity
    var intensityHi     = -Infinity
  
    if(vertexIntensity) {
      if(params.vertexIntensityBounds) {
        intensityLo = +params.vertexIntensityBounds[0]
        intensityHi = +params.vertexIntensityBounds[1]
      } else {
        for(var i=0; i<vertexIntensity.length; ++i) {
          var f = vertexIntensity[i]
          intensityLo = Math.min(intensityLo, f)
          intensityHi = Math.max(intensityHi, f)
        }
      }
    } else {
      for(var i=0; i<positions.length; ++i) {
        var f = positions[i][2]
        intensityLo = Math.min(intensityLo, f)
        intensityHi = Math.max(intensityHi, f)
      }
    }
  
    if(vertexIntensity) {
      this.intensity = vertexIntensity
    } else {
      this.intensity = takeZComponent(positions)
    }
  
    //Update bounds
    this.bounds       = [[Infinity,Infinity,Infinity], [-Infinity,-Infinity,-Infinity]]
    for(var i=0; i<positions.length; ++i) {
      var p = positions[i]
      for(var j=0; j<3; ++j) {
        if(isNaN(p[j]) || !isFinite(p[j])) {
          continue
        }
        this.bounds[0][j] = Math.min(this.bounds[0][j], p[j])
        this.bounds[1][j] = Math.max(this.bounds[1][j], p[j])
      }
    }
  
    //Pack cells into buffers
    var triangleCount = 0
  
  fill_loop:
    for(var i=0; i<cells.length; ++i) {
      var cell = cells[i]
      switch(cell.length) {
        case 3:
          //Check NaNs
          for(var j=0; j<3; ++j) {
            var v = cell[j]
            var p = positions[v]
            for(var k=0; k<3; ++k) {
              if(isNaN(p[k]) || !isFinite(p[k])) {
                continue fill_loop
              }
            }
          }
  
          for(var j=0; j<3; ++j) {
            var v = cell[2 - j]
  
            var p = positions[v]
            tPos.push(p[0], p[1], p[2], p[3])
  
            var w = vectors[v]
            tVec.push(w[0], w[1], w[2], w[3] || 0)
  
            var c = meshColor
            if(c.length === 3) {
              tCol.push(c[0], c[1], c[2], 1)
            } else {
              tCol.push(c[0], c[1], c[2], c[3])
            }
  
            var uv
            if(vertexIntensity) {
              uv = [
                (vertexIntensity[v] - intensityLo) /
                (intensityHi - intensityLo), 0]
            } else {
              uv = [
                (p[2] - intensityLo) /
                (intensityHi - intensityLo), 0]
            }
            tUVs.push(uv[0], uv[1])
  
            tIds.push(i)
          }
          triangleCount += 1
        break
  
        default:
        break
      }
    }
  
    this.triangleCount  = triangleCount
  
    this.trianglePositions.update(tPos)
    this.triangleVectors.update(tVec)
    this.triangleColors.update(tCol)
    this.triangleUVs.update(tUVs)
    this.triangleIds.update(new Uint32Array(tIds))
  }
  
  proto.drawTransparent = proto.draw = function(params) {
    params = params || {}
    var gl          = this.gl
    var model       = params.model      || IDENTITY
    var view        = params.view       || IDENTITY
    var projection  = params.projection || IDENTITY
  
    var clipBounds = [[-1e6,-1e6,-1e6],[1e6,1e6,1e6]]
    for(var i=0; i<3; ++i) {
      clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i])
      clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i])
    }
  
    var uniforms = {
      model:      model,
      view:       view,
      projection: projection,
      inverseModel: IDENTITY.slice(),
  
      clipBounds: clipBounds,
  
      kambient:   this.ambientLight,
      kdiffuse:   this.diffuseLight,
      kspecular:  this.specularLight,
      roughness:  this.roughness,
      fresnel:    this.fresnel,
  
      eyePosition:   [0,0,0],
      lightPosition: [0,0,0],
  
      opacity:  this.opacity,
  
      tubeScale: this.tubeScale,
  
      vectorScale: this.vectorScale,
      coneScale: this.coneScale,
      coneOffset: this.coneOffset,
  
      texture:    0
    }
  
    uniforms.inverseModel = invert(uniforms.inverseModel, uniforms.model)
  
    gl.disable(gl.CULL_FACE)
  
    this.texture.bind(0)
  
    var invCameraMatrix = new Array(16)
    multiply(invCameraMatrix, uniforms.view, uniforms.model)
    multiply(invCameraMatrix, uniforms.projection, invCameraMatrix)
    invert(invCameraMatrix, invCameraMatrix)
  
    for(var i=0; i<3; ++i) {
      uniforms.eyePosition[i] = invCameraMatrix[12+i] / invCameraMatrix[15]
    }
  
    var w = invCameraMatrix[15]
    for(var i=0; i<3; ++i) {
      w += this.lightPosition[i] * invCameraMatrix[4*i+3]
    }
    for(var i=0; i<3; ++i) {
      var s = invCameraMatrix[12+i]
      for(var j=0; j<3; ++j) {
        s += invCameraMatrix[4*j+i] * this.lightPosition[j]
      }
      uniforms.lightPosition[i] = s / w
    }
  
    if(this.triangleCount > 0) {
      var shader = this.triShader
      shader.bind()
      shader.uniforms = uniforms
  
      this.triangleVAO.bind()
      gl.drawArrays(gl.TRIANGLES, 0, this.triangleCount*3)
      this.triangleVAO.unbind()
    }
  }
  
  proto.drawPick = function(params) {
    params = params || {}
  
    var gl         = this.gl
  
    var model      = params.model      || IDENTITY
    var view       = params.view       || IDENTITY
    var projection = params.projection || IDENTITY
  
    var clipBounds = [[-1e6,-1e6,-1e6],[1e6,1e6,1e6]]
    for(var i=0; i<3; ++i) {
      clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i])
      clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i])
    }
  
    //Save camera parameters
    this._model      = [].slice.call(model)
    this._view       = [].slice.call(view)
    this._projection = [].slice.call(projection)
    this._resolution = [gl.drawingBufferWidth, gl.drawingBufferHeight]
  
    var uniforms = {
      model:      model,
      view:       view,
      projection: projection,
      clipBounds: clipBounds,
  
      tubeScale: this.tubeScale,
      vectorScale: this.vectorScale,
      coneScale: this.coneScale,
      coneOffset: this.coneOffset,
  
      pickId:     this.pickId / 255.0,
    }
  
    var shader = this.pickShader
    shader.bind()
    shader.uniforms = uniforms
  
    if(this.triangleCount > 0) {
      this.triangleVAO.bind()
      gl.drawArrays(gl.TRIANGLES, 0, this.triangleCount*3)
      this.triangleVAO.unbind()
    }
  }
  
  
  proto.pick = function(pickData) {
    if(!pickData) {
      return null
    }
    if(pickData.id !== this.pickId) {
      return null
    }
  
    var cellId    = pickData.value[0] + 256*pickData.value[1] + 65536*pickData.value[2]
    var cell      = this.cells[cellId]
    var pos =     this.positions[cell[1]].slice(0, 3)
  
    var result = {
      position: pos,
      dataCoordinate: pos,
      index: Math.floor(cell[1] / 48)
    }
  
  
    if(this.traceType === 'cone') {
      result.index = Math.floor(cell[1] / 48)
    } else if(this.traceType === 'streamtube') {
      result.intensity = this.intensity[cell[1]]
      result.velocity = this.vectors[cell[1]].slice(0, 3)
      result.divergence = this.vectors[cell[1]][3]
      result.index = cellId
    }
  
    return result
  }
  
  
  proto.dispose = function() {
    this.texture.dispose()
  
    this.triShader.dispose()
    this.pickShader.dispose()
  
    this.triangleVAO.dispose()
    this.trianglePositions.dispose()
    this.triangleVectors.dispose()
    this.triangleColors.dispose()
    this.triangleUVs.dispose()
    this.triangleIds.dispose()
  }
  
  function createMeshShader(gl, shaders) {
    var shader = createShader(gl,
      shaders.meshShader.vertex,
      shaders.meshShader.fragment,
      null,
      shaders.meshShader.attributes
    )
  
    shader.attributes.position.location = 0
    shader.attributes.color.location    = 2
    shader.attributes.uv.location       = 3
    shader.attributes.vector.location   = 4
    return shader
  }
  
  
  function createPickShader(gl, shaders) {
    var shader = createShader(gl,
      shaders.pickShader.vertex,
      shaders.pickShader.fragment,
      null,
      shaders.pickShader.attributes
    )
  
    shader.attributes.position.location = 0
    shader.attributes.id.location       = 1
    shader.attributes.vector.location   = 4
    return shader
  }
  
  
  function createVectorMesh(gl, params, opts) {
    var shaders = opts.shaders
  
    if (arguments.length === 1) {
      params = gl
      gl = params.gl
    }
  
  
    var triShader       = createMeshShader(gl, shaders)
    var pickShader      = createPickShader(gl, shaders)
    var meshTexture       = createTexture(gl,
      ndarray(new Uint8Array([255,255,255,255]), [1,1,4]))
    meshTexture.generateMipmap()
    meshTexture.minFilter = gl.LINEAR_MIPMAP_LINEAR
    meshTexture.magFilter = gl.LINEAR
  
    var trianglePositions = createBuffer(gl)
    var triangleVectors   = createBuffer(gl)
    var triangleColors    = createBuffer(gl)
    var triangleUVs       = createBuffer(gl)
    var triangleIds       = createBuffer(gl)
    var triangleVAO       = createVAO(gl, [
      { buffer: trianglePositions,
        type: gl.FLOAT,
        size: 4
      },
      { buffer: triangleIds,
        type: gl.UNSIGNED_BYTE,
        size: 4,
        normalized: true
      },
      { buffer: triangleColors,
        type: gl.FLOAT,
        size: 4
      },
      { buffer: triangleUVs,
        type: gl.FLOAT,
        size: 2
      },
      { buffer: triangleVectors,
        type: gl.FLOAT,
        size: 4
      }
    ])
  
    var mesh = new VectorMesh(gl
      , meshTexture
      , triShader
      , pickShader
      , trianglePositions
      , triangleVectors
      , triangleIds
      , triangleColors
      , triangleUVs
      , triangleVAO
      , opts.traceType || 'cone'
    )
  
    mesh.update(params)
  
    return mesh
  }
  
  module.exports = createVectorMesh
  
  },{"colormap":131,"gl-buffer":258,"gl-mat4/invert":278,"gl-mat4/multiply":280,"gl-shader":312,"gl-texture2d":327,"gl-vao":332,"ndarray":469}],261:[function(_dereq_,module,exports){
  var glslify       = _dereq_('glslify')
  
  var triVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec3 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, coneScale, coneOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * conePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(conePosition, 1.0);\n  vec4 t_position  = view * conePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = conePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"])
  var triFragSrc = glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"])
  var pickVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the cone vertex and normal at the given index.\n//\n// The returned vertex is for a cone with its top at origin and height of 1.0,\n// pointing in the direction of the vector attribute.\n//\n// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.\n// These vertices are used to make up the triangles of the cone by the following:\n//   segment + 0 top vertex\n//   segment + 1 perimeter vertex a+1\n//   segment + 2 perimeter vertex a\n//   segment + 3 center base vertex\n//   segment + 4 perimeter vertex a\n//   segment + 5 perimeter vertex a+1\n// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.\n// To go from index to segment, floor(index / 6)\n// To go from segment to angle, 2*pi * (segment/segmentCount)\n// To go from index to segment index, index - (segment*6)\n//\nvec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {\n\n  const float segmentCount = 8.0;\n\n  float index = rawIndex - floor(rawIndex /\n    (segmentCount * 6.0)) *\n    (segmentCount * 6.0);\n\n  float segment = floor(0.001 + index/6.0);\n  float segmentIndex = index - (segment*6.0);\n\n  normal = -normalize(d);\n\n  if (segmentIndex > 2.99 && segmentIndex < 3.01) {\n    return mix(vec3(0.0), -d, coneOffset);\n  }\n\n  float nextAngle = (\n    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||\n    (segmentIndex > 4.99 &&  segmentIndex < 5.01)\n  ) ? 1.0 : 0.0;\n  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);\n\n  vec3 v1 = mix(d, vec3(0.0), coneOffset);\n  vec3 v2 = v1 - d;\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d)*0.25;\n  vec3 y = v * sin(angle) * length(d)*0.25;\n  vec3 v3 = v2 + x + y;\n  if (segmentIndex < 3.0) {\n    vec3 tx = u * sin(angle);\n    vec3 ty = v * -cos(angle);\n    vec3 tangent = tx + ty;\n    normal = normalize(cross(v3 - v1, tangent));\n  }\n\n  if (segmentIndex == 0.0) {\n    return mix(d, vec3(0.0), coneOffset);\n  }\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float vectorScale, coneScale, coneOffset;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector.xyz), position.w, coneOffset, normal);\n  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n  gl_Position = projection * view * conePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"])
  var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"])
  
  exports.meshShader = {
    vertex:   triVertSrc,
    fragment: triFragSrc,
    attributes: [
      {name: 'position', type: 'vec4'},
      {name: 'color', type: 'vec4'},
      {name: 'uv', type: 'vec2'},
      {name: 'vector', type: 'vec3'}
    ]
  }
  exports.pickShader = {
    vertex:   pickVertSrc,
    fragment: pickFragSrc,
    attributes: [
      {name: 'position', type: 'vec4'},
      {name: 'id', type: 'vec4'},
      {name: 'vector', type: 'vec3'}
    ]
  }
  
  },{"glslify":413}],262:[function(_dereq_,module,exports){
  module.exports = {
    0: 'NONE',
    1: 'ONE',
    2: 'LINE_LOOP',
    3: 'LINE_STRIP',
    4: 'TRIANGLES',
    5: 'TRIANGLE_STRIP',
    6: 'TRIANGLE_FAN',
    256: 'DEPTH_BUFFER_BIT',
    512: 'NEVER',
    513: 'LESS',
    514: 'EQUAL',
    515: 'LEQUAL',
    516: 'GREATER',
    517: 'NOTEQUAL',
    518: 'GEQUAL',
    519: 'ALWAYS',
    768: 'SRC_COLOR',
    769: 'ONE_MINUS_SRC_COLOR',
    770: 'SRC_ALPHA',
    771: 'ONE_MINUS_SRC_ALPHA',
    772: 'DST_ALPHA',
    773: 'ONE_MINUS_DST_ALPHA',
    774: 'DST_COLOR',
    775: 'ONE_MINUS_DST_COLOR',
    776: 'SRC_ALPHA_SATURATE',
    1024: 'STENCIL_BUFFER_BIT',
    1028: 'FRONT',
    1029: 'BACK',
    1032: 'FRONT_AND_BACK',
    1280: 'INVALID_ENUM',
    1281: 'INVALID_VALUE',
    1282: 'INVALID_OPERATION',
    1285: 'OUT_OF_MEMORY',
    1286: 'INVALID_FRAMEBUFFER_OPERATION',
    2304: 'CW',
    2305: 'CCW',
    2849: 'LINE_WIDTH',
    2884: 'CULL_FACE',
    2885: 'CULL_FACE_MODE',
    2886: 'FRONT_FACE',
    2928: 'DEPTH_RANGE',
    2929: 'DEPTH_TEST',
    2930: 'DEPTH_WRITEMASK',
    2931: 'DEPTH_CLEAR_VALUE',
    2932: 'DEPTH_FUNC',
    2960: 'STENCIL_TEST',
    2961: 'STENCIL_CLEAR_VALUE',
    2962: 'STENCIL_FUNC',
    2963: 'STENCIL_VALUE_MASK',
    2964: 'STENCIL_FAIL',
    2965: 'STENCIL_PASS_DEPTH_FAIL',
    2966: 'STENCIL_PASS_DEPTH_PASS',
    2967: 'STENCIL_REF',
    2968: 'STENCIL_WRITEMASK',
    2978: 'VIEWPORT',
    3024: 'DITHER',
    3042: 'BLEND',
    3088: 'SCISSOR_BOX',
    3089: 'SCISSOR_TEST',
    3106: 'COLOR_CLEAR_VALUE',
    3107: 'COLOR_WRITEMASK',
    3317: 'UNPACK_ALIGNMENT',
    3333: 'PACK_ALIGNMENT',
    3379: 'MAX_TEXTURE_SIZE',
    3386: 'MAX_VIEWPORT_DIMS',
    3408: 'SUBPIXEL_BITS',
    3410: 'RED_BITS',
    3411: 'GREEN_BITS',
    3412: 'BLUE_BITS',
    3413: 'ALPHA_BITS',
    3414: 'DEPTH_BITS',
    3415: 'STENCIL_BITS',
    3553: 'TEXTURE_2D',
    4352: 'DONT_CARE',
    4353: 'FASTEST',
    4354: 'NICEST',
    5120: 'BYTE',
    5121: 'UNSIGNED_BYTE',
    5122: 'SHORT',
    5123: 'UNSIGNED_SHORT',
    5124: 'INT',
    5125: 'UNSIGNED_INT',
    5126: 'FLOAT',
    5386: 'INVERT',
    5890: 'TEXTURE',
    6401: 'STENCIL_INDEX',
    6402: 'DEPTH_COMPONENT',
    6406: 'ALPHA',
    6407: 'RGB',
    6408: 'RGBA',
    6409: 'LUMINANCE',
    6410: 'LUMINANCE_ALPHA',
    7680: 'KEEP',
    7681: 'REPLACE',
    7682: 'INCR',
    7683: 'DECR',
    7936: 'VENDOR',
    7937: 'RENDERER',
    7938: 'VERSION',
    9728: 'NEAREST',
    9729: 'LINEAR',
    9984: 'NEAREST_MIPMAP_NEAREST',
    9985: 'LINEAR_MIPMAP_NEAREST',
    9986: 'NEAREST_MIPMAP_LINEAR',
    9987: 'LINEAR_MIPMAP_LINEAR',
    10240: 'TEXTURE_MAG_FILTER',
    10241: 'TEXTURE_MIN_FILTER',
    10242: 'TEXTURE_WRAP_S',
    10243: 'TEXTURE_WRAP_T',
    10497: 'REPEAT',
    10752: 'POLYGON_OFFSET_UNITS',
    16384: 'COLOR_BUFFER_BIT',
    32769: 'CONSTANT_COLOR',
    32770: 'ONE_MINUS_CONSTANT_COLOR',
    32771: 'CONSTANT_ALPHA',
    32772: 'ONE_MINUS_CONSTANT_ALPHA',
    32773: 'BLEND_COLOR',
    32774: 'FUNC_ADD',
    32777: 'BLEND_EQUATION_RGB',
    32778: 'FUNC_SUBTRACT',
    32779: 'FUNC_REVERSE_SUBTRACT',
    32819: 'UNSIGNED_SHORT_4_4_4_4',
    32820: 'UNSIGNED_SHORT_5_5_5_1',
    32823: 'POLYGON_OFFSET_FILL',
    32824: 'POLYGON_OFFSET_FACTOR',
    32854: 'RGBA4',
    32855: 'RGB5_A1',
    32873: 'TEXTURE_BINDING_2D',
    32926: 'SAMPLE_ALPHA_TO_COVERAGE',
    32928: 'SAMPLE_COVERAGE',
    32936: 'SAMPLE_BUFFERS',
    32937: 'SAMPLES',
    32938: 'SAMPLE_COVERAGE_VALUE',
    32939: 'SAMPLE_COVERAGE_INVERT',
    32968: 'BLEND_DST_RGB',
    32969: 'BLEND_SRC_RGB',
    32970: 'BLEND_DST_ALPHA',
    32971: 'BLEND_SRC_ALPHA',
    33071: 'CLAMP_TO_EDGE',
    33170: 'GENERATE_MIPMAP_HINT',
    33189: 'DEPTH_COMPONENT16',
    33306: 'DEPTH_STENCIL_ATTACHMENT',
    33635: 'UNSIGNED_SHORT_5_6_5',
    33648: 'MIRRORED_REPEAT',
    33901: 'ALIASED_POINT_SIZE_RANGE',
    33902: 'ALIASED_LINE_WIDTH_RANGE',
    33984: 'TEXTURE0',
    33985: 'TEXTURE1',
    33986: 'TEXTURE2',
    33987: 'TEXTURE3',
    33988: 'TEXTURE4',
    33989: 'TEXTURE5',
    33990: 'TEXTURE6',
    33991: 'TEXTURE7',
    33992: 'TEXTURE8',
    33993: 'TEXTURE9',
    33994: 'TEXTURE10',
    33995: 'TEXTURE11',
    33996: 'TEXTURE12',
    33997: 'TEXTURE13',
    33998: 'TEXTURE14',
    33999: 'TEXTURE15',
    34000: 'TEXTURE16',
    34001: 'TEXTURE17',
    34002: 'TEXTURE18',
    34003: 'TEXTURE19',
    34004: 'TEXTURE20',
    34005: 'TEXTURE21',
    34006: 'TEXTURE22',
    34007: 'TEXTURE23',
    34008: 'TEXTURE24',
    34009: 'TEXTURE25',
    34010: 'TEXTURE26',
    34011: 'TEXTURE27',
    34012: 'TEXTURE28',
    34013: 'TEXTURE29',
    34014: 'TEXTURE30',
    34015: 'TEXTURE31',
    34016: 'ACTIVE_TEXTURE',
    34024: 'MAX_RENDERBUFFER_SIZE',
    34041: 'DEPTH_STENCIL',
    34055: 'INCR_WRAP',
    34056: 'DECR_WRAP',
    34067: 'TEXTURE_CUBE_MAP',
    34068: 'TEXTURE_BINDING_CUBE_MAP',
    34069: 'TEXTURE_CUBE_MAP_POSITIVE_X',
    34070: 'TEXTURE_CUBE_MAP_NEGATIVE_X',
    34071: 'TEXTURE_CUBE_MAP_POSITIVE_Y',
    34072: 'TEXTURE_CUBE_MAP_NEGATIVE_Y',
    34073: 'TEXTURE_CUBE_MAP_POSITIVE_Z',
    34074: 'TEXTURE_CUBE_MAP_NEGATIVE_Z',
    34076: 'MAX_CUBE_MAP_TEXTURE_SIZE',
    34338: 'VERTEX_ATTRIB_ARRAY_ENABLED',
    34339: 'VERTEX_ATTRIB_ARRAY_SIZE',
    34340: 'VERTEX_ATTRIB_ARRAY_STRIDE',
    34341: 'VERTEX_ATTRIB_ARRAY_TYPE',
    34342: 'CURRENT_VERTEX_ATTRIB',
    34373: 'VERTEX_ATTRIB_ARRAY_POINTER',
    34466: 'NUM_COMPRESSED_TEXTURE_FORMATS',
    34467: 'COMPRESSED_TEXTURE_FORMATS',
    34660: 'BUFFER_SIZE',
    34661: 'BUFFER_USAGE',
    34816: 'STENCIL_BACK_FUNC',
    34817: 'STENCIL_BACK_FAIL',
    34818: 'STENCIL_BACK_PASS_DEPTH_FAIL',
    34819: 'STENCIL_BACK_PASS_DEPTH_PASS',
    34877: 'BLEND_EQUATION_ALPHA',
    34921: 'MAX_VERTEX_ATTRIBS',
    34922: 'VERTEX_ATTRIB_ARRAY_NORMALIZED',
    34930: 'MAX_TEXTURE_IMAGE_UNITS',
    34962: 'ARRAY_BUFFER',
    34963: 'ELEMENT_ARRAY_BUFFER',
    34964: 'ARRAY_BUFFER_BINDING',
    34965: 'ELEMENT_ARRAY_BUFFER_BINDING',
    34975: 'VERTEX_ATTRIB_ARRAY_BUFFER_BINDING',
    35040: 'STREAM_DRAW',
    35044: 'STATIC_DRAW',
    35048: 'DYNAMIC_DRAW',
    35632: 'FRAGMENT_SHADER',
    35633: 'VERTEX_SHADER',
    35660: 'MAX_VERTEX_TEXTURE_IMAGE_UNITS',
    35661: 'MAX_COMBINED_TEXTURE_IMAGE_UNITS',
    35663: 'SHADER_TYPE',
    35664: 'FLOAT_VEC2',
    35665: 'FLOAT_VEC3',
    35666: 'FLOAT_VEC4',
    35667: 'INT_VEC2',
    35668: 'INT_VEC3',
    35669: 'INT_VEC4',
    35670: 'BOOL',
    35671: 'BOOL_VEC2',
    35672: 'BOOL_VEC3',
    35673: 'BOOL_VEC4',
    35674: 'FLOAT_MAT2',
    35675: 'FLOAT_MAT3',
    35676: 'FLOAT_MAT4',
    35678: 'SAMPLER_2D',
    35680: 'SAMPLER_CUBE',
    35712: 'DELETE_STATUS',
    35713: 'COMPILE_STATUS',
    35714: 'LINK_STATUS',
    35715: 'VALIDATE_STATUS',
    35716: 'INFO_LOG_LENGTH',
    35717: 'ATTACHED_SHADERS',
    35718: 'ACTIVE_UNIFORMS',
    35719: 'ACTIVE_UNIFORM_MAX_LENGTH',
    35720: 'SHADER_SOURCE_LENGTH',
    35721: 'ACTIVE_ATTRIBUTES',
    35722: 'ACTIVE_ATTRIBUTE_MAX_LENGTH',
    35724: 'SHADING_LANGUAGE_VERSION',
    35725: 'CURRENT_PROGRAM',
    36003: 'STENCIL_BACK_REF',
    36004: 'STENCIL_BACK_VALUE_MASK',
    36005: 'STENCIL_BACK_WRITEMASK',
    36006: 'FRAMEBUFFER_BINDING',
    36007: 'RENDERBUFFER_BINDING',
    36048: 'FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE',
    36049: 'FRAMEBUFFER_ATTACHMENT_OBJECT_NAME',
    36050: 'FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL',
    36051: 'FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE',
    36053: 'FRAMEBUFFER_COMPLETE',
    36054: 'FRAMEBUFFER_INCOMPLETE_ATTACHMENT',
    36055: 'FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT',
    36057: 'FRAMEBUFFER_INCOMPLETE_DIMENSIONS',
    36061: 'FRAMEBUFFER_UNSUPPORTED',
    36064: 'COLOR_ATTACHMENT0',
    36096: 'DEPTH_ATTACHMENT',
    36128: 'STENCIL_ATTACHMENT',
    36160: 'FRAMEBUFFER',
    36161: 'RENDERBUFFER',
    36162: 'RENDERBUFFER_WIDTH',
    36163: 'RENDERBUFFER_HEIGHT',
    36164: 'RENDERBUFFER_INTERNAL_FORMAT',
    36168: 'STENCIL_INDEX8',
    36176: 'RENDERBUFFER_RED_SIZE',
    36177: 'RENDERBUFFER_GREEN_SIZE',
    36178: 'RENDERBUFFER_BLUE_SIZE',
    36179: 'RENDERBUFFER_ALPHA_SIZE',
    36180: 'RENDERBUFFER_DEPTH_SIZE',
    36181: 'RENDERBUFFER_STENCIL_SIZE',
    36194: 'RGB565',
    36336: 'LOW_FLOAT',
    36337: 'MEDIUM_FLOAT',
    36338: 'HIGH_FLOAT',
    36339: 'LOW_INT',
    36340: 'MEDIUM_INT',
    36341: 'HIGH_INT',
    36346: 'SHADER_COMPILER',
    36347: 'MAX_VERTEX_UNIFORM_VECTORS',
    36348: 'MAX_VARYING_VECTORS',
    36349: 'MAX_FRAGMENT_UNIFORM_VECTORS',
    37440: 'UNPACK_FLIP_Y_WEBGL',
    37441: 'UNPACK_PREMULTIPLY_ALPHA_WEBGL',
    37442: 'CONTEXT_LOST_WEBGL',
    37443: 'UNPACK_COLORSPACE_CONVERSION_WEBGL',
    37444: 'BROWSER_DEFAULT_WEBGL'
  }
  
  },{}],263:[function(_dereq_,module,exports){
  var gl10 = _dereq_('./1.0/numbers')
  
  module.exports = function lookupConstant (number) {
    return gl10[number]
  }
  
  },{"./1.0/numbers":262}],264:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createErrorBars
  
  var createBuffer  = _dereq_('gl-buffer')
  var createVAO     = _dereq_('gl-vao')
  var createShader  = _dereq_('./shaders/index')
  
  var IDENTITY = [1,0,0,0,
                  0,1,0,0,
                  0,0,1,0,
                  0,0,0,1]
  
  function ErrorBars(gl, buffer, vao, shader) {
    this.gl           = gl
    this.shader       = shader
    this.buffer       = buffer
    this.vao          = vao
    this.pixelRatio   = 1
    this.bounds       = [[ Infinity, Infinity, Infinity], [-Infinity,-Infinity,-Infinity]]
    this.clipBounds   = [[-Infinity,-Infinity,-Infinity], [ Infinity, Infinity, Infinity]]
    this.lineWidth    = [1,1,1]
    this.capSize      = [10,10,10]
    this.lineCount    = [0,0,0]
    this.lineOffset   = [0,0,0]
    this.opacity      = 1
    this.hasAlpha     = false
  }
  
  var proto = ErrorBars.prototype
  
  proto.isOpaque = function() {
    return !this.hasAlpha
  }
  
  proto.isTransparent = function() {
    return this.hasAlpha
  }
  
  proto.drawTransparent = proto.draw = function(cameraParams) {
    var gl = this.gl
    var uniforms        = this.shader.uniforms
  
    this.shader.bind()
    var view       = uniforms.view       = cameraParams.view       || IDENTITY
    var projection = uniforms.projection = cameraParams.projection || IDENTITY
    uniforms.model      = cameraParams.model      || IDENTITY
    uniforms.clipBounds = this.clipBounds
    uniforms.opacity    = this.opacity
  
  
    var cx = view[12]
    var cy = view[13]
    var cz = view[14]
    var cw = view[15]
  
    var isOrtho = cameraParams._ortho || false
    var orthoFix = (isOrtho) ? 2 : 1 // double up padding for orthographic ticks & labels
    var pixelScaleF = orthoFix * this.pixelRatio * (projection[3]*cx + projection[7]*cy + projection[11]*cz + projection[15]*cw) / gl.drawingBufferHeight
  
    this.vao.bind()
    for(var i=0; i<3; ++i) {
      gl.lineWidth(this.lineWidth[i] * this.pixelRatio)
      uniforms.capSize = this.capSize[i] * pixelScaleF
      if (this.lineCount[i]) {
        gl.drawArrays(gl.LINES, this.lineOffset[i], this.lineCount[i])
      }
    }
    this.vao.unbind()
  }
  
  function updateBounds(bounds, point) {
    for(var i=0; i<3; ++i) {
      bounds[0][i] = Math.min(bounds[0][i], point[i])
      bounds[1][i] = Math.max(bounds[1][i], point[i])
    }
  }
  
  var FACE_TABLE = (function(){
    var table = new Array(3)
    for(var d=0; d<3; ++d) {
      var row = []
      for(var j=1; j<=2; ++j) {
        for(var s=-1; s<=1; s+=2) {
          var u = (j+d) % 3
          var y = [0,0,0]
          y[u] = s
          row.push(y)
        }
      }
      table[d] = row
    }
    return table
  })()
  
  
  function emitFace(verts, x, c, d) {
    var offsets = FACE_TABLE[d]
    for(var i=0; i<offsets.length; ++i) {
      var o = offsets[i]
      verts.push(x[0], x[1], x[2],
                 c[0], c[1], c[2], c[3],
                 o[0], o[1], o[2])
    }
    return offsets.length
  }
  
  proto.update = function(options) {
    options = options || {}
  
    if('lineWidth' in options) {
      this.lineWidth = options.lineWidth
      if(!Array.isArray(this.lineWidth)) {
        this.lineWidth = [this.lineWidth, this.lineWidth, this.lineWidth]
      }
    }
    if('capSize' in options) {
      this.capSize = options.capSize
      if(!Array.isArray(this.capSize)) {
        this.capSize = [this.capSize, this.capSize, this.capSize]
      }
    }
  
    this.hasAlpha = false // default to no transparent draw
    if('opacity' in options) {
      this.opacity = +options.opacity
      if(this.opacity < 1) {
        this.hasAlpha = true;
      }
    }
  
    var color    = options.color || [[0,0,0],[0,0,0],[0,0,0]]
    var position = options.position
    var error    = options.error
    if(!Array.isArray(color[0])) {
      color = [color,color,color]
    }
  
    if(position && error) {
  
      var verts       = []
      var n           = position.length
      var vertexCount = 0
      this.bounds     = [[ Infinity, Infinity, Infinity],
                         [-Infinity,-Infinity,-Infinity]]
      this.lineCount  = [0,0,0]
  
      //Build geometry for lines
      for(var j=0; j<3; ++j) {
        this.lineOffset[j] = vertexCount
  
  i_loop:
        for(var i=0; i<n; ++i) {
          var p = position[i]
  
          for(var k=0; k<3; ++k) {
            if(isNaN(p[k]) || !isFinite(p[k])) {
              continue i_loop
            }
          }
  
          var e = error[i]
          var c = color[j]
          if(Array.isArray(c[0])) {
            c = color[i]
          }
          if(c.length === 3) {
            c = [c[0], c[1], c[2], 1]
          } else if(c.length === 4) {
            c = [c[0], c[1], c[2], c[3]]
            if(!this.hasAlpha && c[3] < 1) this.hasAlpha = true
          }
  
          if(isNaN(e[0][j]) || isNaN(e[1][j])) {
            continue
          }
          if(e[0][j] < 0) {
            var x = p.slice()
            x[j] += e[0][j]
            verts.push(p[0], p[1], p[2],
                       c[0], c[1], c[2], c[3],
                          0,    0,    0,
                       x[0], x[1], x[2],
                       c[0], c[1], c[2], c[3],
                          0,    0,    0)
            updateBounds(this.bounds, x)
            vertexCount += 2 + emitFace(verts, x, c, j)
          }
          if(e[1][j] > 0) {
            var x = p.slice()
            x[j] += e[1][j]
            verts.push(p[0], p[1], p[2],
                       c[0], c[1], c[2], c[3],
                          0,    0,    0,
                       x[0], x[1], x[2],
                       c[0], c[1], c[2], c[3],
                          0,    0,    0)
            updateBounds(this.bounds, x)
            vertexCount += 2 + emitFace(verts, x, c, j)
          }
        }
        this.lineCount[j] = vertexCount - this.lineOffset[j]
      }
      this.buffer.update(verts)
    }
  }
  
  proto.dispose = function() {
    this.shader.dispose()
    this.buffer.dispose()
    this.vao.dispose()
  }
  
  function createErrorBars(options) {
    var gl = options.gl
    var buffer = createBuffer(gl)
    var vao = createVAO(gl, [
        {
          buffer: buffer,
          type:   gl.FLOAT,
          size:   3,
          offset: 0,
          stride: 40
        },
        {
          buffer: buffer,
          type:   gl.FLOAT,
          size:   4,
          offset: 12,
          stride: 40
        },
        {
          buffer: buffer,
          type:   gl.FLOAT,
          size:   3,
          offset: 28,
          stride: 40
        }
      ])
  
    var shader = createShader(gl)
    shader.attributes.position.location = 0
    shader.attributes.color.location    = 1
    shader.attributes.offset.location   = 2
  
    var result = new ErrorBars(gl, buffer, vao, shader)
    result.update(options)
    return result
  }
  
  },{"./shaders/index":265,"gl-buffer":258,"gl-vao":332}],265:[function(_dereq_,module,exports){
  'use strict'
  
  var glslify = _dereq_('glslify')
  var createShader = _dereq_('gl-shader')
  
  var vertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, offset;\nattribute vec4 color;\nuniform mat4 model, view, projection;\nuniform float capSize;\nvarying vec4 fragColor;\nvarying vec3 fragPosition;\n\nvoid main() {\n  vec4 worldPosition  = model * vec4(position, 1.0);\n  worldPosition       = (worldPosition / worldPosition.w) + vec4(capSize * offset, 0.0);\n  gl_Position         = projection * view * worldPosition;\n  fragColor           = color;\n  fragPosition        = position;\n}"])
  var fragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float opacity;\nvarying vec3 fragPosition;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], fragPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  gl_FragColor = opacity * fragColor;\n}"])
  
  module.exports = function(gl) {
    return createShader(gl, vertSrc, fragSrc, null, [
      {name: 'position', type: 'vec3'},
      {name: 'color', type: 'vec4'},
      {name: 'offset', type: 'vec3'}
    ])
  }
  
  },{"gl-shader":312,"glslify":413}],266:[function(_dereq_,module,exports){
  'use strict'
  
  var createTexture = _dereq_('gl-texture2d')
  
  module.exports = createFBO
  
  var colorAttachmentArrays = null
  var FRAMEBUFFER_UNSUPPORTED
  var FRAMEBUFFER_INCOMPLETE_ATTACHMENT
  var FRAMEBUFFER_INCOMPLETE_DIMENSIONS
  var FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT
  
  function saveFBOState(gl) {
    var fbo = gl.getParameter(gl.FRAMEBUFFER_BINDING)
    var rbo = gl.getParameter(gl.RENDERBUFFER_BINDING)
    var tex = gl.getParameter(gl.TEXTURE_BINDING_2D)
    return [fbo, rbo, tex]
  }
  
  function restoreFBOState(gl, data) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, data[0])
    gl.bindRenderbuffer(gl.RENDERBUFFER, data[1])
    gl.bindTexture(gl.TEXTURE_2D, data[2])
  }
  
  function lazyInitColorAttachments(gl, ext) {
    var maxColorAttachments = gl.getParameter(ext.MAX_COLOR_ATTACHMENTS_WEBGL)
    colorAttachmentArrays = new Array(maxColorAttachments + 1)
    for(var i=0; i<=maxColorAttachments; ++i) {
      var x = new Array(maxColorAttachments)
      for(var j=0; j<i; ++j) {
        x[j] = gl.COLOR_ATTACHMENT0 + j
      }
      for(var j=i; j<maxColorAttachments; ++j) {
        x[j] = gl.NONE
      }
      colorAttachmentArrays[i] = x
    }
  }
  
  //Throw an appropriate error
  function throwFBOError(status) {
    switch(status){
      case FRAMEBUFFER_UNSUPPORTED:
        throw new Error('gl-fbo: Framebuffer unsupported')
      case FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
        throw new Error('gl-fbo: Framebuffer incomplete attachment')
      case FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
        throw new Error('gl-fbo: Framebuffer incomplete dimensions')
      case FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
        throw new Error('gl-fbo: Framebuffer incomplete missing attachment')
      default:
        throw new Error('gl-fbo: Framebuffer failed for unspecified reason')
    }
  }
  
  //Initialize a texture object
  function initTexture(gl, width, height, type, format, attachment) {
    if(!type) {
      return null
    }
    var result = createTexture(gl, width, height, format, type)
    result.magFilter = gl.NEAREST
    result.minFilter = gl.NEAREST
    result.mipSamples = 1
    result.bind()
    gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, result.handle, 0)
    return result
  }
  
  //Initialize a render buffer object
  function initRenderBuffer(gl, width, height, component, attachment) {
    var result = gl.createRenderbuffer()
    gl.bindRenderbuffer(gl.RENDERBUFFER, result)
    gl.renderbufferStorage(gl.RENDERBUFFER, component, width, height)
    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachment, gl.RENDERBUFFER, result)
    return result
  }
  
  //Rebuild the frame buffer
  function rebuildFBO(fbo) {
  
    //Save FBO state
    var state = saveFBOState(fbo.gl)
  
    var gl = fbo.gl
    var handle = fbo.handle = gl.createFramebuffer()
    var width = fbo._shape[0]
    var height = fbo._shape[1]
    var numColors = fbo.color.length
    var ext = fbo._ext
    var useStencil = fbo._useStencil
    var useDepth = fbo._useDepth
    var colorType = fbo._colorType
  
    //Bind the fbo
    gl.bindFramebuffer(gl.FRAMEBUFFER, handle)
  
    //Allocate color buffers
    for(var i=0; i<numColors; ++i) {
      fbo.color[i] = initTexture(gl, width, height, colorType, gl.RGBA, gl.COLOR_ATTACHMENT0 + i)
    }
    if(numColors === 0) {
      fbo._color_rb = initRenderBuffer(gl, width, height, gl.RGBA4, gl.COLOR_ATTACHMENT0)
      if(ext) {
        ext.drawBuffersWEBGL(colorAttachmentArrays[0])
      }
    } else if(numColors > 1) {
      ext.drawBuffersWEBGL(colorAttachmentArrays[numColors])
    }
  
    //Allocate depth/stencil buffers
    var WEBGL_depth_texture = gl.getExtension('WEBGL_depth_texture')
    if(WEBGL_depth_texture) {
      if(useStencil) {
        fbo.depth = initTexture(gl, width, height,
                            WEBGL_depth_texture.UNSIGNED_INT_24_8_WEBGL,
                            gl.DEPTH_STENCIL,
                            gl.DEPTH_STENCIL_ATTACHMENT)
      } else if(useDepth) {
        fbo.depth = initTexture(gl, width, height,
                            gl.UNSIGNED_SHORT,
                            gl.DEPTH_COMPONENT,
                            gl.DEPTH_ATTACHMENT)
      }
    } else {
      if(useDepth && useStencil) {
        fbo._depth_rb = initRenderBuffer(gl, width, height, gl.DEPTH_STENCIL, gl.DEPTH_STENCIL_ATTACHMENT)
      } else if(useDepth) {
        fbo._depth_rb = initRenderBuffer(gl, width, height, gl.DEPTH_COMPONENT16, gl.DEPTH_ATTACHMENT)
      } else if(useStencil) {
        fbo._depth_rb = initRenderBuffer(gl, width, height, gl.STENCIL_INDEX, gl.STENCIL_ATTACHMENT)
      }
    }
  
    //Check frame buffer state
    var status = gl.checkFramebufferStatus(gl.FRAMEBUFFER)
    if(status !== gl.FRAMEBUFFER_COMPLETE) {
  
      //Release all partially allocated resources
      fbo._destroyed = true
  
      //Release all resources
      gl.bindFramebuffer(gl.FRAMEBUFFER, null)
      gl.deleteFramebuffer(fbo.handle)
      fbo.handle = null
      if(fbo.depth) {
        fbo.depth.dispose()
        fbo.depth = null
      }
      if(fbo._depth_rb) {
        gl.deleteRenderbuffer(fbo._depth_rb)
        fbo._depth_rb = null
      }
      for(var i=0; i<fbo.color.length; ++i) {
        fbo.color[i].dispose()
        fbo.color[i] = null
      }
      if(fbo._color_rb) {
        gl.deleteRenderbuffer(fbo._color_rb)
        fbo._color_rb = null
      }
  
      restoreFBOState(gl, state)
  
      //Throw the frame buffer error
      throwFBOError(status)
    }
  
    //Everything ok, let's get on with life
    restoreFBOState(gl, state)
  }
  
  function Framebuffer(gl, width, height, colorType, numColors, useDepth, useStencil, ext) {
  
    //Handle and set properties
    this.gl = gl
    this._shape = [width|0, height|0]
    this._destroyed = false
    this._ext = ext
  
    //Allocate buffers
    this.color = new Array(numColors)
    for(var i=0; i<numColors; ++i) {
      this.color[i] = null
    }
    this._color_rb = null
    this.depth = null
    this._depth_rb = null
  
    //Save depth and stencil flags
    this._colorType = colorType
    this._useDepth = useDepth
    this._useStencil = useStencil
  
    //Shape vector for resizing
    var parent = this
    var shapeVector = [width|0, height|0]
    Object.defineProperties(shapeVector, {
      0: {
        get: function() {
          return parent._shape[0]
        },
        set: function(w) {
          return parent.width = w
        }
      },
      1: {
        get: function() {
          return parent._shape[1]
        },
        set: function(h) {
          return parent.height = h
        }
      }
    })
    this._shapeVector = shapeVector
  
    //Initialize all attachments
    rebuildFBO(this)
  }
  
  var proto = Framebuffer.prototype
  
  function reshapeFBO(fbo, w, h) {
    //If fbo is invalid, just skip this
    if(fbo._destroyed) {
      throw new Error('gl-fbo: Can\'t resize destroyed FBO')
    }
  
    //Don't resize if no change in shape
    if( (fbo._shape[0] === w) &&
        (fbo._shape[1] === h) ) {
      return
    }
  
    var gl = fbo.gl
  
    //Check parameter ranges
    var maxFBOSize = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE)
    if( w < 0 || w > maxFBOSize ||
        h < 0 || h > maxFBOSize) {
      throw new Error('gl-fbo: Can\'t resize FBO, invalid dimensions')
    }
  
    //Update shape
    fbo._shape[0] = w
    fbo._shape[1] = h
  
    //Save framebuffer state
    var state = saveFBOState(gl)
  
    //Resize framebuffer attachments
    for(var i=0; i<fbo.color.length; ++i) {
      fbo.color[i].shape = fbo._shape
    }
    if(fbo._color_rb) {
      gl.bindRenderbuffer(gl.RENDERBUFFER, fbo._color_rb)
      gl.renderbufferStorage(gl.RENDERBUFFER, gl.RGBA4, fbo._shape[0], fbo._shape[1])
    }
    if(fbo.depth) {
      fbo.depth.shape = fbo._shape
    }
    if(fbo._depth_rb) {
      gl.bindRenderbuffer(gl.RENDERBUFFER, fbo._depth_rb)
      if(fbo._useDepth && fbo._useStencil) {
        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, fbo._shape[0], fbo._shape[1])
      } else if(fbo._useDepth) {
        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_COMPONENT16, fbo._shape[0], fbo._shape[1])
      } else if(fbo._useStencil) {
        gl.renderbufferStorage(gl.RENDERBUFFER, gl.STENCIL_INDEX, fbo._shape[0], fbo._shape[1])
      }
    }
  
    //Check FBO status after resize, if something broke then die in a fire
    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo.handle)
    var status = gl.checkFramebufferStatus(gl.FRAMEBUFFER)
    if(status !== gl.FRAMEBUFFER_COMPLETE) {
      fbo.dispose()
      restoreFBOState(gl, state)
      throwFBOError(status)
    }
  
    //Restore framebuffer state
    restoreFBOState(gl, state)
  }
  
  Object.defineProperties(proto, {
    'shape': {
      get: function() {
        if(this._destroyed) {
          return [0,0]
        }
        return this._shapeVector
      },
      set: function(x) {
        if(!Array.isArray(x)) {
          x = [x|0, x|0]
        }
        if(x.length !== 2) {
          throw new Error('gl-fbo: Shape vector must be length 2')
        }
  
        var w = x[0]|0
        var h = x[1]|0
        reshapeFBO(this, w, h)
  
        return [w, h]
      },
      enumerable: false
    },
    'width': {
      get: function() {
        if(this._destroyed) {
          return 0
        }
        return this._shape[0]
      },
      set: function(w) {
        w = w|0
        reshapeFBO(this, w, this._shape[1])
        return w
      },
      enumerable: false
    },
    'height': {
      get: function() {
        if(this._destroyed) {
          return 0
        }
        return this._shape[1]
      },
      set: function(h) {
        h = h|0
        reshapeFBO(this, this._shape[0], h)
        return h
      },
      enumerable: false
    }
  })
  
  proto.bind = function() {
    if(this._destroyed) {
      return
    }
    var gl = this.gl
    gl.bindFramebuffer(gl.FRAMEBUFFER, this.handle)
    gl.viewport(0, 0, this._shape[0], this._shape[1])
  }
  
  proto.dispose = function() {
    if(this._destroyed) {
      return
    }
    this._destroyed = true
    var gl = this.gl
    gl.deleteFramebuffer(this.handle)
    this.handle = null
    if(this.depth) {
      this.depth.dispose()
      this.depth = null
    }
    if(this._depth_rb) {
      gl.deleteRenderbuffer(this._depth_rb)
      this._depth_rb = null
    }
    for(var i=0; i<this.color.length; ++i) {
      this.color[i].dispose()
      this.color[i] = null
    }
    if(this._color_rb) {
      gl.deleteRenderbuffer(this._color_rb)
      this._color_rb = null
    }
  }
  
  function createFBO(gl, width, height, options) {
  
    //Update frame buffer error code values
    if(!FRAMEBUFFER_UNSUPPORTED) {
      FRAMEBUFFER_UNSUPPORTED = gl.FRAMEBUFFER_UNSUPPORTED
      FRAMEBUFFER_INCOMPLETE_ATTACHMENT = gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT
      FRAMEBUFFER_INCOMPLETE_DIMENSIONS = gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS
      FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT = gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT
    }
  
    //Lazily initialize color attachment arrays
    var WEBGL_draw_buffers = gl.getExtension('WEBGL_draw_buffers')
    if(!colorAttachmentArrays && WEBGL_draw_buffers) {
      lazyInitColorAttachments(gl, WEBGL_draw_buffers)
    }
  
    //Special case: Can accept an array as argument
    if(Array.isArray(width)) {
      options = height
      height = width[1]|0
      width = width[0]|0
    }
  
    if(typeof width !== 'number') {
      throw new Error('gl-fbo: Missing shape parameter')
    }
  
    //Validate width/height properties
    var maxFBOSize = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE)
    if(width < 0 || width > maxFBOSize || height < 0 || height > maxFBOSize) {
      throw new Error('gl-fbo: Parameters are too large for FBO')
    }
  
    //Handle each option type
    options = options || {}
  
    //Figure out number of color buffers to use
    var numColors = 1
    if('color' in options) {
      numColors = Math.max(options.color|0, 0)
      if(numColors < 0) {
        throw new Error('gl-fbo: Must specify a nonnegative number of colors')
      }
      if(numColors > 1) {
        //Check if multiple render targets supported
        if(!WEBGL_draw_buffers) {
          throw new Error('gl-fbo: Multiple draw buffer extension not supported')
        } else if(numColors > gl.getParameter(WEBGL_draw_buffers.MAX_COLOR_ATTACHMENTS_WEBGL)) {
          throw new Error('gl-fbo: Context does not support ' + numColors + ' draw buffers')
        }
      }
    }
  
    //Determine whether to use floating point textures
    var colorType = gl.UNSIGNED_BYTE
    var OES_texture_float = gl.getExtension('OES_texture_float')
    if(options.float && numColors > 0) {
      if(!OES_texture_float) {
        throw new Error('gl-fbo: Context does not support floating point textures')
      }
      colorType = gl.FLOAT
    } else if(options.preferFloat && numColors > 0) {
      if(OES_texture_float) {
        colorType = gl.FLOAT
      }
    }
  
    //Check if we should use depth buffer
    var useDepth = true
    if('depth' in options) {
      useDepth = !!options.depth
    }
  
    //Check if we should use a stencil buffer
    var useStencil = false
    if('stencil' in options) {
      useStencil = !!options.stencil
    }
  
    return new Framebuffer(
      gl,
      width,
      height,
      colorType,
      numColors,
      useDepth,
      useStencil,
      WEBGL_draw_buffers)
  }
  
  },{"gl-texture2d":327}],267:[function(_dereq_,module,exports){
  
  var sprintf = _dereq_('sprintf-js').sprintf;
  var glConstants = _dereq_('gl-constants/lookup');
  var shaderName = _dereq_('glsl-shader-name');
  var addLineNumbers = _dereq_('add-line-numbers');
  
  module.exports = formatCompilerError;
  
  function formatCompilerError(errLog, src, type) {
      "use strict";
  
      var name = shaderName(src) || 'of unknown name (see npm glsl-shader-name)';
  
      var typeName = 'unknown type';
      if (type !== undefined) {
          typeName = type === glConstants.FRAGMENT_SHADER ? 'fragment' : 'vertex'
      }
  
      var longForm = sprintf('Error compiling %s shader %s:\n', typeName, name);
      var shortForm = sprintf("%s%s", longForm, errLog);
  
      var errorStrings = errLog.split('\n');
      var errors = {};
  
      for (var i = 0; i < errorStrings.length; i++) {
          var errorString = errorStrings[i];
          if (errorString === '' || errorString === "\0") continue;
          var lineNo = parseInt(errorString.split(':')[2]);
          if (isNaN(lineNo)) {
              throw new Error(sprintf('Could not parse error: %s', errorString));
          }
          errors[lineNo] = errorString;
      }
  
      var lines = addLineNumbers(src).split('\n');
  
      for (var i = 0; i < lines.length; i++) {
          if (!errors[i+3] && !errors[i+2] && !errors[i+1]) continue;
          var line = lines[i];
          longForm += line + '\n';
          if (errors[i+1]) {
              var e = errors[i+1];
              e = e.substr(e.split(':', 3).join(':').length + 1).trim();
              longForm += sprintf('^^^ %s\n\n', e);
          }
      }
  
      return {
          long: longForm.trim(),
          short: shortForm.trim()
      };
  }
  
  
  },{"add-line-numbers":66,"gl-constants/lookup":263,"glsl-shader-name":405,"sprintf-js":539}],268:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createHeatmap2D
  
  var bsearch = _dereq_('binary-search-bounds')
  var iota = _dereq_('iota-array')
  var pool = _dereq_('typedarray-pool')
  var createShader = _dereq_('gl-shader')
  var createBuffer = _dereq_('gl-buffer')
  
  var shaders = _dereq_('./lib/shaders')
  
  function GLHeatmap2D (
    plot,
    shader,
    pickShader,
    positionBuffer,
    weightBuffer,
    colorBuffer,
    idBuffer) {
    this.plot = plot
    this.shader = shader
    this.pickShader = pickShader
    this.positionBuffer = positionBuffer
    this.weightBuffer = weightBuffer
    this.colorBuffer = colorBuffer
    this.idBuffer = idBuffer
    this.xData = []
    this.yData = []
    this.shape = [0, 0]
    this.bounds = [Infinity, Infinity, -Infinity, -Infinity]
    this.pickOffset = 0
  }
  
  var proto = GLHeatmap2D.prototype
  
  var WEIGHTS = [
    0, 0,
    1, 0,
    0, 1,
    1, 0,
    1, 1,
    0, 1
  ]
  
  proto.draw = (function () {
    var MATRIX = [
      1, 0, 0,
      0, 1, 0,
      0, 0, 1
    ]
  
    return function () {
      var plot = this.plot
      var shader = this.shader
      var bounds = this.bounds
      var numVertices = this.numVertices
  
      if (numVertices <= 0) {
        return
      }
  
      var gl = plot.gl
      var dataBox = plot.dataBox
  
      var boundX = bounds[2] - bounds[0]
      var boundY = bounds[3] - bounds[1]
      var dataX = dataBox[2] - dataBox[0]
      var dataY = dataBox[3] - dataBox[1]
  
      MATRIX[0] = 2.0 * boundX / dataX
      MATRIX[4] = 2.0 * boundY / dataY
      MATRIX[6] = 2.0 * (bounds[0] - dataBox[0]) / dataX - 1.0
      MATRIX[7] = 2.0 * (bounds[1] - dataBox[1]) / dataY - 1.0
  
      shader.bind()
  
      var uniforms = shader.uniforms
      uniforms.viewTransform = MATRIX
  
      uniforms.shape = this.shape
  
      var attributes = shader.attributes
      this.positionBuffer.bind()
      attributes.position.pointer()
  
      this.weightBuffer.bind()
      attributes.weight.pointer(gl.UNSIGNED_BYTE, false)
  
      this.colorBuffer.bind()
      attributes.color.pointer(gl.UNSIGNED_BYTE, true)
  
      gl.drawArrays(gl.TRIANGLES, 0, numVertices)
    }
  })()
  
  proto.drawPick = (function () {
    var MATRIX = [
      1, 0, 0,
      0, 1, 0,
      0, 0, 1
    ]
  
    var PICK_VECTOR = [0, 0, 0, 0]
  
    return function (pickOffset) {
      var plot = this.plot
      var shader = this.pickShader
      var bounds = this.bounds
      var numVertices = this.numVertices
  
      if (numVertices <= 0) {
        return
      }
  
      var gl = plot.gl
      var dataBox = plot.dataBox
  
      var boundX = bounds[2] - bounds[0]
      var boundY = bounds[3] - bounds[1]
      var dataX = dataBox[2] - dataBox[0]
      var dataY = dataBox[3] - dataBox[1]
  
      MATRIX[0] = 2.0 * boundX / dataX
      MATRIX[4] = 2.0 * boundY / dataY
      MATRIX[6] = 2.0 * (bounds[0] - dataBox[0]) / dataX - 1.0
      MATRIX[7] = 2.0 * (bounds[1] - dataBox[1]) / dataY - 1.0
  
      for (var i = 0; i < 4; ++i) {
        PICK_VECTOR[i] = (pickOffset >> (i * 8)) & 0xff
      }
  
      this.pickOffset = pickOffset
  
      shader.bind()
  
      var uniforms = shader.uniforms
      uniforms.viewTransform = MATRIX
      uniforms.pickOffset = PICK_VECTOR
      uniforms.shape = this.shape
  
      var attributes = shader.attributes
      this.positionBuffer.bind()
      attributes.position.pointer()
  
      this.weightBuffer.bind()
      attributes.weight.pointer(gl.UNSIGNED_BYTE, false)
  
      this.idBuffer.bind()
      attributes.pickId.pointer(gl.UNSIGNED_BYTE, false)
  
      gl.drawArrays(gl.TRIANGLES, 0, numVertices)
  
      return pickOffset + this.shape[0] * this.shape[1]
    }
  })()
  
  proto.pick = function (x, y, value) {
    var pickOffset = this.pickOffset
    var pointCount = this.shape[0] * this.shape[1]
    if (value < pickOffset || value >= pickOffset + pointCount) {
      return null
    }
    var pointId = value - pickOffset
    var xData = this.xData
    var yData = this.yData
    return {
      object: this,
      pointId: pointId,
      dataCoord: [
        xData[pointId % this.shape[0]],
        yData[(pointId / this.shape[0]) | 0]]
    }
  }
  
  proto.update = function (options) {
    options = options || {}
  
    var shape = options.shape || [0, 0]
  
    var x = options.x || iota(shape[0])
    var y = options.y || iota(shape[1])
    var z = options.z || new Float32Array(shape[0] * shape[1])
  
    var isSmooth = options.zsmooth !== false
  
    this.xData = x
    this.yData = y
  
    var colorLevels = options.colorLevels || [0]
    var colorValues = options.colorValues || [0, 0, 0, 1]
    var colorCount = colorLevels.length
  
    var bounds = this.bounds
    var lox, loy, hix, hiy
    if (isSmooth) {
      lox = bounds[0] = x[0]
      loy = bounds[1] = y[0]
      hix = bounds[2] = x[x.length - 1]
      hiy = bounds[3] = y[y.length - 1]
    } else {
      /* To get squares to centre on data values */
      lox = bounds[0] = x[0] + (x[1] - x[0]) / 2 /* starting x value */
      loy = bounds[1] = y[0] + (y[1] - y[0]) / 2 /* starting y value */
  
      /* Bounds needs to add half a square on each end */
      hix = bounds[2] = x[x.length - 1] + (x[x.length - 1] - x[x.length - 2]) / 2
      hiy = bounds[3] = y[y.length - 1] + (y[y.length - 1] - y[y.length - 2]) / 2
  
      // N.B. Resolution = 1 / range
    }
    var xs = 1.0 / (hix - lox)
    var ys = 1.0 / (hiy - loy)
  
    var numX = shape[0]
    var numY = shape[1]
  
    this.shape = [numX, numY]
  
    var numVerts = (
      isSmooth ? (numX - 1) * (numY - 1) : numX * numY
    ) * (WEIGHTS.length >>> 1)
  
    this.numVertices = numVerts
  
    var colors = pool.mallocUint8(numVerts * 4)
    var positions = pool.mallocFloat32(numVerts * 2)
    var weights   = pool.mallocUint8 (numVerts * 2)
    var ids = pool.mallocUint32(numVerts)
  
    var ptr = 0
  
    var ni = isSmooth ? numX - 1 : numX
    var nj = isSmooth ? numY - 1 : numY
  
    for (var j = 0; j < nj; ++j) {
      var yc0, yc1
  
      if (isSmooth) {
        yc0 =  ys * (y[j] - loy)
        yc1 =  ys * (y[j + 1] - loy)
      } else {
        yc0 = j < numY - 1 ? ys * (y[j] - (y[j + 1] - y[j])/2 - loy) : ys * (y[j] - (y[j] - y[j - 1])/2 - loy)
        yc1 = j < numY - 1 ? ys * (y[j] + (y[j + 1] - y[j])/2 - loy) : ys * (y[j] + (y[j] - y[j - 1])/2 - loy)
      }
  
      for (var i = 0; i < ni; ++i) {
        var xc0, xc1
  
        if (isSmooth) {
          xc0 = xs * (x[i] - lox)
          xc1 = xs * (x[i + 1] - lox)
        } else {
          xc0 = i < numX - 1 ? xs * (x[i] - (x[i + 1] - x[i])/2 - lox) : xs * (x[i] - (x[i] - x[i - 1])/2 - lox)
          xc1 = i < numX - 1 ? xs * (x[i] + (x[i + 1] - x[i])/2 - lox) : xs * (x[i] + (x[i] - x[i - 1])/2 - lox)
        }
  
        for (var dd = 0; dd < WEIGHTS.length; dd += 2) {
          var dx = WEIGHTS[dd]
          var dy = WEIGHTS[dd + 1]
          var offset = isSmooth ? (j + dy) * numX + (i + dx) : j * numX + i
          var zc = z[offset]
          var colorIdx = bsearch.le(colorLevels, zc)
          var r, g, b, a
          if (colorIdx < 0) {
            r = colorValues[0]
            g = colorValues[1]
            b = colorValues[2]
            a = colorValues[3]
          } else if (colorIdx === colorCount - 1) {
            r = colorValues[4 * colorCount - 4]
            g = colorValues[4 * colorCount - 3]
            b = colorValues[4 * colorCount - 2]
            a = colorValues[4 * colorCount - 1]
          } else {
            var t = (zc - colorLevels[colorIdx]) /
              (colorLevels[colorIdx + 1] - colorLevels[colorIdx])
            var ti = 1.0 - t
            var i0 = 4 * colorIdx
            var i1 = 4 * (colorIdx + 1)
            r = ti * colorValues[i0] + t * colorValues[i1]
            g = ti * colorValues[i0 + 1] + t * colorValues[i1 + 1]
            b = ti * colorValues[i0 + 2] + t * colorValues[i1 + 2]
            a = ti * colorValues[i0 + 3] + t * colorValues[i1 + 3]
          }
  
          colors[4 * ptr] = 255 * r
          colors[4 * ptr + 1] = 255 * g
          colors[4 * ptr + 2] = 255 * b
          colors[4 * ptr + 3] = 255 * a
  
          positions[2*ptr] = xc0*.5 + xc1*.5;
          positions[2*ptr+1] = yc0*.5 + yc1*.5;
  
          weights[2*ptr] = dx;
          weights[2*ptr+1] = dy;
  
          ids[ptr] = j * numX + i
  
          ptr += 1
        }
      }
    }
  
    this.positionBuffer.update(positions)
    this.weightBuffer.update(weights)
    this.colorBuffer.update(colors)
    this.idBuffer.update(ids)
  
    pool.free(positions)
    pool.free(colors)
    pool.free(weights)
    pool.free(ids)
  }
  
  proto.dispose = function () {
    this.shader.dispose()
    this.pickShader.dispose()
    this.positionBuffer.dispose()
    this.weightBuffer.dispose()
    this.colorBuffer.dispose()
    this.idBuffer.dispose()
    this.plot.removeObject(this)
  }
  
  function createHeatmap2D (plot, options) {
    var gl = plot.gl
  
    var shader = createShader(gl, shaders.vertex, shaders.fragment)
    var pickShader = createShader(gl, shaders.pickVertex, shaders.pickFragment)
  
    var positionBuffer = createBuffer(gl)
    var weightBuffer   = createBuffer(gl)
    var colorBuffer = createBuffer(gl)
    var idBuffer = createBuffer(gl)
  
    var heatmap = new GLHeatmap2D(
      plot,
      shader,
      pickShader,
      positionBuffer,
      weightBuffer,
      colorBuffer,
      idBuffer)
  
    heatmap.update(options)
    plot.addObject(heatmap)
  
    return heatmap
  }
  
  },{"./lib/shaders":269,"binary-search-bounds":96,"gl-buffer":258,"gl-shader":312,"iota-array":437,"typedarray-pool":567}],269:[function(_dereq_,module,exports){
  'use strict'
  
  var glslify = _dereq_('glslify')
  
  module.exports = {
    fragment:     glslify(["precision lowp float;\n#define GLSLIFY 1\nvarying vec4 fragColor;\nvoid main() {\n  gl_FragColor = vec4(fragColor.rgb * fragColor.a, fragColor.a);\n}\n"]),
    vertex:       glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 color;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  fragColor = color;\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"]),
    pickFragment: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nuniform vec2 shape;\nuniform vec4 pickOffset;\n\nvoid main() {\n  vec2 d = step(.5, vWeight);\n  vec4 id = fragId + pickOffset;\n  id.x += d.x + d.y*shape.x;\n\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  gl_FragColor = id/255.;\n}\n"]),
    pickVertex:   glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\nattribute vec2 weight;\n\nuniform vec2 shape;\nuniform mat3 viewTransform;\n\nvarying vec4 fragId;\nvarying vec2 vWeight;\n\nvoid main() {\n  vWeight = weight;\n\n  fragId = pickId;\n\n  vec3 vPosition = viewTransform * vec3( position + (weight-.5)/(shape-1.) , 1.0);\n  gl_Position = vec4(vPosition.xy, 0, vPosition.z);\n}\n"])
  }
  
  },{"glslify":413}],270:[function(_dereq_,module,exports){
  var glslify       = _dereq_('glslify')
  var createShader  = _dereq_('gl-shader')
  
  var vertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, nextPosition;\nattribute float arcLength, lineWidth;\nattribute vec4 color;\n\nuniform vec2 screenShape;\nuniform float pixelRatio;\nuniform mat4 model, view, projection;\n\nvarying vec4 fragColor;\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  vec4 startPoint = project(position);\n  vec4 endPoint   = project(nextPosition);\n\n  vec2 A = startPoint.xy / startPoint.w;\n  vec2 B =   endPoint.xy /   endPoint.w;\n\n  float clipAngle = atan(\n    (B.y - A.y) * screenShape.y,\n    (B.x - A.x) * screenShape.x\n  );\n\n  vec2 offset = 0.5 * pixelRatio * lineWidth * vec2(\n    sin(clipAngle),\n    -cos(clipAngle)\n  ) / screenShape;\n\n  gl_Position = vec4(startPoint.xy + startPoint.w * offset, startPoint.zw);\n\n  worldPosition = position;\n  pixelArcLength = arcLength;\n  fragColor = color;\n}\n"])
  var forwardFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3      clipBounds[2];\nuniform sampler2D dashTexture;\nuniform float     dashScale;\nuniform float     opacity;\n\nvarying vec3    worldPosition;\nvarying float   pixelArcLength;\nvarying vec4    fragColor;\n\nvoid main() {\n  if (\n    outOfRange(clipBounds[0], clipBounds[1], worldPosition) ||\n    fragColor.a * opacity == 0.\n  ) discard;\n\n  float dashWeight = texture2D(dashTexture, vec2(dashScale * pixelArcLength, 0)).r;\n  if(dashWeight < 0.5) {\n    discard;\n  }\n  gl_FragColor = fragColor * opacity;\n}\n"])
  var pickFrag = glslify(["precision highp float;\n#define GLSLIFY 1\n\n#define FLOAT_MAX  1.70141184e38\n#define FLOAT_MIN  1.17549435e-38\n\n// https://github.com/mikolalysenko/glsl-read-float/blob/master/index.glsl\nvec4 packFloat(float v) {\n  float av = abs(v);\n\n  //Handle special cases\n  if(av < FLOAT_MIN) {\n    return vec4(0.0, 0.0, 0.0, 0.0);\n  } else if(v > FLOAT_MAX) {\n    return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n  } else if(v < -FLOAT_MAX) {\n    return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n  }\n\n  vec4 c = vec4(0,0,0,0);\n\n  //Compute exponent and mantissa\n  float e = floor(log2(av));\n  float m = av * pow(2.0, -e) - 1.0;\n\n  //Unpack mantissa\n  c[1] = floor(128.0 * m);\n  m -= c[1] / 128.0;\n  c[2] = floor(32768.0 * m);\n  m -= c[2] / 32768.0;\n  c[3] = floor(8388608.0 * m);\n\n  //Unpack exponent\n  float ebias = e + 127.0;\n  c[0] = floor(ebias / 2.0);\n  ebias -= c[0] * 2.0;\n  c[1] += floor(ebias) * 128.0;\n\n  //Unpack sign bit\n  c[0] += 128.0 * step(0.0, -v);\n\n  //Scale back to range\n  return c / 255.0;\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform float pickId;\nuniform vec3 clipBounds[2];\n\nvarying vec3 worldPosition;\nvarying float pixelArcLength;\nvarying vec4 fragColor;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], worldPosition)) discard;\n\n  gl_FragColor = vec4(pickId/255.0, packFloat(pixelArcLength).xyz);\n}"])
  
  var ATTRIBUTES = [
    {name: 'position', type: 'vec3'},
    {name: 'nextPosition', type: 'vec3'},
    {name: 'arcLength', type: 'float'},
    {name: 'lineWidth', type: 'float'},
    {name: 'color', type: 'vec4'}
  ]
  
  exports.createShader = function(gl) {
    return createShader(gl, vertSrc, forwardFrag, null, ATTRIBUTES)
  }
  
  exports.createPickShader = function(gl) {
    return createShader(gl, vertSrc, pickFrag, null, ATTRIBUTES)
  }
  
  },{"gl-shader":312,"glslify":413}],271:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createLinePlot
  
  var createBuffer = _dereq_('gl-buffer')
  var createVAO = _dereq_('gl-vao')
  var createTexture = _dereq_('gl-texture2d')
  
  var UINT8_VIEW = new Uint8Array(4)
  var FLOAT_VIEW = new Float32Array(UINT8_VIEW.buffer)
  // https://github.com/mikolalysenko/glsl-read-float/blob/master/index.js
  function unpackFloat(x, y, z, w) {
    UINT8_VIEW[0] = w
    UINT8_VIEW[1] = z
    UINT8_VIEW[2] = y
    UINT8_VIEW[3] = x
    return FLOAT_VIEW[0]
  }
  
  var bsearch = _dereq_('binary-search-bounds')
  var ndarray = _dereq_('ndarray')
  var shaders = _dereq_('./lib/shaders')
  
  var createShader = shaders.createShader
  var createPickShader = shaders.createPickShader
  
  var identity = [1, 0, 0, 0,
    0, 1, 0, 0,
    0, 0, 1, 0,
    0, 0, 0, 1]
  
  function distance (a, b) {
    var s = 0.0
    for (var i = 0; i < 3; ++i) {
      var d = a[i] - b[i]
      s += d * d
    }
    return Math.sqrt(s)
  }
  
  function filterClipBounds (bounds) {
    var result = [[-1e6, -1e6, -1e6], [1e6, 1e6, 1e6]]
    for (var i = 0; i < 3; ++i) {
      result[0][i] = Math.max(bounds[0][i], result[0][i])
      result[1][i] = Math.min(bounds[1][i], result[1][i])
    }
    return result
  }
  
  function PickResult (tau, position, index, dataCoordinate) {
    this.arcLength = tau
    this.position = position
    this.index = index
    this.dataCoordinate = dataCoordinate
  }
  
  function LinePlot (gl, shader, pickShader, buffer, vao, texture) {
    this.gl = gl
    this.shader = shader
    this.pickShader = pickShader
    this.buffer = buffer
    this.vao = vao
    this.clipBounds = [
      [ -Infinity, -Infinity, -Infinity ],
      [ Infinity, Infinity, Infinity ]]
    this.points = []
    this.arcLength = []
    this.vertexCount = 0
    this.bounds = [[0, 0, 0], [0, 0, 0]]
    this.pickId = 0
    this.lineWidth = 1
    this.texture = texture
    this.dashScale = 1
    this.opacity = 1
    this.hasAlpha = false
    this.dirty = true
    this.pixelRatio = 1
  }
  
  var proto = LinePlot.prototype
  
  proto.isTransparent = function () {
    return this.hasAlpha
  }
  
  proto.isOpaque = function () {
    return !this.hasAlpha
  }
  
  proto.pickSlots = 1
  
  proto.setPickBase = function (id) {
    this.pickId = id
  }
  
  proto.drawTransparent = proto.draw = function (camera) {
    if (!this.vertexCount) return
    var gl = this.gl
    var shader = this.shader
    var vao = this.vao
    shader.bind()
    shader.uniforms = {
      model: camera.model || identity,
      view: camera.view || identity,
      projection: camera.projection || identity,
      clipBounds: filterClipBounds(this.clipBounds),
      dashTexture: this.texture.bind(),
      dashScale: this.dashScale / this.arcLength[this.arcLength.length - 1],
      opacity: this.opacity,
      screenShape: [gl.drawingBufferWidth, gl.drawingBufferHeight],
      pixelRatio: this.pixelRatio
    }
    vao.bind()
    vao.draw(gl.TRIANGLE_STRIP, this.vertexCount)
    vao.unbind()
  }
  
  proto.drawPick = function (camera) {
    if (!this.vertexCount) return
    var gl = this.gl
    var shader = this.pickShader
    var vao = this.vao
    shader.bind()
    shader.uniforms = {
      model: camera.model || identity,
      view: camera.view || identity,
      projection: camera.projection || identity,
      pickId: this.pickId,
      clipBounds: filterClipBounds(this.clipBounds),
      screenShape: [gl.drawingBufferWidth, gl.drawingBufferHeight],
      pixelRatio: this.pixelRatio
    }
    vao.bind()
    vao.draw(gl.TRIANGLE_STRIP, this.vertexCount)
    vao.unbind()
  }
  
  proto.update = function (options) {
    var i, j
  
    this.dirty = true
  
    var connectGaps = !!options.connectGaps
  
    if ('dashScale' in options) {
      this.dashScale = options.dashScale
    }
  
    this.hasAlpha = false // default to no transparent draw
    if ('opacity' in options) {
      this.opacity = +options.opacity
      if(this.opacity < 1) {
        this.hasAlpha = true;
      }
    }
  
    // Recalculate buffer data
    var buffer = []
    var arcLengthArray = []
    var pointArray = []
    var arcLength = 0.0
    var vertexCount = 0
    var bounds = [
      [ Infinity, Infinity, Infinity ],
      [ -Infinity, -Infinity, -Infinity ]]
  
    var positions = options.position || options.positions
    if (positions) {
  
      // Default color
      var colors = options.color || options.colors || [0, 0, 0, 1]
  
      var lineWidth = options.lineWidth || 1
  
      var hadGap = false
  
      fill_loop:
      for (i = 1; i < positions.length; ++i) {
        var a = positions[i - 1]
        var b = positions[i]
  
        arcLengthArray.push(arcLength)
        pointArray.push(a.slice())
  
        for (j = 0; j < 3; ++j) {
          if (isNaN(a[j]) || isNaN(b[j]) ||
            !isFinite(a[j]) || !isFinite(b[j])) {
  
            if (!connectGaps && buffer.length > 0) {
              for (var k = 0; k < 24; ++k) {
                buffer.push(buffer[buffer.length - 12])
              }
              vertexCount += 2
              hadGap = true
            }
  
            continue fill_loop
          }
          bounds[0][j] = Math.min(bounds[0][j], a[j], b[j])
          bounds[1][j] = Math.max(bounds[1][j], a[j], b[j])
        }
  
        var acolor, bcolor
        if (Array.isArray(colors[0])) {
          acolor = (colors.length > i - 1) ? colors[i - 1] :             // using index value
                   (colors.length > 0)     ? colors[colors.length - 1] : // using last item
                                             [0, 0, 0, 1];               // using black
  
          bcolor = (colors.length > i) ? colors[i] :                 // using index value
                   (colors.length > 0) ? colors[colors.length - 1] : // using last item
                                         [0, 0, 0, 1];               // using black
        } else {
          acolor = bcolor = colors
        }
  
        if (acolor.length === 3) {
          acolor = [acolor[0], acolor[1], acolor[2], 1]
        }
        if (bcolor.length === 3) {
          bcolor = [bcolor[0], bcolor[1], bcolor[2], 1]
        }
  
        if(!this.hasAlpha && acolor[3] < 1) this.hasAlpha = true
  
        var w0
        if (Array.isArray(lineWidth)) {
          w0 = (lineWidth.length > i - 1) ? lineWidth[i - 1] :                // using index value
               (lineWidth.length > 0)     ? lineWidth[lineWidth.length - 1] : // using last item
                                            [0, 0, 0, 1];                     // using black
        } else {
          w0 = lineWidth
        }
  
        var t0 = arcLength
        arcLength += distance(a, b)
  
        if (hadGap) {
          for (j = 0; j < 2; ++j) {
            buffer.push(
              a[0], a[1], a[2], b[0], b[1], b[2], t0, w0, acolor[0], acolor[1], acolor[2], acolor[3])
          }
          vertexCount += 2
          hadGap = false
        }
  
        buffer.push(
          a[0], a[1], a[2], b[0], b[1], b[2], t0, w0, acolor[0], acolor[1], acolor[2], acolor[3],
          a[0], a[1], a[2], b[0], b[1], b[2], t0, -w0, acolor[0], acolor[1], acolor[2], acolor[3],
          b[0], b[1], b[2], a[0], a[1], a[2], arcLength, -w0, bcolor[0], bcolor[1], bcolor[2], bcolor[3],
          b[0], b[1], b[2], a[0], a[1], a[2], arcLength, w0, bcolor[0], bcolor[1], bcolor[2], bcolor[3])
  
        vertexCount += 4
      }
    }
    this.buffer.update(buffer)
  
    arcLengthArray.push(arcLength)
    pointArray.push(positions[positions.length - 1].slice())
  
    this.bounds = bounds
  
    this.vertexCount = vertexCount
  
    this.points = pointArray
    this.arcLength = arcLengthArray
  
    if ('dashes' in options) {
      var dashArray = options.dashes
  
      // Calculate prefix sum
      var prefixSum = dashArray.slice()
      prefixSum.unshift(0)
      for (i = 1; i < prefixSum.length; ++i) {
        prefixSum[i] = prefixSum[i - 1] + prefixSum[i]
      }
  
      var dashTexture = ndarray(new Array(256 * 4), [256, 1, 4])
      for (i = 0; i < 256; ++i) {
        for (j = 0; j < 4; ++j) {
          dashTexture.set(i, 0, j, 0)
        }
        if (bsearch.le(prefixSum, prefixSum[prefixSum.length - 1] * i / 255.0) & 1) {
          dashTexture.set(i, 0, 0, 0)
        } else {
          dashTexture.set(i, 0, 0, 255)
        }
      }
  
      this.texture.setPixels(dashTexture)
    }
  }
  
  proto.dispose = function () {
    this.shader.dispose()
    this.vao.dispose()
    this.buffer.dispose()
  }
  
  proto.pick = function (selection) {
    if (!selection) {
      return null
    }
    if (selection.id !== this.pickId) {
      return null
    }
    var tau = unpackFloat(
      selection.value[0],
      selection.value[1],
      selection.value[2],
      0)
    var index = bsearch.le(this.arcLength, tau)
    if (index < 0) {
      return null
    }
    if (index === this.arcLength.length - 1) {
      return new PickResult(
        this.arcLength[this.arcLength.length - 1],
        this.points[this.points.length - 1].slice(),
        index)
    }
    var a = this.points[index]
    var b = this.points[Math.min(index + 1, this.points.length - 1)]
    var t = (tau - this.arcLength[index]) / (this.arcLength[index + 1] - this.arcLength[index])
    var ti = 1.0 - t
    var x = [0, 0, 0]
    for (var i = 0; i < 3; ++i) {
      x[i] = ti * a[i] + t * b[i]
    }
    var dataIndex = Math.min((t < 0.5) ? index : (index + 1), this.points.length - 1)
    return new PickResult(
      tau,
      x,
      dataIndex,
      this.points[dataIndex])
  }
  
  function createLinePlot (options) {
    var gl = options.gl || (options.scene && options.scene.gl)
  
    var shader = createShader(gl)
    shader.attributes.position.location = 0
    shader.attributes.nextPosition.location = 1
    shader.attributes.arcLength.location = 2
    shader.attributes.lineWidth.location = 3
    shader.attributes.color.location = 4
  
    var pickShader = createPickShader(gl)
    pickShader.attributes.position.location = 0
    pickShader.attributes.nextPosition.location = 1
    pickShader.attributes.arcLength.location = 2
    pickShader.attributes.lineWidth.location = 3
    pickShader.attributes.color.location = 4
  
    var buffer = createBuffer(gl)
    var vao = createVAO(gl, [
      {
        'buffer': buffer,
        'size': 3,
        'offset': 0,
        'stride': 48
      },
      {
        'buffer': buffer,
        'size': 3,
        'offset': 12,
        'stride': 48
      },
      {
        'buffer': buffer,
        'size': 1,
        'offset': 24,
        'stride': 48
      },
      {
        'buffer': buffer,
        'size': 1,
        'offset': 28,
        'stride': 48
      },
      {
        'buffer': buffer,
        'size': 4,
        'offset': 32,
        'stride': 48
      }
    ])
  
    // Create texture for dash pattern
    var defaultTexture = ndarray(new Array(256 * 4), [256, 1, 4])
    for (var i = 0; i < 256 * 4; ++i) {
      defaultTexture.data[i] = 255
    }
    var texture = createTexture(gl, defaultTexture)
    texture.wrap = gl.REPEAT
  
    var linePlot = new LinePlot(gl, shader, pickShader, buffer, vao, texture)
    linePlot.update(options)
    return linePlot
  }
  
  },{"./lib/shaders":270,"binary-search-bounds":96,"gl-buffer":258,"gl-texture2d":327,"gl-vao":332,"ndarray":469}],272:[function(_dereq_,module,exports){
  module.exports = clone;
  
  /**
   * Creates a new mat4 initialized with values from an existing matrix
   *
   * @param {mat4} a matrix to clone
   * @returns {mat4} a new 4x4 matrix
   */
  function clone(a) {
      var out = new Float32Array(16);
      out[0] = a[0];
      out[1] = a[1];
      out[2] = a[2];
      out[3] = a[3];
      out[4] = a[4];
      out[5] = a[5];
      out[6] = a[6];
      out[7] = a[7];
      out[8] = a[8];
      out[9] = a[9];
      out[10] = a[10];
      out[11] = a[11];
      out[12] = a[12];
      out[13] = a[13];
      out[14] = a[14];
      out[15] = a[15];
      return out;
  };
  },{}],273:[function(_dereq_,module,exports){
  module.exports = create;
  
  /**
   * Creates a new identity mat4
   *
   * @returns {mat4} a new 4x4 matrix
   */
  function create() {
      var out = new Float32Array(16);
      out[0] = 1;
      out[1] = 0;
      out[2] = 0;
      out[3] = 0;
      out[4] = 0;
      out[5] = 1;
      out[6] = 0;
      out[7] = 0;
      out[8] = 0;
      out[9] = 0;
      out[10] = 1;
      out[11] = 0;
      out[12] = 0;
      out[13] = 0;
      out[14] = 0;
      out[15] = 1;
      return out;
  };
  },{}],274:[function(_dereq_,module,exports){
  module.exports = determinant;
  
  /**
   * Calculates the determinant of a mat4
   *
   * @param {mat4} a the source matrix
   * @returns {Number} determinant of a
   */
  function determinant(a) {
      var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
          a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
          a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
          a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],
  
          b00 = a00 * a11 - a01 * a10,
          b01 = a00 * a12 - a02 * a10,
          b02 = a00 * a13 - a03 * a10,
          b03 = a01 * a12 - a02 * a11,
          b04 = a01 * a13 - a03 * a11,
          b05 = a02 * a13 - a03 * a12,
          b06 = a20 * a31 - a21 * a30,
          b07 = a20 * a32 - a22 * a30,
          b08 = a20 * a33 - a23 * a30,
          b09 = a21 * a32 - a22 * a31,
          b10 = a21 * a33 - a23 * a31,
          b11 = a22 * a33 - a23 * a32;
  
      // Calculate the determinant
      return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
  };
  },{}],275:[function(_dereq_,module,exports){
  module.exports = fromQuat;
  
  /**
   * Creates a matrix from a quaternion rotation.
   *
   * @param {mat4} out mat4 receiving operation result
   * @param {quat4} q Rotation quaternion
   * @returns {mat4} out
   */
  function fromQuat(out, q) {
      var x = q[0], y = q[1], z = q[2], w = q[3],
          x2 = x + x,
          y2 = y + y,
          z2 = z + z,
  
          xx = x * x2,
          yx = y * x2,
          yy = y * y2,
          zx = z * x2,
          zy = z * y2,
          zz = z * z2,
          wx = w * x2,
          wy = w * y2,
          wz = w * z2;
  
      out[0] = 1 - yy - zz;
      out[1] = yx + wz;
      out[2] = zx - wy;
      out[3] = 0;
  
      out[4] = yx - wz;
      out[5] = 1 - xx - zz;
      out[6] = zy + wx;
      out[7] = 0;
  
      out[8] = zx + wy;
      out[9] = zy - wx;
      out[10] = 1 - xx - yy;
      out[11] = 0;
  
      out[12] = 0;
      out[13] = 0;
      out[14] = 0;
      out[15] = 1;
  
      return out;
  };
  },{}],276:[function(_dereq_,module,exports){
  module.exports = fromRotationTranslation;
  
  /**
   * Creates a matrix from a quaternion rotation and vector translation
   * This is equivalent to (but much faster than):
   *
   *     mat4.identity(dest);
   *     mat4.translate(dest, vec);
   *     var quatMat = mat4.create();
   *     quat4.toMat4(quat, quatMat);
   *     mat4.multiply(dest, quatMat);
   *
   * @param {mat4} out mat4 receiving operation result
   * @param {quat4} q Rotation quaternion
   * @param {vec3} v Translation vector
   * @returns {mat4} out
   */
  function fromRotationTranslation(out, q, v) {
      // Quaternion math
      var x = q[0], y = q[1], z = q[2], w = q[3],
          x2 = x + x,
          y2 = y + y,
          z2 = z + z,
  
          xx = x * x2,
          xy = x * y2,
          xz = x * z2,
          yy = y * y2,
          yz = y * z2,
          zz = z * z2,
          wx = w * x2,
          wy = w * y2,
          wz = w * z2;
  
      out[0] = 1 - (yy + zz);
      out[1] = xy + wz;
      out[2] = xz - wy;
      out[3] = 0;
      out[4] = xy - wz;
      out[5] = 1 - (xx + zz);
      out[6] = yz + wx;
      out[7] = 0;
      out[8] = xz + wy;
      out[9] = yz - wx;
      out[10] = 1 - (xx + yy);
      out[11] = 0;
      out[12] = v[0];
      out[13] = v[1];
      out[14] = v[2];
      out[15] = 1;
      
      return out;
  };
  },{}],277:[function(_dereq_,module,exports){
  module.exports = identity;
  
  /**
   * Set a mat4 to the identity matrix
   *
   * @param {mat4} out the receiving matrix
   * @returns {mat4} out
   */
  function identity(out) {
      out[0] = 1;
      out[1] = 0;
      out[2] = 0;
      out[3] = 0;
      out[4] = 0;
      out[5] = 1;
      out[6] = 0;
      out[7] = 0;
      out[8] = 0;
      out[9] = 0;
      out[10] = 1;
      out[11] = 0;
      out[12] = 0;
      out[13] = 0;
      out[14] = 0;
      out[15] = 1;
      return out;
  };
  },{}],278:[function(_dereq_,module,exports){
  module.exports = invert;
  
  /**
   * Inverts a mat4
   *
   * @param {mat4} out the receiving matrix
   * @param {mat4} a the source matrix
   * @returns {mat4} out
   */
  function invert(out, a) {
      var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
          a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
          a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
          a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],
  
          b00 = a00 * a11 - a01 * a10,
          b01 = a00 * a12 - a02 * a10,
          b02 = a00 * a13 - a03 * a10,
          b03 = a01 * a12 - a02 * a11,
          b04 = a01 * a13 - a03 * a11,
          b05 = a02 * a13 - a03 * a12,
          b06 = a20 * a31 - a21 * a30,
          b07 = a20 * a32 - a22 * a30,
          b08 = a20 * a33 - a23 * a30,
          b09 = a21 * a32 - a22 * a31,
          b10 = a21 * a33 - a23 * a31,
          b11 = a22 * a33 - a23 * a32,
  
          // Calculate the determinant
          det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
  
      if (!det) { 
          return null; 
      }
      det = 1.0 / det;
  
      out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
      out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
      out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
      out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
      out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
      out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
      out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
      out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
      out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
      out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
      out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
      out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
      out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
      out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
      out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
      out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
  
      return out;
  };
  },{}],279:[function(_dereq_,module,exports){
  var identity = _dereq_('./identity');
  
  module.exports = lookAt;
  
  /**
   * Generates a look-at matrix with the given eye position, focal point, and up axis
   *
   * @param {mat4} out mat4 frustum matrix will be written into
   * @param {vec3} eye Position of the viewer
   * @param {vec3} center Point the viewer is looking at
   * @param {vec3} up vec3 pointing up
   * @returns {mat4} out
   */
  function lookAt(out, eye, center, up) {
      var x0, x1, x2, y0, y1, y2, z0, z1, z2, len,
          eyex = eye[0],
          eyey = eye[1],
          eyez = eye[2],
          upx = up[0],
          upy = up[1],
          upz = up[2],
          centerx = center[0],
          centery = center[1],
          centerz = center[2];
  
      if (Math.abs(eyex - centerx) < 0.000001 &&
          Math.abs(eyey - centery) < 0.000001 &&
          Math.abs(eyez - centerz) < 0.000001) {
          return identity(out);
      }
  
      z0 = eyex - centerx;
      z1 = eyey - centery;
      z2 = eyez - centerz;
  
      len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
      z0 *= len;
      z1 *= len;
      z2 *= len;
  
      x0 = upy * z2 - upz * z1;
      x1 = upz * z0 - upx * z2;
      x2 = upx * z1 - upy * z0;
      len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
      if (!len) {
          x0 = 0;
          x1 = 0;
          x2 = 0;
      } else {
          len = 1 / len;
          x0 *= len;
          x1 *= len;
          x2 *= len;
      }
  
      y0 = z1 * x2 - z2 * x1;
      y1 = z2 * x0 - z0 * x2;
      y2 = z0 * x1 - z1 * x0;
  
      len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
      if (!len) {
          y0 = 0;
          y1 = 0;
          y2 = 0;
      } else {
          len = 1 / len;
          y0 *= len;
          y1 *= len;
          y2 *= len;
      }
  
      out[0] = x0;
      out[1] = y0;
      out[2] = z0;
      out[3] = 0;
      out[4] = x1;
      out[5] = y1;
      out[6] = z1;
      out[7] = 0;
      out[8] = x2;
      out[9] = y2;
      out[10] = z2;
      out[11] = 0;
      out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
      out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
      out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
      out[15] = 1;
  
      return out;
  };
  },{"./identity":277}],280:[function(_dereq_,module,exports){
  module.exports = multiply;
  
  /**
   * Multiplies two mat4's
   *
   * @param {mat4} out the receiving matrix
   * @param {mat4} a the first operand
   * @param {mat4} b the second operand
   * @returns {mat4} out
   */
  function multiply(out, a, b) {
      var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
          a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
          a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
          a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
  
      // Cache only the current line of the second matrix
      var b0  = b[0], b1 = b[1], b2 = b[2], b3 = b[3];  
      out[0] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
      out[1] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
      out[2] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
      out[3] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
  
      b0 = b[4]; b1 = b[5]; b2 = b[6]; b3 = b[7];
      out[4] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
      out[5] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
      out[6] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
      out[7] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
  
      b0 = b[8]; b1 = b[9]; b2 = b[10]; b3 = b[11];
      out[8] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
      out[9] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
      out[10] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
      out[11] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
  
      b0 = b[12]; b1 = b[13]; b2 = b[14]; b3 = b[15];
      out[12] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
      out[13] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
      out[14] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
      out[15] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
      return out;
  };
  },{}],281:[function(_dereq_,module,exports){
  module.exports = ortho;
  
  /**
   * Generates a orthogonal projection matrix with the given bounds
   *
   * @param {mat4} out mat4 frustum matrix will be written into
   * @param {number} left Left bound of the frustum
   * @param {number} right Right bound of the frustum
   * @param {number} bottom Bottom bound of the frustum
   * @param {number} top Top bound of the frustum
   * @param {number} near Near bound of the frustum
   * @param {number} far Far bound of the frustum
   * @returns {mat4} out
   */
  function ortho(out, left, right, bottom, top, near, far) {
      var lr = 1 / (left - right),
          bt = 1 / (bottom - top),
          nf = 1 / (near - far);
      out[0] = -2 * lr;
      out[1] = 0;
      out[2] = 0;
      out[3] = 0;
      out[4] = 0;
      out[5] = -2 * bt;
      out[6] = 0;
      out[7] = 0;
      out[8] = 0;
      out[9] = 0;
      out[10] = 2 * nf;
      out[11] = 0;
      out[12] = (left + right) * lr;
      out[13] = (top + bottom) * bt;
      out[14] = (far + near) * nf;
      out[15] = 1;
      return out;
  };
  },{}],282:[function(_dereq_,module,exports){
  module.exports = perspective;
  
  /**
   * Generates a perspective projection matrix with the given bounds
   *
   * @param {mat4} out mat4 frustum matrix will be written into
   * @param {number} fovy Vertical field of view in radians
   * @param {number} aspect Aspect ratio. typically viewport width/height
   * @param {number} near Near bound of the frustum
   * @param {number} far Far bound of the frustum
   * @returns {mat4} out
   */
  function perspective(out, fovy, aspect, near, far) {
      var f = 1.0 / Math.tan(fovy / 2),
          nf = 1 / (near - far);
      out[0] = f / aspect;
      out[1] = 0;
      out[2] = 0;
      out[3] = 0;
      out[4] = 0;
      out[5] = f;
      out[6] = 0;
      out[7] = 0;
      out[8] = 0;
      out[9] = 0;
      out[10] = (far + near) * nf;
      out[11] = -1;
      out[12] = 0;
      out[13] = 0;
      out[14] = (2 * far * near) * nf;
      out[15] = 0;
      return out;
  };
  },{}],283:[function(_dereq_,module,exports){
  module.exports = rotate;
  
  /**
   * Rotates a mat4 by the given angle
   *
   * @param {mat4} out the receiving matrix
   * @param {mat4} a the matrix to rotate
   * @param {Number} rad the angle to rotate the matrix by
   * @param {vec3} axis the axis to rotate around
   * @returns {mat4} out
   */
  function rotate(out, a, rad, axis) {
      var x = axis[0], y = axis[1], z = axis[2],
          len = Math.sqrt(x * x + y * y + z * z),
          s, c, t,
          a00, a01, a02, a03,
          a10, a11, a12, a13,
          a20, a21, a22, a23,
          b00, b01, b02,
          b10, b11, b12,
          b20, b21, b22;
  
      if (Math.abs(len) < 0.000001) { return null; }
      
      len = 1 / len;
      x *= len;
      y *= len;
      z *= len;
  
      s = Math.sin(rad);
      c = Math.cos(rad);
      t = 1 - c;
  
      a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
      a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
      a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];
  
      // Construct the elements of the rotation matrix
      b00 = x * x * t + c; b01 = y * x * t + z * s; b02 = z * x * t - y * s;
      b10 = x * y * t - z * s; b11 = y * y * t + c; b12 = z * y * t + x * s;
      b20 = x * z * t + y * s; b21 = y * z * t - x * s; b22 = z * z * t + c;
  
      // Perform rotation-specific matrix multiplication
      out[0] = a00 * b00 + a10 * b01 + a20 * b02;
      out[1] = a01 * b00 + a11 * b01 + a21 * b02;
      out[2] = a02 * b00 + a12 * b01 + a22 * b02;
      out[3] = a03 * b00 + a13 * b01 + a23 * b02;
      out[4] = a00 * b10 + a10 * b11 + a20 * b12;
      out[5] = a01 * b10 + a11 * b11 + a21 * b12;
      out[6] = a02 * b10 + a12 * b11 + a22 * b12;
      out[7] = a03 * b10 + a13 * b11 + a23 * b12;
      out[8] = a00 * b20 + a10 * b21 + a20 * b22;
      out[9] = a01 * b20 + a11 * b21 + a21 * b22;
      out[10] = a02 * b20 + a12 * b21 + a22 * b22;
      out[11] = a03 * b20 + a13 * b21 + a23 * b22;
  
      if (a !== out) { // If the source and destination differ, copy the unchanged last row
          out[12] = a[12];
          out[13] = a[13];
          out[14] = a[14];
          out[15] = a[15];
      }
      return out;
  };
  },{}],284:[function(_dereq_,module,exports){
  module.exports = rotateX;
  
  /**
   * Rotates a matrix by the given angle around the X axis
   *
   * @param {mat4} out the receiving matrix
   * @param {mat4} a the matrix to rotate
   * @param {Number} rad the angle to rotate the matrix by
   * @returns {mat4} out
   */
  function rotateX(out, a, rad) {
      var s = Math.sin(rad),
          c = Math.cos(rad),
          a10 = a[4],
          a11 = a[5],
          a12 = a[6],
          a13 = a[7],
          a20 = a[8],
          a21 = a[9],
          a22 = a[10],
          a23 = a[11];
  
      if (a !== out) { // If the source and destination differ, copy the unchanged rows
          out[0]  = a[0];
          out[1]  = a[1];
          out[2]  = a[2];
          out[3]  = a[3];
          out[12] = a[12];
          out[13] = a[13];
          out[14] = a[14];
          out[15] = a[15];
      }
  
      // Perform axis-specific matrix multiplication
      out[4] = a10 * c + a20 * s;
      out[5] = a11 * c + a21 * s;
      out[6] = a12 * c + a22 * s;
      out[7] = a13 * c + a23 * s;
      out[8] = a20 * c - a10 * s;
      out[9] = a21 * c - a11 * s;
      out[10] = a22 * c - a12 * s;
      out[11] = a23 * c - a13 * s;
      return out;
  };
  },{}],285:[function(_dereq_,module,exports){
  module.exports = rotateY;
  
  /**
   * Rotates a matrix by the given angle around the Y axis
   *
   * @param {mat4} out the receiving matrix
   * @param {mat4} a the matrix to rotate
   * @param {Number} rad the angle to rotate the matrix by
   * @returns {mat4} out
   */
  function rotateY(out, a, rad) {
      var s = Math.sin(rad),
          c = Math.cos(rad),
          a00 = a[0],
          a01 = a[1],
          a02 = a[2],
          a03 = a[3],
          a20 = a[8],
          a21 = a[9],
          a22 = a[10],
          a23 = a[11];
  
      if (a !== out) { // If the source and destination differ, copy the unchanged rows
          out[4]  = a[4];
          out[5]  = a[5];
          out[6]  = a[6];
          out[7]  = a[7];
          out[12] = a[12];
          out[13] = a[13];
          out[14] = a[14];
          out[15] = a[15];
      }
  
      // Perform axis-specific matrix multiplication
      out[0] = a00 * c - a20 * s;
      out[1] = a01 * c - a21 * s;
      out[2] = a02 * c - a22 * s;
      out[3] = a03 * c - a23 * s;
      out[8] = a00 * s + a20 * c;
      out[9] = a01 * s + a21 * c;
      out[10] = a02 * s + a22 * c;
      out[11] = a03 * s + a23 * c;
      return out;
  };
  },{}],286:[function(_dereq_,module,exports){
  module.exports = rotateZ;
  
  /**
   * Rotates a matrix by the given angle around the Z axis
   *
   * @param {mat4} out the receiving matrix
   * @param {mat4} a the matrix to rotate
   * @param {Number} rad the angle to rotate the matrix by
   * @returns {mat4} out
   */
  function rotateZ(out, a, rad) {
      var s = Math.sin(rad),
          c = Math.cos(rad),
          a00 = a[0],
          a01 = a[1],
          a02 = a[2],
          a03 = a[3],
          a10 = a[4],
          a11 = a[5],
          a12 = a[6],
          a13 = a[7];
  
      if (a !== out) { // If the source and destination differ, copy the unchanged last row
          out[8]  = a[8];
          out[9]  = a[9];
          out[10] = a[10];
          out[11] = a[11];
          out[12] = a[12];
          out[13] = a[13];
          out[14] = a[14];
          out[15] = a[15];
      }
  
      // Perform axis-specific matrix multiplication
      out[0] = a00 * c + a10 * s;
      out[1] = a01 * c + a11 * s;
      out[2] = a02 * c + a12 * s;
      out[3] = a03 * c + a13 * s;
      out[4] = a10 * c - a00 * s;
      out[5] = a11 * c - a01 * s;
      out[6] = a12 * c - a02 * s;
      out[7] = a13 * c - a03 * s;
      return out;
  };
  },{}],287:[function(_dereq_,module,exports){
  module.exports = scale;
  
  /**
   * Scales the mat4 by the dimensions in the given vec3
   *
   * @param {mat4} out the receiving matrix
   * @param {mat4} a the matrix to scale
   * @param {vec3} v the vec3 to scale the matrix by
   * @returns {mat4} out
   **/
  function scale(out, a, v) {
      var x = v[0], y = v[1], z = v[2];
  
      out[0] = a[0] * x;
      out[1] = a[1] * x;
      out[2] = a[2] * x;
      out[3] = a[3] * x;
      out[4] = a[4] * y;
      out[5] = a[5] * y;
      out[6] = a[6] * y;
      out[7] = a[7] * y;
      out[8] = a[8] * z;
      out[9] = a[9] * z;
      out[10] = a[10] * z;
      out[11] = a[11] * z;
      out[12] = a[12];
      out[13] = a[13];
      out[14] = a[14];
      out[15] = a[15];
      return out;
  };
  },{}],288:[function(_dereq_,module,exports){
  module.exports = translate;
  
  /**
   * Translate a mat4 by the given vector
   *
   * @param {mat4} out the receiving matrix
   * @param {mat4} a the matrix to translate
   * @param {vec3} v vector to translate by
   * @returns {mat4} out
   */
  function translate(out, a, v) {
      var x = v[0], y = v[1], z = v[2],
          a00, a01, a02, a03,
          a10, a11, a12, a13,
          a20, a21, a22, a23;
  
      if (a === out) {
          out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
          out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
          out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
          out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
      } else {
          a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
          a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
          a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];
  
          out[0] = a00; out[1] = a01; out[2] = a02; out[3] = a03;
          out[4] = a10; out[5] = a11; out[6] = a12; out[7] = a13;
          out[8] = a20; out[9] = a21; out[10] = a22; out[11] = a23;
  
          out[12] = a00 * x + a10 * y + a20 * z + a[12];
          out[13] = a01 * x + a11 * y + a21 * z + a[13];
          out[14] = a02 * x + a12 * y + a22 * z + a[14];
          out[15] = a03 * x + a13 * y + a23 * z + a[15];
      }
  
      return out;
  };
  },{}],289:[function(_dereq_,module,exports){
  module.exports = transpose;
  
  /**
   * Transpose the values of a mat4
   *
   * @param {mat4} out the receiving matrix
   * @param {mat4} a the source matrix
   * @returns {mat4} out
   */
  function transpose(out, a) {
      // If we are transposing ourselves we can skip a few steps but have to cache some values
      if (out === a) {
          var a01 = a[1], a02 = a[2], a03 = a[3],
              a12 = a[6], a13 = a[7],
              a23 = a[11];
  
          out[1] = a[4];
          out[2] = a[8];
          out[3] = a[12];
          out[4] = a01;
          out[6] = a[9];
          out[7] = a[13];
          out[8] = a02;
          out[9] = a12;
          out[11] = a[14];
          out[12] = a03;
          out[13] = a13;
          out[14] = a23;
      } else {
          out[0] = a[0];
          out[1] = a[4];
          out[2] = a[8];
          out[3] = a[12];
          out[4] = a[1];
          out[5] = a[5];
          out[6] = a[9];
          out[7] = a[13];
          out[8] = a[2];
          out[9] = a[6];
          out[10] = a[10];
          out[11] = a[14];
          out[12] = a[3];
          out[13] = a[7];
          out[14] = a[11];
          out[15] = a[15];
      }
      
      return out;
  };
  },{}],290:[function(_dereq_,module,exports){
  'use strict'
  
  var barycentric            = _dereq_('barycentric')
  var closestPointToTriangle = _dereq_('polytope-closest-point/lib/closest_point_2d.js')
  
  module.exports = closestPointToPickLocation
  
  function xformMatrix(m, v) {
    var out = [0,0,0,0]
    for(var i=0; i<4; ++i) {
      for(var j=0; j<4; ++j) {
        out[j] += m[4*i + j] * v[i]
      }
    }
    return out
  }
  
  function projectVertex(v, model, view, projection, resolution) {
    var p = xformMatrix(projection,
              xformMatrix(view,
                xformMatrix(model, [v[0], v[1], v[2], 1])))
    for(var i=0; i<3; ++i) {
      p[i] /= p[3]
    }
    return [ 0.5 * resolution[0] * (1.0+p[0]), 0.5 * resolution[1] * (1.0-p[1]) ]
  }
  
  function barycentricCoord(simplex, point) {
    if(simplex.length === 2) {
      var d0 = 0.0
      var d1 = 0.0
      for(var i=0; i<2; ++i) {
        d0 += Math.pow(point[i] - simplex[0][i], 2)
        d1 += Math.pow(point[i] - simplex[1][i], 2)
      }
      d0 = Math.sqrt(d0)
      d1 = Math.sqrt(d1)
      if(d0+d1 < 1e-6) {
        return [1,0]
      }
      return [d1/(d0+d1),d0/(d1+d0)]
    } else if(simplex.length === 3) {
      var closestPoint = [0,0]
      closestPointToTriangle(simplex[0], simplex[1], simplex[2], point, closestPoint)
      return barycentric(simplex, closestPoint)
    }
    return []
  }
  
  function interpolate(simplex, weights) {
    var result = [0,0,0]
    for(var i=0; i<simplex.length; ++i) {
      var p = simplex[i]
      var w = weights[i]
      for(var j=0; j<3; ++j) {
        result[j] += w * p[j]
      }
    }
    return result
  }
  
  function closestPointToPickLocation(simplex, pixelCoord, model, view, projection, resolution) {
    if(simplex.length === 1) {
      return [0, simplex[0].slice()]
    }
    var simplex2D = new Array(simplex.length)
    for(var i=0; i<simplex.length; ++i) {
      simplex2D[i] = projectVertex(simplex[i], model, view, projection, resolution);
    }
  
    var closestIndex = 0
    var closestDist  = Infinity
    for(var i=0; i<simplex2D.length; ++i) {
      var d2 = 0.0
      for(var j=0; j<2; ++j) {
        d2 += Math.pow(simplex2D[i][j] - pixelCoord[j], 2)
      }
      if(d2 < closestDist) {
        closestDist  = d2
        closestIndex = i
      }
    }
  
    var weights = barycentricCoord(simplex2D, pixelCoord)
    var s = 0.0
    for(var i=0; i<3; ++i) {
      if(weights[i] < -0.001 ||
         weights[i] > 1.0001) {
        return null
      }
      s += weights[i]
    }
    if(Math.abs(s - 1.0) > 0.001) {
      return null
    }
    return [closestIndex, interpolate(simplex, weights), weights]
  }
  },{"barycentric":78,"polytope-closest-point/lib/closest_point_2d.js":499}],291:[function(_dereq_,module,exports){
  var glslify       = _dereq_('glslify')
  
  var triVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position, normal;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model\n           , view\n           , projection\n           , inverseModel;\nuniform vec3 eyePosition\n           , lightPosition;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvec4 project(vec3 p) {\n  return projection * view * model * vec4(p, 1.0);\n}\n\nvoid main() {\n  gl_Position      = project(position);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * vec4(position , 1.0);\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal  = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  f_color          = color;\n  f_data           = position;\n  f_uv             = uv;\n}\n"])
  var triFragSrc = glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\n//#pragma glslify: beckmann = require(glsl-specular-beckmann) // used in gl-surface3d\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness\n            , fresnel\n            , kambient\n            , kdiffuse\n            , kspecular;\nuniform sampler2D texture;\n\nvarying vec3 f_normal\n           , f_lightDirection\n           , f_eyeDirection\n           , f_data;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (f_color.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], f_data)\n  ) discard;\n\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  //float specular = max(0.0, beckmann(L, V, N, roughness)); // used in gl-surface3d\n\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = vec4(f_color.rgb, 1.0) * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * f_color.a;\n}\n"])
  var edgeVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\n\nuniform mat4 model, view, projection;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_color = color;\n  f_data  = position;\n  f_uv    = uv;\n}"])
  var edgeFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec3 f_data;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_data)) discard;\n\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"])
  var pointVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 uv;\nattribute float pointSize;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0 ,0.0 ,0.0);\n  } else {\n    gl_Position = projection * view * model * vec4(position, 1.0);\n  }\n  gl_PointSize = pointSize;\n  f_color = color;\n  f_uv = uv;\n}"])
  var pointFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D texture;\nuniform float opacity;\n\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  vec2 pointR = gl_PointCoord.xy - vec2(0.5, 0.5);\n  if(dot(pointR, pointR) > 0.25) {\n    discard;\n  }\n  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;\n}"])
  var pickVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n  f_id        = id;\n  f_position  = position;\n}"])
  var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"])
  var pickPointVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3  position;\nattribute float pointSize;\nattribute vec4  id;\n\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0.0, 0.0, 0.0, 0.0);\n  } else {\n    gl_Position  = projection * view * model * vec4(position, 1.0);\n    gl_PointSize = pointSize;\n  }\n  f_id         = id;\n  f_position   = position;\n}"])
  var contourVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec3 position;\n\nuniform mat4 model, view, projection;\n\nvoid main() {\n  gl_Position = projection * view * model * vec4(position, 1.0);\n}"])
  var contourFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform vec3 contourColor;\n\nvoid main() {\n  gl_FragColor = vec4(contourColor, 1.0);\n}\n"])
  
  exports.meshShader = {
    vertex:   triVertSrc,
    fragment: triFragSrc,
    attributes: [
      {name: 'position', type: 'vec3'},
      {name: 'normal', type: 'vec3'},
      {name: 'color', type: 'vec4'},
      {name: 'uv', type: 'vec2'}
    ]
  }
  exports.wireShader = {
    vertex:   edgeVertSrc,
    fragment: edgeFragSrc,
    attributes: [
      {name: 'position', type: 'vec3'},
      {name: 'color', type: 'vec4'},
      {name: 'uv', type: 'vec2'}
    ]
  }
  exports.pointShader = {
    vertex:   pointVertSrc,
    fragment: pointFragSrc,
    attributes: [
      {name: 'position', type: 'vec3'},
      {name: 'color', type: 'vec4'},
      {name: 'uv', type: 'vec2'},
      {name: 'pointSize', type: 'float'}
    ]
  }
  exports.pickShader = {
    vertex:   pickVertSrc,
    fragment: pickFragSrc,
    attributes: [
      {name: 'position', type: 'vec3'},
      {name: 'id', type: 'vec4'}
    ]
  }
  exports.pointPickShader = {
    vertex:   pickPointVertSrc,
    fragment: pickFragSrc,
    attributes: [
      {name: 'position', type: 'vec3'},
      {name: 'pointSize', type: 'float'},
      {name: 'id', type: 'vec4'}
    ]
  }
  exports.contourShader = {
    vertex:   contourVertSrc,
    fragment: contourFragSrc,
    attributes: [
      {name: 'position', type: 'vec3'}
    ]
  }
  
  },{"glslify":413}],292:[function(_dereq_,module,exports){
  'use strict'
  
  var DEFAULT_VERTEX_NORMALS_EPSILON = 1e-6; // may be too large if triangles are very small
  var DEFAULT_FACE_NORMALS_EPSILON = 1e-6;
  
  var createShader  = _dereq_('gl-shader')
  var createBuffer  = _dereq_('gl-buffer')
  var createVAO     = _dereq_('gl-vao')
  var createTexture = _dereq_('gl-texture2d')
  var normals       = _dereq_('normals')
  var multiply      = _dereq_('gl-mat4/multiply')
  var invert        = _dereq_('gl-mat4/invert')
  var ndarray       = _dereq_('ndarray')
  var colormap      = _dereq_('colormap')
  var getContour    = _dereq_('simplicial-complex-contour')
  var pool          = _dereq_('typedarray-pool')
  var shaders       = _dereq_('./lib/shaders')
  var closestPoint  = _dereq_('./lib/closest-point')
  
  var meshShader    = shaders.meshShader
  var wireShader    = shaders.wireShader
  var pointShader   = shaders.pointShader
  var pickShader    = shaders.pickShader
  var pointPickShader = shaders.pointPickShader
  var contourShader = shaders.contourShader
  
  var IDENTITY = [
    1,0,0,0,
    0,1,0,0,
    0,0,1,0,
    0,0,0,1]
  
  
  function SimplicialMesh(gl
    , texture
    , triShader
    , lineShader
    , pointShader
    , pickShader
    , pointPickShader
    , contourShader
    , trianglePositions
    , triangleIds
    , triangleColors
    , triangleUVs
    , triangleNormals
    , triangleVAO
    , edgePositions
    , edgeIds
    , edgeColors
    , edgeUVs
    , edgeVAO
    , pointPositions
    , pointIds
    , pointColors
    , pointUVs
    , pointSizes
    , pointVAO
    , contourPositions
    , contourVAO) {
  
    this.gl                = gl
    this.pixelRatio         = 1
    this.cells             = []
    this.positions         = []
    this.intensity         = []
    this.texture           = texture
    this.dirty             = true
  
    this.triShader         = triShader
    this.lineShader        = lineShader
    this.pointShader       = pointShader
    this.pickShader        = pickShader
    this.pointPickShader   = pointPickShader
    this.contourShader     = contourShader
  
    this.trianglePositions = trianglePositions
    this.triangleColors    = triangleColors
    this.triangleNormals   = triangleNormals
    this.triangleUVs       = triangleUVs
    this.triangleIds       = triangleIds
    this.triangleVAO       = triangleVAO
    this.triangleCount     = 0
  
    this.lineWidth         = 1
    this.edgePositions     = edgePositions
    this.edgeColors        = edgeColors
    this.edgeUVs           = edgeUVs
    this.edgeIds           = edgeIds
    this.edgeVAO           = edgeVAO
    this.edgeCount         = 0
  
    this.pointPositions    = pointPositions
    this.pointColors       = pointColors
    this.pointUVs          = pointUVs
    this.pointSizes        = pointSizes
    this.pointIds          = pointIds
    this.pointVAO          = pointVAO
    this.pointCount        = 0
  
    this.contourLineWidth  = 1
    this.contourPositions  = contourPositions
    this.contourVAO        = contourVAO
    this.contourCount      = 0
    this.contourColor      = [0,0,0]
    this.contourEnable     = true
  
    this.pickVertex        = true;
    this.pickId            = 1
    this.bounds            = [
      [ Infinity, Infinity, Infinity],
      [-Infinity,-Infinity,-Infinity] ]
    this.clipBounds        = [
      [-Infinity,-Infinity,-Infinity],
      [ Infinity, Infinity, Infinity] ]
  
    this.lightPosition = [1e5, 1e5, 0]
    this.ambientLight  = 0.8
    this.diffuseLight  = 0.8
    this.specularLight = 2.0
    this.roughness     = 0.5
    this.fresnel       = 1.5
  
    this.opacity       = 1.0
    this.hasAlpha      = false
    this.opacityscale  = false
  
    this._model       = IDENTITY
    this._view        = IDENTITY
    this._projection  = IDENTITY
    this._resolution  = [1,1]
  }
  
  var proto = SimplicialMesh.prototype
  
  proto.isOpaque = function() {
    return !this.hasAlpha
  }
  
  proto.isTransparent = function() {
    return this.hasAlpha
  }
  
  proto.pickSlots = 1
  
  proto.setPickBase = function(id) {
    this.pickId = id
  }
  
  function getOpacityFromScale(ratio, opacityscale) {
  
    if(!opacityscale) return 1
    if(!opacityscale.length) return 1
  
    for(var i = 0; i < opacityscale.length; ++i) {
      if(opacityscale.length < 2) return 1
      if(opacityscale[i][0] === ratio) return opacityscale[i][1]
      if(opacityscale[i][0] > ratio && i > 0) {
        var d = (opacityscale[i][0] - ratio) / (opacityscale[i][0] - opacityscale[i - 1][0])
        return opacityscale[i][1] * (1 - d) + d * opacityscale[i - 1][1]
      }
    }
  
    return 1
  }
  
  function genColormap(param, opacityscale) {
    var colors = colormap({
        colormap: param
      , nshades:  256
      , format:  'rgba'
    })
  
    var result = new Uint8Array(256*4)
    for(var i=0; i<256; ++i) {
      var c = colors[i]
      for(var j=0; j<3; ++j) {
        result[4*i+j] = c[j]
      }
      if(!opacityscale) {
        result[4*i+3] = 255 * c[3]
      } else {
        result[4*i+3] = 255 * getOpacityFromScale(i / 255.0, opacityscale)
      }
    }
  
    return ndarray(result, [256,256,4], [4,0,1])
  }
  
  function takeZComponent(array) {
    var n = array.length
    var result = new Array(n)
    for(var i=0; i<n; ++i) {
      result[i] = array[i][2]
    }
    return result
  }
  
  proto.highlight = function(selection) {
    if(!selection || !this.contourEnable) {
      this.contourCount = 0
      return
    }
    var level = getContour(this.cells, this.intensity, selection.intensity)
    var cells         = level.cells
    var vertexIds     = level.vertexIds
    var vertexWeights = level.vertexWeights
    var numCells = cells.length
    var result = pool.mallocFloat32(2 * 3 * numCells)
    var ptr = 0
    for(var i=0; i<numCells; ++i) {
      var c = cells[i]
      for(var j=0; j<2; ++j) {
        var v = c[0]
        if(c.length === 2) {
          v = c[j]
        }
        var a = vertexIds[v][0]
        var b = vertexIds[v][1]
        var w = vertexWeights[v]
        var wi = 1.0 - w
        var pa = this.positions[a]
        var pb = this.positions[b]
        for(var k=0; k<3; ++k) {
          result[ptr++] = w * pa[k] + wi * pb[k]
        }
      }
    }
    this.contourCount = (ptr / 3)|0
    this.contourPositions.update(result.subarray(0, ptr))
    pool.free(result)
  }
  
  proto.update = function(params) {
    params = params || {}
    var gl = this.gl
  
    this.dirty = true
  
    if('contourEnable' in params) {
      this.contourEnable = params.contourEnable
    }
    if('contourColor' in params) {
      this.contourColor = params.contourColor
    }
    if('lineWidth' in params) {
      this.lineWidth = params.lineWidth
    }
    if('lightPosition' in params) {
      this.lightPosition = params.lightPosition
    }
  
    this.hasAlpha = false // default to no transparent draw
    if('opacity' in params) {
      this.opacity = params.opacity
      if(this.opacity < 1) {
        this.hasAlpha = true;
      }
    }
    if('opacityscale' in params) {
      this.opacityscale = params.opacityscale
      this.hasAlpha = true;
    }
  
    if('ambient' in params) {
      this.ambientLight  = params.ambient
    }
    if('diffuse' in params) {
      this.diffuseLight = params.diffuse
    }
    if('specular' in params) {
      this.specularLight = params.specular
    }
    if('roughness' in params) {
      this.roughness = params.roughness
    }
    if('fresnel' in params) {
      this.fresnel = params.fresnel
    }
  
    if(params.texture) {
      this.texture.dispose()
      this.texture = createTexture(gl, params.texture)
    } else if (params.colormap) {
      this.texture.shape = [256,256]
      this.texture.minFilter = gl.LINEAR_MIPMAP_LINEAR
      this.texture.magFilter = gl.LINEAR
      this.texture.setPixels(genColormap(params.colormap, this.opacityscale))
      this.texture.generateMipmap()
    }
  
    var cells = params.cells
    var positions = params.positions
  
    if(!positions || !cells) {
      return
    }
  
    var tPos = []
    var tCol = []
    var tNor = []
    var tUVs = []
    var tIds = []
  
    var ePos = []
    var eCol = []
    var eUVs = []
    var eIds = []
  
    var pPos = []
    var pCol = []
    var pUVs = []
    var pSiz = []
    var pIds = []
  
    //Save geometry data for picking calculations
    this.cells     = cells
    this.positions = positions
  
    //Compute normals
    var vertexNormals = params.vertexNormals
    var cellNormals   = params.cellNormals
    var vertexNormalsEpsilon = params.vertexNormalsEpsilon === void(0) ? DEFAULT_VERTEX_NORMALS_EPSILON : params.vertexNormalsEpsilon
    var faceNormalsEpsilon = params.faceNormalsEpsilon === void(0) ? DEFAULT_FACE_NORMALS_EPSILON : params.faceNormalsEpsilon
    if(params.useFacetNormals && !cellNormals) {
      cellNormals = normals.faceNormals(cells, positions, faceNormalsEpsilon)
    }
    if(!cellNormals && !vertexNormals) {
      vertexNormals = normals.vertexNormals(cells, positions, vertexNormalsEpsilon)
    }
  
    //Compute colors
    var vertexColors    = params.vertexColors
    var cellColors      = params.cellColors
    var meshColor       = params.meshColor || [1,1,1,1]
  
    //UVs
    var vertexUVs       = params.vertexUVs
    var vertexIntensity = params.vertexIntensity
    var cellUVs         = params.cellUVs
    var cellIntensity   = params.cellIntensity
  
    var intensityLo     = Infinity
    var intensityHi     = -Infinity
    if(!vertexUVs && !cellUVs) {
      if(vertexIntensity) {
        if(params.vertexIntensityBounds) {
          intensityLo = +params.vertexIntensityBounds[0]
          intensityHi = +params.vertexIntensityBounds[1]
        } else {
          for(var i=0; i<vertexIntensity.length; ++i) {
            var f = vertexIntensity[i]
            intensityLo = Math.min(intensityLo, f)
            intensityHi = Math.max(intensityHi, f)
          }
        }
      } else if(cellIntensity) {
        if(params.cellIntensityBounds) {
          intensityLo = +params.cellIntensityBounds[0]
          intensityHi = +params.cellIntensityBounds[1]
        } else {
          for(var i=0; i<cellIntensity.length; ++i) {
            var f = cellIntensity[i]
            intensityLo = Math.min(intensityLo, f)
            intensityHi = Math.max(intensityHi, f)
          }
        }
      } else {
        for(var i=0; i<positions.length; ++i) {
          var f = positions[i][2]
          intensityLo = Math.min(intensityLo, f)
          intensityHi = Math.max(intensityHi, f)
        }
      }
    }
  
    if(vertexIntensity) {
      this.intensity = vertexIntensity
    } else if(cellIntensity) {
      this.intensity = cellIntensity
    } else {
      this.intensity = takeZComponent(positions)
    }
  
    this.pickVertex = !(cellIntensity || cellColors)
  
    //Point size
    var pointSizes      = params.pointSizes
    var meshPointSize   = params.pointSize || 1.0
  
    //Update bounds
    this.bounds       = [[Infinity,Infinity,Infinity], [-Infinity,-Infinity,-Infinity]]
    for(var i=0; i<positions.length; ++i) {
      var p = positions[i]
      for(var j=0; j<3; ++j) {
        if(isNaN(p[j]) || !isFinite(p[j])) {
          continue
        }
        this.bounds[0][j] = Math.min(this.bounds[0][j], p[j])
        this.bounds[1][j] = Math.max(this.bounds[1][j], p[j])
      }
    }
  
    //Pack cells into buffers
    var triangleCount = 0
    var edgeCount = 0
    var pointCount = 0
  
  fill_loop:
    for(var i=0; i<cells.length; ++i) {
      var cell = cells[i]
      switch(cell.length) {
        case 1:
  
          var v = cell[0]
          var p = positions[v]
  
          //Check NaNs
          for(var j=0; j<3; ++j) {
            if(isNaN(p[j]) || !isFinite(p[j])) {
              continue fill_loop
            }
          }
  
          pPos.push(p[0], p[1], p[2])
  
          var c
          if(vertexColors) {
            c = vertexColors[v]
          } else if(cellColors) {
            c = cellColors[i]
          } else {
            c = meshColor
          }
          if(this.opacityscale && vertexIntensity) {
            tCol.push(c[0], c[1], c[2],
              this.opacity * getOpacityFromScale(
                (vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo),
                this.opacityscale
              )
            )
          } else if(c.length === 3) {
            pCol.push(c[0], c[1], c[2], this.opacity)
          } else {
            pCol.push(c[0], c[1], c[2], c[3] * this.opacity)
            if(c[3] < 1) this.hasAlpha = true
          }
  
          var uv
          if(vertexUVs) {
            uv = vertexUVs[v]
          } else if(vertexIntensity) {
            uv = [
              (vertexIntensity[v] - intensityLo) /
              (intensityHi - intensityLo), 0]
          } else if(cellUVs) {
            uv = cellUVs[i]
          } else if(cellIntensity) {
            uv = [
              (cellIntensity[i] - intensityLo) /
              (intensityHi - intensityLo), 0]
          } else {
            uv = [
              (p[2] - intensityLo) /
              (intensityHi - intensityLo), 0]
          }
          pUVs.push(uv[0], uv[1])
  
          if(pointSizes) {
            pSiz.push(pointSizes[v])
          } else {
            pSiz.push(meshPointSize)
          }
  
          pIds.push(i)
  
          pointCount += 1
        break
  
        case 2:
  
          //Check NaNs
          for(var j=0; j<2; ++j) {
            var v = cell[j]
            var p = positions[v]
            for(var k=0; k<3; ++k) {
              if(isNaN(p[k]) || !isFinite(p[k])) {
                continue fill_loop
              }
            }
          }
  
          for(var j=0; j<2; ++j) {
            var v = cell[j]
            var p = positions[v]
  
            ePos.push(p[0], p[1], p[2])
  
            var c
            if(vertexColors) {
              c = vertexColors[v]
            } else if(cellColors) {
              c = cellColors[i]
            } else {
              c = meshColor
            }
            if(this.opacityscale && vertexIntensity) {
              tCol.push(c[0], c[1], c[2],
                this.opacity * getOpacityFromScale(
                  (vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo),
                  this.opacityscale
                )
              )
            } else if(c.length === 3) {
              eCol.push(c[0], c[1], c[2], this.opacity)
            } else {
              eCol.push(c[0], c[1], c[2], c[3] * this.opacity)
              if(c[3] < 1) this.hasAlpha = true
            }
  
            var uv
            if(vertexUVs) {
              uv = vertexUVs[v]
            } else if(vertexIntensity) {
              uv = [
                (vertexIntensity[v] - intensityLo) /
                (intensityHi - intensityLo), 0]
            } else if(cellUVs) {
              uv = cellUVs[i]
            } else if(cellIntensity) {
              uv = [
                (cellIntensity[i] - intensityLo) /
                (intensityHi - intensityLo), 0]
            } else {
              uv = [
                (p[2] - intensityLo) /
                (intensityHi - intensityLo), 0]
            }
            eUVs.push(uv[0], uv[1])
  
            eIds.push(i)
          }
          edgeCount += 1
        break
  
        case 3:
          //Check NaNs
          for(var j=0; j<3; ++j) {
            var v = cell[j]
            var p = positions[v]
            for(var k=0; k<3; ++k) {
              if(isNaN(p[k]) || !isFinite(p[k])) {
                continue fill_loop
              }
            }
          }
  
          for(var j=0; j<3; ++j) {
            var v = cell[2 - j]
  
            var p = positions[v]
            tPos.push(p[0], p[1], p[2])
  
            var c
            if(vertexColors) {
              c = vertexColors[v]
            } else if(cellColors) {
              c = cellColors[i]
            } else {
              c = meshColor
            }
  
            if(!c) {
              tCol.push(0.5,0.5,0.5,1)
            } else if(this.opacityscale && vertexIntensity) {
              tCol.push(c[0], c[1], c[2],
                this.opacity * getOpacityFromScale(
                  (vertexIntensity[v] - intensityLo) / (intensityHi - intensityLo),
                  this.opacityscale
                )
              )
            } else if(c.length === 3) {
              tCol.push(c[0], c[1], c[2], this.opacity)
            } else {
              tCol.push(c[0], c[1], c[2], c[3] * this.opacity)
              if(c[3] < 1) this.hasAlpha = true
            }
  
            var uv
            if(vertexUVs) {
              uv = vertexUVs[v]
            } else if(vertexIntensity) {
              uv = [
                (vertexIntensity[v] - intensityLo) /
                (intensityHi - intensityLo), 0]
            } else if(cellUVs) {
              uv = cellUVs[i]
            } else if(cellIntensity) {
              uv = [
                (cellIntensity[i] - intensityLo) /
                (intensityHi - intensityLo), 0]
            } else {
              uv = [
                (p[2] - intensityLo) /
                (intensityHi - intensityLo), 0]
            }
            tUVs.push(uv[0], uv[1])
  
            var q
            if(vertexNormals) {
              q = vertexNormals[v]
            } else {
              q = cellNormals[i]
            }
            tNor.push(q[0], q[1], q[2])
  
            tIds.push(i)
          }
          triangleCount += 1
        break
  
        default:
        break
      }
    }
  
    this.pointCount     = pointCount
    this.edgeCount      = edgeCount
    this.triangleCount  = triangleCount
  
    this.pointPositions.update(pPos)
    this.pointColors.update(pCol)
    this.pointUVs.update(pUVs)
    this.pointSizes.update(pSiz)
    this.pointIds.update(new Uint32Array(pIds))
  
    this.edgePositions.update(ePos)
    this.edgeColors.update(eCol)
    this.edgeUVs.update(eUVs)
    this.edgeIds.update(new Uint32Array(eIds))
  
    this.trianglePositions.update(tPos)
    this.triangleColors.update(tCol)
    this.triangleUVs.update(tUVs)
    this.triangleNormals.update(tNor)
    this.triangleIds.update(new Uint32Array(tIds))
  }
  
  proto.drawTransparent = proto.draw = function(params) {
    params = params || {}
    var gl          = this.gl
    var model       = params.model      || IDENTITY
    var view        = params.view       || IDENTITY
    var projection  = params.projection || IDENTITY
  
    var clipBounds = [[-1e6,-1e6,-1e6],[1e6,1e6,1e6]]
    for(var i=0; i<3; ++i) {
      clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i])
      clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i])
    }
  
    var uniforms = {
      model:      model,
      view:       view,
      projection: projection,
      inverseModel: IDENTITY.slice(),
  
      clipBounds: clipBounds,
  
      kambient:   this.ambientLight,
      kdiffuse:   this.diffuseLight,
      kspecular:  this.specularLight,
      roughness:  this.roughness,
      fresnel:    this.fresnel,
  
      eyePosition:   [0,0,0],
      lightPosition: [0,0,0],
  
      contourColor: this.contourColor,
  
      texture:    0
    }
  
    uniforms.inverseModel = invert(uniforms.inverseModel, uniforms.model)
  
    gl.disable(gl.CULL_FACE)
  
    this.texture.bind(0)
  
    var invCameraMatrix = new Array(16)
    multiply(invCameraMatrix, uniforms.view, uniforms.model)
    multiply(invCameraMatrix, uniforms.projection, invCameraMatrix)
    invert(invCameraMatrix, invCameraMatrix)
  
    for(var i=0; i<3; ++i) {
      uniforms.eyePosition[i] = invCameraMatrix[12+i] / invCameraMatrix[15]
    }
  
    var w = invCameraMatrix[15]
    for(var i=0; i<3; ++i) {
      w += this.lightPosition[i] * invCameraMatrix[4*i+3]
    }
    for(var i=0; i<3; ++i) {
      var s = invCameraMatrix[12+i]
      for(var j=0; j<3; ++j) {
        s += invCameraMatrix[4*j+i] * this.lightPosition[j]
      }
      uniforms.lightPosition[i] = s / w
    }
  
    if(this.triangleCount > 0) {
      var shader = this.triShader
      shader.bind()
      shader.uniforms = uniforms
  
      this.triangleVAO.bind()
      gl.drawArrays(gl.TRIANGLES, 0, this.triangleCount*3)
      this.triangleVAO.unbind()
    }
  
    if(this.edgeCount > 0 && this.lineWidth > 0) {
      var shader = this.lineShader
      shader.bind()
      shader.uniforms = uniforms
  
      this.edgeVAO.bind()
      gl.lineWidth(this.lineWidth * this.pixelRatio)
      gl.drawArrays(gl.LINES, 0, this.edgeCount*2)
      this.edgeVAO.unbind()
    }
  
    if(this.pointCount > 0) {
      var shader = this.pointShader
      shader.bind()
      shader.uniforms = uniforms
  
      this.pointVAO.bind()
      gl.drawArrays(gl.POINTS, 0, this.pointCount)
      this.pointVAO.unbind()
    }
  
    if(this.contourEnable && this.contourCount > 0 && this.contourLineWidth > 0) {
      var shader = this.contourShader
      shader.bind()
      shader.uniforms = uniforms
  
      this.contourVAO.bind()
      gl.drawArrays(gl.LINES, 0, this.contourCount)
      this.contourVAO.unbind()
    }
  }
  
  proto.drawPick = function(params) {
    params = params || {}
  
    var gl         = this.gl
  
    var model      = params.model      || IDENTITY
    var view       = params.view       || IDENTITY
    var projection = params.projection || IDENTITY
  
    var clipBounds = [[-1e6,-1e6,-1e6],[1e6,1e6,1e6]]
    for(var i=0; i<3; ++i) {
      clipBounds[0][i] = Math.max(clipBounds[0][i], this.clipBounds[0][i])
      clipBounds[1][i] = Math.min(clipBounds[1][i], this.clipBounds[1][i])
    }
  
    //Save camera parameters
    this._model      = [].slice.call(model)
    this._view       = [].slice.call(view)
    this._projection = [].slice.call(projection)
    this._resolution = [gl.drawingBufferWidth, gl.drawingBufferHeight]
  
    var uniforms = {
      model:      model,
      view:       view,
      projection: projection,
      clipBounds: clipBounds,
      pickId:     this.pickId / 255.0,
    }
  
    var shader = this.pickShader
    shader.bind()
    shader.uniforms = uniforms
  
    if(this.triangleCount > 0) {
      this.triangleVAO.bind()
      gl.drawArrays(gl.TRIANGLES, 0, this.triangleCount*3)
      this.triangleVAO.unbind()
    }
  
    if(this.edgeCount > 0) {
      this.edgeVAO.bind()
      gl.lineWidth(this.lineWidth * this.pixelRatio)
      gl.drawArrays(gl.LINES, 0, this.edgeCount*2)
      this.edgeVAO.unbind()
    }
  
    if(this.pointCount > 0) {
      var shader = this.pointPickShader
      shader.bind()
      shader.uniforms = uniforms
  
      this.pointVAO.bind()
      gl.drawArrays(gl.POINTS, 0, this.pointCount)
      this.pointVAO.unbind()
    }
  }
  
  
  proto.pick = function(pickData) {
    if(!pickData) {
      return null
    }
    if(pickData.id !== this.pickId) {
      return null
    }
  
    var cellId    = pickData.value[0] + 256*pickData.value[1] + 65536*pickData.value[2]
    var cell      = this.cells[cellId]
    var positions = this.positions
  
    var simplex   = new Array(cell.length)
    for(var i=0; i<cell.length; ++i) {
      simplex[i] = positions[cell[i]]
    }
  
    var x = pickData.coord[0];
    var y = pickData.coord[1];
  
    if(!this.pickVertex) {
      var A = this.positions[cell[0]];
      var B = this.positions[cell[1]];
      var C = this.positions[cell[2]];
  
      var dataCoordinate = [
        (A[0] + B[0] + C[0]) / 3,
        (A[1] + B[1] + C[1]) / 3,
        (A[2] + B[2] + C[2]) / 3
      ]
  
      return {
        _cellCenter : true,
        position: [x, y],
        index:    cellId,
        cell:     cell,
        cellId:   cellId,
        intensity:  this.intensity[cellId],
        dataCoordinate: dataCoordinate
      }
    }
  
    var data = closestPoint(
      simplex,
      [x * this.pixelRatio, this._resolution[1] - y * this.pixelRatio],
      this._model,
      this._view,
      this._projection,
      this._resolution)
  
    if(!data) {
      return null
    }
  
    var weights = data[2]
    var interpIntensity = 0.0
    for(var i=0; i<cell.length; ++i) {
      interpIntensity += weights[i] * this.intensity[cell[i]]
    }
  
    return {
      position: data[1],
      index:    cell[data[0]],
      cell:     cell,
      cellId:   cellId,
      intensity:  interpIntensity,
      dataCoordinate: this.positions[cell[data[0]]]
    }
  }
  
  
  proto.dispose = function() {
    this.texture.dispose()
  
    this.triShader.dispose()
    this.lineShader.dispose()
    this.pointShader.dispose()
    this.pickShader.dispose()
    this.pointPickShader.dispose()
  
    this.triangleVAO.dispose()
    this.trianglePositions.dispose()
    this.triangleColors.dispose()
    this.triangleUVs.dispose()
    this.triangleNormals.dispose()
    this.triangleIds.dispose()
  
    this.edgeVAO.dispose()
    this.edgePositions.dispose()
    this.edgeColors.dispose()
    this.edgeUVs.dispose()
    this.edgeIds.dispose()
  
    this.pointVAO.dispose()
    this.pointPositions.dispose()
    this.pointColors.dispose()
    this.pointUVs.dispose()
    this.pointSizes.dispose()
    this.pointIds.dispose()
  
    this.contourVAO.dispose()
    this.contourPositions.dispose()
    this.contourShader.dispose()
  }
  
  function createMeshShader(gl) {
    var shader = createShader(gl, meshShader.vertex, meshShader.fragment)
    shader.attributes.position.location = 0
    shader.attributes.color.location    = 2
    shader.attributes.uv.location       = 3
    shader.attributes.normal.location   = 4
    return shader
  }
  
  function createWireShader(gl) {
    var shader = createShader(gl, wireShader.vertex, wireShader.fragment)
    shader.attributes.position.location = 0
    shader.attributes.color.location    = 2
    shader.attributes.uv.location       = 3
    return shader
  }
  
  function createPointShader(gl) {
    var shader = createShader(gl, pointShader.vertex, pointShader.fragment)
    shader.attributes.position.location  = 0
    shader.attributes.color.location     = 2
    shader.attributes.uv.location        = 3
    shader.attributes.pointSize.location = 4
    return shader
  }
  
  function createPickShader(gl) {
    var shader = createShader(gl, pickShader.vertex, pickShader.fragment)
    shader.attributes.position.location = 0
    shader.attributes.id.location       = 1
    return shader
  }
  
  function createPointPickShader(gl) {
    var shader = createShader(gl, pointPickShader.vertex, pointPickShader.fragment)
    shader.attributes.position.location  = 0
    shader.attributes.id.location        = 1
    shader.attributes.pointSize.location = 4
    return shader
  }
  
  function createContourShader(gl) {
    var shader = createShader(gl, contourShader.vertex, contourShader.fragment)
    shader.attributes.position.location = 0
    return shader
  }
  
  function createSimplicialMesh(gl, params) {
    if (arguments.length === 1) {
      params = gl;
      gl = params.gl;
    }
  
    //enable derivatives for face normals
    var ext = gl.getExtension('OES_standard_derivatives') || gl.getExtension('MOZ_OES_standard_derivatives') || gl.getExtension('WEBKIT_OES_standard_derivatives')
    if (!ext)
      throw new Error('derivatives not supported')
  
    var triShader       = createMeshShader(gl)
    var lineShader      = createWireShader(gl)
    var pointShader     = createPointShader(gl)
    var pickShader      = createPickShader(gl)
    var pointPickShader = createPointPickShader(gl)
    var contourShader   = createContourShader(gl)
  
    var meshTexture       = createTexture(gl,
      ndarray(new Uint8Array([255,255,255,255]), [1,1,4]))
    meshTexture.generateMipmap()
    meshTexture.minFilter = gl.LINEAR_MIPMAP_LINEAR
    meshTexture.magFilter = gl.LINEAR
  
    var trianglePositions = createBuffer(gl)
    var triangleColors    = createBuffer(gl)
    var triangleUVs       = createBuffer(gl)
    var triangleNormals   = createBuffer(gl)
    var triangleIds       = createBuffer(gl)
    var triangleVAO       = createVAO(gl, [
      { buffer: trianglePositions,
        type: gl.FLOAT,
        size: 3
      },
      { buffer: triangleIds,
        type: gl.UNSIGNED_BYTE,
        size: 4,
        normalized: true
      },
      { buffer: triangleColors,
        type: gl.FLOAT,
        size: 4
      },
      { buffer: triangleUVs,
        type: gl.FLOAT,
        size: 2
      },
      { buffer: triangleNormals,
        type: gl.FLOAT,
        size: 3
      }
    ])
  
    var edgePositions = createBuffer(gl)
    var edgeColors    = createBuffer(gl)
    var edgeUVs       = createBuffer(gl)
    var edgeIds       = createBuffer(gl)
    var edgeVAO       = createVAO(gl, [
      { buffer: edgePositions,
        type: gl.FLOAT,
        size: 3
      },
      { buffer: edgeIds,
        type: gl.UNSIGNED_BYTE,
        size: 4,
        normalized: true
      },
      { buffer: edgeColors,
        type: gl.FLOAT,
        size: 4
      },
      { buffer: edgeUVs,
        type: gl.FLOAT,
        size: 2
      }
    ])
  
    var pointPositions  = createBuffer(gl)
    var pointColors     = createBuffer(gl)
    var pointUVs        = createBuffer(gl)
    var pointSizes      = createBuffer(gl)
    var pointIds        = createBuffer(gl)
    var pointVAO        = createVAO(gl, [
      { buffer: pointPositions,
        type: gl.FLOAT,
        size: 3
      },
      { buffer: pointIds,
        type: gl.UNSIGNED_BYTE,
        size: 4,
        normalized: true
      },
      { buffer: pointColors,
        type: gl.FLOAT,
        size: 4
      },
      { buffer: pointUVs,
        type: gl.FLOAT,
        size: 2
      },
      { buffer: pointSizes,
        type: gl.FLOAT,
        size: 1
      }
    ])
  
    var contourPositions = createBuffer(gl)
    var contourVAO       = createVAO(gl, [
      { buffer: contourPositions,
        type:   gl.FLOAT,
        size:   3
      }])
  
    var mesh = new SimplicialMesh(gl
      , meshTexture
      , triShader
      , lineShader
      , pointShader
      , pickShader
      , pointPickShader
      , contourShader
      , trianglePositions
      , triangleIds
      , triangleColors
      , triangleUVs
      , triangleNormals
      , triangleVAO
      , edgePositions
      , edgeIds
      , edgeColors
      , edgeUVs
      , edgeVAO
      , pointPositions
      , pointIds
      , pointColors
      , pointUVs
      , pointSizes
      , pointVAO
      , contourPositions
      , contourVAO)
  
    mesh.update(params)
  
    return mesh
  }
  
  module.exports = createSimplicialMesh
  
  },{"./lib/closest-point":290,"./lib/shaders":291,"colormap":131,"gl-buffer":258,"gl-mat4/invert":278,"gl-mat4/multiply":280,"gl-shader":312,"gl-texture2d":327,"gl-vao":332,"ndarray":469,"normals":472,"simplicial-complex-contour":528,"typedarray-pool":567}],293:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createBoxes
  
  var createBuffer = _dereq_('gl-buffer')
  var createShader = _dereq_('gl-shader')
  
  var shaders = _dereq_('./shaders')
  
  function Boxes(plot, vbo, shader) {
    this.plot   = plot
    this.vbo    = vbo
    this.shader = shader
  }
  
  var proto = Boxes.prototype
  
  proto.bind = function() {
    var shader = this.shader
    this.vbo.bind()
    this.shader.bind()
    shader.attributes.coord.pointer()
    shader.uniforms.screenBox = this.plot.screenBox
  }
  
  proto.drawBox = (function() {
    var lo = [0,0]
    var hi = [0,0]
    return function(loX, loY, hiX, hiY, color) {
      var plot       = this.plot
      var shader     = this.shader
      var gl         = plot.gl
  
      lo[0] = loX
      lo[1] = loY
      hi[0] = hiX
      hi[1] = hiY
  
      shader.uniforms.lo     = lo
      shader.uniforms.hi     = hi
      shader.uniforms.color  = color
  
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4)
    }
  }())
  
  proto.dispose = function() {
    this.vbo.dispose()
    this.shader.dispose()
  }
  
  function createBoxes(plot) {
    var gl  = plot.gl
    var vbo = createBuffer(gl, [
      0,0,
      0,1,
      1,0,
      1,1])
    var shader  = createShader(gl, shaders.boxVert, shaders.lineFrag)
    return new Boxes(plot, vbo, shader)
  }
  
  },{"./shaders":296,"gl-buffer":258,"gl-shader":312}],294:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createGrid
  
  var createBuffer  = _dereq_('gl-buffer')
  var createShader  = _dereq_('gl-shader')
  var bsearch       = _dereq_('binary-search-bounds')
  var shaders       = _dereq_('./shaders')
  
  function Grid(plot, vbo, shader, tickShader) {
    this.plot   = plot
    this.vbo    = vbo
    this.shader = shader
    this.tickShader = tickShader
    this.ticks  = [[], []]
  }
  
  function compareTickNum(a, b) {
    return a - b
  }
  
  var proto = Grid.prototype
  
  proto.draw = (function() {
  
    var DATA_SHIFT = [0,0]
    var DATA_SCALE = [0,0]
    var DATA_AXIS  = [0,0]
  
    return function() {
      var plot       = this.plot
      var vbo        = this.vbo
      var shader     = this.shader
      var ticks      = this.ticks
      var gl         = plot.gl
      var bounds     = plot._tickBounds
      var dataBox    = plot.dataBox
      var viewPixels = plot.viewBox
      var lineWidth  = plot.gridLineWidth
      var gridColor  = plot.gridLineColor
      var gridEnable = plot.gridLineEnable
      var pixelRatio = plot.pixelRatio
  
      for(var i=0; i<2; ++i) {
        var lo = bounds[i]
        var hi = bounds[i+2]
        var boundScale = hi - lo
        var dataCenter  = 0.5 * (dataBox[i+2] + dataBox[i])
        var dataWidth   = dataBox[i+2] - dataBox[i]
        DATA_SCALE[i] = 2.0 * boundScale / dataWidth
        DATA_SHIFT[i] = 2.0 * (lo - dataCenter) / dataWidth
      }
  
      shader.bind()
      vbo.bind()
      shader.attributes.dataCoord.pointer()
      shader.uniforms.dataShift = DATA_SHIFT
      shader.uniforms.dataScale = DATA_SCALE
  
      var offset = 0
      for(var i=0; i<2; ++i) {
        DATA_AXIS[0] = DATA_AXIS[1] = 0
        DATA_AXIS[i] = 1
        shader.uniforms.dataAxis  = DATA_AXIS
        shader.uniforms.lineWidth = lineWidth[i] / (viewPixels[i+2] - viewPixels[i]) * pixelRatio
        shader.uniforms.color     = gridColor[i]
  
        var size = ticks[i].length * 6
        if(gridEnable[i] && size) {
          gl.drawArrays(gl.TRIANGLES, offset, size)
        }
        offset += size
      }
    }
  })()
  
  proto.drawTickMarks = (function() {
    var DATA_SHIFT = [0,0]
    var DATA_SCALE = [0,0]
    var X_AXIS     = [1,0]
    var Y_AXIS     = [0,1]
    var SCR_OFFSET = [0,0]
    var TICK_SCALE = [0,0]
  
    return function() {
      var plot       = this.plot
      var vbo        = this.vbo
      var shader     = this.tickShader
      var ticks      = this.ticks
      var gl         = plot.gl
      var bounds     = plot._tickBounds
      var dataBox    = plot.dataBox
      var viewBox    = plot.viewBox
      var pixelRatio = plot.pixelRatio
      var screenBox  = plot.screenBox
  
      var screenWidth  = screenBox[2] - screenBox[0]
      var screenHeight = screenBox[3] - screenBox[1]
      var viewWidth    = viewBox[2]   - viewBox[0]
      var viewHeight   = viewBox[3]   - viewBox[1]
  
      for(var i=0; i<2; ++i) {
        var lo = bounds[i]
        var hi = bounds[i+2]
        var boundScale = hi - lo
        var dataCenter  = 0.5 * (dataBox[i+2] + dataBox[i])
        var dataWidth   = (dataBox[i+2] - dataBox[i])
        DATA_SCALE[i] = 2.0 * boundScale / dataWidth
        DATA_SHIFT[i] = 2.0 * (lo - dataCenter) / dataWidth
      }
  
      DATA_SCALE[0] *= viewWidth / screenWidth
      DATA_SHIFT[0] *= viewWidth / screenWidth
  
      DATA_SCALE[1] *= viewHeight / screenHeight
      DATA_SHIFT[1] *= viewHeight / screenHeight
  
      shader.bind()
      vbo.bind()
  
      shader.attributes.dataCoord.pointer()
  
      var uniforms = shader.uniforms
      uniforms.dataShift = DATA_SHIFT
      uniforms.dataScale = DATA_SCALE
  
      var tickMarkLength = plot.tickMarkLength
      var tickMarkWidth  = plot.tickMarkWidth
      var tickMarkColor  = plot.tickMarkColor
  
      var xTicksOffset = 0
      var yTicksOffset = ticks[0].length * 6
  
      var xStart = Math.min(bsearch.ge(ticks[0], (dataBox[0] - bounds[0]) / (bounds[2] - bounds[0]), compareTickNum), ticks[0].length)
      var xEnd   = Math.min(bsearch.gt(ticks[0], (dataBox[2] - bounds[0]) / (bounds[2] - bounds[0]), compareTickNum), ticks[0].length)
      var xOffset = xTicksOffset + 6 * xStart
      var xCount  = 6 * Math.max(0, xEnd - xStart)
  
      var yStart = Math.min(bsearch.ge(ticks[1], (dataBox[1] - bounds[1]) / (bounds[3] - bounds[1]), compareTickNum), ticks[1].length)
      var yEnd   = Math.min(bsearch.gt(ticks[1], (dataBox[3] - bounds[1]) / (bounds[3] - bounds[1]), compareTickNum), ticks[1].length)
      var yOffset = yTicksOffset + 6 * yStart
      var yCount  = 6 * Math.max(0, yEnd - yStart)
  
      SCR_OFFSET[0]         = 2.0 * (viewBox[0] - tickMarkLength[1]) / screenWidth - 1.0
      SCR_OFFSET[1]         = (viewBox[3] + viewBox[1]) / screenHeight - 1.0
      TICK_SCALE[0]         = tickMarkLength[1] * pixelRatio / screenWidth
      TICK_SCALE[1]         = tickMarkWidth[1]  * pixelRatio / screenHeight
  
      if(yCount) {
        uniforms.color        = tickMarkColor[1]
        uniforms.tickScale    = TICK_SCALE
        uniforms.dataAxis     = Y_AXIS
        uniforms.screenOffset = SCR_OFFSET
        gl.drawArrays(gl.TRIANGLES, yOffset, yCount)
      }
  
      SCR_OFFSET[0]         = (viewBox[2] + viewBox[0]) / screenWidth - 1.0
      SCR_OFFSET[1]         = 2.0 * (viewBox[1] - tickMarkLength[0]) / screenHeight - 1.0
      TICK_SCALE[0]         = tickMarkWidth[0]  * pixelRatio / screenWidth
      TICK_SCALE[1]         = tickMarkLength[0] * pixelRatio / screenHeight
  
      if(xCount) {
        uniforms.color        = tickMarkColor[0]
        uniforms.tickScale    = TICK_SCALE
        uniforms.dataAxis     = X_AXIS
        uniforms.screenOffset = SCR_OFFSET
        gl.drawArrays(gl.TRIANGLES, xOffset, xCount)
      }
  
      SCR_OFFSET[0]         = 2.0 * (viewBox[2] + tickMarkLength[3]) / screenWidth - 1.0
      SCR_OFFSET[1]         = (viewBox[3] + viewBox[1]) / screenHeight - 1.0
      TICK_SCALE[0]         = tickMarkLength[3] * pixelRatio / screenWidth
      TICK_SCALE[1]         = tickMarkWidth[3]  * pixelRatio / screenHeight
  
      if(yCount) {
        uniforms.color        = tickMarkColor[3]
        uniforms.tickScale    = TICK_SCALE
        uniforms.dataAxis     = Y_AXIS
        uniforms.screenOffset = SCR_OFFSET
        gl.drawArrays(gl.TRIANGLES, yOffset, yCount)
      }
  
      SCR_OFFSET[0]         = (viewBox[2] + viewBox[0]) / screenWidth - 1.0
      SCR_OFFSET[1]         = 2.0 * (viewBox[3] + tickMarkLength[2]) / screenHeight - 1.0
      TICK_SCALE[0]         = tickMarkWidth[2]  * pixelRatio / screenWidth
      TICK_SCALE[1]         = tickMarkLength[2] * pixelRatio / screenHeight
  
      if(xCount) {
        uniforms.color        = tickMarkColor[2]
        uniforms.tickScale    = TICK_SCALE
        uniforms.dataAxis     = X_AXIS
        uniforms.screenOffset = SCR_OFFSET
        gl.drawArrays(gl.TRIANGLES, xOffset, xCount)
      }
    }
  })()
  
  proto.update = (function() {
    var OFFSET_X = [1,  1, -1, -1,  1, -1]
    var OFFSET_Y = [1, -1,  1,  1, -1, -1]
  
    return function(options) {
      var ticks  = options.ticks
      var bounds = options.bounds
      var data   = new Float32Array(6 * 3 * (ticks[0].length + ticks[1].length))
  
      var zeroLineEnable = this.plot.zeroLineEnable
  
      var ptr    = 0
      var gridTicks = [[], []]
      for(var dim=0; dim<2; ++dim) {
        var localTicks = gridTicks[dim]
        var axisTicks = ticks[dim]
        var lo = bounds[dim]
        var hi = bounds[dim+2]
        for(var i=0; i<axisTicks.length; ++i) {
          var x = (axisTicks[i].x - lo) / (hi - lo)
          localTicks.push(x)
          for(var j=0; j<6; ++j) {
            data[ptr++] = x
            data[ptr++] = OFFSET_X[j]
            data[ptr++] = OFFSET_Y[j]
          }
        }
      }
  
      this.ticks = gridTicks
      this.vbo.update(data)
    }
  })()
  
  proto.dispose = function() {
    this.vbo.dispose()
    this.shader.dispose()
    this.tickShader.dispose()
  }
  
  function createGrid(plot) {
    var gl     = plot.gl
    var vbo    = createBuffer(gl)
    var shader = createShader(gl, shaders.gridVert, shaders.gridFrag)
    var tickShader = createShader(gl, shaders.tickVert, shaders.gridFrag)
    var grid   = new Grid(plot, vbo, shader, tickShader)
    return grid
  }
  
  },{"./shaders":296,"binary-search-bounds":96,"gl-buffer":258,"gl-shader":312}],295:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createLines
  
  var createBuffer = _dereq_('gl-buffer')
  var createShader = _dereq_('gl-shader')
  
  var shaders = _dereq_('./shaders')
  
  function Lines(plot, vbo, shader) {
    this.plot   = plot
    this.vbo    = vbo
    this.shader = shader
  }
  
  var proto = Lines.prototype
  
  proto.bind = function() {
    var shader = this.shader
    this.vbo.bind()
    this.shader.bind()
    shader.attributes.coord.pointer()
    shader.uniforms.screenBox = this.plot.screenBox
  }
  
  proto.drawLine = (function() {
    var start = [0,0]
    var end   = [0,0]
    return function(startX, startY, endX, endY, width, color) {
      var plot       = this.plot
      var shader     = this.shader
      var gl         = plot.gl
  
      start[0] = startX
      start[1] = startY
      end[0]   = endX
      end[1]   = endY
  
      shader.uniforms.start  = start
      shader.uniforms.end    = end
      shader.uniforms.width  = width * plot.pixelRatio
      shader.uniforms.color  = color
  
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4)
    }
  }())
  
  proto.dispose = function() {
    this.vbo.dispose()
    this.shader.dispose()
  }
  
  function createLines(plot) {
    var gl  = plot.gl
    var vbo = createBuffer(gl, [
      -1,-1,
      -1,1,
      1,-1,
      1,1])
    var shader  = createShader(gl, shaders.lineVert, shaders.lineFrag)
    var lines   = new Lines(plot, vbo, shader)
    return lines
  }
  
  },{"./shaders":296,"gl-buffer":258,"gl-shader":312}],296:[function(_dereq_,module,exports){
  'use strict'
  
  var glslify = _dereq_('glslify')
  
  var FRAGMENT = glslify(["precision lowp float;\n#define GLSLIFY 1\nuniform vec4 color;\nvoid main() {\n  gl_FragColor = vec4(color.xyz * color.w, color.w);\n}\n"])
  
  module.exports = {
    lineVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 start, end;\nuniform float width;\n\nvec2 perp(vec2 v) {\n  return vec2(v.y, -v.x);\n}\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  vec2 delta = normalize(perp(start - end));\n  vec2 offset = mix(start, end, 0.5 * (coord.y+1.0));\n  gl_Position = vec4(screen(offset + 0.5 * width * delta * coord.x), 0, 1);\n}\n"]),
    lineFrag: FRAGMENT,
    textVert: glslify(["#define GLSLIFY 1\nattribute vec3 textCoordinate;\n\nuniform vec2 dataScale, dataShift, dataAxis, screenOffset, textScale;\nuniform float angle;\n\nvoid main() {\n  float dataOffset  = textCoordinate.z;\n  vec2 glyphOffset  = textCoordinate.xy;\n  mat2 glyphMatrix = mat2(cos(angle), sin(angle), -sin(angle), cos(angle));\n  vec2 screenCoordinate = dataAxis * (dataScale * dataOffset + dataShift) +\n    glyphMatrix * glyphOffset * textScale + screenOffset;\n  gl_Position = vec4(screenCoordinate, 0, 1);\n}\n"]),
    textFrag: FRAGMENT,
    gridVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale;\nuniform float lineWidth;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  pos += 10.0 * dataCoord.y * vec2(dataAxis.y, -dataAxis.x) + dataCoord.z * lineWidth;\n  gl_Position = vec4(pos, 0, 1);\n}\n"]),
    gridFrag: FRAGMENT,
    boxVert:  glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 coord;\n\nuniform vec4 screenBox;\nuniform vec2 lo, hi;\n\nvec2 screen(vec2 v) {\n  return 2.0 * (v - screenBox.xy) / (screenBox.zw - screenBox.xy) - 1.0;\n}\n\nvoid main() {\n  gl_Position = vec4(screen(mix(lo, hi, coord)), 0, 1);\n}\n"]),
    tickVert: glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 dataCoord;\n\nuniform vec2 dataAxis, dataShift, dataScale, screenOffset, tickScale;\n\nvoid main() {\n  vec2 pos = dataAxis * (dataScale * dataCoord.x + dataShift);\n  gl_Position = vec4(pos + tickScale*dataCoord.yz + screenOffset, 0, 1);\n}\n"])
  }
  
  },{"glslify":413}],297:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createTextElements
  
  var createBuffer = _dereq_('gl-buffer')
  var createShader = _dereq_('gl-shader')
  var getText      = _dereq_('text-cache')
  var bsearch      = _dereq_('binary-search-bounds')
  var shaders      = _dereq_('./shaders')
  
  function TextElements(plot, vbo, shader) {
    this.plot         = plot
    this.vbo          = vbo
    this.shader       = shader
    this.tickOffset   = [[],[]]
    this.tickX        = [[],[]]
    this.labelOffset  = [0,0]
    this.labelCount   = [0,0]
  }
  
  var proto = TextElements.prototype
  
  proto.drawTicks = (function() {
    var DATA_AXIS = [0,0]
    var SCREEN_OFFSET = [0,0]
    var ZERO_2 = [0,0]
  
    return function(axis) {
      var plot        = this.plot
      var shader      = this.shader
      var tickX       = this.tickX[axis]
      var tickOffset  = this.tickOffset[axis]
      var gl          = plot.gl
      var viewBox     = plot.viewBox
      var dataBox     = plot.dataBox
      var screenBox   = plot.screenBox
      var pixelRatio  = plot.pixelRatio
      var tickEnable  = plot.tickEnable
      var tickPad     = plot.tickPad
      var textColor   = plot.tickColor
      var textAngle   = plot.tickAngle
      // todo check if this should be used (now unused)
      // var tickLength  = plot.tickMarkLength
  
      var labelEnable = plot.labelEnable
      var labelPad    = plot.labelPad
      var labelColor  = plot.labelColor
      var labelAngle  = plot.labelAngle
      var labelOffset = this.labelOffset[axis]
      var labelCount  = this.labelCount[axis]
  
      var start = bsearch.lt(tickX, dataBox[axis])
      var end   = bsearch.le(tickX, dataBox[axis+2])
  
      DATA_AXIS[0]    = DATA_AXIS[1] = 0
      DATA_AXIS[axis] = 1
  
      SCREEN_OFFSET[axis] = (viewBox[2+axis] + viewBox[axis]) / (screenBox[2+axis] - screenBox[axis]) - 1.0
  
      var screenScale = 2.0 / screenBox[2+(axis^1)] - screenBox[axis^1]
  
      SCREEN_OFFSET[axis^1] = screenScale * viewBox[axis^1] - 1.0
      if(tickEnable[axis]) {
        SCREEN_OFFSET[axis^1] -= screenScale * pixelRatio * tickPad[axis]
        if(start < end && tickOffset[end] > tickOffset[start]) {
          shader.uniforms.dataAxis     = DATA_AXIS
          shader.uniforms.screenOffset = SCREEN_OFFSET
          shader.uniforms.color        = textColor[axis]
          shader.uniforms.angle        = textAngle[axis]
          gl.drawArrays(
            gl.TRIANGLES,
            tickOffset[start],
            tickOffset[end] - tickOffset[start])
        }
      }
      if(labelEnable[axis] && labelCount) {
        SCREEN_OFFSET[axis^1] -= screenScale * pixelRatio * labelPad[axis]
        shader.uniforms.dataAxis     = ZERO_2
        shader.uniforms.screenOffset = SCREEN_OFFSET
        shader.uniforms.color        = labelColor[axis]
        shader.uniforms.angle        = labelAngle[axis]
        gl.drawArrays(
          gl.TRIANGLES,
          labelOffset,
          labelCount)
      }
  
      SCREEN_OFFSET[axis^1] = screenScale * viewBox[2+(axis^1)] - 1.0
      if(tickEnable[axis+2]) {
        SCREEN_OFFSET[axis^1] += screenScale * pixelRatio * tickPad[axis+2]
        if(start < end && tickOffset[end] > tickOffset[start]) {
          shader.uniforms.dataAxis     = DATA_AXIS
          shader.uniforms.screenOffset = SCREEN_OFFSET
          shader.uniforms.color        = textColor[axis+2]
          shader.uniforms.angle        = textAngle[axis+2]
          gl.drawArrays(
            gl.TRIANGLES,
            tickOffset[start],
            tickOffset[end] - tickOffset[start])
        }
      }
      if(labelEnable[axis+2] && labelCount) {
        SCREEN_OFFSET[axis^1] += screenScale * pixelRatio * labelPad[axis+2]
        shader.uniforms.dataAxis     = ZERO_2
        shader.uniforms.screenOffset = SCREEN_OFFSET
        shader.uniforms.color        = labelColor[axis+2]
        shader.uniforms.angle        = labelAngle[axis+2]
        gl.drawArrays(
          gl.TRIANGLES,
          labelOffset,
          labelCount)
      }
  
    }
  })()
  
  proto.drawTitle = (function() {
    var DATA_AXIS = [0,0]
    var SCREEN_OFFSET = [0,0]
  
    return function() {
      var plot        = this.plot
      var shader      = this.shader
      var gl          = plot.gl
      var screenBox   = plot.screenBox
      var titleCenter = plot.titleCenter
      var titleAngle  = plot.titleAngle
      var titleColor  = plot.titleColor
      var pixelRatio  = plot.pixelRatio
  
      if(!this.titleCount) {
        return
      }
  
      for(var i=0; i<2; ++i) {
        SCREEN_OFFSET[i] = 2.0 * (titleCenter[i]*pixelRatio - screenBox[i]) /
          (screenBox[2+i] - screenBox[i]) - 1
      }
  
      shader.bind()
      shader.uniforms.dataAxis      = DATA_AXIS
      shader.uniforms.screenOffset  = SCREEN_OFFSET
      shader.uniforms.angle         = titleAngle
      shader.uniforms.color         = titleColor
  
      gl.drawArrays(gl.TRIANGLES, this.titleOffset, this.titleCount)
    }
  })()
  
  proto.bind = (function() {
    var DATA_SHIFT = [0,0]
    var DATA_SCALE = [0,0]
    var TEXT_SCALE = [0,0]
  
    return function() {
      var plot      = this.plot
      var shader    = this.shader
      var bounds    = plot._tickBounds
      var dataBox   = plot.dataBox
      var screenBox = plot.screenBox
      var viewBox   = plot.viewBox
  
      shader.bind()
  
      //Set up coordinate scaling uniforms
      for(var i=0; i<2; ++i) {
  
        var lo = bounds[i]
        var hi = bounds[i+2]
        var boundScale = hi - lo
        var dataCenter  = 0.5 * (dataBox[i+2] + dataBox[i])
        var dataWidth   = (dataBox[i+2] - dataBox[i])
  
        var viewLo = viewBox[i]
        var viewHi = viewBox[i+2]
        var viewScale = viewHi - viewLo
        var screenLo = screenBox[i]
        var screenHi = screenBox[i+2]
        var screenScale = screenHi - screenLo
  
        DATA_SCALE[i] = 2.0 * boundScale / dataWidth * viewScale / screenScale
        DATA_SHIFT[i] = 2.0 * (lo - dataCenter) / dataWidth * viewScale / screenScale
      }
  
      TEXT_SCALE[1] = 2.0 * plot.pixelRatio / (screenBox[3] - screenBox[1])
      TEXT_SCALE[0] = TEXT_SCALE[1] * (screenBox[3] - screenBox[1]) / (screenBox[2] - screenBox[0])
  
      shader.uniforms.dataScale = DATA_SCALE
      shader.uniforms.dataShift = DATA_SHIFT
      shader.uniforms.textScale = TEXT_SCALE
  
      //Set attributes
      this.vbo.bind()
      shader.attributes.textCoordinate.pointer()
    }
  })()
  
  proto.update = function(options) {
    var vertices  = []
    var axesTicks = options.ticks
    var bounds    = options.bounds
    var i, j, k, data, scale, dimension
  
    for(dimension=0; dimension<2; ++dimension) {
      var offsets = [Math.floor(vertices.length/3)], tickX = [-Infinity]
  
      //Copy vertices over to buffer
      var ticks = axesTicks[dimension]
      for(i=0; i<ticks.length; ++i) {
        var tick  = ticks[i]
        var x     = tick.x
        var text  = tick.text
        var font  = tick.font || 'sans-serif'
        scale = (tick.fontSize || 12)
  
        var coordScale = 1.0 / (bounds[dimension+2] - bounds[dimension])
        var coordShift = bounds[dimension]
  
        var rows = text.split('\n')
        for(var r = 0; r < rows.length; r++) {
          data = getText(font, rows[r]).data
          for (j = 0; j < data.length; j += 2) {
            vertices.push(
                data[j] * scale,
                -data[j + 1] * scale - r * scale * 1.2,
                (x - coordShift) * coordScale)
          }
        }
  
        offsets.push(Math.floor(vertices.length/3))
        tickX.push(x)
      }
  
      this.tickOffset[dimension] = offsets
      this.tickX[dimension] = tickX
    }
  
    //Add labels
    for(dimension=0; dimension<2; ++dimension) {
      this.labelOffset[dimension] = Math.floor(vertices.length/3)
  
      data  = getText(options.labelFont[dimension], options.labels[dimension], { textAlign: 'center' }).data
      scale = options.labelSize[dimension]
      for(i=0; i<data.length; i+=2) {
        vertices.push(data[i]*scale, -data[i+1]*scale, 0)
      }
  
      this.labelCount[dimension] =
        Math.floor(vertices.length/3) - this.labelOffset[dimension]
    }
  
    //Add title
    this.titleOffset = Math.floor(vertices.length/3)
    data = getText(options.titleFont, options.title).data
    scale = options.titleSize
    for(i=0; i<data.length; i+=2) {
      vertices.push(data[i]*scale, -data[i+1]*scale, 0)
    }
    this.titleCount = Math.floor(vertices.length/3) - this.titleOffset
  
    //Upload new vertices
    this.vbo.update(vertices)
  }
  
  proto.dispose = function() {
    this.vbo.dispose()
    this.shader.dispose()
  }
  
  function createTextElements(plot) {
    var gl = plot.gl
    var vbo = createBuffer(gl)
    var shader = createShader(gl, shaders.textVert, shaders.textFrag)
    var text = new TextElements(plot, vbo, shader)
    return text
  }
  
  },{"./shaders":296,"binary-search-bounds":96,"gl-buffer":258,"gl-shader":312,"text-cache":547}],298:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createGLPlot2D
  
  var createPick = _dereq_('gl-select-static')
  
  var createGrid = _dereq_('./lib/grid')
  var createText = _dereq_('./lib/text')
  var createLine = _dereq_('./lib/line')
  var createBox  = _dereq_('./lib/box')
  
  function GLPlot2D(gl, pickBuffer) {
    this.gl               = gl
    this.pickBuffer       = pickBuffer
  
    this.screenBox        = [0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight]
    this.viewBox          = [0, 0, 0, 0]
    this.dataBox          = [-10, -10, 10, 10]
  
    this.gridLineEnable   = [true,true]
    this.gridLineWidth    = [1,1]
    this.gridLineColor    = [[0,0,0,1],
                             [0,0,0,1]]
  
    this.pixelRatio       = 1
  
    this.tickMarkLength   = [0,0,0,0]
    this.tickMarkWidth    = [0,0,0,0]
    this.tickMarkColor    = [[0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1]]
  
    this.tickPad          = [15,15,15,15]
    this.tickAngle        = [0,0,0,0]
    this.tickEnable       = [true,true,true,true]
    this.tickColor        = [[0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1]]
  
    this.labelPad         = [15,15,15,15]
    this.labelAngle       = [0,Math.PI/2,0,3.0*Math.PI/2]
    this.labelEnable      = [true,true,true,true]
    this.labelColor       = [[0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1]]
  
    this.titleCenter      = [0,0]
    this.titleEnable      = true
    this.titleAngle       = 0
    this.titleColor       = [0,0,0,1]
  
    this.borderColor      = [0,0,0,0]
    this.backgroundColor  = [0,0,0,0]
  
    this.zeroLineEnable   = [true, true]
    this.zeroLineWidth    = [4, 4]
    this.zeroLineColor    = [[0, 0, 0, 1],[0, 0, 0, 1]]
  
    this.borderLineEnable = [true,true,true,true]
    this.borderLineWidth  = [2,2,2,2]
    this.borderLineColor  = [[0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1]]
  
    //Drawing parameters
    this.grid             = null
    this.text             = null
    this.line             = null
    this.box              = null
    this.objects          = []
    this.overlays         = []
  
    this._tickBounds      = [Infinity, Infinity, -Infinity, -Infinity]
  
    this.static = false
  
    this.dirty        = false
    this.pickDirty    = false
    this.pickDelay    = 120
    this.pickRadius   = 10
    this._pickTimeout = null
    this._drawPick    = this.drawPick.bind(this)
  
    this._depthCounter = 0
  }
  
  var proto = GLPlot2D.prototype
  
  proto.setDirty = function() {
    this.dirty = this.pickDirty = true
  }
  
  proto.setOverlayDirty = function() {
    this.dirty = true
  }
  
  proto.nextDepthValue = function() {
    return (this._depthCounter++) / 65536.0
  }
  
  function lerp(a, b, t) {
    var s = 0.5 * (t + 1.0)
    return Math.floor((1.0-s)*a + s*b)|0
  }
  
  proto.draw = (function() {
  var TICK_MARK_BOX = [0,0,0,0]
  return function() {
    var gl         = this.gl
    var screenBox  = this.screenBox
    var viewPixels = this.viewBox
    var dataBox    = this.dataBox
    var pixelRatio = this.pixelRatio
    var grid       = this.grid
    var line       = this.line
    var text       = this.text
    var objects    = this.objects
  
    this._depthCounter = 0
  
    if(this.pickDirty) {
      if(this._pickTimeout) {
        clearTimeout(this._pickTimeout)
      }
      this.pickDirty = false
      this._pickTimeout = setTimeout(this._drawPick, this.pickDelay)
    }
  
    if(!this.dirty) {
      return
    }
    this.dirty = false
  
    gl.bindFramebuffer(gl.FRAMEBUFFER, null)
  
    //Turn on scissor
    gl.enable(gl.SCISSOR_TEST)
  
    //Turn off depth buffer
    gl.disable(gl.DEPTH_TEST)
    gl.depthFunc(gl.LESS)
    gl.depthMask(false)
  
    //Configure premultiplied alpha blending
    gl.enable(gl.BLEND)
    gl.blendEquation(gl.FUNC_ADD, gl.FUNC_ADD);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
  
    //Draw border
    if (this.borderColor) {
      gl.scissor(
        screenBox[0],
        screenBox[1],
        screenBox[2]-screenBox[0],
        screenBox[3]-screenBox[1])
      var borderColor = this.borderColor
      gl.clearColor(
        borderColor[0]*borderColor[3],
        borderColor[1]*borderColor[3],
        borderColor[2]*borderColor[3],
        borderColor[3])
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
    }
  
    //Draw center pane
    gl.scissor(
      viewPixels[0],
      viewPixels[1],
      viewPixels[2]-viewPixels[0],
      viewPixels[3]-viewPixels[1])
    gl.viewport(
      viewPixels[0],
      viewPixels[1],
      viewPixels[2]-viewPixels[0],
      viewPixels[3]-viewPixels[1])
    var backgroundColor = this.backgroundColor
    gl.clearColor(
      backgroundColor[0]*backgroundColor[3],
      backgroundColor[1]*backgroundColor[3],
      backgroundColor[2]*backgroundColor[3],
      backgroundColor[3])
    gl.clear(gl.COLOR_BUFFER_BIT)
  
    //Draw grid
    grid.draw()
  
    //Draw zero lines separately
    var zeroLineEnable = this.zeroLineEnable
    var zeroLineColor  = this.zeroLineColor
    var zeroLineWidth  = this.zeroLineWidth
    if(zeroLineEnable[0] || zeroLineEnable[1]) {
      line.bind()
      for(var i=0; i<2; ++i) {
        if(!zeroLineEnable[i] ||
          !(dataBox[i] <= 0 && dataBox[i+2] >= 0)) {
          continue
        }
  
        var zeroIntercept = screenBox[i] -
          dataBox[i] * (screenBox[i+2] - screenBox[i]) / (dataBox[i+2] - dataBox[i])
  
        if(i === 0) {
          line.drawLine(
            zeroIntercept, screenBox[1], zeroIntercept, screenBox[3],
            zeroLineWidth[i],
            zeroLineColor[i])
        } else {
          line.drawLine(
            screenBox[0], zeroIntercept, screenBox[2], zeroIntercept,
            zeroLineWidth[i],
            zeroLineColor[i])
        }
      }
    }
  
    //Draw traces
    for(var i=0; i<objects.length; ++i) {
      objects[i].draw()
    }
  
    //Return viewport to default
    gl.viewport(
      screenBox[0],
      screenBox[1],
      screenBox[2]-screenBox[0],
      screenBox[3]-screenBox[1])
    gl.scissor(
      screenBox[0],
      screenBox[1],
      screenBox[2]-screenBox[0],
      screenBox[3]-screenBox[1])
  
    //Draw tick marks
    this.grid.drawTickMarks()
  
    //Draw line elements
    line.bind()
  
    //Draw border lines
    var borderLineEnable = this.borderLineEnable
    var borderLineWidth  = this.borderLineWidth
    var borderLineColor  = this.borderLineColor
    if(borderLineEnable[1]) {
      line.drawLine(
        viewPixels[0], viewPixels[1] - 0.5*borderLineWidth[1]*pixelRatio,
        viewPixels[0], viewPixels[3] + 0.5*borderLineWidth[3]*pixelRatio,
        borderLineWidth[1], borderLineColor[1])
    }
    if(borderLineEnable[0]) {
      line.drawLine(
        viewPixels[0] - 0.5*borderLineWidth[0]*pixelRatio, viewPixels[1],
        viewPixels[2] + 0.5*borderLineWidth[2]*pixelRatio, viewPixels[1],
        borderLineWidth[0], borderLineColor[0])
    }
    if(borderLineEnable[3]) {
      line.drawLine(
        viewPixels[2], viewPixels[1] - 0.5*borderLineWidth[1]*pixelRatio,
        viewPixels[2], viewPixels[3] + 0.5*borderLineWidth[3]*pixelRatio,
        borderLineWidth[3], borderLineColor[3])
    }
    if(borderLineEnable[2]) {
      line.drawLine(
        viewPixels[0] - 0.5*borderLineWidth[0]*pixelRatio, viewPixels[3],
        viewPixels[2] + 0.5*borderLineWidth[2]*pixelRatio, viewPixels[3],
        borderLineWidth[2], borderLineColor[2])
    }
  
    //Draw text elements
    text.bind()
    for(var i=0; i<2; ++i) {
      text.drawTicks(i)
    }
    if(this.titleEnable) {
      text.drawTitle()
    }
  
    //Draw other overlay elements (select boxes, etc.)
    var overlays = this.overlays
    for(var i=0; i<overlays.length; ++i) {
      overlays[i].draw()
    }
  
    //Turn off scissor test
    gl.disable(gl.SCISSOR_TEST)
    gl.disable(gl.BLEND)
    gl.depthMask(true)
  }
  })()
  
  proto.drawPick = (function() {
  
  return function() {
    if (this.static) return;
  
    var pickBuffer = this.pickBuffer
    var gl = this.gl
  
    this._pickTimeout = null
    pickBuffer.begin()
  
    var pickOffset = 1
    var objects = this.objects
    for(var i=0; i<objects.length; ++i) {
      pickOffset = objects[i].drawPick(pickOffset)
    }
  
    pickBuffer.end()
  }
  })()
  
  proto.pick = (function() {
  return function(x, y) {
    if (this.static) return;
  
    var pixelRatio     = this.pixelRatio
    var pickPixelRatio = this.pickPixelRatio
    var viewBox        = this.viewBox
  
    var scrX = Math.round((x - viewBox[0] / pixelRatio) * pickPixelRatio)|0
    var scrY = Math.round((y - viewBox[1] / pixelRatio) * pickPixelRatio)|0
  
    var pickResult = this.pickBuffer.query(scrX, scrY, this.pickRadius)
    if(!pickResult) {
      return null
    }
  
    var pickValue = pickResult.id +
      (pickResult.value[0]<<8)  +
      (pickResult.value[1]<<16) +
      (pickResult.value[2]<<24)
  
    var objects = this.objects
    for(var i=0; i<objects.length; ++i) {
      var result = objects[i].pick(scrX, scrY, pickValue)
      if(result) {
        return result
      }
    }
  
    return null
  }
  })()
  
  function deepClone(array) {
    var result = array.slice()
    for(var i=0; i<result.length; ++i) {
      result[i] = result[i].slice()
    }
    return result
  }
  
  function compareTicks(a, b) {
    return a.x - b.x
  }
  
  proto.setScreenBox = function(nbox) {
    var screenBox = this.screenBox
    var pixelRatio = this.pixelRatio
  
    screenBox[0] = Math.round(nbox[0] * pixelRatio) | 0
    screenBox[1] = Math.round(nbox[1] * pixelRatio) | 0
    screenBox[2] = Math.round(nbox[2] * pixelRatio) | 0
    screenBox[3] = Math.round(nbox[3] * pixelRatio) | 0
  
    this.setDirty()
  }
  
  proto.setDataBox = function(nbox) {
    var dataBox = this.dataBox
  
    var different =
      dataBox[0] !== nbox[0] ||
      dataBox[1] !== nbox[1] ||
      dataBox[2] !== nbox[2] ||
      dataBox[3] !== nbox[3]
  
    if(different) {
      dataBox[0] = nbox[0]
      dataBox[1] = nbox[1]
      dataBox[2] = nbox[2]
      dataBox[3] = nbox[3]
  
      this.setDirty()
    }
  }
  
  proto.setViewBox = function(nbox) {
    var pixelRatio = this.pixelRatio
    var viewBox = this.viewBox
  
    viewBox[0] = Math.round(nbox[0] * pixelRatio)|0
    viewBox[1] = Math.round(nbox[1] * pixelRatio)|0
    viewBox[2] = Math.round(nbox[2] * pixelRatio)|0
    viewBox[3] = Math.round(nbox[3] * pixelRatio)|0
  
    var pickPixelRatio = this.pickPixelRatio
    this.pickBuffer.shape = [
      Math.round((nbox[2] - nbox[0]) * pickPixelRatio)|0,
      Math.round((nbox[3] - nbox[1]) * pickPixelRatio)|0 ]
  
    this.setDirty()
  }
  
  proto.update = function(options) {
    options = options || {}
  
    var gl = this.gl
  
    this.pixelRatio      = options.pixelRatio || 1
  
    var pixelRatio       = this.pixelRatio
    this.pickPixelRatio  = Math.max(pixelRatio, 1)
  
    this.setScreenBox(options.screenBox ||
      [0, 0, gl.drawingBufferWidth/pixelRatio, gl.drawingBufferHeight/pixelRatio])
  
    var screenBox = this.screenBox
    this.setViewBox(options.viewBox ||
      [0.125*(this.screenBox[2]-this.screenBox[0])/pixelRatio,
       0.125*(this.screenBox[3]-this.screenBox[1])/pixelRatio,
       0.875*(this.screenBox[2]-this.screenBox[0])/pixelRatio,
       0.875*(this.screenBox[3]-this.screenBox[1])/pixelRatio])
  
    var viewBox = this.viewBox
    var aspectRatio = (viewBox[2] - viewBox[0]) / (viewBox[3] - viewBox[1])
    this.setDataBox(options.dataBox || [-10, -10/aspectRatio, 10, 10/aspectRatio])
  
    this.borderColor     = options.borderColor !== false ? (options.borderColor || [0,0,0,0]).slice() : false
    this.backgroundColor = (options.backgroundColor || [0,0,0,0]).slice()
  
    this.gridLineEnable  = (options.gridLineEnable || [true,true]).slice()
    this.gridLineWidth   = (options.gridLineWidth || [1,1]).slice()
    this.gridLineColor   = deepClone(options.gridLineColor ||
      [[0.5,0.5,0.5,1],[0.5,0.5,0.5,1]])
  
    this.zeroLineEnable   = (options.zeroLineEnable || [true, true]).slice()
    this.zeroLineWidth    = (options.zeroLineWidth || [4, 4]).slice()
    this.zeroLineColor    = deepClone(options.zeroLineColor ||
      [[0, 0, 0, 1],[0, 0, 0, 1]])
  
    this.tickMarkLength   = (options.tickMarkLength || [0,0,0,0]).slice()
    this.tickMarkWidth    = (options.tickMarkWidth || [0,0,0,0]).slice()
    this.tickMarkColor    = deepClone(options.tickMarkColor ||
      [[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]])
  
    this.titleCenter      = (options.titleCenter || [
      0.5*(viewBox[0]+viewBox[2])/pixelRatio,(viewBox[3]+120)/pixelRatio]).slice()
    this.titleEnable      = !('titleEnable' in options) || !!options.titleEnable
    this.titleAngle       = options.titleAngle || 0
    this.titleColor       = (options.titleColor || [0,0,0,1]).slice()
  
    this.labelPad         = (options.labelPad || [15,15,15,15]).slice()
    this.labelAngle       = (options.labelAngle ||
      [0,Math.PI/2,0,3.0*Math.PI/2]).slice()
    this.labelEnable      = (options.labelEnable || [true,true,true,true]).slice()
    this.labelColor       = deepClone(options.labelColor ||
      [[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]])
  
    this.tickPad         = (options.tickPad || [15,15,15,15]).slice()
    this.tickAngle       = (options.tickAngle || [0,0,0,0]).slice()
    this.tickEnable      = (options.tickEnable || [true,true,true,true]).slice()
    this.tickColor       = deepClone(options.tickColor ||
      [[0,0,0,1],[0,0,0,1],[0,0,0,1],[0,0,0,1]])
  
    this.borderLineEnable = (options.borderLineEnable ||
                              [true,true,true,true]).slice()
    this.borderLineWidth  = (options.borderLineWidth || [2,2,2,2]).slice()
    this.borderLineColor  = deepClone(options.borderLineColor ||
                            [[0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1],
                             [0,0,0,1]])
  
    var ticks = options.ticks || [ [], [] ]
  
    //Compute bounds on ticks
    var bounds = this._tickBounds
    bounds[0] = bounds[1] =  Infinity
    bounds[2] = bounds[3] = -Infinity
    for(var i=0; i<2; ++i) {
      var axisTicks = ticks[i].slice(0)
      if(axisTicks.length === 0) {
        continue
      }
      axisTicks.sort(compareTicks)
      bounds[i]   = Math.min(bounds[i], axisTicks[0].x)
      bounds[i+2] = Math.max(bounds[i+2], axisTicks[axisTicks.length-1].x)
    }
  
    //Update grid
    this.grid.update({
      bounds: bounds,
      ticks:  ticks
    })
  
    //Update text
    this.text.update({
      bounds:     bounds,
      ticks:      ticks,
      labels:     options.labels    || ['x', 'y'],
      labelSize:  options.labelSize || [12,12],
      labelFont:  options.labelFont || ['sans-serif', 'sans-serif'],
      title:      options.title     || '',
      titleSize:  options.titleSize || 18,
      titleFont:  options.titleFont || 'sans-serif'
    })
  
    this.static = !!options.static;
  
    this.setDirty()
  }
  
  proto.dispose = function() {
    this.box.dispose()
    this.grid.dispose()
    this.text.dispose()
    this.line.dispose()
    for(var i=this.objects.length-1; i>=0; --i) {
      this.objects[i].dispose()
    }
    this.objects.length = 0
    for(var i=this.overlays.length-1; i>=0; --i) {
      this.overlays[i].dispose()
    }
    this.overlays.length = 0
  
    this.gl = null
  }
  
  proto.addObject = function(object) {
    if(this.objects.indexOf(object) < 0) {
      this.objects.push(object)
      this.setDirty()
    }
  }
  
  proto.removeObject = function(object) {
    var objects = this.objects
    for(var i=0; i<objects.length; ++i) {
      if(objects[i] === object) {
        objects.splice(i,1)
        this.setDirty()
        break
      }
    }
  }
  
  proto.addOverlay = function(object) {
    if(this.overlays.indexOf(object) < 0) {
      this.overlays.push(object)
      this.setOverlayDirty()
    }
  }
  
  proto.removeOverlay = function(object) {
    var objects = this.overlays
    for(var i=0; i<objects.length; ++i) {
      if(objects[i] === object) {
        objects.splice(i,1)
        this.setOverlayDirty()
        break
      }
    }
  }
  
  function createGLPlot2D(options) {
    var gl = options.gl
    var pickBuffer = createPick(gl, [
      gl.drawingBufferWidth, gl.drawingBufferHeight])
    var plot = new GLPlot2D(gl, pickBuffer)
    plot.grid = createGrid(plot)
    plot.text = createText(plot)
    plot.line = createLine(plot)
    plot.box  = createBox(plot)
    plot.update(options)
    return plot
  }
  
  },{"./lib/box":293,"./lib/grid":294,"./lib/line":295,"./lib/text":297,"gl-select-static":311}],299:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createCamera
  
  var now         = _dereq_('right-now')
  var createView  = _dereq_('3d-view')
  var mouseChange = _dereq_('mouse-change')
  var mouseWheel  = _dereq_('mouse-wheel')
  var mouseOffset = _dereq_('mouse-event-offset')
  var hasPassive  = _dereq_('has-passive-events')
  
  function createCamera(element, options) {
    element = element || document.body
    options = options || {}
  
    var limits  = [ 0.01, Infinity ]
    if('distanceLimits' in options) {
      limits[0] = options.distanceLimits[0]
      limits[1] = options.distanceLimits[1]
    }
    if('zoomMin' in options) {
      limits[0] = options.zoomMin
    }
    if('zoomMax' in options) {
      limits[1] = options.zoomMax
    }
  
    var view = createView({
      center: options.center || [0,0,0],
      up:     options.up     || [0,1,0],
      eye:    options.eye    || [0,0,10],
      mode:   options.mode   || 'orbit',
      distanceLimits: limits
    })
  
    var pmatrix = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
    var distance = 0.0
    var width   = element.clientWidth
    var height  = element.clientHeight
  
    var camera = {
      keyBindingMode: 'rotate',
      enableWheel: true,
      view:               view,
      element:            element,
      delay:              options.delay          || 16,
      rotateSpeed:        options.rotateSpeed    || 1,
      zoomSpeed:          options.zoomSpeed      || 1,
      translateSpeed:     options.translateSpeed || 1,
      flipX:              !!options.flipX,
      flipY:              !!options.flipY,
      modes:              view.modes,
      _ortho: options._ortho || (options.projection && options.projection.type === 'orthographic') || false,
      tick: function() {
        var t = now()
        var delay = this.delay
        var ctime = t - 2 * delay
        view.idle(t-delay)
        view.recalcMatrix(ctime)
        view.flush(t-(100+delay*2))
        var allEqual = true
        var matrix = view.computedMatrix
        for(var i=0; i<16; ++i) {
          allEqual = allEqual && (pmatrix[i] === matrix[i])
          pmatrix[i] = matrix[i]
        }
        var sizeChanged =
            element.clientWidth === width &&
            element.clientHeight === height
        width  = element.clientWidth
        height = element.clientHeight
        if(allEqual) {
          return !sizeChanged
        }
        distance = Math.exp(view.computedRadius[0])
        return true
      },
      lookAt: function(eye, center, up) {
        view.lookAt(view.lastT(), eye, center, up)
      },
      rotate: function(pitch, yaw, roll) {
        view.rotate(view.lastT(), pitch, yaw, roll)
      },
      pan: function(dx, dy, dz) {
        view.pan(view.lastT(), dx, dy, dz)
      },
      translate: function(dx, dy, dz) {
        view.translate(view.lastT(), dx, dy, dz)
      }
    }
  
    Object.defineProperties(camera, {
      matrix: {
        get: function() {
          return view.computedMatrix
        },
        set: function(mat) {
          view.setMatrix(view.lastT(), mat)
          return view.computedMatrix
        },
        enumerable: true
      },
      mode: {
        get: function() {
          return view.getMode()
        },
        set: function(mode) {
          var curUp = view.computedUp.slice()
          var curEye = view.computedEye.slice()
          var curCenter = view.computedCenter.slice()
          view.setMode(mode)
          if(mode === 'turntable') {
            // Hacky time warping stuff to generate smooth animation
            var t0 = now()
            view._active.lookAt(t0, curEye, curCenter, curUp)
            view._active.lookAt(t0 + 500, curEye, curCenter, [0, 0, 1])
            view._active.flush(t0)
          }
          return view.getMode()
        },
        enumerable: true
      },
      center: {
        get: function() {
          return view.computedCenter
        },
        set: function(ncenter) {
          view.lookAt(view.lastT(), null, ncenter)
          return view.computedCenter
        },
        enumerable: true
      },
      eye: {
        get: function() {
          return view.computedEye
        },
        set: function(neye) {
          view.lookAt(view.lastT(), neye)
          return view.computedEye
        },
        enumerable: true
      },
      up: {
        get: function() {
          return view.computedUp
        },
        set: function(nup) {
          view.lookAt(view.lastT(), null, null, nup)
          return view.computedUp
        },
        enumerable: true
      },
      distance: {
        get: function() {
          return distance
        },
        set: function(d) {
          view.setDistance(view.lastT(), d)
          return d
        },
        enumerable: true
      },
      distanceLimits: {
        get: function() {
          return view.getDistanceLimits(limits)
        },
        set: function(v) {
          view.setDistanceLimits(v)
          return v
        },
        enumerable: true
      }
    })
  
    element.addEventListener('contextmenu', function(ev) {
      ev.preventDefault()
      return false
    })
  
    camera._lastX = -1
    camera._lastY = -1
    camera._lastMods = {shift: false, control: false, alt: false, meta: false}
  
    camera.enableMouseListeners = function() {
  
      camera.mouseListener = mouseChange(element, handleInteraction)
  
      //enable simple touch interactions
      element.addEventListener('touchstart', function (ev) {
        var xy = mouseOffset(ev.changedTouches[0], element)
        handleInteraction(0, xy[0], xy[1], camera._lastMods)
        handleInteraction(1, xy[0], xy[1], camera._lastMods)
  
        ev.preventDefault()
      }, hasPassive ? {passive: false} : false)
  
      element.addEventListener('touchmove', function (ev) {
        var xy = mouseOffset(ev.changedTouches[0], element)
        handleInteraction(1, xy[0], xy[1], camera._lastMods)
  
        ev.preventDefault()
      }, hasPassive ? {passive: false} : false)
  
      element.addEventListener('touchend', function (ev) {
  
        handleInteraction(0, camera._lastX, camera._lastY, camera._lastMods)
  
        ev.preventDefault()
      }, hasPassive ? {passive: false} : false)
  
      function handleInteraction (buttons, x, y, mods) {
        var keyBindingMode = camera.keyBindingMode
  
        if(keyBindingMode === false) return
  
        var rotate = keyBindingMode === 'rotate'
        var pan = keyBindingMode === 'pan'
        var zoom = keyBindingMode === 'zoom'
  
        var ctrl = !!mods.control
        var alt = !!mods.alt
        var shift = !!mods.shift
        var left = !!(buttons & 1)
        var right = !!(buttons & 2)
        var middle = !!(buttons & 4)
  
        var scale = 1.0 / element.clientHeight
        var dx    = scale * (x - camera._lastX)
        var dy    = scale * (y - camera._lastY)
  
        var flipX = camera.flipX ? 1 : -1
        var flipY = camera.flipY ? 1 : -1
  
        var drot  = Math.PI * camera.rotateSpeed
  
        var t = now()
  
        if(camera._lastX !== -1 && camera._lastY !== -1) {
          if((rotate && left && !ctrl && !alt && !shift) || (left && !ctrl && !alt && shift)) {
            // Rotate
            view.rotate(t, flipX * drot * dx, -flipY * drot * dy, 0)
          }
  
          if((pan && left && !ctrl && !alt && !shift) || right || (left && ctrl && !alt && !shift)) {
            // Pan
            view.pan(t, -camera.translateSpeed * dx * distance, camera.translateSpeed * dy * distance, 0)
          }
  
          if((zoom && left && !ctrl && !alt && !shift) || middle || (left && !ctrl && alt && !shift)) {
            // Zoom
            var kzoom = -camera.zoomSpeed * dy / window.innerHeight * (t - view.lastT()) * 100
            view.pan(t, 0, 0, distance * (Math.exp(kzoom) - 1))
          }
        }
  
        camera._lastX = x
        camera._lastY = y
        camera._lastMods = mods
  
        return true
      }
  
      camera.wheelListener = mouseWheel(element, function(dx, dy) {
        // TODO remove now that we can disable scroll via scrollZoom?
        if(camera.keyBindingMode === false) return
        if(!camera.enableWheel) return
  
        var flipX = camera.flipX ? 1 : -1
        var flipY = camera.flipY ? 1 : -1
        var t = now()
        if(Math.abs(dx) > Math.abs(dy)) {
          view.rotate(t, 0, 0, -dx * flipX * Math.PI * camera.rotateSpeed / window.innerWidth)
        } else {
          if(!camera._ortho) {
            var kzoom = -camera.zoomSpeed * flipY * dy / window.innerHeight * (t - view.lastT()) / 20.0
            view.pan(t, 0, 0, distance * (Math.exp(kzoom) - 1))
          }
        }
      }, true)
    }
  
    camera.enableMouseListeners()
  
    return camera
  }
  
  },{"3d-view":54,"has-passive-events":415,"mouse-change":457,"mouse-event-offset":458,"mouse-wheel":460,"right-now":514}],300:[function(_dereq_,module,exports){
  var glslify      = _dereq_('glslify')
  var createShader = _dereq_('gl-shader')
  
  var vertSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\nattribute vec2 position;\nvarying vec2 uv;\nvoid main() {\n  uv = position;\n  gl_Position = vec4(position, 0, 1);\n}"])
  var fragSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform sampler2D accumBuffer;\nvarying vec2 uv;\n\nvoid main() {\n  vec4 accum = texture2D(accumBuffer, 0.5 * (uv + 1.0));\n  gl_FragColor = min(vec4(1,1,1,1), accum);\n}"])
  
  module.exports = function(gl) {
    return createShader(gl, vertSrc, fragSrc, null, [ { name: 'position', type: 'vec2'}])
  }
  
  },{"gl-shader":312,"glslify":413}],301:[function(_dereq_,module,exports){
  'use strict'
  
  var createCamera = _dereq_('./camera.js')
  var createAxes   = _dereq_('gl-axes3d')
  var axesRanges   = _dereq_('gl-axes3d/properties')
  var createSpikes = _dereq_('gl-spikes3d')
  var createSelect = _dereq_('gl-select-static')
  var createFBO    = _dereq_('gl-fbo')
  var drawTriangle = _dereq_('a-big-triangle')
  var mouseChange  = _dereq_('mouse-change')
  var perspective  = _dereq_('gl-mat4/perspective')
  var ortho        = _dereq_('gl-mat4/ortho')
  var createShader = _dereq_('./lib/shader')
  var isMobile = _dereq_('is-mobile')({ tablet: true, featureDetect: true })
  
  module.exports = {
    createScene: createScene,
    createCamera: createCamera
  }
  
  function MouseSelect() {
    this.mouse          = [-1,-1]
    this.screen         = null
    this.distance       = Infinity
    this.index          = null
    this.dataCoordinate = null
    this.dataPosition   = null
    this.object         = null
    this.data           = null
  }
  
  function getContext(canvas, options) {
    var gl = null
    try {
      gl = canvas.getContext('webgl', options)
      if(!gl) {
        gl = canvas.getContext('experimental-webgl', options)
      }
    } catch(e) {
      return null
    }
    return gl
  }
  
  function roundUpPow10(x) {
    var y = Math.round(Math.log(Math.abs(x)) / Math.log(10))
    if(y < 0) {
      var base = Math.round(Math.pow(10, -y))
      return Math.ceil(x*base) / base
    } else if(y > 0) {
      var base = Math.round(Math.pow(10, y))
      return Math.ceil(x/base) * base
    }
    return Math.ceil(x)
  }
  
  function defaultBool(x) {
    if(typeof x === 'boolean') {
      return x
    }
    return true
  }
  
  function createScene(options) {
    options = options || {}
    options.camera = options.camera || {}
  
    var canvas = options.canvas
    if(!canvas) {
      canvas = document.createElement('canvas')
      if(options.container) {
        var container = options.container
        container.appendChild(canvas)
      } else {
        document.body.appendChild(canvas)
      }
    }
  
    var gl = options.gl
    if(!gl) {
      if(options.glOptions) {
        isMobile = !!options.glOptions.preserveDrawingBuffer
      }
  
      gl = getContext(canvas,
        options.glOptions || {
          premultipliedAlpha: true,
          antialias: true,
          preserveDrawingBuffer: isMobile
        })
    }
    if(!gl) {
      throw new Error('webgl not supported')
    }
  
    //Initial bounds
    var bounds = options.bounds || [[-10,-10,-10], [10,10,10]]
  
    //Create selection
    var selection = new MouseSelect()
  
    //Accumulation buffer
    var accumBuffer = createFBO(gl,
      gl.drawingBufferWidth, gl.drawingBufferHeight, {
        preferFloat: !isMobile
      })
  
    var accumShader = createShader(gl)
  
    var isOrtho =
      (options.cameraObject && options.cameraObject._ortho === true) ||
      (options.camera.projection && options.camera.projection.type === 'orthographic') ||
      false
  
    //Create a camera
    var cameraOptions = {
      eye:     options.camera.eye     || [2,0,0],
      center:  options.camera.center  || [0,0,0],
      up:      options.camera.up      || [0,1,0],
      zoomMin: options.camera.zoomMax || 0.1,
      zoomMax: options.camera.zoomMin || 100,
      mode:    options.camera.mode    || 'turntable',
      _ortho:  isOrtho
    }
  
    //Create axes
    var axesOptions = options.axes || {}
    var axes = createAxes(gl, axesOptions)
    axes.enable = !axesOptions.disable
  
    //Create spikes
    var spikeOptions = options.spikes || {}
    var spikes = createSpikes(gl, spikeOptions)
  
    //Object list is empty initially
    var objects         = []
    var pickBufferIds   = []
    var pickBufferCount = []
    var pickBuffers     = []
  
    //Dirty flag, skip redraw if scene static
    var dirty       = true
    var pickDirty   = true
  
    var projection     = new Array(16)
    var model          = new Array(16)
  
    var cameraParams = {
      view:         null,
      projection:   projection,
      model:        model,
      _ortho:       false
    }
  
    var pickDirty = true
  
    var viewShape = [ gl.drawingBufferWidth, gl.drawingBufferHeight ]
  
    var camera = options.cameraObject || createCamera(canvas, cameraOptions)
  
    //Create scene object
    var scene = {
      gl:           gl,
      contextLost:  false,
      pixelRatio:   options.pixelRatio || 1,
      canvas:       canvas,
      selection:    selection,
      camera:       camera,
      axes:         axes,
      axesPixels:   null,
      spikes:       spikes,
      bounds:       bounds,
      objects:      objects,
      shape:        viewShape,
      aspect:       options.aspectRatio || [1,1,1],
      pickRadius:   options.pickRadius || 10,
      zNear:        options.zNear || 0.01,
      zFar:         options.zFar  || 1000,
      fovy:         options.fovy  || Math.PI/4,
      clearColor:   options.clearColor || [0,0,0,0],
      autoResize:   defaultBool(options.autoResize),
      autoBounds:   defaultBool(options.autoBounds),
      autoScale:    !!options.autoScale,
      autoCenter:   defaultBool(options.autoCenter),
      clipToBounds: defaultBool(options.clipToBounds),
      snapToData:   !!options.snapToData,
      onselect:     options.onselect || null,
      onrender:     options.onrender || null,
      onclick:      options.onclick  || null,
      cameraParams: cameraParams,
      oncontextloss: null,
      mouseListener: null,
      _stopped: false,
  
      getAspectratio: function() {
        return {
          x: this.aspect[0],
          y: this.aspect[1],
          z: this.aspect[2]
        }
      },
  
      setAspectratio: function(aspectratio) {
        this.aspect[0] = aspectratio.x
        this.aspect[1] = aspectratio.y
        this.aspect[2] = aspectratio.z
        pickDirty = true
      },
  
      setBounds: function(axisIndex, range) {
        this.bounds[0][axisIndex] = range.min
        this.bounds[1][axisIndex] = range.max
      },
  
      setClearColor: function(clearColor) {
        this.clearColor = clearColor
      },
  
      clearRGBA: function() {
        this.gl.clearColor(
          this.clearColor[0],
          this.clearColor[1],
          this.clearColor[2],
          this.clearColor[3]
        )
  
        this.gl.clear(
          this.gl.COLOR_BUFFER_BIT |
          this.gl.DEPTH_BUFFER_BIT
        )
      }
    }
  
    var pickShape = [ (gl.drawingBufferWidth/scene.pixelRatio)|0, (gl.drawingBufferHeight/scene.pixelRatio)|0 ]
  
    function resizeListener() {
      if(scene._stopped) {
        return
      }
      if(!scene.autoResize) {
        return
      }
      var parent = canvas.parentNode
      var width  = 1
      var height = 1
      if(parent && parent !== document.body) {
        width  = parent.clientWidth
        height = parent.clientHeight
      } else {
        width  = window.innerWidth
        height = window.innerHeight
      }
      var nextWidth  = Math.ceil(width  * scene.pixelRatio)|0
      var nextHeight = Math.ceil(height * scene.pixelRatio)|0
      if(nextWidth !== canvas.width || nextHeight !== canvas.height) {
        canvas.width   = nextWidth
        canvas.height  = nextHeight
        var style = canvas.style
        style.position = style.position || 'absolute'
        style.left     = '0px'
        style.top      = '0px'
        style.width    = width  + 'px'
        style.height   = height + 'px'
        dirty = true
      }
    }
    if(scene.autoResize) {
      resizeListener()
    }
    window.addEventListener('resize', resizeListener)
  
    function reallocPickIds() {
      var numObjs = objects.length
      var numPick = pickBuffers.length
      for(var i=0; i<numPick; ++i) {
        pickBufferCount[i] = 0
      }
      obj_loop:
      for(var i=0; i<numObjs; ++i) {
        var obj = objects[i]
        var pickCount = obj.pickSlots
        if(!pickCount) {
          pickBufferIds[i] = -1
          continue
        }
        for(var j=0; j<numPick; ++j) {
          if(pickBufferCount[j] + pickCount < 255) {
            pickBufferIds[i] = j
            obj.setPickBase(pickBufferCount[j]+1)
            pickBufferCount[j] += pickCount
            continue obj_loop
          }
        }
        //Create new pick buffer
        var nbuffer = createSelect(gl, viewShape)
        pickBufferIds[i] = numPick
        pickBuffers.push(nbuffer)
        pickBufferCount.push(pickCount)
        obj.setPickBase(1)
        numPick += 1
      }
      while(numPick > 0 && pickBufferCount[numPick-1] === 0) {
        pickBufferCount.pop()
        pickBuffers.pop().dispose()
      }
    }
  
    scene.update = function(options) {
  
      if(scene._stopped) {
        return
      }
      options = options || {}
      dirty = true
      pickDirty = true
    }
  
    scene.add = function(obj) {
      if(scene._stopped) {
        return
      }
      obj.axes = axes
      objects.push(obj)
      pickBufferIds.push(-1)
      dirty = true
      pickDirty = true
      reallocPickIds()
    }
  
    scene.remove = function(obj) {
      if(scene._stopped) {
        return
      }
      var idx = objects.indexOf(obj)
      if(idx < 0) {
        return
      }
      objects.splice(idx, 1)
      pickBufferIds.pop()
      dirty = true
      pickDirty = true
      reallocPickIds()
    }
  
    scene.dispose = function() {
      if(scene._stopped) {
        return
      }
  
      scene._stopped = true
  
      window.removeEventListener('resize', resizeListener)
      canvas.removeEventListener('webglcontextlost', checkContextLoss)
      scene.mouseListener.enabled = false
  
      if(scene.contextLost) {
        return
      }
  
      //Destroy objects
      axes.dispose()
      spikes.dispose()
      for(var i=0; i<objects.length; ++i) {
        objects[i].dispose()
      }
  
      //Clean up buffers
      accumBuffer.dispose()
      for(var i=0; i<pickBuffers.length; ++i) {
        pickBuffers[i].dispose()
      }
  
      //Clean up shaders
      accumShader.dispose()
  
      //Release all references
      gl = null
      axes = null
      spikes = null
      objects = []
    }
  
    //Update mouse position
    scene._mouseRotating = false
    scene._prevButtons = 0
  
    scene.enableMouseListeners = function() {
  
      scene.mouseListener = mouseChange(canvas, function(buttons, x, y) {
        if(scene._stopped) {
          return
        }
  
        var numPick = pickBuffers.length
        var numObjs = objects.length
        var prevObj = selection.object
  
        selection.distance = Infinity
        selection.mouse[0] = x
        selection.mouse[1] = y
        selection.object = null
        selection.screen = null
        selection.dataCoordinate = selection.dataPosition = null
  
        var change = false
  
        if(buttons && scene._prevButtons) {
          scene._mouseRotating = true
        } else {
          if(scene._mouseRotating) {
            pickDirty = true
          }
          scene._mouseRotating = false
  
          for(var i=0; i<numPick; ++i) {
            var result = pickBuffers[i].query(x, pickShape[1] - y - 1, scene.pickRadius)
            if(result) {
              if(result.distance > selection.distance) {
                continue
              }
              for(var j=0; j<numObjs; ++j) {
                var obj = objects[j]
                if(pickBufferIds[j] !== i) {
                  continue
                }
                var objPick = obj.pick(result)
                if(objPick) {
                  selection.buttons        = buttons
                  selection.screen         = result.coord
                  selection.distance       = result.distance
                  selection.object         = obj
                  selection.index          = objPick.distance
                  selection.dataPosition   = objPick.position
                  selection.dataCoordinate = objPick.dataCoordinate
                  selection.data           = objPick
                  change = true
                }
              }
            }
          }
        }
  
        if(prevObj && prevObj !== selection.object) {
          if(prevObj.highlight) {
            prevObj.highlight(null)
          }
          dirty = true
        }
        if(selection.object) {
          if(selection.object.highlight) {
            selection.object.highlight(selection.data)
          }
          dirty = true
        }
  
        change = change || (selection.object !== prevObj)
        if(change && scene.onselect) {
          scene.onselect(selection)
        }
  
        if((buttons & 1) && !(scene._prevButtons & 1) && scene.onclick) {
          scene.onclick(selection)
        }
        scene._prevButtons = buttons
      })
    }
  
    function checkContextLoss() {
      if(scene.contextLost) {
        return true
      }
      if(gl.isContextLost()) {
        scene.contextLost = true
        scene.mouseListener.enabled = false
        scene.selection.object = null
        if(scene.oncontextloss) {
          scene.oncontextloss()
        }
      }
    }
  
    canvas.addEventListener('webglcontextlost', checkContextLoss)
  
    //Render the scene for mouse picking
    function renderPick() {
      if(checkContextLoss()) {
        return
      }
  
      gl.colorMask(true, true, true, true)
      gl.depthMask(true)
      gl.disable(gl.BLEND)
      gl.enable(gl.DEPTH_TEST)
      gl.depthFunc(gl.LEQUAL)
  
      var numObjs = objects.length
      var numPick = pickBuffers.length
      for(var j=0; j<numPick; ++j) {
        var buf = pickBuffers[j]
        buf.shape = pickShape
        buf.begin()
        for(var i=0; i<numObjs; ++i) {
          if(pickBufferIds[i] !== j) {
            continue
          }
          var obj = objects[i]
          if(obj.drawPick) {
            obj.pixelRatio = 1
            obj.drawPick(cameraParams)
          }
        }
        buf.end()
      }
    }
  
    var nBounds = [
      [ Infinity, Infinity, Infinity],
      [-Infinity,-Infinity,-Infinity]]
  
    var prevBounds = [nBounds[0].slice(), nBounds[1].slice()]
  
    function redraw() {
      if(checkContextLoss()) {
        return
      }
  
      resizeListener()
  
      //Tick camera
      var cameraMoved = scene.camera.tick()
      cameraParams.view = scene.camera.matrix
      dirty     = dirty || cameraMoved
      pickDirty = pickDirty || cameraMoved
  
        //Set pixel ratio
      axes.pixelRatio   = scene.pixelRatio
      spikes.pixelRatio = scene.pixelRatio
  
      //Check if any objects changed, recalculate bounds
      var numObjs = objects.length
      var lo = nBounds[0]
      var hi = nBounds[1]
      lo[0] = lo[1] = lo[2] =  Infinity
      hi[0] = hi[1] = hi[2] = -Infinity
      for(var i=0; i<numObjs; ++i) {
        var obj = objects[i]
  
        //Set the axes properties for each object
        obj.pixelRatio = scene.pixelRatio
        obj.axes = scene.axes
  
        dirty = dirty || !!obj.dirty
        pickDirty = pickDirty || !!obj.dirty
        var obb = obj.bounds
        if(obb) {
          var olo = obb[0]
          var ohi = obb[1]
          for(var j=0; j<3; ++j) {
            lo[j] = Math.min(lo[j], olo[j])
            hi[j] = Math.max(hi[j], ohi[j])
          }
        }
      }
  
      //Recalculate bounds
      var bounds = scene.bounds
      if(scene.autoBounds) {
        for(var j=0; j<3; ++j) {
          if(hi[j] < lo[j]) {
            lo[j] = -1
            hi[j] = 1
          } else {
            if(lo[j] === hi[j]) {
              lo[j] -= 1
              hi[j] += 1
            }
            var padding = 0.05 * (hi[j] - lo[j])
            lo[j] = lo[j] - padding
            hi[j] = hi[j] + padding
          }
          bounds[0][j] = lo[j]
          bounds[1][j] = hi[j]
        }
      }
  
      var boundsChanged = false
      for(var j=0; j<3; ++j) {
          boundsChanged = boundsChanged ||
              (prevBounds[0][j] !== bounds[0][j])  ||
              (prevBounds[1][j] !== bounds[1][j])
          prevBounds[0][j] = bounds[0][j]
          prevBounds[1][j] = bounds[1][j]
      }
  
      //Recalculate bounds
      pickDirty = pickDirty || boundsChanged
      dirty = dirty || boundsChanged
  
      if(!dirty) {
        return
      }
  
      if(boundsChanged) {
        var tickSpacing = [0,0,0]
        for(var i=0; i<3; ++i) {
          tickSpacing[i] = roundUpPow10((bounds[1][i]-bounds[0][i]) / 10.0)
        }
        if(axes.autoTicks) {
          axes.update({
            bounds: bounds,
            tickSpacing: tickSpacing
          })
        } else {
          axes.update({
            bounds: bounds
          })
        }
      }
  
      //Get scene
      var width  = gl.drawingBufferWidth
      var height = gl.drawingBufferHeight
      viewShape[0] = width
      viewShape[1] = height
      pickShape[0] = Math.max(width/scene.pixelRatio, 1)|0
      pickShape[1] = Math.max(height/scene.pixelRatio, 1)|0
  
      //Compute camera parameters
      calcCameraParams(scene, isOrtho)
  
      //Apply axes/clip bounds
      for(var i=0; i<numObjs; ++i) {
        var obj = objects[i]
  
        //Set axes bounds
        obj.axesBounds = bounds
  
        //Set clip bounds
        if(scene.clipToBounds) {
          obj.clipBounds = bounds
        }
      }
      //Set spike parameters
      if(selection.object) {
        if(scene.snapToData) {
          spikes.position = selection.dataCoordinate
        } else {
          spikes.position = selection.dataPosition
        }
        spikes.bounds = bounds
      }
  
      //If state changed, then redraw pick buffers
      if(pickDirty) {
        pickDirty = false
        renderPick()
      }
  
      //Recalculate pixel data
      scene.axesPixels = axesRanges(scene.axes, cameraParams, width, height)
  
      //Call render callback
      if(scene.onrender) {
        scene.onrender()
      }
  
      //Read value
      gl.bindFramebuffer(gl.FRAMEBUFFER, null)
      gl.viewport(0, 0, width, height)
  
      //General strategy: 3 steps
      //  1. render non-transparent objects
      //  2. accumulate transparent objects into separate fbo
      //  3. composite final scene
  
      //Clear FBO
      scene.clearRGBA()
  
      gl.depthMask(true)
      gl.colorMask(true, true, true, true)
      gl.enable(gl.DEPTH_TEST)
      gl.depthFunc(gl.LEQUAL)
      gl.disable(gl.BLEND)
      gl.disable(gl.CULL_FACE)  //most visualization surfaces are 2 sided
  
      //Render opaque pass
      var hasTransparent = false
      if(axes.enable) {
        hasTransparent = hasTransparent || axes.isTransparent()
        axes.draw(cameraParams)
      }
      spikes.axes = axes
      if(selection.object) {
        spikes.draw(cameraParams)
      }
  
      gl.disable(gl.CULL_FACE)  //most visualization surfaces are 2 sided
  
      for(var i=0; i<numObjs; ++i) {
        var obj = objects[i]
        obj.axes = axes
        obj.pixelRatio = scene.pixelRatio
        if(obj.isOpaque && obj.isOpaque()) {
          obj.draw(cameraParams)
        }
        if(obj.isTransparent && obj.isTransparent()) {
          hasTransparent = true
        }
      }
  
      if(hasTransparent) {
        //Render transparent pass
        accumBuffer.shape = viewShape
        accumBuffer.bind()
        gl.clear(gl.DEPTH_BUFFER_BIT)
        gl.colorMask(false, false, false, false)
        gl.depthMask(true)
        gl.depthFunc(gl.LESS)
  
        //Render forward facing objects
        if(axes.enable && axes.isTransparent()) {
          axes.drawTransparent(cameraParams)
        }
        for(var i=0; i<numObjs; ++i) {
          var obj = objects[i]
          if(obj.isOpaque && obj.isOpaque()) {
            obj.draw(cameraParams)
          }
        }
  
        //Render transparent pass
        gl.enable(gl.BLEND)
        gl.blendEquation(gl.FUNC_ADD)
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA)
        gl.colorMask(true, true, true, true)
        gl.depthMask(false)
        gl.clearColor(0,0,0,0)
        gl.clear(gl.COLOR_BUFFER_BIT)
  
        if(axes.isTransparent()) {
          axes.drawTransparent(cameraParams)
        }
  
        for(var i=0; i<numObjs; ++i) {
          var obj = objects[i]
          if(obj.isTransparent && obj.isTransparent()) {
            obj.drawTransparent(cameraParams)
          }
        }
  
        //Unbind framebuffer
        gl.bindFramebuffer(gl.FRAMEBUFFER, null)
  
        //Draw composite pass
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA)
        gl.disable(gl.DEPTH_TEST)
        accumShader.bind()
        accumBuffer.color[0].bind(0)
        accumShader.uniforms.accumBuffer = 0
        drawTriangle(gl)
  
        //Turn off blending
        gl.disable(gl.BLEND)
      }
  
      //Clear dirty flags
      dirty = false
      for(var i=0; i<numObjs; ++i) {
        objects[i].dirty = false
      }
    }
  
    //Draw the whole scene
    function render() {
      if(scene._stopped || scene.contextLost) {
        return
      }
      // this order is important: ios safari sometimes has sync raf
      redraw()
      requestAnimationFrame(render)
    }
  
    scene.enableMouseListeners()
    render()
  
    //Force redraw of whole scene
    scene.redraw = function() {
      if(scene._stopped) {
        return
      }
      dirty = true
      redraw()
    }
  
    return scene
  }
  
  function calcCameraParams(scene, isOrtho) {
    var bounds = scene.bounds
    var cameraParams = scene.cameraParams
    var projection = cameraParams.projection
    var model = cameraParams.model
  
    var width = scene.gl.drawingBufferWidth
    var height = scene.gl.drawingBufferHeight
    var zNear = scene.zNear
    var zFar = scene.zFar
    var fovy = scene.fovy
  
    var r = width / height
  
    if(isOrtho) {
      ortho(projection,
        -r,
        r,
        -1,
        1,
        zNear,
        zFar
      )
      cameraParams._ortho = true
    } else {
      perspective(projection,
        fovy,
        r,
        zNear,
        zFar
      )
      cameraParams._ortho = false
    }
  
    //Compute model matrix
    for(var i=0; i<16; ++i) {
      model[i] = 0
    }
    model[15] = 1
  
    var maxS = 0
    for(var i=0; i<3; ++i) {
      maxS = Math.max(maxS, bounds[1][i] - bounds[0][i])
    }
  
    for(var i=0; i<3; ++i) {
      if(scene.autoScale) {
        model[5*i] = scene.aspect[i] / (bounds[1][i] - bounds[0][i])
      } else {
        model[5*i] = 1 / maxS
      }
      if(scene.autoCenter) {
        model[12+i] = -model[5*i] * 0.5 * (bounds[0][i] + bounds[1][i])
      }
    }
  }
  
  },{"./camera.js":299,"./lib/shader":300,"a-big-triangle":64,"gl-axes3d":250,"gl-axes3d/properties":257,"gl-fbo":266,"gl-mat4/ortho":281,"gl-mat4/perspective":282,"gl-select-static":311,"gl-spikes3d":321,"is-mobile":441,"mouse-change":457}],302:[function(_dereq_,module,exports){
  var glslify = _dereq_('glslify')
  
  exports.pointVertex       = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform float pointCloud;\n\nhighp float rand(vec2 co) {\n  highp float a = 12.9898;\n  highp float b = 78.233;\n  highp float c = 43758.5453;\n  highp float d = dot(co.xy, vec2(a, b));\n  highp float e = mod(d, 3.14);\n  return fract(sin(e) * c);\n}\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n    // if we don't jitter the point size a bit, overall point cloud\n    // saturation 'jumps' on zooming, which is disturbing and confusing\n  gl_PointSize = pointSize * ((19.5 + rand(position)) / 20.0);\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    // get the same square surface as circle would be\n    gl_PointSize *= 0.886;\n  }\n}"])
  exports.pointFragment     = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color, borderColor;\nuniform float centerFraction;\nuniform float pointCloud;\n\nvoid main() {\n  float radius;\n  vec4 baseColor;\n  if(pointCloud != 0.0) { // pointCloud is truthy\n    if(centerFraction == 1.0) {\n      gl_FragColor = color;\n    } else {\n      gl_FragColor = mix(borderColor, color, centerFraction);\n    }\n  } else {\n    radius = length(2.0 * gl_PointCoord.xy - 1.0);\n    if(radius > 1.0) {\n      discard;\n    }\n    baseColor = mix(borderColor, color, step(radius, centerFraction));\n    gl_FragColor = vec4(baseColor.rgb * baseColor.a, baseColor.a);\n  }\n}\n"])
  exports.pickVertex        = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 position;\nattribute vec4 pickId;\n\nuniform mat3 matrix;\nuniform float pointSize;\nuniform vec4 pickOffset;\n\nvarying vec4 fragId;\n\nvoid main() {\n  vec3 hgPosition = matrix * vec3(position, 1);\n  gl_Position  = vec4(hgPosition.xy, 0, hgPosition.z);\n  gl_PointSize = pointSize;\n\n  vec4 id = pickId + pickOffset;\n  id.y += floor(id.x / 256.0);\n  id.x -= floor(id.x / 256.0) * 256.0;\n\n  id.z += floor(id.y / 256.0);\n  id.y -= floor(id.y / 256.0) * 256.0;\n\n  id.w += floor(id.z / 256.0);\n  id.z -= floor(id.z / 256.0) * 256.0;\n\n  fragId = id;\n}\n"])
  exports.pickFragment      = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragId;\n\nvoid main() {\n  float radius = length(2.0 * gl_PointCoord.xy - 1.0);\n  if(radius > 1.0) {\n    discard;\n  }\n  gl_FragColor = fragId / 255.0;\n}\n"])
  
  },{"glslify":413}],303:[function(_dereq_,module,exports){
  'use strict'
  
  var createShader = _dereq_('gl-shader')
  var createBuffer = _dereq_('gl-buffer')
  
  var pool = _dereq_('typedarray-pool')
  
  var SHADERS = _dereq_('./lib/shader')
  
  module.exports = createPointcloud2D
  
  function Pointcloud2D(plot, offsetBuffer, pickBuffer, shader, pickShader) {
    this.plot           = plot
    this.offsetBuffer   = offsetBuffer
    this.pickBuffer     = pickBuffer
    this.shader         = shader
    this.pickShader     = pickShader
    this.sizeMin        = 0.5
    this.sizeMinCap     = 2
    this.sizeMax        = 20
    this.areaRatio      = 1.0
    this.pointCount     = 0
    this.color          = [1, 0, 0, 1]
    this.borderColor    = [0, 0, 0, 1]
    this.blend          = false
    this.pickOffset     = 0
    this.points         = null
  }
  
  var proto = Pointcloud2D.prototype
  
  proto.dispose = function() {
    this.shader.dispose()
    this.pickShader.dispose()
    this.offsetBuffer.dispose()
    this.pickBuffer.dispose()
    this.plot.removeObject(this)
  }
  
  proto.update = function(options) {
  
    var i
  
    options = options || {}
  
    function dflt(opt, value) {
      if(opt in options) {
        return options[opt]
      }
      return value
    }
  
    this.sizeMin      = dflt('sizeMin', 0.5)
    // this.sizeMinCap      = dflt('sizeMinCap', 2)
    this.sizeMax      = dflt('sizeMax', 20)
    this.color        = dflt('color', [1, 0, 0, 1]).slice()
    this.areaRatio    = dflt('areaRatio', 1)
    this.borderColor  = dflt('borderColor', [0, 0, 0, 1]).slice()
    this.blend        = dflt('blend', false)
  
    //Update point data
  
    // Attempt straight-through processing (STP) to avoid allocation and copy
    // TODO eventually abstract out STP logic, maybe into `pool` or a layer above
    var pointCount = options.positions.length >>> 1
    var dataStraightThrough = options.positions instanceof Float32Array
    var idStraightThrough = options.idToIndex instanceof Int32Array && options.idToIndex.length >= pointCount // permit larger to help reuse
  
    var data          = options.positions
    var packed        = dataStraightThrough ? data : pool.mallocFloat32(data.length)
    var packedId      = idStraightThrough ? options.idToIndex : pool.mallocInt32(pointCount)
  
    if(!dataStraightThrough) {
      packed.set(data)
    }
  
    if(!idStraightThrough) {
      packed.set(data)
      for(i = 0; i < pointCount; i++) {
        packedId[i] = i
      }
    }
  
    this.points       = data
  
    this.offsetBuffer.update(packed)
    this.pickBuffer.update(packedId)
  
    if(!dataStraightThrough) {
      pool.free(packed)
    }
  
    if(!idStraightThrough) {
      pool.free(packedId)
    }
  
    this.pointCount = pointCount
    this.pickOffset = 0
  }
  
  function count(points, dataBox) {
    var visiblePointCountEstimate = 0
    var length = points.length >>> 1
    var i
    for(i = 0; i < length; i++) {
      var x = points[i * 2]
      var y = points[i * 2 + 1]
      if(x >= dataBox[0] && x <= dataBox[2] && y >= dataBox[1] && y <= dataBox[3])
        visiblePointCountEstimate++
    }
    return visiblePointCountEstimate
  }
  
  proto.unifiedDraw = (function() {
    var MATRIX = [1, 0, 0,
                  0, 1, 0,
                  0, 0, 1]
    var PICK_VEC4 = [0, 0, 0, 0]
  return function(pickOffset) {
    var pick = pickOffset !== void(0)
  
    var shader        = pick ? this.pickShader : this.shader
    var gl            = this.plot.gl
    var dataBox       = this.plot.dataBox
  
    if(this.pointCount === 0) {
      return pickOffset
    }
  
    var dataX   = dataBox[2] - dataBox[0]
    var dataY   = dataBox[3] - dataBox[1]
  
    var visiblePointCountEstimate = count(this.points, dataBox)
    var basicPointSize =  this.plot.pickPixelRatio * Math.max(Math.min(this.sizeMinCap, this.sizeMin), Math.min(this.sizeMax, this.sizeMax / Math.pow(visiblePointCountEstimate, 0.33333)))
  
    MATRIX[0] = 2.0 / dataX
    MATRIX[4] = 2.0 / dataY
    MATRIX[6] = -2.0 * dataBox[0] / dataX - 1.0
    MATRIX[7] = -2.0 * dataBox[1] / dataY - 1.0
  
    this.offsetBuffer.bind()
  
    shader.bind()
    shader.attributes.position.pointer()
    shader.uniforms.matrix      = MATRIX
    shader.uniforms.color       = this.color
    shader.uniforms.borderColor = this.borderColor
    shader.uniforms.pointCloud = basicPointSize < 5
    shader.uniforms.pointSize = basicPointSize
    shader.uniforms.centerFraction = Math.min(1, Math.max(0, Math.sqrt(1 - this.areaRatio)))
  
    if(pick) {
  
      PICK_VEC4[0] = ( pickOffset        & 0xff)
      PICK_VEC4[1] = ((pickOffset >> 8)  & 0xff)
      PICK_VEC4[2] = ((pickOffset >> 16) & 0xff)
      PICK_VEC4[3] = ((pickOffset >> 24) & 0xff)
  
      this.pickBuffer.bind()
      shader.attributes.pickId.pointer(gl.UNSIGNED_BYTE)
      shader.uniforms.pickOffset = PICK_VEC4
      this.pickOffset = pickOffset
    }
  
    // Worth switching these off, but we can't make assumptions about other
    // renderers, so let's restore it after each draw
    var blend = gl.getParameter(gl.BLEND)
    var dither = gl.getParameter(gl.DITHER)
  
    if(blend && !this.blend)
      gl.disable(gl.BLEND)
    if(dither)
      gl.disable(gl.DITHER)
  
    gl.drawArrays(gl.POINTS, 0, this.pointCount)
  
    if(blend && !this.blend)
      gl.enable(gl.BLEND)
    if(dither)
      gl.enable(gl.DITHER)
  
    return pickOffset + this.pointCount
  }
  })()
  
  proto.draw = proto.unifiedDraw
  proto.drawPick = proto.unifiedDraw
  
  proto.pick = function(x, y, value) {
    var pickOffset = this.pickOffset
    var pointCount = this.pointCount
    if(value < pickOffset || value >= pickOffset + pointCount) {
      return null
    }
    var pointId = value - pickOffset
    var points = this.points
    return {
      object: this,
      pointId: pointId,
      dataCoord: [points[2 * pointId], points[2 * pointId + 1] ]
    }
  }
  
  function createPointcloud2D(plot, options) {
    var gl = plot.gl
    var buffer = createBuffer(gl)
    var pickBuffer = createBuffer(gl)
    var shader = createShader(gl, SHADERS.pointVertex, SHADERS.pointFragment)
    var pickShader = createShader(gl, SHADERS.pickVertex, SHADERS.pickFragment)
  
    var result = new Pointcloud2D(plot, buffer, pickBuffer, shader, pickShader)
    result.update(options)
  
    //Register with plot
    plot.addObject(result)
  
    return result
  }
  
  },{"./lib/shader":302,"gl-buffer":258,"gl-shader":312,"typedarray-pool":567}],304:[function(_dereq_,module,exports){
  module.exports = slerp
  
  /**
   * Performs a spherical linear interpolation between two quat
   *
   * @param {quat} out the receiving quaternion
   * @param {quat} a the first operand
   * @param {quat} b the second operand
   * @param {Number} t interpolation amount between the two inputs
   * @returns {quat} out
   */
  function slerp (out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
  
    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
      bx = b[0], by = b[1], bz = b[2], bw = b[3]
  
    var omega, cosom, sinom, scale0, scale1
  
    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw
    // adjust signs (if necessary)
    if (cosom < 0.0) {
      cosom = -cosom
      bx = -bx
      by = -by
      bz = -bz
      bw = -bw
    }
    // calculate coefficients
    if ((1.0 - cosom) > 0.000001) {
      // standard case (slerp)
      omega = Math.acos(cosom)
      sinom = Math.sin(omega)
      scale0 = Math.sin((1.0 - t) * omega) / sinom
      scale1 = Math.sin(t * omega) / sinom
    } else {
      // "from" and "to" quaternions are very close
      //  ... so we can do a linear interpolation
      scale0 = 1.0 - t
      scale1 = t
    }
    // calculate final values
    out[0] = scale0 * ax + scale1 * bx
    out[1] = scale0 * ay + scale1 * by
    out[2] = scale0 * az + scale1 * bz
    out[3] = scale0 * aw + scale1 * bw
  
    return out
  }
  
  },{}],305:[function(_dereq_,module,exports){
  'use strict';
  
  module.exports = function(a){
    return (!a && a !== 0) ? '' : a.toString();
  }
  
  },{}],306:[function(_dereq_,module,exports){
  "use strict"
  
  var vectorizeText = _dereq_("vectorize-text")
  
  module.exports = getGlyph
  
  var GLYPH_CACHE = {}
  
  function getGlyph(symbol, font, pixelRatio) {
    var fontCache = GLYPH_CACHE[font]
    if(!fontCache) {
      fontCache = GLYPH_CACHE[font] = {}
    }
    if(symbol in fontCache) {
      return fontCache[symbol]
    }
  
    var config = {
      textAlign: "center",
      textBaseline: "middle",
      lineHeight: 1.0,
      font: font,
      lineSpacing: 1.25,
      styletags: {
        breaklines:true,
        bolds: true,
        italics: true,
        subscripts:true,
        superscripts:true
      }
    }
  
    //Get line and triangle meshes for glyph
    config.triangles = true
    var triSymbol = vectorizeText(symbol, config)
    config.triangles = false
    var lineSymbol = vectorizeText(symbol, config)
  
    var i, j
  
    if(pixelRatio && pixelRatio !== 1) {
      for(i = 0; i < triSymbol.positions.length; ++i){
        for(j = 0; j < triSymbol.positions[i].length; ++j){
          triSymbol.positions[i][j] /= pixelRatio;
        }
      }
  
      for(i = 0; i < lineSymbol.positions.length; ++i){
        for(j = 0; j < lineSymbol.positions[i].length; ++j){
          lineSymbol.positions[i][j] /= pixelRatio;
        }
      }
    }
  
    //Calculate bounding box
    var bounds = [[Infinity,Infinity], [-Infinity,-Infinity]]
    var n = lineSymbol.positions.length
    for(i = 0; i < n; ++i) {
      var p = lineSymbol.positions[i]
      for(j=0; j<2; ++j) {
        bounds[0][j] = Math.min(bounds[0][j], p[j])
        bounds[1][j] = Math.max(bounds[1][j], p[j])
      }
    }
  
    //Save cached symbol
    return fontCache[symbol] = [triSymbol, lineSymbol, bounds]
  }
  },{"vectorize-text":572}],307:[function(_dereq_,module,exports){
  var createShaderWrapper = _dereq_('gl-shader')
  var glslify = _dereq_('glslify')
  
  var perspectiveVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform vec4 highlightId;\nuniform float highlightScale;\nuniform mat4 model, view, projection;\nuniform vec3 clipBounds[2];\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = 1.0;\n    if(distance(highlightId, id) < 0.0001) {\n      scale = highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1);\n    vec4 viewPosition = view * worldPosition;\n    viewPosition = viewPosition / viewPosition.w;\n    vec4 clipPosition = projection * (viewPosition + scale * vec4(glyph.x, -glyph.y, 0, 0));\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"])
  var orthographicVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float highlightScale, pixelRatio;\nuniform vec4 highlightId;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float scale = pixelRatio;\n    if(distance(highlightId.bgr, id.bgr) < 0.001) {\n      scale *= highlightScale;\n    }\n\n    vec4 worldPosition = model * vec4(position, 1.0);\n    vec4 viewPosition = view * worldPosition;\n    vec4 clipPosition = projection * viewPosition;\n    clipPosition /= clipPosition.w;\n\n    gl_Position = clipPosition + vec4(screenSize * scale * vec2(glyph.x, -glyph.y), 0.0, 0.0);\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = position;\n  }\n}"])
  var projectionVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nattribute vec3 position;\nattribute vec4 color;\nattribute vec2 glyph;\nattribute vec4 id;\n\nuniform float highlightScale;\nuniform vec4 highlightId;\nuniform vec3 axes[2];\nuniform mat4 model, view, projection;\nuniform vec2 screenSize;\nuniform vec3 clipBounds[2];\nuniform float scale, pixelRatio;\n\nvarying vec4 interpColor;\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], position)) {\n\n    gl_Position = vec4(0,0,0,0);\n  } else {\n    float lscale = pixelRatio * scale;\n    if(distance(highlightId, id) < 0.0001) {\n      lscale *= highlightScale;\n    }\n\n    vec4 clipCenter   = projection * view * model * vec4(position, 1);\n    vec3 dataPosition = position + 0.5*lscale*(axes[0] * glyph.x + axes[1] * glyph.y) * clipCenter.w * screenSize.y;\n    vec4 clipPosition = projection * view * model * vec4(dataPosition, 1);\n\n    gl_Position = clipPosition;\n    interpColor = color;\n    pickId = id;\n    dataCoordinate = dataPosition;\n  }\n}\n"])
  var drawFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float opacity;\n\nvarying vec4 interpColor;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (\n    outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate) ||\n    interpColor.a * opacity == 0.\n  ) discard;\n  gl_FragColor = interpColor * opacity;\n}\n"])
  var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 fragClipBounds[2];\nuniform float pickGroup;\n\nvarying vec4 pickId;\nvarying vec3 dataCoordinate;\n\nvoid main() {\n  if (outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate)) discard;\n\n  gl_FragColor = vec4(pickGroup, pickId.bgr);\n}"])
  
  var ATTRIBUTES = [
    {name: 'position', type: 'vec3'},
    {name: 'color', type: 'vec4'},
    {name: 'glyph', type: 'vec2'},
    {name: 'id', type: 'vec4'}
  ]
  
  var perspective = {
      vertex: perspectiveVertSrc,
      fragment: drawFragSrc,
      attributes: ATTRIBUTES
    },
    ortho = {
      vertex: orthographicVertSrc,
      fragment: drawFragSrc,
      attributes: ATTRIBUTES
    },
    project = {
      vertex: projectionVertSrc,
      fragment: drawFragSrc,
      attributes: ATTRIBUTES
    },
    pickPerspective = {
      vertex: perspectiveVertSrc,
      fragment: pickFragSrc,
      attributes: ATTRIBUTES
    },
    pickOrtho = {
      vertex: orthographicVertSrc,
      fragment: pickFragSrc,
      attributes: ATTRIBUTES
    },
    pickProject = {
      vertex: projectionVertSrc,
      fragment: pickFragSrc,
      attributes: ATTRIBUTES
    }
  
  function createShader(gl, src) {
    var shader = createShaderWrapper(gl, src)
    var attr = shader.attributes
    attr.position.location = 0
    attr.color.location = 1
    attr.glyph.location = 2
    attr.id.location = 3
    return shader
  }
  
  exports.createPerspective = function(gl) {
    return createShader(gl, perspective)
  }
  exports.createOrtho = function(gl) {
    return createShader(gl, ortho)
  }
  exports.createProject = function(gl) {
    return createShader(gl, project)
  }
  exports.createPickPerspective = function(gl) {
    return createShader(gl, pickPerspective)
  }
  exports.createPickOrtho = function(gl) {
    return createShader(gl, pickOrtho)
  }
  exports.createPickProject = function(gl) {
    return createShader(gl, pickProject)
  }
  
  },{"gl-shader":312,"glslify":413}],308:[function(_dereq_,module,exports){
  'use strict'
  
  var isAllBlank      = _dereq_('is-string-blank')
  var createBuffer    = _dereq_('gl-buffer')
  var createVAO       = _dereq_('gl-vao')
  var pool            = _dereq_('typedarray-pool')
  var mat4mult        = _dereq_('gl-mat4/multiply')
  var shaders         = _dereq_('./lib/shaders')
  var getGlyph        = _dereq_('./lib/glyphs')
  var getSimpleString = _dereq_('./lib/get-simple-string')
  
  var IDENTITY = [1,0,0,0,
                  0,1,0,0,
                  0,0,1,0,
                  0,0,0,1]
  
  module.exports = createPointCloud
  
  function transformMat4(x, m) {
    var x0 = x[0]
    var x1 = x[1]
    var x2 = x[2]
    var x3 = x[3]
    x[0] = m[0] * x0 + m[4] * x1 + m[8]  * x2 + m[12] * x3
    x[1] = m[1] * x0 + m[5] * x1 + m[9]  * x2 + m[13] * x3
    x[2] = m[2] * x0 + m[6] * x1 + m[10] * x2 + m[14] * x3
    x[3] = m[3] * x0 + m[7] * x1 + m[11] * x2 + m[15] * x3
    return x
  }
  
  function project(p, v, m, x) {
    transformMat4(x, x, m)
    transformMat4(x, x, v)
    return transformMat4(x, x, p)
  }
  
  function ScatterPlotPickResult(index, position) {
    this.index = index
    this.dataCoordinate = this.position = position
  }
  
  function fixOpacity(a) {
    if(a === true) return 1
    if(a > 1) return 1
    return a
  }
  
  function PointCloud(
    gl,
    shader,
    orthoShader,
    projectShader,
    pointBuffer,
    colorBuffer,
    glyphBuffer,
    idBuffer,
    vao,
    pickPerspectiveShader,
    pickOrthoShader,
    pickProjectShader) {
  
    this.gl              = gl
  
    this.pixelRatio      = 1
  
    this.shader          = shader
    this.orthoShader     = orthoShader
    this.projectShader   = projectShader
  
    this.pointBuffer     = pointBuffer
    this.colorBuffer     = colorBuffer
    this.glyphBuffer     = glyphBuffer
    this.idBuffer        = idBuffer
    this.vao             = vao
    this.vertexCount     = 0
    this.lineVertexCount = 0
  
    this.opacity         = 1
    this.hasAlpha        = false
  
    this.lineWidth       = 0
    this.projectScale    = [2.0/3.0, 2.0/3.0, 2.0/3.0]
    this.projectOpacity  = [1, 1, 1]
    this.projectHasAlpha  = false
  
    this.pickId                = 0
    this.pickPerspectiveShader = pickPerspectiveShader
    this.pickOrthoShader       = pickOrthoShader
    this.pickProjectShader     = pickProjectShader
    this.points                = []
  
    this._selectResult = new ScatterPlotPickResult(0, [0,0,0])
  
    this.useOrtho = true
    this.bounds   = [[ Infinity,Infinity,Infinity],
                     [-Infinity,-Infinity,-Infinity]]
  
    //Axes projections
    this.axesProject = [ true, true, true ]
    this.axesBounds = [[-Infinity,-Infinity,-Infinity],
                       [ Infinity, Infinity, Infinity]]
  
    this.highlightId    = [1,1,1,1]
    this.highlightScale = 2
  
    this.clipBounds = [[-Infinity,-Infinity,-Infinity],
                       [ Infinity, Infinity, Infinity]]
  
    this.dirty = true
  }
  
  var proto = PointCloud.prototype
  
  proto.pickSlots = 1
  
  proto.setPickBase = function(pickBase) {
    this.pickId = pickBase
  }
  
  proto.isTransparent = function() {
    if(this.hasAlpha)  {
      return true
    }
    for(var i=0; i<3; ++i) {
      if(this.axesProject[i] && this.projectHasAlpha) {
        return true
      }
    }
    return false
  }
  
  proto.isOpaque = function() {
    if(!this.hasAlpha)  {
      return true
    }
    for(var i=0; i<3; ++i) {
      if(this.axesProject[i] && !this.projectHasAlpha) {
        return true
      }
    }
    return false
  }
  
  var VIEW_SHAPE = [0,0]
  var U_VEC = [0,0,0]
  var V_VEC = [0,0,0]
  var MU_VEC = [0,0,0,1]
  var MV_VEC = [0,0,0,1]
  var SCRATCH_MATRIX = IDENTITY.slice()
  var SCRATCH_VEC = [0,0,0]
  var CLIP_BOUNDS = [[0,0,0], [0,0,0]]
  
  function zeroVec(a) {
    a[0] = a[1] = a[2] = 0
    return a
  }
  
  function augment(hg, af) {
    hg[0] = af[0]
    hg[1] = af[1]
    hg[2] = af[2]
    hg[3] = 1
    return hg
  }
  
  function setComponent(out, v, i, x) {
    out[0] = v[0]
    out[1] = v[1]
    out[2] = v[2]
    out[i] = x
    return out
  }
  
  function getClipBounds(bounds) {
    var result = CLIP_BOUNDS
    for(var i=0; i<2; ++i) {
      for(var j=0; j<3; ++j) {
        result[i][j] = Math.max(Math.min(bounds[i][j], 1e8), -1e8)
      }
    }
    return result
  }
  
  function drawProject(shader, points, camera, pixelRatio) {
    var axesProject = points.axesProject
  
    var gl         = points.gl
    var uniforms   = shader.uniforms
    var model      = camera.model      || IDENTITY
    var view       = camera.view       || IDENTITY
    var projection = camera.projection || IDENTITY
    var bounds     = points.axesBounds
    var clipBounds = getClipBounds(points.clipBounds)
  
    var cubeAxis
    if(points.axes && points.axes.lastCubeProps) {
      cubeAxis = points.axes.lastCubeProps.axis
    } else {
      cubeAxis = [1,1,1]
    }
  
    VIEW_SHAPE[0] = 2.0/gl.drawingBufferWidth
    VIEW_SHAPE[1] = 2.0/gl.drawingBufferHeight
  
    shader.bind()
    uniforms.view           = view
    uniforms.projection     = projection
    uniforms.screenSize     = VIEW_SHAPE
    uniforms.highlightId    = points.highlightId
    uniforms.highlightScale = points.highlightScale
    uniforms.clipBounds     = clipBounds
    uniforms.pickGroup      = points.pickId / 255.0
    uniforms.pixelRatio     = pixelRatio
  
    for(var i=0; i<3; ++i) {
      if(!axesProject[i]) {
        continue
      }
  
      uniforms.scale          = points.projectScale[i]
      uniforms.opacity        = points.projectOpacity[i]
  
      //Project model matrix
      var pmodel = SCRATCH_MATRIX
      for(var j=0; j<16; ++j) {
        pmodel[j] = 0
      }
      for(var j=0; j<4; ++j) {
        pmodel[5*j] = 1
      }
      pmodel[5*i] = 0
      if(cubeAxis[i] < 0) {
        pmodel[12+i] = bounds[0][i]
      } else {
        pmodel[12+i] = bounds[1][i]
      }
      mat4mult(pmodel, model, pmodel)
      uniforms.model = pmodel
  
      //Compute initial axes
      var u = (i+1)%3
      var v = (i+2)%3
      var du = zeroVec(U_VEC)
      var dv = zeroVec(V_VEC)
      du[u] = 1
      dv[v] = 1
  
      //Align orientation relative to viewer
      var mdu = project(projection, view, model, augment(MU_VEC, du))
      var mdv = project(projection, view, model, augment(MV_VEC, dv))
      if(Math.abs(mdu[1]) > Math.abs(mdv[1])) {
        var tmp = mdu
        mdu = mdv
        mdv = tmp
        tmp = du
        du = dv
        dv = tmp
        var t = u
        u = v
        v = t
      }
      if(mdu[0] < 0) {
        du[u] = -1
      }
      if(mdv[1] > 0) {
        dv[v] = -1
      }
      var su = 0.0
      var sv = 0.0
      for(var j=0; j<4; ++j) {
        su += Math.pow(model[4*u+j], 2)
        sv += Math.pow(model[4*v+j], 2)
      }
      du[u] /= Math.sqrt(su)
      dv[v] /= Math.sqrt(sv)
      uniforms.axes[0] = du
      uniforms.axes[1] = dv
  
      //Update fragment clip bounds
      uniforms.fragClipBounds[0] = setComponent(SCRATCH_VEC, clipBounds[0], i, -1e8)
      uniforms.fragClipBounds[1] = setComponent(SCRATCH_VEC, clipBounds[1], i, 1e8)
  
      points.vao.bind()
  
      //Draw interior
      points.vao.draw(gl.TRIANGLES, points.vertexCount)
  
      //Draw edges
      if(points.lineWidth > 0) {
        gl.lineWidth(points.lineWidth * pixelRatio)
        points.vao.draw(gl.LINES, points.lineVertexCount, points.vertexCount)
      }
  
      points.vao.unbind()
    }
  }
  
  
  var NEG_INFINITY3 = [-1e8, -1e8, -1e8]
  var POS_INFINITY3 = [1e8, 1e8, 1e8]
  var CLIP_GROUP    = [NEG_INFINITY3, POS_INFINITY3]
  
  function drawFull(shader, pshader, points, camera, pixelRatio, transparent, forceDraw) {
    var gl = points.gl
  
    if(transparent === points.projectHasAlpha || forceDraw) {
      drawProject(pshader, points, camera, pixelRatio)
    }
  
    if(transparent === points.hasAlpha || forceDraw) {
  
      shader.bind()
      var uniforms = shader.uniforms
  
      uniforms.model      = camera.model      || IDENTITY
      uniforms.view       = camera.view       || IDENTITY
      uniforms.projection = camera.projection || IDENTITY
  
      VIEW_SHAPE[0]       = 2.0/gl.drawingBufferWidth
      VIEW_SHAPE[1]       = 2.0/gl.drawingBufferHeight
      uniforms.screenSize = VIEW_SHAPE
  
      uniforms.highlightId    = points.highlightId
      uniforms.highlightScale = points.highlightScale
  
      uniforms.fragClipBounds = CLIP_GROUP
      uniforms.clipBounds     = points.axes.bounds
  
      uniforms.opacity    = points.opacity
      uniforms.pickGroup  = points.pickId / 255.0
  
      uniforms.pixelRatio = pixelRatio
  
      points.vao.bind()
  
      //Draw interior
      points.vao.draw(gl.TRIANGLES, points.vertexCount)
  
      //Draw edges
      if(points.lineWidth > 0) {
        gl.lineWidth(points.lineWidth * pixelRatio)
        points.vao.draw(gl.LINES, points.lineVertexCount, points.vertexCount)
      }
  
      points.vao.unbind()
    }
  
  
  }
  
  proto.draw = function(camera) {
    var shader = this.useOrtho ? this.orthoShader : this.shader
    drawFull(shader, this.projectShader, this, camera, this.pixelRatio, false, false)
  }
  
  proto.drawTransparent = function(camera) {
    var shader = this.useOrtho ? this.orthoShader : this.shader
    drawFull(shader, this.projectShader, this, camera, this.pixelRatio, true, false)
  }
  
  proto.drawPick = function(camera) {
    var shader = this.useOrtho ? this.pickOrthoShader : this.pickPerspectiveShader
    drawFull(shader, this.pickProjectShader, this, camera, 1, true, true)
  }
  
  proto.pick = function(selected) {
    if(!selected) {
      return null
    }
    if(selected.id !== this.pickId) {
      return null
    }
    var x = selected.value[2] + (selected.value[1]<<8) + (selected.value[0]<<16)
    if(x >= this.pointCount || x < 0) {
      return null
    }
  
    //Unpack result
    var coord = this.points[x]
    var result = this._selectResult
    result.index = x
    for(var i=0; i<3; ++i) {
      result.position[i] = result.dataCoordinate[i] = coord[i]
    }
    return result
  }
  
  proto.highlight = function(selection) {
    if(!selection) {
      this.highlightId = [1,1,1,1]
    } else {
      var pointId = selection.index
      var a0 =  pointId     &0xff
      var a1 = (pointId>>8) &0xff
      var a2 = (pointId>>16)&0xff
      this.highlightId = [a0/255.0, a1/255.0, a2/255.0, 0]
    }
  }
  
  function get_glyphData(glyphs, index, font, pixelRatio) {
    var str
  
    // use the data if presented in an array
    if(Array.isArray(glyphs)) {
      if(index < glyphs.length) {
        str = glyphs[index]
      } else {
        str = undefined
      }
    } else {
      str = glyphs
    }
  
    str = getSimpleString(str) // this would handle undefined cases
  
    var visible = true
    if(isAllBlank(str)) {
      str = '▼' // Note: this special character may have minimum number of surfaces
      visible = false
    }
  
    var glyph = getGlyph(str, font, pixelRatio)
  
    return { mesh:glyph[0],
            lines:glyph[1],
           bounds:glyph[2],
          visible:visible };
  }
  
  
  
  proto.update = function(options) {
  
    options = options || {}
  
    if('perspective' in options) {
      this.useOrtho = !options.perspective
    }
    if('orthographic' in options) {
      this.useOrtho = !!options.orthographic
    }
    if('lineWidth' in options) {
      this.lineWidth = options.lineWidth
    }
    if('project' in options) {
      if(Array.isArray(options.project)) {
        this.axesProject = options.project
      } else {
        var v = !!options.project
        this.axesProject = [v,v,v]
      }
    }
    if('projectScale' in options) {
      if(Array.isArray(options.projectScale)) {
        this.projectScale = options.projectScale.slice()
      } else {
        var s = +options.projectScale
        this.projectScale = [s,s,s]
      }
    }
  
    this.projectHasAlpha = false // default to no transparent draw
    if('projectOpacity' in options) {
      if(Array.isArray(options.projectOpacity)) {
        this.projectOpacity = options.projectOpacity.slice()
      } else {
        var s = +options.projectOpacity
        this.projectOpacity = [s,s,s]
      }
      for(var i=0; i<3; ++i) {
        this.projectOpacity[i] = fixOpacity(this.projectOpacity[i]);
        if(this.projectOpacity[i] < 1) {
          this.projectHasAlpha = true;
        }
      }
    }
  
    this.hasAlpha = false // default to no transparent draw
    if('opacity' in options) {
      this.opacity = fixOpacity(options.opacity)
      if(this.opacity < 1) {
        this.hasAlpha = true;
      }
    }
  
    //Set dirty flag
    this.dirty = true
  
    //Create new buffers
    var points = options.position
  
    //Text font
    var font      = options.font      || 'normal'
    var alignment = options.alignment || [0,0]
  
    var alignmentX;
    var alignmentY;
    if (alignment.length === 2) {
      alignmentX = alignment[0]
      alignmentY = alignment[1]
    } else {
      alignmentX = []
      alignmentY = []
      for (var i = 0; i < alignment.length; ++i) {
        alignmentX[i] = alignment[i][0]
        alignmentY[i] = alignment[i][1]
      }
    }
  
    //Bounds
    var lowerBound = [ Infinity, Infinity, Infinity]
    var upperBound = [-Infinity,-Infinity,-Infinity]
  
    //Unpack options
    var glyphs     = options.glyph
    var colors     = options.color
    var sizes      = options.size
    var angles     = options.angle
    var lineColors = options.lineColor
  
    //Picking geometry
    var pickCounter = -1
  
    //First do pass to compute buffer sizes
    var triVertexCount  = 0
    var lineVertexCount = 0
  
    var numPoints = 0;
  
    if(points.length) {
  
      //Count number of points and buffer size
      numPoints = points.length
  
    count_loop:
      for(var i=0; i<numPoints; ++i) {
        var x = points[i]
        for(var j=0; j<3; ++j) {
          if(isNaN(x[j]) || !isFinite(x[j])) {
            continue count_loop
          }
        }
  
        var glyphData = get_glyphData(glyphs, i, font, this.pixelRatio)
  
        var glyphMesh   = glyphData.mesh
        var glyphLines  = glyphData.lines
        var glyphBounds = glyphData.bounds
  
        triVertexCount  += glyphMesh.cells.length * 3
        lineVertexCount += glyphLines.edges.length * 2
      }
    }
  
    var vertexCount   = triVertexCount + lineVertexCount
  
    //Preallocate data
    var positionArray = pool.mallocFloat(3*vertexCount)
    var colorArray    = pool.mallocFloat(4*vertexCount)
    var glyphArray    = pool.mallocFloat(2*vertexCount)
    var idArray       = pool.mallocUint32(vertexCount)
  
    if(vertexCount > 0) {
      var triOffset  = 0
      var lineOffset = triVertexCount
      var color      = [0,0,0,1]
      var lineColor  = [0,0,0,1]
  
      var isColorArray      = Array.isArray(colors)     && Array.isArray(colors[0])
      var isLineColorArray  = Array.isArray(lineColors) && Array.isArray(lineColors[0])
  
    fill_loop:
      for(var i=0; i<numPoints; ++i) {
        //Increment pickCounter
        pickCounter += 1
  
        var x = points[i]
        for(var j=0; j<3; ++j) {
          if(isNaN(x[j]) || !isFinite(x[j])) {
            continue fill_loop
          }
  
          upperBound[j] = Math.max(upperBound[j], x[j])
          lowerBound[j] = Math.min(lowerBound[j], x[j])
        }
  
        var glyphData = get_glyphData(glyphs, i, font, this.pixelRatio)
  
        var glyphMesh   = glyphData.mesh
        var glyphLines  = glyphData.lines
        var glyphBounds = glyphData.bounds
        var glyphVisible = glyphData.visible
  
        //Get color
        if(!glyphVisible) color = [1,1,1,0]
        else if(Array.isArray(colors)) {
          var c
          if(isColorArray) {
            if(i < colors.length) {
              c = colors[i]
            } else {
              c = [0,0,0,0]
            }
          } else {
            c = colors
          }
  
          if(c.length === 3) {
            for(var j=0; j<3; ++j) {
              color[j] = c[j]
            }
            color[3] = 1
          } else if(c.length === 4) {
            for(var j=0; j<4; ++j) {
              color[j] = c[j]
            }
            if(!this.hasAlpha && c[3] < 1) this.hasAlpha = true
          }
        } else {
          color[0] = color[1] = color[2] = 0
          color[3] = 1
        }
  
  
        //Get lineColor
        if(!glyphVisible) lineColor = [1,1,1,0]
        else if(Array.isArray(lineColors)) {
          var c
          if(isLineColorArray) {
            if(i < lineColors.length) {
              c = lineColors[i]
            } else {
              c = [0,0,0,0]
            }
          } else {
            c = lineColors
          }
  
          if(c.length === 3) {
            for(var j=0; j<3; ++j) {
              lineColor[j] = c[j]
            }
            lineColor[j] = 1
          } else if(c.length === 4) {
            for(var j=0; j<4; ++j) {
              lineColor[j] = c[j]
            }
            if(!this.hasAlpha && c[3] < 1) this.hasAlpha = true
          }
        } else {
          lineColor[0] = lineColor[1] = lineColor[2] = 0
          lineColor[3] = 1
        }
  
  
        var size = 0.5
        if(!glyphVisible) size = 0.0
        else if(Array.isArray(sizes)) {
          if(i < sizes.length) {
            size = +sizes[i]
          } else {
            size = 12
          }
        } else if(sizes) {
          size = +sizes
        } else if(this.useOrtho) {
          size = 12
        }
  
  
        var angle = 0
        if(Array.isArray(angles)) {
          if(i < angles.length) {
            angle = +angles[i]
          } else {
            angle = 0
          }
        } else if(angles) {
          angle = +angles
        }
  
        //Loop through markers and append to buffers
        var cos = Math.cos(angle)
        var sin = Math.sin(angle)
  
        var x = points[i]
        for(var j=0; j<3; ++j) {
          upperBound[j] = Math.max(upperBound[j], x[j])
          lowerBound[j] = Math.min(lowerBound[j], x[j])
        }
  
        //Calculate text offset
        var textOffsetX = alignmentX
        var textOffsetY = alignmentY
  
        var textOffsetX = 0
        if(Array.isArray(alignmentX)) {
          if(i < alignmentX.length) {
            textOffsetX = alignmentX[i]
          } else {
            textOffsetX = 0
          }
        } else if(alignmentX) {
          textOffsetX = alignmentX
        }
  
        var textOffsetY = 0
        if(Array.isArray(alignmentY)) {
          if(i < alignmentY.length) {
            textOffsetY = alignmentY[i]
          } else {
            textOffsetY = 0
          }
        } else if(alignmentY) {
          textOffsetY = alignmentY
        }
  
        textOffsetX *= (textOffsetX > 0) ? (1 - glyphBounds[0][0]) :
                       (textOffsetX < 0) ? (1 + glyphBounds[1][0]) : 1;
  
        textOffsetY *= (textOffsetY > 0) ? (1 - glyphBounds[0][1]) :
                       (textOffsetY < 0) ? (1 + glyphBounds[1][1]) : 1;
  
        var textOffset = [textOffsetX, textOffsetY]
  
        //Write out inner marker
        var cells = glyphMesh.cells || []
        var verts = glyphMesh.positions || []
  
        for(var j=0; j<cells.length; ++j) {
          var cell = cells[j]
          for(var k=0; k<3; ++k) {
            for(var l=0; l<3; ++l) {
              positionArray[3*triOffset+l] = x[l]
            }
            for(var l=0; l<4; ++l) {
              colorArray[4*triOffset+l] = color[l]
            }
            idArray[triOffset] = pickCounter
            var p = verts[cell[k]]
            glyphArray[2*triOffset]   = size * (cos*p[0] - sin*p[1] + textOffset[0])
            glyphArray[2*triOffset+1] = size * (sin*p[0] + cos*p[1] + textOffset[1])
            triOffset += 1
          }
        }
  
        var cells = glyphLines.edges
        var verts = glyphLines.positions
  
        for(var j=0; j<cells.length; ++j) {
          var cell = cells[j]
          for(var k=0; k<2; ++k) {
            for(var l=0; l<3; ++l) {
              positionArray[3*lineOffset+l] = x[l]
            }
            for(var l=0; l<4; ++l) {
              colorArray[4*lineOffset+l] = lineColor[l]
            }
            idArray[lineOffset] = pickCounter
            var p = verts[cell[k]]
            glyphArray[2*lineOffset]   = size * (cos*p[0] - sin*p[1] + textOffset[0])
            glyphArray[2*lineOffset+1] = size * (sin*p[0] + cos*p[1] + textOffset[1])
            lineOffset += 1
          }
        }
  
      }
  
  
  
    }
  
    //Update bounds
    this.bounds = [lowerBound, upperBound]
  
    //Save points
    this.points = points
  
    //Save number of points
    this.pointCount = points.length
  
    //Update vertex counts
    this.vertexCount      = triVertexCount
    this.lineVertexCount  = lineVertexCount
  
    this.pointBuffer.update(positionArray)
    this.colorBuffer.update(colorArray)
    this.glyphBuffer.update(glyphArray)
    //this.idBuffer.update(new Uint32Array(idArray))
    this.idBuffer.update(idArray)
  
    pool.free(positionArray)
    pool.free(colorArray)
    pool.free(glyphArray)
    pool.free(idArray)
  }
  
  proto.dispose = function() {
    //Shaders
    this.shader.dispose()
    this.orthoShader.dispose()
    this.pickPerspectiveShader.dispose()
    this.pickOrthoShader.dispose()
  
    //Vertex array
    this.vao.dispose()
  
    //Buffers
    this.pointBuffer.dispose()
    this.colorBuffer.dispose()
    this.glyphBuffer.dispose()
    this.idBuffer.dispose()
  }
  
  function createPointCloud(options) {
    var gl = options.gl
  
    var shader                = shaders.createPerspective(gl)
    var orthoShader           = shaders.createOrtho(gl)
    var projectShader         = shaders.createProject(gl)
    var pickPerspectiveShader = shaders.createPickPerspective(gl)
    var pickOrthoShader       = shaders.createPickOrtho(gl)
    var pickProjectShader     = shaders.createPickProject(gl)
  
    var pointBuffer = createBuffer(gl)
    var colorBuffer = createBuffer(gl)
    var glyphBuffer = createBuffer(gl)
    var idBuffer    = createBuffer(gl)
    var vao = createVAO(gl, [
      {
        buffer: pointBuffer,
        size: 3,
        type: gl.FLOAT
      },
      {
        buffer: colorBuffer,
        size: 4,
        type: gl.FLOAT
      },
      {
        buffer: glyphBuffer,
        size: 2,
        type: gl.FLOAT
      },
      {
        buffer: idBuffer,
        size: 4,
        type: gl.UNSIGNED_BYTE,
        normalized: true
      }
    ])
  
    var pointCloud = new PointCloud(
      gl,
      shader,
      orthoShader,
      projectShader,
      pointBuffer,
      colorBuffer,
      glyphBuffer,
      idBuffer,
      vao,
      pickPerspectiveShader,
      pickOrthoShader,
      pickProjectShader)
  
    pointCloud.update(options)
  
    return pointCloud
  }
  
  },{"./lib/get-simple-string":305,"./lib/glyphs":306,"./lib/shaders":307,"gl-buffer":258,"gl-mat4/multiply":280,"gl-vao":332,"is-string-blank":444,"typedarray-pool":567}],309:[function(_dereq_,module,exports){
  'use strict'
  
  var glslify = _dereq_('glslify')
  
  exports.boxVertex = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec2 vertex;\n\nuniform vec2 cornerA, cornerB;\n\nvoid main() {\n  gl_Position = vec4(mix(cornerA, cornerB, vertex), 0, 1);\n}\n"])
  exports.boxFragment = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main() {\n  gl_FragColor = color;\n}\n"])
  
  },{"glslify":413}],310:[function(_dereq_,module,exports){
  'use strict'
  
  var createShader = _dereq_('gl-shader')
  var createBuffer = _dereq_('gl-buffer')
  
  var SHADERS = _dereq_('./lib/shaders')
  
  module.exports = createSelectBox
  
  function SelectBox(plot, boxBuffer, boxShader) {
    this.plot = plot
    this.boxBuffer = boxBuffer
    this.boxShader = boxShader
  
    this.enabled = true
  
    this.selectBox = [Infinity,Infinity,-Infinity,-Infinity]
  
    this.borderColor = [0,0,0,1]
    this.innerFill   = false
    this.innerColor  = [0,0,0,0.25]
    this.outerFill   = true
    this.outerColor  = [0,0,0,0.5]
    this.borderWidth = 10
  }
  
  var proto = SelectBox.prototype
  
  proto.draw = function() {
    if(!this.enabled) {
      return
    }
  
    var plot         = this.plot
    var selectBox    = this.selectBox
    var lineWidth    = this.borderWidth
  
    var innerFill    = this.innerFill
    var innerColor   = this.innerColor
    var outerFill    = this.outerFill
    var outerColor   = this.outerColor
    var borderColor  = this.borderColor
  
    var boxes        = plot.box
    var screenBox    = plot.screenBox
    var dataBox      = plot.dataBox
    var viewBox      = plot.viewBox
    var pixelRatio   = plot.pixelRatio
  
    //Map select box into pixel coordinates
    var loX = (selectBox[0]-dataBox[0])*(viewBox[2]-viewBox[0])/(dataBox[2]-dataBox[0])+viewBox[0]
    var loY = (selectBox[1]-dataBox[1])*(viewBox[3]-viewBox[1])/(dataBox[3]-dataBox[1])+viewBox[1]
    var hiX = (selectBox[2]-dataBox[0])*(viewBox[2]-viewBox[0])/(dataBox[2]-dataBox[0])+viewBox[0]
    var hiY = (selectBox[3]-dataBox[1])*(viewBox[3]-viewBox[1])/(dataBox[3]-dataBox[1])+viewBox[1]
  
    loX = Math.max(loX, viewBox[0])
    loY = Math.max(loY, viewBox[1])
    hiX = Math.min(hiX, viewBox[2])
    hiY = Math.min(hiY, viewBox[3])
  
    if(hiX < loX || hiY < loY) {
      return
    }
  
    boxes.bind()
  
    //Draw box
    var screenWidth  = screenBox[2] - screenBox[0]
    var screenHeight = screenBox[3] - screenBox[1]
  
    if(this.outerFill) {
      boxes.drawBox(0, 0, screenWidth, loY, outerColor)
      boxes.drawBox(0, loY, loX, hiY, outerColor)
      boxes.drawBox(0, hiY, screenWidth, screenHeight, outerColor)
      boxes.drawBox(hiX, loY, screenWidth, hiY, outerColor)
    }
  
    if(this.innerFill) {
      boxes.drawBox(loX, loY, hiX, hiY, innerColor)
    }
  
    //Draw border
    if(lineWidth > 0) {
  
      //Draw border
      var w = lineWidth * pixelRatio
      boxes.drawBox(loX-w, loY-w, hiX+w, loY+w, borderColor)
      boxes.drawBox(loX-w, hiY-w, hiX+w, hiY+w, borderColor)
      boxes.drawBox(loX-w, loY-w, loX+w, hiY+w, borderColor)
      boxes.drawBox(hiX-w, loY-w, hiX+w, hiY+w, borderColor)
    }
  }
  
  proto.update = function(options) {
    options = options || {}
  
    this.innerFill    = !!options.innerFill
    this.outerFill    = !!options.outerFill
    this.innerColor   = (options.innerColor   || [0,0,0,0.5]).slice()
    this.outerColor   = (options.outerColor   || [0,0,0,0.5]).slice()
    this.borderColor  = (options.borderColor || [0,0,0,1]).slice()
    this.borderWidth  = options.borderWidth || 0
    this.selectBox    = (options.selectBox || this.selectBox).slice()
  }
  
  proto.dispose = function() {
    this.boxBuffer.dispose()
    this.boxShader.dispose()
    this.plot.removeOverlay(this)
  }
  
  function createSelectBox(plot, options) {
    var gl = plot.gl
    var buffer = createBuffer(gl, [
      0, 0,
      0, 1,
      1, 0,
      1, 1 ])
    var shader = createShader(gl, SHADERS.boxVertex, SHADERS.boxFragment)
    var selectBox = new SelectBox(plot, buffer, shader)
    selectBox.update(options)
    plot.addOverlay(selectBox)
    return selectBox
  }
  
  },{"./lib/shaders":309,"gl-buffer":258,"gl-shader":312}],311:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createSelectBuffer
  
  var createFBO = _dereq_('gl-fbo')
  var pool      = _dereq_('typedarray-pool')
  var ndarray   = _dereq_('ndarray')
  var nextPow2  = _dereq_('bit-twiddle').nextPow2
  
  var selectRange = function(arr, x, y) {
    var closestD2 = 1e8
    var closestX = -1
    var closestY = -1
  
    var ni = arr.shape[0]
    var nj = arr.shape[1]
    for(var i = 0; i < ni; i++) {
      for(var j = 0; j < nj; j++) {
        var r = arr.get(i, j, 0)
        var g = arr.get(i, j, 1)
        var b = arr.get(i, j, 2)
        var a = arr.get(i, j, 3)
  
        if(r < 255 || g < 255 || b < 255 || a < 255) {
          var dx = x - i
          var dy = y - j
          var d2 = dx*dx + dy*dy
          if(d2 < closestD2) {
            closestD2 = d2
            closestX = i
            closestY = j
          }
        }
      }
    }
  
    return [closestX, closestY, closestD2]
  }
  
  function SelectResult(x, y, id, value, distance) {
    this.coord = [x, y]
    this.id = id
    this.value = value
    this.distance = distance
  }
  
  function SelectBuffer(gl, fbo, buffer) {
    this.gl     = gl
    this.fbo    = fbo
    this.buffer = buffer
    this._readTimeout = null
    var self = this
  
    this._readCallback = function() {
      if(!self.gl) {
        return
      }
      fbo.bind()
      gl.readPixels(0,0,fbo.shape[0],fbo.shape[1],gl.RGBA,gl.UNSIGNED_BYTE,self.buffer)
      self._readTimeout = null
    }
  }
  
  var proto = SelectBuffer.prototype
  
  Object.defineProperty(proto, 'shape', {
    get: function() {
      if(!this.gl) {
        return [0,0]
      }
      return this.fbo.shape.slice()
    },
    set: function(v) {
      if(!this.gl) {
        return
      }
      this.fbo.shape = v
      var c = this.fbo.shape[0]
      var r = this.fbo.shape[1]
      if(r*c*4 > this.buffer.length) {
        pool.free(this.buffer)
        var buffer = this.buffer = pool.mallocUint8(nextPow2(r*c*4))
        for(var i=0; i<r*c*4; ++i) {
          buffer[i] = 0xff
        }
      }
      return v
    }
  })
  
  proto.begin = function() {
    var gl = this.gl
    var shape = this.shape
    if(!gl) {
      return
    }
  
    this.fbo.bind()
    gl.clearColor(1,1,1,1)
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT)
  }
  
  proto.end = function() {
    var gl = this.gl
    if(!gl) {
      return
    }
    gl.bindFramebuffer(gl.FRAMEBUFFER, null)
    if(!this._readTimeout) {
      clearTimeout(this._readTimeout)
    }
    this._readTimeout = setTimeout(this._readCallback, 1)
  }
  
  proto.query = function(x, y, radius) {
    if(!this.gl) {
      return null
    }
  
    var shape = this.fbo.shape.slice()
  
    x = x|0
    y = y|0
    if(typeof radius !== 'number') {
      radius = 1.0
    }
  
    var x0 = Math.min(Math.max(x - radius, 0), shape[0])|0
    var x1 = Math.min(Math.max(x + radius, 0), shape[0])|0
    var y0 = Math.min(Math.max(y - radius, 0), shape[1])|0
    var y1 = Math.min(Math.max(y + radius, 0), shape[1])|0
  
    if(x1 <= x0 || y1 <= y0) {
      return null
    }
  
    var dims   = [x1-x0,y1-y0]
    var region = ndarray(
      this.buffer,
      [dims[0], dims[1], 4],
      [4, shape[0]*4, 1],
      4*(x0 + shape[0]*y0));
  
    var closest = selectRange(region.hi(dims[0],dims[1],1), radius, radius)
    var dx = closest[0]
    var dy = closest[1]
    if(dx < 0 || Math.pow(this.radius, 2) < closest[2]) {
      return null
    }
  
    var c0 = region.get(dx, dy, 0)
    var c1 = region.get(dx, dy, 1)
    var c2 = region.get(dx, dy, 2)
    var c3 = region.get(dx, dy, 3)
  
    return new SelectResult(
       (dx + x0)|0,
       (dy + y0)|0,
       c0,
       [c1, c2, c3],
       Math.sqrt(closest[2]))
  }
  
  proto.dispose = function() {
    if(!this.gl) {
      return
    }
    this.fbo.dispose()
    pool.free(this.buffer)
    this.gl = null
    if(this._readTimeout) {
      clearTimeout(this._readTimeout)
    }
  }
  
  function createSelectBuffer(gl, shape) {
    var width = shape[0]
    var height = shape[1]
    var options = {}
    var fbo = createFBO(gl, width, height, options)
    var buffer = pool.mallocUint8(width*height*4)
    return new SelectBuffer(gl, fbo, buffer)
  }
  
  },{"bit-twiddle":97,"gl-fbo":266,"ndarray":469,"typedarray-pool":567}],312:[function(_dereq_,module,exports){
  'use strict'
  
  var createUniformWrapper   = _dereq_('./lib/create-uniforms')
  var createAttributeWrapper = _dereq_('./lib/create-attributes')
  var makeReflect            = _dereq_('./lib/reflect')
  var shaderCache            = _dereq_('./lib/shader-cache')
  var runtime                = _dereq_('./lib/runtime-reflect')
  var GLError                = _dereq_("./lib/GLError")
  
  //Shader object
  function Shader(gl) {
    this.gl         = gl
    this.gl.lastAttribCount = 0  // fixme where else should we store info, safe but not nice on the gl object
  
    //Default initialize these to null
    this._vref      =
    this._fref      =
    this._relink    =
    this.vertShader =
    this.fragShader =
    this.program    =
    this.attributes =
    this.uniforms   =
    this.types      = null
  }
  
  var proto = Shader.prototype
  
  proto.bind = function() {
    if(!this.program) {
      this._relink()
    }
  
    // ensuring that we have the right number of enabled vertex attributes
    var i
    var newAttribCount = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES) // more robust approach
    //var newAttribCount = Object.keys(this.attributes).length // avoids the probably immaterial introspection slowdown
    var oldAttribCount = this.gl.lastAttribCount
    if(newAttribCount > oldAttribCount) {
      for(i = oldAttribCount; i < newAttribCount; i++) {
        this.gl.enableVertexAttribArray(i)
      }
    } else if(oldAttribCount > newAttribCount) {
      for(i = newAttribCount; i < oldAttribCount; i++) {
        this.gl.disableVertexAttribArray(i)
      }
    }
  
    this.gl.lastAttribCount = newAttribCount
  
    this.gl.useProgram(this.program)
  }
  
  proto.dispose = function() {
  
    // disabling vertex attributes so new shader starts with zero
    // and it's also useful if all shaders are disposed but the
    // gl context is reused for subsequent replotting
    var oldAttribCount = this.gl.lastAttribCount
    for (var i = 0; i < oldAttribCount; i++) {
      this.gl.disableVertexAttribArray(i)
    }
    this.gl.lastAttribCount = 0
  
    if(this._fref) {
      this._fref.dispose()
    }
    if(this._vref) {
      this._vref.dispose()
    }
    this.attributes =
    this.types      =
    this.vertShader =
    this.fragShader =
    this.program    =
    this._relink    =
    this._fref      =
    this._vref      = null
  }
  
  function compareAttributes(a, b) {
    if(a.name < b.name) {
      return -1
    }
    return 1
  }
  
  //Update export hook for glslify-live
  proto.update = function(
      vertSource
    , fragSource
    , uniforms
    , attributes) {
  
    //If only one object passed, assume glslify style output
    if(!fragSource || arguments.length === 1) {
      var obj = vertSource
      vertSource = obj.vertex
      fragSource = obj.fragment
      uniforms   = obj.uniforms
      attributes = obj.attributes
    }
  
    var wrapper = this
    var gl      = wrapper.gl
  
    //Compile vertex and fragment shaders
    var pvref = wrapper._vref
    wrapper._vref = shaderCache.shader(gl, gl.VERTEX_SHADER, vertSource)
    if(pvref) {
      pvref.dispose()
    }
    wrapper.vertShader = wrapper._vref.shader
    var pfref = this._fref
    wrapper._fref = shaderCache.shader(gl, gl.FRAGMENT_SHADER, fragSource)
    if(pfref) {
      pfref.dispose()
    }
    wrapper.fragShader = wrapper._fref.shader
  
    //If uniforms/attributes is not specified, use RT reflection
    if(!uniforms || !attributes) {
  
      //Create initial test program
      var testProgram = gl.createProgram()
      gl.attachShader(testProgram, wrapper.fragShader)
      gl.attachShader(testProgram, wrapper.vertShader)
      gl.linkProgram(testProgram)
      if(!gl.getProgramParameter(testProgram, gl.LINK_STATUS)) {
        var errLog = gl.getProgramInfoLog(testProgram)
        throw new GLError(errLog, 'Error linking program:' + errLog)
      }
  
      //Load data from runtime
      uniforms   = uniforms   || runtime.uniforms(gl, testProgram)
      attributes = attributes || runtime.attributes(gl, testProgram)
  
      //Release test program
      gl.deleteProgram(testProgram)
    }
  
    //Sort attributes lexicographically
    // overrides undefined WebGL behavior for attribute locations
    attributes = attributes.slice()
    attributes.sort(compareAttributes)
  
    //Convert attribute types, read out locations
    var attributeUnpacked  = []
    var attributeNames     = []
    var attributeLocations = []
    var i
    for(i=0; i<attributes.length; ++i) {
      var attr = attributes[i]
      if(attr.type.indexOf('mat') >= 0) {
        var size = attr.type.charAt(attr.type.length-1)|0
        var locVector = new Array(size)
        for(var j=0; j<size; ++j) {
          locVector[j] = attributeLocations.length
          attributeNames.push(attr.name + '[' + j + ']')
          if(typeof attr.location === 'number') {
            attributeLocations.push(attr.location + j)
          } else if(Array.isArray(attr.location) &&
                    attr.location.length === size &&
                    typeof attr.location[j] === 'number') {
            attributeLocations.push(attr.location[j]|0)
          } else {
            attributeLocations.push(-1)
          }
        }
        attributeUnpacked.push({
          name: attr.name,
          type: attr.type,
          locations: locVector
        })
      } else {
        attributeUnpacked.push({
          name: attr.name,
          type: attr.type,
          locations: [ attributeLocations.length ]
        })
        attributeNames.push(attr.name)
        if(typeof attr.location === 'number') {
          attributeLocations.push(attr.location|0)
        } else {
          attributeLocations.push(-1)
        }
      }
    }
  
    //For all unspecified attributes, assign them lexicographically min attribute
    var curLocation = 0
    for(i=0; i<attributeLocations.length; ++i) {
      if(attributeLocations[i] < 0) {
        while(attributeLocations.indexOf(curLocation) >= 0) {
          curLocation += 1
        }
        attributeLocations[i] = curLocation
      }
    }
  
    //Rebuild program and recompute all uniform locations
    var uniformLocations = new Array(uniforms.length)
    function relink() {
      wrapper.program = shaderCache.program(
          gl
        , wrapper._vref
        , wrapper._fref
        , attributeNames
        , attributeLocations)
  
      for(var i=0; i<uniforms.length; ++i) {
        uniformLocations[i] = gl.getUniformLocation(
            wrapper.program
          , uniforms[i].name)
      }
    }
  
    //Perform initial linking, reuse program used for reflection
    relink()
  
    //Save relinking procedure, defer until runtime
    wrapper._relink = relink
  
    //Generate type info
    wrapper.types = {
      uniforms:   makeReflect(uniforms),
      attributes: makeReflect(attributes)
    }
  
    //Generate attribute wrappers
    wrapper.attributes = createAttributeWrapper(
        gl
      , wrapper
      , attributeUnpacked
      , attributeLocations)
  
    //Generate uniform wrappers
    Object.defineProperty(wrapper, 'uniforms', createUniformWrapper(
        gl
      , wrapper
      , uniforms
      , uniformLocations))
  }
  
  //Compiles and links a shader program with the given attribute and vertex list
  function createShader(
      gl
    , vertSource
    , fragSource
    , uniforms
    , attributes) {
  
    var shader = new Shader(gl)
  
    shader.update(
        vertSource
      , fragSource
      , uniforms
      , attributes)
  
    return shader
  }
  
  module.exports = createShader
  
  },{"./lib/GLError":313,"./lib/create-attributes":314,"./lib/create-uniforms":315,"./lib/reflect":316,"./lib/runtime-reflect":317,"./lib/shader-cache":318}],313:[function(_dereq_,module,exports){
  function GLError (rawError, shortMessage, longMessage) {
      this.shortMessage = shortMessage || ''
      this.longMessage = longMessage || ''
      this.rawError = rawError || ''
      this.message =
        'gl-shader: ' + (shortMessage || rawError || '') +
        (longMessage ? '\n'+longMessage : '')
      this.stack = (new Error()).stack
  }
  GLError.prototype = new Error
  GLError.prototype.name = 'GLError'
  GLError.prototype.constructor = GLError
  module.exports = GLError
  
  },{}],314:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createAttributeWrapper
  
  var GLError = _dereq_("./GLError")
  
  function ShaderAttribute(
      gl
    , wrapper
    , index
    , locations
    , dimension
    , constFunc) {
    this._gl        = gl
    this._wrapper   = wrapper
    this._index     = index
    this._locations = locations
    this._dimension = dimension
    this._constFunc = constFunc
  }
  
  var proto = ShaderAttribute.prototype
  
  proto.pointer = function setAttribPointer(
      type
    , normalized
    , stride
    , offset) {
  
    var self      = this
    var gl        = self._gl
    var location  = self._locations[self._index]
  
    gl.vertexAttribPointer(
        location
      , self._dimension
      , type || gl.FLOAT
      , !!normalized
      , stride || 0
      , offset || 0)
    gl.enableVertexAttribArray(location)
  }
  
  proto.set = function(x0, x1, x2, x3) {
    return this._constFunc(this._locations[this._index], x0, x1, x2, x3)
  }
  
  Object.defineProperty(proto, 'location', {
    get: function() {
      return this._locations[this._index]
    }
    , set: function(v) {
      if(v !== this._locations[this._index]) {
        this._locations[this._index] = v|0
        this._wrapper.program = null
      }
      return v|0
    }
  })
  
  //Adds a vector attribute to obj
  function addVectorAttribute(
      gl
    , wrapper
    , index
    , locations
    , dimension
    , obj
    , name) {
  
    //Construct constant function
    var constFuncArgs = [ 'gl', 'v' ]
    var varNames = []
    for(var i=0; i<dimension; ++i) {
      constFuncArgs.push('x'+i)
      varNames.push('x'+i)
    }
    constFuncArgs.push(
      'if(x0.length===void 0){return gl.vertexAttrib' +
      dimension + 'f(v,' +
      varNames.join() +
      ')}else{return gl.vertexAttrib' +
      dimension +
      'fv(v,x0)}')
    var constFunc = Function.apply(null, constFuncArgs)
  
    //Create attribute wrapper
    var attr = new ShaderAttribute(
        gl
      , wrapper
      , index
      , locations
      , dimension
      , constFunc)
  
    //Create accessor
    Object.defineProperty(obj, name, {
      set: function(x) {
        gl.disableVertexAttribArray(locations[index])
        constFunc(gl, locations[index], x)
        return x
      }
      , get: function() {
        return attr
      }
      , enumerable: true
    })
  }
  
  function addMatrixAttribute(
      gl
    , wrapper
    , index
    , locations
    , dimension
    , obj
    , name) {
  
    var parts = new Array(dimension)
    var attrs = new Array(dimension)
    for(var i=0; i<dimension; ++i) {
      addVectorAttribute(
          gl
        , wrapper
        , index[i]
        , locations
        , dimension
        , parts
        , i)
      attrs[i] = parts[i]
    }
  
    Object.defineProperty(parts, 'location', {
      set: function(v) {
        if(Array.isArray(v)) {
          for(var i=0; i<dimension; ++i) {
            attrs[i].location = v[i]
          }
        } else {
          for(var i=0; i<dimension; ++i) {
            attrs[i].location = v + i
          }
        }
        return v
      }
      , get: function() {
        var result = new Array(dimension)
        for(var i=0; i<dimension; ++i) {
          result[i] = locations[index[i]]
        }
        return result
      }
      , enumerable: true
    })
  
    parts.pointer = function(type, normalized, stride, offset) {
      type       = type || gl.FLOAT
      normalized = !!normalized
      stride     = stride || (dimension * dimension)
      offset     = offset || 0
      for(var i=0; i<dimension; ++i) {
        var location = locations[index[i]]
        gl.vertexAttribPointer(
              location
            , dimension
            , type
            , normalized
            , stride
            , offset + i * dimension)
        gl.enableVertexAttribArray(location)
      }
    }
  
    var scratch = new Array(dimension)
    var vertexAttrib = gl['vertexAttrib' + dimension + 'fv']
  
    Object.defineProperty(obj, name, {
      set: function(x) {
        for(var i=0; i<dimension; ++i) {
          var loc = locations[index[i]]
          gl.disableVertexAttribArray(loc)
          if(Array.isArray(x[0])) {
            vertexAttrib.call(gl, loc, x[i])
          } else {
            for(var j=0; j<dimension; ++j) {
              scratch[j] = x[dimension*i + j]
            }
            vertexAttrib.call(gl, loc, scratch)
          }
        }
        return x
      }
      , get: function() {
        return parts
      }
      , enumerable: true
    })
  }
  
  //Create shims for attributes
  function createAttributeWrapper(
      gl
    , wrapper
    , attributes
    , locations) {
  
    var obj = {}
    for(var i=0, n=attributes.length; i<n; ++i) {
  
      var a = attributes[i]
      var name = a.name
      var type = a.type
      var locs = a.locations
  
      switch(type) {
        case 'bool':
        case 'int':
        case 'float':
          addVectorAttribute(
              gl
            , wrapper
            , locs[0]
            , locations
            , 1
            , obj
            , name)
        break
  
        default:
          if(type.indexOf('vec') >= 0) {
            var d = type.charCodeAt(type.length-1) - 48
            if(d < 2 || d > 4) {
              throw new GLError('', 'Invalid data type for attribute ' + name + ': ' + type)
            }
            addVectorAttribute(
                gl
              , wrapper
              , locs[0]
              , locations
              , d
              , obj
              , name)
          } else if(type.indexOf('mat') >= 0) {
            var d = type.charCodeAt(type.length-1) - 48
            if(d < 2 || d > 4) {
              throw new GLError('', 'Invalid data type for attribute ' + name + ': ' + type)
            }
            addMatrixAttribute(
                gl
              , wrapper
              , locs
              , locations
              , d
              , obj
              , name)
          } else {
            throw new GLError('', 'Unknown data type for attribute ' + name + ': ' + type)
          }
        break
      }
    }
    return obj
  }
  
  },{"./GLError":313}],315:[function(_dereq_,module,exports){
  'use strict'
  
  var coallesceUniforms = _dereq_('./reflect')
  var GLError = _dereq_("./GLError")
  
  module.exports = createUniformWrapper
  
  //Binds a function and returns a value
  function identity(x) {
    var c = new Function('y', 'return function(){return y}')
    return c(x)
  }
  
  function makeVector(length, fill) {
    var result = new Array(length)
    for(var i=0; i<length; ++i) {
      result[i] = fill
    }
    return result
  }
  
  //Create shims for uniforms
  function createUniformWrapper(gl, wrapper, uniforms, locations) {
  
    function makeGetter(index) {
      var proc = new Function(
          'gl'
        , 'wrapper'
        , 'locations'
        , 'return function(){return gl.getUniform(wrapper.program,locations[' + index + '])}')
      return proc(gl, wrapper, locations)
    }
  
    function makePropSetter(path, index, type) {
      switch(type) {
        case 'bool':
        case 'int':
        case 'sampler2D':
        case 'samplerCube':
          return 'gl.uniform1i(locations[' + index + '],obj' + path + ')'
        case 'float':
          return 'gl.uniform1f(locations[' + index + '],obj' + path + ')'
        default:
          var vidx = type.indexOf('vec')
          if(0 <= vidx && vidx <= 1 && type.length === 4 + vidx) {
            var d = type.charCodeAt(type.length-1) - 48
            if(d < 2 || d > 4) {
              throw new GLError('', 'Invalid data type')
            }
            switch(type.charAt(0)) {
              case 'b':
              case 'i':
                return 'gl.uniform' + d + 'iv(locations[' + index + '],obj' + path + ')'
              case 'v':
                return 'gl.uniform' + d + 'fv(locations[' + index + '],obj' + path + ')'
              default:
                throw new GLError('', 'Unrecognized data type for vector ' + name + ': ' + type)
            }
          } else if(type.indexOf('mat') === 0 && type.length === 4) {
            var d = type.charCodeAt(type.length-1) - 48
            if(d < 2 || d > 4) {
              throw new GLError('', 'Invalid uniform dimension type for matrix ' + name + ': ' + type)
            }
            return 'gl.uniformMatrix' + d + 'fv(locations[' + index + '],false,obj' + path + ')'
          } else {
            throw new GLError('', 'Unknown uniform data type for ' + name + ': ' + type)
          }
        break
      }
    }
  
    function enumerateIndices(prefix, type) {
      if(typeof type !== 'object') {
        return [ [prefix, type] ]
      }
      var indices = []
      for(var id in type) {
        var prop = type[id]
        var tprefix = prefix
        if(parseInt(id) + '' === id) {
          tprefix += '[' + id + ']'
        } else {
          tprefix += '.' + id
        }
        if(typeof prop === 'object') {
          indices.push.apply(indices, enumerateIndices(tprefix, prop))
        } else {
          indices.push([tprefix, prop])
        }
      }
      return indices
    }
  
    function makeSetter(type) {
      var code = [ 'return function updateProperty(obj){' ]
      var indices = enumerateIndices('', type)
      for(var i=0; i<indices.length; ++i) {
        var item = indices[i]
        var path = item[0]
        var idx  = item[1]
        if(locations[idx]) {
          code.push(makePropSetter(path, idx, uniforms[idx].type))
        }
      }
      code.push('return obj}')
      var proc = new Function('gl', 'locations', code.join('\n'))
      return proc(gl, locations)
    }
  
    function defaultValue(type) {
      switch(type) {
        case 'bool':
          return false
        case 'int':
        case 'sampler2D':
        case 'samplerCube':
          return 0
        case 'float':
          return 0.0
        default:
          var vidx = type.indexOf('vec')
          if(0 <= vidx && vidx <= 1 && type.length === 4 + vidx) {
            var d = type.charCodeAt(type.length-1) - 48
            if(d < 2 || d > 4) {
              throw new GLError('', 'Invalid data type')
            }
            if(type.charAt(0) === 'b') {
              return makeVector(d, false)
            }
            return makeVector(d, 0)
          } else if(type.indexOf('mat') === 0 && type.length === 4) {
            var d = type.charCodeAt(type.length-1) - 48
            if(d < 2 || d > 4) {
              throw new GLError('', 'Invalid uniform dimension type for matrix ' + name + ': ' + type)
            }
            return makeVector(d*d, 0)
          } else {
            throw new GLError('', 'Unknown uniform data type for ' + name + ': ' + type)
          }
        break
      }
    }
  
    function storeProperty(obj, prop, type) {
      if(typeof type === 'object') {
        var child = processObject(type)
        Object.defineProperty(obj, prop, {
          get: identity(child),
          set: makeSetter(type),
          enumerable: true,
          configurable: false
        })
      } else {
        if(locations[type]) {
          Object.defineProperty(obj, prop, {
            get: makeGetter(type),
            set: makeSetter(type),
            enumerable: true,
            configurable: false
          })
        } else {
          obj[prop] = defaultValue(uniforms[type].type)
        }
      }
    }
  
    function processObject(obj) {
      var result
      if(Array.isArray(obj)) {
        result = new Array(obj.length)
        for(var i=0; i<obj.length; ++i) {
          storeProperty(result, i, obj[i])
        }
      } else {
        result = {}
        for(var id in obj) {
          storeProperty(result, id, obj[id])
        }
      }
      return result
    }
  
    //Return data
    var coallesced = coallesceUniforms(uniforms, true)
    return {
      get: identity(processObject(coallesced)),
      set: makeSetter(coallesced),
      enumerable: true,
      configurable: true
    }
  }
  
  },{"./GLError":313,"./reflect":316}],316:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = makeReflectTypes
  
  //Construct type info for reflection.
  //
  // This iterates over the flattened list of uniform type values and smashes them into a JSON object.
  //
  // The leaves of the resulting object are either indices or type strings representing primitive glslify types
  function makeReflectTypes(uniforms, useIndex) {
    var obj = {}
    for(var i=0; i<uniforms.length; ++i) {
      var n = uniforms[i].name
      var parts = n.split(".")
      var o = obj
      for(var j=0; j<parts.length; ++j) {
        var x = parts[j].split("[")
        if(x.length > 1) {
          if(!(x[0] in o)) {
            o[x[0]] = []
          }
          o = o[x[0]]
          for(var k=1; k<x.length; ++k) {
            var y = parseInt(x[k])
            if(k<x.length-1 || j<parts.length-1) {
              if(!(y in o)) {
                if(k < x.length-1) {
                  o[y] = []
                } else {
                  o[y] = {}
                }
              }
              o = o[y]
            } else {
              if(useIndex) {
                o[y] = i
              } else {
                o[y] = uniforms[i].type
              }
            }
          }
        } else if(j < parts.length-1) {
          if(!(x[0] in o)) {
            o[x[0]] = {}
          }
          o = o[x[0]]
        } else {
          if(useIndex) {
            o[x[0]] = i
          } else {
            o[x[0]] = uniforms[i].type
          }
        }
      }
    }
    return obj
  }
  },{}],317:[function(_dereq_,module,exports){
  'use strict'
  
  exports.uniforms    = runtimeUniforms
  exports.attributes  = runtimeAttributes
  
  var GL_TO_GLSL_TYPES = {
    'FLOAT':       'float',
    'FLOAT_VEC2':  'vec2',
    'FLOAT_VEC3':  'vec3',
    'FLOAT_VEC4':  'vec4',
    'INT':         'int',
    'INT_VEC2':    'ivec2',
    'INT_VEC3':    'ivec3',
    'INT_VEC4':    'ivec4',
    'BOOL':        'bool',
    'BOOL_VEC2':   'bvec2',
    'BOOL_VEC3':   'bvec3',
    'BOOL_VEC4':   'bvec4',
    'FLOAT_MAT2':  'mat2',
    'FLOAT_MAT3':  'mat3',
    'FLOAT_MAT4':  'mat4',
    'SAMPLER_2D':  'sampler2D',
    'SAMPLER_CUBE':'samplerCube'
  }
  
  var GL_TABLE = null
  
  function getType(gl, type) {
    if(!GL_TABLE) {
      var typeNames = Object.keys(GL_TO_GLSL_TYPES)
      GL_TABLE = {}
      for(var i=0; i<typeNames.length; ++i) {
        var tn = typeNames[i]
        GL_TABLE[gl[tn]] = GL_TO_GLSL_TYPES[tn]
      }
    }
    return GL_TABLE[type]
  }
  
  function runtimeUniforms(gl, program) {
    var numUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS)
    var result = []
    for(var i=0; i<numUniforms; ++i) {
      var info = gl.getActiveUniform(program, i)
      if(info) {
        var type = getType(gl, info.type)
        if(info.size > 1) {
          for(var j=0; j<info.size; ++j) {
            result.push({
              name: info.name.replace('[0]', '[' + j + ']'),
              type: type
            })
          }
        } else {
          result.push({
            name: info.name,
            type: type
          })
        }
      }
    }
    return result
  }
  
  function runtimeAttributes(gl, program) {
    var numAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES)
    var result = []
    for(var i=0; i<numAttributes; ++i) {
      var info = gl.getActiveAttrib(program, i)
      if(info) {
        result.push({
          name: info.name,
          type: getType(gl, info.type)
        })
      }
    }
    return result
  }
  
  },{}],318:[function(_dereq_,module,exports){
  'use strict'
  
  exports.shader   = getShaderReference
  exports.program  = createProgram
  
  var GLError = _dereq_("./GLError")
  var formatCompilerError = _dereq_('gl-format-compiler-error');
  
  var weakMap = typeof WeakMap === 'undefined' ? _dereq_('weakmap-shim') : WeakMap
  var CACHE = new weakMap()
  
  var SHADER_COUNTER = 0
  
  function ShaderReference(id, src, type, shader, programs, count, cache) {
    this.id       = id
    this.src      = src
    this.type     = type
    this.shader   = shader
    this.count    = count
    this.programs = []
    this.cache    = cache
  }
  
  ShaderReference.prototype.dispose = function() {
    if(--this.count === 0) {
      var cache    = this.cache
      var gl       = cache.gl
  
      //Remove program references
      var programs = this.programs
      for(var i=0, n=programs.length; i<n; ++i) {
        var p = cache.programs[programs[i]]
        if(p) {
          delete cache.programs[i]
          gl.deleteProgram(p)
        }
      }
  
      //Remove shader reference
      gl.deleteShader(this.shader)
      delete cache.shaders[(this.type === gl.FRAGMENT_SHADER)|0][this.src]
    }
  }
  
  function ContextCache(gl) {
    this.gl       = gl
    this.shaders  = [{}, {}]
    this.programs = {}
  }
  
  var proto = ContextCache.prototype
  
  function compileShader(gl, type, src) {
    var shader = gl.createShader(type)
    gl.shaderSource(shader, src)
    gl.compileShader(shader)
    if(!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
      var errLog = gl.getShaderInfoLog(shader)
      try {
          var fmt = formatCompilerError(errLog, src, type);
      } catch (e){
          console.warn('Failed to format compiler error: ' + e);
          throw new GLError(errLog, 'Error compiling shader:\n' + errLog)
      }
      throw new GLError(errLog, fmt.short, fmt.long)
    }
    return shader
  }
  
  proto.getShaderReference = function(type, src) {
    var gl      = this.gl
    var shaders = this.shaders[(type === gl.FRAGMENT_SHADER)|0]
    var shader  = shaders[src]
    if(!shader || !gl.isShader(shader.shader)) {
      var shaderObj = compileShader(gl, type, src)
      shader = shaders[src] = new ShaderReference(
        SHADER_COUNTER++,
        src,
        type,
        shaderObj,
        [],
        1,
        this)
    } else {
      shader.count += 1
    }
    return shader
  }
  
  function linkProgram(gl, vshader, fshader, attribs, locations) {
    var program = gl.createProgram()
    gl.attachShader(program, vshader)
    gl.attachShader(program, fshader)
    for(var i=0; i<attribs.length; ++i) {
      gl.bindAttribLocation(program, locations[i], attribs[i])
    }
    gl.linkProgram(program)
    if(!gl.getProgramParameter(program, gl.LINK_STATUS)) {
      var errLog = gl.getProgramInfoLog(program)
      throw new GLError(errLog, 'Error linking program: ' + errLog)
    }
    return program
  }
  
  proto.getProgram = function(vref, fref, attribs, locations) {
    var token = [vref.id, fref.id, attribs.join(':'), locations.join(':')].join('@')
    var prog  = this.programs[token]
    if(!prog || !this.gl.isProgram(prog)) {
      this.programs[token] = prog = linkProgram(
        this.gl,
        vref.shader,
        fref.shader,
        attribs,
        locations)
      vref.programs.push(token)
      fref.programs.push(token)
    }
    return prog
  }
  
  function getCache(gl) {
    var ctxCache = CACHE.get(gl)
    if(!ctxCache) {
      ctxCache = new ContextCache(gl)
      CACHE.set(gl, ctxCache)
    }
    return ctxCache
  }
  
  function getShaderReference(gl, type, src) {
    return getCache(gl).getShaderReference(type, src)
  }
  
  function createProgram(gl, vref, fref, attribs, locations) {
    return getCache(gl).getProgram(vref, fref, attribs, locations)
  }
  
  },{"./GLError":313,"gl-format-compiler-error":267,"weakmap-shim":577}],319:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createSpikes2D
  
  function GLSpikes2D(plot) {
    this.plot = plot
    this.enable = [true, true, false, false]
    this.width  = [1, 1, 1, 1]
    this.color  = [[0,0,0,1],
                   [0,0,0,1],
                   [0,0,0,1],
                   [0,0,0,1]]
    this.center = [Infinity, Infinity]
  }
  
  var proto = GLSpikes2D.prototype
  
  proto.update = function(options) {
    options = options || {}
    this.enable = (options.enable || [true,true,false,false]).slice()
    this.width  = (options.width || [1,1,1,1]).slice()
    this.color  = (options.color || [
                    [0,0,0,1],
                    [0,0,0,1],
                    [0,0,0,1],
                    [0,0,0,1]]).map(function(x) { return x.slice() })
    this.center = (options.center || [Infinity,Infinity]).slice()
    this.plot.setOverlayDirty()
  }
  
  proto.draw = function() {
    var spikeEnable = this.enable
    var spikeWidth  = this.width
    var spikeColor  = this.color
    var spikeCenter = this.center
    var plot        = this.plot
    var line        = plot.line
  
    var dataBox     = plot.dataBox
    var viewPixels  = plot.viewBox
  
    line.bind()
  
    if(dataBox[0] <= spikeCenter[0] && spikeCenter[0] <= dataBox[2] &&
       dataBox[1] <= spikeCenter[1] && spikeCenter[1] <= dataBox[3]) {
  
      var centerX = viewPixels[0] + (spikeCenter[0] - dataBox[0]) / (dataBox[2] - dataBox[0]) * (viewPixels[2] - viewPixels[0])
      var centerY = viewPixels[1] + (spikeCenter[1] - dataBox[1]) / (dataBox[3] - dataBox[1]) * (viewPixels[3] - viewPixels[1])
  
      if(spikeEnable[0]) {
       line.drawLine(
         centerX, centerY,
         viewPixels[0], centerY,
         spikeWidth[0], spikeColor[0])
      }
      if(spikeEnable[1]) {
       line.drawLine(
         centerX, centerY,
         centerX, viewPixels[1],
         spikeWidth[1], spikeColor[1])
      }
      if(spikeEnable[2]) {
        line.drawLine(
          centerX, centerY,
          viewPixels[2], centerY,
          spikeWidth[2], spikeColor[2])
      }
      if(spikeEnable[3]) {
        line.drawLine(
          centerX, centerY,
          centerX, viewPixels[3],
          spikeWidth[3], spikeColor[3])
      }
    }
  }
  
  proto.dispose = function() {
    this.plot.removeOverlay(this)
  }
  
  function createSpikes2D(plot, options) {
    var spikes = new GLSpikes2D(plot)
    spikes.update(options)
    plot.addOverlay(spikes)
    return spikes
  }
  
  },{}],320:[function(_dereq_,module,exports){
  'use strict'
  
  var glslify      = _dereq_('glslify')
  var createShader = _dereq_('gl-shader')
  
  var vertSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nattribute vec3 position, color;\nattribute float weight;\n\nuniform mat4 model, view, projection;\nuniform vec3 coordinates[3];\nuniform vec4 colors[3];\nuniform vec2 screenShape;\nuniform float lineWidth;\n\nvarying vec4 fragColor;\n\nvoid main() {\n  vec3 vertexPosition = mix(coordinates[0],\n    mix(coordinates[2], coordinates[1], 0.5 * (position + 1.0)), abs(position));\n\n  vec4 clipPos = projection * view * model * vec4(vertexPosition, 1.0);\n  vec2 clipOffset = (projection * view * model * vec4(color, 0.0)).xy;\n  vec2 delta = weight * clipOffset * screenShape;\n  vec2 lineOffset = normalize(vec2(delta.y, -delta.x)) / screenShape;\n\n  gl_Position   = vec4(clipPos.xy + clipPos.w * 0.5 * lineWidth * lineOffset, clipPos.z, clipPos.w);\n  fragColor     = color.x * colors[0] + color.y * colors[1] + color.z * colors[2];\n}\n"])
  var fragSrc = glslify(["precision mediump float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n  gl_FragColor = fragColor;\n}"])
  
  module.exports = function(gl) {
    return createShader(gl, vertSrc, fragSrc, null, [
      {name: 'position', type: 'vec3'},
      {name: 'color', type: 'vec3'},
      {name: 'weight', type: 'float'}
    ])
  }
  
  },{"gl-shader":312,"glslify":413}],321:[function(_dereq_,module,exports){
  'use strict'
  
  var createBuffer = _dereq_('gl-buffer')
  var createVAO = _dereq_('gl-vao')
  var createShader = _dereq_('./shaders/index')
  
  module.exports = createSpikes
  
  var identity = [1,0,0,0,
                  0,1,0,0,
                  0,0,1,0,
                  0,0,0,1]
  
  function AxisSpikes(gl, buffer, vao, shader) {
    this.gl         = gl
    this.buffer     = buffer
    this.vao        = vao
    this.shader     = shader
    this.pixelRatio = 1
    this.bounds     = [[-1000,-1000,-1000], [1000,1000,1000]]
    this.position   = [0,0,0]
    this.lineWidth  = [2,2,2]
    this.colors     = [[0,0,0,1], [0,0,0,1], [0,0,0,1]]
    this.enabled    = [true,true,true]
    this.drawSides  = [true,true,true]
    this.axes       = null
  }
  
  var proto = AxisSpikes.prototype
  
  var OUTER_FACE = [0,0,0]
  var INNER_FACE = [0,0,0]
  
  var SHAPE = [0,0]
  
  proto.isTransparent = function() {
    return false
  }
  
  proto.drawTransparent = function(camera) {}
  
  proto.draw = function(camera) {
    var gl = this.gl
    var vao = this.vao
    var shader = this.shader
  
    vao.bind()
    shader.bind()
  
    var model      = camera.model || identity
    var view       = camera.view || identity
    var projection = camera.projection || identity
  
    var axis
    if(this.axes) {
      axis = this.axes.lastCubeProps.axis
    }
  
    var outerFace = OUTER_FACE
    var innerFace = INNER_FACE
    for(var i=0; i<3; ++i) {
      if(axis && axis[i] < 0) {
        outerFace[i] = this.bounds[0][i]
        innerFace[i] = this.bounds[1][i]
      } else {
        outerFace[i] = this.bounds[1][i]
        innerFace[i] = this.bounds[0][i]
      }
    }
  
    SHAPE[0] = gl.drawingBufferWidth
    SHAPE[1] = gl.drawingBufferHeight
  
    shader.uniforms.model       = model
    shader.uniforms.view        = view
    shader.uniforms.projection  = projection
    shader.uniforms.coordinates = [this.position, outerFace, innerFace]
    shader.uniforms.colors      = this.colors
    shader.uniforms.screenShape = SHAPE
  
    for(var i=0; i<3; ++i) {
      shader.uniforms.lineWidth = this.lineWidth[i] * this.pixelRatio
      if(this.enabled[i]) {
        vao.draw(gl.TRIANGLES, 6, 6*i)
        if(this.drawSides[i]) {
          vao.draw(gl.TRIANGLES, 12, 18+12*i)
        }
      }
    }
  
    vao.unbind()
  }
  
  proto.update = function(options) {
    if(!options) {
      return
    }
    if("bounds" in options) {
      this.bounds = options.bounds
    }
    if("position" in options) {
      this.position = options.position
    }
    if("lineWidth" in options) {
      this.lineWidth = options.lineWidth
    }
    if("colors" in options) {
      this.colors = options.colors
    }
    if("enabled" in options) {
      this.enabled = options.enabled
    }
    if("drawSides" in options) {
      this.drawSides = options.drawSides
    }
  }
  
  proto.dispose = function() {
    this.vao.dispose()
    this.buffer.dispose()
    this.shader.dispose()
  }
  
  
  
  function createSpikes(gl, options) {
    //Create buffers
    var data = [ ]
  
    function line(x,y,z,i,l,h) {
      var row = [x,y,z,  0,0,0,  1]
      row[i+3] = 1
      row[i] = l
      data.push.apply(data, row)
      row[6] = -1
      data.push.apply(data, row)
      row[i] = h
      data.push.apply(data, row)
      data.push.apply(data, row)
      row[6] = 1
      data.push.apply(data, row)
      row[i] = l
      data.push.apply(data, row)
    }
  
    line(0,0,0, 0, 0, 1)
    line(0,0,0, 1, 0, 1)
    line(0,0,0, 2, 0, 1)
  
    line(1,0,0,  1,  -1,1)
    line(1,0,0,  2,  -1,1)
  
    line(0,1,0,  0,  -1,1)
    line(0,1,0,  2,  -1,1)
  
    line(0,0,1,  0,  -1,1)
    line(0,0,1,  1,  -1,1)
  
    var buffer = createBuffer(gl, data)
    var vao = createVAO(gl, [{
      type: gl.FLOAT,
      buffer: buffer,
      size: 3,
      offset: 0,
      stride: 28
    }, {
      type: gl.FLOAT,
      buffer: buffer,
      size: 3,
      offset: 12,
      stride: 28
    }, {
      type: gl.FLOAT,
      buffer: buffer,
      size: 1,
      offset: 24,
      stride: 28
    }])
  
    //Create shader
    var shader = createShader(gl)
    shader.attributes.position.location = 0
    shader.attributes.color.location = 1
    shader.attributes.weight.location = 2
  
    //Create spike object
    var spikes = new AxisSpikes(gl, buffer, vao, shader)
  
    //Set parameters
    spikes.update(options)
  
    //Return resulting object
    return spikes
  }
  
  },{"./shaders/index":320,"gl-buffer":258,"gl-vao":332}],322:[function(_dereq_,module,exports){
  var glslify       = _dereq_('glslify')
  
  var triVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 color, position;\nattribute vec2 uv;\n\nuniform float vectorScale, tubeScale;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 eyePosition, lightPosition;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  // Scale the vector magnitude to stay constant with\n  // model & view changes.\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * tubePosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  f_lightDirection = lightPosition - cameraCoordinate.xyz;\n  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);\n\n  // vec4 m_position  = model * vec4(tubePosition, 1.0);\n  vec4 t_position  = view * tubePosition;\n  gl_Position      = projection * t_position;\n\n  f_color          = color;\n  f_data           = tubePosition.xyz;\n  f_position       = position.xyz;\n  f_uv             = uv;\n}\n"])
  var triFragSrc = glslify(["#extension GL_OES_standard_derivatives : enable\n\nprecision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat cookTorranceSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness,\n  float fresnel) {\n\n  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);\n  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);\n\n  //Half angle vector\n  vec3 H = normalize(lightDirection + viewDirection);\n\n  //Geometric term\n  float NdotH = max(dot(surfaceNormal, H), 0.0);\n  float VdotH = max(dot(viewDirection, H), 0.000001);\n  float LdotH = max(dot(lightDirection, H), 0.000001);\n  float G1 = (2.0 * NdotH * VdotN) / VdotH;\n  float G2 = (2.0 * NdotH * LdotN) / LdotH;\n  float G = min(1.0, min(G1, G2));\n  \n  //Distribution term\n  float D = beckmannDistribution(NdotH, roughness);\n\n  //Fresnel term\n  float F = pow(1.0 - VdotN, fresnel);\n\n  //Multiply terms and done\n  return  G * F * D / max(3.14159265 * VdotN, 0.000001);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform sampler2D texture;\n\nvarying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;\nvarying vec4 f_color;\nvarying vec2 f_uv;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n  vec3 N = normalize(f_normal);\n  vec3 L = normalize(f_lightDirection);\n  vec3 V = normalize(f_eyeDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  vec4 surfaceColor = f_color * texture2D(texture, f_uv);\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = litColor * opacity;\n}\n"])
  var pickVertSrc = glslify(["precision highp float;\n\nprecision highp float;\n#define GLSLIFY 1\n\nvec3 getOrthogonalVector(vec3 v) {\n  // Return up-vector for only-z vector.\n  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).\n  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.\n  // Assign z = 0, x = -b, y = a:\n  // a*-b + b*a + c*0 = -ba + ba + 0 = 0\n  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {\n    return normalize(vec3(-v.y, v.x, 0.0));\n  } else {\n    return normalize(vec3(0.0, v.z, -v.y));\n  }\n}\n\n// Calculate the tube vertex and normal at the given index.\n//\n// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.\n//\n// Each tube segment is made up of a ring of vertices.\n// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.\n// The indexes of tube segments run from 0 to 8.\n//\nvec3 getTubePosition(vec3 d, float index, out vec3 normal) {\n  float segmentCount = 8.0;\n\n  float angle = 2.0 * 3.14159 * (index / segmentCount);\n\n  vec3 u = getOrthogonalVector(d);\n  vec3 v = normalize(cross(u, d));\n\n  vec3 x = u * cos(angle) * length(d);\n  vec3 y = v * sin(angle) * length(d);\n  vec3 v3 = x + y;\n\n  normal = normalize(v3);\n\n  return v3;\n}\n\nattribute vec4 vector;\nattribute vec4 position;\nattribute vec4 id;\n\nuniform mat4 model, view, projection;\nuniform float tubeScale;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  vec3 normal;\n  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);\n  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);\n\n  gl_Position = projection * view * tubePosition;\n  f_id        = id;\n  f_position  = position.xyz;\n}\n"])
  var pickFragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3  clipBounds[2];\nuniform float pickId;\n\nvarying vec3 f_position;\nvarying vec4 f_id;\n\nvoid main() {\n  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;\n\n  gl_FragColor = vec4(pickId, f_id.xyz);\n}"])
  
  exports.meshShader = {
    vertex:   triVertSrc,
    fragment: triFragSrc,
    attributes: [
      {name: 'position', type: 'vec4'},
      {name: 'color', type: 'vec4'},
      {name: 'uv', type: 'vec2'},
      {name: 'vector', type: 'vec4'}
    ]
  }
  exports.pickShader = {
    vertex:   pickVertSrc,
    fragment: pickFragSrc,
    attributes: [
      {name: 'position', type: 'vec4'},
      {name: 'id', type: 'vec4'},
      {name: 'vector', type: 'vec4'}
    ]
  }
  
  },{"glslify":413}],323:[function(_dereq_,module,exports){
  "use strict";
  
  var vec3 = _dereq_('gl-vec3');
  var vec4 = _dereq_('gl-vec4');
  var GRID_TYPES = ['xyz', 'xzy', 'yxz', 'yzx', 'zxy', 'zyx'];
  
  var streamToTube = function(stream, maxDivergence, minDistance, maxNorm) {
    var points = stream.points;
    var velocities = stream.velocities;
    var divergences = stream.divergences;
  
    var verts = [];
    var faces = [];
    var vectors = [];
    var previousVerts = [];
    var currentVerts = [];
    var intensities = [];
    var previousIntensity = 0;
    var currentIntensity = 0;
    var currentVector = vec4.create();
    var previousVector = vec4.create();
  
    var facets = 8;
  
    for (var i = 0; i < points.length; i++) {
      var p = points[i];
      var fwd = velocities[i];
      var r = divergences[i];
      if (maxDivergence === 0) {
        r = minDistance * 0.05;
      }
      currentIntensity = vec3.length(fwd) / maxNorm;
  
      currentVector = vec4.create();
      vec3.copy(currentVector, fwd);
      currentVector[3] = r;
  
      for (var a = 0; a < facets; a++) {
        currentVerts[a] = [p[0], p[1], p[2], a];
      }
      if (previousVerts.length > 0) {
        for (var a = 0; a < facets; a++) {
          var a1 = (a+1) % facets;
          verts.push(
            previousVerts[a],
            currentVerts[a],
            currentVerts[a1],
  
            currentVerts[a1],
            previousVerts[a1],
            previousVerts[a]
          );
          vectors.push(
            previousVector,
            currentVector,
            currentVector,
  
            currentVector,
            previousVector,
            previousVector
          );
          intensities.push(
            previousIntensity,
            currentIntensity,
            currentIntensity,
  
            currentIntensity,
            previousIntensity,
            previousIntensity
          );
  
          var len = verts.length;
          faces.push(
            [len-6, len-5, len-4],
            [len-3, len-2, len-1]
          );
        }
      }
      var tmp1 = previousVerts;
      previousVerts = currentVerts;
      currentVerts = tmp1;
  
      var tmp2 = previousVector;
      previousVector = currentVector;
      currentVector = tmp2;
  
      var tmp3 = previousIntensity;
      previousIntensity = currentIntensity;
      currentIntensity = tmp3;
    }
    return {
      positions: verts,
      cells: faces,
      vectors: vectors,
      vertexIntensity: intensities
    };
  };
  
  var createTubes = function(streams, colormap, maxDivergence, minDistance) {
  
    var maxNorm = 0;
    for (var i=0; i<streams.length; i++) {
      var velocities = streams[i].velocities;
      for (var j=0; j<velocities.length; j++) {
        maxNorm = Math.max(maxNorm,
          vec3.length(velocities[j])
        );
      }
    }
  
    var tubes = streams.map(function(s) {
      return streamToTube(s, maxDivergence, minDistance, maxNorm);
    });
  
    var positions = [];
    var cells = [];
    var vectors = [];
    var vertexIntensity = [];
    for (var i=0; i < tubes.length; i++) {
      var tube = tubes[i];
      var offset = positions.length;
      positions = positions.concat(tube.positions);
      vectors = vectors.concat(tube.vectors);
      vertexIntensity = vertexIntensity.concat(tube.vertexIntensity);
      for (var j=0; j<tube.cells.length; j++) {
        var cell = tube.cells[j];
        var newCell = [];
        cells.push(newCell);
        for (var k=0; k<cell.length; k++) {
          newCell.push(cell[k] + offset);
        }
      }
    }
    return {
      positions: positions,
      cells: cells,
      vectors: vectors,
      vertexIntensity: vertexIntensity,
      colormap: colormap
    };
  };
  
  var findLastSmallerIndex = function(points, v) {
    var len = points.length;
    var i;
    for (i=0; i<len; i++) {
      var p = points[i];
      if (p === v) return i;
      else if (p > v) return i-1;
    }
    return i;
  };
  
  var clamp = function(v, min, max) {
    return v < min ? min : (v > max ? max : v);
  };
  
  var sampleMeshgrid = function(point, vectorField, gridInfo) {
    var vectors = vectorField.vectors;
    var meshgrid = vectorField.meshgrid;
  
    var x = point[0];
    var y = point[1];
    var z = point[2];
  
    var w = meshgrid[0].length;
    var h = meshgrid[1].length;
    var d = meshgrid[2].length;
  
    // Find the index of the nearest smaller value in the meshgrid for each coordinate of (x,y,z).
    // The nearest smaller value index for x is the index x0 such that
    // meshgrid[0][x0] < x and for all x1 > x0, meshgrid[0][x1] >= x.
    var x0 = findLastSmallerIndex(meshgrid[0], x);
    var y0 = findLastSmallerIndex(meshgrid[1], y);
    var z0 = findLastSmallerIndex(meshgrid[2], z);
  
    // Get the nearest larger meshgrid value indices.
    // From the above "nearest smaller value", we know that
    //   meshgrid[0][x0] < x
    //   meshgrid[0][x0+1] >= x
    var x1 = x0 + 1;
    var y1 = y0 + 1;
    var z1 = z0 + 1;
  
    x0 = clamp(x0, 0, w-1);
    x1 = clamp(x1, 0, w-1);
    y0 = clamp(y0, 0, h-1);
    y1 = clamp(y1, 0, h-1);
    z0 = clamp(z0, 0, d-1);
    z1 = clamp(z1, 0, d-1);
  
    // Reject points outside the meshgrid, return a zero vector.
    if (x0 < 0 || y0 < 0 || z0 < 0 || x1 > w-1 || y1 > h-1 || z1 > d-1) {
      return vec3.create();
    }
  
    // Normalize point coordinates to 0..1 scaling factor between x0 and x1.
    var mX0 = meshgrid[0][x0];
    var mX1 = meshgrid[0][x1];
    var mY0 = meshgrid[1][y0];
    var mY1 = meshgrid[1][y1];
    var mZ0 = meshgrid[2][z0];
    var mZ1 = meshgrid[2][z1];
    var xf = (x - mX0) / (mX1 - mX0);
    var yf = (y - mY0) / (mY1 - mY0);
    var zf = (z - mZ0) / (mZ1 - mZ0);
  
    if (!isFinite(xf)) xf = 0.5;
    if (!isFinite(yf)) yf = 0.5;
    if (!isFinite(zf)) zf = 0.5;
  
    var x0off;
    var x1off;
    var y0off;
    var y1off;
    var z0off;
    var z1off;
  
    if(gridInfo.reversedX) {
      x0 = w - 1 - x0;
      x1 = w - 1 - x1;
    }
  
    if(gridInfo.reversedY) {
      y0 = h - 1 - y0;
      y1 = h - 1 - y1;
    }
  
    if(gridInfo.reversedZ) {
      z0 = d - 1 - z0;
      z1 = d - 1 - z1;
    }
  
    switch(gridInfo.filled) {
      case 5: // 'zyx'
        z0off = z0;
        z1off = z1;
        y0off = y0*d;
        y1off = y1*d;
        x0off = x0*d*h;
        x1off = x1*d*h;
        break;
  
      case 4: // 'zxy'
        z0off = z0;
        z1off = z1;
        x0off = x0*d;
        x1off = x1*d;
        y0off = y0*d*w;
        y1off = y1*d*w;
        break;
  
      case 3: // 'yzx'
        y0off = y0;
        y1off = y1;
        z0off = z0*h;
        z1off = z1*h;
        x0off = x0*h*d;
        x1off = x1*h*d;
        break;
  
      case 2: // 'yxz'
        y0off = y0;
        y1off = y1;
        x0off = x0*h;
        x1off = x1*h;
        z0off = z0*h*w;
        z1off = z1*h*w;
        break;
  
      case 1: // 'xzy'
        x0off = x0;
        x1off = x1;
        z0off = z0*w;
        z1off = z1*w;
        y0off = y0*w*d;
        y1off = y1*w*d;
        break;
  
      default: // case 0: // 'xyz'
        x0off = x0;
        x1off = x1;
        y0off = y0*w;
        y1off = y1*w;
        z0off = z0*w*h;
        z1off = z1*w*h;
        break;
    }
  
    // Sample data vectors around the (x,y,z) point.
    var v000 = vectors[x0off + y0off + z0off];
    var v001 = vectors[x0off + y0off + z1off];
    var v010 = vectors[x0off + y1off + z0off];
    var v011 = vectors[x0off + y1off + z1off];
    var v100 = vectors[x1off + y0off + z0off];
    var v101 = vectors[x1off + y0off + z1off];
    var v110 = vectors[x1off + y1off + z0off];
    var v111 = vectors[x1off + y1off + z1off];
  
    var c00 = vec3.create();
    var c01 = vec3.create();
    var c10 = vec3.create();
    var c11 = vec3.create();
  
    vec3.lerp(c00, v000, v100, xf);
    vec3.lerp(c01, v001, v101, xf);
    vec3.lerp(c10, v010, v110, xf);
    vec3.lerp(c11, v011, v111, xf);
  
    var c0 = vec3.create();
    var c1 = vec3.create();
  
    vec3.lerp(c0, c00, c10, yf);
    vec3.lerp(c1, c01, c11, yf);
  
    var c = vec3.create();
  
    vec3.lerp(c, c0, c1, zf);
  
    return c;
  };
  
  
  var vabs = function(dst, v) {
    var x = v[0];
    var y = v[1];
    var z = v[2];
    dst[0] = x < 0 ? -x : x;
    dst[1] = y < 0 ? -y : y;
    dst[2] = z < 0 ? -z : z;
    return dst;
  };
  
  var findMinSeparation = function(xs) {
    var minSeparation = Infinity;
    xs.sort(function(a, b) { return a - b; });
    var len = xs.length;
    for (var i=1; i<len; i++) {
      var d = Math.abs(xs[i] - xs[i-1]);
      if (d < minSeparation) {
        minSeparation = d;
      }
    }
    return minSeparation;
  };
  
  // Finds the minimum per-component distance in positions.
  //
  var calculateMinPositionDistance = function(positions) {
    var xs = [], ys = [], zs = [];
    var xi = {}, yi = {}, zi = {};
    var len = positions.length;
    for (var i=0; i<len; i++) {
      var p = positions[i];
      var x = p[0], y = p[1], z = p[2];
  
      // Split the positions array into arrays of unique component values.
      //
      // Why go through the trouble of using a uniqueness hash table vs
      // sort and uniq:
      //
      // Suppose you've got a million positions in a 100x100x100 grid.
      //
      // Using a uniqueness hash table, you're doing 1M array reads,
      // 3M hash table lookups from 100-element hashes, 300 hash table inserts, then
      // sorting three 100-element arrays and iterating over them.
      // Roughly, 1M + 3M * ln(100) + 300 * ln(100/2) + 3 * 100 * ln(100) + 3 * 100 =
      //          1M + 13.8M + 0.0012M +  0.0014M + 0.0003M
      //          =~ 15M
      //
      // Sort and uniq solution would do 1M array reads, 3M array inserts,
      // sort three 1M-element arrays and iterate over them.
      // Roughly, 1M + 3M + 3 * 1M * ln(1M) + 3 * 1M =
      //          1M + 3M + 41.4M + 3M
      //          =~ 48.4M
      //
      // Guessing that a hard-coded sort & uniq would be faster due to not having
      // to run a hashing function on everything. More memory usage though
      // (bunch of small hash tables vs. duplicating the input array.)
      //
      // In JS-land, who knows. Maybe xi[x] casts x to string and destroys perf,
      // maybe numeric keys get special-cased, maybe the object lookups run at near O(1)-speeds.
      // Maybe the sorting comparison function is expensive to call, maybe it gets inlined or special-cased.
      //
      // ... You're probably not going to call this with more than 10k positions anyhow, so this is very academic.
      //
      if (!xi[x]) {
        xs.push(x);
        xi[x] = true;
      }
      if (!yi[y]) {
        ys.push(y);
        yi[y] = true;
      }
      if (!zi[z]) {
        zs.push(z);
        zi[z] = true;
      }
    }
    var xSep = findMinSeparation(xs);
    var ySep = findMinSeparation(ys);
    var zSep = findMinSeparation(zs);
    var minSeparation = Math.min(xSep, ySep, zSep);
  
    return isFinite(minSeparation) ? minSeparation : 1;
  };
  
  module.exports = function(vectorField, bounds) {
    var positions = vectorField.startingPositions;
    var maxLength = vectorField.maxLength || 1000;
    var tubeSize = vectorField.tubeSize || 1;
    var absoluteTubeSize = vectorField.absoluteTubeSize;
    var gridFill = vectorField.gridFill || '+x+y+z';
  
    var gridInfo = {};
    if(gridFill.indexOf('-x') !== -1) { gridInfo.reversedX = true; }
    if(gridFill.indexOf('-y') !== -1) { gridInfo.reversedY = true; }
    if(gridFill.indexOf('-z') !== -1) { gridInfo.reversedZ = true; }
    gridInfo.filled = GRID_TYPES.indexOf(gridFill.replace(/-/g, '').replace(/\+/g, ''));
  
    var getVelocity = vectorField.getVelocity || function(p) {
      return sampleMeshgrid(p, vectorField, gridInfo);
    };
  
    var getDivergence = vectorField.getDivergence || function(p, v0) {
      var dp = vec3.create();
      var e = 0.0001;
  
      vec3.add(dp, p, [e, 0, 0]);
      var vx = getVelocity(dp);
      vec3.subtract(vx, vx, v0);
      vec3.scale(vx, vx, 1/e);
  
      vec3.add(dp, p, [0, e, 0]);
      var vy = getVelocity(dp);
      vec3.subtract(vy, vy, v0);
      vec3.scale(vy, vy, 1/e);
  
      vec3.add(dp, p, [0, 0, e]);
      var vz = getVelocity(dp);
      vec3.subtract(vz, vz, v0);
      vec3.scale(vz, vz, 1/e);
  
      vec3.add(dp, vx, vy);
      vec3.add(dp, dp, vz);
      return dp;
    };
  
    var streams = [];
  
    var minX = bounds[0][0], minY = bounds[0][1], minZ = bounds[0][2];
    var maxX = bounds[1][0], maxY = bounds[1][1], maxZ = bounds[1][2];
  
    var inBounds = function(p) {
      var x = p[0];
      var y = p[1];
      var z = p[2];
      return !(
        x < minX || x > maxX ||
        y < minY || y > maxY ||
        z < minZ || z > maxZ
      );
    };
  
    var boundsSize = vec3.distance(bounds[0], bounds[1]);
    var maxStepSize = 10 * boundsSize / maxLength;
    var maxStepSizeSq = maxStepSize * maxStepSize;
  
    var minDistance = 1;
    var maxDivergence = 0; // For component-wise divergence vec3.create();
  
    // In case we need to do component-wise divergence visualization
    // var tmp = vec3.create();
  
    var len = positions.length;
    if (len > 1) {
      minDistance = calculateMinPositionDistance(positions);
    }
  
    for (var i = 0; i < len; i++) {
      var p = vec3.create();
      vec3.copy(p, positions[i]);
  
      var stream = [p];
      var velocities = [];
      var v = getVelocity(p);
      var op = p;
      velocities.push(v);
  
      var divergences = [];
  
      var dv = getDivergence(p, v);
      var dvLength = vec3.length(dv);
      if (isFinite(dvLength) && dvLength > maxDivergence) {
        maxDivergence = dvLength;
      }
      // In case we need to do component-wise divergence visualization
      // vec3.max(maxDivergence, maxDivergence, vabs(tmp, dv));
      divergences.push(dvLength);
  
      streams.push({points: stream, velocities: velocities, divergences: divergences});
  
      var j = 0;
  
      while (j < maxLength * 100 && stream.length < maxLength && inBounds(p)) {
        j++;
        var np = vec3.clone(v);
        var sqLen = vec3.squaredLength(np);
        if (sqLen === 0) {
          break;
        } else if (sqLen > maxStepSizeSq) {
          vec3.scale(np, np, maxStepSize / Math.sqrt(sqLen));
        }
        vec3.add(np, np, p);
  
        v = getVelocity(np);
  
        if (vec3.squaredDistance(op, np) - maxStepSizeSq > -0.0001 * maxStepSizeSq) {
          stream.push(np);
          op = np;
          velocities.push(v);
          var dv = getDivergence(np, v);
          var dvLength = vec3.length(dv);
          if (isFinite(dvLength) && dvLength > maxDivergence) {
            maxDivergence = dvLength;
          }
          // In case we need to do component-wise divergence visualization
          //vec3.max(maxDivergence, maxDivergence, vabs(tmp, dv));
          divergences.push(dvLength);
        }
  
        p = np;
      }
    }
  
    var tubes = createTubes(streams, vectorField.colormap, maxDivergence, minDistance);
  
    if (absoluteTubeSize) {
      tubes.tubeScale = absoluteTubeSize;
    } else {
      // Avoid division by zero.
      if (maxDivergence === 0) {
        maxDivergence = 1;
      }
      tubes.tubeScale = tubeSize * 0.5 * minDistance / maxDivergence;
    }
  
    return tubes;
  };
  
  var shaders = _dereq_('./lib/shaders');
  var createMesh = _dereq_('gl-cone3d').createMesh;
  module.exports.createTubeMesh = function(gl, params) {
    return createMesh(gl, params, {
      shaders: shaders,
      traceType: 'streamtube'
    });
  }
  
  },{"./lib/shaders":322,"gl-cone3d":259,"gl-vec3":351,"gl-vec4":387}],324:[function(_dereq_,module,exports){
  var createShader = _dereq_('gl-shader')
  var glslify = _dereq_('glslify')
  
  var vertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute vec3 f;\nattribute vec3 normal;\n\nuniform vec3 objectOffset;\nuniform mat4 model, view, projection, inverseModel;\nuniform vec3 lightPosition, eyePosition;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 localCoordinate = vec3(uv.zw, f.x);\n  worldCoordinate = objectOffset + localCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n  vec4 clipPosition = projection * view * worldPosition;\n  gl_Position = clipPosition;\n  kill = f.y;\n  value = f.z;\n  planeCoordinate = uv.xy;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Lighting geometry parameters\n  vec4 cameraCoordinate = view * worldPosition;\n  cameraCoordinate.xyz /= cameraCoordinate.w;\n  lightDirection = lightPosition - cameraCoordinate.xyz;\n  eyeDirection   = eyePosition - cameraCoordinate.xyz;\n  surfaceNormal  = normalize((vec4(normal,0) * inverseModel).xyz);\n}\n"])
  var fragSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nfloat beckmannDistribution(float x, float roughness) {\n  float NdotH = max(x, 0.0001);\n  float cos2Alpha = NdotH * NdotH;\n  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;\n  float roughness2 = roughness * roughness;\n  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;\n  return exp(tan2Alpha / roughness2) / denom;\n}\n\nfloat beckmannSpecular(\n  vec3 lightDirection,\n  vec3 viewDirection,\n  vec3 surfaceNormal,\n  float roughness) {\n  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);\n}\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec3 lowerBound, upperBound;\nuniform float contourTint;\nuniform vec4 contourColor;\nuniform sampler2D colormap;\nuniform vec3 clipBounds[2];\nuniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;\nuniform float vertexColor;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  if (\n    kill > 0.0 ||\n    vColor.a == 0.0 ||\n    outOfRange(clipBounds[0], clipBounds[1], worldCoordinate)\n  ) discard;\n\n  vec3 N = normalize(surfaceNormal);\n  vec3 V = normalize(eyeDirection);\n  vec3 L = normalize(lightDirection);\n\n  if(gl_FrontFacing) {\n    N = -N;\n  }\n\n  float specular = max(beckmannSpecular(L, V, N, roughness), 0.);\n  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);\n\n  //decide how to interpolate color — in vertex or in fragment\n  vec4 surfaceColor =\n    step(vertexColor, .5) * texture2D(colormap, vec2(value, value)) +\n    step(.5, vertexColor) * vColor;\n\n  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);\n\n  gl_FragColor = mix(litColor, contourColor, contourTint) * opacity;\n}\n"])
  var contourVertSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec4 uv;\nattribute float f;\n\nuniform vec3 objectOffset;\nuniform mat3 permutation;\nuniform mat4 model, view, projection;\nuniform float height, zOffset;\nuniform sampler2D colormap;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 lightDirection, eyeDirection, surfaceNormal;\nvarying vec4 vColor;\n\nvoid main() {\n  vec3 dataCoordinate = permutation * vec3(uv.xy, height);\n  worldCoordinate = objectOffset + dataCoordinate;\n  vec4 worldPosition = model * vec4(worldCoordinate, 1.0);\n\n  vec4 clipPosition = projection * view * worldPosition;\n  clipPosition.z += zOffset;\n\n  gl_Position = clipPosition;\n  value = f + objectOffset.z;\n  kill = -1.0;\n  planeCoordinate = uv.zw;\n\n  vColor = texture2D(colormap, vec2(value, value));\n\n  //Don't do lighting for contours\n  surfaceNormal   = vec3(1,0,0);\n  eyeDirection    = vec3(0,1,0);\n  lightDirection  = vec3(0,0,1);\n}\n"])
  var pickSrc = glslify(["precision highp float;\n#define GLSLIFY 1\n\nbool outOfRange(float a, float b, float p) {\n  return ((p > max(a, b)) || \n          (p < min(a, b)));\n}\n\nbool outOfRange(vec2 a, vec2 b, vec2 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y));\n}\n\nbool outOfRange(vec3 a, vec3 b, vec3 p) {\n  return (outOfRange(a.x, b.x, p.x) ||\n          outOfRange(a.y, b.y, p.y) ||\n          outOfRange(a.z, b.z, p.z));\n}\n\nbool outOfRange(vec4 a, vec4 b, vec4 p) {\n  return outOfRange(a.xyz, b.xyz, p.xyz);\n}\n\nuniform vec2 shape;\nuniform vec3 clipBounds[2];\nuniform float pickId;\n\nvarying float value, kill;\nvarying vec3 worldCoordinate;\nvarying vec2 planeCoordinate;\nvarying vec3 surfaceNormal;\n\nvec2 splitFloat(float v) {\n  float vh = 255.0 * v;\n  float upper = floor(vh);\n  float lower = fract(vh);\n  return vec2(upper / 255.0, floor(lower * 16.0) / 16.0);\n}\n\nvoid main() {\n  if ((kill > 0.0) ||\n      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;\n\n  vec2 ux = splitFloat(planeCoordinate.x / shape.x);\n  vec2 uy = splitFloat(planeCoordinate.y / shape.y);\n  gl_FragColor = vec4(pickId, ux.x, uy.x, ux.y + (uy.y/16.0));\n}\n"])
  
  exports.createShader = function (gl) {
    var shader = createShader(gl, vertSrc, fragSrc, null, [
      {name: 'uv', type: 'vec4'},
      {name: 'f', type: 'vec3'},
      {name: 'normal', type: 'vec3'}
    ])
    shader.attributes.uv.location = 0
    shader.attributes.f.location = 1
    shader.attributes.normal.location = 2
    return shader
  }
  exports.createPickShader = function (gl) {
    var shader = createShader(gl, vertSrc, pickSrc, null, [
      {name: 'uv', type: 'vec4'},
      {name: 'f', type: 'vec3'},
      {name: 'normal', type: 'vec3'}
    ])
    shader.attributes.uv.location = 0
    shader.attributes.f.location = 1
    shader.attributes.normal.location = 2
    return shader
  }
  exports.createContourShader = function (gl) {
    var shader = createShader(gl, contourVertSrc, fragSrc, null, [
      {name: 'uv', type: 'vec4'},
      {name: 'f', type: 'float'}
    ])
    shader.attributes.uv.location = 0
    shader.attributes.f.location = 1
    return shader
  }
  exports.createPickContourShader = function (gl) {
    var shader = createShader(gl, contourVertSrc, pickSrc, null, [
      {name: 'uv', type: 'vec4'},
      {name: 'f', type: 'float'}
    ])
    shader.attributes.uv.location = 0
    shader.attributes.f.location = 1
    return shader
  }
  
  },{"gl-shader":312,"glslify":413}],325:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createSurfacePlot
  
  var bits = _dereq_('bit-twiddle')
  var createBuffer = _dereq_('gl-buffer')
  var createVAO = _dereq_('gl-vao')
  var createTexture = _dereq_('gl-texture2d')
  var pool = _dereq_('typedarray-pool')
  var colormap = _dereq_('colormap')
  var ops = _dereq_('ndarray-ops')
  var pack = _dereq_('ndarray-pack')
  var ndarray = _dereq_('ndarray')
  var surfaceNets = _dereq_('surface-nets')
  var multiply = _dereq_('gl-mat4/multiply')
  var invert = _dereq_('gl-mat4/invert')
  var bsearch = _dereq_('binary-search-bounds')
  var gradient = _dereq_('ndarray-gradient')
  var shaders = _dereq_('./lib/shaders')
  
  var createShader = shaders.createShader
  var createContourShader = shaders.createContourShader
  var createPickShader = shaders.createPickShader
  var createPickContourShader = shaders.createPickContourShader
  
  var SURFACE_VERTEX_SIZE = 4 * (4 + 3 + 3)
  
  var IDENTITY = [
    1, 0, 0, 0,
    0, 1, 0, 0,
    0, 0, 1, 0,
    0, 0, 0, 1 ]
  
  var QUAD = [
    [0, 0],
    [0, 1],
    [1, 0],
    [1, 1],
    [1, 0],
    [0, 1]
  ]
  
  var PERMUTATIONS = [
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0]
  ]
  
  ;(function () {
    for (var i = 0; i < 3; ++i) {
      var p = PERMUTATIONS[i]
      var u = (i + 1) % 3
      var v = (i + 2) % 3
      p[u + 0] = 1
      p[v + 3] = 1
      p[i + 6] = 1
    }
  })()
  
  function SurfacePickResult (position, index, uv, level, dataCoordinate) {
    this.position = position
    this.index = index
    this.uv = uv
    this.level = level
    this.dataCoordinate = dataCoordinate
  }
  
  var N_COLORS = 256
  
  function SurfacePlot (
    gl,
    shape,
    bounds,
    shader,
    pickShader,
    coordinates,
    vao,
    colorMap,
    contourShader,
    contourPickShader,
    contourBuffer,
    contourVAO,
    dynamicBuffer,
    dynamicVAO,
    objectOffset) {
    this.gl = gl
    this.shape = shape
    this.bounds = bounds
    this.objectOffset = objectOffset
    this.intensityBounds = []
  
    this._shader = shader
    this._pickShader = pickShader
    this._coordinateBuffer = coordinates
    this._vao = vao
    this._colorMap = colorMap
  
    this._contourShader = contourShader
    this._contourPickShader = contourPickShader
    this._contourBuffer = contourBuffer
    this._contourVAO = contourVAO
    this._contourOffsets = [[], [], []]
    this._contourCounts = [[], [], []]
    this._vertexCount = 0
  
    this._pickResult = new SurfacePickResult([0, 0, 0], [0, 0], [0, 0], [0, 0, 0], [0, 0, 0])
  
    this._dynamicBuffer = dynamicBuffer
    this._dynamicVAO = dynamicVAO
    this._dynamicOffsets = [0, 0, 0]
    this._dynamicCounts = [0, 0, 0]
  
    this.contourWidth = [ 1, 1, 1 ]
    this.contourLevels = [[1], [1], [1]]
    this.contourTint = [0, 0, 0]
    this.contourColor = [[0.5, 0.5, 0.5, 1], [0.5, 0.5, 0.5, 1], [0.5, 0.5, 0.5, 1]]
  
    this.showContour = true
    this.showSurface = true
  
    this.enableHighlight = [true, true, true]
    this.highlightColor = [[0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1]]
    this.highlightTint = [ 1, 1, 1 ]
    this.highlightLevel = [-1, -1, -1]
  
    // Dynamic contour options
    this.enableDynamic = [ true, true, true ]
    this.dynamicLevel = [ NaN, NaN, NaN ]
    this.dynamicColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ]
    this.dynamicTint = [ 1, 1, 1 ]
    this.dynamicWidth = [ 1, 1, 1 ]
  
    this.axesBounds = [[Infinity, Infinity, Infinity], [-Infinity, -Infinity, -Infinity]]
    this.surfaceProject = [ false, false, false ]
    this.contourProject = [[ false, false, false ],
      [ false, false, false ],
      [ false, false, false ]]
  
    this.colorBounds = [ false, false ]
  
    // Store xyz fields, need this for picking
    this._field = [
      ndarray(pool.mallocFloat(1024), [0, 0]),
      ndarray(pool.mallocFloat(1024), [0, 0]),
      ndarray(pool.mallocFloat(1024), [0, 0]) ]
  
    this.pickId = 1
    this.clipBounds = [[-Infinity, -Infinity, -Infinity], [Infinity, Infinity, Infinity]]
  
    this.snapToData = false
  
    this.pixelRatio = 1
  
    this.opacity = 1.0
  
    this.lightPosition = [10, 10000, 0]
    this.ambientLight = 0.8
    this.diffuseLight = 0.8
    this.specularLight = 2.0
    this.roughness = 0.5
    this.fresnel = 1.5
    this.vertexColor = 0
  
    this.dirty = true
  }
  
  var proto = SurfacePlot.prototype
  
  proto.genColormap = function (name, opacityscale) {
    var hasAlpha = false
  
    var x = pack([colormap({
      colormap: name,
      nshades: N_COLORS,
      format: 'rgba'
    }).map(function (c, i) {
      var a = opacityscale ? getOpacityFromScale(i / 255.0, opacityscale) : c[3]
      if(a < 1) hasAlpha = true
      return [c[0], c[1], c[2], 255 * a]
    })])
    ops.divseq(x, 255.0)
  
    this.hasAlphaScale = hasAlpha
    return x
  }
  
  proto.isTransparent = function () {
    return this.opacity < 1 || this.hasAlphaScale
  }
  
  proto.isOpaque = function () {
    return !this.isTransparent()
  }
  
  proto.pickSlots = 1
  
  proto.setPickBase = function (id) {
    this.pickId = id
  }
  
  function getOpacityFromScale(ratio, opacityscale) { // copied form gl-mesh3d
    if(!opacityscale) return 1
    if(!opacityscale.length) return 1
  
    for(var i = 0; i < opacityscale.length; ++i) {
      if(opacityscale.length < 2) return 1
      if(opacityscale[i][0] === ratio) return opacityscale[i][1]
      if(opacityscale[i][0] > ratio && i > 0) {
        var d = (opacityscale[i][0] - ratio) / (opacityscale[i][0] - opacityscale[i - 1][0])
        return opacityscale[i][1] * (1 - d) + d * opacityscale[i - 1][1]
      }
    }
  
    return 1
  }
  
  var ZERO_VEC = [0, 0, 0]
  
  var PROJECT_DATA = {
    showSurface: false,
    showContour: false,
    projections: [IDENTITY.slice(), IDENTITY.slice(), IDENTITY.slice()],
    clipBounds: [
      [[0, 0, 0], [0, 0, 0]],
      [[0, 0, 0], [0, 0, 0]],
      [[0, 0, 0], [0, 0, 0]]]
  }
  
  function computeProjectionData (camera, obj) {
    var i, j, k
  
    // Compute cube properties
    var cubeAxis = (obj.axes && obj.axes.lastCubeProps.axis) || ZERO_VEC
  
    var showSurface = obj.showSurface
    var showContour = obj.showContour
  
    for (i = 0; i < 3; ++i) {
      showSurface = showSurface || obj.surfaceProject[i]
      for (j = 0; j < 3; ++j) {
        showContour = showContour || obj.contourProject[i][j]
      }
    }
  
    for (i = 0; i < 3; ++i) {
      // Construct projection onto axis
      var axisSquish = PROJECT_DATA.projections[i]
      for (j = 0; j < 16; ++j) {
        axisSquish[j] = 0
      }
      for (j = 0; j < 4; ++j) {
        axisSquish[5 * j] = 1
      }
      axisSquish[5 * i] = 0
      axisSquish[12 + i] = obj.axesBounds[+(cubeAxis[i] > 0)][i]
      multiply(axisSquish, camera.model, axisSquish)
  
      var nclipBounds = PROJECT_DATA.clipBounds[i]
      for (k = 0; k < 2; ++k) {
        for (j = 0; j < 3; ++j) {
          nclipBounds[k][j] = camera.clipBounds[k][j]
        }
      }
      nclipBounds[0][i] = -1e8
      nclipBounds[1][i] = 1e8
    }
  
    PROJECT_DATA.showSurface = showSurface
    PROJECT_DATA.showContour = showContour
  
    return PROJECT_DATA
  }
  
  var UNIFORMS = {
    model: IDENTITY,
    view: IDENTITY,
    projection: IDENTITY,
    inverseModel: IDENTITY.slice(),
    lowerBound: [0, 0, 0],
    upperBound: [0, 0, 0],
    colorMap: 0,
    clipBounds: [[0, 0, 0], [0, 0, 0]],
    height: 0.0,
    contourTint: 0,
    contourColor: [0, 0, 0, 1],
    permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
    zOffset: -1e-4,
    objectOffset: [0, 0, 0],
    kambient: 1,
    kdiffuse: 1,
    kspecular: 1,
    lightPosition: [1000, 1000, 1000],
    eyePosition: [0, 0, 0],
    roughness: 1,
    fresnel: 1,
    opacity: 1,
    vertexColor: 0
  }
  
  var MATRIX_INVERSE = IDENTITY.slice()
  var DEFAULT_PERM = [1, 0, 0, 0, 1, 0, 0, 0, 1]
  
  function drawCore (params, transparent) {
    params = params || {}
    var gl = this.gl
  
    gl.disable(gl.CULL_FACE)
  
    this._colorMap.bind(0)
  
    var uniforms = UNIFORMS
    uniforms.model = params.model || IDENTITY
    uniforms.view = params.view || IDENTITY
    uniforms.projection = params.projection || IDENTITY
    uniforms.lowerBound = [this.bounds[0][0], this.bounds[0][1], this.colorBounds[0] || this.bounds[0][2]]
    uniforms.upperBound = [this.bounds[1][0], this.bounds[1][1], this.colorBounds[1] || this.bounds[1][2]]
    uniforms.objectOffset = this.objectOffset
    uniforms.contourColor = this.contourColor[0]
  
    uniforms.inverseModel = invert(uniforms.inverseModel, uniforms.model)
  
    for (var i = 0; i < 2; ++i) {
      var clipClamped = uniforms.clipBounds[i]
      for (var j = 0; j < 3; ++j) {
        clipClamped[j] = Math.min(Math.max(this.clipBounds[i][j], -1e8), 1e8)
      }
    }
  
    uniforms.kambient = this.ambientLight
    uniforms.kdiffuse = this.diffuseLight
    uniforms.kspecular = this.specularLight
  
    uniforms.roughness = this.roughness
    uniforms.fresnel = this.fresnel
    uniforms.opacity = this.opacity
  
    uniforms.height = 0.0
    uniforms.permutation = DEFAULT_PERM
  
    uniforms.vertexColor = this.vertexColor
  
    // Compute camera matrix inverse
    var invCameraMatrix = MATRIX_INVERSE
    multiply(invCameraMatrix, uniforms.view, uniforms.model)
    multiply(invCameraMatrix, uniforms.projection, invCameraMatrix)
    invert(invCameraMatrix, invCameraMatrix)
  
    for (i = 0; i < 3; ++i) {
      uniforms.eyePosition[i] = invCameraMatrix[12 + i] / invCameraMatrix[15]
    }
  
    var w = invCameraMatrix[15]
    for (i = 0; i < 3; ++i) {
      w += this.lightPosition[i] * invCameraMatrix[4 * i + 3]
    }
    for (i = 0; i < 3; ++i) {
      var s = invCameraMatrix[12 + i]
      for (j = 0; j < 3; ++j) {
        s += invCameraMatrix[4 * j + i] * this.lightPosition[j]
      }
      uniforms.lightPosition[i] = s / w
    }
  
    var projectData = computeProjectionData(uniforms, this)
  
    if (projectData.showSurface)  {
      // Set up uniforms
      this._shader.bind()
      this._shader.uniforms = uniforms
  
      // Draw it
      this._vao.bind()
  
      if (this.showSurface && this._vertexCount) {
        this._vao.draw(gl.TRIANGLES, this._vertexCount)
      }
  
      // Draw projections of surface
      for (i = 0; i < 3; ++i) {
        if (!this.surfaceProject[i] || !this.vertexCount) {
          continue
        }
        this._shader.uniforms.model = projectData.projections[i]
        this._shader.uniforms.clipBounds = projectData.clipBounds[i]
        this._vao.draw(gl.TRIANGLES, this._vertexCount)
      }
  
      this._vao.unbind()
    }
  
    if (projectData.showContour) {
      var shader = this._contourShader
  
      // Don't apply lighting to contours
      uniforms.kambient = 1.0
      uniforms.kdiffuse = 0.0
      uniforms.kspecular = 0.0
      uniforms.opacity = 1.0
  
      shader.bind()
      shader.uniforms = uniforms
  
      // Draw contour lines
      var vao = this._contourVAO
      vao.bind()
  
      // Draw contour levels
      for (i = 0; i < 3; ++i) {
        shader.uniforms.permutation = PERMUTATIONS[i]
        gl.lineWidth(this.contourWidth[i] * this.pixelRatio)
  
        for (j = 0; j < this.contourLevels[i].length; ++j) {
          if (j === this.highlightLevel[i]) {
            shader.uniforms.contourColor = this.highlightColor[i]
            shader.uniforms.contourTint = this.highlightTint[i]
          } else if (j === 0 || (j - 1) === this.highlightLevel[i]) {
            shader.uniforms.contourColor = this.contourColor[i]
            shader.uniforms.contourTint = this.contourTint[i]
          }
          if (!this._contourCounts[i][j]) {
            continue
          }
  
          shader.uniforms.height = this.contourLevels[i][j]
          vao.draw(gl.LINES, this._contourCounts[i][j], this._contourOffsets[i][j])
        }
      }
  
      // Draw projections of surface
      for (i = 0; i < 3; ++i) {
        shader.uniforms.model = projectData.projections[i]
        shader.uniforms.clipBounds = projectData.clipBounds[i]
        for (j = 0; j < 3; ++j) {
          if (!this.contourProject[i][j]) {
            continue
          }
          shader.uniforms.permutation = PERMUTATIONS[j]
          gl.lineWidth(this.contourWidth[j] * this.pixelRatio)
          for (var k = 0; k < this.contourLevels[j].length; ++k) {
            if (k === this.highlightLevel[j]) {
              shader.uniforms.contourColor = this.highlightColor[j]
              shader.uniforms.contourTint = this.highlightTint[j]
            } else if (k === 0 || (k - 1) === this.highlightLevel[j]) {
              shader.uniforms.contourColor = this.contourColor[j]
              shader.uniforms.contourTint = this.contourTint[j]
            }
            if (!this._contourCounts[j][k]) {
              continue
            }
  
            shader.uniforms.height = this.contourLevels[j][k]
            vao.draw(gl.LINES, this._contourCounts[j][k], this._contourOffsets[j][k])
          }
        }
      }
  
      vao.unbind()
  
      // Draw dynamic contours
      vao = this._dynamicVAO
      vao.bind()
  
      // Draw contour levels
      for (i = 0; i < 3; ++i) {
        if (this._dynamicCounts[i] === 0) {
          continue
        }
  
        shader.uniforms.model = uniforms.model
        shader.uniforms.clipBounds = uniforms.clipBounds
        shader.uniforms.permutation = PERMUTATIONS[i]
        gl.lineWidth(this.dynamicWidth[i] * this.pixelRatio)
  
        shader.uniforms.contourColor = this.dynamicColor[i]
        shader.uniforms.contourTint = this.dynamicTint[i]
        shader.uniforms.height = this.dynamicLevel[i]
        vao.draw(gl.LINES, this._dynamicCounts[i], this._dynamicOffsets[i])
  
        for (j = 0; j < 3; ++j) {
          if (!this.contourProject[j][i]) {
            continue
          }
  
          shader.uniforms.model = projectData.projections[j]
          shader.uniforms.clipBounds = projectData.clipBounds[j]
          vao.draw(gl.LINES, this._dynamicCounts[i], this._dynamicOffsets[i])
        }
      }
  
      vao.unbind()
    }
  }
  
  proto.draw = function (params) {
    return drawCore.call(this, params, false)
  }
  
  proto.drawTransparent = function (params) {
    return drawCore.call(this, params, true)
  }
  
  var PICK_UNIFORMS = {
    model: IDENTITY,
    view: IDENTITY,
    projection: IDENTITY,
    inverseModel: IDENTITY,
    clipBounds: [[0, 0, 0], [0, 0, 0]],
    height: 0.0,
    shape: [0, 0],
    pickId: 0,
    lowerBound: [0, 0, 0],
    upperBound: [0, 0, 0],
    zOffset: 0.0,
    objectOffset: [0, 0, 0],
    permutation: [1, 0, 0, 0, 1, 0, 0, 0, 1],
    lightPosition: [0, 0, 0],
    eyePosition: [0, 0, 0]
  }
  
  proto.drawPick = function (params) {
    params = params || {}
    var gl = this.gl
    gl.disable(gl.CULL_FACE)
  
    var uniforms = PICK_UNIFORMS
    uniforms.model = params.model || IDENTITY
    uniforms.view = params.view || IDENTITY
    uniforms.projection = params.projection || IDENTITY
    uniforms.shape = this._field[2].shape
    uniforms.pickId = this.pickId / 255.0
    uniforms.lowerBound = this.bounds[0]
    uniforms.upperBound = this.bounds[1]
    uniforms.objectOffset = this.objectOffset
    uniforms.permutation = DEFAULT_PERM
  
    for (var i = 0; i < 2; ++i) {
      var clipClamped = uniforms.clipBounds[i]
      for (var j = 0; j < 3; ++j) {
        clipClamped[j] = Math.min(Math.max(this.clipBounds[i][j], -1e8), 1e8)
      }
    }
  
    var projectData = computeProjectionData(uniforms, this)
  
    if (projectData.showSurface) {
      // Set up uniforms
      this._pickShader.bind()
      this._pickShader.uniforms = uniforms
  
      // Draw it
      this._vao.bind()
      this._vao.draw(gl.TRIANGLES, this._vertexCount)
  
      // Draw projections of surface
      for (i = 0; i < 3; ++i) {
        if (!this.surfaceProject[i]) {
          continue
        }
        this._pickShader.uniforms.model = projectData.projections[i]
        this._pickShader.uniforms.clipBounds = projectData.clipBounds[i]
        this._vao.draw(gl.TRIANGLES, this._vertexCount)
      }
  
      this._vao.unbind()
    }
  
    if (projectData.showContour) {
      var shader = this._contourPickShader
  
      shader.bind()
      shader.uniforms = uniforms
  
      var vao = this._contourVAO
      vao.bind()
  
      for (j = 0; j < 3; ++j) {
        gl.lineWidth(this.contourWidth[j] * this.pixelRatio)
        shader.uniforms.permutation = PERMUTATIONS[j]
        for (i = 0; i < this.contourLevels[j].length; ++i) {
          if (this._contourCounts[j][i]) {
            shader.uniforms.height = this.contourLevels[j][i]
            vao.draw(gl.LINES, this._contourCounts[j][i], this._contourOffsets[j][i])
          }
        }
      }
  
      // Draw projections of surface
      for (i = 0; i < 3; ++i) {
        shader.uniforms.model = projectData.projections[i]
        shader.uniforms.clipBounds = projectData.clipBounds[i]
  
        for (j = 0; j < 3; ++j) {
          if (!this.contourProject[i][j]) {
            continue
          }
  
          shader.uniforms.permutation = PERMUTATIONS[j]
          gl.lineWidth(this.contourWidth[j] * this.pixelRatio)
          for (var k = 0; k < this.contourLevels[j].length; ++k) {
            if (this._contourCounts[j][k]) {
              shader.uniforms.height = this.contourLevels[j][k]
              vao.draw(gl.LINES, this._contourCounts[j][k], this._contourOffsets[j][k])
            }
          }
        }
      }
  
      vao.unbind()
    }
  }
  
  proto.pick = function (selection) {
    if (!selection) {
      return null
    }
  
    if (selection.id !== this.pickId) {
      return null
    }
  
    var shape = this._field[2].shape
  
    var result = this._pickResult
  
    // Compute uv coordinate
    var x = shape[0] * (selection.value[0] + (selection.value[2] >> 4) / 16.0) / 255.0
    var ix = Math.floor(x)
    var fx = x - ix
  
    var y = shape[1] * (selection.value[1] + (selection.value[2] & 15) / 16.0) / 255.0
    var iy = Math.floor(y)
    var fy = y - iy
  
    ix += 1
    iy += 1
  
    // Compute xyz coordinate
    var pos = result.position
    pos[0] = pos[1] = pos[2] = 0
    for (var dx = 0; dx < 2; ++dx) {
      var s = dx ? fx : 1.0 - fx
      for (var dy = 0; dy < 2; ++dy) {
        var t = dy ? fy : 1.0 - fy
  
        var r = ix + dx
        var c = iy + dy
        var w = s * t
  
        for (var i = 0; i < 3; ++i) {
          pos[i] += this._field[i].get(r, c) * w
        }
      }
    }
  
    // Find closest level
    var levelIndex = this._pickResult.level
    for (var j = 0; j < 3; ++j) {
      levelIndex[j] = bsearch.le(this.contourLevels[j], pos[j])
      if (levelIndex[j] < 0) {
        if (this.contourLevels[j].length > 0) {
          levelIndex[j] = 0
        }
      } else if (levelIndex[j] < this.contourLevels[j].length - 1) {
        var a = this.contourLevels[j][levelIndex[j]]
        var b = this.contourLevels[j][levelIndex[j] + 1]
        if (Math.abs(a - pos[j]) > Math.abs(b - pos[j])) {
          levelIndex[j] += 1
        }
      }
    }
  
    result.index[0] = fx < 0.5 ? ix : (ix + 1)
    result.index[1] = fy < 0.5 ? iy : (iy + 1)
  
    result.uv[0] = x / shape[0]
    result.uv[1] = y / shape[1]
  
    for (i = 0; i < 3; ++i) {
      result.dataCoordinate[i] = this._field[i].get(result.index[0], result.index[1])
    }
  
    return result
  }
  
  proto.padField = function(dstField, srcField) {
    var srcShape = srcField.shape.slice()
    var dstShape = dstField.shape.slice()
  
    // Center
    ops.assign(dstField.lo(1, 1).hi(srcShape[0], srcShape[1]), srcField)
  
    // Edges
    ops.assign(dstField.lo(1).hi(srcShape[0], 1),
      srcField.hi(srcShape[0], 1))
    ops.assign(dstField.lo(1, dstShape[1] - 1).hi(srcShape[0], 1),
      srcField.lo(0, srcShape[1] - 1).hi(srcShape[0], 1))
    ops.assign(dstField.lo(0, 1).hi(1, srcShape[1]),
      srcField.hi(1))
    ops.assign(dstField.lo(dstShape[0] - 1, 1).hi(1, srcShape[1]),
      srcField.lo(srcShape[0] - 1))
    // Corners
    dstField.set(0, 0, srcField.get(0, 0))
    dstField.set(0, dstShape[1] - 1, srcField.get(0, srcShape[1] - 1))
    dstField.set(dstShape[0] - 1, 0, srcField.get(srcShape[0] - 1, 0))
    dstField.set(dstShape[0] - 1, dstShape[1] - 1, srcField.get(srcShape[0] - 1, srcShape[1] - 1))
  }
  
  function handleArray (param, ctor) {
    if (Array.isArray(param)) {
      return [ ctor(param[0]), ctor(param[1]), ctor(param[2]) ]
    }
    return [ ctor(param), ctor(param), ctor(param) ]
  }
  
  function toColor (x) {
    if (Array.isArray(x)) {
      if (x.length === 3) {
        return [x[0], x[1], x[2], 1]
      }
      return [x[0], x[1], x[2], x[3]]
    }
    return [0, 0, 0, 1]
  }
  
  function handleColor (param) {
    if (Array.isArray(param)) {
      if (Array.isArray(param)) {
        return [
          toColor(param[0]),
          toColor(param[1]),
          toColor(param[2]) ]
      } else {
        var c = toColor(param)
        return [
          c.slice(),
          c.slice(),
          c.slice() ]
      }
    }
  }
  
  proto.update = function (params) {
    params = params || {}
  
    this.objectOffset = params.objectOffset || this.objectOffset
  
    this.dirty = true
  
    if ('contourWidth' in params) {
      this.contourWidth = handleArray(params.contourWidth, Number)
    }
    if ('showContour' in params) {
      this.showContour = handleArray(params.showContour, Boolean)
    }
    if ('showSurface' in params) {
      this.showSurface = !!params.showSurface
    }
    if ('contourTint' in params) {
      this.contourTint = handleArray(params.contourTint, Boolean)
    }
    if ('contourColor' in params) {
      this.contourColor = handleColor(params.contourColor)
    }
    if ('contourProject' in params) {
      this.contourProject = handleArray(params.contourProject, function (x) {
        return handleArray(x, Boolean)
      })
    }
    if ('surfaceProject' in params) {
      this.surfaceProject = params.surfaceProject
    }
    if ('dynamicColor' in params) {
      this.dynamicColor = handleColor(params.dynamicColor)
    }
    if ('dynamicTint' in params) {
      this.dynamicTint = handleArray(params.dynamicTint, Number)
    }
    if ('dynamicWidth' in params) {
      this.dynamicWidth = handleArray(params.dynamicWidth, Number)
    }
    if ('opacity' in params) {
      this.opacity = params.opacity
    }
    if('opacityscale' in params) {
      this.opacityscale = params.opacityscale
    }
    if ('colorBounds' in params) {
      this.colorBounds = params.colorBounds
    }
    if ('vertexColor' in params) {
      this.vertexColor = params.vertexColor ? 1 : 0;
    }
    if ('colormap' in params) {
      this._colorMap.setPixels(this.genColormap(params.colormap, this.opacityscale))
    }
  
    var field = params.field || (params.coords && params.coords[2]) || null
    var levelsChanged = false
  
    if (!field) {
      if (this._field[2].shape[0] || this._field[2].shape[2]) {
        field = this._field[2].lo(1, 1).hi(this._field[2].shape[0] - 2, this._field[2].shape[1] - 2)
      } else {
        field = this._field[2].hi(0, 0)
      }
    }
  
    // Update field
    if ('field' in params || 'coords' in params) {
      var fsize = (field.shape[0] + 2) * (field.shape[1] + 2)
  
      // Resize if necessary
      if (fsize > this._field[2].data.length) {
        pool.freeFloat(this._field[2].data)
        this._field[2].data = pool.mallocFloat(bits.nextPow2(fsize))
      }
  
      // Pad field
      this._field[2] = ndarray(this._field[2].data, [field.shape[0] + 2, field.shape[1] + 2])
      this.padField(this._field[2], field)
  
      // Save shape of field
      this.shape = field.shape.slice()
      var shape = this.shape
  
      // Resize coordinate fields if necessary
      for (var i = 0; i < 2; ++i) {
        if (this._field[2].size > this._field[i].data.length) {
          pool.freeFloat(this._field[i].data)
          this._field[i].data = pool.mallocFloat(this._field[2].size)
        }
        this._field[i] = ndarray(this._field[i].data, [shape[0] + 2, shape[1] + 2])
      }
  
      // Generate x/y coordinates
      if (params.coords) {
        var coords = params.coords
        if (!Array.isArray(coords) || coords.length !== 3) {
          throw new Error('gl-surface: invalid coordinates for x/y')
        }
        for (i = 0; i < 2; ++i) {
          var coord = coords[i]
          for (j = 0; j < 2; ++j) {
            if (coord.shape[j] !== shape[j]) {
              throw new Error('gl-surface: coords have incorrect shape')
            }
          }
          this.padField(this._field[i], coord)
        }
      } else if (params.ticks) {
        var ticks = params.ticks
        if (!Array.isArray(ticks) || ticks.length !== 2) {
          throw new Error('gl-surface: invalid ticks')
        }
        for (i = 0; i < 2; ++i) {
          var tick = ticks[i]
          if (Array.isArray(tick) || tick.length) {
            tick = ndarray(tick)
          }
          if (tick.shape[0] !== shape[i]) {
            throw new Error('gl-surface: invalid tick length')
          }
          // Make a copy view of the tick array
          var tick2 = ndarray(tick.data, shape)
          tick2.stride[i] = tick.stride[0]
          tick2.stride[i ^ 1] = 0
  
          // Fill in field array
          this.padField(this._field[i], tick2)
        }
      } else {
        for (i = 0; i < 2; ++i) {
          var offset = [0, 0]
          offset[i] = 1
          this._field[i] = ndarray(this._field[i].data, [shape[0] + 2, shape[1] + 2], offset, 0)
        }
        this._field[0].set(0, 0, 0)
        for (var j = 0; j < shape[0]; ++j) {
          this._field[0].set(j + 1, 0, j)
        }
        this._field[0].set(shape[0] + 1, 0, shape[0] - 1)
        this._field[1].set(0, 0, 0)
        for (j = 0; j < shape[1]; ++j) {
          this._field[1].set(0, j + 1, j)
        }
        this._field[1].set(0, shape[1] + 1, shape[1] - 1)
      }
  
      // Save shape
      var fields = this._field
  
      // Compute surface normals
      var dfields = ndarray(pool.mallocFloat(fields[2].size * 3 * 2), [3, shape[0] + 2, shape[1] + 2, 2])
      for (i = 0; i < 3; ++i) {
        gradient(dfields.pick(i), fields[i], 'mirror')
      }
      var normals = ndarray(pool.mallocFloat(fields[2].size * 3), [shape[0] + 2, shape[1] + 2, 3])
      for (i = 0; i < shape[0] + 2; ++i) {
        for (j = 0; j < shape[1] + 2; ++j) {
          var dxdu = dfields.get(0, i, j, 0)
          var dxdv = dfields.get(0, i, j, 1)
          var dydu = dfields.get(1, i, j, 0)
          var dydv = dfields.get(1, i, j, 1)
          var dzdu = dfields.get(2, i, j, 0)
          var dzdv = dfields.get(2, i, j, 1)
  
          var nx = dydu * dzdv - dydv * dzdu
          var ny = dzdu * dxdv - dzdv * dxdu
          var nz = dxdu * dydv - dxdv * dydu
  
          var nl = Math.sqrt(nx * nx + ny * ny + nz * nz)
          if (nl < 1e-8) {
            nl = Math.max(Math.abs(nx), Math.abs(ny), Math.abs(nz))
            if (nl < 1e-8) {
              nz = 1.0
              ny = nx = 0.0
              nl = 1.0
            } else {
              nl = 1.0 / nl
            }
          } else {
            nl = 1.0 / Math.sqrt(nl)
          }
  
          normals.set(i, j, 0, nx * nl)
          normals.set(i, j, 1, ny * nl)
          normals.set(i, j, 2, nz * nl)
        }
      }
      pool.free(dfields.data)
  
      // Initialize surface
      var lo = [ Infinity, Infinity, Infinity ]
      var hi = [ -Infinity, -Infinity, -Infinity ]
      var lo_intensity = Infinity
      var hi_intensity = -Infinity
      var count = (shape[0] - 1) * (shape[1] - 1) * 6
      var tverts = pool.mallocFloat(bits.nextPow2(10 * count))
      var tptr = 0
      var vertexCount = 0
      for (i = 0; i < shape[0] - 1; ++i) {
        j_loop:
        for (j = 0; j < shape[1] - 1; ++j) {
          // Test for NaNs
          for (var dx = 0; dx < 2; ++dx) {
            for (var dy = 0; dy < 2; ++dy) {
              for (var k = 0; k < 3; ++k) {
                var f = this._field[k].get(1 + i + dx, 1 + j + dy)
                if (isNaN(f) || !isFinite(f)) {
                  continue j_loop
                }
              }
            }
          }
          for (k = 0; k < 6; ++k) {
            var r = i + QUAD[k][0]
            var c = j + QUAD[k][1]
  
            var tx = this._field[0].get(r + 1, c + 1)
            var ty = this._field[1].get(r + 1, c + 1)
            f =      this._field[2].get(r + 1, c + 1)
  
            nx = normals.get(r + 1, c + 1, 0)
            ny = normals.get(r + 1, c + 1, 1)
            nz = normals.get(r + 1, c + 1, 2)
  
            if (params.intensity) {
              vf = params.intensity.get(r, c)
            }
  
            var vf = (params.intensity) ?
              params.intensity.get(r, c) :
              f + this.objectOffset[2];
  
            tverts[tptr++] = r
            tverts[tptr++] = c
            tverts[tptr++] = tx
            tverts[tptr++] = ty
            tverts[tptr++] = f
            tverts[tptr++] = 0
            tverts[tptr++] = vf
            tverts[tptr++] = nx
            tverts[tptr++] = ny
            tverts[tptr++] = nz
  
            lo[0] = Math.min(lo[0], tx + this.objectOffset[0])
            lo[1] = Math.min(lo[1], ty + this.objectOffset[1])
            lo[2] = Math.min(lo[2], f  + this.objectOffset[2])
            lo_intensity = Math.min(lo_intensity, vf)
  
            hi[0] = Math.max(hi[0], tx + this.objectOffset[0])
            hi[1] = Math.max(hi[1], ty + this.objectOffset[1])
            hi[2] = Math.max(hi[2], f  + this.objectOffset[2])
            hi_intensity = Math.max(hi_intensity, vf)
  
            vertexCount += 1
          }
        }
      }
  
      if (params.intensityBounds) {
        lo_intensity = +params.intensityBounds[0]
        hi_intensity = +params.intensityBounds[1]
      }
  
      // Scale all vertex intensities
      for (i = 6; i < tptr; i += 10) {
        tverts[i] = (tverts[i] - lo_intensity) / (hi_intensity - lo_intensity)
      }
  
      this._vertexCount = vertexCount
      this._coordinateBuffer.update(tverts.subarray(0, tptr))
      pool.freeFloat(tverts)
      pool.free(normals.data)
  
      // Update bounds
      this.bounds = [lo, hi]
  
      // Save intensity
      this.intensity = params.intensity || this._field[2]
  
      if(this.intensityBounds[0] !== lo_intensity || this.intensityBounds[1] !== hi_intensity) {
          levelsChanged = true
      }
  
      // Save intensity bound
      this.intensityBounds = [lo_intensity, hi_intensity]
    }
  
    // Update level crossings
    if ('levels' in params) {
      var levels = params.levels
      if (!Array.isArray(levels[0])) {
        levels = [ [], [], levels ]
      } else {
        levels = levels.slice()
      }
      for (i = 0; i < 3; ++i) {
        levels[i] = levels[i].slice()
        levels[i].sort(function (a, b) {
          return a - b
        })
      }
      for (i = 0; i < 3; ++i) {
        for (j = 0; j < levels[i].length; ++j) {
          levels[i][j] -= this.objectOffset[i]
        }
      }
      change_test:
      for (i = 0; i < 3; ++i) {
        if (levels[i].length !== this.contourLevels[i].length) {
          levelsChanged = true
          break
        }
        for (j = 0; j < levels[i].length; ++j) {
          if (levels[i][j] !== this.contourLevels[i][j]) {
            levelsChanged = true
            break change_test
          }
        }
      }
      this.contourLevels = levels
    }
  
    if (levelsChanged) {
      fields = this._field
      shape = this.shape
  
      // Update contour lines
      var contourVerts = []
  
      for (var dim = 0; dim < 3; ++dim) {
        var contourLevel = this.contourLevels[dim]
  
        var levelOffsets = []
        var levelCounts = []
  
        var parts = [0, 0, 0]
  
        for (i = 0; i < contourLevel.length; ++i) {
          var graph = surfaceNets(this._field[dim], contourLevel[i])
  
          levelOffsets.push((contourVerts.length / 5) | 0)
          vertexCount = 0
  
          edge_loop:
          for (j = 0; j < graph.cells.length; ++j) {
            var e = graph.cells[j]
            for (k = 0; k < 2; ++k) {
              var p = graph.positions[e[k]]
  
              var x = p[0]
              var ix = Math.floor(x) | 0
              var fx = x - ix
  
              var y = p[1]
              var iy = Math.floor(y) | 0
              var fy = y - iy
  
              var hole = false
              axis_loop:
              for (var axis = 0; axis < 3; ++axis) {
                parts[axis] = 0.0
                var iu = (dim + axis + 1) % 3
                for (dx = 0; dx < 2; ++dx) {
                  var s = dx ? fx : 1.0 - fx
                  r = Math.min(Math.max(ix + dx, 0), shape[0]) | 0
                  for (dy = 0; dy < 2; ++dy) {
                    var t = dy ? fy : 1.0 - fy
                    c = Math.min(Math.max(iy + dy, 0), shape[1]) | 0
  
                    if (axis < 2) {
                      f = this._field[iu].get(r, c)
                    } else {
                      f = (this.intensity.get(r, c) - this.intensityBounds[0]) / (this.intensityBounds[1] - this.intensityBounds[0])
                    }
                    if (!isFinite(f) || isNaN(f)) {
                      hole = true
                      break axis_loop
                    }
  
                    var w = s * t
                    parts[axis] += w * f
                  }
                }
              }
  
              if (!hole) {
                contourVerts.push(
                  parts[0],
                  parts[1],
                  p[0],
                  p[1],
                  parts[2]
                )
                vertexCount += 1
              } else {
                if (k > 0) {
                  // If we already added first edge, pop off verts
                  for (var l = 0; l < 5; ++l) {
                    contourVerts.pop()
                  }
                  vertexCount -= 1
                }
                continue edge_loop
              }
            }
          }
          levelCounts.push(vertexCount)
        }
  
        // Store results
        this._contourOffsets[dim] = levelOffsets
        this._contourCounts[dim] = levelCounts
  
      }
  
      var floatBuffer = pool.mallocFloat(contourVerts.length)
      for (i = 0; i < contourVerts.length; ++i) {
        floatBuffer[i] = contourVerts[i]
      }
      this._contourBuffer.update(floatBuffer)
      pool.freeFloat(floatBuffer)
    }
  }
  
  proto.dispose = function () {
    this._shader.dispose()
    this._vao.dispose()
    this._coordinateBuffer.dispose()
    this._colorMap.dispose()
    this._contourBuffer.dispose()
    this._contourVAO.dispose()
    this._contourShader.dispose()
    this._contourPickShader.dispose()
    this._dynamicBuffer.dispose()
    this._dynamicVAO.dispose()
    for (var i = 0; i < 3; ++i) {
      pool.freeFloat(this._field[i].data)
    }
  }
  
  proto.highlight = function (selection) {
    var i
  
    if (!selection) {
      this._dynamicCounts = [0, 0, 0]
      this.dyanamicLevel = [NaN, NaN, NaN]
      this.highlightLevel = [-1, -1, -1]
      return
    }
  
    for (i = 0; i < 3; ++i) {
      if (this.enableHighlight[i]) {
        this.highlightLevel[i] = selection.level[i]
      } else {
        this.highlightLevel[i] = -1
      }
    }
  
    var levels
    if (this.snapToData) {
      levels = selection.dataCoordinate
    } else {
      levels = selection.position
    }
    for (i = 0; i < 3; ++i) {
      levels[i] -= this.objectOffset[i]
    }
    if ((!this.enableDynamic[0] || levels[0] === this.dynamicLevel[0]) &&
      (!this.enableDynamic[1] || levels[1] === this.dynamicLevel[1]) &&
      (!this.enableDynamic[2] || levels[2] === this.dynamicLevel[2])) {
      return
    }
  
    var vertexCount = 0
    var shape = this.shape
    var scratchBuffer = pool.mallocFloat(12 * shape[0] * shape[1])
  
    for (var d = 0; d < 3; ++d) {
      if (!this.enableDynamic[d]) {
        this.dynamicLevel[d] = NaN
        this._dynamicCounts[d] = 0
        continue
      }
  
      this.dynamicLevel[d] = levels[d]
  
      var u = (d + 1) % 3
      var v = (d + 2) % 3
  
      var f = this._field[d]
      var g = this._field[u]
      var h = this._field[v]
  
      var graph = surfaceNets(f, levels[d])
      var edges = graph.cells
      var positions = graph.positions
  
      this._dynamicOffsets[d] = vertexCount
  
      for (i = 0; i < edges.length; ++i) {
        var e = edges[i]
        for (var j = 0; j < 2; ++j) {
          var p = positions[e[j]]
  
          var x = +p[0]
          var ix = x | 0
          var jx = Math.min(ix + 1, shape[0]) | 0
          var fx = x - ix
          var hx = 1.0 - fx
  
          var y = +p[1]
          var iy = y | 0
          var jy = Math.min(iy + 1, shape[1]) | 0
          var fy = y - iy
          var hy = 1.0 - fy
  
          var w00 = hx * hy
          var w01 = hx * fy
          var w10 = fx * hy
          var w11 = fx * fy
  
          var cu = w00 * g.get(ix, iy) +
            w01 * g.get(ix, jy) +
            w10 * g.get(jx, iy) +
            w11 * g.get(jx, jy)
  
          var cv = w00 * h.get(ix, iy) +
            w01 * h.get(ix, jy) +
            w10 * h.get(jx, iy) +
            w11 * h.get(jx, jy)
  
          if (isNaN(cu) || isNaN(cv)) {
            if (j) {
              vertexCount -= 1
            }
            break
          }
  
          scratchBuffer[2 * vertexCount + 0] = cu
          scratchBuffer[2 * vertexCount + 1] = cv
  
          vertexCount += 1
        }
      }
  
      this._dynamicCounts[d] = vertexCount - this._dynamicOffsets[d]
    }
  
    this._dynamicBuffer.update(scratchBuffer.subarray(0, 2 * vertexCount))
    pool.freeFloat(scratchBuffer)
  }
  
  function createSurfacePlot (params) {
    var gl = params.gl
  
    var shader = createShader(gl)
    var pickShader = createPickShader(gl)
    var contourShader = createContourShader(gl)
    var contourPickShader = createPickContourShader(gl)
  
    var coordinateBuffer = createBuffer(gl)
    var vao = createVAO(gl, [
      { buffer: coordinateBuffer,
        size: 4,
        stride: SURFACE_VERTEX_SIZE,
        offset: 0
      },
      { buffer: coordinateBuffer,
        size: 3,
        stride: SURFACE_VERTEX_SIZE,
        offset: 16
      },
      {
        buffer: coordinateBuffer,
        size: 3,
        stride: SURFACE_VERTEX_SIZE,
        offset: 28
      }
    ])
  
    var contourBuffer = createBuffer(gl)
    var contourVAO = createVAO(gl, [
      {
        buffer: contourBuffer,
        size: 4,
        stride: 20,
        offset: 0
      },
      {
        buffer: contourBuffer,
        size: 1,
        stride: 20,
        offset: 16
      }
    ])
  
    var dynamicBuffer = createBuffer(gl)
    var dynamicVAO = createVAO(gl, [
      {
        buffer: dynamicBuffer,
        size: 2,
        type: gl.FLOAT
      }])
  
    var cmap = createTexture(gl, 1, N_COLORS, gl.RGBA, gl.UNSIGNED_BYTE)
    cmap.minFilter = gl.LINEAR
    cmap.magFilter = gl.LINEAR
  
    var surface = new SurfacePlot(
      gl,
      [0, 0], // shape
      [[0, 0, 0], [0, 0, 0]], // bounds
      shader,
      pickShader,
      coordinateBuffer,
      vao,
      cmap,
      contourShader,
      contourPickShader,
      contourBuffer,
      contourVAO,
      dynamicBuffer,
      dynamicVAO,
      [0, 0, 0] // objectOffset
    )
  
    var nparams = {
      levels: [[], [], []]
    }
    for (var id in params) {
      nparams[id] = params[id]
    }
    nparams.colormap = nparams.colormap || 'jet'
  
    surface.update(nparams)
  
    return surface
  }
  
  },{"./lib/shaders":324,"binary-search-bounds":96,"bit-twiddle":97,"colormap":131,"gl-buffer":258,"gl-mat4/invert":278,"gl-mat4/multiply":280,"gl-texture2d":327,"gl-vao":332,"ndarray":469,"ndarray-gradient":462,"ndarray-ops":464,"ndarray-pack":465,"surface-nets":542,"typedarray-pool":567}],326:[function(_dereq_,module,exports){
  'use strict'
  
  var Font = _dereq_('css-font')
  var pick = _dereq_('pick-by-alias')
  var createRegl = _dereq_('regl')
  var createGl = _dereq_('gl-util/context')
  var WeakMap = _dereq_('es6-weak-map')
  var rgba = _dereq_('color-normalize')
  var fontAtlas = _dereq_('font-atlas')
  var pool = _dereq_('typedarray-pool')
  var parseRect = _dereq_('parse-rect')
  var isObj = _dereq_('is-plain-obj')
  var parseUnit = _dereq_('parse-unit')
  var px = _dereq_('to-px')
  var kerning = _dereq_('detect-kerning')
  var extend = _dereq_('object-assign')
  var metrics = _dereq_('font-measure')
  var flatten = _dereq_('flatten-vertex-data')
  var ref = _dereq_('bit-twiddle');
  var nextPow2 = ref.nextPow2;
  
  var shaderCache = new WeakMap
  
  
  // Safari does not support font-stretch
  var isStretchSupported = false
  if (document.body) {
      var el = document.body.appendChild(document.createElement('div'))
      el.style.font = 'italic small-caps bold condensed 16px/2 cursive'
      if (getComputedStyle(el).fontStretch) {
          isStretchSupported = true
      }
      document.body.removeChild(el)
  }
  
  var GlText = function GlText (o) {
    if (isRegl(o)) {
      o = {regl: o}
      this.gl = o.regl._gl
    }
    else {
      this.gl = createGl(o)
    }
  
    this.shader = shaderCache.get(this.gl)
  
    if (!this.shader) {
      this.regl = o.regl || createRegl({ gl: this.gl })
    }
    else {
      this.regl = this.shader.regl
    }
  
    this.charBuffer = this.regl.buffer({ type: 'uint8', usage: 'stream' })
    this.sizeBuffer = this.regl.buffer({ type: 'float', usage: 'stream' })
  
    if (!this.shader) {
      this.shader = this.createShader()
      shaderCache.set(this.gl, this.shader)
    }
  
    this.batch = []
  
    // multiple options initial state
    this.fontSize = []
    this.font = []
    this.fontAtlas = []
  
    this.draw = this.shader.draw.bind(this)
    this.render = function () {
      // FIXME: add Safari regl report here:
      // charBuffer and width just do not trigger
      this.regl._refresh()
      this.draw(this.batch)
    }
    this.canvas = this.gl.canvas
  
    this.update(isObj(o) ? o : {})
  };
  
  GlText.prototype.createShader = function createShader () {
    var regl = this.regl
  
    // FIXME: store 2 shader versions: with normal viewport and without
    // draw texture method
    var draw = regl({
      blend: {
        enable: true,
        color: [0,0,0,1],
  
        func: {
          srcRGB: 'src alpha',
          dstRGB: 'one minus src alpha',
          srcAlpha: 'one minus dst alpha',
          dstAlpha: 'one'
        }
      },
      stencil: {enable: false},
      depth: {enable: false},
  
      count: regl.prop('count'),
      offset: regl.prop('offset'),
      attributes: {
        charOffset: {
          offset: 4,
          stride: 8,
          buffer: regl.this('sizeBuffer')
        },
        width: {
          offset: 0,
          stride: 8,
          buffer: regl.this('sizeBuffer')
        },
        char: regl.this('charBuffer'),
        position: regl.this('position')
      },
      uniforms: {
        atlasSize: function (c, p) { return [p.atlas.width, p.atlas.height]; },
        atlasDim: function (c, p) { return [p.atlas.cols, p.atlas.rows]; },
        atlas: function (c, p) { return p.atlas.texture; },
        charStep: function (c, p) { return p.atlas.step; },
        em: function (c, p) { return p.atlas.em; },
        color: regl.prop('color'),
        opacity: regl.prop('opacity'),
        viewport: regl.this('viewportArray'),
        scale: regl.this('scale'),
        align: regl.prop('align'),
        baseline: regl.prop('baseline'),
        translate: regl.this('translate'),
        positionOffset: regl.prop('positionOffset')
      },
      primitive: 'points',
      viewport: regl.this('viewport'),
  
      vert: ("\n\t\t\tprecision highp float;\n\t\t\tattribute float width, charOffset, char;\n\t\t\tattribute vec2 position;\n\t\t\tuniform float fontSize, charStep, em, align, baseline;\n\t\t\tuniform vec4 viewport;\n\t\t\tuniform vec4 color;\n\t\t\tuniform vec2 atlasSize, atlasDim, scale, translate, positionOffset;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvoid main () {\n\t\t\t\t" + (!GlText.normalViewport ? 'vec2 positionOffset = vec2(positionOffset.x,- positionOffset.y);' : '') + "\n\n\t\t\t\tvec2 offset = floor(em * (vec2(align + charOffset, baseline)\n\t\t\t\t\t+ positionOffset))\n\t\t\t\t\t/ (viewport.zw * scale.xy);\n\n\t\t\t\tvec2 position = (position + translate) * scale;\n\t\t\t\tposition += offset * scale;\n\n\t\t\t\t" + (GlText.normalViewport ? 'position.y = 1. - position.y;' : '') + "\n\n\t\t\t\tcharCoord = position * viewport.zw + viewport.xy;\n\n\t\t\t\tgl_Position = vec4(position * 2. - 1., 0, 1);\n\n\t\t\t\tgl_PointSize = charStep;\n\n\t\t\t\tcharId.x = mod(char, atlasDim.x);\n\t\t\t\tcharId.y = floor(char / atlasDim.x);\n\n\t\t\t\tcharWidth = width * em;\n\n\t\t\t\tfontColor = color / 255.;\n\t\t\t}"),
  
      frag: "\n\t\t\tprecision highp float;\n\t\t\tuniform sampler2D atlas;\n\t\t\tuniform float fontSize, charStep, opacity;\n\t\t\tuniform vec2 atlasSize;\n\t\t\tuniform vec4 viewport;\n\t\t\tvarying vec4 fontColor;\n\t\t\tvarying vec2 charCoord, charId;\n\t\t\tvarying float charWidth;\n\n\t\t\tfloat lightness(vec4 color) {\n\t\t\t\treturn color.r * 0.299 + color.g * 0.587 + color.b * 0.114;\n\t\t\t}\n\n\t\t\tvoid main () {\n\t\t\t\tvec2 uv = gl_FragCoord.xy - charCoord + charStep * .5;\n\t\t\t\tfloat halfCharStep = floor(charStep * .5 + .5);\n\n\t\t\t\t// invert y and shift by 1px (FF expecially needs that)\n\t\t\t\tuv.y = charStep - uv.y;\n\n\t\t\t\t// ignore points outside of character bounding box\n\t\t\t\tfloat halfCharWidth = ceil(charWidth * .5);\n\t\t\t\tif (floor(uv.x) > halfCharStep + halfCharWidth ||\n\t\t\t\t\tfloor(uv.x) < halfCharStep - halfCharWidth) return;\n\n\t\t\t\tuv += charId * charStep;\n\t\t\t\tuv = uv / atlasSize;\n\n\t\t\t\tvec4 color = fontColor;\n\t\t\t\tvec4 mask = texture2D(atlas, uv);\n\n\t\t\t\tfloat maskY = lightness(mask);\n\t\t\t\t// float colorY = lightness(color);\n\t\t\t\tcolor.a *= maskY;\n\t\t\t\tcolor.a *= opacity;\n\n\t\t\t\t// color.a += .1;\n\n\t\t\t\t// antialiasing, see yiq color space y-channel formula\n\t\t\t\t// color.rgb += (1. - color.rgb) * (1. - mask.rgb);\n\n\t\t\t\tgl_FragColor = color;\n\t\t\t}"
    })
  
    // per font-size atlas
    var atlas = {}
  
    return { regl: regl, draw: draw, atlas: atlas }
  };
  
  GlText.prototype.update = function update (o) {
      var this$1 = this;
  
    if (typeof o === 'string') { o = { text: o } }
    else if (!o) { return }
  
    // FIXME: make this a static transform or more general approact
    o = pick(o, {
      position: 'position positions coord coords coordinates',
      font: 'font fontFace fontface typeface cssFont css-font family fontFamily',
      fontSize: 'fontSize fontsize size font-size',
      text: 'text texts chars characters value values symbols',
      align: 'align alignment textAlign textbaseline',
      baseline: 'baseline textBaseline textbaseline',
      direction: 'dir direction textDirection',
      color: 'color colour fill fill-color fillColor textColor textcolor',
      kerning: 'kerning kern',
      range: 'range dataBox',
      viewport: 'vp viewport viewBox viewbox viewPort',
      opacity: 'opacity alpha transparency visible visibility opaque',
      offset: 'offset positionOffset padding shift indent indentation'
    }, true)
  
  
    if (o.opacity != null) {
      if (Array.isArray(o.opacity)) {
        this.opacity = o.opacity.map(function (o) { return parseFloat(o); })
      }
      else {
        this.opacity = parseFloat(o.opacity)
      }
    }
  
    if (o.viewport != null) {
      this.viewport = parseRect(o.viewport)
  
      if (GlText.normalViewport) {
        this.viewport.y = this.canvas.height - this.viewport.y - this.viewport.height
      }
  
      this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height]
  
    }
    if (this.viewport == null) {
      this.viewport = {
        x: 0, y: 0,
        width: this.gl.drawingBufferWidth,
        height: this.gl.drawingBufferHeight
      }
      this.viewportArray = [this.viewport.x, this.viewport.y, this.viewport.width, this.viewport.height]
    }
  
    if (o.kerning != null) { this.kerning = o.kerning }
  
    if (o.offset != null) {
      if (typeof o.offset === 'number') { o.offset = [o.offset, 0] }
  
      this.positionOffset = flatten(o.offset)
    }
  
    if (o.direction) { this.direction = o.direction }
  
    if (o.range) {
      this.range = o.range
      this.scale = [1 / (o.range[2] - o.range[0]), 1 / (o.range[3] - o.range[1])]
      this.translate = [-o.range[0], -o.range[1]]
    }
    if (o.scale) { this.scale = o.scale }
    if (o.translate) { this.translate = o.translate }
  
    // default scale corresponds to viewport
    if (!this.scale) { this.scale = [1 / this.viewport.width, 1 / this.viewport.height] }
  
    if (!this.translate) { this.translate = [0, 0] }
  
    if (!this.font.length && !o.font) { o.font = GlText.baseFontSize + 'px sans-serif' }
  
    // normalize font caching string
    var newFont = false, newFontSize = false
  
    // obtain new font data
    if (o.font) {
      (Array.isArray(o.font) ? o.font : [o.font]).forEach(function (font, i) {
        // normalize font
        if (typeof font === 'string') {
          try {
            font = Font.parse(font)
          } catch (e) {
            font = Font.parse(GlText.baseFontSize + 'px ' + font)
          }
        }
        else { font = Font.parse(Font.stringify(font)) }
  
        var baseString = Font.stringify({
          size: GlText.baseFontSize,
          family: font.family,
          stretch: isStretchSupported ? font.stretch : undefined,
          variant: font.variant,
          weight: font.weight,
          style: font.style
        })
  
        var unit = parseUnit(font.size)
        var fs = Math.round(unit[0] * px(unit[1]))
        if (fs !== this$1.fontSize[i]) {
          newFontSize = true
          this$1.fontSize[i] = fs
        }
  
        // calc new font metrics/atlas
        if (!this$1.font[i] || baseString != this$1.font[i].baseString) {
          newFont = true
  
          // obtain font cache or create one
          this$1.font[i] = GlText.fonts[baseString]
          if (!this$1.font[i]) {
            var family = font.family.join(', ')
            var style = [font.style]
            if (font.style != font.variant) { style.push(font.variant) }
            if (font.variant != font.weight) { style.push(font.weight) }
            if (isStretchSupported && font.weight != font.stretch) { style.push(font.stretch) }
  
            this$1.font[i] = {
              baseString: baseString,
  
              // typeface
              family: family,
              weight: font.weight,
              stretch: font.stretch,
              style: font.style,
              variant: font.variant,
  
              // widths of characters
              width: {},
  
              // kernin pairs offsets
              kerning: {},
  
              metrics: metrics(family, {
                origin: 'top',
                fontSize: GlText.baseFontSize,
                fontStyle: style.join(' ')
              })
            }
  
            GlText.fonts[baseString] = this$1.font[i]
          }
        }
      })
    }
  
    // FIXME: make independend font-size
    // if (o.fontSize) {
    // let unit = parseUnit(o.fontSize)
    // let fs = Math.round(unit[0] * px(unit[1]))
  
    // if (fs != this.fontSize) {
    // 	newFontSize = true
    // 	this.fontSize = fs
    // }
    // }
  
    if (newFont || newFontSize) {
      this.font.forEach(function (font, i) {
        var fontString = Font.stringify({
          size: this$1.fontSize[i],
          family: font.family,
          stretch: isStretchSupported ? font.stretch : undefined,
          variant: font.variant,
          weight: font.weight,
          style: font.style
        })
  
        // calc new font size atlas
        this$1.fontAtlas[i] = this$1.shader.atlas[fontString]
  
        if (!this$1.fontAtlas[i]) {
          var metrics = font.metrics
  
          this$1.shader.atlas[fontString] =
          this$1.fontAtlas[i] = {
            fontString: fontString,
            // even step is better for rendered characters
            step: Math.ceil(this$1.fontSize[i] * metrics.bottom * .5) * 2,
            em: this$1.fontSize[i],
            cols: 0,
            rows: 0,
            height: 0,
            width: 0,
            chars: [],
            ids: {},
            texture: this$1.regl.texture()
          }
        }
  
        // bump atlas characters
        if (o.text == null) { o.text = this$1.text }
      })
    }
  
    // if multiple positions - duplicate text arguments
    // FIXME: this possibly can be done better to avoid array spawn
    if (typeof o.text === 'string' && o.position && o.position.length > 2) {
      var textArray = Array(o.position.length * .5)
      for (var i = 0; i < textArray.length; i++) {
        textArray[i] = o.text
      }
      o.text = textArray
    }
  
    // calculate offsets for the new font/text
    var newAtlasChars
    if (o.text != null || newFont) {
      // FIXME: ignore spaces
      // text offsets within the text buffer
      this.textOffsets = [0]
  
      if (Array.isArray(o.text)) {
        this.count = o.text[0].length
        this.counts = [this.count]
        for (var i$1 = 1; i$1 < o.text.length; i$1++) {
          this.textOffsets[i$1] = this.textOffsets[i$1 - 1] + o.text[i$1 - 1].length
          this.count += o.text[i$1].length
          this.counts.push(o.text[i$1].length)
        }
        this.text = o.text.join('')
      }
      else {
        this.text = o.text
        this.count = this.text.length
        this.counts = [this.count]
      }
  
      newAtlasChars = []
  
      // detect & measure new characters
      this.font.forEach(function (font, idx) {
        GlText.atlasContext.font = font.baseString
  
        var atlas = this$1.fontAtlas[idx]
  
        for (var i = 0; i < this$1.text.length; i++) {
          var char = this$1.text.charAt(i)
  
          if (atlas.ids[char] == null) {
            atlas.ids[char] = atlas.chars.length
            atlas.chars.push(char)
            newAtlasChars.push(char)
          }
  
          if (font.width[char] == null) {
            font.width[char] = GlText.atlasContext.measureText(char).width / GlText.baseFontSize
  
            // measure kerning pairs for the new character
            if (this$1.kerning) {
              var pairs = []
              for (var baseChar in font.width) {
                pairs.push(baseChar + char, char + baseChar)
              }
              extend(font.kerning, kerning(font.family, {
                pairs: pairs
              }))
            }
          }
        }
      })
    }
  
    // create single position buffer (faster than batch or multiple separate instances)
    if (o.position) {
      if (o.position.length > 2) {
        var flat = !o.position[0].length
        var positionData = pool.mallocFloat(this.count * 2)
        for (var i$2 = 0, ptr = 0; i$2 < this.counts.length; i$2++) {
          var count = this.counts[i$2]
          if (flat) {
            for (var j = 0; j < count; j++) {
              positionData[ptr++] = o.position[i$2 * 2]
              positionData[ptr++] = o.position[i$2 * 2 + 1]
            }
          }
          else {
            for (var j$1 = 0; j$1 < count; j$1++) {
              positionData[ptr++] = o.position[i$2][0]
              positionData[ptr++] = o.position[i$2][1]
            }
          }
        }
        if (this.position.call) {
          this.position({
            type: 'float',
            data: positionData
          })
        } else {
          this.position = this.regl.buffer({
            type: 'float',
            data: positionData
          })
        }
        pool.freeFloat(positionData)
      }
      else {
        if (this.position.destroy) { this.position.destroy() }
        this.position = {
          constant: o.position
        }
      }
    }
  
    // populate text/offset buffers if font/text has changed
    // as [charWidth, offset, charWidth, offset...]
    // that is in em units since font-size can change often
    if (o.text || newFont) {
      var charIds = pool.mallocUint8(this.count)
      var sizeData = pool.mallocFloat(this.count * 2)
      this.textWidth = []
  
      for (var i$3 = 0, ptr$1 = 0; i$3 < this.counts.length; i$3++) {
        var count$1 = this.counts[i$3]
        var font = this.font[i$3] || this.font[0]
        var atlas = this.fontAtlas[i$3] || this.fontAtlas[0]
  
        for (var j$2 = 0; j$2 < count$1; j$2++) {
          var char = this.text.charAt(ptr$1)
          var prevChar = this.text.charAt(ptr$1 - 1)
  
          charIds[ptr$1] = atlas.ids[char]
          sizeData[ptr$1 * 2] = font.width[char]
  
          if (j$2) {
            var prevWidth = sizeData[ptr$1 * 2 - 2]
            var currWidth = sizeData[ptr$1 * 2]
            var prevOffset = sizeData[ptr$1 * 2 - 1]
            var offset = prevOffset + prevWidth * .5 + currWidth * .5;
  
            if (this.kerning) {
              var kerning$1 = font.kerning[prevChar + char]
              if (kerning$1) {
                offset += kerning$1 * 1e-3
              }
            }
  
            sizeData[ptr$1 * 2 + 1] = offset
          }
          else {
            sizeData[ptr$1 * 2 + 1] = sizeData[ptr$1 * 2] * .5
          }
  
          ptr$1++
        }
        this.textWidth.push(
          !sizeData.length ? 0 :
          // last offset + half last width
          sizeData[ptr$1 * 2 - 2] * .5 + sizeData[ptr$1 * 2 - 1]
        )
      }
  
  
      // bump recalc align offset
      if (!o.align) { o.align = this.align }
      this.charBuffer({data: charIds, type: 'uint8', usage: 'stream'})
      this.sizeBuffer({data: sizeData, type: 'float', usage: 'stream'})
      pool.freeUint8(charIds)
      pool.freeFloat(sizeData)
  
      // udpate font atlas and texture
      if (newAtlasChars.length) {
        this.font.forEach(function (font, i) {
          var atlas = this$1.fontAtlas[i]
  
          // FIXME: insert metrics-based ratio here
          var step = atlas.step
  
          var maxCols = Math.floor(GlText.maxAtlasSize / step)
          var cols = Math.min(maxCols, atlas.chars.length)
          var rows = Math.ceil(atlas.chars.length / cols)
  
          var atlasWidth = nextPow2( cols * step )
          // let atlasHeight = Math.min(rows * step + step * .5, GlText.maxAtlasSize);
          var atlasHeight = nextPow2( rows * step );
  
          atlas.width = atlasWidth
          atlas.height = atlasHeight;
          atlas.rows = rows
          atlas.cols = cols
  
          if (!atlas.em) { return }
  
          atlas.texture({
            data: fontAtlas({
              canvas: GlText.atlasCanvas,
              font: atlas.fontString,
              chars: atlas.chars,
              shape: [atlasWidth, atlasHeight],
              step: [step, step]
            })
          })
  
        })
      }
    }
  
    if (o.align) {
      this.align = o.align
      this.alignOffset = this.textWidth.map(function (textWidth, i) {
        var align = !Array.isArray(this$1.align) ? this$1.align : this$1.align.length > 1 ? this$1.align[i] : this$1.align[0]
  
        if (typeof align === 'number') { return align }
        switch (align) {
          case 'right':
          case 'end':
            return -textWidth
          case 'center':
          case 'centre':
          case 'middle':
            return -textWidth * .5
        }
  
        return 0
      })
    }
  
    if (this.baseline == null && o.baseline == null) {
      o.baseline = 0
    }
    if (o.baseline != null) {
      this.baseline = o.baseline
      if (!Array.isArray(this.baseline)) { this.baseline = [this.baseline] }
      this.baselineOffset = this.baseline.map(function (baseline, i) {
        var m = (this$1.font[i] || this$1.font[0]).metrics
        var base = 0
  
        base += m.bottom * .5
  
        if (typeof baseline === 'number') {
          base += (baseline - m.baseline)
        }
        else {
          base += -m[baseline]
        }
  
        if (!GlText.normalViewport) { base *= -1 }
        return base
      })
    }
  
    // flatten colors to a single uint8 array
    if (o.color != null) {
      if (!o.color) { o.color = 'transparent' }
  
      // single color
      if (typeof o.color === 'string' || !isNaN(o.color)) {
        this.color = rgba(o.color, 'uint8')
      }
      // array
      else {
        var colorData
  
        // flat array
        if (typeof o.color[0] === 'number' && o.color.length > this.counts.length) {
          var l = o.color.length
          colorData = pool.mallocUint8(l)
          var sub = (o.color.subarray || o.color.slice).bind(o.color)
          for (var i$4 = 0; i$4 < l; i$4 += 4) {
            colorData.set(rgba(sub(i$4, i$4 + 4), 'uint8'), i$4)
          }
        }
        // nested array
        else {
          var l$1 = o.color.length
          colorData = pool.mallocUint8(l$1 * 4)
          for (var i$5 = 0; i$5 < l$1; i$5++) {
            colorData.set(rgba(o.color[i$5] || 0, 'uint8'), i$5 * 4)
          }
        }
  
        this.color = colorData
      }
    }
  
    // update render batch
    if (o.position || o.text || o.color || o.baseline || o.align || o.font || o.offset || o.opacity) {
      var isBatch = (this.color.length > 4)
        || (this.baselineOffset.length > 1)
        || (this.align && this.align.length > 1)
        || (this.fontAtlas.length > 1)
        || (this.positionOffset.length > 2)
      if (isBatch) {
        var length = Math.max(
          this.position.length * .5 || 0,
          this.color.length * .25 || 0,
          this.baselineOffset.length || 0,
          this.alignOffset.length || 0,
          this.font.length || 0,
          this.opacity.length || 0,
          this.positionOffset.length * .5 || 0
        )
        this.batch = Array(length)
        for (var i$6 = 0; i$6 < this.batch.length; i$6++) {
          this.batch[i$6] = {
            count: this.counts.length > 1 ? this.counts[i$6] : this.counts[0],
            offset: this.textOffsets.length > 1 ? this.textOffsets[i$6] : this.textOffsets[0],
            color: !this.color ? [0,0,0,255] : this.color.length <= 4 ? this.color : this.color.subarray(i$6 * 4, i$6 * 4 + 4),
            opacity: Array.isArray(this.opacity) ? this.opacity[i$6] : this.opacity,
            baseline: this.baselineOffset[i$6] != null ? this.baselineOffset[i$6] : this.baselineOffset[0],
            align: !this.align ? 0 : this.alignOffset[i$6] != null ? this.alignOffset[i$6] : this.alignOffset[0],
            atlas: this.fontAtlas[i$6] || this.fontAtlas[0],
            positionOffset: this.positionOffset.length > 2 ? this.positionOffset.subarray(i$6 * 2, i$6 * 2 + 2) : this.positionOffset
          }
        }
      }
      // single-color, single-baseline, single-align batch is faster to render
      else {
        if (this.count) {
          this.batch = [{
            count: this.count,
            offset: 0,
            color: this.color || [0,0,0,255],
            opacity: Array.isArray(this.opacity) ? this.opacity[0] : this.opacity,
            baseline: this.baselineOffset[0],
            align: this.alignOffset ? this.alignOffset[0] : 0,
            atlas: this.fontAtlas[0],
            positionOffset: this.positionOffset
          }]
        }
        else {
          this.batch = []
        }
      }
    }
  };
  
  GlText.prototype.destroy = function destroy () {
    // TODO: count instances of atlases and destroy all on null
  };
  
  
  // defaults
  GlText.prototype.kerning = true
  GlText.prototype.position = { constant: new Float32Array(2) }
  GlText.prototype.translate = null
  GlText.prototype.scale = null
  GlText.prototype.font = null
  GlText.prototype.text = ''
  GlText.prototype.positionOffset = [0, 0]
  GlText.prototype.opacity = 1
  GlText.prototype.color = new Uint8Array([0, 0, 0, 255])
  GlText.prototype.alignOffset = [0, 0]
  
  
  // whether viewport should be top↓bottom 2d one (true) or webgl one (false)
  GlText.normalViewport = false
  
  // size of an atlas
  GlText.maxAtlasSize = 1024
  
  // font atlas canvas is singleton
  GlText.atlasCanvas = document.createElement('canvas')
  GlText.atlasContext = GlText.atlasCanvas.getContext('2d', {alpha: false})
  
  // font-size used for metrics, atlas step calculation
  GlText.baseFontSize = 64
  
  // fonts storage
  GlText.fonts = {}
  
  // max number of different font atlases/textures cached
  // FIXME: enable atlas size limitation via LRU
  // GlText.atlasCacheSize = 64
  
  function isRegl (o) {
    return typeof o === 'function' &&
    o._gl &&
    o.prop &&
    o.texture &&
    o.buffer
  }
  
  
  module.exports = GlText
  
  
  },{"bit-twiddle":97,"color-normalize":125,"css-font":144,"detect-kerning":172,"es6-weak-map":233,"flatten-vertex-data":244,"font-atlas":245,"font-measure":246,"gl-util/context":328,"is-plain-obj":443,"object-assign":473,"parse-rect":478,"parse-unit":480,"pick-by-alias":485,"regl":512,"to-px":550,"typedarray-pool":567}],327:[function(_dereq_,module,exports){
  'use strict'
  
  var ndarray = _dereq_('ndarray')
  var ops     = _dereq_('ndarray-ops')
  var pool    = _dereq_('typedarray-pool')
  
  module.exports = createTexture2D
  
  var linearTypes = null
  var filterTypes = null
  var wrapTypes   = null
  
  function lazyInitLinearTypes(gl) {
    linearTypes = [
      gl.LINEAR,
      gl.NEAREST_MIPMAP_LINEAR,
      gl.LINEAR_MIPMAP_NEAREST,
      gl.LINEAR_MIPMAP_NEAREST
    ]
    filterTypes = [
      gl.NEAREST,
      gl.LINEAR,
      gl.NEAREST_MIPMAP_NEAREST,
      gl.NEAREST_MIPMAP_LINEAR,
      gl.LINEAR_MIPMAP_NEAREST,
      gl.LINEAR_MIPMAP_LINEAR
    ]
    wrapTypes = [
      gl.REPEAT,
      gl.CLAMP_TO_EDGE,
      gl.MIRRORED_REPEAT
    ]
  }
  
  function acceptTextureDOM (obj) {
    return (
      ('undefined' != typeof HTMLCanvasElement && obj instanceof HTMLCanvasElement) ||
      ('undefined' != typeof HTMLImageElement && obj instanceof HTMLImageElement) ||
      ('undefined' != typeof HTMLVideoElement && obj instanceof HTMLVideoElement) ||
      ('undefined' != typeof ImageData && obj instanceof ImageData))
  }
  
  var convertFloatToUint8 = function(out, inp) {
    ops.muls(out, inp, 255.0)
  }
  
  function reshapeTexture(tex, w, h) {
    var gl = tex.gl
    var maxSize = gl.getParameter(gl.MAX_TEXTURE_SIZE)
    if(w < 0 || w > maxSize || h < 0 || h > maxSize) {
      throw new Error('gl-texture2d: Invalid texture size')
    }
    tex._shape = [w, h]
    tex.bind()
    gl.texImage2D(gl.TEXTURE_2D, 0, tex.format, w, h, 0, tex.format, tex.type, null)
    tex._mipLevels = [0]
    return tex
  }
  
  function Texture2D(gl, handle, width, height, format, type) {
    this.gl = gl
    this.handle = handle
    this.format = format
    this.type = type
    this._shape = [width, height]
    this._mipLevels = [0]
    this._magFilter = gl.NEAREST
    this._minFilter = gl.NEAREST
    this._wrapS = gl.CLAMP_TO_EDGE
    this._wrapT = gl.CLAMP_TO_EDGE
    this._anisoSamples = 1
  
    var parent = this
    var wrapVector = [this._wrapS, this._wrapT]
    Object.defineProperties(wrapVector, [
      {
        get: function() {
          return parent._wrapS
        },
        set: function(v) {
          return parent.wrapS = v
        }
      },
      {
        get: function() {
          return parent._wrapT
        },
        set: function(v) {
          return parent.wrapT = v
        }
      }
    ])
    this._wrapVector = wrapVector
  
    var shapeVector = [this._shape[0], this._shape[1]]
    Object.defineProperties(shapeVector, [
      {
        get: function() {
          return parent._shape[0]
        },
        set: function(v) {
          return parent.width = v
        }
      },
      {
        get: function() {
          return parent._shape[1]
        },
        set: function(v) {
          return parent.height = v
        }
      }
    ])
    this._shapeVector = shapeVector
  }
  
  var proto = Texture2D.prototype
  
  Object.defineProperties(proto, {
    minFilter: {
      get: function() {
        return this._minFilter
      },
      set: function(v) {
        this.bind()
        var gl = this.gl
        if(this.type === gl.FLOAT && linearTypes.indexOf(v) >= 0) {
          if(!gl.getExtension('OES_texture_float_linear')) {
            v = gl.NEAREST
          }
        }
        if(filterTypes.indexOf(v) < 0) {
          throw new Error('gl-texture2d: Unknown filter mode ' + v)
        }
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, v)
        return this._minFilter = v
      }
    },
    magFilter: {
      get: function() {
        return this._magFilter
      },
      set: function(v) {
        this.bind()
        var gl = this.gl
        if(this.type === gl.FLOAT && linearTypes.indexOf(v) >= 0) {
          if(!gl.getExtension('OES_texture_float_linear')) {
            v = gl.NEAREST
          }
        }
        if(filterTypes.indexOf(v) < 0) {
          throw new Error('gl-texture2d: Unknown filter mode ' + v)
        }
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, v)
        return this._magFilter = v
      }
    },
    mipSamples: {
      get: function() {
        return this._anisoSamples
      },
      set: function(i) {
        var psamples = this._anisoSamples
        this._anisoSamples = Math.max(i, 1)|0
        if(psamples !== this._anisoSamples) {
          var ext = this.gl.getExtension('EXT_texture_filter_anisotropic')
          if(ext) {
            this.gl.texParameterf(this.gl.TEXTURE_2D, ext.TEXTURE_MAX_ANISOTROPY_EXT, this._anisoSamples)
          }
        }
        return this._anisoSamples
      }
    },
    wrapS: {
      get: function() {
        return this._wrapS
      },
      set: function(v) {
        this.bind()
        if(wrapTypes.indexOf(v) < 0) {
          throw new Error('gl-texture2d: Unknown wrap mode ' + v)
        }
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, v)
        return this._wrapS = v
      }
    },
    wrapT: {
      get: function() {
        return this._wrapT
      },
      set: function(v) {
        this.bind()
        if(wrapTypes.indexOf(v) < 0) {
          throw new Error('gl-texture2d: Unknown wrap mode ' + v)
        }
        this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, v)
        return this._wrapT = v
      }
    },
    wrap: {
      get: function() {
        return this._wrapVector
      },
      set: function(v) {
        if(!Array.isArray(v)) {
          v = [v,v]
        }
        if(v.length !== 2) {
          throw new Error('gl-texture2d: Must specify wrap mode for rows and columns')
        }
        for(var i=0; i<2; ++i) {
          if(wrapTypes.indexOf(v[i]) < 0) {
            throw new Error('gl-texture2d: Unknown wrap mode ' + v)
          }
        }
        this._wrapS = v[0]
        this._wrapT = v[1]
  
        var gl = this.gl
        this.bind()
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, this._wrapS)
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, this._wrapT)
  
        return v
      }
    },
    shape: {
      get: function() {
        return this._shapeVector
      },
      set: function(x) {
        if(!Array.isArray(x)) {
          x = [x|0,x|0]
        } else {
          if(x.length !== 2) {
            throw new Error('gl-texture2d: Invalid texture shape')
          }
        }
        reshapeTexture(this, x[0]|0, x[1]|0)
        return [x[0]|0, x[1]|0]
      }
    },
    width: {
      get: function() {
        return this._shape[0]
      },
      set: function(w) {
        w = w|0
        reshapeTexture(this, w, this._shape[1])
        return w
      }
    },
    height: {
      get: function() {
        return this._shape[1]
      },
      set: function(h) {
        h = h|0
        reshapeTexture(this, this._shape[0], h)
        return h
      }
    }
  })
  
  proto.bind = function(unit) {
    var gl = this.gl
    if(unit !== undefined) {
      gl.activeTexture(gl.TEXTURE0 + (unit|0))
    }
    gl.bindTexture(gl.TEXTURE_2D, this.handle)
    if(unit !== undefined) {
      return (unit|0)
    }
    return gl.getParameter(gl.ACTIVE_TEXTURE) - gl.TEXTURE0
  }
  
  proto.dispose = function() {
    this.gl.deleteTexture(this.handle)
  }
  
  proto.generateMipmap = function() {
    this.bind()
    this.gl.generateMipmap(this.gl.TEXTURE_2D)
  
    //Update mip levels
    var l = Math.min(this._shape[0], this._shape[1])
    for(var i=0; l>0; ++i, l>>>=1) {
      if(this._mipLevels.indexOf(i) < 0) {
        this._mipLevels.push(i)
      }
    }
  }
  
  proto.setPixels = function(data, x_off, y_off, mip_level) {
    var gl = this.gl
    this.bind()
    if(Array.isArray(x_off)) {
      mip_level = y_off
      y_off = x_off[1]|0
      x_off = x_off[0]|0
    } else {
      x_off = x_off || 0
      y_off = y_off || 0
    }
    mip_level = mip_level || 0
    var directData = acceptTextureDOM(data) ? data : data.raw
    if(directData) {
      var needsMip = this._mipLevels.indexOf(mip_level) < 0
      if(needsMip) {
        gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, directData)
        this._mipLevels.push(mip_level)
      } else {
        gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, this.format, this.type, directData)
      }
    } else if(data.shape && data.stride && data.data) {
      if(data.shape.length < 2 ||
         x_off + data.shape[1] > this._shape[1]>>>mip_level ||
         y_off + data.shape[0] > this._shape[0]>>>mip_level ||
         x_off < 0 ||
         y_off < 0) {
        throw new Error('gl-texture2d: Texture dimensions are out of bounds')
      }
      texSubImageArray(gl, x_off, y_off, mip_level, this.format, this.type, this._mipLevels, data)
    } else {
      throw new Error('gl-texture2d: Unsupported data type')
    }
  }
  
  
  function isPacked(shape, stride) {
    if(shape.length === 3) {
      return  (stride[2] === 1) &&
              (stride[1] === shape[0]*shape[2]) &&
              (stride[0] === shape[2])
    }
    return  (stride[0] === 1) &&
            (stride[1] === shape[0])
  }
  
  function texSubImageArray(gl, x_off, y_off, mip_level, cformat, ctype, mipLevels, array) {
    var dtype = array.dtype
    var shape = array.shape.slice()
    if(shape.length < 2 || shape.length > 3) {
      throw new Error('gl-texture2d: Invalid ndarray, must be 2d or 3d')
    }
    var type = 0, format = 0
    var packed = isPacked(shape, array.stride.slice())
    if(dtype === 'float32') {
      type = gl.FLOAT
    } else if(dtype === 'float64') {
      type = gl.FLOAT
      packed = false
      dtype = 'float32'
    } else if(dtype === 'uint8') {
      type = gl.UNSIGNED_BYTE
    } else {
      type = gl.UNSIGNED_BYTE
      packed = false
      dtype = 'uint8'
    }
    var channels = 1
    if(shape.length === 2) {
      format = gl.LUMINANCE
      shape = [shape[0], shape[1], 1]
      array = ndarray(array.data, shape, [array.stride[0], array.stride[1], 1], array.offset)
    } else if(shape.length === 3) {
      if(shape[2] === 1) {
        format = gl.ALPHA
      } else if(shape[2] === 2) {
        format = gl.LUMINANCE_ALPHA
      } else if(shape[2] === 3) {
        format = gl.RGB
      } else if(shape[2] === 4) {
        format = gl.RGBA
      } else {
        throw new Error('gl-texture2d: Invalid shape for pixel coords')
      }
      channels = shape[2]
    } else {
      throw new Error('gl-texture2d: Invalid shape for texture')
    }
    //For 1-channel textures allow conversion between formats
    if((format  === gl.LUMINANCE || format  === gl.ALPHA) &&
       (cformat === gl.LUMINANCE || cformat === gl.ALPHA)) {
      format = cformat
    }
    if(format !== cformat) {
      throw new Error('gl-texture2d: Incompatible texture format for setPixels')
    }
    var size = array.size
    var needsMip = mipLevels.indexOf(mip_level) < 0
    if(needsMip) {
      mipLevels.push(mip_level)
    }
    if(type === ctype && packed) {
      //Array data types are compatible, can directly copy into texture
      if(array.offset === 0 && array.data.length === size) {
        if(needsMip) {
          gl.texImage2D(gl.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, array.data)
        } else {
          gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, array.data)
        }
      } else {
        if(needsMip) {
          gl.texImage2D(gl.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, array.data.subarray(array.offset, array.offset+size))
        } else {
          gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, array.data.subarray(array.offset, array.offset+size))
        }
      }
    } else {
      //Need to do type conversion to pack data into buffer
      var pack_buffer
      if(ctype === gl.FLOAT) {
        pack_buffer = pool.mallocFloat32(size)
      } else {
        pack_buffer = pool.mallocUint8(size)
      }
      var pack_view = ndarray(pack_buffer, shape, [shape[2], shape[2]*shape[0], 1])
      if(type === gl.FLOAT && ctype === gl.UNSIGNED_BYTE) {
        convertFloatToUint8(pack_view, array)
      } else {
        ops.assign(pack_view, array)
      }
      if(needsMip) {
        gl.texImage2D(gl.TEXTURE_2D, mip_level, cformat, shape[0], shape[1], 0, cformat, ctype, pack_buffer.subarray(0, size))
      } else {
        gl.texSubImage2D(gl.TEXTURE_2D, mip_level, x_off, y_off, shape[0], shape[1], cformat, ctype, pack_buffer.subarray(0, size))
      }
      if(ctype === gl.FLOAT) {
        pool.freeFloat32(pack_buffer)
      } else {
        pool.freeUint8(pack_buffer)
      }
    }
  }
  
  function initTexture(gl) {
    var tex = gl.createTexture()
    gl.bindTexture(gl.TEXTURE_2D, tex)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
    return tex
  }
  
  function createTextureShape(gl, width, height, format, type) {
    var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE)
    if(width < 0 || width > maxTextureSize || height < 0 || height  > maxTextureSize) {
      throw new Error('gl-texture2d: Invalid texture shape')
    }
    if(type === gl.FLOAT && !gl.getExtension('OES_texture_float')) {
      throw new Error('gl-texture2d: Floating point textures not supported on this platform')
    }
    var tex = initTexture(gl)
    gl.texImage2D(gl.TEXTURE_2D, 0, format, width, height, 0, format, type, null)
    return new Texture2D(gl, tex, width, height, format, type)
  }
  
  function createTextureDOM(gl, directData, width, height, format, type) {
    var tex = initTexture(gl)
    gl.texImage2D(gl.TEXTURE_2D, 0, format, format, type, directData)
    return new Texture2D(gl, tex, width, height, format, type)
  }
  
  //Creates a texture from an ndarray
  function createTextureArray(gl, array) {
    var dtype = array.dtype
    var shape = array.shape.slice()
    var maxSize = gl.getParameter(gl.MAX_TEXTURE_SIZE)
    if(shape[0] < 0 || shape[0] > maxSize || shape[1] < 0 || shape[1] > maxSize) {
      throw new Error('gl-texture2d: Invalid texture size')
    }
    var packed = isPacked(shape, array.stride.slice())
    var type = 0
    if(dtype === 'float32') {
      type = gl.FLOAT
    } else if(dtype === 'float64') {
      type = gl.FLOAT
      packed = false
      dtype = 'float32'
    } else if(dtype === 'uint8') {
      type = gl.UNSIGNED_BYTE
    } else {
      type = gl.UNSIGNED_BYTE
      packed = false
      dtype = 'uint8'
    }
    var format = 0
    if(shape.length === 2) {
      format = gl.LUMINANCE
      shape = [shape[0], shape[1], 1]
      array = ndarray(array.data, shape, [array.stride[0], array.stride[1], 1], array.offset)
    } else if(shape.length === 3) {
      if(shape[2] === 1) {
        format = gl.ALPHA
      } else if(shape[2] === 2) {
        format = gl.LUMINANCE_ALPHA
      } else if(shape[2] === 3) {
        format = gl.RGB
      } else if(shape[2] === 4) {
        format = gl.RGBA
      } else {
        throw new Error('gl-texture2d: Invalid shape for pixel coords')
      }
    } else {
      throw new Error('gl-texture2d: Invalid shape for texture')
    }
    if(type === gl.FLOAT && !gl.getExtension('OES_texture_float')) {
      type = gl.UNSIGNED_BYTE
      packed = false
    }
    var buffer, buf_store
    var size = array.size
    if(!packed) {
      var stride = [shape[2], shape[2]*shape[0], 1]
      buf_store = pool.malloc(size, dtype)
      var buf_array = ndarray(buf_store, shape, stride, 0)
      if((dtype === 'float32' || dtype === 'float64') && type === gl.UNSIGNED_BYTE) {
        convertFloatToUint8(buf_array, array)
      } else {
        ops.assign(buf_array, array)
      }
      buffer = buf_store.subarray(0, size)
    } else if (array.offset === 0 && array.data.length === size) {
      buffer = array.data
    } else {
      buffer = array.data.subarray(array.offset, array.offset + size)
    }
    var tex = initTexture(gl)
    gl.texImage2D(gl.TEXTURE_2D, 0, format, shape[0], shape[1], 0, format, type, buffer)
    if(!packed) {
      pool.free(buf_store)
    }
    return new Texture2D(gl, tex, shape[0], shape[1], format, type)
  }
  
  function createTexture2D(gl) {
    if(arguments.length <= 1) {
      throw new Error('gl-texture2d: Missing arguments for texture2d constructor')
    }
    if(!linearTypes) {
      lazyInitLinearTypes(gl)
    }
    if(typeof arguments[1] === 'number') {
      return createTextureShape(gl, arguments[1], arguments[2], arguments[3]||gl.RGBA, arguments[4]||gl.UNSIGNED_BYTE)
    }
    if(Array.isArray(arguments[1])) {
      return createTextureShape(gl, arguments[1][0]|0, arguments[1][1]|0, arguments[2]||gl.RGBA, arguments[3]||gl.UNSIGNED_BYTE)
    }
    if(typeof arguments[1] === 'object') {
      var obj = arguments[1]
      var directData = acceptTextureDOM(obj) ? obj : obj.raw
      if (directData) {
        return createTextureDOM(gl, directData, obj.width|0, obj.height|0, arguments[2]||gl.RGBA, arguments[3]||gl.UNSIGNED_BYTE)
      } else if(obj.shape && obj.data && obj.stride) {
        return createTextureArray(gl, obj)
      }
    }
    throw new Error('gl-texture2d: Invalid arguments for texture2d constructor')
  }
  
  },{"ndarray":469,"ndarray-ops":464,"typedarray-pool":567}],328:[function(_dereq_,module,exports){
  (function (global){
  /** @module  gl-util/context */
  'use strict'
  
  var pick = _dereq_('pick-by-alias')
  
  module.exports = function setContext (o) {
    if (!o) o = {}
    else if (typeof o === 'string') o = {container: o}
  
    // HTMLCanvasElement
    if (isCanvas(o)) {
      o = {container: o}
    }
    // HTMLElement
    else if (isElement(o)) {
      o = {container: o}
    }
    // WebGLContext
    else if (isContext(o)) {
      o = {gl: o}
    }
    // options object
    else {
      o = pick(o, {
        container: 'container target element el canvas holder parent parentNode wrapper use ref root node',
        gl: 'gl context webgl glContext',
        attrs: 'attributes attrs contextAttributes',
        pixelRatio: 'pixelRatio pxRatio px ratio pxratio pixelratio',
        width: 'w width',
        height: 'h height'
      }, true)
    }
  
    if (!o.pixelRatio) o.pixelRatio = global.pixelRatio || 1
  
    // make sure there is container and canvas
    if (o.gl) {
      return o.gl
    }
    if (o.canvas) {
      o.container = o.canvas.parentNode
    }
    if (o.container) {
      if (typeof o.container === 'string') {
        var c = document.querySelector(o.container)
        if (!c) throw Error('Element ' + o.container + ' is not found')
        o.container = c
      }
      if (isCanvas(o.container)) {
        o.canvas = o.container
        o.container = o.canvas.parentNode
      }
      else if (!o.canvas) {
        o.canvas = createCanvas()
        o.container.appendChild(o.canvas)
        resize(o)
      }
    }
    // blank new canvas
    else if (!o.canvas) {
      if (typeof document !== 'undefined') {
        o.container = document.body || document.documentElement
        o.canvas = createCanvas()
        o.container.appendChild(o.canvas)
        resize(o)
      }
      else {
        throw Error('Not DOM environment. Use headless-gl.')
      }
    }
  
    // make sure there is context
    if (!o.gl) {
      try {
        o.gl = o.canvas.getContext('webgl', o.attrs)
      } catch (e) {
        try {
          o.gl = o.canvas.getContext('experimental-webgl', o.attrs)
        }
        catch (e) {
          o.gl = o.canvas.getContext('webgl-experimental', o.attrs)
        }
      }
    }
  
    return o.gl
  }
  
  
  function resize (o) {
    if (o.container) {
      if (o.container == document.body) {
        if (!document.body.style.width) o.canvas.width = o.width || (o.pixelRatio * global.innerWidth)
        if (!document.body.style.height) o.canvas.height = o.height || (o.pixelRatio * global.innerHeight)
      }
      else {
        var bounds = o.container.getBoundingClientRect()
        o.canvas.width = o.width || (bounds.right - bounds.left)
        o.canvas.height = o.height || (bounds.bottom - bounds.top)
      }
    }
  }
  
  function isCanvas (e) {
    return typeof e.getContext === 'function'
      && 'width' in e
      && 'height' in e
  }
  
  function isElement (e) {
    return typeof e.nodeName === 'string' &&
      typeof e.appendChild === 'function' &&
      typeof e.getBoundingClientRect === 'function'
  }
  
  function isContext (e) {
    return typeof e.drawArrays === 'function' ||
      typeof e.drawElements === 'function'
  }
  
  function createCanvas () {
    var canvas = document.createElement('canvas')
    canvas.style.position = 'absolute'
    canvas.style.top = 0
    canvas.style.left = 0
  
    return canvas
  }
  
  }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{"pick-by-alias":485}],329:[function(_dereq_,module,exports){
  "use strict"
  
  function doBind(gl, elements, attributes) {
    if(elements) {
      elements.bind()
    } else {
      gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null)
    }
    var nattribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS)|0
    if(attributes) {
      if(attributes.length > nattribs) {
        throw new Error("gl-vao: Too many vertex attributes")
      }
      for(var i=0; i<attributes.length; ++i) {
        var attrib = attributes[i]
        if(attrib.buffer) {
          var buffer = attrib.buffer
          var size = attrib.size || 4
          var type = attrib.type || gl.FLOAT
          var normalized = !!attrib.normalized
          var stride = attrib.stride || 0
          var offset = attrib.offset || 0
          buffer.bind()
          gl.enableVertexAttribArray(i)
          gl.vertexAttribPointer(i, size, type, normalized, stride, offset)
        } else {
          if(typeof attrib === "number") {
            gl.vertexAttrib1f(i, attrib)
          } else if(attrib.length === 1) {
            gl.vertexAttrib1f(i, attrib[0])
          } else if(attrib.length === 2) {
            gl.vertexAttrib2f(i, attrib[0], attrib[1])
          } else if(attrib.length === 3) {
            gl.vertexAttrib3f(i, attrib[0], attrib[1], attrib[2])
          } else if(attrib.length === 4) {
            gl.vertexAttrib4f(i, attrib[0], attrib[1], attrib[2], attrib[3])
          } else {
            throw new Error("gl-vao: Invalid vertex attribute")
          }
          gl.disableVertexAttribArray(i)
        }
      }
      for(; i<nattribs; ++i) {
        gl.disableVertexAttribArray(i)
      }
    } else {
      gl.bindBuffer(gl.ARRAY_BUFFER, null)
      for(var i=0; i<nattribs; ++i) {
        gl.disableVertexAttribArray(i)
      }
    }
  }
  
  module.exports = doBind
  },{}],330:[function(_dereq_,module,exports){
  "use strict"
  
  var bindAttribs = _dereq_("./do-bind.js")
  
  function VAOEmulated(gl) {
    this.gl = gl
    this._elements = null
    this._attributes = null
    this._elementsType = gl.UNSIGNED_SHORT
  }
  
  VAOEmulated.prototype.bind = function() {
    bindAttribs(this.gl, this._elements, this._attributes)
  }
  
  VAOEmulated.prototype.update = function(attributes, elements, elementsType) {
    this._elements = elements
    this._attributes = attributes
    this._elementsType = elementsType || this.gl.UNSIGNED_SHORT
  }
  
  VAOEmulated.prototype.dispose = function() { }
  VAOEmulated.prototype.unbind = function() { }
  
  VAOEmulated.prototype.draw = function(mode, count, offset) {
    offset = offset || 0
    var gl = this.gl
    if(this._elements) {
      gl.drawElements(mode, count, this._elementsType, offset)
    } else {
      gl.drawArrays(mode, offset, count)
    }
  }
  
  function createVAOEmulated(gl) {
    return new VAOEmulated(gl)
  }
  
  module.exports = createVAOEmulated
  },{"./do-bind.js":329}],331:[function(_dereq_,module,exports){
  "use strict"
  
  var bindAttribs = _dereq_("./do-bind.js")
  
  function VertexAttribute(location, dimension, a, b, c, d) {
    this.location = location
    this.dimension = dimension
    this.a = a
    this.b = b
    this.c = c
    this.d = d
  }
  
  VertexAttribute.prototype.bind = function(gl) {
    switch(this.dimension) {
      case 1:
        gl.vertexAttrib1f(this.location, this.a)
      break
      case 2:
        gl.vertexAttrib2f(this.location, this.a, this.b)
      break
      case 3:
        gl.vertexAttrib3f(this.location, this.a, this.b, this.c)
      break
      case 4:
        gl.vertexAttrib4f(this.location, this.a, this.b, this.c, this.d)
      break
    }
  }
  
  function VAONative(gl, ext, handle) {
    this.gl = gl
    this._ext = ext
    this.handle = handle
    this._attribs = []
    this._useElements = false
    this._elementsType = gl.UNSIGNED_SHORT
  }
  
  VAONative.prototype.bind = function() {
    this._ext.bindVertexArrayOES(this.handle)
    for(var i=0; i<this._attribs.length; ++i) {
      this._attribs[i].bind(this.gl)
    }
  }
  
  VAONative.prototype.unbind = function() {
    this._ext.bindVertexArrayOES(null)
  }
  
  VAONative.prototype.dispose = function() {
    this._ext.deleteVertexArrayOES(this.handle)
  }
  
  VAONative.prototype.update = function(attributes, elements, elementsType) {
    this.bind()
    bindAttribs(this.gl, elements, attributes)
    this.unbind()
    this._attribs.length = 0
    if(attributes)
    for(var i=0; i<attributes.length; ++i) {
      var a = attributes[i]
      if(typeof a === "number") {
        this._attribs.push(new VertexAttribute(i, 1, a))
      } else if(Array.isArray(a)) {
        this._attribs.push(new VertexAttribute(i, a.length, a[0], a[1], a[2], a[3]))
      }
    }
    this._useElements = !!elements
    this._elementsType = elementsType || this.gl.UNSIGNED_SHORT
  }
  
  VAONative.prototype.draw = function(mode, count, offset) {
    offset = offset || 0
    var gl = this.gl
    if(this._useElements) {
      gl.drawElements(mode, count, this._elementsType, offset)
    } else {
      gl.drawArrays(mode, offset, count)
    }
  }
  
  function createVAONative(gl, ext) {
    return new VAONative(gl, ext, ext.createVertexArrayOES())
  }
  
  module.exports = createVAONative
  },{"./do-bind.js":329}],332:[function(_dereq_,module,exports){
  "use strict"
  
  var createVAONative = _dereq_("./lib/vao-native.js")
  var createVAOEmulated = _dereq_("./lib/vao-emulated.js")
  
  function ExtensionShim (gl) {
    this.bindVertexArrayOES = gl.bindVertexArray.bind(gl)
    this.createVertexArrayOES = gl.createVertexArray.bind(gl)
    this.deleteVertexArrayOES = gl.deleteVertexArray.bind(gl)
  }
  
  function createVAO(gl, attributes, elements, elementsType) {
    var ext = gl.createVertexArray
      ? new ExtensionShim(gl)
      : gl.getExtension('OES_vertex_array_object')
    var vao
  
    if(ext) {
      vao = createVAONative(gl, ext)
    } else {
      vao = createVAOEmulated(gl)
    }
    vao.update(attributes, elements, elementsType)
    return vao
  }
  
  module.exports = createVAO
  
  },{"./lib/vao-emulated.js":330,"./lib/vao-native.js":331}],333:[function(_dereq_,module,exports){
  module.exports = add;
  
  /**
   * Adds two vec3's
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {vec3} out
   */
  function add(out, a, b) {
      out[0] = a[0] + b[0]
      out[1] = a[1] + b[1]
      out[2] = a[2] + b[2]
      return out
  }
  },{}],334:[function(_dereq_,module,exports){
  module.exports = angle
  
  var fromValues = _dereq_('./fromValues')
  var normalize = _dereq_('./normalize')
  var dot = _dereq_('./dot')
  
  /**
   * Get the angle between two 3D vectors
   * @param {vec3} a The first operand
   * @param {vec3} b The second operand
   * @returns {Number} The angle in radians
   */
  function angle(a, b) {
      var tempA = fromValues(a[0], a[1], a[2])
      var tempB = fromValues(b[0], b[1], b[2])
   
      normalize(tempA, tempA)
      normalize(tempB, tempB)
   
      var cosine = dot(tempA, tempB)
  
      if(cosine > 1.0){
          return 0
      } else {
          return Math.acos(cosine)
      }     
  }
  
  },{"./dot":344,"./fromValues":350,"./normalize":361}],335:[function(_dereq_,module,exports){
  module.exports = ceil
  
  /**
   * Math.ceil the components of a vec3
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a vector to ceil
   * @returns {vec3} out
   */
  function ceil(out, a) {
    out[0] = Math.ceil(a[0])
    out[1] = Math.ceil(a[1])
    out[2] = Math.ceil(a[2])
    return out
  }
  
  },{}],336:[function(_dereq_,module,exports){
  module.exports = clone;
  
  /**
   * Creates a new vec3 initialized with values from an existing vector
   *
   * @param {vec3} a vector to clone
   * @returns {vec3} a new 3D vector
   */
  function clone(a) {
      var out = new Float32Array(3)
      out[0] = a[0]
      out[1] = a[1]
      out[2] = a[2]
      return out
  }
  },{}],337:[function(_dereq_,module,exports){
  module.exports = copy;
  
  /**
   * Copy the values from one vec3 to another
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the source vector
   * @returns {vec3} out
   */
  function copy(out, a) {
      out[0] = a[0]
      out[1] = a[1]
      out[2] = a[2]
      return out
  }
  },{}],338:[function(_dereq_,module,exports){
  module.exports = create;
  
  /**
   * Creates a new, empty vec3
   *
   * @returns {vec3} a new 3D vector
   */
  function create() {
      var out = new Float32Array(3)
      out[0] = 0
      out[1] = 0
      out[2] = 0
      return out
  }
  },{}],339:[function(_dereq_,module,exports){
  module.exports = cross;
  
  /**
   * Computes the cross product of two vec3's
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {vec3} out
   */
  function cross(out, a, b) {
      var ax = a[0], ay = a[1], az = a[2],
          bx = b[0], by = b[1], bz = b[2]
  
      out[0] = ay * bz - az * by
      out[1] = az * bx - ax * bz
      out[2] = ax * by - ay * bx
      return out
  }
  },{}],340:[function(_dereq_,module,exports){
  module.exports = _dereq_('./distance')
  
  },{"./distance":341}],341:[function(_dereq_,module,exports){
  module.exports = distance;
  
  /**
   * Calculates the euclidian distance between two vec3's
   *
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {Number} distance between a and b
   */
  function distance(a, b) {
      var x = b[0] - a[0],
          y = b[1] - a[1],
          z = b[2] - a[2]
      return Math.sqrt(x*x + y*y + z*z)
  }
  },{}],342:[function(_dereq_,module,exports){
  module.exports = _dereq_('./divide')
  
  },{"./divide":343}],343:[function(_dereq_,module,exports){
  module.exports = divide;
  
  /**
   * Divides two vec3's
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {vec3} out
   */
  function divide(out, a, b) {
      out[0] = a[0] / b[0]
      out[1] = a[1] / b[1]
      out[2] = a[2] / b[2]
      return out
  }
  },{}],344:[function(_dereq_,module,exports){
  module.exports = dot;
  
  /**
   * Calculates the dot product of two vec3's
   *
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {Number} dot product of a and b
   */
  function dot(a, b) {
      return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]
  }
  },{}],345:[function(_dereq_,module,exports){
  module.exports = 0.000001
  
  },{}],346:[function(_dereq_,module,exports){
  module.exports = equals
  
  var EPSILON = _dereq_('./epsilon')
  
  /**
   * Returns whether or not the vectors have approximately the same elements in the same position.
   *
   * @param {vec3} a The first vector.
   * @param {vec3} b The second vector.
   * @returns {Boolean} True if the vectors are equal, false otherwise.
   */
  function equals(a, b) {
    var a0 = a[0]
    var a1 = a[1]
    var a2 = a[2]
    var b0 = b[0]
    var b1 = b[1]
    var b2 = b[2]
    return (Math.abs(a0 - b0) <= EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
            Math.abs(a2 - b2) <= EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)))
  }
  
  },{"./epsilon":345}],347:[function(_dereq_,module,exports){
  module.exports = exactEquals
  
  /**
   * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
   *
   * @param {vec3} a The first vector.
   * @param {vec3} b The second vector.
   * @returns {Boolean} True if the vectors are equal, false otherwise.
   */
  function exactEquals(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2]
  }
  
  },{}],348:[function(_dereq_,module,exports){
  module.exports = floor
  
  /**
   * Math.floor the components of a vec3
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a vector to floor
   * @returns {vec3} out
   */
  function floor(out, a) {
    out[0] = Math.floor(a[0])
    out[1] = Math.floor(a[1])
    out[2] = Math.floor(a[2])
    return out
  }
  
  },{}],349:[function(_dereq_,module,exports){
  module.exports = forEach;
  
  var vec = _dereq_('./create')()
  
  /**
   * Perform some operation over an array of vec3s.
   *
   * @param {Array} a the array of vectors to iterate over
   * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
   * @param {Number} offset Number of elements to skip at the beginning of the array
   * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
   * @param {Function} fn Function to call for each vector in the array
   * @param {Object} [arg] additional argument to pass to fn
   * @returns {Array} a
   * @function
   */
  function forEach(a, stride, offset, count, fn, arg) {
          var i, l
          if(!stride) {
              stride = 3
          }
  
          if(!offset) {
              offset = 0
          }
          
          if(count) {
              l = Math.min((count * stride) + offset, a.length)
          } else {
              l = a.length
          }
  
          for(i = offset; i < l; i += stride) {
              vec[0] = a[i] 
              vec[1] = a[i+1] 
              vec[2] = a[i+2]
              fn(vec, vec, arg)
              a[i] = vec[0] 
              a[i+1] = vec[1] 
              a[i+2] = vec[2]
          }
          
          return a
  }
  },{"./create":338}],350:[function(_dereq_,module,exports){
  module.exports = fromValues;
  
  /**
   * Creates a new vec3 initialized with the given values
   *
   * @param {Number} x X component
   * @param {Number} y Y component
   * @param {Number} z Z component
   * @returns {vec3} a new 3D vector
   */
  function fromValues(x, y, z) {
      var out = new Float32Array(3)
      out[0] = x
      out[1] = y
      out[2] = z
      return out
  }
  },{}],351:[function(_dereq_,module,exports){
  module.exports = {
    EPSILON: _dereq_('./epsilon')
    , create: _dereq_('./create')
    , clone: _dereq_('./clone')
    , angle: _dereq_('./angle')
    , fromValues: _dereq_('./fromValues')
    , copy: _dereq_('./copy')
    , set: _dereq_('./set')
    , equals: _dereq_('./equals')
    , exactEquals: _dereq_('./exactEquals')
    , add: _dereq_('./add')
    , subtract: _dereq_('./subtract')
    , sub: _dereq_('./sub')
    , multiply: _dereq_('./multiply')
    , mul: _dereq_('./mul')
    , divide: _dereq_('./divide')
    , div: _dereq_('./div')
    , min: _dereq_('./min')
    , max: _dereq_('./max')
    , floor: _dereq_('./floor')
    , ceil: _dereq_('./ceil')
    , round: _dereq_('./round')
    , scale: _dereq_('./scale')
    , scaleAndAdd: _dereq_('./scaleAndAdd')
    , distance: _dereq_('./distance')
    , dist: _dereq_('./dist')
    , squaredDistance: _dereq_('./squaredDistance')
    , sqrDist: _dereq_('./sqrDist')
    , length: _dereq_('./length')
    , len: _dereq_('./len')
    , squaredLength: _dereq_('./squaredLength')
    , sqrLen: _dereq_('./sqrLen')
    , negate: _dereq_('./negate')
    , inverse: _dereq_('./inverse')
    , normalize: _dereq_('./normalize')
    , dot: _dereq_('./dot')
    , cross: _dereq_('./cross')
    , lerp: _dereq_('./lerp')
    , random: _dereq_('./random')
    , transformMat4: _dereq_('./transformMat4')
    , transformMat3: _dereq_('./transformMat3')
    , transformQuat: _dereq_('./transformQuat')
    , rotateX: _dereq_('./rotateX')
    , rotateY: _dereq_('./rotateY')
    , rotateZ: _dereq_('./rotateZ')
    , forEach: _dereq_('./forEach')
  }
  
  },{"./add":333,"./angle":334,"./ceil":335,"./clone":336,"./copy":337,"./create":338,"./cross":339,"./dist":340,"./distance":341,"./div":342,"./divide":343,"./dot":344,"./epsilon":345,"./equals":346,"./exactEquals":347,"./floor":348,"./forEach":349,"./fromValues":350,"./inverse":352,"./len":353,"./length":354,"./lerp":355,"./max":356,"./min":357,"./mul":358,"./multiply":359,"./negate":360,"./normalize":361,"./random":362,"./rotateX":363,"./rotateY":364,"./rotateZ":365,"./round":366,"./scale":367,"./scaleAndAdd":368,"./set":369,"./sqrDist":370,"./sqrLen":371,"./squaredDistance":372,"./squaredLength":373,"./sub":374,"./subtract":375,"./transformMat3":376,"./transformMat4":377,"./transformQuat":378}],352:[function(_dereq_,module,exports){
  module.exports = inverse;
  
  /**
   * Returns the inverse of the components of a vec3
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a vector to invert
   * @returns {vec3} out
   */
  function inverse(out, a) {
    out[0] = 1.0 / a[0]
    out[1] = 1.0 / a[1]
    out[2] = 1.0 / a[2]
    return out
  }
  },{}],353:[function(_dereq_,module,exports){
  module.exports = _dereq_('./length')
  
  },{"./length":354}],354:[function(_dereq_,module,exports){
  module.exports = length;
  
  /**
   * Calculates the length of a vec3
   *
   * @param {vec3} a vector to calculate length of
   * @returns {Number} length of a
   */
  function length(a) {
      var x = a[0],
          y = a[1],
          z = a[2]
      return Math.sqrt(x*x + y*y + z*z)
  }
  },{}],355:[function(_dereq_,module,exports){
  module.exports = lerp;
  
  /**
   * Performs a linear interpolation between two vec3's
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @param {Number} t interpolation amount between the two inputs
   * @returns {vec3} out
   */
  function lerp(out, a, b, t) {
      var ax = a[0],
          ay = a[1],
          az = a[2]
      out[0] = ax + t * (b[0] - ax)
      out[1] = ay + t * (b[1] - ay)
      out[2] = az + t * (b[2] - az)
      return out
  }
  },{}],356:[function(_dereq_,module,exports){
  module.exports = max;
  
  /**
   * Returns the maximum of two vec3's
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {vec3} out
   */
  function max(out, a, b) {
      out[0] = Math.max(a[0], b[0])
      out[1] = Math.max(a[1], b[1])
      out[2] = Math.max(a[2], b[2])
      return out
  }
  },{}],357:[function(_dereq_,module,exports){
  module.exports = min;
  
  /**
   * Returns the minimum of two vec3's
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {vec3} out
   */
  function min(out, a, b) {
      out[0] = Math.min(a[0], b[0])
      out[1] = Math.min(a[1], b[1])
      out[2] = Math.min(a[2], b[2])
      return out
  }
  },{}],358:[function(_dereq_,module,exports){
  module.exports = _dereq_('./multiply')
  
  },{"./multiply":359}],359:[function(_dereq_,module,exports){
  module.exports = multiply;
  
  /**
   * Multiplies two vec3's
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {vec3} out
   */
  function multiply(out, a, b) {
      out[0] = a[0] * b[0]
      out[1] = a[1] * b[1]
      out[2] = a[2] * b[2]
      return out
  }
  },{}],360:[function(_dereq_,module,exports){
  module.exports = negate;
  
  /**
   * Negates the components of a vec3
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a vector to negate
   * @returns {vec3} out
   */
  function negate(out, a) {
      out[0] = -a[0]
      out[1] = -a[1]
      out[2] = -a[2]
      return out
  }
  },{}],361:[function(_dereq_,module,exports){
  module.exports = normalize;
  
  /**
   * Normalize a vec3
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a vector to normalize
   * @returns {vec3} out
   */
  function normalize(out, a) {
      var x = a[0],
          y = a[1],
          z = a[2]
      var len = x*x + y*y + z*z
      if (len > 0) {
          //TODO: evaluate use of glm_invsqrt here?
          len = 1 / Math.sqrt(len)
          out[0] = a[0] * len
          out[1] = a[1] * len
          out[2] = a[2] * len
      }
      return out
  }
  },{}],362:[function(_dereq_,module,exports){
  module.exports = random;
  
  /**
   * Generates a random vector with the given scale
   *
   * @param {vec3} out the receiving vector
   * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
   * @returns {vec3} out
   */
  function random(out, scale) {
      scale = scale || 1.0
  
      var r = Math.random() * 2.0 * Math.PI
      var z = (Math.random() * 2.0) - 1.0
      var zScale = Math.sqrt(1.0-z*z) * scale
  
      out[0] = Math.cos(r) * zScale
      out[1] = Math.sin(r) * zScale
      out[2] = z * scale
      return out
  }
  },{}],363:[function(_dereq_,module,exports){
  module.exports = rotateX;
  
  /**
   * Rotate a 3D vector around the x-axis
   * @param {vec3} out The receiving vec3
   * @param {vec3} a The vec3 point to rotate
   * @param {vec3} b The origin of the rotation
   * @param {Number} c The angle of rotation
   * @returns {vec3} out
   */
  function rotateX(out, a, b, c){
      var by = b[1]
      var bz = b[2]
  
      // Translate point to the origin
      var py = a[1] - by
      var pz = a[2] - bz
  
      var sc = Math.sin(c)
      var cc = Math.cos(c)
  
      // perform rotation and translate to correct position
      out[0] = a[0]
      out[1] = by + py * cc - pz * sc
      out[2] = bz + py * sc + pz * cc
  
      return out
  }
  
  },{}],364:[function(_dereq_,module,exports){
  module.exports = rotateY;
  
  /**
   * Rotate a 3D vector around the y-axis
   * @param {vec3} out The receiving vec3
   * @param {vec3} a The vec3 point to rotate
   * @param {vec3} b The origin of the rotation
   * @param {Number} c The angle of rotation
   * @returns {vec3} out
   */
  function rotateY(out, a, b, c){
      var bx = b[0]
      var bz = b[2]
  
      // translate point to the origin
      var px = a[0] - bx
      var pz = a[2] - bz
      
      var sc = Math.sin(c)
      var cc = Math.cos(c)
    
      // perform rotation and translate to correct position
      out[0] = bx + pz * sc + px * cc
      out[1] = a[1]
      out[2] = bz + pz * cc - px * sc
    
      return out
  }
  
  },{}],365:[function(_dereq_,module,exports){
  module.exports = rotateZ;
  
  /**
   * Rotate a 3D vector around the z-axis
   * @param {vec3} out The receiving vec3
   * @param {vec3} a The vec3 point to rotate
   * @param {vec3} b The origin of the rotation
   * @param {Number} c The angle of rotation
   * @returns {vec3} out
   */
  function rotateZ(out, a, b, c){
      var bx = b[0]
      var by = b[1]
  
      //Translate point to the origin
      var px = a[0] - bx
      var py = a[1] - by
    
      var sc = Math.sin(c)
      var cc = Math.cos(c)
  
      // perform rotation and translate to correct position
      out[0] = bx + px * cc - py * sc
      out[1] = by + px * sc + py * cc
      out[2] = a[2]
    
      return out
  }
  
  },{}],366:[function(_dereq_,module,exports){
  module.exports = round
  
  /**
   * Math.round the components of a vec3
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a vector to round
   * @returns {vec3} out
   */
  function round(out, a) {
    out[0] = Math.round(a[0])
    out[1] = Math.round(a[1])
    out[2] = Math.round(a[2])
    return out
  }
  
  },{}],367:[function(_dereq_,module,exports){
  module.exports = scale;
  
  /**
   * Scales a vec3 by a scalar number
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the vector to scale
   * @param {Number} b amount to scale the vector by
   * @returns {vec3} out
   */
  function scale(out, a, b) {
      out[0] = a[0] * b
      out[1] = a[1] * b
      out[2] = a[2] * b
      return out
  }
  },{}],368:[function(_dereq_,module,exports){
  module.exports = scaleAndAdd;
  
  /**
   * Adds two vec3's after scaling the second operand by a scalar value
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @param {Number} scale the amount to scale b by before adding
   * @returns {vec3} out
   */
  function scaleAndAdd(out, a, b, scale) {
      out[0] = a[0] + (b[0] * scale)
      out[1] = a[1] + (b[1] * scale)
      out[2] = a[2] + (b[2] * scale)
      return out
  }
  },{}],369:[function(_dereq_,module,exports){
  module.exports = set;
  
  /**
   * Set the components of a vec3 to the given values
   *
   * @param {vec3} out the receiving vector
   * @param {Number} x X component
   * @param {Number} y Y component
   * @param {Number} z Z component
   * @returns {vec3} out
   */
  function set(out, x, y, z) {
      out[0] = x
      out[1] = y
      out[2] = z
      return out
  }
  },{}],370:[function(_dereq_,module,exports){
  module.exports = _dereq_('./squaredDistance')
  
  },{"./squaredDistance":372}],371:[function(_dereq_,module,exports){
  module.exports = _dereq_('./squaredLength')
  
  },{"./squaredLength":373}],372:[function(_dereq_,module,exports){
  module.exports = squaredDistance;
  
  /**
   * Calculates the squared euclidian distance between two vec3's
   *
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {Number} squared distance between a and b
   */
  function squaredDistance(a, b) {
      var x = b[0] - a[0],
          y = b[1] - a[1],
          z = b[2] - a[2]
      return x*x + y*y + z*z
  }
  },{}],373:[function(_dereq_,module,exports){
  module.exports = squaredLength;
  
  /**
   * Calculates the squared length of a vec3
   *
   * @param {vec3} a vector to calculate squared length of
   * @returns {Number} squared length of a
   */
  function squaredLength(a) {
      var x = a[0],
          y = a[1],
          z = a[2]
      return x*x + y*y + z*z
  }
  },{}],374:[function(_dereq_,module,exports){
  module.exports = _dereq_('./subtract')
  
  },{"./subtract":375}],375:[function(_dereq_,module,exports){
  module.exports = subtract;
  
  /**
   * Subtracts vector b from vector a
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the first operand
   * @param {vec3} b the second operand
   * @returns {vec3} out
   */
  function subtract(out, a, b) {
      out[0] = a[0] - b[0]
      out[1] = a[1] - b[1]
      out[2] = a[2] - b[2]
      return out
  }
  },{}],376:[function(_dereq_,module,exports){
  module.exports = transformMat3;
  
  /**
   * Transforms the vec3 with a mat3.
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the vector to transform
   * @param {mat4} m the 3x3 matrix to transform with
   * @returns {vec3} out
   */
  function transformMat3(out, a, m) {
      var x = a[0], y = a[1], z = a[2]
      out[0] = x * m[0] + y * m[3] + z * m[6]
      out[1] = x * m[1] + y * m[4] + z * m[7]
      out[2] = x * m[2] + y * m[5] + z * m[8]
      return out
  }
  },{}],377:[function(_dereq_,module,exports){
  module.exports = transformMat4;
  
  /**
   * Transforms the vec3 with a mat4.
   * 4th vector component is implicitly '1'
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the vector to transform
   * @param {mat4} m matrix to transform with
   * @returns {vec3} out
   */
  function transformMat4(out, a, m) {
      var x = a[0], y = a[1], z = a[2],
          w = m[3] * x + m[7] * y + m[11] * z + m[15]
      w = w || 1.0
      out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w
      out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w
      out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w
      return out
  }
  },{}],378:[function(_dereq_,module,exports){
  module.exports = transformQuat;
  
  /**
   * Transforms the vec3 with a quat
   *
   * @param {vec3} out the receiving vector
   * @param {vec3} a the vector to transform
   * @param {quat} q quaternion to transform with
   * @returns {vec3} out
   */
  function transformQuat(out, a, q) {
      // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
  
      var x = a[0], y = a[1], z = a[2],
          qx = q[0], qy = q[1], qz = q[2], qw = q[3],
  
          // calculate quat * vec
          ix = qw * x + qy * z - qz * y,
          iy = qw * y + qz * x - qx * z,
          iz = qw * z + qx * y - qy * x,
          iw = -qx * x - qy * y - qz * z
  
      // calculate result * inverse quat
      out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy
      out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz
      out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx
      return out
  }
  },{}],379:[function(_dereq_,module,exports){
  module.exports = add
  
  /**
   * Adds two vec4's
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @returns {vec4} out
   */
  function add (out, a, b) {
    out[0] = a[0] + b[0]
    out[1] = a[1] + b[1]
    out[2] = a[2] + b[2]
    out[3] = a[3] + b[3]
    return out
  }
  
  },{}],380:[function(_dereq_,module,exports){
  module.exports = clone
  
  /**
   * Creates a new vec4 initialized with values from an existing vector
   *
   * @param {vec4} a vector to clone
   * @returns {vec4} a new 4D vector
   */
  function clone (a) {
    var out = new Float32Array(4)
    out[0] = a[0]
    out[1] = a[1]
    out[2] = a[2]
    out[3] = a[3]
    return out
  }
  
  },{}],381:[function(_dereq_,module,exports){
  module.exports = copy
  
  /**
   * Copy the values from one vec4 to another
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the source vector
   * @returns {vec4} out
   */
  function copy (out, a) {
    out[0] = a[0]
    out[1] = a[1]
    out[2] = a[2]
    out[3] = a[3]
    return out
  }
  
  },{}],382:[function(_dereq_,module,exports){
  module.exports = create
  
  /**
   * Creates a new, empty vec4
   *
   * @returns {vec4} a new 4D vector
   */
  function create () {
    var out = new Float32Array(4)
    out[0] = 0
    out[1] = 0
    out[2] = 0
    out[3] = 0
    return out
  }
  
  },{}],383:[function(_dereq_,module,exports){
  module.exports = distance
  
  /**
   * Calculates the euclidian distance between two vec4's
   *
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @returns {Number} distance between a and b
   */
  function distance (a, b) {
    var x = b[0] - a[0],
      y = b[1] - a[1],
      z = b[2] - a[2],
      w = b[3] - a[3]
    return Math.sqrt(x * x + y * y + z * z + w * w)
  }
  
  },{}],384:[function(_dereq_,module,exports){
  module.exports = divide
  
  /**
   * Divides two vec4's
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @returns {vec4} out
   */
  function divide (out, a, b) {
    out[0] = a[0] / b[0]
    out[1] = a[1] / b[1]
    out[2] = a[2] / b[2]
    out[3] = a[3] / b[3]
    return out
  }
  
  },{}],385:[function(_dereq_,module,exports){
  module.exports = dot
  
  /**
   * Calculates the dot product of two vec4's
   *
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @returns {Number} dot product of a and b
   */
  function dot (a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3]
  }
  
  },{}],386:[function(_dereq_,module,exports){
  module.exports = fromValues
  
  /**
   * Creates a new vec4 initialized with the given values
   *
   * @param {Number} x X component
   * @param {Number} y Y component
   * @param {Number} z Z component
   * @param {Number} w W component
   * @returns {vec4} a new 4D vector
   */
  function fromValues (x, y, z, w) {
    var out = new Float32Array(4)
    out[0] = x
    out[1] = y
    out[2] = z
    out[3] = w
    return out
  }
  
  },{}],387:[function(_dereq_,module,exports){
  module.exports = {
    create: _dereq_('./create'),
    clone: _dereq_('./clone'),
    fromValues: _dereq_('./fromValues'),
    copy: _dereq_('./copy'),
    set: _dereq_('./set'),
    add: _dereq_('./add'),
    subtract: _dereq_('./subtract'),
    multiply: _dereq_('./multiply'),
    divide: _dereq_('./divide'),
    min: _dereq_('./min'),
    max: _dereq_('./max'),
    scale: _dereq_('./scale'),
    scaleAndAdd: _dereq_('./scaleAndAdd'),
    distance: _dereq_('./distance'),
    squaredDistance: _dereq_('./squaredDistance'),
    length: _dereq_('./length'),
    squaredLength: _dereq_('./squaredLength'),
    negate: _dereq_('./negate'),
    inverse: _dereq_('./inverse'),
    normalize: _dereq_('./normalize'),
    dot: _dereq_('./dot'),
    lerp: _dereq_('./lerp'),
    random: _dereq_('./random'),
    transformMat4: _dereq_('./transformMat4'),
    transformQuat: _dereq_('./transformQuat')
  }
  
  },{"./add":379,"./clone":380,"./copy":381,"./create":382,"./distance":383,"./divide":384,"./dot":385,"./fromValues":386,"./inverse":388,"./length":389,"./lerp":390,"./max":391,"./min":392,"./multiply":393,"./negate":394,"./normalize":395,"./random":396,"./scale":397,"./scaleAndAdd":398,"./set":399,"./squaredDistance":400,"./squaredLength":401,"./subtract":402,"./transformMat4":403,"./transformQuat":404}],388:[function(_dereq_,module,exports){
  module.exports = inverse
  
  /**
   * Returns the inverse of the components of a vec4
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a vector to invert
   * @returns {vec4} out
   */
  function inverse (out, a) {
    out[0] = 1.0 / a[0]
    out[1] = 1.0 / a[1]
    out[2] = 1.0 / a[2]
    out[3] = 1.0 / a[3]
    return out
  }
  
  },{}],389:[function(_dereq_,module,exports){
  module.exports = length
  
  /**
   * Calculates the length of a vec4
   *
   * @param {vec4} a vector to calculate length of
   * @returns {Number} length of a
   */
  function length (a) {
    var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3]
    return Math.sqrt(x * x + y * y + z * z + w * w)
  }
  
  },{}],390:[function(_dereq_,module,exports){
  module.exports = lerp
  
  /**
   * Performs a linear interpolation between two vec4's
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @param {Number} t interpolation amount between the two inputs
   * @returns {vec4} out
   */
  function lerp (out, a, b, t) {
    var ax = a[0],
      ay = a[1],
      az = a[2],
      aw = a[3]
    out[0] = ax + t * (b[0] - ax)
    out[1] = ay + t * (b[1] - ay)
    out[2] = az + t * (b[2] - az)
    out[3] = aw + t * (b[3] - aw)
    return out
  }
  
  },{}],391:[function(_dereq_,module,exports){
  module.exports = max
  
  /**
   * Returns the maximum of two vec4's
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @returns {vec4} out
   */
  function max (out, a, b) {
    out[0] = Math.max(a[0], b[0])
    out[1] = Math.max(a[1], b[1])
    out[2] = Math.max(a[2], b[2])
    out[3] = Math.max(a[3], b[3])
    return out
  }
  
  },{}],392:[function(_dereq_,module,exports){
  module.exports = min
  
  /**
   * Returns the minimum of two vec4's
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @returns {vec4} out
   */
  function min (out, a, b) {
    out[0] = Math.min(a[0], b[0])
    out[1] = Math.min(a[1], b[1])
    out[2] = Math.min(a[2], b[2])
    out[3] = Math.min(a[3], b[3])
    return out
  }
  
  },{}],393:[function(_dereq_,module,exports){
  module.exports = multiply
  
  /**
   * Multiplies two vec4's
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @returns {vec4} out
   */
  function multiply (out, a, b) {
    out[0] = a[0] * b[0]
    out[1] = a[1] * b[1]
    out[2] = a[2] * b[2]
    out[3] = a[3] * b[3]
    return out
  }
  
  },{}],394:[function(_dereq_,module,exports){
  module.exports = negate
  
  /**
   * Negates the components of a vec4
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a vector to negate
   * @returns {vec4} out
   */
  function negate (out, a) {
    out[0] = -a[0]
    out[1] = -a[1]
    out[2] = -a[2]
    out[3] = -a[3]
    return out
  }
  
  },{}],395:[function(_dereq_,module,exports){
  module.exports = normalize
  
  /**
   * Normalize a vec4
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a vector to normalize
   * @returns {vec4} out
   */
  function normalize (out, a) {
    var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3]
    var len = x * x + y * y + z * z + w * w
    if (len > 0) {
      len = 1 / Math.sqrt(len)
      out[0] = x * len
      out[1] = y * len
      out[2] = z * len
      out[3] = w * len
    }
    return out
  }
  
  },{}],396:[function(_dereq_,module,exports){
  var vecNormalize = _dereq_('./normalize')
  var vecScale = _dereq_('./scale')
  
  module.exports = random
  
  /**
   * Generates a random vector with the given scale
   *
   * @param {vec4} out the receiving vector
   * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
   * @returns {vec4} out
   */
  function random (out, scale) {
    scale = scale || 1.0
  
    // TODO: This is a pretty awful way of doing this. Find something better.
    out[0] = Math.random()
    out[1] = Math.random()
    out[2] = Math.random()
    out[3] = Math.random()
    vecNormalize(out, out)
    vecScale(out, out, scale)
    return out
  }
  
  },{"./normalize":395,"./scale":397}],397:[function(_dereq_,module,exports){
  module.exports = scale
  
  /**
   * Scales a vec4 by a scalar number
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the vector to scale
   * @param {Number} b amount to scale the vector by
   * @returns {vec4} out
   */
  function scale (out, a, b) {
    out[0] = a[0] * b
    out[1] = a[1] * b
    out[2] = a[2] * b
    out[3] = a[3] * b
    return out
  }
  
  },{}],398:[function(_dereq_,module,exports){
  module.exports = scaleAndAdd
  
  /**
   * Adds two vec4's after scaling the second operand by a scalar value
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @param {Number} scale the amount to scale b by before adding
   * @returns {vec4} out
   */
  function scaleAndAdd (out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale)
    out[1] = a[1] + (b[1] * scale)
    out[2] = a[2] + (b[2] * scale)
    out[3] = a[3] + (b[3] * scale)
    return out
  }
  
  },{}],399:[function(_dereq_,module,exports){
  module.exports = set
  
  /**
   * Set the components of a vec4 to the given values
   *
   * @param {vec4} out the receiving vector
   * @param {Number} x X component
   * @param {Number} y Y component
   * @param {Number} z Z component
   * @param {Number} w W component
   * @returns {vec4} out
   */
  function set (out, x, y, z, w) {
    out[0] = x
    out[1] = y
    out[2] = z
    out[3] = w
    return out
  }
  
  },{}],400:[function(_dereq_,module,exports){
  module.exports = squaredDistance
  
  /**
   * Calculates the squared euclidian distance between two vec4's
   *
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @returns {Number} squared distance between a and b
   */
  function squaredDistance (a, b) {
    var x = b[0] - a[0],
      y = b[1] - a[1],
      z = b[2] - a[2],
      w = b[3] - a[3]
    return x * x + y * y + z * z + w * w
  }
  
  },{}],401:[function(_dereq_,module,exports){
  module.exports = squaredLength
  
  /**
   * Calculates the squared length of a vec4
   *
   * @param {vec4} a vector to calculate squared length of
   * @returns {Number} squared length of a
   */
  function squaredLength (a) {
    var x = a[0],
      y = a[1],
      z = a[2],
      w = a[3]
    return x * x + y * y + z * z + w * w
  }
  
  },{}],402:[function(_dereq_,module,exports){
  module.exports = subtract
  
  /**
   * Subtracts vector b from vector a
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the first operand
   * @param {vec4} b the second operand
   * @returns {vec4} out
   */
  function subtract (out, a, b) {
    out[0] = a[0] - b[0]
    out[1] = a[1] - b[1]
    out[2] = a[2] - b[2]
    out[3] = a[3] - b[3]
    return out
  }
  
  },{}],403:[function(_dereq_,module,exports){
  module.exports = transformMat4
  
  /**
   * Transforms the vec4 with a mat4.
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the vector to transform
   * @param {mat4} m matrix to transform with
   * @returns {vec4} out
   */
  function transformMat4 (out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3]
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w
    return out
  }
  
  },{}],404:[function(_dereq_,module,exports){
  module.exports = transformQuat
  
  /**
   * Transforms the vec4 with a quat
   *
   * @param {vec4} out the receiving vector
   * @param {vec4} a the vector to transform
   * @param {quat} q quaternion to transform with
   * @returns {vec4} out
   */
  function transformQuat (out, a, q) {
    var x = a[0], y = a[1], z = a[2],
      qx = q[0], qy = q[1], qz = q[2], qw = q[3],
  
      // calculate quat * vec
      ix = qw * x + qy * z - qz * y,
      iy = qw * y + qz * x - qx * z,
      iz = qw * z + qx * y - qy * x,
      iw = -qx * x - qy * y - qz * z
  
    // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx
    out[3] = a[3]
    return out
  }
  
  },{}],405:[function(_dereq_,module,exports){
  var tokenize = _dereq_('glsl-tokenizer')
  var atob     = _dereq_('atob-lite')
  
  module.exports = getName
  
  function getName(src) {
    var tokens = Array.isArray(src)
      ? src
      : tokenize(src)
  
    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]
      if (token.type !== 'preprocessor') continue
      var match = token.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/)
      if (!match) continue
      if (!match[2]) continue
  
      var b64  = match[1]
      var name = match[2]
  
      return (b64 ? atob(name) : name).trim()
    }
  }
  
  },{"atob-lite":77,"glsl-tokenizer":412}],406:[function(_dereq_,module,exports){
  module.exports = tokenize
  
  var literals100 = _dereq_('./lib/literals')
    , operators = _dereq_('./lib/operators')
    , builtins100 = _dereq_('./lib/builtins')
    , literals300es = _dereq_('./lib/literals-300es')
    , builtins300es = _dereq_('./lib/builtins-300es')
  
  var NORMAL = 999          // <-- never emitted
    , TOKEN = 9999          // <-- never emitted
    , BLOCK_COMMENT = 0
    , LINE_COMMENT = 1
    , PREPROCESSOR = 2
    , OPERATOR = 3
    , INTEGER = 4
    , FLOAT = 5
    , IDENT = 6
    , BUILTIN = 7
    , KEYWORD = 8
    , WHITESPACE = 9
    , EOF = 10
    , HEX = 11
  
  var map = [
      'block-comment'
    , 'line-comment'
    , 'preprocessor'
    , 'operator'
    , 'integer'
    , 'float'
    , 'ident'
    , 'builtin'
    , 'keyword'
    , 'whitespace'
    , 'eof'
    , 'integer'
  ]
  
  function tokenize(opt) {
    var i = 0
      , total = 0
      , mode = NORMAL
      , c
      , last
      , content = []
      , tokens = []
      , token_idx = 0
      , token_offs = 0
      , line = 1
      , col = 0
      , start = 0
      , isnum = false
      , isoperator = false
      , input = ''
      , len
  
    opt = opt || {}
    var allBuiltins = builtins100
    var allLiterals = literals100
    if (opt.version === '300 es') {
      allBuiltins = builtins300es
      allLiterals = literals300es
    }
  
    // cache by name
    var builtinsDict = {}, literalsDict = {}
    for (var i = 0; i < allBuiltins.length; i++) {
      builtinsDict[allBuiltins[i]] = true
    }
    for (var i = 0; i < allLiterals.length; i++) {
      literalsDict[allLiterals[i]] = true
    }
  
    return function(data) {
      tokens = []
      if (data !== null) return write(data)
      return end()
    }
  
    function token(data) {
      if (data.length) {
        tokens.push({
          type: map[mode]
        , data: data
        , position: start
        , line: line
        , column: col
        })
      }
    }
  
    function write(chunk) {
      i = 0
  
      if (chunk.toString) chunk = chunk.toString()
  
      input += chunk.replace(/\r\n/g, '\n')
      len = input.length
  
  
      var last
  
      while(c = input[i], i < len) {
        last = i
  
        switch(mode) {
          case BLOCK_COMMENT: i = block_comment(); break
          case LINE_COMMENT: i = line_comment(); break
          case PREPROCESSOR: i = preprocessor(); break
          case OPERATOR: i = operator(); break
          case INTEGER: i = integer(); break
          case HEX: i = hex(); break
          case FLOAT: i = decimal(); break
          case TOKEN: i = readtoken(); break
          case WHITESPACE: i = whitespace(); break
          case NORMAL: i = normal(); break
        }
  
        if(last !== i) {
          switch(input[last]) {
            case '\n': col = 0; ++line; break
            default: ++col; break
          }
        }
      }
  
      total += i
      input = input.slice(i)
      return tokens
    }
  
    function end(chunk) {
      if(content.length) {
        token(content.join(''))
      }
  
      mode = EOF
      token('(eof)')
      return tokens
    }
  
    function normal() {
      content = content.length ? [] : content
  
      if(last === '/' && c === '*') {
        start = total + i - 1
        mode = BLOCK_COMMENT
        last = c
        return i + 1
      }
  
      if(last === '/' && c === '/') {
        start = total + i - 1
        mode = LINE_COMMENT
        last = c
        return i + 1
      }
  
      if(c === '#') {
        mode = PREPROCESSOR
        start = total + i
        return i
      }
  
      if(/\s/.test(c)) {
        mode = WHITESPACE
        start = total + i
        return i
      }
  
      isnum = /\d/.test(c)
      isoperator = /[^\w_]/.test(c)
  
      start = total + i
      mode = isnum ? INTEGER : isoperator ? OPERATOR : TOKEN
      return i
    }
  
    function whitespace() {
      if(/[^\s]/g.test(c)) {
        token(content.join(''))
        mode = NORMAL
        return i
      }
      content.push(c)
      last = c
      return i + 1
    }
  
    function preprocessor() {
      if((c === '\r' || c === '\n') && last !== '\\') {
        token(content.join(''))
        mode = NORMAL
        return i
      }
      content.push(c)
      last = c
      return i + 1
    }
  
    function line_comment() {
      return preprocessor()
    }
  
    function block_comment() {
      if(c === '/' && last === '*') {
        content.push(c)
        token(content.join(''))
        mode = NORMAL
        return i + 1
      }
  
      content.push(c)
      last = c
      return i + 1
    }
  
    function operator() {
      if(last === '.' && /\d/.test(c)) {
        mode = FLOAT
        return i
      }
  
      if(last === '/' && c === '*') {
        mode = BLOCK_COMMENT
        return i
      }
  
      if(last === '/' && c === '/') {
        mode = LINE_COMMENT
        return i
      }
  
      if(c === '.' && content.length) {
        while(determine_operator(content));
  
        mode = FLOAT
        return i
      }
  
      if(c === ';' || c === ')' || c === '(') {
        if(content.length) while(determine_operator(content));
        token(c)
        mode = NORMAL
        return i + 1
      }
  
      var is_composite_operator = content.length === 2 && c !== '='
      if(/[\w_\d\s]/.test(c) || is_composite_operator) {
        while(determine_operator(content));
        mode = NORMAL
        return i
      }
  
      content.push(c)
      last = c
      return i + 1
    }
  
    function determine_operator(buf) {
      var j = 0
        , idx
        , res
  
      do {
        idx = operators.indexOf(buf.slice(0, buf.length + j).join(''))
        res = operators[idx]
  
        if(idx === -1) {
          if(j-- + buf.length > 0) continue
          res = buf.slice(0, 1).join('')
        }
  
        token(res)
  
        start += res.length
        content = content.slice(res.length)
        return content.length
      } while(1)
    }
  
    function hex() {
      if(/[^a-fA-F0-9]/.test(c)) {
        token(content.join(''))
        mode = NORMAL
        return i
      }
  
      content.push(c)
      last = c
      return i + 1
    }
  
    function integer() {
      if(c === '.') {
        content.push(c)
        mode = FLOAT
        last = c
        return i + 1
      }
  
      if(/[eE]/.test(c)) {
        content.push(c)
        mode = FLOAT
        last = c
        return i + 1
      }
  
      if(c === 'x' && content.length === 1 && content[0] === '0') {
        mode = HEX
        content.push(c)
        last = c
        return i + 1
      }
  
      if(/[^\d]/.test(c)) {
        token(content.join(''))
        mode = NORMAL
        return i
      }
  
      content.push(c)
      last = c
      return i + 1
    }
  
    function decimal() {
      if(c === 'f') {
        content.push(c)
        last = c
        i += 1
      }
  
      if(/[eE]/.test(c)) {
        content.push(c)
        last = c
        return i + 1
      }
  
      if ((c === '-' || c === '+') && /[eE]/.test(last)) {
        content.push(c)
        last = c
        return i + 1
      }
  
      if(/[^\d]/.test(c)) {
        token(content.join(''))
        mode = NORMAL
        return i
      }
  
      content.push(c)
      last = c
      return i + 1
    }
  
    function readtoken() {
      if(/[^\d\w_]/.test(c)) {
        var contentstr = content.join('')
        if(literalsDict[contentstr]) {
          mode = KEYWORD
        } else if(builtinsDict[contentstr]) {
          mode = BUILTIN
        } else {
          mode = IDENT
        }
        token(content.join(''))
        mode = NORMAL
        return i
      }
      content.push(c)
      last = c
      return i + 1
    }
  }
  
  },{"./lib/builtins":408,"./lib/builtins-300es":407,"./lib/literals":410,"./lib/literals-300es":409,"./lib/operators":411}],407:[function(_dereq_,module,exports){
  // 300es builtins/reserved words that were previously valid in v100
  var v100 = _dereq_('./builtins')
  
  // The texture2D|Cube functions have been removed
  // And the gl_ features are updated
  v100 = v100.slice().filter(function (b) {
    return !/^(gl\_|texture)/.test(b)
  })
  
  module.exports = v100.concat([
    // the updated gl_ constants
      'gl_VertexID'
    , 'gl_InstanceID'
    , 'gl_Position'
    , 'gl_PointSize'
    , 'gl_FragCoord'
    , 'gl_FrontFacing'
    , 'gl_FragDepth'
    , 'gl_PointCoord'
    , 'gl_MaxVertexAttribs'
    , 'gl_MaxVertexUniformVectors'
    , 'gl_MaxVertexOutputVectors'
    , 'gl_MaxFragmentInputVectors'
    , 'gl_MaxVertexTextureImageUnits'
    , 'gl_MaxCombinedTextureImageUnits'
    , 'gl_MaxTextureImageUnits'
    , 'gl_MaxFragmentUniformVectors'
    , 'gl_MaxDrawBuffers'
    , 'gl_MinProgramTexelOffset'
    , 'gl_MaxProgramTexelOffset'
    , 'gl_DepthRangeParameters'
    , 'gl_DepthRange'
  
    // other builtins
    , 'trunc'
    , 'round'
    , 'roundEven'
    , 'isnan'
    , 'isinf'
    , 'floatBitsToInt'
    , 'floatBitsToUint'
    , 'intBitsToFloat'
    , 'uintBitsToFloat'
    , 'packSnorm2x16'
    , 'unpackSnorm2x16'
    , 'packUnorm2x16'
    , 'unpackUnorm2x16'
    , 'packHalf2x16'
    , 'unpackHalf2x16'
    , 'outerProduct'
    , 'transpose'
    , 'determinant'
    , 'inverse'
    , 'texture'
    , 'textureSize'
    , 'textureProj'
    , 'textureLod'
    , 'textureOffset'
    , 'texelFetch'
    , 'texelFetchOffset'
    , 'textureProjOffset'
    , 'textureLodOffset'
    , 'textureProjLod'
    , 'textureProjLodOffset'
    , 'textureGrad'
    , 'textureGradOffset'
    , 'textureProjGrad'
    , 'textureProjGradOffset'
  ])
  
  },{"./builtins":408}],408:[function(_dereq_,module,exports){
  module.exports = [
    // Keep this list sorted
    'abs'
    , 'acos'
    , 'all'
    , 'any'
    , 'asin'
    , 'atan'
    , 'ceil'
    , 'clamp'
    , 'cos'
    , 'cross'
    , 'dFdx'
    , 'dFdy'
    , 'degrees'
    , 'distance'
    , 'dot'
    , 'equal'
    , 'exp'
    , 'exp2'
    , 'faceforward'
    , 'floor'
    , 'fract'
    , 'gl_BackColor'
    , 'gl_BackLightModelProduct'
    , 'gl_BackLightProduct'
    , 'gl_BackMaterial'
    , 'gl_BackSecondaryColor'
    , 'gl_ClipPlane'
    , 'gl_ClipVertex'
    , 'gl_Color'
    , 'gl_DepthRange'
    , 'gl_DepthRangeParameters'
    , 'gl_EyePlaneQ'
    , 'gl_EyePlaneR'
    , 'gl_EyePlaneS'
    , 'gl_EyePlaneT'
    , 'gl_Fog'
    , 'gl_FogCoord'
    , 'gl_FogFragCoord'
    , 'gl_FogParameters'
    , 'gl_FragColor'
    , 'gl_FragCoord'
    , 'gl_FragData'
    , 'gl_FragDepth'
    , 'gl_FragDepthEXT'
    , 'gl_FrontColor'
    , 'gl_FrontFacing'
    , 'gl_FrontLightModelProduct'
    , 'gl_FrontLightProduct'
    , 'gl_FrontMaterial'
    , 'gl_FrontSecondaryColor'
    , 'gl_LightModel'
    , 'gl_LightModelParameters'
    , 'gl_LightModelProducts'
    , 'gl_LightProducts'
    , 'gl_LightSource'
    , 'gl_LightSourceParameters'
    , 'gl_MaterialParameters'
    , 'gl_MaxClipPlanes'
    , 'gl_MaxCombinedTextureImageUnits'
    , 'gl_MaxDrawBuffers'
    , 'gl_MaxFragmentUniformComponents'
    , 'gl_MaxLights'
    , 'gl_MaxTextureCoords'
    , 'gl_MaxTextureImageUnits'
    , 'gl_MaxTextureUnits'
    , 'gl_MaxVaryingFloats'
    , 'gl_MaxVertexAttribs'
    , 'gl_MaxVertexTextureImageUnits'
    , 'gl_MaxVertexUniformComponents'
    , 'gl_ModelViewMatrix'
    , 'gl_ModelViewMatrixInverse'
    , 'gl_ModelViewMatrixInverseTranspose'
    , 'gl_ModelViewMatrixTranspose'
    , 'gl_ModelViewProjectionMatrix'
    , 'gl_ModelViewProjectionMatrixInverse'
    , 'gl_ModelViewProjectionMatrixInverseTranspose'
    , 'gl_ModelViewProjectionMatrixTranspose'
    , 'gl_MultiTexCoord0'
    , 'gl_MultiTexCoord1'
    , 'gl_MultiTexCoord2'
    , 'gl_MultiTexCoord3'
    , 'gl_MultiTexCoord4'
    , 'gl_MultiTexCoord5'
    , 'gl_MultiTexCoord6'
    , 'gl_MultiTexCoord7'
    , 'gl_Normal'
    , 'gl_NormalMatrix'
    , 'gl_NormalScale'
    , 'gl_ObjectPlaneQ'
    , 'gl_ObjectPlaneR'
    , 'gl_ObjectPlaneS'
    , 'gl_ObjectPlaneT'
    , 'gl_Point'
    , 'gl_PointCoord'
    , 'gl_PointParameters'
    , 'gl_PointSize'
    , 'gl_Position'
    , 'gl_ProjectionMatrix'
    , 'gl_ProjectionMatrixInverse'
    , 'gl_ProjectionMatrixInverseTranspose'
    , 'gl_ProjectionMatrixTranspose'
    , 'gl_SecondaryColor'
    , 'gl_TexCoord'
    , 'gl_TextureEnvColor'
    , 'gl_TextureMatrix'
    , 'gl_TextureMatrixInverse'
    , 'gl_TextureMatrixInverseTranspose'
    , 'gl_TextureMatrixTranspose'
    , 'gl_Vertex'
    , 'greaterThan'
    , 'greaterThanEqual'
    , 'inversesqrt'
    , 'length'
    , 'lessThan'
    , 'lessThanEqual'
    , 'log'
    , 'log2'
    , 'matrixCompMult'
    , 'max'
    , 'min'
    , 'mix'
    , 'mod'
    , 'normalize'
    , 'not'
    , 'notEqual'
    , 'pow'
    , 'radians'
    , 'reflect'
    , 'refract'
    , 'sign'
    , 'sin'
    , 'smoothstep'
    , 'sqrt'
    , 'step'
    , 'tan'
    , 'texture2D'
    , 'texture2DLod'
    , 'texture2DProj'
    , 'texture2DProjLod'
    , 'textureCube'
    , 'textureCubeLod'
    , 'texture2DLodEXT'
    , 'texture2DProjLodEXT'
    , 'textureCubeLodEXT'
    , 'texture2DGradEXT'
    , 'texture2DProjGradEXT'
    , 'textureCubeGradEXT'
  ]
  
  },{}],409:[function(_dereq_,module,exports){
  var v100 = _dereq_('./literals')
  
  module.exports = v100.slice().concat([
     'layout'
    , 'centroid'
    , 'smooth'
    , 'case'
    , 'mat2x2'
    , 'mat2x3'
    , 'mat2x4'
    , 'mat3x2'
    , 'mat3x3'
    , 'mat3x4'
    , 'mat4x2'
    , 'mat4x3'
    , 'mat4x4'
    , 'uvec2'
    , 'uvec3'
    , 'uvec4'
    , 'samplerCubeShadow'
    , 'sampler2DArray'
    , 'sampler2DArrayShadow'
    , 'isampler2D'
    , 'isampler3D'
    , 'isamplerCube'
    , 'isampler2DArray'
    , 'usampler2D'
    , 'usampler3D'
    , 'usamplerCube'
    , 'usampler2DArray'
    , 'coherent'
    , 'restrict'
    , 'readonly'
    , 'writeonly'
    , 'resource'
    , 'atomic_uint'
    , 'noperspective'
    , 'patch'
    , 'sample'
    , 'subroutine'
    , 'common'
    , 'partition'
    , 'active'
    , 'filter'
    , 'image1D'
    , 'image2D'
    , 'image3D'
    , 'imageCube'
    , 'iimage1D'
    , 'iimage2D'
    , 'iimage3D'
    , 'iimageCube'
    , 'uimage1D'
    , 'uimage2D'
    , 'uimage3D'
    , 'uimageCube'
    , 'image1DArray'
    , 'image2DArray'
    , 'iimage1DArray'
    , 'iimage2DArray'
    , 'uimage1DArray'
    , 'uimage2DArray'
    , 'image1DShadow'
    , 'image2DShadow'
    , 'image1DArrayShadow'
    , 'image2DArrayShadow'
    , 'imageBuffer'
    , 'iimageBuffer'
    , 'uimageBuffer'
    , 'sampler1DArray'
    , 'sampler1DArrayShadow'
    , 'isampler1D'
    , 'isampler1DArray'
    , 'usampler1D'
    , 'usampler1DArray'
    , 'isampler2DRect'
    , 'usampler2DRect'
    , 'samplerBuffer'
    , 'isamplerBuffer'
    , 'usamplerBuffer'
    , 'sampler2DMS'
    , 'isampler2DMS'
    , 'usampler2DMS'
    , 'sampler2DMSArray'
    , 'isampler2DMSArray'
    , 'usampler2DMSArray'
  ])
  
  },{"./literals":410}],410:[function(_dereq_,module,exports){
  module.exports = [
    // current
      'precision'
    , 'highp'
    , 'mediump'
    , 'lowp'
    , 'attribute'
    , 'const'
    , 'uniform'
    , 'varying'
    , 'break'
    , 'continue'
    , 'do'
    , 'for'
    , 'while'
    , 'if'
    , 'else'
    , 'in'
    , 'out'
    , 'inout'
    , 'float'
    , 'int'
    , 'uint'
    , 'void'
    , 'bool'
    , 'true'
    , 'false'
    , 'discard'
    , 'return'
    , 'mat2'
    , 'mat3'
    , 'mat4'
    , 'vec2'
    , 'vec3'
    , 'vec4'
    , 'ivec2'
    , 'ivec3'
    , 'ivec4'
    , 'bvec2'
    , 'bvec3'
    , 'bvec4'
    , 'sampler1D'
    , 'sampler2D'
    , 'sampler3D'
    , 'samplerCube'
    , 'sampler1DShadow'
    , 'sampler2DShadow'
    , 'struct'
  
    // future
    , 'asm'
    , 'class'
    , 'union'
    , 'enum'
    , 'typedef'
    , 'template'
    , 'this'
    , 'packed'
    , 'goto'
    , 'switch'
    , 'default'
    , 'inline'
    , 'noinline'
    , 'volatile'
    , 'public'
    , 'static'
    , 'extern'
    , 'external'
    , 'interface'
    , 'long'
    , 'short'
    , 'double'
    , 'half'
    , 'fixed'
    , 'unsigned'
    , 'input'
    , 'output'
    , 'hvec2'
    , 'hvec3'
    , 'hvec4'
    , 'dvec2'
    , 'dvec3'
    , 'dvec4'
    , 'fvec2'
    , 'fvec3'
    , 'fvec4'
    , 'sampler2DRect'
    , 'sampler3DRect'
    , 'sampler2DRectShadow'
    , 'sizeof'
    , 'cast'
    , 'namespace'
    , 'using'
  ]
  
  },{}],411:[function(_dereq_,module,exports){
  module.exports = [
      '<<='
    , '>>='
    , '++'
    , '--'
    , '<<'
    , '>>'
    , '<='
    , '>='
    , '=='
    , '!='
    , '&&'
    , '||'
    , '+='
    , '-='
    , '*='
    , '/='
    , '%='
    , '&='
    , '^^'
    , '^='
    , '|='
    , '('
    , ')'
    , '['
    , ']'
    , '.'
    , '!'
    , '~'
    , '*'
    , '/'
    , '%'
    , '+'
    , '-'
    , '<'
    , '>'
    , '&'
    , '^'
    , '|'
    , '?'
    , ':'
    , '='
    , ','
    , ';'
    , '{'
    , '}'
  ]
  
  },{}],412:[function(_dereq_,module,exports){
  var tokenize = _dereq_('./index')
  
  module.exports = tokenizeString
  
  function tokenizeString(str, opt) {
    var generator = tokenize(opt)
    var tokens = []
  
    tokens = tokens.concat(generator(str))
    tokens = tokens.concat(generator(null))
  
    return tokens
  }
  
  },{"./index":406}],413:[function(_dereq_,module,exports){
  module.exports = function(strings) {
    if (typeof strings === 'string') strings = [strings]
    var exprs = [].slice.call(arguments,1)
    var parts = []
    for (var i = 0; i < strings.length-1; i++) {
      parts.push(strings[i], exprs[i] || '')
    }
    parts.push(strings[i])
    return parts.join('')
  }
  
  },{}],414:[function(_dereq_,module,exports){
  (function (global){
  'use strict'
  
  var isBrowser = _dereq_('is-browser')
  var hasHover
  
  if (typeof global.matchMedia === 'function') {
    hasHover = !global.matchMedia('(hover: none)').matches
  }
  else {
    hasHover = isBrowser
  }
  
  module.exports = hasHover
  
  }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{"is-browser":438}],415:[function(_dereq_,module,exports){
  'use strict'
  
  var isBrowser = _dereq_('is-browser')
  
  function detect() {
    var supported = false
  
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function() {
          supported = true
        }
      })
  
      window.addEventListener('test', null, opts)
      window.removeEventListener('test', null, opts)
    } catch(e) {
      supported = false
    }
  
    return supported
  }
  
  module.exports = isBrowser && detect()
  
  },{"is-browser":438}],416:[function(_dereq_,module,exports){
  exports.read = function (buffer, offset, isLE, mLen, nBytes) {
    var e, m
    var eLen = (nBytes * 8) - mLen - 1
    var eMax = (1 << eLen) - 1
    var eBias = eMax >> 1
    var nBits = -7
    var i = isLE ? (nBytes - 1) : 0
    var d = isLE ? -1 : 1
    var s = buffer[offset + i]
  
    i += d
  
    e = s & ((1 << (-nBits)) - 1)
    s >>= (-nBits)
    nBits += eLen
    for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
  
    m = e & ((1 << (-nBits)) - 1)
    e >>= (-nBits)
    nBits += mLen
    for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
  
    if (e === 0) {
      e = 1 - eBias
    } else if (e === eMax) {
      return m ? NaN : ((s ? -1 : 1) * Infinity)
    } else {
      m = m + Math.pow(2, mLen)
      e = e - eBias
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
  }
  
  exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c
    var eLen = (nBytes * 8) - mLen - 1
    var eMax = (1 << eLen) - 1
    var eBias = eMax >> 1
    var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
    var i = isLE ? 0 : (nBytes - 1)
    var d = isLE ? 1 : -1
    var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
  
    value = Math.abs(value)
  
    if (isNaN(value) || value === Infinity) {
      m = isNaN(value) ? 1 : 0
      e = eMax
    } else {
      e = Math.floor(Math.log(value) / Math.LN2)
      if (value * (c = Math.pow(2, -e)) < 1) {
        e--
        c *= 2
      }
      if (e + eBias >= 1) {
        value += rt / c
      } else {
        value += rt * Math.pow(2, 1 - eBias)
      }
      if (value * c >= 2) {
        e++
        c /= 2
      }
  
      if (e + eBias >= eMax) {
        m = 0
        e = eMax
      } else if (e + eBias >= 1) {
        m = ((value * c) - 1) * Math.pow(2, mLen)
        e = e + eBias
      } else {
        m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
        e = 0
      }
    }
  
    for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
  
    e = (e << mLen) | m
    eLen += mLen
    for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
  
    buffer[offset + i - d] |= s * 128
  }
  
  },{}],417:[function(_dereq_,module,exports){
  'use strict';
  
  var typeHandlers = _dereq_('./types');
  
  module.exports = function (buffer, filepath) {
    var type, result;
    for (type in typeHandlers) {
      result = typeHandlers[type].detect(buffer, filepath);
      if (result) {
        return type;
      }
    }
  };
  
  },{"./types":420}],418:[function(_dereq_,module,exports){
  (function (Buffer){
  'use strict';
  
  var fs = _dereq_('fs');
  var path = _dereq_('path');
  
  var typeHandlers = _dereq_('./types');
  var detector = _dereq_('./detector');
  
  // Maximum buffer size, with a default of 512 kilobytes.
  // TO-DO: make this adaptive based on the initial signature of the image
  var MaxBufferSize = 512*1024;
  
  /**
   * Return size information based on a buffer
   *
   * @param {Buffer} buffer
   * @param {String} filepath
   * @returns {Object}
   */
  function lookup (buffer, filepath) {
    // detect the file type.. don't rely on the extension
    var type = detector(buffer, filepath);
  
    // find an appropriate handler for this file type
    if (type in typeHandlers) {
      var size = typeHandlers[type].calculate(buffer, filepath);
      if (size !== false) {
        size.type = type;
        return size;
      }
    }
  
    // throw up, if we don't understand the file
    throw new TypeError('unsupported file type: ' + type + ' (file: ' + filepath + ')');
  }
  
  /**
   * Reads a file into a buffer.
   *
   * The callback will be called after the process has completed. The
   * callback's first argument will be an error (or null). The second argument
   * will be the Buffer, if the operation was successful.
   *
   * @param {String} filepath
   * @param {Function} callback
   */
  function asyncFileToBuffer (filepath, callback) {
    // open the file in read only mode
    fs.open(filepath, 'r', function (err, descriptor) {
      if (err) { return callback(err); }
      fs.fstat(descriptor, function (err, stats) {
        if (err) { return callback(err); }
        var size = stats.size;
        if (size <= 0) {
          return callback(new Error('File size is not greater than 0 —— ' + filepath));
        }
        var bufferSize = Math.min(size, MaxBufferSize);
        var buffer = Buffer.alloc(bufferSize);
        // read first buffer block from the file, asynchronously
        fs.read(descriptor, buffer, 0, bufferSize, 0, function (err) {
          if (err) { return callback(err); }
          // close the file, we are done
          fs.close(descriptor, function (err) {
            callback(err, buffer);
          });
        });
      });
    });
  }
  
  /**
   * Synchronously reads a file into a buffer, blocking the nodejs process.
   *
   * @param {String} filepath
   * @returns {Buffer}
   */
  function syncFileToBuffer (filepath) {
    // read from the file, synchronously
    var descriptor = fs.openSync(filepath, 'r');
    var size = fs.fstatSync(descriptor).size;
    var bufferSize = Math.min(size, MaxBufferSize);
    var buffer = Buffer.alloc(bufferSize);
    fs.readSync(descriptor, buffer, 0, bufferSize, 0);
    fs.closeSync(descriptor);
    return buffer;
  }
  
  /**
   * @param {Buffer|string} input - buffer or relative/absolute path of the image file
   * @param {Function=} callback - optional function for async detection
   */
  module.exports = function (input, callback) {
  
    // Handle buffer input
    if (Buffer.isBuffer(input)) {
      return lookup(input);
    }
  
    // input should be a string at this point
    if (typeof input !== 'string') {
      throw new TypeError('invalid invocation');
    }
  
    // resolve the file path
    var filepath = path.resolve(input);
  
    if (typeof callback === 'function') {
      asyncFileToBuffer(filepath, function (err, buffer) {
        if (err) { return callback(err); }
  
        // return the dimensions
        var dimensions;
        try {
          dimensions = lookup(buffer, filepath);
        } catch (e) {
          err = e;
        }
        callback(err, dimensions);
      });
    } else {
      var buffer = syncFileToBuffer(filepath);
      return lookup(buffer, filepath);
    }
  };
  
  module.exports.types = Object.keys(typeHandlers);
  
  }).call(this,_dereq_("buffer").Buffer)
  },{"./detector":417,"./types":420,"buffer":111,"fs":109,"path":481}],419:[function(_dereq_,module,exports){
  'use strict';
  
  // Abstract reading multi-byte unsigned integers
  function readUInt (buffer, bits, offset, isBigEndian) {
    offset = offset || 0;
    var endian = isBigEndian ? 'BE' : 'LE';
    var method = buffer['readUInt' + bits + endian];
    return method.call(buffer, offset);
  }
  
  module.exports = readUInt;
  
  },{}],420:[function(_dereq_,module,exports){
  'use strict';
  
  // load all available handlers for browserify support
  var typeHandlers = {
    bmp: _dereq_('./types/bmp'),
    cur: _dereq_('./types/cur'),
    dds: _dereq_('./types/dds'),
    gif: _dereq_('./types/gif'),
    icns: _dereq_('./types/icns'),
    ico: _dereq_('./types/ico'),
    jpg: _dereq_('./types/jpg'),
    png: _dereq_('./types/png'),
    psd: _dereq_('./types/psd'),
    svg: _dereq_('./types/svg'),
    tiff: _dereq_('./types/tiff'),
    webp: _dereq_('./types/webp'),
  };
  
  module.exports = typeHandlers;
  
  },{"./types/bmp":421,"./types/cur":422,"./types/dds":423,"./types/gif":424,"./types/icns":425,"./types/ico":426,"./types/jpg":427,"./types/png":428,"./types/psd":429,"./types/svg":430,"./types/tiff":431,"./types/webp":432}],421:[function(_dereq_,module,exports){
  'use strict';
  
  function isBMP (buffer) {
    return ('BM' === buffer.toString('ascii', 0, 2));
  }
  
  function calculate (buffer) {
    return {
      'width': buffer.readUInt32LE(18),
      'height': Math.abs(buffer.readInt32LE(22))
    };
  }
  
  module.exports = {
    'detect': isBMP,
    'calculate': calculate
  };
  
  },{}],422:[function(_dereq_,module,exports){
  'use strict';
  
  var TYPE_CURSOR = 2;
  
  function isCUR (buffer) {
    var type;
    if (buffer.readUInt16LE(0) !== 0) {
      return false;
    }
    type = buffer.readUInt16LE(2);
    return type === TYPE_CURSOR;
  }
  
  module.exports = {
    'detect': isCUR,
    'calculate': _dereq_('./ico').calculate
  };
  
  },{"./ico":426}],423:[function(_dereq_,module,exports){
  'use strict';
  
  function isDDS(buffer){
    return buffer.readUInt32LE(0) === 0x20534444;
  }
  
  function calculate(buffer){
    // read file resolution metadata
    return {
      'height': buffer.readUInt32LE(12),
      'width': buffer.readUInt32LE(16)
    };
  }
  
  module.exports = {
    'detect': isDDS,
    'calculate': calculate
  };
  
  },{}],424:[function(_dereq_,module,exports){
  'use strict';
  
  var gifRegexp = /^GIF8[79]a/;
  function isGIF (buffer) {
    var signature = buffer.toString('ascii', 0, 6);
    return (gifRegexp.test(signature));
  }
  
  function calculate(buffer) {
    return {
      'width': buffer.readUInt16LE(6),
      'height': buffer.readUInt16LE(8)
    };
  }
  
  module.exports = {
    'detect': isGIF,
    'calculate': calculate
  };
  
  },{}],425:[function(_dereq_,module,exports){
  'use strict';
  
  /**
   * ICNS Header
   *
   * | Offset | Size | Purpose                                                |
   * | 0	    | 4    | Magic literal, must be "icns" (0x69, 0x63, 0x6e, 0x73) |
   * | 4      | 4    | Length of file, in bytes, msb first.                   |
   *
   **/
  var SIZE_HEADER = 4 + 4; // 8
  var FILE_LENGTH_OFFSET = 4; // MSB => BIG ENDIAN
  
  /**
   * Image Entry
   *
   * | Offset | Size | Purpose                                                          |
   * | 0	    | 4    | Icon type, see OSType below.                                     |
   * | 4      | 4    | Length of data, in bytes (including type and length), msb first. |
   * | 8      | n    | Icon data                                                        |
   *
   **/
  var ENTRY_LENGTH_OFFSET = 4; // MSB => BIG ENDIAN
  
  function isICNS (buffer) {
    return ('icns' === buffer.toString('ascii', 0, 4));
  }
  
  var ICON_TYPE_SIZE = {
    ICON: 32,
    'ICN#': 32,
    // m => 16 x 16
    'icm#': 16,
    icm4: 16,
    icm8: 16,
    // s => 16 x 16
    'ics#': 16,
    ics4: 16,
    ics8: 16,
    is32: 16,
    s8mk: 16,
    icp4: 16,
    // l => 32 x 32
    icl4: 32,
    icl8: 32,
    il32: 32,
    l8mk: 32,
    icp5: 32,
    ic11: 32,
    // h => 48 x 48
    ich4: 48,
    ich8: 48,
    ih32: 48,
    h8mk: 48,
    // . => 64 x 64
    icp6: 64,
    ic12: 32,
    // t => 128 x 128
    it32: 128,
    t8mk: 128,
    ic07: 128,
    // . => 256 x 256
    ic08: 256,
    ic13: 256,
    // . => 512 x 512
    ic09: 512,
    ic14: 512,
    // . => 1024 x 1024
    ic10: 1024,
  };
  
  function readImageHeader(buffer, imageOffset) {
    var imageLengthOffset = imageOffset + ENTRY_LENGTH_OFFSET;
    // returns [type, length]
    return [
      buffer.toString('ascii', imageOffset, imageLengthOffset),
      buffer.readUInt32BE(imageLengthOffset)
    ];
  }
  
  function getImageSize(type) {
    var size = ICON_TYPE_SIZE[type];
    return { width: size, height: size, type: type };
  }
  
  function calculate (buffer) {
    var
      bufferLength = buffer.length,
      imageOffset = SIZE_HEADER,
      fileLength = buffer.readUInt32BE(FILE_LENGTH_OFFSET),
      imageHeader,
      imageSize,
      result;
  
    imageHeader = readImageHeader(buffer, imageOffset);
    imageSize = getImageSize(imageHeader[0]);
    imageOffset += imageHeader[1];
  
    if (imageOffset === fileLength) {
      return imageSize;
    }
    
    result = {
      width: imageSize.width,
      height: imageSize.height,
      images: [imageSize]
    };
    
    while (imageOffset < fileLength && imageOffset < bufferLength) {
      imageHeader = readImageHeader(buffer, imageOffset);
      imageSize = getImageSize(imageHeader[0]);
      imageOffset += imageHeader[1];
      result.images.push(imageSize);
    }
    
    return result;
  }
  
  module.exports = {
    'detect': isICNS,
    'calculate': calculate
  };
  
  },{}],426:[function(_dereq_,module,exports){
  'use strict';
  
  var TYPE_ICON = 1;
  
  /**
   * ICON Header
   *
   * | Offset | Size | Purpose                                                                                   |
   * | 0	    | 2    | Reserved. Must always be 0.                                                               |
   * | 2      | 2    | Image type: 1 for icon (.ICO) image, 2 for cursor (.CUR) image. Other values are invalid. |
   * | 4      | 2    | Number of images in the file.                                                             |
   *
   **/
  var SIZE_HEADER = 2 + 2 + 2; // 6
  
  /**
   * Image Entry
   *
   * | Offset | Size | Purpose                                                                                          |
   * | 0	    | 1    | Image width in pixels. Can be any number between 0 and 255. Value 0 means width is 256 pixels.   |
   * | 1      | 1    | Image height in pixels. Can be any number between 0 and 255. Value 0 means height is 256 pixels. |
   * | 2      | 1    | Number of colors in the color palette. Should be 0 if the image does not use a color palette.    |
   * | 3      | 1    | Reserved. Should be 0.                                                                           |
   * | 4      | 2    | ICO format: Color planes. Should be 0 or 1.                                                      |
   * |        |      | CUR format: The horizontal coordinates of the hotspot in number of pixels from the left.         |
   * | 6      | 2    | ICO format: Bits per pixel.                                                                      |
   * |        |      | CUR format: The vertical coordinates of the hotspot in number of pixels from the top.            |
   * | 8      | 4    | The size of the image's data in bytes                                                            |
   * | 12     | 4    | The offset of BMP or PNG data from the beginning of the ICO/CUR file                             |
   *
   **/
  var SIZE_IMAGE_ENTRY = 1 + 1 + 1 + 1 + 2 + 2 + 4 + 4; // 16
  
  function isICO (buffer) {
    var type;
    if (buffer.readUInt16LE(0) !== 0) {
      return false;
    }
    type = buffer.readUInt16LE(2);
    return type === TYPE_ICON;
  }
  
  function getSizeFromOffset(buffer, offset) {
    var value = buffer.readUInt8(offset);
    return value === 0 ? 256 : value;
  }
  
  function getImageSize(buffer, imageIndex) {
    var offset = SIZE_HEADER + (imageIndex * SIZE_IMAGE_ENTRY);
    return {
      'width': getSizeFromOffset(buffer, offset),
      'height': getSizeFromOffset(buffer, offset + 1)
    };
  }
  
  function calculate (buffer) {
    var 
      nbImages = buffer.readUInt16LE(4),
      result = getImageSize(buffer, 0),
      imageIndex;
      
    if (nbImages === 1) {
      return result;
    }
    
    result.images = [{
      width: result.width,
      height: result.height
    }];
    
    for (imageIndex = 1; imageIndex < nbImages; imageIndex += 1) {
      result.images.push(getImageSize(buffer, imageIndex));
    }
    
    return result;
  }
  
  module.exports = {
    'detect': isICO,
    'calculate': calculate
  };
  
  },{}],427:[function(_dereq_,module,exports){
  'use strict';
  
  var readUInt = _dereq_('../readUInt');
  
  // NOTE: we only support baseline and progressive JPGs here
  // due to the structure of the loader class, we only get a buffer
  // with a maximum size of 4096 bytes. so if the SOF marker is outside
  // if this range we can't detect the file size correctly.
  
  function isJPG (buffer) { //, filepath
    var SOIMarker = buffer.toString('hex', 0, 2);
    return ('ffd8' === SOIMarker);
  }
  
  function isEXIF (buffer) { //, filepath
    var exifMarker = buffer.toString('hex', 2, 6);
    return (exifMarker === '45786966'); // 'Exif'
  }
  
  function extractSize (buffer, i) {
    return {
      'height' : buffer.readUInt16BE(i),
      'width' : buffer.readUInt16BE(i + 2)
    };
  }
  
  var APP1_DATA_SIZE_BYTES = 2;
  var EXIF_HEADER_BYTES = 6;
  var TIFF_BYTE_ALIGN_BYTES = 2;
  var BIG_ENDIAN_BYTE_ALIGN = '4d4d';
  var LITTLE_ENDIAN_BYTE_ALIGN = '4949';
  
  // Each entry is exactly 12 bytes
  var IDF_ENTRY_BYTES = 12;
  var NUM_DIRECTORY_ENTRIES_BYTES = 2;
  
  function validateExifBlock (buffer, i) {
    // Skip APP1 Data Size
    var exifBlock = buffer.slice(APP1_DATA_SIZE_BYTES, i);
  
    // Consider byte alignment
    var byteAlign = exifBlock.toString('hex', EXIF_HEADER_BYTES, EXIF_HEADER_BYTES + TIFF_BYTE_ALIGN_BYTES);
  
    // Ignore Empty EXIF. Validate byte alignment
    var isBigEndian = byteAlign === BIG_ENDIAN_BYTE_ALIGN;
    var isLittleEndian = byteAlign === LITTLE_ENDIAN_BYTE_ALIGN;
  
    if (isBigEndian || isLittleEndian) {
      return extractOrientation(exifBlock, isBigEndian);
    }
  }
  
  function extractOrientation (exifBlock, isBigEndian) {
    // TODO: assert that this contains 0x002A
    // var STATIC_MOTOROLA_TIFF_HEADER_BYTES = 2;
    // var TIFF_IMAGE_FILE_DIRECTORY_BYTES = 4;
  
    // TODO: derive from TIFF_IMAGE_FILE_DIRECTORY_BYTES
    var idfOffset = 8;
  
    // IDF osset works from right after the header bytes
    // (so the offset includes the tiff byte align)
    var offset = EXIF_HEADER_BYTES + idfOffset;
  
    var idfDirectoryEntries = readUInt(exifBlock, 16, offset, isBigEndian);
  
    var start;
    var end;
    for (var directoryEntryNumber = 0; directoryEntryNumber < idfDirectoryEntries; directoryEntryNumber++) {
      start = offset + NUM_DIRECTORY_ENTRIES_BYTES + (directoryEntryNumber * IDF_ENTRY_BYTES);
      end = start + IDF_ENTRY_BYTES;
  
      // Skip on corrupt EXIF blocks
      if (start > exifBlock.length) {
        return;
      }
  
      var block = exifBlock.slice(start, end);
      var tagNumber = readUInt(block, 16, 0, isBigEndian);
  
      // 0x0112 (decimal: 274) is the `orientation` tag ID
      if (tagNumber === 274) {
        var dataFormat = readUInt(block, 16, 2, isBigEndian);
        if (dataFormat !== 3) {
          return;
        }
  
        // unsinged int has 2 bytes per component
        // if there would more than 4 bytes in total it's a pointer
        var numberOfComponents = readUInt(block, 32, 4, isBigEndian);
        if (numberOfComponents !== 1) {
          return;
        }
  
        return readUInt(block, 16, 8, isBigEndian);
      }
    }
  }
  
  function validateBuffer (buffer, i) {
    // index should be within buffer limits
    if (i > buffer.length) {
      throw new TypeError('Corrupt JPG, exceeded buffer limits');
    }
    // Every JPEG block must begin with a 0xFF
    if (buffer[i] !== 0xFF) {
      throw new TypeError('Invalid JPG, marker table corrupted');
    }
  }
  
  function calculate (buffer) {
    // Skip 4 chars, they are for signature
    buffer = buffer.slice(4);
  
    var orientation;
  
    var i, next;
    while (buffer.length) {
      // read length of the next block
      i = buffer.readUInt16BE(0);
  
      if (isEXIF(buffer)) {
        orientation = validateExifBlock(buffer, i);
      }
  
      // ensure correct format
      validateBuffer(buffer, i);
  
      // 0xFFC0 is baseline standard(SOF)
      // 0xFFC1 is baseline optimized(SOF)
      // 0xFFC2 is progressive(SOF2)
      next = buffer[i + 1];
      if (next === 0xC0 || next === 0xC1 || next === 0xC2) {
        var size = extractSize(buffer, i + 5);
  
        if (!orientation) {
          return size;
        }
  
        return {
          width: size.width,
          height: size.height,
          orientation: orientation
        };
      }
  
      // move to the next block
      buffer = buffer.slice(i + 2);
    }
  
    throw new TypeError('Invalid JPG, no size found');
  }
  
  module.exports = {
    'detect': isJPG,
    'calculate': calculate
  };
  
  },{"../readUInt":419}],428:[function(_dereq_,module,exports){
  'use strict';
  
  var pngSignature = 'PNG\r\n\x1a\n';
  var pngImageHeaderChunkName = 'IHDR';
  
  // Used to detect "fried" png's: http://www.jongware.com/pngdefry.html
  var pngFriedChunkName = 'CgBI'; 
  
  function isPNG (buffer) {
    if (pngSignature === buffer.toString('ascii', 1, 8)) {
      var chunkName = buffer.toString('ascii', 12, 16);
      if (chunkName === pngFriedChunkName) {
        chunkName = buffer.toString('ascii', 28, 32);
      }
      if (chunkName !== pngImageHeaderChunkName) {
        throw new TypeError('invalid png');
      }
      return true;
    }
  }
  
  function calculate (buffer) {
    if (buffer.toString('ascii', 12, 16) === pngFriedChunkName) {
      return {
        'width': buffer.readUInt32BE(32),
        'height': buffer.readUInt32BE(36)
      };
    }
    return {
      'width': buffer.readUInt32BE(16),
      'height': buffer.readUInt32BE(20)
    };
  }
  
  module.exports = {
    'detect': isPNG,
    'calculate': calculate
  };
  
  },{}],429:[function(_dereq_,module,exports){
  'use strict';
  
  function isPSD (buffer) {
    return ('8BPS' === buffer.toString('ascii', 0, 4));
  }
  
  function calculate (buffer) {
    return {
      'width': buffer.readUInt32BE(18),
      'height': buffer.readUInt32BE(14)
    };
  }
  
  module.exports = {
    'detect': isPSD,
    'calculate': calculate
  };
  
  },{}],430:[function(_dereq_,module,exports){
  'use strict';
  
  var svgReg = /<svg\s([^>"']|"[^"]*"|'[^']*')*>/;
  function isSVG (buffer) {
    return svgReg.test(buffer);
  }
  
  var extractorRegExps = {
    'root': svgReg,
    'width': /\swidth=(['"])([^%]+?)\1/,
    'height': /\sheight=(['"])([^%]+?)\1/,
    'viewbox': /\sviewBox=(['"])(.+?)\1/
  };
  
  var units = {
    'cm': 96/2.54,
    'mm': 96/2.54/10,
    'm':  96/2.54*100,
    'pt': 96/72,
    'pc': 96/72/12,
    'em': 16,
    'ex': 8,
  };
  
  function parseLength (len) {
    var m = /([0-9.]+)([a-z]*)/.exec(len);
    if (!m) {
      return undefined;
    }
    return Math.round(parseFloat(m[1]) * (units[m[2]] || 1));
  }
  
  function parseViewbox (viewbox) {
    var bounds = viewbox.split(' ');
    return {
      'width': parseLength(bounds[2]),
      'height': parseLength(bounds[3])
    };
  }
  
  function parseAttributes (root) {
    var width = root.match(extractorRegExps.width);
    var height = root.match(extractorRegExps.height);
    var viewbox = root.match(extractorRegExps.viewbox);
    return {
      'width': width && parseLength(width[2]),
      'height': height && parseLength(height[2]),
      'viewbox': viewbox && parseViewbox(viewbox[2])
    };
  }
  
  function calculateByDimensions (attrs) {
    return {
      'width': attrs.width,
      'height': attrs.height
    };
  }
  
  function calculateByViewbox (attrs) {
    var ratio = attrs.viewbox.width / attrs.viewbox.height;
    if (attrs.width) {
      return {
        'width': attrs.width,
        'height': Math.floor(attrs.width / ratio)
      };
    }
    if (attrs.height) {
      return {
        'width': Math.floor(attrs.height * ratio),
        'height': attrs.height
      };
    }
    return {
      'width': attrs.viewbox.width,
      'height': attrs.viewbox.height
    };
  }
  
  function calculate (buffer) {
    var root = buffer.toString('utf8').match(extractorRegExps.root);
    if (root) {
      var attrs = parseAttributes(root[0]);
      if (attrs.width && attrs.height) {
        return calculateByDimensions(attrs);
      }
      if (attrs.viewbox) {
        return calculateByViewbox(attrs);
      }
    }
    throw new TypeError('invalid svg');
  }
  
  module.exports = {
    'detect': isSVG,
    'calculate': calculate
  };
  
  },{}],431:[function(_dereq_,module,exports){
  (function (Buffer){
  'use strict';
  
  // based on http://www.compix.com/fileformattif.htm
  // TO-DO: support big-endian as well
  
  var fs = _dereq_('fs');
  var readUInt = _dereq_('../readUInt');
  
  function isTIFF (buffer) {
    var hex4 = buffer.toString('hex', 0, 4);
    return ('49492a00' === hex4 || '4d4d002a' === hex4);
  }
  
  // Read IFD (image-file-directory) into a buffer
  function readIFD (buffer, filepath, isBigEndian) {
  
    var ifdOffset = readUInt(buffer, 32, 4, isBigEndian);
  
    // read only till the end of the file
    var bufferSize = 1024;
    var fileSize = fs.statSync(filepath).size;
    if (ifdOffset + bufferSize > fileSize) {
      bufferSize = fileSize - ifdOffset - 10;
    }
  
    // populate the buffer
    var endBuffer = Buffer.alloc(bufferSize);
    var descriptor = fs.openSync(filepath, 'r');
    fs.readSync(descriptor, endBuffer, 0, bufferSize, ifdOffset);
  
    // var ifdLength = readUInt(endBuffer, 16, 0, isBigEndian);
    var ifdBuffer = endBuffer.slice(2); //, 2 + 12 * ifdLength);
    return ifdBuffer;
  }
  
  // TIFF values seem to be messed up on Big-Endian, this helps
  function readValue (buffer, isBigEndian) {
    var low = readUInt(buffer, 16, 8, isBigEndian);
    var high = readUInt(buffer, 16, 10, isBigEndian);
    return (high << 16) + low;
  }
  
  // move to the next tag
  function nextTag (buffer) {
    if (buffer.length > 24) {
      return buffer.slice(12);
    }
  }
  
  // Extract IFD tags from TIFF metadata
  /* eslint-disable complexity */
  function extractTags (buffer, isBigEndian) {
    var tags = {};
    var code, type, length;
  
    while (buffer && buffer.length) {
      code = readUInt(buffer, 16, 0, isBigEndian);
      type = readUInt(buffer, 16, 2, isBigEndian);
      length = readUInt(buffer, 32, 4, isBigEndian);
  
      // 0 means end of IFD
      if (code === 0) {
        break;
      } else {
        // 256 is width, 257 is height
        // if (code === 256 || code === 257) {
        if (length === 1 && (type === 3 || type === 4)) {
          tags[code] = readValue(buffer, isBigEndian);
        }
  
        // move to the next tag
        buffer = nextTag(buffer);
      }
    }
    return tags;
  }
  /* eslint-enable complexity */
  
  // Test if the TIFF is Big Endian or Little Endian
  function determineEndianness (buffer) {
    var signature = buffer.toString('ascii', 0, 2);
    if ('II' === signature) {
      return 'LE';
    } else if ('MM' === signature) {
      return 'BE';
    }
  }
  
  function calculate (buffer, filepath) {
  
    if (!filepath) {
      throw new TypeError('Tiff doesn\'t support buffer');
    }
  
    // Determine BE/LE
    var isBigEndian = determineEndianness(buffer) === 'BE';
  
    // read the IFD
    var ifdBuffer = readIFD(buffer, filepath, isBigEndian);
  
    // extract the tags from the IFD
    var tags = extractTags(ifdBuffer, isBigEndian);
  
    var width = tags[256];
    var height = tags[257];
  
    if (!width || !height) {
      throw new TypeError('Invalid Tiff, missing tags');
    }
  
    return {
      'width': width,
      'height': height
    };
  }
  
  module.exports = {
    'detect': isTIFF,
    'calculate': calculate
  };
  
  }).call(this,_dereq_("buffer").Buffer)
  },{"../readUInt":419,"buffer":111,"fs":109}],432:[function(_dereq_,module,exports){
  'use strict';
  
  // based on https://developers.google.com/speed/webp/docs/riff_container
  
  function isWebP (buffer) {
    var riffHeader = 'RIFF' === buffer.toString('ascii', 0, 4);
    var webpHeader = 'WEBP' === buffer.toString('ascii', 8, 12);
    var vp8Header  = 'VP8'  === buffer.toString('ascii', 12, 15);
    return (riffHeader && webpHeader && vp8Header);
  }
  
  /* eslint-disable complexity */
  function calculate (buffer) {
    var chunkHeader = buffer.toString('ascii', 12, 16);
    buffer = buffer.slice(20, 30);
  
    // Extended webp stream signature
    if (chunkHeader === 'VP8X') {
      var extendedHeader = buffer[0];
      var validStart = (extendedHeader & 0xc0) === 0;
      var validEnd = (extendedHeader & 0x01) === 0;
      if (validStart && validEnd) {
        return calculateExtended(buffer);
      } else {
        return false;
      }
    }
  
    // Lossless webp stream signature
    if (chunkHeader === 'VP8 ' && buffer[0] !== 0x2f) {
      return calculateLossy(buffer);
    }
  
    // Lossy webp stream signature
    var signature = buffer.toString('hex', 3, 6);
    if (chunkHeader === 'VP8L' && signature !== '9d012a') {
      return calculateLossless(buffer);
    }
  
    return false;
  }
  /* eslint-enable complexity */
  
  function calculateExtended (buffer) {
    return {
      'width': 1 + buffer.readUIntLE(4, 3),
      'height': 1 + buffer.readUIntLE(7, 3)
    };
  }
  
  function calculateLossless (buffer) {
    return {
      'width': 1 + (((buffer[2] & 0x3F) << 8) | buffer[1]),
      'height': 1 + (((buffer[4] & 0xF) << 10) | (buffer[3] << 2) |
                    ((buffer[2] & 0xC0) >> 6))
    };
  }
  
  function calculateLossy (buffer) {
    // `& 0x3fff` returns the last 14 bits
    // TO-DO: include webp scaling in the calculations
    return {
      'width': buffer.readInt16LE(6) & 0x3fff,
      'height': buffer.readInt16LE(8) & 0x3fff
    };
  }
  
  module.exports = {
    'detect': isWebP,
    'calculate': calculate
  };
  
  },{}],433:[function(_dereq_,module,exports){
  "use strict"
  
  //High level idea:
  // 1. Use Clarkson's incremental construction to find convex hull
  // 2. Point location in triangulation by jump and walk
  
  module.exports = incrementalConvexHull
  
  var orient = _dereq_("robust-orientation")
  var compareCell = _dereq_("simplicial-complex").compareCells
  
  function compareInt(a, b) {
    return a - b
  }
  
  function Simplex(vertices, adjacent, boundary) {
    this.vertices = vertices
    this.adjacent = adjacent
    this.boundary = boundary
    this.lastVisited = -1
  }
  
  Simplex.prototype.flip = function() {
    var t = this.vertices[0]
    this.vertices[0] = this.vertices[1]
    this.vertices[1] = t
    var u = this.adjacent[0]
    this.adjacent[0] = this.adjacent[1]
    this.adjacent[1] = u
  }
  
  function GlueFacet(vertices, cell, index) {
    this.vertices = vertices
    this.cell = cell
    this.index = index
  }
  
  function compareGlue(a, b) {
    return compareCell(a.vertices, b.vertices)
  }
  
  function bakeOrient(d) {
    var code = ["function orient(){var tuple=this.tuple;return test("]
    for(var i=0; i<=d; ++i) {
      if(i > 0) {
        code.push(",")
      }
      code.push("tuple[", i, "]")
    }
    code.push(")}return orient")
    var proc = new Function("test", code.join(""))
    var test = orient[d+1]
    if(!test) {
      test = orient
    }
    return proc(test)
  }
  
  var BAKED = []
  
  function Triangulation(dimension, vertices, simplices) {
    this.dimension = dimension
    this.vertices = vertices
    this.simplices = simplices
    this.interior = simplices.filter(function(c) {
      return !c.boundary
    })
  
    this.tuple = new Array(dimension+1)
    for(var i=0; i<=dimension; ++i) {
      this.tuple[i] = this.vertices[i]
    }
  
    var o = BAKED[dimension]
    if(!o) {
      o = BAKED[dimension] = bakeOrient(dimension)
    }
    this.orient = o
  }
  
  var proto = Triangulation.prototype
  
  //Degenerate situation where we are on boundary, but coplanar to face
  proto.handleBoundaryDegeneracy = function(cell, point) {
    var d = this.dimension
    var n = this.vertices.length - 1
    var tuple = this.tuple
    var verts = this.vertices
  
    //Dumb solution: Just do dfs from boundary cell until we find any peak, or terminate
    var toVisit = [ cell ]
    cell.lastVisited = -n
    while(toVisit.length > 0) {
      cell = toVisit.pop()
      var cellVerts = cell.vertices
      var cellAdj = cell.adjacent
      for(var i=0; i<=d; ++i) {
        var neighbor = cellAdj[i]
        if(!neighbor.boundary || neighbor.lastVisited <= -n) {
          continue
        }
        var nv = neighbor.vertices
        for(var j=0; j<=d; ++j) {
          var vv = nv[j]
          if(vv < 0) {
            tuple[j] = point
          } else {
            tuple[j] = verts[vv]
          }
        }
        var o = this.orient()
        if(o > 0) {
          return neighbor
        }
        neighbor.lastVisited = -n
        if(o === 0) {
          toVisit.push(neighbor)
        }
      }
    }
    return null
  }
  
  proto.walk = function(point, random) {
    //Alias local properties
    var n = this.vertices.length - 1
    var d = this.dimension
    var verts = this.vertices
    var tuple = this.tuple
  
    //Compute initial jump cell
    var initIndex = random ? (this.interior.length * Math.random())|0 : (this.interior.length-1)
    var cell = this.interior[ initIndex ]
  
    //Start walking
  outerLoop:
    while(!cell.boundary) {
      var cellVerts = cell.vertices
      var cellAdj = cell.adjacent
  
      for(var i=0; i<=d; ++i) {
        tuple[i] = verts[cellVerts[i]]
      }
      cell.lastVisited = n
  
      //Find farthest adjacent cell
      for(var i=0; i<=d; ++i) {
        var neighbor = cellAdj[i]
        if(neighbor.lastVisited >= n) {
          continue
        }
        var prev = tuple[i]
        tuple[i] = point
        var o = this.orient()
        tuple[i] = prev
        if(o < 0) {
          cell = neighbor
          continue outerLoop
        } else {
          if(!neighbor.boundary) {
            neighbor.lastVisited = n
          } else {
            neighbor.lastVisited = -n
          }
        }
      }
      return
    }
  
    return cell
  }
  
  proto.addPeaks = function(point, cell) {
    var n = this.vertices.length - 1
    var d = this.dimension
    var verts = this.vertices
    var tuple = this.tuple
    var interior = this.interior
    var simplices = this.simplices
  
    //Walking finished at boundary, time to add peaks
    var tovisit = [ cell ]
  
    //Stretch initial boundary cell into a peak
    cell.lastVisited = n
    cell.vertices[cell.vertices.indexOf(-1)] = n
    cell.boundary = false
    interior.push(cell)
  
    //Record a list of all new boundaries created by added peaks so we can glue them together when we are all done
    var glueFacets = []
  
    //Do a traversal of the boundary walking outward from starting peak
    while(tovisit.length > 0) {
      //Pop off peak and walk over adjacent cells
      var cell = tovisit.pop()
      var cellVerts = cell.vertices
      var cellAdj = cell.adjacent
      var indexOfN = cellVerts.indexOf(n)
      if(indexOfN < 0) {
        continue
      }
  
      for(var i=0; i<=d; ++i) {
        if(i === indexOfN) {
          continue
        }
  
        //For each boundary neighbor of the cell
        var neighbor = cellAdj[i]
        if(!neighbor.boundary || neighbor.lastVisited >= n) {
          continue
        }
  
        var nv = neighbor.vertices
  
        //Test if neighbor is a peak
        if(neighbor.lastVisited !== -n) {      
          //Compute orientation of p relative to each boundary peak
          var indexOfNeg1 = 0
          for(var j=0; j<=d; ++j) {
            if(nv[j] < 0) {
              indexOfNeg1 = j
              tuple[j] = point
            } else {
              tuple[j] = verts[nv[j]]
            }
          }
          var o = this.orient()
  
          //Test if neighbor cell is also a peak
          if(o > 0) {
            nv[indexOfNeg1] = n
            neighbor.boundary = false
            interior.push(neighbor)
            tovisit.push(neighbor)
            neighbor.lastVisited = n
            continue
          } else {
            neighbor.lastVisited = -n
          }
        }
  
        var na = neighbor.adjacent
  
        //Otherwise, replace neighbor with new face
        var vverts = cellVerts.slice()
        var vadj = cellAdj.slice()
        var ncell = new Simplex(vverts, vadj, true)
        simplices.push(ncell)
  
        //Connect to neighbor
        var opposite = na.indexOf(cell)
        if(opposite < 0) {
          continue
        }
        na[opposite] = ncell
        vadj[indexOfN] = neighbor
  
        //Connect to cell
        vverts[i] = -1
        vadj[i] = cell
        cellAdj[i] = ncell
  
        //Flip facet
        ncell.flip()
  
        //Add to glue list
        for(var j=0; j<=d; ++j) {
          var uu = vverts[j]
          if(uu < 0 || uu === n) {
            continue
          }
          var nface = new Array(d-1)
          var nptr = 0
          for(var k=0; k<=d; ++k) {
            var vv = vverts[k]
            if(vv < 0 || k === j) {
              continue
            }
            nface[nptr++] = vv
          }
          glueFacets.push(new GlueFacet(nface, ncell, j))
        }
      }
    }
  
    //Glue boundary facets together
    glueFacets.sort(compareGlue)
  
    for(var i=0; i+1<glueFacets.length; i+=2) {
      var a = glueFacets[i]
      var b = glueFacets[i+1]
      var ai = a.index
      var bi = b.index
      if(ai < 0 || bi < 0) {
        continue
      }
      a.cell.adjacent[a.index] = b.cell
      b.cell.adjacent[b.index] = a.cell
    }
  }
  
  proto.insert = function(point, random) {
    //Add point
    var verts = this.vertices
    verts.push(point)
  
    var cell = this.walk(point, random)
    if(!cell) {
      return
    }
  
    //Alias local properties
    var d = this.dimension
    var tuple = this.tuple
  
    //Degenerate case: If point is coplanar to cell, then walk until we find a non-degenerate boundary
    for(var i=0; i<=d; ++i) {
      var vv = cell.vertices[i]
      if(vv < 0) {
        tuple[i] = point
      } else {
        tuple[i] = verts[vv]
      }
    }
    var o = this.orient(tuple)
    if(o < 0) {
      return
    } else if(o === 0) {
      cell = this.handleBoundaryDegeneracy(cell, point)
      if(!cell) {
        return
      }
    }
  
    //Add peaks
    this.addPeaks(point, cell)
  }
  
  //Extract all boundary cells
  proto.boundary = function() {
    var d = this.dimension
    var boundary = []
    var cells = this.simplices
    var nc = cells.length
    for(var i=0; i<nc; ++i) {
      var c = cells[i]
      if(c.boundary) {
        var bcell = new Array(d)
        var cv = c.vertices
        var ptr = 0
        var parity = 0
        for(var j=0; j<=d; ++j) {
          if(cv[j] >= 0) {
            bcell[ptr++] = cv[j]
          } else {
            parity = j&1
          }
        }
        if(parity === (d&1)) {
          var t = bcell[0]
          bcell[0] = bcell[1]
          bcell[1] = t
        }
        boundary.push(bcell)
      }
    }
    return boundary
  }
  
  function incrementalConvexHull(points, randomSearch) {
    var n = points.length
    if(n === 0) {
      throw new Error("Must have at least d+1 points")
    }
    var d = points[0].length
    if(n <= d) {
      throw new Error("Must input at least d+1 points")
    }
  
    //FIXME: This could be degenerate, but need to select d+1 non-coplanar points to bootstrap process
    var initialSimplex = points.slice(0, d+1)
  
    //Make sure initial simplex is positively oriented
    var o = orient.apply(void 0, initialSimplex)
    if(o === 0) {
      throw new Error("Input not in general position")
    }
    var initialCoords = new Array(d+1)
    for(var i=0; i<=d; ++i) {
      initialCoords[i] = i
    }
    if(o < 0) {
      initialCoords[0] = 1
      initialCoords[1] = 0
    }
  
    //Create initial topological index, glue pointers together (kind of messy)
    var initialCell = new Simplex(initialCoords, new Array(d+1), false)
    var boundary = initialCell.adjacent
    var list = new Array(d+2)
    for(var i=0; i<=d; ++i) {
      var verts = initialCoords.slice()
      for(var j=0; j<=d; ++j) {
        if(j === i) {
          verts[j] = -1
        }
      }
      var t = verts[0]
      verts[0] = verts[1]
      verts[1] = t
      var cell = new Simplex(verts, new Array(d+1), true)
      boundary[i] = cell
      list[i] = cell
    }
    list[d+1] = initialCell
    for(var i=0; i<=d; ++i) {
      var verts = boundary[i].vertices
      var adj = boundary[i].adjacent
      for(var j=0; j<=d; ++j) {
        var v = verts[j]
        if(v < 0) {
          adj[j] = initialCell
          continue
        }
        for(var k=0; k<=d; ++k) {
          if(boundary[k].vertices.indexOf(v) < 0) {
            adj[j] = boundary[k]
          }
        }
      }
    }
  
    //Initialize triangles
    var triangles = new Triangulation(d, initialSimplex, list)
  
    //Insert remaining points
    var useRandom = !!randomSearch
    for(var i=d+1; i<n; ++i) {
      triangles.insert(points[i], useRandom)
    }
    
    //Extract boundary cells
    return triangles.boundary()
  }
  },{"robust-orientation":520,"simplicial-complex":530}],434:[function(_dereq_,module,exports){
  "use strict"
  
  var bounds = _dereq_("binary-search-bounds")
  
  var NOT_FOUND = 0
  var SUCCESS = 1
  var EMPTY = 2
  
  module.exports = createWrapper
  
  function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
    this.mid = mid
    this.left = left
    this.right = right
    this.leftPoints = leftPoints
    this.rightPoints = rightPoints
    this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length
  }
  
  var proto = IntervalTreeNode.prototype
  
  function copy(a, b) {
    a.mid = b.mid
    a.left = b.left
    a.right = b.right
    a.leftPoints = b.leftPoints
    a.rightPoints = b.rightPoints
    a.count = b.count
  }
  
  function rebuild(node, intervals) {
    var ntree = createIntervalTree(intervals)
    node.mid = ntree.mid
    node.left = ntree.left
    node.right = ntree.right
    node.leftPoints = ntree.leftPoints
    node.rightPoints = ntree.rightPoints
    node.count = ntree.count
  }
  
  function rebuildWithInterval(node, interval) {
    var intervals = node.intervals([])
    intervals.push(interval)
    rebuild(node, intervals)    
  }
  
  function rebuildWithoutInterval(node, interval) {
    var intervals = node.intervals([])
    var idx = intervals.indexOf(interval)
    if(idx < 0) {
      return NOT_FOUND
    }
    intervals.splice(idx, 1)
    rebuild(node, intervals)
    return SUCCESS
  }
  
  proto.intervals = function(result) {
    result.push.apply(result, this.leftPoints)
    if(this.left) {
      this.left.intervals(result)
    }
    if(this.right) {
      this.right.intervals(result)
    }
    return result
  }
  
  proto.insert = function(interval) {
    var weight = this.count - this.leftPoints.length
    this.count += 1
    if(interval[1] < this.mid) {
      if(this.left) {
        if(4*(this.left.count+1) > 3*(weight+1)) {
          rebuildWithInterval(this, interval)
        } else {
          this.left.insert(interval)
        }
      } else {
        this.left = createIntervalTree([interval])
      }
    } else if(interval[0] > this.mid) {
      if(this.right) {
        if(4*(this.right.count+1) > 3*(weight+1)) {
          rebuildWithInterval(this, interval)
        } else {
          this.right.insert(interval)
        }
      } else {
        this.right = createIntervalTree([interval])
      }
    } else {
      var l = bounds.ge(this.leftPoints, interval, compareBegin)
      var r = bounds.ge(this.rightPoints, interval, compareEnd)
      this.leftPoints.splice(l, 0, interval)
      this.rightPoints.splice(r, 0, interval)
    }
  }
  
  proto.remove = function(interval) {
    var weight = this.count - this.leftPoints
    if(interval[1] < this.mid) {
      if(!this.left) {
        return NOT_FOUND
      }
      var rw = this.right ? this.right.count : 0
      if(4 * rw > 3 * (weight-1)) {
        return rebuildWithoutInterval(this, interval)
      }
      var r = this.left.remove(interval)
      if(r === EMPTY) {
        this.left = null
        this.count -= 1
        return SUCCESS
      } else if(r === SUCCESS) {
        this.count -= 1
      }
      return r
    } else if(interval[0] > this.mid) {
      if(!this.right) {
        return NOT_FOUND
      }
      var lw = this.left ? this.left.count : 0
      if(4 * lw > 3 * (weight-1)) {
        return rebuildWithoutInterval(this, interval)
      }
      var r = this.right.remove(interval)
      if(r === EMPTY) {
        this.right = null
        this.count -= 1
        return SUCCESS
      } else if(r === SUCCESS) {
        this.count -= 1
      }
      return r
    } else {
      if(this.count === 1) {
        if(this.leftPoints[0] === interval) {
          return EMPTY
        } else {
          return NOT_FOUND
        }
      }
      if(this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
        if(this.left && this.right) {
          var p = this
          var n = this.left
          while(n.right) {
            p = n
            n = n.right
          }
          if(p === this) {
            n.right = this.right
          } else {
            var l = this.left
            var r = this.right
            p.count -= n.count
            p.right = n.left
            n.left = l
            n.right = r
          }
          copy(this, n)
          this.count = (this.left?this.left.count:0) + (this.right?this.right.count:0) + this.leftPoints.length
        } else if(this.left) {
          copy(this, this.left)
        } else {
          copy(this, this.right)
        }
        return SUCCESS
      }
      for(var l = bounds.ge(this.leftPoints, interval, compareBegin); l<this.leftPoints.length; ++l) {
        if(this.leftPoints[l][0] !== interval[0]) {
          break
        }
        if(this.leftPoints[l] === interval) {
          this.count -= 1
          this.leftPoints.splice(l, 1)
          for(var r = bounds.ge(this.rightPoints, interval, compareEnd); r<this.rightPoints.length; ++r) {
            if(this.rightPoints[r][1] !== interval[1]) {
              break
            } else if(this.rightPoints[r] === interval) {
              this.rightPoints.splice(r, 1)
              return SUCCESS
            }
          }
        }
      }
      return NOT_FOUND
    }
  }
  
  function reportLeftRange(arr, hi, cb) {
    for(var i=0; i<arr.length && arr[i][0] <= hi; ++i) {
      var r = cb(arr[i])
      if(r) { return r }
    }
  }
  
  function reportRightRange(arr, lo, cb) {
    for(var i=arr.length-1; i>=0 && arr[i][1] >= lo; --i) {
      var r = cb(arr[i])
      if(r) { return r }
    }
  }
  
  function reportRange(arr, cb) {
    for(var i=0; i<arr.length; ++i) {
      var r = cb(arr[i])
      if(r) { return r }
    }
  }
  
  proto.queryPoint = function(x, cb) {
    if(x < this.mid) {
      if(this.left) {
        var r = this.left.queryPoint(x, cb)
        if(r) { return r }
      }
      return reportLeftRange(this.leftPoints, x, cb)
    } else if(x > this.mid) {
      if(this.right) {
        var r = this.right.queryPoint(x, cb)
        if(r) { return r }
      }
      return reportRightRange(this.rightPoints, x, cb)
    } else {
      return reportRange(this.leftPoints, cb)
    }
  }
  
  proto.queryInterval = function(lo, hi, cb) {
    if(lo < this.mid && this.left) {
      var r = this.left.queryInterval(lo, hi, cb)
      if(r) { return r }
    }
    if(hi > this.mid && this.right) {
      var r = this.right.queryInterval(lo, hi, cb)
      if(r) { return r }
    }
    if(hi < this.mid) {
      return reportLeftRange(this.leftPoints, hi, cb)
    } else if(lo > this.mid) {
      return reportRightRange(this.rightPoints, lo, cb)
    } else {
      return reportRange(this.leftPoints, cb)
    }
  }
  
  function compareNumbers(a, b) {
    return a - b
  }
  
  function compareBegin(a, b) {
    var d = a[0] - b[0]
    if(d) { return d }
    return a[1] - b[1]
  }
  
  function compareEnd(a, b) {
    var d = a[1] - b[1]
    if(d) { return d }
    return a[0] - b[0]
  }
  
  function createIntervalTree(intervals) {
    if(intervals.length === 0) {
      return null
    }
    var pts = []
    for(var i=0; i<intervals.length; ++i) {
      pts.push(intervals[i][0], intervals[i][1])
    }
    pts.sort(compareNumbers)
  
    var mid = pts[pts.length>>1]
  
    var leftIntervals = []
    var rightIntervals = []
    var centerIntervals = []
    for(var i=0; i<intervals.length; ++i) {
      var s = intervals[i]
      if(s[1] < mid) {
        leftIntervals.push(s)
      } else if(mid < s[0]) {
        rightIntervals.push(s)
      } else {
        centerIntervals.push(s)
      }
    }
  
    //Split center intervals
    var leftPoints = centerIntervals
    var rightPoints = centerIntervals.slice()
    leftPoints.sort(compareBegin)
    rightPoints.sort(compareEnd)
  
    return new IntervalTreeNode(mid, 
      createIntervalTree(leftIntervals),
      createIntervalTree(rightIntervals),
      leftPoints,
      rightPoints)
  }
  
  //User friendly wrapper that makes it possible to support empty trees
  function IntervalTree(root) {
    this.root = root
  }
  
  var tproto = IntervalTree.prototype
  
  tproto.insert = function(interval) {
    if(this.root) {
      this.root.insert(interval)
    } else {
      this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval])
    }
  }
  
  tproto.remove = function(interval) {
    if(this.root) {
      var r = this.root.remove(interval)
      if(r === EMPTY) {
        this.root = null
      }
      return r !== NOT_FOUND
    }
    return false
  }
  
  tproto.queryPoint = function(p, cb) {
    if(this.root) {
      return this.root.queryPoint(p, cb)
    }
  }
  
  tproto.queryInterval = function(lo, hi, cb) {
    if(lo <= hi && this.root) {
      return this.root.queryInterval(lo, hi, cb)
    }
  }
  
  Object.defineProperty(tproto, "count", {
    get: function() {
      if(this.root) {
        return this.root.count
      }
      return 0
    }
  })
  
  Object.defineProperty(tproto, "intervals", {
    get: function() {
      if(this.root) {
        return this.root.intervals([])
      }
      return []
    }
  })
  
  function createWrapper(intervals) {
    if(!intervals || intervals.length === 0) {
      return new IntervalTree(null)
    }
    return new IntervalTree(createIntervalTree(intervals))
  }
  
  },{"binary-search-bounds":435}],435:[function(_dereq_,module,exports){
  arguments[4][243][0].apply(exports,arguments)
  },{"dup":243}],436:[function(_dereq_,module,exports){
  "use strict"
  
  function invertPermutation(pi, result) {
    result = result || new Array(pi.length)
    for(var i=0; i<pi.length; ++i) {
      result[pi[i]] = i
    }
    return result
  }
  
  module.exports = invertPermutation
  },{}],437:[function(_dereq_,module,exports){
  "use strict"
  
  function iota(n) {
    var result = new Array(n)
    for(var i=0; i<n; ++i) {
      result[i] = i
    }
    return result
  }
  
  module.exports = iota
  },{}],438:[function(_dereq_,module,exports){
  module.exports = true;
  },{}],439:[function(_dereq_,module,exports){
  /*!
   * Determine if an object is a Buffer
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   */
  
  // The _isBuffer check is for Safari 5-7 support, because it's missing
  // Object.prototype.constructor. Remove this eventually
  module.exports = function (obj) {
    return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
  }
  
  function isBuffer (obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
  }
  
  // For Node v0.10 support. Remove this eventually.
  function isSlowBuffer (obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
  }
  
  },{}],440:[function(_dereq_,module,exports){
  'use strict';
  module.exports = typeof navigator !== 'undefined' &&
    (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion));
  
  },{}],441:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = isMobile
  module.exports.isMobile = isMobile
  module.exports.default = isMobile
  
  var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
  
  var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i
  
  function isMobile (opts) {
    if (!opts) opts = {}
    var ua = opts.ua
    if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
    if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
      ua = ua.headers['user-agent']
    }
    if (typeof ua !== 'string') return false
  
    var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)
  
    if (
      !result &&
      opts.tablet &&
      opts.featureDetect &&
      navigator &&
      navigator.maxTouchPoints > 1 &&
      ua.indexOf('Macintosh') !== -1 &&
      ua.indexOf('Safari') !== -1
    ) {
      result = true
    }
  
    return result
  }
  
  },{}],442:[function(_dereq_,module,exports){
  'use strict';
  module.exports = function (x) {
    var type = typeof x;
    return x !== null && (type === 'object' || type === 'function');
  };
  
  },{}],443:[function(_dereq_,module,exports){
  'use strict';
  var toString = Object.prototype.toString;
  
  module.exports = function (x) {
    var prototype;
    return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
  };
  
  },{}],444:[function(_dereq_,module,exports){
  'use strict';
  
  /**
   * Is this string all whitespace?
   * This solution kind of makes my brain hurt, but it's significantly faster
   * than !str.trim() or any other solution I could find.
   *
   * whitespace codes from: http://en.wikipedia.org/wiki/Whitespace_character
   * and verified with:
   *
   *  for(var i = 0; i < 65536; i++) {
   *      var s = String.fromCharCode(i);
   *      if(+s===0 && !s.trim()) console.log(i, s);
   *  }
   *
   * which counts a couple of these as *not* whitespace, but finds nothing else
   * that *is* whitespace. Note that charCodeAt stops at 16 bits, but it appears
   * that there are no whitespace characters above this, and code points above
   * this do not map onto white space characters.
   */
  
  module.exports = function(str){
      var l = str.length,
          a;
      for(var i = 0; i < l; i++) {
          a = str.charCodeAt(i);
          if((a < 9 || a > 13) && (a !== 32) && (a !== 133) && (a !== 160) &&
              (a !== 5760) && (a !== 6158) && (a < 8192 || a > 8205) &&
              (a !== 8232) && (a !== 8233) && (a !== 8239) && (a !== 8287) &&
              (a !== 8288) && (a !== 12288) && (a !== 65279)) {
                  return false;
          }
      }
      return true;
  }
  
  },{}],445:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = function isPath(str) {
    if (typeof str !== 'string') return false
  
    str = str.trim()
  
    // https://www.w3.org/TR/SVG/paths.html#PathDataBNF
    if (/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(str) && /[\dz]$/i.test(str) && str.length > 4) return true
  
    return false
  }
  
  },{}],446:[function(_dereq_,module,exports){
  function lerp(v0, v1, t) {
      return v0*(1-t)+v1*t
  }
  module.exports = lerp
  },{}],447:[function(_dereq_,module,exports){
  /* Mapbox GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/mapbox/mapbox-gl-js/blob/v1.10.1/LICENSE.txt */
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.mapboxgl = factory());
  }(this, (function () { 'use strict';
  
  /* eslint-disable */
  
  var shared, worker, mapboxgl;
  // define gets called three times: one for each chunk. we rely on the order
  // they're imported to know which is which
  function define(_, chunk) {
  if (!shared) {
      shared = chunk;
  } else if (!worker) {
      worker = chunk;
  } else {
      var workerBundleString = 'var sharedChunk = {}; (' + shared + ')(sharedChunk); (' + worker + ')(sharedChunk);'
  
      var sharedChunk = {};
      shared(sharedChunk);
      mapboxgl = chunk(sharedChunk);
      mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: 'text/javascript' }));
  }
  }
  
  
  define(["exports"],(function(t){"use strict";function e(t,e){return t(e={exports:{}},e.exports),e.exports}var r=n;function n(t,e,r,n){this.cx=3*t,this.bx=3*(r-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(n-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=n,this.p2x=r,this.p2y=n;}n.prototype.sampleCurveX=function(t){return ((this.ax*t+this.bx)*t+this.cx)*t},n.prototype.sampleCurveY=function(t){return ((this.ay*t+this.by)*t+this.cy)*t},n.prototype.sampleCurveDerivativeX=function(t){return (3*this.ax*t+2*this.bx)*t+this.cx},n.prototype.solveCurveX=function(t,e){var r,n,i,a,o;for(void 0===e&&(e=1e-6),i=t,o=0;o<8;o++){if(a=this.sampleCurveX(i)-t,Math.abs(a)<e)return i;var s=this.sampleCurveDerivativeX(i);if(Math.abs(s)<1e-6)break;i-=a/s;}if((i=t)<(r=0))return r;if(i>(n=1))return n;for(;r<n;){if(a=this.sampleCurveX(i),Math.abs(a-t)<e)return i;t>a?r=i:n=i,i=.5*(n-r)+r;}return i},n.prototype.solve=function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))};var i=a;function a(t,e){this.x=t,this.y=e;}function o(t,e,n,i){var a=new r(t,e,n,i);return function(t){return a.solve(t)}}a.prototype={clone:function(){return new a(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,r=t.y-this.y;return e*e+r*r},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[2]*this.x+t[3]*this.y;return this.x=t[0]*this.x+t[1]*this.y,this.y=e,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),r=Math.sin(t),n=r*this.x+e*this.y;return this.x=e*this.x-r*this.y,this.y=n,this},_rotateAround:function(t,e){var r=Math.cos(t),n=Math.sin(t),i=e.y+n*(this.x-e.x)+r*(this.y-e.y);return this.x=e.x+r*(this.x-e.x)-n*(this.y-e.y),this.y=i,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},a.convert=function(t){return t instanceof a?t:Array.isArray(t)?new a(t[0],t[1]):t};var s=o(.25,.1,.25,1);function u(t,e,r){return Math.min(r,Math.max(e,t))}function l(t,e,r){var n=r-e,i=((t-e)%n+n)%n+e;return i===e?r:i}function p(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}var c=1;function h(){return c++}function f(){return function t(e){return e?(e^16*Math.random()>>e/4).toString(16):([1e7]+-[1e3]+-4e3+-8e3+-1e11).replace(/[018]/g,t)}()}function y(t){return !!t&&/^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)}function d(t,e){t.forEach((function(t){e[t]&&(e[t]=e[t].bind(e));}));}function m(t,e){return -1!==t.indexOf(e,t.length-e.length)}function v(t,e,r){var n={};for(var i in t)n[i]=e.call(r||this,t[i],i,t);return n}function g(t,e,r){var n={};for(var i in t)e.call(r||this,t[i],i,t)&&(n[i]=t[i]);return n}function x(t){return Array.isArray(t)?t.map(x):"object"==typeof t&&t?v(t,x):t}var b={};function w(t){b[t]||("undefined"!=typeof console&&console.warn(t),b[t]=!0);}function _(t,e,r){return (r.y-t.y)*(e.x-t.x)>(e.y-t.y)*(r.x-t.x)}function A(t){for(var e=0,r=0,n=t.length,i=n-1,a=void 0,o=void 0;r<n;i=r++)e+=((o=t[i]).x-(a=t[r]).x)*(a.y+o.y);return e}function S(){return "undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope}function k(t){var e={};if(t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g,(function(t,r,n,i){var a=n||i;return e[r]=!a||a.toLowerCase(),""})),e["max-age"]){var r=parseInt(e["max-age"],10);isNaN(r)?delete e["max-age"]:e["max-age"]=r;}return e}var I=null;function z(t){if(null==I){var e=t.navigator?t.navigator.userAgent:null;I=!!t.safari||!(!e||!(/\b(iPad|iPhone|iPod)\b/.test(e)||e.match("Safari")&&!e.match("Chrome")));}return I}function C(t){try{var e=self[t];return e.setItem("_mapbox_test_",1),e.removeItem("_mapbox_test_"),!0}catch(t){return !1}}var M,E,T,P,B=self.performance&&self.performance.now?self.performance.now.bind(self.performance):Date.now.bind(Date),V=self.requestAnimationFrame||self.mozRequestAnimationFrame||self.webkitRequestAnimationFrame||self.msRequestAnimationFrame,F=self.cancelAnimationFrame||self.mozCancelAnimationFrame||self.webkitCancelAnimationFrame||self.msCancelAnimationFrame,D={now:B,frame:function(t){var e=V(t);return {cancel:function(){return F(e)}}},getImageData:function(t,e){void 0===e&&(e=0);var r=self.document.createElement("canvas"),n=r.getContext("2d");if(!n)throw new Error("failed to create canvas 2d context");return r.width=t.width,r.height=t.height,n.drawImage(t,0,0,t.width,t.height),n.getImageData(-e,-e,t.width+2*e,t.height+2*e)},resolveURL:function(t){return M||(M=self.document.createElement("a")),M.href=t,M.href},hardwareConcurrency:self.navigator.hardwareConcurrency||4,get devicePixelRatio(){return self.devicePixelRatio},get prefersReducedMotion(){return !!self.matchMedia&&(null==E&&(E=self.matchMedia("(prefers-reduced-motion: reduce)")),E.matches)}},L={API_URL:"https://api.mapbox.com",get EVENTS_URL(){return this.API_URL?0===this.API_URL.indexOf("https://api.mapbox.cn")?"https://events.mapbox.cn/events/v2":0===this.API_URL.indexOf("https://api.mapbox.com")?"https://events.mapbox.com/events/v2":null:null},FEEDBACK_URL:"https://apps.mapbox.com/feedback",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null,MAX_PARALLEL_IMAGE_REQUESTS:16},R={supported:!1,testSupport:function(t){!O&&P&&(U?j(t):T=t);}},O=!1,U=!1;function j(t){var e=t.createTexture();t.bindTexture(t.TEXTURE_2D,e);try{if(t.texImage2D(t.TEXTURE_2D,0,t.RGBA,t.RGBA,t.UNSIGNED_BYTE,P),t.isContextLost())return;R.supported=!0;}catch(t){}t.deleteTexture(e),O=!0;}self.document&&((P=self.document.createElement("img")).onload=function(){T&&j(T),T=null,U=!0;},P.onerror=function(){O=!0,T=null;},P.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");var q="01",N=function(t,e){this._transformRequestFn=t,this._customAccessToken=e,this._createSkuToken();};function K(t){return 0===t.indexOf("mapbox:")}N.prototype._createSkuToken=function(){var t=function(){for(var t="",e=0;e<10;e++)t+="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62*Math.random())];return {token:["1",q,t].join(""),tokenExpiresAt:Date.now()+432e5}}();this._skuToken=t.token,this._skuTokenExpiresAt=t.tokenExpiresAt;},N.prototype._isSkuTokenExpired=function(){return Date.now()>this._skuTokenExpiresAt},N.prototype.transformRequest=function(t,e){return this._transformRequestFn&&this._transformRequestFn(t,e)||{url:t}},N.prototype.normalizeStyleURL=function(t,e){if(!K(t))return t;var r=J(t);return r.path="/styles/v1"+r.path,this._makeAPIURL(r,this._customAccessToken||e)},N.prototype.normalizeGlyphsURL=function(t,e){if(!K(t))return t;var r=J(t);return r.path="/fonts/v1"+r.path,this._makeAPIURL(r,this._customAccessToken||e)},N.prototype.normalizeSourceURL=function(t,e){if(!K(t))return t;var r=J(t);return r.path="/v4/"+r.authority+".json",r.params.push("secure"),this._makeAPIURL(r,this._customAccessToken||e)},N.prototype.normalizeSpriteURL=function(t,e,r,n){var i=J(t);return K(t)?(i.path="/styles/v1"+i.path+"/sprite"+e+r,this._makeAPIURL(i,this._customAccessToken||n)):(i.path+=""+e+r,H(i))},N.prototype.normalizeTileURL=function(t,e){if(this._isSkuTokenExpired()&&this._createSkuToken(),t&&!K(t))return t;var r=J(t);r.path=r.path.replace(/(\.(png|jpg)\d*)(?=$)/,(D.devicePixelRatio>=2||512===e?"@2x":"")+(R.supported?".webp":"$1")),r.path=r.path.replace(/^.+\/v4\//,"/"),r.path="/v4"+r.path;var n=this._customAccessToken||function(t){for(var e=0,r=t;e<r.length;e+=1){var n=r[e].match(/^access_token=(.*)$/);if(n)return n[1]}return null}(r.params)||L.ACCESS_TOKEN;return L.REQUIRE_ACCESS_TOKEN&&n&&this._skuToken&&r.params.push("sku="+this._skuToken),this._makeAPIURL(r,n)},N.prototype.canonicalizeTileURL=function(t,e){var r=J(t);if(!r.path.match(/(^\/v4\/)/)||!r.path.match(/\.[\w]+$/))return t;var n="mapbox://tiles/";n+=r.path.replace("/v4/","");var i=r.params;return e&&(i=i.filter((function(t){return !t.match(/^access_token=/)}))),i.length&&(n+="?"+i.join("&")),n},N.prototype.canonicalizeTileset=function(t,e){for(var r=!!e&&K(e),n=[],i=0,a=t.tiles||[];i<a.length;i+=1){var o=a[i];Z(o)?n.push(this.canonicalizeTileURL(o,r)):n.push(o);}return n},N.prototype._makeAPIURL=function(t,e){var r="See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes",n=J(L.API_URL);if(t.protocol=n.protocol,t.authority=n.authority,"/"!==n.path&&(t.path=""+n.path+t.path),!L.REQUIRE_ACCESS_TOKEN)return H(t);if(!(e=e||L.ACCESS_TOKEN))throw new Error("An API access token is required to use Mapbox GL. "+r);if("s"===e[0])throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). "+r);return t.params=t.params.filter((function(t){return -1===t.indexOf("access_token")})),t.params.push("access_token="+e),H(t)};var G=/^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;function Z(t){return G.test(t)}var X=/^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;function J(t){var e=t.match(X);if(!e)throw new Error("Unable to parse URL object");return {protocol:e[1],authority:e[2],path:e[3]||"/",params:e[4]?e[4].split("&"):[]}}function H(t){var e=t.params.length?"?"+t.params.join("&"):"";return t.protocol+"://"+t.authority+t.path+e}function Y(t){if(!t)return null;var e=t.split(".");if(!e||3!==e.length)return null;try{return JSON.parse(decodeURIComponent(self.atob(e[1]).split("").map((function(t){return "%"+("00"+t.charCodeAt(0).toString(16)).slice(-2)})).join("")))}catch(t){return null}}var $=function(t){this.type=t,this.anonId=null,this.eventData={},this.queue=[],this.pendingRequest=null;};$.prototype.getStorageKey=function(t){var e,r=Y(L.ACCESS_TOKEN);return e=r&&r.u?self.btoa(encodeURIComponent(r.u).replace(/%([0-9A-F]{2})/g,(function(t,e){return String.fromCharCode(Number("0x"+e))}))):L.ACCESS_TOKEN||"",t?"mapbox.eventData."+t+":"+e:"mapbox.eventData:"+e},$.prototype.fetchEventData=function(){var t=C("localStorage"),e=this.getStorageKey(),r=this.getStorageKey("uuid");if(t)try{var n=self.localStorage.getItem(e);n&&(this.eventData=JSON.parse(n));var i=self.localStorage.getItem(r);i&&(this.anonId=i);}catch(t){w("Unable to read from LocalStorage");}},$.prototype.saveEventData=function(){var t=C("localStorage"),e=this.getStorageKey(),r=this.getStorageKey("uuid");if(t)try{self.localStorage.setItem(r,this.anonId),Object.keys(this.eventData).length>=1&&self.localStorage.setItem(e,JSON.stringify(this.eventData));}catch(t){w("Unable to write to LocalStorage");}},$.prototype.processRequests=function(t){},$.prototype.postEvent=function(t,e,r,n){var i=this;if(L.EVENTS_URL){var a=J(L.EVENTS_URL);a.params.push("access_token="+(n||L.ACCESS_TOKEN||""));var o={event:this.type,created:new Date(t).toISOString(),sdkIdentifier:"mapbox-gl-js",sdkVersion:"1.10.1",skuId:q,userId:this.anonId},s=e?p(o,e):o,u={url:H(a),headers:{"Content-Type":"text/plain"},body:JSON.stringify([s])};this.pendingRequest=xt(u,(function(t){i.pendingRequest=null,r(t),i.saveEventData(),i.processRequests(n);}));}},$.prototype.queueRequest=function(t,e){this.queue.push(t),this.processRequests(e);};var W,Q,tt=function(t){function e(){t.call(this,"map.load"),this.success={},this.skuToken="";}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.postMapLoadEvent=function(t,e,r,n){this.skuToken=r,(L.EVENTS_URL&&n||L.ACCESS_TOKEN&&Array.isArray(t)&&t.some((function(t){return K(t)||Z(t)})))&&this.queueRequest({id:e,timestamp:Date.now()},n);},e.prototype.processRequests=function(t){var e=this;if(!this.pendingRequest&&0!==this.queue.length){var r=this.queue.shift(),n=r.id,i=r.timestamp;n&&this.success[n]||(this.anonId||this.fetchEventData(),y(this.anonId)||(this.anonId=f()),this.postEvent(i,{skuToken:this.skuToken},(function(t){t||n&&(e.success[n]=!0);}),t));}},e}($),et=new(function(t){function e(e){t.call(this,"appUserTurnstile"),this._customAccessToken=e;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.postTurnstileEvent=function(t,e){L.EVENTS_URL&&L.ACCESS_TOKEN&&Array.isArray(t)&&t.some((function(t){return K(t)||Z(t)}))&&this.queueRequest(Date.now(),e);},e.prototype.processRequests=function(t){var e=this;if(!this.pendingRequest&&0!==this.queue.length){this.anonId&&this.eventData.lastSuccess&&this.eventData.tokenU||this.fetchEventData();var r=Y(L.ACCESS_TOKEN),n=r?r.u:L.ACCESS_TOKEN,i=n!==this.eventData.tokenU;y(this.anonId)||(this.anonId=f(),i=!0);var a=this.queue.shift();if(this.eventData.lastSuccess){var o=new Date(this.eventData.lastSuccess),s=new Date(a),u=(a-this.eventData.lastSuccess)/864e5;i=i||u>=1||u<-1||o.getDate()!==s.getDate();}else i=!0;if(!i)return this.processRequests();this.postEvent(a,{"enabled.telemetry":!1},(function(t){t||(e.eventData.lastSuccess=a,e.eventData.tokenU=n);}),t);}},e}($)),rt=et.postTurnstileEvent.bind(et),nt=new tt,it=nt.postMapLoadEvent.bind(nt),at=500,ot=50;function st(){self.caches&&!W&&(W=self.caches.open("mapbox-tiles"));}function ut(t){var e=t.indexOf("?");return e<0?t:t.slice(0,e)}var lt,pt=1/0;function ct(){return null==lt&&(lt=self.OffscreenCanvas&&new self.OffscreenCanvas(1,1).getContext("2d")&&"function"==typeof self.createImageBitmap),lt}var ht={Unknown:"Unknown",Style:"Style",Source:"Source",Tile:"Tile",Glyphs:"Glyphs",SpriteImage:"SpriteImage",SpriteJSON:"SpriteJSON",Image:"Image"};"function"==typeof Object.freeze&&Object.freeze(ht);var ft=function(t){function e(e,r,n){401===r&&Z(n)&&(e+=": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"),t.call(this,e),this.status=r,this.url=n,this.name=this.constructor.name,this.message=e;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.toString=function(){return this.name+": "+this.message+" ("+this.status+"): "+this.url},e}(Error),yt=S()?function(){return self.worker&&self.worker.referrer}:function(){return ("blob:"===self.location.protocol?self.parent:self).location.href};var dt,mt,vt=function(t,e){if(!(/^file:/.test(r=t.url)||/^file:/.test(yt())&&!/^\w+:/.test(r))){if(self.fetch&&self.Request&&self.AbortController&&self.Request.prototype.hasOwnProperty("signal"))return function(t,e){var r,n=new self.AbortController,i=new self.Request(t.url,{method:t.method||"GET",body:t.body,credentials:t.credentials,headers:t.headers,referrer:yt(),signal:n.signal}),a=!1,o=!1,s=(r=i.url).indexOf("sku=")>0&&Z(r);"json"===t.type&&i.headers.set("Accept","application/json");var u=function(r,n,a){if(!o){if(r&&"SecurityError"!==r.message&&w(r),n&&a)return l(n);var u=Date.now();self.fetch(i).then((function(r){if(r.ok){var n=s?r.clone():null;return l(r,n,u)}return e(new ft(r.statusText,r.status,t.url))})).catch((function(t){20!==t.code&&e(new Error(t.message));}));}},l=function(r,n,s){("arrayBuffer"===t.type?r.arrayBuffer():"json"===t.type?r.json():r.text()).then((function(t){o||(n&&s&&function(t,e,r){if(st(),W){var n={status:e.status,statusText:e.statusText,headers:new self.Headers};e.headers.forEach((function(t,e){return n.headers.set(e,t)}));var i=k(e.headers.get("Cache-Control")||"");i["no-store"]||(i["max-age"]&&n.headers.set("Expires",new Date(r+1e3*i["max-age"]).toUTCString()),new Date(n.headers.get("Expires")).getTime()-r<42e4||function(t,e){if(void 0===Q)try{new Response(new ReadableStream),Q=!0;}catch(t){Q=!1;}Q?e(t.body):t.blob().then(e);}(e,(function(e){var r=new self.Response(e,n);st(),W&&W.then((function(e){return e.put(ut(t.url),r)})).catch((function(t){return w(t.message)}));})));}}(i,n,s),a=!0,e(null,t,r.headers.get("Cache-Control"),r.headers.get("Expires")));})).catch((function(t){o||e(new Error(t.message));}));};return s?function(t,e){if(st(),!W)return e(null);var r=ut(t.url);W.then((function(t){t.match(r).then((function(n){var i=function(t){if(!t)return !1;var e=new Date(t.headers.get("Expires")||0),r=k(t.headers.get("Cache-Control")||"");return e>Date.now()&&!r["no-cache"]}(n);t.delete(r),i&&t.put(r,n.clone()),e(null,n,i);})).catch(e);})).catch(e);}(i,u):u(null,null),{cancel:function(){o=!0,a||n.abort();}}}(t,e);if(S()&&self.worker&&self.worker.actor)return self.worker.actor.send("getResource",t,e,void 0,!0)}var r;return function(t,e){var r=new self.XMLHttpRequest;for(var n in r.open(t.method||"GET",t.url,!0),"arrayBuffer"===t.type&&(r.responseType="arraybuffer"),t.headers)r.setRequestHeader(n,t.headers[n]);return "json"===t.type&&(r.responseType="text",r.setRequestHeader("Accept","application/json")),r.withCredentials="include"===t.credentials,r.onerror=function(){e(new Error(r.statusText));},r.onload=function(){if((r.status>=200&&r.status<300||0===r.status)&&null!==r.response){var n=r.response;if("json"===t.type)try{n=JSON.parse(r.response);}catch(t){return e(t)}e(null,n,r.getResponseHeader("Cache-Control"),r.getResponseHeader("Expires"));}else e(new ft(r.statusText,r.status,t.url));},r.send(t.body),{cancel:function(){return r.abort()}}}(t,e)},gt=function(t,e){return vt(p(t,{type:"arrayBuffer"}),e)},xt=function(t,e){return vt(p(t,{method:"POST"}),e)};dt=[],mt=0;var bt=function(t,e){if(R.supported&&(t.headers||(t.headers={}),t.headers.accept="image/webp,*/*"),mt>=L.MAX_PARALLEL_IMAGE_REQUESTS){var r={requestParameters:t,callback:e,cancelled:!1,cancel:function(){this.cancelled=!0;}};return dt.push(r),r}mt++;var n=!1,i=function(){if(!n)for(n=!0,mt--;dt.length&&mt<L.MAX_PARALLEL_IMAGE_REQUESTS;){var t=dt.shift();t.cancelled||(t.cancel=bt(t.requestParameters,t.callback).cancel);}},a=gt(t,(function(t,r,n,a){i(),t?e(t):r&&(ct()?function(t,e){var r=new self.Blob([new Uint8Array(t)],{type:"image/png"});self.createImageBitmap(r).then((function(t){e(null,t);})).catch((function(t){e(new Error("Could not load image because of "+t.message+". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));}));}(r,e):function(t,e,r,n){var i=new self.Image,a=self.URL;i.onload=function(){e(null,i),a.revokeObjectURL(i.src);},i.onerror=function(){return e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."))};var o=new self.Blob([new Uint8Array(t)],{type:"image/png"});i.cacheControl=r,i.expires=n,i.src=t.byteLength?a.createObjectURL(o):"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";}(r,e,n,a));}));return {cancel:function(){a.cancel(),i();}}};function wt(t,e,r){r[t]&&-1!==r[t].indexOf(e)||(r[t]=r[t]||[],r[t].push(e));}function _t(t,e,r){if(r&&r[t]){var n=r[t].indexOf(e);-1!==n&&r[t].splice(n,1);}}var At=function(t,e){void 0===e&&(e={}),p(this,e),this.type=t;},St=function(t){function e(e,r){void 0===r&&(r={}),t.call(this,"error",p({error:e},r));}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e}(At),kt=function(){};kt.prototype.on=function(t,e){return this._listeners=this._listeners||{},wt(t,e,this._listeners),this},kt.prototype.off=function(t,e){return _t(t,e,this._listeners),_t(t,e,this._oneTimeListeners),this},kt.prototype.once=function(t,e){return this._oneTimeListeners=this._oneTimeListeners||{},wt(t,e,this._oneTimeListeners),this},kt.prototype.fire=function(t,e){"string"==typeof t&&(t=new At(t,e||{}));var r=t.type;if(this.listens(r)){t.target=this;for(var n=0,i=this._listeners&&this._listeners[r]?this._listeners[r].slice():[];n<i.length;n+=1)i[n].call(this,t);for(var a=0,o=this._oneTimeListeners&&this._oneTimeListeners[r]?this._oneTimeListeners[r].slice():[];a<o.length;a+=1){var s=o[a];_t(r,s,this._oneTimeListeners),s.call(this,t);}var u=this._eventedParent;u&&(p(t,"function"==typeof this._eventedParentData?this._eventedParentData():this._eventedParentData),u.fire(t));}else t instanceof St&&console.error(t.error);return this},kt.prototype.listens=function(t){return this._listeners&&this._listeners[t]&&this._listeners[t].length>0||this._oneTimeListeners&&this._oneTimeListeners[t]&&this._oneTimeListeners[t].length>0||this._eventedParent&&this._eventedParent.listens(t)},kt.prototype.setEventedParent=function(t,e){return this._eventedParent=t,this._eventedParentData=e,this};var It={$version:8,$root:{version:{required:!0,type:"enum",values:[8]},name:{type:"string"},metadata:{type:"*"},center:{type:"array",value:"number"},zoom:{type:"number"},bearing:{type:"number",default:0,period:360,units:"degrees"},pitch:{type:"number",default:0,units:"degrees"},light:{type:"light"},sources:{required:!0,type:"sources"},sprite:{type:"string"},glyphs:{type:"string"},transition:{type:"transition"},layers:{required:!0,type:"array",value:"layer"}},sources:{"*":{type:"source"}},source:["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],source_vector:{type:{required:!0,type:"enum",values:{vector:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},attribution:{type:"string"},promoteId:{type:"promoteId"},"*":{type:"*"}},source_raster:{type:{required:!0,type:"enum",values:{raster:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},attribution:{type:"string"},"*":{type:"*"}},source_raster_dem:{type:{required:!0,type:"enum",values:{"raster-dem":{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},attribution:{type:"string"},encoding:{type:"enum",values:{terrarium:{},mapbox:{}},default:"mapbox"},"*":{type:"*"}},source_geojson:{type:{required:!0,type:"enum",values:{geojson:{}}},data:{type:"*"},maxzoom:{type:"number",default:18},attribution:{type:"string"},buffer:{type:"number",default:128,maximum:512,minimum:0},tolerance:{type:"number",default:.375},cluster:{type:"boolean",default:!1},clusterRadius:{type:"number",default:50,minimum:0},clusterMaxZoom:{type:"number"},clusterProperties:{type:"*"},lineMetrics:{type:"boolean",default:!1},generateId:{type:"boolean",default:!1},promoteId:{type:"promoteId"}},source_video:{type:{required:!0,type:"enum",values:{video:{}}},urls:{required:!0,type:"array",value:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},source_image:{type:{required:!0,type:"enum",values:{image:{}}},url:{required:!0,type:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},layer:{id:{type:"string",required:!0},type:{type:"enum",values:{fill:{},line:{},symbol:{},circle:{},heatmap:{},"fill-extrusion":{},raster:{},hillshade:{},background:{}},required:!0},metadata:{type:"*"},source:{type:"string"},"source-layer":{type:"string"},minzoom:{type:"number",minimum:0,maximum:24},maxzoom:{type:"number",minimum:0,maximum:24},filter:{type:"filter"},layout:{type:"layout"},paint:{type:"paint"}},layout:["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background"],layout_background:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_fill:{"fill-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_circle:{"circle-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_heatmap:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},"layout_fill-extrusion":{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_line:{"line-cap":{type:"enum",values:{butt:{},round:{},square:{}},default:"butt",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-join":{type:"enum",values:{bevel:{},round:{},miter:{}},default:"miter",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{type:"number",default:2,requires:[{"line-join":"miter"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-round-limit":{type:"number",default:1.05,requires:[{"line-join":"round"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_symbol:{"symbol-placement":{type:"enum",values:{point:{},line:{},"line-center":{}},default:"point",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-spacing":{type:"number",default:250,minimum:1,units:"pixels",requires:[{"symbol-placement":"line"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{type:"boolean",default:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{type:"enum",values:{auto:{},"viewport-y":{},source:{}},default:"auto",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-optional":{type:"boolean",default:!1,requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-size":{type:"number",default:1,minimum:0,units:"factor of the original icon size",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{type:"enum",values:{none:{},width:{},height:{},both:{}},default:"none",requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{type:"array",value:"number",length:4,default:[0,0,0,0],units:"pixels",requires:["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-image":{type:"resolvedImage",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{type:"boolean",default:!1,requires:["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-offset":{type:"array",value:"number",length:2,default:[0,0],requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-field":{type:"formatted",default:"",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-font":{type:"array",value:"string",default:["Open Sans Regular","Arial Unicode MS Regular"],requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-size":{type:"number",default:16,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{type:"number",default:10,minimum:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{type:"number",default:1.2,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-letter-spacing":{type:"number",default:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-justify":{type:"enum",values:{auto:{},left:{},center:{},right:{}},default:"center",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{type:"number",units:"ems",default:0,requires:["text-field"],"property-type":"data-driven",expression:{interpolated:!0,parameters:["zoom","feature"]}},"text-variable-anchor":{type:"array",value:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},requires:["text-field",{"symbol-placement":["point"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["text-field",{"!":"text-variable-anchor"}],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{type:"number",default:45,units:"degrees",requires:["text-field",{"symbol-placement":["line","line-center"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-writing-mode":{type:"array",value:"enum",values:{horizontal:{},vertical:{}},requires:["text-field",{"symbol-placement":["point"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-keep-upright":{type:"boolean",default:!0,requires:["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-transform":{type:"enum",values:{none:{},uppercase:{},lowercase:{}},default:"none",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-offset":{type:"array",value:"number",units:"ems",length:2,default:[0,0],requires:["text-field",{"!":"text-radial-offset"}],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-optional":{type:"boolean",default:!1,requires:["text-field","icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_raster:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_hillshade:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},filter:{type:"array",value:"*"},filter_operator:{type:"enum",values:{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},in:{},"!in":{},all:{},any:{},none:{},has:{},"!has":{},within:{}}},geometry_type:{type:"enum",values:{Point:{},LineString:{},Polygon:{}}},function:{expression:{type:"expression"},stops:{type:"array",value:"function_stop"},base:{type:"number",default:1,minimum:0},property:{type:"string",default:"$zoom"},type:{type:"enum",values:{identity:{},exponential:{},interval:{},categorical:{}},default:"exponential"},colorSpace:{type:"enum",values:{rgb:{},lab:{},hcl:{}},default:"rgb"},default:{type:"*",required:!1}},function_stop:{type:"array",minimum:0,maximum:24,value:["number","color"],length:2},expression:{type:"array",value:"*",minimum:1},expression_name:{type:"enum",values:{let:{group:"Variable binding"},var:{group:"Variable binding"},literal:{group:"Types"},array:{group:"Types"},at:{group:"Lookup"},in:{group:"Lookup"},"index-of":{group:"Lookup"},slice:{group:"Lookup"},case:{group:"Decision"},match:{group:"Decision"},coalesce:{group:"Decision"},step:{group:"Ramps, scales, curves"},interpolate:{group:"Ramps, scales, curves"},"interpolate-hcl":{group:"Ramps, scales, curves"},"interpolate-lab":{group:"Ramps, scales, curves"},ln2:{group:"Math"},pi:{group:"Math"},e:{group:"Math"},typeof:{group:"Types"},string:{group:"Types"},number:{group:"Types"},boolean:{group:"Types"},object:{group:"Types"},collator:{group:"Types"},format:{group:"Types"},image:{group:"Types"},"number-format":{group:"Types"},"to-string":{group:"Types"},"to-number":{group:"Types"},"to-boolean":{group:"Types"},"to-rgba":{group:"Color"},"to-color":{group:"Types"},rgb:{group:"Color"},rgba:{group:"Color"},get:{group:"Lookup"},has:{group:"Lookup"},length:{group:"Lookup"},properties:{group:"Feature data"},"feature-state":{group:"Feature data"},"geometry-type":{group:"Feature data"},id:{group:"Feature data"},zoom:{group:"Zoom"},"heatmap-density":{group:"Heatmap"},"line-progress":{group:"Feature data"},accumulated:{group:"Feature data"},"+":{group:"Math"},"*":{group:"Math"},"-":{group:"Math"},"/":{group:"Math"},"%":{group:"Math"},"^":{group:"Math"},sqrt:{group:"Math"},log10:{group:"Math"},ln:{group:"Math"},log2:{group:"Math"},sin:{group:"Math"},cos:{group:"Math"},tan:{group:"Math"},asin:{group:"Math"},acos:{group:"Math"},atan:{group:"Math"},min:{group:"Math"},max:{group:"Math"},round:{group:"Math"},abs:{group:"Math"},ceil:{group:"Math"},floor:{group:"Math"},distance:{group:"Math"},"==":{group:"Decision"},"!=":{group:"Decision"},">":{group:"Decision"},"<":{group:"Decision"},">=":{group:"Decision"},"<=":{group:"Decision"},all:{group:"Decision"},any:{group:"Decision"},"!":{group:"Decision"},within:{group:"Decision"},"is-supported-script":{group:"String"},upcase:{group:"String"},downcase:{group:"String"},concat:{group:"String"},"resolved-locale":{group:"String"}}},light:{anchor:{type:"enum",default:"viewport",values:{map:{},viewport:{}},"property-type":"data-constant",transition:!1,expression:{interpolated:!1,parameters:["zoom"]}},position:{type:"array",default:[1.15,210,30],length:3,value:"number","property-type":"data-constant",transition:!0,expression:{interpolated:!0,parameters:["zoom"]}},color:{type:"color","property-type":"data-constant",default:"#ffffff",expression:{interpolated:!0,parameters:["zoom"]},transition:!0},intensity:{type:"number","property-type":"data-constant",default:.5,minimum:0,maximum:1,expression:{interpolated:!0,parameters:["zoom"]},transition:!0}},paint:["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background"],paint_fill:{"fill-antialias":{type:"boolean",default:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{type:"color",transition:!0,requires:[{"!":"fill-pattern"},{"fill-antialias":!0}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-extrusion-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-extrusion-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"fill-extrusion-height":{type:"number",default:0,minimum:0,units:"meters",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{type:"number",default:0,minimum:0,units:"meters",transition:!0,requires:["fill-extrusion-height"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{type:"boolean",default:!0,transition:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_line:{"line-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"line-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["line-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-width":{type:"number",default:1,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{type:"number",default:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{type:"array",value:"number",minimum:0,transition:!0,units:"line widths",requires:[{"!":"line-pattern"}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"line-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-gradient":{type:"color",transition:!1,requires:[{"!":"line-dasharray"},{"!":"line-pattern"},{source:"geojson",has:{lineMetrics:!0}}],expression:{interpolated:!0,parameters:["line-progress"]},"property-type":"color-ramp"}},paint_circle:{"circle-radius":{type:"number",default:5,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{type:"number",default:0,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["circle-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{type:"enum",values:{map:{},viewport:{}},default:"map",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"}},paint_heatmap:{"heatmap-radius":{type:"number",default:30,minimum:1,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{type:"number",default:1,minimum:0,transition:!1,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{type:"number",default:1,minimum:0,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"heatmap-color":{type:"color",default:["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",.1,"royalblue",.3,"cyan",.5,"lime",.7,"yellow",1,"red"],transition:!1,expression:{interpolated:!0,parameters:["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_symbol:{"icon-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{type:"color",default:"#000000",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["icon-image","icon-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{type:"color",default:"#000000",transition:!0,overridable:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["text-field","text-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_raster:{"raster-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{type:"number",default:0,period:360,transition:!0,units:"degrees",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{type:"number",default:0,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-saturation":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-contrast":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-resampling":{type:"enum",values:{linear:{},nearest:{}},default:"linear",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{type:"number",default:300,minimum:0,transition:!1,units:"milliseconds",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_hillshade:{"hillshade-illumination-direction":{type:"number",default:335,minimum:0,maximum:359,transition:!1,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{type:"number",default:.5,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{type:"color",default:"#FFFFFF",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_background:{"background-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"background-pattern"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"background-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"background-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},transition:{duration:{type:"number",default:300,minimum:0,units:"milliseconds"},delay:{type:"number",default:0,minimum:0,units:"milliseconds"}},"property-type":{"data-driven":{type:"property-type"},"cross-faded":{type:"property-type"},"cross-faded-data-driven":{type:"property-type"},"color-ramp":{type:"property-type"},"data-constant":{type:"property-type"},constant:{type:"property-type"}},promoteId:{"*":{type:"string"}}},zt=function(t,e,r,n){this.message=(t?t+": ":"")+r,n&&(this.identifier=n),null!=e&&e.__line__&&(this.line=e.__line__);};function Ct(t){var e=t.value;return e?[new zt(t.key,e,"constants have been deprecated as of v8")]:[]}function Mt(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}function Et(t){return t instanceof Number||t instanceof String||t instanceof Boolean?t.valueOf():t}function Tt(t){if(Array.isArray(t))return t.map(Tt);if(t instanceof Object&&!(t instanceof Number||t instanceof String||t instanceof Boolean)){var e={};for(var r in t)e[r]=Tt(t[r]);return e}return Et(t)}var Pt=function(t){function e(e,r){t.call(this,r),this.message=r,this.key=e;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e}(Error),Bt=function(t,e){void 0===e&&(e=[]),this.parent=t,this.bindings={};for(var r=0,n=e;r<n.length;r+=1){var i=n[r];this.bindings[i[0]]=i[1];}};Bt.prototype.concat=function(t){return new Bt(this,t)},Bt.prototype.get=function(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(t+" not found in scope.")},Bt.prototype.has=function(t){return !!this.bindings[t]||!!this.parent&&this.parent.has(t)};var Vt={kind:"null"},Ft={kind:"number"},Dt={kind:"string"},Lt={kind:"boolean"},Rt={kind:"color"},Ot={kind:"object"},Ut={kind:"value"},jt={kind:"collator"},qt={kind:"formatted"},Nt={kind:"resolvedImage"};function Kt(t,e){return {kind:"array",itemType:t,N:e}}function Gt(t){if("array"===t.kind){var e=Gt(t.itemType);return "number"==typeof t.N?"array<"+e+", "+t.N+">":"value"===t.itemType.kind?"array":"array<"+e+">"}return t.kind}var Zt=[Vt,Ft,Dt,Lt,Rt,qt,Ot,Kt(Ut),Nt];function Xt(t,e){if("error"===e.kind)return null;if("array"===t.kind){if("array"===e.kind&&(0===e.N&&"value"===e.itemType.kind||!Xt(t.itemType,e.itemType))&&("number"!=typeof t.N||t.N===e.N))return null}else {if(t.kind===e.kind)return null;if("value"===t.kind)for(var r=0,n=Zt;r<n.length;r+=1)if(!Xt(n[r],e))return null}return "Expected "+Gt(t)+" but found "+Gt(e)+" instead."}function Jt(t,e){return e.some((function(e){return e.kind===t.kind}))}function Ht(t,e){return e.some((function(e){return "null"===e?null===t:"array"===e?Array.isArray(t):"object"===e?t&&!Array.isArray(t)&&"object"==typeof t:e===typeof t}))}var Yt=e((function(t,e){var r={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};function n(t){return (t=Math.round(t))<0?0:t>255?255:t}function i(t){return n("%"===t[t.length-1]?parseFloat(t)/100*255:parseInt(t))}function a(t){return (e="%"===t[t.length-1]?parseFloat(t)/100:parseFloat(t))<0?0:e>1?1:e;var e;}function o(t,e,r){return r<0?r+=1:r>1&&(r-=1),6*r<1?t+(e-t)*r*6:2*r<1?e:3*r<2?t+(e-t)*(2/3-r)*6:t}try{e.parseCSSColor=function(t){var e,s=t.replace(/ /g,"").toLowerCase();if(s in r)return r[s].slice();if("#"===s[0])return 4===s.length?(e=parseInt(s.substr(1),16))>=0&&e<=4095?[(3840&e)>>4|(3840&e)>>8,240&e|(240&e)>>4,15&e|(15&e)<<4,1]:null:7===s.length&&(e=parseInt(s.substr(1),16))>=0&&e<=16777215?[(16711680&e)>>16,(65280&e)>>8,255&e,1]:null;var u=s.indexOf("("),l=s.indexOf(")");if(-1!==u&&l+1===s.length){var p=s.substr(0,u),c=s.substr(u+1,l-(u+1)).split(","),h=1;switch(p){case"rgba":if(4!==c.length)return null;h=a(c.pop());case"rgb":return 3!==c.length?null:[i(c[0]),i(c[1]),i(c[2]),h];case"hsla":if(4!==c.length)return null;h=a(c.pop());case"hsl":if(3!==c.length)return null;var f=(parseFloat(c[0])%360+360)%360/360,y=a(c[1]),d=a(c[2]),m=d<=.5?d*(y+1):d+y-d*y,v=2*d-m;return [n(255*o(v,m,f+1/3)),n(255*o(v,m,f)),n(255*o(v,m,f-1/3)),h];default:return null}}return null};}catch(t){}})).parseCSSColor,$t=function(t,e,r,n){void 0===n&&(n=1),this.r=t,this.g=e,this.b=r,this.a=n;};$t.parse=function(t){if(t){if(t instanceof $t)return t;if("string"==typeof t){var e=Yt(t);if(e)return new $t(e[0]/255*e[3],e[1]/255*e[3],e[2]/255*e[3],e[3])}}},$t.prototype.toString=function(){var t=this.toArray(),e=t[1],r=t[2],n=t[3];return "rgba("+Math.round(t[0])+","+Math.round(e)+","+Math.round(r)+","+n+")"},$t.prototype.toArray=function(){var t=this.a;return 0===t?[0,0,0,0]:[255*this.r/t,255*this.g/t,255*this.b/t,t]},$t.black=new $t(0,0,0,1),$t.white=new $t(1,1,1,1),$t.transparent=new $t(0,0,0,0),$t.red=new $t(1,0,0,1);var Wt=function(t,e,r){this.sensitivity=t?e?"variant":"case":e?"accent":"base",this.locale=r,this.collator=new Intl.Collator(this.locale?this.locale:[],{sensitivity:this.sensitivity,usage:"search"});};Wt.prototype.compare=function(t,e){return this.collator.compare(t,e)},Wt.prototype.resolvedLocale=function(){return new Intl.Collator(this.locale?this.locale:[]).resolvedOptions().locale};var Qt=function(t,e,r,n,i){this.text=t,this.image=e,this.scale=r,this.fontStack=n,this.textColor=i;},te=function(t){this.sections=t;};te.fromString=function(t){return new te([new Qt(t,null,null,null,null)])},te.prototype.isEmpty=function(){return 0===this.sections.length||!this.sections.some((function(t){return 0!==t.text.length||t.image&&0!==t.image.name.length}))},te.factory=function(t){return t instanceof te?t:te.fromString(t)},te.prototype.toString=function(){return 0===this.sections.length?"":this.sections.map((function(t){return t.text})).join("")},te.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];if(n.image)t.push(["image",n.image.name]);else {t.push(n.text);var i={};n.fontStack&&(i["text-font"]=["literal",n.fontStack.split(",")]),n.scale&&(i["font-scale"]=n.scale),n.textColor&&(i["text-color"]=["rgba"].concat(n.textColor.toArray())),t.push(i);}}return t};var ee=function(t){this.name=t.name,this.available=t.available;};function re(t,e,r,n){return "number"==typeof t&&t>=0&&t<=255&&"number"==typeof e&&e>=0&&e<=255&&"number"==typeof r&&r>=0&&r<=255?void 0===n||"number"==typeof n&&n>=0&&n<=1?null:"Invalid rgba value ["+[t,e,r,n].join(", ")+"]: 'a' must be between 0 and 1.":"Invalid rgba value ["+("number"==typeof n?[t,e,r,n]:[t,e,r]).join(", ")+"]: 'r', 'g', and 'b' must be between 0 and 255."}function ne(t){if(null===t)return !0;if("string"==typeof t)return !0;if("boolean"==typeof t)return !0;if("number"==typeof t)return !0;if(t instanceof $t)return !0;if(t instanceof Wt)return !0;if(t instanceof te)return !0;if(t instanceof ee)return !0;if(Array.isArray(t)){for(var e=0,r=t;e<r.length;e+=1)if(!ne(r[e]))return !1;return !0}if("object"==typeof t){for(var n in t)if(!ne(t[n]))return !1;return !0}return !1}function ie(t){if(null===t)return Vt;if("string"==typeof t)return Dt;if("boolean"==typeof t)return Lt;if("number"==typeof t)return Ft;if(t instanceof $t)return Rt;if(t instanceof Wt)return jt;if(t instanceof te)return qt;if(t instanceof ee)return Nt;if(Array.isArray(t)){for(var e,r=t.length,n=0,i=t;n<i.length;n+=1){var a=ie(i[n]);if(e){if(e===a)continue;e=Ut;break}e=a;}return Kt(e||Ut,r)}return Ot}function ae(t){var e=typeof t;return null===t?"":"string"===e||"number"===e||"boolean"===e?String(t):t instanceof $t||t instanceof te||t instanceof ee?t.toString():JSON.stringify(t)}ee.prototype.toString=function(){return this.name},ee.fromString=function(t){return t?new ee({name:t,available:!1}):null},ee.prototype.serialize=function(){return ["image",this.name]};var oe=function(t,e){this.type=t,this.value=e;};oe.parse=function(t,e){if(2!==t.length)return e.error("'literal' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(!ne(t[1]))return e.error("invalid value");var r=t[1],n=ie(r),i=e.expectedType;return "array"!==n.kind||0!==n.N||!i||"array"!==i.kind||"number"==typeof i.N&&0!==i.N||(n=i),new oe(n,r)},oe.prototype.evaluate=function(){return this.value},oe.prototype.eachChild=function(){},oe.prototype.outputDefined=function(){return !0},oe.prototype.serialize=function(){return "array"===this.type.kind||"object"===this.type.kind?["literal",this.value]:this.value instanceof $t?["rgba"].concat(this.value.toArray()):this.value instanceof te?this.value.serialize():this.value};var se=function(t){this.name="ExpressionEvaluationError",this.message=t;};se.prototype.toJSON=function(){return this.message};var ue={string:Dt,number:Ft,boolean:Lt,object:Ot},le=function(t,e){this.type=t,this.args=e;};le.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r,n=1,i=t[0];if("array"===i){var a,o;if(t.length>2){var s=t[1];if("string"!=typeof s||!(s in ue)||"object"===s)return e.error('The item type argument of "array" must be one of string, number, boolean',1);a=ue[s],n++;}else a=Ut;if(t.length>3){if(null!==t[2]&&("number"!=typeof t[2]||t[2]<0||t[2]!==Math.floor(t[2])))return e.error('The length argument to "array" must be a positive integer literal',2);o=t[2],n++;}r=Kt(a,o);}else r=ue[i];for(var u=[];n<t.length;n++){var l=e.parse(t[n],n,Ut);if(!l)return null;u.push(l);}return new le(r,u)},le.prototype.evaluate=function(t){for(var e=0;e<this.args.length;e++){var r=this.args[e].evaluate(t);if(!Xt(this.type,ie(r)))return r;if(e===this.args.length-1)throw new se("Expected value to be of type "+Gt(this.type)+", but found "+Gt(ie(r))+" instead.")}return null},le.prototype.eachChild=function(t){this.args.forEach(t);},le.prototype.outputDefined=function(){return this.args.every((function(t){return t.outputDefined()}))},le.prototype.serialize=function(){var t=this.type,e=[t.kind];if("array"===t.kind){var r=t.itemType;if("string"===r.kind||"number"===r.kind||"boolean"===r.kind){e.push(r.kind);var n=t.N;("number"==typeof n||this.args.length>1)&&e.push(n);}}return e.concat(this.args.map((function(t){return t.serialize()})))};var pe=function(t){this.type=qt,this.sections=t;};pe.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r=t[1];if(!Array.isArray(r)&&"object"==typeof r)return e.error("First argument must be an image or text section.");for(var n=[],i=!1,a=1;a<=t.length-1;++a){var o=t[a];if(i&&"object"==typeof o&&!Array.isArray(o)){i=!1;var s=null;if(o["font-scale"]&&!(s=e.parse(o["font-scale"],1,Ft)))return null;var u=null;if(o["text-font"]&&!(u=e.parse(o["text-font"],1,Kt(Dt))))return null;var l=null;if(o["text-color"]&&!(l=e.parse(o["text-color"],1,Rt)))return null;var p=n[n.length-1];p.scale=s,p.font=u,p.textColor=l;}else {var c=e.parse(t[a],1,Ut);if(!c)return null;var h=c.type.kind;if("string"!==h&&"value"!==h&&"null"!==h&&"resolvedImage"!==h)return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");i=!0,n.push({content:c,scale:null,font:null,textColor:null});}}return new pe(n)},pe.prototype.evaluate=function(t){return new te(this.sections.map((function(e){var r=e.content.evaluate(t);return ie(r)===Nt?new Qt("",r,null,null,null):new Qt(ae(r),null,e.scale?e.scale.evaluate(t):null,e.font?e.font.evaluate(t).join(","):null,e.textColor?e.textColor.evaluate(t):null)})))},pe.prototype.eachChild=function(t){for(var e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t(n.content),n.scale&&t(n.scale),n.font&&t(n.font),n.textColor&&t(n.textColor);}},pe.prototype.outputDefined=function(){return !1},pe.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t.push(n.content.serialize());var i={};n.scale&&(i["font-scale"]=n.scale.serialize()),n.font&&(i["text-font"]=n.font.serialize()),n.textColor&&(i["text-color"]=n.textColor.serialize()),t.push(i);}return t};var ce=function(t){this.type=Nt,this.input=t;};ce.parse=function(t,e){if(2!==t.length)return e.error("Expected two arguments.");var r=e.parse(t[1],1,Dt);return r?new ce(r):e.error("No image name provided.")},ce.prototype.evaluate=function(t){var e=this.input.evaluate(t),r=ee.fromString(e);return r&&t.availableImages&&(r.available=t.availableImages.indexOf(e)>-1),r},ce.prototype.eachChild=function(t){t(this.input);},ce.prototype.outputDefined=function(){return !1},ce.prototype.serialize=function(){return ["image",this.input.serialize()]};var he={"to-boolean":Lt,"to-color":Rt,"to-number":Ft,"to-string":Dt},fe=function(t,e){this.type=t,this.args=e;};fe.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r=t[0];if(("to-boolean"===r||"to-string"===r)&&2!==t.length)return e.error("Expected one argument.");for(var n=he[r],i=[],a=1;a<t.length;a++){var o=e.parse(t[a],a,Ut);if(!o)return null;i.push(o);}return new fe(n,i)},fe.prototype.evaluate=function(t){if("boolean"===this.type.kind)return Boolean(this.args[0].evaluate(t));if("color"===this.type.kind){for(var e,r,n=0,i=this.args;n<i.length;n+=1){if(r=null,(e=i[n].evaluate(t))instanceof $t)return e;if("string"==typeof e){var a=t.parseColor(e);if(a)return a}else if(Array.isArray(e)&&!(r=e.length<3||e.length>4?"Invalid rbga value "+JSON.stringify(e)+": expected an array containing either three or four numeric values.":re(e[0],e[1],e[2],e[3])))return new $t(e[0]/255,e[1]/255,e[2]/255,e[3])}throw new se(r||"Could not parse color from value '"+("string"==typeof e?e:String(JSON.stringify(e)))+"'")}if("number"===this.type.kind){for(var o=null,s=0,u=this.args;s<u.length;s+=1){if(null===(o=u[s].evaluate(t)))return 0;var l=Number(o);if(!isNaN(l))return l}throw new se("Could not convert "+JSON.stringify(o)+" to number.")}return "formatted"===this.type.kind?te.fromString(ae(this.args[0].evaluate(t))):"resolvedImage"===this.type.kind?ee.fromString(ae(this.args[0].evaluate(t))):ae(this.args[0].evaluate(t))},fe.prototype.eachChild=function(t){this.args.forEach(t);},fe.prototype.outputDefined=function(){return this.args.every((function(t){return t.outputDefined()}))},fe.prototype.serialize=function(){if("formatted"===this.type.kind)return new pe([{content:this.args[0],scale:null,font:null,textColor:null}]).serialize();if("resolvedImage"===this.type.kind)return new ce(this.args[0]).serialize();var t=["to-"+this.type.kind];return this.eachChild((function(e){t.push(e.serialize());})),t};var ye=["Unknown","Point","LineString","Polygon"],de=function(){this.globals=null,this.feature=null,this.featureState=null,this.formattedSection=null,this._parseColorCache={},this.availableImages=null,this.canonical=null;};de.prototype.id=function(){return this.feature&&"id"in this.feature?this.feature.id:null},de.prototype.geometryType=function(){return this.feature?"number"==typeof this.feature.type?ye[this.feature.type]:this.feature.type:null},de.prototype.geometry=function(){return this.feature&&"geometry"in this.feature?this.feature.geometry:null},de.prototype.canonicalID=function(){return this.canonical},de.prototype.properties=function(){return this.feature&&this.feature.properties||{}},de.prototype.parseColor=function(t){var e=this._parseColorCache[t];return e||(e=this._parseColorCache[t]=$t.parse(t)),e};var me=function(t,e,r,n){this.name=t,this.type=e,this._evaluate=r,this.args=n;};me.prototype.evaluate=function(t){return this._evaluate(t,this.args)},me.prototype.eachChild=function(t){this.args.forEach(t);},me.prototype.outputDefined=function(){return !1},me.prototype.serialize=function(){return [this.name].concat(this.args.map((function(t){return t.serialize()})))},me.parse=function(t,e){var r,n=t[0],i=me.definitions[n];if(!i)return e.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0);for(var a=Array.isArray(i)?i[0]:i.type,o=Array.isArray(i)?[[i[1],i[2]]]:i.overloads,s=o.filter((function(e){var r=e[0];return !Array.isArray(r)||r.length===t.length-1})),u=null,l=0,p=s;l<p.length;l+=1){var c=p[l],h=c[0],f=c[1];u=new Re(e.registry,e.path,null,e.scope);for(var y=[],d=!1,m=1;m<t.length;m++){var v=t[m],g=Array.isArray(h)?h[m-1]:h.type,x=u.parse(v,1+y.length,g);if(!x){d=!0;break}y.push(x);}if(!d)if(Array.isArray(h)&&h.length!==y.length)u.error("Expected "+h.length+" arguments, but found "+y.length+" instead.");else {for(var b=0;b<y.length;b++){var w=Array.isArray(h)?h[b]:h.type,_=y[b];u.concat(b+1).checkSubtype(w,_.type);}if(0===u.errors.length)return new me(n,a,f,y)}}if(1===s.length)(r=e.errors).push.apply(r,u.errors);else {for(var A=(s.length?s:o).map((function(t){var e;return e=t[0],Array.isArray(e)?"("+e.map(Gt).join(", ")+")":"("+Gt(e.type)+"...)"})).join(" | "),S=[],k=1;k<t.length;k++){var I=e.parse(t[k],1+S.length);if(!I)return null;S.push(Gt(I.type));}e.error("Expected arguments of type "+A+", but found ("+S.join(", ")+") instead.");}return null},me.register=function(t,e){for(var r in me.definitions=e,e)t[r]=me;};var ve=function(t,e,r){this.type=jt,this.locale=r,this.caseSensitive=t,this.diacriticSensitive=e;};function ge(t,e){t[0]=Math.min(t[0],e[0]),t[1]=Math.min(t[1],e[1]),t[2]=Math.max(t[2],e[0]),t[3]=Math.max(t[3],e[1]);}function xe(t,e){return !(t[0]<=e[0]||t[2]>=e[2]||t[1]<=e[1]||t[3]>=e[3])}function be(t,e){var r=(180+t[0])/360,n=(180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t[1]*Math.PI/360)))/360,i=Math.pow(2,e.z);return [Math.round(r*i*8192),Math.round(n*i*8192)]}function we(t,e,r){return e[1]>t[1]!=r[1]>t[1]&&t[0]<(r[0]-e[0])*(t[1]-e[1])/(r[1]-e[1])+e[0]}function _e(t,e){for(var r,n,i,a,o,s,u,l=!1,p=0,c=e.length;p<c;p++)for(var h=e[p],f=0,y=h.length;f<y-1;f++){if((a=(r=t)[0]-(n=h[f])[0])*(u=r[1]-(i=h[f+1])[1])-(s=r[0]-i[0])*(o=r[1]-n[1])==0&&a*s<=0&&o*u<=0)return !1;we(t,h[f],h[f+1])&&(l=!l);}return l}function Ae(t,e){for(var r=0;r<e.length;r++)if(_e(t,e[r]))return !0;return !1}function Se(t,e,r,n){var i=n[0]-r[0],a=n[1]-r[1],o=(t[0]-r[0])*a-i*(t[1]-r[1]),s=(e[0]-r[0])*a-i*(e[1]-r[1]);return o>0&&s<0||o<0&&s>0}function ke(t,e,r){for(var n=0,i=r;n<i.length;n+=1)for(var a=i[n],o=0;o<a.length-1;++o)if(0!=(c=[(p=a[o+1])[0]-(l=a[o])[0],p[1]-l[1]])[0]*(h=[(u=e)[0]-(s=t)[0],u[1]-s[1]])[1]-c[1]*h[0]&&Se(s,u,l,p)&&Se(l,p,s,u))return !0;var s,u,l,p,c,h;return !1}function Ie(t,e){for(var r=0;r<t.length;++r)if(!_e(t[r],e))return !1;for(var n=0;n<t.length-1;++n)if(ke(t[n],t[n+1],e))return !1;return !0}function ze(t,e){for(var r=0;r<e.length;r++)if(Ie(t,e[r]))return !0;return !1}function Ce(t,e,r){for(var n=[],i=0;i<t.length;i++){for(var a=[],o=0;o<t[i].length;o++){var s=be(t[i][o],r);ge(e,s),a.push(s);}n.push(a);}return n}function Me(t,e,r){for(var n=[],i=0;i<t.length;i++){var a=Ce(t[i],e,r);n.push(a);}return n}function Ee(t,e,r,n){if(t[0]<r[0]||t[0]>r[2]){var i=.5*n,a=t[0]-r[0]>i?-n:r[0]-t[0]>i?n:0;0===a&&(a=t[0]-r[2]>i?-n:r[2]-t[0]>i?n:0),t[0]+=a;}ge(e,t);}function Te(t,e,r,n){for(var i=8192*Math.pow(2,n.z),a=[8192*n.x,8192*n.y],o=[],s=0,u=t;s<u.length;s+=1)for(var l=0,p=u[s];l<p.length;l+=1){var c=p[l],h=[c.x+a[0],c.y+a[1]];Ee(h,e,r,i),o.push(h);}return o}function Pe(t,e,r,n){for(var i,a=8192*Math.pow(2,n.z),o=[8192*n.x,8192*n.y],s=[],u=0,l=t;u<l.length;u+=1){for(var p=[],c=0,h=l[u];c<h.length;c+=1){var f=h[c],y=[f.x+o[0],f.y+o[1]];ge(e,y),p.push(y);}s.push(p);}if(e[2]-e[0]<=a/2){(i=e)[0]=i[1]=1/0,i[2]=i[3]=-1/0;for(var d=0,m=s;d<m.length;d+=1)for(var v=0,g=m[d];v<g.length;v+=1)Ee(g[v],e,r,a);}return s}ve.parse=function(t,e){if(2!==t.length)return e.error("Expected one argument.");var r=t[1];if("object"!=typeof r||Array.isArray(r))return e.error("Collator options argument must be an object.");var n=e.parse(void 0!==r["case-sensitive"]&&r["case-sensitive"],1,Lt);if(!n)return null;var i=e.parse(void 0!==r["diacritic-sensitive"]&&r["diacritic-sensitive"],1,Lt);if(!i)return null;var a=null;return r.locale&&!(a=e.parse(r.locale,1,Dt))?null:new ve(n,i,a)},ve.prototype.evaluate=function(t){return new Wt(this.caseSensitive.evaluate(t),this.diacriticSensitive.evaluate(t),this.locale?this.locale.evaluate(t):null)},ve.prototype.eachChild=function(t){t(this.caseSensitive),t(this.diacriticSensitive),this.locale&&t(this.locale);},ve.prototype.outputDefined=function(){return !1},ve.prototype.serialize=function(){var t={};return t["case-sensitive"]=this.caseSensitive.serialize(),t["diacritic-sensitive"]=this.diacriticSensitive.serialize(),this.locale&&(t.locale=this.locale.serialize()),["collator",t]};var Be=function(t,e){this.type=Lt,this.geojson=t,this.geometries=e;};function Ve(t){if(t instanceof me){if("get"===t.name&&1===t.args.length)return !1;if("feature-state"===t.name)return !1;if("has"===t.name&&1===t.args.length)return !1;if("properties"===t.name||"geometry-type"===t.name||"id"===t.name)return !1;if(/^filter-/.test(t.name))return !1}if(t instanceof Be)return !1;var e=!0;return t.eachChild((function(t){e&&!Ve(t)&&(e=!1);})),e}function Fe(t){if(t instanceof me&&"feature-state"===t.name)return !1;var e=!0;return t.eachChild((function(t){e&&!Fe(t)&&(e=!1);})),e}function De(t,e){if(t instanceof me&&e.indexOf(t.name)>=0)return !1;var r=!0;return t.eachChild((function(t){r&&!De(t,e)&&(r=!1);})),r}Be.parse=function(t,e){if(2!==t.length)return e.error("'within' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(ne(t[1])){var r=t[1];if("FeatureCollection"===r.type)for(var n=0;n<r.features.length;++n){var i=r.features[n].geometry.type;if("Polygon"===i||"MultiPolygon"===i)return new Be(r,r.features[n].geometry)}else if("Feature"===r.type){var a=r.geometry.type;if("Polygon"===a||"MultiPolygon"===a)return new Be(r,r.geometry)}else if("Polygon"===r.type||"MultiPolygon"===r.type)return new Be(r,r)}return e.error("'within' expression requires valid geojson object that contains polygon geometry type.")},Be.prototype.evaluate=function(t){if(null!=t.geometry()&&null!=t.canonicalID()){if("Point"===t.geometryType())return function(t,e){var r=[1/0,1/0,-1/0,-1/0],n=[1/0,1/0,-1/0,-1/0],i=t.canonicalID();if("Polygon"===e.type){var a=Ce(e.coordinates,n,i),o=Te(t.geometry(),r,n,i);if(!xe(r,n))return !1;for(var s=0,u=o;s<u.length;s+=1)if(!_e(u[s],a))return !1}if("MultiPolygon"===e.type){var l=Me(e.coordinates,n,i),p=Te(t.geometry(),r,n,i);if(!xe(r,n))return !1;for(var c=0,h=p;c<h.length;c+=1)if(!Ae(h[c],l))return !1}return !0}(t,this.geometries);if("LineString"===t.geometryType())return function(t,e){var r=[1/0,1/0,-1/0,-1/0],n=[1/0,1/0,-1/0,-1/0],i=t.canonicalID();if("Polygon"===e.type){var a=Ce(e.coordinates,n,i),o=Pe(t.geometry(),r,n,i);if(!xe(r,n))return !1;for(var s=0,u=o;s<u.length;s+=1)if(!Ie(u[s],a))return !1}if("MultiPolygon"===e.type){var l=Me(e.coordinates,n,i),p=Pe(t.geometry(),r,n,i);if(!xe(r,n))return !1;for(var c=0,h=p;c<h.length;c+=1)if(!ze(h[c],l))return !1}return !0}(t,this.geometries)}return !1},Be.prototype.eachChild=function(){},Be.prototype.outputDefined=function(){return !0},Be.prototype.serialize=function(){return ["within",this.geojson]};var Le=function(t,e){this.type=e.type,this.name=t,this.boundExpression=e;};Le.parse=function(t,e){if(2!==t.length||"string"!=typeof t[1])return e.error("'var' expression requires exactly one string literal argument.");var r=t[1];return e.scope.has(r)?new Le(r,e.scope.get(r)):e.error('Unknown variable "'+r+'". Make sure "'+r+'" has been bound in an enclosing "let" expression before using it.',1)},Le.prototype.evaluate=function(t){return this.boundExpression.evaluate(t)},Le.prototype.eachChild=function(){},Le.prototype.outputDefined=function(){return !1},Le.prototype.serialize=function(){return ["var",this.name]};var Re=function(t,e,r,n,i){void 0===e&&(e=[]),void 0===n&&(n=new Bt),void 0===i&&(i=[]),this.registry=t,this.path=e,this.key=e.map((function(t){return "["+t+"]"})).join(""),this.scope=n,this.errors=i,this.expectedType=r;};function Oe(t,e){for(var r,n=t.length-1,i=0,a=n,o=0;i<=a;)if((r=t[o=Math.floor((i+a)/2)])<=e){if(o===n||e<t[o+1])return o;i=o+1;}else {if(!(r>e))throw new se("Input is not a number.");a=o-1;}return 0}Re.prototype.parse=function(t,e,r,n,i){return void 0===i&&(i={}),e?this.concat(e,r,n)._parse(t,i):this._parse(t,i)},Re.prototype._parse=function(t,e){function r(t,e,r){return "assert"===r?new le(e,[t]):"coerce"===r?new fe(e,[t]):t}if(null!==t&&"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t||(t=["literal",t]),Array.isArray(t)){if(0===t.length)return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');var n=t[0];if("string"!=typeof n)return this.error("Expression name must be a string, but found "+typeof n+' instead. If you wanted a literal array, use ["literal", [...]].',0),null;var i=this.registry[n];if(i){var a=i.parse(t,this);if(!a)return null;if(this.expectedType){var o=this.expectedType,s=a.type;if("string"!==o.kind&&"number"!==o.kind&&"boolean"!==o.kind&&"object"!==o.kind&&"array"!==o.kind||"value"!==s.kind)if("color"!==o.kind&&"formatted"!==o.kind&&"resolvedImage"!==o.kind||"value"!==s.kind&&"string"!==s.kind){if(this.checkSubtype(o,s))return null}else a=r(a,o,e.typeAnnotation||"coerce");else a=r(a,o,e.typeAnnotation||"assert");}if(!(a instanceof oe)&&"resolvedImage"!==a.type.kind&&function t(e){if(e instanceof Le)return t(e.boundExpression);if(e instanceof me&&"error"===e.name)return !1;if(e instanceof ve)return !1;if(e instanceof Be)return !1;var r=e instanceof fe||e instanceof le,n=!0;return e.eachChild((function(e){n=r?n&&t(e):n&&e instanceof oe;})),!!n&&Ve(e)&&De(e,["zoom","heatmap-density","line-progress","accumulated","is-supported-script"])}(a)){var u=new de;try{a=new oe(a.type,a.evaluate(u));}catch(t){return this.error(t.message),null}}return a}return this.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0)}return this.error(void 0===t?"'undefined' value invalid. Use null instead.":"object"==typeof t?'Bare objects invalid. Use ["literal", {...}] instead.':"Expected an array, but found "+typeof t+" instead.")},Re.prototype.concat=function(t,e,r){var n="number"==typeof t?this.path.concat(t):this.path,i=r?this.scope.concat(r):this.scope;return new Re(this.registry,n,e||null,i,this.errors)},Re.prototype.error=function(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];var n=""+this.key+e.map((function(t){return "["+t+"]"})).join("");this.errors.push(new Pt(n,t));},Re.prototype.checkSubtype=function(t,e){var r=Xt(t,e);return r&&this.error(r),r};var Ue=function(t,e,r){this.type=t,this.input=e,this.labels=[],this.outputs=[];for(var n=0,i=r;n<i.length;n+=1){var a=i[n],o=a[1];this.labels.push(a[0]),this.outputs.push(o);}};function je(t,e,r){return t*(1-r)+e*r}Ue.parse=function(t,e){if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");var r=e.parse(t[1],1,Ft);if(!r)return null;var n=[],i=null;e.expectedType&&"value"!==e.expectedType.kind&&(i=e.expectedType);for(var a=1;a<t.length;a+=2){var o=1===a?-1/0:t[a],s=t[a+1],u=a,l=a+1;if("number"!=typeof o)return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',u);if(n.length&&n[n.length-1][0]>=o)return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',u);var p=e.parse(s,l,i);if(!p)return null;i=i||p.type,n.push([o,p]);}return new Ue(i,r,n)},Ue.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;return n>=e[i-1]?r[i-1].evaluate(t):r[Oe(e,n)].evaluate(t)},Ue.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1)t(r[e]);},Ue.prototype.outputDefined=function(){return this.outputs.every((function(t){return t.outputDefined()}))},Ue.prototype.serialize=function(){for(var t=["step",this.input.serialize()],e=0;e<this.labels.length;e++)e>0&&t.push(this.labels[e]),t.push(this.outputs[e].serialize());return t};var qe=Object.freeze({__proto__:null,number:je,color:function(t,e,r){return new $t(je(t.r,e.r,r),je(t.g,e.g,r),je(t.b,e.b,r),je(t.a,e.a,r))},array:function(t,e,r){return t.map((function(t,n){return je(t,e[n],r)}))}}),Ne=6/29*3*(6/29),Ke=Math.PI/180,Ge=180/Math.PI;function Ze(t){return t>.008856451679035631?Math.pow(t,1/3):t/Ne+4/29}function Xe(t){return t>6/29?t*t*t:Ne*(t-4/29)}function Je(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function He(t){return (t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function Ye(t){var e=He(t.r),r=He(t.g),n=He(t.b),i=Ze((.4124564*e+.3575761*r+.1804375*n)/.95047),a=Ze((.2126729*e+.7151522*r+.072175*n)/1);return {l:116*a-16,a:500*(i-a),b:200*(a-Ze((.0193339*e+.119192*r+.9503041*n)/1.08883)),alpha:t.a}}function $e(t){var e=(t.l+16)/116,r=isNaN(t.a)?e:e+t.a/500,n=isNaN(t.b)?e:e-t.b/200;return e=1*Xe(e),r=.95047*Xe(r),n=1.08883*Xe(n),new $t(Je(3.2404542*r-1.5371385*e-.4985314*n),Je(-.969266*r+1.8760108*e+.041556*n),Je(.0556434*r-.2040259*e+1.0572252*n),t.alpha)}function We(t,e,r){var n=e-t;return t+r*(n>180||n<-180?n-360*Math.round(n/360):n)}var Qe={forward:Ye,reverse:$e,interpolate:function(t,e,r){return {l:je(t.l,e.l,r),a:je(t.a,e.a,r),b:je(t.b,e.b,r),alpha:je(t.alpha,e.alpha,r)}}},tr={forward:function(t){var e=Ye(t),r=e.l,n=e.a,i=e.b,a=Math.atan2(i,n)*Ge;return {h:a<0?a+360:a,c:Math.sqrt(n*n+i*i),l:r,alpha:t.a}},reverse:function(t){var e=t.h*Ke,r=t.c;return $e({l:t.l,a:Math.cos(e)*r,b:Math.sin(e)*r,alpha:t.alpha})},interpolate:function(t,e,r){return {h:We(t.h,e.h,r),c:je(t.c,e.c,r),l:je(t.l,e.l,r),alpha:je(t.alpha,e.alpha,r)}}},er=Object.freeze({__proto__:null,lab:Qe,hcl:tr}),rr=function(t,e,r,n,i){this.type=t,this.operator=e,this.interpolation=r,this.input=n,this.labels=[],this.outputs=[];for(var a=0,o=i;a<o.length;a+=1){var s=o[a],u=s[1];this.labels.push(s[0]),this.outputs.push(u);}};function nr(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}rr.interpolationFactor=function(t,e,n,i){var a=0;if("exponential"===t.name)a=nr(e,t.base,n,i);else if("linear"===t.name)a=nr(e,1,n,i);else if("cubic-bezier"===t.name){var o=t.controlPoints;a=new r(o[0],o[1],o[2],o[3]).solve(nr(e,1,n,i));}return a},rr.parse=function(t,e){var r=t[0],n=t[1],i=t[2],a=t.slice(3);if(!Array.isArray(n)||0===n.length)return e.error("Expected an interpolation type expression.",1);if("linear"===n[0])n={name:"linear"};else if("exponential"===n[0]){var o=n[1];if("number"!=typeof o)return e.error("Exponential interpolation requires a numeric base.",1,1);n={name:"exponential",base:o};}else {if("cubic-bezier"!==n[0])return e.error("Unknown interpolation type "+String(n[0]),1,0);var s=n.slice(1);if(4!==s.length||s.some((function(t){return "number"!=typeof t||t<0||t>1})))return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);n={name:"cubic-bezier",controlPoints:s};}if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(!(i=e.parse(i,2,Ft)))return null;var u=[],l=null;"interpolate-hcl"===r||"interpolate-lab"===r?l=Rt:e.expectedType&&"value"!==e.expectedType.kind&&(l=e.expectedType);for(var p=0;p<a.length;p+=2){var c=a[p],h=a[p+1],f=p+3,y=p+4;if("number"!=typeof c)return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',f);if(u.length&&u[u.length-1][0]>=c)return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',f);var d=e.parse(h,y,l);if(!d)return null;l=l||d.type,u.push([c,d]);}return "number"===l.kind||"color"===l.kind||"array"===l.kind&&"number"===l.itemType.kind&&"number"==typeof l.N?new rr(l,r,n,i,u):e.error("Type "+Gt(l)+" is not interpolatable.")},rr.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;if(n>=e[i-1])return r[i-1].evaluate(t);var a=Oe(e,n),o=rr.interpolationFactor(this.interpolation,n,e[a],e[a+1]),s=r[a].evaluate(t),u=r[a+1].evaluate(t);return "interpolate"===this.operator?qe[this.type.kind.toLowerCase()](s,u,o):"interpolate-hcl"===this.operator?tr.reverse(tr.interpolate(tr.forward(s),tr.forward(u),o)):Qe.reverse(Qe.interpolate(Qe.forward(s),Qe.forward(u),o))},rr.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1)t(r[e]);},rr.prototype.outputDefined=function(){return this.outputs.every((function(t){return t.outputDefined()}))},rr.prototype.serialize=function(){var t;t="linear"===this.interpolation.name?["linear"]:"exponential"===this.interpolation.name?1===this.interpolation.base?["linear"]:["exponential",this.interpolation.base]:["cubic-bezier"].concat(this.interpolation.controlPoints);for(var e=[this.operator,t,this.input.serialize()],r=0;r<this.labels.length;r++)e.push(this.labels[r],this.outputs[r].serialize());return e};var ir=function(t,e){this.type=t,this.args=e;};ir.parse=function(t,e){if(t.length<2)return e.error("Expectected at least one argument.");var r=null,n=e.expectedType;n&&"value"!==n.kind&&(r=n);for(var i=[],a=0,o=t.slice(1);a<o.length;a+=1){var s=e.parse(o[a],1+i.length,r,void 0,{typeAnnotation:"omit"});if(!s)return null;r=r||s.type,i.push(s);}var u=n&&i.some((function(t){return Xt(n,t.type)}));return new ir(u?Ut:r,i)},ir.prototype.evaluate=function(t){for(var e,r=null,n=0,i=0,a=this.args;i<a.length&&(n++,(r=a[i].evaluate(t))&&r instanceof ee&&!r.available&&(e||(e=r.name),r=null,n===this.args.length&&(r=e)),null===r);i+=1);return r},ir.prototype.eachChild=function(t){this.args.forEach(t);},ir.prototype.outputDefined=function(){return this.args.every((function(t){return t.outputDefined()}))},ir.prototype.serialize=function(){var t=["coalesce"];return this.eachChild((function(e){t.push(e.serialize());})),t};var ar=function(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e;};ar.prototype.evaluate=function(t){return this.result.evaluate(t)},ar.prototype.eachChild=function(t){for(var e=0,r=this.bindings;e<r.length;e+=1)t(r[e][1]);t(this.result);},ar.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found "+(t.length-1)+" instead.");for(var r=[],n=1;n<t.length-1;n+=2){var i=t[n];if("string"!=typeof i)return e.error("Expected string, but found "+typeof i+" instead.",n);if(/[^a-zA-Z0-9_]/.test(i))return e.error("Variable names must contain only alphanumeric characters or '_'.",n);var a=e.parse(t[n+1],n+1);if(!a)return null;r.push([i,a]);}var o=e.parse(t[t.length-1],t.length-1,e.expectedType,r);return o?new ar(r,o):null},ar.prototype.outputDefined=function(){return this.result.outputDefined()},ar.prototype.serialize=function(){for(var t=["let"],e=0,r=this.bindings;e<r.length;e+=1){var n=r[e];t.push(n[0],n[1].serialize());}return t.push(this.result.serialize()),t};var or=function(t,e,r){this.type=t,this.index=e,this.input=r;};or.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,Ft),n=e.parse(t[2],2,Kt(e.expectedType||Ut));return r&&n?new or(n.type.itemType,r,n):null},or.prototype.evaluate=function(t){var e=this.index.evaluate(t),r=this.input.evaluate(t);if(e<0)throw new se("Array index out of bounds: "+e+" < 0.");if(e>=r.length)throw new se("Array index out of bounds: "+e+" > "+(r.length-1)+".");if(e!==Math.floor(e))throw new se("Array index must be an integer, but found "+e+" instead.");return r[e]},or.prototype.eachChild=function(t){t(this.index),t(this.input);},or.prototype.outputDefined=function(){return !1},or.prototype.serialize=function(){return ["at",this.index.serialize(),this.input.serialize()]};var sr=function(t,e){this.type=Lt,this.needle=t,this.haystack=e;};sr.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,Ut),n=e.parse(t[2],2,Ut);return r&&n?Jt(r.type,[Lt,Dt,Ft,Vt,Ut])?new sr(r,n):e.error("Expected first argument to be of type boolean, string, number or null, but found "+Gt(r.type)+" instead"):null},sr.prototype.evaluate=function(t){var e=this.needle.evaluate(t),r=this.haystack.evaluate(t);if(!r)return !1;if(!Ht(e,["boolean","string","number","null"]))throw new se("Expected first argument to be of type boolean, string, number or null, but found "+Gt(ie(e))+" instead.");if(!Ht(r,["string","array"]))throw new se("Expected second argument to be of type array or string, but found "+Gt(ie(r))+" instead.");return r.indexOf(e)>=0},sr.prototype.eachChild=function(t){t(this.needle),t(this.haystack);},sr.prototype.outputDefined=function(){return !0},sr.prototype.serialize=function(){return ["in",this.needle.serialize(),this.haystack.serialize()]};var ur=function(t,e,r){this.type=Ft,this.needle=t,this.haystack=e,this.fromIndex=r;};ur.parse=function(t,e){if(t.length<=2||t.length>=5)return e.error("Expected 3 or 4 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,Ut),n=e.parse(t[2],2,Ut);if(!r||!n)return null;if(!Jt(r.type,[Lt,Dt,Ft,Vt,Ut]))return e.error("Expected first argument to be of type boolean, string, number or null, but found "+Gt(r.type)+" instead");if(4===t.length){var i=e.parse(t[3],3,Ft);return i?new ur(r,n,i):null}return new ur(r,n)},ur.prototype.evaluate=function(t){var e=this.needle.evaluate(t),r=this.haystack.evaluate(t);if(!Ht(e,["boolean","string","number","null"]))throw new se("Expected first argument to be of type boolean, string, number or null, but found "+Gt(ie(e))+" instead.");if(!Ht(r,["string","array"]))throw new se("Expected second argument to be of type array or string, but found "+Gt(ie(r))+" instead.");if(this.fromIndex){var n=this.fromIndex.evaluate(t);return r.indexOf(e,n)}return r.indexOf(e)},ur.prototype.eachChild=function(t){t(this.needle),t(this.haystack),this.fromIndex&&t(this.fromIndex);},ur.prototype.outputDefined=function(){return !1},ur.prototype.serialize=function(){if(null!=this.fromIndex&&void 0!==this.fromIndex){var t=this.fromIndex.serialize();return ["index-of",this.needle.serialize(),this.haystack.serialize(),t]}return ["index-of",this.needle.serialize(),this.haystack.serialize()]};var lr=function(t,e,r,n,i,a){this.inputType=t,this.type=e,this.input=r,this.cases=n,this.outputs=i,this.otherwise=a;};lr.parse=function(t,e){if(t.length<5)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if(t.length%2!=1)return e.error("Expected an even number of arguments.");var r,n;e.expectedType&&"value"!==e.expectedType.kind&&(n=e.expectedType);for(var i={},a=[],o=2;o<t.length-1;o+=2){var s=t[o],u=t[o+1];Array.isArray(s)||(s=[s]);var l=e.concat(o);if(0===s.length)return l.error("Expected at least one branch label.");for(var p=0,c=s;p<c.length;p+=1){var h=c[p];if("number"!=typeof h&&"string"!=typeof h)return l.error("Branch labels must be numbers or strings.");if("number"==typeof h&&Math.abs(h)>Number.MAX_SAFE_INTEGER)return l.error("Branch labels must be integers no larger than "+Number.MAX_SAFE_INTEGER+".");if("number"==typeof h&&Math.floor(h)!==h)return l.error("Numeric branch labels must be integer values.");if(r){if(l.checkSubtype(r,ie(h)))return null}else r=ie(h);if(void 0!==i[String(h)])return l.error("Branch labels must be unique.");i[String(h)]=a.length;}var f=e.parse(u,o,n);if(!f)return null;n=n||f.type,a.push(f);}var y=e.parse(t[1],1,Ut);if(!y)return null;var d=e.parse(t[t.length-1],t.length-1,n);return d?"value"!==y.type.kind&&e.concat(1).checkSubtype(r,y.type)?null:new lr(r,n,y,i,a,d):null},lr.prototype.evaluate=function(t){var e=this.input.evaluate(t);return (ie(e)===this.inputType&&this.outputs[this.cases[e]]||this.otherwise).evaluate(t)},lr.prototype.eachChild=function(t){t(this.input),this.outputs.forEach(t),t(this.otherwise);},lr.prototype.outputDefined=function(){return this.outputs.every((function(t){return t.outputDefined()}))&&this.otherwise.outputDefined()},lr.prototype.serialize=function(){for(var t=this,e=["match",this.input.serialize()],r=[],n={},i=0,a=Object.keys(this.cases).sort();i<a.length;i+=1){var o=a[i];void 0===(c=n[this.cases[o]])?(n[this.cases[o]]=r.length,r.push([this.cases[o],[o]])):r[c][1].push(o);}for(var s=function(e){return "number"===t.inputType.kind?Number(e):e},u=0,l=r;u<l.length;u+=1){var p=l[u],c=p[0],h=p[1];e.push(1===h.length?s(h[0]):h.map(s)),e.push(this.outputs[outputIndex$1].serialize());}return e.push(this.otherwise.serialize()),e};var pr=function(t,e,r){this.type=t,this.branches=e,this.otherwise=r;};pr.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found only "+(t.length-1)+".");if(t.length%2!=0)return e.error("Expected an odd number of arguments.");var r;e.expectedType&&"value"!==e.expectedType.kind&&(r=e.expectedType);for(var n=[],i=1;i<t.length-1;i+=2){var a=e.parse(t[i],i,Lt);if(!a)return null;var o=e.parse(t[i+1],i+1,r);if(!o)return null;n.push([a,o]),r=r||o.type;}var s=e.parse(t[t.length-1],t.length-1,r);return s?new pr(r,n,s):null},pr.prototype.evaluate=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[1];if(n[0].evaluate(t))return i.evaluate(t)}return this.otherwise.evaluate(t)},pr.prototype.eachChild=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[1];t(n[0]),t(i);}t(this.otherwise);},pr.prototype.outputDefined=function(){return this.branches.every((function(t){return t[1].outputDefined()}))&&this.otherwise.outputDefined()},pr.prototype.serialize=function(){var t=["case"];return this.eachChild((function(e){t.push(e.serialize());})),t};var cr=function(t,e,r,n){this.type=t,this.input=e,this.beginIndex=r,this.endIndex=n;};function hr(t,e){return "=="===t||"!="===t?"boolean"===e.kind||"string"===e.kind||"number"===e.kind||"null"===e.kind||"value"===e.kind:"string"===e.kind||"number"===e.kind||"value"===e.kind}function fr(t,e,r,n){return 0===n.compare(e,r)}function yr(t,e,r){var n="=="!==t&&"!="!==t;return function(){function i(t,e,r){this.type=Lt,this.lhs=t,this.rhs=e,this.collator=r,this.hasUntypedArgument="value"===t.type.kind||"value"===e.type.kind;}return i.parse=function(t,e){if(3!==t.length&&4!==t.length)return e.error("Expected two or three arguments.");var r=t[0],a=e.parse(t[1],1,Ut);if(!a)return null;if(!hr(r,a.type))return e.concat(1).error('"'+r+"\" comparisons are not supported for type '"+Gt(a.type)+"'.");var o=e.parse(t[2],2,Ut);if(!o)return null;if(!hr(r,o.type))return e.concat(2).error('"'+r+"\" comparisons are not supported for type '"+Gt(o.type)+"'.");if(a.type.kind!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot compare types '"+Gt(a.type)+"' and '"+Gt(o.type)+"'.");n&&("value"===a.type.kind&&"value"!==o.type.kind?a=new le(o.type,[a]):"value"!==a.type.kind&&"value"===o.type.kind&&(o=new le(a.type,[o])));var s=null;if(4===t.length){if("string"!==a.type.kind&&"string"!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot use collator to compare non-string types.");if(!(s=e.parse(t[3],3,jt)))return null}return new i(a,o,s)},i.prototype.evaluate=function(i){var a=this.lhs.evaluate(i),o=this.rhs.evaluate(i);if(n&&this.hasUntypedArgument){var s=ie(a),u=ie(o);if(s.kind!==u.kind||"string"!==s.kind&&"number"!==s.kind)throw new se('Expected arguments for "'+t+'" to be (string, string) or (number, number), but found ('+s.kind+", "+u.kind+") instead.")}if(this.collator&&!n&&this.hasUntypedArgument){var l=ie(a),p=ie(o);if("string"!==l.kind||"string"!==p.kind)return e(i,a,o)}return this.collator?r(i,a,o,this.collator.evaluate(i)):e(i,a,o)},i.prototype.eachChild=function(t){t(this.lhs),t(this.rhs),this.collator&&t(this.collator);},i.prototype.outputDefined=function(){return !0},i.prototype.serialize=function(){var e=[t];return this.eachChild((function(t){e.push(t.serialize());})),e},i}()}cr.parse=function(t,e){if(t.length<=2||t.length>=5)return e.error("Expected 3 or 4 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,Ut),n=e.parse(t[2],2,Ft);if(!r||!n)return null;if(!Jt(r.type,[Kt(Ut),Dt,Ut]))return e.error("Expected first argument to be of type array or string, but found "+Gt(r.type)+" instead");if(4===t.length){var i=e.parse(t[3],3,Ft);return i?new cr(r.type,r,n,i):null}return new cr(r.type,r,n)},cr.prototype.evaluate=function(t){var e=this.input.evaluate(t),r=this.beginIndex.evaluate(t);if(!Ht(e,["string","array"]))throw new se("Expected first argument to be of type array or string, but found "+Gt(ie(e))+" instead.");if(this.endIndex){var n=this.endIndex.evaluate(t);return e.slice(r,n)}return e.slice(r)},cr.prototype.eachChild=function(t){t(this.input),t(this.beginIndex),this.endIndex&&t(this.endIndex);},cr.prototype.outputDefined=function(){return !1},cr.prototype.serialize=function(){if(null!=this.endIndex&&void 0!==this.endIndex){var t=this.endIndex.serialize();return ["slice",this.input.serialize(),this.beginIndex.serialize(),t]}return ["slice",this.input.serialize(),this.beginIndex.serialize()]};var dr=yr("==",(function(t,e,r){return e===r}),fr),mr=yr("!=",(function(t,e,r){return e!==r}),(function(t,e,r,n){return !fr(0,e,r,n)})),vr=yr("<",(function(t,e,r){return e<r}),(function(t,e,r,n){return n.compare(e,r)<0})),gr=yr(">",(function(t,e,r){return e>r}),(function(t,e,r,n){return n.compare(e,r)>0})),xr=yr("<=",(function(t,e,r){return e<=r}),(function(t,e,r,n){return n.compare(e,r)<=0})),br=yr(">=",(function(t,e,r){return e>=r}),(function(t,e,r,n){return n.compare(e,r)>=0})),wr=function(t,e,r,n,i){this.type=Dt,this.number=t,this.locale=e,this.currency=r,this.minFractionDigits=n,this.maxFractionDigits=i;};wr.parse=function(t,e){if(3!==t.length)return e.error("Expected two arguments.");var r=e.parse(t[1],1,Ft);if(!r)return null;var n=t[2];if("object"!=typeof n||Array.isArray(n))return e.error("NumberFormat options argument must be an object.");var i=null;if(n.locale&&!(i=e.parse(n.locale,1,Dt)))return null;var a=null;if(n.currency&&!(a=e.parse(n.currency,1,Dt)))return null;var o=null;if(n["min-fraction-digits"]&&!(o=e.parse(n["min-fraction-digits"],1,Ft)))return null;var s=null;return n["max-fraction-digits"]&&!(s=e.parse(n["max-fraction-digits"],1,Ft))?null:new wr(r,i,a,o,s)},wr.prototype.evaluate=function(t){return new Intl.NumberFormat(this.locale?this.locale.evaluate(t):[],{style:this.currency?"currency":"decimal",currency:this.currency?this.currency.evaluate(t):void 0,minimumFractionDigits:this.minFractionDigits?this.minFractionDigits.evaluate(t):void 0,maximumFractionDigits:this.maxFractionDigits?this.maxFractionDigits.evaluate(t):void 0}).format(this.number.evaluate(t))},wr.prototype.eachChild=function(t){t(this.number),this.locale&&t(this.locale),this.currency&&t(this.currency),this.minFractionDigits&&t(this.minFractionDigits),this.maxFractionDigits&&t(this.maxFractionDigits);},wr.prototype.outputDefined=function(){return !1},wr.prototype.serialize=function(){var t={};return this.locale&&(t.locale=this.locale.serialize()),this.currency&&(t.currency=this.currency.serialize()),this.minFractionDigits&&(t["min-fraction-digits"]=this.minFractionDigits.serialize()),this.maxFractionDigits&&(t["max-fraction-digits"]=this.maxFractionDigits.serialize()),["number-format",this.number.serialize(),t]};var _r=function(t){this.type=Ft,this.input=t;};_r.parse=function(t,e){if(2!==t.length)return e.error("Expected 1 argument, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1);return r?"array"!==r.type.kind&&"string"!==r.type.kind&&"value"!==r.type.kind?e.error("Expected argument of type string or array, but found "+Gt(r.type)+" instead."):new _r(r):null},_r.prototype.evaluate=function(t){var e=this.input.evaluate(t);if("string"==typeof e)return e.length;if(Array.isArray(e))return e.length;throw new se("Expected value to be of type string or array, but found "+Gt(ie(e))+" instead.")},_r.prototype.eachChild=function(t){t(this.input);},_r.prototype.outputDefined=function(){return !1},_r.prototype.serialize=function(){var t=["length"];return this.eachChild((function(e){t.push(e.serialize());})),t};var Ar={"==":dr,"!=":mr,">":gr,"<":vr,">=":br,"<=":xr,array:le,at:or,boolean:le,case:pr,coalesce:ir,collator:ve,format:pe,image:ce,in:sr,"index-of":ur,interpolate:rr,"interpolate-hcl":rr,"interpolate-lab":rr,length:_r,let:ar,literal:oe,match:lr,number:le,"number-format":wr,object:le,slice:cr,step:Ue,string:le,"to-boolean":fe,"to-color":fe,"to-number":fe,"to-string":fe,var:Le,within:Be};function Sr(t,e){var r=e[0],n=e[1],i=e[2],a=e[3];r=r.evaluate(t),n=n.evaluate(t),i=i.evaluate(t);var o=a?a.evaluate(t):1,s=re(r,n,i,o);if(s)throw new se(s);return new $t(r/255*o,n/255*o,i/255*o,o)}function kr(t,e){return t in e}function Ir(t,e){var r=e[t];return void 0===r?null:r}function zr(t){return {type:t}}function Cr(t){return {result:"success",value:t}}function Mr(t){return {result:"error",value:t}}function Er(t){return "data-driven"===t["property-type"]||"cross-faded-data-driven"===t["property-type"]}function Tr(t){return !!t.expression&&t.expression.parameters.indexOf("zoom")>-1}function Pr(t){return !!t.expression&&t.expression.interpolated}function Br(t){return t instanceof Number?"number":t instanceof String?"string":t instanceof Boolean?"boolean":Array.isArray(t)?"array":null===t?"null":typeof t}function Vr(t){return "object"==typeof t&&null!==t&&!Array.isArray(t)}function Fr(t){return t}function Dr(t,e,r){return void 0!==t?t:void 0!==e?e:void 0!==r?r:void 0}function Lr(t,e,r,n,i){return Dr(typeof r===i?n[r]:void 0,t.default,e.default)}function Rr(t,e,r){if("number"!==Br(r))return Dr(t.default,e.default);var n=t.stops.length;if(1===n)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[n-1][0])return t.stops[n-1][1];var i=Oe(t.stops.map((function(t){return t[0]})),r);return t.stops[i][1]}function Or(t,e,r){var n=void 0!==t.base?t.base:1;if("number"!==Br(r))return Dr(t.default,e.default);var i=t.stops.length;if(1===i)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[i-1][0])return t.stops[i-1][1];var a=Oe(t.stops.map((function(t){return t[0]})),r),o=function(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}(r,n,t.stops[a][0],t.stops[a+1][0]),s=t.stops[a][1],u=t.stops[a+1][1],l=qe[e.type]||Fr;if(t.colorSpace&&"rgb"!==t.colorSpace){var p=er[t.colorSpace];l=function(t,e){return p.reverse(p.interpolate(p.forward(t),p.forward(e),o))};}return "function"==typeof s.evaluate?{evaluate:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];var r=s.evaluate.apply(void 0,t),n=u.evaluate.apply(void 0,t);if(void 0!==r&&void 0!==n)return l(r,n,o)}}:l(s,u,o)}function Ur(t,e,r){return "color"===e.type?r=$t.parse(r):"formatted"===e.type?r=te.fromString(r.toString()):"resolvedImage"===e.type?r=ee.fromString(r.toString()):Br(r)===e.type||"enum"===e.type&&e.values[r]||(r=void 0),Dr(r,t.default,e.default)}me.register(Ar,{error:[{kind:"error"},[Dt],function(t,e){throw new se(e[0].evaluate(t))}],typeof:[Dt,[Ut],function(t,e){return Gt(ie(e[0].evaluate(t)))}],"to-rgba":[Kt(Ft,4),[Rt],function(t,e){return e[0].evaluate(t).toArray()}],rgb:[Rt,[Ft,Ft,Ft],Sr],rgba:[Rt,[Ft,Ft,Ft,Ft],Sr],has:{type:Lt,overloads:[[[Dt],function(t,e){return kr(e[0].evaluate(t),t.properties())}],[[Dt,Ot],function(t,e){var r=e[1];return kr(e[0].evaluate(t),r.evaluate(t))}]]},get:{type:Ut,overloads:[[[Dt],function(t,e){return Ir(e[0].evaluate(t),t.properties())}],[[Dt,Ot],function(t,e){var r=e[1];return Ir(e[0].evaluate(t),r.evaluate(t))}]]},"feature-state":[Ut,[Dt],function(t,e){return Ir(e[0].evaluate(t),t.featureState||{})}],properties:[Ot,[],function(t){return t.properties()}],"geometry-type":[Dt,[],function(t){return t.geometryType()}],id:[Ut,[],function(t){return t.id()}],zoom:[Ft,[],function(t){return t.globals.zoom}],"heatmap-density":[Ft,[],function(t){return t.globals.heatmapDensity||0}],"line-progress":[Ft,[],function(t){return t.globals.lineProgress||0}],accumulated:[Ut,[],function(t){return void 0===t.globals.accumulated?null:t.globals.accumulated}],"+":[Ft,zr(Ft),function(t,e){for(var r=0,n=0,i=e;n<i.length;n+=1)r+=i[n].evaluate(t);return r}],"*":[Ft,zr(Ft),function(t,e){for(var r=1,n=0,i=e;n<i.length;n+=1)r*=i[n].evaluate(t);return r}],"-":{type:Ft,overloads:[[[Ft,Ft],function(t,e){var r=e[1];return e[0].evaluate(t)-r.evaluate(t)}],[[Ft],function(t,e){return -e[0].evaluate(t)}]]},"/":[Ft,[Ft,Ft],function(t,e){var r=e[1];return e[0].evaluate(t)/r.evaluate(t)}],"%":[Ft,[Ft,Ft],function(t,e){var r=e[1];return e[0].evaluate(t)%r.evaluate(t)}],ln2:[Ft,[],function(){return Math.LN2}],pi:[Ft,[],function(){return Math.PI}],e:[Ft,[],function(){return Math.E}],"^":[Ft,[Ft,Ft],function(t,e){var r=e[1];return Math.pow(e[0].evaluate(t),r.evaluate(t))}],sqrt:[Ft,[Ft],function(t,e){return Math.sqrt(e[0].evaluate(t))}],log10:[Ft,[Ft],function(t,e){return Math.log(e[0].evaluate(t))/Math.LN10}],ln:[Ft,[Ft],function(t,e){return Math.log(e[0].evaluate(t))}],log2:[Ft,[Ft],function(t,e){return Math.log(e[0].evaluate(t))/Math.LN2}],sin:[Ft,[Ft],function(t,e){return Math.sin(e[0].evaluate(t))}],cos:[Ft,[Ft],function(t,e){return Math.cos(e[0].evaluate(t))}],tan:[Ft,[Ft],function(t,e){return Math.tan(e[0].evaluate(t))}],asin:[Ft,[Ft],function(t,e){return Math.asin(e[0].evaluate(t))}],acos:[Ft,[Ft],function(t,e){return Math.acos(e[0].evaluate(t))}],atan:[Ft,[Ft],function(t,e){return Math.atan(e[0].evaluate(t))}],min:[Ft,zr(Ft),function(t,e){return Math.min.apply(Math,e.map((function(e){return e.evaluate(t)})))}],max:[Ft,zr(Ft),function(t,e){return Math.max.apply(Math,e.map((function(e){return e.evaluate(t)})))}],abs:[Ft,[Ft],function(t,e){return Math.abs(e[0].evaluate(t))}],round:[Ft,[Ft],function(t,e){var r=e[0].evaluate(t);return r<0?-Math.round(-r):Math.round(r)}],floor:[Ft,[Ft],function(t,e){return Math.floor(e[0].evaluate(t))}],ceil:[Ft,[Ft],function(t,e){return Math.ceil(e[0].evaluate(t))}],"filter-==":[Lt,[Dt,Ut],function(t,e){var r=e[0],n=e[1];return t.properties()[r.value]===n.value}],"filter-id-==":[Lt,[Ut],function(t,e){var r=e[0];return t.id()===r.value}],"filter-type-==":[Lt,[Dt],function(t,e){var r=e[0];return t.geometryType()===r.value}],"filter-<":[Lt,[Dt,Ut],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<a}],"filter-id-<":[Lt,[Ut],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<i}],"filter->":[Lt,[Dt,Ut],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>a}],"filter-id->":[Lt,[Ut],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>i}],"filter-<=":[Lt,[Dt,Ut],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<=a}],"filter-id-<=":[Lt,[Ut],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<=i}],"filter->=":[Lt,[Dt,Ut],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>=a}],"filter-id->=":[Lt,[Ut],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>=i}],"filter-has":[Lt,[Ut],function(t,e){return e[0].value in t.properties()}],"filter-has-id":[Lt,[],function(t){return null!==t.id()&&void 0!==t.id()}],"filter-type-in":[Lt,[Kt(Dt)],function(t,e){return e[0].value.indexOf(t.geometryType())>=0}],"filter-id-in":[Lt,[Kt(Ut)],function(t,e){return e[0].value.indexOf(t.id())>=0}],"filter-in-small":[Lt,[Dt,Kt(Ut)],function(t,e){var r=e[0];return e[1].value.indexOf(t.properties()[r.value])>=0}],"filter-in-large":[Lt,[Dt,Kt(Ut)],function(t,e){var r=e[0],n=e[1];return function(t,e,r,n){for(;r<=n;){var i=r+n>>1;if(e[i]===t)return !0;e[i]>t?n=i-1:r=i+1;}return !1}(t.properties()[r.value],n.value,0,n.value.length-1)}],all:{type:Lt,overloads:[[[Lt,Lt],function(t,e){var r=e[1];return e[0].evaluate(t)&&r.evaluate(t)}],[zr(Lt),function(t,e){for(var r=0,n=e;r<n.length;r+=1)if(!n[r].evaluate(t))return !1;return !0}]]},any:{type:Lt,overloads:[[[Lt,Lt],function(t,e){var r=e[1];return e[0].evaluate(t)||r.evaluate(t)}],[zr(Lt),function(t,e){for(var r=0,n=e;r<n.length;r+=1)if(n[r].evaluate(t))return !0;return !1}]]},"!":[Lt,[Lt],function(t,e){return !e[0].evaluate(t)}],"is-supported-script":[Lt,[Dt],function(t,e){var r=t.globals&&t.globals.isSupportedScript;return !r||r(e[0].evaluate(t))}],upcase:[Dt,[Dt],function(t,e){return e[0].evaluate(t).toUpperCase()}],downcase:[Dt,[Dt],function(t,e){return e[0].evaluate(t).toLowerCase()}],concat:[Dt,zr(Ut),function(t,e){return e.map((function(e){return ae(e.evaluate(t))})).join("")}],"resolved-locale":[Dt,[jt],function(t,e){return e[0].evaluate(t).resolvedLocale()}]});var jr=function(t,e){this.expression=t,this._warningHistory={},this._evaluator=new de,this._defaultValue=e?function(t){return "color"===t.type&&Vr(t.default)?new $t(0,0,0,0):"color"===t.type?$t.parse(t.default)||null:void 0===t.default?null:t.default}(e):null,this._enumValues=e&&"enum"===e.type?e.values:null;};function qr(t){return Array.isArray(t)&&t.length>0&&"string"==typeof t[0]&&t[0]in Ar}function Nr(t,e){var r=new Re(Ar,[],e?function(t){var e={color:Rt,string:Dt,number:Ft,enum:Dt,boolean:Lt,formatted:qt,resolvedImage:Nt};return "array"===t.type?Kt(e[t.value]||Ut,t.length):e[t.type]}(e):void 0),n=r.parse(t,void 0,void 0,void 0,e&&"string"===e.type?{typeAnnotation:"coerce"}:void 0);return n?Cr(new jr(n,e)):Mr(r.errors)}jr.prototype.evaluateWithoutErrorHandling=function(t,e,r,n,i,a){return this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=r,this._evaluator.canonical=n,this._evaluator.availableImages=i||null,this._evaluator.formattedSection=a,this.expression.evaluate(this._evaluator)},jr.prototype.evaluate=function(t,e,r,n,i,a){this._evaluator.globals=t,this._evaluator.feature=e||null,this._evaluator.featureState=r||null,this._evaluator.canonical=n,this._evaluator.availableImages=i||null,this._evaluator.formattedSection=a||null;try{var o=this.expression.evaluate(this._evaluator);if(null==o||"number"==typeof o&&o!=o)return this._defaultValue;if(this._enumValues&&!(o in this._enumValues))throw new se("Expected value to be one of "+Object.keys(this._enumValues).map((function(t){return JSON.stringify(t)})).join(", ")+", but found "+JSON.stringify(o)+" instead.");return o}catch(t){return this._warningHistory[t.message]||(this._warningHistory[t.message]=!0,"undefined"!=typeof console&&console.warn(t.message)),this._defaultValue}};var Kr=function(t,e){this.kind=t,this._styleExpression=e,this.isStateDependent="constant"!==t&&!Fe(e.expression);};Kr.prototype.evaluateWithoutErrorHandling=function(t,e,r,n,i,a){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i,a)},Kr.prototype.evaluate=function(t,e,r,n,i,a){return this._styleExpression.evaluate(t,e,r,n,i,a)};var Gr=function(t,e,r,n){this.kind=t,this.zoomStops=r,this._styleExpression=e,this.isStateDependent="camera"!==t&&!Fe(e.expression),this.interpolationType=n;};function Zr(t,e){if("error"===(t=Nr(t,e)).result)return t;var r=t.value.expression,n=Ve(r);if(!n&&!Er(e))return Mr([new Pt("","data expressions not supported")]);var i=De(r,["zoom"]);if(!i&&!Tr(e))return Mr([new Pt("","zoom expressions not supported")]);var a=function t(e){var r=null;if(e instanceof ar)r=t(e.result);else if(e instanceof ir)for(var n=0,i=e.args;n<i.length&&!(r=t(i[n]));n+=1);else (e instanceof Ue||e instanceof rr)&&e.input instanceof me&&"zoom"===e.input.name&&(r=e);return r instanceof Pt||e.eachChild((function(e){var n=t(e);n instanceof Pt?r=n:!r&&n?r=new Pt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):r&&n&&r!==n&&(r=new Pt("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));})),r}(r);return a||i?a instanceof Pt?Mr([a]):a instanceof rr&&!Pr(e)?Mr([new Pt("",'"interpolate" expressions cannot be used with this property')]):Cr(a?new Gr(n?"camera":"composite",t.value,a.labels,a instanceof rr?a.interpolation:void 0):new Kr(n?"constant":"source",t.value)):Mr([new Pt("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')])}Gr.prototype.evaluateWithoutErrorHandling=function(t,e,r,n,i,a){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i,a)},Gr.prototype.evaluate=function(t,e,r,n,i,a){return this._styleExpression.evaluate(t,e,r,n,i,a)},Gr.prototype.interpolationFactor=function(t,e,r){return this.interpolationType?rr.interpolationFactor(this.interpolationType,t,e,r):0};var Xr=function(t,e){this._parameters=t,this._specification=e,Mt(this,function t(e,r){var n,i,a,o="color"===r.type,s=e.stops&&"object"==typeof e.stops[0][0],u=s||!(s||void 0!==e.property),l=e.type||(Pr(r)?"exponential":"interval");if(o&&((e=Mt({},e)).stops&&(e.stops=e.stops.map((function(t){return [t[0],$t.parse(t[1])]}))),e.default=$t.parse(e.default?e.default:r.default)),e.colorSpace&&"rgb"!==e.colorSpace&&!er[e.colorSpace])throw new Error("Unknown color space: "+e.colorSpace);if("exponential"===l)n=Or;else if("interval"===l)n=Rr;else if("categorical"===l){n=Lr,i=Object.create(null);for(var p=0,c=e.stops;p<c.length;p+=1){var h=c[p];i[h[0]]=h[1];}a=typeof e.stops[0][0];}else {if("identity"!==l)throw new Error('Unknown function type "'+l+'"');n=Ur;}if(s){for(var f={},y=[],d=0;d<e.stops.length;d++){var m=e.stops[d],v=m[0].zoom;void 0===f[v]&&(f[v]={zoom:v,type:e.type,property:e.property,default:e.default,stops:[]},y.push(v)),f[v].stops.push([m[0].value,m[1]]);}for(var g=[],x=0,b=y;x<b.length;x+=1){var w=b[x];g.push([f[w].zoom,t(f[w],r)]);}var _={name:"linear"};return {kind:"composite",interpolationType:_,interpolationFactor:rr.interpolationFactor.bind(void 0,_),zoomStops:g.map((function(t){return t[0]})),evaluate:function(t,n){var i=t.zoom;return Or({stops:g,base:e.base},r,i).evaluate(i,n)}}}if(u){var A="exponential"===l?{name:"exponential",base:void 0!==e.base?e.base:1}:null;return {kind:"camera",interpolationType:A,interpolationFactor:rr.interpolationFactor.bind(void 0,A),zoomStops:e.stops.map((function(t){return t[0]})),evaluate:function(t){return n(e,r,t.zoom,i,a)}}}return {kind:"source",evaluate:function(t,o){var s=o&&o.properties?o.properties[e.property]:void 0;return void 0===s?Dr(e.default,r.default):n(e,r,s,i,a)}}}(this._parameters,this._specification));};function Jr(t){var e=t.key,r=t.value,n=t.valueSpec||{},i=t.objectElementValidators||{},a=t.style,o=t.styleSpec,s=[],u=Br(r);if("object"!==u)return [new zt(e,r,"object expected, "+u+" found")];for(var l in r){var p=l.split(".")[0],c=n[p]||n["*"],h=void 0;if(i[p])h=i[p];else if(n[p])h=bn;else if(i["*"])h=i["*"];else {if(!n["*"]){s.push(new zt(e,r[l],'unknown property "'+l+'"'));continue}h=bn;}s=s.concat(h({key:(e?e+".":e)+l,value:r[l],valueSpec:c,style:a,styleSpec:o,object:r,objectKey:l},r));}for(var f in n)i[f]||n[f].required&&void 0===n[f].default&&void 0===r[f]&&s.push(new zt(e,r,'missing required property "'+f+'"'));return s}function Hr(t){var e=t.value,r=t.valueSpec,n=t.style,i=t.styleSpec,a=t.key,o=t.arrayElementValidator||bn;if("array"!==Br(e))return [new zt(a,e,"array expected, "+Br(e)+" found")];if(r.length&&e.length!==r.length)return [new zt(a,e,"array length "+r.length+" expected, length "+e.length+" found")];if(r["min-length"]&&e.length<r["min-length"])return [new zt(a,e,"array length at least "+r["min-length"]+" expected, length "+e.length+" found")];var s={type:r.value,values:r.values};i.$version<7&&(s.function=r.function),"object"===Br(r.value)&&(s=r.value);for(var u=[],l=0;l<e.length;l++)u=u.concat(o({array:e,arrayIndex:l,value:e[l],valueSpec:s,style:n,styleSpec:i,key:a+"["+l+"]"}));return u}function Yr(t){var e=t.key,r=t.value,n=t.valueSpec,i=Br(r);return "number"===i&&r!=r&&(i="NaN"),"number"!==i?[new zt(e,r,"number expected, "+i+" found")]:"minimum"in n&&r<n.minimum?[new zt(e,r,r+" is less than the minimum value "+n.minimum)]:"maximum"in n&&r>n.maximum?[new zt(e,r,r+" is greater than the maximum value "+n.maximum)]:[]}function $r(t){var e,r,n,i=t.valueSpec,a=Et(t.value.type),o={},s="categorical"!==a&&void 0===t.value.property,u=!s,l="array"===Br(t.value.stops)&&"array"===Br(t.value.stops[0])&&"object"===Br(t.value.stops[0][0]),p=Jr({key:t.key,value:t.value,valueSpec:t.styleSpec.function,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{stops:function(t){if("identity"===a)return [new zt(t.key,t.value,'identity function may not have a "stops" property')];var e=[],r=t.value;return e=e.concat(Hr({key:t.key,value:r,valueSpec:t.valueSpec,style:t.style,styleSpec:t.styleSpec,arrayElementValidator:c})),"array"===Br(r)&&0===r.length&&e.push(new zt(t.key,r,"array must have at least one stop")),e},default:function(t){return bn({key:t.key,value:t.value,valueSpec:i,style:t.style,styleSpec:t.styleSpec})}}});return "identity"===a&&s&&p.push(new zt(t.key,t.value,'missing required property "property"')),"identity"===a||t.value.stops||p.push(new zt(t.key,t.value,'missing required property "stops"')),"exponential"===a&&t.valueSpec.expression&&!Pr(t.valueSpec)&&p.push(new zt(t.key,t.value,"exponential functions not supported")),t.styleSpec.$version>=8&&(u&&!Er(t.valueSpec)?p.push(new zt(t.key,t.value,"property functions not supported")):s&&!Tr(t.valueSpec)&&p.push(new zt(t.key,t.value,"zoom functions not supported"))),"categorical"!==a&&!l||void 0!==t.value.property||p.push(new zt(t.key,t.value,'"property" property is required')),p;function c(t){var e=[],a=t.value,s=t.key;if("array"!==Br(a))return [new zt(s,a,"array expected, "+Br(a)+" found")];if(2!==a.length)return [new zt(s,a,"array length 2 expected, length "+a.length+" found")];if(l){if("object"!==Br(a[0]))return [new zt(s,a,"object expected, "+Br(a[0])+" found")];if(void 0===a[0].zoom)return [new zt(s,a,"object stop key must have zoom")];if(void 0===a[0].value)return [new zt(s,a,"object stop key must have value")];if(n&&n>Et(a[0].zoom))return [new zt(s,a[0].zoom,"stop zoom values must appear in ascending order")];Et(a[0].zoom)!==n&&(n=Et(a[0].zoom),r=void 0,o={}),e=e.concat(Jr({key:s+"[0]",value:a[0],valueSpec:{zoom:{}},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{zoom:Yr,value:h}}));}else e=e.concat(h({key:s+"[0]",value:a[0],valueSpec:{},style:t.style,styleSpec:t.styleSpec},a));return qr(Tt(a[1]))?e.concat([new zt(s+"[1]",a[1],"expressions are not allowed in function stops.")]):e.concat(bn({key:s+"[1]",value:a[1],valueSpec:i,style:t.style,styleSpec:t.styleSpec}))}function h(t,n){var s=Br(t.value),u=Et(t.value),l=null!==t.value?t.value:n;if(e){if(s!==e)return [new zt(t.key,l,s+" stop domain type must match previous stop domain type "+e)]}else e=s;if("number"!==s&&"string"!==s&&"boolean"!==s)return [new zt(t.key,l,"stop domain value must be a number, string, or boolean")];if("number"!==s&&"categorical"!==a){var p="number expected, "+s+" found";return Er(i)&&void 0===a&&(p+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new zt(t.key,l,p)]}return "categorical"!==a||"number"!==s||isFinite(u)&&Math.floor(u)===u?"categorical"!==a&&"number"===s&&void 0!==r&&u<r?[new zt(t.key,l,"stop domain values must appear in ascending order")]:(r=u,"categorical"===a&&u in o?[new zt(t.key,l,"stop domain values must be unique")]:(o[u]=!0,[])):[new zt(t.key,l,"integer expected, found "+u)]}}function Wr(t){var e=("property"===t.expressionContext?Zr:Nr)(Tt(t.value),t.valueSpec);if("error"===e.result)return e.value.map((function(e){return new zt(""+t.key+e.key,t.value,e.message)}));var r=e.value.expression||e.value._styleExpression.expression;if("property"===t.expressionContext&&"text-font"===t.propertyKey&&!r.outputDefined())return [new zt(t.key,t.value,'Invalid data expression for "'+t.propertyKey+'". Output values must be contained as literals within the expression.')];if("property"===t.expressionContext&&"layout"===t.propertyType&&!Fe(r))return [new zt(t.key,t.value,'"feature-state" data expressions are not supported with layout properties.')];if("filter"===t.expressionContext&&!Fe(r))return [new zt(t.key,t.value,'"feature-state" data expressions are not supported with filters.')];if(t.expressionContext&&0===t.expressionContext.indexOf("cluster")){if(!De(r,["zoom","feature-state"]))return [new zt(t.key,t.value,'"zoom" and "feature-state" expressions are not supported with cluster properties.')];if("cluster-initial"===t.expressionContext&&!Ve(r))return [new zt(t.key,t.value,"Feature data expressions are not supported with initial expression part of cluster properties.")]}return []}function Qr(t){var e=t.key,r=t.value,n=t.valueSpec,i=[];return Array.isArray(n.values)?-1===n.values.indexOf(Et(r))&&i.push(new zt(e,r,"expected one of ["+n.values.join(", ")+"], "+JSON.stringify(r)+" found")):-1===Object.keys(n.values).indexOf(Et(r))&&i.push(new zt(e,r,"expected one of ["+Object.keys(n.values).join(", ")+"], "+JSON.stringify(r)+" found")),i}function tn(t){if(!0===t||!1===t)return !0;if(!Array.isArray(t)||0===t.length)return !1;switch(t[0]){case"has":return t.length>=2&&"$id"!==t[1]&&"$type"!==t[1];case"in":return t.length>=3&&("string"!=typeof t[1]||Array.isArray(t[2]));case"!in":case"!has":case"none":return !1;case"==":case"!=":case">":case">=":case"<":case"<=":return 3!==t.length||Array.isArray(t[1])||Array.isArray(t[2]);case"any":case"all":for(var e=0,r=t.slice(1);e<r.length;e+=1){var n=r[e];if(!tn(n)&&"boolean"!=typeof n)return !1}return !0;default:return !0}}Xr.deserialize=function(t){return new Xr(t._parameters,t._specification)},Xr.serialize=function(t){return {_parameters:t._parameters,_specification:t._specification}};var en={type:"boolean",default:!1,transition:!1,"property-type":"data-driven",expression:{interpolated:!1,parameters:["zoom","feature"]}};function rn(t){if(null==t)return {filter:function(){return !0},needGeometry:!1};tn(t)||(t=an(t));var e=Nr(t,en);if("error"===e.result)throw new Error(e.value.map((function(t){return t.key+": "+t.message})).join(", "));return {filter:function(t,r,n){return e.value.evaluate(t,r,{},n)},needGeometry:function t(e){if(!Array.isArray(e))return !1;if("within"===e[0])return !0;for(var r=1;r<e.length;r++)if(t(e[r]))return !0;return !1}(t)}}function nn(t,e){return t<e?-1:t>e?1:0}function an(t){if(!t)return !0;var e,r=t[0];return t.length<=1?"any"!==r:"=="===r?on(t[1],t[2],"=="):"!="===r?ln(on(t[1],t[2],"==")):"<"===r||">"===r||"<="===r||">="===r?on(t[1],t[2],r):"any"===r?(e=t.slice(1),["any"].concat(e.map(an))):"all"===r?["all"].concat(t.slice(1).map(an)):"none"===r?["all"].concat(t.slice(1).map(an).map(ln)):"in"===r?sn(t[1],t.slice(2)):"!in"===r?ln(sn(t[1],t.slice(2))):"has"===r?un(t[1]):"!has"===r?ln(un(t[1])):"within"!==r||t}function on(t,e,r){switch(t){case"$type":return ["filter-type-"+r,e];case"$id":return ["filter-id-"+r,e];default:return ["filter-"+r,t,e]}}function sn(t,e){if(0===e.length)return !1;switch(t){case"$type":return ["filter-type-in",["literal",e]];case"$id":return ["filter-id-in",["literal",e]];default:return e.length>200&&!e.some((function(t){return typeof t!=typeof e[0]}))?["filter-in-large",t,["literal",e.sort(nn)]]:["filter-in-small",t,["literal",e]]}}function un(t){switch(t){case"$type":return !0;case"$id":return ["filter-has-id"];default:return ["filter-has",t]}}function ln(t){return ["!",t]}function pn(t){return tn(Tt(t.value))?Wr(Mt({},t,{expressionContext:"filter",valueSpec:{value:"boolean"}})):function t(e){var r=e.value,n=e.key;if("array"!==Br(r))return [new zt(n,r,"array expected, "+Br(r)+" found")];var i,a=e.styleSpec,o=[];if(r.length<1)return [new zt(n,r,"filter array must have at least 1 element")];switch(o=o.concat(Qr({key:n+"[0]",value:r[0],valueSpec:a.filter_operator,style:e.style,styleSpec:e.styleSpec})),Et(r[0])){case"<":case"<=":case">":case">=":r.length>=2&&"$type"===Et(r[1])&&o.push(new zt(n,r,'"$type" cannot be use with operator "'+r[0]+'"'));case"==":case"!=":3!==r.length&&o.push(new zt(n,r,'filter array for operator "'+r[0]+'" must have 3 elements'));case"in":case"!in":r.length>=2&&"string"!==(i=Br(r[1]))&&o.push(new zt(n+"[1]",r[1],"string expected, "+i+" found"));for(var s=2;s<r.length;s++)i=Br(r[s]),"$type"===Et(r[1])?o=o.concat(Qr({key:n+"["+s+"]",value:r[s],valueSpec:a.geometry_type,style:e.style,styleSpec:e.styleSpec})):"string"!==i&&"number"!==i&&"boolean"!==i&&o.push(new zt(n+"["+s+"]",r[s],"string, number, or boolean expected, "+i+" found"));break;case"any":case"all":case"none":for(var u=1;u<r.length;u++)o=o.concat(t({key:n+"["+u+"]",value:r[u],style:e.style,styleSpec:e.styleSpec}));break;case"has":case"!has":i=Br(r[1]),2!==r.length?o.push(new zt(n,r,'filter array for "'+r[0]+'" operator must have 2 elements')):"string"!==i&&o.push(new zt(n+"[1]",r[1],"string expected, "+i+" found"));break;case"within":i=Br(r[1]),2!==r.length?o.push(new zt(n,r,'filter array for "'+r[0]+'" operator must have 2 elements')):"object"!==i&&o.push(new zt(n+"[1]",r[1],"object expected, "+i+" found"));}return o}(t)}function cn(t,e){var r=t.key,n=t.style,i=t.styleSpec,a=t.value,o=t.objectKey,s=i[e+"_"+t.layerType];if(!s)return [];var u=o.match(/^(.*)-transition$/);if("paint"===e&&u&&s[u[1]]&&s[u[1]].transition)return bn({key:r,value:a,valueSpec:i.transition,style:n,styleSpec:i});var l,p=t.valueSpec||s[o];if(!p)return [new zt(r,a,'unknown property "'+o+'"')];if("string"===Br(a)&&Er(p)&&!p.tokens&&(l=/^{([^}]+)}$/.exec(a)))return [new zt(r,a,'"'+o+'" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": '+JSON.stringify(l[1])+" }`.")];var c=[];return "symbol"===t.layerType&&("text-field"===o&&n&&!n.glyphs&&c.push(new zt(r,a,'use of "text-field" requires a style "glyphs" property')),"text-font"===o&&Vr(Tt(a))&&"identity"===Et(a.type)&&c.push(new zt(r,a,'"text-font" does not support identity functions'))),c.concat(bn({key:t.key,value:a,valueSpec:p,style:n,styleSpec:i,expressionContext:"property",propertyType:e,propertyKey:o}))}function hn(t){return cn(t,"paint")}function fn(t){return cn(t,"layout")}function yn(t){var e=[],r=t.value,n=t.key,i=t.style,a=t.styleSpec;r.type||r.ref||e.push(new zt(n,r,'either "type" or "ref" is required'));var o,s=Et(r.type),u=Et(r.ref);if(r.id)for(var l=Et(r.id),p=0;p<t.arrayIndex;p++){var c=i.layers[p];Et(c.id)===l&&e.push(new zt(n,r.id,'duplicate layer id "'+r.id+'", previously used at line '+c.id.__line__));}if("ref"in r)["type","source","source-layer","filter","layout"].forEach((function(t){t in r&&e.push(new zt(n,r[t],'"'+t+'" is prohibited for ref layers'));})),i.layers.forEach((function(t){Et(t.id)===u&&(o=t);})),o?o.ref?e.push(new zt(n,r.ref,"ref cannot reference another ref layer")):s=Et(o.type):e.push(new zt(n,r.ref,'ref layer "'+u+'" not found'));else if("background"!==s)if(r.source){var h=i.sources&&i.sources[r.source],f=h&&Et(h.type);h?"vector"===f&&"raster"===s?e.push(new zt(n,r.source,'layer "'+r.id+'" requires a raster source')):"raster"===f&&"raster"!==s?e.push(new zt(n,r.source,'layer "'+r.id+'" requires a vector source')):"vector"!==f||r["source-layer"]?"raster-dem"===f&&"hillshade"!==s?e.push(new zt(n,r.source,"raster-dem source can only be used with layer type 'hillshade'.")):"line"!==s||!r.paint||!r.paint["line-gradient"]||"geojson"===f&&h.lineMetrics||e.push(new zt(n,r,'layer "'+r.id+'" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')):e.push(new zt(n,r,'layer "'+r.id+'" must specify a "source-layer"')):e.push(new zt(n,r.source,'source "'+r.source+'" not found'));}else e.push(new zt(n,r,'missing required property "source"'));return e=e.concat(Jr({key:n,value:r,valueSpec:a.layer,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(){return []},type:function(){return bn({key:n+".type",value:r.type,valueSpec:a.layer.type,style:t.style,styleSpec:t.styleSpec,object:r,objectKey:"type"})},filter:pn,layout:function(t){return Jr({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return fn(Mt({layerType:s},t))}}})},paint:function(t){return Jr({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return hn(Mt({layerType:s},t))}}})}}}))}function dn(t){var e=t.value,r=t.key,n=Br(e);return "string"!==n?[new zt(r,e,"string expected, "+n+" found")]:[]}var mn={promoteId:function(t){var e=t.key,r=t.value;if("string"===Br(r))return dn({key:e,value:r});var n=[];for(var i in r)n.push.apply(n,dn({key:e+"."+i,value:r[i]}));return n}};function vn(t){var e=t.value,r=t.key,n=t.styleSpec,i=t.style;if(!e.type)return [new zt(r,e,'"type" is required')];var a,o=Et(e.type);switch(o){case"vector":case"raster":case"raster-dem":return Jr({key:r,value:e,valueSpec:n["source_"+o.replace("-","_")],style:t.style,styleSpec:n,objectElementValidators:mn});case"geojson":if(a=Jr({key:r,value:e,valueSpec:n.source_geojson,style:i,styleSpec:n,objectElementValidators:mn}),e.cluster)for(var s in e.clusterProperties){var u=e.clusterProperties[s],l=u[0],p="string"==typeof l?[l,["accumulated"],["get",s]]:l;a.push.apply(a,Wr({key:r+"."+s+".map",value:u[1],expressionContext:"cluster-map"})),a.push.apply(a,Wr({key:r+"."+s+".reduce",value:p,expressionContext:"cluster-reduce"}));}return a;case"video":return Jr({key:r,value:e,valueSpec:n.source_video,style:i,styleSpec:n});case"image":return Jr({key:r,value:e,valueSpec:n.source_image,style:i,styleSpec:n});case"canvas":return [new zt(r,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")];default:return Qr({key:r+".type",value:e.type,valueSpec:{values:["vector","raster","raster-dem","geojson","video","image"]},style:i,styleSpec:n})}}function gn(t){var e=t.value,r=t.styleSpec,n=r.light,i=t.style,a=[],o=Br(e);if(void 0===e)return a;if("object"!==o)return a.concat([new zt("light",e,"object expected, "+o+" found")]);for(var s in e){var u=s.match(/^(.*)-transition$/);a=a.concat(u&&n[u[1]]&&n[u[1]].transition?bn({key:s,value:e[s],valueSpec:r.transition,style:i,styleSpec:r}):n[s]?bn({key:s,value:e[s],valueSpec:n[s],style:i,styleSpec:r}):[new zt(s,e[s],'unknown property "'+s+'"')]);}return a}var xn={"*":function(){return []},array:Hr,boolean:function(t){var e=t.value,r=t.key,n=Br(e);return "boolean"!==n?[new zt(r,e,"boolean expected, "+n+" found")]:[]},number:Yr,color:function(t){var e=t.key,r=t.value,n=Br(r);return "string"!==n?[new zt(e,r,"color expected, "+n+" found")]:null===Yt(r)?[new zt(e,r,'color expected, "'+r+'" found')]:[]},constants:Ct,enum:Qr,filter:pn,function:$r,layer:yn,object:Jr,source:vn,light:gn,string:dn,formatted:function(t){return 0===dn(t).length?[]:Wr(t)},resolvedImage:function(t){return 0===dn(t).length?[]:Wr(t)}};function bn(t){var e=t.value,r=t.valueSpec,n=t.styleSpec;return r.expression&&Vr(Et(e))?$r(t):r.expression&&qr(Tt(e))?Wr(t):r.type&&xn[r.type]?xn[r.type](t):Jr(Mt({},t,{valueSpec:r.type?n[r.type]:r}))}function wn(t){var e=t.value,r=t.key,n=dn(t);return n.length||(-1===e.indexOf("{fontstack}")&&n.push(new zt(r,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&n.push(new zt(r,e,'"glyphs" url must include a "{range}" token'))),n}function _n(t,e){void 0===e&&(e=It);var r=[];return r=r.concat(bn({key:"",value:t,valueSpec:e.$root,styleSpec:e,style:t,objectElementValidators:{glyphs:wn,"*":function(){return []}}})),t.constants&&(r=r.concat(Ct({key:"constants",value:t.constants,style:t,styleSpec:e}))),An(r)}function An(t){return [].concat(t).sort((function(t,e){return t.line-e.line}))}function Sn(t){return function(){for(var e=[],r=arguments.length;r--;)e[r]=arguments[r];return An(t.apply(this,e))}}_n.source=Sn(vn),_n.light=Sn(gn),_n.layer=Sn(yn),_n.filter=Sn(pn),_n.paintProperty=Sn(hn),_n.layoutProperty=Sn(fn);var kn=_n,In=kn.light,zn=kn.paintProperty,Cn=kn.layoutProperty;function Mn(t,e){var r=!1;if(e&&e.length)for(var n=0,i=e;n<i.length;n+=1)t.fire(new St(new Error(i[n].message))),r=!0;return r}var En=Tn;function Tn(t,e,r){var n=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var i=new Int32Array(this.arrayBuffer);t=i[0],this.d=(e=i[1])+2*(r=i[2]);for(var a=0;a<this.d*this.d;a++){var o=i[3+a],s=i[3+a+1];n.push(o===s?null:i.subarray(o,s));}var u=i[3+n.length+1];this.keys=i.subarray(i[3+n.length],u),this.bboxes=i.subarray(u),this.insert=this._insertReadonly;}else {this.d=e+2*r;for(var l=0;l<this.d*this.d;l++)n.push([]);this.keys=[],this.bboxes=[];}this.n=e,this.extent=t,this.padding=r,this.scale=e/t,this.uid=0;var p=r/e*t;this.min=-p,this.max=t+p;}Tn.prototype.insert=function(t,e,r,n,i){this._forEachCell(e,r,n,i,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(e),this.bboxes.push(r),this.bboxes.push(n),this.bboxes.push(i);},Tn.prototype._insertReadonly=function(){throw "Cannot insert into a GridIndex created from an ArrayBuffer."},Tn.prototype._insertCell=function(t,e,r,n,i,a){this.cells[i].push(a);},Tn.prototype.query=function(t,e,r,n,i){var a=this.min,o=this.max;if(t<=a&&e<=a&&o<=r&&o<=n&&!i)return Array.prototype.slice.call(this.keys);var s=[];return this._forEachCell(t,e,r,n,this._queryCell,s,{},i),s},Tn.prototype._queryCell=function(t,e,r,n,i,a,o,s){var u=this.cells[i];if(null!==u)for(var l=this.keys,p=this.bboxes,c=0;c<u.length;c++){var h=u[c];if(void 0===o[h]){var f=4*h;(s?s(p[f+0],p[f+1],p[f+2],p[f+3]):t<=p[f+2]&&e<=p[f+3]&&r>=p[f+0]&&n>=p[f+1])?(o[h]=!0,a.push(l[h])):o[h]=!1;}}},Tn.prototype._forEachCell=function(t,e,r,n,i,a,o,s){for(var u=this._convertToCellCoord(t),l=this._convertToCellCoord(e),p=this._convertToCellCoord(r),c=this._convertToCellCoord(n),h=u;h<=p;h++)for(var f=l;f<=c;f++){var y=this.d*f+h;if((!s||s(this._convertFromCellCoord(h),this._convertFromCellCoord(f),this._convertFromCellCoord(h+1),this._convertFromCellCoord(f+1)))&&i.call(this,t,e,r,n,y,a,o,s))return}},Tn.prototype._convertFromCellCoord=function(t){return (t-this.padding)/this.scale},Tn.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},Tn.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,e=3+this.cells.length+1+1,r=0,n=0;n<this.cells.length;n++)r+=this.cells[n].length;var i=new Int32Array(e+r+this.keys.length+this.bboxes.length);i[0]=this.extent,i[1]=this.n,i[2]=this.padding;for(var a=e,o=0;o<t.length;o++){var s=t[o];i[3+o]=a,i.set(s,a),a+=s.length;}return i[3+t.length]=a,i.set(this.keys,a),i[3+t.length+1]=a+=this.keys.length,i.set(this.bboxes,a),a+=this.bboxes.length,i.buffer};var Pn=self.ImageData,Bn=self.ImageBitmap,Vn={};function Fn(t,e,r){void 0===r&&(r={}),Object.defineProperty(e,"_classRegistryKey",{value:t,writeable:!1}),Vn[t]={klass:e,omit:r.omit||[],shallow:r.shallow||[]};}for(var Dn in Fn("Object",Object),En.serialize=function(t,e){var r=t.toArrayBuffer();return e&&e.push(r),{buffer:r}},En.deserialize=function(t){return new En(t.buffer)},Fn("Grid",En),Fn("Color",$t),Fn("Error",Error),Fn("ResolvedImage",ee),Fn("StylePropertyFunction",Xr),Fn("StyleExpression",jr,{omit:["_evaluator"]}),Fn("ZoomDependentExpression",Gr),Fn("ZoomConstantExpression",Kr),Fn("CompoundExpression",me,{omit:["_evaluate"]}),Ar)Ar[Dn]._classRegistryKey||Fn("Expression_"+Dn,Ar[Dn]);function Ln(t){return t&&"undefined"!=typeof ArrayBuffer&&(t instanceof ArrayBuffer||t.constructor&&"ArrayBuffer"===t.constructor.name)}function Rn(t){return Bn&&t instanceof Bn}function On(t,e){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp)return t;if(Ln(t)||Rn(t))return e&&e.push(t),t;if(ArrayBuffer.isView(t)){var r=t;return e&&e.push(r.buffer),r}if(t instanceof Pn)return e&&e.push(t.data.buffer),t;if(Array.isArray(t)){for(var n=[],i=0,a=t;i<a.length;i+=1)n.push(On(a[i],e));return n}if("object"==typeof t){var o=t.constructor,s=o._classRegistryKey;if(!s)throw new Error("can't serialize object of unregistered class");var u=o.serialize?o.serialize(t,e):{};if(!o.serialize){for(var l in t)if(t.hasOwnProperty(l)&&!(Vn[s].omit.indexOf(l)>=0)){var p=t[l];u[l]=Vn[s].shallow.indexOf(l)>=0?p:On(p,e);}t instanceof Error&&(u.message=t.message);}if(u.$name)throw new Error("$name property is reserved for worker serialization logic.");return "Object"!==s&&(u.$name=s),u}throw new Error("can't serialize object of type "+typeof t)}function Un(t){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp||Ln(t)||Rn(t)||ArrayBuffer.isView(t)||t instanceof Pn)return t;if(Array.isArray(t))return t.map(Un);if("object"==typeof t){var e=t.$name||"Object",r=Vn[e].klass;if(!r)throw new Error("can't deserialize unregistered class "+e);if(r.deserialize)return r.deserialize(t);for(var n=Object.create(r.prototype),i=0,a=Object.keys(t);i<a.length;i+=1){var o=a[i];if("$name"!==o){var s=t[o];n[o]=Vn[e].shallow.indexOf(o)>=0?s:Un(s);}}return n}throw new Error("can't deserialize object of type "+typeof t)}var jn=function(){this.first=!0;};jn.prototype.update=function(t,e){var r=Math.floor(t);return this.first?(this.first=!1,this.lastIntegerZoom=r,this.lastIntegerZoomTime=0,this.lastZoom=t,this.lastFloorZoom=r,!0):(this.lastFloorZoom>r?(this.lastIntegerZoom=r+1,this.lastIntegerZoomTime=e):this.lastFloorZoom<r&&(this.lastIntegerZoom=r,this.lastIntegerZoomTime=e),t!==this.lastZoom&&(this.lastZoom=t,this.lastFloorZoom=r,!0))};var qn={"Latin-1 Supplement":function(t){return t>=128&&t<=255},Arabic:function(t){return t>=1536&&t<=1791},"Arabic Supplement":function(t){return t>=1872&&t<=1919},"Arabic Extended-A":function(t){return t>=2208&&t<=2303},"Hangul Jamo":function(t){return t>=4352&&t<=4607},"Unified Canadian Aboriginal Syllabics":function(t){return t>=5120&&t<=5759},Khmer:function(t){return t>=6016&&t<=6143},"Unified Canadian Aboriginal Syllabics Extended":function(t){return t>=6320&&t<=6399},"General Punctuation":function(t){return t>=8192&&t<=8303},"Letterlike Symbols":function(t){return t>=8448&&t<=8527},"Number Forms":function(t){return t>=8528&&t<=8591},"Miscellaneous Technical":function(t){return t>=8960&&t<=9215},"Control Pictures":function(t){return t>=9216&&t<=9279},"Optical Character Recognition":function(t){return t>=9280&&t<=9311},"Enclosed Alphanumerics":function(t){return t>=9312&&t<=9471},"Geometric Shapes":function(t){return t>=9632&&t<=9727},"Miscellaneous Symbols":function(t){return t>=9728&&t<=9983},"Miscellaneous Symbols and Arrows":function(t){return t>=11008&&t<=11263},"CJK Radicals Supplement":function(t){return t>=11904&&t<=12031},"Kangxi Radicals":function(t){return t>=12032&&t<=12255},"Ideographic Description Characters":function(t){return t>=12272&&t<=12287},"CJK Symbols and Punctuation":function(t){return t>=12288&&t<=12351},Hiragana:function(t){return t>=12352&&t<=12447},Katakana:function(t){return t>=12448&&t<=12543},Bopomofo:function(t){return t>=12544&&t<=12591},"Hangul Compatibility Jamo":function(t){return t>=12592&&t<=12687},Kanbun:function(t){return t>=12688&&t<=12703},"Bopomofo Extended":function(t){return t>=12704&&t<=12735},"CJK Strokes":function(t){return t>=12736&&t<=12783},"Katakana Phonetic Extensions":function(t){return t>=12784&&t<=12799},"Enclosed CJK Letters and Months":function(t){return t>=12800&&t<=13055},"CJK Compatibility":function(t){return t>=13056&&t<=13311},"CJK Unified Ideographs Extension A":function(t){return t>=13312&&t<=19903},"Yijing Hexagram Symbols":function(t){return t>=19904&&t<=19967},"CJK Unified Ideographs":function(t){return t>=19968&&t<=40959},"Yi Syllables":function(t){return t>=40960&&t<=42127},"Yi Radicals":function(t){return t>=42128&&t<=42191},"Hangul Jamo Extended-A":function(t){return t>=43360&&t<=43391},"Hangul Syllables":function(t){return t>=44032&&t<=55215},"Hangul Jamo Extended-B":function(t){return t>=55216&&t<=55295},"Private Use Area":function(t){return t>=57344&&t<=63743},"CJK Compatibility Ideographs":function(t){return t>=63744&&t<=64255},"Arabic Presentation Forms-A":function(t){return t>=64336&&t<=65023},"Vertical Forms":function(t){return t>=65040&&t<=65055},"CJK Compatibility Forms":function(t){return t>=65072&&t<=65103},"Small Form Variants":function(t){return t>=65104&&t<=65135},"Arabic Presentation Forms-B":function(t){return t>=65136&&t<=65279},"Halfwidth and Fullwidth Forms":function(t){return t>=65280&&t<=65519}};function Nn(t){for(var e=0,r=t;e<r.length;e+=1)if(Kn(r[e].charCodeAt(0)))return !0;return !1}function Kn(t){return !(746!==t&&747!==t&&(t<4352||!(qn["Bopomofo Extended"](t)||qn.Bopomofo(t)||qn["CJK Compatibility Forms"](t)&&!(t>=65097&&t<=65103)||qn["CJK Compatibility Ideographs"](t)||qn["CJK Compatibility"](t)||qn["CJK Radicals Supplement"](t)||qn["CJK Strokes"](t)||!(!qn["CJK Symbols and Punctuation"](t)||t>=12296&&t<=12305||t>=12308&&t<=12319||12336===t)||qn["CJK Unified Ideographs Extension A"](t)||qn["CJK Unified Ideographs"](t)||qn["Enclosed CJK Letters and Months"](t)||qn["Hangul Compatibility Jamo"](t)||qn["Hangul Jamo Extended-A"](t)||qn["Hangul Jamo Extended-B"](t)||qn["Hangul Jamo"](t)||qn["Hangul Syllables"](t)||qn.Hiragana(t)||qn["Ideographic Description Characters"](t)||qn.Kanbun(t)||qn["Kangxi Radicals"](t)||qn["Katakana Phonetic Extensions"](t)||qn.Katakana(t)&&12540!==t||!(!qn["Halfwidth and Fullwidth Forms"](t)||65288===t||65289===t||65293===t||t>=65306&&t<=65310||65339===t||65341===t||65343===t||t>=65371&&t<=65503||65507===t||t>=65512&&t<=65519)||!(!qn["Small Form Variants"](t)||t>=65112&&t<=65118||t>=65123&&t<=65126)||qn["Unified Canadian Aboriginal Syllabics"](t)||qn["Unified Canadian Aboriginal Syllabics Extended"](t)||qn["Vertical Forms"](t)||qn["Yijing Hexagram Symbols"](t)||qn["Yi Syllables"](t)||qn["Yi Radicals"](t))))}function Gn(t){return !(Kn(t)||function(t){return !!(qn["Latin-1 Supplement"](t)&&(167===t||169===t||174===t||177===t||188===t||189===t||190===t||215===t||247===t)||qn["General Punctuation"](t)&&(8214===t||8224===t||8225===t||8240===t||8241===t||8251===t||8252===t||8258===t||8263===t||8264===t||8265===t||8273===t)||qn["Letterlike Symbols"](t)||qn["Number Forms"](t)||qn["Miscellaneous Technical"](t)&&(t>=8960&&t<=8967||t>=8972&&t<=8991||t>=8996&&t<=9e3||9003===t||t>=9085&&t<=9114||t>=9150&&t<=9165||9167===t||t>=9169&&t<=9179||t>=9186&&t<=9215)||qn["Control Pictures"](t)&&9251!==t||qn["Optical Character Recognition"](t)||qn["Enclosed Alphanumerics"](t)||qn["Geometric Shapes"](t)||qn["Miscellaneous Symbols"](t)&&!(t>=9754&&t<=9759)||qn["Miscellaneous Symbols and Arrows"](t)&&(t>=11026&&t<=11055||t>=11088&&t<=11097||t>=11192&&t<=11243)||qn["CJK Symbols and Punctuation"](t)||qn.Katakana(t)||qn["Private Use Area"](t)||qn["CJK Compatibility Forms"](t)||qn["Small Form Variants"](t)||qn["Halfwidth and Fullwidth Forms"](t)||8734===t||8756===t||8757===t||t>=9984&&t<=10087||t>=10102&&t<=10131||65532===t||65533===t)}(t))}function Zn(t){return t>=1424&&t<=2303||qn["Arabic Presentation Forms-A"](t)||qn["Arabic Presentation Forms-B"](t)}function Xn(t,e){return !(!e&&Zn(t)||t>=2304&&t<=3583||t>=3840&&t<=4255||qn.Khmer(t))}function Jn(t){for(var e=0,r=t;e<r.length;e+=1)if(Zn(r[e].charCodeAt(0)))return !0;return !1}var Hn=null,Yn="unavailable",$n=null,Wn=function(t){t&&"string"==typeof t&&t.indexOf("NetworkError")>-1&&(Yn="error"),Hn&&Hn(t);};function Qn(){ti.fire(new At("pluginStateChange",{pluginStatus:Yn,pluginURL:$n}));}var ti=new kt,ei=function(){return Yn},ri=function(){if("deferred"!==Yn||!$n)throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");Yn="loading",Qn(),$n&&gt({url:$n},(function(t){t?Wn(t):(Yn="loaded",Qn());}));},ni={applyArabicShaping:null,processBidirectionalText:null,processStyledBidirectionalText:null,isLoaded:function(){return "loaded"===Yn||null!=ni.applyArabicShaping},isLoading:function(){return "loading"===Yn},setState:function(t){Yn=t.pluginStatus,$n=t.pluginURL;},isParsed:function(){return null!=ni.applyArabicShaping&&null!=ni.processBidirectionalText&&null!=ni.processStyledBidirectionalText},getPluginURL:function(){return $n}},ii=function(t,e){this.zoom=t,e?(this.now=e.now,this.fadeDuration=e.fadeDuration,this.zoomHistory=e.zoomHistory,this.transition=e.transition):(this.now=0,this.fadeDuration=0,this.zoomHistory=new jn,this.transition={});};ii.prototype.isSupportedScript=function(t){return function(t,e){for(var r=0,n=t;r<n.length;r+=1)if(!Xn(n[r].charCodeAt(0),e))return !1;return !0}(t,ni.isLoaded())},ii.prototype.crossFadingFactor=function(){return 0===this.fadeDuration?1:Math.min((this.now-this.zoomHistory.lastIntegerZoomTime)/this.fadeDuration,1)},ii.prototype.getCrossfadeParameters=function(){var t=this.zoom,e=t-Math.floor(t),r=this.crossFadingFactor();return t>this.zoomHistory.lastIntegerZoom?{fromScale:2,toScale:1,t:e+(1-e)*r}:{fromScale:.5,toScale:1,t:1-(1-r)*e}};var ai=function(t,e){this.property=t,this.value=e,this.expression=function(t,e){if(Vr(t))return new Xr(t,e);if(qr(t)){var r=Zr(t,e);if("error"===r.result)throw new Error(r.value.map((function(t){return t.key+": "+t.message})).join(", "));return r.value}var n=t;return "string"==typeof t&&"color"===e.type&&(n=$t.parse(t)),{kind:"constant",evaluate:function(){return n}}}(void 0===e?t.specification.default:e,t.specification);};ai.prototype.isDataDriven=function(){return "source"===this.expression.kind||"composite"===this.expression.kind},ai.prototype.possiblyEvaluate=function(t,e,r){return this.property.possiblyEvaluate(this,t,e,r)};var oi=function(t){this.property=t,this.value=new ai(t,void 0);};oi.prototype.transitioned=function(t,e){return new ui(this.property,this.value,e,p({},t.transition,this.transition),t.now)},oi.prototype.untransitioned=function(){return new ui(this.property,this.value,null,{},0)};var si=function(t){this._properties=t,this._values=Object.create(t.defaultTransitionablePropertyValues);};si.prototype.getValue=function(t){return x(this._values[t].value.value)},si.prototype.setValue=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new oi(this._values[t].property)),this._values[t].value=new ai(this._values[t].property,null===e?void 0:x(e));},si.prototype.getTransition=function(t){return x(this._values[t].transition)},si.prototype.setTransition=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new oi(this._values[t].property)),this._values[t].transition=x(e)||void 0;},si.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);var a=this.getTransition(n);void 0!==a&&(t[n+"-transition"]=a);}return t},si.prototype.transitioned=function(t,e){for(var r=new li(this._properties),n=0,i=Object.keys(this._values);n<i.length;n+=1){var a=i[n];r._values[a]=this._values[a].transitioned(t,e._values[a]);}return r},si.prototype.untransitioned=function(){for(var t=new li(this._properties),e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e];t._values[n]=this._values[n].untransitioned();}return t};var ui=function(t,e,r,n,i){this.property=t,this.value=e,this.begin=i+n.delay||0,this.end=this.begin+n.duration||0,t.specification.transition&&(n.delay||n.duration)&&(this.prior=r);};ui.prototype.possiblyEvaluate=function(t,e,r){var n=t.now||0,i=this.value.possiblyEvaluate(t,e,r),a=this.prior;if(a){if(n>this.end)return this.prior=null,i;if(this.value.isDataDriven())return this.prior=null,i;if(n<this.begin)return a.possiblyEvaluate(t,e,r);var o=(n-this.begin)/(this.end-this.begin);return this.property.interpolate(a.possiblyEvaluate(t,e,r),i,function(t){if(t<=0)return 0;if(t>=1)return 1;var e=t*t,r=e*t;return 4*(t<.5?r:3*(t-e)+r-.75)}(o))}return i};var li=function(t){this._properties=t,this._values=Object.create(t.defaultTransitioningPropertyValues);};li.prototype.possiblyEvaluate=function(t,e,r){for(var n=new hi(this._properties),i=0,a=Object.keys(this._values);i<a.length;i+=1){var o=a[i];n._values[o]=this._values[o].possiblyEvaluate(t,e,r);}return n},li.prototype.hasTransition=function(){for(var t=0,e=Object.keys(this._values);t<e.length;t+=1)if(this._values[e[t]].prior)return !0;return !1};var pi=function(t){this._properties=t,this._values=Object.create(t.defaultPropertyValues);};pi.prototype.getValue=function(t){return x(this._values[t].value)},pi.prototype.setValue=function(t,e){this._values[t]=new ai(this._values[t].property,null===e?void 0:x(e));},pi.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);}return t},pi.prototype.possiblyEvaluate=function(t,e,r){for(var n=new hi(this._properties),i=0,a=Object.keys(this._values);i<a.length;i+=1){var o=a[i];n._values[o]=this._values[o].possiblyEvaluate(t,e,r);}return n};var ci=function(t,e,r){this.property=t,this.value=e,this.parameters=r;};ci.prototype.isConstant=function(){return "constant"===this.value.kind},ci.prototype.constantOr=function(t){return "constant"===this.value.kind?this.value.value:t},ci.prototype.evaluate=function(t,e,r,n){return this.property.evaluate(this.value,this.parameters,t,e,r,n)};var hi=function(t){this._properties=t,this._values=Object.create(t.defaultPossiblyEvaluatedValues);};hi.prototype.get=function(t){return this._values[t]};var fi=function(t){this.specification=t;};fi.prototype.possiblyEvaluate=function(t,e){return t.expression.evaluate(e)},fi.prototype.interpolate=function(t,e,r){var n=qe[this.specification.type];return n?n(t,e,r):t};var yi=function(t,e){this.specification=t,this.overrides=e;};yi.prototype.possiblyEvaluate=function(t,e,r,n){return new ci(this,"constant"===t.expression.kind||"camera"===t.expression.kind?{kind:"constant",value:t.expression.evaluate(e,null,{},r,n)}:t.expression,e)},yi.prototype.interpolate=function(t,e,r){if("constant"!==t.value.kind||"constant"!==e.value.kind)return t;if(void 0===t.value.value||void 0===e.value.value)return new ci(this,{kind:"constant",value:void 0},t.parameters);var n=qe[this.specification.type];return n?new ci(this,{kind:"constant",value:n(t.value.value,e.value.value,r)},t.parameters):t},yi.prototype.evaluate=function(t,e,r,n,i,a){return "constant"===t.kind?t.value:t.evaluate(e,r,n,i,a)};var di=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.possiblyEvaluate=function(t,e,r,n){if(void 0===t.value)return new ci(this,{kind:"constant",value:void 0},e);if("constant"===t.expression.kind){var i=t.expression.evaluate(e,null,{},r,n),a="resolvedImage"===t.property.specification.type&&"string"!=typeof i?i.name:i,o=this._calculate(a,a,a,e);return new ci(this,{kind:"constant",value:o},e)}if("camera"===t.expression.kind){var s=this._calculate(t.expression.evaluate({zoom:e.zoom-1}),t.expression.evaluate({zoom:e.zoom}),t.expression.evaluate({zoom:e.zoom+1}),e);return new ci(this,{kind:"constant",value:s},e)}return new ci(this,t.expression,e)},e.prototype.evaluate=function(t,e,r,n,i,a){if("source"===t.kind){var o=t.evaluate(e,r,n,i,a);return this._calculate(o,o,o,e)}return "composite"===t.kind?this._calculate(t.evaluate({zoom:Math.floor(e.zoom)-1},r,n),t.evaluate({zoom:Math.floor(e.zoom)},r,n),t.evaluate({zoom:Math.floor(e.zoom)+1},r,n),e):t.value},e.prototype._calculate=function(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:r,to:e}},e.prototype.interpolate=function(t){return t},e}(yi),mi=function(t){this.specification=t;};mi.prototype.possiblyEvaluate=function(t,e,r,n){if(void 0!==t.value){if("constant"===t.expression.kind){var i=t.expression.evaluate(e,null,{},r,n);return this._calculate(i,i,i,e)}return this._calculate(t.expression.evaluate(new ii(Math.floor(e.zoom-1),e)),t.expression.evaluate(new ii(Math.floor(e.zoom),e)),t.expression.evaluate(new ii(Math.floor(e.zoom+1),e)),e)}},mi.prototype._calculate=function(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:r,to:e}},mi.prototype.interpolate=function(t){return t};var vi=function(t){this.specification=t;};vi.prototype.possiblyEvaluate=function(t,e,r,n){return !!t.expression.evaluate(e,null,{},r,n)},vi.prototype.interpolate=function(){return !1};var gi=function(t){for(var e in this.properties=t,this.defaultPropertyValues={},this.defaultTransitionablePropertyValues={},this.defaultTransitioningPropertyValues={},this.defaultPossiblyEvaluatedValues={},this.overridableProperties=[],t){var r=t[e];r.specification.overridable&&this.overridableProperties.push(e);var n=this.defaultPropertyValues[e]=new ai(r,void 0),i=this.defaultTransitionablePropertyValues[e]=new oi(r);this.defaultTransitioningPropertyValues[e]=i.untransitioned(),this.defaultPossiblyEvaluatedValues[e]=n.possiblyEvaluate({});}};Fn("DataDrivenProperty",yi),Fn("DataConstantProperty",fi),Fn("CrossFadedDataDrivenProperty",di),Fn("CrossFadedProperty",mi),Fn("ColorRampProperty",vi);var xi=function(t){function e(e,r){if(t.call(this),this.id=e.id,this.type=e.type,this._featureFilter={filter:function(){return !0},needGeometry:!1},"custom"!==e.type&&(this.metadata=(e=e).metadata,this.minzoom=e.minzoom,this.maxzoom=e.maxzoom,"background"!==e.type&&(this.source=e.source,this.sourceLayer=e["source-layer"],this.filter=e.filter),r.layout&&(this._unevaluatedLayout=new pi(r.layout)),r.paint)){for(var n in this._transitionablePaint=new si(r.paint),e.paint)this.setPaintProperty(n,e.paint[n],{validate:!1});for(var i in e.layout)this.setLayoutProperty(i,e.layout[i],{validate:!1});this._transitioningPaint=this._transitionablePaint.untransitioned(),this.paint=new hi(r.paint);}}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getCrossfadeParameters=function(){return this._crossfadeParameters},e.prototype.getLayoutProperty=function(t){return "visibility"===t?this.visibility:this._unevaluatedLayout.getValue(t)},e.prototype.setLayoutProperty=function(t,e,r){void 0===r&&(r={}),null!=e&&this._validate(Cn,"layers."+this.id+".layout."+t,t,e,r)||("visibility"!==t?this._unevaluatedLayout.setValue(t,e):this.visibility=e);},e.prototype.getPaintProperty=function(t){return m(t,"-transition")?this._transitionablePaint.getTransition(t.slice(0,-"-transition".length)):this._transitionablePaint.getValue(t)},e.prototype.setPaintProperty=function(t,e,r){if(void 0===r&&(r={}),null!=e&&this._validate(zn,"layers."+this.id+".paint."+t,t,e,r))return !1;if(m(t,"-transition"))return this._transitionablePaint.setTransition(t.slice(0,-"-transition".length),e||void 0),!1;var n=this._transitionablePaint._values[t],i="cross-faded-data-driven"===n.property.specification["property-type"],a=n.value.isDataDriven(),o=n.value;this._transitionablePaint.setValue(t,e),this._handleSpecialPaintPropertyUpdate(t);var s=this._transitionablePaint._values[t].value;return s.isDataDriven()||a||i||this._handleOverridablePaintPropertyUpdate(t,o,s)},e.prototype._handleSpecialPaintPropertyUpdate=function(t){},e.prototype._handleOverridablePaintPropertyUpdate=function(t,e,r){return !1},e.prototype.isHidden=function(t){return !!(this.minzoom&&t<this.minzoom)||!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.visibility},e.prototype.updateTransitions=function(t){this._transitioningPaint=this._transitionablePaint.transitioned(t,this._transitioningPaint);},e.prototype.hasTransition=function(){return this._transitioningPaint.hasTransition()},e.prototype.recalculate=function(t,e){t.getCrossfadeParameters&&(this._crossfadeParameters=t.getCrossfadeParameters()),this._unevaluatedLayout&&(this.layout=this._unevaluatedLayout.possiblyEvaluate(t,void 0,e)),this.paint=this._transitioningPaint.possiblyEvaluate(t,void 0,e);},e.prototype.serialize=function(){var t={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:this._unevaluatedLayout&&this._unevaluatedLayout.serialize(),paint:this._transitionablePaint&&this._transitionablePaint.serialize()};return this.visibility&&(t.layout=t.layout||{},t.layout.visibility=this.visibility),g(t,(function(t,e){return !(void 0===t||"layout"===e&&!Object.keys(t).length||"paint"===e&&!Object.keys(t).length)}))},e.prototype._validate=function(t,e,r,n,i){return void 0===i&&(i={}),(!i||!1!==i.validate)&&Mn(this,t.call(kn,{key:e,layerType:this.type,objectKey:r,value:n,styleSpec:It,style:{glyphs:!0,sprite:!0}}))},e.prototype.is3D=function(){return !1},e.prototype.isTileClipped=function(){return !1},e.prototype.hasOffscreenPass=function(){return !1},e.prototype.resize=function(){},e.prototype.isStateDependent=function(){for(var t in this.paint._values){var e=this.paint.get(t);if(e instanceof ci&&Er(e.property.specification)&&("source"===e.value.kind||"composite"===e.value.kind)&&e.value.isStateDependent)return !0}return !1},e}(kt),bi={Int8:Int8Array,Uint8:Uint8Array,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array},wi=function(t,e){this._structArray=t,this._pos1=e*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8;},_i=function(){this.isTransferred=!1,this.capacity=-1,this.resize(0);};function Ai(t,e){void 0===e&&(e=1);var r=0,n=0;return {members:t.map((function(t){var i=bi[t.type].BYTES_PER_ELEMENT,a=r=Si(r,Math.max(e,i)),o=t.components||1;return n=Math.max(n,i),r+=i*o,{name:t.name,type:t.type,components:o,offset:a}})),size:Si(r,Math.max(n,e)),alignment:e}}function Si(t,e){return Math.ceil(t/e)*e}_i.serialize=function(t,e){return t._trim(),e&&(t.isTransferred=!0,e.push(t.arrayBuffer)),{length:t.length,arrayBuffer:t.arrayBuffer}},_i.deserialize=function(t){var e=Object.create(this.prototype);return e.arrayBuffer=t.arrayBuffer,e.length=t.length,e.capacity=t.arrayBuffer.byteLength/e.bytesPerElement,e._refreshViews(),e},_i.prototype._trim=function(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews());},_i.prototype.clear=function(){this.length=0;},_i.prototype.resize=function(t){this.reserve(t),this.length=t;},_i.prototype.reserve=function(t){if(t>this.capacity){this.capacity=Math.max(t,Math.floor(5*this.capacity),128),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement);var e=this.uint8;this._refreshViews(),e&&this.uint8.set(e);}},_i.prototype._refreshViews=function(){throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")};var ki=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.int16[n+0]=e,this.int16[n+1]=r,t},e}(_i);ki.prototype.bytesPerElement=4,Fn("StructArrayLayout2i4",ki);var Ii=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.int16[a+0]=e,this.int16[a+1]=r,this.int16[a+2]=n,this.int16[a+3]=i,t},e}(_i);Ii.prototype.bytesPerElement=8,Fn("StructArrayLayout4i8",Ii);var zi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}(_i);zi.prototype.bytesPerElement=12,Fn("StructArrayLayout2i4i12",zi);var Ci=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=4*t,u=8*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.uint8[u+4]=n,this.uint8[u+5]=i,this.uint8[u+6]=a,this.uint8[u+7]=o,t},e}(_i);Ci.prototype.bytesPerElement=8,Fn("StructArrayLayout2i4ub8",Ci);var Mi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l){var p=this.length;return this.resize(p+1),this.emplace(p,t,e,r,n,i,a,o,s,u,l)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p){var c=9*t,h=18*t;return this.uint16[c+0]=e,this.uint16[c+1]=r,this.uint16[c+2]=n,this.uint16[c+3]=i,this.uint16[c+4]=a,this.uint16[c+5]=o,this.uint16[c+6]=s,this.uint16[c+7]=u,this.uint8[h+16]=l,this.uint8[h+17]=p,t},e}(_i);Mi.prototype.bytesPerElement=18,Fn("StructArrayLayout8ui2ub18",Mi);var Ei=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c){var h=this.length;return this.resize(h+1),this.emplace(h,t,e,r,n,i,a,o,s,u,l,p,c)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h){var f=12*t;return this.int16[f+0]=e,this.int16[f+1]=r,this.int16[f+2]=n,this.int16[f+3]=i,this.uint16[f+4]=a,this.uint16[f+5]=o,this.uint16[f+6]=s,this.uint16[f+7]=u,this.int16[f+8]=l,this.int16[f+9]=p,this.int16[f+10]=c,this.int16[f+11]=h,t},e}(_i);Ei.prototype.bytesPerElement=24,Fn("StructArrayLayout4i4ui4i24",Ei);var Ti=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.float32[i+0]=e,this.float32[i+1]=r,this.float32[i+2]=n,t},e}(_i);Ti.prototype.bytesPerElement=12,Fn("StructArrayLayout3f12",Ti);var Pi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){return this.uint32[1*t+0]=e,t},e}(_i);Pi.prototype.bytesPerElement=4,Fn("StructArrayLayout1ul4",Pi);var Bi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u){var l=this.length;return this.resize(l+1),this.emplace(l,t,e,r,n,i,a,o,s,u)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l){var p=10*t,c=5*t;return this.int16[p+0]=e,this.int16[p+1]=r,this.int16[p+2]=n,this.int16[p+3]=i,this.int16[p+4]=a,this.int16[p+5]=o,this.uint32[c+3]=s,this.uint16[p+8]=u,this.uint16[p+9]=l,t},e}(_i);Bi.prototype.bytesPerElement=20,Fn("StructArrayLayout6i1ul2ui20",Bi);var Vi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}(_i);Vi.prototype.bytesPerElement=12,Fn("StructArrayLayout2i2i2i12",Vi);var Fi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i){var a=this.length;return this.resize(a+1),this.emplace(a,t,e,r,n,i)},e.prototype.emplace=function(t,e,r,n,i,a){var o=4*t,s=8*t;return this.float32[o+0]=e,this.float32[o+1]=r,this.float32[o+2]=n,this.int16[s+6]=i,this.int16[s+7]=a,t},e}(_i);Fi.prototype.bytesPerElement=16,Fn("StructArrayLayout2f1f2i16",Fi);var Di=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=12*t,o=3*t;return this.uint8[a+0]=e,this.uint8[a+1]=r,this.float32[o+1]=n,this.float32[o+2]=i,t},e}(_i);Di.prototype.bytesPerElement=12,Fn("StructArrayLayout2ub2f12",Di);var Li=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.uint16[i+0]=e,this.uint16[i+1]=r,this.uint16[i+2]=n,t},e}(_i);Li.prototype.bytesPerElement=6,Fn("StructArrayLayout3ui6",Li);var Ri=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m){var v=this.length;return this.resize(v+1),this.emplace(v,t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v){var g=24*t,x=12*t,b=48*t;return this.int16[g+0]=e,this.int16[g+1]=r,this.uint16[g+2]=n,this.uint16[g+3]=i,this.uint32[x+2]=a,this.uint32[x+3]=o,this.uint32[x+4]=s,this.uint16[g+10]=u,this.uint16[g+11]=l,this.uint16[g+12]=p,this.float32[x+7]=c,this.float32[x+8]=h,this.uint8[b+36]=f,this.uint8[b+37]=y,this.uint8[b+38]=d,this.uint32[x+10]=m,this.int16[g+22]=v,t},e}(_i);Ri.prototype.bytesPerElement=48,Fn("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48",Ri);var Oi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b,w,_,A,S,k,I,z){var C=this.length;return this.resize(C+1),this.emplace(C,t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b,w,_,A,S,k,I,z)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b,w,_,A,S,k,I,z,C){var M=34*t,E=17*t;return this.int16[M+0]=e,this.int16[M+1]=r,this.int16[M+2]=n,this.int16[M+3]=i,this.int16[M+4]=a,this.int16[M+5]=o,this.int16[M+6]=s,this.int16[M+7]=u,this.uint16[M+8]=l,this.uint16[M+9]=p,this.uint16[M+10]=c,this.uint16[M+11]=h,this.uint16[M+12]=f,this.uint16[M+13]=y,this.uint16[M+14]=d,this.uint16[M+15]=m,this.uint16[M+16]=v,this.uint16[M+17]=g,this.uint16[M+18]=x,this.uint16[M+19]=b,this.uint16[M+20]=w,this.uint16[M+21]=_,this.uint16[M+22]=A,this.uint32[E+12]=S,this.float32[E+13]=k,this.float32[E+14]=I,this.float32[E+15]=z,this.float32[E+16]=C,t},e}(_i);Oi.prototype.bytesPerElement=68,Fn("StructArrayLayout8i15ui1ul4f68",Oi);var Ui=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){return this.float32[1*t+0]=e,t},e}(_i);Ui.prototype.bytesPerElement=4,Fn("StructArrayLayout1f4",Ui);var ji=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.int16[i+0]=e,this.int16[i+1]=r,this.int16[i+2]=n,t},e}(_i);ji.prototype.bytesPerElement=6,Fn("StructArrayLayout3i6",ji);var qi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=4*t;return this.uint32[2*t+0]=e,this.uint16[i+2]=r,this.uint16[i+3]=n,t},e}(_i);qi.prototype.bytesPerElement=8,Fn("StructArrayLayout1ul2ui8",qi);var Ni=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.uint16[n+0]=e,this.uint16[n+1]=r,t},e}(_i);Ni.prototype.bytesPerElement=4,Fn("StructArrayLayout2ui4",Ni);var Ki=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){return this.uint16[1*t+0]=e,t},e}(_i);Ki.prototype.bytesPerElement=2,Fn("StructArrayLayout1ui2",Ki);var Gi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.float32[n+0]=e,this.float32[n+1]=r,t},e}(_i);Gi.prototype.bytesPerElement=8,Fn("StructArrayLayout2f8",Gi);var Zi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.float32[a+0]=e,this.float32[a+1]=r,this.float32[a+2]=n,this.float32[a+3]=i,t},e}(_i);Zi.prototype.bytesPerElement=16,Fn("StructArrayLayout4f16",Zi);var Xi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var r={anchorPointX:{configurable:!0},anchorPointY:{configurable:!0},x1:{configurable:!0},y1:{configurable:!0},x2:{configurable:!0},y2:{configurable:!0},featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0},anchorPoint:{configurable:!0}};return r.anchorPointX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorPointY.get=function(){return this._structArray.int16[this._pos2+1]},r.x1.get=function(){return this._structArray.int16[this._pos2+2]},r.y1.get=function(){return this._structArray.int16[this._pos2+3]},r.x2.get=function(){return this._structArray.int16[this._pos2+4]},r.y2.get=function(){return this._structArray.int16[this._pos2+5]},r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+8]},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+9]},r.anchorPoint.get=function(){return new i(this.anchorPointX,this.anchorPointY)},Object.defineProperties(e.prototype,r),e}(wi);Xi.prototype.size=20;var Ji=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.get=function(t){return new Xi(this,t)},e}(Bi);Fn("CollisionBoxArray",Ji);var Hi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var r={anchorX:{configurable:!0},anchorY:{configurable:!0},glyphStartIndex:{configurable:!0},numGlyphs:{configurable:!0},vertexStartIndex:{configurable:!0},lineStartIndex:{configurable:!0},lineLength:{configurable:!0},segment:{configurable:!0},lowerSize:{configurable:!0},upperSize:{configurable:!0},lineOffsetX:{configurable:!0},lineOffsetY:{configurable:!0},writingMode:{configurable:!0},placedOrientation:{configurable:!0},hidden:{configurable:!0},crossTileID:{configurable:!0},associatedIconIndex:{configurable:!0}};return r.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},r.glyphStartIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.numGlyphs.get=function(){return this._structArray.uint16[this._pos2+3]},r.vertexStartIndex.get=function(){return this._structArray.uint32[this._pos4+2]},r.lineStartIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.lineLength.get=function(){return this._structArray.uint32[this._pos4+4]},r.segment.get=function(){return this._structArray.uint16[this._pos2+10]},r.lowerSize.get=function(){return this._structArray.uint16[this._pos2+11]},r.upperSize.get=function(){return this._structArray.uint16[this._pos2+12]},r.lineOffsetX.get=function(){return this._structArray.float32[this._pos4+7]},r.lineOffsetY.get=function(){return this._structArray.float32[this._pos4+8]},r.writingMode.get=function(){return this._structArray.uint8[this._pos1+36]},r.placedOrientation.get=function(){return this._structArray.uint8[this._pos1+37]},r.placedOrientation.set=function(t){this._structArray.uint8[this._pos1+37]=t;},r.hidden.get=function(){return this._structArray.uint8[this._pos1+38]},r.hidden.set=function(t){this._structArray.uint8[this._pos1+38]=t;},r.crossTileID.get=function(){return this._structArray.uint32[this._pos4+10]},r.crossTileID.set=function(t){this._structArray.uint32[this._pos4+10]=t;},r.associatedIconIndex.get=function(){return this._structArray.int16[this._pos2+22]},Object.defineProperties(e.prototype,r),e}(wi);Hi.prototype.size=48;var Yi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.get=function(t){return new Hi(this,t)},e}(Ri);Fn("PlacedSymbolArray",Yi);var $i=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var r={anchorX:{configurable:!0},anchorY:{configurable:!0},rightJustifiedTextSymbolIndex:{configurable:!0},centerJustifiedTextSymbolIndex:{configurable:!0},leftJustifiedTextSymbolIndex:{configurable:!0},verticalPlacedTextSymbolIndex:{configurable:!0},placedIconSymbolIndex:{configurable:!0},verticalPlacedIconSymbolIndex:{configurable:!0},key:{configurable:!0},textBoxStartIndex:{configurable:!0},textBoxEndIndex:{configurable:!0},verticalTextBoxStartIndex:{configurable:!0},verticalTextBoxEndIndex:{configurable:!0},iconBoxStartIndex:{configurable:!0},iconBoxEndIndex:{configurable:!0},verticalIconBoxStartIndex:{configurable:!0},verticalIconBoxEndIndex:{configurable:!0},featureIndex:{configurable:!0},numHorizontalGlyphVertices:{configurable:!0},numVerticalGlyphVertices:{configurable:!0},numIconVertices:{configurable:!0},numVerticalIconVertices:{configurable:!0},useRuntimeCollisionCircles:{configurable:!0},crossTileID:{configurable:!0},textBoxScale:{configurable:!0},textOffset0:{configurable:!0},textOffset1:{configurable:!0},collisionCircleDiameter:{configurable:!0}};return r.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},r.rightJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+2]},r.centerJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+3]},r.leftJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+4]},r.verticalPlacedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+5]},r.placedIconSymbolIndex.get=function(){return this._structArray.int16[this._pos2+6]},r.verticalPlacedIconSymbolIndex.get=function(){return this._structArray.int16[this._pos2+7]},r.key.get=function(){return this._structArray.uint16[this._pos2+8]},r.textBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+9]},r.textBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+10]},r.verticalTextBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+11]},r.verticalTextBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+12]},r.iconBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+13]},r.iconBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+14]},r.verticalIconBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+15]},r.verticalIconBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+16]},r.featureIndex.get=function(){return this._structArray.uint16[this._pos2+17]},r.numHorizontalGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+18]},r.numVerticalGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+19]},r.numIconVertices.get=function(){return this._structArray.uint16[this._pos2+20]},r.numVerticalIconVertices.get=function(){return this._structArray.uint16[this._pos2+21]},r.useRuntimeCollisionCircles.get=function(){return this._structArray.uint16[this._pos2+22]},r.crossTileID.get=function(){return this._structArray.uint32[this._pos4+12]},r.crossTileID.set=function(t){this._structArray.uint32[this._pos4+12]=t;},r.textBoxScale.get=function(){return this._structArray.float32[this._pos4+13]},r.textOffset0.get=function(){return this._structArray.float32[this._pos4+14]},r.textOffset1.get=function(){return this._structArray.float32[this._pos4+15]},r.collisionCircleDiameter.get=function(){return this._structArray.float32[this._pos4+16]},Object.defineProperties(e.prototype,r),e}(wi);$i.prototype.size=68;var Wi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.get=function(t){return new $i(this,t)},e}(Oi);Fn("SymbolInstanceArray",Wi);var Qi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getoffsetX=function(t){return this.float32[1*t+0]},e}(Ui);Fn("GlyphOffsetArray",Qi);var ta=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getx=function(t){return this.int16[3*t+0]},e.prototype.gety=function(t){return this.int16[3*t+1]},e.prototype.gettileUnitDistanceFromAnchor=function(t){return this.int16[3*t+2]},e}(ji);Fn("SymbolLineVertexArray",ta);var ea=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var r={featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0}};return r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+0]},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+3]},Object.defineProperties(e.prototype,r),e}(wi);ea.prototype.size=8;var ra=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.get=function(t){return new ea(this,t)},e}(qi);Fn("FeatureIndexArray",ra);var na=Ai([{name:"a_pos",components:2,type:"Int16"}],4).members,ia=function(t){void 0===t&&(t=[]),this.segments=t;};function aa(t,e){return 256*(t=u(Math.floor(t),0,255))+u(Math.floor(e),0,255)}ia.prototype.prepareSegment=function(t,e,r,n){var i=this.segments[this.segments.length-1];return t>ia.MAX_VERTEX_ARRAY_LENGTH&&w("Max vertices per segment is "+ia.MAX_VERTEX_ARRAY_LENGTH+": bucket requested "+t),(!i||i.vertexLength+t>ia.MAX_VERTEX_ARRAY_LENGTH||i.sortKey!==n)&&(i={vertexOffset:e.length,primitiveOffset:r.length,vertexLength:0,primitiveLength:0},void 0!==n&&(i.sortKey=n),this.segments.push(i)),i},ia.prototype.get=function(){return this.segments},ia.prototype.destroy=function(){for(var t=0,e=this.segments;t<e.length;t+=1){var r=e[t];for(var n in r.vaos)r.vaos[n].destroy();}},ia.simpleSegment=function(t,e,r,n){return new ia([{vertexOffset:t,primitiveOffset:e,vertexLength:r,primitiveLength:n,vaos:{},sortKey:0}])},ia.MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,Fn("SegmentVector",ia);var oa=Ai([{name:"a_pattern_from",components:4,type:"Uint16"},{name:"a_pattern_to",components:4,type:"Uint16"},{name:"a_pixel_ratio_from",components:1,type:"Uint8"},{name:"a_pixel_ratio_to",components:1,type:"Uint8"}]),sa=e((function(t){t.exports=function(t,e){var r,n,i,a,o,s,u,l;for(n=t.length-(r=3&t.length),i=e,o=3432918353,s=461845907,l=0;l<n;)u=255&t.charCodeAt(l)|(255&t.charCodeAt(++l))<<8|(255&t.charCodeAt(++l))<<16|(255&t.charCodeAt(++l))<<24,++l,i=27492+(65535&(a=5*(65535&(i=(i^=u=(65535&(u=(u=(65535&u)*o+(((u>>>16)*o&65535)<<16)&4294967295)<<15|u>>>17))*s+(((u>>>16)*s&65535)<<16)&4294967295)<<13|i>>>19))+((5*(i>>>16)&65535)<<16)&4294967295))+((58964+(a>>>16)&65535)<<16);switch(u=0,r){case 3:u^=(255&t.charCodeAt(l+2))<<16;case 2:u^=(255&t.charCodeAt(l+1))<<8;case 1:i^=u=(65535&(u=(u=(65535&(u^=255&t.charCodeAt(l)))*o+(((u>>>16)*o&65535)<<16)&4294967295)<<15|u>>>17))*s+(((u>>>16)*s&65535)<<16)&4294967295;}return i^=t.length,i=2246822507*(65535&(i^=i>>>16))+((2246822507*(i>>>16)&65535)<<16)&4294967295,i=3266489909*(65535&(i^=i>>>13))+((3266489909*(i>>>16)&65535)<<16)&4294967295,(i^=i>>>16)>>>0};})),ua=e((function(t){t.exports=function(t,e){for(var r,n=t.length,i=e^n,a=0;n>=4;)r=1540483477*(65535&(r=255&t.charCodeAt(a)|(255&t.charCodeAt(++a))<<8|(255&t.charCodeAt(++a))<<16|(255&t.charCodeAt(++a))<<24))+((1540483477*(r>>>16)&65535)<<16),i=1540483477*(65535&i)+((1540483477*(i>>>16)&65535)<<16)^(r=1540483477*(65535&(r^=r>>>24))+((1540483477*(r>>>16)&65535)<<16)),n-=4,++a;switch(n){case 3:i^=(255&t.charCodeAt(a+2))<<16;case 2:i^=(255&t.charCodeAt(a+1))<<8;case 1:i=1540483477*(65535&(i^=255&t.charCodeAt(a)))+((1540483477*(i>>>16)&65535)<<16);}return i=1540483477*(65535&(i^=i>>>13))+((1540483477*(i>>>16)&65535)<<16),(i^=i>>>15)>>>0};})),la=sa,pa=ua;la.murmur3=sa,la.murmur2=pa;var ca=function(){this.ids=[],this.positions=[],this.indexed=!1;};ca.prototype.add=function(t,e,r,n){this.ids.push(fa(t)),this.positions.push(e,r,n);},ca.prototype.getPositions=function(t){for(var e=fa(t),r=0,n=this.ids.length-1;r<n;){var i=r+n>>1;this.ids[i]>=e?n=i:r=i+1;}for(var a=[];this.ids[r]===e;)a.push({index:this.positions[3*r],start:this.positions[3*r+1],end:this.positions[3*r+2]}),r++;return a},ca.serialize=function(t,e){var r=new Float64Array(t.ids),n=new Uint32Array(t.positions);return function t(e,r,n,i){for(;n<i;){for(var a=e[n+i>>1],o=n-1,s=i+1;;){do{o++;}while(e[o]<a);do{s--;}while(e[s]>a);if(o>=s)break;ya(e,o,s),ya(r,3*o,3*s),ya(r,3*o+1,3*s+1),ya(r,3*o+2,3*s+2);}s-n<i-s?(t(e,r,n,s),n=s+1):(t(e,r,s+1,i),i=s);}}(r,n,0,r.length-1),e&&e.push(r.buffer,n.buffer),{ids:r,positions:n}},ca.deserialize=function(t){var e=new ca;return e.ids=t.ids,e.positions=t.positions,e.indexed=!0,e};var ha=Math.pow(2,53)-1;function fa(t){var e=+t;return !isNaN(e)&&e<=ha?e:la(String(t))}function ya(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}Fn("FeaturePositionMap",ca);var da=function(t,e){this.gl=t.gl,this.location=e;},ma=function(t){function e(e,r){t.call(this,e,r),this.current=0;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1i(this.location,t));},e}(da),va=function(t){function e(e,r){t.call(this,e,r),this.current=0;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1f(this.location,t));},e}(da),ga=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0];}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]||(this.current=t,this.gl.uniform2f(this.location,t[0],t[1]));},e}(da),xa=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0,0];}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]||(this.current=t,this.gl.uniform3f(this.location,t[0],t[1],t[2]));},e}(da),ba=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0,0,0];}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]&&t[3]===this.current[3]||(this.current=t,this.gl.uniform4f(this.location,t[0],t[1],t[2],t[3]));},e}(da),wa=function(t){function e(e,r){t.call(this,e,r),this.current=$t.transparent;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.set=function(t){t.r===this.current.r&&t.g===this.current.g&&t.b===this.current.b&&t.a===this.current.a||(this.current=t,this.gl.uniform4f(this.location,t.r,t.g,t.b,t.a));},e}(da),_a=new Float32Array(16),Aa=function(t){function e(e,r){t.call(this,e,r),this.current=_a;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.set=function(t){if(t[12]!==this.current[12]||t[0]!==this.current[0])return this.current=t,void this.gl.uniformMatrix4fv(this.location,!1,t);for(var e=1;e<16;e++)if(t[e]!==this.current[e]){this.current=t,this.gl.uniformMatrix4fv(this.location,!1,t);break}},e}(da);function Sa(t){return [aa(255*t.r,255*t.g),aa(255*t.b,255*t.a)]}var ka=function(t,e,r){this.value=t,this.uniformNames=e.map((function(t){return "u_"+t})),this.type=r;};ka.prototype.setUniform=function(t,e,r){t.set(r.constantOr(this.value));},ka.prototype.getBinding=function(t,e,r){return "color"===this.type?new wa(t,e):new va(t,e)};var Ia=function(t,e){this.uniformNames=e.map((function(t){return "u_"+t})),this.patternFrom=null,this.patternTo=null,this.pixelRatioFrom=1,this.pixelRatioTo=1;};Ia.prototype.setConstantPatternPositions=function(t,e){this.pixelRatioFrom=e.pixelRatio,this.pixelRatioTo=t.pixelRatio,this.patternFrom=e.tlbr,this.patternTo=t.tlbr;},Ia.prototype.setUniform=function(t,e,r,n){var i="u_pattern_to"===n?this.patternTo:"u_pattern_from"===n?this.patternFrom:"u_pixel_ratio_to"===n?this.pixelRatioTo:"u_pixel_ratio_from"===n?this.pixelRatioFrom:null;i&&t.set(i);},Ia.prototype.getBinding=function(t,e,r){return "u_pattern"===r.substr(0,9)?new ba(t,e):new va(t,e)};var za=function(t,e,r,n){this.expression=t,this.type=r,this.maxValue=0,this.paintVertexAttributes=e.map((function(t){return {name:"a_"+t,type:"Float32",components:"color"===r?2:1,offset:0}})),this.paintVertexArray=new n;};za.prototype.populatePaintArray=function(t,e,r,n,i){var a=this.paintVertexArray.length,o=this.expression.evaluate(new ii(0),e,{},n,[],i);this.paintVertexArray.resize(t),this._setPaintValue(a,t,o);},za.prototype.updatePaintArray=function(t,e,r,n){var i=this.expression.evaluate({zoom:0},r,n);this._setPaintValue(t,e,i);},za.prototype._setPaintValue=function(t,e,r){if("color"===this.type)for(var n=Sa(r),i=t;i<e;i++)this.paintVertexArray.emplace(i,n[0],n[1]);else {for(var a=t;a<e;a++)this.paintVertexArray.emplace(a,r);this.maxValue=Math.max(this.maxValue,Math.abs(r));}},za.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},za.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();};var Ca=function(t,e,r,n,i,a){this.expression=t,this.uniformNames=e.map((function(t){return "u_"+t+"_t"})),this.type=r,this.useIntegerZoom=n,this.zoom=i,this.maxValue=0,this.paintVertexAttributes=e.map((function(t){return {name:"a_"+t,type:"Float32",components:"color"===r?4:2,offset:0}})),this.paintVertexArray=new a;};Ca.prototype.populatePaintArray=function(t,e,r,n,i){var a=this.expression.evaluate(new ii(this.zoom),e,{},n,[],i),o=this.expression.evaluate(new ii(this.zoom+1),e,{},n,[],i),s=this.paintVertexArray.length;this.paintVertexArray.resize(t),this._setPaintValue(s,t,a,o);},Ca.prototype.updatePaintArray=function(t,e,r,n){var i=this.expression.evaluate({zoom:this.zoom},r,n),a=this.expression.evaluate({zoom:this.zoom+1},r,n);this._setPaintValue(t,e,i,a);},Ca.prototype._setPaintValue=function(t,e,r,n){if("color"===this.type)for(var i=Sa(r),a=Sa(n),o=t;o<e;o++)this.paintVertexArray.emplace(o,i[0],i[1],a[0],a[1]);else {for(var s=t;s<e;s++)this.paintVertexArray.emplace(s,r,n);this.maxValue=Math.max(this.maxValue,Math.abs(r),Math.abs(n));}},Ca.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Ca.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();},Ca.prototype.setUniform=function(t,e){var r=this.useIntegerZoom?Math.floor(e.zoom):e.zoom,n=u(this.expression.interpolationFactor(r,this.zoom,this.zoom+1),0,1);t.set(n);},Ca.prototype.getBinding=function(t,e,r){return new va(t,e)};var Ma=function(t,e,r,n,i,a){this.expression=t,this.type=e,this.useIntegerZoom=r,this.zoom=n,this.layerId=a,this.zoomInPaintVertexArray=new i,this.zoomOutPaintVertexArray=new i;};Ma.prototype.populatePaintArray=function(t,e,r){var n=this.zoomInPaintVertexArray.length;this.zoomInPaintVertexArray.resize(t),this.zoomOutPaintVertexArray.resize(t),this._setPaintValues(n,t,e.patterns&&e.patterns[this.layerId],r);},Ma.prototype.updatePaintArray=function(t,e,r,n,i){this._setPaintValues(t,e,r.patterns&&r.patterns[this.layerId],i);},Ma.prototype._setPaintValues=function(t,e,r,n){if(n&&r){var i=n[r.min],a=n[r.mid],o=n[r.max];if(i&&a&&o)for(var s=t;s<e;s++)this.zoomInPaintVertexArray.emplace(s,a.tl[0],a.tl[1],a.br[0],a.br[1],i.tl[0],i.tl[1],i.br[0],i.br[1],a.pixelRatio,i.pixelRatio),this.zoomOutPaintVertexArray.emplace(s,a.tl[0],a.tl[1],a.br[0],a.br[1],o.tl[0],o.tl[1],o.br[0],o.br[1],a.pixelRatio,o.pixelRatio);}},Ma.prototype.upload=function(t){this.zoomInPaintVertexArray&&this.zoomInPaintVertexArray.arrayBuffer&&this.zoomOutPaintVertexArray&&this.zoomOutPaintVertexArray.arrayBuffer&&(this.zoomInPaintVertexBuffer=t.createVertexBuffer(this.zoomInPaintVertexArray,oa.members,this.expression.isStateDependent),this.zoomOutPaintVertexBuffer=t.createVertexBuffer(this.zoomOutPaintVertexArray,oa.members,this.expression.isStateDependent));},Ma.prototype.destroy=function(){this.zoomOutPaintVertexBuffer&&this.zoomOutPaintVertexBuffer.destroy(),this.zoomInPaintVertexBuffer&&this.zoomInPaintVertexBuffer.destroy();};var Ea=function(t,e,r,n){this.binders={},this.layoutAttributes=n,this._buffers=[];var i=[];for(var a in t.paint._values)if(r(a)){var o=t.paint.get(a);if(o instanceof ci&&Er(o.property.specification)){var s=Pa(a,t.type),u=o.value,l=o.property.specification.type,p=o.property.useIntegerZoom,c=o.property.specification["property-type"],h="cross-faded"===c||"cross-faded-data-driven"===c;if("constant"===u.kind)this.binders[a]=h?new Ia(u.value,s):new ka(u.value,s,l),i.push("/u_"+a);else if("source"===u.kind||h){var f=Ba(a,l,"source");this.binders[a]=h?new Ma(u,l,p,e,f,t.id):new za(u,s,l,f),i.push("/a_"+a);}else {var y=Ba(a,l,"composite");this.binders[a]=new Ca(u,s,l,p,e,y),i.push("/z_"+a);}}}this.cacheKey=i.sort().join("");};Ea.prototype.getMaxValue=function(t){var e=this.binders[t];return e instanceof za||e instanceof Ca?e.maxValue:0},Ea.prototype.populatePaintArrays=function(t,e,r,n,i){for(var a in this.binders){var o=this.binders[a];(o instanceof za||o instanceof Ca||o instanceof Ma)&&o.populatePaintArray(t,e,r,n,i);}},Ea.prototype.setConstantPatternPositions=function(t,e){for(var r in this.binders){var n=this.binders[r];n instanceof Ia&&n.setConstantPatternPositions(t,e);}},Ea.prototype.updatePaintArrays=function(t,e,r,n,i){var a=!1;for(var o in t)for(var s=0,u=e.getPositions(o);s<u.length;s+=1){var l=u[s],p=r.feature(l.index);for(var c in this.binders){var h=this.binders[c];if((h instanceof za||h instanceof Ca||h instanceof Ma)&&!0===h.expression.isStateDependent){var f=n.paint.get(c);h.expression=f.value,h.updatePaintArray(l.start,l.end,p,t[o],i),a=!0;}}}return a},Ea.prototype.defines=function(){var t=[];for(var e in this.binders){var r=this.binders[e];(r instanceof ka||r instanceof Ia)&&t.push.apply(t,r.uniformNames.map((function(t){return "#define HAS_UNIFORM_"+t})));}return t},Ea.prototype.getPaintVertexBuffers=function(){return this._buffers},Ea.prototype.getUniforms=function(t,e){var r=[];for(var n in this.binders){var i=this.binders[n];if(i instanceof ka||i instanceof Ia||i instanceof Ca)for(var a=0,o=i.uniformNames;a<o.length;a+=1){var s=o[a];if(e[s]){var u=i.getBinding(t,e[s],s);r.push({name:s,property:n,binding:u});}}}return r},Ea.prototype.setUniforms=function(t,e,r,n){for(var i=0,a=e;i<a.length;i+=1){var o=a[i],s=o.name,u=o.property;this.binders[u].setUniform(o.binding,n,r.get(u),s);}},Ea.prototype.updatePaintBuffers=function(t){for(var e in this._buffers=[],this.binders){var r=this.binders[e];if(t&&r instanceof Ma){var n=2===t.fromScale?r.zoomInPaintVertexBuffer:r.zoomOutPaintVertexBuffer;n&&this._buffers.push(n);}else (r instanceof za||r instanceof Ca)&&r.paintVertexBuffer&&this._buffers.push(r.paintVertexBuffer);}},Ea.prototype.upload=function(t){for(var e in this.binders){var r=this.binders[e];(r instanceof za||r instanceof Ca||r instanceof Ma)&&r.upload(t);}this.updatePaintBuffers();},Ea.prototype.destroy=function(){for(var t in this.binders){var e=this.binders[t];(e instanceof za||e instanceof Ca||e instanceof Ma)&&e.destroy();}};var Ta=function(t,e,r,n){void 0===n&&(n=function(){return !0}),this.programConfigurations={};for(var i=0,a=e;i<a.length;i+=1){var o=a[i];this.programConfigurations[o.id]=new Ea(o,r,n,t);}this.needsUpload=!1,this._featureMap=new ca,this._bufferOffset=0;};function Pa(t,e){return {"text-opacity":["opacity"],"icon-opacity":["opacity"],"text-color":["fill_color"],"icon-color":["fill_color"],"text-halo-color":["halo_color"],"icon-halo-color":["halo_color"],"text-halo-blur":["halo_blur"],"icon-halo-blur":["halo_blur"],"text-halo-width":["halo_width"],"icon-halo-width":["halo_width"],"line-gap-width":["gapwidth"],"line-pattern":["pattern_to","pattern_from","pixel_ratio_to","pixel_ratio_from"],"fill-pattern":["pattern_to","pattern_from","pixel_ratio_to","pixel_ratio_from"],"fill-extrusion-pattern":["pattern_to","pattern_from","pixel_ratio_to","pixel_ratio_from"]}[t]||[t.replace(e+"-","").replace(/-/g,"_")]}function Ba(t,e,r){var n={color:{source:Gi,composite:Zi},number:{source:Ui,composite:Gi}},i=function(t){return {"line-pattern":{source:Mi,composite:Mi},"fill-pattern":{source:Mi,composite:Mi},"fill-extrusion-pattern":{source:Mi,composite:Mi}}[t]}(t);return i&&i[r]||n[e][r]}Ta.prototype.populatePaintArrays=function(t,e,r,n,i,a){for(var o in this.programConfigurations)this.programConfigurations[o].populatePaintArrays(t,e,n,i,a);void 0!==e.id&&this._featureMap.add(e.id,r,this._bufferOffset,t),this._bufferOffset=t,this.needsUpload=!0;},Ta.prototype.updatePaintArrays=function(t,e,r,n){for(var i=0,a=r;i<a.length;i+=1){var o=a[i];this.needsUpload=this.programConfigurations[o.id].updatePaintArrays(t,this._featureMap,e,o,n)||this.needsUpload;}},Ta.prototype.get=function(t){return this.programConfigurations[t]},Ta.prototype.upload=function(t){if(this.needsUpload){for(var e in this.programConfigurations)this.programConfigurations[e].upload(t);this.needsUpload=!1;}},Ta.prototype.destroy=function(){for(var t in this.programConfigurations)this.programConfigurations[t].destroy();},Fn("ConstantBinder",ka),Fn("CrossFadedConstantBinder",Ia),Fn("SourceExpressionBinder",za),Fn("CrossFadedCompositeBinder",Ma),Fn("CompositeExpressionBinder",Ca),Fn("ProgramConfiguration",Ea,{omit:["_buffers"]}),Fn("ProgramConfigurationSet",Ta);var Va={min:-1*Math.pow(2,14),max:Math.pow(2,14)-1};function Fa(t){for(var e=8192/t.extent,r=t.loadGeometry(),n=0;n<r.length;n++)for(var i=r[n],a=0;a<i.length;a++){var o=i[a];o.x=Math.round(o.x*e),o.y=Math.round(o.y*e),(o.x<Va.min||o.x>Va.max||o.y<Va.min||o.y>Va.max)&&(w("Geometry exceeds allowed extent, reduce your vector tile buffer size"),o.x=u(o.x,Va.min,Va.max),o.y=u(o.y,Va.min,Va.max));}return r}function Da(t,e,r,n,i){t.emplaceBack(2*e+(n+1)/2,2*r+(i+1)/2);}var La=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new ki,this.indexArray=new Li,this.segments=new ia,this.programConfigurations=new Ta(na,t.layers,t.zoom),this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};function Ra(t,e){for(var r=0;r<t.length;r++)if(Xa(e,t[r]))return !0;for(var n=0;n<e.length;n++)if(Xa(t,e[n]))return !0;return !!qa(t,e)}function Oa(t,e,r){return !!Xa(t,e)||!!Ka(e,t,r)}function Ua(t,e){if(1===t.length)return Za(e,t[0]);for(var r=0;r<e.length;r++)for(var n=e[r],i=0;i<n.length;i++)if(Xa(t,n[i]))return !0;for(var a=0;a<t.length;a++)if(Za(e,t[a]))return !0;for(var o=0;o<e.length;o++)if(qa(t,e[o]))return !0;return !1}function ja(t,e,r){if(t.length>1){if(qa(t,e))return !0;for(var n=0;n<e.length;n++)if(Ka(e[n],t,r))return !0}for(var i=0;i<t.length;i++)if(Ka(t[i],e,r))return !0;return !1}function qa(t,e){if(0===t.length||0===e.length)return !1;for(var r=0;r<t.length-1;r++)for(var n=t[r],i=t[r+1],a=0;a<e.length-1;a++)if(Na(n,i,e[a],e[a+1]))return !0;return !1}function Na(t,e,r,n){return _(t,r,n)!==_(e,r,n)&&_(t,e,r)!==_(t,e,n)}function Ka(t,e,r){var n=r*r;if(1===e.length)return t.distSqr(e[0])<n;for(var i=1;i<e.length;i++)if(Ga(t,e[i-1],e[i])<n)return !0;return !1}function Ga(t,e,r){var n=e.distSqr(r);if(0===n)return t.distSqr(e);var i=((t.x-e.x)*(r.x-e.x)+(t.y-e.y)*(r.y-e.y))/n;return t.distSqr(i<0?e:i>1?r:r.sub(e)._mult(i)._add(e))}function Za(t,e){for(var r,n,i,a=!1,o=0;o<t.length;o++)for(var s=0,u=(r=t[o]).length-1;s<r.length;u=s++)(n=r[s]).y>e.y!=(i=r[u]).y>e.y&&e.x<(i.x-n.x)*(e.y-n.y)/(i.y-n.y)+n.x&&(a=!a);return a}function Xa(t,e){for(var r=!1,n=0,i=t.length-1;n<t.length;i=n++){var a=t[n],o=t[i];a.y>e.y!=o.y>e.y&&e.x<(o.x-a.x)*(e.y-a.y)/(o.y-a.y)+a.x&&(r=!r);}return r}function Ja(t,e,r){var n=r[0],i=r[2];if(t.x<n.x&&e.x<n.x||t.x>i.x&&e.x>i.x||t.y<n.y&&e.y<n.y||t.y>i.y&&e.y>i.y)return !1;var a=_(t,e,r[0]);return a!==_(t,e,r[1])||a!==_(t,e,r[2])||a!==_(t,e,r[3])}function Ha(t,e,r){var n=e.paint.get(t).value;return "constant"===n.kind?n.value:r.programConfigurations.get(e.id).getMaxValue(t)}function Ya(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])}function $a(t,e,r,n,a){if(!e[0]&&!e[1])return t;var o=i.convert(e)._mult(a);"viewport"===r&&o._rotate(-n);for(var s=[],u=0;u<t.length;u++)s.push(t[u].sub(o));return s}La.prototype.populate=function(t,e,r){var n=this.layers[0],i=[],a=null;"circle"===n.type&&(a=n.layout.get("circle-sort-key"));for(var o=0,s=t;o<s.length;o+=1){var u=s[o],l=u.feature,p=u.id,c=u.index,h=u.sourceLayerIndex,f=this.layers[0]._featureFilter.needGeometry,y={type:l.type,id:p,properties:l.properties,geometry:f?Fa(l):[]};if(this.layers[0]._featureFilter.filter(new ii(this.zoom),y,r)){f||(y.geometry=Fa(l));var d=a?a.evaluate(y,{},r):void 0;i.push({id:p,properties:l.properties,type:l.type,sourceLayerIndex:h,index:c,geometry:y.geometry,patterns:{},sortKey:d});}}a&&i.sort((function(t,e){return t.sortKey-e.sortKey}));for(var m=0,v=i;m<v.length;m+=1){var g=v[m],x=g.geometry,b=g.index,w=g.sourceLayerIndex,_=t[b].feature;this.addFeature(g,x,b,r),e.featureIndex.insert(_,x,b,w,this.index);}},La.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},La.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},La.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},La.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,na),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},La.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},La.prototype.addFeature=function(t,e,r,n){for(var i=0,a=e;i<a.length;i+=1)for(var o=0,s=a[i];o<s.length;o+=1){var u=s[o],l=u.x,p=u.y;if(!(l<0||l>=8192||p<0||p>=8192)){var c=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray,t.sortKey),h=c.vertexLength;Da(this.layoutVertexArray,l,p,-1,-1),Da(this.layoutVertexArray,l,p,1,-1),Da(this.layoutVertexArray,l,p,1,1),Da(this.layoutVertexArray,l,p,-1,1),this.indexArray.emplaceBack(h,h+1,h+2),this.indexArray.emplaceBack(h,h+3,h+2),c.vertexLength+=4,c.primitiveLength+=2;}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,{},n);},Fn("CircleBucket",La,{omit:["layers"]});var Wa=new gi({"circle-sort-key":new yi(It.layout_circle["circle-sort-key"])}),Qa={paint:new gi({"circle-radius":new yi(It.paint_circle["circle-radius"]),"circle-color":new yi(It.paint_circle["circle-color"]),"circle-blur":new yi(It.paint_circle["circle-blur"]),"circle-opacity":new yi(It.paint_circle["circle-opacity"]),"circle-translate":new fi(It.paint_circle["circle-translate"]),"circle-translate-anchor":new fi(It.paint_circle["circle-translate-anchor"]),"circle-pitch-scale":new fi(It.paint_circle["circle-pitch-scale"]),"circle-pitch-alignment":new fi(It.paint_circle["circle-pitch-alignment"]),"circle-stroke-width":new yi(It.paint_circle["circle-stroke-width"]),"circle-stroke-color":new yi(It.paint_circle["circle-stroke-color"]),"circle-stroke-opacity":new yi(It.paint_circle["circle-stroke-opacity"])}),layout:Wa},to="undefined"!=typeof Float32Array?Float32Array:Array;function eo(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t}function ro(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],c=e[8],h=e[9],f=e[10],y=e[11],d=e[12],m=e[13],v=e[14],g=e[15],x=r[0],b=r[1],w=r[2],_=r[3];return t[0]=x*n+b*s+w*c+_*d,t[1]=x*i+b*u+w*h+_*m,t[2]=x*a+b*l+w*f+_*v,t[3]=x*o+b*p+w*y+_*g,t[4]=(x=r[4])*n+(b=r[5])*s+(w=r[6])*c+(_=r[7])*d,t[5]=x*i+b*u+w*h+_*m,t[6]=x*a+b*l+w*f+_*v,t[7]=x*o+b*p+w*y+_*g,t[8]=(x=r[8])*n+(b=r[9])*s+(w=r[10])*c+(_=r[11])*d,t[9]=x*i+b*u+w*h+_*m,t[10]=x*a+b*l+w*f+_*v,t[11]=x*o+b*p+w*y+_*g,t[12]=(x=r[12])*n+(b=r[13])*s+(w=r[14])*c+(_=r[15])*d,t[13]=x*i+b*u+w*h+_*m,t[14]=x*a+b*l+w*f+_*v,t[15]=x*o+b*p+w*y+_*g,t}Math.hypot||(Math.hypot=function(){for(var t=arguments,e=0,r=arguments.length;r--;)e+=t[r]*t[r];return Math.sqrt(e)});var no,io=ro;function ao(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3];return t[0]=r[0]*n+r[4]*i+r[8]*a+r[12]*o,t[1]=r[1]*n+r[5]*i+r[9]*a+r[13]*o,t[2]=r[2]*n+r[6]*i+r[10]*a+r[14]*o,t[3]=r[3]*n+r[7]*i+r[11]*a+r[15]*o,t}no=new to(3),to!=Float32Array&&(no[0]=0,no[1]=0,no[2]=0),function(){var t=new to(4);to!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0,t[3]=0);}();var oo=(function(){var t=new to(2);to!=Float32Array&&(t[0]=0,t[1]=0);}(),function(t){function e(e){t.call(this,e,Qa);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.createBucket=function(t){return new La(t)},e.prototype.queryRadius=function(t){var e=t;return Ha("circle-radius",this,e)+Ha("circle-stroke-width",this,e)+Ya(this.paint.get("circle-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o,s){for(var u=$a(t,this.paint.get("circle-translate"),this.paint.get("circle-translate-anchor"),a.angle,o),l=this.paint.get("circle-radius").evaluate(e,r)+this.paint.get("circle-stroke-width").evaluate(e,r),p="map"===this.paint.get("circle-pitch-alignment"),c=p?u:function(t,e){return t.map((function(t){return so(t,e)}))}(u,s),h=p?l*o:l,f=0,y=n;f<y.length;f+=1)for(var d=0,m=y[f];d<m.length;d+=1){var v=m[d],g=p?v:so(v,s),x=h,b=ao([],[v.x,v.y,0,1],s);if("viewport"===this.paint.get("circle-pitch-scale")&&"map"===this.paint.get("circle-pitch-alignment")?x*=b[3]/a.cameraToCenterDistance:"map"===this.paint.get("circle-pitch-scale")&&"viewport"===this.paint.get("circle-pitch-alignment")&&(x*=a.cameraToCenterDistance/b[3]),Oa(c,g,x))return !0}return !1},e}(xi));function so(t,e){var r=ao([],[t.x,t.y,0,1],e);return new i(r[0]/r[3],r[1]/r[3])}var uo=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e}(La);function lo(t,e,r,n){var i=e.width,a=e.height;if(n){if(n instanceof Uint8ClampedArray)n=new Uint8Array(n.buffer);else if(n.length!==i*a*r)throw new RangeError("mismatched image size")}else n=new Uint8Array(i*a*r);return t.width=i,t.height=a,t.data=n,t}function po(t,e,r){var n=e.width,i=e.height;if(n!==t.width||i!==t.height){var a=lo({},{width:n,height:i},r);co(t,a,{x:0,y:0},{x:0,y:0},{width:Math.min(t.width,n),height:Math.min(t.height,i)},r),t.width=n,t.height=i,t.data=a.data;}}function co(t,e,r,n,i,a){if(0===i.width||0===i.height)return e;if(i.width>t.width||i.height>t.height||r.x>t.width-i.width||r.y>t.height-i.height)throw new RangeError("out of range source coordinates for image copy");if(i.width>e.width||i.height>e.height||n.x>e.width-i.width||n.y>e.height-i.height)throw new RangeError("out of range destination coordinates for image copy");for(var o=t.data,s=e.data,u=0;u<i.height;u++)for(var l=((r.y+u)*t.width+r.x)*a,p=((n.y+u)*e.width+n.x)*a,c=0;c<i.width*a;c++)s[p+c]=o[l+c];return e}Fn("HeatmapBucket",uo,{omit:["layers"]});var ho=function(t,e){lo(this,t,1,e);};ho.prototype.resize=function(t){po(this,t,1);},ho.prototype.clone=function(){return new ho({width:this.width,height:this.height},new Uint8Array(this.data))},ho.copy=function(t,e,r,n,i){co(t,e,r,n,i,1);};var fo=function(t,e){lo(this,t,4,e);};fo.prototype.resize=function(t){po(this,t,4);},fo.prototype.replace=function(t,e){e?this.data.set(t):this.data=t instanceof Uint8ClampedArray?new Uint8Array(t.buffer):t;},fo.prototype.clone=function(){return new fo({width:this.width,height:this.height},new Uint8Array(this.data))},fo.copy=function(t,e,r,n,i){co(t,e,r,n,i,4);},Fn("AlphaImage",ho),Fn("RGBAImage",fo);var yo={paint:new gi({"heatmap-radius":new yi(It.paint_heatmap["heatmap-radius"]),"heatmap-weight":new yi(It.paint_heatmap["heatmap-weight"]),"heatmap-intensity":new fi(It.paint_heatmap["heatmap-intensity"]),"heatmap-color":new vi(It.paint_heatmap["heatmap-color"]),"heatmap-opacity":new fi(It.paint_heatmap["heatmap-opacity"])})};function mo(t,e){for(var r=new Uint8Array(1024),n={},i=0,a=0;i<256;i++,a+=4){n[e]=i/255;var o=t.evaluate(n);r[a+0]=Math.floor(255*o.r/o.a),r[a+1]=Math.floor(255*o.g/o.a),r[a+2]=Math.floor(255*o.b/o.a),r[a+3]=Math.floor(255*o.a);}return new fo({width:256,height:1},r)}var vo=function(t){function e(e){t.call(this,e,yo),this._updateColorRamp();}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.createBucket=function(t){return new uo(t)},e.prototype._handleSpecialPaintPropertyUpdate=function(t){"heatmap-color"===t&&this._updateColorRamp();},e.prototype._updateColorRamp=function(){this.colorRamp=mo(this._transitionablePaint._values["heatmap-color"].value.expression,"heatmapDensity"),this.colorRampTexture=null;},e.prototype.resize=function(){this.heatmapFbo&&(this.heatmapFbo.destroy(),this.heatmapFbo=null);},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("heatmap-opacity")&&"none"!==this.visibility},e}(xi),go={paint:new gi({"hillshade-illumination-direction":new fi(It.paint_hillshade["hillshade-illumination-direction"]),"hillshade-illumination-anchor":new fi(It.paint_hillshade["hillshade-illumination-anchor"]),"hillshade-exaggeration":new fi(It.paint_hillshade["hillshade-exaggeration"]),"hillshade-shadow-color":new fi(It.paint_hillshade["hillshade-shadow-color"]),"hillshade-highlight-color":new fi(It.paint_hillshade["hillshade-highlight-color"]),"hillshade-accent-color":new fi(It.paint_hillshade["hillshade-accent-color"])})},xo=function(t){function e(e){t.call(this,e,go);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("hillshade-exaggeration")&&"none"!==this.visibility},e}(xi),bo=Ai([{name:"a_pos",components:2,type:"Int16"}],4).members,wo=Ao,_o=Ao;function Ao(t,e,r){r=r||2;var n,i,a,o,s,u,l,p=e&&e.length,c=p?e[0]*r:t.length,h=So(t,0,c,r,!0),f=[];if(!h||h.next===h.prev)return f;if(p&&(h=function(t,e,r,n){var i,a,o,s=[];for(i=0,a=e.length;i<a;i++)(o=So(t,e[i]*n,i<a-1?e[i+1]*n:t.length,n,!1))===o.next&&(o.steiner=!0),s.push(Fo(o));for(s.sort(To),i=0;i<s.length;i++)Po(s[i],r),r=ko(r,r.next);return r}(t,e,h,r)),t.length>80*r){n=a=t[0],i=o=t[1];for(var y=r;y<c;y+=r)(s=t[y])<n&&(n=s),(u=t[y+1])<i&&(i=u),s>a&&(a=s),u>o&&(o=u);l=0!==(l=Math.max(a-n,o-i))?1/l:0;}return Io(h,f,r,n,i,l),f}function So(t,e,r,n,i){var a,o;if(i===Jo(t,e,r,n)>0)for(a=e;a<r;a+=n)o=Go(a,t[a],t[a+1],o);else for(a=r-n;a>=e;a-=n)o=Go(a,t[a],t[a+1],o);return o&&Oo(o,o.next)&&(Zo(o),o=o.next),o}function ko(t,e){if(!t)return t;e||(e=t);var r,n=t;do{if(r=!1,n.steiner||!Oo(n,n.next)&&0!==Ro(n.prev,n,n.next))n=n.next;else {if(Zo(n),(n=e=n.prev)===n.next)break;r=!0;}}while(r||n!==e);return e}function Io(t,e,r,n,i,a,o){if(t){!o&&a&&function(t,e,r,n){var i=t;do{null===i.z&&(i.z=Vo(i.x,i.y,e,r,n)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next;}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){var e,r,n,i,a,o,s,u,l=1;do{for(r=t,t=null,a=null,o=0;r;){for(o++,n=r,s=0,e=0;e<l&&(s++,n=n.nextZ);e++);for(u=l;s>0||u>0&&n;)0!==s&&(0===u||!n||r.z<=n.z)?(i=r,r=r.nextZ,s--):(i=n,n=n.nextZ,u--),a?a.nextZ=i:t=i,i.prevZ=a,a=i;r=n;}a.nextZ=null,l*=2;}while(o>1)}(i);}(t,n,i,a);for(var s,u,l=t;t.prev!==t.next;)if(s=t.prev,u=t.next,a?Co(t,n,i,a):zo(t))e.push(s.i/r),e.push(t.i/r),e.push(u.i/r),Zo(t),t=u.next,l=u.next;else if((t=u)===l){o?1===o?Io(t=Mo(ko(t),e,r),e,r,n,i,a,2):2===o&&Eo(t,e,r,n,i,a):Io(ko(t),e,r,n,i,a,1);break}}}function zo(t){var e=t.prev,r=t,n=t.next;if(Ro(e,r,n)>=0)return !1;for(var i=t.next.next;i!==t.prev;){if(Do(e.x,e.y,r.x,r.y,n.x,n.y,i.x,i.y)&&Ro(i.prev,i,i.next)>=0)return !1;i=i.next;}return !0}function Co(t,e,r,n){var i=t.prev,a=t,o=t.next;if(Ro(i,a,o)>=0)return !1;for(var s=i.x>a.x?i.x>o.x?i.x:o.x:a.x>o.x?a.x:o.x,u=i.y>a.y?i.y>o.y?i.y:o.y:a.y>o.y?a.y:o.y,l=Vo(i.x<a.x?i.x<o.x?i.x:o.x:a.x<o.x?a.x:o.x,i.y<a.y?i.y<o.y?i.y:o.y:a.y<o.y?a.y:o.y,e,r,n),p=Vo(s,u,e,r,n),c=t.prevZ,h=t.nextZ;c&&c.z>=l&&h&&h.z<=p;){if(c!==t.prev&&c!==t.next&&Do(i.x,i.y,a.x,a.y,o.x,o.y,c.x,c.y)&&Ro(c.prev,c,c.next)>=0)return !1;if(c=c.prevZ,h!==t.prev&&h!==t.next&&Do(i.x,i.y,a.x,a.y,o.x,o.y,h.x,h.y)&&Ro(h.prev,h,h.next)>=0)return !1;h=h.nextZ;}for(;c&&c.z>=l;){if(c!==t.prev&&c!==t.next&&Do(i.x,i.y,a.x,a.y,o.x,o.y,c.x,c.y)&&Ro(c.prev,c,c.next)>=0)return !1;c=c.prevZ;}for(;h&&h.z<=p;){if(h!==t.prev&&h!==t.next&&Do(i.x,i.y,a.x,a.y,o.x,o.y,h.x,h.y)&&Ro(h.prev,h,h.next)>=0)return !1;h=h.nextZ;}return !0}function Mo(t,e,r){var n=t;do{var i=n.prev,a=n.next.next;!Oo(i,a)&&Uo(i,n,n.next,a)&&No(i,a)&&No(a,i)&&(e.push(i.i/r),e.push(n.i/r),e.push(a.i/r),Zo(n),Zo(n.next),n=t=a),n=n.next;}while(n!==t);return ko(n)}function Eo(t,e,r,n,i,a){var o=t;do{for(var s=o.next.next;s!==o.prev;){if(o.i!==s.i&&Lo(o,s)){var u=Ko(o,s);return o=ko(o,o.next),u=ko(u,u.next),Io(o,e,r,n,i,a),void Io(u,e,r,n,i,a)}s=s.next;}o=o.next;}while(o!==t)}function To(t,e){return t.x-e.x}function Po(t,e){if(e=function(t,e){var r,n=e,i=t.x,a=t.y,o=-1/0;do{if(a<=n.y&&a>=n.next.y&&n.next.y!==n.y){var s=n.x+(a-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(s<=i&&s>o){if(o=s,s===i){if(a===n.y)return n;if(a===n.next.y)return n.next}r=n.x<n.next.x?n:n.next;}}n=n.next;}while(n!==e);if(!r)return null;if(i===o)return r;var u,l=r,p=r.x,c=r.y,h=1/0;n=r;do{i>=n.x&&n.x>=p&&i!==n.x&&Do(a<c?i:o,a,p,c,a<c?o:i,a,n.x,n.y)&&(u=Math.abs(a-n.y)/(i-n.x),No(n,t)&&(u<h||u===h&&(n.x>r.x||n.x===r.x&&Bo(r,n)))&&(r=n,h=u)),n=n.next;}while(n!==l);return r}(t,e)){var r=Ko(e,t);ko(e,e.next),ko(r,r.next);}}function Bo(t,e){return Ro(t.prev,t,e.prev)<0&&Ro(e.next,t,t.next)<0}function Vo(t,e,r,n,i){return (t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=32767*(t-r)*i)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=32767*(e-n)*i)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function Fo(t){var e=t,r=t;do{(e.x<r.x||e.x===r.x&&e.y<r.y)&&(r=e),e=e.next;}while(e!==t);return r}function Do(t,e,r,n,i,a,o,s){return (i-o)*(e-s)-(t-o)*(a-s)>=0&&(t-o)*(n-s)-(r-o)*(e-s)>=0&&(r-o)*(a-s)-(i-o)*(n-s)>=0}function Lo(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){var r=t;do{if(r.i!==t.i&&r.next.i!==t.i&&r.i!==e.i&&r.next.i!==e.i&&Uo(r,r.next,t,e))return !0;r=r.next;}while(r!==t);return !1}(t,e)&&(No(t,e)&&No(e,t)&&function(t,e){var r=t,n=!1,i=(t.x+e.x)/2,a=(t.y+e.y)/2;do{r.y>a!=r.next.y>a&&r.next.y!==r.y&&i<(r.next.x-r.x)*(a-r.y)/(r.next.y-r.y)+r.x&&(n=!n),r=r.next;}while(r!==t);return n}(t,e)&&(Ro(t.prev,t,e.prev)||Ro(t,e.prev,e))||Oo(t,e)&&Ro(t.prev,t,t.next)>0&&Ro(e.prev,e,e.next)>0)}function Ro(t,e,r){return (e.y-t.y)*(r.x-e.x)-(e.x-t.x)*(r.y-e.y)}function Oo(t,e){return t.x===e.x&&t.y===e.y}function Uo(t,e,r,n){var i=qo(Ro(t,e,r)),a=qo(Ro(t,e,n)),o=qo(Ro(r,n,t)),s=qo(Ro(r,n,e));return i!==a&&o!==s||!(0!==i||!jo(t,r,e))||!(0!==a||!jo(t,n,e))||!(0!==o||!jo(r,t,n))||!(0!==s||!jo(r,e,n))}function jo(t,e,r){return e.x<=Math.max(t.x,r.x)&&e.x>=Math.min(t.x,r.x)&&e.y<=Math.max(t.y,r.y)&&e.y>=Math.min(t.y,r.y)}function qo(t){return t>0?1:t<0?-1:0}function No(t,e){return Ro(t.prev,t,t.next)<0?Ro(t,e,t.next)>=0&&Ro(t,t.prev,e)>=0:Ro(t,e,t.prev)<0||Ro(t,t.next,e)<0}function Ko(t,e){var r=new Xo(t.i,t.x,t.y),n=new Xo(e.i,e.x,e.y),i=t.next,a=e.prev;return t.next=e,e.prev=t,r.next=i,i.prev=r,n.next=r,r.prev=n,a.next=n,n.prev=a,n}function Go(t,e,r,n){var i=new Xo(t,e,r);return n?(i.next=n.next,i.prev=n,n.next.prev=i,n.next=i):(i.prev=i,i.next=i),i}function Zo(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ);}function Xo(t,e,r){this.i=t,this.x=e,this.y=r,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1;}function Jo(t,e,r,n){for(var i=0,a=e,o=r-n;a<r;a+=n)i+=(t[o]-t[a])*(t[a+1]+t[o+1]),o=a;return i}function Ho(t,e,r,n,i){!function t(e,r,n,i,a){for(;i>n;){if(i-n>600){var o=i-n+1,s=r-n+1,u=Math.log(o),l=.5*Math.exp(2*u/3),p=.5*Math.sqrt(u*l*(o-l)/o)*(s-o/2<0?-1:1);t(e,r,Math.max(n,Math.floor(r-s*l/o+p)),Math.min(i,Math.floor(r+(o-s)*l/o+p)),a);}var c=e[r],h=n,f=i;for(Yo(e,n,r),a(e[i],c)>0&&Yo(e,n,i);h<f;){for(Yo(e,h,f),h++,f--;a(e[h],c)<0;)h++;for(;a(e[f],c)>0;)f--;}0===a(e[n],c)?Yo(e,n,f):Yo(e,++f,i),f<=r&&(n=f+1),r<=f&&(i=f-1);}}(t,e,r||0,n||t.length-1,i||$o);}function Yo(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}function $o(t,e){return t<e?-1:t>e?1:0}function Wo(t,e){var r=t.length;if(r<=1)return [t];for(var n,i,a=[],o=0;o<r;o++){var s=A(t[o]);0!==s&&(t[o].area=Math.abs(s),void 0===i&&(i=s<0),i===s<0?(n&&a.push(n),n=[t[o]]):n.push(t[o]));}if(n&&a.push(n),e>1)for(var u=0;u<a.length;u++)a[u].length<=e||(Ho(a[u],e,1,a[u].length-1,Qo),a[u]=a[u].slice(0,e));return a}function Qo(t,e){return e.area-t.area}function ts(t,e,r){for(var n=r.patternDependencies,i=!1,a=0,o=e;a<o.length;a+=1){var s=o[a].paint.get(t+"-pattern");s.isConstant()||(i=!0);var u=s.constantOr(null);u&&(i=!0,n[u.to]=!0,n[u.from]=!0);}return i}function es(t,e,r,n,i){for(var a=i.patternDependencies,o=0,s=e;o<s.length;o+=1){var u=s[o],l=u.paint.get(t+"-pattern").value;if("constant"!==l.kind){var p=l.evaluate({zoom:n-1},r,{},i.availableImages),c=l.evaluate({zoom:n},r,{},i.availableImages),h=l.evaluate({zoom:n+1},r,{},i.availableImages);c=c&&c.name?c.name:c,h=h&&h.name?h.name:h,a[p=p&&p.name?p.name:p]=!0,a[c]=!0,a[h]=!0,r.patterns[u.id]={min:p,mid:c,max:h};}}return r}Ao.deviation=function(t,e,r,n){var i=e&&e.length,a=Math.abs(Jo(t,0,i?e[0]*r:t.length,r));if(i)for(var o=0,s=e.length;o<s;o++)a-=Math.abs(Jo(t,e[o]*r,o<s-1?e[o+1]*r:t.length,r));var u=0;for(o=0;o<n.length;o+=3){var l=n[o]*r,p=n[o+1]*r,c=n[o+2]*r;u+=Math.abs((t[l]-t[c])*(t[p+1]-t[l+1])-(t[l]-t[p])*(t[c+1]-t[l+1]));}return 0===a&&0===u?0:Math.abs((u-a)/a)},Ao.flatten=function(t){for(var e=t[0][0].length,r={vertices:[],holes:[],dimensions:e},n=0,i=0;i<t.length;i++){for(var a=0;a<t[i].length;a++)for(var o=0;o<e;o++)r.vertices.push(t[i][a][o]);i>0&&r.holes.push(n+=t[i-1].length);}return r},wo.default=_o;var rs=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.layoutVertexArray=new ki,this.indexArray=new Li,this.indexArray2=new Ni,this.programConfigurations=new Ta(bo,t.layers,t.zoom),this.segments=new ia,this.segments2=new ia,this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};rs.prototype.populate=function(t,e,r){this.hasPattern=ts("fill",this.layers,e);for(var n=this.layers[0].layout.get("fill-sort-key"),i=[],a=0,o=t;a<o.length;a+=1){var s=o[a],u=s.feature,l=s.id,p=s.index,c=s.sourceLayerIndex,h=this.layers[0]._featureFilter.needGeometry,f={type:u.type,id:l,properties:u.properties,geometry:h?Fa(u):[]};if(this.layers[0]._featureFilter.filter(new ii(this.zoom),f,r)){h||(f.geometry=Fa(u));var y=n?n.evaluate(f,{},r,e.availableImages):void 0;i.push({id:l,properties:u.properties,type:u.type,sourceLayerIndex:c,index:p,geometry:f.geometry,patterns:{},sortKey:y});}}n&&i.sort((function(t,e){return t.sortKey-e.sortKey}));for(var d=0,m=i;d<m.length;d+=1){var v=m[d],g=v.geometry,x=v.index,b=v.sourceLayerIndex;if(this.hasPattern){var w=es("fill",this.layers,v,this.zoom,e);this.patternFeatures.push(w);}else this.addFeature(v,g,x,r,{});e.featureIndex.insert(t[x].feature,g,x,b,this.index);}},rs.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},rs.prototype.addFeatures=function(t,e,r){for(var n=0,i=this.patternFeatures;n<i.length;n+=1){var a=i[n];this.addFeature(a,a.geometry,a.index,e,r);}},rs.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},rs.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},rs.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,bo),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.indexBuffer2=t.createIndexBuffer(this.indexArray2)),this.programConfigurations.upload(t),this.uploaded=!0;},rs.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.indexBuffer2.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.segments2.destroy());},rs.prototype.addFeature=function(t,e,r,n,i){for(var a=0,o=Wo(e,500);a<o.length;a+=1){for(var s=o[a],u=0,l=0,p=s;l<p.length;l+=1)u+=p[l].length;for(var c=this.segments.prepareSegment(u,this.layoutVertexArray,this.indexArray),h=c.vertexLength,f=[],y=[],d=0,m=s;d<m.length;d+=1){var v=m[d];if(0!==v.length){v!==s[0]&&y.push(f.length/2);var g=this.segments2.prepareSegment(v.length,this.layoutVertexArray,this.indexArray2),x=g.vertexLength;this.layoutVertexArray.emplaceBack(v[0].x,v[0].y),this.indexArray2.emplaceBack(x+v.length-1,x),f.push(v[0].x),f.push(v[0].y);for(var b=1;b<v.length;b++)this.layoutVertexArray.emplaceBack(v[b].x,v[b].y),this.indexArray2.emplaceBack(x+b-1,x+b),f.push(v[b].x),f.push(v[b].y);g.vertexLength+=v.length,g.primitiveLength+=v.length;}}for(var w=wo(f,y),_=0;_<w.length;_+=3)this.indexArray.emplaceBack(h+w[_],h+w[_+1],h+w[_+2]);c.vertexLength+=u,c.primitiveLength+=w.length/3;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,i,n);},Fn("FillBucket",rs,{omit:["layers","patternFeatures"]});var ns=new gi({"fill-sort-key":new yi(It.layout_fill["fill-sort-key"])}),is={paint:new gi({"fill-antialias":new fi(It.paint_fill["fill-antialias"]),"fill-opacity":new yi(It.paint_fill["fill-opacity"]),"fill-color":new yi(It.paint_fill["fill-color"]),"fill-outline-color":new yi(It.paint_fill["fill-outline-color"]),"fill-translate":new fi(It.paint_fill["fill-translate"]),"fill-translate-anchor":new fi(It.paint_fill["fill-translate-anchor"]),"fill-pattern":new di(It.paint_fill["fill-pattern"])}),layout:ns},as=function(t){function e(e){t.call(this,e,is);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.recalculate=function(e,r){t.prototype.recalculate.call(this,e,r);var n=this.paint._values["fill-outline-color"];"constant"===n.value.kind&&void 0===n.value.value&&(this.paint._values["fill-outline-color"]=this.paint._values["fill-color"]);},e.prototype.createBucket=function(t){return new rs(t)},e.prototype.queryRadius=function(){return Ya(this.paint.get("fill-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o){return Ua($a(t,this.paint.get("fill-translate"),this.paint.get("fill-translate-anchor"),a.angle,o),n)},e.prototype.isTileClipped=function(){return !0},e}(xi),os=Ai([{name:"a_pos",components:2,type:"Int16"},{name:"a_normal_ed",components:4,type:"Int16"}],4).members,ss=us;function us(t,e,r,n,i){this.properties={},this.extent=r,this.type=0,this._pbf=t,this._geometry=-1,this._keys=n,this._values=i,t.readFields(ls,this,e);}function ls(t,e,r){1==t?e.id=r.readVarint():2==t?function(t,e){for(var r=t.readVarint()+t.pos;t.pos<r;){var n=e._keys[t.readVarint()],i=e._values[t.readVarint()];e.properties[n]=i;}}(r,e):3==t?e.type=r.readVarint():4==t&&(e._geometry=r.pos);}function ps(t){for(var e,r,n=0,i=0,a=t.length,o=a-1;i<a;o=i++)n+=((r=t[o]).x-(e=t[i]).x)*(e.y+r.y);return n}us.types=["Unknown","Point","LineString","Polygon"],us.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,r=t.readVarint()+t.pos,n=1,a=0,o=0,s=0,u=[];t.pos<r;){if(a<=0){var l=t.readVarint();n=7&l,a=l>>3;}if(a--,1===n||2===n)o+=t.readSVarint(),s+=t.readSVarint(),1===n&&(e&&u.push(e),e=[]),e.push(new i(o,s));else {if(7!==n)throw new Error("unknown command "+n);e&&e.push(e[0].clone());}}return e&&u.push(e),u},us.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e=t.readVarint()+t.pos,r=1,n=0,i=0,a=0,o=1/0,s=-1/0,u=1/0,l=-1/0;t.pos<e;){if(n<=0){var p=t.readVarint();r=7&p,n=p>>3;}if(n--,1===r||2===r)(i+=t.readSVarint())<o&&(o=i),i>s&&(s=i),(a+=t.readSVarint())<u&&(u=a),a>l&&(l=a);else if(7!==r)throw new Error("unknown command "+r)}return [o,u,s,l]},us.prototype.toGeoJSON=function(t,e,r){var n,i,a=this.extent*Math.pow(2,r),o=this.extent*t,s=this.extent*e,u=this.loadGeometry(),l=us.types[this.type];function p(t){for(var e=0;e<t.length;e++){var r=t[e];t[e]=[360*(r.x+o)/a-180,360/Math.PI*Math.atan(Math.exp((180-360*(r.y+s)/a)*Math.PI/180))-90];}}switch(this.type){case 1:var c=[];for(n=0;n<u.length;n++)c[n]=u[n][0];p(u=c);break;case 2:for(n=0;n<u.length;n++)p(u[n]);break;case 3:for(u=function(t){var e=t.length;if(e<=1)return [t];for(var r,n,i=[],a=0;a<e;a++){var o=ps(t[a]);0!==o&&(void 0===n&&(n=o<0),n===o<0?(r&&i.push(r),r=[t[a]]):r.push(t[a]));}return r&&i.push(r),i}(u),n=0;n<u.length;n++)for(i=0;i<u[n].length;i++)p(u[n][i]);}1===u.length?u=u[0]:l="Multi"+l;var h={type:"Feature",geometry:{type:l,coordinates:u},properties:this.properties};return "id"in this&&(h.id=this.id),h};var cs=hs;function hs(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(fs,this,e),this.length=this._features.length;}function fs(t,e,r){15===t?e.version=r.readVarint():1===t?e.name=r.readString():5===t?e.extent=r.readVarint():2===t?e._features.push(r.pos):3===t?e._keys.push(r.readString()):4===t&&e._values.push(function(t){for(var e=null,r=t.readVarint()+t.pos;t.pos<r;){var n=t.readVarint()>>3;e=1===n?t.readString():2===n?t.readFloat():3===n?t.readDouble():4===n?t.readVarint64():5===n?t.readVarint():6===n?t.readSVarint():7===n?t.readBoolean():null;}return e}(r));}function ys(t,e,r){if(3===t){var n=new cs(r,r.readVarint()+r.pos);n.length&&(e[n.name]=n);}}hs.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[t];var e=this._pbf.readVarint()+this._pbf.pos;return new ss(this._pbf,e,this.extent,this._keys,this._values)};var ds={VectorTile:function(t,e){this.layers=t.readFields(ys,{},e);},VectorTileFeature:ss,VectorTileLayer:cs},ms=ds.VectorTileFeature.types,vs=Math.pow(2,13);function gs(t,e,r,n,i,a,o,s){t.emplaceBack(e,r,2*Math.floor(n*vs)+o,i*vs*2,a*vs*2,Math.round(s));}var xs=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new zi,this.indexArray=new Li,this.programConfigurations=new Ta(os,t.layers,t.zoom),this.segments=new ia,this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};function bs(t,e){return t.x===e.x&&(t.x<0||t.x>8192)||t.y===e.y&&(t.y<0||t.y>8192)}xs.prototype.populate=function(t,e,r){this.features=[],this.hasPattern=ts("fill-extrusion",this.layers,e);for(var n=0,i=t;n<i.length;n+=1){var a=i[n],o=a.feature,s=a.id,u=a.index,l=a.sourceLayerIndex,p=this.layers[0]._featureFilter.needGeometry,c={type:o.type,id:s,properties:o.properties,geometry:p?Fa(o):[]};if(this.layers[0]._featureFilter.filter(new ii(this.zoom),c,r)){var h={id:s,sourceLayerIndex:l,index:u,geometry:p?c.geometry:Fa(o),properties:o.properties,type:o.type,patterns:{}};void 0!==o.id&&(h.id=o.id),this.hasPattern?this.features.push(es("fill-extrusion",this.layers,h,this.zoom,e)):this.addFeature(h,h.geometry,u,r,{}),e.featureIndex.insert(o,h.geometry,u,l,this.index,!0);}}},xs.prototype.addFeatures=function(t,e,r){for(var n=0,i=this.features;n<i.length;n+=1){var a=i[n];this.addFeature(a,a.geometry,a.index,e,r);}},xs.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},xs.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},xs.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},xs.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,os),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},xs.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},xs.prototype.addFeature=function(t,e,r,n,i){for(var a=0,o=Wo(e,500);a<o.length;a+=1){for(var s=o[a],u=0,l=0,p=s;l<p.length;l+=1)u+=p[l].length;for(var c=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray),h=0,f=s;h<f.length;h+=1){var y=f[h];if(0!==y.length&&!((P=y).every((function(t){return t.x<0}))||P.every((function(t){return t.x>8192}))||P.every((function(t){return t.y<0}))||P.every((function(t){return t.y>8192}))))for(var d=0,m=0;m<y.length;m++){var v=y[m];if(m>=1){var g=y[m-1];if(!bs(v,g)){c.vertexLength+4>ia.MAX_VERTEX_ARRAY_LENGTH&&(c=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray));var x=v.sub(g)._perp()._unit(),b=g.dist(v);d+b>32768&&(d=0),gs(this.layoutVertexArray,v.x,v.y,x.x,x.y,0,0,d),gs(this.layoutVertexArray,v.x,v.y,x.x,x.y,0,1,d),gs(this.layoutVertexArray,g.x,g.y,x.x,x.y,0,0,d+=b),gs(this.layoutVertexArray,g.x,g.y,x.x,x.y,0,1,d);var w=c.vertexLength;this.indexArray.emplaceBack(w,w+2,w+1),this.indexArray.emplaceBack(w+1,w+2,w+3),c.vertexLength+=4,c.primitiveLength+=2;}}}}if(c.vertexLength+u>ia.MAX_VERTEX_ARRAY_LENGTH&&(c=this.segments.prepareSegment(u,this.layoutVertexArray,this.indexArray)),"Polygon"===ms[t.type]){for(var _=[],A=[],S=c.vertexLength,k=0,I=s;k<I.length;k+=1){var z=I[k];if(0!==z.length){z!==s[0]&&A.push(_.length/2);for(var C=0;C<z.length;C++){var M=z[C];gs(this.layoutVertexArray,M.x,M.y,0,0,1,1,0),_.push(M.x),_.push(M.y);}}}for(var E=wo(_,A),T=0;T<E.length;T+=3)this.indexArray.emplaceBack(S+E[T],S+E[T+2],S+E[T+1]);c.primitiveLength+=E.length/3,c.vertexLength+=u;}}var P;this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,i,n);},Fn("FillExtrusionBucket",xs,{omit:["layers","features"]});var ws={paint:new gi({"fill-extrusion-opacity":new fi(It["paint_fill-extrusion"]["fill-extrusion-opacity"]),"fill-extrusion-color":new yi(It["paint_fill-extrusion"]["fill-extrusion-color"]),"fill-extrusion-translate":new fi(It["paint_fill-extrusion"]["fill-extrusion-translate"]),"fill-extrusion-translate-anchor":new fi(It["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),"fill-extrusion-pattern":new di(It["paint_fill-extrusion"]["fill-extrusion-pattern"]),"fill-extrusion-height":new yi(It["paint_fill-extrusion"]["fill-extrusion-height"]),"fill-extrusion-base":new yi(It["paint_fill-extrusion"]["fill-extrusion-base"]),"fill-extrusion-vertical-gradient":new fi(It["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])})},_s=function(t){function e(e){t.call(this,e,ws);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.createBucket=function(t){return new xs(t)},e.prototype.queryRadius=function(){return Ya(this.paint.get("fill-extrusion-translate"))},e.prototype.is3D=function(){return !0},e.prototype.queryIntersectsFeature=function(t,e,r,n,a,o,s,u){var l=$a(t,this.paint.get("fill-extrusion-translate"),this.paint.get("fill-extrusion-translate-anchor"),o.angle,s),p=this.paint.get("fill-extrusion-height").evaluate(e,r),c=this.paint.get("fill-extrusion-base").evaluate(e,r),h=function(t,e,r,n){for(var a=[],o=0,s=t;o<s.length;o+=1){var u=s[o],l=[u.x,u.y,0,1];ao(l,l,e),a.push(new i(l[0]/l[3],l[1]/l[3]));}return a}(l,u),f=function(t,e,r,n){for(var a=[],o=[],s=n[8]*e,u=n[9]*e,l=n[10]*e,p=n[11]*e,c=n[8]*r,h=n[9]*r,f=n[10]*r,y=n[11]*r,d=0,m=t;d<m.length;d+=1){for(var v=[],g=[],x=0,b=m[d];x<b.length;x+=1){var w=b[x],_=w.x,A=w.y,S=n[0]*_+n[4]*A+n[12],k=n[1]*_+n[5]*A+n[13],I=n[2]*_+n[6]*A+n[14],z=n[3]*_+n[7]*A+n[15],C=I+l,M=z+p,E=S+c,T=k+h,P=I+f,B=z+y,V=new i((S+s)/M,(k+u)/M);V.z=C/M,v.push(V);var F=new i(E/B,T/B);F.z=P/B,g.push(F);}a.push(v),o.push(g);}return [a,o]}(n,c,p,u);return function(t,e,r){var n=1/0;Ua(r,e)&&(n=Ss(r,e[0]));for(var i=0;i<e.length;i++)for(var a=e[i],o=t[i],s=0;s<a.length-1;s++){var u=a[s],l=[u,a[s+1],o[s+1],o[s],u];Ra(r,l)&&(n=Math.min(n,Ss(r,l)));}return n!==1/0&&n}(f[0],f[1],h)},e}(xi);function As(t,e){return t.x*e.x+t.y*e.y}function Ss(t,e){if(1===t.length){for(var r,n=0,i=e[n++];!r||i.equals(r);)if(!(r=e[n++]))return 1/0;for(;n<e.length;n++){var a=e[n],o=t[0],s=r.sub(i),u=a.sub(i),l=o.sub(i),p=As(s,s),c=As(s,u),h=As(u,u),f=As(l,s),y=As(l,u),d=p*h-c*c,m=(h*f-c*y)/d,v=(p*y-c*f)/d,g=i.z*(1-m-v)+r.z*m+a.z*v;if(isFinite(g))return g}return 1/0}for(var x=1/0,b=0,w=e;b<w.length;b+=1)x=Math.min(x,w[b].z);return x}var ks=Ai([{name:"a_pos_normal",components:2,type:"Int16"},{name:"a_data",components:4,type:"Uint8"}],4).members,Is=ds.VectorTileFeature.types,zs=Math.cos(Math.PI/180*37.5),Cs=Math.pow(2,14)/.5,Ms=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.layoutVertexArray=new Ci,this.indexArray=new Li,this.programConfigurations=new Ta(ks,t.layers,t.zoom),this.segments=new ia,this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};Ms.prototype.populate=function(t,e,r){this.hasPattern=ts("line",this.layers,e);for(var n=this.layers[0].layout.get("line-sort-key"),i=[],a=0,o=t;a<o.length;a+=1){var s=o[a],u=s.feature,l=s.id,p=s.index,c=s.sourceLayerIndex,h=this.layers[0]._featureFilter.needGeometry,f={type:u.type,id:l,properties:u.properties,geometry:h?Fa(u):[]};if(this.layers[0]._featureFilter.filter(new ii(this.zoom),f,r)){h||(f.geometry=Fa(u));var y=n?n.evaluate(f,{},r):void 0;i.push({id:l,properties:u.properties,type:u.type,sourceLayerIndex:c,index:p,geometry:f.geometry,patterns:{},sortKey:y});}}n&&i.sort((function(t,e){return t.sortKey-e.sortKey}));for(var d=0,m=i;d<m.length;d+=1){var v=m[d],g=v.geometry,x=v.index,b=v.sourceLayerIndex;if(this.hasPattern){var w=es("line",this.layers,v,this.zoom,e);this.patternFeatures.push(w);}else this.addFeature(v,g,x,r,{});e.featureIndex.insert(t[x].feature,g,x,b,this.index);}},Ms.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},Ms.prototype.addFeatures=function(t,e,r){for(var n=0,i=this.patternFeatures;n<i.length;n+=1){var a=i[n];this.addFeature(a,a.geometry,a.index,e,r);}},Ms.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},Ms.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},Ms.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,ks),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},Ms.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},Ms.prototype.addFeature=function(t,e,r,n,i){for(var a=this.layers[0].layout,o=a.get("line-join").evaluate(t,{}),s=a.get("line-cap"),u=a.get("line-miter-limit"),l=a.get("line-round-limit"),p=0,c=e;p<c.length;p+=1)this.addLine(c[p],t,o,s,u,l);this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,i,n);},Ms.prototype.addLine=function(t,e,r,n,i,a){if(this.distance=0,this.scaledDistance=0,this.totalDistance=0,e.properties&&e.properties.hasOwnProperty("mapbox_clip_start")&&e.properties.hasOwnProperty("mapbox_clip_end")){this.clipStart=+e.properties.mapbox_clip_start,this.clipEnd=+e.properties.mapbox_clip_end;for(var o=0;o<t.length-1;o++)this.totalDistance+=t[o].dist(t[o+1]);this.updateScaledDistance();}for(var s="Polygon"===Is[e.type],u=t.length;u>=2&&t[u-1].equals(t[u-2]);)u--;for(var l=0;l<u-1&&t[l].equals(t[l+1]);)l++;if(!(u<(s?3:2))){"bevel"===r&&(i=1.05);var p,c=this.overscaling<=16?122880/(512*this.overscaling):0,h=this.segments.prepareSegment(10*u,this.layoutVertexArray,this.indexArray),f=void 0,y=void 0,d=void 0,m=void 0;this.e1=this.e2=-1,s&&(m=t[l].sub(p=t[u-2])._unit()._perp());for(var v=l;v<u;v++)if(!(y=v===u-1?s?t[l+1]:void 0:t[v+1])||!t[v].equals(y)){m&&(d=m),p&&(f=p),p=t[v],m=y?y.sub(p)._unit()._perp():d;var g=(d=d||m).add(m);0===g.x&&0===g.y||g._unit();var x=d.x*m.x+d.y*m.y,b=g.x*m.x+g.y*m.y,w=0!==b?1/b:1/0,_=2*Math.sqrt(2-2*b),A=b<zs&&f&&y,S=d.x*m.y-d.y*m.x>0;if(A&&v>l){var k=p.dist(f);if(k>2*c){var I=p.sub(p.sub(f)._mult(c/k)._round());this.updateDistance(f,I),this.addCurrentVertex(I,d,0,0,h),f=I;}}var z=f&&y,C=z?r:s?"butt":n;if(z&&"round"===C&&(w<a?C="miter":w<=2&&(C="fakeround")),"miter"===C&&w>i&&(C="bevel"),"bevel"===C&&(w>2&&(C="flipbevel"),w<i&&(C="miter")),f&&this.updateDistance(f,p),"miter"===C)g._mult(w),this.addCurrentVertex(p,g,0,0,h);else if("flipbevel"===C){if(w>100)g=m.mult(-1);else {var M=w*d.add(m).mag()/d.sub(m).mag();g._perp()._mult(M*(S?-1:1));}this.addCurrentVertex(p,g,0,0,h),this.addCurrentVertex(p,g.mult(-1),0,0,h);}else if("bevel"===C||"fakeround"===C){var E=-Math.sqrt(w*w-1),T=S?E:0,P=S?0:E;if(f&&this.addCurrentVertex(p,d,T,P,h),"fakeround"===C)for(var B=Math.round(180*_/Math.PI/20),V=1;V<B;V++){var F=V/B;if(.5!==F){var D=F-.5;F+=F*D*(F-1)*((1.0904+x*(x*(3.55645-1.43519*x)-3.2452))*D*D+(.848013+x*(.215638*x-1.06021)));}var L=m.sub(d)._mult(F)._add(d)._unit()._mult(S?-1:1);this.addHalfVertex(p,L.x,L.y,!1,S,0,h);}y&&this.addCurrentVertex(p,m,-T,-P,h);}else if("butt"===C)this.addCurrentVertex(p,g,0,0,h);else if("square"===C){var R=f?1:-1;this.addCurrentVertex(p,g,R,R,h);}else "round"===C&&(f&&(this.addCurrentVertex(p,d,0,0,h),this.addCurrentVertex(p,d,1,1,h,!0)),y&&(this.addCurrentVertex(p,m,-1,-1,h,!0),this.addCurrentVertex(p,m,0,0,h)));if(A&&v<u-1){var O=p.dist(y);if(O>2*c){var U=p.add(y.sub(p)._mult(c/O)._round());this.updateDistance(p,U),this.addCurrentVertex(U,m,0,0,h),p=U;}}}}},Ms.prototype.addCurrentVertex=function(t,e,r,n,i,a){void 0===a&&(a=!1);var o=e.y*n-e.x,s=-e.y-e.x*n;this.addHalfVertex(t,e.x+e.y*r,e.y-e.x*r,a,!1,r,i),this.addHalfVertex(t,o,s,a,!0,-n,i),this.distance>Cs/2&&0===this.totalDistance&&(this.distance=0,this.addCurrentVertex(t,e,r,n,i,a));},Ms.prototype.addHalfVertex=function(t,e,r,n,i,a,o){var s=.5*this.scaledDistance;this.layoutVertexArray.emplaceBack((t.x<<1)+(n?1:0),(t.y<<1)+(i?1:0),Math.round(63*e)+128,Math.round(63*r)+128,1+(0===a?0:a<0?-1:1)|(63&s)<<2,s>>6);var u=o.vertexLength++;this.e1>=0&&this.e2>=0&&(this.indexArray.emplaceBack(this.e1,this.e2,u),o.primitiveLength++),i?this.e2=u:this.e1=u;},Ms.prototype.updateScaledDistance=function(){this.scaledDistance=this.totalDistance>0?(this.clipStart+(this.clipEnd-this.clipStart)*this.distance/this.totalDistance)*(Cs-1):this.distance;},Ms.prototype.updateDistance=function(t,e){this.distance+=t.dist(e),this.updateScaledDistance();},Fn("LineBucket",Ms,{omit:["layers","patternFeatures"]});var Es=new gi({"line-cap":new fi(It.layout_line["line-cap"]),"line-join":new yi(It.layout_line["line-join"]),"line-miter-limit":new fi(It.layout_line["line-miter-limit"]),"line-round-limit":new fi(It.layout_line["line-round-limit"]),"line-sort-key":new yi(It.layout_line["line-sort-key"])}),Ts={paint:new gi({"line-opacity":new yi(It.paint_line["line-opacity"]),"line-color":new yi(It.paint_line["line-color"]),"line-translate":new fi(It.paint_line["line-translate"]),"line-translate-anchor":new fi(It.paint_line["line-translate-anchor"]),"line-width":new yi(It.paint_line["line-width"]),"line-gap-width":new yi(It.paint_line["line-gap-width"]),"line-offset":new yi(It.paint_line["line-offset"]),"line-blur":new yi(It.paint_line["line-blur"]),"line-dasharray":new mi(It.paint_line["line-dasharray"]),"line-pattern":new di(It.paint_line["line-pattern"]),"line-gradient":new vi(It.paint_line["line-gradient"])}),layout:Es},Ps=new(function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.possiblyEvaluate=function(e,r){return r=new ii(Math.floor(r.zoom),{now:r.now,fadeDuration:r.fadeDuration,zoomHistory:r.zoomHistory,transition:r.transition}),t.prototype.possiblyEvaluate.call(this,e,r)},e.prototype.evaluate=function(e,r,n,i){return r=p({},r,{zoom:Math.floor(r.zoom)}),t.prototype.evaluate.call(this,e,r,n,i)},e}(yi))(Ts.paint.properties["line-width"].specification);Ps.useIntegerZoom=!0;var Bs=function(t){function e(e){t.call(this,e,Ts);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._handleSpecialPaintPropertyUpdate=function(t){"line-gradient"===t&&this._updateGradient();},e.prototype._updateGradient=function(){this.gradient=mo(this._transitionablePaint._values["line-gradient"].value.expression,"lineProgress"),this.gradientTexture=null;},e.prototype.recalculate=function(e,r){t.prototype.recalculate.call(this,e,r),this.paint._values["line-floorwidth"]=Ps.possiblyEvaluate(this._transitioningPaint._values["line-width"].value,e);},e.prototype.createBucket=function(t){return new Ms(t)},e.prototype.queryRadius=function(t){var e=t,r=Vs(Ha("line-width",this,e),Ha("line-gap-width",this,e)),n=Ha("line-offset",this,e);return r/2+Math.abs(n)+Ya(this.paint.get("line-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,a,o,s){var u=$a(t,this.paint.get("line-translate"),this.paint.get("line-translate-anchor"),o.angle,s),l=s/2*Vs(this.paint.get("line-width").evaluate(e,r),this.paint.get("line-gap-width").evaluate(e,r)),p=this.paint.get("line-offset").evaluate(e,r);return p&&(n=function(t,e){for(var r=[],n=new i(0,0),a=0;a<t.length;a++){for(var o=t[a],s=[],u=0;u<o.length;u++){var l=o[u],p=o[u+1],c=0===u?n:l.sub(o[u-1])._unit()._perp(),h=u===o.length-1?n:p.sub(l)._unit()._perp(),f=c._add(h)._unit();f._mult(1/(f.x*h.x+f.y*h.y)),s.push(f._mult(e)._add(l));}r.push(s);}return r}(n,p*s)),function(t,e,r){for(var n=0;n<e.length;n++){var i=e[n];if(t.length>=3)for(var a=0;a<i.length;a++)if(Xa(t,i[a]))return !0;if(ja(t,i,r))return !0}return !1}(u,n,l)},e.prototype.isTileClipped=function(){return !0},e}(xi);function Vs(t,e){return e>0?e+2*t:t}var Fs=Ai([{name:"a_pos_offset",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint16"},{name:"a_pixeloffset",components:4,type:"Int16"}],4),Ds=Ai([{name:"a_projected_pos",components:3,type:"Float32"}],4),Ls=(Ai([{name:"a_fade_opacity",components:1,type:"Uint32"}],4),Ai([{name:"a_placed",components:2,type:"Uint8"},{name:"a_shift",components:2,type:"Float32"}])),Rs=(Ai([{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Int16",name:"x1"},{type:"Int16",name:"y1"},{type:"Int16",name:"x2"},{type:"Int16",name:"y2"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"}]),Ai([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4)),Os=Ai([{name:"a_pos",components:2,type:"Float32"},{name:"a_radius",components:1,type:"Float32"},{name:"a_flags",components:2,type:"Int16"}],4);function Us(t,e,r){return t.sections.forEach((function(t){t.text=function(t,e,r){var n=e.layout.get("text-transform").evaluate(r,{});return "uppercase"===n?t=t.toLocaleUpperCase():"lowercase"===n&&(t=t.toLocaleLowerCase()),ni.applyArabicShaping&&(t=ni.applyArabicShaping(t)),t}(t.text,e,r);})),t}Ai([{name:"triangle",components:3,type:"Uint16"}]),Ai([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Uint16",name:"glyphStartIndex"},{type:"Uint16",name:"numGlyphs"},{type:"Uint32",name:"vertexStartIndex"},{type:"Uint32",name:"lineStartIndex"},{type:"Uint32",name:"lineLength"},{type:"Uint16",name:"segment"},{type:"Uint16",name:"lowerSize"},{type:"Uint16",name:"upperSize"},{type:"Float32",name:"lineOffsetX"},{type:"Float32",name:"lineOffsetY"},{type:"Uint8",name:"writingMode"},{type:"Uint8",name:"placedOrientation"},{type:"Uint8",name:"hidden"},{type:"Uint32",name:"crossTileID"},{type:"Int16",name:"associatedIconIndex"}]),Ai([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Int16",name:"rightJustifiedTextSymbolIndex"},{type:"Int16",name:"centerJustifiedTextSymbolIndex"},{type:"Int16",name:"leftJustifiedTextSymbolIndex"},{type:"Int16",name:"verticalPlacedTextSymbolIndex"},{type:"Int16",name:"placedIconSymbolIndex"},{type:"Int16",name:"verticalPlacedIconSymbolIndex"},{type:"Uint16",name:"key"},{type:"Uint16",name:"textBoxStartIndex"},{type:"Uint16",name:"textBoxEndIndex"},{type:"Uint16",name:"verticalTextBoxStartIndex"},{type:"Uint16",name:"verticalTextBoxEndIndex"},{type:"Uint16",name:"iconBoxStartIndex"},{type:"Uint16",name:"iconBoxEndIndex"},{type:"Uint16",name:"verticalIconBoxStartIndex"},{type:"Uint16",name:"verticalIconBoxEndIndex"},{type:"Uint16",name:"featureIndex"},{type:"Uint16",name:"numHorizontalGlyphVertices"},{type:"Uint16",name:"numVerticalGlyphVertices"},{type:"Uint16",name:"numIconVertices"},{type:"Uint16",name:"numVerticalIconVertices"},{type:"Uint16",name:"useRuntimeCollisionCircles"},{type:"Uint32",name:"crossTileID"},{type:"Float32",name:"textBoxScale"},{type:"Float32",components:2,name:"textOffset"},{type:"Float32",name:"collisionCircleDiameter"}]),Ai([{type:"Float32",name:"offsetX"}]),Ai([{type:"Int16",name:"x"},{type:"Int16",name:"y"},{type:"Int16",name:"tileUnitDistanceFromAnchor"}]);var js={"!":"︕","#":"＃",$:"＄","%":"％","&":"＆","(":"︵",")":"︶","*":"＊","+":"＋",",":"︐","-":"︲",".":"・","/":"／",":":"︓",";":"︔","<":"︿","=":"＝",">":"﹀","?":"︖","@":"＠","[":"﹇","\\":"＼","]":"﹈","^":"＾",_:"︳","`":"｀","{":"︷","|":"―","}":"︸","~":"～","¢":"￠","£":"￡","¥":"￥","¦":"￤","¬":"￢","¯":"￣","–":"︲","—":"︱","‘":"﹃","’":"﹄","“":"﹁","”":"﹂","…":"︙","‧":"・","₩":"￦","、":"︑","。":"︒","〈":"︿","〉":"﹀","《":"︽","》":"︾","「":"﹁","」":"﹂","『":"﹃","』":"﹄","【":"︻","】":"︼","〔":"︹","〕":"︺","〖":"︗","〗":"︘","！":"︕","（":"︵","）":"︶","，":"︐","－":"︲","．":"・","：":"︓","；":"︔","＜":"︿","＞":"﹀","？":"︖","［":"﹇","］":"﹈","＿":"︳","｛":"︷","｜":"―","｝":"︸","｟":"︵","｠":"︶","｡":"︒","｢":"﹁","｣":"﹂"},qs=function(t,e,r,n,i){var a,o,s=8*i-n-1,u=(1<<s)-1,l=u>>1,p=-7,c=r?i-1:0,h=r?-1:1,f=t[e+c];for(c+=h,a=f&(1<<-p)-1,f>>=-p,p+=s;p>0;a=256*a+t[e+c],c+=h,p-=8);for(o=a&(1<<-p)-1,a>>=-p,p+=n;p>0;o=256*o+t[e+c],c+=h,p-=8);if(0===a)a=1-l;else {if(a===u)return o?NaN:1/0*(f?-1:1);o+=Math.pow(2,n),a-=l;}return (f?-1:1)*o*Math.pow(2,a-n)},Ns=function(t,e,r,n,i,a){var o,s,u,l=8*a-i-1,p=(1<<l)-1,c=p>>1,h=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,f=n?0:a-1,y=n?1:-1,d=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,o=p):(o=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-o))<1&&(o--,u*=2),(e+=o+c>=1?h/u:h*Math.pow(2,1-c))*u>=2&&(o++,u/=2),o+c>=p?(s=0,o=p):o+c>=1?(s=(e*u-1)*Math.pow(2,i),o+=c):(s=e*Math.pow(2,c-1)*Math.pow(2,i),o=0));i>=8;t[r+f]=255&s,f+=y,s/=256,i-=8);for(o=o<<i|s,l+=i;l>0;t[r+f]=255&o,f+=y,o/=256,l-=8);t[r+f-y]|=128*d;},Ks=Gs;function Gs(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length;}Gs.Varint=0,Gs.Fixed64=1,Gs.Bytes=2,Gs.Fixed32=5;var Zs="undefined"==typeof TextDecoder?null:new TextDecoder("utf8");function Xs(t){return t.type===Gs.Bytes?t.readVarint()+t.pos:t.pos+1}function Js(t,e,r){return r?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function Hs(t,e,r){var n=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.floor(Math.log(e)/(7*Math.LN2));r.realloc(n);for(var i=r.pos-1;i>=t;i--)r.buf[i+n]=r.buf[i];}function Ys(t,e){for(var r=0;r<t.length;r++)e.writeVarint(t[r]);}function $s(t,e){for(var r=0;r<t.length;r++)e.writeSVarint(t[r]);}function Ws(t,e){for(var r=0;r<t.length;r++)e.writeFloat(t[r]);}function Qs(t,e){for(var r=0;r<t.length;r++)e.writeDouble(t[r]);}function tu(t,e){for(var r=0;r<t.length;r++)e.writeBoolean(t[r]);}function eu(t,e){for(var r=0;r<t.length;r++)e.writeFixed32(t[r]);}function ru(t,e){for(var r=0;r<t.length;r++)e.writeSFixed32(t[r]);}function nu(t,e){for(var r=0;r<t.length;r++)e.writeFixed64(t[r]);}function iu(t,e){for(var r=0;r<t.length;r++)e.writeSFixed64(t[r]);}function au(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function ou(t,e,r){t[r]=e,t[r+1]=e>>>8,t[r+2]=e>>>16,t[r+3]=e>>>24;}function su(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}function uu(t,e,r){1===t&&r.readMessage(lu,e);}function lu(t,e,r){if(3===t){var n=r.readMessage(pu,{}),i=n.width,a=n.height,o=n.left,s=n.top,u=n.advance;e.push({id:n.id,bitmap:new ho({width:i+6,height:a+6},n.bitmap),metrics:{width:i,height:a,left:o,top:s,advance:u}});}}function pu(t,e,r){1===t?e.id=r.readVarint():2===t?e.bitmap=r.readBytes():3===t?e.width=r.readVarint():4===t?e.height=r.readVarint():5===t?e.left=r.readSVarint():6===t?e.top=r.readSVarint():7===t&&(e.advance=r.readVarint());}function cu(t){for(var e=0,r=0,n=0,i=t;n<i.length;n+=1){var a=i[n];e+=a.w*a.h,r=Math.max(r,a.w);}t.sort((function(t,e){return e.h-t.h}));for(var o=[{x:0,y:0,w:Math.max(Math.ceil(Math.sqrt(e/.95)),r),h:1/0}],s=0,u=0,l=0,p=t;l<p.length;l+=1)for(var c=p[l],h=o.length-1;h>=0;h--){var f=o[h];if(!(c.w>f.w||c.h>f.h)){if(c.x=f.x,c.y=f.y,u=Math.max(u,c.y+c.h),s=Math.max(s,c.x+c.w),c.w===f.w&&c.h===f.h){var y=o.pop();h<o.length&&(o[h]=y);}else c.h===f.h?(f.x+=c.w,f.w-=c.w):c.w===f.w?(f.y+=c.h,f.h-=c.h):(o.push({x:f.x+c.w,y:f.y,w:f.w-c.w,h:c.h}),f.y+=c.h,f.h-=c.h);break}}return {w:s,h:u,fill:e/(s*u)||0}}Gs.prototype={destroy:function(){this.buf=null;},readFields:function(t,e,r){for(r=r||this.length;this.pos<r;){var n=this.readVarint(),i=n>>3,a=this.pos;this.type=7&n,t(i,e,this),this.pos===a&&this.skip(n);}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=au(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=su(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=au(this.buf,this.pos)+4294967296*au(this.buf,this.pos+4);return this.pos+=8,t},readSFixed64:function(){var t=au(this.buf,this.pos)+4294967296*su(this.buf,this.pos+4);return this.pos+=8,t},readFloat:function(){var t=qs(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=qs(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,r,n=this.buf;return e=127&(r=n[this.pos++]),r<128?e:(e|=(127&(r=n[this.pos++]))<<7,r<128?e:(e|=(127&(r=n[this.pos++]))<<14,r<128?e:(e|=(127&(r=n[this.pos++]))<<21,r<128?e:function(t,e,r){var n,i,a=r.buf;if(n=(112&(i=a[r.pos++]))>>4,i<128)return Js(t,n,e);if(n|=(127&(i=a[r.pos++]))<<3,i<128)return Js(t,n,e);if(n|=(127&(i=a[r.pos++]))<<10,i<128)return Js(t,n,e);if(n|=(127&(i=a[r.pos++]))<<17,i<128)return Js(t,n,e);if(n|=(127&(i=a[r.pos++]))<<24,i<128)return Js(t,n,e);if(n|=(1&(i=a[r.pos++]))<<31,i<128)return Js(t,n,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(r=n[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=this.pos;return this.pos=t,t-e>=12&&Zs?function(t,e,r){return Zs.decode(t.subarray(e,r))}(this.buf,e,t):function(t,e,r){for(var n="",i=e;i<r;){var a,o,s,u=t[i],l=null,p=u>239?4:u>223?3:u>191?2:1;if(i+p>r)break;1===p?u<128&&(l=u):2===p?128==(192&(a=t[i+1]))&&(l=(31&u)<<6|63&a)<=127&&(l=null):3===p?(o=t[i+2],128==(192&(a=t[i+1]))&&128==(192&o)&&((l=(15&u)<<12|(63&a)<<6|63&o)<=2047||l>=55296&&l<=57343)&&(l=null)):4===p&&(o=t[i+2],s=t[i+3],128==(192&(a=t[i+1]))&&128==(192&o)&&128==(192&s)&&((l=(15&u)<<18|(63&a)<<12|(63&o)<<6|63&s)<=65535||l>=1114112)&&(l=null)),null===l?(l=65533,p=1):l>65535&&(l-=65536,n+=String.fromCharCode(l>>>10&1023|55296),l=56320|1023&l),n+=String.fromCharCode(l),i+=p;}return n}(this.buf,e,t)},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){if(this.type!==Gs.Bytes)return t.push(this.readVarint(e));var r=Xs(this);for(t=t||[];this.pos<r;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){if(this.type!==Gs.Bytes)return t.push(this.readSVarint());var e=Xs(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){if(this.type!==Gs.Bytes)return t.push(this.readBoolean());var e=Xs(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){if(this.type!==Gs.Bytes)return t.push(this.readFloat());var e=Xs(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){if(this.type!==Gs.Bytes)return t.push(this.readDouble());var e=Xs(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){if(this.type!==Gs.Bytes)return t.push(this.readFixed32());var e=Xs(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){if(this.type!==Gs.Bytes)return t.push(this.readSFixed32());var e=Xs(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){if(this.type!==Gs.Bytes)return t.push(this.readFixed64());var e=Xs(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){if(this.type!==Gs.Bytes)return t.push(this.readSFixed64());var e=Xs(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===Gs.Varint)for(;this.buf[this.pos++]>127;);else if(e===Gs.Bytes)this.pos=this.readVarint()+this.pos;else if(e===Gs.Fixed32)this.pos+=4;else {if(e!==Gs.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8;}},writeTag:function(t,e){this.writeVarint(t<<3|e);},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var r=new Uint8Array(e);r.set(this.buf),this.buf=r,this.length=e;}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),ou(this.buf,t,this.pos),this.pos+=4;},writeSFixed32:function(t){this.realloc(4),ou(this.buf,t,this.pos),this.pos+=4;},writeFixed64:function(t){this.realloc(8),ou(this.buf,-1&t,this.pos),ou(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeSFixed64:function(t){this.realloc(8),ou(this.buf,-1&t,this.pos),ou(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var r,n;if(t>=0?(r=t%4294967296|0,n=t/4294967296|0):(n=~(-t/4294967296),4294967295^(r=~(-t%4294967296))?r=r+1|0:(r=0,n=n+1|0)),t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,r){r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,r.buf[r.pos]=127&(t>>>=7);}(r,0,e),function(t,e){var r=(7&t)<<4;e.buf[e.pos++]|=r|((t>>>=3)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),t&&(e.buf[e.pos++]=127&t)))));}(n,e);}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))));},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t);},writeBoolean:function(t){this.writeVarint(Boolean(t));},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,r){for(var n,i,a=0;a<e.length;a++){if((n=e.charCodeAt(a))>55295&&n<57344){if(!i){n>56319||a+1===e.length?(t[r++]=239,t[r++]=191,t[r++]=189):i=n;continue}if(n<56320){t[r++]=239,t[r++]=191,t[r++]=189,i=n;continue}n=i-55296<<10|n-56320|65536,i=null;}else i&&(t[r++]=239,t[r++]=191,t[r++]=189,i=null);n<128?t[r++]=n:(n<2048?t[r++]=n>>6|192:(n<65536?t[r++]=n>>12|224:(t[r++]=n>>18|240,t[r++]=n>>12&63|128),t[r++]=n>>6&63|128),t[r++]=63&n|128);}return r}(this.buf,t,this.pos);var r=this.pos-e;r>=128&&Hs(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r;},writeFloat:function(t){this.realloc(4),Ns(this.buf,t,this.pos,!0,23,4),this.pos+=4;},writeDouble:function(t){this.realloc(8),Ns(this.buf,t,this.pos,!0,52,8),this.pos+=8;},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var r=0;r<e;r++)this.buf[this.pos++]=t[r];},writeRawMessage:function(t,e){this.pos++;var r=this.pos;t(e,this);var n=this.pos-r;n>=128&&Hs(r,n,this),this.pos=r-1,this.writeVarint(n),this.pos+=n;},writeMessage:function(t,e,r){this.writeTag(t,Gs.Bytes),this.writeRawMessage(e,r);},writePackedVarint:function(t,e){e.length&&this.writeMessage(t,Ys,e);},writePackedSVarint:function(t,e){e.length&&this.writeMessage(t,$s,e);},writePackedBoolean:function(t,e){e.length&&this.writeMessage(t,tu,e);},writePackedFloat:function(t,e){e.length&&this.writeMessage(t,Ws,e);},writePackedDouble:function(t,e){e.length&&this.writeMessage(t,Qs,e);},writePackedFixed32:function(t,e){e.length&&this.writeMessage(t,eu,e);},writePackedSFixed32:function(t,e){e.length&&this.writeMessage(t,ru,e);},writePackedFixed64:function(t,e){e.length&&this.writeMessage(t,nu,e);},writePackedSFixed64:function(t,e){e.length&&this.writeMessage(t,iu,e);},writeBytesField:function(t,e){this.writeTag(t,Gs.Bytes),this.writeBytes(e);},writeFixed32Field:function(t,e){this.writeTag(t,Gs.Fixed32),this.writeFixed32(e);},writeSFixed32Field:function(t,e){this.writeTag(t,Gs.Fixed32),this.writeSFixed32(e);},writeFixed64Field:function(t,e){this.writeTag(t,Gs.Fixed64),this.writeFixed64(e);},writeSFixed64Field:function(t,e){this.writeTag(t,Gs.Fixed64),this.writeSFixed64(e);},writeVarintField:function(t,e){this.writeTag(t,Gs.Varint),this.writeVarint(e);},writeSVarintField:function(t,e){this.writeTag(t,Gs.Varint),this.writeSVarint(e);},writeStringField:function(t,e){this.writeTag(t,Gs.Bytes),this.writeString(e);},writeFloatField:function(t,e){this.writeTag(t,Gs.Fixed32),this.writeFloat(e);},writeDoubleField:function(t,e){this.writeTag(t,Gs.Fixed64),this.writeDouble(e);},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e));}};var hu=function(t,e){var r=e.pixelRatio,n=e.version,i=e.stretchX,a=e.stretchY,o=e.content;this.paddedRect=t,this.pixelRatio=r,this.stretchX=i,this.stretchY=a,this.content=o,this.version=n;},fu={tl:{configurable:!0},br:{configurable:!0},tlbr:{configurable:!0},displaySize:{configurable:!0}};fu.tl.get=function(){return [this.paddedRect.x+1,this.paddedRect.y+1]},fu.br.get=function(){return [this.paddedRect.x+this.paddedRect.w-1,this.paddedRect.y+this.paddedRect.h-1]},fu.tlbr.get=function(){return this.tl.concat(this.br)},fu.displaySize.get=function(){return [(this.paddedRect.w-2)/this.pixelRatio,(this.paddedRect.h-2)/this.pixelRatio]},Object.defineProperties(hu.prototype,fu);var yu=function(t,e){var r={},n={};this.haveRenderCallbacks=[];var i=[];this.addImages(t,r,i),this.addImages(e,n,i);var a=cu(i),o=new fo({width:a.w||1,height:a.h||1});for(var s in t){var u=t[s],l=r[s].paddedRect;fo.copy(u.data,o,{x:0,y:0},{x:l.x+1,y:l.y+1},u.data);}for(var p in e){var c=e[p],h=n[p].paddedRect,f=h.x+1,y=h.y+1,d=c.data.width,m=c.data.height;fo.copy(c.data,o,{x:0,y:0},{x:f,y:y},c.data),fo.copy(c.data,o,{x:0,y:m-1},{x:f,y:y-1},{width:d,height:1}),fo.copy(c.data,o,{x:0,y:0},{x:f,y:y+m},{width:d,height:1}),fo.copy(c.data,o,{x:d-1,y:0},{x:f-1,y:y},{width:1,height:m}),fo.copy(c.data,o,{x:0,y:0},{x:f+d,y:y},{width:1,height:m});}this.image=o,this.iconPositions=r,this.patternPositions=n;};yu.prototype.addImages=function(t,e,r){for(var n in t){var i=t[n],a={x:0,y:0,w:i.data.width+2,h:i.data.height+2};r.push(a),e[n]=new hu(a,i),i.hasRenderCallback&&this.haveRenderCallbacks.push(n);}},yu.prototype.patchUpdatedImages=function(t,e){for(var r in t.dispatchRenderCallbacks(this.haveRenderCallbacks),t.updatedImages)this.patchUpdatedImage(this.iconPositions[r],t.getImage(r),e),this.patchUpdatedImage(this.patternPositions[r],t.getImage(r),e);},yu.prototype.patchUpdatedImage=function(t,e,r){if(t&&e&&t.version!==e.version){t.version=e.version;var n=t.tl;r.update(e.data,void 0,{x:n[0],y:n[1]});}},Fn("ImagePosition",hu),Fn("ImageAtlas",yu);var du={horizontal:1,vertical:2,horizontalOnly:3},mu=function(){this.scale=1,this.fontStack="",this.imageName=null;};mu.forText=function(t,e){var r=new mu;return r.scale=t||1,r.fontStack=e,r},mu.forImage=function(t){var e=new mu;return e.imageName=t,e};var vu=function(){this.text="",this.sectionIndex=[],this.sections=[],this.imageSectionID=null;};function gu(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d){var m,v=vu.fromFeature(t,i);c===du.vertical&&v.verticalizePunctuation();var g=ni.processBidirectionalText,x=ni.processStyledBidirectionalText;if(g&&1===v.sections.length){m=[];for(var b=0,w=g(v.toString(),ku(v,l,a,e,n,f,y));b<w.length;b+=1){var _=w[b],A=new vu;A.text=_,A.sections=v.sections;for(var S=0;S<_.length;S++)A.sectionIndex.push(0);m.push(A);}}else if(x){m=[];for(var k=0,I=x(v.text,v.sectionIndex,ku(v,l,a,e,n,f,y));k<I.length;k+=1){var z=I[k],C=new vu;C.text=z[0],C.sectionIndex=z[1],C.sections=v.sections,m.push(C);}}else m=function(t,e){for(var r=[],n=t.text,i=0,a=0,o=e;a<o.length;a+=1){var s=o[a];r.push(t.substring(i,s)),i=s;}return i<n.length&&r.push(t.substring(i,n.length)),r}(v,ku(v,l,a,e,n,f,y));var M=[],E={positionedLines:M,text:v.toString(),top:p[1],bottom:p[1],left:p[0],right:p[0],writingMode:c,iconsInText:!1,verticalizable:!1};return function(t,e,r,n,i,a,o,s,u,l,p,c){for(var h=0,f=-17,y=0,d=0,m="right"===s?1:"left"===s?0:.5,v=0,g=0,x=i;g<x.length;g+=1){var b=x[g];b.trim();var w=b.getMaxScale(),_=24*(w-1),A={positionedGlyphs:[],lineOffset:0};t.positionedLines[v]=A;var S=A.positionedGlyphs,k=0;if(b.length()){for(var I=0;I<b.length();I++){var z=b.getSection(I),C=b.getSectionIndex(I),M=b.getCharCode(I),E=0,T=null,P=null,B=null,V=24,F=!(u===du.horizontal||!p&&!Kn(M)||p&&(xu[M]||(K=M,qn.Arabic(K)||qn["Arabic Supplement"](K)||qn["Arabic Extended-A"](K)||qn["Arabic Presentation Forms-A"](K)||qn["Arabic Presentation Forms-B"](K))));if(z.imageName){var D=n[z.imageName];if(!D)continue;B=z.imageName,t.iconsInText=t.iconsInText||!0,P=D.paddedRect;var L=D.displaySize;z.scale=24*z.scale/c,E=_+(24-L[1]*z.scale),V=(T={width:L[0],height:L[1],left:1,top:-3,advance:F?L[1]:L[0]}).advance;var R=F?L[0]*z.scale-24*w:L[1]*z.scale-24*w;R>0&&R>k&&(k=R);}else {var O=r[z.fontStack],U=O&&O[M];if(U&&U.rect)P=U.rect,T=U.metrics;else {var j=e[z.fontStack],q=j&&j[M];if(!q)continue;T=q.metrics;}E=24*(w-z.scale);}F?(t.verticalizable=!0,S.push({glyph:M,imageName:B,x:h,y:f+E,vertical:F,scale:z.scale,fontStack:z.fontStack,sectionIndex:C,metrics:T,rect:P}),h+=V*z.scale+l):(S.push({glyph:M,imageName:B,x:h,y:f+E,vertical:F,scale:z.scale,fontStack:z.fontStack,sectionIndex:C,metrics:T,rect:P}),h+=T.advance*z.scale+l);}0!==S.length&&(y=Math.max(h-l,y),zu(S,0,S.length-1,m,k)),h=0;var N=a*w+k;A.lineOffset=Math.max(k,_),f+=N,d=Math.max(N,d),++v;}else f+=a,++v;}var K,G=f- -17,Z=Iu(o),X=Z.horizontalAlign,J=Z.verticalAlign;(function(t,e,r,n,i,a,o,s,u){var l,p=(e-r)*i;l=a!==o?-s*n- -17:(-n*u+.5)*o;for(var c=0,h=t;c<h.length;c+=1)for(var f=0,y=h[c].positionedGlyphs;f<y.length;f+=1){var d=y[f];d.x+=p,d.y+=l;}})(t.positionedLines,m,X,J,y,d,a,G,i.length),t.top+=-J*G,t.bottom=t.top+G,t.left+=-X*y,t.right=t.left+y;}(E,e,r,n,m,o,s,u,c,l,h,d),!function(t){for(var e=0,r=t;e<r.length;e+=1)if(0!==r[e].positionedGlyphs.length)return !1;return !0}(M)&&E}vu.fromFeature=function(t,e){for(var r=new vu,n=0;n<t.sections.length;n++){var i=t.sections[n];i.image?r.addImageSection(i):r.addTextSection(i,e);}return r},vu.prototype.length=function(){return this.text.length},vu.prototype.getSection=function(t){return this.sections[this.sectionIndex[t]]},vu.prototype.getSectionIndex=function(t){return this.sectionIndex[t]},vu.prototype.getCharCode=function(t){return this.text.charCodeAt(t)},vu.prototype.verticalizePunctuation=function(){this.text=function(t){for(var e="",r=0;r<t.length;r++){var n=t.charCodeAt(r+1)||null,i=t.charCodeAt(r-1)||null;e+=n&&Gn(n)&&!js[t[r+1]]||i&&Gn(i)&&!js[t[r-1]]||!js[t[r]]?t[r]:js[t[r]];}return e}(this.text);},vu.prototype.trim=function(){for(var t=0,e=0;e<this.text.length&&xu[this.text.charCodeAt(e)];e++)t++;for(var r=this.text.length,n=this.text.length-1;n>=0&&n>=t&&xu[this.text.charCodeAt(n)];n--)r--;this.text=this.text.substring(t,r),this.sectionIndex=this.sectionIndex.slice(t,r);},vu.prototype.substring=function(t,e){var r=new vu;return r.text=this.text.substring(t,e),r.sectionIndex=this.sectionIndex.slice(t,e),r.sections=this.sections,r},vu.prototype.toString=function(){return this.text},vu.prototype.getMaxScale=function(){var t=this;return this.sectionIndex.reduce((function(e,r){return Math.max(e,t.sections[r].scale)}),0)},vu.prototype.addTextSection=function(t,e){this.text+=t.text,this.sections.push(mu.forText(t.scale,t.fontStack||e));for(var r=this.sections.length-1,n=0;n<t.text.length;++n)this.sectionIndex.push(r);},vu.prototype.addImageSection=function(t){var e=t.image?t.image.name:"";if(0!==e.length){var r=this.getNextImageSectionCharCode();r?(this.text+=String.fromCharCode(r),this.sections.push(mu.forImage(e)),this.sectionIndex.push(this.sections.length-1)):w("Reached maximum number of images 6401");}else w("Can't add FormattedSection with an empty image.");},vu.prototype.getNextImageSectionCharCode=function(){return this.imageSectionID?this.imageSectionID>=63743?null:++this.imageSectionID:(this.imageSectionID=57344,this.imageSectionID)};var xu={9:!0,10:!0,11:!0,12:!0,13:!0,32:!0},bu={};function wu(t,e,r,n,i,a){if(e.imageName){var o=n[e.imageName];return o?o.displaySize[0]*e.scale*24/a+i:0}var s=r[e.fontStack],u=s&&s[t];return u?u.metrics.advance*e.scale+i:0}function _u(t,e,r,n){var i=Math.pow(t-e,2);return n?t<e?i/2:2*i:i+Math.abs(r)*r}function Au(t,e,r){var n=0;return 10===t&&(n-=1e4),r&&(n+=150),40!==t&&65288!==t||(n+=50),41!==e&&65289!==e||(n+=50),n}function Su(t,e,r,n,i,a){for(var o=null,s=_u(e,r,i,a),u=0,l=n;u<l.length;u+=1){var p=l[u],c=_u(e-p.x,r,i,a)+p.badness;c<=s&&(o=p,s=c);}return {index:t,x:e,priorBreak:o,badness:s}}function ku(t,e,r,n,i,a,o){if("point"!==a)return [];if(!t)return [];for(var s,u=[],l=function(t,e,r,n,i,a){for(var o=0,s=0;s<t.length();s++){var u=t.getSection(s);o+=wu(t.getCharCode(s),u,n,i,e,a);}return o/Math.max(1,Math.ceil(o/r))}(t,e,r,n,i,o),p=t.text.indexOf("​")>=0,c=0,h=0;h<t.length();h++){var f=t.getSection(h),y=t.getCharCode(h);if(xu[y]||(c+=wu(y,f,n,i,e,o)),h<t.length()-1){var d=!((s=y)<11904||!(qn["Bopomofo Extended"](s)||qn.Bopomofo(s)||qn["CJK Compatibility Forms"](s)||qn["CJK Compatibility Ideographs"](s)||qn["CJK Compatibility"](s)||qn["CJK Radicals Supplement"](s)||qn["CJK Strokes"](s)||qn["CJK Symbols and Punctuation"](s)||qn["CJK Unified Ideographs Extension A"](s)||qn["CJK Unified Ideographs"](s)||qn["Enclosed CJK Letters and Months"](s)||qn["Halfwidth and Fullwidth Forms"](s)||qn.Hiragana(s)||qn["Ideographic Description Characters"](s)||qn["Kangxi Radicals"](s)||qn["Katakana Phonetic Extensions"](s)||qn.Katakana(s)||qn["Vertical Forms"](s)||qn["Yi Radicals"](s)||qn["Yi Syllables"](s)));(bu[y]||d||f.imageName)&&u.push(Su(h+1,c,l,u,Au(y,t.getCharCode(h+1),d&&p),!1));}}return function t(e){return e?t(e.priorBreak).concat(e.index):[]}(Su(t.length(),c,l,u,0,!0))}function Iu(t){var e=.5,r=.5;switch(t){case"right":case"top-right":case"bottom-right":e=1;break;case"left":case"top-left":case"bottom-left":e=0;}switch(t){case"bottom":case"bottom-right":case"bottom-left":r=1;break;case"top":case"top-right":case"top-left":r=0;}return {horizontalAlign:e,verticalAlign:r}}function zu(t,e,r,n,i){if(n||i)for(var a=t[r],o=(t[r].x+a.metrics.advance*a.scale)*n,s=e;s<=r;s++)t[s].x-=o,t[s].y+=i;}function Cu(t,e,r,n,i,a){var o,s=t.image;if(s.content){var u=s.content,l=s.pixelRatio||1;o=[u[0]/l,u[1]/l,s.displaySize[0]-u[2]/l,s.displaySize[1]-u[3]/l];}var p,c,h,f,y=e.left*a,d=e.right*a;"width"===r||"both"===r?(f=i[0]+y-n[3],c=i[0]+d+n[1]):c=(f=i[0]+(y+d-s.displaySize[0])/2)+s.displaySize[0];var m=e.top*a,v=e.bottom*a;return "height"===r||"both"===r?(p=i[1]+m-n[0],h=i[1]+v+n[2]):h=(p=i[1]+(m+v-s.displaySize[1])/2)+s.displaySize[1],{image:s,top:p,right:c,bottom:h,left:f,collisionPadding:o}}bu[10]=!0,bu[32]=!0,bu[38]=!0,bu[40]=!0,bu[41]=!0,bu[43]=!0,bu[45]=!0,bu[47]=!0,bu[173]=!0,bu[183]=!0,bu[8203]=!0,bu[8208]=!0,bu[8211]=!0,bu[8231]=!0;var Mu=function(t){function e(e,r,n,i){t.call(this,e,r),this.angle=n,void 0!==i&&(this.segment=i);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.clone=function(){return new e(this.x,this.y,this.angle,this.segment)},e}(i);function Eu(t,e){var r=e.expression;if("constant"===r.kind)return {kind:"constant",layoutSize:r.evaluate(new ii(t+1))};if("source"===r.kind)return {kind:"source"};for(var n=r.zoomStops,i=r.interpolationType,a=0;a<n.length&&n[a]<=t;)a++;for(var o=a=Math.max(0,a-1);o<n.length&&n[o]<t+1;)o++;o=Math.min(n.length-1,o);var s=n[a],u=n[o];return "composite"===r.kind?{kind:"composite",minZoom:s,maxZoom:u,interpolationType:i}:{kind:"camera",minZoom:s,maxZoom:u,minSize:r.evaluate(new ii(s)),maxSize:r.evaluate(new ii(u)),interpolationType:i}}function Tu(t,e,r){var n=e.uSize,i=r.lowerSize;return "source"===t.kind?i/128:"composite"===t.kind?je(i/128,r.upperSize/128,e.uSizeT):n}function Pu(t,e){var r=0,n=0;if("constant"===t.kind)n=t.layoutSize;else if("source"!==t.kind){var i=t.interpolationType,a=i?u(rr.interpolationFactor(i,e,t.minZoom,t.maxZoom),0,1):0;"camera"===t.kind?n=je(t.minSize,t.maxSize,a):r=a;}return {uSizeT:r,uSize:n}}Fn("Anchor",Mu);var Bu=Object.freeze({__proto__:null,getSizeData:Eu,evaluateSizeForFeature:Tu,evaluateSizeForZoom:Pu,SIZE_PACK_FACTOR:128});function Vu(t,e,r,n,i){if(void 0===e.segment)return !0;for(var a=e,o=e.segment+1,s=0;s>-r/2;){if(--o<0)return !1;s-=t[o].dist(a),a=t[o];}s+=t[o].dist(t[o+1]),o++;for(var u=[],l=0;s<r/2;){var p=t[o],c=t[o+1];if(!c)return !1;var h=t[o-1].angleTo(p)-p.angleTo(c);for(h=Math.abs((h+3*Math.PI)%(2*Math.PI)-Math.PI),u.push({distance:s,angleDelta:h}),l+=h;s-u[0].distance>n;)l-=u.shift().angleDelta;if(l>i)return !1;o++,s+=p.dist(c);}return !0}function Fu(t){for(var e=0,r=0;r<t.length-1;r++)e+=t[r].dist(t[r+1]);return e}function Du(t,e,r){return t?.6*e*r:0}function Lu(t,e){return Math.max(t?t.right-t.left:0,e?e.right-e.left:0)}function Ru(t,e,r,n,i,a){for(var o=Du(r,i,a),s=Lu(r,n)*a,u=0,l=Fu(t)/2,p=0;p<t.length-1;p++){var c=t[p],h=t[p+1],f=c.dist(h);if(u+f>l){var y=(l-u)/f,d=je(c.x,h.x,y),m=je(c.y,h.y,y),v=new Mu(d,m,h.angleTo(c),p);return v._round(),!o||Vu(t,v,s,o,e)?v:void 0}u+=f;}}function Ou(t,e,r,n,i,a,o,s,u){var l=Du(n,a,o),p=Lu(n,i),c=p*o,h=0===t[0].x||t[0].x===u||0===t[0].y||t[0].y===u;return e-c<e/4&&(e=c+e/4),function t(e,r,n,i,a,o,s,u,l){for(var p=o/2,c=Fu(e),h=0,f=r-n,y=[],d=0;d<e.length-1;d++){for(var m=e[d],v=e[d+1],g=m.dist(v),x=v.angleTo(m);f+n<h+g;){var b=((f+=n)-h)/g,w=je(m.x,v.x,b),_=je(m.y,v.y,b);if(w>=0&&w<l&&_>=0&&_<l&&f-p>=0&&f+p<=c){var A=new Mu(w,_,x,d);A._round(),i&&!Vu(e,A,o,i,a)||y.push(A);}}h+=g;}return u||y.length||s||(y=t(e,h/2,n,i,a,o,s,!0,l)),y}(t,h?e/2*s%e:(p/2+2*a)*o*s%e,e,l,r,c,h,!1,u)}function Uu(t,e,r,n,a){for(var o=[],s=0;s<t.length;s++)for(var u=t[s],l=void 0,p=0;p<u.length-1;p++){var c=u[p],h=u[p+1];c.x<e&&h.x<e||(c.x<e?c=new i(e,c.y+(e-c.x)/(h.x-c.x)*(h.y-c.y))._round():h.x<e&&(h=new i(e,c.y+(e-c.x)/(h.x-c.x)*(h.y-c.y))._round()),c.y<r&&h.y<r||(c.y<r?c=new i(c.x+(r-c.y)/(h.y-c.y)*(h.x-c.x),r)._round():h.y<r&&(h=new i(c.x+(r-c.y)/(h.y-c.y)*(h.x-c.x),r)._round()),c.x>=n&&h.x>=n||(c.x>=n?c=new i(n,c.y+(n-c.x)/(h.x-c.x)*(h.y-c.y))._round():h.x>=n&&(h=new i(n,c.y+(n-c.x)/(h.x-c.x)*(h.y-c.y))._round()),c.y>=a&&h.y>=a||(c.y>=a?c=new i(c.x+(a-c.y)/(h.y-c.y)*(h.x-c.x),a)._round():h.y>=a&&(h=new i(c.x+(a-c.y)/(h.y-c.y)*(h.x-c.x),a)._round()),l&&c.equals(l[l.length-1])||o.push(l=[c]),l.push(h)))));}return o}function ju(t,e,r,n){var a=[],o=t.image,s=o.pixelRatio,u=o.paddedRect.w-2,l=o.paddedRect.h-2,p=t.right-t.left,c=t.bottom-t.top,h=o.stretchX||[[0,u]],f=o.stretchY||[[0,l]],y=function(t,e){return t+e[1]-e[0]},d=h.reduce(y,0),m=f.reduce(y,0),v=u-d,g=l-m,x=0,b=d,w=0,_=m,A=0,S=v,k=0,I=g;if(o.content&&n){var z=o.content;x=qu(h,0,z[0]),w=qu(f,0,z[1]),b=qu(h,z[0],z[2]),_=qu(f,z[1],z[3]),A=z[0]-x,k=z[1]-w,S=z[2]-z[0]-b,I=z[3]-z[1]-_;}var C=function(n,a,u,l){var h=Ku(n.stretch-x,b,p,t.left),f=Gu(n.fixed-A,S,n.stretch,d),y=Ku(a.stretch-w,_,c,t.top),v=Gu(a.fixed-k,I,a.stretch,m),g=Ku(u.stretch-x,b,p,t.left),z=Gu(u.fixed-A,S,u.stretch,d),C=Ku(l.stretch-w,_,c,t.top),M=Gu(l.fixed-k,I,l.stretch,m),E=new i(h,y),T=new i(g,y),P=new i(g,C),B=new i(h,C),V=new i(f/s,v/s),F=new i(z/s,M/s),D=e*Math.PI/180;if(D){var L=Math.sin(D),R=Math.cos(D),O=[R,-L,L,R];E._matMult(O),T._matMult(O),B._matMult(O),P._matMult(O);}var U=n.stretch+n.fixed,j=a.stretch+a.fixed;return {tl:E,tr:T,bl:B,br:P,tex:{x:o.paddedRect.x+1+U,y:o.paddedRect.y+1+j,w:u.stretch+u.fixed-U,h:l.stretch+l.fixed-j},writingMode:void 0,glyphOffset:[0,0],sectionIndex:0,pixelOffsetTL:V,pixelOffsetBR:F,minFontScaleX:S/s/p,minFontScaleY:I/s/c,isSDF:r}};if(n&&(o.stretchX||o.stretchY))for(var M=Nu(h,v,d),E=Nu(f,g,m),T=0;T<M.length-1;T++)for(var P=M[T],B=M[T+1],V=0;V<E.length-1;V++)a.push(C(P,E[V],B,E[V+1]));else a.push(C({fixed:0,stretch:-1},{fixed:0,stretch:-1},{fixed:0,stretch:u+1},{fixed:0,stretch:l+1}));return a}function qu(t,e,r){for(var n=0,i=0,a=t;i<a.length;i+=1){var o=a[i];n+=Math.max(e,Math.min(r,o[1]))-Math.max(e,Math.min(r,o[0]));}return n}function Nu(t,e,r){for(var n=[{fixed:-1,stretch:0}],i=0,a=t;i<a.length;i+=1){var o=a[i],s=o[0],u=o[1],l=n[n.length-1];n.push({fixed:s-l.stretch,stretch:l.stretch}),n.push({fixed:s-l.stretch,stretch:l.stretch+(u-s)});}return n.push({fixed:e+1,stretch:r}),n}function Ku(t,e,r,n){return t/e*r+n}function Gu(t,e,r,n){return t-e*r/n}var Zu=function(t,e,r,n,a,o,s,u,l,p){if(this.boxStartIndex=t.length,l){var c=o.top,h=o.bottom,f=o.collisionPadding;f&&(c-=f[1],h+=f[3]);var y=h-c;y>0&&(y=Math.max(10,y),this.circleDiameter=y);}else {var d=o.top*s-u,m=o.bottom*s+u,v=o.left*s-u,g=o.right*s+u,x=o.collisionPadding;if(x&&(v-=x[0]*s,d-=x[1]*s,g+=x[2]*s,m+=x[3]*s),p){var b=new i(v,d),w=new i(g,d),_=new i(v,m),A=new i(g,m),S=p*Math.PI/180;b._rotate(S),w._rotate(S),_._rotate(S),A._rotate(S),v=Math.min(b.x,w.x,_.x,A.x),g=Math.max(b.x,w.x,_.x,A.x),d=Math.min(b.y,w.y,_.y,A.y),m=Math.max(b.y,w.y,_.y,A.y);}t.emplaceBack(e.x,e.y,v,d,g,m,r,n,a);}this.boxEndIndex=t.length;},Xu=function(t,e){if(void 0===t&&(t=[]),void 0===e&&(e=Ju),this.data=t,this.length=this.data.length,this.compare=e,this.length>0)for(var r=(this.length>>1)-1;r>=0;r--)this._down(r);};function Ju(t,e){return t<e?-1:t>e?1:0}function Hu(t,e,r){void 0===e&&(e=1),void 0===r&&(r=!1);for(var n=1/0,a=1/0,o=-1/0,s=-1/0,u=t[0],l=0;l<u.length;l++){var p=u[l];(!l||p.x<n)&&(n=p.x),(!l||p.y<a)&&(a=p.y),(!l||p.x>o)&&(o=p.x),(!l||p.y>s)&&(s=p.y);}var c=Math.min(o-n,s-a),h=c/2,f=new Xu([],Yu);if(0===c)return new i(n,a);for(var y=n;y<o;y+=c)for(var d=a;d<s;d+=c)f.push(new $u(y+h,d+h,h,t));for(var m=function(t){for(var e=0,r=0,n=0,i=t[0],a=0,o=i.length,s=o-1;a<o;s=a++){var u=i[a],l=i[s],p=u.x*l.y-l.x*u.y;r+=(u.x+l.x)*p,n+=(u.y+l.y)*p,e+=3*p;}return new $u(r/e,n/e,0,t)}(t),v=f.length;f.length;){var g=f.pop();(g.d>m.d||!m.d)&&(m=g,r&&console.log("found best %d after %d probes",Math.round(1e4*g.d)/1e4,v)),g.max-m.d<=e||(f.push(new $u(g.p.x-(h=g.h/2),g.p.y-h,h,t)),f.push(new $u(g.p.x+h,g.p.y-h,h,t)),f.push(new $u(g.p.x-h,g.p.y+h,h,t)),f.push(new $u(g.p.x+h,g.p.y+h,h,t)),v+=4);}return r&&(console.log("num probes: "+v),console.log("best distance: "+m.d)),m.p}function Yu(t,e){return e.max-t.max}function $u(t,e,r,n){this.p=new i(t,e),this.h=r,this.d=function(t,e){for(var r=!1,n=1/0,i=0;i<e.length;i++)for(var a=e[i],o=0,s=a.length,u=s-1;o<s;u=o++){var l=a[o],p=a[u];l.y>t.y!=p.y>t.y&&t.x<(p.x-l.x)*(t.y-l.y)/(p.y-l.y)+l.x&&(r=!r),n=Math.min(n,Ga(t,l,p));}return (r?1:-1)*Math.sqrt(n)}(this.p,n),this.max=this.d+this.h*Math.SQRT2;}Xu.prototype.push=function(t){this.data.push(t),this.length++,this._up(this.length-1);},Xu.prototype.pop=function(){if(0!==this.length){var t=this.data[0],e=this.data.pop();return this.length--,this.length>0&&(this.data[0]=e,this._down(0)),t}},Xu.prototype.peek=function(){return this.data[0]},Xu.prototype._up=function(t){for(var e=this.data,r=this.compare,n=e[t];t>0;){var i=t-1>>1,a=e[i];if(r(n,a)>=0)break;e[t]=a,t=i;}e[t]=n;},Xu.prototype._down=function(t){for(var e=this.data,r=this.compare,n=this.length>>1,i=e[t];t<n;){var a=1+(t<<1),o=e[a],s=a+1;if(s<this.length&&r(e[s],o)<0&&(a=s,o=e[s]),r(o,i)>=0)break;e[t]=o,t=a;}e[t]=i;};var Wu=Number.POSITIVE_INFINITY;function Qu(t,e){return e[1]!==Wu?function(t,e,r){var n=0,i=0;switch(e=Math.abs(e),r=Math.abs(r),t){case"top-right":case"top-left":case"top":i=r-7;break;case"bottom-right":case"bottom-left":case"bottom":i=7-r;}switch(t){case"top-right":case"bottom-right":case"right":n=-e;break;case"top-left":case"bottom-left":case"left":n=e;}return [n,i]}(t,e[0],e[1]):function(t,e){var r=0,n=0;e<0&&(e=0);var i=e/Math.sqrt(2);switch(t){case"top-right":case"top-left":n=i-7;break;case"bottom-right":case"bottom-left":n=7-i;break;case"bottom":n=7-e;break;case"top":n=e-7;}switch(t){case"top-right":case"bottom-right":r=-i;break;case"top-left":case"bottom-left":r=i;break;case"left":r=e;break;case"right":r=-e;}return [r,n]}(t,e[0])}function tl(t){switch(t){case"right":case"top-right":case"bottom-right":return "right";case"left":case"top-left":case"bottom-left":return "left"}return "center"}function el(t,e,r,n,a,o,s,u,l,p,c,h,f,y,d){var m=function(t,e,r,n,a,o,s,u){for(var l=n.layout.get("text-rotate").evaluate(o,{})*Math.PI/180,p=[],c=0,h=e.positionedLines;c<h.length;c+=1)for(var f=h[c],y=0,d=f.positionedGlyphs;y<d.length;y+=1){var m=d[y];if(m.rect){var v=m.rect||{},g=4,x=!0,b=1,w=0,_=(a||u)&&m.vertical,A=m.metrics.advance*m.scale/2;if(u&&e.verticalizable&&(w=f.lineOffset/2-(m.imageName?-(24-m.metrics.width*m.scale)/2:24*(m.scale-1))),m.imageName){var S=s[m.imageName];x=S.sdf,g=1/(b=S.pixelRatio);}var k=a?[m.x+A,m.y]:[0,0],I=a?[0,0]:[m.x+A+r[0],m.y+r[1]-w],z=[0,0];_&&(z=I,I=[0,0]);var C=(m.metrics.left-g)*m.scale-A+I[0],M=(-m.metrics.top-g)*m.scale+I[1],E=C+v.w*m.scale/b,T=M+v.h*m.scale/b,P=new i(C,M),B=new i(E,M),V=new i(C,T),F=new i(E,T);if(_){var D=new i(-A,A- -17),L=-Math.PI/2,R=12-A,O=new i(22-R,-(m.imageName?R:0)),U=new(Function.prototype.bind.apply(i,[null].concat(z)));P._rotateAround(L,D)._add(O)._add(U),B._rotateAround(L,D)._add(O)._add(U),V._rotateAround(L,D)._add(O)._add(U),F._rotateAround(L,D)._add(O)._add(U);}if(l){var j=Math.sin(l),q=Math.cos(l),N=[q,-j,j,q];P._matMult(N),B._matMult(N),V._matMult(N),F._matMult(N);}var K=new i(0,0),G=new i(0,0);p.push({tl:P,tr:B,bl:V,br:F,tex:v,writingMode:e.writingMode,glyphOffset:k,sectionIndex:m.sectionIndex,isSDF:x,pixelOffsetTL:K,pixelOffsetBR:G,minFontScaleX:0,minFontScaleY:0});}}return p}(0,r,u,a,o,s,n,t.allowVerticalPlacement),v=t.textSizeData,g=null;"source"===v.kind?(g=[128*a.layout.get("text-size").evaluate(s,{})])[0]>32640&&w(t.layerIds[0]+': Value for "text-size" is >= 255. Reduce your "text-size".'):"composite"===v.kind&&((g=[128*y.compositeTextSizes[0].evaluate(s,{},d),128*y.compositeTextSizes[1].evaluate(s,{},d)])[0]>32640||g[1]>32640)&&w(t.layerIds[0]+': Value for "text-size" is >= 255. Reduce your "text-size".'),t.addSymbols(t.text,m,g,u,o,s,p,e,l.lineStartIndex,l.lineLength,f,d);for(var x=0,b=c;x<b.length;x+=1)h[b[x]]=t.text.placedSymbolArray.length-1;return 4*m.length}function rl(t){for(var e in t)return t[e];return null}function nl(t,e,r,n){var i=t.compareText;if(e in i){for(var a=i[e],o=a.length-1;o>=0;o--)if(n.dist(a[o])<r)return !0}else i[e]=[];return i[e].push(n),!1}var il=ds.VectorTileFeature.types,al=[{name:"a_fade_opacity",components:1,type:"Uint8",offset:0}];function ol(t,e,r,n,i,a,o,s,u,l,p,c,h){var f=s?Math.min(32640,Math.round(s[0])):0,y=s?Math.min(32640,Math.round(s[1])):0;t.emplaceBack(e,r,Math.round(32*n),Math.round(32*i),a,o,(f<<1)+(u?1:0),y,16*l,16*p,256*c,256*h);}function sl(t,e,r){t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r);}function ul(t){for(var e=0,r=t.sections;e<r.length;e+=1)if(Jn(r[e].text))return !0;return !1}var ll=function(t){this.layoutVertexArray=new Ei,this.indexArray=new Li,this.programConfigurations=t,this.segments=new ia,this.dynamicLayoutVertexArray=new Ti,this.opacityVertexArray=new Pi,this.placedSymbolArray=new Yi;};ll.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length&&0===this.indexArray.length&&0===this.dynamicLayoutVertexArray.length&&0===this.opacityVertexArray.length},ll.prototype.upload=function(t,e,r,n){this.isEmpty()||(r&&(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Fs.members),this.indexBuffer=t.createIndexBuffer(this.indexArray,e),this.dynamicLayoutVertexBuffer=t.createVertexBuffer(this.dynamicLayoutVertexArray,Ds.members,!0),this.opacityVertexBuffer=t.createVertexBuffer(this.opacityVertexArray,al,!0),this.opacityVertexBuffer.itemSize=1),(r||n)&&this.programConfigurations.upload(t));},ll.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.dynamicLayoutVertexBuffer.destroy(),this.opacityVertexBuffer.destroy());},Fn("SymbolBuffers",ll);var pl=function(t,e,r){this.layoutVertexArray=new t,this.layoutAttributes=e,this.indexArray=new r,this.segments=new ia,this.collisionVertexArray=new Di;};pl.prototype.upload=function(t){this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,this.layoutAttributes),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.collisionVertexBuffer=t.createVertexBuffer(this.collisionVertexArray,Ls.members,!0);},pl.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy(),this.collisionVertexBuffer.destroy());},Fn("CollisionBuffers",pl);var cl=function(t){this.collisionBoxArray=t.collisionBoxArray,this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.pixelRatio=t.pixelRatio,this.sourceLayerIndex=t.sourceLayerIndex,this.hasPattern=!1,this.hasRTLText=!1,this.sortKeyRanges=[],this.collisionCircleArray=[],this.placementInvProjMatrix=eo([]),this.placementViewportMatrix=eo([]);var e=this.layers[0]._unevaluatedLayout._values;this.textSizeData=Eu(this.zoom,e["text-size"]),this.iconSizeData=Eu(this.zoom,e["icon-size"]);var r=this.layers[0].layout,n=r.get("symbol-sort-key"),i=r.get("symbol-z-order");this.sortFeaturesByKey="viewport-y"!==i&&void 0!==n.constantOr(1),this.sortFeaturesByY=("viewport-y"===i||"auto"===i&&!this.sortFeaturesByKey)&&(r.get("text-allow-overlap")||r.get("icon-allow-overlap")||r.get("text-ignore-placement")||r.get("icon-ignore-placement")),"point"===r.get("symbol-placement")&&(this.writingModes=r.get("text-writing-mode").map((function(t){return du[t]}))),this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id})),this.sourceID=t.sourceID;};cl.prototype.createArrays=function(){this.text=new ll(new Ta(Fs.members,this.layers,this.zoom,(function(t){return /^text/.test(t)}))),this.icon=new ll(new Ta(Fs.members,this.layers,this.zoom,(function(t){return /^icon/.test(t)}))),this.glyphOffsetArray=new Qi,this.lineVertexArray=new ta,this.symbolInstances=new Wi;},cl.prototype.calculateGlyphDependencies=function(t,e,r,n,i){for(var a=0;a<t.length;a++)if(e[t.charCodeAt(a)]=!0,(r||n)&&i){var o=js[t.charAt(a)];o&&(e[o.charCodeAt(0)]=!0);}},cl.prototype.populate=function(t,e,r){var n=this.layers[0],i=n.layout,a=i.get("text-font"),o=i.get("text-field"),s=i.get("icon-image"),u=("constant"!==o.value.kind||o.value.value instanceof te&&!o.value.value.isEmpty()||o.value.value.toString().length>0)&&("constant"!==a.value.kind||a.value.value.length>0),l="constant"!==s.value.kind||!!s.value.value||Object.keys(s.parameters).length>0,p=i.get("symbol-sort-key");if(this.features=[],u||l){for(var c=e.iconDependencies,h=e.glyphDependencies,f=e.availableImages,y=new ii(this.zoom),d=0,m=t;d<m.length;d+=1){var v=m[d],g=v.feature,x=v.id,b=v.index,w=v.sourceLayerIndex,_=n._featureFilter.needGeometry,A={type:g.type,id:x,properties:g.properties,geometry:_?Fa(g):[]};if(n._featureFilter.filter(y,A,r)){_||(A.geometry=Fa(g));var S=void 0;if(u){var k=n.getValueAndResolveTokens("text-field",A,r,f),I=te.factory(k);ul(I)&&(this.hasRTLText=!0),(!this.hasRTLText||"unavailable"===ei()||this.hasRTLText&&ni.isParsed())&&(S=Us(I,n,A));}var z=void 0;if(l){var C=n.getValueAndResolveTokens("icon-image",A,r,f);z=C instanceof ee?C:ee.fromString(C);}if(S||z){var M=this.sortFeaturesByKey?p.evaluate(A,{},r):void 0,E={id:x,text:S,icon:z,index:b,sourceLayerIndex:w,geometry:Fa(g),properties:g.properties,type:il[g.type],sortKey:M};if(this.features.push(E),z&&(c[z.name]=!0),S){var T=a.evaluate(A,{},r).join(","),P="map"===i.get("text-rotation-alignment")&&"point"!==i.get("symbol-placement");this.allowVerticalPlacement=this.writingModes&&this.writingModes.indexOf(du.vertical)>=0;for(var B=0,V=S.sections;B<V.length;B+=1){var F=V[B];if(F.image)c[F.image.name]=!0;else {var D=Nn(S.toString()),L=F.fontStack||T,R=h[L]=h[L]||{};this.calculateGlyphDependencies(F.text,R,P,this.allowVerticalPlacement,D);}}}}}}"line"===i.get("symbol-placement")&&(this.features=function(t){var e={},r={},n=[],i=0;function a(e){n.push(t[e]),i++;}function o(t,e,i){var a=r[t];return delete r[t],r[e]=a,n[a].geometry[0].pop(),n[a].geometry[0]=n[a].geometry[0].concat(i[0]),a}function s(t,r,i){var a=e[r];return delete e[r],e[t]=a,n[a].geometry[0].shift(),n[a].geometry[0]=i[0].concat(n[a].geometry[0]),a}function u(t,e,r){var n=r?e[0][e[0].length-1]:e[0][0];return t+":"+n.x+":"+n.y}for(var l=0;l<t.length;l++){var p=t[l],c=p.geometry,h=p.text?p.text.toString():null;if(h){var f=u(h,c),y=u(h,c,!0);if(f in r&&y in e&&r[f]!==e[y]){var d=s(f,y,c),m=o(f,y,n[d].geometry);delete e[f],delete r[y],r[u(h,n[m].geometry,!0)]=m,n[d].geometry=null;}else f in r?o(f,y,c):y in e?s(f,y,c):(a(l),e[f]=i-1,r[y]=i-1);}else a(l);}return n.filter((function(t){return t.geometry}))}(this.features)),this.sortFeaturesByKey&&this.features.sort((function(t,e){return t.sortKey-e.sortKey}));}},cl.prototype.update=function(t,e,r){this.stateDependentLayers.length&&(this.text.programConfigurations.updatePaintArrays(t,e,this.layers,r),this.icon.programConfigurations.updatePaintArrays(t,e,this.layers,r));},cl.prototype.isEmpty=function(){return 0===this.symbolInstances.length&&!this.hasRTLText},cl.prototype.uploadPending=function(){return !this.uploaded||this.text.programConfigurations.needsUpload||this.icon.programConfigurations.needsUpload},cl.prototype.upload=function(t){!this.uploaded&&this.hasDebugData()&&(this.textCollisionBox.upload(t),this.iconCollisionBox.upload(t)),this.text.upload(t,this.sortFeaturesByY,!this.uploaded,this.text.programConfigurations.needsUpload),this.icon.upload(t,this.sortFeaturesByY,!this.uploaded,this.icon.programConfigurations.needsUpload),this.uploaded=!0;},cl.prototype.destroyDebugData=function(){this.textCollisionBox.destroy(),this.iconCollisionBox.destroy();},cl.prototype.destroy=function(){this.text.destroy(),this.icon.destroy(),this.hasDebugData()&&this.destroyDebugData();},cl.prototype.addToLineVertexArray=function(t,e){var r=this.lineVertexArray.length;if(void 0!==t.segment){for(var n=t.dist(e[t.segment+1]),i=t.dist(e[t.segment]),a={},o=t.segment+1;o<e.length;o++)a[o]={x:e[o].x,y:e[o].y,tileUnitDistanceFromAnchor:n},o<e.length-1&&(n+=e[o+1].dist(e[o]));for(var s=t.segment||0;s>=0;s--)a[s]={x:e[s].x,y:e[s].y,tileUnitDistanceFromAnchor:i},s>0&&(i+=e[s-1].dist(e[s]));for(var u=0;u<e.length;u++){var l=a[u];this.lineVertexArray.emplaceBack(l.x,l.y,l.tileUnitDistanceFromAnchor);}}return {lineStartIndex:r,lineLength:this.lineVertexArray.length-r}},cl.prototype.addSymbols=function(t,e,r,n,i,a,o,s,u,l,p,c){for(var h=t.indexArray,f=t.layoutVertexArray,y=t.segments.prepareSegment(4*e.length,f,h,a.sortKey),d=this.glyphOffsetArray.length,m=y.vertexLength,v=this.allowVerticalPlacement&&o===du.vertical?Math.PI/2:0,g=a.text&&a.text.sections,x=0;x<e.length;x++){var b=e[x],w=b.tl,_=b.tr,A=b.bl,S=b.br,k=b.tex,I=b.pixelOffsetTL,z=b.pixelOffsetBR,C=b.minFontScaleX,M=b.minFontScaleY,E=b.glyphOffset,T=b.isSDF,P=b.sectionIndex,B=y.vertexLength,V=E[1];ol(f,s.x,s.y,w.x,V+w.y,k.x,k.y,r,T,I.x,I.y,C,M),ol(f,s.x,s.y,_.x,V+_.y,k.x+k.w,k.y,r,T,z.x,I.y,C,M),ol(f,s.x,s.y,A.x,V+A.y,k.x,k.y+k.h,r,T,I.x,z.y,C,M),ol(f,s.x,s.y,S.x,V+S.y,k.x+k.w,k.y+k.h,r,T,z.x,z.y,C,M),sl(t.dynamicLayoutVertexArray,s,v),h.emplaceBack(B,B+1,B+2),h.emplaceBack(B+1,B+2,B+3),y.vertexLength+=4,y.primitiveLength+=2,this.glyphOffsetArray.emplaceBack(E[0]),x!==e.length-1&&P===e[x+1].sectionIndex||t.programConfigurations.populatePaintArrays(f.length,a,a.index,{},c,g&&g[P]);}t.placedSymbolArray.emplaceBack(s.x,s.y,d,this.glyphOffsetArray.length-d,m,u,l,s.segment,r?r[0]:0,r?r[1]:0,n[0],n[1],o,0,!1,0,p);},cl.prototype._addCollisionDebugVertex=function(t,e,r,n,i,a){return e.emplaceBack(0,0),t.emplaceBack(r.x,r.y,n,i,Math.round(a.x),Math.round(a.y))},cl.prototype.addCollisionDebugVertices=function(t,e,r,n,a,o,s){var u=a.segments.prepareSegment(4,a.layoutVertexArray,a.indexArray),l=u.vertexLength,p=a.layoutVertexArray,c=a.collisionVertexArray,h=s.anchorX,f=s.anchorY;this._addCollisionDebugVertex(p,c,o,h,f,new i(t,e)),this._addCollisionDebugVertex(p,c,o,h,f,new i(r,e)),this._addCollisionDebugVertex(p,c,o,h,f,new i(r,n)),this._addCollisionDebugVertex(p,c,o,h,f,new i(t,n)),u.vertexLength+=4;var y=a.indexArray;y.emplaceBack(l,l+1),y.emplaceBack(l+1,l+2),y.emplaceBack(l+2,l+3),y.emplaceBack(l+3,l),u.primitiveLength+=4;},cl.prototype.addDebugCollisionBoxes=function(t,e,r,n){for(var i=t;i<e;i++){var a=this.collisionBoxArray.get(i);this.addCollisionDebugVertices(a.x1,a.y1,a.x2,a.y2,n?this.textCollisionBox:this.iconCollisionBox,a.anchorPoint,r);}},cl.prototype.generateCollisionDebugBuffers=function(){this.hasDebugData()&&this.destroyDebugData(),this.textCollisionBox=new pl(Vi,Rs.members,Ni),this.iconCollisionBox=new pl(Vi,Rs.members,Ni);for(var t=0;t<this.symbolInstances.length;t++){var e=this.symbolInstances.get(t);this.addDebugCollisionBoxes(e.textBoxStartIndex,e.textBoxEndIndex,e,!0),this.addDebugCollisionBoxes(e.verticalTextBoxStartIndex,e.verticalTextBoxEndIndex,e,!0),this.addDebugCollisionBoxes(e.iconBoxStartIndex,e.iconBoxEndIndex,e,!1),this.addDebugCollisionBoxes(e.verticalIconBoxStartIndex,e.verticalIconBoxEndIndex,e,!1);}},cl.prototype._deserializeCollisionBoxesForSymbol=function(t,e,r,n,i,a,o,s,u){for(var l={},p=e;p<r;p++){var c=t.get(p);l.textBox={x1:c.x1,y1:c.y1,x2:c.x2,y2:c.y2,anchorPointX:c.anchorPointX,anchorPointY:c.anchorPointY},l.textFeatureIndex=c.featureIndex;break}for(var h=n;h<i;h++){var f=t.get(h);l.verticalTextBox={x1:f.x1,y1:f.y1,x2:f.x2,y2:f.y2,anchorPointX:f.anchorPointX,anchorPointY:f.anchorPointY},l.verticalTextFeatureIndex=f.featureIndex;break}for(var y=a;y<o;y++){var d=t.get(y);l.iconBox={x1:d.x1,y1:d.y1,x2:d.x2,y2:d.y2,anchorPointX:d.anchorPointX,anchorPointY:d.anchorPointY},l.iconFeatureIndex=d.featureIndex;break}for(var m=s;m<u;m++){var v=t.get(m);l.verticalIconBox={x1:v.x1,y1:v.y1,x2:v.x2,y2:v.y2,anchorPointX:v.anchorPointX,anchorPointY:v.anchorPointY},l.verticalIconFeatureIndex=v.featureIndex;break}return l},cl.prototype.deserializeCollisionBoxes=function(t){this.collisionArrays=[];for(var e=0;e<this.symbolInstances.length;e++){var r=this.symbolInstances.get(e);this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t,r.textBoxStartIndex,r.textBoxEndIndex,r.verticalTextBoxStartIndex,r.verticalTextBoxEndIndex,r.iconBoxStartIndex,r.iconBoxEndIndex,r.verticalIconBoxStartIndex,r.verticalIconBoxEndIndex));}},cl.prototype.hasTextData=function(){return this.text.segments.get().length>0},cl.prototype.hasIconData=function(){return this.icon.segments.get().length>0},cl.prototype.hasDebugData=function(){return this.textCollisionBox&&this.iconCollisionBox},cl.prototype.hasTextCollisionBoxData=function(){return this.hasDebugData()&&this.textCollisionBox.segments.get().length>0},cl.prototype.hasIconCollisionBoxData=function(){return this.hasDebugData()&&this.iconCollisionBox.segments.get().length>0},cl.prototype.addIndicesForPlacedSymbol=function(t,e){for(var r=t.placedSymbolArray.get(e),n=r.vertexStartIndex+4*r.numGlyphs,i=r.vertexStartIndex;i<n;i+=4)t.indexArray.emplaceBack(i,i+1,i+2),t.indexArray.emplaceBack(i+1,i+2,i+3);},cl.prototype.getSortedSymbolIndexes=function(t){if(this.sortedAngle===t&&void 0!==this.symbolInstanceIndexes)return this.symbolInstanceIndexes;for(var e=Math.sin(t),r=Math.cos(t),n=[],i=[],a=[],o=0;o<this.symbolInstances.length;++o){a.push(o);var s=this.symbolInstances.get(o);n.push(0|Math.round(e*s.anchorX+r*s.anchorY)),i.push(s.featureIndex);}return a.sort((function(t,e){return n[t]-n[e]||i[e]-i[t]})),a},cl.prototype.addToSortKeyRanges=function(t,e){var r=this.sortKeyRanges[this.sortKeyRanges.length-1];r&&r.sortKey===e?r.symbolInstanceEnd=t+1:this.sortKeyRanges.push({sortKey:e,symbolInstanceStart:t,symbolInstanceEnd:t+1});},cl.prototype.sortFeatures=function(t){var e=this;if(this.sortFeaturesByY&&this.sortedAngle!==t&&!(this.text.segments.get().length>1||this.icon.segments.get().length>1)){this.symbolInstanceIndexes=this.getSortedSymbolIndexes(t),this.sortedAngle=t,this.text.indexArray.clear(),this.icon.indexArray.clear(),this.featureSortOrder=[];for(var r=0,n=this.symbolInstanceIndexes;r<n.length;r+=1){var i=this.symbolInstances.get(n[r]);this.featureSortOrder.push(i.featureIndex),[i.rightJustifiedTextSymbolIndex,i.centerJustifiedTextSymbolIndex,i.leftJustifiedTextSymbolIndex].forEach((function(t,r,n){t>=0&&n.indexOf(t)===r&&e.addIndicesForPlacedSymbol(e.text,t);})),i.verticalPlacedTextSymbolIndex>=0&&this.addIndicesForPlacedSymbol(this.text,i.verticalPlacedTextSymbolIndex),i.placedIconSymbolIndex>=0&&this.addIndicesForPlacedSymbol(this.icon,i.placedIconSymbolIndex),i.verticalPlacedIconSymbolIndex>=0&&this.addIndicesForPlacedSymbol(this.icon,i.verticalPlacedIconSymbolIndex);}this.text.indexBuffer&&this.text.indexBuffer.updateData(this.text.indexArray),this.icon.indexBuffer&&this.icon.indexBuffer.updateData(this.icon.indexArray);}},Fn("SymbolBucket",cl,{omit:["layers","collisionBoxArray","features","compareText"]}),cl.MAX_GLYPHS=65535,cl.addDynamicAttributes=sl;var hl=new gi({"symbol-placement":new fi(It.layout_symbol["symbol-placement"]),"symbol-spacing":new fi(It.layout_symbol["symbol-spacing"]),"symbol-avoid-edges":new fi(It.layout_symbol["symbol-avoid-edges"]),"symbol-sort-key":new yi(It.layout_symbol["symbol-sort-key"]),"symbol-z-order":new fi(It.layout_symbol["symbol-z-order"]),"icon-allow-overlap":new fi(It.layout_symbol["icon-allow-overlap"]),"icon-ignore-placement":new fi(It.layout_symbol["icon-ignore-placement"]),"icon-optional":new fi(It.layout_symbol["icon-optional"]),"icon-rotation-alignment":new fi(It.layout_symbol["icon-rotation-alignment"]),"icon-size":new yi(It.layout_symbol["icon-size"]),"icon-text-fit":new fi(It.layout_symbol["icon-text-fit"]),"icon-text-fit-padding":new fi(It.layout_symbol["icon-text-fit-padding"]),"icon-image":new yi(It.layout_symbol["icon-image"]),"icon-rotate":new yi(It.layout_symbol["icon-rotate"]),"icon-padding":new fi(It.layout_symbol["icon-padding"]),"icon-keep-upright":new fi(It.layout_symbol["icon-keep-upright"]),"icon-offset":new yi(It.layout_symbol["icon-offset"]),"icon-anchor":new yi(It.layout_symbol["icon-anchor"]),"icon-pitch-alignment":new fi(It.layout_symbol["icon-pitch-alignment"]),"text-pitch-alignment":new fi(It.layout_symbol["text-pitch-alignment"]),"text-rotation-alignment":new fi(It.layout_symbol["text-rotation-alignment"]),"text-field":new yi(It.layout_symbol["text-field"]),"text-font":new yi(It.layout_symbol["text-font"]),"text-size":new yi(It.layout_symbol["text-size"]),"text-max-width":new yi(It.layout_symbol["text-max-width"]),"text-line-height":new fi(It.layout_symbol["text-line-height"]),"text-letter-spacing":new yi(It.layout_symbol["text-letter-spacing"]),"text-justify":new yi(It.layout_symbol["text-justify"]),"text-radial-offset":new yi(It.layout_symbol["text-radial-offset"]),"text-variable-anchor":new fi(It.layout_symbol["text-variable-anchor"]),"text-anchor":new yi(It.layout_symbol["text-anchor"]),"text-max-angle":new fi(It.layout_symbol["text-max-angle"]),"text-writing-mode":new fi(It.layout_symbol["text-writing-mode"]),"text-rotate":new yi(It.layout_symbol["text-rotate"]),"text-padding":new fi(It.layout_symbol["text-padding"]),"text-keep-upright":new fi(It.layout_symbol["text-keep-upright"]),"text-transform":new yi(It.layout_symbol["text-transform"]),"text-offset":new yi(It.layout_symbol["text-offset"]),"text-allow-overlap":new fi(It.layout_symbol["text-allow-overlap"]),"text-ignore-placement":new fi(It.layout_symbol["text-ignore-placement"]),"text-optional":new fi(It.layout_symbol["text-optional"])}),fl={paint:new gi({"icon-opacity":new yi(It.paint_symbol["icon-opacity"]),"icon-color":new yi(It.paint_symbol["icon-color"]),"icon-halo-color":new yi(It.paint_symbol["icon-halo-color"]),"icon-halo-width":new yi(It.paint_symbol["icon-halo-width"]),"icon-halo-blur":new yi(It.paint_symbol["icon-halo-blur"]),"icon-translate":new fi(It.paint_symbol["icon-translate"]),"icon-translate-anchor":new fi(It.paint_symbol["icon-translate-anchor"]),"text-opacity":new yi(It.paint_symbol["text-opacity"]),"text-color":new yi(It.paint_symbol["text-color"],{runtimeType:Rt,getOverride:function(t){return t.textColor},hasOverride:function(t){return !!t.textColor}}),"text-halo-color":new yi(It.paint_symbol["text-halo-color"]),"text-halo-width":new yi(It.paint_symbol["text-halo-width"]),"text-halo-blur":new yi(It.paint_symbol["text-halo-blur"]),"text-translate":new fi(It.paint_symbol["text-translate"]),"text-translate-anchor":new fi(It.paint_symbol["text-translate-anchor"])}),layout:hl},yl=function(t){this.type=t.property.overrides?t.property.overrides.runtimeType:Vt,this.defaultValue=t;};yl.prototype.evaluate=function(t){if(t.formattedSection){var e=this.defaultValue.property.overrides;if(e&&e.hasOverride(t.formattedSection))return e.getOverride(t.formattedSection)}return t.feature&&t.featureState?this.defaultValue.evaluate(t.feature,t.featureState):this.defaultValue.property.specification.default},yl.prototype.eachChild=function(t){this.defaultValue.isConstant()||t(this.defaultValue.value._styleExpression.expression);},yl.prototype.outputDefined=function(){return !1},yl.prototype.serialize=function(){return null},Fn("FormatSectionOverride",yl,{omit:["defaultValue"]});var dl=function(t){function e(e){t.call(this,e,fl);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.recalculate=function(e,r){if(t.prototype.recalculate.call(this,e,r),"auto"===this.layout.get("icon-rotation-alignment")&&(this.layout._values["icon-rotation-alignment"]="point"!==this.layout.get("symbol-placement")?"map":"viewport"),"auto"===this.layout.get("text-rotation-alignment")&&(this.layout._values["text-rotation-alignment"]="point"!==this.layout.get("symbol-placement")?"map":"viewport"),"auto"===this.layout.get("text-pitch-alignment")&&(this.layout._values["text-pitch-alignment"]=this.layout.get("text-rotation-alignment")),"auto"===this.layout.get("icon-pitch-alignment")&&(this.layout._values["icon-pitch-alignment"]=this.layout.get("icon-rotation-alignment")),"point"===this.layout.get("symbol-placement")){var n=this.layout.get("text-writing-mode");if(n){for(var i=[],a=0,o=n;a<o.length;a+=1){var s=o[a];i.indexOf(s)<0&&i.push(s);}this.layout._values["text-writing-mode"]=i;}else this.layout._values["text-writing-mode"]=["horizontal"];}this._setPaintOverrides();},e.prototype.getValueAndResolveTokens=function(t,e,r,n){var i=this.layout.get(t).evaluate(e,{},r,n),a=this._unevaluatedLayout._values[t];return a.isDataDriven()||qr(a.value)||!i?i:function(t,e){return e.replace(/{([^{}]+)}/g,(function(e,r){return r in t?String(t[r]):""}))}(e.properties,i)},e.prototype.createBucket=function(t){return new cl(t)},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e.prototype._setPaintOverrides=function(){for(var t=0,r=fl.paint.overridableProperties;t<r.length;t+=1){var n=r[t];if(e.hasPaintOverride(this.layout,n)){var i,a=this.paint.get(n),o=new yl(a),s=new jr(o,a.property.specification);i="constant"===a.value.kind||"source"===a.value.kind?new Kr("source",s):new Gr("composite",s,a.value.zoomStops,a.value._interpolationType),this.paint._values[n]=new ci(a.property,i,a.parameters);}}},e.prototype._handleOverridablePaintPropertyUpdate=function(t,r,n){return !(!this.layout||r.isDataDriven()||n.isDataDriven())&&e.hasPaintOverride(this.layout,t)},e.hasPaintOverride=function(t,e){var r=t.get("text-field"),n=fl.paint.properties[e],i=!1,a=function(t){for(var e=0,r=t;e<r.length;e+=1)if(n.overrides&&n.overrides.hasOverride(r[e]))return void(i=!0)};if("constant"===r.value.kind&&r.value.value instanceof te)a(r.value.value.sections);else if("source"===r.value.kind){var o=function(t){i||(t instanceof oe&&ie(t.value)===qt?a(t.value.sections):t instanceof pe?a(t.sections):t.eachChild(o));},s=r.value;s._styleExpression&&o(s._styleExpression.expression);}return i},e}(xi),ml={paint:new gi({"background-color":new fi(It.paint_background["background-color"]),"background-pattern":new mi(It.paint_background["background-pattern"]),"background-opacity":new fi(It.paint_background["background-opacity"])})},vl=function(t){function e(e){t.call(this,e,ml);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e}(xi),gl={paint:new gi({"raster-opacity":new fi(It.paint_raster["raster-opacity"]),"raster-hue-rotate":new fi(It.paint_raster["raster-hue-rotate"]),"raster-brightness-min":new fi(It.paint_raster["raster-brightness-min"]),"raster-brightness-max":new fi(It.paint_raster["raster-brightness-max"]),"raster-saturation":new fi(It.paint_raster["raster-saturation"]),"raster-contrast":new fi(It.paint_raster["raster-contrast"]),"raster-resampling":new fi(It.paint_raster["raster-resampling"]),"raster-fade-duration":new fi(It.paint_raster["raster-fade-duration"])})},xl=function(t){function e(e){t.call(this,e,gl);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e}(xi),bl=function(t){function e(e){t.call(this,e,{}),this.implementation=e;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.is3D=function(){return "3d"===this.implementation.renderingMode},e.prototype.hasOffscreenPass=function(){return void 0!==this.implementation.prerender},e.prototype.recalculate=function(){},e.prototype.updateTransitions=function(){},e.prototype.hasTransition=function(){},e.prototype.serialize=function(){},e.prototype.onAdd=function(t){this.implementation.onAdd&&this.implementation.onAdd(t,t.painter.context.gl);},e.prototype.onRemove=function(t){this.implementation.onRemove&&this.implementation.onRemove(t,t.painter.context.gl);},e}(xi),wl={circle:oo,heatmap:vo,hillshade:xo,fill:as,"fill-extrusion":_s,line:Bs,symbol:dl,background:vl,raster:xl},_l=self.HTMLImageElement,Al=self.HTMLCanvasElement,Sl=self.HTMLVideoElement,kl=self.ImageData,Il=self.ImageBitmap,zl=function(t,e,r,n){this.context=t,this.format=r,this.texture=t.gl.createTexture(),this.update(e,n);};zl.prototype.update=function(t,e,r){var n=t.width,i=t.height,a=!(this.size&&this.size[0]===n&&this.size[1]===i||r),o=this.context,s=o.gl;if(this.useMipmap=Boolean(e&&e.useMipmap),s.bindTexture(s.TEXTURE_2D,this.texture),o.pixelStoreUnpackFlipY.set(!1),o.pixelStoreUnpack.set(1),o.pixelStoreUnpackPremultiplyAlpha.set(this.format===s.RGBA&&(!e||!1!==e.premultiply)),a)this.size=[n,i],t instanceof _l||t instanceof Al||t instanceof Sl||t instanceof kl||Il&&t instanceof Il?s.texImage2D(s.TEXTURE_2D,0,this.format,this.format,s.UNSIGNED_BYTE,t):s.texImage2D(s.TEXTURE_2D,0,this.format,n,i,0,this.format,s.UNSIGNED_BYTE,t.data);else {var u=r||{x:0,y:0},l=u.x,p=u.y;t instanceof _l||t instanceof Al||t instanceof Sl||t instanceof kl||Il&&t instanceof Il?s.texSubImage2D(s.TEXTURE_2D,0,l,p,s.RGBA,s.UNSIGNED_BYTE,t):s.texSubImage2D(s.TEXTURE_2D,0,l,p,n,i,s.RGBA,s.UNSIGNED_BYTE,t.data);}this.useMipmap&&this.isSizePowerOfTwo()&&s.generateMipmap(s.TEXTURE_2D);},zl.prototype.bind=function(t,e,r){var n=this.context.gl;n.bindTexture(n.TEXTURE_2D,this.texture),r!==n.LINEAR_MIPMAP_NEAREST||this.isSizePowerOfTwo()||(r=n.LINEAR),t!==this.filter&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,t),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,r||t),this.filter=t),e!==this.wrap&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,e),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,e),this.wrap=e);},zl.prototype.isSizePowerOfTwo=function(){return this.size[0]===this.size[1]&&Math.log(this.size[0])/Math.LN2%1==0},zl.prototype.destroy=function(){this.context.gl.deleteTexture(this.texture),this.texture=null;};var Cl=function(t){var e=this;this._callback=t,this._triggered=!1,"undefined"!=typeof MessageChannel&&(this._channel=new MessageChannel,this._channel.port2.onmessage=function(){e._triggered=!1,e._callback();});};Cl.prototype.trigger=function(){var t=this;this._triggered||(this._triggered=!0,this._channel?this._channel.port1.postMessage(!0):setTimeout((function(){t._triggered=!1,t._callback();}),0));},Cl.prototype.remove=function(){delete this._channel,this._callback=function(){};};var Ml=function(t,e,r){this.target=t,this.parent=e,this.mapId=r,this.callbacks={},this.tasks={},this.taskQueue=[],this.cancelCallbacks={},d(["receive","process"],this),this.invoker=new Cl(this.process),this.target.addEventListener("message",this.receive,!1),this.globalScope=S()?t:self;};function El(t,e,r){var n=2*Math.PI*6378137/256/Math.pow(2,r);return [t*n-2*Math.PI*6378137/2,e*n-2*Math.PI*6378137/2]}Ml.prototype.send=function(t,e,r,n,i){var a=this;void 0===i&&(i=!1);var o=Math.round(1e18*Math.random()).toString(36).substring(0,10);r&&(this.callbacks[o]=r);var s=z(this.globalScope)?void 0:[];return this.target.postMessage({id:o,type:t,hasCallback:!!r,targetMapId:n,mustQueue:i,sourceMapId:this.mapId,data:On(e,s)},s),{cancel:function(){r&&delete a.callbacks[o],a.target.postMessage({id:o,type:"<cancel>",targetMapId:n,sourceMapId:a.mapId});}}},Ml.prototype.receive=function(t){var e=t.data,r=e.id;if(r&&(!e.targetMapId||this.mapId===e.targetMapId))if("<cancel>"===e.type){delete this.tasks[r];var n=this.cancelCallbacks[r];delete this.cancelCallbacks[r],n&&n();}else S()||e.mustQueue?(this.tasks[r]=e,this.taskQueue.push(r),this.invoker.trigger()):this.processTask(r,e);},Ml.prototype.process=function(){if(this.taskQueue.length){var t=this.taskQueue.shift(),e=this.tasks[t];delete this.tasks[t],this.taskQueue.length&&this.invoker.trigger(),e&&this.processTask(t,e);}},Ml.prototype.processTask=function(t,e){var r=this;if("<response>"===e.type){var n=this.callbacks[t];delete this.callbacks[t],n&&(e.error?n(Un(e.error)):n(null,Un(e.data)));}else {var i=!1,a=z(this.globalScope)?void 0:[],o=e.hasCallback?function(e,n){i=!0,delete r.cancelCallbacks[t],r.target.postMessage({id:t,type:"<response>",sourceMapId:r.mapId,error:e?On(e):null,data:On(n,a)},a);}:function(t){i=!0;},s=null,u=Un(e.data);if(this.parent[e.type])s=this.parent[e.type](e.sourceMapId,u,o);else if(this.parent.getWorkerSource){var l=e.type.split(".");s=this.parent.getWorkerSource(e.sourceMapId,l[0],u.source)[l[1]](u,o);}else o(new Error("Could not find function "+e.type));!i&&s&&s.cancel&&(this.cancelCallbacks[t]=s.cancel);}},Ml.prototype.remove=function(){this.invoker.remove(),this.target.removeEventListener("message",this.receive,!1);};var Tl=function(t,e){t&&(e?this.setSouthWest(t).setNorthEast(e):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]));};Tl.prototype.setNorthEast=function(t){return this._ne=t instanceof Pl?new Pl(t.lng,t.lat):Pl.convert(t),this},Tl.prototype.setSouthWest=function(t){return this._sw=t instanceof Pl?new Pl(t.lng,t.lat):Pl.convert(t),this},Tl.prototype.extend=function(t){var e,r,n=this._sw,i=this._ne;if(t instanceof Pl)e=t,r=t;else {if(!(t instanceof Tl))return Array.isArray(t)?4===t.length||t.every(Array.isArray)?this.extend(Tl.convert(t)):this.extend(Pl.convert(t)):this;if(r=t._ne,!(e=t._sw)||!r)return this}return n||i?(n.lng=Math.min(e.lng,n.lng),n.lat=Math.min(e.lat,n.lat),i.lng=Math.max(r.lng,i.lng),i.lat=Math.max(r.lat,i.lat)):(this._sw=new Pl(e.lng,e.lat),this._ne=new Pl(r.lng,r.lat)),this},Tl.prototype.getCenter=function(){return new Pl((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)},Tl.prototype.getSouthWest=function(){return this._sw},Tl.prototype.getNorthEast=function(){return this._ne},Tl.prototype.getNorthWest=function(){return new Pl(this.getWest(),this.getNorth())},Tl.prototype.getSouthEast=function(){return new Pl(this.getEast(),this.getSouth())},Tl.prototype.getWest=function(){return this._sw.lng},Tl.prototype.getSouth=function(){return this._sw.lat},Tl.prototype.getEast=function(){return this._ne.lng},Tl.prototype.getNorth=function(){return this._ne.lat},Tl.prototype.toArray=function(){return [this._sw.toArray(),this._ne.toArray()]},Tl.prototype.toString=function(){return "LngLatBounds("+this._sw.toString()+", "+this._ne.toString()+")"},Tl.prototype.isEmpty=function(){return !(this._sw&&this._ne)},Tl.prototype.contains=function(t){var e=Pl.convert(t),r=e.lng,n=e.lat,i=this._sw.lng<=r&&r<=this._ne.lng;return this._sw.lng>this._ne.lng&&(i=this._sw.lng>=r&&r>=this._ne.lng),this._sw.lat<=n&&n<=this._ne.lat&&i},Tl.convert=function(t){return !t||t instanceof Tl?t:new Tl(t)};var Pl=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid LngLat object: ("+t+", "+e+")");if(this.lng=+t,this.lat=+e,this.lat>90||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")};Pl.prototype.wrap=function(){return new Pl(l(this.lng,-180,180),this.lat)},Pl.prototype.toArray=function(){return [this.lng,this.lat]},Pl.prototype.toString=function(){return "LngLat("+this.lng+", "+this.lat+")"},Pl.prototype.distanceTo=function(t){var e=Math.PI/180,r=this.lat*e,n=t.lat*e,i=Math.sin(r)*Math.sin(n)+Math.cos(r)*Math.cos(n)*Math.cos((t.lng-this.lng)*e);return 6371008.8*Math.acos(Math.min(i,1))},Pl.prototype.toBounds=function(t){void 0===t&&(t=0);var e=360*t/40075017,r=e/Math.cos(Math.PI/180*this.lat);return new Tl(new Pl(this.lng-r,this.lat-e),new Pl(this.lng+r,this.lat+e))},Pl.convert=function(t){if(t instanceof Pl)return t;if(Array.isArray(t)&&(2===t.length||3===t.length))return new Pl(Number(t[0]),Number(t[1]));if(!Array.isArray(t)&&"object"==typeof t&&null!==t)return new Pl(Number("lng"in t?t.lng:t.lon),Number(t.lat));throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")};var Bl=2*Math.PI*6371008.8;function Vl(t){return Bl*Math.cos(t*Math.PI/180)}function Fl(t){return (180+t)/360}function Dl(t){return (180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360)))/360}function Ll(t,e){return t/Vl(e)}function Rl(t){return 360/Math.PI*Math.atan(Math.exp((180-360*t)*Math.PI/180))-90}var Ol=function(t,e,r){void 0===r&&(r=0),this.x=+t,this.y=+e,this.z=+r;};Ol.fromLngLat=function(t,e){void 0===e&&(e=0);var r=Pl.convert(t);return new Ol(Fl(r.lng),Dl(r.lat),Ll(e,r.lat))},Ol.prototype.toLngLat=function(){return new Pl(360*this.x-180,Rl(this.y))},Ol.prototype.toAltitude=function(){return this.z*Vl(Rl(this.y))},Ol.prototype.meterInMercatorCoordinateUnits=function(){return 1/Bl*(t=Rl(this.y),1/Math.cos(t*Math.PI/180));var t;};var Ul=function(t,e,r){this.z=t,this.x=e,this.y=r,this.key=Nl(0,t,t,e,r);};Ul.prototype.equals=function(t){return this.z===t.z&&this.x===t.x&&this.y===t.y},Ul.prototype.url=function(t,e){var r,n,i,a,o,s=(n=this.y,i=this.z,a=El(256*(r=this.x),256*(n=Math.pow(2,i)-n-1),i),o=El(256*(r+1),256*(n+1),i),a[0]+","+a[1]+","+o[0]+","+o[1]),u=function(t,e,r){for(var n,i="",a=t;a>0;a--)i+=(e&(n=1<<a-1)?1:0)+(r&n?2:0);return i}(this.z,this.x,this.y);return t[(this.x+this.y)%t.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace("{z}",String(this.z)).replace("{x}",String(this.x)).replace("{y}",String("tms"===e?Math.pow(2,this.z)-this.y-1:this.y)).replace("{quadkey}",u).replace("{bbox-epsg-3857}",s)},Ul.prototype.getTilePoint=function(t){var e=Math.pow(2,this.z);return new i(8192*(t.x*e-this.x),8192*(t.y*e-this.y))},Ul.prototype.toString=function(){return this.z+"/"+this.x+"/"+this.y};var jl=function(t,e){this.wrap=t,this.canonical=e,this.key=Nl(t,e.z,e.z,e.x,e.y);},ql=function(t,e,r,n,i){this.overscaledZ=t,this.wrap=e,this.canonical=new Ul(r,+n,+i),this.key=Nl(e,t,r,n,i);};function Nl(t,e,r,n,i){(t*=2)<0&&(t=-1*t-1);var a=1<<r;return (a*a*t+a*i+n).toString(36)+r.toString(36)+e.toString(36)}ql.prototype.equals=function(t){return this.overscaledZ===t.overscaledZ&&this.wrap===t.wrap&&this.canonical.equals(t.canonical)},ql.prototype.scaledTo=function(t){var e=this.canonical.z-t;return t>this.canonical.z?new ql(t,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y):new ql(t,this.wrap,t,this.canonical.x>>e,this.canonical.y>>e)},ql.prototype.calculateScaledKey=function(t,e){var r=this.canonical.z-t;return t>this.canonical.z?Nl(this.wrap*+e,t,this.canonical.z,this.canonical.x,this.canonical.y):Nl(this.wrap*+e,t,t,this.canonical.x>>r,this.canonical.y>>r)},ql.prototype.isChildOf=function(t){if(t.wrap!==this.wrap)return !1;var e=this.canonical.z-t.canonical.z;return 0===t.overscaledZ||t.overscaledZ<this.overscaledZ&&t.canonical.x===this.canonical.x>>e&&t.canonical.y===this.canonical.y>>e},ql.prototype.children=function(t){if(this.overscaledZ>=t)return [new ql(this.overscaledZ+1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];var e=this.canonical.z+1,r=2*this.canonical.x,n=2*this.canonical.y;return [new ql(e,this.wrap,e,r,n),new ql(e,this.wrap,e,r+1,n),new ql(e,this.wrap,e,r,n+1),new ql(e,this.wrap,e,r+1,n+1)]},ql.prototype.isLessThan=function(t){return this.wrap<t.wrap||!(this.wrap>t.wrap)&&(this.overscaledZ<t.overscaledZ||!(this.overscaledZ>t.overscaledZ)&&(this.canonical.x<t.canonical.x||!(this.canonical.x>t.canonical.x)&&this.canonical.y<t.canonical.y))},ql.prototype.wrapped=function(){return new ql(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)},ql.prototype.unwrapTo=function(t){return new ql(this.overscaledZ,t,this.canonical.z,this.canonical.x,this.canonical.y)},ql.prototype.overscaleFactor=function(){return Math.pow(2,this.overscaledZ-this.canonical.z)},ql.prototype.toUnwrapped=function(){return new jl(this.wrap,this.canonical)},ql.prototype.toString=function(){return this.overscaledZ+"/"+this.canonical.x+"/"+this.canonical.y},ql.prototype.getTilePoint=function(t){return this.canonical.getTilePoint(new Ol(t.x-this.wrap,t.y))},Fn("CanonicalTileID",Ul),Fn("OverscaledTileID",ql,{omit:["posMatrix"]});var Kl=function(t,e,r){if(this.uid=t,e.height!==e.width)throw new RangeError("DEM tiles must be square");if(r&&"mapbox"!==r&&"terrarium"!==r)return w('"'+r+'" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');this.stride=e.height;var n=this.dim=e.height-2;this.data=new Uint32Array(e.data.buffer),this.encoding=r||"mapbox";for(var i=0;i<n;i++)this.data[this._idx(-1,i)]=this.data[this._idx(0,i)],this.data[this._idx(n,i)]=this.data[this._idx(n-1,i)],this.data[this._idx(i,-1)]=this.data[this._idx(i,0)],this.data[this._idx(i,n)]=this.data[this._idx(i,n-1)];this.data[this._idx(-1,-1)]=this.data[this._idx(0,0)],this.data[this._idx(n,-1)]=this.data[this._idx(n-1,0)],this.data[this._idx(-1,n)]=this.data[this._idx(0,n-1)],this.data[this._idx(n,n)]=this.data[this._idx(n-1,n-1)];};Kl.prototype.get=function(t,e){var r=new Uint8Array(this.data.buffer),n=4*this._idx(t,e);return ("terrarium"===this.encoding?this._unpackTerrarium:this._unpackMapbox)(r[n],r[n+1],r[n+2])},Kl.prototype.getUnpackVector=function(){return "terrarium"===this.encoding?[256,1,1/256,32768]:[6553.6,25.6,.1,1e4]},Kl.prototype._idx=function(t,e){if(t<-1||t>=this.dim+1||e<-1||e>=this.dim+1)throw new RangeError("out of range source coordinates for DEM data");return (e+1)*this.stride+(t+1)},Kl.prototype._unpackMapbox=function(t,e,r){return (256*t*256+256*e+r)/10-1e4},Kl.prototype._unpackTerrarium=function(t,e,r){return 256*t+e+r/256-32768},Kl.prototype.getPixels=function(){return new fo({width:this.stride,height:this.stride},new Uint8Array(this.data.buffer))},Kl.prototype.backfillBorder=function(t,e,r){if(this.dim!==t.dim)throw new Error("dem dimension mismatch");var n=e*this.dim,i=e*this.dim+this.dim,a=r*this.dim,o=r*this.dim+this.dim;switch(e){case-1:n=i-1;break;case 1:i=n+1;}switch(r){case-1:a=o-1;break;case 1:o=a+1;}for(var s=-e*this.dim,u=-r*this.dim,l=a;l<o;l++)for(var p=n;p<i;p++)this.data[this._idx(p,l)]=t.data[this._idx(p+s,l+u)];},Fn("DEMData",Kl);var Gl=function(t){this._stringToNumber={},this._numberToString=[];for(var e=0;e<t.length;e++){var r=t[e];this._stringToNumber[r]=e,this._numberToString[e]=r;}};Gl.prototype.encode=function(t){return this._stringToNumber[t]},Gl.prototype.decode=function(t){return this._numberToString[t]};var Zl=function(t,e,r,n,i){this.type="Feature",this._vectorTileFeature=t,t._z=e,t._x=r,t._y=n,this.properties=t.properties,this.id=i;},Xl={geometry:{configurable:!0}};Xl.geometry.get=function(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x,this._vectorTileFeature._y,this._vectorTileFeature._z).geometry),this._geometry},Xl.geometry.set=function(t){this._geometry=t;},Zl.prototype.toJSON=function(){var t={geometry:this.geometry};for(var e in this)"_geometry"!==e&&"_vectorTileFeature"!==e&&(t[e]=this[e]);return t},Object.defineProperties(Zl.prototype,Xl);var Jl=function(){this.state={},this.stateChanges={},this.deletedStates={};};Jl.prototype.updateState=function(t,e,r){var n=String(e);if(this.stateChanges[t]=this.stateChanges[t]||{},this.stateChanges[t][n]=this.stateChanges[t][n]||{},p(this.stateChanges[t][n],r),null===this.deletedStates[t])for(var i in this.deletedStates[t]={},this.state[t])i!==n&&(this.deletedStates[t][i]=null);else if(this.deletedStates[t]&&null===this.deletedStates[t][n])for(var a in this.deletedStates[t][n]={},this.state[t][n])r[a]||(this.deletedStates[t][n][a]=null);else for(var o in r)this.deletedStates[t]&&this.deletedStates[t][n]&&null===this.deletedStates[t][n][o]&&delete this.deletedStates[t][n][o];},Jl.prototype.removeFeatureState=function(t,e,r){if(null!==this.deletedStates[t]){var n=String(e);if(this.deletedStates[t]=this.deletedStates[t]||{},r&&void 0!==e)null!==this.deletedStates[t][n]&&(this.deletedStates[t][n]=this.deletedStates[t][n]||{},this.deletedStates[t][n][r]=null);else if(void 0!==e)if(this.stateChanges[t]&&this.stateChanges[t][n])for(r in this.deletedStates[t][n]={},this.stateChanges[t][n])this.deletedStates[t][n][r]=null;else this.deletedStates[t][n]=null;else this.deletedStates[t]=null;}},Jl.prototype.getState=function(t,e){var r=String(e),n=p({},(this.state[t]||{})[r],(this.stateChanges[t]||{})[r]);if(null===this.deletedStates[t])return {};if(this.deletedStates[t]){var i=this.deletedStates[t][e];if(null===i)return {};for(var a in i)delete n[a];}return n},Jl.prototype.initializeTileState=function(t,e){t.setFeatureState(this.state,e);},Jl.prototype.coalesceChanges=function(t,e){var r={};for(var n in this.stateChanges){this.state[n]=this.state[n]||{};var i={};for(var a in this.stateChanges[n])this.state[n][a]||(this.state[n][a]={}),p(this.state[n][a],this.stateChanges[n][a]),i[a]=this.state[n][a];r[n]=i;}for(var o in this.deletedStates){this.state[o]=this.state[o]||{};var s={};if(null===this.deletedStates[o])for(var u in this.state[o])s[u]={},this.state[o][u]={};else for(var l in this.deletedStates[o]){if(null===this.deletedStates[o][l])this.state[o][l]={};else for(var c=0,h=Object.keys(this.deletedStates[o][l]);c<h.length;c+=1)delete this.state[o][l][h[c]];s[l]=this.state[o][l];}r[o]=r[o]||{},p(r[o],s);}if(this.stateChanges={},this.deletedStates={},0!==Object.keys(r).length)for(var f in t)t[f].setFeatureState(r,e);};var Hl=function(t,e){this.tileID=t,this.x=t.canonical.x,this.y=t.canonical.y,this.z=t.canonical.z,this.grid=new En(8192,16,0),this.grid3D=new En(8192,16,0),this.featureIndexArray=new ra,this.promoteId=e;};function Yl(t,e,r,n,i){return v(t,(function(t,a){var o=e instanceof hi?e.get(a):null;return o&&o.evaluate?o.evaluate(r,n,i):o}))}function $l(t){for(var e=1/0,r=1/0,n=-1/0,i=-1/0,a=0,o=t;a<o.length;a+=1){var s=o[a];e=Math.min(e,s.x),r=Math.min(r,s.y),n=Math.max(n,s.x),i=Math.max(i,s.y);}return {minX:e,minY:r,maxX:n,maxY:i}}function Wl(t,e){return e-t}Hl.prototype.insert=function(t,e,r,n,i,a){var o=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(r,n,i);for(var s=a?this.grid3D:this.grid,u=0;u<e.length;u++){for(var l=e[u],p=[1/0,1/0,-1/0,-1/0],c=0;c<l.length;c++){var h=l[c];p[0]=Math.min(p[0],h.x),p[1]=Math.min(p[1],h.y),p[2]=Math.max(p[2],h.x),p[3]=Math.max(p[3],h.y);}p[0]<8192&&p[1]<8192&&p[2]>=0&&p[3]>=0&&s.insert(o,p[0],p[1],p[2],p[3]);}},Hl.prototype.loadVTLayers=function(){return this.vtLayers||(this.vtLayers=new ds.VectorTile(new Ks(this.rawTileData)).layers,this.sourceLayerCoder=new Gl(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"])),this.vtLayers},Hl.prototype.query=function(t,e,r,n){var a=this;this.loadVTLayers();for(var o=t.params||{},s=8192/t.tileSize/t.scale,u=rn(o.filter),l=t.queryGeometry,p=t.queryPadding*s,c=$l(l),h=this.grid.query(c.minX-p,c.minY-p,c.maxX+p,c.maxY+p),f=$l(t.cameraQueryGeometry),y=this.grid3D.query(f.minX-p,f.minY-p,f.maxX+p,f.maxY+p,(function(e,r,n,a){return function(t,e,r,n,a){for(var o=0,s=t;o<s.length;o+=1){var u=s[o];if(e<=u.x&&r<=u.y&&n>=u.x&&a>=u.y)return !0}var l=[new i(e,r),new i(e,a),new i(n,a),new i(n,r)];if(t.length>2)for(var p=0,c=l;p<c.length;p+=1)if(Xa(t,c[p]))return !0;for(var h=0;h<t.length-1;h++)if(Ja(t[h],t[h+1],l))return !0;return !1}(t.cameraQueryGeometry,e-p,r-p,n+p,a+p)})),d=0,m=y;d<m.length;d+=1)h.push(m[d]);h.sort(Wl);for(var v,g={},x=function(i){var p=h[i];if(p!==v){v=p;var c=a.featureIndexArray.get(p),f=null;a.loadMatchingFeature(g,c.bucketIndex,c.sourceLayerIndex,c.featureIndex,u,o.layers,o.availableImages,e,r,n,(function(e,r,n){return f||(f=Fa(e)),r.queryIntersectsFeature(l,e,n,f,a.z,t.transform,s,t.pixelPosMatrix)}));}},b=0;b<h.length;b++)x(b);return g},Hl.prototype.loadMatchingFeature=function(t,e,r,n,i,a,o,s,u,l,p){var c=this.bucketLayerIDs[e];if(!a||function(t,e){for(var r=0;r<t.length;r++)if(e.indexOf(t[r])>=0)return !0;return !1}(a,c)){var h=this.sourceLayerCoder.decode(r),f=this.vtLayers[h].feature(n);if(i.filter(new ii(this.tileID.overscaledZ),f))for(var y=this.getId(f,h),d=0;d<c.length;d++){var m=c[d];if(!(a&&a.indexOf(m)<0)){var v=s[m];if(v){var g={};void 0!==y&&l&&(g=l.getState(v.sourceLayer||"_geojsonTileLayer",y));var x=u[m];x.paint=Yl(x.paint,v.paint,f,g,o),x.layout=Yl(x.layout,v.layout,f,g,o);var b=!p||p(f,v,g);if(b){var w=new Zl(f,this.z,this.x,this.y,y);w.layer=x;var _=t[m];void 0===_&&(_=t[m]=[]),_.push({featureIndex:n,feature:w,intersectionZ:b});}}}}}},Hl.prototype.lookupSymbolFeatures=function(t,e,r,n,i,a,o,s){var u={};this.loadVTLayers();for(var l=rn(i),p=0,c=t;p<c.length;p+=1)this.loadMatchingFeature(u,r,n,c[p],l,a,o,s,e);return u},Hl.prototype.hasLayer=function(t){for(var e=0,r=this.bucketLayerIDs;e<r.length;e+=1)for(var n=0,i=r[e];n<i.length;n+=1)if(t===i[n])return !0;return !1},Hl.prototype.getId=function(t,e){var r=t.id;return this.promoteId&&"boolean"==typeof(r=t.properties["string"==typeof this.promoteId?this.promoteId:this.promoteId[e]])&&(r=Number(r)),r},Fn("FeatureIndex",Hl,{omit:["rawTileData","sourceLayerCoder"]});var Ql=function(t,e){this.tileID=t,this.uid=h(),this.uses=0,this.tileSize=e,this.buckets={},this.expirationTime=null,this.queryPadding=0,this.hasSymbolBuckets=!1,this.hasRTLText=!1,this.dependencies={},this.expiredRequestCount=0,this.state="loading";};Ql.prototype.registerFadeDuration=function(t){var e=t+this.timeAdded;e<D.now()||this.fadeEndTime&&e<this.fadeEndTime||(this.fadeEndTime=e);},Ql.prototype.wasRequested=function(){return "errored"===this.state||"loaded"===this.state||"reloading"===this.state},Ql.prototype.loadVectorData=function(t,e,r){if(this.hasData()&&this.unloadVectorData(),this.state="loaded",t){for(var n in t.featureIndex&&(this.latestFeatureIndex=t.featureIndex,t.rawTileData?(this.latestRawTileData=t.rawTileData,this.latestFeatureIndex.rawTileData=t.rawTileData):this.latestRawTileData&&(this.latestFeatureIndex.rawTileData=this.latestRawTileData)),this.collisionBoxArray=t.collisionBoxArray,this.buckets=function(t,e){var r={};if(!e)return r;for(var n=function(){var t=a[i],n=t.layerIds.map((function(t){return e.getLayer(t)})).filter(Boolean);if(0!==n.length){t.layers=n,t.stateDependentLayerIds&&(t.stateDependentLayers=t.stateDependentLayerIds.map((function(t){return n.filter((function(e){return e.id===t}))[0]})));for(var o=0,s=n;o<s.length;o+=1)r[s[o].id]=t;}},i=0,a=t;i<a.length;i+=1)n();return r}(t.buckets,e.style),this.hasSymbolBuckets=!1,this.buckets){var i=this.buckets[n];if(i instanceof cl){if(this.hasSymbolBuckets=!0,!r)break;i.justReloaded=!0;}}if(this.hasRTLText=!1,this.hasSymbolBuckets)for(var a in this.buckets){var o=this.buckets[a];if(o instanceof cl&&o.hasRTLText){this.hasRTLText=!0,ni.isLoading()||ni.isLoaded()||"deferred"!==ei()||ri();break}}for(var s in this.queryPadding=0,this.buckets){var u=this.buckets[s];this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(s).queryRadius(u));}t.imageAtlas&&(this.imageAtlas=t.imageAtlas),t.glyphAtlasImage&&(this.glyphAtlasImage=t.glyphAtlasImage);}else this.collisionBoxArray=new Ji;},Ql.prototype.unloadVectorData=function(){for(var t in this.buckets)this.buckets[t].destroy();this.buckets={},this.imageAtlasTexture&&this.imageAtlasTexture.destroy(),this.imageAtlas&&(this.imageAtlas=null),this.glyphAtlasTexture&&this.glyphAtlasTexture.destroy(),this.latestFeatureIndex=null,this.state="unloaded";},Ql.prototype.getBucket=function(t){return this.buckets[t.id]},Ql.prototype.upload=function(t){for(var e in this.buckets){var r=this.buckets[e];r.uploadPending()&&r.upload(t);}var n=t.gl;this.imageAtlas&&!this.imageAtlas.uploaded&&(this.imageAtlasTexture=new zl(t,this.imageAtlas.image,n.RGBA),this.imageAtlas.uploaded=!0),this.glyphAtlasImage&&(this.glyphAtlasTexture=new zl(t,this.glyphAtlasImage,n.ALPHA),this.glyphAtlasImage=null);},Ql.prototype.prepare=function(t){this.imageAtlas&&this.imageAtlas.patchUpdatedImages(t,this.imageAtlasTexture);},Ql.prototype.queryRenderedFeatures=function(t,e,r,n,i,a,o,s,u,l){return this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData?this.latestFeatureIndex.query({queryGeometry:n,cameraQueryGeometry:i,scale:a,tileSize:this.tileSize,pixelPosMatrix:l,transform:s,params:o,queryPadding:this.queryPadding*u},t,e,r):{}},Ql.prototype.querySourceFeatures=function(t,e){var r=this.latestFeatureIndex;if(r&&r.rawTileData){var n=r.loadVTLayers(),i=e?e.sourceLayer:"",a=n._geojsonTileLayer||n[i];if(a)for(var o=rn(e&&e.filter),s=this.tileID.canonical,u=s.z,l=s.x,p=s.y,c={z:u,x:l,y:p},h=0;h<a.length;h++){var f=a.feature(h);if(o.filter(new ii(this.tileID.overscaledZ),f)){var y=r.getId(f,i),d=new Zl(f,u,l,p,y);d.tile=c,t.push(d);}}}},Ql.prototype.hasData=function(){return "loaded"===this.state||"reloading"===this.state||"expired"===this.state},Ql.prototype.patternsLoaded=function(){return this.imageAtlas&&!!Object.keys(this.imageAtlas.patternPositions).length},Ql.prototype.setExpiryData=function(t){var e=this.expirationTime;if(t.cacheControl){var r=k(t.cacheControl);r["max-age"]&&(this.expirationTime=Date.now()+1e3*r["max-age"]);}else t.expires&&(this.expirationTime=new Date(t.expires).getTime());if(this.expirationTime){var n=Date.now(),i=!1;if(this.expirationTime>n)i=!1;else if(e)if(this.expirationTime<e)i=!0;else {var a=this.expirationTime-e;a?this.expirationTime=n+Math.max(a,3e4):i=!0;}else i=!0;i?(this.expiredRequestCount++,this.state="expired"):this.expiredRequestCount=0;}},Ql.prototype.getExpiryTimeout=function(){if(this.expirationTime)return this.expiredRequestCount?1e3*(1<<Math.min(this.expiredRequestCount-1,31)):Math.min(this.expirationTime-(new Date).getTime(),Math.pow(2,31)-1)},Ql.prototype.setFeatureState=function(t,e){if(this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData&&0!==Object.keys(t).length){var r=this.latestFeatureIndex.loadVTLayers();for(var n in this.buckets)if(e.style.hasLayer(n)){var i=this.buckets[n],a=i.layers[0].sourceLayer||"_geojsonTileLayer",o=r[a],s=t[a];if(o&&s&&0!==Object.keys(s).length){i.update(s,o,this.imageAtlas&&this.imageAtlas.patternPositions||{});var u=e&&e.style&&e.style.getLayer(n);u&&(this.queryPadding=Math.max(this.queryPadding,u.queryRadius(i)));}}}},Ql.prototype.holdingForFade=function(){return void 0!==this.symbolFadeHoldUntil},Ql.prototype.symbolFadeFinished=function(){return !this.symbolFadeHoldUntil||this.symbolFadeHoldUntil<D.now()},Ql.prototype.clearFadeHold=function(){this.symbolFadeHoldUntil=void 0;},Ql.prototype.setHoldDuration=function(t){this.symbolFadeHoldUntil=D.now()+t;},Ql.prototype.setDependencies=function(t,e){for(var r={},n=0,i=e;n<i.length;n+=1)r[i[n]]=!0;this.dependencies[t]=r;},Ql.prototype.hasDependency=function(t,e){for(var r=0,n=t;r<n.length;r+=1){var i=this.dependencies[n[r]];if(i)for(var a=0,o=e;a<o.length;a+=1)if(i[o[a]])return !0}return !1};var tp=self.performance,ep=function(t){this._marks={start:[t.url,"start"].join("#"),end:[t.url,"end"].join("#"),measure:t.url.toString()},tp.mark(this._marks.start);};ep.prototype.finish=function(){tp.mark(this._marks.end);var t=tp.getEntriesByName(this._marks.measure);return 0===t.length&&(tp.measure(this._marks.measure,this._marks.start,this._marks.end),t=tp.getEntriesByName(this._marks.measure),tp.clearMarks(this._marks.start),tp.clearMarks(this._marks.end),tp.clearMeasures(this._marks.measure)),t},t.Actor=Ml,t.AlphaImage=ho,t.CanonicalTileID=Ul,t.CollisionBoxArray=Ji,t.Color=$t,t.DEMData=Kl,t.DataConstantProperty=fi,t.DictionaryCoder=Gl,t.EXTENT=8192,t.ErrorEvent=St,t.EvaluationParameters=ii,t.Event=At,t.Evented=kt,t.FeatureIndex=Hl,t.FillBucket=rs,t.FillExtrusionBucket=xs,t.ImageAtlas=yu,t.ImagePosition=hu,t.LineBucket=Ms,t.LngLat=Pl,t.LngLatBounds=Tl,t.MercatorCoordinate=Ol,t.ONE_EM=24,t.OverscaledTileID=ql,t.Point=i,t.Point$1=i,t.Properties=gi,t.Protobuf=Ks,t.RGBAImage=fo,t.RequestManager=N,t.RequestPerformance=ep,t.ResourceType=ht,t.SegmentVector=ia,t.SourceFeatureState=Jl,t.StructArrayLayout1ui2=Ki,t.StructArrayLayout2f1f2i16=Fi,t.StructArrayLayout2i4=ki,t.StructArrayLayout3ui6=Li,t.StructArrayLayout4i8=Ii,t.SymbolBucket=cl,t.Texture=zl,t.Tile=Ql,t.Transitionable=si,t.Uniform1f=va,t.Uniform1i=ma,t.Uniform2f=ga,t.Uniform3f=xa,t.Uniform4f=ba,t.UniformColor=wa,t.UniformMatrix4f=Aa,t.UnwrappedTileID=jl,t.ValidationError=zt,t.WritingMode=du,t.ZoomHistory=jn,t.add=function(t,e,r){return t[0]=e[0]+r[0],t[1]=e[1]+r[1],t[2]=e[2]+r[2],t},t.addDynamicAttributes=sl,t.asyncAll=function(t,e,r){if(!t.length)return r(null,[]);var n=t.length,i=new Array(t.length),a=null;t.forEach((function(t,o){e(t,(function(t,e){t&&(a=t),i[o]=e,0==--n&&r(a,i);}));}));},t.bezier=o,t.bindAll=d,t.browser=D,t.cacheEntryPossiblyAdded=function(t){++pt>ot&&(t.getActor().send("enforceCacheSizeLimit",at),pt=0);},t.clamp=u,t.clearTileCache=function(t){var e=self.caches.delete("mapbox-tiles");t&&e.catch(t).then((function(){return t()}));},t.clipLine=Uu,t.clone=function(t){var e=new to(16);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e[3]=t[3],e[4]=t[4],e[5]=t[5],e[6]=t[6],e[7]=t[7],e[8]=t[8],e[9]=t[9],e[10]=t[10],e[11]=t[11],e[12]=t[12],e[13]=t[13],e[14]=t[14],e[15]=t[15],e},t.clone$1=x,t.clone$2=function(t){var e=new to(3);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e},t.collisionCircleLayout=Os,t.config=L,t.create=function(){var t=new to(16);return to!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0),t[0]=1,t[5]=1,t[10]=1,t[15]=1,t},t.create$1=function(){var t=new to(9);return to!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[5]=0,t[6]=0,t[7]=0),t[0]=1,t[4]=1,t[8]=1,t},t.create$2=function(){var t=new to(4);return to!=Float32Array&&(t[1]=0,t[2]=0),t[0]=1,t[3]=1,t},t.createCommonjsModule=e,t.createExpression=Nr,t.createLayout=Ai,t.createStyleLayer=function(t){return "custom"===t.type?new bl(t):new wl[t.type](t)},t.cross=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=r[0],s=r[1],u=r[2];return t[0]=i*u-a*s,t[1]=a*o-n*u,t[2]=n*s-i*o,t},t.deepEqual=function t(e,r){if(Array.isArray(e)){if(!Array.isArray(r)||e.length!==r.length)return !1;for(var n=0;n<e.length;n++)if(!t(e[n],r[n]))return !1;return !0}if("object"==typeof e&&null!==e&&null!==r){if("object"!=typeof r)return !1;if(Object.keys(e).length!==Object.keys(r).length)return !1;for(var i in e)if(!t(e[i],r[i]))return !1;return !0}return e===r},t.dot=function(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]},t.dot$1=function(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]+t[3]*e[3]},t.ease=s,t.emitValidationErrors=Mn,t.endsWith=m,t.enforceCacheSizeLimit=function(t){st(),W&&W.then((function(e){e.keys().then((function(r){for(var n=0;n<r.length-t;n++)e.delete(r[n]);}));}));},t.evaluateSizeForFeature=Tu,t.evaluateSizeForZoom=Pu,t.evaluateVariableOffset=Qu,t.evented=ti,t.extend=p,t.featureFilter=rn,t.filterObject=g,t.fromRotation=function(t,e){var r=Math.sin(e),n=Math.cos(e);return t[0]=n,t[1]=r,t[2]=0,t[3]=-r,t[4]=n,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t},t.getAnchorAlignment=Iu,t.getAnchorJustification=tl,t.getArrayBuffer=gt,t.getImage=bt,t.getJSON=function(t,e){return vt(p(t,{type:"json"}),e)},t.getRTLTextPluginStatus=ei,t.getReferrer=yt,t.getVideo=function(t,e){var r,n,i=self.document.createElement("video");i.muted=!0,i.onloadstart=function(){e(null,i);};for(var a=0;a<t.length;a++){var o=self.document.createElement("source");r=t[a],n=void 0,(n=self.document.createElement("a")).href=r,(n.protocol!==self.document.location.protocol||n.host!==self.document.location.host)&&(i.crossOrigin="Anonymous"),o.src=t[a],i.appendChild(o);}return {cancel:function(){}}},t.identity=eo,t.invert=function(t,e){var r=e[0],n=e[1],i=e[2],a=e[3],o=e[4],s=e[5],u=e[6],l=e[7],p=e[8],c=e[9],h=e[10],f=e[11],y=e[12],d=e[13],m=e[14],v=e[15],g=r*s-n*o,x=r*u-i*o,b=r*l-a*o,w=n*u-i*s,_=n*l-a*s,A=i*l-a*u,S=p*d-c*y,k=p*m-h*y,I=p*v-f*y,z=c*m-h*d,C=c*v-f*d,M=h*v-f*m,E=g*M-x*C+b*z+w*I-_*k+A*S;return E?(t[0]=(s*M-u*C+l*z)*(E=1/E),t[1]=(i*C-n*M-a*z)*E,t[2]=(d*A-m*_+v*w)*E,t[3]=(h*_-c*A-f*w)*E,t[4]=(u*I-o*M-l*k)*E,t[5]=(r*M-i*I+a*k)*E,t[6]=(m*b-y*A-v*x)*E,t[7]=(p*A-h*b+f*x)*E,t[8]=(o*C-s*I+l*S)*E,t[9]=(n*I-r*C-a*S)*E,t[10]=(y*_-d*b+v*g)*E,t[11]=(c*b-p*_-f*g)*E,t[12]=(s*k-o*z-u*S)*E,t[13]=(r*z-n*k+i*S)*E,t[14]=(d*x-y*w-m*g)*E,t[15]=(p*w-c*x+h*g)*E,t):null},t.isChar=qn,t.isMapboxURL=K,t.keysDifference=function(t,e){var r=[];for(var n in t)n in e||r.push(n);return r},t.makeRequest=vt,t.mapObject=v,t.mercatorXfromLng=Fl,t.mercatorYfromLat=Dl,t.mercatorZfromAltitude=Ll,t.mul=io,t.multiply=ro,t.mvt=ds,t.normalize=function(t,e){var r=e[0],n=e[1],i=e[2],a=r*r+n*n+i*i;return a>0&&(a=1/Math.sqrt(a)),t[0]=e[0]*a,t[1]=e[1]*a,t[2]=e[2]*a,t},t.number=je,t.offscreenCanvasSupported=ct,t.ortho=function(t,e,r,n,i,a,o){var s=1/(e-r),u=1/(n-i),l=1/(a-o);return t[0]=-2*s,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*u,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*l,t[11]=0,t[12]=(e+r)*s,t[13]=(i+n)*u,t[14]=(o+a)*l,t[15]=1,t},t.parseGlyphPBF=function(t){return new Ks(t).readFields(uu,[])},t.pbf=Ks,t.performSymbolLayout=function(t,e,r,n,i,a,o){t.createArrays(),t.tilePixelRatio=8192/(512*t.overscaling),t.compareText={},t.iconsNeedLinear=!1;var s=t.layers[0].layout,u=t.layers[0]._unevaluatedLayout._values,l={};if("composite"===t.textSizeData.kind){var p=t.textSizeData,c=p.maxZoom;l.compositeTextSizes=[u["text-size"].possiblyEvaluate(new ii(p.minZoom),o),u["text-size"].possiblyEvaluate(new ii(c),o)];}if("composite"===t.iconSizeData.kind){var h=t.iconSizeData,f=h.maxZoom;l.compositeIconSizes=[u["icon-size"].possiblyEvaluate(new ii(h.minZoom),o),u["icon-size"].possiblyEvaluate(new ii(f),o)];}l.layoutTextSize=u["text-size"].possiblyEvaluate(new ii(t.zoom+1),o),l.layoutIconSize=u["icon-size"].possiblyEvaluate(new ii(t.zoom+1),o),l.textMaxSize=u["text-size"].possiblyEvaluate(new ii(18));for(var y=24*s.get("text-line-height"),d="map"===s.get("text-rotation-alignment")&&"point"!==s.get("symbol-placement"),m=s.get("text-keep-upright"),v=s.get("text-size"),g=function(){var a=b[x],u=s.get("text-font").evaluate(a,{},o).join(","),p=v.evaluate(a,{},o),c=l.layoutTextSize.evaluate(a,{},o),h=l.layoutIconSize.evaluate(a,{},o),f={horizontal:{},vertical:void 0},g=a.text,_=[0,0];if(g){var A=g.toString(),S=24*s.get("text-letter-spacing").evaluate(a,{},o),k=function(t){for(var e=0,r=t;e<r.length;e+=1)if(n=r[e].charCodeAt(0),qn.Arabic(n)||qn["Arabic Supplement"](n)||qn["Arabic Extended-A"](n)||qn["Arabic Presentation Forms-A"](n)||qn["Arabic Presentation Forms-B"](n))return !1;var n;return !0}(A)?S:0,I=s.get("text-anchor").evaluate(a,{},o),z=s.get("text-variable-anchor");if(!z){var C=s.get("text-radial-offset").evaluate(a,{},o);_=C?Qu(I,[24*C,Wu]):s.get("text-offset").evaluate(a,{},o).map((function(t){return 24*t}));}var M=d?"center":s.get("text-justify").evaluate(a,{},o),E=s.get("symbol-placement"),T="point"===E?24*s.get("text-max-width").evaluate(a,{},o):0,P=function(){t.allowVerticalPlacement&&Nn(A)&&(f.vertical=gu(g,e,r,i,u,T,y,I,"left",k,_,du.vertical,!0,E,c,p));};if(!d&&z){for(var B="auto"===M?z.map((function(t){return tl(t)})):[M],V=!1,F=0;F<B.length;F++){var D=B[F];if(!f.horizontal[D])if(V)f.horizontal[D]=f.horizontal[0];else {var L=gu(g,e,r,i,u,T,y,"center",D,k,_,du.horizontal,!1,E,c,p);L&&(f.horizontal[D]=L,V=1===L.positionedLines.length);}}P();}else {"auto"===M&&(M=tl(I));var R=gu(g,e,r,i,u,T,y,I,M,k,_,du.horizontal,!1,E,c,p);R&&(f.horizontal[M]=R),P(),Nn(A)&&d&&m&&(f.vertical=gu(g,e,r,i,u,T,y,I,M,k,_,du.vertical,!1,E,c,p));}}var O=void 0,U=!1;if(a.icon&&a.icon.name){var j=n[a.icon.name];j&&(O=function(t,e,r){var n=Iu(r),i=e[0]-t.displaySize[0]*n.horizontalAlign,a=e[1]-t.displaySize[1]*n.verticalAlign;return {image:t,top:a,bottom:a+t.displaySize[1],left:i,right:i+t.displaySize[0]}}(i[a.icon.name],s.get("icon-offset").evaluate(a,{},o),s.get("icon-anchor").evaluate(a,{},o)),U=j.sdf,void 0===t.sdfIcons?t.sdfIcons=j.sdf:t.sdfIcons!==j.sdf&&w("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),(j.pixelRatio!==t.pixelRatio||0!==s.get("icon-rotate").constantOr(1))&&(t.iconsNeedLinear=!0));}var q=rl(f.horizontal)||f.vertical;t.iconsInText=!!q&&q.iconsInText,(q||O)&&function(t,e,r,n,i,a,o,s,u,l,p){var c=a.textMaxSize.evaluate(e,{});void 0===c&&(c=o);var h,f=t.layers[0].layout,y=f.get("icon-offset").evaluate(e,{},p),d=rl(r.horizontal),m=o/24,v=t.tilePixelRatio*m,g=t.tilePixelRatio*c/24,x=t.tilePixelRatio*s,b=t.tilePixelRatio*f.get("symbol-spacing"),_=f.get("text-padding")*t.tilePixelRatio,A=f.get("icon-padding")*t.tilePixelRatio,S=f.get("text-max-angle")/180*Math.PI,k="map"===f.get("text-rotation-alignment")&&"point"!==f.get("symbol-placement"),I="map"===f.get("icon-rotation-alignment")&&"point"!==f.get("symbol-placement"),z=f.get("symbol-placement"),C=b/2,M=f.get("icon-text-fit");n&&"none"!==M&&(t.allowVerticalPlacement&&r.vertical&&(h=Cu(n,r.vertical,M,f.get("icon-text-fit-padding"),y,m)),d&&(n=Cu(n,d,M,f.get("icon-text-fit-padding"),y,m)));var E=function(s,c){c.x<0||c.x>=8192||c.y<0||c.y>=8192||function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b,_,A,S,k){var I,z,C,M,E,T=t.addToLineVertexArray(e,r),P=0,B=0,V=0,F=0,D=-1,L=-1,R={},O=la(""),U=0,j=0;if(void 0===s._unevaluatedLayout.getValue("text-radial-offset")?(U=(I=s.layout.get("text-offset").evaluate(b,{},S).map((function(t){return 24*t})))[0],j=I[1]):(U=24*s.layout.get("text-radial-offset").evaluate(b,{},S),j=Wu),t.allowVerticalPlacement&&n.vertical){var q=s.layout.get("text-rotate").evaluate(b,{},S)+90;M=new Zu(u,e,l,p,c,n.vertical,h,f,y,q),o&&(E=new Zu(u,e,l,p,c,o,m,v,y,q));}if(i){var N=s.layout.get("icon-rotate").evaluate(b,{}),K="none"!==s.layout.get("icon-text-fit"),G=ju(i,N,A,K),Z=o?ju(o,N,A,K):void 0;C=new Zu(u,e,l,p,c,i,m,v,!1,N),P=4*G.length;var X=t.iconSizeData,J=null;"source"===X.kind?(J=[128*s.layout.get("icon-size").evaluate(b,{})])[0]>32640&&w(t.layerIds[0]+': Value for "icon-size" is >= 255. Reduce your "icon-size".'):"composite"===X.kind&&((J=[128*_.compositeIconSizes[0].evaluate(b,{},S),128*_.compositeIconSizes[1].evaluate(b,{},S)])[0]>32640||J[1]>32640)&&w(t.layerIds[0]+': Value for "icon-size" is >= 255. Reduce your "icon-size".'),t.addSymbols(t.icon,G,J,x,g,b,!1,e,T.lineStartIndex,T.lineLength,-1,S),D=t.icon.placedSymbolArray.length-1,Z&&(B=4*Z.length,t.addSymbols(t.icon,Z,J,x,g,b,du.vertical,e,T.lineStartIndex,T.lineLength,-1,S),L=t.icon.placedSymbolArray.length-1);}for(var H in n.horizontal){var Y=n.horizontal[H];if(!z){O=la(Y.text);var $=s.layout.get("text-rotate").evaluate(b,{},S);z=new Zu(u,e,l,p,c,Y,h,f,y,$);}var W=1===Y.positionedLines.length;if(V+=el(t,e,Y,a,s,y,b,d,T,n.vertical?du.horizontal:du.horizontalOnly,W?Object.keys(n.horizontal):[H],R,D,_,S),W)break}n.vertical&&(F+=el(t,e,n.vertical,a,s,y,b,d,T,du.vertical,["vertical"],R,L,_,S));var Q=z?z.boxStartIndex:t.collisionBoxArray.length,tt=z?z.boxEndIndex:t.collisionBoxArray.length,et=M?M.boxStartIndex:t.collisionBoxArray.length,rt=M?M.boxEndIndex:t.collisionBoxArray.length,nt=C?C.boxStartIndex:t.collisionBoxArray.length,it=C?C.boxEndIndex:t.collisionBoxArray.length,at=E?E.boxStartIndex:t.collisionBoxArray.length,ot=E?E.boxEndIndex:t.collisionBoxArray.length,st=-1,ut=function(t,e){return t&&t.circleDiameter?Math.max(t.circleDiameter,e):e};st=ut(z,st),st=ut(M,st),st=ut(C,st);var lt=(st=ut(E,st))>-1?1:0;lt&&(st*=k/24),t.glyphOffsetArray.length>=cl.MAX_GLYPHS&&w("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"),void 0!==b.sortKey&&t.addToSortKeyRanges(t.symbolInstances.length,b.sortKey),t.symbolInstances.emplaceBack(e.x,e.y,R.right>=0?R.right:-1,R.center>=0?R.center:-1,R.left>=0?R.left:-1,R.vertical||-1,D,L,O,Q,tt,et,rt,nt,it,at,ot,l,V,F,P,B,lt,0,h,U,j,st);}(t,c,s,r,n,i,h,t.layers[0],t.collisionBoxArray,e.index,e.sourceLayerIndex,t.index,v,_,k,u,x,A,I,y,e,a,l,p,o);};if("line"===z)for(var T=0,P=Uu(e.geometry,0,0,8192,8192);T<P.length;T+=1)for(var B=P[T],V=0,F=Ou(B,b,S,r.vertical||d,n,24,g,t.overscaling,8192);V<F.length;V+=1){var D=F[V];d&&nl(t,d.text,C,D)||E(B,D);}else if("line-center"===z)for(var L=0,R=e.geometry;L<R.length;L+=1){var O=R[L];if(O.length>1){var U=Ru(O,S,r.vertical||d,n,24,g);U&&E(O,U);}}else if("Polygon"===e.type)for(var j=0,q=Wo(e.geometry,0);j<q.length;j+=1){var N=q[j],K=Hu(N,16);E(N[0],new Mu(K.x,K.y,0));}else if("LineString"===e.type)for(var G=0,Z=e.geometry;G<Z.length;G+=1){var X=Z[G];E(X,new Mu(X[0].x,X[0].y,0));}else if("Point"===e.type)for(var J=0,H=e.geometry;J<H.length;J+=1)for(var Y=0,$=H[J];Y<$.length;Y+=1){var W=$[Y];E([W],new Mu(W.x,W.y,0));}}(t,a,f,O,n,l,c,h,_,U,o);},x=0,b=t.features;x<b.length;x+=1)g();a&&t.generateCollisionDebugBuffers();},t.perspective=function(t,e,r,n,i){var a,o=1/Math.tan(e/2);return t[0]=o/r,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=o,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=-1,t[12]=0,t[13]=0,t[15]=0,null!=i&&i!==1/0?(t[10]=(i+n)*(a=1/(n-i)),t[14]=2*i*n*a):(t[10]=-1,t[14]=-2*n),t},t.pick=function(t,e){for(var r={},n=0;n<e.length;n++){var i=e[n];i in t&&(r[i]=t[i]);}return r},t.plugin=ni,t.polygonIntersectsPolygon=Ra,t.postMapLoadEvent=it,t.postTurnstileEvent=rt,t.potpack=cu,t.refProperties=["type","source","source-layer","minzoom","maxzoom","filter","layout"],t.register=Fn,t.registerForPluginStateChange=function(t){return t({pluginStatus:Yn,pluginURL:$n}),ti.on("pluginStateChange",t),t},t.rotate=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=Math.sin(r),u=Math.cos(r);return t[0]=n*u+a*s,t[1]=i*u+o*s,t[2]=n*-s+a*u,t[3]=i*-s+o*u,t},t.rotateX=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[4],o=e[5],s=e[6],u=e[7],l=e[8],p=e[9],c=e[10],h=e[11];return e!==t&&(t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[4]=a*i+l*n,t[5]=o*i+p*n,t[6]=s*i+c*n,t[7]=u*i+h*n,t[8]=l*i-a*n,t[9]=p*i-o*n,t[10]=c*i-s*n,t[11]=h*i-u*n,t},t.rotateZ=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[0],o=e[1],s=e[2],u=e[3],l=e[4],p=e[5],c=e[6],h=e[7];return e!==t&&(t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=a*i+l*n,t[1]=o*i+p*n,t[2]=s*i+c*n,t[3]=u*i+h*n,t[4]=l*i-a*n,t[5]=p*i-o*n,t[6]=c*i-s*n,t[7]=h*i-u*n,t},t.scale=function(t,e,r){var n=r[0],i=r[1],a=r[2];return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t[3]=e[3]*n,t[4]=e[4]*i,t[5]=e[5]*i,t[6]=e[6]*i,t[7]=e[7]*i,t[8]=e[8]*a,t[9]=e[9]*a,t[10]=e[10]*a,t[11]=e[11]*a,t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],t},t.scale$1=function(t,e,r){return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t[3]=e[3]*r,t},t.scale$2=function(t,e,r){return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t},t.setCacheLimits=function(t,e){at=t,ot=e;},t.setRTLTextPlugin=function(t,e,r){if(void 0===r&&(r=!1),"deferred"===Yn||"loading"===Yn||"loaded"===Yn)throw new Error("setRTLTextPlugin cannot be called multiple times.");$n=D.resolveURL(t),Yn="deferred",Hn=e,Qn(),r||ri();},t.sphericalToCartesian=function(t){var e=t[0],r=t[1],n=t[2];return r+=90,r*=Math.PI/180,n*=Math.PI/180,{x:e*Math.cos(r)*Math.sin(n),y:e*Math.sin(r)*Math.sin(n),z:e*Math.cos(n)}},t.sqrLen=function(t){var e=t[0],r=t[1];return e*e+r*r},t.styleSpec=It,t.sub=function(t,e,r){return t[0]=e[0]-r[0],t[1]=e[1]-r[1],t[2]=e[2]-r[2],t},t.symbolSize=Bu,t.transformMat3=function(t,e,r){var n=e[0],i=e[1],a=e[2];return t[0]=n*r[0]+i*r[3]+a*r[6],t[1]=n*r[1]+i*r[4]+a*r[7],t[2]=n*r[2]+i*r[5]+a*r[8],t},t.transformMat4=ao,t.translate=function(t,e,r){var n,i,a,o,s,u,l,p,c,h,f,y,d=r[0],m=r[1],v=r[2];return e===t?(t[12]=e[0]*d+e[4]*m+e[8]*v+e[12],t[13]=e[1]*d+e[5]*m+e[9]*v+e[13],t[14]=e[2]*d+e[6]*m+e[10]*v+e[14],t[15]=e[3]*d+e[7]*m+e[11]*v+e[15]):(i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],c=e[8],h=e[9],f=e[10],y=e[11],t[0]=n=e[0],t[1]=i,t[2]=a,t[3]=o,t[4]=s,t[5]=u,t[6]=l,t[7]=p,t[8]=c,t[9]=h,t[10]=f,t[11]=y,t[12]=n*d+s*m+c*v+e[12],t[13]=i*d+u*m+h*v+e[13],t[14]=a*d+l*m+f*v+e[14],t[15]=o*d+p*m+y*v+e[15]),t},t.triggerPluginCompletionEvent=Wn,t.uniqueId=h,t.validateCustomStyleLayer=function(t){var e=[],r=t.id;return void 0===r&&e.push({message:"layers."+r+': missing required property "id"'}),void 0===t.render&&e.push({message:"layers."+r+': missing required method "render"'}),t.renderingMode&&"2d"!==t.renderingMode&&"3d"!==t.renderingMode&&e.push({message:"layers."+r+': property "renderingMode" must be either "2d" or "3d"'}),e},t.validateLight=In,t.validateStyle=kn,t.values=function(t){var e=[];for(var r in t)e.push(t[r]);return e},t.vectorTile=ds,t.version="1.10.1",t.warnOnce=w,t.webpSupported=R,t.window=self,t.wrap=l;}));
  
  define(["./shared"],(function(e){"use strict";function t(e){var r=typeof e;if("number"===r||"boolean"===r||"string"===r||null==e)return JSON.stringify(e);if(Array.isArray(e)){for(var i="[",o=0,n=e;o<n.length;o+=1)i+=t(n[o])+",";return i+"]"}for(var s=Object.keys(e).sort(),a="{",l=0;l<s.length;l++)a+=JSON.stringify(s[l])+":"+t(e[s[l]])+",";return a+"}"}function r(r){for(var i="",o=0,n=e.refProperties;o<n.length;o+=1)i+="/"+t(r[n[o]]);return i}var i=function(e){this.keyCache={},e&&this.replace(e);};i.prototype.replace=function(e){this._layerConfigs={},this._layers={},this.update(e,[]);},i.prototype.update=function(t,i){for(var o=this,n=0,s=t;n<s.length;n+=1){var a=s[n];this._layerConfigs[a.id]=a;var l=this._layers[a.id]=e.createStyleLayer(a);l._featureFilter=e.featureFilter(l.filter),this.keyCache[a.id]&&delete this.keyCache[a.id];}for(var u=0,h=i;u<h.length;u+=1){var c=h[u];delete this.keyCache[c],delete this._layerConfigs[c],delete this._layers[c];}this.familiesBySource={};for(var p=0,f=function(e,t){for(var i={},o=0;o<e.length;o++){var n=t&&t[e[o].id]||r(e[o]);t&&(t[e[o].id]=n);var s=i[n];s||(s=i[n]=[]),s.push(e[o]);}var a=[];for(var l in i)a.push(i[l]);return a}(e.values(this._layerConfigs),this.keyCache);p<f.length;p+=1){var d=f[p].map((function(e){return o._layers[e.id]})),g=d[0];if("none"!==g.visibility){var v=g.source||"",m=this.familiesBySource[v];m||(m=this.familiesBySource[v]={});var y=g.sourceLayer||"_geojsonTileLayer",x=m[y];x||(x=m[y]=[]),x.push(d);}}};var o=function(t){var r={},i=[];for(var o in t){var n=t[o],s=r[o]={};for(var a in n){var l=n[+a];if(l&&0!==l.bitmap.width&&0!==l.bitmap.height){var u={x:0,y:0,w:l.bitmap.width+2,h:l.bitmap.height+2};i.push(u),s[a]={rect:u,metrics:l.metrics};}}}var h=e.potpack(i),c=new e.AlphaImage({width:h.w||1,height:h.h||1});for(var p in t){var f=t[p];for(var d in f){var g=f[+d];if(g&&0!==g.bitmap.width&&0!==g.bitmap.height){var v=r[p][d].rect;e.AlphaImage.copy(g.bitmap,c,{x:0,y:0},{x:v.x+1,y:v.y+1},g.bitmap);}}}this.image=c,this.positions=r;};e.register("GlyphAtlas",o);var n=function(t){this.tileID=new e.OverscaledTileID(t.tileID.overscaledZ,t.tileID.wrap,t.tileID.canonical.z,t.tileID.canonical.x,t.tileID.canonical.y),this.uid=t.uid,this.zoom=t.zoom,this.pixelRatio=t.pixelRatio,this.tileSize=t.tileSize,this.source=t.source,this.overscaling=this.tileID.overscaleFactor(),this.showCollisionBoxes=t.showCollisionBoxes,this.collectResourceTiming=!!t.collectResourceTiming,this.returnDependencies=!!t.returnDependencies,this.promoteId=t.promoteId;};function s(t,r,i){for(var o=new e.EvaluationParameters(r),n=0,s=t;n<s.length;n+=1)s[n].recalculate(o,i);}function a(t,r){var i=e.getArrayBuffer(t.request,(function(t,i,o,n){t?r(t):i&&r(null,{vectorTile:new e.vectorTile.VectorTile(new e.pbf(i)),rawData:i,cacheControl:o,expires:n});}));return function(){i.cancel(),r();}}n.prototype.parse=function(t,r,i,n,a){var l=this;this.status="parsing",this.data=t,this.collisionBoxArray=new e.CollisionBoxArray;var u=new e.DictionaryCoder(Object.keys(t.layers).sort()),h=new e.FeatureIndex(this.tileID,this.promoteId);h.bucketLayerIDs=[];var c,p,f,d,g={},v={featureIndex:h,iconDependencies:{},patternDependencies:{},glyphDependencies:{},availableImages:i},m=r.familiesBySource[this.source];for(var y in m){var x=t.layers[y];if(x){1===x.version&&e.warnOnce('Vector tile source "'+this.source+'" layer "'+y+'" does not use vector tile spec v2 and therefore may have some rendering errors.');for(var w=u.encode(y),S=[],I=0;I<x.length;I++){var M=x.feature(I),b=h.getId(M,y);S.push({feature:M,id:b,index:I,sourceLayerIndex:w});}for(var _=0,k=m[y];_<k.length;_+=1){var P=k[_],T=P[0];T.minzoom&&this.zoom<Math.floor(T.minzoom)||T.maxzoom&&this.zoom>=T.maxzoom||"none"!==T.visibility&&(s(P,this.zoom,i),(g[T.id]=T.createBucket({index:h.bucketLayerIDs.length,layers:P,zoom:this.zoom,pixelRatio:this.pixelRatio,overscaling:this.overscaling,collisionBoxArray:this.collisionBoxArray,sourceLayerIndex:w,sourceID:this.source})).populate(S,v,this.tileID.canonical),h.bucketLayerIDs.push(P.map((function(e){return e.id}))));}}}var C=e.mapObject(v.glyphDependencies,(function(e){return Object.keys(e).map(Number)}));Object.keys(C).length?n.send("getGlyphs",{uid:this.uid,stacks:C},(function(e,t){c||(c=e,p=t,O.call(l));})):p={};var D=Object.keys(v.iconDependencies);D.length?n.send("getImages",{icons:D,source:this.source,tileID:this.tileID,type:"icons"},(function(e,t){c||(c=e,f=t,O.call(l));})):f={};var L=Object.keys(v.patternDependencies);function O(){if(c)return a(c);if(p&&f&&d){var t=new o(p),r=new e.ImageAtlas(f,d);for(var n in g){var l=g[n];l instanceof e.SymbolBucket?(s(l.layers,this.zoom,i),e.performSymbolLayout(l,p,t.positions,f,r.iconPositions,this.showCollisionBoxes,this.tileID.canonical)):l.hasPattern&&(l instanceof e.LineBucket||l instanceof e.FillBucket||l instanceof e.FillExtrusionBucket)&&(s(l.layers,this.zoom,i),l.addFeatures(v,this.tileID.canonical,r.patternPositions));}this.status="done",a(null,{buckets:e.values(g).filter((function(e){return !e.isEmpty()})),featureIndex:h,collisionBoxArray:this.collisionBoxArray,glyphAtlasImage:t.image,imageAtlas:r,glyphMap:this.returnDependencies?p:null,iconMap:this.returnDependencies?f:null,glyphPositions:this.returnDependencies?t.positions:null});}}L.length?n.send("getImages",{icons:L,source:this.source,tileID:this.tileID,type:"patterns"},(function(e,t){c||(c=e,d=t,O.call(l));})):d={},O.call(this);};var l=function(e,t,r,i){this.actor=e,this.layerIndex=t,this.availableImages=r,this.loadVectorData=i||a,this.loading={},this.loaded={};};l.prototype.loadTile=function(t,r){var i=this,o=t.uid;this.loading||(this.loading={});var s=!!(t&&t.request&&t.request.collectResourceTiming)&&new e.RequestPerformance(t.request),a=this.loading[o]=new n(t);a.abort=this.loadVectorData(t,(function(t,n){if(delete i.loading[o],t||!n)return a.status="done",i.loaded[o]=a,r(t);var l=n.rawData,u={};n.expires&&(u.expires=n.expires),n.cacheControl&&(u.cacheControl=n.cacheControl);var h={};if(s){var c=s.finish();c&&(h.resourceTiming=JSON.parse(JSON.stringify(c)));}a.vectorTile=n.vectorTile,a.parse(n.vectorTile,i.layerIndex,i.availableImages,i.actor,(function(t,i){if(t||!i)return r(t);r(null,e.extend({rawTileData:l.slice(0)},i,u,h));})),i.loaded=i.loaded||{},i.loaded[o]=a;}));},l.prototype.reloadTile=function(e,t){var r=this,i=this.loaded,o=e.uid,n=this;if(i&&i[o]){var s=i[o];s.showCollisionBoxes=e.showCollisionBoxes;var a=function(e,i){var o=s.reloadCallback;o&&(delete s.reloadCallback,s.parse(s.vectorTile,n.layerIndex,r.availableImages,n.actor,o)),t(e,i);};"parsing"===s.status?s.reloadCallback=a:"done"===s.status&&(s.vectorTile?s.parse(s.vectorTile,this.layerIndex,this.availableImages,this.actor,a):a());}},l.prototype.abortTile=function(e,t){var r=this.loading,i=e.uid;r&&r[i]&&r[i].abort&&(r[i].abort(),delete r[i]),t();},l.prototype.removeTile=function(e,t){var r=this.loaded,i=e.uid;r&&r[i]&&delete r[i],t();};var u=e.window.ImageBitmap,h=function(){this.loaded={};};function c(e,t){if(0!==e.length){p(e[0],t);for(var r=1;r<e.length;r++)p(e[r],!t);}}function p(e,t){for(var r=0,i=0,o=e.length,n=o-1;i<o;n=i++)r+=(e[i][0]-e[n][0])*(e[n][1]+e[i][1]);r>=0!=!!t&&e.reverse();}h.prototype.loadTile=function(t,r){var i=t.uid,o=t.encoding,n=t.rawImageData,s=u&&n instanceof u?this.getImageData(n):n,a=new e.DEMData(i,s,o);this.loaded=this.loaded||{},this.loaded[i]=a,r(null,a);},h.prototype.getImageData=function(t){this.offscreenCanvas&&this.offscreenCanvasContext||(this.offscreenCanvas=new OffscreenCanvas(t.width,t.height),this.offscreenCanvasContext=this.offscreenCanvas.getContext("2d")),this.offscreenCanvas.width=t.width,this.offscreenCanvas.height=t.height,this.offscreenCanvasContext.drawImage(t,0,0,t.width,t.height);var r=this.offscreenCanvasContext.getImageData(-1,-1,t.width+2,t.height+2);return this.offscreenCanvasContext.clearRect(0,0,this.offscreenCanvas.width,this.offscreenCanvas.height),new e.RGBAImage({width:r.width,height:r.height},r.data)},h.prototype.removeTile=function(e){var t=this.loaded,r=e.uid;t&&t[r]&&delete t[r];};var f=e.vectorTile.VectorTileFeature.prototype.toGeoJSON,d=function(t){this._feature=t,this.extent=e.EXTENT,this.type=t.type,this.properties=t.tags,"id"in t&&!isNaN(t.id)&&(this.id=parseInt(t.id,10));};d.prototype.loadGeometry=function(){if(1===this._feature.type){for(var t=[],r=0,i=this._feature.geometry;r<i.length;r+=1){var o=i[r];t.push([new e.Point$1(o[0],o[1])]);}return t}for(var n=[],s=0,a=this._feature.geometry;s<a.length;s+=1){for(var l=[],u=0,h=a[s];u<h.length;u+=1){var c=h[u];l.push(new e.Point$1(c[0],c[1]));}n.push(l);}return n},d.prototype.toGeoJSON=function(e,t,r){return f.call(this,e,t,r)};var g=function(t){this.layers={_geojsonTileLayer:this},this.name="_geojsonTileLayer",this.extent=e.EXTENT,this.length=t.length,this._features=t;};g.prototype.feature=function(e){return new d(this._features[e])};var v=e.vectorTile.VectorTileFeature,m=y;function y(e,t){this.options=t||{},this.features=e,this.length=e.length;}function x(e,t){this.id="number"==typeof e.id?e.id:void 0,this.type=e.type,this.rawGeometry=1===e.type?[e.geometry]:e.geometry,this.properties=e.tags,this.extent=t||4096;}y.prototype.feature=function(e){return new x(this.features[e],this.options.extent)},x.prototype.loadGeometry=function(){var t=this.rawGeometry;this.geometry=[];for(var r=0;r<t.length;r++){for(var i=t[r],o=[],n=0;n<i.length;n++)o.push(new e.Point$1(i[n][0],i[n][1]));this.geometry.push(o);}return this.geometry},x.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-1/0,i=1/0,o=-1/0,n=0;n<e.length;n++)for(var s=e[n],a=0;a<s.length;a++){var l=s[a];t=Math.min(t,l.x),r=Math.max(r,l.x),i=Math.min(i,l.y),o=Math.max(o,l.y);}return [t,i,r,o]},x.prototype.toGeoJSON=v.prototype.toGeoJSON;var w=I,S=m;function I(t){var r=new e.pbf;return function(e,t){for(var r in e.layers)t.writeMessage(3,M,e.layers[r]);}(t,r),r.finish()}function M(e,t){var r;t.writeVarintField(15,e.version||1),t.writeStringField(1,e.name||""),t.writeVarintField(5,e.extent||4096);var i={keys:[],values:[],keycache:{},valuecache:{}};for(r=0;r<e.length;r++)i.feature=e.feature(r),t.writeMessage(2,b,i);var o=i.keys;for(r=0;r<o.length;r++)t.writeStringField(3,o[r]);var n=i.values;for(r=0;r<n.length;r++)t.writeMessage(4,C,n[r]);}function b(e,t){var r=e.feature;void 0!==r.id&&t.writeVarintField(1,r.id),t.writeMessage(2,_,e),t.writeVarintField(3,r.type),t.writeMessage(4,T,r);}function _(e,t){var r=e.feature,i=e.keys,o=e.values,n=e.keycache,s=e.valuecache;for(var a in r.properties){var l=n[a];void 0===l&&(i.push(a),n[a]=l=i.length-1),t.writeVarint(l);var u=r.properties[a],h=typeof u;"string"!==h&&"boolean"!==h&&"number"!==h&&(u=JSON.stringify(u));var c=h+":"+u,p=s[c];void 0===p&&(o.push(u),s[c]=p=o.length-1),t.writeVarint(p);}}function k(e,t){return (t<<3)+(7&e)}function P(e){return e<<1^e>>31}function T(e,t){for(var r=e.loadGeometry(),i=e.type,o=0,n=0,s=r.length,a=0;a<s;a++){var l=r[a],u=1;1===i&&(u=l.length),t.writeVarint(k(1,u));for(var h=3===i?l.length-1:l.length,c=0;c<h;c++){1===c&&1!==i&&t.writeVarint(k(2,h-1));var p=l[c].x-o,f=l[c].y-n;t.writeVarint(P(p)),t.writeVarint(P(f)),o+=p,n+=f;}3===i&&t.writeVarint(k(7,1));}}function C(e,t){var r=typeof e;"string"===r?t.writeStringField(1,e):"boolean"===r?t.writeBooleanField(7,e):"number"===r&&(e%1!=0?t.writeDoubleField(3,e):e<0?t.writeSVarintField(6,e):t.writeVarintField(5,e));}function D(e,t,r,i){L(e,r,i),L(t,2*r,2*i),L(t,2*r+1,2*i+1);}function L(e,t,r){var i=e[t];e[t]=e[r],e[r]=i;}function O(e,t,r,i){var o=e-r,n=t-i;return o*o+n*n}w.fromVectorTileJs=I,w.fromGeojsonVt=function(e,t){t=t||{};var r={};for(var i in e)r[i]=new m(e[i].features,t),r[i].name=i,r[i].version=t.version,r[i].extent=t.extent;return I({layers:r})},w.GeoJSONWrapper=S;var z=function(e){return e[0]},E=function(e){return e[1]},F=function(e,t,r,i,o){void 0===t&&(t=z),void 0===r&&(r=E),void 0===i&&(i=64),void 0===o&&(o=Float64Array),this.nodeSize=i,this.points=e;for(var n=e.length<65536?Uint16Array:Uint32Array,s=this.ids=new n(e.length),a=this.coords=new o(2*e.length),l=0;l<e.length;l++)s[l]=l,a[2*l]=t(e[l]),a[2*l+1]=r(e[l]);!function e(t,r,i,o,n,s){if(!(n-o<=i)){var a=o+n>>1;!function e(t,r,i,o,n,s){for(;n>o;){if(n-o>600){var a=n-o+1,l=i-o+1,u=Math.log(a),h=.5*Math.exp(2*u/3),c=.5*Math.sqrt(u*h*(a-h)/a)*(l-a/2<0?-1:1);e(t,r,i,Math.max(o,Math.floor(i-l*h/a+c)),Math.min(n,Math.floor(i+(a-l)*h/a+c)),s);}var p=r[2*i+s],f=o,d=n;for(D(t,r,o,i),r[2*n+s]>p&&D(t,r,o,n);f<d;){for(D(t,r,f,d),f++,d--;r[2*f+s]<p;)f++;for(;r[2*d+s]>p;)d--;}r[2*o+s]===p?D(t,r,o,d):D(t,r,++d,n),d<=i&&(o=d+1),i<=d&&(n=d-1);}}(t,r,a,o,n,s%2),e(t,r,i,o,a-1,s+1),e(t,r,i,a+1,n,s+1);}}(s,a,i,0,s.length-1,0);};F.prototype.range=function(e,t,r,i){return function(e,t,r,i,o,n,s){for(var a,l,u=[0,e.length-1,0],h=[];u.length;){var c=u.pop(),p=u.pop(),f=u.pop();if(p-f<=s)for(var d=f;d<=p;d++)l=t[2*d+1],(a=t[2*d])>=r&&a<=o&&l>=i&&l<=n&&h.push(e[d]);else {var g=Math.floor((f+p)/2);l=t[2*g+1],(a=t[2*g])>=r&&a<=o&&l>=i&&l<=n&&h.push(e[g]);var v=(c+1)%2;(0===c?r<=a:i<=l)&&(u.push(f),u.push(g-1),u.push(v)),(0===c?o>=a:n>=l)&&(u.push(g+1),u.push(p),u.push(v));}}return h}(this.ids,this.coords,e,t,r,i,this.nodeSize)},F.prototype.within=function(e,t,r){return function(e,t,r,i,o,n){for(var s=[0,e.length-1,0],a=[],l=o*o;s.length;){var u=s.pop(),h=s.pop(),c=s.pop();if(h-c<=n)for(var p=c;p<=h;p++)O(t[2*p],t[2*p+1],r,i)<=l&&a.push(e[p]);else {var f=Math.floor((c+h)/2),d=t[2*f],g=t[2*f+1];O(d,g,r,i)<=l&&a.push(e[f]);var v=(u+1)%2;(0===u?r-o<=d:i-o<=g)&&(s.push(c),s.push(f-1),s.push(v)),(0===u?r+o>=d:i+o>=g)&&(s.push(f+1),s.push(h),s.push(v));}}return a}(this.ids,this.coords,e,t,r,this.nodeSize)};var N={minZoom:0,maxZoom:16,radius:40,extent:512,nodeSize:64,log:!1,generateId:!1,reduce:null,map:function(e){return e}},J=function(e){this.options=V(Object.create(N),e),this.trees=new Array(this.options.maxZoom+1);};function Z(e,t,r,i,o){return {x:e,y:t,zoom:1/0,id:r,parentId:-1,numPoints:i,properties:o}}function A(e,t){var r=e.geometry.coordinates,i=r[1];return {x:Y(r[0]),y:j(i),zoom:1/0,index:t,parentId:-1}}function B(e){return {type:"Feature",id:e.id,properties:G(e),geometry:{type:"Point",coordinates:[(i=e.x,360*(i-.5)),(t=e.y,r=(180-360*t)*Math.PI/180,360*Math.atan(Math.exp(r))/Math.PI-90)]}};var t,r,i;}function G(e){var t=e.numPoints,r=t>=1e4?Math.round(t/1e3)+"k":t>=1e3?Math.round(t/100)/10+"k":t;return V(V({},e.properties),{cluster:!0,cluster_id:e.id,point_count:t,point_count_abbreviated:r})}function Y(e){return e/360+.5}function j(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function V(e,t){for(var r in t)e[r]=t[r];return e}function X(e){return e.x}function W(e){return e.y}function R(e,t,r,i,o,n){var s=o-r,a=n-i;if(0!==s||0!==a){var l=((e-r)*s+(t-i)*a)/(s*s+a*a);l>1?(r=o,i=n):l>0&&(r+=s*l,i+=a*l);}return (s=e-r)*s+(a=t-i)*a}function q(e,t,r,i){var o={id:void 0===e?null:e,type:t,geometry:r,tags:i,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};return function(e){var t=e.geometry,r=e.type;if("Point"===r||"MultiPoint"===r||"LineString"===r)U(e,t);else if("Polygon"===r||"MultiLineString"===r)for(var i=0;i<t.length;i++)U(e,t[i]);else if("MultiPolygon"===r)for(i=0;i<t.length;i++)for(var o=0;o<t[i].length;o++)U(e,t[i][o]);}(o),o}function U(e,t){for(var r=0;r<t.length;r+=3)e.minX=Math.min(e.minX,t[r]),e.minY=Math.min(e.minY,t[r+1]),e.maxX=Math.max(e.maxX,t[r]),e.maxY=Math.max(e.maxY,t[r+1]);}function $(e,t,r,i){if(t.geometry){var o=t.geometry.coordinates,n=t.geometry.type,s=Math.pow(r.tolerance/((1<<r.maxZoom)*r.extent),2),a=[],l=t.id;if(r.promoteId?l=t.properties[r.promoteId]:r.generateId&&(l=i||0),"Point"===n)H(o,a);else if("MultiPoint"===n)for(var u=0;u<o.length;u++)H(o[u],a);else if("LineString"===n)K(o,a,s,!1);else if("MultiLineString"===n){if(r.lineMetrics){for(u=0;u<o.length;u++)K(o[u],a=[],s,!1),e.push(q(l,"LineString",a,t.properties));return}Q(o,a,s,!1);}else if("Polygon"===n)Q(o,a,s,!0);else {if("MultiPolygon"!==n){if("GeometryCollection"===n){for(u=0;u<t.geometry.geometries.length;u++)$(e,{id:l,geometry:t.geometry.geometries[u],properties:t.properties},r,i);return}throw new Error("Input data is not a valid GeoJSON object.")}for(u=0;u<o.length;u++){var h=[];Q(o[u],h,s,!0),a.push(h);}}e.push(q(l,n,a,t.properties));}}function H(e,t){t.push(ee(e[0])),t.push(te(e[1])),t.push(0);}function K(e,t,r,i){for(var o,n,s=0,a=0;a<e.length;a++){var l=ee(e[a][0]),u=te(e[a][1]);t.push(l),t.push(u),t.push(0),a>0&&(s+=i?(o*u-l*n)/2:Math.sqrt(Math.pow(l-o,2)+Math.pow(u-n,2))),o=l,n=u;}var h=t.length-3;t[2]=1,function e(t,r,i,o){for(var n,s=o,a=i-r>>1,l=i-r,u=t[r],h=t[r+1],c=t[i],p=t[i+1],f=r+3;f<i;f+=3){var d=R(t[f],t[f+1],u,h,c,p);if(d>s)n=f,s=d;else if(d===s){var g=Math.abs(f-a);g<l&&(n=f,l=g);}}s>o&&(n-r>3&&e(t,r,n,o),t[n+2]=s,i-n>3&&e(t,n,i,o));}(t,0,h,r),t[h+2]=1,t.size=Math.abs(s),t.start=0,t.end=t.size;}function Q(e,t,r,i){for(var o=0;o<e.length;o++){var n=[];K(e[o],n,r,i),t.push(n);}}function ee(e){return e/360+.5}function te(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function re(e,t,r,i,o,n,s,a){if(i/=t,n>=(r/=t)&&s<i)return e;if(s<r||n>=i)return null;for(var l=[],u=0;u<e.length;u++){var h=e[u],c=h.geometry,p=h.type,f=0===o?h.minX:h.minY,d=0===o?h.maxX:h.maxY;if(f>=r&&d<i)l.push(h);else if(!(d<r||f>=i)){var g=[];if("Point"===p||"MultiPoint"===p)ie(c,g,r,i,o);else if("LineString"===p)oe(c,g,r,i,o,!1,a.lineMetrics);else if("MultiLineString"===p)se(c,g,r,i,o,!1);else if("Polygon"===p)se(c,g,r,i,o,!0);else if("MultiPolygon"===p)for(var v=0;v<c.length;v++){var m=[];se(c[v],m,r,i,o,!0),m.length&&g.push(m);}if(g.length){if(a.lineMetrics&&"LineString"===p){for(v=0;v<g.length;v++)l.push(q(h.id,p,g[v],h.tags));continue}"LineString"!==p&&"MultiLineString"!==p||(1===g.length?(p="LineString",g=g[0]):p="MultiLineString"),"Point"!==p&&"MultiPoint"!==p||(p=3===g.length?"Point":"MultiPoint"),l.push(q(h.id,p,g,h.tags));}}}return l.length?l:null}function ie(e,t,r,i,o){for(var n=0;n<e.length;n+=3){var s=e[n+o];s>=r&&s<=i&&(t.push(e[n]),t.push(e[n+1]),t.push(e[n+2]));}}function oe(e,t,r,i,o,n,s){for(var a,l,u=ne(e),h=0===o?le:ue,c=e.start,p=0;p<e.length-3;p+=3){var f=e[p],d=e[p+1],g=e[p+2],v=e[p+3],m=e[p+4],y=0===o?f:d,x=0===o?v:m,w=!1;s&&(a=Math.sqrt(Math.pow(f-v,2)+Math.pow(d-m,2))),y<r?x>r&&(l=h(u,f,d,v,m,r),s&&(u.start=c+a*l)):y>i?x<i&&(l=h(u,f,d,v,m,i),s&&(u.start=c+a*l)):ae(u,f,d,g),x<r&&y>=r&&(l=h(u,f,d,v,m,r),w=!0),x>i&&y<=i&&(l=h(u,f,d,v,m,i),w=!0),!n&&w&&(s&&(u.end=c+a*l),t.push(u),u=ne(e)),s&&(c+=a);}var S=e.length-3;f=e[S],d=e[S+1],g=e[S+2],(y=0===o?f:d)>=r&&y<=i&&ae(u,f,d,g),S=u.length-3,n&&S>=3&&(u[S]!==u[0]||u[S+1]!==u[1])&&ae(u,u[0],u[1],u[2]),u.length&&t.push(u);}function ne(e){var t=[];return t.size=e.size,t.start=e.start,t.end=e.end,t}function se(e,t,r,i,o,n){for(var s=0;s<e.length;s++)oe(e[s],t,r,i,o,n,!1);}function ae(e,t,r,i){e.push(t),e.push(r),e.push(i);}function le(e,t,r,i,o,n){var s=(n-t)/(i-t);return e.push(n),e.push(r+(o-r)*s),e.push(1),s}function ue(e,t,r,i,o,n){var s=(n-r)/(o-r);return e.push(t+(i-t)*s),e.push(n),e.push(1),s}function he(e,t){for(var r=[],i=0;i<e.length;i++){var o,n=e[i],s=n.type;if("Point"===s||"MultiPoint"===s||"LineString"===s)o=ce(n.geometry,t);else if("MultiLineString"===s||"Polygon"===s){o=[];for(var a=0;a<n.geometry.length;a++)o.push(ce(n.geometry[a],t));}else if("MultiPolygon"===s)for(o=[],a=0;a<n.geometry.length;a++){for(var l=[],u=0;u<n.geometry[a].length;u++)l.push(ce(n.geometry[a][u],t));o.push(l);}r.push(q(n.id,s,o,n.tags));}return r}function ce(e,t){var r=[];r.size=e.size,void 0!==e.start&&(r.start=e.start,r.end=e.end);for(var i=0;i<e.length;i+=3)r.push(e[i]+t,e[i+1],e[i+2]);return r}function pe(e,t){if(e.transformed)return e;var r,i,o,n=1<<e.z,s=e.x,a=e.y;for(r=0;r<e.features.length;r++){var l=e.features[r],u=l.geometry,h=l.type;if(l.geometry=[],1===h)for(i=0;i<u.length;i+=2)l.geometry.push(fe(u[i],u[i+1],t,n,s,a));else for(i=0;i<u.length;i++){var c=[];for(o=0;o<u[i].length;o+=2)c.push(fe(u[i][o],u[i][o+1],t,n,s,a));l.geometry.push(c);}}return e.transformed=!0,e}function fe(e,t,r,i,o,n){return [Math.round(r*(e*i-o)),Math.round(r*(t*i-n))]}function de(e,t,r,i,o){for(var n=t===o.maxZoom?0:o.tolerance/((1<<t)*o.extent),s={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:r,y:i,z:t,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0},a=0;a<e.length;a++){s.numFeatures++,ge(s,e[a],n,o);var l=e[a].minX,u=e[a].minY,h=e[a].maxX,c=e[a].maxY;l<s.minX&&(s.minX=l),u<s.minY&&(s.minY=u),h>s.maxX&&(s.maxX=h),c>s.maxY&&(s.maxY=c);}return s}function ge(e,t,r,i){var o=t.geometry,n=t.type,s=[];if("Point"===n||"MultiPoint"===n)for(var a=0;a<o.length;a+=3)s.push(o[a]),s.push(o[a+1]),e.numPoints++,e.numSimplified++;else if("LineString"===n)ve(s,o,e,r,!1,!1);else if("MultiLineString"===n||"Polygon"===n)for(a=0;a<o.length;a++)ve(s,o[a],e,r,"Polygon"===n,0===a);else if("MultiPolygon"===n)for(var l=0;l<o.length;l++){var u=o[l];for(a=0;a<u.length;a++)ve(s,u[a],e,r,!0,0===a);}if(s.length){var h=t.tags||null;if("LineString"===n&&i.lineMetrics){for(var c in h={},t.tags)h[c]=t.tags[c];h.mapbox_clip_start=o.start/o.size,h.mapbox_clip_end=o.end/o.size;}var p={geometry:s,type:"Polygon"===n||"MultiPolygon"===n?3:"LineString"===n||"MultiLineString"===n?2:1,tags:h};null!==t.id&&(p.id=t.id),e.features.push(p);}}function ve(e,t,r,i,o,n){var s=i*i;if(i>0&&t.size<(o?s:i))r.numPoints+=t.length/3;else {for(var a=[],l=0;l<t.length;l+=3)(0===i||t[l+2]>s)&&(r.numSimplified++,a.push(t[l]),a.push(t[l+1])),r.numPoints++;o&&function(e,t){for(var r=0,i=0,o=e.length,n=o-2;i<o;n=i,i+=2)r+=(e[i]-e[n])*(e[i+1]+e[n+1]);if(r>0===t)for(i=0,o=e.length;i<o/2;i+=2){var s=e[i],a=e[i+1];e[i]=e[o-2-i],e[i+1]=e[o-1-i],e[o-2-i]=s,e[o-1-i]=a;}}(a,n),e.push(a);}}function me(e,t){var r=(t=this.options=function(e,t){for(var r in t)e[r]=t[r];return e}(Object.create(this.options),t)).debug;if(r&&console.time("preprocess data"),t.maxZoom<0||t.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");if(t.promoteId&&t.generateId)throw new Error("promoteId and generateId cannot be used together.");var i=function(e,t){var r=[];if("FeatureCollection"===e.type)for(var i=0;i<e.features.length;i++)$(r,e.features[i],t,i);else $(r,"Feature"===e.type?e:{geometry:e},t);return r}(e,t);this.tiles={},this.tileCoords=[],r&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",t.indexMaxZoom,t.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),(i=function(e,t){var r=t.buffer/t.extent,i=e,o=re(e,1,-1-r,r,0,-1,2,t),n=re(e,1,1-r,2+r,0,-1,2,t);return (o||n)&&(i=re(e,1,-r,1+r,0,-1,2,t)||[],o&&(i=he(o,1).concat(i)),n&&(i=i.concat(he(n,-1)))),i}(i,t)).length&&this.splitTile(i,0,0,0),r&&(i.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)));}function ye(e,t,r){return 32*((1<<e)*r+t)+e}function xe(e,t){var r=e.tileID.canonical;if(!this._geoJSONIndex)return t(null,null);var i=this._geoJSONIndex.getTile(r.z,r.x,r.y);if(!i)return t(null,null);var o=new g(i.features),n=w(o);0===n.byteOffset&&n.byteLength===n.buffer.byteLength||(n=new Uint8Array(n)),t(null,{vectorTile:o,rawData:n.buffer});}J.prototype.load=function(e){var t=this.options,r=t.log,i=t.minZoom,o=t.maxZoom,n=t.nodeSize;r&&console.time("total time");var s="prepare "+e.length+" points";r&&console.time(s),this.points=e;for(var a=[],l=0;l<e.length;l++)e[l].geometry&&a.push(A(e[l],l));this.trees[o+1]=new F(a,X,W,n,Float32Array),r&&console.timeEnd(s);for(var u=o;u>=i;u--){var h=+Date.now();a=this._cluster(a,u),this.trees[u]=new F(a,X,W,n,Float32Array),r&&console.log("z%d: %d clusters in %dms",u,a.length,+Date.now()-h);}return r&&console.timeEnd("total time"),this},J.prototype.getClusters=function(e,t){var r=((e[0]+180)%360+360)%360-180,i=Math.max(-90,Math.min(90,e[1])),o=180===e[2]?180:((e[2]+180)%360+360)%360-180,n=Math.max(-90,Math.min(90,e[3]));if(e[2]-e[0]>=360)r=-180,o=180;else if(r>o){var s=this.getClusters([r,i,180,n],t),a=this.getClusters([-180,i,o,n],t);return s.concat(a)}for(var l=this.trees[this._limitZoom(t)],u=[],h=0,c=l.range(Y(r),j(n),Y(o),j(i));h<c.length;h+=1){var p=l.points[c[h]];u.push(p.numPoints?B(p):this.points[p.index]);}return u},J.prototype.getChildren=function(e){var t=this._getOriginId(e),r=this._getOriginZoom(e),i="No cluster with the specified id.",o=this.trees[r];if(!o)throw new Error(i);var n=o.points[t];if(!n)throw new Error(i);for(var s=this.options.radius/(this.options.extent*Math.pow(2,r-1)),a=[],l=0,u=o.within(n.x,n.y,s);l<u.length;l+=1){var h=o.points[u[l]];h.parentId===e&&a.push(h.numPoints?B(h):this.points[h.index]);}if(0===a.length)throw new Error(i);return a},J.prototype.getLeaves=function(e,t,r){var i=[];return this._appendLeaves(i,e,t=t||10,r=r||0,0),i},J.prototype.getTile=function(e,t,r){var i=this.trees[this._limitZoom(e)],o=Math.pow(2,e),n=this.options,s=n.radius/n.extent,a=(r-s)/o,l=(r+1+s)/o,u={features:[]};return this._addTileFeatures(i.range((t-s)/o,a,(t+1+s)/o,l),i.points,t,r,o,u),0===t&&this._addTileFeatures(i.range(1-s/o,a,1,l),i.points,o,r,o,u),t===o-1&&this._addTileFeatures(i.range(0,a,s/o,l),i.points,-1,r,o,u),u.features.length?u:null},J.prototype.getClusterExpansionZoom=function(e){for(var t=this._getOriginZoom(e)-1;t<=this.options.maxZoom;){var r=this.getChildren(e);if(t++,1!==r.length)break;e=r[0].properties.cluster_id;}return t},J.prototype._appendLeaves=function(e,t,r,i,o){for(var n=0,s=this.getChildren(t);n<s.length;n+=1){var a=s[n],l=a.properties;if(l&&l.cluster?o+l.point_count<=i?o+=l.point_count:o=this._appendLeaves(e,l.cluster_id,r,i,o):o<i?o++:e.push(a),e.length===r)break}return o},J.prototype._addTileFeatures=function(e,t,r,i,o,n){for(var s=0,a=e;s<a.length;s+=1){var l=t[a[s]],u=l.numPoints,h={type:1,geometry:[[Math.round(this.options.extent*(l.x*o-r)),Math.round(this.options.extent*(l.y*o-i))]],tags:u?G(l):this.points[l.index].properties},c=void 0;u?c=l.id:this.options.generateId?c=l.index:this.points[l.index].id&&(c=this.points[l.index].id),void 0!==c&&(h.id=c),n.features.push(h);}},J.prototype._limitZoom=function(e){return Math.max(this.options.minZoom,Math.min(e,this.options.maxZoom+1))},J.prototype._cluster=function(e,t){for(var r=[],i=this.options,o=i.reduce,n=i.radius/(i.extent*Math.pow(2,t)),s=0;s<e.length;s++){var a=e[s];if(!(a.zoom<=t)){a.zoom=t;for(var l=this.trees[t+1],u=l.within(a.x,a.y,n),h=a.numPoints||1,c=a.x*h,p=a.y*h,f=o&&h>1?this._map(a,!0):null,d=(s<<5)+(t+1)+this.points.length,g=0,v=u;g<v.length;g+=1){var m=l.points[v[g]];if(!(m.zoom<=t)){m.zoom=t;var y=m.numPoints||1;c+=m.x*y,p+=m.y*y,h+=y,m.parentId=d,o&&(f||(f=this._map(a,!0)),o(f,this._map(m)));}}1===h?r.push(a):(a.parentId=d,r.push(Z(c/h,p/h,d,h,f)));}}return r},J.prototype._getOriginId=function(e){return e-this.points.length>>5},J.prototype._getOriginZoom=function(e){return (e-this.points.length)%32},J.prototype._map=function(e,t){if(e.numPoints)return t?V({},e.properties):e.properties;var r=this.points[e.index].properties,i=this.options.map(r);return t&&i===r?V({},i):i},me.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!1,promoteId:null,generateId:!1,debug:0},me.prototype.splitTile=function(e,t,r,i,o,n,s){for(var a=[e,t,r,i],l=this.options,u=l.debug;a.length;){i=a.pop(),r=a.pop(),t=a.pop(),e=a.pop();var h=1<<t,c=ye(t,r,i),p=this.tiles[c];if(!p&&(u>1&&console.time("creation"),p=this.tiles[c]=de(e,t,r,i,l),this.tileCoords.push({z:t,x:r,y:i}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",t,r,i,p.numFeatures,p.numPoints,p.numSimplified),console.timeEnd("creation"));var f="z"+t;this.stats[f]=(this.stats[f]||0)+1,this.total++;}if(p.source=e,o){if(t===l.maxZoom||t===o)continue;var d=1<<o-t;if(r!==Math.floor(n/d)||i!==Math.floor(s/d))continue}else if(t===l.indexMaxZoom||p.numPoints<=l.indexMaxPoints)continue;if(p.source=null,0!==e.length){u>1&&console.time("clipping");var g,v,m,y,x,w,S=.5*l.buffer/l.extent,I=.5-S,M=.5+S,b=1+S;g=v=m=y=null,x=re(e,h,r-S,r+M,0,p.minX,p.maxX,l),w=re(e,h,r+I,r+b,0,p.minX,p.maxX,l),e=null,x&&(g=re(x,h,i-S,i+M,1,p.minY,p.maxY,l),v=re(x,h,i+I,i+b,1,p.minY,p.maxY,l),x=null),w&&(m=re(w,h,i-S,i+M,1,p.minY,p.maxY,l),y=re(w,h,i+I,i+b,1,p.minY,p.maxY,l),w=null),u>1&&console.timeEnd("clipping"),a.push(g||[],t+1,2*r,2*i),a.push(v||[],t+1,2*r,2*i+1),a.push(m||[],t+1,2*r+1,2*i),a.push(y||[],t+1,2*r+1,2*i+1);}}},me.prototype.getTile=function(e,t,r){var i=this.options,o=i.extent,n=i.debug;if(e<0||e>24)return null;var s=1<<e,a=ye(e,t=(t%s+s)%s,r);if(this.tiles[a])return pe(this.tiles[a],o);n>1&&console.log("drilling down to z%d-%d-%d",e,t,r);for(var l,u=e,h=t,c=r;!l&&u>0;)u--,h=Math.floor(h/2),c=Math.floor(c/2),l=this.tiles[ye(u,h,c)];return l&&l.source?(n>1&&console.log("found parent tile z%d-%d-%d",u,h,c),n>1&&console.time("drilling down"),this.splitTile(l.source,u,h,c,e,t,r),n>1&&console.timeEnd("drilling down"),this.tiles[a]?pe(this.tiles[a],o):null):null};var we=function(t){function r(e,r,i,o){t.call(this,e,r,i,xe),o&&(this.loadGeoJSON=o);}return t&&(r.__proto__=t),(r.prototype=Object.create(t&&t.prototype)).constructor=r,r.prototype.loadData=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),this._pendingCallback=t,this._pendingLoadDataParams=e,this._state&&"Idle"!==this._state?this._state="NeedsLoadData":(this._state="Coalescing",this._loadData());},r.prototype._loadData=function(){var t=this;if(this._pendingCallback&&this._pendingLoadDataParams){var r=this._pendingCallback,i=this._pendingLoadDataParams;delete this._pendingCallback,delete this._pendingLoadDataParams;var o=!!(i&&i.request&&i.request.collectResourceTiming)&&new e.RequestPerformance(i.request);this.loadGeoJSON(i,(function(n,s){if(n||!s)return r(n);if("object"!=typeof s)return r(new Error("Input data given to '"+i.source+"' is not a valid GeoJSON object."));!function e(t,r){var i,o=t&&t.type;if("FeatureCollection"===o)for(i=0;i<t.features.length;i++)e(t.features[i],r);else if("GeometryCollection"===o)for(i=0;i<t.geometries.length;i++)e(t.geometries[i],r);else if("Feature"===o)e(t.geometry,r);else if("Polygon"===o)c(t.coordinates,r);else if("MultiPolygon"===o)for(i=0;i<t.coordinates.length;i++)c(t.coordinates[i],r);return t}(s,!0);try{t._geoJSONIndex=i.cluster?new J(function(t){var r=t.superclusterOptions,i=t.clusterProperties;if(!i||!r)return r;for(var o={},n={},s={accumulated:null,zoom:0},a={properties:null},l=Object.keys(i),u=0,h=l;u<h.length;u+=1){var c=h[u],p=i[c],f=p[0],d=e.createExpression(p[1]),g=e.createExpression("string"==typeof f?[f,["accumulated"],["get",c]]:f);o[c]=d.value,n[c]=g.value;}return r.map=function(e){a.properties=e;for(var t={},r=0,i=l;r<i.length;r+=1){var n=i[r];t[n]=o[n].evaluate(s,a);}return t},r.reduce=function(e,t){a.properties=t;for(var r=0,i=l;r<i.length;r+=1){var o=i[r];s.accumulated=e[o],e[o]=n[o].evaluate(s,a);}},r}(i)).load(s.features):function(e,t){return new me(e,t)}(s,i.geojsonVtOptions);}catch(n){return r(n)}t.loaded={};var a={};if(o){var l=o.finish();l&&(a.resourceTiming={},a.resourceTiming[i.source]=JSON.parse(JSON.stringify(l)));}r(null,a);}));}},r.prototype.coalesce=function(){"Coalescing"===this._state?this._state="Idle":"NeedsLoadData"===this._state&&(this._state="Coalescing",this._loadData());},r.prototype.reloadTile=function(e,r){var i=this.loaded;return i&&i[e.uid]?t.prototype.reloadTile.call(this,e,r):this.loadTile(e,r)},r.prototype.loadGeoJSON=function(t,r){if(t.request)e.getJSON(t.request,r);else {if("string"!=typeof t.data)return r(new Error("Input data given to '"+t.source+"' is not a valid GeoJSON object."));try{return r(null,JSON.parse(t.data))}catch(e){return r(new Error("Input data given to '"+t.source+"' is not a valid GeoJSON object."))}}},r.prototype.removeSource=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),t();},r.prototype.getClusterExpansionZoom=function(e,t){try{t(null,this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));}catch(e){t(e);}},r.prototype.getClusterChildren=function(e,t){try{t(null,this._geoJSONIndex.getChildren(e.clusterId));}catch(e){t(e);}},r.prototype.getClusterLeaves=function(e,t){try{t(null,this._geoJSONIndex.getLeaves(e.clusterId,e.limit,e.offset));}catch(e){t(e);}},r}(l),Se=function(t){var r=this;this.self=t,this.actor=new e.Actor(t,this),this.layerIndexes={},this.availableImages={},this.workerSourceTypes={vector:l,geojson:we},this.workerSources={},this.demWorkerSources={},this.self.registerWorkerSource=function(e,t){if(r.workerSourceTypes[e])throw new Error('Worker source with name "'+e+'" already registered.');r.workerSourceTypes[e]=t;},this.self.registerRTLTextPlugin=function(t){if(e.plugin.isParsed())throw new Error("RTL text plugin already registered.");e.plugin.applyArabicShaping=t.applyArabicShaping,e.plugin.processBidirectionalText=t.processBidirectionalText,e.plugin.processStyledBidirectionalText=t.processStyledBidirectionalText;};};return Se.prototype.setReferrer=function(e,t){this.referrer=t;},Se.prototype.setImages=function(e,t,r){for(var i in this.availableImages[e]=t,this.workerSources[e]){var o=this.workerSources[e][i];for(var n in o)o[n].availableImages=t;}r();},Se.prototype.setLayers=function(e,t,r){this.getLayerIndex(e).replace(t),r();},Se.prototype.updateLayers=function(e,t,r){this.getLayerIndex(e).update(t.layers,t.removedIds),r();},Se.prototype.loadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).loadTile(t,r);},Se.prototype.loadDEMTile=function(e,t,r){this.getDEMWorkerSource(e,t.source).loadTile(t,r);},Se.prototype.reloadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).reloadTile(t,r);},Se.prototype.abortTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).abortTile(t,r);},Se.prototype.removeTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).removeTile(t,r);},Se.prototype.removeDEMTile=function(e,t){this.getDEMWorkerSource(e,t.source).removeTile(t);},Se.prototype.removeSource=function(e,t,r){if(this.workerSources[e]&&this.workerSources[e][t.type]&&this.workerSources[e][t.type][t.source]){var i=this.workerSources[e][t.type][t.source];delete this.workerSources[e][t.type][t.source],void 0!==i.removeSource?i.removeSource(t,r):r();}},Se.prototype.loadWorkerSource=function(e,t,r){try{this.self.importScripts(t.url),r();}catch(e){r(e.toString());}},Se.prototype.syncRTLPluginState=function(t,r,i){try{e.plugin.setState(r);var o=e.plugin.getPluginURL();if(e.plugin.isLoaded()&&!e.plugin.isParsed()&&null!=o){this.self.importScripts(o);var n=e.plugin.isParsed();i(n?void 0:new Error("RTL Text Plugin failed to import scripts from "+o),n);}}catch(e){i(e.toString());}},Se.prototype.getAvailableImages=function(e){var t=this.availableImages[e];return t||(t=[]),t},Se.prototype.getLayerIndex=function(e){var t=this.layerIndexes[e];return t||(t=this.layerIndexes[e]=new i),t},Se.prototype.getWorkerSource=function(e,t,r){var i=this;return this.workerSources[e]||(this.workerSources[e]={}),this.workerSources[e][t]||(this.workerSources[e][t]={}),this.workerSources[e][t][r]||(this.workerSources[e][t][r]=new this.workerSourceTypes[t]({send:function(t,r,o){i.actor.send(t,r,o,e);}},this.getLayerIndex(e),this.getAvailableImages(e))),this.workerSources[e][t][r]},Se.prototype.getDEMWorkerSource=function(e,t){return this.demWorkerSources[e]||(this.demWorkerSources[e]={}),this.demWorkerSources[e][t]||(this.demWorkerSources[e][t]=new h),this.demWorkerSources[e][t]},Se.prototype.enforceCacheSizeLimit=function(t,r){e.enforceCacheSizeLimit(r);},"undefined"!=typeof WorkerGlobalScope&&void 0!==e.window&&e.window instanceof WorkerGlobalScope&&(e.window.worker=new Se(e.window)),Se}));
  
  define(["./shared"],(function(t){"use strict";var e=t.createCommonjsModule((function(t){function e(t){return !i(t)}function i(t){return "undefined"==typeof window||"undefined"==typeof document?"not a browser":Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray?Function.prototype&&Function.prototype.bind?Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions?"JSON"in window&&"parse"in JSON&&"stringify"in JSON?function(){if(!("Worker"in window&&"Blob"in window&&"URL"in window))return !1;var t,e,i=new Blob([""],{type:"text/javascript"}),o=URL.createObjectURL(i);try{e=new Worker(o),t=!0;}catch(e){t=!1;}return e&&e.terminate(),URL.revokeObjectURL(o),t}()?"Uint8ClampedArray"in window?ArrayBuffer.isView?function(){var t=document.createElement("canvas");t.width=t.height=1;var e=t.getContext("2d");if(!e)return !1;var i=e.getImageData(0,0,1,1);return i&&i.width===t.width}()?(void 0===o[i=t&&t.failIfMajorPerformanceCaveat]&&(o[i]=function(t){var i=function(t){var i=document.createElement("canvas"),o=Object.create(e.webGLContextAttributes);return o.failIfMajorPerformanceCaveat=t,i.probablySupportsContext?i.probablySupportsContext("webgl",o)||i.probablySupportsContext("experimental-webgl",o):i.supportsContext?i.supportsContext("webgl",o)||i.supportsContext("experimental-webgl",o):i.getContext("webgl",o)||i.getContext("experimental-webgl",o)}(t);if(!i)return !1;var o=i.createShader(i.VERTEX_SHADER);return !(!o||i.isContextLost())&&(i.shaderSource(o,"void main() {}"),i.compileShader(o),!0===i.getShaderParameter(o,i.COMPILE_STATUS))}(i)),o[i]?void 0:"insufficient WebGL support"):"insufficient Canvas/getImageData support":"insufficient ArrayBuffer support":"insufficient Uint8ClampedArray support":"insufficient worker support":"insufficient JSON support":"insufficient Object support":"insufficient Function support":"insufficent Array support";var i;}t.exports?t.exports=e:window&&(window.mapboxgl=window.mapboxgl||{},window.mapboxgl.supported=e,window.mapboxgl.notSupportedReason=i);var o={};e.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0};})),i={create:function(e,i,o){var r=t.window.document.createElement(e);return void 0!==i&&(r.className=i),o&&o.appendChild(r),r},createNS:function(e,i){return t.window.document.createElementNS(e,i)}},o=t.window.document.documentElement.style;function r(t){if(!o)return t[0];for(var e=0;e<t.length;e++)if(t[e]in o)return t[e];return t[0]}var a,n=r(["userSelect","MozUserSelect","WebkitUserSelect","msUserSelect"]);i.disableDrag=function(){o&&n&&(a=o[n],o[n]="none");},i.enableDrag=function(){o&&n&&(o[n]=a);};var s=r(["transform","WebkitTransform"]);i.setTransform=function(t,e){t.style[s]=e;};var l=!1;try{var c=Object.defineProperty({},"passive",{get:function(){l=!0;}});t.window.addEventListener("test",c,c),t.window.removeEventListener("test",c,c);}catch(t){l=!1;}i.addEventListener=function(t,e,i,o){void 0===o&&(o={}),t.addEventListener(e,i,"passive"in o&&l?o:o.capture);},i.removeEventListener=function(t,e,i,o){void 0===o&&(o={}),t.removeEventListener(e,i,"passive"in o&&l?o:o.capture);};var u=function(e){e.preventDefault(),e.stopPropagation(),t.window.removeEventListener("click",u,!0);};function h(t){var e=t.userImage;return !!(e&&e.render&&e.render())&&(t.data.replace(new Uint8Array(e.data.buffer)),!0)}i.suppressClick=function(){t.window.addEventListener("click",u,!0),t.window.setTimeout((function(){t.window.removeEventListener("click",u,!0);}),0);},i.mousePos=function(e,i){var o=e.getBoundingClientRect();return new t.Point(i.clientX-o.left-e.clientLeft,i.clientY-o.top-e.clientTop)},i.touchPos=function(e,i){for(var o=e.getBoundingClientRect(),r=[],a=0;a<i.length;a++)r.push(new t.Point(i[a].clientX-o.left-e.clientLeft,i[a].clientY-o.top-e.clientTop));return r},i.mouseButton=function(e){return void 0!==t.window.InstallTrigger&&2===e.button&&e.ctrlKey&&t.window.navigator.platform.toUpperCase().indexOf("MAC")>=0?0:e.button},i.remove=function(t){t.parentNode&&t.parentNode.removeChild(t);};var p=function(e){function i(){e.call(this),this.images={},this.updatedImages={},this.callbackDispatchedThisFrame={},this.loaded=!1,this.requestors=[],this.patterns={},this.atlasImage=new t.RGBAImage({width:1,height:1}),this.dirty=!0;}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.isLoaded=function(){return this.loaded},i.prototype.setLoaded=function(t){if(this.loaded!==t&&(this.loaded=t,t)){for(var e=0,i=this.requestors;e<i.length;e+=1){var o=i[e];this._notify(o.ids,o.callback);}this.requestors=[];}},i.prototype.getImage=function(t){return this.images[t]},i.prototype.addImage=function(t,e){this._validate(t,e)&&(this.images[t]=e);},i.prototype._validate=function(e,i){var o=!0;return this._validateStretch(i.stretchX,i.data&&i.data.width)||(this.fire(new t.ErrorEvent(new Error('Image "'+e+'" has invalid "stretchX" value'))),o=!1),this._validateStretch(i.stretchY,i.data&&i.data.height)||(this.fire(new t.ErrorEvent(new Error('Image "'+e+'" has invalid "stretchY" value'))),o=!1),this._validateContent(i.content,i)||(this.fire(new t.ErrorEvent(new Error('Image "'+e+'" has invalid "content" value'))),o=!1),o},i.prototype._validateStretch=function(t,e){if(!t)return !0;for(var i=0,o=0,r=t;o<r.length;o+=1){var a=r[o];if(a[0]<i||a[1]<a[0]||e<a[1])return !1;i=a[1];}return !0},i.prototype._validateContent=function(t,e){return !(t&&(4!==t.length||t[0]<0||e.data.width<t[0]||t[1]<0||e.data.height<t[1]||t[2]<0||e.data.width<t[2]||t[3]<0||e.data.height<t[3]||t[2]<t[0]||t[3]<t[1]))},i.prototype.updateImage=function(t,e){e.version=this.images[t].version+1,this.images[t]=e,this.updatedImages[t]=!0;},i.prototype.removeImage=function(t){var e=this.images[t];delete this.images[t],delete this.patterns[t],e.userImage&&e.userImage.onRemove&&e.userImage.onRemove();},i.prototype.listImages=function(){return Object.keys(this.images)},i.prototype.getImages=function(t,e){var i=!0;if(!this.isLoaded())for(var o=0,r=t;o<r.length;o+=1)this.images[r[o]]||(i=!1);this.isLoaded()||i?this._notify(t,e):this.requestors.push({ids:t,callback:e});},i.prototype._notify=function(e,i){for(var o={},r=0,a=e;r<a.length;r+=1){var n=a[r];this.images[n]||this.fire(new t.Event("styleimagemissing",{id:n}));var s=this.images[n];s?o[n]={data:s.data.clone(),pixelRatio:s.pixelRatio,sdf:s.sdf,version:s.version,stretchX:s.stretchX,stretchY:s.stretchY,content:s.content,hasRenderCallback:Boolean(s.userImage&&s.userImage.render)}:t.warnOnce('Image "'+n+'" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');}i(null,o);},i.prototype.getPixelSize=function(){var t=this.atlasImage;return {width:t.width,height:t.height}},i.prototype.getPattern=function(e){var i=this.patterns[e],o=this.getImage(e);if(!o)return null;if(i&&i.position.version===o.version)return i.position;if(i)i.position.version=o.version;else {var r={w:o.data.width+2,h:o.data.height+2,x:0,y:0},a=new t.ImagePosition(r,o);this.patterns[e]={bin:r,position:a};}return this._updatePatternAtlas(),this.patterns[e].position},i.prototype.bind=function(e){var i=e.gl;this.atlasTexture?this.dirty&&(this.atlasTexture.update(this.atlasImage),this.dirty=!1):this.atlasTexture=new t.Texture(e,this.atlasImage,i.RGBA),this.atlasTexture.bind(i.LINEAR,i.CLAMP_TO_EDGE);},i.prototype._updatePatternAtlas=function(){var e=[];for(var i in this.patterns)e.push(this.patterns[i].bin);var o=t.potpack(e),r=o.w,a=o.h,n=this.atlasImage;for(var s in n.resize({width:r||1,height:a||1}),this.patterns){var l=this.patterns[s].bin,c=l.x+1,u=l.y+1,h=this.images[s].data,p=h.width,d=h.height;t.RGBAImage.copy(h,n,{x:0,y:0},{x:c,y:u},{width:p,height:d}),t.RGBAImage.copy(h,n,{x:0,y:d-1},{x:c,y:u-1},{width:p,height:1}),t.RGBAImage.copy(h,n,{x:0,y:0},{x:c,y:u+d},{width:p,height:1}),t.RGBAImage.copy(h,n,{x:p-1,y:0},{x:c-1,y:u},{width:1,height:d}),t.RGBAImage.copy(h,n,{x:0,y:0},{x:c+p,y:u},{width:1,height:d});}this.dirty=!0;},i.prototype.beginFrame=function(){this.callbackDispatchedThisFrame={};},i.prototype.dispatchRenderCallbacks=function(t){for(var e=0,i=t;e<i.length;e+=1){var o=i[e];if(!this.callbackDispatchedThisFrame[o]){this.callbackDispatchedThisFrame[o]=!0;var r=this.images[o];h(r)&&this.updateImage(o,r);}}},i}(t.Evented),d=m,_=m,f=1e20;function m(t,e,i,o,r,a){this.fontSize=t||24,this.buffer=void 0===e?3:e,this.cutoff=o||.25,this.fontFamily=r||"sans-serif",this.fontWeight=a||"normal",this.radius=i||8;var n=this.size=this.fontSize+2*this.buffer;this.canvas=document.createElement("canvas"),this.canvas.width=this.canvas.height=n,this.ctx=this.canvas.getContext("2d"),this.ctx.font=this.fontWeight+" "+this.fontSize+"px "+this.fontFamily,this.ctx.textBaseline="middle",this.ctx.fillStyle="black",this.gridOuter=new Float64Array(n*n),this.gridInner=new Float64Array(n*n),this.f=new Float64Array(n),this.d=new Float64Array(n),this.z=new Float64Array(n+1),this.v=new Int16Array(n),this.middle=Math.round(n/2*(navigator.userAgent.indexOf("Gecko/")>=0?1.2:1));}function g(t,e,i,o,r,a,n){for(var s=0;s<e;s++){for(var l=0;l<i;l++)o[l]=t[l*e+s];for(v(o,r,a,n,i),l=0;l<i;l++)t[l*e+s]=r[l];}for(l=0;l<i;l++){for(s=0;s<e;s++)o[s]=t[l*e+s];for(v(o,r,a,n,e),s=0;s<e;s++)t[l*e+s]=Math.sqrt(r[s]);}}function v(t,e,i,o,r){i[0]=0,o[0]=-f,o[1]=+f;for(var a=1,n=0;a<r;a++){for(var s=(t[a]+a*a-(t[i[n]]+i[n]*i[n]))/(2*a-2*i[n]);s<=o[n];)n--,s=(t[a]+a*a-(t[i[n]]+i[n]*i[n]))/(2*a-2*i[n]);i[++n]=a,o[n]=s,o[n+1]=+f;}for(a=0,n=0;a<r;a++){for(;o[n+1]<a;)n++;e[a]=(a-i[n])*(a-i[n])+t[i[n]];}}m.prototype.draw=function(t){this.ctx.clearRect(0,0,this.size,this.size),this.ctx.fillText(t,this.buffer,this.middle);for(var e=this.ctx.getImageData(0,0,this.size,this.size),i=new Uint8ClampedArray(this.size*this.size),o=0;o<this.size*this.size;o++){var r=e.data[4*o+3]/255;this.gridOuter[o]=1===r?0:0===r?f:Math.pow(Math.max(0,.5-r),2),this.gridInner[o]=1===r?f:0===r?0:Math.pow(Math.max(0,r-.5),2);}for(g(this.gridOuter,this.size,this.size,this.f,this.d,this.v,this.z),g(this.gridInner,this.size,this.size,this.f,this.d,this.v,this.z),o=0;o<this.size*this.size;o++)i[o]=Math.max(0,Math.min(255,Math.round(255-255*((this.gridOuter[o]-this.gridInner[o])/this.radius+this.cutoff))));return i},d.default=_;var y=function(t,e){this.requestManager=t,this.localIdeographFontFamily=e,this.entries={};};y.prototype.setURL=function(t){this.url=t;},y.prototype.getGlyphs=function(e,i){var o=this,r=[];for(var a in e)for(var n=0,s=e[a];n<s.length;n+=1)r.push({stack:a,id:s[n]});t.asyncAll(r,(function(t,e){var i=t.stack,r=t.id,a=o.entries[i];a||(a=o.entries[i]={glyphs:{},requests:{},ranges:{}});var n=a.glyphs[r];if(void 0===n){if(n=o._tinySDF(a,i,r))return a.glyphs[r]=n,void e(null,{stack:i,id:r,glyph:n});var s=Math.floor(r/256);if(256*s>65535)e(new Error("glyphs > 65535 not supported"));else if(a.ranges[s])e(null,{stack:i,id:r,glyph:n});else {var l=a.requests[s];l||(l=a.requests[s]=[],y.loadGlyphRange(i,s,o.url,o.requestManager,(function(t,e){if(e){for(var i in e)o._doesCharSupportLocalGlyph(+i)||(a.glyphs[+i]=e[+i]);a.ranges[s]=!0;}for(var r=0,n=l;r<n.length;r+=1)(0,n[r])(t,e);delete a.requests[s];}))),l.push((function(t,o){t?e(t):o&&e(null,{stack:i,id:r,glyph:o[r]||null});}));}}else e(null,{stack:i,id:r,glyph:n});}),(function(t,e){if(t)i(t);else if(e){for(var o={},r=0,a=e;r<a.length;r+=1){var n=a[r],s=n.stack,l=n.id,c=n.glyph;(o[s]||(o[s]={}))[l]=c&&{id:c.id,bitmap:c.bitmap.clone(),metrics:c.metrics};}i(null,o);}}));},y.prototype._doesCharSupportLocalGlyph=function(e){return !!this.localIdeographFontFamily&&(t.isChar["CJK Unified Ideographs"](e)||t.isChar["Hangul Syllables"](e)||t.isChar.Hiragana(e)||t.isChar.Katakana(e))},y.prototype._tinySDF=function(e,i,o){var r=this.localIdeographFontFamily;if(r&&this._doesCharSupportLocalGlyph(o)){var a=e.tinySDF;if(!a){var n="400";/bold/i.test(i)?n="900":/medium/i.test(i)?n="500":/light/i.test(i)&&(n="200"),a=e.tinySDF=new y.TinySDF(24,3,8,.25,r,n);}return {id:o,bitmap:new t.AlphaImage({width:30,height:30},a.draw(String.fromCharCode(o))),metrics:{width:24,height:24,left:0,top:-8,advance:24}}}},y.loadGlyphRange=function(e,i,o,r,a){var n=256*i,s=n+255,l=r.transformRequest(r.normalizeGlyphsURL(o).replace("{fontstack}",e).replace("{range}",n+"-"+s),t.ResourceType.Glyphs);t.getArrayBuffer(l,(function(e,i){if(e)a(e);else if(i){for(var o={},r=0,n=t.parseGlyphPBF(i);r<n.length;r+=1){var s=n[r];o[s.id]=s;}a(null,o);}}));},y.TinySDF=d;var x=function(){this.specification=t.styleSpec.light.position;};x.prototype.possiblyEvaluate=function(e,i){return t.sphericalToCartesian(e.expression.evaluate(i))},x.prototype.interpolate=function(e,i,o){return {x:t.number(e.x,i.x,o),y:t.number(e.y,i.y,o),z:t.number(e.z,i.z,o)}};var b=new t.Properties({anchor:new t.DataConstantProperty(t.styleSpec.light.anchor),position:new x,color:new t.DataConstantProperty(t.styleSpec.light.color),intensity:new t.DataConstantProperty(t.styleSpec.light.intensity)}),w=function(e){function i(i){e.call(this),this._transitionable=new t.Transitionable(b),this.setLight(i),this._transitioning=this._transitionable.untransitioned();}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.getLight=function(){return this._transitionable.serialize()},i.prototype.setLight=function(e,i){if(void 0===i&&(i={}),!this._validate(t.validateLight,e,i))for(var o in e){var r=e[o];t.endsWith(o,"-transition")?this._transitionable.setTransition(o.slice(0,-"-transition".length),r):this._transitionable.setValue(o,r);}},i.prototype.updateTransitions=function(t){this._transitioning=this._transitionable.transitioned(t,this._transitioning);},i.prototype.hasTransition=function(){return this._transitioning.hasTransition()},i.prototype.recalculate=function(t){this.properties=this._transitioning.possiblyEvaluate(t);},i.prototype._validate=function(e,i,o){return (!o||!1!==o.validate)&&t.emitValidationErrors(this,e.call(t.validateStyle,t.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:t.styleSpec})))},i}(t.Evented),T=function(t,e){this.width=t,this.height=e,this.nextRow=0,this.data=new Uint8Array(this.width*this.height),this.dashEntry={};};T.prototype.getDash=function(t,e){var i=t.join(",")+String(e);return this.dashEntry[i]||(this.dashEntry[i]=this.addDash(t,e)),this.dashEntry[i]},T.prototype.getDashRanges=function(t,e,i){var o=[],r=t.length%2==1?-t[t.length-1]*i:0,a=t[0]*i,n=!0;o.push({left:r,right:a,isDash:n,zeroLength:0===t[0]});for(var s=t[0],l=1;l<t.length;l++){var c=t[l];o.push({left:r=s*i,right:a=(s+=c)*i,isDash:n=!n,zeroLength:0===c});}return o},T.prototype.addRoundDash=function(t,e,i){for(var o=e/2,r=-i;r<=i;r++)for(var a=this.width*(this.nextRow+i+r),n=0,s=t[n],l=0;l<this.width;l++){l/s.right>1&&(s=t[++n]);var c=Math.abs(l-s.left),u=Math.abs(l-s.right),h=Math.min(c,u),p=void 0,d=r/i*(o+1);if(s.isDash){var _=o-Math.abs(d);p=Math.sqrt(h*h+_*_);}else p=o-Math.sqrt(h*h+d*d);this.data[a+l]=Math.max(0,Math.min(255,p+128));}},T.prototype.addRegularDash=function(t){for(var e=t.length-1;e>=0;--e){var i=t[e],o=t[e+1];i.zeroLength?t.splice(e,1):o&&o.isDash===i.isDash&&(o.left=i.left,t.splice(e,1));}var r=t[0],a=t[t.length-1];r.isDash===a.isDash&&(r.left=a.left-this.width,a.right=r.right+this.width);for(var n=this.width*this.nextRow,s=0,l=t[s],c=0;c<this.width;c++){c/l.right>1&&(l=t[++s]);var u=Math.abs(c-l.left),h=Math.abs(c-l.right),p=Math.min(u,h);this.data[n+c]=Math.max(0,Math.min(255,(l.isDash?p:-p)+128));}},T.prototype.addDash=function(e,i){var o=i?7:0,r=2*o+1;if(this.nextRow+r>this.height)return t.warnOnce("LineAtlas out of space"),null;for(var a=0,n=0;n<e.length;n++)a+=e[n];if(0!==a){var s=this.width/a,l=this.getDashRanges(e,this.width,s);i?this.addRoundDash(l,s,o):this.addRegularDash(l);}var c={y:(this.nextRow+o+.5)/this.height,height:2*o/this.height,width:a};return this.nextRow+=r,this.dirty=!0,c},T.prototype.bind=function(t){var e=t.gl;this.texture?(e.bindTexture(e.TEXTURE_2D,this.texture),this.dirty&&(this.dirty=!1,e.texSubImage2D(e.TEXTURE_2D,0,0,0,this.width,this.height,e.ALPHA,e.UNSIGNED_BYTE,this.data))):(this.texture=e.createTexture(),e.bindTexture(e.TEXTURE_2D,this.texture),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,e.LINEAR),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,e.LINEAR),e.texImage2D(e.TEXTURE_2D,0,e.ALPHA,this.width,this.height,0,e.ALPHA,e.UNSIGNED_BYTE,this.data));};var E=function e(i,o){this.workerPool=i,this.actors=[],this.currentActor=0,this.id=t.uniqueId();for(var r=this.workerPool.acquire(this.id),a=0;a<r.length;a++){var n=new e.Actor(r[a],o,this.id);n.name="Worker "+a,this.actors.push(n);}};function I(e,i,o){var r=function(r,a){if(r)return o(r);if(a){var n=t.pick(t.extend(a,e),["tiles","minzoom","maxzoom","attribution","mapbox_logo","bounds","scheme","tileSize","encoding"]);a.vector_layers&&(n.vectorLayers=a.vector_layers,n.vectorLayerIds=n.vectorLayers.map((function(t){return t.id}))),n.tiles=i.canonicalizeTileset(n,e.url),o(null,n);}};return e.url?t.getJSON(i.transformRequest(i.normalizeSourceURL(e.url),t.ResourceType.Source),r):t.browser.frame((function(){return r(null,e)}))}E.prototype.broadcast=function(e,i,o){t.asyncAll(this.actors,(function(t,o){t.send(e,i,o);}),o=o||function(){});},E.prototype.getActor=function(){return this.currentActor=(this.currentActor+1)%this.actors.length,this.actors[this.currentActor]},E.prototype.remove=function(){this.actors.forEach((function(t){t.remove();})),this.actors=[],this.workerPool.release(this.id);},E.Actor=t.Actor;var P=function(e,i,o){this.bounds=t.LngLatBounds.convert(this.validateBounds(e)),this.minzoom=i||0,this.maxzoom=o||24;};P.prototype.validateBounds=function(t){return Array.isArray(t)&&4===t.length?[Math.max(-180,t[0]),Math.max(-90,t[1]),Math.min(180,t[2]),Math.min(90,t[3])]:[-180,-90,180,90]},P.prototype.contains=function(e){var i=Math.pow(2,e.z),o=Math.floor(t.mercatorXfromLng(this.bounds.getWest())*i),r=Math.floor(t.mercatorYfromLat(this.bounds.getNorth())*i),a=Math.ceil(t.mercatorXfromLng(this.bounds.getEast())*i),n=Math.ceil(t.mercatorYfromLat(this.bounds.getSouth())*i);return e.x>=o&&e.x<a&&e.y>=r&&e.y<n};var S=function(e){function i(i,o,r,a){if(e.call(this),this.id=i,this.dispatcher=r,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,this._loaded=!1,t.extend(this,t.pick(o,["url","scheme","tileSize","promoteId"])),this._options=t.extend({type:"vector"},o),this._collectResourceTiming=o.collectResourceTiming,512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(a);}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.load=function(){var e=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=I(this._options,this.map._requestManager,(function(i,o){e._tileJSONRequest=null,e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):o&&(t.extend(e,o),o.bounds&&(e.tileBounds=new P(o.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(o.tiles,e.map._requestManager._customAccessToken),t.postMapLoadEvent(o.tiles,e.map._getMapId(),e.map._requestManager._skuToken,e.map._requestManager._customAccessToken),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));}));},i.prototype.loaded=function(){return this._loaded},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.loadTile=function(e,i){var o=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme)),r={request:this.map._requestManager.transformRequest(o,t.ResourceType.Tile),uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,tileSize:this.tileSize*e.tileID.overscaleFactor(),type:this.type,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId};function a(o,r){return delete e.request,e.aborted?i(null):o&&404!==o.status?i(o):(r&&r.resourceTiming&&(e.resourceTiming=r.resourceTiming),this.map._refreshExpiredTiles&&r&&e.setExpiryData(r),e.loadVectorData(r,this.map.painter),t.cacheEntryPossiblyAdded(this.dispatcher),i(null),void(e.reloadCallback&&(this.loadTile(e,e.reloadCallback),e.reloadCallback=null)))}r.request.collectResourceTiming=this._collectResourceTiming,e.actor&&"expired"!==e.state?"loading"===e.state?e.reloadCallback=i:e.request=e.actor.send("reloadTile",r,a.bind(this)):(e.actor=this.dispatcher.getActor(),e.request=e.actor.send("loadTile",r,a.bind(this)));},i.prototype.abortTile=function(t){t.request&&(t.request.cancel(),delete t.request),t.actor&&t.actor.send("abortTile",{uid:t.uid,type:this.type,source:this.id},void 0);},i.prototype.unloadTile=function(t){t.unloadVectorData(),t.actor&&t.actor.send("removeTile",{uid:t.uid,type:this.type,source:this.id},void 0);},i.prototype.hasTransition=function(){return !1},i}(t.Evented),C=function(e){function i(i,o,r,a){e.call(this),this.id=i,this.dispatcher=r,this.setEventedParent(a),this.type="raster",this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,this._options=t.extend({type:"raster"},o),t.extend(this,t.pick(o,["url","scheme","tileSize"]));}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.load=function(){var e=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=I(this._options,this.map._requestManager,(function(i,o){e._tileJSONRequest=null,e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):o&&(t.extend(e,o),o.bounds&&(e.tileBounds=new P(o.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(o.tiles),t.postMapLoadEvent(o.tiles,e.map._getMapId(),e.map._requestManager._skuToken),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));}));},i.prototype.loaded=function(){return this._loaded},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.loadTile=function(e,i){var o=this,r=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.tileSize);e.request=t.getImage(this.map._requestManager.transformRequest(r,t.ResourceType.Tile),(function(r,a){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(r)e.state="errored",i(r);else if(a){o.map._refreshExpiredTiles&&e.setExpiryData(a),delete a.cacheControl,delete a.expires;var n=o.map.painter.context,s=n.gl;e.texture=o.map.painter.getTileTexture(a.width),e.texture?e.texture.update(a,{useMipmap:!0}):(e.texture=new t.Texture(n,a,s.RGBA,{useMipmap:!0}),e.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE,s.LINEAR_MIPMAP_NEAREST),n.extTextureFilterAnisotropic&&s.texParameterf(s.TEXTURE_2D,n.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,n.extTextureFilterAnisotropicMax)),e.state="loaded",t.cacheEntryPossiblyAdded(o.dispatcher),i(null);}}));},i.prototype.abortTile=function(t,e){t.request&&(t.request.cancel(),delete t.request),e();},i.prototype.unloadTile=function(t,e){t.texture&&this.map.painter.saveTileTexture(t.texture),e();},i.prototype.hasTransition=function(){return !1},i}(t.Evented),z=function(e){function i(i,o,r,a){e.call(this,i,o,r,a),this.type="raster-dem",this.maxzoom=22,this._options=t.extend({type:"raster-dem"},o),this.encoding=o.encoding||"mapbox";}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.serialize=function(){return {type:"raster-dem",url:this.url,tileSize:this.tileSize,tiles:this.tiles,bounds:this.bounds,encoding:this.encoding}},i.prototype.loadTile=function(e,i){var o=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.tileSize);function r(t,o){t&&(e.state="errored",i(t)),o&&(e.dem=o,e.needsHillshadePrepare=!0,e.state="loaded",i(null));}e.request=t.getImage(this.map._requestManager.transformRequest(o,t.ResourceType.Tile),function(o,a){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(o)e.state="errored",i(o);else if(a){this.map._refreshExpiredTiles&&e.setExpiryData(a),delete a.cacheControl,delete a.expires;var n=t.window.ImageBitmap&&a instanceof t.window.ImageBitmap&&t.offscreenCanvasSupported()?a:t.browser.getImageData(a,1),s={uid:e.uid,coord:e.tileID,source:this.id,rawImageData:n,encoding:this.encoding};e.actor&&"expired"!==e.state||(e.actor=this.dispatcher.getActor(),e.actor.send("loadDEMTile",s,r.bind(this)));}}.bind(this)),e.neighboringTiles=this._getNeighboringTiles(e.tileID);},i.prototype._getNeighboringTiles=function(e){var i=e.canonical,o=Math.pow(2,i.z),r=(i.x-1+o)%o,a=0===i.x?e.wrap-1:e.wrap,n=(i.x+1+o)%o,s=i.x+1===o?e.wrap+1:e.wrap,l={};return l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y).key]={backfilled:!1},i.y>0&&(l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y-1).key]={backfilled:!1}),i.y+1<o&&(l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y+1).key]={backfilled:!1}),l},i.prototype.unloadTile=function(t){t.demTexture&&this.map.painter.saveTileTexture(t.demTexture),t.fbo&&(t.fbo.destroy(),delete t.fbo),t.dem&&delete t.dem,delete t.neighboringTiles,t.state="unloaded",t.actor&&t.actor.send("removeDEMTile",{uid:t.uid,source:this.id});},i}(C),D=function(e){function i(i,o,r,a){e.call(this),this.id=i,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this._removed=!1,this._loaded=!1,this.actor=r.getActor(),this.setEventedParent(a),this._data=o.data,this._options=t.extend({},o),this._collectResourceTiming=o.collectResourceTiming,this._resourceTiming=[],void 0!==o.maxzoom&&(this.maxzoom=o.maxzoom),o.type&&(this.type=o.type),o.attribution&&(this.attribution=o.attribution),this.promoteId=o.promoteId;var n=t.EXTENT/this.tileSize;this.workerOptions=t.extend({source:this.id,cluster:o.cluster||!1,geojsonVtOptions:{buffer:(void 0!==o.buffer?o.buffer:128)*n,tolerance:(void 0!==o.tolerance?o.tolerance:.375)*n,extent:t.EXTENT,maxZoom:this.maxzoom,lineMetrics:o.lineMetrics||!1,generateId:o.generateId||!1},superclusterOptions:{maxZoom:void 0!==o.clusterMaxZoom?Math.min(o.clusterMaxZoom,this.maxzoom-1):this.maxzoom-1,extent:t.EXTENT,radius:(o.clusterRadius||50)*n,log:!1,generateId:o.generateId||!1},clusterProperties:o.clusterProperties},o.workerOptions);}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData((function(i){if(i)e.fire(new t.ErrorEvent(i));else {var o={dataType:"source",sourceDataType:"metadata"};e._collectResourceTiming&&e._resourceTiming&&e._resourceTiming.length>0&&(o.resourceTiming=e._resourceTiming,e._resourceTiming=[]),e.fire(new t.Event("data",o));}}));},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setData=function(e){var i=this;return this._data=e,this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData((function(e){if(e)i.fire(new t.ErrorEvent(e));else {var o={dataType:"source",sourceDataType:"content"};i._collectResourceTiming&&i._resourceTiming&&i._resourceTiming.length>0&&(o.resourceTiming=i._resourceTiming,i._resourceTiming=[]),i.fire(new t.Event("data",o));}})),this},i.prototype.getClusterExpansionZoom=function(t,e){return this.actor.send("geojson.getClusterExpansionZoom",{clusterId:t,source:this.id},e),this},i.prototype.getClusterChildren=function(t,e){return this.actor.send("geojson.getClusterChildren",{clusterId:t,source:this.id},e),this},i.prototype.getClusterLeaves=function(t,e,i,o){return this.actor.send("geojson.getClusterLeaves",{source:this.id,clusterId:t,limit:e,offset:i},o),this},i.prototype._updateWorkerData=function(e){var i=this;this._loaded=!1;var o=t.extend({},this.workerOptions),r=this._data;"string"==typeof r?(o.request=this.map._requestManager.transformRequest(t.browser.resolveURL(r),t.ResourceType.Source),o.request.collectResourceTiming=this._collectResourceTiming):o.data=JSON.stringify(r),this.actor.send(this.type+".loadData",o,(function(t,r){i._removed||r&&r.abandoned||(i._loaded=!0,r&&r.resourceTiming&&r.resourceTiming[i.id]&&(i._resourceTiming=r.resourceTiming[i.id].slice(0)),i.actor.send(i.type+".coalesce",{source:o.source},null),e(t));}));},i.prototype.loaded=function(){return this._loaded},i.prototype.loadTile=function(e,i){var o=this,r=e.actor?"reloadTile":"loadTile";e.actor=this.actor,e.request=this.actor.send(r,{type:this.type,uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId},(function(t,a){return delete e.request,e.unloadVectorData(),e.aborted?i(null):t?i(t):(e.loadVectorData(a,o.map.painter,"reloadTile"===r),i(null))}));},i.prototype.abortTile=function(t){t.request&&(t.request.cancel(),delete t.request),t.aborted=!0;},i.prototype.unloadTile=function(t){t.unloadVectorData(),this.actor.send("removeTile",{uid:t.uid,type:this.type,source:this.id});},i.prototype.onRemove=function(){this._removed=!0,this.actor.send("removeSource",{type:this.type,source:this.id});},i.prototype.serialize=function(){return t.extend({},this._options,{type:this.type,data:this._data})},i.prototype.hasTransition=function(){return !1},i}(t.Evented),M=t.createLayout([{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]),L=function(e){function i(t,i,o,r){e.call(this),this.id=t,this.dispatcher=o,this.coordinates=i.coordinates,this.type="image",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.tiles={},this._loaded=!1,this.setEventedParent(r),this.options=i;}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.load=function(e,i){var o=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this.url=this.options.url,t.getImage(this.map._requestManager.transformRequest(this.url,t.ResourceType.Image),(function(r,a){o._loaded=!0,r?o.fire(new t.ErrorEvent(r)):a&&(o.image=a,e&&(o.coordinates=e),i&&i(),o._finishLoading());}));},i.prototype.loaded=function(){return this._loaded},i.prototype.updateImage=function(t){var e=this;return this.image&&t.url?(this.options.url=t.url,this.load(t.coordinates,(function(){e.texture=null;})),this):this},i.prototype._finishLoading=function(){this.map&&(this.setCoordinates(this.coordinates),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})));},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setCoordinates=function(e){var i=this;this.coordinates=e;var o=e.map(t.MercatorCoordinate.fromLngLat);this.tileID=function(e){for(var i=1/0,o=1/0,r=-1/0,a=-1/0,n=0,s=e;n<s.length;n+=1){var l=s[n];i=Math.min(i,l.x),o=Math.min(o,l.y),r=Math.max(r,l.x),a=Math.max(a,l.y);}var c=Math.max(r-i,a-o),u=Math.max(0,Math.floor(-Math.log(c)/Math.LN2)),h=Math.pow(2,u);return new t.CanonicalTileID(u,Math.floor((i+r)/2*h),Math.floor((o+a)/2*h))}(o),this.minzoom=this.maxzoom=this.tileID.z;var r=o.map((function(t){return i.tileID.getTilePoint(t)._round()}));return this._boundsArray=new t.StructArrayLayout4i8,this._boundsArray.emplaceBack(r[0].x,r[0].y,0,0),this._boundsArray.emplaceBack(r[1].x,r[1].y,t.EXTENT,0),this._boundsArray.emplaceBack(r[3].x,r[3].y,0,t.EXTENT),this._boundsArray.emplaceBack(r[2].x,r[2].y,t.EXTENT,t.EXTENT),this.boundsBuffer&&(this.boundsBuffer.destroy(),delete this.boundsBuffer),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})),this},i.prototype.prepare=function(){if(0!==Object.keys(this.tiles).length&&this.image){var e=this.map.painter.context,i=e.gl;for(var o in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,M.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture||(this.texture=new t.Texture(e,this.image,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var r=this.tiles[o];"loaded"!==r.state&&(r.state="loaded",r.texture=this.texture);}}},i.prototype.loadTile=function(t,e){this.tileID&&this.tileID.equals(t.tileID.canonical)?(this.tiles[String(t.tileID.wrap)]=t,t.buckets={},e(null)):(t.state="errored",e(null));},i.prototype.serialize=function(){return {type:"image",url:this.options.url,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return !1},i}(t.Evented),A=function(e){function i(t,i,o,r){e.call(this,t,i,o,r),this.roundZoom=!0,this.type="video",this.options=i;}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.load=function(){var e=this;this._loaded=!1;var i=this.options;this.urls=[];for(var o=0,r=i.urls;o<r.length;o+=1)this.urls.push(this.map._requestManager.transformRequest(r[o],t.ResourceType.Source).url);t.getVideo(this.urls,(function(i,o){e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):o&&(e.video=o,e.video.loop=!0,e.video.addEventListener("playing",(function(){e.map.triggerRepaint();})),e.map&&e.video.play(),e._finishLoading());}));},i.prototype.pause=function(){this.video&&this.video.pause();},i.prototype.play=function(){this.video&&this.video.play();},i.prototype.seek=function(e){if(this.video){var i=this.video.seekable;e<i.start(0)||e>i.end(0)?this.fire(new t.ErrorEvent(new t.ValidationError("sources."+this.id,null,"Playback for this video can be set only between the "+i.start(0)+" and "+i.end(0)+"-second mark."))):this.video.currentTime=e;}},i.prototype.getVideo=function(){return this.video},i.prototype.onAdd=function(t){this.map||(this.map=t,this.load(),this.video&&(this.video.play(),this.setCoordinates(this.coordinates)));},i.prototype.prepare=function(){if(!(0===Object.keys(this.tiles).length||this.video.readyState<2)){var e=this.map.painter.context,i=e.gl;for(var o in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,M.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?this.video.paused||(this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE),i.texSubImage2D(i.TEXTURE_2D,0,0,0,i.RGBA,i.UNSIGNED_BYTE,this.video)):(this.texture=new t.Texture(e,this.video,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var r=this.tiles[o];"loaded"!==r.state&&(r.state="loaded",r.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"video",urls:this.urls,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this.video&&!this.video.paused},i}(L),R=function(e){function i(i,o,r,a){e.call(this,i,o,r,a),o.coordinates?Array.isArray(o.coordinates)&&4===o.coordinates.length&&!o.coordinates.some((function(t){return !Array.isArray(t)||2!==t.length||t.some((function(t){return "number"!=typeof t}))}))||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"coordinates" property must be an array of 4 longitude/latitude array pairs'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "coordinates"'))),o.animate&&"boolean"!=typeof o.animate&&this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'optional "animate" property must be a boolean value'))),o.canvas?"string"==typeof o.canvas||o.canvas instanceof t.window.HTMLCanvasElement||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "canvas"'))),this.options=o,this.animate=void 0===o.animate||o.animate;}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.load=function(){this._loaded=!0,this.canvas||(this.canvas=this.options.canvas instanceof t.window.HTMLCanvasElement?this.options.canvas:t.window.document.getElementById(this.options.canvas)),this.width=this.canvas.width,this.height=this.canvas.height,this._hasInvalidDimensions()?this.fire(new t.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))):(this.play=function(){this._playing=!0,this.map.triggerRepaint();},this.pause=function(){this._playing&&(this.prepare(),this._playing=!1);},this._finishLoading());},i.prototype.getCanvas=function(){return this.canvas},i.prototype.onAdd=function(t){this.map=t,this.load(),this.canvas&&this.animate&&this.play();},i.prototype.onRemove=function(){this.pause();},i.prototype.prepare=function(){var e=!1;if(this.canvas.width!==this.width&&(this.width=this.canvas.width,e=!0),this.canvas.height!==this.height&&(this.height=this.canvas.height,e=!0),!this._hasInvalidDimensions()&&0!==Object.keys(this.tiles).length){var i=this.map.painter.context,o=i.gl;for(var r in this.boundsBuffer||(this.boundsBuffer=i.createVertexBuffer(this._boundsArray,M.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?(e||this._playing)&&this.texture.update(this.canvas,{premultiply:!0}):this.texture=new t.Texture(i,this.canvas,o.RGBA,{premultiply:!0}),this.tiles){var a=this.tiles[r];"loaded"!==a.state&&(a.state="loaded",a.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"canvas",coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this._playing},i.prototype._hasInvalidDimensions=function(){for(var t=0,e=[this.canvas.width,this.canvas.height];t<e.length;t+=1){var i=e[t];if(isNaN(i)||i<=0)return !0}return !1},i}(L),k={vector:S,raster:C,"raster-dem":z,geojson:D,video:A,image:L,canvas:R};function B(e,i){var o=t.identity([]);return t.translate(o,o,[1,1,0]),t.scale(o,o,[.5*e.width,.5*e.height,1]),t.multiply(o,o,e.calculatePosMatrix(i.toUnwrapped()))}function O(t,e,i,o,r,a){var n=function(t,e,i){if(t)for(var o=0,r=t;o<r.length;o+=1){var a=e[r[o]];if(a&&a.source===i&&"fill-extrusion"===a.type)return !0}else for(var n in e){var s=e[n];if(s.source===i&&"fill-extrusion"===s.type)return !0}return !1}(r&&r.layers,e,t.id),s=a.maxPitchScaleFactor(),l=t.tilesIn(o,s,n);l.sort(F);for(var c=[],u=0,h=l;u<h.length;u+=1){var p=h[u];c.push({wrappedTileID:p.tileID.wrapped().key,queryResults:p.tile.queryRenderedFeatures(e,i,t._state,p.queryGeometry,p.cameraQueryGeometry,p.scale,r,a,s,B(t.transform,p.tileID))});}var d=function(t){for(var e={},i={},o=0,r=t;o<r.length;o+=1){var a=r[o],n=a.queryResults,s=a.wrappedTileID,l=i[s]=i[s]||{};for(var c in n)for(var u=n[c],h=l[c]=l[c]||{},p=e[c]=e[c]||[],d=0,_=u;d<_.length;d+=1){var f=_[d];h[f.featureIndex]||(h[f.featureIndex]=!0,p.push(f));}}return e}(c);for(var _ in d)d[_].forEach((function(e){var i=e.feature,o=t.getFeatureState(i.layer["source-layer"],i.id);i.source=i.layer.source,i.layer["source-layer"]&&(i.sourceLayer=i.layer["source-layer"]),i.state=o;}));return d}function F(t,e){var i=t.tileID,o=e.tileID;return i.overscaledZ-o.overscaledZ||i.canonical.y-o.canonical.y||i.wrap-o.wrap||i.canonical.x-o.canonical.x}var U=function(t,e){this.max=t,this.onRemove=e,this.reset();};U.prototype.reset=function(){for(var t in this.data)for(var e=0,i=this.data[t];e<i.length;e+=1){var o=i[e];o.timeout&&clearTimeout(o.timeout),this.onRemove(o.value);}return this.data={},this.order=[],this},U.prototype.add=function(t,e,i){var o=this,r=t.wrapped().key;void 0===this.data[r]&&(this.data[r]=[]);var a={value:e,timeout:void 0};if(void 0!==i&&(a.timeout=setTimeout((function(){o.remove(t,a);}),i)),this.data[r].push(a),this.order.push(r),this.order.length>this.max){var n=this._getAndRemoveByKey(this.order[0]);n&&this.onRemove(n);}return this},U.prototype.has=function(t){return t.wrapped().key in this.data},U.prototype.getAndRemove=function(t){return this.has(t)?this._getAndRemoveByKey(t.wrapped().key):null},U.prototype._getAndRemoveByKey=function(t){var e=this.data[t].shift();return e.timeout&&clearTimeout(e.timeout),0===this.data[t].length&&delete this.data[t],this.order.splice(this.order.indexOf(t),1),e.value},U.prototype.getByKey=function(t){var e=this.data[t];return e?e[0].value:null},U.prototype.get=function(t){return this.has(t)?this.data[t.wrapped().key][0].value:null},U.prototype.remove=function(t,e){if(!this.has(t))return this;var i=t.wrapped().key,o=void 0===e?0:this.data[i].indexOf(e),r=this.data[i][o];return this.data[i].splice(o,1),r.timeout&&clearTimeout(r.timeout),0===this.data[i].length&&delete this.data[i],this.onRemove(r.value),this.order.splice(this.order.indexOf(i),1),this},U.prototype.setMaxSize=function(t){for(this.max=t;this.order.length>this.max;){var e=this._getAndRemoveByKey(this.order[0]);e&&this.onRemove(e);}return this},U.prototype.filter=function(t){var e=[];for(var i in this.data)for(var o=0,r=this.data[i];o<r.length;o+=1){var a=r[o];t(a.value)||e.push(a);}for(var n=0,s=e;n<s.length;n+=1){var l=s[n];this.remove(l.value.tileID,l);}};var N=function(t,e,i){this.context=t;var o=t.gl;this.buffer=o.createBuffer(),this.dynamicDraw=Boolean(i),this.context.unbindVAO(),t.bindElementBuffer.set(this.buffer),o.bufferData(o.ELEMENT_ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?o.DYNAMIC_DRAW:o.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};N.prototype.bind=function(){this.context.bindElementBuffer.set(this.buffer);},N.prototype.updateData=function(t){var e=this.context.gl;this.context.unbindVAO(),this.bind(),e.bufferSubData(e.ELEMENT_ARRAY_BUFFER,0,t.arrayBuffer);},N.prototype.destroy=function(){this.buffer&&(this.context.gl.deleteBuffer(this.buffer),delete this.buffer);};var Z={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT",Int32:"INT",Uint32:"UNSIGNED_INT",Float32:"FLOAT"},j=function(t,e,i,o){this.length=e.length,this.attributes=i,this.itemSize=e.bytesPerElement,this.dynamicDraw=o,this.context=t;var r=t.gl;this.buffer=r.createBuffer(),t.bindVertexBuffer.set(this.buffer),r.bufferData(r.ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?r.DYNAMIC_DRAW:r.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};j.prototype.bind=function(){this.context.bindVertexBuffer.set(this.buffer);},j.prototype.updateData=function(t){var e=this.context.gl;this.bind(),e.bufferSubData(e.ARRAY_BUFFER,0,t.arrayBuffer);},j.prototype.enableAttributes=function(t,e){for(var i=0;i<this.attributes.length;i++){var o=e.attributes[this.attributes[i].name];void 0!==o&&t.enableVertexAttribArray(o);}},j.prototype.setVertexAttribPointers=function(t,e,i){for(var o=0;o<this.attributes.length;o++){var r=this.attributes[o],a=e.attributes[r.name];void 0!==a&&t.vertexAttribPointer(a,r.components,t[Z[r.type]],!1,this.itemSize,r.offset+this.itemSize*(i||0));}},j.prototype.destroy=function(){this.buffer&&(this.context.gl.deleteBuffer(this.buffer),delete this.buffer);};var q=function(t){this.gl=t.gl,this.default=this.getDefault(),this.current=this.default,this.dirty=!1;};q.prototype.get=function(){return this.current},q.prototype.set=function(t){},q.prototype.getDefault=function(){return this.default},q.prototype.setDefault=function(){this.set(this.default);};var V=function(e){function i(){e.apply(this,arguments);}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.getDefault=function(){return t.Color.transparent},i.prototype.set=function(t){var e=this.current;(t.r!==e.r||t.g!==e.g||t.b!==e.b||t.a!==e.a||this.dirty)&&(this.gl.clearColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1);},i}(q),G=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return 1},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.clearDepth(t),this.current=t,this.dirty=!1);},e}(q),W=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return 0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.clearStencil(t),this.current=t,this.dirty=!1);},e}(q),X=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return [!0,!0,!0,!0]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||t[3]!==e[3]||this.dirty)&&(this.gl.colorMask(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1);},e}(q),H=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return !0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.depthMask(t),this.current=t,this.dirty=!1);},e}(q),K=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return 255},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.stencilMask(t),this.current=t,this.dirty=!1);},e}(q),Y=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return {func:this.gl.ALWAYS,ref:0,mask:255}},e.prototype.set=function(t){var e=this.current;(t.func!==e.func||t.ref!==e.ref||t.mask!==e.mask||this.dirty)&&(this.gl.stencilFunc(t.func,t.ref,t.mask),this.current=t,this.dirty=!1);},e}(q),J=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [t.KEEP,t.KEEP,t.KEEP]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||this.dirty)&&(this.gl.stencilOp(t[0],t[1],t[2]),this.current=t,this.dirty=!1);},e}(q),Q=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.STENCIL_TEST):e.disable(e.STENCIL_TEST),this.current=t,this.dirty=!1;}},e}(q),$=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return [0,1]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||this.dirty)&&(this.gl.depthRange(t[0],t[1]),this.current=t,this.dirty=!1);},e}(q),tt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.DEPTH_TEST):e.disable(e.DEPTH_TEST),this.current=t,this.dirty=!1;}},e}(q),et=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return this.gl.LESS},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.depthFunc(t),this.current=t,this.dirty=!1);},e}(q),it=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.BLEND):e.disable(e.BLEND),this.current=t,this.dirty=!1;}},e}(q),ot=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [t.ONE,t.ZERO]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||this.dirty)&&(this.gl.blendFunc(t[0],t[1]),this.current=t,this.dirty=!1);},e}(q),rt=function(e){function i(){e.apply(this,arguments);}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.getDefault=function(){return t.Color.transparent},i.prototype.set=function(t){var e=this.current;(t.r!==e.r||t.g!==e.g||t.b!==e.b||t.a!==e.a||this.dirty)&&(this.gl.blendColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1);},i}(q),at=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return this.gl.FUNC_ADD},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.blendEquation(t),this.current=t,this.dirty=!1);},e}(q),nt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.CULL_FACE):e.disable(e.CULL_FACE),this.current=t,this.dirty=!1;}},e}(q),st=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return this.gl.BACK},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.cullFace(t),this.current=t,this.dirty=!1);},e}(q),lt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return this.gl.CCW},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.frontFace(t),this.current=t,this.dirty=!1);},e}(q),ct=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.useProgram(t),this.current=t,this.dirty=!1);},e}(q),ut=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return this.gl.TEXTURE0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.activeTexture(t),this.current=t,this.dirty=!1);},e}(q),ht=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [0,0,t.drawingBufferWidth,t.drawingBufferHeight]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||t[3]!==e[3]||this.dirty)&&(this.gl.viewport(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1);},e}(q),pt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindFramebuffer(e.FRAMEBUFFER,t),this.current=t,this.dirty=!1;}},e}(q),dt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindRenderbuffer(e.RENDERBUFFER,t),this.current=t,this.dirty=!1;}},e}(q),_t=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindTexture(e.TEXTURE_2D,t),this.current=t,this.dirty=!1;}},e}(q),ft=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindBuffer(e.ARRAY_BUFFER,t),this.current=t,this.dirty=!1;}},e}(q),mt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){var e=this.gl;e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,t),this.current=t,this.dirty=!1;},e}(q),gt=function(t){function e(e){t.call(this,e),this.vao=e.extVertexArrayObject;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){this.vao&&(t!==this.current||this.dirty)&&(this.vao.bindVertexArrayOES(t),this.current=t,this.dirty=!1);},e}(q),vt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return 4},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_ALIGNMENT,t),this.current=t,this.dirty=!1;}},e}(q),yt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,t),this.current=t,this.dirty=!1;}},e}(q),xt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,t),this.current=t,this.dirty=!1;}},e}(q),bt=function(t){function e(e,i){t.call(this,e),this.context=e,this.parent=i;}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.getDefault=function(){return null},e}(q),wt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.setDirty=function(){this.dirty=!0;},e.prototype.set=function(t){if(t!==this.current||this.dirty){this.context.bindFramebuffer.set(this.parent);var e=this.gl;e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0),this.current=t,this.dirty=!1;}},e}(bt),Tt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.set=function(t){if(t!==this.current||this.dirty){this.context.bindFramebuffer.set(this.parent);var e=this.gl;e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.RENDERBUFFER,t),this.current=t,this.dirty=!1;}},e}(bt),Et=function(t,e,i,o){this.context=t,this.width=e,this.height=i;var r=this.framebuffer=t.gl.createFramebuffer();this.colorAttachment=new wt(t,r),o&&(this.depthAttachment=new Tt(t,r));};Et.prototype.destroy=function(){var t=this.context.gl,e=this.colorAttachment.get();if(e&&t.deleteTexture(e),this.depthAttachment){var i=this.depthAttachment.get();i&&t.deleteRenderbuffer(i);}t.deleteFramebuffer(this.framebuffer);};var It=function(t,e,i){this.func=t,this.mask=e,this.range=i;};It.ReadOnly=!1,It.ReadWrite=!0,It.disabled=new It(519,It.ReadOnly,[0,1]);var Pt=function(t,e,i,o,r,a){this.test=t,this.ref=e,this.mask=i,this.fail=o,this.depthFail=r,this.pass=a;};Pt.disabled=new Pt({func:519,mask:0},0,0,7680,7680,7680);var St=function(t,e,i){this.blendFunction=t,this.blendColor=e,this.mask=i;};St.disabled=new St(St.Replace=[1,0],t.Color.transparent,[!1,!1,!1,!1]),St.unblended=new St(St.Replace,t.Color.transparent,[!0,!0,!0,!0]),St.alphaBlended=new St([1,771],t.Color.transparent,[!0,!0,!0,!0]);var Ct=function(t,e,i){this.enable=t,this.mode=e,this.frontFace=i;};Ct.disabled=new Ct(!1,1029,2305),Ct.backCCW=new Ct(!0,1029,2305);var zt=function(t){this.gl=t,this.extVertexArrayObject=this.gl.getExtension("OES_vertex_array_object"),this.clearColor=new V(this),this.clearDepth=new G(this),this.clearStencil=new W(this),this.colorMask=new X(this),this.depthMask=new H(this),this.stencilMask=new K(this),this.stencilFunc=new Y(this),this.stencilOp=new J(this),this.stencilTest=new Q(this),this.depthRange=new $(this),this.depthTest=new tt(this),this.depthFunc=new et(this),this.blend=new it(this),this.blendFunc=new ot(this),this.blendColor=new rt(this),this.blendEquation=new at(this),this.cullFace=new nt(this),this.cullFaceSide=new st(this),this.frontFace=new lt(this),this.program=new ct(this),this.activeTexture=new ut(this),this.viewport=new ht(this),this.bindFramebuffer=new pt(this),this.bindRenderbuffer=new dt(this),this.bindTexture=new _t(this),this.bindVertexBuffer=new ft(this),this.bindElementBuffer=new mt(this),this.bindVertexArrayOES=this.extVertexArrayObject&&new gt(this),this.pixelStoreUnpack=new vt(this),this.pixelStoreUnpackPremultiplyAlpha=new yt(this),this.pixelStoreUnpackFlipY=new xt(this),this.extTextureFilterAnisotropic=t.getExtension("EXT_texture_filter_anisotropic")||t.getExtension("MOZ_EXT_texture_filter_anisotropic")||t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.extTextureFilterAnisotropic&&(this.extTextureFilterAnisotropicMax=t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.extTextureHalfFloat=t.getExtension("OES_texture_half_float"),this.extTextureHalfFloat&&(t.getExtension("OES_texture_half_float_linear"),this.extRenderToTextureHalfFloat=t.getExtension("EXT_color_buffer_half_float")),this.extTimerQuery=t.getExtension("EXT_disjoint_timer_query");};zt.prototype.setDefault=function(){this.unbindVAO(),this.clearColor.setDefault(),this.clearDepth.setDefault(),this.clearStencil.setDefault(),this.colorMask.setDefault(),this.depthMask.setDefault(),this.stencilMask.setDefault(),this.stencilFunc.setDefault(),this.stencilOp.setDefault(),this.stencilTest.setDefault(),this.depthRange.setDefault(),this.depthTest.setDefault(),this.depthFunc.setDefault(),this.blend.setDefault(),this.blendFunc.setDefault(),this.blendColor.setDefault(),this.blendEquation.setDefault(),this.cullFace.setDefault(),this.cullFaceSide.setDefault(),this.frontFace.setDefault(),this.program.setDefault(),this.activeTexture.setDefault(),this.bindFramebuffer.setDefault(),this.pixelStoreUnpack.setDefault(),this.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.pixelStoreUnpackFlipY.setDefault();},zt.prototype.setDirty=function(){this.clearColor.dirty=!0,this.clearDepth.dirty=!0,this.clearStencil.dirty=!0,this.colorMask.dirty=!0,this.depthMask.dirty=!0,this.stencilMask.dirty=!0,this.stencilFunc.dirty=!0,this.stencilOp.dirty=!0,this.stencilTest.dirty=!0,this.depthRange.dirty=!0,this.depthTest.dirty=!0,this.depthFunc.dirty=!0,this.blend.dirty=!0,this.blendFunc.dirty=!0,this.blendColor.dirty=!0,this.blendEquation.dirty=!0,this.cullFace.dirty=!0,this.cullFaceSide.dirty=!0,this.frontFace.dirty=!0,this.program.dirty=!0,this.activeTexture.dirty=!0,this.viewport.dirty=!0,this.bindFramebuffer.dirty=!0,this.bindRenderbuffer.dirty=!0,this.bindTexture.dirty=!0,this.bindVertexBuffer.dirty=!0,this.bindElementBuffer.dirty=!0,this.extVertexArrayObject&&(this.bindVertexArrayOES.dirty=!0),this.pixelStoreUnpack.dirty=!0,this.pixelStoreUnpackPremultiplyAlpha.dirty=!0,this.pixelStoreUnpackFlipY.dirty=!0;},zt.prototype.createIndexBuffer=function(t,e){return new N(this,t,e)},zt.prototype.createVertexBuffer=function(t,e,i){return new j(this,t,e,i)},zt.prototype.createRenderbuffer=function(t,e,i){var o=this.gl,r=o.createRenderbuffer();return this.bindRenderbuffer.set(r),o.renderbufferStorage(o.RENDERBUFFER,t,e,i),this.bindRenderbuffer.set(null),r},zt.prototype.createFramebuffer=function(t,e,i){return new Et(this,t,e,i)},zt.prototype.clear=function(t){var e=t.color,i=t.depth,o=this.gl,r=0;e&&(r|=o.COLOR_BUFFER_BIT,this.clearColor.set(e),this.colorMask.set([!0,!0,!0,!0])),void 0!==i&&(r|=o.DEPTH_BUFFER_BIT,this.depthRange.set([0,1]),this.clearDepth.set(i),this.depthMask.set(!0)),o.clear(r);},zt.prototype.setCullFace=function(t){!1===t.enable?this.cullFace.set(!1):(this.cullFace.set(!0),this.cullFaceSide.set(t.mode),this.frontFace.set(t.frontFace));},zt.prototype.setDepthMode=function(t){t.func!==this.gl.ALWAYS||t.mask?(this.depthTest.set(!0),this.depthFunc.set(t.func),this.depthMask.set(t.mask),this.depthRange.set(t.range)):this.depthTest.set(!1);},zt.prototype.setStencilMode=function(t){t.test.func!==this.gl.ALWAYS||t.mask?(this.stencilTest.set(!0),this.stencilMask.set(t.mask),this.stencilOp.set([t.fail,t.depthFail,t.pass]),this.stencilFunc.set({func:t.test.func,ref:t.ref,mask:t.test.mask})):this.stencilTest.set(!1);},zt.prototype.setColorMode=function(e){t.deepEqual(e.blendFunction,St.Replace)?this.blend.set(!1):(this.blend.set(!0),this.blendFunc.set(e.blendFunction),this.blendColor.set(e.blendColor)),this.colorMask.set(e.mask);},zt.prototype.unbindVAO=function(){this.extVertexArrayObject&&this.bindVertexArrayOES.set(null);};var Dt=function(e){function i(i,o,r){var a=this;e.call(this),this.id=i,this.dispatcher=r,this.on("data",(function(t){"source"===t.dataType&&"metadata"===t.sourceDataType&&(a._sourceLoaded=!0),a._sourceLoaded&&!a._paused&&"source"===t.dataType&&"content"===t.sourceDataType&&(a.reload(),a.transform&&a.update(a.transform));})),this.on("error",(function(){a._sourceErrored=!0;})),this._source=function(e,i,o,r){var a=new k[i.type](e,i,o,r);if(a.id!==e)throw new Error("Expected Source id to be "+e+" instead of "+a.id);return t.bindAll(["load","abort","unload","serialize","prepare"],a),a}(i,o,r,this),this._tiles={},this._cache=new U(0,this._unloadTile.bind(this)),this._timers={},this._cacheTimers={},this._maxTileCacheSize=null,this._loadedParentTiles={},this._coveredTiles={},this._state=new t.SourceFeatureState;}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.onAdd=function(t){this.map=t,this._maxTileCacheSize=t?t._maxTileCacheSize:null,this._source&&this._source.onAdd&&this._source.onAdd(t);},i.prototype.onRemove=function(t){this._source&&this._source.onRemove&&this._source.onRemove(t);},i.prototype.loaded=function(){if(this._sourceErrored)return !0;if(!this._sourceLoaded)return !1;if(!this._source.loaded())return !1;for(var t in this._tiles){var e=this._tiles[t];if("loaded"!==e.state&&"errored"!==e.state)return !1}return !0},i.prototype.getSource=function(){return this._source},i.prototype.pause=function(){this._paused=!0;},i.prototype.resume=function(){if(this._paused){var t=this._shouldReloadOnResume;this._paused=!1,this._shouldReloadOnResume=!1,t&&this.reload(),this.transform&&this.update(this.transform);}},i.prototype._loadTile=function(t,e){return this._source.loadTile(t,e)},i.prototype._unloadTile=function(t){if(this._source.unloadTile)return this._source.unloadTile(t,(function(){}))},i.prototype._abortTile=function(t){if(this._source.abortTile)return this._source.abortTile(t,(function(){}))},i.prototype.serialize=function(){return this._source.serialize()},i.prototype.prepare=function(t){for(var e in this._source.prepare&&this._source.prepare(),this._state.coalesceChanges(this._tiles,this.map?this.map.painter:null),this._tiles){var i=this._tiles[e];i.upload(t),i.prepare(this.map.style.imageManager);}},i.prototype.getIds=function(){return t.values(this._tiles).map((function(t){return t.tileID})).sort(Mt).map((function(t){return t.key}))},i.prototype.getRenderableIds=function(e){var i=this,o=[];for(var r in this._tiles)this._isIdRenderable(r,e)&&o.push(this._tiles[r]);return e?o.sort((function(e,o){var r=e.tileID,a=o.tileID,n=new t.Point(r.canonical.x,r.canonical.y)._rotate(i.transform.angle),s=new t.Point(a.canonical.x,a.canonical.y)._rotate(i.transform.angle);return r.overscaledZ-a.overscaledZ||s.y-n.y||s.x-n.x})).map((function(t){return t.tileID.key})):o.map((function(t){return t.tileID})).sort(Mt).map((function(t){return t.key}))},i.prototype.hasRenderableParent=function(t){var e=this.findLoadedParent(t,0);return !!e&&this._isIdRenderable(e.tileID.key)},i.prototype._isIdRenderable=function(t,e){return this._tiles[t]&&this._tiles[t].hasData()&&!this._coveredTiles[t]&&(e||!this._tiles[t].holdingForFade())},i.prototype.reload=function(){if(this._paused)this._shouldReloadOnResume=!0;else for(var t in this._cache.reset(),this._tiles)"errored"!==this._tiles[t].state&&this._reloadTile(t,"reloading");},i.prototype._reloadTile=function(t,e){var i=this._tiles[t];i&&("loading"!==i.state&&(i.state=e),this._loadTile(i,this._tileLoaded.bind(this,i,t,e)));},i.prototype._tileLoaded=function(e,i,o,r){if(r)return e.state="errored",void(404!==r.status?this._source.fire(new t.ErrorEvent(r,{tile:e})):this.update(this.transform));e.timeAdded=t.browser.now(),"expired"===o&&(e.refreshedUponExpiration=!0),this._setTileReloadTimer(i,e),"raster-dem"===this.getSource().type&&e.dem&&this._backfillDEM(e),this._state.initializeTileState(e,this.map?this.map.painter:null),this._source.fire(new t.Event("data",{dataType:"source",tile:e,coord:e.tileID}));},i.prototype._backfillDEM=function(t){for(var e=this.getRenderableIds(),i=0;i<e.length;i++){var o=e[i];if(t.neighboringTiles&&t.neighboringTiles[o]){var r=this.getTileByID(o);a(t,r),a(r,t);}}function a(t,e){t.needsHillshadePrepare=!0;var i=e.tileID.canonical.x-t.tileID.canonical.x,o=e.tileID.canonical.y-t.tileID.canonical.y,r=Math.pow(2,t.tileID.canonical.z),a=e.tileID.key;0===i&&0===o||Math.abs(o)>1||(Math.abs(i)>1&&(1===Math.abs(i+r)?i+=r:1===Math.abs(i-r)&&(i-=r)),e.dem&&t.dem&&(t.dem.backfillBorder(e.dem,i,o),t.neighboringTiles&&t.neighboringTiles[a]&&(t.neighboringTiles[a].backfilled=!0)));}},i.prototype.getTile=function(t){return this.getTileByID(t.key)},i.prototype.getTileByID=function(t){return this._tiles[t]},i.prototype._retainLoadedChildren=function(t,e,i,o){for(var r in this._tiles){var a=this._tiles[r];if(!(o[r]||!a.hasData()||a.tileID.overscaledZ<=e||a.tileID.overscaledZ>i)){for(var n=a.tileID;a&&a.tileID.overscaledZ>e+1;){var s=a.tileID.scaledTo(a.tileID.overscaledZ-1);(a=this._tiles[s.key])&&a.hasData()&&(n=s);}for(var l=n;l.overscaledZ>e;)if(t[(l=l.scaledTo(l.overscaledZ-1)).key]){o[n.key]=n;break}}}},i.prototype.findLoadedParent=function(t,e){if(t.key in this._loadedParentTiles){var i=this._loadedParentTiles[t.key];return i&&i.tileID.overscaledZ>=e?i:null}for(var o=t.overscaledZ-1;o>=e;o--){var r=t.scaledTo(o),a=this._getLoadedTile(r);if(a)return a}},i.prototype._getLoadedTile=function(t){var e=this._tiles[t.key];return e&&e.hasData()?e:this._cache.getByKey(t.wrapped().key)},i.prototype.updateCacheSize=function(t){var e=Math.ceil(t.width/this._source.tileSize)+1,i=Math.ceil(t.height/this._source.tileSize)+1,o=Math.floor(e*i*5),r="number"==typeof this._maxTileCacheSize?Math.min(this._maxTileCacheSize,o):o;this._cache.setMaxSize(r);},i.prototype.handleWrapJump=function(t){var e=Math.round((t-(void 0===this._prevLng?t:this._prevLng))/360);if(this._prevLng=t,e){var i={};for(var o in this._tiles){var r=this._tiles[o];r.tileID=r.tileID.unwrapTo(r.tileID.wrap+e),i[r.tileID.key]=r;}for(var a in this._tiles=i,this._timers)clearTimeout(this._timers[a]),delete this._timers[a];for(var n in this._tiles)this._setTileReloadTimer(n,this._tiles[n]);}},i.prototype.update=function(e){var o=this;if(this.transform=e,this._sourceLoaded&&!this._paused){var r;this.updateCacheSize(e),this.handleWrapJump(this.transform.center.lng),this._coveredTiles={},this.used?this._source.tileID?r=e.getVisibleUnwrappedCoordinates(this._source.tileID).map((function(e){return new t.OverscaledTileID(e.canonical.z,e.wrap,e.canonical.z,e.canonical.x,e.canonical.y)})):(r=e.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}),this._source.hasTile&&(r=r.filter((function(t){return o._source.hasTile(t)})))):r=[];var a=e.coveringZoomLevel(this._source),n=Math.max(a-i.maxOverzooming,this._source.minzoom),s=Math.max(a+i.maxUnderzooming,this._source.minzoom),l=this._updateRetainedTiles(r,a);if(Lt(this._source.type)){for(var c={},u={},h=0,p=Object.keys(l);h<p.length;h+=1){var d=p[h],_=l[d],f=this._tiles[d];if(f&&!(f.fadeEndTime&&f.fadeEndTime<=t.browser.now())){var m=this.findLoadedParent(_,n);m&&(this._addTile(m.tileID),c[m.tileID.key]=m.tileID),u[d]=_;}}for(var g in this._retainLoadedChildren(u,a,s,l),c)l[g]||(this._coveredTiles[g]=!0,l[g]=c[g]);}for(var v in l)this._tiles[v].clearFadeHold();for(var y=0,x=t.keysDifference(this._tiles,l);y<x.length;y+=1){var b=x[y],w=this._tiles[b];w.hasSymbolBuckets&&!w.holdingForFade()?w.setHoldDuration(this.map._fadeDuration):w.hasSymbolBuckets&&!w.symbolFadeFinished()||this._removeTile(b);}this._updateLoadedParentTileCache();}},i.prototype.releaseSymbolFadeTiles=function(){for(var t in this._tiles)this._tiles[t].holdingForFade()&&this._removeTile(t);},i.prototype._updateRetainedTiles=function(t,e){for(var o={},r={},a=Math.max(e-i.maxOverzooming,this._source.minzoom),n=Math.max(e+i.maxUnderzooming,this._source.minzoom),s={},l=0,c=t;l<c.length;l+=1){var u=c[l],h=this._addTile(u);o[u.key]=u,h.hasData()||e<this._source.maxzoom&&(s[u.key]=u);}this._retainLoadedChildren(s,e,n,o);for(var p=0,d=t;p<d.length;p+=1){var _=d[p],f=this._tiles[_.key];if(!f.hasData()){if(e+1>this._source.maxzoom){var m=_.children(this._source.maxzoom)[0],g=this.getTile(m);if(g&&g.hasData()){o[m.key]=m;continue}}else {var v=_.children(this._source.maxzoom);if(o[v[0].key]&&o[v[1].key]&&o[v[2].key]&&o[v[3].key])continue}for(var y=f.wasRequested(),x=_.overscaledZ-1;x>=a;--x){var b=_.scaledTo(x);if(r[b.key])break;if(r[b.key]=!0,!(f=this.getTile(b))&&y&&(f=this._addTile(b)),f&&(o[b.key]=b,y=f.wasRequested(),f.hasData()))break}}}return o},i.prototype._updateLoadedParentTileCache=function(){for(var t in this._loadedParentTiles={},this._tiles){for(var e=[],i=void 0,o=this._tiles[t].tileID;o.overscaledZ>0;){if(o.key in this._loadedParentTiles){i=this._loadedParentTiles[o.key];break}e.push(o.key);var r=o.scaledTo(o.overscaledZ-1);if(i=this._getLoadedTile(r))break;o=r;}for(var a=0,n=e;a<n.length;a+=1)this._loadedParentTiles[n[a]]=i;}},i.prototype._addTile=function(e){var i=this._tiles[e.key];if(i)return i;(i=this._cache.getAndRemove(e))&&(this._setTileReloadTimer(e.key,i),i.tileID=e,this._state.initializeTileState(i,this.map?this.map.painter:null),this._cacheTimers[e.key]&&(clearTimeout(this._cacheTimers[e.key]),delete this._cacheTimers[e.key],this._setTileReloadTimer(e.key,i)));var o=Boolean(i);return o||(i=new t.Tile(e,this._source.tileSize*e.overscaleFactor()),this._loadTile(i,this._tileLoaded.bind(this,i,e.key,i.state))),i?(i.uses++,this._tiles[e.key]=i,o||this._source.fire(new t.Event("dataloading",{tile:i,coord:i.tileID,dataType:"source"})),i):null},i.prototype._setTileReloadTimer=function(t,e){var i=this;t in this._timers&&(clearTimeout(this._timers[t]),delete this._timers[t]);var o=e.getExpiryTimeout();o&&(this._timers[t]=setTimeout((function(){i._reloadTile(t,"expired"),delete i._timers[t];}),o));},i.prototype._removeTile=function(t){var e=this._tiles[t];e&&(e.uses--,delete this._tiles[t],this._timers[t]&&(clearTimeout(this._timers[t]),delete this._timers[t]),e.uses>0||(e.hasData()&&"reloading"!==e.state?this._cache.add(e.tileID,e,e.getExpiryTimeout()):(e.aborted=!0,this._abortTile(e),this._unloadTile(e))));},i.prototype.clearTiles=function(){for(var t in this._shouldReloadOnResume=!1,this._paused=!1,this._tiles)this._removeTile(t);this._cache.reset();},i.prototype.tilesIn=function(e,i,o){var r=this,a=[],n=this.transform;if(!n)return a;for(var s=o?n.getCameraQueryGeometry(e):e,l=e.map((function(t){return n.pointCoordinate(t)})),c=s.map((function(t){return n.pointCoordinate(t)})),u=this.getIds(),h=1/0,p=1/0,d=-1/0,_=-1/0,f=0,m=c;f<m.length;f+=1){var g=m[f];h=Math.min(h,g.x),p=Math.min(p,g.y),d=Math.max(d,g.x),_=Math.max(_,g.y);}for(var v=function(e){var o=r._tiles[u[e]];if(!o.holdingForFade()){var s=o.tileID,f=Math.pow(2,n.zoom-o.tileID.overscaledZ),m=i*o.queryPadding*t.EXTENT/o.tileSize/f,g=[s.getTilePoint(new t.MercatorCoordinate(h,p)),s.getTilePoint(new t.MercatorCoordinate(d,_))];if(g[0].x-m<t.EXTENT&&g[0].y-m<t.EXTENT&&g[1].x+m>=0&&g[1].y+m>=0){var v=l.map((function(t){return s.getTilePoint(t)})),y=c.map((function(t){return s.getTilePoint(t)}));a.push({tile:o,tileID:s,queryGeometry:v,cameraQueryGeometry:y,scale:f});}}},y=0;y<u.length;y++)v(y);return a},i.prototype.getVisibleCoordinates=function(t){for(var e=this,i=this.getRenderableIds(t).map((function(t){return e._tiles[t].tileID})),o=0,r=i;o<r.length;o+=1){var a=r[o];a.posMatrix=this.transform.calculatePosMatrix(a.toUnwrapped());}return i},i.prototype.hasTransition=function(){if(this._source.hasTransition())return !0;if(Lt(this._source.type))for(var e in this._tiles){var i=this._tiles[e];if(void 0!==i.fadeEndTime&&i.fadeEndTime>=t.browser.now())return !0}return !1},i.prototype.setFeatureState=function(t,e,i){this._state.updateState(t=t||"_geojsonTileLayer",e,i);},i.prototype.removeFeatureState=function(t,e,i){this._state.removeFeatureState(t=t||"_geojsonTileLayer",e,i);},i.prototype.getFeatureState=function(t,e){return this._state.getState(t=t||"_geojsonTileLayer",e)},i.prototype.setDependencies=function(t,e,i){var o=this._tiles[t];o&&o.setDependencies(e,i);},i.prototype.reloadTilesForDependencies=function(t,e){for(var i in this._tiles)this._tiles[i].hasDependency(t,e)&&this._reloadTile(i,"reloading");this._cache.filter((function(i){return !i.hasDependency(t,e)}));},i}(t.Evented);function Mt(t,e){var i=Math.abs(2*t.wrap)-+(t.wrap<0),o=Math.abs(2*e.wrap)-+(e.wrap<0);return t.overscaledZ-e.overscaledZ||o-i||e.canonical.y-t.canonical.y||e.canonical.x-t.canonical.x}function Lt(t){return "raster"===t||"image"===t||"video"===t}function At(){return new t.window.Worker(Wr.workerUrl)}Dt.maxOverzooming=10,Dt.maxUnderzooming=3;var Rt="mapboxgl_preloaded_worker_pool",kt=function(){this.active={};};kt.prototype.acquire=function(t){if(!this.workers)for(this.workers=[];this.workers.length<kt.workerCount;)this.workers.push(new At);return this.active[t]=!0,this.workers.slice()},kt.prototype.release=function(t){delete this.active[t],0===this.numActive()&&(this.workers.forEach((function(t){t.terminate();})),this.workers=null);},kt.prototype.isPreloaded=function(){return !!this.active[Rt]},kt.prototype.numActive=function(){return Object.keys(this.active).length};var Bt,Ot=Math.floor(t.browser.hardwareConcurrency/2);function Ft(){return Bt||(Bt=new kt),Bt}function Ut(e,i){var o={};for(var r in e)"ref"!==r&&(o[r]=e[r]);return t.refProperties.forEach((function(t){t in i&&(o[t]=i[t]);})),o}function Nt(t){t=t.slice();for(var e=Object.create(null),i=0;i<t.length;i++)e[t[i].id]=t[i];for(var o=0;o<t.length;o++)"ref"in t[o]&&(t[o]=Ut(t[o],e[t[o].ref]));return t}kt.workerCount=Math.max(Math.min(Ot,6),1);var Zt={setStyle:"setStyle",addLayer:"addLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setGeoJSONSourceData:"setGeoJSONSourceData",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight"};function jt(t,e,i){i.push({command:Zt.addSource,args:[t,e[t]]});}function qt(t,e,i){e.push({command:Zt.removeSource,args:[t]}),i[t]=!0;}function Vt(t,e,i,o){qt(t,i,o),jt(t,e,i);}function Gt(e,i,o){var r;for(r in e[o])if(e[o].hasOwnProperty(r)&&"data"!==r&&!t.deepEqual(e[o][r],i[o][r]))return !1;for(r in i[o])if(i[o].hasOwnProperty(r)&&"data"!==r&&!t.deepEqual(e[o][r],i[o][r]))return !1;return !0}function Wt(e,i,o,r,a,n){var s;for(s in i=i||{},e=e||{})e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||o.push({command:n,args:[r,s,i[s],a]}));for(s in i)i.hasOwnProperty(s)&&!e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||o.push({command:n,args:[r,s,i[s],a]}));}function Xt(t){return t.id}function Ht(t,e){return t[e.id]=e,t}var Kt=function(t,e){this.reset(t,e);};Kt.prototype.reset=function(t,e){this.points=t||[],this._distances=[0];for(var i=1;i<this.points.length;i++)this._distances[i]=this._distances[i-1]+this.points[i].dist(this.points[i-1]);this.length=this._distances[this._distances.length-1],this.padding=Math.min(e||0,.5*this.length),this.paddedLength=this.length-2*this.padding;},Kt.prototype.lerp=function(e){if(1===this.points.length)return this.points[0];e=t.clamp(e,0,1);for(var i=1,o=this._distances[i],r=e*this.paddedLength+this.padding;o<r&&i<this._distances.length;)o=this._distances[++i];var a=i-1,n=this._distances[a],s=o-n,l=s>0?(r-n)/s:0;return this.points[a].mult(1-l).add(this.points[i].mult(l))};var Yt=function(t,e,i){var o=this.boxCells=[],r=this.circleCells=[];this.xCellCount=Math.ceil(t/i),this.yCellCount=Math.ceil(e/i);for(var a=0;a<this.xCellCount*this.yCellCount;a++)o.push([]),r.push([]);this.circleKeys=[],this.boxKeys=[],this.bboxes=[],this.circles=[],this.width=t,this.height=e,this.xScale=this.xCellCount/t,this.yScale=this.yCellCount/e,this.boxUid=0,this.circleUid=0;};function Jt(e,i,o,r,a){var n=t.create();return i?(t.scale(n,n,[1/a,1/a,1]),o||t.rotateZ(n,n,r.angle)):t.multiply(n,r.labelPlaneMatrix,e),n}function Qt(e,i,o,r,a){if(i){var n=t.clone(e);return t.scale(n,n,[a,a,1]),o||t.rotateZ(n,n,-r.angle),n}return r.glCoordMatrix}function $t(e,i){var o=[e.x,e.y,0,1];ue(o,o,i);var r=o[3];return {point:new t.Point(o[0]/r,o[1]/r),signedDistanceFromCamera:r}}function te(t,e){return .5+t/e*.5}function ee(t,e){var i=t[0]/t[3],o=t[1]/t[3];return i>=-e[0]&&i<=e[0]&&o>=-e[1]&&o<=e[1]}function ie(e,i,o,r,a,n,s,l){var c=r?e.textSizeData:e.iconSizeData,u=t.evaluateSizeForZoom(c,o.transform.zoom),h=[256/o.width*2+1,256/o.height*2+1],p=r?e.text.dynamicLayoutVertexArray:e.icon.dynamicLayoutVertexArray;p.clear();for(var d=e.lineVertexArray,_=r?e.text.placedSymbolArray:e.icon.placedSymbolArray,f=o.transform.width/o.transform.height,m=!1,g=0;g<_.length;g++){var v=_.get(g);if(v.hidden||v.writingMode===t.WritingMode.vertical&&!m)ce(v.numGlyphs,p);else {m=!1;var y=[v.anchorX,v.anchorY,0,1];if(t.transformMat4(y,y,i),ee(y,h)){var x=te(o.transform.cameraToCenterDistance,y[3]),b=t.evaluateSizeForFeature(c,u,v),w=s?b/x:b*x,T=new t.Point(v.anchorX,v.anchorY),E=$t(T,a).point,I={},P=ae(v,w,!1,l,i,a,n,e.glyphOffsetArray,d,p,E,T,I,f);m=P.useVertical,(P.notEnoughRoom||m||P.needsFlipping&&ae(v,w,!0,l,i,a,n,e.glyphOffsetArray,d,p,E,T,I,f).notEnoughRoom)&&ce(v.numGlyphs,p);}else ce(v.numGlyphs,p);}}r?e.text.dynamicLayoutVertexBuffer.updateData(p):e.icon.dynamicLayoutVertexBuffer.updateData(p);}function oe(t,e,i,o,r,a,n,s,l,c,u){var h=s.glyphStartIndex+s.numGlyphs,p=s.lineStartIndex,d=s.lineStartIndex+s.lineLength,_=e.getoffsetX(s.glyphStartIndex),f=e.getoffsetX(h-1),m=se(t*_,i,o,r,a,n,s.segment,p,d,l,c,u);if(!m)return null;var g=se(t*f,i,o,r,a,n,s.segment,p,d,l,c,u);return g?{first:m,last:g}:null}function re(e,i,o,r){return e===t.WritingMode.horizontal&&Math.abs(o.y-i.y)>Math.abs(o.x-i.x)*r?{useVertical:!0}:(e===t.WritingMode.vertical?i.y<o.y:i.x>o.x)?{needsFlipping:!0}:null}function ae(e,i,o,r,a,n,s,l,c,u,h,p,d,_){var f,m=i/24,g=e.lineOffsetX*m,v=e.lineOffsetY*m;if(e.numGlyphs>1){var y=e.glyphStartIndex+e.numGlyphs,x=e.lineStartIndex,b=e.lineStartIndex+e.lineLength,w=oe(m,l,g,v,o,h,p,e,c,n,d);if(!w)return {notEnoughRoom:!0};var T=$t(w.first.point,s).point,E=$t(w.last.point,s).point;if(r&&!o){var I=re(e.writingMode,T,E,_);if(I)return I}f=[w.first];for(var P=e.glyphStartIndex+1;P<y-1;P++)f.push(se(m*l.getoffsetX(P),g,v,o,h,p,e.segment,x,b,c,n,d));f.push(w.last);}else {if(r&&!o){var S=$t(p,a).point,C=e.lineStartIndex+e.segment+1,z=new t.Point(c.getx(C),c.gety(C)),D=$t(z,a),M=D.signedDistanceFromCamera>0?D.point:ne(p,z,S,1,a),L=re(e.writingMode,S,M,_);if(L)return L}var A=se(m*l.getoffsetX(e.glyphStartIndex),g,v,o,h,p,e.segment,e.lineStartIndex,e.lineStartIndex+e.lineLength,c,n,d);if(!A)return {notEnoughRoom:!0};f=[A];}for(var R=0,k=f;R<k.length;R+=1){var B=k[R];t.addDynamicAttributes(u,B.point,B.angle);}return {}}function ne(t,e,i,o,r){var a=$t(t.add(t.sub(e)._unit()),r).point,n=i.sub(a);return i.add(n._mult(o/n.mag()))}function se(e,i,o,r,a,n,s,l,c,u,h,p){var d=r?e-i:e+i,_=d>0?1:-1,f=0;r&&(_*=-1,f=Math.PI),_<0&&(f+=Math.PI);for(var m=_>0?l+s:l+s+1,g=a,v=a,y=0,x=0,b=Math.abs(d),w=[];y+x<=b;){if((m+=_)<l||m>=c)return null;if(v=g,w.push(g),void 0===(g=p[m])){var T=new t.Point(u.getx(m),u.gety(m)),E=$t(T,h);if(E.signedDistanceFromCamera>0)g=p[m]=E.point;else {var I=m-_;g=ne(0===y?n:new t.Point(u.getx(I),u.gety(I)),T,v,b-y+1,h);}}y+=x,x=v.dist(g);}var P=(b-y)/x,S=g.sub(v),C=S.mult(P)._add(v);C._add(S._unit()._perp()._mult(o*_));var z=f+Math.atan2(g.y-v.y,g.x-v.x);return w.push(C),{point:C,angle:z,path:w}}Yt.prototype.keysLength=function(){return this.boxKeys.length+this.circleKeys.length},Yt.prototype.insert=function(t,e,i,o,r){this._forEachCell(e,i,o,r,this._insertBoxCell,this.boxUid++),this.boxKeys.push(t),this.bboxes.push(e),this.bboxes.push(i),this.bboxes.push(o),this.bboxes.push(r);},Yt.prototype.insertCircle=function(t,e,i,o){this._forEachCell(e-o,i-o,e+o,i+o,this._insertCircleCell,this.circleUid++),this.circleKeys.push(t),this.circles.push(e),this.circles.push(i),this.circles.push(o);},Yt.prototype._insertBoxCell=function(t,e,i,o,r,a){this.boxCells[r].push(a);},Yt.prototype._insertCircleCell=function(t,e,i,o,r,a){this.circleCells[r].push(a);},Yt.prototype._query=function(t,e,i,o,r,a){if(i<0||t>this.width||o<0||e>this.height)return !r&&[];var n=[];if(t<=0&&e<=0&&this.width<=i&&this.height<=o){if(r)return !0;for(var s=0;s<this.boxKeys.length;s++)n.push({key:this.boxKeys[s],x1:this.bboxes[4*s],y1:this.bboxes[4*s+1],x2:this.bboxes[4*s+2],y2:this.bboxes[4*s+3]});for(var l=0;l<this.circleKeys.length;l++){var c=this.circles[3*l],u=this.circles[3*l+1],h=this.circles[3*l+2];n.push({key:this.circleKeys[l],x1:c-h,y1:u-h,x2:c+h,y2:u+h});}return a?n.filter(a):n}return this._forEachCell(t,e,i,o,this._queryCell,n,{hitTest:r,seenUids:{box:{},circle:{}}},a),r?n.length>0:n},Yt.prototype._queryCircle=function(t,e,i,o,r){var a=t-i,n=t+i,s=e-i,l=e+i;if(n<0||a>this.width||l<0||s>this.height)return !o&&[];var c=[];return this._forEachCell(a,s,n,l,this._queryCellCircle,c,{hitTest:o,circle:{x:t,y:e,radius:i},seenUids:{box:{},circle:{}}},r),o?c.length>0:c},Yt.prototype.query=function(t,e,i,o,r){return this._query(t,e,i,o,!1,r)},Yt.prototype.hitTest=function(t,e,i,o,r){return this._query(t,e,i,o,!0,r)},Yt.prototype.hitTestCircle=function(t,e,i,o){return this._queryCircle(t,e,i,!0,o)},Yt.prototype._queryCell=function(t,e,i,o,r,a,n,s){var l=n.seenUids,c=this.boxCells[r];if(null!==c)for(var u=this.bboxes,h=0,p=c;h<p.length;h+=1){var d=p[h];if(!l.box[d]){l.box[d]=!0;var _=4*d;if(t<=u[_+2]&&e<=u[_+3]&&i>=u[_+0]&&o>=u[_+1]&&(!s||s(this.boxKeys[d]))){if(n.hitTest)return a.push(!0),!0;a.push({key:this.boxKeys[d],x1:u[_],y1:u[_+1],x2:u[_+2],y2:u[_+3]});}}}var f=this.circleCells[r];if(null!==f)for(var m=this.circles,g=0,v=f;g<v.length;g+=1){var y=v[g];if(!l.circle[y]){l.circle[y]=!0;var x=3*y;if(this._circleAndRectCollide(m[x],m[x+1],m[x+2],t,e,i,o)&&(!s||s(this.circleKeys[y]))){if(n.hitTest)return a.push(!0),!0;var b=m[x],w=m[x+1],T=m[x+2];a.push({key:this.circleKeys[y],x1:b-T,y1:w-T,x2:b+T,y2:w+T});}}}},Yt.prototype._queryCellCircle=function(t,e,i,o,r,a,n,s){var l=n.circle,c=n.seenUids,u=this.boxCells[r];if(null!==u)for(var h=this.bboxes,p=0,d=u;p<d.length;p+=1){var _=d[p];if(!c.box[_]){c.box[_]=!0;var f=4*_;if(this._circleAndRectCollide(l.x,l.y,l.radius,h[f+0],h[f+1],h[f+2],h[f+3])&&(!s||s(this.boxKeys[_])))return a.push(!0),!0}}var m=this.circleCells[r];if(null!==m)for(var g=this.circles,v=0,y=m;v<y.length;v+=1){var x=y[v];if(!c.circle[x]){c.circle[x]=!0;var b=3*x;if(this._circlesCollide(g[b],g[b+1],g[b+2],l.x,l.y,l.radius)&&(!s||s(this.circleKeys[x])))return a.push(!0),!0}}},Yt.prototype._forEachCell=function(t,e,i,o,r,a,n,s){for(var l=this._convertToXCellCoord(t),c=this._convertToYCellCoord(e),u=this._convertToXCellCoord(i),h=this._convertToYCellCoord(o),p=l;p<=u;p++)for(var d=c;d<=h;d++)if(r.call(this,t,e,i,o,this.xCellCount*d+p,a,n,s))return},Yt.prototype._convertToXCellCoord=function(t){return Math.max(0,Math.min(this.xCellCount-1,Math.floor(t*this.xScale)))},Yt.prototype._convertToYCellCoord=function(t){return Math.max(0,Math.min(this.yCellCount-1,Math.floor(t*this.yScale)))},Yt.prototype._circlesCollide=function(t,e,i,o,r,a){var n=o-t,s=r-e,l=i+a;return l*l>n*n+s*s},Yt.prototype._circleAndRectCollide=function(t,e,i,o,r,a,n){var s=(a-o)/2,l=Math.abs(t-(o+s));if(l>s+i)return !1;var c=(n-r)/2,u=Math.abs(e-(r+c));if(u>c+i)return !1;if(l<=s||u<=c)return !0;var h=l-s,p=u-c;return h*h+p*p<=i*i};var le=new Float32Array([-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0]);function ce(t,e){for(var i=0;i<t;i++){var o=e.length;e.resize(o+4),e.float32.set(le,3*o);}}function ue(t,e,i){var o=e[0],r=e[1];return t[0]=i[0]*o+i[4]*r+i[12],t[1]=i[1]*o+i[5]*r+i[13],t[3]=i[3]*o+i[7]*r+i[15],t}var he=function(t,e,i){void 0===e&&(e=new Yt(t.width+200,t.height+200,25)),void 0===i&&(i=new Yt(t.width+200,t.height+200,25)),this.transform=t,this.grid=e,this.ignoredGrid=i,this.pitchfactor=Math.cos(t._pitch)*t.cameraToCenterDistance,this.screenRightBoundary=t.width+100,this.screenBottomBoundary=t.height+100,this.gridRightBoundary=t.width+200,this.gridBottomBoundary=t.height+200;};function pe(e,i,o){return i*(t.EXTENT/(e.tileSize*Math.pow(2,o-e.tileID.overscaledZ)))}he.prototype.placeCollisionBox=function(t,e,i,o,r){var a=this.projectAndGetPerspectiveRatio(o,t.anchorPointX,t.anchorPointY),n=i*a.perspectiveRatio,s=t.x1*n+a.point.x,l=t.y1*n+a.point.y,c=t.x2*n+a.point.x,u=t.y2*n+a.point.y;return !this.isInsideGrid(s,l,c,u)||!e&&this.grid.hitTest(s,l,c,u,r)?{box:[],offscreen:!1}:{box:[s,l,c,u],offscreen:this.isOffscreen(s,l,c,u)}},he.prototype.placeCollisionCircles=function(e,i,o,r,a,n,s,l,c,u,h,p,d){var _=[],f=new t.Point(i.anchorX,i.anchorY),m=$t(f,n),g=te(this.transform.cameraToCenterDistance,m.signedDistanceFromCamera),v=(u?a/g:a*g)/t.ONE_EM,y=$t(f,s).point,x=oe(v,r,i.lineOffsetX*v,i.lineOffsetY*v,!1,y,f,i,o,s,{}),b=!1,w=!1,T=!0;if(x){for(var E=.5*p*g+d,I=new t.Point(-100,-100),P=new t.Point(this.screenRightBoundary,this.screenBottomBoundary),S=new Kt,C=x.first,z=x.last,D=[],M=C.path.length-1;M>=1;M--)D.push(C.path[M]);for(var L=1;L<z.path.length;L++)D.push(z.path[L]);var A=2.5*E;if(l){var R=D.map((function(t){return $t(t,l)}));D=R.some((function(t){return t.signedDistanceFromCamera<=0}))?[]:R.map((function(t){return t.point}));}var k=[];if(D.length>0){for(var B=D[0].clone(),O=D[0].clone(),F=1;F<D.length;F++)B.x=Math.min(B.x,D[F].x),B.y=Math.min(B.y,D[F].y),O.x=Math.max(O.x,D[F].x),O.y=Math.max(O.y,D[F].y);k=B.x>=I.x&&O.x<=P.x&&B.y>=I.y&&O.y<=P.y?[D]:O.x<I.x||B.x>P.x||O.y<I.y||B.y>P.y?[]:t.clipLine([D],I.x,I.y,P.x,P.y);}for(var U=0,N=k;U<N.length;U+=1){var Z;S.reset(N[U],.25*E),Z=S.length<=.5*E?1:Math.ceil(S.paddedLength/A)+1;for(var j=0;j<Z;j++){var q=j/Math.max(Z-1,1),V=S.lerp(q),G=V.x+100,W=V.y+100;_.push(G,W,E,0);var X=G-E,H=W-E,K=G+E,Y=W+E;if(T=T&&this.isOffscreen(X,H,K,Y),w=w||this.isInsideGrid(X,H,K,Y),!e&&this.grid.hitTestCircle(G,W,E,h)&&(b=!0,!c))return {circles:[],offscreen:!1,collisionDetected:b}}}}return {circles:!c&&b||!w?[]:_,offscreen:T,collisionDetected:b}},he.prototype.queryRenderedSymbols=function(e){if(0===e.length||0===this.grid.keysLength()&&0===this.ignoredGrid.keysLength())return {};for(var i=[],o=1/0,r=1/0,a=-1/0,n=-1/0,s=0,l=e;s<l.length;s+=1){var c=l[s],u=new t.Point(c.x+100,c.y+100);o=Math.min(o,u.x),r=Math.min(r,u.y),a=Math.max(a,u.x),n=Math.max(n,u.y),i.push(u);}for(var h={},p={},d=0,_=this.grid.query(o,r,a,n).concat(this.ignoredGrid.query(o,r,a,n));d<_.length;d+=1){var f=_[d],m=f.key;if(void 0===h[m.bucketInstanceId]&&(h[m.bucketInstanceId]={}),!h[m.bucketInstanceId][m.featureIndex]){var g=[new t.Point(f.x1,f.y1),new t.Point(f.x2,f.y1),new t.Point(f.x2,f.y2),new t.Point(f.x1,f.y2)];t.polygonIntersectsPolygon(i,g)&&(h[m.bucketInstanceId][m.featureIndex]=!0,void 0===p[m.bucketInstanceId]&&(p[m.bucketInstanceId]=[]),p[m.bucketInstanceId].push(m.featureIndex));}}return p},he.prototype.insertCollisionBox=function(t,e,i,o,r){(e?this.ignoredGrid:this.grid).insert({bucketInstanceId:i,featureIndex:o,collisionGroupID:r},t[0],t[1],t[2],t[3]);},he.prototype.insertCollisionCircles=function(t,e,i,o,r){for(var a=e?this.ignoredGrid:this.grid,n={bucketInstanceId:i,featureIndex:o,collisionGroupID:r},s=0;s<t.length;s+=4)a.insertCircle(n,t[s],t[s+1],t[s+2]);},he.prototype.projectAndGetPerspectiveRatio=function(e,i,o){var r=[i,o,0,1];return ue(r,r,e),{point:new t.Point((r[0]/r[3]+1)/2*this.transform.width+100,(-r[1]/r[3]+1)/2*this.transform.height+100),perspectiveRatio:.5+this.transform.cameraToCenterDistance/r[3]*.5}},he.prototype.isOffscreen=function(t,e,i,o){return i<100||t>=this.screenRightBoundary||o<100||e>this.screenBottomBoundary},he.prototype.isInsideGrid=function(t,e,i,o){return i>=0&&t<this.gridRightBoundary&&o>=0&&e<this.gridBottomBoundary},he.prototype.getViewportMatrix=function(){var e=t.identity([]);return t.translate(e,e,[-100,-100,0]),e};var de=function(t,e,i,o){this.opacity=t?Math.max(0,Math.min(1,t.opacity+(t.placed?e:-e))):o&&i?1:0,this.placed=i;};de.prototype.isHidden=function(){return 0===this.opacity&&!this.placed};var _e=function(t,e,i,o,r){this.text=new de(t?t.text:null,e,i,r),this.icon=new de(t?t.icon:null,e,o,r);};_e.prototype.isHidden=function(){return this.text.isHidden()&&this.icon.isHidden()};var fe=function(t,e,i){this.text=t,this.icon=e,this.skipFade=i;},me=function(){this.invProjMatrix=t.create(),this.viewportMatrix=t.create(),this.circles=[];},ge=function(t,e,i,o,r){this.bucketInstanceId=t,this.featureIndex=e,this.sourceLayerIndex=i,this.bucketIndex=o,this.tileID=r;},ve=function(t){this.crossSourceCollisions=t,this.maxGroupID=0,this.collisionGroups={};};function ye(e,i,o,r,a){var n=t.getAnchorAlignment(e),s=-(n.horizontalAlign-.5)*i,l=-(n.verticalAlign-.5)*o,c=t.evaluateVariableOffset(e,r);return new t.Point(s+c[0]*a,l+c[1]*a)}function xe(e,i,o,r,a,n){var s=e.x1,l=e.x2,c=e.y1,u=e.y2,h=e.anchorPointX,p=e.anchorPointY,d=new t.Point(i,o);return r&&d._rotate(a?n:-n),{x1:s+d.x,y1:c+d.y,x2:l+d.x,y2:u+d.y,anchorPointX:h,anchorPointY:p}}ve.prototype.get=function(t){if(this.crossSourceCollisions)return {ID:0,predicate:null};if(!this.collisionGroups[t]){var e=++this.maxGroupID;this.collisionGroups[t]={ID:e,predicate:function(t){return t.collisionGroupID===e}};}return this.collisionGroups[t]};var be=function(t,e,i,o){this.transform=t.clone(),this.collisionIndex=new he(this.transform),this.placements={},this.opacities={},this.variableOffsets={},this.stale=!1,this.commitTime=0,this.fadeDuration=e,this.retainedQueryData={},this.collisionGroups=new ve(i),this.collisionCircleArrays={},this.prevPlacement=o,o&&(o.prevPlacement=void 0),this.placedOrientations={};};function we(t,e,i,o,r){t.emplaceBack(e?1:0,i?1:0,o||0,r||0),t.emplaceBack(e?1:0,i?1:0,o||0,r||0),t.emplaceBack(e?1:0,i?1:0,o||0,r||0),t.emplaceBack(e?1:0,i?1:0,o||0,r||0);}be.prototype.getBucketParts=function(e,i,o,r){var a=o.getBucket(i),n=o.latestFeatureIndex;if(a&&n&&i.id===a.layerIds[0]){var s=o.collisionBoxArray,l=a.layers[0].layout,c=Math.pow(2,this.transform.zoom-o.tileID.overscaledZ),u=o.tileSize/t.EXTENT,h=this.transform.calculatePosMatrix(o.tileID.toUnwrapped()),p="map"===l.get("text-pitch-alignment"),d="map"===l.get("text-rotation-alignment"),_=pe(o,1,this.transform.zoom),f=Jt(h,p,d,this.transform,_),m=null;if(p){var g=Qt(h,p,d,this.transform,_);m=t.multiply([],this.transform.labelPlaneMatrix,g);}this.retainedQueryData[a.bucketInstanceId]=new ge(a.bucketInstanceId,n,a.sourceLayerIndex,a.index,o.tileID);var v={bucket:a,layout:l,posMatrix:h,textLabelPlaneMatrix:f,labelToScreenMatrix:m,scale:c,textPixelRatio:u,holdingForFade:o.holdingForFade(),collisionBoxArray:s,partiallyEvaluatedTextSize:t.evaluateSizeForZoom(a.textSizeData,this.transform.zoom),collisionGroup:this.collisionGroups.get(a.sourceID)};if(r)for(var y=0,x=a.sortKeyRanges;y<x.length;y+=1){var b=x[y];e.push({sortKey:b.sortKey,symbolInstanceStart:b.symbolInstanceStart,symbolInstanceEnd:b.symbolInstanceEnd,parameters:v});}else e.push({symbolInstanceStart:0,symbolInstanceEnd:a.symbolInstances.length,parameters:v});}},be.prototype.attemptAnchorPlacement=function(t,e,i,o,r,a,n,s,l,c,u,h,p,d,_){var f,m=[h.textOffset0,h.textOffset1],g=ye(t,i,o,m,r),v=this.collisionIndex.placeCollisionBox(xe(e,g.x,g.y,a,n,this.transform.angle),u,s,l,c.predicate);if(!_||0!==this.collisionIndex.placeCollisionBox(xe(_,g.x,g.y,a,n,this.transform.angle),u,s,l,c.predicate).box.length)return v.box.length>0?(this.prevPlacement&&this.prevPlacement.variableOffsets[h.crossTileID]&&this.prevPlacement.placements[h.crossTileID]&&this.prevPlacement.placements[h.crossTileID].text&&(f=this.prevPlacement.variableOffsets[h.crossTileID].anchor),this.variableOffsets[h.crossTileID]={textOffset:m,width:i,height:o,anchor:t,textBoxScale:r,prevAnchor:f},this.markUsedJustification(p,t,h,d),p.allowVerticalPlacement&&(this.markUsedOrientation(p,d,h),this.placedOrientations[h.crossTileID]=d),{shift:g,placedGlyphBoxes:v}):void 0},be.prototype.placeLayerBucketPart=function(e,i,o){var r=this,a=e.parameters,n=a.bucket,s=a.layout,l=a.posMatrix,c=a.textLabelPlaneMatrix,u=a.labelToScreenMatrix,h=a.textPixelRatio,p=a.holdingForFade,d=a.collisionBoxArray,_=a.partiallyEvaluatedTextSize,f=a.collisionGroup,m=s.get("text-optional"),g=s.get("icon-optional"),v=s.get("text-allow-overlap"),y=s.get("icon-allow-overlap"),x="map"===s.get("text-rotation-alignment"),b="map"===s.get("text-pitch-alignment"),w="none"!==s.get("icon-text-fit"),T="viewport-y"===s.get("symbol-z-order"),E=v&&(y||!n.hasIconData()||g),I=y&&(v||!n.hasTextData()||m);!n.collisionArrays&&d&&n.deserializeCollisionBoxes(d);var P=function(e,a){if(!i[e.crossTileID])if(p)r.placements[e.crossTileID]=new fe(!1,!1,!1);else {var d,T=!1,P=!1,S=!0,C=null,z={box:null,offscreen:null},D={box:null,offscreen:null},M=null,L=null,A=0,R=0,k=0;a.textFeatureIndex?A=a.textFeatureIndex:e.useRuntimeCollisionCircles&&(A=e.featureIndex),a.verticalTextFeatureIndex&&(R=a.verticalTextFeatureIndex);var B=a.textBox;if(B){var O=function(i){var o=t.WritingMode.horizontal;if(n.allowVerticalPlacement&&!i&&r.prevPlacement){var a=r.prevPlacement.placedOrientations[e.crossTileID];a&&(r.placedOrientations[e.crossTileID]=a,r.markUsedOrientation(n,o=a,e));}return o},F=function(i,o){if(n.allowVerticalPlacement&&e.numVerticalGlyphVertices>0&&a.verticalTextBox)for(var r=0,s=n.writingModes;r<s.length&&(s[r]===t.WritingMode.vertical?(z=o(),D=z):z=i(),!(z&&z.box&&z.box.length));r+=1);else z=i();};if(s.get("text-variable-anchor")){var U=s.get("text-variable-anchor");if(r.prevPlacement&&r.prevPlacement.variableOffsets[e.crossTileID]){var N=r.prevPlacement.variableOffsets[e.crossTileID];U.indexOf(N.anchor)>0&&(U=U.filter((function(t){return t!==N.anchor}))).unshift(N.anchor);}var Z=function(t,i,o){for(var a=t.x2-t.x1,s=t.y2-t.y1,c=e.textBoxScale,u=w&&!y?i:null,p={box:[],offscreen:!1},d=v?2*U.length:U.length,_=0;_<d;++_){var m=r.attemptAnchorPlacement(U[_%U.length],t,a,s,c,x,b,h,l,f,_>=U.length,e,n,o,u);if(m&&(p=m.placedGlyphBoxes)&&p.box&&p.box.length){T=!0,C=m.shift;break}}return p};F((function(){return Z(B,a.iconBox,t.WritingMode.horizontal)}),(function(){var i=a.verticalTextBox;return n.allowVerticalPlacement&&!(z&&z.box&&z.box.length)&&e.numVerticalGlyphVertices>0&&i?Z(i,a.verticalIconBox,t.WritingMode.vertical):{box:null,offscreen:null}})),z&&(T=z.box,S=z.offscreen);var j=O(z&&z.box);if(!T&&r.prevPlacement){var q=r.prevPlacement.variableOffsets[e.crossTileID];q&&(r.variableOffsets[e.crossTileID]=q,r.markUsedJustification(n,q.anchor,e,j));}}else {var V=function(t,i){var o=r.collisionIndex.placeCollisionBox(t,v,h,l,f.predicate);return o&&o.box&&o.box.length&&(r.markUsedOrientation(n,i,e),r.placedOrientations[e.crossTileID]=i),o};F((function(){return V(B,t.WritingMode.horizontal)}),(function(){var i=a.verticalTextBox;return n.allowVerticalPlacement&&e.numVerticalGlyphVertices>0&&i?V(i,t.WritingMode.vertical):{box:null,offscreen:null}})),O(z&&z.box&&z.box.length);}}if(T=(d=z)&&d.box&&d.box.length>0,S=d&&d.offscreen,e.useRuntimeCollisionCircles){var G=n.text.placedSymbolArray.get(e.centerJustifiedTextSymbolIndex),W=t.evaluateSizeForFeature(n.textSizeData,_,G),X=s.get("text-padding");M=r.collisionIndex.placeCollisionCircles(v,G,n.lineVertexArray,n.glyphOffsetArray,W,l,c,u,o,b,f.predicate,e.collisionCircleDiameter,X),T=v||M.circles.length>0&&!M.collisionDetected,S=S&&M.offscreen;}if(a.iconFeatureIndex&&(k=a.iconFeatureIndex),a.iconBox){var H=function(t){var e=w&&C?xe(t,C.x,C.y,x,b,r.transform.angle):t;return r.collisionIndex.placeCollisionBox(e,y,h,l,f.predicate)};P=D&&D.box&&D.box.length&&a.verticalIconBox?(L=H(a.verticalIconBox)).box.length>0:(L=H(a.iconBox)).box.length>0,S=S&&L.offscreen;}var K=m||0===e.numHorizontalGlyphVertices&&0===e.numVerticalGlyphVertices,Y=g||0===e.numIconVertices;if(K||Y?Y?K||(P=P&&T):T=P&&T:P=T=P&&T,T&&d&&d.box&&r.collisionIndex.insertCollisionBox(d.box,s.get("text-ignore-placement"),n.bucketInstanceId,D&&D.box&&R?R:A,f.ID),P&&L&&r.collisionIndex.insertCollisionBox(L.box,s.get("icon-ignore-placement"),n.bucketInstanceId,k,f.ID),M&&(T&&r.collisionIndex.insertCollisionCircles(M.circles,s.get("text-ignore-placement"),n.bucketInstanceId,A,f.ID),o)){var J=n.bucketInstanceId,Q=r.collisionCircleArrays[J];void 0===Q&&(Q=r.collisionCircleArrays[J]=new me);for(var $=0;$<M.circles.length;$+=4)Q.circles.push(M.circles[$+0]),Q.circles.push(M.circles[$+1]),Q.circles.push(M.circles[$+2]),Q.circles.push(M.collisionDetected?1:0);}r.placements[e.crossTileID]=new fe(T||E,P||I,S||n.justReloaded),i[e.crossTileID]=!0;}};if(T)for(var S=n.getSortedSymbolIndexes(this.transform.angle),C=S.length-1;C>=0;--C){var z=S[C];P(n.symbolInstances.get(z),n.collisionArrays[z]);}else for(var D=e.symbolInstanceStart;D<e.symbolInstanceEnd;D++)P(n.symbolInstances.get(D),n.collisionArrays[D]);if(o&&n.bucketInstanceId in this.collisionCircleArrays){var M=this.collisionCircleArrays[n.bucketInstanceId];t.invert(M.invProjMatrix,l),M.viewportMatrix=this.collisionIndex.getViewportMatrix();}n.justReloaded=!1;},be.prototype.markUsedJustification=function(e,i,o,r){var a;a=r===t.WritingMode.vertical?o.verticalPlacedTextSymbolIndex:{left:o.leftJustifiedTextSymbolIndex,center:o.centerJustifiedTextSymbolIndex,right:o.rightJustifiedTextSymbolIndex}[t.getAnchorJustification(i)];for(var n=0,s=[o.leftJustifiedTextSymbolIndex,o.centerJustifiedTextSymbolIndex,o.rightJustifiedTextSymbolIndex,o.verticalPlacedTextSymbolIndex];n<s.length;n+=1){var l=s[n];l>=0&&(e.text.placedSymbolArray.get(l).crossTileID=a>=0&&l!==a?0:o.crossTileID);}},be.prototype.markUsedOrientation=function(e,i,o){for(var r=i===t.WritingMode.horizontal||i===t.WritingMode.horizontalOnly?i:0,a=i===t.WritingMode.vertical?i:0,n=0,s=[o.leftJustifiedTextSymbolIndex,o.centerJustifiedTextSymbolIndex,o.rightJustifiedTextSymbolIndex];n<s.length;n+=1)e.text.placedSymbolArray.get(s[n]).placedOrientation=r;o.verticalPlacedTextSymbolIndex&&(e.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).placedOrientation=a);},be.prototype.commit=function(t){this.commitTime=t,this.zoomAtLastRecencyCheck=this.transform.zoom;var e=this.prevPlacement,i=!1;this.prevZoomAdjustment=e?e.zoomAdjustment(this.transform.zoom):0;var o=e?e.symbolFadeChange(t):1,r=e?e.opacities:{},a=e?e.variableOffsets:{},n=e?e.placedOrientations:{};for(var s in this.placements){var l=this.placements[s],c=r[s];c?(this.opacities[s]=new _e(c,o,l.text,l.icon),i=i||l.text!==c.text.placed||l.icon!==c.icon.placed):(this.opacities[s]=new _e(null,o,l.text,l.icon,l.skipFade),i=i||l.text||l.icon);}for(var u in r){var h=r[u];if(!this.opacities[u]){var p=new _e(h,o,!1,!1);p.isHidden()||(this.opacities[u]=p,i=i||h.text.placed||h.icon.placed);}}for(var d in a)this.variableOffsets[d]||!this.opacities[d]||this.opacities[d].isHidden()||(this.variableOffsets[d]=a[d]);for(var _ in n)this.placedOrientations[_]||!this.opacities[_]||this.opacities[_].isHidden()||(this.placedOrientations[_]=n[_]);i?this.lastPlacementChangeTime=t:"number"!=typeof this.lastPlacementChangeTime&&(this.lastPlacementChangeTime=e?e.lastPlacementChangeTime:t);},be.prototype.updateLayerOpacities=function(t,e){for(var i={},o=0,r=e;o<r.length;o+=1){var a=r[o],n=a.getBucket(t);n&&a.latestFeatureIndex&&t.id===n.layerIds[0]&&this.updateBucketOpacities(n,i,a.collisionBoxArray);}},be.prototype.updateBucketOpacities=function(e,i,o){var r=this;e.hasTextData()&&e.text.opacityVertexArray.clear(),e.hasIconData()&&e.icon.opacityVertexArray.clear(),e.hasIconCollisionBoxData()&&e.iconCollisionBox.collisionVertexArray.clear(),e.hasTextCollisionBoxData()&&e.textCollisionBox.collisionVertexArray.clear();var a=e.layers[0].layout,n=new _e(null,0,!1,!1,!0),s=a.get("text-allow-overlap"),l=a.get("icon-allow-overlap"),c=a.get("text-variable-anchor"),u="map"===a.get("text-rotation-alignment"),h="map"===a.get("text-pitch-alignment"),p="none"!==a.get("icon-text-fit"),d=new _e(null,0,s&&(l||!e.hasIconData()||a.get("icon-optional")),l&&(s||!e.hasTextData()||a.get("text-optional")),!0);!e.collisionArrays&&o&&(e.hasIconCollisionBoxData()||e.hasTextCollisionBoxData())&&e.deserializeCollisionBoxes(o);for(var _=function(t,e,i){for(var o=0;o<e/4;o++)t.opacityVertexArray.emplaceBack(i);},f=function(o){var a=e.symbolInstances.get(o),s=a.numHorizontalGlyphVertices,l=a.numVerticalGlyphVertices,f=a.crossTileID,m=r.opacities[f];i[f]?m=n:m||(r.opacities[f]=m=d),i[f]=!0;var g=a.numIconVertices>0,v=r.placedOrientations[a.crossTileID],y=v===t.WritingMode.vertical,x=v===t.WritingMode.horizontal||v===t.WritingMode.horizontalOnly;if(s>0||l>0){var b=De(m.text);_(e.text,s,y?Me:b),_(e.text,l,x?Me:b);var w=m.text.isHidden();[a.rightJustifiedTextSymbolIndex,a.centerJustifiedTextSymbolIndex,a.leftJustifiedTextSymbolIndex].forEach((function(t){t>=0&&(e.text.placedSymbolArray.get(t).hidden=w||y?1:0);})),a.verticalPlacedTextSymbolIndex>=0&&(e.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden=w||x?1:0);var T=r.variableOffsets[a.crossTileID];T&&r.markUsedJustification(e,T.anchor,a,v);var E=r.placedOrientations[a.crossTileID];E&&(r.markUsedJustification(e,"left",a,E),r.markUsedOrientation(e,E,a));}if(g){var I=De(m.icon),P=!(p&&a.verticalPlacedIconSymbolIndex&&y);a.placedIconSymbolIndex>=0&&(_(e.icon,a.numIconVertices,P?I:Me),e.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden=m.icon.isHidden()),a.verticalPlacedIconSymbolIndex>=0&&(_(e.icon,a.numVerticalIconVertices,P?Me:I),e.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden=m.icon.isHidden());}if(e.hasIconCollisionBoxData()||e.hasTextCollisionBoxData()){var S=e.collisionArrays[o];if(S){var C=new t.Point(0,0);if(S.textBox||S.verticalTextBox){var z=!0;if(c){var D=r.variableOffsets[f];D?(C=ye(D.anchor,D.width,D.height,D.textOffset,D.textBoxScale),u&&C._rotate(h?r.transform.angle:-r.transform.angle)):z=!1;}S.textBox&&we(e.textCollisionBox.collisionVertexArray,m.text.placed,!z||y,C.x,C.y),S.verticalTextBox&&we(e.textCollisionBox.collisionVertexArray,m.text.placed,!z||x,C.x,C.y);}var M=Boolean(!x&&S.verticalIconBox);S.iconBox&&we(e.iconCollisionBox.collisionVertexArray,m.icon.placed,M,p?C.x:0,p?C.y:0),S.verticalIconBox&&we(e.iconCollisionBox.collisionVertexArray,m.icon.placed,!M,p?C.x:0,p?C.y:0);}}},m=0;m<e.symbolInstances.length;m++)f(m);if(e.sortFeatures(this.transform.angle),this.retainedQueryData[e.bucketInstanceId]&&(this.retainedQueryData[e.bucketInstanceId].featureSortOrder=e.featureSortOrder),e.hasTextData()&&e.text.opacityVertexBuffer&&e.text.opacityVertexBuffer.updateData(e.text.opacityVertexArray),e.hasIconData()&&e.icon.opacityVertexBuffer&&e.icon.opacityVertexBuffer.updateData(e.icon.opacityVertexArray),e.hasIconCollisionBoxData()&&e.iconCollisionBox.collisionVertexBuffer&&e.iconCollisionBox.collisionVertexBuffer.updateData(e.iconCollisionBox.collisionVertexArray),e.hasTextCollisionBoxData()&&e.textCollisionBox.collisionVertexBuffer&&e.textCollisionBox.collisionVertexBuffer.updateData(e.textCollisionBox.collisionVertexArray),e.bucketInstanceId in this.collisionCircleArrays){var g=this.collisionCircleArrays[e.bucketInstanceId];e.placementInvProjMatrix=g.invProjMatrix,e.placementViewportMatrix=g.viewportMatrix,e.collisionCircleArray=g.circles,delete this.collisionCircleArrays[e.bucketInstanceId];}},be.prototype.symbolFadeChange=function(t){return 0===this.fadeDuration?1:(t-this.commitTime)/this.fadeDuration+this.prevZoomAdjustment},be.prototype.zoomAdjustment=function(t){return Math.max(0,(this.transform.zoom-t)/1.5)},be.prototype.hasTransitions=function(t){return this.stale||t-this.lastPlacementChangeTime<this.fadeDuration},be.prototype.stillRecent=function(t,e){var i=this.zoomAtLastRecencyCheck===e?1-this.zoomAdjustment(e):1;return this.zoomAtLastRecencyCheck=e,this.commitTime+this.fadeDuration*i>t},be.prototype.setStale=function(){this.stale=!0;};var Te=Math.pow(2,25),Ee=Math.pow(2,24),Ie=Math.pow(2,17),Pe=Math.pow(2,16),Se=Math.pow(2,9),Ce=Math.pow(2,8),ze=Math.pow(2,1);function De(t){if(0===t.opacity&&!t.placed)return 0;if(1===t.opacity&&t.placed)return 4294967295;var e=t.placed?1:0,i=Math.floor(127*t.opacity);return i*Te+e*Ee+i*Ie+e*Pe+i*Se+e*Ce+i*ze+e}var Me=0,Le=function(t){this._sortAcrossTiles="viewport-y"!==t.layout.get("symbol-z-order")&&void 0!==t.layout.get("symbol-sort-key").constantOr(1),this._currentTileIndex=0,this._currentPartIndex=0,this._seenCrossTileIDs={},this._bucketParts=[];};Le.prototype.continuePlacement=function(t,e,i,o,r){for(var a=this._bucketParts;this._currentTileIndex<t.length;)if(e.getBucketParts(a,o,t[this._currentTileIndex],this._sortAcrossTiles),this._currentTileIndex++,r())return !0;for(this._sortAcrossTiles&&(this._sortAcrossTiles=!1,a.sort((function(t,e){return t.sortKey-e.sortKey})));this._currentPartIndex<a.length;)if(e.placeLayerBucketPart(a[this._currentPartIndex],this._seenCrossTileIDs,i),this._currentPartIndex++,r())return !0;return !1};var Ae=function(t,e,i,o,r,a,n){this.placement=new be(t,r,a,n),this._currentPlacementIndex=e.length-1,this._forceFullPlacement=i,this._showCollisionBoxes=o,this._done=!1;};Ae.prototype.isDone=function(){return this._done},Ae.prototype.continuePlacement=function(e,i,o){for(var r=this,a=t.browser.now(),n=function(){var e=t.browser.now()-a;return !r._forceFullPlacement&&e>2};this._currentPlacementIndex>=0;){var s=i[e[this._currentPlacementIndex]],l=this.placement.collisionIndex.transform.zoom;if("symbol"===s.type&&(!s.minzoom||s.minzoom<=l)&&(!s.maxzoom||s.maxzoom>l)){if(this._inProgressLayer||(this._inProgressLayer=new Le(s)),this._inProgressLayer.continuePlacement(o[s.source],this.placement,this._showCollisionBoxes,s,n))return;delete this._inProgressLayer;}this._currentPlacementIndex--;}this._done=!0;},Ae.prototype.commit=function(t){return this.placement.commit(t),this.placement};var Re=512/t.EXTENT/2,ke=function(t,e,i){this.tileID=t,this.indexedSymbolInstances={},this.bucketInstanceId=i;for(var o=0;o<e.length;o++){var r=e.get(o),a=r.key;this.indexedSymbolInstances[a]||(this.indexedSymbolInstances[a]=[]),this.indexedSymbolInstances[a].push({crossTileID:r.crossTileID,coord:this.getScaledCoordinates(r,t)});}};ke.prototype.getScaledCoordinates=function(e,i){var o=Re/Math.pow(2,i.canonical.z-this.tileID.canonical.z);return {x:Math.floor((i.canonical.x*t.EXTENT+e.anchorX)*o),y:Math.floor((i.canonical.y*t.EXTENT+e.anchorY)*o)}},ke.prototype.findMatches=function(t,e,i){for(var o=this.tileID.canonical.z<e.canonical.z?1:Math.pow(2,this.tileID.canonical.z-e.canonical.z),r=0;r<t.length;r++){var a=t.get(r);if(!a.crossTileID){var n=this.indexedSymbolInstances[a.key];if(n)for(var s=this.getScaledCoordinates(a,e),l=0,c=n;l<c.length;l+=1){var u=c[l];if(Math.abs(u.coord.x-s.x)<=o&&Math.abs(u.coord.y-s.y)<=o&&!i[u.crossTileID]){i[u.crossTileID]=!0,a.crossTileID=u.crossTileID;break}}}}};var Be=function(){this.maxCrossTileID=0;};Be.prototype.generate=function(){return ++this.maxCrossTileID};var Oe=function(){this.indexes={},this.usedCrossTileIDs={},this.lng=0;};Oe.prototype.handleWrapJump=function(t){var e=Math.round((t-this.lng)/360);if(0!==e)for(var i in this.indexes){var o=this.indexes[i],r={};for(var a in o){var n=o[a];n.tileID=n.tileID.unwrapTo(n.tileID.wrap+e),r[n.tileID.key]=n;}this.indexes[i]=r;}this.lng=t;},Oe.prototype.addBucket=function(t,e,i){if(this.indexes[t.overscaledZ]&&this.indexes[t.overscaledZ][t.key]){if(this.indexes[t.overscaledZ][t.key].bucketInstanceId===e.bucketInstanceId)return !1;this.removeBucketCrossTileIDs(t.overscaledZ,this.indexes[t.overscaledZ][t.key]);}for(var o=0;o<e.symbolInstances.length;o++)e.symbolInstances.get(o).crossTileID=0;this.usedCrossTileIDs[t.overscaledZ]||(this.usedCrossTileIDs[t.overscaledZ]={});var r=this.usedCrossTileIDs[t.overscaledZ];for(var a in this.indexes){var n=this.indexes[a];if(Number(a)>t.overscaledZ)for(var s in n){var l=n[s];l.tileID.isChildOf(t)&&l.findMatches(e.symbolInstances,t,r);}else {var c=n[t.scaledTo(Number(a)).key];c&&c.findMatches(e.symbolInstances,t,r);}}for(var u=0;u<e.symbolInstances.length;u++){var h=e.symbolInstances.get(u);h.crossTileID||(h.crossTileID=i.generate(),r[h.crossTileID]=!0);}return void 0===this.indexes[t.overscaledZ]&&(this.indexes[t.overscaledZ]={}),this.indexes[t.overscaledZ][t.key]=new ke(t,e.symbolInstances,e.bucketInstanceId),!0},Oe.prototype.removeBucketCrossTileIDs=function(t,e){for(var i in e.indexedSymbolInstances)for(var o=0,r=e.indexedSymbolInstances[i];o<r.length;o+=1)delete this.usedCrossTileIDs[t][r[o].crossTileID];},Oe.prototype.removeStaleBuckets=function(t){var e=!1;for(var i in this.indexes){var o=this.indexes[i];for(var r in o)t[o[r].bucketInstanceId]||(this.removeBucketCrossTileIDs(i,o[r]),delete o[r],e=!0);}return e};var Fe=function(){this.layerIndexes={},this.crossTileIDs=new Be,this.maxBucketInstanceId=0,this.bucketsInCurrentPlacement={};};Fe.prototype.addLayer=function(t,e,i){var o=this.layerIndexes[t.id];void 0===o&&(o=this.layerIndexes[t.id]=new Oe);var r=!1,a={};o.handleWrapJump(i);for(var n=0,s=e;n<s.length;n+=1){var l=s[n],c=l.getBucket(t);c&&t.id===c.layerIds[0]&&(c.bucketInstanceId||(c.bucketInstanceId=++this.maxBucketInstanceId),o.addBucket(l.tileID,c,this.crossTileIDs)&&(r=!0),a[c.bucketInstanceId]=!0);}return o.removeStaleBuckets(a)&&(r=!0),r},Fe.prototype.pruneUnusedLayers=function(t){var e={};for(var i in t.forEach((function(t){e[t]=!0;})),this.layerIndexes)e[i]||delete this.layerIndexes[i];};var Ue=function(e,i){return t.emitValidationErrors(e,i&&i.filter((function(t){return "source.canvas"!==t.identifier})))},Ne=t.pick(Zt,["addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition","setGeoJSONSourceData"]),Ze=t.pick(Zt,["setCenter","setZoom","setBearing","setPitch"]),je=function(){var e={},i=t.styleSpec.$version;for(var o in t.styleSpec.$root){var r,a=t.styleSpec.$root[o];if(a.required)null!=(r="version"===o?i:"array"===a.type?[]:{})&&(e[o]=r);}return e}(),qe=function(e){function i(o,r){var a=this;void 0===r&&(r={}),e.call(this),this.map=o,this.dispatcher=new E(Ft(),this),this.imageManager=new p,this.imageManager.setEventedParent(this),this.glyphManager=new y(o._requestManager,r.localIdeographFontFamily),this.lineAtlas=new T(256,512),this.crossTileSymbolIndex=new Fe,this._layers={},this._serializedLayers={},this._order=[],this.sourceCaches={},this.zoomHistory=new t.ZoomHistory,this._loaded=!1,this._availableImages=[],this._resetUpdates(),this.dispatcher.broadcast("setReferrer",t.getReferrer());var n=this;this._rtlTextPluginCallback=i.registerForPluginStateChange((function(e){n.dispatcher.broadcast("syncRTLPluginState",{pluginStatus:e.pluginStatus,pluginURL:e.pluginURL},(function(e,i){if(t.triggerPluginCompletionEvent(e),i&&i.every((function(t){return t})))for(var o in n.sourceCaches)n.sourceCaches[o].reload();}));})),this.on("data",(function(t){if("source"===t.dataType&&"metadata"===t.sourceDataType){var e=a.sourceCaches[t.sourceId];if(e){var i=e.getSource();if(i&&i.vectorLayerIds)for(var o in a._layers){var r=a._layers[o];r.source===i.id&&a._validateLayer(r);}}}}));}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.loadURL=function(e,i){var o=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"}));var r="boolean"==typeof i.validate?i.validate:!t.isMapboxURL(e);e=this.map._requestManager.normalizeStyleURL(e,i.accessToken);var a=this.map._requestManager.transformRequest(e,t.ResourceType.Style);this._request=t.getJSON(a,(function(e,i){o._request=null,e?o.fire(new t.ErrorEvent(e)):i&&o._load(i,r);}));},i.prototype.loadJSON=function(e,i){var o=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"})),this._request=t.browser.frame((function(){o._request=null,o._load(e,!1!==i.validate);}));},i.prototype.loadEmpty=function(){this.fire(new t.Event("dataloading",{dataType:"style"})),this._load(je,!1);},i.prototype._load=function(e,i){if(!i||!Ue(this,t.validateStyle(e))){for(var o in this._loaded=!0,this.stylesheet=e,e.sources)this.addSource(o,e.sources[o],{validate:!1});e.sprite?this._loadSprite(e.sprite):this.imageManager.setLoaded(!0),this.glyphManager.setURL(e.glyphs);var r=Nt(this.stylesheet.layers);this._order=r.map((function(t){return t.id})),this._layers={},this._serializedLayers={};for(var a=0,n=r;a<n.length;a+=1){var s=n[a];(s=t.createStyleLayer(s)).setEventedParent(this,{layer:{id:s.id}}),this._layers[s.id]=s,this._serializedLayers[s.id]=s.serialize();}this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new w(this.stylesheet.light),this.fire(new t.Event("data",{dataType:"style"})),this.fire(new t.Event("style.load"));}},i.prototype._loadSprite=function(e){var i=this;this._spriteRequest=function(e,i,o){var r,a,n,s=t.browser.devicePixelRatio>1?"@2x":"",l=t.getJSON(i.transformRequest(i.normalizeSpriteURL(e,s,".json"),t.ResourceType.SpriteJSON),(function(t,e){l=null,n||(n=t,r=e,u());})),c=t.getImage(i.transformRequest(i.normalizeSpriteURL(e,s,".png"),t.ResourceType.SpriteImage),(function(t,e){c=null,n||(n=t,a=e,u());}));function u(){if(n)o(n);else if(r&&a){var e=t.browser.getImageData(a),i={};for(var s in r){var l=r[s],c=l.width,u=l.height,h=l.x,p=l.y,d=l.sdf,_=l.pixelRatio,f=l.stretchX,m=l.stretchY,g=l.content,v=new t.RGBAImage({width:c,height:u});t.RGBAImage.copy(e,v,{x:h,y:p},{x:0,y:0},{width:c,height:u}),i[s]={data:v,pixelRatio:_,sdf:d,stretchX:f,stretchY:m,content:g};}o(null,i);}}return {cancel:function(){l&&(l.cancel(),l=null),c&&(c.cancel(),c=null);}}}(e,this.map._requestManager,(function(e,o){if(i._spriteRequest=null,e)i.fire(new t.ErrorEvent(e));else if(o)for(var r in o)i.imageManager.addImage(r,o[r]);i.imageManager.setLoaded(!0),i._availableImages=i.imageManager.listImages(),i.dispatcher.broadcast("setImages",i._availableImages),i.fire(new t.Event("data",{dataType:"style"}));}));},i.prototype._validateLayer=function(e){var i=this.sourceCaches[e.source];if(i){var o=e.sourceLayer;if(o){var r=i.getSource();("geojson"===r.type||r.vectorLayerIds&&-1===r.vectorLayerIds.indexOf(o))&&this.fire(new t.ErrorEvent(new Error('Source layer "'+o+'" does not exist on source "'+r.id+'" as specified by style layer "'+e.id+'"')));}}},i.prototype.loaded=function(){if(!this._loaded)return !1;if(Object.keys(this._updatedSources).length)return !1;for(var t in this.sourceCaches)if(!this.sourceCaches[t].loaded())return !1;return !!this.imageManager.isLoaded()},i.prototype._serializeLayers=function(t){for(var e=[],i=0,o=t;i<o.length;i+=1){var r=this._layers[o[i]];"custom"!==r.type&&e.push(r.serialize());}return e},i.prototype.hasTransitions=function(){if(this.light&&this.light.hasTransition())return !0;for(var t in this.sourceCaches)if(this.sourceCaches[t].hasTransition())return !0;for(var e in this._layers)if(this._layers[e].hasTransition())return !0;return !1},i.prototype._checkLoaded=function(){if(!this._loaded)throw new Error("Style is not done loading")},i.prototype.update=function(e){if(this._loaded){var i=this._changed;if(this._changed){var o=Object.keys(this._updatedLayers),r=Object.keys(this._removedLayers);for(var a in (o.length||r.length)&&this._updateWorkerLayers(o,r),this._updatedSources){var n=this._updatedSources[a];"reload"===n?this._reloadSource(a):"clear"===n&&this._clearSource(a);}for(var s in this._updateTilesForChangedImages(),this._updatedPaintProps)this._layers[s].updateTransitions(e);this.light.updateTransitions(e),this._resetUpdates();}for(var l in this.sourceCaches)this.sourceCaches[l].used=!1;for(var c=0,u=this._order;c<u.length;c+=1){var h=this._layers[u[c]];h.recalculate(e,this._availableImages),!h.isHidden(e.zoom)&&h.source&&(this.sourceCaches[h.source].used=!0);}this.light.recalculate(e),this.z=e.zoom,i&&this.fire(new t.Event("data",{dataType:"style"}));}},i.prototype._updateTilesForChangedImages=function(){var t=Object.keys(this._changedImages);if(t.length){for(var e in this.sourceCaches)this.sourceCaches[e].reloadTilesForDependencies(["icons","patterns"],t);this._changedImages={};}},i.prototype._updateWorkerLayers=function(t,e){this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(t),removedIds:e});},i.prototype._resetUpdates=function(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSources={},this._updatedPaintProps={},this._changedImages={};},i.prototype.setState=function(e){var i=this;if(this._checkLoaded(),Ue(this,t.validateStyle(e)))return !1;(e=t.clone$1(e)).layers=Nt(e.layers);var o=function(e,i){if(!e)return [{command:Zt.setStyle,args:[i]}];var o=[];try{if(!t.deepEqual(e.version,i.version))return [{command:Zt.setStyle,args:[i]}];t.deepEqual(e.center,i.center)||o.push({command:Zt.setCenter,args:[i.center]}),t.deepEqual(e.zoom,i.zoom)||o.push({command:Zt.setZoom,args:[i.zoom]}),t.deepEqual(e.bearing,i.bearing)||o.push({command:Zt.setBearing,args:[i.bearing]}),t.deepEqual(e.pitch,i.pitch)||o.push({command:Zt.setPitch,args:[i.pitch]}),t.deepEqual(e.sprite,i.sprite)||o.push({command:Zt.setSprite,args:[i.sprite]}),t.deepEqual(e.glyphs,i.glyphs)||o.push({command:Zt.setGlyphs,args:[i.glyphs]}),t.deepEqual(e.transition,i.transition)||o.push({command:Zt.setTransition,args:[i.transition]}),t.deepEqual(e.light,i.light)||o.push({command:Zt.setLight,args:[i.light]});var r={},a=[];!function(e,i,o,r){var a;for(a in i=i||{},e=e||{})e.hasOwnProperty(a)&&(i.hasOwnProperty(a)||qt(a,o,r));for(a in i)i.hasOwnProperty(a)&&(e.hasOwnProperty(a)?t.deepEqual(e[a],i[a])||("geojson"===e[a].type&&"geojson"===i[a].type&&Gt(e,i,a)?o.push({command:Zt.setGeoJSONSourceData,args:[a,i[a].data]}):Vt(a,i,o,r)):jt(a,i,o));}(e.sources,i.sources,a,r);var n=[];e.layers&&e.layers.forEach((function(t){r[t.source]?o.push({command:Zt.removeLayer,args:[t.id]}):n.push(t);})),o=o.concat(a),function(e,i,o){i=i||[];var r,a,n,s,l,c,u,h=(e=e||[]).map(Xt),p=i.map(Xt),d=e.reduce(Ht,{}),_=i.reduce(Ht,{}),f=h.slice(),m=Object.create(null);for(r=0,a=0;r<h.length;r++)_.hasOwnProperty(n=h[r])?a++:(o.push({command:Zt.removeLayer,args:[n]}),f.splice(f.indexOf(n,a),1));for(r=0,a=0;r<p.length;r++)f[f.length-1-r]!==(n=p[p.length-1-r])&&(d.hasOwnProperty(n)?(o.push({command:Zt.removeLayer,args:[n]}),f.splice(f.lastIndexOf(n,f.length-a),1)):a++,o.push({command:Zt.addLayer,args:[_[n],c=f[f.length-r]]}),f.splice(f.length-r,0,n),m[n]=!0);for(r=0;r<p.length;r++)if(s=d[n=p[r]],l=_[n],!m[n]&&!t.deepEqual(s,l))if(t.deepEqual(s.source,l.source)&&t.deepEqual(s["source-layer"],l["source-layer"])&&t.deepEqual(s.type,l.type)){for(u in Wt(s.layout,l.layout,o,n,null,Zt.setLayoutProperty),Wt(s.paint,l.paint,o,n,null,Zt.setPaintProperty),t.deepEqual(s.filter,l.filter)||o.push({command:Zt.setFilter,args:[n,l.filter]}),t.deepEqual(s.minzoom,l.minzoom)&&t.deepEqual(s.maxzoom,l.maxzoom)||o.push({command:Zt.setLayerZoomRange,args:[n,l.minzoom,l.maxzoom]}),s)s.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?Wt(s[u],l[u],o,n,u.slice(6),Zt.setPaintProperty):t.deepEqual(s[u],l[u])||o.push({command:Zt.setLayerProperty,args:[n,u,l[u]]}));for(u in l)l.hasOwnProperty(u)&&!s.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?Wt(s[u],l[u],o,n,u.slice(6),Zt.setPaintProperty):t.deepEqual(s[u],l[u])||o.push({command:Zt.setLayerProperty,args:[n,u,l[u]]}));}else o.push({command:Zt.removeLayer,args:[n]}),c=f[f.lastIndexOf(n)+1],o.push({command:Zt.addLayer,args:[l,c]});}(n,i.layers,o);}catch(t){console.warn("Unable to compute style diff:",t),o=[{command:Zt.setStyle,args:[i]}];}return o}(this.serialize(),e).filter((function(t){return !(t.command in Ze)}));if(0===o.length)return !1;var r=o.filter((function(t){return !(t.command in Ne)}));if(r.length>0)throw new Error("Unimplemented: "+r.map((function(t){return t.command})).join(", ")+".");return o.forEach((function(t){"setTransition"!==t.command&&i[t.command].apply(i,t.args);})),this.stylesheet=e,!0},i.prototype.addImage=function(e,i){if(this.getImage(e))return this.fire(new t.ErrorEvent(new Error("An image with this name already exists.")));this.imageManager.addImage(e,i),this._availableImages=this.imageManager.listImages(),this._changedImages[e]=!0,this._changed=!0,this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.updateImage=function(t,e){this.imageManager.updateImage(t,e);},i.prototype.getImage=function(t){return this.imageManager.getImage(t)},i.prototype.removeImage=function(e){if(!this.getImage(e))return this.fire(new t.ErrorEvent(new Error("No image with this name exists.")));this.imageManager.removeImage(e),this._availableImages=this.imageManager.listImages(),this._changedImages[e]=!0,this._changed=!0,this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.listImages=function(){return this._checkLoaded(),this.imageManager.listImages()},i.prototype.addSource=function(e,i,o){var r=this;if(void 0===o&&(o={}),this._checkLoaded(),void 0!==this.sourceCaches[e])throw new Error("There is already a source with this ID");if(!i.type)throw new Error("The type property must be defined, but the only the following properties were given: "+Object.keys(i).join(", ")+".");if(!(["vector","raster","geojson","video","image"].indexOf(i.type)>=0&&this._validate(t.validateStyle.source,"sources."+e,i,null,o))){this.map&&this.map._collectResourceTiming&&(i.collectResourceTiming=!0);var a=this.sourceCaches[e]=new Dt(e,i,this.dispatcher);a.style=this,a.setEventedParent(this,(function(){return {isSourceLoaded:r.loaded(),source:a.serialize(),sourceId:e}})),a.onAdd(this.map),this._changed=!0;}},i.prototype.removeSource=function(e){if(this._checkLoaded(),void 0===this.sourceCaches[e])throw new Error("There is no source with this ID");for(var i in this._layers)if(this._layers[i].source===e)return this.fire(new t.ErrorEvent(new Error('Source "'+e+'" cannot be removed while layer "'+i+'" is using it.')));var o=this.sourceCaches[e];delete this.sourceCaches[e],delete this._updatedSources[e],o.fire(new t.Event("data",{sourceDataType:"metadata",dataType:"source",sourceId:e})),o.setEventedParent(null),o.clearTiles(),o.onRemove&&o.onRemove(this.map),this._changed=!0;},i.prototype.setGeoJSONSourceData=function(t,e){this._checkLoaded(),this.sourceCaches[t].getSource().setData(e),this._changed=!0;},i.prototype.getSource=function(t){return this.sourceCaches[t]&&this.sourceCaches[t].getSource()},i.prototype.addLayer=function(e,i,o){void 0===o&&(o={}),this._checkLoaded();var r=e.id;if(this.getLayer(r))this.fire(new t.ErrorEvent(new Error('Layer with id "'+r+'" already exists on this map')));else {var a;if("custom"===e.type){if(Ue(this,t.validateCustomStyleLayer(e)))return;a=t.createStyleLayer(e);}else {if("object"==typeof e.source&&(this.addSource(r,e.source),e=t.clone$1(e),e=t.extend(e,{source:r})),this._validate(t.validateStyle.layer,"layers."+r,e,{arrayIndex:-1},o))return;a=t.createStyleLayer(e),this._validateLayer(a),a.setEventedParent(this,{layer:{id:r}}),this._serializedLayers[a.id]=a.serialize();}var n=i?this._order.indexOf(i):this._order.length;if(i&&-1===n)this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.')));else {if(this._order.splice(n,0,r),this._layerOrderChanged=!0,this._layers[r]=a,this._removedLayers[r]&&a.source&&"custom"!==a.type){var s=this._removedLayers[r];delete this._removedLayers[r],s.type!==a.type?this._updatedSources[a.source]="clear":(this._updatedSources[a.source]="reload",this.sourceCaches[a.source].pause());}this._updateLayer(a),a.onAdd&&a.onAdd(this.map);}}},i.prototype.moveLayer=function(e,i){if(this._checkLoaded(),this._changed=!0,this._layers[e]){if(e!==i){var o=this._order.indexOf(e);this._order.splice(o,1);var r=i?this._order.indexOf(i):this._order.length;i&&-1===r?this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.'))):(this._order.splice(r,0,e),this._layerOrderChanged=!0);}}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be moved.")));},i.prototype.removeLayer=function(e){this._checkLoaded();var i=this._layers[e];if(i){i.setEventedParent(null);var o=this._order.indexOf(e);this._order.splice(o,1),this._layerOrderChanged=!0,this._changed=!0,this._removedLayers[e]=i,delete this._layers[e],delete this._serializedLayers[e],delete this._updatedLayers[e],delete this._updatedPaintProps[e],i.onRemove&&i.onRemove(this.map);}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be removed.")));},i.prototype.getLayer=function(t){return this._layers[t]},i.prototype.hasLayer=function(t){return t in this._layers},i.prototype.setLayerZoomRange=function(e,i,o){this._checkLoaded();var r=this.getLayer(e);r?r.minzoom===i&&r.maxzoom===o||(null!=i&&(r.minzoom=i),null!=o&&(r.maxzoom=o),this._updateLayer(r)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot have zoom extent.")));},i.prototype.setFilter=function(e,i,o){void 0===o&&(o={}),this._checkLoaded();var r=this.getLayer(e);if(r){if(!t.deepEqual(r.filter,i))return null==i?(r.filter=void 0,void this._updateLayer(r)):void(this._validate(t.validateStyle.filter,"layers."+r.id+".filter",i,null,o)||(r.filter=t.clone$1(i),this._updateLayer(r)))}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be filtered.")));},i.prototype.getFilter=function(e){return t.clone$1(this.getLayer(e).filter)},i.prototype.setLayoutProperty=function(e,i,o,r){void 0===r&&(r={}),this._checkLoaded();var a=this.getLayer(e);a?t.deepEqual(a.getLayoutProperty(i),o)||(a.setLayoutProperty(i,o,r),this._updateLayer(a)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getLayoutProperty=function(e,i){var o=this.getLayer(e);if(o)return o.getLayoutProperty(i);this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style.")));},i.prototype.setPaintProperty=function(e,i,o,r){void 0===r&&(r={}),this._checkLoaded();var a=this.getLayer(e);a?t.deepEqual(a.getPaintProperty(i),o)||(a.setPaintProperty(i,o,r)&&this._updateLayer(a),this._changed=!0,this._updatedPaintProps[e]=!0):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getPaintProperty=function(t,e){return this.getLayer(t).getPaintProperty(e)},i.prototype.setFeatureState=function(e,i){this._checkLoaded();var o=e.source,r=e.sourceLayer,a=this.sourceCaches[o];if(void 0!==a){var n=a.getSource().type;"geojson"===n&&r?this.fire(new t.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))):"vector"!==n||r?(void 0===e.id&&this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided."))),a.setFeatureState(r,e.id,i)):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+o+"' does not exist in the map's style.")));},i.prototype.removeFeatureState=function(e,i){this._checkLoaded();var o=e.source,r=this.sourceCaches[o];if(void 0!==r){var a=r.getSource().type,n="vector"===a?e.sourceLayer:void 0;"vector"!==a||n?i&&"string"!=typeof e.id&&"number"!=typeof e.id?this.fire(new t.ErrorEvent(new Error("A feature id is requred to remove its specific state property."))):r.removeFeatureState(n,e.id,i):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+o+"' does not exist in the map's style.")));},i.prototype.getFeatureState=function(e){this._checkLoaded();var i=e.source,o=e.sourceLayer,r=this.sourceCaches[i];if(void 0!==r){if("vector"!==r.getSource().type||o)return void 0===e.id&&this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided."))),r.getFeatureState(o,e.id);this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+i+"' does not exist in the map's style.")));},i.prototype.getTransition=function(){return t.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)},i.prototype.serialize=function(){return t.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,sources:t.mapObject(this.sourceCaches,(function(t){return t.serialize()})),layers:this._serializeLayers(this._order)},(function(t){return void 0!==t}))},i.prototype._updateLayer=function(t){this._updatedLayers[t.id]=!0,t.source&&!this._updatedSources[t.source]&&"raster"!==this.sourceCaches[t.source].getSource().type&&(this._updatedSources[t.source]="reload",this.sourceCaches[t.source].pause()),this._changed=!0;},i.prototype._flattenAndSortRenderedFeatures=function(t){for(var e=this,i=function(t){return "fill-extrusion"===e._layers[t].type},o={},r=[],a=this._order.length-1;a>=0;a--){var n=this._order[a];if(i(n)){o[n]=a;for(var s=0,l=t;s<l.length;s+=1){var c=l[s][n];if(c)for(var u=0,h=c;u<h.length;u+=1)r.push(h[u]);}}}r.sort((function(t,e){return e.intersectionZ-t.intersectionZ}));for(var p=[],d=this._order.length-1;d>=0;d--){var _=this._order[d];if(i(_))for(var f=r.length-1;f>=0;f--){var m=r[f].feature;if(o[m.layer.id]<d)break;p.push(m),r.pop();}else for(var g=0,v=t;g<v.length;g+=1){var y=v[g][_];if(y)for(var x=0,b=y;x<b.length;x+=1)p.push(b[x].feature);}}return p},i.prototype.queryRenderedFeatures=function(e,i,o){i&&i.filter&&this._validate(t.validateStyle.filter,"queryRenderedFeatures.filter",i.filter,null,i);var r={};if(i&&i.layers){if(!Array.isArray(i.layers))return this.fire(new t.ErrorEvent(new Error("parameters.layers must be an Array."))),[];for(var a=0,n=i.layers;a<n.length;a+=1){var s=n[a],l=this._layers[s];if(!l)return this.fire(new t.ErrorEvent(new Error("The layer '"+s+"' does not exist in the map's style and cannot be queried for features."))),[];r[l.source]=!0;}}var c=[];for(var u in i.availableImages=this._availableImages,this.sourceCaches)i.layers&&!r[u]||c.push(O(this.sourceCaches[u],this._layers,this._serializedLayers,e,i,o));return this.placement&&c.push(function(t,e,i,o,r,a,n){for(var s={},l=a.queryRenderedSymbols(o),c=[],u=0,h=Object.keys(l).map(Number);u<h.length;u+=1)c.push(n[h[u]]);c.sort(F);for(var p=function(){var i=_[d],o=i.featureIndex.lookupSymbolFeatures(l[i.bucketInstanceId],e,i.bucketIndex,i.sourceLayerIndex,r.filter,r.layers,r.availableImages,t);for(var a in o){var n=s[a]=s[a]||[],c=o[a];c.sort((function(t,e){var o=i.featureSortOrder;if(o){var r=o.indexOf(t.featureIndex);return o.indexOf(e.featureIndex)-r}return e.featureIndex-t.featureIndex}));for(var u=0,h=c;u<h.length;u+=1)n.push(h[u]);}},d=0,_=c;d<_.length;d+=1)p();var f=function(e){s[e].forEach((function(o){var r=o.feature,a=i[t[e].source].getFeatureState(r.layer["source-layer"],r.id);r.source=r.layer.source,r.layer["source-layer"]&&(r.sourceLayer=r.layer["source-layer"]),r.state=a;}));};for(var m in s)f(m);return s}(this._layers,this._serializedLayers,this.sourceCaches,e,i,this.placement.collisionIndex,this.placement.retainedQueryData)),this._flattenAndSortRenderedFeatures(c)},i.prototype.querySourceFeatures=function(e,i){i&&i.filter&&this._validate(t.validateStyle.filter,"querySourceFeatures.filter",i.filter,null,i);var o=this.sourceCaches[e];return o?function(t,e){for(var i=t.getRenderableIds().map((function(e){return t.getTileByID(e)})),o=[],r={},a=0;a<i.length;a++){var n=i[a],s=n.tileID.canonical.key;r[s]||(r[s]=!0,n.querySourceFeatures(o,e));}return o}(o,i):[]},i.prototype.addSourceType=function(t,e,o){return i.getSourceType(t)?o(new Error('A source type called "'+t+'" already exists.')):(i.setSourceType(t,e),e.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:t,url:e.workerSourceURL},o):o(null,null))},i.prototype.getLight=function(){return this.light.getLight()},i.prototype.setLight=function(e,i){void 0===i&&(i={}),this._checkLoaded();var o=this.light.getLight(),r=!1;for(var a in e)if(!t.deepEqual(e[a],o[a])){r=!0;break}if(r){var n={now:t.browser.now(),transition:t.extend({duration:300,delay:0},this.stylesheet.transition)};this.light.setLight(e,i),this.light.updateTransitions(n);}},i.prototype._validate=function(e,i,o,r,a){return void 0===a&&(a={}),(!a||!1!==a.validate)&&Ue(this,e.call(t.validateStyle,t.extend({key:i,style:this.serialize(),value:o,styleSpec:t.styleSpec},r)))},i.prototype._remove=function(){for(var e in this._request&&(this._request.cancel(),this._request=null),this._spriteRequest&&(this._spriteRequest.cancel(),this._spriteRequest=null),t.evented.off("pluginStateChange",this._rtlTextPluginCallback),this._layers)this._layers[e].setEventedParent(null);for(var i in this.sourceCaches)this.sourceCaches[i].clearTiles(),this.sourceCaches[i].setEventedParent(null);this.imageManager.setEventedParent(null),this.setEventedParent(null),this.dispatcher.remove();},i.prototype._clearSource=function(t){this.sourceCaches[t].clearTiles();},i.prototype._reloadSource=function(t){this.sourceCaches[t].resume(),this.sourceCaches[t].reload();},i.prototype._updateSources=function(t){for(var e in this.sourceCaches)this.sourceCaches[e].update(t);},i.prototype._generateCollisionBoxes=function(){for(var t in this.sourceCaches)this._reloadSource(t);},i.prototype._updatePlacement=function(e,i,o,r,a){void 0===a&&(a=!1);for(var n=!1,s=!1,l={},c=0,u=this._order;c<u.length;c+=1){var h=this._layers[u[c]];if("symbol"===h.type){if(!l[h.source]){var p=this.sourceCaches[h.source];l[h.source]=p.getRenderableIds(!0).map((function(t){return p.getTileByID(t)})).sort((function(t,e){return e.tileID.overscaledZ-t.tileID.overscaledZ||(t.tileID.isLessThan(e.tileID)?-1:1)}));}var d=this.crossTileSymbolIndex.addLayer(h,l[h.source],e.center.lng);n=n||d;}}if(this.crossTileSymbolIndex.pruneUnusedLayers(this._order),((a=a||this._layerOrderChanged||0===o)||!this.pauseablePlacement||this.pauseablePlacement.isDone()&&!this.placement.stillRecent(t.browser.now(),e.zoom))&&(this.pauseablePlacement=new Ae(e,this._order,a,i,o,r,this.placement),this._layerOrderChanged=!1),this.pauseablePlacement.isDone()?this.placement.setStale():(this.pauseablePlacement.continuePlacement(this._order,this._layers,l),this.pauseablePlacement.isDone()&&(this.placement=this.pauseablePlacement.commit(t.browser.now()),s=!0),n&&this.pauseablePlacement.placement.setStale()),s||n)for(var _=0,f=this._order;_<f.length;_+=1){var m=this._layers[f[_]];"symbol"===m.type&&this.placement.updateLayerOpacities(m,l[m.source]);}return !this.pauseablePlacement.isDone()||this.placement.hasTransitions(t.browser.now())},i.prototype._releaseSymbolFadeTiles=function(){for(var t in this.sourceCaches)this.sourceCaches[t].releaseSymbolFadeTiles();},i.prototype.getImages=function(t,e,i){this.imageManager.getImages(e.icons,i),this._updateTilesForChangedImages();var o=this.sourceCaches[e.source];o&&o.setDependencies(e.tileID.key,e.type,e.icons);},i.prototype.getGlyphs=function(t,e,i){this.glyphManager.getGlyphs(e.stacks,i);},i.prototype.getResource=function(e,i,o){return t.makeRequest(i,o)},i}(t.Evented);qe.getSourceType=function(t){return k[t]},qe.setSourceType=function(t,e){k[t]=e;},qe.registerForPluginStateChange=t.registerForPluginStateChange;var Ve=t.createLayout([{name:"a_pos",type:"Int16",components:2}]),Ge=gi("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif","#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"),We=gi("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Xe=gi("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),He=gi("varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),Ke=gi("void main() {gl_FragColor=vec4(1.0);}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Ye=gi("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),Je=gi("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),Qe=gi("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}","attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),$e=gi("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}","attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),ti=gi("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}","attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}"),ei=gi("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),ii=gi("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),oi=gi("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),ri=gi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),ai=gi("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),ni=gi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),si=gi("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform float u_maxzoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggeration=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/ pow(2.0,(u_zoom-u_maxzoom)*exaggeration+19.2562-u_zoom);gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),li=gi("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),ci=gi("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),ui=gi("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,vec2(v_lineprogress,0.5));gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define MAX_LINE_DISTANCE 32767.0\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_lineprogress=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0/MAX_LINE_DISTANCE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),hi=gi("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),pi=gi("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),di=gi("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),_i=gi("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"),fi=gi("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),mi=gi("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}");function gi(t,e){var i=/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,o={};return {fragmentSource:t=t.replace(i,(function(t,e,i,r,a){return o[a]=!0,"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nvarying "+i+" "+r+" "+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"\n#ifdef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n"})),vertexSource:e=e.replace(i,(function(t,e,i,r,a){var n="float"===r?"vec2":"vec4",s=a.match(/color/)?"color":n;return o[a]?"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nuniform lowp float u_"+a+"_t;\nattribute "+i+" "+n+" a_"+a+";\nvarying "+i+" "+r+" "+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"vec4"===s?"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+a+" = a_"+a+";\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+a+" = unpack_mix_"+s+"(a_"+a+", u_"+a+"_t);\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nuniform lowp float u_"+a+"_t;\nattribute "+i+" "+n+" a_"+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"vec4"===s?"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = a_"+a+";\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = unpack_mix_"+s+"(a_"+a+", u_"+a+"_t);\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n"}))}}var vi=Object.freeze({__proto__:null,prelude:Ge,background:We,backgroundPattern:Xe,circle:He,clippingMask:Ke,heatmap:Ye,heatmapTexture:Je,collisionBox:Qe,collisionCircle:$e,debug:ti,fill:ei,fillOutline:ii,fillOutlinePattern:oi,fillPattern:ri,fillExtrusion:ai,fillExtrusionPattern:ni,hillshadePrepare:si,hillshade:li,line:ci,lineGradient:ui,linePattern:hi,lineSDF:pi,raster:di,symbolIcon:_i,symbolSDF:fi,symbolTextAndIcon:mi}),yi=function(){this.boundProgram=null,this.boundLayoutVertexBuffer=null,this.boundPaintVertexBuffers=[],this.boundIndexBuffer=null,this.boundVertexOffset=null,this.boundDynamicVertexBuffer=null,this.vao=null;};yi.prototype.bind=function(t,e,i,o,r,a,n,s){this.context=t;for(var l=this.boundPaintVertexBuffers.length!==o.length,c=0;!l&&c<o.length;c++)this.boundPaintVertexBuffers[c]!==o[c]&&(l=!0);t.extVertexArrayObject&&this.vao&&this.boundProgram===e&&this.boundLayoutVertexBuffer===i&&!l&&this.boundIndexBuffer===r&&this.boundVertexOffset===a&&this.boundDynamicVertexBuffer===n&&this.boundDynamicVertexBuffer2===s?(t.bindVertexArrayOES.set(this.vao),n&&n.bind(),r&&r.dynamicDraw&&r.bind(),s&&s.bind()):this.freshBind(e,i,o,r,a,n,s);},yi.prototype.freshBind=function(t,e,i,o,r,a,n){var s,l=t.numAttributes,c=this.context,u=c.gl;if(c.extVertexArrayObject)this.vao&&this.destroy(),this.vao=c.extVertexArrayObject.createVertexArrayOES(),c.bindVertexArrayOES.set(this.vao),s=0,this.boundProgram=t,this.boundLayoutVertexBuffer=e,this.boundPaintVertexBuffers=i,this.boundIndexBuffer=o,this.boundVertexOffset=r,this.boundDynamicVertexBuffer=a,this.boundDynamicVertexBuffer2=n;else {s=c.currentNumAttributes||0;for(var h=l;h<s;h++)u.disableVertexAttribArray(h);}e.enableAttributes(u,t);for(var p=0,d=i;p<d.length;p+=1)d[p].enableAttributes(u,t);a&&a.enableAttributes(u,t),n&&n.enableAttributes(u,t),e.bind(),e.setVertexAttribPointers(u,t,r);for(var _=0,f=i;_<f.length;_+=1){var m=f[_];m.bind(),m.setVertexAttribPointers(u,t,r);}a&&(a.bind(),a.setVertexAttribPointers(u,t,r)),o&&o.bind(),n&&(n.bind(),n.setVertexAttribPointers(u,t,r)),c.currentNumAttributes=l;},yi.prototype.destroy=function(){this.vao&&(this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null);};var xi=function(t,e,i,o,r){var a=t.gl;this.program=a.createProgram();var n=i?i.defines():[];r&&n.push("#define OVERDRAW_INSPECTOR;");var s=n.concat(Ge.fragmentSource,e.fragmentSource).join("\n"),l=n.concat(Ge.vertexSource,e.vertexSource).join("\n"),c=a.createShader(a.FRAGMENT_SHADER);if(a.isContextLost())this.failedToCreate=!0;else {a.shaderSource(c,s),a.compileShader(c),a.attachShader(this.program,c);var u=a.createShader(a.VERTEX_SHADER);if(a.isContextLost())this.failedToCreate=!0;else {a.shaderSource(u,l),a.compileShader(u),a.attachShader(this.program,u);for(var h=i?i.layoutAttributes:[],p=0;p<h.length;p++)a.bindAttribLocation(this.program,p,h[p].name);a.linkProgram(this.program),a.deleteShader(u),a.deleteShader(c),this.numAttributes=a.getProgramParameter(this.program,a.ACTIVE_ATTRIBUTES),this.attributes={};for(var d={},_=0;_<this.numAttributes;_++){var f=a.getActiveAttrib(this.program,_);f&&(this.attributes[f.name]=a.getAttribLocation(this.program,f.name));}for(var m=a.getProgramParameter(this.program,a.ACTIVE_UNIFORMS),g=0;g<m;g++){var v=a.getActiveUniform(this.program,g);v&&(d[v.name]=a.getUniformLocation(this.program,v.name));}this.fixedUniforms=o(t,d),this.binderUniforms=i?i.getUniforms(t,d):[];}}};function bi(t,e,i){var o=1/pe(i,1,e.transform.tileZoom),r=Math.pow(2,i.tileID.overscaledZ),a=i.tileSize*Math.pow(2,e.transform.tileZoom)/r,n=a*(i.tileID.canonical.x+i.tileID.wrap*r),s=a*i.tileID.canonical.y;return {u_image:0,u_texsize:i.imageAtlasTexture.size,u_scale:[o,t.fromScale,t.toScale],u_fade:t.t,u_pixel_coord_upper:[n>>16,s>>16],u_pixel_coord_lower:[65535&n,65535&s]}}xi.prototype.draw=function(t,e,i,o,r,a,n,s,l,c,u,h,p,d,_,f){var m,g=t.gl;if(!this.failedToCreate){for(var v in t.program.set(this.program),t.setDepthMode(i),t.setStencilMode(o),t.setColorMode(r),t.setCullFace(a),this.fixedUniforms)this.fixedUniforms[v].set(n[v]);d&&d.setUniforms(t,this.binderUniforms,h,{zoom:p});for(var y=(m={},m[g.LINES]=2,m[g.TRIANGLES]=3,m[g.LINE_STRIP]=1,m)[e],x=0,b=u.get();x<b.length;x+=1){var w=b[x],T=w.vaos||(w.vaos={});(T[s]||(T[s]=new yi)).bind(t,this,l,d?d.getPaintVertexBuffers():[],c,w.vertexOffset,_,f),g.drawElements(e,w.primitiveLength*y,g.UNSIGNED_SHORT,w.primitiveOffset*y*2);}}};var wi=function(e,i,o,r){var a=i.style.light,n=a.properties.get("position"),s=[n.x,n.y,n.z],l=t.create$1();"viewport"===a.properties.get("anchor")&&t.fromRotation(l,-i.transform.angle),t.transformMat3(s,s,l);var c=a.properties.get("color");return {u_matrix:e,u_lightpos:s,u_lightintensity:a.properties.get("intensity"),u_lightcolor:[c.r,c.g,c.b],u_vertical_gradient:+o,u_opacity:r}},Ti=function(e,i,o,r,a,n,s){return t.extend(wi(e,i,o,r),bi(n,i,s),{u_height_factor:-Math.pow(2,a.overscaledZ)/s.tileSize/8})},Ei=function(t){return {u_matrix:t}},Ii=function(e,i,o,r){return t.extend(Ei(e),bi(o,i,r))},Pi=function(t,e){return {u_matrix:t,u_world:e}},Si=function(e,i,o,r,a){return t.extend(Ii(e,i,o,r),{u_world:a})},Ci=function(e,i,o,r){var a,n,s=e.transform;if("map"===r.paint.get("circle-pitch-alignment")){var l=pe(o,1,s.zoom);a=!0,n=[l,l];}else a=!1,n=s.pixelsToGLUnits;return {u_camera_to_center_distance:s.cameraToCenterDistance,u_scale_with_map:+("map"===r.paint.get("circle-pitch-scale")),u_matrix:e.translatePosMatrix(i.posMatrix,o,r.paint.get("circle-translate"),r.paint.get("circle-translate-anchor")),u_pitch_with_map:+a,u_device_pixel_ratio:t.browser.devicePixelRatio,u_extrude_scale:n}},zi=function(t,e,i){var o=pe(i,1,e.zoom),r=Math.pow(2,e.zoom-i.tileID.overscaledZ),a=i.tileID.overscaleFactor();return {u_matrix:t,u_camera_to_center_distance:e.cameraToCenterDistance,u_pixels_to_tile_units:o,u_extrude_scale:[e.pixelsToGLUnits[0]/(o*r),e.pixelsToGLUnits[1]/(o*r)],u_overscale_factor:a}},Di=function(t,e,i){return {u_matrix:t,u_inv_matrix:e,u_camera_to_center_distance:i.cameraToCenterDistance,u_viewport_size:[i.width,i.height]}},Mi=function(t,e,i){return void 0===i&&(i=1),{u_matrix:t,u_color:e,u_overlay:0,u_overlay_scale:i}},Li=function(t){return {u_matrix:t}},Ai=function(t,e,i,o){return {u_matrix:t,u_extrude_scale:pe(e,1,i),u_intensity:o}},Ri=function(e,i,o){var r=e.transform;return {u_matrix:Ui(e,i,o),u_ratio:1/pe(i,1,r.zoom),u_device_pixel_ratio:t.browser.devicePixelRatio,u_units_to_pixels:[1/r.pixelsToGLUnits[0],1/r.pixelsToGLUnits[1]]}},ki=function(e,i,o){return t.extend(Ri(e,i,o),{u_image:0})},Bi=function(e,i,o,r){var a=e.transform,n=Fi(i,a);return {u_matrix:Ui(e,i,o),u_texsize:i.imageAtlasTexture.size,u_ratio:1/pe(i,1,a.zoom),u_device_pixel_ratio:t.browser.devicePixelRatio,u_image:0,u_scale:[n,r.fromScale,r.toScale],u_fade:r.t,u_units_to_pixels:[1/a.pixelsToGLUnits[0],1/a.pixelsToGLUnits[1]]}},Oi=function(e,i,o,r,a){var n=e.lineAtlas,s=Fi(i,e.transform),l="round"===o.layout.get("line-cap"),c=n.getDash(r.from,l),u=n.getDash(r.to,l),h=c.width*a.fromScale,p=u.width*a.toScale;return t.extend(Ri(e,i,o),{u_patternscale_a:[s/h,-c.height/2],u_patternscale_b:[s/p,-u.height/2],u_sdfgamma:n.width/(256*Math.min(h,p)*t.browser.devicePixelRatio)/2,u_image:0,u_tex_y_a:c.y,u_tex_y_b:u.y,u_mix:a.t})};function Fi(t,e){return 1/pe(t,1,e.tileZoom)}function Ui(t,e,i){return t.translatePosMatrix(e.tileID.posMatrix,e,i.paint.get("line-translate"),i.paint.get("line-translate-anchor"))}var Ni=function(t,e,i,o,r){return {u_matrix:t,u_tl_parent:e,u_scale_parent:i,u_buffer_scale:1,u_fade_t:o.mix,u_opacity:o.opacity*r.paint.get("raster-opacity"),u_image0:0,u_image1:1,u_brightness_low:r.paint.get("raster-brightness-min"),u_brightness_high:r.paint.get("raster-brightness-max"),u_saturation_factor:(n=r.paint.get("raster-saturation"),n>0?1-1/(1.001-n):-n),u_contrast_factor:(a=r.paint.get("raster-contrast"),a>0?1/(1-a):1+a),u_spin_weights:Zi(r.paint.get("raster-hue-rotate"))};var a,n;};function Zi(t){t*=Math.PI/180;var e=Math.sin(t),i=Math.cos(t);return [(2*i+1)/3,(-Math.sqrt(3)*e-i+1)/3,(Math.sqrt(3)*e-i+1)/3]}var ji,qi=function(t,e,i,o,r,a,n,s,l,c){var u=r.transform;return {u_is_size_zoom_constant:+("constant"===t||"source"===t),u_is_size_feature_constant:+("constant"===t||"camera"===t),u_size_t:e?e.uSizeT:0,u_size:e?e.uSize:0,u_camera_to_center_distance:u.cameraToCenterDistance,u_pitch:u.pitch/360*2*Math.PI,u_rotate_symbol:+i,u_aspect_ratio:u.width/u.height,u_fade_change:r.options.fadeDuration?r.symbolFadeChange:1,u_matrix:a,u_label_plane_matrix:n,u_coord_matrix:s,u_is_text:+l,u_pitch_with_map:+o,u_texsize:c,u_texture:0}},Vi=function(e,i,o,r,a,n,s,l,c,u,h){var p=a.transform;return t.extend(qi(e,i,o,r,a,n,s,l,c,u),{u_gamma_scale:r?Math.cos(p._pitch)*p.cameraToCenterDistance:1,u_device_pixel_ratio:t.browser.devicePixelRatio,u_is_halo:+h})},Gi=function(e,i,o,r,a,n,s,l,c,u){return t.extend(Vi(e,i,o,r,a,n,s,l,!0,c,!0),{u_texsize_icon:u,u_texture_icon:1})},Wi=function(t,e,i){return {u_matrix:t,u_opacity:e,u_color:i}},Xi=function(e,i,o,r,a,n){return t.extend(function(t,e,i,o){var r=i.imageManager.getPattern(t.from.toString()),a=i.imageManager.getPattern(t.to.toString()),n=i.imageManager.getPixelSize(),s=n.width,l=n.height,c=Math.pow(2,o.tileID.overscaledZ),u=o.tileSize*Math.pow(2,i.transform.tileZoom)/c,h=u*(o.tileID.canonical.x+o.tileID.wrap*c),p=u*o.tileID.canonical.y;return {u_image:0,u_pattern_tl_a:r.tl,u_pattern_br_a:r.br,u_pattern_tl_b:a.tl,u_pattern_br_b:a.br,u_texsize:[s,l],u_mix:e.t,u_pattern_size_a:r.displaySize,u_pattern_size_b:a.displaySize,u_scale_a:e.fromScale,u_scale_b:e.toScale,u_tile_units_to_pixels:1/pe(o,1,i.transform.tileZoom),u_pixel_coord_upper:[h>>16,p>>16],u_pixel_coord_lower:[65535&h,65535&p]}}(r,n,o,a),{u_matrix:e,u_opacity:i})},Hi={fillExtrusion:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient),u_opacity:new t.Uniform1f(e,i.u_opacity)}},fillExtrusionPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient),u_height_factor:new t.Uniform1f(e,i.u_height_factor),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform3f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade),u_opacity:new t.Uniform1f(e,i.u_opacity)}},fill:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},fillPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform3f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},fillOutline:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world)}},fillOutlinePattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform3f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},circle:function(e,i){return {u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_scale_with_map:new t.Uniform1i(e,i.u_scale_with_map),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},collisionBox:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pixels_to_tile_units:new t.Uniform1f(e,i.u_pixels_to_tile_units),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_overscale_factor:new t.Uniform1f(e,i.u_overscale_factor)}},collisionCircle:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_inv_matrix:new t.UniformMatrix4f(e,i.u_inv_matrix),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_viewport_size:new t.Uniform2f(e,i.u_viewport_size)}},debug:function(e,i){return {u_color:new t.UniformColor(e,i.u_color),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_overlay:new t.Uniform1i(e,i.u_overlay),u_overlay_scale:new t.Uniform1f(e,i.u_overlay_scale)}},clippingMask:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmap:function(e,i){return {u_extrude_scale:new t.Uniform1f(e,i.u_extrude_scale),u_intensity:new t.Uniform1f(e,i.u_intensity),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmapTexture:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_color_ramp:new t.Uniform1i(e,i.u_color_ramp),u_opacity:new t.Uniform1f(e,i.u_opacity)}},hillshade:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_latrange:new t.Uniform2f(e,i.u_latrange),u_light:new t.Uniform2f(e,i.u_light),u_shadow:new t.UniformColor(e,i.u_shadow),u_highlight:new t.UniformColor(e,i.u_highlight),u_accent:new t.UniformColor(e,i.u_accent)}},hillshadePrepare:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_dimension:new t.Uniform2f(e,i.u_dimension),u_zoom:new t.Uniform1f(e,i.u_zoom),u_maxzoom:new t.Uniform1f(e,i.u_maxzoom),u_unpack:new t.Uniform4f(e,i.u_unpack)}},line:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels)}},lineGradient:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_image:new t.Uniform1i(e,i.u_image)}},linePattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_texsize:new t.Uniform2f(e,i.u_texsize),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_image:new t.Uniform1i(e,i.u_image),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_scale:new t.Uniform3f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},lineSDF:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_patternscale_a:new t.Uniform2f(e,i.u_patternscale_a),u_patternscale_b:new t.Uniform2f(e,i.u_patternscale_b),u_sdfgamma:new t.Uniform1f(e,i.u_sdfgamma),u_image:new t.Uniform1i(e,i.u_image),u_tex_y_a:new t.Uniform1f(e,i.u_tex_y_a),u_tex_y_b:new t.Uniform1f(e,i.u_tex_y_b),u_mix:new t.Uniform1f(e,i.u_mix)}},raster:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_tl_parent:new t.Uniform2f(e,i.u_tl_parent),u_scale_parent:new t.Uniform1f(e,i.u_scale_parent),u_buffer_scale:new t.Uniform1f(e,i.u_buffer_scale),u_fade_t:new t.Uniform1f(e,i.u_fade_t),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image0:new t.Uniform1i(e,i.u_image0),u_image1:new t.Uniform1i(e,i.u_image1),u_brightness_low:new t.Uniform1f(e,i.u_brightness_low),u_brightness_high:new t.Uniform1f(e,i.u_brightness_high),u_saturation_factor:new t.Uniform1f(e,i.u_saturation_factor),u_contrast_factor:new t.Uniform1f(e,i.u_contrast_factor),u_spin_weights:new t.Uniform3f(e,i.u_spin_weights)}},symbolIcon:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1i(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture)}},symbolSDF:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1i(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture),u_gamma_scale:new t.Uniform1f(e,i.u_gamma_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_is_halo:new t.Uniform1i(e,i.u_is_halo)}},symbolTextAndIcon:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1i(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texsize_icon:new t.Uniform2f(e,i.u_texsize_icon),u_texture:new t.Uniform1i(e,i.u_texture),u_texture_icon:new t.Uniform1i(e,i.u_texture_icon),u_gamma_scale:new t.Uniform1f(e,i.u_gamma_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_is_halo:new t.Uniform1i(e,i.u_is_halo)}},background:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_color:new t.UniformColor(e,i.u_color)}},backgroundPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image:new t.Uniform1i(e,i.u_image),u_pattern_tl_a:new t.Uniform2f(e,i.u_pattern_tl_a),u_pattern_br_a:new t.Uniform2f(e,i.u_pattern_br_a),u_pattern_tl_b:new t.Uniform2f(e,i.u_pattern_tl_b),u_pattern_br_b:new t.Uniform2f(e,i.u_pattern_br_b),u_texsize:new t.Uniform2f(e,i.u_texsize),u_mix:new t.Uniform1f(e,i.u_mix),u_pattern_size_a:new t.Uniform2f(e,i.u_pattern_size_a),u_pattern_size_b:new t.Uniform2f(e,i.u_pattern_size_b),u_scale_a:new t.Uniform1f(e,i.u_scale_a),u_scale_b:new t.Uniform1f(e,i.u_scale_b),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_tile_units_to_pixels:new t.Uniform1f(e,i.u_tile_units_to_pixels)}}};function Ki(e,i,o,r,a,n,s){for(var l=e.context,c=l.gl,u=e.useProgram("collisionBox"),h=[],p=0,d=0,_=0;_<r.length;_++){var f=r[_],m=i.getTile(f),g=m.getBucket(o);if(g){var v=f.posMatrix;0===a[0]&&0===a[1]||(v=e.translatePosMatrix(f.posMatrix,m,a,n));var y=s?g.textCollisionBox:g.iconCollisionBox,x=g.collisionCircleArray;if(x.length>0){var b=t.create(),w=v;t.mul(b,g.placementInvProjMatrix,e.transform.glCoordMatrix),t.mul(b,b,g.placementViewportMatrix),h.push({circleArray:x,circleOffset:d,transform:w,invTransform:b}),d=p+=x.length/4;}y&&u.draw(l,c.LINES,It.disabled,Pt.disabled,e.colorModeForRenderPass(),Ct.disabled,zi(v,e.transform,m),o.id,y.layoutVertexBuffer,y.indexBuffer,y.segments,null,e.transform.zoom,null,null,y.collisionVertexBuffer);}}if(s&&h.length){var T=e.useProgram("collisionCircle"),E=new t.StructArrayLayout2f1f2i16;E.resize(4*p),E._trim();for(var I=0,P=0,S=h;P<S.length;P+=1)for(var C=S[P],z=0;z<C.circleArray.length/4;z++){var D=4*z,M=C.circleArray[D+0],L=C.circleArray[D+1],A=C.circleArray[D+2],R=C.circleArray[D+3];E.emplace(I++,M,L,A,R,0),E.emplace(I++,M,L,A,R,1),E.emplace(I++,M,L,A,R,2),E.emplace(I++,M,L,A,R,3);}(!ji||ji.length<2*p)&&(ji=function(e){var i=2*e,o=new t.StructArrayLayout3ui6;o.resize(i),o._trim();for(var r=0;r<i;r++){var a=6*r;o.uint16[a+0]=4*r+0,o.uint16[a+1]=4*r+1,o.uint16[a+2]=4*r+2,o.uint16[a+3]=4*r+2,o.uint16[a+4]=4*r+3,o.uint16[a+5]=4*r+0;}return o}(p));for(var k=l.createIndexBuffer(ji,!0),B=l.createVertexBuffer(E,t.collisionCircleLayout.members,!0),O=0,F=h;O<F.length;O+=1){var U=F[O],N=Di(U.transform,U.invTransform,e.transform);T.draw(l,c.TRIANGLES,It.disabled,Pt.disabled,e.colorModeForRenderPass(),Ct.disabled,N,o.id,B,k,t.SegmentVector.simpleSegment(0,2*U.circleOffset,U.circleArray.length,U.circleArray.length/2),null,e.transform.zoom,null,null,null);}B.destroy(),k.destroy();}}var Yi=t.identity(new Float32Array(16));function Ji(e,i,o,r,a,n){var s=t.getAnchorAlignment(e),l=-(s.horizontalAlign-.5)*i,c=-(s.verticalAlign-.5)*o,u=t.evaluateVariableOffset(e,r);return new t.Point((l/a+u[0])*n,(c/a+u[1])*n)}function Qi(e,i,o,r,a,n,s,l,c,u,h){var p=e.text.placedSymbolArray,d=e.text.dynamicLayoutVertexArray,_=e.icon.dynamicLayoutVertexArray,f={};d.clear();for(var m=0;m<p.length;m++){var g=p.get(m),v=g.hidden||!g.crossTileID||e.allowVerticalPlacement&&!g.placedOrientation?null:r[g.crossTileID];if(v){var y=new t.Point(g.anchorX,g.anchorY),x=$t(y,o?l:s),b=te(n.cameraToCenterDistance,x.signedDistanceFromCamera),w=a.evaluateSizeForFeature(e.textSizeData,u,g)*b/t.ONE_EM;o&&(w*=e.tilePixelRatio/c);for(var T=Ji(v.anchor,v.width,v.height,v.textOffset,v.textBoxScale,w),E=o?$t(y.add(T),s).point:x.point.add(i?T.rotate(-n.angle):T),I=e.allowVerticalPlacement&&g.placedOrientation===t.WritingMode.vertical?Math.PI/2:0,P=0;P<g.numGlyphs;P++)t.addDynamicAttributes(d,E,I);h&&g.associatedIconIndex>=0&&(f[g.associatedIconIndex]={shiftedAnchor:E,angle:I});}else ce(g.numGlyphs,d);}if(h){_.clear();for(var S=e.icon.placedSymbolArray,C=0;C<S.length;C++){var z=S.get(C);if(z.hidden)ce(z.numGlyphs,_);else {var D=f[C];if(D)for(var M=0;M<z.numGlyphs;M++)t.addDynamicAttributes(_,D.shiftedAnchor,D.angle);else ce(z.numGlyphs,_);}}e.icon.dynamicLayoutVertexBuffer.updateData(_);}e.text.dynamicLayoutVertexBuffer.updateData(d);}function $i(t,e,i){return i.iconsInText&&e?"symbolTextAndIcon":t?"symbolSDF":"symbolIcon"}function to(e,i,o,r,a,n,s,l,c,u,h,p){for(var d=e.context,_=d.gl,f=e.transform,m="map"===l,g="map"===c,v=m&&"point"!==o.layout.get("symbol-placement"),y=m&&!g&&!v,x=void 0!==o.layout.get("symbol-sort-key").constantOr(1),b=e.depthModeForSublayer(0,It.ReadOnly),w=o.layout.get("text-variable-anchor"),T=[],E=0,I=r;E<I.length;E+=1){var P=I[E],S=i.getTile(P),C=S.getBucket(o);if(C){var z=a?C.text:C.icon;if(z&&z.segments.get().length){var D=z.programConfigurations.get(o.id),M=a||C.sdfIcons,L=a?C.textSizeData:C.iconSizeData,A=g||0!==f.pitch,R=e.useProgram($i(M,a,C),D),k=t.evaluateSizeForZoom(L,f.zoom),B=void 0,O=[0,0],F=void 0,U=void 0,N=null,Z=void 0;if(a)F=S.glyphAtlasTexture,U=_.LINEAR,B=S.glyphAtlasTexture.size,C.iconsInText&&(O=S.imageAtlasTexture.size,N=S.imageAtlasTexture,Z=A||e.options.rotating||e.options.zooming||"composite"===L.kind||"camera"===L.kind?_.LINEAR:_.NEAREST);else {var j=1!==o.layout.get("icon-size").constantOr(0)||C.iconsNeedLinear;F=S.imageAtlasTexture,U=M||e.options.rotating||e.options.zooming||j||A?_.LINEAR:_.NEAREST,B=S.imageAtlasTexture.size;}var q=pe(S,1,e.transform.zoom),V=Jt(P.posMatrix,g,m,e.transform,q),G=Qt(P.posMatrix,g,m,e.transform,q),W=w&&C.hasTextData(),X="none"!==o.layout.get("icon-text-fit")&&W&&C.hasIconData();v&&ie(C,P.posMatrix,e,a,V,G,g,u);var H=e.translatePosMatrix(P.posMatrix,S,n,s),K=v||a&&w||X?Yi:V,Y=e.translatePosMatrix(G,S,n,s,!0),J=M&&0!==o.paint.get(a?"text-halo-width":"icon-halo-width").constantOr(1),Q={program:R,buffers:z,uniformValues:M?C.iconsInText?Gi(L.kind,k,y,g,e,H,K,Y,B,O):Vi(L.kind,k,y,g,e,H,K,Y,a,B,!0):qi(L.kind,k,y,g,e,H,K,Y,a,B),atlasTexture:F,atlasTextureIcon:N,atlasInterpolation:U,atlasInterpolationIcon:Z,isSDF:M,hasHalo:J};if(x)for(var $=0,tt=z.segments.get();$<tt.length;$+=1){var et=tt[$];T.push({segments:new t.SegmentVector([et]),sortKey:et.sortKey,state:Q});}else T.push({segments:z.segments,sortKey:0,state:Q});}}}x&&T.sort((function(t,e){return t.sortKey-e.sortKey}));for(var it=0,ot=T;it<ot.length;it+=1){var rt=ot[it],at=rt.state;if(d.activeTexture.set(_.TEXTURE0),at.atlasTexture.bind(at.atlasInterpolation,_.CLAMP_TO_EDGE),at.atlasTextureIcon&&(d.activeTexture.set(_.TEXTURE1),at.atlasTextureIcon&&at.atlasTextureIcon.bind(at.atlasInterpolationIcon,_.CLAMP_TO_EDGE)),at.isSDF){var nt=at.uniformValues;at.hasHalo&&(nt.u_is_halo=1,eo(at.buffers,rt.segments,o,e,at.program,b,h,p,nt)),nt.u_is_halo=0;}eo(at.buffers,rt.segments,o,e,at.program,b,h,p,at.uniformValues);}}function eo(t,e,i,o,r,a,n,s,l){var c=o.context;r.draw(c,c.gl.TRIANGLES,a,n,s,Ct.disabled,l,i.id,t.layoutVertexBuffer,t.indexBuffer,e,i.paint,o.transform.zoom,t.programConfigurations.get(i.id),t.dynamicLayoutVertexBuffer,t.opacityVertexBuffer);}function io(t,e,i,o,r,a,n){var s,l,c,u,h,p=t.context.gl,d=i.paint.get("fill-pattern"),_=d&&d.constantOr(1),f=i.getCrossfadeParameters();n?(l=_&&!i.getPaintProperty("fill-outline-color")?"fillOutlinePattern":"fillOutline",s=p.LINES):(l=_?"fillPattern":"fill",s=p.TRIANGLES);for(var m=0,g=o;m<g.length;m+=1){var v=g[m],y=e.getTile(v);if(!_||y.patternsLoaded()){var x=y.getBucket(i);if(x){var b=x.programConfigurations.get(i.id),w=t.useProgram(l,b);_&&(t.context.activeTexture.set(p.TEXTURE0),y.imageAtlasTexture.bind(p.LINEAR,p.CLAMP_TO_EDGE),b.updatePaintBuffers(f));var T=d.constantOr(null);if(T&&y.imageAtlas){var E=y.imageAtlas,I=E.patternPositions[T.to.toString()],P=E.patternPositions[T.from.toString()];I&&P&&b.setConstantPatternPositions(I,P);}var S=t.translatePosMatrix(v.posMatrix,y,i.paint.get("fill-translate"),i.paint.get("fill-translate-anchor"));if(n){u=x.indexBuffer2,h=x.segments2;var C=[p.drawingBufferWidth,p.drawingBufferHeight];c="fillOutlinePattern"===l&&_?Si(S,t,f,y,C):Pi(S,C);}else u=x.indexBuffer,h=x.segments,c=_?Ii(S,t,f,y):Ei(S);w.draw(t.context,s,r,t.stencilModeForClipping(v),a,Ct.disabled,c,i.id,x.layoutVertexBuffer,u,h,i.paint,t.transform.zoom,b);}}}}function oo(t,e,i,o,r,a,n){for(var s=t.context,l=s.gl,c=i.paint.get("fill-extrusion-pattern"),u=c.constantOr(1),h=i.getCrossfadeParameters(),p=i.paint.get("fill-extrusion-opacity"),d=0,_=o;d<_.length;d+=1){var f=_[d],m=e.getTile(f),g=m.getBucket(i);if(g){var v=g.programConfigurations.get(i.id),y=t.useProgram(u?"fillExtrusionPattern":"fillExtrusion",v);u&&(t.context.activeTexture.set(l.TEXTURE0),m.imageAtlasTexture.bind(l.LINEAR,l.CLAMP_TO_EDGE),v.updatePaintBuffers(h));var x=c.constantOr(null);if(x&&m.imageAtlas){var b=m.imageAtlas,w=b.patternPositions[x.to.toString()],T=b.patternPositions[x.from.toString()];w&&T&&v.setConstantPatternPositions(w,T);}var E=t.translatePosMatrix(f.posMatrix,m,i.paint.get("fill-extrusion-translate"),i.paint.get("fill-extrusion-translate-anchor")),I=i.paint.get("fill-extrusion-vertical-gradient"),P=u?Ti(E,t,I,p,f,h,m):wi(E,t,I,p);y.draw(s,s.gl.TRIANGLES,r,a,n,Ct.backCCW,P,i.id,g.layoutVertexBuffer,g.indexBuffer,g.segments,i.paint,t.transform.zoom,v);}}}function ro(e,i,o,r,a,n){var s=e.context,l=s.gl,c=i.fbo;if(c){var u=e.useProgram("hillshade");s.activeTexture.set(l.TEXTURE0),l.bindTexture(l.TEXTURE_2D,c.colorAttachment.get());var h=function(e,i,o){var r=o.paint.get("hillshade-shadow-color"),a=o.paint.get("hillshade-highlight-color"),n=o.paint.get("hillshade-accent-color"),s=o.paint.get("hillshade-illumination-direction")*(Math.PI/180);"viewport"===o.paint.get("hillshade-illumination-anchor")&&(s-=e.transform.angle);var l,c,u,h=!e.options.moving;return {u_matrix:e.transform.calculatePosMatrix(i.tileID.toUnwrapped(),h),u_image:0,u_latrange:(l=i.tileID,c=Math.pow(2,l.canonical.z),u=l.canonical.y,[new t.MercatorCoordinate(0,u/c).toLngLat().lat,new t.MercatorCoordinate(0,(u+1)/c).toLngLat().lat]),u_light:[o.paint.get("hillshade-exaggeration"),s],u_shadow:r,u_highlight:a,u_accent:n}}(e,i,o);u.draw(s,l.TRIANGLES,r,a,n,Ct.disabled,h,o.id,e.rasterBoundsBuffer,e.quadTriangleIndexBuffer,e.rasterBoundsSegments);}}function ao(e,i,o,r,a,n,s){var l=e.context,c=l.gl,u=i.dem;if(u&&u.data){var h=u.dim,p=u.stride,d=u.getPixels();if(l.activeTexture.set(c.TEXTURE1),l.pixelStoreUnpackPremultiplyAlpha.set(!1),i.demTexture=i.demTexture||e.getTileTexture(p),i.demTexture){var _=i.demTexture;_.update(d,{premultiply:!1}),_.bind(c.NEAREST,c.CLAMP_TO_EDGE);}else i.demTexture=new t.Texture(l,d,c.RGBA,{premultiply:!1}),i.demTexture.bind(c.NEAREST,c.CLAMP_TO_EDGE);l.activeTexture.set(c.TEXTURE0);var f=i.fbo;if(!f){var m=new t.Texture(l,{width:h,height:h,data:null},c.RGBA);m.bind(c.LINEAR,c.CLAMP_TO_EDGE),(f=i.fbo=l.createFramebuffer(h,h,!0)).colorAttachment.set(m.texture);}l.bindFramebuffer.set(f.framebuffer),l.viewport.set([0,0,h,h]),e.useProgram("hillshadePrepare").draw(l,c.TRIANGLES,a,n,s,Ct.disabled,function(e,i,o){var r=i.stride,a=t.create();return t.ortho(a,0,t.EXTENT,-t.EXTENT,0,0,1),t.translate(a,a,[0,-t.EXTENT,0]),{u_matrix:a,u_image:1,u_dimension:[r,r],u_zoom:e.overscaledZ,u_maxzoom:o,u_unpack:i.getUnpackVector()}}(i.tileID,u,r),o.id,e.rasterBoundsBuffer,e.quadTriangleIndexBuffer,e.rasterBoundsSegments),i.needsHillshadePrepare=!1;}}function no(e,i,o,r,a){var n=r.paint.get("raster-fade-duration");if(n>0){var s=t.browser.now(),l=(s-e.timeAdded)/n,c=i?(s-i.timeAdded)/n:-1,u=o.getSource(),h=a.coveringZoomLevel({tileSize:u.tileSize,roundZoom:u.roundZoom}),p=!i||Math.abs(i.tileID.overscaledZ-h)>Math.abs(e.tileID.overscaledZ-h),d=p&&e.refreshedUponExpiration?1:t.clamp(p?l:1-c,0,1);return e.refreshedUponExpiration&&l>=1&&(e.refreshedUponExpiration=!1),i?{opacity:1,mix:1-d}:{opacity:d,mix:0}}return {opacity:1,mix:0}}var so=new t.Color(1,0,0,1),lo=new t.Color(0,1,0,1),co=new t.Color(0,0,1,1),uo=new t.Color(1,0,1,1),ho=new t.Color(0,1,1,1);function po(t,e,i,o){fo(t,0,e+i/2,t.transform.width,i,o);}function _o(t,e,i,o){fo(t,e-i/2,0,i,t.transform.height,o);}function fo(e,i,o,r,a,n){var s=e.context,l=s.gl;l.enable(l.SCISSOR_TEST),l.scissor(i*t.browser.devicePixelRatio,o*t.browser.devicePixelRatio,r*t.browser.devicePixelRatio,a*t.browser.devicePixelRatio),s.clear({color:n}),l.disable(l.SCISSOR_TEST);}function mo(e,i,o){var r=e.context,a=r.gl,n=o.posMatrix,s=e.useProgram("debug"),l=It.disabled,c=Pt.disabled,u=e.colorModeForRenderPass();r.activeTexture.set(a.TEXTURE0),e.emptyTexture.bind(a.LINEAR,a.CLAMP_TO_EDGE),s.draw(r,a.LINE_STRIP,l,c,u,Ct.disabled,Mi(n,t.Color.red),"$debug",e.debugBuffer,e.tileBorderIndexBuffer,e.debugSegments);var h=i.getTileByID(o.key).latestRawTileData,p=Math.floor((h&&h.byteLength||0)/1024),d=i.getTile(o).tileSize,_=512/Math.min(d,512)*(o.overscaledZ/e.transform.zoom)*.5,f=o.canonical.toString();o.overscaledZ!==o.canonical.z&&(f+=" => "+o.overscaledZ),function(t,e){t.initDebugOverlayCanvas();var i=t.debugOverlayCanvas,o=t.context.gl,r=t.debugOverlayCanvas.getContext("2d");r.clearRect(0,0,i.width,i.height),r.shadowColor="white",r.shadowBlur=2,r.lineWidth=1.5,r.strokeStyle="white",r.textBaseline="top",r.font="bold 36px Open Sans, sans-serif",r.fillText(e,5,5),r.strokeText(e,5,5),t.debugOverlayTexture.update(i),t.debugOverlayTexture.bind(o.LINEAR,o.CLAMP_TO_EDGE);}(e,f+" "+p+"kb"),s.draw(r,a.TRIANGLES,l,c,St.alphaBlended,Ct.disabled,Mi(n,t.Color.transparent,_),"$debug",e.debugBuffer,e.quadTriangleIndexBuffer,e.debugSegments);}var go={symbol:function(e,i,o,r,a){if("translucent"===e.renderPass){var n=Pt.disabled,s=e.colorModeForRenderPass();o.layout.get("text-variable-anchor")&&function(e,i,o,r,a,n,s){for(var l=i.transform,c="map"===a,u="map"===n,h=0,p=e;h<p.length;h+=1){var d=p[h],_=r.getTile(d),f=_.getBucket(o);if(f&&f.text&&f.text.segments.get().length){var m=t.evaluateSizeForZoom(f.textSizeData,l.zoom),g=pe(_,1,i.transform.zoom),v=Jt(d.posMatrix,u,c,i.transform,g),y="none"!==o.layout.get("icon-text-fit")&&f.hasIconData();if(m){var x=Math.pow(2,l.zoom-_.tileID.overscaledZ);Qi(f,c,u,s,t.symbolSize,l,v,d.posMatrix,x,m,y);}}}}(r,e,o,i,o.layout.get("text-rotation-alignment"),o.layout.get("text-pitch-alignment"),a),0!==o.paint.get("icon-opacity").constantOr(1)&&to(e,i,o,r,!1,o.paint.get("icon-translate"),o.paint.get("icon-translate-anchor"),o.layout.get("icon-rotation-alignment"),o.layout.get("icon-pitch-alignment"),o.layout.get("icon-keep-upright"),n,s),0!==o.paint.get("text-opacity").constantOr(1)&&to(e,i,o,r,!0,o.paint.get("text-translate"),o.paint.get("text-translate-anchor"),o.layout.get("text-rotation-alignment"),o.layout.get("text-pitch-alignment"),o.layout.get("text-keep-upright"),n,s),i.map.showCollisionBoxes&&(Ki(e,i,o,r,o.paint.get("text-translate"),o.paint.get("text-translate-anchor"),!0),Ki(e,i,o,r,o.paint.get("icon-translate"),o.paint.get("icon-translate-anchor"),!1));}},circle:function(e,i,o,r){if("translucent"===e.renderPass){var a=o.paint.get("circle-opacity"),n=o.paint.get("circle-stroke-width"),s=o.paint.get("circle-stroke-opacity"),l=void 0!==o.layout.get("circle-sort-key").constantOr(1);if(0!==a.constantOr(1)||0!==n.constantOr(1)&&0!==s.constantOr(1)){for(var c=e.context,u=c.gl,h=e.depthModeForSublayer(0,It.ReadOnly),p=Pt.disabled,d=e.colorModeForRenderPass(),_=[],f=0;f<r.length;f++){var m=r[f],g=i.getTile(m),v=g.getBucket(o);if(v){var y=v.programConfigurations.get(o.id),x={programConfiguration:y,program:e.useProgram("circle",y),layoutVertexBuffer:v.layoutVertexBuffer,indexBuffer:v.indexBuffer,uniformValues:Ci(e,m,g,o)};if(l)for(var b=0,w=v.segments.get();b<w.length;b+=1){var T=w[b];_.push({segments:new t.SegmentVector([T]),sortKey:T.sortKey,state:x});}else _.push({segments:v.segments,sortKey:0,state:x});}}l&&_.sort((function(t,e){return t.sortKey-e.sortKey}));for(var E=0,I=_;E<I.length;E+=1){var P=I[E],S=P.state;S.program.draw(c,u.TRIANGLES,h,p,d,Ct.disabled,S.uniformValues,o.id,S.layoutVertexBuffer,S.indexBuffer,P.segments,o.paint,e.transform.zoom,S.programConfiguration);}}}},heatmap:function(e,i,o,r){if(0!==o.paint.get("heatmap-opacity"))if("offscreen"===e.renderPass){var a=e.context,n=a.gl,s=Pt.disabled,l=new St([n.ONE,n.ONE],t.Color.transparent,[!0,!0,!0,!0]);!function(t,e,i){var o=t.gl;t.activeTexture.set(o.TEXTURE1),t.viewport.set([0,0,e.width/4,e.height/4]);var r=i.heatmapFbo;if(r)o.bindTexture(o.TEXTURE_2D,r.colorAttachment.get()),t.bindFramebuffer.set(r.framebuffer);else {var a=o.createTexture();o.bindTexture(o.TEXTURE_2D,a),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_S,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_T,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MIN_FILTER,o.LINEAR),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MAG_FILTER,o.LINEAR),r=i.heatmapFbo=t.createFramebuffer(e.width/4,e.height/4,!1),function(t,e,i,o){var r=t.gl;r.texImage2D(r.TEXTURE_2D,0,r.RGBA,e.width/4,e.height/4,0,r.RGBA,t.extRenderToTextureHalfFloat?t.extTextureHalfFloat.HALF_FLOAT_OES:r.UNSIGNED_BYTE,null),o.colorAttachment.set(i);}(t,e,a,r);}}(a,e,o),a.clear({color:t.Color.transparent});for(var c=0;c<r.length;c++){var u=r[c];if(!i.hasRenderableParent(u)){var h=i.getTile(u),p=h.getBucket(o);if(p){var d=p.programConfigurations.get(o.id);e.useProgram("heatmap",d).draw(a,n.TRIANGLES,It.disabled,s,l,Ct.disabled,Ai(u.posMatrix,h,e.transform.zoom,o.paint.get("heatmap-intensity")),o.id,p.layoutVertexBuffer,p.indexBuffer,p.segments,o.paint,e.transform.zoom,d);}}}a.viewport.set([0,0,e.width,e.height]);}else "translucent"===e.renderPass&&(e.context.setColorMode(e.colorModeForRenderPass()),function(e,i){var o=e.context,r=o.gl,a=i.heatmapFbo;if(a){o.activeTexture.set(r.TEXTURE0),r.bindTexture(r.TEXTURE_2D,a.colorAttachment.get()),o.activeTexture.set(r.TEXTURE1);var n=i.colorRampTexture;n||(n=i.colorRampTexture=new t.Texture(o,i.colorRamp,r.RGBA)),n.bind(r.LINEAR,r.CLAMP_TO_EDGE),e.useProgram("heatmapTexture").draw(o,r.TRIANGLES,It.disabled,Pt.disabled,e.colorModeForRenderPass(),Ct.disabled,function(e,i,o,r){var a=t.create();t.ortho(a,0,e.width,e.height,0,0,1);var n=e.context.gl;return {u_matrix:a,u_world:[n.drawingBufferWidth,n.drawingBufferHeight],u_image:0,u_color_ramp:1,u_opacity:i.paint.get("heatmap-opacity")}}(e,i),i.id,e.viewportBuffer,e.quadTriangleIndexBuffer,e.viewportSegments,i.paint,e.transform.zoom);}}(e,o));},line:function(e,i,o,r){if("translucent"===e.renderPass){var a=o.paint.get("line-opacity"),n=o.paint.get("line-width");if(0!==a.constantOr(1)&&0!==n.constantOr(1)){var s=e.depthModeForSublayer(0,It.ReadOnly),l=e.colorModeForRenderPass(),c=o.paint.get("line-dasharray"),u=o.paint.get("line-pattern"),h=u.constantOr(1),p=o.paint.get("line-gradient"),d=o.getCrossfadeParameters(),_=h?"linePattern":c?"lineSDF":p?"lineGradient":"line",f=e.context,m=f.gl,g=!0;if(p){f.activeTexture.set(m.TEXTURE0);var v=o.gradientTexture;if(!o.gradient)return;v||(v=o.gradientTexture=new t.Texture(f,o.gradient,m.RGBA)),v.bind(m.LINEAR,m.CLAMP_TO_EDGE);}for(var y=0,x=r;y<x.length;y+=1){var b=x[y],w=i.getTile(b);if(!h||w.patternsLoaded()){var T=w.getBucket(o);if(T){var E=T.programConfigurations.get(o.id),I=e.context.program.get(),P=e.useProgram(_,E),S=g||P.program!==I,C=u.constantOr(null);if(C&&w.imageAtlas){var z=w.imageAtlas,D=z.patternPositions[C.to.toString()],M=z.patternPositions[C.from.toString()];D&&M&&E.setConstantPatternPositions(D,M);}var L=h?Bi(e,w,o,d):c?Oi(e,w,o,c,d):p?ki(e,w,o):Ri(e,w,o);h?(f.activeTexture.set(m.TEXTURE0),w.imageAtlasTexture.bind(m.LINEAR,m.CLAMP_TO_EDGE),E.updatePaintBuffers(d)):c&&(S||e.lineAtlas.dirty)&&(f.activeTexture.set(m.TEXTURE0),e.lineAtlas.bind(f)),P.draw(f,m.TRIANGLES,s,e.stencilModeForClipping(b),l,Ct.disabled,L,o.id,T.layoutVertexBuffer,T.indexBuffer,T.segments,o.paint,e.transform.zoom,E),g=!1;}}}}}},fill:function(e,i,o,r){var a=o.paint.get("fill-color"),n=o.paint.get("fill-opacity");if(0!==n.constantOr(1)){var s=e.colorModeForRenderPass(),l=o.paint.get("fill-pattern"),c=e.opaquePassEnabledForLayer()&&!l.constantOr(1)&&1===a.constantOr(t.Color.transparent).a&&1===n.constantOr(0)?"opaque":"translucent";if(e.renderPass===c){var u=e.depthModeForSublayer(1,"opaque"===e.renderPass?It.ReadWrite:It.ReadOnly);io(e,i,o,r,u,s,!1);}if("translucent"===e.renderPass&&o.paint.get("fill-antialias")){var h=e.depthModeForSublayer(o.getPaintProperty("fill-outline-color")?2:0,It.ReadOnly);io(e,i,o,r,h,s,!0);}}},"fill-extrusion":function(t,e,i,o){var r=i.paint.get("fill-extrusion-opacity");if(0!==r&&"translucent"===t.renderPass){var a=new It(t.context.gl.LEQUAL,It.ReadWrite,t.depthRangeFor3D);if(1!==r||i.paint.get("fill-extrusion-pattern").constantOr(1))oo(t,e,i,o,a,Pt.disabled,St.disabled),oo(t,e,i,o,a,t.stencilModeFor3D(),t.colorModeForRenderPass());else {var n=t.colorModeForRenderPass();oo(t,e,i,o,a,Pt.disabled,n);}}},hillshade:function(t,e,i,o){if("offscreen"===t.renderPass||"translucent"===t.renderPass){for(var r=t.context,a=e.getSource().maxzoom,n=t.depthModeForSublayer(0,It.ReadOnly),s=t.colorModeForRenderPass(),l="translucent"===t.renderPass?t.stencilConfigForOverlap(o):[{},o],c=l[0],u=0,h=l[1];u<h.length;u+=1){var p=h[u],d=e.getTile(p);d.needsHillshadePrepare&&"offscreen"===t.renderPass?ao(t,d,i,a,n,Pt.disabled,s):"translucent"===t.renderPass&&ro(t,d,i,n,c[p.overscaledZ],s);}r.viewport.set([0,0,t.width,t.height]);}},raster:function(t,e,i,o){if("translucent"===t.renderPass&&0!==i.paint.get("raster-opacity")&&o.length)for(var r=t.context,a=r.gl,n=e.getSource(),s=t.useProgram("raster"),l=t.colorModeForRenderPass(),c=n instanceof L?[{},o]:t.stencilConfigForOverlap(o),u=c[0],h=c[1],p=h[h.length-1].overscaledZ,d=!t.options.moving,_=0,f=h;_<f.length;_+=1){var m=f[_],g=t.depthModeForSublayer(m.overscaledZ-p,1===i.paint.get("raster-opacity")?It.ReadWrite:It.ReadOnly,a.LESS),v=e.getTile(m),y=t.transform.calculatePosMatrix(m.toUnwrapped(),d);v.registerFadeDuration(i.paint.get("raster-fade-duration"));var x=e.findLoadedParent(m,0),b=no(v,x,e,i,t.transform),w=void 0,T=void 0,E="nearest"===i.paint.get("raster-resampling")?a.NEAREST:a.LINEAR;r.activeTexture.set(a.TEXTURE0),v.texture.bind(E,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),r.activeTexture.set(a.TEXTURE1),x?(x.texture.bind(E,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),w=Math.pow(2,x.tileID.overscaledZ-v.tileID.overscaledZ),T=[v.tileID.canonical.x*w%1,v.tileID.canonical.y*w%1]):v.texture.bind(E,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST);var I=Ni(y,T||[0,0],w||1,b,i);n instanceof L?s.draw(r,a.TRIANGLES,g,Pt.disabled,l,Ct.disabled,I,i.id,n.boundsBuffer,t.quadTriangleIndexBuffer,n.boundsSegments):s.draw(r,a.TRIANGLES,g,u[m.overscaledZ],l,Ct.disabled,I,i.id,t.rasterBoundsBuffer,t.quadTriangleIndexBuffer,t.rasterBoundsSegments);}},background:function(t,e,i){var o=i.paint.get("background-color"),r=i.paint.get("background-opacity");if(0!==r){var a=t.context,n=a.gl,s=t.transform,l=s.tileSize,c=i.paint.get("background-pattern");if(!t.isPatternMissing(c)){var u=!c&&1===o.a&&1===r&&t.opaquePassEnabledForLayer()?"opaque":"translucent";if(t.renderPass===u){var h=Pt.disabled,p=t.depthModeForSublayer(0,"opaque"===u?It.ReadWrite:It.ReadOnly),d=t.colorModeForRenderPass(),_=t.useProgram(c?"backgroundPattern":"background"),f=s.coveringTiles({tileSize:l});c&&(a.activeTexture.set(n.TEXTURE0),t.imageManager.bind(t.context));for(var m=i.getCrossfadeParameters(),g=0,v=f;g<v.length;g+=1){var y=v[g],x=t.transform.calculatePosMatrix(y.toUnwrapped()),b=c?Xi(x,r,t,c,{tileID:y,tileSize:l},m):Wi(x,r,o);_.draw(a,n.TRIANGLES,p,h,d,Ct.disabled,b,i.id,t.tileExtentBuffer,t.quadTriangleIndexBuffer,t.tileExtentSegments);}}}}},debug:function(t,e,i){for(var o=0;o<i.length;o++)mo(t,e,i[o]);},custom:function(t,e,i){var o=t.context,r=i.implementation;if("offscreen"===t.renderPass){var a=r.prerender;a&&(t.setCustomLayerDefaults(),o.setColorMode(t.colorModeForRenderPass()),a.call(r,o.gl,t.transform.customLayerMatrix()),o.setDirty(),t.setBaseState());}else if("translucent"===t.renderPass){t.setCustomLayerDefaults(),o.setColorMode(t.colorModeForRenderPass()),o.setStencilMode(Pt.disabled);var n="3d"===r.renderingMode?new It(t.context.gl.LEQUAL,It.ReadWrite,t.depthRangeFor3D):t.depthModeForSublayer(0,It.ReadOnly);o.setDepthMode(n),r.render(o.gl,t.transform.customLayerMatrix()),o.setDirty(),t.setBaseState(),o.bindFramebuffer.set(null);}}},vo=function(t,e){this.context=new zt(t),this.transform=e,this._tileTextures={},this.setup(),this.numSublayers=Dt.maxUnderzooming+Dt.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.crossTileSymbolIndex=new Fe,this.gpuTimers={};};vo.prototype.resize=function(e,i){if(this.width=e*t.browser.devicePixelRatio,this.height=i*t.browser.devicePixelRatio,this.context.viewport.set([0,0,this.width,this.height]),this.style)for(var o=0,r=this.style._order;o<r.length;o+=1)this.style._layers[r[o]].resize();},vo.prototype.setup=function(){var e=this.context,i=new t.StructArrayLayout2i4;i.emplaceBack(0,0),i.emplaceBack(t.EXTENT,0),i.emplaceBack(0,t.EXTENT),i.emplaceBack(t.EXTENT,t.EXTENT),this.tileExtentBuffer=e.createVertexBuffer(i,Ve.members),this.tileExtentSegments=t.SegmentVector.simpleSegment(0,0,4,2);var o=new t.StructArrayLayout2i4;o.emplaceBack(0,0),o.emplaceBack(t.EXTENT,0),o.emplaceBack(0,t.EXTENT),o.emplaceBack(t.EXTENT,t.EXTENT),this.debugBuffer=e.createVertexBuffer(o,Ve.members),this.debugSegments=t.SegmentVector.simpleSegment(0,0,4,5);var r=new t.StructArrayLayout4i8;r.emplaceBack(0,0,0,0),r.emplaceBack(t.EXTENT,0,t.EXTENT,0),r.emplaceBack(0,t.EXTENT,0,t.EXTENT),r.emplaceBack(t.EXTENT,t.EXTENT,t.EXTENT,t.EXTENT),this.rasterBoundsBuffer=e.createVertexBuffer(r,M.members),this.rasterBoundsSegments=t.SegmentVector.simpleSegment(0,0,4,2);var a=new t.StructArrayLayout2i4;a.emplaceBack(0,0),a.emplaceBack(1,0),a.emplaceBack(0,1),a.emplaceBack(1,1),this.viewportBuffer=e.createVertexBuffer(a,Ve.members),this.viewportSegments=t.SegmentVector.simpleSegment(0,0,4,2);var n=new t.StructArrayLayout1ui2;n.emplaceBack(0),n.emplaceBack(1),n.emplaceBack(3),n.emplaceBack(2),n.emplaceBack(0),this.tileBorderIndexBuffer=e.createIndexBuffer(n);var s=new t.StructArrayLayout3ui6;s.emplaceBack(0,1,2),s.emplaceBack(2,1,3),this.quadTriangleIndexBuffer=e.createIndexBuffer(s),this.emptyTexture=new t.Texture(e,{width:1,height:1,data:new Uint8Array([0,0,0,0])},e.gl.RGBA);var l=this.context.gl;this.stencilClearMode=new Pt({func:l.ALWAYS,mask:0},0,255,l.ZERO,l.ZERO,l.ZERO);},vo.prototype.clearStencil=function(){var e=this.context,i=e.gl;this.nextStencilID=1,this.currentStencilSource=void 0;var o=t.create();t.ortho(o,0,this.width,this.height,0,0,1),t.scale(o,o,[i.drawingBufferWidth,i.drawingBufferHeight,0]),this.useProgram("clippingMask").draw(e,i.TRIANGLES,It.disabled,this.stencilClearMode,St.disabled,Ct.disabled,Li(o),"$clipping",this.viewportBuffer,this.quadTriangleIndexBuffer,this.viewportSegments);},vo.prototype._renderTileClippingMasks=function(t,e){if(this.currentStencilSource!==t.source&&t.isTileClipped()&&e&&e.length){this.currentStencilSource=t.source;var i=this.context,o=i.gl;this.nextStencilID+e.length>256&&this.clearStencil(),i.setColorMode(St.disabled),i.setDepthMode(It.disabled);var r=this.useProgram("clippingMask");this._tileClippingMaskIDs={};for(var a=0,n=e;a<n.length;a+=1){var s=n[a],l=this._tileClippingMaskIDs[s.key]=this.nextStencilID++;r.draw(i,o.TRIANGLES,It.disabled,new Pt({func:o.ALWAYS,mask:0},l,255,o.KEEP,o.KEEP,o.REPLACE),St.disabled,Ct.disabled,Li(s.posMatrix),"$clipping",this.tileExtentBuffer,this.quadTriangleIndexBuffer,this.tileExtentSegments);}}},vo.prototype.stencilModeFor3D=function(){this.currentStencilSource=void 0,this.nextStencilID+1>256&&this.clearStencil();var t=this.nextStencilID++,e=this.context.gl;return new Pt({func:e.NOTEQUAL,mask:255},t,255,e.KEEP,e.KEEP,e.REPLACE)},vo.prototype.stencilModeForClipping=function(t){var e=this.context.gl;return new Pt({func:e.EQUAL,mask:255},this._tileClippingMaskIDs[t.key],0,e.KEEP,e.KEEP,e.REPLACE)},vo.prototype.stencilConfigForOverlap=function(t){var e,i=this.context.gl,o=t.sort((function(t,e){return e.overscaledZ-t.overscaledZ})),r=o[o.length-1].overscaledZ,a=o[0].overscaledZ-r+1;if(a>1){this.currentStencilSource=void 0,this.nextStencilID+a>256&&this.clearStencil();for(var n={},s=0;s<a;s++)n[s+r]=new Pt({func:i.GEQUAL,mask:255},s+this.nextStencilID,255,i.KEEP,i.KEEP,i.REPLACE);return this.nextStencilID+=a,[n,o]}return [(e={},e[r]=Pt.disabled,e),o]},vo.prototype.colorModeForRenderPass=function(){var e=this.context.gl;return this._showOverdrawInspector?new St([e.CONSTANT_COLOR,e.ONE],new t.Color(1/8,1/8,1/8,0),[!0,!0,!0,!0]):"opaque"===this.renderPass?St.unblended:St.alphaBlended},vo.prototype.depthModeForSublayer=function(t,e,i){if(!this.opaquePassEnabledForLayer())return It.disabled;var o=1-((1+this.currentLayer)*this.numSublayers+t)*this.depthEpsilon;return new It(i||this.context.gl.LEQUAL,e,[o,o])},vo.prototype.opaquePassEnabledForLayer=function(){return this.currentLayer<this.opaquePassCutoff},vo.prototype.render=function(e,i){var o=this;this.style=e,this.options=i,this.lineAtlas=e.lineAtlas,this.imageManager=e.imageManager,this.glyphManager=e.glyphManager,this.symbolFadeChange=e.placement.symbolFadeChange(t.browser.now()),this.imageManager.beginFrame();var r=this.style._order,a=this.style.sourceCaches;for(var n in a){var s=a[n];s.used&&s.prepare(this.context);}var l,c,u={},h={},p={};for(var d in a){var _=a[d];u[d]=_.getVisibleCoordinates(),h[d]=u[d].slice().reverse(),p[d]=_.getVisibleCoordinates(!0).reverse();}this.opaquePassCutoff=1/0;for(var f=0;f<r.length;f++)if(this.style._layers[r[f]].is3D()){this.opaquePassCutoff=f;break}this.renderPass="offscreen";for(var m=0,g=r;m<g.length;m+=1){var v=this.style._layers[g[m]];if(v.hasOffscreenPass()&&!v.isHidden(this.transform.zoom)){var y=h[v.source];("custom"===v.type||y.length)&&this.renderLayer(this,a[v.source],v,y);}}for(this.context.bindFramebuffer.set(null),this.context.clear({color:i.showOverdrawInspector?t.Color.black:t.Color.transparent,depth:1}),this.clearStencil(),this._showOverdrawInspector=i.showOverdrawInspector,this.depthRangeFor3D=[0,1-(e._order.length+2)*this.numSublayers*this.depthEpsilon],this.renderPass="opaque",this.currentLayer=r.length-1;this.currentLayer>=0;this.currentLayer--){var x=this.style._layers[r[this.currentLayer]],b=a[x.source],w=u[x.source];this._renderTileClippingMasks(x,w),this.renderLayer(this,b,x,w);}for(this.renderPass="translucent",this.currentLayer=0;this.currentLayer<r.length;this.currentLayer++){var T=this.style._layers[r[this.currentLayer]],E=a[T.source],I=("symbol"===T.type?p:h)[T.source];this._renderTileClippingMasks(T,u[T.source]),this.renderLayer(this,E,T,I);}this.options.showTileBoundaries&&(t.values(this.style._layers).forEach((function(t){t.source&&!t.isHidden(o.transform.zoom)&&(t.source!==(c&&c.id)&&(c=o.style.sourceCaches[t.source]),(!l||l.getSource().maxzoom<c.getSource().maxzoom)&&(l=c));})),l&&go.debug(this,l,l.getVisibleCoordinates())),this.options.showPadding&&function(t){var e=t.transform.padding;po(t,t.transform.height-(e.top||0),3,so),po(t,e.bottom||0,3,lo),_o(t,e.left||0,3,co),_o(t,t.transform.width-(e.right||0),3,uo);var i=t.transform.centerPoint;!function(t,e,i,o){fo(t,e-1,i-10,2,20,o),fo(t,e-10,i-1,20,2,o);}(t,i.x,t.transform.height-i.y,ho);}(this),this.context.setDefault();},vo.prototype.renderLayer=function(t,e,i,o){i.isHidden(this.transform.zoom)||("background"===i.type||"custom"===i.type||o.length)&&(this.id=i.id,this.gpuTimingStart(i),go[i.type](t,e,i,o,this.style.placement.variableOffsets),this.gpuTimingEnd());},vo.prototype.gpuTimingStart=function(t){if(this.options.gpuTiming){var e=this.context.extTimerQuery,i=this.gpuTimers[t.id];i||(i=this.gpuTimers[t.id]={calls:0,cpuTime:0,query:e.createQueryEXT()}),i.calls++,e.beginQueryEXT(e.TIME_ELAPSED_EXT,i.query);}},vo.prototype.gpuTimingEnd=function(){if(this.options.gpuTiming){var t=this.context.extTimerQuery;t.endQueryEXT(t.TIME_ELAPSED_EXT);}},vo.prototype.collectGpuTimers=function(){var t=this.gpuTimers;return this.gpuTimers={},t},vo.prototype.queryGpuTimers=function(t){var e={};for(var i in t){var o=t[i],r=this.context.extTimerQuery,a=r.getQueryObjectEXT(o.query,r.QUERY_RESULT_EXT)/1e6;r.deleteQueryEXT(o.query),e[i]=a;}return e},vo.prototype.translatePosMatrix=function(e,i,o,r,a){if(!o[0]&&!o[1])return e;var n=a?"map"===r?this.transform.angle:0:"viewport"===r?-this.transform.angle:0;if(n){var s=Math.sin(n),l=Math.cos(n);o=[o[0]*l-o[1]*s,o[0]*s+o[1]*l];}var c=[a?o[0]:pe(i,o[0],this.transform.zoom),a?o[1]:pe(i,o[1],this.transform.zoom),0],u=new Float32Array(16);return t.translate(u,e,c),u},vo.prototype.saveTileTexture=function(t){var e=this._tileTextures[t.size[0]];e?e.push(t):this._tileTextures[t.size[0]]=[t];},vo.prototype.getTileTexture=function(t){var e=this._tileTextures[t];return e&&e.length>0?e.pop():null},vo.prototype.isPatternMissing=function(t){if(!t)return !1;if(!t.from||!t.to)return !0;var e=this.imageManager.getPattern(t.from.toString()),i=this.imageManager.getPattern(t.to.toString());return !e||!i},vo.prototype.useProgram=function(t,e){this.cache=this.cache||{};var i=""+t+(e?e.cacheKey:"")+(this._showOverdrawInspector?"/overdraw":"");return this.cache[i]||(this.cache[i]=new xi(this.context,vi[t],e,Hi[t],this._showOverdrawInspector)),this.cache[i]},vo.prototype.setCustomLayerDefaults=function(){this.context.unbindVAO(),this.context.cullFace.setDefault(),this.context.activeTexture.setDefault(),this.context.pixelStoreUnpack.setDefault(),this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.context.pixelStoreUnpackFlipY.setDefault();},vo.prototype.setBaseState=function(){var t=this.context.gl;this.context.cullFace.set(!1),this.context.viewport.set([0,0,this.width,this.height]),this.context.blendEquation.set(t.FUNC_ADD);},vo.prototype.initDebugOverlayCanvas=function(){null==this.debugOverlayCanvas&&(this.debugOverlayCanvas=t.window.document.createElement("canvas"),this.debugOverlayCanvas.width=512,this.debugOverlayCanvas.height=512,this.debugOverlayTexture=new t.Texture(this.context,this.debugOverlayCanvas,this.context.gl.RGBA));},vo.prototype.destroy=function(){this.emptyTexture.destroy(),this.debugOverlayTexture&&this.debugOverlayTexture.destroy();};var yo=function(t,e){this.points=t,this.planes=e;};yo.fromInvProjectionMatrix=function(e,i,o){var r=Math.pow(2,o),a=[[-1,1,-1,1],[1,1,-1,1],[1,-1,-1,1],[-1,-1,-1,1],[-1,1,1,1],[1,1,1,1],[1,-1,1,1],[-1,-1,1,1]].map((function(i){return t.transformMat4([],i,e)})).map((function(e){return t.scale$1([],e,1/e[3]/i*r)})),n=[[0,1,2],[6,5,4],[0,3,7],[2,1,5],[3,2,6],[0,4,5]].map((function(e){var i=t.sub([],a[e[0]],a[e[1]]),o=t.sub([],a[e[2]],a[e[1]]),r=t.normalize([],t.cross([],i,o)),n=-t.dot(r,a[e[1]]);return r.concat(n)}));return new yo(a,n)};var xo=function(e,i){this.min=e,this.max=i,this.center=t.scale$2([],t.add([],this.min,this.max),.5);};xo.prototype.quadrant=function(e){for(var i=[e%2==0,e<2],o=t.clone$2(this.min),r=t.clone$2(this.max),a=0;a<i.length;a++)o[a]=i[a]?this.min[a]:this.center[a],r[a]=i[a]?this.center[a]:this.max[a];return r[2]=this.max[2],new xo(o,r)},xo.prototype.distanceX=function(t){return Math.max(Math.min(this.max[0],t[0]),this.min[0])-t[0]},xo.prototype.distanceY=function(t){return Math.max(Math.min(this.max[1],t[1]),this.min[1])-t[1]},xo.prototype.intersects=function(e){for(var i=[[this.min[0],this.min[1],0,1],[this.max[0],this.min[1],0,1],[this.max[0],this.max[1],0,1],[this.min[0],this.max[1],0,1]],o=!0,r=0;r<e.planes.length;r++){for(var a=e.planes[r],n=0,s=0;s<i.length;s++)n+=t.dot$1(a,i[s])>=0;if(0===n)return 0;n!==i.length&&(o=!1);}if(o)return 2;for(var l=0;l<3;l++){for(var c=Number.MAX_VALUE,u=-Number.MAX_VALUE,h=0;h<e.points.length;h++){var p=e.points[h][l]-this.min[l];c=Math.min(c,p),u=Math.max(u,p);}if(u<0||c>this.max[l]-this.min[l])return 0}return 1};var bo=function(t,e,i,o){if(void 0===t&&(t=0),void 0===e&&(e=0),void 0===i&&(i=0),void 0===o&&(o=0),isNaN(t)||t<0||isNaN(e)||e<0||isNaN(i)||i<0||isNaN(o)||o<0)throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");this.top=t,this.bottom=e,this.left=i,this.right=o;};bo.prototype.interpolate=function(e,i,o){return null!=i.top&&null!=e.top&&(this.top=t.number(e.top,i.top,o)),null!=i.bottom&&null!=e.bottom&&(this.bottom=t.number(e.bottom,i.bottom,o)),null!=i.left&&null!=e.left&&(this.left=t.number(e.left,i.left,o)),null!=i.right&&null!=e.right&&(this.right=t.number(e.right,i.right,o)),this},bo.prototype.getCenter=function(e,i){var o=t.clamp((this.left+e-this.right)/2,0,e),r=t.clamp((this.top+i-this.bottom)/2,0,i);return new t.Point(o,r)},bo.prototype.equals=function(t){return this.top===t.top&&this.bottom===t.bottom&&this.left===t.left&&this.right===t.right},bo.prototype.clone=function(){return new bo(this.top,this.bottom,this.left,this.right)},bo.prototype.toJSON=function(){return {top:this.top,bottom:this.bottom,left:this.left,right:this.right}};var wo=function(e,i,o,r,a){this.tileSize=512,this.maxValidLatitude=85.051129,this._renderWorldCopies=void 0===a||a,this._minZoom=e||0,this._maxZoom=i||22,this._minPitch=null==o?0:o,this._maxPitch=null==r?60:r,this.setMaxBounds(),this.width=0,this.height=0,this._center=new t.LngLat(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._unmodified=!0,this._edgeInsets=new bo,this._posMatrixCache={},this._alignedPosMatrixCache={};},To={minZoom:{configurable:!0},maxZoom:{configurable:!0},minPitch:{configurable:!0},maxPitch:{configurable:!0},renderWorldCopies:{configurable:!0},worldSize:{configurable:!0},centerOffset:{configurable:!0},size:{configurable:!0},bearing:{configurable:!0},pitch:{configurable:!0},fov:{configurable:!0},zoom:{configurable:!0},center:{configurable:!0},padding:{configurable:!0},centerPoint:{configurable:!0},unmodified:{configurable:!0},point:{configurable:!0}};wo.prototype.clone=function(){var t=new wo(this._minZoom,this._maxZoom,this._minPitch,this.maxPitch,this._renderWorldCopies);return t.tileSize=this.tileSize,t.latRange=this.latRange,t.width=this.width,t.height=this.height,t._center=this._center,t.zoom=this.zoom,t.angle=this.angle,t._fov=this._fov,t._pitch=this._pitch,t._unmodified=this._unmodified,t._edgeInsets=this._edgeInsets.clone(),t._calcMatrices(),t},To.minZoom.get=function(){return this._minZoom},To.minZoom.set=function(t){this._minZoom!==t&&(this._minZoom=t,this.zoom=Math.max(this.zoom,t));},To.maxZoom.get=function(){return this._maxZoom},To.maxZoom.set=function(t){this._maxZoom!==t&&(this._maxZoom=t,this.zoom=Math.min(this.zoom,t));},To.minPitch.get=function(){return this._minPitch},To.minPitch.set=function(t){this._minPitch!==t&&(this._minPitch=t,this.pitch=Math.max(this.pitch,t));},To.maxPitch.get=function(){return this._maxPitch},To.maxPitch.set=function(t){this._maxPitch!==t&&(this._maxPitch=t,this.pitch=Math.min(this.pitch,t));},To.renderWorldCopies.get=function(){return this._renderWorldCopies},To.renderWorldCopies.set=function(t){void 0===t?t=!0:null===t&&(t=!1),this._renderWorldCopies=t;},To.worldSize.get=function(){return this.tileSize*this.scale},To.centerOffset.get=function(){return this.centerPoint._sub(this.size._div(2))},To.size.get=function(){return new t.Point(this.width,this.height)},To.bearing.get=function(){return -this.angle/Math.PI*180},To.bearing.set=function(e){var i=-t.wrap(e,-180,180)*Math.PI/180;this.angle!==i&&(this._unmodified=!1,this.angle=i,this._calcMatrices(),this.rotationMatrix=t.create$2(),t.rotate(this.rotationMatrix,this.rotationMatrix,this.angle));},To.pitch.get=function(){return this._pitch/Math.PI*180},To.pitch.set=function(e){var i=t.clamp(e,this.minPitch,this.maxPitch)/180*Math.PI;this._pitch!==i&&(this._unmodified=!1,this._pitch=i,this._calcMatrices());},To.fov.get=function(){return this._fov/Math.PI*180},To.fov.set=function(t){t=Math.max(.01,Math.min(60,t)),this._fov!==t&&(this._unmodified=!1,this._fov=t/180*Math.PI,this._calcMatrices());},To.zoom.get=function(){return this._zoom},To.zoom.set=function(t){var e=Math.min(Math.max(t,this.minZoom),this.maxZoom);this._zoom!==e&&(this._unmodified=!1,this._zoom=e,this.scale=this.zoomScale(e),this.tileZoom=Math.floor(e),this.zoomFraction=e-this.tileZoom,this._constrain(),this._calcMatrices());},To.center.get=function(){return this._center},To.center.set=function(t){t.lat===this._center.lat&&t.lng===this._center.lng||(this._unmodified=!1,this._center=t,this._constrain(),this._calcMatrices());},To.padding.get=function(){return this._edgeInsets.toJSON()},To.padding.set=function(t){this._edgeInsets.equals(t)||(this._unmodified=!1,this._edgeInsets.interpolate(this._edgeInsets,t,1),this._calcMatrices());},To.centerPoint.get=function(){return this._edgeInsets.getCenter(this.width,this.height)},wo.prototype.isPaddingEqual=function(t){return this._edgeInsets.equals(t)},wo.prototype.interpolatePadding=function(t,e,i){this._unmodified=!1,this._edgeInsets.interpolate(t,e,i),this._constrain(),this._calcMatrices();},wo.prototype.coveringZoomLevel=function(t){var e=(t.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/t.tileSize));return Math.max(0,e)},wo.prototype.getVisibleUnwrappedCoordinates=function(e){var i=[new t.UnwrappedTileID(0,e)];if(this._renderWorldCopies)for(var o=this.pointCoordinate(new t.Point(0,0)),r=this.pointCoordinate(new t.Point(this.width,0)),a=this.pointCoordinate(new t.Point(this.width,this.height)),n=this.pointCoordinate(new t.Point(0,this.height)),s=Math.floor(Math.min(o.x,r.x,a.x,n.x)),l=Math.floor(Math.max(o.x,r.x,a.x,n.x)),c=s-1;c<=l+1;c++)0!==c&&i.push(new t.UnwrappedTileID(c,e));return i},wo.prototype.coveringTiles=function(e){var i=this.coveringZoomLevel(e),o=i;if(void 0!==e.minzoom&&i<e.minzoom)return [];void 0!==e.maxzoom&&i>e.maxzoom&&(i=e.maxzoom);var r=t.MercatorCoordinate.fromLngLat(this.center),a=Math.pow(2,i),n=[a*r.x,a*r.y,0],s=yo.fromInvProjectionMatrix(this.invProjMatrix,this.worldSize,i),l=e.minzoom||0;this.pitch<=60&&this._edgeInsets.top<.1&&(l=i);var c=function(t){return {aabb:new xo([t*a,0,0],[(t+1)*a,a,0]),zoom:0,x:0,y:0,wrap:t,fullyVisible:!1}},u=[],h=[],p=i,d=e.reparseOverscaled?o:i;if(this._renderWorldCopies)for(var _=1;_<=3;_++)u.push(c(-_)),u.push(c(_));for(u.push(c(0));u.length>0;){var f=u.pop(),m=f.x,g=f.y,v=f.fullyVisible;if(!v){var y=f.aabb.intersects(s);if(0===y)continue;v=2===y;}var x=f.aabb.distanceX(n),b=f.aabb.distanceY(n),w=Math.max(Math.abs(x),Math.abs(b));if(f.zoom===p||w>3+(1<<p-f.zoom)-2&&f.zoom>=l)h.push({tileID:new t.OverscaledTileID(f.zoom===p?d:f.zoom,f.wrap,f.zoom,m,g),distanceSq:t.sqrLen([n[0]-.5-m,n[1]-.5-g])});else for(var T=0;T<4;T++){var E=(m<<1)+T%2,I=(g<<1)+(T>>1);u.push({aabb:f.aabb.quadrant(T),zoom:f.zoom+1,x:E,y:I,wrap:f.wrap,fullyVisible:v});}}return h.sort((function(t,e){return t.distanceSq-e.distanceSq})).map((function(t){return t.tileID}))},wo.prototype.resize=function(t,e){this.width=t,this.height=e,this.pixelsToGLUnits=[2/t,-2/e],this._constrain(),this._calcMatrices();},To.unmodified.get=function(){return this._unmodified},wo.prototype.zoomScale=function(t){return Math.pow(2,t)},wo.prototype.scaleZoom=function(t){return Math.log(t)/Math.LN2},wo.prototype.project=function(e){var i=t.clamp(e.lat,-this.maxValidLatitude,this.maxValidLatitude);return new t.Point(t.mercatorXfromLng(e.lng)*this.worldSize,t.mercatorYfromLat(i)*this.worldSize)},wo.prototype.unproject=function(e){return new t.MercatorCoordinate(e.x/this.worldSize,e.y/this.worldSize).toLngLat()},To.point.get=function(){return this.project(this.center)},wo.prototype.setLocationAtPoint=function(e,i){var o=this.pointCoordinate(i),r=this.pointCoordinate(this.centerPoint),a=this.locationCoordinate(e),n=new t.MercatorCoordinate(a.x-(o.x-r.x),a.y-(o.y-r.y));this.center=this.coordinateLocation(n),this._renderWorldCopies&&(this.center=this.center.wrap());},wo.prototype.locationPoint=function(t){return this.coordinatePoint(this.locationCoordinate(t))},wo.prototype.pointLocation=function(t){return this.coordinateLocation(this.pointCoordinate(t))},wo.prototype.locationCoordinate=function(e){return t.MercatorCoordinate.fromLngLat(e)},wo.prototype.coordinateLocation=function(t){return t.toLngLat()},wo.prototype.pointCoordinate=function(e){var i=[e.x,e.y,0,1],o=[e.x,e.y,1,1];t.transformMat4(i,i,this.pixelMatrixInverse),t.transformMat4(o,o,this.pixelMatrixInverse);var r=i[3],a=o[3],n=i[1]/r,s=o[1]/a,l=i[2]/r,c=o[2]/a,u=l===c?0:(0-l)/(c-l);return new t.MercatorCoordinate(t.number(i[0]/r,o[0]/a,u)/this.worldSize,t.number(n,s,u)/this.worldSize)},wo.prototype.coordinatePoint=function(e){var i=[e.x*this.worldSize,e.y*this.worldSize,0,1];return t.transformMat4(i,i,this.pixelMatrix),new t.Point(i[0]/i[3],i[1]/i[3])},wo.prototype.getBounds=function(){return (new t.LngLatBounds).extend(this.pointLocation(new t.Point(0,0))).extend(this.pointLocation(new t.Point(this.width,0))).extend(this.pointLocation(new t.Point(this.width,this.height))).extend(this.pointLocation(new t.Point(0,this.height)))},wo.prototype.getMaxBounds=function(){return this.latRange&&2===this.latRange.length&&this.lngRange&&2===this.lngRange.length?new t.LngLatBounds([this.lngRange[0],this.latRange[0]],[this.lngRange[1],this.latRange[1]]):null},wo.prototype.setMaxBounds=function(t){t?(this.lngRange=[t.getWest(),t.getEast()],this.latRange=[t.getSouth(),t.getNorth()],this._constrain()):(this.lngRange=null,this.latRange=[-this.maxValidLatitude,this.maxValidLatitude]);},wo.prototype.calculatePosMatrix=function(e,i){void 0===i&&(i=!1);var o=e.key,r=i?this._alignedPosMatrixCache:this._posMatrixCache;if(r[o])return r[o];var a=e.canonical,n=this.worldSize/this.zoomScale(a.z),s=a.x+Math.pow(2,a.z)*e.wrap,l=t.identity(new Float64Array(16));return t.translate(l,l,[s*n,a.y*n,0]),t.scale(l,l,[n/t.EXTENT,n/t.EXTENT,1]),t.multiply(l,i?this.alignedProjMatrix:this.projMatrix,l),r[o]=new Float32Array(l),r[o]},wo.prototype.customLayerMatrix=function(){return this.mercatorMatrix.slice()},wo.prototype._constrain=function(){if(this.center&&this.width&&this.height&&!this._constraining){this._constraining=!0;var e,i,o,r,a=-90,n=90,s=-180,l=180,c=this.size,u=this._unmodified;if(this.latRange){var h=this.latRange;a=t.mercatorYfromLat(h[1])*this.worldSize,e=(n=t.mercatorYfromLat(h[0])*this.worldSize)-a<c.y?c.y/(n-a):0;}if(this.lngRange){var p=this.lngRange;s=t.mercatorXfromLng(p[0])*this.worldSize,i=(l=t.mercatorXfromLng(p[1])*this.worldSize)-s<c.x?c.x/(l-s):0;}var d=this.point,_=Math.max(i||0,e||0);if(_)return this.center=this.unproject(new t.Point(i?(l+s)/2:d.x,e?(n+a)/2:d.y)),this.zoom+=this.scaleZoom(_),this._unmodified=u,void(this._constraining=!1);if(this.latRange){var f=d.y,m=c.y/2;f-m<a&&(r=a+m),f+m>n&&(r=n-m);}if(this.lngRange){var g=d.x,v=c.x/2;g-v<s&&(o=s+v),g+v>l&&(o=l-v);}void 0===o&&void 0===r||(this.center=this.unproject(new t.Point(void 0!==o?o:d.x,void 0!==r?r:d.y))),this._unmodified=u,this._constraining=!1;}},wo.prototype._calcMatrices=function(){if(this.height){var e=this.centerOffset;this.cameraToCenterDistance=.5/Math.tan(this._fov/2)*this.height;var i=Math.PI/2+this._pitch,o=this._fov*(.5+e.y/this.height),r=Math.sin(o)*this.cameraToCenterDistance/Math.sin(t.clamp(Math.PI-i-o,.01,Math.PI-.01)),a=this.point,n=a.x,s=a.y,l=1.01*(Math.cos(Math.PI/2-this._pitch)*r+this.cameraToCenterDistance),c=this.height/50,u=new Float64Array(16);t.perspective(u,this._fov,this.width/this.height,c,l),u[8]=2*-e.x/this.width,u[9]=2*e.y/this.height,t.scale(u,u,[1,-1,1]),t.translate(u,u,[0,0,-this.cameraToCenterDistance]),t.rotateX(u,u,this._pitch),t.rotateZ(u,u,this.angle),t.translate(u,u,[-n,-s,0]),this.mercatorMatrix=t.scale([],u,[this.worldSize,this.worldSize,this.worldSize]),t.scale(u,u,[1,1,t.mercatorZfromAltitude(1,this.center.lat)*this.worldSize,1]),this.projMatrix=u,this.invProjMatrix=t.invert([],this.projMatrix);var h=this.width%2/2,p=this.height%2/2,d=Math.cos(this.angle),_=Math.sin(this.angle),f=n-Math.round(n)+d*h+_*p,m=s-Math.round(s)+d*p+_*h,g=new Float64Array(u);if(t.translate(g,g,[f>.5?f-1:f,m>.5?m-1:m,0]),this.alignedProjMatrix=g,u=t.create(),t.scale(u,u,[this.width/2,-this.height/2,1]),t.translate(u,u,[1,-1,0]),this.labelPlaneMatrix=u,u=t.create(),t.scale(u,u,[1,-1,1]),t.translate(u,u,[-1,-1,0]),t.scale(u,u,[2/this.width,2/this.height,1]),this.glCoordMatrix=u,this.pixelMatrix=t.multiply(new Float64Array(16),this.labelPlaneMatrix,this.projMatrix),!(u=t.invert(new Float64Array(16),this.pixelMatrix)))throw new Error("failed to invert matrix");this.pixelMatrixInverse=u,this._posMatrixCache={},this._alignedPosMatrixCache={};}},wo.prototype.maxPitchScaleFactor=function(){if(!this.pixelMatrixInverse)return 1;var e=this.pointCoordinate(new t.Point(0,0)),i=[e.x*this.worldSize,e.y*this.worldSize,0,1];return t.transformMat4(i,i,this.pixelMatrix)[3]/this.cameraToCenterDistance},wo.prototype.getCameraPoint=function(){var e=Math.tan(this._pitch)*(this.cameraToCenterDistance||1);return this.centerPoint.add(new t.Point(0,e))},wo.prototype.getCameraQueryGeometry=function(e){var i=this.getCameraPoint();if(1===e.length)return [e[0],i];for(var o=i.x,r=i.y,a=i.x,n=i.y,s=0,l=e;s<l.length;s+=1){var c=l[s];o=Math.min(o,c.x),r=Math.min(r,c.y),a=Math.max(a,c.x),n=Math.max(n,c.y);}return [new t.Point(o,r),new t.Point(a,r),new t.Point(a,n),new t.Point(o,n),new t.Point(o,r)]},Object.defineProperties(wo.prototype,To);var Eo=function(e){var i,o,r,a;this._hashName=e&&encodeURIComponent(e),t.bindAll(["_getCurrentHash","_onHashChange","_updateHash"],this),this._updateHash=(i=this._updateHashUnthrottled.bind(this),o=!1,r=null,a=function(){r=null,o&&(i(),r=setTimeout(a,300),o=!1);},function(){return o=!0,r||a(),r});};Eo.prototype.addTo=function(e){return this._map=e,t.window.addEventListener("hashchange",this._onHashChange,!1),this._map.on("moveend",this._updateHash),this},Eo.prototype.remove=function(){return t.window.removeEventListener("hashchange",this._onHashChange,!1),this._map.off("moveend",this._updateHash),clearTimeout(this._updateHash()),delete this._map,this},Eo.prototype.getHashString=function(e){var i=this._map.getCenter(),o=Math.round(100*this._map.getZoom())/100,r=Math.ceil((o*Math.LN2+Math.log(512/360/.5))/Math.LN10),a=Math.pow(10,r),n=Math.round(i.lng*a)/a,s=Math.round(i.lat*a)/a,l=this._map.getBearing(),c=this._map.getPitch(),u="";if(u+=e?"/"+n+"/"+s+"/"+o:o+"/"+s+"/"+n,(l||c)&&(u+="/"+Math.round(10*l)/10),c&&(u+="/"+Math.round(c)),this._hashName){var h=this._hashName,p=!1,d=t.window.location.hash.slice(1).split("&").map((function(t){var e=t.split("=")[0];return e===h?(p=!0,e+"="+u):t})).filter((function(t){return t}));return p||d.push(h+"="+u),"#"+d.join("&")}return "#"+u},Eo.prototype._getCurrentHash=function(){var e,i=this,o=t.window.location.hash.replace("#","");return this._hashName?(o.split("&").map((function(t){return t.split("=")})).forEach((function(t){t[0]===i._hashName&&(e=t);})),(e&&e[1]||"").split("/")):o.split("/")},Eo.prototype._onHashChange=function(){var t=this._getCurrentHash();if(t.length>=3&&!t.some((function(t){return isNaN(t)}))){var e=this._map.dragRotate.isEnabled()&&this._map.touchZoomRotate.isEnabled()?+(t[3]||0):this._map.getBearing();return this._map.jumpTo({center:[+t[2],+t[1]],zoom:+t[0],bearing:e,pitch:+(t[4]||0)}),!0}return !1},Eo.prototype._updateHashUnthrottled=function(){var e=this.getHashString();try{t.window.history.replaceState(t.window.history.state,"",e);}catch(t){}};var Io={linearity:.3,easing:t.bezier(0,0,.3,1)},Po=t.extend({deceleration:2500,maxSpeed:1400},Io),So=t.extend({deceleration:20,maxSpeed:1400},Io),Co=t.extend({deceleration:1e3,maxSpeed:360},Io),zo=t.extend({deceleration:1e3,maxSpeed:90},Io),Do=function(t){this._map=t,this.clear();};function Mo(t,e){(!t.duration||t.duration<e.duration)&&(t.duration=e.duration,t.easing=e.easing);}function Lo(e,i,o){var r=o.maxSpeed,a=o.linearity,n=o.deceleration,s=t.clamp(e*a/(i/1e3),-r,r),l=Math.abs(s)/(n*a);return {easing:o.easing,duration:1e3*l,amount:s*(l/2)}}Do.prototype.clear=function(){this._inertiaBuffer=[];},Do.prototype.record=function(e){this._drainInertiaBuffer(),this._inertiaBuffer.push({time:t.browser.now(),settings:e});},Do.prototype._drainInertiaBuffer=function(){for(var e=this._inertiaBuffer,i=t.browser.now();e.length>0&&i-e[0].time>160;)e.shift();},Do.prototype._onMoveEnd=function(e){if(this._drainInertiaBuffer(),!(this._inertiaBuffer.length<2)){for(var i={zoom:0,bearing:0,pitch:0,pan:new t.Point(0,0),pinchAround:void 0,around:void 0},o=0,r=this._inertiaBuffer;o<r.length;o+=1){var a=r[o].settings;i.zoom+=a.zoomDelta||0,i.bearing+=a.bearingDelta||0,i.pitch+=a.pitchDelta||0,a.panDelta&&i.pan._add(a.panDelta),a.around&&(i.around=a.around),a.pinchAround&&(i.pinchAround=a.pinchAround);}var n=this._inertiaBuffer[this._inertiaBuffer.length-1].time-this._inertiaBuffer[0].time,s={};if(i.pan.mag()){var l=Lo(i.pan.mag(),n,t.extend({},Po,e||{}));s.offset=i.pan.mult(l.amount/i.pan.mag()),s.center=this._map.transform.center,Mo(s,l);}if(i.zoom){var c=Lo(i.zoom,n,So);s.zoom=this._map.transform.zoom+c.amount,Mo(s,c);}if(i.bearing){var u=Lo(i.bearing,n,Co);s.bearing=this._map.transform.bearing+t.clamp(u.amount,-179,179),Mo(s,u);}if(i.pitch){var h=Lo(i.pitch,n,zo);s.pitch=this._map.transform.pitch+h.amount,Mo(s,h);}if(s.zoom||s.bearing){var p=void 0===i.pinchAround?i.around:i.pinchAround;s.around=p?this._map.unproject(p):this._map.getCenter();}return this.clear(),t.extend(s,{noMoveStart:!0})}};var Ao=function(e){function o(o,r,a,n){void 0===n&&(n={});var s=i.mousePos(r.getCanvasContainer(),a),l=r.unproject(s);e.call(this,o,t.extend({point:s,lngLat:l,originalEvent:a},n)),this._defaultPrevented=!1,this.target=r;}e&&(o.__proto__=e),(o.prototype=Object.create(e&&e.prototype)).constructor=o;var r={defaultPrevented:{configurable:!0}};return o.prototype.preventDefault=function(){this._defaultPrevented=!0;},r.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(o.prototype,r),o}(t.Event),Ro=function(e){function o(o,r,a){var n="touchend"===o?a.changedTouches:a.touches,s=i.touchPos(r.getCanvasContainer(),n),l=s.map((function(t){return r.unproject(t)})),c=s.reduce((function(t,e,i,o){return t.add(e.div(o.length))}),new t.Point(0,0)),u=r.unproject(c);e.call(this,o,{points:s,point:c,lngLats:l,lngLat:u,originalEvent:a}),this._defaultPrevented=!1;}e&&(o.__proto__=e),(o.prototype=Object.create(e&&e.prototype)).constructor=o;var r={defaultPrevented:{configurable:!0}};return o.prototype.preventDefault=function(){this._defaultPrevented=!0;},r.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(o.prototype,r),o}(t.Event),ko=function(t){function e(e,i,o){t.call(this,e,{originalEvent:o}),this._defaultPrevented=!1;}t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e;var i={defaultPrevented:{configurable:!0}};return e.prototype.preventDefault=function(){this._defaultPrevented=!0;},i.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(e.prototype,i),e}(t.Event),Bo=function(t,e){this._map=t,this._clickTolerance=e.clickTolerance;};Bo.prototype.reset=function(){delete this._mousedownPos;},Bo.prototype.wheel=function(t){return this._firePreventable(new ko(t.type,this._map,t))},Bo.prototype.mousedown=function(t,e){return this._mousedownPos=e,this._firePreventable(new Ao(t.type,this._map,t))},Bo.prototype.mouseup=function(t){this._map.fire(new Ao(t.type,this._map,t));},Bo.prototype.click=function(t,e){this._mousedownPos&&this._mousedownPos.dist(e)>=this._clickTolerance||this._map.fire(new Ao(t.type,this._map,t));},Bo.prototype.dblclick=function(t){return this._firePreventable(new Ao(t.type,this._map,t))},Bo.prototype.mouseover=function(t){this._map.fire(new Ao(t.type,this._map,t));},Bo.prototype.mouseout=function(t){this._map.fire(new Ao(t.type,this._map,t));},Bo.prototype.touchstart=function(t){return this._firePreventable(new Ro(t.type,this._map,t))},Bo.prototype.touchmove=function(t){this._map.fire(new Ro(t.type,this._map,t));},Bo.prototype.touchend=function(t){this._map.fire(new Ro(t.type,this._map,t));},Bo.prototype.touchcancel=function(t){this._map.fire(new Ro(t.type,this._map,t));},Bo.prototype._firePreventable=function(t){if(this._map.fire(t),t.defaultPrevented)return {}},Bo.prototype.isEnabled=function(){return !0},Bo.prototype.isActive=function(){return !1},Bo.prototype.enable=function(){},Bo.prototype.disable=function(){};var Oo=function(t){this._map=t;};Oo.prototype.reset=function(){this._delayContextMenu=!1,delete this._contextMenuEvent;},Oo.prototype.mousemove=function(t){this._map.fire(new Ao(t.type,this._map,t));},Oo.prototype.mousedown=function(){this._delayContextMenu=!0;},Oo.prototype.mouseup=function(){this._delayContextMenu=!1,this._contextMenuEvent&&(this._map.fire(new Ao("contextmenu",this._map,this._contextMenuEvent)),delete this._contextMenuEvent);},Oo.prototype.contextmenu=function(t){this._delayContextMenu?this._contextMenuEvent=t:this._map.fire(new Ao(t.type,this._map,t)),this._map.listens("contextmenu")&&t.preventDefault();},Oo.prototype.isEnabled=function(){return !0},Oo.prototype.isActive=function(){return !1},Oo.prototype.enable=function(){},Oo.prototype.disable=function(){};var Fo=function(t,e){this._map=t,this._el=t.getCanvasContainer(),this._container=t.getContainer(),this._clickTolerance=e.clickTolerance||1;};function Uo(t,e){for(var i={},o=0;o<t.length;o++)i[t[o].identifier]=e[o];return i}Fo.prototype.isEnabled=function(){return !!this._enabled},Fo.prototype.isActive=function(){return !!this._active},Fo.prototype.enable=function(){this.isEnabled()||(this._enabled=!0);},Fo.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},Fo.prototype.mousedown=function(t,e){this.isEnabled()&&t.shiftKey&&0===t.button&&(i.disableDrag(),this._startPos=this._lastPos=e,this._active=!0);},Fo.prototype.mousemoveWindow=function(t,e){if(this._active){var o=e;if(!(this._lastPos.equals(o)||!this._box&&o.dist(this._startPos)<this._clickTolerance)){var r=this._startPos;this._lastPos=o,this._box||(this._box=i.create("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",t));var a=Math.min(r.x,o.x),n=Math.max(r.x,o.x),s=Math.min(r.y,o.y),l=Math.max(r.y,o.y);i.setTransform(this._box,"translate("+a+"px,"+s+"px)"),this._box.style.width=n-a+"px",this._box.style.height=l-s+"px";}}},Fo.prototype.mouseupWindow=function(e,o){var r=this;if(this._active&&0===e.button){var a=this._startPos,n=o;if(this.reset(),i.suppressClick(),a.x!==n.x||a.y!==n.y)return this._map.fire(new t.Event("boxzoomend",{originalEvent:e})),{cameraAnimation:function(t){return t.fitScreenCoordinates(a,n,r._map.getBearing(),{linear:!0})}};this._fireEvent("boxzoomcancel",e);}},Fo.prototype.keydown=function(t){this._active&&27===t.keyCode&&(this.reset(),this._fireEvent("boxzoomcancel",t));},Fo.prototype.reset=function(){this._active=!1,this._container.classList.remove("mapboxgl-crosshair"),this._box&&(i.remove(this._box),this._box=null),i.enableDrag(),delete this._startPos,delete this._lastPos;},Fo.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,{originalEvent:i}))};var No=function(t){this.reset(),this.numTouches=t.numTouches;};No.prototype.reset=function(){delete this.centroid,delete this.startTime,delete this.touches,this.aborted=!1;},No.prototype.touchstart=function(e,i,o){(this.centroid||o.length>this.numTouches)&&(this.aborted=!0),this.aborted||(void 0===this.startTime&&(this.startTime=e.timeStamp),o.length===this.numTouches&&(this.centroid=function(e){for(var i=new t.Point(0,0),o=0,r=e;o<r.length;o+=1)i._add(r[o]);return i.div(e.length)}(i),this.touches=Uo(o,i)));},No.prototype.touchmove=function(t,e,i){if(!this.aborted&&this.centroid){var o=Uo(i,e);for(var r in this.touches){var a=o[r];(!a||a.dist(this.touches[r])>30)&&(this.aborted=!0);}}},No.prototype.touchend=function(t,e,i){if((!this.centroid||t.timeStamp-this.startTime>500)&&(this.aborted=!0),0===i.length){var o=!this.aborted&&this.centroid;if(this.reset(),o)return o}};var Zo=function(t){this.singleTap=new No(t),this.numTaps=t.numTaps,this.reset();};Zo.prototype.reset=function(){this.lastTime=1/0,delete this.lastTap,this.count=0,this.singleTap.reset();},Zo.prototype.touchstart=function(t,e,i){this.singleTap.touchstart(t,e,i);},Zo.prototype.touchmove=function(t,e,i){this.singleTap.touchmove(t,e,i);},Zo.prototype.touchend=function(t,e,i){var o=this.singleTap.touchend(t,e,i);if(o){var r=t.timeStamp-this.lastTime<500,a=!this.lastTap||this.lastTap.dist(o)<30;if(r&&a||this.reset(),this.count++,this.lastTime=t.timeStamp,this.lastTap=o,this.count===this.numTaps)return this.reset(),o}};var jo=function(){this._zoomIn=new Zo({numTouches:1,numTaps:2}),this._zoomOut=new Zo({numTouches:2,numTaps:1}),this.reset();};jo.prototype.reset=function(){this._active=!1,this._zoomIn.reset(),this._zoomOut.reset();},jo.prototype.touchstart=function(t,e,i){this._zoomIn.touchstart(t,e,i),this._zoomOut.touchstart(t,e,i);},jo.prototype.touchmove=function(t,e,i){this._zoomIn.touchmove(t,e,i),this._zoomOut.touchmove(t,e,i);},jo.prototype.touchend=function(t,e,i){var o=this,r=this._zoomIn.touchend(t,e,i),a=this._zoomOut.touchend(t,e,i);return r?(this._active=!0,t.preventDefault(),setTimeout((function(){return o.reset()}),0),{cameraAnimation:function(e){return e.easeTo({duration:300,zoom:e.getZoom()+1,around:e.unproject(r)},{originalEvent:t})}}):a?(this._active=!0,t.preventDefault(),setTimeout((function(){return o.reset()}),0),{cameraAnimation:function(e){return e.easeTo({duration:300,zoom:e.getZoom()-1,around:e.unproject(a)},{originalEvent:t})}}):void 0},jo.prototype.touchcancel=function(){this.reset();},jo.prototype.enable=function(){this._enabled=!0;},jo.prototype.disable=function(){this._enabled=!1,this.reset();},jo.prototype.isEnabled=function(){return this._enabled},jo.prototype.isActive=function(){return this._active};var qo=function(t){this.reset(),this._clickTolerance=t.clickTolerance||1;};qo.prototype.reset=function(){this._active=!1,this._moved=!1,delete this._lastPoint,delete this._eventButton;},qo.prototype._correctButton=function(t,e){return !1},qo.prototype._move=function(t,e){return {}},qo.prototype.mousedown=function(t,e){if(!this._lastPoint){var o=i.mouseButton(t);this._correctButton(t,o)&&(this._lastPoint=e,this._eventButton=o);}},qo.prototype.mousemoveWindow=function(t,e){var i=this._lastPoint;if(i&&(t.preventDefault(),this._moved||!(e.dist(i)<this._clickTolerance)))return this._moved=!0,this._lastPoint=e,this._move(i,e)},qo.prototype.mouseupWindow=function(t){i.mouseButton(t)===this._eventButton&&(this._moved&&i.suppressClick(),this.reset());},qo.prototype.enable=function(){this._enabled=!0;},qo.prototype.disable=function(){this._enabled=!1,this.reset();},qo.prototype.isEnabled=function(){return this._enabled},qo.prototype.isActive=function(){return this._active};var Vo=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.mousedown=function(e,i){t.prototype.mousedown.call(this,e,i),this._lastPoint&&(this._active=!0);},e.prototype._correctButton=function(t,e){return 0===e&&!t.ctrlKey},e.prototype._move=function(t,e){return {around:e,panDelta:e.sub(t)}},e}(qo),Go=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._correctButton=function(t,e){return 0===e&&t.ctrlKey||2===e},e.prototype._move=function(t,e){var i=.8*(e.x-t.x);if(i)return this._active=!0,{bearingDelta:i}},e.prototype.contextmenu=function(t){t.preventDefault();},e}(qo),Wo=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype._correctButton=function(t,e){return 0===e&&t.ctrlKey||2===e},e.prototype._move=function(t,e){var i=-.5*(e.y-t.y);if(i)return this._active=!0,{pitchDelta:i}},e.prototype.contextmenu=function(t){t.preventDefault();},e}(qo),Xo=function(t){this._minTouches=1,this._clickTolerance=t.clickTolerance||1,this.reset();};Xo.prototype.reset=function(){this._active=!1,this._touches={},this._sum=new t.Point(0,0);},Xo.prototype.touchstart=function(t,e,i){return this._calculateTransform(t,e,i)},Xo.prototype.touchmove=function(t,e,i){if(this._active)return t.preventDefault(),this._calculateTransform(t,e,i)},Xo.prototype.touchend=function(t,e,i){this._calculateTransform(t,e,i),this._active&&i.length<this._minTouches&&this.reset();},Xo.prototype.touchcancel=function(){this.reset();},Xo.prototype._calculateTransform=function(e,i,o){o.length>0&&(this._active=!0);var r=Uo(o,i),a=new t.Point(0,0),n=new t.Point(0,0),s=0;for(var l in r){var c=r[l],u=this._touches[l];u&&(a._add(c),n._add(c.sub(u)),s++,r[l]=c);}if(this._touches=r,!(s<this._minTouches)&&n.mag()){var h=n.div(s);if(this._sum._add(h),!(this._sum.mag()<this._clickTolerance))return {around:a.div(s),panDelta:h}}},Xo.prototype.enable=function(){this._enabled=!0;},Xo.prototype.disable=function(){this._enabled=!1,this.reset();},Xo.prototype.isEnabled=function(){return this._enabled},Xo.prototype.isActive=function(){return this._active};var Ho=function(){this.reset();};function Ko(t,e,i){for(var o=0;o<t.length;o++)if(t[o].identifier===i)return e[o]}function Yo(t,e){return Math.log(t/e)/Math.LN2}Ho.prototype.reset=function(){this._active=!1,delete this._firstTwoTouches;},Ho.prototype._start=function(t){},Ho.prototype._move=function(t,e,i){return {}},Ho.prototype.touchstart=function(t,e,i){this._firstTwoTouches||i.length<2||(this._firstTwoTouches=[i[0].identifier,i[1].identifier],this._start([e[0],e[1]]));},Ho.prototype.touchmove=function(t,e,i){if(this._firstTwoTouches){t.preventDefault();var o=this._firstTwoTouches,r=o[1],a=Ko(i,e,o[0]),n=Ko(i,e,r);if(a&&n){var s=this._aroundCenter?null:a.add(n).div(2);return this._move([a,n],s,t)}}},Ho.prototype.touchend=function(t,e,o){if(this._firstTwoTouches){var r=this._firstTwoTouches,a=r[1],n=Ko(o,e,r[0]),s=Ko(o,e,a);n&&s||(this._active&&i.suppressClick(),this.reset());}},Ho.prototype.touchcancel=function(){this.reset();},Ho.prototype.enable=function(t){this._enabled=!0,this._aroundCenter=!!t&&"center"===t.around;},Ho.prototype.disable=function(){this._enabled=!1,this.reset();},Ho.prototype.isEnabled=function(){return this._enabled},Ho.prototype.isActive=function(){return this._active};var Jo=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.reset=function(){t.prototype.reset.call(this),delete this._distance,delete this._startDistance;},e.prototype._start=function(t){this._startDistance=this._distance=t[0].dist(t[1]);},e.prototype._move=function(t,e){var i=this._distance;if(this._distance=t[0].dist(t[1]),this._active||!(Math.abs(Yo(this._distance,this._startDistance))<.1))return this._active=!0,{zoomDelta:Yo(this._distance,i),pinchAround:e}},e}(Ho);function Qo(t,e){return 180*t.angleWith(e)/Math.PI}var $o=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.reset=function(){t.prototype.reset.call(this),delete this._minDiameter,delete this._startVector,delete this._vector;},e.prototype._start=function(t){this._startVector=this._vector=t[0].sub(t[1]),this._minDiameter=t[0].dist(t[1]);},e.prototype._move=function(t,e){var i=this._vector;if(this._vector=t[0].sub(t[1]),this._active||!this._isBelowThreshold(this._vector))return this._active=!0,{bearingDelta:Qo(this._vector,i),pinchAround:e}},e.prototype._isBelowThreshold=function(t){this._minDiameter=Math.min(this._minDiameter,t.mag());var e=25/(Math.PI*this._minDiameter)*360,i=Qo(t,this._startVector);return Math.abs(i)<e},e}(Ho);function tr(t){return Math.abs(t.y)>Math.abs(t.x)}var er=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e.prototype.reset=function(){t.prototype.reset.call(this),this._valid=void 0,delete this._firstMove,delete this._lastPoints;},e.prototype._start=function(t){this._lastPoints=t,tr(t[0].sub(t[1]))&&(this._valid=!1);},e.prototype._move=function(t,e,i){var o=t[0].sub(this._lastPoints[0]),r=t[1].sub(this._lastPoints[1]);if(this._valid=this.gestureBeginsVertically(o,r,i.timeStamp),this._valid)return this._lastPoints=t,this._active=!0,{pitchDelta:(o.y+r.y)/2*-.5}},e.prototype.gestureBeginsVertically=function(t,e,i){if(void 0!==this._valid)return this._valid;var o=t.mag()>=2,r=e.mag()>=2;if(o||r){if(!o||!r)return void 0===this._firstMove&&(this._firstMove=i),i-this._firstMove<100&&void 0;var a=t.y>0==e.y>0;return tr(t)&&tr(e)&&a}},e}(Ho),ir={panStep:100,bearingStep:15,pitchStep:10},or=function(){var t=ir;this._panStep=t.panStep,this._bearingStep=t.bearingStep,this._pitchStep=t.pitchStep;};function rr(t){return t*(2-t)}or.prototype.reset=function(){this._active=!1;},or.prototype.keydown=function(t){var e=this;if(!(t.altKey||t.ctrlKey||t.metaKey)){var i=0,o=0,r=0,a=0,n=0;switch(t.keyCode){case 61:case 107:case 171:case 187:i=1;break;case 189:case 109:case 173:i=-1;break;case 37:t.shiftKey?o=-1:(t.preventDefault(),a=-1);break;case 39:t.shiftKey?o=1:(t.preventDefault(),a=1);break;case 38:t.shiftKey?r=1:(t.preventDefault(),n=-1);break;case 40:t.shiftKey?r=-1:(t.preventDefault(),n=1);break;default:return}return {cameraAnimation:function(s){var l=s.getZoom();s.easeTo({duration:300,easeId:"keyboardHandler",easing:rr,zoom:i?Math.round(l)+i*(t.shiftKey?2:1):l,bearing:s.getBearing()+o*e._bearingStep,pitch:s.getPitch()+r*e._pitchStep,offset:[-a*e._panStep,-n*e._panStep],center:s.getCenter()},{originalEvent:t});}}}},or.prototype.enable=function(){this._enabled=!0;},or.prototype.disable=function(){this._enabled=!1,this.reset();},or.prototype.isEnabled=function(){return this._enabled},or.prototype.isActive=function(){return this._active};var ar=function(e,i){this._map=e,this._el=e.getCanvasContainer(),this._handler=i,this._delta=0,this._defaultZoomRate=.01,this._wheelZoomRate=1/450,t.bindAll(["_onWheel","_onTimeout","_onScrollFrame","_onScrollFinished"],this);};ar.prototype.setZoomRate=function(t){this._defaultZoomRate=t;},ar.prototype.setWheelZoomRate=function(t){this._wheelZoomRate=t;},ar.prototype.isEnabled=function(){return !!this._enabled},ar.prototype.isActive=function(){return !!this._active||void 0!==this._finishTimeout},ar.prototype.isZooming=function(){return !!this._zooming},ar.prototype.enable=function(t){this.isEnabled()||(this._enabled=!0,this._aroundCenter=t&&"center"===t.around);},ar.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},ar.prototype.wheel=function(e){if(this.isEnabled()){var i=e.deltaMode===t.window.WheelEvent.DOM_DELTA_LINE?40*e.deltaY:e.deltaY,o=t.browser.now(),r=o-(this._lastWheelEventTime||0);this._lastWheelEventTime=o,0!==i&&i%4.000244140625==0?this._type="wheel":0!==i&&Math.abs(i)<4?this._type="trackpad":r>400?(this._type=null,this._lastValue=i,this._timeout=setTimeout(this._onTimeout,40,e)):this._type||(this._type=Math.abs(r*i)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,i+=this._lastValue)),e.shiftKey&&i&&(i/=4),this._type&&(this._lastWheelEvent=e,this._delta-=i,this._active||this._start(e)),e.preventDefault();}},ar.prototype._onTimeout=function(t){this._type="wheel",this._delta-=this._lastValue,this._active||this._start(t);},ar.prototype._start=function(e){if(this._delta){this._frameId&&(this._frameId=null),this._active=!0,this.isZooming()||(this._zooming=!0),this._finishTimeout&&(clearTimeout(this._finishTimeout),delete this._finishTimeout);var o=i.mousePos(this._el,e);this._around=t.LngLat.convert(this._aroundCenter?this._map.getCenter():this._map.unproject(o)),this._aroundPoint=this._map.transform.locationPoint(this._around),this._frameId||(this._frameId=!0,this._handler._triggerRenderFrame());}},ar.prototype.renderFrame=function(){return this._onScrollFrame()},ar.prototype._onScrollFrame=function(){var e=this;if(this._frameId&&(this._frameId=null,this.isActive())){var i=this._map.transform;if(0!==this._delta){var o="wheel"===this._type&&Math.abs(this._delta)>4.000244140625?this._wheelZoomRate:this._defaultZoomRate,r=2/(1+Math.exp(-Math.abs(this._delta*o)));this._delta<0&&0!==r&&(r=1/r);var a="number"==typeof this._targetZoom?i.zoomScale(this._targetZoom):i.scale;this._targetZoom=Math.min(i.maxZoom,Math.max(i.minZoom,i.scaleZoom(a*r))),"wheel"===this._type&&(this._startZoom=i.zoom,this._easing=this._smoothOutEasing(200)),this._delta=0;}var n,s="number"==typeof this._targetZoom?this._targetZoom:i.zoom,l=this._startZoom,c=this._easing,u=!1;if("wheel"===this._type&&l&&c){var h=Math.min((t.browser.now()-this._lastWheelEventTime)/200,1),p=c(h);n=t.number(l,s,p),h<1?this._frameId||(this._frameId=!0):u=!0;}else n=s,u=!0;return this._active=!0,u&&(this._active=!1,this._finishTimeout=setTimeout((function(){e._zooming=!1,e._handler._triggerRenderFrame(),delete e._targetZoom,delete e._finishTimeout;}),200)),{noInertia:!0,needsRenderFrame:!u,zoomDelta:n-i.zoom,around:this._aroundPoint,originalEvent:this._lastWheelEvent}}},ar.prototype._smoothOutEasing=function(e){var i=t.ease;if(this._prevEase){var o=this._prevEase,r=(t.browser.now()-o.start)/o.duration,a=o.easing(r+.01)-o.easing(r),n=.27/Math.sqrt(a*a+1e-4)*.01,s=Math.sqrt(.0729-n*n);i=t.bezier(n,s,.25,1);}return this._prevEase={start:t.browser.now(),duration:e,easing:i},i},ar.prototype.reset=function(){this._active=!1;};var nr=function(t,e){this._clickZoom=t,this._tapZoom=e;};nr.prototype.enable=function(){this._clickZoom.enable(),this._tapZoom.enable();},nr.prototype.disable=function(){this._clickZoom.disable(),this._tapZoom.disable();},nr.prototype.isEnabled=function(){return this._clickZoom.isEnabled()&&this._tapZoom.isEnabled()},nr.prototype.isActive=function(){return this._clickZoom.isActive()||this._tapZoom.isActive()};var sr=function(){this.reset();};sr.prototype.reset=function(){this._active=!1;},sr.prototype.dblclick=function(t,e){return t.preventDefault(),{cameraAnimation:function(i){i.easeTo({duration:300,zoom:i.getZoom()+(t.shiftKey?-1:1),around:i.unproject(e)},{originalEvent:t});}}},sr.prototype.enable=function(){this._enabled=!0;},sr.prototype.disable=function(){this._enabled=!1,this.reset();},sr.prototype.isEnabled=function(){return this._enabled},sr.prototype.isActive=function(){return this._active};var lr=function(){this._tap=new Zo({numTouches:1,numTaps:1}),this.reset();};lr.prototype.reset=function(){this._active=!1,delete this._swipePoint,delete this._swipeTouch,delete this._tapTime,this._tap.reset();},lr.prototype.touchstart=function(t,e,i){this._swipePoint||(this._tapTime&&t.timeStamp-this._tapTime>500&&this.reset(),this._tapTime?i.length>0&&(this._swipePoint=e[0],this._swipeTouch=i[0].identifier):this._tap.touchstart(t,e,i));},lr.prototype.touchmove=function(t,e,i){if(this._tapTime){if(this._swipePoint){if(i[0].identifier!==this._swipeTouch)return;var o=e[0],r=o.y-this._swipePoint.y;return this._swipePoint=o,t.preventDefault(),this._active=!0,{zoomDelta:r/128}}}else this._tap.touchmove(t,e,i);},lr.prototype.touchend=function(t,e,i){this._tapTime?this._swipePoint&&0===i.length&&this.reset():this._tap.touchend(t,e,i)&&(this._tapTime=t.timeStamp);},lr.prototype.touchcancel=function(){this.reset();},lr.prototype.enable=function(){this._enabled=!0;},lr.prototype.disable=function(){this._enabled=!1,this.reset();},lr.prototype.isEnabled=function(){return this._enabled},lr.prototype.isActive=function(){return this._active};var cr=function(t,e,i){this._el=t,this._mousePan=e,this._touchPan=i;};cr.prototype.enable=function(t){this._inertiaOptions=t||{},this._mousePan.enable(),this._touchPan.enable(),this._el.classList.add("mapboxgl-touch-drag-pan");},cr.prototype.disable=function(){this._mousePan.disable(),this._touchPan.disable(),this._el.classList.remove("mapboxgl-touch-drag-pan");},cr.prototype.isEnabled=function(){return this._mousePan.isEnabled()&&this._touchPan.isEnabled()},cr.prototype.isActive=function(){return this._mousePan.isActive()||this._touchPan.isActive()};var ur=function(t,e,i){this._pitchWithRotate=t.pitchWithRotate,this._mouseRotate=e,this._mousePitch=i;};ur.prototype.enable=function(){this._mouseRotate.enable(),this._pitchWithRotate&&this._mousePitch.enable();},ur.prototype.disable=function(){this._mouseRotate.disable(),this._mousePitch.disable();},ur.prototype.isEnabled=function(){return this._mouseRotate.isEnabled()&&(!this._pitchWithRotate||this._mousePitch.isEnabled())},ur.prototype.isActive=function(){return this._mouseRotate.isActive()||this._mousePitch.isActive()};var hr=function(t,e,i,o){this._el=t,this._touchZoom=e,this._touchRotate=i,this._tapDragZoom=o,this._rotationDisabled=!1,this._enabled=!0;};hr.prototype.enable=function(t){this._touchZoom.enable(t),this._rotationDisabled||this._touchRotate.enable(t),this._tapDragZoom.enable(),this._el.classList.add("mapboxgl-touch-zoom-rotate");},hr.prototype.disable=function(){this._touchZoom.disable(),this._touchRotate.disable(),this._tapDragZoom.disable(),this._el.classList.remove("mapboxgl-touch-zoom-rotate");},hr.prototype.isEnabled=function(){return this._touchZoom.isEnabled()&&(this._rotationDisabled||this._touchRotate.isEnabled())&&this._tapDragZoom.isEnabled()},hr.prototype.isActive=function(){return this._touchZoom.isActive()||this._touchRotate.isActive()||this._tapDragZoom.isActive()},hr.prototype.disableRotation=function(){this._rotationDisabled=!0,this._touchRotate.disable();},hr.prototype.enableRotation=function(){this._rotationDisabled=!1,this._touchZoom.isEnabled()&&this._touchRotate.enable();};var pr=function(t){return t.zoom||t.drag||t.pitch||t.rotate},dr=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),(e.prototype=Object.create(t&&t.prototype)).constructor=e,e}(t.Event);function _r(t){return t.panDelta&&t.panDelta.mag()||t.zoomDelta||t.bearingDelta||t.pitchDelta}var fr=function(e,o){this._map=e,this._el=this._map.getCanvasContainer(),this._handlers=[],this._handlersById={},this._changes=[],this._inertia=new Do(e),this._bearingSnap=o.bearingSnap,this._previousActiveHandlers={},this._eventsInProgress={},this._addDefaultHandlers(o),t.bindAll(["handleEvent","handleWindowEvent"],this);var r=this._el;this._listeners=[[r,"touchstart",{passive:!1}],[r,"touchmove",{passive:!1}],[r,"touchend",void 0],[r,"touchcancel",void 0],[r,"mousedown",void 0],[r,"mousemove",void 0],[r,"mouseup",void 0],[t.window.document,"mousemove",{capture:!0}],[t.window.document,"mouseup",void 0],[r,"mouseover",void 0],[r,"mouseout",void 0],[r,"dblclick",void 0],[r,"click",void 0],[r,"keydown",{capture:!1}],[r,"keyup",void 0],[r,"wheel",{passive:!1}],[r,"contextmenu",void 0],[t.window,"blur",void 0]];for(var a=0,n=this._listeners;a<n.length;a+=1){var s=n[a],l=s[0];i.addEventListener(l,s[1],l===t.window.document?this.handleWindowEvent:this.handleEvent,s[2]);}};fr.prototype.destroy=function(){for(var e=0,o=this._listeners;e<o.length;e+=1){var r=o[e],a=r[0];i.removeEventListener(a,r[1],a===t.window.document?this.handleWindowEvent:this.handleEvent,r[2]);}},fr.prototype._addDefaultHandlers=function(t){var e=this._map,i=e.getCanvasContainer();this._add("mapEvent",new Bo(e,t));var o=e.boxZoom=new Fo(e,t);this._add("boxZoom",o);var r=new jo,a=new sr;e.doubleClickZoom=new nr(a,r),this._add("tapZoom",r),this._add("clickZoom",a);var n=new lr;this._add("tapDragZoom",n);var s=e.touchPitch=new er;this._add("touchPitch",s);var l=new Go(t),c=new Wo(t);e.dragRotate=new ur(t,l,c),this._add("mouseRotate",l,["mousePitch"]),this._add("mousePitch",c,["mouseRotate"]);var u=new Vo(t),h=new Xo(t);e.dragPan=new cr(i,u,h),this._add("mousePan",u),this._add("touchPan",h,["touchZoom","touchRotate"]);var p=new $o,d=new Jo;e.touchZoomRotate=new hr(i,d,p,n),this._add("touchRotate",p,["touchPan","touchZoom"]),this._add("touchZoom",d,["touchPan","touchRotate"]);var _=e.scrollZoom=new ar(e,this);this._add("scrollZoom",_,["mousePan"]);var f=e.keyboard=new or;this._add("keyboard",f),this._add("blockableMapEvent",new Oo(e));for(var m=0,g=["boxZoom","doubleClickZoom","tapDragZoom","touchPitch","dragRotate","dragPan","touchZoomRotate","scrollZoom","keyboard"];m<g.length;m+=1){var v=g[m];t.interactive&&t[v]&&e[v].enable(t[v]);}},fr.prototype._add=function(t,e,i){this._handlers.push({handlerName:t,handler:e,allowed:i}),this._handlersById[t]=e;},fr.prototype.stop=function(){if(!this._updatingCamera){for(var t=0,e=this._handlers;t<e.length;t+=1)e[t].handler.reset();this._inertia.clear(),this._fireEvents({},{}),this._changes=[];}},fr.prototype.isActive=function(){for(var t=0,e=this._handlers;t<e.length;t+=1)if(e[t].handler.isActive())return !0;return !1},fr.prototype.isZooming=function(){return !!this._eventsInProgress.zoom||this._map.scrollZoom.isZooming()},fr.prototype.isRotating=function(){return !!this._eventsInProgress.rotate},fr.prototype.isMoving=function(){return Boolean(pr(this._eventsInProgress))||this.isZooming()},fr.prototype._blockedByActive=function(t,e,i){for(var o in t)if(o!==i&&(!e||e.indexOf(o)<0))return !0;return !1},fr.prototype.handleWindowEvent=function(t){this.handleEvent(t,t.type+"Window");},fr.prototype._getMapTouches=function(t){for(var e=[],i=0,o=t;i<o.length;i+=1){var r=o[i];this._el.contains(r.target)&&e.push(r);}return e},fr.prototype.handleEvent=function(t,e){if("blur"!==t.type){this._updatingCamera=!0;for(var o="renderFrame"===t.type?void 0:t,r={needsRenderFrame:!1},a={},n={},s=t.touches?this._getMapTouches(t.touches):void 0,l=s?i.touchPos(this._el,s):i.mousePos(this._el,t),c=0,u=this._handlers;c<u.length;c+=1){var h=u[c],p=h.handlerName,d=h.handler,_=h.allowed;if(d.isEnabled()){var f=void 0;this._blockedByActive(n,_,p)?d.reset():d[e||t.type]&&(f=d[e||t.type](t,l,s),this.mergeHandlerResult(r,a,f,p,o),f&&f.needsRenderFrame&&this._triggerRenderFrame()),(f||d.isActive())&&(n[p]=d);}}var m={};for(var g in this._previousActiveHandlers)n[g]||(m[g]=o);this._previousActiveHandlers=n,(Object.keys(m).length||_r(r))&&(this._changes.push([r,a,m]),this._triggerRenderFrame()),(Object.keys(n).length||_r(r))&&this._map._stop(!0),this._updatingCamera=!1;var v=r.cameraAnimation;v&&(this._inertia.clear(),this._fireEvents({},{}),this._changes=[],v(this._map));}else this.stop();},fr.prototype.mergeHandlerResult=function(e,i,o,r,a){if(o){t.extend(e,o);var n={handlerName:r,originalEvent:o.originalEvent||a};void 0!==o.zoomDelta&&(i.zoom=n),void 0!==o.panDelta&&(i.drag=n),void 0!==o.pitchDelta&&(i.pitch=n),void 0!==o.bearingDelta&&(i.rotate=n);}},fr.prototype._applyChanges=function(){for(var e={},i={},o={},r=0,a=this._changes;r<a.length;r+=1){var n=a[r],s=n[0],l=n[1],c=n[2];s.panDelta&&(e.panDelta=(e.panDelta||new t.Point(0,0))._add(s.panDelta)),s.zoomDelta&&(e.zoomDelta=(e.zoomDelta||0)+s.zoomDelta),s.bearingDelta&&(e.bearingDelta=(e.bearingDelta||0)+s.bearingDelta),s.pitchDelta&&(e.pitchDelta=(e.pitchDelta||0)+s.pitchDelta),void 0!==s.around&&(e.around=s.around),void 0!==s.pinchAround&&(e.pinchAround=s.pinchAround),s.noInertia&&(e.noInertia=s.noInertia),t.extend(i,l),t.extend(o,c);}this._updateMapTransform(e,i,o),this._changes=[];},fr.prototype._updateMapTransform=function(t,e,i){var o=this._map,r=o.transform;if(!_r(t))return this._fireEvents(e,i);var a=t.panDelta,n=t.zoomDelta,s=t.bearingDelta,l=t.pitchDelta,c=t.around,u=t.pinchAround;void 0!==u&&(c=u),o._stop(!0),c=c||o.transform.centerPoint;var h=r.pointLocation(a?c.sub(a):c);s&&(r.bearing+=s),l&&(r.pitch+=l),n&&(r.zoom+=n),r.setLocationAtPoint(h,c),this._map._update(),t.noInertia||this._inertia.record(t),this._fireEvents(e,i);},fr.prototype._fireEvents=function(e,i){var o=this,r=pr(this._eventsInProgress),a=pr(e),n={};for(var s in e)this._eventsInProgress[s]||(n[s+"start"]=e[s].originalEvent),this._eventsInProgress[s]=e[s];for(var l in !r&&a&&this._fireEvent("movestart",a.originalEvent),n)this._fireEvent(l,n[l]);for(var c in e.rotate&&(this._bearingChanged=!0),a&&this._fireEvent("move",a.originalEvent),e)this._fireEvent(c,e[c].originalEvent);var u,h={};for(var p in this._eventsInProgress){var d=this._eventsInProgress[p],_=d.handlerName,f=d.originalEvent;this._handlersById[_].isActive()||(delete this._eventsInProgress[p],h[p+"end"]=u=i[_]||f);}for(var m in h)this._fireEvent(m,h[m]);var g=pr(this._eventsInProgress);if((r||a)&&!g){this._updatingCamera=!0;var v=this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions),y=function(t){return 0!==t&&-o._bearingSnap<t&&t<o._bearingSnap};v?(y(v.bearing||this._map.getBearing())&&(v.bearing=0),this._map.easeTo(v,{originalEvent:u})):(this._map.fire(new t.Event("moveend",{originalEvent:u})),y(this._map.getBearing())&&this._map.resetNorth()),this._bearingChanged=!1,this._updatingCamera=!1;}},fr.prototype._fireEvent=function(e,i){this._map.fire(new t.Event(e,i?{originalEvent:i}:{}));},fr.prototype._triggerRenderFrame=function(){var t=this;void 0===this._frameId&&(this._frameId=this._map._requestRenderFrame((function(e){delete t._frameId,t.handleEvent(new dr("renderFrame",{timeStamp:e})),t._applyChanges();})));};var mr=function(e){function i(i,o){e.call(this),this._moving=!1,this._zooming=!1,this.transform=i,this._bearingSnap=o.bearingSnap,t.bindAll(["_renderFrameCallback"],this);}return e&&(i.__proto__=e),(i.prototype=Object.create(e&&e.prototype)).constructor=i,i.prototype.getCenter=function(){return new t.LngLat(this.transform.center.lng,this.transform.center.lat)},i.prototype.setCenter=function(t,e){return this.jumpTo({center:t},e)},i.prototype.panBy=function(e,i,o){return e=t.Point.convert(e).mult(-1),this.panTo(this.transform.center,t.extend({offset:e},i),o)},i.prototype.panTo=function(e,i,o){return this.easeTo(t.extend({center:e},i),o)},i.prototype.getZoom=function(){return this.transform.zoom},i.prototype.setZoom=function(t,e){return this.jumpTo({zoom:t},e),this},i.prototype.zoomTo=function(e,i,o){return this.easeTo(t.extend({zoom:e},i),o)},i.prototype.zoomIn=function(t,e){return this.zoomTo(this.getZoom()+1,t,e),this},i.prototype.zoomOut=function(t,e){return this.zoomTo(this.getZoom()-1,t,e),this},i.prototype.getBearing=function(){return this.transform.bearing},i.prototype.setBearing=function(t,e){return this.jumpTo({bearing:t},e),this},i.prototype.getPadding=function(){return this.transform.padding},i.prototype.setPadding=function(t,e){return this.jumpTo({padding:t},e),this},i.prototype.rotateTo=function(e,i,o){return this.easeTo(t.extend({bearing:e},i),o)},i.prototype.resetNorth=function(e,i){return this.rotateTo(0,t.extend({duration:1e3},e),i),this},i.prototype.resetNorthPitch=function(e,i){return this.easeTo(t.extend({bearing:0,pitch:0,duration:1e3},e),i),this},i.prototype.snapToNorth=function(t,e){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(t,e):this},i.prototype.getPitch=function(){return this.transform.pitch},i.prototype.setPitch=function(t,e){return this.jumpTo({pitch:t},e),this},i.prototype.cameraForBounds=function(e,i){return e=t.LngLatBounds.convert(e),this._cameraForBoxAndBearing(e.getNorthWest(),e.getSouthEast(),0,i)},i.prototype._cameraForBoxAndBearing=function(e,i,o,r){var a={top:0,bottom:0,right:0,left:0};if("number"==typeof(r=t.extend({padding:a,offset:[0,0],maxZoom:this.transform.maxZoom},r)).padding){var n=r.padding;r.padding={top:n,bottom:n,right:n,left:n};}r.padding=t.extend(a,r.padding);var s=this.transform,l=s.padding,c=s.project(t.LngLat.convert(e)),u=s.project(t.LngLat.convert(i)),h=c.rotate(-o*Math.PI/180),p=u.rotate(-o*Math.PI/180),d=new t.Point(Math.max(h.x,p.x),Math.max(h.y,p.y)),_=new t.Point(Math.min(h.x,p.x),Math.min(h.y,p.y)),f=d.sub(_),m=(s.width-(l.left+l.right+r.padding.left+r.padding.right))/f.x,g=(s.height-(l.top+l.bottom+r.padding.top+r.padding.bottom))/f.y;if(!(g<0||m<0)){var v=Math.min(s.scaleZoom(s.scale*Math.min(m,g)),r.maxZoom),y=t.Point.convert(r.offset),x=new t.Point(y.x+(r.padding.left-r.padding.right)/2,y.y+(r.padding.top-r.padding.bottom)/2).mult(s.scale/s.zoomScale(v));return {center:s.unproject(c.add(u).div(2).sub(x)),zoom:v,bearing:o}}t.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");},i.prototype.fitBounds=function(t,e,i){return this._fitInternal(this.cameraForBounds(t,e),e,i)},i.prototype.fitScreenCoordinates=function(e,i,o,r,a){return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t.Point.convert(e)),this.transform.pointLocation(t.Point.convert(i)),o,r),r,a)},i.prototype._fitInternal=function(e,i,o){return e?(delete(i=t.extend(e,i)).padding,i.linear?this.easeTo(i,o):this.flyTo(i,o)):this},i.prototype.jumpTo=function(e,i){this.stop();var o=this.transform,r=!1,a=!1,n=!1;return "zoom"in e&&o.zoom!==+e.zoom&&(r=!0,o.zoom=+e.zoom),void 0!==e.center&&(o.center=t.LngLat.convert(e.center)),"bearing"in e&&o.bearing!==+e.bearing&&(a=!0,o.bearing=+e.bearing),"pitch"in e&&o.pitch!==+e.pitch&&(n=!0,o.pitch=+e.pitch),null==e.padding||o.isPaddingEqual(e.padding)||(o.padding=e.padding),this.fire(new t.Event("movestart",i)).fire(new t.Event("move",i)),r&&this.fire(new t.Event("zoomstart",i)).fire(new t.Event("zoom",i)).fire(new t.Event("zoomend",i)),a&&this.fire(new t.Event("rotatestart",i)).fire(new t.Event("rotate",i)).fire(new t.Event("rotateend",i)),n&&this.fire(new t.Event("pitchstart",i)).fire(new t.Event("pitch",i)).fire(new t.Event("pitchend",i)),this.fire(new t.Event("moveend",i))},i.prototype.easeTo=function(e,i){var o=this;this._stop(!1,e.easeId),(!1===(e=t.extend({offset:[0,0],duration:500,easing:t.ease},e)).animate||!e.essential&&t.browser.prefersReducedMotion)&&(e.duration=0);var r=this.transform,a=this.getZoom(),n=this.getBearing(),s=this.getPitch(),l=this.getPadding(),c="zoom"in e?+e.zoom:a,u="bearing"in e?this._normalizeBearing(e.bearing,n):n,h="pitch"in e?+e.pitch:s,p="padding"in e?e.padding:r.padding,d=t.Point.convert(e.offset),_=r.centerPoint.add(d),f=r.pointLocation(_),m=t.LngLat.convert(e.center||f);this._normalizeCenter(m);var g,v,y=r.project(f),x=r.project(m).sub(y),b=r.zoomScale(c-a);e.around&&(g=t.LngLat.convert(e.around),v=r.locationPoint(g));var w={moving:this._moving,zooming:this._zooming,rotating:this._rotating,pitching:this._pitching};return this._zooming=this._zooming||c!==a,this._rotating=this._rotating||n!==u,this._pitching=this._pitching||h!==s,this._padding=!r.isPaddingEqual(p),this._easeId=e.easeId,this._prepareEase(i,e.noMoveStart,w),clearTimeout(this._easeEndTimeoutID),this._ease((function(e){if(o._zooming&&(r.zoom=t.number(a,c,e)),o._rotating&&(r.bearing=t.number(n,u,e)),o._pitching&&(r.pitch=t.number(s,h,e)),o._padding&&(r.interpolatePadding(l,p,e),_=r.centerPoint.add(d)),g)r.setLocationAtPoint(g,v);else {var f=r.zoomScale(r.zoom-a),m=c>a?Math.min(2,b):Math.max(.5,b),w=Math.pow(m,1-e),T=r.unproject(y.add(x.mult(e*w)).mult(f));r.setLocationAtPoint(r.renderWorldCopies?T.wrap():T,_);}o._fireMoveEvents(i);}),(function(t){o._afterEase(i,t);}),e),this},i.prototype._prepareEase=function(e,i,o){void 0===o&&(o={}),this._moving=!0,i||o.moving||this.fire(new t.Event("movestart",e)),this._zooming&&!o.zooming&&this.fire(new t.Event("zoomstart",e)),this._rotating&&!o.rotating&&this.fire(new t.Event("rotatestart",e)),this._pitching&&!o.pitching&&this.fire(new t.Event("pitchstart",e));},i.prototype._fireMoveEvents=function(e){this.fire(new t.Event("move",e)),this._zooming&&this.fire(new t.Event("zoom",e)),this._rotating&&this.fire(new t.Event("rotate",e)),this._pitching&&this.fire(new t.Event("pitch",e));},i.prototype._afterEase=function(e,i){if(!this._easeId||!i||this._easeId!==i){delete this._easeId;var o=this._zooming,r=this._rotating,a=this._pitching;this._moving=!1,this._zooming=!1,this._rotating=!1,this._pitching=!1,this._padding=!1,o&&this.fire(new t.Event("zoomend",e)),r&&this.fire(new t.Event("rotateend",e)),a&&this.fire(new t.Event("pitchend",e)),this.fire(new t.Event("moveend",e));}},i.prototype.flyTo=function(e,i){var o=this;if(!e.essential&&t.browser.prefersReducedMotion){var r=t.pick(e,["center","zoom","bearing","pitch","around"]);return this.jumpTo(r,i)}this.stop(),e=t.extend({offset:[0,0],speed:1.2,curve:1.42,easing:t.ease},e);var a=this.transform,n=this.getZoom(),s=this.getBearing(),l=this.getPitch(),c=this.getPadding(),u="zoom"in e?t.clamp(+e.zoom,a.minZoom,a.maxZoom):n,h="bearing"in e?this._normalizeBearing(e.bearing,s):s,p="pitch"in e?+e.pitch:l,d="padding"in e?e.padding:a.padding,_=a.zoomScale(u-n),f=t.Point.convert(e.offset),m=a.centerPoint.add(f),g=a.pointLocation(m),v=t.LngLat.convert(e.center||g);this._normalizeCenter(v);var y=a.project(g),x=a.project(v).sub(y),b=e.curve,w=Math.max(a.width,a.height),T=w/_,E=x.mag();if("minZoom"in e){var I=t.clamp(Math.min(e.minZoom,n,u),a.minZoom,a.maxZoom),P=w/a.zoomScale(I-n);b=Math.sqrt(P/E*2);}var S=b*b;function C(t){var e=(T*T-w*w+(t?-1:1)*S*S*E*E)/(2*(t?T:w)*S*E);return Math.log(Math.sqrt(e*e+1)-e)}function z(t){return (Math.exp(t)-Math.exp(-t))/2}function D(t){return (Math.exp(t)+Math.exp(-t))/2}var M=C(0),L=function(t){return D(M)/D(M+b*t)},A=function(t){return w*((D(M)*(z(e=M+b*t)/D(e))-z(M))/S)/E;var e;},R=(C(1)-M)/b;if(Math.abs(E)<1e-6||!isFinite(R)){if(Math.abs(w-T)<1e-6)return this.easeTo(e,i);var k=T<w?-1:1;R=Math.abs(Math.log(T/w))/b,A=function(){return 0},L=function(t){return Math.exp(k*b*t)};}return e.duration="duration"in e?+e.duration:1e3*R/("screenSpeed"in e?+e.screenSpeed/b:+e.speed),e.maxDuration&&e.duration>e.maxDuration&&(e.duration=0),this._zooming=!0,this._rotating=s!==h,this._pitching=p!==l,this._padding=!a.isPaddingEqual(d),this._prepareEase(i,!1),this._ease((function(e){var r=e*R,_=1/L(r);a.zoom=1===e?u:n+a.scaleZoom(_),o._rotating&&(a.bearing=t.number(s,h,e)),o._pitching&&(a.pitch=t.number(l,p,e)),o._padding&&(a.interpolatePadding(c,d,e),m=a.centerPoint.add(f));var g=1===e?v:a.unproject(y.add(x.mult(A(r))).mult(_));a.setLocationAtPoint(a.renderWorldCopies?g.wrap():g,m),o._fireMoveEvents(i);}),(function(){return o._afterEase(i)}),e),this},i.prototype.isEasing=function(){return !!this._easeFrameId},i.prototype.stop=function(){return this._stop()},i.prototype._stop=function(t,e){if(this._easeFrameId&&(this._cancelRenderFrame(this._easeFrameId),delete this._easeFrameId,delete this._onEaseFrame),this._onEaseEnd){var i=this._onEaseEnd;delete this._onEaseEnd,i.call(this,e);}if(!t){var o=this.handlers;o&&o.stop();}return this},i.prototype._ease=function(e,i,o){!1===o.animate||0===o.duration?(e(1),i()):(this._easeStart=t.browser.now(),this._easeOptions=o,this._onEaseFrame=e,this._onEaseEnd=i,this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback));},i.prototype._renderFrameCallback=function(){var e=Math.min((t.browser.now()-this._easeStart)/this._easeOptions.duration,1);this._onEaseFrame(this._easeOptions.easing(e)),e<1?this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback):this.stop();},i.prototype._normalizeBearing=function(e,i){e=t.wrap(e,-180,180);var o=Math.abs(e-i);return Math.abs(e-360-i)<o&&(e-=360),Math.abs(e+360-i)<o&&(e+=360),e},i.prototype._normalizeCenter=function(t){var e=this.transform;if(e.renderWorldCopies&&!e.lngRange){var i=t.lng-e.center.lng;t.lng+=i>180?-360:i<-180?360:0;}},i}(t.Evented),gr=function(e){void 0===e&&(e={}),this.options=e,t.bindAll(["_updateEditLink","_updateData","_updateCompact"],this);};gr.prototype.getDefaultPosition=function(){return "bottom-right"},gr.prototype.onAdd=function(t){var e=this.options&&this.options.compact;return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),this._innerContainer=i.create("div","mapboxgl-ctrl-attrib-inner",this._container),e&&this._container.classList.add("mapboxgl-compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("styledata",this._updateData),this._map.on("sourcedata",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===e&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container},gr.prototype.onRemove=function(){i.remove(this._container),this._map.off("styledata",this._updateData),this._map.off("sourcedata",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0,this._attribHTML=void 0;},gr.prototype._updateEditLink=function(){var e=this._editLink;e||(e=this._editLink=this._container.querySelector(".mapbox-improve-map"));var i=[{key:"owner",value:this.styleOwner},{key:"id",value:this.styleId},{key:"access_token",value:this._map._requestManager._customAccessToken||t.config.ACCESS_TOKEN}];if(e){var o=i.reduce((function(t,e,o){return e.value&&(t+=e.key+"="+e.value+(o<i.length-1?"&":"")),t}),"?");e.href=t.config.FEEDBACK_URL+"/"+o+(this._map._hash?this._map._hash.getHashString(!0):""),e.rel="noopener nofollow";}},gr.prototype._updateData=function(t){!t||"metadata"!==t.sourceDataType&&"style"!==t.dataType||(this._updateAttributions(),this._updateEditLink());},gr.prototype._updateAttributions=function(){if(this._map.style){var t=[];if(this.options.customAttribution&&(Array.isArray(this.options.customAttribution)?t=t.concat(this.options.customAttribution.map((function(t){return "string"!=typeof t?"":t}))):"string"==typeof this.options.customAttribution&&t.push(this.options.customAttribution)),this._map.style.stylesheet){var e=this._map.style.stylesheet;this.styleOwner=e.owner,this.styleId=e.id;}var i=this._map.style.sourceCaches;for(var o in i){var r=i[o];if(r.used){var a=r.getSource();a.attribution&&t.indexOf(a.attribution)<0&&t.push(a.attribution);}}t.sort((function(t,e){return t.length-e.length}));var n=(t=t.filter((function(e,i){for(var o=i+1;o<t.length;o++)if(t[o].indexOf(e)>=0)return !1;return !0}))).join(" | ");n!==this._attribHTML&&(this._attribHTML=n,t.length?(this._innerContainer.innerHTML=n,this._container.classList.remove("mapboxgl-attrib-empty")):this._container.classList.add("mapboxgl-attrib-empty"),this._editLink=null);}},gr.prototype._updateCompact=function(){this._map.getCanvasContainer().offsetWidth<=640?this._container.classList.add("mapboxgl-compact"):this._container.classList.remove("mapboxgl-compact");};var vr=function(){t.bindAll(["_updateLogo"],this),t.bindAll(["_updateCompact"],this);};vr.prototype.onAdd=function(t){this._map=t,this._container=i.create("div","mapboxgl-ctrl");var e=i.create("a","mapboxgl-ctrl-logo");return e.target="_blank",e.rel="noopener nofollow",e.href="https://www.mapbox.com/",e.setAttribute("aria-label",this._map._getUIString("LogoControl.Title")),e.setAttribute("rel","noopener nofollow"),this._container.appendChild(e),this._container.style.display="none",this._map.on("sourcedata",this._updateLogo),this._updateLogo(),this._map.on("resize",this._updateCompact),this._updateCompact(),this._container},vr.prototype.onRemove=function(){i.remove(this._container),this._map.off("sourcedata",this._updateLogo),this._map.off("resize",this._updateCompact);},vr.prototype.getDefaultPosition=function(){return "bottom-left"},vr.prototype._updateLogo=function(t){t&&"metadata"!==t.sourceDataType||(this._container.style.display=this._logoRequired()?"block":"none");},vr.prototype._logoRequired=function(){if(this._map.style){var t=this._map.style.sourceCaches;for(var e in t)if(t[e].getSource().mapbox_logo)return !0;return !1}},vr.prototype._updateCompact=function(){var t=this._container.children;if(t.length){var e=t[0];this._map.getCanvasContainer().offsetWidth<250?e.classList.add("mapboxgl-compact"):e.classList.remove("mapboxgl-compact");}};var yr=function(){this._queue=[],this._id=0,this._cleared=!1,this._currentlyRunning=!1;};yr.prototype.add=function(t){var e=++this._id;return this._queue.push({callback:t,id:e,cancelled:!1}),e},yr.prototype.remove=function(t){for(var e=this._currentlyRunning,i=0,o=e?this._queue.concat(e):this._queue;i<o.length;i+=1){var r=o[i];if(r.id===t)return void(r.cancelled=!0)}},yr.prototype.run=function(t){void 0===t&&(t=0);var e=this._currentlyRunning=this._queue;this._queue=[];for(var i=0,o=e;i<o.length;i+=1){var r=o[i];if(!r.cancelled&&(r.callback(t),this._cleared))break}this._cleared=!1,this._currentlyRunning=!1;},yr.prototype.clear=function(){this._currentlyRunning&&(this._cleared=!0),this._queue=[];};var xr={"FullscreenControl.Enter":"Enter fullscreen","FullscreenControl.Exit":"Exit fullscreen","GeolocateControl.FindMyLocation":"Find my location","GeolocateControl.LocationNotAvailable":"Location not available","LogoControl.Title":"Mapbox logo","NavigationControl.ResetBearing":"Reset bearing to north","NavigationControl.ZoomIn":"Zoom in","NavigationControl.ZoomOut":"Zoom out","ScaleControl.Feet":"ft","ScaleControl.Meters":"m","ScaleControl.Kilometers":"km","ScaleControl.Miles":"mi","ScaleControl.NauticalMiles":"nm"},br=t.window.HTMLImageElement,wr=t.window.HTMLElement,Tr=t.window.ImageBitmap,Er={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:-2,maxZoom:22,minPitch:0,maxPitch:60,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,touchPitch:!0,bearingSnap:7,clickTolerance:3,pitchWithRotate:!0,hash:!1,attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0,renderWorldCopies:!0,refreshExpiredTiles:!0,maxTileCacheSize:null,localIdeographFontFamily:"sans-serif",transformRequest:null,accessToken:null,fadeDuration:300,crossSourceCollisions:!0},Ir=function(o){function r(e){var i=this;if(null!=(e=t.extend({},Er,e)).minZoom&&null!=e.maxZoom&&e.minZoom>e.maxZoom)throw new Error("maxZoom must be greater than or equal to minZoom");if(null!=e.minPitch&&null!=e.maxPitch&&e.minPitch>e.maxPitch)throw new Error("maxPitch must be greater than or equal to minPitch");if(null!=e.minPitch&&e.minPitch<0)throw new Error("minPitch must be greater than or equal to 0");if(null!=e.maxPitch&&e.maxPitch>60)throw new Error("maxPitch must be less than or equal to 60");var r=new wo(e.minZoom,e.maxZoom,e.minPitch,e.maxPitch,e.renderWorldCopies);if(o.call(this,r,e),this._interactive=e.interactive,this._maxTileCacheSize=e.maxTileCacheSize,this._failIfMajorPerformanceCaveat=e.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=e.preserveDrawingBuffer,this._antialias=e.antialias,this._trackResize=e.trackResize,this._bearingSnap=e.bearingSnap,this._refreshExpiredTiles=e.refreshExpiredTiles,this._fadeDuration=e.fadeDuration,this._crossSourceCollisions=e.crossSourceCollisions,this._crossFadingFactor=1,this._collectResourceTiming=e.collectResourceTiming,this._renderTaskQueue=new yr,this._controls=[],this._mapId=t.uniqueId(),this._locale=t.extend({},xr,e.locale),this._requestManager=new t.RequestManager(e.transformRequest,e.accessToken),"string"==typeof e.container){if(this._container=t.window.document.getElementById(e.container),!this._container)throw new Error("Container '"+e.container+"' not found.")}else {if(!(e.container instanceof wr))throw new Error("Invalid type: 'container' must be a String or HTMLElement.");this._container=e.container;}if(e.maxBounds&&this.setMaxBounds(e.maxBounds),t.bindAll(["_onWindowOnline","_onWindowResize","_contextLost","_contextRestored"],this),this._setupContainer(),this._setupPainter(),void 0===this.painter)throw new Error("Failed to initialize WebGL.");this.on("move",(function(){return i._update(!1)})),this.on("moveend",(function(){return i._update(!1)})),this.on("zoom",(function(){return i._update(!0)})),void 0!==t.window&&(t.window.addEventListener("online",this._onWindowOnline,!1),t.window.addEventListener("resize",this._onWindowResize,!1)),this.handlers=new fr(this,e),this._hash=e.hash&&new Eo("string"==typeof e.hash&&e.hash||void 0).addTo(this),this._hash&&this._hash._onHashChange()||(this.jumpTo({center:e.center,zoom:e.zoom,bearing:e.bearing,pitch:e.pitch}),e.bounds&&(this.resize(),this.fitBounds(e.bounds,t.extend({},e.fitBoundsOptions,{duration:0})))),this.resize(),this._localIdeographFontFamily=e.localIdeographFontFamily,e.style&&this.setStyle(e.style,{localIdeographFontFamily:e.localIdeographFontFamily}),e.attributionControl&&this.addControl(new gr({customAttribution:e.customAttribution})),this.addControl(new vr,e.logoPosition),this.on("style.load",(function(){i.transform.unmodified&&i.jumpTo(i.style.stylesheet);})),this.on("data",(function(e){i._update("style"===e.dataType),i.fire(new t.Event(e.dataType+"data",e));})),this.on("dataloading",(function(e){i.fire(new t.Event(e.dataType+"dataloading",e));}));}o&&(r.__proto__=o),(r.prototype=Object.create(o&&o.prototype)).constructor=r;var a={showTileBoundaries:{configurable:!0},showPadding:{configurable:!0},showCollisionBoxes:{configurable:!0},showOverdrawInspector:{configurable:!0},repaint:{configurable:!0},vertices:{configurable:!0},version:{configurable:!0}};return r.prototype._getMapId=function(){return this._mapId},r.prototype.addControl=function(e,i){if(void 0===i&&e.getDefaultPosition&&(i=e.getDefaultPosition()),void 0===i&&(i="top-right"),!e||!e.onAdd)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));var o=e.onAdd(this);this._controls.push(e);var r=this._controlPositions[i];return -1!==i.indexOf("bottom")?r.insertBefore(o,r.firstChild):r.appendChild(o),this},r.prototype.removeControl=function(e){if(!e||!e.onRemove)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));var i=this._controls.indexOf(e);return i>-1&&this._controls.splice(i,1),e.onRemove(this),this},r.prototype.resize=function(e){var i=this._containerDimensions(),o=i[0],r=i[1];this._resizeCanvas(o,r),this.transform.resize(o,r),this.painter.resize(o,r);var a=!this._moving;return a&&(this.stop(),this.fire(new t.Event("movestart",e)).fire(new t.Event("move",e))),this.fire(new t.Event("resize",e)),a&&this.fire(new t.Event("moveend",e)),this},r.prototype.getBounds=function(){return this.transform.getBounds()},r.prototype.getMaxBounds=function(){return this.transform.getMaxBounds()},r.prototype.setMaxBounds=function(e){return this.transform.setMaxBounds(t.LngLatBounds.convert(e)),this._update()},r.prototype.setMinZoom=function(t){if((t=null==t?-2:t)>=-2&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t&&this.setZoom(t),this;throw new Error("minZoom must be between -2 and the current maxZoom, inclusive")},r.prototype.getMinZoom=function(){return this.transform.minZoom},r.prototype.setMaxZoom=function(t){if((t=null==t?22:t)>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t&&this.setZoom(t),this;throw new Error("maxZoom must be greater than the current minZoom")},r.prototype.getMaxZoom=function(){return this.transform.maxZoom},r.prototype.setMinPitch=function(t){if((t=null==t?0:t)<0)throw new Error("minPitch must be greater than or equal to 0");if(t>=0&&t<=this.transform.maxPitch)return this.transform.minPitch=t,this._update(),this.getPitch()<t&&this.setPitch(t),this;throw new Error("minPitch must be between 0 and the current maxPitch, inclusive")},r.prototype.getMinPitch=function(){return this.transform.minPitch},r.prototype.setMaxPitch=function(t){if((t=null==t?60:t)>60)throw new Error("maxPitch must be less than or equal to 60");if(t>=this.transform.minPitch)return this.transform.maxPitch=t,this._update(),this.getPitch()>t&&this.setPitch(t),this;throw new Error("maxPitch must be greater than the current minPitch")},r.prototype.getMaxPitch=function(){return this.transform.maxPitch},r.prototype.getRenderWorldCopies=function(){return this.transform.renderWorldCopies},r.prototype.setRenderWorldCopies=function(t){return this.transform.renderWorldCopies=t,this._update()},r.prototype.project=function(e){return this.transform.locationPoint(t.LngLat.convert(e))},r.prototype.unproject=function(e){return this.transform.pointLocation(t.Point.convert(e))},r.prototype.isMoving=function(){return this._moving||this.handlers.isMoving()},r.prototype.isZooming=function(){return this._zooming||this.handlers.isZooming()},r.prototype.isRotating=function(){return this._rotating||this.handlers.isRotating()},r.prototype._createDelegatedListener=function(t,e,i){var o,r=this;if("mouseenter"===t||"mouseover"===t){var a=!1;return {layer:e,listener:i,delegates:{mousemove:function(o){var n=r.getLayer(e)?r.queryRenderedFeatures(o.point,{layers:[e]}):[];n.length?a||(a=!0,i.call(r,new Ao(t,r,o.originalEvent,{features:n}))):a=!1;},mouseout:function(){a=!1;}}}}if("mouseleave"===t||"mouseout"===t){var n=!1;return {layer:e,listener:i,delegates:{mousemove:function(o){(r.getLayer(e)?r.queryRenderedFeatures(o.point,{layers:[e]}):[]).length?n=!0:n&&(n=!1,i.call(r,new Ao(t,r,o.originalEvent)));},mouseout:function(e){n&&(n=!1,i.call(r,new Ao(t,r,e.originalEvent)));}}}}return {layer:e,listener:i,delegates:(o={},o[t]=function(t){var o=r.getLayer(e)?r.queryRenderedFeatures(t.point,{layers:[e]}):[];o.length&&(t.features=o,i.call(r,t),delete t.features);},o)}},r.prototype.on=function(t,e,i){if(void 0===i)return o.prototype.on.call(this,t,e);var r=this._createDelegatedListener(t,e,i);for(var a in this._delegatedListeners=this._delegatedListeners||{},this._delegatedListeners[t]=this._delegatedListeners[t]||[],this._delegatedListeners[t].push(r),r.delegates)this.on(a,r.delegates[a]);return this},r.prototype.once=function(t,e,i){if(void 0===i)return o.prototype.once.call(this,t,e);var r=this._createDelegatedListener(t,e,i);for(var a in r.delegates)this.once(a,r.delegates[a]);return this},r.prototype.off=function(t,e,i){var r=this;return void 0===i?o.prototype.off.call(this,t,e):(this._delegatedListeners&&this._delegatedListeners[t]&&function(o){for(var a=o[t],n=0;n<a.length;n++){var s=a[n];if(s.layer===e&&s.listener===i){for(var l in s.delegates)r.off(l,s.delegates[l]);return a.splice(n,1),r}}}(this._delegatedListeners),this)},r.prototype.queryRenderedFeatures=function(e,i){if(!this.style)return [];var o;if(void 0!==i||void 0===e||e instanceof t.Point||Array.isArray(e)||(i=e,e=void 0),i=i||{},(e=e||[[0,0],[this.transform.width,this.transform.height]])instanceof t.Point||"number"==typeof e[0])o=[t.Point.convert(e)];else {var r=t.Point.convert(e[0]),a=t.Point.convert(e[1]);o=[r,new t.Point(a.x,r.y),a,new t.Point(r.x,a.y),r];}return this.style.queryRenderedFeatures(o,i,this.transform)},r.prototype.querySourceFeatures=function(t,e){return this.style.querySourceFeatures(t,e)},r.prototype.setStyle=function(e,i){return !1!==(i=t.extend({},{localIdeographFontFamily:this._localIdeographFontFamily},i)).diff&&i.localIdeographFontFamily===this._localIdeographFontFamily&&this.style&&e?(this._diffStyle(e,i),this):(this._localIdeographFontFamily=i.localIdeographFontFamily,this._updateStyle(e,i))},r.prototype._getUIString=function(t){var e=this._locale[t];if(null==e)throw new Error("Missing UI string '"+t+"'");return e},r.prototype._updateStyle=function(t,e){return this.style&&(this.style.setEventedParent(null),this.style._remove()),t?(this.style=new qe(this,e||{}),this.style.setEventedParent(this,{style:this.style}),"string"==typeof t?this.style.loadURL(t):this.style.loadJSON(t),this):(delete this.style,this)},r.prototype._lazyInitEmptyStyle=function(){this.style||(this.style=new qe(this,{}),this.style.setEventedParent(this,{style:this.style}),this.style.loadEmpty());},r.prototype._diffStyle=function(e,i){var o=this;if("string"==typeof e){var r=this._requestManager.normalizeStyleURL(e),a=this._requestManager.transformRequest(r,t.ResourceType.Style);t.getJSON(a,(function(e,r){e?o.fire(new t.ErrorEvent(e)):r&&o._updateDiff(r,i);}));}else "object"==typeof e&&this._updateDiff(e,i);},r.prototype._updateDiff=function(e,i){try{this.style.setState(e)&&this._update(!0);}catch(o){t.warnOnce("Unable to perform style diff: "+(o.message||o.error||o)+".  Rebuilding the style from scratch."),this._updateStyle(e,i);}},r.prototype.getStyle=function(){if(this.style)return this.style.serialize()},r.prototype.isStyleLoaded=function(){return this.style?this.style.loaded():t.warnOnce("There is no style added to the map.")},r.prototype.addSource=function(t,e){return this._lazyInitEmptyStyle(),this.style.addSource(t,e),this._update(!0)},r.prototype.isSourceLoaded=function(e){var i=this.style&&this.style.sourceCaches[e];if(void 0!==i)return i.loaded();this.fire(new t.ErrorEvent(new Error("There is no source with ID '"+e+"'")));},r.prototype.areTilesLoaded=function(){var t=this.style&&this.style.sourceCaches;for(var e in t){var i=t[e]._tiles;for(var o in i){var r=i[o];if("loaded"!==r.state&&"errored"!==r.state)return !1}}return !0},r.prototype.addSourceType=function(t,e,i){return this._lazyInitEmptyStyle(),this.style.addSourceType(t,e,i)},r.prototype.removeSource=function(t){return this.style.removeSource(t),this._update(!0)},r.prototype.getSource=function(t){return this.style.getSource(t)},r.prototype.addImage=function(e,i,o){void 0===o&&(o={});var r=o.pixelRatio;void 0===r&&(r=1);var a=o.sdf;void 0===a&&(a=!1);var n=o.stretchX,s=o.stretchY,l=o.content;if(this._lazyInitEmptyStyle(),i instanceof br||Tr&&i instanceof Tr){var c=t.browser.getImageData(i);this.style.addImage(e,{data:new t.RGBAImage({width:c.width,height:c.height},c.data),pixelRatio:r,stretchX:n,stretchY:s,content:l,sdf:a,version:0});}else {if(void 0===i.width||void 0===i.height)return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));var u=i;this.style.addImage(e,{data:new t.RGBAImage({width:i.width,height:i.height},new Uint8Array(i.data)),pixelRatio:r,stretchX:n,stretchY:s,content:l,sdf:a,version:0,userImage:u}),u.onAdd&&u.onAdd(this,e);}},r.prototype.updateImage=function(e,i){var o=this.style.getImage(e);if(!o)return this.fire(new t.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));var r=i instanceof br||Tr&&i instanceof Tr?t.browser.getImageData(i):i,a=r.width,n=r.height,s=r.data;return void 0===a||void 0===n?this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`"))):a!==o.data.width||n!==o.data.height?this.fire(new t.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image"))):(o.data.replace(s,!(i instanceof br||Tr&&i instanceof Tr)),void this.style.updateImage(e,o))},r.prototype.hasImage=function(e){return e?!!this.style.getImage(e):(this.fire(new t.ErrorEvent(new Error("Missing required image id"))),!1)},r.prototype.removeImage=function(t){this.style.removeImage(t);},r.prototype.loadImage=function(e,i){t.getImage(this._requestManager.transformRequest(e,t.ResourceType.Image),i);},r.prototype.listImages=function(){return this.style.listImages()},r.prototype.addLayer=function(t,e){return this._lazyInitEmptyStyle(),this.style.addLayer(t,e),this._update(!0)},r.prototype.moveLayer=function(t,e){return this.style.moveLayer(t,e),this._update(!0)},r.prototype.removeLayer=function(t){return this.style.removeLayer(t),this._update(!0)},r.prototype.getLayer=function(t){return this.style.getLayer(t)},r.prototype.setLayerZoomRange=function(t,e,i){return this.style.setLayerZoomRange(t,e,i),this._update(!0)},r.prototype.setFilter=function(t,e,i){return void 0===i&&(i={}),this.style.setFilter(t,e,i),this._update(!0)},r.prototype.getFilter=function(t){return this.style.getFilter(t)},r.prototype.setPaintProperty=function(t,e,i,o){return void 0===o&&(o={}),this.style.setPaintProperty(t,e,i,o),this._update(!0)},r.prototype.getPaintProperty=function(t,e){return this.style.getPaintProperty(t,e)},r.prototype.setLayoutProperty=function(t,e,i,o){return void 0===o&&(o={}),this.style.setLayoutProperty(t,e,i,o),this._update(!0)},r.prototype.getLayoutProperty=function(t,e){return this.style.getLayoutProperty(t,e)},r.prototype.setLight=function(t,e){return void 0===e&&(e={}),this._lazyInitEmptyStyle(),this.style.setLight(t,e),this._update(!0)},r.prototype.getLight=function(){return this.style.getLight()},r.prototype.setFeatureState=function(t,e){return this.style.setFeatureState(t,e),this._update()},r.prototype.removeFeatureState=function(t,e){return this.style.removeFeatureState(t,e),this._update()},r.prototype.getFeatureState=function(t){return this.style.getFeatureState(t)},r.prototype.getContainer=function(){return this._container},r.prototype.getCanvasContainer=function(){return this._canvasContainer},r.prototype.getCanvas=function(){return this._canvas},r.prototype._containerDimensions=function(){var t=0,e=0;return this._container&&(t=this._container.clientWidth||400,e=this._container.clientHeight||300),[t,e]},r.prototype._detectMissingCSS=function(){"rgb(250, 128, 114)"!==t.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color")&&t.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");},r.prototype._setupContainer=function(){var t=this._container;t.classList.add("mapboxgl-map"),(this._missingCSSCanary=i.create("div","mapboxgl-canary",t)).style.visibility="hidden",this._detectMissingCSS();var e=this._canvasContainer=i.create("div","mapboxgl-canvas-container",t);this._interactive&&e.classList.add("mapboxgl-interactive"),this._canvas=i.create("canvas","mapboxgl-canvas",e),this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex","0"),this._canvas.setAttribute("aria-label","Map");var o=this._containerDimensions();this._resizeCanvas(o[0],o[1]);var r=this._controlContainer=i.create("div","mapboxgl-control-container",t),a=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach((function(t){a[t]=i.create("div","mapboxgl-ctrl-"+t,r);}));},r.prototype._resizeCanvas=function(e,i){var o=t.browser.devicePixelRatio||1;this._canvas.width=o*e,this._canvas.height=o*i,this._canvas.style.width=e+"px",this._canvas.style.height=i+"px";},r.prototype._setupPainter=function(){var i=t.extend({},e.webGLContextAttributes,{failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer,antialias:this._antialias||!1}),o=this._canvas.getContext("webgl",i)||this._canvas.getContext("experimental-webgl",i);o?(this.painter=new vo(o,this.transform),t.webpSupported.testSupport(o)):this.fire(new t.ErrorEvent(new Error("Failed to initialize WebGL")));},r.prototype._contextLost=function(e){e.preventDefault(),this._frame&&(this._frame.cancel(),this._frame=null),this.fire(new t.Event("webglcontextlost",{originalEvent:e}));},r.prototype._contextRestored=function(e){this._setupPainter(),this.resize(),this._update(),this.fire(new t.Event("webglcontextrestored",{originalEvent:e}));},r.prototype.loaded=function(){return !this._styleDirty&&!this._sourcesDirty&&!!this.style&&this.style.loaded()},r.prototype._update=function(t){return this.style?(this._styleDirty=this._styleDirty||t,this._sourcesDirty=!0,this.triggerRepaint(),this):this},r.prototype._requestRenderFrame=function(t){return this._update(),this._renderTaskQueue.add(t)},r.prototype._cancelRenderFrame=function(t){this._renderTaskQueue.remove(t);},r.prototype._render=function(e){var i,o=this,r=0,a=this.painter.context.extTimerQuery;if(this.listens("gpu-timing-frame")&&(i=a.createQueryEXT(),a.beginQueryEXT(a.TIME_ELAPSED_EXT,i),r=t.browser.now()),this.painter.context.setDirty(),this.painter.setBaseState(),this._renderTaskQueue.run(e),!this._removed){var n=!1;if(this.style&&this._styleDirty){this._styleDirty=!1;var s=this.transform.zoom,l=t.browser.now();this.style.zoomHistory.update(s,l);var c=new t.EvaluationParameters(s,{now:l,fadeDuration:this._fadeDuration,zoomHistory:this.style.zoomHistory,transition:this.style.getTransition()}),u=c.crossFadingFactor();1===u&&u===this._crossFadingFactor||(n=!0,this._crossFadingFactor=u),this.style.update(c);}if(this.style&&this._sourcesDirty&&(this._sourcesDirty=!1,this.style._updateSources(this.transform)),this._placementDirty=this.style&&this.style._updatePlacement(this.painter.transform,this.showCollisionBoxes,this._fadeDuration,this._crossSourceCollisions),this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showOverdrawInspector:this._showOverdrawInspector,rotating:this.isRotating(),zooming:this.isZooming(),moving:this.isMoving(),fadeDuration:this._fadeDuration,showPadding:this.showPadding,gpuTiming:!!this.listens("gpu-timing-layer")}),this.fire(new t.Event("render")),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire(new t.Event("load"))),this.style&&(this.style.hasTransitions()||n)&&(this._styleDirty=!0),this.style&&!this._placementDirty&&this.style._releaseSymbolFadeTiles(),this.listens("gpu-timing-frame")){var h=t.browser.now()-r;a.endQueryEXT(a.TIME_ELAPSED_EXT,i),setTimeout((function(){var e=a.getQueryObjectEXT(i,a.QUERY_RESULT_EXT)/1e6;a.deleteQueryEXT(i),o.fire(new t.Event("gpu-timing-frame",{cpuTime:h,gpuTime:e}));}),50);}if(this.listens("gpu-timing-layer")){var p=this.painter.collectGpuTimers();setTimeout((function(){var e=o.painter.queryGpuTimers(p);o.fire(new t.Event("gpu-timing-layer",{layerTimes:e}));}),50);}return this._sourcesDirty||this._styleDirty||this._placementDirty||this._repaint?this.triggerRepaint():!this.isMoving()&&this.loaded()&&(this._fullyLoaded||(this._fullyLoaded=!0),this.fire(new t.Event("idle"))),this}},r.prototype.remove=function(){this._hash&&this._hash.remove();for(var e=0,i=this._controls;e<i.length;e+=1)i[e].onRemove(this);this._controls=[],this._frame&&(this._frame.cancel(),this._frame=null),this._renderTaskQueue.clear(),this.painter.destroy(),this.handlers.destroy(),delete this.handlers,this.setStyle(null),void 0!==t.window&&(t.window.removeEventListener("resize",this._onWindowResize,!1),t.window.removeEventListener("online",this._onWindowOnline,!1));var o=this.painter.context.gl.getExtension("WEBGL_lose_context");o&&o.loseContext(),Pr(this._canvasContainer),Pr(this._controlContainer),Pr(this._missingCSSCanary),this._container.classList.remove("mapboxgl-map"),this._removed=!0,this.fire(new t.Event("remove"));},r.prototype.triggerRepaint=function(){var e=this;this.style&&!this._frame&&(this._frame=t.browser.frame((function(t){e._frame=null,e._render(t);})));},r.prototype._onWindowOnline=function(){this._update();},r.prototype._onWindowResize=function(t){this._trackResize&&this.resize({originalEvent:t})._update();},a.showTileBoundaries.get=function(){return !!this._showTileBoundaries},a.showTileBoundaries.set=function(t){this._showTileBoundaries!==t&&(this._showTileBoundaries=t,this._update());},a.showPadding.get=function(){return !!this._showPadding},a.showPadding.set=function(t){this._showPadding!==t&&(this._showPadding=t,this._update());},a.showCollisionBoxes.get=function(){return !!this._showCollisionBoxes},a.showCollisionBoxes.set=function(t){this._showCollisionBoxes!==t&&(this._showCollisionBoxes=t,t?this.style._generateCollisionBoxes():this._update());},a.showOverdrawInspector.get=function(){return !!this._showOverdrawInspector},a.showOverdrawInspector.set=function(t){this._showOverdrawInspector!==t&&(this._showOverdrawInspector=t,this._update());},a.repaint.get=function(){return !!this._repaint},a.repaint.set=function(t){this._repaint!==t&&(this._repaint=t,this.triggerRepaint());},a.vertices.get=function(){return !!this._vertices},a.vertices.set=function(t){this._vertices=t,this._update();},r.prototype._setCacheLimits=function(e,i){t.setCacheLimits(e,i);},a.version.get=function(){return t.version},Object.defineProperties(r.prototype,a),r}(mr);function Pr(t){t.parentNode&&t.parentNode.removeChild(t);}var Sr={showCompass:!0,showZoom:!0,visualizePitch:!1},Cr=function(e){var o=this;this.options=t.extend({},Sr,e),this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._container.addEventListener("contextmenu",(function(t){return t.preventDefault()})),this.options.showZoom&&(t.bindAll(["_setButtonTitle","_updateZoomButtons"],this),this._zoomInButton=this._createButton("mapboxgl-ctrl-zoom-in",(function(t){return o._map.zoomIn({},{originalEvent:t})})),i.create("span","mapboxgl-ctrl-icon",this._zoomInButton).setAttribute("aria-hidden",!0),this._zoomOutButton=this._createButton("mapboxgl-ctrl-zoom-out",(function(t){return o._map.zoomOut({},{originalEvent:t})})),i.create("span","mapboxgl-ctrl-icon",this._zoomOutButton).setAttribute("aria-hidden",!0)),this.options.showCompass&&(t.bindAll(["_rotateCompassArrow"],this),this._compass=this._createButton("mapboxgl-ctrl-compass",(function(t){o.options.visualizePitch?o._map.resetNorthPitch({},{originalEvent:t}):o._map.resetNorth({},{originalEvent:t});})),this._compassIcon=i.create("span","mapboxgl-ctrl-icon",this._compass),this._compassIcon.setAttribute("aria-hidden",!0));};Cr.prototype._updateZoomButtons=function(){var t=this._map.getZoom();this._zoomInButton.disabled=t===this._map.getMaxZoom(),this._zoomOutButton.disabled=t===this._map.getMinZoom();},Cr.prototype._rotateCompassArrow=function(){var t=this.options.visualizePitch?"scale("+1/Math.pow(Math.cos(this._map.transform.pitch*(Math.PI/180)),.5)+") rotateX("+this._map.transform.pitch+"deg) rotateZ("+this._map.transform.angle*(180/Math.PI)+"deg)":"rotate("+this._map.transform.angle*(180/Math.PI)+"deg)";this._compassIcon.style.transform=t;},Cr.prototype.onAdd=function(t){return this._map=t,this.options.showZoom&&(this._setButtonTitle(this._zoomInButton,"ZoomIn"),this._setButtonTitle(this._zoomOutButton,"ZoomOut"),this._map.on("zoom",this._updateZoomButtons),this._updateZoomButtons()),this.options.showCompass&&(this._setButtonTitle(this._compass,"ResetBearing"),this.options.visualizePitch&&this._map.on("pitch",this._rotateCompassArrow),this._map.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._handler=new zr(this._map,this._compass,this.options.visualizePitch)),this._container},Cr.prototype.onRemove=function(){i.remove(this._container),this.options.showZoom&&this._map.off("zoom",this._updateZoomButtons),this.options.showCompass&&(this.options.visualizePitch&&this._map.off("pitch",this._rotateCompassArrow),this._map.off("rotate",this._rotateCompassArrow),this._handler.off(),delete this._handler),delete this._map;},Cr.prototype._createButton=function(t,e){var o=i.create("button",t,this._container);return o.type="button",o.addEventListener("click",e),o},Cr.prototype._setButtonTitle=function(t,e){var i=this._map._getUIString("NavigationControl."+e);t.title=i,t.setAttribute("aria-label",i);};var zr=function(e,o,r){void 0===r&&(r=!1),this._clickTolerance=10,this.element=o,this.mouseRotate=new Go({clickTolerance:e.dragRotate._mouseRotate._clickTolerance}),this.map=e,r&&(this.mousePitch=new Wo({clickTolerance:e.dragRotate._mousePitch._clickTolerance})),t.bindAll(["mousedown","mousemove","mouseup","touchstart","touchmove","touchend","reset"],this),i.addEventListener(o,"mousedown",this.mousedown),i.addEventListener(o,"touchstart",this.touchstart,{passive:!1}),i.addEventListener(o,"touchmove",this.touchmove),i.addEventListener(o,"touchend",this.touchend),i.addEventListener(o,"touchcancel",this.reset);};function Dr(e,i,o){if(e=new t.LngLat(e.lng,e.lat),i){var r=new t.LngLat(e.lng-360,e.lat),a=new t.LngLat(e.lng+360,e.lat),n=o.locationPoint(e).distSqr(i);o.locationPoint(r).distSqr(i)<n?e=r:o.locationPoint(a).distSqr(i)<n&&(e=a);}for(;Math.abs(e.lng-o.center.lng)>180;){var s=o.locationPoint(e);if(s.x>=0&&s.y>=0&&s.x<=o.width&&s.y<=o.height)break;e.lng>o.center.lng?e.lng-=360:e.lng+=360;}return e}zr.prototype.down=function(t,e){this.mouseRotate.mousedown(t,e),this.mousePitch&&this.mousePitch.mousedown(t,e),i.disableDrag();},zr.prototype.move=function(t,e){var i=this.map,o=this.mouseRotate.mousemoveWindow(t,e);if(o&&o.bearingDelta&&i.setBearing(i.getBearing()+o.bearingDelta),this.mousePitch){var r=this.mousePitch.mousemoveWindow(t,e);r&&r.pitchDelta&&i.setPitch(i.getPitch()+r.pitchDelta);}},zr.prototype.off=function(){var t=this.element;i.removeEventListener(t,"mousedown",this.mousedown),i.removeEventListener(t,"touchstart",this.touchstart,{passive:!1}),i.removeEventListener(t,"touchmove",this.touchmove),i.removeEventListener(t,"touchend",this.touchend),i.removeEventListener(t,"touchcancel",this.reset),this.offTemp();},zr.prototype.offTemp=function(){i.enableDrag(),i.removeEventListener(t.window,"mousemove",this.mousemove),i.removeEventListener(t.window,"mouseup",this.mouseup);},zr.prototype.mousedown=function(e){this.down(t.extend({},e,{ctrlKey:!0,preventDefault:function(){return e.preventDefault()}}),i.mousePos(this.element,e)),i.addEventListener(t.window,"mousemove",this.mousemove),i.addEventListener(t.window,"mouseup",this.mouseup);},zr.prototype.mousemove=function(t){this.move(t,i.mousePos(this.element,t));},zr.prototype.mouseup=function(t){this.mouseRotate.mouseupWindow(t),this.mousePitch&&this.mousePitch.mouseupWindow(t),this.offTemp();},zr.prototype.touchstart=function(t){1!==t.targetTouches.length?this.reset():(this._startPos=this._lastPos=i.touchPos(this.element,t.targetTouches)[0],this.down({type:"mousedown",button:0,ctrlKey:!0,preventDefault:function(){return t.preventDefault()}},this._startPos));},zr.prototype.touchmove=function(t){1!==t.targetTouches.length?this.reset():(this._lastPos=i.touchPos(this.element,t.targetTouches)[0],this.move({preventDefault:function(){return t.preventDefault()}},this._lastPos));},zr.prototype.touchend=function(t){0===t.targetTouches.length&&this._startPos&&this._lastPos&&this._startPos.dist(this._lastPos)<this._clickTolerance&&this.element.click(),this.reset();},zr.prototype.reset=function(){this.mouseRotate.reset(),this.mousePitch&&this.mousePitch.reset(),delete this._startPos,delete this._lastPos,this.offTemp();};var Mr={center:"translate(-50%,-50%)",top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"};function Lr(t,e,i){var o=t.classList;for(var r in Mr)o.remove("mapboxgl-"+i+"-anchor-"+r);o.add("mapboxgl-"+i+"-anchor-"+e);}var Ar,Rr=function(e){function o(o,r){var a=this;if(e.call(this),(o instanceof t.window.HTMLElement||r)&&(o=t.extend({element:o},r)),t.bindAll(["_update","_onMove","_onUp","_addDragHandler","_onMapClick","_onKeyPress"],this),this._anchor=o&&o.anchor||"center",this._color=o&&o.color||"#3FB1CE",this._draggable=o&&o.draggable||!1,this._state="inactive",this._rotation=o&&o.rotation||0,this._rotationAlignment=o&&o.rotationAlignment||"auto",this._pitchAlignment=o&&o.pitchAlignment&&"auto"!==o.pitchAlignment?o.pitchAlignment:this._rotationAlignment,o&&o.element)this._element=o.element,this._offset=t.Point.convert(o&&o.offset||[0,0]);else {this._defaultMarker=!0,this._element=i.create("div"),this._element.setAttribute("aria-label","Map marker");var n=i.createNS("http://www.w3.org/2000/svg","svg");n.setAttributeNS(null,"display","block"),n.setAttributeNS(null,"height","41px"),n.setAttributeNS(null,"width","27px"),n.setAttributeNS(null,"viewBox","0 0 27 41");var s=i.createNS("http://www.w3.org/2000/svg","g");s.setAttributeNS(null,"stroke","none"),s.setAttributeNS(null,"stroke-width","1"),s.setAttributeNS(null,"fill","none"),s.setAttributeNS(null,"fill-rule","evenodd");var l=i.createNS("http://www.w3.org/2000/svg","g");l.setAttributeNS(null,"fill-rule","nonzero");var c=i.createNS("http://www.w3.org/2000/svg","g");c.setAttributeNS(null,"transform","translate(3.0, 29.0)"),c.setAttributeNS(null,"fill","#000000");for(var u=0,h=[{rx:"10.5",ry:"5.25002273"},{rx:"10.5",ry:"5.25002273"},{rx:"9.5",ry:"4.77275007"},{rx:"8.5",ry:"4.29549936"},{rx:"7.5",ry:"3.81822308"},{rx:"6.5",ry:"3.34094679"},{rx:"5.5",ry:"2.86367051"},{rx:"4.5",ry:"2.38636864"}];u<h.length;u+=1){var p=h[u],d=i.createNS("http://www.w3.org/2000/svg","ellipse");d.setAttributeNS(null,"opacity","0.04"),d.setAttributeNS(null,"cx","10.5"),d.setAttributeNS(null,"cy","5.80029008"),d.setAttributeNS(null,"rx",p.rx),d.setAttributeNS(null,"ry",p.ry),c.appendChild(d);}var _=i.createNS("http://www.w3.org/2000/svg","g");_.setAttributeNS(null,"fill",this._color);var f=i.createNS("http://www.w3.org/2000/svg","path");f.setAttributeNS(null,"d","M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"),_.appendChild(f);var m=i.createNS("http://www.w3.org/2000/svg","g");m.setAttributeNS(null,"opacity","0.25"),m.setAttributeNS(null,"fill","#000000");var g=i.createNS("http://www.w3.org/2000/svg","path");g.setAttributeNS(null,"d","M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"),m.appendChild(g);var v=i.createNS("http://www.w3.org/2000/svg","g");v.setAttributeNS(null,"transform","translate(6.0, 7.0)"),v.setAttributeNS(null,"fill","#FFFFFF");var y=i.createNS("http://www.w3.org/2000/svg","g");y.setAttributeNS(null,"transform","translate(8.0, 8.0)");var x=i.createNS("http://www.w3.org/2000/svg","circle");x.setAttributeNS(null,"fill","#000000"),x.setAttributeNS(null,"opacity","0.25"),x.setAttributeNS(null,"cx","5.5"),x.setAttributeNS(null,"cy","5.5"),x.setAttributeNS(null,"r","5.4999962");var b=i.createNS("http://www.w3.org/2000/svg","circle");b.setAttributeNS(null,"fill","#FFFFFF"),b.setAttributeNS(null,"cx","5.5"),b.setAttributeNS(null,"cy","5.5"),b.setAttributeNS(null,"r","5.4999962"),y.appendChild(x),y.appendChild(b),l.appendChild(c),l.appendChild(_),l.appendChild(m),l.appendChild(v),l.appendChild(y),n.appendChild(l),this._element.appendChild(n),this._offset=t.Point.convert(o&&o.offset||[0,-14]);}this._element.classList.add("mapboxgl-marker"),this._element.addEventListener("dragstart",(function(t){t.preventDefault();})),this._element.addEventListener("mousedown",(function(t){t.preventDefault();})),this._element.addEventListener("focus",(function(){var t=a._map.getContainer();t.scrollTop=0,t.scrollLeft=0;})),Lr(this._element,this._anchor,"marker"),this._popup=null;}return e&&(o.__proto__=e),(o.prototype=Object.create(e&&e.prototype)).constructor=o,o.prototype.addTo=function(t){return this.remove(),this._map=t,t.getCanvasContainer().appendChild(this._element),t.on("move",this._update),t.on("moveend",this._update),this.setDraggable(this._draggable),this._update(),this._map.on("click",this._onMapClick),this},o.prototype.remove=function(){return this._map&&(this._map.off("click",this._onMapClick),this._map.off("move",this._update),this._map.off("moveend",this._update),this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler),this._map.off("mouseup",this._onUp),this._map.off("touchend",this._onUp),this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),delete this._map),i.remove(this._element),this._popup&&this._popup.remove(),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._popup&&this._popup.setLngLat(this._lngLat),this._update(),this},o.prototype.getElement=function(){return this._element},o.prototype.setPopup=function(t){if(this._popup&&(this._popup.remove(),this._popup=null,this._element.removeEventListener("keypress",this._onKeyPress),this._originalTabIndex||this._element.removeAttribute("tabindex")),t){if(!("offset"in t.options)){var e=Math.sqrt(Math.pow(13.5,2)/2);t.options.offset=this._defaultMarker?{top:[0,0],"top-left":[0,0],"top-right":[0,0],bottom:[0,-38.1],"bottom-left":[e,-1*(24.6+e)],"bottom-right":[-e,-1*(24.6+e)],left:[13.5,-24.6],right:[-13.5,-24.6]}:this._offset;}this._popup=t,this._lngLat&&this._popup.setLngLat(this._lngLat),this._originalTabIndex=this._element.getAttribute("tabindex"),this._originalTabIndex||this._element.setAttribute("tabindex","0"),this._element.addEventListener("keypress",this._onKeyPress);}return this},o.prototype._onKeyPress=function(t){var e=t.code,i=t.charCode||t.keyCode;"Space"!==e&&"Enter"!==e&&32!==i&&13!==i||this.togglePopup();},o.prototype._onMapClick=function(t){var e=t.originalEvent.target,i=this._element;this._popup&&(e===i||i.contains(e))&&this.togglePopup();},o.prototype.getPopup=function(){return this._popup},o.prototype.togglePopup=function(){var t=this._popup;return t?(t.isOpen()?t.remove():t.addTo(this._map),this):this},o.prototype._update=function(t){if(this._map){this._map.transform.renderWorldCopies&&(this._lngLat=Dr(this._lngLat,this._pos,this._map.transform)),this._pos=this._map.project(this._lngLat)._add(this._offset);var e="";"viewport"===this._rotationAlignment||"auto"===this._rotationAlignment?e="rotateZ("+this._rotation+"deg)":"map"===this._rotationAlignment&&(e="rotateZ("+(this._rotation-this._map.getBearing())+"deg)");var o="";"viewport"===this._pitchAlignment||"auto"===this._pitchAlignment?o="rotateX(0deg)":"map"===this._pitchAlignment&&(o="rotateX("+this._map.getPitch()+"deg)"),t&&"moveend"!==t.type||(this._pos=this._pos.round()),i.setTransform(this._element,Mr[this._anchor]+" translate("+this._pos.x+"px, "+this._pos.y+"px) "+o+" "+e);}},o.prototype.getOffset=function(){return this._offset},o.prototype.setOffset=function(e){return this._offset=t.Point.convert(e),this._update(),this},o.prototype._onMove=function(e){this._pos=e.point.sub(this._positionDelta),this._lngLat=this._map.unproject(this._pos),this.setLngLat(this._lngLat),this._element.style.pointerEvents="none","pending"===this._state&&(this._state="active",this.fire(new t.Event("dragstart"))),this.fire(new t.Event("drag"));},o.prototype._onUp=function(){this._element.style.pointerEvents="auto",this._positionDelta=null,this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),"active"===this._state&&this.fire(new t.Event("dragend")),this._state="inactive";},o.prototype._addDragHandler=function(t){this._element.contains(t.originalEvent.target)&&(t.preventDefault(),this._positionDelta=t.point.sub(this._pos).add(this._offset),this._state="pending",this._map.on("mousemove",this._onMove),this._map.on("touchmove",this._onMove),this._map.once("mouseup",this._onUp),this._map.once("touchend",this._onUp));},o.prototype.setDraggable=function(t){return this._draggable=!!t,this._map&&(t?(this._map.on("mousedown",this._addDragHandler),this._map.on("touchstart",this._addDragHandler)):(this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler))),this},o.prototype.isDraggable=function(){return this._draggable},o.prototype.setRotation=function(t){return this._rotation=t||0,this._update(),this},o.prototype.getRotation=function(){return this._rotation},o.prototype.setRotationAlignment=function(t){return this._rotationAlignment=t||"auto",this._update(),this},o.prototype.getRotationAlignment=function(){return this._rotationAlignment},o.prototype.setPitchAlignment=function(t){return this._pitchAlignment=t&&"auto"!==t?t:this._rotationAlignment,this._update(),this},o.prototype.getPitchAlignment=function(){return this._pitchAlignment},o}(t.Evented),kr={positionOptions:{enableHighAccuracy:!1,maximumAge:0,timeout:6e3},fitBoundsOptions:{maxZoom:15},trackUserLocation:!1,showAccuracyCircle:!0,showUserLocation:!0},Br=0,Or=!1,Fr=function(e){function o(i){e.call(this),this.options=t.extend({},kr,i),t.bindAll(["_onSuccess","_onError","_onZoom","_finish","_setupUI","_updateCamera","_updateMarker"],this);}return e&&(o.__proto__=e),(o.prototype=Object.create(e&&e.prototype)).constructor=o,o.prototype.onAdd=function(e){var o;return this._map=e,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),o=this._setupUI,void 0!==Ar?o(Ar):void 0!==t.window.navigator.permissions?t.window.navigator.permissions.query({name:"geolocation"}).then((function(t){o(Ar="denied"!==t.state);})):o(Ar=!!t.window.navigator.geolocation),this._container},o.prototype.onRemove=function(){void 0!==this._geolocationWatchID&&(t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0),this.options.showUserLocation&&this._userLocationDotMarker&&this._userLocationDotMarker.remove(),this.options.showAccuracyCircle&&this._accuracyCircleMarker&&this._accuracyCircleMarker.remove(),i.remove(this._container),this._map.off("zoom",this._onZoom),this._map=void 0,Br=0,Or=!1;},o.prototype._isOutOfMapMaxBounds=function(t){var e=this._map.getMaxBounds(),i=t.coords;return e&&(i.longitude<e.getWest()||i.longitude>e.getEast()||i.latitude<e.getSouth()||i.latitude>e.getNorth())},o.prototype._setErrorState=function(){switch(this._watchState){case"WAITING_ACTIVE":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"ACTIVE_LOCK":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");break;case"BACKGROUND":this._watchState="BACKGROUND_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");}},o.prototype._onSuccess=function(e){if(this._map){if(this._isOutOfMapMaxBounds(e))return this._setErrorState(),this.fire(new t.Event("outofmaxbounds",e)),this._updateMarker(),void this._finish();if(this.options.trackUserLocation)switch(this._lastKnownPosition=e,this._watchState){case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"BACKGROUND":case"BACKGROUND_ERROR":this._watchState="BACKGROUND",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");}this.options.showUserLocation&&"OFF"!==this._watchState&&this._updateMarker(e),this.options.trackUserLocation&&"ACTIVE_LOCK"!==this._watchState||this._updateCamera(e),this.options.showUserLocation&&this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("geolocate",e)),this._finish();}},o.prototype._updateCamera=function(e){var i=new t.LngLat(e.coords.longitude,e.coords.latitude),o=e.coords.accuracy,r=this._map.getBearing(),a=t.extend({bearing:r},this.options.fitBoundsOptions);this._map.fitBounds(i.toBounds(o),a,{geolocateSource:!0});},o.prototype._updateMarker=function(e){if(e){var i=new t.LngLat(e.coords.longitude,e.coords.latitude);this._accuracyCircleMarker.setLngLat(i).addTo(this._map),this._userLocationDotMarker.setLngLat(i).addTo(this._map),this._accuracy=e.coords.accuracy,this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius();}else this._userLocationDotMarker.remove(),this._accuracyCircleMarker.remove();},o.prototype._updateCircleRadius=function(){var t=this._map._container.clientHeight/2,e=this._map.unproject([0,t]),i=this._map.unproject([1,t]),o=e.distanceTo(i),r=Math.ceil(2*this._accuracy/o);this._circleElement.style.width=r+"px",this._circleElement.style.height=r+"px";},o.prototype._onZoom=function(){this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius();},o.prototype._onError=function(e){if(this._map){if(this.options.trackUserLocation)if(1===e.code){this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.disabled=!0;var i=this._map._getUIString("GeolocateControl.LocationNotAvailable");this._geolocateButton.title=i,this._geolocateButton.setAttribute("aria-label",i),void 0!==this._geolocationWatchID&&this._clearWatch();}else {if(3===e.code&&Or)return;this._setErrorState();}"OFF"!==this._watchState&&this.options.showUserLocation&&this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("error",e)),this._finish();}},o.prototype._finish=function(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0;},o.prototype._setupUI=function(e){var o=this;if(this._container.addEventListener("contextmenu",(function(t){return t.preventDefault()})),this._geolocateButton=i.create("button","mapboxgl-ctrl-geolocate",this._container),i.create("span","mapboxgl-ctrl-icon",this._geolocateButton).setAttribute("aria-hidden",!0),this._geolocateButton.type="button",!1===e){t.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");var r=this._map._getUIString("GeolocateControl.LocationNotAvailable");this._geolocateButton.disabled=!0,this._geolocateButton.title=r,this._geolocateButton.setAttribute("aria-label",r);}else {var a=this._map._getUIString("GeolocateControl.FindMyLocation");this._geolocateButton.title=a,this._geolocateButton.setAttribute("aria-label",a);}this.options.trackUserLocation&&(this._geolocateButton.setAttribute("aria-pressed","false"),this._watchState="OFF"),this.options.showUserLocation&&(this._dotElement=i.create("div","mapboxgl-user-location-dot"),this._userLocationDotMarker=new Rr(this._dotElement),this._circleElement=i.create("div","mapboxgl-user-location-accuracy-circle"),this._accuracyCircleMarker=new Rr({element:this._circleElement,pitchAlignment:"map"}),this.options.trackUserLocation&&(this._watchState="OFF"),this._map.on("zoom",this._onZoom)),this._geolocateButton.addEventListener("click",this.trigger.bind(this)),this._setup=!0,this.options.trackUserLocation&&this._map.on("movestart",(function(e){e.geolocateSource||"ACTIVE_LOCK"!==o._watchState||e.originalEvent&&"resize"===e.originalEvent.type||(o._watchState="BACKGROUND",o._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),o._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),o.fire(new t.Event("trackuserlocationend")));}));},o.prototype.trigger=function(){if(!this._setup)return t.warnOnce("Geolocate control triggered before added to a map"),!1;if(this.options.trackUserLocation){switch(this._watchState){case"OFF":this._watchState="WAITING_ACTIVE",this.fire(new t.Event("trackuserlocationstart"));break;case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":case"BACKGROUND_ERROR":Br--,Or=!1,this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this.fire(new t.Event("trackuserlocationend"));break;case"BACKGROUND":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._lastKnownPosition&&this._updateCamera(this._lastKnownPosition),this.fire(new t.Event("trackuserlocationstart"));}switch(this._watchState){case"WAITING_ACTIVE":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_LOCK":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"BACKGROUND":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");break;case"BACKGROUND_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");}if("OFF"===this._watchState&&void 0!==this._geolocationWatchID)this._clearWatch();else if(void 0===this._geolocationWatchID){var e;this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","true"),++Br>1?(e={maximumAge:6e5,timeout:0},Or=!0):(e=this.options.positionOptions,Or=!1),this._geolocationWatchID=t.window.navigator.geolocation.watchPosition(this._onSuccess,this._onError,e);}}else t.window.navigator.geolocation.getCurrentPosition(this._onSuccess,this._onError,this.options.positionOptions),this._timeoutId=setTimeout(this._finish,1e4);return !0},o.prototype._clearWatch=function(){t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0,this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","false"),this.options.showUserLocation&&this._updateMarker(null);},o}(t.Evented),Ur={maxWidth:100,unit:"metric"},Nr=function(e){this.options=t.extend({},Ur,e),t.bindAll(["_onMove","setUnit"],this);};function Zr(t,e,i){var o=i&&i.maxWidth||100,r=t._container.clientHeight/2,a=t.unproject([0,r]),n=t.unproject([o,r]),s=a.distanceTo(n);if(i&&"imperial"===i.unit){var l=3.2808*s;l>5280?jr(e,o,l/5280,t._getUIString("ScaleControl.Miles")):jr(e,o,l,t._getUIString("ScaleControl.Feet"));}else i&&"nautical"===i.unit?jr(e,o,s/1852,t._getUIString("ScaleControl.NauticalMiles")):s>=1e3?jr(e,o,s/1e3,t._getUIString("ScaleControl.Kilometers")):jr(e,o,s,t._getUIString("ScaleControl.Meters"));}function jr(t,e,i,o){var r,a,n,s=(r=i,(a=Math.pow(10,(""+Math.floor(r)).length-1))*(n=(n=r/a)>=10?10:n>=5?5:n>=3?3:n>=2?2:n>=1?1:function(t){var e=Math.pow(10,Math.ceil(-Math.log(t)/Math.LN10));return Math.round(t*e)/e}(n)));t.style.width=e*(s/i)+"px",t.innerHTML=s+"&nbsp;"+o;}Nr.prototype.getDefaultPosition=function(){return "bottom-left"},Nr.prototype._onMove=function(){Zr(this._map,this._container,this.options);},Nr.prototype.onAdd=function(t){return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-scale",t.getContainer()),this._map.on("move",this._onMove),this._onMove(),this._container},Nr.prototype.onRemove=function(){i.remove(this._container),this._map.off("move",this._onMove),this._map=void 0;},Nr.prototype.setUnit=function(t){this.options.unit=t,Zr(this._map,this._container,this.options);};var qr=function(e){this._fullscreen=!1,e&&e.container&&(e.container instanceof t.window.HTMLElement?this._container=e.container:t.warnOnce("Full screen control 'container' must be a DOM element.")),t.bindAll(["_onClickFullscreen","_changeIcon"],this),"onfullscreenchange"in t.window.document?this._fullscreenchange="fullscreenchange":"onmozfullscreenchange"in t.window.document?this._fullscreenchange="mozfullscreenchange":"onwebkitfullscreenchange"in t.window.document?this._fullscreenchange="webkitfullscreenchange":"onmsfullscreenchange"in t.window.document&&(this._fullscreenchange="MSFullscreenChange");};qr.prototype.onAdd=function(e){return this._map=e,this._container||(this._container=this._map.getContainer()),this._controlContainer=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._checkFullscreenSupport()?this._setupUI():(this._controlContainer.style.display="none",t.warnOnce("This device does not support fullscreen mode.")),this._controlContainer},qr.prototype.onRemove=function(){i.remove(this._controlContainer),this._map=null,t.window.document.removeEventListener(this._fullscreenchange,this._changeIcon);},qr.prototype._checkFullscreenSupport=function(){return !!(t.window.document.fullscreenEnabled||t.window.document.mozFullScreenEnabled||t.window.document.msFullscreenEnabled||t.window.document.webkitFullscreenEnabled)},qr.prototype._setupUI=function(){var e=this._fullscreenButton=i.create("button","mapboxgl-ctrl-fullscreen",this._controlContainer);i.create("span","mapboxgl-ctrl-icon",e).setAttribute("aria-hidden",!0),e.type="button",this._updateTitle(),this._fullscreenButton.addEventListener("click",this._onClickFullscreen),t.window.document.addEventListener(this._fullscreenchange,this._changeIcon);},qr.prototype._updateTitle=function(){var t=this._getTitle();this._fullscreenButton.setAttribute("aria-label",t),this._fullscreenButton.title=t;},qr.prototype._getTitle=function(){return this._map._getUIString(this._isFullscreen()?"FullscreenControl.Exit":"FullscreenControl.Enter")},qr.prototype._isFullscreen=function(){return this._fullscreen},qr.prototype._changeIcon=function(){(t.window.document.fullscreenElement||t.window.document.mozFullScreenElement||t.window.document.webkitFullscreenElement||t.window.document.msFullscreenElement)===this._container!==this._fullscreen&&(this._fullscreen=!this._fullscreen,this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"),this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"),this._updateTitle());},qr.prototype._onClickFullscreen=function(){this._isFullscreen()?t.window.document.exitFullscreen?t.window.document.exitFullscreen():t.window.document.mozCancelFullScreen?t.window.document.mozCancelFullScreen():t.window.document.msExitFullscreen?t.window.document.msExitFullscreen():t.window.document.webkitCancelFullScreen&&t.window.document.webkitCancelFullScreen():this._container.requestFullscreen?this._container.requestFullscreen():this._container.mozRequestFullScreen?this._container.mozRequestFullScreen():this._container.msRequestFullscreen?this._container.msRequestFullscreen():this._container.webkitRequestFullscreen&&this._container.webkitRequestFullscreen();};var Vr={closeButton:!0,closeOnClick:!0,className:"",maxWidth:"240px"},Gr=function(e){function o(i){e.call(this),this.options=t.extend(Object.create(Vr),i),t.bindAll(["_update","_onClose","remove","_onMouseMove","_onMouseUp","_onDrag"],this);}return e&&(o.__proto__=e),(o.prototype=Object.create(e&&e.prototype)).constructor=o,o.prototype.addTo=function(e){return this._map&&this.remove(),this._map=e,this.options.closeOnClick&&this._map.on("click",this._onClose),this.options.closeOnMove&&this._map.on("move",this._onClose),this._map.on("remove",this.remove),this._update(),this._trackPointer?(this._map.on("mousemove",this._onMouseMove),this._map.on("mouseup",this._onMouseUp),this._container&&this._container.classList.add("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.add("mapboxgl-track-pointer")):this._map.on("move",this._update),this.fire(new t.Event("open")),this},o.prototype.isOpen=function(){return !!this._map},o.prototype.remove=function(){return this._content&&i.remove(this._content),this._container&&(i.remove(this._container),delete this._container),this._map&&(this._map.off("move",this._update),this._map.off("move",this._onClose),this._map.off("click",this._onClose),this._map.off("remove",this.remove),this._map.off("mousemove",this._onMouseMove),this._map.off("mouseup",this._onMouseUp),this._map.off("drag",this._onDrag),delete this._map),this.fire(new t.Event("close")),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._trackPointer=!1,this._update(),this._map&&(this._map.on("move",this._update),this._map.off("mousemove",this._onMouseMove),this._container&&this._container.classList.remove("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")),this},o.prototype.trackPointer=function(){return this._trackPointer=!0,this._pos=null,this._update(),this._map&&(this._map.off("move",this._update),this._map.on("mousemove",this._onMouseMove),this._map.on("drag",this._onDrag),this._container&&this._container.classList.add("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.add("mapboxgl-track-pointer")),this},o.prototype.getElement=function(){return this._container},o.prototype.setText=function(e){return this.setDOMContent(t.window.document.createTextNode(e))},o.prototype.setHTML=function(e){var i,o=t.window.document.createDocumentFragment(),r=t.window.document.createElement("body");for(r.innerHTML=e;i=r.firstChild;)o.appendChild(i);return this.setDOMContent(o)},o.prototype.getMaxWidth=function(){return this._container&&this._container.style.maxWidth},o.prototype.setMaxWidth=function(t){return this.options.maxWidth=t,this._update(),this},o.prototype.setDOMContent=function(t){return this._createContent(),this._content.appendChild(t),this._update(),this},o.prototype.addClassName=function(t){this._container&&this._container.classList.add(t);},o.prototype.removeClassName=function(t){this._container&&this._container.classList.remove(t);},o.prototype.toggleClassName=function(t){if(this._container)return this._container.classList.toggle(t)},o.prototype._createContent=function(){this._content&&i.remove(this._content),this._content=i.create("div","mapboxgl-popup-content",this._container),this.options.closeButton&&(this._closeButton=i.create("button","mapboxgl-popup-close-button",this._content),this._closeButton.type="button",this._closeButton.setAttribute("aria-label","Close popup"),this._closeButton.innerHTML="&#215;",this._closeButton.addEventListener("click",this._onClose));},o.prototype._onMouseUp=function(t){this._update(t.point);},o.prototype._onMouseMove=function(t){this._update(t.point);},o.prototype._onDrag=function(t){this._update(t.point);},o.prototype._update=function(e){var o=this;if(this._map&&(this._lngLat||this._trackPointer)&&this._content&&(this._container||(this._container=i.create("div","mapboxgl-popup",this._map.getContainer()),this._tip=i.create("div","mapboxgl-popup-tip",this._container),this._container.appendChild(this._content),this.options.className&&this.options.className.split(" ").forEach((function(t){return o._container.classList.add(t)})),this._trackPointer&&this._container.classList.add("mapboxgl-popup-track-pointer")),this.options.maxWidth&&this._container.style.maxWidth!==this.options.maxWidth&&(this._container.style.maxWidth=this.options.maxWidth),this._map.transform.renderWorldCopies&&!this._trackPointer&&(this._lngLat=Dr(this._lngLat,this._pos,this._map.transform)),!this._trackPointer||e)){var r=this._pos=this._trackPointer&&e?e:this._map.project(this._lngLat),a=this.options.anchor,n=function e(i){if(i){if("number"==typeof i){var o=Math.round(Math.sqrt(.5*Math.pow(i,2)));return {center:new t.Point(0,0),top:new t.Point(0,i),"top-left":new t.Point(o,o),"top-right":new t.Point(-o,o),bottom:new t.Point(0,-i),"bottom-left":new t.Point(o,-o),"bottom-right":new t.Point(-o,-o),left:new t.Point(i,0),right:new t.Point(-i,0)}}if(i instanceof t.Point||Array.isArray(i)){var r=t.Point.convert(i);return {center:r,top:r,"top-left":r,"top-right":r,bottom:r,"bottom-left":r,"bottom-right":r,left:r,right:r}}return {center:t.Point.convert(i.center||[0,0]),top:t.Point.convert(i.top||[0,0]),"top-left":t.Point.convert(i["top-left"]||[0,0]),"top-right":t.Point.convert(i["top-right"]||[0,0]),bottom:t.Point.convert(i.bottom||[0,0]),"bottom-left":t.Point.convert(i["bottom-left"]||[0,0]),"bottom-right":t.Point.convert(i["bottom-right"]||[0,0]),left:t.Point.convert(i.left||[0,0]),right:t.Point.convert(i.right||[0,0])}}return e(new t.Point(0,0))}(this.options.offset);if(!a){var s,l=this._container.offsetWidth,c=this._container.offsetHeight;s=r.y+n.bottom.y<c?["top"]:r.y>this._map.transform.height-c?["bottom"]:[],r.x<l/2?s.push("left"):r.x>this._map.transform.width-l/2&&s.push("right"),a=0===s.length?"bottom":s.join("-");}var u=r.add(n[a]).round();i.setTransform(this._container,Mr[a]+" translate("+u.x+"px,"+u.y+"px)"),Lr(this._container,a,"popup");}},o.prototype._onClose=function(){this.remove();},o}(t.Evented),Wr={version:t.version,supported:e,setRTLTextPlugin:t.setRTLTextPlugin,getRTLTextPluginStatus:t.getRTLTextPluginStatus,Map:Ir,NavigationControl:Cr,GeolocateControl:Fr,AttributionControl:gr,ScaleControl:Nr,FullscreenControl:qr,Popup:Gr,Marker:Rr,Style:qe,LngLat:t.LngLat,LngLatBounds:t.LngLatBounds,Point:t.Point,MercatorCoordinate:t.MercatorCoordinate,Evented:t.Evented,config:t.config,prewarm:function(){Ft().acquire(Rt);},clearPrewarmedResources:function(){var t=Bt;t&&(t.isPreloaded()&&1===t.numActive()?(t.release(Rt),Bt=null):console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));},get accessToken(){return t.config.ACCESS_TOKEN},set accessToken(e){t.config.ACCESS_TOKEN=e;},get baseApiUrl(){return t.config.API_URL},set baseApiUrl(e){t.config.API_URL=e;},get workerCount(){return kt.workerCount},set workerCount(t){kt.workerCount=t;},get maxParallelImageRequests(){return t.config.MAX_PARALLEL_IMAGE_REQUESTS},set maxParallelImageRequests(e){t.config.MAX_PARALLEL_IMAGE_REQUESTS=e;},clearStorage:function(e){t.clearTileCache(e);},workerUrl:""};return Wr}));
  
  //
  
  return mapboxgl;
  
  })));
  
  
  },{}],448:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createTable
  
  var chull = _dereq_('convex-hull')
  
  function constructVertex(d, a, b) {
    var x = new Array(d)
    for(var i=0; i<d; ++i) {
      x[i] = 0.0
      if(i === a) {
        x[i] += 0.5
      }
      if(i === b) {
        x[i] += 0.5
      }
    }
    return x
  }
  
  function constructCell(dimension, mask) {
    if(mask === 0 || mask === (1<<(dimension+1))-1) {
      return []
    }
    var points = []
    var index  = []
    for(var i=0; i<=dimension; ++i) {
      if(mask & (1<<i)) {
        points.push(constructVertex(dimension, i-1, i-1))
        index.push(null)
        for(var j=0; j<=dimension; ++j) {
          if(~mask & (1<<j)) {
            points.push(constructVertex(dimension, i-1, j-1))
            index.push([i,j])
          }
        }
      }
    }
    
    //Preprocess points so first d+1 points are linearly independent
    var hull = chull(points)
    var faces = []
  i_loop:
    for(var i=0; i<hull.length; ++i) {
      var face = hull[i]
      var nface = []
      for(var j=0; j<face.length; ++j) {
        if(!index[face[j]]) {
          continue i_loop
        }
        nface.push(index[face[j]].slice())
      }
      faces.push(nface)
    }
    return faces
  }
  
  function createTable(dimension) {
    var numCells = 1<<(dimension+1)
    var result = new Array(numCells)
    for(var i=0; i<numCells; ++i) {
      result[i] = constructCell(dimension, i)
    }
    return result
  }
  },{"convex-hull":135}],449:[function(_dereq_,module,exports){
  /*jshint unused:true*/
  /*
  Input:  matrix      ; a 4x4 matrix
  Output: translation ; a 3 component vector
          scale       ; a 3 component vector
          skew        ; skew factors XY,XZ,YZ represented as a 3 component vector
          perspective ; a 4 component vector
          quaternion  ; a 4 component vector
  Returns false if the matrix cannot be decomposed, true if it can
  
  
  References:
  https://github.com/kamicane/matrix3d/blob/master/lib/Matrix3d.js
  https://github.com/ChromiumWebApps/chromium/blob/master/ui/gfx/transform_util.cc
  http://www.w3.org/TR/css3-transforms/#decomposing-a-3d-matrix
  */
  
  var normalize = _dereq_('./normalize')
  
  var create = _dereq_('gl-mat4/create')
  var clone = _dereq_('gl-mat4/clone')
  var determinant = _dereq_('gl-mat4/determinant')
  var invert = _dereq_('gl-mat4/invert')
  var transpose = _dereq_('gl-mat4/transpose')
  var vec3 = {
      length: _dereq_('gl-vec3/length'),
      normalize: _dereq_('gl-vec3/normalize'),
      dot: _dereq_('gl-vec3/dot'),
      cross: _dereq_('gl-vec3/cross')
  }
  
  var tmp = create()
  var perspectiveMatrix = create()
  var tmpVec4 = [0, 0, 0, 0]
  var row = [ [0,0,0], [0,0,0], [0,0,0] ]
  var pdum3 = [0,0,0]
  
  module.exports = function decomposeMat4(matrix, translation, scale, skew, perspective, quaternion) {
      if (!translation) translation = [0,0,0]
      if (!scale) scale = [0,0,0]
      if (!skew) skew = [0,0,0]
      if (!perspective) perspective = [0,0,0,1]
      if (!quaternion) quaternion = [0,0,0,1]
  
      //normalize, if not possible then bail out early
      if (!normalize(tmp, matrix))
          return false
  
      // perspectiveMatrix is used to solve for perspective, but it also provides
      // an easy way to test for singularity of the upper 3x3 component.
      clone(perspectiveMatrix, tmp)
  
      perspectiveMatrix[3] = 0
      perspectiveMatrix[7] = 0
      perspectiveMatrix[11] = 0
      perspectiveMatrix[15] = 1
  
      // If the perspectiveMatrix is not invertible, we are also unable to
      // decompose, so we'll bail early. Constant taken from SkMatrix44::invert.
      if (Math.abs(determinant(perspectiveMatrix) < 1e-8))
          return false
  
      var a03 = tmp[3], a13 = tmp[7], a23 = tmp[11],
              a30 = tmp[12], a31 = tmp[13], a32 = tmp[14], a33 = tmp[15]
  
      // First, isolate perspective.
      if (a03 !== 0 || a13 !== 0 || a23 !== 0) {
          tmpVec4[0] = a03
          tmpVec4[1] = a13
          tmpVec4[2] = a23
          tmpVec4[3] = a33
  
          // Solve the equation by inverting perspectiveMatrix and multiplying
          // rightHandSide by the inverse.
          // resuing the perspectiveMatrix here since it's no longer needed
          var ret = invert(perspectiveMatrix, perspectiveMatrix)
          if (!ret) return false
          transpose(perspectiveMatrix, perspectiveMatrix)
  
          //multiply by transposed inverse perspective matrix, into perspective vec4
          vec4multMat4(perspective, tmpVec4, perspectiveMatrix)
      } else { 
          //no perspective
          perspective[0] = perspective[1] = perspective[2] = 0
          perspective[3] = 1
      }
  
      // Next take care of translation
      translation[0] = a30
      translation[1] = a31
      translation[2] = a32
  
      // Now get scale and shear. 'row' is a 3 element array of 3 component vectors
      mat3from4(row, tmp)
  
      // Compute X scale factor and normalize first row.
      scale[0] = vec3.length(row[0])
      vec3.normalize(row[0], row[0])
  
      // Compute XY shear factor and make 2nd row orthogonal to 1st.
      skew[0] = vec3.dot(row[0], row[1])
      combine(row[1], row[1], row[0], 1.0, -skew[0])
  
      // Now, compute Y scale and normalize 2nd row.
      scale[1] = vec3.length(row[1])
      vec3.normalize(row[1], row[1])
      skew[0] /= scale[1]
  
      // Compute XZ and YZ shears, orthogonalize 3rd row
      skew[1] = vec3.dot(row[0], row[2])
      combine(row[2], row[2], row[0], 1.0, -skew[1])
      skew[2] = vec3.dot(row[1], row[2])
      combine(row[2], row[2], row[1], 1.0, -skew[2])
  
      // Next, get Z scale and normalize 3rd row.
      scale[2] = vec3.length(row[2])
      vec3.normalize(row[2], row[2])
      skew[1] /= scale[2]
      skew[2] /= scale[2]
  
  
      // At this point, the matrix (in rows) is orthonormal.
      // Check for a coordinate system flip.  If the determinant
      // is -1, then negate the matrix and the scaling factors.
      vec3.cross(pdum3, row[1], row[2])
      if (vec3.dot(row[0], pdum3) < 0) {
          for (var i = 0; i < 3; i++) {
              scale[i] *= -1;
              row[i][0] *= -1
              row[i][1] *= -1
              row[i][2] *= -1
          }
      }
  
      // Now, get the rotations out
      quaternion[0] = 0.5 * Math.sqrt(Math.max(1 + row[0][0] - row[1][1] - row[2][2], 0))
      quaternion[1] = 0.5 * Math.sqrt(Math.max(1 - row[0][0] + row[1][1] - row[2][2], 0))
      quaternion[2] = 0.5 * Math.sqrt(Math.max(1 - row[0][0] - row[1][1] + row[2][2], 0))
      quaternion[3] = 0.5 * Math.sqrt(Math.max(1 + row[0][0] + row[1][1] + row[2][2], 0))
  
      if (row[2][1] > row[1][2])
          quaternion[0] = -quaternion[0]
      if (row[0][2] > row[2][0])
          quaternion[1] = -quaternion[1]
      if (row[1][0] > row[0][1])
          quaternion[2] = -quaternion[2]
      return true
  }
  
  //will be replaced by gl-vec4 eventually
  function vec4multMat4(out, a, m) {
      var x = a[0], y = a[1], z = a[2], w = a[3];
      out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
      out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
      out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
      out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
      return out;
  }
  
  //gets upper-left of a 4x4 matrix into a 3x3 of vectors
  function mat3from4(out, mat4x4) {
      out[0][0] = mat4x4[0]
      out[0][1] = mat4x4[1]
      out[0][2] = mat4x4[2]
      
      out[1][0] = mat4x4[4]
      out[1][1] = mat4x4[5]
      out[1][2] = mat4x4[6]
  
      out[2][0] = mat4x4[8]
      out[2][1] = mat4x4[9]
      out[2][2] = mat4x4[10]
  }
  
  function combine(out, a, b, scale1, scale2) {
      out[0] = a[0] * scale1 + b[0] * scale2
      out[1] = a[1] * scale1 + b[1] * scale2
      out[2] = a[2] * scale1 + b[2] * scale2
  }
  },{"./normalize":450,"gl-mat4/clone":272,"gl-mat4/create":273,"gl-mat4/determinant":274,"gl-mat4/invert":278,"gl-mat4/transpose":289,"gl-vec3/cross":339,"gl-vec3/dot":344,"gl-vec3/length":354,"gl-vec3/normalize":361}],450:[function(_dereq_,module,exports){
  module.exports = function normalize(out, mat) {
      var m44 = mat[15]
      // Cannot normalize.
      if (m44 === 0) 
          return false
      var scale = 1 / m44
      for (var i=0; i<16; i++)
          out[i] = mat[i] * scale
      return true
  }
  },{}],451:[function(_dereq_,module,exports){
  var lerp = _dereq_('gl-vec3/lerp')
  
  var recompose = _dereq_('mat4-recompose')
  var decompose = _dereq_('mat4-decompose')
  var determinant = _dereq_('gl-mat4/determinant')
  var slerp = _dereq_('quat-slerp')
  
  var state0 = state()
  var state1 = state()
  var tmp = state()
  
  module.exports = interpolate
  function interpolate(out, start, end, alpha) {
      if (determinant(start) === 0 || determinant(end) === 0)
          return false
  
      //decompose the start and end matrices into individual components
      var r0 = decompose(start, state0.translate, state0.scale, state0.skew, state0.perspective, state0.quaternion)
      var r1 = decompose(end, state1.translate, state1.scale, state1.skew, state1.perspective, state1.quaternion)
      if (!r0 || !r1)
          return false    
  
  
      //now lerp/slerp the start and end components into a temporary     lerp(tmptranslate, state0.translate, state1.translate, alpha)
      lerp(tmp.translate, state0.translate, state1.translate, alpha)
      lerp(tmp.skew, state0.skew, state1.skew, alpha)
      lerp(tmp.scale, state0.scale, state1.scale, alpha)
      lerp(tmp.perspective, state0.perspective, state1.perspective, alpha)
      slerp(tmp.quaternion, state0.quaternion, state1.quaternion, alpha)
  
      //and recompose into our 'out' matrix
      recompose(out, tmp.translate, tmp.scale, tmp.skew, tmp.perspective, tmp.quaternion)
      return true
  }
  
  function state() {
      return {
          translate: vec3(),
          scale: vec3(1),
          skew: vec3(),
          perspective: vec4(),
          quaternion: vec4()
      }
  }
  
  function vec3(n) {
      return [n||0,n||0,n||0]
  }
  
  function vec4() {
      return [0,0,0,1]
  }
  },{"gl-mat4/determinant":274,"gl-vec3/lerp":355,"mat4-decompose":449,"mat4-recompose":452,"quat-slerp":501}],452:[function(_dereq_,module,exports){
  /*
  Input:  translation ; a 3 component vector
          scale       ; a 3 component vector
          skew        ; skew factors XY,XZ,YZ represented as a 3 component vector
          perspective ; a 4 component vector
          quaternion  ; a 4 component vector
  Output: matrix      ; a 4x4 matrix
  
  From: http://www.w3.org/TR/css3-transforms/#recomposing-to-a-3d-matrix
  */
  
  var mat4 = {
      identity: _dereq_('gl-mat4/identity'),
      translate: _dereq_('gl-mat4/translate'),
      multiply: _dereq_('gl-mat4/multiply'),
      create: _dereq_('gl-mat4/create'),
      scale: _dereq_('gl-mat4/scale'),
      fromRotationTranslation: _dereq_('gl-mat4/fromRotationTranslation')
  }
  
  var rotationMatrix = mat4.create()
  var temp = mat4.create()
  
  module.exports = function recomposeMat4(matrix, translation, scale, skew, perspective, quaternion) {
      mat4.identity(matrix)
  
      //apply translation & rotation
      mat4.fromRotationTranslation(matrix, quaternion, translation)
  
      //apply perspective
      matrix[3] = perspective[0]
      matrix[7] = perspective[1]
      matrix[11] = perspective[2]
      matrix[15] = perspective[3]
          
      // apply skew
      // temp is a identity 4x4 matrix initially
      mat4.identity(temp)
  
      if (skew[2] !== 0) {
          temp[9] = skew[2]
          mat4.multiply(matrix, matrix, temp)
      }
  
      if (skew[1] !== 0) {
          temp[9] = 0
          temp[8] = skew[1]
          mat4.multiply(matrix, matrix, temp)
      }
  
      if (skew[0] !== 0) {
          temp[8] = 0
          temp[4] = skew[0]
          mat4.multiply(matrix, matrix, temp)
      }
  
      //apply scale
      mat4.scale(matrix, matrix, scale)
      return matrix
  }
  },{"gl-mat4/create":273,"gl-mat4/fromRotationTranslation":276,"gl-mat4/identity":277,"gl-mat4/multiply":280,"gl-mat4/scale":287,"gl-mat4/translate":288}],453:[function(_dereq_,module,exports){
  'use strict';
  module.exports = Math.log2 || function (x) {
    return Math.log(x) * Math.LOG2E;
  };
  
  },{}],454:[function(_dereq_,module,exports){
  'use strict'
  
  var bsearch   = _dereq_('binary-search-bounds')
  var m4interp  = _dereq_('mat4-interpolate')
  var invert44  = _dereq_('gl-mat4/invert')
  var rotateX   = _dereq_('gl-mat4/rotateX')
  var rotateY   = _dereq_('gl-mat4/rotateY')
  var rotateZ   = _dereq_('gl-mat4/rotateZ')
  var lookAt    = _dereq_('gl-mat4/lookAt')
  var translate = _dereq_('gl-mat4/translate')
  var scale     = _dereq_('gl-mat4/scale')
  var normalize = _dereq_('gl-vec3/normalize')
  
  var DEFAULT_CENTER = [0,0,0]
  
  module.exports = createMatrixCameraController
  
  function MatrixCameraController(initialMatrix) {
    this._components    = initialMatrix.slice()
    this._time          = [0]
    this.prevMatrix     = initialMatrix.slice()
    this.nextMatrix     = initialMatrix.slice()
    this.computedMatrix = initialMatrix.slice()
    this.computedInverse = initialMatrix.slice()
    this.computedEye    = [0,0,0]
    this.computedUp     = [0,0,0]
    this.computedCenter = [0,0,0]
    this.computedRadius = [0]
    this._limits        = [-Infinity, Infinity]
  }
  
  var proto = MatrixCameraController.prototype
  
  proto.recalcMatrix = function(t) {
    var time = this._time
    var tidx = bsearch.le(time, t)
    var mat = this.computedMatrix
    if(tidx < 0) {
      return
    }
    var comps = this._components
    if(tidx === time.length-1) {
      var ptr = 16*tidx
      for(var i=0; i<16; ++i) {
        mat[i] = comps[ptr++]
      }
    } else {
      var dt = (time[tidx+1] - time[tidx])
      var ptr = 16*tidx
      var prev = this.prevMatrix
      var allEqual = true
      for(var i=0; i<16; ++i) {
        prev[i] = comps[ptr++]
      }
      var next = this.nextMatrix
      for(var i=0; i<16; ++i) {
        next[i] = comps[ptr++]
        allEqual = allEqual && (prev[i] === next[i])
      }
      if(dt < 1e-6 || allEqual) {
        for(var i=0; i<16; ++i) {
          mat[i] = prev[i]
        }
      } else {
        m4interp(mat, prev, next, (t - time[tidx])/dt)
      }
    }
  
    var up = this.computedUp
    up[0] = mat[1]
    up[1] = mat[5]
    up[2] = mat[9]
    normalize(up, up)
  
    var imat = this.computedInverse
    invert44(imat, mat)
    var eye = this.computedEye
    var w = imat[15]
    eye[0] = imat[12]/w
    eye[1] = imat[13]/w
    eye[2] = imat[14]/w
  
    var center = this.computedCenter
    var radius = Math.exp(this.computedRadius[0])
    for(var i=0; i<3; ++i) {
      center[i] = eye[i] - mat[2+4*i] * radius
    }
  }
  
  proto.idle = function(t) {
    if(t < this.lastT()) {
      return
    }
    var mc = this._components
    var ptr = mc.length-16
    for(var i=0; i<16; ++i) {
      mc.push(mc[ptr++])
    }
    this._time.push(t)
  }
  
  proto.flush = function(t) {
    var idx = bsearch.gt(this._time, t) - 2
    if(idx < 0) {
      return
    }
    this._time.splice(0, idx)
    this._components.splice(0, 16*idx)
  }
  
  proto.lastT = function() {
    return this._time[this._time.length-1]
  }
  
  proto.lookAt = function(t, eye, center, up) {
    this.recalcMatrix(t)
    eye    = eye || this.computedEye
    center = center || DEFAULT_CENTER
    up     = up || this.computedUp
    this.setMatrix(t, lookAt(this.computedMatrix, eye, center, up))
    var d2 = 0.0
    for(var i=0; i<3; ++i) {
      d2 += Math.pow(center[i] - eye[i], 2)
    }
    d2 = Math.log(Math.sqrt(d2))
    this.computedRadius[0] = d2
  }
  
  proto.rotate = function(t, yaw, pitch, roll) {
    this.recalcMatrix(t)
    var mat = this.computedInverse
    if(yaw)   rotateY(mat, mat, yaw)
    if(pitch) rotateX(mat, mat, pitch)
    if(roll)  rotateZ(mat, mat, roll)
    this.setMatrix(t, invert44(this.computedMatrix, mat))
  }
  
  var tvec = [0,0,0]
  
  proto.pan = function(t, dx, dy, dz) {
    tvec[0] = -(dx || 0.0)
    tvec[1] = -(dy || 0.0)
    tvec[2] = -(dz || 0.0)
    this.recalcMatrix(t)
    var mat = this.computedInverse
    translate(mat, mat, tvec)
    this.setMatrix(t, invert44(mat, mat))
  }
  
  proto.translate = function(t, dx, dy, dz) {
    tvec[0] = dx || 0.0
    tvec[1] = dy || 0.0
    tvec[2] = dz || 0.0
    this.recalcMatrix(t)
    var mat = this.computedMatrix
    translate(mat, mat, tvec)
    this.setMatrix(t, mat)
  }
  
  proto.setMatrix = function(t, mat) {
    if(t < this.lastT()) {
      return
    }
    this._time.push(t)
    for(var i=0; i<16; ++i) {
      this._components.push(mat[i])
    }
  }
  
  proto.setDistance = function(t, d) {
    this.computedRadius[0] = d
  }
  
  proto.setDistanceLimits = function(a,b) {
    var lim = this._limits
    lim[0] = a
    lim[1] = b
  }
  
  proto.getDistanceLimits = function(out) {
    var lim = this._limits
    if(out) {
      out[0] = lim[0]
      out[1] = lim[1]
      return out
    }
    return lim
  }
  
  function createMatrixCameraController(options) {
    options = options || {}
    var matrix = options.matrix || 
                [1,0,0,0,
                 0,1,0,0,
                 0,0,1,0,
                 0,0,0,1]
    return new MatrixCameraController(matrix)
  }
  
  },{"binary-search-bounds":455,"gl-mat4/invert":278,"gl-mat4/lookAt":279,"gl-mat4/rotateX":284,"gl-mat4/rotateY":285,"gl-mat4/rotateZ":286,"gl-mat4/scale":287,"gl-mat4/translate":288,"gl-vec3/normalize":361,"mat4-interpolate":451}],455:[function(_dereq_,module,exports){
  arguments[4][243][0].apply(exports,arguments)
  },{"dup":243}],456:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = monotoneConvexHull2D
  
  var orient = _dereq_('robust-orientation')[3]
  
  function monotoneConvexHull2D(points) {
    var n = points.length
  
    if(n < 3) {
      var result = new Array(n)
      for(var i=0; i<n; ++i) {
        result[i] = i
      }
  
      if(n === 2 &&
         points[0][0] === points[1][0] &&
         points[0][1] === points[1][1]) {
        return [0]
      }
  
      return result
    }
  
    //Sort point indices along x-axis
    var sorted = new Array(n)
    for(var i=0; i<n; ++i) {
      sorted[i] = i
    }
    sorted.sort(function(a,b) {
      var d = points[a][0]-points[b][0]
      if(d) {
        return d
      }
      return points[a][1] - points[b][1]
    })
  
    //Construct upper and lower hulls
    var lower = [sorted[0], sorted[1]]
    var upper = [sorted[0], sorted[1]]
  
    for(var i=2; i<n; ++i) {
      var idx = sorted[i]
      var p   = points[idx]
  
      //Insert into lower list
      var m = lower.length
      while(m > 1 && orient(
          points[lower[m-2]], 
          points[lower[m-1]], 
          p) <= 0) {
        m -= 1
        lower.pop()
      }
      lower.push(idx)
  
      //Insert into upper list
      m = upper.length
      while(m > 1 && orient(
          points[upper[m-2]], 
          points[upper[m-1]], 
          p) >= 0) {
        m -= 1
        upper.pop()
      }
      upper.push(idx)
    }
  
    //Merge lists together
    var result = new Array(upper.length + lower.length - 2)
    var ptr    = 0
    for(var i=0, nl=lower.length; i<nl; ++i) {
      result[ptr++] = lower[i]
    }
    for(var j=upper.length-2; j>0; --j) {
      result[ptr++] = upper[j]
    }
  
    //Return result
    return result
  }
  },{"robust-orientation":520}],457:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = mouseListen
  
  var mouse = _dereq_('mouse-event')
  
  function mouseListen (element, callback) {
    if (!callback) {
      callback = element
      element = window
    }
  
    var buttonState = 0
    var x = 0
    var y = 0
    var mods = {
      shift: false,
      alt: false,
      control: false,
      meta: false
    }
    var attached = false
  
    function updateMods (ev) {
      var changed = false
      if ('altKey' in ev) {
        changed = changed || ev.altKey !== mods.alt
        mods.alt = !!ev.altKey
      }
      if ('shiftKey' in ev) {
        changed = changed || ev.shiftKey !== mods.shift
        mods.shift = !!ev.shiftKey
      }
      if ('ctrlKey' in ev) {
        changed = changed || ev.ctrlKey !== mods.control
        mods.control = !!ev.ctrlKey
      }
      if ('metaKey' in ev) {
        changed = changed || ev.metaKey !== mods.meta
        mods.meta = !!ev.metaKey
      }
      return changed
    }
  
    function handleEvent (nextButtons, ev) {
      var nextX = mouse.x(ev)
      var nextY = mouse.y(ev)
      if ('buttons' in ev) {
        nextButtons = ev.buttons | 0
      }
      if (nextButtons !== buttonState ||
        nextX !== x ||
        nextY !== y ||
        updateMods(ev)) {
        buttonState = nextButtons | 0
        x = nextX || 0
        y = nextY || 0
        callback && callback(buttonState, x, y, mods)
      }
    }
  
    function clearState (ev) {
      handleEvent(0, ev)
    }
  
    function handleBlur () {
      if (buttonState ||
        x ||
        y ||
        mods.shift ||
        mods.alt ||
        mods.meta ||
        mods.control) {
        x = y = 0
        buttonState = 0
        mods.shift = mods.alt = mods.control = mods.meta = false
        callback && callback(0, 0, 0, mods)
      }
    }
  
    function handleMods (ev) {
      if (updateMods(ev)) {
        callback && callback(buttonState, x, y, mods)
      }
    }
  
    function handleMouseMove (ev) {
      if (mouse.buttons(ev) === 0) {
        handleEvent(0, ev)
      } else {
        handleEvent(buttonState, ev)
      }
    }
  
    function handleMouseDown (ev) {
      handleEvent(buttonState | mouse.buttons(ev), ev)
    }
  
    function handleMouseUp (ev) {
      handleEvent(buttonState & ~mouse.buttons(ev), ev)
    }
  
    function attachListeners () {
      if (attached) {
        return
      }
      attached = true
  
      element.addEventListener('mousemove', handleMouseMove)
  
      element.addEventListener('mousedown', handleMouseDown)
  
      element.addEventListener('mouseup', handleMouseUp)
  
      element.addEventListener('mouseleave', clearState)
      element.addEventListener('mouseenter', clearState)
      element.addEventListener('mouseout', clearState)
      element.addEventListener('mouseover', clearState)
  
      element.addEventListener('blur', handleBlur)
  
      element.addEventListener('keyup', handleMods)
      element.addEventListener('keydown', handleMods)
      element.addEventListener('keypress', handleMods)
  
      if (element !== window) {
        window.addEventListener('blur', handleBlur)
  
        window.addEventListener('keyup', handleMods)
        window.addEventListener('keydown', handleMods)
        window.addEventListener('keypress', handleMods)
      }
    }
  
    function detachListeners () {
      if (!attached) {
        return
      }
      attached = false
  
      element.removeEventListener('mousemove', handleMouseMove)
  
      element.removeEventListener('mousedown', handleMouseDown)
  
      element.removeEventListener('mouseup', handleMouseUp)
  
      element.removeEventListener('mouseleave', clearState)
      element.removeEventListener('mouseenter', clearState)
      element.removeEventListener('mouseout', clearState)
      element.removeEventListener('mouseover', clearState)
  
      element.removeEventListener('blur', handleBlur)
  
      element.removeEventListener('keyup', handleMods)
      element.removeEventListener('keydown', handleMods)
      element.removeEventListener('keypress', handleMods)
  
      if (element !== window) {
        window.removeEventListener('blur', handleBlur)
  
        window.removeEventListener('keyup', handleMods)
        window.removeEventListener('keydown', handleMods)
        window.removeEventListener('keypress', handleMods)
      }
    }
  
    // Attach listeners
    attachListeners()
  
    var result = {
      element: element
    }
  
    Object.defineProperties(result, {
      enabled: {
        get: function () { return attached },
        set: function (f) {
          if (f) {
            attachListeners()
          } else {
            detachListeners()
          }
        },
        enumerable: true
      },
      buttons: {
        get: function () { return buttonState },
        enumerable: true
      },
      x: {
        get: function () { return x },
        enumerable: true
      },
      y: {
        get: function () { return y },
        enumerable: true
      },
      mods: {
        get: function () { return mods },
        enumerable: true
      }
    })
  
    return result
  }
  
  },{"mouse-event":459}],458:[function(_dereq_,module,exports){
  var rootPosition = { left: 0, top: 0 }
  
  module.exports = mouseEventOffset
  function mouseEventOffset (ev, target, out) {
    target = target || ev.currentTarget || ev.srcElement
    if (!Array.isArray(out)) {
      out = [ 0, 0 ]
    }
    var cx = ev.clientX || 0
    var cy = ev.clientY || 0
    var rect = getBoundingClientOffset(target)
    out[0] = cx - rect.left
    out[1] = cy - rect.top
    return out
  }
  
  function getBoundingClientOffset (element) {
    if (element === window ||
        element === document ||
        element === document.body) {
      return rootPosition
    } else {
      return element.getBoundingClientRect()
    }
  }
  
  },{}],459:[function(_dereq_,module,exports){
  'use strict'
  
  function mouseButtons(ev) {
    if(typeof ev === 'object') {
      if('buttons' in ev) {
        return ev.buttons
      } else if('which' in ev) {
        var b = ev.which
        if(b === 2) {
          return 4
        } else if(b === 3) {
          return 2
        } else if(b > 0) {
          return 1<<(b-1)
        }
      } else if('button' in ev) {
        var b = ev.button
        if(b === 1) {
          return 4
        } else if(b === 2) {
          return 2
        } else if(b >= 0) {
          return 1<<b
        }
      }
    }
    return 0
  }
  exports.buttons = mouseButtons
  
  function mouseElement(ev) {
    return ev.target || ev.srcElement || window
  }
  exports.element = mouseElement
  
  function mouseRelativeX(ev) {
    if(typeof ev === 'object') {
      if('offsetX' in ev) {
        return ev.offsetX
      }
      var target = mouseElement(ev)
      var bounds = target.getBoundingClientRect()
      return ev.clientX - bounds.left
    }
    return 0
  }
  exports.x = mouseRelativeX
  
  function mouseRelativeY(ev) {
    if(typeof ev === 'object') {
      if('offsetY' in ev) {
        return ev.offsetY
      }
      var target = mouseElement(ev)
      var bounds = target.getBoundingClientRect()
      return ev.clientY - bounds.top
    }
    return 0
  }
  exports.y = mouseRelativeY
  
  },{}],460:[function(_dereq_,module,exports){
  'use strict'
  
  var toPX = _dereq_('to-px')
  
  module.exports = mouseWheelListen
  
  function mouseWheelListen(element, callback, noScroll) {
    if(typeof element === 'function') {
      noScroll = !!callback
      callback = element
      element = window
    }
    var lineHeight = toPX('ex', element)
    var listener = function(ev) {
      if(noScroll) {
        ev.preventDefault()
      }
      var dx = ev.deltaX || 0
      var dy = ev.deltaY || 0
      var dz = ev.deltaZ || 0
      var mode = ev.deltaMode
      var scale = 1
      switch(mode) {
        case 1:
          scale = lineHeight
        break
        case 2:
          scale = window.innerHeight
        break
      }
      dx *= scale
      dy *= scale
      dz *= scale
      if(dx || dy || dz) {
        return callback(dx, dy, dz, ev)
      }
    }
    element.addEventListener('wheel', listener)
    return listener
  }
  
  },{"to-px":550}],461:[function(_dereq_,module,exports){
  "use strict"
  
  var pool = _dereq_("typedarray-pool")
  
  module.exports = createSurfaceExtractor
  
  //Helper macros
  function array(i) {
    return "a" + i
  }
  function data(i) {
    return "d" + i
  }
  function cube(i,bitmask) {
    return "c" + i + "_" + bitmask
  }
  function shape(i) {
    return "s" + i
  }
  function stride(i,j) {
    return "t" + i + "_" + j
  }
  function offset(i) {
    return "o" + i
  }
  function scalar(i) {
    return "x" + i
  }
  function pointer(i) {
    return "p" + i
  }
  function delta(i,bitmask) {
    return "d" + i + "_" + bitmask
  }
  function index(i) {
    return "i" + i
  }
  function step(i,j) {
    return "u" + i + "_" + j
  }
  function pcube(bitmask) {
    return "b" + bitmask
  }
  function qcube(bitmask) {
    return "y" + bitmask
  }
  function pdelta(bitmask) {
    return "e" + bitmask
  }
  function vert(i) {
    return "v" + i
  }
  var VERTEX_IDS = "V"
  var PHASES = "P"
  var VERTEX_COUNT = "N"
  var POOL_SIZE = "Q"
  var POINTER = "X"
  var TEMPORARY = "T"
  
  function permBitmask(dimension, mask, order) {
    var r = 0
    for(var i=0; i<dimension; ++i) {
      if(mask & (1<<i)) {
        r |= (1<<order[i])
      }
    }
    return r
  }
  
  //Generates the surface procedure
  function compileSurfaceProcedure(vertexFunc, faceFunc, phaseFunc, scalarArgs, order, typesig) {
    var arrayArgs = typesig.length
    var dimension = order.length
  
    if(dimension < 2) {
      throw new Error("ndarray-extract-contour: Dimension must be at least 2")
    }
  
    var funcName = "extractContour" + order.join("_")
    var code = []
    var vars = []
    var args = []
  
    //Assemble arguments
    for(var i=0; i<arrayArgs; ++i) {
      args.push(array(i))  
    }
    for(var i=0; i<scalarArgs; ++i) {
      args.push(scalar(i))
    }
  
    //Shape
    for(var i=0; i<dimension; ++i) {
      vars.push(shape(i) + "=" + array(0) + ".shape[" + i + "]|0")
    }
    //Data, stride, offset pointers
    for(var i=0; i<arrayArgs; ++i) {
      vars.push(data(i) + "=" + array(i) + ".data",
                offset(i) + "=" + array(i) + ".offset|0")
      for(var j=0; j<dimension; ++j) {
        vars.push(stride(i,j) + "=" + array(i) + ".stride[" + j + "]|0")
      }
    }
    //Pointer, delta and cube variables
    for(var i=0; i<arrayArgs; ++i) {
      vars.push(pointer(i) + "=" + offset(i))
      vars.push(cube(i,0))
      for(var j=1; j<(1<<dimension); ++j) {
        var ptrStr = []
        for(var k=0; k<dimension; ++k) {
          if(j & (1<<k)) {
            ptrStr.push("-" + stride(i,k))
          }
        }
        vars.push(delta(i,j) + "=(" + ptrStr.join("") + ")|0")
        vars.push(cube(i,j) + "=0")
      }
    }
    //Create step variables
    for(var i=0; i<arrayArgs; ++i) {
      for(var j=0; j<dimension; ++j) {
        var stepVal = [ stride(i,order[j]) ]
        if(j > 0) {
          stepVal.push(stride(i, order[j-1]) + "*" + shape(order[j-1]) )
        }
        vars.push(step(i,order[j]) + "=(" + stepVal.join("-") + ")|0")
      }
    }
    //Create index variables
    for(var i=0; i<dimension; ++i) {
      vars.push(index(i) + "=0")
    }
    //Vertex count
    vars.push(VERTEX_COUNT + "=0")
    //Compute pool size, initialize pool step
    var sizeVariable = ["2"]
    for(var i=dimension-2; i>=0; --i) {
      sizeVariable.push(shape(order[i]))
    }
    //Previous phases and vertex_ids
    vars.push(POOL_SIZE + "=(" + sizeVariable.join("*") + ")|0",
              PHASES + "=mallocUint32(" + POOL_SIZE + ")",
              VERTEX_IDS + "=mallocUint32(" + POOL_SIZE + ")",
              POINTER + "=0")
    //Create cube variables for phases
    vars.push(pcube(0) + "=0")
    for(var j=1; j<(1<<dimension); ++j) {
      var cubeDelta = []
      var cubeStep = [ ]
      for(var k=0; k<dimension; ++k) {
        if(j & (1<<k)) {
          if(cubeStep.length === 0) {
            cubeDelta.push("1")
          } else {
            cubeDelta.unshift(cubeStep.join("*"))
          }
        }
        cubeStep.push(shape(order[k]))
      }
      var signFlag = ""
      if(cubeDelta[0].indexOf(shape(order[dimension-2])) < 0) {
        signFlag = "-"
      }
      var jperm = permBitmask(dimension, j, order)
      vars.push(pdelta(jperm) + "=(-" + cubeDelta.join("-") + ")|0",
                qcube(jperm) + "=(" + signFlag + cubeDelta.join("-") + ")|0",
                pcube(jperm) + "=0")
    }
    vars.push(vert(0) + "=0", TEMPORARY + "=0")
  
    function forLoopBegin(i, start) {
      code.push("for(", index(order[i]), "=", start, ";",
        index(order[i]), "<", shape(order[i]), ";",
        "++", index(order[i]), "){")
    }
  
    function forLoopEnd(i) {
      for(var j=0; j<arrayArgs; ++j) {
        code.push(pointer(j), "+=", step(j,order[i]), ";")
      }
      code.push("}")
    }
  
    function fillEmptySlice(k) {
      for(var i=k-1; i>=0; --i) {
        forLoopBegin(i, 0) 
      }
      var phaseFuncArgs = []
      for(var i=0; i<arrayArgs; ++i) {
        if(typesig[i]) {
          phaseFuncArgs.push(data(i) + ".get(" + pointer(i) + ")")
        } else {
          phaseFuncArgs.push(data(i) + "[" + pointer(i) + "]")
        }
      }
      for(var i=0; i<scalarArgs; ++i) {
        phaseFuncArgs.push(scalar(i))
      }
      code.push(PHASES, "[", POINTER, "++]=phase(", phaseFuncArgs.join(), ");")
      for(var i=0; i<k; ++i) {
        forLoopEnd(i)
      }
      for(var j=0; j<arrayArgs; ++j) {
        code.push(pointer(j), "+=", step(j,order[k]), ";")
      }
    }
  
    function processGridCell(mask) {
      //Read in local data
      for(var i=0; i<arrayArgs; ++i) {
        if(typesig[i]) {
          code.push(cube(i,0), "=", data(i), ".get(", pointer(i), ");")
        } else {
          code.push(cube(i,0), "=", data(i), "[", pointer(i), "];")
        }
      }
  
      //Read in phase
      var phaseFuncArgs = []
      for(var i=0; i<arrayArgs; ++i) {
        phaseFuncArgs.push(cube(i,0))
      }
      for(var i=0; i<scalarArgs; ++i) {
        phaseFuncArgs.push(scalar(i))
      }
      
      code.push(pcube(0), "=", PHASES, "[", POINTER, "]=phase(", phaseFuncArgs.join(), ");")
      
      //Read in other cube data
      for(var j=1; j<(1<<dimension); ++j) {
        code.push(pcube(j), "=", PHASES, "[", POINTER, "+", pdelta(j), "];")
      }
  
      //Check for boundary crossing
      var vertexPredicate = []
      for(var j=1; j<(1<<dimension); ++j) {
        vertexPredicate.push("(" + pcube(0) + "!==" + pcube(j) + ")")
      }
      code.push("if(", vertexPredicate.join("||"), "){")
  
      //Read in boundary data
      var vertexArgs = []
      for(var i=0; i<dimension; ++i) {
        vertexArgs.push(index(i))
      }
      for(var i=0; i<arrayArgs; ++i) {
        vertexArgs.push(cube(i,0))
        for(var j=1; j<(1<<dimension); ++j) {
          if(typesig[i]) {
            code.push(cube(i,j), "=", data(i), ".get(", pointer(i), "+", delta(i,j), ");")
          } else {
            code.push(cube(i,j), "=", data(i), "[", pointer(i), "+", delta(i,j), "];")
          }
          vertexArgs.push(cube(i,j))
        }
      }
      for(var i=0; i<(1<<dimension); ++i) {
        vertexArgs.push(pcube(i))
      }
      for(var i=0; i<scalarArgs; ++i) {
        vertexArgs.push(scalar(i))
      }
  
      //Generate vertex
      code.push("vertex(", vertexArgs.join(), ");",
        vert(0), "=", VERTEX_IDS, "[", POINTER, "]=", VERTEX_COUNT, "++;")
  
      //Check for face crossings
      var base = (1<<dimension)-1
      var corner = pcube(base)
      for(var j=0; j<dimension; ++j) {
        if((mask & ~(1<<j))===0) {
          //Check face
          var subset = base^(1<<j)
          var edge = pcube(subset)
          var faceArgs = [ ]
          for(var k=subset; k>0; k=(k-1)&subset) {
            faceArgs.push(VERTEX_IDS + "[" + POINTER + "+" + pdelta(k) + "]")
          }
          faceArgs.push(vert(0))
          for(var k=0; k<arrayArgs; ++k) {
            if(j&1) {
              faceArgs.push(cube(k,base), cube(k,subset))
            } else {
              faceArgs.push(cube(k,subset), cube(k,base))
            }
          }
          if(j&1) {
            faceArgs.push(corner, edge)
          } else {
            faceArgs.push(edge, corner)
          }
          for(var k=0; k<scalarArgs; ++k) {
            faceArgs.push(scalar(k))
          }
          code.push("if(", corner, "!==", edge, "){",
            "face(", faceArgs.join(), ")}")
        }
      }
      
      //Increment pointer, close off if statement
      code.push("}",
        POINTER, "+=1;")
    }
  
    function flip() {
      for(var j=1; j<(1<<dimension); ++j) {
        code.push(TEMPORARY, "=", pdelta(j), ";",
                  pdelta(j), "=", qcube(j), ";",
                  qcube(j), "=", TEMPORARY, ";")
      }
    }
  
    function createLoop(i, mask) {
      if(i < 0) {
        processGridCell(mask)
        return
      }
      fillEmptySlice(i)
      code.push("if(", shape(order[i]), ">0){",
        index(order[i]), "=1;")
      createLoop(i-1, mask|(1<<order[i]))
  
      for(var j=0; j<arrayArgs; ++j) {
        code.push(pointer(j), "+=", step(j,order[i]), ";")
      }
      if(i === dimension-1) {
        code.push(POINTER, "=0;")
        flip()
      }
      forLoopBegin(i, 2)
      createLoop(i-1, mask)
      if(i === dimension-1) {
        code.push("if(", index(order[dimension-1]), "&1){",
          POINTER, "=0;}")
        flip()
      }
      forLoopEnd(i)
      code.push("}")
    }
  
    createLoop(dimension-1, 0)
  
    //Release scratch memory
    code.push("freeUint32(", VERTEX_IDS, ");freeUint32(", PHASES, ");")
  
    //Compile and link procedure
    var procedureCode = [
      "'use strict';",
      "function ", funcName, "(", args.join(), "){",
        "var ", vars.join(), ";",
        code.join(""),
      "}",
      "return ", funcName ].join("")
  
    var proc = new Function(
      "vertex", 
      "face", 
      "phase", 
      "mallocUint32", 
      "freeUint32",
      procedureCode)
    return proc(
      vertexFunc, 
      faceFunc, 
      phaseFunc, 
      pool.mallocUint32, 
      pool.freeUint32)
  }
  
  function createSurfaceExtractor(args) {
    function error(msg) {
      throw new Error("ndarray-extract-contour: " + msg)
    }
    if(typeof args !== "object") {
      error("Must specify arguments")
    }
    var order = args.order
    if(!Array.isArray(order)) {
      error("Must specify order")
    }
    var arrays = args.arrayArguments||1
    if(arrays < 1) {
      error("Must have at least one array argument")
    }
    var scalars = args.scalarArguments||0
    if(scalars < 0) {
      error("Scalar arg count must be > 0")
    }
    if(typeof args.vertex !== "function") {
      error("Must specify vertex creation function")
    }
    if(typeof args.cell !== "function") {
      error("Must specify cell creation function")
    }
    if(typeof args.phase !== "function") {
      error("Must specify phase function")
    }
    var getters = args.getters || []
    var typesig = new Array(arrays)
    for(var i=0; i<arrays; ++i) {
      if(getters.indexOf(i) >= 0) {
        typesig[i] = true
      } else {
        typesig[i] = false
      }
    }
    return compileSurfaceProcedure(
      args.vertex,
      args.cell,
      args.phase,
      scalars,
      order,
      typesig)
  }
  },{"typedarray-pool":567}],462:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports      = gradient
  
  var dup             = _dereq_('dup')
  var cwiseCompiler   = _dereq_('cwise-compiler')
  
  var TEMPLATE_CACHE  = {}
  var GRADIENT_CACHE  = {}
  
  var EmptyProc = {
    body: "",
    args: [],
    thisVars: [],
    localVars: []
  }
  
  var centralDiff = cwiseCompiler({
    args: [ 'array', 'array', 'array' ],
    pre: EmptyProc,
    post: EmptyProc,
    body: {
      args: [ {
        name: 'out', 
        lvalue: true,
        rvalue: false,
        count: 1
      }, {
        name: 'left', 
        lvalue: false,
        rvalue: true,
        count: 1
      }, {
        name: 'right', 
        lvalue: false,
        rvalue: true,
        count: 1
      }],
      body: "out=0.5*(left-right)",
      thisVars: [],
      localVars: []
    },
    funcName: 'cdiff'
  })
  
  var zeroOut = cwiseCompiler({
    args: [ 'array' ],
    pre: EmptyProc,
    post: EmptyProc,
    body: {
      args: [ {
        name: 'out', 
        lvalue: true,
        rvalue: false,
        count: 1
      }],
      body: "out=0",
      thisVars: [],
      localVars: []
    },
    funcName: 'zero'
  })
  
  function generateTemplate(d) {
    if(d in TEMPLATE_CACHE) {
      return TEMPLATE_CACHE[d]
    }
    var code = []
    for(var i=0; i<d; ++i) {
      code.push('out', i, 's=0.5*(inp', i, 'l-inp', i, 'r);')
    }
    var args = [ 'array' ]
    var names = ['junk']
    for(var i=0; i<d; ++i) {
      args.push('array')
      names.push('out' + i + 's')
      var o = dup(d)
      o[i] = -1
      args.push({
        array: 0,
        offset: o.slice()
      })
      o[i] = 1
      args.push({
        array: 0,
        offset: o.slice()
      })
      names.push('inp' + i + 'l', 'inp' + i + 'r')
    }
    return TEMPLATE_CACHE[d] = cwiseCompiler({
      args: args,
      pre:  EmptyProc,
      post: EmptyProc,
      body: {
        body: code.join(''),
        args: names.map(function(n) {
          return {
            name: n,
            lvalue: n.indexOf('out') === 0,
            rvalue: n.indexOf('inp') === 0,
            count: (n!=='junk')|0
          }
        }),
        thisVars: [],
        localVars: []
      },
      funcName: 'fdTemplate' + d
    })
  }
  
  function generateGradient(boundaryConditions) {
    var token = boundaryConditions.join()
    var proc = GRADIENT_CACHE[token]
    if(proc) {
      return proc
    }
  
    var d = boundaryConditions.length
    var code = ['function gradient(dst,src){var s=src.shape.slice();' ]
    
    function handleBoundary(facet) {
      var cod = d - facet.length
  
      var loStr = []
      var hiStr = []
      var pickStr = []
      for(var i=0; i<d; ++i) {
        if(facet.indexOf(i+1) >= 0) {
          pickStr.push('0')
        } else if(facet.indexOf(-(i+1)) >= 0) {
          pickStr.push('s['+i+']-1')
        } else {
          pickStr.push('-1')
          loStr.push('1')
          hiStr.push('s['+i+']-2')
        }
      }
      var boundStr = '.lo(' + loStr.join() + ').hi(' + hiStr.join() + ')'
      if(loStr.length === 0) {
        boundStr = ''
      }
          
      if(cod > 0) {
        code.push('if(1') 
        for(var i=0; i<d; ++i) {
          if(facet.indexOf(i+1) >= 0 || facet.indexOf(-(i+1)) >= 0) {
            continue
          }
          code.push('&&s[', i, ']>2')
        }
        code.push('){grad', cod, '(src.pick(', pickStr.join(), ')', boundStr)
        for(var i=0; i<d; ++i) {
          if(facet.indexOf(i+1) >= 0 || facet.indexOf(-(i+1)) >= 0) {
            continue
          }
          code.push(',dst.pick(', pickStr.join(), ',', i, ')', boundStr)
        }
        code.push(');')
      }
  
      for(var i=0; i<facet.length; ++i) {
        var bnd = Math.abs(facet[i])-1
        var outStr = 'dst.pick(' + pickStr.join() + ',' + bnd + ')' + boundStr
        switch(boundaryConditions[bnd]) {
  
          case 'clamp':
            var cPickStr = pickStr.slice()
            var dPickStr = pickStr.slice()
            if(facet[i] < 0) {
              cPickStr[bnd] = 's[' + bnd + ']-2'
            } else {
              dPickStr[bnd] = '1'
            }
            if(cod === 0) {
              code.push('if(s[', bnd, ']>1){dst.set(',
                pickStr.join(), ',', bnd, ',0.5*(src.get(',
                  cPickStr.join(), ')-src.get(',
                  dPickStr.join(), ')))}else{dst.set(',
                pickStr.join(), ',', bnd, ',0)};')
            } else {
              code.push('if(s[', bnd, ']>1){diff(', outStr, 
                  ',src.pick(', cPickStr.join(), ')', boundStr, 
                  ',src.pick(', dPickStr.join(), ')', boundStr, 
                  ');}else{zero(', outStr, ');};')
            }
          break
  
          case 'mirror':
            if(cod === 0) {
              code.push('dst.set(', pickStr.join(), ',', bnd, ',0);')
            } else {
              code.push('zero(', outStr, ');')
            }
          break
  
          case 'wrap':
            var aPickStr = pickStr.slice()
            var bPickStr = pickStr.slice()
            if(facet[i] < 0) {
              aPickStr[bnd] = 's[' + bnd + ']-2'
              bPickStr[bnd] = '0'
              
            } else {
              aPickStr[bnd] = 's[' + bnd + ']-1'
              bPickStr[bnd] = '1'
            }
            if(cod === 0) {
              code.push('if(s[', bnd, ']>2){dst.set(',
                pickStr.join(), ',', bnd, ',0.5*(src.get(',
                  aPickStr.join(), ')-src.get(',
                  bPickStr.join(), ')))}else{dst.set(',
                pickStr.join(), ',', bnd, ',0)};')
            } else {
              code.push('if(s[', bnd, ']>2){diff(', outStr, 
                  ',src.pick(', aPickStr.join(), ')', boundStr, 
                  ',src.pick(', bPickStr.join(), ')', boundStr, 
                  ');}else{zero(', outStr, ');};')
            }
          break
  
          default:
            throw new Error('ndarray-gradient: Invalid boundary condition')
        }
      }
  
      if(cod > 0) {
        code.push('};')
      }
    }
  
    //Enumerate ridges, facets, etc. of hypercube
    for(var i=0; i<(1<<d); ++i) {
      var faces = []
      for(var j=0; j<d; ++j) {
        if(i & (1<<j)) {
          faces.push(j+1)
        }
      }
      for(var k=0; k<(1<<faces.length); ++k) {
        var sfaces = faces.slice()
        for(var j=0; j<faces.length; ++j) {
          if(k & (1<<j)) {
            sfaces[j] = -sfaces[j]
          }
        }
        handleBoundary(sfaces)
      }
    }
  
    code.push('return dst;};return gradient')
  
    //Compile and link routine, save cached procedure
    var linkNames = [ 'diff', 'zero' ]
    var linkArgs  = [ centralDiff, zeroOut ]
    for(var i=1; i<=d; ++i) {
      linkNames.push('grad' + i)
      linkArgs.push(generateTemplate(i))
    }
    linkNames.push(code.join(''))
  
    var link = Function.apply(void 0, linkNames)
    var proc = link.apply(void 0, linkArgs)
    TEMPLATE_CACHE[token] = proc
    return proc
  }
  
  function gradient(out, inp, bc) {
    if(Array.isArray(bc)) {
      if(bc.length !== inp.dimension) {
        throw new Error('ndarray-gradient: invalid boundary conditions')
      }
    } else if(typeof bc === 'string') {
      bc = dup(inp.dimension, bc)
    } else {
      bc = dup(inp.dimension, 'clamp')
    }
    if(out.dimension !== inp.dimension + 1) {
      throw new Error('ndarray-gradient: output dimension must be +1 input dimension')
    }
    if(out.shape[inp.dimension] !== inp.dimension) {
      throw new Error('ndarray-gradient: output shape must match input shape')
    }
    for(var i=0; i<inp.dimension; ++i) {
      if(out.shape[i] !== inp.shape[i]) {
        throw new Error('ndarray-gradient: shape mismatch')
      }
    }
    if(inp.size === 0) {
      return out
    }
    if(inp.dimension <= 0) {
      out.set(0)
      return out
    }
    var cached = generateGradient(bc)
    return cached(out, inp)
  }
  },{"cwise-compiler":151,"dup":176}],463:[function(_dereq_,module,exports){
  "use strict"
  
  function interp1d(arr, x) {
    var ix = Math.floor(x)
      , fx = x - ix
      , s0 = 0 <= ix   && ix   < arr.shape[0]
      , s1 = 0 <= ix+1 && ix+1 < arr.shape[0]
      , w0 = s0 ? +arr.get(ix)   : 0.0
      , w1 = s1 ? +arr.get(ix+1) : 0.0
    return (1.0-fx)*w0 + fx*w1
  }
  
  function interp2d(arr, x, y) {
    var ix = Math.floor(x)
      , fx = x - ix
      , s0 = 0 <= ix   && ix   < arr.shape[0]
      , s1 = 0 <= ix+1 && ix+1 < arr.shape[0]
      , iy = Math.floor(y)
      , fy = y - iy
      , t0 = 0 <= iy   && iy   < arr.shape[1]
      , t1 = 0 <= iy+1 && iy+1 < arr.shape[1]
      , w00 = s0&&t0 ? arr.get(ix  ,iy  ) : 0.0
      , w01 = s0&&t1 ? arr.get(ix  ,iy+1) : 0.0
      , w10 = s1&&t0 ? arr.get(ix+1,iy  ) : 0.0
      , w11 = s1&&t1 ? arr.get(ix+1,iy+1) : 0.0
    return (1.0-fy) * ((1.0-fx)*w00 + fx*w10) + fy * ((1.0-fx)*w01 + fx*w11)
  }
  
  function interp3d(arr, x, y, z) {
    var ix = Math.floor(x)
      , fx = x - ix
      , s0 = 0 <= ix   && ix   < arr.shape[0]
      , s1 = 0 <= ix+1 && ix+1 < arr.shape[0]
      , iy = Math.floor(y)
      , fy = y - iy
      , t0 = 0 <= iy   && iy   < arr.shape[1]
      , t1 = 0 <= iy+1 && iy+1 < arr.shape[1]
      , iz = Math.floor(z)
      , fz = z - iz
      , u0 = 0 <= iz   && iz   < arr.shape[2]
      , u1 = 0 <= iz+1 && iz+1 < arr.shape[2]
      , w000 = s0&&t0&&u0 ? arr.get(ix,iy,iz)       : 0.0
      , w010 = s0&&t1&&u0 ? arr.get(ix,iy+1,iz)     : 0.0
      , w100 = s1&&t0&&u0 ? arr.get(ix+1,iy,iz)     : 0.0
      , w110 = s1&&t1&&u0 ? arr.get(ix+1,iy+1,iz)   : 0.0
      , w001 = s0&&t0&&u1 ? arr.get(ix,iy,iz+1)     : 0.0
      , w011 = s0&&t1&&u1 ? arr.get(ix,iy+1,iz+1)   : 0.0
      , w101 = s1&&t0&&u1 ? arr.get(ix+1,iy,iz+1)   : 0.0
      , w111 = s1&&t1&&u1 ? arr.get(ix+1,iy+1,iz+1) : 0.0
    return (1.0-fz) * ((1.0-fy) * ((1.0-fx)*w000 + fx*w100) + fy * ((1.0-fx)*w010 + fx*w110)) + fz * ((1.0-fy) * ((1.0-fx)*w001 + fx*w101) + fy * ((1.0-fx)*w011 + fx*w111))
  }
  
  function interpNd(arr) {
    var d = arr.shape.length|0
      , ix = new Array(d)
      , fx = new Array(d)
      , s0 = new Array(d)
      , s1 = new Array(d)
      , i, t
    for(i=0; i<d; ++i) {
      t = +arguments[i+1]
      ix[i] = Math.floor(t)
      fx[i] = t - ix[i]
      s0[i] = (0 <= ix[i]   && ix[i]   < arr.shape[i])
      s1[i] = (0 <= ix[i]+1 && ix[i]+1 < arr.shape[i])
    }
    var r = 0.0, j, w, idx
  i_loop:
    for(i=0; i<(1<<d); ++i) {
      w = 1.0
      idx = arr.offset
      for(j=0; j<d; ++j) {
        if(i & (1<<j)) {
          if(!s1[j]) {
            continue i_loop
          }
          w *= fx[j]
          idx += arr.stride[j] * (ix[j] + 1)
        } else {
          if(!s0[j]) {
            continue i_loop
          }
          w *= 1.0 - fx[j]
          idx += arr.stride[j] * ix[j]
        }
      }
      r += w * arr.data[idx]
    }
    return r
  }
  
  function interpolate(arr, x, y, z) {
    switch(arr.shape.length) {
      case 0:
        return 0.0
      case 1:
        return interp1d(arr, x)
      case 2:
        return interp2d(arr, x, y)
      case 3:
        return interp3d(arr, x, y, z)
      default:
        return interpNd.apply(undefined, arguments)
    }
  }
  module.exports = interpolate
  module.exports.d1 = interp1d
  module.exports.d2 = interp2d
  module.exports.d3 = interp3d
  
  },{}],464:[function(_dereq_,module,exports){
  "use strict"
  
  var compile = _dereq_("cwise-compiler")
  
  var EmptyProc = {
    body: "",
    args: [],
    thisVars: [],
    localVars: []
  }
  
  function fixup(x) {
    if(!x) {
      return EmptyProc
    }
    for(var i=0; i<x.args.length; ++i) {
      var a = x.args[i]
      if(i === 0) {
        x.args[i] = {name: a, lvalue:true, rvalue: !!x.rvalue, count:x.count||1 }
      } else {
        x.args[i] = {name: a, lvalue:false, rvalue:true, count: 1}
      }
    }
    if(!x.thisVars) {
      x.thisVars = []
    }
    if(!x.localVars) {
      x.localVars = []
    }
    return x
  }
  
  function pcompile(user_args) {
    return compile({
      args:     user_args.args,
      pre:      fixup(user_args.pre),
      body:     fixup(user_args.body),
      post:     fixup(user_args.proc),
      funcName: user_args.funcName
    })
  }
  
  function makeOp(user_args) {
    var args = []
    for(var i=0; i<user_args.args.length; ++i) {
      args.push("a"+i)
    }
    var wrapper = new Function("P", [
      "return function ", user_args.funcName, "_ndarrayops(", args.join(","), ") {P(", args.join(","), ");return a0}"
    ].join(""))
    return wrapper(pcompile(user_args))
  }
  
  var assign_ops = {
    add:  "+",
    sub:  "-",
    mul:  "*",
    div:  "/",
    mod:  "%",
    band: "&",
    bor:  "|",
    bxor: "^",
    lshift: "<<",
    rshift: ">>",
    rrshift: ">>>"
  }
  ;(function(){
    for(var id in assign_ops) {
      var op = assign_ops[id]
      exports[id] = makeOp({
        args: ["array","array","array"],
        body: {args:["a","b","c"],
               body: "a=b"+op+"c"},
        funcName: id
      })
      exports[id+"eq"] = makeOp({
        args: ["array","array"],
        body: {args:["a","b"],
               body:"a"+op+"=b"},
        rvalue: true,
        funcName: id+"eq"
      })
      exports[id+"s"] = makeOp({
        args: ["array", "array", "scalar"],
        body: {args:["a","b","s"],
               body:"a=b"+op+"s"},
        funcName: id+"s"
      })
      exports[id+"seq"] = makeOp({
        args: ["array","scalar"],
        body: {args:["a","s"],
               body:"a"+op+"=s"},
        rvalue: true,
        funcName: id+"seq"
      })
    }
  })();
  
  var unary_ops = {
    not: "!",
    bnot: "~",
    neg: "-",
    recip: "1.0/"
  }
  ;(function(){
    for(var id in unary_ops) {
      var op = unary_ops[id]
      exports[id] = makeOp({
        args: ["array", "array"],
        body: {args:["a","b"],
               body:"a="+op+"b"},
        funcName: id
      })
      exports[id+"eq"] = makeOp({
        args: ["array"],
        body: {args:["a"],
               body:"a="+op+"a"},
        rvalue: true,
        count: 2,
        funcName: id+"eq"
      })
    }
  })();
  
  var binary_ops = {
    and: "&&",
    or: "||",
    eq: "===",
    neq: "!==",
    lt: "<",
    gt: ">",
    leq: "<=",
    geq: ">="
  }
  ;(function() {
    for(var id in binary_ops) {
      var op = binary_ops[id]
      exports[id] = makeOp({
        args: ["array","array","array"],
        body: {args:["a", "b", "c"],
               body:"a=b"+op+"c"},
        funcName: id
      })
      exports[id+"s"] = makeOp({
        args: ["array","array","scalar"],
        body: {args:["a", "b", "s"],
               body:"a=b"+op+"s"},
        funcName: id+"s"
      })
      exports[id+"eq"] = makeOp({
        args: ["array", "array"],
        body: {args:["a", "b"],
               body:"a=a"+op+"b"},
        rvalue:true,
        count:2,
        funcName: id+"eq"
      })
      exports[id+"seq"] = makeOp({
        args: ["array", "scalar"],
        body: {args:["a","s"],
               body:"a=a"+op+"s"},
        rvalue:true,
        count:2,
        funcName: id+"seq"
      })
    }
  })();
  
  var math_unary = [
    "abs",
    "acos",
    "asin",
    "atan",
    "ceil",
    "cos",
    "exp",
    "floor",
    "log",
    "round",
    "sin",
    "sqrt",
    "tan"
  ]
  ;(function() {
    for(var i=0; i<math_unary.length; ++i) {
      var f = math_unary[i]
      exports[f] = makeOp({
                      args: ["array", "array"],
                      pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                      body: {args:["a","b"], body:"a=this_f(b)", thisVars:["this_f"]},
                      funcName: f
                    })
      exports[f+"eq"] = makeOp({
                        args: ["array"],
                        pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                        body: {args: ["a"], body:"a=this_f(a)", thisVars:["this_f"]},
                        rvalue: true,
                        count: 2,
                        funcName: f+"eq"
                      })
    }
  })();
  
  var math_comm = [
    "max",
    "min",
    "atan2",
    "pow"
  ]
  ;(function(){
    for(var i=0; i<math_comm.length; ++i) {
      var f= math_comm[i]
      exports[f] = makeOp({
                    args:["array", "array", "array"],
                    pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                    body: {args:["a","b","c"], body:"a=this_f(b,c)", thisVars:["this_f"]},
                    funcName: f
                  })
      exports[f+"s"] = makeOp({
                    args:["array", "array", "scalar"],
                    pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                    body: {args:["a","b","c"], body:"a=this_f(b,c)", thisVars:["this_f"]},
                    funcName: f+"s"
                    })
      exports[f+"eq"] = makeOp({ args:["array", "array"],
                    pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                    body: {args:["a","b"], body:"a=this_f(a,b)", thisVars:["this_f"]},
                    rvalue: true,
                    count: 2,
                    funcName: f+"eq"
                    })
      exports[f+"seq"] = makeOp({ args:["array", "scalar"],
                    pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                    body: {args:["a","b"], body:"a=this_f(a,b)", thisVars:["this_f"]},
                    rvalue:true,
                    count:2,
                    funcName: f+"seq"
                    })
    }
  })();
  
  var math_noncomm = [
    "atan2",
    "pow"
  ]
  ;(function(){
    for(var i=0; i<math_noncomm.length; ++i) {
      var f= math_noncomm[i]
      exports[f+"op"] = makeOp({
                    args:["array", "array", "array"],
                    pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                    body: {args:["a","b","c"], body:"a=this_f(c,b)", thisVars:["this_f"]},
                    funcName: f+"op"
                  })
      exports[f+"ops"] = makeOp({
                    args:["array", "array", "scalar"],
                    pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                    body: {args:["a","b","c"], body:"a=this_f(c,b)", thisVars:["this_f"]},
                    funcName: f+"ops"
                    })
      exports[f+"opeq"] = makeOp({ args:["array", "array"],
                    pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                    body: {args:["a","b"], body:"a=this_f(b,a)", thisVars:["this_f"]},
                    rvalue: true,
                    count: 2,
                    funcName: f+"opeq"
                    })
      exports[f+"opseq"] = makeOp({ args:["array", "scalar"],
                    pre: {args:[], body:"this_f=Math."+f, thisVars:["this_f"]},
                    body: {args:["a","b"], body:"a=this_f(b,a)", thisVars:["this_f"]},
                    rvalue:true,
                    count:2,
                    funcName: f+"opseq"
                    })
    }
  })();
  
  exports.any = compile({
    args:["array"],
    pre: EmptyProc,
    body: {args:[{name:"a", lvalue:false, rvalue:true, count:1}], body: "if(a){return true}", localVars: [], thisVars: []},
    post: {args:[], localVars:[], thisVars:[], body:"return false"},
    funcName: "any"
  })
  
  exports.all = compile({
    args:["array"],
    pre: EmptyProc,
    body: {args:[{name:"x", lvalue:false, rvalue:true, count:1}], body: "if(!x){return false}", localVars: [], thisVars: []},
    post: {args:[], localVars:[], thisVars:[], body:"return true"},
    funcName: "all"
  })
  
  exports.sum = compile({
    args:["array"],
    pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
    body: {args:[{name:"a", lvalue:false, rvalue:true, count:1}], body: "this_s+=a", localVars: [], thisVars: ["this_s"]},
    post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
    funcName: "sum"
  })
  
  exports.prod = compile({
    args:["array"],
    pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=1"},
    body: {args:[{name:"a", lvalue:false, rvalue:true, count:1}], body: "this_s*=a", localVars: [], thisVars: ["this_s"]},
    post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
    funcName: "prod"
  })
  
  exports.norm2squared = compile({
    args:["array"],
    pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
    body: {args:[{name:"a", lvalue:false, rvalue:true, count:2}], body: "this_s+=a*a", localVars: [], thisVars: ["this_s"]},
    post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
    funcName: "norm2squared"
  })
    
  exports.norm2 = compile({
    args:["array"],
    pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
    body: {args:[{name:"a", lvalue:false, rvalue:true, count:2}], body: "this_s+=a*a", localVars: [], thisVars: ["this_s"]},
    post: {args:[], localVars:[], thisVars:["this_s"], body:"return Math.sqrt(this_s)"},
    funcName: "norm2"
  })
    
  
  exports.norminf = compile({
    args:["array"],
    pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
    body: {args:[{name:"a", lvalue:false, rvalue:true, count:4}], body:"if(-a>this_s){this_s=-a}else if(a>this_s){this_s=a}", localVars: [], thisVars: ["this_s"]},
    post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
    funcName: "norminf"
  })
  
  exports.norm1 = compile({
    args:["array"],
    pre: {args:[], localVars:[], thisVars:["this_s"], body:"this_s=0"},
    body: {args:[{name:"a", lvalue:false, rvalue:true, count:3}], body: "this_s+=a<0?-a:a", localVars: [], thisVars: ["this_s"]},
    post: {args:[], localVars:[], thisVars:["this_s"], body:"return this_s"},
    funcName: "norm1"
  })
  
  exports.sup = compile({
    args: [ "array" ],
    pre:
     { body: "this_h=-Infinity",
       args: [],
       thisVars: [ "this_h" ],
       localVars: [] },
    body:
     { body: "if(_inline_1_arg0_>this_h)this_h=_inline_1_arg0_",
       args: [{"name":"_inline_1_arg0_","lvalue":false,"rvalue":true,"count":2} ],
       thisVars: [ "this_h" ],
       localVars: [] },
    post:
     { body: "return this_h",
       args: [],
       thisVars: [ "this_h" ],
       localVars: [] }
   })
  
  exports.inf = compile({
    args: [ "array" ],
    pre:
     { body: "this_h=Infinity",
       args: [],
       thisVars: [ "this_h" ],
       localVars: [] },
    body:
     { body: "if(_inline_1_arg0_<this_h)this_h=_inline_1_arg0_",
       args: [{"name":"_inline_1_arg0_","lvalue":false,"rvalue":true,"count":2} ],
       thisVars: [ "this_h" ],
       localVars: [] },
    post:
     { body: "return this_h",
       args: [],
       thisVars: [ "this_h" ],
       localVars: [] }
   })
  
  exports.argmin = compile({
    args:["index","array","shape"],
    pre:{
      body:"{this_v=Infinity;this_i=_inline_0_arg2_.slice(0)}",
      args:[
        {name:"_inline_0_arg0_",lvalue:false,rvalue:false,count:0},
        {name:"_inline_0_arg1_",lvalue:false,rvalue:false,count:0},
        {name:"_inline_0_arg2_",lvalue:false,rvalue:true,count:1}
        ],
      thisVars:["this_i","this_v"],
      localVars:[]},
    body:{
      body:"{if(_inline_1_arg1_<this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
      args:[
        {name:"_inline_1_arg0_",lvalue:false,rvalue:true,count:2},
        {name:"_inline_1_arg1_",lvalue:false,rvalue:true,count:2}],
      thisVars:["this_i","this_v"],
      localVars:["_inline_1_k"]},
    post:{
      body:"{return this_i}",
      args:[],
      thisVars:["this_i"],
      localVars:[]}
  })
  
  exports.argmax = compile({
    args:["index","array","shape"],
    pre:{
      body:"{this_v=-Infinity;this_i=_inline_0_arg2_.slice(0)}",
      args:[
        {name:"_inline_0_arg0_",lvalue:false,rvalue:false,count:0},
        {name:"_inline_0_arg1_",lvalue:false,rvalue:false,count:0},
        {name:"_inline_0_arg2_",lvalue:false,rvalue:true,count:1}
        ],
      thisVars:["this_i","this_v"],
      localVars:[]},
    body:{
      body:"{if(_inline_1_arg1_>this_v){this_v=_inline_1_arg1_;for(var _inline_1_k=0;_inline_1_k<_inline_1_arg0_.length;++_inline_1_k){this_i[_inline_1_k]=_inline_1_arg0_[_inline_1_k]}}}",
      args:[
        {name:"_inline_1_arg0_",lvalue:false,rvalue:true,count:2},
        {name:"_inline_1_arg1_",lvalue:false,rvalue:true,count:2}],
      thisVars:["this_i","this_v"],
      localVars:["_inline_1_k"]},
    post:{
      body:"{return this_i}",
      args:[],
      thisVars:["this_i"],
      localVars:[]}
  })  
  
  exports.random = makeOp({
    args: ["array"],
    pre: {args:[], body:"this_f=Math.random", thisVars:["this_f"]},
    body: {args: ["a"], body:"a=this_f()", thisVars:["this_f"]},
    funcName: "random"
  })
  
  exports.assign = makeOp({
    args:["array", "array"],
    body: {args:["a", "b"], body:"a=b"},
    funcName: "assign" })
  
  exports.assigns = makeOp({
    args:["array", "scalar"],
    body: {args:["a", "b"], body:"a=b"},
    funcName: "assigns" })
  
  
  exports.equals = compile({
    args:["array", "array"],
    pre: EmptyProc,
    body: {args:[{name:"x", lvalue:false, rvalue:true, count:1},
                 {name:"y", lvalue:false, rvalue:true, count:1}], 
          body: "if(x!==y){return false}", 
          localVars: [], 
          thisVars: []},
    post: {args:[], localVars:[], thisVars:[], body:"return true"},
    funcName: "equals"
  })
  
  
  
  },{"cwise-compiler":151}],465:[function(_dereq_,module,exports){
  "use strict"
  
  var ndarray = _dereq_("ndarray")
  var do_convert = _dereq_("./doConvert.js")
  
  module.exports = function convert(arr, result) {
    var shape = [], c = arr, sz = 1
    while(Array.isArray(c)) {
      shape.push(c.length)
      sz *= c.length
      c = c[0]
    }
    if(shape.length === 0) {
      return ndarray()
    }
    if(!result) {
      result = ndarray(new Float64Array(sz), shape)
    }
    do_convert(result, arr)
    return result
  }
  
  },{"./doConvert.js":466,"ndarray":469}],466:[function(_dereq_,module,exports){
  module.exports=_dereq_('cwise-compiler')({"args":["array","scalar","index"],"pre":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"body":{"body":"{\nvar _inline_1_v=_inline_1_arg1_,_inline_1_i\nfor(_inline_1_i=0;_inline_1_i<_inline_1_arg2_.length-1;++_inline_1_i) {\n_inline_1_v=_inline_1_v[_inline_1_arg2_[_inline_1_i]]\n}\n_inline_1_arg0_=_inline_1_v[_inline_1_arg2_[_inline_1_arg2_.length-1]]\n}","args":[{"name":"_inline_1_arg0_","lvalue":true,"rvalue":false,"count":1},{"name":"_inline_1_arg1_","lvalue":false,"rvalue":true,"count":1},{"name":"_inline_1_arg2_","lvalue":false,"rvalue":true,"count":4}],"thisVars":[],"localVars":["_inline_1_i","_inline_1_v"]},"post":{"body":"{}","args":[],"thisVars":[],"localVars":[]},"funcName":"convert","blockSize":64})
  
  },{"cwise-compiler":151}],467:[function(_dereq_,module,exports){
  "use strict"
  
  var pool = _dereq_("typedarray-pool")
  
  var INSERTION_SORT_THRESHOLD = 32
  
  function getMallocFree(dtype) {
    switch(dtype) {
      case "uint8":
        return [pool.mallocUint8, pool.freeUint8]
      case "uint16":
        return [pool.mallocUint16, pool.freeUint16]
      case "uint32":
        return [pool.mallocUint32, pool.freeUint32]
      case "int8":
        return [pool.mallocInt8, pool.freeInt8]
      case "int16":
        return [pool.mallocInt16, pool.freeInt16]
      case "int32":
        return [pool.mallocInt32, pool.freeInt32]
      case "float32":
        return [pool.mallocFloat, pool.freeFloat]
      case "float64":
        return [pool.mallocDouble, pool.freeDouble]
      default:
        return null
    }
  }
  
  function shapeArgs(dimension) {
    var args = []
    for(var i=0; i<dimension; ++i) {
      args.push("s"+i)
    }
    for(var i=0; i<dimension; ++i) {
      args.push("n"+i)
    }
    for(var i=1; i<dimension; ++i) {
      args.push("d"+i)
    }
    for(var i=1; i<dimension; ++i) {
      args.push("e"+i)
    }
    for(var i=1; i<dimension; ++i) {
      args.push("f"+i)
    }
    return args
  }
  
  function createInsertionSort(order, dtype) {
  
    var code = ["'use strict'"]
    var funcName = ["ndarrayInsertionSort", order.join("d"), dtype].join("")
    var funcArgs = ["left", "right", "data", "offset" ].concat(shapeArgs(order.length))
    var allocator = getMallocFree(dtype)
    
    var vars = [ "i,j,cptr,ptr=left*s0+offset" ]
    
    if(order.length > 1) {
      var scratch_shape = []
      for(var i=1; i<order.length; ++i) {
        vars.push("i"+i)
        scratch_shape.push("n"+i)
      }
      if(allocator) {
        vars.push("scratch=malloc(" + scratch_shape.join("*") + ")")
      } else {
        vars.push("scratch=new Array("+scratch_shape.join("*") + ")")
      }
      vars.push("dptr","sptr","a","b")
    } else {
      vars.push("scratch")
    }
    
    function dataRead(ptr) {
      if(dtype === "generic") {
        return ["data.get(", ptr, ")"].join("")
      }
      return ["data[",ptr,"]"].join("")
    }
    
    function dataWrite(ptr, v) {
      if(dtype === "generic") {
        return ["data.set(", ptr, ",", v, ")"].join("")
      }
      return ["data[",ptr,"]=",v].join("")
    }
    
    //Create function header
    code.push(
      ["function ", funcName, "(", funcArgs.join(","), "){var ", vars.join(",")].join(""),
        "for(i=left+1;i<=right;++i){",
          "j=i;ptr+=s0",
          "cptr=ptr")
    
    
    if(order.length > 1) {
    
      //Copy data into scratch
      code.push("dptr=0;sptr=ptr")
      for(var i=order.length-1; i>=0; --i) {
        var j = order[i]
        if(j === 0) {
          continue
        }
        code.push(["for(i",j,"=0;i",j,"<n",j,";++i",j,"){"].join(""))
      }
      code.push("scratch[dptr++]=",dataRead("sptr"))
      for(var i=0; i<order.length; ++i) {
        var j = order[i]
        if(j === 0) {
          continue
        }
        code.push("sptr+=d"+j,"}")
      }
  
      
      //Compare items in outer loop
      code.push("__g:while(j-->left){",
                "dptr=0",
                "sptr=cptr-s0")
      for(var i=1; i<order.length; ++i) {
        if(i === 1) {
          code.push("__l:")
        }
        code.push(["for(i",i,"=0;i",i,"<n",i,";++i",i,"){"].join(""))
      }
      code.push(["a=", dataRead("sptr"),"\nb=scratch[dptr]\nif(a<b){break __g}\nif(a>b){break __l}"].join(""))
      for(var i=order.length-1; i>=1; --i) {
        code.push(
          "sptr+=e"+i,
          "dptr+=f"+i,
          "}")
      }
      
      //Copy data back
      code.push("dptr=cptr;sptr=cptr-s0")
      for(var i=order.length-1; i>=0; --i) {
        var j = order[i]
        if(j === 0) {
          continue
        }
        code.push(["for(i",j,"=0;i",j,"<n",j,";++i",j,"){"].join(""))
      }
      code.push(dataWrite("dptr", dataRead("sptr")))
      for(var i=0; i<order.length; ++i) {
        var j = order[i]
        if(j === 0) {
          continue
        }
        code.push(["dptr+=d",j,";sptr+=d",j].join(""),"}")
      }
      
      //Close while loop
      code.push("cptr-=s0\n}")
  
      //Copy scratch into cptr
      code.push("dptr=cptr;sptr=0")
      for(var i=order.length-1; i>=0; --i) {
        var j = order[i]
        if(j === 0) {
          continue
        }
        code.push(["for(i",j,"=0;i",j,"<n",j,";++i",j,"){"].join(""))
      }
      code.push(dataWrite("dptr", "scratch[sptr++]"))
      for(var i=0; i<order.length; ++i) {
        var j = order[i]
        if(j === 0) {
          continue
        }
        code.push("dptr+=d"+j,"}")
      }
    } else {
      code.push("scratch=" + dataRead("ptr"),
                "while((j-->left)&&("+dataRead("cptr-s0")+">scratch)){",
                  dataWrite("cptr", dataRead("cptr-s0")),
                  "cptr-=s0",
                "}",
                dataWrite("cptr", "scratch"))
    }
    
    //Close outer loop body
    code.push("}")
    if(order.length > 1 && allocator) {
      code.push("free(scratch)")
    }
    code.push("} return " + funcName)
    
    //Compile and link function
    if(allocator) {
      var result = new Function("malloc", "free", code.join("\n"))
      return result(allocator[0], allocator[1])
    } else {
      var result = new Function(code.join("\n"))
      return result()
    }
  }
  
  function createQuickSort(order, dtype, insertionSort) {
    var code = [ "'use strict'" ]
    var funcName = ["ndarrayQuickSort", order.join("d"), dtype].join("")
    var funcArgs = ["left", "right", "data", "offset" ].concat(shapeArgs(order.length))
    var allocator = getMallocFree(dtype)
    var labelCounter=0
    
    code.push(["function ", funcName, "(", funcArgs.join(","), "){"].join(""))
    
    var vars = [
      "sixth=((right-left+1)/6)|0",
      "index1=left+sixth",
      "index5=right-sixth",
      "index3=(left+right)>>1",
      "index2=index3-sixth",
      "index4=index3+sixth",
      "el1=index1",
      "el2=index2",
      "el3=index3",
      "el4=index4",
      "el5=index5",
      "less=left+1",
      "great=right-1",
      "pivots_are_equal=true",
      "tmp",
      "tmp0",
      "x",
      "y",
      "z",
      "k",
      "ptr0",
      "ptr1",
      "ptr2",
      "comp_pivot1=0",
      "comp_pivot2=0",
      "comp=0"
    ]
    
    if(order.length > 1) {
      var ele_size = []
      for(var i=1; i<order.length; ++i) {
        ele_size.push("n"+i)
        vars.push("i"+i)
      }
      for(var i=0; i<8; ++i) {
        vars.push("b_ptr"+i)
      }
      vars.push(
        "ptr3",
        "ptr4",
        "ptr5",
        "ptr6",
        "ptr7",
        "pivot_ptr",
        "ptr_shift",
        "elementSize="+ele_size.join("*"))
      if(allocator) {
        vars.push("pivot1=malloc(elementSize)",
                  "pivot2=malloc(elementSize)")
      } else {
        vars.push("pivot1=new Array(elementSize),pivot2=new Array(elementSize)")
      }
    } else {
      vars.push("pivot1", "pivot2")
    }
    
    //Initialize local variables
    code.push("var " + vars.join(","))
    
    function toPointer(v) {
      return ["(offset+",v,"*s0)"].join("")
    }
    
    function dataRead(ptr) {
      if(dtype === "generic") {
        return ["data.get(", ptr, ")"].join("")
      }
      return ["data[",ptr,"]"].join("")
    }
    
    function dataWrite(ptr, v) {
      if(dtype === "generic") {
        return ["data.set(", ptr, ",", v, ")"].join("")
      }
      return ["data[",ptr,"]=",v].join("")
    }
    
    function cacheLoop(ptrs, usePivot, body) {
      if(ptrs.length === 1) {
        code.push("ptr0="+toPointer(ptrs[0]))
      } else {
        for(var i=0; i<ptrs.length; ++i) {
          code.push(["b_ptr",i,"=s0*",ptrs[i]].join(""))
        }
      }
      if(usePivot) {
        code.push("pivot_ptr=0")
      }
      code.push("ptr_shift=offset")
      for(var i=order.length-1; i>=0; --i) {
        var j = order[i]
        if(j === 0) {
          continue
        }
        code.push(["for(i",j,"=0;i",j,"<n",j,";++i",j,"){"].join(""))
      }
      if(ptrs.length > 1) {
        for(var i=0; i<ptrs.length; ++i) {
          code.push(["ptr",i,"=b_ptr",i,"+ptr_shift"].join(""))
        }
      }
      code.push(body)
      if(usePivot) {
        code.push("++pivot_ptr")
      }
      for(var i=0; i<order.length; ++i) {
        var j = order[i]
        if(j === 0) {
          continue
        }
        if(ptrs.length>1) {
          code.push("ptr_shift+=d"+j)
        } else {
          code.push("ptr0+=d"+j)
        }
        code.push("}")
      }
    }
    
    function lexicoLoop(label, ptrs, usePivot, body) {
      if(ptrs.length === 1) {
        code.push("ptr0="+toPointer(ptrs[0]))
      } else {
        for(var i=0; i<ptrs.length; ++i) {
          code.push(["b_ptr",i,"=s0*",ptrs[i]].join(""))
        }
        code.push("ptr_shift=offset")
      }
      if(usePivot) {
        code.push("pivot_ptr=0")
      }
      if(label) {
        code.push(label+":")
      }
      for(var i=1; i<order.length; ++i) {
        code.push(["for(i",i,"=0;i",i,"<n",i,";++i",i,"){"].join(""))
      }
      if(ptrs.length > 1) {
        for(var i=0; i<ptrs.length; ++i) {
          code.push(["ptr",i,"=b_ptr",i,"+ptr_shift"].join(""))
        }
      }
      code.push(body)
      for(var i=order.length-1; i>=1; --i) {
        if(usePivot) {
          code.push("pivot_ptr+=f"+i)
        }
        if(ptrs.length > 1) {
          code.push("ptr_shift+=e"+i)
        } else {
          code.push("ptr0+=e"+i)
        }
        code.push("}")
      }
    }
    
    function cleanUp() {
      if(order.length > 1 && allocator) {
        code.push("free(pivot1)", "free(pivot2)")
      }
    }
    
    function compareSwap(a_id, b_id) {
      var a = "el"+a_id
      var b = "el"+b_id
      if(order.length > 1) {
        var lbl = "__l" + (++labelCounter)
        lexicoLoop(lbl, [a, b], false, [
          "comp=",dataRead("ptr0"),"-",dataRead("ptr1"),"\n",
          "if(comp>0){tmp0=", a, ";",a,"=",b,";", b,"=tmp0;break ", lbl,"}\n",
          "if(comp<0){break ", lbl, "}"
        ].join(""))
      } else {
        code.push(["if(", dataRead(toPointer(a)), ">", dataRead(toPointer(b)), "){tmp0=", a, ";",a,"=",b,";", b,"=tmp0}"].join(""))
      }
    }
    
    compareSwap(1, 2)
    compareSwap(4, 5)
    compareSwap(1, 3)
    compareSwap(2, 3)
    compareSwap(1, 4)
    compareSwap(3, 4)
    compareSwap(2, 5)
    compareSwap(2, 3)
    compareSwap(4, 5)
    
    if(order.length > 1) {
      cacheLoop(["el1", "el2", "el3", "el4", "el5", "index1", "index3", "index5"], true, [
        "pivot1[pivot_ptr]=",dataRead("ptr1"),"\n",
        "pivot2[pivot_ptr]=",dataRead("ptr3"),"\n",
        "pivots_are_equal=pivots_are_equal&&(pivot1[pivot_ptr]===pivot2[pivot_ptr])\n",
        "x=",dataRead("ptr0"),"\n",
        "y=",dataRead("ptr2"),"\n",
        "z=",dataRead("ptr4"),"\n",
        dataWrite("ptr5", "x"),"\n",
        dataWrite("ptr6", "y"),"\n",
        dataWrite("ptr7", "z")
      ].join(""))
    } else {
      code.push([
        "pivot1=", dataRead(toPointer("el2")), "\n",
        "pivot2=", dataRead(toPointer("el4")), "\n",
        "pivots_are_equal=pivot1===pivot2\n",
        "x=", dataRead(toPointer("el1")), "\n",
        "y=", dataRead(toPointer("el3")), "\n",
        "z=", dataRead(toPointer("el5")), "\n",
        dataWrite(toPointer("index1"), "x"), "\n",
        dataWrite(toPointer("index3"), "y"), "\n",
        dataWrite(toPointer("index5"), "z")
      ].join(""))
    }
    
  
    function moveElement(dst, src) {
      if(order.length > 1) {
        cacheLoop([dst, src], false,
          dataWrite("ptr0", dataRead("ptr1"))
        )
      } else {
        code.push(dataWrite(toPointer(dst), dataRead(toPointer(src))))
      }
    }
    
    moveElement("index2", "left")
    moveElement("index4", "right")
    
    function comparePivot(result, ptr, n) {
      if(order.length > 1) {
        var lbl = "__l" + (++labelCounter)
        lexicoLoop(lbl, [ptr], true, [
          result,"=",dataRead("ptr0"),"-pivot",n,"[pivot_ptr]\n",
          "if(",result,"!==0){break ", lbl, "}"
        ].join(""))
      } else {
        code.push([result,"=", dataRead(toPointer(ptr)), "-pivot", n].join(""))
      }
    }
    
    function swapElements(a, b) {
      if(order.length > 1) {
        cacheLoop([a,b],false,[
          "tmp=",dataRead("ptr0"),"\n",
          dataWrite("ptr0", dataRead("ptr1")),"\n",
          dataWrite("ptr1", "tmp")
        ].join(""))
      } else {
        code.push([
          "ptr0=",toPointer(a),"\n",
          "ptr1=",toPointer(b),"\n",
          "tmp=",dataRead("ptr0"),"\n",
          dataWrite("ptr0", dataRead("ptr1")),"\n",
          dataWrite("ptr1", "tmp")
        ].join(""))
      }
    }
    
    function tripleSwap(k, less, great) {
      if(order.length > 1) {
        cacheLoop([k,less,great], false, [
          "tmp=",dataRead("ptr0"),"\n",
          dataWrite("ptr0", dataRead("ptr1")),"\n",
          dataWrite("ptr1", dataRead("ptr2")),"\n",
          dataWrite("ptr2", "tmp")
        ].join(""))
        code.push("++"+less, "--"+great)
      } else {
        code.push([
          "ptr0=",toPointer(k),"\n",
          "ptr1=",toPointer(less),"\n",
          "ptr2=",toPointer(great),"\n",
          "++",less,"\n",
          "--",great,"\n",
          "tmp=", dataRead("ptr0"), "\n",
          dataWrite("ptr0", dataRead("ptr1")), "\n",
          dataWrite("ptr1", dataRead("ptr2")), "\n",
          dataWrite("ptr2", "tmp")
        ].join(""))
      }
    }
    
    function swapAndDecrement(k, great) {
      swapElements(k, great)
      code.push("--"+great)
    }
      
    code.push("if(pivots_are_equal){")
      //Pivots are equal case
      code.push("for(k=less;k<=great;++k){")
        comparePivot("comp", "k", 1)
        code.push("if(comp===0){continue}")
        code.push("if(comp<0){")
          code.push("if(k!==less){")
            swapElements("k", "less")
          code.push("}")
          code.push("++less")
        code.push("}else{")
          code.push("while(true){")
            comparePivot("comp", "great", 1)
            code.push("if(comp>0){")
              code.push("great--")
            code.push("}else if(comp<0){")
              tripleSwap("k", "less", "great")
              code.push("break")
            code.push("}else{")
              swapAndDecrement("k", "great")
              code.push("break")
            code.push("}")
          code.push("}")
        code.push("}")
      code.push("}")
    code.push("}else{")
      //Pivots not equal case
      code.push("for(k=less;k<=great;++k){")
        comparePivot("comp_pivot1", "k", 1)
        code.push("if(comp_pivot1<0){")
          code.push("if(k!==less){")
            swapElements("k", "less")
          code.push("}")
          code.push("++less")
        code.push("}else{")
          comparePivot("comp_pivot2", "k", 2)
          code.push("if(comp_pivot2>0){")
            code.push("while(true){")
              comparePivot("comp", "great", 2)
              code.push("if(comp>0){")
                code.push("if(--great<k){break}")
                code.push("continue")
              code.push("}else{")
                comparePivot("comp", "great", 1)
                code.push("if(comp<0){")
                  tripleSwap("k", "less", "great")
                code.push("}else{")
                  swapAndDecrement("k", "great")
                code.push("}")
                code.push("break")
              code.push("}")
            code.push("}")
          code.push("}")
        code.push("}")
      code.push("}")
    code.push("}")
    
    //Move pivots to correct place
    function storePivot(mem_dest, pivot_dest, pivot) {
      if(order.length>1) {
        cacheLoop([mem_dest, pivot_dest], true, [
          dataWrite("ptr0", dataRead("ptr1")), "\n",
          dataWrite("ptr1", ["pivot",pivot,"[pivot_ptr]"].join(""))
        ].join(""))
      } else {
        code.push(
            dataWrite(toPointer(mem_dest), dataRead(toPointer(pivot_dest))),
            dataWrite(toPointer(pivot_dest), "pivot"+pivot))
      }
    }
    
    storePivot("left", "(less-1)", 1)
    storePivot("right", "(great+1)", 2)
  
    //Recursive sort call
    function doSort(left, right) {
      code.push([
        "if((",right,"-",left,")<=",INSERTION_SORT_THRESHOLD,"){\n",
          "insertionSort(", left, ",", right, ",data,offset,", shapeArgs(order.length).join(","), ")\n",
        "}else{\n",
          funcName, "(", left, ",", right, ",data,offset,", shapeArgs(order.length).join(","), ")\n",
        "}"
      ].join(""))
    }
    doSort("left", "(less-2)")
    doSort("(great+2)", "right")
    
    //If pivots are equal, then early out
    code.push("if(pivots_are_equal){")
      cleanUp()
      code.push("return")
    code.push("}")
    
    function walkPointer(ptr, pivot, body) {
      if(order.length > 1) {
        code.push(["__l",++labelCounter,":while(true){"].join(""))
        cacheLoop([ptr], true, [
          "if(", dataRead("ptr0"), "!==pivot", pivot, "[pivot_ptr]){break __l", labelCounter, "}"
        ].join(""))
        code.push(body, "}")
      } else {
        code.push(["while(", dataRead(toPointer(ptr)), "===pivot", pivot, "){", body, "}"].join(""))
      }
    }
    
    //Check bounds
    code.push("if(less<index1&&great>index5){")
    
      walkPointer("less", 1, "++less")
      walkPointer("great", 2, "--great")
    
      code.push("for(k=less;k<=great;++k){")
        comparePivot("comp_pivot1", "k", 1)
        code.push("if(comp_pivot1===0){")
          code.push("if(k!==less){")
            swapElements("k", "less")
          code.push("}")
          code.push("++less")
        code.push("}else{")
          comparePivot("comp_pivot2", "k", 2)
          code.push("if(comp_pivot2===0){")
            code.push("while(true){")
              comparePivot("comp", "great", 2)
              code.push("if(comp===0){")
                code.push("if(--great<k){break}")
                code.push("continue")
              code.push("}else{")
                comparePivot("comp", "great", 1)
                code.push("if(comp<0){")
                  tripleSwap("k", "less", "great")
                code.push("}else{")
                  swapAndDecrement("k", "great")
                code.push("}")
                code.push("break")
              code.push("}")
            code.push("}")
          code.push("}")
        code.push("}")
      code.push("}")
    code.push("}")
    
    //Clean up and do a final sorting pass
    cleanUp()
    doSort("less", "great")
   
    //Close off main loop
    code.push("}return " + funcName)
    
    //Compile and link
    if(order.length > 1 && allocator) {
      var compiled = new Function("insertionSort", "malloc", "free", code.join("\n"))
      return compiled(insertionSort, allocator[0], allocator[1])
    }
    var compiled = new Function("insertionSort", code.join("\n"))
    return compiled(insertionSort)
  }
  
  function compileSort(order, dtype) {
    var code = ["'use strict'"]
    var funcName = ["ndarraySortWrapper", order.join("d"), dtype].join("")
    var funcArgs = [ "array" ]
    
    code.push(["function ", funcName, "(", funcArgs.join(","), "){"].join(""))
    
    //Unpack local variables from array
    var vars = ["data=array.data,offset=array.offset|0,shape=array.shape,stride=array.stride"]
    for(var i=0; i<order.length; ++i) {
      vars.push(["s",i,"=stride[",i,"]|0,n",i,"=shape[",i,"]|0"].join(""))
    }
    
    var scratch_stride = new Array(order.length)
    var nprod = []
    for(var i=0; i<order.length; ++i) {
      var k = order[i]
      if(k === 0) {
        continue
      }
      if(nprod.length === 0) {
        scratch_stride[k] = "1"
      } else {
        scratch_stride[k] = nprod.join("*")
      }
      nprod.push("n"+k)
    }
    
    var p = -1, q = -1
    for(var i=0; i<order.length; ++i) {
      var j = order[i]
      if(j !== 0) {
        if(p > 0) {
          vars.push(["d",j,"=s",j,"-d",p,"*n",p].join(""))
        } else {
          vars.push(["d",j,"=s",j].join(""))
        }
        p = j
      }
      var k = order.length-1-i
      if(k !== 0) {
        if(q > 0) {
          vars.push(["e",k,"=s",k,"-e",q,"*n",q,
                    ",f",k,"=",scratch_stride[k],"-f",q,"*n",q].join(""))
        } else {
          vars.push(["e",k,"=s",k,",f",k,"=",scratch_stride[k]].join(""))
        }
        q = k
      }
    }
    
    //Declare local variables
    code.push("var " + vars.join(","))
    
    //Create arguments for subroutine
    var sortArgs = ["0", "n0-1", "data", "offset"].concat(shapeArgs(order.length))
    
    //Call main sorting routine
    code.push([
      "if(n0<=",INSERTION_SORT_THRESHOLD,"){",
        "insertionSort(", sortArgs.join(","), ")}else{",
        "quickSort(", sortArgs.join(","),
      ")}"
    ].join(""))
    
    //Return
    code.push("}return " + funcName)
    
    //Link everything together
    var result = new Function("insertionSort", "quickSort", code.join("\n"))
    var insertionSort = createInsertionSort(order, dtype)
    var quickSort = createQuickSort(order, dtype, insertionSort)
    return result(insertionSort, quickSort)
  }
  
  module.exports = compileSort
  },{"typedarray-pool":567}],468:[function(_dereq_,module,exports){
  "use strict"
  
  var compile = _dereq_("./lib/compile_sort.js")
  var CACHE = {}
  
  function sort(array) {
    var order = array.order
    var dtype = array.dtype
    var typeSig = [order, dtype ]
    var typeName = typeSig.join(":")
    var compiled = CACHE[typeName]
    if(!compiled) {
      CACHE[typeName] = compiled = compile(order, dtype)
    }
    compiled(array)
    return array
  }
  
  module.exports = sort
  },{"./lib/compile_sort.js":467}],469:[function(_dereq_,module,exports){
  var iota = _dereq_("iota-array")
  var isBuffer = _dereq_("is-buffer")
  
  var hasTypedArrays  = ((typeof Float64Array) !== "undefined")
  
  function compare1st(a, b) {
    return a[0] - b[0]
  }
  
  function order() {
    var stride = this.stride
    var terms = new Array(stride.length)
    var i
    for(i=0; i<terms.length; ++i) {
      terms[i] = [Math.abs(stride[i]), i]
    }
    terms.sort(compare1st)
    var result = new Array(terms.length)
    for(i=0; i<result.length; ++i) {
      result[i] = terms[i][1]
    }
    return result
  }
  
  function compileConstructor(dtype, dimension) {
    var className = ["View", dimension, "d", dtype].join("")
    if(dimension < 0) {
      className = "View_Nil" + dtype
    }
    var useGetters = (dtype === "generic")
  
    if(dimension === -1) {
      //Special case for trivial arrays
      var code =
        "function "+className+"(a){this.data=a;};\
  var proto="+className+".prototype;\
  proto.dtype='"+dtype+"';\
  proto.index=function(){return -1};\
  proto.size=0;\
  proto.dimension=-1;\
  proto.shape=proto.stride=proto.order=[];\
  proto.lo=proto.hi=proto.transpose=proto.step=\
  function(){return new "+className+"(this.data);};\
  proto.get=proto.set=function(){};\
  proto.pick=function(){return null};\
  return function construct_"+className+"(a){return new "+className+"(a);}"
      var procedure = new Function(code)
      return procedure()
    } else if(dimension === 0) {
      //Special case for 0d arrays
      var code =
        "function "+className+"(a,d) {\
  this.data = a;\
  this.offset = d\
  };\
  var proto="+className+".prototype;\
  proto.dtype='"+dtype+"';\
  proto.index=function(){return this.offset};\
  proto.dimension=0;\
  proto.size=1;\
  proto.shape=\
  proto.stride=\
  proto.order=[];\
  proto.lo=\
  proto.hi=\
  proto.transpose=\
  proto.step=function "+className+"_copy() {\
  return new "+className+"(this.data,this.offset)\
  };\
  proto.pick=function "+className+"_pick(){\
  return TrivialArray(this.data);\
  };\
  proto.valueOf=proto.get=function "+className+"_get(){\
  return "+(useGetters ? "this.data.get(this.offset)" : "this.data[this.offset]")+
  "};\
  proto.set=function "+className+"_set(v){\
  return "+(useGetters ? "this.data.set(this.offset,v)" : "this.data[this.offset]=v")+"\
  };\
  return function construct_"+className+"(a,b,c,d){return new "+className+"(a,d)}"
      var procedure = new Function("TrivialArray", code)
      return procedure(CACHED_CONSTRUCTORS[dtype][0])
    }
  
    var code = ["'use strict'"]
  
    //Create constructor for view
    var indices = iota(dimension)
    var args = indices.map(function(i) { return "i"+i })
    var index_str = "this.offset+" + indices.map(function(i) {
          return "this.stride[" + i + "]*i" + i
        }).join("+")
    var shapeArg = indices.map(function(i) {
        return "b"+i
      }).join(",")
    var strideArg = indices.map(function(i) {
        return "c"+i
      }).join(",")
    code.push(
      "function "+className+"(a," + shapeArg + "," + strideArg + ",d){this.data=a",
        "this.shape=[" + shapeArg + "]",
        "this.stride=[" + strideArg + "]",
        "this.offset=d|0}",
      "var proto="+className+".prototype",
      "proto.dtype='"+dtype+"'",
      "proto.dimension="+dimension)
  
    //view.size:
    code.push("Object.defineProperty(proto,'size',{get:function "+className+"_size(){\
  return "+indices.map(function(i) { return "this.shape["+i+"]" }).join("*"),
  "}})")
  
    //view.order:
    if(dimension === 1) {
      code.push("proto.order=[0]")
    } else {
      code.push("Object.defineProperty(proto,'order',{get:")
      if(dimension < 4) {
        code.push("function "+className+"_order(){")
        if(dimension === 2) {
          code.push("return (Math.abs(this.stride[0])>Math.abs(this.stride[1]))?[1,0]:[0,1]}})")
        } else if(dimension === 3) {
          code.push(
  "var s0=Math.abs(this.stride[0]),s1=Math.abs(this.stride[1]),s2=Math.abs(this.stride[2]);\
  if(s0>s1){\
  if(s1>s2){\
  return [2,1,0];\
  }else if(s0>s2){\
  return [1,2,0];\
  }else{\
  return [1,0,2];\
  }\
  }else if(s0>s2){\
  return [2,0,1];\
  }else if(s2>s1){\
  return [0,1,2];\
  }else{\
  return [0,2,1];\
  }}})")
        }
      } else {
        code.push("ORDER})")
      }
    }
  
    //view.set(i0, ..., v):
    code.push(
  "proto.set=function "+className+"_set("+args.join(",")+",v){")
    if(useGetters) {
      code.push("return this.data.set("+index_str+",v)}")
    } else {
      code.push("return this.data["+index_str+"]=v}")
    }
  
    //view.get(i0, ...):
    code.push("proto.get=function "+className+"_get("+args.join(",")+"){")
    if(useGetters) {
      code.push("return this.data.get("+index_str+")}")
    } else {
      code.push("return this.data["+index_str+"]}")
    }
  
    //view.index:
    code.push(
      "proto.index=function "+className+"_index(", args.join(), "){return "+index_str+"}")
  
    //view.hi():
    code.push("proto.hi=function "+className+"_hi("+args.join(",")+"){return new "+className+"(this.data,"+
      indices.map(function(i) {
        return ["(typeof i",i,"!=='number'||i",i,"<0)?this.shape[", i, "]:i", i,"|0"].join("")
      }).join(",")+","+
      indices.map(function(i) {
        return "this.stride["+i + "]"
      }).join(",")+",this.offset)}")
  
    //view.lo():
    var a_vars = indices.map(function(i) { return "a"+i+"=this.shape["+i+"]" })
    var c_vars = indices.map(function(i) { return "c"+i+"=this.stride["+i+"]" })
    code.push("proto.lo=function "+className+"_lo("+args.join(",")+"){var b=this.offset,d=0,"+a_vars.join(",")+","+c_vars.join(","))
    for(var i=0; i<dimension; ++i) {
      code.push(
  "if(typeof i"+i+"==='number'&&i"+i+">=0){\
  d=i"+i+"|0;\
  b+=c"+i+"*d;\
  a"+i+"-=d}")
    }
    code.push("return new "+className+"(this.data,"+
      indices.map(function(i) {
        return "a"+i
      }).join(",")+","+
      indices.map(function(i) {
        return "c"+i
      }).join(",")+",b)}")
  
    //view.step():
    code.push("proto.step=function "+className+"_step("+args.join(",")+"){var "+
      indices.map(function(i) {
        return "a"+i+"=this.shape["+i+"]"
      }).join(",")+","+
      indices.map(function(i) {
        return "b"+i+"=this.stride["+i+"]"
      }).join(",")+",c=this.offset,d=0,ceil=Math.ceil")
    for(var i=0; i<dimension; ++i) {
      code.push(
  "if(typeof i"+i+"==='number'){\
  d=i"+i+"|0;\
  if(d<0){\
  c+=b"+i+"*(a"+i+"-1);\
  a"+i+"=ceil(-a"+i+"/d)\
  }else{\
  a"+i+"=ceil(a"+i+"/d)\
  }\
  b"+i+"*=d\
  }")
    }
    code.push("return new "+className+"(this.data,"+
      indices.map(function(i) {
        return "a" + i
      }).join(",")+","+
      indices.map(function(i) {
        return "b" + i
      }).join(",")+",c)}")
  
    //view.transpose():
    var tShape = new Array(dimension)
    var tStride = new Array(dimension)
    for(var i=0; i<dimension; ++i) {
      tShape[i] = "a[i"+i+"]"
      tStride[i] = "b[i"+i+"]"
    }
    code.push("proto.transpose=function "+className+"_transpose("+args+"){"+
      args.map(function(n,idx) { return n + "=(" + n + "===undefined?" + idx + ":" + n + "|0)"}).join(";"),
      "var a=this.shape,b=this.stride;return new "+className+"(this.data,"+tShape.join(",")+","+tStride.join(",")+",this.offset)}")
  
    //view.pick():
    code.push("proto.pick=function "+className+"_pick("+args+"){var a=[],b=[],c=this.offset")
    for(var i=0; i<dimension; ++i) {
      code.push("if(typeof i"+i+"==='number'&&i"+i+">=0){c=(c+this.stride["+i+"]*i"+i+")|0}else{a.push(this.shape["+i+"]);b.push(this.stride["+i+"])}")
    }
    code.push("var ctor=CTOR_LIST[a.length+1];return ctor(this.data,a,b,c)}")
  
    //Add return statement
    code.push("return function construct_"+className+"(data,shape,stride,offset){return new "+className+"(data,"+
      indices.map(function(i) {
        return "shape["+i+"]"
      }).join(",")+","+
      indices.map(function(i) {
        return "stride["+i+"]"
      }).join(",")+",offset)}")
  
    //Compile procedure
    var procedure = new Function("CTOR_LIST", "ORDER", code.join("\n"))
    return procedure(CACHED_CONSTRUCTORS[dtype], order)
  }
  
  function arrayDType(data) {
    if(isBuffer(data)) {
      return "buffer"
    }
    if(hasTypedArrays) {
      switch(Object.prototype.toString.call(data)) {
        case "[object Float64Array]":
          return "float64"
        case "[object Float32Array]":
          return "float32"
        case "[object Int8Array]":
          return "int8"
        case "[object Int16Array]":
          return "int16"
        case "[object Int32Array]":
          return "int32"
        case "[object Uint8Array]":
          return "uint8"
        case "[object Uint16Array]":
          return "uint16"
        case "[object Uint32Array]":
          return "uint32"
        case "[object Uint8ClampedArray]":
          return "uint8_clamped"
        case "[object BigInt64Array]":
          return "bigint64"
        case "[object BigUint64Array]":
          return "biguint64"
      }
    }
    if(Array.isArray(data)) {
      return "array"
    }
    return "generic"
  }
  
  var CACHED_CONSTRUCTORS = {
    "float32":[],
    "float64":[],
    "int8":[],
    "int16":[],
    "int32":[],
    "uint8":[],
    "uint16":[],
    "uint32":[],
    "array":[],
    "uint8_clamped":[],
    "bigint64": [],
    "biguint64": [],
    "buffer":[],
    "generic":[]
  }
  
  ;(function() {
    for(var id in CACHED_CONSTRUCTORS) {
      CACHED_CONSTRUCTORS[id].push(compileConstructor(id, -1))
    }
  });
  
  function wrappedNDArrayCtor(data, shape, stride, offset) {
    if(data === undefined) {
      var ctor = CACHED_CONSTRUCTORS.array[0]
      return ctor([])
    } else if(typeof data === "number") {
      data = [data]
    }
    if(shape === undefined) {
      shape = [ data.length ]
    }
    var d = shape.length
    if(stride === undefined) {
      stride = new Array(d)
      for(var i=d-1, sz=1; i>=0; --i) {
        stride[i] = sz
        sz *= shape[i]
      }
    }
    if(offset === undefined) {
      offset = 0
      for(var i=0; i<d; ++i) {
        if(stride[i] < 0) {
          offset -= (shape[i]-1)*stride[i]
        }
      }
    }
    var dtype = arrayDType(data)
    var ctor_list = CACHED_CONSTRUCTORS[dtype]
    while(ctor_list.length <= d+1) {
      ctor_list.push(compileConstructor(dtype, ctor_list.length-1))
    }
    var ctor = ctor_list[d+1]
    return ctor(data, shape, stride, offset)
  }
  
  module.exports = wrappedNDArrayCtor
  
  },{"iota-array":437,"is-buffer":439}],470:[function(_dereq_,module,exports){
  "use strict"
  
  var doubleBits = _dereq_("double-bits")
  
  var SMALLEST_DENORM = Math.pow(2, -1074)
  var UINT_MAX = (-1)>>>0
  
  module.exports = nextafter
  
  function nextafter(x, y) {
    if(isNaN(x) || isNaN(y)) {
      return NaN
    }
    if(x === y) {
      return x
    }
    if(x === 0) {
      if(y < 0) {
        return -SMALLEST_DENORM
      } else {
        return SMALLEST_DENORM
      }
    }
    var hi = doubleBits.hi(x)
    var lo = doubleBits.lo(x)
    if((y > x) === (x > 0)) {
      if(lo === UINT_MAX) {
        hi += 1
        lo = 0
      } else {
        lo += 1
      }
    } else {
      if(lo === 0) {
        lo = UINT_MAX
        hi -= 1
      } else {
        lo -= 1
      }
    }
    return doubleBits.pack(lo, hi)
  }
  },{"double-bits":173}],471:[function(_dereq_,module,exports){
  
  var π = Math.PI
  var _120 = radians(120)
  
  module.exports = normalize
  
  /**
   * describe `path` in terms of cubic bézier 
   * curves and move commands
   *
   * @param {Array} path
   * @return {Array}
   */
  
  function normalize(path){
    // init state
    var prev
    var result = []
    var bezierX = 0
    var bezierY = 0
    var startX = 0
    var startY = 0
    var quadX = null
    var quadY = null
    var x = 0
    var y = 0
  
    for (var i = 0, len = path.length; i < len; i++) {
      var seg = path[i]
      var command = seg[0]
      switch (command) {
        case 'M':
          startX = seg[1]
          startY = seg[2]
          break
        case 'A':
          seg = arc(x, y,seg[1],seg[2],radians(seg[3]),seg[4],seg[5],seg[6],seg[7])
          // split multi part
          seg.unshift('C')
          if (seg.length > 7) {
            result.push(seg.splice(0, 7))
            seg.unshift('C')
          }
          break
        case 'S':
          // default control point
          var cx = x
          var cy = y
          if (prev == 'C' || prev == 'S') {
            cx += cx - bezierX // reflect the previous command's control
            cy += cy - bezierY // point relative to the current point
          }
          seg = ['C', cx, cy, seg[1], seg[2], seg[3], seg[4]]
          break
        case 'T':
          if (prev == 'Q' || prev == 'T') {
            quadX = x * 2 - quadX // as with 'S' reflect previous control point
            quadY = y * 2 - quadY
          } else {
            quadX = x
            quadY = y
          }
          seg = quadratic(x, y, quadX, quadY, seg[1], seg[2])
          break
        case 'Q':
          quadX = seg[1]
          quadY = seg[2]
          seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4])
          break
        case 'L':
          seg = line(x, y, seg[1], seg[2])
          break
        case 'H':
          seg = line(x, y, seg[1], y)
          break
        case 'V':
          seg = line(x, y, x, seg[1])
          break
        case 'Z':
          seg = line(x, y, startX, startY)
          break
      }
  
      // update state
      prev = command
      x = seg[seg.length - 2]
      y = seg[seg.length - 1]
      if (seg.length > 4) {
        bezierX = seg[seg.length - 4]
        bezierY = seg[seg.length - 3]
      } else {
        bezierX = x
        bezierY = y
      }
      result.push(seg)
    }
  
    return result
  }
  
  function line(x1, y1, x2, y2){
    return ['C', x1, y1, x2, y2, x2, y2]
  }
  
  function quadratic(x1, y1, cx, cy, x2, y2){
    return [
      'C',
      x1/3 + (2/3) * cx,
      y1/3 + (2/3) * cy,
      x2/3 + (2/3) * cx,
      y2/3 + (2/3) * cy,
      x2,
      y2
    ]
  }
  
  // This function is ripped from 
  // github.com/DmitryBaranovskiy/raphael/blob/4d97d4/raphael.js#L2216-L2304 
  // which references w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
  // TODO: make it human readable
  
  function arc(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
    if (!recursive) {
      var xy = rotate(x1, y1, -angle)
      x1 = xy.x
      y1 = xy.y
      xy = rotate(x2, y2, -angle)
      x2 = xy.x
      y2 = xy.y
      var x = (x1 - x2) / 2
      var y = (y1 - y2) / 2
      var h = (x * x) / (rx * rx) + (y * y) / (ry * ry)
      if (h > 1) {
        h = Math.sqrt(h)
        rx = h * rx
        ry = h * ry
      }
      var rx2 = rx * rx
      var ry2 = ry * ry
      var k = (large_arc_flag == sweep_flag ? -1 : 1)
        * Math.sqrt(Math.abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x)))
      if (k == Infinity) k = 1 // neutralize
      var cx = k * rx * y / ry + (x1 + x2) / 2
      var cy = k * -ry * x / rx + (y1 + y2) / 2
      var f1 = Math.asin(((y1 - cy) / ry).toFixed(9))
      var f2 = Math.asin(((y2 - cy) / ry).toFixed(9))
  
      f1 = x1 < cx ? π - f1 : f1
      f2 = x2 < cx ? π - f2 : f2
      if (f1 < 0) f1 = π * 2 + f1
      if (f2 < 0) f2 = π * 2 + f2
      if (sweep_flag && f1 > f2) f1 = f1 - π * 2
      if (!sweep_flag && f2 > f1) f2 = f2 - π * 2
    } else {
      f1 = recursive[0]
      f2 = recursive[1]
      cx = recursive[2]
      cy = recursive[3]
    }
    // greater than 120 degrees requires multiple segments
    if (Math.abs(f2 - f1) > _120) {
      var f2old = f2
      var x2old = x2
      var y2old = y2
      f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1)
      x2 = cx + rx * Math.cos(f2)
      y2 = cy + ry * Math.sin(f2)
      var res = arc(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [f2, f2old, cx, cy])
    }
    var t = Math.tan((f2 - f1) / 4)
    var hx = 4 / 3 * rx * t
    var hy = 4 / 3 * ry * t
    var curve = [
      2 * x1 - (x1 + hx * Math.sin(f1)),
      2 * y1 - (y1 - hy * Math.cos(f1)),
      x2 + hx * Math.sin(f2),
      y2 - hy * Math.cos(f2),
      x2,
      y2
    ]
    if (recursive) return curve
    if (res) curve = curve.concat(res)
    for (var i = 0; i < curve.length;) {
      var rot = rotate(curve[i], curve[i+1], angle)
      curve[i++] = rot.x
      curve[i++] = rot.y
    }
    return curve
  }
  
  function rotate(x, y, rad){
    return {
      x: x * Math.cos(rad) - y * Math.sin(rad),
      y: x * Math.sin(rad) + y * Math.cos(rad)
    }
  }
  
  function radians(degress){
    return degress * (π / 180)
  }
  
  },{}],472:[function(_dereq_,module,exports){
  var DEFAULT_NORMALS_EPSILON = 1e-6;
  var DEFAULT_FACE_EPSILON = 1e-6;
  
  //Estimate the vertex normals of a mesh
  exports.vertexNormals = function(faces, positions, specifiedEpsilon) {
  
    var N         = positions.length;
    var normals   = new Array(N);
    var epsilon   = specifiedEpsilon === void(0) ? DEFAULT_NORMALS_EPSILON : specifiedEpsilon;
  
    //Initialize normal array
    for(var i=0; i<N; ++i) {
      normals[i] = [0.0, 0.0, 0.0];
    }
  
    //Walk over all the faces and add per-vertex contribution to normal weights
    for(var i=0; i<faces.length; ++i) {
      var f = faces[i];
      var p = 0;
      var c = f[f.length-1];
      var n = f[0];
      for(var j=0; j<f.length; ++j) {
  
        //Shift indices back
        p = c;
        c = n;
        n = f[(j+1) % f.length];
  
        var v0 = positions[p];
        var v1 = positions[c];
        var v2 = positions[n];
  
        //Compute infineteismal arcs
        var d01 = new Array(3);
        var m01 = 0.0;
        var d21 = new Array(3);
        var m21 = 0.0;
        for(var k=0; k<3; ++k) {
          d01[k] = v0[k]  - v1[k];
          m01   += d01[k] * d01[k];
          d21[k] = v2[k]  - v1[k];
          m21   += d21[k] * d21[k];
        }
  
        //Accumulate values in normal
        if(m01 * m21 > epsilon) {
          var norm = normals[c];
          var w = 1.0 / Math.sqrt(m01 * m21);
          for(var k=0; k<3; ++k) {
            var u = (k+1)%3;
            var v = (k+2)%3;
            norm[k] += w * (d21[u] * d01[v] - d21[v] * d01[u]);
          }
        }
      }
    }
  
    //Scale all normals to unit length
    for(var i=0; i<N; ++i) {
      var norm = normals[i];
      var m = 0.0;
      for(var k=0; k<3; ++k) {
        m += norm[k] * norm[k];
      }
      if(m > epsilon) {
        var w = 1.0 / Math.sqrt(m);
        for(var k=0; k<3; ++k) {
          norm[k] *= w;
        }
      } else {
        for(var k=0; k<3; ++k) {
          norm[k] = 0.0;
        }
      }
    }
  
    //Return the resulting set of patches
    return normals;
  }
  
  //Compute face normals of a mesh
  exports.faceNormals = function(faces, positions, specifiedEpsilon) {
  
    var N         = faces.length;
    var normals   = new Array(N);
    var epsilon   = specifiedEpsilon === void(0) ? DEFAULT_FACE_EPSILON : specifiedEpsilon;
  
    for(var i=0; i<N; ++i) {
      var f = faces[i];
      var pos = new Array(3);
      for(var j=0; j<3; ++j) {
        pos[j] = positions[f[j]];
      }
  
      var d01 = new Array(3);
      var d21 = new Array(3);
      for(var j=0; j<3; ++j) {
        d01[j] = pos[1][j] - pos[0][j];
        d21[j] = pos[2][j] - pos[0][j];
      }
  
      var n = new Array(3);
      var l = 0.0;
      for(var j=0; j<3; ++j) {
        var u = (j+1)%3;
        var v = (j+2)%3;
        n[j] = d01[u] * d21[v] - d01[v] * d21[u];
        l += n[j] * n[j];
      }
      if(l > epsilon) {
        l = 1.0 / Math.sqrt(l);
      } else {
        l = 0.0;
      }
      for(var j=0; j<3; ++j) {
        n[j] *= l;
      }
      normals[i] = n;
    }
    return normals;
  }
  
  
  
  },{}],473:[function(_dereq_,module,exports){
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  
  'use strict';
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;
  
  function toObject(val) {
    if (val === null || val === undefined) {
      throw new TypeError('Object.assign cannot be called with null or undefined');
    }
  
    return Object(val);
  }
  
  function shouldUseNative() {
    try {
      if (!Object.assign) {
        return false;
      }
  
      // Detect buggy property enumeration order in older V8 versions.
  
      // https://bugs.chromium.org/p/v8/issues/detail?id=4118
      var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
      test1[5] = 'de';
      if (Object.getOwnPropertyNames(test1)[0] === '5') {
        return false;
      }
  
      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test2 = {};
      for (var i = 0; i < 10; i++) {
        test2['_' + String.fromCharCode(i)] = i;
      }
      var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
        return test2[n];
      });
      if (order2.join('') !== '0123456789') {
        return false;
      }
  
      // https://bugs.chromium.org/p/v8/issues/detail?id=3056
      var test3 = {};
      'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
        test3[letter] = letter;
      });
      if (Object.keys(Object.assign({}, test3)).join('') !==
          'abcdefghijklmnopqrst') {
        return false;
      }
  
      return true;
    } catch (err) {
      // We don't expect any of the above to throw, but better to be safe.
      return false;
    }
  }
  
  module.exports = shouldUseNative() ? Object.assign : function (target, source) {
    var from;
    var to = toObject(target);
    var symbols;
  
    for (var s = 1; s < arguments.length; s++) {
      from = Object(arguments[s]);
  
      for (var key in from) {
        if (hasOwnProperty.call(from, key)) {
          to[key] = from[key];
        }
      }
  
      if (getOwnPropertySymbols) {
        symbols = getOwnPropertySymbols(from);
        for (var i = 0; i < symbols.length; i++) {
          if (propIsEnumerable.call(from, symbols[i])) {
            to[symbols[i]] = from[symbols[i]];
          }
        }
      }
    }
  
    return to;
  };
  
  },{}],474:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = quatFromFrame
  
  function quatFromFrame(
    out,
    rx, ry, rz,
    ux, uy, uz,
    fx, fy, fz) {
    var tr = rx + uy + fz
    if(l > 0) {
      var l = Math.sqrt(tr + 1.0)
      out[0] = 0.5 * (uz - fy) / l
      out[1] = 0.5 * (fx - rz) / l
      out[2] = 0.5 * (ry - uy) / l
      out[3] = 0.5 * l
    } else {
      var tf = Math.max(rx, uy, fz)
      var l = Math.sqrt(2 * tf - tr + 1.0)
      if(rx >= tf) {
        //x y z  order
        out[0] = 0.5 * l
        out[1] = 0.5 * (ux + ry) / l
        out[2] = 0.5 * (fx + rz) / l
        out[3] = 0.5 * (uz - fy) / l
      } else if(uy >= tf) {
        //y z x  order
        out[0] = 0.5 * (ry + ux) / l
        out[1] = 0.5 * l
        out[2] = 0.5 * (fy + uz) / l
        out[3] = 0.5 * (fx - rz) / l
      } else {
        //z x y  order
        out[0] = 0.5 * (rz + fx) / l
        out[1] = 0.5 * (uz + fy) / l
        out[2] = 0.5 * l
        out[3] = 0.5 * (ry - ux) / l
      }
    }
    return out
  }
  },{}],475:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createOrbitController
  
  var filterVector  = _dereq_('filtered-vector')
  var lookAt        = _dereq_('gl-mat4/lookAt')
  var mat4FromQuat  = _dereq_('gl-mat4/fromQuat')
  var invert44      = _dereq_('gl-mat4/invert')
  var quatFromFrame = _dereq_('./lib/quatFromFrame')
  
  function len3(x,y,z) {
    return Math.sqrt(Math.pow(x,2) + Math.pow(y,2) + Math.pow(z,2))
  }
  
  function len4(w,x,y,z) {
    return Math.sqrt(Math.pow(w,2) + Math.pow(x,2) + Math.pow(y,2) + Math.pow(z,2))
  }
  
  function normalize4(out, a) {
    var ax = a[0]
    var ay = a[1]
    var az = a[2]
    var aw = a[3]
    var al = len4(ax, ay, az, aw)
    if(al > 1e-6) {
      out[0] = ax/al
      out[1] = ay/al
      out[2] = az/al
      out[3] = aw/al
    } else {
      out[0] = out[1] = out[2] = 0.0
      out[3] = 1.0
    }
  }
  
  function OrbitCameraController(initQuat, initCenter, initRadius) {
    this.radius    = filterVector([initRadius])
    this.center    = filterVector(initCenter)
    this.rotation  = filterVector(initQuat)
  
    this.computedRadius   = this.radius.curve(0)
    this.computedCenter   = this.center.curve(0)
    this.computedRotation = this.rotation.curve(0)
    this.computedUp       = [0.1,0,0]
    this.computedEye      = [0.1,0,0]
    this.computedMatrix   = [0.1,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]
  
    this.recalcMatrix(0)
  }
  
  var proto = OrbitCameraController.prototype
  
  proto.lastT = function() {
    return Math.max(
      this.radius.lastT(),
      this.center.lastT(),
      this.rotation.lastT())
  }
  
  proto.recalcMatrix = function(t) {
    this.radius.curve(t)
    this.center.curve(t)
    this.rotation.curve(t)
  
    var quat = this.computedRotation
    normalize4(quat, quat)
  
    var mat = this.computedMatrix
    mat4FromQuat(mat, quat)
  
    var center = this.computedCenter
    var eye    = this.computedEye
    var up     = this.computedUp
    var radius = Math.exp(this.computedRadius[0])
  
    eye[0] = center[0] + radius * mat[2]
    eye[1] = center[1] + radius * mat[6]
    eye[2] = center[2] + radius * mat[10]
    up[0] = mat[1]
    up[1] = mat[5]
    up[2] = mat[9]
  
    for(var i=0; i<3; ++i) {
      var rr = 0.0
      for(var j=0; j<3; ++j) {
        rr += mat[i+4*j] * eye[j]
      }
      mat[12+i] = -rr
    }
  }
  
  proto.getMatrix = function(t, result) {
    this.recalcMatrix(t)
    var m = this.computedMatrix
    if(result) {
      for(var i=0; i<16; ++i) {
        result[i] = m[i]
      }
      return result
    }
    return m
  }
  
  proto.idle = function(t) {
    this.center.idle(t)
    this.radius.idle(t)
    this.rotation.idle(t)
  }
  
  proto.flush = function(t) {
    this.center.flush(t)
    this.radius.flush(t)
    this.rotation.flush(t)
  }
  
  proto.pan = function(t, dx, dy, dz) {
    dx = dx || 0.0
    dy = dy || 0.0
    dz = dz || 0.0
  
    this.recalcMatrix(t)
    var mat = this.computedMatrix
  
    var ux = mat[1]
    var uy = mat[5]
    var uz = mat[9]
    var ul = len3(ux, uy, uz)
    ux /= ul
    uy /= ul
    uz /= ul
  
    var rx = mat[0]
    var ry = mat[4]
    var rz = mat[8]
    var ru = rx * ux + ry * uy + rz * uz
    rx -= ux * ru
    ry -= uy * ru
    rz -= uz * ru
    var rl = len3(rx, ry, rz)
    rx /= rl
    ry /= rl
    rz /= rl
  
    var fx = mat[2]
    var fy = mat[6]
    var fz = mat[10]
    var fu = fx * ux + fy * uy + fz * uz
    var fr = fx * rx + fy * ry + fz * rz
    fx -= fu * ux + fr * rx
    fy -= fu * uy + fr * ry
    fz -= fu * uz + fr * rz
    var fl = len3(fx, fy, fz)
    fx /= fl
    fy /= fl
    fz /= fl
  
    var vx = rx * dx + ux * dy
    var vy = ry * dx + uy * dy
    var vz = rz * dx + uz * dy
  
    this.center.move(t, vx, vy, vz)
  
    //Update z-component of radius
    var radius = Math.exp(this.computedRadius[0])
    radius = Math.max(1e-4, radius + dz)
    this.radius.set(t, Math.log(radius))
  }
  
  proto.rotate = function(t, dx, dy, dz) {
    this.recalcMatrix(t)
  
    dx = dx||0.0
    dy = dy||0.0
  
    var mat = this.computedMatrix
  
    var rx = mat[0]
    var ry = mat[4]
    var rz = mat[8]
  
    var ux = mat[1]
    var uy = mat[5]
    var uz = mat[9]
  
    var fx = mat[2]
    var fy = mat[6]
    var fz = mat[10]
  
    var qx = dx * rx + dy * ux
    var qy = dx * ry + dy * uy
    var qz = dx * rz + dy * uz
  
    var bx = -(fy * qz - fz * qy)
    var by = -(fz * qx - fx * qz)
    var bz = -(fx * qy - fy * qx)  
    var bw = Math.sqrt(Math.max(0.0, 1.0 - Math.pow(bx,2) - Math.pow(by,2) - Math.pow(bz,2)))
    var bl = len4(bx, by, bz, bw)
    if(bl > 1e-6) {
      bx /= bl
      by /= bl
      bz /= bl
      bw /= bl
    } else {
      bx = by = bz = 0.0
      bw = 1.0
    }
  
    var rotation = this.computedRotation
    var ax = rotation[0]
    var ay = rotation[1]
    var az = rotation[2]
    var aw = rotation[3]
  
    var cx = ax*bw + aw*bx + ay*bz - az*by
    var cy = ay*bw + aw*by + az*bx - ax*bz
    var cz = az*bw + aw*bz + ax*by - ay*bx
    var cw = aw*bw - ax*bx - ay*by - az*bz
    
    //Apply roll
    if(dz) {
      bx = fx
      by = fy
      bz = fz
      var s = Math.sin(dz) / len3(bx, by, bz)
      bx *= s
      by *= s
      bz *= s
      bw = Math.cos(dx)
      cx = cx*bw + cw*bx + cy*bz - cz*by
      cy = cy*bw + cw*by + cz*bx - cx*bz
      cz = cz*bw + cw*bz + cx*by - cy*bx
      cw = cw*bw - cx*bx - cy*by - cz*bz
    }
  
    var cl = len4(cx, cy, cz, cw)
    if(cl > 1e-6) {
      cx /= cl
      cy /= cl
      cz /= cl
      cw /= cl
    } else {
      cx = cy = cz = 0.0
      cw = 1.0
    }
  
    this.rotation.set(t, cx, cy, cz, cw)
  }
  
  proto.lookAt = function(t, eye, center, up) {
    this.recalcMatrix(t)
  
    center = center || this.computedCenter
    eye    = eye    || this.computedEye
    up     = up     || this.computedUp
  
    var mat = this.computedMatrix
    lookAt(mat, eye, center, up)
  
    var rotation = this.computedRotation
    quatFromFrame(rotation,
      mat[0], mat[1], mat[2],
      mat[4], mat[5], mat[6],
      mat[8], mat[9], mat[10])
    normalize4(rotation, rotation)
    this.rotation.set(t, rotation[0], rotation[1], rotation[2], rotation[3])
  
    var fl = 0.0
    for(var i=0; i<3; ++i) {
      fl += Math.pow(center[i] - eye[i], 2)
    }
    this.radius.set(t, 0.5 * Math.log(Math.max(fl, 1e-6)))
  
    this.center.set(t, center[0], center[1], center[2])
  }
  
  proto.translate = function(t, dx, dy, dz) {
    this.center.move(t,
      dx||0.0,
      dy||0.0,
      dz||0.0)
  }
  
  proto.setMatrix = function(t, matrix) {
  
    var rotation = this.computedRotation
    quatFromFrame(rotation,
      matrix[0], matrix[1], matrix[2],
      matrix[4], matrix[5], matrix[6],
      matrix[8], matrix[9], matrix[10])
    normalize4(rotation, rotation)
    this.rotation.set(t, rotation[0], rotation[1], rotation[2], rotation[3])
  
    var mat = this.computedMatrix
    invert44(mat, matrix)
    var w = mat[15]
    if(Math.abs(w) > 1e-6) {
      var cx = mat[12]/w
      var cy = mat[13]/w
      var cz = mat[14]/w
  
      this.recalcMatrix(t)  
      var r = Math.exp(this.computedRadius[0])
      this.center.set(t, cx-mat[2]*r, cy-mat[6]*r, cz-mat[10]*r)
      this.radius.idle(t)
    } else {
      this.center.idle(t)
      this.radius.idle(t)
    }
  }
  
  proto.setDistance = function(t, d) {
    if(d > 0) {
      this.radius.set(t, Math.log(d))
    }
  }
  
  proto.setDistanceLimits = function(lo, hi) {
    if(lo > 0) {
      lo = Math.log(lo)
    } else {
      lo = -Infinity    
    }
    if(hi > 0) {
      hi = Math.log(hi)
    } else {
      hi = Infinity
    }
    hi = Math.max(hi, lo)
    this.radius.bounds[0][0] = lo
    this.radius.bounds[1][0] = hi
  }
  
  proto.getDistanceLimits = function(out) {
    var bounds = this.radius.bounds
    if(out) {
      out[0] = Math.exp(bounds[0][0])
      out[1] = Math.exp(bounds[1][0])
      return out
    }
    return [ Math.exp(bounds[0][0]), Math.exp(bounds[1][0]) ]
  }
  
  proto.toJSON = function() {
    this.recalcMatrix(this.lastT())
    return {
      center:   this.computedCenter.slice(),
      rotation: this.computedRotation.slice(),
      distance: Math.log(this.computedRadius[0]),
      zoomMin:  this.radius.bounds[0][0],
      zoomMax:  this.radius.bounds[1][0]
    }
  }
  
  proto.fromJSON = function(options) {
    var t = this.lastT()
    var c = options.center
    if(c) {
      this.center.set(t, c[0], c[1], c[2])
    }
    var r = options.rotation
    if(r) {
      this.rotation.set(t, r[0], r[1], r[2], r[3])
    }
    var d = options.distance
    if(d && d > 0) {
      this.radius.set(t, Math.log(d))
    }
    this.setDistanceLimits(options.zoomMin, options.zoomMax)
  }
  
  function createOrbitController(options) {
    options = options || {}
    var center   = options.center   || [0,0,0]
    var rotation = options.rotation || [0,0,0,1]
    var radius   = options.radius   || 1.0
  
    center = [].slice.call(center, 0, 3)
    rotation = [].slice.call(rotation, 0, 4)
    normalize4(rotation, rotation)
  
    var result = new OrbitCameraController(
      rotation,
      center,
      Math.log(radius))
  
    result.setDistanceLimits(options.zoomMin, options.zoomMax)
  
    if('eye' in options || 'up' in options) {
      result.lookAt(0, options.eye, options.center, options.up)
    }
  
    return result
  }
  },{"./lib/quatFromFrame":474,"filtered-vector":242,"gl-mat4/fromQuat":275,"gl-mat4/invert":278,"gl-mat4/lookAt":279}],476:[function(_dereq_,module,exports){
  /*!
   * pad-left <https://github.com/jonschlinkert/pad-left>
   *
   * Copyright (c) 2014-2015, Jon Schlinkert.
   * Licensed under the MIT license.
   */
  
  'use strict';
  
  var repeat = _dereq_('repeat-string');
  
  module.exports = function padLeft(str, num, ch) {
    ch = typeof ch !== 'undefined' ? (ch + '') : ' ';
    return repeat(ch, num) + str;
  };
  },{"repeat-string":513}],477:[function(_dereq_,module,exports){
  'use strict'
  
  /**
   * @module parenthesis
   */
  
  function parse (str, opts) {
    // pretend non-string parsed per-se
    if (typeof str !== 'string') return [str]
  
    var res = [str]
  
    if (typeof opts === 'string' || Array.isArray(opts)) {
      opts = {brackets: opts}
    }
    else if (!opts) opts = {}
  
    var brackets = opts.brackets ? (Array.isArray(opts.brackets) ? opts.brackets : [opts.brackets]) : ['{}', '[]', '()']
  
    var escape = opts.escape || '___'
  
    var flat = !!opts.flat
  
    brackets.forEach(function (bracket) {
      // create parenthesis regex
      var pRE = new RegExp(['\\', bracket[0], '[^\\', bracket[0], '\\', bracket[1], ']*\\', bracket[1]].join(''))
  
      var ids = []
  
      function replaceToken(token, idx, str){
        // save token to res
        var refId = res.push(token.slice(bracket[0].length, -bracket[1].length)) - 1
  
        ids.push(refId)
  
        return escape + refId + escape
      }
  
      res.forEach(function (str, i) {
        var prevStr
  
        // replace paren tokens till there’s none
        var a = 0
        while (str != prevStr) {
          prevStr = str
          str = str.replace(pRE, replaceToken)
          if (a++ > 10e3) throw Error('References have circular dependency. Please, check them.')
        }
  
        res[i] = str
      })
  
      // wrap found refs to brackets
      ids = ids.reverse()
      res = res.map(function (str) {
        ids.forEach(function (id) {
          str = str.replace(new RegExp('(\\' + escape + id + '\\' + escape + ')', 'g'), bracket[0] + '$1' + bracket[1])
        })
        return str
      })
    })
  
    var re = new RegExp('\\' + escape + '([0-9]+)' + '\\' + escape)
  
    // transform references to tree
    function nest (str, refs, escape) {
      var res = [], match
  
      var a = 0
      while (match = re.exec(str)) {
        if (a++ > 10e3) throw Error('Circular references in parenthesis')
  
        res.push(str.slice(0, match.index))
  
        res.push(nest(refs[match[1]], refs))
  
        str = str.slice(match.index + match[0].length)
      }
  
      res.push(str)
  
      return res
    }
  
    return flat ? res : nest(res[0], res)
  }
  
  function stringify (arg, opts) {
    if (opts && opts.flat) {
      var escape = opts && opts.escape || '___'
  
      var str = arg[0], prevStr
  
      // pretend bad string stringified with no parentheses
      if (!str) return ''
  
  
      var re = new RegExp('\\' + escape + '([0-9]+)' + '\\' + escape)
  
      var a = 0
      while (str != prevStr) {
        if (a++ > 10e3) throw Error('Circular references in ' + arg)
        prevStr = str
        str = str.replace(re, replaceRef)
      }
  
      return str
    }
  
    return arg.reduce(function f (prev, curr) {
      if (Array.isArray(curr)) {
        curr = curr.reduce(f, '')
      }
      return prev + curr
    }, '')
  
    function replaceRef(match, idx){
      if (arg[idx] == null) throw Error('Reference ' + idx + 'is undefined')
      return arg[idx]
    }
  }
  
  function parenthesis (arg, opts) {
    if (Array.isArray(arg)) {
      return stringify(arg, opts)
    }
    else {
      return parse(arg, opts)
    }
  }
  
  parenthesis.parse = parse
  parenthesis.stringify = stringify
  
  module.exports = parenthesis
  
  },{}],478:[function(_dereq_,module,exports){
  'use strict'
  
  var pick = _dereq_('pick-by-alias')
  
  module.exports = parseRect
  
  function parseRect (arg) {
    var rect
  
    // direct arguments sequence
    if (arguments.length > 1) {
      arg = arguments
    }
  
    // svg viewbox
    if (typeof arg === 'string') {
      arg = arg.split(/\s/).map(parseFloat)
    }
    else if (typeof arg === 'number') {
      arg = [arg]
    }
  
    // 0, 0, 100, 100 - array-like
    if (arg.length && typeof arg[0] === 'number') {
      // [w, w]
      if (arg.length === 1) {
        rect = {
          width: arg[0],
          height: arg[0],
          x: 0, y: 0
        }
      }
      // [w, h]
      else if (arg.length === 2) {
        rect = {
          width: arg[0],
          height: arg[1],
          x: 0, y: 0
        }
      }
      // [l, t, r, b]
      else {
        rect = {
          x: arg[0],
          y: arg[1],
          width: (arg[2] - arg[0]) || 0,
          height: (arg[3] - arg[1]) || 0
        }
      }
    }
    // {x, y, w, h} or {l, t, b, r}
    else if (arg) {
      arg = pick(arg, {
        left: 'x l left Left',
        top: 'y t top Top',
        width: 'w width W Width',
        height: 'h height W Width',
        bottom: 'b bottom Bottom',
        right: 'r right Right'
      })
  
      rect = {
        x: arg.left || 0,
        y: arg.top || 0
      }
  
      if (arg.width == null) {
        if (arg.right) rect.width = arg.right - rect.x
        else rect.width = 0
      }
      else {
        rect.width = arg.width
      }
  
      if (arg.height == null) {
        if (arg.bottom) rect.height = arg.bottom - rect.y
        else rect.height = 0
      }
      else {
        rect.height = arg.height
      }
    }
  
    return rect
  }
  
  },{"pick-by-alias":485}],479:[function(_dereq_,module,exports){
  
  module.exports = parse
  
  /**
   * expected argument lengths
   * @type {Object}
   */
  
  var length = {a: 7, c: 6, h: 1, l: 2, m: 2, q: 4, s: 4, t: 2, v: 1, z: 0}
  
  /**
   * segment pattern
   * @type {RegExp}
   */
  
  var segment = /([astvzqmhlc])([^astvzqmhlc]*)/ig
  
  /**
   * parse an svg path data string. Generates an Array
   * of commands where each command is an Array of the
   * form `[command, arg1, arg2, ...]`
   *
   * @param {String} path
   * @return {Array}
   */
  
  function parse(path) {
    var data = []
    path.replace(segment, function(_, command, args){
      var type = command.toLowerCase()
      args = parseValues(args)
  
      // overloaded moveTo
      if (type == 'm' && args.length > 2) {
        data.push([command].concat(args.splice(0, 2)))
        type = 'l'
        command = command == 'm' ? 'l' : 'L'
      }
  
      while (true) {
        if (args.length == length[type]) {
          args.unshift(command)
          return data.push(args)
        }
        if (args.length < length[type]) throw new Error('malformed path data')
        data.push([command].concat(args.splice(0, length[type])))
      }
    })
    return data
  }
  
  var number = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig
  
  function parseValues(args) {
    var numbers = args.match(number)
    return numbers ? numbers.map(Number) : []
  }
  
  },{}],480:[function(_dereq_,module,exports){
  module.exports = function parseUnit(str, out) {
      if (!out)
          out = [ 0, '' ]
  
      str = String(str)
      var num = parseFloat(str, 10)
      out[0] = num
      out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || ''
      return out
  }
  },{}],481:[function(_dereq_,module,exports){
  (function (process){
  // .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
  // backported and transplited with Babel, with backwards-compat fixes
  
  // Copyright Joyent, Inc. and other Node contributors.
  //
  // Permission is hereby granted, free of charge, to any person obtaining a
  // copy of this software and associated documentation files (the
  // "Software"), to deal in the Software without restriction, including
  // without limitation the rights to use, copy, modify, merge, publish,
  // distribute, sublicense, and/or sell copies of the Software, and to permit
  // persons to whom the Software is furnished to do so, subject to the
  // following conditions:
  //
  // The above copyright notice and this permission notice shall be included
  // in all copies or substantial portions of the Software.
  //
  // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
  // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
  // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
  // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
  // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
  // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
  // USE OR OTHER DEALINGS IN THE SOFTWARE.
  
  // resolves . and .. elements in a path array with directory names there
  // must be no slashes, empty elements, or device names (c:\) in the array
  // (so also no leading and trailing slashes - it does not distinguish
  // relative and absolute paths)
  function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
      var last = parts[i];
      if (last === '.') {
        parts.splice(i, 1);
      } else if (last === '..') {
        parts.splice(i, 1);
        up++;
      } else if (up) {
        parts.splice(i, 1);
        up--;
      }
    }
  
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
      for (; up--; up) {
        parts.unshift('..');
      }
    }
  
    return parts;
  }
  
  // path.resolve([from ...], to)
  // posix version
  exports.resolve = function() {
    var resolvedPath = '',
        resolvedAbsolute = false;
  
    for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
      var path = (i >= 0) ? arguments[i] : process.cwd();
  
      // Skip empty and invalid entries
      if (typeof path !== 'string') {
        throw new TypeError('Arguments to path.resolve must be strings');
      } else if (!path) {
        continue;
      }
  
      resolvedPath = path + '/' + resolvedPath;
      resolvedAbsolute = path.charAt(0) === '/';
    }
  
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
  
    // Normalize the path
    resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
      return !!p;
    }), !resolvedAbsolute).join('/');
  
    return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
  };
  
  // path.normalize(path)
  // posix version
  exports.normalize = function(path) {
    var isAbsolute = exports.isAbsolute(path),
        trailingSlash = substr(path, -1) === '/';
  
    // Normalize the path
    path = normalizeArray(filter(path.split('/'), function(p) {
      return !!p;
    }), !isAbsolute).join('/');
  
    if (!path && !isAbsolute) {
      path = '.';
    }
    if (path && trailingSlash) {
      path += '/';
    }
  
    return (isAbsolute ? '/' : '') + path;
  };
  
  // posix version
  exports.isAbsolute = function(path) {
    return path.charAt(0) === '/';
  };
  
  // posix version
  exports.join = function() {
    var paths = Array.prototype.slice.call(arguments, 0);
    return exports.normalize(filter(paths, function(p, index) {
      if (typeof p !== 'string') {
        throw new TypeError('Arguments to path.join must be strings');
      }
      return p;
    }).join('/'));
  };
  
  
  // path.relative(from, to)
  // posix version
  exports.relative = function(from, to) {
    from = exports.resolve(from).substr(1);
    to = exports.resolve(to).substr(1);
  
    function trim(arr) {
      var start = 0;
      for (; start < arr.length; start++) {
        if (arr[start] !== '') break;
      }
  
      var end = arr.length - 1;
      for (; end >= 0; end--) {
        if (arr[end] !== '') break;
      }
  
      if (start > end) return [];
      return arr.slice(start, end - start + 1);
    }
  
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
  
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
      if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
      }
    }
  
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
      outputParts.push('..');
    }
  
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
  
    return outputParts.join('/');
  };
  
  exports.sep = '/';
  exports.delimiter = ':';
  
  exports.dirname = function (path) {
    if (typeof path !== 'string') path = path + '';
    if (path.length === 0) return '.';
    var code = path.charCodeAt(0);
    var hasRoot = code === 47 /*/*/;
    var end = -1;
    var matchedSlash = true;
    for (var i = path.length - 1; i >= 1; --i) {
      code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          if (!matchedSlash) {
            end = i;
            break;
          }
        } else {
        // We saw the first non-path separator
        matchedSlash = false;
      }
    }
  
    if (end === -1) return hasRoot ? '/' : '.';
    if (hasRoot && end === 1) {
      // return '//';
      // Backwards-compat fix:
      return '/';
    }
    return path.slice(0, end);
  };
  
  function basename(path) {
    if (typeof path !== 'string') path = path + '';
  
    var start = 0;
    var end = -1;
    var matchedSlash = true;
    var i;
  
    for (i = path.length - 1; i >= 0; --i) {
      if (path.charCodeAt(i) === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            start = i + 1;
            break;
          }
        } else if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // path component
        matchedSlash = false;
        end = i + 1;
      }
    }
  
    if (end === -1) return '';
    return path.slice(start, end);
  }
  
  // Uses a mixed approach for backwards-compatibility, as ext behavior changed
  // in new Node.js versions, so only basename() above is backported here
  exports.basename = function (path, ext) {
    var f = basename(path);
    if (ext && f.substr(-1 * ext.length) === ext) {
      f = f.substr(0, f.length - ext.length);
    }
    return f;
  };
  
  exports.extname = function (path) {
    if (typeof path !== 'string') path = path + '';
    var startDot = -1;
    var startPart = 0;
    var end = -1;
    var matchedSlash = true;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find
    var preDotState = 0;
    for (var i = path.length - 1; i >= 0; --i) {
      var code = path.charCodeAt(i);
      if (code === 47 /*/*/) {
          // If we reached a path separator that was not part of a set of path
          // separators at the end of the string, stop now
          if (!matchedSlash) {
            startPart = i + 1;
            break;
          }
          continue;
        }
      if (end === -1) {
        // We saw the first non-path separator, mark this as the end of our
        // extension
        matchedSlash = false;
        end = i + 1;
      }
      if (code === 46 /*.*/) {
          // If this is our first dot, mark it as the start of our extension
          if (startDot === -1)
            startDot = i;
          else if (preDotState !== 1)
            preDotState = 1;
      } else if (startDot !== -1) {
        // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension
        preDotState = -1;
      }
    }
  
    if (startDot === -1 || end === -1 ||
        // We saw a non-dot character immediately before the dot
        preDotState === 0 ||
        // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
      return '';
    }
    return path.slice(startDot, end);
  };
  
  function filter (xs, f) {
      if (xs.filter) return xs.filter(f);
      var res = [];
      for (var i = 0; i < xs.length; i++) {
          if (f(xs[i], i, xs)) res.push(xs[i]);
      }
      return res;
  }
  
  // String.prototype.substr - negative index don't work in IE8
  var substr = 'ab'.substr(-1) === 'b'
      ? function (str, start, len) { return str.substr(start, len) }
      : function (str, start, len) {
          if (start < 0) start = str.length + start;
          return str.substr(start, len);
      }
  ;
  
  }).call(this,_dereq_('_process'))
  },{"_process":500}],482:[function(_dereq_,module,exports){
  (function (process){
  // Generated by CoffeeScript 1.12.2
  (function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
  
    if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
      module.exports = function() {
        return performance.now();
      };
    } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
      module.exports = function() {
        return (getNanoSeconds() - nodeLoadTime) / 1e6;
      };
      hrtime = process.hrtime;
      getNanoSeconds = function() {
        var hr;
        hr = hrtime();
        return hr[0] * 1e9 + hr[1];
      };
      moduleLoadTime = getNanoSeconds();
      upTime = process.uptime() * 1e9;
      nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
      module.exports = function() {
        return Date.now() - loadTime;
      };
      loadTime = Date.now();
    } else {
      module.exports = function() {
        return new Date().getTime() - loadTime;
      };
      loadTime = new Date().getTime();
    }
  
  }).call(this);
  
  
  
  }).call(this,_dereq_('_process'))
  },{"_process":500}],483:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = permutationSign
  
  var BRUTE_FORCE_CUTOFF = 32
  
  var pool = _dereq_("typedarray-pool")
  
  function permutationSign(p) {
    var n = p.length
    if(n < BRUTE_FORCE_CUTOFF) {
      //Use quadratic algorithm for small n
      var sgn = 1
      for(var i=0; i<n; ++i) {
        for(var j=0; j<i; ++j) {
          if(p[i] < p[j]) {
            sgn = -sgn
          } else if(p[i] === p[j]) {
            return 0
          }
        }
      }
      return sgn
    } else {
      //Otherwise use linear time algorithm
      var visited = pool.mallocUint8(n)
      for(var i=0; i<n; ++i) {
        visited[i] = 0
      }
      var sgn = 1
      for(var i=0; i<n; ++i) {
        if(!visited[i]) {
          var count = 1
          visited[i] = 1
          for(var j=p[i]; j!==i; j=p[j]) {
            if(visited[j]) {
              pool.freeUint8(visited)
              return 0
            }
            count += 1
            visited[j] = 1
          }
          if(!(count & 1)) {
            sgn = -sgn
          }
        }
      }
      pool.freeUint8(visited)
      return sgn
    }
  }
  },{"typedarray-pool":567}],484:[function(_dereq_,module,exports){
  "use strict"
  
  var pool = _dereq_("typedarray-pool")
  var inverse = _dereq_("invert-permutation")
  
  function rank(permutation) {
    var n = permutation.length
    switch(n) {
      case 0:
      case 1:
        return 0
      case 2:
        return permutation[1]
      default:
        break
    }
    var p = pool.mallocUint32(n)
    var pinv = pool.mallocUint32(n)
    var r = 0, s, t, i
    inverse(permutation, pinv)
    for(i=0; i<n; ++i) {
      p[i] = permutation[i]
    }
    for(i=n-1; i>0; --i) {
      t = pinv[i]
      s = p[i]
      p[i] = p[t]
      p[t] = s
      pinv[i] = pinv[s]
      pinv[s] = t
      r = (r + s) * i
    }
    pool.freeUint32(pinv)
    pool.freeUint32(p)
    return r
  }
  
  function unrank(n, r, p) {
    switch(n) {
      case 0:
        if(p) { return p }
        return []
      case 1:
        if(p) {
          p[0] = 0
          return p
        } else {
          return [0]
        }
      case 2:
        if(p) {
          if(r) {
            p[0] = 0
            p[1] = 1
          } else {
            p[0] = 1
            p[1] = 0
          }
          return p
        } else {
          return r ? [0,1] : [1,0]
        }
      default:
        break
    }
    p = p || new Array(n)
    var s, t, i, nf=1
    p[0] = 0
    for(i=1; i<n; ++i) {
      p[i] = i
      nf = (nf*i)|0
    }
    for(i=n-1; i>0; --i) {
      s = (r / nf)|0
      r = (r - s * nf)|0
      nf = (nf / i)|0
      t = p[i]|0
      p[i] = p[s]|0
      p[s] = t|0
    }
    return p
  }
  
  exports.rank = rank
  exports.unrank = unrank
  
  },{"invert-permutation":436,"typedarray-pool":567}],485:[function(_dereq_,module,exports){
  'use strict'
  
  
  module.exports = function pick (src, props, keepRest) {
    var result = {}, prop, i
  
    if (typeof props === 'string') props = toList(props)
    if (Array.isArray(props)) {
      var res = {}
      for (i = 0; i < props.length; i++) {
        res[props[i]] = true
      }
      props = res
    }
  
    // convert strings to lists
    for (prop in props) {
      props[prop] = toList(props[prop])
    }
  
    // keep-rest strategy requires unmatched props to be preserved
    var occupied = {}
  
    for (prop in props) {
      var aliases = props[prop]
  
      if (Array.isArray(aliases)) {
        for (i = 0; i < aliases.length; i++) {
          var alias = aliases[i]
  
          if (keepRest) {
            occupied[alias] = true
          }
  
          if (alias in src) {
            result[prop] = src[alias]
  
            if (keepRest) {
              for (var j = i; j < aliases.length; j++) {
                occupied[aliases[j]] = true
              }
            }
  
            break
          }
        }
      }
      else if (prop in src) {
        if (props[prop]) {
          result[prop] = src[prop]
        }
  
        if (keepRest) {
          occupied[prop] = true
        }
      }
    }
  
    if (keepRest) {
      for (prop in src) {
        if (occupied[prop]) continue
        result[prop] = src[prop]
      }
    }
  
    return result
  }
  
  var CACHE = {}
  
  function toList(arg) {
    if (CACHE[arg]) return CACHE[arg]
    if (typeof arg === 'string') {
      arg = CACHE[arg] = arg.split(/\s*,\s*|\s+/)
    }
    return arg
  }
  
  },{}],486:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = planarDual
  
  var compareAngle = _dereq_("compare-angle")
  
  function planarDual(cells, positions) {
  
    var numVertices = positions.length|0
    var numEdges = cells.length
    var adj = [new Array(numVertices), new Array(numVertices)]
    for(var i=0; i<numVertices; ++i) {
      adj[0][i] = []
      adj[1][i] = []
    }
    for(var i=0; i<numEdges; ++i) {
      var c = cells[i]
      adj[0][c[0]].push(c)
      adj[1][c[1]].push(c)
    }
  
    var cycles = []
  
    //Add isolated vertices as trivial case
    for(var i=0; i<numVertices; ++i) {
      if(adj[0][i].length + adj[1][i].length === 0) {
        cycles.push( [i] )
      }
    }
  
    //Remove a half edge
    function cut(c, i) {
      var a = adj[i][c[i]]
      a.splice(a.indexOf(c), 1)
    }
  
    //Find next vertex and cut edge
    function next(a, b, noCut) {
      var nextCell, nextVertex, nextDir
      for(var i=0; i<2; ++i) {
        if(adj[i][b].length > 0) {
          nextCell = adj[i][b][0]
          nextDir = i
          break
        }
      }
      nextVertex = nextCell[nextDir^1]
  
      for(var dir=0; dir<2; ++dir) {
        var nbhd = adj[dir][b]
        for(var k=0; k<nbhd.length; ++k) {
          var e = nbhd[k]
          var p = e[dir^1]
          var cmp = compareAngle(
              positions[a], 
              positions[b], 
              positions[nextVertex],
              positions[p])
          if(cmp > 0) {
            nextCell = e
            nextVertex = p
            nextDir = dir
          }
        }
      }
      if(noCut) {
        return nextVertex
      }
      if(nextCell) {
        cut(nextCell, nextDir)
      }
      return nextVertex
    }
  
    function extractCycle(v, dir) {
      var e0 = adj[dir][v][0]
      var cycle = [v]
      cut(e0, dir)
      var u = e0[dir^1]
      var d0 = dir
      while(true) {
        while(u !== v) {
          cycle.push(u)
          u = next(cycle[cycle.length-2], u, false)
        }
        if(adj[0][v].length + adj[1][v].length === 0) {
          break
        }
        var a = cycle[cycle.length-1]
        var b = v
        var c = cycle[1]
        var d = next(a, b, true)
        if(compareAngle(positions[a], positions[b], positions[c], positions[d]) < 0) {
          break
        }
        cycle.push(v)
        u = next(a, b)
      }
      return cycle
    }
  
    function shouldGlue(pcycle, ncycle) {
      return (ncycle[1] === ncycle[ncycle.length-1])
    }
  
    for(var i=0; i<numVertices; ++i) {
      for(var j=0; j<2; ++j) {
        var pcycle = []
        while(adj[j][i].length > 0) {
          var ni = adj[0][i].length
          var ncycle = extractCycle(i,j)
          if(shouldGlue(pcycle, ncycle)) {
            //Glue together trivial cycles
            pcycle.push.apply(pcycle, ncycle)
          } else {
            if(pcycle.length > 0) {
              cycles.push(pcycle)
            }
            pcycle = ncycle
          }
        }
        if(pcycle.length > 0) {
          cycles.push(pcycle)
        }
      }
    }
  
    //Combine paths and loops together
    return cycles
  }
  },{"compare-angle":132}],487:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = trimLeaves
  
  var e2a = _dereq_('edges-to-adjacency-list')
  
  function trimLeaves(edges, positions) {
    var adj = e2a(edges, positions.length)
    var live = new Array(positions.length)
    var nbhd = new Array(positions.length)
  
    var dead = []
    for(var i=0; i<positions.length; ++i) {
      var count = adj[i].length
      nbhd[i] = count
      live[i] = true
      if(count <= 1) {
        dead.push(i)
      }
    }
  
    while(dead.length > 0) {
      var v = dead.pop()
      live[v] = false
      var n = adj[v]
      for(var i=0; i<n.length; ++i) {
        var u = n[i]
        if(--nbhd[u] === 0) {
          dead.push(u)
        }
      }
    }
  
    var newIndex = new Array(positions.length)
    var npositions = []
    for(var i=0; i<positions.length; ++i) {
      if(live[i]) {
        var v = npositions.length
        newIndex[i] = v
        npositions.push(positions[i])
      } else {
        newIndex[i] = -1
      }
    }
  
    var nedges = []
    for(var i=0; i<edges.length; ++i) {
      var e = edges[i]
      if(live[e[0]] && live[e[1]]) {
        nedges.push([ newIndex[e[0]], newIndex[e[1]] ])
      }
    }
    
    return [ nedges, npositions ]
  }
  },{"edges-to-adjacency-list":178}],488:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = planarGraphToPolyline
  
  var e2a = _dereq_('edges-to-adjacency-list')
  var planarDual = _dereq_('planar-dual')
  var preprocessPolygon = _dereq_('point-in-big-polygon')
  var twoProduct = _dereq_('two-product')
  var robustSum = _dereq_('robust-sum')
  var uniq = _dereq_('uniq')
  var trimLeaves = _dereq_('./lib/trim-leaves')
  
  function makeArray(length, fill) {
    var result = new Array(length)
    for(var i=0; i<length; ++i) {
      result[i] = fill
    }
    return result
  }
  
  function makeArrayOfArrays(length) {
    var result = new Array(length)
    for(var i=0; i<length; ++i) {
      result[i] = []
    }
    return result
  }
  
  
  function planarGraphToPolyline(edges, positions) {
  
    //Trim leaves
    var result = trimLeaves(edges, positions)
    edges = result[0]
    positions = result[1]
  
    var numVertices = positions.length
    var numEdges = edges.length
  
    //Calculate adjacency list, check manifold
    var adj = e2a(edges, positions.length)
    for(var i=0; i<numVertices; ++i) {
      if(adj[i].length % 2 === 1) {
        throw new Error('planar-graph-to-polyline: graph must be manifold')
      }
    }
  
    //Get faces
    var faces = planarDual(edges, positions)
  
    //Check orientation of a polygon using exact arithmetic
    function ccw(c) {
      var n = c.length
      var area = [0]
      for(var j=0; j<n; ++j) {
        var a = positions[c[j]]
        var b = positions[c[(j+1)%n]]
        var t00 = twoProduct(-a[0], a[1])
        var t01 = twoProduct(-a[0], b[1])
        var t10 = twoProduct( b[0], a[1])
        var t11 = twoProduct( b[0], b[1])
        area = robustSum(area, robustSum(robustSum(t00, t01), robustSum(t10, t11)))
      }
      return area[area.length-1] > 0
    }
  
    //Extract all clockwise faces
    faces = faces.filter(ccw)
  
    //Detect which loops are contained in one another to handle parent-of relation
    var numFaces = faces.length
    var parent = new Array(numFaces)
    var containment = new Array(numFaces)
    for(var i=0; i<numFaces; ++i) {
      parent[i] = i
      var row = new Array(numFaces)
      var loopVertices = faces[i].map(function(v) {
        return positions[v]
      })
      var pmc = preprocessPolygon([loopVertices])
      var count = 0
      outer:
      for(var j=0; j<numFaces; ++j) {
        row[j] = 0
        if(i === j) {
          continue
        }
        var c = faces[j]
        var n = c.length
        for(var k=0; k<n; ++k) {
          var d = pmc(positions[c[k]])
          if(d !== 0) {
            if(d < 0) {
              row[j] = 1
              count += 1
            }
            continue outer
          }
        }
        row[j] = 1
        count += 1
      }
      containment[i] = [count, i, row]
    }
    containment.sort(function(a,b) {
      return b[0] - a[0]
    })
    for(var i=0; i<numFaces; ++i) {
      var row = containment[i]
      var idx = row[1]
      var children = row[2]
      for(var j=0; j<numFaces; ++j) {
        if(children[j]) {
          parent[j] = idx
        }
      }
    }
  
    //Initialize face adjacency list
    var fadj = makeArrayOfArrays(numFaces)
    for(var i=0; i<numFaces; ++i) {
      fadj[i].push(parent[i])
      fadj[parent[i]].push(i)
    }
  
    //Build adjacency matrix for edges
    var edgeAdjacency = {}
    var internalVertices = makeArray(numVertices, false)
    for(var i=0; i<numFaces; ++i) {
      var c = faces[i]
      var n = c.length
      for(var j=0; j<n; ++j) {
        var a = c[j]
        var b = c[(j+1)%n]
        var key = Math.min(a,b) + ":" + Math.max(a,b)
        if(key in edgeAdjacency) {
          var neighbor = edgeAdjacency[key]
          fadj[neighbor].push(i)
          fadj[i].push(neighbor)
          internalVertices[a] = internalVertices[b] = true
        } else {
          edgeAdjacency[key] = i
        }
      }
    }
  
    function sharedBoundary(c) {
      var n = c.length
      for(var i=0; i<n; ++i) {
        if(!internalVertices[c[i]]) {
          return false
        }
      }
      return true
    }
  
    var toVisit = []
    var parity = makeArray(numFaces, -1)
    for(var i=0; i<numFaces; ++i) {
      if(parent[i] === i && !sharedBoundary(faces[i])) {
        toVisit.push(i)
        parity[i] = 0
      } else {
        parity[i] = -1
      }
    }
  
    //Using face adjacency, classify faces as in/out
    var result = []
    while(toVisit.length > 0) {
      var top = toVisit.pop()
      var nbhd = fadj[top]
      uniq(nbhd, function(a,b) {
        return a-b
      })
      var nnbhr = nbhd.length
      var p = parity[top]
      var polyline
      if(p === 0) {
        var c = faces[top]
        polyline = [c]
      }
      for(var i=0; i<nnbhr; ++i) {
        var f = nbhd[i]
        if(parity[f] >= 0) {
          continue
        }
        parity[f] = p^1
        toVisit.push(f)
        if(p === 0) {
          var c = faces[f]
          if(!sharedBoundary(c)) {
            c.reverse()
            polyline.push(c)
          }
        }
      }
      if(p === 0) {
        result.push(polyline)
      }
    }
  
    return result
  }
  },{"./lib/trim-leaves":487,"edges-to-adjacency-list":178,"planar-dual":486,"point-in-big-polygon":490,"robust-sum":525,"two-product":554,"uniq":569}],489:[function(_dereq_,module,exports){
  arguments[4][243][0].apply(exports,arguments)
  },{"dup":243}],490:[function(_dereq_,module,exports){
  module.exports = preprocessPolygon
  
  var orient = _dereq_('robust-orientation')[3]
  var makeSlabs = _dereq_('slab-decomposition')
  var makeIntervalTree = _dereq_('interval-tree-1d')
  var bsearch = _dereq_('binary-search-bounds')
  
  function visitInterval() {
    return true
  }
  
  function intervalSearch(table) {
    return function(x, y) {
      var tree = table[x]
      if(tree) {
        return !!tree.queryPoint(y, visitInterval)
      }
      return false
    }
  }
  
  function buildVerticalIndex(segments) {
    var table = {}
    for(var i=0; i<segments.length; ++i) {
      var s = segments[i]
      var x = s[0][0]
      var y0 = s[0][1]
      var y1 = s[1][1]
      var p = [ Math.min(y0, y1), Math.max(y0, y1) ]
      if(x in table) {
        table[x].push(p)
      } else {
        table[x] = [ p ]
      }
    }
    var intervalTable = {}
    var keys = Object.keys(table)
    for(var i=0; i<keys.length; ++i) {
      var segs = table[keys[i]]
      intervalTable[keys[i]] = makeIntervalTree(segs)
    }
    return intervalSearch(intervalTable)
  }
  
  function buildSlabSearch(slabs, coordinates) {
    return function(p) {
      var bucket = bsearch.le(coordinates, p[0])
      if(bucket < 0) {
        return 1
      }
      var root = slabs[bucket]
      if(!root) {
        if(bucket > 0 && coordinates[bucket] === p[0]) {
          root = slabs[bucket-1]
        } else {
          return 1
        }
      }
      var lastOrientation = 1
      while(root) {
        var s = root.key
        var o = orient(p, s[0], s[1])
        if(s[0][0] < s[1][0]) {
          if(o < 0) {
            root = root.left
          } else if(o > 0) {
            lastOrientation = -1
            root = root.right
          } else {
            return 0
          }
        } else {
          if(o > 0) {
            root = root.left
          } else if(o < 0) {
            lastOrientation = 1
            root = root.right
          } else {
            return 0
          }
        }
      }
      return lastOrientation
    }
  }
  
  function classifyEmpty(p) {
    return 1
  }
  
  function createClassifyVertical(testVertical) {
    return function classify(p) {
      if(testVertical(p[0], p[1])) {
        return 0
      }
      return 1
    }
  }
  
  function createClassifyPointDegen(testVertical, testNormal) {
    return function classify(p) {
      if(testVertical(p[0], p[1])) {
        return 0
      }
      return testNormal(p)
    }
  }
  
  function preprocessPolygon(loops) {
    //Compute number of loops
    var numLoops = loops.length
  
    //Unpack segments
    var segments = []
    var vsegments = []
    var ptr = 0
    for(var i=0; i<numLoops; ++i) {
      var loop = loops[i]
      var numVertices = loop.length
      for(var s=numVertices-1,t=0; t<numVertices; s=(t++)) {
        var a = loop[s]
        var b = loop[t]
        if(a[0] === b[0]) {
          vsegments.push([a,b])
        } else {
          segments.push([a,b])
        }
      }
    }
  
    //Degenerate case: All loops are empty
    if(segments.length === 0) {
      if(vsegments.length === 0) {
        return classifyEmpty
      } else {
        return createClassifyVertical(buildVerticalIndex(vsegments))
      }
    }
  
    //Build slab decomposition
    var slabs = makeSlabs(segments)
    var testSlab = buildSlabSearch(slabs.slabs, slabs.coordinates)
  
    if(vsegments.length === 0) {
      return testSlab
    } else {
      return createClassifyPointDegen(
        buildVerticalIndex(vsegments),
        testSlab)
    }
  }
  },{"binary-search-bounds":489,"interval-tree-1d":434,"robust-orientation":520,"slab-decomposition":537}],491:[function(_dereq_,module,exports){
  /*
   * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
   * @license MIT
   * @preserve Project Home: https://github.com/voidqk/polybooljs
   */
  
  var BuildLog = _dereq_('./lib/build-log');
  var Epsilon = _dereq_('./lib/epsilon');
  var Intersecter = _dereq_('./lib/intersecter');
  var SegmentChainer = _dereq_('./lib/segment-chainer');
  var SegmentSelector = _dereq_('./lib/segment-selector');
  var GeoJSON = _dereq_('./lib/geojson');
  
  var buildLog = false;
  var epsilon = Epsilon();
  
  var PolyBool;
  PolyBool = {
    // getter/setter for buildLog
    buildLog: function(bl){
      if (bl === true)
        buildLog = BuildLog();
      else if (bl === false)
        buildLog = false;
      return buildLog === false ? false : buildLog.list;
    },
    // getter/setter for epsilon
    epsilon: function(v){
      return epsilon.epsilon(v);
    },
  
    // core API
    segments: function(poly){
      var i = Intersecter(true, epsilon, buildLog);
      poly.regions.forEach(i.addRegion);
      return {
        segments: i.calculate(poly.inverted),
        inverted: poly.inverted
      };
    },
    combine: function(segments1, segments2){
      var i3 = Intersecter(false, epsilon, buildLog);
      return {
        combined: i3.calculate(
          segments1.segments, segments1.inverted,
          segments2.segments, segments2.inverted
        ),
        inverted1: segments1.inverted,
        inverted2: segments2.inverted
      };
    },
    selectUnion: function(combined){
      return {
        segments: SegmentSelector.union(combined.combined, buildLog),
        inverted: combined.inverted1 || combined.inverted2
      }
    },
    selectIntersect: function(combined){
      return {
        segments: SegmentSelector.intersect(combined.combined, buildLog),
        inverted: combined.inverted1 && combined.inverted2
      }
    },
    selectDifference: function(combined){
      return {
        segments: SegmentSelector.difference(combined.combined, buildLog),
        inverted: combined.inverted1 && !combined.inverted2
      }
    },
    selectDifferenceRev: function(combined){
      return {
        segments: SegmentSelector.differenceRev(combined.combined, buildLog),
        inverted: !combined.inverted1 && combined.inverted2
      }
    },
    selectXor: function(combined){
      return {
        segments: SegmentSelector.xor(combined.combined, buildLog),
        inverted: combined.inverted1 !== combined.inverted2
      }
    },
    polygon: function(segments){
      return {
        regions: SegmentChainer(segments.segments, epsilon, buildLog),
        inverted: segments.inverted
      };
    },
  
    // GeoJSON converters
    polygonFromGeoJSON: function(geojson){
      return GeoJSON.toPolygon(PolyBool, geojson);
    },
    polygonToGeoJSON: function(poly){
      return GeoJSON.fromPolygon(PolyBool, epsilon, poly);
    },
  
    // helper functions for common operations
    union: function(poly1, poly2){
      return operate(poly1, poly2, PolyBool.selectUnion);
    },
    intersect: function(poly1, poly2){
      return operate(poly1, poly2, PolyBool.selectIntersect);
    },
    difference: function(poly1, poly2){
      return operate(poly1, poly2, PolyBool.selectDifference);
    },
    differenceRev: function(poly1, poly2){
      return operate(poly1, poly2, PolyBool.selectDifferenceRev);
    },
    xor: function(poly1, poly2){
      return operate(poly1, poly2, PolyBool.selectXor);
    }
  };
  
  function operate(poly1, poly2, selector){
    var seg1 = PolyBool.segments(poly1);
    var seg2 = PolyBool.segments(poly2);
    var comb = PolyBool.combine(seg1, seg2);
    var seg3 = selector(comb);
    return PolyBool.polygon(seg3);
  }
  
  if (typeof window === 'object')
    window.PolyBool = PolyBool;
  
  module.exports = PolyBool;
  
  },{"./lib/build-log":492,"./lib/epsilon":493,"./lib/geojson":494,"./lib/intersecter":495,"./lib/segment-chainer":497,"./lib/segment-selector":498}],492:[function(_dereq_,module,exports){
  // (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
  // MIT License
  // Project Home: https://github.com/voidqk/polybooljs
  
  //
  // used strictly for logging the processing of the algorithm... only useful if you intend on
  // looking under the covers (for pretty UI's or debugging)
  //
  
  function BuildLog(){
    var my;
    var nextSegmentId = 0;
    var curVert = false;
  
    function push(type, data){
      my.list.push({
        type: type,
        data: data ? JSON.parse(JSON.stringify(data)) : void 0
      });
      return my;
    }
  
    my = {
      list: [],
      segmentId: function(){
        return nextSegmentId++;
      },
      checkIntersection: function(seg1, seg2){
        return push('check', { seg1: seg1, seg2: seg2 });
      },
      segmentChop: function(seg, end){
        push('div_seg', { seg: seg, pt: end });
        return push('chop', { seg: seg, pt: end });
      },
      statusRemove: function(seg){
        return push('pop_seg', { seg: seg });
      },
      segmentUpdate: function(seg){
        return push('seg_update', { seg: seg });
      },
      segmentNew: function(seg, primary){
        return push('new_seg', { seg: seg, primary: primary });
      },
      segmentRemove: function(seg){
        return push('rem_seg', { seg: seg });
      },
      tempStatus: function(seg, above, below){
        return push('temp_status', { seg: seg, above: above, below: below });
      },
      rewind: function(seg){
        return push('rewind', { seg: seg });
      },
      status: function(seg, above, below){
        return push('status', { seg: seg, above: above, below: below });
      },
      vert: function(x){
        if (x === curVert)
          return my;
        curVert = x;
        return push('vert', { x: x });
      },
      log: function(data){
        if (typeof data !== 'string')
          data = JSON.stringify(data, false, '  ');
        return push('log', { txt: data });
      },
      reset: function(){
        return push('reset');
      },
      selected: function(segs){
        return push('selected', { segs: segs });
      },
      chainStart: function(seg){
        return push('chain_start', { seg: seg });
      },
      chainRemoveHead: function(index, pt){
        return push('chain_rem_head', { index: index, pt: pt });
      },
      chainRemoveTail: function(index, pt){
        return push('chain_rem_tail', { index: index, pt: pt });
      },
      chainNew: function(pt1, pt2){
        return push('chain_new', { pt1: pt1, pt2: pt2 });
      },
      chainMatch: function(index){
        return push('chain_match', { index: index });
      },
      chainClose: function(index){
        return push('chain_close', { index: index });
      },
      chainAddHead: function(index, pt){
        return push('chain_add_head', { index: index, pt: pt });
      },
      chainAddTail: function(index, pt){
        return push('chain_add_tail', { index: index, pt: pt, });
      },
      chainConnect: function(index1, index2){
        return push('chain_con', { index1: index1, index2: index2 });
      },
      chainReverse: function(index){
        return push('chain_rev', { index: index });
      },
      chainJoin: function(index1, index2){
        return push('chain_join', { index1: index1, index2: index2 });
      },
      done: function(){
        return push('done');
      }
    };
    return my;
  }
  
  module.exports = BuildLog;
  
  },{}],493:[function(_dereq_,module,exports){
  // (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
  // MIT License
  // Project Home: https://github.com/voidqk/polybooljs
  
  //
  // provides the raw computation functions that takes epsilon into account
  //
  // zero is defined to be between (-epsilon, epsilon) exclusive
  //
  
  function Epsilon(eps){
    if (typeof eps !== 'number')
      eps = 0.0000000001; // sane default? sure why not
    var my = {
      epsilon: function(v){
        if (typeof v === 'number')
          eps = v;
        return eps;
      },
      pointAboveOrOnLine: function(pt, left, right){
        var Ax = left[0];
        var Ay = left[1];
        var Bx = right[0];
        var By = right[1];
        var Cx = pt[0];
        var Cy = pt[1];
        return (Bx - Ax) * (Cy - Ay) - (By - Ay) * (Cx - Ax) >= -eps;
      },
      pointBetween: function(p, left, right){
        // p must be collinear with left->right
        // returns false if p == left, p == right, or left == right
        var d_py_ly = p[1] - left[1];
        var d_rx_lx = right[0] - left[0];
        var d_px_lx = p[0] - left[0];
        var d_ry_ly = right[1] - left[1];
  
        var dot = d_px_lx * d_rx_lx + d_py_ly * d_ry_ly;
        // if `dot` is 0, then `p` == `left` or `left` == `right` (reject)
        // if `dot` is less than 0, then `p` is to the left of `left` (reject)
        if (dot < eps)
          return false;
  
        var sqlen = d_rx_lx * d_rx_lx + d_ry_ly * d_ry_ly;
        // if `dot` > `sqlen`, then `p` is to the right of `right` (reject)
        // therefore, if `dot - sqlen` is greater than 0, then `p` is to the right of `right` (reject)
        if (dot - sqlen > -eps)
          return false;
  
        return true;
      },
      pointsSameX: function(p1, p2){
        return Math.abs(p1[0] - p2[0]) < eps;
      },
      pointsSameY: function(p1, p2){
        return Math.abs(p1[1] - p2[1]) < eps;
      },
      pointsSame: function(p1, p2){
        return my.pointsSameX(p1, p2) && my.pointsSameY(p1, p2);
      },
      pointsCompare: function(p1, p2){
        // returns -1 if p1 is smaller, 1 if p2 is smaller, 0 if equal
        if (my.pointsSameX(p1, p2))
          return my.pointsSameY(p1, p2) ? 0 : (p1[1] < p2[1] ? -1 : 1);
        return p1[0] < p2[0] ? -1 : 1;
      },
      pointsCollinear: function(pt1, pt2, pt3){
        // does pt1->pt2->pt3 make a straight line?
        // essentially this is just checking to see if the slope(pt1->pt2) === slope(pt2->pt3)
        // if slopes are equal, then they must be collinear, because they share pt2
        var dx1 = pt1[0] - pt2[0];
        var dy1 = pt1[1] - pt2[1];
        var dx2 = pt2[0] - pt3[0];
        var dy2 = pt2[1] - pt3[1];
        return Math.abs(dx1 * dy2 - dx2 * dy1) < eps;
      },
      linesIntersect: function(a0, a1, b0, b1){
        // returns false if the lines are coincident (e.g., parallel or on top of each other)
        //
        // returns an object if the lines intersect:
        //   {
        //     pt: [x, y],    where the intersection point is at
        //     alongA: where intersection point is along A,
        //     alongB: where intersection point is along B
        //   }
        //
        //  alongA and alongB will each be one of: -2, -1, 0, 1, 2
        //
        //  with the following meaning:
        //
        //    -2   intersection point is before segment's first point
        //    -1   intersection point is directly on segment's first point
        //     0   intersection point is between segment's first and second points (exclusive)
        //     1   intersection point is directly on segment's second point
        //     2   intersection point is after segment's second point
        var adx = a1[0] - a0[0];
        var ady = a1[1] - a0[1];
        var bdx = b1[0] - b0[0];
        var bdy = b1[1] - b0[1];
  
        var axb = adx * bdy - ady * bdx;
        if (Math.abs(axb) < eps)
          return false; // lines are coincident
  
        var dx = a0[0] - b0[0];
        var dy = a0[1] - b0[1];
  
        var A = (bdx * dy - bdy * dx) / axb;
        var B = (adx * dy - ady * dx) / axb;
  
        var ret = {
          alongA: 0,
          alongB: 0,
          pt: [
            a0[0] + A * adx,
            a0[1] + A * ady
          ]
        };
  
        // categorize where intersection point is along A and B
  
        if (A <= -eps)
          ret.alongA = -2;
        else if (A < eps)
          ret.alongA = -1;
        else if (A - 1 <= -eps)
          ret.alongA = 0;
        else if (A - 1 < eps)
          ret.alongA = 1;
        else
          ret.alongA = 2;
  
        if (B <= -eps)
          ret.alongB = -2;
        else if (B < eps)
          ret.alongB = -1;
        else if (B - 1 <= -eps)
          ret.alongB = 0;
        else if (B - 1 < eps)
          ret.alongB = 1;
        else
          ret.alongB = 2;
  
        return ret;
      },
      pointInsideRegion: function(pt, region){
        var x = pt[0];
        var y = pt[1];
        var last_x = region[region.length - 1][0];
        var last_y = region[region.length - 1][1];
        var inside = false;
        for (var i = 0; i < region.length; i++){
          var curr_x = region[i][0];
          var curr_y = region[i][1];
  
          // if y is between curr_y and last_y, and
          // x is to the right of the boundary created by the line
          if ((curr_y - y > eps) != (last_y - y > eps) &&
            (last_x - curr_x) * (y - curr_y) / (last_y - curr_y) + curr_x - x > eps)
            inside = !inside
  
          last_x = curr_x;
          last_y = curr_y;
        }
        return inside;
      }
    };
    return my;
  }
  
  module.exports = Epsilon;
  
  },{}],494:[function(_dereq_,module,exports){
  // (c) Copyright 2017, Sean Connelly (@voidqk), http://syntheti.cc
  // MIT License
  // Project Home: https://github.com/voidqk/polybooljs
  
  //
  // convert between PolyBool polygon format and GeoJSON formats (Polygon and MultiPolygon)
  //
  
  var GeoJSON = {
    // convert a GeoJSON object to a PolyBool polygon
    toPolygon: function(PolyBool, geojson){
  
      // converts list of LineString's to segments
      function GeoPoly(coords){
        // check for empty coords
        if (coords.length <= 0)
          return PolyBool.segments({ inverted: false, regions: [] });
  
        // convert LineString to segments
        function LineString(ls){
          // remove tail which should be the same as head
          var reg = ls.slice(0, ls.length - 1);
          return PolyBool.segments({ inverted: false, regions: [reg] });
        }
  
        // the first LineString is considered the outside
        var out = LineString(coords[0]);
  
        // the rest of the LineStrings are considered interior holes, so subtract them from the
        // current result
        for (var i = 1; i < coords.length; i++)
          out = PolyBool.selectDifference(PolyBool.combine(out, LineString(coords[i])));
  
        return out;
      }
  
      if (geojson.type === 'Polygon'){
        // single polygon, so just convert it and we're done
        return PolyBool.polygon(GeoPoly(geojson.coordinates));
      }
      else if (geojson.type === 'MultiPolygon'){
        // multiple polygons, so union all the polygons together
        var out = PolyBool.segments({ inverted: false, regions: [] });
        for (var i = 0; i < geojson.coordinates.length; i++)
          out = PolyBool.selectUnion(PolyBool.combine(out, GeoPoly(geojson.coordinates[i])));
        return PolyBool.polygon(out);
      }
      throw new Error('PolyBool: Cannot convert GeoJSON object to PolyBool polygon');
    },
  
    // convert a PolyBool polygon to a GeoJSON object
    fromPolygon: function(PolyBool, eps, poly){
      // make sure out polygon is clean
      poly = PolyBool.polygon(PolyBool.segments(poly));
  
      // test if r1 is inside r2
      function regionInsideRegion(r1, r2){
        // we're guaranteed no lines intersect (because the polygon is clean), but a vertex
        // could be on the edge -- so we just average pt[0] and pt[1] to produce a point on the
        // edge of the first line, which cannot be on an edge
        return eps.pointInsideRegion([
          (r1[0][0] + r1[1][0]) * 0.5,
          (r1[0][1] + r1[1][1]) * 0.5
        ], r2);
      }
  
      // calculate inside heirarchy
      //
      //  _____________________   _______    roots -> A       -> F
      // |          A          | |   F   |            |          |
      // |  _______   _______  | |  ___  |            +-- B      +-- G
      // | |   B   | |   C   | | | |   | |            |   |
      // | |  ___  | |  ___  | | | |   | |            |   +-- D
      // | | | D | | | | E | | | | | G | |            |
      // | | |___| | | |___| | | | |   | |            +-- C
      // | |_______| |_______| | | |___| |                |
      // |_____________________| |_______|                +-- E
  
      function newNode(region){
        return {
          region: region,
          children: []
        };
      }
  
      var roots = newNode(null);
  
      function addChild(root, region){
        // first check if we're inside any children
        for (var i = 0; i < root.children.length; i++){
          var child = root.children[i];
          if (regionInsideRegion(region, child.region)){
            // we are, so insert inside them instead
            addChild(child, region);
            return;
          }
        }
  
        // not inside any children, so check to see if any children are inside us
        var node = newNode(region);
        for (var i = 0; i < root.children.length; i++){
          var child = root.children[i];
          if (regionInsideRegion(child.region, region)){
            // oops... move the child beneath us, and remove them from root
            node.children.push(child);
            root.children.splice(i, 1);
            i--;
          }
        }
  
        // now we can add ourselves
        root.children.push(node);
      }
  
      // add all regions to the root
      for (var i = 0; i < poly.regions.length; i++){
        var region = poly.regions[i];
        if (region.length < 3) // regions must have at least 3 points (sanity check)
          continue;
        addChild(roots, region);
      }
  
      // with our heirarchy, we can distinguish between exterior borders, and interior holes
      // the root nodes are exterior, children are interior, children's children are exterior,
      // children's children's children are interior, etc
  
      // while we're at it, exteriors are counter-clockwise, and interiors are clockwise
  
      function forceWinding(region, clockwise){
        // first, see if we're clockwise or counter-clockwise
        // https://en.wikipedia.org/wiki/Shoelace_formula
        var winding = 0;
        var last_x = region[region.length - 1][0];
        var last_y = region[region.length - 1][1];
        var copy = [];
        for (var i = 0; i < region.length; i++){
          var curr_x = region[i][0];
          var curr_y = region[i][1];
          copy.push([curr_x, curr_y]); // create a copy while we're at it
          winding += curr_y * last_x - curr_x * last_y;
          last_x = curr_x;
          last_y = curr_y;
        }
        // this assumes Cartesian coordinates (Y is positive going up)
        var isclockwise = winding < 0;
        if (isclockwise !== clockwise)
          copy.reverse();
        // while we're here, the last point must be the first point...
        copy.push([copy[0][0], copy[0][1]]);
        return copy;
      }
  
      var geopolys = [];
  
      function addExterior(node){
        var poly = [forceWinding(node.region, false)];
        geopolys.push(poly);
        // children of exteriors are interior
        for (var i = 0; i < node.children.length; i++)
          poly.push(getInterior(node.children[i]));
      }
  
      function getInterior(node){
        // children of interiors are exterior
        for (var i = 0; i < node.children.length; i++)
          addExterior(node.children[i]);
        // return the clockwise interior
        return forceWinding(node.region, true);
      }
  
      // root nodes are exterior
      for (var i = 0; i < roots.children.length; i++)
        addExterior(roots.children[i]);
  
      // lastly, construct the approrpriate GeoJSON object
  
      if (geopolys.length <= 0) // empty GeoJSON Polygon
        return { type: 'Polygon', coordinates: [] };
      if (geopolys.length == 1) // use a GeoJSON Polygon
        return { type: 'Polygon', coordinates: geopolys[0] };
      return { // otherwise, use a GeoJSON MultiPolygon
        type: 'MultiPolygon',
        coordinates: geopolys
      };
    }
  };
  
  module.exports = GeoJSON;
  
  },{}],495:[function(_dereq_,module,exports){
  // (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
  // MIT License
  // Project Home: https://github.com/voidqk/polybooljs
  
  //
  // this is the core work-horse
  //
  
  var LinkedList = _dereq_('./linked-list');
  
  function Intersecter(selfIntersection, eps, buildLog){
    // selfIntersection is true/false depending on the phase of the overall algorithm
  
    //
    // segment creation
    //
  
    function segmentNew(start, end){
      return {
        id: buildLog ? buildLog.segmentId() : -1,
        start: start,
        end: end,
        myFill: {
          above: null, // is there fill above us?
          below: null  // is there fill below us?
        },
        otherFill: null
      };
    }
  
    function segmentCopy(start, end, seg){
      return {
        id: buildLog ? buildLog.segmentId() : -1,
        start: start,
        end: end,
        myFill: {
          above: seg.myFill.above,
          below: seg.myFill.below
        },
        otherFill: null
      };
    }
  
    //
    // event logic
    //
  
    var event_root = LinkedList.create();
  
    function eventCompare(p1_isStart, p1_1, p1_2, p2_isStart, p2_1, p2_2){
      // compare the selected points first
      var comp = eps.pointsCompare(p1_1, p2_1);
      if (comp !== 0)
        return comp;
      // the selected points are the same
  
      if (eps.pointsSame(p1_2, p2_2)) // if the non-selected points are the same too...
        return 0; // then the segments are equal
  
      if (p1_isStart !== p2_isStart) // if one is a start and the other isn't...
        return p1_isStart ? 1 : -1; // favor the one that isn't the start
  
      // otherwise, we'll have to calculate which one is below the other manually
      return eps.pointAboveOrOnLine(p1_2,
        p2_isStart ? p2_1 : p2_2, // order matters
        p2_isStart ? p2_2 : p2_1
      ) ? 1 : -1;
    }
  
    function eventAdd(ev, other_pt){
      event_root.insertBefore(ev, function(here){
        // should ev be inserted before here?
        var comp = eventCompare(
          ev  .isStart, ev  .pt,      other_pt,
          here.isStart, here.pt, here.other.pt
        );
        return comp < 0;
      });
    }
  
    function eventAddSegmentStart(seg, primary){
      var ev_start = LinkedList.node({
        isStart: true,
        pt: seg.start,
        seg: seg,
        primary: primary,
        other: null,
        status: null
      });
      eventAdd(ev_start, seg.end);
      return ev_start;
    }
  
    function eventAddSegmentEnd(ev_start, seg, primary){
      var ev_end = LinkedList.node({
        isStart: false,
        pt: seg.end,
        seg: seg,
        primary: primary,
        other: ev_start,
        status: null
      });
      ev_start.other = ev_end;
      eventAdd(ev_end, ev_start.pt);
    }
  
    function eventAddSegment(seg, primary){
      var ev_start = eventAddSegmentStart(seg, primary);
      eventAddSegmentEnd(ev_start, seg, primary);
      return ev_start;
    }
  
    function eventUpdateEnd(ev, end){
      // slides an end backwards
      //   (start)------------(end)    to:
      //   (start)---(end)
  
      if (buildLog)
        buildLog.segmentChop(ev.seg, end);
  
      ev.other.remove();
      ev.seg.end = end;
      ev.other.pt = end;
      eventAdd(ev.other, ev.pt);
    }
  
    function eventDivide(ev, pt){
      var ns = segmentCopy(pt, ev.seg.end, ev.seg);
      eventUpdateEnd(ev, pt);
      return eventAddSegment(ns, ev.primary);
    }
  
    function calculate(primaryPolyInverted, secondaryPolyInverted){
      // if selfIntersection is true then there is no secondary polygon, so that isn't used
  
      //
      // status logic
      //
  
      var status_root = LinkedList.create();
  
      function statusCompare(ev1, ev2){
        var a1 = ev1.seg.start;
        var a2 = ev1.seg.end;
        var b1 = ev2.seg.start;
        var b2 = ev2.seg.end;
  
        if (eps.pointsCollinear(a1, b1, b2)){
          if (eps.pointsCollinear(a2, b1, b2))
            return 1;//eventCompare(true, a1, a2, true, b1, b2);
          return eps.pointAboveOrOnLine(a2, b1, b2) ? 1 : -1;
        }
        return eps.pointAboveOrOnLine(a1, b1, b2) ? 1 : -1;
      }
  
      function statusFindSurrounding(ev){
        return status_root.findTransition(function(here){
          var comp = statusCompare(ev, here.ev);
          return comp > 0;
        });
      }
  
      function checkIntersection(ev1, ev2){
        // returns the segment equal to ev1, or false if nothing equal
  
        var seg1 = ev1.seg;
        var seg2 = ev2.seg;
        var a1 = seg1.start;
        var a2 = seg1.end;
        var b1 = seg2.start;
        var b2 = seg2.end;
  
        if (buildLog)
          buildLog.checkIntersection(seg1, seg2);
  
        var i = eps.linesIntersect(a1, a2, b1, b2);
  
        if (i === false){
          // segments are parallel or coincident
  
          // if points aren't collinear, then the segments are parallel, so no intersections
          if (!eps.pointsCollinear(a1, a2, b1))
            return false;
          // otherwise, segments are on top of each other somehow (aka coincident)
  
          if (eps.pointsSame(a1, b2) || eps.pointsSame(a2, b1))
            return false; // segments touch at endpoints... no intersection
  
          var a1_equ_b1 = eps.pointsSame(a1, b1);
          var a2_equ_b2 = eps.pointsSame(a2, b2);
  
          if (a1_equ_b1 && a2_equ_b2)
            return ev2; // segments are exactly equal
  
          var a1_between = !a1_equ_b1 && eps.pointBetween(a1, b1, b2);
          var a2_between = !a2_equ_b2 && eps.pointBetween(a2, b1, b2);
  
          // handy for debugging:
          // buildLog.log({
          //	a1_equ_b1: a1_equ_b1,
          //	a2_equ_b2: a2_equ_b2,
          //	a1_between: a1_between,
          //	a2_between: a2_between
          // });
  
          if (a1_equ_b1){
            if (a2_between){
              //  (a1)---(a2)
              //  (b1)----------(b2)
              eventDivide(ev2, a2);
            }
            else{
              //  (a1)----------(a2)
              //  (b1)---(b2)
              eventDivide(ev1, b2);
            }
            return ev2;
          }
          else if (a1_between){
            if (!a2_equ_b2){
              // make a2 equal to b2
              if (a2_between){
                //         (a1)---(a2)
                //  (b1)-----------------(b2)
                eventDivide(ev2, a2);
              }
              else{
                //         (a1)----------(a2)
                //  (b1)----------(b2)
                eventDivide(ev1, b2);
              }
            }
  
            //         (a1)---(a2)
            //  (b1)----------(b2)
            eventDivide(ev2, a1);
          }
        }
        else{
          // otherwise, lines intersect at i.pt, which may or may not be between the endpoints
  
          // is A divided between its endpoints? (exclusive)
          if (i.alongA === 0){
            if (i.alongB === -1) // yes, at exactly b1
              eventDivide(ev1, b1);
            else if (i.alongB === 0) // yes, somewhere between B's endpoints
              eventDivide(ev1, i.pt);
            else if (i.alongB === 1) // yes, at exactly b2
              eventDivide(ev1, b2);
          }
  
          // is B divided between its endpoints? (exclusive)
          if (i.alongB === 0){
            if (i.alongA === -1) // yes, at exactly a1
              eventDivide(ev2, a1);
            else if (i.alongA === 0) // yes, somewhere between A's endpoints (exclusive)
              eventDivide(ev2, i.pt);
            else if (i.alongA === 1) // yes, at exactly a2
              eventDivide(ev2, a2);
          }
        }
        return false;
      }
  
      //
      // main event loop
      //
      var segments = [];
      while (!event_root.isEmpty()){
        var ev = event_root.getHead();
  
        if (buildLog)
          buildLog.vert(ev.pt[0]);
  
        if (ev.isStart){
  
          if (buildLog)
            buildLog.segmentNew(ev.seg, ev.primary);
  
          var surrounding = statusFindSurrounding(ev);
          var above = surrounding.before ? surrounding.before.ev : null;
          var below = surrounding.after ? surrounding.after.ev : null;
  
          if (buildLog){
            buildLog.tempStatus(
              ev.seg,
              above ? above.seg : false,
              below ? below.seg : false
            );
          }
  
          function checkBothIntersections(){
            if (above){
              var eve = checkIntersection(ev, above);
              if (eve)
                return eve;
            }
            if (below)
              return checkIntersection(ev, below);
            return false;
          }
  
          var eve = checkBothIntersections();
          if (eve){
            // ev and eve are equal
            // we'll keep eve and throw away ev
  
            // merge ev.seg's fill information into eve.seg
  
            if (selfIntersection){
              var toggle; // are we a toggling edge?
              if (ev.seg.myFill.below === null)
                toggle = true;
              else
                toggle = ev.seg.myFill.above !== ev.seg.myFill.below;
  
              // merge two segments that belong to the same polygon
              // think of this as sandwiching two segments together, where `eve.seg` is
              // the bottom -- this will cause the above fill flag to toggle
              if (toggle)
                eve.seg.myFill.above = !eve.seg.myFill.above;
            }
            else{
              // merge two segments that belong to different polygons
              // each segment has distinct knowledge, so no special logic is needed
              // note that this can only happen once per segment in this phase, because we
              // are guaranteed that all self-intersections are gone
              eve.seg.otherFill = ev.seg.myFill;
            }
  
            if (buildLog)
              buildLog.segmentUpdate(eve.seg);
  
            ev.other.remove();
            ev.remove();
          }
  
          if (event_root.getHead() !== ev){
            // something was inserted before us in the event queue, so loop back around and
            // process it before continuing
            if (buildLog)
              buildLog.rewind(ev.seg);
            continue;
          }
  
          //
          // calculate fill flags
          //
          if (selfIntersection){
            var toggle; // are we a toggling edge?
            if (ev.seg.myFill.below === null) // if we are a new segment...
              toggle = true; // then we toggle
            else // we are a segment that has previous knowledge from a division
              toggle = ev.seg.myFill.above !== ev.seg.myFill.below; // calculate toggle
  
            // next, calculate whether we are filled below us
            if (!below){ // if nothing is below us...
              // we are filled below us if the polygon is inverted
              ev.seg.myFill.below = primaryPolyInverted;
            }
            else{
              // otherwise, we know the answer -- it's the same if whatever is below
              // us is filled above it
              ev.seg.myFill.below = below.seg.myFill.above;
            }
  
            // since now we know if we're filled below us, we can calculate whether
            // we're filled above us by applying toggle to whatever is below us
            if (toggle)
              ev.seg.myFill.above = !ev.seg.myFill.below;
            else
              ev.seg.myFill.above = ev.seg.myFill.below;
          }
          else{
            // now we fill in any missing transition information, since we are all-knowing
            // at this point
  
            if (ev.seg.otherFill === null){
              // if we don't have other information, then we need to figure out if we're
              // inside the other polygon
              var inside;
              if (!below){
                // if nothing is below us, then we're inside if the other polygon is
                // inverted
                inside =
                  ev.primary ? secondaryPolyInverted : primaryPolyInverted;
              }
              else{ // otherwise, something is below us
                // so copy the below segment's other polygon's above
                if (ev.primary === below.primary)
                  inside = below.seg.otherFill.above;
                else
                  inside = below.seg.myFill.above;
              }
              ev.seg.otherFill = {
                above: inside,
                below: inside
              };
            }
          }
  
          if (buildLog){
            buildLog.status(
              ev.seg,
              above ? above.seg : false,
              below ? below.seg : false
            );
          }
  
          // insert the status and remember it for later removal
          ev.other.status = surrounding.insert(LinkedList.node({ ev: ev }));
        }
        else{
          var st = ev.status;
  
          if (st === null){
            throw new Error('PolyBool: Zero-length segment detected; your epsilon is ' +
              'probably too small or too large');
          }
  
          // removing the status will create two new adjacent edges, so we'll need to check
          // for those
          if (status_root.exists(st.prev) && status_root.exists(st.next))
            checkIntersection(st.prev.ev, st.next.ev);
  
          if (buildLog)
            buildLog.statusRemove(st.ev.seg);
  
          // remove the status
          st.remove();
  
          // if we've reached this point, we've calculated everything there is to know, so
          // save the segment for reporting
          if (!ev.primary){
            // make sure `seg.myFill` actually points to the primary polygon though
            var s = ev.seg.myFill;
            ev.seg.myFill = ev.seg.otherFill;
            ev.seg.otherFill = s;
          }
          segments.push(ev.seg);
        }
  
        // remove the event and continue
        event_root.getHead().remove();
      }
  
      if (buildLog)
        buildLog.done();
  
      return segments;
    }
  
    // return the appropriate API depending on what we're doing
    if (!selfIntersection){
      // performing combination of polygons, so only deal with already-processed segments
      return {
        calculate: function(segments1, inverted1, segments2, inverted2){
          // segmentsX come from the self-intersection API, or this API
          // invertedX is whether we treat that list of segments as an inverted polygon or not
          // returns segments that can be used for further operations
          segments1.forEach(function(seg){
            eventAddSegment(segmentCopy(seg.start, seg.end, seg), true);
          });
          segments2.forEach(function(seg){
            eventAddSegment(segmentCopy(seg.start, seg.end, seg), false);
          });
          return calculate(inverted1, inverted2);
        }
      };
    }
  
    // otherwise, performing self-intersection, so deal with regions
    return {
      addRegion: function(region){
        // regions are a list of points:
        //  [ [0, 0], [100, 0], [50, 100] ]
        // you can add multiple regions before running calculate
        var pt1;
        var pt2 = region[region.length - 1];
        for (var i = 0; i < region.length; i++){
          pt1 = pt2;
          pt2 = region[i];
  
          var forward = eps.pointsCompare(pt1, pt2);
          if (forward === 0) // points are equal, so we have a zero-length segment
            continue; // just skip it
  
          eventAddSegment(
            segmentNew(
              forward < 0 ? pt1 : pt2,
              forward < 0 ? pt2 : pt1
            ),
            true
          );
        }
      },
      calculate: function(inverted){
        // is the polygon inverted?
        // returns segments
        return calculate(inverted, false);
      }
    };
  }
  
  module.exports = Intersecter;
  
  },{"./linked-list":496}],496:[function(_dereq_,module,exports){
  // (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
  // MIT License
  // Project Home: https://github.com/voidqk/polybooljs
  
  //
  // simple linked list implementation that allows you to traverse down nodes and save positions
  //
  
  var LinkedList = {
    create: function(){
      var my = {
        root: { root: true, next: null },
        exists: function(node){
          if (node === null || node === my.root)
            return false;
          return true;
        },
        isEmpty: function(){
          return my.root.next === null;
        },
        getHead: function(){
          return my.root.next;
        },
        insertBefore: function(node, check){
          var last = my.root;
          var here = my.root.next;
          while (here !== null){
            if (check(here)){
              node.prev = here.prev;
              node.next = here;
              here.prev.next = node;
              here.prev = node;
              return;
            }
            last = here;
            here = here.next;
          }
          last.next = node;
          node.prev = last;
          node.next = null;
        },
        findTransition: function(check){
          var prev = my.root;
          var here = my.root.next;
          while (here !== null){
            if (check(here))
              break;
            prev = here;
            here = here.next;
          }
          return {
            before: prev === my.root ? null : prev,
            after: here,
            insert: function(node){
              node.prev = prev;
              node.next = here;
              prev.next = node;
              if (here !== null)
                here.prev = node;
              return node;
            }
          };
        }
      };
      return my;
    },
    node: function(data){
      data.prev = null;
      data.next = null;
      data.remove = function(){
        data.prev.next = data.next;
        if (data.next)
          data.next.prev = data.prev;
        data.prev = null;
        data.next = null;
      };
      return data;
    }
  };
  
  module.exports = LinkedList;
  
  },{}],497:[function(_dereq_,module,exports){
  // (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
  // MIT License
  // Project Home: https://github.com/voidqk/polybooljs
  
  //
  // converts a list of segments into a list of regions, while also removing unnecessary verticies
  //
  
  function SegmentChainer(segments, eps, buildLog){
    var chains = [];
    var regions = [];
  
    segments.forEach(function(seg){
      var pt1 = seg.start;
      var pt2 = seg.end;
      if (eps.pointsSame(pt1, pt2)){
        console.warn('PolyBool: Warning: Zero-length segment detected; your epsilon is ' +
          'probably too small or too large');
        return;
      }
  
      if (buildLog)
        buildLog.chainStart(seg);
  
      // search for two chains that this segment matches
      var first_match = {
        index: 0,
        matches_head: false,
        matches_pt1: false
      };
      var second_match = {
        index: 0,
        matches_head: false,
        matches_pt1: false
      };
      var next_match = first_match;
      function setMatch(index, matches_head, matches_pt1){
        // return true if we've matched twice
        next_match.index = index;
        next_match.matches_head = matches_head;
        next_match.matches_pt1 = matches_pt1;
        if (next_match === first_match){
          next_match = second_match;
          return false;
        }
        next_match = null;
        return true; // we've matched twice, we're done here
      }
      for (var i = 0; i < chains.length; i++){
        var chain = chains[i];
        var head  = chain[0];
        var head2 = chain[1];
        var tail  = chain[chain.length - 1];
        var tail2 = chain[chain.length - 2];
        if (eps.pointsSame(head, pt1)){
          if (setMatch(i, true, true))
            break;
        }
        else if (eps.pointsSame(head, pt2)){
          if (setMatch(i, true, false))
            break;
        }
        else if (eps.pointsSame(tail, pt1)){
          if (setMatch(i, false, true))
            break;
        }
        else if (eps.pointsSame(tail, pt2)){
          if (setMatch(i, false, false))
            break;
        }
      }
  
      if (next_match === first_match){
        // we didn't match anything, so create a new chain
        chains.push([ pt1, pt2 ]);
        if (buildLog)
          buildLog.chainNew(pt1, pt2);
        return;
      }
  
      if (next_match === second_match){
        // we matched a single chain
  
        if (buildLog)
          buildLog.chainMatch(first_match.index);
  
        // add the other point to the apporpriate end, and check to see if we've closed the
        // chain into a loop
  
        var index = first_match.index;
        var pt = first_match.matches_pt1 ? pt2 : pt1; // if we matched pt1, then we add pt2, etc
        var addToHead = first_match.matches_head; // if we matched at head, then add to the head
  
        var chain = chains[index];
        var grow  = addToHead ? chain[0] : chain[chain.length - 1];
        var grow2 = addToHead ? chain[1] : chain[chain.length - 2];
        var oppo  = addToHead ? chain[chain.length - 1] : chain[0];
        var oppo2 = addToHead ? chain[chain.length - 2] : chain[1];
  
        if (eps.pointsCollinear(grow2, grow, pt)){
          // grow isn't needed because it's directly between grow2 and pt:
          // grow2 ---grow---> pt
          if (addToHead){
            if (buildLog)
              buildLog.chainRemoveHead(first_match.index, pt);
            chain.shift();
          }
          else{
            if (buildLog)
              buildLog.chainRemoveTail(first_match.index, pt);
            chain.pop();
          }
          grow = grow2; // old grow is gone... new grow is what grow2 was
        }
  
        if (eps.pointsSame(oppo, pt)){
          // we're closing the loop, so remove chain from chains
          chains.splice(index, 1);
  
          if (eps.pointsCollinear(oppo2, oppo, grow)){
            // oppo isn't needed because it's directly between oppo2 and grow:
            // oppo2 ---oppo--->grow
            if (addToHead){
              if (buildLog)
                buildLog.chainRemoveTail(first_match.index, grow);
              chain.pop();
            }
            else{
              if (buildLog)
                buildLog.chainRemoveHead(first_match.index, grow);
              chain.shift();
            }
          }
  
          if (buildLog)
            buildLog.chainClose(first_match.index);
  
          // we have a closed chain!
          regions.push(chain);
          return;
        }
  
        // not closing a loop, so just add it to the apporpriate side
        if (addToHead){
          if (buildLog)
            buildLog.chainAddHead(first_match.index, pt);
          chain.unshift(pt);
        }
        else{
          if (buildLog)
            buildLog.chainAddTail(first_match.index, pt);
          chain.push(pt);
        }
        return;
      }
  
      // otherwise, we matched two chains, so we need to combine those chains together
  
      function reverseChain(index){
        if (buildLog)
          buildLog.chainReverse(index);
        chains[index].reverse(); // gee, that's easy
      }
  
      function appendChain(index1, index2){
        // index1 gets index2 appended to it, and index2 is removed
        var chain1 = chains[index1];
        var chain2 = chains[index2];
        var tail  = chain1[chain1.length - 1];
        var tail2 = chain1[chain1.length - 2];
        var head  = chain2[0];
        var head2 = chain2[1];
  
        if (eps.pointsCollinear(tail2, tail, head)){
          // tail isn't needed because it's directly between tail2 and head
          // tail2 ---tail---> head
          if (buildLog)
            buildLog.chainRemoveTail(index1, tail);
          chain1.pop();
          tail = tail2; // old tail is gone... new tail is what tail2 was
        }
  
        if (eps.pointsCollinear(tail, head, head2)){
          // head isn't needed because it's directly between tail and head2
          // tail ---head---> head2
          if (buildLog)
            buildLog.chainRemoveHead(index2, head);
          chain2.shift();
        }
  
        if (buildLog)
          buildLog.chainJoin(index1, index2);
        chains[index1] = chain1.concat(chain2);
        chains.splice(index2, 1);
      }
  
      var F = first_match.index;
      var S = second_match.index;
  
      if (buildLog)
        buildLog.chainConnect(F, S);
  
      var reverseF = chains[F].length < chains[S].length; // reverse the shorter chain, if needed
      if (first_match.matches_head){
        if (second_match.matches_head){
          if (reverseF){
            // <<<< F <<<< --- >>>> S >>>>
            reverseChain(F);
            // >>>> F >>>> --- >>>> S >>>>
            appendChain(F, S);
          }
          else{
            // <<<< F <<<< --- >>>> S >>>>
            reverseChain(S);
            // <<<< F <<<< --- <<<< S <<<<   logically same as:
            // >>>> S >>>> --- >>>> F >>>>
            appendChain(S, F);
          }
        }
        else{
          // <<<< F <<<< --- <<<< S <<<<   logically same as:
          // >>>> S >>>> --- >>>> F >>>>
          appendChain(S, F);
        }
      }
      else{
        if (second_match.matches_head){
          // >>>> F >>>> --- >>>> S >>>>
          appendChain(F, S);
        }
        else{
          if (reverseF){
            // >>>> F >>>> --- <<<< S <<<<
            reverseChain(F);
            // <<<< F <<<< --- <<<< S <<<<   logically same as:
            // >>>> S >>>> --- >>>> F >>>>
            appendChain(S, F);
          }
          else{
            // >>>> F >>>> --- <<<< S <<<<
            reverseChain(S);
            // >>>> F >>>> --- >>>> S >>>>
            appendChain(F, S);
          }
        }
      }
    });
  
    return regions;
  }
  
  module.exports = SegmentChainer;
  
  },{}],498:[function(_dereq_,module,exports){
  // (c) Copyright 2016, Sean Connelly (@voidqk), http://syntheti.cc
  // MIT License
  // Project Home: https://github.com/voidqk/polybooljs
  
  //
  // filter a list of segments based on boolean operations
  //
  
  function select(segments, selection, buildLog){
    var result = [];
    segments.forEach(function(seg){
      var index =
        (seg.myFill.above ? 8 : 0) +
        (seg.myFill.below ? 4 : 0) +
        ((seg.otherFill && seg.otherFill.above) ? 2 : 0) +
        ((seg.otherFill && seg.otherFill.below) ? 1 : 0);
      if (selection[index] !== 0){
        // copy the segment to the results, while also calculating the fill status
        result.push({
          id: buildLog ? buildLog.segmentId() : -1,
          start: seg.start,
          end: seg.end,
          myFill: {
            above: selection[index] === 1, // 1 if filled above
            below: selection[index] === 2  // 2 if filled below
          },
          otherFill: null
        });
      }
    });
  
    if (buildLog)
      buildLog.selected(result);
  
    return result;
  }
  
  var SegmentSelector = {
    union: function(segments, buildLog){ // primary | secondary
      // above1 below1 above2 below2    Keep?               Value
      //    0      0      0      0   =>   no                  0
      //    0      0      0      1   =>   yes filled below    2
      //    0      0      1      0   =>   yes filled above    1
      //    0      0      1      1   =>   no                  0
      //    0      1      0      0   =>   yes filled below    2
      //    0      1      0      1   =>   yes filled below    2
      //    0      1      1      0   =>   no                  0
      //    0      1      1      1   =>   no                  0
      //    1      0      0      0   =>   yes filled above    1
      //    1      0      0      1   =>   no                  0
      //    1      0      1      0   =>   yes filled above    1
      //    1      0      1      1   =>   no                  0
      //    1      1      0      0   =>   no                  0
      //    1      1      0      1   =>   no                  0
      //    1      1      1      0   =>   no                  0
      //    1      1      1      1   =>   no                  0
      return select(segments, [
        0, 2, 1, 0,
        2, 2, 0, 0,
        1, 0, 1, 0,
        0, 0, 0, 0
      ], buildLog);
    },
    intersect: function(segments, buildLog){ // primary & secondary
      // above1 below1 above2 below2    Keep?               Value
      //    0      0      0      0   =>   no                  0
      //    0      0      0      1   =>   no                  0
      //    0      0      1      0   =>   no                  0
      //    0      0      1      1   =>   no                  0
      //    0      1      0      0   =>   no                  0
      //    0      1      0      1   =>   yes filled below    2
      //    0      1      1      0   =>   no                  0
      //    0      1      1      1   =>   yes filled below    2
      //    1      0      0      0   =>   no                  0
      //    1      0      0      1   =>   no                  0
      //    1      0      1      0   =>   yes filled above    1
      //    1      0      1      1   =>   yes filled above    1
      //    1      1      0      0   =>   no                  0
      //    1      1      0      1   =>   yes filled below    2
      //    1      1      1      0   =>   yes filled above    1
      //    1      1      1      1   =>   no                  0
      return select(segments, [
        0, 0, 0, 0,
        0, 2, 0, 2,
        0, 0, 1, 1,
        0, 2, 1, 0
      ], buildLog);
    },
    difference: function(segments, buildLog){ // primary - secondary
      // above1 below1 above2 below2    Keep?               Value
      //    0      0      0      0   =>   no                  0
      //    0      0      0      1   =>   no                  0
      //    0      0      1      0   =>   no                  0
      //    0      0      1      1   =>   no                  0
      //    0      1      0      0   =>   yes filled below    2
      //    0      1      0      1   =>   no                  0
      //    0      1      1      0   =>   yes filled below    2
      //    0      1      1      1   =>   no                  0
      //    1      0      0      0   =>   yes filled above    1
      //    1      0      0      1   =>   yes filled above    1
      //    1      0      1      0   =>   no                  0
      //    1      0      1      1   =>   no                  0
      //    1      1      0      0   =>   no                  0
      //    1      1      0      1   =>   yes filled above    1
      //    1      1      1      0   =>   yes filled below    2
      //    1      1      1      1   =>   no                  0
      return select(segments, [
        0, 0, 0, 0,
        2, 0, 2, 0,
        1, 1, 0, 0,
        0, 1, 2, 0
      ], buildLog);
    },
    differenceRev: function(segments, buildLog){ // secondary - primary
      // above1 below1 above2 below2    Keep?               Value
      //    0      0      0      0   =>   no                  0
      //    0      0      0      1   =>   yes filled below    2
      //    0      0      1      0   =>   yes filled above    1
      //    0      0      1      1   =>   no                  0
      //    0      1      0      0   =>   no                  0
      //    0      1      0      1   =>   no                  0
      //    0      1      1      0   =>   yes filled above    1
      //    0      1      1      1   =>   yes filled above    1
      //    1      0      0      0   =>   no                  0
      //    1      0      0      1   =>   yes filled below    2
      //    1      0      1      0   =>   no                  0
      //    1      0      1      1   =>   yes filled below    2
      //    1      1      0      0   =>   no                  0
      //    1      1      0      1   =>   no                  0
      //    1      1      1      0   =>   no                  0
      //    1      1      1      1   =>   no                  0
      return select(segments, [
        0, 2, 1, 0,
        0, 0, 1, 1,
        0, 2, 0, 2,
        0, 0, 0, 0
      ], buildLog);
    },
    xor: function(segments, buildLog){ // primary ^ secondary
      // above1 below1 above2 below2    Keep?               Value
      //    0      0      0      0   =>   no                  0
      //    0      0      0      1   =>   yes filled below    2
      //    0      0      1      0   =>   yes filled above    1
      //    0      0      1      1   =>   no                  0
      //    0      1      0      0   =>   yes filled below    2
      //    0      1      0      1   =>   no                  0
      //    0      1      1      0   =>   no                  0
      //    0      1      1      1   =>   yes filled above    1
      //    1      0      0      0   =>   yes filled above    1
      //    1      0      0      1   =>   no                  0
      //    1      0      1      0   =>   no                  0
      //    1      0      1      1   =>   yes filled below    2
      //    1      1      0      0   =>   no                  0
      //    1      1      0      1   =>   yes filled above    1
      //    1      1      1      0   =>   yes filled below    2
      //    1      1      1      1   =>   no                  0
      return select(segments, [
        0, 2, 1, 0,
        2, 0, 0, 1,
        1, 0, 0, 2,
        0, 1, 2, 0
      ], buildLog);
    }
  };
  
  module.exports = SegmentSelector;
  
  },{}],499:[function(_dereq_,module,exports){
  //Optimized version for triangle closest point
  // Based on Eberly's WildMagick codes
  // http://www.geometrictools.com/LibMathematics/Distance/Distance.html
  "use strict";
  
  var diff = new Float64Array(4);
  var edge0 = new Float64Array(4);
  var edge1 = new Float64Array(4);
  
  function closestPoint2d(V0, V1, V2, point, result) {
    //Reallocate buffers if necessary
    if(diff.length < point.length) {
      diff = new Float64Array(point.length);
      edge0 = new Float64Array(point.length);
      edge1 = new Float64Array(point.length);
    }
    //Compute edges
    for(var i=0; i<point.length; ++i) {
      diff[i]  = V0[i] - point[i];
      edge0[i] = V1[i] - V0[i];
      edge1[i] = V2[i] - V0[i];
    }
    //Compute coefficients for quadratic func
    var a00 = 0.0
      , a01 = 0.0
      , a11 = 0.0
      , b0  = 0.0
      , b1  = 0.0
      , c   = 0.0;
    for(var i=0; i<point.length; ++i) {
      var e0 = edge0[i]
        , e1 = edge1[i]
        , d  = diff[i];
      a00 += e0 * e0;
      a01 += e0 * e1;
      a11 += e1 * e1;
      b0  += d * e0;
      b1  += d * e1;
      c   += d * d;
    }
    //Compute determinant/coeffs
    var det = Math.abs(a00*a11 - a01*a01);
    var s   = a01*b1 - a11*b0;
    var t   = a01*b0 - a00*b1;
    var sqrDistance;
    //Hardcoded Voronoi diagram classification
    if (s + t <= det) {
      if (s < 0) {
        if (t < 0) { // region 4
          if (b0 < 0) {
            t = 0;
            if (-b0 >= a00) {
              s = 1.0;
              sqrDistance = a00 + 2.0*b0 + c;
            } else {
              s = -b0/a00;
              sqrDistance = b0*s + c;
            }
          } else {
            s = 0;
            if (b1 >= 0) {
              t = 0;
              sqrDistance = c;
            } else if (-b1 >= a11) {
              t = 1;
              sqrDistance = a11 + 2.0*b1 + c;
            } else {
              t = -b1/a11;
              sqrDistance = b1*t + c;
            }
          }
        } else {  // region 3
          s = 0;
          if (b1 >= 0) {
            t = 0;
            sqrDistance = c;
          } else if (-b1 >= a11) {
            t = 1;
            sqrDistance = a11 + 2.0*b1 + c;
          } else {
            t = -b1/a11;
            sqrDistance = b1*t + c;
          }
        }
      } else if (t < 0) { // region 5
        t = 0;
        if (b0 >= 0) {
          s = 0;
          sqrDistance = c;
        } else if (-b0 >= a00) {
          s = 1;
          sqrDistance = a00 + 2.0*b0 + c;
        } else {
          s = -b0/a00;
          sqrDistance = b0*s + c;
        }
      } else {  // region 0
        // minimum at interior point
        var invDet = 1.0 / det;
        s *= invDet;
        t *= invDet;
        sqrDistance = s*(a00*s + a01*t + 2.0*b0) + t*(a01*s + a11*t + 2.0*b1) + c;
      }
    } else {
      var tmp0, tmp1, numer, denom;
      
      if (s < 0) {  // region 2
        tmp0 = a01 + b0;
        tmp1 = a11 + b1;
        if (tmp1 > tmp0) {
          numer = tmp1 - tmp0;
          denom = a00 - 2.0*a01 + a11;
          if (numer >= denom) {
            s = 1;
            t = 0;
            sqrDistance = a00 + 2.0*b0 + c;
          } else {
            s = numer/denom;
            t = 1 - s;
            sqrDistance = s*(a00*s + a01*t + 2.0*b0) +
            t*(a01*s + a11*t + 2.0*b1) + c;
          }
        } else {
          s = 0;
          if (tmp1 <= 0) {
            t = 1;
            sqrDistance = a11 + 2.0*b1 + c;
          } else if (b1 >= 0) {
            t = 0;
            sqrDistance = c;
          } else {
            t = -b1/a11;
            sqrDistance = b1*t + c;
          }
        }
      } else if (t < 0) {  // region 6
        tmp0 = a01 + b1;
        tmp1 = a00 + b0;
        if (tmp1 > tmp0) {
          numer = tmp1 - tmp0;
          denom = a00 - 2.0*a01 + a11;
          if (numer >= denom) {
            t = 1;
            s = 0;
            sqrDistance = a11 + 2.0*b1 + c;
          } else {
            t = numer/denom;
            s = 1 - t;
            sqrDistance = s*(a00*s + a01*t + 2.0*b0) +
            t*(a01*s + a11*t + 2.0*b1) + c;
          }
        } else {
          t = 0;
          if (tmp1 <= 0) {
            s = 1;
            sqrDistance = a00 + 2.0*b0 + c;
          } else if (b0 >= 0) {
            s = 0;
            sqrDistance = c;
          } else {
            s = -b0/a00;
            sqrDistance = b0*s + c;
          }
        }
      } else {  // region 1
        numer = a11 + b1 - a01 - b0;
        if (numer <= 0) {
          s = 0;
          t = 1;
          sqrDistance = a11 + 2.0*b1 + c;
        } else {
          denom = a00 - 2.0*a01 + a11;
          if (numer >= denom) {
            s = 1;
            t = 0;
            sqrDistance = a00 + 2.0*b0 + c;
          } else {
            s = numer/denom;
            t = 1 - s;
            sqrDistance = s*(a00*s + a01*t + 2.0*b0) +
            t*(a01*s + a11*t + 2.0*b1) + c;
          }
        }
      }
    }
    var u = 1.0 - s - t;
    for(var i=0; i<point.length; ++i) {
      result[i] = u * V0[i] + s * V1[i] + t * V2[i];
    }
    if(sqrDistance < 0) {
      return 0;
    }
    return sqrDistance;
  }
  
  module.exports = closestPoint2d;
  
  },{}],500:[function(_dereq_,module,exports){
  // shim for using process in browser
  var process = module.exports = {};
  
  // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.
  
  var cachedSetTimeout;
  var cachedClearTimeout;
  
  function defaultSetTimout() {
      throw new Error('setTimeout has not been defined');
  }
  function defaultClearTimeout () {
      throw new Error('clearTimeout has not been defined');
  }
  (function () {
      try {
          if (typeof setTimeout === 'function') {
              cachedSetTimeout = setTimeout;
          } else {
              cachedSetTimeout = defaultSetTimout;
          }
      } catch (e) {
          cachedSetTimeout = defaultSetTimout;
      }
      try {
          if (typeof clearTimeout === 'function') {
              cachedClearTimeout = clearTimeout;
          } else {
              cachedClearTimeout = defaultClearTimeout;
          }
      } catch (e) {
          cachedClearTimeout = defaultClearTimeout;
      }
  } ())
  function runTimeout(fun) {
      if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
      }
      // if setTimeout wasn't available but was latter defined
      if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
      } catch(e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
              return cachedSetTimeout.call(null, fun, 0);
          } catch(e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
              return cachedSetTimeout.call(this, fun, 0);
          }
      }
  
  
  }
  function runClearTimeout(marker) {
      if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
      }
      // if clearTimeout wasn't available but was latter defined
      if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
      }
      try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
      } catch (e){
          try {
              // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
              return cachedClearTimeout.call(null, marker);
          } catch (e){
              // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
              // Some versions of I.E. have different rules for clearTimeout vs setTimeout
              return cachedClearTimeout.call(this, marker);
          }
      }
  
  
  
  }
  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;
  
  function cleanUpNextTick() {
      if (!draining || !currentQueue) {
          return;
      }
      draining = false;
      if (currentQueue.length) {
          queue = currentQueue.concat(queue);
      } else {
          queueIndex = -1;
      }
      if (queue.length) {
          drainQueue();
      }
  }
  
  function drainQueue() {
      if (draining) {
          return;
      }
      var timeout = runTimeout(cleanUpNextTick);
      draining = true;
  
      var len = queue.length;
      while(len) {
          currentQueue = queue;
          queue = [];
          while (++queueIndex < len) {
              if (currentQueue) {
                  currentQueue[queueIndex].run();
              }
          }
          queueIndex = -1;
          len = queue.length;
      }
      currentQueue = null;
      draining = false;
      runClearTimeout(timeout);
  }
  
  process.nextTick = function (fun) {
      var args = new Array(arguments.length - 1);
      if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
              args[i - 1] = arguments[i];
          }
      }
      queue.push(new Item(fun, args));
      if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
      }
  };
  
  // v8 likes predictible objects
  function Item(fun, array) {
      this.fun = fun;
      this.array = array;
  }
  Item.prototype.run = function () {
      this.fun.apply(null, this.array);
  };
  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues
  process.versions = {};
  
  function noop() {}
  
  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;
  
  process.listeners = function (name) { return [] }
  
  process.binding = function (name) {
      throw new Error('process.binding is not supported');
  };
  
  process.cwd = function () { return '/' };
  process.chdir = function (dir) {
      throw new Error('process.chdir is not supported');
  };
  process.umask = function() { return 0; };
  
  },{}],501:[function(_dereq_,module,exports){
  module.exports = _dereq_('gl-quat/slerp')
  },{"gl-quat/slerp":304}],502:[function(_dereq_,module,exports){
  (function (global){
  var now = _dereq_('performance-now')
    , root = typeof window === 'undefined' ? global : window
    , vendors = ['moz', 'webkit']
    , suffix = 'AnimationFrame'
    , raf = root['request' + suffix]
    , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
  
  for(var i = 0; !raf && i < vendors.length; i++) {
    raf = root[vendors[i] + 'Request' + suffix]
    caf = root[vendors[i] + 'Cancel' + suffix]
        || root[vendors[i] + 'CancelRequest' + suffix]
  }
  
  // Some versions of FF have rAF but not cAF
  if(!raf || !caf) {
    var last = 0
      , id = 0
      , queue = []
      , frameDuration = 1000 / 60
  
    raf = function(callback) {
      if(queue.length === 0) {
        var _now = now()
          , next = Math.max(0, frameDuration - (_now - last))
        last = next + _now
        setTimeout(function() {
          var cp = queue.slice(0)
          // Clear queue here to prevent
          // callbacks from appending listeners
          // to the current frame's queue
          queue.length = 0
          for(var i = 0; i < cp.length; i++) {
            if(!cp[i].cancelled) {
              try{
                cp[i].callback(last)
              } catch(e) {
                setTimeout(function() { throw e }, 0)
              }
            }
          }
        }, Math.round(next))
      }
      queue.push({
        handle: ++id,
        callback: callback,
        cancelled: false
      })
      return id
    }
  
    caf = function(handle) {
      for(var i = 0; i < queue.length; i++) {
        if(queue[i].handle === handle) {
          queue[i].cancelled = true
        }
      }
    }
  }
  
  module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return raf.call(root, fn)
  }
  module.exports.cancel = function() {
    caf.apply(root, arguments)
  }
  module.exports.polyfill = function(object) {
    if (!object) {
      object = root;
    }
    object.requestAnimationFrame = raf
    object.cancelAnimationFrame = caf
  }
  
  }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{"performance-now":482}],503:[function(_dereq_,module,exports){
  'use strict'
  
  var bnadd = _dereq_('big-rat/add')
  
  module.exports = add
  
  function add (a, b) {
    var n = a.length
    var r = new Array(n)
    for (var i=0; i<n; ++i) {
      r[i] = bnadd(a[i], b[i])
    }
    return r
  }
  
  },{"big-rat/add":80}],504:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = float2rat
  
  var rat = _dereq_('big-rat')
  
  function float2rat(v) {
    var result = new Array(v.length)
    for(var i=0; i<v.length; ++i) {
      result[i] = rat(v[i])
    }
    return result
  }
  
  },{"big-rat":83}],505:[function(_dereq_,module,exports){
  'use strict'
  
  var rat = _dereq_('big-rat')
  var mul = _dereq_('big-rat/mul')
  
  module.exports = muls
  
  function muls(a, x) {
    var s = rat(x)
    var n = a.length
    var r = new Array(n)
    for(var i=0; i<n; ++i) {
      r[i] = mul(a[i], s)
    }
    return r
  }
  
  },{"big-rat":83,"big-rat/mul":92}],506:[function(_dereq_,module,exports){
  'use strict'
  
  var bnsub = _dereq_('big-rat/sub')
  
  module.exports = sub
  
  function sub(a, b) {
    var n = a.length
    var r = new Array(n)
      for(var i=0; i<n; ++i) {
      r[i] = bnsub(a[i], b[i])
    }
    return r
  }
  
  },{"big-rat/sub":94}],507:[function(_dereq_,module,exports){
  'use strict'
  
  var compareCell = _dereq_('compare-cell')
  var compareOrientedCell = _dereq_('compare-oriented-cell')
  var orientation = _dereq_('cell-orientation')
  
  module.exports = reduceCellComplex
  
  function reduceCellComplex(cells) {
    cells.sort(compareOrientedCell)
    var n = cells.length
    var ptr = 0
    for(var i=0; i<n; ++i) {
      var c = cells[i]
      var o = orientation(c)
      if(o === 0) {
        continue
      }
      if(ptr > 0) {
        var f = cells[ptr-1]
        if(compareCell(c, f) === 0 &&
           orientation(f)    !== o) {
          ptr -= 1
          continue
        }
      }
      cells[ptr++] = c
    }
    cells.length = ptr
    return cells
  }
  
  },{"cell-orientation":117,"compare-cell":133,"compare-oriented-cell":134}],508:[function(_dereq_,module,exports){
  'use strict'
  
  var getBounds = _dereq_('array-bounds')
  var rgba = _dereq_('color-normalize')
  var updateDiff = _dereq_('update-diff')
  var pick = _dereq_('pick-by-alias')
  var extend = _dereq_('object-assign')
  var flatten = _dereq_('flatten-vertex-data')
  var ref = _dereq_('to-float32');
  var float32 = ref.float32;
  var fract32 = ref.fract32;
  
  module.exports = Error2D
  
  var WEIGHTS = [
    //direction, lineWidth shift, capSize shift
  
    // x-error bar
    [1, 0, 0, 1, 0, 0],
    [1, 0, 0, -1, 0, 0],
    [-1, 0, 0, -1, 0, 0],
  
    [-1, 0, 0, -1, 0, 0],
    [-1, 0, 0, 1, 0, 0],
    [1, 0, 0, 1, 0, 0],
  
    // x-error right cap
    [1, 0, -1, 0, 0, 1],
    [1, 0, -1, 0, 0, -1],
    [1, 0, 1, 0, 0, -1],
  
    [1, 0, 1, 0, 0, -1],
    [1, 0, 1, 0, 0, 1],
    [1, 0, -1, 0, 0, 1],
  
    // x-error left cap
    [-1, 0, -1, 0, 0, 1],
    [-1, 0, -1, 0, 0, -1],
    [-1, 0, 1, 0, 0, -1],
  
    [-1, 0, 1, 0, 0, -1],
    [-1, 0, 1, 0, 0, 1],
    [-1, 0, -1, 0, 0, 1],
  
    // y-error bar
    [0, 1, 1, 0, 0, 0],
    [0, 1, -1, 0, 0, 0],
    [0, -1, -1, 0, 0, 0],
  
    [0, -1, -1, 0, 0, 0],
    [0, 1, 1, 0, 0, 0],
    [0, -1, 1, 0, 0, 0],
  
    // y-error top cap
    [0, 1, 0, -1, 1, 0],
    [0, 1, 0, -1, -1, 0],
    [0, 1, 0, 1, -1, 0],
  
    [0, 1, 0, 1, 1, 0],
    [0, 1, 0, -1, 1, 0],
    [0, 1, 0, 1, -1, 0],
  
    // y-error bottom cap
    [0, -1, 0, -1, 1, 0],
    [0, -1, 0, -1, -1, 0],
    [0, -1, 0, 1, -1, 0],
  
    [0, -1, 0, 1, 1, 0],
    [0, -1, 0, -1, 1, 0],
    [0, -1, 0, 1, -1, 0]
  ]
  
  
  function Error2D (regl, options) {
    if (typeof regl === 'function') {
      if (!options) { options = {} }
      options.regl = regl
    }
    else {
      options = regl
    }
    if (options.length) { options.positions = options }
    regl = options.regl
  
    if (!regl.hasExtension('ANGLE_instanced_arrays')) {
      throw Error('regl-error2d: `ANGLE_instanced_arrays` extension should be enabled');
    }
  
    // persistent variables
    var gl = regl._gl, drawErrors, positionBuffer, positionFractBuffer, colorBuffer, errorBuffer, meshBuffer,
        defaults = {
          color: 'black',
          capSize: 5,
          lineWidth: 1,
          opacity: 1,
          viewport: null,
          range: null,
          offset: 0,
          count: 0,
          bounds: null,
          positions: [],
          errors: []
        }, groups = []
  
    //color per-point
    colorBuffer = regl.buffer({
      usage: 'dynamic',
      type: 'uint8',
      data: new Uint8Array(0)
    })
    //xy-position per-point
    positionBuffer = regl.buffer({
      usage: 'dynamic',
      type: 'float',
      data: new Uint8Array(0)
    })
    //xy-position float32-fraction
    positionFractBuffer = regl.buffer({
      usage: 'dynamic',
      type: 'float',
      data: new Uint8Array(0)
    })
    //4 errors per-point
    errorBuffer = regl.buffer({
      usage: 'dynamic',
      type: 'float',
      data: new Uint8Array(0)
    })
    //error bar mesh
    meshBuffer = regl.buffer({
      usage: 'static',
      type: 'float',
      data: WEIGHTS
    })
  
    update(options)
  
    //drawing method
    drawErrors = regl({
      vert: "\n\t\tprecision highp float;\n\n\t\tattribute vec2 position, positionFract;\n\t\tattribute vec4 error;\n\t\tattribute vec4 color;\n\n\t\tattribute vec2 direction, lineOffset, capOffset;\n\n\t\tuniform vec4 viewport;\n\t\tuniform float lineWidth, capSize;\n\t\tuniform vec2 scale, scaleFract, translate, translateFract;\n\n\t\tvarying vec4 fragColor;\n\n\t\tvoid main() {\n\t\t\tfragColor = color / 255.;\n\n\t\t\tvec2 pixelOffset = lineWidth * lineOffset + (capSize + lineWidth) * capOffset;\n\n\t\t\tvec2 dxy = -step(.5, direction.xy) * error.xz + step(direction.xy, vec2(-.5)) * error.yw;\n\n\t\t\tvec2 position = position + dxy;\n\n\t\t\tvec2 pos = (position + translate) * scale\n\t\t\t\t+ (positionFract + translateFract) * scale\n\t\t\t\t+ (position + translate) * scaleFract\n\t\t\t\t+ (positionFract + translateFract) * scaleFract;\n\n\t\t\tpos += pixelOffset / viewport.zw;\n\n\t\t\tgl_Position = vec4(pos * 2. - 1., 0, 1);\n\t\t}\n\t\t",
  
      frag: "\n\t\tprecision highp float;\n\n\t\tvarying vec4 fragColor;\n\n\t\tuniform float opacity;\n\n\t\tvoid main() {\n\t\t\tgl_FragColor = fragColor;\n\t\t\tgl_FragColor.a *= opacity;\n\t\t}\n\t\t",
  
      uniforms: {
        range: regl.prop('range'),
        lineWidth: regl.prop('lineWidth'),
        capSize: regl.prop('capSize'),
        opacity: regl.prop('opacity'),
        scale: regl.prop('scale'),
        translate: regl.prop('translate'),
        scaleFract: regl.prop('scaleFract'),
        translateFract: regl.prop('translateFract'),
        viewport: function (ctx, prop) { return [prop.viewport.x, prop.viewport.y, ctx.viewportWidth, ctx.viewportHeight]; }
      },
  
      attributes: {
        //dynamic attributes
        color: {
          buffer: colorBuffer,
          offset: function (ctx, prop) { return prop.offset * 4; },
          divisor: 1,
        },
        position: {
          buffer: positionBuffer,
          offset: function (ctx, prop) { return prop.offset * 8; },
          divisor: 1
        },
        positionFract: {
          buffer: positionFractBuffer,
          offset: function (ctx, prop) { return prop.offset * 8; },
          divisor: 1
        },
        error: {
          buffer: errorBuffer,
          offset: function (ctx, prop) { return prop.offset * 16; },
          divisor: 1
        },
  
        //static attributes
        direction: {
          buffer: meshBuffer,
          stride: 24,
          offset: 0
        },
        lineOffset: {
          buffer: meshBuffer,
          stride: 24,
          offset: 8
        },
        capOffset: {
          buffer: meshBuffer,
          stride: 24,
          offset: 16
        }
      },
  
      primitive: 'triangles',
  
      blend: {
        enable: true,
        color: [0,0,0,0],
        equation: {
          rgb: 'add',
          alpha: 'add'
        },
        func: {
          srcRGB: 'src alpha',
          dstRGB: 'one minus src alpha',
          srcAlpha: 'one minus dst alpha',
          dstAlpha: 'one'
        }
      },
  
      depth: {
        enable: false
      },
  
      scissor: {
        enable: true,
        box: regl.prop('viewport')
      },
      viewport: regl.prop('viewport'),
      stencil: false,
  
      instances: regl.prop('count'),
      count: WEIGHTS.length
    })
  
    //expose API
    extend(error2d, {
      update: update,
      draw: draw,
      destroy: destroy,
      regl: regl,
      gl: gl,
      canvas: gl.canvas,
      groups: groups
    })
  
    return error2d
  
    function error2d (opts) {
      //update
      if (opts) {
        update(opts)
      }
  
      //destroy
      else if (opts === null) {
        destroy()
      }
  
      draw()
    }
  
  
    //main draw method
    function draw (options) {
      if (typeof options === 'number') { return drawGroup(options) }
  
      //make options a batch
      if (options && !Array.isArray(options)) { options = [options] }
  
  
      regl._refresh()
  
      //render multiple polylines via regl batch
      groups.forEach(function (s, i) {
        if (!s) { return }
  
        if (options) {
          if (!options[i]) { s.draw = false }
          else { s.draw = true }
        }
  
        //ignore draw flag for one pass
        if (!s.draw) {
          s.draw = true;
          return
        }
  
        drawGroup(i)
      })
    }
  
    //draw single error group by id
    function drawGroup (s) {
      if (typeof s === 'number') { s = groups[s] }
      if (s == null) { return }
  
      if (!(s && s.count && s.color && s.opacity && s.positions && s.positions.length > 1)) { return }
  
      s.scaleRatio = [
        s.scale[0] * s.viewport.width,
        s.scale[1] * s.viewport.height
      ]
  
      drawErrors(s)
  
      if (s.after) { s.after(s) }
    }
  
    function update (options) {
      if (!options) { return }
  
      //direct points argument
      if (options.length != null) {
        if (typeof options[0] === 'number') { options = [{positions: options}] }
      }
  
      //make options a batch
      else if (!Array.isArray(options)) { options = [options] }
  
      //global count of points
      var pointCount = 0, errorCount = 0
  
      error2d.groups = groups = options.map(function (options, i) {
        var group = groups[i]
  
        if (!options) { return group }
        else if (typeof options === 'function') { options = {after: options} }
        else if (typeof options[0] === 'number') { options = {positions: options} }
  
        //copy options to avoid mutation & handle aliases
        options = pick(options, {
          color: 'color colors fill',
          capSize: 'capSize cap capsize cap-size',
          lineWidth: 'lineWidth line-width width line thickness',
          opacity: 'opacity alpha',
          range: 'range dataBox',
          viewport: 'viewport viewBox',
          errors: 'errors error',
          positions: 'positions position data points'
        })
  
        if (!group) {
          groups[i] = group = {
            id: i,
            scale: null,
            translate: null,
            scaleFract: null,
            translateFract: null,
            draw: true
          }
          options = extend({}, defaults, options)
        }
  
        updateDiff(group, options, [{
          lineWidth: function (v) { return +v * .5; },
          capSize: function (v) { return +v * .5; },
          opacity: parseFloat,
          errors: function (errors) {
            errors = flatten(errors)
  
            errorCount += errors.length
            return errors
          },
          positions: function (positions, state) {
            positions = flatten(positions, 'float64')
            state.count = Math.floor(positions.length / 2)
            state.bounds = getBounds(positions, 2)
            state.offset = pointCount
  
            pointCount += state.count
  
            return positions
          }
        }, {
          color: function (colors, state) {
            var count = state.count
  
            if (!colors) { colors = 'transparent' }
  
            // 'black' or [0,0,0,0] case
            if (!Array.isArray(colors) || typeof colors[0] === 'number') {
              var color = colors
              colors = Array(count)
              for (var i = 0; i < count; i++) {
                colors[i] = color
              }
            }
  
            if (colors.length < count) { throw Error('Not enough colors') }
  
            var colorData = new Uint8Array(count * 4)
  
            //convert colors to float arrays
            for (var i$1 = 0; i$1 < count; i$1++) {
              var c = rgba(colors[i$1], 'uint8')
              colorData.set(c, i$1 * 4)
            }
  
            return colorData
          },
  
          range: function (range, state, options) {
            var bounds = state.bounds
            if (!range) { range = bounds }
  
            state.scale = [1 / (range[2] - range[0]), 1 / (range[3] - range[1])]
            state.translate = [-range[0], -range[1]]
  
            state.scaleFract = fract32(state.scale)
            state.translateFract = fract32(state.translate)
  
            return range
          },
  
          viewport: function (vp) {
            var viewport
  
            if (Array.isArray(vp)) {
              viewport = {
                x: vp[0],
                y: vp[1],
                width: vp[2] - vp[0],
                height: vp[3] - vp[1]
              }
            }
            else if (vp) {
              viewport = {
                x: vp.x || vp.left || 0,
                y: vp.y || vp.top || 0
              }
  
              if (vp.right) { viewport.width = vp.right - viewport.x }
              else { viewport.width = vp.w || vp.width || 0 }
  
              if (vp.bottom) { viewport.height = vp.bottom - viewport.y }
              else { viewport.height = vp.h || vp.height || 0 }
            }
            else {
              viewport = {
                x: 0, y: 0,
                width: gl.drawingBufferWidth,
                height: gl.drawingBufferHeight
              }
            }
  
            return viewport
          }
        }])
  
        return group
      })
  
      if (pointCount || errorCount) {
        var len = groups.reduce(function (acc, group, i) {
          return acc + (group ? group.count : 0)
        }, 0)
  
        var positionData = new Float64Array(len * 2)
        var colorData = new Uint8Array(len * 4)
        var errorData = new Float32Array(len * 4)
  
        groups.forEach(function (group, i) {
          if (!group) { return }
          var positions = group.positions;
          var count = group.count;
          var offset = group.offset;
          var color = group.color;
          var errors = group.errors;
          if (!count) { return }
  
          colorData.set(color, offset * 4)
          errorData.set(errors, offset * 4)
          positionData.set(positions, offset * 2)
        })
  
        positionBuffer(float32(positionData))
        positionFractBuffer(fract32(positionData))
        colorBuffer(colorData)
        errorBuffer(errorData)
      }
  
    }
  
    function destroy () {
      positionBuffer.destroy()
      positionFractBuffer.destroy()
      colorBuffer.destroy()
      errorBuffer.destroy()
      meshBuffer.destroy()
    }
  }
  
  },{"array-bounds":70,"color-normalize":125,"flatten-vertex-data":244,"object-assign":473,"pick-by-alias":485,"to-float32":549,"update-diff":571}],509:[function(_dereq_,module,exports){
  'use strict'
  
  
  var rgba = _dereq_('color-normalize')
  var getBounds = _dereq_('array-bounds')
  var extend = _dereq_('object-assign')
  var glslify = _dereq_('glslify')
  var pick = _dereq_('pick-by-alias')
  var flatten = _dereq_('flatten-vertex-data')
  var triangulate = _dereq_('earcut')
  var normalize = _dereq_('array-normalize')
  var ref = _dereq_('to-float32');
  var float32 = ref.float32;
  var fract32 = ref.fract32;
  var WeakMap = _dereq_('es6-weak-map')
  var parseRect = _dereq_('parse-rect')
  
  
  module.exports = Line2D
  
  
  /** @constructor */
  function Line2D (regl, options) {
    if (!(this instanceof Line2D)) { return new Line2D(regl, options) }
  
    if (typeof regl === 'function') {
      if (!options) { options = {} }
      options.regl = regl
    }
    else {
      options = regl
    }
    if (options.length) { options.positions = options }
    regl = options.regl
  
    if (!regl.hasExtension('ANGLE_instanced_arrays')) {
      throw Error('regl-error2d: `ANGLE_instanced_arrays` extension should be enabled');
    }
  
    // persistent variables
    this.gl = regl._gl
    this.regl = regl
  
    // list of options for lines
    this.passes = []
  
    // cached shaders instance
    this.shaders = Line2D.shaders.has(regl) ? Line2D.shaders.get(regl) : Line2D.shaders.set(regl, Line2D.createShaders(regl)).get(regl)
  
  
    // init defaults
    this.update(options)
  }
  
  
  Line2D.dashMult = 2
  Line2D.maxPatternLength = 256
  Line2D.precisionThreshold = 3e6
  Line2D.maxPoints = 1e4
  Line2D.maxLines = 2048
  
  
  // cache of created draw calls per-regl instance
  Line2D.shaders = new WeakMap()
  
  
  // create static shaders once
  Line2D.createShaders = function (regl) {
    var offsetBuffer = regl.buffer({
      usage: 'static',
      type: 'float',
      data: [0,1, 0,0, 1,1, 1,0]
    })
  
    var shaderOptions = {
      primitive: 'triangle strip',
      instances: regl.prop('count'),
      count: 4,
      offset: 0,
  
      uniforms: {
        miterMode: function (ctx, prop) { return prop.join === 'round' ? 2 : 1; },
        miterLimit: regl.prop('miterLimit'),
        scale: regl.prop('scale'),
        scaleFract: regl.prop('scaleFract'),
        translateFract: regl.prop('translateFract'),
        translate: regl.prop('translate'),
        thickness: regl.prop('thickness'),
        dashPattern: regl.prop('dashTexture'),
        opacity: regl.prop('opacity'),
        pixelRatio: regl.context('pixelRatio'),
        id: regl.prop('id'),
        dashSize: regl.prop('dashLength'),
        viewport: function (c, p) { return [p.viewport.x, p.viewport.y, c.viewportWidth, c.viewportHeight]; },
        depth: regl.prop('depth')
      },
  
      blend: {
        enable: true,
        color: [0,0,0,0],
        equation: {
          rgb: 'add',
          alpha: 'add'
        },
        func: {
          srcRGB: 'src alpha',
          dstRGB: 'one minus src alpha',
          srcAlpha: 'one minus dst alpha',
          dstAlpha: 'one'
        }
      },
      depth: {
        enable: function (c, p) {
          return !p.overlay
        }
      },
      stencil: {enable: false},
      scissor: {
        enable: true,
        box: regl.prop('viewport')
      },
      viewport: regl.prop('viewport')
    }
  
  
    // simplified rectangular line shader
    var drawRectLine = regl(extend({
      vert: glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, aCoordFract, bCoordFract;\nattribute vec4 color;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvec2 project(vec2 position, vec2 positionFract, vec2 scale, vec2 scaleFract, vec2 translate, vec2 translateFract) {\n\t// the order is important\n\treturn position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n}\n\nvoid main() {\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineOffset = lineTop * 2. - 1.;\n\n\tvec2 diff = (bCoord + bCoordFract - aCoord - aCoordFract);\n\ttangent = normalize(diff * scale * viewport.zw);\n\tvec2 normal = vec2(-tangent.y, tangent.x);\n\n\tvec2 position = project(aCoord, aCoordFract, scale, scaleFract, translate, translateFract) * lineStart\n\t\t+ project(bCoord, bCoordFract, scale, scaleFract, translate, translateFract) * lineEnd\n\n\t\t+ thickness * normal * .5 * lineOffset / viewport.zw;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n}\n"]),
      frag: glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D dashPattern;\n\nuniform float dashSize, pixelRatio, thickness, opacity, id;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\n\nvoid main() {\n\tfloat alpha = 1.;\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashSize) * .5 + .25;\n\tfloat dash = texture2D(dashPattern, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"]),
  
      attributes: {
        // if point is at the end of segment
        lineEnd: {
          buffer: offsetBuffer,
          divisor: 0,
          stride: 8,
          offset: 0
        },
        // if point is at the top of segment
        lineTop: {
          buffer: offsetBuffer,
          divisor: 0,
          stride: 8,
          offset: 4
        },
        // beginning of line coordinate
        aCoord: {
          buffer: regl.prop('positionBuffer'),
          stride: 8,
          offset: 8,
          divisor: 1
        },
        // end of line coordinate
        bCoord: {
          buffer: regl.prop('positionBuffer'),
          stride: 8,
          offset: 16,
          divisor: 1
        },
        aCoordFract: {
          buffer: regl.prop('positionFractBuffer'),
          stride: 8,
          offset: 8,
          divisor: 1
        },
        bCoordFract: {
          buffer: regl.prop('positionFractBuffer'),
          stride: 8,
          offset: 16,
          divisor: 1
        },
        color: {
          buffer: regl.prop('colorBuffer'),
          stride: 4,
          offset: 0,
          divisor: 1
        }
      }
    }, shaderOptions))
  
    // create regl draw
    var drawMiterLine
  
    try {
      drawMiterLine = regl(extend({
        // culling removes polygon creasing
        cull: {
          enable: true,
          face: 'back'
        },
  
        vert: glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aCoord, bCoord, nextCoord, prevCoord;\nattribute vec4 aColor, bColor;\nattribute float lineEnd, lineTop;\n\nuniform vec2 scale, translate;\nuniform float thickness, pixelRatio, id, depth;\nuniform vec4 viewport;\nuniform float miterLimit, miterMode;\n\nvarying vec4 fragColor;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 tangent;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nconst float REVERSE_THRESHOLD = -.875;\nconst float MIN_DIFF = 1e-6;\n\n// TODO: possible optimizations: avoid overcalculating all for vertices and calc just one instead\n// TODO: precalculate dot products, normalize things beforehead etc.\n// TODO: refactor to rectangular algorithm\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nbool isNaN( float val ){\n  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true;\n}\n\nvoid main() {\n\tvec2 aCoord = aCoord, bCoord = bCoord, prevCoord = prevCoord, nextCoord = nextCoord;\n\n  vec2 adjustedScale;\n  adjustedScale.x = (abs(scale.x) < MIN_DIFF) ? MIN_DIFF : scale.x;\n  adjustedScale.y = (abs(scale.y) < MIN_DIFF) ? MIN_DIFF : scale.y;\n\n  vec2 scaleRatio = adjustedScale * viewport.zw;\n\tvec2 normalWidth = thickness / scaleRatio;\n\n\tfloat lineStart = 1. - lineEnd;\n\tfloat lineBot = 1. - lineTop;\n\n\tfragColor = (lineStart * aColor + lineEnd * bColor) / 255.;\n\n\tif (isNaN(aCoord.x) || isNaN(aCoord.y) || isNaN(bCoord.x) || isNaN(bCoord.y)) return;\n\n\tif (aCoord == prevCoord) prevCoord = aCoord + normalize(bCoord - aCoord);\n\tif (bCoord == nextCoord) nextCoord = bCoord - normalize(bCoord - aCoord);\n\n\tvec2 prevDiff = aCoord - prevCoord;\n\tvec2 currDiff = bCoord - aCoord;\n\tvec2 nextDiff = nextCoord - bCoord;\n\n\tvec2 prevTangent = normalize(prevDiff * scaleRatio);\n\tvec2 currTangent = normalize(currDiff * scaleRatio);\n\tvec2 nextTangent = normalize(nextDiff * scaleRatio);\n\n\tvec2 prevNormal = vec2(-prevTangent.y, prevTangent.x);\n\tvec2 currNormal = vec2(-currTangent.y, currTangent.x);\n\tvec2 nextNormal = vec2(-nextTangent.y, nextTangent.x);\n\n\tvec2 startJoinDirection = normalize(prevTangent - currTangent);\n\tvec2 endJoinDirection = normalize(currTangent - nextTangent);\n\n\t// collapsed/unidirectional segment cases\n\t// FIXME: there should be more elegant solution\n\tvec2 prevTanDiff = abs(prevTangent - currTangent);\n\tvec2 nextTanDiff = abs(nextTangent - currTangent);\n\tif (max(prevTanDiff.x, prevTanDiff.y) < MIN_DIFF) {\n\t\tstartJoinDirection = currNormal;\n\t}\n\tif (max(nextTanDiff.x, nextTanDiff.y) < MIN_DIFF) {\n\t\tendJoinDirection = currNormal;\n\t}\n\tif (aCoord == bCoord) {\n\t\tendJoinDirection = startJoinDirection;\n\t\tcurrNormal = prevNormal;\n\t\tcurrTangent = prevTangent;\n\t}\n\n\ttangent = currTangent;\n\n\t//calculate join shifts relative to normals\n\tfloat startJoinShift = dot(currNormal, startJoinDirection);\n\tfloat endJoinShift = dot(currNormal, endJoinDirection);\n\n\tfloat startMiterRatio = abs(1. / startJoinShift);\n\tfloat endMiterRatio = abs(1. / endJoinShift);\n\n\tvec2 startJoin = startJoinDirection * startMiterRatio;\n\tvec2 endJoin = endJoinDirection * endMiterRatio;\n\n\tvec2 startTopJoin, startBotJoin, endTopJoin, endBotJoin;\n\tstartTopJoin = sign(startJoinShift) * startJoin * .5;\n\tstartBotJoin = -startTopJoin;\n\n\tendTopJoin = sign(endJoinShift) * endJoin * .5;\n\tendBotJoin = -endTopJoin;\n\n\tvec2 aTopCoord = aCoord + normalWidth * startTopJoin;\n\tvec2 bTopCoord = bCoord + normalWidth * endTopJoin;\n\tvec2 aBotCoord = aCoord + normalWidth * startBotJoin;\n\tvec2 bBotCoord = bCoord + normalWidth * endBotJoin;\n\n\t//miter anti-clipping\n\tfloat baClipping = distToLine(bCoord, aCoord, aBotCoord) / dot(normalize(normalWidth * endBotJoin), normalize(normalWidth.yx * vec2(-startBotJoin.y, startBotJoin.x)));\n\tfloat abClipping = distToLine(aCoord, bCoord, bTopCoord) / dot(normalize(normalWidth * startBotJoin), normalize(normalWidth.yx * vec2(-endBotJoin.y, endBotJoin.x)));\n\n\t//prevent close to reverse direction switch\n\tbool prevReverse = dot(currTangent, prevTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, prevNormal)) * min(length(prevDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\tbool nextReverse = dot(currTangent, nextTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, nextNormal)) * min(length(nextDiff), length(currDiff)) <  length(normalWidth * currNormal);\n\n\tif (prevReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * startJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / startMiterRatio, 1.);\n\t\taBotCoord = aCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\taTopCoord = aCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!nextReverse && baClipping > 0. && baClipping < length(normalWidth * endBotJoin)) {\n\t\t//handle miter clipping\n\t\tbTopCoord -= normalWidth * endTopJoin;\n\t\tbTopCoord += normalize(endTopJoin * normalWidth) * baClipping;\n\t}\n\n\tif (nextReverse) {\n\t\t//make join rectangular\n\t\tvec2 miterShift = normalWidth * endJoinDirection * miterLimit * .5;\n\t\tfloat normalAdjust = 1. - min(miterLimit / endMiterRatio, 1.);\n\t\tbBotCoord = bCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;\n\t\tbTopCoord = bCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;\n\t}\n\telse if (!prevReverse && abClipping > 0. && abClipping < length(normalWidth * startBotJoin)) {\n\t\t//handle miter clipping\n\t\taBotCoord -= normalWidth * startBotJoin;\n\t\taBotCoord += normalize(startBotJoin * normalWidth) * abClipping;\n\t}\n\n\tvec2 aTopPosition = (aTopCoord) * adjustedScale + translate;\n\tvec2 aBotPosition = (aBotCoord) * adjustedScale + translate;\n\n\tvec2 bTopPosition = (bTopCoord) * adjustedScale + translate;\n\tvec2 bBotPosition = (bBotCoord) * adjustedScale + translate;\n\n\t//position is normalized 0..1 coord on the screen\n\tvec2 position = (aTopPosition * lineTop + aBotPosition * lineBot) * lineStart + (bTopPosition * lineTop + bBotPosition * lineBot) * lineEnd;\n\n\tstartCoord = aCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\tendCoord = bCoord * scaleRatio + translate * viewport.zw + viewport.xy;\n\n\tgl_Position = vec4(position  * 2.0 - 1.0, depth, 1);\n\n\tenableStartMiter = step(dot(currTangent, prevTangent), .5);\n\tenableEndMiter = step(dot(currTangent, nextTangent), .5);\n\n\t//bevel miter cutoffs\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * miterLimit * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * miterLimit * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n\n\t//round miter cutoffs\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tvec2 startMiterWidth = vec2(startJoinDirection) * thickness * abs(dot(startJoinDirection, currNormal)) * .5;\n\t\t\tstartCutoff = vec4(aCoord, aCoord);\n\t\t\tstartCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;\n\t\t\tstartCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tstartCutoff += viewport.xyxy;\n\t\t\tstartCutoff += startMiterWidth.xyxy;\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tvec2 endMiterWidth = vec2(endJoinDirection) * thickness * abs(dot(endJoinDirection, currNormal)) * .5;\n\t\t\tendCutoff = vec4(bCoord, bCoord);\n\t\t\tendCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;\n\t\t\tendCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;\n\t\t\tendCutoff += viewport.xyxy;\n\t\t\tendCutoff += endMiterWidth.xyxy;\n\t\t}\n\t}\n}\n"]),
        frag: glslify(["precision highp float;\n#define GLSLIFY 1\n\nuniform sampler2D dashPattern;\nuniform float dashSize, pixelRatio, thickness, opacity, id, miterMode;\n\nvarying vec4 fragColor;\nvarying vec2 tangent;\nvarying vec4 startCutoff, endCutoff;\nvarying vec2 startCoord, endCoord;\nvarying float enableStartMiter, enableEndMiter;\n\nfloat distToLine(vec2 p, vec2 a, vec2 b) {\n\tvec2 diff = b - a;\n\tvec2 perp = normalize(vec2(-diff.y, diff.x));\n\treturn dot(p - a, perp);\n}\n\nvoid main() {\n\tfloat alpha = 1., distToStart, distToEnd;\n\tfloat cutoff = thickness * .5;\n\n\t//bevel miter\n\tif (miterMode == 1.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToStart + 1., 0.), 1.);\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < -1.) {\n\t\t\t\tdiscard;\n\t\t\t\treturn;\n\t\t\t}\n\t\t\talpha *= min(max(distToEnd + 1., 0.), 1.);\n\t\t}\n\t}\n\n\t// round miter\n\telse if (miterMode == 2.) {\n\t\tif (enableStartMiter == 1.) {\n\t\t\tdistToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);\n\t\t\tif (distToStart < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - startCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\n\t\tif (enableEndMiter == 1.) {\n\t\t\tdistToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);\n\t\t\tif (distToEnd < 0.) {\n\t\t\t\tfloat radius = length(gl_FragCoord.xy - endCoord);\n\n\t\t\t\tif(radius > cutoff + .5) {\n\t\t\t\t\tdiscard;\n\t\t\t\t\treturn;\n\t\t\t\t}\n\n\t\t\t\talpha -= smoothstep(cutoff - .5, cutoff + .5, radius);\n\t\t\t}\n\t\t}\n\t}\n\n\tfloat t = fract(dot(tangent, gl_FragCoord.xy) / dashSize) * .5 + .25;\n\tfloat dash = texture2D(dashPattern, vec2(t, .5)).r;\n\n\tgl_FragColor = fragColor;\n\tgl_FragColor.a *= alpha * opacity * dash;\n}\n"]),
  
        attributes: {
          // is line end
          lineEnd: {
            buffer: offsetBuffer,
            divisor: 0,
            stride: 8,
            offset: 0
          },
          // is line top
          lineTop: {
            buffer: offsetBuffer,
            divisor: 0,
            stride: 8,
            offset: 4
          },
          // left color
          aColor: {
            buffer: regl.prop('colorBuffer'),
            stride: 4,
            offset: 0,
            divisor: 1
          },
          // right color
          bColor: {
            buffer: regl.prop('colorBuffer'),
            stride: 4,
            offset: 4,
            divisor: 1
          },
          prevCoord: {
            buffer: regl.prop('positionBuffer'),
            stride: 8,
            offset: 0,
            divisor: 1
          },
          aCoord: {
            buffer: regl.prop('positionBuffer'),
            stride: 8,
            offset: 8,
            divisor: 1
          },
          bCoord: {
            buffer: regl.prop('positionBuffer'),
            stride: 8,
            offset: 16,
            divisor: 1
          },
          nextCoord: {
            buffer: regl.prop('positionBuffer'),
            stride: 8,
            offset: 24,
            divisor: 1
          }
        }
      }, shaderOptions))
    } catch (e) {
      // IE/bad Webkit fallback
      drawMiterLine = drawRectLine
    }
  
    // fill shader
    var drawFill = regl({
      primitive: 'triangle',
      elements: function (ctx, prop) { return prop.triangles; },
      offset: 0,
  
      vert: glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 position, positionFract;\n\nuniform vec4 color;\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio, id;\nuniform vec4 viewport;\nuniform float opacity;\n\nvarying vec4 fragColor;\n\nconst float MAX_LINES = 256.;\n\nvoid main() {\n\tfloat depth = (MAX_LINES - 4. - id) / (MAX_LINES);\n\n\tvec2 position = position * scale + translate\n       + positionFract * scale + translateFract\n       + position * scaleFract\n       + positionFract * scaleFract;\n\n\tgl_Position = vec4(position * 2.0 - 1.0, depth, 1);\n\n\tfragColor = color / 255.;\n\tfragColor.a *= opacity;\n}\n"]),
      frag: glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n\tgl_FragColor = fragColor;\n}\n"]),
  
      uniforms: {
        scale: regl.prop('scale'),
        color: regl.prop('fill'),
        scaleFract: regl.prop('scaleFract'),
        translateFract: regl.prop('translateFract'),
        translate: regl.prop('translate'),
        opacity: regl.prop('opacity'),
        pixelRatio: regl.context('pixelRatio'),
        id: regl.prop('id'),
        viewport: function (ctx, prop) { return [prop.viewport.x, prop.viewport.y, ctx.viewportWidth, ctx.viewportHeight]; }
      },
  
      attributes: {
        position: {
          buffer: regl.prop('positionBuffer'),
          stride: 8,
          offset: 8
        },
        positionFract: {
          buffer: regl.prop('positionFractBuffer'),
          stride: 8,
          offset: 8
        }
      },
  
      blend: shaderOptions.blend,
  
      depth: { enable: false },
      scissor: shaderOptions.scissor,
      stencil: shaderOptions.stencil,
      viewport: shaderOptions.viewport
    })
  
    return {
      fill: drawFill, rect: drawRectLine, miter: drawMiterLine
    }
  }
  
  
  // used to for new lines instances
  Line2D.defaults = {
    dashes: null,
    join: 'miter',
    miterLimit: 1,
    thickness: 10,
    cap: 'square',
    color: 'black',
    opacity: 1,
    overlay: false,
    viewport: null,
    range: null,
    close: false,
    fill: null
  }
  
  
  Line2D.prototype.render = function () {
    var ref;
  
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    if (args.length) {
      (ref = this).update.apply(ref, args)
    }
  
    this.draw()
  }
  
  
  Line2D.prototype.draw = function () {
    var this$1 = this;
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
  
    // render multiple polylines via regl batch
    (args.length ? args : this.passes).forEach(function (s, i) {
      var ref;
  
      // render array pass as a list of passes
      if (s && Array.isArray(s)) { return (ref = this$1).draw.apply(ref, s) }
  
      if (typeof s === 'number') { s = this$1.passes[s] }
  
      if (!(s && s.count > 1 && s.opacity)) { return }
  
      this$1.regl._refresh()
  
      if (s.fill && s.triangles && s.triangles.length > 2) {
        this$1.shaders.fill(s)
      }
  
      if (!s.thickness) { return }
  
      // high scale is only available for rect mode with precision
      if (s.scale[0] * s.viewport.width > Line2D.precisionThreshold || s.scale[1] * s.viewport.height > Line2D.precisionThreshold) {
        this$1.shaders.rect(s)
      }
  
      // thin this.passes or too many points are rendered as simplified rect shader
      else if (s.join === 'rect' || (!s.join && (s.thickness <= 2 || s.count >= Line2D.maxPoints))) {
        this$1.shaders.rect(s)
      }
      else {
        this$1.shaders.miter(s)
      }
    })
  
    return this
  }
  
  Line2D.prototype.update = function (options) {
    var this$1 = this;
  
    if (!options) { return }
  
    if (options.length != null) {
      if (typeof options[0] === 'number') { options = [{positions: options}] }
    }
  
    // make options a batch
    else if (!Array.isArray(options)) { options = [options] }
  
    var ref = this;
    var regl = ref.regl;
    var gl = ref.gl;
  
    // process per-line settings
    options.forEach(function (o, i) {
      var state = this$1.passes[i]
  
      if (o === undefined) { return }
  
      // null-argument removes pass
      if (o === null) {
        this$1.passes[i] = null
        return
      }
  
      if (typeof o[0] === 'number') { o = {positions: o} }
  
      // handle aliases
      o = pick(o, {
        positions: 'positions points data coords',
        thickness: 'thickness lineWidth lineWidths line-width linewidth width stroke-width strokewidth strokeWidth',
        join: 'lineJoin linejoin join type mode',
        miterLimit: 'miterlimit miterLimit',
        dashes: 'dash dashes dasharray dash-array dashArray',
        color: 'color colour stroke colors colours stroke-color strokeColor',
        fill: 'fill fill-color fillColor',
        opacity: 'alpha opacity',
        overlay: 'overlay crease overlap intersect',
        close: 'closed close closed-path closePath',
        range: 'range dataBox',
        viewport: 'viewport viewBox',
        hole: 'holes hole hollow'
      })
  
      // init state
      if (!state) {
        this$1.passes[i] = state = {
          id: i,
          scale: null,
          scaleFract: null,
          translate: null,
          translateFract: null,
          count: 0,
          hole: [],
          depth: 0,
  
          dashLength: 1,
          dashTexture: regl.texture({
            channels: 1,
            data: new Uint8Array([255]),
            width: 1,
            height: 1,
            mag: 'linear',
            min: 'linear'
          }),
  
          colorBuffer: regl.buffer({
            usage: 'dynamic',
            type: 'uint8',
            data: new Uint8Array()
          }),
          positionBuffer: regl.buffer({
            usage: 'dynamic',
            type: 'float',
            data: new Uint8Array()
          }),
          positionFractBuffer: regl.buffer({
            usage: 'dynamic',
            type: 'float',
            data: new Uint8Array()
          })
        }
  
        o = extend({}, Line2D.defaults, o)
      }
      if (o.thickness != null) { state.thickness = parseFloat(o.thickness) }
      if (o.opacity != null) { state.opacity = parseFloat(o.opacity) }
      if (o.miterLimit != null) { state.miterLimit = parseFloat(o.miterLimit) }
      if (o.overlay != null) {
        state.overlay = !!o.overlay
        if (i < Line2D.maxLines) {
          state.depth = 2 * (Line2D.maxLines - 1 - i % Line2D.maxLines) / Line2D.maxLines - 1.;
        }
      }
      if (o.join != null) { state.join = o.join }
      if (o.hole != null) { state.hole = o.hole }
      if (o.fill != null) { state.fill = !o.fill ? null : rgba(o.fill, 'uint8') }
      if (o.viewport != null) { state.viewport = parseRect(o.viewport) }
  
      if (!state.viewport) {
        state.viewport = parseRect([
          gl.drawingBufferWidth,
          gl.drawingBufferHeight
        ])
      }
  
      if (o.close != null) { state.close = o.close }
  
      // reset positions
      if (o.positions === null) { o.positions = [] }
      if (o.positions) {
        var positions, count
  
        // if positions are an object with x/y
        if (o.positions.x && o.positions.y) {
          var xPos = o.positions.x
          var yPos = o.positions.y
          count = state.count = Math.max(
            xPos.length,
            yPos.length
          )
          positions = new Float64Array(count * 2)
          for (var i$1 = 0; i$1 < count; i$1++) {
            positions[i$1 * 2] = xPos[i$1]
            positions[i$1 * 2 + 1] = yPos[i$1]
          }
        }
        else {
          positions = flatten(o.positions, 'float64')
          count = state.count = Math.floor(positions.length / 2)
        }
  
        var bounds = state.bounds = getBounds(positions, 2)
  
        // create fill positions
        // FIXME: fill positions can be set only along with positions
        if (state.fill) {
          var pos = []
  
          // filter bad vertices and remap triangles to ensure shape
          var ids = {}
          var lastId = 0
  
          for (var i$2 = 0, ptr = 0, l = state.count; i$2 < l; i$2++) {
            var x = positions[i$2*2]
            var y = positions[i$2*2 + 1]
            if (isNaN(x) || isNaN(y) || x == null || y == null) {
              x = positions[lastId*2]
              y = positions[lastId*2 + 1]
              ids[i$2] = lastId
            }
            else {
              lastId = i$2
            }
            pos[ptr++] = x
            pos[ptr++] = y
          }
  
          var triangles = triangulate(pos, state.hole || [])
  
          for (var i$3 = 0, l$1 = triangles.length; i$3 < l$1; i$3++) {
            if (ids[triangles[i$3]] != null) { triangles[i$3] = ids[triangles[i$3]] }
          }
  
          state.triangles = triangles
        }
  
        // update position buffers
        var npos = new Float64Array(positions)
        normalize(npos, 2, bounds)
  
        var positionData = new Float64Array(count * 2 + 6)
  
        // rotate first segment join
        if (state.close) {
          if (positions[0] === positions[count*2 - 2] &&
            positions[1] === positions[count*2 - 1]) {
            positionData[0] = npos[count*2 - 4]
            positionData[1] = npos[count*2 - 3]
          }
          else {
            positionData[0] = npos[count*2 - 2]
            positionData[1] = npos[count*2 - 1]
          }
        }
        else {
          positionData[0] = npos[0]
          positionData[1] = npos[1]
        }
  
        positionData.set(npos, 2)
  
        // add last segment
        if (state.close) {
          // ignore coinciding start/end
          if (positions[0] === positions[count*2 - 2] &&
            positions[1] === positions[count*2 - 1]) {
            positionData[count*2 + 2] = npos[2]
            positionData[count*2 + 3] = npos[3]
            state.count -= 1
          }
          else {
            positionData[count*2 + 2] = npos[0]
            positionData[count*2 + 3] = npos[1]
            positionData[count*2 + 4] = npos[2]
            positionData[count*2 + 5] = npos[3]
          }
        }
        // add stub
        else {
          positionData[count*2 + 2] = npos[count*2 - 2]
          positionData[count*2 + 3] = npos[count*2 - 1]
          positionData[count*2 + 4] = npos[count*2 - 2]
          positionData[count*2 + 5] = npos[count*2 - 1]
        }
  
        state.positionBuffer(float32(positionData))
        state.positionFractBuffer(fract32(positionData))
      }
  
      if (o.range) {
        state.range = o.range
      } else if (!state.range) {
        state.range = state.bounds
      }
  
      if ((o.range || o.positions) && state.count) {
        var bounds$1 = state.bounds
  
        var boundsW = bounds$1[2] - bounds$1[0],
          boundsH = bounds$1[3] - bounds$1[1]
  
        var rangeW = state.range[2] - state.range[0],
          rangeH = state.range[3] - state.range[1]
  
        state.scale = [
          boundsW / rangeW,
          boundsH / rangeH
        ]
        state.translate = [
          -state.range[0] / rangeW + bounds$1[0] / rangeW || 0,
          -state.range[1] / rangeH + bounds$1[1] / rangeH || 0
        ]
  
        state.scaleFract = fract32(state.scale)
        state.translateFract = fract32(state.translate)
      }
  
      if (o.dashes) {
        var dashLength = 0., dashData
  
        if (!o.dashes || o.dashes.length < 2) {
          dashLength = 1.
          dashData = new Uint8Array([255, 255, 255, 255, 255, 255, 255, 255])
        }
  
        else {
          dashLength = 0.;
          for(var i$4 = 0; i$4 < o.dashes.length; ++i$4) {
            dashLength += o.dashes[i$4]
          }
          dashData = new Uint8Array(dashLength * Line2D.dashMult)
          var ptr$1 = 0
          var fillColor = 255
  
          // repeat texture two times to provide smooth 0-step
          for (var k = 0; k < 2; k++) {
            for(var i$5 = 0; i$5 < o.dashes.length; ++i$5) {
              for(var j = 0, l$2 = o.dashes[i$5] * Line2D.dashMult * .5; j < l$2; ++j) {
                dashData[ptr$1++] = fillColor
              }
              fillColor ^= 255
            }
          }
        }
  
        state.dashLength = dashLength
        state.dashTexture({
          channels: 1,
          data: dashData,
          width: dashData.length,
          height: 1,
          mag: 'linear',
          min: 'linear'
        }, 0, 0)
      }
  
      if (o.color) {
        var count$1 = state.count
        var colors = o.color
  
        if (!colors) { colors = 'transparent' }
  
        var colorData = new Uint8Array(count$1 * 4 + 4)
  
        // convert colors to typed arrays
        if (!Array.isArray(colors) || typeof colors[0] === 'number') {
          var c = rgba(colors, 'uint8')
  
          for (var i$6 = 0; i$6 < count$1 + 1; i$6++) {
            colorData.set(c, i$6 * 4)
          }
        } else {
          for (var i$7 = 0; i$7 < count$1; i$7++) {
            var c$1 = rgba(colors[i$7], 'uint8')
            colorData.set(c$1, i$7 * 4)
          }
          colorData.set(rgba(colors[0], 'uint8'), count$1 * 4)
        }
  
        state.colorBuffer({
          usage: 'dynamic',
          type: 'uint8',
          data: colorData
        })
      }
    })
  
    // remove unmentioned passes
    if (options.length < this.passes.length) {
      for (var i = options.length; i < this.passes.length; i++) {
        var pass = this.passes[i]
        if (!pass) { continue }
        pass.colorBuffer.destroy()
        pass.positionBuffer.destroy()
        pass.dashTexture.destroy()
      }
      this.passes.length = options.length
    }
  
    // remove null items
    var passes = []
    for (var i$1 = 0; i$1 < this.passes.length; i$1++) {
      if (this.passes[i$1] !== null) { passes.push(this.passes[i$1]) }
    }
    this.passes = passes
  
    return this
  }
  
  Line2D.prototype.destroy = function () {
    this.passes.forEach(function (pass) {
      pass.colorBuffer.destroy()
      pass.positionBuffer.destroy()
      pass.dashTexture.destroy()
    })
  
    this.passes.length = 0
  
    return this
  }
  
  },{"array-bounds":70,"array-normalize":71,"color-normalize":125,"earcut":177,"es6-weak-map":233,"flatten-vertex-data":244,"glslify":413,"object-assign":473,"parse-rect":478,"pick-by-alias":485,"to-float32":549}],510:[function(_dereq_,module,exports){
  'use strict';
  
  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }
  
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  
  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }
  
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }
  
  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
  
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
  
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
  
    return _arr;
  }
  
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
  
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  
    return arr2;
  }
  
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  
  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  
  var rgba = _dereq_('color-normalize');
  
  var getBounds = _dereq_('array-bounds');
  
  var colorId = _dereq_('color-id');
  
  var cluster = _dereq_('@plotly/point-cluster');
  
  var extend = _dereq_('object-assign');
  
  var glslify = _dereq_('glslify');
  
  var pick = _dereq_('pick-by-alias');
  
  var updateDiff = _dereq_('update-diff');
  
  var flatten = _dereq_('flatten-vertex-data');
  
  var ie = _dereq_('is-iexplorer');
  
  var f32 = _dereq_('to-float32');
  
  var parseRect = _dereq_('parse-rect');
  
  var scatter = Scatter;
  
  function Scatter(regl, options) {
    var _this = this;
  
    if (!(this instanceof Scatter)) return new Scatter(regl, options);
  
    if (typeof regl === 'function') {
      if (!options) options = {};
      options.regl = regl;
    } else {
      options = regl;
      regl = null;
    }
  
    if (options && options.length) options.positions = options;
    regl = options.regl; // persistent variables
  
    var gl = regl._gl,
        paletteTexture,
        palette = [],
        paletteIds = {},
        // state
    groups = [],
        // textures for marker keys
    markerTextures = [null],
        markerCache = [null];
    var maxColors = 255,
        maxSize = 100; // direct color buffer mode
    // IE does not support palette anyways
  
    this.tooManyColors = ie; // texture with color palette
  
    paletteTexture = regl.texture({
      data: new Uint8Array(maxColors * 4),
      width: maxColors,
      height: 1,
      type: 'uint8',
      format: 'rgba',
      wrapS: 'clamp',
      wrapT: 'clamp',
      mag: 'nearest',
      min: 'nearest'
    });
    extend(this, {
      regl: regl,
      gl: gl,
      groups: groups,
      markerCache: markerCache,
      markerTextures: markerTextures,
      palette: palette,
      paletteIds: paletteIds,
      paletteTexture: paletteTexture,
      maxColors: maxColors,
      maxSize: maxSize,
      canvas: gl.canvas
    });
    this.update(options); // common shader options
  
    var shaderOptions = {
      uniforms: {
        constPointSize: !!options.constPointSize,
        pixelRatio: regl.context('pixelRatio'),
        palette: paletteTexture,
        paletteSize: function paletteSize(ctx, prop) {
          return [_this.tooManyColors ? 0 : maxColors, paletteTexture.height];
        },
        scale: regl.prop('scale'),
        scaleFract: regl.prop('scaleFract'),
        translate: regl.prop('translate'),
        translateFract: regl.prop('translateFract'),
        opacity: regl.prop('opacity'),
        marker: regl.prop('markerTexture')
      },
      attributes: {
        // FIXME: optimize these parts
        x: function x(ctx, prop) {
          return prop.xAttr || {
            buffer: prop.positionBuffer,
            stride: 8,
            offset: 0
          };
        },
        y: function y(ctx, prop) {
          return prop.yAttr || {
            buffer: prop.positionBuffer,
            stride: 8,
            offset: 4
          };
        },
        xFract: function xFract(ctx, prop) {
          return prop.xAttr ? {
            constant: [0, 0]
          } : {
            buffer: prop.positionFractBuffer,
            stride: 8,
            offset: 0
          };
        },
        yFract: function yFract(ctx, prop) {
          return prop.yAttr ? {
            constant: [0, 0]
          } : {
            buffer: prop.positionFractBuffer,
            stride: 8,
            offset: 4
          };
        },
        size: function size(ctx, prop) {
          return prop.size.length ? {
            buffer: prop.sizeBuffer,
            stride: 2,
            offset: 0
          } : {
            constant: [Math.round(prop.size * 255 / _this.maxSize)]
          };
        },
        borderSize: function borderSize(ctx, prop) {
          return prop.borderSize.length ? {
            buffer: prop.sizeBuffer,
            stride: 2,
            offset: 1
          } : {
            constant: [Math.round(prop.borderSize * 255 / _this.maxSize)]
          };
        },
        colorId: function colorId(ctx, prop) {
          return prop.color.length ? {
            buffer: prop.colorBuffer,
            stride: _this.tooManyColors ? 8 : 4,
            offset: 0
          } : {
            constant: _this.tooManyColors ? palette.slice(prop.color * 4, prop.color * 4 + 4) : [prop.color]
          };
        },
        borderColorId: function borderColorId(ctx, prop) {
          return prop.borderColor.length ? {
            buffer: prop.colorBuffer,
            stride: _this.tooManyColors ? 8 : 4,
            offset: _this.tooManyColors ? 4 : 2
          } : {
            constant: _this.tooManyColors ? palette.slice(prop.borderColor * 4, prop.borderColor * 4 + 4) : [prop.borderColor]
          };
        },
        isActive: function isActive(ctx, prop) {
          return prop.activation === true ? {
            constant: [1]
          } : prop.activation ? prop.activation : {
            constant: [0]
          };
        }
      },
      blend: {
        enable: true,
        color: [0, 0, 0, 1],
        // photoshop blending
        func: {
          srcRGB: 'src alpha',
          dstRGB: 'one minus src alpha',
          srcAlpha: 'one minus dst alpha',
          dstAlpha: 'one'
        }
      },
      scissor: {
        enable: true,
        box: regl.prop('viewport')
      },
      viewport: regl.prop('viewport'),
      stencil: {
        enable: false
      },
      depth: {
        enable: false
      },
      elements: regl.prop('elements'),
      count: regl.prop('count'),
      offset: regl.prop('offset'),
      primitive: 'points'
    }; // draw sdf-marker
  
    var markerOptions = extend({}, shaderOptions);
    markerOptions.frag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragWidth, fragBorderColorLevel, fragColorLevel;\n\nuniform sampler2D marker;\nuniform float opacity;\n\nfloat smoothStep(float x, float y) {\n  return 1.0 / (1.0 + exp(50.0*(x - y)));\n}\n\nvoid main() {\n  float dist = texture2D(marker, gl_PointCoord).r, delta = fragWidth;\n\n  // max-distance alpha\n  if (dist < 0.003) discard;\n\n  // null-border case\n  if (fragBorderColorLevel == fragColorLevel || fragBorderColor.a == 0.) {\n    float colorAmt = smoothstep(.5 - delta, .5 + delta, dist);\n    gl_FragColor = vec4(fragColor.rgb, colorAmt * fragColor.a * opacity);\n  }\n  else {\n    float borderColorAmt = smoothstep(fragBorderColorLevel - delta, fragBorderColorLevel + delta, dist);\n    float colorAmt = smoothstep(fragColorLevel - delta, fragColorLevel + delta, dist);\n\n    vec4 color = fragBorderColor;\n    color.a *= borderColorAmt;\n    color = mix(color, fragColor, colorAmt);\n    color.a *= opacity;\n\n    gl_FragColor = color;\n  }\n\n}\n"]);
    markerOptions.vert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform vec2 scale, scaleFract, translate, translateFract, paletteSize;\nuniform float pixelRatio;\nuniform bool constPointSize;\nuniform sampler2D palette;\n\nconst float maxSize = 100.;\nconst float borderLevel = .5;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragPointSize, fragBorderRadius, fragWidth, fragBorderColorLevel, fragColorLevel;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(palette,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = 2. * size * pointSizeScale;\n  fragPointSize = size * pixelRatio;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragColor = color;\n  fragBorderColor = borderColor;\n  fragWidth = 1. / gl_PointSize;\n\n  fragBorderColorLevel = clamp(borderLevel - borderLevel * borderSize / size, 0., 1.);\n  fragColorLevel = clamp(borderLevel + (1. - borderLevel) * borderSize / size, 0., 1.);\n}"]);
    this.drawMarker = regl(markerOptions); // draw circle
  
    var circleOptions = extend({}, shaderOptions);
    circleOptions.frag = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor, fragBorderColor;\n\nuniform float opacity;\nvarying float fragBorderRadius, fragWidth;\n\nfloat smoothStep(float edge0, float edge1, float x) {\n\tfloat t;\n\tt = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);\n\treturn t * t * (3.0 - 2.0 * t);\n}\n\nvoid main() {\n\tfloat radius, alpha = 1.0, delta = fragWidth;\n\n\tradius = length(2.0 * gl_PointCoord.xy - 1.0);\n\n\tif (radius > 1.0 + delta) {\n\t\tdiscard;\n\t}\n\n\talpha -= smoothstep(1.0 - delta, 1.0 + delta, radius);\n\n\tfloat borderRadius = fragBorderRadius;\n\tfloat ratio = smoothstep(borderRadius - delta, borderRadius + delta, radius);\n\tvec4 color = mix(fragColor, fragBorderColor, ratio);\n\tcolor.a *= alpha * opacity;\n\tgl_FragColor = color;\n}\n"]);
    circleOptions.vert = glslify(["precision highp float;\n#define GLSLIFY 1\n\nattribute float x, y, xFract, yFract;\nattribute float size, borderSize;\nattribute vec4 colorId, borderColorId;\nattribute float isActive;\n\nuniform vec2 scale, scaleFract, translate, translateFract;\nuniform float pixelRatio;\nuniform bool constPointSize;\nuniform sampler2D palette;\nuniform vec2 paletteSize;\n\nconst float maxSize = 100.;\n\nvarying vec4 fragColor, fragBorderColor;\nvarying float fragBorderRadius, fragWidth;\n\nfloat pointSizeScale = (constPointSize) ? 2. : pixelRatio;\n\nbool isDirect = (paletteSize.x < 1.);\n\nvec4 getColor(vec4 id) {\n  return isDirect ? id / 255. : texture2D(palette,\n    vec2(\n      (id.x + .5) / paletteSize.x,\n      (id.y + .5) / paletteSize.y\n    )\n  );\n}\n\nvoid main() {\n  // ignore inactive points\n  if (isActive == 0.) return;\n\n  vec2 position = vec2(x, y);\n  vec2 positionFract = vec2(xFract, yFract);\n\n  vec4 color = getColor(colorId);\n  vec4 borderColor = getColor(borderColorId);\n\n  float size = size * maxSize / 255.;\n  float borderSize = borderSize * maxSize / 255.;\n\n  gl_PointSize = (size + borderSize) * pointSizeScale;\n\n  vec2 pos = (position + translate) * scale\n      + (positionFract + translateFract) * scale\n      + (position + translate) * scaleFract\n      + (positionFract + translateFract) * scaleFract;\n\n  gl_Position = vec4(pos * 2. - 1., 0., 1.);\n\n  fragBorderRadius = 1. - 2. * borderSize / (size + borderSize);\n  fragColor = color;\n  fragBorderColor = borderColor.a == 0. || borderSize == 0. ? vec4(color.rgb, 0.) : borderColor;\n  fragWidth = 1. / gl_PointSize;\n}\n"]); // polyfill IE
  
    if (ie) {
      circleOptions.frag = circleOptions.frag.replace('smoothstep', 'smoothStep');
      markerOptions.frag = markerOptions.frag.replace('smoothstep', 'smoothStep');
    }
  
    this.drawCircle = regl(circleOptions);
  } // single pass defaults
  
  
  Scatter.defaults = {
    color: 'black',
    borderColor: 'transparent',
    borderSize: 0,
    size: 12,
    opacity: 1,
    marker: undefined,
    viewport: null,
    range: null,
    pixelSize: null,
    count: 0,
    offset: 0,
    bounds: null,
    positions: [],
    snap: 1e4
  }; // update & redraw
  
  Scatter.prototype.render = function () {
    if (arguments.length) {
      this.update.apply(this, arguments);
    }
  
    this.draw();
    return this;
  }; // draw all groups or only indicated ones
  
  
  Scatter.prototype.draw = function () {
    var _this2 = this;
  
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
  
    var groups = this.groups; // if directly array passed - treat as passes
  
    if (args.length === 1 && Array.isArray(args[0]) && (args[0][0] === null || Array.isArray(args[0][0]))) {
      args = args[0];
    } // FIXME: remove once https://github.com/regl-project/regl/issues/474 resolved
  
  
    this.regl._refresh();
  
    if (args.length) {
      for (var i = 0; i < args.length; i++) {
        this.drawItem(i, args[i]);
      }
    } // draw all passes
    else {
        groups.forEach(function (group, i) {
          _this2.drawItem(i);
        });
      }
  
    return this;
  }; // draw specific scatter group
  
  
  Scatter.prototype.drawItem = function (id, els) {
    var groups = this.groups;
    var group = groups[id]; // debug viewport
    // let { viewport } = group
    // gl.enable(gl.SCISSOR_TEST);
    // gl.scissor(viewport.x, viewport.y, viewport.width, viewport.height);
    // gl.clearColor(0, 0, 0, .5);
    // gl.clear(gl.COLOR_BUFFER_BIT);
  
    if (typeof els === 'number') {
      id = els;
      group = groups[els];
      els = null;
    }
  
    if (!(group && group.count && group.opacity)) return; // draw circles
  
    if (group.activation[0]) {
      // TODO: optimize this performance by making groups and regl.this props
      this.drawCircle(this.getMarkerDrawOptions(0, group, els));
    } // draw all other available markers
  
  
    var batch = [];
  
    for (var i = 1; i < group.activation.length; i++) {
      if (!group.activation[i] || group.activation[i] !== true && !group.activation[i].data.length) continue;
      batch.push.apply(batch, _toConsumableArray(this.getMarkerDrawOptions(i, group, els)));
    }
  
    if (batch.length) {
      this.drawMarker(batch);
    }
  }; // get options for the marker ids
  
  
  Scatter.prototype.getMarkerDrawOptions = function (markerId, group, elements) {
    var range = group.range,
        tree = group.tree,
        viewport = group.viewport,
        activation = group.activation,
        selectionBuffer = group.selectionBuffer,
        count = group.count;
    var regl = this.regl; // direct points
  
    if (!tree) {
      // if elements array - draw unclustered points
      if (elements) {
        return [extend({}, group, {
          markerTexture: this.markerTextures[markerId],
          activation: activation[markerId],
          count: elements.length,
          elements: elements,
          offset: 0
        })];
      }
  
      return [extend({}, group, {
        markerTexture: this.markerTextures[markerId],
        activation: activation[markerId],
        offset: 0
      })];
    } // clustered points
  
  
    var batch = [];
    var lod = tree.range(range, {
      lod: true,
      px: [(range[2] - range[0]) / viewport.width, (range[3] - range[1]) / viewport.height]
    }); // enable elements by using selection buffer
  
    if (elements) {
      var markerActivation = activation[markerId];
      var mask = markerActivation.data;
      var data = new Uint8Array(count);
  
      for (var i = 0; i < elements.length; i++) {
        var id = elements[i];
        data[id] = mask ? mask[id] : 1;
      }
  
      selectionBuffer.subdata(data);
    }
  
    for (var l = lod.length; l--;) {
      var _lod$l = _slicedToArray(lod[l], 2),
          from = _lod$l[0],
          to = _lod$l[1];
  
      batch.push(extend({}, group, {
        markerTexture: this.markerTextures[markerId],
        activation: elements ? selectionBuffer : activation[markerId],
        offset: from,
        count: to - from
      }));
    }
  
    return batch;
  }; // update groups options
  
  
  Scatter.prototype.update = function () {
    var _this3 = this;
  
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
  
    if (!args.length) return; // passes are as single array
  
    if (args.length === 1 && Array.isArray(args[0])) args = args[0];
    var groups = this.groups,
        gl = this.gl,
        regl = this.regl,
        maxSize = this.maxSize,
        maxColors = this.maxColors,
        palette = this.palette;
    this.groups = groups = args.map(function (options, i) {
      var group = groups[i];
      if (options === undefined) return group;
      if (options === null) options = {
        positions: null
      };else if (typeof options === 'function') options = {
        ondraw: options
      };else if (typeof options[0] === 'number') options = {
        positions: options
      }; // copy options to avoid mutation & handle aliases
  
      options = pick(options, {
        positions: 'positions data points',
        snap: 'snap cluster lod tree',
        size: 'sizes size radius',
        borderSize: 'borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline',
        color: 'colors color fill fill-color fillColor',
        borderColor: 'borderColors borderColor stroke stroke-color strokeColor',
        marker: 'markers marker shape',
        range: 'range dataBox databox',
        viewport: 'viewport viewPort viewBox viewbox',
        opacity: 'opacity alpha transparency',
        bounds: 'bound bounds boundaries limits',
        tooManyColors: 'tooManyColors palette paletteMode optimizePalette enablePalette'
      });
      if (options.positions === null) options.positions = [];
      if (options.tooManyColors != null) _this3.tooManyColors = options.tooManyColors;
  
      if (!group) {
        groups[i] = group = {
          id: i,
          scale: null,
          translate: null,
          scaleFract: null,
          translateFract: null,
          // buffers for active markers
          activation: [],
          // buffer for filtered markers
          selectionBuffer: regl.buffer({
            data: new Uint8Array(0),
            usage: 'stream',
            type: 'uint8'
          }),
          // buffers with data: it is faster to switch them per-pass
          // than provide one congregate buffer
          sizeBuffer: regl.buffer({
            data: new Uint8Array(0),
            usage: 'dynamic',
            type: 'uint8'
          }),
          colorBuffer: regl.buffer({
            data: new Uint8Array(0),
            usage: 'dynamic',
            type: 'uint8'
          }),
          positionBuffer: regl.buffer({
            data: new Uint8Array(0),
            usage: 'dynamic',
            type: 'float'
          }),
          positionFractBuffer: regl.buffer({
            data: new Uint8Array(0),
            usage: 'dynamic',
            type: 'float'
          })
        };
        options = extend({}, Scatter.defaults, options);
      } // force update triggers
  
  
      if (options.positions && !('marker' in options)) {
        options.marker = group.marker;
        delete group.marker;
      } // updating markers cause recalculating snapping
  
  
      if (options.marker && !('positions' in options)) {
        options.positions = group.positions;
        delete group.positions;
      } // global count of points
  
  
      var hasSize = 0,
          hasColor = 0;
      updateDiff(group, options, [{
        snap: true,
        size: function size(s, group) {
          if (s == null) s = Scatter.defaults.size;
          hasSize += s && s.length ? 1 : 0;
          return s;
        },
        borderSize: function borderSize(s, group) {
          if (s == null) s = Scatter.defaults.borderSize;
          hasSize += s && s.length ? 1 : 0;
          return s;
        },
        opacity: parseFloat,
        // add colors to palette, save references
        color: function color(c, group) {
          if (c == null) c = Scatter.defaults.color;
          c = _this3.updateColor(c);
          hasColor++;
          return c;
        },
        borderColor: function borderColor(c, group) {
          if (c == null) c = Scatter.defaults.borderColor;
          c = _this3.updateColor(c);
          hasColor++;
          return c;
        },
        bounds: function bounds(_bounds, group, options) {
          if (!('range' in options)) options.range = null;
          return _bounds;
        },
        positions: function positions(_positions, group, options) {
          var snap = group.snap;
          var positionBuffer = group.positionBuffer,
              positionFractBuffer = group.positionFractBuffer,
              selectionBuffer = group.selectionBuffer; // separate buffers for x/y coordinates
  
          if (_positions.x || _positions.y) {
            if (_positions.x.length) {
              group.xAttr = {
                buffer: regl.buffer(_positions.x),
                offset: 0,
                stride: 4,
                count: _positions.x.length
              };
            } else {
              group.xAttr = {
                buffer: _positions.x.buffer,
                offset: _positions.x.offset * 4 || 0,
                stride: (_positions.x.stride || 1) * 4,
                count: _positions.x.count
              };
            }
  
            if (_positions.y.length) {
              group.yAttr = {
                buffer: regl.buffer(_positions.y),
                offset: 0,
                stride: 4,
                count: _positions.y.length
              };
            } else {
              group.yAttr = {
                buffer: _positions.y.buffer,
                offset: _positions.y.offset * 4 || 0,
                stride: (_positions.y.stride || 1) * 4,
                count: _positions.y.count
              };
            }
  
            group.count = Math.max(group.xAttr.count, group.yAttr.count);
            return _positions;
          }
  
          _positions = flatten(_positions, 'float64');
          var count = group.count = Math.floor(_positions.length / 2);
          var bounds = group.bounds = count ? getBounds(_positions, 2) : null; // if range is not provided updated - recalc it
  
          if (!options.range && !group.range) {
            delete group.range;
            options.range = bounds;
          } // reset marker
  
  
          if (!options.marker && !group.marker) {
            delete group.marker;
            options.marker = null;
          } // build cluster tree if required
  
  
          if (snap && (snap === true || count > snap)) {
            group.tree = cluster(_positions, {
              bounds: bounds
            });
          } // existing tree instance
          else if (snap && snap.length) {
              group.tree = snap;
            }
  
          if (group.tree) {
            var opts = {
              primitive: 'points',
              usage: 'static',
              data: group.tree,
              type: 'uint32'
            };
            if (group.elements) group.elements(opts);else group.elements = regl.elements(opts);
          } // update position buffers
  
  
          positionBuffer({
            data: f32.float(_positions),
            usage: 'dynamic'
          });
          positionFractBuffer({
            data: f32.fract(_positions),
            usage: 'dynamic'
          }); // expand selectionBuffer
  
          selectionBuffer({
            data: new Uint8Array(count),
            type: 'uint8',
            usage: 'stream'
          });
          return _positions;
        }
      }, {
        // create marker ids corresponding to known marker textures
        marker: function marker(markers, group, options) {
          var activation = group.activation; // reset marker elements
  
          activation.forEach(function (buffer) {
            return buffer && buffer.destroy && buffer.destroy();
          });
          activation.length = 0; // single sdf marker
  
          if (!markers || typeof markers[0] === 'number') {
            var id = _this3.addMarker(markers);
  
            activation[id] = true;
          } // per-point markers use mask buffers to enable markers in vert shader
          else {
              var markerMasks = [];
  
              for (var _i = 0, l = Math.min(markers.length, group.count); _i < l; _i++) {
                var _id = _this3.addMarker(markers[_i]);
  
                if (!markerMasks[_id]) markerMasks[_id] = new Uint8Array(group.count); // enable marker by default
  
                markerMasks[_id][_i] = 1;
              }
  
              for (var _id2 = 0; _id2 < markerMasks.length; _id2++) {
                if (!markerMasks[_id2]) continue;
                var opts = {
                  data: markerMasks[_id2],
                  type: 'uint8',
                  usage: 'static'
                };
  
                if (!activation[_id2]) {
                  activation[_id2] = regl.buffer(opts);
                } else {
                  activation[_id2](opts);
                }
  
                activation[_id2].data = markerMasks[_id2];
              }
            }
  
          return markers;
        },
        range: function range(_range, group, options) {
          var bounds = group.bounds; // FIXME: why do we need this?
  
          if (!bounds) return;
          if (!_range) _range = bounds;
          group.scale = [1 / (_range[2] - _range[0]), 1 / (_range[3] - _range[1])];
          group.translate = [-_range[0], -_range[1]];
          group.scaleFract = f32.fract(group.scale);
          group.translateFract = f32.fract(group.translate);
          return _range;
        },
        viewport: function viewport(vp) {
          var rect = parseRect(vp || [gl.drawingBufferWidth, gl.drawingBufferHeight]); // normalize viewport to the canvas coordinates
          // rect.y = gl.drawingBufferHeight - rect.height - rect.y
  
          return rect;
        }
      }]); // update size buffer, if needed
  
      if (hasSize) {
        var _group = group,
            count = _group.count,
            size = _group.size,
            borderSize = _group.borderSize,
            sizeBuffer = _group.sizeBuffer;
        var sizes = new Uint8Array(count * 2);
  
        if (size.length || borderSize.length) {
          for (var _i2 = 0; _i2 < count; _i2++) {
            // we downscale size to allow for fractions
            sizes[_i2 * 2] = Math.round((size[_i2] == null ? size : size[_i2]) * 255 / maxSize);
            sizes[_i2 * 2 + 1] = Math.round((borderSize[_i2] == null ? borderSize : borderSize[_i2]) * 255 / maxSize);
          }
        }
  
        sizeBuffer({
          data: sizes,
          usage: 'dynamic'
        });
      } // update color buffer if needed
  
  
      if (hasColor) {
        var _group2 = group,
            _count = _group2.count,
            color = _group2.color,
            borderColor = _group2.borderColor,
            colorBuffer = _group2.colorBuffer;
        var colors; // if too many colors - put colors to buffer directly
  
        if (_this3.tooManyColors) {
          if (color.length || borderColor.length) {
            colors = new Uint8Array(_count * 8);
  
            for (var _i3 = 0; _i3 < _count; _i3++) {
              var _colorId = color[_i3];
              colors[_i3 * 8] = palette[_colorId * 4];
              colors[_i3 * 8 + 1] = palette[_colorId * 4 + 1];
              colors[_i3 * 8 + 2] = palette[_colorId * 4 + 2];
              colors[_i3 * 8 + 3] = palette[_colorId * 4 + 3];
              var borderColorId = borderColor[_i3];
              colors[_i3 * 8 + 4] = palette[borderColorId * 4];
              colors[_i3 * 8 + 5] = palette[borderColorId * 4 + 1];
              colors[_i3 * 8 + 6] = palette[borderColorId * 4 + 2];
              colors[_i3 * 8 + 7] = palette[borderColorId * 4 + 3];
            }
          }
        } // if limited amount of colors - keep palette color picking
        // that saves significant memory
        else {
            if (color.length || borderColor.length) {
              // we need slight data increase by 2 due to vec4 borderId in shader
              colors = new Uint8Array(_count * 4 + 2);
  
              for (var _i4 = 0; _i4 < _count; _i4++) {
                // put color coords in palette texture
                if (color[_i4] != null) {
                  colors[_i4 * 4] = color[_i4] % maxColors;
                  colors[_i4 * 4 + 1] = Math.floor(color[_i4] / maxColors);
                }
  
                if (borderColor[_i4] != null) {
                  colors[_i4 * 4 + 2] = borderColor[_i4] % maxColors;
                  colors[_i4 * 4 + 3] = Math.floor(borderColor[_i4] / maxColors);
                }
              }
            }
          }
  
        colorBuffer({
          data: colors || new Uint8Array(0),
          type: 'uint8',
          usage: 'dynamic'
        });
      }
  
      return group;
    });
  }; // get (and create) marker texture id
  
  
  Scatter.prototype.addMarker = function (sdf) {
    var markerTextures = this.markerTextures,
        regl = this.regl,
        markerCache = this.markerCache;
    var pos = sdf == null ? 0 : markerCache.indexOf(sdf);
    if (pos >= 0) return pos; // convert sdf to 0..255 range
  
    var distArr;
  
    if (sdf instanceof Uint8Array || sdf instanceof Uint8ClampedArray) {
      distArr = sdf;
    } else {
      distArr = new Uint8Array(sdf.length);
  
      for (var i = 0, l = sdf.length; i < l; i++) {
        distArr[i] = sdf[i] * 255;
      }
    }
  
    var radius = Math.floor(Math.sqrt(distArr.length));
    pos = markerTextures.length;
    markerCache.push(sdf);
    markerTextures.push(regl.texture({
      channels: 1,
      data: distArr,
      radius: radius,
      mag: 'linear',
      min: 'linear'
    }));
    return pos;
  }; // register color to palette, return it's index or list of indexes
  
  
  Scatter.prototype.updateColor = function (colors) {
    var paletteIds = this.paletteIds,
        palette = this.palette,
        maxColors = this.maxColors;
  
    if (!Array.isArray(colors)) {
      colors = [colors];
    }
  
    var idx = []; // if color groups - flatten them
  
    if (typeof colors[0] === 'number') {
      var grouped = [];
  
      if (Array.isArray(colors)) {
        for (var i = 0; i < colors.length; i += 4) {
          grouped.push(colors.slice(i, i + 4));
        }
      } else {
        for (var _i5 = 0; _i5 < colors.length; _i5 += 4) {
          grouped.push(colors.subarray(_i5, _i5 + 4));
        }
      }
  
      colors = grouped;
    }
  
    for (var _i6 = 0; _i6 < colors.length; _i6++) {
      var color = colors[_i6];
      color = rgba(color, 'uint8');
      var id = colorId(color, false); // if new color - save it
  
      if (paletteIds[id] == null) {
        var pos = palette.length;
        paletteIds[id] = Math.floor(pos / 4);
        palette[pos] = color[0];
        palette[pos + 1] = color[1];
        palette[pos + 2] = color[2];
        palette[pos + 3] = color[3];
      }
  
      idx[_i6] = paletteIds[id];
    } // detect if too many colors in palette
  
  
    if (!this.tooManyColors && palette.length > maxColors * 4) this.tooManyColors = true; // limit max color
  
    this.updatePalette(palette); // keep static index for single-color property
  
    return idx.length === 1 ? idx[0] : idx;
  };
  
  Scatter.prototype.updatePalette = function (palette) {
    if (this.tooManyColors) return;
    var maxColors = this.maxColors,
        paletteTexture = this.paletteTexture;
    var requiredHeight = Math.ceil(palette.length * .25 / maxColors); // pad data
  
    if (requiredHeight > 1) {
      palette = palette.slice();
  
      for (var i = palette.length * .25 % maxColors; i < requiredHeight * maxColors; i++) {
        palette.push(0, 0, 0, 0);
      }
    } // ensure height
  
  
    if (paletteTexture.height < requiredHeight) {
      paletteTexture.resize(maxColors, requiredHeight);
    } // update full data
  
  
    paletteTexture.subimage({
      width: Math.min(palette.length * .25, maxColors),
      height: requiredHeight,
      data: palette
    }, 0, 0);
  }; // remove unused stuff
  
  
  Scatter.prototype.destroy = function () {
    this.groups.forEach(function (group) {
      group.sizeBuffer.destroy();
      group.positionBuffer.destroy();
      group.positionFractBuffer.destroy();
      group.colorBuffer.destroy();
      group.activation.forEach(function (b) {
        return b && b.destroy && b.destroy();
      });
      group.selectionBuffer.destroy();
      if (group.elements) group.elements.destroy();
    });
    this.groups.length = 0;
    this.paletteTexture.destroy();
    this.markerTextures.forEach(function (txt) {
      return txt && txt.destroy && txt.destroy();
    });
    return this;
  };
  
  var extend$1 = _dereq_('object-assign');
  
  var reglScatter2d = function reglScatter2d(regl, options) {
    var scatter$1 = new scatter(regl, options);
    var render = scatter$1.render.bind(scatter$1); // expose API
  
    extend$1(render, {
      render: render,
      update: scatter$1.update.bind(scatter$1),
      draw: scatter$1.draw.bind(scatter$1),
      destroy: scatter$1.destroy.bind(scatter$1),
      regl: scatter$1.regl,
      gl: scatter$1.gl,
      canvas: scatter$1.gl.canvas,
      groups: scatter$1.groups,
      markers: scatter$1.markerCache,
      palette: scatter$1.palette
    });
    return render;
  };
  
  module.exports = reglScatter2d;
  
  },{"@plotly/point-cluster":57,"array-bounds":70,"color-id":123,"color-normalize":125,"flatten-vertex-data":244,"glslify":413,"is-iexplorer":440,"object-assign":473,"parse-rect":478,"pick-by-alias":485,"to-float32":549,"update-diff":571}],511:[function(_dereq_,module,exports){
  'use strict'
  
  
  var createScatter = _dereq_('regl-scatter2d')
  var pick = _dereq_('pick-by-alias')
  var getBounds = _dereq_('array-bounds')
  var raf = _dereq_('raf')
  var arrRange = _dereq_('array-range')
  var rect = _dereq_('parse-rect')
  var flatten = _dereq_('flatten-vertex-data')
  
  
  module.exports = SPLOM
  
  
  // @constructor
  function SPLOM (regl, options) {
    if (!(this instanceof SPLOM)) { return new SPLOM(regl, options) }
  
    // render passes
    this.traces = []
  
    // passes for scatter, combined across traces
    this.passes = {}
  
    this.regl = regl
  
    // main scatter drawing instance
    this.scatter = createScatter(regl)
  
    this.canvas = this.scatter.canvas
  }
  
  
  // update & draw passes once per frame
  SPLOM.prototype.render = function () {
    var this$1 = this;
    var ref;
  
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    if (args.length) {
      (ref = this).update.apply(ref, args)
    }
  
    if (this.regl.attributes.preserveDrawingBuffer) { return this.draw() }
  
    // make sure draw is not called more often than once a frame
    if (this.dirty) {
      if (this.planned == null) {
        this.planned = raf(function () {
          this$1.draw()
          this$1.dirty = true
          this$1.planned = null
        })
      }
    }
    else {
      this.draw()
      this.dirty = true
      raf(function () {
        this$1.dirty = false
      })
    }
  
    return this
  }
  
  
  // update passes
  SPLOM.prototype.update = function () {
    var ref;
  
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    if (!args.length) { return }
  
    for (var i = 0; i < args.length; i++) {
      this.updateItem(i, args[i])
    }
  
    // remove nulled passes
    this.traces = this.traces.filter(Boolean)
  
    // FIXME: update passes independently
    var passes = []
    var offset = 0
    for (var i$1 = 0; i$1 < this.traces.length; i$1++) {
      var trace = this.traces[i$1]
      var tracePasses = this.traces[i$1].passes
      for (var j = 0; j < tracePasses.length; j++) {
        passes.push(this.passes[tracePasses[j]])
      }
      // save offset of passes
      trace.passOffset = offset
      offset += trace.passes.length
    }
  
    (ref = this.scatter).update.apply(ref, passes)
  
    return this
  }
  
  
  // update trace by index, not supposed to be called directly
  SPLOM.prototype.updateItem = function (i, options) {
    var ref = this;
    var regl = ref.regl;
  
    // remove pass if null
    if (options === null) {
      this.traces[i] = null
      return this
    }
  
    if (!options) { return this }
  
    var o = pick(options, {
      data: 'data items columns rows values dimensions samples x',
      snap: 'snap cluster',
      size: 'sizes size radius',
      color: 'colors color fill fill-color fillColor',
      opacity: 'opacity alpha transparency opaque',
      borderSize: 'borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline',
      borderColor: 'borderColors borderColor bordercolor stroke stroke-color strokeColor',
      marker: 'markers marker shape',
      range: 'range ranges databox dataBox',
      viewport: 'viewport viewBox viewbox',
      domain: 'domain domains area areas',
      padding: 'pad padding paddings pads margin margins',
      transpose: 'transpose transposed',
      diagonal: 'diagonal diag showDiagonal',
      upper: 'upper up top upperhalf upperHalf showupperhalf showUpper showUpperHalf',
      lower: 'lower low bottom lowerhalf lowerHalf showlowerhalf showLowerHalf showLower'
    })
  
    // we provide regl buffer per-trace, since trace data can be changed
    var trace = (this.traces[i] || (this.traces[i] = {
      id: i,
      buffer: regl.buffer({
        usage: 'dynamic',
        type: 'float',
        data: new Uint8Array()
      }),
      color: 'black',
      marker: null,
      size: 12,
      borderColor: 'transparent',
      borderSize: 1,
      viewport:  rect([regl._gl.drawingBufferWidth, regl._gl.drawingBufferHeight]),
      padding: [0, 0, 0, 0],
      opacity: 1,
      diagonal: true,
      upper: true,
      lower: true
    }))
  
  
    // save styles
    if (o.color != null) {
      trace.color = o.color
    }
    if (o.size != null) {
      trace.size = o.size
    }
    if (o.marker != null) {
      trace.marker = o.marker
    }
    if (o.borderColor != null) {
      trace.borderColor = o.borderColor
    }
    if (o.borderSize != null) {
      trace.borderSize = o.borderSize
    }
    if (o.opacity != null) {
      trace.opacity = o.opacity
    }
    if (o.viewport) {
      trace.viewport = rect(o.viewport)
    }
    if (o.diagonal != null) { trace.diagonal = o.diagonal }
    if (o.upper != null) { trace.upper = o.upper }
    if (o.lower != null) { trace.lower = o.lower }
  
    // put flattened data into buffer
    if (o.data) {
      trace.buffer(flatten(o.data))
      trace.columns = o.data.length
      trace.count = o.data[0].length
  
      // detect bounds per-column
      trace.bounds = []
  
      for (var i$1 = 0; i$1 < trace.columns; i$1++) {
        trace.bounds[i$1] = getBounds(o.data[i$1], 1)
      }
    }
  
    // add proper range updating markers
    var multirange
    if (o.range) {
      trace.range = o.range
      multirange = trace.range && typeof trace.range[0] !== 'number'
    }
  
    if (o.domain) {
      trace.domain = o.domain
    }
    var multipadding = false
    if (o.padding != null) {
      // multiple paddings
      if (Array.isArray(o.padding) && o.padding.length === trace.columns && typeof o.padding[o.padding.length - 1] === 'number') {
        trace.padding = o.padding.map(getPad)
        multipadding = true
      }
      // single padding
      else {
        trace.padding = getPad(o.padding)
      }
    }
  
    // create passes
    var m = trace.columns
    var n = trace.count
  
    var w = trace.viewport.width
    var h = trace.viewport.height
    var left = trace.viewport.x
    var top = trace.viewport.y
    var iw = w / m
    var ih = h / m
  
    trace.passes = []
  
    for (var i$2 = 0; i$2 < m; i$2++) {
      for (var j = 0; j < m; j++) {
        if (!trace.diagonal && j === i$2) { continue }
        if (!trace.upper && i$2 > j) { continue }
        if (!trace.lower && i$2 < j) { continue }
  
        var key = passId(trace.id, i$2, j)
  
        var pass = this.passes[key] || (this.passes[key] = {})
  
        if (o.data) {
          if (o.transpose) {
            pass.positions = {
              x: {buffer: trace.buffer, offset: j, count: n, stride: m},
              y: {buffer: trace.buffer, offset: i$2, count: n, stride: m}
            }
          }
          else {
            pass.positions = {
              x: {buffer: trace.buffer, offset: j * n, count: n},
              y: {buffer: trace.buffer, offset: i$2 * n, count: n}
            }
          }
  
          pass.bounds = getBox(trace.bounds, i$2, j)
        }
  
        if (o.domain || o.viewport || o.data) {
          var pad = multipadding ? getBox(trace.padding, i$2, j) : trace.padding
          if (trace.domain) {
            var ref$1 = getBox(trace.domain, i$2, j);
            var lox = ref$1[0];
            var loy = ref$1[1];
            var hix = ref$1[2];
            var hiy = ref$1[3];
  
            pass.viewport = [
              left + lox * w + pad[0],
              top + loy * h + pad[1],
              left + hix * w - pad[2],
              top + hiy * h - pad[3]
            ]
          }
          // consider auto-domain equipartial
          else {
            pass.viewport = [
              left + j * iw + iw * pad[0],
              top + i$2 * ih + ih * pad[1],
              left + (j + 1) * iw - iw * pad[2],
              top + (i$2 + 1) * ih - ih * pad[3]
            ]
          }
        }
  
        if (o.color) { pass.color = trace.color }
        if (o.size) { pass.size = trace.size }
        if (o.marker) { pass.marker = trace.marker }
        if (o.borderSize) { pass.borderSize = trace.borderSize }
        if (o.borderColor) { pass.borderColor = trace.borderColor }
        if (o.opacity) { pass.opacity = trace.opacity }
  
        if (o.range) {
          pass.range = multirange ? getBox(trace.range, i$2, j) : trace.range || pass.bounds
        }
  
        trace.passes.push(key)
      }
    }
  
    return this
  }
  
  
  // draw all or passed passes
  SPLOM.prototype.draw = function () {
    var ref$2;
  
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];
    if (!args.length) {
      this.scatter.draw()
    }
    else {
      var idx = []
      for (var i = 0; i < args.length; i++) {
        // draw(0, 2, 5) - draw traces
        if (typeof args[i] === 'number' ) {
          var ref = this.traces[args[i]];
          var passes = ref.passes;
          var passOffset = ref.passOffset;
          idx.push.apply(idx, arrRange(passOffset, passOffset + passes.length))
        }
        // draw([0, 1, 2 ...], [3, 4, 5]) - draw points
        else if (args[i].length) {
          var els = args[i]
          var ref$1 = this.traces[i];
          var passes$1 = ref$1.passes;
          var passOffset$1 = ref$1.passOffset;
          passes$1 = passes$1.map(function (passId, i) {
            idx[passOffset$1 + i] = els
          })
        }
      }
      (ref$2 = this.scatter).draw.apply(ref$2, idx)
    }
  
    return this
  }
  
  
  // dispose resources
  SPLOM.prototype.destroy = function () {
    this.traces.forEach(function (trace) {
      if (trace.buffer && trace.buffer.destroy) { trace.buffer.destroy() }
    })
    this.traces = null
    this.passes = null
  
    this.scatter.destroy()
  
    return this
  }
  
  
  // return pass corresponding to trace i- j- square
  function passId (trace, i, j) {
    var id = (trace.id != null ? trace.id : trace)
    var n = i
    var m = j
    var key = id << 16 | (n & 0xff) << 8 | m & 0xff
  
    return key
  }
  
  
  // return bounding box corresponding to a pass
  function getBox (items, i, j) {
    var ilox, iloy, ihix, ihiy, jlox, jloy, jhix, jhiy
    var iitem = items[i], jitem = items[j]
  
    if (iitem.length > 2) {
      ilox = iitem[0]
      ihix = iitem[2]
      iloy = iitem[1]
      ihiy = iitem[3]
    }
    else if (iitem.length) {
      ilox = iloy = iitem[0]
      ihix = ihiy = iitem[1]
    }
    else {
      ilox = iitem.x
      iloy = iitem.y
      ihix = iitem.x + iitem.width
      ihiy = iitem.y + iitem.height
    }
  
    if (jitem.length > 2) {
      jlox = jitem[0]
      jhix = jitem[2]
      jloy = jitem[1]
      jhiy = jitem[3]
    }
    else if (jitem.length) {
      jlox = jloy = jitem[0]
      jhix = jhiy = jitem[1]
    }
    else {
      jlox = jitem.x
      jloy = jitem.y
      jhix = jitem.x + jitem.width
      jhiy = jitem.y + jitem.height
    }
  
    return [ jlox, iloy, jhix, ihiy ]
  }
  
  
  function getPad (arg) {
    if (typeof arg === 'number') { return [arg, arg, arg, arg] }
    else if (arg.length === 2) { return [arg[0], arg[1], arg[0], arg[1]] }
    else {
      var box = rect(arg)
      return [box.x, box.y, box.x + box.width, box.y + box.height]
    }
  }
  
  },{"array-bounds":70,"array-range":72,"flatten-vertex-data":244,"parse-rect":478,"pick-by-alias":485,"raf":502,"regl-scatter2d":510}],512:[function(_dereq_,module,exports){
  (function(ja,N){"object"===typeof exports&&"undefined"!==typeof module?module.exports=N():"function"===typeof define&&define.amd?define(N):ja.createREGL=N()})(this,function(){function ja(a,b){this.id=Bb++;this.type=a;this.data=b}function N(a){if(0===a.length)return[];var b=a.charAt(0),c=a.charAt(a.length-1);if(1<a.length&&b===c&&('"'===b||"'"===b))return['"'+a.substr(1,a.length-2).replace(/\\/g,"\\\\").replace(/"/g,'\\"')+'"'];if(b=/\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(a))return N(a.substr(0,
  b.index)).concat(N(b[1])).concat(N(a.substr(b.index+b[0].length)));b=a.split(".");if(1===b.length)return['"'+a.replace(/\\/g,"\\\\").replace(/"/g,'\\"')+'"'];a=[];for(c=0;c<b.length;++c)a=a.concat(N(b[c]));return a}function bb(a){return"["+N(a).join("][")+"]"}function Cb(){var a={"":0},b=[""];return{id:function(c){var e=a[c];if(e)return e;e=a[c]=b.length;b.push(c);return e},str:function(a){return b[a]}}}function Db(a,b,c){function e(){var b=window.innerWidth,e=window.innerHeight;a!==document.body&&
  (e=a.getBoundingClientRect(),b=e.right-e.left,e=e.bottom-e.top);g.width=c*b;g.height=c*e;H(g.style,{width:b+"px",height:e+"px"})}var g=document.createElement("canvas");H(g.style,{border:0,margin:0,padding:0,top:0,left:0});a.appendChild(g);a===document.body&&(g.style.position="absolute",H(a.style,{margin:0,padding:0}));var d;a!==document.body&&"function"===typeof ResizeObserver?(d=new ResizeObserver(function(){setTimeout(e)}),d.observe(a)):window.addEventListener("resize",e,!1);e();return{canvas:g,
  onDestroy:function(){d?d.disconnect():window.removeEventListener("resize",e);a.removeChild(g)}}}function Eb(a,b){function c(c){try{return a.getContext(c,b)}catch(g){return null}}return c("webgl")||c("experimental-webgl")||c("webgl-experimental")}function cb(a){return"string"===typeof a?a.split():a}function db(a){return"string"===typeof a?document.querySelector(a):a}function Fb(a){var b=a||{},c,e,g,d;a={};var r=[],n=[],u="undefined"===typeof window?1:window.devicePixelRatio,q=!1,t=function(a){},m=
  function(){};"string"===typeof b?c=document.querySelector(b):"object"===typeof b&&("string"===typeof b.nodeName&&"function"===typeof b.appendChild&&"function"===typeof b.getBoundingClientRect?c=b:"function"===typeof b.drawArrays||"function"===typeof b.drawElements?(d=b,g=d.canvas):("gl"in b?d=b.gl:"canvas"in b?g=db(b.canvas):"container"in b&&(e=db(b.container)),"attributes"in b&&(a=b.attributes),"extensions"in b&&(r=cb(b.extensions)),"optionalExtensions"in b&&(n=cb(b.optionalExtensions)),"onDone"in
  b&&(t=b.onDone),"profile"in b&&(q=!!b.profile),"pixelRatio"in b&&(u=+b.pixelRatio)));c&&("canvas"===c.nodeName.toLowerCase()?g=c:e=c);if(!d){if(!g){c=Db(e||document.body,t,u);if(!c)return null;g=c.canvas;m=c.onDestroy}void 0===a.premultipliedAlpha&&(a.premultipliedAlpha=!0);d=Eb(g,a)}return d?{gl:d,canvas:g,container:e,extensions:r,optionalExtensions:n,pixelRatio:u,profile:q,onDone:t,onDestroy:m}:(m(),t("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org"),null)}
  function Gb(a,b){function c(b){b=b.toLowerCase();var c;try{c=e[b]=a.getExtension(b)}catch(g){}return!!c}for(var e={},g=0;g<b.extensions.length;++g){var d=b.extensions[g];if(!c(d))return b.onDestroy(),b.onDone('"'+d+'" extension is not supported by the current WebGL context, try upgrading your system or a different browser'),null}b.optionalExtensions.forEach(c);return{extensions:e,restore:function(){Object.keys(e).forEach(function(a){if(e[a]&&!c(a))throw Error("(regl): error restoring extension "+
  a);})}}}function A(a,b){for(var c=Array(a),e=0;e<a;++e)c[e]=b(e);return c}function eb(a){var b,c;b=(65535<a)<<4;a>>>=b;c=(255<a)<<3;a>>>=c;b|=c;c=(15<a)<<2;a>>>=c;b|=c;c=(3<a)<<1;return b|c|a>>>c>>1}function fb(){function a(a){a:{for(var b=16;268435456>=b;b*=16)if(a<=b){a=b;break a}a=0}b=c[eb(a)>>2];return 0<b.length?b.pop():new ArrayBuffer(a)}function b(a){c[eb(a.byteLength)>>2].push(a)}var c=A(8,function(){return[]});return{alloc:a,free:b,allocType:function(b,c){var d=null;switch(b){case 5120:d=
  new Int8Array(a(c),0,c);break;case 5121:d=new Uint8Array(a(c),0,c);break;case 5122:d=new Int16Array(a(2*c),0,c);break;case 5123:d=new Uint16Array(a(2*c),0,c);break;case 5124:d=new Int32Array(a(4*c),0,c);break;case 5125:d=new Uint32Array(a(4*c),0,c);break;case 5126:d=new Float32Array(a(4*c),0,c);break;default:return null}return d.length!==c?d.subarray(0,c):d},freeType:function(a){b(a.buffer)}}}function X(a){return!!a&&"object"===typeof a&&Array.isArray(a.shape)&&Array.isArray(a.stride)&&"number"===
  typeof a.offset&&a.shape.length===a.stride.length&&(Array.isArray(a.data)||G(a.data))}function gb(a,b,c,e,g,d){for(var r=0;r<b;++r)for(var n=a[r],u=0;u<c;++u)for(var q=n[u],t=0;t<e;++t)g[d++]=q[t]}function hb(a,b,c,e,g){for(var d=1,r=c+1;r<b.length;++r)d*=b[r];var n=b[c];if(4===b.length-c){var u=b[c+1],q=b[c+2];b=b[c+3];for(r=0;r<n;++r)gb(a[r],u,q,b,e,g),g+=d}else for(r=0;r<n;++r)hb(a[r],b,c+1,e,g),g+=d}function Fa(a){return Ga[Object.prototype.toString.call(a)]|0}function ib(a,b){for(var c=0;c<b.length;++c)a[c]=
  b[c]}function jb(a,b,c,e,g,d,r){for(var n=0,u=0;u<c;++u)for(var q=0;q<e;++q)a[n++]=b[g*u+d*q+r]}function Hb(a,b,c,e){function g(b){this.id=u++;this.buffer=a.createBuffer();this.type=b;this.usage=35044;this.byteLength=0;this.dimension=1;this.dtype=5121;this.persistentData=null;c.profile&&(this.stats={size:0})}function d(b,c,k){b.byteLength=c.byteLength;a.bufferData(b.type,c,k)}function r(a,b,c,h,f,p){a.usage=c;if(Array.isArray(b)){if(a.dtype=h||5126,0<b.length)if(Array.isArray(b[0])){f=kb(b);for(var l=
  h=1;l<f.length;++l)h*=f[l];a.dimension=h;b=Qa(b,f,a.dtype);d(a,b,c);p?a.persistentData=b:z.freeType(b)}else"number"===typeof b[0]?(a.dimension=f,f=z.allocType(a.dtype,b.length),ib(f,b),d(a,f,c),p?a.persistentData=f:z.freeType(f)):G(b[0])&&(a.dimension=b[0].length,a.dtype=h||Fa(b[0])||5126,b=Qa(b,[b.length,b[0].length],a.dtype),d(a,b,c),p?a.persistentData=b:z.freeType(b))}else if(G(b))a.dtype=h||Fa(b),a.dimension=f,d(a,b,c),p&&(a.persistentData=new Uint8Array(new Uint8Array(b.buffer)));else if(X(b)){f=
  b.shape;var v=b.stride,l=b.offset,e=0,g=0,q=0,n=0;1===f.length?(e=f[0],g=1,q=v[0],n=0):2===f.length&&(e=f[0],g=f[1],q=v[0],n=v[1]);a.dtype=h||Fa(b.data)||5126;a.dimension=g;f=z.allocType(a.dtype,e*g);jb(f,b.data,e,g,q,n,l);d(a,f,c);p?a.persistentData=f:z.freeType(f)}else b instanceof ArrayBuffer&&(a.dtype=5121,a.dimension=f,d(a,b,c),p&&(a.persistentData=new Uint8Array(new Uint8Array(b))))}function n(c){b.bufferCount--;e(c);a.deleteBuffer(c.buffer);c.buffer=null;delete q[c.id]}var u=0,q={};g.prototype.bind=
  function(){a.bindBuffer(this.type,this.buffer)};g.prototype.destroy=function(){n(this)};var t=[];c.profile&&(b.getTotalBufferSize=function(){var a=0;Object.keys(q).forEach(function(b){a+=q[b].stats.size});return a});return{create:function(m,e,d,h){function f(b){var m=35044,e=null,d=0,g=0,k=1;Array.isArray(b)||G(b)||X(b)||b instanceof ArrayBuffer?e=b:"number"===typeof b?d=b|0:b&&("data"in b&&(e=b.data),"usage"in b&&(m=lb[b.usage]),"type"in b&&(g=Ha[b.type]),"dimension"in b&&(k=b.dimension|0),"length"in
  b&&(d=b.length|0));p.bind();e?r(p,e,m,g,k,h):(d&&a.bufferData(p.type,d,m),p.dtype=g||5121,p.usage=m,p.dimension=k,p.byteLength=d);c.profile&&(p.stats.size=p.byteLength*ha[p.dtype]);return f}b.bufferCount++;var p=new g(e);q[p.id]=p;d||f(m);f._reglType="buffer";f._buffer=p;f.subdata=function(b,c){var m=(c||0)|0,h;p.bind();if(G(b)||b instanceof ArrayBuffer)a.bufferSubData(p.type,m,b);else if(Array.isArray(b)){if(0<b.length)if("number"===typeof b[0]){var d=z.allocType(p.dtype,b.length);ib(d,b);a.bufferSubData(p.type,
  m,d);z.freeType(d)}else if(Array.isArray(b[0])||G(b[0]))h=kb(b),d=Qa(b,h,p.dtype),a.bufferSubData(p.type,m,d),z.freeType(d)}else if(X(b)){h=b.shape;var e=b.stride,g=d=0,k=0,q=0;1===h.length?(d=h[0],g=1,k=e[0],q=0):2===h.length&&(d=h[0],g=h[1],k=e[0],q=e[1]);h=Array.isArray(b.data)?p.dtype:Fa(b.data);h=z.allocType(h,d*g);jb(h,b.data,d,g,k,q,b.offset);a.bufferSubData(p.type,m,h);z.freeType(h)}return f};c.profile&&(f.stats=p.stats);f.destroy=function(){n(p)};return f},createStream:function(a,b){var c=
  t.pop();c||(c=new g(a));c.bind();r(c,b,35040,0,1,!1);return c},destroyStream:function(a){t.push(a)},clear:function(){J(q).forEach(n);t.forEach(n)},getBuffer:function(a){return a&&a._buffer instanceof g?a._buffer:null},restore:function(){J(q).forEach(function(b){b.buffer=a.createBuffer();a.bindBuffer(b.type,b.buffer);a.bufferData(b.type,b.persistentData||b.byteLength,b.usage)})},_initBuffer:r}}function Ib(a,b,c,e){function g(a){this.id=u++;n[this.id]=this;this.buffer=a;this.primType=4;this.type=this.vertCount=
  0}function d(d,e,g,h,f,p,l){d.buffer.bind();var v;e?((v=l)||G(e)&&(!X(e)||G(e.data))||(v=b.oes_element_index_uint?5125:5123),c._initBuffer(d.buffer,e,g,v,3)):(a.bufferData(34963,p,g),d.buffer.dtype=v||5121,d.buffer.usage=g,d.buffer.dimension=3,d.buffer.byteLength=p);v=l;if(!l){switch(d.buffer.dtype){case 5121:case 5120:v=5121;break;case 5123:case 5122:v=5123;break;case 5125:case 5124:v=5125}d.buffer.dtype=v}d.type=v;e=f;0>e&&(e=d.buffer.byteLength,5123===v?e>>=1:5125===v&&(e>>=2));d.vertCount=e;e=
  h;0>h&&(e=4,h=d.buffer.dimension,1===h&&(e=0),2===h&&(e=1),3===h&&(e=4));d.primType=e}function r(a){e.elementsCount--;delete n[a.id];a.buffer.destroy();a.buffer=null}var n={},u=0,q={uint8:5121,uint16:5123};b.oes_element_index_uint&&(q.uint32=5125);g.prototype.bind=function(){this.buffer.bind()};var t=[];return{create:function(a,b){function k(a){if(a)if("number"===typeof a)h(a),f.primType=4,f.vertCount=a|0,f.type=5121;else{var b=null,c=35044,e=-1,g=-1,m=0,n=0;if(Array.isArray(a)||G(a)||X(a))b=a;else if("data"in
  a&&(b=a.data),"usage"in a&&(c=lb[a.usage]),"primitive"in a&&(e=Sa[a.primitive]),"count"in a&&(g=a.count|0),"type"in a&&(n=q[a.type]),"length"in a)m=a.length|0;else if(m=g,5123===n||5122===n)m*=2;else if(5125===n||5124===n)m*=4;d(f,b,c,e,g,m,n)}else h(),f.primType=4,f.vertCount=0,f.type=5121;return k}var h=c.create(null,34963,!0),f=new g(h._buffer);e.elementsCount++;k(a);k._reglType="elements";k._elements=f;k.subdata=function(a,b){h.subdata(a,b);return k};k.destroy=function(){r(f)};return k},createStream:function(a){var b=
  t.pop();b||(b=new g(c.create(null,34963,!0,!1)._buffer));d(b,a,35040,-1,-1,0,0);return b},destroyStream:function(a){t.push(a)},getElements:function(a){return"function"===typeof a&&a._elements instanceof g?a._elements:null},clear:function(){J(n).forEach(r)}}}function nb(a){for(var b=z.allocType(5123,a.length),c=0;c<a.length;++c)if(isNaN(a[c]))b[c]=65535;else if(Infinity===a[c])b[c]=31744;else if(-Infinity===a[c])b[c]=64512;else{ob[0]=a[c];var e=Jb[0],g=e>>>31<<15,d=(e<<1>>>24)-127,e=e>>13&1023;b[c]=
  -24>d?g:-14>d?g+(e+1024>>-14-d):15<d?g+31744:g+(d+15<<10)+e}return b}function na(a){return Array.isArray(a)||G(a)}function ka(a){return"[object "+a+"]"}function pb(a){return Array.isArray(a)&&(0===a.length||"number"===typeof a[0])}function qb(a){return Array.isArray(a)&&0!==a.length&&na(a[0])?!0:!1}function Y(a){return Object.prototype.toString.call(a)}function Ta(a){if(!a)return!1;var b=Y(a);return 0<=Kb.indexOf(b)?!0:pb(a)||qb(a)||X(a)}function rb(a,b){36193===a.type?(a.data=nb(b),z.freeType(b)):
  a.data=b}function Ia(a,b,c,e,g,d){a="undefined"!==typeof w[a]?w[a]:S[a]*Z[b];d&&(a*=6);if(g){for(e=0;1<=c;)e+=a*c*c,c/=2;return e}return a*c*e}function Lb(a,b,c,e,g,d,r){function n(){this.format=this.internalformat=6408;this.type=5121;this.flipY=this.premultiplyAlpha=this.compressed=!1;this.unpackAlignment=1;this.colorSpace=37444;this.channels=this.height=this.width=0}function u(a,b){a.internalformat=b.internalformat;a.format=b.format;a.type=b.type;a.compressed=b.compressed;a.premultiplyAlpha=b.premultiplyAlpha;
  a.flipY=b.flipY;a.unpackAlignment=b.unpackAlignment;a.colorSpace=b.colorSpace;a.width=b.width;a.height=b.height;a.channels=b.channels}function q(a,b){if("object"===typeof b&&b){"premultiplyAlpha"in b&&(a.premultiplyAlpha=b.premultiplyAlpha);"flipY"in b&&(a.flipY=b.flipY);"alignment"in b&&(a.unpackAlignment=b.alignment);"colorSpace"in b&&(a.colorSpace=Mb[b.colorSpace]);"type"in b&&(a.type=K[b.type]);var c=a.width,f=a.height,e=a.channels,d=!1;"shape"in b?(c=b.shape[0],f=b.shape[1],3===b.shape.length&&
  (e=b.shape[2],d=!0)):("radius"in b&&(c=f=b.radius),"width"in b&&(c=b.width),"height"in b&&(f=b.height),"channels"in b&&(e=b.channels,d=!0));a.width=c|0;a.height=f|0;a.channels=e|0;c=!1;"format"in b&&(c=b.format,f=a.internalformat=B[c],a.format=M[f],c in K&&!("type"in b)&&(a.type=K[c]),c in V&&(a.compressed=!0),c=!0);!d&&c?a.channels=S[a.format]:d&&!c&&a.channels!==La[a.format]&&(a.format=a.internalformat=La[a.channels])}}function t(b){a.pixelStorei(37440,b.flipY);a.pixelStorei(37441,b.premultiplyAlpha);
  a.pixelStorei(37443,b.colorSpace);a.pixelStorei(3317,b.unpackAlignment)}function m(){n.call(this);this.yOffset=this.xOffset=0;this.data=null;this.needsFree=!1;this.element=null;this.needsCopy=!1}function F(a,b){var c=null;Ta(b)?c=b:b&&(q(a,b),"x"in b&&(a.xOffset=b.x|0),"y"in b&&(a.yOffset=b.y|0),Ta(b.data)&&(c=b.data));if(b.copy){var f=g.viewportWidth,d=g.viewportHeight;a.width=a.width||f-a.xOffset;a.height=a.height||d-a.yOffset;a.needsCopy=!0}else if(!c)a.width=a.width||1,a.height=a.height||1,a.channels=
  a.channels||4;else if(G(c))a.channels=a.channels||4,a.data=c,"type"in b||5121!==a.type||(a.type=Ga[Object.prototype.toString.call(c)]|0);else if(pb(c)){a.channels=a.channels||4;f=c;d=f.length;switch(a.type){case 5121:case 5123:case 5125:case 5126:d=z.allocType(a.type,d);d.set(f);a.data=d;break;case 36193:a.data=nb(f)}a.alignment=1;a.needsFree=!0}else if(X(c)){f=c.data;Array.isArray(f)||5121!==a.type||(a.type=Ga[Object.prototype.toString.call(f)]|0);var d=c.shape,e=c.stride,h,l,k,p;3===d.length?(k=
  d[2],p=e[2]):p=k=1;h=d[0];l=d[1];d=e[0];e=e[1];a.alignment=1;a.width=h;a.height=l;a.channels=k;a.format=a.internalformat=La[k];a.needsFree=!0;h=p;c=c.offset;k=a.width;p=a.height;l=a.channels;for(var y=z.allocType(36193===a.type?5126:a.type,k*p*l),I=0,U=0;U<p;++U)for(var da=0;da<k;++da)for(var Ua=0;Ua<l;++Ua)y[I++]=f[d*da+e*U+h*Ua+c];rb(a,y)}else if(Y(c)===Va||Y(c)===Wa||Y(c)===sb)Y(c)===Va||Y(c)===Wa?a.element=c:a.element=c.canvas,a.width=a.element.width,a.height=a.element.height,a.channels=4;else if(Y(c)===
  tb)a.element=c,a.width=c.width,a.height=c.height,a.channels=4;else if(Y(c)===ub)a.element=c,a.width=c.naturalWidth,a.height=c.naturalHeight,a.channels=4;else if(Y(c)===vb)a.element=c,a.width=c.videoWidth,a.height=c.videoHeight,a.channels=4;else if(qb(c)){f=a.width||c[0].length;d=a.height||c.length;e=a.channels;e=na(c[0][0])?e||c[0][0].length:e||1;h=Ma.shape(c);k=1;for(p=0;p<h.length;++p)k*=h[p];k=z.allocType(36193===a.type?5126:a.type,k);Ma.flatten(c,h,"",k);rb(a,k);a.alignment=1;a.width=f;a.height=
  d;a.channels=e;a.format=a.internalformat=La[e];a.needsFree=!0}}function k(b,c,f,d,h){var g=b.element,k=b.data,l=b.internalformat,p=b.format,v=b.type,y=b.width,I=b.height;t(b);g?a.texSubImage2D(c,h,f,d,p,v,g):b.compressed?a.compressedTexSubImage2D(c,h,f,d,l,y,I,k):b.needsCopy?(e(),a.copyTexSubImage2D(c,h,f,d,b.xOffset,b.yOffset,y,I)):a.texSubImage2D(c,h,f,d,y,I,p,v,k)}function h(){return L.pop()||new m}function f(a){a.needsFree&&z.freeType(a.data);m.call(a);L.push(a)}function p(){n.call(this);this.genMipmaps=
  !1;this.mipmapHint=4352;this.mipmask=0;this.images=Array(16)}function l(a,b,c){var f=a.images[0]=h();a.mipmask=1;f.width=a.width=b;f.height=a.height=c;f.channels=a.channels=4}function v(a,b){var c=null;if(Ta(b))c=a.images[0]=h(),u(c,a),F(c,b),a.mipmask=1;else if(q(a,b),Array.isArray(b.mipmap))for(var f=b.mipmap,d=0;d<f.length;++d)c=a.images[d]=h(),u(c,a),c.width>>=d,c.height>>=d,F(c,f[d]),a.mipmask|=1<<d;else c=a.images[0]=h(),u(c,a),F(c,b),a.mipmask=1;u(a,a.images[0])}function Q(b,c){for(var f=b.images,
  d=0;d<f.length&&f[d];++d){var h=f[d],g=c,k=d,l=h.element,p=h.data,v=h.internalformat,y=h.format,I=h.type,U=h.width,da=h.height;t(h);l?a.texImage2D(g,k,y,y,I,l):h.compressed?a.compressedTexImage2D(g,k,v,U,da,0,p):h.needsCopy?(e(),a.copyTexImage2D(g,k,y,h.xOffset,h.yOffset,U,da,0)):a.texImage2D(g,k,y,U,da,0,y,I,p||null)}}function C(){var a=A.pop()||new p;n.call(a);for(var b=a.mipmask=0;16>b;++b)a.images[b]=null;return a}function va(a){for(var b=a.images,c=0;c<b.length;++c)b[c]&&f(b[c]),b[c]=null;A.push(a)}
  function ea(){this.magFilter=this.minFilter=9728;this.wrapT=this.wrapS=33071;this.anisotropic=1;this.genMipmaps=!1;this.mipmapHint=4352}function mb(a,b){"min"in b&&(a.minFilter=O[b.min],0<=Nb.indexOf(a.minFilter)&&!("faces"in b)&&(a.genMipmaps=!0));"mag"in b&&(a.magFilter=T[b.mag]);var c=a.wrapS,f=a.wrapT;if("wrap"in b){var d=b.wrap;"string"===typeof d?c=f=la[d]:Array.isArray(d)&&(c=la[d[0]],f=la[d[1]])}else"wrapS"in b&&(c=la[b.wrapS]),"wrapT"in b&&(f=la[b.wrapT]);a.wrapS=c;a.wrapT=f;"anisotropic"in
  b&&(a.anisotropic=b.anisotropic);if("mipmap"in b){c=!1;switch(typeof b.mipmap){case "string":a.mipmapHint=x[b.mipmap];c=a.genMipmaps=!0;break;case "boolean":c=a.genMipmaps=b.mipmap;break;case "object":a.genMipmaps=!1,c=!0}!c||"min"in b||(a.minFilter=9984)}}function Ra(c,f){a.texParameteri(f,10241,c.minFilter);a.texParameteri(f,10240,c.magFilter);a.texParameteri(f,10242,c.wrapS);a.texParameteri(f,10243,c.wrapT);b.ext_texture_filter_anisotropic&&a.texParameteri(f,34046,c.anisotropic);c.genMipmaps&&
  (a.hint(33170,c.mipmapHint),a.generateMipmap(f))}function R(b){n.call(this);this.mipmask=0;this.internalformat=6408;this.id=P++;this.refCount=1;this.target=b;this.texture=a.createTexture();this.unit=-1;this.bindCount=0;this.texInfo=new ea;r.profile&&(this.stats={size:0})}function sa(b){a.activeTexture(33984);a.bindTexture(b.target,b.texture)}function za(){var b=W[0];b?a.bindTexture(b.target,b.texture):a.bindTexture(3553,null)}function D(b){var c=b.texture,f=b.unit,h=b.target;0<=f&&(a.activeTexture(33984+
  f),a.bindTexture(h,null),W[f]=null);a.deleteTexture(c);b.texture=null;b.params=null;b.pixels=null;b.refCount=0;delete E[b.id];d.textureCount--}var x={"don't care":4352,"dont care":4352,nice:4354,fast:4353},la={repeat:10497,clamp:33071,mirror:33648},T={nearest:9728,linear:9729},O=H({mipmap:9987,"nearest mipmap nearest":9984,"linear mipmap nearest":9985,"nearest mipmap linear":9986,"linear mipmap linear":9987},T),Mb={none:0,browser:37444},K={uint8:5121,rgba4:32819,rgb565:33635,"rgb5 a1":32820},B={alpha:6406,
  luminance:6409,"luminance alpha":6410,rgb:6407,rgba:6408,rgba4:32854,"rgb5 a1":32855,rgb565:36194},V={};b.ext_srgb&&(B.srgb=35904,B.srgba=35906);b.oes_texture_float&&(K.float32=K["float"]=5126);b.oes_texture_half_float&&(K.float16=K["half float"]=36193);b.webgl_depth_texture&&(H(B,{depth:6402,"depth stencil":34041}),H(K,{uint16:5123,uint32:5125,"depth stencil":34042}));b.webgl_compressed_texture_s3tc&&H(V,{"rgb s3tc dxt1":33776,"rgba s3tc dxt1":33777,"rgba s3tc dxt3":33778,"rgba s3tc dxt5":33779});
  b.webgl_compressed_texture_atc&&H(V,{"rgb atc":35986,"rgba atc explicit alpha":35987,"rgba atc interpolated alpha":34798});b.webgl_compressed_texture_pvrtc&&H(V,{"rgb pvrtc 4bppv1":35840,"rgb pvrtc 2bppv1":35841,"rgba pvrtc 4bppv1":35842,"rgba pvrtc 2bppv1":35843});b.webgl_compressed_texture_etc1&&(V["rgb etc1"]=36196);var w=Array.prototype.slice.call(a.getParameter(34467));Object.keys(V).forEach(function(a){var b=V[a];0<=w.indexOf(b)&&(B[a]=b)});var wa=Object.keys(B);c.textureFormats=wa;var aa=[];
  Object.keys(B).forEach(function(a){aa[B[a]]=a});var xa=[];Object.keys(K).forEach(function(a){xa[K[a]]=a});var ba=[];Object.keys(T).forEach(function(a){ba[T[a]]=a});var Da=[];Object.keys(O).forEach(function(a){Da[O[a]]=a});var fa=[];Object.keys(la).forEach(function(a){fa[la[a]]=a});var M=wa.reduce(function(a,c){var f=B[c];6409===f||6406===f||6409===f||6410===f||6402===f||34041===f||b.ext_srgb&&(35904===f||35906===f)?a[f]=f:32855===f||0<=c.indexOf("rgba")?a[f]=6408:a[f]=6407;return a},{}),L=[],A=[],
  P=0,E={},ia=c.maxTextureUnits,W=Array(ia).map(function(){return null});H(R.prototype,{bind:function(){this.bindCount+=1;var b=this.unit;if(0>b){for(var c=0;c<ia;++c){var f=W[c];if(f){if(0<f.bindCount)continue;f.unit=-1}W[c]=this;b=c;break}r.profile&&d.maxTextureUnits<b+1&&(d.maxTextureUnits=b+1);this.unit=b;a.activeTexture(33984+b);a.bindTexture(this.target,this.texture)}return b},unbind:function(){--this.bindCount},decRef:function(){0>=--this.refCount&&D(this)}});r.profile&&(d.getTotalTextureSize=
  function(){var a=0;Object.keys(E).forEach(function(b){a+=E[b].stats.size});return a});return{create2D:function(b,c){function e(a,b){var c=g.texInfo;ea.call(c);var f=C();"number"===typeof a?"number"===typeof b?l(f,a|0,b|0):l(f,a|0,a|0):a?(mb(c,a),v(f,a)):l(f,1,1);c.genMipmaps&&(f.mipmask=(f.width<<1)-1);g.mipmask=f.mipmask;u(g,f);g.internalformat=f.internalformat;e.width=f.width;e.height=f.height;sa(g);Q(f,3553);Ra(c,3553);za();va(f);r.profile&&(g.stats.size=Ia(g.internalformat,g.type,f.width,f.height,
  c.genMipmaps,!1));e.format=aa[g.internalformat];e.type=xa[g.type];e.mag=ba[c.magFilter];e.min=Da[c.minFilter];e.wrapS=fa[c.wrapS];e.wrapT=fa[c.wrapT];return e}var g=new R(3553);E[g.id]=g;d.textureCount++;e(b,c);e.subimage=function(a,b,c,d){b|=0;c|=0;d|=0;var l=h();u(l,g);l.width=0;l.height=0;F(l,a);l.width=l.width||(g.width>>d)-b;l.height=l.height||(g.height>>d)-c;sa(g);k(l,3553,b,c,d);za();f(l);return e};e.resize=function(b,c){var f=b|0,d=c|0||f;if(f===g.width&&d===g.height)return e;e.width=g.width=
  f;e.height=g.height=d;sa(g);for(var h=0;g.mipmask>>h;++h){var l=f>>h,y=d>>h;if(!l||!y)break;a.texImage2D(3553,h,g.format,l,y,0,g.format,g.type,null)}za();r.profile&&(g.stats.size=Ia(g.internalformat,g.type,f,d,!1,!1));return e};e._reglType="texture2d";e._texture=g;r.profile&&(e.stats=g.stats);e.destroy=function(){g.decRef()};return e},createCube:function(b,c,e,g,p,n){function m(a,b,c,f,d,e){var h,ma=x.texInfo;ea.call(ma);for(h=0;6>h;++h)D[h]=C();if("number"===typeof a||!a)for(a=a|0||1,h=0;6>h;++h)l(D[h],
  a,a);else if("object"===typeof a)if(b)v(D[0],a),v(D[1],b),v(D[2],c),v(D[3],f),v(D[4],d),v(D[5],e);else if(mb(ma,a),q(x,a),"faces"in a)for(a=a.faces,h=0;6>h;++h)u(D[h],x),v(D[h],a[h]);else for(h=0;6>h;++h)v(D[h],a);u(x,D[0]);x.mipmask=ma.genMipmaps?(D[0].width<<1)-1:D[0].mipmask;x.internalformat=D[0].internalformat;m.width=D[0].width;m.height=D[0].height;sa(x);for(h=0;6>h;++h)Q(D[h],34069+h);Ra(ma,34067);za();r.profile&&(x.stats.size=Ia(x.internalformat,x.type,m.width,m.height,ma.genMipmaps,!0));m.format=
  aa[x.internalformat];m.type=xa[x.type];m.mag=ba[ma.magFilter];m.min=Da[ma.minFilter];m.wrapS=fa[ma.wrapS];m.wrapT=fa[ma.wrapT];for(h=0;6>h;++h)va(D[h]);return m}var x=new R(34067);E[x.id]=x;d.cubeCount++;var D=Array(6);m(b,c,e,g,p,n);m.subimage=function(a,b,c,d,e){c|=0;d|=0;e|=0;var g=h();u(g,x);g.width=0;g.height=0;F(g,b);g.width=g.width||(x.width>>e)-c;g.height=g.height||(x.height>>e)-d;sa(x);k(g,34069+a,c,d,e);za();f(g);return m};m.resize=function(b){b|=0;if(b!==x.width){m.width=x.width=b;m.height=
  x.height=b;sa(x);for(var c=0;6>c;++c)for(var f=0;x.mipmask>>f;++f)a.texImage2D(34069+c,f,x.format,b>>f,b>>f,0,x.format,x.type,null);za();r.profile&&(x.stats.size=Ia(x.internalformat,x.type,m.width,m.height,!1,!0));return m}};m._reglType="textureCube";m._texture=x;r.profile&&(m.stats=x.stats);m.destroy=function(){x.decRef()};return m},clear:function(){for(var b=0;b<ia;++b)a.activeTexture(33984+b),a.bindTexture(3553,null),W[b]=null;J(E).forEach(D);d.cubeCount=0;d.textureCount=0},getTexture:function(a){return null},
  restore:function(){for(var b=0;b<ia;++b){var c=W[b];c&&(c.bindCount=0,c.unit=-1,W[b]=null)}J(E).forEach(function(b){b.texture=a.createTexture();a.bindTexture(b.target,b.texture);for(var c=0;32>c;++c)if(0!==(b.mipmask&1<<c))if(3553===b.target)a.texImage2D(3553,c,b.internalformat,b.width>>c,b.height>>c,0,b.internalformat,b.type,null);else for(var f=0;6>f;++f)a.texImage2D(34069+f,c,b.internalformat,b.width>>c,b.height>>c,0,b.internalformat,b.type,null);Ra(b.texInfo,b.target)})}}}function Ob(a,b,c,e,
  g,d){function r(a,b,c){this.target=a;this.texture=b;this.renderbuffer=c;var f=a=0;b?(a=b.width,f=b.height):c&&(a=c.width,f=c.height);this.width=a;this.height=f}function n(a){a&&(a.texture&&a.texture._texture.decRef(),a.renderbuffer&&a.renderbuffer._renderbuffer.decRef())}function u(a,b,c){a&&(a.texture?a.texture._texture.refCount+=1:a.renderbuffer._renderbuffer.refCount+=1)}function q(b,c){c&&(c.texture?a.framebufferTexture2D(36160,b,c.target,c.texture._texture.texture,0):a.framebufferRenderbuffer(36160,
  b,36161,c.renderbuffer._renderbuffer.renderbuffer))}function t(a){var b=3553,c=null,f=null,d=a;"object"===typeof a&&(d=a.data,"target"in a&&(b=a.target|0));a=d._reglType;"texture2d"===a?c=d:"textureCube"===a?c=d:"renderbuffer"===a&&(f=d,b=36161);return new r(b,c,f)}function m(a,b,c,f,d){if(c)return a=e.create2D({width:a,height:b,format:f,type:d}),a._texture.refCount=0,new r(3553,a,null);a=g.create({width:a,height:b,format:f});a._renderbuffer.refCount=0;return new r(36161,null,a)}function F(a){return a&&
  (a.texture||a.renderbuffer)}function k(a,b,c){a&&(a.texture?a.texture.resize(b,c):a.renderbuffer&&a.renderbuffer.resize(b,c),a.width=b,a.height=c)}function h(){this.id=z++;w[this.id]=this;this.framebuffer=a.createFramebuffer();this.height=this.width=0;this.colorAttachments=[];this.depthStencilAttachment=this.stencilAttachment=this.depthAttachment=null}function f(a){a.colorAttachments.forEach(n);n(a.depthAttachment);n(a.stencilAttachment);n(a.depthStencilAttachment)}function p(b){a.deleteFramebuffer(b.framebuffer);
  b.framebuffer=null;d.framebufferCount--;delete w[b.id]}function l(b){var f;a.bindFramebuffer(36160,b.framebuffer);var d=b.colorAttachments;for(f=0;f<d.length;++f)q(36064+f,d[f]);for(f=d.length;f<c.maxColorAttachments;++f)a.framebufferTexture2D(36160,36064+f,3553,null,0);a.framebufferTexture2D(36160,33306,3553,null,0);a.framebufferTexture2D(36160,36096,3553,null,0);a.framebufferTexture2D(36160,36128,3553,null,0);q(36096,b.depthAttachment);q(36128,b.stencilAttachment);q(33306,b.depthStencilAttachment);
  a.checkFramebufferStatus(36160);a.isContextLost();a.bindFramebuffer(36160,Q.next?Q.next.framebuffer:null);Q.cur=Q.next;a.getError()}function v(a,b){function c(a,b){var d,h=0,g=0,k=!0,p=!0;d=null;var v=!0,n="rgba",q="uint8",r=1,ea=null,ba=null,Q=null,fa=!1;if("number"===typeof a)h=a|0,g=b|0||h;else if(a){"shape"in a?(g=a.shape,h=g[0],g=g[1]):("radius"in a&&(h=g=a.radius),"width"in a&&(h=a.width),"height"in a&&(g=a.height));if("color"in a||"colors"in a)d=a.color||a.colors,Array.isArray(d);if(!d){"colorCount"in
  a&&(r=a.colorCount|0);"colorTexture"in a&&(v=!!a.colorTexture,n="rgba4");if("colorType"in a&&(q=a.colorType,!v))if("half float"===q||"float16"===q)n="rgba16f";else if("float"===q||"float32"===q)n="rgba32f";"colorFormat"in a&&(n=a.colorFormat,0<=C.indexOf(n)?v=!0:0<=va.indexOf(n)&&(v=!1))}if("depthTexture"in a||"depthStencilTexture"in a)fa=!(!a.depthTexture&&!a.depthStencilTexture);"depth"in a&&("boolean"===typeof a.depth?k=a.depth:(ea=a.depth,p=!1));"stencil"in a&&("boolean"===typeof a.stencil?p=
  a.stencil:(ba=a.stencil,k=!1));"depthStencil"in a&&("boolean"===typeof a.depthStencil?k=p=a.depthStencil:(Q=a.depthStencil,p=k=!1))}else h=g=1;var M=null,z=null,w=null,R=null;if(Array.isArray(d))M=d.map(t);else if(d)M=[t(d)];else for(M=Array(r),d=0;d<r;++d)M[d]=m(h,g,v,n,q);h=h||M[0].width;g=g||M[0].height;ea?z=t(ea):k&&!p&&(z=m(h,g,fa,"depth","uint32"));ba?w=t(ba):p&&!k&&(w=m(h,g,!1,"stencil","uint8"));Q?R=t(Q):!ea&&!ba&&p&&k&&(R=m(h,g,fa,"depth stencil","depth stencil"));k=null;for(d=0;d<M.length;++d)u(M[d],
  h,g),M[d]&&M[d].texture&&(p=Xa[M[d].texture._texture.format]*Na[M[d].texture._texture.type],null===k&&(k=p));u(z,h,g);u(w,h,g);u(R,h,g);f(e);e.width=h;e.height=g;e.colorAttachments=M;e.depthAttachment=z;e.stencilAttachment=w;e.depthStencilAttachment=R;c.color=M.map(F);c.depth=F(z);c.stencil=F(w);c.depthStencil=F(R);c.width=e.width;c.height=e.height;l(e);return c}var e=new h;d.framebufferCount++;c(a,b);return H(c,{resize:function(a,b){var f=Math.max(a|0,1),d=Math.max(b|0||f,1);if(f===e.width&&d===
  e.height)return c;for(var h=e.colorAttachments,g=0;g<h.length;++g)k(h[g],f,d);k(e.depthAttachment,f,d);k(e.stencilAttachment,f,d);k(e.depthStencilAttachment,f,d);e.width=c.width=f;e.height=c.height=d;l(e);return c},_reglType:"framebuffer",_framebuffer:e,destroy:function(){p(e);f(e)},use:function(a){Q.setFBO({framebuffer:c},a)}})}var Q={cur:null,next:null,dirty:!1,setFBO:null},C=["rgba"],va=["rgba4","rgb565","rgb5 a1"];b.ext_srgb&&va.push("srgba");b.ext_color_buffer_half_float&&va.push("rgba16f","rgb16f");
  b.webgl_color_buffer_float&&va.push("rgba32f");var ea=["uint8"];b.oes_texture_half_float&&ea.push("half float","float16");b.oes_texture_float&&ea.push("float","float32");var z=0,w={};return H(Q,{getFramebuffer:function(a){return"function"===typeof a&&"framebuffer"===a._reglType&&(a=a._framebuffer,a instanceof h)?a:null},create:v,createCube:function(a){function b(a){var f,d={color:null},h=0,g=null;f="rgba";var k="uint8",l=1;if("number"===typeof a)h=a|0;else if(a){"shape"in a?h=a.shape[0]:("radius"in
  a&&(h=a.radius|0),"width"in a?h=a.width|0:"height"in a&&(h=a.height|0));if("color"in a||"colors"in a)g=a.color||a.colors,Array.isArray(g);g||("colorCount"in a&&(l=a.colorCount|0),"colorType"in a&&(k=a.colorType),"colorFormat"in a&&(f=a.colorFormat));"depth"in a&&(d.depth=a.depth);"stencil"in a&&(d.stencil=a.stencil);"depthStencil"in a&&(d.depthStencil=a.depthStencil)}else h=1;if(g)if(Array.isArray(g))for(a=[],f=0;f<g.length;++f)a[f]=g[f];else a=[g];else for(a=Array(l),g={radius:h,format:f,type:k},
  f=0;f<l;++f)a[f]=e.createCube(g);d.color=Array(a.length);for(f=0;f<a.length;++f)l=a[f],h=h||l.width,d.color[f]={target:34069,data:a[f]};for(f=0;6>f;++f){for(l=0;l<a.length;++l)d.color[l].target=34069+f;0<f&&(d.depth=c[0].depth,d.stencil=c[0].stencil,d.depthStencil=c[0].depthStencil);if(c[f])c[f](d);else c[f]=v(d)}return H(b,{width:h,height:h,color:a})}var c=Array(6);b(a);return H(b,{faces:c,resize:function(a){var f=a|0;if(f===b.width)return b;var d=b.color;for(a=0;a<d.length;++a)d[a].resize(f);for(a=
  0;6>a;++a)c[a].resize(f);b.width=b.height=f;return b},_reglType:"framebufferCube",destroy:function(){c.forEach(function(a){a.destroy()})}})},clear:function(){J(w).forEach(p)},restore:function(){Q.cur=null;Q.next=null;Q.dirty=!0;J(w).forEach(function(b){b.framebuffer=a.createFramebuffer();l(b)})}})}function Ya(){this.w=this.z=this.y=this.x=this.state=0;this.buffer=null;this.size=0;this.normalized=!1;this.type=5126;this.divisor=this.stride=this.offset=0}function Pb(a,b,c,e,g){function d(a){if(a!==h.currentVAO){var c=
  b.oes_vertex_array_object;a?c.bindVertexArrayOES(a.vao):c.bindVertexArrayOES(null);h.currentVAO=a}}function r(c){if(c!==h.currentVAO){if(c)c.bindAttrs();else for(var d=b.angle_instanced_arrays,e=0;e<m.length;++e){var g=m[e];g.buffer?(a.enableVertexAttribArray(e),a.vertexAttribPointer(e,g.size,g.type,g.normalized,g.stride,g.offfset),d&&d.vertexAttribDivisorANGLE(e,g.divisor)):(a.disableVertexAttribArray(e),a.vertexAttrib4f(e,g.x,g.y,g.z,g.w))}h.currentVAO=c}}function n(){J(k).forEach(function(a){a.destroy()})}
  function u(){this.id=++F;this.attributes=[];var a=b.oes_vertex_array_object;this.vao=a?a.createVertexArrayOES():null;k[this.id]=this;this.buffers=[]}function q(){b.oes_vertex_array_object&&J(k).forEach(function(a){a.refresh()})}var t=c.maxAttributes,m=Array(t);for(c=0;c<t;++c)m[c]=new Ya;var F=0,k={},h={Record:Ya,scope:{},state:m,currentVAO:null,targetVAO:null,restore:b.oes_vertex_array_object?q:function(){},createVAO:function(a){function b(a){for(var f=0;f<c.buffers.length;++f)c.buffers[f].destroy();
  c.buffers.length=0;f=c.attributes;f.length=a.length;for(var d=0;d<a.length;++d){var h=a[d],e=f[d]=new Ya;Array.isArray(h)||G(h)||X(h)?(h=g.create(h,34962,!1,!0),e.buffer=g.getBuffer(h),e.size=e.buffer.dimension|0,e.normalized=!1,e.type=e.buffer.dtype,e.offset=0,e.stride=0,e.divisor=0,e.state=1,c.buffers.push(h)):g.getBuffer(h)?(e.buffer=g.getBuffer(h),e.size=e.buffer.dimension|0,e.normalized=!1,e.type=e.buffer.dtype,e.offset=0,e.stride=0,e.divisor=0,e.state=1):g.getBuffer(h.buffer)?(e.buffer=g.getBuffer(h.buffer),
  e.size=(+h.size||e.buffer.dimension)|0,e.normalized=!!h.normalized||!1,e.type="type"in h?Ha[h.type]:e.buffer.dtype,e.offset=(h.offset||0)|0,e.stride=(h.stride||0)|0,e.divisor=(h.divisor||0)|0,e.state=1):"x"in h&&(e.x=+h.x||0,e.y=+h.y||0,e.z=+h.z||0,e.w=+h.w||0,e.state=2)}c.refresh();return b}var c=new u;e.vaoCount+=1;b.destroy=function(){c.destroy()};b._vao=c;b._reglType="vao";return b(a)},getVAO:function(a){return"function"===typeof a&&a._vao?a._vao:null},destroyBuffer:function(b){for(var c=0;c<
  m.length;++c){var d=m[c];d.buffer===b&&(a.disableVertexAttribArray(c),d.buffer=null)}},setVAO:b.oes_vertex_array_object?d:r,clear:b.oes_vertex_array_object?n:function(){}};u.prototype.bindAttrs=function(){for(var c=b.angle_instanced_arrays,d=this.attributes,e=0;e<d.length;++e){var h=d[e];h.buffer?(a.enableVertexAttribArray(e),a.bindBuffer(34962,h.buffer.buffer),a.vertexAttribPointer(e,h.size,h.type,h.normalized,h.stride,h.offset),c&&c.vertexAttribDivisorANGLE(e,h.divisor)):(a.disableVertexAttribArray(e),
  a.vertexAttrib4f(e,h.x,h.y,h.z,h.w))}for(c=d.length;c<t;++c)a.disableVertexAttribArray(c)};u.prototype.refresh=function(){var a=b.oes_vertex_array_object;a&&(a.bindVertexArrayOES(this.vao),this.bindAttrs(),h.currentVAO=this)};u.prototype.destroy=function(){if(this.vao){var a=b.oes_vertex_array_object;this===h.currentVAO&&(h.currentVAO=null,a.bindVertexArrayOES(null));a.deleteVertexArrayOES(this.vao);this.vao=null}k[this.id]&&(delete k[this.id],--e.vaoCount)};return h}function Qb(a,b,c,e){function g(a,
  b,c,d){this.name=a;this.id=b;this.location=c;this.info=d}function d(a,b){for(var c=0;c<a.length;++c)if(a[c].id===b.id){a[c].location=b.location;return}a.push(b)}function r(c,f,d){d=35632===c?q:t;var e=d[f];if(!e){var g=b.str(f),e=a.createShader(c);a.shaderSource(e,g);a.compileShader(e);d[f]=e}return e}function n(a,b){this.id=k++;this.fragId=a;this.vertId=b;this.program=null;this.uniforms=[];this.attributes=[];e.profile&&(this.stats={uniformsCount:0,attributesCount:0})}function u(c,f,k){var m;m=r(35632,
  c.fragId);var n=r(35633,c.vertId);f=c.program=a.createProgram();a.attachShader(f,m);a.attachShader(f,n);if(k)for(m=0;m<k.length;++m)n=k[m],a.bindAttribLocation(f,n[0],n[1]);a.linkProgram(f);n=a.getProgramParameter(f,35718);e.profile&&(c.stats.uniformsCount=n);var q=c.uniforms;for(m=0;m<n;++m)if(k=a.getActiveUniform(f,m))if(1<k.size)for(var u=0;u<k.size;++u){var t=k.name.replace("[0]","["+u+"]");d(q,new g(t,b.id(t),a.getUniformLocation(f,t),k))}else d(q,new g(k.name,b.id(k.name),a.getUniformLocation(f,
  k.name),k));n=a.getProgramParameter(f,35721);e.profile&&(c.stats.attributesCount=n);c=c.attributes;for(m=0;m<n;++m)(k=a.getActiveAttrib(f,m))&&d(c,new g(k.name,b.id(k.name),a.getAttribLocation(f,k.name),k))}var q={},t={},m={},F=[],k=0;e.profile&&(c.getMaxUniformsCount=function(){var a=0;F.forEach(function(b){b.stats.uniformsCount>a&&(a=b.stats.uniformsCount)});return a},c.getMaxAttributesCount=function(){var a=0;F.forEach(function(b){b.stats.attributesCount>a&&(a=b.stats.attributesCount)});return a});
  return{clear:function(){var b=a.deleteShader.bind(a);J(q).forEach(b);q={};J(t).forEach(b);t={};F.forEach(function(b){a.deleteProgram(b.program)});F.length=0;m={};c.shaderCount=0},program:function(a,b,d,e){var g=m[b];g||(g=m[b]={});var k=g[a];if(k&&!e)return k;b=new n(b,a);c.shaderCount++;u(b,d,e);k||(g[a]=b);F.push(b);return b},restore:function(){q={};t={};for(var a=0;a<F.length;++a)u(F[a],null,F[a].attributes.map(function(a){return[a.location,a.name]}))},shader:r,frag:-1,vert:-1}}function Rb(a,b,
  c,e,g,d,r){function n(d){var g;g=null===b.next?5121:b.next.colorAttachments[0].texture._texture.type;var m=0,n=0,k=e.framebufferWidth,h=e.framebufferHeight,f=null;G(d)?f=d:d&&(m=d.x|0,n=d.y|0,k=(d.width||e.framebufferWidth-m)|0,h=(d.height||e.framebufferHeight-n)|0,f=d.data||null);c();d=k*h*4;f||(5121===g?f=new Uint8Array(d):5126===g&&(f=f||new Float32Array(d)));a.pixelStorei(3333,4);a.readPixels(m,n,k,h,6408,g,f);return f}function u(a){var c;b.setFBO({framebuffer:a.framebuffer},function(){c=n(a)});
  return c}return function(a){return a&&"framebuffer"in a?u(a):n(a)}}function ta(a){return Array.prototype.slice.call(a)}function Aa(a){return ta(a).join("")}function Sb(){function a(){var a=[],b=[];return H(function(){a.push.apply(a,ta(arguments))},{def:function(){var d="v"+c++;b.push(d);0<arguments.length&&(a.push(d,"="),a.push.apply(a,ta(arguments)),a.push(";"));return d},toString:function(){return Aa([0<b.length?"var "+b.join(",")+";":"",Aa(a)])}})}function b(){function b(a,e){d(a,e,"=",c.def(a,
  e),";")}var c=a(),d=a(),e=c.toString,g=d.toString;return H(function(){c.apply(c,ta(arguments))},{def:c.def,entry:c,exit:d,save:b,set:function(a,d,e){b(a,d);c(a,d,"=",e,";")},toString:function(){return e()+g()}})}var c=0,e=[],g=[],d=a(),r={};return{global:d,link:function(a){for(var b=0;b<g.length;++b)if(g[b]===a)return e[b];b="g"+c++;e.push(b);g.push(a);return b},block:a,proc:function(a,c){function d(){var a="a"+e.length;e.push(a);return a}var e=[];c=c||0;for(var g=0;g<c;++g)d();var g=b(),F=g.toString;
  return r[a]=H(g,{arg:d,toString:function(){return Aa(["function(",e.join(),"){",F(),"}"])}})},scope:b,cond:function(){var a=Aa(arguments),c=b(),d=b(),e=c.toString,g=d.toString;return H(c,{then:function(){c.apply(c,ta(arguments));return this},"else":function(){d.apply(d,ta(arguments));return this},toString:function(){var b=g();b&&(b="else{"+b+"}");return Aa(["if(",a,"){",e(),"}",b])}})},compile:function(){var a=['"use strict";',d,"return {"];Object.keys(r).forEach(function(b){a.push('"',b,'":',r[b].toString(),
  ",")});a.push("}");var b=Aa(a).replace(/;/g,";\n").replace(/}/g,"}\n").replace(/{/g,"{\n");return Function.apply(null,e.concat(b)).apply(null,g)}}}function Oa(a){return Array.isArray(a)||G(a)||X(a)}function wb(a){return a.sort(function(a,c){return"viewport"===a?-1:"viewport"===c?1:a<c?-1:1})}function P(a,b,c,e){this.thisDep=a;this.contextDep=b;this.propDep=c;this.append=e}function ua(a){return a&&!(a.thisDep||a.contextDep||a.propDep)}function C(a){return new P(!1,!1,!1,a)}function L(a,b){var c=a.type;
  return 0===c?(c=a.data.length,new P(!0,1<=c,2<=c,b)):4===c?(c=a.data,new P(c.thisDep,c.contextDep,c.propDep,b)):new P(3===c,2===c,1===c,b)}function Tb(a,b,c,e,g,d,r,n,u,q,t,m,F,k,h){function f(a){return a.replace(".","_")}function p(a,b,c){var d=f(a);Ka.push(a);Ca[d]=pa[d]=!!c;qa[d]=b}function l(a,b,c){var d=f(a);Ka.push(a);Array.isArray(c)?(pa[d]=c.slice(),Ca[d]=c.slice()):pa[d]=Ca[d]=c;ra[d]=b}function v(){var a=Sb(),c=a.link,d=a.global;a.id=ta++;a.batchId="0";var e=c(ka),f=a.shared={props:"a0"};
  Object.keys(ka).forEach(function(a){f[a]=d.def(e,".",a)});var g=a.next={},h=a.current={};Object.keys(ra).forEach(function(a){Array.isArray(pa[a])&&(g[a]=d.def(f.next,".",a),h[a]=d.def(f.current,".",a))});var ca=a.constants={};Object.keys(Z).forEach(function(a){ca[a]=d.def(JSON.stringify(Z[a]))});a.invoke=function(b,d){switch(d.type){case 0:var e=["this",f.context,f.props,a.batchId];return b.def(c(d.data),".call(",e.slice(0,Math.max(d.data.length+1,4)),")");case 1:return b.def(f.props,d.data);case 2:return b.def(f.context,
  d.data);case 3:return b.def("this",d.data);case 4:return d.data.append(a,b),d.data.ref}};a.attribCache={};var ya={};a.scopeAttrib=function(a){a=b.id(a);if(a in ya)return ya[a];var d=q.scope[a];d||(d=q.scope[a]=new ia);return ya[a]=c(d)};return a}function Q(a){var b=a["static"];a=a.dynamic;var c;if("profile"in b){var d=!!b.profile;c=C(function(a,b){return d});c.enable=d}else if("profile"in a){var e=a.profile;c=L(e,function(a,b){return a.invoke(b,e)})}return c}function z(a,b){var c=a["static"],d=a.dynamic;
  if("framebuffer"in c){var e=c.framebuffer;return e?(e=n.getFramebuffer(e),C(function(a,b){var c=a.link(e),d=a.shared;b.set(d.framebuffer,".next",c);d=d.context;b.set(d,".framebufferWidth",c+".width");b.set(d,".framebufferHeight",c+".height");return c})):C(function(a,b){var c=a.shared;b.set(c.framebuffer,".next","null");c=c.context;b.set(c,".framebufferWidth",c+".drawingBufferWidth");b.set(c,".framebufferHeight",c+".drawingBufferHeight");return"null"})}if("framebuffer"in d){var f=d.framebuffer;return L(f,
  function(a,b){var c=a.invoke(b,f),d=a.shared,e=d.framebuffer,c=b.def(e,".getFramebuffer(",c,")");b.set(e,".next",c);d=d.context;b.set(d,".framebufferWidth",c+"?"+c+".width:"+d+".drawingBufferWidth");b.set(d,".framebufferHeight",c+"?"+c+".height:"+d+".drawingBufferHeight");return c})}return null}function w(a,b,c){function d(a){if(a in e){var c=e[a];a=!0;var g=c.x|0,y=c.y|0,h,U;"width"in c?h=c.width|0:a=!1;"height"in c?U=c.height|0:a=!1;return new P(!a&&b&&b.thisDep,!a&&b&&b.contextDep,!a&&b&&b.propDep,
  function(a,b){var d=a.shared.context,e=h;"width"in c||(e=b.def(d,".","framebufferWidth","-",g));var f=U;"height"in c||(f=b.def(d,".","framebufferHeight","-",y));return[g,y,e,f]})}if(a in f){var k=f[a];a=L(k,function(a,b){var c=a.invoke(b,k),d=a.shared.context,e=b.def(c,".x|0"),f=b.def(c,".y|0"),g=b.def('"width" in ',c,"?",c,".width|0:","(",d,".","framebufferWidth","-",e,")"),c=b.def('"height" in ',c,"?",c,".height|0:","(",d,".","framebufferHeight","-",f,")");return[e,f,g,c]});b&&(a.thisDep=a.thisDep||
  b.thisDep,a.contextDep=a.contextDep||b.contextDep,a.propDep=a.propDep||b.propDep);return a}return b?new P(b.thisDep,b.contextDep,b.propDep,function(a,b){var c=a.shared.context;return[0,0,b.def(c,".","framebufferWidth"),b.def(c,".","framebufferHeight")]}):null}var e=a["static"],f=a.dynamic;if(a=d("viewport")){var g=a;a=new P(a.thisDep,a.contextDep,a.propDep,function(a,b){var c=g.append(a,b),d=a.shared.context;b.set(d,".viewportWidth",c[2]);b.set(d,".viewportHeight",c[3]);return c})}return{viewport:a,
  scissor_box:d("scissor.box")}}function H(a,b){var c=a["static"];if("string"===typeof c.frag&&"string"===typeof c.vert){if(0<Object.keys(b.dynamic).length)return null;var c=b["static"],d=Object.keys(c);if(0<d.length&&"number"===typeof c[d[0]]){for(var e=[],f=0;f<d.length;++f)e.push([c[d[f]]|0,d[f]]);return e}}return null}function E(a,c,d){function e(a){if(a in f){var c=b.id(f[a]);a=C(function(){return c});a.id=c;return a}if(a in g){var d=g[a];return L(d,function(a,b){var c=a.invoke(b,d);return b.def(a.shared.strings,
  ".id(",c,")")})}return null}var f=a["static"],g=a.dynamic,h=e("frag"),ca=e("vert"),ya=null;ua(h)&&ua(ca)?(ya=t.program(ca.id,h.id,null,d),a=C(function(a,b){return a.link(ya)})):a=new P(h&&h.thisDep||ca&&ca.thisDep,h&&h.contextDep||ca&&ca.contextDep,h&&h.propDep||ca&&ca.propDep,function(a,b){var c=a.shared.shader,d;d=h?h.append(a,b):b.def(c,".","frag");var e;e=ca?ca.append(a,b):b.def(c,".","vert");return b.def(c+".program("+e+","+d+")")});return{frag:h,vert:ca,progVar:a,program:ya}}function G(a,b){function c(a,
  b){if(a in e){var d=e[a]|0;return C(function(a,c){b&&(a.OFFSET=d);return d})}if(a in f){var h=f[a];return L(h,function(a,c){var d=a.invoke(c,h);b&&(a.OFFSET=d);return d})}return b&&g?C(function(a,b){a.OFFSET="0";return 0}):null}var e=a["static"],f=a.dynamic,g=function(){if("elements"in e){var a=e.elements;Oa(a)?a=d.getElements(d.create(a,!0)):a&&(a=d.getElements(a));var b=C(function(b,c){if(a){var d=b.link(a);return b.ELEMENTS=d}return b.ELEMENTS=null});b.value=a;return b}if("elements"in f){var c=
  f.elements;return L(c,function(a,b){var d=a.shared,e=d.isBufferArgs,d=d.elements,f=a.invoke(b,c),g=b.def("null"),e=b.def(e,"(",f,")"),f=a.cond(e).then(g,"=",d,".createStream(",f,");")["else"](g,"=",d,".getElements(",f,");");b.entry(f);b.exit(a.cond(e).then(d,".destroyStream(",g,");"));return a.ELEMENTS=g})}return null}(),h=c("offset",!0);return{elements:g,primitive:function(){if("primitive"in e){var a=e.primitive;return C(function(b,c){return Sa[a]})}if("primitive"in f){var b=f.primitive;return L(b,
  function(a,c){var d=a.constants.primTypes,e=a.invoke(c,b);return c.def(d,"[",e,"]")})}return g?ua(g)?g.value?C(function(a,b){return b.def(a.ELEMENTS,".primType")}):C(function(){return 4}):new P(g.thisDep,g.contextDep,g.propDep,function(a,b){var c=a.ELEMENTS;return b.def(c,"?",c,".primType:",4)}):null}(),count:function(){if("count"in e){var a=e.count|0;return C(function(){return a})}if("count"in f){var b=f.count;return L(b,function(a,c){return a.invoke(c,b)})}return g?ua(g)?g?h?new P(h.thisDep,h.contextDep,
  h.propDep,function(a,b){return b.def(a.ELEMENTS,".vertCount-",a.OFFSET)}):C(function(a,b){return b.def(a.ELEMENTS,".vertCount")}):C(function(){return-1}):new P(g.thisDep||h.thisDep,g.contextDep||h.contextDep,g.propDep||h.propDep,function(a,b){var c=a.ELEMENTS;return a.OFFSET?b.def(c,"?",c,".vertCount-",a.OFFSET,":-1"):b.def(c,"?",c,".vertCount:-1")}):null}(),instances:c("instances",!1),offset:h}}function R(a,b){var c=a["static"],d=a.dynamic,e={};Ka.forEach(function(a){function b(f,h){if(a in c){var y=
  f(c[a]);e[g]=C(function(){return y})}else if(a in d){var I=d[a];e[g]=L(I,function(a,b){return h(a,b,a.invoke(b,I))})}}var g=f(a);switch(a){case "cull.enable":case "blend.enable":case "dither":case "stencil.enable":case "depth.enable":case "scissor.enable":case "polygonOffset.enable":case "sample.alpha":case "sample.enable":case "depth.mask":return b(function(a){return a},function(a,b,c){return c});case "depth.func":return b(function(a){return $a[a]},function(a,b,c){return b.def(a.constants.compareFuncs,
  "[",c,"]")});case "depth.range":return b(function(a){return a},function(a,b,c){a=b.def("+",c,"[0]");b=b.def("+",c,"[1]");return[a,b]});case "blend.func":return b(function(a){return[Ea["srcRGB"in a?a.srcRGB:a.src],Ea["dstRGB"in a?a.dstRGB:a.dst],Ea["srcAlpha"in a?a.srcAlpha:a.src],Ea["dstAlpha"in a?a.dstAlpha:a.dst]]},function(a,b,c){function d(a,e){return b.def('"',a,e,'" in ',c,"?",c,".",a,e,":",c,".",a)}a=a.constants.blendFuncs;var e=d("src","RGB"),f=d("dst","RGB"),e=b.def(a,"[",e,"]"),g=b.def(a,
  "[",d("src","Alpha"),"]"),f=b.def(a,"[",f,"]");a=b.def(a,"[",d("dst","Alpha"),"]");return[e,f,g,a]});case "blend.equation":return b(function(a){if("string"===typeof a)return[W[a],W[a]];if("object"===typeof a)return[W[a.rgb],W[a.alpha]]},function(a,b,c){var d=a.constants.blendEquations,e=b.def(),f=b.def();a=a.cond("typeof ",c,'==="string"');a.then(e,"=",f,"=",d,"[",c,"];");a["else"](e,"=",d,"[",c,".rgb];",f,"=",d,"[",c,".alpha];");b(a);return[e,f]});case "blend.color":return b(function(a){return A(4,
  function(b){return+a[b]})},function(a,b,c){return A(4,function(a){return b.def("+",c,"[",a,"]")})});case "stencil.mask":return b(function(a){return a|0},function(a,b,c){return b.def(c,"|0")});case "stencil.func":return b(function(a){return[$a[a.cmp||"keep"],a.ref||0,"mask"in a?a.mask:-1]},function(a,b,c){a=b.def('"cmp" in ',c,"?",a.constants.compareFuncs,"[",c,".cmp]",":",7680);var d=b.def(c,".ref|0");b=b.def('"mask" in ',c,"?",c,".mask|0:-1");return[a,d,b]});case "stencil.opFront":case "stencil.opBack":return b(function(b){return["stencil.opBack"===
  a?1029:1028,Pa[b.fail||"keep"],Pa[b.zfail||"keep"],Pa[b.zpass||"keep"]]},function(b,c,d){function e(a){return c.def('"',a,'" in ',d,"?",f,"[",d,".",a,"]:",7680)}var f=b.constants.stencilOps;return["stencil.opBack"===a?1029:1028,e("fail"),e("zfail"),e("zpass")]});case "polygonOffset.offset":return b(function(a){return[a.factor|0,a.units|0]},function(a,b,c){a=b.def(c,".factor|0");b=b.def(c,".units|0");return[a,b]});case "cull.face":return b(function(a){var b=0;"front"===a?b=1028:"back"===a&&(b=1029);
  return b},function(a,b,c){return b.def(c,'==="front"?',1028,":",1029)});case "lineWidth":return b(function(a){return a},function(a,b,c){return c});case "frontFace":return b(function(a){return xb[a]},function(a,b,c){return b.def(c+'==="cw"?2304:2305')});case "colorMask":return b(function(a){return a.map(function(a){return!!a})},function(a,b,c){return A(4,function(a){return"!!"+c+"["+a+"]"})});case "sample.coverage":return b(function(a){return["value"in a?a.value:1,!!a.invert]},function(a,b,c){a=b.def('"value" in ',
  c,"?+",c,".value:1");b=b.def("!!",c,".invert");return[a,b]})}});return e}function sa(a,b){var c=a["static"],d=a.dynamic,e={};Object.keys(c).forEach(function(a){var b=c[a],d;if("number"===typeof b||"boolean"===typeof b)d=C(function(){return b});else if("function"===typeof b){var f=b._reglType;if("texture2d"===f||"textureCube"===f)d=C(function(a){return a.link(b)});else if("framebuffer"===f||"framebufferCube"===f)d=C(function(a){return a.link(b.color[0])})}else na(b)&&(d=C(function(a){return a.global.def("[",
  A(b.length,function(a){return b[a]}),"]")}));d.value=b;e[a]=d});Object.keys(d).forEach(function(a){var b=d[a];e[a]=L(b,function(a,c){return a.invoke(c,b)})});return e}function J(a,c){var d=a["static"],e=a.dynamic,f={};Object.keys(d).forEach(function(a){var c=d[a],e=b.id(a),h=new ia;if(Oa(c))h.state=1,h.buffer=g.getBuffer(g.create(c,34962,!1,!0)),h.type=0;else{var y=g.getBuffer(c);if(y)h.state=1,h.buffer=y,h.type=0;else if("constant"in c){var I=c.constant;h.buffer="null";h.state=2;"number"===typeof I?
  h.x=I:Ba.forEach(function(a,b){b<I.length&&(h[a]=I[b])})}else{var y=Oa(c.buffer)?g.getBuffer(g.create(c.buffer,34962,!1,!0)):g.getBuffer(c.buffer),k=c.offset|0,m=c.stride|0,da=c.size|0,n=!!c.normalized,l=0;"type"in c&&(l=Ha[c.type]);c=c.divisor|0;h.buffer=y;h.state=1;h.size=da;h.normalized=n;h.type=l||y.dtype;h.offset=k;h.stride=m;h.divisor=c}}f[a]=C(function(a,b){var c=a.attribCache;if(e in c)return c[e];var d={isStream:!1};Object.keys(h).forEach(function(a){d[a]=h[a]});h.buffer&&(d.buffer=a.link(h.buffer),
  d.type=d.type||d.buffer+".dtype");return c[e]=d})});Object.keys(e).forEach(function(a){var b=e[a];f[a]=L(b,function(a,c){function d(a){c(y[a],"=",e,".",a,"|0;")}var e=a.invoke(c,b),f=a.shared,g=a.constants,h=f.isBufferArgs,f=f.buffer,y={isStream:c.def(!1)},I=new ia;I.state=1;Object.keys(I).forEach(function(a){y[a]=c.def(""+I[a])});var k=y.buffer,U=y.type;c("if(",h,"(",e,")){",y.isStream,"=true;",k,"=",f,".createStream(",34962,",",e,");",U,"=",k,".dtype;","}else{",k,"=",f,".getBuffer(",e,");","if(",
  k,"){",U,"=",k,".dtype;",'}else if("constant" in ',e,"){",y.state,"=",2,";","if(typeof "+e+'.constant === "number"){',y[Ba[0]],"=",e,".constant;",Ba.slice(1).map(function(a){return y[a]}).join("="),"=0;","}else{",Ba.map(function(a,b){return y[a]+"="+e+".constant.length>"+b+"?"+e+".constant["+b+"]:0;"}).join(""),"}}else{","if(",h,"(",e,".buffer)){",k,"=",f,".createStream(",34962,",",e,".buffer);","}else{",k,"=",f,".getBuffer(",e,".buffer);","}",U,'="type" in ',e,"?",g.glTypes,"[",e,".type]:",k,".dtype;",
  y.normalized,"=!!",e,".normalized;");d("size");d("offset");d("stride");d("divisor");c("}}");c.exit("if(",y.isStream,"){",f,".destroyStream(",k,");","}");return y})});return f}function D(a,b){var c=a["static"],d=a.dynamic;if("vao"in c){var e=c.vao;null!==e&&null===q.getVAO(e)&&(e=q.createVAO(e));return C(function(a){return a.link(q.getVAO(e))})}if("vao"in d){var f=d.vao;return L(f,function(a,b){var c=a.invoke(b,f);return b.def(a.shared.vao+".getVAO("+c+")")})}return null}function x(a){var b=a["static"],
  c=a.dynamic,d={};Object.keys(b).forEach(function(a){var c=b[a];d[a]=C(function(a,b){return"number"===typeof c||"boolean"===typeof c?""+c:a.link(c)})});Object.keys(c).forEach(function(a){var b=c[a];d[a]=L(b,function(a,c){return a.invoke(c,b)})});return d}function la(a,b,d,e,g){function h(a){var b=n[a];b&&(Za[a]=b)}var k=H(a,b),m=z(a,g),n=w(a,m,g),l=G(a,g),Za=R(a,g),p=E(a,g,k);h("viewport");h(f("scissor.box"));var r=0<Object.keys(Za).length,m={framebuffer:m,draw:l,shader:p,state:Za,dirty:r,scopeVAO:null,
  drawVAO:null,useVAO:!1,attributes:{}};m.profile=Q(a,g);m.uniforms=sa(d,g);m.drawVAO=m.scopeVAO=D(a,g);if(!m.drawVAO&&p.program&&!k&&c.angle_instanced_arrays){var t=!0;a=p.program.attributes.map(function(a){a=b["static"][a];t=t&&!!a;return a});if(t&&0<a.length){var v=q.getVAO(q.createVAO(a));m.drawVAO=new P(null,null,null,function(a,b){return a.link(v)});m.useVAO=!0}}k?m.useVAO=!0:m.attributes=J(b,g);m.context=x(e,g);return m}function T(a,b,c){var d=a.shared.context,e=a.scope();Object.keys(c).forEach(function(f){b.save(d,
  "."+f);e(d,".",f,"=",c[f].append(a,b),";")});b(e)}function O(a,b,c,d){var e=a.shared,f=e.gl,g=e.framebuffer,h;Ja&&(h=b.def(e.extensions,".webgl_draw_buffers"));var k=a.constants,e=k.drawBuffer,k=k.backBuffer;a=c?c.append(a,b):b.def(g,".next");d||b("if(",a,"!==",g,".cur){");b("if(",a,"){",f,".bindFramebuffer(",36160,",",a,".framebuffer);");Ja&&b(h,".drawBuffersWEBGL(",e,"[",a,".colorAttachments.length]);");b("}else{",f,".bindFramebuffer(",36160,",null);");Ja&&b(h,".drawBuffersWEBGL(",k,");");b("}",
  g,".cur=",a,";");d||b("}")}function S(a,b,c){var d=a.shared,e=d.gl,g=a.current,h=a.next,k=d.current,m=d.next,n=a.cond(k,".dirty");Ka.forEach(function(b){b=f(b);if(!(b in c.state)){var d,I;if(b in h){d=h[b];I=g[b];var l=A(pa[b].length,function(a){return n.def(d,"[",a,"]")});n(a.cond(l.map(function(a,b){return a+"!=="+I+"["+b+"]"}).join("||")).then(e,".",ra[b],"(",l,");",l.map(function(a,b){return I+"["+b+"]="+a}).join(";"),";"))}else d=n.def(m,".",b),l=a.cond(d,"!==",k,".",b),n(l),b in qa?l(a.cond(d).then(e,
  ".enable(",qa[b],");")["else"](e,".disable(",qa[b],");"),k,".",b,"=",d,";"):l(e,".",ra[b],"(",d,");",k,".",b,"=",d,";")}});0===Object.keys(c.state).length&&n(k,".dirty=false;");b(n)}function K(a,b,c,d){var e=a.shared,f=a.current,g=e.current,h=e.gl;wb(Object.keys(c)).forEach(function(e){var k=c[e];if(!d||d(k)){var m=k.append(a,b);if(qa[e]){var n=qa[e];ua(k)?m?b(h,".enable(",n,");"):b(h,".disable(",n,");"):b(a.cond(m).then(h,".enable(",n,");")["else"](h,".disable(",n,");"));b(g,".",e,"=",m,";")}else if(na(m)){var l=
  f[e];b(h,".",ra[e],"(",m,");",m.map(function(a,b){return l+"["+b+"]="+a}).join(";"),";")}else b(h,".",ra[e],"(",m,");",g,".",e,"=",m,";")}})}function B(a,b){oa&&(a.instancing=b.def(a.shared.extensions,".angle_instanced_arrays"))}function V(a,b,c,d,e){function f(){return"undefined"===typeof performance?"Date.now()":"performance.now()"}function g(a){q=b.def();a(q,"=",f(),";");"string"===typeof e?a(l,".count+=",e,";"):a(l,".count++;");k&&(d?(t=b.def(),a(t,"=",r,".getNumPendingQueries();")):a(r,".beginQuery(",
  l,");"))}function h(a){a(l,".cpuTime+=",f(),"-",q,";");k&&(d?a(r,".pushScopeStats(",t,",",r,".getNumPendingQueries(),",l,");"):a(r,".endQuery();"))}function m(a){var c=b.def(p,".profile");b(p,".profile=",a,";");b.exit(p,".profile=",c,";")}var n=a.shared,l=a.stats,p=n.current,r=n.timer;c=c.profile;var q,t;if(c){if(ua(c)){c.enable?(g(b),h(b.exit),m("true")):m("false");return}c=c.append(a,b);m(c)}else c=b.def(p,".profile");n=a.block();g(n);b("if(",c,"){",n,"}");a=a.block();h(a);b.exit("if(",c,"){",a,
  "}")}function N(a,b,c,d,e){function f(a){switch(a){case 35664:case 35667:case 35671:return 2;case 35665:case 35668:case 35672:return 3;case 35666:case 35669:case 35673:return 4;default:return 1}}function g(c,d,e){function f(){b("if(!",l,".buffer){",m,".enableVertexAttribArray(",n,");}");var c=e.type,g;g=e.size?b.def(e.size,"||",d):d;b("if(",l,".type!==",c,"||",l,".size!==",g,"||",da.map(function(a){return l+"."+a+"!=="+e[a]}).join("||"),"){",m,".bindBuffer(",34962,",",U,".buffer);",m,".vertexAttribPointer(",
  [n,g,c,e.normalized,e.stride,e.offset],");",l,".type=",c,";",l,".size=",g,";",da.map(function(a){return l+"."+a+"="+e[a]+";"}).join(""),"}");oa&&(c=e.divisor,b("if(",l,".divisor!==",c,"){",a.instancing,".vertexAttribDivisorANGLE(",[n,c],");",l,".divisor=",c,";}"))}function k(){b("if(",l,".buffer){",m,".disableVertexAttribArray(",n,");",l,".buffer=null;","}if(",Ba.map(function(a,b){return l+"."+a+"!=="+p[b]}).join("||"),"){",m,".vertexAttrib4f(",n,",",p,");",Ba.map(function(a,b){return l+"."+a+"="+
  p[b]+";"}).join(""),"}")}var m=h.gl,n=b.def(c,".location"),l=b.def(h.attributes,"[",n,"]");c=e.state;var U=e.buffer,p=[e.x,e.y,e.z,e.w],da=["buffer","normalized","offset","stride"];1===c?f():2===c?k():(b("if(",c,"===",1,"){"),f(),b("}else{"),k(),b("}"))}var h=a.shared;d.forEach(function(d){var h=d.name,k=c.attributes[h],m;if(k){if(!e(k))return;m=k.append(a,b)}else{if(!e(yb))return;var n=a.scopeAttrib(h);m={};Object.keys(new ia).forEach(function(a){m[a]=b.def(n,".",a)})}g(a.link(d),f(d.info.type),
  m)})}function wa(a,c,d,e,f){for(var g=a.shared,h=g.gl,k,m=0;m<e.length;++m){var n=e[m],l=n.name,p=n.info.type,r=d.uniforms[l],n=a.link(n)+".location",q;if(r){if(!f(r))continue;if(ua(r)){l=r.value;if(35678===p||35680===p)p=a.link(l._texture||l.color[0]._texture),c(h,".uniform1i(",n,",",p+".bind());"),c.exit(p,".unbind();");else if(35674===p||35675===p||35676===p)l=a.global.def("new Float32Array(["+Array.prototype.slice.call(l)+"])"),r=2,35675===p?r=3:35676===p&&(r=4),c(h,".uniformMatrix",r,"fv(",n,
  ",false,",l,");");else{switch(p){case 5126:k="1f";break;case 35664:k="2f";break;case 35665:k="3f";break;case 35666:k="4f";break;case 35670:k="1i";break;case 5124:k="1i";break;case 35671:k="2i";break;case 35667:k="2i";break;case 35672:k="3i";break;case 35668:k="3i";break;case 35673:k="4i";break;case 35669:k="4i"}c(h,".uniform",k,"(",n,",",na(l)?Array.prototype.slice.call(l):l,");")}continue}else q=r.append(a,c)}else{if(!f(yb))continue;q=c.def(g.uniforms,"[",b.id(l),"]")}35678===p?c("if(",q,"&&",q,
  '._reglType==="framebuffer"){',q,"=",q,".color[0];","}"):35680===p&&c("if(",q,"&&",q,'._reglType==="framebufferCube"){',q,"=",q,".color[0];","}");l=1;switch(p){case 35678:case 35680:p=c.def(q,"._texture");c(h,".uniform1i(",n,",",p,".bind());");c.exit(p,".unbind();");continue;case 5124:case 35670:k="1i";break;case 35667:case 35671:k="2i";l=2;break;case 35668:case 35672:k="3i";l=3;break;case 35669:case 35673:k="4i";l=4;break;case 5126:k="1f";break;case 35664:k="2f";l=2;break;case 35665:k="3f";l=3;break;
  case 35666:k="4f";l=4;break;case 35674:k="Matrix2fv";break;case 35675:k="Matrix3fv";break;case 35676:k="Matrix4fv"}c(h,".uniform",k,"(",n,",");if("M"===k.charAt(0)){var n=Math.pow(p-35674+2,2),t=a.global.def("new Float32Array(",n,")");c("false,(Array.isArray(",q,")||",q," instanceof Float32Array)?",q,":(",A(n,function(a){return t+"["+a+"]="+q+"["+a+"]"}),",",t,")")}else 1<l?c(A(l,function(a){return q+"["+a+"]"})):c(q);c(");")}}function aa(a,b,c,d){function e(f){var g=l[f];return g?g.contextDep&&d.contextDynamic||
  g.propDep?g.append(a,c):g.append(a,b):b.def(m,".",f)}function f(){function a(){c(v,".drawElementsInstancedANGLE(",[p,r,u,q+"<<(("+u+"-5121)>>1)",t],");")}function b(){c(v,".drawArraysInstancedANGLE(",[p,q,r,t],");")}n?ba?a():(c("if(",n,"){"),a(),c("}else{"),b(),c("}")):b()}function g(){function a(){c(k+".drawElements("+[p,r,u,q+"<<(("+u+"-5121)>>1)"]+");")}function b(){c(k+".drawArrays("+[p,q,r]+");")}n?ba?a():(c("if(",n,"){"),a(),c("}else{"),b(),c("}")):b()}var h=a.shared,k=h.gl,m=h.draw,l=d.draw,
  n=function(){var e=l.elements,f=b;if(e){if(e.contextDep&&d.contextDynamic||e.propDep)f=c;e=e.append(a,f)}else e=f.def(m,".","elements");e&&f("if("+e+")"+k+".bindBuffer(34963,"+e+".buffer.buffer);");return e}(),p=e("primitive"),q=e("offset"),r=function(){var e=l.count,f=b;if(e){if(e.contextDep&&d.contextDynamic||e.propDep)f=c;e=e.append(a,f)}else e=f.def(m,".","count");return e}();if("number"===typeof r){if(0===r)return}else c("if(",r,"){"),c.exit("}");var t,v;oa&&(t=e("instances"),v=a.instancing);
  var u=n+".type",ba=l.elements&&ua(l.elements);oa&&("number"!==typeof t||0<=t)?"string"===typeof t?(c("if(",t,">0){"),f(),c("}else if(",t,"<0){"),g(),c("}")):f():g()}function xa(a,b,c,d,e){b=v();e=b.proc("body",e);oa&&(b.instancing=e.def(b.shared.extensions,".angle_instanced_arrays"));a(b,e,c,d);return b.compile().body}function ba(a,b,c,d){B(a,b);c.useVAO?c.drawVAO?b(a.shared.vao,".setVAO(",c.drawVAO.append(a,b),");"):b(a.shared.vao,".setVAO(",a.shared.vao,".targetVAO);"):(b(a.shared.vao,".setVAO(null);"),
  N(a,b,c,d.attributes,function(){return!0}));wa(a,b,c,d.uniforms,function(){return!0});aa(a,b,b,c)}function Da(a,b){var c=a.proc("draw",1);B(a,c);T(a,c,b.context);O(a,c,b.framebuffer);S(a,c,b);K(a,c,b.state);V(a,c,b,!1,!0);var d=b.shader.progVar.append(a,c);c(a.shared.gl,".useProgram(",d,".program);");if(b.shader.program)ba(a,c,b,b.shader.program);else{c(a.shared.vao,".setVAO(null);");var e=a.global.def("{}"),f=c.def(d,".id"),g=c.def(e,"[",f,"]");c(a.cond(g).then(g,".call(this,a0);")["else"](g,"=",
  e,"[",f,"]=",a.link(function(c){return xa(ba,a,b,c,1)}),"(",d,");",g,".call(this,a0);"))}0<Object.keys(b.state).length&&c(a.shared.current,".dirty=true;")}function fa(a,b,c,d){function e(){return!0}a.batchId="a1";B(a,b);N(a,b,c,d.attributes,e);wa(a,b,c,d.uniforms,e);aa(a,b,b,c)}function M(a,b,c,d){function e(a){return a.contextDep&&g||a.propDep}function f(a){return!e(a)}B(a,b);var g=c.contextDep,h=b.def(),k=b.def();a.shared.props=k;a.batchId=h;var m=a.scope(),l=a.scope();b(m.entry,"for(",h,"=0;",
  h,"<","a1",";++",h,"){",k,"=","a0","[",h,"];",l,"}",m.exit);c.needsContext&&T(a,l,c.context);c.needsFramebuffer&&O(a,l,c.framebuffer);K(a,l,c.state,e);c.profile&&e(c.profile)&&V(a,l,c,!1,!0);d?(c.useVAO?c.drawVAO?e(c.drawVAO)?l(a.shared.vao,".setVAO(",c.drawVAO.append(a,l),");"):m(a.shared.vao,".setVAO(",c.drawVAO.append(a,m),");"):m(a.shared.vao,".setVAO(",a.shared.vao,".targetVAO);"):(m(a.shared.vao,".setVAO(null);"),N(a,m,c,d.attributes,f),N(a,l,c,d.attributes,e)),wa(a,m,c,d.uniforms,f),wa(a,l,
  c,d.uniforms,e),aa(a,m,l,c)):(b=a.global.def("{}"),d=c.shader.progVar.append(a,l),k=l.def(d,".id"),m=l.def(b,"[",k,"]"),l(a.shared.gl,".useProgram(",d,".program);","if(!",m,"){",m,"=",b,"[",k,"]=",a.link(function(b){return xa(fa,a,c,b,2)}),"(",d,");}",m,".call(this,a0[",h,"],",h,");"))}function X(a,b){function c(a){return a.contextDep&&e||a.propDep}var d=a.proc("batch",2);a.batchId="0";B(a,d);var e=!1,f=!0;Object.keys(b.context).forEach(function(a){e=e||b.context[a].propDep});e||(T(a,d,b.context),
  f=!1);var g=b.framebuffer,h=!1;g?(g.propDep?e=h=!0:g.contextDep&&e&&(h=!0),h||O(a,d,g)):O(a,d,null);b.state.viewport&&b.state.viewport.propDep&&(e=!0);S(a,d,b);K(a,d,b.state,function(a){return!c(a)});b.profile&&c(b.profile)||V(a,d,b,!1,"a1");b.contextDep=e;b.needsContext=f;b.needsFramebuffer=h;f=b.shader.progVar;if(f.contextDep&&e||f.propDep)M(a,d,b,null);else if(f=f.append(a,d),d(a.shared.gl,".useProgram(",f,".program);"),b.shader.program)M(a,d,b,b.shader.program);else{d(a.shared.vao,".setVAO(null);");
  var g=a.global.def("{}"),h=d.def(f,".id"),k=d.def(g,"[",h,"]");d(a.cond(k).then(k,".call(this,a0,a1);")["else"](k,"=",g,"[",h,"]=",a.link(function(c){return xa(M,a,b,c,2)}),"(",f,");",k,".call(this,a0,a1);"))}0<Object.keys(b.state).length&&d(a.shared.current,".dirty=true;")}function Y(a,c){function d(b){var g=c.shader[b];g&&e.set(f.shader,"."+b,g.append(a,e))}var e=a.proc("scope",3);a.batchId="a2";var f=a.shared,g=f.current;T(a,e,c.context);c.framebuffer&&c.framebuffer.append(a,e);wb(Object.keys(c.state)).forEach(function(b){var d=
  c.state[b].append(a,e);na(d)?d.forEach(function(c,d){e.set(a.next[b],"["+d+"]",c)}):e.set(f.next,"."+b,d)});V(a,e,c,!0,!0);["elements","offset","count","instances","primitive"].forEach(function(b){var d=c.draw[b];d&&e.set(f.draw,"."+b,""+d.append(a,e))});Object.keys(c.uniforms).forEach(function(d){e.set(f.uniforms,"["+b.id(d)+"]",c.uniforms[d].append(a,e))});Object.keys(c.attributes).forEach(function(b){var d=c.attributes[b].append(a,e),f=a.scopeAttrib(b);Object.keys(new ia).forEach(function(a){e.set(f,
  "."+a,d[a])})});c.scopeVAO&&e.set(f.vao,".targetVAO",c.scopeVAO.append(a,e));d("vert");d("frag");0<Object.keys(c.state).length&&(e(g,".dirty=true;"),e.exit(g,".dirty=true;"));e("a1(",a.shared.context,",a0,",a.batchId,");")}function ha(a){if("object"===typeof a&&!na(a)){for(var b=Object.keys(a),c=0;c<b.length;++c)if(ga.isDynamic(a[b[c]]))return!0;return!1}}function ja(a,b,c){function d(a,b){g.forEach(function(c){var d=e[c];ga.isDynamic(d)&&(d=a.invoke(b,d),b(l,".",c,"=",d,";"))})}var e=b["static"][c];
  if(e&&ha(e)){var f=a.global,g=Object.keys(e),h=!1,k=!1,m=!1,l=a.global.def("{}");g.forEach(function(b){var c=e[b];if(ga.isDynamic(c))"function"===typeof c&&(c=e[b]=ga.unbox(c)),b=L(c,null),h=h||b.thisDep,m=m||b.propDep,k=k||b.contextDep;else{f(l,".",b,"=");switch(typeof c){case "number":f(c);break;case "string":f('"',c,'"');break;case "object":Array.isArray(c)&&f("[",c.join(),"]");break;default:f(a.link(c))}f(";")}});b.dynamic[c]=new ga.DynamicVariable(4,{thisDep:h,contextDep:k,propDep:m,ref:l,append:d});
  delete b["static"][c]}}var ia=q.Record,W={add:32774,subtract:32778,"reverse subtract":32779};c.ext_blend_minmax&&(W.min=32775,W.max=32776);var oa=c.angle_instanced_arrays,Ja=c.webgl_draw_buffers,pa={dirty:!0,profile:h.profile},Ca={},Ka=[],qa={},ra={};p("dither",3024);p("blend.enable",3042);l("blend.color","blendColor",[0,0,0,0]);l("blend.equation","blendEquationSeparate",[32774,32774]);l("blend.func","blendFuncSeparate",[1,0,1,0]);p("depth.enable",2929,!0);l("depth.func","depthFunc",513);l("depth.range",
  "depthRange",[0,1]);l("depth.mask","depthMask",!0);l("colorMask","colorMask",[!0,!0,!0,!0]);p("cull.enable",2884);l("cull.face","cullFace",1029);l("frontFace","frontFace",2305);l("lineWidth","lineWidth",1);p("polygonOffset.enable",32823);l("polygonOffset.offset","polygonOffset",[0,0]);p("sample.alpha",32926);p("sample.enable",32928);l("sample.coverage","sampleCoverage",[1,!1]);p("stencil.enable",2960);l("stencil.mask","stencilMask",-1);l("stencil.func","stencilFunc",[519,0,-1]);l("stencil.opFront",
  "stencilOpSeparate",[1028,7680,7680,7680]);l("stencil.opBack","stencilOpSeparate",[1029,7680,7680,7680]);p("scissor.enable",3089);l("scissor.box","scissor",[0,0,a.drawingBufferWidth,a.drawingBufferHeight]);l("viewport","viewport",[0,0,a.drawingBufferWidth,a.drawingBufferHeight]);var ka={gl:a,context:F,strings:b,next:Ca,current:pa,draw:m,elements:d,buffer:g,shader:t,attributes:q.state,vao:q,uniforms:u,framebuffer:n,extensions:c,timer:k,isBufferArgs:Oa},Z={primTypes:Sa,compareFuncs:$a,blendFuncs:Ea,
  blendEquations:W,stencilOps:Pa,glTypes:Ha,orientationType:xb};Ja&&(Z.backBuffer=[1029],Z.drawBuffer=A(e.maxDrawbuffers,function(a){return 0===a?[0]:A(a,function(a){return 36064+a})}));var ta=0;return{next:Ca,current:pa,procs:function(){var a=v(),b=a.proc("poll"),d=a.proc("refresh"),f=a.block();b(f);d(f);var g=a.shared,h=g.gl,k=g.next,m=g.current;f(m,".dirty=false;");O(a,b);O(a,d,null,!0);var l;oa&&(l=a.link(oa));c.oes_vertex_array_object&&d(a.link(c.oes_vertex_array_object),".bindVertexArrayOES(null);");
  for(var n=0;n<e.maxAttributes;++n){var p=d.def(g.attributes,"[",n,"]"),q=a.cond(p,".buffer");q.then(h,".enableVertexAttribArray(",n,");",h,".bindBuffer(",34962,",",p,".buffer.buffer);",h,".vertexAttribPointer(",n,",",p,".size,",p,".type,",p,".normalized,",p,".stride,",p,".offset);")["else"](h,".disableVertexAttribArray(",n,");",h,".vertexAttrib4f(",n,",",p,".x,",p,".y,",p,".z,",p,".w);",p,".buffer=null;");d(q);oa&&d(l,".vertexAttribDivisorANGLE(",n,",",p,".divisor);")}d(a.shared.vao,".currentVAO=null;",
  a.shared.vao,".setVAO(",a.shared.vao,".targetVAO);");Object.keys(qa).forEach(function(c){var e=qa[c],g=f.def(k,".",c),l=a.block();l("if(",g,"){",h,".enable(",e,")}else{",h,".disable(",e,")}",m,".",c,"=",g,";");d(l);b("if(",g,"!==",m,".",c,"){",l,"}")});Object.keys(ra).forEach(function(c){var e=ra[c],g=pa[c],l,n,p=a.block();p(h,".",e,"(");na(g)?(e=g.length,l=a.global.def(k,".",c),n=a.global.def(m,".",c),p(A(e,function(a){return l+"["+a+"]"}),");",A(e,function(a){return n+"["+a+"]="+l+"["+a+"];"}).join("")),
  b("if(",A(e,function(a){return l+"["+a+"]!=="+n+"["+a+"]"}).join("||"),"){",p,"}")):(l=f.def(k,".",c),n=f.def(m,".",c),p(l,");",m,".",c,"=",l,";"),b("if(",l,"!==",n,"){",p,"}"));d(p)});return a.compile()}(),compile:function(a,b,c,d,e){var f=v();f.stats=f.link(e);Object.keys(b["static"]).forEach(function(a){ja(f,b,a)});Ub.forEach(function(b){ja(f,a,b)});c=la(a,b,c,d,f);Da(f,c);Y(f,c);X(f,c);return f.compile()}}}function zb(a,b){for(var c=0;c<a.length;++c)if(a[c]===b)return c;return-1}var H=function(a,
  b){for(var c=Object.keys(b),e=0;e<c.length;++e)a[c[e]]=b[c[e]];return a},Bb=0,ga={DynamicVariable:ja,define:function(a,b){return new ja(a,bb(b+""))},isDynamic:function(a){return"function"===typeof a&&!a._reglType||a instanceof ja},unbox:function(a,b){return"function"===typeof a?new ja(0,a):a},accessor:bb},ab={next:"function"===typeof requestAnimationFrame?function(a){return requestAnimationFrame(a)}:function(a){return setTimeout(a,16)},cancel:"function"===typeof cancelAnimationFrame?function(a){return cancelAnimationFrame(a)}:
  clearTimeout},Ab="undefined"!==typeof performance&&performance.now?function(){return performance.now()}:function(){return+new Date},z=fb();z.zero=fb();var Vb=function(a,b){var c=1;b.ext_texture_filter_anisotropic&&(c=a.getParameter(34047));var e=1,g=1;b.webgl_draw_buffers&&(e=a.getParameter(34852),g=a.getParameter(36063));var d=!!b.oes_texture_float;if(d){d=a.createTexture();a.bindTexture(3553,d);a.texImage2D(3553,0,6408,1,1,0,6408,5126,null);var r=a.createFramebuffer();a.bindFramebuffer(36160,r);
  a.framebufferTexture2D(36160,36064,3553,d,0);a.bindTexture(3553,null);if(36053!==a.checkFramebufferStatus(36160))d=!1;else{a.viewport(0,0,1,1);a.clearColor(1,0,0,1);a.clear(16384);var n=z.allocType(5126,4);a.readPixels(0,0,1,1,6408,5126,n);a.getError()?d=!1:(a.deleteFramebuffer(r),a.deleteTexture(d),d=1===n[0]);z.freeType(n)}}n=!0;"undefined"!==typeof navigator&&(/MSIE/.test(navigator.userAgent)||/Trident\//.test(navigator.appVersion)||/Edge/.test(navigator.userAgent))||(n=a.createTexture(),r=z.allocType(5121,
  36),a.activeTexture(33984),a.bindTexture(34067,n),a.texImage2D(34069,0,6408,3,3,0,6408,5121,r),z.freeType(r),a.bindTexture(34067,null),a.deleteTexture(n),n=!a.getError());return{colorBits:[a.getParameter(3410),a.getParameter(3411),a.getParameter(3412),a.getParameter(3413)],depthBits:a.getParameter(3414),stencilBits:a.getParameter(3415),subpixelBits:a.getParameter(3408),extensions:Object.keys(b).filter(function(a){return!!b[a]}),maxAnisotropic:c,maxDrawbuffers:e,maxColorAttachments:g,pointSizeDims:a.getParameter(33901),
  lineWidthDims:a.getParameter(33902),maxViewportDims:a.getParameter(3386),maxCombinedTextureUnits:a.getParameter(35661),maxCubeMapSize:a.getParameter(34076),maxRenderbufferSize:a.getParameter(34024),maxTextureUnits:a.getParameter(34930),maxTextureSize:a.getParameter(3379),maxAttributes:a.getParameter(34921),maxVertexUniforms:a.getParameter(36347),maxVertexTextureUnits:a.getParameter(35660),maxVaryingVectors:a.getParameter(36348),maxFragmentUniforms:a.getParameter(36349),glsl:a.getParameter(35724),
  renderer:a.getParameter(7937),vendor:a.getParameter(7936),version:a.getParameter(7938),readFloat:d,npotTextureCube:n}},G=function(a){return a instanceof Uint8Array||a instanceof Uint16Array||a instanceof Uint32Array||a instanceof Int8Array||a instanceof Int16Array||a instanceof Int32Array||a instanceof Float32Array||a instanceof Float64Array||a instanceof Uint8ClampedArray},J=function(a){return Object.keys(a).map(function(b){return a[b]})},Ma={shape:function(a){for(var b=[];a.length;a=a[0])b.push(a.length);
  return b},flatten:function(a,b,c,e){var g=1;if(b.length)for(var d=0;d<b.length;++d)g*=b[d];else g=0;c=e||z.allocType(c,g);switch(b.length){case 0:break;case 1:e=b[0];for(b=0;b<e;++b)c[b]=a[b];break;case 2:e=b[0];b=b[1];for(d=g=0;d<e;++d)for(var r=a[d],n=0;n<b;++n)c[g++]=r[n];break;case 3:gb(a,b[0],b[1],b[2],c,0);break;default:hb(a,b,0,c,0)}return c}},Ga={"[object Int8Array]":5120,"[object Int16Array]":5122,"[object Int32Array]":5124,"[object Uint8Array]":5121,"[object Uint8ClampedArray]":5121,"[object Uint16Array]":5123,
  "[object Uint32Array]":5125,"[object Float32Array]":5126,"[object Float64Array]":5121,"[object ArrayBuffer]":5121},Ha={int8:5120,int16:5122,int32:5124,uint8:5121,uint16:5123,uint32:5125,"float":5126,float32:5126},lb={dynamic:35048,stream:35040,"static":35044},Qa=Ma.flatten,kb=Ma.shape,ha=[];ha[5120]=1;ha[5122]=2;ha[5124]=4;ha[5121]=1;ha[5123]=2;ha[5125]=4;ha[5126]=4;var Sa={points:0,point:0,lines:1,line:1,triangles:4,triangle:4,"line loop":2,"line strip":3,"triangle strip":5,"triangle fan":6},ob=
  new Float32Array(1),Jb=new Uint32Array(ob.buffer),Nb=[9984,9986,9985,9987],La=[0,6409,6410,6407,6408],S={};S[6409]=S[6406]=S[6402]=1;S[34041]=S[6410]=2;S[6407]=S[35904]=3;S[6408]=S[35906]=4;var Va=ka("HTMLCanvasElement"),Wa=ka("OffscreenCanvas"),sb=ka("CanvasRenderingContext2D"),tb=ka("ImageBitmap"),ub=ka("HTMLImageElement"),vb=ka("HTMLVideoElement"),Kb=Object.keys(Ga).concat([Va,Wa,sb,tb,ub,vb]),Z=[];Z[5121]=1;Z[5126]=4;Z[36193]=2;Z[5123]=2;Z[5125]=4;var w=[];w[32854]=2;w[32855]=2;w[36194]=2;w[34041]=
  4;w[33776]=.5;w[33777]=.5;w[33778]=1;w[33779]=1;w[35986]=.5;w[35987]=1;w[34798]=1;w[35840]=.5;w[35841]=.25;w[35842]=.5;w[35843]=.25;w[36196]=.5;var E=[];E[32854]=2;E[32855]=2;E[36194]=2;E[33189]=2;E[36168]=1;E[34041]=4;E[35907]=4;E[34836]=16;E[34842]=8;E[34843]=6;var Wb=function(a,b,c,e,g){function d(a){this.id=q++;this.refCount=1;this.renderbuffer=a;this.format=32854;this.height=this.width=0;g.profile&&(this.stats={size:0})}function r(b){var c=b.renderbuffer;a.bindRenderbuffer(36161,null);a.deleteRenderbuffer(c);
  b.renderbuffer=null;b.refCount=0;delete t[b.id];e.renderbufferCount--}var n={rgba4:32854,rgb565:36194,"rgb5 a1":32855,depth:33189,stencil:36168,"depth stencil":34041};b.ext_srgb&&(n.srgba=35907);b.ext_color_buffer_half_float&&(n.rgba16f=34842,n.rgb16f=34843);b.webgl_color_buffer_float&&(n.rgba32f=34836);var u=[];Object.keys(n).forEach(function(a){u[n[a]]=a});var q=0,t={};d.prototype.decRef=function(){0>=--this.refCount&&r(this)};g.profile&&(e.getTotalRenderbufferSize=function(){var a=0;Object.keys(t).forEach(function(b){a+=
  t[b].stats.size});return a});return{create:function(b,c){function k(b,c){var d=0,e=0,m=32854;"object"===typeof b&&b?("shape"in b?(e=b.shape,d=e[0]|0,e=e[1]|0):("radius"in b&&(d=e=b.radius|0),"width"in b&&(d=b.width|0),"height"in b&&(e=b.height|0)),"format"in b&&(m=n[b.format])):"number"===typeof b?(d=b|0,e="number"===typeof c?c|0:d):b||(d=e=1);if(d!==h.width||e!==h.height||m!==h.format)return k.width=h.width=d,k.height=h.height=e,h.format=m,a.bindRenderbuffer(36161,h.renderbuffer),a.renderbufferStorage(36161,
  m,d,e),g.profile&&(h.stats.size=E[h.format]*h.width*h.height),k.format=u[h.format],k}var h=new d(a.createRenderbuffer());t[h.id]=h;e.renderbufferCount++;k(b,c);k.resize=function(b,c){var d=b|0,e=c|0||d;if(d===h.width&&e===h.height)return k;k.width=h.width=d;k.height=h.height=e;a.bindRenderbuffer(36161,h.renderbuffer);a.renderbufferStorage(36161,h.format,d,e);g.profile&&(h.stats.size=E[h.format]*h.width*h.height);return k};k._reglType="renderbuffer";k._renderbuffer=h;g.profile&&(k.stats=h.stats);k.destroy=
  function(){h.decRef()};return k},clear:function(){J(t).forEach(r)},restore:function(){J(t).forEach(function(b){b.renderbuffer=a.createRenderbuffer();a.bindRenderbuffer(36161,b.renderbuffer);a.renderbufferStorage(36161,b.format,b.width,b.height)});a.bindRenderbuffer(36161,null)}}},Xa=[];Xa[6408]=4;Xa[6407]=3;var Na=[];Na[5121]=1;Na[5126]=4;Na[36193]=2;var Ba=["x","y","z","w"],Ub="blend.func blend.equation stencil.func stencil.opFront stencil.opBack sample.coverage viewport scissor.box polygonOffset.offset".split(" "),
  Ea={0:0,1:1,zero:0,one:1,"src color":768,"one minus src color":769,"src alpha":770,"one minus src alpha":771,"dst color":774,"one minus dst color":775,"dst alpha":772,"one minus dst alpha":773,"constant color":32769,"one minus constant color":32770,"constant alpha":32771,"one minus constant alpha":32772,"src alpha saturate":776},$a={never:512,less:513,"<":513,equal:514,"=":514,"==":514,"===":514,lequal:515,"<=":515,greater:516,">":516,notequal:517,"!=":517,"!==":517,gequal:518,">=":518,always:519},
  Pa={0:0,zero:0,keep:7680,replace:7681,increment:7682,decrement:7683,"increment wrap":34055,"decrement wrap":34056,invert:5386},xb={cw:2304,ccw:2305},yb=new P(!1,!1,!1,function(){}),Xb=function(a,b){function c(){this.endQueryIndex=this.startQueryIndex=-1;this.sum=0;this.stats=null}function e(a,b,d){var e=r.pop()||new c;e.startQueryIndex=a;e.endQueryIndex=b;e.sum=0;e.stats=d;n.push(e)}if(!b.ext_disjoint_timer_query)return null;var g=[],d=[],r=[],n=[],u=[],q=[];return{beginQuery:function(a){var c=g.pop()||
  b.ext_disjoint_timer_query.createQueryEXT();b.ext_disjoint_timer_query.beginQueryEXT(35007,c);d.push(c);e(d.length-1,d.length,a)},endQuery:function(){b.ext_disjoint_timer_query.endQueryEXT(35007)},pushScopeStats:e,update:function(){var a,c;a=d.length;if(0!==a){q.length=Math.max(q.length,a+1);u.length=Math.max(u.length,a+1);u[0]=0;var e=q[0]=0;for(c=a=0;c<d.length;++c){var k=d[c];b.ext_disjoint_timer_query.getQueryObjectEXT(k,34919)?(e+=b.ext_disjoint_timer_query.getQueryObjectEXT(k,34918),g.push(k)):
  d[a++]=k;u[c+1]=e;q[c+1]=a}d.length=a;for(c=a=0;c<n.length;++c){var e=n[c],h=e.startQueryIndex,k=e.endQueryIndex;e.sum+=u[k]-u[h];h=q[h];k=q[k];k===h?(e.stats.gpuTime+=e.sum/1E6,r.push(e)):(e.startQueryIndex=h,e.endQueryIndex=k,n[a++]=e)}n.length=a}},getNumPendingQueries:function(){return d.length},clear:function(){g.push.apply(g,d);for(var a=0;a<g.length;a++)b.ext_disjoint_timer_query.deleteQueryEXT(g[a]);d.length=0;g.length=0},restore:function(){d.length=0;g.length=0}}};return function(a){function b(){if(0===
  B.length)w&&w.update(),aa=null;else{aa=ab.next(b);t();for(var a=B.length-1;0<=a;--a){var c=B[a];c&&c(A,null,0)}k.flush();w&&w.update()}}function c(){!aa&&0<B.length&&(aa=ab.next(b))}function e(){aa&&(ab.cancel(b),aa=null)}function g(a){a.preventDefault();e();V.forEach(function(a){a()})}function d(a){k.getError();f.restore();D.restore();R.restore();x.restore();N.restore();T.restore();J.restore();w&&w.restore();O.procs.refresh();c();X.forEach(function(a){a()})}function r(a){function b(a){var c={},d=
  {};Object.keys(a).forEach(function(b){var e=a[b];ga.isDynamic(e)?d[b]=ga.unbox(e,b):c[b]=e});return{dynamic:d,"static":c}}function c(a){for(;m.length<a;)m.push(null);return m}var d=b(a.context||{}),e=b(a.uniforms||{}),f=b(a.attributes||{}),g=b(function(a){function b(a){if(a in c){var d=c[a];delete c[a];Object.keys(d).forEach(function(b){c[a+"."+b]=d[b]})}}var c=H({},a);delete c.uniforms;delete c.attributes;delete c.context;delete c.vao;"stencil"in c&&c.stencil.op&&(c.stencil.opBack=c.stencil.opFront=
  c.stencil.op,delete c.stencil.op);b("blend");b("depth");b("cull");b("stencil");b("polygonOffset");b("scissor");b("sample");"vao"in a&&(c.vao=a.vao);return c}(a));a={gpuTime:0,cpuTime:0,count:0};var d=O.compile(g,f,e,d,a),h=d.draw,k=d.batch,l=d.scope,m=[];return H(function(a,b){var d;if("function"===typeof a)return l.call(this,null,a,0);if("function"===typeof b)if("number"===typeof a)for(d=0;d<a;++d)l.call(this,null,b,d);else if(Array.isArray(a))for(d=0;d<a.length;++d)l.call(this,a[d],b,d);else return l.call(this,
  a,b,0);else if("number"===typeof a){if(0<a)return k.call(this,c(a|0),a|0)}else if(Array.isArray(a)){if(a.length)return k.call(this,a,a.length)}else return h.call(this,a)},{stats:a})}function n(a,b){var c=0;O.procs.poll();var d=b.color;d&&(k.clearColor(+d[0]||0,+d[1]||0,+d[2]||0,+d[3]||0),c|=16384);"depth"in b&&(k.clearDepth(+b.depth),c|=256);"stencil"in b&&(k.clearStencil(b.stencil|0),c|=1024);k.clear(c)}function u(a){B.push(a);c();return{cancel:function(){function b(){var a=zb(B,b);B[a]=B[B.length-
  1];--B.length;0>=B.length&&e()}var c=zb(B,a);B[c]=b}}}function q(){var a=S.viewport,b=S.scissor_box;a[0]=a[1]=b[0]=b[1]=0;A.viewportWidth=A.framebufferWidth=A.drawingBufferWidth=a[2]=b[2]=k.drawingBufferWidth;A.viewportHeight=A.framebufferHeight=A.drawingBufferHeight=a[3]=b[3]=k.drawingBufferHeight}function t(){A.tick+=1;A.time=z();q();O.procs.poll()}function m(){q();O.procs.refresh();w&&w.update()}function z(){return(Ab()-C)/1E3}a=Fb(a);if(!a)return null;var k=a.gl,h=k.getContextAttributes();k.isContextLost();
  var f=Gb(k,a);if(!f)return null;var p=Cb(),l={vaoCount:0,bufferCount:0,elementsCount:0,framebufferCount:0,shaderCount:0,textureCount:0,cubeCount:0,renderbufferCount:0,maxTextureUnits:0},v=f.extensions,w=Xb(k,v),C=Ab(),E=k.drawingBufferWidth,L=k.drawingBufferHeight,A={tick:0,time:0,viewportWidth:E,viewportHeight:L,framebufferWidth:E,framebufferHeight:L,drawingBufferWidth:E,drawingBufferHeight:L,pixelRatio:a.pixelRatio},G=Vb(k,v),R=Hb(k,l,a,function(a){return J.destroyBuffer(a)}),J=Pb(k,v,G,l,R),P=
  Ib(k,v,R,l),D=Qb(k,p,l,a),x=Lb(k,v,G,function(){O.procs.poll()},A,l,a),N=Wb(k,v,G,l,a),T=Ob(k,v,G,x,N,l),O=Tb(k,p,v,G,R,P,x,T,{},J,D,{elements:null,primitive:4,count:-1,offset:0,instances:-1},A,w,a),p=Rb(k,T,O.procs.poll,A,h,v,G),S=O.next,K=k.canvas,B=[],V=[],X=[],Y=[a.onDestroy],aa=null;K&&(K.addEventListener("webglcontextlost",g,!1),K.addEventListener("webglcontextrestored",d,!1));var Z=T.setFBO=r({framebuffer:ga.define.call(null,1,"framebuffer")});m();h=H(r,{clear:function(a){if("framebuffer"in
  a)if(a.framebuffer&&"framebufferCube"===a.framebuffer_reglType)for(var b=0;6>b;++b)Z(H({framebuffer:a.framebuffer.faces[b]},a),n);else Z(a,n);else n(null,a)},prop:ga.define.bind(null,1),context:ga.define.bind(null,2),"this":ga.define.bind(null,3),draw:r({}),buffer:function(a){return R.create(a,34962,!1,!1)},elements:function(a){return P.create(a,!1)},texture:x.create2D,cube:x.createCube,renderbuffer:N.create,framebuffer:T.create,framebufferCube:T.createCube,vao:J.createVAO,attributes:h,frame:u,on:function(a,
  b){var c;switch(a){case "frame":return u(b);case "lost":c=V;break;case "restore":c=X;break;case "destroy":c=Y}c.push(b);return{cancel:function(){for(var a=0;a<c.length;++a)if(c[a]===b){c[a]=c[c.length-1];c.pop();break}}}},limits:G,hasExtension:function(a){return 0<=G.extensions.indexOf(a.toLowerCase())},read:p,destroy:function(){B.length=0;e();K&&(K.removeEventListener("webglcontextlost",g),K.removeEventListener("webglcontextrestored",d));D.clear();T.clear();N.clear();x.clear();P.clear();R.clear();
  J.clear();w&&w.clear();Y.forEach(function(a){a()})},_gl:k,_refresh:m,poll:function(){t();w&&w.update()},now:z,stats:l});a.onDone(null,h);return h}});
  
  },{}],513:[function(_dereq_,module,exports){
  /*!
   * repeat-string <https://github.com/jonschlinkert/repeat-string>
   *
   * Copyright (c) 2014-2015, Jon Schlinkert.
   * Licensed under the MIT License.
   */
  
  'use strict';
  
  /**
   * Results cache
   */
  
  var res = '';
  var cache;
  
  /**
   * Expose `repeat`
   */
  
  module.exports = repeat;
  
  /**
   * Repeat the given `string` the specified `number`
   * of times.
   *
   * **Example:**
   *
   * ```js
   * var repeat = require('repeat-string');
   * repeat('A', 5);
   * //=> AAAAA
   * ```
   *
   * @param {String} `string` The string to repeat
   * @param {Number} `number` The number of times to repeat the string
   * @return {String} Repeated string
   * @api public
   */
  
  function repeat(str, num) {
    if (typeof str !== 'string') {
      throw new TypeError('expected a string');
    }
  
    // cover common, quick use cases
    if (num === 1) return str;
    if (num === 2) return str + str;
  
    var max = str.length * num;
    if (cache !== str || typeof cache === 'undefined') {
      cache = str;
      res = '';
    } else if (res.length >= max) {
      return res.substr(0, max);
    }
  
    while (max > res.length && num > 1) {
      if (num & 1) {
        res += str;
      }
  
      num >>= 1;
      str += str;
    }
  
    res += str;
    res = res.substr(0, max);
    return res;
  }
  
  },{}],514:[function(_dereq_,module,exports){
  (function (global){
  module.exports =
    global.performance &&
    global.performance.now ? function now() {
      return performance.now()
    } : Date.now || function now() {
      return +new Date
    }
  
  }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{}],515:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = compressExpansion
  
  function compressExpansion(e) {
    var m = e.length
    var Q = e[e.length-1]
    var bottom = m
    for(var i=m-2; i>=0; --i) {
      var a = Q
      var b = e[i]
      Q = a + b
      var bv = Q - a
      var q = b - bv
      if(q) {
        e[--bottom] = Q
        Q = q
      }
    }
    var top = 0
    for(var i=bottom; i<m; ++i) {
      var a = e[i]
      var b = Q
      Q = a + b
      var bv = Q - a
      var q = b - bv
      if(q) {
        e[top++] = q
      }
    }
    e[top++] = Q
    e.length = top
    return e
  }
  },{}],516:[function(_dereq_,module,exports){
  "use strict"
  
  var twoProduct = _dereq_("two-product")
  var robustSum = _dereq_("robust-sum")
  var robustScale = _dereq_("robust-scale")
  var compress = _dereq_("robust-compress")
  
  var NUM_EXPANDED = 6
  
  function cofactor(m, c) {
    var result = new Array(m.length-1)
    for(var i=1; i<m.length; ++i) {
      var r = result[i-1] = new Array(m.length-1)
      for(var j=0,k=0; j<m.length; ++j) {
        if(j === c) {
          continue
        }
        r[k++] = m[i][j]
      }
    }
    return result
  }
  
  function matrix(n) {
    var result = new Array(n)
    for(var i=0; i<n; ++i) {
      result[i] = new Array(n)
      for(var j=0; j<n; ++j) {
        result[i][j] = ["m[", i, "][", j, "]"].join("")
      }
    }
    return result
  }
  
  function sign(n) {
    if(n & 1) {
      return "-"
    }
    return ""
  }
  
  function generateSum(expr) {
    if(expr.length === 1) {
      return expr[0]
    } else if(expr.length === 2) {
      return ["sum(", expr[0], ",", expr[1], ")"].join("")
    } else {
      var m = expr.length>>1
      return ["sum(", generateSum(expr.slice(0, m)), ",", generateSum(expr.slice(m)), ")"].join("")
    }
  }
  
  function determinant(m) {
    if(m.length === 2) {
      return ["sum(prod(", m[0][0], ",", m[1][1], "),prod(-", m[0][1], ",", m[1][0], "))"].join("")
    } else {
      var expr = []
      for(var i=0; i<m.length; ++i) {
        expr.push(["scale(", determinant(cofactor(m, i)), ",", sign(i), m[0][i], ")"].join(""))
      }
      return generateSum(expr)
    }
  }
  
  function compileDeterminant(n) {
    var proc = new Function("sum", "scale", "prod", "compress", [
      "function robustDeterminant",n, "(m){return compress(", 
        determinant(matrix(n)),
      ")};return robustDeterminant", n].join(""))
    return proc(robustSum, robustScale, twoProduct, compress)
  }
  
  var CACHE = [
    function robustDeterminant0() { return [0] },
    function robustDeterminant1(m) { return [m[0][0]] }
  ]
  
  function generateDispatch() {
    while(CACHE.length < NUM_EXPANDED) {
      CACHE.push(compileDeterminant(CACHE.length))
    }
    var procArgs = []
    var code = ["function robustDeterminant(m){switch(m.length){"]
    for(var i=0; i<NUM_EXPANDED; ++i) {
      procArgs.push("det" + i)
      code.push("case ", i, ":return det", i, "(m);")
    }
    code.push("}\
  var det=CACHE[m.length];\
  if(!det)\
  det=CACHE[m.length]=gen(m.length);\
  return det(m);\
  }\
  return robustDeterminant")
    procArgs.push("CACHE", "gen", code.join(""))
    var proc = Function.apply(undefined, procArgs)
    module.exports = proc.apply(undefined, CACHE.concat([CACHE, compileDeterminant]))
    for(var i=0; i<CACHE.length; ++i) {
      module.exports[i] = CACHE[i]
    }
  }
  
  generateDispatch()
  },{"robust-compress":515,"robust-scale":522,"robust-sum":525,"two-product":554}],517:[function(_dereq_,module,exports){
  "use strict"
  
  var twoProduct = _dereq_("two-product")
  var robustSum = _dereq_("robust-sum")
  
  module.exports = robustDotProduct
  
  function robustDotProduct(a, b) {
    var r = twoProduct(a[0], b[0])
    for(var i=1; i<a.length; ++i) {
      r = robustSum(r, twoProduct(a[i], b[i]))
    }
    return r
  }
  },{"robust-sum":525,"two-product":554}],518:[function(_dereq_,module,exports){
  "use strict"
  
  var twoProduct = _dereq_("two-product")
  var robustSum = _dereq_("robust-sum")
  var robustDiff = _dereq_("robust-subtract")
  var robustScale = _dereq_("robust-scale")
  
  var NUM_EXPAND = 6
  
  function cofactor(m, c) {
    var result = new Array(m.length-1)
    for(var i=1; i<m.length; ++i) {
      var r = result[i-1] = new Array(m.length-1)
      for(var j=0,k=0; j<m.length; ++j) {
        if(j === c) {
          continue
        }
        r[k++] = m[i][j]
      }
    }
    return result
  }
  
  function matrix(n) {
    var result = new Array(n)
    for(var i=0; i<n; ++i) {
      result[i] = new Array(n)
      for(var j=0; j<n; ++j) {
        result[i][j] = ["m", j, "[", (n-i-2), "]"].join("")
      }
    }
    return result
  }
  
  function generateSum(expr) {
    if(expr.length === 1) {
      return expr[0]
    } else if(expr.length === 2) {
      return ["sum(", expr[0], ",", expr[1], ")"].join("")
    } else {
      var m = expr.length>>1
      return ["sum(", generateSum(expr.slice(0, m)), ",", generateSum(expr.slice(m)), ")"].join("")
    }
  }
  
  function makeProduct(a, b) {
    if(a.charAt(0) === "m") {
      if(b.charAt(0) === "w") {
        var toks = a.split("[")
        return ["w", b.substr(1), "m", toks[0].substr(1)].join("")
      } else {
        return ["prod(", a, ",", b, ")"].join("")
      }
    } else {
      return makeProduct(b, a)
    }
  }
  
  function sign(s) {
    if(s & 1 !== 0) {
      return "-"
    }
    return ""
  }
  
  function determinant(m) {
    if(m.length === 2) {
      return [["diff(", makeProduct(m[0][0], m[1][1]), ",", makeProduct(m[1][0], m[0][1]), ")"].join("")]
    } else {
      var expr = []
      for(var i=0; i<m.length; ++i) {
        expr.push(["scale(", generateSum(determinant(cofactor(m, i))), ",", sign(i), m[0][i], ")"].join(""))
      }
      return expr
    }
  }
  
  function makeSquare(d, n) {
    var terms = []
    for(var i=0; i<n-2; ++i) {
      terms.push(["prod(m", d, "[", i, "],m", d, "[", i, "])"].join(""))
    }
    return generateSum(terms)
  }
  
  function orientation(n) {
    var pos = []
    var neg = []
    var m = matrix(n)
    for(var i=0; i<n; ++i) {
      m[0][i] = "1"
      m[n-1][i] = "w"+i
    } 
    for(var i=0; i<n; ++i) {
      if((i&1)===0) {
        pos.push.apply(pos,determinant(cofactor(m, i)))
      } else {
        neg.push.apply(neg,determinant(cofactor(m, i)))
      }
    }
    var posExpr = generateSum(pos)
    var negExpr = generateSum(neg)
    var funcName = "exactInSphere" + n
    var funcArgs = []
    for(var i=0; i<n; ++i) {
      funcArgs.push("m" + i)
    }
    var code = ["function ", funcName, "(", funcArgs.join(), "){"]
    for(var i=0; i<n; ++i) {
      code.push("var w",i,"=",makeSquare(i,n),";")
      for(var j=0; j<n; ++j) {
        if(j !== i) {
          code.push("var w",i,"m",j,"=scale(w",i,",m",j,"[0]);")
        }
      }
    }
    code.push("var p=", posExpr, ",n=", negExpr, ",d=diff(p,n);return d[d.length-1];}return ", funcName)
    var proc = new Function("sum", "diff", "prod", "scale", code.join(""))
    return proc(robustSum, robustDiff, twoProduct, robustScale)
  }
  
  function inSphere0() { return 0 }
  function inSphere1() { return 0 }
  function inSphere2() { return 0 }
  
  var CACHED = [
    inSphere0,
    inSphere1,
    inSphere2
  ]
  
  function slowInSphere(args) {
    var proc = CACHED[args.length]
    if(!proc) {
      proc = CACHED[args.length] = orientation(args.length)
    }
    return proc.apply(undefined, args)
  }
  
  function generateInSphereTest() {
    while(CACHED.length <= NUM_EXPAND) {
      CACHED.push(orientation(CACHED.length))
    }
    var args = []
    var procArgs = ["slow"]
    for(var i=0; i<=NUM_EXPAND; ++i) {
      args.push("a" + i)
      procArgs.push("o" + i)
    }
    var code = [
      "function testInSphere(", args.join(), "){switch(arguments.length){case 0:case 1:return 0;"
    ]
    for(var i=2; i<=NUM_EXPAND; ++i) {
      code.push("case ", i, ":return o", i, "(", args.slice(0, i).join(), ");")
    }
    code.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return testInSphere")
    procArgs.push(code.join(""))
  
    var proc = Function.apply(undefined, procArgs)
  
    module.exports = proc.apply(undefined, [slowInSphere].concat(CACHED))
    for(var i=0; i<=NUM_EXPAND; ++i) {
      module.exports[i] = CACHED[i]
    }
  }
  
  generateInSphereTest()
  },{"robust-scale":522,"robust-subtract":524,"robust-sum":525,"two-product":554}],519:[function(_dereq_,module,exports){
  "use strict"
  
  var determinant = _dereq_("robust-determinant")
  
  var NUM_EXPAND = 6
  
  function generateSolver(n) {
    var funcName = "robustLinearSolve" + n + "d"
    var code = ["function ", funcName, "(A,b){return ["]
    for(var i=0; i<n; ++i) {
      code.push("det([")
      for(var j=0; j<n; ++j) {
        if(j > 0) {
          code.push(",")
        }
        code.push("[")
        for(var k=0; k<n; ++k) {
          if(k > 0) {
            code.push(",")
          }
          if(k === i) {
            code.push("+b[", j, "]")
          } else {
            code.push("+A[", j, "][", k, "]")
          }
        }
        code.push("]")
      }
      code.push("]),")
    }
    code.push("det(A)]}return ", funcName)
    var proc = new Function("det", code.join(""))
    if(n < 6) {
      return proc(determinant[n])
    }
    return proc(determinant)
  }
  
  function robustLinearSolve0d() {
    return [ 0 ]
  }
  
  function robustLinearSolve1d(A, b) {
    return [ [ b[0] ], [ A[0][0] ] ]
  }
  
  var CACHE = [
    robustLinearSolve0d,
    robustLinearSolve1d
  ]
  
  function generateDispatch() {
    while(CACHE.length < NUM_EXPAND) {
      CACHE.push(generateSolver(CACHE.length))
    }
    var procArgs = []
    var code = ["function dispatchLinearSolve(A,b){switch(A.length){"]
    for(var i=0; i<NUM_EXPAND; ++i) {
      procArgs.push("s" + i)
      code.push("case ", i, ":return s", i, "(A,b);")
    }
    code.push("}var s=CACHE[A.length];if(!s)s=CACHE[A.length]=g(A.length);return s(A,b)}return dispatchLinearSolve")
    procArgs.push("CACHE", "g", code.join(""))
    var proc = Function.apply(undefined, procArgs)
    module.exports = proc.apply(undefined, CACHE.concat([CACHE, generateSolver]))
    for(var i=0; i<NUM_EXPAND; ++i) {
      module.exports[i] = CACHE[i]
    }
  }
  
  generateDispatch()
  },{"robust-determinant":516}],520:[function(_dereq_,module,exports){
  "use strict"
  
  var twoProduct = _dereq_("two-product")
  var robustSum = _dereq_("robust-sum")
  var robustScale = _dereq_("robust-scale")
  var robustSubtract = _dereq_("robust-subtract")
  
  var NUM_EXPAND = 5
  
  var EPSILON     = 1.1102230246251565e-16
  var ERRBOUND3   = (3.0 + 16.0 * EPSILON) * EPSILON
  var ERRBOUND4   = (7.0 + 56.0 * EPSILON) * EPSILON
  
  function cofactor(m, c) {
    var result = new Array(m.length-1)
    for(var i=1; i<m.length; ++i) {
      var r = result[i-1] = new Array(m.length-1)
      for(var j=0,k=0; j<m.length; ++j) {
        if(j === c) {
          continue
        }
        r[k++] = m[i][j]
      }
    }
    return result
  }
  
  function matrix(n) {
    var result = new Array(n)
    for(var i=0; i<n; ++i) {
      result[i] = new Array(n)
      for(var j=0; j<n; ++j) {
        result[i][j] = ["m", j, "[", (n-i-1), "]"].join("")
      }
    }
    return result
  }
  
  function sign(n) {
    if(n & 1) {
      return "-"
    }
    return ""
  }
  
  function generateSum(expr) {
    if(expr.length === 1) {
      return expr[0]
    } else if(expr.length === 2) {
      return ["sum(", expr[0], ",", expr[1], ")"].join("")
    } else {
      var m = expr.length>>1
      return ["sum(", generateSum(expr.slice(0, m)), ",", generateSum(expr.slice(m)), ")"].join("")
    }
  }
  
  function determinant(m) {
    if(m.length === 2) {
      return [["sum(prod(", m[0][0], ",", m[1][1], "),prod(-", m[0][1], ",", m[1][0], "))"].join("")]
    } else {
      var expr = []
      for(var i=0; i<m.length; ++i) {
        expr.push(["scale(", generateSum(determinant(cofactor(m, i))), ",", sign(i), m[0][i], ")"].join(""))
      }
      return expr
    }
  }
  
  function orientation(n) {
    var pos = []
    var neg = []
    var m = matrix(n)
    var args = []
    for(var i=0; i<n; ++i) {
      if((i&1)===0) {
        pos.push.apply(pos, determinant(cofactor(m, i)))
      } else {
        neg.push.apply(neg, determinant(cofactor(m, i)))
      }
      args.push("m" + i)
    }
    var posExpr = generateSum(pos)
    var negExpr = generateSum(neg)
    var funcName = "orientation" + n + "Exact"
    var code = ["function ", funcName, "(", args.join(), "){var p=", posExpr, ",n=", negExpr, ",d=sub(p,n);\
  return d[d.length-1];};return ", funcName].join("")
    var proc = new Function("sum", "prod", "scale", "sub", code)
    return proc(robustSum, twoProduct, robustScale, robustSubtract)
  }
  
  var orientation3Exact = orientation(3)
  var orientation4Exact = orientation(4)
  
  var CACHED = [
    function orientation0() { return 0 },
    function orientation1() { return 0 },
    function orientation2(a, b) { 
      return b[0] - a[0]
    },
    function orientation3(a, b, c) {
      var l = (a[1] - c[1]) * (b[0] - c[0])
      var r = (a[0] - c[0]) * (b[1] - c[1])
      var det = l - r
      var s
      if(l > 0) {
        if(r <= 0) {
          return det
        } else {
          s = l + r
        }
      } else if(l < 0) {
        if(r >= 0) {
          return det
        } else {
          s = -(l + r)
        }
      } else {
        return det
      }
      var tol = ERRBOUND3 * s
      if(det >= tol || det <= -tol) {
        return det
      }
      return orientation3Exact(a, b, c)
    },
    function orientation4(a,b,c,d) {
      var adx = a[0] - d[0]
      var bdx = b[0] - d[0]
      var cdx = c[0] - d[0]
      var ady = a[1] - d[1]
      var bdy = b[1] - d[1]
      var cdy = c[1] - d[1]
      var adz = a[2] - d[2]
      var bdz = b[2] - d[2]
      var cdz = c[2] - d[2]
      var bdxcdy = bdx * cdy
      var cdxbdy = cdx * bdy
      var cdxady = cdx * ady
      var adxcdy = adx * cdy
      var adxbdy = adx * bdy
      var bdxady = bdx * ady
      var det = adz * (bdxcdy - cdxbdy) 
              + bdz * (cdxady - adxcdy)
              + cdz * (adxbdy - bdxady)
      var permanent = (Math.abs(bdxcdy) + Math.abs(cdxbdy)) * Math.abs(adz)
                    + (Math.abs(cdxady) + Math.abs(adxcdy)) * Math.abs(bdz)
                    + (Math.abs(adxbdy) + Math.abs(bdxady)) * Math.abs(cdz)
      var tol = ERRBOUND4 * permanent
      if ((det > tol) || (-det > tol)) {
        return det
      }
      return orientation4Exact(a,b,c,d)
    }
  ]
  
  function slowOrient(args) {
    var proc = CACHED[args.length]
    if(!proc) {
      proc = CACHED[args.length] = orientation(args.length)
    }
    return proc.apply(undefined, args)
  }
  
  function generateOrientationProc() {
    while(CACHED.length <= NUM_EXPAND) {
      CACHED.push(orientation(CACHED.length))
    }
    var args = []
    var procArgs = ["slow"]
    for(var i=0; i<=NUM_EXPAND; ++i) {
      args.push("a" + i)
      procArgs.push("o" + i)
    }
    var code = [
      "function getOrientation(", args.join(), "){switch(arguments.length){case 0:case 1:return 0;"
    ]
    for(var i=2; i<=NUM_EXPAND; ++i) {
      code.push("case ", i, ":return o", i, "(", args.slice(0, i).join(), ");")
    }
    code.push("}var s=new Array(arguments.length);for(var i=0;i<arguments.length;++i){s[i]=arguments[i]};return slow(s);}return getOrientation")
    procArgs.push(code.join(""))
  
    var proc = Function.apply(undefined, procArgs)
    module.exports = proc.apply(undefined, [slowOrient].concat(CACHED))
    for(var i=0; i<=NUM_EXPAND; ++i) {
      module.exports[i] = CACHED[i]
    }
  }
  
  generateOrientationProc()
  },{"robust-scale":522,"robust-subtract":524,"robust-sum":525,"two-product":554}],521:[function(_dereq_,module,exports){
  "use strict"
  
  var robustSum = _dereq_("robust-sum")
  var robustScale = _dereq_("robust-scale")
  
  module.exports = robustProduct
  
  function robustProduct(a, b) {
    if(a.length === 1) {
      return robustScale(b, a[0])
    }
    if(b.length === 1) {
      return robustScale(a, b[0])
    }
    if(a.length === 0 || b.length === 0) {
      return [0]
    }
    var r = [0]
    if(a.length < b.length) {
      for(var i=0; i<a.length; ++i) {
        r = robustSum(r, robustScale(b, a[i]))
      }
    } else {
      for(var i=0; i<b.length; ++i) {
        r = robustSum(r, robustScale(a, b[i]))
      }    
    }
    return r
  }
  },{"robust-scale":522,"robust-sum":525}],522:[function(_dereq_,module,exports){
  "use strict"
  
  var twoProduct = _dereq_("two-product")
  var twoSum = _dereq_("two-sum")
  
  module.exports = scaleLinearExpansion
  
  function scaleLinearExpansion(e, scale) {
    var n = e.length
    if(n === 1) {
      var ts = twoProduct(e[0], scale)
      if(ts[0]) {
        return ts
      }
      return [ ts[1] ]
    }
    var g = new Array(2 * n)
    var q = [0.1, 0.1]
    var t = [0.1, 0.1]
    var count = 0
    twoProduct(e[0], scale, q)
    if(q[0]) {
      g[count++] = q[0]
    }
    for(var i=1; i<n; ++i) {
      twoProduct(e[i], scale, t)
      var pq = q[1]
      twoSum(pq, t[0], q)
      if(q[0]) {
        g[count++] = q[0]
      }
      var a = t[1]
      var b = q[1]
      var x = a + b
      var bv = x - a
      var y = b - bv
      q[1] = x
      if(y) {
        g[count++] = y
      }
    }
    if(q[1]) {
      g[count++] = q[1]
    }
    if(count === 0) {
      g[count++] = 0.0
    }
    g.length = count
    return g
  }
  },{"two-product":554,"two-sum":555}],523:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = segmentsIntersect
  
  var orient = _dereq_("robust-orientation")[3]
  
  function checkCollinear(a0, a1, b0, b1) {
  
    for(var d=0; d<2; ++d) {
      var x0 = a0[d]
      var y0 = a1[d]
      var l0 = Math.min(x0, y0)
      var h0 = Math.max(x0, y0)    
  
      var x1 = b0[d]
      var y1 = b1[d]
      var l1 = Math.min(x1, y1)
      var h1 = Math.max(x1, y1)    
  
      if(h1 < l0 || h0 < l1) {
        return false
      }
    }
  
    return true
  }
  
  function segmentsIntersect(a0, a1, b0, b1) {
    var x0 = orient(a0, b0, b1)
    var y0 = orient(a1, b0, b1)
    if((x0 > 0 && y0 > 0) || (x0 < 0 && y0 < 0)) {
      return false
    }
  
    var x1 = orient(b0, a0, a1)
    var y1 = orient(b1, a0, a1)
    if((x1 > 0 && y1 > 0) || (x1 < 0 && y1 < 0)) {
      return false
    }
  
    //Check for degenerate collinear case
    if(x0 === 0 && y0 === 0 && x1 === 0 && y1 === 0) {
      return checkCollinear(a0, a1, b0, b1)
    }
  
    return true
  }
  },{"robust-orientation":520}],524:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = robustSubtract
  
  //Easy case: Add two scalars
  function scalarScalar(a, b) {
    var x = a + b
    var bv = x - a
    var av = x - bv
    var br = b - bv
    var ar = a - av
    var y = ar + br
    if(y) {
      return [y, x]
    }
    return [x]
  }
  
  function robustSubtract(e, f) {
    var ne = e.length|0
    var nf = f.length|0
    if(ne === 1 && nf === 1) {
      return scalarScalar(e[0], -f[0])
    }
    var n = ne + nf
    var g = new Array(n)
    var count = 0
    var eptr = 0
    var fptr = 0
    var abs = Math.abs
    var ei = e[eptr]
    var ea = abs(ei)
    var fi = -f[fptr]
    var fa = abs(fi)
    var a, b
    if(ea < fa) {
      b = ei
      eptr += 1
      if(eptr < ne) {
        ei = e[eptr]
        ea = abs(ei)
      }
    } else {
      b = fi
      fptr += 1
      if(fptr < nf) {
        fi = -f[fptr]
        fa = abs(fi)
      }
    }
    if((eptr < ne && ea < fa) || (fptr >= nf)) {
      a = ei
      eptr += 1
      if(eptr < ne) {
        ei = e[eptr]
        ea = abs(ei)
      }
    } else {
      a = fi
      fptr += 1
      if(fptr < nf) {
        fi = -f[fptr]
        fa = abs(fi)
      }
    }
    var x = a + b
    var bv = x - a
    var y = b - bv
    var q0 = y
    var q1 = x
    var _x, _bv, _av, _br, _ar
    while(eptr < ne && fptr < nf) {
      if(ea < fa) {
        a = ei
        eptr += 1
        if(eptr < ne) {
          ei = e[eptr]
          ea = abs(ei)
        }
      } else {
        a = fi
        fptr += 1
        if(fptr < nf) {
          fi = -f[fptr]
          fa = abs(fi)
        }
      }
      b = q0
      x = a + b
      bv = x - a
      y = b - bv
      if(y) {
        g[count++] = y
      }
      _x = q1 + x
      _bv = _x - q1
      _av = _x - _bv
      _br = x - _bv
      _ar = q1 - _av
      q0 = _ar + _br
      q1 = _x
    }
    while(eptr < ne) {
      a = ei
      b = q0
      x = a + b
      bv = x - a
      y = b - bv
      if(y) {
        g[count++] = y
      }
      _x = q1 + x
      _bv = _x - q1
      _av = _x - _bv
      _br = x - _bv
      _ar = q1 - _av
      q0 = _ar + _br
      q1 = _x
      eptr += 1
      if(eptr < ne) {
        ei = e[eptr]
      }
    }
    while(fptr < nf) {
      a = fi
      b = q0
      x = a + b
      bv = x - a
      y = b - bv
      if(y) {
        g[count++] = y
      } 
      _x = q1 + x
      _bv = _x - q1
      _av = _x - _bv
      _br = x - _bv
      _ar = q1 - _av
      q0 = _ar + _br
      q1 = _x
      fptr += 1
      if(fptr < nf) {
        fi = -f[fptr]
      }
    }
    if(q0) {
      g[count++] = q0
    }
    if(q1) {
      g[count++] = q1
    }
    if(!count) {
      g[count++] = 0.0  
    }
    g.length = count
    return g
  }
  },{}],525:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = linearExpansionSum
  
  //Easy case: Add two scalars
  function scalarScalar(a, b) {
    var x = a + b
    var bv = x - a
    var av = x - bv
    var br = b - bv
    var ar = a - av
    var y = ar + br
    if(y) {
      return [y, x]
    }
    return [x]
  }
  
  function linearExpansionSum(e, f) {
    var ne = e.length|0
    var nf = f.length|0
    if(ne === 1 && nf === 1) {
      return scalarScalar(e[0], f[0])
    }
    var n = ne + nf
    var g = new Array(n)
    var count = 0
    var eptr = 0
    var fptr = 0
    var abs = Math.abs
    var ei = e[eptr]
    var ea = abs(ei)
    var fi = f[fptr]
    var fa = abs(fi)
    var a, b
    if(ea < fa) {
      b = ei
      eptr += 1
      if(eptr < ne) {
        ei = e[eptr]
        ea = abs(ei)
      }
    } else {
      b = fi
      fptr += 1
      if(fptr < nf) {
        fi = f[fptr]
        fa = abs(fi)
      }
    }
    if((eptr < ne && ea < fa) || (fptr >= nf)) {
      a = ei
      eptr += 1
      if(eptr < ne) {
        ei = e[eptr]
        ea = abs(ei)
      }
    } else {
      a = fi
      fptr += 1
      if(fptr < nf) {
        fi = f[fptr]
        fa = abs(fi)
      }
    }
    var x = a + b
    var bv = x - a
    var y = b - bv
    var q0 = y
    var q1 = x
    var _x, _bv, _av, _br, _ar
    while(eptr < ne && fptr < nf) {
      if(ea < fa) {
        a = ei
        eptr += 1
        if(eptr < ne) {
          ei = e[eptr]
          ea = abs(ei)
        }
      } else {
        a = fi
        fptr += 1
        if(fptr < nf) {
          fi = f[fptr]
          fa = abs(fi)
        }
      }
      b = q0
      x = a + b
      bv = x - a
      y = b - bv
      if(y) {
        g[count++] = y
      }
      _x = q1 + x
      _bv = _x - q1
      _av = _x - _bv
      _br = x - _bv
      _ar = q1 - _av
      q0 = _ar + _br
      q1 = _x
    }
    while(eptr < ne) {
      a = ei
      b = q0
      x = a + b
      bv = x - a
      y = b - bv
      if(y) {
        g[count++] = y
      }
      _x = q1 + x
      _bv = _x - q1
      _av = _x - _bv
      _br = x - _bv
      _ar = q1 - _av
      q0 = _ar + _br
      q1 = _x
      eptr += 1
      if(eptr < ne) {
        ei = e[eptr]
      }
    }
    while(fptr < nf) {
      a = fi
      b = q0
      x = a + b
      bv = x - a
      y = b - bv
      if(y) {
        g[count++] = y
      } 
      _x = q1 + x
      _bv = _x - q1
      _av = _x - _bv
      _br = x - _bv
      _ar = q1 - _av
      q0 = _ar + _br
      q1 = _x
      fptr += 1
      if(fptr < nf) {
        fi = f[fptr]
      }
    }
    if(q0) {
      g[count++] = q0
    }
    if(q1) {
      g[count++] = q1
    }
    if(!count) {
      g[count++] = 0.0  
    }
    g.length = count
    return g
  }
  },{}],526:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = function signum(x) {
    if(x < 0) { return -1 }
    if(x > 0) { return 1 }
    return 0.0
  }
  },{}],527:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = boundary
  
  var bnd = _dereq_('boundary-cells')
  var reduce = _dereq_('reduce-simplicial-complex')
  
  function boundary(cells) {
    return reduce(bnd(cells))
  }
  
  },{"boundary-cells":100,"reduce-simplicial-complex":507}],528:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = extractContour
  
  var ndarray = _dereq_('ndarray')
  var pool    = _dereq_('typedarray-pool')
  var ndsort  = _dereq_('ndarray-sort')
  
  var contourAlgorithm = _dereq_('./lib/codegen')
  
  function getDimension(cells) {
    var numCells = cells.length
    var d = 0
    for(var i=0; i<numCells; ++i) {
      d = Math.max(d, cells[i].length)|0
    }
    return d-1
  }
  
  function getSigns(values, level) {
    var numVerts    = values.length
    var vertexSigns = pool.mallocUint8(numVerts)
    for(var i=0; i<numVerts; ++i) {
      vertexSigns[i] = (values[i] < level)|0
    }
    return vertexSigns
  }
  
  function getEdges(cells, d) {
    var numCells = cells.length
    var maxEdges = ((d * (d+1)/2) * numCells)|0
    var edges    = pool.mallocUint32(maxEdges*2)
    var ePtr     = 0
    for(var i=0; i<numCells; ++i) {
      var c = cells[i]
      var d = c.length
      for(var j=0; j<d; ++j) {
        for(var k=0; k<j; ++k) {
          var a = c[k]
          var b = c[j]
          edges[ePtr++] = Math.min(a,b)|0
          edges[ePtr++] = Math.max(a,b)|0
        }
      }
    }
    var nedges = (ePtr/2)|0
    ndsort(ndarray(edges, [nedges,2])) 
    var ptr = 2
    for(var i=2; i<ePtr; i+=2) {
      if(edges[i-2] === edges[i] &&
         edges[i-1] === edges[i+1]) {
        continue
      }
      edges[ptr++] = edges[i]
      edges[ptr++] = edges[i+1]
    }
  
    return ndarray(edges, [(ptr/2)|0, 2])
  }
  
  function getCrossingWeights(edges, values, signs, level) {
    var edata     = edges.data
    var numEdges  = edges.shape[0]
    var weights   = pool.mallocDouble(numEdges)
    var ptr       = 0
    for(var i=0; i<numEdges; ++i) {
      var a  = edata[2*i]
      var b  = edata[2*i+1]
      if(signs[a] === signs[b]) {
        continue
      }
      var va = values[a]
      var vb = values[b]
      edata[2*ptr]     = a
      edata[2*ptr+1]   = b
      weights[ptr++]   = (vb - level) / (vb - va)
    }
    edges.shape[0] = ptr
    return ndarray(weights, [ptr])
  }
  
  function getCascade(edges, numVerts) {
    var result   = pool.mallocInt32(numVerts*2)
    var numEdges = edges.shape[0]
    var edata    = edges.data
    result[0]    = 0
    var lastV    = 0
    for(var i=0; i<numEdges; ++i) {
      var a = edata[2*i]
      if(a !== lastV) {
        result[2*lastV+1] = i
        while(++lastV < a) {
          result[2*lastV] = i
          result[2*lastV+1] = i
        }
        result[2*lastV] = i
      }
    }
    result[2*lastV+1] = numEdges
    while(++lastV < numVerts) {
      result[2*lastV] = result[2*lastV+1] = numEdges
    }
    return result
  }
  
  function unpackEdges(edges) {
    var ne = edges.shape[0]|0
    var edata = edges.data
    var result = new Array(ne)
    for(var i=0; i<ne; ++i) {
      result[i] = [edata[2*i], edata[2*i+1]]
    }
    return result
  }
  
  function extractContour(cells, values, level, d) {
    level = level||0.0
  
    //If user didn't specify `d`, use brute force scan
    if(typeof d === 'undefined') {
      d = getDimension(cells)
    }
  
    //Count number of cells
    var numCells = cells.length
    if(numCells === 0 || d < 1) {
      return {
        cells:         [],
        vertexIds:     [],
        vertexWeights: []
      }
    }
  
    //Read in vertex signs
    var vertexSigns = getSigns(values, +level)
  
    //First get 1-skeleton, find all crossings
    var edges   = getEdges(cells, d)
    var weights = getCrossingWeights(edges, values, vertexSigns, +level)
  
    //Build vertex cascade to speed up binary search
    var vcascade = getCascade(edges, values.length|0)
  
    //Then construct cells
    var faces = contourAlgorithm(d)(cells, edges.data, vcascade, vertexSigns)
  
    //Unpack data into pretty format
    var uedges   = unpackEdges(edges)
    var uweights = [].slice.call(weights.data, 0, weights.shape[0])
  
    //Release data
    pool.free(vertexSigns)
    pool.free(edges.data)
    pool.free(weights.data)
    pool.free(vcascade)
    
    return {
      cells:         faces,
      vertexIds:     uedges,
      vertexWeights: uweights
    }
  }
  },{"./lib/codegen":529,"ndarray":469,"ndarray-sort":468,"typedarray-pool":567}],529:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = getPolygonizer
  
  var pool = _dereq_('typedarray-pool')
  var createMSTable = _dereq_('marching-simplex-table')
  
  var CACHE = {}
  
  function createCellPolygonizer(d) {
    var maxCellSize = 0
    var tables = new Array(d+1)
    tables[0] = [ [] ]
    for(var i=1; i<=d; ++i) {
      var tab = tables[i] = createMSTable(i)
      for(var j=0; j<tab.length; ++j) {
        maxCellSize = Math.max(maxCellSize, tab[i].length)
      }
    }
  
    var code  = [
    'function B(C,E,i,j){',
      'var a=Math.min(i,j)|0,b=Math.max(i,j)|0,l=C[2*a],h=C[2*a+1];',
      'while(l<h){',
        'var m=(l+h)>>1,v=E[2*m+1];',
        'if(v===b){return m}',
        'if(b<v){h=m}else{l=m+1}',
      '}',
      'return l;',
    '};',
    'function getContour', d, 'd(F,E,C,S){',
      'var n=F.length,R=[];',
      'for(var i=0;i<n;++i){var c=F[i],l=c.length;'
    ]
  
    function generateCase(facets) {
      if(facets.length <= 0) {
        return
      }
      code.push('R.push(')
      for(var i=0; i<facets.length; ++i) {
        var facet = facets[i]
        if(i > 0) {
          code.push(',')
        }
        code.push('[')
        for(var j=0; j<facet.length; ++j) {
          var f = facet[j]
          if(j > 0) {
            code.push(',')
          }
          code.push('B(C,E,c[', f[0], '],c[', f[1], '])')
        }
        code.push(']')
      }
      code.push(');')
    }
  
    for(var i=d+1; i>1; --i) {
      if(i < d+1) {
        code.push('else ')
      }
      code.push('if(l===', i, '){')
  
      //Generate mask
      var maskStr = []
      for(var j=0; j<i; ++j) {
        maskStr.push('(S[c['+j+']]<<'+j+')')
      }
  
      //Perform table look up
      code.push('var M=', maskStr.join('+'), 
        ';if(M===0||M===', (1<<i)-1, 
          '){continue}switch(M){')
  
      var tab = tables[i-1]
      for(var j=0; j<tab.length; ++j) {
        code.push('case ', j, ':')
        generateCase(tab[j])
        code.push('break;')
      }
      code.push('}}')
    }
    code.push('}return R;};return getContour', d, 'd')
  
    var proc = new Function('pool', code.join(''))
    return proc(pool)
  }
  
  function getPolygonizer(d) {
    var alg = CACHE[d]
    if(!alg) {
      alg = CACHE[d] = createCellPolygonizer(d) 
    }
    return alg
  }
  },{"marching-simplex-table":448,"typedarray-pool":567}],530:[function(_dereq_,module,exports){
  "use strict"; "use restrict";
  
  var bits      = _dereq_("bit-twiddle")
    , UnionFind = _dereq_("union-find")
  
  //Returns the dimension of a cell complex
  function dimension(cells) {
    var d = 0
      , max = Math.max
    for(var i=0, il=cells.length; i<il; ++i) {
      d = max(d, cells[i].length)
    }
    return d-1
  }
  exports.dimension = dimension
  
  //Counts the number of vertices in faces
  function countVertices(cells) {
    var vc = -1
      , max = Math.max
    for(var i=0, il=cells.length; i<il; ++i) {
      var c = cells[i]
      for(var j=0, jl=c.length; j<jl; ++j) {
        vc = max(vc, c[j])
      }
    }
    return vc+1
  }
  exports.countVertices = countVertices
  
  //Returns a deep copy of cells
  function cloneCells(cells) {
    var ncells = new Array(cells.length)
    for(var i=0, il=cells.length; i<il; ++i) {
      ncells[i] = cells[i].slice(0)
    }
    return ncells
  }
  exports.cloneCells = cloneCells
  
  //Ranks a pair of cells up to permutation
  function compareCells(a, b) {
    var n = a.length
      , t = a.length - b.length
      , min = Math.min
    if(t) {
      return t
    }
    switch(n) {
      case 0:
        return 0;
      case 1:
        return a[0] - b[0];
      case 2:
        var d = a[0]+a[1]-b[0]-b[1]
        if(d) {
          return d
        }
        return min(a[0],a[1]) - min(b[0],b[1])
      case 3:
        var l1 = a[0]+a[1]
          , m1 = b[0]+b[1]
        d = l1+a[2] - (m1+b[2])
        if(d) {
          return d
        }
        var l0 = min(a[0], a[1])
          , m0 = min(b[0], b[1])
          , d  = min(l0, a[2]) - min(m0, b[2])
        if(d) {
          return d
        }
        return min(l0+a[2], l1) - min(m0+b[2], m1)
      
      //TODO: Maybe optimize n=4 as well?
      
      default:
        var as = a.slice(0)
        as.sort()
        var bs = b.slice(0)
        bs.sort()
        for(var i=0; i<n; ++i) {
          t = as[i] - bs[i]
          if(t) {
            return t
          }
        }
        return 0
    }
  }
  exports.compareCells = compareCells
  
  function compareZipped(a, b) {
    return compareCells(a[0], b[0])
  }
  
  //Puts a cell complex into normal order for the purposes of findCell queries
  function normalize(cells, attr) {
    if(attr) {
      var len = cells.length
      var zipped = new Array(len)
      for(var i=0; i<len; ++i) {
        zipped[i] = [cells[i], attr[i]]
      }
      zipped.sort(compareZipped)
      for(var i=0; i<len; ++i) {
        cells[i] = zipped[i][0]
        attr[i] = zipped[i][1]
      }
      return cells
    } else {
      cells.sort(compareCells)
      return cells
    }
  }
  exports.normalize = normalize
  
  //Removes all duplicate cells in the complex
  function unique(cells) {
    if(cells.length === 0) {
      return []
    }
    var ptr = 1
      , len = cells.length
    for(var i=1; i<len; ++i) {
      var a = cells[i]
      if(compareCells(a, cells[i-1])) {
        if(i === ptr) {
          ptr++
          continue
        }
        cells[ptr++] = a
      }
    }
    cells.length = ptr
    return cells
  }
  exports.unique = unique;
  
  //Finds a cell in a normalized cell complex
  function findCell(cells, c) {
    var lo = 0
      , hi = cells.length-1
      , r  = -1
    while (lo <= hi) {
      var mid = (lo + hi) >> 1
        , s   = compareCells(cells[mid], c)
      if(s <= 0) {
        if(s === 0) {
          r = mid
        }
        lo = mid + 1
      } else if(s > 0) {
        hi = mid - 1
      }
    }
    return r
  }
  exports.findCell = findCell;
  
  //Builds an index for an n-cell.  This is more general than dual, but less efficient
  function incidence(from_cells, to_cells) {
    var index = new Array(from_cells.length)
    for(var i=0, il=index.length; i<il; ++i) {
      index[i] = []
    }
    var b = []
    for(var i=0, n=to_cells.length; i<n; ++i) {
      var c = to_cells[i]
      var cl = c.length
      for(var k=1, kn=(1<<cl); k<kn; ++k) {
        b.length = bits.popCount(k)
        var l = 0
        for(var j=0; j<cl; ++j) {
          if(k & (1<<j)) {
            b[l++] = c[j]
          }
        }
        var idx=findCell(from_cells, b)
        if(idx < 0) {
          continue
        }
        while(true) {
          index[idx++].push(i)
          if(idx >= from_cells.length || compareCells(from_cells[idx], b) !== 0) {
            break
          }
        }
      }
    }
    return index
  }
  exports.incidence = incidence
  
  //Computes the dual of the mesh.  This is basically an optimized version of buildIndex for the situation where from_cells is just the list of vertices
  function dual(cells, vertex_count) {
    if(!vertex_count) {
      return incidence(unique(skeleton(cells, 0)), cells, 0)
    }
    var res = new Array(vertex_count)
    for(var i=0; i<vertex_count; ++i) {
      res[i] = []
    }
    for(var i=0, len=cells.length; i<len; ++i) {
      var c = cells[i]
      for(var j=0, cl=c.length; j<cl; ++j) {
        res[c[j]].push(i)
      }
    }
    return res
  }
  exports.dual = dual
  
  //Enumerates all cells in the complex
  function explode(cells) {
    var result = []
    for(var i=0, il=cells.length; i<il; ++i) {
      var c = cells[i]
        , cl = c.length|0
      for(var j=1, jl=(1<<cl); j<jl; ++j) {
        var b = []
        for(var k=0; k<cl; ++k) {
          if((j >>> k) & 1) {
            b.push(c[k])
          }
        }
        result.push(b)
      }
    }
    return normalize(result)
  }
  exports.explode = explode
  
  //Enumerates all of the n-cells of a cell complex
  function skeleton(cells, n) {
    if(n < 0) {
      return []
    }
    var result = []
      , k0     = (1<<(n+1))-1
    for(var i=0; i<cells.length; ++i) {
      var c = cells[i]
      for(var k=k0; k<(1<<c.length); k=bits.nextCombination(k)) {
        var b = new Array(n+1)
          , l = 0
        for(var j=0; j<c.length; ++j) {
          if(k & (1<<j)) {
            b[l++] = c[j]
          }
        }
        result.push(b)
      }
    }
    return normalize(result)
  }
  exports.skeleton = skeleton;
  
  //Computes the boundary of all cells, does not remove duplicates
  function boundary(cells) {
    var res = []
    for(var i=0,il=cells.length; i<il; ++i) {
      var c = cells[i]
      for(var j=0,cl=c.length; j<cl; ++j) {
        var b = new Array(c.length-1)
        for(var k=0, l=0; k<cl; ++k) {
          if(k !== j) {
            b[l++] = c[k]
          }
        }
        res.push(b)
      }
    }
    return normalize(res)
  }
  exports.boundary = boundary;
  
  //Computes connected components for a dense cell complex
  function connectedComponents_dense(cells, vertex_count) {
    var labels = new UnionFind(vertex_count)
    for(var i=0; i<cells.length; ++i) {
      var c = cells[i]
      for(var j=0; j<c.length; ++j) {
        for(var k=j+1; k<c.length; ++k) {
          labels.link(c[j], c[k])
        }
      }
    }
    var components = []
      , component_labels = labels.ranks
    for(var i=0; i<component_labels.length; ++i) {
      component_labels[i] = -1
    }
    for(var i=0; i<cells.length; ++i) {
      var l = labels.find(cells[i][0])
      if(component_labels[l] < 0) {
        component_labels[l] = components.length
        components.push([cells[i].slice(0)])
      } else {
        components[component_labels[l]].push(cells[i].slice(0))
      }
    }
    return components
  }
  
  //Computes connected components for a sparse graph
  function connectedComponents_sparse(cells) {
    var vertices  = unique(normalize(skeleton(cells, 0)))
      , labels    = new UnionFind(vertices.length)
    for(var i=0; i<cells.length; ++i) {
      var c = cells[i]
      for(var j=0; j<c.length; ++j) {
        var vj = findCell(vertices, [c[j]])
        for(var k=j+1; k<c.length; ++k) {
          labels.link(vj, findCell(vertices, [c[k]]))
        }
      }
    }
    var components        = []
      , component_labels  = labels.ranks
    for(var i=0; i<component_labels.length; ++i) {
      component_labels[i] = -1
    }
    for(var i=0; i<cells.length; ++i) {
      var l = labels.find(findCell(vertices, [cells[i][0]]));
      if(component_labels[l] < 0) {
        component_labels[l] = components.length
        components.push([cells[i].slice(0)])
      } else {
        components[component_labels[l]].push(cells[i].slice(0))
      }
    }
    return components
  }
  
  //Computes connected components for a cell complex
  function connectedComponents(cells, vertex_count) {
    if(vertex_count) {
      return connectedComponents_dense(cells, vertex_count)
    }
    return connectedComponents_sparse(cells)
  }
  exports.connectedComponents = connectedComponents
  
  },{"bit-twiddle":97,"union-find":568}],531:[function(_dereq_,module,exports){
  arguments[4][97][0].apply(exports,arguments)
  },{"dup":97}],532:[function(_dereq_,module,exports){
  arguments[4][530][0].apply(exports,arguments)
  },{"bit-twiddle":531,"dup":530,"union-find":533}],533:[function(_dereq_,module,exports){
  "use strict"; "use restrict";
  
  module.exports = UnionFind;
  
  function UnionFind(count) {
    this.roots = new Array(count);
    this.ranks = new Array(count);
    
    for(var i=0; i<count; ++i) {
      this.roots[i] = i;
      this.ranks[i] = 0;
    }
  }
  
  UnionFind.prototype.length = function() {
    return this.roots.length;
  }
  
  UnionFind.prototype.makeSet = function() {
    var n = this.roots.length;
    this.roots.push(n);
    this.ranks.push(0);
    return n;
  }
  
  UnionFind.prototype.find = function(x) {
    var roots = this.roots;
    while(roots[x] !== x) {
      var y = roots[x];
      roots[x] = roots[y];
      x = y;
    }
    return x;
  }
  
  UnionFind.prototype.link = function(x, y) {
    var xr = this.find(x)
      , yr = this.find(y);
    if(xr === yr) {
      return;
    }
    var ranks = this.ranks
      , roots = this.roots
      , xd    = ranks[xr]
      , yd    = ranks[yr];
    if(xd < yd) {
      roots[xr] = yr;
    } else if(yd < xd) {
      roots[yr] = xr;
    } else {
      roots[yr] = xr;
      ++ranks[xr];
    }
  }
  
  
  },{}],534:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = simplifyPolygon
  
  var orient = _dereq_("robust-orientation")
  var sc = _dereq_("simplicial-complex")
  
  function errorWeight(base, a, b) {
    var area = Math.abs(orient(base, a, b))
    var perim = Math.sqrt(Math.pow(a[0] - b[0], 2) + Math.pow(a[1]-b[1], 2))
    return area / perim
  }
  
  function simplifyPolygon(cells, positions, minArea) {
  
    var n = positions.length
    var nc = cells.length
    var inv = new Array(n)
    var outv = new Array(n)
    var weights = new Array(n)
    var dead = new Array(n)
    
    //Initialize tables
    for(var i=0; i<n; ++i) {
      inv[i] = outv[i] = -1
      weights[i] = Infinity
      dead[i] = false
    }
  
    //Compute neighbors
    for(var i=0; i<nc; ++i) {
      var c = cells[i]
      if(c.length !== 2) {
        throw new Error("Input must be a graph")
      }
      var s = c[1]
      var t = c[0]
      if(outv[t] !== -1) {
        outv[t] = -2
      } else {
        outv[t] = s
      }
      if(inv[s] !== -1) {
        inv[s] = -2
      } else {
        inv[s] = t
      }
    }
  
    //Updates the weight for vertex i
    function computeWeight(i) {
      if(dead[i]) {
        return Infinity
      }
      //TODO: Check that the line segment doesn't cross once simplified
      var s = inv[i]
      var t = outv[i]
      if((s<0) || (t<0)) {
        return Infinity
      } else {
        return errorWeight(positions[i], positions[s], positions[t])
      }
    }
  
    //Swaps two nodes on the heap (i,j) are the index of the nodes
    function heapSwap(i,j) {
      var a = heap[i]
      var b = heap[j]
      heap[i] = b
      heap[j] = a
      index[a] = j
      index[b] = i
    }
  
    //Returns the weight of node i on the heap
    function heapWeight(i) {
      return weights[heap[i]]
    }
  
    function heapParent(i) {
      if(i & 1) {
        return (i - 1) >> 1
      }
      return (i >> 1) - 1
    }
  
    //Bubble element i down the heap
    function heapDown(i) {
      var w = heapWeight(i)
      while(true) {
        var tw = w
        var left  = 2*i + 1
        var right = 2*(i + 1)
        var next = i
        if(left < heapCount) {
          var lw = heapWeight(left)
          if(lw < tw) {
            next = left
            tw = lw
          }
        }
        if(right < heapCount) {
          var rw = heapWeight(right)
          if(rw < tw) {
            next = right
          }
        }
        if(next === i) {
          return i
        }
        heapSwap(i, next)
        i = next      
      }
    }
  
    //Bubbles element i up the heap
    function heapUp(i) {
      var w = heapWeight(i)
      while(i > 0) {
        var parent = heapParent(i)
        if(parent >= 0) {
          var pw = heapWeight(parent)
          if(w < pw) {
            heapSwap(i, parent)
            i = parent
            continue
          }
        }
        return i
      }
    }
  
    //Pop minimum element
    function heapPop() {
      if(heapCount > 0) {
        var head = heap[0]
        heapSwap(0, heapCount-1)
        heapCount -= 1
        heapDown(0)
        return head
      }
      return -1
    }
  
    //Update heap item i
    function heapUpdate(i, w) {
      var a = heap[i]
      if(weights[a] === w) {
        return i
      }
      weights[a] = -Infinity
      heapUp(i)
      heapPop()
      weights[a] = w
      heapCount += 1
      return heapUp(heapCount-1)
    }
  
    //Kills a vertex (assume vertex already removed from heap)
    function kill(i) {
      if(dead[i]) {
        return
      }
      //Kill vertex
      dead[i] = true
      //Fixup topology
      var s = inv[i]
      var t = outv[i]
      if(inv[t] >= 0) {
        inv[t] = s
      }
      if(outv[s] >= 0) {
        outv[s] = t
      }
  
      //Update weights on s and t
      if(index[s] >= 0) {
        heapUpdate(index[s], computeWeight(s))
      }
      if(index[t] >= 0) {
        heapUpdate(index[t], computeWeight(t))
      }
    }
  
    //Initialize weights and heap
    var heap = []
    var index = new Array(n)
    for(var i=0; i<n; ++i) {
      var w = weights[i] = computeWeight(i)
      if(w < Infinity) {
        index[i] = heap.length
        heap.push(i)
      } else {
        index[i] = -1
      }
    }
    var heapCount = heap.length
    for(var i=heapCount>>1; i>=0; --i) {
      heapDown(i)
    }
    
    //Kill vertices
    while(true) {
      var hmin = heapPop()
      if((hmin < 0) || (weights[hmin] > minArea)) {
        break
      }
      kill(hmin)
    }
  
    //Build collapsed vertex table
    var npositions = []
    for(var i=0; i<n; ++i) {
      if(!dead[i]) {
        index[i] = npositions.length
        npositions.push(positions[i].slice())
      }
    }
    var nv = npositions.length
  
    function tortoiseHare(seq, start) {
      if(seq[start] < 0) {
        return start
      }
      var t = start
      var h = start
      do {
        //Walk two steps with h
        var nh = seq[h]
        if(!dead[h] || nh < 0 || nh === h) {
          break
        }
        h = nh
        nh = seq[h]
        if(!dead[h] || nh < 0 || nh === h) {
          break
        }
        h = nh
  
        //Walk one step with t
        t = seq[t]
      } while(t !== h)
      //Compress cycles
      for(var v=start; v!==h; v = seq[v]) {
        seq[v] = h
      }
      return h
    }
  
    var ncells = []
    cells.forEach(function(c) {
      var tin = tortoiseHare(inv, c[0])
      var tout = tortoiseHare(outv, c[1])
      if(tin >= 0 && tout >= 0 && tin !== tout) {
        var cin = index[tin]
        var cout = index[tout]
        if(cin !== cout) {
          ncells.push([ cin, cout ])
        }
      }
    })
  
    //Normalize result
    sc.unique(sc.normalize(ncells))
  
    //Return final list of cells
    return {
      positions: npositions,
      edges: ncells
    }
  }
  },{"robust-orientation":520,"simplicial-complex":532}],535:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = orderSegments
  
  var orient = _dereq_("robust-orientation")
  
  function horizontalOrder(a, b) {
    var bl, br
    if(b[0][0] < b[1][0]) {
      bl = b[0]
      br = b[1]
    } else if(b[0][0] > b[1][0]) {
      bl = b[1]
      br = b[0]
    } else {
      var alo = Math.min(a[0][1], a[1][1])
      var ahi = Math.max(a[0][1], a[1][1])
      var blo = Math.min(b[0][1], b[1][1])
      var bhi = Math.max(b[0][1], b[1][1])
      if(ahi < blo) {
        return ahi - blo
      }
      if(alo > bhi) {
        return alo - bhi
      }
      return ahi - bhi
    }
    var al, ar
    if(a[0][1] < a[1][1]) {
      al = a[0]
      ar = a[1]
    } else {
      al = a[1]
      ar = a[0]
    }
    var d = orient(br, bl, al)
    if(d) {
      return d
    }
    d = orient(br, bl, ar)
    if(d) {
      return d
    }
    return ar - br
  }
  
  function orderSegments(b, a) {
    var al, ar
    if(a[0][0] < a[1][0]) {
      al = a[0]
      ar = a[1]
    } else if(a[0][0] > a[1][0]) {
      al = a[1]
      ar = a[0]
    } else {
      return horizontalOrder(a, b)
    }
    var bl, br
    if(b[0][0] < b[1][0]) {
      bl = b[0]
      br = b[1]
    } else if(b[0][0] > b[1][0]) {
      bl = b[1]
      br = b[0]
    } else {
      return -horizontalOrder(b, a)
    }
    var d1 = orient(al, ar, br)
    var d2 = orient(al, ar, bl)
    if(d1 < 0) {
      if(d2 <= 0) {
        return d1
      }
    } else if(d1 > 0) {
      if(d2 >= 0) {
        return d1
      }
    } else if(d2) {
      return d2
    }
    d1 = orient(br, bl, ar)
    d2 = orient(br, bl, al)
    if(d1 < 0) {
      if(d2 <= 0) {
        return d1
      }
    } else if(d1 > 0) {
      if(d2 >= 0) {
        return d1
      }
    } else if(d2) {
      return d2
    }
    return ar[0] - br[0]
  }
  },{"robust-orientation":520}],536:[function(_dereq_,module,exports){
  arguments[4][243][0].apply(exports,arguments)
  },{"dup":243}],537:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = createSlabDecomposition
  
  var bounds = _dereq_("binary-search-bounds")
  var createRBTree = _dereq_("functional-red-black-tree")
  var orient = _dereq_("robust-orientation")
  var orderSegments = _dereq_("./lib/order-segments")
  
  function SlabDecomposition(slabs, coordinates, horizontal) {
    this.slabs = slabs
    this.coordinates = coordinates
    this.horizontal = horizontal
  }
  
  var proto = SlabDecomposition.prototype
  
  function compareHorizontal(e, y) {
    return e.y - y
  }
  
  function searchBucket(root, p) {
    var lastNode = null
    while(root) {
      var seg = root.key
      var l, r
      if(seg[0][0] < seg[1][0]) {
        l = seg[0]
        r = seg[1]
      } else {
        l = seg[1]
        r = seg[0]
      }
      var o = orient(l, r, p)
      if(o < 0) {
        root = root.left
      } else if(o > 0) {
        if(p[0] !== seg[1][0]) {
          lastNode = root
          root = root.right
        } else {
          var val = searchBucket(root.right, p)
          if(val) {
            return val
          }
          root = root.left
        }
      } else {
        if(p[0] !== seg[1][0]) {
          return root
        } else {
          var val = searchBucket(root.right, p)
          if(val) {
            return val
          }
          root = root.left
        }
      }
    }
    return lastNode
  }
  
  proto.castUp = function(p) {
    var bucket = bounds.le(this.coordinates, p[0])
    if(bucket < 0) {
      return -1
    }
    var root = this.slabs[bucket]
    var hitNode = searchBucket(this.slabs[bucket], p)
    var lastHit = -1
    if(hitNode) {
      lastHit = hitNode.value
    }
    //Edge case: need to handle horizontal segments (sucks)
    if(this.coordinates[bucket] === p[0]) {
      var lastSegment = null
      if(hitNode) {
        lastSegment = hitNode.key
      }
      if(bucket > 0) {
        var otherHitNode = searchBucket(this.slabs[bucket-1], p)
        if(otherHitNode) {
          if(lastSegment) {
            if(orderSegments(otherHitNode.key, lastSegment) > 0) {
              lastSegment = otherHitNode.key
              lastHit = otherHitNode.value
            }
          } else {
            lastHit = otherHitNode.value
            lastSegment = otherHitNode.key
          }
        }
      }
      var horiz = this.horizontal[bucket]
      if(horiz.length > 0) {
        var hbucket = bounds.ge(horiz, p[1], compareHorizontal)
        if(hbucket < horiz.length) {
          var e = horiz[hbucket]
          if(p[1] === e.y) {
            if(e.closed) {
              return e.index
            } else {
              while(hbucket < horiz.length-1 && horiz[hbucket+1].y === p[1]) {
                hbucket = hbucket+1
                e = horiz[hbucket]
                if(e.closed) {
                  return e.index
                }
              }
              if(e.y === p[1] && !e.start) {
                hbucket = hbucket+1
                if(hbucket >= horiz.length) {
                  return lastHit
                }
                e = horiz[hbucket]
              }
            }
          }
          //Check if e is above/below last segment
          if(e.start) {
            if(lastSegment) {
              var o = orient(lastSegment[0], lastSegment[1], [p[0], e.y])
              if(lastSegment[0][0] > lastSegment[1][0]) {
                o = -o
              }
              if(o > 0) {
                lastHit = e.index
              }
            } else {
              lastHit = e.index
            }
          } else if(e.y !== p[1]) {
            lastHit = e.index
          }
        }
      }
    }
    return lastHit
  }
  
  function IntervalSegment(y, index, start, closed) {
    this.y = y
    this.index = index
    this.start = start
    this.closed = closed
  }
  
  function Event(x, segment, create, index) {
    this.x = x
    this.segment = segment
    this.create = create
    this.index = index
  }
  
  
  function createSlabDecomposition(segments) {
    var numSegments = segments.length
    var numEvents = 2 * numSegments
    var events = new Array(numEvents)
    for(var i=0; i<numSegments; ++i) {
      var s = segments[i]
      var f = s[0][0] < s[1][0]
      events[2*i] = new Event(s[0][0], s, f, i)
      events[2*i+1] = new Event(s[1][0], s, !f, i)
    }
    events.sort(function(a,b) {
      var d = a.x - b.x
      if(d) {
        return d
      }
      d = a.create - b.create
      if(d) {
        return d
      }
      return Math.min(a.segment[0][1], a.segment[1][1]) - Math.min(b.segment[0][1], b.segment[1][1])
    })
    var tree = createRBTree(orderSegments)
    var slabs = []
    var lines = []
    var horizontal = []
    var lastX = -Infinity
    for(var i=0; i<numEvents; ) {
      var x = events[i].x
      var horiz = []
      while(i < numEvents) {
        var e = events[i]
        if(e.x !== x) {
          break
        }
        i += 1
        if(e.segment[0][0] === e.x && e.segment[1][0] === e.x) {
          if(e.create) {
            if(e.segment[0][1] < e.segment[1][1]) {
              horiz.push(new IntervalSegment(
                  e.segment[0][1],
                  e.index,
                  true,
                  true))
              horiz.push(new IntervalSegment(
                  e.segment[1][1],
                  e.index,
                  false,
                  false))
            } else {
              horiz.push(new IntervalSegment(
                  e.segment[1][1],
                  e.index,
                  true,
                  false))
              horiz.push(new IntervalSegment(
                  e.segment[0][1],
                  e.index,
                  false,
                  true))
            }
          }
        } else {
          if(e.create) {
            tree = tree.insert(e.segment, e.index)
          } else {
            tree = tree.remove(e.segment)
          }
        }
      }
      slabs.push(tree.root)
      lines.push(x)
      horizontal.push(horiz)
    }
    return new SlabDecomposition(slabs, lines, horizontal)
  }
  },{"./lib/order-segments":535,"binary-search-bounds":536,"functional-red-black-tree":247,"robust-orientation":520}],538:[function(_dereq_,module,exports){
  "use strict"
  
  var robustDot = _dereq_("robust-dot-product")
  var robustSum = _dereq_("robust-sum")
  
  module.exports = splitPolygon
  module.exports.positive = positive
  module.exports.negative = negative
  
  function planeT(p, plane) {
    var r = robustSum(robustDot(p, plane), [plane[plane.length-1]])
    return r[r.length-1]
  }
  
  
  //Can't do this exactly and emit a floating point result
  function lerpW(a, wa, b, wb) {
    var d = wb - wa
    var t = -wa / d
    if(t < 0.0) {
      t = 0.0
    } else if(t > 1.0) {
      t = 1.0
    }
    var ti = 1.0 - t
    var n = a.length
    var r = new Array(n)
    for(var i=0; i<n; ++i) {
      r[i] = t * a[i] + ti * b[i]
    }
    return r
  }
  
  function splitPolygon(points, plane) {
    var pos = []
    var neg = []
    var a = planeT(points[points.length-1], plane)
    for(var s=points[points.length-1], t=points[0], i=0; i<points.length; ++i, s=t) {
      t = points[i]
      var b = planeT(t, plane)
      if((a < 0 && b > 0) || (a > 0 && b < 0)) {
        var p = lerpW(s, b, t, a)
        pos.push(p)
        neg.push(p.slice())
      }
      if(b < 0) {
        neg.push(t.slice())
      } else if(b > 0) {
        pos.push(t.slice())
      } else {
        pos.push(t.slice())
        neg.push(t.slice())
      }
      a = b
    }
    return { positive: pos, negative: neg }
  }
  
  function positive(points, plane) {
    var pos = []
    var a = planeT(points[points.length-1], plane)
    for(var s=points[points.length-1], t=points[0], i=0; i<points.length; ++i, s=t) {
      t = points[i]
      var b = planeT(t, plane)
      if((a < 0 && b > 0) || (a > 0 && b < 0)) {
        pos.push(lerpW(s, b, t, a))
      }
      if(b >= 0) {
        pos.push(t.slice())
      }
      a = b
    }
    return pos
  }
  
  function negative(points, plane) {
    var neg = []
    var a = planeT(points[points.length-1], plane)
    for(var s=points[points.length-1], t=points[0], i=0; i<points.length; ++i, s=t) {
      t = points[i]
      var b = planeT(t, plane)
      if((a < 0 && b > 0) || (a > 0 && b < 0)) {
        neg.push(lerpW(s, b, t, a))
      }
      if(b <= 0) {
        neg.push(t.slice())
      }
      a = b
    }
    return neg
  }
  },{"robust-dot-product":517,"robust-sum":525}],539:[function(_dereq_,module,exports){
  /* global window, exports, define */
  
  !function() {
      'use strict'
  
      var re = {
          not_string: /[^s]/,
          not_bool: /[^t]/,
          not_type: /[^T]/,
          not_primitive: /[^v]/,
          number: /[diefg]/,
          numeric_arg: /[bcdiefguxX]/,
          json: /[j]/,
          not_json: /[^j]/,
          text: /^[^\x25]+/,
          modulo: /^\x25{2}/,
          placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
          key: /^([a-z_][a-z_\d]*)/i,
          key_access: /^\.([a-z_][a-z_\d]*)/i,
          index_access: /^\[(\d+)\]/,
          sign: /^[+-]/
      }
  
      function sprintf(key) {
          // `arguments` is not an array, but should be fine for this call
          return sprintf_format(sprintf_parse(key), arguments)
      }
  
      function vsprintf(fmt, argv) {
          return sprintf.apply(null, [fmt].concat(argv || []))
      }
  
      function sprintf_format(parse_tree, argv) {
          var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
          for (i = 0; i < tree_length; i++) {
              if (typeof parse_tree[i] === 'string') {
                  output += parse_tree[i]
              }
              else if (typeof parse_tree[i] === 'object') {
                  ph = parse_tree[i] // convenience purposes only
                  if (ph.keys) { // keyword argument
                      arg = argv[cursor]
                      for (k = 0; k < ph.keys.length; k++) {
                          if (arg == undefined) {
                              throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                          }
                          arg = arg[ph.keys[k]]
                      }
                  }
                  else if (ph.param_no) { // positional argument (explicit)
                      arg = argv[ph.param_no]
                  }
                  else { // positional argument (implicit)
                      arg = argv[cursor++]
                  }
  
                  if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                      arg = arg()
                  }
  
                  if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                      throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                  }
  
                  if (re.number.test(ph.type)) {
                      is_positive = arg >= 0
                  }
  
                  switch (ph.type) {
                      case 'b':
                          arg = parseInt(arg, 10).toString(2)
                          break
                      case 'c':
                          arg = String.fromCharCode(parseInt(arg, 10))
                          break
                      case 'd':
                      case 'i':
                          arg = parseInt(arg, 10)
                          break
                      case 'j':
                          arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                          break
                      case 'e':
                          arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                          break
                      case 'f':
                          arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                          break
                      case 'g':
                          arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                          break
                      case 'o':
                          arg = (parseInt(arg, 10) >>> 0).toString(8)
                          break
                      case 's':
                          arg = String(arg)
                          arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                          break
                      case 't':
                          arg = String(!!arg)
                          arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                          break
                      case 'T':
                          arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                          arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                          break
                      case 'u':
                          arg = parseInt(arg, 10) >>> 0
                          break
                      case 'v':
                          arg = arg.valueOf()
                          arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                          break
                      case 'x':
                          arg = (parseInt(arg, 10) >>> 0).toString(16)
                          break
                      case 'X':
                          arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                          break
                  }
                  if (re.json.test(ph.type)) {
                      output += arg
                  }
                  else {
                      if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                          sign = is_positive ? '+' : '-'
                          arg = arg.toString().replace(re.sign, '')
                      }
                      else {
                          sign = ''
                      }
                      pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                      pad_length = ph.width - (sign + arg).length
                      pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                      output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                  }
              }
          }
          return output
      }
  
      var sprintf_cache = Object.create(null)
  
      function sprintf_parse(fmt) {
          if (sprintf_cache[fmt]) {
              return sprintf_cache[fmt]
          }
  
          var _fmt = fmt, match, parse_tree = [], arg_names = 0
          while (_fmt) {
              if ((match = re.text.exec(_fmt)) !== null) {
                  parse_tree.push(match[0])
              }
              else if ((match = re.modulo.exec(_fmt)) !== null) {
                  parse_tree.push('%')
              }
              else if ((match = re.placeholder.exec(_fmt)) !== null) {
                  if (match[2]) {
                      arg_names |= 1
                      var field_list = [], replacement_field = match[2], field_match = []
                      if ((field_match = re.key.exec(replacement_field)) !== null) {
                          field_list.push(field_match[1])
                          while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                              if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                  field_list.push(field_match[1])
                              }
                              else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                  field_list.push(field_match[1])
                              }
                              else {
                                  throw new SyntaxError('[sprintf] failed to parse named argument key')
                              }
                          }
                      }
                      else {
                          throw new SyntaxError('[sprintf] failed to parse named argument key')
                      }
                      match[2] = field_list
                  }
                  else {
                      arg_names |= 2
                  }
                  if (arg_names === 3) {
                      throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                  }
  
                  parse_tree.push(
                      {
                          placeholder: match[0],
                          param_no:    match[1],
                          keys:        match[2],
                          sign:        match[3],
                          pad_char:    match[4],
                          align:       match[5],
                          width:       match[6],
                          precision:   match[7],
                          type:        match[8]
                      }
                  )
              }
              else {
                  throw new SyntaxError('[sprintf] unexpected placeholder')
              }
              _fmt = _fmt.substring(match[0].length)
          }
          return sprintf_cache[fmt] = parse_tree
      }
  
      /**
       * export to either browser or node.js
       */
      /* eslint-disable quote-props */
      if (typeof exports !== 'undefined') {
          exports['sprintf'] = sprintf
          exports['vsprintf'] = vsprintf
      }
      if (typeof window !== 'undefined') {
          window['sprintf'] = sprintf
          window['vsprintf'] = vsprintf
  
          if (typeof define === 'function' && define['amd']) {
              define(function() {
                  return {
                      'sprintf': sprintf,
                      'vsprintf': vsprintf
                  }
              })
          }
      }
      /* eslint-enable quote-props */
  }(); // eslint-disable-line
  
  },{}],540:[function(_dereq_,module,exports){
  'use strict'
  
  var paren = _dereq_('parenthesis')
  
  module.exports = function splitBy (string, separator, o) {
    if (string == null) throw Error('First argument should be a string')
    if (separator == null) throw Error('Separator should be a string or a RegExp')
  
    if (!o) o = {}
    else if (typeof o === 'string' || Array.isArray(o)) {
      o = {ignore: o}
    }
  
    if (o.escape == null) o.escape = true
    if (o.ignore == null) o.ignore = ['[]', '()', '{}', '<>', '""', "''", '``', '“”', '«»']
    else {
      if (typeof o.ignore === 'string') {o.ignore = [o.ignore]}
  
      o.ignore = o.ignore.map(function (pair) {
        // '"' → '""'
        if (pair.length === 1) pair = pair + pair
        return pair
      })
    }
  
    var tokens = paren.parse(string, {flat: true, brackets: o.ignore})
    var str = tokens[0]
  
    var parts = str.split(separator)
  
    // join parts separated by escape
    if (o.escape) {
      var cleanParts = []
      for (var i = 0; i < parts.length; i++) {
        var prev = parts[i]
        var part = parts[i + 1]
  
        if (prev[prev.length - 1] === '\\' && prev[prev.length - 2] !== '\\') {
          cleanParts.push(prev + separator + part)
          i++
        }
        else {
          cleanParts.push(prev)
        }
      }
      parts = cleanParts
    }
  
    // open parens pack & apply unquotes, if any
    for (var i = 0; i < parts.length; i++) {
      tokens[0] = parts[i]
      parts[i] = paren.stringify(tokens, {flat: true})
    }
  
    return parts
  }
  
  },{"parenthesis":477}],541:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = stronglyConnectedComponents
  
  function stronglyConnectedComponents(adjList) {
    var numVertices = adjList.length;
    var index = new Array(numVertices)
    var lowValue = new Array(numVertices)
    var active = new Array(numVertices)
    var child = new Array(numVertices)
    var scc = new Array(numVertices)
    var sccLinks = new Array(numVertices)
    
    //Initialize tables
    for(var i=0; i<numVertices; ++i) {
      index[i] = -1
      lowValue[i] = 0
      active[i] = false
      child[i] = 0
      scc[i] = -1
      sccLinks[i] = []
    }
  
    // The strongConnect function
    var count = 0
    var components = []
    var sccAdjList = []
  
    function strongConnect(v) {
      // To avoid running out of stack space, this emulates the recursive behaviour of the normal algorithm, effectively using T as the call stack.
      var S = [v], T = [v]
      index[v] = lowValue[v] = count
      active[v] = true
      count += 1
      while(T.length > 0) {
        v = T[T.length-1]
        var e = adjList[v]
        if (child[v] < e.length) { // If we're not done iterating over the children, first try finishing that.
          for(var i=child[v]; i<e.length; ++i) { // Start where we left off.
            var u = e[i]
            if(index[u] < 0) {
              index[u] = lowValue[u] = count
              active[u] = true
              count += 1
              S.push(u)
              T.push(u)
              break // First recurse, then continue here (with the same child!).
              // There is a slight change to Tarjan's algorithm here.
              // Normally, after having recursed, we set lowValue like we do for an active child (although some variants of the algorithm do it slightly differently).
              // Here, we only do so if the child we recursed on is still active.
              // The reasoning is that if it is no longer active, it must have had a lowValue equal to its own index, which means that it is necessarily higher than our lowValue.
            } else if (active[u]) {
              lowValue[v] = Math.min(lowValue[v], lowValue[u])|0
            }
            if (scc[u] >= 0) {
              // Node v is not yet assigned an scc, but once it is that scc can apparently reach scc[u].
              sccLinks[v].push(scc[u])
            }
          }
          child[v] = i // Remember where we left off.
        } else { // If we're done iterating over the children, check whether we have an scc.
          if(lowValue[v] === index[v]) { // TODO: It /might/ be true that T is always a prefix of S (at this point!!!), and if so, this could be used here.
            var component = []
            var links = [], linkCount = 0
            for(var i=S.length-1; i>=0; --i) {
              var w = S[i]
              active[w] = false
              component.push(w)
              links.push(sccLinks[w])
              linkCount += sccLinks[w].length
              scc[w] = components.length
              if(w === v) {
                S.length = i
                break
              }
            }
            components.push(component)
            var allLinks = new Array(linkCount)
            for(var i=0; i<links.length; i++) {
              for(var j=0; j<links[i].length; j++) {
                allLinks[--linkCount] = links[i][j]
              }
            }
            sccAdjList.push(allLinks)
          }
          T.pop() // Now we're finished exploring this particular node (normally corresponds to the return statement)
        }
      }
    }
  
    //Run strong connect starting from each vertex
    for(var i=0; i<numVertices; ++i) {
      if(index[i] < 0) {
        strongConnect(i)
      }
    }
    
    // Compact sccAdjList
    var newE
    for(var i=0; i<sccAdjList.length; i++) {
      var e = sccAdjList[i]
      if (e.length === 0) continue
      e.sort(function (a,b) { return a-b; })
      newE = [e[0]]
      for(var j=1; j<e.length; j++) {
        if (e[j] !== e[j-1]) {
          newE.push(e[j])
        }
      }
      sccAdjList[i] = newE
    }  
  
    return {components: components, adjacencyList: sccAdjList}
  }
  
  },{}],542:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = surfaceNets
  
  var generateContourExtractor = _dereq_("ndarray-extract-contour")
  var triangulateCube = _dereq_("triangulate-hypercube")
  var zeroCrossings = _dereq_("zero-crossings")
  
  function buildSurfaceNets(order, dtype) {
    var dimension = order.length
    var code = ["'use strict';"]
    var funcName = "surfaceNets" + order.join("_") + "d" + dtype
  
    //Contour extraction function
    code.push(
      "var contour=genContour({",
        "order:[", order.join(), "],",
        "scalarArguments: 3,",
        "phase:function phaseFunc(p,a,b,c) { return (p > c)|0 },")
    if(dtype === "generic") {
      code.push("getters:[0],")
    }
  
    //Generate vertex function
    var cubeArgs = []
    var extraArgs = []
    for(var i=0; i<dimension; ++i) {
      cubeArgs.push("d" + i)
      extraArgs.push("d" + i)
    }
    for(var i=0; i<(1<<dimension); ++i) {
      cubeArgs.push("v" + i)
      extraArgs.push("v" + i)
    }
    for(var i=0; i<(1<<dimension); ++i) {
      cubeArgs.push("p" + i)
      extraArgs.push("p" + i)
    }
    cubeArgs.push("a", "b", "c")
    extraArgs.push("a", "c")
    code.push("vertex:function vertexFunc(", cubeArgs.join(), "){")
    //Mask args together
    var maskStr = []
    for(var i=0; i<(1<<dimension); ++i) {
      maskStr.push("(p" + i + "<<" + i + ")")
    }
    //Generate variables and giganto switch statement
    code.push("var m=(", maskStr.join("+"), ")|0;if(m===0||m===", (1<<(1<<dimension))-1, "){return}")
    var extraFuncs = []
    var currentFunc = []
    if(1<<(1<<dimension) <= 128) {
      code.push("switch(m){")
      currentFunc = code
    } else {
      code.push("switch(m>>>7){")
    }
    for(var i=0; i<1<<(1<<dimension); ++i) {
      if(1<<(1<<dimension) > 128) {
        if((i%128)===0) {
          if(extraFuncs.length > 0) {
            currentFunc.push("}}")
          }
          var efName = "vExtra" + extraFuncs.length
          code.push("case ", (i>>>7), ":", efName, "(m&0x7f,", extraArgs.join(), ");break;")
          currentFunc = [
            "function ", efName, "(m,", extraArgs.join(), "){switch(m){"
          ]
          extraFuncs.push(currentFunc)
        }  
      }
      currentFunc.push("case ", (i&0x7f), ":")
      var crossings = new Array(dimension)
      var denoms = new Array(dimension)
      var crossingCount = new Array(dimension)
      var bias = new Array(dimension)
      var totalCrossings = 0
      for(var j=0; j<dimension; ++j) {
        crossings[j] = []
        denoms[j] = []
        crossingCount[j] = 0
        bias[j] = 0
      }
      for(var j=0; j<(1<<dimension); ++j) {
        for(var k=0; k<dimension; ++k) {
          var u = j ^ (1<<k)
          if(u > j) {
            continue
          }
          if(!(i&(1<<u)) !== !(i&(1<<j))) {
            var sign = 1
            if(i&(1<<u)) {
              denoms[k].push("v" + u + "-v" + j)
            } else {
              denoms[k].push("v" + j + "-v" + u)
              sign = -sign
            }
            if(sign < 0) {
              crossings[k].push("-v" + j + "-v" + u)
              crossingCount[k] += 2
            } else {
              crossings[k].push("v" + j + "+v" + u)
              crossingCount[k] -= 2            
            }
            totalCrossings += 1
            for(var l=0; l<dimension; ++l) {
              if(l === k) {
                continue
              }
              if(u&(1<<l)) {
                bias[l] += 1
              } else {
                bias[l] -= 1
              }
            }
          }
        }
      }
      var vertexStr = []
      for(var k=0; k<dimension; ++k) {
        if(crossings[k].length === 0) {
          vertexStr.push("d" + k + "-0.5")
        } else {
          var cStr = ""
          if(crossingCount[k] < 0) {
            cStr = crossingCount[k] + "*c"
          } else if(crossingCount[k] > 0) {
            cStr = "+" + crossingCount[k] + "*c"
          }
          var weight = 0.5 * (crossings[k].length / totalCrossings)
          var shift = 0.5 + 0.5 * (bias[k] / totalCrossings)
          vertexStr.push("d" + k + "-" + shift + "-" + weight + "*(" + crossings[k].join("+") + cStr + ")/(" + denoms[k].join("+") + ")")
          
        }
      }
      currentFunc.push("a.push([", vertexStr.join(), "]);",
        "break;")
    }
    code.push("}},")
    if(extraFuncs.length > 0) {
      currentFunc.push("}}")
    }
  
    //Create face function
    var faceArgs = []
    for(var i=0; i<(1<<(dimension-1)); ++i) {
      faceArgs.push("v" + i)
    }
    faceArgs.push("c0", "c1", "p0", "p1", "a", "b", "c")
    code.push("cell:function cellFunc(", faceArgs.join(), "){")
  
    var facets = triangulateCube(dimension-1)
    code.push("if(p0){b.push(",
      facets.map(function(f) {
        return "[" + f.map(function(v) {
          return "v" + v
        }) + "]"
      }).join(), ")}else{b.push(",
      facets.map(function(f) {
        var e = f.slice()
        e.reverse()
        return "[" + e.map(function(v) {
          return "v" + v
        }) + "]"
      }).join(),
      ")}}});function ", funcName, "(array,level){var verts=[],cells=[];contour(array,verts,cells,level);return {positions:verts,cells:cells};} return ", funcName, ";")
  
    for(var i=0; i<extraFuncs.length; ++i) {
      code.push(extraFuncs[i].join(""))
    }
  
    //Compile and link
    var proc = new Function("genContour", code.join(""))
    return proc(generateContourExtractor)
  }
  
  //1D case: Need to handle specially
  function mesh1D(array, level) {
    var zc = zeroCrossings(array, level)
    var n = zc.length
    var npos = new Array(n)
    var ncel = new Array(n)
    for(var i=0; i<n; ++i) {
      npos[i] = [ zc[i] ]
      ncel[i] = [ i ]
    }
    return {
      positions: npos,
      cells: ncel
    }
  }
  
  var CACHE = {}
  
  function surfaceNets(array,level) {
    if(array.dimension <= 0) {
      return { positions: [], cells: [] }
    } else if(array.dimension === 1) {
      return mesh1D(array, level)
    }
    var typesig = array.order.join() + "-" + array.dtype
    var proc = CACHE[typesig]
    var level = (+level) || 0.0
    if(!proc) {
      proc = CACHE[typesig] = buildSurfaceNets(array.order, array.dtype)
    }
    return proc(array,level)
  }
  },{"ndarray-extract-contour":461,"triangulate-hypercube":552,"zero-crossings":596}],543:[function(_dereq_,module,exports){
  "use strict";
  
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  
  var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
  
  var TAU = Math.PI * 2;
  
  var mapToEllipse = function mapToEllipse(_ref, rx, ry, cosphi, sinphi, centerx, centery) {
    var x = _ref.x,
        y = _ref.y;
  
    x *= rx;
    y *= ry;
  
    var xp = cosphi * x - sinphi * y;
    var yp = sinphi * x + cosphi * y;
  
    return {
      x: xp + centerx,
      y: yp + centery
    };
  };
  
  var approxUnitArc = function approxUnitArc(ang1, ang2) {
    // If 90 degree circular arc, use a constant
    // as derived from http://spencermortensen.com/articles/bezier-circle
    var a = ang2 === 1.5707963267948966 ? 0.551915024494 : ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
  
    var x1 = Math.cos(ang1);
    var y1 = Math.sin(ang1);
    var x2 = Math.cos(ang1 + ang2);
    var y2 = Math.sin(ang1 + ang2);
  
    return [{
      x: x1 - y1 * a,
      y: y1 + x1 * a
    }, {
      x: x2 + y2 * a,
      y: y2 - x2 * a
    }, {
      x: x2,
      y: y2
    }];
  };
  
  var vectorAngle = function vectorAngle(ux, uy, vx, vy) {
    var sign = ux * vy - uy * vx < 0 ? -1 : 1;
  
    var dot = ux * vx + uy * vy;
  
    if (dot > 1) {
      dot = 1;
    }
  
    if (dot < -1) {
      dot = -1;
    }
  
    return sign * Math.acos(dot);
  };
  
  var getArcCenter = function getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp) {
    var rxsq = Math.pow(rx, 2);
    var rysq = Math.pow(ry, 2);
    var pxpsq = Math.pow(pxp, 2);
    var pypsq = Math.pow(pyp, 2);
  
    var radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;
  
    if (radicant < 0) {
      radicant = 0;
    }
  
    radicant /= rxsq * pypsq + rysq * pxpsq;
    radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
  
    var centerxp = radicant * rx / ry * pyp;
    var centeryp = radicant * -ry / rx * pxp;
  
    var centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
    var centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;
  
    var vx1 = (pxp - centerxp) / rx;
    var vy1 = (pyp - centeryp) / ry;
    var vx2 = (-pxp - centerxp) / rx;
    var vy2 = (-pyp - centeryp) / ry;
  
    var ang1 = vectorAngle(1, 0, vx1, vy1);
    var ang2 = vectorAngle(vx1, vy1, vx2, vy2);
  
    if (sweepFlag === 0 && ang2 > 0) {
      ang2 -= TAU;
    }
  
    if (sweepFlag === 1 && ang2 < 0) {
      ang2 += TAU;
    }
  
    return [centerx, centery, ang1, ang2];
  };
  
  var arcToBezier = function arcToBezier(_ref2) {
    var px = _ref2.px,
        py = _ref2.py,
        cx = _ref2.cx,
        cy = _ref2.cy,
        rx = _ref2.rx,
        ry = _ref2.ry,
        _ref2$xAxisRotation = _ref2.xAxisRotation,
        xAxisRotation = _ref2$xAxisRotation === undefined ? 0 : _ref2$xAxisRotation,
        _ref2$largeArcFlag = _ref2.largeArcFlag,
        largeArcFlag = _ref2$largeArcFlag === undefined ? 0 : _ref2$largeArcFlag,
        _ref2$sweepFlag = _ref2.sweepFlag,
        sweepFlag = _ref2$sweepFlag === undefined ? 0 : _ref2$sweepFlag;
  
    var curves = [];
  
    if (rx === 0 || ry === 0) {
      return [];
    }
  
    var sinphi = Math.sin(xAxisRotation * TAU / 360);
    var cosphi = Math.cos(xAxisRotation * TAU / 360);
  
    var pxp = cosphi * (px - cx) / 2 + sinphi * (py - cy) / 2;
    var pyp = -sinphi * (px - cx) / 2 + cosphi * (py - cy) / 2;
  
    if (pxp === 0 && pyp === 0) {
      return [];
    }
  
    rx = Math.abs(rx);
    ry = Math.abs(ry);
  
    var lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
  
    if (lambda > 1) {
      rx *= Math.sqrt(lambda);
      ry *= Math.sqrt(lambda);
    }
  
    var _getArcCenter = getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp),
        _getArcCenter2 = _slicedToArray(_getArcCenter, 4),
        centerx = _getArcCenter2[0],
        centery = _getArcCenter2[1],
        ang1 = _getArcCenter2[2],
        ang2 = _getArcCenter2[3];
  
    // If 'ang2' == 90.0000000001, then `ratio` will evaluate to
    // 1.0000000001. This causes `segments` to be greater than one, which is an
    // unecessary split, and adds extra points to the bezier curve. To alleviate
    // this issue, we round to 1.0 when the ratio is close to 1.0.
  
  
    var ratio = Math.abs(ang2) / (TAU / 4);
    if (Math.abs(1.0 - ratio) < 0.0000001) {
      ratio = 1.0;
    }
  
    var segments = Math.max(Math.ceil(ratio), 1);
  
    ang2 /= segments;
  
    for (var i = 0; i < segments; i++) {
      curves.push(approxUnitArc(ang1, ang2));
      ang1 += ang2;
    }
  
    return curves.map(function (curve) {
      var _mapToEllipse = mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery),
          x1 = _mapToEllipse.x,
          y1 = _mapToEllipse.y;
  
      var _mapToEllipse2 = mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery),
          x2 = _mapToEllipse2.x,
          y2 = _mapToEllipse2.y;
  
      var _mapToEllipse3 = mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery),
          x = _mapToEllipse3.x,
          y = _mapToEllipse3.y;
  
      return { x1: x1, y1: y1, x2: x2, y2: y2, x: x, y: y };
    });
  };
  
  exports.default = arcToBezier;
  module.exports = exports.default;
  },{}],544:[function(_dereq_,module,exports){
  'use strict'
  
  var parse = _dereq_('parse-svg-path')
  var abs = _dereq_('abs-svg-path')
  var normalize = _dereq_('normalize-svg-path')
  var isSvgPath = _dereq_('is-svg-path')
  var assert = _dereq_('assert')
  
  module.exports = pathBounds
  
  
  function pathBounds(path) {
    // ES6 string tpl call
    if (Array.isArray(path) && path.length === 1 && typeof path[0] === 'string') path = path[0]
  
    // svg path string
    if (typeof path === 'string') {
      assert(isSvgPath(path), 'String is not an SVG path.')
      path = parse(path)
    }
  
    assert(Array.isArray(path), 'Argument should be a string or an array of path segments.')
  
    path = abs(path)
    path = normalize(path)
  
    if (!path.length) return [0, 0, 0, 0]
  
    var bounds = [Infinity, Infinity, -Infinity, -Infinity]
  
    for (var i = 0, l = path.length; i < l; i++) {
      var points = path[i].slice(1)
  
      for (var j = 0; j < points.length; j += 2) {
        if (points[j + 0] < bounds[0]) bounds[0] = points[j + 0]
        if (points[j + 1] < bounds[1]) bounds[1] = points[j + 1]
        if (points[j + 0] > bounds[2]) bounds[2] = points[j + 0]
        if (points[j + 1] > bounds[3]) bounds[3] = points[j + 1]
      }
    }
  
    return bounds
  }
  
  },{"abs-svg-path":65,"assert":73,"is-svg-path":445,"normalize-svg-path":545,"parse-svg-path":479}],545:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = normalize
  
  var arcToCurve = _dereq_('svg-arc-to-cubic-bezier')
  
  function normalize(path){
    // init state
    var prev
    var result = []
    var bezierX = 0
    var bezierY = 0
    var startX = 0
    var startY = 0
    var quadX = null
    var quadY = null
    var x = 0
    var y = 0
  
    for (var i = 0, len = path.length; i < len; i++) {
      var seg = path[i]
      var command = seg[0]
  
      switch (command) {
        case 'M':
          startX = seg[1]
          startY = seg[2]
          break
        case 'A':
          var curves = arcToCurve({
            px: x,
            py: y,
            cx: seg[6],
            cy:  seg[7],
            rx: seg[1],
            ry: seg[2],
            xAxisRotation: seg[3],
            largeArcFlag: seg[4],
            sweepFlag: seg[5]
          })
  
          // null-curves
          if (!curves.length) continue
  
          for (var j = 0, c; j < curves.length; j++) {
            c = curves[j]
            seg = ['C', c.x1, c.y1, c.x2, c.y2, c.x, c.y]
            if (j < curves.length - 1) result.push(seg)
          }
  
          break
        case 'S':
          // default control point
          var cx = x
          var cy = y
          if (prev == 'C' || prev == 'S') {
            cx += cx - bezierX // reflect the previous command's control
            cy += cy - bezierY // point relative to the current point
          }
          seg = ['C', cx, cy, seg[1], seg[2], seg[3], seg[4]]
          break
        case 'T':
          if (prev == 'Q' || prev == 'T') {
            quadX = x * 2 - quadX // as with 'S' reflect previous control point
            quadY = y * 2 - quadY
          } else {
            quadX = x
            quadY = y
          }
          seg = quadratic(x, y, quadX, quadY, seg[1], seg[2])
          break
        case 'Q':
          quadX = seg[1]
          quadY = seg[2]
          seg = quadratic(x, y, seg[1], seg[2], seg[3], seg[4])
          break
        case 'L':
          seg = line(x, y, seg[1], seg[2])
          break
        case 'H':
          seg = line(x, y, seg[1], y)
          break
        case 'V':
          seg = line(x, y, x, seg[1])
          break
        case 'Z':
          seg = line(x, y, startX, startY)
          break
      }
  
      // update state
      prev = command
      x = seg[seg.length - 2]
      y = seg[seg.length - 1]
      if (seg.length > 4) {
        bezierX = seg[seg.length - 4]
        bezierY = seg[seg.length - 3]
      } else {
        bezierX = x
        bezierY = y
      }
      result.push(seg)
    }
  
    return result
  }
  
  function line(x1, y1, x2, y2){
    return ['C', x1, y1, x2, y2, x2, y2]
  }
  
  function quadratic(x1, y1, cx, cy, x2, y2){
    return [
      'C',
      x1/3 + (2/3) * cx,
      y1/3 + (2/3) * cy,
      x2/3 + (2/3) * cx,
      y2/3 + (2/3) * cy,
      x2,
      y2
    ]
  }
  
  },{"svg-arc-to-cubic-bezier":543}],546:[function(_dereq_,module,exports){
  'use strict'
  
  var pathBounds = _dereq_('svg-path-bounds')
  var parsePath = _dereq_('parse-svg-path')
  var drawPath = _dereq_('draw-svg-path')
  var isSvgPath = _dereq_('is-svg-path')
  var bitmapSdf = _dereq_('bitmap-sdf')
  
  var canvas = document.createElement('canvas')
  var ctx = canvas.getContext('2d')
  
  
  module.exports = pathSdf
  
  
  function pathSdf (path, options) {
    if (!isSvgPath(path)) throw Error('Argument should be valid svg path string')
  
    if (!options) options = {}
  
    var w, h
    if (options.shape) {
      w = options.shape[0]
      h = options.shape[1]
    }
    else {
      w = canvas.width = options.w || options.width || 200
      h = canvas.height = options.h || options.height || 200
    }
    var size = Math.min(w, h)
  
    var stroke = options.stroke || 0
  
    var viewbox = options.viewbox || options.viewBox || pathBounds(path)
    var scale = [w / (viewbox[2] - viewbox[0]), h / (viewbox[3] - viewbox[1])]
    var maxScale = Math.min(scale[0] || 0, scale[1] || 0) / 2
  
    //clear ctx
    ctx.fillStyle = 'black'
    ctx.fillRect(0, 0, w, h)
  
    ctx.fillStyle = 'white'
  
    if (stroke)	{
      if (typeof stroke != 'number') stroke = 1
      if (stroke > 0) {
        ctx.strokeStyle = 'white'
      }
      else {
        ctx.strokeStyle = 'black'
      }
  
      ctx.lineWidth = Math.abs(stroke)
    }
  
    ctx.translate(w * .5, h * .5)
    ctx.scale(maxScale, maxScale)
  
    //if canvas svg paths api is available
    if (isPath2DSupported()) {
      var path2d = new Path2D(path)
      ctx.fill(path2d)
      stroke && ctx.stroke(path2d)
    }
    //fallback to bezier-curves
    else {
      var segments = parsePath(path)
      drawPath(ctx, segments)
      ctx.fill()
      stroke && ctx.stroke()
    }
  
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  
    var data = bitmapSdf(ctx, {
      cutoff: options.cutoff != null ? options.cutoff : .5,
      radius: options.radius != null ? options.radius : size * .5
    })
  
    return data
  }
  
  var path2DSupported
  
  function isPath2DSupported () {
    if (path2DSupported != null) return path2DSupported
  
    var ctx = document.createElement('canvas').getContext('2d')
    ctx.canvas.width = ctx.canvas.height = 1
  
    if (!window.Path2D) return path2DSupported = false
  
    var path = new Path2D('M0,0h1v1h-1v-1Z')
  
    ctx.fillStyle = 'black'
    ctx.fill(path)
  
    var idata = ctx.getImageData(0,0,1,1)
  
    return path2DSupported = idata && idata.data && idata.data[3] === 255
  }
  
  },{"bitmap-sdf":98,"draw-svg-path":174,"is-svg-path":445,"parse-svg-path":479,"svg-path-bounds":544}],547:[function(_dereq_,module,exports){
  (function (process){
  'use strict'
  
  module.exports = textGet
  
  var vectorizeText = _dereq_('vectorize-text')
  
  var globals = window || process.global || {}
  var __TEXT_CACHE  = globals.__TEXT_CACHE || {}
  globals.__TEXT_CACHE = {}
  
  function unwrap(mesh) {
    var cells     = mesh.cells
    var positions = mesh.positions
    var data      = new Float32Array(cells.length * 6)
    var ptr       = 0
    var shapeX    = 0
    for(var i=0; i<cells.length; ++i) {
      var tri = cells[i]
      for(var j=0; j<3; ++j) {
        var point = positions[tri[j]]
        data[ptr++] = point[0]
        data[ptr++] = point[1] + 1.4
        shapeX      = Math.max(point[0], shapeX)
      }
    }
    return {
      data:  data,
      shape: shapeX
    }
  }
  
  function textGet(font, text, opts) {
    var opts = opts || {}
    var fontcache = __TEXT_CACHE[font]
    if(!fontcache) {
      fontcache = __TEXT_CACHE[font] = {
        ' ': {
          data:   new Float32Array(0),
          shape: 0.2
        }
      }
    }
    var mesh = fontcache[text]
    if(!mesh) {
      if(text.length <= 1 || !/\d/.test(text)) {
        mesh = fontcache[text] = unwrap(vectorizeText(text, {
          triangles:     true,
          font:          font,
          textAlign:     opts.textAlign || 'left',
          textBaseline:  'alphabetic',
          styletags: {
              breaklines: true,
                   bolds: true,
                 italics: true,
              subscripts: true,
            superscripts: true
          }
        }))
      } else {
        var parts = text.split(/(\d|\s)/)
        var buffer = new Array(parts.length)
        var bufferSize = 0
        var shapeX = 0
        for(var i=0; i<parts.length; ++i) {
          buffer[i] = textGet(font, parts[i])
          bufferSize += buffer[i].data.length
          shapeX += buffer[i].shape
          if(i>0) {
            shapeX += 0.02
          }
        }
  
        var data = new Float32Array(bufferSize)
        var ptr     = 0
        var xOffset = -0.5 * shapeX
        for(var i=0; i<buffer.length; ++i) {
          var bdata = buffer[i].data
          for(var j=0; j<bdata.length; j+=2) {
            data[ptr++] = bdata[j] + xOffset
            data[ptr++] = bdata[j+1]
          }
          xOffset += buffer[i].shape + 0.02
        }
  
        mesh = fontcache[text] = {
          data:  data,
          shape: shapeX
        }
      }
    }
  
     return mesh
  }
  
  }).call(this,_dereq_('_process'))
  },{"_process":500,"vectorize-text":572}],548:[function(_dereq_,module,exports){
  // TinyColor v1.4.2
  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License
  
  (function(Math) {
  
  var trimLeft = /^\s+/,
      trimRight = /\s+$/,
      tinyCounter = 0,
      mathRound = Math.round,
      mathMin = Math.min,
      mathMax = Math.max,
      mathRandom = Math.random;
  
  function tinycolor (color, opts) {
  
      color = (color) ? color : '';
      opts = opts || { };
  
      // If input is already a tinycolor, return itself
      if (color instanceof tinycolor) {
         return color;
      }
      // If we are called as a function, call using new instead
      if (!(this instanceof tinycolor)) {
          return new tinycolor(color, opts);
      }
  
      var rgb = inputToRGB(color);
      this._originalInput = color,
      this._r = rgb.r,
      this._g = rgb.g,
      this._b = rgb.b,
      this._a = rgb.a,
      this._roundA = mathRound(100*this._a) / 100,
      this._format = opts.format || rgb.format;
      this._gradientType = opts.gradientType;
  
      // Don't let the range of [0,255] come back in [0,1].
      // Potentially lose a little bit of precision here, but will fix issues where
      // .5 gets interpreted as half of the total, instead of half of 1
      // If it was supposed to be 128, this was already taken care of by `inputToRgb`
      if (this._r < 1) { this._r = mathRound(this._r); }
      if (this._g < 1) { this._g = mathRound(this._g); }
      if (this._b < 1) { this._b = mathRound(this._b); }
  
      this._ok = rgb.ok;
      this._tc_id = tinyCounter++;
  }
  
  tinycolor.prototype = {
      isDark: function() {
          return this.getBrightness() < 128;
      },
      isLight: function() {
          return !this.isDark();
      },
      isValid: function() {
          return this._ok;
      },
      getOriginalInput: function() {
        return this._originalInput;
      },
      getFormat: function() {
          return this._format;
      },
      getAlpha: function() {
          return this._a;
      },
      getBrightness: function() {
          //http://www.w3.org/TR/AERT#color-contrast
          var rgb = this.toRgb();
          return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
      },
      getLuminance: function() {
          //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
          var rgb = this.toRgb();
          var RsRGB, GsRGB, BsRGB, R, G, B;
          RsRGB = rgb.r/255;
          GsRGB = rgb.g/255;
          BsRGB = rgb.b/255;
  
          if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
          if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
          if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
          return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
      },
      setAlpha: function(value) {
          this._a = boundAlpha(value);
          this._roundA = mathRound(100*this._a) / 100;
          return this;
      },
      toHsv: function() {
          var hsv = rgbToHsv(this._r, this._g, this._b);
          return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
      },
      toHsvString: function() {
          var hsv = rgbToHsv(this._r, this._g, this._b);
          var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
          return (this._a == 1) ?
            "hsv("  + h + ", " + s + "%, " + v + "%)" :
            "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
      },
      toHsl: function() {
          var hsl = rgbToHsl(this._r, this._g, this._b);
          return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
      },
      toHslString: function() {
          var hsl = rgbToHsl(this._r, this._g, this._b);
          var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
          return (this._a == 1) ?
            "hsl("  + h + ", " + s + "%, " + l + "%)" :
            "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
      },
      toHex: function(allow3Char) {
          return rgbToHex(this._r, this._g, this._b, allow3Char);
      },
      toHexString: function(allow3Char) {
          return '#' + this.toHex(allow3Char);
      },
      toHex8: function(allow4Char) {
          return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
      },
      toHex8String: function(allow4Char) {
          return '#' + this.toHex8(allow4Char);
      },
      toRgb: function() {
          return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
      },
      toRgbString: function() {
          return (this._a == 1) ?
            "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
            "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
      },
      toPercentageRgb: function() {
          return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
      },
      toPercentageRgbString: function() {
          return (this._a == 1) ?
            "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
            "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
      },
      toName: function() {
          if (this._a === 0) {
              return "transparent";
          }
  
          if (this._a < 1) {
              return false;
          }
  
          return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
      },
      toFilter: function(secondColor) {
          var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
          var secondHex8String = hex8String;
          var gradientType = this._gradientType ? "GradientType = 1, " : "";
  
          if (secondColor) {
              var s = tinycolor(secondColor);
              secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
          }
  
          return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
      },
      toString: function(format) {
          var formatSet = !!format;
          format = format || this._format;
  
          var formattedString = false;
          var hasAlpha = this._a < 1 && this._a >= 0;
          var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
  
          if (needsAlphaFormat) {
              // Special case for "transparent", all other non-alpha formats
              // will return rgba when there is transparency.
              if (format === "name" && this._a === 0) {
                  return this.toName();
              }
              return this.toRgbString();
          }
          if (format === "rgb") {
              formattedString = this.toRgbString();
          }
          if (format === "prgb") {
              formattedString = this.toPercentageRgbString();
          }
          if (format === "hex" || format === "hex6") {
              formattedString = this.toHexString();
          }
          if (format === "hex3") {
              formattedString = this.toHexString(true);
          }
          if (format === "hex4") {
              formattedString = this.toHex8String(true);
          }
          if (format === "hex8") {
              formattedString = this.toHex8String();
          }
          if (format === "name") {
              formattedString = this.toName();
          }
          if (format === "hsl") {
              formattedString = this.toHslString();
          }
          if (format === "hsv") {
              formattedString = this.toHsvString();
          }
  
          return formattedString || this.toHexString();
      },
      clone: function() {
          return tinycolor(this.toString());
      },
  
      _applyModification: function(fn, args) {
          var color = fn.apply(null, [this].concat([].slice.call(args)));
          this._r = color._r;
          this._g = color._g;
          this._b = color._b;
          this.setAlpha(color._a);
          return this;
      },
      lighten: function() {
          return this._applyModification(lighten, arguments);
      },
      brighten: function() {
          return this._applyModification(brighten, arguments);
      },
      darken: function() {
          return this._applyModification(darken, arguments);
      },
      desaturate: function() {
          return this._applyModification(desaturate, arguments);
      },
      saturate: function() {
          return this._applyModification(saturate, arguments);
      },
      greyscale: function() {
          return this._applyModification(greyscale, arguments);
      },
      spin: function() {
          return this._applyModification(spin, arguments);
      },
  
      _applyCombination: function(fn, args) {
          return fn.apply(null, [this].concat([].slice.call(args)));
      },
      analogous: function() {
          return this._applyCombination(analogous, arguments);
      },
      complement: function() {
          return this._applyCombination(complement, arguments);
      },
      monochromatic: function() {
          return this._applyCombination(monochromatic, arguments);
      },
      splitcomplement: function() {
          return this._applyCombination(splitcomplement, arguments);
      },
      triad: function() {
          return this._applyCombination(triad, arguments);
      },
      tetrad: function() {
          return this._applyCombination(tetrad, arguments);
      }
  };
  
  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function(color, opts) {
      if (typeof color == "object") {
          var newColor = {};
          for (var i in color) {
              if (color.hasOwnProperty(i)) {
                  if (i === "a") {
                      newColor[i] = color[i];
                  }
                  else {
                      newColor[i] = convertToPercentage(color[i]);
                  }
              }
          }
          color = newColor;
      }
  
      return tinycolor(color, opts);
  };
  
  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
  
      var rgb = { r: 0, g: 0, b: 0 };
      var a = 1;
      var s = null;
      var v = null;
      var l = null;
      var ok = false;
      var format = false;
  
      if (typeof color == "string") {
          color = stringInputToObject(color);
      }
  
      if (typeof color == "object") {
          if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
              rgb = rgbToRgb(color.r, color.g, color.b);
              ok = true;
              format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
          }
          else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
              s = convertToPercentage(color.s);
              v = convertToPercentage(color.v);
              rgb = hsvToRgb(color.h, s, v);
              ok = true;
              format = "hsv";
          }
          else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
              s = convertToPercentage(color.s);
              l = convertToPercentage(color.l);
              rgb = hslToRgb(color.h, s, l);
              ok = true;
              format = "hsl";
          }
  
          if (color.hasOwnProperty("a")) {
              a = color.a;
          }
      }
  
      a = boundAlpha(a);
  
      return {
          ok: ok,
          format: color.format || format,
          r: mathMin(255, mathMax(rgb.r, 0)),
          g: mathMin(255, mathMax(rgb.g, 0)),
          b: mathMin(255, mathMax(rgb.b, 0)),
          a: a
      };
  }
  
  
  // Conversion Functions
  // --------------------
  
  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
  
  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b){
      return {
          r: bound01(r, 255) * 255,
          g: bound01(g, 255) * 255,
          b: bound01(b, 255) * 255
      };
  }
  
  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
  
      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);
  
      var max = mathMax(r, g, b), min = mathMin(r, g, b);
      var h, s, l = (max + min) / 2;
  
      if(max == min) {
          h = s = 0; // achromatic
      }
      else {
          var d = max - min;
          s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
          switch(max) {
              case r: h = (g - b) / d + (g < b ? 6 : 0); break;
              case g: h = (b - r) / d + 2; break;
              case b: h = (r - g) / d + 4; break;
          }
  
          h /= 6;
      }
  
      return { h: h, s: s, l: l };
  }
  
  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
      var r, g, b;
  
      h = bound01(h, 360);
      s = bound01(s, 100);
      l = bound01(l, 100);
  
      function hue2rgb(p, q, t) {
          if(t < 0) t += 1;
          if(t > 1) t -= 1;
          if(t < 1/6) return p + (q - p) * 6 * t;
          if(t < 1/2) return q;
          if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
          return p;
      }
  
      if(s === 0) {
          r = g = b = l; // achromatic
      }
      else {
          var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
          var p = 2 * l - q;
          r = hue2rgb(p, q, h + 1/3);
          g = hue2rgb(p, q, h);
          b = hue2rgb(p, q, h - 1/3);
      }
  
      return { r: r * 255, g: g * 255, b: b * 255 };
  }
  
  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
  
      r = bound01(r, 255);
      g = bound01(g, 255);
      b = bound01(b, 255);
  
      var max = mathMax(r, g, b), min = mathMin(r, g, b);
      var h, s, v = max;
  
      var d = max - min;
      s = max === 0 ? 0 : d / max;
  
      if(max == min) {
          h = 0; // achromatic
      }
      else {
          switch(max) {
              case r: h = (g - b) / d + (g < b ? 6 : 0); break;
              case g: h = (b - r) / d + 2; break;
              case b: h = (r - g) / d + 4; break;
          }
          h /= 6;
      }
      return { h: h, s: s, v: v };
  }
  
  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
   function hsvToRgb(h, s, v) {
  
      h = bound01(h, 360) * 6;
      s = bound01(s, 100);
      v = bound01(v, 100);
  
      var i = Math.floor(h),
          f = h - i,
          p = v * (1 - s),
          q = v * (1 - f * s),
          t = v * (1 - (1 - f) * s),
          mod = i % 6,
          r = [v, q, p, p, t, v][mod],
          g = [t, v, v, q, p, p][mod],
          b = [p, p, t, v, v, q][mod];
  
      return { r: r * 255, g: g * 255, b: b * 255 };
  }
  
  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
  
      var hex = [
          pad2(mathRound(r).toString(16)),
          pad2(mathRound(g).toString(16)),
          pad2(mathRound(b).toString(16))
      ];
  
      // Return a 3 character hex if possible
      if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
          return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
      }
  
      return hex.join("");
  }
  
  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
  
      var hex = [
          pad2(mathRound(r).toString(16)),
          pad2(mathRound(g).toString(16)),
          pad2(mathRound(b).toString(16)),
          pad2(convertDecimalToHex(a))
      ];
  
      // Return a 4 character hex if possible
      if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
          return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
      }
  
      return hex.join("");
  }
  
  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
  
      var hex = [
          pad2(convertDecimalToHex(a)),
          pad2(mathRound(r).toString(16)),
          pad2(mathRound(g).toString(16)),
          pad2(mathRound(b).toString(16))
      ];
  
      return hex.join("");
  }
  
  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
      if (!color1 || !color2) { return false; }
      return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  
  tinycolor.random = function() {
      return tinycolor.fromRatio({
          r: mathRandom(),
          g: mathRandom(),
          b: mathRandom()
      });
  };
  
  
  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
  
  function desaturate(color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.s -= amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
  }
  
  function saturate(color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.s += amount / 100;
      hsl.s = clamp01(hsl.s);
      return tinycolor(hsl);
  }
  
  function greyscale(color) {
      return tinycolor(color).desaturate(100);
  }
  
  function lighten (color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.l += amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
  }
  
  function brighten(color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var rgb = tinycolor(color).toRgb();
      rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
      rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
      rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
      return tinycolor(rgb);
  }
  
  function darken (color, amount) {
      amount = (amount === 0) ? 0 : (amount || 10);
      var hsl = tinycolor(color).toHsl();
      hsl.l -= amount / 100;
      hsl.l = clamp01(hsl.l);
      return tinycolor(hsl);
  }
  
  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function spin(color, amount) {
      var hsl = tinycolor(color).toHsl();
      var hue = (hsl.h + amount) % 360;
      hsl.h = hue < 0 ? 360 + hue : hue;
      return tinycolor(hsl);
  }
  
  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
  
  function complement(color) {
      var hsl = tinycolor(color).toHsl();
      hsl.h = (hsl.h + 180) % 360;
      return tinycolor(hsl);
  }
  
  function triad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [
          tinycolor(color),
          tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
          tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
      ];
  }
  
  function tetrad(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [
          tinycolor(color),
          tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
          tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
          tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
      ];
  }
  
  function splitcomplement(color) {
      var hsl = tinycolor(color).toHsl();
      var h = hsl.h;
      return [
          tinycolor(color),
          tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
          tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
      ];
  }
  
  function analogous(color, results, slices) {
      results = results || 6;
      slices = slices || 30;
  
      var hsl = tinycolor(color).toHsl();
      var part = 360 / slices;
      var ret = [tinycolor(color)];
  
      for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
          hsl.h = (hsl.h + part) % 360;
          ret.push(tinycolor(hsl));
      }
      return ret;
  }
  
  function monochromatic(color, results) {
      results = results || 6;
      var hsv = tinycolor(color).toHsv();
      var h = hsv.h, s = hsv.s, v = hsv.v;
      var ret = [];
      var modification = 1 / results;
  
      while (results--) {
          ret.push(tinycolor({ h: h, s: s, v: v}));
          v = (v + modification) % 1;
      }
  
      return ret;
  }
  
  // Utility Functions
  // ---------------------
  
  tinycolor.mix = function(color1, color2, amount) {
      amount = (amount === 0) ? 0 : (amount || 50);
  
      var rgb1 = tinycolor(color1).toRgb();
      var rgb2 = tinycolor(color2).toRgb();
  
      var p = amount / 100;
  
      var rgba = {
          r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
          g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
          b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
          a: ((rgb2.a - rgb1.a) * p) + rgb1.a
      };
  
      return tinycolor(rgba);
  };
  
  
  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
  
  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function(color1, color2) {
      var c1 = tinycolor(color1);
      var c2 = tinycolor(color2);
      return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
  };
  
  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
  
  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function(color1, color2, wcag2) {
      var readability = tinycolor.readability(color1, color2);
      var wcag2Parms, out;
  
      out = false;
  
      wcag2Parms = validateWCAG2Parms(wcag2);
      switch (wcag2Parms.level + wcag2Parms.size) {
          case "AAsmall":
          case "AAAlarge":
              out = readability >= 4.5;
              break;
          case "AAlarge":
              out = readability >= 3;
              break;
          case "AAAsmall":
              out = readability >= 7;
              break;
      }
      return out;
  
  };
  
  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function(baseColor, colorList, args) {
      var bestColor = null;
      var bestScore = 0;
      var readability;
      var includeFallbackColors, level, size ;
      args = args || {};
      includeFallbackColors = args.includeFallbackColors ;
      level = args.level;
      size = args.size;
  
      for (var i= 0; i < colorList.length ; i++) {
          readability = tinycolor.readability(baseColor, colorList[i]);
          if (readability > bestScore) {
              bestScore = readability;
              bestColor = tinycolor(colorList[i]);
          }
      }
  
      if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
          return bestColor;
      }
      else {
          args.includeFallbackColors=false;
          return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
      }
  };
  
  
  // Big List of Colors
  // ------------------
  // <http://www.w3.org/TR/css3-color/#svg-color>
  var names = tinycolor.names = {
      aliceblue: "f0f8ff",
      antiquewhite: "faebd7",
      aqua: "0ff",
      aquamarine: "7fffd4",
      azure: "f0ffff",
      beige: "f5f5dc",
      bisque: "ffe4c4",
      black: "000",
      blanchedalmond: "ffebcd",
      blue: "00f",
      blueviolet: "8a2be2",
      brown: "a52a2a",
      burlywood: "deb887",
      burntsienna: "ea7e5d",
      cadetblue: "5f9ea0",
      chartreuse: "7fff00",
      chocolate: "d2691e",
      coral: "ff7f50",
      cornflowerblue: "6495ed",
      cornsilk: "fff8dc",
      crimson: "dc143c",
      cyan: "0ff",
      darkblue: "00008b",
      darkcyan: "008b8b",
      darkgoldenrod: "b8860b",
      darkgray: "a9a9a9",
      darkgreen: "006400",
      darkgrey: "a9a9a9",
      darkkhaki: "bdb76b",
      darkmagenta: "8b008b",
      darkolivegreen: "556b2f",
      darkorange: "ff8c00",
      darkorchid: "9932cc",
      darkred: "8b0000",
      darksalmon: "e9967a",
      darkseagreen: "8fbc8f",
      darkslateblue: "483d8b",
      darkslategray: "2f4f4f",
      darkslategrey: "2f4f4f",
      darkturquoise: "00ced1",
      darkviolet: "9400d3",
      deeppink: "ff1493",
      deepskyblue: "00bfff",
      dimgray: "696969",
      dimgrey: "696969",
      dodgerblue: "1e90ff",
      firebrick: "b22222",
      floralwhite: "fffaf0",
      forestgreen: "228b22",
      fuchsia: "f0f",
      gainsboro: "dcdcdc",
      ghostwhite: "f8f8ff",
      gold: "ffd700",
      goldenrod: "daa520",
      gray: "808080",
      green: "008000",
      greenyellow: "adff2f",
      grey: "808080",
      honeydew: "f0fff0",
      hotpink: "ff69b4",
      indianred: "cd5c5c",
      indigo: "4b0082",
      ivory: "fffff0",
      khaki: "f0e68c",
      lavender: "e6e6fa",
      lavenderblush: "fff0f5",
      lawngreen: "7cfc00",
      lemonchiffon: "fffacd",
      lightblue: "add8e6",
      lightcoral: "f08080",
      lightcyan: "e0ffff",
      lightgoldenrodyellow: "fafad2",
      lightgray: "d3d3d3",
      lightgreen: "90ee90",
      lightgrey: "d3d3d3",
      lightpink: "ffb6c1",
      lightsalmon: "ffa07a",
      lightseagreen: "20b2aa",
      lightskyblue: "87cefa",
      lightslategray: "789",
      lightslategrey: "789",
      lightsteelblue: "b0c4de",
      lightyellow: "ffffe0",
      lime: "0f0",
      limegreen: "32cd32",
      linen: "faf0e6",
      magenta: "f0f",
      maroon: "800000",
      mediumaquamarine: "66cdaa",
      mediumblue: "0000cd",
      mediumorchid: "ba55d3",
      mediumpurple: "9370db",
      mediumseagreen: "3cb371",
      mediumslateblue: "7b68ee",
      mediumspringgreen: "00fa9a",
      mediumturquoise: "48d1cc",
      mediumvioletred: "c71585",
      midnightblue: "191970",
      mintcream: "f5fffa",
      mistyrose: "ffe4e1",
      moccasin: "ffe4b5",
      navajowhite: "ffdead",
      navy: "000080",
      oldlace: "fdf5e6",
      olive: "808000",
      olivedrab: "6b8e23",
      orange: "ffa500",
      orangered: "ff4500",
      orchid: "da70d6",
      palegoldenrod: "eee8aa",
      palegreen: "98fb98",
      paleturquoise: "afeeee",
      palevioletred: "db7093",
      papayawhip: "ffefd5",
      peachpuff: "ffdab9",
      peru: "cd853f",
      pink: "ffc0cb",
      plum: "dda0dd",
      powderblue: "b0e0e6",
      purple: "800080",
      rebeccapurple: "663399",
      red: "f00",
      rosybrown: "bc8f8f",
      royalblue: "4169e1",
      saddlebrown: "8b4513",
      salmon: "fa8072",
      sandybrown: "f4a460",
      seagreen: "2e8b57",
      seashell: "fff5ee",
      sienna: "a0522d",
      silver: "c0c0c0",
      skyblue: "87ceeb",
      slateblue: "6a5acd",
      slategray: "708090",
      slategrey: "708090",
      snow: "fffafa",
      springgreen: "00ff7f",
      steelblue: "4682b4",
      tan: "d2b48c",
      teal: "008080",
      thistle: "d8bfd8",
      tomato: "ff6347",
      turquoise: "40e0d0",
      violet: "ee82ee",
      wheat: "f5deb3",
      white: "fff",
      whitesmoke: "f5f5f5",
      yellow: "ff0",
      yellowgreen: "9acd32"
  };
  
  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);
  
  
  // Utilities
  // ---------
  
  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
      var flipped = { };
      for (var i in o) {
          if (o.hasOwnProperty(i)) {
              flipped[o[i]] = i;
          }
      }
      return flipped;
  }
  
  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
      a = parseFloat(a);
  
      if (isNaN(a) || a < 0 || a > 1) {
          a = 1;
      }
  
      return a;
  }
  
  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
      if (isOnePointZero(n)) { n = "100%"; }
  
      var processPercent = isPercentage(n);
      n = mathMin(max, mathMax(0, parseFloat(n)));
  
      // Automatically convert percentage into number
      if (processPercent) {
          n = parseInt(n * max, 10) / 100;
      }
  
      // Handle floating point rounding errors
      if ((Math.abs(n - max) < 0.000001)) {
          return 1;
      }
  
      // Convert into [0, 1] range if it isn't already
      return (n % max) / parseFloat(max);
  }
  
  // Force a number between 0 and 1
  function clamp01(val) {
      return mathMin(1, mathMax(0, val));
  }
  
  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
      return parseInt(val, 16);
  }
  
  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
      return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
  }
  
  // Check to see if string passed in is a percentage
  function isPercentage(n) {
      return typeof n === "string" && n.indexOf('%') != -1;
  }
  
  // Force a hex value to have 2 characters
  function pad2(c) {
      return c.length == 1 ? '0' + c : '' + c;
  }
  
  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
      if (n <= 1) {
          n = (n * 100) + "%";
      }
  
      return n;
  }
  
  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
      return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
      return (parseIntFromHex(h) / 255);
  }
  
  var matchers = (function() {
  
      // <http://www.w3.org/TR/css3-values/#integers>
      var CSS_INTEGER = "[-\\+]?\\d+%?";
  
      // <http://www.w3.org/TR/css3-values/#number-value>
      var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
  
      // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
      var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
  
      // Actual matching.
      // Parentheses and commas are optional, but not required.
      // Whitespace can take the place of commas or opening paren
      var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
      var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  
      return {
          CSS_UNIT: new RegExp(CSS_UNIT),
          rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
          rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
          hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
          hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
          hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
          hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
          hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
          hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
      };
  })();
  
  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
      return !!matchers.CSS_UNIT.exec(color);
  }
  
  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
  
      color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
      var named = false;
      if (names[color]) {
          color = names[color];
          named = true;
      }
      else if (color == 'transparent') {
          return { r: 0, g: 0, b: 0, a: 0, format: "name" };
      }
  
      // Try to match string input using regular expressions.
      // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
      // Just return an object and let the conversion functions handle that.
      // This way the result will be the same whether the tinycolor is initialized with string or object.
      var match;
      if ((match = matchers.rgb.exec(color))) {
          return { r: match[1], g: match[2], b: match[3] };
      }
      if ((match = matchers.rgba.exec(color))) {
          return { r: match[1], g: match[2], b: match[3], a: match[4] };
      }
      if ((match = matchers.hsl.exec(color))) {
          return { h: match[1], s: match[2], l: match[3] };
      }
      if ((match = matchers.hsla.exec(color))) {
          return { h: match[1], s: match[2], l: match[3], a: match[4] };
      }
      if ((match = matchers.hsv.exec(color))) {
          return { h: match[1], s: match[2], v: match[3] };
      }
      if ((match = matchers.hsva.exec(color))) {
          return { h: match[1], s: match[2], v: match[3], a: match[4] };
      }
      if ((match = matchers.hex8.exec(color))) {
          return {
              r: parseIntFromHex(match[1]),
              g: parseIntFromHex(match[2]),
              b: parseIntFromHex(match[3]),
              a: convertHexToDecimal(match[4]),
              format: named ? "name" : "hex8"
          };
      }
      if ((match = matchers.hex6.exec(color))) {
          return {
              r: parseIntFromHex(match[1]),
              g: parseIntFromHex(match[2]),
              b: parseIntFromHex(match[3]),
              format: named ? "name" : "hex"
          };
      }
      if ((match = matchers.hex4.exec(color))) {
          return {
              r: parseIntFromHex(match[1] + '' + match[1]),
              g: parseIntFromHex(match[2] + '' + match[2]),
              b: parseIntFromHex(match[3] + '' + match[3]),
              a: convertHexToDecimal(match[4] + '' + match[4]),
              format: named ? "name" : "hex8"
          };
      }
      if ((match = matchers.hex3.exec(color))) {
          return {
              r: parseIntFromHex(match[1] + '' + match[1]),
              g: parseIntFromHex(match[2] + '' + match[2]),
              b: parseIntFromHex(match[3] + '' + match[3]),
              format: named ? "name" : "hex"
          };
      }
  
      return false;
  }
  
  function validateWCAG2Parms(parms) {
      // return valid WCAG2 parms for isReadable.
      // If input parms are invalid, return {"level":"AA", "size":"small"}
      var level, size;
      parms = parms || {"level":"AA", "size":"small"};
      level = (parms.level || "AA").toUpperCase();
      size = (parms.size || "small").toLowerCase();
      if (level !== "AA" && level !== "AAA") {
          level = "AA";
      }
      if (size !== "small" && size !== "large") {
          size = "small";
      }
      return {"level":level, "size":size};
  }
  
  // Node: Export function
  if (typeof module !== "undefined" && module.exports) {
      module.exports = tinycolor;
  }
  // AMD/requirejs: Define the module
  else if (typeof define === 'function' && define.amd) {
      define(function () {return tinycolor;});
  }
  // Browser: Expose to window
  else {
      window.tinycolor = tinycolor;
  }
  
  })(Math);
  
  },{}],549:[function(_dereq_,module,exports){
  /* @module to-float32 */
  
  'use strict'
  
  module.exports = float32
  module.exports.float32 =
  module.exports.float = float32
  module.exports.fract32 =
  module.exports.fract = fract32
  
  var narr = new Float32Array(1)
  
  // return fractional part of float32 array
  function fract32 (arr) {
    if (arr.length) {
      var fract = float32(arr)
      for (var i = 0, l = fract.length; i < l; i++) {
        fract[i] = arr[i] - fract[i]
      }
      return fract
    }
  
    // number
    return float32(arr - float32(arr))
  }
  
  // make sure data is float32 array
  function float32 (arr) {
    if (arr.length) {
      if (arr instanceof Float32Array) return arr
      var float = new Float32Array(arr)
      float.set(arr)
      return float
    }
  
    // number
    narr[0] = arr
    return narr[0]
  }
  
  },{}],550:[function(_dereq_,module,exports){
  'use strict'
  
  var parseUnit = _dereq_('parse-unit')
  
  module.exports = toPX
  
  var PIXELS_PER_INCH = 96
  
  function getPropertyInPX(element, prop) {
    var parts = parseUnit(getComputedStyle(element).getPropertyValue(prop))
    return parts[0] * toPX(parts[1], element)
  }
  
  //This brutal hack is needed
  function getSizeBrutal(unit, element) {
    var testDIV = document.createElement('div')
    testDIV.style['font-size'] = '128' + unit
    element.appendChild(testDIV)
    var size = getPropertyInPX(testDIV, 'font-size') / 128
    element.removeChild(testDIV)
    return size
  }
  
  function toPX(str, element) {
    element = element || document.body
    str = (str || 'px').trim().toLowerCase()
    if(element === window || element === document) {
      element = document.body 
    }
    switch(str) {
      case '%':  //Ambiguous, not sure if we should use width or height
        return element.clientHeight / 100.0
      case 'ch':
      case 'ex':
        return getSizeBrutal(str, element)
      case 'em':
        return getPropertyInPX(element, 'font-size')
      case 'rem':
        return getPropertyInPX(document.body, 'font-size')
      case 'vw':
        return window.innerWidth/100
      case 'vh':
        return window.innerHeight/100
      case 'vmin':
        return Math.min(window.innerWidth, window.innerHeight) / 100
      case 'vmax':
        return Math.max(window.innerWidth, window.innerHeight) / 100
      case 'in':
        return PIXELS_PER_INCH
      case 'cm':
        return PIXELS_PER_INCH / 2.54
      case 'mm':
        return PIXELS_PER_INCH / 25.4
      case 'pt':
        return PIXELS_PER_INCH / 72
      case 'pc':
        return PIXELS_PER_INCH / 6
    }
    return 1
  }
  },{"parse-unit":480}],551:[function(_dereq_,module,exports){
  // https://github.com/topojson/topojson-client v3.1.0 Copyright 2019 Mike Bostock
  (function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.topojson = global.topojson || {}));
  }(this, function (exports) { 'use strict';
  
  function identity(x) {
    return x;
  }
  
  function transform(transform) {
    if (transform == null) return identity;
    var x0,
        y0,
        kx = transform.scale[0],
        ky = transform.scale[1],
        dx = transform.translate[0],
        dy = transform.translate[1];
    return function(input, i) {
      if (!i) x0 = y0 = 0;
      var j = 2, n = input.length, output = new Array(n);
      output[0] = (x0 += input[0]) * kx + dx;
      output[1] = (y0 += input[1]) * ky + dy;
      while (j < n) output[j] = input[j], ++j;
      return output;
    };
  }
  
  function bbox(topology) {
    var t = transform(topology.transform), key,
        x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
  
    function bboxPoint(p) {
      p = t(p);
      if (p[0] < x0) x0 = p[0];
      if (p[0] > x1) x1 = p[0];
      if (p[1] < y0) y0 = p[1];
      if (p[1] > y1) y1 = p[1];
    }
  
    function bboxGeometry(o) {
      switch (o.type) {
        case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
        case "Point": bboxPoint(o.coordinates); break;
        case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
      }
    }
  
    topology.arcs.forEach(function(arc) {
      var i = -1, n = arc.length, p;
      while (++i < n) {
        p = t(arc[i], i);
        if (p[0] < x0) x0 = p[0];
        if (p[0] > x1) x1 = p[0];
        if (p[1] < y0) y0 = p[1];
        if (p[1] > y1) y1 = p[1];
      }
    });
  
    for (key in topology.objects) {
      bboxGeometry(topology.objects[key]);
    }
  
    return [x0, y0, x1, y1];
  }
  
  function reverse(array, n) {
    var t, j = array.length, i = j - n;
    while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
  }
  
  function feature(topology, o) {
    if (typeof o === "string") o = topology.objects[o];
    return o.type === "GeometryCollection"
        ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
        : feature$1(topology, o);
  }
  
  function feature$1(topology, o) {
    var id = o.id,
        bbox = o.bbox,
        properties = o.properties == null ? {} : o.properties,
        geometry = object(topology, o);
    return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
        : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
        : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
  }
  
  function object(topology, o) {
    var transformPoint = transform(topology.transform),
        arcs = topology.arcs;
  
    function arc(i, points) {
      if (points.length) points.pop();
      for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
        points.push(transformPoint(a[k], k));
      }
      if (i < 0) reverse(points, n);
    }
  
    function point(p) {
      return transformPoint(p);
    }
  
    function line(arcs) {
      var points = [];
      for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
      if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
      return points;
    }
  
    function ring(arcs) {
      var points = line(arcs);
      while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
      return points;
    }
  
    function polygon(arcs) {
      return arcs.map(ring);
    }
  
    function geometry(o) {
      var type = o.type, coordinates;
      switch (type) {
        case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
        case "Point": coordinates = point(o.coordinates); break;
        case "MultiPoint": coordinates = o.coordinates.map(point); break;
        case "LineString": coordinates = line(o.arcs); break;
        case "MultiLineString": coordinates = o.arcs.map(line); break;
        case "Polygon": coordinates = polygon(o.arcs); break;
        case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
        default: return null;
      }
      return {type: type, coordinates: coordinates};
    }
  
    return geometry(o);
  }
  
  function stitch(topology, arcs) {
    var stitchedArcs = {},
        fragmentByStart = {},
        fragmentByEnd = {},
        fragments = [],
        emptyIndex = -1;
  
    // Stitch empty arcs first, since they may be subsumed by other arcs.
    arcs.forEach(function(i, j) {
      var arc = topology.arcs[i < 0 ? ~i : i], t;
      if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
        t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
      }
    });
  
    arcs.forEach(function(i) {
      var e = ends(i),
          start = e[0],
          end = e[1],
          f, g;
  
      if (f = fragmentByEnd[start]) {
        delete fragmentByEnd[f.end];
        f.push(i);
        f.end = end;
        if (g = fragmentByStart[end]) {
          delete fragmentByStart[g.start];
          var fg = g === f ? f : f.concat(g);
          fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
        } else {
          fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
        }
      } else if (f = fragmentByStart[end]) {
        delete fragmentByStart[f.start];
        f.unshift(i);
        f.start = start;
        if (g = fragmentByEnd[start]) {
          delete fragmentByEnd[g.end];
          var gf = g === f ? f : g.concat(f);
          fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
        } else {
          fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
        }
      } else {
        f = [i];
        fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
      }
    });
  
    function ends(i) {
      var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
      if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
      else p1 = arc[arc.length - 1];
      return i < 0 ? [p1, p0] : [p0, p1];
    }
  
    function flush(fragmentByEnd, fragmentByStart) {
      for (var k in fragmentByEnd) {
        var f = fragmentByEnd[k];
        delete fragmentByStart[f.start];
        delete f.start;
        delete f.end;
        f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
        fragments.push(f);
      }
    }
  
    flush(fragmentByEnd, fragmentByStart);
    flush(fragmentByStart, fragmentByEnd);
    arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
  
    return fragments;
  }
  
  function mesh(topology) {
    return object(topology, meshArcs.apply(this, arguments));
  }
  
  function meshArcs(topology, object, filter) {
    var arcs, i, n;
    if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
    else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
    return {type: "MultiLineString", arcs: stitch(topology, arcs)};
  }
  
  function extractArcs(topology, object, filter) {
    var arcs = [],
        geomsByArc = [],
        geom;
  
    function extract0(i) {
      var j = i < 0 ? ~i : i;
      (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
    }
  
    function extract1(arcs) {
      arcs.forEach(extract0);
    }
  
    function extract2(arcs) {
      arcs.forEach(extract1);
    }
  
    function extract3(arcs) {
      arcs.forEach(extract2);
    }
  
    function geometry(o) {
      switch (geom = o, o.type) {
        case "GeometryCollection": o.geometries.forEach(geometry); break;
        case "LineString": extract1(o.arcs); break;
        case "MultiLineString": case "Polygon": extract2(o.arcs); break;
        case "MultiPolygon": extract3(o.arcs); break;
      }
    }
  
    geometry(object);
  
    geomsByArc.forEach(filter == null
        ? function(geoms) { arcs.push(geoms[0].i); }
        : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
  
    return arcs;
  }
  
  function planarRingArea(ring) {
    var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
    while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
    return Math.abs(area); // Note: doubled area!
  }
  
  function merge(topology) {
    return object(topology, mergeArcs.apply(this, arguments));
  }
  
  function mergeArcs(topology, objects) {
    var polygonsByArc = {},
        polygons = [],
        groups = [];
  
    objects.forEach(geometry);
  
    function geometry(o) {
      switch (o.type) {
        case "GeometryCollection": o.geometries.forEach(geometry); break;
        case "Polygon": extract(o.arcs); break;
        case "MultiPolygon": o.arcs.forEach(extract); break;
      }
    }
  
    function extract(polygon) {
      polygon.forEach(function(ring) {
        ring.forEach(function(arc) {
          (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
        });
      });
      polygons.push(polygon);
    }
  
    function area(ring) {
      return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
    }
  
    polygons.forEach(function(polygon) {
      if (!polygon._) {
        var group = [],
            neighbors = [polygon];
        polygon._ = 1;
        groups.push(group);
        while (polygon = neighbors.pop()) {
          group.push(polygon);
          polygon.forEach(function(ring) {
            ring.forEach(function(arc) {
              polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
                if (!polygon._) {
                  polygon._ = 1;
                  neighbors.push(polygon);
                }
              });
            });
          });
        }
      }
    });
  
    polygons.forEach(function(polygon) {
      delete polygon._;
    });
  
    return {
      type: "MultiPolygon",
      arcs: groups.map(function(polygons) {
        var arcs = [], n;
  
        // Extract the exterior (unique) arcs.
        polygons.forEach(function(polygon) {
          polygon.forEach(function(ring) {
            ring.forEach(function(arc) {
              if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
                arcs.push(arc);
              }
            });
          });
        });
  
        // Stitch the arcs into one or more rings.
        arcs = stitch(topology, arcs);
  
        // If more than one ring is returned,
        // at most one of these rings can be the exterior;
        // choose the one with the greatest absolute area.
        if ((n = arcs.length) > 1) {
          for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
            if ((ki = area(arcs[i])) > k) {
              t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
            }
          }
        }
  
        return arcs;
      }).filter(function(arcs) {
        return arcs.length > 0;
      })
    };
  }
  
  function bisect(a, x) {
    var lo = 0, hi = a.length;
    while (lo < hi) {
      var mid = lo + hi >>> 1;
      if (a[mid] < x) lo = mid + 1;
      else hi = mid;
    }
    return lo;
  }
  
  function neighbors(objects) {
    var indexesByArc = {}, // arc index -> array of object indexes
        neighbors = objects.map(function() { return []; });
  
    function line(arcs, i) {
      arcs.forEach(function(a) {
        if (a < 0) a = ~a;
        var o = indexesByArc[a];
        if (o) o.push(i);
        else indexesByArc[a] = [i];
      });
    }
  
    function polygon(arcs, i) {
      arcs.forEach(function(arc) { line(arc, i); });
    }
  
    function geometry(o, i) {
      if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
      else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
    }
  
    var geometryType = {
      LineString: line,
      MultiLineString: polygon,
      Polygon: polygon,
      MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
    };
  
    objects.forEach(geometry);
  
    for (var i in indexesByArc) {
      for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
        for (var k = j + 1; k < m; ++k) {
          var ij = indexes[j], ik = indexes[k], n;
          if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
          if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
        }
      }
    }
  
    return neighbors;
  }
  
  function untransform(transform) {
    if (transform == null) return identity;
    var x0,
        y0,
        kx = transform.scale[0],
        ky = transform.scale[1],
        dx = transform.translate[0],
        dy = transform.translate[1];
    return function(input, i) {
      if (!i) x0 = y0 = 0;
      var j = 2,
          n = input.length,
          output = new Array(n),
          x1 = Math.round((input[0] - dx) / kx),
          y1 = Math.round((input[1] - dy) / ky);
      output[0] = x1 - x0, x0 = x1;
      output[1] = y1 - y0, y0 = y1;
      while (j < n) output[j] = input[j], ++j;
      return output;
    };
  }
  
  function quantize(topology, transform) {
    if (topology.transform) throw new Error("already quantized");
  
    if (!transform || !transform.scale) {
      if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be ≥2");
      box = topology.bbox || bbox(topology);
      var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
      transform = {scale: [x1 - x0 ? (x1 - x0) / (n - 1) : 1, y1 - y0 ? (y1 - y0) / (n - 1) : 1], translate: [x0, y0]};
    } else {
      box = topology.bbox;
    }
  
    var t = untransform(transform), box, key, inputs = topology.objects, outputs = {};
  
    function quantizePoint(point) {
      return t(point);
    }
  
    function quantizeGeometry(input) {
      var output;
      switch (input.type) {
        case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
        case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
        case "MultiPoint": output = {type: "MultiPoint", coordinates: input.coordinates.map(quantizePoint)}; break;
        default: return input;
      }
      if (input.id != null) output.id = input.id;
      if (input.bbox != null) output.bbox = input.bbox;
      if (input.properties != null) output.properties = input.properties;
      return output;
    }
  
    function quantizeArc(input) {
      var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
      output[0] = t(input[0], 0);
      while (++i < n) if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
      if (j === 1) output[j++] = [0, 0]; // an arc must have at least two points
      output.length = j;
      return output;
    }
  
    for (key in inputs) outputs[key] = quantizeGeometry(inputs[key]);
  
    return {
      type: "Topology",
      bbox: box,
      transform: transform,
      objects: outputs,
      arcs: topology.arcs.map(quantizeArc)
    };
  }
  
  exports.bbox = bbox;
  exports.feature = feature;
  exports.merge = merge;
  exports.mergeArcs = mergeArcs;
  exports.mesh = mesh;
  exports.meshArcs = meshArcs;
  exports.neighbors = neighbors;
  exports.quantize = quantize;
  exports.transform = transform;
  exports.untransform = untransform;
  
  Object.defineProperty(exports, '__esModule', { value: true });
  
  }));
  
  },{}],552:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = triangulateCube
  
  var perm = _dereq_("permutation-rank")
  var sgn = _dereq_("permutation-parity")
  var gamma = _dereq_("gamma")
  
  function triangulateCube(dimension) {
    if(dimension < 0) {
      return [ ]
    }
    if(dimension === 0) {
      return [ [0] ]
    }
    var dfactorial = Math.round(gamma(dimension+1))|0
    var result = []
    for(var i=0; i<dfactorial; ++i) {
      var p = perm.unrank(dimension, i)
      var cell = [ 0 ]
      var v = 0
      for(var j=0; j<p.length; ++j) {
        v += (1<<p[j])
        cell.push(v)
      }
      if(sgn(p) < 1) {
        cell[0] = v
        cell[dimension] = 0
      }
      result.push(cell)
    }
    return result
  }
  },{"gamma":248,"permutation-parity":483,"permutation-rank":484}],553:[function(_dereq_,module,exports){
  'use strict'
  
  module.exports = createTurntableController
  
  var filterVector = _dereq_('filtered-vector')
  var invert44     = _dereq_('gl-mat4/invert')
  var rotateM      = _dereq_('gl-mat4/rotate')
  var cross        = _dereq_('gl-vec3/cross')
  var normalize3   = _dereq_('gl-vec3/normalize')
  var dot3         = _dereq_('gl-vec3/dot')
  
  function len3(x, y, z) {
    return Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2) + Math.pow(z, 2))
  }
  
  function clamp1(x) {
    return Math.min(1.0, Math.max(-1.0, x))
  }
  
  function findOrthoPair(v) {
    var vx = Math.abs(v[0])
    var vy = Math.abs(v[1])
    var vz = Math.abs(v[2])
  
    var u = [0,0,0]
    if(vx > Math.max(vy, vz)) {
      u[2] = 1
    } else if(vy > Math.max(vx, vz)) {
      u[0] = 1
    } else {
      u[1] = 1
    }
  
    var vv = 0
    var uv = 0
    for(var i=0; i<3; ++i ) {
      vv += v[i] * v[i]
      uv += u[i] * v[i]
    }
    for(var i=0; i<3; ++i) {
      u[i] -= (uv / vv) *  v[i]
    }
    normalize3(u, u)
    return u
  }
  
  function TurntableController(zoomMin, zoomMax, center, up, right, radius, theta, phi) {
    this.center = filterVector(center)
    this.up     = filterVector(up)
    this.right  = filterVector(right)
    this.radius = filterVector([radius])
    this.angle  = filterVector([theta, phi])
    this.angle.bounds = [[-Infinity,-Math.PI/2], [Infinity,Math.PI/2]]
    this.setDistanceLimits(zoomMin, zoomMax)
  
    this.computedCenter = this.center.curve(0)
    this.computedUp     = this.up.curve(0)
    this.computedRight  = this.right.curve(0)
    this.computedRadius = this.radius.curve(0)
    this.computedAngle  = this.angle.curve(0)
    this.computedToward = [0,0,0]
    this.computedEye    = [0,0,0]
    this.computedMatrix = new Array(16)
    for(var i=0; i<16; ++i) {
      this.computedMatrix[i] = 0.5
    }
  
    this.recalcMatrix(0)
  }
  
  var proto = TurntableController.prototype
  
  proto.setDistanceLimits = function(minDist, maxDist) {
    if(minDist > 0) {
      minDist = Math.log(minDist)
    } else {
      minDist = -Infinity
    }
    if(maxDist > 0) {
      maxDist = Math.log(maxDist)
    } else {
      maxDist = Infinity
    }
    maxDist = Math.max(maxDist, minDist)
    this.radius.bounds[0][0] = minDist
    this.radius.bounds[1][0] = maxDist
  }
  
  proto.getDistanceLimits = function(out) {
    var bounds = this.radius.bounds[0]
    if(out) {
      out[0] = Math.exp(bounds[0][0])
      out[1] = Math.exp(bounds[1][0])
      return out
    }
    return [ Math.exp(bounds[0][0]), Math.exp(bounds[1][0]) ]
  }
  
  proto.recalcMatrix = function(t) {
    //Recompute curves
    this.center.curve(t)
    this.up.curve(t)
    this.right.curve(t)
    this.radius.curve(t)
    this.angle.curve(t)
  
    //Compute frame for camera matrix
    var up     = this.computedUp
    var right  = this.computedRight
    var uu = 0.0
    var ur = 0.0
    for(var i=0; i<3; ++i) {
      ur += up[i] * right[i]
      uu += up[i] * up[i]
    }
    var ul = Math.sqrt(uu)
    var rr = 0.0
    for(var i=0; i<3; ++i) {
      right[i] -= up[i] * ur / uu
      rr       += right[i] * right[i]
      up[i]    /= ul
    }
    var rl = Math.sqrt(rr)
    for(var i=0; i<3; ++i) {
      right[i] /= rl
    }
  
    //Compute toward vector
    var toward = this.computedToward
    cross(toward, up, right)
    normalize3(toward, toward)
  
    //Compute angular parameters
    var radius = Math.exp(this.computedRadius[0])
    var theta  = this.computedAngle[0]
    var phi    = this.computedAngle[1]
  
    var ctheta = Math.cos(theta)
    var stheta = Math.sin(theta)
    var cphi   = Math.cos(phi)
    var sphi   = Math.sin(phi)
  
    var center = this.computedCenter
  
    var wx = ctheta * cphi 
    var wy = stheta * cphi
    var wz = sphi
  
    var sx = -ctheta * sphi
    var sy = -stheta * sphi
    var sz = cphi
  
    var eye = this.computedEye
    var mat = this.computedMatrix
    for(var i=0; i<3; ++i) {
      var x      = wx * right[i] + wy * toward[i] + wz * up[i]
      mat[4*i+1] = sx * right[i] + sy * toward[i] + sz * up[i]
      mat[4*i+2] = x
      mat[4*i+3] = 0.0
    }
  
    var ax = mat[1]
    var ay = mat[5]
    var az = mat[9]
    var bx = mat[2]
    var by = mat[6]
    var bz = mat[10]
    var cx = ay * bz - az * by
    var cy = az * bx - ax * bz
    var cz = ax * by - ay * bx
    var cl = len3(cx, cy, cz)
    cx /= cl
    cy /= cl
    cz /= cl
    mat[0] = cx
    mat[4] = cy
    mat[8] = cz
  
    for(var i=0; i<3; ++i) {
      eye[i] = center[i] + mat[2+4*i]*radius
    }
  
    for(var i=0; i<3; ++i) {
      var rr = 0.0
      for(var j=0; j<3; ++j) {
        rr += mat[i+4*j] * eye[j]
      }
      mat[12+i] = -rr
    }
    mat[15] = 1.0
  }
  
  proto.getMatrix = function(t, result) {
    this.recalcMatrix(t)
    var mat = this.computedMatrix
    if(result) {
      for(var i=0; i<16; ++i) {
        result[i] = mat[i]
      }
      return result
    }
    return mat
  }
  
  var zAxis = [0,0,0]
  proto.rotate = function(t, dtheta, dphi, droll) {
    this.angle.move(t, dtheta, dphi)
    if(droll) {
      this.recalcMatrix(t)
  
      var mat = this.computedMatrix
      zAxis[0] = mat[2]
      zAxis[1] = mat[6]
      zAxis[2] = mat[10]
  
      var up     = this.computedUp
      var right  = this.computedRight
      var toward = this.computedToward
  
      for(var i=0; i<3; ++i) {
        mat[4*i]   = up[i]
        mat[4*i+1] = right[i]
        mat[4*i+2] = toward[i]
      }
      rotateM(mat, mat, droll, zAxis)
      for(var i=0; i<3; ++i) {
        up[i] =    mat[4*i]
        right[i] = mat[4*i+1]
      }
  
      this.up.set(t, up[0], up[1], up[2])
      this.right.set(t, right[0], right[1], right[2])
    }
  }
  
  proto.pan = function(t, dx, dy, dz) {
    dx = dx || 0.0
    dy = dy || 0.0
    dz = dz || 0.0
  
    this.recalcMatrix(t)
    var mat = this.computedMatrix
  
    var dist = Math.exp(this.computedRadius[0])
  
    var ux = mat[1]
    var uy = mat[5]
    var uz = mat[9]
    var ul = len3(ux, uy, uz)
    ux /= ul
    uy /= ul
    uz /= ul
  
    var rx = mat[0]
    var ry = mat[4]
    var rz = mat[8]
    var ru = rx * ux + ry * uy + rz * uz
    rx -= ux * ru
    ry -= uy * ru
    rz -= uz * ru
    var rl = len3(rx, ry, rz)
    rx /= rl
    ry /= rl
    rz /= rl
  
    var vx = rx * dx + ux * dy
    var vy = ry * dx + uy * dy
    var vz = rz * dx + uz * dy
    this.center.move(t, vx, vy, vz)
  
    //Update z-component of radius
    var radius = Math.exp(this.computedRadius[0])
    radius = Math.max(1e-4, radius + dz)
    this.radius.set(t, Math.log(radius))
  }
  
  proto.translate = function(t, dx, dy, dz) {
    this.center.move(t,
      dx||0.0,
      dy||0.0,
      dz||0.0)
  }
  
  //Recenters the coordinate axes
  proto.setMatrix = function(t, mat, axes, noSnap) {
    
    //Get the axes for tare
    var ushift = 1
    if(typeof axes === 'number') {
      ushift = (axes)|0
    } 
    if(ushift < 0 || ushift > 3) {
      ushift = 1
    }
    var vshift = (ushift + 2) % 3
    var fshift = (ushift + 1) % 3
  
    //Recompute state for new t value
    if(!mat) { 
      this.recalcMatrix(t)
      mat = this.computedMatrix
    }
  
    //Get right and up vectors
    var ux = mat[ushift]
    var uy = mat[ushift+4]
    var uz = mat[ushift+8]
    if(!noSnap) {
      var ul = len3(ux, uy, uz)
      ux /= ul
      uy /= ul
      uz /= ul
    } else {
      var ax = Math.abs(ux)
      var ay = Math.abs(uy)
      var az = Math.abs(uz)
      var am = Math.max(ax,ay,az)
      if(ax === am) {
        ux = (ux < 0) ? -1 : 1
        uy = uz = 0
      } else if(az === am) {
        uz = (uz < 0) ? -1 : 1
        ux = uy = 0
      } else {
        uy = (uy < 0) ? -1 : 1
        ux = uz = 0
      }
    }
  
    var rx = mat[vshift]
    var ry = mat[vshift+4]
    var rz = mat[vshift+8]
    var ru = rx * ux + ry * uy + rz * uz
    rx -= ux * ru
    ry -= uy * ru
    rz -= uz * ru
    var rl = len3(rx, ry, rz)
    rx /= rl
    ry /= rl
    rz /= rl
    
    var fx = uy * rz - uz * ry
    var fy = uz * rx - ux * rz
    var fz = ux * ry - uy * rx
    var fl = len3(fx, fy, fz)
    fx /= fl
    fy /= fl
    fz /= fl
  
    this.center.jump(t, ex, ey, ez)
    this.radius.idle(t)
    this.up.jump(t, ux, uy, uz)
    this.right.jump(t, rx, ry, rz)
  
    var phi, theta
    if(ushift === 2) {
      var cx = mat[1]
      var cy = mat[5]
      var cz = mat[9]
      var cr = cx * rx + cy * ry + cz * rz
      var cf = cx * fx + cy * fy + cz * fz
      if(tu < 0) {
        phi = -Math.PI/2
      } else {
        phi = Math.PI/2
      }
      theta = Math.atan2(cf, cr)
    } else {
      var tx = mat[2]
      var ty = mat[6]
      var tz = mat[10]
      var tu = tx * ux + ty * uy + tz * uz
      var tr = tx * rx + ty * ry + tz * rz
      var tf = tx * fx + ty * fy + tz * fz
  
      phi = Math.asin(clamp1(tu))
      theta = Math.atan2(tf, tr)
    }
  
    this.angle.jump(t, theta, phi)
  
    this.recalcMatrix(t)
    var dx = mat[2]
    var dy = mat[6]
    var dz = mat[10]
  
    var imat = this.computedMatrix
    invert44(imat, mat)
    var w  = imat[15]
    var ex = imat[12] / w
    var ey = imat[13] / w
    var ez = imat[14] / w
  
    var gs = Math.exp(this.computedRadius[0])
    this.center.jump(t, ex-dx*gs, ey-dy*gs, ez-dz*gs)
  }
  
  proto.lastT = function() {
    return Math.max(
      this.center.lastT(),
      this.up.lastT(),
      this.right.lastT(),
      this.radius.lastT(),
      this.angle.lastT())
  }
  
  proto.idle = function(t) {
    this.center.idle(t)
    this.up.idle(t)
    this.right.idle(t)
    this.radius.idle(t)
    this.angle.idle(t)
  }
  
  proto.flush = function(t) {
    this.center.flush(t)
    this.up.flush(t)
    this.right.flush(t)
    this.radius.flush(t)
    this.angle.flush(t)
  }
  
  proto.setDistance = function(t, d) {
    if(d > 0) {
      this.radius.set(t, Math.log(d))
    }
  }
  
  proto.lookAt = function(t, eye, center, up) {
    this.recalcMatrix(t)
  
    eye    = eye    || this.computedEye
    center = center || this.computedCenter
    up     = up     || this.computedUp
  
    var ux = up[0]
    var uy = up[1]
    var uz = up[2]
    var ul = len3(ux, uy, uz)
    if(ul < 1e-6) {
      return
    }
    ux /= ul
    uy /= ul
    uz /= ul
  
    var tx = eye[0] - center[0]
    var ty = eye[1] - center[1]
    var tz = eye[2] - center[2]
    var tl = len3(tx, ty, tz)
    if(tl < 1e-6) {
      return
    }
    tx /= tl
    ty /= tl
    tz /= tl
  
    var right = this.computedRight
    var rx = right[0]
    var ry = right[1]
    var rz = right[2]
    var ru = ux*rx + uy*ry + uz*rz
    rx -= ru * ux
    ry -= ru * uy
    rz -= ru * uz
    var rl = len3(rx, ry, rz)
  
    if(rl < 0.01) {
      rx = uy * tz - uz * ty
      ry = uz * tx - ux * tz
      rz = ux * ty - uy * tx
      rl = len3(rx, ry, rz)
      if(rl < 1e-6) {
        return
      }
    }
    rx /= rl
    ry /= rl
    rz /= rl
  
    this.up.set(t, ux, uy, uz)
    this.right.set(t, rx, ry, rz)
    this.center.set(t, center[0], center[1], center[2])
    this.radius.set(t, Math.log(tl))
  
    var fx = uy * rz - uz * ry
    var fy = uz * rx - ux * rz
    var fz = ux * ry - uy * rx
    var fl = len3(fx, fy, fz)
    fx /= fl
    fy /= fl
    fz /= fl
  
    var tu = ux*tx + uy*ty + uz*tz
    var tr = rx*tx + ry*ty + rz*tz
    var tf = fx*tx + fy*ty + fz*tz
  
    var phi   = Math.asin(clamp1(tu))
    var theta = Math.atan2(tf, tr)
  
    var angleState = this.angle._state
    var lastTheta  = angleState[angleState.length-1]
    var lastPhi    = angleState[angleState.length-2]
    lastTheta      = lastTheta % (2.0 * Math.PI)
    var dp = Math.abs(lastTheta + 2.0 * Math.PI - theta)
    var d0 = Math.abs(lastTheta - theta)
    var dn = Math.abs(lastTheta - 2.0 * Math.PI - theta)
    if(dp < d0) {
      lastTheta += 2.0 * Math.PI
    }
    if(dn < d0) {
      lastTheta -= 2.0 * Math.PI
    }
  
    this.angle.jump(this.angle.lastT(), lastTheta, lastPhi)
    this.angle.set(t, theta, phi)
  }
  
  function createTurntableController(options) {
    options = options || {}
  
    var center = options.center || [0,0,0]
    var up     = options.up     || [0,1,0]
    var right  = options.right  || findOrthoPair(up)
    var radius = options.radius || 1.0
    var theta  = options.theta  || 0.0
    var phi    = options.phi    || 0.0
  
    center = [].slice.call(center, 0, 3)
  
    up = [].slice.call(up, 0, 3)
    normalize3(up, up)
  
    right = [].slice.call(right, 0, 3)
    normalize3(right, right)
  
    if('eye' in options) {
      var eye = options.eye
      var toward = [
        eye[0]-center[0],
        eye[1]-center[1],
        eye[2]-center[2]
      ]
      cross(right, toward, up)
      if(len3(right[0], right[1], right[2]) < 1e-6) {
        right = findOrthoPair(up)
      } else {
        normalize3(right, right)
      }
  
      radius = len3(toward[0], toward[1], toward[2])
  
      var ut = dot3(up, toward) / radius
      var rt = dot3(right, toward) / radius
      phi    = Math.acos(ut)
      theta  = Math.acos(rt)
    }
  
    //Use logarithmic coordinates for radius
    radius = Math.log(radius)
  
    //Return the controller
    return new TurntableController(
      options.zoomMin,
      options.zoomMax,
      center,
      up,
      right,
      radius,
      theta,
      phi)
  }
  },{"filtered-vector":242,"gl-mat4/invert":278,"gl-mat4/rotate":283,"gl-vec3/cross":339,"gl-vec3/dot":344,"gl-vec3/normalize":361}],554:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = twoProduct
  
  var SPLITTER = +(Math.pow(2, 27) + 1.0)
  
  function twoProduct(a, b, result) {
    var x = a * b
  
    var c = SPLITTER * a
    var abig = c - a
    var ahi = c - abig
    var alo = a - ahi
  
    var d = SPLITTER * b
    var bbig = d - b
    var bhi = d - bbig
    var blo = b - bhi
  
    var err1 = x - (ahi * bhi)
    var err2 = err1 - (alo * bhi)
    var err3 = err2 - (ahi * blo)
  
    var y = alo * blo - err3
  
    if(result) {
      result[0] = y
      result[1] = x
      return result
    }
  
    return [ y, x ]
  }
  },{}],555:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = fastTwoSum
  
  function fastTwoSum(a, b, result) {
    var x = a + b
    var bv = x - a
    var av = x - bv
    var br = b - bv
    var ar = a - av
    if(result) {
      result[0] = ar + br
      result[1] = x
      return result
    }
    return [ar+br, x]
  }
  },{}],556:[function(_dereq_,module,exports){
  "use strict";
  
  var isPrototype = _dereq_("../prototype/is");
  
  module.exports = function (value) {
    if (typeof value !== "function") return false;
  
    if (!hasOwnProperty.call(value, "length")) return false;
  
    try {
      if (typeof value.length !== "number") return false;
      if (typeof value.call !== "function") return false;
      if (typeof value.apply !== "function") return false;
    } catch (error) {
      return false;
    }
  
    return !isPrototype(value);
  };
  
  },{"../prototype/is":563}],557:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue       = _dereq_("../value/is")
    , isObject      = _dereq_("../object/is")
    , stringCoerce  = _dereq_("../string/coerce")
    , toShortString = _dereq_("./to-short-string");
  
  var resolveMessage = function (message, value) {
    return message.replace("%v", toShortString(value));
  };
  
  module.exports = function (value, defaultMessage, inputOptions) {
    if (!isObject(inputOptions)) throw new TypeError(resolveMessage(defaultMessage, value));
    if (!isValue(value)) {
      if ("default" in inputOptions) return inputOptions["default"];
      if (inputOptions.isOptional) return null;
    }
    var errorMessage = stringCoerce(inputOptions.errorMessage);
    if (!isValue(errorMessage)) errorMessage = defaultMessage;
    throw new TypeError(resolveMessage(errorMessage, value));
  };
  
  },{"../object/is":560,"../string/coerce":564,"../value/is":566,"./to-short-string":559}],558:[function(_dereq_,module,exports){
  "use strict";
  
  module.exports = function (value) {
    try {
      return value.toString();
    } catch (error) {
      try { return String(value); }
      catch (error2) { return null; }
    }
  };
  
  },{}],559:[function(_dereq_,module,exports){
  "use strict";
  
  var safeToString = _dereq_("./safe-to-string");
  
  var reNewLine = /[\n\r\u2028\u2029]/g;
  
  module.exports = function (value) {
    var string = safeToString(value);
    if (string === null) return "<Non-coercible to string value>";
    // Trim if too long
    if (string.length > 100) string = string.slice(0, 99) + "…";
    // Replace eventual new lines
    string = string.replace(reNewLine, function (char) {
      switch (char) {
        case "\n":
          return "\\n";
        case "\r":
          return "\\r";
        case "\u2028":
          return "\\u2028";
        case "\u2029":
          return "\\u2029";
        /* istanbul ignore next */
        default:
          throw new Error("Unexpected character");
      }
    });
    return string;
  };
  
  },{"./safe-to-string":558}],560:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue = _dereq_("../value/is");
  
  // prettier-ignore
  var possibleTypes = { "object": true, "function": true, "undefined": true /* document.all */ };
  
  module.exports = function (value) {
    if (!isValue(value)) return false;
    return hasOwnProperty.call(possibleTypes, typeof value);
  };
  
  },{"../value/is":566}],561:[function(_dereq_,module,exports){
  "use strict";
  
  var resolveException = _dereq_("../lib/resolve-exception")
    , is               = _dereq_("./is");
  
  module.exports = function (value/*, options*/) {
    if (is(value)) return value;
    return resolveException(value, "%v is not a plain function", arguments[1]);
  };
  
  },{"../lib/resolve-exception":557,"./is":562}],562:[function(_dereq_,module,exports){
  "use strict";
  
  var isFunction = _dereq_("../function/is");
  
  var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;
  
  module.exports = function (value) {
    if (!isFunction(value)) return false;
    if (classRe.test(functionToString.call(value))) return false;
    return true;
  };
  
  },{"../function/is":556}],563:[function(_dereq_,module,exports){
  "use strict";
  
  var isObject = _dereq_("../object/is");
  
  module.exports = function (value) {
    if (!isObject(value)) return false;
    try {
      if (!value.constructor) return false;
      return value.constructor.prototype === value;
    } catch (error) {
      return false;
    }
  };
  
  },{"../object/is":560}],564:[function(_dereq_,module,exports){
  "use strict";
  
  var isValue  = _dereq_("../value/is")
    , isObject = _dereq_("../object/is");
  
  var objectToString = Object.prototype.toString;
  
  module.exports = function (value) {
    if (!isValue(value)) return null;
    if (isObject(value)) {
      // Reject Object.prototype.toString coercion
      var valueToString = value.toString;
      if (typeof valueToString !== "function") return null;
      if (valueToString === objectToString) return null;
      // Note: It can be object coming from other realm, still as there's no ES3 and CSP compliant
      // way to resolve its realm's Object.prototype.toString it's left as not addressed edge case
    }
    try {
      return "" + value; // Ensure implicit coercion
    } catch (error) {
      return null;
    }
  };
  
  },{"../object/is":560,"../value/is":566}],565:[function(_dereq_,module,exports){
  "use strict";
  
  var resolveException = _dereq_("../lib/resolve-exception")
    , is               = _dereq_("./is");
  
  module.exports = function (value/*, options*/) {
    if (is(value)) return value;
    return resolveException(value, "Cannot use %v", arguments[1]);
  };
  
  },{"../lib/resolve-exception":557,"./is":566}],566:[function(_dereq_,module,exports){
  "use strict";
  
  // ES3 safe
  var _undefined = void 0;
  
  module.exports = function (value) { return value !== _undefined && value !== null; };
  
  },{}],567:[function(_dereq_,module,exports){
  (function (global){
  'use strict'
  
  var bits = _dereq_('bit-twiddle')
  var dup = _dereq_('dup')
  var Buffer = _dereq_('buffer').Buffer
  
  //Legacy pool support
  if(!global.__TYPEDARRAY_POOL) {
    global.__TYPEDARRAY_POOL = {
        UINT8     : dup([32, 0])
      , UINT16    : dup([32, 0])
      , UINT32    : dup([32, 0])
      , BIGUINT64 : dup([32, 0])
      , INT8      : dup([32, 0])
      , INT16     : dup([32, 0])
      , INT32     : dup([32, 0])
      , BIGINT64  : dup([32, 0])
      , FLOAT     : dup([32, 0])
      , DOUBLE    : dup([32, 0])
      , DATA      : dup([32, 0])
      , UINT8C    : dup([32, 0])
      , BUFFER    : dup([32, 0])
    }
  }
  
  var hasUint8C = (typeof Uint8ClampedArray) !== 'undefined'
  var hasBigUint64 = (typeof BigUint64Array) !== 'undefined'
  var hasBigInt64 = (typeof BigInt64Array) !== 'undefined'
  var POOL = global.__TYPEDARRAY_POOL
  
  //Upgrade pool
  if(!POOL.UINT8C) {
    POOL.UINT8C = dup([32, 0])
  }
  if(!POOL.BIGUINT64) {
    POOL.BIGUINT64 = dup([32, 0])
  }
  if(!POOL.BIGINT64) {
    POOL.BIGINT64 = dup([32, 0])
  }
  if(!POOL.BUFFER) {
    POOL.BUFFER = dup([32, 0])
  }
  
  //New technique: Only allocate from ArrayBufferView and Buffer
  var DATA    = POOL.DATA
    , BUFFER  = POOL.BUFFER
  
  exports.free = function free(array) {
    if(Buffer.isBuffer(array)) {
      BUFFER[bits.log2(array.length)].push(array)
    } else {
      if(Object.prototype.toString.call(array) !== '[object ArrayBuffer]') {
        array = array.buffer
      }
      if(!array) {
        return
      }
      var n = array.length || array.byteLength
      var log_n = bits.log2(n)|0
      DATA[log_n].push(array)
    }
  }
  
  function freeArrayBuffer(buffer) {
    if(!buffer) {
      return
    }
    var n = buffer.length || buffer.byteLength
    var log_n = bits.log2(n)
    DATA[log_n].push(buffer)
  }
  
  function freeTypedArray(array) {
    freeArrayBuffer(array.buffer)
  }
  
  exports.freeUint8 =
  exports.freeUint16 =
  exports.freeUint32 =
  exports.freeBigUint64 =
  exports.freeInt8 =
  exports.freeInt16 =
  exports.freeInt32 =
  exports.freeBigInt64 =
  exports.freeFloat32 = 
  exports.freeFloat =
  exports.freeFloat64 = 
  exports.freeDouble = 
  exports.freeUint8Clamped = 
  exports.freeDataView = freeTypedArray
  
  exports.freeArrayBuffer = freeArrayBuffer
  
  exports.freeBuffer = function freeBuffer(array) {
    BUFFER[bits.log2(array.length)].push(array)
  }
  
  exports.malloc = function malloc(n, dtype) {
    if(dtype === undefined || dtype === 'arraybuffer') {
      return mallocArrayBuffer(n)
    } else {
      switch(dtype) {
        case 'uint8':
          return mallocUint8(n)
        case 'uint16':
          return mallocUint16(n)
        case 'uint32':
          return mallocUint32(n)
        case 'int8':
          return mallocInt8(n)
        case 'int16':
          return mallocInt16(n)
        case 'int32':
          return mallocInt32(n)
        case 'float':
        case 'float32':
          return mallocFloat(n)
        case 'double':
        case 'float64':
          return mallocDouble(n)
        case 'uint8_clamped':
          return mallocUint8Clamped(n)
        case 'bigint64':
          return mallocBigInt64(n)
        case 'biguint64':
          return mallocBigUint64(n)
        case 'buffer':
          return mallocBuffer(n)
        case 'data':
        case 'dataview':
          return mallocDataView(n)
  
        default:
          return null
      }
    }
    return null
  }
  
  function mallocArrayBuffer(n) {
    var n = bits.nextPow2(n)
    var log_n = bits.log2(n)
    var d = DATA[log_n]
    if(d.length > 0) {
      return d.pop()
    }
    return new ArrayBuffer(n)
  }
  exports.mallocArrayBuffer = mallocArrayBuffer
  
  function mallocUint8(n) {
    return new Uint8Array(mallocArrayBuffer(n), 0, n)
  }
  exports.mallocUint8 = mallocUint8
  
  function mallocUint16(n) {
    return new Uint16Array(mallocArrayBuffer(2*n), 0, n)
  }
  exports.mallocUint16 = mallocUint16
  
  function mallocUint32(n) {
    return new Uint32Array(mallocArrayBuffer(4*n), 0, n)
  }
  exports.mallocUint32 = mallocUint32
  
  function mallocInt8(n) {
    return new Int8Array(mallocArrayBuffer(n), 0, n)
  }
  exports.mallocInt8 = mallocInt8
  
  function mallocInt16(n) {
    return new Int16Array(mallocArrayBuffer(2*n), 0, n)
  }
  exports.mallocInt16 = mallocInt16
  
  function mallocInt32(n) {
    return new Int32Array(mallocArrayBuffer(4*n), 0, n)
  }
  exports.mallocInt32 = mallocInt32
  
  function mallocFloat(n) {
    return new Float32Array(mallocArrayBuffer(4*n), 0, n)
  }
  exports.mallocFloat32 = exports.mallocFloat = mallocFloat
  
  function mallocDouble(n) {
    return new Float64Array(mallocArrayBuffer(8*n), 0, n)
  }
  exports.mallocFloat64 = exports.mallocDouble = mallocDouble
  
  function mallocUint8Clamped(n) {
    if(hasUint8C) {
      return new Uint8ClampedArray(mallocArrayBuffer(n), 0, n)
    } else {
      return mallocUint8(n)
    }
  }
  exports.mallocUint8Clamped = mallocUint8Clamped
  
  function mallocBigUint64(n) {
    if(hasBigUint64) {
      return new BigUint64Array(mallocArrayBuffer(8*n), 0, n)
    } else {
      return null;
    }
  }
  exports.mallocBigUint64 = mallocBigUint64
  
  function mallocBigInt64(n) {
    if (hasBigInt64) {
      return new BigInt64Array(mallocArrayBuffer(8*n), 0, n)
    } else {
      return null;
    }
  }
  exports.mallocBigInt64 = mallocBigInt64
  
  function mallocDataView(n) {
    return new DataView(mallocArrayBuffer(n), 0, n)
  }
  exports.mallocDataView = mallocDataView
  
  function mallocBuffer(n) {
    n = bits.nextPow2(n)
    var log_n = bits.log2(n)
    var cache = BUFFER[log_n]
    if(cache.length > 0) {
      return cache.pop()
    }
    return new Buffer(n)
  }
  exports.mallocBuffer = mallocBuffer
  
  exports.clearCache = function clearCache() {
    for(var i=0; i<32; ++i) {
      POOL.UINT8[i].length = 0
      POOL.UINT16[i].length = 0
      POOL.UINT32[i].length = 0
      POOL.INT8[i].length = 0
      POOL.INT16[i].length = 0
      POOL.INT32[i].length = 0
      POOL.FLOAT[i].length = 0
      POOL.DOUBLE[i].length = 0
      POOL.BIGUINT64[i].length = 0
      POOL.BIGINT64[i].length = 0
      POOL.UINT8C[i].length = 0
      DATA[i].length = 0
      BUFFER[i].length = 0
    }
  }
  
  }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{"bit-twiddle":97,"buffer":111,"dup":176}],568:[function(_dereq_,module,exports){
  "use strict"; "use restrict";
  
  module.exports = UnionFind;
  
  function UnionFind(count) {
    this.roots = new Array(count);
    this.ranks = new Array(count);
    
    for(var i=0; i<count; ++i) {
      this.roots[i] = i;
      this.ranks[i] = 0;
    }
  }
  
  var proto = UnionFind.prototype
  
  Object.defineProperty(proto, "length", {
    "get": function() {
      return this.roots.length
    }
  })
  
  proto.makeSet = function() {
    var n = this.roots.length;
    this.roots.push(n);
    this.ranks.push(0);
    return n;
  }
  
  proto.find = function(x) {
    var x0 = x
    var roots = this.roots;
    while(roots[x] !== x) {
      x = roots[x]
    }
    while(roots[x0] !== x) {
      var y = roots[x0]
      roots[x0] = x
      x0 = y
    }
    return x;
  }
  
  proto.link = function(x, y) {
    var xr = this.find(x)
      , yr = this.find(y);
    if(xr === yr) {
      return;
    }
    var ranks = this.ranks
      , roots = this.roots
      , xd    = ranks[xr]
      , yd    = ranks[yr];
    if(xd < yd) {
      roots[xr] = yr;
    } else if(yd < xd) {
      roots[yr] = xr;
    } else {
      roots[yr] = xr;
      ++ranks[xr];
    }
  }
  },{}],569:[function(_dereq_,module,exports){
  "use strict"
  
  function unique_pred(list, compare) {
    var ptr = 1
      , len = list.length
      , a=list[0], b=list[0]
    for(var i=1; i<len; ++i) {
      b = a
      a = list[i]
      if(compare(a, b)) {
        if(i === ptr) {
          ptr++
          continue
        }
        list[ptr++] = a
      }
    }
    list.length = ptr
    return list
  }
  
  function unique_eq(list) {
    var ptr = 1
      , len = list.length
      , a=list[0], b = list[0]
    for(var i=1; i<len; ++i, b=a) {
      b = a
      a = list[i]
      if(a !== b) {
        if(i === ptr) {
          ptr++
          continue
        }
        list[ptr++] = a
      }
    }
    list.length = ptr
    return list
  }
  
  function unique(list, compare, sorted) {
    if(list.length === 0) {
      return list
    }
    if(compare) {
      if(!sorted) {
        list.sort(compare)
      }
      return unique_pred(list, compare)
    }
    if(!sorted) {
      list.sort()
    }
    return unique_eq(list)
  }
  
  module.exports = unique
  
  },{}],570:[function(_dereq_,module,exports){
  var reg = /[\'\"]/
  
  module.exports = function unquote(str) {
    if (!str) {
      return ''
    }
    if (reg.test(str.charAt(0))) {
      str = str.substr(1)
    }
    if (reg.test(str.charAt(str.length - 1))) {
      str = str.substr(0, str.length - 1)
    }
    return str
  }
  
  },{}],571:[function(_dereq_,module,exports){
  /**
   * @module update-diff
   */
  
  'use strict'
  
  module.exports = function updateDiff (obj, diff, mappers) {
    if (!Array.isArray(mappers)) mappers = [].slice.call(arguments, 2)
  
    for (var i = 0, l = mappers.length; i < l; i++) {
      var dict = mappers[i]
      for (var prop in dict) {
        if (diff[prop] !== undefined && !Array.isArray(diff[prop]) && obj[prop] === diff[prop]) continue
  
        if (prop in diff) {
          var result
  
          if (dict[prop] === true) result = diff[prop]
          else if (dict[prop] === false) continue
          else if (typeof dict[prop] === 'function') {
            result = dict[prop](diff[prop], obj, diff)
            if (result === undefined) continue
          }
  
          obj[prop] = result
        }
      }
    }
  
    return obj
  }
  
  },{}],572:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = createText
  
  var vectorizeText = _dereq_("./lib/vtext")
  var defaultCanvas = null
  var defaultContext = null
  
  if(typeof document !== 'undefined') {
    defaultCanvas = document.createElement('canvas')
    defaultCanvas.width = 8192
    defaultCanvas.height = 1024
    defaultContext = defaultCanvas.getContext("2d")
  }
  
  function createText(str, options) {
    if((typeof options !== "object") || (options === null)) {
      options = {}
    }
    return vectorizeText(
      str,
      options.canvas || defaultCanvas,
      options.context || defaultContext,
      options)
  }
  
  },{"./lib/vtext":573}],573:[function(_dereq_,module,exports){
  module.exports = vectorizeText
  module.exports.processPixels = processPixels
  
  var surfaceNets = _dereq_('surface-nets')
  var ndarray = _dereq_('ndarray')
  var simplify = _dereq_('simplify-planar-graph')
  var cleanPSLG = _dereq_('clean-pslg')
  var cdt2d = _dereq_('cdt2d')
  var toPolygonCrappy = _dereq_('planar-graph-to-polyline')
  
  var TAG_bold = "b"
  var CHR_bold = 'b|'
  
  var TAG_italic = "i"
  var CHR_italic = 'i|'
  
  var TAG_super = "sup"
  var CHR_super0 = '+'
  var CHR_super = '+1'
  
  var TAG_sub = "sub"
  var CHR_sub0 = '-'
  var CHR_sub = '-1'
  
  function parseTag(tag, TAG_CHR, str, map) {
  
    var opnTag =  "<"  + tag + ">"
    var clsTag =  "</" + tag + ">"
  
    var nOPN = opnTag.length
    var nCLS = clsTag.length
  
    var isRecursive = (TAG_CHR[0] === CHR_super0) ||
                      (TAG_CHR[0] === CHR_sub0);
  
    var a = 0
    var b = -nCLS
    while (a > -1) {
      a = str.indexOf(opnTag, a)
      if(a === -1) break
  
      b = str.indexOf(clsTag, a + nOPN)
      if(b === -1) break
  
      if(b <= a) break
  
      for(var i = a; i < b + nCLS; ++i){
        if((i < a + nOPN) || (i >= b)) {
          map[i] = null
          str = str.substr(0, i) + " " + str.substr(i + 1)
        } else {
          if(map[i] !== null) {
            var pos = map[i].indexOf(TAG_CHR[0])
            if(pos === -1) {
              map[i] += TAG_CHR
            } else { // i.e. to handle multiple sub/super-scripts
              if(isRecursive) {
                // i.e to increase the sub/sup number
                map[i] = map[i].substr(0, pos + 1) + (1 + parseInt(map[i][pos + 1])) + map[i].substr(pos + 2)
              }
            }
          }
        }
      }
  
      var start = a + nOPN
      var remainingStr = str.substr(start, b - start)
  
      var c = remainingStr.indexOf(opnTag)
      if(c !== -1) a = c
      else a = b + nCLS
    }
  
    return map
  }
  
  function transformPositions(positions, options, size) {
    var align = options.textAlign || "start"
    var baseline = options.textBaseline || "alphabetic"
  
    var lo = [1<<30, 1<<30]
    var hi = [0,0]
    var n = positions.length
    for(var i=0; i<n; ++i) {
      var p = positions[i]
      for(var j=0; j<2; ++j) {
        lo[j] = Math.min(lo[j], p[j])|0
        hi[j] = Math.max(hi[j], p[j])|0
      }
    }
  
    var xShift = 0
    switch(align) {
      case "center":
        xShift = -0.5 * (lo[0] + hi[0])
      break
  
      case "right":
      case "end":
        xShift = -hi[0]
      break
  
      case "left":
      case "start":
        xShift = -lo[0]
      break
  
      default:
        throw new Error("vectorize-text: Unrecognized textAlign: '" + align + "'")
    }
  
    var yShift = 0
    switch(baseline) {
      case "hanging":
      case "top":
        yShift = -lo[1]
      break
  
      case "middle":
        yShift = -0.5 * (lo[1] + hi[1])
      break
  
      case "alphabetic":
      case "ideographic":
        yShift = -3 * size
      break
  
      case "bottom":
        yShift = -hi[1]
      break
  
      default:
        throw new Error("vectorize-text: Unrecoginized textBaseline: '" + baseline + "'")
    }
  
    var scale = 1.0 / size
    if("lineHeight" in options) {
      scale *= +options.lineHeight
    } else if("width" in options) {
      scale = options.width / (hi[0] - lo[0])
    } else if("height" in options) {
      scale = options.height / (hi[1] - lo[1])
    }
  
    return positions.map(function(p) {
      return [ scale * (p[0] + xShift), scale * (p[1] + yShift) ]
    })
  }
  
  function getPixels(canvas, context, rawString, fontSize, lineSpacing, styletags) {
  
    rawString = rawString.replace(/\n/g, '') // don't accept \n in the input
  
    if(styletags.breaklines === true) {
      rawString = rawString.replace(/\<br\>/g, '\n') // replace <br> tags with \n in the string
    } else {
      rawString = rawString.replace(/\<br\>/g, ' ') // don't accept <br> tags in the input and replace with space in this case
    }
  
    var activeStyle = ""
    var map = []
    for(j = 0; j < rawString.length; ++j) {
      map[j] = activeStyle
    }
  
    if(styletags.bolds === true) map = parseTag(TAG_bold, CHR_bold, rawString, map)
    if(styletags.italics === true) map = parseTag(TAG_italic, CHR_italic, rawString, map)
    if(styletags.superscripts === true) map = parseTag(TAG_super, CHR_super, rawString, map)
    if(styletags.subscripts === true) map = parseTag(TAG_sub, CHR_sub, rawString, map)
  
    var allStyles = []
    var plainText = ""
    for(j = 0; j < rawString.length; ++j) {
      if(map[j] !== null) {
        plainText += rawString[j]
        allStyles.push(map[j])
      }
    }
  
    var allTexts = plainText.split('\n')
  
    var numberOfLines = allTexts.length
    var lineHeight = Math.round(lineSpacing * fontSize)
    var offsetX = fontSize
    var offsetY = fontSize * 2
    var maxWidth = 0
    var minHeight = numberOfLines * lineHeight + offsetY
  
    if(canvas.height < minHeight) {
      canvas.height = minHeight
    }
  
    context.fillStyle = "#000"
    context.fillRect(0, 0, canvas.width, canvas.height)
  
    context.fillStyle = "#fff"
    var i, j, xPos, yPos, zPos
    var nDone = 0
  
    var buffer = ""
    function writeBuffer() {
      if(buffer !== "") {
        var delta = context.measureText(buffer).width
  
        context.fillText(buffer, offsetX + xPos, offsetY + yPos)
        xPos += delta
      }
    }
  
    function getTextFontSize() {
      return "" + Math.round(zPos) + "px ";
    }
  
    function changeStyle(oldStyle, newStyle) {
      var ctxFont = "" + context.font;
  
      if(styletags.subscripts === true) {
        var oldIndex_Sub = oldStyle.indexOf(CHR_sub0);
        var newIndex_Sub = newStyle.indexOf(CHR_sub0);
  
        var oldSub = (oldIndex_Sub > -1) ? parseInt(oldStyle[1 + oldIndex_Sub]) : 0;
        var newSub = (newIndex_Sub > -1) ? parseInt(newStyle[1 + newIndex_Sub]) : 0;
  
        if(oldSub !== newSub) {
          ctxFont = ctxFont.replace(getTextFontSize(), "?px ")
          zPos *= Math.pow(0.75, (newSub - oldSub))
          ctxFont = ctxFont.replace("?px ", getTextFontSize())
        }
        yPos += 0.25 * lineHeight * (newSub - oldSub);
      }
  
      if(styletags.superscripts === true) {
        var oldIndex_Super = oldStyle.indexOf(CHR_super0);
        var newIndex_Super = newStyle.indexOf(CHR_super0);
  
        var oldSuper = (oldIndex_Super > -1) ? parseInt(oldStyle[1 + oldIndex_Super]) : 0;
        var newSuper = (newIndex_Super > -1) ? parseInt(newStyle[1 + newIndex_Super]) : 0;
  
        if(oldSuper !== newSuper) {
          ctxFont = ctxFont.replace(getTextFontSize(), "?px ")
          zPos *= Math.pow(0.75, (newSuper - oldSuper))
          ctxFont = ctxFont.replace("?px ", getTextFontSize())
        }
        yPos -= 0.25 * lineHeight * (newSuper - oldSuper);
      }
  
      if(styletags.bolds === true) {
        var wasBold = (oldStyle.indexOf(CHR_bold) > -1)
        var is_Bold = (newStyle.indexOf(CHR_bold) > -1)
  
        if(!wasBold && is_Bold) {
          if(wasItalic) {
            ctxFont = ctxFont.replace("italic ", "italic bold ")
          } else {
            ctxFont = "bold " + ctxFont
          }
        }
        if(wasBold && !is_Bold) {
          ctxFont = ctxFont.replace("bold ", '')
        }
      }
  
      if(styletags.italics === true) {
        var wasItalic = (oldStyle.indexOf(CHR_italic) > -1)
        var is_Italic = (newStyle.indexOf(CHR_italic) > -1)
  
        if(!wasItalic && is_Italic) {
          ctxFont = "italic " + ctxFont
        }
        if(wasItalic && !is_Italic) {
          ctxFont = ctxFont.replace("italic ", '')
        }
      }
      context.font = ctxFont
    }
  
    for(i = 0; i < numberOfLines; ++i) {
      var txt = allTexts[i] + '\n'
      xPos = 0
      yPos = i * lineHeight
      zPos = fontSize
  
      buffer = ""
      
      for(j = 0; j < txt.length; ++j) {
        var style = (j + nDone < allStyles.length) ? allStyles[j + nDone] : allStyles[allStyles.length - 1]
        if(activeStyle === style) {
          buffer += txt[j]
        } else {
          writeBuffer()
          buffer = txt[j]
  
          if(style !== undefined) {
            changeStyle(activeStyle, style)
            activeStyle = style
          }
        }
      }
      writeBuffer()
  
      nDone += txt.length
  
      var width = Math.round(xPos + 2 * offsetX) | 0
      if(maxWidth < width) maxWidth = width
    }
  
    //Cut pixels from image
    var xCut = maxWidth
    var yCut = offsetY + lineHeight * numberOfLines
    var pixels = ndarray(context.getImageData(0, 0, xCut, yCut).data, [yCut, xCut, 4])
    return pixels.pick(-1, -1, 0).transpose(1, 0)
  }
  
  function getContour(pixels, doSimplify) {
    var contour = surfaceNets(pixels, 128)
    if(doSimplify) {
      return simplify(contour.cells, contour.positions, 0.25)
    }
    return {
      edges: contour.cells,
      positions: contour.positions
    }
  }
  
  function processPixelsImpl(pixels, options, size, simplify) {
    //Extract contour
    var contour = getContour(pixels, simplify)
  
    //Apply warp to positions
    var positions = transformPositions(contour.positions, options, size)
    var edges     = contour.edges
    var flip = "ccw" === options.orientation
  
    //Clean up the PSLG, resolve self intersections, etc.
    cleanPSLG(positions, edges)
  
    //If triangulate flag passed, triangulate the result
    if(options.polygons || options.polygon || options.polyline) {
      var result = toPolygonCrappy(edges, positions)
      var nresult = new Array(result.length)
      for(var i=0; i<result.length; ++i) {
        var loops = result[i]
        var nloops = new Array(loops.length)
        for(var j=0; j<loops.length; ++j) {
          var loop = loops[j]
          var nloop = new Array(loop.length)
          for(var k=0; k<loop.length; ++k) {
            nloop[k] = positions[loop[k]].slice()
          }
          if(flip) {
            nloop.reverse()
          }
          nloops[j] = nloop
        }
        nresult[i] = nloops
      }
      return nresult
    } else if(options.triangles || options.triangulate || options.triangle) {
      return {
        cells: cdt2d(positions, edges, {
          delaunay: false,
          exterior: false,
          interior: true
        }),
        positions: positions
      }
    } else {
      return {
        edges:     edges,
        positions: positions
      }
    }
  }
  
  function processPixels(pixels, options, size) {
    try {
      return processPixelsImpl(pixels, options, size, true)
    } catch(e) {}
    try {
      return processPixelsImpl(pixels, options, size, false)
    } catch(e) {}
    if(options.polygons || options.polyline || options.polygon) {
      return []
    }
    if(options.triangles || options.triangulate || options.triangle) {
      return {
        cells: [],
        positions: []
      }
    }
    return {
      edges: [],
      positions: []
    }
  }
  
  function vectorizeText(str, canvas, context, options) {
    var size = 64
    var lineSpacing = 1.25
    var styletags = {
      breaklines: false,
      bolds: false,
      italics: false,
      subscripts: false,
      superscripts: false
    }
  
    if(options) {
  
      if(options.size &&
         options.size > 0) size =
         options.size
  
      if(options.lineSpacing &&
         options.lineSpacing > 0) lineSpacing =
         options.lineSpacing
  
      if(options.styletags &&
         options.styletags.breaklines) styletags.breaklines =
         options.styletags.breaklines ? true : false
  
      if(options.styletags &&
         options.styletags.bolds) styletags.bolds =
         options.styletags.bolds ? true : false
  
      if(options.styletags &&
         options.styletags.italics) styletags.italics =
         options.styletags.italics ? true : false
  
      if(options.styletags &&
         options.styletags.subscripts) styletags.subscripts =
         options.styletags.subscripts ? true : false
  
      if(options.styletags &&
         options.styletags.superscripts) styletags.superscripts =
         options.styletags.superscripts ? true : false
    }
  
    context.font = [
      options.fontStyle,
      options.fontVariant,
      options.fontWeight,
      size + "px",
      options.font
    ].filter(function(d) {return d}).join(" ")
    context.textAlign = "start"
    context.textBaseline = "alphabetic"
    context.direction = "ltr"
  
    var pixels = getPixels(canvas, context, str, size, lineSpacing, styletags)
  
    return processPixels(pixels, options, size)
  }
  
  },{"cdt2d":112,"clean-pslg":121,"ndarray":469,"planar-graph-to-polyline":488,"simplify-planar-graph":534,"surface-nets":542}],574:[function(_dereq_,module,exports){
  // Copyright (C) 2011 Google Inc.
  //
  // Licensed under the Apache License, Version 2.0 (the "License");
  // you may not use this file except in compliance with the License.
  // You may obtain a copy of the License at
  //
  // http://www.apache.org/licenses/LICENSE-2.0
  //
  // Unless required by applicable law or agreed to in writing, software
  // distributed under the License is distributed on an "AS IS" BASIS,
  // WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  // See the License for the specific language governing permissions and
  // limitations under the License.
  
  /**
   * @fileoverview Install a leaky WeakMap emulation on platforms that
   * don't provide a built-in one.
   *
   * <p>Assumes that an ES5 platform where, if {@code WeakMap} is
   * already present, then it conforms to the anticipated ES6
   * specification. To run this file on an ES5 or almost ES5
   * implementation where the {@code WeakMap} specification does not
   * quite conform, run <code>repairES5.js</code> first.
   *
   * <p>Even though WeakMapModule is not global, the linter thinks it
   * is, which is why it is in the overrides list below.
   *
   * <p>NOTE: Before using this WeakMap emulation in a non-SES
   * environment, see the note below about hiddenRecord.
   *
   * @author Mark S. Miller
   * @requires crypto, ArrayBuffer, Uint8Array, navigator, console
   * @overrides WeakMap, ses, Proxy
   * @overrides WeakMapModule
   */
  
  /**
   * This {@code WeakMap} emulation is observably equivalent to the
   * ES-Harmony WeakMap, but with leakier garbage collection properties.
   *
   * <p>As with true WeakMaps, in this emulation, a key does not
   * retain maps indexed by that key and (crucially) a map does not
   * retain the keys it indexes. A map by itself also does not retain
   * the values associated with that map.
   *
   * <p>However, the values associated with a key in some map are
   * retained so long as that key is retained and those associations are
   * not overridden. For example, when used to support membranes, all
   * values exported from a given membrane will live for the lifetime
   * they would have had in the absence of an interposed membrane. Even
   * when the membrane is revoked, all objects that would have been
   * reachable in the absence of revocation will still be reachable, as
   * far as the GC can tell, even though they will no longer be relevant
   * to ongoing computation.
   *
   * <p>The API implemented here is approximately the API as implemented
   * in FF6.0a1 and agreed to by MarkM, Andreas Gal, and Dave Herman,
   * rather than the offially approved proposal page. TODO(erights):
   * upgrade the ecmascript WeakMap proposal page to explain this API
   * change and present to EcmaScript committee for their approval.
   *
   * <p>The first difference between the emulation here and that in
   * FF6.0a1 is the presence of non enumerable {@code get___, has___,
   * set___, and delete___} methods on WeakMap instances to represent
   * what would be the hidden internal properties of a primitive
   * implementation. Whereas the FF6.0a1 WeakMap.prototype methods
   * require their {@code this} to be a genuine WeakMap instance (i.e.,
   * an object of {@code [[Class]]} "WeakMap}), since there is nothing
   * unforgeable about the pseudo-internal method names used here,
   * nothing prevents these emulated prototype methods from being
   * applied to non-WeakMaps with pseudo-internal methods of the same
   * names.
   *
   * <p>Another difference is that our emulated {@code
   * WeakMap.prototype} is not itself a WeakMap. A problem with the
   * current FF6.0a1 API is that WeakMap.prototype is itself a WeakMap
   * providing ambient mutability and an ambient communications
   * channel. Thus, if a WeakMap is already present and has this
   * problem, repairES5.js wraps it in a safe wrappper in order to
   * prevent access to this channel. (See
   * PATCH_MUTABLE_FROZEN_WEAKMAP_PROTO in repairES5.js).
   */
  
  /**
   * If this is a full <a href=
   * "http://code.google.com/p/es-lab/wiki/SecureableES5"
   * >secureable ES5</a> platform and the ES-Harmony {@code WeakMap} is
   * absent, install an approximate emulation.
   *
   * <p>If WeakMap is present but cannot store some objects, use our approximate
   * emulation as a wrapper.
   *
   * <p>If this is almost a secureable ES5 platform, then WeakMap.js
   * should be run after repairES5.js.
   *
   * <p>See {@code WeakMap} for documentation of the garbage collection
   * properties of this WeakMap emulation.
   */
  (function WeakMapModule() {
    "use strict";
  
    if (typeof ses !== 'undefined' && ses.ok && !ses.ok()) {
      // already too broken, so give up
      return;
    }
  
    /**
     * In some cases (current Firefox), we must make a choice betweeen a
     * WeakMap which is capable of using all varieties of host objects as
     * keys and one which is capable of safely using proxies as keys. See
     * comments below about HostWeakMap and DoubleWeakMap for details.
     *
     * This function (which is a global, not exposed to guests) marks a
     * WeakMap as permitted to do what is necessary to index all host
     * objects, at the cost of making it unsafe for proxies.
     *
     * Do not apply this function to anything which is not a genuine
     * fresh WeakMap.
     */
    function weakMapPermitHostObjects(map) {
      // identity of function used as a secret -- good enough and cheap
      if (map.permitHostObjects___) {
        map.permitHostObjects___(weakMapPermitHostObjects);
      }
    }
    if (typeof ses !== 'undefined') {
      ses.weakMapPermitHostObjects = weakMapPermitHostObjects;
    }
  
    // IE 11 has no Proxy but has a broken WeakMap such that we need to patch
    // it using DoubleWeakMap; this flag tells DoubleWeakMap so.
    var doubleWeakMapCheckSilentFailure = false;
  
    // Check if there is already a good-enough WeakMap implementation, and if so
    // exit without replacing it.
    if (typeof WeakMap === 'function') {
      var HostWeakMap = WeakMap;
      // There is a WeakMap -- is it good enough?
      if (typeof navigator !== 'undefined' &&
          /Firefox/.test(navigator.userAgent)) {
        // We're now *assuming not*, because as of this writing (2013-05-06)
        // Firefox's WeakMaps have a miscellany of objects they won't accept, and
        // we don't want to make an exhaustive list, and testing for just one
        // will be a problem if that one is fixed alone (as they did for Event).
  
        // If there is a platform that we *can* reliably test on, here's how to
        // do it:
        //  var problematic = ... ;
        //  var testHostMap = new HostWeakMap();
        //  try {
        //    testHostMap.set(problematic, 1);  // Firefox 20 will throw here
        //    if (testHostMap.get(problematic) === 1) {
        //      return;
        //    }
        //  } catch (e) {}
  
      } else {
        // IE 11 bug: WeakMaps silently fail to store frozen objects.
        var testMap = new HostWeakMap();
        var testObject = Object.freeze({});
        testMap.set(testObject, 1);
        if (testMap.get(testObject) !== 1) {
          doubleWeakMapCheckSilentFailure = true;
          // Fall through to installing our WeakMap.
        } else {
          module.exports = WeakMap;
          return;
        }
      }
    }
  
    var hop = Object.prototype.hasOwnProperty;
    var gopn = Object.getOwnPropertyNames;
    var defProp = Object.defineProperty;
    var isExtensible = Object.isExtensible;
  
    /**
     * Security depends on HIDDEN_NAME being both <i>unguessable</i> and
     * <i>undiscoverable</i> by untrusted code.
     *
     * <p>Given the known weaknesses of Math.random() on existing
     * browsers, it does not generate unguessability we can be confident
     * of.
     *
     * <p>It is the monkey patching logic in this file that is intended
     * to ensure undiscoverability. The basic idea is that there are
     * three fundamental means of discovering properties of an object:
     * The for/in loop, Object.keys(), and Object.getOwnPropertyNames(),
     * as well as some proposed ES6 extensions that appear on our
     * whitelist. The first two only discover enumerable properties, and
     * we only use HIDDEN_NAME to name a non-enumerable property, so the
     * only remaining threat should be getOwnPropertyNames and some
     * proposed ES6 extensions that appear on our whitelist. We monkey
     * patch them to remove HIDDEN_NAME from the list of properties they
     * returns.
     *
     * <p>TODO(erights): On a platform with built-in Proxies, proxies
     * could be used to trap and thereby discover the HIDDEN_NAME, so we
     * need to monkey patch Proxy.create, Proxy.createFunction, etc, in
     * order to wrap the provided handler with the real handler which
     * filters out all traps using HIDDEN_NAME.
     *
     * <p>TODO(erights): Revisit Mike Stay's suggestion that we use an
     * encapsulated function at a not-necessarily-secret name, which
     * uses the Stiegler shared-state rights amplification pattern to
     * reveal the associated value only to the WeakMap in which this key
     * is associated with that value. Since only the key retains the
     * function, the function can also remember the key without causing
     * leakage of the key, so this doesn't violate our general gc
     * goals. In addition, because the name need not be a guarded
     * secret, we could efficiently handle cross-frame frozen keys.
     */
    var HIDDEN_NAME_PREFIX = 'weakmap:';
    var HIDDEN_NAME = HIDDEN_NAME_PREFIX + 'ident:' + Math.random() + '___';
  
    if (typeof crypto !== 'undefined' &&
        typeof crypto.getRandomValues === 'function' &&
        typeof ArrayBuffer === 'function' &&
        typeof Uint8Array === 'function') {
      var ab = new ArrayBuffer(25);
      var u8s = new Uint8Array(ab);
      crypto.getRandomValues(u8s);
      HIDDEN_NAME = HIDDEN_NAME_PREFIX + 'rand:' +
        Array.prototype.map.call(u8s, function(u8) {
          return (u8 % 36).toString(36);
        }).join('') + '___';
    }
  
    function isNotHiddenName(name) {
      return !(
          name.substr(0, HIDDEN_NAME_PREFIX.length) == HIDDEN_NAME_PREFIX &&
          name.substr(name.length - 3) === '___');
    }
  
    /**
     * Monkey patch getOwnPropertyNames to avoid revealing the
     * HIDDEN_NAME.
     *
     * <p>The ES5.1 spec requires each name to appear only once, but as
     * of this writing, this requirement is controversial for ES6, so we
     * made this code robust against this case. If the resulting extra
     * search turns out to be expensive, we can probably relax this once
     * ES6 is adequately supported on all major browsers, iff no browser
     * versions we support at that time have relaxed this constraint
     * without providing built-in ES6 WeakMaps.
     */
    defProp(Object, 'getOwnPropertyNames', {
      value: function fakeGetOwnPropertyNames(obj) {
        return gopn(obj).filter(isNotHiddenName);
      }
    });
  
    /**
     * getPropertyNames is not in ES5 but it is proposed for ES6 and
     * does appear in our whitelist, so we need to clean it too.
     */
    if ('getPropertyNames' in Object) {
      var originalGetPropertyNames = Object.getPropertyNames;
      defProp(Object, 'getPropertyNames', {
        value: function fakeGetPropertyNames(obj) {
          return originalGetPropertyNames(obj).filter(isNotHiddenName);
        }
      });
    }
  
    /**
     * <p>To treat objects as identity-keys with reasonable efficiency
     * on ES5 by itself (i.e., without any object-keyed collections), we
     * need to add a hidden property to such key objects when we
     * can. This raises several issues:
     * <ul>
     * <li>Arranging to add this property to objects before we lose the
     *     chance, and
     * <li>Hiding the existence of this new property from most
     *     JavaScript code.
     * <li>Preventing <i>certification theft</i>, where one object is
     *     created falsely claiming to be the key of an association
     *     actually keyed by another object.
     * <li>Preventing <i>value theft</i>, where untrusted code with
     *     access to a key object but not a weak map nevertheless
     *     obtains access to the value associated with that key in that
     *     weak map.
     * </ul>
     * We do so by
     * <ul>
     * <li>Making the name of the hidden property unguessable, so "[]"
     *     indexing, which we cannot intercept, cannot be used to access
     *     a property without knowing the name.
     * <li>Making the hidden property non-enumerable, so we need not
     *     worry about for-in loops or {@code Object.keys},
     * <li>monkey patching those reflective methods that would
     *     prevent extensions, to add this hidden property first,
     * <li>monkey patching those methods that would reveal this
     *     hidden property.
     * </ul>
     * Unfortunately, because of same-origin iframes, we cannot reliably
     * add this hidden property before an object becomes
     * non-extensible. Instead, if we encounter a non-extensible object
     * without a hidden record that we can detect (whether or not it has
     * a hidden record stored under a name secret to us), then we just
     * use the key object itself to represent its identity in a brute
     * force leaky map stored in the weak map, losing all the advantages
     * of weakness for these.
     */
    function getHiddenRecord(key) {
      if (key !== Object(key)) {
        throw new TypeError('Not an object: ' + key);
      }
      var hiddenRecord = key[HIDDEN_NAME];
      if (hiddenRecord && hiddenRecord.key === key) { return hiddenRecord; }
      if (!isExtensible(key)) {
        // Weak map must brute force, as explained in doc-comment above.
        return void 0;
      }
  
      // The hiddenRecord and the key point directly at each other, via
      // the "key" and HIDDEN_NAME properties respectively. The key
      // field is for quickly verifying that this hidden record is an
      // own property, not a hidden record from up the prototype chain.
      //
      // NOTE: Because this WeakMap emulation is meant only for systems like
      // SES where Object.prototype is frozen without any numeric
      // properties, it is ok to use an object literal for the hiddenRecord.
      // This has two advantages:
      // * It is much faster in a performance critical place
      // * It avoids relying on Object.create(null), which had been
      //   problematic on Chrome 28.0.1480.0. See
      //   https://code.google.com/p/google-caja/issues/detail?id=1687
      hiddenRecord = { key: key };
  
      // When using this WeakMap emulation on platforms where
      // Object.prototype might not be frozen and Object.create(null) is
      // reliable, use the following two commented out lines instead.
      // hiddenRecord = Object.create(null);
      // hiddenRecord.key = key;
  
      // Please contact us if you need this to work on platforms where
      // Object.prototype might not be frozen and
      // Object.create(null) might not be reliable.
  
      try {
        defProp(key, HIDDEN_NAME, {
          value: hiddenRecord,
          writable: false,
          enumerable: false,
          configurable: false
        });
        return hiddenRecord;
      } catch (error) {
        // Under some circumstances, isExtensible seems to misreport whether
        // the HIDDEN_NAME can be defined.
        // The circumstances have not been isolated, but at least affect
        // Node.js v0.10.26 on TravisCI / Linux, but not the same version of
        // Node.js on OS X.
        return void 0;
      }
    }
  
    /**
     * Monkey patch operations that would make their argument
     * non-extensible.
     *
     * <p>The monkey patched versions throw a TypeError if their
     * argument is not an object, so it should only be done to functions
     * that should throw a TypeError anyway if their argument is not an
     * object.
     */
    (function(){
      var oldFreeze = Object.freeze;
      defProp(Object, 'freeze', {
        value: function identifyingFreeze(obj) {
          getHiddenRecord(obj);
          return oldFreeze(obj);
        }
      });
      var oldSeal = Object.seal;
      defProp(Object, 'seal', {
        value: function identifyingSeal(obj) {
          getHiddenRecord(obj);
          return oldSeal(obj);
        }
      });
      var oldPreventExtensions = Object.preventExtensions;
      defProp(Object, 'preventExtensions', {
        value: function identifyingPreventExtensions(obj) {
          getHiddenRecord(obj);
          return oldPreventExtensions(obj);
        }
      });
    })();
  
    function constFunc(func) {
      func.prototype = null;
      return Object.freeze(func);
    }
  
    var calledAsFunctionWarningDone = false;
    function calledAsFunctionWarning() {
      // Future ES6 WeakMap is currently (2013-09-10) expected to reject WeakMap()
      // but we used to permit it and do it ourselves, so warn only.
      if (!calledAsFunctionWarningDone && typeof console !== 'undefined') {
        calledAsFunctionWarningDone = true;
        console.warn('WeakMap should be invoked as new WeakMap(), not ' +
            'WeakMap(). This will be an error in the future.');
      }
    }
  
    var nextId = 0;
  
    var OurWeakMap = function() {
      if (!(this instanceof OurWeakMap)) {  // approximate test for new ...()
        calledAsFunctionWarning();
      }
  
      // We are currently (12/25/2012) never encountering any prematurely
      // non-extensible keys.
      var keys = []; // brute force for prematurely non-extensible keys.
      var values = []; // brute force for corresponding values.
      var id = nextId++;
  
      function get___(key, opt_default) {
        var index;
        var hiddenRecord = getHiddenRecord(key);
        if (hiddenRecord) {
          return id in hiddenRecord ? hiddenRecord[id] : opt_default;
        } else {
          index = keys.indexOf(key);
          return index >= 0 ? values[index] : opt_default;
        }
      }
  
      function has___(key) {
        var hiddenRecord = getHiddenRecord(key);
        if (hiddenRecord) {
          return id in hiddenRecord;
        } else {
          return keys.indexOf(key) >= 0;
        }
      }
  
      function set___(key, value) {
        var index;
        var hiddenRecord = getHiddenRecord(key);
        if (hiddenRecord) {
          hiddenRecord[id] = value;
        } else {
          index = keys.indexOf(key);
          if (index >= 0) {
            values[index] = value;
          } else {
            // Since some browsers preemptively terminate slow turns but
            // then continue computing with presumably corrupted heap
            // state, we here defensively get keys.length first and then
            // use it to update both the values and keys arrays, keeping
            // them in sync.
            index = keys.length;
            values[index] = value;
            // If we crash here, values will be one longer than keys.
            keys[index] = key;
          }
        }
        return this;
      }
  
      function delete___(key) {
        var hiddenRecord = getHiddenRecord(key);
        var index, lastIndex;
        if (hiddenRecord) {
          return id in hiddenRecord && delete hiddenRecord[id];
        } else {
          index = keys.indexOf(key);
          if (index < 0) {
            return false;
          }
          // Since some browsers preemptively terminate slow turns but
          // then continue computing with potentially corrupted heap
          // state, we here defensively get keys.length first and then use
          // it to update both the keys and the values array, keeping
          // them in sync. We update the two with an order of assignments,
          // such that any prefix of these assignments will preserve the
          // key/value correspondence, either before or after the delete.
          // Note that this needs to work correctly when index === lastIndex.
          lastIndex = keys.length - 1;
          keys[index] = void 0;
          // If we crash here, there's a void 0 in the keys array, but
          // no operation will cause a "keys.indexOf(void 0)", since
          // getHiddenRecord(void 0) will always throw an error first.
          values[index] = values[lastIndex];
          // If we crash here, values[index] cannot be found here,
          // because keys[index] is void 0.
          keys[index] = keys[lastIndex];
          // If index === lastIndex and we crash here, then keys[index]
          // is still void 0, since the aliasing killed the previous key.
          keys.length = lastIndex;
          // If we crash here, keys will be one shorter than values.
          values.length = lastIndex;
          return true;
        }
      }
  
      return Object.create(OurWeakMap.prototype, {
        get___:    { value: constFunc(get___) },
        has___:    { value: constFunc(has___) },
        set___:    { value: constFunc(set___) },
        delete___: { value: constFunc(delete___) }
      });
    };
  
    OurWeakMap.prototype = Object.create(Object.prototype, {
      get: {
        /**
         * Return the value most recently associated with key, or
         * opt_default if none.
         */
        value: function get(key, opt_default) {
          return this.get___(key, opt_default);
        },
        writable: true,
        configurable: true
      },
  
      has: {
        /**
         * Is there a value associated with key in this WeakMap?
         */
        value: function has(key) {
          return this.has___(key);
        },
        writable: true,
        configurable: true
      },
  
      set: {
        /**
         * Associate value with key in this WeakMap, overwriting any
         * previous association if present.
         */
        value: function set(key, value) {
          return this.set___(key, value);
        },
        writable: true,
        configurable: true
      },
  
      'delete': {
        /**
         * Remove any association for key in this WeakMap, returning
         * whether there was one.
         *
         * <p>Note that the boolean return here does not work like the
         * {@code delete} operator. The {@code delete} operator returns
         * whether the deletion succeeds at bringing about a state in
         * which the deleted property is absent. The {@code delete}
         * operator therefore returns true if the property was already
         * absent, whereas this {@code delete} method returns false if
         * the association was already absent.
         */
        value: function remove(key) {
          return this.delete___(key);
        },
        writable: true,
        configurable: true
      }
    });
  
    if (typeof HostWeakMap === 'function') {
      (function() {
        // If we got here, then the platform has a WeakMap but we are concerned
        // that it may refuse to store some key types. Therefore, make a map
        // implementation which makes use of both as possible.
  
        // In this mode we are always using double maps, so we are not proxy-safe.
        // This combination does not occur in any known browser, but we had best
        // be safe.
        if (doubleWeakMapCheckSilentFailure && typeof Proxy !== 'undefined') {
          Proxy = undefined;
        }
  
        function DoubleWeakMap() {
          if (!(this instanceof OurWeakMap)) {  // approximate test for new ...()
            calledAsFunctionWarning();
          }
  
          // Preferable, truly weak map.
          var hmap = new HostWeakMap();
  
          // Our hidden-property-based pseudo-weak-map. Lazily initialized in the
          // 'set' implementation; thus we can avoid performing extra lookups if
          // we know all entries actually stored are entered in 'hmap'.
          var omap = undefined;
  
          // Hidden-property maps are not compatible with proxies because proxies
          // can observe the hidden name and either accidentally expose it or fail
          // to allow the hidden property to be set. Therefore, we do not allow
          // arbitrary WeakMaps to switch to using hidden properties, but only
          // those which need the ability, and unprivileged code is not allowed
          // to set the flag.
          //
          // (Except in doubleWeakMapCheckSilentFailure mode in which case we
          // disable proxies.)
          var enableSwitching = false;
  
          function dget(key, opt_default) {
            if (omap) {
              return hmap.has(key) ? hmap.get(key)
                  : omap.get___(key, opt_default);
            } else {
              return hmap.get(key, opt_default);
            }
          }
  
          function dhas(key) {
            return hmap.has(key) || (omap ? omap.has___(key) : false);
          }
  
          var dset;
          if (doubleWeakMapCheckSilentFailure) {
            dset = function(key, value) {
              hmap.set(key, value);
              if (!hmap.has(key)) {
                if (!omap) { omap = new OurWeakMap(); }
                omap.set(key, value);
              }
              return this;
            };
          } else {
            dset = function(key, value) {
              if (enableSwitching) {
                try {
                  hmap.set(key, value);
                } catch (e) {
                  if (!omap) { omap = new OurWeakMap(); }
                  omap.set___(key, value);
                }
              } else {
                hmap.set(key, value);
              }
              return this;
            };
          }
  
          function ddelete(key) {
            var result = !!hmap['delete'](key);
            if (omap) { return omap.delete___(key) || result; }
            return result;
          }
  
          return Object.create(OurWeakMap.prototype, {
            get___:    { value: constFunc(dget) },
            has___:    { value: constFunc(dhas) },
            set___:    { value: constFunc(dset) },
            delete___: { value: constFunc(ddelete) },
            permitHostObjects___: { value: constFunc(function(token) {
              if (token === weakMapPermitHostObjects) {
                enableSwitching = true;
              } else {
                throw new Error('bogus call to permitHostObjects___');
              }
            })}
          });
        }
        DoubleWeakMap.prototype = OurWeakMap.prototype;
        module.exports = DoubleWeakMap;
  
        // define .constructor to hide OurWeakMap ctor
        Object.defineProperty(WeakMap.prototype, 'constructor', {
          value: WeakMap,
          enumerable: false,  // as default .constructor is
          configurable: true,
          writable: true
        });
      })();
    } else {
      // There is no host WeakMap, so we must use the emulation.
  
      // Emulated WeakMaps are incompatible with native proxies (because proxies
      // can observe the hidden name), so we must disable Proxy usage (in
      // ArrayLike and Domado, currently).
      if (typeof Proxy !== 'undefined') {
        Proxy = undefined;
      }
  
      module.exports = OurWeakMap;
    }
  })();
  
  },{}],575:[function(_dereq_,module,exports){
  var hiddenStore = _dereq_('./hidden-store.js');
  
  module.exports = createStore;
  
  function createStore() {
      var key = {};
  
      return function (obj) {
          if ((typeof obj !== 'object' || obj === null) &&
              typeof obj !== 'function'
          ) {
              throw new Error('Weakmap-shim: Key must be object')
          }
  
          var store = obj.valueOf(key);
          return store && store.identity === key ?
              store : hiddenStore(obj, key);
      };
  }
  
  },{"./hidden-store.js":576}],576:[function(_dereq_,module,exports){
  module.exports = hiddenStore;
  
  function hiddenStore(obj, key) {
      var store = { identity: key };
      var valueOf = obj.valueOf;
  
      Object.defineProperty(obj, "valueOf", {
          value: function (value) {
              return value !== key ?
                  valueOf.apply(this, arguments) : store;
          },
          writable: true
      });
  
      return store;
  }
  
  },{}],577:[function(_dereq_,module,exports){
  // Original - @Gozola.
  // https://gist.github.com/Gozala/1269991
  // This is a reimplemented version (with a few bug fixes).
  
  var createStore = _dereq_('./create-store.js');
  
  module.exports = weakMap;
  
  function weakMap() {
      var privates = createStore();
  
      return {
          'get': function (key, fallback) {
              var store = privates(key)
              return store.hasOwnProperty('value') ?
                  store.value : fallback
          },
          'set': function (key, value) {
              privates(key).value = value;
              return this;
          },
          'has': function(key) {
              return 'value' in privates(key);
          },
          'delete': function (key) {
              return delete privates(key).value;
          }
      }
  }
  
  },{"./create-store.js":575}],578:[function(_dereq_,module,exports){
  var getContext = _dereq_('get-canvas-context')
  
  module.exports = function getWebGLContext (opt) {
    return getContext('webgl', opt)
  }
  
  },{"get-canvas-context":249}],579:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Traditional Chinese calendar for jQuery v2.0.2.
     Written by Nicolas Riesco (enquiries@nicolasriesco.net) December 2016.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  var gregorianCalendar = main.instance();
  
  /** Implementation of the traditional Chinese calendar.
      Source of calendar tables https://github.com/isee15/Lunar-Solar-Calendar-Converter .
      @class ChineseCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function ChineseCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  ChineseCalendar.prototype = new main.baseCalendar;
  
  assign(ChineseCalendar.prototype, {
      /** The calendar name.
          @memberof ChineseCalendar */
      name: 'Chinese',
       /** Julian date of start of Gregorian epoch: 1 January 0001 CE.
          @memberof GregorianCalendar */
      jdEpoch: 1721425.5,
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof ChineseCalendar */
      hasYearZero: false,
      /** The minimum month number.
          This calendar uses month indices to account for intercalary months. 
          @memberof ChineseCalendar */
      minMonth: 0,
      /** The first month in the year.
          This calendar uses month indices to account for intercalary months. 
          @memberof ChineseCalendar */
      firstMonth: 0,
      /** The minimum day number.
          @memberof ChineseCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof ChineseCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Chinese',
              epochs: ['BEC', 'EC'],
              monthNumbers: function(date, padded) {
                  if (typeof date === 'string') {
                      var match = date.match(MONTH_NUMBER_REGEXP);
                      return (match) ? match[0] : '';
                  }
  
                  var year = this._validateYear(date);
                  var monthIndex = date.month();
  
                  var month = '' + this.toChineseMonth(year, monthIndex);
  
                  if (padded && month.length < 2) {
                      month = "0" + month;
                  }
  
                  if (this.isIntercalaryMonth(year, monthIndex)) {
                      month += 'i';
                  }
  
                  return month;
              },
              monthNames: function(date) {
                  if (typeof date === 'string') {
                      var match = date.match(MONTH_NAME_REGEXP);
                      return (match) ? match[0] : '';
                  }
  
                  var year = this._validateYear(date);
                  var monthIndex = date.month();
  
                  var month = this.toChineseMonth(year, monthIndex);
  
                  var monthName = ['一月','二月','三月','四月','五月','六月',
                      '七月','八月','九月','十月','十一月','十二月'][month - 1];
  
                  if (this.isIntercalaryMonth(year, monthIndex)) {
                      monthName = '闰' + monthName;
                  }
  
                  return monthName;
              },
              monthNamesShort: function(date) {
                  if (typeof date === 'string') {
                      var match = date.match(MONTH_SHORT_NAME_REGEXP);
                      return (match) ? match[0] : '';
                  }
  
                  var year = this._validateYear(date);
                  var monthIndex = date.month();
  
                  var month = this.toChineseMonth(year, monthIndex);
  
                  var monthName = ['一','二','三','四','五','六',
                      '七','八','九','十','十一','十二'][month - 1];
  
                  if (this.isIntercalaryMonth(year, monthIndex)) {
                      monthName = '闰' + monthName;
                  }
  
                  return monthName;
              },
              parseMonth: function(year, monthString) {
                  year = this._validateYear(year);
                  var month = parseInt(monthString);
                  var isIntercalary;
  
                  if (!isNaN(month)) {
                      var i = monthString[monthString.length - 1];
                      isIntercalary = (i === 'i' || i === 'I');
                  } else {
                      if (monthString[0] === '闰') {
                          isIntercalary = true;
                          monthString = monthString.substring(1);
                      }
                      if (monthString[monthString.length - 1] === '月') {
                          monthString = monthString.substring(0, monthString.length - 1);
                      }
                      month = 1 +
                          ['一','二','三','四','五','六',
                          '七','八','九','十','十一','十二'].indexOf(monthString);
                  }
  
                  var monthIndex = this.toMonthIndex(year, month, isIntercalary);
                  return monthIndex;
              },
              dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
              dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
              digits: null,
              dateFormat: 'yyyy/mm/dd',
              firstDay: 1,
              isRTL: false
          }
      },
  
      /** Check that a candidate date is from the same calendar and is valid.
          @memberof BaseCalendar
          @private
          @param year {CDate|number} The date or the year to validate.
          @param error {string} Error message if invalid.
          @return {number} The year.
          @throws Error if year out of range. */
      _validateYear: function(year, error) {
          if (year.year) {
              year = year.year();
          }
  
          if (typeof year !== 'number' || year < 1888 || year > 2111) {
              throw error.replace(/\{0\}/, this.local.name);
          }
  
          return year;
      },
  
      /** Retrieve the month index (i.e. accounting for intercalary months).
          @memberof ChineseCalendar
          @param year {number} The year.
          @param month {number} The month (1 for first month).
          @param [isIntercalary=false] {boolean} If month is intercalary.
          @return {number} The month index (0 for first month).
          @throws Error if an invalid month/year or a different calendar used. */
      toMonthIndex: function(year, month, isIntercalary) {
          // compute intercalary month in the year (0 if none)
          var intercalaryMonth = this.intercalaryMonth(year);
  
          // validate month
          var invalidIntercalaryMonth = 
              (isIntercalary && month !== intercalaryMonth);
          if (invalidIntercalaryMonth || month < 1 || month > 12) {
              throw main.local.invalidMonth
                  .replace(/\{0\}/, this.local.name);
          }
  
          // compute month index
          var monthIndex;
  
          if (!intercalaryMonth) {
              monthIndex = month - 1;
          } else if(!isIntercalary && month <= intercalaryMonth) {
              monthIndex = month - 1;
          } else {
              monthIndex = month;
          }
  
          return monthIndex;
      },
  
      /** Retrieve the month (i.e. accounting for intercalary months).
          @memberof ChineseCalendar
          @param year {CDate|number} The date or the year to examine.
          @param monthIndex {number} The month index (0 for first month).
          @return {number} The month (1 for first month).
          @throws Error if an invalid month/year or a different calendar used. */
      toChineseMonth: function(year, monthIndex) {
          if (year.year) {
              year = year.year();
              monthIndex = year.month();
          }
  
          // compute intercalary month in the year (0 if none)
          var intercalaryMonth = this.intercalaryMonth(year);
  
          // validate month
          var maxMonthIndex = (intercalaryMonth) ? 12 : 11;
          if (monthIndex < 0 || monthIndex > maxMonthIndex) {
              throw main.local.invalidMonth
                  .replace(/\{0\}/, this.local.name);
          }
  
          // compute Chinese month
          var month;
  
          if (!intercalaryMonth) {
              month = monthIndex + 1;
          } else if(monthIndex < intercalaryMonth) {
              month = monthIndex + 1;
          } else {
              month = monthIndex;
          }
  
          return month;
      },
  
      /** Determine the intercalary month of a year (if any).
          @memberof ChineseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The intercalary month number, or 0 if none.
          @throws Error if an invalid year or a different calendar used. */
      intercalaryMonth: function(year) {
          year = this._validateYear(year);
  
          var monthDaysTable = LUNAR_MONTH_DAYS[year - LUNAR_MONTH_DAYS[0]];
          var intercalaryMonth = monthDaysTable >> 13;
  
          return intercalaryMonth;
      },
  
      /** Determine whether this date is an intercalary month.
          @memberof ChineseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [monthIndex] {number} The month index to examine.
          @return {boolean} <code>true</code> if this is an intercalary month, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      isIntercalaryMonth: function(year, monthIndex) {
          if (year.year) {
              year = year.year();
              monthIndex = year.month();
          }
  
          var intercalaryMonth = this.intercalaryMonth(year);
  
          return !!intercalaryMonth && intercalaryMonth === monthIndex;
      },
  
      /** Determine whether this date is in a leap year.
          @memberof ChineseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          return (this.intercalaryMonth(year) !== 0);
      },
  
      /** Determine the week of the year for a date - ISO 8601.
          @memberof ChineseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [monthIndex] {number} The month index to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, monthIndex, day) {
          // compute Chinese new year
          var validatedYear =
              this._validateYear(year, main.local.invalidyear);
          var packedDate =
              CHINESE_NEW_YEAR[validatedYear - CHINESE_NEW_YEAR[0]];
  
          var y = (packedDate >> 9) & 0xFFF;
          var m = (packedDate >> 5) & 0x0F;
          var d = packedDate & 0x1F;
          
          // find first Thrusday of the year
          var firstThursday;
          firstThursday = gregorianCalendar.newDate(y, m, d);
          firstThursday.add(4 - (firstThursday.dayOfWeek() || 7), 'd');
  
          // compute days from first Thursday
          var offset =
              this.toJD(year, monthIndex, day) - firstThursday.toJD();
          return 1 + Math.floor(offset / 7);
      },
  
      /** Retrieve the number of months in a year.
          @memberof ChineseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of months.
          @throws Error if an invalid year or a different calendar used. */
      monthsInYear: function(year) {
          return (this.leapYear(year)) ? 13 : 12;
      },
  
      /** Retrieve the number of days in a month.
          @memberof ChineseCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [monthIndex] {number} The month index.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, monthIndex) {
          if (year.year) {
              monthIndex = year.month();
              year = year.year();
          }
  
          year = this._validateYear(year);
  
          var monthDaysTable = LUNAR_MONTH_DAYS[year - LUNAR_MONTH_DAYS[0]];
  
          var intercalaryMonth = monthDaysTable >> 13;
          var maxMonthIndex = (intercalaryMonth) ? 12 : 11;
          if (monthIndex > maxMonthIndex) {
              throw main.local.invalidMonth
                  .replace(/\{0\}/, this.local.name);
          }
  
          var daysInMonth = (monthDaysTable & (1 << (12 - monthIndex))) ?
              30 : 29;
  
          return daysInMonth;
      },
  
      /** Determine whether this date is a week day.
          @memberof ChineseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [monthIndex] {number} The month index to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, monthIndex, day) {
          return (this.dayOfWeek(year, monthIndex, day) || 7) < 6;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof ChineseCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [monthIndex] {number} The month index to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, monthIndex, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          year = this._validateYear(date.year());
          monthIndex = date.month();
          day = date.day();
  
          var isIntercalary = this.isIntercalaryMonth(year, monthIndex);
          var month = this.toChineseMonth(year, monthIndex);
  
          var solar = toSolar(year, month, day, isIntercalary);
  
          return gregorianCalendar.toJD(solar.year, solar.month, solar.day);
      },
  
      /** Create a new date from a Julian date.
          @memberof ChineseCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          var date = gregorianCalendar.fromJD(jd);
          var lunar = toLunar(date.year(), date.month(), date.day());
          var monthIndex = this.toMonthIndex(
              lunar.year, lunar.month, lunar.isIntercalary);
          return this.newDate(lunar.year, monthIndex, lunar.day);
      },
  
      /** Create a new date from a string.
          @memberof ChineseCalendar
          @param dateString {string} String representing a Chinese date
          @return {CDate} The new date.
          @throws Error if an invalid date. */
      fromString: function(dateString) {
          var match = dateString.match(DATE_REGEXP);
  
          var year = this._validateYear(+match[1]);
  
          var month = +match[2];
          var isIntercalary = !!match[3];
          var monthIndex = this.toMonthIndex(year, month, isIntercalary);
  
          var day = +match[4];
  
          return this.newDate(year, monthIndex, day);
      },
  
      /** Add period(s) to a date.
          Cater for no year zero.
          @memberof ChineseCalendar
          @param date {CDate} The starting date.
          @param offset {number} The number of periods to adjust by.
          @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
          @return {CDate} The updated date.
          @throws Error if a different calendar used. */
      add: function(date, offset, period) {
          var year = date.year();
          var monthIndex = date.month();
          var isIntercalary = this.isIntercalaryMonth(year, monthIndex);
          var month = this.toChineseMonth(year, monthIndex);
  
          var cdate = Object.getPrototypeOf(ChineseCalendar.prototype)
              .add.call(this, date, offset, period);
  
          if (period === 'y') {
              // Resync month
              var resultYear = cdate.year();
              var resultMonthIndex = cdate.month();
  
              // Using the fact the month index of an intercalary month
              // equals its month number:
              var resultCanBeIntercalaryMonth =
                  this.isIntercalaryMonth(resultYear, month);
  
              var correctedMonthIndex =
                  (isIntercalary && resultCanBeIntercalaryMonth) ?
                  this.toMonthIndex(resultYear, month, true) :
                  this.toMonthIndex(resultYear, month, false);
  
              if (correctedMonthIndex !== resultMonthIndex) {
                  cdate.month(correctedMonthIndex);
              }
          }
  
          return cdate;
      },
  });
  
  // Used by ChineseCalendar.prototype.fromString
  var DATE_REGEXP = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m;
  var MONTH_NUMBER_REGEXP = /^\d?\d[iI]?/m;
  var MONTH_NAME_REGEXP = /^闰?十?[一二三四五六七八九]?月/m;
  var MONTH_SHORT_NAME_REGEXP = /^闰?十?[一二三四五六七八九]?/m;
  
  // Chinese calendar implementation
  main.calendars.chinese = ChineseCalendar;
  
  // Chinese calendar tables from year 1888 to 2111
  //
  // Source:
  // https://github.com/isee15/Lunar-Solar-Calendar-Converter.git
  
  // Table of intercalary months and days per month from year 1888 to 2111
  //
  // bit (12 - i):        days in the i^th month
  //                      (= 0 if i^th lunar month has 29 days)
  //                      (= 1 if i^th lunar month has 30 days)
  //                      (first month in lunar year is i = 0)
  // bits (13,14,15,16):  intercalary month
  //                      (= 0 if lunar year has no intercalary month)
  var LUNAR_MONTH_DAYS = [1887, 0x1694, 0x16aa, 0x4ad5,
      0xab6, 0xc4b7, 0x4ae, 0xa56, 0xb52a, 0x1d2a, 0xd54, 0x75aa, 0x156a,
      0x1096d, 0x95c, 0x14ae, 0xaa4d, 0x1a4c, 0x1b2a, 0x8d55, 0xad4,
      0x135a, 0x495d, 0x95c, 0xd49b, 0x149a, 0x1a4a, 0xbaa5, 0x16a8,
      0x1ad4, 0x52da, 0x12b6, 0xe937, 0x92e, 0x1496, 0xb64b, 0xd4a,
      0xda8, 0x95b5, 0x56c, 0x12ae, 0x492f, 0x92e, 0xcc96, 0x1a94,
      0x1d4a, 0xada9, 0xb5a, 0x56c, 0x726e, 0x125c, 0xf92d, 0x192a,
      0x1a94, 0xdb4a, 0x16aa, 0xad4, 0x955b, 0x4ba, 0x125a, 0x592b,
      0x152a, 0xf695, 0xd94, 0x16aa, 0xaab5, 0x9b4, 0x14b6, 0x6a57,
      0xa56, 0x1152a, 0x1d2a, 0xd54, 0xd5aa, 0x156a, 0x96c, 0x94ae,
      0x14ae, 0xa4c, 0x7d26, 0x1b2a, 0xeb55, 0xad4, 0x12da, 0xa95d,
      0x95a, 0x149a, 0x9a4d, 0x1a4a, 0x11aa5, 0x16a8, 0x16d4, 0xd2da,
      0x12b6, 0x936, 0x9497, 0x1496, 0x1564b, 0xd4a, 0xda8, 0xd5b4,
      0x156c, 0x12ae, 0xa92f, 0x92e, 0xc96, 0x6d4a, 0x1d4a, 0x10d65,
      0xb58, 0x156c, 0xb26d, 0x125c, 0x192c, 0x9a95, 0x1a94, 0x1b4a,
      0x4b55, 0xad4, 0xf55b, 0x4ba, 0x125a, 0xb92b, 0x152a, 0x1694,
      0x96aa, 0x15aa, 0x12ab5, 0x974, 0x14b6, 0xca57, 0xa56, 0x1526,
      0x8e95, 0xd54, 0x15aa, 0x49b5, 0x96c, 0xd4ae, 0x149c, 0x1a4c,
      0xbd26, 0x1aa6, 0xb54, 0x6d6a, 0x12da, 0x1695d, 0x95a, 0x149a,
      0xda4b, 0x1a4a, 0x1aa4, 0xbb54, 0x16b4, 0xada, 0x495b, 0x936,
      0xf497, 0x1496, 0x154a, 0xb6a5, 0xda4, 0x15b4, 0x6ab6, 0x126e,
      0x1092f, 0x92e, 0xc96, 0xcd4a, 0x1d4a, 0xd64, 0x956c, 0x155c,
      0x125c, 0x792e, 0x192c, 0xfa95, 0x1a94, 0x1b4a, 0xab55, 0xad4,
      0x14da, 0x8a5d, 0xa5a, 0x1152b, 0x152a, 0x1694, 0xd6aa, 0x15aa,
      0xab4, 0x94ba, 0x14b6, 0xa56, 0x7527, 0xd26, 0xee53, 0xd54, 0x15aa,
      0xa9b5, 0x96c, 0x14ae, 0x8a4e, 0x1a4c, 0x11d26, 0x1aa4, 0x1b54,
      0xcd6a, 0xada, 0x95c, 0x949d, 0x149a, 0x1a2a, 0x5b25, 0x1aa4,
      0xfb52, 0x16b4, 0xaba, 0xa95b, 0x936, 0x1496, 0x9a4b, 0x154a,
      0x136a5, 0xda4, 0x15ac];
  
  // Table of Chinese New Years from year 1888 to 2111
  // 
  // bits (0 to 4):   solar day
  // bits (5 to 8):   solar month
  // bits (9 to 20):  solar year
  var CHINESE_NEW_YEAR = [1887, 0xec04c, 0xec23f, 0xec435, 0xec649,
      0xec83e, 0xeca51, 0xecc46, 0xece3a, 0xed04d, 0xed242, 0xed436,
      0xed64a, 0xed83f, 0xeda53, 0xedc48, 0xede3d, 0xee050, 0xee244,
      0xee439, 0xee64d, 0xee842, 0xeea36, 0xeec4a, 0xeee3e, 0xef052,
      0xef246, 0xef43a, 0xef64e, 0xef843, 0xefa37, 0xefc4b, 0xefe41,
      0xf0054, 0xf0248, 0xf043c, 0xf0650, 0xf0845, 0xf0a38, 0xf0c4d,
      0xf0e42, 0xf1037, 0xf124a, 0xf143e, 0xf1651, 0xf1846, 0xf1a3a,
      0xf1c4e, 0xf1e44, 0xf2038, 0xf224b, 0xf243f, 0xf2653, 0xf2848,
      0xf2a3b, 0xf2c4f, 0xf2e45, 0xf3039, 0xf324d, 0xf3442, 0xf3636,
      0xf384a, 0xf3a3d, 0xf3c51, 0xf3e46, 0xf403b, 0xf424e, 0xf4443,
      0xf4638, 0xf484c, 0xf4a3f, 0xf4c52, 0xf4e48, 0xf503c, 0xf524f,
      0xf5445, 0xf5639, 0xf584d, 0xf5a42, 0xf5c35, 0xf5e49, 0xf603e,
      0xf6251, 0xf6446, 0xf663b, 0xf684f, 0xf6a43, 0xf6c37, 0xf6e4b,
      0xf703f, 0xf7252, 0xf7447, 0xf763c, 0xf7850, 0xf7a45, 0xf7c39,
      0xf7e4d, 0xf8042, 0xf8254, 0xf8449, 0xf863d, 0xf8851, 0xf8a46,
      0xf8c3b, 0xf8e4f, 0xf9044, 0xf9237, 0xf944a, 0xf963f, 0xf9853,
      0xf9a47, 0xf9c3c, 0xf9e50, 0xfa045, 0xfa238, 0xfa44c, 0xfa641,
      0xfa836, 0xfaa49, 0xfac3d, 0xfae52, 0xfb047, 0xfb23a, 0xfb44e,
      0xfb643, 0xfb837, 0xfba4a, 0xfbc3f, 0xfbe53, 0xfc048, 0xfc23c,
      0xfc450, 0xfc645, 0xfc839, 0xfca4c, 0xfcc41, 0xfce36, 0xfd04a,
      0xfd23d, 0xfd451, 0xfd646, 0xfd83a, 0xfda4d, 0xfdc43, 0xfde37,
      0xfe04b, 0xfe23f, 0xfe453, 0xfe648, 0xfe83c, 0xfea4f, 0xfec44,
      0xfee38, 0xff04c, 0xff241, 0xff436, 0xff64a, 0xff83e, 0xffa51,
      0xffc46, 0xffe3a, 0x10004e, 0x100242, 0x100437, 0x10064b, 0x100841,
      0x100a53, 0x100c48, 0x100e3c, 0x10104f, 0x101244, 0x101438,
      0x10164c, 0x101842, 0x101a35, 0x101c49, 0x101e3d, 0x102051,
      0x102245, 0x10243a, 0x10264e, 0x102843, 0x102a37, 0x102c4b,
      0x102e3f, 0x103053, 0x103247, 0x10343b, 0x10364f, 0x103845,
      0x103a38, 0x103c4c, 0x103e42, 0x104036, 0x104249, 0x10443d,
      0x104651, 0x104846, 0x104a3a, 0x104c4e, 0x104e43, 0x105038,
      0x10524a, 0x10543e, 0x105652, 0x105847, 0x105a3b, 0x105c4f,
      0x105e45, 0x106039, 0x10624c, 0x106441, 0x106635, 0x106849,
      0x106a3d, 0x106c51, 0x106e47, 0x10703c, 0x10724f, 0x107444,
      0x107638, 0x10784c, 0x107a3f, 0x107c53, 0x107e48];
  
  function toLunar(yearOrDate, monthOrResult, day, result) {
      var solarDate;
      var lunarDate;
  
      if(typeof yearOrDate === 'object') {
          solarDate = yearOrDate;
          lunarDate = monthOrResult || {};
  
      } else {
          var isValidYear = (typeof yearOrDate === 'number') &&
              (yearOrDate >= 1888) && (yearOrDate <= 2111);
          if(!isValidYear)
              throw new Error("Solar year outside range 1888-2111");
  
          var isValidMonth = (typeof monthOrResult === 'number') &&
              (monthOrResult >= 1) && (monthOrResult <= 12);
          if(!isValidMonth)
              throw new Error("Solar month outside range 1 - 12");
  
          var isValidDay = (typeof day === 'number') && (day >= 1) && (day <= 31);
          if(!isValidDay)
              throw new Error("Solar day outside range 1 - 31");
  
          solarDate = {
              year: yearOrDate,
              month: monthOrResult,
              day: day,
          };
          lunarDate = result || {};
      }
  
      // Compute Chinese new year and lunar year
      var chineseNewYearPackedDate =
          CHINESE_NEW_YEAR[solarDate.year - CHINESE_NEW_YEAR[0]];
  
      var packedDate = (solarDate.year << 9) | (solarDate.month << 5)
          | solarDate.day;
  
      lunarDate.year = (packedDate >= chineseNewYearPackedDate) ?
          solarDate.year :
          solarDate.year - 1;
  
      chineseNewYearPackedDate =
          CHINESE_NEW_YEAR[lunarDate.year - CHINESE_NEW_YEAR[0]];
  
      var y = (chineseNewYearPackedDate >> 9) & 0xFFF;
      var m = (chineseNewYearPackedDate >> 5) & 0x0F;
      var d = chineseNewYearPackedDate & 0x1F;
  
      // Compute days from new year
      var daysFromNewYear;
  
      var chineseNewYearJSDate = new Date(y, m -1, d);
      var jsDate = new Date(solarDate.year, solarDate.month - 1, solarDate.day);
  
      daysFromNewYear = Math.round(
          (jsDate - chineseNewYearJSDate) / (24 * 3600 * 1000));
  
      // Compute lunar month and day
      var monthDaysTable = LUNAR_MONTH_DAYS[lunarDate.year - LUNAR_MONTH_DAYS[0]];
  
      var i;
      for(i = 0; i < 13; i++) {
          var daysInMonth = (monthDaysTable & (1 << (12 - i))) ? 30 : 29;
  
          if (daysFromNewYear < daysInMonth) {
              break;
          }
  
          daysFromNewYear -= daysInMonth;
      }
  
      var intercalaryMonth = monthDaysTable >> 13;
      if (!intercalaryMonth || i < intercalaryMonth) {
          lunarDate.isIntercalary = false;
          lunarDate.month = 1 + i;
      } else if (i === intercalaryMonth) {
          lunarDate.isIntercalary = true;
          lunarDate.month = i;
      } else {
          lunarDate.isIntercalary = false;
          lunarDate.month = i;
      }
  
      lunarDate.day = 1 + daysFromNewYear;
  
      return lunarDate;
  }
  
  function toSolar(yearOrDate, monthOrResult, day, isIntercalaryOrResult, result) {
      var solarDate;
      var lunarDate;
  
      if(typeof yearOrDate === 'object') {
          lunarDate = yearOrDate;
          solarDate = monthOrResult || {};
  
      } else {
          var isValidYear = (typeof yearOrDate === 'number') &&
              (yearOrDate >= 1888) && (yearOrDate <= 2111);
          if(!isValidYear)
              throw new Error("Lunar year outside range 1888-2111");
  
          var isValidMonth = (typeof monthOrResult === 'number') &&
              (monthOrResult >= 1) && (monthOrResult <= 12);
          if(!isValidMonth)
              throw new Error("Lunar month outside range 1 - 12");
  
          var isValidDay = (typeof day === 'number') && (day >= 1) && (day <= 30);
          if(!isValidDay)
              throw new Error("Lunar day outside range 1 - 30");
  
          var isIntercalary;
          if(typeof isIntercalaryOrResult === 'object') {
              isIntercalary = false;
              solarDate = isIntercalaryOrResult;
          } else {
              isIntercalary = !!isIntercalaryOrResult;
              solarDate = result || {};
          }
  
          lunarDate = {
              year: yearOrDate,
              month: monthOrResult,
              day: day,
              isIntercalary: isIntercalary,
          };
      }
  
      // Compute days from new year
      var daysFromNewYear;
  
      daysFromNewYear = lunarDate.day - 1;
  
      var monthDaysTable = LUNAR_MONTH_DAYS[lunarDate.year - LUNAR_MONTH_DAYS[0]];
      var intercalaryMonth = monthDaysTable >> 13;
  
      var monthsFromNewYear;
      if (!intercalaryMonth) {
          monthsFromNewYear = lunarDate.month - 1;
      } else if (lunarDate.month > intercalaryMonth) {
          monthsFromNewYear = lunarDate.month;
      } else if (lunarDate.isIntercalary) {
          monthsFromNewYear = lunarDate.month;
      } else {
          monthsFromNewYear = lunarDate.month - 1;
      }
  
      for(var i = 0; i < monthsFromNewYear; i++) {
          var daysInMonth = (monthDaysTable & (1 << (12 - i))) ? 30 : 29;
          daysFromNewYear += daysInMonth;
      }
  
      // Compute Chinese new year
      var packedDate = CHINESE_NEW_YEAR[lunarDate.year - CHINESE_NEW_YEAR[0]];
  
      var y = (packedDate >> 9) & 0xFFF;
      var m = (packedDate >> 5) & 0x0F;
      var d = packedDate & 0x1F;
  
      // Compute solar date
      var jsDate = new Date(y, m - 1, d + daysFromNewYear);
  
      solarDate.year = jsDate.getFullYear();
      solarDate.month = 1 + jsDate.getMonth();
      solarDate.day = jsDate.getDate();
  
      return solarDate;
  }
  
  
  },{"../main":593,"object-assign":473}],580:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Coptic calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Coptic calendar.
      See <a href="http://en.wikipedia.org/wiki/Coptic_calendar">http://en.wikipedia.org/wiki/Coptic_calendar</a>.
      See also Calendrical Calculations: The Millennium Edition
      (<a href="http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml">http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml</a>).
      @class CopticCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function CopticCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  CopticCalendar.prototype = new main.baseCalendar;
  
  assign(CopticCalendar.prototype, {
      /** The calendar name.
          @memberof CopticCalendar */
      name: 'Coptic',
      /** Julian date of start of Coptic epoch: 29 August 284 CE (Gregorian).
          @memberof CopticCalendar */
      jdEpoch: 1825029.5,
      /** Days per month in a common year.
          @memberof CopticCalendar */
      daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof CopticCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof CopticCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof CopticCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof CopticCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof CopticCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Coptic',
              epochs: ['BAM', 'AM'],
              monthNames: ['Thout', 'Paopi', 'Hathor', 'Koiak', 'Tobi', 'Meshir',
              'Paremhat', 'Paremoude', 'Pashons', 'Paoni', 'Epip', 'Mesori', 'Pi Kogi Enavot'],
              monthNamesShort: ['Tho', 'Pao', 'Hath', 'Koi', 'Tob', 'Mesh',
              'Pat', 'Pad', 'Pash', 'Pao', 'Epi', 'Meso', 'PiK'],
              dayNames: ['Tkyriaka', 'Pesnau', 'Pshoment', 'Peftoou', 'Ptiou', 'Psoou', 'Psabbaton'],
              dayNamesShort: ['Tky', 'Pes', 'Psh', 'Pef', 'Pti', 'Pso', 'Psa'],
              dayNamesMin: ['Tk', 'Pes', 'Psh', 'Pef', 'Pt', 'Pso', 'Psa'],
              digits: null,
              dateFormat: 'dd/mm/yyyy',
              firstDay: 0,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof CopticCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          var year = date.year() + (date.year() < 0 ? 1 : 0); // No year zero
          return year % 4 === 3 || year % 4 === -1;
      },
  
      /** Retrieve the number of months in a year.
          @memberof CopticCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of months.
          @throws Error if an invalid year or a different calendar used. */
      monthsInYear: function(year) {
          this._validate(year, this.minMonth, this.minDay,
              main.local.invalidYear || main.regionalOptions[''].invalidYear);
          return 13;
      },
  
      /** Determine the week of the year for a date.
          @memberof CopticCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number) the month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Sunday of this week starting on Sunday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(-checkDate.dayOfWeek(), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a month.
          @memberof CopticCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          return this.daysPerMonth[date.month() - 1] +
              (date.month() === 13 && this.leapYear(date.year()) ? 1 : 0);
      },
  
      /** Determine whether this date is a week day.
          @memberof CopticCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param month {number} The month to examine.
          @param day {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return (this.dayOfWeek(year, month, day) || 7) < 6;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof CopticCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number) the month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          year = date.year();
          if (year < 0) { year++; } // No year zero
          return date.day() + (date.month() - 1) * 30 +
              (year - 1) * 365 + Math.floor(year / 4) + this.jdEpoch - 1;
      },
  
      /** Create a new date from a Julian date.
          @memberof CopticCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          var c = Math.floor(jd) + 0.5 - this.jdEpoch;
          var year = Math.floor((c - Math.floor((c + 366) / 1461)) / 365) + 1;
          if (year <= 0) { year--; } // No year zero
          c = Math.floor(jd) + 0.5 - this.newDate(year, 1, 1).toJD();
          var month = Math.floor(c / 30) + 1;
          var day = c - (month - 1) * 30 + 1;
          return this.newDate(year, month, day);
      }
  });
  
  // Coptic calendar implementation
  main.calendars.coptic = CopticCalendar;
  
  
  },{"../main":593,"object-assign":473}],581:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Discworld calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) January 2016.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Discworld calendar - Unseen University version.
      See also <a href="http://wiki.lspace.org/mediawiki/Discworld_calendar">http://wiki.lspace.org/mediawiki/Discworld_calendar</a>
      and <a href="http://discworld.wikia.com/wiki/Discworld_calendar">http://discworld.wikia.com/wiki/Discworld_calendar</a>.
      @class DiscworldCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function DiscworldCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  DiscworldCalendar.prototype = new main.baseCalendar;
  
  assign(DiscworldCalendar.prototype, {
      /** The calendar name.
          @memberof DiscworldCalendar */
      name: 'Discworld',
      /** Julian date of start of Discworld epoch: 1 January 0001 CE.
          @memberof DiscworldCalendar */
      jdEpoch: 1721425.5,
      /** Days per month in a common year.
          @memberof DiscworldCalendar */
      daysPerMonth: [16, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof DiscworldCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof DiscworldCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof DiscworldCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof DiscworldCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof DiscworldCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Discworld',
              epochs: ['BUC', 'UC'],
              monthNames: ['Ick', 'Offle', 'February', 'March', 'April', 'May', 'June',
              'Grune', 'August', 'Spune', 'Sektober', 'Ember', 'December'],
              monthNamesShort: ['Ick', 'Off', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Gru', 'Aug', 'Spu', 'Sek', 'Emb', 'Dec'],
              dayNames: ['Sunday', 'Octeday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
              dayNamesShort: ['Sun', 'Oct', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              dayNamesMin: ['Su', 'Oc', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
              digits: null,
              dateFormat: 'yyyy/mm/dd',
              firstDay: 2,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof DiscworldCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return false;
      },
  
      /** Retrieve the number of months in a year.
          @memberof DiscworldCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of months.
          @throws Error if an invalid year or a different calendar used. */
      monthsInYear: function(year) {
          this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return 13;
      },
  
      /** Retrieve the number of days in a year.
          @memberof DiscworldCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of days.
          @throws Error if an invalid year or a different calendar used. */
      daysInYear: function(year) {
          this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return 400;
      },
  
      /** Determine the week of the year for a date.
          @memberof DiscworldCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Sunday of this week starting on Sunday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(-checkDate.dayOfWeek(), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 8) + 1;
      },
  
      /** Retrieve the number of days in a month.
          @memberof DiscworldCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          return this.daysPerMonth[date.month() - 1];
      },
  
      /** Retrieve the number of days in a week.
          @memberof DiscworldCalendar
          @return {number} The number of days. */
      daysInWeek: function() {
          return 8;
      },
  
      /** Retrieve the day of the week for a date.
          @memberof DiscworldCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The day of the week: 0 to number of days - 1.
          @throws Error if an invalid date or a different calendar used. */
      dayOfWeek: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          return (date.day() + 1) % 8;
      },
  
      /** Determine whether this date is a week day.
          @memberof DiscworldCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          var dow = this.dayOfWeek(year, month, day);
          return (dow >= 2 && dow <= 6);
      },
  
      /** Retrieve additional information about a date.
          @memberof DiscworldCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {object} Additional information - contents depends on calendar.
          @throws Error if an invalid date or a different calendar used. */
      extraInfo: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          return {century: centuries[Math.floor((date.year() - 1) / 100) + 1] || ''};
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof DiscworldCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          year = date.year() + (date.year() < 0 ? 1 : 0);
          month = date.month();
          day = date.day();
          return day + (month > 1 ? 16 : 0) + (month > 2 ? (month - 2) * 32 : 0) +
              (year - 1) * 400 + this.jdEpoch - 1;
      },
  
      /** Create a new date from a Julian date.
          @memberof DiscworldCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          jd = Math.floor(jd + 0.5) - Math.floor(this.jdEpoch) - 1;
          var year = Math.floor(jd / 400) + 1;
          jd -= (year - 1) * 400;
          jd += (jd > 15 ? 16 : 0);
          var month = Math.floor(jd / 32) + 1;
          var day = jd - (month - 1) * 32 + 1;
          return this.newDate(year <= 0 ? year - 1 : year, month, day);
      }
  });
  
  // Names of the centuries
  var centuries = {
      20: 'Fruitbat',
      21: 'Anchovy'
  };
  
  // Discworld calendar implementation
  main.calendars.discworld = DiscworldCalendar;
  
  
  },{"../main":593,"object-assign":473}],582:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Ethiopian calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Ethiopian calendar.
      See <a href="http://en.wikipedia.org/wiki/Ethiopian_calendar">http://en.wikipedia.org/wiki/Ethiopian_calendar</a>.
      See also Calendrical Calculations: The Millennium Edition
      (<a href="http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml">http://emr.cs.iit.edu/home/reingold/calendar-book/index.shtml</a>).
      @class EthiopianCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function EthiopianCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  EthiopianCalendar.prototype = new main.baseCalendar;
  
  assign(EthiopianCalendar.prototype, {
      /** The calendar name.
          @memberof EthiopianCalendar */
      name: 'Ethiopian',
      /** Julian date of start of Ethiopian epoch: 27 August 8 CE (Gregorian).
          @memberof EthiopianCalendar */
      jdEpoch: 1724220.5,
      /** Days per month in a common year.
          @memberof EthiopianCalendar */
      daysPerMonth: [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 5],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof EthiopianCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof EthiopianCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof EthiopianCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof EthiopianCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof EthiopianCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Ethiopian',
              epochs: ['BEE', 'EE'],
              monthNames: ['Meskerem', 'Tikemet', 'Hidar', 'Tahesas', 'Tir', 'Yekatit',
              'Megabit', 'Miazia', 'Genbot', 'Sene', 'Hamle', 'Nehase', 'Pagume'],
              monthNamesShort: ['Mes', 'Tik', 'Hid', 'Tah', 'Tir', 'Yek',
              'Meg', 'Mia', 'Gen', 'Sen', 'Ham', 'Neh', 'Pag'],
              dayNames: ['Ehud', 'Segno', 'Maksegno', 'Irob', 'Hamus', 'Arb', 'Kidame'],
              dayNamesShort: ['Ehu', 'Seg', 'Mak', 'Iro', 'Ham', 'Arb', 'Kid'],
              dayNamesMin: ['Eh', 'Se', 'Ma', 'Ir', 'Ha', 'Ar', 'Ki'],
              digits: null,
              dateFormat: 'dd/mm/yyyy',
              firstDay: 0,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof EthiopianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          var year = date.year() + (date.year() < 0 ? 1 : 0); // No year zero
          return year % 4 === 3 || year % 4 === -1;
      },
  
      /** Retrieve the number of months in a year.
          @memberof EthiopianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of months.
          @throws Error if an invalid year or a different calendar used. */
      monthsInYear: function(year) {
          this._validate(year, this.minMonth, this.minDay,
              main.local.invalidYear || main.regionalOptions[''].invalidYear);
          return 13;
      },
  
      /** Determine the week of the year for a date.
          @memberof EthiopianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Sunday of this week starting on Sunday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(-checkDate.dayOfWeek(), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a month.
          @memberof EthiopianCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          return this.daysPerMonth[date.month() - 1] +
              (date.month() === 13 && this.leapYear(date.year()) ? 1 : 0);
      },
  
      /** Determine whether this date is a week day.
          @memberof EthiopianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return (this.dayOfWeek(year, month, day) || 7) < 6;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof EthiopianCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          year = date.year();
          if (year < 0) { year++; } // No year zero
          return date.day() + (date.month() - 1) * 30 +
              (year - 1) * 365 + Math.floor(year / 4) + this.jdEpoch - 1;
      },
  
      /** Create a new date from a Julian date.
          @memberof EthiopianCalendar
          @param jd {number} the Julian date to convert.
          @return {CDate} the equivalent date. */
      fromJD: function(jd) {
          var c = Math.floor(jd) + 0.5 - this.jdEpoch;
          var year = Math.floor((c - Math.floor((c + 366) / 1461)) / 365) + 1;
          if (year <= 0) { year--; } // No year zero
          c = Math.floor(jd) + 0.5 - this.newDate(year, 1, 1).toJD();
          var month = Math.floor(c / 30) + 1;
          var day = c - (month - 1) * 30 + 1;
          return this.newDate(year, month, day);
      }
  });
  
  // Ethiopian calendar implementation
  main.calendars.ethiopian = EthiopianCalendar;
  
  
  },{"../main":593,"object-assign":473}],583:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Hebrew calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Hebrew civil calendar.
      Based on code from <a href="http://www.fourmilab.ch/documents/calendar/">http://www.fourmilab.ch/documents/calendar/</a>.
      See also <a href="http://en.wikipedia.org/wiki/Hebrew_calendar">http://en.wikipedia.org/wiki/Hebrew_calendar</a>.
      @class HebrewCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function HebrewCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  HebrewCalendar.prototype = new main.baseCalendar;
  
  assign(HebrewCalendar.prototype, {
      /** The calendar name.
          @memberof HebrewCalendar */
      name: 'Hebrew',
      /** Julian date of start of Hebrew epoch: 7 October 3761 BCE.
          @memberof HebrewCalendar */
      jdEpoch: 347995.5,
      /** Days per month in a common year.
          @memberof HebrewCalendar */
      daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 29],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof HebrewCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof HebrewCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof HebrewCalendar */
      firstMonth: 7,
      /** The minimum day number.
          @memberof HebrewCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof HebrewCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Hebrew',
              epochs: ['BAM', 'AM'],
              monthNames: ['Nisan', 'Iyar', 'Sivan', 'Tammuz', 'Av', 'Elul',
              'Tishrei', 'Cheshvan', 'Kislev', 'Tevet', 'Shevat', 'Adar', 'Adar II'],
              monthNamesShort: ['Nis', 'Iya', 'Siv', 'Tam', 'Av', 'Elu', 'Tis', 'Che', 'Kis', 'Tev', 'She', 'Ada', 'Ad2'],
              dayNames: ['Yom Rishon', 'Yom Sheni', 'Yom Shlishi', 'Yom Revi\'i', 'Yom Chamishi', 'Yom Shishi', 'Yom Shabbat'],
              dayNamesShort: ['Ris', 'She', 'Shl', 'Rev', 'Cha', 'Shi', 'Sha'],
              dayNamesMin: ['Ri','She','Shl','Re','Ch','Shi','Sha'],
              digits: null,
              dateFormat: 'dd/mm/yyyy',
              firstDay: 0,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof HebrewCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return this._leapYear(date.year());
      },
  
      /** Determine whether this date is in a leap year.
          @memberof HebrewCalendar
          @private
          @param year {number} The year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      _leapYear: function(year) {
          year = (year < 0 ? year + 1 : year);
          return mod(year * 7 + 1, 19) < 7;
      },
  
      /** Retrieve the number of months in a year.
          @memberof HebrewCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of months.
          @throws Error if an invalid year or a different calendar used. */
      monthsInYear: function(year) {
          this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return this._leapYear(year.year ? year.year() : year) ? 13 : 12;
      },
  
      /** Determine the week of the year for a date.
          @memberof HebrewCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Sunday of this week starting on Sunday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(-checkDate.dayOfWeek(), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a year.
          @memberof HebrewCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of days.
          @throws Error if an invalid year or a different calendar used. */
      daysInYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          year = date.year();
          return this.toJD((year === -1 ? +1 : year + 1), 7, 1) - this.toJD(year, 7, 1);
      },
  
      /** Retrieve the number of days in a month.
          @memberof HebrewCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          if (year.year) {
              month = year.month();
              year = year.year();
          }
          this._validate(year, month, this.minDay, main.local.invalidMonth);
          return (month === 12 && this.leapYear(year) ? 30 : // Adar I
                  (month === 8 && mod(this.daysInYear(year), 10) === 5 ? 30 : // Cheshvan in shlemah year
                  (month === 9 && mod(this.daysInYear(year), 10) === 3 ? 29 : // Kislev in chaserah year
                  this.daysPerMonth[month - 1])));
      },
  
      /** Determine whether this date is a week day.
          @memberof HebrewCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return this.dayOfWeek(year, month, day) !== 6;
      },
  
      /** Retrieve additional information about a date - year type.
          @memberof HebrewCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {object} Additional information - contents depends on calendar.
          @throws Error if an invalid date or a different calendar used. */
      extraInfo: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          return {yearType: (this.leapYear(date) ? 'embolismic' : 'common') + ' ' +
              ['deficient', 'regular', 'complete'][this.daysInYear(date) % 10 - 3]};
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof HebrewCalendar
          @param year {CDate)|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          year = date.year();
          month = date.month();
          day = date.day();
          var adjYear = (year <= 0 ? year + 1 : year);
          var jd = this.jdEpoch + this._delay1(adjYear) +
              this._delay2(adjYear) + day + 1;
          if (month < 7) {
              for (var m = 7; m <= this.monthsInYear(year); m++) {
                  jd += this.daysInMonth(year, m);
              }
              for (var m = 1; m < month; m++) {
                  jd += this.daysInMonth(year, m);
              }
          }
          else {
              for (var m = 7; m < month; m++) {
                  jd += this.daysInMonth(year, m);
              }
          }
          return jd;
      },
  
      /** Test for delay of start of new year and to avoid
          Sunday, Wednesday, or Friday as start of the new year.
          @memberof HebrewCalendar
          @private
          @param year {number} The year to examine.
          @return {number} The days to offset by. */
      _delay1: function(year) {
          var months = Math.floor((235 * year - 234) / 19);
          var parts = 12084 + 13753 * months;
          var day = months * 29 + Math.floor(parts / 25920);
          if (mod(3 * (day + 1), 7) < 3) {
              day++;
          }
          return day;
      },
  
      /** Check for delay in start of new year due to length of adjacent years.
          @memberof HebrewCalendar
          @private
          @param year {number} The year to examine.
          @return {number} The days to offset by. */
      _delay2: function(year) {
          var last = this._delay1(year - 1);
          var present = this._delay1(year);
          var next = this._delay1(year + 1);
          return ((next - present) === 356 ? 2 : ((present - last) === 382 ? 1 : 0));
      },
  
      /** Create a new date from a Julian date.
          @memberof HebrewCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          jd = Math.floor(jd) + 0.5;
          var year = Math.floor(((jd - this.jdEpoch) * 98496.0) / 35975351.0) - 1;
          while (jd >= this.toJD((year === -1 ? +1 : year + 1), 7, 1)) {
              year++;
          }
          var month = (jd < this.toJD(year, 1, 1)) ? 7 : 1;
          while (jd > this.toJD(year, month, this.daysInMonth(year, month))) {
              month++;
          }
          var day = jd - this.toJD(year, month, 1) + 1;
          return this.newDate(year, month, day);
      }
  });
  
  // Modulus function which works for non-integers.
  function mod(a, b) {
      return a - (b * Math.floor(a / b));
  }
  
  // Hebrew calendar implementation
  main.calendars.hebrew = HebrewCalendar;
  
  
  },{"../main":593,"object-assign":473}],584:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Islamic calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Islamic or '16 civil' calendar.
      Based on code from <a href="http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php">http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php</a>.
      See also <a href="http://en.wikipedia.org/wiki/Islamic_calendar">http://en.wikipedia.org/wiki/Islamic_calendar</a>.
      @class IslamicCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function IslamicCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  IslamicCalendar.prototype = new main.baseCalendar;
  
  assign(IslamicCalendar.prototype, {
      /** The calendar name.
          @memberof IslamicCalendar */
      name: 'Islamic',
      /** Julian date of start of Islamic epoch: 16 July 622 CE.
          @memberof IslamicCalendar */
      jdEpoch: 1948439.5,
      /** Days per month in a common year.
          @memberof IslamicCalendar */
      daysPerMonth: [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof IslamicCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof IslamicCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof IslamicCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof IslamicCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof IslamicCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Islamic',
              epochs: ['BH', 'AH'],
              monthNames: ['Muharram', 'Safar', 'Rabi\' al-awwal', 'Rabi\' al-thani', 'Jumada al-awwal', 'Jumada al-thani',
              'Rajab', 'Sha\'aban', 'Ramadan', 'Shawwal', 'Dhu al-Qi\'dah', 'Dhu al-Hijjah'],
              monthNamesShort: ['Muh', 'Saf', 'Rab1', 'Rab2', 'Jum1', 'Jum2', 'Raj', 'Sha\'', 'Ram', 'Shaw', 'DhuQ', 'DhuH'],
              dayNames: ['Yawm al-ahad', 'Yawm al-ithnayn', 'Yawm ath-thulaathaa\'',
              'Yawm al-arbi\'aa\'', 'Yawm al-khamīs', 'Yawm al-jum\'a', 'Yawm as-sabt'],
              dayNamesShort: ['Aha', 'Ith', 'Thu', 'Arb', 'Kha', 'Jum', 'Sab'],
              dayNamesMin: ['Ah','It','Th','Ar','Kh','Ju','Sa'],
              digits: null,
              dateFormat: 'yyyy/mm/dd',
              firstDay: 6,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof IslamicCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return (date.year() * 11 + 14) % 30 < 11;
      },
  
      /** Determine the week of the year for a date.
          @memberof IslamicCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Sunday of this week starting on Sunday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(-checkDate.dayOfWeek(), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a year.
          @memberof IslamicCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of days.
          @throws Error if an invalid year or a different calendar used. */
      daysInYear: function(year) {
          return (this.leapYear(year) ? 355 : 354);
      },
  
      /** Retrieve the number of days in a month.
          @memberof IslamicCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          return this.daysPerMonth[date.month() - 1] +
              (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
      },
  
      /** Determine whether this date is a week day.
          @memberof IslamicCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return this.dayOfWeek(year, month, day) !== 5;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof IslamicCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          year = date.year();
          month = date.month();
          day = date.day();
          year = (year <= 0 ? year + 1 : year);
          return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 +
              Math.floor((3 + (11 * year)) / 30) + this.jdEpoch - 1;
      },
  
      /** Create a new date from a Julian date.
          @memberof IslamicCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          jd = Math.floor(jd) + 0.5;
          var year = Math.floor((30 * (jd - this.jdEpoch) + 10646) / 10631);
          year = (year <= 0 ? year - 1 : year);
          var month = Math.min(12, Math.ceil((jd - 29 - this.toJD(year, 1, 1)) / 29.5) + 1);
          var day = jd - this.toJD(year, month, 1) + 1;
          return this.newDate(year, month, day);
      }
  });
  
  // Islamic (16 civil) calendar implementation
  main.calendars.islamic = IslamicCalendar;
  
  
  },{"../main":593,"object-assign":473}],585:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Julian calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Julian calendar.
      Based on code from <a href="http://www.fourmilab.ch/documents/calendar/">http://www.fourmilab.ch/documents/calendar/</a>.
      See also <a href="http://en.wikipedia.org/wiki/Julian_calendar">http://en.wikipedia.org/wiki/Julian_calendar</a>.
      @class JulianCalendar
      @augments BaseCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function JulianCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  JulianCalendar.prototype = new main.baseCalendar;
  
  assign(JulianCalendar.prototype, {
      /** The calendar name.
          @memberof JulianCalendar */
      name: 'Julian',
      /** Julian date of start of Julian epoch: 1 January 0001 AD = 30 December 0001 BCE.
          @memberof JulianCalendar */
      jdEpoch: 1721423.5,
      /** Days per month in a common year.
          @memberof JulianCalendar */
      daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof JulianCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof JulianCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof JulianCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof JulianCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof JulianCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Julian',
              epochs: ['BC', 'AD'],
              monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'],
              monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
              dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
              digits: null,
              dateFormat: 'mm/dd/yyyy',
              firstDay: 0,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof JulianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          var year = (date.year() < 0 ? date.year() + 1 : date.year()); // No year zero
          return (year % 4) === 0;
      },
  
      /** Determine the week of the year for a date - ISO 8601.
          @memberof JulianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Thursday of this week starting on Monday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(4 - (checkDate.dayOfWeek() || 7), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a month.
          @memberof JulianCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          return this.daysPerMonth[date.month() - 1] +
              (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
      },
  
      /** Determine whether this date is a week day.
          @memberof JulianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} True if a week day, false if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return (this.dayOfWeek(year, month, day) || 7) < 6;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof JulianCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          year = date.year();
          month = date.month();
          day = date.day();
          if (year < 0) { year++; } // No year zero
          // Jean Meeus algorithm, "Astronomical Algorithms", 1991
          if (month <= 2) {
              year--;
              month += 12;
          }
          return Math.floor(365.25 * (year + 4716)) +
              Math.floor(30.6001 * (month + 1)) + day - 1524.5;
      },
  
      /** Create a new date from a Julian date.
          @memberof JulianCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          // Jean Meeus algorithm, "Astronomical Algorithms", 1991
          var a = Math.floor(jd + 0.5);
          var b = a + 1524;
          var c = Math.floor((b - 122.1) / 365.25);
          var d = Math.floor(365.25 * c);
          var e = Math.floor((b - d) / 30.6001);
          var month = e - Math.floor(e < 14 ? 1 : 13);
          var year = c - Math.floor(month > 2 ? 4716 : 4715);
          var day = b - d - Math.floor(30.6001 * e);
          if (year <= 0) { year--; } // No year zero
          return this.newDate(year, month, day);
      }
  });
  
  // Julian calendar implementation
  main.calendars.julian = JulianCalendar;
  
  
  },{"../main":593,"object-assign":473}],586:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Mayan calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Mayan Long Count calendar.
      See also <a href="http://en.wikipedia.org/wiki/Mayan_calendar">http://en.wikipedia.org/wiki/Mayan_calendar</a>.
      @class MayanCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function MayanCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  MayanCalendar.prototype = new main.baseCalendar;
  
  assign(MayanCalendar.prototype, {
      /** The calendar name.
          @memberof MayanCalendar */
      name: 'Mayan',
      /** Julian date of start of Mayan epoch: 11 August 3114 BCE.
          @memberof MayanCalendar */
      jdEpoch: 584282.5,
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof MayanCalendar */
      hasYearZero: true,
      /** The minimum month number.
          @memberof MayanCalendar */
      minMonth: 0,
      /** The first month in the year.
          @memberof MayanCalendar */
      firstMonth: 0,
      /** The minimum day number.
          @memberof MayanCalendar */
      minDay: 0,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof MayanCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left.
          @property haabMonths {string[]} The names of the Haab months.
          @property tzolkinMonths {string[]} The names of the Tzolkin months. */
      regionalOptions: { // Localisations
          '': {
              name: 'Mayan',
              epochs: ['', ''],
              monthNames: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
              '10', '11', '12', '13', '14', '15', '16', '17'],
              monthNamesShort: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
              '10', '11', '12', '13', '14', '15', '16', '17'],
              dayNames: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
              '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
              dayNamesShort: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
              '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
              dayNamesMin: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
              '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
              digits: null,
              dateFormat: 'YYYY.m.d',
              firstDay: 0,
              isRTL: false,
              haabMonths: ['Pop', 'Uo', 'Zip', 'Zotz', 'Tzec', 'Xul', 'Yaxkin', 'Mol', 'Chen', 'Yax',
              'Zac', 'Ceh', 'Mac', 'Kankin', 'Muan', 'Pax', 'Kayab', 'Cumku', 'Uayeb'],
              tzolkinMonths: ['Imix', 'Ik', 'Akbal', 'Kan', 'Chicchan', 'Cimi', 'Manik', 'Lamat', 'Muluc', 'Oc',
              'Chuen', 'Eb', 'Ben', 'Ix', 'Men', 'Cib', 'Caban', 'Etznab', 'Cauac', 'Ahau']
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof MayanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return false;
      },
  
      /** Format the year, if not a simple sequential number.
          @memberof MayanCalendar
          @param year {CDate|number} The date to format or the year to format.
          @return {string} The formatted year.
          @throws Error if an invalid year or a different calendar used. */
      formatYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          year = date.year();
          var baktun = Math.floor(year / 400);
          year = year % 400;
          year += (year < 0 ? 400 : 0);
          var katun = Math.floor(year / 20);
          return baktun + '.' + katun + '.' + (year % 20);
      },
  
      /** Convert from the formatted year back to a single number.
          @memberof MayanCalendar
          @param years {string} The year as n.n.n.
          @return {number} The sequential year.
          @throws Error if an invalid value is supplied. */
      forYear: function(years) {
          years = years.split('.');
          if (years.length < 3) {
              throw 'Invalid Mayan year';
          }
          var year = 0;
          for (var i = 0; i < years.length; i++) {
              var y = parseInt(years[i], 10);
              if (Math.abs(y) > 19 || (i > 0 && y < 0)) {
                  throw 'Invalid Mayan year';
              }
              year = year * 20 + y;
          }
          return year;
      },
  
      /** Retrieve the number of months in a year.
          @memberof MayanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of months.
          @throws Error if an invalid year or a different calendar used. */
      monthsInYear: function(year) {
          this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return 18;
      },
  
      /** Determine the week of the year for a date.
          @memberof MayanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          this._validate(year, month, day, main.local.invalidDate);
          return 0;
      },
  
      /** Retrieve the number of days in a year.
          @memberof MayanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of days.
          @throws Error if an invalid year or a different calendar used. */
      daysInYear: function(year) {
          this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return 360;
      },
  
      /** Retrieve the number of days in a month.
          @memberof MayanCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          this._validate(year, month, this.minDay, main.local.invalidMonth);
          return 20;
      },
  
      /** Retrieve the number of days in a week.
          @memberof MayanCalendar
          @return {number} The number of days. */
      daysInWeek: function() {
          return 5; // Just for formatting
      },
  
      /** Retrieve the day of the week for a date.
          @memberof MayanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The day of the week: 0 to number of days - 1.
          @throws Error if an invalid date or a different calendar used. */
      dayOfWeek: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          return date.day();
      },
  
      /** Determine whether this date is a week day.
          @memberof MayanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          this._validate(year, month, day, main.local.invalidDate);
          return true;
      },
  
      /** Retrieve additional information about a date - Haab and Tzolkin equivalents.
          @memberof MayanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {object} Additional information - contents depends on calendar.
          @throws Error if an invalid date or a different calendar used. */
      extraInfo: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          var jd = date.toJD();
          var haab = this._toHaab(jd);
          var tzolkin = this._toTzolkin(jd);
          return {haabMonthName: this.local.haabMonths[haab[0] - 1],
              haabMonth: haab[0], haabDay: haab[1],
              tzolkinDayName: this.local.tzolkinMonths[tzolkin[0] - 1],
              tzolkinDay: tzolkin[0], tzolkinTrecena: tzolkin[1]};
      },
  
      /** Retrieve Haab date from a Julian date.
          @memberof MayanCalendar
          @private
          @param jd  {number} The Julian date.
          @return {number[]} Corresponding Haab month and day. */
      _toHaab: function(jd) {
          jd -= this.jdEpoch;
          var day = mod(jd + 8 + ((18 - 1) * 20), 365);
          return [Math.floor(day / 20) + 1, mod(day, 20)];
      },
  
      /** Retrieve Tzolkin date from a Julian date.
          @memberof MayanCalendar
          @private
          @param jd {number} The Julian date.
          @return {number[]} Corresponding Tzolkin day and trecena. */
      _toTzolkin: function(jd) {
          jd -= this.jdEpoch;
          return [amod(jd + 20, 20), amod(jd + 4, 13)];
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof MayanCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          return date.day() + (date.month() * 20) + (date.year() * 360) + this.jdEpoch;
      },
  
      /** Create a new date from a Julian date.
          @memberof MayanCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          jd = Math.floor(jd) + 0.5 - this.jdEpoch;
          var year = Math.floor(jd / 360);
          jd = jd % 360;
          jd += (jd < 0 ? 360 : 0);
          var month = Math.floor(jd / 20);
          var day = jd % 20;
          return this.newDate(year, month, day);
      }
  });
  
  // Modulus function which works for non-integers.
  function mod(a, b) {
      return a - (b * Math.floor(a / b));
  }
  
  // Modulus function which returns numerator if modulus is zero.
  function amod(a, b) {
      return mod(a - 1, b) + 1;
  }
  
  // Mayan calendar implementation
  main.calendars.mayan = MayanCalendar;
  
  
  },{"../main":593,"object-assign":473}],587:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  /* http://keith-wood.name/calendars.html
     Nanakshahi calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) January 2016.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Nanakshahi calendar.
      See also <a href="https://en.wikipedia.org/wiki/Nanakshahi_calendar">https://en.wikipedia.org/wiki/Nanakshahi_calendar</a>.
      @class NanakshahiCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function NanakshahiCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  NanakshahiCalendar.prototype = new main.baseCalendar;
  
  var gregorian = main.instance('gregorian');
  
  assign(NanakshahiCalendar.prototype, {
      /** The calendar name.
          @memberof NanakshahiCalendar */
      name: 'Nanakshahi',
      /** Julian date of start of Nanakshahi epoch: 14 March 1469 CE.
          @memberof NanakshahiCalendar */
      jdEpoch: 2257673.5,
      /** Days per month in a common year.
          @memberof NanakshahiCalendar */
      daysPerMonth: [31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 30, 30],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof NanakshahiCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof NanakshahiCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof NanakshahiCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof NanakshahiCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof NanakshahiCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Nanakshahi',
              epochs: ['BN', 'AN'],
              monthNames: ['Chet', 'Vaisakh', 'Jeth', 'Harh', 'Sawan', 'Bhadon',
              'Assu', 'Katak', 'Maghar', 'Poh', 'Magh', 'Phagun'],
              monthNamesShort: ['Che', 'Vai', 'Jet', 'Har', 'Saw', 'Bha', 'Ass', 'Kat', 'Mgr', 'Poh', 'Mgh', 'Pha'],
              dayNames: ['Somvaar', 'Mangalvar', 'Budhvaar', 'Veervaar', 'Shukarvaar', 'Sanicharvaar', 'Etvaar'],
              dayNamesShort: ['Som', 'Mangal', 'Budh', 'Veer', 'Shukar', 'Sanichar', 'Et'],
              dayNamesMin: ['So', 'Ma', 'Bu', 'Ve', 'Sh', 'Sa', 'Et'],
              digits: null,
              dateFormat: 'dd-mm-yyyy',
              firstDay: 0,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof NanakshahiCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay,
              main.local.invalidYear || main.regionalOptions[''].invalidYear);
          return gregorian.leapYear(date.year() + (date.year() < 1 ? 1 : 0) + 1469);
      },
  
      /** Determine the week of the year for a date.
          @memberof NanakshahiCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Monday of this week starting on Monday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(1 - (checkDate.dayOfWeek() || 7), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a month.
          @memberof NanakshahiCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          return this.daysPerMonth[date.month() - 1] +
              (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
      },
  
      /** Determine whether this date is a week day.
          @memberof NanakshahiCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return (this.dayOfWeek(year, month, day) || 7) < 6;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof NanakshahiCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidMonth);
          var year = date.year();
          if (year < 0) { year++; } // No year zero
          var doy = date.day();
          for (var m = 1; m < date.month(); m++) {
              doy += this.daysPerMonth[m - 1];
          }
          return doy + gregorian.toJD(year + 1468, 3, 13);
      },
  
      /** Create a new date from a Julian date.
          @memberof NanakshahiCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          jd = Math.floor(jd + 0.5);
          var year = Math.floor((jd - (this.jdEpoch - 1)) / 366);
          while (jd >= this.toJD(year + 1, 1, 1)) {
              year++;
          }
          var day = jd - Math.floor(this.toJD(year, 1, 1) + 0.5) + 1;
          var month = 1;
          while (day > this.daysInMonth(year, month)) {
              day -= this.daysInMonth(year, month);
              month++;
          }
          return this.newDate(year, month, day);
      }
  });
  
  // Nanakshahi calendar implementation
  main.calendars.nanakshahi = NanakshahiCalendar;
  
  
  },{"../main":593,"object-assign":473}],588:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Nepali calendar for jQuery v2.0.2.
     Written by Artur Neumann (ict.projects{at}nepal.inf.org) April 2013.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Nepali civil calendar.
      Based on the ideas from 
      <a href="http://codeissue.com/articles/a04e050dea7468f/algorithm-to-convert-english-date-to-nepali-date-using-c-net">http://codeissue.com/articles/a04e050dea7468f/algorithm-to-convert-english-date-to-nepali-date-using-c-net</a>
      and <a href="http://birenj2ee.blogspot.com/2011/04/nepali-calendar-in-java.html">http://birenj2ee.blogspot.com/2011/04/nepali-calendar-in-java.html</a>
      See also <a href="http://en.wikipedia.org/wiki/Nepali_calendar">http://en.wikipedia.org/wiki/Nepali_calendar</a>
      and <a href="https://en.wikipedia.org/wiki/Bikram_Samwat">https://en.wikipedia.org/wiki/Bikram_Samwat</a>.
      @class NepaliCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function NepaliCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  NepaliCalendar.prototype = new main.baseCalendar;
  
  assign(NepaliCalendar.prototype, {
      /** The calendar name.
          @memberof NepaliCalendar */
      name: 'Nepali',
      /** Julian date of start of Nepali epoch: 14 April 57 BCE.
          @memberof NepaliCalendar */
      jdEpoch: 1700709.5,
      /** Days per month in a common year.
          @memberof NepaliCalendar */
      daysPerMonth: [31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof NepaliCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof NepaliCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof NepaliCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof NepaliCalendar */
      minDay: 1, 
      /** The number of days in the year.
          @memberof NepaliCalendar */
      daysPerYear: 365,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof NepaliCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Nepali',
              epochs: ['BBS', 'ABS'],
              monthNames: ['Baisakh', 'Jestha', 'Ashadh', 'Shrawan', 'Bhadra', 'Ashwin',
              'Kartik', 'Mangsir', 'Paush', 'Mangh', 'Falgun', 'Chaitra'],
              monthNamesShort: ['Bai', 'Je', 'As', 'Shra', 'Bha', 'Ash', 'Kar', 'Mang', 'Pau', 'Ma', 'Fal', 'Chai'],
              dayNames: ['Aaitabaar', 'Sombaar', 'Manglbaar', 'Budhabaar', 'Bihibaar', 'Shukrabaar', 'Shanibaar'],
              dayNamesShort: ['Aaita', 'Som', 'Mangl', 'Budha', 'Bihi', 'Shukra', 'Shani'],
              dayNamesMin: ['Aai', 'So', 'Man', 'Bu', 'Bi', 'Shu', 'Sha'],
              digits: null,
              dateFormat: 'dd/mm/yyyy',
              firstDay: 1,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof NepaliCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          return this.daysInYear(year) !== this.daysPerYear;
      },
  
      /** Determine the week of the year for a date.
          @memberof NepaliCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Sunday of this week starting on Sunday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(-checkDate.dayOfWeek(), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a year.
          @memberof NepaliCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of days.
          @throws Error if an invalid year or a different calendar used. */
      daysInYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          year = date.year();
          if (typeof this.NEPALI_CALENDAR_DATA[year] === 'undefined') {
              return this.daysPerYear;
          }
          var daysPerYear = 0;
          for (var month_number = this.minMonth; month_number <= 12; month_number++) {
              daysPerYear += this.NEPALI_CALENDAR_DATA[year][month_number];
          }
          return daysPerYear;
      },
  
      /** Retrieve the number of days in a month.
          @memberof NepaliCalendar
          @param year {CDate|number| The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          if (year.year) {
              month = year.month();
              year = year.year();
          }
          this._validate(year, month, this.minDay, main.local.invalidMonth);
          return (typeof this.NEPALI_CALENDAR_DATA[year] === 'undefined' ?
              this.daysPerMonth[month - 1] : this.NEPALI_CALENDAR_DATA[year][month]);
      },
  
      /** Determine whether this date is a week day.
          @memberof NepaliCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return this.dayOfWeek(year, month, day) !== 6;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof NepaliCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(nepaliYear, nepaliMonth, nepaliDay) {
          var date = this._validate(nepaliYear, nepaliMonth, nepaliDay, main.local.invalidDate);
          nepaliYear = date.year();
          nepaliMonth = date.month();
          nepaliDay = date.day();
          var gregorianCalendar = main.instance();
          var gregorianDayOfYear = 0; // We will add all the days that went by since
          // the 1st. January and then we can get the Gregorian Date
          var nepaliMonthToCheck = nepaliMonth;
          var nepaliYearToCheck = nepaliYear;
          this._createMissingCalendarData(nepaliYear);
          // Get the correct year
          var gregorianYear = nepaliYear - (nepaliMonthToCheck > 9 || (nepaliMonthToCheck === 9 &&
              nepaliDay >= this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0]) ? 56 : 57);
          // First we add the amount of days in the actual Nepali month as the day of year in the
          // Gregorian one because at least this days are gone since the 1st. Jan. 
          if (nepaliMonth !== 9) {
              gregorianDayOfYear = nepaliDay;
              nepaliMonthToCheck--;
          }
          // Now we loop throw all Nepali month and add the amount of days to gregorianDayOfYear 
          // we do this till we reach Paush (9th month). 1st. January always falls in this month  
          while (nepaliMonthToCheck !== 9) {
              if (nepaliMonthToCheck <= 0) {
                  nepaliMonthToCheck = 12;
                  nepaliYearToCheck--;
              }                
              gregorianDayOfYear += this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][nepaliMonthToCheck];
              nepaliMonthToCheck--;
          }        
          // If the date that has to be converted is in Paush (month no. 9) we have to do some other calculation
          if (nepaliMonth === 9) {
              // Add the days that are passed since the first day of Paush and substract the
              // amount of days that lie between 1st. Jan and 1st Paush
              gregorianDayOfYear += nepaliDay - this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0];
              // For the first days of Paush we are now in negative values,
              // because in the end of the gregorian year we substract
              // 365 / 366 days (P.S. remember math in school + - gives -)
              if (gregorianDayOfYear < 0) {
                  gregorianDayOfYear += gregorianCalendar.daysInYear(gregorianYear);
              }
          }
          else {
              gregorianDayOfYear += this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][9] -
                  this.NEPALI_CALENDAR_DATA[nepaliYearToCheck][0];
          }        
          return gregorianCalendar.newDate(gregorianYear, 1 ,1).add(gregorianDayOfYear, 'd').toJD();
      },
      
      /** Create a new date from a Julian date.
          @memberof NepaliCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          var gregorianCalendar =  main.instance();
          var gregorianDate = gregorianCalendar.fromJD(jd);
          var gregorianYear = gregorianDate.year();
          var gregorianDayOfYear = gregorianDate.dayOfYear();
          var nepaliYear = gregorianYear + 56; //this is not final, it could be also +57 but +56 is always true for 1st Jan.
          this._createMissingCalendarData(nepaliYear);
          var nepaliMonth = 9; // Jan 1 always fall in Nepali month Paush which is the 9th month of Nepali calendar.
          // Get the Nepali day in Paush (month 9) of 1st January 
          var dayOfFirstJanInPaush = this.NEPALI_CALENDAR_DATA[nepaliYear][0];
          // Check how many days are left of Paush .
          // Days calculated from 1st Jan till the end of the actual Nepali month, 
          // we use this value to check if the gregorian Date is in the actual Nepali month.
          var daysSinceJanFirstToEndOfNepaliMonth =
              this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth] - dayOfFirstJanInPaush + 1;
          // If the gregorian day-of-year is smaller o equal than the sum of days between the 1st January and 
          // the end of the actual nepali month we found the correct nepali month.
          // Example: 
          // The 4th February 2011 is the gregorianDayOfYear 35 (31 days of January + 4)
          // 1st January 2011 is in the nepali year 2067, where 1st. January is in the 17th day of Paush (9th month)
          // In 2067 Paush has 30days, This means (30-17+1=14) there are 14days between 1st January and end of Paush 
          // (including 17th January)
          // The gregorianDayOfYear (35) is bigger than 14, so we check the next month
          // The next nepali month (Mangh) has 29 days 
          // 29+14=43, this is bigger than gregorianDayOfYear(35) so, we found the correct nepali month
          while (gregorianDayOfYear > daysSinceJanFirstToEndOfNepaliMonth) {
              nepaliMonth++;
              if (nepaliMonth > 12) {
                  nepaliMonth = 1;
                  nepaliYear++;
              }    
              daysSinceJanFirstToEndOfNepaliMonth += this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth];
          }
          // The last step is to calculate the nepali day-of-month
          // to continue our example from before:
          // we calculated there are 43 days from 1st. January (17 Paush) till end of Mangh (29 days)
          // when we subtract from this 43 days the day-of-year of the the Gregorian date (35),
          // we know how far the searched day is away from the end of the Nepali month.
          // So we simply subtract this number from the amount of days in this month (30) 
          var nepaliDayOfMonth = this.NEPALI_CALENDAR_DATA[nepaliYear][nepaliMonth] -
              (daysSinceJanFirstToEndOfNepaliMonth - gregorianDayOfYear);        
          return this.newDate(nepaliYear, nepaliMonth, nepaliDayOfMonth);
      },
      
      /** Creates missing data in the NEPALI_CALENDAR_DATA table.
          This data will not be correct but just give an estimated result. Mostly -/+ 1 day
          @private
          @param nepaliYear {number} The missing year number. */
      _createMissingCalendarData: function(nepaliYear) {
          var tmp_calendar_data = this.daysPerMonth.slice(0);
          tmp_calendar_data.unshift(17);
          for (var nepaliYearToCreate = (nepaliYear - 1); nepaliYearToCreate < (nepaliYear + 2); nepaliYearToCreate++) {
              if (typeof this.NEPALI_CALENDAR_DATA[nepaliYearToCreate] === 'undefined') {
                  this.NEPALI_CALENDAR_DATA[nepaliYearToCreate] = tmp_calendar_data;
              }
          }
      },
      
      NEPALI_CALENDAR_DATA:  {
          // These data are from http://www.ashesh.com.np
          1970: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1971: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          1972: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          1973: [19, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1974: [19, 31, 31, 32, 30, 31, 31, 30, 29, 30, 29, 30, 30],
          1975: [18, 31, 31, 32, 32, 30, 31, 30, 29, 30, 29, 30, 30],
          1976: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1977: [18, 31, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
          1978: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1979: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1980: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1981: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          1982: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1983: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1984: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1985: [18, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          1986: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1987: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          1988: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          1989: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          1990: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1991: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],    
          // These data are from http://nepalicalendar.rat32.com/index.php
          1992: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1993: [18, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          1994: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1995: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          1996: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          1997: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1998: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          1999: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2000: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2001: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2002: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2003: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2004: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2005: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2006: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2007: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2008: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2009: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2010: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2011: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2012: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2013: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2014: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2015: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2016: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2017: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2018: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2019: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2020: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2021: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2022: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2023: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2024: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2025: [18, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2026: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2027: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2028: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2029: [18, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          2030: [17, 31, 32, 31, 32, 31, 30, 30, 30, 30, 30, 30, 31],
          2031: [17, 31, 32, 31, 32, 31, 31, 31, 31, 31, 31, 31, 31],
          2032: [17, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32, 32],
          2033: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2034: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2035: [17, 30, 32, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2036: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2037: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2038: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2039: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2040: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2041: [18, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2042: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2043: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2044: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2045: [18, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2046: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2047: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2048: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2049: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2050: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2051: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2052: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2053: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2054: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2055: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 29, 30],
          2056: [17, 31, 31, 32, 31, 32, 30, 30, 29, 30, 29, 30, 30],
          2057: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2058: [17, 30, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2059: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2060: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2061: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2062: [17, 30, 32, 31, 32, 31, 31, 29, 30, 29, 30, 29, 31],
          2063: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2064: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2065: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2066: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 29, 31],
          2067: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2068: [17, 31, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2069: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2070: [17, 31, 31, 31, 32, 31, 31, 29, 30, 30, 29, 30, 30],
          2071: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2072: [17, 31, 32, 31, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2073: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31],
          2074: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2075: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2076: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          2077: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 29, 31],
          2078: [17, 31, 31, 31, 32, 31, 31, 30, 29, 30, 29, 30, 30],
          2079: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30],
          2080: [16, 31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 30],
          // These data are from http://www.ashesh.com.np/nepali-calendar/
          2081: [17, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2082: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2083: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2084: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2085: [17, 31, 32, 31, 32, 31, 31, 30, 30, 29, 30, 30, 30],
          2086: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2087: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
          2088: [16, 30, 31, 32, 32, 30, 31, 30, 30, 29, 30, 30, 30],
          2089: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2090: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2091: [16, 31, 31, 32, 31, 31, 31, 30, 30, 29, 30, 30, 30],
          2092: [16, 31, 31, 32, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2093: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2094: [17, 31, 31, 32, 31, 31, 30, 30, 30, 29, 30, 30, 30],
          2095: [17, 31, 31, 32, 31, 31, 31, 30, 29, 30, 30, 30, 30],
          2096: [17, 30, 31, 32, 32, 31, 30, 30, 29, 30, 29, 30, 30],
          2097: [17, 31, 32, 31, 32, 31, 30, 30, 30, 29, 30, 30, 30],
          2098: [17, 31, 31, 32, 31, 31, 31, 29, 30, 29, 30, 30, 31],
          2099: [17, 31, 31, 32, 31, 31, 31, 30, 29, 29, 30, 30, 30],
          2100: [17, 31, 32, 31, 32, 30, 31, 30, 29, 30, 29, 30, 30]    
      }
  });    
  
  // Nepali calendar implementation
  main.calendars.nepali = NepaliCalendar;
  
  
  },{"../main":593,"object-assign":473}],589:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Persian calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the Persian or Jalali calendar.
      Based on code from <a href="http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php">http://www.iranchamber.com/calendar/converter/iranian_calendar_converter.php</a>.
      See also <a href="http://en.wikipedia.org/wiki/Iranian_calendar">http://en.wikipedia.org/wiki/Iranian_calendar</a>.
      @class PersianCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function PersianCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  PersianCalendar.prototype = new main.baseCalendar;
  
  assign(PersianCalendar.prototype, {
      /** The calendar name.
          @memberof PersianCalendar */
      name: 'Persian',
      /** Julian date of start of Persian epoch: 19 March 622 CE.
          @memberof PersianCalendar */
      jdEpoch: 1948320.5,
      /** Days per month in a common year.
          @memberof PersianCalendar */
      daysPerMonth: [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof PersianCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof PersianCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof PersianCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof PersianCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof PersianCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Persian',
              epochs: ['BP', 'AP'],
              monthNames: ['Farvardin', 'Ordibehesht', 'Khordad', 'Tir', 'Mordad', 'Shahrivar',
              'Mehr', 'Aban', 'Azar', 'Day', 'Bahman', 'Esfand'],
              monthNamesShort: ['Far', 'Ord', 'Kho', 'Tir', 'Mor', 'Sha', 'Meh', 'Aba', 'Aza', 'Day', 'Bah', 'Esf'],
              dayNames: ['Yekshambe', 'Doshambe', 'Seshambe', 'Chæharshambe', 'Panjshambe', 'Jom\'e', 'Shambe'],
              dayNamesShort: ['Yek', 'Do', 'Se', 'Chæ', 'Panj', 'Jom', 'Sha'],
              dayNamesMin: ['Ye','Do','Se','Ch','Pa','Jo','Sh'],
              digits: null,
              dateFormat: 'yyyy/mm/dd',
              firstDay: 6,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof PersianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return (((((date.year() - (date.year() > 0 ? 474 : 473)) % 2820) +
              474 + 38) * 682) % 2816) < 682;
      },
  
      /** Determine the week of the year for a date.
          @memberof PersianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Saturday of this week starting on Saturday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(-((checkDate.dayOfWeek() + 1) % 7), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a month.
          @memberof PersianCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          return this.daysPerMonth[date.month() - 1] +
              (date.month() === 12 && this.leapYear(date.year()) ? 1 : 0);
      },
  
      /** Determine whether this date is a week day.
          @memberof PersianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return this.dayOfWeek(year, month, day) !== 5;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof PersianCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          year = date.year();
          month = date.month();
          day = date.day();
          var epBase = year - (year >= 0 ? 474 : 473);
          var epYear = 474 + mod(epBase, 2820);
          return day + (month <= 7 ? (month - 1) * 31 : (month - 1) * 30 + 6) +
              Math.floor((epYear * 682 - 110) / 2816) + (epYear - 1) * 365 +
              Math.floor(epBase / 2820) * 1029983 + this.jdEpoch - 1;
      },
  
      /** Create a new date from a Julian date.
          @memberof PersianCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          jd = Math.floor(jd) + 0.5;
          var depoch = jd - this.toJD(475, 1, 1);
          var cycle = Math.floor(depoch / 1029983);
          var cyear = mod(depoch, 1029983);
          var ycycle = 2820;
          if (cyear !== 1029982) {
              var aux1 = Math.floor(cyear / 366);
              var aux2 = mod(cyear, 366);
              ycycle = Math.floor(((2134 * aux1) + (2816 * aux2) + 2815) / 1028522) + aux1 + 1;
          }
          var year = ycycle + (2820 * cycle) + 474;
          year = (year <= 0 ? year - 1 : year);
          var yday = jd - this.toJD(year, 1, 1) + 1;
          var month = (yday <= 186 ? Math.ceil(yday / 31) : Math.ceil((yday - 6) / 30));
          var day = jd - this.toJD(year, month, 1) + 1;
          return this.newDate(year, month, day);
      }
  });
  
  // Modulus function which works for non-integers.
  function mod(a, b) {
      return a - (b * Math.floor(a / b));
  }
  
  // Persian (Jalali) calendar implementation
  main.calendars.persian = PersianCalendar;
  main.calendars.jalali = PersianCalendar;
  
  
  },{"../main":593,"object-assign":473}],590:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Taiwanese (Minguo) calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  var gregorianCalendar = main.instance();
  
  /** Implementation of the Taiwanese calendar.
      See http://en.wikipedia.org/wiki/Minguo_calendar.
      @class TaiwanCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function TaiwanCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  TaiwanCalendar.prototype = new main.baseCalendar;
  
  assign(TaiwanCalendar.prototype, {
      /** The calendar name.
          @memberof TaiwanCalendar */
      name: 'Taiwan',
      /** Julian date of start of Taiwan epoch: 1 January 1912 CE (Gregorian).
          @memberof TaiwanCalendar */
      jdEpoch: 2419402.5,
      /** Difference in years between Taiwan and Gregorian calendars.
          @memberof TaiwanCalendar */
      yearsOffset: 1911,
      /** Days per month in a common year.
          @memberof TaiwanCalendar */
      daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof TaiwanCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof TaiwanCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof TaiwanCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof TaiwanCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof TaiwanCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Taiwan',
              epochs: ['BROC', 'ROC'],
              monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'],
              monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
              dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
              digits: null,
              dateFormat: 'yyyy/mm/dd',
              firstDay: 1,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof TaiwanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          var year = this._t2gYear(date.year());
          return gregorianCalendar.leapYear(year);
      },
  
      /** Determine the week of the year for a date - ISO 8601.
          @memberof TaiwanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          var year = this._t2gYear(date.year());
          return gregorianCalendar.weekOfYear(year, date.month(), date.day());
      },
  
      /** Retrieve the number of days in a month.
          @memberof TaiwanCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          return this.daysPerMonth[date.month() - 1] +
              (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
      },
  
      /** Determine whether this date is a week day.
          @memberof TaiwanCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return (this.dayOfWeek(year, month, day) || 7) < 6;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof TaiwanCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          var year = this._t2gYear(date.year());
          return gregorianCalendar.toJD(year, date.month(), date.day());
      },
  
      /** Create a new date from a Julian date.
          @memberof TaiwanCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          var date = gregorianCalendar.fromJD(jd);
          var year = this._g2tYear(date.year());
          return this.newDate(year, date.month(), date.day());
      },
  
      /** Convert Taiwanese to Gregorian year.
          @memberof TaiwanCalendar
          @private
          @param year {number} The Taiwanese year.
          @return {number} The corresponding Gregorian year. */
      _t2gYear: function(year) {
          return year + this.yearsOffset + (year >= -this.yearsOffset && year <= -1 ? 1 : 0);
      },
  
      /** Convert Gregorian to Taiwanese year.
          @memberof TaiwanCalendar
          @private
          @param year {number} The Gregorian year.
          @return {number} The corresponding Taiwanese year. */
      _g2tYear: function(year) {
          return year - this.yearsOffset - (year >= 1 && year <= this.yearsOffset ? 1 : 0);
      }
  });
  
  // Taiwan calendar implementation
  main.calendars.taiwan = TaiwanCalendar;
  
  
  },{"../main":593,"object-assign":473}],591:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Thai calendar for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) February 2010.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  var gregorianCalendar = main.instance();
  
  /** Implementation of the Thai calendar.
      See http://en.wikipedia.org/wiki/Thai_calendar.
      @class ThaiCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function ThaiCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  ThaiCalendar.prototype = new main.baseCalendar;
  
  assign(ThaiCalendar.prototype, {
      /** The calendar name.
          @memberof ThaiCalendar */
      name: 'Thai',
      /** Julian date of start of Thai epoch: 1 January 543 BCE (Gregorian).
          @memberof ThaiCalendar */
      jdEpoch: 1523098.5,
      /** Difference in years between Thai and Gregorian calendars.
          @memberof ThaiCalendar */
      yearsOffset: 543, 
      /** Days per month in a common year.
          @memberof ThaiCalendar */
      daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof ThaiCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof ThaiCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof ThaiCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof ThaiCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof ThaiCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Thai',
              epochs: ['BBE', 'BE'],
              monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'],
              monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
              dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
              digits: null,
              dateFormat: 'dd/mm/yyyy',
              firstDay: 0,
              isRTL: false
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof ThaiCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          var year = this._t2gYear(date.year());
          return gregorianCalendar.leapYear(year);
      },
  
      /** Determine the week of the year for a date - ISO 8601.
          @memberof ThaiCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          var year = this._t2gYear(date.year());
          return gregorianCalendar.weekOfYear(year, date.month(), date.day());
      },
  
      /** Retrieve the number of days in a month.
          @memberof ThaiCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          return this.daysPerMonth[date.month() - 1] +
              (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
      },
  
      /** Determine whether this date is a week day.
          @memberof ThaiCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return (this.dayOfWeek(year, month, day) || 7) < 6;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof ThaiCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          var year = this._t2gYear(date.year());
          return gregorianCalendar.toJD(year, date.month(), date.day());
      },
  
      /** Create a new date from a Julian date.
          @memberof ThaiCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          var date = gregorianCalendar.fromJD(jd);
          var year = this._g2tYear(date.year());
          return this.newDate(year, date.month(), date.day());
      },
  
      /** Convert Thai to Gregorian year.
          @memberof ThaiCalendar
          @private
          @param year {number} The Thai year.
          @return {number} The corresponding Gregorian year. */
      _t2gYear: function(year) {
          return year - this.yearsOffset - (year >= 1 && year <= this.yearsOffset ? 1 : 0);
      },
  
      /** Convert Gregorian to Thai year.
          @memberof ThaiCalendar
          @private
          @param year {number} The Gregorian year.
          @return {number} The corresponding Thai year. */
      _g2tYear: function(year) {
          return year + this.yearsOffset + (year >= -this.yearsOffset && year <= -1 ? 1 : 0);
      }
  });
  
  // Thai calendar implementation
  main.calendars.thai = ThaiCalendar;
  
  
  },{"../main":593,"object-assign":473}],592:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     UmmAlQura calendar for jQuery v2.0.2.
     Written by Amro Osama March 2013.
     Modified by Binnooh.com & www.elm.sa - 2014 - Added dates back to 1276 Hijri year.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var main = _dereq_('../main');
  var assign = _dereq_('object-assign');
  
  
  /** Implementation of the UmmAlQura or 'saudi' calendar.
      See also <a href="http://en.wikipedia.org/wiki/Islamic_calendar#Saudi_Arabia.27s_Umm_al-Qura_calendar">http://en.wikipedia.org/wiki/Islamic_calendar#Saudi_Arabia.27s_Umm_al-Qura_calendar</a>.
      <a href="http://www.ummulqura.org.sa/About.aspx">http://www.ummulqura.org.sa/About.aspx</a>
      <a href="http://www.staff.science.uu.nl/~gent0113/islam/ummalqura.htm">http://www.staff.science.uu.nl/~gent0113/islam/ummalqura.htm</a>
      @class UmmAlQuraCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function UmmAlQuraCalendar(language) {
      this.local = this.regionalOptions[language || ''] || this.regionalOptions[''];
  }
  
  UmmAlQuraCalendar.prototype = new main.baseCalendar;
  
  assign(UmmAlQuraCalendar.prototype, {
      /** The calendar name.
          @memberof UmmAlQuraCalendar */
      name: 'UmmAlQura',
      //jdEpoch: 1948440, // Julian date of start of UmmAlQura epoch: 14 March 1937 CE
      //daysPerMonth: // Days per month in a common year, replaced by a method.
      /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof UmmAlQuraCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof UmmAlQuraCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof UmmAlQuraCalendar */
      firstMonth: 1,
      /** The minimum day number.
          @memberof UmmAlQuraCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof UmmAlQuraCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Umm al-Qura',
              epochs: ['BH', 'AH'],
              monthNames: ['Al-Muharram', 'Safar', 'Rabi\' al-awwal', 'Rabi\' Al-Thani', 'Jumada Al-Awwal', 'Jumada Al-Thani',
              'Rajab', 'Sha\'aban', 'Ramadan', 'Shawwal', 'Dhu al-Qi\'dah', 'Dhu al-Hijjah'],
              monthNamesShort: ['Muh', 'Saf', 'Rab1', 'Rab2', 'Jum1', 'Jum2', 'Raj', 'Sha\'', 'Ram', 'Shaw', 'DhuQ', 'DhuH'],
              dayNames: ['Yawm al-Ahad', 'Yawm al-Ithnain', 'Yawm al-Thalāthā’', 'Yawm al-Arba‘ā’', 'Yawm al-Khamīs', 'Yawm al-Jum‘a', 'Yawm al-Sabt'],
              dayNamesMin: ['Ah', 'Ith', 'Th', 'Ar', 'Kh', 'Ju', 'Sa'],
              digits: null,
              dateFormat: 'yyyy/mm/dd',
              firstDay: 6,
              isRTL: true
          }
      },
  
      /** Determine whether this date is in a leap year.
          @memberof UmmAlQuraCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function (year) {
          var date = this._validate(year, this.minMonth, this.minDay, main.local.invalidYear);
          return (this.daysInYear(date.year()) === 355);
      },
  
      /** Determine the week of the year for a date.
          @memberof UmmAlQuraCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function (year, month, day) {
          // Find Sunday of this week starting on Sunday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(-checkDate.dayOfWeek(), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a year.
          @memberof UmmAlQuraCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of days.
          @throws Error if an invalid year or a different calendar used. */
      daysInYear: function (year) {
          var daysCount = 0;
          for (var i = 1; i <= 12; i++) {
              daysCount += this.daysInMonth(year, i);
          }
          return daysCount;
      },
  
      /** Retrieve the number of days in a month.
          @memberof UmmAlQuraCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function (year, month) {
          var date = this._validate(year, month, this.minDay, main.local.invalidMonth);
          var mcjdn = date.toJD() - 2400000 + 0.5; // Modified Chronological Julian Day Number (MCJDN)
          // the MCJDN's of the start of the lunations in the Umm al-Qura calendar are stored in the 'ummalqura_dat' array
          var index = 0;
          for (var i = 0; i < ummalqura_dat.length; i++) {
              if (ummalqura_dat[i] > mcjdn) {
                  return (ummalqura_dat[index] - ummalqura_dat[index - 1]);
              }
              index++;
          }
          return 30; // Unknown outside
      },
  
      /** Determine whether this date is a week day.
          @memberof UmmAlQuraCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function (year, month, day) {
          return this.dayOfWeek(year, month, day) !== 5;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof UmmAlQuraCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function (year, month, day) {
          var date = this._validate(year, month, day, main.local.invalidDate);
          var index = (12 * (date.year() - 1)) + date.month() - 15292;
          var mcjdn = date.day() + ummalqura_dat[index - 1] - 1;
          return mcjdn + 2400000 - 0.5; // Modified Chronological Julian Day Number (MCJDN)
      },
  
      /** Create a new date from a Julian date.
          @memberof UmmAlQuraCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function (jd) {
          var mcjdn = jd - 2400000 + 0.5; // Modified Chronological Julian Day Number (MCJDN)
          // the MCJDN's of the start of the lunations in the Umm al-Qura calendar 
          // are stored in the 'ummalqura_dat' array
          var index = 0;
          for (var i = 0; i < ummalqura_dat.length; i++) {
              if (ummalqura_dat[i] > mcjdn) break;
              index++;
          }
          var lunation = index + 15292; //UmmAlQura Lunation Number
          var ii = Math.floor((lunation - 1) / 12);
          var year = ii + 1;
          var month = lunation - 12 * ii;
          var day = mcjdn - ummalqura_dat[index - 1] + 1;
          return this.newDate(year, month, day);
      },
  
      /** Determine whether a date is valid for this calendar.
          @memberof UmmAlQuraCalendar
          @param year {number} The year to examine.
          @param month {number} The month to examine.
          @param day {number} The day to examine.
          @return {boolean} <code>true</code> if a valid date, <code>false</code> if not. */
      isValid: function(year, month, day) {
          var valid = main.baseCalendar.prototype.isValid.apply(this, arguments);
          if (valid) {
              year = (year.year != null ? year.year : year);
              valid = (year >= 1276 && year <= 1500);
          }
          return valid;
      },
  
      /** Check that a candidate date is from the same calendar and is valid.
          @memberof UmmAlQuraCalendar
          @private
          @param year {CDate|number} The date to validate or the year to validate.
          @param month {number} The month to validate.
          @param day {number} The day to validate.
          @param error {string} Error message if invalid.
          @throws Error if different calendars used or invalid date. */
      _validate: function(year, month, day, error) {
          var date = main.baseCalendar.prototype._validate.apply(this, arguments);
          if (date.year < 1276 || date.year > 1500) {
              throw error.replace(/\{0\}/, this.local.name);
          }
          return date;
      }
  });
  
  // UmmAlQura calendar implementation
  main.calendars.ummalqura = UmmAlQuraCalendar;
  
  var ummalqura_dat = [
      20,    50,    79,    109,   138,   168,   197,   227,   256,   286,   315,   345,   374,   404,   433,   463,   492,   522,   551,   581, 
      611,   641,   670,   700,   729,   759,   788,   818,   847,   877,   906,   936,   965,   995,   1024,  1054,  1083,  1113,  1142,  1172,
      1201,  1231,  1260,  1290,  1320,  1350,  1379,  1409,  1438,  1468,  1497,  1527,  1556,  1586,  1615,  1645,  1674,  1704,  1733,  1763,
      1792,  1822,  1851,  1881,  1910,  1940,  1969,  1999,  2028,  2058,  2087,  2117,  2146,  2176,  2205,  2235,  2264,  2294,  2323,  2353,
      2383,  2413,  2442,  2472,  2501,  2531,  2560,  2590,  2619,  2649,  2678,  2708,  2737,  2767,  2796,  2826,  2855,  2885,  2914,  2944,
      2973,  3003,  3032,  3062,  3091,  3121,  3150,  3180,  3209,  3239,  3268,  3298,  3327,  3357,  3386,  3416,  3446,  3476,  3505,  3535,
      3564,  3594,  3623,  3653,  3682,  3712,  3741,  3771,  3800,  3830,  3859,  3889,  3918,  3948,  3977,  4007,  4036,  4066,  4095,  4125,
      4155,  4185,  4214,  4244,  4273,  4303,  4332,  4362,  4391,  4421,  4450,  4480,  4509,  4539,  4568,  4598,  4627,  4657,  4686,  4716,
      4745,  4775,  4804,  4834,  4863,  4893,  4922,  4952,  4981,  5011,  5040,  5070,  5099,  5129,  5158,  5188,  5218,  5248,  5277,  5307,
      5336,  5366,  5395,  5425,  5454,  5484,  5513,  5543,  5572,  5602,  5631,  5661,  5690,  5720,  5749,  5779,  5808,  5838,  5867,  5897,
      5926,  5956,  5985,  6015,  6044,  6074,  6103,  6133,  6162,  6192,  6221,  6251,  6281,  6311,  6340,  6370,  6399,  6429,  6458,  6488,
      6517,  6547,  6576,  6606,  6635,  6665,  6694,  6724,  6753,  6783,  6812,  6842,  6871,  6901,  6930,  6960,  6989,  7019,  7048,  7078,
      7107,  7137,  7166,  7196,  7225,  7255,  7284,  7314,  7344,  7374,  7403,  7433,  7462,  7492,  7521,  7551,  7580,  7610,  7639,  7669,
      7698,  7728,  7757,  7787,  7816,  7846,  7875,  7905,  7934,  7964,  7993,  8023,  8053,  8083,  8112,  8142,  8171,  8201,  8230,  8260,
      8289,  8319,  8348,  8378,  8407,  8437,  8466,  8496,  8525,  8555,  8584,  8614,  8643,  8673,  8702,  8732,  8761,  8791,  8821,  8850,
      8880,  8909,  8938,  8968,  8997,  9027,  9056,  9086,  9115,  9145,  9175,  9205,  9234,  9264,  9293,  9322,  9352,  9381,  9410,  9440,
      9470,  9499,  9529,  9559,  9589,  9618,  9648,  9677,  9706,  9736,  9765,  9794,  9824,  9853,  9883,  9913,  9943,  9972,  10002, 10032,
      10061, 10090, 10120, 10149, 10178, 10208, 10237, 10267, 10297, 10326, 10356, 10386, 10415, 10445, 10474, 10504, 10533, 10562, 10592, 10621,
      10651, 10680, 10710, 10740, 10770, 10799, 10829, 10858, 10888, 10917, 10947, 10976, 11005, 11035, 11064, 11094, 11124, 11153, 11183, 11213,
      11242, 11272, 11301, 11331, 11360, 11389, 11419, 11448, 11478, 11507, 11537, 11567, 11596, 11626, 11655, 11685, 11715, 11744, 11774, 11803,
      11832, 11862, 11891, 11921, 11950, 11980, 12010, 12039, 12069, 12099, 12128, 12158, 12187, 12216, 12246, 12275, 12304, 12334, 12364, 12393,
      12423, 12453, 12483, 12512, 12542, 12571, 12600, 12630, 12659, 12688, 12718, 12747, 12777, 12807, 12837, 12866, 12896, 12926, 12955, 12984,
      13014, 13043, 13072, 13102, 13131, 13161, 13191, 13220, 13250, 13280, 13310, 13339, 13368, 13398, 13427, 13456, 13486, 13515, 13545, 13574,
      13604, 13634, 13664, 13693, 13723, 13752, 13782, 13811, 13840, 13870, 13899, 13929, 13958, 13988, 14018, 14047, 14077, 14107, 14136, 14166,
      14195, 14224, 14254, 14283, 14313, 14342, 14372, 14401, 14431, 14461, 14490, 14520, 14550, 14579, 14609, 14638, 14667, 14697, 14726, 14756,
      14785, 14815, 14844, 14874, 14904, 14933, 14963, 14993, 15021, 15051, 15081, 15110, 15140, 15169, 15199, 15228, 15258, 15287, 15317, 15347,
      15377, 15406, 15436, 15465, 15494, 15524, 15553, 15582, 15612, 15641, 15671, 15701, 15731, 15760, 15790, 15820, 15849, 15878, 15908, 15937,
      15966, 15996, 16025, 16055, 16085, 16114, 16144, 16174, 16204, 16233, 16262, 16292, 16321, 16350, 16380, 16409, 16439, 16468, 16498, 16528,
      16558, 16587, 16617, 16646, 16676, 16705, 16734, 16764, 16793, 16823, 16852, 16882, 16912, 16941, 16971, 17001, 17030, 17060, 17089, 17118,
      17148, 17177, 17207, 17236, 17266, 17295, 17325, 17355, 17384, 17414, 17444, 17473, 17502, 17532, 17561, 17591, 17620, 17650, 17679, 17709,
      17738, 17768, 17798, 17827, 17857, 17886, 17916, 17945, 17975, 18004, 18034, 18063, 18093, 18122, 18152, 18181, 18211, 18241, 18270, 18300,
      18330, 18359, 18388, 18418, 18447, 18476, 18506, 18535, 18565, 18595, 18625, 18654, 18684, 18714, 18743, 18772, 18802, 18831, 18860, 18890,
      18919, 18949, 18979, 19008, 19038, 19068, 19098, 19127, 19156, 19186, 19215, 19244, 19274, 19303, 19333, 19362, 19392, 19422, 19452, 19481,
      19511, 19540, 19570, 19599, 19628, 19658, 19687, 19717, 19746, 19776, 19806, 19836, 19865, 19895, 19924, 19954, 19983, 20012, 20042, 20071,
      20101, 20130, 20160, 20190, 20219, 20249, 20279, 20308, 20338, 20367, 20396, 20426, 20455, 20485, 20514, 20544, 20573, 20603, 20633, 20662,
      20692, 20721, 20751, 20780, 20810, 20839, 20869, 20898, 20928, 20957, 20987, 21016, 21046, 21076, 21105, 21135, 21164, 21194, 21223, 21253,
      21282, 21312, 21341, 21371, 21400, 21430, 21459, 21489, 21519, 21548, 21578, 21607, 21637, 21666, 21696, 21725, 21754, 21784, 21813, 21843,
      21873, 21902, 21932, 21962, 21991, 22021, 22050, 22080, 22109, 22138, 22168, 22197, 22227, 22256, 22286, 22316, 22346, 22375, 22405, 22434,
      22464, 22493, 22522, 22552, 22581, 22611, 22640, 22670, 22700, 22730, 22759, 22789, 22818, 22848, 22877, 22906, 22936, 22965, 22994, 23024,
      23054, 23083, 23113, 23143, 23173, 23202, 23232, 23261, 23290, 23320, 23349, 23379, 23408, 23438, 23467, 23497, 23527, 23556, 23586, 23616,
      23645, 23674, 23704, 23733, 23763, 23792, 23822, 23851, 23881, 23910, 23940, 23970, 23999, 24029, 24058, 24088, 24117, 24147, 24176, 24206,
      24235, 24265, 24294, 24324, 24353, 24383, 24413, 24442, 24472, 24501, 24531, 24560, 24590, 24619, 24648, 24678, 24707, 24737, 24767, 24796,
      24826, 24856, 24885, 24915, 24944, 24974, 25003, 25032, 25062, 25091, 25121, 25150, 25180, 25210, 25240, 25269, 25299, 25328, 25358, 25387,
      25416, 25446, 25475, 25505, 25534, 25564, 25594, 25624, 25653, 25683, 25712, 25742, 25771, 25800, 25830, 25859, 25888, 25918, 25948, 25977,
      26007, 26037, 26067, 26096, 26126, 26155, 26184, 26214, 26243, 26272, 26302, 26332, 26361, 26391, 26421, 26451, 26480, 26510, 26539, 26568,
      26598, 26627, 26656, 26686, 26715, 26745, 26775, 26805, 26834, 26864, 26893, 26923, 26952, 26982, 27011, 27041, 27070, 27099, 27129, 27159,
      27188, 27218, 27248, 27277, 27307, 27336, 27366, 27395, 27425, 27454, 27484, 27513, 27542, 27572, 27602, 27631, 27661, 27691, 27720, 27750,
      27779, 27809, 27838, 27868, 27897, 27926, 27956, 27985, 28015, 28045, 28074, 28104, 28134, 28163, 28193, 28222, 28252, 28281, 28310, 28340,
      28369, 28399, 28428, 28458, 28488, 28517, 28547, 28577,
      // From 1356
      28607, 28636, 28665, 28695, 28724, 28754, 28783, 28813, 28843, 28872, 28901, 28931, 28960, 28990, 29019, 29049, 29078, 29108, 29137, 29167,
      29196, 29226, 29255, 29285, 29315, 29345, 29375, 29404, 29434, 29463, 29492, 29522, 29551, 29580, 29610, 29640, 29669, 29699, 29729, 29759,
      29788, 29818, 29847, 29876, 29906, 29935, 29964, 29994, 30023, 30053, 30082, 30112, 30141, 30171, 30200, 30230, 30259, 30289, 30318, 30348,
      30378, 30408, 30437, 30467, 30496, 30526, 30555, 30585, 30614, 30644, 30673, 30703, 30732, 30762, 30791, 30821, 30850, 30880, 30909, 30939,
      30968, 30998, 31027, 31057, 31086, 31116, 31145, 31175, 31204, 31234, 31263, 31293, 31322, 31352, 31381, 31411, 31441, 31471, 31500, 31530,
      31559, 31589, 31618, 31648, 31676, 31706, 31736, 31766, 31795, 31825, 31854, 31884, 31913, 31943, 31972, 32002, 32031, 32061, 32090, 32120,
      32150, 32180, 32209, 32239, 32268, 32298, 32327, 32357, 32386, 32416, 32445, 32475, 32504, 32534, 32563, 32593, 32622, 32652, 32681, 32711,
      32740, 32770, 32799, 32829, 32858, 32888, 32917, 32947, 32976, 33006, 33035, 33065, 33094, 33124, 33153, 33183, 33213, 33243, 33272, 33302,
      33331, 33361, 33390, 33420, 33450, 33479, 33509, 33539, 33568, 33598, 33627, 33657, 33686, 33716, 33745, 33775, 33804, 33834, 33863, 33893,
      33922, 33952, 33981, 34011, 34040, 34069, 34099, 34128, 34158, 34187, 34217, 34247, 34277, 34306, 34336, 34365, 34395, 34424, 34454, 34483,
      34512, 34542, 34571, 34601, 34631, 34660, 34690, 34719, 34749, 34778, 34808, 34837, 34867, 34896, 34926, 34955, 34985, 35015, 35044, 35074,
      35103, 35133, 35162, 35192, 35222, 35251, 35280, 35310, 35340, 35370, 35399, 35429, 35458, 35488, 35517, 35547, 35576, 35605, 35635, 35665,
      35694, 35723, 35753, 35782, 35811, 35841, 35871, 35901, 35930, 35960, 35989, 36019, 36048, 36078, 36107, 36136, 36166, 36195, 36225, 36254,
      36284, 36314, 36343, 36373, 36403, 36433, 36462, 36492, 36521, 36551, 36580, 36610, 36639, 36669, 36698, 36728, 36757, 36786, 36816, 36845,
      36875, 36904, 36934, 36963, 36993, 37022, 37052, 37081, 37111, 37141, 37170, 37200, 37229, 37259, 37288, 37318, 37347, 37377, 37406, 37436,
      37465, 37495, 37524, 37554, 37584, 37613, 37643, 37672, 37701, 37731, 37760, 37790, 37819, 37849, 37878, 37908, 37938, 37967, 37997, 38027,
      38056, 38085, 38115, 38144, 38174, 38203, 38233, 38262, 38292, 38322, 38351, 38381, 38410, 38440, 38469, 38499, 38528, 38558, 38587, 38617,
      38646, 38676, 38705, 38735, 38764, 38794, 38823, 38853, 38882, 38912, 38941, 38971, 39001, 39030, 39059, 39089, 39118, 39148, 39178, 39208,
      39237, 39267, 39297, 39326, 39355, 39385, 39414, 39444, 39473, 39503, 39532, 39562, 39592, 39621, 39650, 39680, 39709, 39739, 39768, 39798,
      39827, 39857, 39886, 39916, 39946, 39975, 40005, 40035, 40064, 40094, 40123, 40153, 40182, 40212, 40241, 40271, 40300, 40330, 40359, 40389,
      40418, 40448, 40477, 40507, 40536, 40566, 40595, 40625, 40655, 40685, 40714, 40744, 40773, 40803, 40832, 40862, 40892, 40921, 40951, 40980,
      41009, 41039, 41068, 41098, 41127, 41157, 41186, 41216, 41245, 41275, 41304, 41334, 41364, 41393, 41422, 41452, 41481, 41511, 41540, 41570,
      41599, 41629, 41658, 41688, 41718, 41748, 41777, 41807, 41836, 41865, 41894, 41924, 41953, 41983, 42012, 42042, 42072, 42102, 42131, 42161,
      42190, 42220, 42249, 42279, 42308, 42337, 42367, 42397, 42426, 42456, 42485, 42515, 42545, 42574, 42604, 42633, 42662, 42692, 42721, 42751,
      42780, 42810, 42839, 42869, 42899, 42929, 42958, 42988, 43017, 43046, 43076, 43105, 43135, 43164, 43194, 43223, 43253, 43283, 43312, 43342,
      43371, 43401, 43430, 43460, 43489, 43519, 43548, 43578, 43607, 43637, 43666, 43696, 43726, 43755, 43785, 43814, 43844, 43873, 43903, 43932,
      43962, 43991, 44021, 44050, 44080, 44109, 44139, 44169, 44198, 44228, 44258, 44287, 44317, 44346, 44375, 44405, 44434, 44464, 44493, 44523,
      44553, 44582, 44612, 44641, 44671, 44700, 44730, 44759, 44788, 44818, 44847, 44877, 44906, 44936, 44966, 44996, 45025, 45055, 45084, 45114,
      45143, 45172, 45202, 45231, 45261, 45290, 45320, 45350, 45380, 45409, 45439, 45468, 45498, 45527, 45556, 45586, 45615, 45644, 45674, 45704,
      45733, 45763, 45793, 45823, 45852, 45882, 45911, 45940, 45970, 45999, 46028, 46058, 46088, 46117, 46147, 46177, 46206, 46236, 46265, 46295,
      46324, 46354, 46383, 46413, 46442, 46472, 46501, 46531, 46560, 46590, 46620, 46649, 46679, 46708, 46738, 46767, 46797, 46826, 46856, 46885,
      46915, 46944, 46974, 47003, 47033, 47063, 47092, 47122, 47151, 47181, 47210, 47240, 47269, 47298, 47328, 47357, 47387, 47417, 47446, 47476,
      47506, 47535, 47565, 47594, 47624, 47653, 47682, 47712, 47741, 47771, 47800, 47830, 47860, 47890, 47919, 47949, 47978, 48008, 48037, 48066,
      48096, 48125, 48155, 48184, 48214, 48244, 48273, 48303, 48333, 48362, 48392, 48421, 48450, 48480, 48509, 48538, 48568, 48598, 48627, 48657,
      48687, 48717, 48746, 48776, 48805, 48834, 48864, 48893, 48922, 48952, 48982, 49011, 49041, 49071, 49100, 49130, 49160, 49189, 49218, 49248,
      49277, 49306, 49336, 49365, 49395, 49425, 49455, 49484, 49514, 49543, 49573, 49602, 49632, 49661, 49690, 49720, 49749, 49779, 49809, 49838,
      49868, 49898, 49927, 49957, 49986, 50016, 50045, 50075, 50104, 50133, 50163, 50192, 50222, 50252, 50281, 50311, 50340, 50370, 50400, 50429,
      50459, 50488, 50518, 50547, 50576, 50606, 50635, 50665, 50694, 50724, 50754, 50784, 50813, 50843, 50872, 50902, 50931, 50960, 50990, 51019,
      51049, 51078, 51108, 51138, 51167, 51197, 51227, 51256, 51286, 51315, 51345, 51374, 51403, 51433, 51462, 51492, 51522, 51552, 51582, 51611,
      51641, 51670, 51699, 51729, 51758, 51787, 51816, 51846, 51876, 51906, 51936, 51965, 51995, 52025, 52054, 52083, 52113, 52142, 52171, 52200,
      52230, 52260, 52290, 52319, 52349, 52379, 52408, 52438, 52467, 52497, 52526, 52555, 52585, 52614, 52644, 52673, 52703, 52733, 52762, 52792,
      52822, 52851, 52881, 52910, 52939, 52969, 52998, 53028, 53057, 53087, 53116, 53146, 53176, 53205, 53235, 53264, 53294, 53324, 53353, 53383,
      53412, 53441, 53471, 53500, 53530, 53559, 53589, 53619, 53648, 53678, 53708, 53737, 53767, 53796, 53825, 53855, 53884, 53913, 53943, 53973,
      54003, 54032, 54062, 54092, 54121, 54151, 54180, 54209, 54239, 54268, 54297, 54327, 54357, 54387, 54416, 54446, 54476, 54505, 54535, 54564,
      54593, 54623, 54652, 54681, 54711, 54741, 54770, 54800, 54830, 54859, 54889, 54919, 54948, 54977, 55007, 55036, 55066, 55095, 55125, 55154,
      55184, 55213, 55243, 55273, 55302, 55332, 55361, 55391, 55420, 55450, 55479, 55508, 55538, 55567, 55597, 55627, 55657, 55686, 55716, 55745,
      55775, 55804, 55834, 55863, 55892, 55922, 55951, 55981, 56011, 56040, 56070, 56100, 56129, 56159, 56188, 56218, 56247, 56276, 56306, 56335,
      56365, 56394, 56424, 56454, 56483, 56513, 56543, 56572, 56601, 56631, 56660, 56690, 56719, 56749, 56778, 56808, 56837, 56867, 56897, 56926,
      56956, 56985, 57015, 57044, 57074, 57103, 57133, 57162, 57192, 57221, 57251, 57280, 57310, 57340, 57369, 57399, 57429, 57458, 57487, 57517,
      57546, 57576, 57605, 57634, 57664, 57694, 57723, 57753, 57783, 57813, 57842, 57871, 57901, 57930, 57959, 57989, 58018, 58048, 58077, 58107,
      58137, 58167, 58196, 58226, 58255, 58285, 58314, 58343, 58373, 58402, 58432, 58461, 58491, 58521, 58551, 58580, 58610, 58639, 58669, 58698,
      58727, 58757, 58786, 58816, 58845, 58875, 58905, 58934, 58964, 58994, 59023, 59053, 59082, 59111, 59141, 59170, 59200, 59229, 59259, 59288,
      59318, 59348, 59377, 59407, 59436, 59466, 59495, 59525, 59554, 59584, 59613, 59643, 59672, 59702, 59731, 59761, 59791, 59820, 59850, 59879,
      59909, 59939, 59968, 59997, 60027, 60056, 60086, 60115, 60145, 60174, 60204, 60234, 60264, 60293, 60323, 60352, 60381, 60411, 60440, 60469,
      60499, 60528, 60558, 60588, 60618, 60648, 60677, 60707, 60736, 60765, 60795, 60824, 60853, 60883, 60912, 60942, 60972, 61002, 61031, 61061,
      61090, 61120, 61149, 61179, 61208, 61237, 61267, 61296, 61326, 61356, 61385, 61415, 61445, 61474, 61504, 61533, 61563, 61592, 61621, 61651,
      61680, 61710, 61739, 61769, 61799, 61828, 61858, 61888, 61917, 61947, 61976, 62006, 62035, 62064, 62094, 62123, 62153, 62182, 62212, 62242,
      62271, 62301, 62331, 62360, 62390, 62419, 62448, 62478, 62507, 62537, 62566, 62596, 62625, 62655, 62685, 62715, 62744, 62774, 62803, 62832,
      62862, 62891, 62921, 62950, 62980, 63009, 63039, 63069, 63099, 63128, 63157, 63187, 63216, 63246, 63275, 63305, 63334, 63363, 63393, 63423,
      63453, 63482, 63512, 63541, 63571, 63600, 63630, 63659, 63689, 63718, 63747, 63777, 63807, 63836, 63866, 63895, 63925, 63955, 63984, 64014,
      64043, 64073, 64102, 64131, 64161, 64190, 64220, 64249, 64279, 64309, 64339, 64368, 64398, 64427, 64457, 64486, 64515, 64545, 64574, 64603,
      64633, 64663, 64692, 64722, 64752, 64782, 64811, 64841, 64870, 64899, 64929, 64958, 64987, 65017, 65047, 65076, 65106, 65136, 65166, 65195,
      65225, 65254, 65283, 65313, 65342, 65371, 65401, 65431, 65460, 65490, 65520, 65549, 65579, 65608, 65638, 65667, 65697, 65726, 65755, 65785,
      65815, 65844, 65874, 65903, 65933, 65963, 65992, 66022, 66051, 66081, 66110, 66140, 66169, 66199, 66228, 66258, 66287, 66317, 66346, 66376,
      66405, 66435, 66465, 66494, 66524, 66553, 66583, 66612, 66641, 66671, 66700, 66730, 66760, 66789, 66819, 66849, 66878, 66908, 66937, 66967,
      66996, 67025, 67055, 67084, 67114, 67143, 67173, 67203, 67233, 67262, 67292, 67321, 67351, 67380, 67409, 67439, 67468, 67497, 67527, 67557,
      67587, 67617, 67646, 67676, 67705, 67735, 67764, 67793, 67823, 67852, 67882, 67911, 67941, 67971, 68000, 68030, 68060, 68089, 68119, 68148,
      68177, 68207, 68236, 68266, 68295, 68325, 68354, 68384, 68414, 68443, 68473, 68502, 68532, 68561, 68591, 68620, 68650, 68679, 68708, 68738,
      68768, 68797, 68827, 68857, 68886, 68916, 68946, 68975, 69004, 69034, 69063, 69092, 69122, 69152, 69181, 69211, 69240, 69270, 69300, 69330,
      69359, 69388, 69418, 69447, 69476, 69506, 69535, 69565, 69595, 69624, 69654, 69684, 69713, 69743, 69772, 69802, 69831, 69861, 69890, 69919,
      69949, 69978, 70008, 70038, 70067, 70097, 70126, 70156, 70186, 70215, 70245, 70274, 70303, 70333, 70362, 70392, 70421, 70451, 70481, 70510,
      70540, 70570, 70599, 70629, 70658, 70687, 70717, 70746, 70776, 70805, 70835, 70864, 70894, 70924, 70954, 70983, 71013, 71042, 71071, 71101,
      71130, 71159, 71189, 71218, 71248, 71278, 71308, 71337, 71367, 71397, 71426, 71455, 71485, 71514, 71543, 71573, 71602, 71632, 71662, 71691,
      71721, 71751, 71781, 71810, 71839, 71869, 71898, 71927, 71957, 71986, 72016, 72046, 72075, 72105, 72135, 72164, 72194, 72223, 72253, 72282,
      72311, 72341, 72370, 72400, 72429, 72459, 72489, 72518, 72548, 72577, 72607, 72637, 72666, 72695, 72725, 72754, 72784, 72813, 72843, 72872,
      72902, 72931, 72961, 72991, 73020, 73050, 73080, 73109, 73139, 73168, 73197, 73227, 73256, 73286, 73315, 73345, 73375, 73404, 73434, 73464,
      73493, 73523, 73552, 73581, 73611, 73640, 73669, 73699, 73729, 73758, 73788, 73818, 73848, 73877, 73907, 73936, 73965, 73995, 74024, 74053,
      74083, 74113, 74142, 74172, 74202, 74231, 74261, 74291, 74320, 74349, 74379, 74408, 74437, 74467, 74497, 74526, 74556, 74586, 74615, 74645,
      74675, 74704, 74733, 74763, 74792, 74822, 74851, 74881, 74910, 74940, 74969, 74999, 75029, 75058, 75088, 75117, 75147, 75176, 75206, 75235,
      75264, 75294, 75323, 75353, 75383, 75412, 75442, 75472, 75501, 75531, 75560, 75590, 75619, 75648, 75678, 75707, 75737, 75766, 75796, 75826,
      75856, 75885, 75915, 75944, 75974, 76003, 76032, 76062, 76091, 76121, 76150, 76180, 76210, 76239, 76269, 76299, 76328, 76358, 76387, 76416,
      76446, 76475, 76505, 76534, 76564, 76593, 76623, 76653, 76682, 76712, 76741, 76771, 76801, 76830, 76859, 76889, 76918, 76948, 76977, 77007,
      77036, 77066, 77096, 77125, 77155, 77185, 77214, 77243, 77273, 77302, 77332, 77361, 77390, 77420, 77450, 77479, 77509, 77539, 77569, 77598,
      77627, 77657, 77686, 77715, 77745, 77774, 77804, 77833, 77863, 77893, 77923, 77952, 77982, 78011, 78041, 78070, 78099, 78129, 78158, 78188,
      78217, 78247, 78277, 78307, 78336, 78366, 78395, 78425, 78454, 78483, 78513, 78542, 78572, 78601, 78631, 78661, 78690, 78720, 78750, 78779,
      78808, 78838, 78867, 78897, 78926, 78956, 78985, 79015, 79044, 79074, 79104, 79133, 79163, 79192, 79222, 79251, 79281, 79310, 79340, 79369,
      79399, 79428, 79458, 79487, 79517, 79546, 79576, 79606, 79635, 79665, 79695, 79724, 79753, 79783, 79812, 79841, 79871, 79900, 79930, 79960,
      79990];
  
  
  },{"../main":593,"object-assign":473}],593:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Calendars for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var assign = _dereq_('object-assign');
  
  
  function Calendars() {
      this.regionalOptions = [];
      this.regionalOptions[''] = {
          invalidCalendar: 'Calendar {0} not found',
          invalidDate: 'Invalid {0} date',
          invalidMonth: 'Invalid {0} month',
          invalidYear: 'Invalid {0} year',
          differentCalendars: 'Cannot mix {0} and {1} dates'
      };
      this.local = this.regionalOptions[''];
      this.calendars = {};
      this._localCals = {};
  }
  
  /** Create the calendars plugin.
      <p>Provides support for various world calendars in a consistent manner.</p>
       @class Calendars
      @example _exports.instance('julian').newDate(2014, 12, 25) */
  assign(Calendars.prototype, {
  
      /** Obtain a calendar implementation and localisation.
          @memberof Calendars
          @param [name='gregorian'] {string} The name of the calendar, e.g. 'gregorian', 'persian', 'islamic'.
          @param [language=''] {string} The language code to use for localisation (default is English).
          @return {Calendar} The calendar and localisation.
          @throws Error if calendar not found. */
      instance: function(name, language) {
          name = (name || 'gregorian').toLowerCase();
          language = language || '';
          var cal = this._localCals[name + '-' + language];
          if (!cal && this.calendars[name]) {
              cal = new this.calendars[name](language);
              this._localCals[name + '-' + language] = cal;
          }
          if (!cal) {
              throw (this.local.invalidCalendar || this.regionalOptions[''].invalidCalendar).
                  replace(/\{0\}/, name);
          }
          return cal;
      },
  
      /** Create a new date - for today if no other parameters given.
          @memberof Calendars
          @param year {CDate|number} The date to copy or the year for the date.
          @param [month] {number} The month for the date.
          @param [day] {number} The day for the date.
          @param [calendar='gregorian'] {BaseCalendar|string} The underlying calendar or the name of the calendar.
          @param [language=''] {string} The language to use for localisation (default English).
          @return {CDate} The new date.
          @throws Error if an invalid date. */
      newDate: function(year, month, day, calendar, language) {
          calendar = (year != null && year.year ? year.calendar() : (typeof calendar === 'string' ?
              this.instance(calendar, language) : calendar)) || this.instance();
          return calendar.newDate(year, month, day);
      },
      
      /** A simple digit substitution function for localising numbers via the Calendar digits option.
          @member Calendars
          @param digits {string[]} The substitute digits, for 0 through 9.
          @return {function} The substitution function. */
      substituteDigits: function(digits) {
          return function(value) {
              return (value + '').replace(/[0-9]/g, function(digit) {
                  return digits[digit];
              });
          }
      },
      
      /** Digit substitution function for localising Chinese style numbers via the Calendar digits option.
          @member Calendars
          @param digits {string[]} The substitute digits, for 0 through 9.
          @param powers {string[]} The characters denoting powers of 10, i.e. 1, 10, 100, 1000.
          @return {function} The substitution function. */
      substituteChineseDigits: function(digits, powers) {
          return function(value) {
              var localNumber = '';
              var power = 0;
              while (value > 0) {
                  var units = value % 10;
                  localNumber = (units === 0 ? '' : digits[units] + powers[power]) + localNumber;
                  power++;
                  value = Math.floor(value / 10);
              }
              if (localNumber.indexOf(digits[1] + powers[1]) === 0) {
                  localNumber = localNumber.substr(1);
              }
              return localNumber || digits[0];
          }
      }
  });
  
  /** Generic date, based on a particular calendar.
      @class CDate
      @param calendar {BaseCalendar} The underlying calendar implementation.
      @param year {number} The year for this date.
      @param month {number} The month for this date.
      @param day {number} The day for this date.
      @return {CDate} The date object.
      @throws Error if an invalid date. */
  function CDate(calendar, year, month, day) {
      this._calendar = calendar;
      this._year = year;
      this._month = month;
      this._day = day;
      if (this._calendar._validateLevel === 0 &&
              !this._calendar.isValid(this._year, this._month, this._day)) {
          throw (_exports.local.invalidDate || _exports.regionalOptions[''].invalidDate).
              replace(/\{0\}/, this._calendar.local.name);
      }
  }
  
  /** Pad a numeric value with leading zeroes.
      @private
      @param value {number} The number to format.
      @param length {number} The minimum length.
      @return {string} The formatted number. */
  function pad(value, length) {
      value = '' + value;
      return '000000'.substring(0, length - value.length) + value;
  }
  
  assign(CDate.prototype, {
  
      /** Create a new date.
          @memberof CDate
          @param [year] {CDate|number} The date to copy or the year for the date (default this date).
          @param [month] {number} The month for the date.
          @param [day] {number} The day for the date.
          @return {CDate} The new date.
          @throws Error if an invalid date. */
      newDate: function(year, month, day) {
          return this._calendar.newDate((year == null ? this : year), month, day);
      },
  
      /** Set or retrieve the year for this date.
          @memberof CDate
          @param [year] {number} The year for the date.
          @return {number|CDate} The date's year (if no parameter) or the updated date.
          @throws Error if an invalid date. */
      year: function(year) {
          return (arguments.length === 0 ? this._year : this.set(year, 'y'));
      },
  
      /** Set or retrieve the month for this date.
          @memberof CDate
          @param [month] {number} The month for the date.
          @return {number|CDate} The date's month (if no parameter) or the updated date.
          @throws Error if an invalid date. */
      month: function(month) {
          return (arguments.length === 0 ? this._month : this.set(month, 'm'));
      },
  
      /** Set or retrieve the day for this date.
          @memberof CDate
          @param [day] {number} The day for the date.
          @return {number|CData} The date's day (if no parameter) or the updated date.
          @throws Error if an invalid date. */
      day: function(day) {
          return (arguments.length === 0 ? this._day : this.set(day, 'd'));
      },
  
      /** Set new values for this date.
          @memberof CDate
          @param year {number} The year for the date.
          @param month {number} The month for the date.
          @param day {number} The day for the date.
          @return {CDate} The updated date.
          @throws Error if an invalid date. */
      date: function(year, month, day) {
          if (!this._calendar.isValid(year, month, day)) {
              throw (_exports.local.invalidDate || _exports.regionalOptions[''].invalidDate).
                  replace(/\{0\}/, this._calendar.local.name);
          }
          this._year = year;
          this._month = month;
          this._day = day;
          return this;
      },
  
      /** Determine whether this date is in a leap year.
          @memberof CDate
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not. */
      leapYear: function() {
          return this._calendar.leapYear(this);
      },
  
      /** Retrieve the epoch designator for this date, e.g. BCE or CE.
          @memberof CDate
          @return {string} The current epoch. */
      epoch: function() {
          return this._calendar.epoch(this);
      },
  
      /** Format the year, if not a simple sequential number.
          @memberof CDate
          @return {string} The formatted year. */
      formatYear: function() {
          return this._calendar.formatYear(this);
      },
  
      /** Retrieve the month of the year for this date,
          i.e. the month's position within a numbered year.
          @memberof CDate
          @return {number} The month of the year: <code>minMonth</code> to months per year. */
      monthOfYear: function() {
          return this._calendar.monthOfYear(this);
      },
  
      /** Retrieve the week of the year for this date.
          @memberof CDate
          @return {number} The week of the year: 1 to weeks per year. */
      weekOfYear: function() {
          return this._calendar.weekOfYear(this);
      },
  
      /** Retrieve the number of days in the year for this date.
          @memberof CDate
          @return {number} The number of days in this year. */
      daysInYear: function() {
          return this._calendar.daysInYear(this);
      },
  
      /** Retrieve the day of the year for this date.
          @memberof CDate
          @return {number} The day of the year: 1 to days per year. */
      dayOfYear: function() {
          return this._calendar.dayOfYear(this);
      },
  
      /** Retrieve the number of days in the month for this date.
          @memberof CDate
          @return {number} The number of days. */
      daysInMonth: function() {
          return this._calendar.daysInMonth(this);
      },
  
      /** Retrieve the day of the week for this date.
          @memberof CDate
          @return {number} The day of the week: 0 to number of days - 1. */
      dayOfWeek: function() {
          return this._calendar.dayOfWeek(this);
      },
  
      /** Determine whether this date is a week day.
          @memberof CDate
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not. */
      weekDay: function() {
          return this._calendar.weekDay(this);
      },
  
      /** Retrieve additional information about this date.
          @memberof CDate
          @return {object} Additional information - contents depends on calendar. */
      extraInfo: function() {
          return this._calendar.extraInfo(this);
      },
  
      /** Add period(s) to a date.
          @memberof CDate
          @param offset {number} The number of periods to adjust by.
          @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
          @return {CDate} The updated date. */
      add: function(offset, period) {
          return this._calendar.add(this, offset, period);
      },
  
      /** Set a portion of the date.
          @memberof CDate
          @param value {number} The new value for the period.
          @param period {string} One of 'y' for year, 'm' for month, 'd' for day.
          @return {CDate} The updated date.
          @throws Error if not a valid date. */
      set: function(value, period) {
          return this._calendar.set(this, value, period);
      },
  
      /** Compare this date to another date.
          @memberof CDate
          @param date {CDate} The other date.
          @return {number} -1 if this date is before the other date,
                  0 if they are equal, or +1 if this date is after the other date. */
      compareTo: function(date) {
          if (this._calendar.name !== date._calendar.name) {
              throw (_exports.local.differentCalendars || _exports.regionalOptions[''].differentCalendars).
                  replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, date._calendar.local.name);
          }
          var c = (this._year !== date._year ? this._year - date._year :
              this._month !== date._month ? this.monthOfYear() - date.monthOfYear() :
              this._day - date._day);
          return (c === 0 ? 0 : (c < 0 ? -1 : +1));
      },
  
      /** Retrieve the calendar backing this date.
          @memberof CDate
          @return {BaseCalendar} The calendar implementation. */
      calendar: function() {
          return this._calendar;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof CDate
          @return {number} The equivalent Julian date. */
      toJD: function() {
          return this._calendar.toJD(this);
      },
  
      /** Create a new date from a Julian date.
          @memberof CDate
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          return this._calendar.fromJD(jd);
      },
  
      /** Convert this date to a standard (Gregorian) JavaScript Date.
          @memberof CDate
          @return {Date} The equivalent JavaScript date. */
      toJSDate: function() {
          return this._calendar.toJSDate(this);
      },
  
      /** Create a new date from a standard (Gregorian) JavaScript Date.
          @memberof CDate
          @param jsd {Date} The JavaScript date to convert.
          @return {CDate} The equivalent date. */
      fromJSDate: function(jsd) {
          return this._calendar.fromJSDate(jsd);
      },
  
      /** Convert to a string for display.
          @memberof CDate
          @return {string} This date as a string. */
      toString: function() {
          return (this.year() < 0 ? '-' : '') + pad(Math.abs(this.year()), 4) +
              '-' + pad(this.month(), 2) + '-' + pad(this.day(), 2);
      }
  });
  
  /** Basic functionality for all calendars.
      Other calendars should extend this:
      <pre>OtherCalendar.prototype = new BaseCalendar;</pre>
      @class BaseCalendar */
  function BaseCalendar() {
      this.shortYearCutoff = '+10';
  }
  
  assign(BaseCalendar.prototype, {
      _validateLevel: 0, // "Stack" to turn validation on/off
  
      /** Create a new date within this calendar - today if no parameters given.
          @memberof BaseCalendar
          @param year {CDate|number} The date to duplicate or the year for the date.
          @param [month] {number} The month for the date.
          @param [day] {number} The day for the date.
          @return {CDate} The new date.
          @throws Error if not a valid date or a different calendar used. */
      newDate: function(year, month, day) {
          if (year == null) {
              return this.today();
          }
          if (year.year) {
              this._validate(year, month, day,
                  _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
              day = year.day();
              month = year.month();
              year = year.year();
          }
          return new CDate(this, year, month, day);
      },
  
      /** Create a new date for today.
          @memberof BaseCalendar
          @return {CDate} Today's date. */
      today: function() {
          return this.fromJSDate(new Date());
      },
  
      /** Retrieve the epoch designator for this date.
          @memberof BaseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {string} The current epoch.
          @throws Error if an invalid year or a different calendar used. */
      epoch: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay,
              _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
          return (date.year() < 0 ? this.local.epochs[0] : this.local.epochs[1]);
      },
  
      /** Format the year, if not a simple sequential number
          @memberof BaseCalendar
          @param year {CDate|number} The date to format or the year to format.
          @return {string} The formatted year.
          @throws Error if an invalid year or a different calendar used. */
      formatYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay,
              _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
          return (date.year() < 0 ? '-' : '') + pad(Math.abs(date.year()), 4)
      },
  
      /** Retrieve the number of months in a year.
          @memberof BaseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of months.
          @throws Error if an invalid year or a different calendar used. */
      monthsInYear: function(year) {
          this._validate(year, this.minMonth, this.minDay,
              _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
          return 12;
      },
  
      /** Calculate the month's ordinal position within the year -
          for those calendars that don't start at month 1!
          @memberof BaseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param month {number} The month to examine.
          @return {number} The ordinal position, starting from <code>minMonth</code>.
          @throws Error if an invalid year/month or a different calendar used. */
      monthOfYear: function(year, month) {
          var date = this._validate(year, month, this.minDay,
              _exports.local.invalidMonth || _exports.regionalOptions[''].invalidMonth);
          return (date.month() + this.monthsInYear(date) - this.firstMonth) %
              this.monthsInYear(date) + this.minMonth;
      },
  
      /** Calculate actual month from ordinal position, starting from minMonth.
          @memberof BaseCalendar
          @param year {number} The year to examine.
          @param ord {number} The month's ordinal position.
          @return {number} The month's number.
          @throws Error if an invalid year/month. */
      fromMonthOfYear: function(year, ord) {
          var m = (ord + this.firstMonth - 2 * this.minMonth) %
              this.monthsInYear(year) + this.minMonth;
          this._validate(year, m, this.minDay,
              _exports.local.invalidMonth || _exports.regionalOptions[''].invalidMonth);
          return m;
      },
  
      /** Retrieve the number of days in a year.
          @memberof BaseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {number} The number of days.
          @throws Error if an invalid year or a different calendar used. */
      daysInYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay,
              _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
          return (this.leapYear(date) ? 366 : 365);
      },
  
      /** Retrieve the day of the year for a date.
          @memberof BaseCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The day of the year.
          @throws Error if an invalid date or a different calendar used. */
      dayOfYear: function(year, month, day) {
          var date = this._validate(year, month, day,
              _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
          return date.toJD() - this.newDate(date.year(),
              this.fromMonthOfYear(date.year(), this.minMonth), this.minDay).toJD() + 1;
      },
  
      /** Retrieve the number of days in a week.
          @memberof BaseCalendar
          @return {number} The number of days. */
      daysInWeek: function() {
          return 7;
      },
  
      /** Retrieve the day of the week for a date.
          @memberof BaseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The day of the week: 0 to number of days - 1.
          @throws Error if an invalid date or a different calendar used. */
      dayOfWeek: function(year, month, day) {
          var date = this._validate(year, month, day,
              _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
          return (Math.floor(this.toJD(date)) + 2) % this.daysInWeek();
      },
  
      /** Retrieve additional information about a date.
          @memberof BaseCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {object} Additional information - contents depends on calendar.
          @throws Error if an invalid date or a different calendar used. */
      extraInfo: function(year, month, day) {
          this._validate(year, month, day,
              _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
          return {};
      },
  
      /** Add period(s) to a date.
          Cater for no year zero.
          @memberof BaseCalendar
          @param date {CDate} The starting date.
          @param offset {number} The number of periods to adjust by.
          @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
          @return {CDate} The updated date.
          @throws Error if a different calendar used. */
      add: function(date, offset, period) {
          this._validate(date, this.minMonth, this.minDay,
              _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
          return this._correctAdd(date, this._add(date, offset, period), offset, period);
      },
  
      /** Add period(s) to a date.
          @memberof BaseCalendar
          @private
          @param date {CDate} The starting date.
          @param offset {number} The number of periods to adjust by.
          @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
          @return {CDate} The updated date. */
      _add: function(date, offset, period) {
          this._validateLevel++;
          if (period === 'd' || period === 'w') {
              var jd = date.toJD() + offset * (period === 'w' ? this.daysInWeek() : 1);
              var d = date.calendar().fromJD(jd);
              this._validateLevel--;
              return [d.year(), d.month(), d.day()];
          }
          try {
              var y = date.year() + (period === 'y' ? offset : 0);
              var m = date.monthOfYear() + (period === 'm' ? offset : 0);
              var d = date.day();// + (period === 'd' ? offset : 0) +
                  //(period === 'w' ? offset * this.daysInWeek() : 0);
              var resyncYearMonth = function(calendar) {
                  while (m < calendar.minMonth) {
                      y--;
                      m += calendar.monthsInYear(y);
                  }
                  var yearMonths = calendar.monthsInYear(y);
                  while (m > yearMonths - 1 + calendar.minMonth) {
                      y++;
                      m -= yearMonths;
                      yearMonths = calendar.monthsInYear(y);
                  }
              };
              if (period === 'y') {
                  if (date.month() !== this.fromMonthOfYear(y, m)) { // Hebrew
                      m = this.newDate(y, date.month(), this.minDay).monthOfYear();
                  }
                  m = Math.min(m, this.monthsInYear(y));
                  d = Math.min(d, this.daysInMonth(y, this.fromMonthOfYear(y, m)));
              }
              else if (period === 'm') {
                  resyncYearMonth(this);
                  d = Math.min(d, this.daysInMonth(y, this.fromMonthOfYear(y, m)));
              }
              var ymd = [y, this.fromMonthOfYear(y, m), d];
              this._validateLevel--;
              return ymd;
          }
          catch (e) {
              this._validateLevel--;
              throw e;
          }
      },
  
      /** Correct a candidate date after adding period(s) to a date.
          Handle no year zero if necessary.
          @memberof BaseCalendar
          @private
          @param date {CDate} The starting date.
          @param ymd {number[]} The added date.
          @param offset {number} The number of periods to adjust by.
          @param period {string} One of 'y' for year, 'm' for month, 'w' for week, 'd' for day.
          @return {CDate} The updated date. */
      _correctAdd: function(date, ymd, offset, period) {
          if (!this.hasYearZero && (period === 'y' || period === 'm')) {
              if (ymd[0] === 0 || // In year zero
                      (date.year() > 0) !== (ymd[0] > 0)) { // Crossed year zero
                  var adj = {y: [1, 1, 'y'], m: [1, this.monthsInYear(-1), 'm'],
                      w: [this.daysInWeek(), this.daysInYear(-1), 'd'],
                      d: [1, this.daysInYear(-1), 'd']}[period];
                  var dir = (offset < 0 ? -1 : +1);
                  ymd = this._add(date, offset * adj[0] + dir * adj[1], adj[2]);
              }
          }
          return date.date(ymd[0], ymd[1], ymd[2]);
      },
  
      /** Set a portion of the date.
          @memberof BaseCalendar
          @param date {CDate} The starting date.
          @param value {number} The new value for the period.
          @param period {string} One of 'y' for year, 'm' for month, 'd' for day.
          @return {CDate} The updated date.
          @throws Error if an invalid date or a different calendar used. */
      set: function(date, value, period) {
          this._validate(date, this.minMonth, this.minDay,
              _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
          var y = (period === 'y' ? value : date.year());
          var m = (period === 'm' ? value : date.month());
          var d = (period === 'd' ? value : date.day());
          if (period === 'y' || period === 'm') {
              d = Math.min(d, this.daysInMonth(y, m));
          }
          return date.date(y, m, d);
      },
  
      /** Determine whether a date is valid for this calendar.
          @memberof BaseCalendar
          @param year {number} The year to examine.
          @param month {number} The month to examine.
          @param day {number} The day to examine.
          @return {boolean} <code>true</code> if a valid date, <code>false</code> if not. */
      isValid: function(year, month, day) {
          this._validateLevel++;
          var valid = (this.hasYearZero || year !== 0);
          if (valid) {
              var date = this.newDate(year, month, this.minDay);
              valid = (month >= this.minMonth && month - this.minMonth < this.monthsInYear(date)) &&
                  (day >= this.minDay && day - this.minDay < this.daysInMonth(date));
          }
          this._validateLevel--;
          return valid;
      },
  
      /** Convert the date to a standard (Gregorian) JavaScript Date.
          @memberof BaseCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {Date} The equivalent JavaScript date.
          @throws Error if an invalid date or a different calendar used. */
      toJSDate: function(year, month, day) {
          var date = this._validate(year, month, day,
              _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
          return _exports.instance().fromJD(this.toJD(date)).toJSDate();
      },
  
      /** Convert the date from a standard (Gregorian) JavaScript Date.
          @memberof BaseCalendar
          @param jsd {Date} The JavaScript date.
          @return {CDate} The equivalent calendar date. */
      fromJSDate: function(jsd) {
          return this.fromJD(_exports.instance().fromJSDate(jsd).toJD());
      },
  
      /** Check that a candidate date is from the same calendar and is valid.
          @memberof BaseCalendar
          @private
          @param year {CDate|number} The date to validate or the year to validate.
          @param [month] {number} The month to validate.
          @param [day] {number} The day to validate.
          @param error {string} Rrror message if invalid.
          @throws Error if different calendars used or invalid date. */
      _validate: function(year, month, day, error) {
          if (year.year) {
              if (this._validateLevel === 0 && this.name !== year.calendar().name) {
                  throw (_exports.local.differentCalendars || _exports.regionalOptions[''].differentCalendars).
                      replace(/\{0\}/, this.local.name).replace(/\{1\}/, year.calendar().local.name);
              }
              return year;
          }
          try {
              this._validateLevel++;
              if (this._validateLevel === 1 && !this.isValid(year, month, day)) {
                  throw error.replace(/\{0\}/, this.local.name);
              }
              var date = this.newDate(year, month, day);
              this._validateLevel--;
              return date;
          }
          catch (e) {
              this._validateLevel--;
              throw e;
          }
      }
  });
  
  /** Implementation of the Proleptic Gregorian Calendar.
      See <a href=":http://en.wikipedia.org/wiki/Gregorian_calendar">http://en.wikipedia.org/wiki/Gregorian_calendar</a>
      and <a href="http://en.wikipedia.org/wiki/Proleptic_Gregorian_calendar">http://en.wikipedia.org/wiki/Proleptic_Gregorian_calendar</a>.
      @class GregorianCalendar
      @augments BaseCalendar
      @param [language=''] {string} The language code (default English) for localisation. */
  function GregorianCalendar(language) {
      this.local = this.regionalOptions[language] || this.regionalOptions[''];
  }
  
  GregorianCalendar.prototype = new BaseCalendar;
  
  assign(GregorianCalendar.prototype, {
      /** The calendar name.
          @memberof GregorianCalendar */
      name: 'Gregorian',
       /** Julian date of start of Gregorian epoch: 1 January 0001 CE.
          @memberof GregorianCalendar */
      jdEpoch: 1721425.5,
       /** Days per month in a common year.
          @memberof GregorianCalendar */
      daysPerMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
       /** <code>true</code> if has a year zero, <code>false</code> if not.
          @memberof GregorianCalendar */
      hasYearZero: false,
      /** The minimum month number.
          @memberof GregorianCalendar */
      minMonth: 1,
      /** The first month in the year.
          @memberof GregorianCalendar */
      firstMonth: 1,
       /** The minimum day number.
          @memberof GregorianCalendar */
      minDay: 1,
  
      /** Localisations for the plugin.
          Entries are objects indexed by the language code ('' being the default US/English).
          Each object has the following attributes.
          @memberof GregorianCalendar
          @property name {string} The calendar name.
          @property epochs {string[]} The epoch names.
          @property monthNames {string[]} The long names of the months of the year.
          @property monthNamesShort {string[]} The short names of the months of the year.
          @property dayNames {string[]} The long names of the days of the week.
          @property dayNamesShort {string[]} The short names of the days of the week.
          @property dayNamesMin {string[]} The minimal names of the days of the week.
          @property dateFormat {string} The date format for this calendar.
                  See the options on <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a> for details.
          @property firstDay {number} The number of the first day of the week, starting at 0.
          @property isRTL {number} <code>true</code> if this localisation reads right-to-left. */
      regionalOptions: { // Localisations
          '': {
              name: 'Gregorian',
              epochs: ['BCE', 'CE'],
              monthNames: ['January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'],
              monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
              dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
              dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
              digits: null,
              dateFormat: 'mm/dd/yyyy',
              firstDay: 0,
              isRTL: false
          }
      },
      
      /** Determine whether this date is in a leap year.
          @memberof GregorianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @return {boolean} <code>true</code> if this is a leap year, <code>false</code> if not.
          @throws Error if an invalid year or a different calendar used. */
      leapYear: function(year) {
          var date = this._validate(year, this.minMonth, this.minDay,
              _exports.local.invalidYear || _exports.regionalOptions[''].invalidYear);
          var year = date.year() + (date.year() < 0 ? 1 : 0); // No year zero
          return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
      },
  
      /** Determine the week of the year for a date - ISO 8601.
          @memberof GregorianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {number} The week of the year, starting from 1.
          @throws Error if an invalid date or a different calendar used. */
      weekOfYear: function(year, month, day) {
          // Find Thursday of this week starting on Monday
          var checkDate = this.newDate(year, month, day);
          checkDate.add(4 - (checkDate.dayOfWeek() || 7), 'd');
          return Math.floor((checkDate.dayOfYear() - 1) / 7) + 1;
      },
  
      /** Retrieve the number of days in a month.
          @memberof GregorianCalendar
          @param year {CDate|number} The date to examine or the year of the month.
          @param [month] {number} The month.
          @return {number} The number of days in this month.
          @throws Error if an invalid month/year or a different calendar used. */
      daysInMonth: function(year, month) {
          var date = this._validate(year, month, this.minDay,
              _exports.local.invalidMonth || _exports.regionalOptions[''].invalidMonth);
          return this.daysPerMonth[date.month() - 1] +
              (date.month() === 2 && this.leapYear(date.year()) ? 1 : 0);
      },
  
      /** Determine whether this date is a week day.
          @memberof GregorianCalendar
          @param year {CDate|number} The date to examine or the year to examine.
          @param [month] {number} The month to examine.
          @param [day] {number} The day to examine.
          @return {boolean} <code>true</code> if a week day, <code>false</code> if not.
          @throws Error if an invalid date or a different calendar used. */
      weekDay: function(year, month, day) {
          return (this.dayOfWeek(year, month, day) || 7) < 6;
      },
  
      /** Retrieve the Julian date equivalent for this date,
          i.e. days since January 1, 4713 BCE Greenwich noon.
          @memberof GregorianCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {number} The equivalent Julian date.
          @throws Error if an invalid date or a different calendar used. */
      toJD: function(year, month, day) {
          var date = this._validate(year, month, day,
              _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
          year = date.year();
          month = date.month();
          day = date.day();
          if (year < 0) { year++; } // No year zero
          // Jean Meeus algorithm, "Astronomical Algorithms", 1991
          if (month < 3) {
              month += 12;
              year--;
          }
          var a = Math.floor(year / 100);
          var b = 2 - a + Math.floor(a / 4);
          return Math.floor(365.25 * (year + 4716)) +
              Math.floor(30.6001 * (month + 1)) + day + b - 1524.5;
      },
  
      /** Create a new date from a Julian date.
          @memberof GregorianCalendar
          @param jd {number} The Julian date to convert.
          @return {CDate} The equivalent date. */
      fromJD: function(jd) {
          // Jean Meeus algorithm, "Astronomical Algorithms", 1991
          var z = Math.floor(jd + 0.5);
          var a = Math.floor((z - 1867216.25) / 36524.25);
          a = z + 1 + a - Math.floor(a / 4);
          var b = a + 1524;
          var c = Math.floor((b - 122.1) / 365.25);
          var d = Math.floor(365.25 * c);
          var e = Math.floor((b - d) / 30.6001);
          var day = b - d - Math.floor(e * 30.6001);
          var month = e - (e > 13.5 ? 13 : 1);
          var year = c - (month > 2.5 ? 4716 : 4715);
          if (year <= 0) { year--; } // No year zero
          return this.newDate(year, month, day);
      },
  
      /** Convert this date to a standard (Gregorian) JavaScript Date.
          @memberof GregorianCalendar
          @param year {CDate|number} The date to convert or the year to convert.
          @param [month] {number} The month to convert.
          @param [day] {number} The day to convert.
          @return {Date} The equivalent JavaScript date.
          @throws Error if an invalid date or a different calendar used. */
      toJSDate: function(year, month, day) {
          var date = this._validate(year, month, day,
              _exports.local.invalidDate || _exports.regionalOptions[''].invalidDate);
          var jsd = new Date(date.year(), date.month() - 1, date.day());
          jsd.setHours(0);
          jsd.setMinutes(0);
          jsd.setSeconds(0);
          jsd.setMilliseconds(0);
          // Hours may be non-zero on daylight saving cut-over:
          // > 12 when midnight changeover, but then cannot generate
          // midnight datetime, so jump to 1AM, otherwise reset.
          jsd.setHours(jsd.getHours() > 12 ? jsd.getHours() + 2 : 0);
          return jsd;
      },
  
      /** Create a new date from a standard (Gregorian) JavaScript Date.
          @memberof GregorianCalendar
          @param jsd {Date} The JavaScript date to convert.
          @return {CDate} The equivalent date. */
      fromJSDate: function(jsd) {
          return this.newDate(jsd.getFullYear(), jsd.getMonth() + 1, jsd.getDate());
      }
  });
  
  // Singleton manager
  var _exports = module.exports = new Calendars();
  
  // Date template
  _exports.cdate = CDate;
  
  // Base calendar template
  _exports.baseCalendar = BaseCalendar;
  
  // Gregorian calendar implementation
  _exports.calendars.gregorian = GregorianCalendar;
  
  
  },{"object-assign":473}],594:[function(_dereq_,module,exports){
  /*
   * World Calendars
   * https://github.com/alexcjohnson/world-calendars
   *
   * Batch-converted from kbwood/calendars
   * Many thanks to Keith Wood and all of the contributors to the original project!
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  
  ﻿/* http://keith-wood.name/calendars.html
     Calendars extras for jQuery v2.0.2.
     Written by Keith Wood (wood.keith{at}optusnet.com.au) August 2009.
     Available under the MIT (http://keith-wood.name/licence.html) license. 
     Please attribute the author if you use it. */
  
  var assign = _dereq_('object-assign');
  var main = _dereq_('./main');
  
  
  assign(main.regionalOptions[''], {
      invalidArguments: 'Invalid arguments',
      invalidFormat: 'Cannot format a date from another calendar',
      missingNumberAt: 'Missing number at position {0}',
      unknownNameAt: 'Unknown name at position {0}',
      unexpectedLiteralAt: 'Unexpected literal at position {0}',
      unexpectedText: 'Additional text found at end'
  });
  main.local = main.regionalOptions[''];
  
  assign(main.cdate.prototype, {
  
      /** Format this date.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof CDate
          @param [format] {string} The date format to use (see <a href="BaseCalendar.html#formatDate"><code>formatDate</code></a>).
          @param [settings] {object} Options for the <code>formatDate</code> function.
          @return {string} The formatted date. */
      formatDate: function(format, settings) {
          if (typeof format !== 'string') {
              settings = format;
              format = '';
          }
          return this._calendar.formatDate(format || '', this, settings);
      }
  });
  
  assign(main.baseCalendar.prototype, {
  
      UNIX_EPOCH: main.instance().newDate(1970, 1, 1).toJD(),
      SECS_PER_DAY: 24 * 60 * 60,
      TICKS_EPOCH: main.instance().jdEpoch, // 1 January 0001 CE
      TICKS_PER_DAY: 24 * 60 * 60 * 10000000,
  
      /** Date form for ATOM (RFC 3339/ISO 8601).
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      ATOM: 'yyyy-mm-dd',
      /** Date form for cookies.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      COOKIE: 'D, dd M yyyy',
      /** Date form for full date.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      FULL: 'DD, MM d, yyyy',
      /** Date form for ISO 8601.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      ISO_8601: 'yyyy-mm-dd',
      /** Date form for Julian date.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      JULIAN: 'J',
      /** Date form for RFC 822.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      RFC_822: 'D, d M yy',
      /** Date form for RFC 850.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      RFC_850: 'DD, dd-M-yy',
      /** Date form for RFC 1036.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      RFC_1036: 'D, d M yy',
      /** Date form for RFC 1123.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      RFC_1123: 'D, d M yyyy',
      /** Date form for RFC 2822.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      RFC_2822: 'D, d M yyyy',
      /** Date form for RSS (RFC 822).
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      RSS: 'D, d M yy',
      /** Date form for Windows ticks.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      TICKS: '!',
      /** Date form for Unix timestamp.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      TIMESTAMP: '@',
      /** Date form for W3c (ISO 8601).
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar */
      W3C: 'yyyy-mm-dd',
  
      /** Format a date object into a string value.
          The format can be combinations of the following:
          <ul>
          <li>d  - day of month (no leading zero)</li>
          <li>dd - day of month (two digit)</li>
          <li>o  - day of year (no leading zeros)</li>
          <li>oo - day of year (three digit)</li>
          <li>D  - day name short</li>
          <li>DD - day name long</li>
          <li>w  - week of year (no leading zero)</li>
          <li>ww - week of year (two digit)</li>
          <li>m  - month of year (no leading zero)</li>
          <li>mm - month of year (two digit)</li>
          <li>M  - month name short</li>
          <li>MM - month name long</li>
          <li>yy - year (two digit)</li>
          <li>yyyy - year (four digit)</li>
          <li>YYYY - formatted year</li>
          <li>J  - Julian date (days since January 1, 4713 BCE Greenwich noon)</li>
          <li>@  - Unix timestamp (s since 01/01/1970)</li>
          <li>!  - Windows ticks (100ns since 01/01/0001)</li>
          <li>'...' - literal text</li>
          <li>'' - single quote</li>
          </ul>
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar
          @param [format] {string} The desired format of the date (defaults to calendar format).
          @param date {CDate} The date value to format.
          @param [settings] {object} Addition options, whose attributes include:
          @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
          @property [dayNames] {string[]} Names of the days from Sunday.
          @property [monthNamesShort] {string[]} Abbreviated names of the months.
          @property [monthNames] {string[]} Names of the months.
          @property [calculateWeek] {CalendarsPickerCalculateWeek} Function that determines week of the year.
          @property [localNumbers=false] {boolean} <code>true</code> to localise numbers (if available),
                    <code>false</code> to use normal Arabic numerals.
          @return {string} The date in the above format.
          @throws Errors if the date is from a different calendar. */
      formatDate: function(format, date, settings) {
          if (typeof format !== 'string') {
              settings = date;
              date = format;
              format = '';
          }
          if (!date) {
              return '';
          }
          if (date.calendar() !== this) {
              throw main.local.invalidFormat || main.regionalOptions[''].invalidFormat;
          }
          format = format || this.local.dateFormat;
          settings = settings || {};
          var dayNamesShort = settings.dayNamesShort || this.local.dayNamesShort;
          var dayNames = settings.dayNames || this.local.dayNames;
          var monthNumbers = settings.monthNumbers || this.local.monthNumbers;
          var monthNamesShort = settings.monthNamesShort || this.local.monthNamesShort;
          var monthNames = settings.monthNames || this.local.monthNames;
          var calculateWeek = settings.calculateWeek || this.local.calculateWeek;
          // Check whether a format character is doubled
          var doubled = function(match, step) {
              var matches = 1;
              while (iFormat + matches < format.length && format.charAt(iFormat + matches) === match) {
                  matches++;
              }
              iFormat += matches - 1;
              return Math.floor(matches / (step || 1)) > 1;
          };
          // Format a number, with leading zeroes if necessary
          var formatNumber = function(match, value, len, step) {
              var num = '' + value;
              if (doubled(match, step)) {
                  while (num.length < len) {
                      num = '0' + num;
                  }
              }
              return num;
          };
          // Format a name, short or long as requested
          var formatName = function(match, value, shortNames, longNames) {
              return (doubled(match) ? longNames[value] : shortNames[value]);
          };
          // Format month number
          // (e.g. Chinese calendar needs to account for intercalary months)
          var calendar = this;
          var formatMonth = function(date) {
              return (typeof monthNumbers === 'function') ?
                  monthNumbers.call(calendar, date, doubled('m')) :
                  localiseNumbers(formatNumber('m', date.month(), 2));
          };
          // Format a month name, short or long as requested
          var formatMonthName = function(date, useLongName) {
              if (useLongName) {
                  return (typeof monthNames === 'function') ?
                      monthNames.call(calendar, date) :
                      monthNames[date.month() - calendar.minMonth];
              } else {
                  return (typeof monthNamesShort === 'function') ?
                      monthNamesShort.call(calendar, date) :
                      monthNamesShort[date.month() - calendar.minMonth];
              }
          };
          // Localise numbers if requested and available
          var digits = this.local.digits;
          var localiseNumbers = function(value) {
              return (settings.localNumbers && digits ? digits(value) : value);
          };
          var output = '';
          var literal = false;
          for (var iFormat = 0; iFormat < format.length; iFormat++) {
              if (literal) {
                  if (format.charAt(iFormat) === "'" && !doubled("'")) {
                      literal = false;
                  }
                  else {
                      output += format.charAt(iFormat);
                  }
              }
              else {
                  switch (format.charAt(iFormat)) {
                      case 'd': output += localiseNumbers(formatNumber('d', date.day(), 2)); break;
                      case 'D': output += formatName('D', date.dayOfWeek(),
                          dayNamesShort, dayNames); break;
                      case 'o': output += formatNumber('o', date.dayOfYear(), 3); break;
                      case 'w': output += formatNumber('w', date.weekOfYear(), 2); break;
                      case 'm': output += formatMonth(date); break;
                      case 'M': output += formatMonthName(date, doubled('M')); break;
                      case 'y':
                          output += (doubled('y', 2) ? date.year() :
                              (date.year() % 100 < 10 ? '0' : '') + date.year() % 100);
                          break;
                      case 'Y':
                          doubled('Y', 2);
                          output += date.formatYear();
                          break;
                      case 'J': output += date.toJD(); break;
                      case '@': output += (date.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY; break;
                      case '!': output += (date.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY; break;
                      case "'":
                          if (doubled("'")) {
                              output += "'";
                          }
                          else {
                              literal = true;
                          }
                          break;
                      default:
                          output += format.charAt(iFormat);
                  }
              }
          }
          return output;
      },
  
      /** Parse a string value into a date object.
          See <a href="#formatDate"><code>formatDate</code></a> for the possible formats, plus:
          <ul>
          <li>* - ignore rest of string</li>
          </ul>
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar
          @param format {string} The expected format of the date ('' for default calendar format).
          @param value {string} The date in the above format.
          @param [settings] {object} Additional options whose attributes include:
          @property [shortYearCutoff] {number} The cutoff year for determining the century.
          @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
          @property [dayNames] {string[]} Names of the days from Sunday.
          @property [monthNamesShort] {string[]} Abbreviated names of the months.
          @property [monthNames] {string[]} Names of the months.
          @return {CDate} The extracted date value or <code>null</code> if value is blank.
          @throws Errors if the format and/or value are missing,
                  if the value doesn't match the format, or if the date is invalid. */
      parseDate: function(format, value, settings) {
          if (value == null) {
              throw main.local.invalidArguments || main.regionalOptions[''].invalidArguments;
          }
          value = (typeof value === 'object' ? value.toString() : value + '');
          if (value === '') {
              return null;
          }
          format = format || this.local.dateFormat;
          settings = settings || {};
          var shortYearCutoff = settings.shortYearCutoff || this.shortYearCutoff;
          shortYearCutoff = (typeof shortYearCutoff !== 'string' ? shortYearCutoff :
              this.today().year() % 100 + parseInt(shortYearCutoff, 10));
          var dayNamesShort = settings.dayNamesShort || this.local.dayNamesShort;
          var dayNames = settings.dayNames || this.local.dayNames;
          var parseMonth = settings.parseMonth || this.local.parseMonth;
          var monthNumbers = settings.monthNumbers || this.local.monthNumbers;
          var monthNamesShort = settings.monthNamesShort || this.local.monthNamesShort;
          var monthNames = settings.monthNames || this.local.monthNames;
          var jd = -1;
          var year = -1;
          var month = -1;
          var day = -1;
          var doy = -1;
          var shortYear = false;
          var literal = false;
          // Check whether a format character is doubled
          var doubled = function(match, step) {
              var matches = 1;
              while (iFormat + matches < format.length && format.charAt(iFormat + matches) === match) {
                  matches++;
              }
              iFormat += matches - 1;
              return Math.floor(matches / (step || 1)) > 1;
          };
          // Extract a number from the string value
          var getNumber = function(match, step) {
              var isDoubled = doubled(match, step);
              var size = [2, 3, isDoubled ? 4 : 2, isDoubled ? 4 : 2, 10, 11, 20]['oyYJ@!'.indexOf(match) + 1];
              var digits = new RegExp('^-?\\d{1,' + size + '}');
              var num = value.substring(iValue).match(digits);
              if (!num) {
                  throw (main.local.missingNumberAt || main.regionalOptions[''].missingNumberAt).
                      replace(/\{0\}/, iValue);
              }
              iValue += num[0].length;
              return parseInt(num[0], 10);
          };
          // Extract a month number from the string value
          var calendar = this;
          var getMonthNumber = function() {
              if (typeof monthNumbers === 'function') {
                  doubled('m');  // update iFormat
                  var month = monthNumbers.call(calendar, value.substring(iValue));
                  iValue += month.length;
                  return month;
              }
  
              return getNumber('m');
          };
          // Extract a name from the string value and convert to an index
          var getName = function(match, shortNames, longNames, step) {
              var names = (doubled(match, step) ? longNames : shortNames);
              for (var i = 0; i < names.length; i++) {
                  if (value.substr(iValue, names[i].length).toLowerCase() === names[i].toLowerCase()) {
                      iValue += names[i].length;
                      return i + calendar.minMonth;
                  }
              }
              throw (main.local.unknownNameAt || main.regionalOptions[''].unknownNameAt).
                  replace(/\{0\}/, iValue);
          };
          // Extract a month number from the string value
          var getMonthName = function() {
              if (typeof monthNames === 'function') {
                  var month = doubled('M') ?
                      monthNames.call(calendar, value.substring(iValue)) :
                      monthNamesShort.call(calendar, value.substring(iValue));
                  iValue += month.length;
                  return month;
              }
  
              return getName('M', monthNamesShort, monthNames);
          };
          // Confirm that a literal character matches the string value
          var checkLiteral = function() {
              if (value.charAt(iValue) !== format.charAt(iFormat)) {
                  throw (main.local.unexpectedLiteralAt ||
                      main.regionalOptions[''].unexpectedLiteralAt).replace(/\{0\}/, iValue);
              }
              iValue++;
          };
          var iValue = 0;
          for (var iFormat = 0; iFormat < format.length; iFormat++) {
              if (literal) {
                  if (format.charAt(iFormat) === "'" && !doubled("'")) {
                      literal = false;
                  }
                  else {
                      checkLiteral();
                  }
              }
              else {
                  switch (format.charAt(iFormat)) {
                      case 'd': day = getNumber('d'); break;
                      case 'D': getName('D', dayNamesShort, dayNames); break;
                      case 'o': doy = getNumber('o'); break;
                      case 'w': getNumber('w'); break;
                      case 'm': month = getMonthNumber(); break;
                      case 'M': month = getMonthName(); break;
                      case 'y':
                          var iSave = iFormat;
                          shortYear = !doubled('y', 2);
                          iFormat = iSave;
                          year = getNumber('y', 2);
                          break;
                      case 'Y': year = getNumber('Y', 2); break;
                      case 'J':
                          jd = getNumber('J') + 0.5;
                          if (value.charAt(iValue) === '.') {
                              iValue++;
                              getNumber('J');
                          }
                          break;
                      case '@': jd = getNumber('@') / this.SECS_PER_DAY + this.UNIX_EPOCH; break;
                      case '!': jd = getNumber('!') / this.TICKS_PER_DAY + this.TICKS_EPOCH; break;
                      case '*': iValue = value.length; break;
                      case "'":
                          if (doubled("'")) {
                              checkLiteral();
                          }
                          else {
                              literal = true;
                          }
                          break;
                      default: checkLiteral();
                  }
              }
          }
          if (iValue < value.length) {
              throw main.local.unexpectedText || main.regionalOptions[''].unexpectedText;
          }
          if (year === -1) {
              year = this.today().year();
          }
          else if (year < 100 && shortYear) {
              year += (shortYearCutoff === -1 ? 1900 : this.today().year() -
                  this.today().year() % 100 - (year <= shortYearCutoff ? 0 : 100));
          }
          if (typeof month === 'string') {
              month = parseMonth.call(this, year, month);
          }
          if (doy > -1) {
              month = 1;
              day = doy;
              for (var dim = this.daysInMonth(year, month); day > dim; dim = this.daysInMonth(year, month)) {
                  month++;
                  day -= dim;
              }
          }
          return (jd > -1 ? this.fromJD(jd) : this.newDate(year, month, day));
      },
  
      /** A date may be specified as an exact value or a relative one.
          Found in the <code>jquery.calendars.plus.js</code> module.
          @memberof BaseCalendar
          @param dateSpec {CDate|number|string} The date as an object or string in the given format or
                  an offset - numeric days from today, or string amounts and periods, e.g. '+1m +2w'.
          @param defaultDate {CDate} The date to use if no other supplied, may be <code>null</code>.
          @param currentDate {CDate} The current date as a possible basis for relative dates,
                  if <code>null</code> today is used (optional)
          @param [dateFormat] {string} The expected date format - see <a href="#formatDate"><code>formatDate</code></a>.
          @param [settings] {object} Additional options whose attributes include:
          @property [shortYearCutoff] {number} The cutoff year for determining the century.
          @property [dayNamesShort] {string[]} Abbreviated names of the days from Sunday.
          @property [dayNames] {string[]} Names of the days from Sunday.
          @property [monthNamesShort] {string[]} Abbreviated names of the months.
          @property [monthNames] {string[]} Names of the months.
          @return {CDate} The decoded date. */
      determineDate: function(dateSpec, defaultDate, currentDate, dateFormat, settings) {
          if (currentDate && typeof currentDate !== 'object') {
              settings = dateFormat;
              dateFormat = currentDate;
              currentDate = null;
          }
          if (typeof dateFormat !== 'string') {
              settings = dateFormat;
              dateFormat = '';
          }
          var calendar = this;
          var offsetString = function(offset) {
              try {
                  return calendar.parseDate(dateFormat, offset, settings);
              }
              catch (e) {
                  // Ignore
              }
              offset = offset.toLowerCase();
              var date = (offset.match(/^c/) && currentDate ?
                  currentDate.newDate() : null) || calendar.today();
              var pattern = /([+-]?[0-9]+)\s*(d|w|m|y)?/g;
              var matches = pattern.exec(offset);
              while (matches) {
                  date.add(parseInt(matches[1], 10), matches[2] || 'd');
                  matches = pattern.exec(offset);
              }
              return date;
          };
          defaultDate = (defaultDate ? defaultDate.newDate() : null);
          dateSpec = (dateSpec == null ? defaultDate :
              (typeof dateSpec === 'string' ? offsetString(dateSpec) : (typeof dateSpec === 'number' ?
              (isNaN(dateSpec) || dateSpec === Infinity || dateSpec === -Infinity ? defaultDate :
              calendar.today().add(dateSpec, 'd')) : calendar.newDate(dateSpec))));
          return dateSpec;
      }
  });
  
  
  },{"./main":593,"object-assign":473}],595:[function(_dereq_,module,exports){
  module.exports = _dereq_('cwise-compiler')({
      args: ['array', {
          offset: [1],
          array: 0
      }, 'scalar', 'scalar', 'index'],
      pre: {
          "body": "{}",
          "args": [],
          "thisVars": [],
          "localVars": []
      },
      post: {
          "body": "{}",
          "args": [],
          "thisVars": [],
          "localVars": []
      },
      body: {
          "body": "{\n        var _inline_1_da = _inline_1_arg0_ - _inline_1_arg3_\n        var _inline_1_db = _inline_1_arg1_ - _inline_1_arg3_\n        if((_inline_1_da >= 0) !== (_inline_1_db >= 0)) {\n          _inline_1_arg2_.push(_inline_1_arg4_[0] + 0.5 + 0.5 * (_inline_1_da + _inline_1_db) / (_inline_1_da - _inline_1_db))\n        }\n      }",
          "args": [{
              "name": "_inline_1_arg0_",
              "lvalue": false,
              "rvalue": true,
              "count": 1
          }, {
              "name": "_inline_1_arg1_",
              "lvalue": false,
              "rvalue": true,
              "count": 1
          }, {
              "name": "_inline_1_arg2_",
              "lvalue": false,
              "rvalue": true,
              "count": 1
          }, {
              "name": "_inline_1_arg3_",
              "lvalue": false,
              "rvalue": true,
              "count": 2
          }, {
              "name": "_inline_1_arg4_",
              "lvalue": false,
              "rvalue": true,
              "count": 1
          }],
          "thisVars": [],
          "localVars": ["_inline_1_da", "_inline_1_db"]
      },
      funcName: 'zeroCrossings'
  })
  
  },{"cwise-compiler":151}],596:[function(_dereq_,module,exports){
  "use strict"
  
  module.exports = findZeroCrossings
  
  var core = _dereq_("./lib/zc-core")
  
  function findZeroCrossings(array, level) {
    var cross = []
    level = +level || 0.0
    core(array.hi(array.shape[0]-1), cross, level)
    return cross
  }
  },{"./lib/zc-core":595}],597:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /**
   * All paths are tuned for maximum scalability of the arrowhead,
   * ie throughout arrowwidth=0.3..3 the head is joined smoothly
   * to the line, with the line coming from the left and ending at (0, 0).
   *
   * `backoff` is the distance to move the arrowhead and the end of the line,
   * in order that the arrowhead points to the desired place, either at
   * the tip of the arrow or (in the case of circle or square)
   * the center of the symbol.
   *
   * `noRotate`, if truthy, says that this arrowhead should not rotate with the
   * arrow. That's the case for squares, which should always be straight, and
   * circles, for which it's irrelevant.
   */
  
  module.exports = [
      // no arrow
      {
          path: '',
          backoff: 0
      },
      // wide with flat back
      {
          path: 'M-2.4,-3V3L0.6,0Z',
          backoff: 0.6
      },
      // narrower with flat back
      {
          path: 'M-3.7,-2.5V2.5L1.3,0Z',
          backoff: 1.3
      },
      // barbed
      {
          path: 'M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z',
          backoff: 1.55
      },
      // wide line-drawn
      {
          path: 'M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z',
          backoff: 1.6
      },
      // narrower line-drawn
      {
          path: 'M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z',
          backoff: 2
      },
      // circle
      {
          path: 'M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z',
          backoff: 0,
          noRotate: true
      },
      // square
      {
          path: 'M2,2V-2H-2V2Z',
          backoff: 0,
          noRotate: true
      }
  ];
  
  },{}],598:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var ARROWPATHS = _dereq_('./arrow_paths');
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var cartesianConstants = _dereq_('../../plots/cartesian/constants');
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  var axisPlaceableObjs = _dereq_('../../constants/axis_placeable_objects');
  
  function arrowAxisRefDescription(axis) {
      return [
          'In order for absolute positioning of the arrow to work, *a' + axis +
          'ref* must be exactly the same as *' + axis + 'ref*, otherwise *a' + axis +
          'ref* will revert to *pixel* (explained next).',
          'For relative positioning, *a' + axis + 'ref* can be set to *pixel*,',
          'in which case the *a' + axis + '* value is specified in pixels',
          'relative to *' + axis + '*.',
          'Absolute positioning is useful',
          'for trendline annotations which should continue to indicate',
          'the correct trend when zoomed. Relative positioning is useful',
          'for specifying the text offset for an annotated point.'
      ].join(' ');
  }
  
  function arrowCoordinateDescription(axis, lower, upper) {
      return [
          'Sets the', axis, 'component of the arrow tail about the arrow head.',
          'If `a' + axis + 'ref` is `pixel`, a positive (negative)',
          'component corresponds to an arrow pointing',
          'from', upper, 'to', lower, '(' + lower, 'to', upper + ').',
          'If `a' + axis + 'ref` is not `pixel` and is exactly the same as `' + axis + 'ref`,',
          'this is an absolute value on that axis,',
          'like `' + axis + '`, specified in the same coordinates as `' + axis + 'ref`.'
      ].join(' ');
  }
  
  module.exports = templatedArray('annotation', {
      visible: {
          valType: 'boolean',
          
          dflt: true,
          editType: 'calc+arraydraw',
          
      },
  
      text: {
          valType: 'string',
          
          editType: 'calc+arraydraw',
          
      },
      textangle: {
          valType: 'angle',
          dflt: 0,
          
          editType: 'calc+arraydraw',
          
      },
      font: fontAttrs({
          editType: 'calc+arraydraw',
          colorEditType: 'arraydraw',
          
      }),
      width: {
          valType: 'number',
          min: 1,
          dflt: null,
          
          editType: 'calc+arraydraw',
          
      },
      height: {
          valType: 'number',
          min: 1,
          dflt: null,
          
          editType: 'calc+arraydraw',
          
      },
      opacity: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 1,
          
          editType: 'arraydraw',
          
      },
      align: {
          valType: 'enumerated',
          values: ['left', 'center', 'right'],
          dflt: 'center',
          
          editType: 'arraydraw',
          
      },
      valign: {
          valType: 'enumerated',
          values: ['top', 'middle', 'bottom'],
          dflt: 'middle',
          
          editType: 'arraydraw',
          
      },
      bgcolor: {
          valType: 'color',
          dflt: 'rgba(0,0,0,0)',
          
          editType: 'arraydraw',
          
      },
      bordercolor: {
          valType: 'color',
          dflt: 'rgba(0,0,0,0)',
          
          editType: 'arraydraw',
          
      },
      borderpad: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'calc+arraydraw',
          
      },
      borderwidth: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'calc+arraydraw',
          
      },
      // arrow
      showarrow: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc+arraydraw',
          
      },
      arrowcolor: {
          valType: 'color',
          
          editType: 'arraydraw',
          
      },
      arrowhead: {
          valType: 'integer',
          min: 0,
          max: ARROWPATHS.length,
          dflt: 1,
          
          editType: 'arraydraw',
          
      },
      startarrowhead: {
          valType: 'integer',
          min: 0,
          max: ARROWPATHS.length,
          dflt: 1,
          
          editType: 'arraydraw',
          
      },
      arrowside: {
          valType: 'flaglist',
          flags: ['end', 'start'],
          extras: ['none'],
          dflt: 'end',
          
          editType: 'arraydraw',
          
      },
      arrowsize: {
          valType: 'number',
          min: 0.3,
          dflt: 1,
          
          editType: 'calc+arraydraw',
          
      },
      startarrowsize: {
          valType: 'number',
          min: 0.3,
          dflt: 1,
          
          editType: 'calc+arraydraw',
          
      },
      arrowwidth: {
          valType: 'number',
          min: 0.1,
          
          editType: 'calc+arraydraw',
          
      },
      standoff: {
          valType: 'number',
          min: 0,
          dflt: 0,
          
          editType: 'calc+arraydraw',
          
      },
      startstandoff: {
          valType: 'number',
          min: 0,
          dflt: 0,
          
          editType: 'calc+arraydraw',
          
      },
      ax: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
      ay: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
      axref: {
          valType: 'enumerated',
          dflt: 'pixel',
          values: [
              'pixel',
              cartesianConstants.idRegex.x.toString()
          ],
          
          editType: 'calc',
          
      },
      ayref: {
          valType: 'enumerated',
          dflt: 'pixel',
          values: [
              'pixel',
              cartesianConstants.idRegex.y.toString()
          ],
          
          editType: 'calc',
          
      },
      // positioning
      xref: {
          valType: 'enumerated',
          values: [
              'paper',
              cartesianConstants.idRegex.x.toString()
          ],
          
          editType: 'calc',
          
      },
      x: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
      xanchor: {
          valType: 'enumerated',
          values: ['auto', 'left', 'center', 'right'],
          dflt: 'auto',
          
          editType: 'calc+arraydraw',
          
      },
      xshift: {
          valType: 'number',
          dflt: 0,
          
          editType: 'calc+arraydraw',
          
      },
      yref: {
          valType: 'enumerated',
          values: [
              'paper',
              cartesianConstants.idRegex.y.toString()
          ],
          
          editType: 'calc',
          
      },
      y: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
      yanchor: {
          valType: 'enumerated',
          values: ['auto', 'top', 'middle', 'bottom'],
          dflt: 'auto',
          
          editType: 'calc+arraydraw',
          
      },
      yshift: {
          valType: 'number',
          dflt: 0,
          
          editType: 'calc+arraydraw',
          
      },
      clicktoshow: {
          valType: 'enumerated',
          values: [false, 'onoff', 'onout'],
          dflt: false,
          
          editType: 'arraydraw',
          
      },
      xclick: {
          valType: 'any',
          
          editType: 'arraydraw',
          
      },
      yclick: {
          valType: 'any',
          
          editType: 'arraydraw',
          
      },
      hovertext: {
          valType: 'string',
          
          editType: 'arraydraw',
          
      },
      hoverlabel: {
          bgcolor: {
              valType: 'color',
              
              editType: 'arraydraw',
              
          },
          bordercolor: {
              valType: 'color',
              
              editType: 'arraydraw',
              
          },
          font: fontAttrs({
              editType: 'arraydraw',
              
          }),
          editType: 'arraydraw'
      },
      captureevents: {
          valType: 'boolean',
          
          editType: 'arraydraw',
          
      },
      editType: 'calc',
  
      _deprecated: {
          ref: {
              valType: 'string',
              
              editType: 'calc',
              
          }
      }
  });
  
  },{"../../constants/axis_placeable_objects":718,"../../plot_api/plot_template":788,"../../plots/cartesian/constants":805,"../../plots/font_attributes":827,"./arrow_paths":597}],599:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  var draw = _dereq_('./draw').draw;
  
  
  module.exports = function calcAutorange(gd) {
      var fullLayout = gd._fullLayout;
      var annotationList = Lib.filterVisible(fullLayout.annotations);
  
      if(annotationList.length && gd._fullData.length) {
          return Lib.syncOrAsync([draw, annAutorange], gd);
      }
  };
  
  function annAutorange(gd) {
      var fullLayout = gd._fullLayout;
  
      // find the bounding boxes for each of these annotations'
      // relative to their anchor points
      // use the arrow and the text bg rectangle,
      // as the whole anno may include hidden text in its bbox
      Lib.filterVisible(fullLayout.annotations).forEach(function(ann) {
          var xa = Axes.getFromId(gd, ann.xref);
          var ya = Axes.getFromId(gd, ann.yref);
          var xRefType = Axes.getRefType(ann.xref);
          var yRefType = Axes.getRefType(ann.yref);
  
          ann._extremes = {};
          if(xRefType === 'range') calcAxisExpansion(ann, xa);
          if(yRefType === 'range') calcAxisExpansion(ann, ya);
      });
  }
  
  function calcAxisExpansion(ann, ax) {
      var axId = ax._id;
      var letter = axId.charAt(0);
      var pos = ann[letter];
      var apos = ann['a' + letter];
      var ref = ann[letter + 'ref'];
      var aref = ann['a' + letter + 'ref'];
      var padplus = ann['_' + letter + 'padplus'];
      var padminus = ann['_' + letter + 'padminus'];
      var shift = {x: 1, y: -1}[letter] * ann[letter + 'shift'];
      var headSize = 3 * ann.arrowsize * ann.arrowwidth || 0;
      var headPlus = headSize + shift;
      var headMinus = headSize - shift;
      var startHeadSize = 3 * ann.startarrowsize * ann.arrowwidth || 0;
      var startHeadPlus = startHeadSize + shift;
      var startHeadMinus = startHeadSize - shift;
      var extremes;
  
      if(aref === ref) {
          // expand for the arrowhead (padded by arrowhead)
          var extremeArrowHead = Axes.findExtremes(ax, [ax.r2c(pos)], {
              ppadplus: headPlus,
              ppadminus: headMinus
          });
          // again for the textbox (padded by textbox)
          var extremeText = Axes.findExtremes(ax, [ax.r2c(apos)], {
              ppadplus: Math.max(padplus, startHeadPlus),
              ppadminus: Math.max(padminus, startHeadMinus)
          });
          extremes = {
              min: [extremeArrowHead.min[0], extremeText.min[0]],
              max: [extremeArrowHead.max[0], extremeText.max[0]]
          };
      } else {
          startHeadPlus = apos ? startHeadPlus + apos : startHeadPlus;
          startHeadMinus = apos ? startHeadMinus - apos : startHeadMinus;
          extremes = Axes.findExtremes(ax, [ax.r2c(pos)], {
              ppadplus: Math.max(padplus, headPlus, startHeadPlus),
              ppadminus: Math.max(padminus, headMinus, startHeadMinus)
          });
      }
  
      ann._extremes[axId] = extremes;
  }
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"./draw":604}],600:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
  
  module.exports = {
      hasClickToShow: hasClickToShow,
      onClick: onClick
  };
  
  /*
   * hasClickToShow: does the given hoverData have ANY annotations which will
   * turn ON if we click here? (used by hover events to set cursor)
   *
   * gd: graphDiv
   * hoverData: a hoverData array, as included with the *plotly_hover* or
   *     *plotly_click* events in the `points` attribute
   *
   * returns: boolean
   */
  function hasClickToShow(gd, hoverData) {
      var sets = getToggleSets(gd, hoverData);
      return sets.on.length > 0 || sets.explicitOff.length > 0;
  }
  
  /*
   * onClick: perform the toggling (via Plotly.update) implied by clicking
   * at this hoverData
   *
   * gd: graphDiv
   * hoverData: a hoverData array, as included with the *plotly_hover* or
   *     *plotly_click* events in the `points` attribute
   *
   * returns: Promise that the update is complete
   */
  function onClick(gd, hoverData) {
      var toggleSets = getToggleSets(gd, hoverData);
      var onSet = toggleSets.on;
      var offSet = toggleSets.off.concat(toggleSets.explicitOff);
      var update = {};
      var annotationsOut = gd._fullLayout.annotations;
      var i, editHelpers;
  
      if(!(onSet.length || offSet.length)) return;
  
      for(i = 0; i < onSet.length; i++) {
          editHelpers = arrayEditor(gd.layout, 'annotations', annotationsOut[onSet[i]]);
          editHelpers.modifyItem('visible', true);
          Lib.extendFlat(update, editHelpers.getUpdateObj());
      }
  
      for(i = 0; i < offSet.length; i++) {
          editHelpers = arrayEditor(gd.layout, 'annotations', annotationsOut[offSet[i]]);
          editHelpers.modifyItem('visible', false);
          Lib.extendFlat(update, editHelpers.getUpdateObj());
      }
  
      return Registry.call('update', gd, {}, update);
  }
  
  /*
   * getToggleSets: find the annotations which will turn on or off at this
   * hoverData
   *
   * gd: graphDiv
   * hoverData: a hoverData array, as included with the *plotly_hover* or
   *     *plotly_click* events in the `points` attribute
   *
   * returns: {
   *   on: Array (indices of annotations to turn on),
   *   off: Array (indices to turn off because you're not hovering on them),
   *   explicitOff: Array (indices to turn off because you *are* hovering on them)
   * }
   */
  function getToggleSets(gd, hoverData) {
      var annotations = gd._fullLayout.annotations;
      var onSet = [];
      var offSet = [];
      var explicitOffSet = [];
      var hoverLen = (hoverData || []).length;
  
      var i, j, anni, showMode, pointj, xa, ya, toggleType;
  
      for(i = 0; i < annotations.length; i++) {
          anni = annotations[i];
          showMode = anni.clicktoshow;
  
          if(showMode) {
              for(j = 0; j < hoverLen; j++) {
                  pointj = hoverData[j];
                  xa = pointj.xaxis;
                  ya = pointj.yaxis;
  
                  if(xa._id === anni.xref &&
                      ya._id === anni.yref &&
                      xa.d2r(pointj.x) === clickData2r(anni._xclick, xa) &&
                      ya.d2r(pointj.y) === clickData2r(anni._yclick, ya)
                  ) {
                      // match! toggle this annotation
                      // regardless of its clicktoshow mode
                      // but if it's onout mode, off is implicit
                      if(anni.visible) {
                          if(showMode === 'onout') toggleType = offSet;
                          else toggleType = explicitOffSet;
                      } else {
                          toggleType = onSet;
                      }
                      toggleType.push(i);
                      break;
                  }
              }
  
              if(j === hoverLen) {
                  // no match - only turn this annotation OFF, and only if
                  // showmode is 'onout'
                  if(anni.visible && showMode === 'onout') offSet.push(i);
              }
          }
      }
  
      return {on: onSet, off: offSet, explicitOff: explicitOffSet};
  }
  
  // to handle log axes until v2
  function clickData2r(d, ax) {
      return ax.type === 'log' ? ax.l2r(d) : ax.d2r(d);
  }
  
  },{"../../lib":750,"../../plot_api/plot_template":788,"../../registry":882}],601:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../color');
  
  // defaults common to 'annotations' and 'annotations3d'
  module.exports = function handleAnnotationCommonDefaults(annIn, annOut, fullLayout, coerce) {
      coerce('opacity');
      var bgColor = coerce('bgcolor');
  
      var borderColor = coerce('bordercolor');
      var borderOpacity = Color.opacity(borderColor);
  
      coerce('borderpad');
  
      var borderWidth = coerce('borderwidth');
      var showArrow = coerce('showarrow');
  
      coerce('text', showArrow ? ' ' : fullLayout._dfltTitle.annotation);
      coerce('textangle');
      Lib.coerceFont(coerce, 'font', fullLayout.font);
  
      coerce('width');
      coerce('align');
  
      var h = coerce('height');
      if(h) coerce('valign');
  
      if(showArrow) {
          var arrowside = coerce('arrowside');
          var arrowhead;
          var arrowsize;
  
          if(arrowside.indexOf('end') !== -1) {
              arrowhead = coerce('arrowhead');
              arrowsize = coerce('arrowsize');
          }
  
          if(arrowside.indexOf('start') !== -1) {
              coerce('startarrowhead', arrowhead);
              coerce('startarrowsize', arrowsize);
          }
          coerce('arrowcolor', borderOpacity ? annOut.bordercolor : Color.defaultLine);
          coerce('arrowwidth', ((borderOpacity && borderWidth) || 1) * 2);
          coerce('standoff');
          coerce('startstandoff');
      }
  
      var hoverText = coerce('hovertext');
      var globalHoverLabel = fullLayout.hoverlabel || {};
  
      if(hoverText) {
          var hoverBG = coerce('hoverlabel.bgcolor', globalHoverLabel.bgcolor ||
              (Color.opacity(bgColor) ? Color.rgb(bgColor) : Color.defaultLine)
          );
  
          var hoverBorder = coerce('hoverlabel.bordercolor', globalHoverLabel.bordercolor ||
              Color.contrast(hoverBG)
          );
  
          Lib.coerceFont(coerce, 'hoverlabel.font', {
              family: globalHoverLabel.font.family,
              size: globalHoverLabel.font.size,
              color: globalHoverLabel.font.color || hoverBorder
          });
      }
  
      coerce('captureevents', !!hoverText);
  };
  
  },{"../../lib":750,"../color":615}],602:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var toLogRange = _dereq_('../../lib/to_log_range');
  
  /*
   * convertCoords: when converting an axis between log and linear
   * you need to alter any annotations on that axis to keep them
   * pointing at the same data point.
   * In v2.0 this will become obsolete
   *
   * gd: the plot div
   * ax: the axis being changed
   * newType: the type it's getting
   * doExtra: function(attr, val) from inside relayout that sets the attribute.
   *     Use this to make the changes as it's aware if any other changes in the
   *     same relayout call should override this conversion.
   */
  module.exports = function convertCoords(gd, ax, newType, doExtra) {
      ax = ax || {};
  
      var toLog = (newType === 'log') && (ax.type === 'linear');
      var fromLog = (newType === 'linear') && (ax.type === 'log');
  
      if(!(toLog || fromLog)) return;
  
      var annotations = gd._fullLayout.annotations;
      var axLetter = ax._id.charAt(0);
      var ann;
      var attrPrefix;
  
      function convert(attr) {
          var currentVal = ann[attr];
          var newVal = null;
  
          if(toLog) newVal = toLogRange(currentVal, ax.range);
          else newVal = Math.pow(10, currentVal);
  
          // if conversion failed, delete the value so it gets a default value
          if(!isNumeric(newVal)) newVal = null;
  
          doExtra(attrPrefix + attr, newVal);
      }
  
      for(var i = 0; i < annotations.length; i++) {
          ann = annotations[i];
          attrPrefix = 'annotations[' + i + '].';
  
          if(ann[axLetter + 'ref'] === ax._id) convert(axLetter);
          if(ann['a' + axLetter + 'ref'] === ax._id) convert('a' + axLetter);
      }
  };
  
  },{"../../lib/to_log_range":776,"fast-isnumeric":241}],603:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  
  var handleAnnotationCommonDefaults = _dereq_('./common_defaults');
  var attributes = _dereq_('./attributes');
  
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
      handleArrayContainerDefaults(layoutIn, layoutOut, {
          name: 'annotations',
          handleItemDefaults: handleAnnotationDefaults
      });
  };
  
  function handleAnnotationDefaults(annIn, annOut, fullLayout) {
      function coerce(attr, dflt) {
          return Lib.coerce(annIn, annOut, attributes, attr, dflt);
      }
  
      var visible = coerce('visible');
      var clickToShow = coerce('clicktoshow');
  
      if(!(visible || clickToShow)) return;
  
      handleAnnotationCommonDefaults(annIn, annOut, fullLayout, coerce);
  
      var showArrow = annOut.showarrow;
  
      // positioning
      var axLetters = ['x', 'y'];
      var arrowPosDflt = [-10, -30];
      var gdMock = {_fullLayout: fullLayout};
  
      for(var i = 0; i < 2; i++) {
          var axLetter = axLetters[i];
  
          // xref, yref
          var axRef = Axes.coerceRef(annIn, annOut, gdMock, axLetter, '', 'paper');
  
          if(axRef !== 'paper') {
              var ax = Axes.getFromId(gdMock, axRef);
              ax._annIndices.push(annOut._index);
          }
  
          // x, y
          Axes.coercePosition(annOut, gdMock, coerce, axRef, axLetter, 0.5);
  
          if(showArrow) {
              var arrowPosAttr = 'a' + axLetter;
              // axref, ayref
              var aaxRef = Axes.coerceRef(annIn, annOut, gdMock, arrowPosAttr, 'pixel',
                      ['pixel', 'paper']);
  
              // for now the arrow can only be on the same axis or specified as pixels
              // TODO: sometime it might be interesting to allow it to be on *any* axis
              // but that would require updates to drawing & autorange code and maybe more
              if(aaxRef !== 'pixel' && aaxRef !== axRef) {
                  aaxRef = annOut[arrowPosAttr] = 'pixel';
              }
  
              // ax, ay
              var aDflt = (aaxRef === 'pixel') ? arrowPosDflt[i] : 0.4;
              Axes.coercePosition(annOut, gdMock, coerce, aaxRef, arrowPosAttr, aDflt);
          }
  
          // xanchor, yanchor
          coerce(axLetter + 'anchor');
  
          // xshift, yshift
          coerce(axLetter + 'shift');
      }
  
      // if you have one coordinate you should have both
      Lib.noneOrAll(annIn, annOut, ['x', 'y']);
  
      // if you have one part of arrow length you should have both
      if(showArrow) {
          Lib.noneOrAll(annIn, annOut, ['ax', 'ay']);
      }
  
      if(clickToShow) {
          var xClick = coerce('xclick');
          var yClick = coerce('yclick');
  
          // put the actual click data to bind to into private attributes
          // so we don't have to do this little bit of logic on every hover event
          annOut._xclick = (xClick === undefined) ?
              annOut.x :
              Axes.cleanPosition(xClick, gdMock, annOut.xref);
          annOut._yclick = (yClick === undefined) ?
              annOut.y :
              Axes.cleanPosition(yClick, gdMock, annOut.yref);
      }
  }
  
  },{"../../lib":750,"../../plots/array_container_defaults":794,"../../plots/cartesian/axes":799,"./attributes":598,"./common_defaults":601}],604:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Registry = _dereq_('../../registry');
  var Plots = _dereq_('../../plots/plots');
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Color = _dereq_('../color');
  var Drawing = _dereq_('../drawing');
  var Fx = _dereq_('../fx');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var setCursor = _dereq_('../../lib/setcursor');
  var dragElement = _dereq_('../dragelement');
  var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
  
  var drawArrowHead = _dereq_('./draw_arrow_head');
  
  // Annotations are stored in gd.layout.annotations, an array of objects
  // index can point to one item in this array,
  //  or non-numeric to simply add a new one
  //  or -1 to modify all existing
  // opt can be the full options object, or one key (to be set to value)
  //  or undefined to simply redraw
  // if opt is blank, val can be 'add' or a full options object to add a new
  //  annotation at that point in the array, or 'remove' to delete this one
  
  module.exports = {
      draw: draw,
      drawOne: drawOne,
      drawRaw: drawRaw
  };
  
  /*
   * draw: draw all annotations without any new modifications
   */
  function draw(gd) {
      var fullLayout = gd._fullLayout;
  
      fullLayout._infolayer.selectAll('.annotation').remove();
  
      for(var i = 0; i < fullLayout.annotations.length; i++) {
          if(fullLayout.annotations[i].visible) {
              drawOne(gd, i);
          }
      }
  
      return Plots.previousPromises(gd);
  }
  
  /*
   * drawOne: draw a single cartesian or paper-ref annotation, potentially with modifications
   *
   * index (int): the annotation to draw
   */
  function drawOne(gd, index) {
      var fullLayout = gd._fullLayout;
      var options = fullLayout.annotations[index] || {};
      var xa = Axes.getFromId(gd, options.xref);
      var ya = Axes.getFromId(gd, options.yref);
  
      if(xa) xa.setScale();
      if(ya) ya.setScale();
  
      drawRaw(gd, options, index, false, xa, ya);
  }
  
  // Convert pixels to the coordinates relevant for the axis referred to. For
  // example, for paper it would convert to a value normalized by the dimension of
  // the plot.
  // axDomainRef: if true and axa defined, draws relative to axis domain,
  // otherwise draws relative to data (if axa defined) or paper (if not).
  function shiftPosition(axa, dAx, axLetter, gs, options) {
      var optAx = options[axLetter];
      var axRef = options[axLetter + 'ref'];
      var vertical = axLetter.indexOf('y') !== -1;
      var axDomainRef = Axes.getRefType(axRef) === 'domain';
      var gsDim = vertical ? gs.h : gs.w;
      if(axa) {
          if(axDomainRef) {
              // here optAx normalized to length of axis (e.g., normally in range
              // 0 to 1). But dAx is in pixels. So we normalize dAx to length of
              // axis before doing the math.
              return optAx + (vertical ? -dAx : dAx) / axa._length;
          } else {
              return axa.p2r(axa.r2p(optAx) + dAx);
          }
      } else {
          return optAx + (vertical ? -dAx : dAx) / gsDim;
      }
  }
  
  /**
   * drawRaw: draw a single annotation, potentially with modifications
   *
   * @param {DOM element} gd
   * @param {object} options : this annotation's fullLayout options
   * @param {integer} index : index in 'annotations' container of the annotation to draw
   * @param {string} subplotId : id of the annotation's subplot
   *  - use false for 2d (i.e. cartesian or paper-ref) annotations
   * @param {object | undefined} xa : full x-axis object to compute subplot pos-to-px
   * @param {object | undefined} ya : ... y-axis
   */
  function drawRaw(gd, options, index, subplotId, xa, ya) {
      var fullLayout = gd._fullLayout;
      var gs = gd._fullLayout._size;
      var edits = gd._context.edits;
  
      var className, containerStr;
  
      if(subplotId) {
          className = 'annotation-' + subplotId;
          containerStr = subplotId + '.annotations';
      } else {
          className = 'annotation';
          containerStr = 'annotations';
      }
  
      var editHelpers = arrayEditor(gd.layout, containerStr, options);
      var modifyBase = editHelpers.modifyBase;
      var modifyItem = editHelpers.modifyItem;
      var getUpdateObj = editHelpers.getUpdateObj;
  
      // remove the existing annotation if there is one
      fullLayout._infolayer
          .selectAll('.' + className + '[data-index="' + index + '"]')
          .remove();
  
      var annClipID = 'clip' + fullLayout._uid + '_ann' + index;
  
      // this annotation is gone - quit now after deleting it
      // TODO: use d3 idioms instead of deleting and redrawing every time
      if(!options._input || options.visible === false) {
          d3.selectAll('#' + annClipID).remove();
          return;
      }
  
      // calculated pixel positions
      // x & y each will get text, head, and tail as appropriate
      var annPosPx = {x: {}, y: {}};
      var textangle = +options.textangle || 0;
  
      // create the components
      // made a single group to contain all, so opacity can work right
      // with border/arrow together this could handle a whole bunch of
      // cleanup at this point, but works for now
      var annGroup = fullLayout._infolayer.append('g')
          .classed(className, true)
          .attr('data-index', String(index))
          .style('opacity', options.opacity);
  
      // another group for text+background so that they can rotate together
      var annTextGroup = annGroup.append('g')
          .classed('annotation-text-g', true);
  
      var editTextPosition = edits[options.showarrow ? 'annotationTail' : 'annotationPosition'];
      var textEvents = options.captureevents || edits.annotationText || editTextPosition;
  
      function makeEventData(initialEvent) {
          var eventData = {
              index: index,
              annotation: options._input,
              fullAnnotation: options,
              event: initialEvent
          };
          if(subplotId) {
              eventData.subplotId = subplotId;
          }
          return eventData;
      }
  
      var annTextGroupInner = annTextGroup.append('g')
          .style('pointer-events', textEvents ? 'all' : null)
          .call(setCursor, 'pointer')
          .on('click', function() {
              gd._dragging = false;
              gd.emit('plotly_clickannotation', makeEventData(d3.event));
          });
  
      if(options.hovertext) {
          annTextGroupInner
          .on('mouseover', function() {
              var hoverOptions = options.hoverlabel;
              var hoverFont = hoverOptions.font;
              var bBox = this.getBoundingClientRect();
              var bBoxRef = gd.getBoundingClientRect();
  
              Fx.loneHover({
                  x0: bBox.left - bBoxRef.left,
                  x1: bBox.right - bBoxRef.left,
                  y: (bBox.top + bBox.bottom) / 2 - bBoxRef.top,
                  text: options.hovertext,
                  color: hoverOptions.bgcolor,
                  borderColor: hoverOptions.bordercolor,
                  fontFamily: hoverFont.family,
                  fontSize: hoverFont.size,
                  fontColor: hoverFont.color
              }, {
                  container: fullLayout._hoverlayer.node(),
                  outerContainer: fullLayout._paper.node(),
                  gd: gd
              });
          })
          .on('mouseout', function() {
              Fx.loneUnhover(fullLayout._hoverlayer.node());
          });
      }
  
      var borderwidth = options.borderwidth;
      var borderpad = options.borderpad;
      var borderfull = borderwidth + borderpad;
  
      var annTextBG = annTextGroupInner.append('rect')
          .attr('class', 'bg')
          .style('stroke-width', borderwidth + 'px')
          .call(Color.stroke, options.bordercolor)
          .call(Color.fill, options.bgcolor);
  
      var isSizeConstrained = options.width || options.height;
  
      var annTextClip = fullLayout._topclips
          .selectAll('#' + annClipID)
          .data(isSizeConstrained ? [0] : []);
  
      annTextClip.enter().append('clipPath')
          .classed('annclip', true)
          .attr('id', annClipID)
        .append('rect');
      annTextClip.exit().remove();
  
      var font = options.font;
  
      var text = fullLayout._meta ?
          Lib.templateString(options.text, fullLayout._meta) :
          options.text;
  
      var annText = annTextGroupInner.append('text')
          .classed('annotation-text', true)
          .text(text);
  
      function textLayout(s) {
          s.call(Drawing.font, font)
          .attr({
              'text-anchor': {
                  left: 'start',
                  right: 'end'
              }[options.align] || 'middle'
          });
  
          svgTextUtils.convertToTspans(s, gd, drawGraphicalElements);
          return s;
      }
  
      function drawGraphicalElements() {
          // if the text has *only* a link, make the whole box into a link
          var anchor3 = annText.selectAll('a');
          if(anchor3.size() === 1 && anchor3.text() === annText.text()) {
              var wholeLink = annTextGroupInner.insert('a', ':first-child').attr({
                  'xlink:xlink:href': anchor3.attr('xlink:href'),
                  'xlink:xlink:show': anchor3.attr('xlink:show')
              })
              .style({cursor: 'pointer'});
  
              wholeLink.node().appendChild(annTextBG.node());
          }
  
          var mathjaxGroup = annTextGroupInner.select('.annotation-text-math-group');
          var hasMathjax = !mathjaxGroup.empty();
          var anntextBB = Drawing.bBox(
                  (hasMathjax ? mathjaxGroup : annText).node());
          var textWidth = anntextBB.width;
          var textHeight = anntextBB.height;
          var annWidth = options.width || textWidth;
          var annHeight = options.height || textHeight;
          var outerWidth = Math.round(annWidth + 2 * borderfull);
          var outerHeight = Math.round(annHeight + 2 * borderfull);
  
          function shiftFraction(v, anchor) {
              if(anchor === 'auto') {
                  if(v < 1 / 3) anchor = 'left';
                  else if(v > 2 / 3) anchor = 'right';
                  else anchor = 'center';
              }
              return {
                  center: 0,
                  middle: 0,
                  left: 0.5,
                  bottom: -0.5,
                  right: -0.5,
                  top: 0.5
              }[anchor];
          }
  
          var annotationIsOffscreen = false;
          var letters = ['x', 'y'];
  
          for(var i = 0; i < letters.length; i++) {
              var axLetter = letters[i];
              var axRef = options[axLetter + 'ref'] || axLetter;
              var tailRef = options['a' + axLetter + 'ref'];
              var ax = {x: xa, y: ya}[axLetter];
              var dimAngle = (textangle + (axLetter === 'x' ? 0 : -90)) * Math.PI / 180;
              // note that these two can be either positive or negative
              var annSizeFromWidth = outerWidth * Math.cos(dimAngle);
              var annSizeFromHeight = outerHeight * Math.sin(dimAngle);
              // but this one is the positive total size
              var annSize = Math.abs(annSizeFromWidth) + Math.abs(annSizeFromHeight);
              var anchor = options[axLetter + 'anchor'];
              var overallShift = options[axLetter + 'shift'] * (axLetter === 'x' ? 1 : -1);
              var posPx = annPosPx[axLetter];
              var basePx;
              var textPadShift;
              var alignPosition;
              var autoAlignFraction;
              var textShift;
              var axRefType = Axes.getRefType(axRef);
  
              /*
               * calculate the *primary* pixel position
               * which is the arrowhead if there is one,
               * otherwise the text anchor point
               */
              if(ax && (axRefType !== 'domain')) {
                  // check if annotation is off screen, to bypass DOM manipulations
                  var posFraction = ax.r2fraction(options[axLetter]);
                  if(posFraction < 0 || posFraction > 1) {
                      if(tailRef === axRef) {
                          posFraction = ax.r2fraction(options['a' + axLetter]);
                          if(posFraction < 0 || posFraction > 1) {
                              annotationIsOffscreen = true;
                          }
                      } else {
                          annotationIsOffscreen = true;
                      }
                  }
                  basePx = ax._offset + ax.r2p(options[axLetter]);
                  autoAlignFraction = 0.5;
              } else {
                  var axRefTypeEqDomain = axRefType === 'domain';
                  if(axLetter === 'x') {
                      alignPosition = options[axLetter];
                      basePx = axRefTypeEqDomain ?
                          ax._offset + ax._length * alignPosition :
                          basePx = gs.l + gs.w * alignPosition;
                  } else {
                      alignPosition = 1 - options[axLetter];
                      basePx = axRefTypeEqDomain ?
                          ax._offset + ax._length * alignPosition :
                          basePx = gs.t + gs.h * alignPosition;
                  }
                  autoAlignFraction = options.showarrow ? 0.5 : alignPosition;
              }
  
              // now translate this into pixel positions of head, tail, and text
              // as well as paddings for autorange
              if(options.showarrow) {
                  posPx.head = basePx;
  
                  var arrowLength = options['a' + axLetter];
  
                  // with an arrow, the text rotates around the anchor point
                  textShift = annSizeFromWidth * shiftFraction(0.5, options.xanchor) -
                      annSizeFromHeight * shiftFraction(0.5, options.yanchor);
  
                  if(tailRef === axRef) {
                      // In the case tailRefType is 'domain' or 'paper', the arrow's
                      // position is set absolutely, which is consistent with how
                      // it behaves when its position is set in data ('range')
                      // coordinates.
                      var tailRefType = Axes.getRefType(tailRef);
                      if(tailRefType === 'domain') {
                          if(axLetter === 'y') {
                              arrowLength = 1 - arrowLength;
                          }
                          posPx.tail = ax._offset + ax._length * arrowLength;
                      } else if(tailRefType === 'paper') {
                          if(axLetter === 'y') {
                              arrowLength = 1 - arrowLength;
                              posPx.tail = gs.t + gs.h * arrowLength;
                          } else {
                              posPx.tail = gs.l + gs.w * arrowLength;
                          }
                      } else {
                          // assumed tailRef is range or paper referenced
                          posPx.tail = ax._offset + ax.r2p(arrowLength);
                      }
                      // tail is range- or domain-referenced: autorange pads the
                      // text in px from the tail
                      textPadShift = textShift;
                  } else {
                      posPx.tail = basePx + arrowLength;
                      // tail is specified in px from head, so autorange also pads vs head
                      textPadShift = textShift + arrowLength;
                  }
  
                  posPx.text = posPx.tail + textShift;
  
                  // constrain pixel/paper referenced so the draggers are at least
                  // partially visible
                  var maxPx = fullLayout[(axLetter === 'x') ? 'width' : 'height'];
                  if(axRef === 'paper') {
                      posPx.head = Lib.constrain(posPx.head, 1, maxPx - 1);
                  }
                  if(tailRef === 'pixel') {
                      var shiftPlus = -Math.max(posPx.tail - 3, posPx.text);
                      var shiftMinus = Math.min(posPx.tail + 3, posPx.text) - maxPx;
                      if(shiftPlus > 0) {
                          posPx.tail += shiftPlus;
                          posPx.text += shiftPlus;
                      } else if(shiftMinus > 0) {
                          posPx.tail -= shiftMinus;
                          posPx.text -= shiftMinus;
                      }
                  }
  
                  posPx.tail += overallShift;
                  posPx.head += overallShift;
              } else {
                  // with no arrow, the text rotates and *then* we put the anchor
                  // relative to the new bounding box
                  textShift = annSize * shiftFraction(autoAlignFraction, anchor);
                  textPadShift = textShift;
                  posPx.text = basePx + textShift;
              }
  
              posPx.text += overallShift;
              textShift += overallShift;
              textPadShift += overallShift;
  
              // padplus/minus are used by autorange
              options['_' + axLetter + 'padplus'] = (annSize / 2) + textPadShift;
              options['_' + axLetter + 'padminus'] = (annSize / 2) - textPadShift;
  
              // size/shift are used during dragging
              options['_' + axLetter + 'size'] = annSize;
              options['_' + axLetter + 'shift'] = textShift;
          }
  
          if(annotationIsOffscreen) {
              annTextGroupInner.remove();
              return;
          }
  
          var xShift = 0;
          var yShift = 0;
  
          if(options.align !== 'left') {
              xShift = (annWidth - textWidth) * (options.align === 'center' ? 0.5 : 1);
          }
          if(options.valign !== 'top') {
              yShift = (annHeight - textHeight) * (options.valign === 'middle' ? 0.5 : 1);
          }
  
          if(hasMathjax) {
              mathjaxGroup.select('svg').attr({
                  x: borderfull + xShift - 1,
                  y: borderfull + yShift
              })
              .call(Drawing.setClipUrl, isSizeConstrained ? annClipID : null, gd);
          } else {
              var texty = borderfull + yShift - anntextBB.top;
              var textx = borderfull + xShift - anntextBB.left;
  
              annText.call(svgTextUtils.positionText, textx, texty)
                  .call(Drawing.setClipUrl, isSizeConstrained ? annClipID : null, gd);
          }
  
          annTextClip.select('rect').call(Drawing.setRect, borderfull, borderfull,
              annWidth, annHeight);
  
          annTextBG.call(Drawing.setRect, borderwidth / 2, borderwidth / 2,
              outerWidth - borderwidth, outerHeight - borderwidth);
  
          annTextGroupInner.call(Drawing.setTranslate,
              Math.round(annPosPx.x.text - outerWidth / 2),
              Math.round(annPosPx.y.text - outerHeight / 2));
  
          /*
           * rotate text and background
           * we already calculated the text center position *as rotated*
           * because we needed that for autoranging anyway, so now whether
           * we have an arrow or not, we rotate about the text center.
           */
          annTextGroup.attr({transform: 'rotate(' + textangle + ',' +
                              annPosPx.x.text + ',' + annPosPx.y.text + ')'});
  
          /*
           * add the arrow
           * uses options[arrowwidth,arrowcolor,arrowhead] for styling
           * dx and dy are normally zero, but when you are dragging the textbox
           * while the head stays put, dx and dy are the pixel offsets
           */
          var drawArrow = function(dx, dy) {
              annGroup
                  .selectAll('.annotation-arrow-g')
                  .remove();
  
              var headX = annPosPx.x.head;
              var headY = annPosPx.y.head;
              var tailX = annPosPx.x.tail + dx;
              var tailY = annPosPx.y.tail + dy;
              var textX = annPosPx.x.text + dx;
              var textY = annPosPx.y.text + dy;
  
              // find the edge of the text box, where we'll start the arrow:
              // create transform matrix to rotate the text box corners
              var transform = Lib.rotationXYMatrix(textangle, textX, textY);
              var applyTransform = Lib.apply2DTransform(transform);
              var applyTransform2 = Lib.apply2DTransform2(transform);
  
              // calculate and transform bounding box
              var width = +annTextBG.attr('width');
              var height = +annTextBG.attr('height');
              var xLeft = textX - 0.5 * width;
              var xRight = xLeft + width;
              var yTop = textY - 0.5 * height;
              var yBottom = yTop + height;
              var edges = [
                  [xLeft, yTop, xLeft, yBottom],
                  [xLeft, yBottom, xRight, yBottom],
                  [xRight, yBottom, xRight, yTop],
                  [xRight, yTop, xLeft, yTop]
              ].map(applyTransform2);
  
              // Remove the line if it ends inside the box.  Use ray
              // casting for rotated boxes: see which edges intersect a
              // line from the arrowhead to far away and reduce with xor
              // to get the parity of the number of intersections.
              if(edges.reduce(function(a, x) {
                  return a ^
                      !!Lib.segmentsIntersect(headX, headY, headX + 1e6, headY + 1e6,
                              x[0], x[1], x[2], x[3]);
              }, false)) {
                  // no line or arrow - so quit drawArrow now
                  return;
              }
  
              edges.forEach(function(x) {
                  var p = Lib.segmentsIntersect(tailX, tailY, headX, headY,
                              x[0], x[1], x[2], x[3]);
                  if(p) {
                      tailX = p.x;
                      tailY = p.y;
                  }
              });
  
              var strokewidth = options.arrowwidth;
              var arrowColor = options.arrowcolor;
              var arrowSide = options.arrowside;
  
              var arrowGroup = annGroup.append('g')
                  .style({opacity: Color.opacity(arrowColor)})
                  .classed('annotation-arrow-g', true);
  
              var arrow = arrowGroup.append('path')
                  .attr('d', 'M' + tailX + ',' + tailY + 'L' + headX + ',' + headY)
                  .style('stroke-width', strokewidth + 'px')
                  .call(Color.stroke, Color.rgb(arrowColor));
  
              drawArrowHead(arrow, arrowSide, options);
  
              // the arrow dragger is a small square right at the head, then a line to the tail,
              // all expanded by a stroke width of 6px plus the arrow line width
              if(edits.annotationPosition && arrow.node().parentNode && !subplotId) {
                  var arrowDragHeadX = headX;
                  var arrowDragHeadY = headY;
                  if(options.standoff) {
                      var arrowLength = Math.sqrt(Math.pow(headX - tailX, 2) + Math.pow(headY - tailY, 2));
                      arrowDragHeadX += options.standoff * (tailX - headX) / arrowLength;
                      arrowDragHeadY += options.standoff * (tailY - headY) / arrowLength;
                  }
                  var arrowDrag = arrowGroup.append('path')
                      .classed('annotation-arrow', true)
                      .classed('anndrag', true)
                      .classed('cursor-move', true)
                      .attr({
                          d: 'M3,3H-3V-3H3ZM0,0L' + (tailX - arrowDragHeadX) + ',' + (tailY - arrowDragHeadY),
                          transform: 'translate(' + arrowDragHeadX + ',' + arrowDragHeadY + ')'
                      })
                      .style('stroke-width', (strokewidth + 6) + 'px')
                      .call(Color.stroke, 'rgba(0,0,0,0)')
                      .call(Color.fill, 'rgba(0,0,0,0)');
  
                  var annx0, anny0;
  
                  // dragger for the arrow & head: translates the whole thing
                  // (head/tail/text) all together
                  dragElement.init({
                      element: arrowDrag.node(),
                      gd: gd,
                      prepFn: function() {
                          var pos = Drawing.getTranslate(annTextGroupInner);
  
                          annx0 = pos.x;
                          anny0 = pos.y;
                          if(xa && xa.autorange) {
                              modifyBase(xa._name + '.autorange', true);
                          }
                          if(ya && ya.autorange) {
                              modifyBase(ya._name + '.autorange', true);
                          }
                      },
                      moveFn: function(dx, dy) {
                          var annxy0 = applyTransform(annx0, anny0);
                          var xcenter = annxy0[0] + dx;
                          var ycenter = annxy0[1] + dy;
                          annTextGroupInner.call(Drawing.setTranslate, xcenter, ycenter);
  
                          modifyItem('x',
                              shiftPosition(xa, dx, 'x', gs, options));
                          modifyItem('y',
                              shiftPosition(ya, dy, 'y', gs, options));
  
                          // for these 2 calls to shiftPosition, it is assumed xa, ya are
                          // defined, so gsDim will not be used, but we put it in
                          // anyways for consistency
                          if(options.axref === options.xref) {
                              modifyItem('ax', shiftPosition(xa, dx, 'ax', gs, options));
                          }
  
                          if(options.ayref === options.yref) {
                              modifyItem('ay', shiftPosition(ya, dy, 'ay', gs, options));
                          }
  
                          arrowGroup.attr('transform', 'translate(' + dx + ',' + dy + ')');
                          annTextGroup.attr({
                              transform: 'rotate(' + textangle + ',' +
                                     xcenter + ',' + ycenter + ')'
                          });
                      },
                      doneFn: function() {
                          Registry.call('_guiRelayout', gd, getUpdateObj());
                          var notesBox = document.querySelector('.js-notes-box-panel');
                          if(notesBox) notesBox.redraw(notesBox.selectedObj);
                      }
                  });
              }
          };
  
          if(options.showarrow) drawArrow(0, 0);
  
          // user dragging the annotation (text, not arrow)
          if(editTextPosition) {
              var baseTextTransform;
  
              // dragger for the textbox: if there's an arrow, just drag the
              // textbox and tail, leave the head untouched
              dragElement.init({
                  element: annTextGroupInner.node(),
                  gd: gd,
                  prepFn: function() {
                      baseTextTransform = annTextGroup.attr('transform');
                  },
                  moveFn: function(dx, dy) {
                      var csr = 'pointer';
                      if(options.showarrow) {
                          // for these 2 calls to shiftPosition, it is assumed xa, ya are
                          // defined, so gsDim will not be used, but we put it in
                          // anyways for consistency
                          if(options.axref === options.xref) {
                              modifyItem('ax', shiftPosition(xa, dx, 'ax', gs, options));
                          } else {
                              modifyItem('ax', options.ax + dx);
                          }
  
                          if(options.ayref === options.yref) {
                              modifyItem('ay', shiftPosition(ya, dy, 'ay', gs.w, options));
                          } else {
                              modifyItem('ay', options.ay + dy);
                          }
  
                          drawArrow(dx, dy);
                      } else if(!subplotId) {
                          var xUpdate, yUpdate;
                          if(xa) {
                              // shiftPosition will not execute code where xa was
                              // undefined, so we use to calculate xUpdate too
                              xUpdate = shiftPosition(xa, dx, 'x', gs, options);
                          } else {
                              var widthFraction = options._xsize / gs.w;
                              var xLeft = options.x + (options._xshift - options.xshift) / gs.w - widthFraction / 2;
  
                              xUpdate = dragElement.align(xLeft + dx / gs.w,
                                  widthFraction, 0, 1, options.xanchor);
                          }
  
                          if(ya) {
                              // shiftPosition will not execute code where ya was
                              // undefined, so we use to calculate yUpdate too
                              yUpdate = shiftPosition(ya, dy, 'y', gs, options);
                          } else {
                              var heightFraction = options._ysize / gs.h;
                              var yBottom = options.y - (options._yshift + options.yshift) / gs.h - heightFraction / 2;
  
                              yUpdate = dragElement.align(yBottom - dy / gs.h,
                                  heightFraction, 0, 1, options.yanchor);
                          }
                          modifyItem('x', xUpdate);
                          modifyItem('y', yUpdate);
                          if(!xa || !ya) {
                              csr = dragElement.getCursor(
                                  xa ? 0.5 : xUpdate,
                                  ya ? 0.5 : yUpdate,
                                  options.xanchor, options.yanchor
                              );
                          }
                      } else return;
  
                      annTextGroup.attr({
                          transform: 'translate(' + dx + ',' + dy + ')' + baseTextTransform
                      });
  
                      setCursor(annTextGroupInner, csr);
                  },
                  clickFn: function(_, initialEvent) {
                      if(options.captureevents) {
                          gd.emit('plotly_clickannotation', makeEventData(initialEvent));
                      }
                  },
                  doneFn: function() {
                      setCursor(annTextGroupInner);
                      Registry.call('_guiRelayout', gd, getUpdateObj());
                      var notesBox = document.querySelector('.js-notes-box-panel');
                      if(notesBox) notesBox.redraw(notesBox.selectedObj);
                  }
              });
          }
      }
  
      if(edits.annotationText) {
          annText.call(svgTextUtils.makeEditable, {delegate: annTextGroupInner, gd: gd})
              .call(textLayout)
              .on('edit', function(_text) {
                  options.text = _text;
  
                  this.call(textLayout);
  
                  modifyItem('text', _text);
  
                  if(xa && xa.autorange) {
                      modifyBase(xa._name + '.autorange', true);
                  }
                  if(ya && ya.autorange) {
                      modifyBase(ya._name + '.autorange', true);
                  }
  
                  Registry.call('_guiRelayout', gd, getUpdateObj());
              });
      } else annText.call(textLayout);
  }
  
  },{"../../lib":750,"../../lib/setcursor":770,"../../lib/svg_text_utils":774,"../../plot_api/plot_template":788,"../../plots/cartesian/axes":799,"../../plots/plots":862,"../../registry":882,"../color":615,"../dragelement":634,"../drawing":637,"../fx":655,"./draw_arrow_head":605,"d3":169}],605:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Color = _dereq_('../color');
  
  var ARROWPATHS = _dereq_('./arrow_paths');
  
  /**
   * Add arrowhead(s) to a path or line element
   *
   * @param {d3.selection} el3: a d3-selected line or path element
   *
   * @param {string} ends: 'none', 'start', 'end', or 'start+end' for which ends get arrowheads
   *
   * @param {object} options: style information. Must have all the following:
   * @param {number} options.arrowhead: end head style - see ./arrow_paths
   * @param {number} options.startarrowhead: start head style - see ./arrow_paths
   * @param {number} options.arrowsize: relative size of the end head vs line width
   * @param {number} options.startarrowsize: relative size of the start head vs line width
   * @param {number} options.standoff: distance in px to move the end arrow point from its target
   * @param {number} options.startstandoff: distance in px to move the start arrow point from its target
   * @param {number} options.arrowwidth: width of the arrow line
   * @param {string} options.arrowcolor: color of the arrow line, for the head to match
   *     Note that the opacity of this color is ignored, as it's assumed the container
   *     of both the line and head has opacity applied to it so there isn't greater opacity
   *     where they overlap.
   */
  module.exports = function drawArrowHead(el3, ends, options) {
      var el = el3.node();
      var headStyle = ARROWPATHS[options.arrowhead || 0];
      var startHeadStyle = ARROWPATHS[options.startarrowhead || 0];
      var scale = (options.arrowwidth || 1) * (options.arrowsize || 1);
      var startScale = (options.arrowwidth || 1) * (options.startarrowsize || 1);
      var doStart = ends.indexOf('start') >= 0;
      var doEnd = ends.indexOf('end') >= 0;
      var backOff = headStyle.backoff * scale + options.standoff;
      var startBackOff = startHeadStyle.backoff * startScale + options.startstandoff;
  
      var start, end, startRot, endRot;
  
      if(el.nodeName === 'line') {
          start = {x: +el3.attr('x1'), y: +el3.attr('y1')};
          end = {x: +el3.attr('x2'), y: +el3.attr('y2')};
  
          var dx = start.x - end.x;
          var dy = start.y - end.y;
  
          startRot = Math.atan2(dy, dx);
          endRot = startRot + Math.PI;
          if(backOff && startBackOff) {
              if(backOff + startBackOff > Math.sqrt(dx * dx + dy * dy)) {
                  hideLine();
                  return;
              }
          }
  
          if(backOff) {
              if(backOff * backOff > dx * dx + dy * dy) {
                  hideLine();
                  return;
              }
              var backOffX = backOff * Math.cos(startRot);
              var backOffY = backOff * Math.sin(startRot);
  
              end.x += backOffX;
              end.y += backOffY;
              el3.attr({x2: end.x, y2: end.y});
          }
  
          if(startBackOff) {
              if(startBackOff * startBackOff > dx * dx + dy * dy) {
                  hideLine();
                  return;
              }
              var startBackOffX = startBackOff * Math.cos(startRot);
              var startbackOffY = startBackOff * Math.sin(startRot);
  
              start.x -= startBackOffX;
              start.y -= startbackOffY;
              el3.attr({x1: start.x, y1: start.y});
          }
      } else if(el.nodeName === 'path') {
          var pathlen = el.getTotalLength();
          // using dash to hide the backOff region of the path.
          // if we ever allow dash for the arrow we'll have to
          // do better than this hack... maybe just manually
          // combine the two
          var dashArray = '';
  
          if(pathlen < backOff + startBackOff) {
              hideLine();
              return;
          }
  
  
          var start0 = el.getPointAtLength(0);
          var dstart = el.getPointAtLength(0.1);
  
          startRot = Math.atan2(start0.y - dstart.y, start0.x - dstart.x);
          start = el.getPointAtLength(Math.min(startBackOff, pathlen));
  
          dashArray = '0px,' + startBackOff + 'px,';
  
          var end0 = el.getPointAtLength(pathlen);
          var dend = el.getPointAtLength(pathlen - 0.1);
  
          endRot = Math.atan2(end0.y - dend.y, end0.x - dend.x);
          end = el.getPointAtLength(Math.max(0, pathlen - backOff));
  
          var shortening = dashArray ? startBackOff + backOff : backOff;
          dashArray += (pathlen - shortening) + 'px,' + pathlen + 'px';
  
          el3.style('stroke-dasharray', dashArray);
      }
  
      function hideLine() { el3.style('stroke-dasharray', '0px,100px'); }
  
      function drawhead(arrowHeadStyle, p, rot, arrowScale) {
          if(!arrowHeadStyle.path) return;
          if(arrowHeadStyle.noRotate) rot = 0;
  
          d3.select(el.parentNode).append('path')
              .attr({
                  'class': el3.attr('class'),
                  d: arrowHeadStyle.path,
                  transform:
                      'translate(' + p.x + ',' + p.y + ')' +
                      (rot ? 'rotate(' + (rot * 180 / Math.PI) + ')' : '') +
                      'scale(' + arrowScale + ')'
              })
              .style({
                  fill: Color.rgb(options.arrowcolor),
                  'stroke-width': 0
              });
      }
  
      if(doStart) drawhead(startHeadStyle, start, startRot, startScale);
      if(doEnd) drawhead(headStyle, end, endRot, scale);
  };
  
  },{"../color":615,"./arrow_paths":597,"d3":169}],606:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var drawModule = _dereq_('./draw');
  var clickModule = _dereq_('./click');
  
  module.exports = {
      moduleType: 'component',
      name: 'annotations',
  
      layoutAttributes: _dereq_('./attributes'),
      supplyLayoutDefaults: _dereq_('./defaults'),
      includeBasePlot: _dereq_('../../plots/cartesian/include_components')('annotations'),
  
      calcAutorange: _dereq_('./calc_autorange'),
      draw: drawModule.draw,
      drawOne: drawModule.drawOne,
      drawRaw: drawModule.drawRaw,
  
      hasClickToShow: clickModule.hasClickToShow,
      onClick: clickModule.onClick,
  
      convertCoords: _dereq_('./convert_coords')
  };
  
  },{"../../plots/cartesian/include_components":811,"./attributes":598,"./calc_autorange":599,"./click":600,"./convert_coords":602,"./defaults":603,"./draw":604}],607:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var annAttrs = _dereq_('../annotations/attributes');
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  
  module.exports = overrideAll(templatedArray('annotation', {
      visible: annAttrs.visible,
      x: {
          valType: 'any',
          
          
      },
      y: {
          valType: 'any',
          
          
      },
      z: {
          valType: 'any',
          
          
      },
      ax: {
          valType: 'number',
          
          
      },
      ay: {
          valType: 'number',
          
          
      },
  
      xanchor: annAttrs.xanchor,
      xshift: annAttrs.xshift,
      yanchor: annAttrs.yanchor,
      yshift: annAttrs.yshift,
  
      text: annAttrs.text,
      textangle: annAttrs.textangle,
      font: annAttrs.font,
      width: annAttrs.width,
      height: annAttrs.height,
      opacity: annAttrs.opacity,
      align: annAttrs.align,
      valign: annAttrs.valign,
      bgcolor: annAttrs.bgcolor,
      bordercolor: annAttrs.bordercolor,
      borderpad: annAttrs.borderpad,
      borderwidth: annAttrs.borderwidth,
      showarrow: annAttrs.showarrow,
      arrowcolor: annAttrs.arrowcolor,
      arrowhead: annAttrs.arrowhead,
      startarrowhead: annAttrs.startarrowhead,
      arrowside: annAttrs.arrowside,
      arrowsize: annAttrs.arrowsize,
      startarrowsize: annAttrs.startarrowsize,
      arrowwidth: annAttrs.arrowwidth,
      standoff: annAttrs.standoff,
      startstandoff: annAttrs.startstandoff,
      hovertext: annAttrs.hovertext,
      hoverlabel: annAttrs.hoverlabel,
      captureevents: annAttrs.captureevents,
  
      // maybes later?
      // clicktoshow: annAttrs.clicktoshow,
      // xclick: annAttrs.xclick,
      // yclick: annAttrs.yclick,
  
      // not needed!
      // axref: 'pixel'
      // ayref: 'pixel'
      // xref: 'x'
      // yref: 'y
      // zref: 'z'
  }), 'calc', 'from-root');
  
  },{"../../plot_api/edit_types":781,"../../plot_api/plot_template":788,"../annotations/attributes":598}],608:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  module.exports = function convert(scene) {
      var fullSceneLayout = scene.fullSceneLayout;
      var anns = fullSceneLayout.annotations;
  
      for(var i = 0; i < anns.length; i++) {
          mockAnnAxes(anns[i], scene);
      }
  
      scene.fullLayout._infolayer
          .selectAll('.annotation-' + scene.id)
          .remove();
  };
  
  function mockAnnAxes(ann, scene) {
      var fullSceneLayout = scene.fullSceneLayout;
      var domain = fullSceneLayout.domain;
      var size = scene.fullLayout._size;
  
      var base = {
          // this gets fill in on render
          pdata: null,
  
          // to get setConvert to not execute cleanly
          type: 'linear',
  
          // don't try to update them on `editable: true`
          autorange: false,
  
          // set infinite range so that annotation draw routine
          // does not try to remove 'outside-range' annotations,
          // this case is handled in the render loop
          range: [-Infinity, Infinity]
      };
  
      ann._xa = {};
      Lib.extendFlat(ann._xa, base);
      Axes.setConvert(ann._xa);
      ann._xa._offset = size.l + domain.x[0] * size.w;
      ann._xa.l2p = function() {
          return 0.5 * (1 + ann._pdata[0] / ann._pdata[3]) * size.w * (domain.x[1] - domain.x[0]);
      };
  
      ann._ya = {};
      Lib.extendFlat(ann._ya, base);
      Axes.setConvert(ann._ya);
      ann._ya._offset = size.t + (1 - domain.y[1]) * size.h;
      ann._ya.l2p = function() {
          return 0.5 * (1 - ann._pdata[1] / ann._pdata[3]) * size.h * (domain.y[1] - domain.y[0]);
      };
  }
  
  },{"../../lib":750,"../../plots/cartesian/axes":799}],609:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  var handleAnnotationCommonDefaults = _dereq_('../annotations/common_defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function handleDefaults(sceneLayoutIn, sceneLayoutOut, opts) {
      handleArrayContainerDefaults(sceneLayoutIn, sceneLayoutOut, {
          name: 'annotations',
          handleItemDefaults: handleAnnotationDefaults,
          fullLayout: opts.fullLayout
      });
  };
  
  function handleAnnotationDefaults(annIn, annOut, sceneLayout, opts) {
      function coerce(attr, dflt) {
          return Lib.coerce(annIn, annOut, attributes, attr, dflt);
      }
  
      function coercePosition(axLetter) {
          var axName = axLetter + 'axis';
  
          // mock in such way that getFromId grabs correct 3D axis
          var gdMock = { _fullLayout: {} };
          gdMock._fullLayout[axName] = sceneLayout[axName];
  
          return Axes.coercePosition(annOut, gdMock, coerce, axLetter, axLetter, 0.5);
      }
  
  
      var visible = coerce('visible');
      if(!visible) return;
  
      handleAnnotationCommonDefaults(annIn, annOut, opts.fullLayout, coerce);
  
      coercePosition('x');
      coercePosition('y');
      coercePosition('z');
  
      // if you have one coordinate you should all three
      Lib.noneOrAll(annIn, annOut, ['x', 'y', 'z']);
  
      // hard-set here for completeness
      annOut.xref = 'x';
      annOut.yref = 'y';
      annOut.zref = 'z';
  
      coerce('xanchor');
      coerce('yanchor');
      coerce('xshift');
      coerce('yshift');
  
      if(annOut.showarrow) {
          annOut.axref = 'pixel';
          annOut.ayref = 'pixel';
  
          // TODO maybe default values should be bigger than the 2D case?
          coerce('ax', -10);
          coerce('ay', -30);
  
          // if you have one part of arrow length you should have both
          Lib.noneOrAll(annIn, annOut, ['ax', 'ay']);
      }
  }
  
  },{"../../lib":750,"../../plots/array_container_defaults":794,"../../plots/cartesian/axes":799,"../annotations/common_defaults":601,"./attributes":607}],610:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var drawRaw = _dereq_('../annotations/draw').drawRaw;
  var project = _dereq_('../../plots/gl3d/project');
  var axLetters = ['x', 'y', 'z'];
  
  module.exports = function draw(scene) {
      var fullSceneLayout = scene.fullSceneLayout;
      var dataScale = scene.dataScale;
      var anns = fullSceneLayout.annotations;
  
      for(var i = 0; i < anns.length; i++) {
          var ann = anns[i];
          var annotationIsOffscreen = false;
  
          for(var j = 0; j < 3; j++) {
              var axLetter = axLetters[j];
              var pos = ann[axLetter];
              var ax = fullSceneLayout[axLetter + 'axis'];
              var posFraction = ax.r2fraction(pos);
  
              if(posFraction < 0 || posFraction > 1) {
                  annotationIsOffscreen = true;
                  break;
              }
          }
  
          if(annotationIsOffscreen) {
              scene.fullLayout._infolayer
                  .select('.annotation-' + scene.id + '[data-index="' + i + '"]')
                  .remove();
          } else {
              ann._pdata = project(scene.glplot.cameraParams, [
                  fullSceneLayout.xaxis.r2l(ann.x) * dataScale[0],
                  fullSceneLayout.yaxis.r2l(ann.y) * dataScale[1],
                  fullSceneLayout.zaxis.r2l(ann.z) * dataScale[2]
              ]);
  
              drawRaw(scene.graphDiv, ann, i, scene.id, ann._xa, ann._ya);
          }
      }
  };
  
  },{"../../plots/gl3d/project":850,"../annotations/draw":604}],611:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  
  module.exports = {
      moduleType: 'component',
      name: 'annotations3d',
  
      schema: {
          subplots: {
              scene: {annotations: _dereq_('./attributes')}
          }
      },
  
      layoutAttributes: _dereq_('./attributes'),
      handleDefaults: _dereq_('./defaults'),
      includeBasePlot: includeGL3D,
  
      convert: _dereq_('./convert'),
      draw: _dereq_('./draw')
  };
  
  function includeGL3D(layoutIn, layoutOut) {
      var GL3D = Registry.subplotsRegistry.gl3d;
      if(!GL3D) return;
  
      var attrRegex = GL3D.attrRegex;
  
      var keys = Object.keys(layoutIn);
      for(var i = 0; i < keys.length; i++) {
          var k = keys[i];
          if(attrRegex.test(k) && (layoutIn[k].annotations || []).length) {
              Lib.pushUnique(layoutOut._basePlotModules, GL3D);
              Lib.pushUnique(layoutOut._subplots.gl3d, k);
          }
      }
  }
  
  },{"../../lib":750,"../../registry":882,"./attributes":607,"./convert":608,"./defaults":609,"./draw":610}],612:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  // a trimmed down version of:
  // https://github.com/alexcjohnson/world-calendars/blob/master/dist/index.js
  
  module.exports = _dereq_('world-calendars/dist/main');
  
  _dereq_('world-calendars/dist/plus');
  
  _dereq_('world-calendars/dist/calendars/chinese');
  _dereq_('world-calendars/dist/calendars/coptic');
  _dereq_('world-calendars/dist/calendars/discworld');
  _dereq_('world-calendars/dist/calendars/ethiopian');
  _dereq_('world-calendars/dist/calendars/hebrew');
  _dereq_('world-calendars/dist/calendars/islamic');
  _dereq_('world-calendars/dist/calendars/julian');
  _dereq_('world-calendars/dist/calendars/mayan');
  _dereq_('world-calendars/dist/calendars/nanakshahi');
  _dereq_('world-calendars/dist/calendars/nepali');
  _dereq_('world-calendars/dist/calendars/persian');
  _dereq_('world-calendars/dist/calendars/taiwan');
  _dereq_('world-calendars/dist/calendars/thai');
  _dereq_('world-calendars/dist/calendars/ummalqura');
  
  },{"world-calendars/dist/calendars/chinese":579,"world-calendars/dist/calendars/coptic":580,"world-calendars/dist/calendars/discworld":581,"world-calendars/dist/calendars/ethiopian":582,"world-calendars/dist/calendars/hebrew":583,"world-calendars/dist/calendars/islamic":584,"world-calendars/dist/calendars/julian":585,"world-calendars/dist/calendars/mayan":586,"world-calendars/dist/calendars/nanakshahi":587,"world-calendars/dist/calendars/nepali":588,"world-calendars/dist/calendars/persian":589,"world-calendars/dist/calendars/taiwan":590,"world-calendars/dist/calendars/thai":591,"world-calendars/dist/calendars/ummalqura":592,"world-calendars/dist/main":593,"world-calendars/dist/plus":594}],613:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var calendars = _dereq_('./calendars');
  
  var Lib = _dereq_('../../lib');
  var constants = _dereq_('../../constants/numerical');
  
  var EPOCHJD = constants.EPOCHJD;
  var ONEDAY = constants.ONEDAY;
  
  var attributes = {
      valType: 'enumerated',
      values: Object.keys(calendars.calendars),
      
      editType: 'calc',
      dflt: 'gregorian'
  };
  
  var handleDefaults = function(contIn, contOut, attr, dflt) {
      var attrs = {};
      attrs[attr] = attributes;
  
      return Lib.coerce(contIn, contOut, attrs, attr, dflt);
  };
  
  var handleTraceDefaults = function(traceIn, traceOut, coords, layout) {
      for(var i = 0; i < coords.length; i++) {
          handleDefaults(traceIn, traceOut, coords[i] + 'calendar', layout.calendar);
      }
  };
  
  // each calendar needs its own default canonical tick. I would love to use
  // 2000-01-01 (or even 0000-01-01) for them all but they don't necessarily
  // all support either of those dates. Instead I'll use the most significant
  // number they *do* support, biased toward the present day.
  var CANONICAL_TICK = {
      chinese: '2000-01-01',
      coptic: '2000-01-01',
      discworld: '2000-01-01',
      ethiopian: '2000-01-01',
      hebrew: '5000-01-01',
      islamic: '1000-01-01',
      julian: '2000-01-01',
      mayan: '5000-01-01',
      nanakshahi: '1000-01-01',
      nepali: '2000-01-01',
      persian: '1000-01-01',
      jalali: '1000-01-01',
      taiwan: '1000-01-01',
      thai: '2000-01-01',
      ummalqura: '1400-01-01'
  };
  
  // Start on a Sunday - for week ticks
  // Discworld and Mayan calendars don't have 7-day weeks but we're going to give them
  // 7-day week ticks so start on our Sundays.
  // If anyone really cares we can customize the auto tick spacings for these calendars.
  var CANONICAL_SUNDAY = {
      chinese: '2000-01-02',
      coptic: '2000-01-03',
      discworld: '2000-01-03',
      ethiopian: '2000-01-05',
      hebrew: '5000-01-01',
      islamic: '1000-01-02',
      julian: '2000-01-03',
      mayan: '5000-01-01',
      nanakshahi: '1000-01-05',
      nepali: '2000-01-05',
      persian: '1000-01-01',
      jalali: '1000-01-01',
      taiwan: '1000-01-04',
      thai: '2000-01-04',
      ummalqura: '1400-01-06'
  };
  
  var DFLTRANGE = {
      chinese: ['2000-01-01', '2001-01-01'],
      coptic: ['1700-01-01', '1701-01-01'],
      discworld: ['1800-01-01', '1801-01-01'],
      ethiopian: ['2000-01-01', '2001-01-01'],
      hebrew: ['5700-01-01', '5701-01-01'],
      islamic: ['1400-01-01', '1401-01-01'],
      julian: ['2000-01-01', '2001-01-01'],
      mayan: ['5200-01-01', '5201-01-01'],
      nanakshahi: ['0500-01-01', '0501-01-01'],
      nepali: ['2000-01-01', '2001-01-01'],
      persian: ['1400-01-01', '1401-01-01'],
      jalali: ['1400-01-01', '1401-01-01'],
      taiwan: ['0100-01-01', '0101-01-01'],
      thai: ['2500-01-01', '2501-01-01'],
      ummalqura: ['1400-01-01', '1401-01-01']
  };
  
  /*
   * convert d3 templates to world-calendars templates, so our users only need
   * to know d3's specifiers. Map space padding to no padding, and unknown fields
   * to an ugly placeholder
   */
  var UNKNOWN = '##';
  var d3ToWorldCalendars = {
      'd': {'0': 'dd', '-': 'd'}, // 2-digit or unpadded day of month
      'e': {'0': 'd', '-': 'd'}, // alternate, always unpadded day of month
      'a': {'0': 'D', '-': 'D'}, // short weekday name
      'A': {'0': 'DD', '-': 'DD'}, // full weekday name
      'j': {'0': 'oo', '-': 'o'}, // 3-digit or unpadded day of the year
      'W': {'0': 'ww', '-': 'w'}, // 2-digit or unpadded week of the year (Monday first)
      'm': {'0': 'mm', '-': 'm'}, // 2-digit or unpadded month number
      'b': {'0': 'M', '-': 'M'}, // short month name
      'B': {'0': 'MM', '-': 'MM'}, // full month name
      'y': {'0': 'yy', '-': 'yy'}, // 2-digit year (map unpadded to zero-padded)
      'Y': {'0': 'yyyy', '-': 'yyyy'}, // 4-digit year (map unpadded to zero-padded)
      'U': UNKNOWN, // Sunday-first week of the year
      'w': UNKNOWN, // day of the week [0(sunday),6]
      // combined format, we replace the date part with the world-calendar version
      // and the %X stays there for d3 to handle with time parts
      'c': {'0': 'D M d %X yyyy', '-': 'D M d %X yyyy'},
      'x': {'0': 'mm/dd/yyyy', '-': 'mm/dd/yyyy'}
  };
  
  function worldCalFmt(fmt, x, calendar) {
      var dateJD = Math.floor((x + 0.05) / ONEDAY) + EPOCHJD;
      var cDate = getCal(calendar).fromJD(dateJD);
      var i = 0;
      var modifier, directive, directiveLen, directiveObj, replacementPart;
  
      while((i = fmt.indexOf('%', i)) !== -1) {
          modifier = fmt.charAt(i + 1);
          if(modifier === '0' || modifier === '-' || modifier === '_') {
              directiveLen = 3;
              directive = fmt.charAt(i + 2);
              if(modifier === '_') modifier = '-';
          } else {
              directive = modifier;
              modifier = '0';
              directiveLen = 2;
          }
          directiveObj = d3ToWorldCalendars[directive];
          if(!directiveObj) {
              i += directiveLen;
          } else {
              // code is recognized as a date part but world-calendars doesn't support it
              if(directiveObj === UNKNOWN) replacementPart = UNKNOWN;
  
              // format the cDate according to the translated directive
              else replacementPart = cDate.formatDate(directiveObj[modifier]);
  
              fmt = fmt.substr(0, i) + replacementPart + fmt.substr(i + directiveLen);
              i += replacementPart.length;
          }
      }
      return fmt;
  }
  
  // cache world calendars, so we don't have to reinstantiate
  // during each date-time conversion
  var allCals = {};
  function getCal(calendar) {
      var calendarObj = allCals[calendar];
      if(calendarObj) return calendarObj;
  
      calendarObj = allCals[calendar] = calendars.instance(calendar);
      return calendarObj;
  }
  
  function makeAttrs(description) {
      return Lib.extendFlat({}, attributes, { description: description });
  }
  
  function makeTraceAttrsDescription(coord) {
      return 'Sets the calendar system to use with `' + coord + '` date data.';
  }
  
  var xAttrs = {
      xcalendar: makeAttrs(makeTraceAttrsDescription('x'))
  };
  
  var xyAttrs = Lib.extendFlat({}, xAttrs, {
      ycalendar: makeAttrs(makeTraceAttrsDescription('y'))
  });
  
  var xyzAttrs = Lib.extendFlat({}, xyAttrs, {
      zcalendar: makeAttrs(makeTraceAttrsDescription('z'))
  });
  
  var axisAttrs = makeAttrs([
      'Sets the calendar system to use for `range` and `tick0`',
      'if this is a date axis. This does not set the calendar for',
      'interpreting data on this axis, that\'s specified in the trace',
      'or via the global `layout.calendar`'
  ].join(' '));
  
  module.exports = {
      moduleType: 'component',
      name: 'calendars',
  
      schema: {
          traces: {
              scatter: xyAttrs,
              bar: xyAttrs,
              box: xyAttrs,
              heatmap: xyAttrs,
              contour: xyAttrs,
              histogram: xyAttrs,
              histogram2d: xyAttrs,
              histogram2dcontour: xyAttrs,
              scatter3d: xyzAttrs,
              surface: xyzAttrs,
              mesh3d: xyzAttrs,
              scattergl: xyAttrs,
              ohlc: xAttrs,
              candlestick: xAttrs
          },
          layout: {
              calendar: makeAttrs([
                  'Sets the default calendar system to use for interpreting and',
                  'displaying dates throughout the plot.'
              ].join(' '))
          },
          subplots: {
              xaxis: {calendar: axisAttrs},
              yaxis: {calendar: axisAttrs},
              scene: {
                  xaxis: {calendar: axisAttrs},
                  // TODO: it's actually redundant to include yaxis and zaxis here
                  // because in the scene attributes these are the same object so merging
                  // into one merges into them all. However, I left them in for parity with
                  // cartesian, where yaxis is unused until we Plotschema.get() when we
                  // use its presence or absence to determine whether to delete attributes
                  // from yaxis if they only apply to x (rangeselector/rangeslider)
                  yaxis: {calendar: axisAttrs},
                  zaxis: {calendar: axisAttrs}
              },
              polar: {
                  radialaxis: {calendar: axisAttrs}
              }
          },
          transforms: {
              filter: {
                  valuecalendar: makeAttrs([
                      'Sets the calendar system to use for `value`, if it is a date.'
                  ].join(' ')),
                  targetcalendar: makeAttrs([
                      'Sets the calendar system to use for `target`, if it is an',
                      'array of dates. If `target` is a string (eg *x*) we use the',
                      'corresponding trace attribute (eg `xcalendar`) if it exists,',
                      'even if `targetcalendar` is provided.'
                  ].join(' '))
              }
          }
      },
  
      layoutAttributes: attributes,
  
      handleDefaults: handleDefaults,
      handleTraceDefaults: handleTraceDefaults,
  
      CANONICAL_SUNDAY: CANONICAL_SUNDAY,
      CANONICAL_TICK: CANONICAL_TICK,
      DFLTRANGE: DFLTRANGE,
  
      getCal: getCal,
      worldCalFmt: worldCalFmt
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"./calendars":612}],614:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  // IMPORTANT - default colors should be in hex for compatibility
  exports.defaults = [
      '#1f77b4',  // muted blue
      '#ff7f0e',  // safety orange
      '#2ca02c',  // cooked asparagus green
      '#d62728',  // brick red
      '#9467bd',  // muted purple
      '#8c564b',  // chestnut brown
      '#e377c2',  // raspberry yogurt pink
      '#7f7f7f',  // middle gray
      '#bcbd22',  // curry yellow-green
      '#17becf'   // blue-teal
  ];
  
  exports.defaultLine = '#444';
  
  exports.lightLine = '#eee';
  
  exports.background = '#fff';
  
  exports.borderLine = '#BEC8D9';
  
  // with axis.color and Color.interp we aren't using lightLine
  // itself anymore, instead interpolating between axis.color
  // and the background color using tinycolor.mix. lightFraction
  // gives back exactly lightLine if the other colors are defaults.
  exports.lightFraction = 100 * (0xe - 0x4) / (0xf - 0x4);
  
  },{}],615:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var tinycolor = _dereq_('tinycolor2');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var color = module.exports = {};
  
  var colorAttrs = _dereq_('./attributes');
  color.defaults = colorAttrs.defaults;
  var defaultLine = color.defaultLine = colorAttrs.defaultLine;
  color.lightLine = colorAttrs.lightLine;
  var background = color.background = colorAttrs.background;
  
  /*
   * tinyRGB: turn a tinycolor into an rgb string, but
   * unlike the built-in tinycolor.toRgbString this never includes alpha
   */
  color.tinyRGB = function(tc) {
      var c = tc.toRgb();
      return 'rgb(' + Math.round(c.r) + ', ' +
          Math.round(c.g) + ', ' + Math.round(c.b) + ')';
  };
  
  color.rgb = function(cstr) { return color.tinyRGB(tinycolor(cstr)); };
  
  color.opacity = function(cstr) { return cstr ? tinycolor(cstr).getAlpha() : 0; };
  
  color.addOpacity = function(cstr, op) {
      var c = tinycolor(cstr).toRgb();
      return 'rgba(' + Math.round(c.r) + ', ' +
          Math.round(c.g) + ', ' + Math.round(c.b) + ', ' + op + ')';
  };
  
  // combine two colors into one apparent color
  // if back has transparency or is missing,
  // color.background is assumed behind it
  color.combine = function(front, back) {
      var fc = tinycolor(front).toRgb();
      if(fc.a === 1) return tinycolor(front).toRgbString();
  
      var bc = tinycolor(back || background).toRgb();
      var bcflat = bc.a === 1 ? bc : {
          r: 255 * (1 - bc.a) + bc.r * bc.a,
          g: 255 * (1 - bc.a) + bc.g * bc.a,
          b: 255 * (1 - bc.a) + bc.b * bc.a
      };
      var fcflat = {
          r: bcflat.r * (1 - fc.a) + fc.r * fc.a,
          g: bcflat.g * (1 - fc.a) + fc.g * fc.a,
          b: bcflat.b * (1 - fc.a) + fc.b * fc.a
      };
      return tinycolor(fcflat).toRgbString();
  };
  
  /*
   * Create a color that contrasts with cstr.
   *
   * If cstr is a dark color, we lighten it; if it's light, we darken.
   *
   * If lightAmount / darkAmount are used, we adjust by these percentages,
   * otherwise we go all the way to white or black.
   */
  color.contrast = function(cstr, lightAmount, darkAmount) {
      var tc = tinycolor(cstr);
  
      if(tc.getAlpha() !== 1) tc = tinycolor(color.combine(cstr, background));
  
      var newColor = tc.isDark() ?
          (lightAmount ? tc.lighten(lightAmount) : background) :
          (darkAmount ? tc.darken(darkAmount) : defaultLine);
  
      return newColor.toString();
  };
  
  color.stroke = function(s, c) {
      var tc = tinycolor(c);
      s.style({'stroke': color.tinyRGB(tc), 'stroke-opacity': tc.getAlpha()});
  };
  
  color.fill = function(s, c) {
      var tc = tinycolor(c);
      s.style({
          'fill': color.tinyRGB(tc),
          'fill-opacity': tc.getAlpha()
      });
  };
  
  // search container for colors with the deprecated rgb(fractions) format
  // and convert them to rgb(0-255 values)
  color.clean = function(container) {
      if(!container || typeof container !== 'object') return;
  
      var keys = Object.keys(container);
      var i, j, key, val;
  
      for(i = 0; i < keys.length; i++) {
          key = keys[i];
          val = container[key];
  
          if(key.substr(key.length - 5) === 'color') {
              // only sanitize keys that end in "color" or "colorscale"
  
              if(Array.isArray(val)) {
                  for(j = 0; j < val.length; j++) val[j] = cleanOne(val[j]);
              } else container[key] = cleanOne(val);
          } else if(key.substr(key.length - 10) === 'colorscale' && Array.isArray(val)) {
              // colorscales have the format [[0, color1], [frac, color2], ... [1, colorN]]
  
              for(j = 0; j < val.length; j++) {
                  if(Array.isArray(val[j])) val[j][1] = cleanOne(val[j][1]);
              }
          } else if(Array.isArray(val)) {
              // recurse into arrays of objects, and plain objects
  
              var el0 = val[0];
              if(!Array.isArray(el0) && el0 && typeof el0 === 'object') {
                  for(j = 0; j < val.length; j++) color.clean(val[j]);
              }
          } else if(val && typeof val === 'object') color.clean(val);
      }
  };
  
  function cleanOne(val) {
      if(isNumeric(val) || typeof val !== 'string') return val;
  
      var valTrim = val.trim();
      if(valTrim.substr(0, 3) !== 'rgb') return val;
  
      var match = valTrim.match(/^rgba?\s*\(([^()]*)\)$/);
      if(!match) return val;
  
      var parts = match[1].trim().split(/\s*[\s,]\s*/);
      var rgba = valTrim.charAt(3) === 'a' && parts.length === 4;
      if(!rgba && parts.length !== 3) return val;
  
      for(var i = 0; i < parts.length; i++) {
          if(!parts[i].length) return val;
          parts[i] = Number(parts[i]);
  
          if(!(parts[i] >= 0)) {
              // all parts must be non-negative numbers
  
              return val;
          }
  
          if(i === 3) {
              // alpha>1 gets clipped to 1
  
              if(parts[i] > 1) parts[i] = 1;
          } else if(parts[i] >= 1) {
              // r, g, b must be < 1 (ie 1 itself is not allowed)
  
              return val;
          }
      }
  
      var rgbStr = Math.round(parts[0] * 255) + ', ' +
          Math.round(parts[1] * 255) + ', ' +
          Math.round(parts[2] * 255);
  
      if(rgba) return 'rgba(' + rgbStr + ', ' + parts[3] + ')';
      return 'rgb(' + rgbStr + ')';
  }
  
  },{"./attributes":614,"fast-isnumeric":241,"tinycolor2":548}],616:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var axesAttrs = _dereq_('../../plots/cartesian/layout_attributes');
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  
  module.exports = overrideAll({
  // TODO: only right is supported currently
  //     orient: {
  //         valType: 'enumerated',
  //         
  //         values: ['left', 'right', 'top', 'bottom'],
  //         dflt: 'right',
  //         
  //     },
      thicknessmode: {
          valType: 'enumerated',
          values: ['fraction', 'pixels'],
          
          dflt: 'pixels',
          
      },
      thickness: {
          valType: 'number',
          
          min: 0,
          dflt: 30,
          
      },
      lenmode: {
          valType: 'enumerated',
          values: ['fraction', 'pixels'],
          
          dflt: 'fraction',
          
      },
      len: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          
      },
      x: {
          valType: 'number',
          dflt: 1.02,
          min: -2,
          max: 3,
          
          
      },
      xanchor: {
          valType: 'enumerated',
          values: ['left', 'center', 'right'],
          dflt: 'left',
          
          
      },
      xpad: {
          valType: 'number',
          
          min: 0,
          dflt: 10,
          
      },
      y: {
          valType: 'number',
          
          dflt: 0.5,
          min: -2,
          max: 3,
          
      },
      yanchor: {
          valType: 'enumerated',
          values: ['top', 'middle', 'bottom'],
          
          dflt: 'middle',
          
      },
      ypad: {
          valType: 'number',
          
          min: 0,
          dflt: 10,
          
      },
      // a possible line around the bar itself
      outlinecolor: axesAttrs.linecolor,
      outlinewidth: axesAttrs.linewidth,
      // Should outlinewidth have {dflt: 0} ?
      // another possible line outside the padding and tick labels
      bordercolor: axesAttrs.linecolor,
      borderwidth: {
          valType: 'number',
          
          min: 0,
          dflt: 0,
          
      },
      bgcolor: {
          valType: 'color',
          
          dflt: 'rgba(0,0,0,0)',
          
      },
      // tick and title properties named and function exactly as in axes
      tickmode: axesAttrs.tickmode,
      nticks: axesAttrs.nticks,
      tick0: axesAttrs.tick0,
      dtick: axesAttrs.dtick,
      tickvals: axesAttrs.tickvals,
      ticktext: axesAttrs.ticktext,
      ticks: extendFlat({}, axesAttrs.ticks, {dflt: ''}),
      ticklen: axesAttrs.ticklen,
      tickwidth: axesAttrs.tickwidth,
      tickcolor: axesAttrs.tickcolor,
      showticklabels: axesAttrs.showticklabels,
      tickfont: fontAttrs({
          
      }),
      tickangle: axesAttrs.tickangle,
      tickformat: axesAttrs.tickformat,
      tickformatstops: axesAttrs.tickformatstops,
      tickprefix: axesAttrs.tickprefix,
      showtickprefix: axesAttrs.showtickprefix,
      ticksuffix: axesAttrs.ticksuffix,
      showticksuffix: axesAttrs.showticksuffix,
      separatethousands: axesAttrs.separatethousands,
      exponentformat: axesAttrs.exponentformat,
      minexponent: axesAttrs.minexponent,
      showexponent: axesAttrs.showexponent,
      title: {
          text: {
              valType: 'string',
              
              
          },
          font: fontAttrs({
              
          }),
          side: {
              valType: 'enumerated',
              values: ['right', 'top', 'bottom'],
              
              dflt: 'top',
              
          }
      },
  
      _deprecated: {
          title: {
              valType: 'string',
              
              
          },
          titlefont: fontAttrs({
              
          }),
          titleside: {
              valType: 'enumerated',
              values: ['right', 'top', 'bottom'],
              
              dflt: 'top',
              
          }
      }
  }, 'colorbars', 'from-root');
  
  },{"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plots/cartesian/layout_attributes":813,"../../plots/font_attributes":827}],617:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      cn: {
          colorbar: 'colorbar',
          cbbg: 'cbbg',
          cbfill: 'cbfill',
          cbfills: 'cbfills',
          cbline: 'cbline',
          cblines: 'cblines',
          cbaxis: 'cbaxis',
          cbtitleunshift: 'cbtitleunshift',
          cbtitle: 'cbtitle',
          cboutline: 'cboutline',
          crisp: 'crisp',
          jsPlaceholder: 'js-placeholder'
      }
  };
  
  },{}],618:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Template = _dereq_('../../plot_api/plot_template');
  
  var handleTickValueDefaults = _dereq_('../../plots/cartesian/tick_value_defaults');
  var handleTickMarkDefaults = _dereq_('../../plots/cartesian/tick_mark_defaults');
  var handleTickLabelDefaults = _dereq_('../../plots/cartesian/tick_label_defaults');
  
  var attributes = _dereq_('./attributes');
  
  module.exports = function colorbarDefaults(containerIn, containerOut, layout) {
      var colorbarOut = Template.newContainer(containerOut, 'colorbar');
      var colorbarIn = containerIn.colorbar || {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(colorbarIn, colorbarOut, attributes, attr, dflt);
      }
  
      var thicknessmode = coerce('thicknessmode');
      coerce('thickness', (thicknessmode === 'fraction') ?
          30 / (layout.width - layout.margin.l - layout.margin.r) :
          30
      );
  
      var lenmode = coerce('lenmode');
      coerce('len', (lenmode === 'fraction') ?
          1 :
          layout.height - layout.margin.t - layout.margin.b
      );
  
      coerce('x');
      coerce('xanchor');
      coerce('xpad');
      coerce('y');
      coerce('yanchor');
      coerce('ypad');
      Lib.noneOrAll(colorbarIn, colorbarOut, ['x', 'y']);
  
      coerce('outlinecolor');
      coerce('outlinewidth');
      coerce('bordercolor');
      coerce('borderwidth');
      coerce('bgcolor');
  
      handleTickValueDefaults(colorbarIn, colorbarOut, coerce, 'linear');
  
      var opts = {outerTicks: false, font: layout.font};
      handleTickLabelDefaults(colorbarIn, colorbarOut, coerce, 'linear', opts);
      handleTickMarkDefaults(colorbarIn, colorbarOut, coerce, 'linear', opts);
  
      coerce('title.text', layout._dfltTitle.colorbar);
      Lib.coerceFont(coerce, 'title.font', layout.font);
      coerce('title.side');
  };
  
  },{"../../lib":750,"../../plot_api/plot_template":788,"../../plots/cartesian/tick_label_defaults":820,"../../plots/cartesian/tick_mark_defaults":821,"../../plots/cartesian/tick_value_defaults":822,"./attributes":616}],619:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var tinycolor = _dereq_('tinycolor2');
  
  var Plots = _dereq_('../../plots/plots');
  var Registry = _dereq_('../../registry');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var dragElement = _dereq_('../dragelement');
  var Lib = _dereq_('../../lib');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var setCursor = _dereq_('../../lib/setcursor');
  var Drawing = _dereq_('../drawing');
  var Color = _dereq_('../color');
  var Titles = _dereq_('../titles');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var flipScale = _dereq_('../colorscale/helpers').flipScale;
  
  var handleAxisDefaults = _dereq_('../../plots/cartesian/axis_defaults');
  var handleAxisPositionDefaults = _dereq_('../../plots/cartesian/position_defaults');
  var axisLayoutAttrs = _dereq_('../../plots/cartesian/layout_attributes');
  
  var alignmentConstants = _dereq_('../../constants/alignment');
  var LINE_SPACING = alignmentConstants.LINE_SPACING;
  var FROM_TL = alignmentConstants.FROM_TL;
  var FROM_BR = alignmentConstants.FROM_BR;
  
  var cn = _dereq_('./constants').cn;
  
  function draw(gd) {
      var fullLayout = gd._fullLayout;
  
      var colorBars = fullLayout._infolayer
          .selectAll('g.' + cn.colorbar)
          .data(makeColorBarData(gd), function(opts) { return opts._id; });
  
      colorBars.enter().append('g')
          .attr('class', function(opts) { return opts._id; })
          .classed(cn.colorbar, true);
  
      colorBars.each(function(opts) {
          var g = d3.select(this);
  
          Lib.ensureSingle(g, 'rect', cn.cbbg);
          Lib.ensureSingle(g, 'g', cn.cbfills);
          Lib.ensureSingle(g, 'g', cn.cblines);
          Lib.ensureSingle(g, 'g', cn.cbaxis, function(s) { s.classed(cn.crisp, true); });
          Lib.ensureSingle(g, 'g', cn.cbtitleunshift, function(s) { s.append('g').classed(cn.cbtitle, true); });
          Lib.ensureSingle(g, 'rect', cn.cboutline);
  
          var done = drawColorBar(g, opts, gd);
          if(done && done.then) (gd._promises || []).push(done);
  
          if(gd._context.edits.colorbarPosition) {
              makeEditable(g, opts, gd);
          }
      });
  
      colorBars.exit()
          .each(function(opts) { Plots.autoMargin(gd, opts._id); })
          .remove();
  
      colorBars.order();
  }
  
  function makeColorBarData(gd) {
      var fullLayout = gd._fullLayout;
      var calcdata = gd.calcdata;
      var out = [];
  
      // single out item
      var opts;
      // colorbar attr parent container
      var cont;
      // trace attr container
      var trace;
      // colorbar options
      var cbOpt;
  
      function initOpts(opts) {
          return extendFlat(opts, {
              // fillcolor can be a d3 scale, domain is z values, range is colors
              // or leave it out for no fill,
              // or set to a string constant for single-color fill
              _fillcolor: null,
              // line.color has the same options as fillcolor
              _line: {color: null, width: null, dash: null},
              // levels of lines to draw.
              // note that this DOES NOT determine the extent of the bar
              // that's given by the domain of fillcolor
              // (or line.color if no fillcolor domain)
              _levels: {start: null, end: null, size: null},
              // separate fill levels (for example, heatmap coloring of a
              // contour map) if this is omitted, fillcolors will be
              // evaluated halfway between levels
              _filllevels: null,
              // for continuous colorscales: fill with a gradient instead of explicit levels
              // value should be the colorscale [[0, c0], [v1, c1], ..., [1, cEnd]]
              _fillgradient: null,
              // when using a gradient, we need the data range specified separately
              _zrange: null
          });
      }
  
      function calcOpts() {
          if(typeof cbOpt.calc === 'function') {
              cbOpt.calc(gd, trace, opts);
          } else {
              opts._fillgradient = cont.reversescale ?
                  flipScale(cont.colorscale) :
                  cont.colorscale;
              opts._zrange = [cont[cbOpt.min], cont[cbOpt.max]];
          }
      }
  
      for(var i = 0; i < calcdata.length; i++) {
          var cd = calcdata[i];
          trace = cd[0].trace;
          var moduleOpts = trace._module.colorbar;
  
          if(trace.visible === true && moduleOpts) {
              var allowsMultiplotCbs = Array.isArray(moduleOpts);
              var cbOpts = allowsMultiplotCbs ? moduleOpts : [moduleOpts];
  
              for(var j = 0; j < cbOpts.length; j++) {
                  cbOpt = cbOpts[j];
                  var contName = cbOpt.container;
                  cont = contName ? trace[contName] : trace;
  
                  if(cont && cont.showscale) {
                      opts = initOpts(cont.colorbar);
                      opts._id = 'cb' + trace.uid + (allowsMultiplotCbs && contName ? '-' + contName : '');
                      opts._traceIndex = trace.index;
                      opts._propPrefix = (contName ? contName + '.' : '') + 'colorbar.';
                      opts._meta = trace._meta;
                      calcOpts();
                      out.push(opts);
                  }
              }
          }
      }
  
      for(var k in fullLayout._colorAxes) {
          cont = fullLayout[k];
  
          if(cont.showscale) {
              var colorAxOpts = fullLayout._colorAxes[k];
  
              opts = initOpts(cont.colorbar);
              opts._id = 'cb' + k;
              opts._propPrefix = k + '.colorbar.';
              opts._meta = fullLayout._meta;
  
              cbOpt = {min: 'cmin', max: 'cmax'};
              if(colorAxOpts[0] !== 'heatmap') {
                  trace = colorAxOpts[1];
                  cbOpt.calc = trace._module.colorbar.calc;
              }
  
              calcOpts();
              out.push(opts);
          }
      }
  
      return out;
  }
  
  function drawColorBar(g, opts, gd) {
      var fullLayout = gd._fullLayout;
      var gs = fullLayout._size;
  
      var fillColor = opts._fillcolor;
      var line = opts._line;
      var title = opts.title;
      var titleSide = title.side;
  
      var zrange = opts._zrange ||
          d3.extent((typeof fillColor === 'function' ? fillColor : line.color).domain());
  
      var lineColormap = typeof line.color === 'function' ?
          line.color :
          function() { return line.color; };
      var fillColormap = typeof fillColor === 'function' ?
          fillColor :
          function() { return fillColor; };
  
      var levelsIn = opts._levels;
      var levelsOut = calcLevels(gd, opts, zrange);
      var fillLevels = levelsOut.fill;
      var lineLevels = levelsOut.line;
  
      // we calculate pixel sizes based on the specified graph size,
      // not the actual (in case something pushed the margins around)
      // which is a little odd but avoids an odd iterative effect
      // when the colorbar itself is pushing the margins.
      // but then the fractional size is calculated based on the
      // actual graph size, so that the axes will size correctly.
      var thickPx = Math.round(opts.thickness * (opts.thicknessmode === 'fraction' ? gs.w : 1));
      var thickFrac = thickPx / gs.w;
      var lenPx = Math.round(opts.len * (opts.lenmode === 'fraction' ? gs.h : 1));
      var lenFrac = lenPx / gs.h;
      var xpadFrac = opts.xpad / gs.w;
      var yExtraPx = (opts.borderwidth + opts.outlinewidth) / 2;
      var ypadFrac = opts.ypad / gs.h;
  
      // x positioning: do it initially just for left anchor,
      // then fix at the end (since we don't know the width yet)
      var xLeft = Math.round(opts.x * gs.w + opts.xpad);
      // for dragging... this is getting a little muddled...
      var xLeftFrac = opts.x - thickFrac * ({middle: 0.5, right: 1}[opts.xanchor] || 0);
  
      // y positioning we can do correctly from the start
      var yBottomFrac = opts.y + lenFrac * (({top: -0.5, bottom: 0.5}[opts.yanchor] || 0) - 0.5);
      var yBottomPx = Math.round(gs.h * (1 - yBottomFrac));
      var yTopPx = yBottomPx - lenPx;
  
      // stash a few things for makeEditable
      opts._lenFrac = lenFrac;
      opts._thickFrac = thickFrac;
      opts._xLeftFrac = xLeftFrac;
      opts._yBottomFrac = yBottomFrac;
  
      // stash mocked axis for contour label formatting
      var ax = opts._axis = mockColorBarAxis(gd, opts, zrange);
  
      // position can't go in through supplyDefaults
      // because that restricts it to [0,1]
      ax.position = opts.x + xpadFrac + thickFrac;
  
      if(['top', 'bottom'].indexOf(titleSide) !== -1) {
          ax.title.side = titleSide;
          ax.titlex = opts.x + xpadFrac;
          ax.titley = yBottomFrac + (title.side === 'top' ? lenFrac - ypadFrac : ypadFrac);
      }
  
      if(line.color && opts.tickmode === 'auto') {
          ax.tickmode = 'linear';
          ax.tick0 = levelsIn.start;
          var dtick = levelsIn.size;
          // expand if too many contours, so we don't get too many ticks
          var autoNtick = Lib.constrain((yBottomPx - yTopPx) / 50, 4, 15) + 1;
          var dtFactor = (zrange[1] - zrange[0]) / ((opts.nticks || autoNtick) * dtick);
          if(dtFactor > 1) {
              var dtexp = Math.pow(10, Math.floor(Math.log(dtFactor) / Math.LN10));
              dtick *= dtexp * Lib.roundUp(dtFactor / dtexp, [2, 5, 10]);
              // if the contours are at round multiples, reset tick0
              // so they're still at round multiples. Otherwise,
              // keep the first label on the first contour level
              if((Math.abs(levelsIn.start) / levelsIn.size + 1e-6) % 1 < 2e-6) {
                  ax.tick0 = 0;
              }
          }
          ax.dtick = dtick;
      }
  
      // set domain after init, because we may want to
      // allow it outside [0,1]
      ax.domain = [
          yBottomFrac + ypadFrac,
          yBottomFrac + lenFrac - ypadFrac
      ];
  
      ax.setScale();
  
      g.attr('transform', 'translate(' + Math.round(gs.l) + ',' + Math.round(gs.t) + ')');
  
      var titleCont = g.select('.' + cn.cbtitleunshift)
          .attr('transform', 'translate(-' + Math.round(gs.l) + ',-' + Math.round(gs.t) + ')');
  
      var axLayer = g.select('.' + cn.cbaxis);
      var titleEl;
      var titleHeight = 0;
  
      function drawTitle(titleClass, titleOpts) {
          var dfltTitleOpts = {
              propContainer: ax,
              propName: opts._propPrefix + 'title',
              traceIndex: opts._traceIndex,
              _meta: opts._meta,
              placeholder: fullLayout._dfltTitle.colorbar,
              containerGroup: g.select('.' + cn.cbtitle)
          };
  
          // this class-to-rotate thing with convertToTspans is
          // getting hackier and hackier... delete groups with the
          // wrong class (in case earlier the colorbar was drawn on
          // a different side, I think?)
          var otherClass = titleClass.charAt(0) === 'h' ?
              titleClass.substr(1) :
              'h' + titleClass;
          g.selectAll('.' + otherClass + ',.' + otherClass + '-math-group').remove();
  
          Titles.draw(gd, titleClass, extendFlat(dfltTitleOpts, titleOpts || {}));
      }
  
      function drawDummyTitle() {
          if(['top', 'bottom'].indexOf(titleSide) !== -1) {
              // draw the title so we know how much room it needs
              // when we squish the axis. This one only applies to
              // top or bottom titles, not right side.
              var x = gs.l + (opts.x + xpadFrac) * gs.w;
              var fontSize = ax.title.font.size;
              var y;
  
              if(titleSide === 'top') {
                  y = (1 - (yBottomFrac + lenFrac - ypadFrac)) * gs.h +
                      gs.t + 3 + fontSize * 0.75;
              } else {
                  y = (1 - (yBottomFrac + ypadFrac)) * gs.h +
                      gs.t - 3 - fontSize * 0.25;
              }
              drawTitle(ax._id + 'title', {
                  attributes: {x: x, y: y, 'text-anchor': 'start'}
              });
          }
      }
  
      function drawCbTitle() {
          if(['top', 'bottom'].indexOf(titleSide) === -1) {
              var fontSize = ax.title.font.size;
              var y = ax._offset + ax._length / 2;
              var x = gs.l + (ax.position || 0) * gs.w + ((ax.side === 'right') ?
                  10 + fontSize * ((ax.showticklabels ? 1 : 0.5)) :
                  -10 - fontSize * ((ax.showticklabels ? 0.5 : 0)));
  
              // the 'h' + is a hack to get around the fact that
              // convertToTspans rotates any 'y...' class by 90 degrees.
              // TODO: find a better way to control this.
              drawTitle('h' + ax._id + 'title', {
                  avoid: {
                      selection: d3.select(gd).selectAll('g.' + ax._id + 'tick'),
                      side: titleSide,
                      offsetLeft: gs.l,
                      offsetTop: 0,
                      maxShift: fullLayout.width
                  },
                  attributes: {x: x, y: y, 'text-anchor': 'middle'},
                  transform: {rotate: '-90', offset: 0}
              });
          }
      }
  
      function drawAxis() {
          if(['top', 'bottom'].indexOf(titleSide) !== -1) {
              // squish the axis top to make room for the title
              var titleGroup = g.select('.' + cn.cbtitle);
              var titleText = titleGroup.select('text');
              var titleTrans = [-opts.outlinewidth / 2, opts.outlinewidth / 2];
              var mathJaxNode = titleGroup
                  .select('.h' + ax._id + 'title-math-group')
                  .node();
              var lineSize = 15.6;
              if(titleText.node()) {
                  lineSize = parseInt(titleText.node().style.fontSize, 10) * LINE_SPACING;
              }
              if(mathJaxNode) {
                  titleHeight = Drawing.bBox(mathJaxNode).height;
                  if(titleHeight > lineSize) {
                      // not entirely sure how mathjax is doing
                      // vertical alignment, but this seems to work.
                      titleTrans[1] -= (titleHeight - lineSize) / 2;
                  }
              } else if(titleText.node() && !titleText.classed(cn.jsPlaceholder)) {
                  titleHeight = Drawing.bBox(titleText.node()).height;
              }
              if(titleHeight) {
                  // buffer btwn colorbar and title
                  // TODO: configurable
                  titleHeight += 5;
  
                  if(titleSide === 'top') {
                      ax.domain[1] -= titleHeight / gs.h;
                      titleTrans[1] *= -1;
                  } else {
                      ax.domain[0] += titleHeight / gs.h;
                      var nlines = svgTextUtils.lineCount(titleText);
                      titleTrans[1] += (1 - nlines) * lineSize;
                  }
  
                  titleGroup.attr('transform', 'translate(' + titleTrans + ')');
                  ax.setScale();
              }
          }
  
          g.selectAll('.' + cn.cbfills + ',.' + cn.cblines)
              .attr('transform', 'translate(0,' + Math.round(gs.h * (1 - ax.domain[1])) + ')');
  
          axLayer.attr('transform', 'translate(0,' + Math.round(-gs.t) + ')');
  
          var fills = g.select('.' + cn.cbfills)
              .selectAll('rect.' + cn.cbfill)
              .attr('style', '')
              .data(fillLevels);
          fills.enter().append('rect')
              .classed(cn.cbfill, true)
              .style('stroke', 'none');
          fills.exit().remove();
  
          var zBounds = zrange
              .map(ax.c2p)
              .map(Math.round)
              .sort(function(a, b) { return a - b; });
  
          fills.each(function(d, i) {
              var z = [
                  (i === 0) ? zrange[0] : (fillLevels[i] + fillLevels[i - 1]) / 2,
                  (i === fillLevels.length - 1) ? zrange[1] : (fillLevels[i] + fillLevels[i + 1]) / 2
              ]
              .map(ax.c2p)
              .map(Math.round);
  
              // offset the side adjoining the next rectangle so they
              // overlap, to prevent antialiasing gaps
              z[1] = Lib.constrain(z[1] + (z[1] > z[0]) ? 1 : -1, zBounds[0], zBounds[1]);
  
  
              // Colorbar cannot currently support opacities so we
              // use an opaque fill even when alpha channels present
              var fillEl = d3.select(this).attr({
                  x: xLeft,
                  width: Math.max(thickPx, 2),
                  y: d3.min(z),
                  height: Math.max(d3.max(z) - d3.min(z), 2),
              });
  
              if(opts._fillgradient) {
                  Drawing.gradient(fillEl, gd, opts._id, 'vertical', opts._fillgradient, 'fill');
              } else {
                  // tinycolor can't handle exponents and
                  // at this scale, removing it makes no difference.
                  var colorString = fillColormap(d).replace('e-', '');
                  fillEl.attr('fill', tinycolor(colorString).toHexString());
              }
          });
  
          var lines = g.select('.' + cn.cblines)
              .selectAll('path.' + cn.cbline)
              .data(line.color && line.width ? lineLevels : []);
          lines.enter().append('path')
              .classed(cn.cbline, true);
          lines.exit().remove();
          lines.each(function(d) {
              d3.select(this)
                  .attr('d', 'M' + xLeft + ',' +
                      (Math.round(ax.c2p(d)) + (line.width / 2) % 1) + 'h' + thickPx)
                  .call(Drawing.lineGroupStyle, line.width, lineColormap(d), line.dash);
          });
  
          // force full redraw of labels and ticks
          axLayer.selectAll('g.' + ax._id + 'tick,path').remove();
  
          var shift = xLeft + thickPx +
              (opts.outlinewidth || 0) / 2 - (opts.ticks === 'outside' ? 1 : 0);
  
          var vals = Axes.calcTicks(ax);
          var transFn = Axes.makeTransFn(ax);
          var tickSign = Axes.getTickSigns(ax)[2];
  
          Axes.drawTicks(gd, ax, {
              vals: ax.ticks === 'inside' ? Axes.clipEnds(ax, vals) : vals,
              layer: axLayer,
              path: Axes.makeTickPath(ax, shift, tickSign),
              transFn: transFn
          });
  
          return Axes.drawLabels(gd, ax, {
              vals: vals,
              layer: axLayer,
              transFn: transFn,
              labelFns: Axes.makeLabelFns(ax, shift)
          });
      }
  
      // wait for the axis & title to finish rendering before
      // continuing positioning
      // TODO: why are we redrawing multiple times now with this?
      // I guess autoMargin doesn't like being post-promise?
      function positionCB() {
          var innerWidth = thickPx + opts.outlinewidth / 2 + Drawing.bBox(axLayer.node()).width;
          titleEl = titleCont.select('text');
  
          if(titleEl.node() && !titleEl.classed(cn.jsPlaceholder)) {
              var mathJaxNode = titleCont.select('.h' + ax._id + 'title-math-group').node();
              var titleWidth;
              if(mathJaxNode && ['top', 'bottom'].indexOf(titleSide) !== -1) {
                  titleWidth = Drawing.bBox(mathJaxNode).width;
              } else {
                  // note: the formula below works for all title sides,
                  // (except for top/bottom mathjax, above)
                  // but the weird gs.l is because the titleunshift
                  // transform gets removed by Drawing.bBox
                  titleWidth = Drawing.bBox(titleCont.node()).right - xLeft - gs.l;
              }
              innerWidth = Math.max(innerWidth, titleWidth);
          }
  
          var outerwidth = 2 * opts.xpad + innerWidth + opts.borderwidth + opts.outlinewidth / 2;
          var outerheight = yBottomPx - yTopPx;
  
          g.select('.' + cn.cbbg).attr({
              x: xLeft - opts.xpad - (opts.borderwidth + opts.outlinewidth) / 2,
              y: yTopPx - yExtraPx,
              width: Math.max(outerwidth, 2),
              height: Math.max(outerheight + 2 * yExtraPx, 2)
          })
          .call(Color.fill, opts.bgcolor)
          .call(Color.stroke, opts.bordercolor)
          .style('stroke-width', opts.borderwidth);
  
          g.selectAll('.' + cn.cboutline).attr({
              x: xLeft,
              y: yTopPx + opts.ypad + (titleSide === 'top' ? titleHeight : 0),
              width: Math.max(thickPx, 2),
              height: Math.max(outerheight - 2 * opts.ypad - titleHeight, 2)
          })
          .call(Color.stroke, opts.outlinecolor)
          .style({
              fill: 'none',
              'stroke-width': opts.outlinewidth
          });
  
          // fix positioning for xanchor!='left'
          var xoffset = ({center: 0.5, right: 1}[opts.xanchor] || 0) * outerwidth;
          g.attr('transform', 'translate(' + (gs.l - xoffset) + ',' + gs.t + ')');
  
          // auto margin adjustment
          var marginOpts = {};
          var tFrac = FROM_TL[opts.yanchor];
          var bFrac = FROM_BR[opts.yanchor];
          if(opts.lenmode === 'pixels') {
              marginOpts.y = opts.y;
              marginOpts.t = outerheight * tFrac;
              marginOpts.b = outerheight * bFrac;
          } else {
              marginOpts.t = marginOpts.b = 0;
              marginOpts.yt = opts.y + opts.len * tFrac;
              marginOpts.yb = opts.y - opts.len * bFrac;
          }
  
          var lFrac = FROM_TL[opts.xanchor];
          var rFrac = FROM_BR[opts.xanchor];
          if(opts.thicknessmode === 'pixels') {
              marginOpts.x = opts.x;
              marginOpts.l = outerwidth * lFrac;
              marginOpts.r = outerwidth * rFrac;
          } else {
              var extraThickness = outerwidth - thickPx;
              marginOpts.l = extraThickness * lFrac;
              marginOpts.r = extraThickness * rFrac;
              marginOpts.xl = opts.x - opts.thickness * lFrac;
              marginOpts.xr = opts.x + opts.thickness * rFrac;
          }
  
          Plots.autoMargin(gd, opts._id, marginOpts);
      }
  
      return Lib.syncOrAsync([
          Plots.previousPromises,
          drawDummyTitle,
          drawAxis,
          drawCbTitle,
          Plots.previousPromises,
          positionCB
      ], gd);
  }
  
  function makeEditable(g, opts, gd) {
      var fullLayout = gd._fullLayout;
      var gs = fullLayout._size;
      var t0, xf, yf;
  
      dragElement.init({
          element: g.node(),
          gd: gd,
          prepFn: function() {
              t0 = g.attr('transform');
              setCursor(g);
          },
          moveFn: function(dx, dy) {
              g.attr('transform', t0 + ' ' + 'translate(' + dx + ',' + dy + ')');
  
              xf = dragElement.align(opts._xLeftFrac + (dx / gs.w), opts._thickFrac,
                  0, 1, opts.xanchor);
              yf = dragElement.align(opts._yBottomFrac - (dy / gs.h), opts._lenFrac,
                  0, 1, opts.yanchor);
  
              var csr = dragElement.getCursor(xf, yf, opts.xanchor, opts.yanchor);
              setCursor(g, csr);
          },
          doneFn: function() {
              setCursor(g);
  
              if(xf !== undefined && yf !== undefined) {
                  var update = {};
                  update[opts._propPrefix + 'x'] = xf;
                  update[opts._propPrefix + 'y'] = yf;
                  if(opts._traceIndex !== undefined) {
                      Registry.call('_guiRestyle', gd, update, opts._traceIndex);
                  } else {
                      Registry.call('_guiRelayout', gd, update);
                  }
              }
          }
      });
  }
  
  function calcLevels(gd, opts, zrange) {
      var levelsIn = opts._levels;
      var lineLevels = [];
      var fillLevels = [];
      var l;
      var i;
  
      var l0 = levelsIn.end + levelsIn.size / 100;
      var ls = levelsIn.size;
      var zr0 = (1.001 * zrange[0] - 0.001 * zrange[1]);
      var zr1 = (1.001 * zrange[1] - 0.001 * zrange[0]);
  
      for(i = 0; i < 1e5; i++) {
          l = levelsIn.start + i * ls;
          if(ls > 0 ? (l >= l0) : (l <= l0)) break;
          if(l > zr0 && l < zr1) lineLevels.push(l);
      }
  
      if(opts._fillgradient) {
          fillLevels = [0];
      } else if(typeof opts._fillcolor === 'function') {
          var fillLevelsIn = opts._filllevels;
  
          if(fillLevelsIn) {
              l0 = fillLevelsIn.end + fillLevelsIn.size / 100;
              ls = fillLevelsIn.size;
              for(i = 0; i < 1e5; i++) {
                  l = fillLevelsIn.start + i * ls;
                  if(ls > 0 ? (l >= l0) : (l <= l0)) break;
                  if(l > zrange[0] && l < zrange[1]) fillLevels.push(l);
              }
          } else {
              fillLevels = lineLevels.map(function(v) {
                  return v - levelsIn.size / 2;
              });
              fillLevels.push(fillLevels[fillLevels.length - 1] + levelsIn.size);
          }
      } else if(opts._fillcolor && typeof opts._fillcolor === 'string') {
          // doesn't matter what this value is, with a single value
          // we'll make a single fill rect covering the whole bar
          fillLevels = [0];
      }
  
      if(levelsIn.size < 0) {
          lineLevels.reverse();
          fillLevels.reverse();
      }
  
      return {line: lineLevels, fill: fillLevels};
  }
  
  function mockColorBarAxis(gd, opts, zrange) {
      var fullLayout = gd._fullLayout;
  
      var cbAxisIn = {
          type: 'linear',
          range: zrange,
          tickmode: opts.tickmode,
          nticks: opts.nticks,
          tick0: opts.tick0,
          dtick: opts.dtick,
          tickvals: opts.tickvals,
          ticktext: opts.ticktext,
          ticks: opts.ticks,
          ticklen: opts.ticklen,
          tickwidth: opts.tickwidth,
          tickcolor: opts.tickcolor,
          showticklabels: opts.showticklabels,
          tickfont: opts.tickfont,
          tickangle: opts.tickangle,
          tickformat: opts.tickformat,
          exponentformat: opts.exponentformat,
          minexponent: opts.minexponent,
          separatethousands: opts.separatethousands,
          showexponent: opts.showexponent,
          showtickprefix: opts.showtickprefix,
          tickprefix: opts.tickprefix,
          showticksuffix: opts.showticksuffix,
          ticksuffix: opts.ticksuffix,
          title: opts.title,
          showline: true,
          anchor: 'free',
          side: 'right',
          position: 1
      };
  
      var cbAxisOut = {
          type: 'linear',
          _id: 'y' + opts._id
      };
  
      var axisOptions = {
          letter: 'y',
          font: fullLayout.font,
          noHover: true,
          noTickson: true,
          noTicklabelmode: true,
          calendar: fullLayout.calendar  // not really necessary (yet?)
      };
  
      function coerce(attr, dflt) {
          return Lib.coerce(cbAxisIn, cbAxisOut, axisLayoutAttrs, attr, dflt);
      }
  
      handleAxisDefaults(cbAxisIn, cbAxisOut, coerce, axisOptions, fullLayout);
      handleAxisPositionDefaults(cbAxisIn, cbAxisOut, coerce, axisOptions);
  
      return cbAxisOut;
  }
  
  module.exports = {
      draw: draw
  };
  
  },{"../../constants/alignment":717,"../../lib":750,"../../lib/extend":740,"../../lib/setcursor":770,"../../lib/svg_text_utils":774,"../../plots/cartesian/axes":799,"../../plots/cartesian/axis_defaults":801,"../../plots/cartesian/layout_attributes":813,"../../plots/cartesian/position_defaults":816,"../../plots/plots":862,"../../registry":882,"../color":615,"../colorscale/helpers":626,"../dragelement":634,"../drawing":637,"../titles":710,"./constants":617,"d3":169,"tinycolor2":548}],620:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  
  module.exports = function hasColorbar(container) {
      return Lib.isPlainObject(container.colorbar);
  };
  
  },{"../../lib":750}],621:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'component',
      name: 'colorbar',
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
  
      draw: _dereq_('./draw').draw,
      hasColorbar: _dereq_('./has_colorbar')
  };
  
  },{"./attributes":616,"./defaults":618,"./draw":619,"./has_colorbar":620}],622:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorbarAttrs = _dereq_('../colorbar/attributes');
  var counterRegex = _dereq_('../../lib/regex').counter;
  
  var palettes = _dereq_('./scales.js').scales;
  var paletteStr = Object.keys(palettes);
  
  function code(s) {
      return '`' + s + '`';
  }
  
  /**
   * Make colorscale attribute declarations for
   *
   * - colorscale,
   * - (c|z)auto, (c|z)min, (c|z)max,
   * - autocolorscale, reversescale,
   * - showscale (optionally)
   * - color (optionally)
   *
   * @param {string} context (dflt: '', i.e. from trace root):
   *     the container this is in ('', *marker*, *marker.line* etc)
   *
   * @param {object} opts:
   *   - cLetter {string} (dflt: 'c'):
   *     leading letter for 'min', 'max and 'auto' attribute (either 'z' or 'c')
   *
   *   - colorAttr {string} (dflt: 'z' if `cLetter: 'z'`, 'color' if `cLetter: 'c'`):
   *     (for descriptions) sets the name of the color attribute that maps to the colorscale.
   *
   *     N.B. if `colorAttr: 'color'`, we include the `color` declaration here.
   *
   *   - onlyIfNumerical {string} (dflt: false' if `cLetter: 'z'`, true if `cLetter: 'c'`):
   *     (for descriptions) set to true if colorscale attribute only
   *
   *   - colorscaleDflt {string}:
   *     overrides the colorscale dflt
   *
   *   - autoColorDflt {boolean} (dflt true):
   *     normally autocolorscale.dflt is `true`, but pass `false` to override
   *
   *   - noScale {boolean} (dflt: true if `context: 'marker.line'`, false otherwise):
   *     set to `false` to not include showscale attribute (e.g. for 'marker.line')
   *
   *   - showScaleDflt {boolean} (dflt: true if `cLetter: 'z'`, false otherwise)
   *
   *   - editTypeOverride {boolean} (dflt: ''):
   *     most of these attributes already require a recalc, but the ones that do not
   *     have editType *style* or *plot* unless you override (presumably with *calc*)
   *
   *   - anim {boolean) (dflt: undefined): is 'color' animatable?
   *
   * @return {object}
   */
  module.exports = function colorScaleAttrs(context, opts) {
      context = context || '';
      opts = opts || {};
  
      var cLetter = opts.cLetter || 'c';
      var onlyIfNumerical = ('onlyIfNumerical' in opts) ? opts.onlyIfNumerical : Boolean(context);
      var noScale = ('noScale' in opts) ? opts.noScale : context === 'marker.line';
      var showScaleDflt = ('showScaleDflt' in opts) ? opts.showScaleDflt : cLetter === 'z';
      var colorscaleDflt = typeof opts.colorscaleDflt === 'string' ? palettes[opts.colorscaleDflt] : null;
      var editTypeOverride = opts.editTypeOverride || '';
      var contextHead = context ? (context + '.') : '';
  
      var colorAttr, colorAttrFull;
  
      if('colorAttr' in opts) {
          colorAttr = opts.colorAttr;
          colorAttrFull = opts.colorAttr;
      } else {
          colorAttr = {z: 'z', c: 'color'}[cLetter];
          colorAttrFull = 'in ' + code(contextHead + colorAttr);
      }
  
      var effectDesc = onlyIfNumerical ?
          ' Has an effect only if ' + colorAttrFull + 'is set to a numerical array.' :
          '';
  
      var auto = cLetter + 'auto';
      var min = cLetter + 'min';
      var max = cLetter + 'max';
      var mid = cLetter + 'mid';
      var autoFull = code(contextHead + auto);
      var minFull = code(contextHead + min);
      var maxFull = code(contextHead + max);
      var minmaxFull = minFull + ' and ' + maxFull;
      var autoImpliedEdits = {};
      autoImpliedEdits[min] = autoImpliedEdits[max] = undefined;
      var minmaxImpliedEdits = {};
      minmaxImpliedEdits[auto] = false;
  
      var attrs = {};
  
      if(colorAttr === 'color') {
          attrs.color = {
              valType: 'color',
              arrayOk: true,
              
              editType: editTypeOverride || 'style',
              
          };
  
          if(opts.anim) {
              attrs.color.anim = true;
          }
      }
  
      attrs[auto] = {
          valType: 'boolean',
          
          dflt: true,
          editType: 'calc',
          impliedEdits: autoImpliedEdits,
          
      };
  
      attrs[min] = {
          valType: 'number',
          
          dflt: null,
          editType: editTypeOverride || 'plot',
          impliedEdits: minmaxImpliedEdits,
          
      };
  
      attrs[max] = {
          valType: 'number',
          
          dflt: null,
          editType: editTypeOverride || 'plot',
          impliedEdits: minmaxImpliedEdits,
          
      };
  
      attrs[mid] = {
          valType: 'number',
          
          dflt: null,
          editType: 'calc',
          impliedEdits: autoImpliedEdits,
          
      };
  
      attrs.colorscale = {
          valType: 'colorscale',
          
          editType: 'calc',
          dflt: colorscaleDflt,
          impliedEdits: {autocolorscale: false},
          
      };
  
      attrs.autocolorscale = {
          valType: 'boolean',
          
          // gets overrode in 'heatmap' & 'surface' for backwards comp.
          dflt: opts.autoColorDflt === false ? false : true,
          editType: 'calc',
          impliedEdits: {colorscale: undefined},
          
      };
  
      attrs.reversescale = {
          valType: 'boolean',
          
          dflt: false,
          editType: 'plot',
          
      };
  
      if(!noScale) {
          attrs.showscale = {
              valType: 'boolean',
              
              dflt: showScaleDflt,
              editType: 'calc',
              
          };
  
          attrs.colorbar = colorbarAttrs;
      }
  
      if(!opts.noColorAxis) {
          attrs.coloraxis = {
              valType: 'subplotid',
              
              regex: counterRegex('coloraxis'),
              dflt: null,
              editType: 'calc',
              
          };
      }
  
      return attrs;
  };
  
  },{"../../lib/regex":766,"../colorbar/attributes":616,"./scales.js":630}],623:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var extractOpts = _dereq_('./helpers').extractOpts;
  
  module.exports = function calc(gd, trace, opts) {
      var fullLayout = gd._fullLayout;
      var vals = opts.vals;
      var containerStr = opts.containerStr;
  
      var container = containerStr ?
          Lib.nestedProperty(trace, containerStr).get() :
          trace;
  
      var cOpts = extractOpts(container);
      var auto = cOpts.auto !== false;
      var min = cOpts.min;
      var max = cOpts.max;
      var mid = cOpts.mid;
  
      var minVal = function() { return Lib.aggNums(Math.min, null, vals); };
      var maxVal = function() { return Lib.aggNums(Math.max, null, vals); };
  
      if(min === undefined) {
          min = minVal();
      } else if(auto) {
          if(container._colorAx && isNumeric(min)) {
              min = Math.min(min, minVal());
          } else {
              min = minVal();
          }
      }
  
      if(max === undefined) {
          max = maxVal();
      } else if(auto) {
          if(container._colorAx && isNumeric(max)) {
              max = Math.max(max, maxVal());
          } else {
              max = maxVal();
          }
      }
  
      if(auto && mid !== undefined) {
          if(max - mid > mid - min) {
              min = mid - (max - mid);
          } else if(max - mid < mid - min) {
              max = mid + (mid - min);
          }
      }
  
      if(min === max) {
          min -= 0.5;
          max += 0.5;
      }
  
      cOpts._sync('min', min);
      cOpts._sync('max', max);
  
      if(cOpts.autocolorscale) {
          var scl;
          if(min * max < 0) scl = fullLayout.colorscale.diverging;
          else if(min >= 0) scl = fullLayout.colorscale.sequential;
          else scl = fullLayout.colorscale.sequentialminus;
          cOpts._sync('colorscale', scl);
      }
  };
  
  },{"../../lib":750,"./helpers":626,"fast-isnumeric":241}],624:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var hasColorscale = _dereq_('./helpers').hasColorscale;
  var extractOpts = _dereq_('./helpers').extractOpts;
  
  module.exports = function crossTraceDefaults(fullData, fullLayout) {
      function replace(cont, k) {
          var val = cont['_' + k];
          if(val !== undefined) {
              cont[k] = val;
          }
      }
  
      function relinkColorAttrs(outerCont, cbOpt) {
          var cont = cbOpt.container ?
              Lib.nestedProperty(outerCont, cbOpt.container).get() :
              outerCont;
  
          if(cont) {
              if(cont.coloraxis) {
                  // stash ref to color axis
                  cont._colorAx = fullLayout[cont.coloraxis];
              } else {
                  var cOpts = extractOpts(cont);
                  var isAuto = cOpts.auto;
  
                  if(isAuto || cOpts.min === undefined) {
                      replace(cont, cbOpt.min);
                  }
                  if(isAuto || cOpts.max === undefined) {
                      replace(cont, cbOpt.max);
                  }
                  if(cOpts.autocolorscale) {
                      replace(cont, 'colorscale');
                  }
              }
          }
      }
  
      for(var i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
          var cbOpts = trace._module.colorbar;
  
          if(cbOpts) {
              if(Array.isArray(cbOpts)) {
                  for(var j = 0; j < cbOpts.length; j++) {
                      relinkColorAttrs(trace, cbOpts[j]);
                  }
              } else {
                  relinkColorAttrs(trace, cbOpts);
              }
          }
  
          if(hasColorscale(trace, 'marker.line')) {
              relinkColorAttrs(trace, {
                  container: 'marker.line',
                  min: 'cmin',
                  max: 'cmax'
              });
          }
      }
  
      for(var k in fullLayout._colorAxes) {
          relinkColorAttrs(fullLayout[k], {min: 'cmin', max: 'cmax'});
      }
  };
  
  },{"../../lib":750,"./helpers":626}],625:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var hasColorbar = _dereq_('../colorbar/has_colorbar');
  var colorbarDefaults = _dereq_('../colorbar/defaults');
  
  var isValidScale = _dereq_('./scales').isValid;
  var traceIs = _dereq_('../../registry').traceIs;
  
  function npMaybe(parentCont, prefix) {
      var containerStr = prefix.slice(0, prefix.length - 1);
      return prefix ?
          Lib.nestedProperty(parentCont, containerStr).get() || {} :
          parentCont;
  }
  
  /**
   * Colorscale / colorbar default handler
   *
   * @param {object} parentContIn : user (input) parent container (e.g. trace or layout coloraxis object)
   * @param {object} parentContOut : full parent container
   * @param {object} layout : (full) layout object
   * @param {fn} coerce : Lib.coerce wrapper
   * @param {object} opts :
   * - prefix {string} : attr string prefix to colorscale container from parent root
   * - cLetter {string} : 'c or 'z' color letter
   */
  module.exports = function colorScaleDefaults(parentContIn, parentContOut, layout, coerce, opts) {
      var prefix = opts.prefix;
      var cLetter = opts.cLetter;
      var inTrace = '_module' in parentContOut;
      var containerIn = npMaybe(parentContIn, prefix);
      var containerOut = npMaybe(parentContOut, prefix);
      var template = npMaybe(parentContOut._template || {}, prefix) || {};
  
      // colorScaleDefaults wrapper called if-ever we need to reset the colorscale
      // attributes for containers that were linked to invalid color axes
      var thisFn = function() {
          delete parentContIn.coloraxis;
          delete parentContOut.coloraxis;
          return colorScaleDefaults(parentContIn, parentContOut, layout, coerce, opts);
      };
  
      if(inTrace) {
          var colorAxes = layout._colorAxes || {};
          var colorAx = coerce(prefix + 'coloraxis');
  
          if(colorAx) {
              var colorbarVisuals = (
                  traceIs(parentContOut, 'contour') &&
                  Lib.nestedProperty(parentContOut, 'contours.coloring').get()
              ) || 'heatmap';
  
              var stash = colorAxes[colorAx];
  
              if(stash) {
                  stash[2].push(thisFn);
  
                  if(stash[0] !== colorbarVisuals) {
                      stash[0] = false;
                      Lib.warn([
                          'Ignoring coloraxis:', colorAx, 'setting',
                          'as it is linked to incompatible colorscales.'
                      ].join(' '));
                  }
              } else {
                  // stash:
                  // - colorbar visual 'type'
                  // - colorbar options to help in Colorbar.draw
                  // - list of colorScaleDefaults wrapper functions
                  colorAxes[colorAx] = [colorbarVisuals, parentContOut, [thisFn]];
              }
              return;
          }
      }
  
      var minIn = containerIn[cLetter + 'min'];
      var maxIn = containerIn[cLetter + 'max'];
      var validMinMax = isNumeric(minIn) && isNumeric(maxIn) && (minIn < maxIn);
      var auto = coerce(prefix + cLetter + 'auto', !validMinMax);
  
      if(auto) {
          coerce(prefix + cLetter + 'mid');
      } else {
          coerce(prefix + cLetter + 'min');
          coerce(prefix + cLetter + 'max');
      }
  
      // handles both the trace case (autocolorscale is false by default) and
      // the marker and marker.line case (autocolorscale is true by default)
      var sclIn = containerIn.colorscale;
      var sclTemplate = template.colorscale;
      var autoColorscaleDflt;
      if(sclIn !== undefined) autoColorscaleDflt = !isValidScale(sclIn);
      if(sclTemplate !== undefined) autoColorscaleDflt = !isValidScale(sclTemplate);
      coerce(prefix + 'autocolorscale', autoColorscaleDflt);
  
      coerce(prefix + 'colorscale');
      coerce(prefix + 'reversescale');
  
      if(prefix !== 'marker.line.') {
          // handles both the trace case where the dflt is listed in attributes and
          // the marker case where the dflt is determined by hasColorbar
          var showScaleDflt;
          if(prefix && inTrace) showScaleDflt = hasColorbar(containerIn);
  
          var showScale = coerce(prefix + 'showscale', showScaleDflt);
          if(showScale) {
              if(prefix && template) containerOut._template = template;
              colorbarDefaults(containerIn, containerOut, layout);
          }
      }
  };
  
  },{"../../lib":750,"../../registry":882,"../colorbar/defaults":618,"../colorbar/has_colorbar":620,"./scales":630,"fast-isnumeric":241}],626:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var tinycolor = _dereq_('tinycolor2');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../color');
  
  var isValidScale = _dereq_('./scales').isValid;
  
  function hasColorscale(trace, containerStr, colorKey) {
      var container = containerStr ?
          Lib.nestedProperty(trace, containerStr).get() || {} :
          trace;
      var color = container[colorKey || 'color'];
  
      var isArrayWithOneNumber = false;
      if(Lib.isArrayOrTypedArray(color)) {
          for(var i = 0; i < color.length; i++) {
              if(isNumeric(color[i])) {
                  isArrayWithOneNumber = true;
                  break;
              }
          }
      }
  
      return (
          Lib.isPlainObject(container) && (
              isArrayWithOneNumber ||
              container.showscale === true ||
              (isNumeric(container.cmin) && isNumeric(container.cmax)) ||
              isValidScale(container.colorscale) ||
              Lib.isPlainObject(container.colorbar)
          )
      );
  }
  
  var constantAttrs = ['showscale', 'autocolorscale', 'colorscale', 'reversescale', 'colorbar'];
  var letterAttrs = ['min', 'max', 'mid', 'auto'];
  
  /**
   * Extract 'c' / 'z', trace / color axis colorscale options
   *
   * Note that it would be nice to replace all z* with c* equivalents in v2
   *
   * @param {object} cont : attribute container
   * @return {object}:
   *  - min: cmin or zmin
   *  - max: cmax or zmax
   *  - mid: cmid or zmid
   *  - auto: cauto or zauto
   *  - *scale: *scale attrs
   *  - colorbar: colorbar
   *  - _sync: function syncing attr and underscore dual (useful when calc'ing min/max)
   */
  function extractOpts(cont) {
      var colorAx = cont._colorAx;
      var cont2 = colorAx ? colorAx : cont;
      var out = {};
      var cLetter;
      var i, k;
  
      for(i = 0; i < constantAttrs.length; i++) {
          k = constantAttrs[i];
          out[k] = cont2[k];
      }
  
      if(colorAx) {
          cLetter = 'c';
          for(i = 0; i < letterAttrs.length; i++) {
              k = letterAttrs[i];
              out[k] = cont2['c' + k];
          }
      } else {
          var k2;
          for(i = 0; i < letterAttrs.length; i++) {
              k = letterAttrs[i];
              k2 = 'c' + k;
              if(k2 in cont2) {
                  out[k] = cont2[k2];
                  continue;
              }
              k2 = 'z' + k;
              if(k2 in cont2) {
                  out[k] = cont2[k2];
              }
          }
          cLetter = k2.charAt(0);
      }
  
      out._sync = function(k, v) {
          var k2 = letterAttrs.indexOf(k) !== -1 ? cLetter + k : k;
          cont2[k2] = cont2['_' + k2] = v;
      };
  
      return out;
  }
  
  /**
   * Extract colorscale into numeric domain and color range.
   *
   * @param {object} cont colorscale container (e.g. trace, marker)
   *  - colorscale {array of arrays}
   *  - cmin/zmin {number}
   *  - cmax/zmax {number}
   *  - reversescale {boolean}
   *
   * @return {object}
   *  - domain {array}
   *  - range {array}
   */
  function extractScale(cont) {
      var cOpts = extractOpts(cont);
      var cmin = cOpts.min;
      var cmax = cOpts.max;
  
      var scl = cOpts.reversescale ?
          flipScale(cOpts.colorscale) :
          cOpts.colorscale;
  
      var N = scl.length;
      var domain = new Array(N);
      var range = new Array(N);
  
      for(var i = 0; i < N; i++) {
          var si = scl[i];
          domain[i] = cmin + si[0] * (cmax - cmin);
          range[i] = si[1];
      }
  
      return {domain: domain, range: range};
  }
  
  function flipScale(scl) {
      var N = scl.length;
      var sclNew = new Array(N);
  
      for(var i = N - 1, j = 0; i >= 0; i--, j++) {
          var si = scl[i];
          sclNew[j] = [1 - si[0], si[1]];
      }
      return sclNew;
  }
  
  /**
   * General colorscale function generator.
   *
   * @param {object} specs output of Colorscale.extractScale or precomputed domain, range.
   *  - domain {array}
   *  - range {array}
   *
   * @param {object} opts
   *  - noNumericCheck {boolean} if true, scale func bypasses numeric checks
   *  - returnArray {boolean} if true, scale func return 4-item array instead of color strings
   *
   * @return {function}
   */
  function makeColorScaleFunc(specs, opts) {
      opts = opts || {};
  
      var domain = specs.domain;
      var range = specs.range;
      var N = range.length;
      var _range = new Array(N);
  
      for(var i = 0; i < N; i++) {
          var rgba = tinycolor(range[i]).toRgb();
          _range[i] = [rgba.r, rgba.g, rgba.b, rgba.a];
      }
  
      var _sclFunc = d3.scale.linear()
          .domain(domain)
          .range(_range)
          .clamp(true);
  
      var noNumericCheck = opts.noNumericCheck;
      var returnArray = opts.returnArray;
      var sclFunc;
  
      if(noNumericCheck && returnArray) {
          sclFunc = _sclFunc;
      } else if(noNumericCheck) {
          sclFunc = function(v) {
              return colorArray2rbga(_sclFunc(v));
          };
      } else if(returnArray) {
          sclFunc = function(v) {
              if(isNumeric(v)) return _sclFunc(v);
              else if(tinycolor(v).isValid()) return v;
              else return Color.defaultLine;
          };
      } else {
          sclFunc = function(v) {
              if(isNumeric(v)) return colorArray2rbga(_sclFunc(v));
              else if(tinycolor(v).isValid()) return v;
              else return Color.defaultLine;
          };
      }
  
      // colorbar draw looks into the d3 scale closure for domain and range
      sclFunc.domain = _sclFunc.domain;
      sclFunc.range = function() { return range; };
  
      return sclFunc;
  }
  
  function makeColorScaleFuncFromTrace(trace, opts) {
      return makeColorScaleFunc(extractScale(trace), opts);
  }
  
  function colorArray2rbga(colorArray) {
      var colorObj = {
          r: colorArray[0],
          g: colorArray[1],
          b: colorArray[2],
          a: colorArray[3]
      };
  
      return tinycolor(colorObj).toRgbString();
  }
  
  module.exports = {
      hasColorscale: hasColorscale,
      extractOpts: extractOpts,
      extractScale: extractScale,
      flipScale: flipScale,
      makeColorScaleFunc: makeColorScaleFunc,
      makeColorScaleFuncFromTrace: makeColorScaleFuncFromTrace
  };
  
  },{"../../lib":750,"../color":615,"./scales":630,"d3":169,"fast-isnumeric":241,"tinycolor2":548}],627:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scales = _dereq_('./scales');
  var helpers = _dereq_('./helpers');
  
  module.exports = {
      moduleType: 'component',
      name: 'colorscale',
  
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
  
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
      handleDefaults: _dereq_('./defaults'),
      crossTraceDefaults: _dereq_('./cross_trace_defaults'),
  
      calc: _dereq_('./calc'),
  
      // ./scales.js is required in lib/coerce.js ;
      // it needs to be a seperate module to avoid circular a dependency
      scales: scales.scales,
      defaultScale: scales.defaultScale,
      getScale: scales.get,
      isValidScale: scales.isValid,
  
      hasColorscale: helpers.hasColorscale,
      extractOpts: helpers.extractOpts,
      extractScale: helpers.extractScale,
      flipScale: helpers.flipScale,
      makeColorScaleFunc: helpers.makeColorScaleFunc,
      makeColorScaleFuncFromTrace: helpers.makeColorScaleFuncFromTrace
  };
  
  },{"./attributes":622,"./calc":623,"./cross_trace_defaults":624,"./defaults":625,"./helpers":626,"./layout_attributes":628,"./layout_defaults":629,"./scales":630}],628:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var colorScaleAttrs = _dereq_('./attributes');
  var scales = _dereq_('./scales').scales;
  
  var msg = 'Note that `autocolorscale` must be true for this attribute to work.';
  
  module.exports = {
      editType: 'calc',
  
      colorscale: {
          editType: 'calc',
  
          sequential: {
              valType: 'colorscale',
              dflt: scales.Reds,
              
              editType: 'calc',
              
          },
          sequentialminus: {
              valType: 'colorscale',
              dflt: scales.Blues,
              
              editType: 'calc',
              
          },
          diverging: {
              valType: 'colorscale',
              dflt: scales.RdBu,
              
              editType: 'calc',
              
          }
      },
  
      coloraxis: extendFlat({
          // not really a 'subplot' attribute container,
          // but this is the flag we use to denote attributes that
          // support yaxis, yaxis2, yaxis3, ... counters
          _isSubplotObj: true,
          editType: 'calc',
          
      }, colorScaleAttrs('', {
          colorAttr: 'corresponding trace color array(s)',
          noColorAxis: true,
          showScaleDflt: true
      }))
  };
  
  },{"../../lib/extend":740,"./attributes":622,"./scales":630}],629:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Template = _dereq_('../../plot_api/plot_template');
  
  var colorScaleAttrs = _dereq_('./layout_attributes');
  var colorScaleDefaults = _dereq_('./defaults');
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, colorScaleAttrs, attr, dflt);
      }
  
      coerce('colorscale.sequential');
      coerce('colorscale.sequentialminus');
      coerce('colorscale.diverging');
  
      var colorAxes = layoutOut._colorAxes;
      var colorAxIn, colorAxOut;
  
      function coerceAx(attr, dflt) {
          return Lib.coerce(colorAxIn, colorAxOut, colorScaleAttrs.coloraxis, attr, dflt);
      }
  
      for(var k in colorAxes) {
          var stash = colorAxes[k];
  
          if(stash[0]) {
              colorAxIn = layoutIn[k] || {};
              colorAxOut = Template.newContainer(layoutOut, k, 'coloraxis');
              colorAxOut._name = k;
              colorScaleDefaults(colorAxIn, colorAxOut, layoutOut, coerceAx, {prefix: '', cLetter: 'c'});
          } else {
              // re-coerce colorscale attributes w/o coloraxis
              for(var i = 0; i < stash[2].length; i++) {
                  stash[2][i]();
              }
              delete layoutOut._colorAxes[k];
          }
      }
  };
  
  },{"../../lib":750,"../../plot_api/plot_template":788,"./defaults":625,"./layout_attributes":628}],630:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var tinycolor = _dereq_('tinycolor2');
  
  var scales = {
      'Greys': [
          [0, 'rgb(0,0,0)'], [1, 'rgb(255,255,255)']
      ],
  
      'YlGnBu': [
          [0, 'rgb(8,29,88)'], [0.125, 'rgb(37,52,148)'],
          [0.25, 'rgb(34,94,168)'], [0.375, 'rgb(29,145,192)'],
          [0.5, 'rgb(65,182,196)'], [0.625, 'rgb(127,205,187)'],
          [0.75, 'rgb(199,233,180)'], [0.875, 'rgb(237,248,217)'],
          [1, 'rgb(255,255,217)']
      ],
  
      'Greens': [
          [0, 'rgb(0,68,27)'], [0.125, 'rgb(0,109,44)'],
          [0.25, 'rgb(35,139,69)'], [0.375, 'rgb(65,171,93)'],
          [0.5, 'rgb(116,196,118)'], [0.625, 'rgb(161,217,155)'],
          [0.75, 'rgb(199,233,192)'], [0.875, 'rgb(229,245,224)'],
          [1, 'rgb(247,252,245)']
      ],
  
      'YlOrRd': [
          [0, 'rgb(128,0,38)'], [0.125, 'rgb(189,0,38)'],
          [0.25, 'rgb(227,26,28)'], [0.375, 'rgb(252,78,42)'],
          [0.5, 'rgb(253,141,60)'], [0.625, 'rgb(254,178,76)'],
          [0.75, 'rgb(254,217,118)'], [0.875, 'rgb(255,237,160)'],
          [1, 'rgb(255,255,204)']
      ],
  
      'Bluered': [
          [0, 'rgb(0,0,255)'], [1, 'rgb(255,0,0)']
      ],
  
      // modified RdBu based on
      // http://www.kennethmoreland.com/color-maps/
      'RdBu': [
          [0, 'rgb(5,10,172)'], [0.35, 'rgb(106,137,247)'],
          [0.5, 'rgb(190,190,190)'], [0.6, 'rgb(220,170,132)'],
          [0.7, 'rgb(230,145,90)'], [1, 'rgb(178,10,28)']
      ],
  
      // Scale for non-negative numeric values
      'Reds': [
          [0, 'rgb(220,220,220)'], [0.2, 'rgb(245,195,157)'],
          [0.4, 'rgb(245,160,105)'], [1, 'rgb(178,10,28)']
      ],
  
      // Scale for non-positive numeric values
      'Blues': [
          [0, 'rgb(5,10,172)'], [0.35, 'rgb(40,60,190)'],
          [0.5, 'rgb(70,100,245)'], [0.6, 'rgb(90,120,245)'],
          [0.7, 'rgb(106,137,247)'], [1, 'rgb(220,220,220)']
      ],
  
      'Picnic': [
          [0, 'rgb(0,0,255)'], [0.1, 'rgb(51,153,255)'],
          [0.2, 'rgb(102,204,255)'], [0.3, 'rgb(153,204,255)'],
          [0.4, 'rgb(204,204,255)'], [0.5, 'rgb(255,255,255)'],
          [0.6, 'rgb(255,204,255)'], [0.7, 'rgb(255,153,255)'],
          [0.8, 'rgb(255,102,204)'], [0.9, 'rgb(255,102,102)'],
          [1, 'rgb(255,0,0)']
      ],
  
      'Rainbow': [
          [0, 'rgb(150,0,90)'], [0.125, 'rgb(0,0,200)'],
          [0.25, 'rgb(0,25,255)'], [0.375, 'rgb(0,152,255)'],
          [0.5, 'rgb(44,255,150)'], [0.625, 'rgb(151,255,0)'],
          [0.75, 'rgb(255,234,0)'], [0.875, 'rgb(255,111,0)'],
          [1, 'rgb(255,0,0)']
      ],
  
      'Portland': [
          [0, 'rgb(12,51,131)'], [0.25, 'rgb(10,136,186)'],
          [0.5, 'rgb(242,211,56)'], [0.75, 'rgb(242,143,56)'],
          [1, 'rgb(217,30,30)']
      ],
  
      'Jet': [
          [0, 'rgb(0,0,131)'], [0.125, 'rgb(0,60,170)'],
          [0.375, 'rgb(5,255,255)'], [0.625, 'rgb(255,255,0)'],
          [0.875, 'rgb(250,0,0)'], [1, 'rgb(128,0,0)']
      ],
  
      'Hot': [
          [0, 'rgb(0,0,0)'], [0.3, 'rgb(230,0,0)'],
          [0.6, 'rgb(255,210,0)'], [1, 'rgb(255,255,255)']
      ],
  
      'Blackbody': [
          [0, 'rgb(0,0,0)'], [0.2, 'rgb(230,0,0)'],
          [0.4, 'rgb(230,210,0)'], [0.7, 'rgb(255,255,255)'],
          [1, 'rgb(160,200,255)']
      ],
  
      'Earth': [
          [0, 'rgb(0,0,130)'], [0.1, 'rgb(0,180,180)'],
          [0.2, 'rgb(40,210,40)'], [0.4, 'rgb(230,230,50)'],
          [0.6, 'rgb(120,70,20)'], [1, 'rgb(255,255,255)']
      ],
  
      'Electric': [
          [0, 'rgb(0,0,0)'], [0.15, 'rgb(30,0,100)'],
          [0.4, 'rgb(120,0,100)'], [0.6, 'rgb(160,90,0)'],
          [0.8, 'rgb(230,200,0)'], [1, 'rgb(255,250,220)']
      ],
  
      'Viridis': [
          [0, '#440154'], [0.06274509803921569, '#48186a'],
          [0.12549019607843137, '#472d7b'], [0.18823529411764706, '#424086'],
          [0.25098039215686274, '#3b528b'], [0.3137254901960784, '#33638d'],
          [0.3764705882352941, '#2c728e'], [0.4392156862745098, '#26828e'],
          [0.5019607843137255, '#21918c'], [0.5647058823529412, '#1fa088'],
          [0.6274509803921569, '#28ae80'], [0.6901960784313725, '#3fbc73'],
          [0.7529411764705882, '#5ec962'], [0.8156862745098039, '#84d44b'],
          [0.8784313725490196, '#addc30'], [0.9411764705882353, '#d8e219'],
          [1, '#fde725']
      ],
  
      'Cividis': [
          [0.000000, 'rgb(0,32,76)'], [0.058824, 'rgb(0,42,102)'],
          [0.117647, 'rgb(0,52,110)'], [0.176471, 'rgb(39,63,108)'],
          [0.235294, 'rgb(60,74,107)'], [0.294118, 'rgb(76,85,107)'],
          [0.352941, 'rgb(91,95,109)'], [0.411765, 'rgb(104,106,112)'],
          [0.470588, 'rgb(117,117,117)'], [0.529412, 'rgb(131,129,120)'],
          [0.588235, 'rgb(146,140,120)'], [0.647059, 'rgb(161,152,118)'],
          [0.705882, 'rgb(176,165,114)'], [0.764706, 'rgb(192,177,109)'],
          [0.823529, 'rgb(209,191,102)'], [0.882353, 'rgb(225,204,92)'],
          [0.941176, 'rgb(243,219,79)'], [1.000000, 'rgb(255,233,69)']
      ]
  };
  
  var defaultScale = scales.RdBu;
  
  function getScale(scl, dflt) {
      if(!dflt) dflt = defaultScale;
      if(!scl) return dflt;
  
      function parseScale() {
          try {
              scl = scales[scl] || JSON.parse(scl);
          } catch(e) {
              scl = dflt;
          }
      }
  
      if(typeof scl === 'string') {
          parseScale();
          // occasionally scl is double-JSON encoded...
          if(typeof scl === 'string') parseScale();
      }
  
      if(!isValidScaleArray(scl)) return dflt;
      return scl;
  }
  
  
  function isValidScaleArray(scl) {
      var highestVal = 0;
  
      if(!Array.isArray(scl) || scl.length < 2) return false;
  
      if(!scl[0] || !scl[scl.length - 1]) return false;
  
      if(+scl[0][0] !== 0 || +scl[scl.length - 1][0] !== 1) return false;
  
      for(var i = 0; i < scl.length; i++) {
          var si = scl[i];
  
          if(si.length !== 2 || +si[0] < highestVal || !tinycolor(si[1]).isValid()) {
              return false;
          }
  
          highestVal = +si[0];
      }
  
      return true;
  }
  
  function isValidScale(scl) {
      if(scales[scl] !== undefined) return true;
      else return isValidScaleArray(scl);
  }
  
  module.exports = {
      scales: scales,
      defaultScale: defaultScale,
  
      get: getScale,
      isValid: isValidScale
  };
  
  },{"tinycolor2":548}],631:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  // for automatic alignment on dragging, <1/3 means left align,
  // >2/3 means right, and between is center. Pick the right fraction
  // based on where you are, and return the fraction corresponding to
  // that position on the object
  module.exports = function align(v, dv, v0, v1, anchor) {
      var vmin = (v - v0) / (v1 - v0);
      var vmax = vmin + dv / (v1 - v0);
      var vc = (vmin + vmax) / 2;
  
      // explicitly specified anchor
      if(anchor === 'left' || anchor === 'bottom') return vmin;
      if(anchor === 'center' || anchor === 'middle') return vc;
      if(anchor === 'right' || anchor === 'top') return vmax;
  
      // automatic based on position
      if(vmin < (2 / 3) - vc) return vmin;
      if(vmax > (4 / 3) - vc) return vmax;
      return vc;
  };
  
  },{}],632:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  
  // set cursors pointing toward the closest corner/side,
  // to indicate alignment
  // x and y are 0-1, fractions of the plot area
  var cursorset = [
      ['sw-resize', 's-resize', 'se-resize'],
      ['w-resize', 'move', 'e-resize'],
      ['nw-resize', 'n-resize', 'ne-resize']
  ];
  
  module.exports = function getCursor(x, y, xanchor, yanchor) {
      if(xanchor === 'left') x = 0;
      else if(xanchor === 'center') x = 1;
      else if(xanchor === 'right') x = 2;
      else x = Lib.constrain(Math.floor(x * 3), 0, 2);
  
      if(yanchor === 'bottom') y = 0;
      else if(yanchor === 'middle') y = 1;
      else if(yanchor === 'top') y = 2;
      else y = Lib.constrain(Math.floor(y * 3), 0, 2);
  
      return cursorset[y][x];
  };
  
  },{"../../lib":750}],633:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  exports.selectMode = function(dragmode) {
      return (
          dragmode === 'lasso' ||
          dragmode === 'select'
      );
  };
  
  exports.drawMode = function(dragmode) {
      return (
          dragmode === 'drawclosedpath' ||
          dragmode === 'drawopenpath' ||
          dragmode === 'drawline' ||
          dragmode === 'drawrect' ||
          dragmode === 'drawcircle'
      );
  };
  
  exports.openMode = function(dragmode) {
      return (
          dragmode === 'drawline' ||
          dragmode === 'drawopenpath'
      );
  };
  
  exports.rectMode = function(dragmode) {
      return (
          dragmode === 'select' ||
          dragmode === 'drawline' ||
          dragmode === 'drawrect' ||
          dragmode === 'drawcircle'
      );
  };
  
  exports.freeMode = function(dragmode) {
      return (
          dragmode === 'lasso' ||
          dragmode === 'drawclosedpath' ||
          dragmode === 'drawopenpath'
      );
  };
  
  exports.selectingOrDrawing = function(dragmode) {
      return (
          exports.freeMode(dragmode) ||
          exports.rectMode(dragmode)
      );
  };
  
  },{}],634:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var mouseOffset = _dereq_('mouse-event-offset');
  var hasHover = _dereq_('has-hover');
  var supportsPassive = _dereq_('has-passive-events');
  
  var removeElement = _dereq_('../../lib').removeElement;
  var constants = _dereq_('../../plots/cartesian/constants');
  
  var dragElement = module.exports = {};
  
  dragElement.align = _dereq_('./align');
  dragElement.getCursor = _dereq_('./cursor');
  
  var unhover = _dereq_('./unhover');
  dragElement.unhover = unhover.wrapped;
  dragElement.unhoverRaw = unhover.raw;
  
  /**
   * Abstracts click & drag interactions
   *
   * During the interaction, a "coverSlip" element - a transparent
   * div covering the whole page - is created, which has two key effects:
   * - Lets you drag beyond the boundaries of the plot itself without
   *   dropping (but if you drag all the way out of the browser window the
   *   interaction will end)
   * - Freezes the cursor: whatever mouse cursor the drag element had when the
   *   interaction started gets copied to the coverSlip for use until mouseup
   *
   * If the user executes a drag bigger than MINDRAG, callbacks will fire as:
   *      prepFn, moveFn (1 or more times), doneFn
   * If the user does not drag enough, prepFn and clickFn will fire.
   *
   * Note: If you cancel contextmenu, clickFn will fire even with a right click
   * (unlike native events) so you'll get a `plotly_click` event. Cancel context eg:
   *    gd.addEventListener('contextmenu', function(e) { e.preventDefault(); });
   * TODO: we should probably turn this into a `config` parameter, so we can fix it
   * such that if you *don't* cancel contextmenu, we can prevent partial drags, which
   * put you in a weird state.
   *
   * If the user clicks multiple times quickly, clickFn will fire each time
   * but numClicks will increase to help you recognize doubleclicks.
   *
   * @param {object} options with keys:
   *      element (required) the DOM element to drag
   *      prepFn (optional) function(event, startX, startY)
   *          executed on mousedown
   *          startX and startY are the clientX and clientY pixel position
   *          of the mousedown event
   *      moveFn (optional) function(dx, dy)
   *          executed on move, ONLY after we've exceeded MINDRAG
   *          (we keep executing moveFn if you move back to where you started)
   *          dx and dy are the net pixel offset of the drag,
   *          dragged is true/false, has the mouse moved enough to
   *          constitute a drag
   *      doneFn (optional) function(e)
   *          executed on mouseup, ONLY if we exceeded MINDRAG (so you can be
   *          sure that moveFn has been called at least once)
   *          numClicks is how many clicks we've registered within
   *          a doubleclick time
   *          e is the original mouseup event
   *      clickFn (optional) function(numClicks, e)
   *          executed on mouseup if we have NOT exceeded MINDRAG (ie moveFn
   *          has not been called at all)
   *          numClicks is how many clicks we've registered within
   *          a doubleclick time
   *          e is the original mousedown event
   *      clampFn (optional, function(dx, dy) return [dx2, dy2])
   *          Provide custom clamping function for small displacements.
   *          By default, clamping is done using `minDrag` to x and y displacements
   *          independently.
   */
  dragElement.init = function init(options) {
      var gd = options.gd;
      var numClicks = 1;
      var doubleClickDelay = gd._context.doubleClickDelay;
      var element = options.element;
  
      var startX,
          startY,
          newMouseDownTime,
          cursor,
          dragCover,
          initialEvent,
          initialTarget,
          rightClick;
  
      if(!gd._mouseDownTime) gd._mouseDownTime = 0;
  
      element.style.pointerEvents = 'all';
  
      element.onmousedown = onStart;
  
      if(!supportsPassive) {
          element.ontouchstart = onStart;
      } else {
          if(element._ontouchstart) {
              element.removeEventListener('touchstart', element._ontouchstart);
          }
          element._ontouchstart = onStart;
          element.addEventListener('touchstart', onStart, {passive: false});
      }
  
      function _clampFn(dx, dy, minDrag) {
          if(Math.abs(dx) < minDrag) dx = 0;
          if(Math.abs(dy) < minDrag) dy = 0;
          return [dx, dy];
      }
  
      var clampFn = options.clampFn || _clampFn;
  
      function onStart(e) {
          // make dragging and dragged into properties of gd
          // so that others can look at and modify them
          gd._dragged = false;
          gd._dragging = true;
          var offset = pointerOffset(e);
          startX = offset[0];
          startY = offset[1];
          initialTarget = e.target;
          initialEvent = e;
          rightClick = e.buttons === 2 || e.ctrlKey;
  
          // fix Fx.hover for touch events
          if(typeof e.clientX === 'undefined' && typeof e.clientY === 'undefined') {
              e.clientX = startX;
              e.clientY = startY;
          }
  
          newMouseDownTime = (new Date()).getTime();
          if(newMouseDownTime - gd._mouseDownTime < doubleClickDelay) {
              // in a click train
              numClicks += 1;
          } else {
              // new click train
              numClicks = 1;
              gd._mouseDownTime = newMouseDownTime;
          }
  
          if(options.prepFn) options.prepFn(e, startX, startY);
  
          if(hasHover && !rightClick) {
              dragCover = coverSlip();
              dragCover.style.cursor = window.getComputedStyle(element).cursor;
          } else if(!hasHover) {
              // document acts as a dragcover for mobile, bc we can't create dragcover dynamically
              dragCover = document;
              cursor = window.getComputedStyle(document.documentElement).cursor;
              document.documentElement.style.cursor = window.getComputedStyle(element).cursor;
          }
  
          document.addEventListener('mouseup', onDone);
          document.addEventListener('touchend', onDone);
  
          if(options.dragmode !== false) {
              e.preventDefault();
              document.addEventListener('mousemove', onMove);
              document.addEventListener('touchmove', onMove, {passive: false});
          }
  
          return;
      }
  
      function onMove(e) {
          e.preventDefault();
  
          var offset = pointerOffset(e);
          var minDrag = options.minDrag || constants.MINDRAG;
          var dxdy = clampFn(offset[0] - startX, offset[1] - startY, minDrag);
          var dx = dxdy[0];
          var dy = dxdy[1];
  
          if(dx || dy) {
              gd._dragged = true;
              dragElement.unhover(gd);
          }
  
          if(gd._dragged && options.moveFn && !rightClick) {
              gd._dragdata = {
                  element: element,
                  dx: dx,
                  dy: dy
              };
              options.moveFn(dx, dy);
          }
  
          return;
      }
  
      function onDone(e) {
          delete gd._dragdata;
  
          if(options.dragmode !== false) {
              e.preventDefault();
              document.removeEventListener('mousemove', onMove);
              document.removeEventListener('touchmove', onMove);
          }
  
          document.removeEventListener('mouseup', onDone);
          document.removeEventListener('touchend', onDone);
  
          if(hasHover) {
              removeElement(dragCover);
          } else if(cursor) {
              dragCover.documentElement.style.cursor = cursor;
              cursor = null;
          }
  
          if(!gd._dragging) {
              gd._dragged = false;
              return;
          }
          gd._dragging = false;
  
          // don't count as a dblClick unless the mouseUp is also within
          // the dblclick delay
          if((new Date()).getTime() - gd._mouseDownTime > doubleClickDelay) {
              numClicks = Math.max(numClicks - 1, 1);
          }
  
          if(gd._dragged) {
              if(options.doneFn) options.doneFn();
          } else {
              if(options.clickFn) options.clickFn(numClicks, initialEvent);
  
              // If we haven't dragged, this should be a click. But because of the
              // coverSlip changing the element, the natural system might not generate one,
              // so we need to make our own. But right clicks don't normally generate
              // click events, only contextmenu events, which happen on mousedown.
              if(!rightClick) {
                  var e2;
  
                  try {
                      e2 = new MouseEvent('click', e);
                  } catch(err) {
                      var offset = pointerOffset(e);
                      e2 = document.createEvent('MouseEvents');
                      e2.initMouseEvent('click',
                          e.bubbles, e.cancelable,
                          e.view, e.detail,
                          e.screenX, e.screenY,
                          offset[0], offset[1],
                          e.ctrlKey, e.altKey, e.shiftKey, e.metaKey,
                          e.button, e.relatedTarget);
                  }
  
                  initialTarget.dispatchEvent(e2);
              }
          }
  
          gd._dragging = false;
          gd._dragged = false;
          return;
      }
  };
  
  function coverSlip() {
      var cover = document.createElement('div');
  
      cover.className = 'dragcover';
      var cStyle = cover.style;
      cStyle.position = 'fixed';
      cStyle.left = 0;
      cStyle.right = 0;
      cStyle.top = 0;
      cStyle.bottom = 0;
      cStyle.zIndex = 999999999;
      cStyle.background = 'none';
  
      document.body.appendChild(cover);
  
      return cover;
  }
  
  dragElement.coverSlip = coverSlip;
  
  function pointerOffset(e) {
      return mouseOffset(
          e.changedTouches ? e.changedTouches[0] : e,
          document.body
      );
  }
  
  },{"../../lib":750,"../../plots/cartesian/constants":805,"./align":631,"./cursor":632,"./unhover":635,"has-hover":414,"has-passive-events":415,"mouse-event-offset":458}],635:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Events = _dereq_('../../lib/events');
  var throttle = _dereq_('../../lib/throttle');
  var getGraphDiv = _dereq_('../../lib/dom').getGraphDiv;
  
  var hoverConstants = _dereq_('../fx/constants');
  
  var unhover = module.exports = {};
  
  unhover.wrapped = function(gd, evt, subplot) {
      gd = getGraphDiv(gd);
  
      // Important, clear any queued hovers
      if(gd._fullLayout) {
          throttle.clear(gd._fullLayout._uid + hoverConstants.HOVERID);
      }
  
      unhover.raw(gd, evt, subplot);
  };
  
  
  // remove hover effects on mouse out, and emit unhover event
  unhover.raw = function raw(gd, evt) {
      var fullLayout = gd._fullLayout;
      var oldhoverdata = gd._hoverdata;
  
      if(!evt) evt = {};
      if(evt.target &&
         Events.triggerHandler(gd, 'plotly_beforehover', evt) === false) {
          return;
      }
  
      fullLayout._hoverlayer.selectAll('g').remove();
      fullLayout._hoverlayer.selectAll('line').remove();
      fullLayout._hoverlayer.selectAll('circle').remove();
      gd._hoverdata = undefined;
  
      if(evt.target && oldhoverdata) {
          gd.emit('plotly_unhover', {
              event: evt,
              points: oldhoverdata
          });
      }
  };
  
  },{"../../lib/dom":738,"../../lib/events":739,"../../lib/throttle":775,"../fx/constants":649}],636:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  exports.dash = {
      valType: 'string',
      // string type usually doesn't take values... this one should really be
      // a special type or at least a special coercion function, from the GUI
      // you only get these values but elsewhere the user can supply a list of
      // dash lengths in px, and it will be honored
      values: ['solid', 'dot', 'dash', 'longdash', 'dashdot', 'longdashdot'],
      dflt: 'solid',
      
      editType: 'style',
      
  };
  
  },{}],637:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  var tinycolor = _dereq_('tinycolor2');
  
  var Registry = _dereq_('../../registry');
  var Color = _dereq_('../color');
  var Colorscale = _dereq_('../colorscale');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  
  var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
  var alignment = _dereq_('../../constants/alignment');
  var LINE_SPACING = alignment.LINE_SPACING;
  var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
  
  var subTypes = _dereq_('../../traces/scatter/subtypes');
  var makeBubbleSizeFn = _dereq_('../../traces/scatter/make_bubble_size_func');
  var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
  
  var drawing = module.exports = {};
  
  // -----------------------------------------------------
  // styling functions for plot elements
  // -----------------------------------------------------
  
  drawing.font = function(s, family, size, color) {
      // also allow the form font(s, {family, size, color})
      if(Lib.isPlainObject(family)) {
          color = family.color;
          size = family.size;
          family = family.family;
      }
      if(family) s.style('font-family', family);
      if(size + 1) s.style('font-size', size + 'px');
      if(color) s.call(Color.fill, color);
  };
  
  /*
   * Positioning helpers
   * Note: do not use `setPosition` with <text> nodes modified by
   * `svgTextUtils.convertToTspans`. Use `svgTextUtils.positionText`
   * instead, so that <tspan.line> elements get updated to match.
   */
  drawing.setPosition = function(s, x, y) { s.attr('x', x).attr('y', y); };
  drawing.setSize = function(s, w, h) { s.attr('width', w).attr('height', h); };
  drawing.setRect = function(s, x, y, w, h) {
      s.call(drawing.setPosition, x, y).call(drawing.setSize, w, h);
  };
  
  /** Translate node
   *
   * @param {object} d : calcdata point item
   * @param {sel} sel : d3 selction of node to translate
   * @param {object} xa : corresponding full xaxis object
   * @param {object} ya : corresponding full yaxis object
   *
   * @return {boolean} :
   *  true if selection got translated
   *  false if selection could not get translated
   */
  drawing.translatePoint = function(d, sel, xa, ya) {
      var x = xa.c2p(d.x);
      var y = ya.c2p(d.y);
  
      if(isNumeric(x) && isNumeric(y) && sel.node()) {
          // for multiline text this works better
          if(sel.node().nodeName === 'text') {
              sel.attr('x', x).attr('y', y);
          } else {
              sel.attr('transform', 'translate(' + x + ',' + y + ')');
          }
      } else {
          return false;
      }
  
      return true;
  };
  
  drawing.translatePoints = function(s, xa, ya) {
      s.each(function(d) {
          var sel = d3.select(this);
          drawing.translatePoint(d, sel, xa, ya);
      });
  };
  
  drawing.hideOutsideRangePoint = function(d, sel, xa, ya, xcalendar, ycalendar) {
      sel.attr(
          'display',
          (xa.isPtWithinRange(d, xcalendar) && ya.isPtWithinRange(d, ycalendar)) ? null : 'none'
      );
  };
  
  drawing.hideOutsideRangePoints = function(traceGroups, subplot) {
      if(!subplot._hasClipOnAxisFalse) return;
  
      var xa = subplot.xaxis;
      var ya = subplot.yaxis;
  
      traceGroups.each(function(d) {
          var trace = d[0].trace;
          var xcalendar = trace.xcalendar;
          var ycalendar = trace.ycalendar;
          var selector = Registry.traceIs(trace, 'bar-like') ? '.bartext' : '.point,.textpoint';
  
          traceGroups.selectAll(selector).each(function(d) {
              drawing.hideOutsideRangePoint(d, d3.select(this), xa, ya, xcalendar, ycalendar);
          });
      });
  };
  
  drawing.crispRound = function(gd, lineWidth, dflt) {
      // for lines that disable antialiasing we want to
      // make sure the width is an integer, and at least 1 if it's nonzero
  
      if(!lineWidth || !isNumeric(lineWidth)) return dflt || 0;
  
      // but not for static plots - these don't get antialiased anyway.
      if(gd._context.staticPlot) return lineWidth;
  
      if(lineWidth < 1) return 1;
      return Math.round(lineWidth);
  };
  
  drawing.singleLineStyle = function(d, s, lw, lc, ld) {
      s.style('fill', 'none');
      var line = (((d || [])[0] || {}).trace || {}).line || {};
      var lw1 = lw || line.width || 0;
      var dash = ld || line.dash || '';
  
      Color.stroke(s, lc || line.color);
      drawing.dashLine(s, dash, lw1);
  };
  
  drawing.lineGroupStyle = function(s, lw, lc, ld) {
      s.style('fill', 'none')
      .each(function(d) {
          var line = (((d || [])[0] || {}).trace || {}).line || {};
          var lw1 = lw || line.width || 0;
          var dash = ld || line.dash || '';
  
          d3.select(this)
              .call(Color.stroke, lc || line.color)
              .call(drawing.dashLine, dash, lw1);
      });
  };
  
  drawing.dashLine = function(s, dash, lineWidth) {
      lineWidth = +lineWidth || 0;
  
      dash = drawing.dashStyle(dash, lineWidth);
  
      s.style({
          'stroke-dasharray': dash,
          'stroke-width': lineWidth + 'px'
      });
  };
  
  drawing.dashStyle = function(dash, lineWidth) {
      lineWidth = +lineWidth || 1;
      var dlw = Math.max(lineWidth, 3);
  
      if(dash === 'solid') dash = '';
      else if(dash === 'dot') dash = dlw + 'px,' + dlw + 'px';
      else if(dash === 'dash') dash = (3 * dlw) + 'px,' + (3 * dlw) + 'px';
      else if(dash === 'longdash') dash = (5 * dlw) + 'px,' + (5 * dlw) + 'px';
      else if(dash === 'dashdot') {
          dash = (3 * dlw) + 'px,' + dlw + 'px,' + dlw + 'px,' + dlw + 'px';
      } else if(dash === 'longdashdot') {
          dash = (5 * dlw) + 'px,' + (2 * dlw) + 'px,' + dlw + 'px,' + (2 * dlw) + 'px';
      }
      // otherwise user wrote the dasharray themselves - leave it be
  
      return dash;
  };
  
  // Same as fillGroupStyle, except in this case the selection may be a transition
  drawing.singleFillStyle = function(sel) {
      var node = d3.select(sel.node());
      var data = node.data();
      var fillcolor = (((data[0] || [])[0] || {}).trace || {}).fillcolor;
      if(fillcolor) {
          sel.call(Color.fill, fillcolor);
      }
  };
  
  drawing.fillGroupStyle = function(s) {
      s.style('stroke-width', 0)
      .each(function(d) {
          var shape = d3.select(this);
          // N.B. 'd' won't be a calcdata item when
          // fill !== 'none' on a segment-less and marker-less trace
          if(d[0].trace) {
              shape.call(Color.fill, d[0].trace.fillcolor);
          }
      });
  };
  
  var SYMBOLDEFS = _dereq_('./symbol_defs');
  
  drawing.symbolNames = [];
  drawing.symbolFuncs = [];
  drawing.symbolNeedLines = {};
  drawing.symbolNoDot = {};
  drawing.symbolNoFill = {};
  drawing.symbolList = [];
  
  Object.keys(SYMBOLDEFS).forEach(function(k) {
      var symDef = SYMBOLDEFS[k];
      var n = symDef.n;
      drawing.symbolList.push(
          n,
          String(n),
          k,
  
          n + 100,
          String(n + 100),
          k + '-open'
      );
      drawing.symbolNames[n] = k;
      drawing.symbolFuncs[n] = symDef.f;
  
      if(symDef.needLine) {
          drawing.symbolNeedLines[n] = true;
      }
      if(symDef.noDot) {
          drawing.symbolNoDot[n] = true;
      } else {
          drawing.symbolList.push(
              n + 200,
              String(n + 200),
              k + '-dot',
  
              n + 300,
              String(n + 300),
              k + '-open-dot'
          );
      }
      if(symDef.noFill) {
          drawing.symbolNoFill[n] = true;
      }
  });
  
  var MAXSYMBOL = drawing.symbolNames.length;
  // add a dot in the middle of the symbol
  var DOTPATH = 'M0,0.5L0.5,0L0,-0.5L-0.5,0Z';
  
  drawing.symbolNumber = function(v) {
      if(isNumeric(v)) {
          v = +v;
      } else if(typeof v === 'string') {
          var vbase = 0;
          if(v.indexOf('-open') > 0) {
              vbase = 100;
              v = v.replace('-open', '');
          }
          if(v.indexOf('-dot') > 0) {
              vbase += 200;
              v = v.replace('-dot', '');
          }
          v = drawing.symbolNames.indexOf(v);
          if(v >= 0) { v += vbase; }
      }
  
      return (v % 100 >= MAXSYMBOL || v >= 400) ?
          0 : Math.floor(Math.max(v, 0));
  };
  
  function makePointPath(symbolNumber, r) {
      var base = symbolNumber % 100;
      return drawing.symbolFuncs[base](r) + (symbolNumber >= 200 ? DOTPATH : '');
  }
  
  var HORZGRADIENT = {x1: 1, x2: 0, y1: 0, y2: 0};
  var VERTGRADIENT = {x1: 0, x2: 0, y1: 1, y2: 0};
  var stopFormatter = d3.format('~.1f');
  var gradientInfo = {
      radial: {node: 'radialGradient'},
      radialreversed: {node: 'radialGradient', reversed: true},
      horizontal: {node: 'linearGradient', attrs: HORZGRADIENT},
      horizontalreversed: {node: 'linearGradient', attrs: HORZGRADIENT, reversed: true},
      vertical: {node: 'linearGradient', attrs: VERTGRADIENT},
      verticalreversed: {node: 'linearGradient', attrs: VERTGRADIENT, reversed: true}
  };
  
  /**
   * gradient: create and apply a gradient fill
   *
   * @param {object} sel: d3 selection to apply this gradient to
   *     You can use `selection.call(Drawing.gradient, ...)`
   * @param {DOM element} gd: the graph div `sel` is part of
   * @param {string} gradientID: a unique (within this plot) identifier
   *     for this gradient, so that we don't create unnecessary definitions
   * @param {string} type: 'radial', 'horizontal', or 'vertical', optionally with
   *     'reversed' at the end. Normally radial goes center to edge,
   *     horizontal goes right to left, and vertical goes bottom to top
   * @param {array} colorscale: as in attribute values, [[fraction, color], ...]
   * @param {string} prop: the property to apply to, 'fill' or 'stroke'
   */
  drawing.gradient = function(sel, gd, gradientID, type, colorscale, prop) {
      var len = colorscale.length;
      var info = gradientInfo[type];
      var colorStops = new Array(len);
      for(var i = 0; i < len; i++) {
          if(info.reversed) {
              colorStops[len - 1 - i] = [stopFormatter((1 - colorscale[i][0]) * 100), colorscale[i][1]];
          } else {
              colorStops[i] = [stopFormatter(colorscale[i][0] * 100), colorscale[i][1]];
          }
      }
  
      var fullLayout = gd._fullLayout;
      var fullID = 'g' + fullLayout._uid + '-' + gradientID;
  
      var gradient = fullLayout._defs.select('.gradients')
          .selectAll('#' + fullID)
          .data([type + colorStops.join(';')], Lib.identity);
  
      gradient.exit().remove();
  
      gradient.enter()
          .append(info.node)
          .each(function() {
              var el = d3.select(this);
              if(info.attrs) el.attr(info.attrs);
  
              el.attr('id', fullID);
  
              var stops = el.selectAll('stop')
                  .data(colorStops);
              stops.exit().remove();
              stops.enter().append('stop');
  
              stops.each(function(d) {
                  var tc = tinycolor(d[1]);
                  d3.select(this).attr({
                      offset: d[0] + '%',
                      'stop-color': Color.tinyRGB(tc),
                      'stop-opacity': tc.getAlpha()
                  });
              });
          });
  
      sel.style(prop, getFullUrl(fullID, gd))
          .style(prop + '-opacity', null);
  
      var className2query = function(s) {
          return '.' + s.attr('class').replace(/\s/g, '.');
      };
      var k = className2query(d3.select(sel.node().parentNode)) +
          '>' + className2query(sel);
      fullLayout._gradientUrlQueryParts[k] = 1;
  };
  
  /*
   * Make the gradients container and clear out any previous gradients.
   * We never collect all the gradients we need in one place,
   * so we can't ever remove gradients that have stopped being useful,
   * except all at once before a full redraw.
   * The upside of this is arbitrary points can share gradient defs
   */
  drawing.initGradients = function(gd) {
      var fullLayout = gd._fullLayout;
  
      var gradientsGroup = Lib.ensureSingle(fullLayout._defs, 'g', 'gradients');
      gradientsGroup.selectAll('linearGradient,radialGradient').remove();
  
      // initialize stash of query parts filled in Drawing.gradient,
      // used to fix URL strings during image exports
      fullLayout._gradientUrlQueryParts = {};
  };
  
  
  drawing.pointStyle = function(s, trace, gd) {
      if(!s.size()) return;
  
      var fns = drawing.makePointStyleFns(trace);
  
      s.each(function(d) {
          drawing.singlePointStyle(d, d3.select(this), trace, fns, gd);
      });
  };
  
  drawing.singlePointStyle = function(d, sel, trace, fns, gd) {
      var marker = trace.marker;
      var markerLine = marker.line;
  
      sel.style('opacity',
          fns.selectedOpacityFn ? fns.selectedOpacityFn(d) :
              (d.mo === undefined ? marker.opacity : d.mo)
      );
  
      if(fns.ms2mrc) {
          var r;
  
          // handle multi-trace graph edit case
          if(d.ms === 'various' || marker.size === 'various') {
              r = 3;
          } else {
              r = fns.ms2mrc(d.ms);
          }
  
          // store the calculated size so hover can use it
          d.mrc = r;
  
          if(fns.selectedSizeFn) {
              r = d.mrc = fns.selectedSizeFn(d);
          }
  
          // turn the symbol into a sanitized number
          var x = drawing.symbolNumber(d.mx || marker.symbol) || 0;
  
          // save if this marker is open
          // because that impacts how to handle colors
          d.om = x % 200 >= 100;
  
          sel.attr('d', makePointPath(x, r));
      }
  
      var perPointGradient = false;
      var fillColor, lineColor, lineWidth;
  
      // 'so' is suspected outliers, for box plots
      if(d.so) {
          lineWidth = markerLine.outlierwidth;
          lineColor = markerLine.outliercolor;
          fillColor = marker.outliercolor;
      } else {
          var markerLineWidth = (markerLine || {}).width;
  
          lineWidth = (
              d.mlw + 1 ||
              markerLineWidth + 1 ||
              // TODO: we need the latter for legends... can we get rid of it?
              (d.trace ? (d.trace.marker.line || {}).width : 0) + 1
          ) - 1 || 0;
  
          if('mlc' in d) lineColor = d.mlcc = fns.lineScale(d.mlc);
          // weird case: array wasn't long enough to apply to every point
          else if(Lib.isArrayOrTypedArray(markerLine.color)) lineColor = Color.defaultLine;
          else lineColor = markerLine.color;
  
          if(Lib.isArrayOrTypedArray(marker.color)) {
              fillColor = Color.defaultLine;
              perPointGradient = true;
          }
  
          if('mc' in d) {
              fillColor = d.mcc = fns.markerScale(d.mc);
          } else {
              fillColor = marker.color || 'rgba(0,0,0,0)';
          }
  
          if(fns.selectedColorFn) {
              fillColor = fns.selectedColorFn(d);
          }
      }
  
      if(d.om) {
          // open markers can't have zero linewidth, default to 1px,
          // and use fill color as stroke color
          sel.call(Color.stroke, fillColor)
              .style({
                  'stroke-width': (lineWidth || 1) + 'px',
                  fill: 'none'
              });
      } else {
          sel.style('stroke-width', (d.isBlank ? 0 : lineWidth) + 'px');
  
          var markerGradient = marker.gradient;
  
          var gradientType = d.mgt;
          if(gradientType) perPointGradient = true;
          else gradientType = markerGradient && markerGradient.type;
  
          // for legend - arrays will propagate through here, but we don't need
          // to treat it as per-point.
          if(Array.isArray(gradientType)) {
              gradientType = gradientType[0];
              if(!gradientInfo[gradientType]) gradientType = 0;
          }
  
          if(gradientType && gradientType !== 'none') {
              var gradientColor = d.mgc;
              if(gradientColor) perPointGradient = true;
              else gradientColor = markerGradient.color;
  
              var gradientID = trace.uid;
              if(perPointGradient) gradientID += '-' + d.i;
  
              drawing.gradient(sel, gd, gradientID, gradientType,
                  [[0, gradientColor], [1, fillColor]], 'fill');
          } else {
              Color.fill(sel, fillColor);
          }
  
          if(lineWidth) {
              Color.stroke(sel, lineColor);
          }
      }
  };
  
  drawing.makePointStyleFns = function(trace) {
      var out = {};
      var marker = trace.marker;
  
      // allow array marker and marker line colors to be
      // scaled by given max and min to colorscales
      out.markerScale = drawing.tryColorscale(marker, '');
      out.lineScale = drawing.tryColorscale(marker, 'line');
  
      if(Registry.traceIs(trace, 'symbols')) {
          out.ms2mrc = subTypes.isBubble(trace) ?
              makeBubbleSizeFn(trace) :
              function() { return (marker.size || 6) / 2; };
      }
  
      if(trace.selectedpoints) {
          Lib.extendFlat(out, drawing.makeSelectedPointStyleFns(trace));
      }
  
      return out;
  };
  
  drawing.makeSelectedPointStyleFns = function(trace) {
      var out = {};
  
      var selectedAttrs = trace.selected || {};
      var unselectedAttrs = trace.unselected || {};
  
      var marker = trace.marker || {};
      var selectedMarker = selectedAttrs.marker || {};
      var unselectedMarker = unselectedAttrs.marker || {};
  
      var mo = marker.opacity;
      var smo = selectedMarker.opacity;
      var usmo = unselectedMarker.opacity;
      var smoIsDefined = smo !== undefined;
      var usmoIsDefined = usmo !== undefined;
  
      if(Lib.isArrayOrTypedArray(mo) || smoIsDefined || usmoIsDefined) {
          out.selectedOpacityFn = function(d) {
              var base = d.mo === undefined ? marker.opacity : d.mo;
  
              if(d.selected) {
                  return smoIsDefined ? smo : base;
              } else {
                  return usmoIsDefined ? usmo : DESELECTDIM * base;
              }
          };
      }
  
      var mc = marker.color;
      var smc = selectedMarker.color;
      var usmc = unselectedMarker.color;
  
      if(smc || usmc) {
          out.selectedColorFn = function(d) {
              var base = d.mcc || mc;
  
              if(d.selected) {
                  return smc || base;
              } else {
                  return usmc || base;
              }
          };
      }
  
      var ms = marker.size;
      var sms = selectedMarker.size;
      var usms = unselectedMarker.size;
      var smsIsDefined = sms !== undefined;
      var usmsIsDefined = usms !== undefined;
  
      if(Registry.traceIs(trace, 'symbols') && (smsIsDefined || usmsIsDefined)) {
          out.selectedSizeFn = function(d) {
              var base = d.mrc || ms / 2;
  
              if(d.selected) {
                  return smsIsDefined ? sms / 2 : base;
              } else {
                  return usmsIsDefined ? usms / 2 : base;
              }
          };
      }
  
      return out;
  };
  
  drawing.makeSelectedTextStyleFns = function(trace) {
      var out = {};
  
      var selectedAttrs = trace.selected || {};
      var unselectedAttrs = trace.unselected || {};
  
      var textFont = trace.textfont || {};
      var selectedTextFont = selectedAttrs.textfont || {};
      var unselectedTextFont = unselectedAttrs.textfont || {};
  
      var tc = textFont.color;
      var stc = selectedTextFont.color;
      var utc = unselectedTextFont.color;
  
      out.selectedTextColorFn = function(d) {
          var base = d.tc || tc;
  
          if(d.selected) {
              return stc || base;
          } else {
              if(utc) return utc;
              else return stc ? base : Color.addOpacity(base, DESELECTDIM);
          }
      };
  
      return out;
  };
  
  drawing.selectedPointStyle = function(s, trace) {
      if(!s.size() || !trace.selectedpoints) return;
  
      var fns = drawing.makeSelectedPointStyleFns(trace);
      var marker = trace.marker || {};
      var seq = [];
  
      if(fns.selectedOpacityFn) {
          seq.push(function(pt, d) {
              pt.style('opacity', fns.selectedOpacityFn(d));
          });
      }
  
      if(fns.selectedColorFn) {
          seq.push(function(pt, d) {
              Color.fill(pt, fns.selectedColorFn(d));
          });
      }
  
      if(fns.selectedSizeFn) {
          seq.push(function(pt, d) {
              var mx = d.mx || marker.symbol || 0;
              var mrc2 = fns.selectedSizeFn(d);
  
              pt.attr('d', makePointPath(drawing.symbolNumber(mx), mrc2));
  
              // save for Drawing.selectedTextStyle
              d.mrc2 = mrc2;
          });
      }
  
      if(seq.length) {
          s.each(function(d) {
              var pt = d3.select(this);
              for(var i = 0; i < seq.length; i++) {
                  seq[i](pt, d);
              }
          });
      }
  };
  
  drawing.tryColorscale = function(marker, prefix) {
      var cont = prefix ? Lib.nestedProperty(marker, prefix).get() : marker;
  
      if(cont) {
          var colorArray = cont.color;
          if((cont.colorscale || cont._colorAx) && Lib.isArrayOrTypedArray(colorArray)) {
              return Colorscale.makeColorScaleFuncFromTrace(cont);
          }
      }
      return Lib.identity;
  };
  
  var TEXTOFFSETSIGN = {
      start: 1, end: -1, middle: 0, bottom: 1, top: -1
  };
  
  function textPointPosition(s, textPosition, fontSize, markerRadius) {
      var group = d3.select(s.node().parentNode);
  
      var v = textPosition.indexOf('top') !== -1 ?
          'top' :
          textPosition.indexOf('bottom') !== -1 ? 'bottom' : 'middle';
      var h = textPosition.indexOf('left') !== -1 ?
          'end' :
          textPosition.indexOf('right') !== -1 ? 'start' : 'middle';
  
      // if markers are shown, offset a little more than
      // the nominal marker size
      // ie 2/1.6 * nominal, bcs some markers are a bit bigger
      var r = markerRadius ? markerRadius / 0.8 + 1 : 0;
  
      var numLines = (svgTextUtils.lineCount(s) - 1) * LINE_SPACING + 1;
      var dx = TEXTOFFSETSIGN[h] * r;
      var dy = fontSize * 0.75 + TEXTOFFSETSIGN[v] * r +
          (TEXTOFFSETSIGN[v] - 1) * numLines * fontSize / 2;
  
      // fix the overall text group position
      s.attr('text-anchor', h);
      group.attr('transform', 'translate(' + dx + ',' + dy + ')');
  }
  
  function extracTextFontSize(d, trace) {
      var fontSize = d.ts || trace.textfont.size;
      return (isNumeric(fontSize) && fontSize > 0) ? fontSize : 0;
  }
  
  // draw text at points
  drawing.textPointStyle = function(s, trace, gd) {
      if(!s.size()) return;
  
      var selectedTextColorFn;
      if(trace.selectedpoints) {
          var fns = drawing.makeSelectedTextStyleFns(trace);
          selectedTextColorFn = fns.selectedTextColorFn;
      }
  
      var texttemplate = trace.texttemplate;
      var fullLayout = gd._fullLayout;
  
      s.each(function(d) {
          var p = d3.select(this);
  
          var text = texttemplate ?
              Lib.extractOption(d, trace, 'txt', 'texttemplate') :
              Lib.extractOption(d, trace, 'tx', 'text');
  
          if(!text && text !== 0) {
              p.remove();
              return;
          }
  
          if(texttemplate) {
              var labels = trace._module.formatLabels ? trace._module.formatLabels(d, trace, fullLayout) : {};
              var pointValues = {};
              appendArrayPointValue(pointValues, trace, d.i);
              var meta = trace._meta || {};
              text = Lib.texttemplateString(text, labels, fullLayout._d3locale, pointValues, d, meta);
          }
  
          var pos = d.tp || trace.textposition;
          var fontSize = extracTextFontSize(d, trace);
          var fontColor = selectedTextColorFn ?
              selectedTextColorFn(d) :
              (d.tc || trace.textfont.color);
  
          p.call(drawing.font,
                  d.tf || trace.textfont.family,
                  fontSize,
                  fontColor)
              .text(text)
              .call(svgTextUtils.convertToTspans, gd)
              .call(textPointPosition, pos, fontSize, d.mrc);
      });
  };
  
  drawing.selectedTextStyle = function(s, trace) {
      if(!s.size() || !trace.selectedpoints) return;
  
      var fns = drawing.makeSelectedTextStyleFns(trace);
  
      s.each(function(d) {
          var tx = d3.select(this);
          var tc = fns.selectedTextColorFn(d);
          var tp = d.tp || trace.textposition;
          var fontSize = extracTextFontSize(d, trace);
  
          Color.fill(tx, tc);
          textPointPosition(tx, tp, fontSize, d.mrc2 || d.mrc);
      });
  };
  
  // generalized Catmull-Rom splines, per
  // http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
  var CatmullRomExp = 0.5;
  drawing.smoothopen = function(pts, smoothness) {
      if(pts.length < 3) { return 'M' + pts.join('L');}
      var path = 'M' + pts[0];
      var tangents = [];
      var i;
      for(i = 1; i < pts.length - 1; i++) {
          tangents.push(makeTangent(pts[i - 1], pts[i], pts[i + 1], smoothness));
      }
      path += 'Q' + tangents[0][0] + ' ' + pts[1];
      for(i = 2; i < pts.length - 1; i++) {
          path += 'C' + tangents[i - 2][1] + ' ' + tangents[i - 1][0] + ' ' + pts[i];
      }
      path += 'Q' + tangents[pts.length - 3][1] + ' ' + pts[pts.length - 1];
      return path;
  };
  
  drawing.smoothclosed = function(pts, smoothness) {
      if(pts.length < 3) { return 'M' + pts.join('L') + 'Z'; }
      var path = 'M' + pts[0];
      var pLast = pts.length - 1;
      var tangents = [makeTangent(pts[pLast], pts[0], pts[1], smoothness)];
      var i;
      for(i = 1; i < pLast; i++) {
          tangents.push(makeTangent(pts[i - 1], pts[i], pts[i + 1], smoothness));
      }
      tangents.push(
          makeTangent(pts[pLast - 1], pts[pLast], pts[0], smoothness)
      );
  
      for(i = 1; i <= pLast; i++) {
          path += 'C' + tangents[i - 1][1] + ' ' + tangents[i][0] + ' ' + pts[i];
      }
      path += 'C' + tangents[pLast][1] + ' ' + tangents[0][0] + ' ' + pts[0] + 'Z';
      return path;
  };
  
  function makeTangent(prevpt, thispt, nextpt, smoothness) {
      var d1x = prevpt[0] - thispt[0];
      var d1y = prevpt[1] - thispt[1];
      var d2x = nextpt[0] - thispt[0];
      var d2y = nextpt[1] - thispt[1];
      var d1a = Math.pow(d1x * d1x + d1y * d1y, CatmullRomExp / 2);
      var d2a = Math.pow(d2x * d2x + d2y * d2y, CatmullRomExp / 2);
      var numx = (d2a * d2a * d1x - d1a * d1a * d2x) * smoothness;
      var numy = (d2a * d2a * d1y - d1a * d1a * d2y) * smoothness;
      var denom1 = 3 * d2a * (d1a + d2a);
      var denom2 = 3 * d1a * (d1a + d2a);
      return [
          [
              d3.round(thispt[0] + (denom1 && numx / denom1), 2),
              d3.round(thispt[1] + (denom1 && numy / denom1), 2)
          ], [
              d3.round(thispt[0] - (denom2 && numx / denom2), 2),
              d3.round(thispt[1] - (denom2 && numy / denom2), 2)
          ]
      ];
  }
  
  // step paths - returns a generator function for paths
  // with the given step shape
  var STEPPATH = {
      hv: function(p0, p1) {
          return 'H' + d3.round(p1[0], 2) + 'V' + d3.round(p1[1], 2);
      },
      vh: function(p0, p1) {
          return 'V' + d3.round(p1[1], 2) + 'H' + d3.round(p1[0], 2);
      },
      hvh: function(p0, p1) {
          return 'H' + d3.round((p0[0] + p1[0]) / 2, 2) + 'V' +
              d3.round(p1[1], 2) + 'H' + d3.round(p1[0], 2);
      },
      vhv: function(p0, p1) {
          return 'V' + d3.round((p0[1] + p1[1]) / 2, 2) + 'H' +
              d3.round(p1[0], 2) + 'V' + d3.round(p1[1], 2);
      }
  };
  var STEPLINEAR = function(p0, p1) {
      return 'L' + d3.round(p1[0], 2) + ',' + d3.round(p1[1], 2);
  };
  drawing.steps = function(shape) {
      var onestep = STEPPATH[shape] || STEPLINEAR;
      return function(pts) {
          var path = 'M' + d3.round(pts[0][0], 2) + ',' + d3.round(pts[0][1], 2);
          for(var i = 1; i < pts.length; i++) {
              path += onestep(pts[i - 1], pts[i]);
          }
          return path;
      };
  };
  
  // off-screen svg render testing element, shared by the whole page
  // uses the id 'js-plotly-tester' and stores it in drawing.tester
  drawing.makeTester = function() {
      var tester = Lib.ensureSingleById(d3.select('body'), 'svg', 'js-plotly-tester', function(s) {
          s.attr(xmlnsNamespaces.svgAttrs)
              .style({
                  position: 'absolute',
                  left: '-10000px',
                  top: '-10000px',
                  width: '9000px',
                  height: '9000px',
                  'z-index': '1'
              });
      });
  
      // browsers differ on how they describe the bounding rect of
      // the svg if its contents spill over... so make a 1x1px
      // reference point we can measure off of.
      var testref = Lib.ensureSingle(tester, 'path', 'js-reference-point', function(s) {
          s.attr('d', 'M0,0H1V1H0Z')
              .style({
                  'stroke-width': 0,
                  fill: 'black'
              });
      });
  
      drawing.tester = tester;
      drawing.testref = testref;
  };
  
  /*
   * use our offscreen tester to get a clientRect for an element,
   * in a reference frame where it isn't translated (or transformed) and
   * its anchor point is at (0,0)
   * always returns a copy of the bbox, so the caller can modify it safely
   *
   * @param {SVGElement} node: the element to measure. If possible this should be
   *   a <text> or MathJax <g> element that's already passed through
   *   `convertToTspans` because in that case we can cache the results, but it's
   *   possible to pass in any svg element.
   *
   * @param {boolean} inTester: is this element already in `drawing.tester`?
   *   If you are measuring a dummy element, rather than one you really intend
   *   to use on the plot, making it in `drawing.tester` in the first place
   *   allows us to test faster because it cuts out cloning and appending it.
   *
   * @param {string} hash: for internal use only, if we already know the cache key
   *   for this element beforehand.
   *
   * @return {object}: a plain object containing the width, height, left, right,
   *   top, and bottom of `node`
   */
  drawing.savedBBoxes = {};
  var savedBBoxesCount = 0;
  var maxSavedBBoxes = 10000;
  
  drawing.bBox = function(node, inTester, hash) {
      /*
       * Cache elements we've already measured so we don't have to
       * remeasure the same thing many times
       * We have a few bBox callers though who pass a node larger than
       * a <text> or a MathJax <g>, such as an axis group containing many labels.
       * These will not generate a hash (unless we figure out an appropriate
       * hash key for them) and thus we will not hash them.
       */
      if(!hash) hash = nodeHash(node);
      var out;
      if(hash) {
          out = drawing.savedBBoxes[hash];
          if(out) return Lib.extendFlat({}, out);
      } else if(node.childNodes.length === 1) {
          /*
           * If we have only one child element, which is itself hashable, make
           * a new hash from this element plus its x,y,transform
           * These bounding boxes *include* x,y,transform - mostly for use by
           * callers trying to avoid overlaps (ie titles)
           */
          var innerNode = node.childNodes[0];
  
          hash = nodeHash(innerNode);
          if(hash) {
              var x = +innerNode.getAttribute('x') || 0;
              var y = +innerNode.getAttribute('y') || 0;
              var transform = innerNode.getAttribute('transform');
  
              if(!transform) {
                  // in this case, just varying x and y, don't bother caching
                  // the final bBox because the alteration is quick.
                  var innerBB = drawing.bBox(innerNode, false, hash);
                  if(x) {
                      innerBB.left += x;
                      innerBB.right += x;
                  }
                  if(y) {
                      innerBB.top += y;
                      innerBB.bottom += y;
                  }
                  return innerBB;
              }
              /*
               * else we have a transform - rather than make a complicated
               * (and error-prone and probably slow) transform parser/calculator,
               * just continue on calculating the boundingClientRect of the group
               * and use the new composite hash to cache it.
               * That said, `innerNode.transform.baseVal` is an array of
               * `SVGTransform` objects, that *do* seem to have a nice matrix
               * multiplication interface that we could use to avoid making
               * another getBoundingClientRect call...
               */
              hash += '~' + x + '~' + y + '~' + transform;
  
              out = drawing.savedBBoxes[hash];
              if(out) return Lib.extendFlat({}, out);
          }
      }
      var testNode, tester;
      if(inTester) {
          testNode = node;
      } else {
          tester = drawing.tester.node();
  
          // copy the node to test into the tester
          testNode = node.cloneNode(true);
          tester.appendChild(testNode);
      }
  
      // standardize its position (and newline tspans if any)
      d3.select(testNode)
          .attr('transform', null)
          .call(svgTextUtils.positionText, 0, 0);
  
      var testRect = testNode.getBoundingClientRect();
      var refRect = drawing.testref
          .node()
          .getBoundingClientRect();
  
      if(!inTester) tester.removeChild(testNode);
  
      var bb = {
          height: testRect.height,
          width: testRect.width,
          left: testRect.left - refRect.left,
          top: testRect.top - refRect.top,
          right: testRect.right - refRect.left,
          bottom: testRect.bottom - refRect.top
      };
  
      // make sure we don't have too many saved boxes,
      // or a long session could overload on memory
      // by saving boxes for long-gone elements
      if(savedBBoxesCount >= maxSavedBBoxes) {
          drawing.savedBBoxes = {};
          savedBBoxesCount = 0;
      }
  
      // cache this bbox
      if(hash) drawing.savedBBoxes[hash] = bb;
      savedBBoxesCount++;
  
      return Lib.extendFlat({}, bb);
  };
  
  // capture everything about a node (at least in our usage) that
  // impacts its bounding box, given that bBox clears x, y, and transform
  function nodeHash(node) {
      var inputText = node.getAttribute('data-unformatted');
      if(inputText === null) return;
      return inputText +
          node.getAttribute('data-math') +
          node.getAttribute('text-anchor') +
          node.getAttribute('style');
  }
  
  /**
   * Set clipPath URL in a way that work for all situations.
   *
   * In details, graphs on pages with <base> HTML tags need to prepend
   * the clip path ids with the page's base url EXCEPT during toImage exports.
   *
   * @param {d3 selection} s : node to add clip-path attribute
   * @param {string} localId : local clip-path (w/o base url) id
   * @param {DOM element || object} gd
   * - context._baseUrl {string}
   * - context._exportedPlot {boolean}
   */
  drawing.setClipUrl = function(s, localId, gd) {
      s.attr('clip-path', getFullUrl(localId, gd));
  };
  
  function getFullUrl(localId, gd) {
      if(!localId) return null;
  
      var context = gd._context;
      var baseUrl = context._exportedPlot ? '' : (context._baseUrl || '');
      return 'url(\'' + baseUrl + '#' + localId + '\')';
  }
  
  drawing.getTranslate = function(element) {
      // Note the separator [^\d] between x and y in this regex
      // We generally use ',' but IE will convert it to ' '
      var re = /.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/;
      var getter = element.attr ? 'attr' : 'getAttribute';
      var transform = element[getter]('transform') || '';
  
      var translate = transform.replace(re, function(match, p1, p2) {
          return [p1, p2].join(' ');
      })
      .split(' ');
  
      return {
          x: +translate[0] || 0,
          y: +translate[1] || 0
      };
  };
  
  drawing.setTranslate = function(element, x, y) {
      var re = /(\btranslate\(.*?\);?)/;
      var getter = element.attr ? 'attr' : 'getAttribute';
      var setter = element.attr ? 'attr' : 'setAttribute';
      var transform = element[getter]('transform') || '';
  
      x = x || 0;
      y = y || 0;
  
      transform = transform.replace(re, '').trim();
      transform += ' translate(' + x + ', ' + y + ')';
      transform = transform.trim();
  
      element[setter]('transform', transform);
  
      return transform;
  };
  
  drawing.getScale = function(element) {
      var re = /.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/;
      var getter = element.attr ? 'attr' : 'getAttribute';
      var transform = element[getter]('transform') || '';
  
      var translate = transform.replace(re, function(match, p1, p2) {
          return [p1, p2].join(' ');
      })
      .split(' ');
  
      return {
          x: +translate[0] || 1,
          y: +translate[1] || 1
      };
  };
  
  drawing.setScale = function(element, x, y) {
      var re = /(\bscale\(.*?\);?)/;
      var getter = element.attr ? 'attr' : 'getAttribute';
      var setter = element.attr ? 'attr' : 'setAttribute';
      var transform = element[getter]('transform') || '';
  
      x = x || 1;
      y = y || 1;
  
      transform = transform.replace(re, '').trim();
      transform += ' scale(' + x + ', ' + y + ')';
      transform = transform.trim();
  
      element[setter]('transform', transform);
  
      return transform;
  };
  
  var SCALE_RE = /\s*sc.*/;
  
  drawing.setPointGroupScale = function(selection, xScale, yScale) {
      xScale = xScale || 1;
      yScale = yScale || 1;
  
      if(!selection) return;
  
      // The same scale transform for every point:
      var scale = (xScale === 1 && yScale === 1) ?
          '' :
          ' scale(' + xScale + ',' + yScale + ')';
  
      selection.each(function() {
          var t = (this.getAttribute('transform') || '').replace(SCALE_RE, '');
          t += scale;
          t = t.trim();
          this.setAttribute('transform', t);
      });
  };
  
  var TEXT_POINT_LAST_TRANSLATION_RE = /translate\([^)]*\)\s*$/;
  
  drawing.setTextPointsScale = function(selection, xScale, yScale) {
      if(!selection) return;
  
      selection.each(function() {
          var transforms;
          var el = d3.select(this);
          var text = el.select('text');
  
          if(!text.node()) return;
  
          var x = parseFloat(text.attr('x') || 0);
          var y = parseFloat(text.attr('y') || 0);
  
          var existingTransform = (el.attr('transform') || '').match(TEXT_POINT_LAST_TRANSLATION_RE);
  
          if(xScale === 1 && yScale === 1) {
              transforms = [];
          } else {
              transforms = [
                  'translate(' + x + ',' + y + ')',
                  'scale(' + xScale + ',' + yScale + ')',
                  'translate(' + (-x) + ',' + (-y) + ')',
              ];
          }
  
          if(existingTransform) {
              transforms.push(existingTransform);
          }
  
          el.attr('transform', transforms.join(' '));
      });
  };
  
  },{"../../components/fx/helpers":651,"../../constants/alignment":717,"../../constants/interactions":724,"../../constants/xmlns_namespaces":726,"../../lib":750,"../../lib/svg_text_utils":774,"../../registry":882,"../../traces/scatter/make_bubble_size_func":1175,"../../traces/scatter/subtypes":1183,"../color":615,"../colorscale":627,"./symbol_defs":638,"d3":169,"fast-isnumeric":241,"tinycolor2":548}],638:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  /** Marker symbol definitions
   * users can specify markers either by number or name
   * add 100 (or '-open') and you get an open marker
   *  open markers have no fill and use line color as the stroke color
   * add 200 (or '-dot') and you get a dot in the middle
   * add both and you get both
   */
  
  module.exports = {
      circle: {
          n: 0,
          f: function(r) {
              var rs = d3.round(r, 2);
              return 'M' + rs + ',0A' + rs + ',' + rs + ' 0 1,1 0,-' + rs +
                  'A' + rs + ',' + rs + ' 0 0,1 ' + rs + ',0Z';
          }
      },
      square: {
          n: 1,
          f: function(r) {
              var rs = d3.round(r, 2);
              return 'M' + rs + ',' + rs + 'H-' + rs + 'V-' + rs + 'H' + rs + 'Z';
          }
      },
      diamond: {
          n: 2,
          f: function(r) {
              var rd = d3.round(r * 1.3, 2);
              return 'M' + rd + ',0L0,' + rd + 'L-' + rd + ',0L0,-' + rd + 'Z';
          }
      },
      cross: {
          n: 3,
          f: function(r) {
              var rc = d3.round(r * 0.4, 2);
              var rc2 = d3.round(r * 1.2, 2);
              return 'M' + rc2 + ',' + rc + 'H' + rc + 'V' + rc2 + 'H-' + rc +
                  'V' + rc + 'H-' + rc2 + 'V-' + rc + 'H-' + rc + 'V-' + rc2 +
                  'H' + rc + 'V-' + rc + 'H' + rc2 + 'Z';
          }
      },
      x: {
          n: 4,
          f: function(r) {
              var rx = d3.round(r * 0.8 / Math.sqrt(2), 2);
              var ne = 'l' + rx + ',' + rx;
              var se = 'l' + rx + ',-' + rx;
              var sw = 'l-' + rx + ',-' + rx;
              var nw = 'l-' + rx + ',' + rx;
              return 'M0,' + rx + ne + se + sw + se + sw + nw + sw + nw + ne + nw + ne + 'Z';
          }
      },
      'triangle-up': {
          n: 5,
          f: function(r) {
              var rt = d3.round(r * 2 / Math.sqrt(3), 2);
              var r2 = d3.round(r / 2, 2);
              var rs = d3.round(r, 2);
              return 'M-' + rt + ',' + r2 + 'H' + rt + 'L0,-' + rs + 'Z';
          }
      },
      'triangle-down': {
          n: 6,
          f: function(r) {
              var rt = d3.round(r * 2 / Math.sqrt(3), 2);
              var r2 = d3.round(r / 2, 2);
              var rs = d3.round(r, 2);
              return 'M-' + rt + ',-' + r2 + 'H' + rt + 'L0,' + rs + 'Z';
          }
      },
      'triangle-left': {
          n: 7,
          f: function(r) {
              var rt = d3.round(r * 2 / Math.sqrt(3), 2);
              var r2 = d3.round(r / 2, 2);
              var rs = d3.round(r, 2);
              return 'M' + r2 + ',-' + rt + 'V' + rt + 'L-' + rs + ',0Z';
          }
      },
      'triangle-right': {
          n: 8,
          f: function(r) {
              var rt = d3.round(r * 2 / Math.sqrt(3), 2);
              var r2 = d3.round(r / 2, 2);
              var rs = d3.round(r, 2);
              return 'M-' + r2 + ',-' + rt + 'V' + rt + 'L' + rs + ',0Z';
          }
      },
      'triangle-ne': {
          n: 9,
          f: function(r) {
              var r1 = d3.round(r * 0.6, 2);
              var r2 = d3.round(r * 1.2, 2);
              return 'M-' + r2 + ',-' + r1 + 'H' + r1 + 'V' + r2 + 'Z';
          }
      },
      'triangle-se': {
          n: 10,
          f: function(r) {
              var r1 = d3.round(r * 0.6, 2);
              var r2 = d3.round(r * 1.2, 2);
              return 'M' + r1 + ',-' + r2 + 'V' + r1 + 'H-' + r2 + 'Z';
          }
      },
      'triangle-sw': {
          n: 11,
          f: function(r) {
              var r1 = d3.round(r * 0.6, 2);
              var r2 = d3.round(r * 1.2, 2);
              return 'M' + r2 + ',' + r1 + 'H-' + r1 + 'V-' + r2 + 'Z';
          }
      },
      'triangle-nw': {
          n: 12,
          f: function(r) {
              var r1 = d3.round(r * 0.6, 2);
              var r2 = d3.round(r * 1.2, 2);
              return 'M-' + r1 + ',' + r2 + 'V-' + r1 + 'H' + r2 + 'Z';
          }
      },
      pentagon: {
          n: 13,
          f: function(r) {
              var x1 = d3.round(r * 0.951, 2);
              var x2 = d3.round(r * 0.588, 2);
              var y0 = d3.round(-r, 2);
              var y1 = d3.round(r * -0.309, 2);
              var y2 = d3.round(r * 0.809, 2);
              return 'M' + x1 + ',' + y1 + 'L' + x2 + ',' + y2 + 'H-' + x2 +
                  'L-' + x1 + ',' + y1 + 'L0,' + y0 + 'Z';
          }
      },
      hexagon: {
          n: 14,
          f: function(r) {
              var y0 = d3.round(r, 2);
              var y1 = d3.round(r / 2, 2);
              var x = d3.round(r * Math.sqrt(3) / 2, 2);
              return 'M' + x + ',-' + y1 + 'V' + y1 + 'L0,' + y0 +
                  'L-' + x + ',' + y1 + 'V-' + y1 + 'L0,-' + y0 + 'Z';
          }
      },
      hexagon2: {
          n: 15,
          f: function(r) {
              var x0 = d3.round(r, 2);
              var x1 = d3.round(r / 2, 2);
              var y = d3.round(r * Math.sqrt(3) / 2, 2);
              return 'M-' + x1 + ',' + y + 'H' + x1 + 'L' + x0 +
                  ',0L' + x1 + ',-' + y + 'H-' + x1 + 'L-' + x0 + ',0Z';
          }
      },
      octagon: {
          n: 16,
          f: function(r) {
              var a = d3.round(r * 0.924, 2);
              var b = d3.round(r * 0.383, 2);
              return 'M-' + b + ',-' + a + 'H' + b + 'L' + a + ',-' + b + 'V' + b +
                  'L' + b + ',' + a + 'H-' + b + 'L-' + a + ',' + b + 'V-' + b + 'Z';
          }
      },
      star: {
          n: 17,
          f: function(r) {
              var rs = r * 1.4;
              var x1 = d3.round(rs * 0.225, 2);
              var x2 = d3.round(rs * 0.951, 2);
              var x3 = d3.round(rs * 0.363, 2);
              var x4 = d3.round(rs * 0.588, 2);
              var y0 = d3.round(-rs, 2);
              var y1 = d3.round(rs * -0.309, 2);
              var y3 = d3.round(rs * 0.118, 2);
              var y4 = d3.round(rs * 0.809, 2);
              var y5 = d3.round(rs * 0.382, 2);
              return 'M' + x1 + ',' + y1 + 'H' + x2 + 'L' + x3 + ',' + y3 +
                  'L' + x4 + ',' + y4 + 'L0,' + y5 + 'L-' + x4 + ',' + y4 +
                  'L-' + x3 + ',' + y3 + 'L-' + x2 + ',' + y1 + 'H-' + x1 +
                  'L0,' + y0 + 'Z';
          }
      },
      hexagram: {
          n: 18,
          f: function(r) {
              var y = d3.round(r * 0.66, 2);
              var x1 = d3.round(r * 0.38, 2);
              var x2 = d3.round(r * 0.76, 2);
              return 'M-' + x2 + ',0l-' + x1 + ',-' + y + 'h' + x2 +
                  'l' + x1 + ',-' + y + 'l' + x1 + ',' + y + 'h' + x2 +
                  'l-' + x1 + ',' + y + 'l' + x1 + ',' + y + 'h-' + x2 +
                  'l-' + x1 + ',' + y + 'l-' + x1 + ',-' + y + 'h-' + x2 + 'Z';
          }
      },
      'star-triangle-up': {
          n: 19,
          f: function(r) {
              var x = d3.round(r * Math.sqrt(3) * 0.8, 2);
              var y1 = d3.round(r * 0.8, 2);
              var y2 = d3.round(r * 1.6, 2);
              var rc = d3.round(r * 4, 2);
              var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
              return 'M-' + x + ',' + y1 + aPart + x + ',' + y1 +
                  aPart + '0,-' + y2 + aPart + '-' + x + ',' + y1 + 'Z';
          }
      },
      'star-triangle-down': {
          n: 20,
          f: function(r) {
              var x = d3.round(r * Math.sqrt(3) * 0.8, 2);
              var y1 = d3.round(r * 0.8, 2);
              var y2 = d3.round(r * 1.6, 2);
              var rc = d3.round(r * 4, 2);
              var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
              return 'M' + x + ',-' + y1 + aPart + '-' + x + ',-' + y1 +
                  aPart + '0,' + y2 + aPart + x + ',-' + y1 + 'Z';
          }
      },
      'star-square': {
          n: 21,
          f: function(r) {
              var rp = d3.round(r * 1.1, 2);
              var rc = d3.round(r * 2, 2);
              var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
              return 'M-' + rp + ',-' + rp + aPart + '-' + rp + ',' + rp +
                  aPart + rp + ',' + rp + aPart + rp + ',-' + rp +
                  aPart + '-' + rp + ',-' + rp + 'Z';
          }
      },
      'star-diamond': {
          n: 22,
          f: function(r) {
              var rp = d3.round(r * 1.4, 2);
              var rc = d3.round(r * 1.9, 2);
              var aPart = 'A ' + rc + ',' + rc + ' 0 0 1 ';
              return 'M-' + rp + ',0' + aPart + '0,' + rp +
                  aPart + rp + ',0' + aPart + '0,-' + rp +
                  aPart + '-' + rp + ',0' + 'Z';
          }
      },
      'diamond-tall': {
          n: 23,
          f: function(r) {
              var x = d3.round(r * 0.7, 2);
              var y = d3.round(r * 1.4, 2);
              return 'M0,' + y + 'L' + x + ',0L0,-' + y + 'L-' + x + ',0Z';
          }
      },
      'diamond-wide': {
          n: 24,
          f: function(r) {
              var x = d3.round(r * 1.4, 2);
              var y = d3.round(r * 0.7, 2);
              return 'M0,' + y + 'L' + x + ',0L0,-' + y + 'L-' + x + ',0Z';
          }
      },
      hourglass: {
          n: 25,
          f: function(r) {
              var rs = d3.round(r, 2);
              return 'M' + rs + ',' + rs + 'H-' + rs + 'L' + rs + ',-' + rs + 'H-' + rs + 'Z';
          },
          noDot: true
      },
      bowtie: {
          n: 26,
          f: function(r) {
              var rs = d3.round(r, 2);
              return 'M' + rs + ',' + rs + 'V-' + rs + 'L-' + rs + ',' + rs + 'V-' + rs + 'Z';
          },
          noDot: true
      },
      'circle-cross': {
          n: 27,
          f: function(r) {
              var rs = d3.round(r, 2);
              return 'M0,' + rs + 'V-' + rs + 'M' + rs + ',0H-' + rs +
                  'M' + rs + ',0A' + rs + ',' + rs + ' 0 1,1 0,-' + rs +
                  'A' + rs + ',' + rs + ' 0 0,1 ' + rs + ',0Z';
          },
          needLine: true,
          noDot: true
      },
      'circle-x': {
          n: 28,
          f: function(r) {
              var rs = d3.round(r, 2);
              var rc = d3.round(r / Math.sqrt(2), 2);
              return 'M' + rc + ',' + rc + 'L-' + rc + ',-' + rc +
                  'M' + rc + ',-' + rc + 'L-' + rc + ',' + rc +
                  'M' + rs + ',0A' + rs + ',' + rs + ' 0 1,1 0,-' + rs +
                  'A' + rs + ',' + rs + ' 0 0,1 ' + rs + ',0Z';
          },
          needLine: true,
          noDot: true
      },
      'square-cross': {
          n: 29,
          f: function(r) {
              var rs = d3.round(r, 2);
              return 'M0,' + rs + 'V-' + rs + 'M' + rs + ',0H-' + rs +
                  'M' + rs + ',' + rs + 'H-' + rs + 'V-' + rs + 'H' + rs + 'Z';
          },
          needLine: true,
          noDot: true
      },
      'square-x': {
          n: 30,
          f: function(r) {
              var rs = d3.round(r, 2);
              return 'M' + rs + ',' + rs + 'L-' + rs + ',-' + rs +
                  'M' + rs + ',-' + rs + 'L-' + rs + ',' + rs +
                  'M' + rs + ',' + rs + 'H-' + rs + 'V-' + rs + 'H' + rs + 'Z';
          },
          needLine: true,
          noDot: true
      },
      'diamond-cross': {
          n: 31,
          f: function(r) {
              var rd = d3.round(r * 1.3, 2);
              return 'M' + rd + ',0L0,' + rd + 'L-' + rd + ',0L0,-' + rd + 'Z' +
                  'M0,-' + rd + 'V' + rd + 'M-' + rd + ',0H' + rd;
          },
          needLine: true,
          noDot: true
      },
      'diamond-x': {
          n: 32,
          f: function(r) {
              var rd = d3.round(r * 1.3, 2);
              var r2 = d3.round(r * 0.65, 2);
              return 'M' + rd + ',0L0,' + rd + 'L-' + rd + ',0L0,-' + rd + 'Z' +
                  'M-' + r2 + ',-' + r2 + 'L' + r2 + ',' + r2 +
                  'M-' + r2 + ',' + r2 + 'L' + r2 + ',-' + r2;
          },
          needLine: true,
          noDot: true
      },
      'cross-thin': {
          n: 33,
          f: function(r) {
              var rc = d3.round(r * 1.4, 2);
              return 'M0,' + rc + 'V-' + rc + 'M' + rc + ',0H-' + rc;
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      'x-thin': {
          n: 34,
          f: function(r) {
              var rx = d3.round(r, 2);
              return 'M' + rx + ',' + rx + 'L-' + rx + ',-' + rx +
                  'M' + rx + ',-' + rx + 'L-' + rx + ',' + rx;
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      asterisk: {
          n: 35,
          f: function(r) {
              var rc = d3.round(r * 1.2, 2);
              var rs = d3.round(r * 0.85, 2);
              return 'M0,' + rc + 'V-' + rc + 'M' + rc + ',0H-' + rc +
                  'M' + rs + ',' + rs + 'L-' + rs + ',-' + rs +
                  'M' + rs + ',-' + rs + 'L-' + rs + ',' + rs;
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      hash: {
          n: 36,
          f: function(r) {
              var r1 = d3.round(r / 2, 2);
              var r2 = d3.round(r, 2);
              return 'M' + r1 + ',' + r2 + 'V-' + r2 +
                  'm-' + r2 + ',0V' + r2 +
                  'M' + r2 + ',' + r1 + 'H-' + r2 +
                  'm0,-' + r2 + 'H' + r2;
          },
          needLine: true,
          noFill: true
      },
      'y-up': {
          n: 37,
          f: function(r) {
              var x = d3.round(r * 1.2, 2);
              var y0 = d3.round(r * 1.6, 2);
              var y1 = d3.round(r * 0.8, 2);
              return 'M-' + x + ',' + y1 + 'L0,0M' + x + ',' + y1 + 'L0,0M0,-' + y0 + 'L0,0';
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      'y-down': {
          n: 38,
          f: function(r) {
              var x = d3.round(r * 1.2, 2);
              var y0 = d3.round(r * 1.6, 2);
              var y1 = d3.round(r * 0.8, 2);
              return 'M-' + x + ',-' + y1 + 'L0,0M' + x + ',-' + y1 + 'L0,0M0,' + y0 + 'L0,0';
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      'y-left': {
          n: 39,
          f: function(r) {
              var y = d3.round(r * 1.2, 2);
              var x0 = d3.round(r * 1.6, 2);
              var x1 = d3.round(r * 0.8, 2);
              return 'M' + x1 + ',' + y + 'L0,0M' + x1 + ',-' + y + 'L0,0M-' + x0 + ',0L0,0';
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      'y-right': {
          n: 40,
          f: function(r) {
              var y = d3.round(r * 1.2, 2);
              var x0 = d3.round(r * 1.6, 2);
              var x1 = d3.round(r * 0.8, 2);
              return 'M-' + x1 + ',' + y + 'L0,0M-' + x1 + ',-' + y + 'L0,0M' + x0 + ',0L0,0';
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      'line-ew': {
          n: 41,
          f: function(r) {
              var rc = d3.round(r * 1.4, 2);
              return 'M' + rc + ',0H-' + rc;
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      'line-ns': {
          n: 42,
          f: function(r) {
              var rc = d3.round(r * 1.4, 2);
              return 'M0,' + rc + 'V-' + rc;
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      'line-ne': {
          n: 43,
          f: function(r) {
              var rx = d3.round(r, 2);
              return 'M' + rx + ',-' + rx + 'L-' + rx + ',' + rx;
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      'line-nw': {
          n: 44,
          f: function(r) {
              var rx = d3.round(r, 2);
              return 'M' + rx + ',' + rx + 'L-' + rx + ',-' + rx;
          },
          needLine: true,
          noDot: true,
          noFill: true
      },
      'arrow-up': {
          n: 45,
          f: function(r) {
              var rx = d3.round(r, 2);
              var ry = d3.round(r * 2, 2);
              return 'M0,0L-' + rx + ',' + ry + 'H' + rx + 'Z';
          },
          noDot: true
      },
      'arrow-down': {
          n: 46,
          f: function(r) {
              var rx = d3.round(r, 2);
              var ry = d3.round(r * 2, 2);
              return 'M0,0L-' + rx + ',-' + ry + 'H' + rx + 'Z';
          },
          noDot: true
      },
      'arrow-left': {
          n: 47,
          f: function(r) {
              var rx = d3.round(r * 2, 2);
              var ry = d3.round(r, 2);
              return 'M0,0L' + rx + ',-' + ry + 'V' + ry + 'Z';
          },
          noDot: true
      },
      'arrow-right': {
          n: 48,
          f: function(r) {
              var rx = d3.round(r * 2, 2);
              var ry = d3.round(r, 2);
              return 'M0,0L-' + rx + ',-' + ry + 'V' + ry + 'Z';
          },
          noDot: true
      },
      'arrow-bar-up': {
          n: 49,
          f: function(r) {
              var rx = d3.round(r, 2);
              var ry = d3.round(r * 2, 2);
              return 'M-' + rx + ',0H' + rx + 'M0,0L-' + rx + ',' + ry + 'H' + rx + 'Z';
          },
          needLine: true,
          noDot: true
      },
      'arrow-bar-down': {
          n: 50,
          f: function(r) {
              var rx = d3.round(r, 2);
              var ry = d3.round(r * 2, 2);
              return 'M-' + rx + ',0H' + rx + 'M0,0L-' + rx + ',-' + ry + 'H' + rx + 'Z';
          },
          needLine: true,
          noDot: true
      },
      'arrow-bar-left': {
          n: 51,
          f: function(r) {
              var rx = d3.round(r * 2, 2);
              var ry = d3.round(r, 2);
              return 'M0,-' + ry + 'V' + ry + 'M0,0L' + rx + ',-' + ry + 'V' + ry + 'Z';
          },
          needLine: true,
          noDot: true
      },
      'arrow-bar-right': {
          n: 52,
          f: function(r) {
              var rx = d3.round(r * 2, 2);
              var ry = d3.round(r, 2);
              return 'M0,-' + ry + 'V' + ry + 'M0,0L-' + rx + ',-' + ry + 'V' + ry + 'Z';
          },
          needLine: true,
          noDot: true
      }
  };
  
  },{"d3":169}],639:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  module.exports = {
      visible: {
          valType: 'boolean',
          
          editType: 'calc',
          
      },
      type: {
          valType: 'enumerated',
          values: ['percent', 'constant', 'sqrt', 'data'],
          
          editType: 'calc',
          
      },
      symmetric: {
          valType: 'boolean',
          
          editType: 'calc',
          
      },
      array: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      arrayminus: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      value: {
          valType: 'number',
          min: 0,
          dflt: 10,
          
          editType: 'calc',
          
      },
      valueminus: {
          valType: 'number',
          min: 0,
          dflt: 10,
          
          editType: 'calc',
          
      },
      traceref: {
          valType: 'integer',
          min: 0,
          dflt: 0,
          
          editType: 'style'
      },
      tracerefminus: {
          valType: 'integer',
          min: 0,
          dflt: 0,
          
          editType: 'style'
      },
      copy_ystyle: {
          valType: 'boolean',
          
          editType: 'plot'
      },
      copy_zstyle: {
          valType: 'boolean',
          
          editType: 'style'
      },
      color: {
          valType: 'color',
          
          editType: 'style',
          
      },
      thickness: {
          valType: 'number',
          min: 0,
          dflt: 2,
          
          editType: 'style',
          
      },
      width: {
          valType: 'number',
          min: 0,
          
          editType: 'plot',
          
      },
      editType: 'calc',
  
      _deprecated: {
          opacity: {
              valType: 'number',
              
              editType: 'style',
              
          }
      }
  };
  
  },{}],640:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Registry = _dereq_('../../registry');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Lib = _dereq_('../../lib');
  
  var makeComputeError = _dereq_('./compute_error');
  
  module.exports = function calc(gd) {
      var calcdata = gd.calcdata;
  
      for(var i = 0; i < calcdata.length; i++) {
          var calcTrace = calcdata[i];
          var trace = calcTrace[0].trace;
  
          if(trace.visible === true && Registry.traceIs(trace, 'errorBarsOK')) {
              var xa = Axes.getFromId(gd, trace.xaxis);
              var ya = Axes.getFromId(gd, trace.yaxis);
              calcOneAxis(calcTrace, trace, xa, 'x');
              calcOneAxis(calcTrace, trace, ya, 'y');
          }
      }
  };
  
  function calcOneAxis(calcTrace, trace, axis, coord) {
      var opts = trace['error_' + coord] || {};
      var isVisible = (opts.visible && ['linear', 'log'].indexOf(axis.type) !== -1);
      var vals = [];
  
      if(!isVisible) return;
  
      var computeError = makeComputeError(opts);
  
      for(var i = 0; i < calcTrace.length; i++) {
          var calcPt = calcTrace[i];
  
          var iIn = calcPt.i;
  
          // for types that don't include `i` in each calcdata point
          if(iIn === undefined) iIn = i;
  
          // for stacked area inserted points
          // TODO: errorbars have been tested cursorily with stacked area,
          // but not thoroughly. It's not even really clear what you want to do:
          // Should it just be calculated based on that trace's size data?
          // Should you add errors from below in quadrature?
          // And what about normalization, where in principle the errors shrink
          // again when you get up to the top end?
          // One option would be to forbid errorbars with stacking until we
          // decide how to handle these questions.
          else if(iIn === null) continue;
  
          var calcCoord = calcPt[coord];
  
          if(!isNumeric(axis.c2l(calcCoord))) continue;
  
          var errors = computeError(calcCoord, iIn);
          if(isNumeric(errors[0]) && isNumeric(errors[1])) {
              var shoe = calcPt[coord + 's'] = calcCoord - errors[0];
              var hat = calcPt[coord + 'h'] = calcCoord + errors[1];
              vals.push(shoe, hat);
          }
      }
  
      var axId = axis._id;
      var baseExtremes = trace._extremes[axId];
      var extremes = Axes.findExtremes(
          axis,
          vals,
          Lib.extendFlat({tozero: baseExtremes.opts.tozero}, {padded: true})
      );
      baseExtremes.min = baseExtremes.min.concat(extremes.min);
      baseExtremes.max = baseExtremes.max.concat(extremes.max);
  }
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"../../registry":882,"./compute_error":641,"fast-isnumeric":241}],641:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  /**
   * Error bar computing function generator
   *
   * N.B. The generated function does not clean the dataPt entries. Non-numeric
   * entries result in undefined error magnitudes.
   *
   * @param {object} opts error bar attributes
   *
   * @return {function} :
   *      @param {numeric} dataPt data point from where to compute the error magnitude
   *      @param {number} index index of dataPt in its corresponding data array
   *      @return {array}
   *        - error[0] : error magnitude in the negative direction
   *        - error[1] : " " " " positive "
   */
  module.exports = function makeComputeError(opts) {
      var type = opts.type;
      var symmetric = opts.symmetric;
  
      if(type === 'data') {
          var array = opts.array || [];
  
          if(symmetric) {
              return function computeError(dataPt, index) {
                  var val = +(array[index]);
                  return [val, val];
              };
          } else {
              var arrayminus = opts.arrayminus || [];
              return function computeError(dataPt, index) {
                  var val = +array[index];
                  var valMinus = +arrayminus[index];
                  // in case one is present and the other is missing, fill in 0
                  // so we still see the present one. Mostly useful during manual
                  // data entry.
                  if(!isNaN(val) || !isNaN(valMinus)) {
                      return [valMinus || 0, val || 0];
                  }
                  return [NaN, NaN];
              };
          }
      } else {
          var computeErrorValue = makeComputeErrorValue(type, opts.value);
          var computeErrorValueMinus = makeComputeErrorValue(type, opts.valueminus);
  
          if(symmetric || opts.valueminus === undefined) {
              return function computeError(dataPt) {
                  var val = computeErrorValue(dataPt);
                  return [val, val];
              };
          } else {
              return function computeError(dataPt) {
                  return [
                      computeErrorValueMinus(dataPt),
                      computeErrorValue(dataPt)
                  ];
              };
          }
      }
  };
  
  /**
   * Compute error bar magnitude (for all types except data)
   *
   * @param {string} type error bar type
   * @param {numeric} value error bar value
   *
   * @return {function} :
   *      @param {numeric} dataPt
   */
  function makeComputeErrorValue(type, value) {
      if(type === 'percent') {
          return function(dataPt) {
              return Math.abs(dataPt * value / 100);
          };
      }
      if(type === 'constant') {
          return function() {
              return Math.abs(value);
          };
      }
      if(type === 'sqrt') {
          return function(dataPt) {
              return Math.sqrt(Math.abs(dataPt));
          };
      }
  }
  
  },{}],642:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Template = _dereq_('../../plot_api/plot_template');
  
  var attributes = _dereq_('./attributes');
  
  
  module.exports = function(traceIn, traceOut, defaultColor, opts) {
      var objName = 'error_' + opts.axis;
      var containerOut = Template.newContainer(traceOut, objName);
      var containerIn = traceIn[objName] || {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
      }
  
      var hasErrorBars = (
          containerIn.array !== undefined ||
          containerIn.value !== undefined ||
          containerIn.type === 'sqrt'
      );
  
      var visible = coerce('visible', hasErrorBars);
  
      if(visible === false) return;
  
      var type = coerce('type', 'array' in containerIn ? 'data' : 'percent');
      var symmetric = true;
  
      if(type !== 'sqrt') {
          symmetric = coerce('symmetric',
              !((type === 'data' ? 'arrayminus' : 'valueminus') in containerIn));
      }
  
      if(type === 'data') {
          coerce('array');
          coerce('traceref');
          if(!symmetric) {
              coerce('arrayminus');
              coerce('tracerefminus');
          }
      } else if(type === 'percent' || type === 'constant') {
          coerce('value');
          if(!symmetric) coerce('valueminus');
      }
  
      var copyAttr = 'copy_' + opts.inherit + 'style';
      if(opts.inherit) {
          var inheritObj = traceOut['error_' + opts.inherit];
          if((inheritObj || {}).visible) {
              coerce(copyAttr, !(containerIn.color ||
                                 isNumeric(containerIn.thickness) ||
                                 isNumeric(containerIn.width)));
          }
      }
      if(!opts.inherit || !containerOut[copyAttr]) {
          coerce('color', defaultColor);
          coerce('thickness');
          coerce('width', Registry.traceIs(traceOut, 'gl3d') ? 0 : 4);
      }
  };
  
  },{"../../lib":750,"../../plot_api/plot_template":788,"../../registry":882,"./attributes":639,"fast-isnumeric":241}],643:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var attributes = _dereq_('./attributes');
  
  var xyAttrs = {
      error_x: Lib.extendFlat({}, attributes),
      error_y: Lib.extendFlat({}, attributes)
  };
  delete xyAttrs.error_x.copy_zstyle;
  delete xyAttrs.error_y.copy_zstyle;
  delete xyAttrs.error_y.copy_ystyle;
  
  var xyzAttrs = {
      error_x: Lib.extendFlat({}, attributes),
      error_y: Lib.extendFlat({}, attributes),
      error_z: Lib.extendFlat({}, attributes)
  };
  delete xyzAttrs.error_x.copy_ystyle;
  delete xyzAttrs.error_y.copy_ystyle;
  delete xyzAttrs.error_z.copy_ystyle;
  delete xyzAttrs.error_z.copy_zstyle;
  
  module.exports = {
      moduleType: 'component',
      name: 'errorbars',
  
      schema: {
          traces: {
              scatter: xyAttrs,
              bar: xyAttrs,
              histogram: xyAttrs,
              scatter3d: overrideAll(xyzAttrs, 'calc', 'nested'),
              scattergl: overrideAll(xyAttrs, 'calc', 'nested')
          }
      },
  
      supplyDefaults: _dereq_('./defaults'),
  
      calc: _dereq_('./calc'),
      makeComputeError: _dereq_('./compute_error'),
  
      plot: _dereq_('./plot'),
      style: _dereq_('./style'),
      hoverInfo: hoverInfo
  };
  
  function hoverInfo(calcPoint, trace, hoverPoint) {
      if((trace.error_y || {}).visible) {
          hoverPoint.yerr = calcPoint.yh - calcPoint.y;
          if(!trace.error_y.symmetric) hoverPoint.yerrneg = calcPoint.y - calcPoint.ys;
      }
      if((trace.error_x || {}).visible) {
          hoverPoint.xerr = calcPoint.xh - calcPoint.x;
          if(!trace.error_x.symmetric) hoverPoint.xerrneg = calcPoint.x - calcPoint.xs;
      }
  }
  
  },{"../../lib":750,"../../plot_api/edit_types":781,"./attributes":639,"./calc":640,"./compute_error":641,"./defaults":642,"./plot":644,"./style":645}],644:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Drawing = _dereq_('../drawing');
  var subTypes = _dereq_('../../traces/scatter/subtypes');
  
  module.exports = function plot(gd, traces, plotinfo, transitionOpts) {
      var isNew;
  
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      var hasAnimation = transitionOpts && transitionOpts.duration > 0;
  
      traces.each(function(d) {
          var trace = d[0].trace;
          // || {} is in case the trace (specifically scatterternary)
          // doesn't support error bars at all, but does go through
          // the scatter.plot mechanics, which calls ErrorBars.plot
          // internally
          var xObj = trace.error_x || {};
          var yObj = trace.error_y || {};
  
          var keyFunc;
  
          if(trace.ids) {
              keyFunc = function(d) {return d.id;};
          }
  
          var sparse = (
              subTypes.hasMarkers(trace) &&
              trace.marker.maxdisplayed > 0
          );
  
          if(!yObj.visible && !xObj.visible) d = [];
  
          var errorbars = d3.select(this).selectAll('g.errorbar')
              .data(d, keyFunc);
  
          errorbars.exit().remove();
  
          if(!d.length) return;
  
          if(!xObj.visible) errorbars.selectAll('path.xerror').remove();
          if(!yObj.visible) errorbars.selectAll('path.yerror').remove();
  
          errorbars.style('opacity', 1);
  
          var enter = errorbars.enter().append('g')
              .classed('errorbar', true);
  
          if(hasAnimation) {
              enter.style('opacity', 0).transition()
                  .duration(transitionOpts.duration)
                  .style('opacity', 1);
          }
  
          Drawing.setClipUrl(errorbars, plotinfo.layerClipId, gd);
  
          errorbars.each(function(d) {
              var errorbar = d3.select(this);
              var coords = errorCoords(d, xa, ya);
  
              if(sparse && !d.vis) return;
  
              var path;
  
              var yerror = errorbar.select('path.yerror');
              if(yObj.visible && isNumeric(coords.x) &&
                      isNumeric(coords.yh) &&
                      isNumeric(coords.ys)) {
                  var yw = yObj.width;
  
                  path = 'M' + (coords.x - yw) + ',' +
                      coords.yh + 'h' + (2 * yw) + // hat
                      'm-' + yw + ',0V' + coords.ys; // bar
  
  
                  if(!coords.noYS) path += 'm-' + yw + ',0h' + (2 * yw); // shoe
  
                  isNew = !yerror.size();
  
                  if(isNew) {
                      yerror = errorbar.append('path')
                          .style('vector-effect', 'non-scaling-stroke')
                          .classed('yerror', true);
                  } else if(hasAnimation) {
                      yerror = yerror
                          .transition()
                              .duration(transitionOpts.duration)
                              .ease(transitionOpts.easing);
                  }
  
                  yerror.attr('d', path);
              } else yerror.remove();
  
              var xerror = errorbar.select('path.xerror');
              if(xObj.visible && isNumeric(coords.y) &&
                      isNumeric(coords.xh) &&
                      isNumeric(coords.xs)) {
                  var xw = (xObj.copy_ystyle ? yObj : xObj).width;
  
                  path = 'M' + coords.xh + ',' +
                      (coords.y - xw) + 'v' + (2 * xw) + // hat
                      'm0,-' + xw + 'H' + coords.xs; // bar
  
                  if(!coords.noXS) path += 'm0,-' + xw + 'v' + (2 * xw); // shoe
  
                  isNew = !xerror.size();
  
                  if(isNew) {
                      xerror = errorbar.append('path')
                          .style('vector-effect', 'non-scaling-stroke')
                          .classed('xerror', true);
                  } else if(hasAnimation) {
                      xerror = xerror
                          .transition()
                              .duration(transitionOpts.duration)
                              .ease(transitionOpts.easing);
                  }
  
                  xerror.attr('d', path);
              } else xerror.remove();
          });
      });
  };
  
  // compute the coordinates of the error-bar objects
  function errorCoords(d, xa, ya) {
      var out = {
          x: xa.c2p(d.x),
          y: ya.c2p(d.y)
      };
  
      // calculate the error bar size and hat and shoe locations
      if(d.yh !== undefined) {
          out.yh = ya.c2p(d.yh);
          out.ys = ya.c2p(d.ys);
  
          // if the shoes go off-scale (ie log scale, error bars past zero)
          // clip the bar and hide the shoes
          if(!isNumeric(out.ys)) {
              out.noYS = true;
              out.ys = ya.c2p(d.ys, true);
          }
      }
  
      if(d.xh !== undefined) {
          out.xh = xa.c2p(d.xh);
          out.xs = xa.c2p(d.xs);
  
          if(!isNumeric(out.xs)) {
              out.noXS = true;
              out.xs = xa.c2p(d.xs, true);
          }
      }
  
      return out;
  }
  
  },{"../../traces/scatter/subtypes":1183,"../drawing":637,"d3":169,"fast-isnumeric":241}],645:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Color = _dereq_('../color');
  
  
  module.exports = function style(traces) {
      traces.each(function(d) {
          var trace = d[0].trace;
          var yObj = trace.error_y || {};
          var xObj = trace.error_x || {};
  
          var s = d3.select(this);
  
          s.selectAll('path.yerror')
              .style('stroke-width', yObj.thickness + 'px')
              .call(Color.stroke, yObj.color);
  
          if(xObj.copy_ystyle) xObj = yObj;
  
          s.selectAll('path.xerror')
              .style('stroke-width', xObj.thickness + 'px')
              .call(Color.stroke, xObj.color);
      });
  };
  
  },{"../color":615,"d3":169}],646:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var hoverLabelAttrs = _dereq_('./layout_attributes').hoverlabel;
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = {
      hoverlabel: {
          bgcolor: extendFlat({}, hoverLabelAttrs.bgcolor, {
              arrayOk: true,
              
          }),
          bordercolor: extendFlat({}, hoverLabelAttrs.bordercolor, {
              arrayOk: true,
              
          }),
          font: fontAttrs({
              arrayOk: true,
              editType: 'none',
              
          }),
          align: extendFlat({}, hoverLabelAttrs.align, {arrayOk: true}),
          namelength: extendFlat({}, hoverLabelAttrs.namelength, {arrayOk: true}),
          editType: 'none'
      }
  };
  
  },{"../../lib/extend":740,"../../plots/font_attributes":827,"./layout_attributes":656}],647:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  
  module.exports = function calc(gd) {
      var calcdata = gd.calcdata;
      var fullLayout = gd._fullLayout;
  
      function makeCoerceHoverInfo(trace) {
          return function(val) {
              return Lib.coerceHoverinfo({hoverinfo: val}, {_module: trace._module}, fullLayout);
          };
      }
  
      for(var i = 0; i < calcdata.length; i++) {
          var cd = calcdata[i];
          var trace = cd[0].trace;
  
          // don't include hover calc fields for pie traces
          // as calcdata items might be sorted by value and
          // won't match the data array order.
          if(Registry.traceIs(trace, 'pie-like')) continue;
  
          var fillFn = Registry.traceIs(trace, '2dMap') ? paste : Lib.fillArray;
  
          fillFn(trace.hoverinfo, cd, 'hi', makeCoerceHoverInfo(trace));
  
          if(trace.hovertemplate) fillFn(trace.hovertemplate, cd, 'ht');
  
          if(!trace.hoverlabel) continue;
  
          fillFn(trace.hoverlabel.bgcolor, cd, 'hbg');
          fillFn(trace.hoverlabel.bordercolor, cd, 'hbc');
          fillFn(trace.hoverlabel.font.size, cd, 'hts');
          fillFn(trace.hoverlabel.font.color, cd, 'htc');
          fillFn(trace.hoverlabel.font.family, cd, 'htf');
          fillFn(trace.hoverlabel.namelength, cd, 'hnl');
          fillFn(trace.hoverlabel.align, cd, 'hta');
      }
  };
  
  function paste(traceAttr, cd, cdAttr, fn) {
      fn = fn || Lib.identity;
  
      if(Array.isArray(traceAttr)) {
          cd[0][cdAttr] = fn(traceAttr);
      }
  }
  
  },{"../../lib":750,"../../registry":882}],648:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var hover = _dereq_('./hover').hover;
  
  module.exports = function click(gd, evt, subplot) {
      var annotationsDone = Registry.getComponentMethod('annotations', 'onClick')(gd, gd._hoverdata);
  
      // fallback to fail-safe in case the plot type's hover method doesn't pass the subplot.
      // Ternary, for example, didn't, but it was caught because tested.
      if(subplot !== undefined) {
          // The true flag at the end causes it to re-run the hover computation to figure out *which*
          // point is being clicked. Without this, clicking is somewhat unreliable.
          hover(gd, evt, subplot, true);
      }
  
      function emitClick() { gd.emit('plotly_click', {points: gd._hoverdata, event: evt}); }
  
      if(gd._hoverdata && evt && evt.target) {
          if(annotationsDone && annotationsDone.then) {
              annotationsDone.then(emitClick);
          } else emitClick();
  
          // why do we get a double event without this???
          if(evt.stopImmediatePropagation) evt.stopImmediatePropagation();
      }
  };
  
  },{"../../registry":882,"./hover":652}],649:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      // hover labels for multiple horizontal bars get tilted by this angle
      YANGLE: 60,
  
      // size and display constants for hover text
  
      // pixel size of hover arrows
      HOVERARROWSIZE: 6,
      // pixels padding around text
      HOVERTEXTPAD: 3,
      // hover font
      HOVERFONTSIZE: 13,
      HOVERFONT: 'Arial, sans-serif',
  
      // minimum time (msec) between hover calls
      HOVERMINTIME: 50,
  
      // ID suffix (with fullLayout._uid) for hover events in the throttle cache
      HOVERID: '-hover'
  };
  
  },{}],650:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var handleHoverLabelDefaults = _dereq_('./hoverlabel_defaults');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var opts = Lib.extendFlat({}, layout.hoverlabel);
      if(traceOut.hovertemplate) opts.namelength = -1;
  
      handleHoverLabelDefaults(traceIn, traceOut, coerce, opts);
  };
  
  },{"../../lib":750,"./attributes":646,"./hoverlabel_defaults":653}],651:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  // look for either subplot or xaxis and yaxis attributes
  // does not handle splom case
  exports.getSubplot = function(trace) {
      return trace.subplot || (trace.xaxis + trace.yaxis) || trace.geo;
  };
  
  // is trace in given list of subplots?
  // does handle splom case
  exports.isTraceInSubplots = function(trace, subplots) {
      if(trace.type === 'splom') {
          var xaxes = trace.xaxes || [];
          var yaxes = trace.yaxes || [];
          for(var i = 0; i < xaxes.length; i++) {
              for(var j = 0; j < yaxes.length; j++) {
                  if(subplots.indexOf(xaxes[i] + yaxes[j]) !== -1) {
                      return true;
                  }
              }
          }
          return false;
      }
  
      return subplots.indexOf(exports.getSubplot(trace)) !== -1;
  };
  
  // convenience functions for mapping all relevant axes
  exports.flat = function(subplots, v) {
      var out = new Array(subplots.length);
      for(var i = 0; i < subplots.length; i++) {
          out[i] = v;
      }
      return out;
  };
  
  exports.p2c = function(axArray, v) {
      var out = new Array(axArray.length);
      for(var i = 0; i < axArray.length; i++) {
          out[i] = axArray[i].p2c(v);
      }
      return out;
  };
  
  exports.getDistanceFunction = function(mode, dx, dy, dxy) {
      if(mode === 'closest') return dxy || exports.quadrature(dx, dy);
      return mode.charAt(0) === 'x' ? dx : dy;
  };
  
  exports.getClosest = function(cd, distfn, pointData) {
      // do we already have a point number? (array mode only)
      if(pointData.index !== false) {
          if(pointData.index >= 0 && pointData.index < cd.length) {
              pointData.distance = 0;
          } else pointData.index = false;
      } else {
          // apply the distance function to each data point
          // this is the longest loop... if this bogs down, we may need
          // to create pre-sorted data (by x or y), not sure how to
          // do this for 'closest'
          for(var i = 0; i < cd.length; i++) {
              var newDistance = distfn(cd[i]);
              if(newDistance <= pointData.distance) {
                  pointData.index = i;
                  pointData.distance = newDistance;
              }
          }
      }
      return pointData;
  };
  
  /*
   * pseudo-distance function for hover effects on areas: inside the region
   * distance is finite (`passVal`), outside it's Infinity.
   *
   * @param {number} v0: signed difference between the current position and the left edge
   * @param {number} v1: signed difference between the current position and the right edge
   * @param {number} passVal: the value to return on success
   */
  exports.inbox = function(v0, v1, passVal) {
      return (v0 * v1 < 0 || v0 === 0) ? passVal : Infinity;
  };
  
  exports.quadrature = function(dx, dy) {
      return function(di) {
          var x = dx(di);
          var y = dy(di);
          return Math.sqrt(x * x + y * y);
      };
  };
  
  /** Fill event data point object for hover and selection.
   *  Invokes _module.eventData if present.
   *
   * N.B. note that point 'index' corresponds to input data array index
   *  whereas 'number' is its post-transform version.
   *
   * If the hovered/selected pt corresponds to an multiple input points
   * (e.g. for histogram and transformed traces), 'pointNumbers` and 'pointIndices'
   * are include in the event data.
   *
   * @param {object} pt
   * @param {object} trace
   * @param {object} cd
   * @return {object}
   */
  exports.makeEventData = function(pt, trace, cd) {
      // hover uses 'index', select uses 'pointNumber'
      var pointNumber = 'index' in pt ? pt.index : pt.pointNumber;
  
      var out = {
          data: trace._input,
          fullData: trace,
          curveNumber: trace.index,
          pointNumber: pointNumber
      };
  
      if(trace._indexToPoints) {
          var pointIndices = trace._indexToPoints[pointNumber];
  
          if(pointIndices.length === 1) {
              out.pointIndex = pointIndices[0];
          } else {
              out.pointIndices = pointIndices;
          }
      } else {
          out.pointIndex = pointNumber;
      }
  
      if(trace._module.eventData) {
          out = trace._module.eventData(out, pt, trace, cd, pointNumber);
      } else {
          if('xVal' in pt) out.x = pt.xVal;
          else if('x' in pt) out.x = pt.x;
  
          if('yVal' in pt) out.y = pt.yVal;
          else if('y' in pt) out.y = pt.y;
  
          if(pt.xa) out.xaxis = pt.xa;
          if(pt.ya) out.yaxis = pt.ya;
          if(pt.zLabelVal !== undefined) out.z = pt.zLabelVal;
      }
  
      exports.appendArrayPointValue(out, trace, pointNumber);
  
      return out;
  };
  
  /** Appends values inside array attributes corresponding to given point number
   *
   * @param {object} pointData : point data object (gets mutated here)
   * @param {object} trace : full trace object
   * @param {number|Array(number)} pointNumber : point number. May be a length-2 array
   *     [row, col] to dig into 2D arrays
   */
  exports.appendArrayPointValue = function(pointData, trace, pointNumber) {
      var arrayAttrs = trace._arrayAttrs;
  
      if(!arrayAttrs) {
          return;
      }
  
      for(var i = 0; i < arrayAttrs.length; i++) {
          var astr = arrayAttrs[i];
          var key = getPointKey(astr);
  
          if(pointData[key] === undefined) {
              var val = Lib.nestedProperty(trace, astr).get();
              var pointVal = getPointData(val, pointNumber);
  
              if(pointVal !== undefined) pointData[key] = pointVal;
          }
      }
  };
  
  /**
   * Appends values inside array attributes corresponding to given point number array
   * For use when pointData references a plot entity that arose (or potentially arose)
   * from multiple points in the input data
   *
   * @param {object} pointData : point data object (gets mutated here)
   * @param {object} trace : full trace object
   * @param {Array(number)|Array(Array(number))} pointNumbers : Array of point numbers.
   *     Each entry in the array may itself be a length-2 array [row, col] to dig into 2D arrays
   */
  exports.appendArrayMultiPointValues = function(pointData, trace, pointNumbers) {
      var arrayAttrs = trace._arrayAttrs;
  
      if(!arrayAttrs) {
          return;
      }
  
      for(var i = 0; i < arrayAttrs.length; i++) {
          var astr = arrayAttrs[i];
          var key = getPointKey(astr);
  
          if(pointData[key] === undefined) {
              var val = Lib.nestedProperty(trace, astr).get();
              var keyVal = new Array(pointNumbers.length);
  
              for(var j = 0; j < pointNumbers.length; j++) {
                  keyVal[j] = getPointData(val, pointNumbers[j]);
              }
              pointData[key] = keyVal;
          }
      }
  };
  
  var pointKeyMap = {
      ids: 'id',
      locations: 'location',
      labels: 'label',
      values: 'value',
      'marker.colors': 'color',
      parents: 'parent'
  };
  
  function getPointKey(astr) {
      return pointKeyMap[astr] || astr;
  }
  
  function getPointData(val, pointNumber) {
      if(Array.isArray(pointNumber)) {
          if(Array.isArray(val) && Array.isArray(val[pointNumber[0]])) {
              return val[pointNumber[0]][pointNumber[1]];
          }
      } else {
          return val[pointNumber];
      }
  }
  
  var xyHoverMode = {
      x: true,
      y: true
  };
  
  var unifiedHoverMode = {
      'x unified': true,
      'y unified': true
  };
  
  exports.isUnifiedHover = function(hovermode) {
      if(typeof hovermode !== 'string') return false;
      return !!unifiedHoverMode[hovermode];
  };
  
  exports.isXYhover = function(hovermode) {
      if(typeof hovermode !== 'string') return false;
      return !!xyHoverMode[hovermode];
  };
  
  },{"../../lib":750}],652:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  var tinycolor = _dereq_('tinycolor2');
  
  var Lib = _dereq_('../../lib');
  var Events = _dereq_('../../lib/events');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var overrideCursor = _dereq_('../../lib/override_cursor');
  var Drawing = _dereq_('../drawing');
  var Color = _dereq_('../color');
  var dragElement = _dereq_('../dragelement');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Registry = _dereq_('../../registry');
  
  var helpers = _dereq_('./helpers');
  var constants = _dereq_('./constants');
  
  var legendSupplyDefaults = _dereq_('../legend/defaults');
  var legendDraw = _dereq_('../legend/draw');
  
  // hover labels for multiple horizontal bars get tilted by some angle,
  // then need to be offset differently if they overlap
  var YANGLE = constants.YANGLE;
  var YA_RADIANS = Math.PI * YANGLE / 180;
  
  // expansion of projected height
  var YFACTOR = 1 / Math.sin(YA_RADIANS);
  
  // to make the appropriate post-rotation x offset,
  // you need both x and y offsets
  var YSHIFTX = Math.cos(YA_RADIANS);
  var YSHIFTY = Math.sin(YA_RADIANS);
  
  // size and display constants for hover text
  var HOVERARROWSIZE = constants.HOVERARROWSIZE;
  var HOVERTEXTPAD = constants.HOVERTEXTPAD;
  
  // fx.hover: highlight data on hover
  // evt can be a mousemove event, or an object with data about what points
  //   to hover on
  //      {xpx,ypx[,hovermode]} - pixel locations from top left
  //          (with optional overriding hovermode)
  //      {xval,yval[,hovermode]} - data values
  //      [{curveNumber,(pointNumber|xval and/or yval)}] -
  //              array of specific points to highlight
  //          pointNumber is a single integer if gd.data[curveNumber] is 1D,
  //              or a two-element array if it's 2D
  //          xval and yval are data values,
  //              1D data may specify either or both,
  //              2D data must specify both
  // subplot is an id string (default "xy")
  // makes use of gl.hovermode, which can be:
  //      x (find the points with the closest x values, ie a column),
  //      closest (find the single closest point)
  //    internally there are two more that occasionally get used:
  //      y (pick out a row - only used for multiple horizontal bar charts)
  //      array (used when the user specifies an explicit
  //          array of points to hover on)
  //
  // We wrap the hovers in a timer, to limit their frequency.
  // The actual rendering is done by private function _hover.
  exports.hover = function hover(gd, evt, subplot, noHoverEvent) {
      gd = Lib.getGraphDiv(gd);
  
      Lib.throttle(
          gd._fullLayout._uid + constants.HOVERID,
          constants.HOVERMINTIME,
          function() { _hover(gd, evt, subplot, noHoverEvent); }
      );
  };
  
  /*
   * Draw a single hover item or an array of hover item in a pre-existing svg container somewhere
   * hoverItem should have keys:
   *    - x and y (or x0, x1, y0, and y1):
   *      the pixel position to mark, relative to opts.container
   *    - xLabel, yLabel, zLabel, text, and name:
   *      info to go in the label
   *    - color:
   *      the background color for the label.
   *    - idealAlign (optional):
   *      'left' or 'right' for which side of the x/y box to try to put this on first
   *    - borderColor (optional):
   *      color for the border, defaults to strongest contrast with color
   *    - fontFamily (optional):
   *      string, the font for this label, defaults to constants.HOVERFONT
   *    - fontSize (optional):
   *      the label font size, defaults to constants.HOVERFONTSIZE
   *    - fontColor (optional):
   *      defaults to borderColor
   * opts should have keys:
   *    - bgColor:
   *      the background color this is against, used if the trace is
   *      non-opaque, and for the name, which goes outside the box
   *    - container:
   *      a <svg> or <g> element to add the hover label to
   *    - outerContainer:
   *      normally a parent of `container`, sets the bounding box to use to
   *      constrain the hover label and determine whether to show it on the left or right
   * opts can have optional keys:
   *    - anchorIndex:
          the index of the hover item used as an anchor for positioning.
          The other hover items will be pushed up or down to prevent overlap.
   */
  exports.loneHover = function loneHover(hoverItems, opts) {
      var multiHover = true;
      if(!Array.isArray(hoverItems)) {
          multiHover = false;
          hoverItems = [hoverItems];
      }
  
      var pointsData = hoverItems.map(function(hoverItem) {
          return {
              color: hoverItem.color || Color.defaultLine,
              x0: hoverItem.x0 || hoverItem.x || 0,
              x1: hoverItem.x1 || hoverItem.x || 0,
              y0: hoverItem.y0 || hoverItem.y || 0,
              y1: hoverItem.y1 || hoverItem.y || 0,
              xLabel: hoverItem.xLabel,
              yLabel: hoverItem.yLabel,
              zLabel: hoverItem.zLabel,
              text: hoverItem.text,
              name: hoverItem.name,
              idealAlign: hoverItem.idealAlign,
  
              // optional extra bits of styling
              borderColor: hoverItem.borderColor,
              fontFamily: hoverItem.fontFamily,
              fontSize: hoverItem.fontSize,
              fontColor: hoverItem.fontColor,
              nameLength: hoverItem.nameLength,
              textAlign: hoverItem.textAlign,
  
              // filler to make createHoverText happy
              trace: hoverItem.trace || {
                  index: 0,
                  hoverinfo: ''
              },
              xa: {_offset: 0},
              ya: {_offset: 0},
              index: 0,
  
              hovertemplate: hoverItem.hovertemplate || false,
              eventData: hoverItem.eventData || false,
              hovertemplateLabels: hoverItem.hovertemplateLabels || false,
          };
      });
  
      var container3 = d3.select(opts.container);
      var outerContainer3 = opts.outerContainer ? d3.select(opts.outerContainer) : container3;
  
      var fullOpts = {
          hovermode: 'closest',
          rotateLabels: false,
          bgColor: opts.bgColor || Color.background,
          container: container3,
          outerContainer: outerContainer3
      };
  
      var hoverLabel = createHoverText(pointsData, fullOpts, opts.gd);
  
      // Fix vertical overlap
      var tooltipSpacing = 5;
      var lastBottomY = 0;
      var anchor = 0;
      hoverLabel
          .sort(function(a, b) {return a.y0 - b.y0;})
          .each(function(d, i) {
              var topY = d.y0 - d.by / 2;
  
              if((topY - tooltipSpacing) < lastBottomY) {
                  d.offset = (lastBottomY - topY) + tooltipSpacing;
              } else {
                  d.offset = 0;
              }
  
              lastBottomY = topY + d.by + d.offset;
  
              if(i === opts.anchorIndex || 0) anchor = d.offset;
          })
          .each(function(d) {
              d.offset -= anchor;
          });
  
      alignHoverText(hoverLabel, fullOpts.rotateLabels);
  
      return multiHover ? hoverLabel : hoverLabel.node();
  };
  
  // The actual implementation is here:
  function _hover(gd, evt, subplot, noHoverEvent) {
      if(!subplot) subplot = 'xy';
  
      // if the user passed in an array of subplots,
      // use those instead of finding overlayed plots
      var subplots = Array.isArray(subplot) ? subplot : [subplot];
  
      var fullLayout = gd._fullLayout;
      var plots = fullLayout._plots || [];
      var plotinfo = plots[subplot];
      var hasCartesian = fullLayout._has('cartesian');
  
      // list of all overlaid subplots to look at
      if(plotinfo) {
          var overlayedSubplots = plotinfo.overlays.map(function(pi) {
              return pi.id;
          });
  
          subplots = subplots.concat(overlayedSubplots);
      }
  
      var len = subplots.length;
      var xaArray = new Array(len);
      var yaArray = new Array(len);
      var supportsCompare = false;
  
      for(var i = 0; i < len; i++) {
          var spId = subplots[i];
  
          if(plots[spId]) {
              // 'cartesian' case
              supportsCompare = true;
              xaArray[i] = plots[spId].xaxis;
              yaArray[i] = plots[spId].yaxis;
          } else if(fullLayout[spId] && fullLayout[spId]._subplot) {
              // other subplot types
              var _subplot = fullLayout[spId]._subplot;
              xaArray[i] = _subplot.xaxis;
              yaArray[i] = _subplot.yaxis;
          } else {
              Lib.warn('Unrecognized subplot: ' + spId);
              return;
          }
      }
  
      var hovermode = evt.hovermode || fullLayout.hovermode;
  
      if(hovermode && !supportsCompare) hovermode = 'closest';
  
      if(['x', 'y', 'closest', 'x unified', 'y unified'].indexOf(hovermode) === -1 || !gd.calcdata ||
              gd.querySelector('.zoombox') || gd._dragging) {
          return dragElement.unhoverRaw(gd, evt);
      }
  
      var hoverdistance = fullLayout.hoverdistance === -1 ? Infinity : fullLayout.hoverdistance;
      var spikedistance = fullLayout.spikedistance === -1 ? Infinity : fullLayout.spikedistance;
  
      // hoverData: the set of candidate points we've found to highlight
      var hoverData = [];
  
      // searchData: the data to search in. Mostly this is just a copy of
      // gd.calcdata, filtered to the subplot and overlays we're on
      // but if a point array is supplied it will be a mapping
      // of indicated curves
      var searchData = [];
  
      // [x|y]valArray: the axis values of the hover event
      // mapped onto each of the currently selected overlaid subplots
      var xvalArray, yvalArray;
  
      var itemnum, curvenum, cd, trace, subplotId, subploti, mode,
          xval, yval, pointData, closedataPreviousLength;
  
      // spikePoints: the set of candidate points we've found to draw spikes to
      var spikePoints = {
          hLinePoint: null,
          vLinePoint: null
      };
  
      // does subplot have one (or more) horizontal traces?
      // This is used to determine whether we rotate the labels or not
      var hasOneHorizontalTrace = false;
  
      // Figure out what we're hovering on:
      // mouse location or user-supplied data
  
      if(Array.isArray(evt)) {
          // user specified an array of points to highlight
          hovermode = 'array';
          for(itemnum = 0; itemnum < evt.length; itemnum++) {
              cd = gd.calcdata[evt[itemnum].curveNumber || 0];
              if(cd) {
                  trace = cd[0].trace;
                  if(cd[0].trace.hoverinfo !== 'skip') {
                      searchData.push(cd);
                      if(trace.orientation === 'h') {
                          hasOneHorizontalTrace = true;
                      }
                  }
              }
          }
      } else {
          for(curvenum = 0; curvenum < gd.calcdata.length; curvenum++) {
              cd = gd.calcdata[curvenum];
              trace = cd[0].trace;
              if(trace.hoverinfo !== 'skip' && helpers.isTraceInSubplots(trace, subplots)) {
                  searchData.push(cd);
                  if(trace.orientation === 'h') {
                      hasOneHorizontalTrace = true;
                  }
              }
          }
  
          // [x|y]px: the pixels (from top left) of the mouse location
          // on the currently selected plot area
          // add pointerX|Y property for drawing the spikes in spikesnap 'cursor' situation
          var hasUserCalledHover = !evt.target;
          var xpx, ypx;
  
          if(hasUserCalledHover) {
              if('xpx' in evt) xpx = evt.xpx;
              else xpx = xaArray[0]._length / 2;
  
              if('ypx' in evt) ypx = evt.ypx;
              else ypx = yaArray[0]._length / 2;
          } else {
              // fire the beforehover event and quit if it returns false
              // note that we're only calling this on real mouse events, so
              // manual calls to fx.hover will always run.
              if(Events.triggerHandler(gd, 'plotly_beforehover', evt) === false) {
                  return;
              }
  
              var dbb = evt.target.getBoundingClientRect();
  
              xpx = evt.clientX - dbb.left;
              ypx = evt.clientY - dbb.top;
  
              // in case hover was called from mouseout into hovertext,
              // it's possible you're not actually over the plot anymore
              if(xpx < 0 || xpx > xaArray[0]._length || ypx < 0 || ypx > yaArray[0]._length) {
                  return dragElement.unhoverRaw(gd, evt);
              }
          }
  
          evt.pointerX = xpx + xaArray[0]._offset;
          evt.pointerY = ypx + yaArray[0]._offset;
  
          if('xval' in evt) xvalArray = helpers.flat(subplots, evt.xval);
          else xvalArray = helpers.p2c(xaArray, xpx);
  
          if('yval' in evt) yvalArray = helpers.flat(subplots, evt.yval);
          else yvalArray = helpers.p2c(yaArray, ypx);
  
          if(!isNumeric(xvalArray[0]) || !isNumeric(yvalArray[0])) {
              Lib.warn('Fx.hover failed', evt, gd);
              return dragElement.unhoverRaw(gd, evt);
          }
      }
  
      // the pixel distance to beat as a matching point
      // in 'x' or 'y' mode this resets for each trace
      var distance = Infinity;
  
      // find the closest point in each trace
      // this is minimum dx and/or dy, depending on mode
      // and the pixel position for the label (labelXpx, labelYpx)
      function findHoverPoints(customXVal, customYVal) {
          for(curvenum = 0; curvenum < searchData.length; curvenum++) {
              cd = searchData[curvenum];
  
              // filter out invisible or broken data
              if(!cd || !cd[0] || !cd[0].trace) continue;
  
              trace = cd[0].trace;
  
              if(trace.visible !== true || trace._length === 0) continue;
  
              // Explicitly bail out for these two. I don't know how to otherwise prevent
              // the rest of this function from running and failing
              if(['carpet', 'contourcarpet'].indexOf(trace._module.name) !== -1) continue;
  
              if(trace.type === 'splom') {
                  // splom traces do not generate overlay subplots,
                  // it is safe to assume here splom traces correspond to the 0th subplot
                  subploti = 0;
                  subplotId = subplots[subploti];
              } else {
                  subplotId = helpers.getSubplot(trace);
                  subploti = subplots.indexOf(subplotId);
              }
  
              // within one trace mode can sometimes be overridden
              mode = hovermode;
              if(helpers.isUnifiedHover(mode)) {
                  mode = mode.charAt(0);
              }
  
              // container for new point, also used to pass info into module.hoverPoints
              pointData = {
                  // trace properties
                  cd: cd,
                  trace: trace,
                  xa: xaArray[subploti],
                  ya: yaArray[subploti],
  
                  // max distances for hover and spikes - for points that want to show but do not
                  // want to override other points, set distance/spikeDistance equal to max*Distance
                  // and it will not get filtered out but it will be guaranteed to have a greater
                  // distance than any point that calculated a real distance.
                  maxHoverDistance: hoverdistance,
                  maxSpikeDistance: spikedistance,
  
                  // point properties - override all of these
                  index: false, // point index in trace - only used by plotly.js hoverdata consumers
                  distance: Math.min(distance, hoverdistance), // pixel distance or pseudo-distance
  
                  // distance/pseudo-distance for spikes. This distance should always be calculated
                  // as if in "closest" mode, and should only be set if this point should
                  // generate a spike.
                  spikeDistance: Infinity,
  
                  // in some cases the spikes have different positioning from the hover label
                  // they don't need x0/x1, just one position
                  xSpike: undefined,
                  ySpike: undefined,
  
                  // where and how to display the hover label
                  color: Color.defaultLine, // trace color
                  name: trace.name,
                  x0: undefined,
                  x1: undefined,
                  y0: undefined,
                  y1: undefined,
                  xLabelVal: undefined,
                  yLabelVal: undefined,
                  zLabelVal: undefined,
                  text: undefined
              };
  
              // add ref to subplot object (non-cartesian case)
              if(fullLayout[subplotId]) {
                  pointData.subplot = fullLayout[subplotId]._subplot;
              }
              // add ref to splom scene
              if(fullLayout._splomScenes && fullLayout._splomScenes[trace.uid]) {
                  pointData.scene = fullLayout._splomScenes[trace.uid];
              }
  
              closedataPreviousLength = hoverData.length;
  
              // for a highlighting array, figure out what
              // we're searching for with this element
              if(mode === 'array') {
                  var selection = evt[curvenum];
                  if('pointNumber' in selection) {
                      pointData.index = selection.pointNumber;
                      mode = 'closest';
                  } else {
                      mode = '';
                      if('xval' in selection) {
                          xval = selection.xval;
                          mode = 'x';
                      }
                      if('yval' in selection) {
                          yval = selection.yval;
                          mode = mode ? 'closest' : 'y';
                      }
                  }
              } else if(customXVal !== undefined && customYVal !== undefined) {
                  xval = customXVal;
                  yval = customYVal;
              } else {
                  xval = xvalArray[subploti];
                  yval = yvalArray[subploti];
              }
  
              // Now if there is range to look in, find the points to hover.
              if(hoverdistance !== 0) {
                  if(trace._module && trace._module.hoverPoints) {
                      var newPoints = trace._module.hoverPoints(pointData, xval, yval, mode, fullLayout._hoverlayer);
                      if(newPoints) {
                          var newPoint;
                          for(var newPointNum = 0; newPointNum < newPoints.length; newPointNum++) {
                              newPoint = newPoints[newPointNum];
                              if(isNumeric(newPoint.x0) && isNumeric(newPoint.y0)) {
                                  hoverData.push(cleanPoint(newPoint, hovermode));
                              }
                          }
                      }
                  } else {
                      Lib.log('Unrecognized trace type in hover:', trace);
                  }
              }
  
              // in closest mode, remove any existing (farther) points
              // and don't look any farther than this latest point (or points, some
              // traces like box & violin make multiple hover labels at once)
              if(hovermode === 'closest' && hoverData.length > closedataPreviousLength) {
                  hoverData.splice(0, closedataPreviousLength);
                  distance = hoverData[0].distance;
              }
  
              // Now if there is range to look in, find the points to draw the spikelines
              // Do it only if there is no hoverData
              if(hasCartesian && (spikedistance !== 0)) {
                  if(hoverData.length === 0) {
                      pointData.distance = spikedistance;
                      pointData.index = false;
                      var closestPoints = trace._module.hoverPoints(pointData, xval, yval, 'closest', fullLayout._hoverlayer);
                      if(closestPoints) {
                          closestPoints = closestPoints.filter(function(point) {
                              // some hover points, like scatter fills, do not allow spikes,
                              // so will generate a hover point but without a valid spikeDistance
                              return point.spikeDistance <= spikedistance;
                          });
                      }
                      if(closestPoints && closestPoints.length) {
                          var tmpPoint;
                          var closestVPoints = closestPoints.filter(function(point) {
                              return point.xa.showspikes && point.xa.spikesnap !== 'hovered data';
                          });
                          if(closestVPoints.length) {
                              var closestVPt = closestVPoints[0];
                              if(isNumeric(closestVPt.x0) && isNumeric(closestVPt.y0)) {
                                  tmpPoint = fillSpikePoint(closestVPt);
                                  if(!spikePoints.vLinePoint || (spikePoints.vLinePoint.spikeDistance > tmpPoint.spikeDistance)) {
                                      spikePoints.vLinePoint = tmpPoint;
                                  }
                              }
                          }
  
                          var closestHPoints = closestPoints.filter(function(point) {
                              return point.ya.showspikes && point.ya.spikesnap !== 'hovered data';
                          });
                          if(closestHPoints.length) {
                              var closestHPt = closestHPoints[0];
                              if(isNumeric(closestHPt.x0) && isNumeric(closestHPt.y0)) {
                                  tmpPoint = fillSpikePoint(closestHPt);
                                  if(!spikePoints.hLinePoint || (spikePoints.hLinePoint.spikeDistance > tmpPoint.spikeDistance)) {
                                      spikePoints.hLinePoint = tmpPoint;
                                  }
                              }
                          }
                      }
                  }
              }
          }
      }
  
      findHoverPoints();
  
      function selectClosestPoint(pointsData, spikedistance) {
          var resultPoint = null;
          var minDistance = Infinity;
          var thisSpikeDistance;
          for(var i = 0; i < pointsData.length; i++) {
              thisSpikeDistance = pointsData[i].spikeDistance;
              if(thisSpikeDistance <= minDistance && thisSpikeDistance <= spikedistance) {
                  resultPoint = pointsData[i];
                  minDistance = thisSpikeDistance;
              }
          }
          return resultPoint;
      }
  
      function fillSpikePoint(point) {
          if(!point) return null;
          return {
              xa: point.xa,
              ya: point.ya,
              x: point.xSpike !== undefined ? point.xSpike : (point.x0 + point.x1) / 2,
              y: point.ySpike !== undefined ? point.ySpike : (point.y0 + point.y1) / 2,
              distance: point.distance,
              spikeDistance: point.spikeDistance,
              curveNumber: point.trace.index,
              color: point.color,
              pointNumber: point.index
          };
      }
  
      var spikelineOpts = {
          fullLayout: fullLayout,
          container: fullLayout._hoverlayer,
          outerContainer: fullLayout._paperdiv,
          event: evt
      };
      var oldspikepoints = gd._spikepoints;
      var newspikepoints = {
          vLinePoint: spikePoints.vLinePoint,
          hLinePoint: spikePoints.hLinePoint
      };
      gd._spikepoints = newspikepoints;
  
      // Now if it is not restricted by spikedistance option, set the points to draw the spikelines
      if(hasCartesian && (spikedistance !== 0)) {
          if(hoverData.length !== 0) {
              var tmpHPointData = hoverData.filter(function(point) {
                  return point.ya.showspikes;
              });
              var tmpHPoint = selectClosestPoint(tmpHPointData, spikedistance);
              spikePoints.hLinePoint = fillSpikePoint(tmpHPoint);
  
              var tmpVPointData = hoverData.filter(function(point) {
                  return point.xa.showspikes;
              });
              var tmpVPoint = selectClosestPoint(tmpVPointData, spikedistance);
              spikePoints.vLinePoint = fillSpikePoint(tmpVPoint);
          }
      }
  
      // if hoverData is empty check for the spikes to draw and quit if there are none
      if(hoverData.length === 0) {
          var result = dragElement.unhoverRaw(gd, evt);
          if(hasCartesian && ((spikePoints.hLinePoint !== null) || (spikePoints.vLinePoint !== null))) {
              if(spikesChanged(oldspikepoints)) {
                  createSpikelines(gd, spikePoints, spikelineOpts);
              }
          }
          return result;
      }
  
      if(hasCartesian) {
          if(spikesChanged(oldspikepoints)) {
              createSpikelines(gd, spikePoints, spikelineOpts);
          }
      }
  
      hoverData.sort(function(d1, d2) { return d1.distance - d2.distance; });
  
      // If in compare mode, select every point at position
      if(
          helpers.isXYhover(mode) &&
          hoverData[0].length !== 0 &&
          hoverData[0].trace.type !== 'splom' // TODO: add support for splom
      ) {
          var hd = hoverData[0];
          var cd0 = hd.cd[hd.index];
          var isGrouped = (fullLayout.boxmode === 'group' || fullLayout.violinmode === 'group');
  
          var xVal = hd.xVal;
          var ax = hd.xa;
          if(ax.type === 'category') xVal = ax._categoriesMap[xVal];
          if(ax.type === 'date') xVal = ax.d2c(xVal);
          if(cd0 && cd0.t && cd0.t.posLetter === ax._id && isGrouped) {
              xVal += cd0.t.dPos;
          }
  
          var yVal = hd.yVal;
          ax = hd.ya;
          if(ax.type === 'category') yVal = ax._categoriesMap[yVal];
          if(ax.type === 'date') yVal = ax.d2c(yVal);
          if(cd0 && cd0.t && cd0.t.posLetter === ax._id && isGrouped) {
              yVal += cd0.t.dPos;
          }
  
          findHoverPoints(xVal, yVal);
  
          // Remove duplicated hoverData points
          // note that d3 also filters identical points in the rendering steps
          var repeated = {};
          hoverData = hoverData.filter(function(hd) {
              var key = hoverDataKey(hd);
              if(!repeated[key]) {
                  repeated[key] = true;
                  return repeated[key];
              }
          });
      }
  
      // lastly, emit custom hover/unhover events
      var oldhoverdata = gd._hoverdata;
      var newhoverdata = [];
  
      // pull out just the data that's useful to
      // other people and send it to the event
      for(itemnum = 0; itemnum < hoverData.length; itemnum++) {
          var pt = hoverData[itemnum];
          var eventData = helpers.makeEventData(pt, pt.trace, pt.cd);
  
          if(pt.hovertemplate !== false) {
              var ht = false;
              if(pt.cd[pt.index] && pt.cd[pt.index].ht) {
                  ht = pt.cd[pt.index].ht;
              }
              pt.hovertemplate = ht || pt.trace.hovertemplate || false;
          }
  
          pt.eventData = [eventData];
          newhoverdata.push(eventData);
      }
  
      gd._hoverdata = newhoverdata;
  
      var rotateLabels = (
          (hovermode === 'y' && (searchData.length > 1 || hoverData.length > 1)) ||
          (hovermode === 'closest' && hasOneHorizontalTrace && hoverData.length > 1)
      );
  
      var bgColor = Color.combine(
          fullLayout.plot_bgcolor || Color.background,
          fullLayout.paper_bgcolor
      );
  
      var labelOpts = {
          hovermode: hovermode,
          rotateLabels: rotateLabels,
          bgColor: bgColor,
          container: fullLayout._hoverlayer,
          outerContainer: fullLayout._paperdiv,
          commonLabelOpts: fullLayout.hoverlabel,
          hoverdistance: fullLayout.hoverdistance
      };
  
      var hoverLabels = createHoverText(hoverData, labelOpts, gd);
  
      if(!helpers.isUnifiedHover(hovermode)) {
          hoverAvoidOverlaps(hoverLabels, rotateLabels ? 'xa' : 'ya', fullLayout);
          alignHoverText(hoverLabels, rotateLabels);
      }
  
      // TODO: tagName hack is needed to appease geo.js's hack of using evt.target=true
      // we should improve the "fx" API so other plots can use it without these hack.
      if(evt.target && evt.target.tagName) {
          var hasClickToShow = Registry.getComponentMethod('annotations', 'hasClickToShow')(gd, newhoverdata);
          overrideCursor(d3.select(evt.target), hasClickToShow ? 'pointer' : '');
      }
  
      // don't emit events if called manually
      if(!evt.target || noHoverEvent || !hoverChanged(gd, evt, oldhoverdata)) return;
  
      if(oldhoverdata) {
          gd.emit('plotly_unhover', {
              event: evt,
              points: oldhoverdata
          });
      }
  
      gd.emit('plotly_hover', {
          event: evt,
          points: gd._hoverdata,
          xaxes: xaArray,
          yaxes: yaArray,
          xvals: xvalArray,
          yvals: yvalArray
      });
  }
  
  function hoverDataKey(d) {
      return [d.trace.index, d.index, d.x0, d.y0, d.name, d.attr, d.xa, d.ya || ''].join(',');
  }
  
  var EXTRA_STRING_REGEX = /<extra>([\s\S]*)<\/extra>/;
  
  function createHoverText(hoverData, opts, gd) {
      var fullLayout = gd._fullLayout;
      var hovermode = opts.hovermode;
      var rotateLabels = opts.rotateLabels;
      var bgColor = opts.bgColor;
      var container = opts.container;
      var outerContainer = opts.outerContainer;
      var commonLabelOpts = opts.commonLabelOpts || {};
  
      // opts.fontFamily/Size are used for the common label
      // and as defaults for each hover label, though the individual labels
      // can override this.
      var fontFamily = opts.fontFamily || constants.HOVERFONT;
      var fontSize = opts.fontSize || constants.HOVERFONTSIZE;
  
      var c0 = hoverData[0];
      var xa = c0.xa;
      var ya = c0.ya;
      var commonAttr = hovermode.charAt(0) === 'y' ? 'yLabel' : 'xLabel';
      var t0 = c0[commonAttr];
      var t00 = (String(t0) || '').split(' ')[0];
      var outerContainerBB = outerContainer.node().getBoundingClientRect();
      var outerTop = outerContainerBB.top;
      var outerWidth = outerContainerBB.width;
      var outerHeight = outerContainerBB.height;
  
      // show the common label, if any, on the axis
      // never show a common label in array mode,
      // even if sometimes there could be one
      var showCommonLabel = (
          (t0 !== undefined) &&
          (c0.distance <= opts.hoverdistance) &&
          (hovermode === 'x' || hovermode === 'y')
      );
  
      // all hover traces hoverinfo must contain the hovermode
      // to have common labels
      if(showCommonLabel) {
          var allHaveZ = true;
          var i, traceHoverinfo;
          for(i = 0; i < hoverData.length; i++) {
              if(allHaveZ && hoverData[i].zLabel === undefined) allHaveZ = false;
  
              traceHoverinfo = hoverData[i].hoverinfo || hoverData[i].trace.hoverinfo;
              if(traceHoverinfo) {
                  var parts = Array.isArray(traceHoverinfo) ? traceHoverinfo : traceHoverinfo.split('+');
                  if(parts.indexOf('all') === -1 &&
                      parts.indexOf(hovermode) === -1) {
                      showCommonLabel = false;
                      break;
                  }
              }
          }
  
          // xyz labels put all info in their main label, so have no need of a common label
          if(allHaveZ) showCommonLabel = false;
      }
  
      var commonLabel = container.selectAll('g.axistext')
          .data(showCommonLabel ? [0] : []);
      commonLabel.enter().append('g')
          .classed('axistext', true);
      commonLabel.exit().remove();
  
      commonLabel.each(function() {
          var label = d3.select(this);
          var lpath = Lib.ensureSingle(label, 'path', '', function(s) {
              s.style({'stroke-width': '1px'});
          });
          var ltext = Lib.ensureSingle(label, 'text', '', function(s) {
              // prohibit tex interpretation until we can handle
              // tex and regular text together
              s.attr('data-notex', 1);
          });
  
          var commonBgColor = commonLabelOpts.bgcolor || Color.defaultLine;
          var commonStroke = commonLabelOpts.bordercolor || Color.contrast(commonBgColor);
          var contrastColor = Color.contrast(commonBgColor);
          var commonLabelFont = {
              family: commonLabelOpts.font.family || fontFamily,
              size: commonLabelOpts.font.size || fontSize,
              color: commonLabelOpts.font.color || contrastColor
          };
  
          lpath.style({
              fill: commonBgColor,
              stroke: commonStroke
          });
  
          ltext.text(t0)
              .call(Drawing.font, commonLabelFont)
              .call(svgTextUtils.positionText, 0, 0)
              .call(svgTextUtils.convertToTspans, gd);
  
          label.attr('transform', '');
  
          var tbb = ltext.node().getBoundingClientRect();
          var lx, ly;
  
          if(hovermode === 'x') {
              var topsign = xa.side === 'top' ? '-' : '';
  
              ltext.attr('text-anchor', 'middle')
                  .call(svgTextUtils.positionText, 0, (xa.side === 'top' ?
                      (outerTop - tbb.bottom - HOVERARROWSIZE - HOVERTEXTPAD) :
                      (outerTop - tbb.top + HOVERARROWSIZE + HOVERTEXTPAD)));
  
              lx = xa._offset + (c0.x0 + c0.x1) / 2;
              ly = ya._offset + (xa.side === 'top' ? 0 : ya._length);
  
              var halfWidth = tbb.width / 2 + HOVERTEXTPAD;
  
              if(lx < halfWidth) {
                  lx = halfWidth;
  
                  lpath.attr('d', 'M-' + (halfWidth - HOVERARROWSIZE) + ',0' +
                      'L-' + (halfWidth - HOVERARROWSIZE * 2) + ',' + topsign + HOVERARROWSIZE +
                      'H' + (HOVERTEXTPAD + tbb.width / 2) +
                      'v' + topsign + (HOVERTEXTPAD * 2 + tbb.height) +
                      'H-' + halfWidth +
                      'V' + topsign + HOVERARROWSIZE +
                      'Z');
              } else if(lx > (fullLayout.width - halfWidth)) {
                  lx = fullLayout.width - halfWidth;
  
                  lpath.attr('d', 'M' + (halfWidth - HOVERARROWSIZE) + ',0' +
                      'L' + halfWidth + ',' + topsign + HOVERARROWSIZE +
                      'v' + topsign + (HOVERTEXTPAD * 2 + tbb.height) +
                      'H-' + halfWidth +
                      'V' + topsign + HOVERARROWSIZE +
                      'H' + (halfWidth - HOVERARROWSIZE * 2) + 'Z');
              } else {
                  lpath.attr('d', 'M0,0' +
                      'L' + HOVERARROWSIZE + ',' + topsign + HOVERARROWSIZE +
                      'H' + (HOVERTEXTPAD + tbb.width / 2) +
                      'v' + topsign + (HOVERTEXTPAD * 2 + tbb.height) +
                      'H-' + (HOVERTEXTPAD + tbb.width / 2) +
                      'V' + topsign + HOVERARROWSIZE +
                      'H-' + HOVERARROWSIZE + 'Z');
              }
          } else {
              var anchor;
              var sgn;
              var leftsign;
              if(ya.side === 'right') {
                  anchor = 'start';
                  sgn = 1;
                  leftsign = '';
                  lx = xa._offset + xa._length;
              } else {
                  anchor = 'end';
                  sgn = -1;
                  leftsign = '-';
                  lx = xa._offset;
              }
  
              ly = ya._offset + (c0.y0 + c0.y1) / 2;
  
              ltext.attr('text-anchor', anchor);
  
              lpath.attr('d', 'M0,0' +
                  'L' + leftsign + HOVERARROWSIZE + ',' + HOVERARROWSIZE +
                  'V' + (HOVERTEXTPAD + tbb.height / 2) +
                  'h' + leftsign + (HOVERTEXTPAD * 2 + tbb.width) +
                  'V-' + (HOVERTEXTPAD + tbb.height / 2) +
                  'H' + leftsign + HOVERARROWSIZE + 'V-' + HOVERARROWSIZE + 'Z');
  
              var halfHeight = tbb.height / 2;
              var lty = outerTop - tbb.top - halfHeight;
              var clipId = 'clip' + fullLayout._uid + 'commonlabel' + ya._id;
              var clipPath;
  
              if(lx < (tbb.width + 2 * HOVERTEXTPAD + HOVERARROWSIZE)) {
                  clipPath = 'M-' + (HOVERARROWSIZE + HOVERTEXTPAD) + '-' + halfHeight +
                      'h-' + (tbb.width - HOVERTEXTPAD) +
                      'V' + halfHeight +
                      'h' + (tbb.width - HOVERTEXTPAD) + 'Z';
  
                  var ltx = tbb.width - lx + HOVERTEXTPAD;
                  svgTextUtils.positionText(ltext, ltx, lty);
  
                  // shift each line (except the longest) so that start-of-line
                  // is always visible
                  if(anchor === 'end') {
                      ltext.selectAll('tspan').each(function() {
                          var s = d3.select(this);
                          var dummy = Drawing.tester.append('text')
                              .text(s.text())
                              .call(Drawing.font, commonLabelFont);
                          var dummyBB = dummy.node().getBoundingClientRect();
                          if(Math.round(dummyBB.width) < Math.round(tbb.width)) {
                              s.attr('x', ltx - dummyBB.width);
                          }
                          dummy.remove();
                      });
                  }
              } else {
                  svgTextUtils.positionText(ltext, sgn * (HOVERTEXTPAD + HOVERARROWSIZE), lty);
                  clipPath = null;
              }
  
              var textClip = fullLayout._topclips.selectAll('#' + clipId).data(clipPath ? [0] : []);
              textClip.enter().append('clipPath').attr('id', clipId).append('path');
              textClip.exit().remove();
              textClip.select('path').attr('d', clipPath);
              Drawing.setClipUrl(ltext, clipPath ? clipId : null, gd);
          }
  
          label.attr('transform', 'translate(' + lx + ',' + ly + ')');
  
          // remove the "close but not quite" points
          // because of error bars, only take up to a space
          hoverData = filterClosePoints(hoverData);
      });
  
      function filterClosePoints(hoverData) {
          return hoverData.filter(function(d) {
              return (d.zLabelVal !== undefined) ||
                  (d[commonAttr] || '').split(' ')[0] === t00;
          });
      }
  
      // Show a single hover label
      if(helpers.isUnifiedHover(hovermode)) {
          // Delete leftover hover labels from other hovermodes
          container.selectAll('g.hovertext').remove();
  
          // similarly to compare mode, we remove the "close but not quite together" points
          if((t0 !== undefined) && (c0.distance <= opts.hoverdistance)) hoverData = filterClosePoints(hoverData);
  
          // Return early if nothing is hovered on
          if(hoverData.length === 0) return;
  
          // mock legend
          var mockLayoutIn = {
              showlegend: true,
              legend: {
                  title: {text: t0, font: fullLayout.hoverlabel.font},
                  font: fullLayout.hoverlabel.font,
                  bgcolor: fullLayout.hoverlabel.bgcolor,
                  bordercolor: fullLayout.hoverlabel.bordercolor,
                  borderwidth: 1,
                  tracegroupgap: 7,
                  traceorder: fullLayout.legend ? fullLayout.legend.traceorder : undefined,
                  orientation: 'v'
              }
          };
          var mockLayoutOut = {};
          legendSupplyDefaults(mockLayoutIn, mockLayoutOut, gd._fullData);
          var legendOpts = mockLayoutOut.legend;
  
          // prepare items for the legend
          legendOpts.entries = [];
          for(var j = 0; j < hoverData.length; j++) {
              var texts = getHoverLabelText(hoverData[j], true, hovermode, fullLayout, t0);
              var text = texts[0];
              var name = texts[1];
              var pt = hoverData[j];
              pt.name = name;
              if(name !== '') {
                  pt.text = name + ' : ' + text;
              } else {
                  pt.text = text;
              }
  
              // pass through marker's calcdata to style legend items
              var cd = pt.cd[pt.index];
              if(cd) {
                  if(cd.mc) pt.mc = cd.mc;
                  if(cd.mcc) pt.mc = cd.mcc;
                  if(cd.mlc) pt.mlc = cd.mlc;
                  if(cd.mlcc) pt.mlc = cd.mlcc;
                  if(cd.mlw) pt.mlw = cd.mlw;
                  if(cd.mrc) pt.mrc = cd.mrc;
                  if(cd.dir) pt.dir = cd.dir;
              }
              pt._distinct = true;
  
              legendOpts.entries.push([pt]);
          }
          legendOpts.entries.sort(function(a, b) { return a[0].trace.index - b[0].trace.index;});
          legendOpts.layer = container;
  
          // Draw unified hover label
          legendDraw(gd, legendOpts);
  
          // Position the hover
          var ly = Lib.mean(hoverData.map(function(c) {return (c.y0 + c.y1) / 2;}));
          var lx = Lib.mean(hoverData.map(function(c) {return (c.x0 + c.x1) / 2;}));
          var legendContainer = container.select('g.legend');
          var tbb = legendContainer.node().getBoundingClientRect();
          lx += xa._offset;
          ly += ya._offset - tbb.height / 2;
  
          // Change horizontal alignment to end up on screen
          var txWidth = tbb.width + 2 * HOVERTEXTPAD;
          var anchorStartOK = lx + txWidth <= outerWidth;
          var anchorEndOK = lx - txWidth >= 0;
          if(!anchorStartOK && anchorEndOK) {
              lx -= txWidth;
          } else {
              lx += 2 * HOVERTEXTPAD;
          }
  
          // Change vertical alignement to end up on screen
          var txHeight = tbb.height + 2 * HOVERTEXTPAD;
          var overflowTop = ly <= outerTop;
          var overflowBottom = ly + txHeight >= outerHeight;
          var canFit = txHeight <= outerHeight;
          if(canFit) {
              if(overflowTop) {
                  ly = ya._offset + 2 * HOVERTEXTPAD;
              } else if(overflowBottom) {
                  ly = outerHeight - txHeight;
              }
          }
          legendContainer.attr('transform', 'translate(' + lx + ',' + ly + ')');
  
          return legendContainer;
      }
  
      // show all the individual labels
  
      // first create the objects
      var hoverLabels = container.selectAll('g.hovertext')
          .data(hoverData, function(d) {
              // N.B. when multiple items have the same result key-function value,
              // only the first of those items in hoverData gets rendered
              return hoverDataKey(d);
          });
      hoverLabels.enter().append('g')
          .classed('hovertext', true)
          .each(function() {
              var g = d3.select(this);
              // trace name label (rect and text.name)
              g.append('rect')
                  .call(Color.fill, Color.addOpacity(bgColor, 0.8));
              g.append('text').classed('name', true);
              // trace data label (path and text.nums)
              g.append('path')
                  .style('stroke-width', '1px');
              g.append('text').classed('nums', true)
                  .call(Drawing.font, fontFamily, fontSize);
          });
      hoverLabels.exit().remove();
  
      // then put the text in, position the pointer to the data,
      // and figure out sizes
      hoverLabels.each(function(d) {
          var g = d3.select(this).attr('transform', '');
  
          var dColor = d.color;
          if(Array.isArray(dColor)) {
              dColor = dColor[d.eventData[0].pointNumber];
          }
  
          // combine possible non-opaque trace color with bgColor
          var color0 = d.bgcolor || dColor;
          // color for 'nums' part of the label
          var numsColor = Color.combine(
              Color.opacity(color0) ? color0 : Color.defaultLine,
              bgColor
          );
          // color for 'name' part of the label
          var nameColor = Color.combine(
              Color.opacity(dColor) ? dColor : Color.defaultLine,
              bgColor
          );
          // find a contrasting color for border and text
          var contrastColor = d.borderColor || Color.contrast(numsColor);
  
          var texts = getHoverLabelText(d, showCommonLabel, hovermode, fullLayout, t0, g);
          var text = texts[0];
          var name = texts[1];
  
          // main label
          var tx = g.select('text.nums')
              .call(Drawing.font,
                  d.fontFamily || fontFamily,
                  d.fontSize || fontSize,
                  d.fontColor || contrastColor)
              .text(text)
              .attr('data-notex', 1)
              .call(svgTextUtils.positionText, 0, 0)
              .call(svgTextUtils.convertToTspans, gd);
  
          var tx2 = g.select('text.name');
          var tx2width = 0;
          var tx2height = 0;
  
          // secondary label for non-empty 'name'
          if(name && name !== text) {
              tx2.call(Drawing.font,
                      d.fontFamily || fontFamily,
                      d.fontSize || fontSize,
                      nameColor)
                  .text(name)
                  .attr('data-notex', 1)
                  .call(svgTextUtils.positionText, 0, 0)
                  .call(svgTextUtils.convertToTspans, gd);
  
              var t2bb = tx2.node().getBoundingClientRect();
              tx2width = t2bb.width + 2 * HOVERTEXTPAD;
              tx2height = t2bb.height + 2 * HOVERTEXTPAD;
          } else {
              tx2.remove();
              g.select('rect').remove();
          }
  
          g.select('path').style({
              fill: numsColor,
              stroke: contrastColor
          });
  
          var tbb = tx.node().getBoundingClientRect();
          var htx = d.xa._offset + (d.x0 + d.x1) / 2;
          var hty = d.ya._offset + (d.y0 + d.y1) / 2;
          var dx = Math.abs(d.x1 - d.x0);
          var dy = Math.abs(d.y1 - d.y0);
          var txTotalWidth = tbb.width + HOVERARROWSIZE + HOVERTEXTPAD + tx2width;
          var anchorStartOK, anchorEndOK;
  
          d.ty0 = outerTop - tbb.top;
          d.bx = tbb.width + 2 * HOVERTEXTPAD;
          d.by = Math.max(tbb.height + 2 * HOVERTEXTPAD, tx2height);
          d.anchor = 'start';
          d.txwidth = tbb.width;
          d.tx2width = tx2width;
          d.offset = 0;
  
          if(rotateLabels) {
              d.pos = htx;
              anchorStartOK = hty + dy / 2 + txTotalWidth <= outerHeight;
              anchorEndOK = hty - dy / 2 - txTotalWidth >= 0;
              if((d.idealAlign === 'top' || !anchorStartOK) && anchorEndOK) {
                  hty -= dy / 2;
                  d.anchor = 'end';
              } else if(anchorStartOK) {
                  hty += dy / 2;
                  d.anchor = 'start';
              } else d.anchor = 'middle';
          } else {
              d.pos = hty;
              anchorStartOK = htx + dx / 2 + txTotalWidth <= outerWidth;
              anchorEndOK = htx - dx / 2 - txTotalWidth >= 0;
  
              if((d.idealAlign === 'left' || !anchorStartOK) && anchorEndOK) {
                  htx -= dx / 2;
                  d.anchor = 'end';
              } else if(anchorStartOK) {
                  htx += dx / 2;
                  d.anchor = 'start';
              } else {
                  d.anchor = 'middle';
  
                  var txHalfWidth = txTotalWidth / 2;
                  var overflowR = htx + txHalfWidth - outerWidth;
                  var overflowL = htx - txHalfWidth;
                  if(overflowR > 0) htx -= overflowR;
                  if(overflowL < 0) htx += -overflowL;
              }
          }
  
          tx.attr('text-anchor', d.anchor);
          if(tx2width) tx2.attr('text-anchor', d.anchor);
          g.attr('transform', 'translate(' + htx + ',' + hty + ')' +
              (rotateLabels ? 'rotate(' + YANGLE + ')' : ''));
      });
  
      return hoverLabels;
  }
  
  function getHoverLabelText(d, showCommonLabel, hovermode, fullLayout, t0, g) {
      var name = '';
      var text = '';
      // to get custom 'name' labels pass cleanPoint
      if(d.nameOverride !== undefined) d.name = d.nameOverride;
  
      if(d.name) {
          if(d.trace._meta) {
              d.name = Lib.templateString(d.name, d.trace._meta);
          }
          name = plainText(d.name, d.nameLength);
      }
  
      if(d.zLabel !== undefined) {
          if(d.xLabel !== undefined) text += 'x: ' + d.xLabel + '<br>';
          if(d.yLabel !== undefined) text += 'y: ' + d.yLabel + '<br>';
          if(d.trace.type !== 'choropleth' && d.trace.type !== 'choroplethmapbox') {
              text += (text ? 'z: ' : '') + d.zLabel;
          }
      } else if(showCommonLabel && d[hovermode.charAt(0) + 'Label'] === t0) {
          text = d[(hovermode.charAt(0) === 'x' ? 'y' : 'x') + 'Label'] || '';
      } else if(d.xLabel === undefined) {
          if(d.yLabel !== undefined && d.trace.type !== 'scattercarpet') {
              text = d.yLabel;
          }
      } else if(d.yLabel === undefined) text = d.xLabel;
      else text = '(' + d.xLabel + ', ' + d.yLabel + ')';
  
      if((d.text || d.text === 0) && !Array.isArray(d.text)) {
          text += (text ? '<br>' : '') + d.text;
      }
  
      // used by other modules (initially just ternary) that
      // manage their own hoverinfo independent of cleanPoint
      // the rest of this will still apply, so such modules
      // can still put things in (x|y|z)Label, text, and name
      // and hoverinfo will still determine their visibility
      if(d.extraText !== undefined) text += (text ? '<br>' : '') + d.extraText;
  
      // if 'text' is empty at this point,
      // and hovertemplate is not defined,
      // put 'name' in main label and don't show secondary label
      if(g && text === '' && !d.hovertemplate) {
          // if 'name' is also empty, remove entire label
          if(name === '') g.remove();
          text = name;
      }
  
      // hovertemplate
      var d3locale = fullLayout._d3locale;
      var hovertemplate = d.hovertemplate || false;
      var hovertemplateLabels = d.hovertemplateLabels || d;
      var eventData = d.eventData[0] || {};
      if(hovertemplate) {
          text = Lib.hovertemplateString(
              hovertemplate,
              hovertemplateLabels,
              d3locale,
              eventData,
              d.trace._meta
          );
  
          text = text.replace(EXTRA_STRING_REGEX, function(match, extra) {
              // assign name for secondary text label
              name = plainText(extra, d.nameLength);
              // remove from main text label
              return '';
          });
      }
      return [text, name];
  }
  
  // Make groups of touching points, and within each group
  // move each point so that no labels overlap, but the average
  // label position is the same as it was before moving. Indicentally,
  // this is equivalent to saying all the labels are on equal linear
  // springs about their initial position. Initially, each point is
  // its own group, but as we find overlaps we will clump the points.
  //
  // Also, there are hard constraints at the edges of the graphs,
  // that push all groups to the middle so they are visible. I don't
  // know what happens if the group spans all the way from one edge to
  // the other, though it hardly matters - there's just too much
  // information then.
  function hoverAvoidOverlaps(hoverLabels, axKey, fullLayout) {
      var nummoves = 0;
      var axSign = 1;
      var nLabels = hoverLabels.size();
  
      // make groups of touching points
      var pointgroups = new Array(nLabels);
      var k = 0;
  
      hoverLabels.each(function(d) {
          var ax = d[axKey];
          var axIsX = ax._id.charAt(0) === 'x';
          var rng = ax.range;
  
          if(k === 0 && rng && ((rng[0] > rng[1]) !== axIsX)) {
              axSign = -1;
          }
          pointgroups[k++] = [{
              datum: d,
              traceIndex: d.trace.index,
              dp: 0,
              pos: d.pos,
              posref: d.posref,
              size: d.by * (axIsX ? YFACTOR : 1) / 2,
              pmin: 0,
              pmax: (axIsX ? fullLayout.width : fullLayout.height)
          }];
      });
  
      pointgroups.sort(function(a, b) {
          return (a[0].posref - b[0].posref) ||
              // for equal positions, sort trace indices increasing or decreasing
              // depending on whether the axis is reversed or not... so stacked
              // traces will generally keep their order even if one trace adds
              // nothing to the stack.
              (axSign * (b[0].traceIndex - a[0].traceIndex));
      });
  
      var donepositioning, topOverlap, bottomOverlap, i, j, pti, sumdp;
  
      function constrainGroup(grp) {
          var minPt = grp[0];
          var maxPt = grp[grp.length - 1];
  
          // overlap with the top - positive vals are overlaps
          topOverlap = minPt.pmin - minPt.pos - minPt.dp + minPt.size;
  
          // overlap with the bottom - positive vals are overlaps
          bottomOverlap = maxPt.pos + maxPt.dp + maxPt.size - minPt.pmax;
  
          // check for min overlap first, so that we always
          // see the largest labels
          // allow for .01px overlap, so we don't get an
          // infinite loop from rounding errors
          if(topOverlap > 0.01) {
              for(j = grp.length - 1; j >= 0; j--) grp[j].dp += topOverlap;
              donepositioning = false;
          }
          if(bottomOverlap < 0.01) return;
          if(topOverlap < -0.01) {
              // make sure we're not pushing back and forth
              for(j = grp.length - 1; j >= 0; j--) grp[j].dp -= bottomOverlap;
              donepositioning = false;
          }
          if(!donepositioning) return;
  
          // no room to fix positioning, delete off-screen points
  
          // first see how many points we need to delete
          var deleteCount = 0;
          for(i = 0; i < grp.length; i++) {
              pti = grp[i];
              if(pti.pos + pti.dp + pti.size > minPt.pmax) deleteCount++;
          }
  
          // start by deleting points whose data is off screen
          for(i = grp.length - 1; i >= 0; i--) {
              if(deleteCount <= 0) break;
              pti = grp[i];
  
              // pos has already been constrained to [pmin,pmax]
              // so look for points close to that to delete
              if(pti.pos > minPt.pmax - 1) {
                  pti.del = true;
                  deleteCount--;
              }
          }
          for(i = 0; i < grp.length; i++) {
              if(deleteCount <= 0) break;
              pti = grp[i];
  
              // pos has already been constrained to [pmin,pmax]
              // so look for points close to that to delete
              if(pti.pos < minPt.pmin + 1) {
                  pti.del = true;
                  deleteCount--;
  
                  // shift the whole group minus into this new space
                  bottomOverlap = pti.size * 2;
                  for(j = grp.length - 1; j >= 0; j--) grp[j].dp -= bottomOverlap;
              }
          }
          // then delete points that go off the bottom
          for(i = grp.length - 1; i >= 0; i--) {
              if(deleteCount <= 0) break;
              pti = grp[i];
              if(pti.pos + pti.dp + pti.size > minPt.pmax) {
                  pti.del = true;
                  deleteCount--;
              }
          }
      }
  
      // loop through groups, combining them if they overlap,
      // until nothing moves
      while(!donepositioning && nummoves <= nLabels) {
          // to avoid infinite loops, don't move more times
          // than there are traces
          nummoves++;
  
          // assume nothing will move in this iteration,
          // reverse this if it does
          donepositioning = true;
          i = 0;
          while(i < pointgroups.length - 1) {
              // the higher (g0) and lower (g1) point group
              var g0 = pointgroups[i];
              var g1 = pointgroups[i + 1];
  
              // the lowest point in the higher group (p0)
              // the highest point in the lower group (p1)
              var p0 = g0[g0.length - 1];
              var p1 = g1[0];
              topOverlap = p0.pos + p0.dp + p0.size - p1.pos - p1.dp + p1.size;
  
              // Only group points that lie on the same axes
              if(topOverlap > 0.01 && (p0.pmin === p1.pmin) && (p0.pmax === p1.pmax)) {
                  // push the new point(s) added to this group out of the way
                  for(j = g1.length - 1; j >= 0; j--) g1[j].dp += topOverlap;
  
                  // add them to the group
                  g0.push.apply(g0, g1);
                  pointgroups.splice(i + 1, 1);
  
                  // adjust for minimum average movement
                  sumdp = 0;
                  for(j = g0.length - 1; j >= 0; j--) sumdp += g0[j].dp;
                  bottomOverlap = sumdp / g0.length;
                  for(j = g0.length - 1; j >= 0; j--) g0[j].dp -= bottomOverlap;
                  donepositioning = false;
              } else i++;
          }
  
          // check if we're going off the plot on either side and fix
          pointgroups.forEach(constrainGroup);
      }
  
      // now put these offsets into hoverData
      for(i = pointgroups.length - 1; i >= 0; i--) {
          var grp = pointgroups[i];
          for(j = grp.length - 1; j >= 0; j--) {
              var pt = grp[j];
              var hoverPt = pt.datum;
              hoverPt.offset = pt.dp;
              hoverPt.del = pt.del;
          }
      }
  }
  
  function alignHoverText(hoverLabels, rotateLabels) {
      // finally set the text positioning relative to the data and draw the
      // box around it
      hoverLabels.each(function(d) {
          var g = d3.select(this);
          if(d.del) return g.remove();
  
          var tx = g.select('text.nums');
          var anchor = d.anchor;
          var horzSign = anchor === 'end' ? -1 : 1;
          var alignShift = {start: 1, end: -1, middle: 0}[anchor];
          var txx = alignShift * (HOVERARROWSIZE + HOVERTEXTPAD);
          var tx2x = txx + alignShift * (d.txwidth + HOVERTEXTPAD);
          var offsetX = 0;
          var offsetY = d.offset;
  
          if(anchor === 'middle') {
              txx -= d.tx2width / 2;
              tx2x += d.txwidth / 2 + HOVERTEXTPAD;
          }
          if(rotateLabels) {
              offsetY *= -YSHIFTY;
              offsetX = d.offset * YSHIFTX;
          }
  
          g.select('path').attr('d', anchor === 'middle' ?
              // middle aligned: rect centered on data
              ('M-' + (d.bx / 2 + d.tx2width / 2) + ',' + (offsetY - d.by / 2) +
                'h' + d.bx + 'v' + d.by + 'h-' + d.bx + 'Z') :
              // left or right aligned: side rect with arrow to data
              ('M0,0L' + (horzSign * HOVERARROWSIZE + offsetX) + ',' + (HOVERARROWSIZE + offsetY) +
                  'v' + (d.by / 2 - HOVERARROWSIZE) +
                  'h' + (horzSign * d.bx) +
                  'v-' + d.by +
                  'H' + (horzSign * HOVERARROWSIZE + offsetX) +
                  'V' + (offsetY - HOVERARROWSIZE) +
                  'Z'));
  
          var posX = txx + offsetX;
          var posY = offsetY + d.ty0 - d.by / 2 + HOVERTEXTPAD;
          var textAlign = d.textAlign || 'auto';
  
          if(textAlign !== 'auto') {
              if(textAlign === 'left' && anchor !== 'start') {
                  tx.attr('text-anchor', 'start');
                  posX = anchor === 'middle' ?
                      -d.bx / 2 - d.tx2width / 2 + HOVERTEXTPAD :
                      -d.bx - HOVERTEXTPAD;
              } else if(textAlign === 'right' && anchor !== 'end') {
                  tx.attr('text-anchor', 'end');
                  posX = anchor === 'middle' ?
                      d.bx / 2 - d.tx2width / 2 - HOVERTEXTPAD :
                      d.bx + HOVERTEXTPAD;
              }
          }
  
          tx.call(svgTextUtils.positionText, posX, posY);
  
          if(d.tx2width) {
              g.select('text.name')
                  .call(svgTextUtils.positionText,
                      tx2x + alignShift * HOVERTEXTPAD + offsetX,
                      offsetY + d.ty0 - d.by / 2 + HOVERTEXTPAD);
              g.select('rect')
                  .call(Drawing.setRect,
                      tx2x + (alignShift - 1) * d.tx2width / 2 + offsetX,
                      offsetY - d.by / 2 - 1,
                      d.tx2width, d.by + 2);
          }
      });
  }
  
  function cleanPoint(d, hovermode) {
      var index = d.index;
      var trace = d.trace || {};
      var cd0 = d.cd[0];
      var cd = d.cd[index] || {};
  
      function pass(v) {
          return v || (isNumeric(v) && v === 0);
      }
  
      var getVal = Array.isArray(index) ?
          function(calcKey, traceKey) {
              var v = Lib.castOption(cd0, index, calcKey);
              return pass(v) ? v : Lib.extractOption({}, trace, '', traceKey);
          } :
          function(calcKey, traceKey) {
              return Lib.extractOption(cd, trace, calcKey, traceKey);
          };
  
      function fill(key, calcKey, traceKey) {
          var val = getVal(calcKey, traceKey);
          if(pass(val)) d[key] = val;
      }
  
      fill('hoverinfo', 'hi', 'hoverinfo');
      fill('bgcolor', 'hbg', 'hoverlabel.bgcolor');
      fill('borderColor', 'hbc', 'hoverlabel.bordercolor');
      fill('fontFamily', 'htf', 'hoverlabel.font.family');
      fill('fontSize', 'hts', 'hoverlabel.font.size');
      fill('fontColor', 'htc', 'hoverlabel.font.color');
      fill('nameLength', 'hnl', 'hoverlabel.namelength');
      fill('textAlign', 'hta', 'hoverlabel.align');
  
      d.posref = (hovermode === 'y' || (hovermode === 'closest' && trace.orientation === 'h')) ?
          (d.xa._offset + (d.x0 + d.x1) / 2) :
          (d.ya._offset + (d.y0 + d.y1) / 2);
  
      // then constrain all the positions to be on the plot
      d.x0 = Lib.constrain(d.x0, 0, d.xa._length);
      d.x1 = Lib.constrain(d.x1, 0, d.xa._length);
      d.y0 = Lib.constrain(d.y0, 0, d.ya._length);
      d.y1 = Lib.constrain(d.y1, 0, d.ya._length);
  
      // and convert the x and y label values into formatted text
      if(d.xLabelVal !== undefined) {
          d.xLabel = ('xLabel' in d) ? d.xLabel : Axes.hoverLabelText(d.xa, d.xLabelVal);
          d.xVal = d.xa.c2d(d.xLabelVal);
      }
      if(d.yLabelVal !== undefined) {
          d.yLabel = ('yLabel' in d) ? d.yLabel : Axes.hoverLabelText(d.ya, d.yLabelVal);
          d.yVal = d.ya.c2d(d.yLabelVal);
      }
  
      // Traces like heatmaps generate the zLabel in their hoverPoints function
      if(d.zLabelVal !== undefined && d.zLabel === undefined) {
          d.zLabel = String(d.zLabelVal);
      }
  
      // for box means and error bars, add the range to the label
      if(!isNaN(d.xerr) && !(d.xa.type === 'log' && d.xerr <= 0)) {
          var xeText = Axes.tickText(d.xa, d.xa.c2l(d.xerr), 'hover').text;
          if(d.xerrneg !== undefined) {
              d.xLabel += ' +' + xeText + ' / -' +
                  Axes.tickText(d.xa, d.xa.c2l(d.xerrneg), 'hover').text;
          } else d.xLabel += ' ± ' + xeText;
  
          // small distance penalty for error bars, so that if there are
          // traces with errors and some without, the error bar label will
          // hoist up to the point
          if(hovermode === 'x') d.distance += 1;
      }
      if(!isNaN(d.yerr) && !(d.ya.type === 'log' && d.yerr <= 0)) {
          var yeText = Axes.tickText(d.ya, d.ya.c2l(d.yerr), 'hover').text;
          if(d.yerrneg !== undefined) {
              d.yLabel += ' +' + yeText + ' / -' +
                  Axes.tickText(d.ya, d.ya.c2l(d.yerrneg), 'hover').text;
          } else d.yLabel += ' ± ' + yeText;
  
          if(hovermode === 'y') d.distance += 1;
      }
  
      var infomode = d.hoverinfo || d.trace.hoverinfo;
  
      if(infomode && infomode !== 'all') {
          infomode = Array.isArray(infomode) ? infomode : infomode.split('+');
          if(infomode.indexOf('x') === -1) d.xLabel = undefined;
          if(infomode.indexOf('y') === -1) d.yLabel = undefined;
          if(infomode.indexOf('z') === -1) d.zLabel = undefined;
          if(infomode.indexOf('text') === -1) d.text = undefined;
          if(infomode.indexOf('name') === -1) d.name = undefined;
      }
  
      return d;
  }
  
  function createSpikelines(gd, closestPoints, opts) {
      var container = opts.container;
      var fullLayout = opts.fullLayout;
      var gs = fullLayout._size;
      var evt = opts.event;
      var showY = !!closestPoints.hLinePoint;
      var showX = !!closestPoints.vLinePoint;
  
      var xa, ya;
  
      // Remove old spikeline items
      container.selectAll('.spikeline').remove();
  
      if(!(showX || showY)) return;
  
      var contrastColor = Color.combine(fullLayout.plot_bgcolor, fullLayout.paper_bgcolor);
  
      // Horizontal line (to y-axis)
      if(showY) {
          var hLinePoint = closestPoints.hLinePoint;
          var hLinePointX, hLinePointY;
  
          xa = hLinePoint && hLinePoint.xa;
          ya = hLinePoint && hLinePoint.ya;
          var ySnap = ya.spikesnap;
  
          if(ySnap === 'cursor') {
              hLinePointX = evt.pointerX;
              hLinePointY = evt.pointerY;
          } else {
              hLinePointX = xa._offset + hLinePoint.x;
              hLinePointY = ya._offset + hLinePoint.y;
          }
          var dfltHLineColor = tinycolor.readability(hLinePoint.color, contrastColor) < 1.5 ?
              Color.contrast(contrastColor) : hLinePoint.color;
          var yMode = ya.spikemode;
          var yThickness = ya.spikethickness;
          var yColor = ya.spikecolor || dfltHLineColor;
          var xEdge = Axes.getPxPosition(gd, ya);
          var xBase, xEndSpike;
  
          if(yMode.indexOf('toaxis') !== -1 || yMode.indexOf('across') !== -1) {
              if(yMode.indexOf('toaxis') !== -1) {
                  xBase = xEdge;
                  xEndSpike = hLinePointX;
              }
              if(yMode.indexOf('across') !== -1) {
                  var xAcross0 = ya._counterDomainMin;
                  var xAcross1 = ya._counterDomainMax;
                  if(ya.anchor === 'free') {
                      xAcross0 = Math.min(xAcross0, ya.position);
                      xAcross1 = Math.max(xAcross1, ya.position);
                  }
                  xBase = gs.l + xAcross0 * gs.w;
                  xEndSpike = gs.l + xAcross1 * gs.w;
              }
  
              // Foreground horizontal line (to y-axis)
              container.insert('line', ':first-child')
                  .attr({
                      x1: xBase,
                      x2: xEndSpike,
                      y1: hLinePointY,
                      y2: hLinePointY,
                      'stroke-width': yThickness,
                      stroke: yColor,
                      'stroke-dasharray': Drawing.dashStyle(ya.spikedash, yThickness)
                  })
                  .classed('spikeline', true)
                  .classed('crisp', true);
  
              // Background horizontal Line (to y-axis)
              container.insert('line', ':first-child')
                  .attr({
                      x1: xBase,
                      x2: xEndSpike,
                      y1: hLinePointY,
                      y2: hLinePointY,
                      'stroke-width': yThickness + 2,
                      stroke: contrastColor
                  })
                  .classed('spikeline', true)
                  .classed('crisp', true);
          }
          // Y axis marker
          if(yMode.indexOf('marker') !== -1) {
              container.insert('circle', ':first-child')
                  .attr({
                      cx: xEdge + (ya.side !== 'right' ? yThickness : -yThickness),
                      cy: hLinePointY,
                      r: yThickness,
                      fill: yColor
                  })
                  .classed('spikeline', true);
          }
      }
  
      if(showX) {
          var vLinePoint = closestPoints.vLinePoint;
          var vLinePointX, vLinePointY;
  
          xa = vLinePoint && vLinePoint.xa;
          ya = vLinePoint && vLinePoint.ya;
          var xSnap = xa.spikesnap;
  
          if(xSnap === 'cursor') {
              vLinePointX = evt.pointerX;
              vLinePointY = evt.pointerY;
          } else {
              vLinePointX = xa._offset + vLinePoint.x;
              vLinePointY = ya._offset + vLinePoint.y;
          }
          var dfltVLineColor = tinycolor.readability(vLinePoint.color, contrastColor) < 1.5 ?
              Color.contrast(contrastColor) : vLinePoint.color;
          var xMode = xa.spikemode;
          var xThickness = xa.spikethickness;
          var xColor = xa.spikecolor || dfltVLineColor;
          var yEdge = Axes.getPxPosition(gd, xa);
          var yBase, yEndSpike;
  
          if(xMode.indexOf('toaxis') !== -1 || xMode.indexOf('across') !== -1) {
              if(xMode.indexOf('toaxis') !== -1) {
                  yBase = yEdge;
                  yEndSpike = vLinePointY;
              }
              if(xMode.indexOf('across') !== -1) {
                  var yAcross0 = xa._counterDomainMin;
                  var yAcross1 = xa._counterDomainMax;
                  if(xa.anchor === 'free') {
                      yAcross0 = Math.min(yAcross0, xa.position);
                      yAcross1 = Math.max(yAcross1, xa.position);
                  }
                  yBase = gs.t + (1 - yAcross1) * gs.h;
                  yEndSpike = gs.t + (1 - yAcross0) * gs.h;
              }
  
              // Foreground vertical line (to x-axis)
              container.insert('line', ':first-child')
                  .attr({
                      x1: vLinePointX,
                      x2: vLinePointX,
                      y1: yBase,
                      y2: yEndSpike,
                      'stroke-width': xThickness,
                      stroke: xColor,
                      'stroke-dasharray': Drawing.dashStyle(xa.spikedash, xThickness)
                  })
                  .classed('spikeline', true)
                  .classed('crisp', true);
  
              // Background vertical line (to x-axis)
              container.insert('line', ':first-child')
                  .attr({
                      x1: vLinePointX,
                      x2: vLinePointX,
                      y1: yBase,
                      y2: yEndSpike,
                      'stroke-width': xThickness + 2,
                      stroke: contrastColor
                  })
                  .classed('spikeline', true)
                  .classed('crisp', true);
          }
  
          // X axis marker
          if(xMode.indexOf('marker') !== -1) {
              container.insert('circle', ':first-child')
                  .attr({
                      cx: vLinePointX,
                      cy: yEdge - (xa.side !== 'top' ? xThickness : -xThickness),
                      r: xThickness,
                      fill: xColor
                  })
                  .classed('spikeline', true);
          }
      }
  }
  
  function hoverChanged(gd, evt, oldhoverdata) {
      // don't emit any events if nothing changed
      if(!oldhoverdata || oldhoverdata.length !== gd._hoverdata.length) return true;
  
      for(var i = oldhoverdata.length - 1; i >= 0; i--) {
          var oldPt = oldhoverdata[i];
          var newPt = gd._hoverdata[i];
  
          if(oldPt.curveNumber !== newPt.curveNumber ||
              String(oldPt.pointNumber) !== String(newPt.pointNumber) ||
              String(oldPt.pointNumbers) !== String(newPt.pointNumbers)
          ) {
              return true;
          }
      }
      return false;
  }
  
  function spikesChanged(gd, oldspikepoints) {
      // don't relayout the plot because of new spikelines if spikelines points didn't change
      if(!oldspikepoints) return true;
      if(oldspikepoints.vLinePoint !== gd._spikepoints.vLinePoint ||
          oldspikepoints.hLinePoint !== gd._spikepoints.hLinePoint
      ) return true;
      return false;
  }
  
  function plainText(s, len) {
      return svgTextUtils.plainText(s || '', {
          len: len,
          allowedTags: ['br', 'sub', 'sup', 'b', 'i', 'em']
      });
  }
  
  },{"../../lib":750,"../../lib/events":739,"../../lib/override_cursor":761,"../../lib/svg_text_utils":774,"../../plots/cartesian/axes":799,"../../registry":882,"../color":615,"../dragelement":634,"../drawing":637,"../legend/defaults":667,"../legend/draw":668,"./constants":649,"./helpers":651,"d3":169,"fast-isnumeric":241,"tinycolor2":548}],653:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../color');
  var isUnifiedHover = _dereq_('./helpers').isUnifiedHover;
  
  module.exports = function handleHoverLabelDefaults(contIn, contOut, coerce, opts) {
      opts = opts || {};
  
      function inheritFontAttr(attr) {
          if(!opts.font[attr]) {
              opts.font[attr] = contOut.legend ? contOut.legend.font[attr] : contOut.font[attr];
          }
      }
  
      // In unified hover, inherit from layout.legend if available or layout
      if(contOut && isUnifiedHover(contOut.hovermode)) {
          if(!opts.font) opts.font = {};
          inheritFontAttr('size');
          inheritFontAttr('family');
          inheritFontAttr('color');
  
          if(contOut.legend) {
              if(!opts.bgcolor) opts.bgcolor = Color.combine(contOut.legend.bgcolor, contOut.paper_bgcolor);
              if(!opts.bordercolor) opts.bordercolor = contOut.legend.bordercolor;
          } else {
              if(!opts.bgcolor) opts.bgcolor = contOut.paper_bgcolor;
          }
      }
  
      coerce('hoverlabel.bgcolor', opts.bgcolor);
      coerce('hoverlabel.bordercolor', opts.bordercolor);
      coerce('hoverlabel.namelength', opts.namelength);
      Lib.coerceFont(coerce, 'hoverlabel.font', opts.font);
      coerce('hoverlabel.align', opts.align);
  };
  
  },{"../../lib":750,"../color":615,"./helpers":651}],654:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  module.exports = function handleHoverModeDefaults(layoutIn, layoutOut, fullData) {
      function coerce(attr, dflt) {
          // don't coerce if it is already coerced in other place e.g. in cartesian defaults
          if(layoutOut[attr] !== undefined) return layoutOut[attr];
  
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
  
      var clickmode = coerce('clickmode');
  
      var hovermodeDflt;
      if(layoutOut._has('cartesian')) {
          if(clickmode.indexOf('select') > -1) {
              hovermodeDflt = 'closest';
          } else {
              // flag for 'horizontal' plots:
              // determines the state of the mode bar 'compare' hovermode button
              layoutOut._isHoriz = isHoriz(fullData, layoutOut);
              hovermodeDflt = layoutOut._isHoriz ? 'y' : 'x';
          }
      } else hovermodeDflt = 'closest';
  
      return coerce('hovermode', hovermodeDflt);
  };
  
  function isHoriz(fullData, fullLayout) {
      var stackOpts = fullLayout._scatterStackOpts || {};
  
      for(var i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
          var subplot = trace.xaxis + trace.yaxis;
          var subplotStackOpts = stackOpts[subplot] || {};
          var groupOpts = subplotStackOpts[trace.stackgroup] || {};
  
          if(trace.orientation !== 'h' && groupOpts.orientation !== 'h') {
              return false;
          }
      }
  
      return true;
  }
  
  },{"../../lib":750,"./layout_attributes":656}],655:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../lib');
  var dragElement = _dereq_('../dragelement');
  var helpers = _dereq_('./helpers');
  var layoutAttributes = _dereq_('./layout_attributes');
  var hoverModule = _dereq_('./hover');
  
  module.exports = {
      moduleType: 'component',
      name: 'fx',
  
      constants: _dereq_('./constants'),
      schema: {
          layout: layoutAttributes
      },
  
      attributes: _dereq_('./attributes'),
      layoutAttributes: layoutAttributes,
  
      supplyLayoutGlobalDefaults: _dereq_('./layout_global_defaults'),
      supplyDefaults: _dereq_('./defaults'),
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
  
      calc: _dereq_('./calc'),
  
      getDistanceFunction: helpers.getDistanceFunction,
      getClosest: helpers.getClosest,
      inbox: helpers.inbox,
      quadrature: helpers.quadrature,
      appendArrayPointValue: helpers.appendArrayPointValue,
  
      castHoverOption: castHoverOption,
      castHoverinfo: castHoverinfo,
  
      hover: hoverModule.hover,
      unhover: dragElement.unhover,
  
      loneHover: hoverModule.loneHover,
      loneUnhover: loneUnhover,
  
      click: _dereq_('./click')
  };
  
  function loneUnhover(containerOrSelection) {
      // duck type whether the arg is a d3 selection because ie9 doesn't
      // handle instanceof like modern browsers do.
      var selection = Lib.isD3Selection(containerOrSelection) ?
              containerOrSelection :
              d3.select(containerOrSelection);
  
      selection.selectAll('g.hovertext').remove();
      selection.selectAll('.spikeline').remove();
  }
  
  // helpers for traces that use Fx.loneHover
  
  function castHoverOption(trace, ptNumber, attr) {
      return Lib.castOption(trace, ptNumber, 'hoverlabel.' + attr);
  }
  
  function castHoverinfo(trace, fullLayout, ptNumber) {
      function _coerce(val) {
          return Lib.coerceHoverinfo({hoverinfo: val}, {_module: trace._module}, fullLayout);
      }
  
      return Lib.castOption(trace, ptNumber, 'hoverinfo', _coerce);
  }
  
  },{"../../lib":750,"../dragelement":634,"./attributes":646,"./calc":647,"./click":648,"./constants":649,"./defaults":650,"./helpers":651,"./hover":652,"./layout_attributes":656,"./layout_defaults":657,"./layout_global_defaults":658,"d3":169}],656:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var constants = _dereq_('./constants');
  
  var fontAttrs = _dereq_('../../plots/font_attributes')({
      editType: 'none',
      
  });
  fontAttrs.family.dflt = constants.HOVERFONT;
  fontAttrs.size.dflt = constants.HOVERFONTSIZE;
  
  module.exports = {
      clickmode: {
          valType: 'flaglist',
          
          flags: ['event', 'select'],
          dflt: 'event',
          editType: 'plot',
          extras: ['none'],
          
      },
      dragmode: {
          valType: 'enumerated',
          
          values: [
              'zoom',
              'pan',
              'select',
              'lasso',
              'drawclosedpath',
              'drawopenpath',
              'drawline',
              'drawrect',
              'drawcircle',
              'orbit',
              'turntable',
              false
          ],
          dflt: 'zoom',
          editType: 'modebar',
          
      },
      hovermode: {
          valType: 'enumerated',
          
          values: ['x', 'y', 'closest', false, 'x unified', 'y unified'],
          editType: 'modebar',
          
      },
      hoverdistance: {
          valType: 'integer',
          min: -1,
          dflt: 20,
          
          editType: 'none',
          
      },
      spikedistance: {
          valType: 'integer',
          min: -1,
          dflt: 20,
          
          editType: 'none',
          
      },
      hoverlabel: {
          bgcolor: {
              valType: 'color',
              
              editType: 'none',
              
          },
          bordercolor: {
              valType: 'color',
              
              editType: 'none',
              
          },
          font: fontAttrs,
          align: {
              valType: 'enumerated',
              values: ['left', 'right', 'auto'],
              dflt: 'auto',
              
              editType: 'none',
              
          },
          namelength: {
              valType: 'integer',
              min: -1,
              dflt: 15,
              
              editType: 'none',
              
          },
          editType: 'none'
      },
      selectdirection: {
          valType: 'enumerated',
          
          values: ['h', 'v', 'd', 'any'],
          dflt: 'any',
          
          editType: 'none'
      }
  };
  
  },{"../../plots/font_attributes":827,"./constants":649}],657:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var isUnifiedHover = _dereq_('./helpers').isUnifiedHover;
  var layoutAttributes = _dereq_('./layout_attributes');
  var handleHoverModeDefaults = _dereq_('./hovermode_defaults');
  var handleHoverLabelDefaults = _dereq_('./hoverlabel_defaults');
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
  
      var hoverMode = handleHoverModeDefaults(layoutIn, layoutOut, fullData);
      if(hoverMode) {
          coerce('hoverdistance');
          coerce('spikedistance', isUnifiedHover(hoverMode) ? -1 : undefined);
      }
  
      var dragMode = coerce('dragmode');
      if(dragMode === 'select') coerce('selectdirection');
  
      // if only mapbox or geo subplots is present on graph,
      // reset 'zoom' dragmode to 'pan' until 'zoom' is implemented,
      // so that the correct modebar button is active
      var hasMapbox = layoutOut._has('mapbox');
      var hasGeo = layoutOut._has('geo');
      var len = layoutOut._basePlotModules.length;
  
      if(layoutOut.dragmode === 'zoom' && (
          ((hasMapbox || hasGeo) && len === 1) ||
          (hasMapbox && hasGeo && len === 2)
      )) {
          layoutOut.dragmode = 'pan';
      }
  
      handleHoverLabelDefaults(layoutIn, layoutOut, coerce);
  };
  
  },{"../../lib":750,"./helpers":651,"./hoverlabel_defaults":653,"./hovermode_defaults":654,"./layout_attributes":656}],658:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var handleHoverLabelDefaults = _dereq_('./hoverlabel_defaults');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  module.exports = function supplyLayoutGlobalDefaults(layoutIn, layoutOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
  
      handleHoverLabelDefaults(layoutIn, layoutOut, coerce);
  };
  
  },{"../../lib":750,"./hoverlabel_defaults":653,"./layout_attributes":656}],659:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var counterRegex = _dereq_('../../lib/regex').counter;
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  var cartesianIdRegex = _dereq_('../../plots/cartesian/constants').idRegex;
  var Template = _dereq_('../../plot_api/plot_template');
  
  var gridAttrs = {
      rows: {
          valType: 'integer',
          min: 1,
          
          editType: 'plot',
          
      },
      roworder: {
          valType: 'enumerated',
          values: ['top to bottom', 'bottom to top'],
          dflt: 'top to bottom',
          
          editType: 'plot',
          
      },
      columns: {
          valType: 'integer',
          min: 1,
          
          editType: 'plot',
          
      },
      subplots: {
          valType: 'info_array',
          freeLength: true,
          dimensions: 2,
          items: {valType: 'enumerated', values: [counterRegex('xy').toString(), ''], editType: 'plot'},
          
          editType: 'plot',
          
      },
      xaxes: {
          valType: 'info_array',
          freeLength: true,
          items: {valType: 'enumerated', values: [cartesianIdRegex.x.toString(), ''], editType: 'plot'},
          
          editType: 'plot',
          
      },
      yaxes: {
          valType: 'info_array',
          freeLength: true,
          items: {valType: 'enumerated', values: [cartesianIdRegex.y.toString(), ''], editType: 'plot'},
          
          editType: 'plot',
          
      },
      pattern: {
          valType: 'enumerated',
          values: ['independent', 'coupled'],
          dflt: 'coupled',
          
          editType: 'plot',
          
      },
      xgap: {
          valType: 'number',
          min: 0,
          max: 1,
          
          editType: 'plot',
          
      },
      ygap: {
          valType: 'number',
          min: 0,
          max: 1,
          
          editType: 'plot',
          
      },
      domain: domainAttrs({name: 'grid', editType: 'plot', noGridCell: true}, {
          
      }),
      xside: {
          valType: 'enumerated',
          values: ['bottom', 'bottom plot', 'top plot', 'top'],
          dflt: 'bottom plot',
          
          editType: 'plot',
          
      },
      yside: {
          valType: 'enumerated',
          values: ['left', 'left plot', 'right plot', 'right'],
          dflt: 'left plot',
          
          editType: 'plot',
          
      },
      editType: 'plot'
  };
  
  function getAxes(layout, grid, axLetter) {
      var gridVal = grid[axLetter + 'axes'];
      var splomVal = Object.keys((layout._splomAxes || {})[axLetter] || {});
  
      if(Array.isArray(gridVal)) return gridVal;
      if(splomVal.length) return splomVal;
  }
  
  // the shape of the grid - this needs to be done BEFORE supplyDataDefaults
  // so that non-subplot traces can place themselves in the grid
  function sizeDefaults(layoutIn, layoutOut) {
      var gridIn = layoutIn.grid || {};
      var xAxes = getAxes(layoutOut, gridIn, 'x');
      var yAxes = getAxes(layoutOut, gridIn, 'y');
  
      if(!layoutIn.grid && !xAxes && !yAxes) return;
  
      var hasSubplotGrid = Array.isArray(gridIn.subplots) && Array.isArray(gridIn.subplots[0]);
      var hasXaxes = Array.isArray(xAxes);
      var hasYaxes = Array.isArray(yAxes);
      var isSplomGenerated = (
          hasXaxes && xAxes !== gridIn.xaxes &&
          hasYaxes && yAxes !== gridIn.yaxes
      );
  
      var dfltRows, dfltColumns;
  
      if(hasSubplotGrid) {
          dfltRows = gridIn.subplots.length;
          dfltColumns = gridIn.subplots[0].length;
      } else {
          if(hasYaxes) dfltRows = yAxes.length;
          if(hasXaxes) dfltColumns = xAxes.length;
      }
  
      var gridOut = Template.newContainer(layoutOut, 'grid');
  
      function coerce(attr, dflt) {
          return Lib.coerce(gridIn, gridOut, gridAttrs, attr, dflt);
      }
  
      var rows = coerce('rows', dfltRows);
      var columns = coerce('columns', dfltColumns);
  
      if(!(rows * columns > 1)) {
          delete layoutOut.grid;
          return;
      }
  
      if(!hasSubplotGrid && !hasXaxes && !hasYaxes) {
          var useDefaultSubplots = coerce('pattern') === 'independent';
          if(useDefaultSubplots) hasSubplotGrid = true;
      }
      gridOut._hasSubplotGrid = hasSubplotGrid;
  
      var rowOrder = coerce('roworder');
      var reversed = rowOrder === 'top to bottom';
  
      var dfltGapX = hasSubplotGrid ? 0.2 : 0.1;
      var dfltGapY = hasSubplotGrid ? 0.3 : 0.1;
  
      var dfltSideX, dfltSideY;
      if(isSplomGenerated && layoutOut._splomGridDflt) {
          dfltSideX = layoutOut._splomGridDflt.xside;
          dfltSideY = layoutOut._splomGridDflt.yside;
      }
  
      gridOut._domains = {
          x: fillGridPositions('x', coerce, dfltGapX, dfltSideX, columns),
          y: fillGridPositions('y', coerce, dfltGapY, dfltSideY, rows, reversed)
      };
  }
  
  // coerce x or y sizing attributes and return an array of domains for this direction
  function fillGridPositions(axLetter, coerce, dfltGap, dfltSide, len, reversed) {
      var dirGap = coerce(axLetter + 'gap', dfltGap);
      var domain = coerce('domain.' + axLetter);
      coerce(axLetter + 'side', dfltSide);
  
      var out = new Array(len);
      var start = domain[0];
      var step = (domain[1] - start) / (len - dirGap);
      var cellDomain = step * (1 - dirGap);
      for(var i = 0; i < len; i++) {
          var cellStart = start + step * i;
          out[reversed ? (len - 1 - i) : i] = [cellStart, cellStart + cellDomain];
      }
      return out;
  }
  
  // the (cartesian) contents of the grid - this needs to happen AFTER supplyDataDefaults
  // so that we know what cartesian subplots are available
  function contentDefaults(layoutIn, layoutOut) {
      var gridOut = layoutOut.grid;
      // make sure we got to the end of handleGridSizing
      if(!gridOut || !gridOut._domains) return;
  
      var gridIn = layoutIn.grid || {};
      var subplots = layoutOut._subplots;
      var hasSubplotGrid = gridOut._hasSubplotGrid;
      var rows = gridOut.rows;
      var columns = gridOut.columns;
      var useDefaultSubplots = gridOut.pattern === 'independent';
  
      var i, j, xId, yId, subplotId, subplotsOut, yPos;
  
      var axisMap = gridOut._axisMap = {};
  
      if(hasSubplotGrid) {
          var subplotsIn = gridIn.subplots || [];
          subplotsOut = gridOut.subplots = new Array(rows);
          var index = 1;
  
          for(i = 0; i < rows; i++) {
              var rowOut = subplotsOut[i] = new Array(columns);
              var rowIn = subplotsIn[i] || [];
              for(j = 0; j < columns; j++) {
                  if(useDefaultSubplots) {
                      subplotId = (index === 1) ? 'xy' : ('x' + index + 'y' + index);
                      index++;
                  } else subplotId = rowIn[j];
  
                  rowOut[j] = '';
  
                  if(subplots.cartesian.indexOf(subplotId) !== -1) {
                      yPos = subplotId.indexOf('y');
                      xId = subplotId.slice(0, yPos);
                      yId = subplotId.slice(yPos);
                      if((axisMap[xId] !== undefined && axisMap[xId] !== j) ||
                          (axisMap[yId] !== undefined && axisMap[yId] !== i)
                      ) {
                          continue;
                      }
  
                      rowOut[j] = subplotId;
                      axisMap[xId] = j;
                      axisMap[yId] = i;
                  }
              }
          }
      } else {
          var xAxes = getAxes(layoutOut, gridIn, 'x');
          var yAxes = getAxes(layoutOut, gridIn, 'y');
          gridOut.xaxes = fillGridAxes(xAxes, subplots.xaxis, columns, axisMap, 'x');
          gridOut.yaxes = fillGridAxes(yAxes, subplots.yaxis, rows, axisMap, 'y');
      }
  
      var anchors = gridOut._anchors = {};
      var reversed = gridOut.roworder === 'top to bottom';
  
      for(var axisId in axisMap) {
          var axLetter = axisId.charAt(0);
          var side = gridOut[axLetter + 'side'];
  
          var i0, inc, iFinal;
  
          if(side.length < 8) {
              // grid edge -  ie not "* plot" - make these as free axes
              // since we're not guaranteed to have a subplot there at all
              anchors[axisId] = 'free';
          } else if(axLetter === 'x') {
              if((side.charAt(0) === 't') === reversed) {
                  i0 = 0;
                  inc = 1;
                  iFinal = rows;
              } else {
                  i0 = rows - 1;
                  inc = -1;
                  iFinal = -1;
              }
              if(hasSubplotGrid) {
                  var column = axisMap[axisId];
                  for(i = i0; i !== iFinal; i += inc) {
                      subplotId = subplotsOut[i][column];
                      if(!subplotId) continue;
                      yPos = subplotId.indexOf('y');
                      if(subplotId.slice(0, yPos) === axisId) {
                          anchors[axisId] = subplotId.slice(yPos);
                          break;
                      }
                  }
              } else {
                  for(i = i0; i !== iFinal; i += inc) {
                      yId = gridOut.yaxes[i];
                      if(subplots.cartesian.indexOf(axisId + yId) !== -1) {
                          anchors[axisId] = yId;
                          break;
                      }
                  }
              }
          } else {
              if((side.charAt(0) === 'l')) {
                  i0 = 0;
                  inc = 1;
                  iFinal = columns;
              } else {
                  i0 = columns - 1;
                  inc = -1;
                  iFinal = -1;
              }
              if(hasSubplotGrid) {
                  var row = axisMap[axisId];
                  for(i = i0; i !== iFinal; i += inc) {
                      subplotId = subplotsOut[row][i];
                      if(!subplotId) continue;
                      yPos = subplotId.indexOf('y');
                      if(subplotId.slice(yPos) === axisId) {
                          anchors[axisId] = subplotId.slice(0, yPos);
                          break;
                      }
                  }
              } else {
                  for(i = i0; i !== iFinal; i += inc) {
                      xId = gridOut.xaxes[i];
                      if(subplots.cartesian.indexOf(xId + axisId) !== -1) {
                          anchors[axisId] = xId;
                          break;
                      }
                  }
              }
          }
      }
  }
  
  function fillGridAxes(axesIn, axesAllowed, len, axisMap, axLetter) {
      var out = new Array(len);
      var i;
  
      function fillOneAxis(i, axisId) {
          if(axesAllowed.indexOf(axisId) !== -1 && axisMap[axisId] === undefined) {
              out[i] = axisId;
              axisMap[axisId] = i;
          } else out[i] = '';
      }
  
      if(Array.isArray(axesIn)) {
          for(i = 0; i < len; i++) {
              fillOneAxis(i, axesIn[i]);
          }
      } else {
          // default axis list is the first `len` axis ids
          fillOneAxis(0, axLetter);
          for(i = 1; i < len; i++) {
              fillOneAxis(i, axLetter + (i + 1));
          }
      }
  
      return out;
  }
  
  module.exports = {
      moduleType: 'component',
      name: 'grid',
  
      schema: {
          layout: {grid: gridAttrs}
      },
  
      layoutAttributes: gridAttrs,
      sizeDefaults: sizeDefaults,
      contentDefaults: contentDefaults
  };
  
  },{"../../lib":750,"../../lib/regex":766,"../../plot_api/plot_template":788,"../../plots/cartesian/constants":805,"../../plots/domain":826}],660:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var cartesianConstants = _dereq_('../../plots/cartesian/constants');
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  var axisPlaceableObjs = _dereq_('../../constants/axis_placeable_objects');
  
  
  module.exports = templatedArray('image', {
      visible: {
          valType: 'boolean',
          
          dflt: true,
          editType: 'arraydraw',
          
      },
  
      source: {
          valType: 'string',
          
          editType: 'arraydraw',
          
      },
  
      layer: {
          valType: 'enumerated',
          values: ['below', 'above'],
          dflt: 'above',
          
          editType: 'arraydraw',
          
      },
  
      sizex: {
          valType: 'number',
          
          dflt: 0,
          editType: 'arraydraw',
          
      },
  
      sizey: {
          valType: 'number',
          
          dflt: 0,
          editType: 'arraydraw',
          
      },
  
      sizing: {
          valType: 'enumerated',
          values: ['fill', 'contain', 'stretch'],
          dflt: 'contain',
          
          editType: 'arraydraw',
          
      },
  
      opacity: {
          valType: 'number',
          
          min: 0,
          max: 1,
          dflt: 1,
          editType: 'arraydraw',
          
      },
  
      x: {
          valType: 'any',
          
          dflt: 0,
          editType: 'arraydraw',
          
      },
  
      y: {
          valType: 'any',
          
          dflt: 0,
          editType: 'arraydraw',
          
      },
  
      xanchor: {
          valType: 'enumerated',
          values: ['left', 'center', 'right'],
          dflt: 'left',
          
          editType: 'arraydraw',
          
      },
  
      yanchor: {
          valType: 'enumerated',
          values: ['top', 'middle', 'bottom'],
          dflt: 'top',
          
          editType: 'arraydraw',
          
      },
  
      xref: {
          valType: 'enumerated',
          values: [
              'paper',
              cartesianConstants.idRegex.x.toString()
          ],
          dflt: 'paper',
          
          editType: 'arraydraw',
          
      },
  
      yref: {
          valType: 'enumerated',
          values: [
              'paper',
              cartesianConstants.idRegex.y.toString()
          ],
          dflt: 'paper',
          
          editType: 'arraydraw',
          
      },
      editType: 'arraydraw'
  });
  
  },{"../../constants/axis_placeable_objects":718,"../../plot_api/plot_template":788,"../../plots/cartesian/constants":805}],661:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var toLogRange = _dereq_('../../lib/to_log_range');
  
  /*
   * convertCoords: when converting an axis between log and linear
   * you need to alter any images on that axis to keep them
   * pointing at the same data point.
   * In v2.0 this will become obsolete (or perhaps size will still need conversion?)
   * we convert size by declaring that the maximum extent *in data units* should be
   * the same, assuming the image is anchored by its center (could remove that restriction
   * if we think it's important) even though the actual left and right values will not be
   * quite the same since the scale becomes nonlinear (and central anchor means the pixel
   * center of the image, not the data units center)
   *
   * gd: the plot div
   * ax: the axis being changed
   * newType: the type it's getting
   * doExtra: function(attr, val) from inside relayout that sets the attribute.
   *     Use this to make the changes as it's aware if any other changes in the
   *     same relayout call should override this conversion.
   */
  module.exports = function convertCoords(gd, ax, newType, doExtra) {
      ax = ax || {};
  
      var toLog = (newType === 'log') && (ax.type === 'linear');
      var fromLog = (newType === 'linear') && (ax.type === 'log');
  
      if(!(toLog || fromLog)) return;
  
      var images = gd._fullLayout.images;
      var axLetter = ax._id.charAt(0);
      var image;
      var attrPrefix;
  
      for(var i = 0; i < images.length; i++) {
          image = images[i];
          attrPrefix = 'images[' + i + '].';
  
          if(image[axLetter + 'ref'] === ax._id) {
              var currentPos = image[axLetter];
              var currentSize = image['size' + axLetter];
              var newPos = null;
              var newSize = null;
  
              if(toLog) {
                  newPos = toLogRange(currentPos, ax.range);
  
                  // this is the inverse of the conversion we do in fromLog below
                  // so that the conversion is reversible (notice the fromLog conversion
                  // is like sinh, and this one looks like arcsinh)
                  var dx = currentSize / Math.pow(10, newPos) / 2;
                  newSize = 2 * Math.log(dx + Math.sqrt(1 + dx * dx)) / Math.LN10;
              } else {
                  newPos = Math.pow(10, currentPos);
                  newSize = newPos * (Math.pow(10, currentSize / 2) - Math.pow(10, -currentSize / 2));
              }
  
              // if conversion failed, delete the value so it can get a default later on
              if(!isNumeric(newPos)) {
                  newPos = null;
                  newSize = null;
              } else if(!isNumeric(newSize)) newSize = null;
  
              doExtra(attrPrefix + axLetter, newPos);
              doExtra(attrPrefix + 'size' + axLetter, newSize);
          }
      }
  };
  
  },{"../../lib/to_log_range":776,"fast-isnumeric":241}],662:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  
  var attributes = _dereq_('./attributes');
  var name = 'images';
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
      var opts = {
          name: name,
          handleItemDefaults: imageDefaults
      };
  
      handleArrayContainerDefaults(layoutIn, layoutOut, opts);
  };
  
  
  function imageDefaults(imageIn, imageOut, fullLayout) {
      function coerce(attr, dflt) {
          return Lib.coerce(imageIn, imageOut, attributes, attr, dflt);
      }
  
      var source = coerce('source');
      var visible = coerce('visible', !!source);
  
      if(!visible) return imageOut;
  
      coerce('layer');
      coerce('xanchor');
      coerce('yanchor');
      coerce('sizex');
      coerce('sizey');
      coerce('sizing');
      coerce('opacity');
  
      var gdMock = { _fullLayout: fullLayout };
      var axLetters = ['x', 'y'];
  
      for(var i = 0; i < 2; i++) {
          // 'paper' is the fallback axref
          var axLetter = axLetters[i];
          var axRef = Axes.coerceRef(imageIn, imageOut, gdMock, axLetter, 'paper', undefined);
  
          if(axRef !== 'paper') {
              var ax = Axes.getFromId(gdMock, axRef);
              ax._imgIndices.push(imageOut._index);
          }
  
          Axes.coercePosition(imageOut, gdMock, coerce, axRef, axLetter, 0);
      }
  
      return imageOut;
  }
  
  },{"../../lib":750,"../../plots/array_container_defaults":794,"../../plots/cartesian/axes":799,"./attributes":660}],663:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Drawing = _dereq_('../drawing');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var axisIds = _dereq_('../../plots/cartesian/axis_ids');
  var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
  
  module.exports = function draw(gd) {
      var fullLayout = gd._fullLayout;
      var imageDataAbove = [];
      var imageDataSubplot = {};
      var imageDataBelow = [];
      var subplot;
      var i;
  
      // Sort into top, subplot, and bottom layers
      for(i = 0; i < fullLayout.images.length; i++) {
          var img = fullLayout.images[i];
  
          if(img.visible) {
              if(img.layer === 'below' && img.xref !== 'paper' && img.yref !== 'paper') {
                  subplot = axisIds.ref2id(img.xref) + axisIds.ref2id(img.yref);
  
                  var plotinfo = fullLayout._plots[subplot];
  
                  if(!plotinfo) {
                      // Fall back to _imageLowerLayer in case the requested subplot doesn't exist.
                      // This can happen if you reference the image to an x / y axis combination
                      // that doesn't have any data on it (and layer is below)
                      imageDataBelow.push(img);
                      continue;
                  }
  
                  if(plotinfo.mainplot) {
                      subplot = plotinfo.mainplot.id;
                  }
  
                  if(!imageDataSubplot[subplot]) {
                      imageDataSubplot[subplot] = [];
                  }
                  imageDataSubplot[subplot].push(img);
              } else if(img.layer === 'above') {
                  imageDataAbove.push(img);
              } else {
                  imageDataBelow.push(img);
              }
          }
      }
  
  
      var anchors = {
          x: {
              left: { sizing: 'xMin', offset: 0 },
              center: { sizing: 'xMid', offset: -1 / 2 },
              right: { sizing: 'xMax', offset: -1 }
          },
          y: {
              top: { sizing: 'YMin', offset: 0 },
              middle: { sizing: 'YMid', offset: -1 / 2 },
              bottom: { sizing: 'YMax', offset: -1 }
          }
      };
  
  
      // Images must be converted to dataURL's for exporting.
      function setImage(d) {
          var thisImage = d3.select(this);
  
          if(this._imgSrc === d.source) {
              return;
          }
  
          thisImage.attr('xmlns', xmlnsNamespaces.svg);
  
          if(d.source && d.source.slice(0, 5) === 'data:') {
              thisImage.attr('xlink:href', d.source);
              this._imgSrc = d.source;
          } else {
              var imagePromise = new Promise(function(resolve) {
                  var img = new Image();
                  this.img = img;
  
                  // If not set, a `tainted canvas` error is thrown
                  img.setAttribute('crossOrigin', 'anonymous');
                  img.onerror = errorHandler;
                  img.onload = function() {
                      var canvas = document.createElement('canvas');
                      canvas.width = this.width;
                      canvas.height = this.height;
  
                      var ctx = canvas.getContext('2d');
                      ctx.drawImage(this, 0, 0);
  
                      var dataURL = canvas.toDataURL('image/png');
  
                      thisImage.attr('xlink:href', dataURL);
  
                      // resolve promise in onload handler instead of on 'load' to support IE11
                      // see https://github.com/plotly/plotly.js/issues/1685
                      // for more details
                      resolve();
                  };
  
                  thisImage.on('error', errorHandler);
  
                  img.src = d.source;
                  this._imgSrc = d.source;
  
                  function errorHandler() {
                      thisImage.remove();
                      resolve();
                  }
              }.bind(this));
  
              gd._promises.push(imagePromise);
          }
      }
  
      function applyAttributes(d) {
          var thisImage = d3.select(this);
  
          // Axes if specified
          var xa = Axes.getFromId(gd, d.xref);
          var ya = Axes.getFromId(gd, d.yref);
          var xIsDomain = Axes.getRefType(d.xref) === 'domain';
          var yIsDomain = Axes.getRefType(d.yref) === 'domain';
  
          var size = fullLayout._size;
          var width, height;
          if(xa !== undefined) {
              width = ((typeof(d.xref) === 'string') && xIsDomain) ?
                  xa._length * d.sizex :
                  Math.abs(xa.l2p(d.sizex) - xa.l2p(0));
          } else {
              width = d.sizex * size.w;
          }
          if(ya !== undefined) {
              height = ((typeof(d.yref) === 'string') && yIsDomain) ?
                  ya._length * d.sizey :
                  Math.abs(ya.l2p(d.sizey) - ya.l2p(0));
          } else {
              height = d.sizey * size.h;
          }
  
          // Offsets for anchor positioning
          var xOffset = width * anchors.x[d.xanchor].offset;
          var yOffset = height * anchors.y[d.yanchor].offset;
  
          var sizing = anchors.x[d.xanchor].sizing + anchors.y[d.yanchor].sizing;
  
          // Final positions
          var xPos, yPos;
          if(xa !== undefined) {
              xPos = ((typeof(d.xref) === 'string') && xIsDomain) ?
                  xa._length * d.x + xa._offset :
                  xa.r2p(d.x) + xa._offset;
          } else {
              xPos = d.x * size.w + size.l;
          }
          xPos += xOffset;
          if(ya !== undefined) {
              yPos = ((typeof(d.yref) === 'string') && yIsDomain) ?
                  // consistent with "paper" yref value, where positive values
                  // move up the page
                  ya._length * (1 - d.y) + ya._offset :
                  ya.r2p(d.y) + ya._offset;
          } else {
              yPos = size.h - d.y * size.h + size.t;
          }
          yPos += yOffset;
  
          // Construct the proper aspectRatio attribute
          switch(d.sizing) {
              case 'fill':
                  sizing += ' slice';
                  break;
  
              case 'stretch':
                  sizing = 'none';
                  break;
          }
  
          thisImage.attr({
              x: xPos,
              y: yPos,
              width: width,
              height: height,
              preserveAspectRatio: sizing,
              opacity: d.opacity
          });
  
  
          // Set proper clipping on images
          var xId = xa && (Axes.getRefType(d.xref) !== 'domain') ? xa._id : '';
          var yId = ya && (Axes.getRefType(d.yref) !== 'domain') ? ya._id : '';
          var clipAxes = xId + yId;
  
          Drawing.setClipUrl(
              thisImage,
              clipAxes ? ('clip' + fullLayout._uid + clipAxes) : null,
              gd
          );
      }
  
      var imagesBelow = fullLayout._imageLowerLayer.selectAll('image')
          .data(imageDataBelow);
      var imagesAbove = fullLayout._imageUpperLayer.selectAll('image')
          .data(imageDataAbove);
  
      imagesBelow.enter().append('image');
      imagesAbove.enter().append('image');
  
      imagesBelow.exit().remove();
      imagesAbove.exit().remove();
  
      imagesBelow.each(function(d) {
          setImage.bind(this)(d);
          applyAttributes.bind(this)(d);
      });
      imagesAbove.each(function(d) {
          setImage.bind(this)(d);
          applyAttributes.bind(this)(d);
      });
  
      var allSubplots = Object.keys(fullLayout._plots);
      for(i = 0; i < allSubplots.length; i++) {
          subplot = allSubplots[i];
          var subplotObj = fullLayout._plots[subplot];
  
          // filter out overlaid plots (which havd their images on the main plot)
          // and gl2d plots (which don't support below images, at least not yet)
          if(!subplotObj.imagelayer) continue;
  
          var imagesOnSubplot = subplotObj.imagelayer.selectAll('image')
              // even if there are no images on this subplot, we need to run
              // enter and exit in case there were previously
              .data(imageDataSubplot[subplot] || []);
  
          imagesOnSubplot.enter().append('image');
          imagesOnSubplot.exit().remove();
  
          imagesOnSubplot.each(function(d) {
              setImage.bind(this)(d);
              applyAttributes.bind(this)(d);
          });
      }
  };
  
  },{"../../constants/xmlns_namespaces":726,"../../plots/cartesian/axes":799,"../../plots/cartesian/axis_ids":802,"../drawing":637,"d3":169}],664:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'component',
      name: 'images',
  
      layoutAttributes: _dereq_('./attributes'),
      supplyLayoutDefaults: _dereq_('./defaults'),
      includeBasePlot: _dereq_('../../plots/cartesian/include_components')('images'),
  
      draw: _dereq_('./draw'),
  
      convertCoords: _dereq_('./convert_coords')
  };
  
  },{"../../plots/cartesian/include_components":811,"./attributes":660,"./convert_coords":661,"./defaults":662,"./draw":663}],665:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var colorAttrs = _dereq_('../color/attributes');
  
  
  module.exports = {
      bgcolor: {
          valType: 'color',
          
          editType: 'legend',
          
      },
      bordercolor: {
          valType: 'color',
          dflt: colorAttrs.defaultLine,
          
          editType: 'legend',
          
      },
      borderwidth: {
          valType: 'number',
          min: 0,
          dflt: 0,
          
          editType: 'legend',
          
      },
      font: fontAttrs({
          editType: 'legend',
          
      }),
      orientation: {
          valType: 'enumerated',
          values: ['v', 'h'],
          dflt: 'v',
          
          editType: 'legend',
          
      },
      traceorder: {
          valType: 'flaglist',
          flags: ['reversed', 'grouped'],
          extras: ['normal'],
          
          editType: 'legend',
          
      },
      tracegroupgap: {
          valType: 'number',
          min: 0,
          dflt: 10,
          
          editType: 'legend',
          
      },
      itemsizing: {
          valType: 'enumerated',
          values: ['trace', 'constant'],
          dflt: 'trace',
          
          editType: 'legend',
          
      },
  
      itemclick: {
          valType: 'enumerated',
          values: ['toggle', 'toggleothers', false],
          dflt: 'toggle',
          
          editType: 'legend',
          
      },
      itemdoubleclick: {
          valType: 'enumerated',
          values: ['toggle', 'toggleothers', false],
          dflt: 'toggleothers',
          
          editType: 'legend',
          
      },
  
      x: {
          valType: 'number',
          min: -2,
          max: 3,
          
          editType: 'legend',
          
      },
      xanchor: {
          valType: 'enumerated',
          values: ['auto', 'left', 'center', 'right'],
          dflt: 'left',
          
          editType: 'legend',
          
      },
      y: {
          valType: 'number',
          min: -2,
          max: 3,
          
          editType: 'legend',
          
      },
      yanchor: {
          valType: 'enumerated',
          values: ['auto', 'top', 'middle', 'bottom'],
          
          editType: 'legend',
          
      },
      uirevision: {
          valType: 'any',
          
          editType: 'none',
          
      },
      valign: {
          valType: 'enumerated',
          values: ['top', 'middle', 'bottom'],
          dflt: 'middle',
          
          editType: 'legend',
          
      },
      title: {
          text: {
              valType: 'string',
              dflt: '',
              
              editType: 'legend',
              
          },
          font: fontAttrs({
              editType: 'legend',
              
          }),
          side: {
              valType: 'enumerated',
              values: ['top', 'left', 'top left'],
              
              editType: 'legend',
              
          },
          editType: 'legend',
      },
  
      editType: 'legend'
  };
  
  },{"../../plots/font_attributes":827,"../color/attributes":614}],666:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      scrollBarWidth: 6,
      scrollBarMinHeight: 20,
      scrollBarColor: '#808BA4',
      scrollBarMargin: 4,
      scrollBarEnterAttrs: {rx: 20, ry: 3, width: 0, height: 0},
  
      // number of px between legend title and (left) side of legend (always in x direction and from inner border)
      titlePad: 2,
      // number of px between legend symbol and legend text (always in x direction)
      textGap: 40,
      // number of px between each legend item (x and/or y direction)
      itemGap: 5
  };
  
  },{}],667:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Template = _dereq_('../../plot_api/plot_template');
  
  var attributes = _dereq_('./attributes');
  var basePlotLayoutAttributes = _dereq_('../../plots/layout_attributes');
  var helpers = _dereq_('./helpers');
  
  
  module.exports = function legendDefaults(layoutIn, layoutOut, fullData) {
      var containerIn = layoutIn.legend || {};
  
      var legendTraceCount = 0;
      var legendReallyHasATrace = false;
      var defaultOrder = 'normal';
  
      for(var i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
  
          if(!trace.visible) continue;
  
          // Note that we explicitly count any trace that is either shown or
          // *would* be shown by default, toward the two traces you need to
          // ensure the legend is shown by default, because this can still help
          // disambiguate.
          if(trace.showlegend || (
              trace._dfltShowLegend && !(
                  trace._module &&
                  trace._module.attributes &&
                  trace._module.attributes.showlegend &&
                  trace._module.attributes.showlegend.dflt === false
              )
          )) {
              legendTraceCount++;
              if(trace.showlegend) {
                  legendReallyHasATrace = true;
                  // Always show the legend by default if there's a pie,
                  // or if there's only one trace but it's explicitly shown
                  if(Registry.traceIs(trace, 'pie-like') ||
                      trace._input.showlegend === true
                  ) {
                      legendTraceCount++;
                  }
              }
          }
  
          if((Registry.traceIs(trace, 'bar') && layoutOut.barmode === 'stack') ||
                  ['tonextx', 'tonexty'].indexOf(trace.fill) !== -1) {
              defaultOrder = helpers.isGrouped({traceorder: defaultOrder}) ?
                  'grouped+reversed' : 'reversed';
          }
  
          if(trace.legendgroup !== undefined && trace.legendgroup !== '') {
              defaultOrder = helpers.isReversed({traceorder: defaultOrder}) ?
                  'reversed+grouped' : 'grouped';
          }
      }
  
      var showLegend = Lib.coerce(layoutIn, layoutOut,
          basePlotLayoutAttributes, 'showlegend',
          legendReallyHasATrace && legendTraceCount > 1);
  
      if(showLegend === false && !containerIn.uirevision) return;
  
      var containerOut = Template.newContainer(layoutOut, 'legend');
  
      function coerce(attr, dflt) {
          return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
      }
  
      coerce('uirevision', layoutOut.uirevision);
  
      if(showLegend === false) return;
  
      coerce('bgcolor', layoutOut.paper_bgcolor);
      coerce('bordercolor');
      coerce('borderwidth');
      Lib.coerceFont(coerce, 'font', layoutOut.font);
  
      var orientation = coerce('orientation');
      var defaultX, defaultY, defaultYAnchor;
  
      if(orientation === 'h') {
          defaultX = 0;
  
          if(Registry.getComponentMethod('rangeslider', 'isVisible')(layoutIn.xaxis)) {
              defaultY = 1.1;
              defaultYAnchor = 'bottom';
          } else {
              // maybe use y=1.1 / yanchor=bottom as above
              //   to avoid https://github.com/plotly/plotly.js/issues/1199
              //   in v2
              defaultY = -0.1;
              defaultYAnchor = 'top';
          }
      } else {
          defaultX = 1.02;
          defaultY = 1;
          defaultYAnchor = 'auto';
      }
  
      coerce('traceorder', defaultOrder);
      if(helpers.isGrouped(layoutOut.legend)) coerce('tracegroupgap');
  
      coerce('itemsizing');
  
      coerce('itemclick');
      coerce('itemdoubleclick');
  
      coerce('x', defaultX);
      coerce('xanchor');
      coerce('y', defaultY);
      coerce('yanchor', defaultYAnchor);
      coerce('valign');
      Lib.noneOrAll(containerIn, containerOut, ['x', 'y']);
  
      var titleText = coerce('title.text');
      if(titleText) {
          coerce('title.side', orientation === 'h' ? 'left' : 'top');
          Lib.coerceFont(coerce, 'title.font', layoutOut.font);
      }
  };
  
  },{"../../lib":750,"../../plot_api/plot_template":788,"../../plots/layout_attributes":853,"../../registry":882,"./attributes":665,"./helpers":671}],668:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Lib = _dereq_('../../lib');
  var Plots = _dereq_('../../plots/plots');
  var Registry = _dereq_('../../registry');
  var Events = _dereq_('../../lib/events');
  var dragElement = _dereq_('../dragelement');
  var Drawing = _dereq_('../drawing');
  var Color = _dereq_('../color');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var handleClick = _dereq_('./handle_click');
  
  var constants = _dereq_('./constants');
  var alignmentConstants = _dereq_('../../constants/alignment');
  var LINE_SPACING = alignmentConstants.LINE_SPACING;
  var FROM_TL = alignmentConstants.FROM_TL;
  var FROM_BR = alignmentConstants.FROM_BR;
  
  var getLegendData = _dereq_('./get_legend_data');
  var style = _dereq_('./style');
  var helpers = _dereq_('./helpers');
  
  module.exports = function draw(gd, opts) {
      var fullLayout = gd._fullLayout;
      var clipId = 'legend' + fullLayout._uid;
      var layer;
  
      // Check whether this is the main legend (ie. called without any opts)
      if(!opts) {
          opts = fullLayout.legend || {};
          opts._main = true;
          layer = fullLayout._infolayer;
      } else {
          layer = opts.layer;
          clipId += '-hover';
      }
  
      if(!layer) return;
  
      if(!gd._legendMouseDownTime) gd._legendMouseDownTime = 0;
  
      var legendData;
      if(opts._main) {
          if(!gd.calcdata) return;
          legendData = fullLayout.showlegend && getLegendData(gd.calcdata, opts);
      } else {
          if(!opts.entries) return;
          legendData = getLegendData(opts.entries, opts);
      }
  
      var hiddenSlices = fullLayout.hiddenlabels || [];
  
      if(opts._main && (!fullLayout.showlegend || !legendData.length)) {
          layer.selectAll('.legend').remove();
          fullLayout._topdefs.select('#' + clipId).remove();
          return Plots.autoMargin(gd, 'legend');
      }
  
      var legend = Lib.ensureSingle(layer, 'g', 'legend', function(s) {
          if(opts._main) s.attr('pointer-events', 'all');
      });
  
      var clipPath = Lib.ensureSingleById(fullLayout._topdefs, 'clipPath', clipId, function(s) {
          s.append('rect');
      });
  
      var bg = Lib.ensureSingle(legend, 'rect', 'bg', function(s) {
          s.attr('shape-rendering', 'crispEdges');
      });
      bg.call(Color.stroke, opts.bordercolor)
          .call(Color.fill, opts.bgcolor)
          .style('stroke-width', opts.borderwidth + 'px');
  
      var scrollBox = Lib.ensureSingle(legend, 'g', 'scrollbox');
  
      var title = opts.title;
      opts._titleWidth = 0;
      opts._titleHeight = 0;
      if(title.text) {
          var titleEl = Lib.ensureSingle(scrollBox, 'text', 'legendtitletext');
          titleEl.attr('text-anchor', 'start')
              .call(Drawing.font, title.font)
              .text(title.text);
  
          textLayout(titleEl, scrollBox, gd, opts); // handle mathjax or multi-line text and compute title height
      } else {
          scrollBox.selectAll('.legendtitletext').remove();
      }
  
      var scrollBar = Lib.ensureSingle(legend, 'rect', 'scrollbar', function(s) {
          s.attr(constants.scrollBarEnterAttrs)
           .call(Color.fill, constants.scrollBarColor);
      });
  
      var groups = scrollBox.selectAll('g.groups').data(legendData);
      groups.enter().append('g').attr('class', 'groups');
      groups.exit().remove();
  
      var traces = groups.selectAll('g.traces').data(Lib.identity);
      traces.enter().append('g').attr('class', 'traces');
      traces.exit().remove();
  
      traces.style('opacity', function(d) {
          var trace = d[0].trace;
          if(Registry.traceIs(trace, 'pie-like')) {
              return hiddenSlices.indexOf(d[0].label) !== -1 ? 0.5 : 1;
          } else {
              return trace.visible === 'legendonly' ? 0.5 : 1;
          }
      })
      .each(function() { d3.select(this).call(drawTexts, gd, opts); })
      .call(style, gd, opts)
      .each(function() { if(opts._main) d3.select(this).call(setupTraceToggle, gd); });
  
      Lib.syncOrAsync([
          Plots.previousPromises,
          function() { return computeLegendDimensions(gd, groups, traces, opts); },
          function() {
              // IF expandMargin return a Promise (which is truthy),
              // we're under a doAutoMargin redraw, so we don't have to
              // draw the remaining pieces below
              if(opts._main && expandMargin(gd)) return;
  
              var gs = fullLayout._size;
              var bw = opts.borderwidth;
  
              var lx = gs.l + gs.w * opts.x - FROM_TL[getXanchor(opts)] * opts._width;
              var ly = gs.t + gs.h * (1 - opts.y) - FROM_TL[getYanchor(opts)] * opts._effHeight;
  
              if(opts._main && fullLayout.margin.autoexpand) {
                  var lx0 = lx;
                  var ly0 = ly;
  
                  lx = Lib.constrain(lx, 0, fullLayout.width - opts._width);
                  ly = Lib.constrain(ly, 0, fullLayout.height - opts._effHeight);
  
                  if(lx !== lx0) {
                      Lib.log('Constrain legend.x to make legend fit inside graph');
                  }
                  if(ly !== ly0) {
                      Lib.log('Constrain legend.y to make legend fit inside graph');
                  }
              }
  
              // Set size and position of all the elements that make up a legend:
              // legend, background and border, scroll box and scroll bar as well as title
              if(opts._main) Drawing.setTranslate(legend, lx, ly);
  
              // to be safe, remove previous listeners
              scrollBar.on('.drag', null);
              legend.on('wheel', null);
  
              if(!opts._main || opts._height <= opts._maxHeight || gd._context.staticPlot) {
                  // if scrollbar should not be shown.
                  var height = opts._effHeight;
  
                  // if not the main legend, let it be its full size
                  if(!opts._main) height = opts._height;
  
                  bg.attr({
                      width: opts._width - bw,
                      height: height - bw,
                      x: bw / 2,
                      y: bw / 2
                  });
  
                  Drawing.setTranslate(scrollBox, 0, 0);
  
                  clipPath.select('rect').attr({
                      width: opts._width - 2 * bw,
                      height: height - 2 * bw,
                      x: bw,
                      y: bw
                  });
  
                  Drawing.setClipUrl(scrollBox, clipId, gd);
  
                  Drawing.setRect(scrollBar, 0, 0, 0, 0);
                  delete opts._scrollY;
              } else {
                  var scrollBarHeight = Math.max(constants.scrollBarMinHeight,
                      opts._effHeight * opts._effHeight / opts._height);
                  var scrollBarYMax = opts._effHeight -
                      scrollBarHeight -
                      2 * constants.scrollBarMargin;
                  var scrollBoxYMax = opts._height - opts._effHeight;
                  var scrollRatio = scrollBarYMax / scrollBoxYMax;
  
                  var scrollBoxY = Math.min(opts._scrollY || 0, scrollBoxYMax);
  
                  // increase the background and clip-path width
                  // by the scrollbar width and margin
                  bg.attr({
                      width: opts._width -
                          2 * bw +
                          constants.scrollBarWidth +
                          constants.scrollBarMargin,
                      height: opts._effHeight - bw,
                      x: bw / 2,
                      y: bw / 2
                  });
  
                  clipPath.select('rect').attr({
                      width: opts._width -
                          2 * bw +
                          constants.scrollBarWidth +
                          constants.scrollBarMargin,
                      height: opts._effHeight - 2 * bw,
                      x: bw,
                      y: bw + scrollBoxY
                  });
  
                  Drawing.setClipUrl(scrollBox, clipId, gd);
  
                  scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
  
                  // scroll legend by mousewheel or touchpad swipe up/down
                  legend.on('wheel', function() {
                      scrollBoxY = Lib.constrain(
                          opts._scrollY +
                              ((d3.event.deltaY / scrollBarYMax) * scrollBoxYMax),
                          0, scrollBoxYMax);
                      scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
                      if(scrollBoxY !== 0 && scrollBoxY !== scrollBoxYMax) {
                          d3.event.preventDefault();
                      }
                  });
  
                  var eventY0, eventY1, scrollBoxY0;
  
                  var getScrollBarDragY = function(scrollBoxY0, eventY0, eventY1) {
                      var y = ((eventY1 - eventY0) / scrollRatio) + scrollBoxY0;
                      return Lib.constrain(y, 0, scrollBoxYMax);
                  };
  
                  var getNaturalDragY = function(scrollBoxY0, eventY0, eventY1) {
                      var y = ((eventY0 - eventY1) / scrollRatio) + scrollBoxY0;
                      return Lib.constrain(y, 0, scrollBoxYMax);
                  };
  
                  // scroll legend by dragging scrollBAR
                  var scrollBarDrag = d3.behavior.drag()
                  .on('dragstart', function() {
                      var e = d3.event.sourceEvent;
                      if(e.type === 'touchstart') {
                          eventY0 = e.changedTouches[0].clientY;
                      } else {
                          eventY0 = e.clientY;
                      }
                      scrollBoxY0 = scrollBoxY;
                  })
                  .on('drag', function() {
                      var e = d3.event.sourceEvent;
                      if(e.buttons === 2 || e.ctrlKey) return;
                      if(e.type === 'touchmove') {
                          eventY1 = e.changedTouches[0].clientY;
                      } else {
                          eventY1 = e.clientY;
                      }
                      scrollBoxY = getScrollBarDragY(scrollBoxY0, eventY0, eventY1);
                      scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
                  });
                  scrollBar.call(scrollBarDrag);
  
                  // scroll legend by touch-dragging scrollBOX
                  var scrollBoxTouchDrag = d3.behavior.drag()
                  .on('dragstart', function() {
                      var e = d3.event.sourceEvent;
                      if(e.type === 'touchstart') {
                          eventY0 = e.changedTouches[0].clientY;
                          scrollBoxY0 = scrollBoxY;
                      }
                  })
                  .on('drag', function() {
                      var e = d3.event.sourceEvent;
                      if(e.type === 'touchmove') {
                          eventY1 = e.changedTouches[0].clientY;
                          scrollBoxY = getNaturalDragY(scrollBoxY0, eventY0, eventY1);
                          scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio);
                      }
                  });
                  scrollBox.call(scrollBoxTouchDrag);
              }
  
              function scrollHandler(scrollBoxY, scrollBarHeight, scrollRatio) {
                  opts._scrollY = gd._fullLayout.legend._scrollY = scrollBoxY;
                  Drawing.setTranslate(scrollBox, 0, -scrollBoxY);
  
                  Drawing.setRect(
                      scrollBar,
                      opts._width,
                      constants.scrollBarMargin + scrollBoxY * scrollRatio,
                      constants.scrollBarWidth,
                      scrollBarHeight
                  );
                  clipPath.select('rect').attr('y', bw + scrollBoxY);
              }
  
              if(gd._context.edits.legendPosition) {
                  var xf, yf, x0, y0;
  
                  legend.classed('cursor-move', true);
  
                  dragElement.init({
                      element: legend.node(),
                      gd: gd,
                      prepFn: function() {
                          var transform = Drawing.getTranslate(legend);
                          x0 = transform.x;
                          y0 = transform.y;
                      },
                      moveFn: function(dx, dy) {
                          var newX = x0 + dx;
                          var newY = y0 + dy;
  
                          Drawing.setTranslate(legend, newX, newY);
  
                          xf = dragElement.align(newX, 0, gs.l, gs.l + gs.w, opts.xanchor);
                          yf = dragElement.align(newY, 0, gs.t + gs.h, gs.t, opts.yanchor);
                      },
                      doneFn: function() {
                          if(xf !== undefined && yf !== undefined) {
                              Registry.call('_guiRelayout', gd, {'legend.x': xf, 'legend.y': yf});
                          }
                      },
                      clickFn: function(numClicks, e) {
                          var clickedTrace = layer.selectAll('g.traces').filter(function() {
                              var bbox = this.getBoundingClientRect();
                              return (
                                  e.clientX >= bbox.left && e.clientX <= bbox.right &&
                                  e.clientY >= bbox.top && e.clientY <= bbox.bottom
                              );
                          });
                          if(clickedTrace.size() > 0) {
                              clickOrDoubleClick(gd, legend, clickedTrace, numClicks, e);
                          }
                      }
                  });
              }
          }], gd);
  };
  
  function clickOrDoubleClick(gd, legend, legendItem, numClicks, evt) {
      var trace = legendItem.data()[0][0].trace;
      var evtData = {
          event: evt,
          node: legendItem.node(),
          curveNumber: trace.index,
          expandedIndex: trace._expandedIndex,
          data: gd.data,
          layout: gd.layout,
          frames: gd._transitionData._frames,
          config: gd._context,
          fullData: gd._fullData,
          fullLayout: gd._fullLayout
      };
  
      if(trace._group) {
          evtData.group = trace._group;
      }
      if(Registry.traceIs(trace, 'pie-like')) {
          evtData.label = legendItem.datum()[0].label;
      }
  
      var clickVal = Events.triggerHandler(gd, 'plotly_legendclick', evtData);
      if(clickVal === false) return;
  
      if(numClicks === 1) {
          legend._clickTimeout = setTimeout(function() {
              handleClick(legendItem, gd, numClicks);
          }, gd._context.doubleClickDelay);
      } else if(numClicks === 2) {
          if(legend._clickTimeout) clearTimeout(legend._clickTimeout);
          gd._legendMouseDownTime = 0;
  
          var dblClickVal = Events.triggerHandler(gd, 'plotly_legenddoubleclick', evtData);
          if(dblClickVal !== false) handleClick(legendItem, gd, numClicks);
      }
  }
  
  function drawTexts(g, gd, opts) {
      var legendItem = g.data()[0][0];
      var trace = legendItem.trace;
      var isPieLike = Registry.traceIs(trace, 'pie-like');
      var traceIndex = trace.index;
      var isEditable = opts._main && gd._context.edits.legendText && !isPieLike;
      var maxNameLength = opts._maxNameLength;
  
      var name;
      if(!opts.entries) {
          name = isPieLike ? legendItem.label : trace.name;
          if(trace._meta) {
              name = Lib.templateString(name, trace._meta);
          }
      } else {
          name = legendItem.text;
      }
  
      var textEl = Lib.ensureSingle(g, 'text', 'legendtext');
  
      textEl.attr('text-anchor', 'start')
          .call(Drawing.font, opts.font)
          .text(isEditable ? ensureLength(name, maxNameLength) : name);
  
      svgTextUtils.positionText(textEl, constants.textGap, 0);
  
      if(isEditable) {
          textEl.call(svgTextUtils.makeEditable, {gd: gd, text: name})
              .call(textLayout, g, gd, opts)
              .on('edit', function(newName) {
                  this.text(ensureLength(newName, maxNameLength))
                      .call(textLayout, g, gd, opts);
  
                  var fullInput = legendItem.trace._fullInput || {};
                  var update = {};
  
                  if(Registry.hasTransform(fullInput, 'groupby')) {
                      var groupbyIndices = Registry.getTransformIndices(fullInput, 'groupby');
                      var index = groupbyIndices[groupbyIndices.length - 1];
  
                      var kcont = Lib.keyedContainer(fullInput, 'transforms[' + index + '].styles', 'target', 'value.name');
  
                      kcont.set(legendItem.trace._group, newName);
  
                      update = kcont.constructUpdate();
                  } else {
                      update.name = newName;
                  }
  
                  return Registry.call('_guiRestyle', gd, update, traceIndex);
              });
      } else {
          textLayout(textEl, g, gd, opts);
      }
  }
  
  /*
   * Make sure we have a reasonably clickable region.
   * If this string is missing or very short, pad it with spaces out to at least
   * 4 characters, up to the max length of other labels, on the assumption that
   * most characters are wider than spaces so a string of spaces will usually be
   * no wider than the real labels.
   */
  function ensureLength(str, maxLength) {
      var targetLength = Math.max(4, maxLength);
      if(str && str.trim().length >= targetLength / 2) return str;
      str = str || '';
      for(var i = targetLength - str.length; i > 0; i--) str += ' ';
      return str;
  }
  
  function setupTraceToggle(g, gd) {
      var doubleClickDelay = gd._context.doubleClickDelay;
      var newMouseDownTime;
      var numClicks = 1;
  
      var traceToggle = Lib.ensureSingle(g, 'rect', 'legendtoggle', function(s) {
          if(!gd._context.staticPlot) {
              s.style('cursor', 'pointer').attr('pointer-events', 'all');
          }
          s.call(Color.fill, 'rgba(0,0,0,0)');
      });
  
      if(gd._context.staticPlot) return;
  
      traceToggle.on('mousedown', function() {
          newMouseDownTime = (new Date()).getTime();
          if(newMouseDownTime - gd._legendMouseDownTime < doubleClickDelay) {
              // in a click train
              numClicks += 1;
          } else {
              // new click train
              numClicks = 1;
              gd._legendMouseDownTime = newMouseDownTime;
          }
      });
      traceToggle.on('mouseup', function() {
          if(gd._dragged || gd._editing) return;
          var legend = gd._fullLayout.legend;
  
          if((new Date()).getTime() - gd._legendMouseDownTime > doubleClickDelay) {
              numClicks = Math.max(numClicks - 1, 1);
          }
  
          clickOrDoubleClick(gd, legend, g, numClicks, d3.event);
      });
  }
  
  function textLayout(s, g, gd, opts) {
      if(!opts._main) s.attr('data-notex', true); // do not process MathJax if not main
      svgTextUtils.convertToTspans(s, gd, function() {
          computeTextDimensions(g, gd, opts);
      });
  }
  
  function computeTextDimensions(g, gd, opts) {
      var legendItem = g.data()[0][0];
      if(opts._main && legendItem && !legendItem.trace.showlegend) {
          g.remove();
          return;
      }
  
      var mathjaxGroup = g.select('g[class*=math-group]');
      var mathjaxNode = mathjaxGroup.node();
      if(!opts) opts = gd._fullLayout.legend;
      var bw = opts.borderwidth;
      var lineHeight = (legendItem ? opts : opts.title).font.size * LINE_SPACING;
      var height, width;
  
      if(mathjaxNode) {
          var mathjaxBB = Drawing.bBox(mathjaxNode);
  
          height = mathjaxBB.height;
          width = mathjaxBB.width;
  
          if(legendItem) {
              Drawing.setTranslate(mathjaxGroup, 0, height * 0.25);
          } else { // case of title
              Drawing.setTranslate(mathjaxGroup, bw, height * 0.75 + bw);
          }
      } else {
          var textEl = g.select(legendItem ?
              '.legendtext' : '.legendtitletext'
          );
          var textLines = svgTextUtils.lineCount(textEl);
          var textNode = textEl.node();
  
          height = lineHeight * textLines;
          width = textNode ? Drawing.bBox(textNode).width : 0;
  
          // approximation to height offset to center the font
          // to avoid getBoundingClientRect
          var textY = lineHeight * ((textLines - 1) / 2 - 0.3);
          if(legendItem) {
              svgTextUtils.positionText(textEl, constants.textGap, -textY);
          } else { // case of title
              svgTextUtils.positionText(textEl, constants.titlePad + bw, lineHeight + bw);
          }
      }
  
      if(legendItem) {
          legendItem.lineHeight = lineHeight;
          legendItem.height = Math.max(height, 16) + 3;
          legendItem.width = width;
      } else { // case of title
          opts._titleWidth = width;
          opts._titleHeight = height;
      }
  }
  
  function getTitleSize(opts) {
      var w = 0;
      var h = 0;
  
      var side = opts.title.side;
      if(side) {
          if(side.indexOf('left') !== -1) {
              w = opts._titleWidth;
          }
          if(side.indexOf('top') !== -1) {
              h = opts._titleHeight;
          }
      }
  
      return [w, h];
  }
  
  /*
   * Computes in fullLayout.legend:
   *
   *  - _height: legend height including items past scrollbox height
   *  - _maxHeight: maximum legend height before scrollbox is required
   *  - _effHeight: legend height w/ or w/o scrollbox
   *
   *  - _width: legend width
   *  - _maxWidth (for orientation:h only): maximum width before starting new row
   */
  function computeLegendDimensions(gd, groups, traces, opts) {
      var fullLayout = gd._fullLayout;
      if(!opts) opts = fullLayout.legend;
      var gs = fullLayout._size;
  
      var isVertical = helpers.isVertical(opts);
      var isGrouped = helpers.isGrouped(opts);
  
      var bw = opts.borderwidth;
      var bw2 = 2 * bw;
      var textGap = constants.textGap;
      var itemGap = constants.itemGap;
      var endPad = 2 * (bw + itemGap);
  
      var yanchor = getYanchor(opts);
      var isBelowPlotArea = opts.y < 0 || (opts.y === 0 && yanchor === 'top');
      var isAbovePlotArea = opts.y > 1 || (opts.y === 1 && yanchor === 'bottom');
  
      // - if below/above plot area, give it the maximum potential margin-push value
      // - otherwise, extend the height of the plot area
      opts._maxHeight = Math.max(
          (isBelowPlotArea || isAbovePlotArea) ? fullLayout.height / 2 : gs.h,
          30
      );
  
      var toggleRectWidth = 0;
      opts._width = 0;
      opts._height = 0;
      var titleSize = getTitleSize(opts);
  
      if(isVertical) {
          traces.each(function(d) {
              var h = d[0].height;
              Drawing.setTranslate(this,
                  bw + titleSize[0],
                  bw + titleSize[1] + opts._height + h / 2 + itemGap
              );
              opts._height += h;
              opts._width = Math.max(opts._width, d[0].width);
          });
  
          toggleRectWidth = textGap + opts._width;
          opts._width += itemGap + textGap + bw2;
          opts._height += endPad;
  
          if(isGrouped) {
              groups.each(function(d, i) {
                  Drawing.setTranslate(this, 0, i * opts.tracegroupgap);
              });
              opts._height += (opts._lgroupsLength - 1) * opts.tracegroupgap;
          }
      } else {
          var xanchor = getXanchor(opts);
          var isLeftOfPlotArea = opts.x < 0 || (opts.x === 0 && xanchor === 'right');
          var isRightOfPlotArea = opts.x > 1 || (opts.x === 1 && xanchor === 'left');
          var isBeyondPlotAreaY = isAbovePlotArea || isBelowPlotArea;
          var hw = fullLayout.width / 2;
  
          // - if placed within x-margins, extend the width of the plot area
          // - else if below/above plot area and anchored in the margin, extend to opposite margin,
          // - otherwise give it the maximum potential margin-push value
          opts._maxWidth = Math.max(
              isLeftOfPlotArea ? ((isBeyondPlotAreaY && xanchor === 'left') ? gs.l + gs.w : hw) :
              isRightOfPlotArea ? ((isBeyondPlotAreaY && xanchor === 'right') ? gs.r + gs.w : hw) :
              gs.w,
          2 * textGap);
          var maxItemWidth = 0;
          var combinedItemWidth = 0;
          traces.each(function(d) {
              var w = d[0].width + textGap;
              maxItemWidth = Math.max(maxItemWidth, w);
              combinedItemWidth += w;
          });
  
          toggleRectWidth = null;
          var maxRowWidth = 0;
  
          if(isGrouped) {
              var maxGroupHeightInRow = 0;
              var groupOffsetX = 0;
              var groupOffsetY = 0;
              groups.each(function() {
                  var maxWidthInGroup = 0;
                  var offsetY = 0;
                  d3.select(this).selectAll('g.traces').each(function(d) {
                      var h = d[0].height;
                      Drawing.setTranslate(this,
                          titleSize[0],
                          titleSize[1] + bw + itemGap + h / 2 + offsetY
                      );
                      offsetY += h;
                      maxWidthInGroup = Math.max(maxWidthInGroup, textGap + d[0].width);
                  });
                  maxGroupHeightInRow = Math.max(maxGroupHeightInRow, offsetY);
  
                  var next = maxWidthInGroup + itemGap;
  
                  if((next + bw + groupOffsetX) > opts._maxWidth) {
                      maxRowWidth = Math.max(maxRowWidth, groupOffsetX);
                      groupOffsetX = 0;
                      groupOffsetY += maxGroupHeightInRow + opts.tracegroupgap;
                      maxGroupHeightInRow = offsetY;
                  }
  
                  Drawing.setTranslate(this, groupOffsetX, groupOffsetY);
  
                  groupOffsetX += next;
              });
  
              opts._width = Math.max(maxRowWidth, groupOffsetX) + bw;
              opts._height = groupOffsetY + maxGroupHeightInRow + endPad;
          } else {
              var nTraces = traces.size();
              var oneRowLegend = (combinedItemWidth + bw2 + (nTraces - 1) * itemGap) < opts._maxWidth;
  
              var maxItemHeightInRow = 0;
              var offsetX = 0;
              var offsetY = 0;
              var rowWidth = 0;
              traces.each(function(d) {
                  var h = d[0].height;
                  var w = textGap + d[0].width;
                  var next = (oneRowLegend ? w : maxItemWidth) + itemGap;
  
                  if((next + bw + offsetX - itemGap) >= opts._maxWidth) {
                      maxRowWidth = Math.max(maxRowWidth, rowWidth);
                      offsetX = 0;
                      offsetY += maxItemHeightInRow;
                      opts._height += maxItemHeightInRow;
                      maxItemHeightInRow = 0;
                  }
  
                  Drawing.setTranslate(this,
                      titleSize[0] + bw + offsetX,
                      titleSize[1] + bw + offsetY + h / 2 + itemGap
                  );
  
                  rowWidth = offsetX + w + itemGap;
                  offsetX += next;
                  maxItemHeightInRow = Math.max(maxItemHeightInRow, h);
              });
  
              if(oneRowLegend) {
                  opts._width = offsetX + bw2;
                  opts._height = maxItemHeightInRow + endPad;
              } else {
                  opts._width = Math.max(maxRowWidth, rowWidth) + bw2;
                  opts._height += maxItemHeightInRow + endPad;
              }
          }
      }
  
      opts._width = Math.ceil(
          Math.max(
              opts._width + titleSize[0],
              opts._titleWidth + 2 * (bw + constants.titlePad)
          )
      );
  
      opts._height = Math.ceil(
          Math.max(
              opts._height + titleSize[1],
              opts._titleHeight + 2 * (bw + constants.itemGap)
          )
      );
  
      opts._effHeight = Math.min(opts._height, opts._maxHeight);
  
      var edits = gd._context.edits;
      var isEditable = edits.legendText || edits.legendPosition;
      traces.each(function(d) {
          var traceToggle = d3.select(this).select('.legendtoggle');
          var h = d[0].height;
          var w = isEditable ? textGap : (toggleRectWidth || (textGap + d[0].width));
          if(!isVertical) w += itemGap / 2;
          Drawing.setRect(traceToggle, 0, -h / 2, w, h);
      });
  }
  
  function expandMargin(gd) {
      var fullLayout = gd._fullLayout;
      var opts = fullLayout.legend;
      var xanchor = getXanchor(opts);
      var yanchor = getYanchor(opts);
  
      return Plots.autoMargin(gd, 'legend', {
          x: opts.x,
          y: opts.y,
          l: opts._width * (FROM_TL[xanchor]),
          r: opts._width * (FROM_BR[xanchor]),
          b: opts._effHeight * (FROM_BR[yanchor]),
          t: opts._effHeight * (FROM_TL[yanchor])
      });
  }
  
  function getXanchor(opts) {
      return Lib.isRightAnchor(opts) ? 'right' :
          Lib.isCenterAnchor(opts) ? 'center' :
          'left';
  }
  
  function getYanchor(opts) {
      return Lib.isBottomAnchor(opts) ? 'bottom' :
          Lib.isMiddleAnchor(opts) ? 'middle' :
          'top';
  }
  
  },{"../../constants/alignment":717,"../../lib":750,"../../lib/events":739,"../../lib/svg_text_utils":774,"../../plots/plots":862,"../../registry":882,"../color":615,"../dragelement":634,"../drawing":637,"./constants":666,"./get_legend_data":669,"./handle_click":670,"./helpers":671,"./style":673,"d3":169}],669:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var helpers = _dereq_('./helpers');
  
  module.exports = function getLegendData(calcdata, opts) {
      var lgroupToTraces = {};
      var lgroups = [];
      var hasOneNonBlankGroup = false;
      var slicesShown = {};
      var lgroupi = 0;
      var maxNameLength = 0;
      var i, j;
      var main = opts._main;
  
      function addOneItem(legendGroup, legendItem) {
          // each '' legend group is treated as a separate group
          if(legendGroup === '' || !helpers.isGrouped(opts)) {
              // TODO: check this against fullData legendgroups?
              var uniqueGroup = '~~i' + lgroupi;
              lgroups.push(uniqueGroup);
              lgroupToTraces[uniqueGroup] = [[legendItem]];
              lgroupi++;
          } else if(lgroups.indexOf(legendGroup) === -1) {
              lgroups.push(legendGroup);
              hasOneNonBlankGroup = true;
              lgroupToTraces[legendGroup] = [[legendItem]];
          } else {
              lgroupToTraces[legendGroup].push([legendItem]);
          }
      }
  
      // build an { legendgroup: [cd0, cd0], ... } object
      for(i = 0; i < calcdata.length; i++) {
          var cd = calcdata[i];
          var cd0 = cd[0];
          var trace = cd0.trace;
          var lgroup = trace.legendgroup;
  
          if(main && (!trace.visible || !trace.showlegend)) continue;
  
          if(Registry.traceIs(trace, 'pie-like')) {
              if(!slicesShown[lgroup]) slicesShown[lgroup] = {};
  
              for(j = 0; j < cd.length; j++) {
                  var labelj = cd[j].label;
  
                  if(!slicesShown[lgroup][labelj]) {
                      addOneItem(lgroup, {
                          label: labelj,
                          color: cd[j].color,
                          i: cd[j].i,
                          trace: trace,
                          pts: cd[j].pts
                      });
  
                      slicesShown[lgroup][labelj] = true;
                      maxNameLength = Math.max(maxNameLength, (labelj || '').length);
                  }
              }
          } else {
              addOneItem(lgroup, cd0);
              maxNameLength = Math.max(maxNameLength, (trace.name || '').length);
          }
      }
  
      // won't draw a legend in this case
      if(!lgroups.length) return [];
  
      // rearrange lgroupToTraces into a d3-friendly array of arrays
      var lgroupsLength = lgroups.length;
      var ltraces;
      var legendData;
  
      if(hasOneNonBlankGroup && helpers.isGrouped(opts)) {
          legendData = new Array(lgroupsLength);
  
          for(i = 0; i < lgroupsLength; i++) {
              ltraces = lgroupToTraces[lgroups[i]];
              legendData[i] = helpers.isReversed(opts) ? ltraces.reverse() : ltraces;
          }
      } else {
          // collapse all groups into one if all groups are blank
          legendData = [new Array(lgroupsLength)];
  
          for(i = 0; i < lgroupsLength; i++) {
              ltraces = lgroupToTraces[lgroups[i]][0];
              legendData[0][helpers.isReversed(opts) ? lgroupsLength - i - 1 : i] = ltraces;
          }
          lgroupsLength = 1;
      }
  
      // number of legend groups - needed in legend/draw.js
      opts._lgroupsLength = lgroupsLength;
      // maximum name/label length - needed in legend/draw.js
      opts._maxNameLength = maxNameLength;
  
      return legendData;
  };
  
  },{"../../registry":882,"./helpers":671}],670:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  
  var SHOWISOLATETIP = true;
  
  module.exports = function handleClick(g, gd, numClicks) {
      var fullLayout = gd._fullLayout;
  
      if(gd._dragged || gd._editing) return;
  
      var itemClick = fullLayout.legend.itemclick;
      var itemDoubleClick = fullLayout.legend.itemdoubleclick;
  
      if(numClicks === 1 && itemClick === 'toggle' && itemDoubleClick === 'toggleothers' &&
          SHOWISOLATETIP && gd.data && gd._context.showTips
      ) {
          Lib.notifier(Lib._(gd, 'Double-click on legend to isolate one trace'), 'long');
          SHOWISOLATETIP = false;
      } else {
          SHOWISOLATETIP = false;
      }
  
      var mode;
      if(numClicks === 1) mode = itemClick;
      else if(numClicks === 2) mode = itemDoubleClick;
      if(!mode) return;
  
      var hiddenSlices = fullLayout.hiddenlabels ?
          fullLayout.hiddenlabels.slice() :
          [];
  
      var legendItem = g.data()[0][0];
      var fullData = gd._fullData;
      var fullTrace = legendItem.trace;
      var legendgroup = fullTrace.legendgroup;
  
      var i, j, kcont, key, keys, val;
      var attrUpdate = {};
      var attrIndices = [];
      var carrs = [];
      var carrIdx = [];
  
      function insertUpdate(traceIndex, key, value) {
          var attrIndex = attrIndices.indexOf(traceIndex);
          var valueArray = attrUpdate[key];
          if(!valueArray) {
              valueArray = attrUpdate[key] = [];
          }
  
          if(attrIndices.indexOf(traceIndex) === -1) {
              attrIndices.push(traceIndex);
              attrIndex = attrIndices.length - 1;
          }
  
          valueArray[attrIndex] = value;
  
          return attrIndex;
      }
  
      function setVisibility(fullTrace, visibility) {
          var fullInput = fullTrace._fullInput;
          if(Registry.hasTransform(fullInput, 'groupby')) {
              var kcont = carrs[fullInput.index];
              if(!kcont) {
                  var groupbyIndices = Registry.getTransformIndices(fullInput, 'groupby');
                  var lastGroupbyIndex = groupbyIndices[groupbyIndices.length - 1];
                  kcont = Lib.keyedContainer(fullInput, 'transforms[' + lastGroupbyIndex + '].styles', 'target', 'value.visible');
                  carrs[fullInput.index] = kcont;
              }
  
              var curState = kcont.get(fullTrace._group);
  
              // If not specified, assume visible. This happens if there are other style
              // properties set for a group but not the visibility. There are many similar
              // ways to do this (e.g. why not just `curState = fullTrace.visible`??? The
              // answer is: because it breaks other things like groupby trace names in
              // subtle ways.)
              if(curState === undefined) {
                  curState = true;
              }
  
              if(curState !== false) {
                  // true -> legendonly. All others toggle to true:
                  kcont.set(fullTrace._group, visibility);
              }
              carrIdx[fullInput.index] = insertUpdate(fullInput.index, 'visible', fullInput.visible === false ? false : true);
          } else {
              // false -> false (not possible since will not be visible in legend)
              // true -> legendonly
              // legendonly -> true
              var nextVisibility = fullInput.visible === false ? false : visibility;
  
              insertUpdate(fullInput.index, 'visible', nextVisibility);
          }
      }
  
      if(Registry.traceIs(fullTrace, 'pie-like')) {
          var thisLabel = legendItem.label;
          var thisLabelIndex = hiddenSlices.indexOf(thisLabel);
  
          if(mode === 'toggle') {
              if(thisLabelIndex === -1) hiddenSlices.push(thisLabel);
              else hiddenSlices.splice(thisLabelIndex, 1);
          } else if(mode === 'toggleothers') {
              hiddenSlices = [];
              gd.calcdata[0].forEach(function(d) {
                  if(thisLabel !== d.label) {
                      hiddenSlices.push(d.label);
                  }
              });
              if(gd._fullLayout.hiddenlabels && gd._fullLayout.hiddenlabels.length === hiddenSlices.length && thisLabelIndex === -1) {
                  hiddenSlices = [];
              }
          }
  
          Registry.call('_guiRelayout', gd, 'hiddenlabels', hiddenSlices);
      } else {
          var hasLegendgroup = legendgroup && legendgroup.length;
          var traceIndicesInGroup = [];
          var tracei;
          if(hasLegendgroup) {
              for(i = 0; i < fullData.length; i++) {
                  tracei = fullData[i];
                  if(!tracei.visible) continue;
                  if(tracei.legendgroup === legendgroup) {
                      traceIndicesInGroup.push(i);
                  }
              }
          }
  
          if(mode === 'toggle') {
              var nextVisibility;
  
              switch(fullTrace.visible) {
                  case true:
                      nextVisibility = 'legendonly';
                      break;
                  case false:
                      nextVisibility = false;
                      break;
                  case 'legendonly':
                      nextVisibility = true;
                      break;
              }
  
              if(hasLegendgroup) {
                  for(i = 0; i < fullData.length; i++) {
                      if(fullData[i].visible !== false && fullData[i].legendgroup === legendgroup) {
                          setVisibility(fullData[i], nextVisibility);
                      }
                  }
              } else {
                  setVisibility(fullTrace, nextVisibility);
              }
          } else if(mode === 'toggleothers') {
              // Compute the clicked index. expandedIndex does what we want for expanded traces
              // but also culls hidden traces. That means we have some work to do.
              var isClicked, isInGroup, notInLegend, otherState;
              var isIsolated = true;
              for(i = 0; i < fullData.length; i++) {
                  isClicked = fullData[i] === fullTrace;
                  notInLegend = fullData[i].showlegend !== true;
                  if(isClicked || notInLegend) continue;
  
                  isInGroup = (hasLegendgroup && fullData[i].legendgroup === legendgroup);
  
                  if(!isInGroup && fullData[i].visible === true && !Registry.traceIs(fullData[i], 'notLegendIsolatable')) {
                      isIsolated = false;
                      break;
                  }
              }
  
              for(i = 0; i < fullData.length; i++) {
                  // False is sticky; we don't change it.
                  if(fullData[i].visible === false) continue;
  
                  if(Registry.traceIs(fullData[i], 'notLegendIsolatable')) {
                      continue;
                  }
  
                  switch(fullTrace.visible) {
                      case 'legendonly':
                          setVisibility(fullData[i], true);
                          break;
                      case true:
                          otherState = isIsolated ? true : 'legendonly';
                          isClicked = fullData[i] === fullTrace;
                          // N.B. consider traces that have a set legendgroup as toggleable
                          notInLegend = (fullData[i].showlegend !== true && !fullData[i].legendgroup);
                          isInGroup = isClicked || (hasLegendgroup && fullData[i].legendgroup === legendgroup);
                          setVisibility(fullData[i], (isInGroup || notInLegend) ? true : otherState);
                          break;
                  }
              }
          }
  
          for(i = 0; i < carrs.length; i++) {
              kcont = carrs[i];
              if(!kcont) continue;
              var update = kcont.constructUpdate();
  
              var updateKeys = Object.keys(update);
              for(j = 0; j < updateKeys.length; j++) {
                  key = updateKeys[j];
                  val = attrUpdate[key] = attrUpdate[key] || [];
                  val[carrIdx[i]] = update[key];
              }
          }
  
          // The length of the value arrays should be equal and any unspecified
          // values should be explicitly undefined for them to get properly culled
          // as updates and not accidentally reset to the default value. This fills
          // out sparse arrays with the required number of undefined values:
          keys = Object.keys(attrUpdate);
          for(i = 0; i < keys.length; i++) {
              key = keys[i];
              for(j = 0; j < attrIndices.length; j++) {
                  // Use hasOwnPropety to protect against falsey values:
                  if(!attrUpdate[key].hasOwnProperty(j)) {
                      attrUpdate[key][j] = undefined;
                  }
              }
          }
  
          Registry.call('_guiRestyle', gd, attrUpdate, attrIndices);
      }
  };
  
  },{"../../lib":750,"../../registry":882}],671:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  exports.isGrouped = function isGrouped(legendLayout) {
      return (legendLayout.traceorder || '').indexOf('grouped') !== -1;
  };
  
  exports.isVertical = function isVertical(legendLayout) {
      return legendLayout.orientation !== 'h';
  };
  
  exports.isReversed = function isReversed(legendLayout) {
      return (legendLayout.traceorder || '').indexOf('reversed') !== -1;
  };
  
  },{}],672:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  module.exports = {
      moduleType: 'component',
      name: 'legend',
  
      layoutAttributes: _dereq_('./attributes'),
      supplyLayoutDefaults: _dereq_('./defaults'),
  
      draw: _dereq_('./draw'),
      style: _dereq_('./style')
  };
  
  },{"./attributes":665,"./defaults":667,"./draw":668,"./style":673}],673:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../drawing');
  var Color = _dereq_('../color');
  var extractOpts = _dereq_('../colorscale/helpers').extractOpts;
  
  var subTypes = _dereq_('../../traces/scatter/subtypes');
  var stylePie = _dereq_('../../traces/pie/style_one');
  var pieCastOption = _dereq_('../../traces/pie/helpers').castOption;
  
  var CST_MARKER_SIZE = 12;
  var CST_LINE_WIDTH = 5;
  var CST_MARKER_LINE_WIDTH = 2;
  var MAX_LINE_WIDTH = 10;
  var MAX_MARKER_LINE_WIDTH = 5;
  
  module.exports = function style(s, gd, legend) {
      var fullLayout = gd._fullLayout;
      if(!legend) legend = fullLayout.legend;
      var constantItemSizing = legend.itemsizing === 'constant';
  
      var boundLineWidth = function(mlw, cont, max, cst) {
          var v;
          if(mlw + 1) {
              v = mlw;
          } else if(cont && cont.width > 0) {
              v = cont.width;
          } else {
              return 0;
          }
          return constantItemSizing ? cst : Math.min(v, max);
      };
  
      s.each(function(d) {
          var traceGroup = d3.select(this);
  
          var layers = Lib.ensureSingle(traceGroup, 'g', 'layers');
          layers.style('opacity', d[0].trace.opacity);
  
          var valign = legend.valign;
          var lineHeight = d[0].lineHeight;
          var height = d[0].height;
  
          if(valign === 'middle' || !lineHeight || !height) {
              layers.attr('transform', null);
          } else {
              var factor = {top: 1, bottom: -1}[valign];
              var markerOffsetY = factor * (0.5 * (lineHeight - height + 3));
              layers.attr('transform', 'translate(0,' + markerOffsetY + ')');
          }
  
          var fill = layers
              .selectAll('g.legendfill')
                  .data([d]);
          fill.enter().append('g')
              .classed('legendfill', true);
  
          var line = layers
              .selectAll('g.legendlines')
                  .data([d]);
          line.enter().append('g')
              .classed('legendlines', true);
  
          var symbol = layers
              .selectAll('g.legendsymbols')
                  .data([d]);
          symbol.enter().append('g')
              .classed('legendsymbols', true);
  
          symbol.selectAll('g.legendpoints')
              .data([d])
            .enter().append('g')
              .classed('legendpoints', true);
      })
      .each(styleSpatial)
      .each(styleWaterfalls)
      .each(styleFunnels)
      .each(styleBars)
      .each(styleBoxes)
      .each(styleFunnelareas)
      .each(stylePies)
      .each(styleLines)
      .each(stylePoints)
      .each(styleCandles)
      .each(styleOHLC);
  
      function styleLines(d) {
          var d0 = d[0];
          var trace = d0.trace;
          var showFill = trace.visible && trace.fill && trace.fill !== 'none';
          var showLine = subTypes.hasLines(trace);
          var contours = trace.contours;
          var showGradientLine = false;
          var showGradientFill = false;
          var dMod, tMod;
  
          var cOpts = extractOpts(trace);
          var colorscale = cOpts.colorscale;
          var reversescale = cOpts.reversescale;
  
          var fillGradient = function(s) {
              if(s.size()) {
                  var gradientID = 'legendfill-' + trace.uid;
                  Drawing.gradient(s, gd, gradientID,
                      getGradientDirection(reversescale),
                      colorscale, 'fill');
              }
          };
  
          var lineGradient = function(s) {
              if(s.size()) {
                  var gradientID = 'legendline-' + trace.uid;
                  Drawing.lineGroupStyle(s);
                  Drawing.gradient(s, gd, gradientID,
                      getGradientDirection(reversescale),
                      colorscale, 'stroke');
              }
          };
  
          if(contours) {
              var coloring = contours.coloring;
  
              if(coloring === 'lines') {
                  showGradientLine = true;
              } else {
                  showLine = coloring === 'none' || coloring === 'heatmap' || contours.showlines;
              }
  
              if(contours.type === 'constraint') {
                  showFill = contours._operation !== '=';
              } else if(coloring === 'fill' || coloring === 'heatmap') {
                  showGradientFill = true;
              }
          }
  
          // with fill and no markers or text, move the line and fill up a bit
          // so it's more centered
          var markersOrText = subTypes.hasMarkers(trace) || subTypes.hasText(trace);
          var anyFill = showFill || showGradientFill;
          var anyLine = showLine || showGradientLine;
          var pathStart = (markersOrText || !anyFill) ? 'M5,0' :
              // with a line leave it slightly below center, to leave room for the
              // line thickness and because the line is usually more prominent
              anyLine ? 'M5,-2' : 'M5,-3';
  
          var this3 = d3.select(this);
  
          var fill = this3.select('.legendfill').selectAll('path')
              .data(showFill || showGradientFill ? [d] : []);
          fill.enter().append('path').classed('js-fill', true);
          fill.exit().remove();
          fill.attr('d', pathStart + 'h30v6h-30z')
              .call(showFill ? Drawing.fillGroupStyle : fillGradient);
  
          if(showLine || showGradientLine) {
              var lw = boundLineWidth(undefined, trace.line, MAX_LINE_WIDTH, CST_LINE_WIDTH);
              tMod = Lib.minExtend(trace, {line: {width: lw}});
              dMod = [Lib.minExtend(d0, {trace: tMod})];
          }
  
          var line = this3.select('.legendlines').selectAll('path')
              .data(showLine || showGradientLine ? [dMod] : []);
          line.enter().append('path').classed('js-line', true);
          line.exit().remove();
  
          // this is ugly... but you can't apply a gradient to a perfectly
          // horizontal or vertical line. Presumably because then
          // the system doesn't know how to scale vertical variation, even
          // though there *is* no vertical variation in this case.
          // so add an invisibly small angle to the line
          // This issue (and workaround) exist across (Mac) Chrome, FF, and Safari
          line.attr('d', pathStart + (showGradientLine ? 'l30,0.0001' : 'h30'))
              .call(showLine ? Drawing.lineGroupStyle : lineGradient);
      }
  
      function stylePoints(d) {
          var d0 = d[0];
          var trace = d0.trace;
          var showMarkers = subTypes.hasMarkers(trace);
          var showText = subTypes.hasText(trace);
          var showLines = subTypes.hasLines(trace);
          var dMod, tMod;
  
          // 'scatter3d' don't use gd.calcdata,
          // use d0.trace to infer arrayOk attributes
  
          function boundVal(attrIn, arrayToValFn, bounds, cst) {
              var valIn = Lib.nestedProperty(trace, attrIn).get();
              var valToBound = (Lib.isArrayOrTypedArray(valIn) && arrayToValFn) ?
                  arrayToValFn(valIn) :
                  valIn;
  
              if(constantItemSizing && valToBound && cst !== undefined) {
                  valToBound = cst;
              }
  
              if(bounds) {
                  if(valToBound < bounds[0]) return bounds[0];
                  else if(valToBound > bounds[1]) return bounds[1];
              }
              return valToBound;
          }
  
          function pickFirst(array) {
              if(d0._distinct && d0.index && array[d0.index]) return array[d0.index];
              return array[0];
          }
  
          // constrain text, markers, etc so they'll fit on the legend
          if(showMarkers || showText || showLines) {
              var dEdit = {};
              var tEdit = {};
  
              if(showMarkers) {
                  dEdit.mc = boundVal('marker.color', pickFirst);
                  dEdit.mx = boundVal('marker.symbol', pickFirst);
                  dEdit.mo = boundVal('marker.opacity', Lib.mean, [0.2, 1]);
                  dEdit.mlc = boundVal('marker.line.color', pickFirst);
                  dEdit.mlw = boundVal('marker.line.width', Lib.mean, [0, 5], CST_MARKER_LINE_WIDTH);
                  tEdit.marker = {
                      sizeref: 1,
                      sizemin: 1,
                      sizemode: 'diameter'
                  };
  
                  var ms = boundVal('marker.size', Lib.mean, [2, 16], CST_MARKER_SIZE);
                  dEdit.ms = ms;
                  tEdit.marker.size = ms;
              }
  
              if(showLines) {
                  tEdit.line = {
                      width: boundVal('line.width', pickFirst, [0, 10], CST_LINE_WIDTH)
                  };
              }
  
              if(showText) {
                  dEdit.tx = 'Aa';
                  dEdit.tp = boundVal('textposition', pickFirst);
                  dEdit.ts = 10;
                  dEdit.tc = boundVal('textfont.color', pickFirst);
                  dEdit.tf = boundVal('textfont.family', pickFirst);
              }
  
              dMod = [Lib.minExtend(d0, dEdit)];
              tMod = Lib.minExtend(trace, tEdit);
  
              // always show legend items in base state
              tMod.selectedpoints = null;
  
              // never show texttemplate
              tMod.texttemplate = null;
          }
  
          var ptgroup = d3.select(this).select('g.legendpoints');
  
          var pts = ptgroup.selectAll('path.scatterpts')
              .data(showMarkers ? dMod : []);
          // make sure marker is on the bottom, in case it enters after text
          pts.enter().insert('path', ':first-child')
              .classed('scatterpts', true)
              .attr('transform', 'translate(20,0)');
          pts.exit().remove();
          pts.call(Drawing.pointStyle, tMod, gd);
  
          // 'mrc' is set in pointStyle and used in textPointStyle:
          // constrain it here
          if(showMarkers) dMod[0].mrc = 3;
  
          var txt = ptgroup.selectAll('g.pointtext')
              .data(showText ? dMod : []);
          txt.enter()
              .append('g').classed('pointtext', true)
                  .append('text').attr('transform', 'translate(20,0)');
          txt.exit().remove();
          txt.selectAll('text').call(Drawing.textPointStyle, tMod, gd);
      }
  
      function styleWaterfalls(d) {
          var trace = d[0].trace;
          var isWaterfall = trace.type === 'waterfall';
  
          if(d[0]._distinct && isWaterfall) {
              var cont = d[0].trace[d[0].dir].marker;
              d[0].mc = cont.color;
              d[0].mlw = cont.line.width;
              d[0].mlc = cont.line.color;
              return styleBarLike(d, this, 'waterfall');
          }
  
          var ptsData = [];
          if(trace.visible && isWaterfall) {
              ptsData = d[0].hasTotals ?
                  [['increasing', 'M-6,-6V6H0Z'], ['totals', 'M6,6H0L-6,-6H-0Z'], ['decreasing', 'M6,6V-6H0Z']] :
                  [['increasing', 'M-6,-6V6H6Z'], ['decreasing', 'M6,6V-6H-6Z']];
          }
  
          var pts = d3.select(this).select('g.legendpoints')
              .selectAll('path.legendwaterfall')
              .data(ptsData);
          pts.enter().append('path').classed('legendwaterfall', true)
              .attr('transform', 'translate(20,0)')
              .style('stroke-miterlimit', 1);
          pts.exit().remove();
  
          pts.each(function(dd) {
              var pt = d3.select(this);
              var cont = trace[dd[0]].marker;
              var lw = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
  
              pt.attr('d', dd[1])
                  .style('stroke-width', lw + 'px')
                  .call(Color.fill, cont.color);
  
              if(lw) {
                  pt.call(Color.stroke, cont.line.color);
              }
          });
      }
  
      function styleBars(d) {
          styleBarLike(d, this);
      }
  
      function styleFunnels(d) {
          styleBarLike(d, this, 'funnel');
      }
  
      function styleBarLike(d, lThis, desiredType) {
          var trace = d[0].trace;
          var marker = trace.marker || {};
          var markerLine = marker.line || {};
  
          var isVisible = (!desiredType) ? Registry.traceIs(trace, 'bar') :
              (trace.visible && trace.type === desiredType);
  
          var barpath = d3.select(lThis).select('g.legendpoints')
              .selectAll('path.legend' + desiredType)
              .data(isVisible ? [d] : []);
          barpath.enter().append('path').classed('legend' + desiredType, true)
              .attr('d', 'M6,6H-6V-6H6Z')
              .attr('transform', 'translate(20,0)');
          barpath.exit().remove();
  
          barpath.each(function(d) {
              var p = d3.select(this);
              var d0 = d[0];
              var w = boundLineWidth(d0.mlw, marker.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
  
              p.style('stroke-width', w + 'px')
                  .call(Color.fill, d0.mc || marker.color);
  
              if(w) Color.stroke(p, d0.mlc || markerLine.color);
          });
      }
  
      function styleBoxes(d) {
          var trace = d[0].trace;
  
          var pts = d3.select(this).select('g.legendpoints')
              .selectAll('path.legendbox')
              .data(trace.visible && Registry.traceIs(trace, 'box-violin') ? [d] : []);
          pts.enter().append('path').classed('legendbox', true)
              // if we want the median bar, prepend M6,0H-6
              .attr('d', 'M6,6H-6V-6H6Z')
              .attr('transform', 'translate(20,0)');
          pts.exit().remove();
  
          pts.each(function() {
              var p = d3.select(this);
  
              if((trace.boxpoints === 'all' || trace.points === 'all') &&
                  Color.opacity(trace.fillcolor) === 0 && Color.opacity((trace.line || {}).color) === 0
              ) {
                  var tMod = Lib.minExtend(trace, {
                      marker: {
                          size: constantItemSizing ? CST_MARKER_SIZE : Lib.constrain(trace.marker.size, 2, 16),
                          sizeref: 1,
                          sizemin: 1,
                          sizemode: 'diameter'
                      }
                  });
                  pts.call(Drawing.pointStyle, tMod, gd);
              } else {
                  var w = boundLineWidth(undefined, trace.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
  
                  p.style('stroke-width', w + 'px')
                      .call(Color.fill, trace.fillcolor);
  
                  if(w) Color.stroke(p, trace.line.color);
              }
          });
      }
  
      function styleCandles(d) {
          var trace = d[0].trace;
  
          var pts = d3.select(this).select('g.legendpoints')
              .selectAll('path.legendcandle')
              .data(trace.visible && trace.type === 'candlestick' ? [d, d] : []);
          pts.enter().append('path').classed('legendcandle', true)
              .attr('d', function(_, i) {
                  if(i) return 'M-15,0H-8M-8,6V-6H8Z'; // increasing
                  return 'M15,0H8M8,-6V6H-8Z'; // decreasing
              })
              .attr('transform', 'translate(20,0)')
              .style('stroke-miterlimit', 1);
          pts.exit().remove();
  
          pts.each(function(_, i) {
              var p = d3.select(this);
              var cont = trace[i ? 'increasing' : 'decreasing'];
              var w = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
  
              p.style('stroke-width', w + 'px')
                  .call(Color.fill, cont.fillcolor);
  
              if(w) Color.stroke(p, cont.line.color);
          });
      }
  
      function styleOHLC(d) {
          var trace = d[0].trace;
  
          var pts = d3.select(this).select('g.legendpoints')
              .selectAll('path.legendohlc')
              .data(trace.visible && trace.type === 'ohlc' ? [d, d] : []);
          pts.enter().append('path').classed('legendohlc', true)
              .attr('d', function(_, i) {
                  if(i) return 'M-15,0H0M-8,-6V0'; // increasing
                  return 'M15,0H0M8,6V0'; // decreasing
              })
              .attr('transform', 'translate(20,0)')
              .style('stroke-miterlimit', 1);
          pts.exit().remove();
  
          pts.each(function(_, i) {
              var p = d3.select(this);
              var cont = trace[i ? 'increasing' : 'decreasing'];
              var w = boundLineWidth(undefined, cont.line, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
  
              p.style('fill', 'none')
                  .call(Drawing.dashLine, cont.line.dash, w);
  
              if(w) Color.stroke(p, cont.line.color);
          });
      }
  
      function stylePies(d) {
          stylePieLike(d, this, 'pie');
      }
  
      function styleFunnelareas(d) {
          stylePieLike(d, this, 'funnelarea');
      }
  
      function stylePieLike(d, lThis, desiredType) {
          var d0 = d[0];
          var trace = d0.trace;
  
          var isVisible = (!desiredType) ? Registry.traceIs(trace, desiredType) :
              (trace.visible && trace.type === desiredType);
  
          var pts = d3.select(lThis).select('g.legendpoints')
              .selectAll('path.legend' + desiredType)
              .data(isVisible ? [d] : []);
          pts.enter().append('path').classed('legend' + desiredType, true)
              .attr('d', 'M6,6H-6V-6H6Z')
              .attr('transform', 'translate(20,0)');
          pts.exit().remove();
  
          if(pts.size()) {
              var cont = (trace.marker || {}).line;
              var lw = boundLineWidth(pieCastOption(cont.width, d0.pts), cont, MAX_MARKER_LINE_WIDTH, CST_MARKER_LINE_WIDTH);
  
              var tMod = Lib.minExtend(trace, {marker: {line: {width: lw}}});
              // since minExtend do not slice more than 3 items we need to patch line.color here
              tMod.marker.line.color = cont.color;
  
              var d0Mod = Lib.minExtend(d0, {trace: tMod});
  
              stylePie(pts, d0Mod, tMod);
          }
      }
  
      function styleSpatial(d) { // i.e. maninly traces having z and colorscale
          var trace = d[0].trace;
  
          var useGradient;
          var ptsData = [];
          if(trace.visible) {
              switch(trace.type) {
                  case 'histogram2d' :
                  case 'heatmap' :
                      ptsData = [
                          ['M-15,-2V4H15V-2Z'] // similar to contour
                      ];
                      useGradient = true;
                      break;
                  case 'choropleth' :
                  case 'choroplethmapbox' :
                      ptsData = [
                          ['M-6,-6V6H6V-6Z']
                      ];
                      useGradient = true;
                      break;
                  case 'densitymapbox' :
                      ptsData = [
                          ['M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0']
                      ];
                      useGradient = 'radial';
                      break;
                  case 'cone' :
                      ptsData = [
                          ['M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z'],
                          ['M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z'],
                          ['M-6,-2 A2,2 0 0,0 -6,2 L6,0Z']
                      ];
                      useGradient = false;
                      break;
                  case 'streamtube' :
                      ptsData = [
                          ['M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z'],
                          ['M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z'],
                          ['M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z']
                      ];
                      useGradient = false;
                      break;
                  case 'surface' :
                      ptsData = [
                          ['M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z'],
                          ['M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z']
                      ];
                      useGradient = true;
                      break;
                  case 'mesh3d' :
                      ptsData = [
                          ['M-6,6H0L-6,-6Z'],
                          ['M6,6H0L6,-6Z'],
                          ['M-6,-6H6L0,6Z']
                      ];
                      useGradient = false;
                      break;
                  case 'volume' :
                      ptsData = [
                          ['M-6,6H0L-6,-6Z'],
                          ['M6,6H0L6,-6Z'],
                          ['M-6,-6H6L0,6Z']
                      ];
                      useGradient = true;
                      break;
                  case 'isosurface':
                      ptsData = [
                          ['M-6,6H0L-6,-6Z'],
                          ['M6,6H0L6,-6Z'],
                          ['M-6,-6 A12,24 0 0,0 6,-6 L0,6Z']
                      ];
                      useGradient = false;
                      break;
              }
          }
  
          var pts = d3.select(this).select('g.legendpoints')
              .selectAll('path.legend3dandfriends')
              .data(ptsData);
          pts.enter().append('path').classed('legend3dandfriends', true)
              .attr('transform', 'translate(20,0)')
              .style('stroke-miterlimit', 1);
          pts.exit().remove();
  
          pts.each(function(dd, i) {
              var pt = d3.select(this);
  
              var cOpts = extractOpts(trace);
              var colorscale = cOpts.colorscale;
              var reversescale = cOpts.reversescale;
              var fillGradient = function(s) {
                  if(s.size()) {
                      var gradientID = 'legendfill-' + trace.uid;
                      Drawing.gradient(s, gd, gradientID,
                          getGradientDirection(reversescale, useGradient === 'radial'),
                          colorscale, 'fill');
                  }
              };
  
              var fillColor;
              if(!colorscale) {
                  var color = trace.vertexcolor || trace.facecolor || trace.color;
                  fillColor = Lib.isArrayOrTypedArray(color) ? (color[i] || color[0]) : color;
              } else {
                  if(!useGradient) {
                      var len = colorscale.length;
                      fillColor =
                          i === 0 ? colorscale[reversescale ? len - 1 : 0][1] : // minimum
                          i === 1 ? colorscale[reversescale ? 0 : len - 1][1] : // maximum
                              colorscale[Math.floor((len - 1) / 2)][1]; // middle
                  }
              }
  
              pt.attr('d', dd[0]);
              if(fillColor) {
                  pt.call(Color.fill, fillColor);
              } else {
                  pt.call(fillGradient);
              }
          });
      }
  };
  
  function getGradientDirection(reversescale, isRadial) {
      var str = isRadial ? 'radial' : 'horizontal';
      return str + (reversescale ? '' : 'reversed');
  }
  
  },{"../../lib":750,"../../registry":882,"../../traces/pie/helpers":1137,"../../traces/pie/style_one":1143,"../../traces/scatter/subtypes":1183,"../color":615,"../colorscale/helpers":626,"../drawing":637,"d3":169}],674:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Plots = _dereq_('../../plots/plots');
  var axisIds = _dereq_('../../plots/cartesian/axis_ids');
  var Icons = _dereq_('../../fonts/ploticon');
  var eraseActiveShape = _dereq_('../shapes/draw').eraseActiveShape;
  var Lib = _dereq_('../../lib');
  var _ = Lib._;
  
  var modeBarButtons = module.exports = {};
  
  /**
   * ModeBar buttons configuration
   *
   * @param {string} name
   *      name / id of the buttons (for tracking)
   * @param {string} title
   *      text that appears while hovering over the button,
   *      enter null, false or '' for no hover text
   * @param {string} icon
   *      svg icon object associated with the button
   *      can be linked to Plotly.Icons to use the default plotly icons
   * @param {string} [gravity]
   *      icon positioning
   * @param {function} click
   *      click handler associated with the button, a function of
   *      'gd' (the main graph object) and
   *      'ev' (the event object)
   * @param {string} [attr]
   *      attribute associated with button,
   *      use this with 'val' to keep track of the state
   * @param {*} [val]
   *      initial 'attr' value, can be a function of gd
   * @param {boolean} [toggle]
   *      is the button a toggle button?
   */
  modeBarButtons.toImage = {
      name: 'toImage',
      title: function(gd) {
          var opts = gd._context.toImageButtonOptions || {};
          var format = opts.format || 'png';
          return format === 'png' ?
              _(gd, 'Download plot as a png') : // legacy text
              _(gd, 'Download plot'); // generic non-PNG text
      },
      icon: Icons.camera,
      click: function(gd) {
          var toImageButtonOptions = gd._context.toImageButtonOptions;
          var opts = {format: toImageButtonOptions.format || 'png'};
  
          Lib.notifier(_(gd, 'Taking snapshot - this may take a few seconds'), 'long');
  
          if(opts.format !== 'svg' && Lib.isIE()) {
              Lib.notifier(_(gd, 'IE only supports svg.  Changing format to svg.'), 'long');
              opts.format = 'svg';
          }
  
          ['filename', 'width', 'height', 'scale'].forEach(function(key) {
              if(key in toImageButtonOptions) {
                  opts[key] = toImageButtonOptions[key];
              }
          });
  
          Registry.call('downloadImage', gd, opts)
            .then(function(filename) {
                Lib.notifier(_(gd, 'Snapshot succeeded') + ' - ' + filename, 'long');
            })
            .catch(function() {
                Lib.notifier(_(gd, 'Sorry, there was a problem downloading your snapshot!'), 'long');
            });
      }
  };
  
  modeBarButtons.sendDataToCloud = {
      name: 'sendDataToCloud',
      title: function(gd) { return _(gd, 'Edit in Chart Studio'); },
      icon: Icons.disk,
      click: function(gd) {
          Plots.sendDataToCloud(gd);
      }
  };
  
  modeBarButtons.editInChartStudio = {
      name: 'editInChartStudio',
      title: function(gd) { return _(gd, 'Edit in Chart Studio'); },
      icon: Icons.pencil,
      click: function(gd) {
          Plots.sendDataToCloud(gd);
      }
  };
  
  modeBarButtons.zoom2d = {
      name: 'zoom2d',
      title: function(gd) { return _(gd, 'Zoom'); },
      attr: 'dragmode',
      val: 'zoom',
      icon: Icons.zoombox,
      click: handleCartesian
  };
  
  modeBarButtons.pan2d = {
      name: 'pan2d',
      title: function(gd) { return _(gd, 'Pan'); },
      attr: 'dragmode',
      val: 'pan',
      icon: Icons.pan,
      click: handleCartesian
  };
  
  modeBarButtons.select2d = {
      name: 'select2d',
      title: function(gd) { return _(gd, 'Box Select'); },
      attr: 'dragmode',
      val: 'select',
      icon: Icons.selectbox,
      click: handleCartesian
  };
  
  modeBarButtons.lasso2d = {
      name: 'lasso2d',
      title: function(gd) { return _(gd, 'Lasso Select'); },
      attr: 'dragmode',
      val: 'lasso',
      icon: Icons.lasso,
      click: handleCartesian
  };
  
  modeBarButtons.drawclosedpath = {
      name: 'drawclosedpath',
      title: function(gd) { return _(gd, 'Draw closed freeform'); },
      attr: 'dragmode',
      val: 'drawclosedpath',
      icon: Icons.drawclosedpath,
      click: handleCartesian
  };
  
  modeBarButtons.drawopenpath = {
      name: 'drawopenpath',
      title: function(gd) { return _(gd, 'Draw open freeform'); },
      attr: 'dragmode',
      val: 'drawopenpath',
      icon: Icons.drawopenpath,
      click: handleCartesian
  };
  
  modeBarButtons.drawline = {
      name: 'drawline',
      title: function(gd) { return _(gd, 'Draw line'); },
      attr: 'dragmode',
      val: 'drawline',
      icon: Icons.drawline,
      click: handleCartesian
  };
  
  modeBarButtons.drawrect = {
      name: 'drawrect',
      title: function(gd) { return _(gd, 'Draw rectangle'); },
      attr: 'dragmode',
      val: 'drawrect',
      icon: Icons.drawrect,
      click: handleCartesian
  };
  
  modeBarButtons.drawcircle = {
      name: 'drawcircle',
      title: function(gd) { return _(gd, 'Draw circle'); },
      attr: 'dragmode',
      val: 'drawcircle',
      icon: Icons.drawcircle,
      click: handleCartesian
  };
  
  modeBarButtons.eraseshape = {
      name: 'eraseshape',
      title: function(gd) { return _(gd, 'Erase active shape'); },
      icon: Icons.eraseshape,
      click: eraseActiveShape
  };
  
  modeBarButtons.zoomIn2d = {
      name: 'zoomIn2d',
      title: function(gd) { return _(gd, 'Zoom in'); },
      attr: 'zoom',
      val: 'in',
      icon: Icons.zoom_plus,
      click: handleCartesian
  };
  
  modeBarButtons.zoomOut2d = {
      name: 'zoomOut2d',
      title: function(gd) { return _(gd, 'Zoom out'); },
      attr: 'zoom',
      val: 'out',
      icon: Icons.zoom_minus,
      click: handleCartesian
  };
  
  modeBarButtons.autoScale2d = {
      name: 'autoScale2d',
      title: function(gd) { return _(gd, 'Autoscale'); },
      attr: 'zoom',
      val: 'auto',
      icon: Icons.autoscale,
      click: handleCartesian
  };
  
  modeBarButtons.resetScale2d = {
      name: 'resetScale2d',
      title: function(gd) { return _(gd, 'Reset axes'); },
      attr: 'zoom',
      val: 'reset',
      icon: Icons.home,
      click: handleCartesian
  };
  
  modeBarButtons.hoverClosestCartesian = {
      name: 'hoverClosestCartesian',
      title: function(gd) { return _(gd, 'Show closest data on hover'); },
      attr: 'hovermode',
      val: 'closest',
      icon: Icons.tooltip_basic,
      gravity: 'ne',
      click: handleCartesian
  };
  
  modeBarButtons.hoverCompareCartesian = {
      name: 'hoverCompareCartesian',
      title: function(gd) { return _(gd, 'Compare data on hover'); },
      attr: 'hovermode',
      val: function(gd) {
          return gd._fullLayout._isHoriz ? 'y' : 'x';
      },
      icon: Icons.tooltip_compare,
      gravity: 'ne',
      click: handleCartesian
  };
  
  function handleCartesian(gd, ev) {
      var button = ev.currentTarget;
      var astr = button.getAttribute('data-attr');
      var val = button.getAttribute('data-val') || true;
      var fullLayout = gd._fullLayout;
      var aobj = {};
      var axList = axisIds.list(gd, null, true);
      var allSpikesEnabled = fullLayout._cartesianSpikesEnabled;
  
      var ax, i;
  
      if(astr === 'zoom') {
          var mag = (val === 'in') ? 0.5 : 2;
          var r0 = (1 + mag) / 2;
          var r1 = (1 - mag) / 2;
          var axName;
  
          for(i = 0; i < axList.length; i++) {
              ax = axList[i];
  
              if(!ax.fixedrange) {
                  axName = ax._name;
                  if(val === 'auto') {
                      aobj[axName + '.autorange'] = true;
                  } else if(val === 'reset') {
                      if(ax._rangeInitial === undefined) {
                          aobj[axName + '.autorange'] = true;
                      } else {
                          var rangeInitial = ax._rangeInitial.slice();
                          aobj[axName + '.range[0]'] = rangeInitial[0];
                          aobj[axName + '.range[1]'] = rangeInitial[1];
                      }
  
                      // N.B. "reset" also resets showspikes
                      if(ax._showSpikeInitial !== undefined) {
                          aobj[axName + '.showspikes'] = ax._showSpikeInitial;
                          if(allSpikesEnabled === 'on' && !ax._showSpikeInitial) {
                              allSpikesEnabled = 'off';
                          }
                      }
                  } else {
                      var rangeNow = [
                          ax.r2l(ax.range[0]),
                          ax.r2l(ax.range[1]),
                      ];
  
                      var rangeNew = [
                          r0 * rangeNow[0] + r1 * rangeNow[1],
                          r0 * rangeNow[1] + r1 * rangeNow[0]
                      ];
  
                      aobj[axName + '.range[0]'] = ax.l2r(rangeNew[0]);
                      aobj[axName + '.range[1]'] = ax.l2r(rangeNew[1]);
                  }
              }
          }
      } else {
          // if ALL traces have orientation 'h', 'hovermode': 'x' otherwise: 'y'
          if(astr === 'hovermode' && (val === 'x' || val === 'y')) {
              val = fullLayout._isHoriz ? 'y' : 'x';
              button.setAttribute('data-val', val);
          }
  
          aobj[astr] = val;
      }
  
      fullLayout._cartesianSpikesEnabled = allSpikesEnabled;
  
      Registry.call('_guiRelayout', gd, aobj);
  }
  
  modeBarButtons.zoom3d = {
      name: 'zoom3d',
      title: function(gd) { return _(gd, 'Zoom'); },
      attr: 'scene.dragmode',
      val: 'zoom',
      icon: Icons.zoombox,
      click: handleDrag3d
  };
  
  modeBarButtons.pan3d = {
      name: 'pan3d',
      title: function(gd) { return _(gd, 'Pan'); },
      attr: 'scene.dragmode',
      val: 'pan',
      icon: Icons.pan,
      click: handleDrag3d
  };
  
  modeBarButtons.orbitRotation = {
      name: 'orbitRotation',
      title: function(gd) { return _(gd, 'Orbital rotation'); },
      attr: 'scene.dragmode',
      val: 'orbit',
      icon: Icons['3d_rotate'],
      click: handleDrag3d
  };
  
  modeBarButtons.tableRotation = {
      name: 'tableRotation',
      title: function(gd) { return _(gd, 'Turntable rotation'); },
      attr: 'scene.dragmode',
      val: 'turntable',
      icon: Icons['z-axis'],
      click: handleDrag3d
  };
  
  function handleDrag3d(gd, ev) {
      var button = ev.currentTarget;
      var attr = button.getAttribute('data-attr');
      var val = button.getAttribute('data-val') || true;
      var sceneIds = gd._fullLayout._subplots.gl3d || [];
      var layoutUpdate = {};
  
      var parts = attr.split('.');
  
      for(var i = 0; i < sceneIds.length; i++) {
          layoutUpdate[sceneIds[i] + '.' + parts[1]] = val;
      }
  
      // for multi-type subplots
      var val2d = (val === 'pan') ? val : 'zoom';
      layoutUpdate.dragmode = val2d;
  
      Registry.call('_guiRelayout', gd, layoutUpdate);
  }
  
  modeBarButtons.resetCameraDefault3d = {
      name: 'resetCameraDefault3d',
      title: function(gd) { return _(gd, 'Reset camera to default'); },
      attr: 'resetDefault',
      icon: Icons.home,
      click: handleCamera3d
  };
  
  modeBarButtons.resetCameraLastSave3d = {
      name: 'resetCameraLastSave3d',
      title: function(gd) { return _(gd, 'Reset camera to last save'); },
      attr: 'resetLastSave',
      icon: Icons.movie,
      click: handleCamera3d
  };
  
  function handleCamera3d(gd, ev) {
      var button = ev.currentTarget;
      var attr = button.getAttribute('data-attr');
      var resetLastSave = attr === 'resetLastSave';
      var resetDefault = attr === 'resetDefault';
  
      var fullLayout = gd._fullLayout;
      var sceneIds = fullLayout._subplots.gl3d || [];
      var aobj = {};
  
      for(var i = 0; i < sceneIds.length; i++) {
          var sceneId = sceneIds[i];
          var camera = sceneId + '.camera';
          var aspectratio = sceneId + '.aspectratio';
          var aspectmode = sceneId + '.aspectmode';
          var scene = fullLayout[sceneId]._scene;
          var didUpdate;
  
          if(resetLastSave) {
              aobj[camera + '.up'] = scene.viewInitial.up;
              aobj[camera + '.eye'] = scene.viewInitial.eye;
              aobj[camera + '.center'] = scene.viewInitial.center;
              didUpdate = true;
          } else if(resetDefault) {
              aobj[camera + '.up'] = null;
              aobj[camera + '.eye'] = null;
              aobj[camera + '.center'] = null;
              didUpdate = true;
          }
  
          if(didUpdate) {
              aobj[aspectratio + '.x'] = scene.viewInitial.aspectratio.x;
              aobj[aspectratio + '.y'] = scene.viewInitial.aspectratio.y;
              aobj[aspectratio + '.z'] = scene.viewInitial.aspectratio.z;
              aobj[aspectmode] = scene.viewInitial.aspectmode;
          }
      }
  
      Registry.call('_guiRelayout', gd, aobj);
  }
  
  modeBarButtons.hoverClosest3d = {
      name: 'hoverClosest3d',
      title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
      attr: 'hovermode',
      val: null,
      toggle: true,
      icon: Icons.tooltip_basic,
      gravity: 'ne',
      click: handleHover3d
  };
  
  function getNextHover3d(gd, ev) {
      var button = ev.currentTarget;
      var val = button._previousVal;
      var fullLayout = gd._fullLayout;
      var sceneIds = fullLayout._subplots.gl3d || [];
  
      var axes = ['xaxis', 'yaxis', 'zaxis'];
  
      // initialize 'current spike' object to be stored in the DOM
      var currentSpikes = {};
      var layoutUpdate = {};
  
      if(val) {
          layoutUpdate = val;
          button._previousVal = null;
      } else {
          for(var i = 0; i < sceneIds.length; i++) {
              var sceneId = sceneIds[i];
              var sceneLayout = fullLayout[sceneId];
  
              var hovermodeAStr = sceneId + '.hovermode';
              currentSpikes[hovermodeAStr] = sceneLayout.hovermode;
              layoutUpdate[hovermodeAStr] = false;
  
              // copy all the current spike attrs
              for(var j = 0; j < 3; j++) {
                  var axis = axes[j];
                  var spikeAStr = sceneId + '.' + axis + '.showspikes';
                  layoutUpdate[spikeAStr] = false;
                  currentSpikes[spikeAStr] = sceneLayout[axis].showspikes;
              }
          }
  
          button._previousVal = currentSpikes;
      }
      return layoutUpdate;
  }
  
  function handleHover3d(gd, ev) {
      var layoutUpdate = getNextHover3d(gd, ev);
      Registry.call('_guiRelayout', gd, layoutUpdate);
  }
  
  modeBarButtons.zoomInGeo = {
      name: 'zoomInGeo',
      title: function(gd) { return _(gd, 'Zoom in'); },
      attr: 'zoom',
      val: 'in',
      icon: Icons.zoom_plus,
      click: handleGeo
  };
  
  modeBarButtons.zoomOutGeo = {
      name: 'zoomOutGeo',
      title: function(gd) { return _(gd, 'Zoom out'); },
      attr: 'zoom',
      val: 'out',
      icon: Icons.zoom_minus,
      click: handleGeo
  };
  
  modeBarButtons.resetGeo = {
      name: 'resetGeo',
      title: function(gd) { return _(gd, 'Reset'); },
      attr: 'reset',
      val: null,
      icon: Icons.autoscale,
      click: handleGeo
  };
  
  modeBarButtons.hoverClosestGeo = {
      name: 'hoverClosestGeo',
      title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
      attr: 'hovermode',
      val: null,
      toggle: true,
      icon: Icons.tooltip_basic,
      gravity: 'ne',
      click: toggleHover
  };
  
  function handleGeo(gd, ev) {
      var button = ev.currentTarget;
      var attr = button.getAttribute('data-attr');
      var val = button.getAttribute('data-val') || true;
      var fullLayout = gd._fullLayout;
      var geoIds = fullLayout._subplots.geo || [];
  
      for(var i = 0; i < geoIds.length; i++) {
          var id = geoIds[i];
          var geoLayout = fullLayout[id];
  
          if(attr === 'zoom') {
              var scale = geoLayout.projection.scale;
              var newScale = (val === 'in') ? 2 * scale : 0.5 * scale;
  
              Registry.call('_guiRelayout', gd, id + '.projection.scale', newScale);
          }
      }
  
      if(attr === 'reset') {
          resetView(gd, 'geo');
      }
  }
  
  modeBarButtons.hoverClosestGl2d = {
      name: 'hoverClosestGl2d',
      title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
      attr: 'hovermode',
      val: null,
      toggle: true,
      icon: Icons.tooltip_basic,
      gravity: 'ne',
      click: toggleHover
  };
  
  modeBarButtons.hoverClosestPie = {
      name: 'hoverClosestPie',
      title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
      attr: 'hovermode',
      val: 'closest',
      icon: Icons.tooltip_basic,
      gravity: 'ne',
      click: toggleHover
  };
  
  function getNextHover(gd) {
      var fullLayout = gd._fullLayout;
  
      if(fullLayout.hovermode) return false;
  
      if(fullLayout._has('cartesian')) {
          return fullLayout._isHoriz ? 'y' : 'x';
      }
      return 'closest';
  }
  
  function toggleHover(gd) {
      var newHover = getNextHover(gd);
      Registry.call('_guiRelayout', gd, 'hovermode', newHover);
  }
  
  modeBarButtons.resetViewSankey = {
      name: 'resetSankeyGroup',
      title: function(gd) { return _(gd, 'Reset view'); },
      icon: Icons.home,
      click: function(gd) {
          var aObj = {
              'node.groups': [],
              'node.x': [],
              'node.y': []
          };
          for(var i = 0; i < gd._fullData.length; i++) {
              var viewInitial = gd._fullData[i]._viewInitial;
              aObj['node.groups'].push(viewInitial.node.groups.slice());
              aObj['node.x'].push(viewInitial.node.x.slice());
              aObj['node.y'].push(viewInitial.node.y.slice());
          }
          Registry.call('restyle', gd, aObj);
      }
  };
  
  // buttons when more then one plot types are present
  
  modeBarButtons.toggleHover = {
      name: 'toggleHover',
      title: function(gd) { return _(gd, 'Toggle show closest data on hover'); },
      attr: 'hovermode',
      val: null,
      toggle: true,
      icon: Icons.tooltip_basic,
      gravity: 'ne',
      click: function(gd, ev) {
          var layoutUpdate = getNextHover3d(gd, ev);
          layoutUpdate.hovermode = getNextHover(gd);
  
          Registry.call('_guiRelayout', gd, layoutUpdate);
      }
  };
  
  modeBarButtons.resetViews = {
      name: 'resetViews',
      title: function(gd) { return _(gd, 'Reset views'); },
      icon: Icons.home,
      click: function(gd, ev) {
          var button = ev.currentTarget;
  
          button.setAttribute('data-attr', 'zoom');
          button.setAttribute('data-val', 'reset');
          handleCartesian(gd, ev);
  
          button.setAttribute('data-attr', 'resetLastSave');
          handleCamera3d(gd, ev);
  
          resetView(gd, 'geo');
          resetView(gd, 'mapbox');
      }
  };
  
  modeBarButtons.toggleSpikelines = {
      name: 'toggleSpikelines',
      title: function(gd) { return _(gd, 'Toggle Spike Lines'); },
      icon: Icons.spikeline,
      attr: '_cartesianSpikesEnabled',
      val: 'on',
      click: function(gd) {
          var fullLayout = gd._fullLayout;
          var allSpikesEnabled = fullLayout._cartesianSpikesEnabled;
  
          fullLayout._cartesianSpikesEnabled = allSpikesEnabled === 'on' ? 'off' : 'on';
          Registry.call('_guiRelayout', gd, setSpikelineVisibility(gd));
      }
  };
  
  function setSpikelineVisibility(gd) {
      var fullLayout = gd._fullLayout;
      var areSpikesOn = fullLayout._cartesianSpikesEnabled === 'on';
      var axList = axisIds.list(gd, null, true);
      var aobj = {};
  
      for(var i = 0; i < axList.length; i++) {
          var ax = axList[i];
          aobj[ax._name + '.showspikes'] = areSpikesOn ? true : ax._showSpikeInitial;
      }
  
      return aobj;
  }
  
  modeBarButtons.resetViewMapbox = {
      name: 'resetViewMapbox',
      title: function(gd) { return _(gd, 'Reset view'); },
      attr: 'reset',
      icon: Icons.home,
      click: function(gd) {
          resetView(gd, 'mapbox');
      }
  };
  
  modeBarButtons.zoomInMapbox = {
      name: 'zoomInMapbox',
      title: function(gd) { return _(gd, 'Zoom in'); },
      attr: 'zoom',
      val: 'in',
      icon: Icons.zoom_plus,
      click: handleMapboxZoom
  };
  
  modeBarButtons.zoomOutMapbox = {
      name: 'zoomOutMapbox',
      title: function(gd) { return _(gd, 'Zoom out'); },
      attr: 'zoom',
      val: 'out',
      icon: Icons.zoom_minus,
      click: handleMapboxZoom
  };
  
  function handleMapboxZoom(gd, ev) {
      var button = ev.currentTarget;
      var val = button.getAttribute('data-val');
      var fullLayout = gd._fullLayout;
      var subplotIds = fullLayout._subplots.mapbox || [];
      var scalar = 1.05;
      var aObj = {};
  
      for(var i = 0; i < subplotIds.length; i++) {
          var id = subplotIds[i];
          var current = fullLayout[id].zoom;
          var next = (val === 'in') ? scalar * current : current / scalar;
          aObj[id + '.zoom'] = next;
      }
  
      Registry.call('_guiRelayout', gd, aObj);
  }
  
  function resetView(gd, subplotType) {
      var fullLayout = gd._fullLayout;
      var subplotIds = fullLayout._subplots[subplotType] || [];
      var aObj = {};
  
      for(var i = 0; i < subplotIds.length; i++) {
          var id = subplotIds[i];
          var subplotObj = fullLayout[id]._subplot;
          var viewInitial = subplotObj.viewInitial;
          var viewKeys = Object.keys(viewInitial);
  
          for(var j = 0; j < viewKeys.length; j++) {
              var key = viewKeys[j];
              aObj[id + '.' + key] = viewInitial[key];
          }
      }
  
      Registry.call('_guiRelayout', gd, aObj);
  }
  
  },{"../../fonts/ploticon":729,"../../lib":750,"../../plots/cartesian/axis_ids":802,"../../plots/plots":862,"../../registry":882,"../shapes/draw":696}],675:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  exports.manage = _dereq_('./manage');
  
  },{"./manage":676}],676:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var axisIds = _dereq_('../../plots/cartesian/axis_ids');
  var scatterSubTypes = _dereq_('../../traces/scatter/subtypes');
  var Registry = _dereq_('../../registry');
  var isUnifiedHover = _dereq_('../fx/helpers').isUnifiedHover;
  
  var createModeBar = _dereq_('./modebar');
  var modeBarButtons = _dereq_('./buttons');
  
  /**
   * ModeBar wrapper around 'create' and 'update',
   * chooses buttons to pass to ModeBar constructor based on
   * plot type and plot config.
   *
   * @param {object} gd main plot object
   *
   */
  module.exports = function manageModeBar(gd) {
      var fullLayout = gd._fullLayout;
      var context = gd._context;
      var modeBar = fullLayout._modeBar;
  
      if(!context.displayModeBar && !context.watermark) {
          if(modeBar) {
              modeBar.destroy();
              delete fullLayout._modeBar;
          }
          return;
      }
  
      if(!Array.isArray(context.modeBarButtonsToRemove)) {
          throw new Error([
              '*modeBarButtonsToRemove* configuration options',
              'must be an array.'
          ].join(' '));
      }
  
      if(!Array.isArray(context.modeBarButtonsToAdd)) {
          throw new Error([
              '*modeBarButtonsToAdd* configuration options',
              'must be an array.'
          ].join(' '));
      }
  
      var customButtons = context.modeBarButtons;
      var buttonGroups;
  
      if(Array.isArray(customButtons) && customButtons.length) {
          buttonGroups = fillCustomButton(customButtons);
      } else if(!context.displayModeBar && context.watermark) {
          buttonGroups = [];
      } else {
          buttonGroups = getButtonGroups(gd);
      }
  
      if(modeBar) modeBar.update(gd, buttonGroups);
      else fullLayout._modeBar = createModeBar(gd, buttonGroups);
  };
  
  var DRAW_MODES = [
      'drawline',
      'drawopenpath',
      'drawclosedpath',
      'drawcircle',
      'drawrect',
      'eraseshape'
  ];
  
  // logic behind which buttons are displayed by default
  function getButtonGroups(gd) {
      var fullLayout = gd._fullLayout;
      var fullData = gd._fullData;
      var context = gd._context;
      var buttonsToRemove = context.modeBarButtonsToRemove;
      var buttonsToAdd = context.modeBarButtonsToAdd;
  
      var hasCartesian = fullLayout._has('cartesian');
      var hasGL3D = fullLayout._has('gl3d');
      var hasGeo = fullLayout._has('geo');
      var hasPie = fullLayout._has('pie');
      var hasFunnelarea = fullLayout._has('funnelarea');
      var hasGL2D = fullLayout._has('gl2d');
      var hasTernary = fullLayout._has('ternary');
      var hasMapbox = fullLayout._has('mapbox');
      var hasPolar = fullLayout._has('polar');
      var hasSankey = fullLayout._has('sankey');
      var allAxesFixed = areAllAxesFixed(fullLayout);
      var hasUnifiedHoverLabel = isUnifiedHover(fullLayout.hovermode);
  
      var groups = [];
  
      function addGroup(newGroup) {
          if(!newGroup.length) return;
  
          var out = [];
  
          for(var i = 0; i < newGroup.length; i++) {
              var button = newGroup[i];
              if(buttonsToRemove.indexOf(button) !== -1) continue;
              out.push(modeBarButtons[button]);
          }
  
          groups.push(out);
      }
  
      // buttons common to all plot types
      var commonGroup = ['toImage'];
      if(context.showEditInChartStudio) commonGroup.push('editInChartStudio');
      else if(context.showSendToCloud) commonGroup.push('sendDataToCloud');
      addGroup(commonGroup);
  
      var zoomGroup = [];
      var hoverGroup = [];
      var resetGroup = [];
      var dragModeGroup = [];
  
      if((hasCartesian || hasGL2D || hasPie || hasFunnelarea || hasTernary) + hasGeo + hasGL3D + hasMapbox + hasPolar > 1) {
          // graphs with more than one plot types get 'union buttons'
          // which reset the view or toggle hover labels across all subplots.
          hoverGroup = ['toggleHover'];
          resetGroup = ['resetViews'];
      } else if(hasGeo) {
          zoomGroup = ['zoomInGeo', 'zoomOutGeo'];
          hoverGroup = ['hoverClosestGeo'];
          resetGroup = ['resetGeo'];
      } else if(hasGL3D) {
          hoverGroup = ['hoverClosest3d'];
          resetGroup = ['resetCameraDefault3d', 'resetCameraLastSave3d'];
      } else if(hasMapbox) {
          zoomGroup = ['zoomInMapbox', 'zoomOutMapbox'];
          hoverGroup = ['toggleHover'];
          resetGroup = ['resetViewMapbox'];
      } else if(hasGL2D) {
          hoverGroup = ['hoverClosestGl2d'];
      } else if(hasPie) {
          hoverGroup = ['hoverClosestPie'];
      } else if(hasSankey) {
          hoverGroup = ['hoverClosestCartesian', 'hoverCompareCartesian'];
          resetGroup = ['resetViewSankey'];
      } else { // hasPolar, hasTernary
          // always show at least one hover icon.
          hoverGroup = ['toggleHover'];
      }
      // if we have cartesian, allow switching between closest and compare
      // regardless of what other types are on the plot, since they'll all
      // just treat any truthy hovermode as 'closest'
      if(hasCartesian) {
          hoverGroup = ['toggleSpikelines', 'hoverClosestCartesian', 'hoverCompareCartesian'];
      }
      if(hasNoHover(fullData) || hasUnifiedHoverLabel) {
          hoverGroup = [];
      }
  
      if((hasCartesian || hasGL2D) && !allAxesFixed) {
          zoomGroup = ['zoomIn2d', 'zoomOut2d', 'autoScale2d'];
          if(resetGroup[0] !== 'resetViews') resetGroup = ['resetScale2d'];
      }
  
      if(hasGL3D) {
          dragModeGroup = ['zoom3d', 'pan3d', 'orbitRotation', 'tableRotation'];
      } else if(((hasCartesian || hasGL2D) && !allAxesFixed) || hasTernary) {
          dragModeGroup = ['zoom2d', 'pan2d'];
      } else if(hasMapbox || hasGeo) {
          dragModeGroup = ['pan2d'];
      } else if(hasPolar) {
          dragModeGroup = ['zoom2d'];
      }
      if(isSelectable(fullData)) {
          dragModeGroup.push('select2d', 'lasso2d');
      }
  
      // accept pre-defined buttons as string
      if(Array.isArray(buttonsToAdd)) {
          var newList = [];
          for(var i = 0; i < buttonsToAdd.length; i++) {
              var b = buttonsToAdd[i];
              if(typeof b === 'string') {
                  if(DRAW_MODES.indexOf(b) !== -1) {
                      if(
                          fullLayout._has('mapbox') || // draw shapes in paper coordinate (could be improved in future to support data coordinate, when there is no pitch)
                          fullLayout._has('cartesian') // draw shapes in data coordinate
                      ) {
                          dragModeGroup.push(b);
                      }
                  }
              } else newList.push(b);
          }
          buttonsToAdd = newList;
      }
  
      addGroup(dragModeGroup);
      addGroup(zoomGroup.concat(resetGroup));
      addGroup(hoverGroup);
  
      return appendButtonsToGroups(groups, buttonsToAdd);
  }
  
  function areAllAxesFixed(fullLayout) {
      var axList = axisIds.list({_fullLayout: fullLayout}, null, true);
  
      for(var i = 0; i < axList.length; i++) {
          if(!axList[i].fixedrange) {
              return false;
          }
      }
  
      return true;
  }
  
  // look for traces that support selection
  // to be updated as we add more selectPoints handlers
  function isSelectable(fullData) {
      var selectable = false;
  
      for(var i = 0; i < fullData.length; i++) {
          if(selectable) break;
  
          var trace = fullData[i];
  
          if(!trace._module || !trace._module.selectPoints) continue;
  
          if(Registry.traceIs(trace, 'scatter-like')) {
              if(scatterSubTypes.hasMarkers(trace) || scatterSubTypes.hasText(trace)) {
                  selectable = true;
              }
          } else if(Registry.traceIs(trace, 'box-violin')) {
              if(trace.boxpoints === 'all' || trace.points === 'all') {
                  selectable = true;
              }
          } else {
              // assume that in general if the trace module has selectPoints,
              // then it's selectable. Scatter is an exception to this because it must
              // have markers or text, not just be a scatter type.
  
              selectable = true;
          }
      }
  
      return selectable;
  }
  
  // check whether all trace are 'noHover'
  function hasNoHover(fullData) {
      for(var i = 0; i < fullData.length; i++) {
          if(!Registry.traceIs(fullData[i], 'noHover')) return false;
      }
      return true;
  }
  
  function appendButtonsToGroups(groups, buttons) {
      if(buttons.length) {
          if(Array.isArray(buttons[0])) {
              for(var i = 0; i < buttons.length; i++) {
                  groups.push(buttons[i]);
              }
          } else groups.push(buttons);
      }
  
      return groups;
  }
  
  // fill in custom buttons referring to default mode bar buttons
  function fillCustomButton(customButtons) {
      for(var i = 0; i < customButtons.length; i++) {
          var buttonGroup = customButtons[i];
  
          for(var j = 0; j < buttonGroup.length; j++) {
              var button = buttonGroup[j];
  
              if(typeof button === 'string') {
                  if(modeBarButtons[button] !== undefined) {
                      customButtons[i][j] = modeBarButtons[button];
                  } else {
                      throw new Error([
                          '*modeBarButtons* configuration options',
                          'invalid button name'
                      ].join(' '));
                  }
              }
          }
      }
  
      return customButtons;
  }
  
  },{"../../plots/cartesian/axis_ids":802,"../../registry":882,"../../traces/scatter/subtypes":1183,"../fx/helpers":651,"./buttons":674,"./modebar":677}],677:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var Icons = _dereq_('../../fonts/ploticon');
  var Parser = new DOMParser();
  
  /**
   * UI controller for interactive plots
   * @Class
   * @Param {object} opts
   * @Param {object} opts.buttons    nested arrays of grouped buttons config objects
   * @Param {object} opts.container  container div to append modeBar
   * @Param {object} opts.graphInfo  primary plot object containing data and layout
   */
  function ModeBar(opts) {
      this.container = opts.container;
      this.element = document.createElement('div');
  
      this.update(opts.graphInfo, opts.buttons);
  
      this.container.appendChild(this.element);
  }
  
  var proto = ModeBar.prototype;
  
  /**
   * Update modeBar (buttons and logo)
   *
   * @param {object} graphInfo  primary plot object containing data and layout
   * @param {array of arrays} buttons nested arrays of grouped buttons to initialize
   *
   */
  proto.update = function(graphInfo, buttons) {
      this.graphInfo = graphInfo;
  
      var context = this.graphInfo._context;
      var fullLayout = this.graphInfo._fullLayout;
      var modeBarId = 'modebar-' + fullLayout._uid;
  
      this.element.setAttribute('id', modeBarId);
      this._uid = modeBarId;
  
      this.element.className = 'modebar';
      if(context.displayModeBar === 'hover') this.element.className += ' modebar--hover ease-bg';
  
      if(fullLayout.modebar.orientation === 'v') {
          this.element.className += ' vertical';
          buttons = buttons.reverse();
      }
  
      var style = fullLayout.modebar;
      var bgSelector = context.displayModeBar === 'hover' ? '.js-plotly-plot .plotly:hover ' : '';
  
      Lib.deleteRelatedStyleRule(modeBarId);
      Lib.addRelatedStyleRule(modeBarId, bgSelector + '#' + modeBarId + ' .modebar-group', 'background-color: ' + style.bgcolor);
      Lib.addRelatedStyleRule(modeBarId, '#' + modeBarId + ' .modebar-btn .icon path', 'fill: ' + style.color);
      Lib.addRelatedStyleRule(modeBarId, '#' + modeBarId + ' .modebar-btn:hover .icon path', 'fill: ' + style.activecolor);
      Lib.addRelatedStyleRule(modeBarId, '#' + modeBarId + ' .modebar-btn.active .icon path', 'fill: ' + style.activecolor);
  
      // if buttons or logo have changed, redraw modebar interior
      var needsNewButtons = !this.hasButtons(buttons);
      var needsNewLogo = (this.hasLogo !== context.displaylogo);
      var needsNewLocale = (this.locale !== context.locale);
  
      this.locale = context.locale;
  
      if(needsNewButtons || needsNewLogo || needsNewLocale) {
          this.removeAllButtons();
  
          this.updateButtons(buttons);
  
          if(context.watermark || context.displaylogo) {
              var logoGroup = this.getLogo();
              if(context.watermark) {
                  logoGroup.className = logoGroup.className + ' watermark';
              }
  
              if(fullLayout.modebar.orientation === 'v') {
                  this.element.insertBefore(logoGroup, this.element.childNodes[0]);
              } else {
                  this.element.appendChild(logoGroup);
              }
  
              this.hasLogo = true;
          }
      }
  
      this.updateActiveButton();
  };
  
  proto.updateButtons = function(buttons) {
      var _this = this;
  
      this.buttons = buttons;
      this.buttonElements = [];
      this.buttonsNames = [];
  
      this.buttons.forEach(function(buttonGroup) {
          var group = _this.createGroup();
  
          buttonGroup.forEach(function(buttonConfig) {
              var buttonName = buttonConfig.name;
              if(!buttonName) {
                  throw new Error('must provide button \'name\' in button config');
              }
              if(_this.buttonsNames.indexOf(buttonName) !== -1) {
                  throw new Error('button name \'' + buttonName + '\' is taken');
              }
              _this.buttonsNames.push(buttonName);
  
              var button = _this.createButton(buttonConfig);
              _this.buttonElements.push(button);
              group.appendChild(button);
          });
  
          _this.element.appendChild(group);
      });
  };
  
  /**
   * Empty div for containing a group of buttons
   * @Return {HTMLelement}
   */
  proto.createGroup = function() {
      var group = document.createElement('div');
      group.className = 'modebar-group';
      return group;
  };
  
  /**
   * Create a new button div and set constant and configurable attributes
   * @Param {object} config (see ./buttons.js for more info)
   * @Return {HTMLelement}
   */
  proto.createButton = function(config) {
      var _this = this;
      var button = document.createElement('a');
  
      button.setAttribute('rel', 'tooltip');
      button.className = 'modebar-btn';
  
      var title = config.title;
      if(title === undefined) title = config.name;
      // for localization: allow title to be a callable that takes gd as arg
      else if(typeof title === 'function') title = title(this.graphInfo);
  
      if(title || title === 0) button.setAttribute('data-title', title);
  
      if(config.attr !== undefined) button.setAttribute('data-attr', config.attr);
  
      var val = config.val;
      if(val !== undefined) {
          if(typeof val === 'function') val = val(this.graphInfo);
          button.setAttribute('data-val', val);
      }
  
      var click = config.click;
      if(typeof click !== 'function') {
          throw new Error('must provide button \'click\' function in button config');
      } else {
          button.addEventListener('click', function(ev) {
              config.click(_this.graphInfo, ev);
  
              // only needed for 'hoverClosestGeo' which does not call relayout
              _this.updateActiveButton(ev.currentTarget);
          });
      }
  
      button.setAttribute('data-toggle', config.toggle || false);
      if(config.toggle) d3.select(button).classed('active', true);
  
      var icon = config.icon;
      if(typeof icon === 'function') {
          button.appendChild(icon());
      } else {
          button.appendChild(this.createIcon(icon || Icons.question));
      }
      button.setAttribute('data-gravity', config.gravity || 'n');
  
      return button;
  };
  
  /**
   * Add an icon to a button
   * @Param {object} thisIcon
   * @Param {number} thisIcon.width
   * @Param {string} thisIcon.path
   * @Param {string} thisIcon.color
   * @Return {HTMLelement}
   */
  proto.createIcon = function(thisIcon) {
      var iconHeight = isNumeric(thisIcon.height) ?
          Number(thisIcon.height) :
          thisIcon.ascent - thisIcon.descent;
      var svgNS = 'http://www.w3.org/2000/svg';
      var icon;
  
      if(thisIcon.path) {
          icon = document.createElementNS(svgNS, 'svg');
          icon.setAttribute('viewBox', [0, 0, thisIcon.width, iconHeight].join(' '));
          icon.setAttribute('class', 'icon');
  
          var path = document.createElementNS(svgNS, 'path');
          path.setAttribute('d', thisIcon.path);
  
          if(thisIcon.transform) {
              path.setAttribute('transform', thisIcon.transform);
          } else if(thisIcon.ascent !== undefined) {
              // Legacy icon transform calculation
              path.setAttribute('transform', 'matrix(1 0 0 -1 0 ' + thisIcon.ascent + ')');
          }
  
          icon.appendChild(path);
      }
  
      if(thisIcon.svg) {
          var svgDoc = Parser.parseFromString(thisIcon.svg, 'application/xml');
          icon = svgDoc.childNodes[0];
      }
  
      icon.setAttribute('height', '1em');
      icon.setAttribute('width', '1em');
  
      return icon;
  };
  
  /**
   * Updates active button with attribute specified in layout
   * @Param {object} graphInfo plot object containing data and layout
   * @Return {HTMLelement}
   */
  proto.updateActiveButton = function(buttonClicked) {
      var fullLayout = this.graphInfo._fullLayout;
      var dataAttrClicked = (buttonClicked !== undefined) ?
          buttonClicked.getAttribute('data-attr') :
          null;
  
      this.buttonElements.forEach(function(button) {
          var thisval = button.getAttribute('data-val') || true;
          var dataAttr = button.getAttribute('data-attr');
          var isToggleButton = (button.getAttribute('data-toggle') === 'true');
          var button3 = d3.select(button);
  
          // Use 'data-toggle' and 'buttonClicked' to toggle buttons
          // that have no one-to-one equivalent in fullLayout
          if(isToggleButton) {
              if(dataAttr === dataAttrClicked) {
                  button3.classed('active', !button3.classed('active'));
              }
          } else {
              var val = (dataAttr === null) ?
                  dataAttr :
                  Lib.nestedProperty(fullLayout, dataAttr).get();
  
              button3.classed('active', val === thisval);
          }
      });
  };
  
  /**
   * Check if modeBar is configured as button configuration argument
   *
   * @Param {object} buttons 2d array of grouped button config objects
   * @Return {boolean}
   */
  proto.hasButtons = function(buttons) {
      var currentButtons = this.buttons;
  
      if(!currentButtons) return false;
  
      if(buttons.length !== currentButtons.length) return false;
  
      for(var i = 0; i < buttons.length; ++i) {
          if(buttons[i].length !== currentButtons[i].length) return false;
          for(var j = 0; j < buttons[i].length; j++) {
              if(buttons[i][j].name !== currentButtons[i][j].name) return false;
          }
      }
  
      return true;
  };
  
  /**
   * @return {HTMLDivElement} The logo image wrapped in a group
   */
  proto.getLogo = function() {
      var group = this.createGroup();
      var a = document.createElement('a');
  
      a.href = 'https://plotly.com/';
      a.target = '_blank';
      a.setAttribute('data-title', Lib._(this.graphInfo, 'Produced with Plotly'));
      a.className = 'modebar-btn plotlyjsicon modebar-btn--logo';
  
      a.appendChild(this.createIcon(Icons.newplotlylogo));
  
      group.appendChild(a);
      return group;
  };
  
  proto.removeAllButtons = function() {
      while(this.element.firstChild) {
          this.element.removeChild(this.element.firstChild);
      }
  
      this.hasLogo = false;
  };
  
  proto.destroy = function() {
      Lib.removeElement(this.container.querySelector('.modebar'));
      Lib.deleteRelatedStyleRule(this._uid);
  };
  
  function createModeBar(gd, buttons) {
      var fullLayout = gd._fullLayout;
  
      var modeBar = new ModeBar({
          graphInfo: gd,
          container: fullLayout._modebardiv.node(),
          buttons: buttons
      });
  
      if(fullLayout._privateplot) {
          d3.select(modeBar.element).append('span')
              .classed('badge-private float--left', true)
              .text('PRIVATE');
      }
  
      return modeBar;
  }
  
  module.exports = createModeBar;
  
  },{"../../fonts/ploticon":729,"../../lib":750,"d3":169,"fast-isnumeric":241}],678:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var colorAttrs = _dereq_('../color/attributes');
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  
  var buttonAttrs = templatedArray('button', {
      visible: {
          valType: 'boolean',
          
          dflt: true,
          editType: 'plot',
          
      },
      step: {
          valType: 'enumerated',
          
          values: ['month', 'year', 'day', 'hour', 'minute', 'second', 'all'],
          dflt: 'month',
          editType: 'plot',
          
      },
      stepmode: {
          valType: 'enumerated',
          
          values: ['backward', 'todate'],
          dflt: 'backward',
          editType: 'plot',
          
      },
      count: {
          valType: 'number',
          
          min: 0,
          dflt: 1,
          editType: 'plot',
          
      },
      label: {
          valType: 'string',
          
          editType: 'plot',
          
      },
      editType: 'plot',
      
  });
  
  module.exports = {
      visible: {
          valType: 'boolean',
          
          editType: 'plot',
          
      },
  
      buttons: buttonAttrs,
  
      x: {
          valType: 'number',
          min: -2,
          max: 3,
          
          editType: 'plot',
          
      },
      xanchor: {
          valType: 'enumerated',
          values: ['auto', 'left', 'center', 'right'],
          dflt: 'left',
          
          editType: 'plot',
          
      },
      y: {
          valType: 'number',
          min: -2,
          max: 3,
          
          editType: 'plot',
          
      },
      yanchor: {
          valType: 'enumerated',
          values: ['auto', 'top', 'middle', 'bottom'],
          dflt: 'bottom',
          
          editType: 'plot',
          
      },
  
      font: fontAttrs({
          editType: 'plot',
          
      }),
  
      bgcolor: {
          valType: 'color',
          dflt: colorAttrs.lightLine,
          
          editType: 'plot',
          
      },
      activecolor: {
          valType: 'color',
          
          editType: 'plot',
          
      },
      bordercolor: {
          valType: 'color',
          dflt: colorAttrs.defaultLine,
          
          editType: 'plot',
          
      },
      borderwidth: {
          valType: 'number',
          min: 0,
          dflt: 0,
          
          editType: 'plot',
          
      },
      editType: 'plot'
  };
  
  },{"../../plot_api/plot_template":788,"../../plots/font_attributes":827,"../color/attributes":614}],679:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  module.exports = {
  
      // 'y' position pad above counter axis domain
      yPad: 0.02,
  
      // minimum button width (regardless of text size)
      minButtonWidth: 30,
  
      // buttons rect radii
      rx: 3,
      ry: 3,
  
      // light fraction used to compute the 'activecolor' default
      lightAmount: 25,
      darkAmount: 10
  };
  
  },{}],680:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../color');
  var Template = _dereq_('../../plot_api/plot_template');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  
  var attributes = _dereq_('./attributes');
  var constants = _dereq_('./constants');
  
  
  module.exports = function handleDefaults(containerIn, containerOut, layout, counterAxes, calendar) {
      var selectorIn = containerIn.rangeselector || {};
      var selectorOut = Template.newContainer(containerOut, 'rangeselector');
  
      function coerce(attr, dflt) {
          return Lib.coerce(selectorIn, selectorOut, attributes, attr, dflt);
      }
  
      var buttons = handleArrayContainerDefaults(selectorIn, selectorOut, {
          name: 'buttons',
          handleItemDefaults: buttonDefaults,
          calendar: calendar
      });
  
      var visible = coerce('visible', buttons.length > 0);
      if(visible) {
          var posDflt = getPosDflt(containerOut, layout, counterAxes);
          coerce('x', posDflt[0]);
          coerce('y', posDflt[1]);
          Lib.noneOrAll(containerIn, containerOut, ['x', 'y']);
  
          coerce('xanchor');
          coerce('yanchor');
  
          Lib.coerceFont(coerce, 'font', layout.font);
  
          var bgColor = coerce('bgcolor');
          coerce('activecolor', Color.contrast(bgColor, constants.lightAmount, constants.darkAmount));
          coerce('bordercolor');
          coerce('borderwidth');
      }
  };
  
  function buttonDefaults(buttonIn, buttonOut, selectorOut, opts) {
      var calendar = opts.calendar;
  
      function coerce(attr, dflt) {
          return Lib.coerce(buttonIn, buttonOut, attributes.buttons, attr, dflt);
      }
  
      var visible = coerce('visible');
  
      if(visible) {
          var step = coerce('step');
          if(step !== 'all') {
              if(calendar && calendar !== 'gregorian' && (step === 'month' || step === 'year')) {
                  buttonOut.stepmode = 'backward';
              } else {
                  coerce('stepmode');
              }
  
              coerce('count');
          }
  
          coerce('label');
      }
  }
  
  function getPosDflt(containerOut, layout, counterAxes) {
      var anchoredList = counterAxes.filter(function(ax) {
          return layout[ax].anchor === containerOut._id;
      });
  
      var posY = 0;
      for(var i = 0; i < anchoredList.length; i++) {
          var domain = layout[anchoredList[i]].domain;
          if(domain) posY = Math.max(domain[1], posY);
      }
  
      return [containerOut.domain[0], posY + constants.yPad];
  }
  
  },{"../../lib":750,"../../plot_api/plot_template":788,"../../plots/array_container_defaults":794,"../color":615,"./attributes":678,"./constants":679}],681:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Registry = _dereq_('../../registry');
  var Plots = _dereq_('../../plots/plots');
  var Color = _dereq_('../color');
  var Drawing = _dereq_('../drawing');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var axisIds = _dereq_('../../plots/cartesian/axis_ids');
  
  var alignmentConstants = _dereq_('../../constants/alignment');
  var LINE_SPACING = alignmentConstants.LINE_SPACING;
  var FROM_TL = alignmentConstants.FROM_TL;
  var FROM_BR = alignmentConstants.FROM_BR;
  
  var constants = _dereq_('./constants');
  var getUpdateObject = _dereq_('./get_update_object');
  
  module.exports = function draw(gd) {
      var fullLayout = gd._fullLayout;
  
      var selectors = fullLayout._infolayer.selectAll('.rangeselector')
          .data(makeSelectorData(gd), selectorKeyFunc);
  
      selectors.enter().append('g')
          .classed('rangeselector', true);
  
      selectors.exit().remove();
  
      selectors.style({
          cursor: 'pointer',
          'pointer-events': 'all'
      });
  
      selectors.each(function(d) {
          var selector = d3.select(this);
          var axisLayout = d;
          var selectorLayout = axisLayout.rangeselector;
  
          var buttons = selector.selectAll('g.button')
              .data(Lib.filterVisible(selectorLayout.buttons));
  
          buttons.enter().append('g')
              .classed('button', true);
  
          buttons.exit().remove();
  
          buttons.each(function(d) {
              var button = d3.select(this);
              var update = getUpdateObject(axisLayout, d);
  
              d._isActive = isActive(axisLayout, d, update);
  
              button.call(drawButtonRect, selectorLayout, d);
              button.call(drawButtonText, selectorLayout, d, gd);
  
              button.on('click', function() {
                  if(gd._dragged) return;
  
                  Registry.call('_guiRelayout', gd, update);
              });
  
              button.on('mouseover', function() {
                  d._isHovered = true;
                  button.call(drawButtonRect, selectorLayout, d);
              });
  
              button.on('mouseout', function() {
                  d._isHovered = false;
                  button.call(drawButtonRect, selectorLayout, d);
              });
          });
  
          reposition(gd, buttons, selectorLayout, axisLayout._name, selector);
      });
  };
  
  function makeSelectorData(gd) {
      var axes = axisIds.list(gd, 'x', true);
      var data = [];
  
      for(var i = 0; i < axes.length; i++) {
          var axis = axes[i];
  
          if(axis.rangeselector && axis.rangeselector.visible) {
              data.push(axis);
          }
      }
  
      return data;
  }
  
  function selectorKeyFunc(d) {
      return d._id;
  }
  
  function isActive(axisLayout, opts, update) {
      if(opts.step === 'all') {
          return axisLayout.autorange === true;
      } else {
          var keys = Object.keys(update);
  
          return (
              axisLayout.range[0] === update[keys[0]] &&
              axisLayout.range[1] === update[keys[1]]
          );
      }
  }
  
  function drawButtonRect(button, selectorLayout, d) {
      var rect = Lib.ensureSingle(button, 'rect', 'selector-rect', function(s) {
          s.attr('shape-rendering', 'crispEdges');
      });
  
      rect.attr({
          'rx': constants.rx,
          'ry': constants.ry
      });
  
      rect.call(Color.stroke, selectorLayout.bordercolor)
          .call(Color.fill, getFillColor(selectorLayout, d))
          .style('stroke-width', selectorLayout.borderwidth + 'px');
  }
  
  function getFillColor(selectorLayout, d) {
      return (d._isActive || d._isHovered) ?
          selectorLayout.activecolor :
          selectorLayout.bgcolor;
  }
  
  function drawButtonText(button, selectorLayout, d, gd) {
      function textLayout(s) {
          svgTextUtils.convertToTspans(s, gd);
      }
  
      var text = Lib.ensureSingle(button, 'text', 'selector-text', function(s) {
          s.attr('text-anchor', 'middle');
      });
  
      text.call(Drawing.font, selectorLayout.font)
          .text(getLabel(d, gd._fullLayout._meta))
          .call(textLayout);
  }
  
  function getLabel(opts, _meta) {
      if(opts.label) {
          return _meta ?
              Lib.templateString(opts.label, _meta) :
              opts.label;
      }
  
      if(opts.step === 'all') return 'all';
  
      return opts.count + opts.step.charAt(0);
  }
  
  function reposition(gd, buttons, opts, axName, selector) {
      var width = 0;
      var height = 0;
  
      var borderWidth = opts.borderwidth;
  
      buttons.each(function() {
          var button = d3.select(this);
          var text = button.select('.selector-text');
  
          var tHeight = opts.font.size * LINE_SPACING;
          var hEff = Math.max(tHeight * svgTextUtils.lineCount(text), 16) + 3;
  
          height = Math.max(height, hEff);
      });
  
      buttons.each(function() {
          var button = d3.select(this);
          var rect = button.select('.selector-rect');
          var text = button.select('.selector-text');
  
          var tWidth = text.node() && Drawing.bBox(text.node()).width;
          var tHeight = opts.font.size * LINE_SPACING;
          var tLines = svgTextUtils.lineCount(text);
  
          var wEff = Math.max(tWidth + 10, constants.minButtonWidth);
  
          // TODO add MathJax support
  
          // TODO add buttongap attribute
  
          button.attr('transform', 'translate(' +
              (borderWidth + width) + ',' + borderWidth +
          ')');
  
          rect.attr({
              x: 0,
              y: 0,
              width: wEff,
              height: height
          });
  
          svgTextUtils.positionText(text, wEff / 2,
              height / 2 - ((tLines - 1) * tHeight / 2) + 3);
  
          width += wEff + 5;
      });
  
      var graphSize = gd._fullLayout._size;
      var lx = graphSize.l + graphSize.w * opts.x;
      var ly = graphSize.t + graphSize.h * (1 - opts.y);
  
      var xanchor = 'left';
      if(Lib.isRightAnchor(opts)) {
          lx -= width;
          xanchor = 'right';
      }
      if(Lib.isCenterAnchor(opts)) {
          lx -= width / 2;
          xanchor = 'center';
      }
  
      var yanchor = 'top';
      if(Lib.isBottomAnchor(opts)) {
          ly -= height;
          yanchor = 'bottom';
      }
      if(Lib.isMiddleAnchor(opts)) {
          ly -= height / 2;
          yanchor = 'middle';
      }
  
      width = Math.ceil(width);
      height = Math.ceil(height);
      lx = Math.round(lx);
      ly = Math.round(ly);
  
      Plots.autoMargin(gd, axName + '-range-selector', {
          x: opts.x,
          y: opts.y,
          l: width * FROM_TL[xanchor],
          r: width * FROM_BR[xanchor],
          b: height * FROM_BR[yanchor],
          t: height * FROM_TL[yanchor]
      });
  
      selector.attr('transform', 'translate(' + lx + ',' + ly + ')');
  }
  
  },{"../../constants/alignment":717,"../../lib":750,"../../lib/svg_text_utils":774,"../../plots/cartesian/axis_ids":802,"../../plots/plots":862,"../../registry":882,"../color":615,"../drawing":637,"./constants":679,"./get_update_object":682,"d3":169}],682:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  module.exports = function getUpdateObject(axisLayout, buttonLayout) {
      var axName = axisLayout._name;
      var update = {};
  
      if(buttonLayout.step === 'all') {
          update[axName + '.autorange'] = true;
      } else {
          var xrange = getXRange(axisLayout, buttonLayout);
  
          update[axName + '.range[0]'] = xrange[0];
          update[axName + '.range[1]'] = xrange[1];
      }
  
      return update;
  };
  
  function getXRange(axisLayout, buttonLayout) {
      var currentRange = axisLayout.range;
      var base = new Date(axisLayout.r2l(currentRange[1]));
      var step = buttonLayout.step;
      var count = buttonLayout.count;
      var range0;
  
      switch(buttonLayout.stepmode) {
          case 'backward':
              range0 = axisLayout.l2r(+d3.time[step].utc.offset(base, -count));
              break;
  
          case 'todate':
              var base2 = d3.time[step].utc.offset(base, -count);
  
              range0 = axisLayout.l2r(+d3.time[step].utc.ceil(base2));
              break;
      }
  
      var range1 = currentRange[1];
  
      return [range0, range1];
  }
  
  },{"d3":169}],683:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'component',
      name: 'rangeselector',
  
      schema: {
          subplots: {
              xaxis: {rangeselector: _dereq_('./attributes')}
          }
      },
  
      layoutAttributes: _dereq_('./attributes'),
      handleDefaults: _dereq_('./defaults'),
  
      draw: _dereq_('./draw')
  };
  
  },{"./attributes":678,"./defaults":680,"./draw":681}],684:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorAttributes = _dereq_('../color/attributes');
  
  module.exports = {
      bgcolor: {
          valType: 'color',
          dflt: colorAttributes.background,
          
          editType: 'plot',
          
      },
      bordercolor: {
          valType: 'color',
          dflt: colorAttributes.defaultLine,
          
          editType: 'plot',
          
      },
      borderwidth: {
          valType: 'integer',
          dflt: 0,
          min: 0,
          
          editType: 'plot',
          
      },
      autorange: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          impliedEdits: {'range[0]': undefined, 'range[1]': undefined},
          
      },
      range: {
          valType: 'info_array',
          
          items: [
              {valType: 'any', editType: 'calc', impliedEdits: {'^autorange': false}},
              {valType: 'any', editType: 'calc', impliedEdits: {'^autorange': false}}
          ],
          editType: 'calc',
          impliedEdits: {'autorange': false},
          
      },
      thickness: {
          valType: 'number',
          dflt: 0.15,
          min: 0,
          max: 1,
          
          editType: 'plot',
          
      },
      visible: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          
      },
      editType: 'calc'
  };
  
  },{"../color/attributes":614}],685:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var listAxes = _dereq_('../../plots/cartesian/axis_ids').list;
  var getAutoRange = _dereq_('../../plots/cartesian/autorange').getAutoRange;
  var constants = _dereq_('./constants');
  
  module.exports = function calcAutorange(gd) {
      var axes = listAxes(gd, 'x', true);
  
      // Compute new slider range using axis autorange if necessary.
      //
      // Copy back range to input range slider container to skip
      // this step in subsequent draw calls.
  
      for(var i = 0; i < axes.length; i++) {
          var ax = axes[i];
          var opts = ax[constants.name];
  
          if(opts && opts.visible && opts.autorange) {
              opts._input.autorange = true;
              opts._input.range = opts.range = getAutoRange(gd, ax);
          }
      }
  };
  
  },{"../../plots/cartesian/autorange":798,"../../plots/cartesian/axis_ids":802,"./constants":686}],686:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
  
      // attribute container name
      name: 'rangeslider',
  
      // class names
  
      containerClassName: 'rangeslider-container',
      bgClassName: 'rangeslider-bg',
      rangePlotClassName: 'rangeslider-rangeplot',
  
      maskMinClassName: 'rangeslider-mask-min',
      maskMaxClassName: 'rangeslider-mask-max',
      slideBoxClassName: 'rangeslider-slidebox',
  
      grabberMinClassName: 'rangeslider-grabber-min',
      grabAreaMinClassName: 'rangeslider-grabarea-min',
      handleMinClassName: 'rangeslider-handle-min',
  
      grabberMaxClassName: 'rangeslider-grabber-max',
      grabAreaMaxClassName: 'rangeslider-grabarea-max',
      handleMaxClassName: 'rangeslider-handle-max',
  
      maskMinOppAxisClassName: 'rangeslider-mask-min-opp-axis',
      maskMaxOppAxisClassName: 'rangeslider-mask-max-opp-axis',
  
      // style constants
  
      maskColor: 'rgba(0,0,0,0.4)',
      maskOppAxisColor: 'rgba(0,0,0,0.2)',
  
      slideBoxFill: 'transparent',
      slideBoxCursor: 'ew-resize',
  
      grabAreaFill: 'transparent',
      grabAreaCursor: 'col-resize',
      grabAreaWidth: 10,
  
      handleWidth: 4,
      handleRadius: 1,
      handleStrokeWidth: 1,
  
      extraPad: 15
  };
  
  },{}],687:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Template = _dereq_('../../plot_api/plot_template');
  var axisIds = _dereq_('../../plots/cartesian/axis_ids');
  
  var attributes = _dereq_('./attributes');
  var oppAxisAttrs = _dereq_('./oppaxis_attributes');
  
  module.exports = function handleDefaults(layoutIn, layoutOut, axName) {
      var axIn = layoutIn[axName];
      var axOut = layoutOut[axName];
  
      if(!(axIn.rangeslider || layoutOut._requestRangeslider[axOut._id])) return;
  
      // not super proud of this (maybe store _ in axis object instead
      if(!Lib.isPlainObject(axIn.rangeslider)) {
          axIn.rangeslider = {};
      }
  
      var containerIn = axIn.rangeslider;
      var containerOut = Template.newContainer(axOut, 'rangeslider');
  
      function coerce(attr, dflt) {
          return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
      }
  
      var rangeContainerIn, rangeContainerOut;
      function coerceRange(attr, dflt) {
          return Lib.coerce(rangeContainerIn, rangeContainerOut, oppAxisAttrs, attr, dflt);
      }
  
      var visible = coerce('visible');
      if(!visible) return;
  
      coerce('bgcolor', layoutOut.plot_bgcolor);
      coerce('bordercolor');
      coerce('borderwidth');
      coerce('thickness');
  
      coerce('autorange', !axOut.isValidRange(containerIn.range));
      coerce('range');
  
      var subplots = layoutOut._subplots;
      if(subplots) {
          var yIds = subplots.cartesian
              .filter(function(subplotId) {
                  return subplotId.substr(0, subplotId.indexOf('y')) === axisIds.name2id(axName);
              })
              .map(function(subplotId) {
                  return subplotId.substr(subplotId.indexOf('y'), subplotId.length);
              });
          var yNames = Lib.simpleMap(yIds, axisIds.id2name);
          for(var i = 0; i < yNames.length; i++) {
              var yName = yNames[i];
  
              rangeContainerIn = containerIn[yName] || {};
              rangeContainerOut = Template.newContainer(containerOut, yName, 'yaxis');
  
              var yAxOut = layoutOut[yName];
  
              var rangemodeDflt;
              if(rangeContainerIn.range && yAxOut.isValidRange(rangeContainerIn.range)) {
                  rangemodeDflt = 'fixed';
              }
  
              var rangeMode = coerceRange('rangemode', rangemodeDflt);
              if(rangeMode !== 'match') {
                  coerceRange('range', yAxOut.range.slice());
              }
          }
      }
  
      // to map back range slider (auto) range
      containerOut._input = containerIn;
  };
  
  },{"../../lib":750,"../../plot_api/plot_template":788,"../../plots/cartesian/axis_ids":802,"./attributes":684,"./oppaxis_attributes":691}],688:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Registry = _dereq_('../../registry');
  var Plots = _dereq_('../../plots/plots');
  
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../drawing');
  var Color = _dereq_('../color');
  var Titles = _dereq_('../titles');
  
  var Cartesian = _dereq_('../../plots/cartesian');
  var axisIDs = _dereq_('../../plots/cartesian/axis_ids');
  
  var dragElement = _dereq_('../dragelement');
  var setCursor = _dereq_('../../lib/setcursor');
  
  var constants = _dereq_('./constants');
  
  module.exports = function(gd) {
      var fullLayout = gd._fullLayout;
      var rangeSliderData = fullLayout._rangeSliderData;
      for(var i = 0; i < rangeSliderData.length; i++) {
          var opts = rangeSliderData[i][constants.name];
          // fullLayout._uid may not exist when we call makeData
          opts._clipId = opts._id + '-' + fullLayout._uid;
      }
  
      /*
       * <g container />
       *  <rect bg />
       *  < .... range plot />
       *  <rect mask-min />
       *  <rect mask-max />
       *  <rect slidebox />
       *  <g grabber-min />
       *      <rect handle-min />
       *      <rect grabare-min />
       *  <g grabber-max />
       *      <rect handle-max />
       *      <rect grabare-max />
       *
       *  ...
       */
  
      function keyFunction(axisOpts) {
          return axisOpts._name;
      }
  
      var rangeSliders = fullLayout._infolayer
          .selectAll('g.' + constants.containerClassName)
          .data(rangeSliderData, keyFunction);
  
      // remove exiting sliders and their corresponding clip paths
      rangeSliders.exit().each(function(axisOpts) {
          var opts = axisOpts[constants.name];
          fullLayout._topdefs.select('#' + opts._clipId).remove();
      }).remove();
  
      // return early if no range slider is visible
      if(rangeSliderData.length === 0) return;
  
      rangeSliders.enter().append('g')
          .classed(constants.containerClassName, true)
          .attr('pointer-events', 'all');
  
      // for all present range sliders
      rangeSliders.each(function(axisOpts) {
          var rangeSlider = d3.select(this);
          var opts = axisOpts[constants.name];
          var oppAxisOpts = fullLayout[axisIDs.id2name(axisOpts.anchor)];
          var oppAxisRangeOpts = opts[axisIDs.id2name(axisOpts.anchor)];
  
          // update range
          // Expand slider range to the axis range
          if(opts.range) {
              var rng = Lib.simpleMap(opts.range, axisOpts.r2l);
              var axRng = Lib.simpleMap(axisOpts.range, axisOpts.r2l);
              var newRng;
  
              if(axRng[0] < axRng[1]) {
                  newRng = [
                      Math.min(rng[0], axRng[0]),
                      Math.max(rng[1], axRng[1])
                  ];
              } else {
                  newRng = [
                      Math.max(rng[0], axRng[0]),
                      Math.min(rng[1], axRng[1])
                  ];
              }
  
              opts.range = opts._input.range = Lib.simpleMap(newRng, axisOpts.l2r);
          }
  
          axisOpts.cleanRange('rangeslider.range');
  
          // update range slider dimensions
  
          var gs = fullLayout._size;
          var domain = axisOpts.domain;
  
          opts._width = gs.w * (domain[1] - domain[0]);
  
          var x = Math.round(gs.l + (gs.w * domain[0]));
  
          var y = Math.round(
              gs.t + gs.h * (1 - axisOpts._counterDomainMin) +
              (axisOpts.side === 'bottom' ? axisOpts._depth : 0) +
              opts._offsetShift + constants.extraPad
          );
  
          rangeSlider.attr('transform', 'translate(' + x + ',' + y + ')');
  
          // update data <--> pixel coordinate conversion methods
  
          opts._rl = Lib.simpleMap(opts.range, axisOpts.r2l);
          var rl0 = opts._rl[0];
          var rl1 = opts._rl[1];
          var drl = rl1 - rl0;
  
          opts.p2d = function(v) {
              return (v / opts._width) * drl + rl0;
          };
  
          opts.d2p = function(v) {
              return (v - rl0) / drl * opts._width;
          };
  
          if(axisOpts.rangebreaks) {
              var rsBreaks = axisOpts.locateBreaks(rl0, rl1);
  
              if(rsBreaks.length) {
                  var j, brk;
  
                  var lBreaks = 0;
                  for(j = 0; j < rsBreaks.length; j++) {
                      brk = rsBreaks[j];
                      lBreaks += (brk.max - brk.min);
                  }
  
                  // TODO fix for reversed-range axes !!!
  
                  // compute slope and piecewise offsets
                  var m2 = opts._width / (rl1 - rl0 - lBreaks);
                  var _B = [-m2 * rl0];
                  for(j = 0; j < rsBreaks.length; j++) {
                      brk = rsBreaks[j];
                      _B.push(_B[_B.length - 1] - m2 * (brk.max - brk.min));
                  }
  
                  opts.d2p = function(v) {
                      var b = _B[0];
                      for(var j = 0; j < rsBreaks.length; j++) {
                          var brk = rsBreaks[j];
                          if(v >= brk.max) b = _B[j + 1];
                          else if(v < brk.min) break;
                      }
                      return b + m2 * v;
                  };
  
                  // fill pixel (i.e. 'p') min/max here,
                  // to not have to loop through the _rangebreaks twice during `p2d`
                  for(j = 0; j < rsBreaks.length; j++) {
                      brk = rsBreaks[j];
                      brk.pmin = opts.d2p(brk.min);
                      brk.pmax = opts.d2p(brk.max);
                  }
  
                  opts.p2d = function(v) {
                      var b = _B[0];
                      for(var j = 0; j < rsBreaks.length; j++) {
                          var brk = rsBreaks[j];
                          if(v >= brk.pmax) b = _B[j + 1];
                          else if(v < brk.pmin) break;
                      }
                      return (v - b) / m2;
                  };
              }
          }
  
          if(oppAxisRangeOpts.rangemode !== 'match') {
              var range0OppAxis = oppAxisOpts.r2l(oppAxisRangeOpts.range[0]);
              var range1OppAxis = oppAxisOpts.r2l(oppAxisRangeOpts.range[1]);
              var distOppAxis = range1OppAxis - range0OppAxis;
  
              opts.d2pOppAxis = function(v) {
                  return (v - range0OppAxis) / distOppAxis * opts._height;
              };
          }
  
          // update inner nodes
  
          rangeSlider
              .call(drawBg, gd, axisOpts, opts)
              .call(addClipPath, gd, axisOpts, opts)
              .call(drawRangePlot, gd, axisOpts, opts)
              .call(drawMasks, gd, axisOpts, opts, oppAxisRangeOpts)
              .call(drawSlideBox, gd, axisOpts, opts)
              .call(drawGrabbers, gd, axisOpts, opts);
  
          // setup drag element
          setupDragElement(rangeSlider, gd, axisOpts, opts);
  
          // update current range
          setPixelRange(rangeSlider, gd, axisOpts, opts, oppAxisOpts, oppAxisRangeOpts);
  
          // title goes next to range slider instead of tick labels, so
          // just take it over and draw it from here
          if(axisOpts.side === 'bottom') {
              Titles.draw(gd, axisOpts._id + 'title', {
                  propContainer: axisOpts,
                  propName: axisOpts._name + '.title',
                  placeholder: fullLayout._dfltTitle.x,
                  attributes: {
                      x: axisOpts._offset + axisOpts._length / 2,
                      y: y + opts._height + opts._offsetShift + 10 + 1.5 * axisOpts.title.font.size,
                      'text-anchor': 'middle'
                  }
              });
          }
      });
  };
  
  function setupDragElement(rangeSlider, gd, axisOpts, opts) {
      if(gd._context.staticPlot) return;
  
      var slideBox = rangeSlider.select('rect.' + constants.slideBoxClassName).node();
      var grabAreaMin = rangeSlider.select('rect.' + constants.grabAreaMinClassName).node();
      var grabAreaMax = rangeSlider.select('rect.' + constants.grabAreaMaxClassName).node();
  
      function mouseDownHandler() {
          var event = d3.event;
          var target = event.target;
          var startX = event.clientX || event.touches[0].clientX;
          var offsetX = startX - rangeSlider.node().getBoundingClientRect().left;
          var minVal = opts.d2p(axisOpts._rl[0]);
          var maxVal = opts.d2p(axisOpts._rl[1]);
  
          var dragCover = dragElement.coverSlip();
  
          this.addEventListener('touchmove', mouseMove);
          this.addEventListener('touchend', mouseUp);
          dragCover.addEventListener('mousemove', mouseMove);
          dragCover.addEventListener('mouseup', mouseUp);
  
          function mouseMove(e) {
              var clientX = e.clientX || e.touches[0].clientX;
              var delta = +clientX - startX;
              var pixelMin, pixelMax, cursor;
  
              switch(target) {
                  case slideBox:
                      cursor = 'ew-resize';
                      pixelMin = minVal + delta;
                      pixelMax = maxVal + delta;
                      break;
  
                  case grabAreaMin:
                      cursor = 'col-resize';
                      pixelMin = minVal + delta;
                      pixelMax = maxVal;
                      break;
  
                  case grabAreaMax:
                      cursor = 'col-resize';
                      pixelMin = minVal;
                      pixelMax = maxVal + delta;
                      break;
  
                  default:
                      cursor = 'ew-resize';
                      pixelMin = offsetX;
                      pixelMax = offsetX + delta;
                      break;
              }
  
              if(pixelMax < pixelMin) {
                  var tmp = pixelMax;
                  pixelMax = pixelMin;
                  pixelMin = tmp;
              }
  
              opts._pixelMin = pixelMin;
              opts._pixelMax = pixelMax;
  
              setCursor(d3.select(dragCover), cursor);
              setDataRange(rangeSlider, gd, axisOpts, opts);
          }
  
          function mouseUp() {
              dragCover.removeEventListener('mousemove', mouseMove);
              dragCover.removeEventListener('mouseup', mouseUp);
              this.removeEventListener('touchmove', mouseMove);
              this.removeEventListener('touchend', mouseUp);
              Lib.removeElement(dragCover);
          }
      }
  
      rangeSlider.on('mousedown', mouseDownHandler);
      rangeSlider.on('touchstart', mouseDownHandler);
  }
  
  function setDataRange(rangeSlider, gd, axisOpts, opts) {
      function clamp(v) {
          return axisOpts.l2r(Lib.constrain(v, opts._rl[0], opts._rl[1]));
      }
  
      var dataMin = clamp(opts.p2d(opts._pixelMin));
      var dataMax = clamp(opts.p2d(opts._pixelMax));
  
      window.requestAnimationFrame(function() {
          Registry.call('_guiRelayout', gd, axisOpts._name + '.range', [dataMin, dataMax]);
      });
  }
  
  function setPixelRange(rangeSlider, gd, axisOpts, opts, oppAxisOpts, oppAxisRangeOpts) {
      var hw2 = constants.handleWidth / 2;
  
      function clamp(v) {
          return Lib.constrain(v, 0, opts._width);
      }
  
      function clampOppAxis(v) {
          return Lib.constrain(v, 0, opts._height);
      }
  
      function clampHandle(v) {
          return Lib.constrain(v, -hw2, opts._width + hw2);
      }
  
      var pixelMin = clamp(opts.d2p(axisOpts._rl[0]));
      var pixelMax = clamp(opts.d2p(axisOpts._rl[1]));
  
      rangeSlider.select('rect.' + constants.slideBoxClassName)
          .attr('x', pixelMin)
          .attr('width', pixelMax - pixelMin);
  
      rangeSlider.select('rect.' + constants.maskMinClassName)
          .attr('width', pixelMin);
  
      rangeSlider.select('rect.' + constants.maskMaxClassName)
          .attr('x', pixelMax)
          .attr('width', opts._width - pixelMax);
  
      if(oppAxisRangeOpts.rangemode !== 'match') {
          var pixelMinOppAxis = opts._height - clampOppAxis(opts.d2pOppAxis(oppAxisOpts._rl[1]));
          var pixelMaxOppAxis = opts._height - clampOppAxis(opts.d2pOppAxis(oppAxisOpts._rl[0]));
  
          rangeSlider.select('rect.' + constants.maskMinOppAxisClassName)
              .attr('x', pixelMin)
              .attr('height', pixelMinOppAxis)
              .attr('width', pixelMax - pixelMin);
  
          rangeSlider.select('rect.' + constants.maskMaxOppAxisClassName)
              .attr('x', pixelMin)
              .attr('y', pixelMaxOppAxis)
              .attr('height', opts._height - pixelMaxOppAxis)
              .attr('width', pixelMax - pixelMin);
  
          rangeSlider.select('rect.' + constants.slideBoxClassName)
              .attr('y', pixelMinOppAxis)
              .attr('height', pixelMaxOppAxis - pixelMinOppAxis);
      }
  
      // add offset for crispier corners
      // https://github.com/plotly/plotly.js/pull/1409
      var offset = 0.5;
  
      var xMin = Math.round(clampHandle(pixelMin - hw2)) - offset;
      var xMax = Math.round(clampHandle(pixelMax - hw2)) + offset;
  
      rangeSlider.select('g.' + constants.grabberMinClassName)
          .attr('transform', 'translate(' + xMin + ',' + offset + ')');
  
      rangeSlider.select('g.' + constants.grabberMaxClassName)
          .attr('transform', 'translate(' + xMax + ',' + offset + ')');
  }
  
  function drawBg(rangeSlider, gd, axisOpts, opts) {
      var bg = Lib.ensureSingle(rangeSlider, 'rect', constants.bgClassName, function(s) {
          s.attr({
              x: 0,
              y: 0,
              'shape-rendering': 'crispEdges'
          });
      });
  
      var borderCorrect = (opts.borderwidth % 2) === 0 ?
          opts.borderwidth :
          opts.borderwidth - 1;
  
      var offsetShift = -opts._offsetShift;
      var lw = Drawing.crispRound(gd, opts.borderwidth);
  
      bg.attr({
          width: opts._width + borderCorrect,
          height: opts._height + borderCorrect,
          transform: 'translate(' + offsetShift + ',' + offsetShift + ')',
          fill: opts.bgcolor,
          stroke: opts.bordercolor,
          'stroke-width': lw
      });
  }
  
  function addClipPath(rangeSlider, gd, axisOpts, opts) {
      var fullLayout = gd._fullLayout;
  
      var clipPath = Lib.ensureSingleById(fullLayout._topdefs, 'clipPath', opts._clipId, function(s) {
          s.append('rect').attr({ x: 0, y: 0 });
      });
  
      clipPath.select('rect').attr({
          width: opts._width,
          height: opts._height
      });
  }
  
  function drawRangePlot(rangeSlider, gd, axisOpts, opts) {
      var calcData = gd.calcdata;
  
      var rangePlots = rangeSlider.selectAll('g.' + constants.rangePlotClassName)
          .data(axisOpts._subplotsWith, Lib.identity);
  
      rangePlots.enter().append('g')
          .attr('class', function(id) { return constants.rangePlotClassName + ' ' + id; })
          .call(Drawing.setClipUrl, opts._clipId, gd);
  
      rangePlots.order();
  
      rangePlots.exit().remove();
  
      var mainplotinfo;
  
      rangePlots.each(function(id, i) {
          var plotgroup = d3.select(this);
          var isMainPlot = (i === 0);
  
          var oppAxisOpts = axisIDs.getFromId(gd, id, 'y');
          var oppAxisName = oppAxisOpts._name;
          var oppAxisRangeOpts = opts[oppAxisName];
  
          var mockFigure = {
              data: [],
              layout: {
                  xaxis: {
                      type: axisOpts.type,
                      domain: [0, 1],
                      range: opts.range.slice(),
                      calendar: axisOpts.calendar
                  },
                  width: opts._width,
                  height: opts._height,
                  margin: { t: 0, b: 0, l: 0, r: 0 }
              },
              _context: gd._context
          };
  
          if(axisOpts.rangebreaks) {
              mockFigure.layout.xaxis.rangebreaks = axisOpts.rangebreaks;
          }
  
          mockFigure.layout[oppAxisName] = {
              type: oppAxisOpts.type,
              domain: [0, 1],
              range: oppAxisRangeOpts.rangemode !== 'match' ? oppAxisRangeOpts.range.slice() : oppAxisOpts.range.slice(),
              calendar: oppAxisOpts.calendar
          };
  
          if(oppAxisOpts.rangebreaks) {
              mockFigure.layout[oppAxisName].rangebreaks = oppAxisOpts.rangebreaks;
          }
  
          Plots.supplyDefaults(mockFigure);
  
          var xa = mockFigure._fullLayout.xaxis;
          var ya = mockFigure._fullLayout[oppAxisName];
  
          xa.clearCalc();
          xa.setScale();
          ya.clearCalc();
          ya.setScale();
  
          var plotinfo = {
              id: id,
              plotgroup: plotgroup,
              xaxis: xa,
              yaxis: ya,
              isRangePlot: true
          };
  
          if(isMainPlot) mainplotinfo = plotinfo;
          else {
              plotinfo.mainplot = 'xy';
              plotinfo.mainplotinfo = mainplotinfo;
          }
  
          Cartesian.rangePlot(gd, plotinfo, filterRangePlotCalcData(calcData, id));
      });
  }
  
  function filterRangePlotCalcData(calcData, subplotId) {
      var out = [];
  
      for(var i = 0; i < calcData.length; i++) {
          var calcTrace = calcData[i];
          var trace = calcTrace[0].trace;
  
          if(trace.xaxis + trace.yaxis === subplotId) {
              out.push(calcTrace);
          }
      }
  
      return out;
  }
  
  function drawMasks(rangeSlider, gd, axisOpts, opts, oppAxisRangeOpts) {
      var maskMin = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMinClassName, function(s) {
          s.attr({
              x: 0,
              y: 0,
              'shape-rendering': 'crispEdges'
          });
      });
  
      maskMin
          .attr('height', opts._height)
          .call(Color.fill, constants.maskColor);
  
      var maskMax = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMaxClassName, function(s) {
          s.attr({
              y: 0,
              'shape-rendering': 'crispEdges'
          });
      });
  
      maskMax
          .attr('height', opts._height)
          .call(Color.fill, constants.maskColor);
  
      // masks used for oppAxis zoom
      if(oppAxisRangeOpts.rangemode !== 'match') {
          var maskMinOppAxis = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMinOppAxisClassName, function(s) {
              s.attr({
                  y: 0,
                  'shape-rendering': 'crispEdges'
              });
          });
  
          maskMinOppAxis
              .attr('width', opts._width)
              .call(Color.fill, constants.maskOppAxisColor);
  
          var maskMaxOppAxis = Lib.ensureSingle(rangeSlider, 'rect', constants.maskMaxOppAxisClassName, function(s) {
              s.attr({
                  y: 0,
                  'shape-rendering': 'crispEdges'
              });
          });
  
          maskMaxOppAxis
              .attr('width', opts._width)
              .style('border-top', constants.maskOppBorder)
              .call(Color.fill, constants.maskOppAxisColor);
      }
  }
  
  function drawSlideBox(rangeSlider, gd, axisOpts, opts) {
      if(gd._context.staticPlot) return;
  
      var slideBox = Lib.ensureSingle(rangeSlider, 'rect', constants.slideBoxClassName, function(s) {
          s.attr({
              y: 0,
              cursor: constants.slideBoxCursor,
              'shape-rendering': 'crispEdges'
          });
      });
  
      slideBox.attr({
          height: opts._height,
          fill: constants.slideBoxFill
      });
  }
  
  function drawGrabbers(rangeSlider, gd, axisOpts, opts) {
      // <g grabber />
      var grabberMin = Lib.ensureSingle(rangeSlider, 'g', constants.grabberMinClassName);
      var grabberMax = Lib.ensureSingle(rangeSlider, 'g', constants.grabberMaxClassName);
  
      // <g handle />
      var handleFixAttrs = {
          x: 0,
          width: constants.handleWidth,
          rx: constants.handleRadius,
          fill: Color.background,
          stroke: Color.defaultLine,
          'stroke-width': constants.handleStrokeWidth,
          'shape-rendering': 'crispEdges'
      };
      var handleDynamicAttrs = {
          y: Math.round(opts._height / 4),
          height: Math.round(opts._height / 2),
      };
      var handleMin = Lib.ensureSingle(grabberMin, 'rect', constants.handleMinClassName, function(s) {
          s.attr(handleFixAttrs);
      });
      handleMin.attr(handleDynamicAttrs);
  
      var handleMax = Lib.ensureSingle(grabberMax, 'rect', constants.handleMaxClassName, function(s) {
          s.attr(handleFixAttrs);
      });
      handleMax.attr(handleDynamicAttrs);
  
      // <g grabarea />
      var grabAreaFixAttrs = {
          width: constants.grabAreaWidth,
          x: 0,
          y: 0,
          fill: constants.grabAreaFill,
          cursor: !gd._context.staticPlot ? constants.grabAreaCursor : undefined,
      };
  
      var grabAreaMin = Lib.ensureSingle(grabberMin, 'rect', constants.grabAreaMinClassName, function(s) {
          s.attr(grabAreaFixAttrs);
      });
      grabAreaMin.attr('height', opts._height);
  
      var grabAreaMax = Lib.ensureSingle(grabberMax, 'rect', constants.grabAreaMaxClassName, function(s) {
          s.attr(grabAreaFixAttrs);
      });
      grabAreaMax.attr('height', opts._height);
  }
  
  },{"../../lib":750,"../../lib/setcursor":770,"../../plots/cartesian":812,"../../plots/cartesian/axis_ids":802,"../../plots/plots":862,"../../registry":882,"../color":615,"../dragelement":634,"../drawing":637,"../titles":710,"./constants":686,"d3":169}],689:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var axisIDs = _dereq_('../../plots/cartesian/axis_ids');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var constants = _dereq_('./constants');
  var LINE_SPACING = _dereq_('../../constants/alignment').LINE_SPACING;
  var name = constants.name;
  
  function isVisible(ax) {
      var rangeSlider = ax && ax[name];
      return rangeSlider && rangeSlider.visible;
  }
  exports.isVisible = isVisible;
  
  exports.makeData = function(fullLayout) {
      var axes = axisIDs.list({ _fullLayout: fullLayout }, 'x', true);
      var margin = fullLayout.margin;
      var rangeSliderData = [];
  
      if(!fullLayout._has('gl2d')) {
          for(var i = 0; i < axes.length; i++) {
              var ax = axes[i];
  
              if(isVisible(ax)) {
                  rangeSliderData.push(ax);
  
                  var opts = ax[name];
                  opts._id = name + ax._id;
                  opts._height = (fullLayout.height - margin.b - margin.t) * opts.thickness;
                  opts._offsetShift = Math.floor(opts.borderwidth / 2);
              }
          }
      }
  
      fullLayout._rangeSliderData = rangeSliderData;
  };
  
  exports.autoMarginOpts = function(gd, ax) {
      var fullLayout = gd._fullLayout;
      var opts = ax[name];
      var axLetter = ax._id.charAt(0);
  
      var bottomDepth = 0;
      var titleHeight = 0;
      if(ax.side === 'bottom') {
          bottomDepth = ax._depth;
          if(ax.title.text !== fullLayout._dfltTitle[axLetter]) {
              // as in rangeslider/draw.js
              titleHeight = 1.5 * ax.title.font.size + 10 + opts._offsetShift;
              // multi-line extra bump
              var extraLines = (ax.title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
              titleHeight += extraLines * ax.title.font.size * LINE_SPACING;
          }
      }
  
      return {
          x: 0,
          y: ax._counterDomainMin,
          l: 0,
          r: 0,
          t: 0,
          b: opts._height + bottomDepth + Math.max(fullLayout.margin.b, titleHeight),
          pad: constants.extraPad + opts._offsetShift * 2
      };
  };
  
  },{"../../constants/alignment":717,"../../lib/svg_text_utils":774,"../../plots/cartesian/axis_ids":802,"./constants":686}],690:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attrs = _dereq_('./attributes');
  var oppAxisAttrs = _dereq_('./oppaxis_attributes');
  var helpers = _dereq_('./helpers');
  
  module.exports = {
      moduleType: 'component',
      name: 'rangeslider',
  
      schema: {
          subplots: {
              xaxis: {
                  rangeslider: Lib.extendFlat({}, attrs, {
                      yaxis: oppAxisAttrs
                  })
              }
          }
      },
  
      layoutAttributes: _dereq_('./attributes'),
      handleDefaults: _dereq_('./defaults'),
      calcAutorange: _dereq_('./calc_autorange'),
      draw: _dereq_('./draw'),
      isVisible: helpers.isVisible,
      makeData: helpers.makeData,
      autoMarginOpts: helpers.autoMarginOpts
  };
  
  },{"../../lib":750,"./attributes":684,"./calc_autorange":685,"./defaults":687,"./draw":688,"./helpers":689,"./oppaxis_attributes":691}],691:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      // not really a 'subplot' attribute container,
      // but this is the flag we use to denote attributes that
      // support yaxis, yaxis2, yaxis3, ... counters
      _isSubplotObj: true,
  
      rangemode: {
          valType: 'enumerated',
          values: ['auto', 'fixed', 'match'],
          dflt: 'match',
          
          editType: 'calc',
          
      },
      range: {
          valType: 'info_array',
          
          items: [
              {valType: 'any', editType: 'plot'},
              {valType: 'any', editType: 'plot'}
          ],
          editType: 'plot',
          
      },
      editType: 'calc'
  };
  
  },{}],692:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var annAttrs = _dereq_('../annotations/attributes');
  var scatterLineAttrs = _dereq_('../../traces/scatter/attributes').line;
  var dash = _dereq_('../drawing/attributes').dash;
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  var axisPlaceableObjs = _dereq_('../../constants/axis_placeable_objects');
  
  module.exports = templatedArray('shape', {
      visible: {
          valType: 'boolean',
          
          dflt: true,
          editType: 'calc+arraydraw',
          
      },
  
      type: {
          valType: 'enumerated',
          values: ['circle', 'rect', 'path', 'line'],
          
          editType: 'calc+arraydraw',
          
      },
  
      layer: {
          valType: 'enumerated',
          values: ['below', 'above'],
          dflt: 'above',
          
          editType: 'arraydraw',
          
      },
  
      xref: extendFlat({}, annAttrs.xref, {
          
      }),
      xsizemode: {
          valType: 'enumerated',
          values: ['scaled', 'pixel'],
          dflt: 'scaled',
          
          editType: 'calc+arraydraw',
          
      },
      xanchor: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
      x0: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
      x1: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
  
      yref: extendFlat({}, annAttrs.yref, {
          
      }),
      ysizemode: {
          valType: 'enumerated',
          values: ['scaled', 'pixel'],
          dflt: 'scaled',
          
          editType: 'calc+arraydraw',
          
      },
      yanchor: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
      y0: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
      y1: {
          valType: 'any',
          
          editType: 'calc+arraydraw',
          
      },
  
      path: {
          valType: 'string',
          
          editType: 'calc+arraydraw',
          
      },
  
      opacity: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 1,
          
          editType: 'arraydraw',
          
      },
      line: {
          color: extendFlat({}, scatterLineAttrs.color, {editType: 'arraydraw'}),
          width: extendFlat({}, scatterLineAttrs.width, {editType: 'calc+arraydraw'}),
          dash: extendFlat({}, dash, {editType: 'arraydraw'}),
          
          editType: 'calc+arraydraw'
      },
      fillcolor: {
          valType: 'color',
          dflt: 'rgba(0,0,0,0)',
          
          editType: 'arraydraw',
          
      },
      fillrule: {
          valType: 'enumerated',
          values: ['evenodd', 'nonzero'],
          dflt: 'evenodd',
          
          editType: 'arraydraw',
          
      },
      editable: {
          valType: 'boolean',
          
          dflt: false,
          editType: 'calc+arraydraw',
          
      },
  
      editType: 'arraydraw'
  });
  
  },{"../../constants/axis_placeable_objects":718,"../../lib/extend":740,"../../plot_api/plot_template":788,"../../traces/scatter/attributes":1158,"../annotations/attributes":598,"../drawing/attributes":636}],693:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  var constants = _dereq_('./constants');
  var helpers = _dereq_('./helpers');
  
  
  module.exports = function calcAutorange(gd) {
      var fullLayout = gd._fullLayout;
      var shapeList = Lib.filterVisible(fullLayout.shapes);
  
      if(!shapeList.length || !gd._fullData.length) return;
  
      for(var i = 0; i < shapeList.length; i++) {
          var shape = shapeList[i];
          shape._extremes = {};
  
          var ax; var bounds;
          var xRefType = Axes.getRefType(shape.xref);
          var yRefType = Axes.getRefType(shape.yref);
  
          // paper and axis domain referenced shapes don't affect autorange
          if(shape.xref !== 'paper' && xRefType !== 'domain') {
              var vx0 = shape.xsizemode === 'pixel' ? shape.xanchor : shape.x0;
              var vx1 = shape.xsizemode === 'pixel' ? shape.xanchor : shape.x1;
              ax = Axes.getFromId(gd, shape.xref);
  
              bounds = shapeBounds(ax, vx0, vx1, shape.path, constants.paramIsX);
              if(bounds) {
                  shape._extremes[ax._id] = Axes.findExtremes(ax, bounds, calcXPaddingOptions(shape));
              }
          }
  
          if(shape.yref !== 'paper' && yRefType !== 'domain') {
              var vy0 = shape.ysizemode === 'pixel' ? shape.yanchor : shape.y0;
              var vy1 = shape.ysizemode === 'pixel' ? shape.yanchor : shape.y1;
              ax = Axes.getFromId(gd, shape.yref);
  
              bounds = shapeBounds(ax, vy0, vy1, shape.path, constants.paramIsY);
              if(bounds) {
                  shape._extremes[ax._id] = Axes.findExtremes(ax, bounds, calcYPaddingOptions(shape));
              }
          }
      }
  };
  
  function calcXPaddingOptions(shape) {
      return calcPaddingOptions(shape.line.width, shape.xsizemode, shape.x0, shape.x1, shape.path, false);
  }
  
  function calcYPaddingOptions(shape) {
      return calcPaddingOptions(shape.line.width, shape.ysizemode, shape.y0, shape.y1, shape.path, true);
  }
  
  function calcPaddingOptions(lineWidth, sizeMode, v0, v1, path, isYAxis) {
      var ppad = lineWidth / 2;
      var axisDirectionReverted = isYAxis;
  
      if(sizeMode === 'pixel') {
          var coords = path ?
              helpers.extractPathCoords(path, isYAxis ? constants.paramIsY : constants.paramIsX) :
              [v0, v1];
          var maxValue = Lib.aggNums(Math.max, null, coords);
          var minValue = Lib.aggNums(Math.min, null, coords);
          var beforePad = minValue < 0 ? Math.abs(minValue) + ppad : ppad;
          var afterPad = maxValue > 0 ? maxValue + ppad : ppad;
  
          return {
              ppad: ppad,
              ppadplus: axisDirectionReverted ? beforePad : afterPad,
              ppadminus: axisDirectionReverted ? afterPad : beforePad
          };
      } else {
          return {ppad: ppad};
      }
  }
  
  function shapeBounds(ax, v0, v1, path, paramsToUse) {
      var convertVal = (ax.type === 'category' || ax.type === 'multicategory') ? ax.r2c : ax.d2c;
  
      if(v0 !== undefined) return [convertVal(v0), convertVal(v1)];
      if(!path) return;
  
      var min = Infinity;
      var max = -Infinity;
      var segments = path.match(constants.segmentRE);
      var i;
      var segment;
      var drawnParam;
      var params;
      var val;
  
      if(ax.type === 'date') convertVal = helpers.decodeDate(convertVal);
  
      for(i = 0; i < segments.length; i++) {
          segment = segments[i];
          drawnParam = paramsToUse[segment.charAt(0)].drawn;
          if(drawnParam === undefined) continue;
  
          params = segments[i].substr(1).match(constants.paramRE);
          if(!params || params.length < drawnParam) continue;
  
          val = convertVal(params[drawnParam]);
          if(val < min) min = val;
          if(val > max) max = val;
      }
      if(max >= min) return [min, max];
  }
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"./constants":694,"./helpers":703}],694:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  module.exports = {
      segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
      paramRE: /[^\s,]+/g,
  
      // which numbers in each path segment are x (or y) values
      // drawn is which param is a drawn point, as opposed to a
      // control point (which doesn't count toward autorange.
      // TODO: this means curved paths could extend beyond the
      // autorange bounds. This is a bit tricky to get right
      // unless we revert to bounding boxes, but perhaps there's
      // a calculation we could do...)
      paramIsX: {
          M: {0: true, drawn: 0},
          L: {0: true, drawn: 0},
          H: {0: true, drawn: 0},
          V: {},
          Q: {0: true, 2: true, drawn: 2},
          C: {0: true, 2: true, 4: true, drawn: 4},
          T: {0: true, drawn: 0},
          S: {0: true, 2: true, drawn: 2},
          // A: {0: true, 5: true},
          Z: {}
      },
  
      paramIsY: {
          M: {1: true, drawn: 1},
          L: {1: true, drawn: 1},
          H: {},
          V: {0: true, drawn: 0},
          Q: {1: true, 3: true, drawn: 3},
          C: {1: true, 3: true, 5: true, drawn: 5},
          T: {1: true, drawn: 1},
          S: {1: true, 3: true, drawn: 5},
          // A: {1: true, 6: true},
          Z: {}
      },
  
      numParams: {
          M: 2,
          L: 2,
          H: 1,
          V: 1,
          Q: 4,
          C: 6,
          T: 2,
          S: 4,
          // A: 7,
          Z: 0
      }
  };
  
  },{}],695:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  
  var attributes = _dereq_('./attributes');
  var helpers = _dereq_('./helpers');
  
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
      handleArrayContainerDefaults(layoutIn, layoutOut, {
          name: 'shapes',
          handleItemDefaults: handleShapeDefaults
      });
  };
  
  function handleShapeDefaults(shapeIn, shapeOut, fullLayout) {
      function coerce(attr, dflt) {
          return Lib.coerce(shapeIn, shapeOut, attributes, attr, dflt);
      }
  
      var visible = coerce('visible');
      if(!visible) return;
  
      var path = coerce('path');
      var dfltType = path ? 'path' : 'rect';
      var shapeType = coerce('type', dfltType);
      if(shapeOut.type !== 'path') delete shapeOut.path;
  
      coerce('editable');
      coerce('layer');
      coerce('opacity');
      coerce('fillcolor');
      coerce('fillrule');
      var lineWidth = coerce('line.width');
      if(lineWidth) {
          coerce('line.color');
          coerce('line.dash');
      }
  
      var xSizeMode = coerce('xsizemode');
      var ySizeMode = coerce('ysizemode');
  
      // positioning
      var axLetters = ['x', 'y'];
      for(var i = 0; i < 2; i++) {
          var axLetter = axLetters[i];
          var attrAnchor = axLetter + 'anchor';
          var sizeMode = axLetter === 'x' ? xSizeMode : ySizeMode;
          var gdMock = {_fullLayout: fullLayout};
          var ax;
          var pos2r;
          var r2pos;
  
          // xref, yref
          var axRef = Axes.coerceRef(shapeIn, shapeOut, gdMock, axLetter, undefined,
              'paper');
          var axRefType = Axes.getRefType(axRef);
  
          if(axRefType === 'range') {
              ax = Axes.getFromId(gdMock, axRef);
              ax._shapeIndices.push(shapeOut._index);
              r2pos = helpers.rangeToShapePosition(ax);
              pos2r = helpers.shapePositionToRange(ax);
          } else {
              pos2r = r2pos = Lib.identity;
          }
  
          // Coerce x0, x1, y0, y1
          if(shapeType !== 'path') {
              var dflt0 = 0.25;
              var dflt1 = 0.75;
  
              // hack until V2.0 when log has regular range behavior - make it look like other
              // ranges to send to coerce, then put it back after
              // this is all to give reasonable default position behavior on log axes, which is
              // a pretty unimportant edge case so we could just ignore this.
              var attr0 = axLetter + '0';
              var attr1 = axLetter + '1';
              var in0 = shapeIn[attr0];
              var in1 = shapeIn[attr1];
              shapeIn[attr0] = pos2r(shapeIn[attr0], true);
              shapeIn[attr1] = pos2r(shapeIn[attr1], true);
  
              if(sizeMode === 'pixel') {
                  coerce(attr0, 0);
                  coerce(attr1, 10);
              } else {
                  Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attr0, dflt0);
                  Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attr1, dflt1);
              }
  
              // hack part 2
              shapeOut[attr0] = r2pos(shapeOut[attr0]);
              shapeOut[attr1] = r2pos(shapeOut[attr1]);
              shapeIn[attr0] = in0;
              shapeIn[attr1] = in1;
          }
  
          // Coerce xanchor and yanchor
          if(sizeMode === 'pixel') {
              // Hack for log axis described above
              var inAnchor = shapeIn[attrAnchor];
              shapeIn[attrAnchor] = pos2r(shapeIn[attrAnchor], true);
  
              Axes.coercePosition(shapeOut, gdMock, coerce, axRef, attrAnchor, 0.25);
  
              // Hack part 2
              shapeOut[attrAnchor] = r2pos(shapeOut[attrAnchor]);
              shapeIn[attrAnchor] = inAnchor;
          }
      }
  
      if(shapeType === 'path') {
          coerce('path');
      } else {
          Lib.noneOrAll(shapeIn, shapeOut, ['x0', 'x1', 'y0', 'y1']);
      }
  }
  
  },{"../../lib":750,"../../plots/array_container_defaults":794,"../../plots/cartesian/axes":799,"./attributes":692,"./helpers":703}],696:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  var readPaths = _dereq_('./draw_newshape/helpers').readPaths;
  var displayOutlines = _dereq_('./draw_newshape/display_outlines');
  
  var clearOutlineControllers = _dereq_('../../plots/cartesian/handle_outline').clearOutlineControllers;
  
  var Color = _dereq_('../color');
  var Drawing = _dereq_('../drawing');
  var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
  
  var dragElement = _dereq_('../dragelement');
  var setCursor = _dereq_('../../lib/setcursor');
  
  var constants = _dereq_('./constants');
  var helpers = _dereq_('./helpers');
  
  
  // Shapes are stored in gd.layout.shapes, an array of objects
  // index can point to one item in this array,
  //  or non-numeric to simply add a new one
  //  or -1 to modify all existing
  // opt can be the full options object, or one key (to be set to value)
  //  or undefined to simply redraw
  // if opt is blank, val can be 'add' or a full options object to add a new
  //  annotation at that point in the array, or 'remove' to delete this one
  
  module.exports = {
      draw: draw,
      drawOne: drawOne,
      eraseActiveShape: eraseActiveShape
  };
  
  function draw(gd) {
      var fullLayout = gd._fullLayout;
  
      // Remove previous shapes before drawing new in shapes in fullLayout.shapes
      fullLayout._shapeUpperLayer.selectAll('path').remove();
      fullLayout._shapeLowerLayer.selectAll('path').remove();
  
      for(var k in fullLayout._plots) {
          var shapelayer = fullLayout._plots[k].shapelayer;
          if(shapelayer) shapelayer.selectAll('path').remove();
      }
  
      for(var i = 0; i < fullLayout.shapes.length; i++) {
          if(fullLayout.shapes[i].visible) {
              drawOne(gd, i);
          }
      }
  
      // may need to resurrect this if we put text (LaTeX) in shapes
      // return Plots.previousPromises(gd);
  }
  
  function shouldSkipEdits(gd) {
      return !!gd._fullLayout._drawing;
  }
  
  function couldHaveActiveShape(gd) {
      // for now keep config.editable: true as it was before shape-drawing PR
      return !gd._context.edits.shapePosition;
  }
  
  function drawOne(gd, index) {
      // remove the existing shape if there is one.
      // because indices can change, we need to look in all shape layers
      gd._fullLayout._paperdiv
          .selectAll('.shapelayer [data-index="' + index + '"]')
          .remove();
  
      var o = helpers.makeOptionsAndPlotinfo(gd, index);
      var options = o.options;
      var plotinfo = o.plotinfo;
  
      // this shape is gone - quit now after deleting it
      // TODO: use d3 idioms instead of deleting and redrawing every time
      if(!options._input || options.visible === false) return;
  
      if(options.layer !== 'below') {
          drawShape(gd._fullLayout._shapeUpperLayer);
      } else if(options.xref === 'paper' || options.yref === 'paper') {
          drawShape(gd._fullLayout._shapeLowerLayer);
      } else {
          if(plotinfo._hadPlotinfo) {
              var mainPlot = plotinfo.mainplotinfo || plotinfo;
              drawShape(mainPlot.shapelayer);
          } else {
              // Fall back to _shapeLowerLayer in case the requested subplot doesn't exist.
              // This can happen if you reference the shape to an x / y axis combination
              // that doesn't have any data on it (and layer is below)
              drawShape(gd._fullLayout._shapeLowerLayer);
          }
      }
  
      function drawShape(shapeLayer) {
          var d = getPathString(gd, options);
          var attrs = {
              'data-index': index,
              'fill-rule': options.fillrule,
              d: d
          };
  
          var opacity = options.opacity;
          var fillColor = options.fillcolor;
          var lineColor = options.line.width ? options.line.color : 'rgba(0,0,0,0)';
          var lineWidth = options.line.width;
          var lineDash = options.line.dash;
          if(!lineWidth && options.editable === true) {
              // ensure invisible border to activate the shape
              lineWidth = 5;
              lineDash = 'solid';
          }
  
          var isOpen = d[d.length - 1] !== 'Z';
  
          var isActiveShape = couldHaveActiveShape(gd) &&
              options.editable && gd._fullLayout._activeShapeIndex === index;
  
          if(isActiveShape) {
              fillColor = isOpen ? 'rgba(0,0,0,0)' :
                  gd._fullLayout.activeshape.fillcolor;
  
              opacity = gd._fullLayout.activeshape.opacity;
          }
  
          var path = shapeLayer.append('path')
              .attr(attrs)
              .style('opacity', opacity)
              .call(Color.stroke, lineColor)
              .call(Color.fill, fillColor)
              .call(Drawing.dashLine, lineDash, lineWidth);
  
          setClipPath(path, gd, options);
  
          var editHelpers;
          if(isActiveShape || gd._context.edits.shapePosition) editHelpers = arrayEditor(gd.layout, 'shapes', options);
  
          if(isActiveShape) {
              path.style({
                  'cursor': 'move',
              });
  
              var dragOptions = {
                  element: path.node(),
                  plotinfo: plotinfo,
                  gd: gd,
                  editHelpers: editHelpers,
                  isActiveShape: true // i.e. to enable controllers
              };
  
              var polygons = readPaths(d, gd);
              // display polygons on the screen
              displayOutlines(polygons, path, dragOptions);
          } else {
              if(gd._context.edits.shapePosition) {
                  setupDragElement(gd, path, options, index, shapeLayer, editHelpers);
              } else if(options.editable === true) {
                  path.style('pointer-events',
                      (isOpen || Color.opacity(fillColor) * opacity <= 0.5) ? 'stroke' : 'all'
                  );
              }
          }
  
          path.node().addEventListener('click', function() { return activateShape(gd, path); });
      }
  }
  
  function setClipPath(shapePath, gd, shapeOptions) {
      // note that for layer="below" the clipAxes can be different from the
      // subplot we're drawing this in. This could cause problems if the shape
      // spans two subplots. See https://github.com/plotly/plotly.js/issues/1452
      //
      // if axis is 'paper' or an axis with " domain" appended, then there is no
      // clip axis
      var clipAxes = (shapeOptions.xref + shapeOptions.yref).replace(/paper/g, '').replace(/[xyz][1-9]* *domain/g, '');
  
      Drawing.setClipUrl(
          shapePath,
          clipAxes ? 'clip' + gd._fullLayout._uid + clipAxes : null,
          gd
      );
  }
  
  function setupDragElement(gd, shapePath, shapeOptions, index, shapeLayer, editHelpers) {
      var MINWIDTH = 10;
      var MINHEIGHT = 10;
  
      var xPixelSized = shapeOptions.xsizemode === 'pixel';
      var yPixelSized = shapeOptions.ysizemode === 'pixel';
      var isLine = shapeOptions.type === 'line';
      var isPath = shapeOptions.type === 'path';
  
      var modifyItem = editHelpers.modifyItem;
  
      var x0, y0, x1, y1, xAnchor, yAnchor;
      var n0, s0, w0, e0, optN, optS, optW, optE;
      var pathIn;
  
      // setup conversion functions
      var xa = Axes.getFromId(gd, shapeOptions.xref);
      var xRefType = Axes.getRefType(shapeOptions.xref);
      var ya = Axes.getFromId(gd, shapeOptions.yref);
      var yRefType = Axes.getRefType(shapeOptions.yref);
      var x2p = helpers.getDataToPixel(gd, xa, false, xRefType);
      var y2p = helpers.getDataToPixel(gd, ya, true, yRefType);
      var p2x = helpers.getPixelToData(gd, xa, false, xRefType);
      var p2y = helpers.getPixelToData(gd, ya, true, yRefType);
  
      var sensoryElement = obtainSensoryElement();
      var dragOptions = {
          element: sensoryElement.node(),
          gd: gd,
          prepFn: startDrag,
          doneFn: endDrag,
          clickFn: abortDrag
      };
      var dragMode;
  
      dragElement.init(dragOptions);
  
      sensoryElement.node().onmousemove = updateDragMode;
  
      function obtainSensoryElement() {
          return isLine ? createLineDragHandles() : shapePath;
      }
  
      function createLineDragHandles() {
          var minSensoryWidth = 10;
          var sensoryWidth = Math.max(shapeOptions.line.width, minSensoryWidth);
  
          // Helper shapes group
          // Note that by setting the `data-index` attr, it is ensured that
          // the helper group is purged in this modules `draw` function
          var g = shapeLayer.append('g')
            .attr('data-index', index);
  
          // Helper path for moving
          g.append('path')
            .attr('d', shapePath.attr('d'))
            .style({
                'cursor': 'move',
                'stroke-width': sensoryWidth,
                'stroke-opacity': '0' // ensure not visible
            });
  
          // Helper circles for resizing
          var circleStyle = {
              'fill-opacity': '0' // ensure not visible
          };
          var circleRadius = Math.max(sensoryWidth / 2, minSensoryWidth);
  
          g.append('circle')
            .attr({
                'data-line-point': 'start-point',
                'cx': xPixelSized ? x2p(shapeOptions.xanchor) + shapeOptions.x0 : x2p(shapeOptions.x0),
                'cy': yPixelSized ? y2p(shapeOptions.yanchor) - shapeOptions.y0 : y2p(shapeOptions.y0),
                'r': circleRadius
            })
            .style(circleStyle)
            .classed('cursor-grab', true);
  
          g.append('circle')
            .attr({
                'data-line-point': 'end-point',
                'cx': xPixelSized ? x2p(shapeOptions.xanchor) + shapeOptions.x1 : x2p(shapeOptions.x1),
                'cy': yPixelSized ? y2p(shapeOptions.yanchor) - shapeOptions.y1 : y2p(shapeOptions.y1),
                'r': circleRadius
            })
            .style(circleStyle)
            .classed('cursor-grab', true);
  
          return g;
      }
  
      function updateDragMode(evt) {
          if(shouldSkipEdits(gd)) {
              dragMode = null;
              return;
          }
  
          if(isLine) {
              if(evt.target.tagName === 'path') {
                  dragMode = 'move';
              } else {
                  dragMode = evt.target.attributes['data-line-point'].value === 'start-point' ?
                    'resize-over-start-point' : 'resize-over-end-point';
              }
          } else {
              // element might not be on screen at time of setup,
              // so obtain bounding box here
              var dragBBox = dragOptions.element.getBoundingClientRect();
  
              // choose 'move' or 'resize'
              // based on initial position of cursor within the drag element
              var w = dragBBox.right - dragBBox.left;
              var h = dragBBox.bottom - dragBBox.top;
              var x = evt.clientX - dragBBox.left;
              var y = evt.clientY - dragBBox.top;
              var cursor = (!isPath && w > MINWIDTH && h > MINHEIGHT && !evt.shiftKey) ?
                  dragElement.getCursor(x / w, 1 - y / h) :
                  'move';
  
              setCursor(shapePath, cursor);
  
              // possible values 'move', 'sw', 'w', 'se', 'e', 'ne', 'n', 'nw' and 'w'
              dragMode = cursor.split('-')[0];
          }
      }
  
      function startDrag(evt) {
          if(shouldSkipEdits(gd)) return;
  
          // setup update strings and initial values
          if(xPixelSized) {
              xAnchor = x2p(shapeOptions.xanchor);
          }
          if(yPixelSized) {
              yAnchor = y2p(shapeOptions.yanchor);
          }
  
          if(shapeOptions.type === 'path') {
              pathIn = shapeOptions.path;
          } else {
              x0 = xPixelSized ? shapeOptions.x0 : x2p(shapeOptions.x0);
              y0 = yPixelSized ? shapeOptions.y0 : y2p(shapeOptions.y0);
              x1 = xPixelSized ? shapeOptions.x1 : x2p(shapeOptions.x1);
              y1 = yPixelSized ? shapeOptions.y1 : y2p(shapeOptions.y1);
          }
  
          if(x0 < x1) {
              w0 = x0;
              optW = 'x0';
              e0 = x1;
              optE = 'x1';
          } else {
              w0 = x1;
              optW = 'x1';
              e0 = x0;
              optE = 'x0';
          }
  
          // For fixed size shapes take opposing direction of y-axis into account.
          // Hint: For data sized shapes this is done by the y2p function.
          if((!yPixelSized && y0 < y1) || (yPixelSized && y0 > y1)) {
              n0 = y0;
              optN = 'y0';
              s0 = y1;
              optS = 'y1';
          } else {
              n0 = y1;
              optN = 'y1';
              s0 = y0;
              optS = 'y0';
          }
  
          // setup dragMode and the corresponding handler
          updateDragMode(evt);
          renderVisualCues(shapeLayer, shapeOptions);
          deactivateClipPathTemporarily(shapePath, shapeOptions, gd);
          dragOptions.moveFn = (dragMode === 'move') ? moveShape : resizeShape;
          dragOptions.altKey = evt.altKey;
      }
  
      function endDrag() {
          if(shouldSkipEdits(gd)) return;
  
          setCursor(shapePath);
          removeVisualCues(shapeLayer);
  
          // Don't rely on clipPath being activated during re-layout
          setClipPath(shapePath, gd, shapeOptions);
          Registry.call('_guiRelayout', gd, editHelpers.getUpdateObj());
      }
  
      function abortDrag() {
          if(shouldSkipEdits(gd)) return;
  
          removeVisualCues(shapeLayer);
      }
  
      function moveShape(dx, dy) {
          if(shapeOptions.type === 'path') {
              var noOp = function(coord) { return coord; };
              var moveX = noOp;
              var moveY = noOp;
  
              if(xPixelSized) {
                  modifyItem('xanchor', shapeOptions.xanchor = p2x(xAnchor + dx));
              } else {
                  moveX = function moveX(x) { return p2x(x2p(x) + dx); };
                  if(xa && xa.type === 'date') moveX = helpers.encodeDate(moveX);
              }
  
              if(yPixelSized) {
                  modifyItem('yanchor', shapeOptions.yanchor = p2y(yAnchor + dy));
              } else {
                  moveY = function moveY(y) { return p2y(y2p(y) + dy); };
                  if(ya && ya.type === 'date') moveY = helpers.encodeDate(moveY);
              }
  
              modifyItem('path', shapeOptions.path = movePath(pathIn, moveX, moveY));
          } else {
              if(xPixelSized) {
                  modifyItem('xanchor', shapeOptions.xanchor = p2x(xAnchor + dx));
              } else {
                  modifyItem('x0', shapeOptions.x0 = p2x(x0 + dx));
                  modifyItem('x1', shapeOptions.x1 = p2x(x1 + dx));
              }
  
              if(yPixelSized) {
                  modifyItem('yanchor', shapeOptions.yanchor = p2y(yAnchor + dy));
              } else {
                  modifyItem('y0', shapeOptions.y0 = p2y(y0 + dy));
                  modifyItem('y1', shapeOptions.y1 = p2y(y1 + dy));
              }
          }
  
          shapePath.attr('d', getPathString(gd, shapeOptions));
          renderVisualCues(shapeLayer, shapeOptions);
      }
  
      function resizeShape(dx, dy) {
          if(isPath) {
              // TODO: implement path resize, don't forget to update dragMode code
              var noOp = function(coord) { return coord; };
              var moveX = noOp;
              var moveY = noOp;
  
              if(xPixelSized) {
                  modifyItem('xanchor', shapeOptions.xanchor = p2x(xAnchor + dx));
              } else {
                  moveX = function moveX(x) { return p2x(x2p(x) + dx); };
                  if(xa && xa.type === 'date') moveX = helpers.encodeDate(moveX);
              }
  
              if(yPixelSized) {
                  modifyItem('yanchor', shapeOptions.yanchor = p2y(yAnchor + dy));
              } else {
                  moveY = function moveY(y) { return p2y(y2p(y) + dy); };
                  if(ya && ya.type === 'date') moveY = helpers.encodeDate(moveY);
              }
  
              modifyItem('path', shapeOptions.path = movePath(pathIn, moveX, moveY));
          } else if(isLine) {
              if(dragMode === 'resize-over-start-point') {
                  var newX0 = x0 + dx;
                  var newY0 = yPixelSized ? y0 - dy : y0 + dy;
                  modifyItem('x0', shapeOptions.x0 = xPixelSized ? newX0 : p2x(newX0));
                  modifyItem('y0', shapeOptions.y0 = yPixelSized ? newY0 : p2y(newY0));
              } else if(dragMode === 'resize-over-end-point') {
                  var newX1 = x1 + dx;
                  var newY1 = yPixelSized ? y1 - dy : y1 + dy;
                  modifyItem('x1', shapeOptions.x1 = xPixelSized ? newX1 : p2x(newX1));
                  modifyItem('y1', shapeOptions.y1 = yPixelSized ? newY1 : p2y(newY1));
              }
          } else {
              var has = function(str) { return dragMode.indexOf(str) !== -1; };
              var hasN = has('n');
              var hasS = has('s');
              var hasW = has('w');
              var hasE = has('e');
  
              var newN = hasN ? n0 + dy : n0;
              var newS = hasS ? s0 + dy : s0;
              var newW = hasW ? w0 + dx : w0;
              var newE = hasE ? e0 + dx : e0;
  
              if(yPixelSized) {
                  // Do things in opposing direction for y-axis.
                  // Hint: for data-sized shapes the reversal of axis direction is done in p2y.
                  if(hasN) newN = n0 - dy;
                  if(hasS) newS = s0 - dy;
              }
  
              // Update shape eventually. Again, be aware of the
              // opposing direction of the y-axis of fixed size shapes.
              if(
                  (!yPixelSized && newS - newN > MINHEIGHT) ||
                  (yPixelSized && newN - newS > MINHEIGHT)
              ) {
                  modifyItem(optN, shapeOptions[optN] = yPixelSized ? newN : p2y(newN));
                  modifyItem(optS, shapeOptions[optS] = yPixelSized ? newS : p2y(newS));
              }
              if(newE - newW > MINWIDTH) {
                  modifyItem(optW, shapeOptions[optW] = xPixelSized ? newW : p2x(newW));
                  modifyItem(optE, shapeOptions[optE] = xPixelSized ? newE : p2x(newE));
              }
          }
  
          shapePath.attr('d', getPathString(gd, shapeOptions));
          renderVisualCues(shapeLayer, shapeOptions);
      }
  
      function renderVisualCues(shapeLayer, shapeOptions) {
          if(xPixelSized || yPixelSized) {
              renderAnchor();
          }
  
          function renderAnchor() {
              var isNotPath = shapeOptions.type !== 'path';
  
              // d3 join with dummy data to satisfy d3 data-binding
              var visualCues = shapeLayer.selectAll('.visual-cue').data([0]);
  
              // Enter
              var strokeWidth = 1;
              visualCues.enter()
                .append('path')
                .attr({
                    'fill': '#fff',
                    'fill-rule': 'evenodd',
                    'stroke': '#000',
                    'stroke-width': strokeWidth
                })
                .classed('visual-cue', true);
  
              // Update
              var posX = x2p(
                xPixelSized ?
                  shapeOptions.xanchor :
                  Lib.midRange(
                    isNotPath ?
                      [shapeOptions.x0, shapeOptions.x1] :
                      helpers.extractPathCoords(shapeOptions.path, constants.paramIsX))
              );
              var posY = y2p(
                yPixelSized ?
                  shapeOptions.yanchor :
                  Lib.midRange(
                    isNotPath ?
                      [shapeOptions.y0, shapeOptions.y1] :
                      helpers.extractPathCoords(shapeOptions.path, constants.paramIsY))
              );
  
              posX = helpers.roundPositionForSharpStrokeRendering(posX, strokeWidth);
              posY = helpers.roundPositionForSharpStrokeRendering(posY, strokeWidth);
  
              if(xPixelSized && yPixelSized) {
                  var crossPath = 'M' + (posX - 1 - strokeWidth) + ',' + (posY - 1 - strokeWidth) +
                    'h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z';
                  visualCues.attr('d', crossPath);
              } else if(xPixelSized) {
                  var vBarPath = 'M' + (posX - 1 - strokeWidth) + ',' + (posY - 9 - strokeWidth) +
                    'v18 h2 v-18 Z';
                  visualCues.attr('d', vBarPath);
              } else {
                  var hBarPath = 'M' + (posX - 9 - strokeWidth) + ',' + (posY - 1 - strokeWidth) +
                    'h18 v2 h-18 Z';
                  visualCues.attr('d', hBarPath);
              }
          }
      }
  
      function removeVisualCues(shapeLayer) {
          shapeLayer.selectAll('.visual-cue').remove();
      }
  
      function deactivateClipPathTemporarily(shapePath, shapeOptions, gd) {
          var xref = shapeOptions.xref;
          var yref = shapeOptions.yref;
          var xa = Axes.getFromId(gd, xref);
          var ya = Axes.getFromId(gd, yref);
  
          var clipAxes = '';
          if(xref !== 'paper' && !xa.autorange) clipAxes += xref;
          if(yref !== 'paper' && !ya.autorange) clipAxes += yref;
  
          Drawing.setClipUrl(
              shapePath,
              clipAxes ? 'clip' + gd._fullLayout._uid + clipAxes : null,
              gd
          );
      }
  }
  
  function getPathString(gd, options) {
      var type = options.type;
      var xRefType = Axes.getRefType(options.xref);
      var yRefType = Axes.getRefType(options.yref);
      var xa = Axes.getFromId(gd, options.xref);
      var ya = Axes.getFromId(gd, options.yref);
      var gs = gd._fullLayout._size;
      var x2r, x2p, y2r, y2p;
      var x0, x1, y0, y1;
  
      if(xa) {
          if(xRefType === 'domain') {
              x2p = function(v) { return xa._offset + xa._length * v; };
          } else {
              x2r = helpers.shapePositionToRange(xa);
              x2p = function(v) { return xa._offset + xa.r2p(x2r(v, true)); };
          }
      } else {
          x2p = function(v) { return gs.l + gs.w * v; };
      }
  
      if(ya) {
          if(yRefType === 'domain') {
              y2p = function(v) { return ya._offset + ya._length * (1 - v); };
          } else {
              y2r = helpers.shapePositionToRange(ya);
              y2p = function(v) { return ya._offset + ya.r2p(y2r(v, true)); };
          }
      } else {
          y2p = function(v) { return gs.t + gs.h * (1 - v); };
      }
  
      if(type === 'path') {
          if(xa && xa.type === 'date') x2p = helpers.decodeDate(x2p);
          if(ya && ya.type === 'date') y2p = helpers.decodeDate(y2p);
          return convertPath(options, x2p, y2p);
      }
  
      if(options.xsizemode === 'pixel') {
          var xAnchorPos = x2p(options.xanchor);
          x0 = xAnchorPos + options.x0;
          x1 = xAnchorPos + options.x1;
      } else {
          x0 = x2p(options.x0);
          x1 = x2p(options.x1);
      }
  
      if(options.ysizemode === 'pixel') {
          var yAnchorPos = y2p(options.yanchor);
          y0 = yAnchorPos - options.y0;
          y1 = yAnchorPos - options.y1;
      } else {
          y0 = y2p(options.y0);
          y1 = y2p(options.y1);
      }
  
      if(type === 'line') return 'M' + x0 + ',' + y0 + 'L' + x1 + ',' + y1;
      if(type === 'rect') return 'M' + x0 + ',' + y0 + 'H' + x1 + 'V' + y1 + 'H' + x0 + 'Z';
  
      // circle
      var cx = (x0 + x1) / 2;
      var cy = (y0 + y1) / 2;
      var rx = Math.abs(cx - x0);
      var ry = Math.abs(cy - y0);
      var rArc = 'A' + rx + ',' + ry;
      var rightPt = (cx + rx) + ',' + cy;
      var topPt = cx + ',' + (cy - ry);
      return 'M' + rightPt + rArc + ' 0 1,1 ' + topPt +
          rArc + ' 0 0,1 ' + rightPt + 'Z';
  }
  
  
  function convertPath(options, x2p, y2p) {
      var pathIn = options.path;
      var xSizemode = options.xsizemode;
      var ySizemode = options.ysizemode;
      var xAnchor = options.xanchor;
      var yAnchor = options.yanchor;
  
      return pathIn.replace(constants.segmentRE, function(segment) {
          var paramNumber = 0;
          var segmentType = segment.charAt(0);
          var xParams = constants.paramIsX[segmentType];
          var yParams = constants.paramIsY[segmentType];
          var nParams = constants.numParams[segmentType];
  
          var paramString = segment.substr(1).replace(constants.paramRE, function(param) {
              if(xParams[paramNumber]) {
                  if(xSizemode === 'pixel') param = x2p(xAnchor) + Number(param);
                  else param = x2p(param);
              } else if(yParams[paramNumber]) {
                  if(ySizemode === 'pixel') param = y2p(yAnchor) - Number(param);
                  else param = y2p(param);
              }
              paramNumber++;
  
              if(paramNumber > nParams) param = 'X';
              return param;
          });
  
          if(paramNumber > nParams) {
              paramString = paramString.replace(/[\s,]*X.*/, '');
              Lib.log('Ignoring extra params in segment ' + segment);
          }
  
          return segmentType + paramString;
      });
  }
  
  function movePath(pathIn, moveX, moveY) {
      return pathIn.replace(constants.segmentRE, function(segment) {
          var paramNumber = 0;
          var segmentType = segment.charAt(0);
          var xParams = constants.paramIsX[segmentType];
          var yParams = constants.paramIsY[segmentType];
          var nParams = constants.numParams[segmentType];
  
          var paramString = segment.substr(1).replace(constants.paramRE, function(param) {
              if(paramNumber >= nParams) return param;
  
              if(xParams[paramNumber]) param = moveX(param);
              else if(yParams[paramNumber]) param = moveY(param);
  
              paramNumber++;
  
              return param;
          });
  
          return segmentType + paramString;
      });
  }
  
  function activateShape(gd, path) {
      if(!couldHaveActiveShape(gd)) return;
  
      var element = path.node();
      var id = +element.getAttribute('data-index');
      if(id >= 0) {
          // deactivate if already active
          if(id === gd._fullLayout._activeShapeIndex) {
              deactivateShape(gd);
              return;
          }
  
          gd._fullLayout._activeShapeIndex = id;
          gd._fullLayout._deactivateShape = deactivateShape;
          draw(gd);
      }
  }
  
  function deactivateShape(gd) {
      if(!couldHaveActiveShape(gd)) return;
  
      var id = gd._fullLayout._activeShapeIndex;
      if(id >= 0) {
          clearOutlineControllers(gd);
          delete gd._fullLayout._activeShapeIndex;
          draw(gd);
      }
  }
  
  function eraseActiveShape(gd) {
      if(!couldHaveActiveShape(gd)) return;
  
      clearOutlineControllers(gd);
  
      var id = gd._fullLayout._activeShapeIndex;
      var shapes = (gd.layout || {}).shapes || [];
      if(id < shapes.length) {
          var newShapes = [];
          for(var q = 0; q < shapes.length; q++) {
              if(q !== id) {
                  newShapes.push(shapes[q]);
              }
          }
  
          delete gd._fullLayout._activeShapeIndex;
  
          Registry.call('_guiRelayout', gd, {
              shapes: newShapes
          });
      }
  }
  
  },{"../../lib":750,"../../lib/setcursor":770,"../../plot_api/plot_template":788,"../../plots/cartesian/axes":799,"../../plots/cartesian/handle_outline":809,"../../registry":882,"../color":615,"../dragelement":634,"../drawing":637,"./constants":694,"./draw_newshape/display_outlines":700,"./draw_newshape/helpers":701,"./helpers":703}],697:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var dash = _dereq_('../../drawing/attributes').dash;
  var extendFlat = _dereq_('../../../lib/extend').extendFlat;
  
  module.exports = {
      newshape: {
          line: {
              color: {
                  valType: 'color',
                  editType: 'none',
                  
                  
              },
              width: {
                  valType: 'number',
                  min: 0,
                  dflt: 4,
                  
                  editType: 'none',
                  
              },
              dash: extendFlat({}, dash, {
                  dflt: 'solid',
                  editType: 'none'
              }),
              
              editType: 'none'
          },
          fillcolor: {
              valType: 'color',
              dflt: 'rgba(0,0,0,0)',
              
              editType: 'none',
              
          },
          fillrule: {
              valType: 'enumerated',
              values: ['evenodd', 'nonzero'],
              dflt: 'evenodd',
              
              editType: 'none',
              
          },
          opacity: {
              valType: 'number',
              min: 0,
              max: 1,
              dflt: 1,
              
              editType: 'none',
              
          },
          layer: {
              valType: 'enumerated',
              values: ['below', 'above'],
              dflt: 'above',
              
              editType: 'none',
              
          },
          drawdirection: {
              valType: 'enumerated',
              
              values: ['ortho', 'horizontal', 'vertical', 'diagonal'],
              dflt: 'diagonal',
              editType: 'none',
              
          },
  
          editType: 'none'
      },
  
      activeshape: {
          fillcolor: {
              valType: 'color',
              dflt: 'rgb(255,0,255)',
              
              editType: 'none',
              
          },
          opacity: {
              valType: 'number',
              min: 0,
              max: 1,
              dflt: 0.5,
              
              editType: 'none',
              
          },
          editType: 'none'
      }
  };
  
  },{"../../../lib/extend":740,"../../drawing/attributes":636}],698:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var CIRCLE_SIDES = 32;  // should be divisible by 4
  
  module.exports = {
      CIRCLE_SIDES: CIRCLE_SIDES,
      i000: 0,
      i090: CIRCLE_SIDES / 4,
      i180: CIRCLE_SIDES / 2,
      i270: CIRCLE_SIDES / 4 * 3,
      cos45: Math.cos(Math.PI / 4),
      sin45: Math.sin(Math.PI / 4),
      SQRT2: Math.sqrt(2)
  };
  
  },{}],699:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Color = _dereq_('../../color');
  
  
  module.exports = function supplyDrawNewShapeDefaults(layoutIn, layoutOut, coerce) {
      coerce('newshape.drawdirection');
      coerce('newshape.layer');
      coerce('newshape.fillcolor');
      coerce('newshape.fillrule');
      coerce('newshape.opacity');
      var newshapeLineWidth = coerce('newshape.line.width');
      if(newshapeLineWidth) {
          var bgcolor = (layoutIn || {}).plot_bgcolor || '#FFF';
          coerce('newshape.line.color', Color.contrast(bgcolor));
          coerce('newshape.line.dash');
      }
  
      coerce('activeshape.fillcolor');
      coerce('activeshape.opacity');
  };
  
  },{"../../color":615}],700:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var dragElement = _dereq_('../../dragelement');
  var dragHelpers = _dereq_('../../dragelement/helpers');
  var drawMode = dragHelpers.drawMode;
  
  var Registry = _dereq_('../../../registry');
  
  var constants = _dereq_('./constants');
  var i000 = constants.i000;
  var i090 = constants.i090;
  var i180 = constants.i180;
  var i270 = constants.i270;
  
  var handleOutline = _dereq_('../../../plots/cartesian/handle_outline');
  var clearOutlineControllers = handleOutline.clearOutlineControllers;
  
  var helpers = _dereq_('./helpers');
  var pointsShapeRectangle = helpers.pointsShapeRectangle;
  var pointsShapeEllipse = helpers.pointsShapeEllipse;
  var writePaths = helpers.writePaths;
  var newShapes = _dereq_('./newshapes');
  
  module.exports = function displayOutlines(polygons, outlines, dragOptions, nCalls) {
      if(!nCalls) nCalls = 0;
  
      var gd = dragOptions.gd;
  
      function redraw() {
          // recursive call
          displayOutlines(polygons, outlines, dragOptions, nCalls++);
  
          if(pointsShapeEllipse(polygons[0])) {
              update({redrawing: true});
          }
      }
  
      function update(opts) {
          dragOptions.isActiveShape = false; // i.e. to disable controllers
  
          var updateObject = newShapes(outlines, dragOptions);
          if(Object.keys(updateObject).length) {
              Registry.call((opts || {}).redrawing ? 'relayout' : '_guiRelayout', gd, updateObject);
          }
      }
  
  
      var isActiveShape = dragOptions.isActiveShape;
      var fullLayout = gd._fullLayout;
      var zoomLayer = fullLayout._zoomlayer;
  
      var dragmode = dragOptions.dragmode;
      var isDrawMode = drawMode(dragmode);
  
      if(isDrawMode) gd._fullLayout._drawing = true;
      else if(gd._fullLayout._activeShapeIndex >= 0) clearOutlineControllers(gd);
  
      // make outline
      outlines.attr('d', writePaths(polygons));
  
      // add controllers
      var vertexDragOptions;
      var shapeDragOptions;
      var indexI; // cell index
      var indexJ; // vertex or cell-controller index
      var copyPolygons;
  
      if(isActiveShape && !nCalls) {
          copyPolygons = recordPositions([], polygons);
  
          var g = zoomLayer.append('g').attr('class', 'outline-controllers');
          addVertexControllers(g);
          addShapeControllers();
      }
  
      function startDragVertex(evt) {
          indexI = +evt.srcElement.getAttribute('data-i');
          indexJ = +evt.srcElement.getAttribute('data-j');
  
          vertexDragOptions[indexI][indexJ].moveFn = moveVertexController;
      }
  
      function moveVertexController(dx, dy) {
          if(!polygons.length) return;
  
          var x0 = copyPolygons[indexI][indexJ][1];
          var y0 = copyPolygons[indexI][indexJ][2];
  
          var cell = polygons[indexI];
          var len = cell.length;
          if(pointsShapeRectangle(cell)) {
              for(var q = 0; q < len; q++) {
                  if(q === indexJ) continue;
  
                  // move other corners of rectangle
                  var pos = cell[q];
  
                  if(pos[1] === cell[indexJ][1]) {
                      pos[1] = x0 + dx;
                  }
  
                  if(pos[2] === cell[indexJ][2]) {
                      pos[2] = y0 + dy;
                  }
              }
              // move the corner
              cell[indexJ][1] = x0 + dx;
              cell[indexJ][2] = y0 + dy;
  
              if(!pointsShapeRectangle(cell)) {
                  // reject result to rectangles with ensure areas
                  for(var j = 0; j < len; j++) {
                      for(var k = 0; k < cell[j].length; k++) {
                          cell[j][k] = copyPolygons[indexI][j][k];
                      }
                  }
              }
          } else { // other polylines
              cell[indexJ][1] = x0 + dx;
              cell[indexJ][2] = y0 + dy;
          }
  
          redraw();
      }
  
      function endDragVertexController() {
          update();
      }
  
      function removeVertex() {
          if(!polygons.length) return;
          if(!polygons[indexI]) return;
          if(!polygons[indexI].length) return;
  
          var newPolygon = [];
          for(var j = 0; j < polygons[indexI].length; j++) {
              if(j !== indexJ) {
                  newPolygon.push(
                      polygons[indexI][j]
                  );
              }
          }
  
          if(newPolygon.length > 1 && !(
              newPolygon.length === 2 && newPolygon[1][0] === 'Z')
          ) {
              if(indexJ === 0) {
                  newPolygon[0][0] = 'M';
              }
  
              polygons[indexI] = newPolygon;
  
              redraw();
              update();
          }
      }
  
      function clickVertexController(numClicks, evt) {
          if(numClicks === 2) {
              indexI = +evt.srcElement.getAttribute('data-i');
              indexJ = +evt.srcElement.getAttribute('data-j');
  
              var cell = polygons[indexI];
              if(
                  !pointsShapeRectangle(cell) &&
                  !pointsShapeEllipse(cell)
              ) {
                  removeVertex();
              }
          }
      }
  
      function addVertexControllers(g) {
          vertexDragOptions = [];
  
          for(var i = 0; i < polygons.length; i++) {
              var cell = polygons[i];
  
              var onRect = pointsShapeRectangle(cell);
              var onEllipse = !onRect && pointsShapeEllipse(cell);
  
              vertexDragOptions[i] = [];
              for(var j = 0; j < cell.length; j++) {
                  if(cell[j][0] === 'Z') continue;
  
                  if(onEllipse &&
                      j !== i000 &&
                      j !== i090 &&
                      j !== i180 &&
                      j !== i270
                  ) {
                      continue;
                  }
  
                  var x = cell[j][1];
                  var y = cell[j][2];
  
                  var vertex = g.append('circle')
                      .classed('cursor-grab', true)
                      .attr('data-i', i)
                      .attr('data-j', j)
                      .attr('cx', x)
                      .attr('cy', y)
                      .attr('r', 4)
                      .style({
                          'mix-blend-mode': 'luminosity',
                          fill: 'black',
                          stroke: 'white',
                          'stroke-width': 1
                      });
  
                  vertexDragOptions[i][j] = {
                      element: vertex.node(),
                      gd: gd,
                      prepFn: startDragVertex,
                      doneFn: endDragVertexController,
                      clickFn: clickVertexController
                  };
  
                  dragElement.init(vertexDragOptions[i][j]);
              }
          }
      }
  
      function moveShape(dx, dy) {
          if(!polygons.length) return;
  
          for(var i = 0; i < polygons.length; i++) {
              for(var j = 0; j < polygons[i].length; j++) {
                  for(var k = 0; k + 2 < polygons[i][j].length; k += 2) {
                      polygons[i][j][k + 1] = copyPolygons[i][j][k + 1] + dx;
                      polygons[i][j][k + 2] = copyPolygons[i][j][k + 2] + dy;
                  }
              }
          }
      }
  
      function moveShapeController(dx, dy) {
          moveShape(dx, dy);
  
          redraw();
      }
  
      function startDragShapeController(evt) {
          indexI = +evt.srcElement.getAttribute('data-i');
          if(!indexI) indexI = 0; // ensure non-existing move button get zero index
  
          shapeDragOptions[indexI].moveFn = moveShapeController;
      }
  
      function endDragShapeController() {
          update();
      }
  
      function addShapeControllers() {
          shapeDragOptions = [];
  
          if(!polygons.length) return;
  
          var i = 0;
          shapeDragOptions[i] = {
              element: outlines[0][0],
              gd: gd,
              prepFn: startDragShapeController,
              doneFn: endDragShapeController
          };
  
          dragElement.init(shapeDragOptions[i]);
      }
  };
  
  function recordPositions(polygonsOut, polygonsIn) {
      for(var i = 0; i < polygonsIn.length; i++) {
          var cell = polygonsIn[i];
          polygonsOut[i] = [];
          for(var j = 0; j < cell.length; j++) {
              polygonsOut[i][j] = [];
              for(var k = 0; k < cell[j].length; k++) {
                  polygonsOut[i][j][k] = cell[j][k];
              }
          }
      }
      return polygonsOut;
  }
  
  },{"../../../plots/cartesian/handle_outline":809,"../../../registry":882,"../../dragelement":634,"../../dragelement/helpers":633,"./constants":698,"./helpers":701,"./newshapes":702}],701:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var parseSvgPath = _dereq_('parse-svg-path');
  
  var constants = _dereq_('./constants');
  var CIRCLE_SIDES = constants.CIRCLE_SIDES;
  var SQRT2 = constants.SQRT2;
  
  var cartesianHelpers = _dereq_('../../../plots/cartesian/helpers');
  var p2r = cartesianHelpers.p2r;
  var r2p = cartesianHelpers.r2p;
  
  var iC = [0, 3, 4, 5, 6, 1, 2];
  var iQS = [0, 3, 4, 1, 2];
  
  exports.writePaths = function(polygons) {
      var nI = polygons.length;
      if(!nI) return 'M0,0Z';
  
      var str = '';
      for(var i = 0; i < nI; i++) {
          var nJ = polygons[i].length;
          for(var j = 0; j < nJ; j++) {
              var w = polygons[i][j][0];
              if(w === 'Z') {
                  str += 'Z';
              } else {
                  var nK = polygons[i][j].length;
                  for(var k = 0; k < nK; k++) {
                      var realK = k;
                      if(w === 'Q' || w === 'S') {
                          realK = iQS[k];
                      } else if(w === 'C') {
                          realK = iC[k];
                      }
  
                      str += polygons[i][j][realK];
                      if(k > 0 && k < nK - 1) {
                          str += ',';
                      }
                  }
              }
          }
      }
  
      return str;
  };
  
  exports.readPaths = function(str, gd, plotinfo, isActiveShape) {
      var cmd = parseSvgPath(str);
  
      var polys = [];
      var n = -1;
      var newPoly = function() {
          n++;
          polys[n] = [];
      };
  
      var k;
      var x = 0;
      var y = 0;
      var initX;
      var initY;
      var recStart = function() {
          initX = x;
          initY = y;
      };
  
      recStart();
      for(var i = 0; i < cmd.length; i++) {
          var newPos = [];
  
          var x1, x2, y1, y2; // i.e. extra params for curves
  
          var c = cmd[i][0];
          var w = c;
          switch(c) {
              case 'M':
                  newPoly();
                  x = +cmd[i][1];
                  y = +cmd[i][2];
                  newPos.push([w, x, y]);
  
                  recStart();
                  break;
  
              case 'Q':
              case 'S':
                  x1 = +cmd[i][1];
                  y1 = +cmd[i][2];
                  x = +cmd[i][3];
                  y = +cmd[i][4];
                  newPos.push([w, x, y, x1, y1]); // -> iQS order
                  break;
  
              case 'C':
                  x1 = +cmd[i][1];
                  y1 = +cmd[i][2];
                  x2 = +cmd[i][3];
                  y2 = +cmd[i][4];
                  x = +cmd[i][5];
                  y = +cmd[i][6];
                  newPos.push([w, x, y, x1, y1, x2, y2]); // -> iC order
                  break;
  
              case 'T':
              case 'L':
                  x = +cmd[i][1];
                  y = +cmd[i][2];
                  newPos.push([w, x, y]);
                  break;
  
              case 'H':
                  w = 'L'; // convert to line (for now)
                  x = +cmd[i][1];
                  newPos.push([w, x, y]);
                  break;
  
              case 'V':
                  w = 'L'; // convert to line (for now)
                  y = +cmd[i][1];
                  newPos.push([w, x, y]);
                  break;
  
              case 'A':
                  w = 'L'; // convert to line to handle circle
                  var rx = +cmd[i][1];
                  var ry = +cmd[i][2];
                  if(!+cmd[i][4]) {
                      rx = -rx;
                      ry = -ry;
                  }
  
                  var cenX = x - rx;
                  var cenY = y;
                  for(k = 1; k <= CIRCLE_SIDES / 2; k++) {
                      var t = 2 * Math.PI * k / CIRCLE_SIDES;
                      newPos.push([
                          w,
                          cenX + rx * Math.cos(t),
                          cenY + ry * Math.sin(t)
                      ]);
                  }
                  break;
  
              case 'Z':
                  if(x !== initX || y !== initY) {
                      x = initX;
                      y = initY;
                      newPos.push([w, x, y]);
                  }
                  break;
          }
  
          var domain = (plotinfo || {}).domain;
          var size = gd._fullLayout._size;
          var xPixelSized = plotinfo && plotinfo.xsizemode === 'pixel';
          var yPixelSized = plotinfo && plotinfo.ysizemode === 'pixel';
          var noOffset = isActiveShape === false;
  
          for(var j = 0; j < newPos.length; j++) {
              for(k = 0; k + 2 < 7; k += 2) {
                  var _x = newPos[j][k + 1];
                  var _y = newPos[j][k + 2];
  
                  if(_x === undefined || _y === undefined) continue;
                  // keep track of end point for Z
                  x = _x;
                  y = _y;
  
                  if(plotinfo) {
                      if(plotinfo.xaxis && plotinfo.xaxis.p2r) {
                          if(noOffset) _x -= plotinfo.xaxis._offset;
                          if(xPixelSized) {
                              _x = r2p(plotinfo.xaxis, plotinfo.xanchor) + _x;
                          } else {
                              _x = p2r(plotinfo.xaxis, _x);
                          }
                      } else {
                          if(noOffset) _x -= size.l;
                          if(domain) _x = domain.x[0] + _x / size.w;
                          else _x = _x / size.w;
                      }
  
                      if(plotinfo.yaxis && plotinfo.yaxis.p2r) {
                          if(noOffset) _y -= plotinfo.yaxis._offset;
                          if(yPixelSized) {
                              _y = r2p(plotinfo.yaxis, plotinfo.yanchor) - _y;
                          } else {
                              _y = p2r(plotinfo.yaxis, _y);
                          }
                      } else {
                          if(noOffset) _y -= size.t;
                          if(domain) _y = domain.y[1] - _y / size.h;
                          else _y = 1 - _y / size.h;
                      }
                  }
  
                  newPos[j][k + 1] = _x;
                  newPos[j][k + 2] = _y;
              }
              polys[n].push(
                  newPos[j].slice()
              );
          }
      }
  
      return polys;
  };
  
  function almostEq(a, b) {
      return Math.abs(a - b) <= 1e-6;
  }
  
  function dist(a, b) {
      var dx = b[1] - a[1];
      var dy = b[2] - a[2];
      return Math.sqrt(
          dx * dx +
          dy * dy
      );
  }
  
  exports.pointsShapeRectangle = function(cell) {
      var len = cell.length;
      if(len !== 5) return false;
  
      for(var j = 1; j < 3; j++) {
          var e01 = cell[0][j] - cell[1][j];
          var e32 = cell[3][j] - cell[2][j];
  
          if(!almostEq(e01, e32)) return false;
  
          var e03 = cell[0][j] - cell[3][j];
          var e12 = cell[1][j] - cell[2][j];
          if(!almostEq(e03, e12)) return false;
      }
  
      // N.B. rotated rectangles are not valid rects since rotation is not supported in shapes for now.
      if(
          !almostEq(cell[0][1], cell[1][1]) &&
          !almostEq(cell[0][1], cell[3][1])
      ) return false;
  
      // reject cases with zero area
      return !!(
          dist(cell[0], cell[1]) *
          dist(cell[0], cell[3])
      );
  };
  
  exports.pointsShapeEllipse = function(cell) {
      var len = cell.length;
      if(len !== CIRCLE_SIDES + 1) return false;
  
      // opposite diagonals should be the same
      len = CIRCLE_SIDES;
      for(var i = 0; i < len; i++) {
          var k = (len * 2 - i) % len;
  
          var k2 = (len / 2 + k) % len;
          var i2 = (len / 2 + i) % len;
  
          if(!almostEq(
              dist(cell[i], cell[i2]),
              dist(cell[k], cell[k2])
          )) return false;
      }
      return true;
  };
  
  exports.handleEllipse = function(isEllipse, start, end) {
      if(!isEllipse) return [start, end]; // i.e. case of line
  
      var pos = exports.ellipseOver({
          x0: start[0],
          y0: start[1],
          x1: end[0],
          y1: end[1]
      });
  
      var cx = (pos.x1 + pos.x0) / 2;
      var cy = (pos.y1 + pos.y0) / 2;
      var rx = (pos.x1 - pos.x0) / 2;
      var ry = (pos.y1 - pos.y0) / 2;
  
      // make a circle when one dimension is zero
      if(!rx) rx = ry = ry / SQRT2;
      if(!ry) ry = rx = rx / SQRT2;
  
      var cell = [];
      for(var i = 0; i < CIRCLE_SIDES; i++) {
          var t = i * 2 * Math.PI / CIRCLE_SIDES;
          cell.push([
              cx + rx * Math.cos(t),
              cy + ry * Math.sin(t),
          ]);
      }
      return cell;
  };
  
  exports.ellipseOver = function(pos) {
      var x0 = pos.x0;
      var y0 = pos.y0;
      var x1 = pos.x1;
      var y1 = pos.y1;
  
      var dx = x1 - x0;
      var dy = y1 - y0;
  
      x0 -= dx;
      y0 -= dy;
  
      var cx = (x0 + x1) / 2;
      var cy = (y0 + y1) / 2;
  
      var scale = SQRT2;
      dx *= scale;
      dy *= scale;
  
      return {
          x0: cx - dx,
          y0: cy - dy,
          x1: cx + dx,
          y1: cy + dy
      };
  };
  
  },{"../../../plots/cartesian/helpers":810,"./constants":698,"parse-svg-path":479}],702:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var dragHelpers = _dereq_('../../dragelement/helpers');
  var drawMode = dragHelpers.drawMode;
  var openMode = dragHelpers.openMode;
  
  var constants = _dereq_('./constants');
  var i000 = constants.i000;
  var i090 = constants.i090;
  var i180 = constants.i180;
  var i270 = constants.i270;
  var cos45 = constants.cos45;
  var sin45 = constants.sin45;
  
  var cartesianHelpers = _dereq_('../../../plots/cartesian/helpers');
  var p2r = cartesianHelpers.p2r;
  var r2p = cartesianHelpers.r2p;
  
  var handleOutline = _dereq_('../../../plots/cartesian/handle_outline');
  var clearSelect = handleOutline.clearSelect;
  
  var helpers = _dereq_('./helpers');
  var readPaths = helpers.readPaths;
  var writePaths = helpers.writePaths;
  var ellipseOver = helpers.ellipseOver;
  
  
  module.exports = function newShapes(outlines, dragOptions) {
      if(!outlines.length) return;
      var e = outlines[0][0]; // pick first
      if(!e) return;
      var d = e.getAttribute('d');
  
      var gd = dragOptions.gd;
      var drwStyle = gd._fullLayout.newshape;
  
      var plotinfo = dragOptions.plotinfo;
      var xaxis = plotinfo.xaxis;
      var yaxis = plotinfo.yaxis;
      var xPaper = !!plotinfo.domain || !plotinfo.xaxis;
      var yPaper = !!plotinfo.domain || !plotinfo.yaxis;
  
      var isActiveShape = dragOptions.isActiveShape;
      var dragmode = dragOptions.dragmode;
  
      var shapes = (gd.layout || {}).shapes || [];
  
      if(!drawMode(dragmode) && isActiveShape !== undefined) {
          var id = gd._fullLayout._activeShapeIndex;
          if(id < shapes.length) {
              switch(gd._fullLayout.shapes[id].type) {
                  case 'rect':
                      dragmode = 'drawrect';
                      break;
                  case 'circle':
                      dragmode = 'drawcircle';
                      break;
                  case 'line':
                      dragmode = 'drawline';
                      break;
                  case 'path':
                      var path = shapes[id].path || '';
                      if(path[path.length - 1] === 'Z') {
                          dragmode = 'drawclosedpath';
                      } else {
                          dragmode = 'drawopenpath';
                      }
                      break;
              }
          }
      }
  
      var isOpenMode = openMode(dragmode);
  
      var polygons = readPaths(d, gd, plotinfo, isActiveShape);
  
      var newShape = {
          editable: true,
  
          xref: xPaper ? 'paper' : xaxis._id,
          yref: yPaper ? 'paper' : yaxis._id,
  
          layer: drwStyle.layer,
          opacity: drwStyle.opacity,
          line: {
              color: drwStyle.line.color,
              width: drwStyle.line.width,
              dash: drwStyle.line.dash
          }
      };
  
      if(!isOpenMode) {
          newShape.fillcolor = drwStyle.fillcolor;
          newShape.fillrule = drwStyle.fillrule;
      }
  
      var cell;
      // line, rect and circle can be in one cell
      // only define cell if there is single cell
      if(polygons.length === 1) cell = polygons[0];
  
      if(
          cell &&
          dragmode === 'drawrect'
      ) {
          newShape.type = 'rect';
          newShape.x0 = cell[0][1];
          newShape.y0 = cell[0][2];
          newShape.x1 = cell[2][1];
          newShape.y1 = cell[2][2];
      } else if(
          cell &&
          dragmode === 'drawline'
      ) {
          newShape.type = 'line';
          newShape.x0 = cell[0][1];
          newShape.y0 = cell[0][2];
          newShape.x1 = cell[1][1];
          newShape.y1 = cell[1][2];
      } else if(
          cell &&
          dragmode === 'drawcircle'
      ) {
          newShape.type = 'circle'; // an ellipse!
  
          var xA = cell[i000][1];
          var xB = cell[i090][1];
          var xC = cell[i180][1];
          var xD = cell[i270][1];
  
          var yA = cell[i000][2];
          var yB = cell[i090][2];
          var yC = cell[i180][2];
          var yD = cell[i270][2];
  
          var xDateOrLog = plotinfo.xaxis && (
              plotinfo.xaxis.type === 'date' ||
              plotinfo.xaxis.type === 'log'
          );
  
          var yDateOrLog = plotinfo.yaxis && (
              plotinfo.yaxis.type === 'date' ||
              plotinfo.yaxis.type === 'log'
          );
  
          if(xDateOrLog) {
              xA = r2p(plotinfo.xaxis, xA);
              xB = r2p(plotinfo.xaxis, xB);
              xC = r2p(plotinfo.xaxis, xC);
              xD = r2p(plotinfo.xaxis, xD);
          }
  
          if(yDateOrLog) {
              yA = r2p(plotinfo.yaxis, yA);
              yB = r2p(plotinfo.yaxis, yB);
              yC = r2p(plotinfo.yaxis, yC);
              yD = r2p(plotinfo.yaxis, yD);
          }
  
          var x0 = (xB + xD) / 2;
          var y0 = (yA + yC) / 2;
          var rx = (xD - xB + xC - xA) / 2;
          var ry = (yD - yB + yC - yA) / 2;
          var pos = ellipseOver({
              x0: x0,
              y0: y0,
              x1: x0 + rx * cos45,
              y1: y0 + ry * sin45
          });
  
          if(xDateOrLog) {
              pos.x0 = p2r(plotinfo.xaxis, pos.x0);
              pos.x1 = p2r(plotinfo.xaxis, pos.x1);
          }
  
          if(yDateOrLog) {
              pos.y0 = p2r(plotinfo.yaxis, pos.y0);
              pos.y1 = p2r(plotinfo.yaxis, pos.y1);
          }
  
          newShape.x0 = pos.x0;
          newShape.y0 = pos.y0;
          newShape.x1 = pos.x1;
          newShape.y1 = pos.y1;
      } else {
          newShape.type = 'path';
          if(xaxis && yaxis) fixDatesForPaths(polygons, xaxis, yaxis);
          newShape.path = writePaths(polygons);
          cell = null;
      }
  
      clearSelect(gd);
  
      var editHelpers = dragOptions.editHelpers;
      var modifyItem = (editHelpers || {}).modifyItem;
  
      var allShapes = [];
      for(var q = 0; q < shapes.length; q++) {
          var beforeEdit = gd._fullLayout.shapes[q];
          allShapes[q] = beforeEdit._input;
  
          if(
              isActiveShape !== undefined &&
              q === gd._fullLayout._activeShapeIndex
          ) {
              var afterEdit = newShape;
  
              switch(beforeEdit.type) {
                  case 'line':
                  case 'rect':
                  case 'circle':
                      modifyItem('x0', afterEdit.x0);
                      modifyItem('x1', afterEdit.x1);
                      modifyItem('y0', afterEdit.y0);
                      modifyItem('y1', afterEdit.y1);
                      break;
  
                  case 'path':
                      modifyItem('path', afterEdit.path);
                      break;
              }
          }
      }
  
      if(isActiveShape === undefined) {
          allShapes.push(newShape); // add new shape
          return allShapes;
      }
  
      return editHelpers ? editHelpers.getUpdateObj() : {};
  };
  
  function fixDatesForPaths(polygons, xaxis, yaxis) {
      var xIsDate = xaxis.type === 'date';
      var yIsDate = yaxis.type === 'date';
      if(!xIsDate && !yIsDate) return polygons;
  
      for(var i = 0; i < polygons.length; i++) {
          for(var j = 0; j < polygons[i].length; j++) {
              for(var k = 0; k + 2 < polygons[i][j].length; k += 2) {
                  if(xIsDate) polygons[i][j][k + 1] = polygons[i][j][k + 1].replace(' ', '_');
                  if(yIsDate) polygons[i][j][k + 2] = polygons[i][j][k + 2].replace(' ', '_');
              }
          }
      }
  
      return polygons;
  }
  
  },{"../../../plots/cartesian/handle_outline":809,"../../../plots/cartesian/helpers":810,"../../dragelement/helpers":633,"./constants":698,"./helpers":701}],703:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var constants = _dereq_('./constants');
  
  var Lib = _dereq_('../../lib');
  
  // special position conversion functions... category axis positions can't be
  // specified by their data values, because they don't make a continuous mapping.
  // so these have to be specified in terms of the category serial numbers,
  // but can take fractional values. Other axis types we specify position based on
  // the actual data values.
  // TODO: in V2.0 (when log axis ranges are in data units) range and shape position
  // will be identical, so rangeToShapePosition and shapePositionToRange can be
  // removed entirely.
  
  exports.rangeToShapePosition = function(ax) {
      return (ax.type === 'log') ? ax.r2d : function(v) { return v; };
  };
  
  exports.shapePositionToRange = function(ax) {
      return (ax.type === 'log') ? ax.d2r : function(v) { return v; };
  };
  
  exports.decodeDate = function(convertToPx) {
      return function(v) {
          if(v.replace) v = v.replace('_', ' ');
          return convertToPx(v);
      };
  };
  
  exports.encodeDate = function(convertToDate) {
      return function(v) { return convertToDate(v).replace(' ', '_'); };
  };
  
  exports.extractPathCoords = function(path, paramsToUse) {
      var extractedCoordinates = [];
  
      var segments = path.match(constants.segmentRE);
      segments.forEach(function(segment) {
          var relevantParamIdx = paramsToUse[segment.charAt(0)].drawn;
          if(relevantParamIdx === undefined) return;
  
          var params = segment.substr(1).match(constants.paramRE);
          if(!params || params.length < relevantParamIdx) return;
  
          extractedCoordinates.push(Lib.cleanNumber(params[relevantParamIdx]));
      });
  
      return extractedCoordinates;
  };
  
  exports.getDataToPixel = function(gd, axis, isVertical, refType) {
      var gs = gd._fullLayout._size;
      var dataToPixel;
  
      if(axis) {
          if(refType === 'domain') {
              dataToPixel = function(v) {
                  return axis._length * (isVertical ? (1 - v) : v) + axis._offset;
              };
          } else {
              var d2r = exports.shapePositionToRange(axis);
  
              dataToPixel = function(v) {
                  return axis._offset + axis.r2p(d2r(v, true));
              };
  
              if(axis.type === 'date') dataToPixel = exports.decodeDate(dataToPixel);
          }
      } else if(isVertical) {
          dataToPixel = function(v) { return gs.t + gs.h * (1 - v); };
      } else {
          dataToPixel = function(v) { return gs.l + gs.w * v; };
      }
  
      return dataToPixel;
  };
  
  exports.getPixelToData = function(gd, axis, isVertical, opt) {
      var gs = gd._fullLayout._size;
      var pixelToData;
  
      if(axis) {
          if(opt === 'domain') {
              pixelToData = function(p) {
                  var q = (p - axis._offset) / axis._length;
                  return isVertical ? 1 - q : q;
              };
          } else {
              var r2d = exports.rangeToShapePosition(axis);
              pixelToData = function(p) { return r2d(axis.p2r(p - axis._offset)); };
          }
      } else if(isVertical) {
          pixelToData = function(p) { return 1 - (p - gs.t) / gs.h; };
      } else {
          pixelToData = function(p) { return (p - gs.l) / gs.w; };
      }
  
      return pixelToData;
  };
  
  /**
   * Based on the given stroke width, rounds the passed
   * position value to represent either a full or half pixel.
   *
   * In case of an odd stroke width (e.g. 1), this measure ensures
   * that a stroke positioned at the returned position isn't rendered
   * blurry due to anti-aliasing.
   *
   * In case of an even stroke width (e.g. 2), this measure ensures
   * that the position value is transformed to a full pixel value
   * so that anti-aliasing doesn't take effect either.
   *
   * @param {number} pos The raw position value to be transformed
   * @param {number} strokeWidth The stroke width
   * @returns {number} either an integer or a .5 decimal number
   */
  exports.roundPositionForSharpStrokeRendering = function(pos, strokeWidth) {
      var strokeWidthIsOdd = Math.round(strokeWidth % 2) === 1;
      var posValAsInt = Math.round(pos);
  
      return strokeWidthIsOdd ? posValAsInt + 0.5 : posValAsInt;
  };
  
  exports.makeOptionsAndPlotinfo = function(gd, index) {
      var options = gd._fullLayout.shapes[index] || {};
  
      var plotinfo = gd._fullLayout._plots[options.xref + options.yref];
      var hasPlotinfo = !!plotinfo;
      if(hasPlotinfo) {
          plotinfo._hadPlotinfo = true;
      } else {
          plotinfo = {};
          if(options.xref && options.xref !== 'paper') plotinfo.xaxis = gd._fullLayout[options.xref + 'axis'];
          if(options.yref && options.yref !== 'paper') plotinfo.yaxis = gd._fullLayout[options.yref + 'axis'];
      }
  
      plotinfo.xsizemode = options.xsizemode;
      plotinfo.ysizemode = options.ysizemode;
      plotinfo.xanchor = options.xanchor;
      plotinfo.yanchor = options.yanchor;
  
      return {
          options: options,
          plotinfo: plotinfo
      };
  };
  
  },{"../../lib":750,"./constants":694}],704:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var drawModule = _dereq_('./draw');
  
  module.exports = {
      moduleType: 'component',
      name: 'shapes',
  
      layoutAttributes: _dereq_('./attributes'),
      supplyLayoutDefaults: _dereq_('./defaults'),
      supplyDrawNewShapeDefaults: _dereq_('./draw_newshape/defaults'),
      includeBasePlot: _dereq_('../../plots/cartesian/include_components')('shapes'),
  
      calcAutorange: _dereq_('./calc_autorange'),
      draw: drawModule.draw,
      drawOne: drawModule.drawOne
  };
  
  },{"../../plots/cartesian/include_components":811,"./attributes":692,"./calc_autorange":693,"./defaults":695,"./draw":696,"./draw_newshape/defaults":699}],705:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var padAttrs = _dereq_('../../plots/pad_attributes');
  var extendDeepAll = _dereq_('../../lib/extend').extendDeepAll;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var animationAttrs = _dereq_('../../plots/animation_attributes');
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  var constants = _dereq_('./constants');
  
  var stepsAttrs = templatedArray('step', {
      visible: {
          valType: 'boolean',
          
          dflt: true,
          
      },
      method: {
          valType: 'enumerated',
          values: ['restyle', 'relayout', 'animate', 'update', 'skip'],
          dflt: 'restyle',
          
          
      },
      args: {
          valType: 'info_array',
          
          freeLength: true,
          items: [
              { valType: 'any' },
              { valType: 'any' },
              { valType: 'any' }
          ],
          
      },
      label: {
          valType: 'string',
          
          
      },
      value: {
          valType: 'string',
          
          
      },
      execute: {
          valType: 'boolean',
          
          dflt: true,
          
      }
  });
  
  module.exports = overrideAll(templatedArray('slider', {
      visible: {
          valType: 'boolean',
          
          dflt: true,
          
      },
  
      active: {
          valType: 'number',
          
          min: 0,
          dflt: 0,
          
      },
  
      steps: stepsAttrs,
  
      lenmode: {
          valType: 'enumerated',
          values: ['fraction', 'pixels'],
          
          dflt: 'fraction',
          
      },
      len: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          
      },
      x: {
          valType: 'number',
          min: -2,
          max: 3,
          dflt: 0,
          
          
      },
      pad: extendDeepAll(padAttrs({editType: 'arraydraw'}), {
          
      }, {t: {dflt: 20}}),
      xanchor: {
          valType: 'enumerated',
          values: ['auto', 'left', 'center', 'right'],
          dflt: 'left',
          
          
      },
      y: {
          valType: 'number',
          min: -2,
          max: 3,
          dflt: 0,
          
          
      },
      yanchor: {
          valType: 'enumerated',
          values: ['auto', 'top', 'middle', 'bottom'],
          dflt: 'top',
          
          
      },
  
      transition: {
          duration: {
              valType: 'number',
              
              min: 0,
              dflt: 150,
              
          },
          easing: {
              valType: 'enumerated',
              values: animationAttrs.transition.easing.values,
              
              dflt: 'cubic-in-out',
              
          }
      },
  
      currentvalue: {
          visible: {
              valType: 'boolean',
              
              dflt: true,
              
          },
  
          xanchor: {
              valType: 'enumerated',
              values: ['left', 'center', 'right'],
              dflt: 'left',
              
              
          },
  
          offset: {
              valType: 'number',
              dflt: 10,
              
              
          },
  
          prefix: {
              valType: 'string',
              
              
          },
  
          suffix: {
              valType: 'string',
              
              
          },
  
          font: fontAttrs({
              
          })
      },
  
      font: fontAttrs({
          
      }),
  
      activebgcolor: {
          valType: 'color',
          
          dflt: constants.gripBgActiveColor,
          
      },
      bgcolor: {
          valType: 'color',
          
          dflt: constants.railBgColor,
          
      },
      bordercolor: {
          valType: 'color',
          dflt: constants.railBorderColor,
          
          
      },
      borderwidth: {
          valType: 'number',
          min: 0,
          dflt: constants.railBorderWidth,
          
          
      },
      ticklen: {
          valType: 'number',
          min: 0,
          dflt: constants.tickLength,
          
          
      },
      tickcolor: {
          valType: 'color',
          dflt: constants.tickColor,
          
          
      },
      tickwidth: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          
      },
      minorticklen: {
          valType: 'number',
          min: 0,
          dflt: constants.minorTickLength,
          
          
      }
  }), 'arraydraw', 'from-root');
  
  },{"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plot_api/plot_template":788,"../../plots/animation_attributes":793,"../../plots/font_attributes":827,"../../plots/pad_attributes":861,"./constants":706}],706:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  module.exports = {
  
      // layout attribute name
      name: 'sliders',
  
      // class names
      containerClassName: 'slider-container',
      groupClassName: 'slider-group',
      inputAreaClass: 'slider-input-area',
      railRectClass: 'slider-rail-rect',
      railTouchRectClass: 'slider-rail-touch-rect',
      gripRectClass: 'slider-grip-rect',
      tickRectClass: 'slider-tick-rect',
      inputProxyClass: 'slider-input-proxy',
      labelsClass: 'slider-labels',
      labelGroupClass: 'slider-label-group',
      labelClass: 'slider-label',
      currentValueClass: 'slider-current-value',
  
      railHeight: 5,
  
      // DOM attribute name in button group keeping track
      // of active update menu
      menuIndexAttrName: 'slider-active-index',
  
      // id root pass to Plots.autoMargin
      autoMarginIdRoot: 'slider-',
  
      // min item width / height
      minWidth: 30,
      minHeight: 30,
  
      // padding around item text
      textPadX: 40,
  
      // arrow offset off right edge
      arrowOffsetX: 4,
  
      railRadius: 2,
      railWidth: 5,
      railBorder: 4,
      railBorderWidth: 1,
      railBorderColor: '#bec8d9',
      railBgColor: '#f8fafc',
  
      // The distance of the rail from the edge of the touchable area
      // Slightly less than the step inset because of the curved edges
      // of the rail
      railInset: 8,
  
      // The distance from the extremal tick marks to the edge of the
      // touchable area. This is basically the same as the grip radius,
      // but for other styles it wouldn't really need to be.
      stepInset: 10,
  
      gripRadius: 10,
      gripWidth: 20,
      gripHeight: 20,
      gripBorder: 20,
      gripBorderWidth: 1,
      gripBorderColor: '#bec8d9',
      gripBgColor: '#f6f8fa',
      gripBgActiveColor: '#dbdde0',
  
      labelPadding: 8,
      labelOffset: 0,
  
      tickWidth: 1,
      tickColor: '#333',
      tickOffset: 25,
      tickLength: 7,
  
      minorTickOffset: 25,
      minorTickColor: '#333',
      minorTickLength: 4,
  
      // Extra space below the current value label:
      currentValuePadding: 8,
      currentValueInset: 0,
  };
  
  },{}],707:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  
  var attributes = _dereq_('./attributes');
  var constants = _dereq_('./constants');
  
  var name = constants.name;
  var stepAttrs = attributes.steps;
  
  
  module.exports = function slidersDefaults(layoutIn, layoutOut) {
      handleArrayContainerDefaults(layoutIn, layoutOut, {
          name: name,
          handleItemDefaults: sliderDefaults
      });
  };
  
  function sliderDefaults(sliderIn, sliderOut, layoutOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(sliderIn, sliderOut, attributes, attr, dflt);
      }
  
      var steps = handleArrayContainerDefaults(sliderIn, sliderOut, {
          name: 'steps',
          handleItemDefaults: stepDefaults
      });
  
      var stepCount = 0;
      for(var i = 0; i < steps.length; i++) {
          if(steps[i].visible) stepCount++;
      }
  
      var visible;
      // If it has fewer than two options, it's not really a slider
      if(stepCount < 2) visible = sliderOut.visible = false;
      else visible = coerce('visible');
      if(!visible) return;
  
      sliderOut._stepCount = stepCount;
      var visSteps = sliderOut._visibleSteps = Lib.filterVisible(steps);
  
      var active = coerce('active');
      if(!(steps[active] || {}).visible) sliderOut.active = visSteps[0]._index;
  
      coerce('x');
      coerce('y');
      Lib.noneOrAll(sliderIn, sliderOut, ['x', 'y']);
  
      coerce('xanchor');
      coerce('yanchor');
  
      coerce('len');
      coerce('lenmode');
  
      coerce('pad.t');
      coerce('pad.r');
      coerce('pad.b');
      coerce('pad.l');
  
      Lib.coerceFont(coerce, 'font', layoutOut.font);
  
      var currentValueIsVisible = coerce('currentvalue.visible');
  
      if(currentValueIsVisible) {
          coerce('currentvalue.xanchor');
          coerce('currentvalue.prefix');
          coerce('currentvalue.suffix');
          coerce('currentvalue.offset');
  
          Lib.coerceFont(coerce, 'currentvalue.font', sliderOut.font);
      }
  
      coerce('transition.duration');
      coerce('transition.easing');
  
      coerce('bgcolor');
      coerce('activebgcolor');
      coerce('bordercolor');
      coerce('borderwidth');
      coerce('ticklen');
      coerce('tickwidth');
      coerce('tickcolor');
      coerce('minorticklen');
  }
  
  function stepDefaults(valueIn, valueOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(valueIn, valueOut, stepAttrs, attr, dflt);
      }
  
      var visible;
      if(valueIn.method !== 'skip' && !Array.isArray(valueIn.args)) {
          visible = valueOut.visible = false;
      } else visible = coerce('visible');
  
      if(visible) {
          coerce('method');
          coerce('args');
          var label = coerce('label', 'step-' + valueOut._index);
          coerce('value', label);
          coerce('execute');
      }
  }
  
  },{"../../lib":750,"../../plots/array_container_defaults":794,"./attributes":705,"./constants":706}],708:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Plots = _dereq_('../../plots/plots');
  var Color = _dereq_('../color');
  var Drawing = _dereq_('../drawing');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
  
  var constants = _dereq_('./constants');
  var alignmentConstants = _dereq_('../../constants/alignment');
  var LINE_SPACING = alignmentConstants.LINE_SPACING;
  var FROM_TL = alignmentConstants.FROM_TL;
  var FROM_BR = alignmentConstants.FROM_BR;
  
  module.exports = function draw(gd) {
      var fullLayout = gd._fullLayout;
      var sliderData = makeSliderData(fullLayout, gd);
  
      // draw a container for *all* sliders:
      var sliders = fullLayout._infolayer
          .selectAll('g.' + constants.containerClassName)
          .data(sliderData.length > 0 ? [0] : []);
  
      sliders.enter().append('g')
          .classed(constants.containerClassName, true)
          .style('cursor', 'ew-resize');
  
      function clearSlider(sliderOpts) {
          if(sliderOpts._commandObserver) {
              sliderOpts._commandObserver.remove();
              delete sliderOpts._commandObserver;
          }
  
          // Most components don't need to explicitly remove autoMargin, because
          // marginPushers does this - but slider updates don't go through
          // a full replot so we need to explicitly remove it.
          Plots.autoMargin(gd, autoMarginId(sliderOpts));
      }
  
      sliders.exit().each(function() {
          d3.select(this).selectAll('g.' + constants.groupClassName)
              .each(clearSlider);
      })
      .remove();
  
      // Return early if no menus visible:
      if(sliderData.length === 0) return;
  
      var sliderGroups = sliders.selectAll('g.' + constants.groupClassName)
          .data(sliderData, keyFunction);
  
      sliderGroups.enter().append('g')
          .classed(constants.groupClassName, true);
  
      sliderGroups.exit()
          .each(clearSlider)
          .remove();
  
      // Find the dimensions of the sliders:
      for(var i = 0; i < sliderData.length; i++) {
          var sliderOpts = sliderData[i];
          findDimensions(gd, sliderOpts);
      }
  
      sliderGroups.each(function(sliderOpts) {
          var gSlider = d3.select(this);
  
          computeLabelSteps(sliderOpts);
  
          Plots.manageCommandObserver(gd, sliderOpts, sliderOpts._visibleSteps, function(data) {
              // NB: Same as below. This is *not* always the same as sliderOpts since
              // if a new set of steps comes in, the reference in this callback would
              // be invalid. We need to refetch it from the slider group, which is
              // the join data that creates this slider. So if this slider still exists,
              // the group should be valid, *to the best of my knowledge.* If not,
              // we'd have to look it up by d3 data join index/key.
              var opts = gSlider.data()[0];
  
              if(opts.active === data.index) return;
              if(opts._dragging) return;
  
              setActive(gd, gSlider, opts, data.index, false, true);
          });
  
          drawSlider(gd, d3.select(this), sliderOpts);
      });
  };
  
  function autoMarginId(sliderOpts) {
      return constants.autoMarginIdRoot + sliderOpts._index;
  }
  
  // This really only just filters by visibility:
  function makeSliderData(fullLayout, gd) {
      var contOpts = fullLayout[constants.name];
      var sliderData = [];
  
      for(var i = 0; i < contOpts.length; i++) {
          var item = contOpts[i];
          if(!item.visible) continue;
          item._gd = gd;
          sliderData.push(item);
      }
  
      return sliderData;
  }
  
  // This is set in the defaults step:
  function keyFunction(opts) {
      return opts._index;
  }
  
  // Compute the dimensions (mutates sliderOpts):
  function findDimensions(gd, sliderOpts) {
      var sliderLabels = Drawing.tester.selectAll('g.' + constants.labelGroupClass)
          .data(sliderOpts._visibleSteps);
  
      sliderLabels.enter().append('g')
          .classed(constants.labelGroupClass, true);
  
      // loop over fake buttons to find width / height
      var maxLabelWidth = 0;
      var labelHeight = 0;
      sliderLabels.each(function(stepOpts) {
          var labelGroup = d3.select(this);
  
          var text = drawLabel(labelGroup, {step: stepOpts}, sliderOpts);
  
          var textNode = text.node();
          if(textNode) {
              var bBox = Drawing.bBox(textNode);
              labelHeight = Math.max(labelHeight, bBox.height);
              maxLabelWidth = Math.max(maxLabelWidth, bBox.width);
          }
      });
  
      sliderLabels.remove();
  
      var dims = sliderOpts._dims = {};
  
      dims.inputAreaWidth = Math.max(
          constants.railWidth,
          constants.gripHeight
      );
  
      // calculate some overall dimensions - some of these are needed for
      // calculating the currentValue dimensions
      var graphSize = gd._fullLayout._size;
      dims.lx = graphSize.l + graphSize.w * sliderOpts.x;
      dims.ly = graphSize.t + graphSize.h * (1 - sliderOpts.y);
  
      if(sliderOpts.lenmode === 'fraction') {
          // fraction:
          dims.outerLength = Math.round(graphSize.w * sliderOpts.len);
      } else {
          // pixels:
          dims.outerLength = sliderOpts.len;
      }
  
      // The length of the rail, *excluding* padding on either end:
      dims.inputAreaStart = 0;
      dims.inputAreaLength = Math.round(dims.outerLength - sliderOpts.pad.l - sliderOpts.pad.r);
  
      var textableInputLength = dims.inputAreaLength - 2 * constants.stepInset;
      var availableSpacePerLabel = textableInputLength / (sliderOpts._stepCount - 1);
      var computedSpacePerLabel = maxLabelWidth + constants.labelPadding;
      dims.labelStride = Math.max(1, Math.ceil(computedSpacePerLabel / availableSpacePerLabel));
      dims.labelHeight = labelHeight;
  
      // loop over all possible values for currentValue to find the
      // area we need for it
      dims.currentValueMaxWidth = 0;
      dims.currentValueHeight = 0;
      dims.currentValueTotalHeight = 0;
      dims.currentValueMaxLines = 1;
  
      if(sliderOpts.currentvalue.visible) {
          // Get the dimensions of the current value label:
          var dummyGroup = Drawing.tester.append('g');
  
          sliderLabels.each(function(stepOpts) {
              var curValPrefix = drawCurrentValue(dummyGroup, sliderOpts, stepOpts.label);
              var curValSize = (curValPrefix.node() && Drawing.bBox(curValPrefix.node())) || {width: 0, height: 0};
              var lines = svgTextUtils.lineCount(curValPrefix);
              dims.currentValueMaxWidth = Math.max(dims.currentValueMaxWidth, Math.ceil(curValSize.width));
              dims.currentValueHeight = Math.max(dims.currentValueHeight, Math.ceil(curValSize.height));
              dims.currentValueMaxLines = Math.max(dims.currentValueMaxLines, lines);
          });
  
          dims.currentValueTotalHeight = dims.currentValueHeight + sliderOpts.currentvalue.offset;
  
          dummyGroup.remove();
      }
  
      dims.height = dims.currentValueTotalHeight + constants.tickOffset + sliderOpts.ticklen + constants.labelOffset + dims.labelHeight + sliderOpts.pad.t + sliderOpts.pad.b;
  
      var xanchor = 'left';
      if(Lib.isRightAnchor(sliderOpts)) {
          dims.lx -= dims.outerLength;
          xanchor = 'right';
      }
      if(Lib.isCenterAnchor(sliderOpts)) {
          dims.lx -= dims.outerLength / 2;
          xanchor = 'center';
      }
  
      var yanchor = 'top';
      if(Lib.isBottomAnchor(sliderOpts)) {
          dims.ly -= dims.height;
          yanchor = 'bottom';
      }
      if(Lib.isMiddleAnchor(sliderOpts)) {
          dims.ly -= dims.height / 2;
          yanchor = 'middle';
      }
  
      dims.outerLength = Math.ceil(dims.outerLength);
      dims.height = Math.ceil(dims.height);
      dims.lx = Math.round(dims.lx);
      dims.ly = Math.round(dims.ly);
  
      var marginOpts = {
          y: sliderOpts.y,
          b: dims.height * FROM_BR[yanchor],
          t: dims.height * FROM_TL[yanchor]
      };
  
      if(sliderOpts.lenmode === 'fraction') {
          marginOpts.l = 0;
          marginOpts.xl = sliderOpts.x - sliderOpts.len * FROM_TL[xanchor];
          marginOpts.r = 0;
          marginOpts.xr = sliderOpts.x + sliderOpts.len * FROM_BR[xanchor];
      } else {
          marginOpts.x = sliderOpts.x;
          marginOpts.l = dims.outerLength * FROM_TL[xanchor];
          marginOpts.r = dims.outerLength * FROM_BR[xanchor];
      }
  
      Plots.autoMargin(gd, autoMarginId(sliderOpts), marginOpts);
  }
  
  function drawSlider(gd, sliderGroup, sliderOpts) {
      // This is related to the other long notes in this file regarding what happens
      // when slider steps disappear. This particular fix handles what happens when
      // the *current* slider step is removed. The drawing functions will error out
      // when they fail to find it, so the fix for now is that it will just draw the
      // slider in the first position but will not execute the command.
      if(!((sliderOpts.steps[sliderOpts.active] || {}).visible)) {
          sliderOpts.active = sliderOpts._visibleSteps[0]._index;
      }
  
      // These are carefully ordered for proper z-ordering:
      sliderGroup
          .call(drawCurrentValue, sliderOpts)
          .call(drawRail, sliderOpts)
          .call(drawLabelGroup, sliderOpts)
          .call(drawTicks, sliderOpts)
          .call(drawTouchRect, gd, sliderOpts)
          .call(drawGrip, gd, sliderOpts);
  
      var dims = sliderOpts._dims;
  
      // Position the rectangle:
      Drawing.setTranslate(sliderGroup, dims.lx + sliderOpts.pad.l, dims.ly + sliderOpts.pad.t);
  
      sliderGroup.call(setGripPosition, sliderOpts, false);
      sliderGroup.call(drawCurrentValue, sliderOpts);
  }
  
  function drawCurrentValue(sliderGroup, sliderOpts, valueOverride) {
      if(!sliderOpts.currentvalue.visible) return;
  
      var dims = sliderOpts._dims;
      var x0, textAnchor;
  
      switch(sliderOpts.currentvalue.xanchor) {
          case 'right':
              // This is anchored left and adjusted by the width of the longest label
              // so that the prefix doesn't move. The goal of this is to emphasize
              // what's actually changing and make the update less distracting.
              x0 = dims.inputAreaLength - constants.currentValueInset - dims.currentValueMaxWidth;
              textAnchor = 'left';
              break;
          case 'center':
              x0 = dims.inputAreaLength * 0.5;
              textAnchor = 'middle';
              break;
          default:
              x0 = constants.currentValueInset;
              textAnchor = 'left';
      }
  
      var text = Lib.ensureSingle(sliderGroup, 'text', constants.labelClass, function(s) {
          s.attr({
              'text-anchor': textAnchor,
              'data-notex': 1
          });
      });
  
      var str = sliderOpts.currentvalue.prefix ? sliderOpts.currentvalue.prefix : '';
  
      if(typeof valueOverride === 'string') {
          str += valueOverride;
      } else {
          var curVal = sliderOpts.steps[sliderOpts.active].label;
          var _meta = sliderOpts._gd._fullLayout._meta;
          if(_meta) curVal = Lib.templateString(curVal, _meta);
          str += curVal;
      }
  
      if(sliderOpts.currentvalue.suffix) {
          str += sliderOpts.currentvalue.suffix;
      }
  
      text.call(Drawing.font, sliderOpts.currentvalue.font)
          .text(str)
          .call(svgTextUtils.convertToTspans, sliderOpts._gd);
  
      var lines = svgTextUtils.lineCount(text);
  
      var y0 = (dims.currentValueMaxLines + 1 - lines) *
          sliderOpts.currentvalue.font.size * LINE_SPACING;
  
      svgTextUtils.positionText(text, x0, y0);
  
      return text;
  }
  
  function drawGrip(sliderGroup, gd, sliderOpts) {
      var grip = Lib.ensureSingle(sliderGroup, 'rect', constants.gripRectClass, function(s) {
          s.call(attachGripEvents, gd, sliderGroup, sliderOpts)
              .style('pointer-events', 'all');
      });
  
      grip.attr({
          width: constants.gripWidth,
          height: constants.gripHeight,
          rx: constants.gripRadius,
          ry: constants.gripRadius,
      })
      .call(Color.stroke, sliderOpts.bordercolor)
      .call(Color.fill, sliderOpts.bgcolor)
      .style('stroke-width', sliderOpts.borderwidth + 'px');
  }
  
  function drawLabel(item, data, sliderOpts) {
      var text = Lib.ensureSingle(item, 'text', constants.labelClass, function(s) {
          s.attr({
              'text-anchor': 'middle',
              'data-notex': 1
          });
      });
  
      var tx = data.step.label;
      var _meta = sliderOpts._gd._fullLayout._meta;
      if(_meta) tx = Lib.templateString(tx, _meta);
  
      text.call(Drawing.font, sliderOpts.font)
          .text(tx)
          .call(svgTextUtils.convertToTspans, sliderOpts._gd);
  
      return text;
  }
  
  function drawLabelGroup(sliderGroup, sliderOpts) {
      var labels = Lib.ensureSingle(sliderGroup, 'g', constants.labelsClass);
      var dims = sliderOpts._dims;
  
      var labelItems = labels.selectAll('g.' + constants.labelGroupClass)
          .data(dims.labelSteps);
  
      labelItems.enter().append('g')
          .classed(constants.labelGroupClass, true);
  
      labelItems.exit().remove();
  
      labelItems.each(function(d) {
          var item = d3.select(this);
  
          item.call(drawLabel, d, sliderOpts);
  
          Drawing.setTranslate(item,
              normalizedValueToPosition(sliderOpts, d.fraction),
              constants.tickOffset +
                  sliderOpts.ticklen +
                  // position is the baseline of the top line of text only, even
                  // if the label spans multiple lines
                  sliderOpts.font.size * LINE_SPACING +
                  constants.labelOffset +
                  dims.currentValueTotalHeight
          );
      });
  }
  
  function handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, doTransition) {
      var quantizedPosition = Math.round(normalizedPosition * (sliderOpts._stepCount - 1));
      var quantizedIndex = sliderOpts._visibleSteps[quantizedPosition]._index;
  
      if(quantizedIndex !== sliderOpts.active) {
          setActive(gd, sliderGroup, sliderOpts, quantizedIndex, true, doTransition);
      }
  }
  
  function setActive(gd, sliderGroup, sliderOpts, index, doCallback, doTransition) {
      var previousActive = sliderOpts.active;
      sliderOpts.active = index;
  
      // due to templating, it's possible this slider doesn't even exist yet
      arrayEditor(gd.layout, constants.name, sliderOpts)
          .applyUpdate('active', index);
  
      var step = sliderOpts.steps[sliderOpts.active];
  
      sliderGroup.call(setGripPosition, sliderOpts, doTransition);
      sliderGroup.call(drawCurrentValue, sliderOpts);
  
      gd.emit('plotly_sliderchange', {
          slider: sliderOpts,
          step: sliderOpts.steps[sliderOpts.active],
          interaction: doCallback,
          previousActive: previousActive
      });
  
      if(step && step.method && doCallback) {
          if(sliderGroup._nextMethod) {
              // If we've already queued up an update, just overwrite it with the most recent:
              sliderGroup._nextMethod.step = step;
              sliderGroup._nextMethod.doCallback = doCallback;
              sliderGroup._nextMethod.doTransition = doTransition;
          } else {
              sliderGroup._nextMethod = {step: step, doCallback: doCallback, doTransition: doTransition};
              sliderGroup._nextMethodRaf = window.requestAnimationFrame(function() {
                  var _step = sliderGroup._nextMethod.step;
                  if(!_step.method) return;
  
                  if(_step.execute) {
                      Plots.executeAPICommand(gd, _step.method, _step.args);
                  }
  
                  sliderGroup._nextMethod = null;
                  sliderGroup._nextMethodRaf = null;
              });
          }
      }
  }
  
  function attachGripEvents(item, gd, sliderGroup) {
      var node = sliderGroup.node();
      var $gd = d3.select(gd);
  
      // NB: This is *not* the same as sliderOpts itself! These callbacks
      // are in a closure so this array won't actually be correct if the
      // steps have changed since this was initialized. The sliderGroup,
      // however, has not changed since that *is* the slider, so it must
      // be present to receive mouse events.
      function getSliderOpts() {
          return sliderGroup.data()[0];
      }
  
      item.on('mousedown', function() {
          var sliderOpts = getSliderOpts();
          gd.emit('plotly_sliderstart', {slider: sliderOpts});
  
          var grip = sliderGroup.select('.' + constants.gripRectClass);
  
          d3.event.stopPropagation();
          d3.event.preventDefault();
          grip.call(Color.fill, sliderOpts.activebgcolor);
  
          var normalizedPosition = positionToNormalizedValue(sliderOpts, d3.mouse(node)[0]);
          handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, true);
          sliderOpts._dragging = true;
  
          $gd.on('mousemove', function() {
              var sliderOpts = getSliderOpts();
              var normalizedPosition = positionToNormalizedValue(sliderOpts, d3.mouse(node)[0]);
              handleInput(gd, sliderGroup, sliderOpts, normalizedPosition, false);
          });
  
          $gd.on('mouseup', function() {
              var sliderOpts = getSliderOpts();
              sliderOpts._dragging = false;
              grip.call(Color.fill, sliderOpts.bgcolor);
              $gd.on('mouseup', null);
              $gd.on('mousemove', null);
  
              gd.emit('plotly_sliderend', {
                  slider: sliderOpts,
                  step: sliderOpts.steps[sliderOpts.active]
              });
          });
      });
  }
  
  function drawTicks(sliderGroup, sliderOpts) {
      var tick = sliderGroup.selectAll('rect.' + constants.tickRectClass)
          .data(sliderOpts._visibleSteps);
      var dims = sliderOpts._dims;
  
      tick.enter().append('rect')
          .classed(constants.tickRectClass, true);
  
      tick.exit().remove();
  
      tick.attr({
          width: sliderOpts.tickwidth + 'px',
          'shape-rendering': 'crispEdges'
      });
  
      tick.each(function(d, i) {
          var isMajor = i % dims.labelStride === 0;
          var item = d3.select(this);
  
          item
              .attr({height: isMajor ? sliderOpts.ticklen : sliderOpts.minorticklen})
              .call(Color.fill, isMajor ? sliderOpts.tickcolor : sliderOpts.tickcolor);
  
          Drawing.setTranslate(item,
              normalizedValueToPosition(sliderOpts, i / (sliderOpts._stepCount - 1)) - 0.5 * sliderOpts.tickwidth,
              (isMajor ? constants.tickOffset : constants.minorTickOffset) + dims.currentValueTotalHeight
          );
      });
  }
  
  function computeLabelSteps(sliderOpts) {
      var dims = sliderOpts._dims;
      dims.labelSteps = [];
      var nsteps = sliderOpts._stepCount;
  
      for(var i = 0; i < nsteps; i += dims.labelStride) {
          dims.labelSteps.push({
              fraction: i / (nsteps - 1),
              step: sliderOpts._visibleSteps[i]
          });
      }
  }
  
  function setGripPosition(sliderGroup, sliderOpts, doTransition) {
      var grip = sliderGroup.select('rect.' + constants.gripRectClass);
  
      var quantizedIndex = 0;
      for(var i = 0; i < sliderOpts._stepCount; i++) {
          if(sliderOpts._visibleSteps[i]._index === sliderOpts.active) {
              quantizedIndex = i;
              break;
          }
      }
  
      var x = normalizedValueToPosition(sliderOpts, quantizedIndex / (sliderOpts._stepCount - 1));
  
      // If this is true, then *this component* is already invoking its own command
      // and has triggered its own animation.
      if(sliderOpts._invokingCommand) return;
  
      var el = grip;
      if(doTransition && sliderOpts.transition.duration > 0) {
          el = el.transition()
              .duration(sliderOpts.transition.duration)
              .ease(sliderOpts.transition.easing);
      }
  
      // Drawing.setTranslate doesn't work here becasue of the transition duck-typing.
      // It's also not necessary because there are no other transitions to preserve.
      el.attr('transform', 'translate(' + (x - constants.gripWidth * 0.5) + ',' + (sliderOpts._dims.currentValueTotalHeight) + ')');
  }
  
  // Convert a number from [0-1] to a pixel position relative to the slider group container:
  function normalizedValueToPosition(sliderOpts, normalizedPosition) {
      var dims = sliderOpts._dims;
      return dims.inputAreaStart + constants.stepInset +
          (dims.inputAreaLength - 2 * constants.stepInset) * Math.min(1, Math.max(0, normalizedPosition));
  }
  
  // Convert a position relative to the slider group to a nubmer in [0, 1]
  function positionToNormalizedValue(sliderOpts, position) {
      var dims = sliderOpts._dims;
      return Math.min(1, Math.max(0, (position - constants.stepInset - dims.inputAreaStart) / (dims.inputAreaLength - 2 * constants.stepInset - 2 * dims.inputAreaStart)));
  }
  
  function drawTouchRect(sliderGroup, gd, sliderOpts) {
      var dims = sliderOpts._dims;
      var rect = Lib.ensureSingle(sliderGroup, 'rect', constants.railTouchRectClass, function(s) {
          s.call(attachGripEvents, gd, sliderGroup, sliderOpts)
              .style('pointer-events', 'all');
      });
  
      rect.attr({
          width: dims.inputAreaLength,
          height: Math.max(dims.inputAreaWidth, constants.tickOffset + sliderOpts.ticklen + dims.labelHeight)
      })
          .call(Color.fill, sliderOpts.bgcolor)
          .attr('opacity', 0);
  
      Drawing.setTranslate(rect, 0, dims.currentValueTotalHeight);
  }
  
  function drawRail(sliderGroup, sliderOpts) {
      var dims = sliderOpts._dims;
      var computedLength = dims.inputAreaLength - constants.railInset * 2;
      var rect = Lib.ensureSingle(sliderGroup, 'rect', constants.railRectClass);
  
      rect.attr({
          width: computedLength,
          height: constants.railWidth,
          rx: constants.railRadius,
          ry: constants.railRadius,
          'shape-rendering': 'crispEdges'
      })
      .call(Color.stroke, sliderOpts.bordercolor)
      .call(Color.fill, sliderOpts.bgcolor)
      .style('stroke-width', sliderOpts.borderwidth + 'px');
  
      Drawing.setTranslate(rect,
          constants.railInset,
          (dims.inputAreaWidth - constants.railWidth) * 0.5 + dims.currentValueTotalHeight
      );
  }
  
  },{"../../constants/alignment":717,"../../lib":750,"../../lib/svg_text_utils":774,"../../plot_api/plot_template":788,"../../plots/plots":862,"../color":615,"../drawing":637,"./constants":706,"d3":169}],709:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var constants = _dereq_('./constants');
  
  module.exports = {
      moduleType: 'component',
      name: constants.name,
  
      layoutAttributes: _dereq_('./attributes'),
      supplyLayoutDefaults: _dereq_('./defaults'),
  
      draw: _dereq_('./draw')
  };
  
  },{"./attributes":705,"./constants":706,"./defaults":707,"./draw":708}],710:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Plots = _dereq_('../../plots/plots');
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../drawing');
  var Color = _dereq_('../color');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var interactConstants = _dereq_('../../constants/interactions');
  
  var OPPOSITE_SIDE = _dereq_('../../constants/alignment').OPPOSITE_SIDE;
  var numStripRE = / [XY][0-9]* /;
  
  /**
   * Titles - (re)draw titles on the axes and plot:
   * @param {DOM element} gd - the graphDiv
   * @param {string} titleClass - the css class of this title
   * @param {object} options - how and what to draw
   *      propContainer - the layout object containing `title` and `titlefont`
   *          attributes that apply to this title
   *      propName - the full name of the title property (for Plotly.relayout)
   *      [traceIndex] - include only if this property applies to one trace
   *          (such as a colorbar title) - then editing pipes to Plotly.restyle
   *          instead of Plotly.relayout
   *      placeholder - placeholder text for an empty editable title
   *      [avoid] {object} - include if this title should move to avoid other elements
   *          selection - d3 selection of elements to avoid
   *          side - which direction to move if there is a conflict
   *          [offsetLeft] - if these elements are subject to a translation
   *              wrt the title element
   *          [offsetTop]
   *      attributes {object} - position and alignment attributes
   *          x - pixels
   *          y - pixels
   *          text-anchor - start|middle|end
   *      transform {object} - how to transform the title after positioning
   *          rotate - degrees
   *          offset - shift up/down in the rotated frame (unused?)
   *      containerGroup - if an svg <g> element already exists to hold this
   *          title, include here. Otherwise it will go in fullLayout._infolayer
   *      _meta {object (optional} - meta key-value to for title with
   *          Lib.templateString, default to fullLayout._meta, if not provided
   *
   *  @return {selection} d3 selection of title container group
   */
  function draw(gd, titleClass, options) {
      var cont = options.propContainer;
      var prop = options.propName;
      var placeholder = options.placeholder;
      var traceIndex = options.traceIndex;
      var avoid = options.avoid || {};
      var attributes = options.attributes;
      var transform = options.transform;
      var group = options.containerGroup;
  
      var fullLayout = gd._fullLayout;
  
      var opacity = 1;
      var isplaceholder = false;
      var title = cont.title;
      var txt = (title && title.text ? title.text : '').trim();
  
      var font = title && title.font ? title.font : {};
      var fontFamily = font.family;
      var fontSize = font.size;
      var fontColor = font.color;
  
      // only make this title editable if we positively identify its property
      // as one that has editing enabled.
      var editAttr;
      if(prop === 'title.text') editAttr = 'titleText';
      else if(prop.indexOf('axis') !== -1) editAttr = 'axisTitleText';
      else if(prop.indexOf('colorbar' !== -1)) editAttr = 'colorbarTitleText';
      var editable = gd._context.edits[editAttr];
  
      if(txt === '') opacity = 0;
      // look for placeholder text while stripping out numbers from eg X2, Y3
      // this is just for backward compatibility with the old version that had
      // "Click to enter X2 title" and may have gotten saved in some old plots,
      // we don't want this to show up when these are displayed.
      else if(txt.replace(numStripRE, ' % ') === placeholder.replace(numStripRE, ' % ')) {
          opacity = 0.2;
          isplaceholder = true;
          if(!editable) txt = '';
      }
  
      if(options._meta) {
          txt = Lib.templateString(txt, options._meta);
      } else if(fullLayout._meta) {
          txt = Lib.templateString(txt, fullLayout._meta);
      }
  
      var elShouldExist = txt || editable;
  
      if(!group) {
          group = Lib.ensureSingle(fullLayout._infolayer, 'g', 'g-' + titleClass);
      }
  
      var el = group.selectAll('text')
          .data(elShouldExist ? [0] : []);
      el.enter().append('text');
      el.text(txt)
          // this is hacky, but convertToTspans uses the class
          // to determine whether to rotate mathJax...
          // so we need to clear out any old class and put the
          // correct one (only relevant for colorbars, at least
          // for now) - ie don't use .classed
          .attr('class', titleClass);
      el.exit().remove();
  
      if(!elShouldExist) return group;
  
      function titleLayout(titleEl) {
          Lib.syncOrAsync([drawTitle, scootTitle], titleEl);
      }
  
      function drawTitle(titleEl) {
          var transformVal;
  
          if(transform) {
              transformVal = '';
              if(transform.rotate) {
                  transformVal += 'rotate(' + [transform.rotate, attributes.x, attributes.y] + ')';
              }
              if(transform.offset) {
                  transformVal += 'translate(0, ' + transform.offset + ')';
              }
          } else {
              transformVal = null;
          }
  
          titleEl.attr('transform', transformVal);
  
          titleEl.style({
              'font-family': fontFamily,
              'font-size': d3.round(fontSize, 2) + 'px',
              fill: Color.rgb(fontColor),
              opacity: opacity * Color.opacity(fontColor),
              'font-weight': Plots.fontWeight
          })
          .attr(attributes)
          .call(svgTextUtils.convertToTspans, gd);
  
          return Plots.previousPromises(gd);
      }
  
      function scootTitle(titleElIn) {
          var titleGroup = d3.select(titleElIn.node().parentNode);
  
          if(avoid && avoid.selection && avoid.side && txt) {
              titleGroup.attr('transform', null);
  
              // move toward avoid.side (= left, right, top, bottom) if needed
              // can include pad (pixels, default 2)
              var backside = OPPOSITE_SIDE[avoid.side];
              var shiftSign = (avoid.side === 'left' || avoid.side === 'top') ? -1 : 1;
              var pad = isNumeric(avoid.pad) ? avoid.pad : 2;
  
              var titlebb = Drawing.bBox(titleGroup.node());
              var paperbb = {
                  left: 0,
                  top: 0,
                  right: fullLayout.width,
                  bottom: fullLayout.height
              };
  
              var maxshift = avoid.maxShift ||
                  shiftSign * (paperbb[avoid.side] - titlebb[avoid.side]);
              var shift = 0;
  
              // Prevent the title going off the paper
              if(maxshift < 0) {
                  shift = maxshift;
              } else {
                  // so we don't have to offset each avoided element,
                  // give the title the opposite offset
                  var offsetLeft = avoid.offsetLeft || 0;
                  var offsetTop = avoid.offsetTop || 0;
                  titlebb.left -= offsetLeft;
                  titlebb.right -= offsetLeft;
                  titlebb.top -= offsetTop;
                  titlebb.bottom -= offsetTop;
  
                  // iterate over a set of elements (avoid.selection)
                  // to avoid collisions with
                  avoid.selection.each(function() {
                      var avoidbb = Drawing.bBox(this);
  
                      if(Lib.bBoxIntersect(titlebb, avoidbb, pad)) {
                          shift = Math.max(shift, shiftSign * (
                              avoidbb[avoid.side] - titlebb[backside]) + pad);
                      }
                  });
                  shift = Math.min(maxshift, shift);
              }
  
              if(shift > 0 || maxshift < 0) {
                  var shiftTemplate = {
                      left: [-shift, 0],
                      right: [shift, 0],
                      top: [0, -shift],
                      bottom: [0, shift]
                  }[avoid.side];
                  titleGroup.attr('transform', 'translate(' + shiftTemplate + ')');
              }
          }
      }
  
      el.call(titleLayout);
  
      function setPlaceholder() {
          opacity = 0;
          isplaceholder = true;
          el.text(placeholder)
              .on('mouseover.opacity', function() {
                  d3.select(this).transition()
                      .duration(interactConstants.SHOW_PLACEHOLDER).style('opacity', 1);
              })
              .on('mouseout.opacity', function() {
                  d3.select(this).transition()
                      .duration(interactConstants.HIDE_PLACEHOLDER).style('opacity', 0);
              });
      }
  
      if(editable) {
          if(!txt) setPlaceholder();
          else el.on('.opacity', null);
  
          el.call(svgTextUtils.makeEditable, {gd: gd})
              .on('edit', function(text) {
                  if(traceIndex !== undefined) {
                      Registry.call('_guiRestyle', gd, prop, text, traceIndex);
                  } else {
                      Registry.call('_guiRelayout', gd, prop, text);
                  }
              })
              .on('cancel', function() {
                  this.text(this.attr('data-unformatted'))
                      .call(titleLayout);
              })
              .on('input', function(d) {
                  this.text(d || ' ')
                      .call(svgTextUtils.positionText, attributes.x, attributes.y);
              });
      }
      el.classed('js-placeholder', isplaceholder);
  
      return group;
  }
  
  module.exports = {
      draw: draw
  };
  
  },{"../../constants/alignment":717,"../../constants/interactions":724,"../../lib":750,"../../lib/svg_text_utils":774,"../../plots/plots":862,"../../registry":882,"../color":615,"../drawing":637,"d3":169,"fast-isnumeric":241}],711:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var colorAttrs = _dereq_('../color/attributes');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var padAttrs = _dereq_('../../plots/pad_attributes');
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  
  var buttonsAttrs = templatedArray('button', {
      visible: {
          valType: 'boolean',
          
          
      },
      method: {
          valType: 'enumerated',
          values: ['restyle', 'relayout', 'animate', 'update', 'skip'],
          dflt: 'restyle',
          
          
      },
      args: {
          valType: 'info_array',
          
          freeLength: true,
          items: [
              {valType: 'any'},
              {valType: 'any'},
              {valType: 'any'}
          ],
          
      },
      args2: {
          valType: 'info_array',
          
          freeLength: true,
          items: [
              {valType: 'any'},
              {valType: 'any'},
              {valType: 'any'}
          ],
          
      },
      label: {
          valType: 'string',
          
          dflt: '',
          
      },
      execute: {
          valType: 'boolean',
          
          dflt: true,
          
      }
  });
  
  module.exports = overrideAll(templatedArray('updatemenu', {
      _arrayAttrRegexps: [/^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/],
  
      visible: {
          valType: 'boolean',
          
          
      },
  
      type: {
          valType: 'enumerated',
          values: ['dropdown', 'buttons'],
          dflt: 'dropdown',
          
          
      },
  
      direction: {
          valType: 'enumerated',
          values: ['left', 'right', 'up', 'down'],
          dflt: 'down',
          
          
      },
  
      active: {
          valType: 'integer',
          
          min: -1,
          dflt: 0,
          
      },
  
      showactive: {
          valType: 'boolean',
          
          dflt: true,
          
      },
  
      buttons: buttonsAttrs,
  
      x: {
          valType: 'number',
          min: -2,
          max: 3,
          dflt: -0.05,
          
          
      },
      xanchor: {
          valType: 'enumerated',
          values: ['auto', 'left', 'center', 'right'],
          dflt: 'right',
          
          
      },
      y: {
          valType: 'number',
          min: -2,
          max: 3,
          dflt: 1,
          
          
      },
      yanchor: {
          valType: 'enumerated',
          values: ['auto', 'top', 'middle', 'bottom'],
          dflt: 'top',
          
          
      },
  
      pad: extendFlat(padAttrs({editType: 'arraydraw'}), {
          
      }),
  
      font: fontAttrs({
          
      }),
  
      bgcolor: {
          valType: 'color',
          
          
      },
      bordercolor: {
          valType: 'color',
          dflt: colorAttrs.borderLine,
          
          
      },
      borderwidth: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'arraydraw',
          
      }
  }), 'arraydraw', 'from-root');
  
  },{"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plot_api/plot_template":788,"../../plots/font_attributes":827,"../../plots/pad_attributes":861,"../color/attributes":614}],712:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  module.exports = {
  
      // layout attribute name
      name: 'updatemenus',
  
      // class names
      containerClassName: 'updatemenu-container',
      headerGroupClassName: 'updatemenu-header-group',
      headerClassName: 'updatemenu-header',
      headerArrowClassName: 'updatemenu-header-arrow',
      dropdownButtonGroupClassName: 'updatemenu-dropdown-button-group',
      dropdownButtonClassName: 'updatemenu-dropdown-button',
      buttonClassName: 'updatemenu-button',
      itemRectClassName: 'updatemenu-item-rect',
      itemTextClassName: 'updatemenu-item-text',
  
      // DOM attribute name in button group keeping track
      // of active update menu
      menuIndexAttrName: 'updatemenu-active-index',
  
      // id root pass to Plots.autoMargin
      autoMarginIdRoot: 'updatemenu-',
  
      // options when 'active: -1'
      blankHeaderOpts: { label: '  ' },
  
      // min item width / height
      minWidth: 30,
      minHeight: 30,
  
      // padding around item text
      textPadX: 24,
      arrowPadX: 16,
  
      // item rect radii
      rx: 2,
      ry: 2,
  
      // item  text x offset off left edge
      textOffsetX: 12,
  
      // item  text y offset (w.r.t. middle)
      textOffsetY: 3,
  
      // arrow offset off right edge
      arrowOffsetX: 4,
  
      // gap between header and buttons
      gapButtonHeader: 5,
  
      // gap between between buttons
      gapButton: 2,
  
      // color given to active buttons
      activeColor: '#F4FAFF',
  
      // color given to hovered buttons
      hoverColor: '#F4FAFF',
  
      // symbol for menu open arrow
      arrowSymbol: {
          left: '◄',
          right: '►',
          up: '▲',
          down: '▼'
      }
  };
  
  },{}],713:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  
  var attributes = _dereq_('./attributes');
  var constants = _dereq_('./constants');
  
  var name = constants.name;
  var buttonAttrs = attributes.buttons;
  
  
  module.exports = function updateMenusDefaults(layoutIn, layoutOut) {
      var opts = {
          name: name,
          handleItemDefaults: menuDefaults
      };
  
      handleArrayContainerDefaults(layoutIn, layoutOut, opts);
  };
  
  function menuDefaults(menuIn, menuOut, layoutOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(menuIn, menuOut, attributes, attr, dflt);
      }
  
      var buttons = handleArrayContainerDefaults(menuIn, menuOut, {
          name: 'buttons',
          handleItemDefaults: buttonDefaults
      });
  
      var visible = coerce('visible', buttons.length > 0);
      if(!visible) return;
  
      coerce('active');
      coerce('direction');
      coerce('type');
      coerce('showactive');
  
      coerce('x');
      coerce('y');
      Lib.noneOrAll(menuIn, menuOut, ['x', 'y']);
  
      coerce('xanchor');
      coerce('yanchor');
  
      coerce('pad.t');
      coerce('pad.r');
      coerce('pad.b');
      coerce('pad.l');
  
      Lib.coerceFont(coerce, 'font', layoutOut.font);
  
      coerce('bgcolor', layoutOut.paper_bgcolor);
      coerce('bordercolor');
      coerce('borderwidth');
  }
  
  function buttonDefaults(buttonIn, buttonOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(buttonIn, buttonOut, buttonAttrs, attr, dflt);
      }
  
      var visible = coerce('visible',
          (buttonIn.method === 'skip' || Array.isArray(buttonIn.args)));
      if(visible) {
          coerce('method');
          coerce('args');
          coerce('args2');
          coerce('label');
          coerce('execute');
      }
  }
  
  },{"../../lib":750,"../../plots/array_container_defaults":794,"./attributes":711,"./constants":712}],714:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Plots = _dereq_('../../plots/plots');
  var Color = _dereq_('../color');
  var Drawing = _dereq_('../drawing');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var arrayEditor = _dereq_('../../plot_api/plot_template').arrayEditor;
  
  var LINE_SPACING = _dereq_('../../constants/alignment').LINE_SPACING;
  
  var constants = _dereq_('./constants');
  var ScrollBox = _dereq_('./scrollbox');
  
  module.exports = function draw(gd) {
      var fullLayout = gd._fullLayout;
      var menuData = Lib.filterVisible(fullLayout[constants.name]);
  
      /* Update menu data is bound to the header-group.
       * The items in the header group are always present.
       *
       * Upon clicking on a header its corresponding button
       * data is bound to the button-group.
       *
       * We draw all headers in one group before all buttons
       * so that the buttons *always* appear above the headers.
       *
       * Note that only one set of buttons are visible at once.
       *
       * <g container />
       *
       *     <g header-group />
       *         <g item header />
       *         <text item header-arrow />
       *     <g header-group />
       *         <g item header />
       *         <text item header-arrow />
       *     ...
       *
       *     <g button-group />
       *         <g item button />
       *         <g item button />
       *         ...
       */
  
      function clearAutoMargin(menuOpts) {
          Plots.autoMargin(gd, autoMarginId(menuOpts));
      }
  
      // draw update menu container
      var menus = fullLayout._menulayer
          .selectAll('g.' + constants.containerClassName)
          .data(menuData.length > 0 ? [0] : []);
  
      menus.enter().append('g')
          .classed(constants.containerClassName, true)
          .style('cursor', 'pointer');
  
      menus.exit().each(function() {
          // Most components don't need to explicitly remove autoMargin, because
          // marginPushers does this - but updatemenu updates don't go through
          // a full replot so we need to explicitly remove it.
          // This is for removing *all* updatemenus, removing individuals is
          // handled below, in headerGroups.exit
          d3.select(this).selectAll('g.' + constants.headerGroupClassName)
              .each(clearAutoMargin);
      }).remove();
  
      // return early if no update menus are visible
      if(menuData.length === 0) return;
  
      // join header group
      var headerGroups = menus.selectAll('g.' + constants.headerGroupClassName)
          .data(menuData, keyFunction);
  
      headerGroups.enter().append('g')
          .classed(constants.headerGroupClassName, true);
  
      // draw dropdown button container
      var gButton = Lib.ensureSingle(menus, 'g', constants.dropdownButtonGroupClassName, function(s) {
          s.style('pointer-events', 'all');
      });
  
      // find dimensions before plotting anything (this mutates menuOpts)
      for(var i = 0; i < menuData.length; i++) {
          var menuOpts = menuData[i];
          findDimensions(gd, menuOpts);
      }
  
      // setup scrollbox
      var scrollBoxId = 'updatemenus' + fullLayout._uid;
      var scrollBox = new ScrollBox(gd, gButton, scrollBoxId);
  
      // remove exiting header, remove dropped buttons and reset margins
      if(headerGroups.enter().size()) {
          // make sure gButton is on top of all headers
          gButton.node().parentNode.appendChild(gButton.node());
          gButton.call(removeAllButtons);
      }
  
      headerGroups.exit().each(function(menuOpts) {
          gButton.call(removeAllButtons);
          clearAutoMargin(menuOpts);
      }).remove();
  
      // draw headers!
      headerGroups.each(function(menuOpts) {
          var gHeader = d3.select(this);
  
          var _gButton = menuOpts.type === 'dropdown' ? gButton : null;
  
          Plots.manageCommandObserver(gd, menuOpts, menuOpts.buttons, function(data) {
              setActive(gd, menuOpts, menuOpts.buttons[data.index], gHeader, _gButton, scrollBox, data.index, true);
          });
  
          if(menuOpts.type === 'dropdown') {
              drawHeader(gd, gHeader, gButton, scrollBox, menuOpts);
  
              // if this menu is active, update the dropdown container
              if(isActive(gButton, menuOpts)) {
                  drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
              }
          } else {
              drawButtons(gd, gHeader, null, null, menuOpts);
          }
      });
  };
  
  // Note that '_index' is set at the default step,
  // it corresponds to the menu index in the user layout update menu container.
  // Because a menu can be set invisible,
  // this is a more 'consistent' field than the index in the menuData.
  function keyFunction(menuOpts) {
      return menuOpts._index;
  }
  
  function isFolded(gButton) {
      return +gButton.attr(constants.menuIndexAttrName) === -1;
  }
  
  function isActive(gButton, menuOpts) {
      return +gButton.attr(constants.menuIndexAttrName) === menuOpts._index;
  }
  
  function setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, buttonIndex, isSilentUpdate) {
      // update 'active' attribute in menuOpts
      menuOpts.active = buttonIndex;
  
      // due to templating, it's possible this slider doesn't even exist yet
      arrayEditor(gd.layout, constants.name, menuOpts)
          .applyUpdate('active', buttonIndex);
  
      if(menuOpts.type === 'buttons') {
          drawButtons(gd, gHeader, null, null, menuOpts);
      } else if(menuOpts.type === 'dropdown') {
          // fold up buttons and redraw header
          gButton.attr(constants.menuIndexAttrName, '-1');
  
          drawHeader(gd, gHeader, gButton, scrollBox, menuOpts);
  
          if(!isSilentUpdate) {
              drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
          }
      }
  }
  
  function drawHeader(gd, gHeader, gButton, scrollBox, menuOpts) {
      var header = Lib.ensureSingle(gHeader, 'g', constants.headerClassName, function(s) {
          s.style('pointer-events', 'all');
      });
  
      var dims = menuOpts._dims;
      var active = menuOpts.active;
      var headerOpts = menuOpts.buttons[active] || constants.blankHeaderOpts;
      var posOpts = { y: menuOpts.pad.t, yPad: 0, x: menuOpts.pad.l, xPad: 0, index: 0 };
      var positionOverrides = {
          width: dims.headerWidth,
          height: dims.headerHeight
      };
  
      header
          .call(drawItem, menuOpts, headerOpts, gd)
          .call(setItemPosition, menuOpts, posOpts, positionOverrides);
  
      // draw drop arrow at the right edge
      var arrow = Lib.ensureSingle(gHeader, 'text', constants.headerArrowClassName, function(s) {
          s.attr('text-anchor', 'end')
              .call(Drawing.font, menuOpts.font)
              .text(constants.arrowSymbol[menuOpts.direction]);
      });
  
      arrow.attr({
          x: dims.headerWidth - constants.arrowOffsetX + menuOpts.pad.l,
          y: dims.headerHeight / 2 + constants.textOffsetY + menuOpts.pad.t
      });
  
      header.on('click', function() {
          gButton.call(removeAllButtons,
              String(isActive(gButton, menuOpts) ? -1 : menuOpts._index)
          );
  
          drawButtons(gd, gHeader, gButton, scrollBox, menuOpts);
      });
  
      header.on('mouseover', function() {
          header.call(styleOnMouseOver);
      });
  
      header.on('mouseout', function() {
          header.call(styleOnMouseOut, menuOpts);
      });
  
      // translate header group
      Drawing.setTranslate(gHeader, dims.lx, dims.ly);
  }
  
  function drawButtons(gd, gHeader, gButton, scrollBox, menuOpts) {
      // If this is a set of buttons, set pointer events = all since we play
      // some minor games with which container is which in order to simplify
      // the drawing of *either* buttons or menus
      if(!gButton) {
          gButton = gHeader;
          gButton.attr('pointer-events', 'all');
      }
  
      var buttonData = (!isFolded(gButton) || menuOpts.type === 'buttons') ?
          menuOpts.buttons :
          [];
  
      var klass = menuOpts.type === 'dropdown' ? constants.dropdownButtonClassName : constants.buttonClassName;
  
      var buttons = gButton.selectAll('g.' + klass)
          .data(Lib.filterVisible(buttonData));
  
      var enter = buttons.enter().append('g')
          .classed(klass, true);
  
      var exit = buttons.exit();
  
      if(menuOpts.type === 'dropdown') {
          enter.attr('opacity', '0')
              .transition()
              .attr('opacity', '1');
  
          exit.transition()
              .attr('opacity', '0')
              .remove();
      } else {
          exit.remove();
      }
  
      var x0 = 0;
      var y0 = 0;
      var dims = menuOpts._dims;
  
      var isVertical = ['up', 'down'].indexOf(menuOpts.direction) !== -1;
  
      if(menuOpts.type === 'dropdown') {
          if(isVertical) {
              y0 = dims.headerHeight + constants.gapButtonHeader;
          } else {
              x0 = dims.headerWidth + constants.gapButtonHeader;
          }
      }
  
      if(menuOpts.type === 'dropdown' && menuOpts.direction === 'up') {
          y0 = -constants.gapButtonHeader + constants.gapButton - dims.openHeight;
      }
  
      if(menuOpts.type === 'dropdown' && menuOpts.direction === 'left') {
          x0 = -constants.gapButtonHeader + constants.gapButton - dims.openWidth;
      }
  
      var posOpts = {
          x: dims.lx + x0 + menuOpts.pad.l,
          y: dims.ly + y0 + menuOpts.pad.t,
          yPad: constants.gapButton,
          xPad: constants.gapButton,
          index: 0,
      };
  
      var scrollBoxPosition = {
          l: posOpts.x + menuOpts.borderwidth,
          t: posOpts.y + menuOpts.borderwidth
      };
  
      buttons.each(function(buttonOpts, buttonIndex) {
          var button = d3.select(this);
  
          button
              .call(drawItem, menuOpts, buttonOpts, gd)
              .call(setItemPosition, menuOpts, posOpts);
  
          button.on('click', function() {
              // skip `dragend` events
              if(d3.event.defaultPrevented) return;
  
              if(buttonOpts.execute) {
                  if(buttonOpts.args2 && menuOpts.active === buttonIndex) {
                      setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, -1);
                      Plots.executeAPICommand(gd, buttonOpts.method, buttonOpts.args2);
                  } else {
                      setActive(gd, menuOpts, buttonOpts, gHeader, gButton, scrollBox, buttonIndex);
                      Plots.executeAPICommand(gd, buttonOpts.method, buttonOpts.args);
                  }
              }
  
              gd.emit('plotly_buttonclicked', {menu: menuOpts, button: buttonOpts, active: menuOpts.active});
          });
  
          button.on('mouseover', function() {
              button.call(styleOnMouseOver);
          });
  
          button.on('mouseout', function() {
              button.call(styleOnMouseOut, menuOpts);
              buttons.call(styleButtons, menuOpts);
          });
      });
  
      buttons.call(styleButtons, menuOpts);
  
      if(isVertical) {
          scrollBoxPosition.w = Math.max(dims.openWidth, dims.headerWidth);
          scrollBoxPosition.h = posOpts.y - scrollBoxPosition.t;
      } else {
          scrollBoxPosition.w = posOpts.x - scrollBoxPosition.l;
          scrollBoxPosition.h = Math.max(dims.openHeight, dims.headerHeight);
      }
  
      scrollBoxPosition.direction = menuOpts.direction;
  
      if(scrollBox) {
          if(buttons.size()) {
              drawScrollBox(gd, gHeader, gButton, scrollBox, menuOpts, scrollBoxPosition);
          } else {
              hideScrollBox(scrollBox);
          }
      }
  }
  
  function drawScrollBox(gd, gHeader, gButton, scrollBox, menuOpts, position) {
      // enable the scrollbox
      var direction = menuOpts.direction;
      var isVertical = (direction === 'up' || direction === 'down');
      var dims = menuOpts._dims;
  
      var active = menuOpts.active;
      var translateX, translateY;
      var i;
      if(isVertical) {
          translateY = 0;
          for(i = 0; i < active; i++) {
              translateY += dims.heights[i] + constants.gapButton;
          }
      } else {
          translateX = 0;
          for(i = 0; i < active; i++) {
              translateX += dims.widths[i] + constants.gapButton;
          }
      }
  
      scrollBox.enable(position, translateX, translateY);
  
      if(scrollBox.hbar) {
          scrollBox.hbar
              .attr('opacity', '0')
              .transition()
              .attr('opacity', '1');
      }
  
      if(scrollBox.vbar) {
          scrollBox.vbar
              .attr('opacity', '0')
              .transition()
              .attr('opacity', '1');
      }
  }
  
  function hideScrollBox(scrollBox) {
      var hasHBar = !!scrollBox.hbar;
      var hasVBar = !!scrollBox.vbar;
  
      if(hasHBar) {
          scrollBox.hbar
              .transition()
              .attr('opacity', '0')
              .each('end', function() {
                  hasHBar = false;
                  if(!hasVBar) scrollBox.disable();
              });
      }
  
      if(hasVBar) {
          scrollBox.vbar
              .transition()
              .attr('opacity', '0')
              .each('end', function() {
                  hasVBar = false;
                  if(!hasHBar) scrollBox.disable();
              });
      }
  }
  
  function drawItem(item, menuOpts, itemOpts, gd) {
      item.call(drawItemRect, menuOpts)
          .call(drawItemText, menuOpts, itemOpts, gd);
  }
  
  function drawItemRect(item, menuOpts) {
      var rect = Lib.ensureSingle(item, 'rect', constants.itemRectClassName, function(s) {
          s.attr({
              rx: constants.rx,
              ry: constants.ry,
              'shape-rendering': 'crispEdges'
          });
      });
  
      rect.call(Color.stroke, menuOpts.bordercolor)
          .call(Color.fill, menuOpts.bgcolor)
          .style('stroke-width', menuOpts.borderwidth + 'px');
  }
  
  function drawItemText(item, menuOpts, itemOpts, gd) {
      var text = Lib.ensureSingle(item, 'text', constants.itemTextClassName, function(s) {
          s.attr({
              'text-anchor': 'start',
              'data-notex': 1
          });
      });
  
      var tx = itemOpts.label;
      var _meta = gd._fullLayout._meta;
      if(_meta) tx = Lib.templateString(tx, _meta);
  
      text.call(Drawing.font, menuOpts.font)
          .text(tx)
          .call(svgTextUtils.convertToTspans, gd);
  }
  
  function styleButtons(buttons, menuOpts) {
      var active = menuOpts.active;
  
      buttons.each(function(buttonOpts, i) {
          var button = d3.select(this);
  
          if(i === active && menuOpts.showactive) {
              button.select('rect.' + constants.itemRectClassName)
                  .call(Color.fill, constants.activeColor);
          }
      });
  }
  
  function styleOnMouseOver(item) {
      item.select('rect.' + constants.itemRectClassName)
          .call(Color.fill, constants.hoverColor);
  }
  
  function styleOnMouseOut(item, menuOpts) {
      item.select('rect.' + constants.itemRectClassName)
          .call(Color.fill, menuOpts.bgcolor);
  }
  
  // find item dimensions (this mutates menuOpts)
  function findDimensions(gd, menuOpts) {
      var dims = menuOpts._dims = {
          width1: 0,
          height1: 0,
          heights: [],
          widths: [],
          totalWidth: 0,
          totalHeight: 0,
          openWidth: 0,
          openHeight: 0,
          lx: 0,
          ly: 0
      };
  
      var fakeButtons = Drawing.tester.selectAll('g.' + constants.dropdownButtonClassName)
          .data(Lib.filterVisible(menuOpts.buttons));
  
      fakeButtons.enter().append('g')
          .classed(constants.dropdownButtonClassName, true);
  
      var isVertical = ['up', 'down'].indexOf(menuOpts.direction) !== -1;
  
      // loop over fake buttons to find width / height
      fakeButtons.each(function(buttonOpts, i) {
          var button = d3.select(this);
  
          button.call(drawItem, menuOpts, buttonOpts, gd);
  
          var text = button.select('.' + constants.itemTextClassName);
  
          // width is given by max width of all buttons
          var tWidth = text.node() && Drawing.bBox(text.node()).width;
          var wEff = Math.max(tWidth + constants.textPadX, constants.minWidth);
  
          // height is determined by item text
          var tHeight = menuOpts.font.size * LINE_SPACING;
          var tLines = svgTextUtils.lineCount(text);
          var hEff = Math.max(tHeight * tLines, constants.minHeight) + constants.textOffsetY;
  
          hEff = Math.ceil(hEff);
          wEff = Math.ceil(wEff);
  
          // Store per-item sizes since a row of horizontal buttons, for example,
          // don't all need to be the same width:
          dims.widths[i] = wEff;
          dims.heights[i] = hEff;
  
          // Height and width of individual element:
          dims.height1 = Math.max(dims.height1, hEff);
          dims.width1 = Math.max(dims.width1, wEff);
  
          if(isVertical) {
              dims.totalWidth = Math.max(dims.totalWidth, wEff);
              dims.openWidth = dims.totalWidth;
              dims.totalHeight += hEff + constants.gapButton;
              dims.openHeight += hEff + constants.gapButton;
          } else {
              dims.totalWidth += wEff + constants.gapButton;
              dims.openWidth += wEff + constants.gapButton;
              dims.totalHeight = Math.max(dims.totalHeight, hEff);
              dims.openHeight = dims.totalHeight;
          }
      });
  
      if(isVertical) {
          dims.totalHeight -= constants.gapButton;
      } else {
          dims.totalWidth -= constants.gapButton;
      }
  
  
      dims.headerWidth = dims.width1 + constants.arrowPadX;
      dims.headerHeight = dims.height1;
  
      if(menuOpts.type === 'dropdown') {
          if(isVertical) {
              dims.width1 += constants.arrowPadX;
              dims.totalHeight = dims.height1;
          } else {
              dims.totalWidth = dims.width1;
          }
          dims.totalWidth += constants.arrowPadX;
      }
  
      fakeButtons.remove();
  
      var paddedWidth = dims.totalWidth + menuOpts.pad.l + menuOpts.pad.r;
      var paddedHeight = dims.totalHeight + menuOpts.pad.t + menuOpts.pad.b;
  
      var graphSize = gd._fullLayout._size;
      dims.lx = graphSize.l + graphSize.w * menuOpts.x;
      dims.ly = graphSize.t + graphSize.h * (1 - menuOpts.y);
  
      var xanchor = 'left';
      if(Lib.isRightAnchor(menuOpts)) {
          dims.lx -= paddedWidth;
          xanchor = 'right';
      }
      if(Lib.isCenterAnchor(menuOpts)) {
          dims.lx -= paddedWidth / 2;
          xanchor = 'center';
      }
  
      var yanchor = 'top';
      if(Lib.isBottomAnchor(menuOpts)) {
          dims.ly -= paddedHeight;
          yanchor = 'bottom';
      }
      if(Lib.isMiddleAnchor(menuOpts)) {
          dims.ly -= paddedHeight / 2;
          yanchor = 'middle';
      }
  
      dims.totalWidth = Math.ceil(dims.totalWidth);
      dims.totalHeight = Math.ceil(dims.totalHeight);
      dims.lx = Math.round(dims.lx);
      dims.ly = Math.round(dims.ly);
  
      Plots.autoMargin(gd, autoMarginId(menuOpts), {
          x: menuOpts.x,
          y: menuOpts.y,
          l: paddedWidth * ({right: 1, center: 0.5}[xanchor] || 0),
          r: paddedWidth * ({left: 1, center: 0.5}[xanchor] || 0),
          b: paddedHeight * ({top: 1, middle: 0.5}[yanchor] || 0),
          t: paddedHeight * ({bottom: 1, middle: 0.5}[yanchor] || 0)
      });
  }
  
  function autoMarginId(menuOpts) {
      return constants.autoMarginIdRoot + menuOpts._index;
  }
  
  // set item positions (mutates posOpts)
  function setItemPosition(item, menuOpts, posOpts, overrideOpts) {
      overrideOpts = overrideOpts || {};
      var rect = item.select('.' + constants.itemRectClassName);
      var text = item.select('.' + constants.itemTextClassName);
      var borderWidth = menuOpts.borderwidth;
      var index = posOpts.index;
      var dims = menuOpts._dims;
  
      Drawing.setTranslate(item, borderWidth + posOpts.x, borderWidth + posOpts.y);
  
      var isVertical = ['up', 'down'].indexOf(menuOpts.direction) !== -1;
      var finalHeight = overrideOpts.height || (isVertical ? dims.heights[index] : dims.height1);
  
      rect.attr({
          x: 0,
          y: 0,
          width: overrideOpts.width || (isVertical ? dims.width1 : dims.widths[index]),
          height: finalHeight
      });
  
      var tHeight = menuOpts.font.size * LINE_SPACING;
      var tLines = svgTextUtils.lineCount(text);
      var spanOffset = ((tLines - 1) * tHeight / 2);
  
      svgTextUtils.positionText(text, constants.textOffsetX,
          finalHeight / 2 - spanOffset + constants.textOffsetY);
  
      if(isVertical) {
          posOpts.y += dims.heights[index] + posOpts.yPad;
      } else {
          posOpts.x += dims.widths[index] + posOpts.xPad;
      }
  
      posOpts.index++;
  }
  
  function removeAllButtons(gButton, newMenuIndexAttr) {
      gButton
          .attr(constants.menuIndexAttrName, newMenuIndexAttr || '-1')
          .selectAll('g.' + constants.dropdownButtonClassName).remove();
  }
  
  },{"../../constants/alignment":717,"../../lib":750,"../../lib/svg_text_utils":774,"../../plot_api/plot_template":788,"../../plots/plots":862,"../color":615,"../drawing":637,"./constants":712,"./scrollbox":716,"d3":169}],715:[function(_dereq_,module,exports){
  arguments[4][709][0].apply(exports,arguments)
  },{"./attributes":711,"./constants":712,"./defaults":713,"./draw":714,"dup":709}],716:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = ScrollBox;
  
  var d3 = _dereq_('d3');
  
  var Color = _dereq_('../color');
  var Drawing = _dereq_('../drawing');
  
  var Lib = _dereq_('../../lib');
  
  /**
   * Helper class to setup a scroll box
   *
   * @class
   * @param           gd          Plotly's graph div
   * @param           container   Container to be scroll-boxed (as a D3 selection)
   * @param {string}  id          Id for the clip path to implement the scroll box
   */
  function ScrollBox(gd, container, id) {
      this.gd = gd;
      this.container = container;
      this.id = id;
  
      // See ScrollBox.prototype.enable for further definition
      this.position = null;  // scrollbox position
      this.translateX = null;  // scrollbox horizontal translation
      this.translateY = null;  // scrollbox vertical translation
      this.hbar = null;  // horizontal scrollbar D3 selection
      this.vbar = null;  // vertical scrollbar D3 selection
  
      // <rect> element to capture pointer events
      this.bg = this.container.selectAll('rect.scrollbox-bg').data([0]);
  
      this.bg.exit()
          .on('.drag', null)
          .on('wheel', null)
          .remove();
  
      this.bg.enter().append('rect')
          .classed('scrollbox-bg', true)
          .style('pointer-events', 'all')
          .attr({
              opacity: 0,
              x: 0,
              y: 0,
              width: 0,
              height: 0
          });
  }
  
  // scroll bar dimensions
  ScrollBox.barWidth = 2;
  ScrollBox.barLength = 20;
  ScrollBox.barRadius = 2;
  ScrollBox.barPad = 1;
  ScrollBox.barColor = '#808BA4';
  
  /**
   * If needed, setup a clip path and scrollbars
   *
   * @method
   * @param {Object}  position
   * @param {number}  position.l  Left side position (in pixels)
   * @param {number}  position.t  Top side (in pixels)
   * @param {number}  position.w  Width (in pixels)
   * @param {number}  position.h  Height (in pixels)
   * @param {string}  [position.direction='down']
   *                  Either 'down', 'left', 'right' or 'up'
   * @param {number}  [translateX=0]  Horizontal offset (in pixels)
   * @param {number}  [translateY=0]  Vertical offset (in pixels)
   */
  ScrollBox.prototype.enable = function enable(position, translateX, translateY) {
      var fullLayout = this.gd._fullLayout;
      var fullWidth = fullLayout.width;
      var fullHeight = fullLayout.height;
  
      // compute position of scrollbox
      this.position = position;
  
      var l = this.position.l;
      var w = this.position.w;
      var t = this.position.t;
      var h = this.position.h;
      var direction = this.position.direction;
      var isDown = (direction === 'down');
      var isLeft = (direction === 'left');
      var isRight = (direction === 'right');
      var isUp = (direction === 'up');
      var boxW = w;
      var boxH = h;
      var boxL, boxR;
      var boxT, boxB;
  
      if(!isDown && !isLeft && !isRight && !isUp) {
          this.position.direction = 'down';
          isDown = true;
      }
  
      var isVertical = isDown || isUp;
      if(isVertical) {
          boxL = l;
          boxR = boxL + boxW;
  
          if(isDown) {
              // anchor to top side
              boxT = t;
              boxB = Math.min(boxT + boxH, fullHeight);
              boxH = boxB - boxT;
          } else {
              // anchor to bottom side
              boxB = t + boxH;
              boxT = Math.max(boxB - boxH, 0);
              boxH = boxB - boxT;
          }
      } else {
          boxT = t;
          boxB = boxT + boxH;
  
          if(isLeft) {
              // anchor to right side
              boxR = l + boxW;
              boxL = Math.max(boxR - boxW, 0);
              boxW = boxR - boxL;
          } else {
              // anchor to left side
              boxL = l;
              boxR = Math.min(boxL + boxW, fullWidth);
              boxW = boxR - boxL;
          }
      }
  
      this._box = {
          l: boxL,
          t: boxT,
          w: boxW,
          h: boxH
      };
  
      // compute position of horizontal scroll bar
      var needsHorizontalScrollBar = (w > boxW);
      var hbarW = ScrollBox.barLength + 2 * ScrollBox.barPad;
      var hbarH = ScrollBox.barWidth + 2 * ScrollBox.barPad;
      // draw horizontal scrollbar on the bottom side
      var hbarL = l;
      var hbarT = t + h;
  
      if(hbarT + hbarH > fullHeight) hbarT = fullHeight - hbarH;
  
      var hbar = this.container.selectAll('rect.scrollbar-horizontal').data(
              (needsHorizontalScrollBar) ? [0] : []);
  
      hbar.exit()
          .on('.drag', null)
          .remove();
  
      hbar.enter().append('rect')
          .classed('scrollbar-horizontal', true)
          .call(Color.fill, ScrollBox.barColor);
  
      if(needsHorizontalScrollBar) {
          this.hbar = hbar.attr({
              'rx': ScrollBox.barRadius,
              'ry': ScrollBox.barRadius,
              'x': hbarL,
              'y': hbarT,
              'width': hbarW,
              'height': hbarH
          });
  
          // hbar center moves between hbarXMin and hbarXMin + hbarTranslateMax
          this._hbarXMin = hbarL + hbarW / 2;
          this._hbarTranslateMax = boxW - hbarW;
      } else {
          delete this.hbar;
          delete this._hbarXMin;
          delete this._hbarTranslateMax;
      }
  
      // compute position of vertical scroll bar
      var needsVerticalScrollBar = (h > boxH);
      var vbarW = ScrollBox.barWidth + 2 * ScrollBox.barPad;
      var vbarH = ScrollBox.barLength + 2 * ScrollBox.barPad;
      // draw vertical scrollbar on the right side
      var vbarL = l + w;
      var vbarT = t;
  
      if(vbarL + vbarW > fullWidth) vbarL = fullWidth - vbarW;
  
      var vbar = this.container.selectAll('rect.scrollbar-vertical').data(
              (needsVerticalScrollBar) ? [0] : []);
  
      vbar.exit()
          .on('.drag', null)
          .remove();
  
      vbar.enter().append('rect')
          .classed('scrollbar-vertical', true)
          .call(Color.fill, ScrollBox.barColor);
  
      if(needsVerticalScrollBar) {
          this.vbar = vbar.attr({
              'rx': ScrollBox.barRadius,
              'ry': ScrollBox.barRadius,
              'x': vbarL,
              'y': vbarT,
              'width': vbarW,
              'height': vbarH
          });
  
          // vbar center moves between vbarYMin and vbarYMin + vbarTranslateMax
          this._vbarYMin = vbarT + vbarH / 2;
          this._vbarTranslateMax = boxH - vbarH;
      } else {
          delete this.vbar;
          delete this._vbarYMin;
          delete this._vbarTranslateMax;
      }
  
      // setup a clip path (if scroll bars are needed)
      var clipId = this.id;
      var clipL = boxL - 0.5;
      var clipR = (needsVerticalScrollBar) ? boxR + vbarW + 0.5 : boxR + 0.5;
      var clipT = boxT - 0.5;
      var clipB = (needsHorizontalScrollBar) ? boxB + hbarH + 0.5 : boxB + 0.5;
  
      var clipPath = fullLayout._topdefs.selectAll('#' + clipId)
          .data((needsHorizontalScrollBar || needsVerticalScrollBar) ? [0] : []);
  
      clipPath.exit().remove();
  
      clipPath.enter()
          .append('clipPath').attr('id', clipId)
          .append('rect');
  
      if(needsHorizontalScrollBar || needsVerticalScrollBar) {
          this._clipRect = clipPath.select('rect').attr({
              x: Math.floor(clipL),
              y: Math.floor(clipT),
              width: Math.ceil(clipR) - Math.floor(clipL),
              height: Math.ceil(clipB) - Math.floor(clipT)
          });
  
          this.container.call(Drawing.setClipUrl, clipId, this.gd);
  
          this.bg.attr({
              x: l,
              y: t,
              width: w,
              height: h
          });
      } else {
          this.bg.attr({
              width: 0,
              height: 0
          });
          this.container
              .on('wheel', null)
              .on('.drag', null)
              .call(Drawing.setClipUrl, null);
          delete this._clipRect;
      }
  
      // set up drag listeners (if scroll bars are needed)
      if(needsHorizontalScrollBar || needsVerticalScrollBar) {
          var onBoxDrag = d3.behavior.drag()
              .on('dragstart', function() {
                  d3.event.sourceEvent.preventDefault();
              })
              .on('drag', this._onBoxDrag.bind(this));
  
          this.container
              .on('wheel', null)
              .on('wheel', this._onBoxWheel.bind(this))
              .on('.drag', null)
              .call(onBoxDrag);
  
          var onBarDrag = d3.behavior.drag()
              .on('dragstart', function() {
                  d3.event.sourceEvent.preventDefault();
                  d3.event.sourceEvent.stopPropagation();
              })
              .on('drag', this._onBarDrag.bind(this));
  
          if(needsHorizontalScrollBar) {
              this.hbar
                  .on('.drag', null)
                  .call(onBarDrag);
          }
  
          if(needsVerticalScrollBar) {
              this.vbar
                  .on('.drag', null)
                  .call(onBarDrag);
          }
      }
  
      // set scrollbox translation
      this.setTranslate(translateX, translateY);
  };
  
  /**
   * If present, remove clip-path and scrollbars
   *
   * @method
   */
  ScrollBox.prototype.disable = function disable() {
      if(this.hbar || this.vbar) {
          this.bg.attr({
              width: 0,
              height: 0
          });
          this.container
              .on('wheel', null)
              .on('.drag', null)
              .call(Drawing.setClipUrl, null);
          delete this._clipRect;
      }
  
      if(this.hbar) {
          this.hbar.on('.drag', null);
          this.hbar.remove();
          delete this.hbar;
          delete this._hbarXMin;
          delete this._hbarTranslateMax;
      }
  
      if(this.vbar) {
          this.vbar.on('.drag', null);
          this.vbar.remove();
          delete this.vbar;
          delete this._vbarYMin;
          delete this._vbarTranslateMax;
      }
  };
  
  /**
   * Handles scroll box drag events
   *
   * @method
   */
  ScrollBox.prototype._onBoxDrag = function _onBoxDrag() {
      var translateX = this.translateX;
      var translateY = this.translateY;
  
      if(this.hbar) {
          translateX -= d3.event.dx;
      }
  
      if(this.vbar) {
          translateY -= d3.event.dy;
      }
  
      this.setTranslate(translateX, translateY);
  };
  
  /**
   * Handles scroll box wheel events
   *
   * @method
   */
  ScrollBox.prototype._onBoxWheel = function _onBoxWheel() {
      var translateX = this.translateX;
      var translateY = this.translateY;
  
      if(this.hbar) {
          translateX += d3.event.deltaY;
      }
  
      if(this.vbar) {
          translateY += d3.event.deltaY;
      }
  
      this.setTranslate(translateX, translateY);
  };
  
  /**
   * Handles scroll bar drag events
   *
   * @method
   */
  ScrollBox.prototype._onBarDrag = function _onBarDrag() {
      var translateX = this.translateX;
      var translateY = this.translateY;
  
      if(this.hbar) {
          var xMin = translateX + this._hbarXMin;
          var xMax = xMin + this._hbarTranslateMax;
          var x = Lib.constrain(d3.event.x, xMin, xMax);
          var xf = (x - xMin) / (xMax - xMin);
  
          var translateXMax = this.position.w - this._box.w;
  
          translateX = xf * translateXMax;
      }
  
      if(this.vbar) {
          var yMin = translateY + this._vbarYMin;
          var yMax = yMin + this._vbarTranslateMax;
          var y = Lib.constrain(d3.event.y, yMin, yMax);
          var yf = (y - yMin) / (yMax - yMin);
  
          var translateYMax = this.position.h - this._box.h;
  
          translateY = yf * translateYMax;
      }
  
      this.setTranslate(translateX, translateY);
  };
  
  /**
   * Set clip path and scroll bar translate transform
   *
   * @method
   * @param {number}  [translateX=0]  Horizontal offset (in pixels)
   * @param {number}  [translateY=0]  Vertical offset (in pixels)
   */
  ScrollBox.prototype.setTranslate = function setTranslate(translateX, translateY) {
      // store translateX and translateY (needed by mouse event handlers)
      var translateXMax = this.position.w - this._box.w;
      var translateYMax = this.position.h - this._box.h;
  
      translateX = Lib.constrain(translateX || 0, 0, translateXMax);
      translateY = Lib.constrain(translateY || 0, 0, translateYMax);
  
      this.translateX = translateX;
      this.translateY = translateY;
  
      this.container.call(Drawing.setTranslate,
          this._box.l - this.position.l - translateX,
          this._box.t - this.position.t - translateY);
  
      if(this._clipRect) {
          this._clipRect.attr({
              x: Math.floor(this.position.l + translateX - 0.5),
              y: Math.floor(this.position.t + translateY - 0.5)
          });
      }
  
      if(this.hbar) {
          var xf = translateX / translateXMax;
  
          this.hbar.call(Drawing.setTranslate,
              translateX + xf * this._hbarTranslateMax,
              translateY);
      }
  
      if(this.vbar) {
          var yf = translateY / translateYMax;
  
          this.vbar.call(Drawing.setTranslate,
              translateX,
              translateY + yf * this._vbarTranslateMax);
      }
  };
  
  },{"../../lib":750,"../color":615,"../drawing":637,"d3":169}],717:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  // fraction of some size to get to a named position
  module.exports = {
      // from bottom left: this is the origin of our paper-reference
      // positioning system
      FROM_BL: {
          left: 0,
          center: 0.5,
          right: 1,
          bottom: 0,
          middle: 0.5,
          top: 1
      },
      // from top left: this is the screen pixel positioning origin
      FROM_TL: {
          left: 0,
          center: 0.5,
          right: 1,
          bottom: 1,
          middle: 0.5,
          top: 0
      },
      // from bottom right: sometimes you just need the opposite of ^^
      FROM_BR: {
          left: 1,
          center: 0.5,
          right: 0,
          bottom: 0,
          middle: 0.5,
          top: 1
      },
      // multiple of fontSize to get the vertical offset between lines
      LINE_SPACING: 1.3,
  
      // multiple of fontSize to shift from the baseline
      // to the cap (captical letter) line
      // (to use when we don't calculate this shift from Drawing.bBox)
      // This is an approximation since in reality cap height can differ
      // from font to font. However, according to Wikipedia
      //   an "average" font might have a cap height of 70% of the em
      // https://en.wikipedia.org/wiki/Em_(typography)#History
      CAP_SHIFT: 0.70,
  
      // half the cap height (distance between baseline and cap line)
      // of an "average" font (for more info see above).
      MID_SHIFT: 0.35,
  
      OPPOSITE_SIDE: {
          left: 'right',
          right: 'left',
          top: 'bottom',
          bottom: 'top'
      }
  };
  
  },{}],718:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = {
      axisRefDescription: function(axisname, lower, upper) {
          return [
              'If set to a', axisname, 'axis id (e.g. *' + axisname + '* or',
              '*' + axisname + '2*), the `' + axisname + '` position refers to a',
              axisname, 'coordinate. If set to *paper*, the `' + axisname + '`',
              'position refers to the distance from the', lower, 'of the plotting',
              'area in normalized coordinates where *0* (*1*) corresponds to the',
              lower, '(' + upper + '). If set to a', axisname, 'axis ID followed by',
              '*domain* (separated by a space), the position behaves like for',
              '*paper*, but refers to the distance in fractions of the domain',
              'length from the', lower, 'of the domain of that axis: e.g.,',
              '*' + axisname + '2 domain* refers to the domain of the second',
              axisname, ' axis and a', axisname, 'position of 0.5 refers to the',
              'point between the', lower, 'and the', upper, 'of the domain of the',
              'second', axisname, 'axis.',
          ].join(' ');
      }
  };
  
  },{}],719:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      INCREASING: {
          COLOR: '#3D9970',
          SYMBOL: '▲'
      },
      DECREASING: {
          COLOR: '#FF4136',
          SYMBOL: '▼'
      }
  };
  
  },{}],720:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      FORMAT_LINK: 'https://github.com/d3/d3-3.x-api-reference/blob/master/Formatting.md#d3_format',
      DATE_FORMAT_LINK: 'https://github.com/d3/d3-time-format#locale_format'
  };
  
  },{}],721:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      COMPARISON_OPS: ['=', '!=', '<', '>=', '>', '<='],
      COMPARISON_OPS2: ['=', '<', '>=', '>', '<='],
      INTERVAL_OPS: ['[]', '()', '[)', '(]', '][', ')(', '](', ')['],
      SET_OPS: ['{}', '}{'],
      CONSTRAINT_REDUCTION: {
          // for contour constraints, open/closed endpoints are equivalent
          '=': '=',
  
          '<': '<',
          '<=': '<',
  
          '>': '>',
          '>=': '>',
  
          '[]': '[]',
          '()': '[]',
          '[)': '[]',
          '(]': '[]',
  
          '][': '][',
          ')(': '][',
          '](': '][',
          ')[': ']['
      }
  };
  
  },{}],722:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = {
      solid: [[], 0],
      dot: [[0.5, 1], 200],
      dash: [[0.5, 1], 50],
      longdash: [[0.5, 1], 10],
      dashdot: [[0.5, 0.625, 0.875, 1], 50],
      longdashdot: [[0.5, 0.7, 0.8, 1], 10]
  };
  
  },{}],723:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = {
      circle: '●',
      'circle-open': '○',
      square: '■',
      'square-open': '□',
      diamond: '◆',
      'diamond-open': '◇',
      cross: '+',
      x: '❌'
  };
  
  },{}],724:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  module.exports = {
      /**
       * Timing information for interactive elements
       */
      SHOW_PLACEHOLDER: 100,
      HIDE_PLACEHOLDER: 1000,
  
      // opacity dimming fraction for points that are not in selection
      DESELECTDIM: 0.2
  };
  
  },{}],725:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  module.exports = {
      /**
       * Standardize all missing data in calcdata to use undefined
       * never null or NaN.
       * That way we can use !==undefined, or !== BADNUM,
       * to test for real data
       */
      BADNUM: undefined,
  
      /*
       * Limit certain operations to well below floating point max value
       * to avoid glitches: Make sure that even when you multiply it by the
       * number of pixels on a giant screen it still works
       */
      FP_SAFE: Number.MAX_VALUE / 10000,
  
      /*
       * conversion of date units to milliseconds
       * year and month constants are marked "AVG"
       * to remind us that not all years and months
       * have the same length
       */
      ONEMAXYEAR: 31622400000, // 366 * ONEDAY
      ONEAVGYEAR: 31557600000, // 365.25 days
      ONEMINYEAR: 31536000000, // 365 * ONEDAY
      ONEMAXQUARTER: 7948800000, // 92 * ONEDAY
      ONEAVGQUARTER: 7889400000, // 1/4 of ONEAVGYEAR
      ONEMINQUARTER: 7689600000, // 89 * ONEDAY
      ONEMAXMONTH: 2678400000, // 31 * ONEDAY
      ONEAVGMONTH: 2629800000, // 1/12 of ONEAVGYEAR
      ONEMINMONTH: 2419200000, // 28 * ONEDAY
      ONEWEEK: 604800000, // 7 * ONEDAY
      ONEDAY: 86400000, // 24 * ONEHOUR
      ONEHOUR: 3600000,
      ONEMIN: 60000,
      ONESEC: 1000,
  
      /*
       * For fast conversion btwn world calendars and epoch ms, the Julian Day Number
       * of the unix epoch. From calendars.instance().newDate(1970, 1, 1).toJD()
       */
      EPOCHJD: 2440587.5,
  
      /*
       * Are two values nearly equal? Compare to 1PPM
       */
      ALMOST_EQUAL: 1 - 1e-6,
  
      /*
       * If we're asked to clip a non-positive log value, how far off-screen
       * do we put it?
       */
      LOG_CLIP: 10,
  
      /*
       * not a number, but for displaying numbers: the "minus sign" symbol is
       * wider than the regular ascii dash "-"
       */
      MINUS_SIGN: '\u2212'
  };
  
  },{}],726:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  exports.xmlns = 'http://www.w3.org/2000/xmlns/';
  exports.svg = 'http://www.w3.org/2000/svg';
  exports.xlink = 'http://www.w3.org/1999/xlink';
  
  // the 'old' d3 quirk got fix in v3.5.7
  // https://github.com/mbostock/d3/commit/a6f66e9dd37f764403fc7c1f26be09ab4af24fed
  exports.svgAttrs = {
      xmlns: exports.svg,
      'xmlns:xlink': exports.xlink
  };
  
  },{}],727:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  exports.version = _dereq_('./version').version;
  
  // inject promise polyfill
  _dereq_('es6-promise').polyfill();
  
  // inject plot css
  _dereq_('../build/plotcss');
  
  // inject default MathJax config
  _dereq_('./fonts/mathjax_config')();
  
  // include registry module and expose register method
  var Registry = _dereq_('./registry');
  var register = exports.register = Registry.register;
  
  // expose plot api methods
  var plotApi = _dereq_('./plot_api');
  var methodNames = Object.keys(plotApi);
  for(var i = 0; i < methodNames.length; i++) {
      var name = methodNames[i];
      // _ -> private API methods, but still registered for internal use
      if(name.charAt(0) !== '_') exports[name] = plotApi[name];
      register({
          moduleType: 'apiMethod',
          name: name,
          fn: plotApi[name]
      });
  }
  
  // scatter is the only trace included by default
  register(_dereq_('./traces/scatter'));
  
  // register all registrable components modules
  register([
      _dereq_('./components/legend'),
      _dereq_('./components/fx'), // fx needs to come after legend
      _dereq_('./components/annotations'),
      _dereq_('./components/annotations3d'),
      _dereq_('./components/shapes'),
      _dereq_('./components/images'),
      _dereq_('./components/updatemenus'),
      _dereq_('./components/sliders'),
      _dereq_('./components/rangeslider'),
      _dereq_('./components/rangeselector'),
      _dereq_('./components/grid'),
      _dereq_('./components/errorbars'),
      _dereq_('./components/colorscale'),
      _dereq_('./components/colorbar')
  ]);
  
  // locales en and en-US are required for default behavior
  register([
      _dereq_('./locale-en'),
      _dereq_('./locale-en-us')
  ]);
  
  // locales that are present in the window should be loaded
  if(window.PlotlyLocales && Array.isArray(window.PlotlyLocales)) {
      register(window.PlotlyLocales);
      delete window.PlotlyLocales;
  }
  
  // plot icons
  exports.Icons = _dereq_('./fonts/ploticon');
  
  // unofficial 'beta' plot methods, use at your own risk
  exports.Plots = _dereq_('./plots/plots');
  exports.Fx = _dereq_('./components/fx');
  exports.Snapshot = _dereq_('./snapshot');
  exports.PlotSchema = _dereq_('./plot_api/plot_schema');
  exports.Queue = _dereq_('./lib/queue');
  
  // export d3 used in the bundle
  exports.d3 = _dereq_('d3');
  
  },{"../build/plotcss":1,"./components/annotations":606,"./components/annotations3d":611,"./components/colorbar":621,"./components/colorscale":627,"./components/errorbars":643,"./components/fx":655,"./components/grid":659,"./components/images":664,"./components/legend":672,"./components/rangeselector":683,"./components/rangeslider":690,"./components/shapes":704,"./components/sliders":709,"./components/updatemenus":715,"./fonts/mathjax_config":728,"./fonts/ploticon":729,"./lib/queue":765,"./locale-en":779,"./locale-en-us":778,"./plot_api":783,"./plot_api/plot_schema":787,"./plots/plots":862,"./registry":882,"./snapshot":887,"./traces/scatter":1170,"./version":1341,"d3":169,"es6-promise":224}],728:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /* global MathJax:false */
  
  module.exports = function() {
      if(typeof MathJax !== 'undefined') {
          var globalConfig = (window.PlotlyConfig || {}).MathJaxConfig !== 'local';
  
          if(globalConfig) {
              MathJax.Hub.Config({
                  messageStyle: 'none',
                  skipStartupTypeset: true,
                  displayAlign: 'left',
                  tex2jax: {
                      inlineMath: [['$', '$'], ['\\(', '\\)']]
                  }
              });
              MathJax.Hub.Configured();
          }
      }
  };
  
  },{}],729:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      'undo': {
          'width': 857.1,
          'height': 1000,
          'path': 'm857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'home': {
          'width': 928.6,
          'height': 1000,
          'path': 'm786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'camera-retro': {
          'width': 1000,
          'height': 1000,
          'path': 'm518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'zoombox': {
          'width': 1000,
          'height': 1000,
          'path': 'm1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'pan': {
          'width': 1000,
          'height': 1000,
          'path': 'm1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'zoom_plus': {
          'width': 875,
          'height': 1000,
          'path': 'm1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'zoom_minus': {
          'width': 875,
          'height': 1000,
          'path': 'm0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'autoscale': {
          'width': 1000,
          'height': 1000,
          'path': 'm250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'tooltip_basic': {
          'width': 1500,
          'height': 1000,
          'path': 'm375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'tooltip_compare': {
          'width': 1125,
          'height': 1000,
          'path': 'm187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'plotlylogo': {
          'width': 1542,
          'height': 1000,
          'path': 'm0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'z-axis': {
          'width': 1000,
          'height': 1000,
          'path': 'm833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      '3d_rotate': {
          'width': 1000,
          'height': 1000,
          'path': 'm922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'camera': {
          'width': 1000,
          'height': 1000,
          'path': 'm500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'movie': {
          'width': 1000,
          'height': 1000,
          'path': 'm938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'question': {
          'width': 857.1,
          'height': 1000,
          'path': 'm500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'disk': {
          'width': 857.1,
          'height': 1000,
          'path': 'm214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'drawopenpath': {
          'width': 70,
          'height': 70,
          'path': 'M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z',
          'transform': 'matrix(1 0 0 1 -15 -15)'
      },
      'drawclosedpath': {
          'width': 90,
          'height': 90,
          'path': 'M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z',
          'transform': 'matrix(1 0 0 1 -5 -5)'
      },
      'lasso': {
          'width': 1031,
          'height': 1000,
          'path': 'm1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'selectbox': {
          'width': 1000,
          'height': 1000,
          'path': 'm0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z',
          'transform': 'matrix(1 0 0 -1 0 850)'
      },
      'drawline': {
          'width': 70,
          'height': 70,
          'path': 'M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z',
          'transform': 'matrix(1 0 0 1 -15 -15)'
      },
      'drawrect': {
          'width': 80,
          'height': 80,
          'path': 'M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z',
          'transform': 'matrix(1 0 0 1 -10 -10)'
      },
      'drawcircle': {
          'width': 80,
          'height': 80,
          'path': 'M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z',
          'transform': 'matrix(1 0 0 1 -10 -10)'
      },
      'eraseshape': {
          'width': 80,
          'height': 80,
          'path': 'M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z',
          'transform': 'matrix(1 0 0 1 -10 -10)'
      },
      'spikeline': {
          'width': 1000,
          'height': 1000,
          'path': 'M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z',
          'transform': 'matrix(1.5 0 0 -1.5 0 850)'
      },
      'pencil': {
          'width': 1792,
          'height': 1792,
          'path': 'M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z',
          'transform': 'matrix(1 0 0 1 0 1)'
      },
      'newplotlylogo': {
          'name': 'newplotlylogo',
          'svg': '<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 132 132\'><defs><style>.cls-1 {fill: #3f4f75;} .cls-2 {fill: #80cfbe;} .cls-3 {fill: #fff;}</style></defs><title>plotly-logomark</title><g id=\'symbol\'><rect class=\'cls-1\' width=\'132\' height=\'132\' rx=\'6\' ry=\'6\'/><circle class=\'cls-2\' cx=\'78\' cy=\'54\' r=\'6\'/><circle class=\'cls-2\' cx=\'102\' cy=\'30\' r=\'6\'/><circle class=\'cls-2\' cx=\'78\' cy=\'30\' r=\'6\'/><circle class=\'cls-2\' cx=\'54\' cy=\'30\' r=\'6\'/><circle class=\'cls-2\' cx=\'30\' cy=\'30\' r=\'6\'/><circle class=\'cls-2\' cx=\'30\' cy=\'54\' r=\'6\'/><path class=\'cls-3\' d=\'M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z\'/><path class=\'cls-3\' d=\'M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z\'/><path class=\'cls-3\' d=\'M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z\'/><path class=\'cls-3\' d=\'M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z\'/></g></svg>'
      }
  };
  
  },{}],730:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  /**
   * Determine the position anchor property of x/y xanchor/yanchor components.
   *
   * - values < 1/3 align the low side at that fraction,
   * - values [1/3, 2/3] align the center at that fraction,
   * - values > 2/3 align the right at that fraction.
   */
  
  
  exports.isLeftAnchor = function isLeftAnchor(opts) {
      return (
        opts.xanchor === 'left' ||
        (opts.xanchor === 'auto' && opts.x <= 1 / 3)
      );
  };
  
  exports.isCenterAnchor = function isCenterAnchor(opts) {
      return (
          opts.xanchor === 'center' ||
          (opts.xanchor === 'auto' && opts.x > 1 / 3 && opts.x < 2 / 3)
      );
  };
  
  exports.isRightAnchor = function isRightAnchor(opts) {
      return (
        opts.xanchor === 'right' ||
        (opts.xanchor === 'auto' && opts.x >= 2 / 3)
      );
  };
  
  exports.isTopAnchor = function isTopAnchor(opts) {
      return (
          opts.yanchor === 'top' ||
          (opts.yanchor === 'auto' && opts.y >= 2 / 3)
      );
  };
  
  exports.isMiddleAnchor = function isMiddleAnchor(opts) {
      return (
          opts.yanchor === 'middle' ||
          (opts.yanchor === 'auto' && opts.y > 1 / 3 && opts.y < 2 / 3)
      );
  };
  
  exports.isBottomAnchor = function isBottomAnchor(opts) {
      return (
        opts.yanchor === 'bottom' ||
        (opts.yanchor === 'auto' && opts.y <= 1 / 3)
      );
  };
  
  },{}],731:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var modModule = _dereq_('./mod');
  var mod = modModule.mod;
  var modHalf = modModule.modHalf;
  
  var PI = Math.PI;
  var twoPI = 2 * PI;
  
  function deg2rad(deg) { return deg / 180 * PI; }
  
  function rad2deg(rad) { return rad / PI * 180; }
  
  /**
   * is sector a full circle?
   * ... this comes up a lot in SVG path-drawing routines
   *
   * N.B. we consider all sectors that span more that 2pi 'full' circles
   *
   * @param {2-item array} aBnds : angular bounds in *radians*
   * @return {boolean}
   */
  function isFullCircle(aBnds) {
      return Math.abs(aBnds[1] - aBnds[0]) > twoPI - 1e-14;
  }
  
  /**
   * angular delta between angle 'a' and 'b'
   * solution taken from: https://stackoverflow.com/a/2007279
   *
   * @param {number} a : first angle in *radians*
   * @param {number} b : second angle in *radians*
   * @return {number} angular delta in *radians*
   */
  function angleDelta(a, b) {
      return modHalf(b - a, twoPI);
  }
  
  /**
   * angular distance between angle 'a' and 'b'
   *
   * @param {number} a : first angle in *radians*
   * @param {number} b : second angle in *radians*
   * @return {number} angular distance in *radians*
   */
  function angleDist(a, b) {
      return Math.abs(angleDelta(a, b));
  }
  
  /**
   * is angle inside sector?
   *
   * @param {number} a : angle to test in *radians*
   * @param {2-item array} aBnds : sector's angular bounds in *radians*
   * @param {boolean}
   */
  function isAngleInsideSector(a, aBnds) {
      if(isFullCircle(aBnds)) return true;
  
      var s0, s1;
  
      if(aBnds[0] < aBnds[1]) {
          s0 = aBnds[0];
          s1 = aBnds[1];
      } else {
          s0 = aBnds[1];
          s1 = aBnds[0];
      }
  
      s0 = mod(s0, twoPI);
      s1 = mod(s1, twoPI);
      if(s0 > s1) s1 += twoPI;
  
      var a0 = mod(a, twoPI);
      var a1 = a0 + twoPI;
  
      return (a0 >= s0 && a0 <= s1) || (a1 >= s0 && a1 <= s1);
  }
  
  /**
   * is pt (r,a) inside sector?
   *
   * @param {number} r : pt's radial coordinate
   * @param {number} a : pt's angular coordinate in *radians*
   * @param {2-item array} rBnds : sector's radial bounds
   * @param {2-item array} aBnds : sector's angular bounds in *radians*
   * @return {boolean}
   */
  function isPtInsideSector(r, a, rBnds, aBnds) {
      if(!isAngleInsideSector(a, aBnds)) return false;
  
      var r0, r1;
  
      if(rBnds[0] < rBnds[1]) {
          r0 = rBnds[0];
          r1 = rBnds[1];
      } else {
          r0 = rBnds[1];
          r1 = rBnds[0];
      }
  
      return r >= r0 && r <= r1;
  }
  
  // common to pathArc, pathSector and pathAnnulus
  function _path(r0, r1, a0, a1, cx, cy, isClosed) {
      cx = cx || 0;
      cy = cy || 0;
  
      var isCircle = isFullCircle([a0, a1]);
      var aStart, aMid, aEnd;
      var rStart, rEnd;
  
      if(isCircle) {
          aStart = 0;
          aMid = PI;
          aEnd = twoPI;
      } else {
          if(a0 < a1) {
              aStart = a0;
              aEnd = a1;
          } else {
              aStart = a1;
              aEnd = a0;
          }
      }
  
      if(r0 < r1) {
          rStart = r0;
          rEnd = r1;
      } else {
          rStart = r1;
          rEnd = r0;
      }
  
      // N.B. svg coordinates here, where y increases downward
      function pt(r, a) {
          return [r * Math.cos(a) + cx, cy - r * Math.sin(a)];
      }
  
      var largeArc = Math.abs(aEnd - aStart) <= PI ? 0 : 1;
      function arc(r, a, cw) {
          return 'A' + [r, r] + ' ' + [0, largeArc, cw] + ' ' + pt(r, a);
      }
  
      var p;
  
      if(isCircle) {
          if(rStart === null) {
              p = 'M' + pt(rEnd, aStart) +
                  arc(rEnd, aMid, 0) +
                  arc(rEnd, aEnd, 0) + 'Z';
          } else {
              p = 'M' + pt(rStart, aStart) +
                  arc(rStart, aMid, 0) +
                  arc(rStart, aEnd, 0) + 'Z' +
                  'M' + pt(rEnd, aStart) +
                  arc(rEnd, aMid, 1) +
                  arc(rEnd, aEnd, 1) + 'Z';
          }
      } else {
          if(rStart === null) {
              p = 'M' + pt(rEnd, aStart) + arc(rEnd, aEnd, 0);
              if(isClosed) p += 'L0,0Z';
          } else {
              p = 'M' + pt(rStart, aStart) +
                  'L' + pt(rEnd, aStart) +
                  arc(rEnd, aEnd, 0) +
                  'L' + pt(rStart, aEnd) +
                  arc(rStart, aStart, 1) + 'Z';
          }
      }
  
      return p;
  }
  
  /**
   * path an arc
   *
   * @param {number} r : radius
   * @param {number} a0 : first angular coordinate in *radians*
   * @param {number} a1 : second angular coordinate in *radians*
   * @param {number (optional)} cx : x coordinate of center
   * @param {number (optional)} cy : y coordinate of center
   * @return {string} svg path
   */
  function pathArc(r, a0, a1, cx, cy) {
      return _path(null, r, a0, a1, cx, cy, 0);
  }
  
  /**
   * path a sector
   *
   * @param {number} r : radius
   * @param {number} a0 : first angular coordinate in *radians*
   * @param {number} a1 : second angular coordinate in *radians*
   * @param {number (optional)} cx : x coordinate of center
   * @param {number (optional)} cy : y coordinate of center
   * @return {string} svg path
   */
  function pathSector(r, a0, a1, cx, cy) {
      return _path(null, r, a0, a1, cx, cy, 1);
  }
  
  /**
   * path an annulus
   *
   * @param {number} r0 : first radial coordinate
   * @param {number} r1 : second radial coordinate
   * @param {number} a0 : first angular coordinate in *radians*
   * @param {number} a1 : second angular coordinate in *radians*
   * @param {number (optional)} cx : x coordinate of center
   * @param {number (optional)} cy : y coordinate of center
   * @return {string} svg path
   */
  function pathAnnulus(r0, r1, a0, a1, cx, cy) {
      return _path(r0, r1, a0, a1, cx, cy, 1);
  }
  
  module.exports = {
      deg2rad: deg2rad,
      rad2deg: rad2deg,
      angleDelta: angleDelta,
      angleDist: angleDist,
      isFullCircle: isFullCircle,
      isAngleInsideSector: isAngleInsideSector,
      isPtInsideSector: isPtInsideSector,
      pathArc: pathArc,
      pathSector: pathSector,
      pathAnnulus: pathAnnulus
  };
  
  },{"./mod":757}],732:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isArray = Array.isArray;
  
  // IE9 fallbacks
  
  var ab = (typeof ArrayBuffer === 'undefined' || !ArrayBuffer.isView) ?
      {isView: function() { return false; }} :
      ArrayBuffer;
  
  var dv = (typeof DataView === 'undefined') ?
      function() {} :
      DataView;
  
  function isTypedArray(a) {
      return ab.isView(a) && !(a instanceof dv);
  }
  exports.isTypedArray = isTypedArray;
  
  function isArrayOrTypedArray(a) {
      return isArray(a) || isTypedArray(a);
  }
  exports.isArrayOrTypedArray = isArrayOrTypedArray;
  
  /*
   * Test whether an input object is 1D.
   *
   * Assumes we already know the object is an array.
   *
   * Looks only at the first element, if the dimensionality is
   * not consistent we won't figure that out here.
   */
  function isArray1D(a) {
      return !isArrayOrTypedArray(a[0]);
  }
  exports.isArray1D = isArray1D;
  
  /*
   * Ensures an array has the right amount of storage space. If it doesn't
   * exist, it creates an array. If it does exist, it returns it if too
   * short or truncates it in-place.
   *
   * The goal is to just reuse memory to avoid a bit of excessive garbage
   * collection.
   */
  exports.ensureArray = function(out, n) {
      // TODO: typed array support here? This is only used in
      // traces/carpet/compute_control_points
      if(!isArray(out)) out = [];
  
      // If too long, truncate. (If too short, it will grow
      // automatically so we don't care about that case)
      out.length = n;
  
      return out;
  };
  
  /*
   * TypedArray-compatible concatenation of n arrays
   * if all arrays are the same type it will preserve that type,
   * otherwise it falls back on Array.
   * Also tries to avoid copying, in case one array has zero length
   * But never mutates an existing array
   */
  exports.concat = function() {
      var args = [];
      var allArray = true;
      var totalLen = 0;
  
      var _constructor, arg0, i, argi, posi, leni, out, j;
  
      for(i = 0; i < arguments.length; i++) {
          argi = arguments[i];
          leni = argi.length;
          if(leni) {
              if(arg0) args.push(argi);
              else {
                  arg0 = argi;
                  posi = leni;
              }
  
              if(isArray(argi)) {
                  _constructor = false;
              } else {
                  allArray = false;
                  if(!totalLen) {
                      _constructor = argi.constructor;
                  } else if(_constructor !== argi.constructor) {
                      // TODO: in principle we could upgrade here,
                      // ie keep typed array but convert all to Float64Array?
                      _constructor = false;
                  }
              }
  
              totalLen += leni;
          }
      }
  
      if(!totalLen) return [];
      if(!args.length) return arg0;
  
      if(allArray) return arg0.concat.apply(arg0, args);
      if(_constructor) {
          // matching typed arrays
          out = new _constructor(totalLen);
          out.set(arg0);
          for(i = 0; i < args.length; i++) {
              argi = args[i];
              out.set(argi, posi);
              posi += argi.length;
          }
          return out;
      }
  
      // mismatched types or Array + typed
      out = new Array(totalLen);
      for(j = 0; j < arg0.length; j++) out[j] = arg0[j];
      for(i = 0; i < args.length; i++) {
          argi = args[i];
          for(j = 0; j < argi.length; j++) out[posi + j] = argi[j];
          posi += j;
      }
      return out;
  };
  
  exports.maxRowLength = function(z) {
      return _rowLength(z, Math.max, 0);
  };
  
  exports.minRowLength = function(z) {
      return _rowLength(z, Math.min, Infinity);
  };
  
  function _rowLength(z, fn, len0) {
      if(isArrayOrTypedArray(z)) {
          if(isArrayOrTypedArray(z[0])) {
              var len = len0;
              for(var i = 0; i < z.length; i++) {
                  len = fn(len, z[i].length);
              }
              return len;
          } else {
              return z.length;
          }
      }
      return 0;
  }
  
  },{}],733:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var BADNUM = _dereq_('../constants/numerical').BADNUM;
  
  // precompile for speed
  var JUNK = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
  
  /**
   * cleanNumber: remove common leading and trailing cruft
   * Always returns either a number or BADNUM.
   */
  module.exports = function cleanNumber(v) {
      if(typeof v === 'string') {
          v = v.replace(JUNK, '');
      }
  
      if(isNumeric(v)) return Number(v);
  
      return BADNUM;
  };
  
  },{"../constants/numerical":725,"fast-isnumeric":241}],734:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /**
   * Clear gl frame (if any). This is a common pattern as
   * we usually set `preserveDrawingBuffer: true` during
   * gl context creation (e.g. via `reglUtils.prepare`).
   *
   * @param {DOM node or object} gd : graph div object
   */
  module.exports = function clearGlCanvases(gd) {
      var fullLayout = gd._fullLayout;
  
      if(fullLayout._glcanvas && fullLayout._glcanvas.size()) {
          fullLayout._glcanvas.each(function(d) {
              if(d.regl) d.regl.clear({color: true, depth: true});
          });
      }
  };
  
  },{}],735:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /**
   * Clear responsive handlers (if any).
   *
   * @param {DOM node or object} gd : graph div object
   */
  module.exports = function clearResponsive(gd) {
      if(gd._responsiveChartHandler) {
          window.removeEventListener('resize', gd._responsiveChartHandler);
          delete gd._responsiveChartHandler;
      }
  };
  
  },{}],736:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var tinycolor = _dereq_('tinycolor2');
  
  var baseTraceAttrs = _dereq_('../plots/attributes');
  var colorscales = _dereq_('../components/colorscale/scales');
  var DESELECTDIM = _dereq_('../constants/interactions').DESELECTDIM;
  
  var nestedProperty = _dereq_('./nested_property');
  var counterRegex = _dereq_('./regex').counter;
  var modHalf = _dereq_('./mod').modHalf;
  var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
  
  exports.valObjectMeta = {
      data_array: {
          // You can use *dflt=[] to force said array to exist though.
          
          
          
          coerceFunction: function(v, propOut, dflt) {
              // TODO maybe `v: {type: 'float32', vals: [/* ... */]}` also
              if(isArrayOrTypedArray(v)) propOut.set(v);
              else if(dflt !== undefined) propOut.set(dflt);
          }
      },
      enumerated: {
          
          
          
          coerceFunction: function(v, propOut, dflt, opts) {
              if(opts.coerceNumber) v = +v;
              if(opts.values.indexOf(v) === -1) propOut.set(dflt);
              else propOut.set(v);
          },
          validateFunction: function(v, opts) {
              if(opts.coerceNumber) v = +v;
  
              var values = opts.values;
              for(var i = 0; i < values.length; i++) {
                  var k = String(values[i]);
  
                  if((k.charAt(0) === '/' && k.charAt(k.length - 1) === '/')) {
                      var regex = new RegExp(k.substr(1, k.length - 2));
                      if(regex.test(v)) return true;
                  } else if(v === values[i]) return true;
              }
              return false;
          }
      },
      'boolean': {
          
          
          
          coerceFunction: function(v, propOut, dflt) {
              if(v === true || v === false) propOut.set(v);
              else propOut.set(dflt);
          }
      },
      number: {
          
          
          
          coerceFunction: function(v, propOut, dflt, opts) {
              if(!isNumeric(v) ||
                      (opts.min !== undefined && v < opts.min) ||
                      (opts.max !== undefined && v > opts.max)) {
                  propOut.set(dflt);
              } else propOut.set(+v);
          }
      },
      integer: {
          
          
          
          coerceFunction: function(v, propOut, dflt, opts) {
              if(v % 1 || !isNumeric(v) ||
                      (opts.min !== undefined && v < opts.min) ||
                      (opts.max !== undefined && v > opts.max)) {
                  propOut.set(dflt);
              } else propOut.set(+v);
          }
      },
      string: {
          
          
          // TODO 'values shouldn't be in there (edge case: 'dash' in Scatter)
          
          coerceFunction: function(v, propOut, dflt, opts) {
              if(typeof v !== 'string') {
                  var okToCoerce = (typeof v === 'number');
  
                  if(opts.strict === true || !okToCoerce) propOut.set(dflt);
                  else propOut.set(String(v));
              } else if(opts.noBlank && !v) propOut.set(dflt);
              else propOut.set(v);
          }
      },
      color: {
          
          
          
          coerceFunction: function(v, propOut, dflt) {
              if(tinycolor(v).isValid()) propOut.set(v);
              else propOut.set(dflt);
          }
      },
      colorlist: {
          
          
          
          coerceFunction: function(v, propOut, dflt) {
              function isColor(color) {
                  return tinycolor(color).isValid();
              }
              if(!Array.isArray(v) || !v.length) propOut.set(dflt);
              else if(v.every(isColor)) propOut.set(v);
              else propOut.set(dflt);
          }
      },
      colorscale: {
          
          
          
          coerceFunction: function(v, propOut, dflt) {
              propOut.set(colorscales.get(v, dflt));
          }
      },
      angle: {
          
          
          
          coerceFunction: function(v, propOut, dflt) {
              if(v === 'auto') propOut.set('auto');
              else if(!isNumeric(v)) propOut.set(dflt);
              else propOut.set(modHalf(+v, 360));
          }
      },
      subplotid: {
          
          
          
          coerceFunction: function(v, propOut, dflt, opts) {
              var regex = opts.regex || counterRegex(dflt);
              if(typeof v === 'string' && regex.test(v)) {
                  propOut.set(v);
                  return;
              }
              propOut.set(dflt);
          },
          validateFunction: function(v, opts) {
              var dflt = opts.dflt;
  
              if(v === dflt) return true;
              if(typeof v !== 'string') return false;
              if(counterRegex(dflt).test(v)) return true;
  
              return false;
          }
      },
      flaglist: {
          
          
          
          coerceFunction: function(v, propOut, dflt, opts) {
              if(typeof v !== 'string') {
                  propOut.set(dflt);
                  return;
              }
              if((opts.extras || []).indexOf(v) !== -1) {
                  propOut.set(v);
                  return;
              }
              var vParts = v.split('+');
              var i = 0;
              while(i < vParts.length) {
                  var vi = vParts[i];
                  if(opts.flags.indexOf(vi) === -1 || vParts.indexOf(vi) < i) {
                      vParts.splice(i, 1);
                  } else i++;
              }
              if(!vParts.length) propOut.set(dflt);
              else propOut.set(vParts.join('+'));
          }
      },
      any: {
          
          
          
          coerceFunction: function(v, propOut, dflt) {
              if(v === undefined) propOut.set(dflt);
              else propOut.set(v);
          }
      },
      info_array: {
          
          
          // set `dimensions=2` for a 2D array or '1-2' for either
          // `items` may be a single object instead of an array, in which case
          // `freeLength` must be true.
          // if `dimensions='1-2'` and items is a 1D array, then the value can
          // either be a matching 1D array or an array of such matching 1D arrays
          
          coerceFunction: function(v, propOut, dflt, opts) {
              // simplified coerce function just for array items
              function coercePart(v, opts, dflt) {
                  var out;
                  var propPart = {set: function(v) { out = v; }};
  
                  if(dflt === undefined) dflt = opts.dflt;
  
                  exports.valObjectMeta[opts.valType].coerceFunction(v, propPart, dflt, opts);
  
                  return out;
              }
  
              var twoD = opts.dimensions === 2 || (opts.dimensions === '1-2' && Array.isArray(v) && Array.isArray(v[0]));
  
              if(!Array.isArray(v)) {
                  propOut.set(dflt);
                  return;
              }
  
              var items = opts.items;
              var vOut = [];
              var arrayItems = Array.isArray(items);
              var arrayItems2D = arrayItems && twoD && Array.isArray(items[0]);
              var innerItemsOnly = twoD && arrayItems && !arrayItems2D;
              var len = (arrayItems && !innerItemsOnly) ? items.length : v.length;
  
              var i, j, row, item, len2, vNew;
  
              dflt = Array.isArray(dflt) ? dflt : [];
  
              if(twoD) {
                  for(i = 0; i < len; i++) {
                      vOut[i] = [];
                      row = Array.isArray(v[i]) ? v[i] : [];
                      if(innerItemsOnly) len2 = items.length;
                      else if(arrayItems) len2 = items[i].length;
                      else len2 = row.length;
  
                      for(j = 0; j < len2; j++) {
                          if(innerItemsOnly) item = items[j];
                          else if(arrayItems) item = items[i][j];
                          else item = items;
  
                          vNew = coercePart(row[j], item, (dflt[i] || [])[j]);
                          if(vNew !== undefined) vOut[i][j] = vNew;
                      }
                  }
              } else {
                  for(i = 0; i < len; i++) {
                      vNew = coercePart(v[i], arrayItems ? items[i] : items, dflt[i]);
                      if(vNew !== undefined) vOut[i] = vNew;
                  }
              }
  
              propOut.set(vOut);
          },
          validateFunction: function(v, opts) {
              if(!Array.isArray(v)) return false;
  
              var items = opts.items;
              var arrayItems = Array.isArray(items);
              var twoD = opts.dimensions === 2;
  
              // when free length is off, input and declared lengths must match
              if(!opts.freeLength && v.length !== items.length) return false;
  
              // valid when all input items are valid
              for(var i = 0; i < v.length; i++) {
                  if(twoD) {
                      if(!Array.isArray(v[i]) || (!opts.freeLength && v[i].length !== items[i].length)) {
                          return false;
                      }
                      for(var j = 0; j < v[i].length; j++) {
                          if(!validate(v[i][j], arrayItems ? items[i][j] : items)) {
                              return false;
                          }
                      }
                  } else if(!validate(v[i], arrayItems ? items[i] : items)) return false;
              }
  
              return true;
          }
      }
  };
  
  /**
   * Ensures that container[attribute] has a valid value.
   *
   * attributes[attribute] is an object with possible keys:
   * - valType: data_array, enumerated, boolean, ... as in valObjectMeta
   * - values: (enumerated only) array of allowed vals
   * - min, max: (number, integer only) inclusive bounds on allowed vals
   *      either or both may be omitted
   * - dflt: if attribute is invalid or missing, use this default
   *      if dflt is provided as an argument to lib.coerce it takes precedence
   *      as a convenience, returns the value it finally set
   */
  exports.coerce = function(containerIn, containerOut, attributes, attribute, dflt) {
      var opts = nestedProperty(attributes, attribute).get();
      var propIn = nestedProperty(containerIn, attribute);
      var propOut = nestedProperty(containerOut, attribute);
      var v = propIn.get();
  
      var template = containerOut._template;
      if(v === undefined && template) {
          v = nestedProperty(template, attribute).get();
          // already used the template value, so short-circuit the second check
          template = 0;
      }
  
      if(dflt === undefined) dflt = opts.dflt;
  
      /**
       * arrayOk: value MAY be an array, then we do no value checking
       * at this point, because it can be more complicated than the
       * individual form (eg. some array vals can be numbers, even if the
       * single values must be color strings)
       */
      if(opts.arrayOk && isArrayOrTypedArray(v)) {
          propOut.set(v);
          return v;
      }
  
      var coerceFunction = exports.valObjectMeta[opts.valType].coerceFunction;
      coerceFunction(v, propOut, dflt, opts);
  
      var out = propOut.get();
      // in case v was provided but invalid, try the template again so it still
      // overrides the regular default
      if(template && out === dflt && !validate(v, opts)) {
          v = nestedProperty(template, attribute).get();
          coerceFunction(v, propOut, dflt, opts);
          out = propOut.get();
      }
      return out;
  };
  
  /**
   * Variation on coerce
   *
   * Uses coerce to get attribute value if user input is valid,
   * returns attribute default if user input it not valid or
   * returns false if there is no user input.
   */
  exports.coerce2 = function(containerIn, containerOut, attributes, attribute, dflt) {
      var propIn = nestedProperty(containerIn, attribute);
      var propOut = exports.coerce(containerIn, containerOut, attributes, attribute, dflt);
      var valIn = propIn.get();
  
      return (valIn !== undefined && valIn !== null) ? propOut : false;
  };
  
  /*
   * Shortcut to coerce the three font attributes
   *
   * 'coerce' is a lib.coerce wrapper with implied first three arguments
   */
  exports.coerceFont = function(coerce, attr, dfltObj) {
      var out = {};
  
      dfltObj = dfltObj || {};
  
      out.family = coerce(attr + '.family', dfltObj.family);
      out.size = coerce(attr + '.size', dfltObj.size);
      out.color = coerce(attr + '.color', dfltObj.color);
  
      return out;
  };
  
  /** Coerce shortcut for 'hoverinfo'
   * handling 1-vs-multi-trace dflt logic
   *
   * @param {object} traceIn : user trace object
   * @param {object} traceOut : full trace object (requires _module ref)
   * @param {object} layoutOut : full layout object (require _dataLength ref)
   * @return {any} : the coerced value
   */
  exports.coerceHoverinfo = function(traceIn, traceOut, layoutOut) {
      var moduleAttrs = traceOut._module.attributes;
      var attrs = moduleAttrs.hoverinfo ? moduleAttrs : baseTraceAttrs;
  
      var valObj = attrs.hoverinfo;
      var dflt;
  
      if(layoutOut._dataLength === 1) {
          var flags = valObj.dflt === 'all' ?
              valObj.flags.slice() :
              valObj.dflt.split('+');
  
          flags.splice(flags.indexOf('name'), 1);
          dflt = flags.join('+');
      }
  
      return exports.coerce(traceIn, traceOut, attrs, 'hoverinfo', dflt);
  };
  
  /** Coerce shortcut for [un]selected.marker.opacity,
   *  which has special default logic, to ensure that it corresponds to the
   *  default selection behavior while allowing to be overtaken by any other
   *  [un]selected attribute.
   *
   *  N.B. This must be called *after* coercing all the other [un]selected attrs,
   *  to give the intended result.
   *
   * @param {object} traceOut : fullData item
   * @param {function} coerce : lib.coerce wrapper with implied first three arguments
   */
  exports.coerceSelectionMarkerOpacity = function(traceOut, coerce) {
      if(!traceOut.marker) return;
  
      var mo = traceOut.marker.opacity;
      // you can still have a `marker` container with no markers if there's text
      if(mo === undefined) return;
  
      var smoDflt;
      var usmoDflt;
  
      // Don't give [un]selected.marker.opacity a default value if
      // marker.opacity is an array: handle this during style step.
      //
      // Only give [un]selected.marker.opacity a default value if you don't
      // set any other [un]selected attributes.
      if(!isArrayOrTypedArray(mo) && !traceOut.selected && !traceOut.unselected) {
          smoDflt = mo;
          usmoDflt = DESELECTDIM * mo;
      }
  
      coerce('selected.marker.opacity', smoDflt);
      coerce('unselected.marker.opacity', usmoDflt);
  };
  
  function validate(value, opts) {
      var valObjectDef = exports.valObjectMeta[opts.valType];
  
      if(opts.arrayOk && isArrayOrTypedArray(value)) return true;
  
      if(valObjectDef.validateFunction) {
          return valObjectDef.validateFunction(value, opts);
      }
  
      var failed = {};
      var out = failed;
      var propMock = { set: function(v) { out = v; } };
  
      // 'failed' just something mutable that won't be === anything else
  
      valObjectDef.coerceFunction(value, propMock, failed, opts);
      return out !== failed;
  }
  exports.validate = validate;
  
  },{"../components/colorscale/scales":630,"../constants/interactions":724,"../plots/attributes":795,"./array":732,"./mod":757,"./nested_property":758,"./regex":766,"fast-isnumeric":241,"tinycolor2":548}],737:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var timeFormat = _dereq_('d3-time-format').timeFormat;
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Loggers = _dereq_('./loggers');
  var mod = _dereq_('./mod').mod;
  
  var constants = _dereq_('../constants/numerical');
  var BADNUM = constants.BADNUM;
  var ONEDAY = constants.ONEDAY;
  var ONEHOUR = constants.ONEHOUR;
  var ONEMIN = constants.ONEMIN;
  var ONESEC = constants.ONESEC;
  var EPOCHJD = constants.EPOCHJD;
  
  var Registry = _dereq_('../registry');
  
  var utcFormat = _dereq_('d3-time-format').utcFormat;
  
  var DATETIME_REGEXP = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m;
  // special regex for chinese calendars to support yyyy-mmi-dd etc for intercalary months
  var DATETIME_REGEXP_CN = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m;
  
  // for 2-digit years, the first year we map them onto
  var YFIRST = new Date().getFullYear() - 70;
  
  function isWorldCalendar(calendar) {
      return (
          calendar &&
          Registry.componentsRegistry.calendars &&
          typeof calendar === 'string' && calendar !== 'gregorian'
      );
  }
  
  /*
   * dateTick0: get the canonical tick for this calendar
   *
   * integer weekdays : Saturday: 0, Sunday: 1, Monday: 2, etc.
   */
  exports.dateTick0 = function(calendar, dayOfWeek) {
      var tick0 = _dateTick0(calendar, !!dayOfWeek);
      if(dayOfWeek < 2) return tick0;
  
      var v = exports.dateTime2ms(tick0, calendar);
      v += ONEDAY * (dayOfWeek - 1); // shift Sunday to Monday, etc.
      return exports.ms2DateTime(v, 0, calendar);
  };
  
  /*
   * _dateTick0: get the canonical tick for this calendar
   *
   * bool sunday is for week ticks, shift it to a Sunday.
   */
  function _dateTick0(calendar, sunday) {
      if(isWorldCalendar(calendar)) {
          return sunday ?
              Registry.getComponentMethod('calendars', 'CANONICAL_SUNDAY')[calendar] :
              Registry.getComponentMethod('calendars', 'CANONICAL_TICK')[calendar];
      } else {
          return sunday ? '2000-01-02' : '2000-01-01';
      }
  }
  
  /*
   * dfltRange: for each calendar, give a valid default range
   */
  exports.dfltRange = function(calendar) {
      if(isWorldCalendar(calendar)) {
          return Registry.getComponentMethod('calendars', 'DFLTRANGE')[calendar];
      } else {
          return ['2000-01-01', '2001-01-01'];
      }
  };
  
  // is an object a javascript date?
  exports.isJSDate = function(v) {
      return typeof v === 'object' && v !== null && typeof v.getTime === 'function';
  };
  
  // The absolute limits of our date-time system
  // This is a little weird: we use MIN_MS and MAX_MS in dateTime2ms
  // but we use dateTime2ms to calculate them (after defining it!)
  var MIN_MS, MAX_MS;
  
  /**
   * dateTime2ms - turn a date object or string s into milliseconds
   * (relative to 1970-01-01, per javascript standard)
   * optional calendar (string) to use a non-gregorian calendar
   *
   * Returns BADNUM if it doesn't find a date
   *
   * strings should have the form:
   *
   *    -?YYYY-mm-dd<sep>HH:MM:SS.sss<tzInfo>?
   *
   * <sep>: space (our normal standard) or T or t (ISO-8601)
   * <tzInfo>: Z, z, [+\-]HH:?MM or [+\-]HH and we THROW IT AWAY
   * this format comes from https://tools.ietf.org/html/rfc3339#section-5.6
   * and 4.2.5.1 Difference between local time and UTC of day (ISO-8601)
   * but we allow it even with a space as the separator
   *
   * May truncate after any full field, and sss can be any length
   * even >3 digits, though javascript dates truncate to milliseconds,
   * we keep as much as javascript numeric precision can hold, but we only
   * report back up to 100 microsecond precision, because most dates support
   * this precision (close to 1970 support more, very far away support less)
   *
   * Expanded to support negative years to -9999 but you must always
   * give 4 digits, except for 2-digit positive years which we assume are
   * near the present time.
   * Note that we follow ISO 8601:2004: there *is* a year 0, which
   * is 1BC/BCE, and -1===2BC etc.
   *
   * World calendars: not all of these *have* agreed extensions to this full range,
   * if you have another calendar system but want a date range outside its validity,
   * you can use a gregorian date string prefixed with 'G' or 'g'.
   *
   * Where to cut off 2-digit years between 1900s and 2000s?
   * from https://docs.microsoft.com/en-us/office/troubleshoot/excel/two-digit-year-numbers#the-2029-rule:
   *   1930-2029 (the most retro of all...)
   * but in my mac chrome from eg. d=new Date(Date.parse('8/19/50')):
   *   1950-2049
   * by Java, from http://stackoverflow.com/questions/2024273/:
   *   now-80 - now+19
   * or FileMaker Pro, from
   *      https://fmhelp.filemaker.com/help/18/fmp/en/index.html#page/FMP_Help/dates-with-two-digit-years.html:
   *   now-70 - now+29
   * but python strptime etc, via
   *      http://docs.python.org/py3k/library/time.html:
   *   1969-2068 (super forward-looking, but static, not sliding!)
   *
   * lets go with now-70 to now+29, and if anyone runs into this problem
   * they can learn the hard way not to use 2-digit years, as no choice we
   * make now will cover all possibilities. mostly this will all be taken
   * care of in initial parsing, should only be an issue for hand-entered data
   * currently (2016) this range is:
   *   1946-2045
   */
  exports.dateTime2ms = function(s, calendar) {
      // first check if s is a date object
      if(exports.isJSDate(s)) {
          // Convert to the UTC milliseconds that give the same
          // hours as this date has in the local timezone
          var tzOffset = s.getTimezoneOffset() * ONEMIN;
          var offsetTweak = (s.getUTCMinutes() - s.getMinutes()) * ONEMIN +
              (s.getUTCSeconds() - s.getSeconds()) * ONESEC +
              (s.getUTCMilliseconds() - s.getMilliseconds());
  
          if(offsetTweak) {
              var comb = 3 * ONEMIN;
              tzOffset = tzOffset - comb / 2 + mod(offsetTweak - tzOffset + comb / 2, comb);
          }
          s = Number(s) - tzOffset;
          if(s >= MIN_MS && s <= MAX_MS) return s;
          return BADNUM;
      }
      // otherwise only accept strings and numbers
      if(typeof s !== 'string' && typeof s !== 'number') return BADNUM;
  
      s = String(s);
  
      var isWorld = isWorldCalendar(calendar);
  
      // to handle out-of-range dates in international calendars, accept
      // 'G' as a prefix to force the built-in gregorian calendar.
      var s0 = s.charAt(0);
      if(isWorld && (s0 === 'G' || s0 === 'g')) {
          s = s.substr(1);
          calendar = '';
      }
  
      var isChinese = isWorld && calendar.substr(0, 7) === 'chinese';
  
      var match = s.match(isChinese ? DATETIME_REGEXP_CN : DATETIME_REGEXP);
      if(!match) return BADNUM;
      var y = match[1];
      var m = match[3] || '1';
      var d = Number(match[5] || 1);
      var H = Number(match[7] || 0);
      var M = Number(match[9] || 0);
      var S = Number(match[11] || 0);
  
      if(isWorld) {
          // disallow 2-digit years for world calendars
          if(y.length === 2) return BADNUM;
          y = Number(y);
  
          var cDate;
          try {
              var calInstance = Registry.getComponentMethod('calendars', 'getCal')(calendar);
              if(isChinese) {
                  var isIntercalary = m.charAt(m.length - 1) === 'i';
                  m = parseInt(m, 10);
                  cDate = calInstance.newDate(y, calInstance.toMonthIndex(y, m, isIntercalary), d);
              } else {
                  cDate = calInstance.newDate(y, Number(m), d);
              }
          } catch(e) { return BADNUM; } // Invalid ... date
  
          if(!cDate) return BADNUM;
  
          return ((cDate.toJD() - EPOCHJD) * ONEDAY) +
              (H * ONEHOUR) + (M * ONEMIN) + (S * ONESEC);
      }
  
      if(y.length === 2) {
          y = (Number(y) + 2000 - YFIRST) % 100 + YFIRST;
      } else y = Number(y);
  
      // new Date uses months from 0; subtract 1 here just so we
      // don't have to do it again during the validity test below
      m -= 1;
  
      // javascript takes new Date(0..99,m,d) to mean 1900-1999, so
      // to support years 0-99 we need to use setFullYear explicitly
      // Note that 2000 is a leap year.
      var date = new Date(Date.UTC(2000, m, d, H, M));
      date.setUTCFullYear(y);
  
      if(date.getUTCMonth() !== m) return BADNUM;
      if(date.getUTCDate() !== d) return BADNUM;
  
      return date.getTime() + S * ONESEC;
  };
  
  MIN_MS = exports.MIN_MS = exports.dateTime2ms('-9999');
  MAX_MS = exports.MAX_MS = exports.dateTime2ms('9999-12-31 23:59:59.9999');
  
  // is string s a date? (see above)
  exports.isDateTime = function(s, calendar) {
      return (exports.dateTime2ms(s, calendar) !== BADNUM);
  };
  
  // pad a number with zeroes, to given # of digits before the decimal point
  function lpad(val, digits) {
      return String(val + Math.pow(10, digits)).substr(1);
  }
  
  /**
   * Turn ms into string of the form YYYY-mm-dd HH:MM:SS.ssss
   * Crop any trailing zeros in time, except never stop right after hours
   * (we could choose to crop '-01' from date too but for now we always
   * show the whole date)
   * Optional range r is the data range that applies, also in ms.
   * If rng is big, the later parts of time will be omitted
   */
  var NINETYDAYS = 90 * ONEDAY;
  var THREEHOURS = 3 * ONEHOUR;
  var FIVEMIN = 5 * ONEMIN;
  exports.ms2DateTime = function(ms, r, calendar) {
      if(typeof ms !== 'number' || !(ms >= MIN_MS && ms <= MAX_MS)) return BADNUM;
  
      if(!r) r = 0;
  
      var msecTenths = Math.floor(mod(ms + 0.05, 1) * 10);
      var msRounded = Math.round(ms - msecTenths / 10);
      var dateStr, h, m, s, msec10, d;
  
      if(isWorldCalendar(calendar)) {
          var dateJD = Math.floor(msRounded / ONEDAY) + EPOCHJD;
          var timeMs = Math.floor(mod(ms, ONEDAY));
          try {
              dateStr = Registry.getComponentMethod('calendars', 'getCal')(calendar)
                  .fromJD(dateJD).formatDate('yyyy-mm-dd');
          } catch(e) {
              // invalid date in this calendar - fall back to Gyyyy-mm-dd
              dateStr = utcFormat('G%Y-%m-%d')(new Date(msRounded));
          }
  
          // yyyy does NOT guarantee 4-digit years. YYYY mostly does, but does
          // other things for a few calendars, so we can't trust it. Just pad
          // it manually (after the '-' if there is one)
          if(dateStr.charAt(0) === '-') {
              while(dateStr.length < 11) dateStr = '-0' + dateStr.substr(1);
          } else {
              while(dateStr.length < 10) dateStr = '0' + dateStr;
          }
  
          // TODO: if this is faster, we could use this block for extracting
          // the time components of regular gregorian too
          h = (r < NINETYDAYS) ? Math.floor(timeMs / ONEHOUR) : 0;
          m = (r < NINETYDAYS) ? Math.floor((timeMs % ONEHOUR) / ONEMIN) : 0;
          s = (r < THREEHOURS) ? Math.floor((timeMs % ONEMIN) / ONESEC) : 0;
          msec10 = (r < FIVEMIN) ? (timeMs % ONESEC) * 10 + msecTenths : 0;
      } else {
          d = new Date(msRounded);
  
          dateStr = utcFormat('%Y-%m-%d')(d);
  
          // <90 days: add hours and minutes - never *only* add hours
          h = (r < NINETYDAYS) ? d.getUTCHours() : 0;
          m = (r < NINETYDAYS) ? d.getUTCMinutes() : 0;
          // <3 hours: add seconds
          s = (r < THREEHOURS) ? d.getUTCSeconds() : 0;
          // <5 minutes: add ms (plus one extra digit, this is msec*10)
          msec10 = (r < FIVEMIN) ? d.getUTCMilliseconds() * 10 + msecTenths : 0;
      }
  
      return includeTime(dateStr, h, m, s, msec10);
  };
  
  // For converting old-style milliseconds to date strings,
  // we use the local timezone rather than UTC like we use
  // everywhere else, both for backward compatibility and
  // because that's how people mostly use javasript date objects.
  // Clip one extra day off our date range though so we can't get
  // thrown beyond the range by the timezone shift.
  exports.ms2DateTimeLocal = function(ms) {
      if(!(ms >= MIN_MS + ONEDAY && ms <= MAX_MS - ONEDAY)) return BADNUM;
  
      var msecTenths = Math.floor(mod(ms + 0.05, 1) * 10);
      var d = new Date(Math.round(ms - msecTenths / 10));
      var dateStr = timeFormat('%Y-%m-%d')(d);
      var h = d.getHours();
      var m = d.getMinutes();
      var s = d.getSeconds();
      var msec10 = d.getUTCMilliseconds() * 10 + msecTenths;
  
      return includeTime(dateStr, h, m, s, msec10);
  };
  
  function includeTime(dateStr, h, m, s, msec10) {
      // include each part that has nonzero data in or after it
      if(h || m || s || msec10) {
          dateStr += ' ' + lpad(h, 2) + ':' + lpad(m, 2);
          if(s || msec10) {
              dateStr += ':' + lpad(s, 2);
              if(msec10) {
                  var digits = 4;
                  while(msec10 % 10 === 0) {
                      digits -= 1;
                      msec10 /= 10;
                  }
                  dateStr += '.' + lpad(msec10, digits);
              }
          }
      }
      return dateStr;
  }
  
  // normalize date format to date string, in case it starts as
  // a Date object or milliseconds
  // optional dflt is the return value if cleaning fails
  exports.cleanDate = function(v, dflt, calendar) {
      // let us use cleanDate to provide a missing default without an error
      if(v === BADNUM) return dflt;
      if(exports.isJSDate(v) || (typeof v === 'number' && isFinite(v))) {
          // do not allow milliseconds (old) or jsdate objects (inherently
          // described as gregorian dates) with world calendars
          if(isWorldCalendar(calendar)) {
              Loggers.error('JS Dates and milliseconds are incompatible with world calendars', v);
              return dflt;
          }
  
          // NOTE: if someone puts in a year as a number rather than a string,
          // this will mistakenly convert it thinking it's milliseconds from 1970
          // that is: '2012' -> Jan. 1, 2012, but 2012 -> 2012 epoch milliseconds
          v = exports.ms2DateTimeLocal(+v);
          if(!v && dflt !== undefined) return dflt;
      } else if(!exports.isDateTime(v, calendar)) {
          Loggers.error('unrecognized date', v);
          return dflt;
      }
      return v;
  };
  
  /*
   *  Date formatting for ticks and hovertext
   */
  
  /*
   * modDateFormat: Support world calendars, and add one item to
   * d3's vocabulary:
   * %{n}f where n is the max number of digits of fractional seconds
   */
  var fracMatch = /%\d?f/g;
  function modDateFormat(fmt, x, formatter, calendar) {
      fmt = fmt.replace(fracMatch, function(match) {
          var digits = Math.min(+(match.charAt(1)) || 6, 6);
          var fracSecs = ((x / 1000 % 1) + 2)
              .toFixed(digits)
              .substr(2).replace(/0+$/, '') || '0';
          return fracSecs;
      });
  
      var d = new Date(Math.floor(x + 0.05));
  
      if(isWorldCalendar(calendar)) {
          try {
              fmt = Registry.getComponentMethod('calendars', 'worldCalFmt')(fmt, x, calendar);
          } catch(e) {
              return 'Invalid';
          }
      }
      return formatter(fmt)(d);
  }
  
  /*
   * formatTime: create a time string from:
   *   x: milliseconds
   *   tr: tickround ('M', 'S', or # digits)
   * only supports UTC times (where every day is 24 hours and 0 is at midnight)
   */
  var MAXSECONDS = [59, 59.9, 59.99, 59.999, 59.9999];
  function formatTime(x, tr) {
      var timePart = mod(x + 0.05, ONEDAY);
  
      var timeStr = lpad(Math.floor(timePart / ONEHOUR), 2) + ':' +
          lpad(mod(Math.floor(timePart / ONEMIN), 60), 2);
  
      if(tr !== 'M') {
          if(!isNumeric(tr)) tr = 0; // should only be 'S'
  
          /*
           * this is a weird one - and shouldn't come up unless people
           * monkey with tick0 in weird ways, but we need to do something!
           * IN PARTICULAR we had better not display garbage (see below)
           * for numbers we always round to the nearest increment of the
           * precision we're showing, and this seems like the right way to
           * handle seconds and milliseconds, as they have a decimal point
           * and people will interpret that to mean rounding like numbers.
           * but for larger increments we floor the value: it's always
           * 2013 until the ball drops on the new year. We could argue about
           * which field it is where we start rounding (should 12:08:59
           * round to 12:09 if we're stopping at minutes?) but for now I'll
           * say we round seconds but floor everything else. BUT that means
           * we need to never round up to 60 seconds, ie 23:59:60
           */
          var sec = Math.min(mod(x / ONESEC, 60), MAXSECONDS[tr]);
  
          var secStr = (100 + sec).toFixed(tr).substr(1);
          if(tr > 0) {
              secStr = secStr.replace(/0+$/, '').replace(/[\.]$/, '');
          }
  
          timeStr += ':' + secStr;
      }
      return timeStr;
  }
  
  /*
   * formatDate: turn a date into tick or hover label text.
   *
   *   x: milliseconds, the value to convert
   *   fmt: optional, an explicit format string (d3 format, even for world calendars)
   *   tr: tickround ('y', 'm', 'd', 'M', 'S', or # digits)
   *      used if no explicit fmt is provided
   *   formatter: locale-aware d3 date formatter for standard gregorian calendars
   *      should be the result of exports.getD3DateFormat(gd)
   *   calendar: optional string, the world calendar system to use
   *
   * returns the date/time as a string, potentially with the leading portion
   * on a separate line (after '\n')
   * Note that this means if you provide an explicit format which includes '\n'
   * the axis may choose to strip things after it when they don't change from
   * one tick to the next (as it does with automatic formatting)
   */
  exports.formatDate = function(x, fmt, tr, formatter, calendar, extraFormat) {
      calendar = isWorldCalendar(calendar) && calendar;
  
      if(!fmt) {
          if(tr === 'y') fmt = extraFormat.year;
          else if(tr === 'm') fmt = extraFormat.month;
          else if(tr === 'd') {
              fmt = extraFormat.dayMonth + '\n' + extraFormat.year;
          } else {
              return formatTime(x, tr) + '\n' + modDateFormat(extraFormat.dayMonthYear, x, formatter, calendar);
          }
      }
  
      return modDateFormat(fmt, x, formatter, calendar);
  };
  
  /*
   * incrementMonth: make a new milliseconds value from the given one,
   * having changed the month
   *
   * special case for world calendars: multiples of 12 are treated as years,
   * even for calendar systems that don't have (always or ever) 12 months/year
   * TODO: perhaps we need a different code for year increments to support this?
   *
   * ms (number): the initial millisecond value
   * dMonth (int): the (signed) number of months to shift
   * calendar (string): the calendar system to use
   *
   * changing month does not (and CANNOT) always preserve day, since
   * months have different lengths. The worst example of this is:
   *   d = new Date(1970,0,31); d.setMonth(1) -> Feb 31 turns into Mar 3
   *
   * But we want to be able to iterate over the last day of each month,
   * regardless of what its number is.
   * So shift 3 days forward, THEN set the new month, then unshift:
   *   1/31 -> 2/28 (or 29) -> 3/31 -> 4/30 -> ...
   *
   * Note that odd behavior still exists if you start from the 26th-28th:
   *   1/28 -> 2/28 -> 3/31
   * but at least you can't shift any dates into the wrong month,
   * and ticks on these days incrementing by month would be very unusual
   */
  var THREEDAYS = 3 * ONEDAY;
  exports.incrementMonth = function(ms, dMonth, calendar) {
      calendar = isWorldCalendar(calendar) && calendar;
  
      // pull time out and operate on pure dates, then add time back at the end
      // this gives maximum precision - not that we *normally* care if we're
      // incrementing by month, but better to be safe!
      var timeMs = mod(ms, ONEDAY);
      ms = Math.round(ms - timeMs);
  
      if(calendar) {
          try {
              var dateJD = Math.round(ms / ONEDAY) + EPOCHJD;
              var calInstance = Registry.getComponentMethod('calendars', 'getCal')(calendar);
              var cDate = calInstance.fromJD(dateJD);
  
              if(dMonth % 12) calInstance.add(cDate, dMonth, 'm');
              else calInstance.add(cDate, dMonth / 12, 'y');
  
              return (cDate.toJD() - EPOCHJD) * ONEDAY + timeMs;
          } catch(e) {
              Loggers.error('invalid ms ' + ms + ' in calendar ' + calendar);
              // then keep going in gregorian even though the result will be 'Invalid'
          }
      }
  
      var y = new Date(ms + THREEDAYS);
      return y.setUTCMonth(y.getUTCMonth() + dMonth) + timeMs - THREEDAYS;
  };
  
  /*
   * findExactDates: what fraction of data is exact days, months, or years?
   *
   * data: array of millisecond values
   * calendar (string) the calendar to test against
   */
  exports.findExactDates = function(data, calendar) {
      var exactYears = 0;
      var exactMonths = 0;
      var exactDays = 0;
      var blankCount = 0;
      var d;
      var di;
  
      var calInstance = (
          isWorldCalendar(calendar) &&
          Registry.getComponentMethod('calendars', 'getCal')(calendar)
      );
  
      for(var i = 0; i < data.length; i++) {
          di = data[i];
  
          // not date data at all
          if(!isNumeric(di)) {
              blankCount ++;
              continue;
          }
  
          // not an exact date
          if(di % ONEDAY) continue;
  
          if(calInstance) {
              try {
                  d = calInstance.fromJD(di / ONEDAY + EPOCHJD);
                  if(d.day() === 1) {
                      if(d.month() === 1) exactYears++;
                      else exactMonths++;
                  } else exactDays++;
              } catch(e) {
                  // invalid date in this calendar - ignore it here.
              }
          } else {
              d = new Date(di);
              if(d.getUTCDate() === 1) {
                  if(d.getUTCMonth() === 0) exactYears++;
                  else exactMonths++;
              } else exactDays++;
          }
      }
      exactMonths += exactYears;
      exactDays += exactMonths;
  
      var dataCount = data.length - blankCount;
  
      return {
          exactYears: exactYears / dataCount,
          exactMonths: exactMonths / dataCount,
          exactDays: exactDays / dataCount
      };
  };
  
  },{"../constants/numerical":725,"../registry":882,"./loggers":754,"./mod":757,"d3-time-format":166,"fast-isnumeric":241}],738:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var loggers = _dereq_('./loggers');
  
  /**
   * Allow referencing a graph DOM element either directly
   * or by its id string
   *
   * @param {HTMLDivElement|string} gd: a graph element or its id
   *
   * @returns {HTMLDivElement} the DOM element of the graph
   */
  function getGraphDiv(gd) {
      var gdElement;
  
      if(typeof gd === 'string') {
          gdElement = document.getElementById(gd);
  
          if(gdElement === null) {
              throw new Error('No DOM element with id \'' + gd + '\' exists on the page.');
          }
  
          return gdElement;
      } else if(gd === null || gd === undefined) {
          throw new Error('DOM element provided is null or undefined');
      }
  
      // otherwise assume that gd is a DOM element
      return gd;
  }
  
  function isPlotDiv(el) {
      var el3 = d3.select(el);
      return el3.node() instanceof HTMLElement &&
          el3.size() &&
          el3.classed('js-plotly-plot');
  }
  
  function removeElement(el) {
      var elParent = el && el.parentNode;
      if(elParent) elParent.removeChild(el);
  }
  
  /**
   * for dynamically adding style rules
   * makes one stylesheet that contains all rules added
   * by all calls to this function
   */
  function addStyleRule(selector, styleString) {
      addRelatedStyleRule('global', selector, styleString);
  }
  
  /**
   * for dynamically adding style rules
   * to a stylesheet uniquely identified by a uid
   */
  function addRelatedStyleRule(uid, selector, styleString) {
      var id = 'plotly.js-style-' + uid;
      var style = document.getElementById(id);
      if(!style) {
          style = document.createElement('style');
          style.setAttribute('id', id);
          // WebKit hack :(
          style.appendChild(document.createTextNode(''));
          document.head.appendChild(style);
      }
      var styleSheet = style.sheet;
  
      if(styleSheet.insertRule) {
          styleSheet.insertRule(selector + '{' + styleString + '}', 0);
      } else if(styleSheet.addRule) {
          styleSheet.addRule(selector, styleString, 0);
      } else loggers.warn('addStyleRule failed');
  }
  
  /**
   * to remove from the page a stylesheet identified by a given uid
   */
  function deleteRelatedStyleRule(uid) {
      var id = 'plotly.js-style-' + uid;
      var style = document.getElementById(id);
      if(style) removeElement(style);
  }
  
  module.exports = {
      getGraphDiv: getGraphDiv,
      isPlotDiv: isPlotDiv,
      removeElement: removeElement,
      addStyleRule: addStyleRule,
      addRelatedStyleRule: addRelatedStyleRule,
      deleteRelatedStyleRule: deleteRelatedStyleRule
  };
  
  },{"./loggers":754,"d3":169}],739:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  /* global jQuery:false */
  
  var EventEmitter = _dereq_('events').EventEmitter;
  
  var Events = {
  
      init: function(plotObj) {
          /*
           * If we have already instantiated an emitter for this plot
           * return early.
           */
          if(plotObj._ev instanceof EventEmitter) return plotObj;
  
          var ev = new EventEmitter();
          var internalEv = new EventEmitter();
  
          /*
           * Assign to plot._ev while we still live in a land
           * where plot is a DOM element with stuff attached to it.
           * In the future we can make plot the event emitter itself.
           */
          plotObj._ev = ev;
  
          /*
           * Create a second event handler that will manage events *internally*.
           * This allows parts of plotly to respond to thing like relayout without
           * having to use the user-facing event handler. They cannot peacefully
           * coexist on the same handler because a user invoking
           * plotObj.removeAllListeners() would detach internal events, breaking
           * plotly.
           */
          plotObj._internalEv = internalEv;
  
          /*
           * Assign bound methods from the ev to the plot object. These methods
           * will reference the 'this' of plot._ev even though they are methods
           * of plot. This will keep the event machinery away from the plot object
           * which currently is often a DOM element but presents an API that will
           * continue to function when plot becomes an emitter. Not all EventEmitter
           * methods have been bound to `plot` as some do not currently add value to
           * the Plotly event API.
           */
          plotObj.on = ev.on.bind(ev);
          plotObj.once = ev.once.bind(ev);
          plotObj.removeListener = ev.removeListener.bind(ev);
          plotObj.removeAllListeners = ev.removeAllListeners.bind(ev);
  
          /*
           * Create functions for managing internal events. These are *only* triggered
           * by the mirroring of external events via the emit function.
           */
          plotObj._internalOn = internalEv.on.bind(internalEv);
          plotObj._internalOnce = internalEv.once.bind(internalEv);
          plotObj._removeInternalListener = internalEv.removeListener.bind(internalEv);
          plotObj._removeAllInternalListeners = internalEv.removeAllListeners.bind(internalEv);
  
          /*
           * We must wrap emit to continue to support JQuery events. The idea
           * is to check to see if the user is using JQuery events, if they are
           * we emit JQuery events to trigger user handlers as well as the EventEmitter
           * events.
           */
          plotObj.emit = function(event, data) {
              if(typeof jQuery !== 'undefined') {
                  jQuery(plotObj).trigger(event, data);
              }
  
              ev.emit(event, data);
              internalEv.emit(event, data);
          };
  
          return plotObj;
      },
  
      /*
       * This function behaves like jQuery's triggerHandler. It calls
       * all handlers for a particular event and returns the return value
       * of the LAST handler. This function also triggers jQuery's
       * triggerHandler for backwards compatibility.
       */
      triggerHandler: function(plotObj, event, data) {
          var jQueryHandlerValue;
          var nodeEventHandlerValue;
  
          /*
           * If jQuery exists run all its handlers for this event and
           * collect the return value of the LAST handler function
           */
          if(typeof jQuery !== 'undefined') {
              jQueryHandlerValue = jQuery(plotObj).triggerHandler(event, data);
          }
  
          /*
           * Now run all the node style event handlers
           */
          var ev = plotObj._ev;
          if(!ev) return jQueryHandlerValue;
  
          var handlers = ev._events[event];
          if(!handlers) return jQueryHandlerValue;
  
          // making sure 'this' is the EventEmitter instance
          function apply(handler) {
              // The 'once' case, we can't just call handler() as we need
              // the return value here. So,
              // - remove handler
              // - call listener and grab return value!
              // - stash 'fired' key to not call handler twice
              if(handler.listener) {
                  ev.removeListener(event, handler.listener);
                  if(!handler.fired) {
                      handler.fired = true;
                      return handler.listener.apply(ev, [data]);
                  }
              } else {
                  return handler.apply(ev, [data]);
              }
          }
  
          // handlers can be function or an array of functions
          handlers = Array.isArray(handlers) ? handlers : [handlers];
  
          var i;
          for(i = 0; i < handlers.length - 1; i++) {
              apply(handlers[i]);
          }
          // now call the final handler and collect its value
          nodeEventHandlerValue = apply(handlers[i]);
  
          /*
           * Return either the jQuery handler value if it exists or the
           * nodeEventHandler value. jQuery event value supersedes nodejs
           * events for backwards compatibility reasons.
           */
          return jQueryHandlerValue !== undefined ?
              jQueryHandlerValue :
              nodeEventHandlerValue;
      },
  
      purge: function(plotObj) {
          delete plotObj._ev;
          delete plotObj.on;
          delete plotObj.once;
          delete plotObj.removeListener;
          delete plotObj.removeAllListeners;
          delete plotObj.emit;
  
          delete plotObj._ev;
          delete plotObj._internalEv;
          delete plotObj._internalOn;
          delete plotObj._internalOnce;
          delete plotObj._removeInternalListener;
          delete plotObj._removeAllInternalListeners;
  
          return plotObj;
      }
  
  };
  
  module.exports = Events;
  
  },{"events":110}],740:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isPlainObject = _dereq_('./is_plain_object.js');
  var isArray = Array.isArray;
  
  function primitivesLoopSplice(source, target) {
      var i, value;
      for(i = 0; i < source.length; i++) {
          value = source[i];
          if(value !== null && typeof(value) === 'object') {
              return false;
          }
          if(value !== void(0)) {
              target[i] = value;
          }
      }
      return true;
  }
  
  exports.extendFlat = function() {
      return _extend(arguments, false, false, false);
  };
  
  exports.extendDeep = function() {
      return _extend(arguments, true, false, false);
  };
  
  exports.extendDeepAll = function() {
      return _extend(arguments, true, true, false);
  };
  
  exports.extendDeepNoArrays = function() {
      return _extend(arguments, true, false, true);
  };
  
  /*
   * Inspired by https://github.com/justmoon/node-extend/blob/master/index.js
   * All credit to the jQuery authors for perfecting this amazing utility.
   *
   * API difference with jQuery version:
   * - No optional boolean (true -> deep extend) first argument,
   *   use `extendFlat` for first-level only extend and
   *   use `extendDeep` for a deep extend.
   *
   * Other differences with jQuery version:
   * - Uses a modern (and faster) isPlainObject routine.
   * - Expected to work with object {} and array [] arguments only.
   * - Does not check for circular structure.
   *   FYI: jQuery only does a check across one level.
   *   Warning: this might result in infinite loops.
   *
   */
  function _extend(inputs, isDeep, keepAllKeys, noArrayCopies) {
      var target = inputs[0];
      var length = inputs.length;
  
      var input, key, src, copy, copyIsArray, clone, allPrimitives;
  
      // TODO does this do the right thing for typed arrays?
  
      if(length === 2 && isArray(target) && isArray(inputs[1]) && target.length === 0) {
          allPrimitives = primitivesLoopSplice(inputs[1], target);
  
          if(allPrimitives) {
              return target;
          } else {
              target.splice(0, target.length); // reset target and continue to next block
          }
      }
  
      for(var i = 1; i < length; i++) {
          input = inputs[i];
  
          for(key in input) {
              src = target[key];
              copy = input[key];
  
              if(noArrayCopies && isArray(copy)) {
                  // Stop early and just transfer the array if array copies are disallowed:
  
                  target[key] = copy;
              } else if(isDeep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
                  // recurse if we're merging plain objects or arrays
  
                  if(copyIsArray) {
                      copyIsArray = false;
                      clone = src && isArray(src) ? src : [];
                  } else {
                      clone = src && isPlainObject(src) ? src : {};
                  }
  
                  // never move original objects, clone them
                  target[key] = _extend([clone, copy], isDeep, keepAllKeys, noArrayCopies);
              } else if(typeof copy !== 'undefined' || keepAllKeys) {
                  // don't bring in undefined values, except for extendDeepAll
  
                  target[key] = copy;
              }
          }
      }
  
      return target;
  }
  
  },{"./is_plain_object.js":751}],741:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  /**
   * Return news array containing only the unique items
   * found in input array.
   *
   * IMPORTANT: Note that items are considered unique
   * if `String({})` is unique. For example;
   *
   *  Lib.filterUnique([ { a: 1 }, { b: 2 } ])
   *
   *  returns [{ a: 1 }]
   *
   * and
   *
   *  Lib.filterUnique([ '1', 1 ])
   *
   *  returns ['1']
   *
   *
   * @param {array} array base array
   * @return {array} new filtered array
   */
  module.exports = function filterUnique(array) {
      var seen = {};
      var out = [];
      var j = 0;
  
      for(var i = 0; i < array.length; i++) {
          var item = array[i];
  
          if(seen[item] !== 1) {
              seen[item] = 1;
              out[j++] = item;
          }
      }
  
      return out;
  };
  
  },{}],742:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /** Filter out object items with visible !== true
   *  insider array container.
   *
   *  @param {array of objects} container
   *  @return {array of objects} of length <= container
   *
   */
  module.exports = function filterVisible(container) {
      var filterFn = isCalcData(container) ? calcDataFilter : baseFilter;
      var out = [];
  
      for(var i = 0; i < container.length; i++) {
          var item = container[i];
          if(filterFn(item)) out.push(item);
      }
  
      return out;
  };
  
  function baseFilter(item) {
      return item.visible === true;
  }
  
  function calcDataFilter(item) {
      var trace = item[0].trace;
      return trace.visible === true && trace._length !== 0;
  }
  
  function isCalcData(cont) {
      return (
          Array.isArray(cont) &&
          Array.isArray(cont[0]) &&
          cont[0][0] &&
          cont[0][0].trace
      );
  }
  
  },{}],743:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var countryRegex = _dereq_('country-regex');
  var turfArea = _dereq_('@turf/area');
  var turfCentroid = _dereq_('@turf/centroid');
  var turfBbox = _dereq_('@turf/bbox');
  
  var identity = _dereq_('./identity');
  var loggers = _dereq_('./loggers');
  var isPlainObject = _dereq_('./is_plain_object');
  var nestedProperty = _dereq_('./nested_property');
  var polygon = _dereq_('./polygon');
  
  // make list of all country iso3 ids from at runtime
  var countryIds = Object.keys(countryRegex);
  
  var locationmodeToIdFinder = {
      'ISO-3': identity,
      'USA-states': identity,
      'country names': countryNameToISO3
  };
  
  function countryNameToISO3(countryName) {
      for(var i = 0; i < countryIds.length; i++) {
          var iso3 = countryIds[i];
          var regex = new RegExp(countryRegex[iso3]);
  
          if(regex.test(countryName.trim().toLowerCase())) return iso3;
      }
  
      loggers.log('Unrecognized country name: ' + countryName + '.');
  
      return false;
  }
  
  function locationToFeature(locationmode, location, features) {
      if(!location || typeof location !== 'string') return false;
  
      var locationId = locationmodeToIdFinder[locationmode](location);
      var filteredFeatures;
      var f, i;
  
      if(locationId) {
          if(locationmode === 'USA-states') {
              // Filter out features out in USA
              //
              // This is important as the Natural Earth files
              // include state/provinces from USA, Canada, Australia and Brazil
              // which have some overlay in their two-letter ids. For example,
              // 'WA' is used for both Washington state and Western Australia.
              filteredFeatures = [];
              for(i = 0; i < features.length; i++) {
                  f = features[i];
                  if(f.properties && f.properties.gu && f.properties.gu === 'USA') {
                      filteredFeatures.push(f);
                  }
              }
          } else {
              filteredFeatures = features;
          }
  
          for(i = 0; i < filteredFeatures.length; i++) {
              f = filteredFeatures[i];
              if(f.id === locationId) return f;
          }
  
          loggers.log([
              'Location with id', locationId,
              'does not have a matching topojson feature at this resolution.'
          ].join(' '));
      }
  
      return false;
  }
  
  function feature2polygons(feature) {
      var geometry = feature.geometry;
      var coords = geometry.coordinates;
      var loc = feature.id;
  
      var polygons = [];
      var appendPolygon, j, k, m;
  
      function doesCrossAntiMerdian(pts) {
          for(var l = 0; l < pts.length - 1; l++) {
              if(pts[l][0] > 0 && pts[l + 1][0] < 0) return l;
          }
          return null;
      }
  
      if(loc === 'RUS' || loc === 'FJI') {
          // Russia and Fiji have landmasses that cross the antimeridian,
          // we need to add +360 to their longitude coordinates, so that
          // polygon 'contains' doesn't get confused when crossing the antimeridian.
          //
          // Note that other countries have polygons on either side of the antimeridian
          // (e.g. some Aleutian island for the USA), but those don't confuse
          // the 'contains' method; these are skipped here.
          appendPolygon = function(_pts) {
              var pts;
  
              if(doesCrossAntiMerdian(_pts) === null) {
                  pts = _pts;
              } else {
                  pts = new Array(_pts.length);
                  for(m = 0; m < _pts.length; m++) {
                      // do not mutate calcdata[i][j].geojson !!
                      pts[m] = [
                          _pts[m][0] < 0 ? _pts[m][0] + 360 : _pts[m][0],
                          _pts[m][1]
                      ];
                  }
              }
  
              polygons.push(polygon.tester(pts));
          };
      } else if(loc === 'ATA') {
          // Antarctica has a landmass that wraps around every longitudes which
          // confuses the 'contains' methods.
          appendPolygon = function(pts) {
              var crossAntiMeridianIndex = doesCrossAntiMerdian(pts);
  
              // polygon that do not cross anti-meridian need no special handling
              if(crossAntiMeridianIndex === null) {
                  return polygons.push(polygon.tester(pts));
              }
  
              // stitch polygon by adding pt over South Pole,
              // so that it covers the projected region covers all latitudes
              //
              // Note that the algorithm below only works for polygons that
              // start and end on longitude -180 (like the ones built by
              // https://github.com/etpinard/sane-topojson).
              var stitch = new Array(pts.length + 1);
              var si = 0;
  
              for(m = 0; m < pts.length; m++) {
                  if(m > crossAntiMeridianIndex) {
                      stitch[si++] = [pts[m][0] + 360, pts[m][1]];
                  } else if(m === crossAntiMeridianIndex) {
                      stitch[si++] = pts[m];
                      stitch[si++] = [pts[m][0], -90];
                  } else {
                      stitch[si++] = pts[m];
                  }
              }
  
              // polygon.tester by default appends pt[0] to the points list,
              // we must remove it here, to avoid a jump in longitude from 180 to -180,
              // that would confuse the 'contains' method
              var tester = polygon.tester(stitch);
              tester.pts.pop();
              polygons.push(tester);
          };
      } else {
          // otherwise using same array ref is fine
          appendPolygon = function(pts) {
              polygons.push(polygon.tester(pts));
          };
      }
  
      switch(geometry.type) {
          case 'MultiPolygon':
              for(j = 0; j < coords.length; j++) {
                  for(k = 0; k < coords[j].length; k++) {
                      appendPolygon(coords[j][k]);
                  }
              }
              break;
          case 'Polygon':
              for(j = 0; j < coords.length; j++) {
                  appendPolygon(coords[j]);
              }
              break;
      }
  
      return polygons;
  }
  
  function getTraceGeojson(trace) {
      var g = trace.geojson;
      var PlotlyGeoAssets = window.PlotlyGeoAssets || {};
      var geojsonIn = typeof g === 'string' ? PlotlyGeoAssets[g] : g;
  
      // This should not happen, but just in case something goes
      // really wrong when fetching the GeoJSON
      if(!isPlainObject(geojsonIn)) {
          loggers.error('Oops ... something went wrong when fetching ' + g);
          return false;
      }
  
      return geojsonIn;
  }
  
  function extractTraceFeature(calcTrace) {
      var trace = calcTrace[0].trace;
  
      var geojsonIn = getTraceGeojson(trace);
      if(!geojsonIn) return false;
  
      var lookup = {};
      var featuresOut = [];
      var i;
  
      for(i = 0; i < trace._length; i++) {
          var cdi = calcTrace[i];
          if(cdi.loc || cdi.loc === 0) {
              lookup[cdi.loc] = cdi;
          }
      }
  
      function appendFeature(fIn) {
          var id = nestedProperty(fIn, trace.featureidkey || 'id').get();
          var cdi = lookup[id];
  
          if(cdi) {
              var geometry = fIn.geometry;
  
              if(geometry.type === 'Polygon' || geometry.type === 'MultiPolygon') {
                  var fOut = {
                      type: 'Feature',
                      id: id,
                      geometry: geometry,
                      properties: {}
                  };
  
                  // Compute centroid, add it to the properties
                  fOut.properties.ct = findCentroid(fOut);
  
                  // Mutate in in/out features into calcdata
                  cdi.fIn = fIn;
                  cdi.fOut = fOut;
  
                  featuresOut.push(fOut);
              } else {
                  loggers.log([
                      'Location', cdi.loc, 'does not have a valid GeoJSON geometry.',
                      'Traces with locationmode *geojson-id* only support',
                      '*Polygon* and *MultiPolygon* geometries.'
                  ].join(' '));
              }
          }
  
          // remove key from lookup, so that we can track (if any)
          // the locations that did not have a corresponding GeoJSON feature
          delete lookup[id];
      }
  
      switch(geojsonIn.type) {
          case 'FeatureCollection':
              var featuresIn = geojsonIn.features;
              for(i = 0; i < featuresIn.length; i++) {
                  appendFeature(featuresIn[i]);
              }
              break;
          case 'Feature':
              appendFeature(geojsonIn);
              break;
          default:
              loggers.warn([
                  'Invalid GeoJSON type', (geojsonIn.type || 'none') + '.',
                  'Traces with locationmode *geojson-id* only support',
                  '*FeatureCollection* and *Feature* types.'
              ].join(' '));
              return false;
      }
  
      for(var loc in lookup) {
          loggers.log([
              'Location *' + loc + '*',
              'does not have a matching feature with id-key',
              '*' + trace.featureidkey + '*.'
          ].join(' '));
      }
  
      return featuresOut;
  }
  
  // TODO this find the centroid of the polygon of maxArea
  // (just like we currently do for geo choropleth polygons),
  // maybe instead it would make more sense to compute the centroid
  // of each polygon and consider those on hover/select
  function findCentroid(feature) {
      var geometry = feature.geometry;
      var poly;
  
      if(geometry.type === 'MultiPolygon') {
          var coords = geometry.coordinates;
          var maxArea = 0;
  
          for(var i = 0; i < coords.length; i++) {
              var polyi = {type: 'Polygon', coordinates: coords[i]};
              var area = turfArea.default(polyi);
              if(area > maxArea) {
                  maxArea = area;
                  poly = polyi;
              }
          }
      } else {
          poly = geometry;
      }
  
      return turfCentroid.default(poly).geometry.coordinates;
  }
  
  function fetchTraceGeoData(calcData) {
      var PlotlyGeoAssets = window.PlotlyGeoAssets || {};
      var promises = [];
  
      function fetch(url) {
          return new Promise(function(resolve, reject) {
              d3.json(url, function(err, d) {
                  if(err) {
                      delete PlotlyGeoAssets[url];
                      var msg = err.status === 404 ?
                          ('GeoJSON at URL "' + url + '" does not exist.') :
                          ('Unexpected error while fetching from ' + url);
                      return reject(new Error(msg));
                  }
  
                  PlotlyGeoAssets[url] = d;
                  return resolve(d);
              });
          });
      }
  
      function wait(url) {
          return new Promise(function(resolve, reject) {
              var cnt = 0;
              var interval = setInterval(function() {
                  if(PlotlyGeoAssets[url] && PlotlyGeoAssets[url] !== 'pending') {
                      clearInterval(interval);
                      return resolve(PlotlyGeoAssets[url]);
                  }
                  if(cnt > 100) {
                      clearInterval(interval);
                      return reject('Unexpected error while fetching from ' + url);
                  }
                  cnt++;
              }, 50);
          });
      }
  
      for(var i = 0; i < calcData.length; i++) {
          var trace = calcData[i][0].trace;
          var url = trace.geojson;
  
          if(typeof url === 'string') {
              if(!PlotlyGeoAssets[url]) {
                  PlotlyGeoAssets[url] = 'pending';
                  promises.push(fetch(url));
              } else if(PlotlyGeoAssets[url] === 'pending') {
                  promises.push(wait(url));
              }
          }
      }
  
      return promises;
  }
  
  // TODO `turf/bbox` gives wrong result when the input feature/geometry
  // crosses the anti-meridian. We should try to implement our own bbox logic.
  function computeBbox(d) {
      return turfBbox.default(d);
  }
  
  module.exports = {
      locationToFeature: locationToFeature,
      feature2polygons: feature2polygons,
      getTraceGeojson: getTraceGeojson,
      extractTraceFeature: extractTraceFeature,
      fetchTraceGeoData: fetchTraceGeoData,
      computeBbox: computeBbox
  };
  
  },{"./identity":748,"./is_plain_object":751,"./loggers":754,"./nested_property":758,"./polygon":762,"@turf/area":59,"@turf/bbox":60,"@turf/centroid":61,"country-regex":139,"d3":169}],744:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var BADNUM = _dereq_('../constants/numerical').BADNUM;
  
  /**
   * Convert calcTrace to GeoJSON 'MultiLineString' coordinate arrays
   *
   * @param {object} calcTrace
   *  gd.calcdata item.
   *  Note that calcTrace[i].lonlat is assumed to be defined
   *
   * @return {array}
   *  return line coords array (or array of arrays)
   *
   */
  exports.calcTraceToLineCoords = function(calcTrace) {
      var trace = calcTrace[0].trace;
      var connectgaps = trace.connectgaps;
  
      var coords = [];
      var lineString = [];
  
      for(var i = 0; i < calcTrace.length; i++) {
          var calcPt = calcTrace[i];
          var lonlat = calcPt.lonlat;
  
          if(lonlat[0] !== BADNUM) {
              lineString.push(lonlat);
          } else if(!connectgaps && lineString.length > 0) {
              coords.push(lineString);
              lineString = [];
          }
      }
  
      if(lineString.length > 0) {
          coords.push(lineString);
      }
  
      return coords;
  };
  
  
  /**
   * Make line ('LineString' or 'MultiLineString') GeoJSON
   *
   * @param {array} coords
   *  results form calcTraceToLineCoords
   * @return {object} out
   *  GeoJSON object
   *
   */
  exports.makeLine = function(coords) {
      if(coords.length === 1) {
          return {
              type: 'LineString',
              coordinates: coords[0]
          };
      } else {
          return {
              type: 'MultiLineString',
              coordinates: coords
          };
      }
  };
  
  /**
   * Make polygon ('Polygon' or 'MultiPolygon') GeoJSON
   *
   * @param {array} coords
   *  results form calcTraceToLineCoords
   * @return {object} out
   *  GeoJSON object
   */
  exports.makePolygon = function(coords) {
      if(coords.length === 1) {
          return {
              type: 'Polygon',
              coordinates: coords
          };
      } else {
          var _coords = new Array(coords.length);
  
          for(var i = 0; i < coords.length; i++) {
              _coords[i] = [coords[i]];
          }
  
          return {
              type: 'MultiPolygon',
              coordinates: _coords
          };
      }
  };
  
  /**
   * Make blank GeoJSON
   *
   * @return {object}
   *  Blank GeoJSON object
   *
   */
  exports.makeBlank = function() {
      return {
          type: 'Point',
          coordinates: []
      };
  };
  
  },{"../constants/numerical":725}],745:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var mod = _dereq_('./mod').mod;
  
  /*
   * look for intersection of two line segments
   *   (1->2 and 3->4) - returns array [x,y] if they do, null if not
   */
  exports.segmentsIntersect = segmentsIntersect;
  function segmentsIntersect(x1, y1, x2, y2, x3, y3, x4, y4) {
      var a = x2 - x1;
      var b = x3 - x1;
      var c = x4 - x3;
      var d = y2 - y1;
      var e = y3 - y1;
      var f = y4 - y3;
      var det = a * f - c * d;
      // parallel lines? intersection is undefined
      // ignore the case where they are colinear
      if(det === 0) return null;
      var t = (b * f - c * e) / det;
      var u = (b * d - a * e) / det;
      // segments do not intersect?
      if(u < 0 || u > 1 || t < 0 || t > 1) return null;
  
      return {x: x1 + a * t, y: y1 + d * t};
  }
  
  /*
   * find the minimum distance between two line segments (1->2 and 3->4)
   */
  exports.segmentDistance = function segmentDistance(x1, y1, x2, y2, x3, y3, x4, y4) {
      if(segmentsIntersect(x1, y1, x2, y2, x3, y3, x4, y4)) return 0;
  
      // the two segments and their lengths squared
      var x12 = x2 - x1;
      var y12 = y2 - y1;
      var x34 = x4 - x3;
      var y34 = y4 - y3;
      var ll12 = x12 * x12 + y12 * y12;
      var ll34 = x34 * x34 + y34 * y34;
  
      // calculate distance squared, then take the sqrt at the very end
      var dist2 = Math.min(
          perpDistance2(x12, y12, ll12, x3 - x1, y3 - y1),
          perpDistance2(x12, y12, ll12, x4 - x1, y4 - y1),
          perpDistance2(x34, y34, ll34, x1 - x3, y1 - y3),
          perpDistance2(x34, y34, ll34, x2 - x3, y2 - y3)
      );
  
      return Math.sqrt(dist2);
  };
  
  /*
   * distance squared from segment ab to point c
   * [xab, yab] is the vector b-a
   * [xac, yac] is the vector c-a
   * llab is the length squared of (b-a), just to simplify calculation
   */
  function perpDistance2(xab, yab, llab, xac, yac) {
      var fcAB = (xac * xab + yac * yab);
      if(fcAB < 0) {
          // point c is closer to point a
          return xac * xac + yac * yac;
      } else if(fcAB > llab) {
          // point c is closer to point b
          var xbc = xac - xab;
          var ybc = yac - yab;
          return xbc * xbc + ybc * ybc;
      } else {
          // perpendicular distance is the shortest
          var crossProduct = xac * yab - yac * xab;
          return crossProduct * crossProduct / llab;
      }
  }
  
  // a very short-term cache for getTextLocation, just because
  // we're often looping over the same locations multiple times
  // invalidated as soon as we look at a different path
  var locationCache, workingPath, workingTextWidth;
  
  // turn a path and position along it into x, y, and angle for the given text
  exports.getTextLocation = function getTextLocation(path, totalPathLen, positionOnPath, textWidth) {
      if(path !== workingPath || textWidth !== workingTextWidth) {
          locationCache = {};
          workingPath = path;
          workingTextWidth = textWidth;
      }
      if(locationCache[positionOnPath]) {
          return locationCache[positionOnPath];
      }
  
      // for the angle, use points on the path separated by the text width
      // even though due to curvature, the text will cover a bit more than that
      var p0 = path.getPointAtLength(mod(positionOnPath - textWidth / 2, totalPathLen));
      var p1 = path.getPointAtLength(mod(positionOnPath + textWidth / 2, totalPathLen));
      // note: atan handles 1/0 nicely
      var theta = Math.atan((p1.y - p0.y) / (p1.x - p0.x));
      // center the text at 2/3 of the center position plus 1/3 the p0/p1 midpoint
      // that's the average position of this segment, assuming it's roughly quadratic
      var pCenter = path.getPointAtLength(mod(positionOnPath, totalPathLen));
      var x = (pCenter.x * 4 + p0.x + p1.x) / 6;
      var y = (pCenter.y * 4 + p0.y + p1.y) / 6;
  
      var out = {x: x, y: y, theta: theta};
      locationCache[positionOnPath] = out;
      return out;
  };
  
  exports.clearLocationCache = function() {
      workingPath = null;
  };
  
  /*
   * Find the segment of `path` that's within the visible area
   * given by `bounds` {left, right, top, bottom}, to within a
   * precision of `buffer` px
   *
   * returns: undefined if nothing is visible, else object:
   * {
   *   min: position where the path first enters bounds, or 0 if it
   *        starts within bounds
   *   max: position where the path last exits bounds, or the path length
   *        if it finishes within bounds
   *   len: max - min, ie the length of visible path
   *   total: the total path length - just included so the caller doesn't
   *        need to call path.getTotalLength() again
   *   isClosed: true iff the start and end points of the path are both visible
   *        and are at the same point
   * }
   *
   * Works by starting from either end and repeatedly finding the distance from
   * that point to the plot area, and if it's outside the plot, moving along the
   * path by that distance (because the plot must be at least that far away on
   * the path). Note that if a path enters, exits, and re-enters the plot, we
   * will not capture this behavior.
   */
  exports.getVisibleSegment = function getVisibleSegment(path, bounds, buffer) {
      var left = bounds.left;
      var right = bounds.right;
      var top = bounds.top;
      var bottom = bounds.bottom;
  
      var pMin = 0;
      var pTotal = path.getTotalLength();
      var pMax = pTotal;
  
      var pt0, ptTotal;
  
      function getDistToPlot(len) {
          var pt = path.getPointAtLength(len);
  
          // hold on to the start and end points for `closed`
          if(len === 0) pt0 = pt;
          else if(len === pTotal) ptTotal = pt;
  
          var dx = (pt.x < left) ? left - pt.x : (pt.x > right ? pt.x - right : 0);
          var dy = (pt.y < top) ? top - pt.y : (pt.y > bottom ? pt.y - bottom : 0);
          return Math.sqrt(dx * dx + dy * dy);
      }
  
      var distToPlot = getDistToPlot(pMin);
      while(distToPlot) {
          pMin += distToPlot + buffer;
          if(pMin > pMax) return;
          distToPlot = getDistToPlot(pMin);
      }
  
      distToPlot = getDistToPlot(pMax);
      while(distToPlot) {
          pMax -= distToPlot + buffer;
          if(pMin > pMax) return;
          distToPlot = getDistToPlot(pMax);
      }
  
      return {
          min: pMin,
          max: pMax,
          len: pMax - pMin,
          total: pTotal,
          isClosed: pMin === 0 && pMax === pTotal &&
              Math.abs(pt0.x - ptTotal.x) < 0.1 &&
              Math.abs(pt0.y - ptTotal.y) < 0.1
      };
  };
  
  /**
   * Find point on SVG path corresponding to a given constraint coordinate
   *
   * @param {SVGPathElement} path
   * @param {Number} val : constraint coordinate value
   * @param {String} coord : 'x' or 'y' the constraint coordinate
   * @param {Object} opts :
   *  - {Number} pathLength : supply total path length before hand
   *  - {Number} tolerance
   *  - {Number} iterationLimit
   * @return {SVGPoint}
   */
  exports.findPointOnPath = function findPointOnPath(path, val, coord, opts) {
      opts = opts || {};
  
      var pathLength = opts.pathLength || path.getTotalLength();
      var tolerance = opts.tolerance || 1e-3;
      var iterationLimit = opts.iterationLimit || 30;
  
      // if path starts at a val greater than the path tail (like on vertical violins),
      // we must flip the sign of the computed diff.
      var mul = path.getPointAtLength(0)[coord] > path.getPointAtLength(pathLength)[coord] ? -1 : 1;
  
      var i = 0;
      var b0 = 0;
      var b1 = pathLength;
      var mid;
      var pt;
      var diff;
  
      while(i < iterationLimit) {
          mid = (b0 + b1) / 2;
          pt = path.getPointAtLength(mid);
          diff = pt[coord] - val;
  
          if(Math.abs(diff) < tolerance) {
              return pt;
          } else {
              if(mul * diff > 0) {
                  b1 = mid;
              } else {
                  b0 = mid;
              }
              i++;
          }
      }
      return pt;
  };
  
  },{"./mod":757}],746:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var tinycolor = _dereq_('tinycolor2');
  var rgba = _dereq_('color-normalize');
  
  var Colorscale = _dereq_('../components/colorscale');
  var colorDflt = _dereq_('../components/color/attributes').defaultLine;
  var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
  
  var colorDfltRgba = rgba(colorDflt);
  var opacityDflt = 1;
  
  function calculateColor(colorIn, opacityIn) {
      var colorOut = colorIn;
      colorOut[3] *= opacityIn;
      return colorOut;
  }
  
  function validateColor(colorIn) {
      if(isNumeric(colorIn)) return colorDfltRgba;
  
      var colorOut = rgba(colorIn);
  
      return colorOut.length ? colorOut : colorDfltRgba;
  }
  
  function validateOpacity(opacityIn) {
      return isNumeric(opacityIn) ? opacityIn : opacityDflt;
  }
  
  function formatColor(containerIn, opacityIn, len) {
      var colorIn = containerIn.color;
      var isArrayColorIn = isArrayOrTypedArray(colorIn);
      var isArrayOpacityIn = isArrayOrTypedArray(opacityIn);
      var cOpts = Colorscale.extractOpts(containerIn);
      var colorOut = [];
  
      var sclFunc, getColor, getOpacity, colori, opacityi;
  
      if(cOpts.colorscale !== undefined) {
          sclFunc = Colorscale.makeColorScaleFuncFromTrace(containerIn);
      } else {
          sclFunc = validateColor;
      }
  
      if(isArrayColorIn) {
          getColor = function(c, i) {
              // FIXME: there is double work, considering that sclFunc does the opposite
              return c[i] === undefined ? colorDfltRgba : rgba(sclFunc(c[i]));
          };
      } else getColor = validateColor;
  
      if(isArrayOpacityIn) {
          getOpacity = function(o, i) {
              return o[i] === undefined ? opacityDflt : validateOpacity(o[i]);
          };
      } else getOpacity = validateOpacity;
  
      if(isArrayColorIn || isArrayOpacityIn) {
          for(var i = 0; i < len; i++) {
              colori = getColor(colorIn, i);
              opacityi = getOpacity(opacityIn, i);
              colorOut[i] = calculateColor(colori, opacityi);
          }
      } else colorOut = calculateColor(rgba(colorIn), opacityIn);
  
      return colorOut;
  }
  
  function parseColorScale(cont) {
      var cOpts = Colorscale.extractOpts(cont);
  
      var colorscale = cOpts.colorscale;
      if(cOpts.reversescale) colorscale = Colorscale.flipScale(cOpts.colorscale);
  
      return colorscale.map(function(elem) {
          var index = elem[0];
          var color = tinycolor(elem[1]);
          var rgb = color.toRgb();
          return {
              index: index,
              rgb: [rgb.r, rgb.g, rgb.b, rgb.a]
          };
      });
  }
  
  module.exports = {
      formatColor: formatColor,
      parseColorScale: parseColorScale
  };
  
  },{"../components/color/attributes":614,"../components/colorscale":627,"./array":732,"color-normalize":125,"fast-isnumeric":241,"tinycolor2":548}],747:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var identity = _dereq_('./identity');
  
  function wrap(d) {return [d];}
  
  module.exports = {
  
      // The D3 data binding concept and the General Update Pattern promotes the idea of
      // traversing into the scenegraph by using the `.data(fun, keyFun)` call.
      // The `fun` is most often a `repeat`, ie. the elements beneath a `<g>` element need
      // access to the same data, or a `descend`, which fans a scenegraph node into a bunch of
      // of elements, e.g. points, lines, rows, requiring an array as input.
      // The role of the `keyFun` is to identify what elements are being entered/exited/updated,
      // otherwise D3 reverts to using a plain index which would screw up `transition`s.
      keyFun: function(d) {return d.key;},
      repeat: wrap,
      descend: identity,
  
      // Plotly.js uses a convention of storing the actual contents of the `calcData` as the
      // element zero of a container array. These helpers are just used for clarity as a
      // newcomer to the codebase may not know what the `[0]` is, and whether there can be further
      // elements (not atm).
      wrap: wrap,
      unwrap: function(d) {return d[0];}
  };
  
  },{"./identity":748}],748:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  // Simple helper functions
  // none of these need any external deps
  
  module.exports = function identity(d) { return d; };
  
  },{}],749:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = function incrementNumeric(x, delta) {
      if(!delta) return x;
  
      // Note 1:
      // 0.3 != 0.1 + 0.2 == 0.30000000000000004
      // but 0.3 == (10 * 0.1 + 10 * 0.2) / 10
      // Attempt to use integer steps to increment
      var scale = 1 / Math.abs(delta);
      var newX = (scale > 1) ? (
          scale * x +
          scale * delta
      ) / scale : x + delta;
  
      // Note 2:
      // now we may also consider rounding to cover few more edge cases
      // e.g. 0.3 * 3 = 0.8999999999999999
      var lenX1 = String(newX).length;
      if(lenX1 > 16) {
          var lenDt = String(delta).length;
          var lenX0 = String(x).length;
  
          if(lenX1 >= lenX0 + lenDt) { // likely a rounding error!
              var s = parseFloat(newX).toPrecision(12);
              if(s.indexOf('e+') === -1) newX = +s;
          }
      }
  
      return newX;
  };
  
  },{}],750:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var utcFormat = _dereq_('d3-time-format').utcFormat;
  var isNumeric = _dereq_('fast-isnumeric');
  
  var numConstants = _dereq_('../constants/numerical');
  var FP_SAFE = numConstants.FP_SAFE;
  var BADNUM = numConstants.BADNUM;
  
  var lib = module.exports = {};
  
  lib.nestedProperty = _dereq_('./nested_property');
  lib.keyedContainer = _dereq_('./keyed_container');
  lib.relativeAttr = _dereq_('./relative_attr');
  lib.isPlainObject = _dereq_('./is_plain_object');
  lib.toLogRange = _dereq_('./to_log_range');
  lib.relinkPrivateKeys = _dereq_('./relink_private');
  
  var arrayModule = _dereq_('./array');
  lib.isTypedArray = arrayModule.isTypedArray;
  lib.isArrayOrTypedArray = arrayModule.isArrayOrTypedArray;
  lib.isArray1D = arrayModule.isArray1D;
  lib.ensureArray = arrayModule.ensureArray;
  lib.concat = arrayModule.concat;
  lib.maxRowLength = arrayModule.maxRowLength;
  lib.minRowLength = arrayModule.minRowLength;
  
  var modModule = _dereq_('./mod');
  lib.mod = modModule.mod;
  lib.modHalf = modModule.modHalf;
  
  var coerceModule = _dereq_('./coerce');
  lib.valObjectMeta = coerceModule.valObjectMeta;
  lib.coerce = coerceModule.coerce;
  lib.coerce2 = coerceModule.coerce2;
  lib.coerceFont = coerceModule.coerceFont;
  lib.coerceHoverinfo = coerceModule.coerceHoverinfo;
  lib.coerceSelectionMarkerOpacity = coerceModule.coerceSelectionMarkerOpacity;
  lib.validate = coerceModule.validate;
  
  var datesModule = _dereq_('./dates');
  lib.dateTime2ms = datesModule.dateTime2ms;
  lib.isDateTime = datesModule.isDateTime;
  lib.ms2DateTime = datesModule.ms2DateTime;
  lib.ms2DateTimeLocal = datesModule.ms2DateTimeLocal;
  lib.cleanDate = datesModule.cleanDate;
  lib.isJSDate = datesModule.isJSDate;
  lib.formatDate = datesModule.formatDate;
  lib.incrementMonth = datesModule.incrementMonth;
  lib.dateTick0 = datesModule.dateTick0;
  lib.dfltRange = datesModule.dfltRange;
  lib.findExactDates = datesModule.findExactDates;
  lib.MIN_MS = datesModule.MIN_MS;
  lib.MAX_MS = datesModule.MAX_MS;
  
  var searchModule = _dereq_('./search');
  lib.findBin = searchModule.findBin;
  lib.sorterAsc = searchModule.sorterAsc;
  lib.sorterDes = searchModule.sorterDes;
  lib.distinctVals = searchModule.distinctVals;
  lib.roundUp = searchModule.roundUp;
  lib.sort = searchModule.sort;
  lib.findIndexOfMin = searchModule.findIndexOfMin;
  
  var statsModule = _dereq_('./stats');
  lib.aggNums = statsModule.aggNums;
  lib.len = statsModule.len;
  lib.mean = statsModule.mean;
  lib.median = statsModule.median;
  lib.midRange = statsModule.midRange;
  lib.variance = statsModule.variance;
  lib.stdev = statsModule.stdev;
  lib.interp = statsModule.interp;
  
  var matrixModule = _dereq_('./matrix');
  lib.init2dArray = matrixModule.init2dArray;
  lib.transposeRagged = matrixModule.transposeRagged;
  lib.dot = matrixModule.dot;
  lib.translationMatrix = matrixModule.translationMatrix;
  lib.rotationMatrix = matrixModule.rotationMatrix;
  lib.rotationXYMatrix = matrixModule.rotationXYMatrix;
  lib.apply2DTransform = matrixModule.apply2DTransform;
  lib.apply2DTransform2 = matrixModule.apply2DTransform2;
  
  var anglesModule = _dereq_('./angles');
  lib.deg2rad = anglesModule.deg2rad;
  lib.rad2deg = anglesModule.rad2deg;
  lib.angleDelta = anglesModule.angleDelta;
  lib.angleDist = anglesModule.angleDist;
  lib.isFullCircle = anglesModule.isFullCircle;
  lib.isAngleInsideSector = anglesModule.isAngleInsideSector;
  lib.isPtInsideSector = anglesModule.isPtInsideSector;
  lib.pathArc = anglesModule.pathArc;
  lib.pathSector = anglesModule.pathSector;
  lib.pathAnnulus = anglesModule.pathAnnulus;
  
  var anchorUtils = _dereq_('./anchor_utils');
  lib.isLeftAnchor = anchorUtils.isLeftAnchor;
  lib.isCenterAnchor = anchorUtils.isCenterAnchor;
  lib.isRightAnchor = anchorUtils.isRightAnchor;
  lib.isTopAnchor = anchorUtils.isTopAnchor;
  lib.isMiddleAnchor = anchorUtils.isMiddleAnchor;
  lib.isBottomAnchor = anchorUtils.isBottomAnchor;
  
  var geom2dModule = _dereq_('./geometry2d');
  lib.segmentsIntersect = geom2dModule.segmentsIntersect;
  lib.segmentDistance = geom2dModule.segmentDistance;
  lib.getTextLocation = geom2dModule.getTextLocation;
  lib.clearLocationCache = geom2dModule.clearLocationCache;
  lib.getVisibleSegment = geom2dModule.getVisibleSegment;
  lib.findPointOnPath = geom2dModule.findPointOnPath;
  
  var extendModule = _dereq_('./extend');
  lib.extendFlat = extendModule.extendFlat;
  lib.extendDeep = extendModule.extendDeep;
  lib.extendDeepAll = extendModule.extendDeepAll;
  lib.extendDeepNoArrays = extendModule.extendDeepNoArrays;
  
  var loggersModule = _dereq_('./loggers');
  lib.log = loggersModule.log;
  lib.warn = loggersModule.warn;
  lib.error = loggersModule.error;
  
  var regexModule = _dereq_('./regex');
  lib.counterRegex = regexModule.counter;
  
  var throttleModule = _dereq_('./throttle');
  lib.throttle = throttleModule.throttle;
  lib.throttleDone = throttleModule.done;
  lib.clearThrottle = throttleModule.clear;
  
  var domModule = _dereq_('./dom');
  lib.getGraphDiv = domModule.getGraphDiv;
  lib.isPlotDiv = domModule.isPlotDiv;
  lib.removeElement = domModule.removeElement;
  lib.addStyleRule = domModule.addStyleRule;
  lib.addRelatedStyleRule = domModule.addRelatedStyleRule;
  lib.deleteRelatedStyleRule = domModule.deleteRelatedStyleRule;
  
  lib.clearResponsive = _dereq_('./clear_responsive');
  
  lib.makeTraceGroups = _dereq_('./make_trace_groups');
  
  lib._ = _dereq_('./localize');
  
  lib.notifier = _dereq_('./notifier');
  
  lib.filterUnique = _dereq_('./filter_unique');
  lib.filterVisible = _dereq_('./filter_visible');
  lib.pushUnique = _dereq_('./push_unique');
  
  lib.increment = _dereq_('./increment');
  
  lib.cleanNumber = _dereq_('./clean_number');
  
  lib.ensureNumber = function ensureNumber(v) {
      if(!isNumeric(v)) return BADNUM;
      v = Number(v);
      if(v < -FP_SAFE || v > FP_SAFE) return BADNUM;
      return isNumeric(v) ? Number(v) : BADNUM;
  };
  
  /**
   * Is v a valid array index? Accepts numeric strings as well as numbers.
   *
   * @param {any} v: the value to test
   * @param {Optional[integer]} len: the array length we are indexing
   *
   * @return {bool}: v is a valid array index
   */
  lib.isIndex = function(v, len) {
      if(len !== undefined && v >= len) return false;
      return isNumeric(v) && (v >= 0) && (v % 1 === 0);
  };
  
  lib.noop = _dereq_('./noop');
  lib.identity = _dereq_('./identity');
  
  /**
   * create an array of length 'cnt' filled with 'v' at all indices
   *
   * @param {any} v
   * @param {number} cnt
   * @return {array}
   */
  lib.repeat = function(v, cnt) {
      var out = new Array(cnt);
      for(var i = 0; i < cnt; i++) {
          out[i] = v;
      }
      return out;
  };
  
  /**
   * swap x and y of the same attribute in container cont
   * specify attr with a ? in place of x/y
   * you can also swap other things than x/y by providing part1 and part2
   */
  lib.swapAttrs = function(cont, attrList, part1, part2) {
      if(!part1) part1 = 'x';
      if(!part2) part2 = 'y';
      for(var i = 0; i < attrList.length; i++) {
          var attr = attrList[i];
          var xp = lib.nestedProperty(cont, attr.replace('?', part1));
          var yp = lib.nestedProperty(cont, attr.replace('?', part2));
          var temp = xp.get();
          xp.set(yp.get());
          yp.set(temp);
      }
  };
  
  /**
   * SVG painter's algo worked around with reinsertion
   */
  lib.raiseToTop = function raiseToTop(elem) {
      elem.parentNode.appendChild(elem);
  };
  
  /**
   * cancel a possibly pending transition; returned selection may be used by caller
   */
  lib.cancelTransition = function(selection) {
      return selection.transition().duration(0);
  };
  
  // constrain - restrict a number v to be between v0 and v1
  lib.constrain = function(v, v0, v1) {
      if(v0 > v1) return Math.max(v1, Math.min(v0, v));
      return Math.max(v0, Math.min(v1, v));
  };
  
  /**
   * do two bounding boxes from getBoundingClientRect,
   * ie {left,right,top,bottom,width,height}, overlap?
   * takes optional padding pixels
   */
  lib.bBoxIntersect = function(a, b, pad) {
      pad = pad || 0;
      return (a.left <= b.right + pad &&
              b.left <= a.right + pad &&
              a.top <= b.bottom + pad &&
              b.top <= a.bottom + pad);
  };
  
  /*
   * simpleMap: alternative to Array.map that only
   * passes on the element and up to 2 extra args you
   * provide (but not the array index or the whole array)
   *
   * array: the array to map it to
   * func: the function to apply
   * x1, x2: optional extra args
   */
  lib.simpleMap = function(array, func, x1, x2, opts) {
      var len = array.length;
      var out = new Array(len);
      for(var i = 0; i < len; i++) out[i] = func(array[i], x1, x2, opts);
      return out;
  };
  
  /**
   * Random string generator
   *
   * @param {object} existing
   *     pass in strings to avoid as keys with truthy values
   * @param {int} bits
   *     bits of information in the output string, default 24
   * @param {int} base
   *     base of string representation, default 16. Should be a power of 2.
   */
  lib.randstr = function randstr(existing, bits, base, _recursion) {
      if(!base) base = 16;
      if(bits === undefined) bits = 24;
      if(bits <= 0) return '0';
  
      var digits = Math.log(Math.pow(2, bits)) / Math.log(base);
      var res = '';
      var i, b, x;
  
      for(i = 2; digits === Infinity; i *= 2) {
          digits = Math.log(Math.pow(2, bits / i)) / Math.log(base) * i;
      }
  
      var rem = digits - Math.floor(digits);
  
      for(i = 0; i < Math.floor(digits); i++) {
          x = Math.floor(Math.random() * base).toString(base);
          res = x + res;
      }
  
      if(rem) {
          b = Math.pow(base, rem);
          x = Math.floor(Math.random() * b).toString(base);
          res = x + res;
      }
  
      var parsed = parseInt(res, base);
      if((existing && existing[res]) ||
           (parsed !== Infinity && parsed >= Math.pow(2, bits))) {
          if(_recursion > 10) {
              lib.warn('randstr failed uniqueness');
              return res;
          }
          return randstr(existing, bits, base, (_recursion || 0) + 1);
      } else return res;
  };
  
  lib.OptionControl = function(opt, optname) {
      /*
       * An environment to contain all option setters and
       * getters that collectively modify opts.
       *
       * You can call up opts from any function in new object
       * as this.optname || this.opt
       *
       * See FitOpts for example of usage
       */
      if(!opt) opt = {};
      if(!optname) optname = 'opt';
  
      var self = {};
      self.optionList = [];
  
      self._newoption = function(optObj) {
          optObj[optname] = opt;
          self[optObj.name] = optObj;
          self.optionList.push(optObj);
      };
  
      self['_' + optname] = opt;
      return self;
  };
  
  /**
   * lib.smooth: smooth arrayIn by convolving with
   * a hann window with given full width at half max
   * bounce the ends in, so the output has the same length as the input
   */
  lib.smooth = function(arrayIn, FWHM) {
      FWHM = Math.round(FWHM) || 0; // only makes sense for integers
      if(FWHM < 2) return arrayIn;
  
      var alen = arrayIn.length;
      var alen2 = 2 * alen;
      var wlen = 2 * FWHM - 1;
      var w = new Array(wlen);
      var arrayOut = new Array(alen);
      var i;
      var j;
      var k;
      var v;
  
      // first make the window array
      for(i = 0; i < wlen; i++) {
          w[i] = (1 - Math.cos(Math.PI * (i + 1) / FWHM)) / (2 * FWHM);
      }
  
      // now do the convolution
      for(i = 0; i < alen; i++) {
          v = 0;
          for(j = 0; j < wlen; j++) {
              k = i + j + 1 - FWHM;
  
              // multibounce
              if(k < -alen) k -= alen2 * Math.round(k / alen2);
              else if(k >= alen2) k -= alen2 * Math.floor(k / alen2);
  
              // single bounce
              if(k < 0) k = - 1 - k;
              else if(k >= alen) k = alen2 - 1 - k;
  
              v += arrayIn[k] * w[j];
          }
          arrayOut[i] = v;
      }
  
      return arrayOut;
  };
  
  /**
   * syncOrAsync: run a sequence of functions synchronously
   * as long as its returns are not promises (ie have no .then)
   * includes one argument arg to send to all functions...
   * this is mainly just to prevent us having to make wrapper functions
   * when the only purpose of the wrapper is to reference gd
   * and a final step to be executed at the end
   * TODO: if there's an error and everything is sync,
   * this doesn't happen yet because we want to make sure
   * that it gets reported
   */
  lib.syncOrAsync = function(sequence, arg, finalStep) {
      var ret, fni;
  
      function continueAsync() {
          return lib.syncOrAsync(sequence, arg, finalStep);
      }
  
      while(sequence.length) {
          fni = sequence.splice(0, 1)[0];
          ret = fni(arg);
  
          if(ret && ret.then) {
              return ret.then(continueAsync)
                  .then(undefined, lib.promiseError);
          }
      }
  
      return finalStep && finalStep(arg);
  };
  
  
  /**
   * Helper to strip trailing slash, from
   * http://stackoverflow.com/questions/6680825/return-string-without-trailing-slash
   */
  lib.stripTrailingSlash = function(str) {
      if(str.substr(-1) === '/') return str.substr(0, str.length - 1);
      return str;
  };
  
  lib.noneOrAll = function(containerIn, containerOut, attrList) {
      /**
       * some attributes come together, so if you have one of them
       * in the input, you should copy the default values of the others
       * to the input as well.
       */
      if(!containerIn) return;
  
      var hasAny = false;
      var hasAll = true;
      var i;
      var val;
  
      for(i = 0; i < attrList.length; i++) {
          val = containerIn[attrList[i]];
          if(val !== undefined && val !== null) hasAny = true;
          else hasAll = false;
      }
  
      if(hasAny && !hasAll) {
          for(i = 0; i < attrList.length; i++) {
              containerIn[attrList[i]] = containerOut[attrList[i]];
          }
      }
  };
  
  /** merges calcdata field (given by cdAttr) with traceAttr values
   *
   * N.B. Loop over minimum of cd.length and traceAttr.length
   * i.e. it does not try to fill in beyond traceAttr.length-1
   *
   * @param {array} traceAttr : trace attribute
   * @param {object} cd : calcdata trace
   * @param {string} cdAttr : calcdata key
   */
  lib.mergeArray = function(traceAttr, cd, cdAttr, fn) {
      var hasFn = typeof fn === 'function';
      if(lib.isArrayOrTypedArray(traceAttr)) {
          var imax = Math.min(traceAttr.length, cd.length);
          for(var i = 0; i < imax; i++) {
              var v = traceAttr[i];
              cd[i][cdAttr] = hasFn ? fn(v) : v;
          }
      }
  };
  
  // cast numbers to positive numbers, returns 0 if not greater than 0
  lib.mergeArrayCastPositive = function(traceAttr, cd, cdAttr) {
      return lib.mergeArray(traceAttr, cd, cdAttr, function(v) {
          var w = +v;
          return !isFinite(w) ? 0 : w > 0 ? w : 0;
      });
  };
  
  /** fills calcdata field (given by cdAttr) with traceAttr values
   *  or function of traceAttr values (e.g. some fallback)
   *
   * N.B. Loops over all cd items.
   *
   * @param {array} traceAttr : trace attribute
   * @param {object} cd : calcdata trace
   * @param {string} cdAttr : calcdata key
   * @param {function} [fn] : optional function to apply to each array item
   */
  lib.fillArray = function(traceAttr, cd, cdAttr, fn) {
      fn = fn || lib.identity;
  
      if(lib.isArrayOrTypedArray(traceAttr)) {
          for(var i = 0; i < cd.length; i++) {
              cd[i][cdAttr] = fn(traceAttr[i]);
          }
      }
  };
  
  /** Handler for trace-wide vs per-point options
   *
   * @param {object} trace : (full) trace object
   * @param {number} ptNumber : index of the point in question
   * @param {string} astr : attribute string
   * @param {function} [fn] : optional function to apply to each array item
   *
   * @return {any}
   */
  lib.castOption = function(trace, ptNumber, astr, fn) {
      fn = fn || lib.identity;
  
      var val = lib.nestedProperty(trace, astr).get();
  
      if(lib.isArrayOrTypedArray(val)) {
          if(Array.isArray(ptNumber) && lib.isArrayOrTypedArray(val[ptNumber[0]])) {
              return fn(val[ptNumber[0]][ptNumber[1]]);
          } else {
              return fn(val[ptNumber]);
          }
      } else {
          return val;
      }
  };
  
  /** Extract option from calcdata item, correctly falling back to
   *  trace value if not found.
   *
   *  @param {object} calcPt : calcdata[i][j] item
   *  @param {object} trace : (full) trace object
   *  @param {string} calcKey : calcdata key
   *  @param {string} traceKey : aka trace attribute string
   *  @return {any}
   */
  lib.extractOption = function(calcPt, trace, calcKey, traceKey) {
      if(calcKey in calcPt) return calcPt[calcKey];
  
      // fallback to trace value,
      //   must check if value isn't itself an array
      //   which means the trace attribute has a corresponding
      //   calcdata key, but its value is falsy
      var traceVal = lib.nestedProperty(trace, traceKey).get();
      if(!Array.isArray(traceVal)) return traceVal;
  };
  
  function makePtIndex2PtNumber(indexToPoints) {
      var ptIndex2ptNumber = {};
      for(var k in indexToPoints) {
          var pts = indexToPoints[k];
          for(var j = 0; j < pts.length; j++) {
              ptIndex2ptNumber[pts[j]] = +k;
          }
      }
      return ptIndex2ptNumber;
  }
  
  /** Tag selected calcdata items
   *
   * N.B. note that point 'index' corresponds to input data array index
   *  whereas 'number' is its post-transform version.
   *
   * @param {array} calcTrace
   * @param {object} trace
   *  - selectedpoints {array}
   *  - _indexToPoints {object}
   * @param {ptNumber2cdIndex} ptNumber2cdIndex (optional)
   *  optional map object for trace types that do not have 1-to-1 point number to
   *  calcdata item index correspondence (e.g. histogram)
   */
  lib.tagSelected = function(calcTrace, trace, ptNumber2cdIndex) {
      var selectedpoints = trace.selectedpoints;
      var indexToPoints = trace._indexToPoints;
      var ptIndex2ptNumber;
  
      // make pt index-to-number map object, which takes care of transformed traces
      if(indexToPoints) {
          ptIndex2ptNumber = makePtIndex2PtNumber(indexToPoints);
      }
  
      function isCdIndexValid(v) {
          return v !== undefined && v < calcTrace.length;
      }
  
      for(var i = 0; i < selectedpoints.length; i++) {
          var ptIndex = selectedpoints[i];
  
          if(lib.isIndex(ptIndex) ||
             (lib.isArrayOrTypedArray(ptIndex) && lib.isIndex(ptIndex[0]) && lib.isIndex(ptIndex[1]))
          ) {
              var ptNumber = ptIndex2ptNumber ? ptIndex2ptNumber[ptIndex] : ptIndex;
              var cdIndex = ptNumber2cdIndex ? ptNumber2cdIndex[ptNumber] : ptNumber;
  
              if(isCdIndexValid(cdIndex)) {
                  calcTrace[cdIndex].selected = 1;
              }
          }
      }
  };
  
  lib.selIndices2selPoints = function(trace) {
      var selectedpoints = trace.selectedpoints;
      var indexToPoints = trace._indexToPoints;
  
      if(indexToPoints) {
          var ptIndex2ptNumber = makePtIndex2PtNumber(indexToPoints);
          var out = [];
  
          for(var i = 0; i < selectedpoints.length; i++) {
              var ptIndex = selectedpoints[i];
              if(lib.isIndex(ptIndex)) {
                  var ptNumber = ptIndex2ptNumber[ptIndex];
                  if(lib.isIndex(ptNumber)) {
                      out.push(ptNumber);
                  }
              }
          }
  
          return out;
      } else {
          return selectedpoints;
      }
  };
  
  /** Returns target as set by 'target' transform attribute
   *
   * @param {object} trace : full trace object
   * @param {object} transformOpts : transform option object
   *  - target (string} :
   *      either an attribute string referencing an array in the trace object, or
   *      a set array.
   *
   * @return {array or false} : the target array (NOT a copy!!) or false if invalid
   */
  lib.getTargetArray = function(trace, transformOpts) {
      var target = transformOpts.target;
  
      if(typeof target === 'string' && target) {
          var array = lib.nestedProperty(trace, target).get();
          return Array.isArray(array) ? array : false;
      } else if(Array.isArray(target)) {
          return target;
      }
  
      return false;
  };
  
  /**
   * modified version of jQuery's extend to strip out private objs and functions,
   * and cut arrays down to first <arraylen> or 1 elements
   * because extend-like algorithms are hella slow
   * obj2 is assumed to already be clean of these things (including no arrays)
   */
  lib.minExtend = function(obj1, obj2) {
      var objOut = {};
      if(typeof obj2 !== 'object') obj2 = {};
      var arrayLen = 3;
      var keys = Object.keys(obj1);
      var i, k, v;
  
      for(i = 0; i < keys.length; i++) {
          k = keys[i];
          v = obj1[k];
          if(k.charAt(0) === '_' || typeof v === 'function') continue;
          else if(k === 'module') objOut[k] = v;
          else if(Array.isArray(v)) {
              if(k === 'colorscale') {
                  objOut[k] = v.slice();
              } else {
                  objOut[k] = v.slice(0, arrayLen);
              }
          } else if(lib.isTypedArray(v)) {
              objOut[k] = v.subarray(0, arrayLen);
          } else if(v && (typeof v === 'object')) objOut[k] = lib.minExtend(obj1[k], obj2[k]);
          else objOut[k] = v;
      }
  
      keys = Object.keys(obj2);
      for(i = 0; i < keys.length; i++) {
          k = keys[i];
          v = obj2[k];
          if(typeof v !== 'object' || !(k in objOut) || typeof objOut[k] !== 'object') {
              objOut[k] = v;
          }
      }
  
      return objOut;
  };
  
  lib.titleCase = function(s) {
      return s.charAt(0).toUpperCase() + s.substr(1);
  };
  
  lib.containsAny = function(s, fragments) {
      for(var i = 0; i < fragments.length; i++) {
          if(s.indexOf(fragments[i]) !== -1) return true;
      }
      return false;
  };
  
  lib.isIE = function() {
      return typeof window.navigator.msSaveBlob !== 'undefined';
  };
  
  var IS_IE9_OR_BELOW_REGEX = /MSIE [1-9]\./;
  lib.isIE9orBelow = function() {
      return lib.isIE() && IS_IE9_OR_BELOW_REGEX.test(window.navigator.userAgent);
  };
  
  var IS_SAFARI_REGEX = /Version\/[\d\.]+.*Safari/;
  lib.isSafari = function() {
      return IS_SAFARI_REGEX.test(window.navigator.userAgent);
  };
  
  var IS_IOS_REGEX = /iPad|iPhone|iPod/;
  lib.isIOS = function() {
      return IS_IOS_REGEX.test(window.navigator.userAgent);
  };
  
  /**
   * Duck typing to recognize a d3 selection, mostly for IE9's benefit
   * because it doesn't handle instanceof like modern browsers
   */
  lib.isD3Selection = function(obj) {
      return obj && (typeof obj.classed === 'function');
  };
  
  /**
   * Append element to DOM only if not present.
   *
   * @param {d3 selection} parent : parent selection of the element in question
   * @param {string} nodeType : node type of element to append
   * @param {string} className (optional) : class name of element in question
   * @param {fn} enterFn (optional) : optional fn applied to entering elements only
   * @return {d3 selection} selection of new layer
   *
   * Previously, we were using the following pattern:
   *
   * ```
   * var sel = parent.selectAll('.' + className)
   *     .data([0]);
   *
   * sel.enter().append(nodeType)
   *     .classed(className, true);
   *
   * return sel;
   * ```
   *
   * in numerous places in our codebase to achieve the same behavior.
   *
   * The logic below performs much better, mostly as we are using
   * `.select` instead `.selectAll` that is `querySelector` instead of
   * `querySelectorAll`.
   *
   */
  lib.ensureSingle = function(parent, nodeType, className, enterFn) {
      var sel = parent.select(nodeType + (className ? '.' + className : ''));
      if(sel.size()) return sel;
  
      var layer = parent.append(nodeType);
      if(className) layer.classed(className, true);
      if(enterFn) layer.call(enterFn);
  
      return layer;
  };
  
  /**
   * Same as Lib.ensureSingle, but using id as selector.
   * This version is mostly used for clipPath nodes.
   *
   * @param {d3 selection} parent : parent selection of the element in question
   * @param {string} nodeType : node type of element to append
   * @param {string} id : id of element in question
   * @param {fn} enterFn (optional) : optional fn applied to entering elements only
   * @return {d3 selection} selection of new layer
   */
  lib.ensureSingleById = function(parent, nodeType, id, enterFn) {
      var sel = parent.select(nodeType + '#' + id);
      if(sel.size()) return sel;
  
      var layer = parent.append(nodeType).attr('id', id);
      if(enterFn) layer.call(enterFn);
  
      return layer;
  };
  
  /**
   * Converts a string path to an object.
   *
   * When given a string containing an array element, it will create a `null`
   * filled array of the given size.
   *
   * @example
   * lib.objectFromPath('nested.test[2].path', 'value');
   * // returns { nested: { test: [null, null, { path: 'value' }]}
   *
   * @param   {string}    path to nested value
   * @param   {*}         any value to be set
   *
   * @return {Object} the constructed object with a full nested path
   */
  lib.objectFromPath = function(path, value) {
      var keys = path.split('.');
      var tmpObj;
      var obj = tmpObj = {};
  
      for(var i = 0; i < keys.length; i++) {
          var key = keys[i];
          var el = null;
  
          var parts = keys[i].match(/(.*)\[([0-9]+)\]/);
  
          if(parts) {
              key = parts[1];
              el = parts[2];
  
              tmpObj = tmpObj[key] = [];
  
              if(i === keys.length - 1) {
                  tmpObj[el] = value;
              } else {
                  tmpObj[el] = {};
              }
  
              tmpObj = tmpObj[el];
          } else {
              if(i === keys.length - 1) {
                  tmpObj[key] = value;
              } else {
                  tmpObj[key] = {};
              }
  
              tmpObj = tmpObj[key];
          }
      }
  
      return obj;
  };
  
  /**
   * Iterate through an object in-place, converting dotted properties to objects.
   *
   * Examples:
   *
   *   lib.expandObjectPaths({'nested.test.path': 'value'});
   *     => { nested: { test: {path: 'value'}}}
   *
   * It also handles array notation, e.g.:
   *
   *   lib.expandObjectPaths({'foo[1].bar': 'value'});
   *     => { foo: [null, {bar: value}] }
   *
   * It handles merges the results when two properties are specified in parallel:
   *
   *   lib.expandObjectPaths({'foo[1].bar': 10, 'foo[0].bar': 20});
   *     => { foo: [{bar: 10}, {bar: 20}] }
   *
   * It does NOT, however, merge mulitple mutliply-nested arrays::
   *
   *   lib.expandObjectPaths({'marker[1].range[1]': 5, 'marker[1].range[0]': 4})
   *     => { marker: [null, {range: 4}] }
   */
  
  // Store this to avoid recompiling regex on *every* prop since this may happen many
  // many times for animations. Could maybe be inside the function. Not sure about
  // scoping vs. recompilation tradeoff, but at least it's not just inlining it into
  // the inner loop.
  var dottedPropertyRegex = /^([^\[\.]+)\.(.+)?/;
  var indexedPropertyRegex = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
  
  lib.expandObjectPaths = function(data) {
      var match, key, prop, datum, idx, dest, trailingPath;
      if(typeof data === 'object' && !Array.isArray(data)) {
          for(key in data) {
              if(data.hasOwnProperty(key)) {
                  if((match = key.match(dottedPropertyRegex))) {
                      datum = data[key];
                      prop = match[1];
  
                      delete data[key];
  
                      data[prop] = lib.extendDeepNoArrays(data[prop] || {}, lib.objectFromPath(key, lib.expandObjectPaths(datum))[prop]);
                  } else if((match = key.match(indexedPropertyRegex))) {
                      datum = data[key];
  
                      prop = match[1];
                      idx = parseInt(match[2]);
  
                      delete data[key];
  
                      data[prop] = data[prop] || [];
  
                      if(match[3] === '.') {
                          // This is the case where theere are subsequent properties into which
                          // we must recurse, e.g. transforms[0].value
                          trailingPath = match[4];
                          dest = data[prop][idx] = data[prop][idx] || {};
  
                          // NB: Extend deep no arrays prevents this from working on multiple
                          // nested properties in the same object, e.g.
                          //
                          // {
                          //   foo[0].bar[1].range
                          //   foo[0].bar[0].range
                          // }
                          //
                          // In this case, the extendDeepNoArrays will overwrite one array with
                          // the other, so that both properties *will not* be present in the
                          // result. Fixing this would require a more intelligent tracking
                          // of changes and merging than extendDeepNoArrays currently accomplishes.
                          lib.extendDeepNoArrays(dest, lib.objectFromPath(trailingPath, lib.expandObjectPaths(datum)));
                      } else {
                          // This is the case where this property is the end of the line,
                          // e.g. xaxis.range[0]
                          data[prop][idx] = lib.expandObjectPaths(datum);
                      }
                  } else {
                      data[key] = lib.expandObjectPaths(data[key]);
                  }
              }
          }
      }
  
      return data;
  };
  
  /**
   * Converts value to string separated by the provided separators.
   *
   * @example
   * lib.numSeparate(2016, '.,');
   * // returns '2016'
   *
   * @example
   * lib.numSeparate(3000, '.,', true);
   * // returns '3,000'
   *
   * @example
   * lib.numSeparate(1234.56, '|,')
   * // returns '1,234|56'
   *
   * @param   {string|number} value       the value to be converted
   * @param   {string}    separators  string of decimal, then thousands separators
   * @param   {boolean}    separatethousands  boolean, 4-digit integers are separated if true
   *
   * @return  {string}    the value that has been separated
   */
  lib.numSeparate = function(value, separators, separatethousands) {
      if(!separatethousands) separatethousands = false;
  
      if(typeof separators !== 'string' || separators.length === 0) {
          throw new Error('Separator string required for formatting!');
      }
  
      if(typeof value === 'number') {
          value = String(value);
      }
  
      var thousandsRe = /(\d+)(\d{3})/;
      var decimalSep = separators.charAt(0);
      var thouSep = separators.charAt(1);
  
      var x = value.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? decimalSep + x[1] : '';
  
      // Years are ignored for thousands separators
      if(thouSep && (x.length > 1 || x1.length > 4 || separatethousands)) {
          while(thousandsRe.test(x1)) {
              x1 = x1.replace(thousandsRe, '$1' + thouSep + '$2');
          }
      }
  
      return x1 + x2;
  };
  
  lib.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
  var SIMPLE_PROPERTY_REGEX = /^\w*$/;
  
  /**
   * Substitute values from an object into a string
   *
   * Examples:
   *  Lib.templateString('name: %{trace}', {trace: 'asdf'}) --> 'name: asdf'
   *  Lib.templateString('name: %{trace[0].name}', {trace: [{name: 'asdf'}]}) --> 'name: asdf'
   *
   * @param {string}  input string containing %{...} template strings
   * @param {obj}     data object containing substitution values
   *
   * @return {string} templated string
   */
  lib.templateString = function(string, obj) {
      // Not all that useful, but cache nestedProperty instantiation
      // just in case it speeds things up *slightly*:
      var getterCache = {};
  
      return string.replace(lib.TEMPLATE_STRING_REGEX, function(dummy, key) {
          var v;
          if(SIMPLE_PROPERTY_REGEX.test(key)) {
              v = obj[key];
          } else {
              getterCache[key] = getterCache[key] || lib.nestedProperty(obj, key).get;
              v = getterCache[key]();
          }
          return lib.isValidTextValue(v) ? v : '';
      });
  };
  
  var hovertemplateWarnings = {
      max: 10,
      count: 0,
      name: 'hovertemplate'
  };
  lib.hovertemplateString = function() {
      return templateFormatString.apply(hovertemplateWarnings, arguments);
  };
  
  var texttemplateWarnings = {
      max: 10,
      count: 0,
      name: 'texttemplate'
  };
  lib.texttemplateString = function() {
      return templateFormatString.apply(texttemplateWarnings, arguments);
  };
  
  var TEMPLATE_STRING_FORMAT_SEPARATOR = /^[:|\|]/;
  /**
   * Substitute values from an object into a string and optionally formats them using d3-format,
   * or fallback to associated labels.
   *
   * Examples:
   *  Lib.hovertemplateString('name: %{trace}', {trace: 'asdf'}) --> 'name: asdf'
   *  Lib.hovertemplateString('name: %{trace[0].name}', {trace: [{name: 'asdf'}]}) --> 'name: asdf'
   *  Lib.hovertemplateString('price: %{y:$.2f}', {y: 1}) --> 'price: $1.00'
   *
   * @param {string}  input string containing %{...:...} template strings
   * @param {obj}     data object containing fallback text when no formatting is specified, ex.: {yLabel: 'formattedYValue'}
   * @param {obj}     d3 locale
   * @param {obj}     data objects containing substitution values
   *
   * @return {string} templated string
   */
  function templateFormatString(string, labels, d3locale) {
      var opts = this;
      var args = arguments;
      if(!labels) labels = {};
      // Not all that useful, but cache nestedProperty instantiation
      // just in case it speeds things up *slightly*:
      var getterCache = {};
  
      return string.replace(lib.TEMPLATE_STRING_REGEX, function(match, key, format) {
          var obj, value, i;
          for(i = 3; i < args.length; i++) {
              obj = args[i];
              if(!obj) continue;
              if(obj.hasOwnProperty(key)) {
                  value = obj[key];
                  break;
              }
  
              if(!SIMPLE_PROPERTY_REGEX.test(key)) {
                  value = getterCache[key] || lib.nestedProperty(obj, key).get();
                  if(value) getterCache[key] = value;
              }
              if(value !== undefined) break;
          }
  
          if(value === undefined && opts) {
              if(opts.count < opts.max) {
                  lib.warn('Variable \'' + key + '\' in ' + opts.name + ' could not be found!');
                  value = match;
              }
  
              if(opts.count === opts.max) {
                  lib.warn('Too many ' + opts.name + ' warnings - additional warnings will be suppressed');
              }
              opts.count++;
  
              return match;
          }
  
          if(format) {
              var fmt;
              if(format[0] === ':') {
                  fmt = d3locale ? d3locale.numberFormat : d3.format;
                  value = fmt(format.replace(TEMPLATE_STRING_FORMAT_SEPARATOR, ''))(value);
              }
  
              if(format[0] === '|') {
                  fmt = d3locale ? d3locale.timeFormat : utcFormat;
                  var ms = lib.dateTime2ms(value);
                  value = lib.formatDate(ms, format.replace(TEMPLATE_STRING_FORMAT_SEPARATOR, ''), false, fmt);
              }
          } else {
              if(labels.hasOwnProperty(key + 'Label')) value = labels[key + 'Label'];
          }
          return value;
      });
  }
  
  /*
   * alphanumeric string sort, tailored for subplot IDs like scene2, scene10, x10y13 etc
   */
  var char0 = 48;
  var char9 = 57;
  lib.subplotSort = function(a, b) {
      var l = Math.min(a.length, b.length) + 1;
      var numA = 0;
      var numB = 0;
      for(var i = 0; i < l; i++) {
          var charA = a.charCodeAt(i) || 0;
          var charB = b.charCodeAt(i) || 0;
          var isNumA = charA >= char0 && charA <= char9;
          var isNumB = charB >= char0 && charB <= char9;
  
          if(isNumA) numA = 10 * numA + charA - char0;
          if(isNumB) numB = 10 * numB + charB - char0;
  
          if(!isNumA || !isNumB) {
              if(numA !== numB) return numA - numB;
              if(charA !== charB) return charA - charB;
          }
      }
      return numB - numA;
  };
  
  // repeatable pseudorandom generator
  var randSeed = 2000000000;
  
  lib.seedPseudoRandom = function() {
      randSeed = 2000000000;
  };
  
  lib.pseudoRandom = function() {
      var lastVal = randSeed;
      randSeed = (69069 * randSeed + 1) % 4294967296;
      // don't let consecutive vals be too close together
      // gets away from really trying to be random, in favor of better local uniformity
      if(Math.abs(randSeed - lastVal) < 429496729) return lib.pseudoRandom();
      return randSeed / 4294967296;
  };
  
  
  /** Fill hover 'pointData' container with 'correct' hover text value
   *
   * - If trace hoverinfo contains a 'text' flag and hovertext is not set,
   *   the text elements will be seen in the hover labels.
   *
   * - If trace hoverinfo contains a 'text' flag and hovertext is set,
   *   hovertext takes precedence over text
   *   i.e. the hoverinfo elements will be seen in the hover labels
   *
   *  @param {object} calcPt
   *  @param {object} trace
   *  @param {object || array} contOut (mutated here)
   */
  lib.fillText = function(calcPt, trace, contOut) {
      var fill = Array.isArray(contOut) ?
          function(v) { contOut.push(v); } :
          function(v) { contOut.text = v; };
  
      var htx = lib.extractOption(calcPt, trace, 'htx', 'hovertext');
      if(lib.isValidTextValue(htx)) return fill(htx);
  
      var tx = lib.extractOption(calcPt, trace, 'tx', 'text');
      if(lib.isValidTextValue(tx)) return fill(tx);
  };
  
  // accept all truthy values and 0 (which gets cast to '0' in the hover labels)
  lib.isValidTextValue = function(v) {
      return v || v === 0;
  };
  
  /**
   * @param {number} ratio
   * @param {number} n (number of decimal places)
   */
  lib.formatPercent = function(ratio, n) {
      n = n || 0;
      var str = (Math.round(100 * ratio * Math.pow(10, n)) * Math.pow(0.1, n)).toFixed(n) + '%';
      for(var i = 0; i < n; i++) {
          if(str.indexOf('.') !== -1) {
              str = str.replace('0%', '%');
              str = str.replace('.%', '%');
          }
      }
      return str;
  };
  
  lib.isHidden = function(gd) {
      var display = window.getComputedStyle(gd).display;
      return !display || display === 'none';
  };
  
  /** Return transform text for bar bar-like rectangles and pie-like slices
   *  @param {object} transform
   *  - targetX: desired position on the x-axis
   *  - targetY: desired position on the y-axis
   *  - textX: text middle position on the x-axis
   *  - textY: text middle position on the y-axis
   *  - anchorX: (optional) text anchor position on the x-axis (computed from textX), zero for middle anchor
   *  - anchorY: (optional) text anchor position on the y-axis (computed from textY), zero for middle anchor
   *  - scale: (optional) scale applied after translate
   *  - rotate: (optional) rotation applied after scale
   *  - noCenter: when defined no extra arguments needed in rotation
   */
  lib.getTextTransform = function(transform) {
      var noCenter = transform.noCenter;
      var textX = transform.textX;
      var textY = transform.textY;
      var targetX = transform.targetX;
      var targetY = transform.targetY;
      var anchorX = transform.anchorX || 0;
      var anchorY = transform.anchorY || 0;
      var rotate = transform.rotate;
      var scale = transform.scale;
      if(!scale) scale = 0;
      else if(scale > 1) scale = 1;
  
      return (
          'translate(' +
              (targetX - scale * (textX + anchorX)) + ',' +
              (targetY - scale * (textY + anchorY)) +
          ')' +
          (scale < 1 ?
              'scale(' + scale + ')' : ''
          ) +
          (rotate ?
              'rotate(' + rotate +
                  (noCenter ? '' : ' ' + textX + ' ' + textY) +
              ')' : ''
          )
      );
  };
  
  lib.ensureUniformFontSize = function(gd, baseFont) {
      var out = lib.extendFlat({}, baseFont);
      out.size = Math.max(
          baseFont.size,
          gd._fullLayout.uniformtext.minsize || 0
      );
      return out;
  };
  
  /**
   * provide a human-readable list e.g. "A, B, C and D" with an ending separator
   *
   * @param {array} arr : the array to join
   * @param {string} mainSeparator : main separator
   * @param {string} lastSeparator : last separator
   *
   * @return {string} : joined list
   */
  lib.join2 = function(arr, mainSeparator, lastSeparator) {
      var len = arr.length;
      if(len > 1) {
          return arr.slice(0, -1).join(mainSeparator) + lastSeparator + arr[len - 1];
      }
      return arr.join(mainSeparator);
  };
  
  },{"../constants/numerical":725,"./anchor_utils":730,"./angles":731,"./array":732,"./clean_number":733,"./clear_responsive":735,"./coerce":736,"./dates":737,"./dom":738,"./extend":740,"./filter_unique":741,"./filter_visible":742,"./geometry2d":745,"./identity":748,"./increment":749,"./is_plain_object":751,"./keyed_container":752,"./localize":753,"./loggers":754,"./make_trace_groups":755,"./matrix":756,"./mod":757,"./nested_property":758,"./noop":759,"./notifier":760,"./push_unique":764,"./regex":766,"./relative_attr":767,"./relink_private":768,"./search":769,"./stats":772,"./throttle":775,"./to_log_range":776,"d3":169,"d3-time-format":166,"fast-isnumeric":241}],751:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  // more info: http://stackoverflow.com/questions/18531624/isplainobject-thing
  module.exports = function isPlainObject(obj) {
      // We need to be a little less strict in the `imagetest` container because
      // of how async image requests are handled.
      //
      // N.B. isPlainObject(new Constructor()) will return true in `imagetest`
      if(window && window.process && window.process.versions) {
          return Object.prototype.toString.call(obj) === '[object Object]';
      }
  
      return (
          Object.prototype.toString.call(obj) === '[object Object]' &&
          Object.getPrototypeOf(obj) === Object.prototype
      );
  };
  
  },{}],752:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var nestedProperty = _dereq_('./nested_property');
  
  var SIMPLE_PROPERTY_REGEX = /^\w*$/;
  
  // bitmask for deciding what's updated. Sometimes the name needs to be updated,
  // sometimes the value needs to be updated, and sometimes both do. This is just
  // a simple way to track what's updated such that it's a simple OR operation to
  // assimilate new updates.
  //
  // The only exception is the UNSET bit that tracks when we need to explicitly
  // unset and remove the property. This concrn arises because of the special
  // way in which nestedProperty handles null/undefined. When you specify `null`,
  // it prunes any unused items in the tree. I ran into some issues with it getting
  // null vs undefined confused, so UNSET is just a bit that forces the property
  // update to send `null`, removing the property explicitly rather than setting
  // it to undefined.
  var NONE = 0;
  var NAME = 1;
  var VALUE = 2;
  var BOTH = 3;
  var UNSET = 4;
  
  module.exports = function keyedContainer(baseObj, path, keyName, valueName) {
      keyName = keyName || 'name';
      valueName = valueName || 'value';
      var i, arr, baseProp;
      var changeTypes = {};
  
      if(path && path.length) {
          baseProp = nestedProperty(baseObj, path);
          arr = baseProp.get();
      } else {
          arr = baseObj;
      }
  
      path = path || '';
  
      // Construct an index:
      var indexLookup = {};
      if(arr) {
          for(i = 0; i < arr.length; i++) {
              indexLookup[arr[i][keyName]] = i;
          }
      }
  
      var isSimpleValueProp = SIMPLE_PROPERTY_REGEX.test(valueName);
  
      var obj = {
          set: function(name, value) {
              var changeType = value === null ? UNSET : NONE;
  
              // create the base array if necessary
              if(!arr) {
                  if(!baseProp || changeType === UNSET) return;
  
                  arr = [];
                  baseProp.set(arr);
              }
  
              var idx = indexLookup[name];
              if(idx === undefined) {
                  if(changeType === UNSET) return;
  
                  changeType = changeType | BOTH;
                  idx = arr.length;
                  indexLookup[name] = idx;
              } else if(value !== (isSimpleValueProp ? arr[idx][valueName] : nestedProperty(arr[idx], valueName).get())) {
                  changeType = changeType | VALUE;
              }
  
              var newValue = arr[idx] = arr[idx] || {};
              newValue[keyName] = name;
  
              if(isSimpleValueProp) {
                  newValue[valueName] = value;
              } else {
                  nestedProperty(newValue, valueName).set(value);
              }
  
              // If it's not an unset, force that bit to be unset. This is all related to the fact
              // that undefined and null are a bit specially implemented in nestedProperties.
              if(value !== null) {
                  changeType = changeType & ~UNSET;
              }
  
              changeTypes[idx] = changeTypes[idx] | changeType;
  
              return obj;
          },
          get: function(name) {
              if(!arr) return;
  
              var idx = indexLookup[name];
  
              if(idx === undefined) {
                  return undefined;
              } else if(isSimpleValueProp) {
                  return arr[idx][valueName];
              } else {
                  return nestedProperty(arr[idx], valueName).get();
              }
          },
          rename: function(name, newName) {
              var idx = indexLookup[name];
  
              if(idx === undefined) return obj;
              changeTypes[idx] = changeTypes[idx] | NAME;
  
              indexLookup[newName] = idx;
              delete indexLookup[name];
  
              arr[idx][keyName] = newName;
  
              return obj;
          },
          remove: function(name) {
              var idx = indexLookup[name];
  
              if(idx === undefined) return obj;
  
              var object = arr[idx];
              if(Object.keys(object).length > 2) {
                  // This object contains more than just the key/value, so unset
                  // the value without modifying the entry otherwise:
                  changeTypes[idx] = changeTypes[idx] | VALUE;
                  return obj.set(name, null);
              }
  
              if(isSimpleValueProp) {
                  for(i = idx; i < arr.length; i++) {
                      changeTypes[i] = changeTypes[i] | BOTH;
                  }
                  for(i = idx; i < arr.length; i++) {
                      indexLookup[arr[i][keyName]]--;
                  }
                  arr.splice(idx, 1);
                  delete(indexLookup[name]);
              } else {
                  // Perform this update *strictly* so we can check whether the result's
                  // been pruned. If so, it's a removal. If not, it's a value unset only.
                  nestedProperty(object, valueName).set(null);
  
                  // Now check if the top level nested property has any keys left. If so,
                  // the object still has values so we only want to unset the key. If not,
                  // the entire object can be removed since there's no other data.
                  // var topLevelKeys = Object.keys(object[valueName.split('.')[0]] || []);
  
                  changeTypes[idx] = changeTypes[idx] | VALUE | UNSET;
              }
  
              return obj;
          },
          constructUpdate: function() {
              var astr, idx;
              var update = {};
              var changed = Object.keys(changeTypes);
              for(var i = 0; i < changed.length; i++) {
                  idx = changed[i];
                  astr = path + '[' + idx + ']';
                  if(arr[idx]) {
                      if(changeTypes[idx] & NAME) {
                          update[astr + '.' + keyName] = arr[idx][keyName];
                      }
                      if(changeTypes[idx] & VALUE) {
                          if(isSimpleValueProp) {
                              update[astr + '.' + valueName] = (changeTypes[idx] & UNSET) ? null : arr[idx][valueName];
                          } else {
                              update[astr + '.' + valueName] = (changeTypes[idx] & UNSET) ? null : nestedProperty(arr[idx], valueName).get();
                          }
                      }
                  } else {
                      update[astr] = null;
                  }
              }
  
              return update;
          }
      };
  
      return obj;
  };
  
  },{"./nested_property":758}],753:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Registry = _dereq_('../registry');
  
  /**
   * localize: translate a string for the current locale
   *
   * @param {object} gd: the graphDiv for context
   *  gd._context.locale determines the language (& optional region/country)
   *  the dictionary for each locale may either be supplied in
   *  gd._context.locales or globally via Plotly.register
   * @param {string} s: the string to translate
   */
  module.exports = function localize(gd, s) {
      var locale = gd._context.locale;
  
      /*
       * Priority of lookup:
       *     contextDicts[locale],
       *     registeredDicts[locale],
       *     contextDicts[baseLocale], (if baseLocale is distinct)
       *     registeredDicts[baseLocale]
       * Return the first translation we find.
       * This way if you have a regionalization you are allowed to specify
       * only what's different from the base locale, everything else will
       * fall back on the base.
       */
      for(var i = 0; i < 2; i++) {
          var locales = gd._context.locales;
          for(var j = 0; j < 2; j++) {
              var dict = (locales[locale] || {}).dictionary;
              if(dict) {
                  var out = dict[s];
                  if(out) return out;
              }
              locales = Registry.localeRegistry;
          }
  
          var baseLocale = locale.split('-')[0];
          if(baseLocale === locale) break;
          locale = baseLocale;
      }
  
      return s;
  };
  
  },{"../registry":882}],754:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /* eslint-disable no-console */
  
  var dfltConfig = _dereq_('../plot_api/plot_config').dfltConfig;
  
  var notifier = _dereq_('./notifier');
  
  var loggers = module.exports = {};
  
  /**
   * ------------------------------------------
   * debugging tools
   * ------------------------------------------
   */
  
  loggers.log = function() {
      var i;
  
      if(dfltConfig.logging > 1) {
          var messages = ['LOG:'];
          for(i = 0; i < arguments.length; i++) {
              messages.push(arguments[i]);
          }
          apply(console.trace || console.log, messages);
      }
  
      if(dfltConfig.notifyOnLogging > 1) {
          var lines = [];
          for(i = 0; i < arguments.length; i++) {
              lines.push(arguments[i]);
          }
          notifier(lines.join('<br>'), 'long');
      }
  };
  
  loggers.warn = function() {
      var i;
  
      if(dfltConfig.logging > 0) {
          var messages = ['WARN:'];
          for(i = 0; i < arguments.length; i++) {
              messages.push(arguments[i]);
          }
          apply(console.trace || console.log, messages);
      }
  
      if(dfltConfig.notifyOnLogging > 0) {
          var lines = [];
          for(i = 0; i < arguments.length; i++) {
              lines.push(arguments[i]);
          }
          notifier(lines.join('<br>'), 'stick');
      }
  };
  
  loggers.error = function() {
      var i;
  
      if(dfltConfig.logging > 0) {
          var messages = ['ERROR:'];
          for(i = 0; i < arguments.length; i++) {
              messages.push(arguments[i]);
          }
          apply(console.error, messages);
      }
  
      if(dfltConfig.notifyOnLogging > 0) {
          var lines = [];
          for(i = 0; i < arguments.length; i++) {
              lines.push(arguments[i]);
          }
          notifier(lines.join('<br>'), 'stick');
      }
  };
  
  /*
   * Robust apply, for IE9 where console.log doesn't support
   * apply like other functions do
   */
  function apply(f, args) {
      if(f && f.apply) {
          try {
              // `this` should always be console, since here we're always
              // applying a method of the console object.
              f.apply(console, args);
              return;
          } catch(e) { /* in case apply failed, fall back on the code below */ }
      }
  
      // no apply - just try calling the function on each arg independently
      for(var i = 0; i < args.length; i++) {
          try {
              f(args[i]);
          } catch(e) {
              // still fails - last resort simple console.log
              console.log(args[i]);
          }
      }
  }
  
  },{"../plot_api/plot_config":786,"./notifier":760}],755:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  /**
   * General helper to manage trace groups based on calcdata
   *
   * @param {d3.selection} traceLayer: a selection containing a single group
   *     to draw these traces into
   * @param {array} cdModule: array of calcdata items for this
   *     module and subplot combination. Assumes the calcdata item for each
   *     trace is an array with the fullData trace attached to the first item.
   * @param {string} cls: the class attribute to give each trace group
   *     so you can give multiple classes separated by spaces
   */
  module.exports = function makeTraceGroups(traceLayer, cdModule, cls) {
      var traces = traceLayer.selectAll('g.' + cls.replace(/\s/g, '.'))
          .data(cdModule, function(cd) { return cd[0].trace.uid; });
  
      traces.exit().remove();
  
      traces.enter().append('g')
          .attr('class', cls);
  
      traces.order();
  
      // stash ref node to trace group in calcdata,
      // useful for (fast) styleOnSelect
      var k = traceLayer.classed('rangeplot') ? 'nodeRangePlot3' : 'node3';
      traces.each(function(cd) { cd[0][k] = d3.select(this); });
  
      return traces;
  };
  
  },{"d3":169}],756:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  exports.init2dArray = function(rowLength, colLength) {
      var array = new Array(rowLength);
      for(var i = 0; i < rowLength; i++) array[i] = new Array(colLength);
      return array;
  };
  
  /**
   * transpose a (possibly ragged) 2d array z. inspired by
   * http://stackoverflow.com/questions/17428587/
   * transposing-a-2d-array-in-javascript
   */
  exports.transposeRagged = function(z) {
      var maxlen = 0;
      var zlen = z.length;
      var i, j;
      // Maximum row length:
      for(i = 0; i < zlen; i++) maxlen = Math.max(maxlen, z[i].length);
  
      var t = new Array(maxlen);
      for(i = 0; i < maxlen; i++) {
          t[i] = new Array(zlen);
          for(j = 0; j < zlen; j++) t[i][j] = z[j][i];
      }
  
      return t;
  };
  
  // our own dot function so that we don't need to include numeric
  exports.dot = function(x, y) {
      if(!(x.length && y.length) || x.length !== y.length) return null;
  
      var len = x.length;
      var out;
      var i;
  
      if(x[0].length) {
          // mat-vec or mat-mat
          out = new Array(len);
          for(i = 0; i < len; i++) out[i] = exports.dot(x[i], y);
      } else if(y[0].length) {
          // vec-mat
          var yTranspose = exports.transposeRagged(y);
          out = new Array(yTranspose.length);
          for(i = 0; i < yTranspose.length; i++) out[i] = exports.dot(x, yTranspose[i]);
      } else {
          // vec-vec
          out = 0;
          for(i = 0; i < len; i++) out += x[i] * y[i];
      }
  
      return out;
  };
  
  // translate by (x,y)
  exports.translationMatrix = function(x, y) {
      return [[1, 0, x], [0, 1, y], [0, 0, 1]];
  };
  
  // rotate by alpha around (0,0)
  exports.rotationMatrix = function(alpha) {
      var a = alpha * Math.PI / 180;
      return [[Math.cos(a), -Math.sin(a), 0],
              [Math.sin(a), Math.cos(a), 0],
              [0, 0, 1]];
  };
  
  // rotate by alpha around (x,y)
  exports.rotationXYMatrix = function(a, x, y) {
      return exports.dot(
          exports.dot(exports.translationMatrix(x, y),
                      exports.rotationMatrix(a)),
          exports.translationMatrix(-x, -y));
  };
  
  // applies a 2D transformation matrix to either x and y params or an [x,y] array
  exports.apply2DTransform = function(transform) {
      return function() {
          var args = arguments;
          if(args.length === 3) {
              args = args[0];
          }// from map
          var xy = arguments.length === 1 ? args[0] : [args[0], args[1]];
          return exports.dot(transform, [xy[0], xy[1], 1]).slice(0, 2);
      };
  };
  
  // applies a 2D transformation matrix to an [x1,y1,x2,y2] array (to transform a segment)
  exports.apply2DTransform2 = function(transform) {
      var at = exports.apply2DTransform(transform);
      return function(xys) {
          return at(xys.slice(0, 2)).concat(at(xys.slice(2, 4)));
      };
  };
  
  },{}],757:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /**
   * sanitized modulus function that always returns in the range [0, d)
   * rather than (-d, 0] if v is negative
   */
  function mod(v, d) {
      var out = v % d;
      return out < 0 ? out + d : out;
  }
  
  /**
   * sanitized modulus function that always returns in the range [-d/2, d/2]
   * rather than (-d, 0] if v is negative
   */
  function modHalf(v, d) {
      return Math.abs(v) > (d / 2) ?
          v - Math.round(v / d) * d :
          v;
  }
  
  module.exports = {
      mod: mod,
      modHalf: modHalf
  };
  
  },{}],758:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
  
  /**
   * convert a string s (such as 'xaxis.range[0]')
   * representing a property of nested object into set and get methods
   * also return the string and object so we don't have to keep track of them
   * allows [-1] for an array index, to set a property inside all elements
   * of an array
   * eg if obj = {arr: [{a: 1}, {a: 2}]}
   * you can do p = nestedProperty(obj, 'arr[-1].a')
   * but you cannot set the array itself this way, to do that
   * just set the whole array.
   * eg if obj = {arr: [1, 2, 3]}
   * you can't do nestedProperty(obj, 'arr[-1]').set(5)
   * but you can do nestedProperty(obj, 'arr').set([5, 5, 5])
   */
  module.exports = function nestedProperty(container, propStr) {
      if(isNumeric(propStr)) propStr = String(propStr);
      else if(typeof propStr !== 'string' ||
              propStr.substr(propStr.length - 4) === '[-1]') {
          throw 'bad property string';
      }
  
      var j = 0;
      var propParts = propStr.split('.');
      var indexed;
      var indices;
      var i;
  
      // check for parts of the nesting hierarchy that are numbers (ie array elements)
      while(j < propParts.length) {
          // look for non-bracket chars, then any number of [##] blocks
          indexed = String(propParts[j]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/);
          if(indexed) {
              if(indexed[1]) propParts[j] = indexed[1];
              // allow propStr to start with bracketed array indices
              else if(j === 0) propParts.splice(0, 1);
              else throw 'bad property string';
  
              indices = indexed[2]
                  .substr(1, indexed[2].length - 2)
                  .split('][');
  
              for(i = 0; i < indices.length; i++) {
                  j++;
                  propParts.splice(j, 0, Number(indices[i]));
              }
          }
          j++;
      }
  
      if(typeof container !== 'object') {
          return badContainer(container, propStr, propParts);
      }
  
      return {
          set: npSet(container, propParts, propStr),
          get: npGet(container, propParts),
          astr: propStr,
          parts: propParts,
          obj: container
      };
  };
  
  function npGet(cont, parts) {
      return function() {
          var curCont = cont;
          var curPart;
          var allSame;
          var out;
          var i;
          var j;
  
          for(i = 0; i < parts.length - 1; i++) {
              curPart = parts[i];
              if(curPart === -1) {
                  allSame = true;
                  out = [];
                  for(j = 0; j < curCont.length; j++) {
                      out[j] = npGet(curCont[j], parts.slice(i + 1))();
                      if(out[j] !== out[0]) allSame = false;
                  }
                  return allSame ? out[0] : out;
              }
              if(typeof curPart === 'number' && !isArrayOrTypedArray(curCont)) {
                  return undefined;
              }
              curCont = curCont[curPart];
              if(typeof curCont !== 'object' || curCont === null) {
                  return undefined;
              }
          }
  
          // only hit this if parts.length === 1
          if(typeof curCont !== 'object' || curCont === null) return undefined;
  
          out = curCont[parts[i]];
          if(out === null) return undefined;
          return out;
      };
  }
  
  /*
   * Can this value be deleted? We can delete `undefined`, and `null` except INSIDE an
   * *args* array.
   *
   * Previously we also deleted some `{}` and `[]`, in order to try and make set/unset
   * a net noop; but this causes far more complication than it's worth, and still had
   * lots of exceptions. See https://github.com/plotly/plotly.js/issues/1410
   *
   * *args* arrays get passed directly to API methods and we should respect null if
   * the user put it there, but otherwise null is deleted as we use it as code
   * in restyle/relayout/update for "delete this value" whereas undefined means
   * "ignore this edit"
   */
  var ARGS_PATTERN = /(^|\.)args\[/;
  function isDeletable(val, propStr) {
      return (val === undefined) || (val === null && !propStr.match(ARGS_PATTERN));
  }
  
  function npSet(cont, parts, propStr) {
      return function(val) {
          var curCont = cont;
          var propPart = '';
          var containerLevels = [[cont, propPart]];
          var toDelete = isDeletable(val, propStr);
          var curPart;
          var i;
  
          for(i = 0; i < parts.length - 1; i++) {
              curPart = parts[i];
  
              if(typeof curPart === 'number' && !isArrayOrTypedArray(curCont)) {
                  throw 'array index but container is not an array';
              }
  
              // handle special -1 array index
              if(curPart === -1) {
                  toDelete = !setArrayAll(curCont, parts.slice(i + 1), val, propStr);
                  if(toDelete) break;
                  else return;
              }
  
              if(!checkNewContainer(curCont, curPart, parts[i + 1], toDelete)) {
                  break;
              }
  
              curCont = curCont[curPart];
  
              if(typeof curCont !== 'object' || curCont === null) {
                  throw 'container is not an object';
              }
  
              propPart = joinPropStr(propPart, curPart);
  
              containerLevels.push([curCont, propPart]);
          }
  
          if(toDelete) {
              if(i === parts.length - 1) {
                  delete curCont[parts[i]];
  
                  // The one bit of pruning we still do: drop `undefined` from the end of arrays.
                  // In case someone has already unset previous items, continue until we hit a
                  // non-undefined value.
                  if(Array.isArray(curCont) && +parts[i] === curCont.length - 1) {
                      while(curCont.length && curCont[curCont.length - 1] === undefined) {
                          curCont.pop();
                      }
                  }
              }
          } else curCont[parts[i]] = val;
      };
  }
  
  function joinPropStr(propStr, newPart) {
      var toAdd = newPart;
      if(isNumeric(newPart)) toAdd = '[' + newPart + ']';
      else if(propStr) toAdd = '.' + newPart;
  
      return propStr + toAdd;
  }
  
  // handle special -1 array index
  function setArrayAll(containerArray, innerParts, val, propStr) {
      var arrayVal = isArrayOrTypedArray(val);
      var allSet = true;
      var thisVal = val;
      var thisPropStr = propStr.replace('-1', 0);
      var deleteThis = arrayVal ? false : isDeletable(val, thisPropStr);
      var firstPart = innerParts[0];
      var i;
  
      for(i = 0; i < containerArray.length; i++) {
          thisPropStr = propStr.replace('-1', i);
          if(arrayVal) {
              thisVal = val[i % val.length];
              deleteThis = isDeletable(thisVal, thisPropStr);
          }
          if(deleteThis) allSet = false;
          if(!checkNewContainer(containerArray, i, firstPart, deleteThis)) {
              continue;
          }
          npSet(containerArray[i], innerParts, propStr.replace('-1', i))(thisVal);
      }
      return allSet;
  }
  
  /**
   * make new sub-container as needed.
   * returns false if there's no container and none is needed
   * because we're only deleting an attribute
   */
  function checkNewContainer(container, part, nextPart, toDelete) {
      if(container[part] === undefined) {
          if(toDelete) return false;
  
          if(typeof nextPart === 'number') container[part] = [];
          else container[part] = {};
      }
      return true;
  }
  
  function badContainer(container, propStr, propParts) {
      return {
          set: function() { throw 'bad container'; },
          get: function() {},
          astr: propStr,
          parts: propParts,
          obj: container
      };
  }
  
  },{"./array":732,"fast-isnumeric":241}],759:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  // Simple helper functions
  // none of these need any external deps
  
  module.exports = function noop() {};
  
  },{}],760:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var NOTEDATA = [];
  
  /**
   * notifier
   * @param {String} text The person's user name
   * @param {Number} [delay=1000] The delay time in milliseconds
   *          or 'long' which provides 2000 ms delay time.
   * @return {undefined} this function does not return a value
   */
  module.exports = function(text, displayLength) {
      if(NOTEDATA.indexOf(text) !== -1) return;
  
      NOTEDATA.push(text);
  
      var ts = 1000;
      if(isNumeric(displayLength)) ts = displayLength;
      else if(displayLength === 'long') ts = 3000;
  
      var notifierContainer = d3.select('body')
          .selectAll('.plotly-notifier')
          .data([0]);
      notifierContainer.enter()
          .append('div')
          .classed('plotly-notifier', true);
  
      var notes = notifierContainer.selectAll('.notifier-note').data(NOTEDATA);
  
      function killNote(transition) {
          transition
              .duration(700)
              .style('opacity', 0)
              .each('end', function(thisText) {
                  var thisIndex = NOTEDATA.indexOf(thisText);
                  if(thisIndex !== -1) NOTEDATA.splice(thisIndex, 1);
                  d3.select(this).remove();
              });
      }
  
      notes.enter().append('div')
          .classed('notifier-note', true)
          .style('opacity', 0)
          .each(function(thisText) {
              var note = d3.select(this);
  
              note.append('button')
                  .classed('notifier-close', true)
                  .html('&times;')
                  .on('click', function() {
                      note.transition().call(killNote);
                  });
  
              var p = note.append('p');
              var lines = thisText.split(/<br\s*\/?>/g);
              for(var i = 0; i < lines.length; i++) {
                  if(i) p.append('br');
                  p.append('span').text(lines[i]);
              }
  
              if(displayLength === 'stick') {
                  note.transition()
                          .duration(350)
                          .style('opacity', 1);
              } else {
                  note.transition()
                          .duration(700)
                          .style('opacity', 1)
                      .transition()
                          .delay(ts)
                          .call(killNote);
              }
          });
  };
  
  },{"d3":169,"fast-isnumeric":241}],761:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var setCursor = _dereq_('./setcursor');
  
  var STASHATTR = 'data-savedcursor';
  var NO_CURSOR = '!!';
  
  /*
   * works with our CSS cursor classes (see css/_cursor.scss)
   * to override a previous cursor set on d3 single-element selections,
   * by moving the name of the original cursor to the data-savedcursor attr.
   * omit cursor to revert to the previously set value.
   */
  module.exports = function overrideCursor(el3, csr) {
      var savedCursor = el3.attr(STASHATTR);
      if(csr) {
          if(!savedCursor) {
              var classes = (el3.attr('class') || '').split(' ');
              for(var i = 0; i < classes.length; i++) {
                  var cls = classes[i];
                  if(cls.indexOf('cursor-') === 0) {
                      el3.attr(STASHATTR, cls.substr(7))
                          .classed(cls, false);
                  }
              }
              if(!el3.attr(STASHATTR)) {
                  el3.attr(STASHATTR, NO_CURSOR);
              }
          }
          setCursor(el3, csr);
      } else if(savedCursor) {
          el3.attr(STASHATTR, null);
  
          if(savedCursor === NO_CURSOR) setCursor(el3);
          else setCursor(el3, savedCursor);
      }
  };
  
  },{"./setcursor":770}],762:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var dot = _dereq_('./matrix').dot;
  var BADNUM = _dereq_('../constants/numerical').BADNUM;
  
  var polygon = module.exports = {};
  
  /**
   * Turn an array of [x, y] pairs into a polygon object
   * that can test if points are inside it
   *
   * @param ptsIn Array of [x, y] pairs
   *
   * @returns polygon Object {xmin, xmax, ymin, ymax, pts, contains}
   *      (x|y)(min|max) are the bounding rect of the polygon
   *      pts is the original array, with the first pair repeated at the end
   *      contains is a function: (pt, omitFirstEdge)
   *          pt is the [x, y] pair to test
   *          omitFirstEdge truthy means points exactly on the first edge don't
   *              count. This is for use adding one polygon to another so we
   *              don't double-count the edge where they meet.
   *          returns boolean: is pt inside the polygon (including on its edges)
   */
  polygon.tester = function tester(ptsIn) {
      var pts = ptsIn.slice();
      var xmin = pts[0][0];
      var xmax = xmin;
      var ymin = pts[0][1];
      var ymax = ymin;
      var i;
  
      pts.push(pts[0]);
      for(i = 1; i < pts.length; i++) {
          xmin = Math.min(xmin, pts[i][0]);
          xmax = Math.max(xmax, pts[i][0]);
          ymin = Math.min(ymin, pts[i][1]);
          ymax = Math.max(ymax, pts[i][1]);
      }
  
      // do we have a rectangle? Handle this here, so we can use the same
      // tester for the rectangular case without sacrificing speed
  
      var isRect = false;
      var rectFirstEdgeTest;
  
      if(pts.length === 5) {
          if(pts[0][0] === pts[1][0]) { // vert, horz, vert, horz
              if(pts[2][0] === pts[3][0] &&
                      pts[0][1] === pts[3][1] &&
                      pts[1][1] === pts[2][1]) {
                  isRect = true;
                  rectFirstEdgeTest = function(pt) { return pt[0] === pts[0][0]; };
              }
          } else if(pts[0][1] === pts[1][1]) { // horz, vert, horz, vert
              if(pts[2][1] === pts[3][1] &&
                      pts[0][0] === pts[3][0] &&
                      pts[1][0] === pts[2][0]) {
                  isRect = true;
                  rectFirstEdgeTest = function(pt) { return pt[1] === pts[0][1]; };
              }
          }
      }
  
      function rectContains(pt, omitFirstEdge) {
          var x = pt[0];
          var y = pt[1];
  
          if(x === BADNUM || x < xmin || x > xmax || y === BADNUM || y < ymin || y > ymax) {
              // pt is outside the bounding box of polygon
              return false;
          }
          if(omitFirstEdge && rectFirstEdgeTest(pt)) return false;
  
          return true;
      }
  
      function contains(pt, omitFirstEdge) {
          var x = pt[0];
          var y = pt[1];
  
          if(x === BADNUM || x < xmin || x > xmax || y === BADNUM || y < ymin || y > ymax) {
              // pt is outside the bounding box of polygon
              return false;
          }
  
          var imax = pts.length;
          var x1 = pts[0][0];
          var y1 = pts[0][1];
          var crossings = 0;
          var i;
          var x0;
          var y0;
          var xmini;
          var ycross;
  
          for(i = 1; i < imax; i++) {
              // find all crossings of a vertical line upward from pt with
              // polygon segments
              // crossings exactly at xmax don't count, unless the point is
              // exactly on the segment, then it counts as inside.
              x0 = x1;
              y0 = y1;
              x1 = pts[i][0];
              y1 = pts[i][1];
              xmini = Math.min(x0, x1);
  
              if(x < xmini || x > Math.max(x0, x1) || y > Math.max(y0, y1)) {
                  // outside the bounding box of this segment, it's only a crossing
                  // if it's below the box.
  
                  continue;
              } else if(y < Math.min(y0, y1)) {
                  // don't count the left-most point of the segment as a crossing
                  // because we don't want to double-count adjacent crossings
                  // UNLESS the polygon turns past vertical at exactly this x
                  // Note that this is repeated below, but we can't factor it out
                  // because
                  if(x !== xmini) crossings++;
              } else {
                  // inside the bounding box, check the actual line intercept
  
                  // vertical segment - we know already that the point is exactly
                  // on the segment, so mark the crossing as exactly at the point.
                  if(x1 === x0) ycross = y;
                  // any other angle
                  else ycross = y0 + (x - x0) * (y1 - y0) / (x1 - x0);
  
                  // exactly on the edge: counts as inside the polygon, unless it's the
                  // first edge and we're omitting it.
                  if(y === ycross) {
                      if(i === 1 && omitFirstEdge) return false;
                      return true;
                  }
  
                  if(y <= ycross && x !== xmini) crossings++;
              }
          }
  
          // if we've gotten this far, odd crossings means inside, even is outside
          return crossings % 2 === 1;
      }
  
      // detect if poly is degenerate
      var degenerate = true;
      var lastPt = pts[0];
      for(i = 1; i < pts.length; i++) {
          if(lastPt[0] !== pts[i][0] || lastPt[1] !== pts[i][1]) {
              degenerate = false;
              break;
          }
      }
  
      return {
          xmin: xmin,
          xmax: xmax,
          ymin: ymin,
          ymax: ymax,
          pts: pts,
          contains: isRect ? rectContains : contains,
          isRect: isRect,
          degenerate: degenerate
      };
  };
  
  /**
   * Test if a segment of a points array is bent or straight
   *
   * @param pts Array of [x, y] pairs
   * @param start the index of the proposed start of the straight section
   * @param end the index of the proposed end point
   * @param tolerance the max distance off the line connecting start and end
   *      before the line counts as bent
   * @returns boolean: true means this segment is bent, false means straight
   */
  polygon.isSegmentBent = function isSegmentBent(pts, start, end, tolerance) {
      var startPt = pts[start];
      var segment = [pts[end][0] - startPt[0], pts[end][1] - startPt[1]];
      var segmentSquared = dot(segment, segment);
      var segmentLen = Math.sqrt(segmentSquared);
      var unitPerp = [-segment[1] / segmentLen, segment[0] / segmentLen];
      var i;
      var part;
      var partParallel;
  
      for(i = start + 1; i < end; i++) {
          part = [pts[i][0] - startPt[0], pts[i][1] - startPt[1]];
          partParallel = dot(part, segment);
  
          if(partParallel < 0 || partParallel > segmentSquared ||
              Math.abs(dot(part, unitPerp)) > tolerance) return true;
      }
      return false;
  };
  
  /**
   * Make a filtering polygon, to minimize the number of segments
   *
   * @param pts Array of [x, y] pairs (must start with at least 1 pair)
   * @param tolerance the maximum deviation from straight allowed for
   *      removing points to simplify the polygon
   *
   * @returns Object {addPt, raw, filtered}
   *      addPt is a function(pt: [x, y] pair) to add a raw point and
   *          continue filtering
   *      raw is all the input points
   *      filtered is the resulting filtered Array of [x, y] pairs
   */
  polygon.filter = function filter(pts, tolerance) {
      var ptsFiltered = [pts[0]];
      var doneRawIndex = 0;
      var doneFilteredIndex = 0;
  
      function addPt(pt) {
          pts.push(pt);
          var prevFilterLen = ptsFiltered.length;
          var iLast = doneRawIndex;
          ptsFiltered.splice(doneFilteredIndex + 1);
  
          for(var i = iLast + 1; i < pts.length; i++) {
              if(i === pts.length - 1 || polygon.isSegmentBent(pts, iLast, i + 1, tolerance)) {
                  ptsFiltered.push(pts[i]);
                  if(ptsFiltered.length < prevFilterLen - 2) {
                      doneRawIndex = i;
                      doneFilteredIndex = ptsFiltered.length - 1;
                  }
                  iLast = i;
              }
          }
      }
  
      if(pts.length > 1) {
          var lastPt = pts.pop();
          addPt(lastPt);
      }
  
      return {
          addPt: addPt,
          raw: pts,
          filtered: ptsFiltered
      };
  };
  
  },{"../constants/numerical":725,"./matrix":756}],763:[function(_dereq_,module,exports){
  (function (global){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var showNoWebGlMsg = _dereq_('./show_no_webgl_msg');
  
  // Note that this module should be ONLY required into
  // files corresponding to regl trace modules
  // so that bundles with non-regl only don't include
  // regl and all its bytes.
  var createRegl = _dereq_('regl');
  
  /**
   * Idempotent version of createRegl. Create regl instances
   * in the correct canvases with the correct attributes and
   * options
   *
   * @param {DOM node or object} gd : graph div object
   * @param {array} extensions : list of extension to pass to createRegl
   *
   * @return {boolean} true if all createRegl calls succeeded, false otherwise
   */
  module.exports = function prepareRegl(gd, extensions) {
      var fullLayout = gd._fullLayout;
      var success = true;
  
      fullLayout._glcanvas.each(function(d) {
          if(d.regl) return;
          // only parcoords needs pick layer
          if(d.pick && !fullLayout._has('parcoords')) return;
  
          try {
              d.regl = createRegl({
                  canvas: this,
                  attributes: {
                      antialias: !d.pick,
                      preserveDrawingBuffer: true
                  },
                  pixelRatio: gd._context.plotGlPixelRatio || global.devicePixelRatio,
                  extensions: extensions || []
              });
          } catch(e) {
              success = false;
          }
  
          if(!d.regl) success = false;
  
          if(success) {
              this.addEventListener('webglcontextlost', function(event) {
                  if(gd && gd.emit) {
                      gd.emit('plotly_webglcontextlost', {
                          event: event,
                          layer: d.key
                      });
                  }
              }, false);
          }
      });
  
      if(!success) {
          showNoWebGlMsg({container: fullLayout._glcontainer.node()});
      }
      return success;
  };
  
  }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
  },{"./show_no_webgl_msg":771,"regl":512}],764:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /**
   * Push array with unique items
   *
   * Ignores falsy items, except 0 so we can use it to construct arrays of indices.
   *
   * @param {array} array
   *  array to be filled
   * @param {any} item
   *  item to be or not to be inserted
   * @return {array}
   *  ref to array (now possibly containing one more item)
   *
   */
  module.exports = function pushUnique(array, item) {
      if(item instanceof RegExp) {
          var itemStr = item.toString();
          for(var i = 0; i < array.length; i++) {
              if(array[i] instanceof RegExp && array[i].toString() === itemStr) {
                  return array;
              }
          }
          array.push(item);
      } else if((item || item === 0) && array.indexOf(item) === -1) array.push(item);
  
      return array;
  };
  
  },{}],765:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var dfltConfig = _dereq_('../plot_api/plot_config').dfltConfig;
  
  /**
   * Copy arg array *without* removing `undefined` values from objects.
   *
   * @param gd
   * @param args
   * @returns {Array}
   */
  function copyArgArray(gd, args) {
      var copy = [];
      var arg;
  
      for(var i = 0; i < args.length; i++) {
          arg = args[i];
  
          if(arg === gd) copy[i] = arg;
          else if(typeof arg === 'object') {
              copy[i] = Array.isArray(arg) ?
                  Lib.extendDeep([], arg) :
                  Lib.extendDeepAll({}, arg);
          } else copy[i] = arg;
      }
  
      return copy;
  }
  
  
  // -----------------------------------------------------
  // Undo/Redo queue for plots
  // -----------------------------------------------------
  
  
  var queue = {};
  
  // TODO: disable/enable undo and redo buttons appropriately
  
  /**
   * Add an item to the undoQueue for a graphDiv
   *
   * @param gd
   * @param undoFunc Function undo this operation
   * @param undoArgs Args to supply undoFunc with
   * @param redoFunc Function to redo this operation
   * @param redoArgs Args to supply redoFunc with
   */
  queue.add = function(gd, undoFunc, undoArgs, redoFunc, redoArgs) {
      var queueObj,
          queueIndex;
  
      // make sure we have the queue and our position in it
      gd.undoQueue = gd.undoQueue || {index: 0, queue: [], sequence: false};
      queueIndex = gd.undoQueue.index;
  
      // if we're already playing an undo or redo, or if this is an auto operation
      // (like pane resize... any others?) then we don't save this to the undo queue
      if(gd.autoplay) {
          if(!gd.undoQueue.inSequence) gd.autoplay = false;
          return;
      }
  
      // if we're not in a sequence or are just starting, we need a new queue item
      if(!gd.undoQueue.sequence || gd.undoQueue.beginSequence) {
          queueObj = {undo: {calls: [], args: []}, redo: {calls: [], args: []}};
          gd.undoQueue.queue.splice(queueIndex, gd.undoQueue.queue.length - queueIndex, queueObj);
          gd.undoQueue.index += 1;
      } else {
          queueObj = gd.undoQueue.queue[queueIndex - 1];
      }
      gd.undoQueue.beginSequence = false;
  
      // we unshift to handle calls for undo in a forward for loop later
      if(queueObj) {
          queueObj.undo.calls.unshift(undoFunc);
          queueObj.undo.args.unshift(undoArgs);
          queueObj.redo.calls.push(redoFunc);
          queueObj.redo.args.push(redoArgs);
      }
  
      if(gd.undoQueue.queue.length > dfltConfig.queueLength) {
          gd.undoQueue.queue.shift();
          gd.undoQueue.index--;
      }
  };
  
  /**
   * Begin a sequence of undoQueue changes
   *
   * @param gd
   */
  queue.startSequence = function(gd) {
      gd.undoQueue = gd.undoQueue || {index: 0, queue: [], sequence: false};
      gd.undoQueue.sequence = true;
      gd.undoQueue.beginSequence = true;
  };
  
  /**
   * Stop a sequence of undoQueue changes
   *
   * Call this *after* you're sure your undo chain has ended
   *
   * @param gd
   */
  queue.stopSequence = function(gd) {
      gd.undoQueue = gd.undoQueue || {index: 0, queue: [], sequence: false};
      gd.undoQueue.sequence = false;
      gd.undoQueue.beginSequence = false;
  };
  
  /**
   * Move one step back in the undo queue, and undo the object there.
   *
   * @param gd
   */
  queue.undo = function undo(gd) {
      var queueObj, i;
  
      if(gd.framework && gd.framework.isPolar) {
          gd.framework.undo();
          return;
      }
      if(gd.undoQueue === undefined ||
              isNaN(gd.undoQueue.index) ||
              gd.undoQueue.index <= 0) {
          return;
      }
  
      // index is pointing to next *forward* queueObj, point to the one we're undoing
      gd.undoQueue.index--;
  
      // get the queueObj for instructions on how to undo
      queueObj = gd.undoQueue.queue[gd.undoQueue.index];
  
      // this sequence keeps things from adding to the queue during undo/redo
      gd.undoQueue.inSequence = true;
      for(i = 0; i < queueObj.undo.calls.length; i++) {
          queue.plotDo(gd, queueObj.undo.calls[i], queueObj.undo.args[i]);
      }
      gd.undoQueue.inSequence = false;
      gd.autoplay = false;
  };
  
  /**
   * Redo the current object in the undo, then move forward in the queue.
   *
   * @param gd
   */
  queue.redo = function redo(gd) {
      var queueObj, i;
  
      if(gd.framework && gd.framework.isPolar) {
          gd.framework.redo();
          return;
      }
      if(gd.undoQueue === undefined ||
              isNaN(gd.undoQueue.index) ||
              gd.undoQueue.index >= gd.undoQueue.queue.length) {
          return;
      }
  
      // get the queueObj for instructions on how to undo
      queueObj = gd.undoQueue.queue[gd.undoQueue.index];
  
      // this sequence keeps things from adding to the queue during undo/redo
      gd.undoQueue.inSequence = true;
      for(i = 0; i < queueObj.redo.calls.length; i++) {
          queue.plotDo(gd, queueObj.redo.calls[i], queueObj.redo.args[i]);
      }
      gd.undoQueue.inSequence = false;
      gd.autoplay = false;
  
      // index is pointing to the thing we just redid, move it
      gd.undoQueue.index++;
  };
  
  /**
   * Called by undo/redo to make the actual changes.
   *
   * Not meant to be called publically, but included for mocking out in tests.
   *
   * @param gd
   * @param func
   * @param args
   */
  queue.plotDo = function(gd, func, args) {
      gd.autoplay = true;
  
      // this *won't* copy gd and it preserves `undefined` properties!
      args = copyArgArray(gd, args);
  
      // call the supplied function
      func.apply(null, args);
  };
  
  module.exports = queue;
  
  },{"../lib":750,"../plot_api/plot_config":786}],766:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /*
   * make a regex for matching counter ids/names ie xaxis, xaxis2, xaxis10...
   *
   * @param {string} head: the head of the pattern, eg 'x' matches 'x', 'x2', 'x10' etc.
   *      'xy' is a special case for cartesian subplots: it matches 'x2y3' etc
   * @param {Optional(string)} tail: a fixed piece after the id
   *      eg counterRegex('scene', '.annotations') for scene2.annotations etc.
   * @param {boolean} openEnded: if true, the string may continue past the match.
   * @param {boolean} matchBeginning: if false, the string may start before the match.
   */
  exports.counter = function(head, tail, openEnded, matchBeginning) {
      var fullTail = (tail || '') + (openEnded ? '' : '$');
      var startWithPrefix = matchBeginning === false ? '' : '^';
      if(head === 'xy') {
          return new RegExp(startWithPrefix + 'x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?' + fullTail);
      }
      return new RegExp(startWithPrefix + head + '([2-9]|[1-9][0-9]+)?' + fullTail);
  };
  
  },{}],767:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  // ASCEND: chop off the last nesting level - either [<n>] or .<key> - to ascend
  // the attribute tree. the remaining attrString is in match[1]
  var ASCEND = /^(.*)(\.[^\.\[\]]+|\[\d\])$/;
  
  // SIMPLEATTR: is this an un-nested attribute? (no dots or brackets)
  var SIMPLEATTR = /^[^\.\[\]]+$/;
  
  /*
   * calculate a relative attribute string, similar to a relative path
   *
   * @param {string} baseAttr:
   *   an attribute string, such as 'annotations[3].x'. The "current location"
   *   is the attribute string minus the last component ('annotations[3]')
   * @param {string} relativeAttr:
   *   a route to the desired attribute string, using '^' to ascend
   *
   * @return {string} attrString:
   *   for example:
   *     relativeAttr('annotations[3].x', 'y') = 'annotations[3].y'
   *     relativeAttr('annotations[3].x', '^[2].z') = 'annotations[2].z'
   *     relativeAttr('annotations[3].x', '^^margin') = 'margin'
   *     relativeAttr('annotations[3].x', '^^margin.r') = 'margin.r'
   */
  module.exports = function(baseAttr, relativeAttr) {
      while(relativeAttr) {
          var match = baseAttr.match(ASCEND);
  
          if(match) baseAttr = match[1];
          else if(baseAttr.match(SIMPLEATTR)) baseAttr = '';
          else throw new Error('bad relativeAttr call:' + [baseAttr, relativeAttr]);
  
          if(relativeAttr.charAt(0) === '^') relativeAttr = relativeAttr.slice(1);
          else break;
      }
  
      if(baseAttr && relativeAttr.charAt(0) !== '[') {
          return baseAttr + '.' + relativeAttr;
      }
      return baseAttr + relativeAttr;
  };
  
  },{}],768:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
  var isPlainObject = _dereq_('./is_plain_object');
  
  /**
   * Relink private _keys and keys with a function value from one container
   * to the new container.
   * Relink means copying if object is pass-by-value and adding a reference
   * if object is pass-by-ref.
   * This prevents deepCopying massive structures like a webgl context.
   */
  module.exports = function relinkPrivateKeys(toContainer, fromContainer) {
      for(var k in fromContainer) {
          var fromVal = fromContainer[k];
          var toVal = toContainer[k];
  
          if(toVal === fromVal) continue;
  
          if(k.charAt(0) === '_' || typeof fromVal === 'function') {
              // if it already exists at this point, it's something
              // that we recreate each time around, so ignore it
              if(k in toContainer) continue;
  
              toContainer[k] = fromVal;
          } else if(isArrayOrTypedArray(fromVal) && isArrayOrTypedArray(toVal) && isPlainObject(fromVal[0])) {
              // filter out data_array items that can contain user objects
              // most of the time the toVal === fromVal check will catch these early
              // but if the user makes new ones we also don't want to recurse in.
              if(k === 'customdata' || k === 'ids') continue;
  
              // recurse into arrays containers
              var minLen = Math.min(fromVal.length, toVal.length);
              for(var j = 0; j < minLen; j++) {
                  if((toVal[j] !== fromVal[j]) && isPlainObject(fromVal[j]) && isPlainObject(toVal[j])) {
                      relinkPrivateKeys(toVal[j], fromVal[j]);
                  }
              }
          } else if(isPlainObject(fromVal) && isPlainObject(toVal)) {
              // recurse into objects, but only if they still exist
              relinkPrivateKeys(toVal, fromVal);
  
              if(!Object.keys(toVal).length) delete toContainer[k];
          }
      }
  };
  
  },{"./array":732,"./is_plain_object":751}],769:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var loggers = _dereq_('./loggers');
  var identity = _dereq_('./identity');
  var BADNUM = _dereq_('../constants/numerical').BADNUM;
  
  // don't trust floating point equality - fraction of bin size to call
  // "on the line" and ensure that they go the right way specified by
  // linelow
  var roundingError = 1e-9;
  
  
  /**
   * findBin - find the bin for val - note that it can return outside the
   * bin range any pos. or neg. integer for linear bins, or -1 or
   * bins.length-1 for explicit.
   * bins is either an object {start,size,end} or an array length #bins+1
   * bins can be either increasing or decreasing but must be monotonic
   * for linear bins, we can just calculate. For listed bins, run a binary
   * search linelow (truthy) says the bin boundary should be attributed to
   * the lower bin rather than the default upper bin
   */
  exports.findBin = function(val, bins, linelow) {
      if(isNumeric(bins.start)) {
          return linelow ?
              Math.ceil((val - bins.start) / bins.size - roundingError) - 1 :
              Math.floor((val - bins.start) / bins.size + roundingError);
      } else {
          var n1 = 0;
          var n2 = bins.length;
          var c = 0;
          var binSize = (n2 > 1) ? (bins[n2 - 1] - bins[0]) / (n2 - 1) : 1;
          var n, test;
          if(binSize >= 0) {
              test = linelow ? lessThan : lessOrEqual;
          } else {
              test = linelow ? greaterOrEqual : greaterThan;
          }
          val += binSize * roundingError * (linelow ? -1 : 1) * (binSize >= 0 ? 1 : -1);
          // c is just to avoid infinite loops if there's an error
          while(n1 < n2 && c++ < 100) {
              n = Math.floor((n1 + n2) / 2);
              if(test(bins[n], val)) n1 = n + 1;
              else n2 = n;
          }
          if(c > 90) loggers.log('Long binary search...');
          return n1 - 1;
      }
  };
  
  function lessThan(a, b) { return a < b; }
  function lessOrEqual(a, b) { return a <= b; }
  function greaterThan(a, b) { return a > b; }
  function greaterOrEqual(a, b) { return a >= b; }
  
  exports.sorterAsc = function(a, b) { return a - b; };
  exports.sorterDes = function(a, b) { return b - a; };
  
  /**
   * find distinct values in an array, lumping together ones that appear to
   * just be off by a rounding error
   * return the distinct values and the minimum difference between any two
   */
  exports.distinctVals = function(valsIn, opts) {
      var unitMinDiff = (opts || {}).unitMinDiff;
  
      var vals = valsIn.slice();  // otherwise we sort the original array...
      vals.sort(exports.sorterAsc); // undefined listed in the end - also works on IE11
  
      var last;
      for(last = vals.length - 1; last > -1; last--) {
          if(vals[last] !== BADNUM) break;
      }
  
      var minDiff = 1;
      if(!unitMinDiff) minDiff = (vals[last] - vals[0]) || 1;
  
      var errDiff = minDiff / (last || 1) / 10000;
      var newVals = [];
      var preV;
      for(var i = 0; i <= last; i++) {
          var v = vals[i];
  
          // make sure values aren't just off by a rounding error
          var diff = v - preV;
  
          if(preV === undefined) {
              newVals.push(v);
              preV = v;
          } else if(diff > errDiff) {
              minDiff = Math.min(minDiff, diff);
  
              newVals.push(v);
              preV = v;
          }
      }
  
      return {vals: newVals, minDiff: minDiff};
  };
  
  /**
   * return the smallest element from (sorted) array arrayIn that's bigger than val,
   * or (reverse) the largest element smaller than val
   * used to find the best tick given the minimum (non-rounded) tick
   * particularly useful for date/time where things are not powers of 10
   * binary search is probably overkill here...
   */
  exports.roundUp = function(val, arrayIn, reverse) {
      var low = 0;
      var high = arrayIn.length - 1;
      var mid;
      var c = 0;
      var dlow = reverse ? 0 : 1;
      var dhigh = reverse ? 1 : 0;
      var rounded = reverse ? Math.ceil : Math.floor;
      // c is just to avoid infinite loops if there's an error
      while(low < high && c++ < 100) {
          mid = rounded((low + high) / 2);
          if(arrayIn[mid] <= val) low = mid + dlow;
          else high = mid - dhigh;
      }
      return arrayIn[low];
  };
  
  /**
   * Tweak to Array.sort(sortFn) that improves performance for pre-sorted arrays
   *
   * Note that newer browsers (such as Chrome v70+) are starting to pick up
   * on pre-sorted arrays which may render the following optimization unnecessary
   * in the future.
   *
   * Motivation: sometimes we need to sort arrays but the input is likely to
   * already be sorted. Browsers don't seem to pick up on pre-sorted arrays,
   * and in fact Chrome is actually *slower* sorting pre-sorted arrays than purely
   * random arrays. FF is at least faster if the array is pre-sorted, but still
   * not as fast as it could be.
   * Here's how this plays out sorting a length-1e6 array:
   *
   * Calls to Sort FN  |  Chrome bare  |  FF bare  |  Chrome tweak  |  FF tweak
   *                   |  v68.0 Mac    |  v61.0 Mac|                |
   * ------------------+---------------+-----------+----------------+------------
   * ordered           |  30.4e6       |  10.1e6   |  1e6           |  1e6
   * reversed          |  29.4e6       |  9.9e6    |  1e6 + reverse |  1e6 + reverse
   * random            |  ~21e6        |  ~18.7e6  |  ~21e6         |  ~18.7e6
   *
   * So this is a substantial win for pre-sorted (ordered or exactly reversed)
   * arrays. Including this wrapper on an unsorted array adds a penalty that will
   * in general be only a few calls to the sort function. The only case this
   * penalty will be significant is if the array is mostly sorted but there are
   * a few unsorted items near the end, but the penalty is still at most N calls
   * out of (for N=1e6) ~20N total calls
   *
   * @param {Array} array: the array, to be sorted in place
   * @param {function} sortFn: As in Array.sort, function(a, b) that puts
   *     item a before item b if the return is negative, a after b if positive,
   *     and no change if zero.
   * @return {Array}: the original array, sorted in place.
   */
  exports.sort = function(array, sortFn) {
      var notOrdered = 0;
      var notReversed = 0;
      for(var i = 1; i < array.length; i++) {
          var pairOrder = sortFn(array[i], array[i - 1]);
          if(pairOrder < 0) notOrdered = 1;
          else if(pairOrder > 0) notReversed = 1;
          if(notOrdered && notReversed) return array.sort(sortFn);
      }
      return notReversed ? array : array.reverse();
  };
  
  /**
   * find index in array 'arr' that minimizes 'fn'
   *
   * @param {array} arr : array where to search
   * @param {fn (optional)} fn : function to minimize,
   *   if not given, fn is the identity function
   * @return {integer}
   */
  exports.findIndexOfMin = function(arr, fn) {
      fn = fn || identity;
  
      var min = Infinity;
      var ind;
  
      for(var i = 0; i < arr.length; i++) {
          var v = fn(arr[i]);
          if(v < min) {
              min = v;
              ind = i;
          }
      }
      return ind;
  };
  
  },{"../constants/numerical":725,"./identity":748,"./loggers":754,"fast-isnumeric":241}],770:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  // works with our CSS cursor classes (see css/_cursor.scss)
  // to apply cursors to d3 single-element selections.
  // omit cursor to revert to the default.
  module.exports = function setCursor(el3, csr) {
      (el3.attr('class') || '').split(' ').forEach(function(cls) {
          if(cls.indexOf('cursor-') === 0) el3.classed(cls, false);
      });
  
      if(csr) el3.classed('cursor-' + csr, true);
  };
  
  },{}],771:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Color = _dereq_('../components/color');
  
  var noop = function() {};
  
  
  /**
   * Prints a no webgl error message into the scene container
   * @param {scene instance} scene
   *
   * Expects 'scene' to have property 'container'
   *
   */
  module.exports = function showNoWebGlMsg(scene) {
      for(var prop in scene) {
          if(typeof scene[prop] === 'function') scene[prop] = noop;
      }
  
      scene.destroy = function() {
          scene.container.parentNode.removeChild(scene.container);
      };
  
      var div = document.createElement('div');
      div.className = 'no-webgl';
      div.style.cursor = 'pointer';
      div.style.fontSize = '24px';
      div.style.color = Color.defaults[0];
      div.style.position = 'absolute';
      div.style.left = div.style.top = '0px';
      div.style.width = div.style.height = '100%';
      div.style['background-color'] = Color.lightLine;
      div.style['z-index'] = 30;
  
      var p = document.createElement('p');
      p.textContent = 'WebGL is not supported by your browser - visit https://get.webgl.org for more info';
      p.style.position = 'relative';
      p.style.top = '50%';
      p.style.left = '50%';
      p.style.height = '30%';
      p.style.width = '50%';
      p.style.margin = '-15% 0 0 -25%';
  
      div.appendChild(p);
      scene.container.appendChild(div);
      scene.container.style.background = '#FFFFFF';
      scene.container.onclick = function() {
          window.open('https://get.webgl.org');
      };
  
      // return before setting up camera and onrender methods
      return false;
  };
  
  },{"../components/color":615}],772:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var isArrayOrTypedArray = _dereq_('./array').isArrayOrTypedArray;
  
  /**
   * aggNums() returns the result of an aggregate function applied to an array of
   * values, where non-numerical values have been tossed out.
   *
   * @param {function} f - aggregation function (e.g., Math.min)
   * @param {Number} v - initial value (continuing from previous calls)
   *      if there's no continuing value, use null for selector-type
   *      functions (max,min), or 0 for summations
   * @param {Array} a - array to aggregate (may be nested, we will recurse,
   *                    but all elements must have the same dimension)
   * @param {Number} len - maximum length of a to aggregate
   * @return {Number} - result of f applied to a starting from v
   */
  exports.aggNums = function(f, v, a, len) {
      var i,
          b;
      if(!len || len > a.length) len = a.length;
      if(!isNumeric(v)) v = false;
      if(isArrayOrTypedArray(a[0])) {
          b = new Array(len);
          for(i = 0; i < len; i++) b[i] = exports.aggNums(f, v, a[i]);
          a = b;
      }
  
      for(i = 0; i < len; i++) {
          if(!isNumeric(v)) v = a[i];
          else if(isNumeric(a[i])) v = f(+v, +a[i]);
      }
      return v;
  };
  
  /**
   * mean & std dev functions using aggNums, so it handles non-numerics nicely
   * even need to use aggNums instead of .length, to toss out non-numerics
   */
  exports.len = function(data) {
      return exports.aggNums(function(a) { return a + 1; }, 0, data);
  };
  
  exports.mean = function(data, len) {
      if(!len) len = exports.len(data);
      return exports.aggNums(function(a, b) { return a + b; }, 0, data) / len;
  };
  
  exports.midRange = function(numArr) {
      if(numArr === undefined || numArr.length === 0) return undefined;
      return (exports.aggNums(Math.max, null, numArr) + exports.aggNums(Math.min, null, numArr)) / 2;
  };
  
  exports.variance = function(data, len, mean) {
      if(!len) len = exports.len(data);
      if(!isNumeric(mean)) mean = exports.mean(data, len);
  
      return exports.aggNums(function(a, b) {
          return a + Math.pow(b - mean, 2);
      }, 0, data) / len;
  };
  
  exports.stdev = function(data, len, mean) {
      return Math.sqrt(exports.variance(data, len, mean));
  };
  
  /**
   * median of a finite set of numbers
   * reference page: https://en.wikipedia.org/wiki/Median#Finite_set_of_numbers
  **/
  exports.median = function(data) {
      var b = data.slice().sort();
      return exports.interp(b, 0.5);
  };
  
  /**
   * interp() computes a percentile (quantile) for a given distribution.
   * We interpolate the distribution (to compute quantiles, we follow method #10 here:
   * http://www.amstat.org/publications/jse/v14n3/langford.html).
   * Typically the index or rank (n * arr.length) may be non-integer.
   * For reference: ends are clipped to the extreme values in the array;
   * For box plots: index you get is half a point too high (see
   * http://en.wikipedia.org/wiki/Percentile#Nearest_rank) but note that this definition
   * indexes from 1 rather than 0, so we subtract 1/2 (instead of add).
   *
   * @param {Array} arr - This array contains the values that make up the distribution.
   * @param {Number} n - Between 0 and 1, n = p/100 is such that we compute the p^th percentile.
   * For example, the 50th percentile (or median) corresponds to n = 0.5
   * @return {Number} - percentile
   */
  exports.interp = function(arr, n) {
      if(!isNumeric(n)) throw 'n should be a finite number';
      n = n * arr.length - 0.5;
      if(n < 0) return arr[0];
      if(n > arr.length - 1) return arr[arr.length - 1];
      var frac = n % 1;
      return frac * arr[Math.ceil(n)] + (1 - frac) * arr[Math.floor(n)];
  };
  
  },{"./array":732,"fast-isnumeric":241}],773:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var rgba = _dereq_('color-normalize');
  
  function str2RgbaArray(color) {
      if(!color) return [0, 0, 0, 1];
      return rgba(color);
  }
  
  module.exports = str2RgbaArray;
  
  },{"color-normalize":125}],774:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  /* global MathJax:false */
  
  var d3 = _dereq_('d3');
  
  var Lib = _dereq_('../lib');
  var xmlnsNamespaces = _dereq_('../constants/xmlns_namespaces');
  var LINE_SPACING = _dereq_('../constants/alignment').LINE_SPACING;
  
  // text converter
  
  function getSize(_selection, _dimension) {
      return _selection.node().getBoundingClientRect()[_dimension];
  }
  
  var FIND_TEX = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
  
  exports.convertToTspans = function(_context, gd, _callback) {
      var str = _context.text();
  
      // Until we get tex integrated more fully (so it can be used along with non-tex)
      // allow some elements to prohibit it by attaching 'data-notex' to the original
      var tex = (!_context.attr('data-notex')) &&
          (typeof MathJax !== 'undefined') &&
          str.match(FIND_TEX);
  
      var parent = d3.select(_context.node().parentNode);
      if(parent.empty()) return;
      var svgClass = (_context.attr('class')) ? _context.attr('class').split(' ')[0] : 'text';
      svgClass += '-math';
      parent.selectAll('svg.' + svgClass).remove();
      parent.selectAll('g.' + svgClass + '-group').remove();
      _context.style('display', null)
          .attr({
              // some callers use data-unformatted *from the <text> element* in 'cancel'
              // so we need it here even if we're going to turn it into math
              // these two (plus style and text-anchor attributes) form the key we're
              // going to use for Drawing.bBox
              'data-unformatted': str,
              'data-math': 'N'
          });
  
      function showText() {
          if(!parent.empty()) {
              svgClass = _context.attr('class') + '-math';
              parent.select('svg.' + svgClass).remove();
          }
          _context.text('')
              .style('white-space', 'pre');
  
          var hasLink = buildSVGText(_context.node(), str);
  
          if(hasLink) {
              // at least in Chrome, pointer-events does not seem
              // to be honored in children of <text> elements
              // so if we have an anchor, we have to make the
              // whole element respond
              _context.style('pointer-events', 'all');
          }
  
          exports.positionText(_context);
  
          if(_callback) _callback.call(_context);
      }
  
      if(tex) {
          ((gd && gd._promises) || []).push(new Promise(function(resolve) {
              _context.style('display', 'none');
              var fontSize = parseInt(_context.node().style.fontSize, 10);
              var config = {fontSize: fontSize};
  
              texToSVG(tex[2], config, function(_svgEl, _glyphDefs, _svgBBox) {
                  parent.selectAll('svg.' + svgClass).remove();
                  parent.selectAll('g.' + svgClass + '-group').remove();
  
                  var newSvg = _svgEl && _svgEl.select('svg');
                  if(!newSvg || !newSvg.node()) {
                      showText();
                      resolve();
                      return;
                  }
  
                  var mathjaxGroup = parent.append('g')
                      .classed(svgClass + '-group', true)
                      .attr({
                          'pointer-events': 'none',
                          'data-unformatted': str,
                          'data-math': 'Y'
                      });
  
                  mathjaxGroup.node().appendChild(newSvg.node());
  
                  // stitch the glyph defs
                  if(_glyphDefs && _glyphDefs.node()) {
                      newSvg.node().insertBefore(_glyphDefs.node().cloneNode(true),
                                                 newSvg.node().firstChild);
                  }
  
                  newSvg.attr({
                      'class': svgClass,
                      height: _svgBBox.height,
                      preserveAspectRatio: 'xMinYMin meet'
                  })
                  .style({overflow: 'visible', 'pointer-events': 'none'});
  
                  var fill = _context.node().style.fill || 'black';
                  var g = newSvg.select('g');
                  g.attr({fill: fill, stroke: fill});
  
                  var newSvgW = getSize(g, 'width');
                  var newSvgH = getSize(g, 'height');
                  var newX = +_context.attr('x') - newSvgW *
                      {start: 0, middle: 0.5, end: 1}[_context.attr('text-anchor') || 'start'];
                  // font baseline is about 1/4 fontSize below centerline
                  var textHeight = fontSize || getSize(_context, 'height');
                  var dy = -textHeight / 4;
  
                  if(svgClass[0] === 'y') {
                      mathjaxGroup.attr({
                          transform: 'rotate(' + [-90, +_context.attr('x'), +_context.attr('y')] +
                          ') translate(' + [-newSvgW / 2, dy - newSvgH / 2] + ')'
                      });
                      newSvg.attr({x: +_context.attr('x'), y: +_context.attr('y')});
                  } else if(svgClass[0] === 'l') {
                      newSvg.attr({x: _context.attr('x'), y: dy - (newSvgH / 2)});
                  } else if(svgClass[0] === 'a' && svgClass.indexOf('atitle') !== 0) {
                      newSvg.attr({x: 0, y: dy});
                  } else {
                      newSvg.attr({x: newX, y: (+_context.attr('y') + dy - newSvgH / 2)});
                  }
  
                  if(_callback) _callback.call(_context, mathjaxGroup);
                  resolve(mathjaxGroup);
              });
          }));
      } else showText();
  
      return _context;
  };
  
  
  // MathJax
  
  var LT_MATCH = /(<|&lt;|&#60;)/g;
  var GT_MATCH = /(>|&gt;|&#62;)/g;
  
  function cleanEscapesForTex(s) {
      return s.replace(LT_MATCH, '\\lt ')
          .replace(GT_MATCH, '\\gt ');
  }
  
  function texToSVG(_texString, _config, _callback) {
      var originalRenderer,
          originalConfig,
          originalProcessSectionDelay,
          tmpDiv;
  
      MathJax.Hub.Queue(
      function() {
          originalConfig = Lib.extendDeepAll({}, MathJax.Hub.config);
  
          originalProcessSectionDelay = MathJax.Hub.processSectionDelay;
          if(MathJax.Hub.processSectionDelay !== undefined) {
              // MathJax 2.5+
              MathJax.Hub.processSectionDelay = 0;
          }
  
          return MathJax.Hub.Config({
              messageStyle: 'none',
              tex2jax: {
                  inlineMath: [['$', '$'], ['\\(', '\\)']]
              },
              displayAlign: 'left',
          });
      },
      function() {
          // Get original renderer
          originalRenderer = MathJax.Hub.config.menuSettings.renderer;
          if(originalRenderer !== 'SVG') {
              return MathJax.Hub.setRenderer('SVG');
          }
      },
      function() {
          var randomID = 'math-output-' + Lib.randstr({}, 64);
          tmpDiv = d3.select('body').append('div')
              .attr({id: randomID})
              .style({visibility: 'hidden', position: 'absolute'})
              .style({'font-size': _config.fontSize + 'px'})
              .text(cleanEscapesForTex(_texString));
  
          return MathJax.Hub.Typeset(tmpDiv.node());
      },
      function() {
          var glyphDefs = d3.select('body').select('#MathJax_SVG_glyphs');
  
          if(tmpDiv.select('.MathJax_SVG').empty() || !tmpDiv.select('svg').node()) {
              Lib.log('There was an error in the tex syntax.', _texString);
              _callback();
          } else {
              var svgBBox = tmpDiv.select('svg').node().getBoundingClientRect();
              _callback(tmpDiv.select('.MathJax_SVG'), glyphDefs, svgBBox);
          }
  
          tmpDiv.remove();
  
          if(originalRenderer !== 'SVG') {
              return MathJax.Hub.setRenderer(originalRenderer);
          }
      },
      function() {
          if(originalProcessSectionDelay !== undefined) {
              MathJax.Hub.processSectionDelay = originalProcessSectionDelay;
          }
          return MathJax.Hub.Config(originalConfig);
      });
  }
  
  var TAG_STYLES = {
      // would like to use baseline-shift for sub/sup but FF doesn't support it
      // so we need to use dy along with the uber hacky shift-back-to
      // baseline below
      sup: 'font-size:70%',
      sub: 'font-size:70%',
      b: 'font-weight:bold',
      i: 'font-style:italic',
      a: 'cursor:pointer',
      span: '',
      em: 'font-style:italic;font-weight:bold'
  };
  
  // baseline shifts for sub and sup
  var SHIFT_DY = {
      sub: '0.3em',
      sup: '-0.6em'
  };
  // reset baseline by adding a tspan (empty except for a zero-width space)
  // with dy of -70% * SHIFT_DY (because font-size=70%)
  var RESET_DY = {
      sub: '-0.21em',
      sup: '0.42em'
  };
  var ZERO_WIDTH_SPACE = '\u200b';
  
  /*
   * Whitelist of protocols in user-supplied urls. Mostly we want to avoid javascript
   * and related attack vectors. The empty items are there for IE, that in various
   * versions treats relative paths as having different flavors of no protocol, while
   * other browsers have these explicitly inherit the protocol of the page they're in.
   */
  var PROTOCOLS = ['http:', 'https:', 'mailto:', '', undefined, ':'];
  
  var NEWLINES = exports.NEWLINES = /(\r\n?|\n)/g;
  
  var SPLIT_TAGS = /(<[^<>]*>)/;
  
  var ONE_TAG = /<(\/?)([^ >]*)(\s+(.*))?>/i;
  
  var BR_TAG = /<br(\s+.*)?>/i;
  exports.BR_TAG_ALL = /<br(\s+.*)?>/gi;
  
  /*
   * style and href: pull them out of either single or double quotes. Also
   * - target: (_blank|_self|_parent|_top|framename)
   *     note that you can't use target to get a popup but if you use popup,
   *     a `framename` will be passed along as the name of the popup window.
   *     per the spec, cannot contain whitespace.
   *     for backward compatibility we default to '_blank'
   * - popup: a custom one for us to enable popup (new window) links. String
   *     for window.open -> strWindowFeatures, like 'menubar=yes,width=500,height=550'
   *     note that at least in Chrome, you need to give at least one property
   *     in this string or the page will open in a new tab anyway. We follow this
   *     convention and will not make a popup if this string is empty.
   *     per the spec, cannot contain whitespace.
   *
   * Because we hack in other attributes with style (sub & sup), drop any trailing
   * semicolon in user-supplied styles so we can consistently append the tag-dependent style
   *
   * These are for tag attributes; Chrome anyway will convert entities in
   * attribute values, but not in attribute names
   * you can test this by for example:
   * > p = document.createElement('p')
   * > p.innerHTML = '<span styl&#x65;="font-color:r&#x65;d;">Hi</span>'
   * > p.innerHTML
   * <- '<span styl&#x65;="font-color:red;">Hi</span>'
   */
  var STYLEMATCH = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i;
  var HREFMATCH = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i;
  var TARGETMATCH = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i;
  var POPUPMATCH = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
  
  // dedicated matcher for these quoted regexes, that can return their results
  // in two different places
  function getQuotedMatch(_str, re) {
      if(!_str) return null;
      var match = _str.match(re);
      var result = match && (match[3] || match[4]);
      return result && convertEntities(result);
  }
  
  var COLORMATCH = /(^|;)\s*color:/;
  
  /**
   * Strip string of tags
   *
   * @param {string} _str : input string
   * @param {object} opts :
   * - len {number} max length of output string
   * - allowedTags {array} list of pseudo-html tags to NOT strip
   * @return {string}
   */
  exports.plainText = function(_str, opts) {
      opts = opts || {};
  
      var len = (opts.len !== undefined && opts.len !== -1) ? opts.len : Infinity;
      var allowedTags = opts.allowedTags !== undefined ? opts.allowedTags : ['br'];
  
      var ellipsis = '...';
      var eLen = ellipsis.length;
  
      var oldParts = _str.split(SPLIT_TAGS);
      var newParts = [];
      var prevTag = '';
      var l = 0;
  
      for(var i = 0; i < oldParts.length; i++) {
          var p = oldParts[i];
          var match = p.match(ONE_TAG);
          var tagType = match && match[2].toLowerCase();
  
          if(tagType) {
              // N.B. tags do not count towards string length
              if(allowedTags.indexOf(tagType) !== -1) {
                  newParts.push(p);
                  prevTag = tagType;
              }
          } else {
              var pLen = p.length;
  
              if((l + pLen) < len) {
                  newParts.push(p);
                  l += pLen;
              } else if(l < len) {
                  var pLen2 = len - l;
  
                  if(prevTag && (prevTag !== 'br' || pLen2 <= eLen || pLen <= eLen)) {
                      newParts.pop();
                  }
  
                  if(len > eLen) {
                      newParts.push(p.substr(0, pLen2 - eLen) + ellipsis);
                  } else {
                      newParts.push(p.substr(0, pLen2));
                  }
                  break;
              }
  
              prevTag = '';
          }
      }
  
      return newParts.join('');
  };
  
  /*
   * N.B. HTML entities are listed without the leading '&' and trailing ';'
   * https://www.freeformatter.com/html-entities.html
   *
   * FWIW if we wanted to support the full set, it has 2261 entries:
   * https://www.w3.org/TR/html5/entities.json
   * though I notice that some of these are duplicates and/or are missing ";"
   * eg: "&amp;", "&amp", "&AMP;", and "&AMP" all map to "&"
   * We no longer need to include numeric entities here, these are now handled
   * by String.fromCodePoint/fromCharCode
   *
   * Anyway the only ones that are really important to allow are the HTML special
   * chars <, >, and &, because these ones can trigger special processing if not
   * replaced by the corresponding entity.
   */
  var entityToUnicode = {
      mu: 'μ',
      amp: '&',
      lt: '<',
      gt: '>',
      nbsp: ' ',
      times: '×',
      plusmn: '±',
      deg: '°'
  };
  
  // NOTE: in general entities can contain uppercase too (so [a-zA-Z]) but all the
  // ones we support use only lowercase. If we ever change that, update the regex.
  var ENTITY_MATCH = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
  function convertEntities(_str) {
      return _str.replace(ENTITY_MATCH, function(fullMatch, innerMatch) {
          var outChar;
          if(innerMatch.charAt(0) === '#') {
              // cannot use String.fromCodePoint in IE
              outChar = fromCodePoint(
                  innerMatch.charAt(1) === 'x' ?
                      parseInt(innerMatch.substr(2), 16) :
                      parseInt(innerMatch.substr(1), 10)
              );
          } else outChar = entityToUnicode[innerMatch];
  
          // as in regular HTML, if we didn't decode the entity just
          // leave the raw text in place.
          return outChar || fullMatch;
      });
  }
  exports.convertEntities = convertEntities;
  
  function fromCodePoint(code) {
      // Don't allow overflow. In Chrome this turns into � but I feel like it's
      // more useful to just not convert it at all.
      if(code > 0x10FFFF) return;
      var stringFromCodePoint = String.fromCodePoint;
      if(stringFromCodePoint) return stringFromCodePoint(code);
  
      // IE doesn't have String.fromCodePoint
      // see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint
      var stringFromCharCode = String.fromCharCode;
      if(code <= 0xFFFF) return stringFromCharCode(code);
      return stringFromCharCode(
          (code >> 10) + 0xD7C0,
          (code % 0x400) + 0xDC00
      );
  }
  
  /*
   * buildSVGText: convert our pseudo-html into SVG tspan elements, and attach these
   * to containerNode
   *
   * @param {svg text element} containerNode: the <text> node to insert this text into
   * @param {string} str: the pseudo-html string to convert to svg
   *
   * @returns {bool}: does the result contain any links? We need to handle the text element
   *   somewhat differently if it does, so just keep track of this when it happens.
   */
  function buildSVGText(containerNode, str) {
      /*
       * Normalize behavior between IE and others wrt newlines and whitespace:pre
       * this combination makes IE barf https://github.com/plotly/plotly.js/issues/746
       * Chrome and FF display \n, \r, or \r\n as a space in this mode.
       * I feel like at some point we turned these into <br> but currently we don't so
       * I'm just going to cement what we do now in Chrome and FF
       */
      str = str.replace(NEWLINES, ' ');
  
      var hasLink = false;
  
      // as we're building the text, keep track of what elements we're nested inside
      // nodeStack will be an array of {node, type, style, href, target, popup}
      // where only type: 'a' gets the last 3 and node is only added when it's created
      var nodeStack = [];
      var currentNode;
      var currentLine = -1;
  
      function newLine() {
          currentLine++;
  
          var lineNode = document.createElementNS(xmlnsNamespaces.svg, 'tspan');
          d3.select(lineNode).attr({
              class: 'line',
              dy: (currentLine * LINE_SPACING) + 'em'
          });
          containerNode.appendChild(lineNode);
  
          currentNode = lineNode;
  
          var oldNodeStack = nodeStack;
          nodeStack = [{node: lineNode}];
  
          if(oldNodeStack.length > 1) {
              for(var i = 1; i < oldNodeStack.length; i++) {
                  enterNode(oldNodeStack[i]);
              }
          }
      }
  
      function enterNode(nodeSpec) {
          var type = nodeSpec.type;
          var nodeAttrs = {};
          var nodeType;
  
          if(type === 'a') {
              nodeType = 'a';
              var target = nodeSpec.target;
              var href = nodeSpec.href;
              var popup = nodeSpec.popup;
              if(href) {
                  nodeAttrs = {
                      'xlink:xlink:show': (target === '_blank' || target.charAt(0) !== '_') ? 'new' : 'replace',
                      target: target,
                      'xlink:xlink:href': href
                  };
                  if(popup) {
                      // security: href and target are not inserted as code but
                      // as attributes. popup is, but limited to /[A-Za-z0-9_=,]/
                      nodeAttrs.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' +
                          popup + '");return false;';
                  }
              }
          } else nodeType = 'tspan';
  
          if(nodeSpec.style) nodeAttrs.style = nodeSpec.style;
  
          var newNode = document.createElementNS(xmlnsNamespaces.svg, nodeType);
  
          if(type === 'sup' || type === 'sub') {
              addTextNode(currentNode, ZERO_WIDTH_SPACE);
              currentNode.appendChild(newNode);
  
              var resetter = document.createElementNS(xmlnsNamespaces.svg, 'tspan');
              addTextNode(resetter, ZERO_WIDTH_SPACE);
              d3.select(resetter).attr('dy', RESET_DY[type]);
              nodeAttrs.dy = SHIFT_DY[type];
  
              currentNode.appendChild(newNode);
              currentNode.appendChild(resetter);
          } else {
              currentNode.appendChild(newNode);
          }
  
          d3.select(newNode).attr(nodeAttrs);
  
          currentNode = nodeSpec.node = newNode;
          nodeStack.push(nodeSpec);
      }
  
      function addTextNode(node, text) {
          node.appendChild(document.createTextNode(text));
      }
  
      function exitNode(type) {
          // A bare closing tag can't close the root node. If we encounter this it
          // means there's an extra closing tag that can just be ignored:
          if(nodeStack.length === 1) {
              Lib.log('Ignoring unexpected end tag </' + type + '>.', str);
              return;
          }
  
          var innerNode = nodeStack.pop();
  
          if(type !== innerNode.type) {
              Lib.log('Start tag <' + innerNode.type + '> doesnt match end tag <' +
                  type + '>. Pretending it did match.', str);
          }
          currentNode = nodeStack[nodeStack.length - 1].node;
      }
  
      var hasLines = BR_TAG.test(str);
  
      if(hasLines) newLine();
      else {
          currentNode = containerNode;
          nodeStack = [{node: containerNode}];
      }
  
      var parts = str.split(SPLIT_TAGS);
      for(var i = 0; i < parts.length; i++) {
          var parti = parts[i];
          var match = parti.match(ONE_TAG);
          var tagType = match && match[2].toLowerCase();
          var tagStyle = TAG_STYLES[tagType];
  
          if(tagType === 'br') {
              newLine();
          } else if(tagStyle === undefined) {
              addTextNode(currentNode, convertEntities(parti));
          } else {
              // tag - open or close
              if(match[1]) {
                  exitNode(tagType);
              } else {
                  var extra = match[4];
  
                  var nodeSpec = {type: tagType};
  
                  // now add style, from both the tag name and any extra css
                  // Most of the svg css that users will care about is just like html,
                  // but font color is different (uses fill). Let our users ignore this.
                  var css = getQuotedMatch(extra, STYLEMATCH);
                  if(css) {
                      css = css.replace(COLORMATCH, '$1 fill:');
                      if(tagStyle) css += ';' + tagStyle;
                  } else if(tagStyle) css = tagStyle;
  
                  if(css) nodeSpec.style = css;
  
                  if(tagType === 'a') {
                      hasLink = true;
  
                      var href = getQuotedMatch(extra, HREFMATCH);
  
                      if(href) {
                          // check safe protocols
                          var dummyAnchor = document.createElement('a');
                          dummyAnchor.href = href;
                          if(PROTOCOLS.indexOf(dummyAnchor.protocol) !== -1) {
                              // Decode href to allow both already encoded and not encoded
                              // URIs. Without decoding prior encoding, an already encoded
                              // URI would be encoded twice producing a semantically different URI.
                              nodeSpec.href = encodeURI(decodeURI(href));
                              nodeSpec.target = getQuotedMatch(extra, TARGETMATCH) || '_blank';
                              nodeSpec.popup = getQuotedMatch(extra, POPUPMATCH);
                          }
                      }
                  }
  
                  enterNode(nodeSpec);
              }
          }
      }
  
      return hasLink;
  }
  
  /*
   * sanitizeHTML: port of buildSVGText aimed at providing a clean subset of HTML
   * @param {string} str: the html string to clean
   * @returns {string}: a cleaned and normalized version of the input,
   *     supporting only a small subset of html
   */
  exports.sanitizeHTML = function sanitizeHTML(str) {
      str = str.replace(NEWLINES, ' ');
  
      var rootNode = document.createElement('p');
      var currentNode = rootNode;
      var nodeStack = [];
  
      var parts = str.split(SPLIT_TAGS);
      for(var i = 0; i < parts.length; i++) {
          var parti = parts[i];
          var match = parti.match(ONE_TAG);
          var tagType = match && match[2].toLowerCase();
  
          if(tagType in TAG_STYLES) {
              if(match[1]) {
                  if(nodeStack.length) {
                      currentNode = nodeStack.pop();
                  }
              } else {
                  var extra = match[4];
  
                  var css = getQuotedMatch(extra, STYLEMATCH);
                  var nodeAttrs = css ? {style: css} : {};
  
                  if(tagType === 'a') {
                      var href = getQuotedMatch(extra, HREFMATCH);
  
                      if(href) {
                          var dummyAnchor = document.createElement('a');
                          dummyAnchor.href = href;
                          if(PROTOCOLS.indexOf(dummyAnchor.protocol) !== -1) {
                              nodeAttrs.href = encodeURI(decodeURI(href));
                              var target = getQuotedMatch(extra, TARGETMATCH);
                              if(target) {
                                  nodeAttrs.target = target;
                              }
                          }
                      }
                  }
  
                  var newNode = document.createElement(tagType);
                  currentNode.appendChild(newNode);
                  d3.select(newNode).attr(nodeAttrs);
  
                  currentNode = newNode;
                  nodeStack.push(newNode);
              }
          } else {
              currentNode.appendChild(
                  document.createTextNode(convertEntities(parti))
              );
          }
      }
      var key = 'innerHTML'; // i.e. to avoid pass test-syntax
      return rootNode[key];
  };
  
  exports.lineCount = function lineCount(s) {
      return s.selectAll('tspan.line').size() || 1;
  };
  
  exports.positionText = function positionText(s, x, y) {
      return s.each(function() {
          var text = d3.select(this);
  
          function setOrGet(attr, val) {
              if(val === undefined) {
                  val = text.attr(attr);
                  if(val === null) {
                      text.attr(attr, 0);
                      val = 0;
                  }
              } else text.attr(attr, val);
              return val;
          }
  
          var thisX = setOrGet('x', x);
          var thisY = setOrGet('y', y);
  
          if(this.nodeName === 'text') {
              text.selectAll('tspan.line').attr({x: thisX, y: thisY});
          }
      });
  };
  
  function alignHTMLWith(_base, container, options) {
      var alignH = options.horizontalAlign;
      var alignV = options.verticalAlign || 'top';
      var bRect = _base.node().getBoundingClientRect();
      var cRect = container.node().getBoundingClientRect();
      var thisRect;
      var getTop;
      var getLeft;
  
      if(alignV === 'bottom') {
          getTop = function() { return bRect.bottom - thisRect.height; };
      } else if(alignV === 'middle') {
          getTop = function() { return bRect.top + (bRect.height - thisRect.height) / 2; };
      } else { // default: top
          getTop = function() { return bRect.top; };
      }
  
      if(alignH === 'right') {
          getLeft = function() { return bRect.right - thisRect.width; };
      } else if(alignH === 'center') {
          getLeft = function() { return bRect.left + (bRect.width - thisRect.width) / 2; };
      } else { // default: left
          getLeft = function() { return bRect.left; };
      }
  
      return function() {
          thisRect = this.node().getBoundingClientRect();
          this.style({
              top: (getTop() - cRect.top) + 'px',
              left: (getLeft() - cRect.left) + 'px',
              'z-index': 1000
          });
          return this;
      };
  }
  
  /*
   * Editable title
   * @param {d3.selection} context: the element being edited. Normally text,
   *   but if it isn't, you should provide the styling options
   * @param {object} options:
   *   @param {div} options.gd: graphDiv
   *   @param {d3.selection} options.delegate: item to bind events to if not this
   *   @param {boolean} options.immediate: start editing now (true) or on click (false, default)
   *   @param {string} options.fill: font color if not as shown
   *   @param {string} options.background: background color if not as shown
   *   @param {string} options.text: initial text, if not as shown
   *   @param {string} options.horizontalAlign: alignment of the edit box wrt. the bound element
   *   @param {string} options.verticalAlign: alignment of the edit box wrt. the bound element
   */
  
  exports.makeEditable = function(context, options) {
      var gd = options.gd;
      var _delegate = options.delegate;
      var dispatch = d3.dispatch('edit', 'input', 'cancel');
      var handlerElement = _delegate || context;
  
      context.style({'pointer-events': _delegate ? 'none' : 'all'});
  
      if(context.size() !== 1) throw new Error('boo');
  
      function handleClick() {
          appendEditable();
          context.style({opacity: 0});
          // also hide any mathjax svg
          var svgClass = handlerElement.attr('class');
          var mathjaxClass;
          if(svgClass) mathjaxClass = '.' + svgClass.split(' ')[0] + '-math-group';
          else mathjaxClass = '[class*=-math-group]';
          if(mathjaxClass) {
              d3.select(context.node().parentNode).select(mathjaxClass).style({opacity: 0});
          }
      }
  
      function selectElementContents(_el) {
          var el = _el.node();
          var range = document.createRange();
          range.selectNodeContents(el);
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          el.focus();
      }
  
      function appendEditable() {
          var plotDiv = d3.select(gd);
          var container = plotDiv.select('.svg-container');
          var div = container.append('div');
          var cStyle = context.node().style;
          var fontSize = parseFloat(cStyle.fontSize || 12);
  
          var initialText = options.text;
          if(initialText === undefined) initialText = context.attr('data-unformatted');
  
          div.classed('plugin-editable editable', true)
              .style({
                  position: 'absolute',
                  'font-family': cStyle.fontFamily || 'Arial',
                  'font-size': fontSize,
                  color: options.fill || cStyle.fill || 'black',
                  opacity: 1,
                  'background-color': options.background || 'transparent',
                  outline: '#ffffff33 1px solid',
                  margin: [-fontSize / 8 + 1, 0, 0, -1].join('px ') + 'px',
                  padding: '0',
                  'box-sizing': 'border-box'
              })
              .attr({contenteditable: true})
              .text(initialText)
              .call(alignHTMLWith(context, container, options))
              .on('blur', function() {
                  gd._editing = false;
                  context.text(this.textContent)
                      .style({opacity: 1});
                  var svgClass = d3.select(this).attr('class');
                  var mathjaxClass;
                  if(svgClass) mathjaxClass = '.' + svgClass.split(' ')[0] + '-math-group';
                  else mathjaxClass = '[class*=-math-group]';
                  if(mathjaxClass) {
                      d3.select(context.node().parentNode).select(mathjaxClass).style({opacity: 0});
                  }
                  var text = this.textContent;
                  d3.select(this).transition().duration(0).remove();
                  d3.select(document).on('mouseup', null);
                  dispatch.edit.call(context, text);
              })
              .on('focus', function() {
                  var editDiv = this;
                  gd._editing = true;
                  d3.select(document).on('mouseup', function() {
                      if(d3.event.target === editDiv) return false;
                      if(document.activeElement === div.node()) div.node().blur();
                  });
              })
              .on('keyup', function() {
                  if(d3.event.which === 27) {
                      gd._editing = false;
                      context.style({opacity: 1});
                      d3.select(this)
                          .style({opacity: 0})
                          .on('blur', function() { return false; })
                          .transition().remove();
                      dispatch.cancel.call(context, this.textContent);
                  } else {
                      dispatch.input.call(context, this.textContent);
                      d3.select(this).call(alignHTMLWith(context, container, options));
                  }
              })
              .on('keydown', function() {
                  if(d3.event.which === 13) this.blur();
              })
              .call(selectElementContents);
      }
  
      if(options.immediate) handleClick();
      else handlerElement.on('click', handleClick);
  
      return d3.rebind(context, dispatch, 'on');
  };
  
  },{"../constants/alignment":717,"../constants/xmlns_namespaces":726,"../lib":750,"d3":169}],775:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var timerCache = {};
  
  /**
   * Throttle a callback. `callback` executes synchronously only if
   * more than `minInterval` milliseconds have already elapsed since the latest
   * call (if any). Otherwise we wait until `minInterval` is over and execute the
   * last callback received while waiting.
   * So the first and last events in a train are always executed (eventually)
   * but some of the events in the middle can be dropped.
   *
   * @param {string} id: an identifier to mark events to throttle together
   * @param {number} minInterval: minimum time, in milliseconds, between
   *   invocations of `callback`
   * @param {function} callback: the function to throttle. `callback` itself
   *   should be a purely synchronous function.
   */
  exports.throttle = function throttle(id, minInterval, callback) {
      var cache = timerCache[id];
      var now = Date.now();
  
      if(!cache) {
          /*
           * Throw out old items before making a new one, to prevent the cache
           * getting overgrown, for example from old plots that have been replaced.
           * 1 minute age is arbitrary.
           */
          for(var idi in timerCache) {
              if(timerCache[idi].ts < now - 60000) {
                  delete timerCache[idi];
              }
          }
          cache = timerCache[id] = {ts: 0, timer: null};
      }
  
      _clearTimeout(cache);
  
      function exec() {
          callback();
          cache.ts = Date.now();
          if(cache.onDone) {
              cache.onDone();
              cache.onDone = null;
          }
      }
  
      if(now > cache.ts + minInterval) {
          exec();
          return;
      }
  
      cache.timer = setTimeout(function() {
          exec();
          cache.timer = null;
      }, minInterval);
  };
  
  exports.done = function(id) {
      var cache = timerCache[id];
      if(!cache || !cache.timer) return Promise.resolve();
  
      return new Promise(function(resolve) {
          var previousOnDone = cache.onDone;
          cache.onDone = function onDone() {
              if(previousOnDone) previousOnDone();
              resolve();
              cache.onDone = null;
          };
      });
  };
  
  /**
   * Clear the throttle cache for one or all timers
   * @param {optional string} id:
   *   if provided, clear just this timer
   *   if omitted, clear all timers (mainly useful for testing)
   */
  exports.clear = function(id) {
      if(id) {
          _clearTimeout(timerCache[id]);
          delete timerCache[id];
      } else {
          for(var idi in timerCache) exports.clear(idi);
      }
  };
  
  function _clearTimeout(cache) {
      if(cache && cache.timer !== null) {
          clearTimeout(cache.timer);
          cache.timer = null;
      }
  }
  
  },{}],776:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  /**
   * convert a linear value into a logged value, folding negative numbers into
   * the given range
   */
  module.exports = function toLogRange(val, range) {
      if(val > 0) return Math.log(val) / Math.LN10;
  
      // move a negative value reference to a log axis - just put the
      // result at the lowest range value on the plot (or if the range also went negative,
      // one millionth of the top of the range)
      var newVal = Math.log(Math.min(range[0], range[1])) / Math.LN10;
      if(!isNumeric(newVal)) newVal = Math.log(Math.max(range[0], range[1])) / Math.LN10 - 6;
      return newVal;
  };
  
  },{"fast-isnumeric":241}],777:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var topojsonUtils = module.exports = {};
  
  var locationmodeToLayer = _dereq_('../plots/geo/constants').locationmodeToLayer;
  var topojsonFeature = _dereq_('topojson-client').feature;
  
  topojsonUtils.getTopojsonName = function(geoLayout) {
      return [
          geoLayout.scope.replace(/ /g, '-'), '_',
          geoLayout.resolution.toString(), 'm'
      ].join('');
  };
  
  topojsonUtils.getTopojsonPath = function(topojsonURL, topojsonName) {
      return topojsonURL + topojsonName + '.json';
  };
  
  topojsonUtils.getTopojsonFeatures = function(trace, topojson) {
      var layer = locationmodeToLayer[trace.locationmode];
      var obj = topojson.objects[layer];
  
      return topojsonFeature(topojson, obj).features;
  };
  
  },{"../plots/geo/constants":829,"topojson-client":551}],778:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'locale',
      name: 'en-US',
      dictionary: {
          'Click to enter Colorscale title': 'Click to enter Colorscale title'
      },
      format: {
          date: '%m/%d/%Y'
      }
  };
  
  },{}],779:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'locale',
      name: 'en',
      dictionary: {
          'Click to enter Colorscale title': 'Click to enter Colourscale title'
      },
      format: {
          days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: [
              'January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'
          ],
          shortMonths: [
              'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
              'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
          ],
          periods: ['AM', 'PM'],
          dateTime: '%a %b %e %X %Y',
          date: '%d/%m/%Y',
          time: '%H:%M:%S',
          decimal: '.',
          thousands: ',',
          grouping: [3],
          currency: ['$', ''],
          year: '%Y',
          month: '%b %Y',
          dayMonth: '%b %-d',
          dayMonthYear: '%b %-d, %Y'
      }
  };
  
  },{}],780:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Registry = _dereq_('../registry');
  
  /*
   * containerArrayMatch: does this attribute string point into a
   * layout container array?
   *
   * @param {String} astr: an attribute string, like *annotations[2].text*
   *
   * @returns {Object | false} Returns false if `astr` doesn't match a container
   *  array. If it does, returns:
   *     {array: {String}, index: {Number}, property: {String}}
   *  ie the attribute string for the array, the index within the array (or ''
   *  if the whole array) and the property within that (or '' if the whole array
   *  or the whole object)
   */
  module.exports = function containerArrayMatch(astr) {
      var rootContainers = Registry.layoutArrayContainers;
      var regexpContainers = Registry.layoutArrayRegexes;
      var rootPart = astr.split('[')[0];
      var arrayStr;
      var match;
  
      // look for regexp matches first, because they may be nested inside root matches
      // eg updatemenus[i].buttons is nested inside updatemenus
      for(var i = 0; i < regexpContainers.length; i++) {
          match = astr.match(regexpContainers[i]);
          if(match && match.index === 0) {
              arrayStr = match[0];
              break;
          }
      }
  
      // now look for root matches
      if(!arrayStr) arrayStr = rootContainers[rootContainers.indexOf(rootPart)];
  
      if(!arrayStr) return false;
  
      var tail = astr.substr(arrayStr.length);
      if(!tail) return {array: arrayStr, index: '', property: ''};
  
      match = tail.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/);
      if(!match) return false;
  
      return {array: arrayStr, index: Number(match[1]), property: match[3] || ''};
  };
  
  },{"../registry":882}],781:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var extendFlat = Lib.extendFlat;
  var isPlainObject = Lib.isPlainObject;
  
  var traceOpts = {
      valType: 'flaglist',
      extras: ['none'],
      flags: ['calc', 'clearAxisTypes', 'plot', 'style', 'markerSize', 'colorbars'],
      
  };
  
  var layoutOpts = {
      valType: 'flaglist',
      extras: ['none'],
      flags: [
          'calc', 'plot', 'legend', 'ticks', 'axrange',
          'layoutstyle', 'modebar', 'camera', 'arraydraw', 'colorbars'
      ],
      
  };
  
  // flags for inside restyle/relayout include a few extras
  // that shouldn't be used in attributes, to deal with certain
  // combinations and conditionals efficiently
  var traceEditTypeFlags = traceOpts.flags.slice()
      .concat(['fullReplot']);
  
  var layoutEditTypeFlags = layoutOpts.flags.slice()
      .concat('layoutReplot');
  
  module.exports = {
      traces: traceOpts,
      layout: layoutOpts,
      /*
       * default (all false) edit flags for restyle (traces)
       * creates a new object each call, so the caller can mutate freely
       */
      traceFlags: function() { return falseObj(traceEditTypeFlags); },
  
      /*
       * default (all false) edit flags for relayout
       * creates a new object each call, so the caller can mutate freely
       */
      layoutFlags: function() { return falseObj(layoutEditTypeFlags); },
  
      /*
       * update `flags` with the `editType` values found in `attr`
       */
      update: function(flags, attr) {
          var editType = attr.editType;
          if(editType && editType !== 'none') {
              var editTypeParts = editType.split('+');
              for(var i = 0; i < editTypeParts.length; i++) {
                  flags[editTypeParts[i]] = true;
              }
          }
      },
  
      overrideAll: overrideAll
  };
  
  function falseObj(keys) {
      var out = {};
      for(var i = 0; i < keys.length; i++) out[keys[i]] = false;
      return out;
  }
  
  /**
   * For attributes that are largely copied from elsewhere into a plot type that doesn't
   * support partial redraws - overrides the editType field of all attributes in the object
   *
   * @param {object} attrs: the attributes to override. Will not be mutated.
   * @param {string} editTypeOverride: the new editType to use
   * @param {'nested'|'from-root'} overrideContainers:
   *   - 'nested' will override editType for nested containers but not the root.
   *   - 'from-root' will also override editType of the root container.
   *   Containers below the absolute top level (trace or layout root) DO need an
   *   editType even if they are not `valObject`s themselves (eg `scatter.marker`)
   *   to handle the case where you edit the whole container.
   *
   * @return {object} a new attributes object with `editType` modified as directed
   */
  function overrideAll(attrs, editTypeOverride, overrideContainers) {
      var out = extendFlat({}, attrs);
      for(var key in out) {
          var attr = out[key];
          if(isPlainObject(attr)) {
              out[key] = overrideOne(attr, editTypeOverride, overrideContainers, key);
          }
      }
      if(overrideContainers === 'from-root') out.editType = editTypeOverride;
  
      return out;
  }
  
  function overrideOne(attr, editTypeOverride, overrideContainers, key) {
      if(attr.valType) {
          var out = extendFlat({}, attr);
          out.editType = editTypeOverride;
  
          if(Array.isArray(attr.items)) {
              out.items = new Array(attr.items.length);
              for(var i = 0; i < attr.items.length; i++) {
                  out.items[i] = overrideOne(attr.items[i], editTypeOverride, 'from-root');
              }
          }
          return out;
      } else {
          // don't provide an editType for the _deprecated container
          return overrideAll(attr, editTypeOverride,
              (key.charAt(0) === '_') ? 'nested' : 'from-root');
      }
  }
  
  },{"../lib":750}],782:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var m4FromQuat = _dereq_('gl-mat4/fromQuat');
  
  var Registry = _dereq_('../registry');
  var Lib = _dereq_('../lib');
  var Plots = _dereq_('../plots/plots');
  var AxisIds = _dereq_('../plots/cartesian/axis_ids');
  var Color = _dereq_('../components/color');
  
  var cleanId = AxisIds.cleanId;
  var getFromTrace = AxisIds.getFromTrace;
  var traceIs = Registry.traceIs;
  
  // clear the promise queue if one of them got rejected
  exports.clearPromiseQueue = function(gd) {
      if(Array.isArray(gd._promises) && gd._promises.length > 0) {
          Lib.log('Clearing previous rejected promises from queue.');
      }
  
      gd._promises = [];
  };
  
  // make a few changes to the layout right away
  // before it gets used for anything
  // backward compatibility and cleanup of nonstandard options
  exports.cleanLayout = function(layout) {
      var i, j;
  
      if(!layout) layout = {};
  
      // cannot have (x|y)axis1, numbering goes axis, axis2, axis3...
      if(layout.xaxis1) {
          if(!layout.xaxis) layout.xaxis = layout.xaxis1;
          delete layout.xaxis1;
      }
      if(layout.yaxis1) {
          if(!layout.yaxis) layout.yaxis = layout.yaxis1;
          delete layout.yaxis1;
      }
      if(layout.scene1) {
          if(!layout.scene) layout.scene = layout.scene1;
          delete layout.scene1;
      }
  
      var axisAttrRegex = (Plots.subplotsRegistry.cartesian || {}).attrRegex;
      var polarAttrRegex = (Plots.subplotsRegistry.polar || {}).attrRegex;
      var ternaryAttrRegex = (Plots.subplotsRegistry.ternary || {}).attrRegex;
      var sceneAttrRegex = (Plots.subplotsRegistry.gl3d || {}).attrRegex;
  
      var keys = Object.keys(layout);
      for(i = 0; i < keys.length; i++) {
          var key = keys[i];
  
          if(axisAttrRegex && axisAttrRegex.test(key)) {
              // modifications to cartesian axes
  
              var ax = layout[key];
              if(ax.anchor && ax.anchor !== 'free') {
                  ax.anchor = cleanId(ax.anchor);
              }
              if(ax.overlaying) ax.overlaying = cleanId(ax.overlaying);
  
              // old method of axis type - isdate and islog (before category existed)
              if(!ax.type) {
                  if(ax.isdate) ax.type = 'date';
                  else if(ax.islog) ax.type = 'log';
                  else if(ax.isdate === false && ax.islog === false) ax.type = 'linear';
              }
              if(ax.autorange === 'withzero' || ax.autorange === 'tozero') {
                  ax.autorange = true;
                  ax.rangemode = 'tozero';
              }
              delete ax.islog;
              delete ax.isdate;
              delete ax.categories; // replaced by _categories
  
              // prune empty domain arrays made before the new nestedProperty
              if(emptyContainer(ax, 'domain')) delete ax.domain;
  
              // autotick -> tickmode
              if(ax.autotick !== undefined) {
                  if(ax.tickmode === undefined) {
                      ax.tickmode = ax.autotick ? 'auto' : 'linear';
                  }
                  delete ax.autotick;
              }
  
              cleanTitle(ax);
          } else if(polarAttrRegex && polarAttrRegex.test(key)) {
              // modifications for polar
  
              var polar = layout[key];
              cleanTitle(polar.radialaxis);
          } else if(ternaryAttrRegex && ternaryAttrRegex.test(key)) {
              // modifications for ternary
  
              var ternary = layout[key];
              cleanTitle(ternary.aaxis);
              cleanTitle(ternary.baxis);
              cleanTitle(ternary.caxis);
          } else if(sceneAttrRegex && sceneAttrRegex.test(key)) {
              // modifications for 3D scenes
  
              var scene = layout[key];
  
              // clean old Camera coords
              var cameraposition = scene.cameraposition;
  
              if(Array.isArray(cameraposition) && cameraposition[0].length === 4) {
                  var rotation = cameraposition[0];
                  var center = cameraposition[1];
                  var radius = cameraposition[2];
                  var mat = m4FromQuat([], rotation);
                  var eye = [];
  
                  for(j = 0; j < 3; ++j) {
                      eye[j] = center[j] + radius * mat[2 + 4 * j];
                  }
  
                  scene.camera = {
                      eye: {x: eye[0], y: eye[1], z: eye[2]},
                      center: {x: center[0], y: center[1], z: center[2]},
                      up: {x: 0, y: 0, z: 1} // we just ignore calculating camera z up in this case
                  };
  
                  delete scene.cameraposition;
              }
  
              // clean axis titles
              cleanTitle(scene.xaxis);
              cleanTitle(scene.yaxis);
              cleanTitle(scene.zaxis);
          }
      }
  
      var annotationsLen = Array.isArray(layout.annotations) ? layout.annotations.length : 0;
      for(i = 0; i < annotationsLen; i++) {
          var ann = layout.annotations[i];
  
          if(!Lib.isPlainObject(ann)) continue;
  
          if(ann.ref) {
              if(ann.ref === 'paper') {
                  ann.xref = 'paper';
                  ann.yref = 'paper';
              } else if(ann.ref === 'data') {
                  ann.xref = 'x';
                  ann.yref = 'y';
              }
              delete ann.ref;
          }
  
          cleanAxRef(ann, 'xref');
          cleanAxRef(ann, 'yref');
      }
  
      var shapesLen = Array.isArray(layout.shapes) ? layout.shapes.length : 0;
      for(i = 0; i < shapesLen; i++) {
          var shape = layout.shapes[i];
  
          if(!Lib.isPlainObject(shape)) continue;
  
          cleanAxRef(shape, 'xref');
          cleanAxRef(shape, 'yref');
      }
  
      var imagesLen = Array.isArray(layout.images) ? layout.images.length : 0;
      for(i = 0; i < imagesLen; i++) {
          var image = layout.images[i];
  
          if(!Lib.isPlainObject(image)) continue;
  
          cleanAxRef(image, 'xref');
          cleanAxRef(image, 'yref');
      }
  
      var legend = layout.legend;
      if(legend) {
          // check for old-style legend positioning (x or y is +/- 100)
          if(legend.x > 3) {
              legend.x = 1.02;
              legend.xanchor = 'left';
          } else if(legend.x < -2) {
              legend.x = -0.02;
              legend.xanchor = 'right';
          }
  
          if(legend.y > 3) {
              legend.y = 1.02;
              legend.yanchor = 'bottom';
          } else if(legend.y < -2) {
              legend.y = -0.02;
              legend.yanchor = 'top';
          }
      }
  
      // clean plot title
      cleanTitle(layout);
  
      /*
       * Moved from rotate -> orbit for dragmode
       */
      if(layout.dragmode === 'rotate') layout.dragmode = 'orbit';
  
      // sanitize rgb(fractions) and rgba(fractions) that old tinycolor
      // supported, but new tinycolor does not because they're not valid css
      Color.clean(layout);
  
      // clean the layout container in layout.template
      if(layout.template && layout.template.layout) {
          exports.cleanLayout(layout.template.layout);
      }
  
      return layout;
  };
  
  function cleanAxRef(container, attr) {
      var valIn = container[attr];
      var axLetter = attr.charAt(0);
      if(valIn && valIn !== 'paper') {
          container[attr] = cleanId(valIn, axLetter, true);
      }
  }
  
  /**
   * Cleans up old title attribute structure (flat) in favor of the new one (nested).
   *
   * @param {Object} titleContainer - an object potentially including deprecated title attributes
   */
  function cleanTitle(titleContainer) {
      if(titleContainer) {
          // title -> title.text
          // (although title used to be a string attribute,
          // numbers are accepted as well)
          if(typeof titleContainer.title === 'string' || typeof titleContainer.title === 'number') {
              titleContainer.title = {
                  text: titleContainer.title
              };
          }
  
          rewireAttr('titlefont', 'font');
          rewireAttr('titleposition', 'position');
          rewireAttr('titleside', 'side');
          rewireAttr('titleoffset', 'offset');
      }
  
      function rewireAttr(oldAttrName, newAttrName) {
          var oldAttrSet = titleContainer[oldAttrName];
          var newAttrSet = titleContainer.title && titleContainer.title[newAttrName];
  
          if(oldAttrSet && !newAttrSet) {
              // Ensure title object exists
              if(!titleContainer.title) {
                  titleContainer.title = {};
              }
  
              titleContainer.title[newAttrName] = titleContainer[oldAttrName];
              delete titleContainer[oldAttrName];
          }
      }
  }
  
  /*
   * cleanData: Make a few changes to the data for backward compatibility
   * before it gets used for anything. Modifies the data traces users provide.
   *
   * Important: if you're going to add something here that modifies a data array,
   * update it in place so the new array === the old one.
   */
  exports.cleanData = function(data) {
      for(var tracei = 0; tracei < data.length; tracei++) {
          var trace = data[tracei];
          var i;
  
          // use xbins to bin data in x, and ybins to bin data in y
          if(trace.type === 'histogramy' && 'xbins' in trace && !('ybins' in trace)) {
              trace.ybins = trace.xbins;
              delete trace.xbins;
          }
  
          // error_y.opacity is obsolete - merge into color
          if(trace.error_y && 'opacity' in trace.error_y) {
              var dc = Color.defaults;
              var yeColor = trace.error_y.color || (traceIs(trace, 'bar') ?
                  Color.defaultLine :
                  dc[tracei % dc.length]);
              trace.error_y.color = Color.addOpacity(
                  Color.rgb(yeColor),
                  Color.opacity(yeColor) * trace.error_y.opacity);
              delete trace.error_y.opacity;
          }
  
          // convert bardir to orientation, and put the data into
          // the axes it's eventually going to be used with
          if('bardir' in trace) {
              if(trace.bardir === 'h' && (traceIs(trace, 'bar') ||
                  trace.type.substr(0, 9) === 'histogram')) {
                  trace.orientation = 'h';
                  exports.swapXYData(trace);
              }
              delete trace.bardir;
          }
  
          // now we have only one 1D histogram type, and whether
          // it uses x or y data depends on trace.orientation
          if(trace.type === 'histogramy') exports.swapXYData(trace);
          if(trace.type === 'histogramx' || trace.type === 'histogramy') {
              trace.type = 'histogram';
          }
  
          // scl->scale, reversescl->reversescale
          if('scl' in trace && !('colorscale' in trace)) {
              trace.colorscale = trace.scl;
              delete trace.scl;
          }
          if('reversescl' in trace && !('reversescale' in trace)) {
              trace.reversescale = trace.reversescl;
              delete trace.reversescl;
          }
  
          // axis ids x1 -> x, y1-> y
          if(trace.xaxis) trace.xaxis = cleanId(trace.xaxis, 'x');
          if(trace.yaxis) trace.yaxis = cleanId(trace.yaxis, 'y');
  
          // scene ids scene1 -> scene
          if(traceIs(trace, 'gl3d') && trace.scene) {
              trace.scene = Plots.subplotsRegistry.gl3d.cleanId(trace.scene);
          }
  
          if(!traceIs(trace, 'pie-like') && !traceIs(trace, 'bar-like')) {
              if(Array.isArray(trace.textposition)) {
                  for(i = 0; i < trace.textposition.length; i++) {
                      trace.textposition[i] = cleanTextPosition(trace.textposition[i]);
                  }
              } else if(trace.textposition) {
                  trace.textposition = cleanTextPosition(trace.textposition);
              }
          }
  
          // fix typo in colorscale definition
          var _module = Registry.getModule(trace);
          if(_module && _module.colorbar) {
              var containerName = _module.colorbar.container;
              var container = containerName ? trace[containerName] : trace;
              if(container && container.colorscale) {
                  if(container.colorscale === 'YIGnBu') container.colorscale = 'YlGnBu';
                  if(container.colorscale === 'YIOrRd') container.colorscale = 'YlOrRd';
              }
          }
  
          // fix typo in surface 'highlight*' definitions
          if(trace.type === 'surface' && Lib.isPlainObject(trace.contours)) {
              var dims = ['x', 'y', 'z'];
  
              for(i = 0; i < dims.length; i++) {
                  var opts = trace.contours[dims[i]];
  
                  if(!Lib.isPlainObject(opts)) continue;
  
                  if(opts.highlightColor) {
                      opts.highlightcolor = opts.highlightColor;
                      delete opts.highlightColor;
                  }
  
                  if(opts.highlightWidth) {
                      opts.highlightwidth = opts.highlightWidth;
                      delete opts.highlightWidth;
                  }
              }
          }
  
          // fixes from converting finance from transforms to real trace types
          if(trace.type === 'candlestick' || trace.type === 'ohlc') {
              var increasingShowlegend = (trace.increasing || {}).showlegend !== false;
              var decreasingShowlegend = (trace.decreasing || {}).showlegend !== false;
              var increasingName = cleanFinanceDir(trace.increasing);
              var decreasingName = cleanFinanceDir(trace.decreasing);
  
              // now figure out something smart to do with the separate direction
              // names we removed
              if((increasingName !== false) && (decreasingName !== false)) {
                  // both sub-names existed: base name previously had no effect
                  // so ignore it and try to find a shared part of the sub-names
  
                  var newName = commonPrefix(
                      increasingName, decreasingName,
                      increasingShowlegend, decreasingShowlegend
                  );
                  // if no common part, leave whatever name was (or wasn't) there
                  if(newName) trace.name = newName;
              } else if((increasingName || decreasingName) && !trace.name) {
                  // one sub-name existed but not the base name - just use the sub-name
                  trace.name = increasingName || decreasingName;
              }
          }
  
          // transforms backward compatibility fixes
          if(Array.isArray(trace.transforms)) {
              var transforms = trace.transforms;
  
              for(i = 0; i < transforms.length; i++) {
                  var transform = transforms[i];
  
                  if(!Lib.isPlainObject(transform)) continue;
  
                  switch(transform.type) {
                      case 'filter':
                          if(transform.filtersrc) {
                              transform.target = transform.filtersrc;
                              delete transform.filtersrc;
                          }
  
                          if(transform.calendar) {
                              if(!transform.valuecalendar) {
                                  transform.valuecalendar = transform.calendar;
                              }
                              delete transform.calendar;
                          }
                          break;
  
                      case 'groupby':
                          // Name has changed from `style` to `styles`, so use `style` but prefer `styles`:
                          transform.styles = transform.styles || transform.style;
  
                          if(transform.styles && !Array.isArray(transform.styles)) {
                              var prevStyles = transform.styles;
                              var styleKeys = Object.keys(prevStyles);
  
                              transform.styles = [];
                              for(var j = 0; j < styleKeys.length; j++) {
                                  transform.styles.push({
                                      target: styleKeys[j],
                                      value: prevStyles[styleKeys[j]]
                                  });
                              }
                          }
                          break;
                  }
              }
          }
  
          // prune empty containers made before the new nestedProperty
          if(emptyContainer(trace, 'line')) delete trace.line;
          if('marker' in trace) {
              if(emptyContainer(trace.marker, 'line')) delete trace.marker.line;
              if(emptyContainer(trace, 'marker')) delete trace.marker;
          }
  
          // sanitize rgb(fractions) and rgba(fractions) that old tinycolor
          // supported, but new tinycolor does not because they're not valid css
          Color.clean(trace);
  
          // remove obsolete autobin(x|y) attributes, but only if true
          // if false, this needs to happen in Histogram.calc because it
          // can be a one-time autobin so we need to know the results before
          // we can push them back into the trace.
          if(trace.autobinx) {
              delete trace.autobinx;
              delete trace.xbins;
          }
          if(trace.autobiny) {
              delete trace.autobiny;
              delete trace.ybins;
          }
  
          cleanTitle(trace);
          if(trace.colorbar) cleanTitle(trace.colorbar);
          if(trace.marker && trace.marker.colorbar) cleanTitle(trace.marker.colorbar);
          if(trace.line && trace.line.colorbar) cleanTitle(trace.line.colorbar);
          if(trace.aaxis) cleanTitle(trace.aaxis);
          if(trace.baxis) cleanTitle(trace.baxis);
      }
  };
  
  function cleanFinanceDir(dirContainer) {
      if(!Lib.isPlainObject(dirContainer)) return false;
  
      var dirName = dirContainer.name;
  
      delete dirContainer.name;
      delete dirContainer.showlegend;
  
      return (typeof dirName === 'string' || typeof dirName === 'number') && String(dirName);
  }
  
  function commonPrefix(name1, name2, show1, show2) {
      // if only one is shown in the legend, use that
      if(show1 && !show2) return name1;
      if(show2 && !show1) return name2;
  
      // if both or neither are in the legend, check if one is blank (or whitespace)
      // and use the other one
      // note that hover labels can still use the name even if the legend doesn't
      if(!name1.trim()) return name2;
      if(!name2.trim()) return name1;
  
      var minLen = Math.min(name1.length, name2.length);
      var i;
      for(i = 0; i < minLen; i++) {
          if(name1.charAt(i) !== name2.charAt(i)) break;
      }
  
      var out = name1.substr(0, i);
      return out.trim();
  }
  
  // textposition - support partial attributes (ie just 'top')
  // and incorrect use of middle / center etc.
  function cleanTextPosition(textposition) {
      var posY = 'middle';
      var posX = 'center';
  
      if(typeof textposition === 'string') {
          if(textposition.indexOf('top') !== -1) posY = 'top';
          else if(textposition.indexOf('bottom') !== -1) posY = 'bottom';
  
          if(textposition.indexOf('left') !== -1) posX = 'left';
          else if(textposition.indexOf('right') !== -1) posX = 'right';
      }
  
      return posY + ' ' + posX;
  }
  
  function emptyContainer(outer, innerStr) {
      return (innerStr in outer) &&
          (typeof outer[innerStr] === 'object') &&
          (Object.keys(outer[innerStr]).length === 0);
  }
  
  
  // swap all the data and data attributes associated with x and y
  exports.swapXYData = function(trace) {
      var i;
      Lib.swapAttrs(trace, ['?', '?0', 'd?', '?bins', 'nbins?', 'autobin?', '?src', 'error_?']);
      if(Array.isArray(trace.z) && Array.isArray(trace.z[0])) {
          if(trace.transpose) delete trace.transpose;
          else trace.transpose = true;
      }
      if(trace.error_x && trace.error_y) {
          var errorY = trace.error_y;
          var copyYstyle = ('copy_ystyle' in errorY) ?
              errorY.copy_ystyle :
              !(errorY.color || errorY.thickness || errorY.width);
          Lib.swapAttrs(trace, ['error_?.copy_ystyle']);
          if(copyYstyle) {
              Lib.swapAttrs(trace, ['error_?.color', 'error_?.thickness', 'error_?.width']);
          }
      }
      if(typeof trace.hoverinfo === 'string') {
          var hoverInfoParts = trace.hoverinfo.split('+');
          for(i = 0; i < hoverInfoParts.length; i++) {
              if(hoverInfoParts[i] === 'x') hoverInfoParts[i] = 'y';
              else if(hoverInfoParts[i] === 'y') hoverInfoParts[i] = 'x';
          }
          trace.hoverinfo = hoverInfoParts.join('+');
      }
  };
  
  // coerce traceIndices input to array of trace indices
  exports.coerceTraceIndices = function(gd, traceIndices) {
      if(isNumeric(traceIndices)) {
          return [traceIndices];
      } else if(!Array.isArray(traceIndices) || !traceIndices.length) {
          return gd.data.map(function(_, i) { return i; });
      } else if(Array.isArray(traceIndices)) {
          var traceIndicesOut = [];
          for(var i = 0; i < traceIndices.length; i++) {
              if(Lib.isIndex(traceIndices[i], gd.data.length)) {
                  traceIndicesOut.push(traceIndices[i]);
              } else {
                  Lib.warn('trace index (', traceIndices[i], ') is not a number or is out of bounds');
              }
          }
          return traceIndicesOut;
      }
  
      return traceIndices;
  };
  
  /**
   * Manages logic around array container item creation / deletion / update
   * that nested property alone can't handle.
   *
   * @param {Object} np
   *  nested property of update attribute string about trace or layout object
   * @param {*} newVal
   *  update value passed to restyle / relayout / update
   * @param {Object} undoit
   *  undo hash (N.B. undoit may be mutated here).
   *
   */
  exports.manageArrayContainers = function(np, newVal, undoit) {
      var obj = np.obj;
      var parts = np.parts;
      var pLength = parts.length;
      var pLast = parts[pLength - 1];
  
      var pLastIsNumber = isNumeric(pLast);
  
      if(pLastIsNumber && newVal === null) {
          // delete item
  
          // Clear item in array container when new value is null
          var contPath = parts.slice(0, pLength - 1).join('.');
          var cont = Lib.nestedProperty(obj, contPath).get();
          cont.splice(pLast, 1);
  
          // Note that nested property clears null / undefined at end of
          // array container, but not within them.
      } else if(pLastIsNumber && np.get() === undefined) {
          // create item
  
          // When adding a new item, make sure undo command will remove it
          if(np.get() === undefined) undoit[np.astr] = null;
  
          np.set(newVal);
      } else {
          // update item
  
          // If the last part of attribute string isn't a number,
          // np.set is all we need.
          np.set(newVal);
      }
  };
  
  /*
   * Match the part to strip off to turn an attribute into its parent
   * really it should be either '.some_characters' or '[number]'
   * but we're a little more permissive here and match either
   * '.not_brackets_or_dot' or '[not_brackets_or_dot]'
   */
  var ATTR_TAIL_RE = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
  
  function getParent(attr) {
      var tail = attr.search(ATTR_TAIL_RE);
      if(tail > 0) return attr.substr(0, tail);
  }
  
  /*
   * hasParent: does an attribute object contain a parent of the given attribute?
   * for example, given 'images[2].x' do we also have 'images' or 'images[2]'?
   *
   * @param {Object} aobj
   *  update object, whose keys are attribute strings and values are their new settings
   * @param {string} attr
   *  the attribute string to test against
   * @returns {Boolean}
   *  is a parent of attr present in aobj?
   */
  exports.hasParent = function(aobj, attr) {
      var attrParent = getParent(attr);
      while(attrParent) {
          if(attrParent in aobj) return true;
          attrParent = getParent(attrParent);
      }
      return false;
  };
  
  /**
   * Empty out types for all axes containing these traces so we auto-set them again
   *
   * @param {object} gd
   * @param {[integer]} traces: trace indices to search for axes to clear the types of
   * @param {object} layoutUpdate: any update being done concurrently to the layout,
   *   which may supercede clearing the axis types
   */
  var axLetters = ['x', 'y', 'z'];
  exports.clearAxisTypes = function(gd, traces, layoutUpdate) {
      for(var i = 0; i < traces.length; i++) {
          var trace = gd._fullData[i];
          for(var j = 0; j < 3; j++) {
              var ax = getFromTrace(gd, trace, axLetters[j]);
  
              // do not clear log type - that's never an auto result so must have been intentional
              if(ax && ax.type !== 'log') {
                  var axAttr = ax._name;
                  var sceneName = ax._id.substr(1);
                  if(sceneName.substr(0, 5) === 'scene') {
                      if(layoutUpdate[sceneName] !== undefined) continue;
                      axAttr = sceneName + '.' + axAttr;
                  }
                  var typeAttr = axAttr + '.type';
  
                  if(layoutUpdate[axAttr] === undefined && layoutUpdate[typeAttr] === undefined) {
                      Lib.nestedProperty(gd.layout, typeAttr).set(null);
                  }
              }
          }
      }
  };
  
  },{"../components/color":615,"../lib":750,"../plots/cartesian/axis_ids":802,"../plots/plots":862,"../registry":882,"fast-isnumeric":241,"gl-mat4/fromQuat":275}],783:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var main = _dereq_('./plot_api');
  
  exports.plot = main.plot;
  exports.newPlot = main.newPlot;
  exports.restyle = main.restyle;
  exports.relayout = main.relayout;
  exports.redraw = main.redraw;
  exports.update = main.update;
  exports._guiRestyle = main._guiRestyle;
  exports._guiRelayout = main._guiRelayout;
  exports._guiUpdate = main._guiUpdate;
  exports._storeDirectGUIEdit = main._storeDirectGUIEdit;
  exports.react = main.react;
  exports.extendTraces = main.extendTraces;
  exports.prependTraces = main.prependTraces;
  exports.addTraces = main.addTraces;
  exports.deleteTraces = main.deleteTraces;
  exports.moveTraces = main.moveTraces;
  exports.purge = main.purge;
  exports.addFrames = main.addFrames;
  exports.deleteFrames = main.deleteFrames;
  exports.animate = main.animate;
  exports.setPlotConfig = main.setPlotConfig;
  
  exports.toImage = _dereq_('./to_image');
  exports.validate = _dereq_('./validate');
  exports.downloadImage = _dereq_('../snapshot/download');
  
  var templateApi = _dereq_('./template_api');
  exports.makeTemplate = templateApi.makeTemplate;
  exports.validateTemplate = templateApi.validateTemplate;
  
  },{"../snapshot/download":884,"./plot_api":785,"./template_api":790,"./to_image":791,"./validate":792}],784:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isPlainObject = _dereq_('../lib/is_plain_object');
  var noop = _dereq_('../lib/noop');
  var Loggers = _dereq_('../lib/loggers');
  var sorterAsc = _dereq_('../lib/search').sorterAsc;
  var Registry = _dereq_('../registry');
  
  
  exports.containerArrayMatch = _dereq_('./container_array_match');
  
  var isAddVal = exports.isAddVal = function isAddVal(val) {
      return val === 'add' || isPlainObject(val);
  };
  
  var isRemoveVal = exports.isRemoveVal = function isRemoveVal(val) {
      return val === null || val === 'remove';
  };
  
  /*
   * applyContainerArrayChanges: for managing arrays of layout components in relayout
   * handles them all with a consistent interface.
   *
   * Here are the supported actions -> relayout calls -> edits we get here
   * (as prepared in _relayout):
   *
   * add an empty obj -> {'annotations[2]': 'add'} -> {2: {'': 'add'}}
   * add a specific obj -> {'annotations[2]': {attrs}} -> {2: {'': {attrs}}}
   * delete an obj -> {'annotations[2]': 'remove'} -> {2: {'': 'remove'}}
   *               -> {'annotations[2]': null} -> {2: {'': null}}
   * delete the whole array -> {'annotations': 'remove'} -> {'': {'': 'remove'}}
   *                        -> {'annotations': null} -> {'': {'': null}}
   * edit an object -> {'annotations[2].text': 'boo'} -> {2: {'text': 'boo'}}
   *
   * You can combine many edits to different objects. Objects are added and edited
   * in ascending order, then removed in descending order.
   * For example, starting with [a, b, c], if you want to:
   * - replace b with d:
   *   {'annotations[1]': d, 'annotations[2]': null} (b is item 2 after adding d)
   * - add a new item d between a and b, and edit b:
   *    {'annotations[1]': d, 'annotations[2].x': newX} (b is item 2 after adding d)
   * - delete b and edit c:
   *    {'annotations[1]': null, 'annotations[2].x': newX} (c is edited before b is removed)
   *
   * You CANNOT combine adding/deleting an item at index `i` with edits to the same index `i`
   * You CANNOT combine replacing/deleting the whole array with anything else (for the same array).
   *
   * @param {HTMLDivElement} gd
   *  the DOM element of the graph container div
   * @param {Lib.nestedProperty} componentType: the array we are editing
   * @param {Object} edits
   *  the changes to make; keys are indices to edit, values are themselves objects:
   *  {attr: newValue} of changes to make to that index (with add/remove behavior
   *  in special values of the empty attr)
   * @param {Object} flags
   *  the flags for which actions we're going to perform to display these (and
   *  any other) changes. If we're already `recalc`ing, we don't need to redraw
   *  individual items
   * @param {function} _nestedProperty
   *  a (possibly modified for gui edits) nestedProperty constructor
   *  The modified version takes a 3rd argument, for a prefix to the attribute
   *  string necessary for storing GUI edits
   *
   * @returns {bool} `true` if it managed to complete drawing of the changes
   *  `false` would mean the parent should replot.
   */
  exports.applyContainerArrayChanges = function applyContainerArrayChanges(gd, np, edits, flags, _nestedProperty) {
      var componentType = np.astr;
      var supplyComponentDefaults = Registry.getComponentMethod(componentType, 'supplyLayoutDefaults');
      var draw = Registry.getComponentMethod(componentType, 'draw');
      var drawOne = Registry.getComponentMethod(componentType, 'drawOne');
      var replotLater = flags.replot || flags.recalc || (supplyComponentDefaults === noop) || (draw === noop);
      var layout = gd.layout;
      var fullLayout = gd._fullLayout;
  
      if(edits['']) {
          if(Object.keys(edits).length > 1) {
              Loggers.warn('Full array edits are incompatible with other edits',
                  componentType);
          }
  
          var fullVal = edits[''][''];
  
          if(isRemoveVal(fullVal)) np.set(null);
          else if(Array.isArray(fullVal)) np.set(fullVal);
          else {
              Loggers.warn('Unrecognized full array edit value', componentType, fullVal);
              return true;
          }
  
          if(replotLater) return false;
  
          supplyComponentDefaults(layout, fullLayout);
          draw(gd);
          return true;
      }
  
      var componentNums = Object.keys(edits).map(Number).sort(sorterAsc);
      var componentArrayIn = np.get();
      var componentArray = componentArrayIn || [];
      // componentArrayFull is used just to keep splices in line between
      // full and input arrays, so private keys can be copied over after
      // redoing supplyDefaults
      // TODO: this assumes componentArray is in gd.layout - which will not be
      // true after we extend this to restyle
      var componentArrayFull = _nestedProperty(fullLayout, componentType).get();
  
      var deletes = [];
      var firstIndexChange = -1;
      var maxIndex = componentArray.length;
      var i;
      var j;
      var componentNum;
      var objEdits;
      var objKeys;
      var objVal;
      var adding, prefix;
  
      // first make the add and edit changes
      for(i = 0; i < componentNums.length; i++) {
          componentNum = componentNums[i];
          objEdits = edits[componentNum];
          objKeys = Object.keys(objEdits);
          objVal = objEdits[''],
          adding = isAddVal(objVal);
  
          if(componentNum < 0 || componentNum > componentArray.length - (adding ? 0 : 1)) {
              Loggers.warn('index out of range', componentType, componentNum);
              continue;
          }
  
          if(objVal !== undefined) {
              if(objKeys.length > 1) {
                  Loggers.warn(
                      'Insertion & removal are incompatible with edits to the same index.',
                      componentType, componentNum);
              }
  
              if(isRemoveVal(objVal)) {
                  deletes.push(componentNum);
              } else if(adding) {
                  if(objVal === 'add') objVal = {};
                  componentArray.splice(componentNum, 0, objVal);
                  if(componentArrayFull) componentArrayFull.splice(componentNum, 0, {});
              } else {
                  Loggers.warn('Unrecognized full object edit value',
                      componentType, componentNum, objVal);
              }
  
              if(firstIndexChange === -1) firstIndexChange = componentNum;
          } else {
              for(j = 0; j < objKeys.length; j++) {
                  prefix = componentType + '[' + componentNum + '].';
                  _nestedProperty(componentArray[componentNum], objKeys[j], prefix)
                      .set(objEdits[objKeys[j]]);
              }
          }
      }
  
      // now do deletes
      for(i = deletes.length - 1; i >= 0; i--) {
          componentArray.splice(deletes[i], 1);
          // TODO: this drops private keys that had been stored in componentArrayFull
          // does this have any ill effects?
          if(componentArrayFull) componentArrayFull.splice(deletes[i], 1);
      }
  
      if(!componentArray.length) np.set(null);
      else if(!componentArrayIn) np.set(componentArray);
  
      if(replotLater) return false;
  
      supplyComponentDefaults(layout, fullLayout);
  
      // finally draw all the components we need to
      // if we added or removed any, redraw all after it
      if(drawOne !== noop) {
          var indicesToDraw;
          if(firstIndexChange === -1) {
              // there's no re-indexing to do, so only redraw components that changed
              indicesToDraw = componentNums;
          } else {
              // in case the component array was shortened, we still need do call
              // drawOne on the latter items so they get properly removed
              maxIndex = Math.max(componentArray.length, maxIndex);
              indicesToDraw = [];
              for(i = 0; i < componentNums.length; i++) {
                  componentNum = componentNums[i];
                  if(componentNum >= firstIndexChange) break;
                  indicesToDraw.push(componentNum);
              }
              for(i = firstIndexChange; i < maxIndex; i++) {
                  indicesToDraw.push(i);
              }
          }
          for(i = 0; i < indicesToDraw.length; i++) {
              drawOne(gd, indicesToDraw[i]);
          }
      } else draw(gd);
  
      return true;
  };
  
  },{"../lib/is_plain_object":751,"../lib/loggers":754,"../lib/noop":759,"../lib/search":769,"../registry":882,"./container_array_match":780}],785:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  var hasHover = _dereq_('has-hover');
  
  var Lib = _dereq_('../lib');
  var nestedProperty = Lib.nestedProperty;
  
  var Events = _dereq_('../lib/events');
  var Queue = _dereq_('../lib/queue');
  
  var Registry = _dereq_('../registry');
  var PlotSchema = _dereq_('./plot_schema');
  var Plots = _dereq_('../plots/plots');
  var Polar = _dereq_('../plots/polar/legacy');
  
  var Axes = _dereq_('../plots/cartesian/axes');
  var Drawing = _dereq_('../components/drawing');
  var Color = _dereq_('../components/color');
  var initInteractions = _dereq_('../plots/cartesian/graph_interact').initInteractions;
  var xmlnsNamespaces = _dereq_('../constants/xmlns_namespaces');
  var svgTextUtils = _dereq_('../lib/svg_text_utils');
  var clearSelect = _dereq_('../plots/cartesian/select').clearSelect;
  
  var dfltConfig = _dereq_('./plot_config').dfltConfig;
  var manageArrays = _dereq_('./manage_arrays');
  var helpers = _dereq_('./helpers');
  var subroutines = _dereq_('./subroutines');
  var editTypes = _dereq_('./edit_types');
  
  var AX_NAME_PATTERN = _dereq_('../plots/cartesian/constants').AX_NAME_PATTERN;
  
  var numericNameWarningCount = 0;
  var numericNameWarningCountLimit = 5;
  
  /**
   * Main plot-creation function
   *
   * @param {string id or DOM element} gd
   *      the id or DOM element of the graph container div
   * @param {array of objects} data
   *      array of traces, containing the data and display information for each trace
   * @param {object} layout
   *      object describing the overall display of the plot,
   *      all the stuff that doesn't pertain to any individual trace
   * @param {object} config
   *      configuration options (see ./plot_config.js for more info)
   *
   * OR
   *
   * @param {string id or DOM element} gd
   *      the id or DOM element of the graph container div
   * @param {object} figure
   *      object containing `data`, `layout`, `config`, and `frames` members
   *
   */
  function plot(gd, data, layout, config) {
      var frames;
  
      gd = Lib.getGraphDiv(gd);
  
      // Events.init is idempotent and bails early if gd has already been init'd
      Events.init(gd);
  
      if(Lib.isPlainObject(data)) {
          var obj = data;
          data = obj.data;
          layout = obj.layout;
          config = obj.config;
          frames = obj.frames;
      }
  
      var okToPlot = Events.triggerHandler(gd, 'plotly_beforeplot', [data, layout, config]);
      if(okToPlot === false) return Promise.reject();
  
      // if there's no data or layout, and this isn't yet a plotly plot
      // container, log a warning to help plotly.js users debug
      if(!data && !layout && !Lib.isPlotDiv(gd)) {
          Lib.warn('Calling Plotly.plot as if redrawing ' +
              'but this container doesn\'t yet have a plot.', gd);
      }
  
      function addFrames() {
          if(frames) {
              return exports.addFrames(gd, frames);
          }
      }
  
      // transfer configuration options to gd until we move over to
      // a more OO like model
      setPlotContext(gd, config);
  
      if(!layout) layout = {};
  
      // hook class for plots main container (in case of plotly.js
      // this won't be #embedded-graph or .js-tab-contents)
      d3.select(gd).classed('js-plotly-plot', true);
  
      // off-screen getBoundingClientRect testing space,
      // in #js-plotly-tester (and stored as Drawing.tester)
      // so we can share cached text across tabs
      Drawing.makeTester();
  
      // collect promises for any async actions during plotting
      // any part of the plotting code can push to gd._promises, then
      // before we move to the next step, we check that they're all
      // complete, and empty out the promise list again.
      if(!Array.isArray(gd._promises)) gd._promises = [];
  
      var graphWasEmpty = ((gd.data || []).length === 0 && Array.isArray(data));
  
      // if there is already data on the graph, append the new data
      // if you only want to redraw, pass a non-array for data
      if(Array.isArray(data)) {
          helpers.cleanData(data);
  
          if(graphWasEmpty) gd.data = data;
          else gd.data.push.apply(gd.data, data);
  
          // for routines outside graph_obj that want a clean tab
          // (rather than appending to an existing one) gd.empty
          // is used to determine whether to make a new tab
          gd.empty = false;
      }
  
      if(!gd.layout || graphWasEmpty) {
          gd.layout = helpers.cleanLayout(layout);
      }
  
      Plots.supplyDefaults(gd);
  
      var fullLayout = gd._fullLayout;
      var hasCartesian = fullLayout._has('cartesian');
  
      // Legacy polar plots
      if(!fullLayout._has('polar') && data && data[0] && data[0].r) {
          Lib.log('Legacy polar charts are deprecated!');
          return plotLegacyPolar(gd, data, layout);
      }
  
      // so we don't try to re-call Plotly.plot from inside
      // legend and colorbar, if margins changed
      fullLayout._replotting = true;
  
      // make or remake the framework if we need to
      if(graphWasEmpty || fullLayout._shouldCreateBgLayer) {
          makePlotFramework(gd);
  
          if(fullLayout._shouldCreateBgLayer) {
              delete fullLayout._shouldCreateBgLayer;
          }
      }
  
      // polar need a different framework
      if(gd.framework !== makePlotFramework) {
          gd.framework = makePlotFramework;
          makePlotFramework(gd);
      }
  
      // clear gradient defs on each .plot call, because we know we'll loop through all traces
      Drawing.initGradients(gd);
  
      // save initial show spikes once per graph
      if(graphWasEmpty) Axes.saveShowSpikeInitial(gd);
  
      // prepare the data and find the autorange
  
      // generate calcdata, if we need to
      // to force redoing calcdata, just delete it before calling Plotly.plot
      var recalc = !gd.calcdata || gd.calcdata.length !== (gd._fullData || []).length;
      if(recalc) Plots.doCalcdata(gd);
  
      // in case it has changed, attach fullData traces to calcdata
      for(var i = 0; i < gd.calcdata.length; i++) {
          gd.calcdata[i][0].trace = gd._fullData[i];
      }
  
      // make the figure responsive
      if(gd._context.responsive) {
          if(!gd._responsiveChartHandler) {
              // Keep a reference to the resize handler to purge it down the road
              gd._responsiveChartHandler = function() { if(!Lib.isHidden(gd)) Plots.resize(gd); };
  
              // Listen to window resize
              window.addEventListener('resize', gd._responsiveChartHandler);
          }
      } else {
          Lib.clearResponsive(gd);
      }
  
      /*
       * start async-friendly code - now we're actually drawing things
       */
  
      var oldMargins = Lib.extendFlat({}, fullLayout._size);
  
      // draw framework first so that margin-pushing
      // components can position themselves correctly
      var drawFrameworkCalls = 0;
      function drawFramework() {
          var basePlotModules = fullLayout._basePlotModules;
  
          for(var i = 0; i < basePlotModules.length; i++) {
              if(basePlotModules[i].drawFramework) {
                  basePlotModules[i].drawFramework(gd);
              }
          }
  
          if(!fullLayout._glcanvas && fullLayout._has('gl')) {
              fullLayout._glcanvas = fullLayout._glcontainer.selectAll('.gl-canvas').data([{
                  key: 'contextLayer',
                  context: true,
                  pick: false
              }, {
                  key: 'focusLayer',
                  context: false,
                  pick: false
              }, {
                  key: 'pickLayer',
                  context: false,
                  pick: true
              }], function(d) { return d.key; });
  
              fullLayout._glcanvas.enter().append('canvas')
                  .attr('class', function(d) {
                      return 'gl-canvas gl-canvas-' + d.key.replace('Layer', '');
                  })
                  .style({
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      overflow: 'visible',
                      'pointer-events': 'none'
                  });
          }
  
          if(fullLayout._glcanvas) {
              fullLayout._glcanvas
                  .attr('width', fullLayout.width)
                  .attr('height', fullLayout.height);
  
              var regl = fullLayout._glcanvas.data()[0].regl;
              if(regl) {
                  // Unfortunately, this can happen when relayouting to large
                  // width/height on some browsers.
                  if(Math.floor(fullLayout.width) !== regl._gl.drawingBufferWidth ||
                      Math.floor(fullLayout.height) !== regl._gl.drawingBufferHeight
                   ) {
                      var msg = 'WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.';
                      if(drawFrameworkCalls) {
                          Lib.error(msg);
                      } else {
                          Lib.log(msg + ' Clearing graph and plotting again.');
                          Plots.cleanPlot([], {}, gd._fullData, fullLayout);
                          Plots.supplyDefaults(gd);
                          fullLayout = gd._fullLayout;
                          Plots.doCalcdata(gd);
                          drawFrameworkCalls++;
                          return drawFramework();
                      }
                  }
              }
          }
  
          if(fullLayout.modebar.orientation === 'h') {
              fullLayout._modebardiv
                .style('height', null)
                .style('width', '100%');
          } else {
              fullLayout._modebardiv
                .style('width', null)
                .style('height', fullLayout.height + 'px');
          }
  
          return Plots.previousPromises(gd);
      }
  
      // draw anything that can affect margins.
      function marginPushers() {
          // First reset the list of things that are allowed to change the margins
          // So any deleted traces or components will be wiped out of the
          // automargin calculation.
          // This means *every* margin pusher must be listed here, even if it
          // doesn't actually try to push the margins until later.
          Plots.clearAutoMarginIds(gd);
  
          subroutines.drawMarginPushers(gd);
          Axes.allowAutoMargin(gd);
  
          // TODO can this be moved elsewhere?
          if(fullLayout._has('pie')) {
              var fullData = gd._fullData;
              for(var i = 0; i < fullData.length; i++) {
                  var trace = fullData[i];
                  if(trace.type === 'pie' && trace.automargin) {
                      Plots.allowAutoMargin(gd, 'pie.' + trace.uid + '.automargin');
                  }
              }
          }
  
          Plots.doAutoMargin(gd);
          return Plots.previousPromises(gd);
      }
  
      // in case the margins changed, draw margin pushers again
      function marginPushersAgain() {
          if(!Plots.didMarginChange(oldMargins, fullLayout._size)) return;
  
          return Lib.syncOrAsync([
              marginPushers,
              subroutines.layoutStyles
          ], gd);
      }
  
      function positionAndAutorange() {
          if(!recalc) {
              doAutoRangeAndConstraints();
              return;
          }
  
          // TODO: autosize extra for text markers and images
          // see https://github.com/plotly/plotly.js/issues/1111
          return Lib.syncOrAsync([
              Registry.getComponentMethod('shapes', 'calcAutorange'),
              Registry.getComponentMethod('annotations', 'calcAutorange'),
              doAutoRangeAndConstraints
          ], gd);
      }
  
      function doAutoRangeAndConstraints() {
          if(gd._transitioning) return;
  
          subroutines.doAutoRangeAndConstraints(gd);
  
          // store initial ranges *after* enforcing constraints, otherwise
          // we will never look like we're at the initial ranges
          if(graphWasEmpty) Axes.saveRangeInitial(gd);
  
          // this one is different from shapes/annotations calcAutorange
          // the others incorporate those components into ax._extremes,
          // this one actually sets the ranges in rangesliders.
          Registry.getComponentMethod('rangeslider', 'calcAutorange')(gd);
      }
  
      // draw ticks, titles, and calculate axis scaling (._b, ._m)
      function drawAxes() {
          return Axes.draw(gd, graphWasEmpty ? '' : 'redraw');
      }
  
      var seq = [
          Plots.previousPromises,
          addFrames,
          drawFramework,
          marginPushers,
          marginPushersAgain
      ];
  
      if(hasCartesian) seq.push(positionAndAutorange);
  
      seq.push(subroutines.layoutStyles);
      if(hasCartesian) seq.push(drawAxes);
  
      seq.push(
          subroutines.drawData,
          subroutines.finalDraw,
          initInteractions,
          Plots.addLinks,
          Plots.rehover,
          Plots.redrag,
          // TODO: doAutoMargin is only needed here for axis automargin, which
          // happens outside of marginPushers where all the other automargins are
          // calculated. Would be much better to separate margin calculations from
          // component drawing - see https://github.com/plotly/plotly.js/issues/2704
          Plots.doAutoMargin,
          Plots.previousPromises
      );
  
      // even if everything we did was synchronous, return a promise
      // so that the caller doesn't care which route we took
      var plotDone = Lib.syncOrAsync(seq, gd);
      if(!plotDone || !plotDone.then) plotDone = Promise.resolve();
  
      return plotDone.then(function() {
          emitAfterPlot(gd);
          return gd;
      });
  }
  
  function emitAfterPlot(gd) {
      var fullLayout = gd._fullLayout;
  
      if(fullLayout._redrawFromAutoMarginCount) {
          fullLayout._redrawFromAutoMarginCount--;
      } else {
          gd.emit('plotly_afterplot');
      }
  }
  
  function setPlotConfig(obj) {
      return Lib.extendFlat(dfltConfig, obj);
  }
  
  function setBackground(gd, bgColor) {
      try {
          gd._fullLayout._paper.style('background', bgColor);
      } catch(e) {
          Lib.error(e);
      }
  }
  
  function opaqueSetBackground(gd, bgColor) {
      var blend = Color.combine(bgColor, 'white');
      setBackground(gd, blend);
  }
  
  function setPlotContext(gd, config) {
      if(!gd._context) {
          gd._context = Lib.extendDeep({}, dfltConfig);
  
          // stash <base> href, used to make robust clipPath URLs
          var base = d3.select('base');
          gd._context._baseUrl = base.size() && base.attr('href') ?
              window.location.href.split('#')[0] :
              '';
      }
  
      var context = gd._context;
  
      var i, keys, key;
  
      if(config) {
          keys = Object.keys(config);
          for(i = 0; i < keys.length; i++) {
              key = keys[i];
              if(key === 'editable' || key === 'edits') continue;
              if(key in context) {
                  if(key === 'setBackground' && config[key] === 'opaque') {
                      context[key] = opaqueSetBackground;
                  } else {
                      context[key] = config[key];
                  }
              }
          }
  
          // map plot3dPixelRatio to plotGlPixelRatio for backward compatibility
          if(config.plot3dPixelRatio && !context.plotGlPixelRatio) {
              context.plotGlPixelRatio = context.plot3dPixelRatio;
          }
  
          // now deal with editable and edits - first editable overrides
          // everything, then edits refines
          var editable = config.editable;
          if(editable !== undefined) {
              // we're not going to *use* context.editable, we're only going to
              // use context.edits... but keep it for the record
              context.editable = editable;
  
              keys = Object.keys(context.edits);
              for(i = 0; i < keys.length; i++) {
                  context.edits[keys[i]] = editable;
              }
          }
          if(config.edits) {
              keys = Object.keys(config.edits);
              for(i = 0; i < keys.length; i++) {
                  key = keys[i];
                  if(key in context.edits) {
                      context.edits[key] = config.edits[key];
                  }
              }
          }
  
          // not part of the user-facing config options
          context._exportedPlot = config._exportedPlot;
      }
  
      // staticPlot forces a bunch of others:
      if(context.staticPlot) {
          context.editable = false;
          context.edits = {};
          context.autosizable = false;
          context.scrollZoom = false;
          context.doubleClick = false;
          context.showTips = false;
          context.showLink = false;
          context.displayModeBar = false;
      }
  
      // make sure hover-only devices have mode bar visible
      if(context.displayModeBar === 'hover' && !hasHover) {
          context.displayModeBar = true;
      }
  
      // default and fallback for setBackground
      if(context.setBackground === 'transparent' || typeof context.setBackground !== 'function') {
          context.setBackground = setBackground;
      }
  
      // Check if gd has a specified widht/height to begin with
      context._hasZeroHeight = context._hasZeroHeight || gd.clientHeight === 0;
      context._hasZeroWidth = context._hasZeroWidth || gd.clientWidth === 0;
  
      // fill context._scrollZoom helper to help manage scrollZoom flaglist
      var szIn = context.scrollZoom;
      var szOut = context._scrollZoom = {};
      if(szIn === true) {
          szOut.cartesian = 1;
          szOut.gl3d = 1;
          szOut.geo = 1;
          szOut.mapbox = 1;
      } else if(typeof szIn === 'string') {
          var parts = szIn.split('+');
          for(i = 0; i < parts.length; i++) {
              szOut[parts[i]] = 1;
          }
      } else if(szIn !== false) {
          szOut.gl3d = 1;
          szOut.geo = 1;
          szOut.mapbox = 1;
      }
  }
  
  function plotLegacyPolar(gd, data, layout) {
      // build or reuse the container skeleton
      var plotContainer = d3.select(gd).selectAll('.plot-container')
          .data([0]);
      plotContainer.enter()
          .insert('div', ':first-child')
          .classed('plot-container plotly', true);
      var paperDiv = plotContainer.selectAll('.svg-container')
          .data([0]);
      paperDiv.enter().append('div')
          .classed('svg-container', true)
          .style('position', 'relative');
  
      // empty it everytime for now
      paperDiv.html('');
  
      // fulfill gd requirements
      if(data) gd.data = data;
      if(layout) gd.layout = layout;
      Polar.manager.fillLayout(gd);
  
      // resize canvas
      paperDiv.style({
          width: gd._fullLayout.width + 'px',
          height: gd._fullLayout.height + 'px'
      });
  
      // instantiate framework
      gd.framework = Polar.manager.framework(gd);
  
      // plot
      gd.framework({data: gd.data, layout: gd.layout}, paperDiv.node());
  
      // set undo point
      gd.framework.setUndoPoint();
  
      // get the resulting svg for extending it
      var polarPlotSVG = gd.framework.svg();
  
      // editable title
      var opacity = 1;
      var txt = gd._fullLayout.title ? gd._fullLayout.title.text : '';
      if(txt === '' || !txt) opacity = 0;
  
      var titleLayout = function() {
          this.call(svgTextUtils.convertToTspans, gd);
          // TODO: html/mathjax
          // TODO: center title
      };
  
      var title = polarPlotSVG.select('.title-group text')
          .call(titleLayout);
  
      if(gd._context.edits.titleText) {
          var placeholderText = Lib._(gd, 'Click to enter Plot title');
          if(!txt || txt === placeholderText) {
              opacity = 0.2;
              // placeholder is not going through convertToTspans
              // so needs explicit data-unformatted
              title.attr({'data-unformatted': placeholderText})
                  .text(placeholderText)
                  .style({opacity: opacity})
                  .on('mouseover.opacity', function() {
                      d3.select(this).transition().duration(100)
                          .style('opacity', 1);
                  })
                  .on('mouseout.opacity', function() {
                      d3.select(this).transition().duration(1000)
                          .style('opacity', 0);
                  });
          }
  
          var setContenteditable = function() {
              this.call(svgTextUtils.makeEditable, {gd: gd})
                  .on('edit', function(text) {
                      gd.framework({layout: {title: {text: text}}});
                      this.text(text)
                          .call(titleLayout);
                      this.call(setContenteditable);
                  })
                  .on('cancel', function() {
                      var txt = this.attr('data-unformatted');
                      this.text(txt).call(titleLayout);
                  });
          };
          title.call(setContenteditable);
      }
  
      gd._context.setBackground(gd, gd._fullLayout.paper_bgcolor);
      Plots.addLinks(gd);
  
      return Promise.resolve();
  }
  
  // convenience function to force a full redraw, mostly for use by plotly.js
  function redraw(gd) {
      gd = Lib.getGraphDiv(gd);
  
      if(!Lib.isPlotDiv(gd)) {
          throw new Error('This element is not a Plotly plot: ' + gd);
      }
  
      helpers.cleanData(gd.data);
      helpers.cleanLayout(gd.layout);
  
      gd.calcdata = undefined;
      return exports.plot(gd).then(function() {
          gd.emit('plotly_redraw');
          return gd;
      });
  }
  
  /**
   * Convenience function to make idempotent plot option obvious to users.
   *
   * @param gd
   * @param {Object[]} data
   * @param {Object} layout
   * @param {Object} config
   */
  function newPlot(gd, data, layout, config) {
      gd = Lib.getGraphDiv(gd);
  
      // remove gl contexts
      Plots.cleanPlot([], {}, gd._fullData || [], gd._fullLayout || {});
  
      Plots.purge(gd);
      return exports.plot(gd, data, layout, config);
  }
  
  /**
   * Wrap negative indicies to their positive counterparts.
   *
   * @param {Number[]} indices An array of indices
   * @param {Number} maxIndex The maximum index allowable (arr.length - 1)
   */
  function positivifyIndices(indices, maxIndex) {
      var parentLength = maxIndex + 1;
      var positiveIndices = [];
      var i;
      var index;
  
      for(i = 0; i < indices.length; i++) {
          index = indices[i];
          if(index < 0) {
              positiveIndices.push(parentLength + index);
          } else {
              positiveIndices.push(index);
          }
      }
      return positiveIndices;
  }
  
  /**
   * Ensures that an index array for manipulating gd.data is valid.
   *
   * Intended for use with addTraces, deleteTraces, and moveTraces.
   *
   * @param gd
   * @param indices
   * @param arrayName
   */
  function assertIndexArray(gd, indices, arrayName) {
      var i,
          index;
  
      for(i = 0; i < indices.length; i++) {
          index = indices[i];
  
          // validate that indices are indeed integers
          if(index !== parseInt(index, 10)) {
              throw new Error('all values in ' + arrayName + ' must be integers');
          }
  
          // check that all indices are in bounds for given gd.data array length
          if(index >= gd.data.length || index < -gd.data.length) {
              throw new Error(arrayName + ' must be valid indices for gd.data.');
          }
  
          // check that indices aren't repeated
          if(indices.indexOf(index, i + 1) > -1 ||
                  index >= 0 && indices.indexOf(-gd.data.length + index) > -1 ||
                  index < 0 && indices.indexOf(gd.data.length + index) > -1) {
              throw new Error('each index in ' + arrayName + ' must be unique.');
          }
      }
  }
  
  /**
   * Private function used by Plotly.moveTraces to check input args
   *
   * @param gd
   * @param currentIndices
   * @param newIndices
   */
  function checkMoveTracesArgs(gd, currentIndices, newIndices) {
      // check that gd has attribute 'data' and 'data' is array
      if(!Array.isArray(gd.data)) {
          throw new Error('gd.data must be an array.');
      }
  
      // validate currentIndices array
      if(typeof currentIndices === 'undefined') {
          throw new Error('currentIndices is a required argument.');
      } else if(!Array.isArray(currentIndices)) {
          currentIndices = [currentIndices];
      }
      assertIndexArray(gd, currentIndices, 'currentIndices');
  
      // validate newIndices array if it exists
      if(typeof newIndices !== 'undefined' && !Array.isArray(newIndices)) {
          newIndices = [newIndices];
      }
      if(typeof newIndices !== 'undefined') {
          assertIndexArray(gd, newIndices, 'newIndices');
      }
  
      // check currentIndices and newIndices are the same length if newIdices exists
      if(typeof newIndices !== 'undefined' && currentIndices.length !== newIndices.length) {
          throw new Error('current and new indices must be of equal length.');
      }
  }
  /**
   * A private function to reduce the type checking clutter in addTraces.
   *
   * @param gd
   * @param traces
   * @param newIndices
   */
  function checkAddTracesArgs(gd, traces, newIndices) {
      var i, value;
  
      // check that gd has attribute 'data' and 'data' is array
      if(!Array.isArray(gd.data)) {
          throw new Error('gd.data must be an array.');
      }
  
      // make sure traces exists
      if(typeof traces === 'undefined') {
          throw new Error('traces must be defined.');
      }
  
      // make sure traces is an array
      if(!Array.isArray(traces)) {
          traces = [traces];
      }
  
      // make sure each value in traces is an object
      for(i = 0; i < traces.length; i++) {
          value = traces[i];
          if(typeof value !== 'object' || (Array.isArray(value) || value === null)) {
              throw new Error('all values in traces array must be non-array objects');
          }
      }
  
      // make sure we have an index for each trace
      if(typeof newIndices !== 'undefined' && !Array.isArray(newIndices)) {
          newIndices = [newIndices];
      }
      if(typeof newIndices !== 'undefined' && newIndices.length !== traces.length) {
          throw new Error(
              'if indices is specified, traces.length must equal indices.length'
          );
      }
  }
  
  /**
   * A private function to reduce the type checking clutter in spliceTraces.
   * Get all update Properties from gd.data. Validate inputs and outputs.
   * Used by prependTrace and extendTraces
   *
   * @param gd
   * @param update
   * @param indices
   * @param maxPoints
   */
  function assertExtendTracesArgs(gd, update, indices, maxPoints) {
      var maxPointsIsObject = Lib.isPlainObject(maxPoints);
  
      if(!Array.isArray(gd.data)) {
          throw new Error('gd.data must be an array');
      }
      if(!Lib.isPlainObject(update)) {
          throw new Error('update must be a key:value object');
      }
  
      if(typeof indices === 'undefined') {
          throw new Error('indices must be an integer or array of integers');
      }
  
      assertIndexArray(gd, indices, 'indices');
  
      for(var key in update) {
          /*
           * Verify that the attribute to be updated contains as many trace updates
           * as indices. Failure must result in throw and no-op
           */
          if(!Array.isArray(update[key]) || update[key].length !== indices.length) {
              throw new Error('attribute ' + key + ' must be an array of length equal to indices array length');
          }
  
          /*
           * if maxPoints is an object it must match keys and array lengths of 'update' 1:1
           */
          if(maxPointsIsObject &&
              (!(key in maxPoints) || !Array.isArray(maxPoints[key]) ||
              maxPoints[key].length !== update[key].length)) {
              throw new Error('when maxPoints is set as a key:value object it must contain a 1:1 ' +
                              'corrispondence with the keys and number of traces in the update object');
          }
      }
  }
  
  /**
   * A private function to reduce the type checking clutter in spliceTraces.
   *
   * @param {Object|HTMLDivElement} gd
   * @param {Object} update
   * @param {Number[]} indices
   * @param {Number||Object} maxPoints
   * @return {Object[]}
   */
  function getExtendProperties(gd, update, indices, maxPoints) {
      var maxPointsIsObject = Lib.isPlainObject(maxPoints);
      var updateProps = [];
      var trace, target, prop, insert, maxp;
  
      // allow scalar index to represent a single trace position
      if(!Array.isArray(indices)) indices = [indices];
  
      // negative indices are wrapped around to their positive value. Equivalent to python indexing.
      indices = positivifyIndices(indices, gd.data.length - 1);
  
      // loop through all update keys and traces and harvest validated data.
      for(var key in update) {
          for(var j = 0; j < indices.length; j++) {
              /*
               * Choose the trace indexed by the indices map argument and get the prop setter-getter
               * instance that references the key and value for this particular trace.
               */
              trace = gd.data[indices[j]];
              prop = nestedProperty(trace, key);
  
              /*
               * Target is the existing gd.data.trace.dataArray value like "x" or "marker.size"
               * Target must exist as an Array to allow the extend operation to be performed.
               */
              target = prop.get();
              insert = update[key][j];
  
              if(!Lib.isArrayOrTypedArray(insert)) {
                  throw new Error('attribute: ' + key + ' index: ' + j + ' must be an array');
              }
              if(!Lib.isArrayOrTypedArray(target)) {
                  throw new Error('cannot extend missing or non-array attribute: ' + key);
              }
              if(target.constructor !== insert.constructor) {
                  throw new Error('cannot extend array with an array of a different type: ' + key);
              }
  
              /*
               * maxPoints may be an object map or a scalar. If object select the key:value, else
               * Use the scalar maxPoints for all key and trace combinations.
               */
              maxp = maxPointsIsObject ? maxPoints[key][j] : maxPoints;
  
              // could have chosen null here, -1 just tells us to not take a window
              if(!isNumeric(maxp)) maxp = -1;
  
              /*
               * Wrap the nestedProperty in an object containing required data
               * for lengthening and windowing this particular trace - key combination.
               * Flooring maxp mirrors the behaviour of floats in the Array.slice JSnative function.
               */
              updateProps.push({
                  prop: prop,
                  target: target,
                  insert: insert,
                  maxp: Math.floor(maxp)
              });
          }
      }
  
      // all target and insertion data now validated
      return updateProps;
  }
  
  /**
   * A private function to key Extend and Prepend traces DRY
   *
   * @param {Object|HTMLDivElement} gd
   * @param {Object} update
   * @param {Number[]} indices
   * @param {Number||Object} maxPoints
   * @param {Function} updateArray
   * @return {Object}
   */
  function spliceTraces(gd, update, indices, maxPoints, updateArray) {
      assertExtendTracesArgs(gd, update, indices, maxPoints);
  
      var updateProps = getExtendProperties(gd, update, indices, maxPoints);
      var undoUpdate = {};
      var undoPoints = {};
  
      for(var i = 0; i < updateProps.length; i++) {
          var prop = updateProps[i].prop;
          var maxp = updateProps[i].maxp;
  
          // return new array and remainder
          var out = updateArray(updateProps[i].target, updateProps[i].insert, maxp);
          prop.set(out[0]);
  
          // build the inverse update object for the undo operation
          if(!Array.isArray(undoUpdate[prop.astr])) undoUpdate[prop.astr] = [];
          undoUpdate[prop.astr].push(out[1]);
  
           // build the matching maxPoints undo object containing original trace lengths
          if(!Array.isArray(undoPoints[prop.astr])) undoPoints[prop.astr] = [];
          undoPoints[prop.astr].push(updateProps[i].target.length);
      }
  
      return {update: undoUpdate, maxPoints: undoPoints};
  }
  
  function concatTypedArray(arr0, arr1) {
      var arr2 = new arr0.constructor(arr0.length + arr1.length);
      arr2.set(arr0);
      arr2.set(arr1, arr0.length);
      return arr2;
  }
  
  /**
   * extend && prepend traces at indices with update arrays, window trace lengths to maxPoints
   *
   * Extend and Prepend have identical APIs. Prepend inserts an array at the head while Extend
   * inserts an array off the tail. Prepend truncates the tail of the array - counting maxPoints
   * from the head, whereas Extend truncates the head of the array, counting backward maxPoints
   * from the tail.
   *
   * If maxPoints is undefined, nonNumeric, negative or greater than extended trace length no
   * truncation / windowing will be performed. If its zero, well the whole trace is truncated.
   *
   * @param {Object|HTMLDivElement} gd The graph div
   * @param {Object} update The key:array map of target attributes to extend
   * @param {Number|Number[]} indices The locations of traces to be extended
   * @param {Number|Object} [maxPoints] Number of points for trace window after lengthening.
   *
   */
  function extendTraces(gd, update, indices, maxPoints) {
      gd = Lib.getGraphDiv(gd);
  
      function updateArray(target, insert, maxp) {
          var newArray, remainder;
  
          if(Lib.isTypedArray(target)) {
              if(maxp < 0) {
                  var none = new target.constructor(0);
                  var both = concatTypedArray(target, insert);
  
                  if(maxp < 0) {
                      newArray = both;
                      remainder = none;
                  } else {
                      newArray = none;
                      remainder = both;
                  }
              } else {
                  newArray = new target.constructor(maxp);
                  remainder = new target.constructor(target.length + insert.length - maxp);
  
                  if(maxp === insert.length) {
                      newArray.set(insert);
                      remainder.set(target);
                  } else if(maxp < insert.length) {
                      var numberOfItemsFromInsert = insert.length - maxp;
  
                      newArray.set(insert.subarray(numberOfItemsFromInsert));
                      remainder.set(target);
                      remainder.set(insert.subarray(0, numberOfItemsFromInsert), target.length);
                  } else {
                      var numberOfItemsFromTarget = maxp - insert.length;
                      var targetBegin = target.length - numberOfItemsFromTarget;
  
                      newArray.set(target.subarray(targetBegin));
                      newArray.set(insert, numberOfItemsFromTarget);
                      remainder.set(target.subarray(0, targetBegin));
                  }
              }
          } else {
              newArray = target.concat(insert);
              remainder = (maxp >= 0 && maxp < newArray.length) ?
                  newArray.splice(0, newArray.length - maxp) :
                  [];
          }
  
          return [newArray, remainder];
      }
  
      var undo = spliceTraces(gd, update, indices, maxPoints, updateArray);
      var promise = exports.redraw(gd);
      var undoArgs = [gd, undo.update, indices, undo.maxPoints];
      Queue.add(gd, exports.prependTraces, undoArgs, extendTraces, arguments);
  
      return promise;
  }
  
  function prependTraces(gd, update, indices, maxPoints) {
      gd = Lib.getGraphDiv(gd);
  
      function updateArray(target, insert, maxp) {
          var newArray, remainder;
  
          if(Lib.isTypedArray(target)) {
              if(maxp <= 0) {
                  var none = new target.constructor(0);
                  var both = concatTypedArray(insert, target);
  
                  if(maxp < 0) {
                      newArray = both;
                      remainder = none;
                  } else {
                      newArray = none;
                      remainder = both;
                  }
              } else {
                  newArray = new target.constructor(maxp);
                  remainder = new target.constructor(target.length + insert.length - maxp);
  
                  if(maxp === insert.length) {
                      newArray.set(insert);
                      remainder.set(target);
                  } else if(maxp < insert.length) {
                      var numberOfItemsFromInsert = insert.length - maxp;
  
                      newArray.set(insert.subarray(0, numberOfItemsFromInsert));
                      remainder.set(insert.subarray(numberOfItemsFromInsert));
                      remainder.set(target, numberOfItemsFromInsert);
                  } else {
                      var numberOfItemsFromTarget = maxp - insert.length;
  
                      newArray.set(insert);
                      newArray.set(target.subarray(0, numberOfItemsFromTarget), insert.length);
                      remainder.set(target.subarray(numberOfItemsFromTarget));
                  }
              }
          } else {
              newArray = insert.concat(target);
              remainder = (maxp >= 0 && maxp < newArray.length) ?
                  newArray.splice(maxp, newArray.length) :
                  [];
          }
  
          return [newArray, remainder];
      }
  
      var undo = spliceTraces(gd, update, indices, maxPoints, updateArray);
      var promise = exports.redraw(gd);
      var undoArgs = [gd, undo.update, indices, undo.maxPoints];
      Queue.add(gd, exports.extendTraces, undoArgs, prependTraces, arguments);
  
      return promise;
  }
  
  /**
   * Add data traces to an existing graph div.
   *
   * @param {Object|HTMLDivElement} gd The graph div
   * @param {Object[]} gd.data The array of traces we're adding to
   * @param {Object[]|Object} traces The object or array of objects to add
   * @param {Number[]|Number} [newIndices=[gd.data.length]] Locations to add traces
   *
   */
  function addTraces(gd, traces, newIndices) {
      gd = Lib.getGraphDiv(gd);
  
      var currentIndices = [];
      var undoFunc = exports.deleteTraces;
      var redoFunc = addTraces;
      var undoArgs = [gd, currentIndices];
      var redoArgs = [gd, traces];  // no newIndices here
      var i;
      var promise;
  
      // all validation is done elsewhere to remove clutter here
      checkAddTracesArgs(gd, traces, newIndices);
  
      // make sure traces is an array
      if(!Array.isArray(traces)) {
          traces = [traces];
      }
  
      // make sure traces do not repeat existing ones
      traces = traces.map(function(trace) {
          return Lib.extendFlat({}, trace);
      });
  
      helpers.cleanData(traces);
  
      // add the traces to gd.data (no redrawing yet!)
      for(i = 0; i < traces.length; i++) {
          gd.data.push(traces[i]);
      }
  
      // to continue, we need to call moveTraces which requires currentIndices
      for(i = 0; i < traces.length; i++) {
          currentIndices.push(-traces.length + i);
      }
  
      // if the user didn't define newIndices, they just want the traces appended
      // i.e., we can simply redraw and be done
      if(typeof newIndices === 'undefined') {
          promise = exports.redraw(gd);
          Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
          return promise;
      }
  
      // make sure indices is property defined
      if(!Array.isArray(newIndices)) {
          newIndices = [newIndices];
      }
  
      try {
          // this is redundant, but necessary to not catch later possible errors!
          checkMoveTracesArgs(gd, currentIndices, newIndices);
      } catch(error) {
          // something went wrong, reset gd to be safe and rethrow error
          gd.data.splice(gd.data.length - traces.length, traces.length);
          throw error;
      }
  
      // if we're here, the user has defined specific places to place the new traces
      // this requires some extra work that moveTraces will do
      Queue.startSequence(gd);
      Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
      promise = exports.moveTraces(gd, currentIndices, newIndices);
      Queue.stopSequence(gd);
      return promise;
  }
  
  /**
   * Delete traces at `indices` from gd.data array.
   *
   * @param {Object|HTMLDivElement} gd The graph div
   * @param {Object[]} gd.data The array of traces we're removing from
   * @param {Number|Number[]} indices The indices
   */
  function deleteTraces(gd, indices) {
      gd = Lib.getGraphDiv(gd);
  
      var traces = [];
      var undoFunc = exports.addTraces;
      var redoFunc = deleteTraces;
      var undoArgs = [gd, traces, indices];
      var redoArgs = [gd, indices];
      var i;
      var deletedTrace;
  
      // make sure indices are defined
      if(typeof indices === 'undefined') {
          throw new Error('indices must be an integer or array of integers.');
      } else if(!Array.isArray(indices)) {
          indices = [indices];
      }
      assertIndexArray(gd, indices, 'indices');
  
      // convert negative indices to positive indices
      indices = positivifyIndices(indices, gd.data.length - 1);
  
      // we want descending here so that splicing later doesn't affect indexing
      indices.sort(Lib.sorterDes);
      for(i = 0; i < indices.length; i += 1) {
          deletedTrace = gd.data.splice(indices[i], 1)[0];
          traces.push(deletedTrace);
      }
  
      var promise = exports.redraw(gd);
      Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
  
      return promise;
  }
  
  /**
   * Move traces at currentIndices array to locations in newIndices array.
   *
   * If newIndices is omitted, currentIndices will be moved to the end. E.g.,
   * these are equivalent:
   *
   * Plotly.moveTraces(gd, [1, 2, 3], [-3, -2, -1])
   * Plotly.moveTraces(gd, [1, 2, 3])
   *
   * @param {Object|HTMLDivElement} gd The graph div
   * @param {Object[]} gd.data The array of traces we're removing from
   * @param {Number|Number[]} currentIndices The locations of traces to be moved
   * @param {Number|Number[]} [newIndices] The locations to move traces to
   *
   * Example calls:
   *
   *      // move trace i to location x
   *      Plotly.moveTraces(gd, i, x)
   *
   *      // move trace i to end of array
   *      Plotly.moveTraces(gd, i)
   *
   *      // move traces i, j, k to end of array (i != j != k)
   *      Plotly.moveTraces(gd, [i, j, k])
   *
   *      // move traces [i, j, k] to [x, y, z] (i != j != k) (x != y != z)
   *      Plotly.moveTraces(gd, [i, j, k], [x, y, z])
   *
   *      // reorder all traces (assume there are 5--a, b, c, d, e)
   *      Plotly.moveTraces(gd, [b, d, e, a, c])  // same as 'move to end'
   */
  function moveTraces(gd, currentIndices, newIndices) {
      gd = Lib.getGraphDiv(gd);
  
      var newData = [];
      var movingTraceMap = [];
      var undoFunc = moveTraces;
      var redoFunc = moveTraces;
      var undoArgs = [gd, newIndices, currentIndices];
      var redoArgs = [gd, currentIndices, newIndices];
      var i;
  
      // to reduce complexity here, check args elsewhere
      // this throws errors where appropriate
      checkMoveTracesArgs(gd, currentIndices, newIndices);
  
      // make sure currentIndices is an array
      currentIndices = Array.isArray(currentIndices) ? currentIndices : [currentIndices];
  
      // if undefined, define newIndices to point to the end of gd.data array
      if(typeof newIndices === 'undefined') {
          newIndices = [];
          for(i = 0; i < currentIndices.length; i++) {
              newIndices.push(-currentIndices.length + i);
          }
      }
  
      // make sure newIndices is an array if it's user-defined
      newIndices = Array.isArray(newIndices) ? newIndices : [newIndices];
  
      // convert negative indices to positive indices (they're the same length)
      currentIndices = positivifyIndices(currentIndices, gd.data.length - 1);
      newIndices = positivifyIndices(newIndices, gd.data.length - 1);
  
      // at this point, we've coerced the index arrays into predictable forms
  
      // get the traces that aren't being moved around
      for(i = 0; i < gd.data.length; i++) {
          // if index isn't in currentIndices, include it in ignored!
          if(currentIndices.indexOf(i) === -1) {
              newData.push(gd.data[i]);
          }
      }
  
      // get a mapping of indices to moving traces
      for(i = 0; i < currentIndices.length; i++) {
          movingTraceMap.push({newIndex: newIndices[i], trace: gd.data[currentIndices[i]]});
      }
  
      // reorder this mapping by newIndex, ascending
      movingTraceMap.sort(function(a, b) {
          return a.newIndex - b.newIndex;
      });
  
      // now, add the moving traces back in, in order!
      for(i = 0; i < movingTraceMap.length; i += 1) {
          newData.splice(movingTraceMap[i].newIndex, 0, movingTraceMap[i].trace);
      }
  
      gd.data = newData;
  
      var promise = exports.redraw(gd);
      Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
  
      return promise;
  }
  
  /**
   * restyle: update trace attributes of an existing plot
   *
   * Can be called two ways.
   *
   * Signature 1:
   * @param {String | HTMLDivElement} gd
   *  the id or DOM element of the graph container div
   * @param {String} astr
   *  attribute string (like `'marker.symbol'`) to update
   * @param {*} val
   *  value to give this attribute
   * @param {Number[] | Number} [traces]
   *  integer or array of integers for the traces to alter (all if omitted)
   *
   * Signature 2:
   * @param {String | HTMLDivElement} gd
   *  (as in signature 1)
   * @param {Object} aobj
   *  attribute object `{astr1: val1, astr2: val2 ...}`
   *  allows setting multiple attributes simultaneously
   * @param {Number[] | Number} [traces]
   *  (as in signature 1)
   *
   * `val` (or `val1`, `val2` ... in the object form) can be an array,
   * to apply different values to each trace.
   *
   * If the array is too short, it will wrap around (useful for
   * style files that want to specify cyclical default values).
   */
  function restyle(gd, astr, val, _traces) {
      gd = Lib.getGraphDiv(gd);
      helpers.clearPromiseQueue(gd);
  
      var aobj = {};
      if(typeof astr === 'string') aobj[astr] = val;
      else if(Lib.isPlainObject(astr)) {
          // the 3-arg form
          aobj = Lib.extendFlat({}, astr);
          if(_traces === undefined) _traces = val;
      } else {
          Lib.warn('Restyle fail.', astr, val, _traces);
          return Promise.reject();
      }
  
      if(Object.keys(aobj).length) gd.changed = true;
  
      var traces = helpers.coerceTraceIndices(gd, _traces);
  
      var specs = _restyle(gd, aobj, traces);
      var flags = specs.flags;
  
      // clear calcdata and/or axis types if required so they get regenerated
      if(flags.calc) gd.calcdata = undefined;
      if(flags.clearAxisTypes) helpers.clearAxisTypes(gd, traces, {});
  
      // fill in redraw sequence
      var seq = [];
  
      if(flags.fullReplot) {
          seq.push(exports.plot);
      } else {
          seq.push(Plots.previousPromises);
  
          // maybe only call Plots.supplyDataDefaults in the splom case,
          // to skip over long and slow axes defaults
          Plots.supplyDefaults(gd);
  
          if(flags.markerSize) {
              Plots.doCalcdata(gd);
              addAxRangeSequence(seq);
  
              // TODO
              // if all axes have autorange:false, then
              // proceed to subroutines.doTraceStyle(),
              // otherwise we must go through addAxRangeSequence,
              // which in general must redraws 'all' axes
          }
  
          if(flags.style) seq.push(subroutines.doTraceStyle);
          if(flags.colorbars) seq.push(subroutines.doColorBars);
  
          seq.push(emitAfterPlot);
      }
  
      seq.push(Plots.rehover, Plots.redrag);
  
      Queue.add(gd,
          restyle, [gd, specs.undoit, specs.traces],
          restyle, [gd, specs.redoit, specs.traces]
      );
  
      var plotDone = Lib.syncOrAsync(seq, gd);
      if(!plotDone || !plotDone.then) plotDone = Promise.resolve();
  
      return plotDone.then(function() {
          gd.emit('plotly_restyle', specs.eventData);
          return gd;
      });
  }
  
  // for undo: undefined initial vals must be turned into nulls
  // so that we unset rather than ignore them
  function undefinedToNull(val) {
      if(val === undefined) return null;
      return val;
  }
  
  /**
   * Factory function to wrap nestedProperty with GUI edits if necessary
   * with GUI edits we add an optional prefix to the nestedProperty constructor
   * to prepend to the attribute string in the preGUI store.
   */
  function makeNP(preGUI, guiEditFlag) {
      if(!guiEditFlag) return nestedProperty;
  
      return function(container, attr, prefix) {
          var np = nestedProperty(container, attr);
          var npSet = np.set;
          np.set = function(val) {
              var fullAttr = (prefix || '') + attr;
              storeCurrent(fullAttr, np.get(), val, preGUI);
              npSet(val);
          };
          return np;
      };
  }
  
  function storeCurrent(attr, val, newVal, preGUI) {
      if(Array.isArray(val) || Array.isArray(newVal)) {
          var arrayVal = Array.isArray(val) ? val : [];
          var arrayNew = Array.isArray(newVal) ? newVal : [];
          var maxLen = Math.max(arrayVal.length, arrayNew.length);
          for(var i = 0; i < maxLen; i++) {
              storeCurrent(attr + '[' + i + ']', arrayVal[i], arrayNew[i], preGUI);
          }
      } else if(Lib.isPlainObject(val) || Lib.isPlainObject(newVal)) {
          var objVal = Lib.isPlainObject(val) ? val : {};
          var objNew = Lib.isPlainObject(newVal) ? newVal : {};
          var objBoth = Lib.extendFlat({}, objVal, objNew);
          for(var key in objBoth) {
              storeCurrent(attr + '.' + key, objVal[key], objNew[key], preGUI);
          }
      } else if(preGUI[attr] === undefined) {
          preGUI[attr] = undefinedToNull(val);
      }
  }
  
  /**
   * storeDirectGUIEdit: for routines that skip restyle/relayout and mock it
   * by emitting a plotly_restyle or plotly_relayout event, this routine
   * keeps track of the initial state in _preGUI for use by uirevision
   * Does *not* apply these changes to data/layout - that's the responsibility
   * of the calling routine.
   *
   * @param {object} container: the input attributes container (eg `layout` or a `trace`)
   * @param {object} preGUI: where original values should be stored, either
   *     `layout._preGUI` or `layout._tracePreGUI[uid]`
   * @param {object} edits: the {attr: val} object as normally passed to `relayout` etc
   */
  function _storeDirectGUIEdit(container, preGUI, edits) {
      for(var attr in edits) {
          var np = nestedProperty(container, attr);
          storeCurrent(attr, np.get(), edits[attr], preGUI);
      }
  }
  
  function _restyle(gd, aobj, traces) {
      var fullLayout = gd._fullLayout;
      var fullData = gd._fullData;
      var data = gd.data;
      var guiEditFlag = fullLayout._guiEditing;
      var layoutNP = makeNP(fullLayout._preGUI, guiEditFlag);
      var eventData = Lib.extendDeepAll({}, aobj);
      var i;
  
      cleanDeprecatedAttributeKeys(aobj);
  
      // initialize flags
      var flags = editTypes.traceFlags();
  
      // copies of the change (and previous values of anything affected)
      // for the undo / redo queue
      var redoit = {};
      var undoit = {};
      var axlist;
  
      // make a new empty vals array for undoit
      function a0() { return traces.map(function() { return undefined; }); }
  
      // for autoranging multiple axes
      function addToAxlist(axid) {
          var axName = Axes.id2name(axid);
          if(axlist.indexOf(axName) === -1) axlist.push(axName);
      }
  
      function autorangeAttr(axName) { return 'LAYOUT' + axName + '.autorange'; }
  
      function rangeAttr(axName) { return 'LAYOUT' + axName + '.range'; }
  
      function getFullTrace(traceIndex) {
          // usually fullData maps 1:1 onto data, but with groupby transforms
          // the fullData index can be greater. Take the *first* matching trace.
          for(var j = traceIndex; j < fullData.length; j++) {
              if(fullData[j]._input === data[traceIndex]) return fullData[j];
          }
          // should never get here - and if we *do* it should cause an error
          // later on undefined fullTrace is passed to nestedProperty.
      }
  
      // for attrs that interact (like scales & autoscales), save the
      // old vals before making the change
      // val=undefined will not set a value, just record what the value was.
      // val=null will delete the attribute
      // attr can be an array to set several at once (all to the same val)
      function doextra(attr, val, i) {
          if(Array.isArray(attr)) {
              attr.forEach(function(a) { doextra(a, val, i); });
              return;
          }
          // quit if explicitly setting this elsewhere
          if(attr in aobj || helpers.hasParent(aobj, attr)) return;
  
          var extraparam;
          if(attr.substr(0, 6) === 'LAYOUT') {
              extraparam = layoutNP(gd.layout, attr.replace('LAYOUT', ''));
          } else {
              var tracei = traces[i];
              var preGUI = fullLayout._tracePreGUI[getFullTrace(tracei)._fullInput.uid];
              extraparam = makeNP(preGUI, guiEditFlag)(data[tracei], attr);
          }
  
          if(!(attr in undoit)) {
              undoit[attr] = a0();
          }
          if(undoit[attr][i] === undefined) {
              undoit[attr][i] = undefinedToNull(extraparam.get());
          }
          if(val !== undefined) {
              extraparam.set(val);
          }
      }
  
      function allBins(binAttr) {
          return function(j) {
              return fullData[j][binAttr];
          };
      }
  
      function arrayBins(binAttr) {
          return function(vij, j) {
              return vij === false ? fullData[traces[j]][binAttr] : null;
          };
      }
  
      // now make the changes to gd.data (and occasionally gd.layout)
      // and figure out what kind of graphics update we need to do
      for(var ai in aobj) {
          if(helpers.hasParent(aobj, ai)) {
              throw new Error('cannot set ' + ai + ' and a parent attribute simultaneously');
          }
  
          var vi = aobj[ai];
          var cont;
          var contFull;
          var param;
          var oldVal;
          var newVal;
          var valObject;
  
          // Backward compatibility shim for turning histogram autobin on,
          // or freezing previous autobinned values.
          // Replace obsolete `autobin(x|y): true` with `(x|y)bins: null`
          // and `autobin(x|y): false` with the `(x|y)bins` in `fullData`
          if(ai === 'autobinx' || ai === 'autobiny') {
              ai = ai.charAt(ai.length - 1) + 'bins';
              if(Array.isArray(vi)) vi = vi.map(arrayBins(ai));
              else if(vi === false) vi = traces.map(allBins(ai));
              else vi = null;
          }
  
          redoit[ai] = vi;
  
          if(ai.substr(0, 6) === 'LAYOUT') {
              param = layoutNP(gd.layout, ai.replace('LAYOUT', ''));
              undoit[ai] = [undefinedToNull(param.get())];
              // since we're allowing val to be an array, allow it here too,
              // even though that's meaningless
              param.set(Array.isArray(vi) ? vi[0] : vi);
              // ironically, the layout attrs in restyle only require replot,
              // not relayout
              flags.calc = true;
              continue;
          }
  
          // set attribute in gd.data
          undoit[ai] = a0();
          for(i = 0; i < traces.length; i++) {
              cont = data[traces[i]];
              contFull = getFullTrace(traces[i]);
              var preGUI = fullLayout._tracePreGUI[contFull._fullInput.uid];
              param = makeNP(preGUI, guiEditFlag)(cont, ai);
              oldVal = param.get();
              newVal = Array.isArray(vi) ? vi[i % vi.length] : vi;
  
              if(newVal === undefined) continue;
  
              var finalPart = param.parts[param.parts.length - 1];
              var prefix = ai.substr(0, ai.length - finalPart.length - 1);
              var prefixDot = prefix ? prefix + '.' : '';
              var innerContFull = prefix ?
                  nestedProperty(contFull, prefix).get() : contFull;
  
              valObject = PlotSchema.getTraceValObject(contFull, param.parts);
  
              if(valObject && valObject.impliedEdits && newVal !== null) {
                  for(var impliedKey in valObject.impliedEdits) {
                      doextra(Lib.relativeAttr(ai, impliedKey), valObject.impliedEdits[impliedKey], i);
                  }
              } else if((finalPart === 'thicknessmode' || finalPart === 'lenmode') &&
                      oldVal !== newVal &&
                      (newVal === 'fraction' || newVal === 'pixels') &&
                      innerContFull
              ) {
                  // changing colorbar size modes,
                  // make the resulting size not change
                  // note that colorbar fractional sizing is based on the
                  // original plot size, before anything (like a colorbar)
                  // increases the margins
  
                  var gs = fullLayout._size;
                  var orient = innerContFull.orient;
                  var topOrBottom = (orient === 'top') || (orient === 'bottom');
                  if(finalPart === 'thicknessmode') {
                      var thicknorm = topOrBottom ? gs.h : gs.w;
                      doextra(prefixDot + 'thickness', innerContFull.thickness *
                          (newVal === 'fraction' ? 1 / thicknorm : thicknorm), i);
                  } else {
                      var lennorm = topOrBottom ? gs.w : gs.h;
                      doextra(prefixDot + 'len', innerContFull.len *
                          (newVal === 'fraction' ? 1 / lennorm : lennorm), i);
                  }
              } else if(ai === 'type' && (
                  (newVal === 'pie') !== (oldVal === 'pie') ||
                  (newVal === 'funnelarea') !== (oldVal === 'funnelarea')
              )) {
                  var labelsTo = 'x';
                  var valuesTo = 'y';
                  if((newVal === 'bar' || oldVal === 'bar') && cont.orientation === 'h') {
                      labelsTo = 'y';
                      valuesTo = 'x';
                  }
                  Lib.swapAttrs(cont, ['?', '?src'], 'labels', labelsTo);
                  Lib.swapAttrs(cont, ['d?', '?0'], 'label', labelsTo);
                  Lib.swapAttrs(cont, ['?', '?src'], 'values', valuesTo);
  
                  if(oldVal === 'pie' || oldVal === 'funnelarea') {
                      nestedProperty(cont, 'marker.color')
                          .set(nestedProperty(cont, 'marker.colors').get());
  
                      // super kludgy - but if all pies are gone we won't remove them otherwise
                      fullLayout._pielayer.selectAll('g.trace').remove();
                  } else if(Registry.traceIs(cont, 'cartesian')) {
                      nestedProperty(cont, 'marker.colors')
                          .set(nestedProperty(cont, 'marker.color').get());
                  }
              }
  
              undoit[ai][i] = undefinedToNull(oldVal);
              // set the new value - if val is an array, it's one el per trace
              // first check for attributes that get more complex alterations
              var swapAttrs = [
                  'swapxy', 'swapxyaxes', 'orientation', 'orientationaxes'
              ];
              if(swapAttrs.indexOf(ai) !== -1) {
                  // setting an orientation: make sure it's changing
                  // before we swap everything else
                  if(ai === 'orientation') {
                      param.set(newVal);
                      // obnoxious that we need this level of coupling... but in order to
                      // properly handle setting orientation to `null` we need to mimic
                      // the logic inside Bars.supplyDefaults for default orientation
                      var defaultOrientation = (cont.x && !cont.y) ? 'h' : 'v';
                      if((param.get() || defaultOrientation) === contFull.orientation) {
                          continue;
                      }
                  } else if(ai === 'orientationaxes') {
                      // orientationaxes has no value,
                      // it flips everything and the axes
  
                      cont.orientation =
                          {v: 'h', h: 'v'}[contFull.orientation];
                  }
                  helpers.swapXYData(cont);
                  flags.calc = flags.clearAxisTypes = true;
              } else if(Plots.dataArrayContainers.indexOf(param.parts[0]) !== -1) {
                  // TODO: use manageArrays.applyContainerArrayChanges here too
                  helpers.manageArrayContainers(param, newVal, undoit);
                  flags.calc = true;
              } else {
                  if(valObject) {
                      // must redo calcdata when restyling array values of arrayOk attributes
                      // ... but no need to this for regl-based traces
                      if(valObject.arrayOk &&
                          !Registry.traceIs(contFull, 'regl') &&
                          (Lib.isArrayOrTypedArray(newVal) || Lib.isArrayOrTypedArray(oldVal))
                      ) {
                          flags.calc = true;
                      } else editTypes.update(flags, valObject);
                  } else {
                      /*
                       * if we couldn't find valObject,  assume a full recalc.
                       * This can happen if you're changing type and making
                       * some other edits too, so the modules we're
                       * looking at don't have these attributes in them.
                       */
                      flags.calc = true;
                  }
  
                  // all the other ones, just modify that one attribute
                  param.set(newVal);
              }
          }
  
          // swap the data attributes of the relevant x and y axes?
          if(['swapxyaxes', 'orientationaxes'].indexOf(ai) !== -1) {
              Axes.swap(gd, traces);
          }
  
          // swap hovermode if set to "compare x/y data"
          if(ai === 'orientationaxes') {
              var hovermode = nestedProperty(gd.layout, 'hovermode');
              var h = hovermode.get();
              if(h === 'x') {
                  hovermode.set('y');
              } else if(h === 'y') {
                  hovermode.set('x');
              } else if(h === 'x unified') {
                  hovermode.set('y unified');
              } else if(h === 'y unified') {
                  hovermode.set('x unified');
              }
          }
  
          // Major enough changes deserve autoscale and
          // non-reversed axes so people don't get confused
          //
          // Note: autobin (or its new analog bin clearing) is not included here
          // since we're not pushing bins back to gd.data, so if we have bin
          // info it was explicitly provided by the user.
          if(['orientation', 'type'].indexOf(ai) !== -1) {
              axlist = [];
              for(i = 0; i < traces.length; i++) {
                  var trace = data[traces[i]];
  
                  if(Registry.traceIs(trace, 'cartesian')) {
                      addToAxlist(trace.xaxis || 'x');
                      addToAxlist(trace.yaxis || 'y');
                  }
              }
  
              doextra(axlist.map(autorangeAttr), true, 0);
              doextra(axlist.map(rangeAttr), [0, 1], 0);
          }
      }
  
      if(flags.calc || flags.plot) {
          flags.fullReplot = true;
      }
  
      return {
          flags: flags,
          undoit: undoit,
          redoit: redoit,
          traces: traces,
          eventData: Lib.extendDeepNoArrays([], [eventData, traces])
      };
  }
  
  /**
   * Converts deprecated attribute keys to
   * the current API to ensure backwards compatibility.
   *
   * This is needed for the update mechanism to determine which
   * subroutines to run based on the actual attribute
   * definitions (that don't include the deprecated ones).
   *
   * E.g. Maps {'xaxis.title': 'A chart'} to {'xaxis.title.text': 'A chart'}
   * and {titlefont: {...}} to {'title.font': {...}}.
   *
   * @param aobj
   */
  function cleanDeprecatedAttributeKeys(aobj) {
      var oldAxisTitleRegex = Lib.counterRegex('axis', '\.title', false, false);
      var colorbarRegex = /colorbar\.title$/;
      var keys = Object.keys(aobj);
      var i, key, value;
  
      for(i = 0; i < keys.length; i++) {
          key = keys[i];
          value = aobj[key];
  
          if((key === 'title' || oldAxisTitleRegex.test(key) || colorbarRegex.test(key)) &&
            (typeof value === 'string' || typeof value === 'number')) {
              replace(key, key.replace('title', 'title.text'));
          } else if(key.indexOf('titlefont') > -1) {
              replace(key, key.replace('titlefont', 'title.font'));
          } else if(key.indexOf('titleposition') > -1) {
              replace(key, key.replace('titleposition', 'title.position'));
          } else if(key.indexOf('titleside') > -1) {
              replace(key, key.replace('titleside', 'title.side'));
          } else if(key.indexOf('titleoffset') > -1) {
              replace(key, key.replace('titleoffset', 'title.offset'));
          }
      }
  
      function replace(oldAttrStr, newAttrStr) {
          aobj[newAttrStr] = aobj[oldAttrStr];
          delete aobj[oldAttrStr];
      }
  }
  
  /**
   * relayout: update layout attributes of an existing plot
   *
   * Can be called two ways:
   *
   * Signature 1:
   * @param {String | HTMLDivElement} gd
   *  the id or dom element of the graph container div
   * @param {String} astr
   *  attribute string (like `'xaxis.range[0]'`) to update
   * @param {*} val
   *  value to give this attribute
   *
   * Signature 2:
   * @param {String | HTMLDivElement} gd
   *  (as in signature 1)
   * @param {Object} aobj
   *  attribute object `{astr1: val1, astr2: val2 ...}`
   *  allows setting multiple attributes simultaneously
   */
  function relayout(gd, astr, val) {
      gd = Lib.getGraphDiv(gd);
      helpers.clearPromiseQueue(gd);
  
      if(gd.framework && gd.framework.isPolar) {
          return Promise.resolve(gd);
      }
  
      var aobj = {};
      if(typeof astr === 'string') {
          aobj[astr] = val;
      } else if(Lib.isPlainObject(astr)) {
          aobj = Lib.extendFlat({}, astr);
      } else {
          Lib.warn('Relayout fail.', astr, val);
          return Promise.reject();
      }
  
      if(Object.keys(aobj).length) gd.changed = true;
  
      var specs = _relayout(gd, aobj);
      var flags = specs.flags;
  
      // clear calcdata if required
      if(flags.calc) gd.calcdata = undefined;
  
      // fill in redraw sequence
  
      // even if we don't have anything left in aobj,
      // something may have happened within relayout that we
      // need to wait for
      var seq = [Plots.previousPromises];
  
      if(flags.layoutReplot) {
          seq.push(subroutines.layoutReplot);
      } else if(Object.keys(aobj).length) {
          axRangeSupplyDefaultsByPass(gd, flags, specs) || Plots.supplyDefaults(gd);
  
          if(flags.legend) seq.push(subroutines.doLegend);
          if(flags.layoutstyle) seq.push(subroutines.layoutStyles);
          if(flags.axrange) addAxRangeSequence(seq, specs.rangesAltered);
          if(flags.ticks) seq.push(subroutines.doTicksRelayout);
          if(flags.modebar) seq.push(subroutines.doModeBar);
          if(flags.camera) seq.push(subroutines.doCamera);
          if(flags.colorbars) seq.push(subroutines.doColorBars);
  
          seq.push(emitAfterPlot);
      }
  
      seq.push(Plots.rehover, Plots.redrag);
  
      Queue.add(gd,
          relayout, [gd, specs.undoit],
          relayout, [gd, specs.redoit]
      );
  
      var plotDone = Lib.syncOrAsync(seq, gd);
      if(!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
  
      return plotDone.then(function() {
          gd.emit('plotly_relayout', specs.eventData);
          return gd;
      });
  }
  
  // Optimization mostly for large splom traces where
  // Plots.supplyDefaults can take > 100ms
  function axRangeSupplyDefaultsByPass(gd, flags, specs) {
      var fullLayout = gd._fullLayout;
  
      if(!flags.axrange) return false;
  
      for(var k in flags) {
          if(k !== 'axrange' && flags[k]) return false;
      }
  
      for(var axId in specs.rangesAltered) {
          var axName = Axes.id2name(axId);
          var axIn = gd.layout[axName];
          var axOut = fullLayout[axName];
          axOut.autorange = axIn.autorange;
          axOut.range = axIn.range.slice();
          axOut.cleanRange();
  
          if(axOut._matchGroup) {
              for(var axId2 in axOut._matchGroup) {
                  if(axId2 !== axId) {
                      var ax2 = fullLayout[Axes.id2name(axId2)];
                      ax2.autorange = axOut.autorange;
                      ax2.range = axOut.range.slice();
                      ax2._input.range = axOut.range.slice();
                  }
              }
          }
      }
  
      return true;
  }
  
  function addAxRangeSequence(seq, rangesAltered) {
      // N.B. leave as sequence of subroutines (for now) instead of
      // subroutine of its own so that finalDraw always gets
      // executed after drawData
      var drawAxes = rangesAltered ?
          function(gd) {
              var axIds = [];
              var skipTitle = true;
  
              for(var id in rangesAltered) {
                  var ax = Axes.getFromId(gd, id);
                  axIds.push(id);
  
                  if(ax._matchGroup) {
                      for(var id2 in ax._matchGroup) {
                          if(!rangesAltered[id2]) {
                              axIds.push(id2);
                          }
                      }
                  }
  
                  if(ax.automargin) skipTitle = false;
              }
  
              return Axes.draw(gd, axIds, {skipTitle: skipTitle});
          } :
          function(gd) {
              return Axes.draw(gd, 'redraw');
          };
  
      seq.push(
          clearSelect,
          subroutines.doAutoRangeAndConstraints,
          drawAxes,
          subroutines.drawData,
          subroutines.finalDraw
      );
  }
  
  var AX_RANGE_RE = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/;
  var AX_AUTORANGE_RE = /^[xyz]axis[0-9]*\.autorange$/;
  var AX_DOMAIN_RE = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
  
  function _relayout(gd, aobj) {
      var layout = gd.layout;
      var fullLayout = gd._fullLayout;
      var guiEditFlag = fullLayout._guiEditing;
      var layoutNP = makeNP(fullLayout._preGUI, guiEditFlag);
      var keys = Object.keys(aobj);
      var axes = Axes.list(gd);
      var eventData = Lib.extendDeepAll({}, aobj);
      var arrayEdits = {};
  
      var arrayStr, i, j;
  
      cleanDeprecatedAttributeKeys(aobj);
      keys = Object.keys(aobj);
  
      // look for 'allaxes', split out into all axes
      // in case of 3D the axis are nested within a scene which is held in _id
      for(i = 0; i < keys.length; i++) {
          if(keys[i].indexOf('allaxes') === 0) {
              for(j = 0; j < axes.length; j++) {
                  var scene = axes[j]._id.substr(1);
                  var axisAttr = (scene.indexOf('scene') !== -1) ? (scene + '.') : '';
                  var newkey = keys[i].replace('allaxes', axisAttr + axes[j]._name);
  
                  if(!aobj[newkey]) aobj[newkey] = aobj[keys[i]];
              }
  
              delete aobj[keys[i]];
          }
      }
  
      // initialize flags
      var flags = editTypes.layoutFlags();
  
      // copies of the change (and previous values of anything affected)
      // for the undo / redo queue
      var redoit = {};
      var undoit = {};
  
      // for attrs that interact (like scales & autoscales), save the
      // old vals before making the change
      // val=undefined will not set a value, just record what the value was.
      // attr can be an array to set several at once (all to the same val)
      function doextra(attr, val) {
          if(Array.isArray(attr)) {
              attr.forEach(function(a) { doextra(a, val); });
              return;
          }
  
          // if we have another value for this attribute (explicitly or
          // via a parent) do not override with this auto-generated extra
          if(attr in aobj || helpers.hasParent(aobj, attr)) return;
  
          var p = layoutNP(layout, attr);
          if(!(attr in undoit)) {
              undoit[attr] = undefinedToNull(p.get());
          }
          if(val !== undefined) p.set(val);
      }
  
      // for constraint enforcement: keep track of all axes (as {id: name})
      // we're editing the (auto)range of, so we can tell the others constrained
      // to scale with them that it's OK for them to shrink
      var rangesAltered = {};
      var axId;
  
      function recordAlteredAxis(pleafPlus) {
          var axId = Axes.name2id(pleafPlus.split('.')[0]);
          rangesAltered[axId] = 1;
          return axId;
      }
  
      // alter gd.layout
      for(var ai in aobj) {
          if(helpers.hasParent(aobj, ai)) {
              throw new Error('cannot set ' + ai + ' and a parent attribute simultaneously');
          }
  
          var p = layoutNP(layout, ai);
          var vi = aobj[ai];
          var plen = p.parts.length;
          // p.parts may end with an index integer if the property is an array
          var pend = plen - 1;
          while(pend > 0 && typeof p.parts[pend] !== 'string') pend--;
          // last property in chain (leaf node)
          var pleaf = p.parts[pend];
          // leaf plus immediate parent
          var pleafPlus = p.parts[pend - 1] + '.' + pleaf;
          // trunk nodes (everything except the leaf)
          var ptrunk = p.parts.slice(0, pend).join('.');
          var parentIn = nestedProperty(gd.layout, ptrunk).get();
          var parentFull = nestedProperty(fullLayout, ptrunk).get();
          var vOld = p.get();
  
          if(vi === undefined) continue;
  
          redoit[ai] = vi;
  
          // axis reverse is special - it is its own inverse
          // op and has no flag.
          undoit[ai] = (pleaf === 'reverse') ? vi : undefinedToNull(vOld);
  
          var valObject = PlotSchema.getLayoutValObject(fullLayout, p.parts);
  
          if(valObject && valObject.impliedEdits && vi !== null) {
              for(var impliedKey in valObject.impliedEdits) {
                  doextra(Lib.relativeAttr(ai, impliedKey), valObject.impliedEdits[impliedKey]);
              }
          }
  
          // Setting width or height to null must reset the graph's width / height
          // back to its initial value as computed during the first pass in Plots.plotAutoSize.
          //
          // To do so, we must manually set them back here using the _initialAutoSize cache.
          // can't use impliedEdits for this because behavior depends on vi
          if(['width', 'height'].indexOf(ai) !== -1) {
              if(vi) {
                  doextra('autosize', null);
                  // currently we don't support autosize one dim only - so
                  // explicitly set the other one. Note that doextra will
                  // ignore this if the same relayout call also provides oppositeAttr
                  var oppositeAttr = ai === 'height' ? 'width' : 'height';
                  doextra(oppositeAttr, fullLayout[oppositeAttr]);
              } else {
                  fullLayout[ai] = gd._initialAutoSize[ai];
              }
          } else if(ai === 'autosize') {
              // depends on vi here too, so again can't use impliedEdits
              doextra('width', vi ? null : fullLayout.width);
              doextra('height', vi ? null : fullLayout.height);
          } else if(pleafPlus.match(AX_RANGE_RE)) {
              // check autorange vs range
  
              recordAlteredAxis(pleafPlus);
              nestedProperty(fullLayout, ptrunk + '._inputRange').set(null);
          } else if(pleafPlus.match(AX_AUTORANGE_RE)) {
              recordAlteredAxis(pleafPlus);
              nestedProperty(fullLayout, ptrunk + '._inputRange').set(null);
              var axFull = nestedProperty(fullLayout, ptrunk).get();
              if(axFull._inputDomain) {
                  // if we're autoranging and this axis has a constrained domain,
                  // reset it so we don't get locked into a shrunken size
                  axFull._input.domain = axFull._inputDomain.slice();
              }
          } else if(pleafPlus.match(AX_DOMAIN_RE)) {
              nestedProperty(fullLayout, ptrunk + '._inputDomain').set(null);
          }
  
          // toggling axis type between log and linear: we need to convert
          // positions for components that are still using linearized values,
          // not data values like newer components.
          // previously we did this for log <-> not-log, but now only do it
          // for log <-> linear
          if(pleaf === 'type') {
              var ax = parentIn;
              var toLog = parentFull.type === 'linear' && vi === 'log';
              var fromLog = parentFull.type === 'log' && vi === 'linear';
  
              if(toLog || fromLog) {
                  if(!ax || !ax.range) {
                      // 2D never gets here, but 3D does
                      // I don't think this is needed, but left here in case there
                      // are edge cases I'm not thinking of.
                      doextra(ptrunk + '.autorange', true);
                  } else if(!parentFull.autorange) {
                      // toggling log without autorange: need to also recalculate ranges
                      // because log axes use linearized values for range endpoints
                      var r0 = ax.range[0];
                      var r1 = ax.range[1];
                      if(toLog) {
                          // if both limits are negative, autorange
                          if(r0 <= 0 && r1 <= 0) {
                              doextra(ptrunk + '.autorange', true);
                          }
                          // if one is negative, set it 6 orders below the other.
                          if(r0 <= 0) r0 = r1 / 1e6;
                          else if(r1 <= 0) r1 = r0 / 1e6;
                          // now set the range values as appropriate
                          doextra(ptrunk + '.range[0]', Math.log(r0) / Math.LN10);
                          doextra(ptrunk + '.range[1]', Math.log(r1) / Math.LN10);
                      } else {
                          doextra(ptrunk + '.range[0]', Math.pow(10, r0));
                          doextra(ptrunk + '.range[1]', Math.pow(10, r1));
                      }
                  } else if(toLog) {
                      // just make sure the range is positive and in the right
                      // order, it'll get recalculated later
                      ax.range = (ax.range[1] > ax.range[0]) ? [1, 2] : [2, 1];
                  }
  
                  // clear polar view initial stash for radial range so that
                  // value get recomputed in correct units
                  if(Array.isArray(fullLayout._subplots.polar) &&
                      fullLayout._subplots.polar.length &&
                      fullLayout[p.parts[0]] &&
                      p.parts[1] === 'radialaxis'
                  ) {
                      delete fullLayout[p.parts[0]]._subplot.viewInitial['radialaxis.range'];
                  }
  
                  // Annotations and images also need to convert to/from linearized coords
                  // Shapes do not need this :)
                  Registry.getComponentMethod('annotations', 'convertCoords')(gd, parentFull, vi, doextra);
                  Registry.getComponentMethod('images', 'convertCoords')(gd, parentFull, vi, doextra);
              } else {
                  // any other type changes: the range from the previous type
                  // will not make sense, so autorange it.
                  doextra(ptrunk + '.autorange', true);
                  doextra(ptrunk + '.range', null);
              }
              nestedProperty(fullLayout, ptrunk + '._inputRange').set(null);
          } else if(pleaf.match(AX_NAME_PATTERN)) {
              var fullProp = nestedProperty(fullLayout, ai).get();
              var newType = (vi || {}).type;
  
              // This can potentially cause strange behavior if the autotype is not
              // numeric (linear, because we don't auto-log) but the previous type
              // was log. That's a very strange edge case though
              if(!newType || newType === '-') newType = 'linear';
              Registry.getComponentMethod('annotations', 'convertCoords')(gd, fullProp, newType, doextra);
              Registry.getComponentMethod('images', 'convertCoords')(gd, fullProp, newType, doextra);
          }
  
          // alter gd.layout
  
          // collect array component edits for execution all together
          // so we can ensure consistent behavior adding/removing items
          // and order-independence for add/remove/edit all together in
          // one relayout call
          var containerArrayMatch = manageArrays.containerArrayMatch(ai);
          if(containerArrayMatch) {
              arrayStr = containerArrayMatch.array;
              i = containerArrayMatch.index;
              var propStr = containerArrayMatch.property;
              var updateValObject = valObject || {editType: 'calc'};
  
              if(i !== '' && propStr === '') {
                  // special handling of undoit if we're adding or removing an element
                  // ie 'annotations[2]' which can be {...} (add) or null,
                  // does not work when replacing the entire array
                  if(manageArrays.isAddVal(vi)) {
                      undoit[ai] = null;
                  } else if(manageArrays.isRemoveVal(vi)) {
                      undoit[ai] = (nestedProperty(layout, arrayStr).get() || [])[i];
                  } else {
                      Lib.warn('unrecognized full object value', aobj);
                  }
              }
              editTypes.update(flags, updateValObject);
  
              // prepare the edits object we'll send to applyContainerArrayChanges
              if(!arrayEdits[arrayStr]) arrayEdits[arrayStr] = {};
              var objEdits = arrayEdits[arrayStr][i];
              if(!objEdits) objEdits = arrayEdits[arrayStr][i] = {};
              objEdits[propStr] = vi;
  
              delete aobj[ai];
          } else if(pleaf === 'reverse') {
              // handle axis reversal explicitly, as there's no 'reverse' attribute
  
              if(parentIn.range) parentIn.range.reverse();
              else {
                  doextra(ptrunk + '.autorange', true);
                  parentIn.range = [1, 0];
              }
  
              if(parentFull.autorange) flags.calc = true;
              else flags.plot = true;
          } else {
              if((fullLayout._has('scatter-like') && fullLayout._has('regl')) &&
                  (ai === 'dragmode' &&
                  (vi === 'lasso' || vi === 'select') &&
                  !(vOld === 'lasso' || vOld === 'select'))
              ) {
                  flags.plot = true;
              } else if(fullLayout._has('gl2d')) {
                  flags.plot = true;
              } else if(valObject) editTypes.update(flags, valObject);
              else flags.calc = true;
  
              p.set(vi);
          }
      }
  
      // now we've collected component edits - execute them all together
      for(arrayStr in arrayEdits) {
          var finished = manageArrays.applyContainerArrayChanges(gd,
              layoutNP(layout, arrayStr), arrayEdits[arrayStr], flags, layoutNP);
          if(!finished) flags.plot = true;
      }
  
      // figure out if we need to recalculate axis constraints
      var constraints = fullLayout._axisConstraintGroups || [];
      for(axId in rangesAltered) {
          for(i = 0; i < constraints.length; i++) {
              var group = constraints[i];
              if(group[axId]) {
                  // Always recalc if we're changing constrained ranges.
                  // Otherwise it's possible to violate the constraints by
                  // specifying arbitrary ranges for all axes in the group.
                  // this way some ranges may expand beyond what's specified,
                  // as they do at first draw, to satisfy the constraints.
                  flags.calc = true;
                  for(var groupAxId in group) {
                      if(!rangesAltered[groupAxId]) {
                          Axes.getFromId(gd, groupAxId)._constraintShrinkable = true;
                      }
                  }
              }
          }
      }
  
      // If the autosize changed or height or width was explicitly specified,
      // this triggers a redraw
      // TODO: do we really need special aobj.height/width handling here?
      // couldn't editType do this?
      if(updateAutosize(gd) || aobj.height || aobj.width) flags.plot = true;
  
      if(flags.plot || flags.calc) {
          flags.layoutReplot = true;
      }
  
      // now all attribute mods are done, as are
      // redo and undo so we can save them
  
      return {
          flags: flags,
          rangesAltered: rangesAltered,
          undoit: undoit,
          redoit: redoit,
          eventData: eventData
      };
  }
  
  /*
   * updateAutosize: we made a change, does it change the autosize result?
   * puts the new size into fullLayout
   * returns true if either height or width changed
   */
  function updateAutosize(gd) {
      var fullLayout = gd._fullLayout;
      var oldWidth = fullLayout.width;
      var oldHeight = fullLayout.height;
  
      // calculate autosizing
      if(gd.layout.autosize) Plots.plotAutoSize(gd, gd.layout, fullLayout);
  
      return (fullLayout.width !== oldWidth) || (fullLayout.height !== oldHeight);
  }
  
  /**
   * update: update trace and layout attributes of an existing plot
   *
   * @param {String | HTMLDivElement} gd
   *  the id or DOM element of the graph container div
   * @param {Object} traceUpdate
   *  attribute object `{astr1: val1, astr2: val2 ...}`
   *  corresponding to updates in the plot's traces
   * @param {Object} layoutUpdate
   *  attribute object `{astr1: val1, astr2: val2 ...}`
   *  corresponding to updates in the plot's layout
   * @param {Number[] | Number} [traces]
   *  integer or array of integers for the traces to alter (all if omitted)
   *
   */
  function update(gd, traceUpdate, layoutUpdate, _traces) {
      gd = Lib.getGraphDiv(gd);
      helpers.clearPromiseQueue(gd);
  
      if(gd.framework && gd.framework.isPolar) {
          return Promise.resolve(gd);
      }
  
      if(!Lib.isPlainObject(traceUpdate)) traceUpdate = {};
      if(!Lib.isPlainObject(layoutUpdate)) layoutUpdate = {};
  
      if(Object.keys(traceUpdate).length) gd.changed = true;
      if(Object.keys(layoutUpdate).length) gd.changed = true;
  
      var traces = helpers.coerceTraceIndices(gd, _traces);
  
      var restyleSpecs = _restyle(gd, Lib.extendFlat({}, traceUpdate), traces);
      var restyleFlags = restyleSpecs.flags;
  
      var relayoutSpecs = _relayout(gd, Lib.extendFlat({}, layoutUpdate));
      var relayoutFlags = relayoutSpecs.flags;
  
      // clear calcdata and/or axis types if required
      if(restyleFlags.calc || relayoutFlags.calc) gd.calcdata = undefined;
      if(restyleFlags.clearAxisTypes) helpers.clearAxisTypes(gd, traces, layoutUpdate);
  
      // fill in redraw sequence
      var seq = [];
  
      if(relayoutFlags.layoutReplot) {
          // N.B. works fine when both
          // relayoutFlags.layoutReplot and restyleFlags.fullReplot are true
          seq.push(subroutines.layoutReplot);
      } else if(restyleFlags.fullReplot) {
          seq.push(exports.plot);
      } else {
          seq.push(Plots.previousPromises);
          axRangeSupplyDefaultsByPass(gd, relayoutFlags, relayoutSpecs) || Plots.supplyDefaults(gd);
  
          if(restyleFlags.style) seq.push(subroutines.doTraceStyle);
          if(restyleFlags.colorbars || relayoutFlags.colorbars) seq.push(subroutines.doColorBars);
          if(relayoutFlags.legend) seq.push(subroutines.doLegend);
          if(relayoutFlags.layoutstyle) seq.push(subroutines.layoutStyles);
          if(relayoutFlags.axrange) addAxRangeSequence(seq, relayoutSpecs.rangesAltered);
          if(relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
          if(relayoutFlags.modebar) seq.push(subroutines.doModeBar);
          if(relayoutFlags.camera) seq.push(subroutines.doCamera);
  
          seq.push(emitAfterPlot);
      }
  
      seq.push(Plots.rehover, Plots.redrag);
  
      Queue.add(gd,
          update, [gd, restyleSpecs.undoit, relayoutSpecs.undoit, restyleSpecs.traces],
          update, [gd, restyleSpecs.redoit, relayoutSpecs.redoit, restyleSpecs.traces]
      );
  
      var plotDone = Lib.syncOrAsync(seq, gd);
      if(!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
  
      return plotDone.then(function() {
          gd.emit('plotly_update', {
              data: restyleSpecs.eventData,
              layout: relayoutSpecs.eventData
          });
  
          return gd;
      });
  }
  
  /*
   * internal-use-only restyle/relayout/update variants that record the initial
   * values in (fullLayout|fullTrace)._preGUI so changes can be persisted across
   * Plotly.react data updates, dependent on uirevision attributes
   */
  function guiEdit(func) {
      return function wrappedEdit(gd) {
          gd._fullLayout._guiEditing = true;
          var p = func.apply(null, arguments);
          gd._fullLayout._guiEditing = false;
          return p;
      };
  }
  
  // For connecting edited layout attributes to uirevision attrs
  // If no `attr` we use `match[1] + '.uirevision'`
  // Ordered by most common edits first, to minimize our search time
  var layoutUIControlPatterns = [
      {pattern: /^hiddenlabels/, attr: 'legend.uirevision'},
      {pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/},
  
      // showspikes and modes include those nested inside scenes
      {pattern: /axis\d*\.showspikes$/, attr: 'modebar.uirevision'},
      {pattern: /(hover|drag)mode$/, attr: 'modebar.uirevision'},
  
      {pattern: /^(scene\d*)\.camera/},
      {pattern: /^(geo\d*)\.(projection|center|fitbounds)/},
      {pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/},
      {pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/},
      {pattern: /^(polar\d*\.angularaxis)\.rotation/},
      {pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/},
  
      {pattern: /^legend\.(x|y)$/, attr: 'editrevision'},
      {pattern: /^(shapes|annotations)/, attr: 'editrevision'},
      {pattern: /^title\.text$/, attr: 'editrevision'}
  ];
  
  // same for trace attributes: if `attr` is given it's in layout,
  // or with no `attr` we use `trace.uirevision`
  var traceUIControlPatterns = [
      {pattern: /^selectedpoints$/, attr: 'selectionrevision'},
      // "visible" includes trace.transforms[i].styles[j].value.visible
      {pattern: /(^|value\.)visible$/, attr: 'legend.uirevision'},
      {pattern: /^dimensions\[\d+\]\.constraintrange/},
      {pattern: /^node\.(x|y|groups)/}, // for Sankey nodes
      {pattern: /^level$/}, // for Sunburst & Treemap traces
  
      // below this you must be in editable: true mode
      // TODO: I still put name and title with `trace.uirevision`
      // reasonable or should these be `editrevision`?
      // Also applies to axis titles up in the layout section
  
      // "name" also includes transform.styles
      {pattern: /(^|value\.)name$/},
      // including nested colorbar attributes (ie marker.colorbar)
      {pattern: /colorbar\.title\.text$/},
      {pattern: /colorbar\.(x|y)$/, attr: 'editrevision'}
  ];
  
  function findUIPattern(key, patternSpecs) {
      for(var i = 0; i < patternSpecs.length; i++) {
          var spec = patternSpecs[i];
          var match = key.match(spec.pattern);
          if(match) {
              return {head: match[1], attr: spec.attr};
          }
      }
  }
  
  // We're finding the new uirevision before supplyDefaults, so do the
  // inheritance manually. Note that only `undefined` inherits - other
  // falsy values are returned.
  function getNewRev(revAttr, container) {
      var newRev = nestedProperty(container, revAttr).get();
      if(newRev !== undefined) return newRev;
  
      var parts = revAttr.split('.');
      parts.pop();
      while(parts.length > 1) {
          parts.pop();
          newRev = nestedProperty(container, parts.join('.') + '.uirevision').get();
          if(newRev !== undefined) return newRev;
      }
  
      return container.uirevision;
  }
  
  function getFullTraceIndexFromUid(uid, fullData) {
      for(var i = 0; i < fullData.length; i++) {
          if(fullData[i]._fullInput.uid === uid) return i;
      }
      return -1;
  }
  
  function getTraceIndexFromUid(uid, data, tracei) {
      for(var i = 0; i < data.length; i++) {
          if(data[i].uid === uid) return i;
      }
      // fall back on trace order, but only if user didn't provide a uid for that trace
      return (!data[tracei] || data[tracei].uid) ? -1 : tracei;
  }
  
  function valsMatch(v1, v2) {
      var v1IsObj = Lib.isPlainObject(v1);
      var v1IsArray = Array.isArray(v1);
      if(v1IsObj || v1IsArray) {
          return (
              (v1IsObj && Lib.isPlainObject(v2)) ||
              (v1IsArray && Array.isArray(v2))
          ) && JSON.stringify(v1) === JSON.stringify(v2);
      }
      return v1 === v2;
  }
  
  function applyUIRevisions(data, layout, oldFullData, oldFullLayout) {
      var layoutPreGUI = oldFullLayout._preGUI;
      var key, revAttr, oldRev, newRev, match, preGUIVal, newNP, newVal;
      var bothInheritAutorange = [];
      var newRangeAccepted = {};
      for(key in layoutPreGUI) {
          match = findUIPattern(key, layoutUIControlPatterns);
          if(match) {
              revAttr = match.attr || (match.head + '.uirevision');
              oldRev = nestedProperty(oldFullLayout, revAttr).get();
              newRev = oldRev && getNewRev(revAttr, layout);
              if(newRev && (newRev === oldRev)) {
                  preGUIVal = layoutPreGUI[key];
                  if(preGUIVal === null) preGUIVal = undefined;
                  newNP = nestedProperty(layout, key);
                  newVal = newNP.get();
                  if(valsMatch(newVal, preGUIVal)) {
                      if(newVal === undefined && key.substr(key.length - 9) === 'autorange') {
                          bothInheritAutorange.push(key.substr(0, key.length - 10));
                      }
                      newNP.set(undefinedToNull(nestedProperty(oldFullLayout, key).get()));
                      continue;
                  }
              }
          } else {
              Lib.warn('unrecognized GUI edit: ' + key);
          }
          // if we got this far, the new value was accepted as the new starting
          // point (either because it changed or revision changed)
          // so remove it from _preGUI for next time.
          delete layoutPreGUI[key];
  
          if(key.substr(key.length - 8, 6) === 'range[') {
              newRangeAccepted[key.substr(0, key.length - 9)] = 1;
          }
      }
  
      // Special logic for `autorange`, since it interacts with `range`:
      // If the new figure's matching `range` was kept, and `autorange`
      // wasn't supplied explicitly in either the original or the new figure,
      // we shouldn't alter that - but we may just have done that, so fix it.
      for(var i = 0; i < bothInheritAutorange.length; i++) {
          var axAttr = bothInheritAutorange[i];
          if(newRangeAccepted[axAttr]) {
              var newAx = nestedProperty(layout, axAttr).get();
              if(newAx) delete newAx.autorange;
          }
      }
  
      // Now traces - try to match them up by uid (in case we added/deleted in
      // the middle), then fall back on index.
      var allTracePreGUI = oldFullLayout._tracePreGUI;
      for(var uid in allTracePreGUI) {
          var tracePreGUI = allTracePreGUI[uid];
          var newTrace = null;
          var fullInput;
          for(key in tracePreGUI) {
              // wait until we know we have preGUI values to look for traces
              // but if we don't find both, stop looking at this uid
              if(!newTrace) {
                  var fulli = getFullTraceIndexFromUid(uid, oldFullData);
                  if(fulli < 0) {
                      // Somehow we didn't even have this trace in oldFullData...
                      // I guess this could happen with `deleteTraces` or something
                      delete allTracePreGUI[uid];
                      break;
                  }
                  var fullTrace = oldFullData[fulli];
                  fullInput = fullTrace._fullInput;
  
                  var newTracei = getTraceIndexFromUid(uid, data, fullInput.index);
                  if(newTracei < 0) {
                      // No match in new data
                      delete allTracePreGUI[uid];
                      break;
                  }
                  newTrace = data[newTracei];
              }
  
              match = findUIPattern(key, traceUIControlPatterns);
              if(match) {
                  if(match.attr) {
                      oldRev = nestedProperty(oldFullLayout, match.attr).get();
                      newRev = oldRev && getNewRev(match.attr, layout);
                  } else {
                      oldRev = fullInput.uirevision;
                      // inheritance for trace.uirevision is simple, just layout.uirevision
                      newRev = newTrace.uirevision;
                      if(newRev === undefined) newRev = layout.uirevision;
                  }
  
                  if(newRev && newRev === oldRev) {
                      preGUIVal = tracePreGUI[key];
                      if(preGUIVal === null) preGUIVal = undefined;
                      newNP = nestedProperty(newTrace, key);
                      newVal = newNP.get();
                      if(valsMatch(newVal, preGUIVal)) {
                          newNP.set(undefinedToNull(nestedProperty(fullInput, key).get()));
                          continue;
                      }
                  }
              } else {
                  Lib.warn('unrecognized GUI edit: ' + key + ' in trace uid ' + uid);
              }
              delete tracePreGUI[key];
          }
      }
  }
  
  /**
   * Plotly.react:
   * A plot/update method that takes the full plot state (same API as plot/newPlot)
   * and diffs to determine the minimal update pathway
   *
   * @param {string id or DOM element} gd
   *      the id or DOM element of the graph container div
   * @param {array of objects} data
   *      array of traces, containing the data and display information for each trace
   * @param {object} layout
   *      object describing the overall display of the plot,
   *      all the stuff that doesn't pertain to any individual trace
   * @param {object} config
   *      configuration options (see ./plot_config.js for more info)
   *
   * OR
   *
   * @param {string id or DOM element} gd
   *      the id or DOM element of the graph container div
   * @param {object} figure
   *      object containing `data`, `layout`, `config`, and `frames` members
   *
   */
  function react(gd, data, layout, config) {
      var frames, plotDone;
  
      function addFrames() { return exports.addFrames(gd, frames); }
  
      gd = Lib.getGraphDiv(gd);
      helpers.clearPromiseQueue(gd);
  
      var oldFullData = gd._fullData;
      var oldFullLayout = gd._fullLayout;
  
      // you can use this as the initial draw as well as to update
      if(!Lib.isPlotDiv(gd) || !oldFullData || !oldFullLayout) {
          plotDone = exports.newPlot(gd, data, layout, config);
      } else {
          if(Lib.isPlainObject(data)) {
              var obj = data;
              data = obj.data;
              layout = obj.layout;
              config = obj.config;
              frames = obj.frames;
          }
  
          var configChanged = false;
          // assume that if there's a config at all, we're reacting to it too,
          // and completely replace the previous config
          if(config) {
              var oldConfig = Lib.extendDeep({}, gd._context);
              gd._context = undefined;
              setPlotContext(gd, config);
              configChanged = diffConfig(oldConfig, gd._context);
          }
  
          gd.data = data || [];
          helpers.cleanData(gd.data);
          gd.layout = layout || {};
          helpers.cleanLayout(gd.layout);
  
          applyUIRevisions(gd.data, gd.layout, oldFullData, oldFullLayout);
  
          var allNames = Object.getOwnPropertyNames(oldFullLayout);
          for(var q = 0; q < allNames.length; q++) {
              var name = allNames[q];
              var start = name.substring(0, 5);
              if(start === 'xaxis' || start === 'yaxis') {
                  var emptyCategories = oldFullLayout[name]._emptyCategories;
                  if(emptyCategories) emptyCategories();
              }
          }
  
          // "true" skips updating calcdata and remapping arrays from calcTransforms,
          // which supplyDefaults usually does at the end, but we may need to NOT do
          // if the diff (which we haven't determined yet) says we'll recalc
          Plots.supplyDefaults(gd, {skipUpdateCalc: true});
  
          var newFullData = gd._fullData;
          var newFullLayout = gd._fullLayout;
          var immutable = newFullLayout.datarevision === undefined;
          var transition = newFullLayout.transition;
  
          var relayoutFlags = diffLayout(gd, oldFullLayout, newFullLayout, immutable, transition);
          var newDataRevision = relayoutFlags.newDataRevision;
          var restyleFlags = diffData(gd, oldFullData, newFullData, immutable, transition, newDataRevision);
  
          // TODO: how to translate this part of relayout to Plotly.react?
          // // Setting width or height to null must reset the graph's width / height
          // // back to its initial value as computed during the first pass in Plots.plotAutoSize.
          // //
          // // To do so, we must manually set them back here using the _initialAutoSize cache.
          // if(['width', 'height'].indexOf(ai) !== -1 && vi === null) {
          //     fullLayout[ai] = gd._initialAutoSize[ai];
          // }
  
          if(updateAutosize(gd)) relayoutFlags.layoutReplot = true;
  
          // clear calcdata if required
          if(restyleFlags.calc || relayoutFlags.calc) gd.calcdata = undefined;
          // otherwise do the calcdata updates and calcTransform array remaps that we skipped earlier
          else Plots.supplyDefaultsUpdateCalc(gd.calcdata, newFullData);
  
          // Note: what restyle/relayout use impliedEdits and clearAxisTypes for
          // must be handled by the user when using Plotly.react.
  
          // fill in redraw sequence
          var seq = [];
  
          if(frames) {
              gd._transitionData = {};
              Plots.createTransitionData(gd);
              seq.push(addFrames);
          }
  
          // Transition pathway,
          // only used when 'transition' is set by user and
          // when at least one animatable attribute has changed,
          // N.B. config changed aren't animatable
          if(newFullLayout.transition && !configChanged && (restyleFlags.anim || relayoutFlags.anim)) {
              if(relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
  
              Plots.doCalcdata(gd);
              subroutines.doAutoRangeAndConstraints(gd);
  
              seq.push(function() {
                  return Plots.transitionFromReact(gd, restyleFlags, relayoutFlags, oldFullLayout);
              });
          } else if(restyleFlags.fullReplot || relayoutFlags.layoutReplot || configChanged) {
              gd._fullLayout._skipDefaults = true;
              seq.push(exports.plot);
          } else {
              for(var componentType in relayoutFlags.arrays) {
                  var indices = relayoutFlags.arrays[componentType];
                  if(indices.length) {
                      var drawOne = Registry.getComponentMethod(componentType, 'drawOne');
                      if(drawOne !== Lib.noop) {
                          for(var i = 0; i < indices.length; i++) {
                              drawOne(gd, indices[i]);
                          }
                      } else {
                          var draw = Registry.getComponentMethod(componentType, 'draw');
                          if(draw === Lib.noop) {
                              throw new Error('cannot draw components: ' + componentType);
                          }
                          draw(gd);
                      }
                  }
              }
  
              seq.push(Plots.previousPromises);
              if(restyleFlags.style) seq.push(subroutines.doTraceStyle);
              if(restyleFlags.colorbars || relayoutFlags.colorbars) seq.push(subroutines.doColorBars);
              if(relayoutFlags.legend) seq.push(subroutines.doLegend);
              if(relayoutFlags.layoutstyle) seq.push(subroutines.layoutStyles);
              if(relayoutFlags.axrange) addAxRangeSequence(seq);
              if(relayoutFlags.ticks) seq.push(subroutines.doTicksRelayout);
              if(relayoutFlags.modebar) seq.push(subroutines.doModeBar);
              if(relayoutFlags.camera) seq.push(subroutines.doCamera);
              seq.push(emitAfterPlot);
          }
  
          seq.push(Plots.rehover, Plots.redrag);
  
          plotDone = Lib.syncOrAsync(seq, gd);
          if(!plotDone || !plotDone.then) plotDone = Promise.resolve(gd);
      }
  
      return plotDone.then(function() {
          gd.emit('plotly_react', {
              data: data,
              layout: layout
          });
  
          return gd;
      });
  }
  
  function diffData(gd, oldFullData, newFullData, immutable, transition, newDataRevision) {
      var sameTraceLength = oldFullData.length === newFullData.length;
  
      if(!transition && !sameTraceLength) {
          return {
              fullReplot: true,
              calc: true
          };
      }
  
      var flags = editTypes.traceFlags();
      flags.arrays = {};
      flags.nChanges = 0;
      flags.nChangesAnim = 0;
  
      var i, trace;
  
      function getTraceValObject(parts) {
          var out = PlotSchema.getTraceValObject(trace, parts);
          if(!trace._module.animatable && out.anim) {
              out.anim = false;
          }
          return out;
      }
  
      var diffOpts = {
          getValObject: getTraceValObject,
          flags: flags,
          immutable: immutable,
          transition: transition,
          newDataRevision: newDataRevision,
          gd: gd
      };
  
      var seenUIDs = {};
  
      for(i = 0; i < oldFullData.length; i++) {
          if(newFullData[i]) {
              trace = newFullData[i]._fullInput;
              if(Plots.hasMakesDataTransform(trace)) trace = newFullData[i];
              if(seenUIDs[trace.uid]) continue;
              seenUIDs[trace.uid] = 1;
  
              getDiffFlags(oldFullData[i]._fullInput, trace, [], diffOpts);
          }
      }
  
      if(flags.calc || flags.plot) {
          flags.fullReplot = true;
      }
  
      if(transition && flags.nChanges && flags.nChangesAnim) {
          flags.anim = (flags.nChanges === flags.nChangesAnim) && sameTraceLength ? 'all' : 'some';
      }
  
      return flags;
  }
  
  function diffLayout(gd, oldFullLayout, newFullLayout, immutable, transition) {
      var flags = editTypes.layoutFlags();
      flags.arrays = {};
      flags.rangesAltered = {};
      flags.nChanges = 0;
      flags.nChangesAnim = 0;
  
      function getLayoutValObject(parts) {
          return PlotSchema.getLayoutValObject(newFullLayout, parts);
      }
  
      var diffOpts = {
          getValObject: getLayoutValObject,
          flags: flags,
          immutable: immutable,
          transition: transition,
          gd: gd
      };
  
      getDiffFlags(oldFullLayout, newFullLayout, [], diffOpts);
  
      if(flags.plot || flags.calc) {
          flags.layoutReplot = true;
      }
  
      if(transition && flags.nChanges && flags.nChangesAnim) {
          flags.anim = flags.nChanges === flags.nChangesAnim ? 'all' : 'some';
      }
  
      return flags;
  }
  
  function getDiffFlags(oldContainer, newContainer, outerparts, opts) {
      var valObject, key, astr;
  
      var getValObject = opts.getValObject;
      var flags = opts.flags;
      var immutable = opts.immutable;
      var inArray = opts.inArray;
      var arrayIndex = opts.arrayIndex;
  
      function changed() {
          var editType = valObject.editType;
          if(inArray && editType.indexOf('arraydraw') !== -1) {
              Lib.pushUnique(flags.arrays[inArray], arrayIndex);
              return;
          }
          editTypes.update(flags, valObject);
  
          if(editType !== 'none') {
              flags.nChanges++;
          }
  
          // track animatable changes
          if(opts.transition && valObject.anim) {
              flags.nChangesAnim++;
          }
  
          // track cartesian axes with altered ranges
          if(AX_RANGE_RE.test(astr) || AX_AUTORANGE_RE.test(astr)) {
              flags.rangesAltered[outerparts[0]] = 1;
          }
  
          // clear _inputDomain on cartesian axes with altered domains
          if(AX_DOMAIN_RE.test(astr)) {
              nestedProperty(newContainer, '_inputDomain').set(null);
          }
  
          // track datarevision changes
          if(key === 'datarevision') {
              flags.newDataRevision = 1;
          }
      }
  
      function valObjectCanBeDataArray(valObject) {
          return valObject.valType === 'data_array' || valObject.arrayOk;
      }
  
      for(key in oldContainer) {
          // short-circuit based on previous calls or previous keys that already maximized the pathway
          if(flags.calc && !opts.transition) return;
  
          var oldVal = oldContainer[key];
          var newVal = newContainer[key];
          var parts = outerparts.concat(key);
          astr = parts.join('.');
  
          if(key.charAt(0) === '_' || typeof oldVal === 'function' || oldVal === newVal) continue;
  
          // FIXME: ax.tick0 and dtick get filled in during plotting (except for geo subplots),
          // and unlike other auto values they don't make it back into the input,
          // so newContainer won't have them.
          if((key === 'tick0' || key === 'dtick') && outerparts[0] !== 'geo') {
              var tickMode = newContainer.tickmode;
              if(tickMode === 'auto' || tickMode === 'array' || !tickMode) continue;
          }
          // FIXME: Similarly for axis ranges for 3D
          // contourcarpet doesn't HAVE zmin/zmax, they're just auto-added. It needs them.
          if(key === 'range' && newContainer.autorange) continue;
          if((key === 'zmin' || key === 'zmax') && newContainer.type === 'contourcarpet') continue;
  
          valObject = getValObject(parts);
  
          // in case type changed, we may not even *have* a valObject.
          if(!valObject) continue;
  
          if(valObject._compareAsJSON && JSON.stringify(oldVal) === JSON.stringify(newVal)) continue;
  
          var valType = valObject.valType;
          var i;
  
          var canBeDataArray = valObjectCanBeDataArray(valObject);
          var wasArray = Array.isArray(oldVal);
          var nowArray = Array.isArray(newVal);
  
          // hack for traces that modify the data in supplyDefaults, like
          // converting 1D to 2D arrays, which will always create new objects
          if(wasArray && nowArray) {
              var inputKey = '_input_' + key;
              var oldValIn = oldContainer[inputKey];
              var newValIn = newContainer[inputKey];
              if(Array.isArray(oldValIn) && oldValIn === newValIn) continue;
          }
  
          if(newVal === undefined) {
              if(canBeDataArray && wasArray) flags.calc = true;
              else changed();
          } else if(valObject._isLinkedToArray) {
              var arrayEditIndices = [];
              var extraIndices = false;
              if(!inArray) flags.arrays[key] = arrayEditIndices;
  
              var minLen = Math.min(oldVal.length, newVal.length);
              var maxLen = Math.max(oldVal.length, newVal.length);
              if(minLen !== maxLen) {
                  if(valObject.editType === 'arraydraw') {
                      extraIndices = true;
                  } else {
                      changed();
                      continue;
                  }
              }
  
              for(i = 0; i < minLen; i++) {
                  getDiffFlags(oldVal[i], newVal[i], parts.concat(i),
                      // add array indices, but not if we're already in an array
                      Lib.extendFlat({inArray: key, arrayIndex: i}, opts));
              }
  
              // put this at the end so that we know our collected array indices are sorted
              // but the check for length changes happens up front so we can short-circuit
              // diffing if appropriate
              if(extraIndices) {
                  for(i = minLen; i < maxLen; i++) {
                      arrayEditIndices.push(i);
                  }
              }
          } else if(!valType && Lib.isPlainObject(oldVal)) {
              getDiffFlags(oldVal, newVal, parts, opts);
          } else if(canBeDataArray) {
              if(wasArray && nowArray) {
                  // don't try to diff two data arrays. If immutable we know the data changed,
                  // if not, assume it didn't and let `layout.datarevision` tell us if it did
                  if(immutable) {
                      flags.calc = true;
                  }
  
                  // look for animatable attributes when the data changed
                  if(immutable || opts.newDataRevision) {
                      changed();
                  }
              } else if(wasArray !== nowArray) {
                  flags.calc = true;
              } else changed();
          } else if(wasArray && nowArray) {
              // info array, colorscale, 'any' - these are short, just stringify.
              // I don't *think* that covers up any real differences post-validation, does it?
              // otherwise we need to dive in 1 (info_array) or 2 (colorscale) levels and compare
              // all elements.
              if(oldVal.length !== newVal.length || String(oldVal) !== String(newVal)) {
                  changed();
              }
          } else {
              changed();
          }
      }
  
      for(key in newContainer) {
          if(!(key in oldContainer || key.charAt(0) === '_' || typeof newContainer[key] === 'function')) {
              valObject = getValObject(outerparts.concat(key));
  
              if(valObjectCanBeDataArray(valObject) && Array.isArray(newContainer[key])) {
                  flags.calc = true;
                  return;
              } else changed();
          }
      }
  }
  
  /*
   * simple diff for config - for now, just treat all changes as equivalent
   */
  function diffConfig(oldConfig, newConfig) {
      var key;
  
      for(key in oldConfig) {
          if(key.charAt(0) === '_') continue;
          var oldVal = oldConfig[key];
          var newVal = newConfig[key];
          if(oldVal !== newVal) {
              if(Lib.isPlainObject(oldVal) && Lib.isPlainObject(newVal)) {
                  if(diffConfig(oldVal, newVal)) {
                      return true;
                  }
              } else if(Array.isArray(oldVal) && Array.isArray(newVal)) {
                  if(oldVal.length !== newVal.length) {
                      return true;
                  }
                  for(var i = 0; i < oldVal.length; i++) {
                      if(oldVal[i] !== newVal[i]) {
                          if(Lib.isPlainObject(oldVal[i]) && Lib.isPlainObject(newVal[i])) {
                              if(diffConfig(oldVal[i], newVal[i])) {
                                  return true;
                              }
                          } else {
                              return true;
                          }
                      }
                  }
              } else {
                  return true;
              }
          }
      }
  }
  
  /**
   * Animate to a frame, sequence of frame, frame group, or frame definition
   *
   * @param {string id or DOM element} gd
   *      the id or DOM element of the graph container div
   *
   * @param {string or object or array of strings or array of objects} frameOrGroupNameOrFrameList
   *      a single frame, array of frames, or group to which to animate. The intent is
   *      inferred by the type of the input. Valid inputs are:
   *
   *      - string, e.g. 'groupname': animate all frames of a given `group` in the order
   *            in which they are defined via `Plotly.addFrames`.
   *
   *      - array of strings, e.g. ['frame1', frame2']: a list of frames by name to which
   *            to animate in sequence
   *
   *      - object: {data: ...}: a frame definition to which to animate. The frame is not
   *            and does not need to be added via `Plotly.addFrames`. It may contain any of
   *            the properties of a frame, including `data`, `layout`, and `traces`. The
   *            frame is used as provided and does not use the `baseframe` property.
   *
   *      - array of objects, e.g. [{data: ...}, {data: ...}]: a list of frame objects,
   *            each following the same rules as a single `object`.
   *
   * @param {object} animationOpts
   *      configuration for the animation
   */
  function animate(gd, frameOrGroupNameOrFrameList, animationOpts) {
      gd = Lib.getGraphDiv(gd);
  
      if(!Lib.isPlotDiv(gd)) {
          throw new Error(
              'This element is not a Plotly plot: ' + gd + '. It\'s likely that you\'ve failed ' +
              'to create a plot before animating it. For more details, see ' +
              'https://plotly.com/javascript/animations/'
          );
      }
  
      var trans = gd._transitionData;
  
      // This is the queue of frames that will be animated as soon as possible. They
      // are popped immediately upon the *start* of a transition:
      if(!trans._frameQueue) {
          trans._frameQueue = [];
      }
  
      animationOpts = Plots.supplyAnimationDefaults(animationOpts);
      var transitionOpts = animationOpts.transition;
      var frameOpts = animationOpts.frame;
  
      // Since frames are popped immediately, an empty queue only means all frames have
      // *started* to transition, not that the animation is complete. To solve that,
      // track a separate counter that increments at the same time as frames are added
      // to the queue, but decrements only when the transition is complete.
      if(trans._frameWaitingCnt === undefined) {
          trans._frameWaitingCnt = 0;
      }
  
      function getTransitionOpts(i) {
          if(Array.isArray(transitionOpts)) {
              if(i >= transitionOpts.length) {
                  return transitionOpts[0];
              } else {
                  return transitionOpts[i];
              }
          } else {
              return transitionOpts;
          }
      }
  
      function getFrameOpts(i) {
          if(Array.isArray(frameOpts)) {
              if(i >= frameOpts.length) {
                  return frameOpts[0];
              } else {
                  return frameOpts[i];
              }
          } else {
              return frameOpts;
          }
      }
  
      // Execute a callback after the wrapper function has been called n times.
      // This is used to defer the resolution until a transition has resovled *and*
      // the frame has completed. If it's not done this way, then we get a race
      // condition in which the animation might resolve before a transition is complete
      // or vice versa.
      function callbackOnNthTime(cb, n) {
          var cnt = 0;
          return function() {
              if(cb && ++cnt === n) {
                  return cb();
              }
          };
      }
  
      return new Promise(function(resolve, reject) {
          function discardExistingFrames() {
              if(trans._frameQueue.length === 0) {
                  return;
              }
  
              while(trans._frameQueue.length) {
                  var next = trans._frameQueue.pop();
                  if(next.onInterrupt) {
                      next.onInterrupt();
                  }
              }
  
              gd.emit('plotly_animationinterrupted', []);
          }
  
          function queueFrames(frameList) {
              if(frameList.length === 0) return;
  
              for(var i = 0; i < frameList.length; i++) {
                  var computedFrame;
  
                  if(frameList[i].type === 'byname') {
                      // If it's a named frame, compute it:
                      computedFrame = Plots.computeFrame(gd, frameList[i].name);
                  } else {
                      // Otherwise we must have been given a simple object, so treat
                      // the input itself as the computed frame.
                      computedFrame = frameList[i].data;
                  }
  
                  var frameOpts = getFrameOpts(i);
                  var transitionOpts = getTransitionOpts(i);
  
                  // It doesn't make much sense for the transition duration to be greater than
                  // the frame duration, so limit it:
                  transitionOpts.duration = Math.min(transitionOpts.duration, frameOpts.duration);
  
                  var nextFrame = {
                      frame: computedFrame,
                      name: frameList[i].name,
                      frameOpts: frameOpts,
                      transitionOpts: transitionOpts,
                  };
                  if(i === frameList.length - 1) {
                      // The last frame in this .animate call stores the promise resolve
                      // and reject callbacks. This is how we ensure that the animation
                      // loop (which may exist as a result of a *different* .animate call)
                      // still resolves or rejecdts this .animate call's promise. once it's
                      // complete.
                      nextFrame.onComplete = callbackOnNthTime(resolve, 2);
                      nextFrame.onInterrupt = reject;
                  }
  
                  trans._frameQueue.push(nextFrame);
              }
  
              // Set it as never having transitioned to a frame. This will cause the animation
              // loop to immediately transition to the next frame (which, for immediate mode,
              // is the first frame in the list since all others would have been discarded
              // below)
              if(animationOpts.mode === 'immediate') {
                  trans._lastFrameAt = -Infinity;
              }
  
              // Only it's not already running, start a RAF loop. This could be avoided in the
              // case that there's only one frame, but it significantly complicated the logic
              // and only sped things up by about 5% or so for a lorenz attractor simulation.
              // It would be a fine thing to implement, but the benefit of that optimization
              // doesn't seem worth the extra complexity.
              if(!trans._animationRaf) {
                  beginAnimationLoop();
              }
          }
  
          function stopAnimationLoop() {
              gd.emit('plotly_animated');
  
              // Be sure to unset also since it's how we know whether a loop is already running:
              window.cancelAnimationFrame(trans._animationRaf);
              trans._animationRaf = null;
          }
  
          function nextFrame() {
              if(trans._currentFrame && trans._currentFrame.onComplete) {
                  // Execute the callback and unset it to ensure it doesn't
                  // accidentally get called twice
                  trans._currentFrame.onComplete();
              }
  
              var newFrame = trans._currentFrame = trans._frameQueue.shift();
  
              if(newFrame) {
                  // Since it's sometimes necessary to do deep digging into frame data,
                  // we'll consider it not 100% impossible for nulls or numbers to sneak through,
                  // so check when casting the name, just to be absolutely certain:
                  var stringName = newFrame.name ? newFrame.name.toString() : null;
                  gd._fullLayout._currentFrame = stringName;
  
                  trans._lastFrameAt = Date.now();
                  trans._timeToNext = newFrame.frameOpts.duration;
  
                  // This is simply called and it's left to .transition to decide how to manage
                  // interrupting current transitions. That means we don't need to worry about
                  // how it resolves or what happens after this:
                  Plots.transition(gd,
                      newFrame.frame.data,
                      newFrame.frame.layout,
                      helpers.coerceTraceIndices(gd, newFrame.frame.traces),
                      newFrame.frameOpts,
                      newFrame.transitionOpts
                  ).then(function() {
                      if(newFrame.onComplete) {
                          newFrame.onComplete();
                      }
                  });
  
                  gd.emit('plotly_animatingframe', {
                      name: stringName,
                      frame: newFrame.frame,
                      animation: {
                          frame: newFrame.frameOpts,
                          transition: newFrame.transitionOpts,
                      }
                  });
              } else {
                  // If there are no more frames, then stop the RAF loop:
                  stopAnimationLoop();
              }
          }
  
          function beginAnimationLoop() {
              gd.emit('plotly_animating');
  
              // If no timer is running, then set last frame = long ago so that the next
              // frame is immediately transitioned:
              trans._lastFrameAt = -Infinity;
              trans._timeToNext = 0;
              trans._runningTransitions = 0;
              trans._currentFrame = null;
  
              var doFrame = function() {
                  // This *must* be requested before nextFrame since nextFrame may decide
                  // to cancel it if there's nothing more to animated:
                  trans._animationRaf = window.requestAnimationFrame(doFrame);
  
                  // Check if we're ready for a new frame:
                  if(Date.now() - trans._lastFrameAt > trans._timeToNext) {
                      nextFrame();
                  }
              };
  
              doFrame();
          }
  
          // This is an animate-local counter that helps match up option input list
          // items with the particular frame.
          var configCounter = 0;
          function setTransitionConfig(frame) {
              if(Array.isArray(transitionOpts)) {
                  if(configCounter >= transitionOpts.length) {
                      frame.transitionOpts = transitionOpts[configCounter];
                  } else {
                      frame.transitionOpts = transitionOpts[0];
                  }
              } else {
                  frame.transitionOpts = transitionOpts;
              }
              configCounter++;
              return frame;
          }
  
          // Disambiguate what's sort of frames have been received
          var i, frame;
          var frameList = [];
          var allFrames = frameOrGroupNameOrFrameList === undefined || frameOrGroupNameOrFrameList === null;
          var isFrameArray = Array.isArray(frameOrGroupNameOrFrameList);
          var isSingleFrame = !allFrames && !isFrameArray && Lib.isPlainObject(frameOrGroupNameOrFrameList);
  
          if(isSingleFrame) {
              // In this case, a simple object has been passed to animate.
              frameList.push({
                  type: 'object',
                  data: setTransitionConfig(Lib.extendFlat({}, frameOrGroupNameOrFrameList))
              });
          } else if(allFrames || ['string', 'number'].indexOf(typeof frameOrGroupNameOrFrameList) !== -1) {
              // In this case, null or undefined has been passed so that we want to
              // animate *all* currently defined frames
              for(i = 0; i < trans._frames.length; i++) {
                  frame = trans._frames[i];
  
                  if(!frame) continue;
  
                  if(allFrames || String(frame.group) === String(frameOrGroupNameOrFrameList)) {
                      frameList.push({
                          type: 'byname',
                          name: String(frame.name),
                          data: setTransitionConfig({name: frame.name})
                      });
                  }
              }
          } else if(isFrameArray) {
              for(i = 0; i < frameOrGroupNameOrFrameList.length; i++) {
                  var frameOrName = frameOrGroupNameOrFrameList[i];
                  if(['number', 'string'].indexOf(typeof frameOrName) !== -1) {
                      frameOrName = String(frameOrName);
                      // In this case, there's an array and this frame is a string name:
                      frameList.push({
                          type: 'byname',
                          name: frameOrName,
                          data: setTransitionConfig({name: frameOrName})
                      });
                  } else if(Lib.isPlainObject(frameOrName)) {
                      frameList.push({
                          type: 'object',
                          data: setTransitionConfig(Lib.extendFlat({}, frameOrName))
                      });
                  }
              }
          }
  
          // Verify that all of these frames actually exist; return and reject if not:
          for(i = 0; i < frameList.length; i++) {
              frame = frameList[i];
              if(frame.type === 'byname' && !trans._frameHash[frame.data.name]) {
                  Lib.warn('animate failure: frame not found: "' + frame.data.name + '"');
                  reject();
                  return;
              }
          }
  
          // If the mode is either next or immediate, then all currently queued frames must
          // be dumped and the corresponding .animate promises rejected.
          if(['next', 'immediate'].indexOf(animationOpts.mode) !== -1) {
              discardExistingFrames();
          }
  
          if(animationOpts.direction === 'reverse') {
              frameList.reverse();
          }
  
          var currentFrame = gd._fullLayout._currentFrame;
          if(currentFrame && animationOpts.fromcurrent) {
              var idx = -1;
              for(i = 0; i < frameList.length; i++) {
                  frame = frameList[i];
                  if(frame.type === 'byname' && frame.name === currentFrame) {
                      idx = i;
                      break;
                  }
              }
  
              if(idx > 0 && idx < frameList.length - 1) {
                  var filteredFrameList = [];
                  for(i = 0; i < frameList.length; i++) {
                      frame = frameList[i];
                      if(frameList[i].type !== 'byname' || i > idx) {
                          filteredFrameList.push(frame);
                      }
                  }
                  frameList = filteredFrameList;
              }
          }
  
          if(frameList.length > 0) {
              queueFrames(frameList);
          } else {
              // This is the case where there were simply no frames. It's a little strange
              // since there's not much to do:
              gd.emit('plotly_animated');
              resolve();
          }
      });
  }
  
  /**
   * Register new frames
   *
   * @param {string id or DOM element} gd
   *      the id or DOM element of the graph container div
   *
   * @param {array of objects} frameList
   *      list of frame definitions, in which each object includes any of:
   *      - name: {string} name of frame to add
   *      - data: {array of objects} trace data
   *      - layout {object} layout definition
   *      - traces {array} trace indices
   *      - baseframe {string} name of frame from which this frame gets defaults
   *
   *  @param {array of integers} indices
   *      an array of integer indices matching the respective frames in `frameList`. If not
   *      provided, an index will be provided in serial order. If already used, the frame
   *      will be overwritten.
   */
  function addFrames(gd, frameList, indices) {
      gd = Lib.getGraphDiv(gd);
  
      if(frameList === null || frameList === undefined) {
          return Promise.resolve();
      }
  
      if(!Lib.isPlotDiv(gd)) {
          throw new Error(
              'This element is not a Plotly plot: ' + gd + '. It\'s likely that you\'ve failed ' +
              'to create a plot before adding frames. For more details, see ' +
              'https://plotly.com/javascript/animations/'
          );
      }
  
      var i, frame, j, idx;
      var _frames = gd._transitionData._frames;
      var _frameHash = gd._transitionData._frameHash;
  
  
      if(!Array.isArray(frameList)) {
          throw new Error('addFrames failure: frameList must be an Array of frame definitions' + frameList);
      }
  
      // Create a sorted list of insertions since we run into lots of problems if these
      // aren't in ascending order of index:
      //
      // Strictly for sorting. Make sure this is guaranteed to never collide with any
      // already-exisisting indices:
      var bigIndex = _frames.length + frameList.length * 2;
  
      var insertions = [];
      var _frameHashLocal = {};
      for(i = frameList.length - 1; i >= 0; i--) {
          if(!Lib.isPlainObject(frameList[i])) continue;
  
          // The entire logic for checking for this type of name collision can be removed once we migrate to ES6 and
          // use a Map instead of an Object instance, as Map keys aren't converted to strings.
          var lookupName = frameList[i].name;
          var name = (_frameHash[lookupName] || _frameHashLocal[lookupName] || {}).name;
          var newName = frameList[i].name;
          var collisionPresent = _frameHash[name] || _frameHashLocal[name];
  
          if(name && newName && typeof newName === 'number' && collisionPresent && numericNameWarningCount < numericNameWarningCountLimit) {
              numericNameWarningCount++;
  
              Lib.warn('addFrames: overwriting frame "' + (_frameHash[name] || _frameHashLocal[name]).name +
                  '" with a frame whose name of type "number" also equates to "' +
                  name + '". This is valid but may potentially lead to unexpected ' +
                  'behavior since all plotly.js frame names are stored internally ' +
                  'as strings.');
  
              if(numericNameWarningCount === numericNameWarningCountLimit) {
                  Lib.warn('addFrames: This API call has yielded too many of these warnings. ' +
                      'For the rest of this call, further warnings about numeric frame ' +
                      'names will be suppressed.');
              }
          }
  
          _frameHashLocal[lookupName] = {name: lookupName};
  
          insertions.push({
              frame: Plots.supplyFrameDefaults(frameList[i]),
              index: (indices && indices[i] !== undefined && indices[i] !== null) ? indices[i] : bigIndex + i
          });
      }
  
      // Sort this, taking note that undefined insertions end up at the end:
      insertions.sort(function(a, b) {
          if(a.index > b.index) return -1;
          if(a.index < b.index) return 1;
          return 0;
      });
  
      var ops = [];
      var revops = [];
      var frameCount = _frames.length;
  
      for(i = insertions.length - 1; i >= 0; i--) {
          frame = insertions[i].frame;
  
          if(typeof frame.name === 'number') {
              Lib.warn('Warning: addFrames accepts frames with numeric names, but the numbers are' +
                  'implicitly cast to strings');
          }
  
          if(!frame.name) {
              // Repeatedly assign a default name, incrementing the counter each time until
              // we get a name that's not in the hashed lookup table:
              while(_frameHash[(frame.name = 'frame ' + gd._transitionData._counter++)]);
          }
  
          if(_frameHash[frame.name]) {
              // If frame is present, overwrite its definition:
              for(j = 0; j < _frames.length; j++) {
                  if((_frames[j] || {}).name === frame.name) break;
              }
              ops.push({type: 'replace', index: j, value: frame});
              revops.unshift({type: 'replace', index: j, value: _frames[j]});
          } else {
              // Otherwise insert it at the end of the list:
              idx = Math.max(0, Math.min(insertions[i].index, frameCount));
  
              ops.push({type: 'insert', index: idx, value: frame});
              revops.unshift({type: 'delete', index: idx});
              frameCount++;
          }
      }
  
      var undoFunc = Plots.modifyFrames;
      var redoFunc = Plots.modifyFrames;
      var undoArgs = [gd, revops];
      var redoArgs = [gd, ops];
  
      if(Queue) Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
  
      return Plots.modifyFrames(gd, ops);
  }
  
  /**
   * Delete frame
   *
   * @param {string id or DOM element} gd
   *      the id or DOM element of the graph container div
   *
   * @param {array of integers} frameList
   *      list of integer indices of frames to be deleted
   */
  function deleteFrames(gd, frameList) {
      gd = Lib.getGraphDiv(gd);
  
      if(!Lib.isPlotDiv(gd)) {
          throw new Error('This element is not a Plotly plot: ' + gd);
      }
  
      var i, idx;
      var _frames = gd._transitionData._frames;
      var ops = [];
      var revops = [];
  
      if(!frameList) {
          frameList = [];
          for(i = 0; i < _frames.length; i++) {
              frameList.push(i);
          }
      }
  
      frameList = frameList.slice();
      frameList.sort();
  
      for(i = frameList.length - 1; i >= 0; i--) {
          idx = frameList[i];
          ops.push({type: 'delete', index: idx});
          revops.unshift({type: 'insert', index: idx, value: _frames[idx]});
      }
  
      var undoFunc = Plots.modifyFrames;
      var redoFunc = Plots.modifyFrames;
      var undoArgs = [gd, revops];
      var redoArgs = [gd, ops];
  
      if(Queue) Queue.add(gd, undoFunc, undoArgs, redoFunc, redoArgs);
  
      return Plots.modifyFrames(gd, ops);
  }
  
  /**
   * Purge a graph container div back to its initial pre-Plotly.plot state
   *
   * @param {string id or DOM element} gd
   *      the id or DOM element of the graph container div
   */
  function purge(gd) {
      gd = Lib.getGraphDiv(gd);
  
      var fullLayout = gd._fullLayout || {};
      var fullData = gd._fullData || [];
  
      // remove gl contexts
      Plots.cleanPlot([], {}, fullData, fullLayout);
  
      // purge properties
      Plots.purge(gd);
  
      // purge event emitter methods
      Events.purge(gd);
  
      // remove plot container
      if(fullLayout._container) fullLayout._container.remove();
  
      // in contrast to Plotly.Plots.purge which does NOT clear _context!
      delete gd._context;
  
      return gd;
  }
  
  // -------------------------------------------------------
  // makePlotFramework: Create the plot container and axes
  // -------------------------------------------------------
  function makePlotFramework(gd) {
      var gd3 = d3.select(gd);
      var fullLayout = gd._fullLayout;
  
      // Plot container
      fullLayout._container = gd3.selectAll('.plot-container').data([0]);
      fullLayout._container.enter()
          .insert('div', ':first-child')
          .classed('plot-container', true)
          .classed('plotly', true);
  
      // Make the svg container
      fullLayout._paperdiv = fullLayout._container.selectAll('.svg-container').data([0]);
      fullLayout._paperdiv.enter().append('div')
          .classed('user-select-none', true)
          .classed('svg-container', true)
          .style('position', 'relative');
  
      // Make the graph containers
      // start fresh each time we get here, so we know the order comes out
      // right, rather than enter/exit which can muck up the order
      // TODO: sort out all the ordering so we don't have to
      // explicitly delete anything
      // FIXME: parcoords reuses this object, not the best pattern
      fullLayout._glcontainer = fullLayout._paperdiv.selectAll('.gl-container')
          .data([{}]);
  
      fullLayout._glcontainer.enter().append('div')
          .classed('gl-container', true);
  
      fullLayout._paperdiv.selectAll('.main-svg').remove();
      fullLayout._paperdiv.select('.modebar-container').remove();
  
      fullLayout._paper = fullLayout._paperdiv.insert('svg', ':first-child')
          .classed('main-svg', true);
  
      fullLayout._toppaper = fullLayout._paperdiv.append('svg')
          .classed('main-svg', true);
  
      fullLayout._modebardiv = fullLayout._paperdiv.append('div');
      delete fullLayout._modeBar;
  
      fullLayout._hoverpaper = fullLayout._paperdiv.append('svg')
          .classed('main-svg', true);
  
      if(!fullLayout._uid) {
          var otherUids = {};
          d3.selectAll('defs').each(function() {
              if(this.id) otherUids[this.id.split('-')[1]] = 1;
          });
          fullLayout._uid = Lib.randstr(otherUids);
      }
  
      fullLayout._paperdiv.selectAll('.main-svg')
          .attr(xmlnsNamespaces.svgAttrs);
  
      fullLayout._defs = fullLayout._paper.append('defs')
          .attr('id', 'defs-' + fullLayout._uid);
  
      fullLayout._clips = fullLayout._defs.append('g')
          .classed('clips', true);
  
      fullLayout._topdefs = fullLayout._toppaper.append('defs')
          .attr('id', 'topdefs-' + fullLayout._uid);
  
      fullLayout._topclips = fullLayout._topdefs.append('g')
          .classed('clips', true);
  
      fullLayout._bgLayer = fullLayout._paper.append('g')
          .classed('bglayer', true);
  
      fullLayout._draggers = fullLayout._paper.append('g')
          .classed('draglayer', true);
  
      // lower shape/image layer - note that this is behind
      // all subplots data/grids but above the backgrounds
      // except inset subplots, whose backgrounds are drawn
      // inside their own group so that they appear above
      // the data for the main subplot
      // lower shapes and images which are fully referenced to
      // a subplot still get drawn within the subplot's group
      // so they will work correctly on insets
      var layerBelow = fullLayout._paper.append('g')
          .classed('layer-below', true);
      fullLayout._imageLowerLayer = layerBelow.append('g')
          .classed('imagelayer', true);
      fullLayout._shapeLowerLayer = layerBelow.append('g')
          .classed('shapelayer', true);
  
      // single cartesian layer for the whole plot
      fullLayout._cartesianlayer = fullLayout._paper.append('g').classed('cartesianlayer', true);
  
      // single polar layer for the whole plot
      fullLayout._polarlayer = fullLayout._paper.append('g').classed('polarlayer', true);
  
      // single ternary layer for the whole plot
      fullLayout._ternarylayer = fullLayout._paper.append('g').classed('ternarylayer', true);
  
      // single geo layer for the whole plot
      fullLayout._geolayer = fullLayout._paper.append('g').classed('geolayer', true);
  
      // single funnelarea layer for the whole plot
      fullLayout._funnelarealayer = fullLayout._paper.append('g').classed('funnelarealayer', true);
  
      // single pie layer for the whole plot
      fullLayout._pielayer = fullLayout._paper.append('g').classed('pielayer', true);
  
      // single treemap layer for the whole plot
      fullLayout._treemaplayer = fullLayout._paper.append('g').classed('treemaplayer', true);
  
      // single sunburst layer for the whole plot
      fullLayout._sunburstlayer = fullLayout._paper.append('g').classed('sunburstlayer', true);
  
      // single indicator layer for the whole plot
      fullLayout._indicatorlayer = fullLayout._toppaper.append('g').classed('indicatorlayer', true);
  
      // fill in image server scrape-svg
      fullLayout._glimages = fullLayout._paper.append('g').classed('glimages', true);
  
      // lastly upper shapes, info (legend, annotations) and hover layers go on top
      // these are in a different svg element normally, but get collapsed into a single
      // svg when exporting (after inserting 3D)
      // upper shapes/images are only those drawn above the whole plot, including subplots
      var layerAbove = fullLayout._toppaper.append('g')
          .classed('layer-above', true);
      fullLayout._imageUpperLayer = layerAbove.append('g')
          .classed('imagelayer', true);
      fullLayout._shapeUpperLayer = layerAbove.append('g')
          .classed('shapelayer', true);
  
      fullLayout._infolayer = fullLayout._toppaper.append('g').classed('infolayer', true);
      fullLayout._menulayer = fullLayout._toppaper.append('g').classed('menulayer', true);
      fullLayout._zoomlayer = fullLayout._toppaper.append('g').classed('zoomlayer', true);
      fullLayout._hoverlayer = fullLayout._hoverpaper.append('g').classed('hoverlayer', true);
  
      // Make the modebar container
      fullLayout._modebardiv
          .classed('modebar-container', true)
          .style('position', 'absolute')
          .style('top', '0px')
          .style('right', '0px');
  
      gd.emit('plotly_framework');
  }
  
  exports.animate = animate;
  exports.addFrames = addFrames;
  exports.deleteFrames = deleteFrames;
  
  exports.addTraces = addTraces;
  exports.deleteTraces = deleteTraces;
  exports.extendTraces = extendTraces;
  exports.moveTraces = moveTraces;
  exports.prependTraces = prependTraces;
  
  exports.newPlot = newPlot;
  exports.plot = plot;
  exports.purge = purge;
  
  exports.react = react;
  exports.redraw = redraw;
  exports.relayout = relayout;
  exports.restyle = restyle;
  
  exports.setPlotConfig = setPlotConfig;
  
  exports.update = update;
  
  exports._guiRelayout = guiEdit(relayout);
  exports._guiRestyle = guiEdit(restyle);
  exports._guiUpdate = guiEdit(update);
  
  exports._storeDirectGUIEdit = _storeDirectGUIEdit;
  
  },{"../components/color":615,"../components/drawing":637,"../constants/xmlns_namespaces":726,"../lib":750,"../lib/events":739,"../lib/queue":765,"../lib/svg_text_utils":774,"../plots/cartesian/axes":799,"../plots/cartesian/constants":805,"../plots/cartesian/graph_interact":808,"../plots/cartesian/select":818,"../plots/plots":862,"../plots/polar/legacy":870,"../registry":882,"./edit_types":781,"./helpers":782,"./manage_arrays":784,"./plot_config":786,"./plot_schema":787,"./subroutines":789,"d3":169,"fast-isnumeric":241,"has-hover":414}],786:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /**
   * This will be transferred over to gd and overridden by
   * config args to Plotly.plot.
   *
   * The defaults are the appropriate settings for plotly.js,
   * so we get the right experience without any config argument.
   *
   * N.B. the config options are not coerced using Lib.coerce so keys
   * like `valType` and `values` are only set for documentation purposes
   * at the moment.
   */
  
  var configAttributes = {
      staticPlot: {
          valType: 'boolean',
          dflt: false,
          
      },
  
      plotlyServerURL: {
          valType: 'string',
          dflt: '',
          
      },
  
      editable: {
          valType: 'boolean',
          dflt: false,
          
      },
      edits: {
          annotationPosition: {
              valType: 'boolean',
              dflt: false,
              
          },
          annotationTail: {
              valType: 'boolean',
              dflt: false,
              
          },
          annotationText: {
              valType: 'boolean',
              dflt: false,
              
          },
          axisTitleText: {
              valType: 'boolean',
              dflt: false,
              
          },
          colorbarPosition: {
              valType: 'boolean',
              dflt: false,
              
          },
          colorbarTitleText: {
              valType: 'boolean',
              dflt: false,
              
          },
          legendPosition: {
              valType: 'boolean',
              dflt: false,
              
          },
          legendText: {
              valType: 'boolean',
              dflt: false,
              
          },
          shapePosition: {
              valType: 'boolean',
              dflt: false,
              
          },
          titleText: {
              valType: 'boolean',
              dflt: false,
              
          }
      },
  
      autosizable: {
          valType: 'boolean',
          dflt: false,
          
      },
      responsive: {
          valType: 'boolean',
          dflt: false,
          
      },
      fillFrame: {
          valType: 'boolean',
          dflt: false,
          
      },
      frameMargins: {
          valType: 'number',
          dflt: 0,
          min: 0,
          max: 0.5,
          
      },
  
      scrollZoom: {
          valType: 'flaglist',
          flags: ['cartesian', 'gl3d', 'geo', 'mapbox'],
          extras: [true, false],
          dflt: 'gl3d+geo+mapbox',
          
      },
      doubleClick: {
          valType: 'enumerated',
          values: [false, 'reset', 'autosize', 'reset+autosize'],
          dflt: 'reset+autosize',
          
      },
      doubleClickDelay: {
          valType: 'number',
          dflt: 300,
          min: 0,
          
      },
  
      showAxisDragHandles: {
          valType: 'boolean',
          dflt: true,
          
      },
      showAxisRangeEntryBoxes: {
          valType: 'boolean',
          dflt: true,
          
      },
  
      showTips: {
          valType: 'boolean',
          dflt: true,
          
      },
  
      showLink: {
          valType: 'boolean',
          dflt: false,
          
      },
      linkText: {
          valType: 'string',
          dflt: 'Edit chart',
          noBlank: true,
          
      },
      sendData: {
          valType: 'boolean',
          dflt: true,
          
      },
      showSources: {
          valType: 'any',
          dflt: false,
          
      },
  
      displayModeBar: {
          valType: 'enumerated',
          values: ['hover', true, false],
          dflt: 'hover',
          
      },
      showSendToCloud: {
          valType: 'boolean',
          dflt: false,
          
      },
      showEditInChartStudio: {
          valType: 'boolean',
          dflt: false,
          
      },
      modeBarButtonsToRemove: {
          valType: 'any',
          dflt: [],
          
      },
      modeBarButtonsToAdd: {
          valType: 'any',
          dflt: [],
          
      },
      modeBarButtons: {
          valType: 'any',
          dflt: false,
          
      },
      toImageButtonOptions: {
          valType: 'any',
          dflt: {},
          
      },
      displaylogo: {
          valType: 'boolean',
          dflt: true,
          
      },
      watermark: {
          valType: 'boolean',
          dflt: false,
          
      },
  
      plotGlPixelRatio: {
          valType: 'number',
          dflt: 2,
          min: 1,
          max: 4,
          
      },
  
      setBackground: {
          valType: 'any',
          dflt: 'transparent',
          
      },
  
      topojsonURL: {
          valType: 'string',
          noBlank: true,
          dflt: 'https://cdn.plot.ly/',
          
      },
  
      mapboxAccessToken: {
          valType: 'string',
          dflt: null,
          
      },
  
      logging: {
          valType: 'integer',
          min: 0,
          max: 2,
          dflt: 1,
          
      },
  
      notifyOnLogging: {
          valType: 'integer',
          min: 0,
          max: 2,
          dflt: 0,
          
      },
  
      queueLength: {
          valType: 'integer',
          min: 0,
          dflt: 0,
          
      },
  
      globalTransforms: {
          valType: 'any',
          dflt: [],
          
      },
  
      locale: {
          valType: 'string',
          dflt: 'en-US',
          
      },
  
      locales: {
          valType: 'any',
          dflt: {},
          
      }
  };
  
  var dfltConfig = {};
  
  function crawl(src, target) {
      for(var k in src) {
          var obj = src[k];
          if(obj.valType) {
              target[k] = obj.dflt;
          } else {
              if(!target[k]) {
                  target[k] = {};
              }
              crawl(obj, target[k]);
          }
      }
  }
  
  crawl(configAttributes, dfltConfig);
  
  module.exports = {
      configAttributes: configAttributes,
      dfltConfig: dfltConfig
  };
  
  },{}],787:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../registry');
  var Lib = _dereq_('../lib');
  
  var baseAttributes = _dereq_('../plots/attributes');
  var baseLayoutAttributes = _dereq_('../plots/layout_attributes');
  var frameAttributes = _dereq_('../plots/frame_attributes');
  var animationAttributes = _dereq_('../plots/animation_attributes');
  var configAttributes = _dereq_('./plot_config').configAttributes;
  
  // polar attributes are not part of the Registry yet
  var polarAreaAttrs = _dereq_('../plots/polar/legacy/area_attributes');
  var polarAxisAttrs = _dereq_('../plots/polar/legacy/axis_attributes');
  
  var editTypes = _dereq_('./edit_types');
  
  var extendFlat = Lib.extendFlat;
  var extendDeepAll = Lib.extendDeepAll;
  var isPlainObject = Lib.isPlainObject;
  var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
  var nestedProperty = Lib.nestedProperty;
  var valObjectMeta = Lib.valObjectMeta;
  
  var IS_SUBPLOT_OBJ = '_isSubplotObj';
  var IS_LINKED_TO_ARRAY = '_isLinkedToArray';
  var ARRAY_ATTR_REGEXPS = '_arrayAttrRegexps';
  var DEPRECATED = '_deprecated';
  var UNDERSCORE_ATTRS = [IS_SUBPLOT_OBJ, IS_LINKED_TO_ARRAY, ARRAY_ATTR_REGEXPS, DEPRECATED];
  
  exports.IS_SUBPLOT_OBJ = IS_SUBPLOT_OBJ;
  exports.IS_LINKED_TO_ARRAY = IS_LINKED_TO_ARRAY;
  exports.DEPRECATED = DEPRECATED;
  exports.UNDERSCORE_ATTRS = UNDERSCORE_ATTRS;
  
  /** Outputs the full plotly.js plot schema
   *
   * @return {object}
   *  - defs
   *  - traces
   *  - layout
   *  - transforms
   *  - frames
   *  - animations
   *  - config
   */
  exports.get = function() {
      var traces = {};
  
      Registry.allTypes.concat('area').forEach(function(type) {
          traces[type] = getTraceAttributes(type);
      });
  
      var transforms = {};
  
      Object.keys(Registry.transformsRegistry).forEach(function(type) {
          transforms[type] = getTransformAttributes(type);
      });
  
      return {
          defs: {
              valObjects: valObjectMeta,
              metaKeys: UNDERSCORE_ATTRS.concat(['description', 'role', 'editType', 'impliedEdits']),
              editType: {
                  traces: editTypes.traces,
                  layout: editTypes.layout
              },
              impliedEdits: {
                  
              }
          },
  
          traces: traces,
          layout: getLayoutAttributes(),
  
          transforms: transforms,
  
          frames: getFramesAttributes(),
          animation: formatAttributes(animationAttributes),
  
          config: formatAttributes(configAttributes)
      };
  };
  
  /**
   * Crawl the attribute tree, recursively calling a callback function
   *
   * @param {object} attrs
   *  The node of the attribute tree (e.g. the root) from which recursion originates
   * @param {Function} callback
   *  A callback function with the signature:
   *          @callback callback
   *          @param {object} attr an attribute
   *          @param {String} attrName name string
   *          @param {object[]} attrs all the attributes
   *          @param {Number} level the recursion level, 0 at the root
   *          @param {String} fullAttrString full attribute name (ie 'marker.line')
   * @param {Number} [specifiedLevel]
   *  The level in the tree, in order to let the callback function detect descend or backtrack,
   *  typically unsupplied (implied 0), just used by the self-recursive call.
   *  The necessity arises because the tree traversal is not controlled by callback return values.
   *  The decision to not use callback return values for controlling tree pruning arose from
   *  the goal of keeping the crawler backwards compatible. Observe that one of the pruning conditions
   *  precedes the callback call.
   * @param {string} [attrString]
   *  the path to the current attribute, as an attribute string (ie 'marker.line')
   *  typically unsupplied, but you may supply it if you want to disambiguate which attrs tree you
   *  are starting from
   *
   * @return {object} transformOut
   *  copy of transformIn that contains attribute defaults
   */
  exports.crawl = function(attrs, callback, specifiedLevel, attrString) {
      var level = specifiedLevel || 0;
      attrString = attrString || '';
  
      Object.keys(attrs).forEach(function(attrName) {
          var attr = attrs[attrName];
  
          if(UNDERSCORE_ATTRS.indexOf(attrName) !== -1) return;
  
          var fullAttrString = (attrString ? attrString + '.' : '') + attrName;
          callback(attr, attrName, attrs, level, fullAttrString);
  
          if(exports.isValObject(attr)) return;
  
          if(isPlainObject(attr) && attrName !== 'impliedEdits') {
              exports.crawl(attr, callback, level + 1, fullAttrString);
          }
      });
  };
  
  /** Is object a value object (or a container object)?
   *
   * @param {object} obj
   * @return {boolean}
   *  returns true for a valid value object and
   *  false for tree nodes in the attribute hierarchy
   */
  exports.isValObject = function(obj) {
      return obj && obj.valType !== undefined;
  };
  
  /**
   * Find all data array attributes in a given trace object - including
   * `arrayOk` attributes.
   *
   * @param {object} trace
   *  full trace object that contains a reference to `_module.attributes`
   *
   * @return {array} arrayAttributes
   *  list of array attributes for the given trace
   */
  exports.findArrayAttributes = function(trace) {
      var arrayAttributes = [];
      var stack = [];
      var isArrayStack = [];
      var baseContainer, baseAttrName;
  
      function callback(attr, attrName, attrs, level) {
          stack = stack.slice(0, level).concat([attrName]);
          isArrayStack = isArrayStack.slice(0, level).concat([attr && attr._isLinkedToArray]);
  
          var splittableAttr = (
              attr &&
              (attr.valType === 'data_array' || attr.arrayOk === true) &&
              !(stack[level - 1] === 'colorbar' && (attrName === 'ticktext' || attrName === 'tickvals'))
          );
  
          // Manually exclude 'colorbar.tickvals' and 'colorbar.ticktext' for now
          // which are declared as `valType: 'data_array'` but scale independently of
          // the coordinate arrays.
          //
          // Down the road, we might want to add a schema field (e.g `uncorrelatedArray: true`)
          // to distinguish attributes of the likes.
  
          if(!splittableAttr) return;
  
          crawlIntoTrace(baseContainer, 0, '');
      }
  
      function crawlIntoTrace(container, i, astrPartial) {
          var item = container[stack[i]];
          var newAstrPartial = astrPartial + stack[i];
          if(i === stack.length - 1) {
              if(isArrayOrTypedArray(item)) {
                  arrayAttributes.push(baseAttrName + newAstrPartial);
              }
          } else {
              if(isArrayStack[i]) {
                  if(Array.isArray(item)) {
                      for(var j = 0; j < item.length; j++) {
                          if(isPlainObject(item[j])) {
                              crawlIntoTrace(item[j], i + 1, newAstrPartial + '[' + j + '].');
                          }
                      }
                  }
              } else if(isPlainObject(item)) {
                  crawlIntoTrace(item, i + 1, newAstrPartial + '.');
              }
          }
      }
  
      baseContainer = trace;
      baseAttrName = '';
      exports.crawl(baseAttributes, callback);
      if(trace._module && trace._module.attributes) {
          exports.crawl(trace._module.attributes, callback);
      }
  
      var transforms = trace.transforms;
      if(transforms) {
          for(var i = 0; i < transforms.length; i++) {
              var transform = transforms[i];
              var module = transform._module;
  
              if(module) {
                  baseAttrName = 'transforms[' + i + '].';
                  baseContainer = transform;
  
                  exports.crawl(module.attributes, callback);
              }
          }
      }
  
      return arrayAttributes;
  };
  
  /*
   * Find the valObject for one attribute in an existing trace
   *
   * @param {object} trace
   *  full trace object that contains a reference to `_module.attributes`
   * @param {object} parts
   *  an array of parts, like ['transforms', 1, 'value']
   *  typically from nestedProperty(...).parts
   *
   * @return {object|false}
   *  the valObject for this attribute, or the last found parent
   *  in some cases the innermost valObject will not exist, for example
   *  `valType: 'any'` attributes where we might set a part of the attribute.
   *  In that case, stop at the deepest valObject we *do* find.
   */
  exports.getTraceValObject = function(trace, parts) {
      var head = parts[0];
      var i = 1; // index to start recursing from
      var moduleAttrs, valObject;
  
      if(head === 'transforms') {
          if(parts.length === 1) {
              return baseAttributes.transforms;
          }
          var transforms = trace.transforms;
          if(!Array.isArray(transforms) || !transforms.length) return false;
          var tNum = parts[1];
          if(!isIndex(tNum) || tNum >= transforms.length) {
              return false;
          }
          moduleAttrs = (Registry.transformsRegistry[transforms[tNum].type] || {}).attributes;
          valObject = moduleAttrs && moduleAttrs[parts[2]];
          i = 3; // start recursing only inside the transform
      } else if(trace.type === 'area') {
          valObject = polarAreaAttrs[head];
      } else {
          // first look in the module for this trace
          // components have already merged their trace attributes in here
          var _module = trace._module;
          if(!_module) _module = (Registry.modules[trace.type || baseAttributes.type.dflt] || {})._module;
          if(!_module) return false;
  
          moduleAttrs = _module.attributes;
          valObject = moduleAttrs && moduleAttrs[head];
  
          // then look in the subplot attributes
          if(!valObject) {
              var subplotModule = _module.basePlotModule;
              if(subplotModule && subplotModule.attributes) {
                  valObject = subplotModule.attributes[head];
              }
          }
  
          // finally look in the global attributes
          if(!valObject) valObject = baseAttributes[head];
      }
  
      return recurseIntoValObject(valObject, parts, i);
  };
  
  /*
   * Find the valObject for one layout attribute
   *
   * @param {array} parts
   *  an array of parts, like ['annotations', 1, 'x']
   *  typically from nestedProperty(...).parts
   *
   * @return {object|false}
   *  the valObject for this attribute, or the last found parent
   *  in some cases the innermost valObject will not exist, for example
   *  `valType: 'any'` attributes where we might set a part of the attribute.
   *  In that case, stop at the deepest valObject we *do* find.
   */
  exports.getLayoutValObject = function(fullLayout, parts) {
      var valObject = layoutHeadAttr(fullLayout, parts[0]);
  
      return recurseIntoValObject(valObject, parts, 1);
  };
  
  function layoutHeadAttr(fullLayout, head) {
      var i, key, _module, attributes;
  
      // look for attributes of the subplot types used on the plot
      var basePlotModules = fullLayout._basePlotModules;
      if(basePlotModules) {
          var out;
          for(i = 0; i < basePlotModules.length; i++) {
              _module = basePlotModules[i];
              if(_module.attrRegex && _module.attrRegex.test(head)) {
                  // if a module defines overrides, these take precedence
                  // initially this is to allow gl2d different editTypes from svg cartesian
                  if(_module.layoutAttrOverrides) return _module.layoutAttrOverrides;
  
                  // otherwise take the first attributes we find
                  if(!out && _module.layoutAttributes) out = _module.layoutAttributes;
              }
  
              // a module can also override the behavior of base (and component) module layout attrs
              // again see gl2d for initial use case
              var baseOverrides = _module.baseLayoutAttrOverrides;
              if(baseOverrides && head in baseOverrides) return baseOverrides[head];
          }
          if(out) return out;
      }
  
      // look for layout attributes contributed by traces on the plot
      var modules = fullLayout._modules;
      if(modules) {
          for(i = 0; i < modules.length; i++) {
              attributes = modules[i].layoutAttributes;
              if(attributes && head in attributes) {
                  return attributes[head];
              }
          }
      }
  
      /*
       * Next look in components.
       * Components that define a schema have already merged this into
       * base and subplot attribute defs, so ignore these.
       * Others (older style) all put all their attributes
       * inside a container matching the module `name`
       * eg `attributes` (array) or `legend` (object)
       */
      for(key in Registry.componentsRegistry) {
          _module = Registry.componentsRegistry[key];
          if(_module.name === 'colorscale' && head.indexOf('coloraxis') === 0) {
              return _module.layoutAttributes[head];
          } else if(!_module.schema && (head === _module.name)) {
              return _module.layoutAttributes;
          }
      }
  
      if(head in baseLayoutAttributes) return baseLayoutAttributes[head];
  
      // Polar doesn't populate _modules or _basePlotModules
      // just fall back on these when the others fail
      if(head === 'radialaxis' || head === 'angularaxis') {
          return polarAxisAttrs[head];
      }
      return polarAxisAttrs.layout[head] || false;
  }
  
  function recurseIntoValObject(valObject, parts, i) {
      if(!valObject) return false;
  
      if(valObject._isLinkedToArray) {
          // skip array index, abort if we try to dive into an array without an index
          if(isIndex(parts[i])) i++;
          else if(i < parts.length) return false;
      }
  
      // now recurse as far as we can. Occasionally we have an attribute
      // setting an internal part below what's in the schema; just return
      // the innermost schema item we find.
      for(; i < parts.length; i++) {
          var newValObject = valObject[parts[i]];
          if(isPlainObject(newValObject)) valObject = newValObject;
          else break;
  
          if(i === parts.length - 1) break;
  
          if(valObject._isLinkedToArray) {
              i++;
              if(!isIndex(parts[i])) return false;
          } else if(valObject.valType === 'info_array') {
              i++;
              var index = parts[i];
              if(!isIndex(index)) return false;
  
              var items = valObject.items;
              if(Array.isArray(items)) {
                  if(index >= items.length) return false;
                  if(valObject.dimensions === 2) {
                      i++;
                      if(parts.length === i) return valObject;
                      var index2 = parts[i];
                      if(!isIndex(index2)) return false;
                      valObject = items[index][index2];
                  } else valObject = items[index];
              } else {
                  valObject = items;
              }
          }
      }
  
      return valObject;
  }
  
  // note: this is different from Lib.isIndex, this one doesn't accept numeric
  // strings, only actual numbers.
  function isIndex(val) {
      return val === Math.round(val) && val >= 0;
  }
  
  function getTraceAttributes(type) {
      var _module, basePlotModule;
  
      if(type === 'area') {
          _module = { attributes: polarAreaAttrs };
          basePlotModule = {};
      } else {
          _module = Registry.modules[type]._module,
          basePlotModule = _module.basePlotModule;
      }
  
      var attributes = {};
  
      // make 'type' the first attribute in the object
      attributes.type = null;
  
      var copyBaseAttributes = extendDeepAll({}, baseAttributes);
      var copyModuleAttributes = extendDeepAll({}, _module.attributes);
  
      // prune global-level trace attributes that are already defined in a trace
      exports.crawl(copyModuleAttributes, function(attr, attrName, attrs, level, fullAttrString) {
          nestedProperty(copyBaseAttributes, fullAttrString).set(undefined);
          // Prune undefined attributes
          if(attr === undefined) nestedProperty(copyModuleAttributes, fullAttrString).set(undefined);
      });
  
      // base attributes (same for all trace types)
      extendDeepAll(attributes, copyBaseAttributes);
  
      // prune-out base attributes based on trace module categories
      if(Registry.traceIs(type, 'noOpacity')) {
          delete attributes.opacity;
      }
      if(!Registry.traceIs(type, 'showLegend')) {
          delete attributes.showlegend;
          delete attributes.legendgroup;
      }
      if(Registry.traceIs(type, 'noHover')) {
          delete attributes.hoverinfo;
          delete attributes.hoverlabel;
      }
      if(!_module.selectPoints) {
          delete attributes.selectedpoints;
      }
  
      // module attributes
      extendDeepAll(attributes, copyModuleAttributes);
  
      // subplot attributes
      if(basePlotModule.attributes) {
          extendDeepAll(attributes, basePlotModule.attributes);
      }
  
      // 'type' gets overwritten by baseAttributes; reset it here
      attributes.type = type;
  
      var out = {
          meta: _module.meta || {},
          categories: _module.categories || {},
          animatable: Boolean(_module.animatable),
          type: type,
          attributes: formatAttributes(attributes),
      };
  
      // trace-specific layout attributes
      if(_module.layoutAttributes) {
          var layoutAttributes = {};
  
          extendDeepAll(layoutAttributes, _module.layoutAttributes);
          out.layoutAttributes = formatAttributes(layoutAttributes);
      }
  
      // drop anim:true in non-animatable modules
      if(!_module.animatable) {
          exports.crawl(out, function(attr) {
              if(exports.isValObject(attr) && 'anim' in attr) {
                  delete attr.anim;
              }
          });
      }
  
      return out;
  }
  
  function getLayoutAttributes() {
      var layoutAttributes = {};
      var key, _module;
  
      // global layout attributes
      extendDeepAll(layoutAttributes, baseLayoutAttributes);
  
      // add base plot module layout attributes
      for(key in Registry.subplotsRegistry) {
          _module = Registry.subplotsRegistry[key];
  
          if(!_module.layoutAttributes) continue;
  
          if(Array.isArray(_module.attr)) {
              for(var i = 0; i < _module.attr.length; i++) {
                  handleBasePlotModule(layoutAttributes, _module, _module.attr[i]);
              }
          } else {
              var astr = _module.attr === 'subplot' ? _module.name : _module.attr;
              handleBasePlotModule(layoutAttributes, _module, astr);
          }
      }
  
      // polar layout attributes
      layoutAttributes = assignPolarLayoutAttrs(layoutAttributes);
  
      // add registered components layout attributes
      for(key in Registry.componentsRegistry) {
          _module = Registry.componentsRegistry[key];
          var schema = _module.schema;
  
          if(schema && (schema.subplots || schema.layout)) {
              /*
               * Components with defined schema have already been merged in at register time
               * but a few components define attributes that apply only to xaxis
               * not yaxis (rangeselector, rangeslider) - delete from y schema.
               * Note that the input attributes for xaxis/yaxis are the same object
               * so it's not possible to only add them to xaxis from the start.
               * If we ever have such asymmetry the other way, or anywhere else,
               * we will need to extend both this code and mergeComponentAttrsToSubplot
               * (which will not find yaxis only for example)
               */
              var subplots = schema.subplots;
              if(subplots && subplots.xaxis && !subplots.yaxis) {
                  for(var xkey in subplots.xaxis) {
                      delete layoutAttributes.yaxis[xkey];
                  }
              }
          } else if(_module.name === 'colorscale') {
              extendDeepAll(layoutAttributes, _module.layoutAttributes);
          } else if(_module.layoutAttributes) {
              // older style without schema need to be explicitly merged in now
              insertAttrs(layoutAttributes, _module.layoutAttributes, _module.name);
          }
      }
  
      return {
          layoutAttributes: formatAttributes(layoutAttributes)
      };
  }
  
  function getTransformAttributes(type) {
      var _module = Registry.transformsRegistry[type];
      var attributes = extendDeepAll({}, _module.attributes);
  
      // add registered components transform attributes
      Object.keys(Registry.componentsRegistry).forEach(function(k) {
          var _module = Registry.componentsRegistry[k];
  
          if(_module.schema && _module.schema.transforms && _module.schema.transforms[type]) {
              Object.keys(_module.schema.transforms[type]).forEach(function(v) {
                  insertAttrs(attributes, _module.schema.transforms[type][v], v);
              });
          }
      });
  
      return {
          attributes: formatAttributes(attributes)
      };
  }
  
  function getFramesAttributes() {
      var attrs = {
          frames: extendDeepAll({}, frameAttributes)
      };
  
      formatAttributes(attrs);
  
      return attrs.frames;
  }
  
  function formatAttributes(attrs) {
      mergeValTypeAndRole(attrs);
      formatArrayContainers(attrs);
      stringify(attrs);
  
      return attrs;
  }
  
  function mergeValTypeAndRole(attrs) {
      function makeSrcAttr(attrName) {
          return {
              valType: 'string',
              
              
              editType: 'none'
          };
      }
  
      function callback(attr, attrName, attrs) {
          if(exports.isValObject(attr)) {
              if(attr.valType === 'data_array') {
                  // all 'data_array' attrs have role 'data'
                  attr.role = 'data';
                  // all 'data_array' attrs have a corresponding 'src' attr
                  attrs[attrName + 'src'] = makeSrcAttr(attrName);
              } else if(attr.arrayOk === true) {
                  // all 'arrayOk' attrs have a corresponding 'src' attr
                  attrs[attrName + 'src'] = makeSrcAttr(attrName);
              }
          } else if(isPlainObject(attr)) {
              // all attrs container objects get role 'object'
              attr.role = 'object';
          }
      }
  
      exports.crawl(attrs, callback);
  }
  
  function formatArrayContainers(attrs) {
      function callback(attr, attrName, attrs) {
          if(!attr) return;
  
          var itemName = attr[IS_LINKED_TO_ARRAY];
  
          if(!itemName) return;
  
          delete attr[IS_LINKED_TO_ARRAY];
  
          attrs[attrName] = { items: {} };
          attrs[attrName].items[itemName] = attr;
          attrs[attrName].role = 'object';
      }
  
      exports.crawl(attrs, callback);
  }
  
  // this can take around 10ms and should only be run from PlotSchema.get(),
  // to ensure JSON.stringify(PlotSchema.get()) gives the intended result.
  function stringify(attrs) {
      function walk(attr) {
          for(var k in attr) {
              if(isPlainObject(attr[k])) {
                  walk(attr[k]);
              } else if(Array.isArray(attr[k])) {
                  for(var i = 0; i < attr[k].length; i++) {
                      walk(attr[k][i]);
                  }
              } else {
                  // as JSON.stringify(/test/) // => {}
                  if(attr[k] instanceof RegExp) {
                      attr[k] = attr[k].toString();
                  }
              }
          }
      }
  
      walk(attrs);
  }
  
  function assignPolarLayoutAttrs(layoutAttributes) {
      extendFlat(layoutAttributes, {
          radialaxis: polarAxisAttrs.radialaxis,
          angularaxis: polarAxisAttrs.angularaxis
      });
  
      extendFlat(layoutAttributes, polarAxisAttrs.layout);
  
      return layoutAttributes;
  }
  
  function handleBasePlotModule(layoutAttributes, _module, astr) {
      var np = nestedProperty(layoutAttributes, astr);
      var attrs = extendDeepAll({}, _module.layoutAttributes);
  
      attrs[IS_SUBPLOT_OBJ] = true;
      np.set(attrs);
  }
  
  function insertAttrs(baseAttrs, newAttrs, astr) {
      var np = nestedProperty(baseAttrs, astr);
  
      np.set(extendDeepAll(np.get() || {}, newAttrs));
  }
  
  },{"../lib":750,"../plots/animation_attributes":793,"../plots/attributes":795,"../plots/frame_attributes":828,"../plots/layout_attributes":853,"../plots/polar/legacy/area_attributes":868,"../plots/polar/legacy/axis_attributes":869,"../registry":882,"./edit_types":781,"./plot_config":786}],788:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var plotAttributes = _dereq_('../plots/attributes');
  
  var TEMPLATEITEMNAME = 'templateitemname';
  
  var templateAttrs = {
      name: {
          valType: 'string',
          
          editType: 'none',
          
      }
  };
  templateAttrs[TEMPLATEITEMNAME] = {
      valType: 'string',
      
      editType: 'calc',
      
  };
  
  /**
   * templatedArray: decorate an attributes object with templating (and array)
   * properties.
   *
   * @param {string} name: the singular form of the array name. Sets
   *     `_isLinkedToArray` to this, so the schema knows to treat this as an array.
   * @param {object} attrs: the item attributes. Since all callers are expected
   *     to be constructing this object on the spot, we mutate it here for
   *     performance, rather than extending a new object with it.
   *
   * @returns {object}: the decorated `attrs` object
   */
  exports.templatedArray = function(name, attrs) {
      attrs._isLinkedToArray = name;
      attrs.name = templateAttrs.name;
      attrs[TEMPLATEITEMNAME] = templateAttrs[TEMPLATEITEMNAME];
      return attrs;
  };
  
  /**
   * traceTemplater: logic for matching traces to trace templates
   *
   * @param {object} dataTemplate: collection of {traceType: [{template}, ...]}
   *     ie each type the template applies to contains a list of template objects,
   *     to be provided cyclically to data traces of that type.
   *
   * @returns {object}: {newTrace}, a function:
   *     newTrace(traceIn): that takes the input traceIn, coerces its type, then
   *         uses that type to find the next template to apply. returns the output
   *         traceOut with template attached, ready to continue supplyDefaults.
   */
  exports.traceTemplater = function(dataTemplate) {
      var traceCounts = {};
      var traceType, typeTemplates;
  
      for(traceType in dataTemplate) {
          typeTemplates = dataTemplate[traceType];
          if(Array.isArray(typeTemplates) && typeTemplates.length) {
              traceCounts[traceType] = 0;
          }
      }
  
      function newTrace(traceIn) {
          traceType = Lib.coerce(traceIn, {}, plotAttributes, 'type');
          var traceOut = {type: traceType, _template: null};
          if(traceType in traceCounts) {
              typeTemplates = dataTemplate[traceType];
              // cycle through traces in the template set for this type
              var typei = traceCounts[traceType] % typeTemplates.length;
              traceCounts[traceType]++;
              traceOut._template = typeTemplates[typei];
          } else {
              // TODO: anything we should do for types missing from the template?
              // try to apply some other type? Or just bail as we do here?
              // Actually I think yes, we should apply other types; would be nice
              // if all scatter* could inherit from each other, and if histogram
              // could inherit from bar, etc... but how to specify this? And do we
              // compose them, or if a type is present require it to be complete?
              // Actually this could apply to layout too - 3D annotations
              // inheriting from 2D, axes of different types inheriting from each
              // other...
          }
          return traceOut;
      }
  
      return {
          newTrace: newTrace
          // TODO: function to figure out what's left & what didn't work
      };
  };
  
  /**
   * newContainer: Create a new sub-container inside `container` and propagate any
   * applicable template to it. If there's no template, still propagates
   * `undefined` so relinkPrivate will not retain an old template!
   *
   * @param {object} container: the outer container, should already have _template
   *     if there *is* a template for this plot
   * @param {string} name: the key of the new container to make
   * @param {string} baseName: if applicable, a base attribute to take the
   *     template from, ie for xaxis3 the base would be xaxis
   *
   * @returns {object}: an object for inclusion _full*, empty except for the
   *     appropriate template piece
   */
  exports.newContainer = function(container, name, baseName) {
      var template = container._template;
      var part = template && (template[name] || (baseName && template[baseName]));
      if(!Lib.isPlainObject(part)) part = null;
  
      var out = container[name] = {_template: part};
      return out;
  };
  
  /**
   * arrayTemplater: special logic for templating both defaults and specific items
   * in a container array (annotations etc)
   *
   * @param {object} container: the outer container, should already have _template
   *     if there *is* a template for this plot
   * @param {string} name: the name of the array to template (ie 'annotations')
   *     will be used to find default ('annotationdefaults' object) and specific
   *     ('annotations' array) template specs.
   * @param {string} inclusionAttr: the attribute determining this item's
   *     inclusion in the output, usually 'visible' or 'enabled'
   *
   * @returns {object}: {newItem, defaultItems}, both functions:
   *     newItem(itemIn): create an output item, bare except for the correct
   *         template and name(s), as the base for supplyDefaults
   *     defaultItems(): to be called after all newItem calls, return any
   *         specific template items that have not already beeen included,
   *         also as bare output items ready for supplyDefaults.
   */
  exports.arrayTemplater = function(container, name, inclusionAttr) {
      var template = container._template;
      var defaultsTemplate = template && template[arrayDefaultKey(name)];
      var templateItems = template && template[name];
      if(!Array.isArray(templateItems) || !templateItems.length) {
          templateItems = [];
      }
  
      var usedNames = {};
  
      function newItem(itemIn) {
          // include name and templateitemname in the output object for ALL
          // container array items. Note: you could potentially use different
          // name and templateitemname, if you're using one template to make
          // another template. templateitemname would be the name in the original
          // template, and name is the new "subclassed" item name.
          var out = {name: itemIn.name, _input: itemIn};
          var templateItemName = out[TEMPLATEITEMNAME] = itemIn[TEMPLATEITEMNAME];
  
          // no itemname: use the default template
          if(!validItemName(templateItemName)) {
              out._template = defaultsTemplate;
              return out;
          }
  
          // look for an item matching this itemname
          // note these do not inherit from the default template, only the item.
          for(var i = 0; i < templateItems.length; i++) {
              var templateItem = templateItems[i];
              if(templateItem.name === templateItemName) {
                  // Note: it's OK to use a template item more than once
                  // but using it at least once will stop it from generating
                  // a default item at the end.
                  usedNames[templateItemName] = 1;
                  out._template = templateItem;
                  return out;
              }
          }
  
          // Didn't find a matching template item, so since this item is intended
          // to only be modifications it's most likely broken. Hide it unless
          // it's explicitly marked visible - in which case it gets NO template,
          // not even the default.
          out[inclusionAttr] = itemIn[inclusionAttr] || false;
          // special falsy value we can look for in validateTemplate
          out._template = false;
          return out;
      }
  
      function defaultItems() {
          var out = [];
          for(var i = 0; i < templateItems.length; i++) {
              var templateItem = templateItems[i];
              var name = templateItem.name;
              // only allow named items to be added as defaults,
              // and only allow each name once
              if(validItemName(name) && !usedNames[name]) {
                  var outi = {
                      _template: templateItem,
                      name: name,
                      _input: {_templateitemname: name}
                  };
                  outi[TEMPLATEITEMNAME] = templateItem[TEMPLATEITEMNAME];
                  out.push(outi);
                  usedNames[name] = 1;
              }
          }
          return out;
      }
  
      return {
          newItem: newItem,
          defaultItems: defaultItems
      };
  };
  
  function validItemName(name) {
      return name && typeof name === 'string';
  }
  
  function arrayDefaultKey(name) {
      var lastChar = name.length - 1;
      if(name.charAt(lastChar) !== 's') {
          Lib.warn('bad argument to arrayDefaultKey: ' + name);
      }
      return name.substr(0, name.length - 1) + 'defaults';
  }
  exports.arrayDefaultKey = arrayDefaultKey;
  
  /**
   * arrayEditor: helper for editing array items that may have come from
   *     template defaults (in which case they will not exist in the input yet)
   *
   * @param {object} parentIn: the input container (eg gd.layout)
   * @param {string} containerStr: the attribute string for the container inside
   *     `parentIn`.
   * @param {object} itemOut: the _full* item (eg gd._fullLayout.annotations[0])
   *     that we'll be editing. Assumed to have been created by `arrayTemplater`.
   *
   * @returns {object}: {modifyBase, modifyItem, getUpdateObj, applyUpdate}, all functions:
   *     modifyBase(attr, value): Add an update that's *not* related to the item.
   *         `attr` is the full attribute string.
   *     modifyItem(attr, value): Add an update to the item. `attr` is just the
   *         portion of the attribute string inside the item.
   *     getUpdateObj(): Get the final constructed update object, to use in
   *         `restyle` or `relayout`. Also resets the update object in case this
   *         update was canceled.
   *     applyUpdate(attr, value): optionally add an update `attr: value`,
   *         then apply it to `parent` which should be the parent of `containerIn`,
   *         ie the object to which `containerStr` is the attribute string.
   */
  exports.arrayEditor = function(parentIn, containerStr, itemOut) {
      var lengthIn = (Lib.nestedProperty(parentIn, containerStr).get() || []).length;
      var index = itemOut._index;
      // Check that we are indeed off the end of this container.
      // Otherwise a devious user could put a key `_templateitemname` in their
      // own input and break lots of things.
      var templateItemName = (index >= lengthIn) && (itemOut._input || {})._templateitemname;
      if(templateItemName) index = lengthIn;
      var itemStr = containerStr + '[' + index + ']';
  
      var update;
      function resetUpdate() {
          update = {};
          if(templateItemName) {
              update[itemStr] = {};
              update[itemStr][TEMPLATEITEMNAME] = templateItemName;
          }
      }
      resetUpdate();
  
      function modifyBase(attr, value) {
          update[attr] = value;
      }
  
      function modifyItem(attr, value) {
          if(templateItemName) {
              // we're making a new object: edit that object
              Lib.nestedProperty(update[itemStr], attr).set(value);
          } else {
              // we're editing an existing object: include *just* the edit
              update[itemStr + '.' + attr] = value;
          }
      }
  
      function getUpdateObj() {
          var updateOut = update;
          resetUpdate();
          return updateOut;
      }
  
      function applyUpdate(attr, value) {
          if(attr) modifyItem(attr, value);
          var updateToApply = getUpdateObj();
          for(var key in updateToApply) {
              Lib.nestedProperty(parentIn, key).set(updateToApply[key]);
          }
      }
  
      return {
          modifyBase: modifyBase,
          modifyItem: modifyItem,
          getUpdateObj: getUpdateObj,
          applyUpdate: applyUpdate
      };
  };
  
  },{"../lib":750,"../plots/attributes":795}],789:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Registry = _dereq_('../registry');
  var Plots = _dereq_('../plots/plots');
  
  var Lib = _dereq_('../lib');
  var clearGlCanvases = _dereq_('../lib/clear_gl_canvases');
  
  var Color = _dereq_('../components/color');
  var Drawing = _dereq_('../components/drawing');
  var Titles = _dereq_('../components/titles');
  var ModeBar = _dereq_('../components/modebar');
  
  var Axes = _dereq_('../plots/cartesian/axes');
  var alignmentConstants = _dereq_('../constants/alignment');
  var axisConstraints = _dereq_('../plots/cartesian/constraints');
  var enforceAxisConstraints = axisConstraints.enforce;
  var cleanAxisConstraints = axisConstraints.clean;
  var doAutoRange = _dereq_('../plots/cartesian/autorange').doAutoRange;
  
  var SVG_TEXT_ANCHOR_START = 'start';
  var SVG_TEXT_ANCHOR_MIDDLE = 'middle';
  var SVG_TEXT_ANCHOR_END = 'end';
  
  exports.layoutStyles = function(gd) {
      return Lib.syncOrAsync([Plots.doAutoMargin, lsInner], gd);
  };
  
  function overlappingDomain(xDomain, yDomain, domains) {
      for(var i = 0; i < domains.length; i++) {
          var existingX = domains[i][0];
          var existingY = domains[i][1];
  
          if(existingX[0] >= xDomain[1] || existingX[1] <= xDomain[0]) {
              continue;
          }
          if(existingY[0] < yDomain[1] && existingY[1] > yDomain[0]) {
              return true;
          }
      }
      return false;
  }
  
  function lsInner(gd) {
      var fullLayout = gd._fullLayout;
      var gs = fullLayout._size;
      var pad = gs.p;
      var axList = Axes.list(gd, '', true);
      var i, subplot, plotinfo, ax, xa, ya;
  
      fullLayout._paperdiv.style({
          width: (gd._context.responsive && fullLayout.autosize && !gd._context._hasZeroWidth && !gd.layout.width) ? '100%' : fullLayout.width + 'px',
          height: (gd._context.responsive && fullLayout.autosize && !gd._context._hasZeroHeight && !gd.layout.height) ? '100%' : fullLayout.height + 'px'
      })
      .selectAll('.main-svg')
      .call(Drawing.setSize, fullLayout.width, fullLayout.height);
      gd._context.setBackground(gd, fullLayout.paper_bgcolor);
  
      exports.drawMainTitle(gd);
      ModeBar.manage(gd);
  
      // _has('cartesian') means SVG specifically, not GL2D - but GL2D
      // can still get here because it makes some of the SVG structure
      // for shared features like selections.
      if(!fullLayout._has('cartesian')) {
          return Plots.previousPromises(gd);
      }
  
      function getLinePosition(ax, counterAx, side) {
          var lwHalf = ax._lw / 2;
  
          if(ax._id.charAt(0) === 'x') {
              if(!counterAx) return gs.t + gs.h * (1 - (ax.position || 0)) + (lwHalf % 1);
              else if(side === 'top') return counterAx._offset - pad - lwHalf;
              return counterAx._offset + counterAx._length + pad + lwHalf;
          }
  
          if(!counterAx) return gs.l + gs.w * (ax.position || 0) + (lwHalf % 1);
          else if(side === 'right') return counterAx._offset + counterAx._length + pad + lwHalf;
          return counterAx._offset - pad - lwHalf;
      }
  
      // some preparation of axis position info
      for(i = 0; i < axList.length; i++) {
          ax = axList[i];
  
          var counterAx = ax._anchorAxis;
  
          // clear axis line positions, to be set in the subplot loop below
          ax._linepositions = {};
  
          // stash crispRounded linewidth so we don't need to pass gd all over the place
          ax._lw = Drawing.crispRound(gd, ax.linewidth, 1);
  
          // figure out the main axis line and main mirror line position.
          // it's easier to follow the logic if we handle these separately from
          // ax._linepositions, which are only used by mirror=allticks
          // for non-main-subplot ticks, and mirror=all(ticks)? for zero line
          // hiding logic
          ax._mainLinePosition = getLinePosition(ax, counterAx, ax.side);
          ax._mainMirrorPosition = (ax.mirror && counterAx) ?
              getLinePosition(ax, counterAx,
                  alignmentConstants.OPPOSITE_SIDE[ax.side]) : null;
      }
  
      // figure out which backgrounds we need to draw,
      // and in which layers to put them
      var lowerBackgroundIDs = [];
      var backgroundIds = [];
      var lowerDomains = [];
      // no need to draw background when paper and plot color are the same color,
      // activate mode just for large splom (which benefit the most from this
      // optimization), but this could apply to all cartesian subplots.
      var noNeedForBg = (
          Color.opacity(fullLayout.paper_bgcolor) === 1 &&
          Color.opacity(fullLayout.plot_bgcolor) === 1 &&
          fullLayout.paper_bgcolor === fullLayout.plot_bgcolor
      );
  
      for(subplot in fullLayout._plots) {
          plotinfo = fullLayout._plots[subplot];
  
          if(plotinfo.mainplot) {
              // mainplot is a reference to the main plot this one is overlaid on
              // so if it exists, this is an overlaid plot and we don't need to
              // give it its own background
              if(plotinfo.bg) {
                  plotinfo.bg.remove();
              }
              plotinfo.bg = undefined;
          } else {
              var xDomain = plotinfo.xaxis.domain;
              var yDomain = plotinfo.yaxis.domain;
              var plotgroup = plotinfo.plotgroup;
  
              if(overlappingDomain(xDomain, yDomain, lowerDomains)) {
                  var pgNode = plotgroup.node();
                  var plotgroupBg = plotinfo.bg = Lib.ensureSingle(plotgroup, 'rect', 'bg');
                  pgNode.insertBefore(plotgroupBg.node(), pgNode.childNodes[0]);
                  backgroundIds.push(subplot);
              } else {
                  plotgroup.select('rect.bg').remove();
                  lowerDomains.push([xDomain, yDomain]);
                  if(!noNeedForBg) {
                      lowerBackgroundIDs.push(subplot);
                      backgroundIds.push(subplot);
                  }
              }
          }
      }
  
      // now create all the lower-layer backgrounds at once now that
      // we have the list of subplots that need them
      var lowerBackgrounds = fullLayout._bgLayer.selectAll('.bg')
          .data(lowerBackgroundIDs);
  
      lowerBackgrounds.enter().append('rect')
          .classed('bg', true);
  
      lowerBackgrounds.exit().remove();
  
      lowerBackgrounds.each(function(subplot) {
          fullLayout._plots[subplot].bg = d3.select(this);
      });
  
      // style all backgrounds
      for(i = 0; i < backgroundIds.length; i++) {
          plotinfo = fullLayout._plots[backgroundIds[i]];
          xa = plotinfo.xaxis;
          ya = plotinfo.yaxis;
  
          if(plotinfo.bg) {
              plotinfo.bg
                  .call(Drawing.setRect,
                      xa._offset - pad, ya._offset - pad,
                      xa._length + 2 * pad, ya._length + 2 * pad)
                  .call(Color.fill, fullLayout.plot_bgcolor)
                  .style('stroke-width', 0);
          }
      }
  
      if(!fullLayout._hasOnlyLargeSploms) {
          for(subplot in fullLayout._plots) {
              plotinfo = fullLayout._plots[subplot];
              xa = plotinfo.xaxis;
              ya = plotinfo.yaxis;
  
              // Clip so that data only shows up on the plot area.
              var clipId = plotinfo.clipId = 'clip' + fullLayout._uid + subplot + 'plot';
  
              var plotClip = Lib.ensureSingleById(fullLayout._clips, 'clipPath', clipId, function(s) {
                  s.classed('plotclip', true)
                      .append('rect');
              });
  
              plotinfo.clipRect = plotClip.select('rect').attr({
                  width: xa._length,
                  height: ya._length
              });
  
              Drawing.setTranslate(plotinfo.plot, xa._offset, ya._offset);
  
              var plotClipId;
              var layerClipId;
  
              if(plotinfo._hasClipOnAxisFalse) {
                  plotClipId = null;
                  layerClipId = clipId;
              } else {
                  plotClipId = clipId;
                  layerClipId = null;
              }
  
              Drawing.setClipUrl(plotinfo.plot, plotClipId, gd);
  
              // stash layer clipId value (null or same as clipId)
              // to DRY up Drawing.setClipUrl calls on trace-module and trace layers
              // downstream
              plotinfo.layerClipId = layerClipId;
          }
      }
  
      var xLinesXLeft, xLinesXRight, xLinesYBottom, xLinesYTop,
          leftYLineWidth, rightYLineWidth;
      var yLinesYBottom, yLinesYTop, yLinesXLeft, yLinesXRight,
          connectYBottom, connectYTop;
      var extraSubplot;
  
      function xLinePath(y) {
          return 'M' + xLinesXLeft + ',' + y + 'H' + xLinesXRight;
      }
  
      function xLinePathFree(y) {
          return 'M' + xa._offset + ',' + y + 'h' + xa._length;
      }
  
      function yLinePath(x) {
          return 'M' + x + ',' + yLinesYTop + 'V' + yLinesYBottom;
      }
  
      function yLinePathFree(x) {
          return 'M' + x + ',' + ya._offset + 'v' + ya._length;
      }
  
      function mainPath(ax, pathFn, pathFnFree) {
          if(!ax.showline || subplot !== ax._mainSubplot) return '';
          if(!ax._anchorAxis) return pathFnFree(ax._mainLinePosition);
          var out = pathFn(ax._mainLinePosition);
          if(ax.mirror) out += pathFn(ax._mainMirrorPosition);
          return out;
      }
  
      for(subplot in fullLayout._plots) {
          plotinfo = fullLayout._plots[subplot];
          xa = plotinfo.xaxis;
          ya = plotinfo.yaxis;
  
          /*
           * x lines get longer where they meet y lines, to make a crisp corner.
           * The x lines get the padding (margin.pad) plus the y line width to
           * fill up the corner nicely. Free x lines are excluded - they always
           * span exactly the data area of the plot
           *
           *  | XXXXX
           *  | XXXXX
           *  |
           *  +------
           *     x1
           *    -----
           *     x2
           */
          var xPath = 'M0,0';
          if(shouldShowLinesOrTicks(xa, subplot)) {
              leftYLineWidth = findCounterAxisLineWidth(xa, 'left', ya, axList);
              xLinesXLeft = xa._offset - (leftYLineWidth ? (pad + leftYLineWidth) : 0);
              rightYLineWidth = findCounterAxisLineWidth(xa, 'right', ya, axList);
              xLinesXRight = xa._offset + xa._length + (rightYLineWidth ? (pad + rightYLineWidth) : 0);
              xLinesYBottom = getLinePosition(xa, ya, 'bottom');
              xLinesYTop = getLinePosition(xa, ya, 'top');
  
              // save axis line positions for extra ticks to reference
              // each subplot that gets ticks from "allticks" gets an entry:
              //    [left or bottom, right or top]
              extraSubplot = (!xa._anchorAxis || subplot !== xa._mainSubplot);
              if(extraSubplot && (xa.mirror === 'allticks' || xa.mirror === 'all')) {
                  xa._linepositions[subplot] = [xLinesYBottom, xLinesYTop];
              }
  
              xPath = mainPath(xa, xLinePath, xLinePathFree);
              if(extraSubplot && xa.showline && (xa.mirror === 'all' || xa.mirror === 'allticks')) {
                  xPath += xLinePath(xLinesYBottom) + xLinePath(xLinesYTop);
              }
  
              plotinfo.xlines
                  .style('stroke-width', xa._lw + 'px')
                  .call(Color.stroke, xa.showline ?
                      xa.linecolor : 'rgba(0,0,0,0)');
          }
          plotinfo.xlines.attr('d', xPath);
  
          /*
           * y lines that meet x axes get longer only by margin.pad, because
           * the x axes fill in the corner space. Free y axes, like free x axes,
           * always span exactly the data area of the plot
           *
           *   |   | XXXX
           * y2| y1| XXXX
           *   |   | XXXX
           *       |
           *       +-----
           */
          var yPath = 'M0,0';
          if(shouldShowLinesOrTicks(ya, subplot)) {
              connectYBottom = findCounterAxisLineWidth(ya, 'bottom', xa, axList);
              yLinesYBottom = ya._offset + ya._length + (connectYBottom ? pad : 0);
              connectYTop = findCounterAxisLineWidth(ya, 'top', xa, axList);
              yLinesYTop = ya._offset - (connectYTop ? pad : 0);
              yLinesXLeft = getLinePosition(ya, xa, 'left');
              yLinesXRight = getLinePosition(ya, xa, 'right');
  
              extraSubplot = (!ya._anchorAxis || subplot !== ya._mainSubplot);
              if(extraSubplot && (ya.mirror === 'allticks' || ya.mirror === 'all')) {
                  ya._linepositions[subplot] = [yLinesXLeft, yLinesXRight];
              }
  
              yPath = mainPath(ya, yLinePath, yLinePathFree);
              if(extraSubplot && ya.showline && (ya.mirror === 'all' || ya.mirror === 'allticks')) {
                  yPath += yLinePath(yLinesXLeft) + yLinePath(yLinesXRight);
              }
  
              plotinfo.ylines
                  .style('stroke-width', ya._lw + 'px')
                  .call(Color.stroke, ya.showline ?
                      ya.linecolor : 'rgba(0,0,0,0)');
          }
          plotinfo.ylines.attr('d', yPath);
      }
  
      Axes.makeClipPaths(gd);
  
      return Plots.previousPromises(gd);
  }
  
  function shouldShowLinesOrTicks(ax, subplot) {
      return (ax.ticks || ax.showline) &&
          (subplot === ax._mainSubplot || ax.mirror === 'all' || ax.mirror === 'allticks');
  }
  
  /*
   * should we draw a line on counterAx at this side of ax?
   * It's assumed that counterAx is known to overlay the subplot we're working on
   * but it may not be its main axis.
   */
  function shouldShowLineThisSide(ax, side, counterAx) {
      // does counterAx get a line at all?
      if(!counterAx.showline || !counterAx._lw) return false;
  
      // are we drawing *all* lines for counterAx?
      if(counterAx.mirror === 'all' || counterAx.mirror === 'allticks') return true;
  
      var anchorAx = counterAx._anchorAxis;
  
      // is this a free axis? free axes can only have a subplot side-line with all(ticks)? mirroring
      if(!anchorAx) return false;
  
      // in order to handle cases where the user forgot to anchor this axis correctly
      // (because its default anchor has the same domain on the relevant end)
      // check whether the relevant position is the same.
      var sideIndex = alignmentConstants.FROM_BL[side];
      if(counterAx.side === side) {
          return anchorAx.domain[sideIndex] === ax.domain[sideIndex];
      }
      return counterAx.mirror && anchorAx.domain[1 - sideIndex] === ax.domain[1 - sideIndex];
  }
  
  /*
   * Is there another axis intersecting `side` end of `ax`?
   * First look at `counterAx` (the axis for this subplot),
   * then at all other potential counteraxes on or overlaying this subplot.
   * Take the line width from the first one that has a line.
   */
  function findCounterAxisLineWidth(ax, side, counterAx, axList) {
      if(shouldShowLineThisSide(ax, side, counterAx)) {
          return counterAx._lw;
      }
      for(var i = 0; i < axList.length; i++) {
          var axi = axList[i];
          if(axi._mainAxis === counterAx._mainAxis && shouldShowLineThisSide(ax, side, axi)) {
              return axi._lw;
          }
      }
      return 0;
  }
  
  exports.drawMainTitle = function(gd) {
      var fullLayout = gd._fullLayout;
  
      var textAnchor = getMainTitleTextAnchor(fullLayout);
      var dy = getMainTitleDy(fullLayout);
  
      Titles.draw(gd, 'gtitle', {
          propContainer: fullLayout,
          propName: 'title.text',
          placeholder: fullLayout._dfltTitle.plot,
          attributes: {
              x: getMainTitleX(fullLayout, textAnchor),
              y: getMainTitleY(fullLayout, dy),
              'text-anchor': textAnchor,
              dy: dy
          }
      });
  };
  
  function getMainTitleX(fullLayout, textAnchor) {
      var title = fullLayout.title;
      var gs = fullLayout._size;
      var hPadShift = 0;
  
      if(textAnchor === SVG_TEXT_ANCHOR_START) {
          hPadShift = title.pad.l;
      } else if(textAnchor === SVG_TEXT_ANCHOR_END) {
          hPadShift = -title.pad.r;
      }
  
      switch(title.xref) {
          case 'paper':
              return gs.l + gs.w * title.x + hPadShift;
          case 'container':
          default:
              return fullLayout.width * title.x + hPadShift;
      }
  }
  
  function getMainTitleY(fullLayout, dy) {
      var title = fullLayout.title;
      var gs = fullLayout._size;
      var vPadShift = 0;
  
      if(dy === '0em' || !dy) {
          vPadShift = -title.pad.b;
      } else if(dy === alignmentConstants.CAP_SHIFT + 'em') {
          vPadShift = title.pad.t;
      }
  
      if(title.y === 'auto') {
          return gs.t / 2;
      } else {
          switch(title.yref) {
              case 'paper':
                  return gs.t + gs.h - gs.h * title.y + vPadShift;
              case 'container':
              default:
                  return fullLayout.height - fullLayout.height * title.y + vPadShift;
          }
      }
  }
  
  function getMainTitleTextAnchor(fullLayout) {
      var title = fullLayout.title;
  
      var textAnchor = SVG_TEXT_ANCHOR_MIDDLE;
      if(Lib.isRightAnchor(title)) {
          textAnchor = SVG_TEXT_ANCHOR_END;
      } else if(Lib.isLeftAnchor(title)) {
          textAnchor = SVG_TEXT_ANCHOR_START;
      }
  
      return textAnchor;
  }
  
  function getMainTitleDy(fullLayout) {
      var title = fullLayout.title;
  
      var dy = '0em';
      if(Lib.isTopAnchor(title)) {
          dy = alignmentConstants.CAP_SHIFT + 'em';
      } else if(Lib.isMiddleAnchor(title)) {
          dy = alignmentConstants.MID_SHIFT + 'em';
      }
  
      return dy;
  }
  
  exports.doTraceStyle = function(gd) {
      var calcdata = gd.calcdata;
      var editStyleCalls = [];
      var i;
  
      for(i = 0; i < calcdata.length; i++) {
          var cd = calcdata[i];
          var cd0 = cd[0] || {};
          var trace = cd0.trace || {};
          var _module = trace._module || {};
  
          // See if we need to do arraysToCalcdata
          // call it regardless of what change we made, in case
          // supplyDefaults brought in an array that was already
          // in gd.data but not in gd._fullData previously
          var arraysToCalcdata = _module.arraysToCalcdata;
          if(arraysToCalcdata) arraysToCalcdata(cd, trace);
  
          var editStyle = _module.editStyle;
          if(editStyle) editStyleCalls.push({fn: editStyle, cd0: cd0});
      }
  
      if(editStyleCalls.length) {
          for(i = 0; i < editStyleCalls.length; i++) {
              var edit = editStyleCalls[i];
              edit.fn(gd, edit.cd0);
          }
          clearGlCanvases(gd);
          exports.redrawReglTraces(gd);
      }
  
      Plots.style(gd);
      Registry.getComponentMethod('legend', 'draw')(gd);
  
      return Plots.previousPromises(gd);
  };
  
  exports.doColorBars = function(gd) {
      Registry.getComponentMethod('colorbar', 'draw')(gd);
      return Plots.previousPromises(gd);
  };
  
  // force plot() to redo the layout and replot with the modified layout
  exports.layoutReplot = function(gd) {
      var layout = gd.layout;
      gd.layout = undefined;
      return Registry.call('plot', gd, '', layout);
  };
  
  exports.doLegend = function(gd) {
      Registry.getComponentMethod('legend', 'draw')(gd);
      return Plots.previousPromises(gd);
  };
  
  exports.doTicksRelayout = function(gd) {
      Axes.draw(gd, 'redraw');
  
      if(gd._fullLayout._hasOnlyLargeSploms) {
          Registry.subplotsRegistry.splom.updateGrid(gd);
          clearGlCanvases(gd);
          exports.redrawReglTraces(gd);
      }
  
      exports.drawMainTitle(gd);
      return Plots.previousPromises(gd);
  };
  
  exports.doModeBar = function(gd) {
      var fullLayout = gd._fullLayout;
  
      ModeBar.manage(gd);
  
      for(var i = 0; i < fullLayout._basePlotModules.length; i++) {
          var updateFx = fullLayout._basePlotModules[i].updateFx;
          if(updateFx) updateFx(gd);
      }
  
      return Plots.previousPromises(gd);
  };
  
  exports.doCamera = function(gd) {
      var fullLayout = gd._fullLayout;
      var sceneIds = fullLayout._subplots.gl3d;
  
      for(var i = 0; i < sceneIds.length; i++) {
          var sceneLayout = fullLayout[sceneIds[i]];
          var scene = sceneLayout._scene;
  
          scene.setViewport(sceneLayout);
      }
  };
  
  exports.drawData = function(gd) {
      var fullLayout = gd._fullLayout;
  
      clearGlCanvases(gd);
  
      // loop over the base plot modules present on graph
      var basePlotModules = fullLayout._basePlotModules;
      for(var i = 0; i < basePlotModules.length; i++) {
          basePlotModules[i].plot(gd);
      }
  
      exports.redrawReglTraces(gd);
  
      // styling separate from drawing
      Plots.style(gd);
  
      // draw components that can be drawn on axes,
      // and that do not push the margins
      Registry.getComponentMethod('shapes', 'draw')(gd);
      Registry.getComponentMethod('annotations', 'draw')(gd);
      Registry.getComponentMethod('images', 'draw')(gd);
  
      // Mark the first render as complete
      fullLayout._replotting = false;
  
      return Plots.previousPromises(gd);
  };
  
  // Draw (or redraw) all regl-based traces in one go,
  // useful during drag and selection where buffers of targeted traces are updated,
  // but all traces need to be redrawn following clearGlCanvases.
  //
  // Note that _module.plot for regl trace does NOT draw things
  // on the canvas, they only update the buffers.
  // Drawing is perform here.
  //
  // TODO try adding per-subplot option using gl.SCISSOR_TEST for
  // non-overlaying, disjoint subplots.
  //
  // TODO try to include parcoords in here.
  // https://github.com/plotly/plotly.js/issues/3069
  exports.redrawReglTraces = function(gd) {
      var fullLayout = gd._fullLayout;
  
      if(fullLayout._has('regl')) {
          var fullData = gd._fullData;
          var cartesianIds = [];
          var polarIds = [];
          var i, sp;
  
          if(fullLayout._hasOnlyLargeSploms) {
              fullLayout._splomGrid.draw();
          }
  
          // N.B.
          // - Loop over fullData (not _splomScenes) to preserve splom trace-to-trace ordering
          // - Fill list if subplot ids (instead of fullLayout._subplots) to handle cases where all traces
          //   of a given module are `visible !== true`
          for(i = 0; i < fullData.length; i++) {
              var trace = fullData[i];
  
              if(trace.visible === true && trace._length !== 0) {
                  if(trace.type === 'splom') {
                      fullLayout._splomScenes[trace.uid].draw();
                  } else if(trace.type === 'scattergl') {
                      Lib.pushUnique(cartesianIds, trace.xaxis + trace.yaxis);
                  } else if(trace.type === 'scatterpolargl') {
                      Lib.pushUnique(polarIds, trace.subplot);
                  }
              }
          }
  
          for(i = 0; i < cartesianIds.length; i++) {
              sp = fullLayout._plots[cartesianIds[i]];
              if(sp._scene) sp._scene.draw();
          }
  
          for(i = 0; i < polarIds.length; i++) {
              sp = fullLayout[polarIds[i]]._subplot;
              if(sp._scene) sp._scene.draw();
          }
      }
  };
  
  exports.doAutoRangeAndConstraints = function(gd) {
      var fullLayout = gd._fullLayout;
      var axList = Axes.list(gd, '', true);
      var matchGroups = fullLayout._axisMatchGroups || [];
      var axLookup = {};
      var ax;
      var axRng;
  
      for(var i = 0; i < axList.length; i++) {
          ax = axList[i];
          cleanAxisConstraints(gd, ax);
          doAutoRange(gd, ax);
          axLookup[ax._id] = 1;
      }
  
      enforceAxisConstraints(gd);
  
      groupLoop:
      for(var j = 0; j < matchGroups.length; j++) {
          var group = matchGroups[j];
          var rng = null;
          var id;
  
          for(id in group) {
              ax = Axes.getFromId(gd, id);
  
              // skip over 'missing' axes which do not pass through doAutoRange
              if(!axLookup[ax._id]) continue;
              // if one axis has autorange false, we're done
              if(ax.autorange === false) continue groupLoop;
  
              axRng = Lib.simpleMap(ax.range, ax.r2l);
              if(rng) {
                  if(rng[0] < rng[1]) {
                      rng[0] = Math.min(rng[0], axRng[0]);
                      rng[1] = Math.max(rng[1], axRng[1]);
                  } else {
                      rng[0] = Math.max(rng[0], axRng[0]);
                      rng[1] = Math.min(rng[1], axRng[1]);
                  }
              } else {
                  rng = axRng;
              }
          }
  
          for(id in group) {
              ax = Axes.getFromId(gd, id);
              ax.range = Lib.simpleMap(rng, ax.l2r);
              ax._input.range = ax.range.slice();
              ax.setScale();
          }
      }
  };
  
  // An initial paint must be completed before these components can be
  // correctly sized and the whole plot re-margined. fullLayout._replotting must
  // be set to false before these will work properly.
  exports.finalDraw = function(gd) {
      // TODO: rangesliders really belong in marginPushers but they need to be
      // drawn after data - can we at least get the margin pushing part separated
      // out and done earlier?
      Registry.getComponentMethod('rangeslider', 'draw')(gd);
      // TODO: rangeselector only needs to be here (in addition to drawMarginPushers)
      // because the margins need to be fully determined before we can call
      // autorange and update axis ranges (which rangeselector needs to know which
      // button is active). Can we break out its automargin step from its draw step?
      Registry.getComponentMethod('rangeselector', 'draw')(gd);
  };
  
  exports.drawMarginPushers = function(gd) {
      Registry.getComponentMethod('legend', 'draw')(gd);
      Registry.getComponentMethod('rangeselector', 'draw')(gd);
      Registry.getComponentMethod('sliders', 'draw')(gd);
      Registry.getComponentMethod('updatemenus', 'draw')(gd);
      Registry.getComponentMethod('colorbar', 'draw')(gd);
  };
  
  },{"../components/color":615,"../components/drawing":637,"../components/modebar":675,"../components/titles":710,"../constants/alignment":717,"../lib":750,"../lib/clear_gl_canvases":734,"../plots/cartesian/autorange":798,"../plots/cartesian/axes":799,"../plots/cartesian/constraints":806,"../plots/plots":862,"../registry":882,"d3":169}],790:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var isPlainObject = Lib.isPlainObject;
  var PlotSchema = _dereq_('./plot_schema');
  var Plots = _dereq_('../plots/plots');
  var plotAttributes = _dereq_('../plots/attributes');
  var Template = _dereq_('./plot_template');
  var dfltConfig = _dereq_('./plot_config').dfltConfig;
  
  /**
   * Plotly.makeTemplate: create a template off an existing figure to reuse
   * style attributes on other figures.
   *
   * Note: separated from the rest of templates because otherwise we get circular
   * references due to PlotSchema.
   *
   * @param {object|DOM element|string} figure: The figure to base the template on
   *     should contain a trace array `figure.data`
   *     and a layout object `figure.layout`
   * @returns {object} template: the extracted template - can then be used as
   *     `layout.template` in another figure.
   */
  exports.makeTemplate = function(figure) {
      figure = Lib.isPlainObject(figure) ? figure : Lib.getGraphDiv(figure);
      figure = Lib.extendDeep({_context: dfltConfig}, {data: figure.data, layout: figure.layout});
      Plots.supplyDefaults(figure);
      var data = figure.data || [];
      var layout = figure.layout || {};
      // copy over a few items to help follow the schema
      layout._basePlotModules = figure._fullLayout._basePlotModules;
      layout._modules = figure._fullLayout._modules;
  
      var template = {
          data: {},
          layout: {}
      };
  
      /*
       * Note: we do NOT validate template values, we just take what's in the
       * user inputs data and layout, not the validated values in fullData and
       * fullLayout. Even if we were to validate here, there's no guarantee that
       * these values would still be valid when applied to a new figure, which
       * may contain different trace modes, different axes, etc. So it's
       * important that when applying a template we still validate the template
       * values, rather than just using them as defaults.
       */
  
      data.forEach(function(trace) {
          // TODO: What if no style info is extracted for this trace. We may
          // not want an empty object as the null value.
          // TODO: allow transforms to contribute to templates?
          // as it stands they are ignored, which may be for the best...
  
          var traceTemplate = {};
          walkStyleKeys(trace, traceTemplate, getTraceInfo.bind(null, trace));
  
          var traceType = Lib.coerce(trace, {}, plotAttributes, 'type');
          var typeTemplates = template.data[traceType];
          if(!typeTemplates) typeTemplates = template.data[traceType] = [];
          typeTemplates.push(traceTemplate);
      });
  
      walkStyleKeys(layout, template.layout, getLayoutInfo.bind(null, layout));
  
      /*
       * Compose the new template with an existing one to the same effect
       *
       * NOTE: there's a possibility of slightly different behavior: if the plot
       * has an invalid value and the old template has a valid value for the same
       * attribute, the plot will use the old template value but this routine
       * will pull the invalid value (resulting in the original default).
       * In the general case it's not possible to solve this with a single value,
       * since valid options can be context-dependent. It could be solved with
       * a *list* of values, but that would be huge complexity for little gain.
       */
      delete template.layout.template;
      var oldTemplate = layout.template;
      if(isPlainObject(oldTemplate)) {
          var oldLayoutTemplate = oldTemplate.layout;
  
          var i, traceType, oldTypeTemplates, oldTypeLen, typeTemplates, typeLen;
  
          if(isPlainObject(oldLayoutTemplate)) {
              mergeTemplates(oldLayoutTemplate, template.layout);
          }
          var oldDataTemplate = oldTemplate.data;
          if(isPlainObject(oldDataTemplate)) {
              for(traceType in template.data) {
                  oldTypeTemplates = oldDataTemplate[traceType];
                  if(Array.isArray(oldTypeTemplates)) {
                      typeTemplates = template.data[traceType];
                      typeLen = typeTemplates.length;
                      oldTypeLen = oldTypeTemplates.length;
                      for(i = 0; i < typeLen; i++) {
                          mergeTemplates(oldTypeTemplates[i % oldTypeLen], typeTemplates[i]);
                      }
                      for(i = typeLen; i < oldTypeLen; i++) {
                          typeTemplates.push(Lib.extendDeep({}, oldTypeTemplates[i]));
                      }
                  }
              }
              for(traceType in oldDataTemplate) {
                  if(!(traceType in template.data)) {
                      template.data[traceType] = Lib.extendDeep([], oldDataTemplate[traceType]);
                  }
              }
          }
      }
  
      return template;
  };
  
  function mergeTemplates(oldTemplate, newTemplate) {
      // we don't care about speed here, just make sure we have a totally
      // distinct object from the previous template
      oldTemplate = Lib.extendDeep({}, oldTemplate);
  
      // sort keys so we always get annotationdefaults before annotations etc
      // so arrayTemplater will work right
      var oldKeys = Object.keys(oldTemplate).sort();
      var i, j;
  
      function mergeOne(oldVal, newVal, key) {
          if(isPlainObject(newVal) && isPlainObject(oldVal)) {
              mergeTemplates(oldVal, newVal);
          } else if(Array.isArray(newVal) && Array.isArray(oldVal)) {
              // Note: omitted `inclusionAttr` from arrayTemplater here,
              // it's irrelevant as we only want the resulting `_template`.
              var templater = Template.arrayTemplater({_template: oldTemplate}, key);
              for(j = 0; j < newVal.length; j++) {
                  var item = newVal[j];
                  var oldItem = templater.newItem(item)._template;
                  if(oldItem) mergeTemplates(oldItem, item);
              }
              var defaultItems = templater.defaultItems();
              for(j = 0; j < defaultItems.length; j++) newVal.push(defaultItems[j]._template);
  
              // templateitemname only applies to receiving plots
              for(j = 0; j < newVal.length; j++) delete newVal[j].templateitemname;
          }
      }
  
      for(i = 0; i < oldKeys.length; i++) {
          var key = oldKeys[i];
          var oldVal = oldTemplate[key];
          if(key in newTemplate) {
              mergeOne(oldVal, newTemplate[key], key);
          } else newTemplate[key] = oldVal;
  
          // if this is a base key from the old template (eg xaxis), look for
          // extended keys (eg xaxis2) in the new template to merge into
          if(getBaseKey(key) === key) {
              for(var key2 in newTemplate) {
                  var baseKey2 = getBaseKey(key2);
                  if(key2 !== baseKey2 && baseKey2 === key && !(key2 in oldTemplate)) {
                      mergeOne(oldVal, newTemplate[key2], key);
                  }
              }
          }
      }
  }
  
  function getBaseKey(key) {
      return key.replace(/[0-9]+$/, '');
  }
  
  function walkStyleKeys(parent, templateOut, getAttributeInfo, path, basePath) {
      var pathAttr = basePath && getAttributeInfo(basePath);
      for(var key in parent) {
          var child = parent[key];
          var nextPath = getNextPath(parent, key, path);
          var nextBasePath = getNextPath(parent, key, basePath);
          var attr = getAttributeInfo(nextBasePath);
          if(!attr) {
              var baseKey = getBaseKey(key);
              if(baseKey !== key) {
                  nextBasePath = getNextPath(parent, baseKey, basePath);
                  attr = getAttributeInfo(nextBasePath);
              }
          }
  
          // we'll get an attr if path starts with a valid part, then has an
          // invalid ending. Make sure we got all the way to the end.
          if(pathAttr && (pathAttr === attr)) continue;
  
          if(!attr || attr._noTemplating ||
              attr.valType === 'data_array' ||
              (attr.arrayOk && Array.isArray(child))
          ) {
              continue;
          }
  
          if(!attr.valType && isPlainObject(child)) {
              walkStyleKeys(child, templateOut, getAttributeInfo, nextPath, nextBasePath);
          } else if(attr._isLinkedToArray && Array.isArray(child)) {
              var dfltDone = false;
              var namedIndex = 0;
              var usedNames = {};
              for(var i = 0; i < child.length; i++) {
                  var item = child[i];
                  if(isPlainObject(item)) {
                      var name = item.name;
                      if(name) {
                          if(!usedNames[name]) {
                              // named array items: allow all attributes except data arrays
                              walkStyleKeys(item, templateOut, getAttributeInfo,
                                  getNextPath(child, namedIndex, nextPath),
                                  getNextPath(child, namedIndex, nextBasePath));
                              namedIndex++;
                              usedNames[name] = 1;
                          }
                      } else if(!dfltDone) {
                          var dfltKey = Template.arrayDefaultKey(key);
                          var dfltPath = getNextPath(parent, dfltKey, path);
  
                          // getAttributeInfo will fail if we try to use dfltKey directly.
                          // Instead put this item into the next array element, then
                          // pull it out and move it to dfltKey.
                          var pathInArray = getNextPath(child, namedIndex, nextPath);
                          walkStyleKeys(item, templateOut, getAttributeInfo, pathInArray,
                              getNextPath(child, namedIndex, nextBasePath));
                          var itemPropInArray = Lib.nestedProperty(templateOut, pathInArray);
                          var dfltProp = Lib.nestedProperty(templateOut, dfltPath);
                          dfltProp.set(itemPropInArray.get());
                          itemPropInArray.set(null);
  
                          dfltDone = true;
                      }
                  }
              }
          } else {
              var templateProp = Lib.nestedProperty(templateOut, nextPath);
              templateProp.set(child);
          }
      }
  }
  
  function getLayoutInfo(layout, path) {
      return PlotSchema.getLayoutValObject(
          layout, Lib.nestedProperty({}, path).parts
      );
  }
  
  function getTraceInfo(trace, path) {
      return PlotSchema.getTraceValObject(
          trace, Lib.nestedProperty({}, path).parts
      );
  }
  
  function getNextPath(parent, key, path) {
      var nextPath;
      if(!path) nextPath = key;
      else if(Array.isArray(parent)) nextPath = path + '[' + key + ']';
      else nextPath = path + '.' + key;
  
      return nextPath;
  }
  
  /**
   * validateTemplate: Test for consistency between the given figure and
   * a template, either already included in the figure or given separately.
   * Note that not every issue we identify here is necessarily a problem,
   * it depends on what you're using the template for.
   *
   * @param {object|DOM element} figure: the plot, with {data, layout} members,
   *     to test the template against
   * @param {Optional(object)} template: the template, with its own {data, layout},
   *     to test. If omitted, we will look for a template already attached as the
   *     plot's `layout.template` attribute.
   *
   * @returns {array} array of error objects each containing:
   *  - {string} code
   *      error code ('missing', 'unused', 'reused', 'noLayout', 'noData')
   *  - {string} msg
   *      a full readable description of the issue.
   */
  exports.validateTemplate = function(figureIn, template) {
      var figure = Lib.extendDeep({}, {
          _context: dfltConfig,
          data: figureIn.data,
          layout: figureIn.layout
      });
      var layout = figure.layout || {};
      if(!isPlainObject(template)) template = layout.template || {};
      var layoutTemplate = template.layout;
      var dataTemplate = template.data;
      var errorList = [];
  
      figure.layout = layout;
      figure.layout.template = template;
      Plots.supplyDefaults(figure);
  
      var fullLayout = figure._fullLayout;
      var fullData = figure._fullData;
  
      var layoutPaths = {};
      function crawlLayoutForContainers(obj, paths) {
          for(var key in obj) {
              if(key.charAt(0) !== '_' && isPlainObject(obj[key])) {
                  var baseKey = getBaseKey(key);
                  var nextPaths = [];
                  var i;
                  for(i = 0; i < paths.length; i++) {
                      nextPaths.push(getNextPath(obj, key, paths[i]));
                      if(baseKey !== key) nextPaths.push(getNextPath(obj, baseKey, paths[i]));
                  }
                  for(i = 0; i < nextPaths.length; i++) {
                      layoutPaths[nextPaths[i]] = 1;
                  }
                  crawlLayoutForContainers(obj[key], nextPaths);
              }
          }
      }
  
      function crawlLayoutTemplateForContainers(obj, path) {
          for(var key in obj) {
              if(key.indexOf('defaults') === -1 && isPlainObject(obj[key])) {
                  var nextPath = getNextPath(obj, key, path);
                  if(layoutPaths[nextPath]) {
                      crawlLayoutTemplateForContainers(obj[key], nextPath);
                  } else {
                      errorList.push({code: 'unused', path: nextPath});
                  }
              }
          }
      }
  
      if(!isPlainObject(layoutTemplate)) {
          errorList.push({code: 'layout'});
      } else {
          crawlLayoutForContainers(fullLayout, ['layout']);
          crawlLayoutTemplateForContainers(layoutTemplate, 'layout');
      }
  
      if(!isPlainObject(dataTemplate)) {
          errorList.push({code: 'data'});
      } else {
          var typeCount = {};
          var traceType;
          for(var i = 0; i < fullData.length; i++) {
              var fullTrace = fullData[i];
              traceType = fullTrace.type;
              typeCount[traceType] = (typeCount[traceType] || 0) + 1;
              if(!fullTrace._fullInput._template) {
                  // this takes care of the case of traceType in the data but not
                  // the template
                  errorList.push({
                      code: 'missing',
                      index: fullTrace._fullInput.index,
                      traceType: traceType
                  });
              }
          }
          for(traceType in dataTemplate) {
              var templateCount = dataTemplate[traceType].length;
              var dataCount = typeCount[traceType] || 0;
              if(templateCount > dataCount) {
                  errorList.push({
                      code: 'unused',
                      traceType: traceType,
                      templateCount: templateCount,
                      dataCount: dataCount
                  });
              } else if(dataCount > templateCount) {
                  errorList.push({
                      code: 'reused',
                      traceType: traceType,
                      templateCount: templateCount,
                      dataCount: dataCount
                  });
              }
          }
      }
  
      // _template: false is when someone tried to modify an array item
      // but there was no template with matching name
      function crawlForMissingTemplates(obj, path) {
          for(var key in obj) {
              if(key.charAt(0) === '_') continue;
              var val = obj[key];
              var nextPath = getNextPath(obj, key, path);
              if(isPlainObject(val)) {
                  if(Array.isArray(obj) && val._template === false && val.templateitemname) {
                      errorList.push({
                          code: 'missing',
                          path: nextPath,
                          templateitemname: val.templateitemname
                      });
                  }
                  crawlForMissingTemplates(val, nextPath);
              } else if(Array.isArray(val) && hasPlainObject(val)) {
                  crawlForMissingTemplates(val, nextPath);
              }
          }
      }
      crawlForMissingTemplates({data: fullData, layout: fullLayout}, '');
  
      if(errorList.length) return errorList.map(format);
  };
  
  function hasPlainObject(arr) {
      for(var i = 0; i < arr.length; i++) {
          if(isPlainObject(arr[i])) return true;
      }
  }
  
  function format(opts) {
      var msg;
      switch(opts.code) {
          case 'data':
              msg = 'The template has no key data.';
              break;
          case 'layout':
              msg = 'The template has no key layout.';
              break;
          case 'missing':
              if(opts.path) {
                  msg = 'There are no templates for item ' + opts.path +
                      ' with name ' + opts.templateitemname;
              } else {
                  msg = 'There are no templates for trace ' + opts.index +
                      ', of type ' + opts.traceType + '.';
              }
              break;
          case 'unused':
              if(opts.path) {
                  msg = 'The template item at ' + opts.path +
                      ' was not used in constructing the plot.';
              } else if(opts.dataCount) {
                  msg = 'Some of the templates of type ' + opts.traceType +
                      ' were not used. The template has ' + opts.templateCount +
                      ' traces, the data only has ' + opts.dataCount +
                      ' of this type.';
              } else {
                  msg = 'The template has ' + opts.templateCount +
                      ' traces of type ' + opts.traceType +
                      ' but there are none in the data.';
              }
              break;
          case 'reused':
              msg = 'Some of the templates of type ' + opts.traceType +
                  ' were used more than once. The template has ' +
                  opts.templateCount + ' traces, the data has ' +
                  opts.dataCount + ' of this type.';
              break;
      }
      opts.msg = msg;
  
      return opts;
  }
  
  },{"../lib":750,"../plots/attributes":795,"../plots/plots":862,"./plot_config":786,"./plot_schema":787,"./plot_template":788}],791:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var plotApi = _dereq_('./plot_api');
  var plots = _dereq_('../plots/plots');
  var Lib = _dereq_('../lib');
  
  var helpers = _dereq_('../snapshot/helpers');
  var toSVG = _dereq_('../snapshot/tosvg');
  var svgToImg = _dereq_('../snapshot/svgtoimg');
  var version = _dereq_('../version').version;
  
  var attrs = {
      format: {
          valType: 'enumerated',
          values: ['png', 'jpeg', 'webp', 'svg', 'full-json'],
          dflt: 'png',
          
      },
      width: {
          valType: 'number',
          min: 1,
          
      },
      height: {
          valType: 'number',
          min: 1,
          
      },
      scale: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
      },
      setBackground: {
          valType: 'any',
          dflt: false,
          
      },
      imageDataOnly: {
          valType: 'boolean',
          dflt: false,
          
      }
  };
  
  /** Plotly.toImage
   *
   * @param {object | string | HTML div} gd
   *   can either be a data/layout/config object
   *   or an existing graph <div>
   *   or an id to an existing graph <div>
   * @param {object} opts (see above)
   * @return {promise}
   */
  function toImage(gd, opts) {
      opts = opts || {};
  
      var data;
      var layout;
      var config;
      var fullLayout;
  
      if(Lib.isPlainObject(gd)) {
          data = gd.data || [];
          layout = gd.layout || {};
          config = gd.config || {};
          fullLayout = {};
      } else {
          gd = Lib.getGraphDiv(gd);
          data = Lib.extendDeep([], gd.data);
          layout = Lib.extendDeep({}, gd.layout);
          config = gd._context;
          fullLayout = gd._fullLayout || {};
      }
  
      function isImpliedOrValid(attr) {
          return !(attr in opts) || Lib.validate(opts[attr], attrs[attr]);
      }
  
      if((!isImpliedOrValid('width') && opts.width !== null) ||
          (!isImpliedOrValid('height') && opts.height !== null)) {
          throw new Error('Height and width should be pixel values.');
      }
  
      if(!isImpliedOrValid('format')) {
          throw new Error('Export format is not ' + Lib.join2(attrs.format.values, ', ', ' or ') + '.');
      }
  
      var fullOpts = {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(opts, fullOpts, attrs, attr, dflt);
      }
  
      var format = coerce('format');
      var width = coerce('width');
      var height = coerce('height');
      var scale = coerce('scale');
      var setBackground = coerce('setBackground');
      var imageDataOnly = coerce('imageDataOnly');
  
      // put the cloned div somewhere off screen before attaching to DOM
      var clonedGd = document.createElement('div');
      clonedGd.style.position = 'absolute';
      clonedGd.style.left = '-5000px';
      document.body.appendChild(clonedGd);
  
      // extend layout with image options
      var layoutImage = Lib.extendFlat({}, layout);
      if(width) {
          layoutImage.width = width;
      } else if(opts.width === null && isNumeric(fullLayout.width)) {
          layoutImage.width = fullLayout.width;
      }
      if(height) {
          layoutImage.height = height;
      } else if(opts.height === null && isNumeric(fullLayout.height)) {
          layoutImage.height = fullLayout.height;
      }
  
      // extend config for static plot
      var configImage = Lib.extendFlat({}, config, {
          _exportedPlot: true,
          staticPlot: true,
          setBackground: setBackground
      });
  
      var redrawFunc = helpers.getRedrawFunc(clonedGd);
  
      function wait() {
          return new Promise(function(resolve) {
              setTimeout(resolve, helpers.getDelay(clonedGd._fullLayout));
          });
      }
  
      function convert() {
          return new Promise(function(resolve, reject) {
              var svg = toSVG(clonedGd, format, scale);
              var width = clonedGd._fullLayout.width;
              var height = clonedGd._fullLayout.height;
  
              function cleanup() {
                  plotApi.purge(clonedGd);
                  document.body.removeChild(clonedGd);
              }
  
              if(format === 'full-json') {
                  var json = plots.graphJson(clonedGd, false, 'keepdata', 'object', true, true);
                  json.version = version;
                  json = JSON.stringify(json);
                  cleanup();
                  if(imageDataOnly) {
                      return resolve(json);
                  } else {
                      return resolve(helpers.encodeJSON(json));
                  }
              }
  
              cleanup();
  
              if(format === 'svg') {
                  if(imageDataOnly) {
                      return resolve(svg);
                  } else {
                      return resolve(helpers.encodeSVG(svg));
                  }
              }
  
              var canvas = document.createElement('canvas');
              canvas.id = Lib.randstr();
  
              svgToImg({
                  format: format,
                  width: width,
                  height: height,
                  scale: scale,
                  canvas: canvas,
                  svg: svg,
                  // ask svgToImg to return a Promise
                  //  rather than EventEmitter
                  //  leave EventEmitter for backward
                  //  compatibility
                  promise: true
              })
              .then(resolve)
              .catch(reject);
          });
      }
  
      function urlToImageData(url) {
          if(imageDataOnly) {
              return url.replace(helpers.IMAGE_URL_PREFIX, '');
          } else {
              return url;
          }
      }
  
      return new Promise(function(resolve, reject) {
          plotApi.plot(clonedGd, data, layoutImage, configImage)
              .then(redrawFunc)
              .then(wait)
              .then(convert)
              .then(function(url) { resolve(urlToImageData(url)); })
              .catch(function(err) { reject(err); });
      });
  }
  
  module.exports = toImage;
  
  },{"../lib":750,"../plots/plots":862,"../snapshot/helpers":886,"../snapshot/svgtoimg":888,"../snapshot/tosvg":890,"../version":1341,"./plot_api":785,"fast-isnumeric":241}],792:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var Plots = _dereq_('../plots/plots');
  var PlotSchema = _dereq_('./plot_schema');
  var dfltConfig = _dereq_('./plot_config').dfltConfig;
  
  var isPlainObject = Lib.isPlainObject;
  var isArray = Array.isArray;
  var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
  
  /**
   * Validate a data array and layout object.
   *
   * @param {array} data
   * @param {object} layout
   *
   * @return {array} array of error objects each containing:
   *  - {string} code
   *      error code ('object', 'array', 'schema', 'unused', 'invisible' or 'value')
   *  - {string} container
   *      container where the error occurs ('data' or 'layout')
   *  - {number} trace
   *      trace index of the 'data' container where the error occurs
   *  - {array} path
   *      nested path to the key that causes the error
   *  - {string} astr
   *      attribute string variant of 'path' compatible with Plotly.restyle and
   *      Plotly.relayout.
   *  - {string} msg
   *      error message (shown in console in logger config argument is enable)
   */
  module.exports = function validate(data, layout) {
      if(data === undefined) data = [];
      if(layout === undefined) layout = {};
  
      var schema = PlotSchema.get();
      var errorList = [];
      var gd = {_context: Lib.extendFlat({}, dfltConfig)};
  
      var dataIn, layoutIn;
  
      if(isArray(data)) {
          gd.data = Lib.extendDeep([], data);
          dataIn = data;
      } else {
          gd.data = [];
          dataIn = [];
          errorList.push(format('array', 'data'));
      }
  
      if(isPlainObject(layout)) {
          gd.layout = Lib.extendDeep({}, layout);
          layoutIn = layout;
      } else {
          gd.layout = {};
          layoutIn = {};
          if(arguments.length > 1) {
              errorList.push(format('object', 'layout'));
          }
      }
  
      // N.B. dataIn and layoutIn are in general not the same as
      // gd.data and gd.layout after supplyDefaults as some attributes
      // in gd.data and gd.layout (still) get mutated during this step.
  
      Plots.supplyDefaults(gd);
  
      var dataOut = gd._fullData;
      var len = dataIn.length;
  
      for(var i = 0; i < len; i++) {
          var traceIn = dataIn[i];
          var base = ['data', i];
  
          if(!isPlainObject(traceIn)) {
              errorList.push(format('object', base));
              continue;
          }
  
          var traceOut = dataOut[i];
          var traceType = traceOut.type;
          var traceSchema = schema.traces[traceType].attributes;
  
          // PlotSchema does something fancy with trace 'type', reset it here
          // to make the trace schema compatible with Lib.validate.
          traceSchema.type = {
              valType: 'enumerated',
              values: [traceType]
          };
  
          if(traceOut.visible === false && traceIn.visible !== false) {
              errorList.push(format('invisible', base));
          }
  
          crawl(traceIn, traceOut, traceSchema, errorList, base);
  
          var transformsIn = traceIn.transforms;
          var transformsOut = traceOut.transforms;
  
          if(transformsIn) {
              if(!isArray(transformsIn)) {
                  errorList.push(format('array', base, ['transforms']));
              }
  
              base.push('transforms');
  
              for(var j = 0; j < transformsIn.length; j++) {
                  var path = ['transforms', j];
                  var transformType = transformsIn[j].type;
  
                  if(!isPlainObject(transformsIn[j])) {
                      errorList.push(format('object', base, path));
                      continue;
                  }
  
                  var transformSchema = schema.transforms[transformType] ?
                      schema.transforms[transformType].attributes :
                      {};
  
                  // add 'type' to transform schema to validate the transform type
                  transformSchema.type = {
                      valType: 'enumerated',
                      values: Object.keys(schema.transforms)
                  };
  
                  crawl(transformsIn[j], transformsOut[j], transformSchema, errorList, base, path);
              }
          }
      }
  
      var layoutOut = gd._fullLayout;
      var layoutSchema = fillLayoutSchema(schema, dataOut);
  
      crawl(layoutIn, layoutOut, layoutSchema, errorList, 'layout');
  
      // return undefined if no validation errors were found
      return (errorList.length === 0) ? void(0) : errorList;
  };
  
  function crawl(objIn, objOut, schema, list, base, path) {
      path = path || [];
  
      var keys = Object.keys(objIn);
  
      for(var i = 0; i < keys.length; i++) {
          var k = keys[i];
  
          // transforms are handled separately
          if(k === 'transforms') continue;
  
          var p = path.slice();
          p.push(k);
  
          var valIn = objIn[k];
          var valOut = objOut[k];
  
          var nestedSchema = getNestedSchema(schema, k);
          var nestedValType = (nestedSchema || {}).valType;
          var isInfoArray = nestedValType === 'info_array';
          var isColorscale = nestedValType === 'colorscale';
          var items = (nestedSchema || {}).items;
  
          if(!isInSchema(schema, k)) {
              list.push(format('schema', base, p));
          } else if(isPlainObject(valIn) && isPlainObject(valOut) && nestedValType !== 'any') {
              crawl(valIn, valOut, nestedSchema, list, base, p);
          } else if(isInfoArray && isArray(valIn)) {
              if(valIn.length > valOut.length) {
                  list.push(format('unused', base, p.concat(valOut.length)));
              }
              var len = valOut.length;
              var arrayItems = Array.isArray(items);
              if(arrayItems) len = Math.min(len, items.length);
              var m, n, item, valInPart, valOutPart;
              if(nestedSchema.dimensions === 2) {
                  for(n = 0; n < len; n++) {
                      if(isArray(valIn[n])) {
                          if(valIn[n].length > valOut[n].length) {
                              list.push(format('unused', base, p.concat(n, valOut[n].length)));
                          }
                          var len2 = valOut[n].length;
                          for(m = 0; m < (arrayItems ? Math.min(len2, items[n].length) : len2); m++) {
                              item = arrayItems ? items[n][m] : items;
                              valInPart = valIn[n][m];
                              valOutPart = valOut[n][m];
                              if(!Lib.validate(valInPart, item)) {
                                  list.push(format('value', base, p.concat(n, m), valInPart));
                              } else if(valOutPart !== valInPart && valOutPart !== +valInPart) {
                                  list.push(format('dynamic', base, p.concat(n, m), valInPart, valOutPart));
                              }
                          }
                      } else {
                          list.push(format('array', base, p.concat(n), valIn[n]));
                      }
                  }
              } else {
                  for(n = 0; n < len; n++) {
                      item = arrayItems ? items[n] : items;
                      valInPart = valIn[n];
                      valOutPart = valOut[n];
                      if(!Lib.validate(valInPart, item)) {
                          list.push(format('value', base, p.concat(n), valInPart));
                      } else if(valOutPart !== valInPart && valOutPart !== +valInPart) {
                          list.push(format('dynamic', base, p.concat(n), valInPart, valOutPart));
                      }
                  }
              }
          } else if(nestedSchema.items && !isInfoArray && isArray(valIn)) {
              var _nestedSchema = items[Object.keys(items)[0]];
              var indexList = [];
  
              var j, _p;
  
              // loop over valOut items while keeping track of their
              // corresponding input container index (given by _index)
              for(j = 0; j < valOut.length; j++) {
                  var _index = valOut[j]._index || j;
  
                  _p = p.slice();
                  _p.push(_index);
  
                  if(isPlainObject(valIn[_index]) && isPlainObject(valOut[j])) {
                      indexList.push(_index);
                      var valInj = valIn[_index];
                      var valOutj = valOut[j];
                      if(isPlainObject(valInj) && valInj.visible !== false && valOutj.visible === false) {
                          list.push(format('invisible', base, _p));
                      } else crawl(valInj, valOutj, _nestedSchema, list, base, _p);
                  }
              }
  
              // loop over valIn to determine where it went wrong for some items
              for(j = 0; j < valIn.length; j++) {
                  _p = p.slice();
                  _p.push(j);
  
                  if(!isPlainObject(valIn[j])) {
                      list.push(format('object', base, _p, valIn[j]));
                  } else if(indexList.indexOf(j) === -1) {
                      list.push(format('unused', base, _p));
                  }
              }
          } else if(!isPlainObject(valIn) && isPlainObject(valOut)) {
              list.push(format('object', base, p, valIn));
          } else if(!isArrayOrTypedArray(valIn) && isArrayOrTypedArray(valOut) && !isInfoArray && !isColorscale) {
              list.push(format('array', base, p, valIn));
          } else if(!(k in objOut)) {
              list.push(format('unused', base, p, valIn));
          } else if(!Lib.validate(valIn, nestedSchema)) {
              list.push(format('value', base, p, valIn));
          } else if(nestedSchema.valType === 'enumerated' &&
              ((nestedSchema.coerceNumber && valIn !== +valOut) || valIn !== valOut)
          ) {
              list.push(format('dynamic', base, p, valIn, valOut));
          }
      }
  
      return list;
  }
  
  // the 'full' layout schema depends on the traces types presents
  function fillLayoutSchema(schema, dataOut) {
      var layoutSchema = schema.layout.layoutAttributes;
  
      for(var i = 0; i < dataOut.length; i++) {
          var traceOut = dataOut[i];
          var traceSchema = schema.traces[traceOut.type];
          var traceLayoutAttr = traceSchema.layoutAttributes;
  
          if(traceLayoutAttr) {
              if(traceOut.subplot) {
                  Lib.extendFlat(layoutSchema[traceSchema.attributes.subplot.dflt], traceLayoutAttr);
              } else {
                  Lib.extendFlat(layoutSchema, traceLayoutAttr);
              }
          }
      }
  
      return layoutSchema;
  }
  
  // validation error codes
  var code2msgFunc = {
      object: function(base, astr) {
          var prefix;
  
          if(base === 'layout' && astr === '') prefix = 'The layout argument';
          else if(base[0] === 'data' && astr === '') {
              prefix = 'Trace ' + base[1] + ' in the data argument';
          } else prefix = inBase(base) + 'key ' + astr;
  
          return prefix + ' must be linked to an object container';
      },
      array: function(base, astr) {
          var prefix;
  
          if(base === 'data') prefix = 'The data argument';
          else prefix = inBase(base) + 'key ' + astr;
  
          return prefix + ' must be linked to an array container';
      },
      schema: function(base, astr) {
          return inBase(base) + 'key ' + astr + ' is not part of the schema';
      },
      unused: function(base, astr, valIn) {
          var target = isPlainObject(valIn) ? 'container' : 'key';
  
          return inBase(base) + target + ' ' + astr + ' did not get coerced';
      },
      dynamic: function(base, astr, valIn, valOut) {
          return [
              inBase(base) + 'key',
              astr,
              '(set to \'' + valIn + '\')',
              'got reset to',
              '\'' + valOut + '\'',
              'during defaults.'
          ].join(' ');
      },
      invisible: function(base, astr) {
          return (
              astr ? (inBase(base) + 'item ' + astr) : ('Trace ' + base[1])
          ) + ' got defaulted to be not visible';
      },
      value: function(base, astr, valIn) {
          return [
              inBase(base) + 'key ' + astr,
              'is set to an invalid value (' + valIn + ')'
          ].join(' ');
      }
  };
  
  function inBase(base) {
      if(isArray(base)) return 'In data trace ' + base[1] + ', ';
  
      return 'In ' + base + ', ';
  }
  
  function format(code, base, path, valIn, valOut) {
      path = path || '';
  
      var container, trace;
  
      // container is either 'data' or 'layout
      // trace is the trace index if 'data', null otherwise
  
      if(isArray(base)) {
          container = base[0];
          trace = base[1];
      } else {
          container = base;
          trace = null;
      }
  
      var astr = convertPathToAttributeString(path);
      var msg = code2msgFunc[code](base, astr, valIn, valOut);
  
      // log to console if logger config option is enabled
      Lib.log(msg);
  
      return {
          code: code,
          container: container,
          trace: trace,
          path: path,
          astr: astr,
          msg: msg
      };
  }
  
  function isInSchema(schema, key) {
      var parts = splitKey(key);
      var keyMinusId = parts.keyMinusId;
      var id = parts.id;
  
      if((keyMinusId in schema) && schema[keyMinusId]._isSubplotObj && id) {
          return true;
      }
  
      return (key in schema);
  }
  
  function getNestedSchema(schema, key) {
      if(key in schema) return schema[key];
  
      var parts = splitKey(key);
  
      return schema[parts.keyMinusId];
  }
  
  var idRegex = Lib.counterRegex('([a-z]+)');
  
  function splitKey(key) {
      var idMatch = key.match(idRegex);
  
      return {
          keyMinusId: idMatch && idMatch[1],
          id: idMatch && idMatch[2]
      };
  }
  
  function convertPathToAttributeString(path) {
      if(!isArray(path)) return String(path);
  
      var astr = '';
  
      for(var i = 0; i < path.length; i++) {
          var p = path[i];
  
          if(typeof p === 'number') {
              astr = astr.substr(0, astr.length - 1) + '[' + p + ']';
          } else {
              astr += p;
          }
  
          if(i < path.length - 1) astr += '.';
      }
  
      return astr;
  }
  
  },{"../lib":750,"../plots/plots":862,"./plot_config":786,"./plot_schema":787}],793:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      mode: {
          valType: 'enumerated',
          dflt: 'afterall',
          
          values: ['immediate', 'next', 'afterall'],
          
      },
      direction: {
          valType: 'enumerated',
          
          values: ['forward', 'reverse'],
          dflt: 'forward',
          
      },
      fromcurrent: {
          valType: 'boolean',
          dflt: false,
          
          
      },
      frame: {
          duration: {
              valType: 'number',
              
              min: 0,
              dflt: 500,
              
          },
          redraw: {
              valType: 'boolean',
              
              dflt: true,
              
          },
      },
      transition: {
          duration: {
              valType: 'number',
              
              min: 0,
              dflt: 500,
              editType: 'none',
              
          },
          easing: {
              valType: 'enumerated',
              dflt: 'cubic-in-out',
              values: [
                  'linear',
                  'quad',
                  'cubic',
                  'sin',
                  'exp',
                  'circle',
                  'elastic',
                  'back',
                  'bounce',
                  'linear-in',
                  'quad-in',
                  'cubic-in',
                  'sin-in',
                  'exp-in',
                  'circle-in',
                  'elastic-in',
                  'back-in',
                  'bounce-in',
                  'linear-out',
                  'quad-out',
                  'cubic-out',
                  'sin-out',
                  'exp-out',
                  'circle-out',
                  'elastic-out',
                  'back-out',
                  'bounce-out',
                  'linear-in-out',
                  'quad-in-out',
                  'cubic-in-out',
                  'sin-in-out',
                  'exp-in-out',
                  'circle-in-out',
                  'elastic-in-out',
                  'back-in-out',
                  'bounce-in-out'
              ],
              
              editType: 'none',
              
          },
          ordering: {
              valType: 'enumerated',
              values: ['layout first', 'traces first'],
              dflt: 'layout first',
              
              editType: 'none',
              
          }
      }
  };
  
  },{}],794:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var Template = _dereq_('../plot_api/plot_template');
  
  /** Convenience wrapper for making array container logic DRY and consistent
   *
   * @param {object} parentObjIn
   *  user input object where the container in question is linked
   *  (i.e. either a user trace object or the user layout object)
   *
   * @param {object} parentObjOut
   *  full object where the coerced container will be linked
   *  (i.e. either a full trace object or the full layout object)
   *
   * @param {object} opts
   *  options object:
   *   - name {string}
   *      name of the key linking the container in question
   *   - inclusionAttr {string}
   *      name of the item attribute for inclusion/exclusion. Default is 'visible'.
   *      Since inclusion is true, use eg 'enabled' instead of 'disabled'.
   *   - handleItemDefaults {function}
   *      defaults method to be called on each item in the array container in question
   *
   *      Its arguments are:
   *          - itemIn {object} item in user layout
   *          - itemOut {object} item in full layout
   *          - parentObj {object} (as in closure)
   *          - opts {object} (as in closure)
   * N.B.
   *
   *  - opts is passed to handleItemDefaults so it can also store
   *    links to supplementary data (e.g. fullData for layout components)
   *
   */
  module.exports = function handleArrayContainerDefaults(parentObjIn, parentObjOut, opts) {
      var name = opts.name;
      var inclusionAttr = opts.inclusionAttr || 'visible';
  
      var previousContOut = parentObjOut[name];
  
      var contIn = Lib.isArrayOrTypedArray(parentObjIn[name]) ? parentObjIn[name] : [];
      var contOut = parentObjOut[name] = [];
      var templater = Template.arrayTemplater(parentObjOut, name, inclusionAttr);
      var i, itemOut;
  
      for(i = 0; i < contIn.length; i++) {
          var itemIn = contIn[i];
  
          if(!Lib.isPlainObject(itemIn)) {
              itemOut = templater.newItem({});
              itemOut[inclusionAttr] = false;
          } else {
              itemOut = templater.newItem(itemIn);
          }
  
          itemOut._index = i;
  
          if(itemOut[inclusionAttr] !== false) {
              opts.handleItemDefaults(itemIn, itemOut, parentObjOut, opts);
          }
  
          contOut.push(itemOut);
      }
  
      var defaultItems = templater.defaultItems();
      for(i = 0; i < defaultItems.length; i++) {
          itemOut = defaultItems[i];
          itemOut._index = contOut.length;
          opts.handleItemDefaults({}, itemOut, parentObjOut, opts, {});
          contOut.push(itemOut);
      }
  
      // in case this array gets its defaults rebuilt independent of the whole layout,
      // relink the private keys just for this array.
      if(Lib.isArrayOrTypedArray(previousContOut)) {
          var len = Math.min(previousContOut.length, contOut.length);
          for(i = 0; i < len; i++) {
              Lib.relinkPrivateKeys(contOut[i], previousContOut[i]);
          }
      }
  
      return contOut;
  };
  
  },{"../lib":750,"../plot_api/plot_template":788}],795:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fxAttrs = _dereq_('../components/fx/attributes');
  
  module.exports = {
      type: {
          valType: 'enumerated',
          
          values: [],     // listed dynamically
          dflt: 'scatter',
          editType: 'calc+clearAxisTypes',
          _noTemplating: true // we handle this at a higher level
      },
      visible: {
          valType: 'enumerated',
          values: [true, false, 'legendonly'],
          
          dflt: true,
          editType: 'calc',
          
      },
      showlegend: {
          valType: 'boolean',
          
          dflt: true,
          editType: 'style',
          
      },
      legendgroup: {
          valType: 'string',
          
          dflt: '',
          editType: 'style',
          
      },
      opacity: {
          valType: 'number',
          
          min: 0,
          max: 1,
          dflt: 1,
          editType: 'style',
          
      },
      name: {
          valType: 'string',
          
          editType: 'style',
          
      },
      uid: {
          valType: 'string',
          
          editType: 'plot',
          anim: true,
          
      },
      ids: {
          valType: 'data_array',
          editType: 'calc',
          anim: true,
          
      },
      customdata: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      meta: {
          valType: 'any',
          arrayOk: true,
          
          editType: 'plot',
          
      },
  
      // N.B. these cannot be 'data_array' as they do not have the same length as
      // other data arrays and arrayOk attributes in general
      //
      // Maybe add another valType:
      // https://github.com/plotly/plotly.js/issues/1894
      selectedpoints: {
          valType: 'any',
          
          editType: 'calc',
          
      },
  
      hoverinfo: {
          valType: 'flaglist',
          
          flags: ['x', 'y', 'z', 'text', 'name'],
          extras: ['all', 'none', 'skip'],
          arrayOk: true,
          dflt: 'all',
          editType: 'none',
          
      },
      hoverlabel: fxAttrs.hoverlabel,
      stream: {
          token: {
              valType: 'string',
              noBlank: true,
              strict: true,
              
              editType: 'calc',
              
          },
          maxpoints: {
              valType: 'number',
              min: 0,
              max: 10000,
              dflt: 500,
              
              editType: 'calc',
              
          },
          editType: 'calc'
      },
      transforms: {
          _isLinkedToArray: 'transform',
          editType: 'calc',
          
      },
      uirevision: {
          valType: 'any',
          
          editType: 'none',
          
      }
  };
  
  },{"../components/fx/attributes":646}],796:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var Lib = _dereq_('../../lib');
  var dateTime2ms = Lib.dateTime2ms;
  var incrementMonth = Lib.incrementMonth;
  var constants = _dereq_('../../constants/numerical');
  var ONEAVGMONTH = constants.ONEAVGMONTH;
  
  module.exports = function alignPeriod(trace, ax, axLetter, vals) {
      if(ax.type !== 'date') return vals;
  
      var alignment = trace[axLetter + 'periodalignment'];
      if(!alignment) return vals;
  
      var period = trace[axLetter + 'period'];
      var mPeriod;
      if(isNumeric(period)) {
          period = +period;
          if(period <= 0) return vals;
      } else if(typeof period === 'string' && period.charAt(0) === 'M') {
          var n = +(period.substring(1));
          if(n > 0 && Math.round(n) === n) {
              mPeriod = n;
          } else return vals;
      }
  
      var calendar = ax.calendar;
  
      var isStart = 'start' === alignment;
      // var isMiddle = 'middle' === alignment;
      var isEnd = 'end' === alignment;
  
      var period0 = trace[axLetter + 'period0'];
      var base = dateTime2ms(period0, calendar) || 0;
  
      var newVals = [];
      var len = vals.length;
      for(var i = 0; i < len; i++) {
          var v = vals[i];
  
          var nEstimated, startTime, endTime;
          if(mPeriod) {
              // guess at how many periods away from base we are
              nEstimated = Math.round((v - base) / (mPeriod * ONEAVGMONTH));
              endTime = incrementMonth(base, mPeriod * nEstimated, calendar);
  
              // iterate to get the exact bounds before and after v
              // there may be ways to make this faster, but most of the time
              // we'll only execute each loop zero or one time.
              while(endTime > v) {
                  endTime = incrementMonth(endTime, -mPeriod, calendar);
              }
              while(endTime <= v) {
                  endTime = incrementMonth(endTime, mPeriod, calendar);
              }
  
              // now we know endTime is the boundary immediately after v
              // so startTime is obtained by incrementing backward one period.
              startTime = incrementMonth(endTime, -mPeriod, calendar);
          } else { // case of ms
              nEstimated = Math.round((v - base) / period);
              endTime = base + nEstimated * period;
  
              while(endTime > v) {
                  endTime -= period;
              }
              while(endTime <= v) {
                  endTime += period;
              }
  
              startTime = endTime - period;
          }
  
          newVals[i] = (
              isStart ? startTime :
              isEnd ? endTime :
              (startTime + endTime) / 2
          );
      }
      return newVals;
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"fast-isnumeric":241}],797:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  module.exports = {
      xaxis: {
          valType: 'subplotid',
          
          dflt: 'x',
          editType: 'calc+clearAxisTypes',
          
      },
      yaxis: {
          valType: 'subplotid',
          
          dflt: 'y',
          editType: 'calc+clearAxisTypes',
          
      }
  };
  
  },{}],798:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var FP_SAFE = _dereq_('../../constants/numerical').FP_SAFE;
  var Registry = _dereq_('../../registry');
  
  module.exports = {
      getAutoRange: getAutoRange,
      makePadFn: makePadFn,
      doAutoRange: doAutoRange,
      findExtremes: findExtremes,
      concatExtremes: concatExtremes
  };
  
  /**
   * getAutoRange
   *
   * Collects all _extremes values corresponding to a given axis
   * and computes its auto range.
   *
   * Note that getAutoRange uses return values from findExtremes.
   *
   * @param {object} gd:
   *   graph div object with filled-in fullData and fullLayout, in particular
   *   with filled-in '_extremes' containers:
   *   {
   *      val: calcdata value,
   *      pad: extra pixels beyond this value,
   *      extrapad: bool, does this point want 5% extra padding
   *   }
   * @param {object} ax:
   *   full axis object, in particular with filled-in '_traceIndices'
   *   and '_annIndices' / '_shapeIndices' if applicable
   * @return {array}
   *   an array of [min, max]. These are calcdata for log and category axes
   *   and data for linear and date axes.
   *
   * TODO: we want to change log to data as well, but it's hard to do this
   * maintaining backward compatibility. category will always have to use calcdata
   * though, because otherwise values between categories (or outside all categories)
   * would be impossible.
   */
  function getAutoRange(gd, ax) {
      var i, j;
      var newRange = [];
  
      var getPad = makePadFn(ax);
      var extremes = concatExtremes(gd, ax);
      var minArray = extremes.min;
      var maxArray = extremes.max;
  
      if(minArray.length === 0 || maxArray.length === 0) {
          return Lib.simpleMap(ax.range, ax.r2l);
      }
  
      var minmin = minArray[0].val;
      var maxmax = maxArray[0].val;
  
      for(i = 1; i < minArray.length; i++) {
          if(minmin !== maxmax) break;
          minmin = Math.min(minmin, minArray[i].val);
      }
      for(i = 1; i < maxArray.length; i++) {
          if(minmin !== maxmax) break;
          maxmax = Math.max(maxmax, maxArray[i].val);
      }
  
      var axReverse = false;
  
      if(ax.range) {
          var rng = Lib.simpleMap(ax.range, ax.r2l);
          axReverse = rng[1] < rng[0];
      }
      // one-time setting to easily reverse the axis
      // when plotting from code
      if(ax.autorange === 'reversed') {
          axReverse = true;
          ax.autorange = true;
      }
  
      var rangeMode = ax.rangemode;
      var toZero = rangeMode === 'tozero';
      var nonNegative = rangeMode === 'nonnegative';
      var axLen = ax._length;
      // don't allow padding to reduce the data to < 10% of the length
      var minSpan = axLen / 10;
  
      // find axis rangebreaks in [v0,v1] and compute its length in value space
      var calcBreaksLength = function(v0, v1) {
          var lBreaks = 0;
          if(ax.rangebreaks) {
              var rangebreaksOut = ax.locateBreaks(v0, v1);
              for(var i = 0; i < rangebreaksOut.length; i++) {
                  var brk = rangebreaksOut[i];
                  lBreaks += brk.max - brk.min;
              }
          }
          return lBreaks;
      };
  
      var mbest = 0;
      var minpt, maxpt, minbest, maxbest, dp, dv;
  
      for(i = 0; i < minArray.length; i++) {
          minpt = minArray[i];
          for(j = 0; j < maxArray.length; j++) {
              maxpt = maxArray[j];
              dv = maxpt.val - minpt.val - calcBreaksLength(minpt.val, maxpt.val);
              if(dv > 0) {
                  dp = axLen - getPad(minpt) - getPad(maxpt);
                  if(dp > minSpan) {
                      if(dv / dp > mbest) {
                          minbest = minpt;
                          maxbest = maxpt;
                          mbest = dv / dp;
                      }
                  } else if(dv / axLen > mbest) {
                      // in case of padding longer than the axis
                      // at least include the unpadded data values.
                      minbest = {val: minpt.val, pad: 0};
                      maxbest = {val: maxpt.val, pad: 0};
                      mbest = dv / axLen;
                  }
              }
          }
      }
  
      function getMaxPad(prev, pt) {
          return Math.max(prev, getPad(pt));
      }
  
      if(minmin === maxmax) {
          var lower = minmin - 1;
          var upper = minmin + 1;
          if(toZero) {
              if(minmin === 0) {
                  // The only value we have on this axis is 0, and we want to
                  // autorange so zero is one end.
                  // In principle this could be [0, 1] or [-1, 0] but usually
                  // 'tozero' pins 0 to the low end, so follow that.
                  newRange = [0, 1];
              } else {
                  var maxPad = (minmin > 0 ? maxArray : minArray).reduce(getMaxPad, 0);
                  // we're pushing a single value away from the edge due to its
                  // padding, with the other end clamped at zero
                  // 0.5 means don't push it farther than the center.
                  var rangeEnd = minmin / (1 - Math.min(0.5, maxPad / axLen));
                  newRange = minmin > 0 ? [0, rangeEnd] : [rangeEnd, 0];
              }
          } else if(nonNegative) {
              newRange = [Math.max(0, lower), Math.max(1, upper)];
          } else {
              newRange = [lower, upper];
          }
      } else {
          if(toZero) {
              if(minbest.val >= 0) {
                  minbest = {val: 0, pad: 0};
              }
              if(maxbest.val <= 0) {
                  maxbest = {val: 0, pad: 0};
              }
          } else if(nonNegative) {
              if(minbest.val - mbest * getPad(minbest) < 0) {
                  minbest = {val: 0, pad: 0};
              }
              if(maxbest.val <= 0) {
                  maxbest = {val: 1, pad: 0};
              }
          }
  
          // in case it changed again...
          mbest = (maxbest.val - minbest.val - calcBreaksLength(minpt.val, maxpt.val)) /
              (axLen - getPad(minbest) - getPad(maxbest));
  
          newRange = [
              minbest.val - mbest * getPad(minbest),
              maxbest.val + mbest * getPad(maxbest)
          ];
      }
  
      // maintain reversal
      if(axReverse) newRange.reverse();
  
      return Lib.simpleMap(newRange, ax.l2r || Number);
  }
  
  /*
   * calculate the pixel padding for ax._min and ax._max entries with
   * optional extrapad as 5% of the total axis length
   */
  function makePadFn(ax) {
      // 5% padding for points that specify extrapad: true
      var extrappad = ax._length / 20;
  
      // domain-constrained axes: base extrappad on the unconstrained
      // domain so it's consistent as the domain changes
      if((ax.constrain === 'domain') && ax._inputDomain) {
          extrappad *= (ax._inputDomain[1] - ax._inputDomain[0]) /
              (ax.domain[1] - ax.domain[0]);
      }
  
      return function getPad(pt) { return pt.pad + (pt.extrapad ? extrappad : 0); };
  }
  
  function concatExtremes(gd, ax) {
      var axId = ax._id;
      var fullData = gd._fullData;
      var fullLayout = gd._fullLayout;
      var minArray = [];
      var maxArray = [];
      var i, j, d;
  
      function _concat(cont, indices) {
          for(i = 0; i < indices.length; i++) {
              var item = cont[indices[i]];
              var extremes = (item._extremes || {})[axId];
              if(item.visible === true && extremes) {
                  for(j = 0; j < extremes.min.length; j++) {
                      d = extremes.min[j];
                      collapseMinArray(minArray, d.val, d.pad, {extrapad: d.extrapad});
                  }
                  for(j = 0; j < extremes.max.length; j++) {
                      d = extremes.max[j];
                      collapseMaxArray(maxArray, d.val, d.pad, {extrapad: d.extrapad});
                  }
              }
          }
      }
  
      _concat(fullData, ax._traceIndices);
      _concat(fullLayout.annotations || [], ax._annIndices || []);
      _concat(fullLayout.shapes || [], ax._shapeIndices || []);
  
      return {min: minArray, max: maxArray};
  }
  
  function doAutoRange(gd, ax) {
      ax.setScale();
  
      if(ax.autorange) {
          ax.range = getAutoRange(gd, ax);
  
          ax._r = ax.range.slice();
          ax._rl = Lib.simpleMap(ax._r, ax.r2l);
  
          // doAutoRange will get called on fullLayout,
          // but we want to report its results back to layout
  
          var axIn = ax._input;
  
          // before we edit _input, store preGUI values
          var edits = {};
          edits[ax._attr + '.range'] = ax.range;
          edits[ax._attr + '.autorange'] = ax.autorange;
          Registry.call('_storeDirectGUIEdit', gd.layout, gd._fullLayout._preGUI, edits);
  
          axIn.range = ax.range.slice();
          axIn.autorange = ax.autorange;
      }
  
      var anchorAx = ax._anchorAxis;
  
      if(anchorAx && anchorAx.rangeslider) {
          var axeRangeOpts = anchorAx.rangeslider[ax._name];
          if(axeRangeOpts) {
              if(axeRangeOpts.rangemode === 'auto') {
                  axeRangeOpts.range = getAutoRange(gd, ax);
              }
          }
          anchorAx._input.rangeslider[ax._name] = Lib.extendFlat({}, axeRangeOpts);
      }
  }
  
  /**
   * findExtremes
   *
   * Find min/max extremes of an array of coordinates on a given axis.
   *
   * Note that findExtremes is called during `calc`, when we don't yet know the axis
   * length; all the inputs should be based solely on the trace data, nothing
   * about the axis layout.
   *
   * Note that `ppad` and `vpad` as well as their asymmetric variants refer to
   * the before and after padding of the passed `data` array, not to the whole axis.
   *
   * @param {object} ax: full axis object
   *   relies on
   *   - ax.type
   *   - ax._m (just its sign)
   *   - ax.d2l
   * @param {array} data:
   *  array of numbers (i.e. already run though ax.d2c)
   * @param {object} opts:
   *  available keys are:
   *      vpad: (number or number array) pad values (data value +-vpad)
   *      ppad: (number or number array) pad pixels (pixel location +-ppad)
   *      ppadplus, ppadminus, vpadplus, vpadminus:
   *          separate padding for each side, overrides symmetric
   *      padded: (boolean) add 5% padding to both ends
   *          (unless one end is overridden by tozero)
   *      tozero: (boolean) make sure to include zero if axis is linear,
   *          and make it a tight bound if possible
   *      vpadLinearized: (boolean) whether or not vpad (or vpadplus/vpadminus)
   *          is linearized (for log scale axes)
   *
   * @return {object}
   *  - min {array of objects}
   *  - max {array of objects}
   *  each object item has fields:
   *    - val {number}
   *    - pad {number}
   *    - extrappad {number}
   *  - opts {object}: a ref to the passed "options" object
   */
  function findExtremes(ax, data, opts) {
      if(!opts) opts = {};
      if(!ax._m) ax.setScale();
  
      var minArray = [];
      var maxArray = [];
  
      var len = data.length;
      var extrapad = opts.padded || false;
      var tozero = opts.tozero && (ax.type === 'linear' || ax.type === '-');
      var isLog = ax.type === 'log';
      var hasArrayOption = false;
      var vpadLinearized = opts.vpadLinearized || false;
      var i, v, di, dmin, dmax, ppadiplus, ppadiminus, vmin, vmax;
  
      function makePadAccessor(item) {
          if(Array.isArray(item)) {
              hasArrayOption = true;
              return function(i) { return Math.max(Number(item[i]||0), 0); };
          } else {
              var v = Math.max(Number(item||0), 0);
              return function() { return v; };
          }
      }
  
      var ppadplus = makePadAccessor((ax._m > 0 ?
          opts.ppadplus : opts.ppadminus) || opts.ppad || 0);
      var ppadminus = makePadAccessor((ax._m > 0 ?
          opts.ppadminus : opts.ppadplus) || opts.ppad || 0);
      var vpadplus = makePadAccessor(opts.vpadplus || opts.vpad);
      var vpadminus = makePadAccessor(opts.vpadminus || opts.vpad);
  
      if(!hasArrayOption) {
          // with no arrays other than `data` we don't need to consider
          // every point, only the extreme data points
          vmin = Infinity;
          vmax = -Infinity;
  
          if(isLog) {
              for(i = 0; i < len; i++) {
                  v = data[i];
                  // data is not linearized yet so we still have to filter out negative logs
                  if(v < vmin && v > 0) vmin = v;
                  if(v > vmax && v < FP_SAFE) vmax = v;
              }
          } else {
              for(i = 0; i < len; i++) {
                  v = data[i];
                  if(v < vmin && v > -FP_SAFE) vmin = v;
                  if(v > vmax && v < FP_SAFE) vmax = v;
              }
          }
  
          data = [vmin, vmax];
          len = 2;
      }
  
      var collapseOpts = {tozero: tozero, extrapad: extrapad};
  
      function addItem(i) {
          di = data[i];
          if(!isNumeric(di)) return;
          ppadiplus = ppadplus(i);
          ppadiminus = ppadminus(i);
  
          if(vpadLinearized) {
              dmin = ax.c2l(di) - vpadminus(i);
              dmax = ax.c2l(di) + vpadplus(i);
          } else {
              vmin = di - vpadminus(i);
              vmax = di + vpadplus(i);
              // special case for log axes: if vpad makes this object span
              // more than an order of mag, clip it to one order. This is so
              // we don't have non-positive errors or absurdly large lower
              // range due to rounding errors
              if(isLog && vmin < vmax / 10) vmin = vmax / 10;
  
              dmin = ax.c2l(vmin);
              dmax = ax.c2l(vmax);
          }
  
          if(tozero) {
              dmin = Math.min(0, dmin);
              dmax = Math.max(0, dmax);
          }
          if(goodNumber(dmin)) {
              collapseMinArray(minArray, dmin, ppadiminus, collapseOpts);
          }
          if(goodNumber(dmax)) {
              collapseMaxArray(maxArray, dmax, ppadiplus, collapseOpts);
          }
      }
  
      // For efficiency covering monotonic or near-monotonic data,
      // check a few points at both ends first and then sweep
      // through the middle
      var iMax = Math.min(6, len);
      for(i = 0; i < iMax; i++) addItem(i);
      for(i = len - 1; i >= iMax; i--) addItem(i);
  
      return {
          min: minArray,
          max: maxArray,
          opts: opts
      };
  }
  
  function collapseMinArray(array, newVal, newPad, opts) {
      collapseArray(array, newVal, newPad, opts, lessOrEqual);
  }
  
  function collapseMaxArray(array, newVal, newPad, opts) {
      collapseArray(array, newVal, newPad, opts, greaterOrEqual);
  }
  
  /**
   * collapseArray
   *
   * Takes items from 'array' and compares them to 'newVal', 'newPad'.
   *
   * @param {array} array:
   *  current set of min or max extremes
   * @param {number} newVal:
   *  new value to compare against
   * @param {number} newPad:
   *  pad value associated with 'newVal'
   * @param {object} opts:
   *  - tozero {boolean}
   *  - extrapad {number}
   * @param {function} atLeastAsExtreme:
   *  comparison function, use
   *  - lessOrEqual for min 'array' and
   *  - greaterOrEqual for max 'array'
   *
   * In practice, 'array' is either
   *  - 'extremes[ax._id].min' or
   *  - 'extremes[ax._id].max
   *  found in traces and layout items that affect autorange.
   *
   * Since we don't yet know the relationship between pixels and values
   * (that's what we're trying to figure out!) AND we don't yet know how
   * many pixels `extrapad` represents (it's going to be 5% of the length,
   * but we don't want to have to redo calc just because length changed)
   * two point must satisfy three criteria simultaneously for one to supersede the other:
   *  - at least as extreme a `val`
   *  - at least as big a `pad`
   *  - an unpadded point cannot supersede a padded point, but any other combination can
   *
   * Then:
   * - If the item supersedes the new point, set includeThis false
   * - If the new pt supersedes the item, delete it from 'array'
   */
  function collapseArray(array, newVal, newPad, opts, atLeastAsExtreme) {
      var tozero = opts.tozero;
      var extrapad = opts.extrapad;
      var includeThis = true;
  
      for(var j = 0; j < array.length && includeThis; j++) {
          var v = array[j];
          if(atLeastAsExtreme(v.val, newVal) && v.pad >= newPad && (v.extrapad || !extrapad)) {
              includeThis = false;
              break;
          } else if(atLeastAsExtreme(newVal, v.val) && v.pad <= newPad && (extrapad || !v.extrapad)) {
              array.splice(j, 1);
              j--;
          }
      }
      if(includeThis) {
          var clipAtZero = (tozero && newVal === 0);
          array.push({
              val: newVal,
              pad: clipAtZero ? 0 : newPad,
              extrapad: clipAtZero ? false : extrapad
          });
      }
  }
  
  // In order to stop overflow errors, don't consider points
  // too close to the limits of js floating point
  function goodNumber(v) {
      return isNumeric(v) && Math.abs(v) < FP_SAFE;
  }
  
  function lessOrEqual(v0, v1) { return v0 <= v1; }
  function greaterOrEqual(v0, v1) { return v0 >= v1; }
  
  },{"../../constants/numerical":725,"../../lib":750,"../../registry":882,"fast-isnumeric":241}],799:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  var Plots = _dereq_('../../plots/plots');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var Titles = _dereq_('../../components/titles');
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  
  var axAttrs = _dereq_('./layout_attributes');
  var cleanTicks = _dereq_('./clean_ticks');
  
  var constants = _dereq_('../../constants/numerical');
  var ONEMAXYEAR = constants.ONEMAXYEAR;
  var ONEAVGYEAR = constants.ONEAVGYEAR;
  var ONEMINYEAR = constants.ONEMINYEAR;
  var ONEMAXQUARTER = constants.ONEMAXQUARTER;
  var ONEAVGQUARTER = constants.ONEAVGQUARTER;
  var ONEMINQUARTER = constants.ONEMINQUARTER;
  var ONEMAXMONTH = constants.ONEMAXMONTH;
  var ONEAVGMONTH = constants.ONEAVGMONTH;
  var ONEMINMONTH = constants.ONEMINMONTH;
  var ONEWEEK = constants.ONEWEEK;
  var ONEDAY = constants.ONEDAY;
  var HALFDAY = ONEDAY / 2;
  var ONEHOUR = constants.ONEHOUR;
  var ONEMIN = constants.ONEMIN;
  var ONESEC = constants.ONESEC;
  var MINUS_SIGN = constants.MINUS_SIGN;
  var BADNUM = constants.BADNUM;
  
  var alignmentConstants = _dereq_('../../constants/alignment');
  var MID_SHIFT = alignmentConstants.MID_SHIFT;
  var CAP_SHIFT = alignmentConstants.CAP_SHIFT;
  var LINE_SPACING = alignmentConstants.LINE_SPACING;
  var OPPOSITE_SIDE = alignmentConstants.OPPOSITE_SIDE;
  
  var axes = module.exports = {};
  
  axes.setConvert = _dereq_('./set_convert');
  var autoType = _dereq_('./axis_autotype');
  
  var axisIds = _dereq_('./axis_ids');
  axes.id2name = axisIds.id2name;
  axes.name2id = axisIds.name2id;
  axes.cleanId = axisIds.cleanId;
  axes.list = axisIds.list;
  axes.listIds = axisIds.listIds;
  axes.getFromId = axisIds.getFromId;
  axes.getFromTrace = axisIds.getFromTrace;
  
  var autorange = _dereq_('./autorange');
  axes.getAutoRange = autorange.getAutoRange;
  axes.findExtremes = autorange.findExtremes;
  
  var epsilon = 0.0001;
  function expandRange(range) {
      var delta = (range[1] - range[0]) * epsilon;
      return [
          range[0] - delta,
          range[1] + delta
      ];
  }
  
  /*
   * find the list of possible axes to reference with an xref or yref attribute
   * and coerce it to that list
   *
   * attr: the attribute we're generating a reference for. Should end in 'x' or 'y'
   *     but can be prefixed, like 'ax' for annotation's arrow x
   * dflt: the default to coerce to, or blank to use the first axis (falling back on
   *     extraOption if there is no axis)
   * extraOption: aside from existing axes with this letter, what non-axis value is allowed?
   *     Only required if it's different from `dflt`
   */
  axes.coerceRef = function(containerIn, containerOut, gd, attr, dflt, extraOption) {
      var axLetter = attr.charAt(attr.length - 1);
      var axlist = gd._fullLayout._subplots[axLetter + 'axis'];
      var refAttr = attr + 'ref';
      var attrDef = {};
  
      if(!dflt) dflt = axlist[0] || (typeof extraOption === 'string' ? extraOption : extraOption[0]);
      if(!extraOption) extraOption = dflt;
      axlist = axlist.concat(axlist.map(function(x) { return x + ' domain'; }));
  
      // data-ref annotations are not supported in gl2d yet
  
      attrDef[refAttr] = {
          valType: 'enumerated',
          values: axlist.concat(extraOption ?
              (typeof extraOption === 'string' ? [extraOption] : extraOption) :
              []),
          dflt: dflt
      };
  
      // xref, yref
      return Lib.coerce(containerIn, containerOut, attrDef, refAttr);
  };
  
  /*
   * Get the type of an axis reference. This can be 'range', 'domain', or 'paper'.
   * This assumes ar is a valid axis reference and returns 'range' if it doesn't
   * match the patterns for 'paper' or 'domain'.
   *
   * ar: the axis reference string
   *
   */
  axes.getRefType = function(ar) {
      if(ar === undefined) { return ar; }
      if(ar === 'paper') { return 'paper'; }
      if(ar === 'pixel') { return 'pixel'; }
      if(/( domain)$/.test(ar)) { return 'domain'; } else { return 'range'; }
  };
  
  /*
   * coerce position attributes (range-type) that can be either on axes or absolute
   * (paper or pixel) referenced. The biggest complication here is that we don't know
   * before looking at the axis whether the value must be a number or not (it may be
   * a date string), so we can't use the regular valType='number' machinery
   *
   * axRef (string): the axis this position is referenced to, or:
   *     paper: fraction of the plot area
   *     pixel: pixels relative to some starting position
   * attr (string): the attribute in containerOut we are coercing
   * dflt (number): the default position, as a fraction or pixels. If the attribute
   *     is to be axis-referenced, this will be converted to an axis data value
   *
   * Also cleans the values, since the attribute definition itself has to say
   * valType: 'any' to handle date axes. This allows us to accept:
   * - for category axes: category names, and convert them here into serial numbers.
   *   Note that this will NOT work for axis range endpoints, because we don't know
   *   the category list yet (it's set by ax.makeCalcdata during calc)
   *   but it works for component (note, shape, images) positions.
   * - for date axes: JS Dates or milliseconds, and convert to date strings
   * - for other types: coerce them to numbers
   */
  axes.coercePosition = function(containerOut, gd, coerce, axRef, attr, dflt) {
      var cleanPos, pos;
      var axRefType = axes.getRefType(axRef);
      if(axRefType !== 'range') {
          cleanPos = Lib.ensureNumber;
          pos = coerce(attr, dflt);
      } else {
          var ax = axes.getFromId(gd, axRef);
          dflt = ax.fraction2r(dflt);
          pos = coerce(attr, dflt);
          cleanPos = ax.cleanPos;
      }
      containerOut[attr] = cleanPos(pos);
  };
  
  axes.cleanPosition = function(pos, gd, axRef) {
      var cleanPos = (axRef === 'paper' || axRef === 'pixel') ?
          Lib.ensureNumber :
          axes.getFromId(gd, axRef).cleanPos;
  
      return cleanPos(pos);
  };
  
  axes.redrawComponents = function(gd, axIds) {
      axIds = axIds ? axIds : axes.listIds(gd);
  
      var fullLayout = gd._fullLayout;
  
      function _redrawOneComp(moduleName, methodName, stashName, shortCircuit) {
          var method = Registry.getComponentMethod(moduleName, methodName);
          var stash = {};
  
          for(var i = 0; i < axIds.length; i++) {
              var ax = fullLayout[axes.id2name(axIds[i])];
              var indices = ax[stashName];
  
              for(var j = 0; j < indices.length; j++) {
                  var ind = indices[j];
  
                  if(!stash[ind]) {
                      method(gd, ind);
                      stash[ind] = 1;
                      // once is enough for images (which doesn't use the `i` arg anyway)
                      if(shortCircuit) return;
                  }
              }
          }
      }
  
      // annotations and shapes 'draw' method is slow,
      // use the finer-grained 'drawOne' method instead
      _redrawOneComp('annotations', 'drawOne', '_annIndices');
      _redrawOneComp('shapes', 'drawOne', '_shapeIndices');
      _redrawOneComp('images', 'draw', '_imgIndices', true);
  };
  
  var getDataConversions = axes.getDataConversions = function(gd, trace, target, targetArray) {
      var ax;
  
      // If target points to an axis, use the type we already have for that
      // axis to find the data type. Otherwise use the values to autotype.
      var d2cTarget = (target === 'x' || target === 'y' || target === 'z') ?
          target :
          targetArray;
  
      // In the case of an array target, make a mock data array
      // and call supplyDefaults to the data type and
      // setup the data-to-calc method.
      if(Array.isArray(d2cTarget)) {
          ax = {
              type: autoType(targetArray),
              _categories: []
          };
          axes.setConvert(ax);
  
          // build up ax._categories (usually done during ax.makeCalcdata()
          if(ax.type === 'category') {
              for(var i = 0; i < targetArray.length; i++) {
                  ax.d2c(targetArray[i]);
              }
          }
          // TODO what to do for transforms?
      } else {
          ax = axes.getFromTrace(gd, trace, d2cTarget);
      }
  
      // if 'target' has corresponding axis
      // -> use setConvert method
      if(ax) return {d2c: ax.d2c, c2d: ax.c2d};
  
      // special case for 'ids'
      // -> cast to String
      if(d2cTarget === 'ids') return {d2c: toString, c2d: toString};
  
      // otherwise (e.g. numeric-array of 'marker.color' or 'marker.size')
      // -> cast to Number
  
      return {d2c: toNum, c2d: toNum};
  };
  
  function toNum(v) { return +v; }
  function toString(v) { return String(v); }
  
  axes.getDataToCoordFunc = function(gd, trace, target, targetArray) {
      return getDataConversions(gd, trace, target, targetArray).d2c;
  };
  
  // get counteraxis letter for this axis (name or id)
  // this can also be used as the id for default counter axis
  axes.counterLetter = function(id) {
      var axLetter = id.charAt(0);
      if(axLetter === 'x') return 'y';
      if(axLetter === 'y') return 'x';
  };
  
  // incorporate a new minimum difference and first tick into
  // forced
  // note that _forceTick0 is linearized, so needs to be turned into
  // a range value for setting tick0
  axes.minDtick = function(ax, newDiff, newFirst, allow) {
      // doesn't make sense to do forced min dTick on log or category axes,
      // and the plot itself may decide to cancel (ie non-grouped bars)
      if(['log', 'category', 'multicategory'].indexOf(ax.type) !== -1 || !allow) {
          ax._minDtick = 0;
      } else if(ax._minDtick === undefined) {
          // undefined means there's nothing there yet
  
          ax._minDtick = newDiff;
          ax._forceTick0 = newFirst;
      } else if(ax._minDtick) {
          if((ax._minDtick / newDiff + 1e-6) % 1 < 2e-6 &&
              // existing minDtick is an integer multiple of newDiff
              // (within rounding err)
              // and forceTick0 can be shifted to newFirst
  
                  (((newFirst - ax._forceTick0) / newDiff % 1) +
                      1.000001) % 1 < 2e-6) {
              ax._minDtick = newDiff;
              ax._forceTick0 = newFirst;
          } else if((newDiff / ax._minDtick + 1e-6) % 1 > 2e-6 ||
              // if the converse is true (newDiff is a multiple of minDtick and
              // newFirst can be shifted to forceTick0) then do nothing - same
              // forcing stands. Otherwise, cancel forced minimum
  
                  (((newFirst - ax._forceTick0) / ax._minDtick % 1) +
                      1.000001) % 1 > 2e-6) {
              ax._minDtick = 0;
          }
      }
  };
  
  // save a copy of the initial axis ranges in fullLayout
  // use them in mode bar and dblclick events
  axes.saveRangeInitial = function(gd, overwrite) {
      var axList = axes.list(gd, '', true);
      var hasOneAxisChanged = false;
  
      for(var i = 0; i < axList.length; i++) {
          var ax = axList[i];
          var isNew = (ax._rangeInitial === undefined);
          var hasChanged = isNew || !(
              ax.range[0] === ax._rangeInitial[0] &&
              ax.range[1] === ax._rangeInitial[1]
          );
  
          if((isNew && ax.autorange === false) || (overwrite && hasChanged)) {
              ax._rangeInitial = ax.range.slice();
              hasOneAxisChanged = true;
          }
      }
  
      return hasOneAxisChanged;
  };
  
  // save a copy of the initial spike visibility
  axes.saveShowSpikeInitial = function(gd, overwrite) {
      var axList = axes.list(gd, '', true);
      var hasOneAxisChanged = false;
      var allSpikesEnabled = 'on';
  
      for(var i = 0; i < axList.length; i++) {
          var ax = axList[i];
          var isNew = (ax._showSpikeInitial === undefined);
          var hasChanged = isNew || !(ax.showspikes === ax._showspikes);
  
          if(isNew || (overwrite && hasChanged)) {
              ax._showSpikeInitial = ax.showspikes;
              hasOneAxisChanged = true;
          }
  
          if(allSpikesEnabled === 'on' && !ax.showspikes) {
              allSpikesEnabled = 'off';
          }
      }
      gd._fullLayout._cartesianSpikesEnabled = allSpikesEnabled;
      return hasOneAxisChanged;
  };
  
  axes.autoBin = function(data, ax, nbins, is2d, calendar, size) {
      var dataMin = Lib.aggNums(Math.min, null, data);
      var dataMax = Lib.aggNums(Math.max, null, data);
  
      if(ax.type === 'category' || ax.type === 'multicategory') {
          return {
              start: dataMin - 0.5,
              end: dataMax + 0.5,
              size: Math.max(1, Math.round(size) || 1),
              _dataSpan: dataMax - dataMin,
          };
      }
  
      if(!calendar) calendar = ax.calendar;
  
      // piggyback off tick code to make "nice" bin sizes and edges
      var dummyAx;
      if(ax.type === 'log') {
          dummyAx = {
              type: 'linear',
              range: [dataMin, dataMax]
          };
      } else {
          dummyAx = {
              type: ax.type,
              range: Lib.simpleMap([dataMin, dataMax], ax.c2r, 0, calendar),
              calendar: calendar
          };
      }
      axes.setConvert(dummyAx);
  
      size = size && cleanTicks.dtick(size, dummyAx.type);
  
      if(size) {
          dummyAx.dtick = size;
          dummyAx.tick0 = cleanTicks.tick0(undefined, dummyAx.type, calendar);
      } else {
          var size0;
          if(nbins) size0 = ((dataMax - dataMin) / nbins);
          else {
              // totally auto: scale off std deviation so the highest bin is
              // somewhat taller than the total number of bins, but don't let
              // the size get smaller than the 'nice' rounded down minimum
              // difference between values
              var distinctData = Lib.distinctVals(data);
              var msexp = Math.pow(10, Math.floor(
                  Math.log(distinctData.minDiff) / Math.LN10));
              var minSize = msexp * Lib.roundUp(
                  distinctData.minDiff / msexp, [0.9, 1.9, 4.9, 9.9], true);
              size0 = Math.max(minSize, 2 * Lib.stdev(data) /
                  Math.pow(data.length, is2d ? 0.25 : 0.4));
  
              // fallback if ax.d2c output BADNUMs
              // e.g. when user try to plot categorical bins
              // on a layout.xaxis.type: 'linear'
              if(!isNumeric(size0)) size0 = 1;
          }
  
          axes.autoTicks(dummyAx, size0);
      }
  
      var finalSize = dummyAx.dtick;
      var binStart = axes.tickIncrement(
              axes.tickFirst(dummyAx), finalSize, 'reverse', calendar);
      var binEnd, bincount;
  
      // check for too many data points right at the edges of bins
      // (>50% within 1% of bin edges) or all data points integral
      // and offset the bins accordingly
      if(typeof finalSize === 'number') {
          binStart = autoShiftNumericBins(binStart, data, dummyAx, dataMin, dataMax);
  
          bincount = 1 + Math.floor((dataMax - binStart) / finalSize);
          binEnd = binStart + bincount * finalSize;
      } else {
          // month ticks - should be the only nonlinear kind we have at this point.
          // dtick (as supplied by axes.autoTick) only has nonlinear values on
          // date and log axes, but even if you display a histogram on a log axis
          // we bin it on a linear axis (which one could argue against, but that's
          // a separate issue)
          if(dummyAx.dtick.charAt(0) === 'M') {
              binStart = autoShiftMonthBins(binStart, data, finalSize, dataMin, calendar);
          }
  
          // calculate the endpoint for nonlinear ticks - you have to
          // just increment until you're done
          binEnd = binStart;
          bincount = 0;
          while(binEnd <= dataMax) {
              binEnd = axes.tickIncrement(binEnd, finalSize, false, calendar);
              bincount++;
          }
      }
  
      return {
          start: ax.c2r(binStart, 0, calendar),
          end: ax.c2r(binEnd, 0, calendar),
          size: finalSize,
          _dataSpan: dataMax - dataMin
      };
  };
  
  
  function autoShiftNumericBins(binStart, data, ax, dataMin, dataMax) {
      var edgecount = 0;
      var midcount = 0;
      var intcount = 0;
      var blankCount = 0;
  
      function nearEdge(v) {
          // is a value within 1% of a bin edge?
          return (1 + (v - binStart) * 100 / ax.dtick) % 100 < 2;
      }
  
      for(var i = 0; i < data.length; i++) {
          if(data[i] % 1 === 0) intcount++;
          else if(!isNumeric(data[i])) blankCount++;
  
          if(nearEdge(data[i])) edgecount++;
          if(nearEdge(data[i] + ax.dtick / 2)) midcount++;
      }
      var dataCount = data.length - blankCount;
  
      if(intcount === dataCount && ax.type !== 'date') {
          if(ax.dtick < 1) {
              // all integers: if bin size is <1, it's because
              // that was specifically requested (large nbins)
              // so respect that... but center the bins containing
              // integers on those integers
  
              binStart = dataMin - 0.5 * ax.dtick;
          } else {
              // otherwise start half an integer down regardless of
              // the bin size, just enough to clear up endpoint
              // ambiguity about which integers are in which bins.
  
              binStart -= 0.5;
              if(binStart + ax.dtick < dataMin) binStart += ax.dtick;
          }
      } else if(midcount < dataCount * 0.1) {
          if(edgecount > dataCount * 0.3 ||
                  nearEdge(dataMin) || nearEdge(dataMax)) {
              // lots of points at the edge, not many in the middle
              // shift half a bin
              var binshift = ax.dtick / 2;
              binStart += (binStart + binshift < dataMin) ? binshift : -binshift;
          }
      }
      return binStart;
  }
  
  
  function autoShiftMonthBins(binStart, data, dtick, dataMin, calendar) {
      var stats = Lib.findExactDates(data, calendar);
      // number of data points that needs to be an exact value
      // to shift that increment to (near) the bin center
      var threshold = 0.8;
  
      if(stats.exactDays > threshold) {
          var numMonths = Number(dtick.substr(1));
  
          if((stats.exactYears > threshold) && (numMonths % 12 === 0)) {
              // The exact middle of a non-leap-year is 1.5 days into July
              // so if we start the bins here, all but leap years will
              // get hover-labeled as exact years.
              binStart = axes.tickIncrement(binStart, 'M6', 'reverse') + ONEDAY * 1.5;
          } else if(stats.exactMonths > threshold) {
              // Months are not as clean, but if we shift half the *longest*
              // month (31/2 days) then 31-day months will get labeled exactly
              // and shorter months will get labeled with the correct month
              // but shifted 12-36 hours into it.
              binStart = axes.tickIncrement(binStart, 'M1', 'reverse') + ONEDAY * 15.5;
          } else {
              // Shifting half a day is exact, but since these are month bins it
              // will always give a somewhat odd-looking label, until we do something
              // smarter like showing the bin boundaries (or the bounds of the actual
              // data in each bin)
              binStart -= HALFDAY;
          }
          var nextBinStart = axes.tickIncrement(binStart, dtick);
  
          if(nextBinStart <= dataMin) return nextBinStart;
      }
      return binStart;
  }
  
  // ----------------------------------------------------
  // Ticks and grids
  // ----------------------------------------------------
  
  // ensure we have tick0, dtick, and tick rounding calculated
  axes.prepTicks = function(ax, opts) {
      var rng = Lib.simpleMap(ax.range, ax.r2l, undefined, undefined, opts);
  
      ax._dtickInit = ax.dtick;
      ax._tick0Init = ax.tick0;
  
      // calculate max number of (auto) ticks to display based on plot size
      if(ax.tickmode === 'auto' || !ax.dtick) {
          var nt = ax.nticks;
          var minPx;
  
          if(!nt) {
              if(ax.type === 'category' || ax.type === 'multicategory') {
                  minPx = ax.tickfont ? (ax.tickfont.size || 12) * 1.2 : 15;
                  nt = ax._length / minPx;
              } else {
                  minPx = ax._id.charAt(0) === 'y' ? 40 : 80;
                  nt = Lib.constrain(ax._length / minPx, 4, 9) + 1;
              }
  
              // radial axes span half their domain,
              // multiply nticks value by two to get correct number of auto ticks.
              if(ax._name === 'radialaxis') nt *= 2;
          }
  
          // add a couple of extra digits for filling in ticks when we
          // have explicit tickvals without tick text
          if(ax.tickmode === 'array') nt *= 100;
  
  
          ax._roughDTick = Math.abs(rng[1] - rng[0]) / nt;
          axes.autoTicks(ax, ax._roughDTick);
  
          // check for a forced minimum dtick
          if(ax._minDtick > 0 && ax.dtick < ax._minDtick * 2) {
              ax.dtick = ax._minDtick;
              ax.tick0 = ax.l2r(ax._forceTick0);
          }
      }
  
      if(ax.ticklabelmode === 'period') {
          adjustPeriodDelta(ax);
      }
  
      // check for missing tick0
      if(!ax.tick0) {
          ax.tick0 = (ax.type === 'date') ? '2000-01-01' : 0;
      }
  
      // ensure we don't try to make ticks below our minimum precision
      // see https://github.com/plotly/plotly.js/issues/2892
      if(ax.type === 'date' && ax.dtick < 0.1) ax.dtick = 0.1;
  
      // now figure out rounding of tick values
      autoTickRound(ax);
  };
  
  function nMonths(dtick) {
      return +(dtick.substring(1));
  }
  
  function adjustPeriodDelta(ax) { // adjusts ax.dtick and sets ax._definedDelta
      var definedDelta;
  
      function mDate() {
          return !(
              isNumeric(ax.dtick) ||
              ax.dtick.charAt(0) !== 'M'
          );
      }
      var isMDate = mDate();
      var tickformat = axes.getTickFormat(ax);
      if(tickformat) {
          var noDtick = ax._dtickInit !== ax.dtick;
          if(
              !(/%[fLQsSMX]/.test(tickformat))
              // %f: microseconds as a decimal number [000000, 999999]
              // %L: milliseconds as a decimal number [000, 999]
              // %Q: milliseconds since UNIX epoch
              // %s: seconds since UNIX epoch
              // %S: second as a decimal number [00,61]
              // %M: minute as a decimal number [00,59]
              // %X: the locale’s time, such as %-I:%M:%S %p
          ) {
              if(
                  /%[HI]/.test(tickformat)
                  // %H: hour (24-hour clock) as a decimal number [00,23]
                  // %I: hour (12-hour clock) as a decimal number [01,12]
              ) {
                  definedDelta = ONEHOUR;
                  if(noDtick && !isMDate && ax.dtick < ONEHOUR) ax.dtick = ONEHOUR;
              } else if(
                  /%p/.test(tickformat) // %p: either AM or PM
              ) {
                  definedDelta = HALFDAY;
                  if(noDtick && !isMDate && ax.dtick < HALFDAY) ax.dtick = HALFDAY;
              } else if(
                  /%[Aadejuwx]/.test(tickformat)
                  // %A: full weekday name
                  // %a: abbreviated weekday name
                  // %d: zero-padded day of the month as a decimal number [01,31]
                  // %e: space-padded day of the month as a decimal number [ 1,31]
                  // %j: day of the year as a decimal number [001,366]
                  // %u: Monday-based (ISO 8601) weekday as a decimal number [1,7]
                  // %w: Sunday-based weekday as a decimal number [0,6]
                  // %x: the locale’s date, such as %-m/%-d/%Y
              ) {
                  definedDelta = ONEDAY;
                  if(noDtick && !isMDate && ax.dtick < ONEDAY) ax.dtick = ONEDAY;
              } else if(
                  /%[UVW]/.test(tickformat)
                  // %U: Sunday-based week of the year as a decimal number [00,53]
                  // %V: ISO 8601 week of the year as a decimal number [01, 53]
                  // %W: Monday-based week of the year as a decimal number [00,53]
              ) {
                  definedDelta = ONEWEEK;
                  if(noDtick && !isMDate && ax.dtick < ONEWEEK) ax.dtick = ONEWEEK;
              } else if(
                  /%[Bbm]/.test(tickformat)
                  // %B: full month name
                  // %b: abbreviated month name
                  // %m: month as a decimal number [01,12]
              ) {
                  definedDelta = ONEAVGMONTH;
                  if(noDtick && (
                      isMDate ? nMonths(ax.dtick) < 1 : ax.dtick < ONEMINMONTH)
                  ) ax.dtick = 'M1';
              } else if(
                  /%[q]/.test(tickformat)
                  // %q: quarter of the year as a decimal number [1,4]
              ) {
                  definedDelta = ONEAVGQUARTER;
                  if(noDtick && (
                      isMDate ? nMonths(ax.dtick) < 3 : ax.dtick < ONEMINQUARTER)
                  ) ax.dtick = 'M3';
              } else if(
                  /%[Yy]/.test(tickformat)
                  // %Y: year with century as a decimal number, such as 1999
                  // %y: year without century as a decimal number [00,99]
              ) {
                  definedDelta = ONEAVGYEAR;
                  if(noDtick && (
                      isMDate ? nMonths(ax.dtick) < 12 : ax.dtick < ONEMINYEAR)
                  ) ax.dtick = 'M12';
              }
          }
      }
  
      isMDate = mDate();
      if(isMDate && ax.tick0 === ax._dowTick0) {
          // discard Sunday/Monday tweaks
          ax.tick0 = ax._rawTick0;
      }
  
      ax._definedDelta = definedDelta;
  }
  
  function positionPeriodTicks(tickVals, ax, definedDelta) {
      for(var i = 0; i < tickVals.length; i++) {
          var v = tickVals[i].value;
  
          var a = i;
          var b = i + 1;
          if(i < tickVals.length - 1) {
              a = i;
              b = i + 1;
          } else if(i > 0) {
              a = i - 1;
              b = i;
          } else {
              a = i;
              b = i;
          }
  
          var A = tickVals[a].value;
          var B = tickVals[b].value;
          var actualDelta = Math.abs(B - A);
          var delta = definedDelta || actualDelta;
          var periodLength = 0;
  
          if(delta >= ONEMINYEAR) {
              if(actualDelta >= ONEMINYEAR && actualDelta <= ONEMAXYEAR) {
                  periodLength = actualDelta;
              } else {
                  periodLength = ONEAVGYEAR;
              }
          } else if(definedDelta === ONEAVGQUARTER && delta >= ONEMINQUARTER) {
              if(actualDelta >= ONEMINQUARTER && actualDelta <= ONEMAXQUARTER) {
                  periodLength = actualDelta;
              } else {
                  periodLength = ONEAVGQUARTER;
              }
          } else if(delta >= ONEMINMONTH) {
              if(actualDelta >= ONEMINMONTH && actualDelta <= ONEMAXMONTH) {
                  periodLength = actualDelta;
              } else {
                  periodLength = ONEAVGMONTH;
              }
          } else if(definedDelta === ONEWEEK && delta >= ONEWEEK) {
              periodLength = ONEWEEK;
          } else if(delta >= ONEDAY) {
              periodLength = ONEDAY;
          } else if(definedDelta === HALFDAY && delta >= HALFDAY) {
              periodLength = HALFDAY;
          } else if(definedDelta === ONEHOUR && delta >= ONEHOUR) {
              periodLength = ONEHOUR;
          }
  
          var inBetween;
          if(periodLength >= actualDelta) {
              // ensure new label positions remain between ticks
              periodLength = actualDelta;
              inBetween = true;
          }
  
          var endPeriod = v + periodLength;
          if(ax.rangebreaks && periodLength > 0) {
              var nAll = 84; // highly divisible 7 * 12
              var n = 0;
              for(var c = 0; c < nAll; c++) {
                  var r = (c + 0.5) / nAll;
                  if(ax.maskBreaks(v * (1 - r) + r * endPeriod) !== BADNUM) n++;
              }
              periodLength *= n / nAll;
  
              if(!periodLength) {
                  tickVals[i].drop = true;
              }
  
              if(inBetween && actualDelta > ONEWEEK) periodLength = actualDelta; // center monthly & longer periods
          }
  
          if(
              periodLength > 0 || // not instant
              i === 0 // taking care first tick added
          ) {
              tickVals[i].periodX = v + periodLength / 2;
          }
      }
  }
  
  // calculate the ticks: text, values, positioning
  // if ticks are set to automatic, determine the right values (tick0,dtick)
  // in any case, set tickround to # of digits to round tick labels to,
  // or codes to this effect for log and date scales
  axes.calcTicks = function calcTicks(ax, opts) {
      axes.prepTicks(ax, opts);
      var rng = Lib.simpleMap(ax.range, ax.r2l, undefined, undefined, opts);
  
      // now that we've figured out the auto values for formatting
      // in case we're missing some ticktext, we can break out for array ticks
      if(ax.tickmode === 'array') return arrayTicks(ax);
  
      // add a tiny bit so we get ticks which may have rounded out
      var exRng = expandRange(rng);
      var startTick = exRng[0];
      var endTick = exRng[1];
      // check for reversed axis
      var axrev = (rng[1] < rng[0]);
      var minRange = Math.min(rng[0], rng[1]);
      var maxRange = Math.max(rng[0], rng[1]);
  
      var isDLog = (ax.type === 'log') && !(isNumeric(ax.dtick) || ax.dtick.charAt(0) === 'L');
      var isPeriod = ax.ticklabelmode === 'period';
  
      // find the first tick
      ax._tmin = axes.tickFirst(ax, opts);
  
      // No visible ticks? Quit.
      // I've only seen this on category axes with all categories off the edge.
      if((ax._tmin < startTick) !== axrev) return [];
  
      // return the full set of tick vals
      if(ax.type === 'category' || ax.type === 'multicategory') {
          endTick = (axrev) ? Math.max(-0.5, endTick) :
              Math.min(ax._categories.length - 0.5, endTick);
      }
  
      var x = ax._tmin;
  
      if(ax.rangebreaks && ax._tick0Init !== ax.tick0) {
          // adjust tick0
          x = moveOutsideBreak(x, ax);
          if(!axrev) {
              x = axes.tickIncrement(x, ax.dtick, !axrev, ax.calendar);
          }
      }
  
      if(isPeriod) {
          // add one item to label period before tick0
          x = axes.tickIncrement(x, ax.dtick, !axrev, ax.calendar);
      }
  
      var maxTicks = Math.max(1000, ax._length || 0);
      var tickVals = [];
      var xPrevious = null;
      for(;
          (axrev) ? (x >= endTick) : (x <= endTick);
          x = axes.tickIncrement(x, ax.dtick, axrev, ax.calendar)
      ) {
          if(ax.rangebreaks) {
              if(!axrev) {
                  if(x < startTick) continue;
                  if(ax.maskBreaks(x) === BADNUM && moveOutsideBreak(x, ax) >= maxRange) break;
              }
          }
  
          // prevent infinite loops - no more than one tick per pixel,
          // and make sure each value is different from the previous
          if(tickVals.length > maxTicks || x === xPrevious) break;
          xPrevious = x;
  
          var minor = false;
          if(isDLog && (x !== (x | 0))) {
              minor = true;
          }
  
          tickVals.push({
              minor: minor,
              value: x
          });
      }
  
      if(isPeriod) positionPeriodTicks(tickVals, ax, ax._definedDelta);
  
      var i;
      if(ax.rangebreaks) {
          var flip = ax._id.charAt(0) === 'y';
  
          var fontSize = 1; // one pixel minimum
          if(ax.tickmode === 'auto') {
              fontSize = ax.tickfont ? ax.tickfont.size : 12;
          }
  
          var prevL = NaN;
          for(i = tickVals.length - 1; i > -1; i--) {
              if(tickVals[i].drop) {
                  tickVals.splice(i, 1);
                  continue;
              }
  
              tickVals[i].value = moveOutsideBreak(tickVals[i].value, ax);
  
              // avoid overlaps
              var l = ax.c2p(tickVals[i].value);
              if(flip ?
                  (prevL > l - fontSize) :
                  (prevL < l + fontSize)
              ) { // ensure one pixel minimum
                  tickVals.splice(axrev ? i + 1 : i, 1);
              } else {
                  prevL = l;
              }
          }
      }
  
      // If same angle over a full circle, the last tick vals is a duplicate.
      // TODO must do something similar for angular date axes.
      if(isAngular(ax) && Math.abs(rng[1] - rng[0]) === 360) {
          tickVals.pop();
      }
  
      // save the last tick as well as first, so we can
      // show the exponent only on the last one
      ax._tmax = (tickVals[tickVals.length - 1] || {}).value;
  
      // for showing the rest of a date when the main tick label is only the
      // latter part: ax._prevDateHead holds what we showed most recently.
      // Start with it cleared and mark that we're in calcTicks (ie calculating a
      // whole string of these so we should care what the previous date head was!)
      ax._prevDateHead = '';
      ax._inCalcTicks = true;
  
      var ticksOut = [];
      var t, p;
      for(i = 0; i < tickVals.length; i++) {
          var _minor = tickVals[i].minor;
          var _value = tickVals[i].value;
  
          t = axes.tickText(
              ax,
              _value,
              false, // hover
              _minor // noSuffixPrefix
          );
  
          p = tickVals[i].periodX;
          if(p !== undefined) {
              t.periodX = p;
              if(p > maxRange || p < minRange) { // hide label if outside the range
                  if(p > maxRange) t.periodX = maxRange;
                  if(p < minRange) t.periodX = minRange;
  
                  t.text = ' '; // don't use an empty string here which can confuse automargin (issue 5132)
                  ax._prevDateHead = '';
              }
          }
  
          ticksOut.push(t);
      }
  
      ax._inCalcTicks = false;
  
      return ticksOut;
  };
  
  function arrayTicks(ax) {
      var vals = ax.tickvals;
      var text = ax.ticktext;
      var ticksOut = new Array(vals.length);
      var rng = Lib.simpleMap(ax.range, ax.r2l);
      var exRng = expandRange(rng);
      var tickMin = Math.min(exRng[0], exRng[1]);
      var tickMax = Math.max(exRng[0], exRng[1]);
      var j = 0;
  
      // without a text array, just format the given values as any other ticks
      // except with more precision to the numbers
      if(!Array.isArray(text)) text = [];
  
      // make sure showing ticks doesn't accidentally add new categories
      // TODO multicategory, if we allow ticktext / tickvals
      var tickVal2l = ax.type === 'category' ? ax.d2l_noadd : ax.d2l;
  
      // array ticks on log axes always show the full number
      // (if no explicit ticktext overrides it)
      if(ax.type === 'log' && String(ax.dtick).charAt(0) !== 'L') {
          ax.dtick = 'L' + Math.pow(10, Math.floor(Math.min(ax.range[0], ax.range[1])) - 1);
      }
  
      for(var i = 0; i < vals.length; i++) {
          var vali = tickVal2l(vals[i]);
          if(vali > tickMin && vali < tickMax) {
              if(text[i] === undefined) ticksOut[j] = axes.tickText(ax, vali);
              else ticksOut[j] = tickTextObj(ax, vali, String(text[i]));
              j++;
          }
      }
  
      if(j < vals.length) ticksOut.splice(j, vals.length - j);
  
      if(ax.rangebreaks) {
          // remove ticks falling inside rangebreaks
          ticksOut = ticksOut.filter(function(d) {
              return ax.maskBreaks(d.x) !== BADNUM;
          });
      }
  
      return ticksOut;
  }
  
  var roundBase10 = [2, 5, 10];
  var roundBase24 = [1, 2, 3, 6, 12];
  var roundBase60 = [1, 2, 5, 10, 15, 30];
  // 2&3 day ticks are weird, but need something btwn 1&7
  var roundDays = [1, 2, 3, 7, 14];
  // approx. tick positions for log axes, showing all (1) and just 1, 2, 5 (2)
  // these don't have to be exact, just close enough to round to the right value
  var roundLog1 = [-0.046, 0, 0.301, 0.477, 0.602, 0.699, 0.778, 0.845, 0.903, 0.954, 1];
  var roundLog2 = [-0.301, 0, 0.301, 0.699, 1];
  // N.B. `thetaunit; 'radians' angular axes must be converted to degrees
  var roundAngles = [15, 30, 45, 90, 180];
  
  function roundDTick(roughDTick, base, roundingSet) {
      return base * Lib.roundUp(roughDTick / base, roundingSet);
  }
  
  // autoTicks: calculate best guess at pleasant ticks for this axis
  // inputs:
  //      ax - an axis object
  //      roughDTick - rough tick spacing (to be turned into a nice round number)
  // outputs (into ax):
  //   tick0: starting point for ticks (not necessarily on the graph)
  //      usually 0 for numeric (=10^0=1 for log) or jan 1, 2000 for dates
  //   dtick: the actual, nice round tick spacing, usually a little larger than roughDTick
  //      if the ticks are spaced linearly (linear scale, categories,
  //          log with only full powers, date ticks < month),
  //          this will just be a number
  //      months: M#
  //      years: M# where # is 12*number of years
  //      log with linear ticks: L# where # is the linear tick spacing
  //      log showing powers plus some intermediates:
  //          D1 shows all digits, D2 shows 2 and 5
  axes.autoTicks = function(ax, roughDTick) {
      var base;
  
      function getBase(v) {
          return Math.pow(v, Math.floor(Math.log(roughDTick) / Math.LN10));
      }
  
      if(ax.type === 'date') {
          ax.tick0 = Lib.dateTick0(ax.calendar, 0);
  
          // the criteria below are all based on the rough spacing we calculate
          // being > half of the final unit - so precalculate twice the rough val
          var roughX2 = 2 * roughDTick;
  
          if(roughX2 > ONEAVGYEAR) {
              roughDTick /= ONEAVGYEAR;
              base = getBase(10);
              ax.dtick = 'M' + (12 * roundDTick(roughDTick, base, roundBase10));
          } else if(roughX2 > ONEAVGMONTH) {
              roughDTick /= ONEAVGMONTH;
              ax.dtick = 'M' + roundDTick(roughDTick, 1, roundBase24);
          } else if(roughX2 > ONEDAY) {
              ax.dtick = roundDTick(roughDTick, ONEDAY, ax._hasDayOfWeekBreaks ? [1, 2, 7, 14] : roundDays);
              // get week ticks on sunday
              // this will also move the base tick off 2000-01-01 if dtick is
              // 2 or 3 days... but that's a weird enough case that we'll ignore it.
              var tickformat = axes.getTickFormat(ax);
              var isPeriod = ax.ticklabelmode === 'period';
              if(isPeriod) ax._rawTick0 = ax.tick0;
  
              if(/%[uVW]/.test(tickformat)) {
                  ax.tick0 = Lib.dateTick0(ax.calendar, 2); // Monday
              } else {
                  ax.tick0 = Lib.dateTick0(ax.calendar, 1); // Sunday
              }
  
              if(isPeriod) ax._dowTick0 = ax.tick0;
          } else if(roughX2 > ONEHOUR) {
              ax.dtick = roundDTick(roughDTick, ONEHOUR, roundBase24);
          } else if(roughX2 > ONEMIN) {
              ax.dtick = roundDTick(roughDTick, ONEMIN, roundBase60);
          } else if(roughX2 > ONESEC) {
              ax.dtick = roundDTick(roughDTick, ONESEC, roundBase60);
          } else {
              // milliseconds
              base = getBase(10);
              ax.dtick = roundDTick(roughDTick, base, roundBase10);
          }
      } else if(ax.type === 'log') {
          ax.tick0 = 0;
          var rng = Lib.simpleMap(ax.range, ax.r2l);
  
          if(roughDTick > 0.7) {
              // only show powers of 10
              ax.dtick = Math.ceil(roughDTick);
          } else if(Math.abs(rng[1] - rng[0]) < 1) {
              // span is less than one power of 10
              var nt = 1.5 * Math.abs((rng[1] - rng[0]) / roughDTick);
  
              // ticks on a linear scale, labeled fully
              roughDTick = Math.abs(Math.pow(10, rng[1]) -
                  Math.pow(10, rng[0])) / nt;
              base = getBase(10);
              ax.dtick = 'L' + roundDTick(roughDTick, base, roundBase10);
          } else {
              // include intermediates between powers of 10,
              // labeled with small digits
              // ax.dtick = "D2" (show 2 and 5) or "D1" (show all digits)
              ax.dtick = (roughDTick > 0.3) ? 'D2' : 'D1';
          }
      } else if(ax.type === 'category' || ax.type === 'multicategory') {
          ax.tick0 = 0;
          ax.dtick = Math.ceil(Math.max(roughDTick, 1));
      } else if(isAngular(ax)) {
          ax.tick0 = 0;
          base = 1;
          ax.dtick = roundDTick(roughDTick, base, roundAngles);
      } else {
          // auto ticks always start at 0
          ax.tick0 = 0;
          base = getBase(10);
          ax.dtick = roundDTick(roughDTick, base, roundBase10);
      }
  
      // prevent infinite loops
      if(ax.dtick === 0) ax.dtick = 1;
  
      // TODO: this is from log axis histograms with autorange off
      if(!isNumeric(ax.dtick) && typeof ax.dtick !== 'string') {
          var olddtick = ax.dtick;
          ax.dtick = 1;
          throw 'ax.dtick error: ' + String(olddtick);
      }
  };
  
  // after dtick is already known, find tickround = precision
  // to display in tick labels
  //   for numeric ticks, integer # digits after . to round to
  //   for date ticks, the last date part to show (y,m,d,H,M,S)
  //      or an integer # digits past seconds
  function autoTickRound(ax) {
      var dtick = ax.dtick;
  
      ax._tickexponent = 0;
      if(!isNumeric(dtick) && typeof dtick !== 'string') {
          dtick = 1;
      }
  
      if(ax.type === 'category' || ax.type === 'multicategory') {
          ax._tickround = null;
      }
      if(ax.type === 'date') {
          // If tick0 is unusual, give tickround a bit more information
          // not necessarily *all* the information in tick0 though, if it's really odd
          // minimal string length for tick0: 'd' is 10, 'M' is 16, 'S' is 19
          // take off a leading minus (year < 0) and i (intercalary month) so length is consistent
          var tick0ms = ax.r2l(ax.tick0);
          var tick0str = ax.l2r(tick0ms).replace(/(^-|i)/g, '');
          var tick0len = tick0str.length;
  
          if(String(dtick).charAt(0) === 'M') {
              // any tick0 more specific than a year: alway show the full date
              if(tick0len > 10 || tick0str.substr(5) !== '01-01') ax._tickround = 'd';
              // show the month unless ticks are full multiples of a year
              else ax._tickround = (+(dtick.substr(1)) % 12 === 0) ? 'y' : 'm';
          } else if((dtick >= ONEDAY && tick0len <= 10) || (dtick >= ONEDAY * 15)) ax._tickround = 'd';
          else if((dtick >= ONEMIN && tick0len <= 16) || (dtick >= ONEHOUR)) ax._tickround = 'M';
          else if((dtick >= ONESEC && tick0len <= 19) || (dtick >= ONEMIN)) ax._tickround = 'S';
          else {
              // tickround is a number of digits of fractional seconds
              // of any two adjacent ticks, at least one will have the maximum fractional digits
              // of all possible ticks - so take the max. length of tick0 and the next one
              var tick1len = ax.l2r(tick0ms + dtick).replace(/^-/, '').length;
              ax._tickround = Math.max(tick0len, tick1len) - 20;
  
              // We shouldn't get here... but in case there's a situation I'm
              // not thinking of where tick0str and tick1str are identical or
              // something, fall back on maximum precision
              if(ax._tickround < 0) ax._tickround = 4;
          }
      } else if(isNumeric(dtick) || dtick.charAt(0) === 'L') {
          // linear or log (except D1, D2)
          var rng = ax.range.map(ax.r2d || Number);
          if(!isNumeric(dtick)) dtick = Number(dtick.substr(1));
          // 2 digits past largest digit of dtick
          ax._tickround = 2 - Math.floor(Math.log(dtick) / Math.LN10 + 0.01);
  
          var maxend = Math.max(Math.abs(rng[0]), Math.abs(rng[1]));
          var rangeexp = Math.floor(Math.log(maxend) / Math.LN10 + 0.01);
          var minexponent = ax.minexponent === undefined ? 3 : ax.minexponent;
          if(Math.abs(rangeexp) > minexponent) {
              if(isSIFormat(ax.exponentformat) && !beyondSI(rangeexp)) {
                  ax._tickexponent = 3 * Math.round((rangeexp - 1) / 3);
              } else ax._tickexponent = rangeexp;
          }
      } else {
          // D1 or D2 (log)
          ax._tickround = null;
      }
  }
  
  // months and years don't have constant millisecond values
  // (but a year is always 12 months so we only need months)
  // log-scale ticks are also not consistently spaced, except
  // for pure powers of 10
  // numeric ticks always have constant differences, other datetime ticks
  // can all be calculated as constant number of milliseconds
  axes.tickIncrement = function(x, dtick, axrev, calendar) {
      var axSign = axrev ? -1 : 1;
  
      // includes linear, all dates smaller than month, and pure 10^n in log
      if(isNumeric(dtick)) return Lib.increment(x, axSign * dtick);
  
      // everything else is a string, one character plus a number
      var tType = dtick.charAt(0);
      var dtSigned = axSign * Number(dtick.substr(1));
  
      // Dates: months (or years - see Lib.incrementMonth)
      if(tType === 'M') return Lib.incrementMonth(x, dtSigned, calendar);
  
      // Log scales: Linear, Digits
      if(tType === 'L') return Math.log(Math.pow(10, x) + dtSigned) / Math.LN10;
  
      // log10 of 2,5,10, or all digits (logs just have to be
      // close enough to round)
      if(tType === 'D') {
          var tickset = (dtick === 'D2') ? roundLog2 : roundLog1;
          var x2 = x + axSign * 0.01;
          var frac = Lib.roundUp(Lib.mod(x2, 1), tickset, axrev);
  
          return Math.floor(x2) +
              Math.log(d3.round(Math.pow(10, frac), 1)) / Math.LN10;
      }
  
      throw 'unrecognized dtick ' + String(dtick);
  };
  
  // calculate the first tick on an axis
  axes.tickFirst = function(ax, opts) {
      var r2l = ax.r2l || Number;
      var rng = Lib.simpleMap(ax.range, r2l, undefined, undefined, opts);
      var axrev = rng[1] < rng[0];
      var sRound = axrev ? Math.floor : Math.ceil;
      // add a tiny extra bit to make sure we get ticks
      // that may have been rounded out
      var r0 = expandRange(rng)[0];
      var dtick = ax.dtick;
      var tick0 = r2l(ax.tick0);
  
      if(isNumeric(dtick)) {
          var tmin = sRound((r0 - tick0) / dtick) * dtick + tick0;
  
          // make sure no ticks outside the category list
          if(ax.type === 'category' || ax.type === 'multicategory') {
              tmin = Lib.constrain(tmin, 0, ax._categories.length - 1);
          }
          return tmin;
      }
  
      var tType = dtick.charAt(0);
      var dtNum = Number(dtick.substr(1));
  
      // Dates: months (or years)
      if(tType === 'M') {
          var cnt = 0;
          var t0 = tick0;
          var t1, mult, newDTick;
  
          // This algorithm should work for *any* nonlinear (but close to linear!)
          // tick spacing. Limit to 10 iterations, for gregorian months it's normally <=3.
          while(cnt < 10) {
              t1 = axes.tickIncrement(t0, dtick, axrev, ax.calendar);
              if((t1 - r0) * (t0 - r0) <= 0) {
                  // t1 and t0 are on opposite sides of r0! we've succeeded!
                  if(axrev) return Math.min(t0, t1);
                  return Math.max(t0, t1);
              }
              mult = (r0 - ((t0 + t1) / 2)) / (t1 - t0);
              newDTick = tType + ((Math.abs(Math.round(mult)) || 1) * dtNum);
              t0 = axes.tickIncrement(t0, newDTick, mult < 0 ? !axrev : axrev, ax.calendar);
              cnt++;
          }
          Lib.error('tickFirst did not converge', ax);
          return t0;
      } else if(tType === 'L') {
          // Log scales: Linear, Digits
  
          return Math.log(sRound(
              (Math.pow(10, r0) - tick0) / dtNum) * dtNum + tick0) / Math.LN10;
      } else if(tType === 'D') {
          var tickset = (dtick === 'D2') ? roundLog2 : roundLog1;
          var frac = Lib.roundUp(Lib.mod(r0, 1), tickset, axrev);
  
          return Math.floor(r0) +
              Math.log(d3.round(Math.pow(10, frac), 1)) / Math.LN10;
      } else throw 'unrecognized dtick ' + String(dtick);
  };
  
  // draw the text for one tick.
  // px,py are the location on gd.paper
  // prefix is there so the x axis ticks can be dropped a line
  // ax is the axis layout, x is the tick value
  // hover is a (truthy) flag for whether to show numbers with a bit
  // more precision for hovertext
  axes.tickText = function(ax, x, hover, noSuffixPrefix) {
      var out = tickTextObj(ax, x);
      var arrayMode = ax.tickmode === 'array';
      var extraPrecision = hover || arrayMode;
      var axType = ax.type;
      // TODO multicategory, if we allow ticktext / tickvals
      var tickVal2l = axType === 'category' ? ax.d2l_noadd : ax.d2l;
      var i;
  
      if(arrayMode && Array.isArray(ax.ticktext)) {
          var rng = Lib.simpleMap(ax.range, ax.r2l);
          var minDiff = (Math.abs(rng[1] - rng[0]) - (ax._lBreaks || 0)) / 10000;
  
          for(i = 0; i < ax.ticktext.length; i++) {
              if(Math.abs(x - tickVal2l(ax.tickvals[i])) < minDiff) break;
          }
          if(i < ax.ticktext.length) {
              out.text = String(ax.ticktext[i]);
              return out;
          }
      }
  
      function isHidden(showAttr) {
          if(showAttr === undefined) return true;
          if(hover) return showAttr === 'none';
  
          var firstOrLast = {
              first: ax._tmin,
              last: ax._tmax
          }[showAttr];
  
          return showAttr !== 'all' && x !== firstOrLast;
      }
  
      var hideexp = hover ?
          'never' :
          ax.exponentformat !== 'none' && isHidden(ax.showexponent) ? 'hide' : '';
  
      if(axType === 'date') formatDate(ax, out, hover, extraPrecision);
      else if(axType === 'log') formatLog(ax, out, hover, extraPrecision, hideexp);
      else if(axType === 'category') formatCategory(ax, out);
      else if(axType === 'multicategory') formatMultiCategory(ax, out, hover);
      else if(isAngular(ax)) formatAngle(ax, out, hover, extraPrecision, hideexp);
      else formatLinear(ax, out, hover, extraPrecision, hideexp);
  
      // add prefix and suffix
      if(!noSuffixPrefix) {
          if(ax.tickprefix && !isHidden(ax.showtickprefix)) out.text = ax.tickprefix + out.text;
          if(ax.ticksuffix && !isHidden(ax.showticksuffix)) out.text += ax.ticksuffix;
      }
  
      // Setup ticks and grid lines boundaries
      // at 1/2 a 'category' to the left/bottom
      if(ax.tickson === 'boundaries' || ax.showdividers) {
          var inbounds = function(v) {
              var p = ax.l2p(v);
              return p >= 0 && p <= ax._length ? v : null;
          };
  
          out.xbnd = [
              inbounds(out.x - 0.5),
              inbounds(out.x + ax.dtick - 0.5)
          ];
      }
  
      return out;
  };
  
  /**
   * create text for a hover label on this axis, with special handling of
   * log axes (where negative values can't be displayed but can appear in hover text)
   *
   * @param {object} ax: the axis to format text for
   * @param {number} val: calcdata value to format
   * @param {Optional(number)} val2: a second value to display
   *
   * @returns {string} `val` formatted as a string appropriate to this axis, or
   *     `val` and `val2` as a range (ie '<val> - <val2>') if `val2` is provided and
   *     it's different from `val`.
   */
  axes.hoverLabelText = function(ax, val, val2) {
      if(val2 !== BADNUM && val2 !== val) {
          return axes.hoverLabelText(ax, val) + ' - ' + axes.hoverLabelText(ax, val2);
      }
  
      var logOffScale = (ax.type === 'log' && val <= 0);
      var tx = axes.tickText(ax, ax.c2l(logOffScale ? -val : val), 'hover').text;
  
      if(logOffScale) {
          return val === 0 ? '0' : MINUS_SIGN + tx;
      }
  
      // TODO: should we do something special if the axis calendar and
      // the data calendar are different? Somehow display both dates with
      // their system names? Right now it will just display in the axis calendar
      // but users could add the other one as text.
      return tx;
  };
  
  function tickTextObj(ax, x, text) {
      var tf = ax.tickfont || {};
  
      return {
          x: x,
          dx: 0,
          dy: 0,
          text: text || '',
          fontSize: tf.size,
          font: tf.family,
          fontColor: tf.color
      };
  }
  
  function formatDate(ax, out, hover, extraPrecision) {
      var tr = ax._tickround;
      var fmt = (hover && ax.hoverformat) || axes.getTickFormat(ax);
  
      if(extraPrecision) {
          // second or sub-second precision: extra always shows max digits.
          // for other fields, extra precision just adds one field.
          if(isNumeric(tr)) tr = 4;
          else tr = {y: 'm', m: 'd', d: 'M', M: 'S', S: 4}[tr];
      }
  
      var dateStr = Lib.formatDate(out.x, fmt, tr, ax._dateFormat, ax.calendar, ax._extraFormat);
      var headStr;
  
      var splitIndex = dateStr.indexOf('\n');
      if(splitIndex !== -1) {
          headStr = dateStr.substr(splitIndex + 1);
          dateStr = dateStr.substr(0, splitIndex);
      }
  
      if(extraPrecision) {
          // if extraPrecision led to trailing zeros, strip them off
          // actually, this can lead to removing even more zeros than
          // in the original rounding, but that's fine because in these
          // contexts uniformity is not so important (if there's even
          // anything to be uniform with!)
  
          // can we remove the whole time part?
          if(dateStr === '00:00:00' || dateStr === '00:00') {
              dateStr = headStr;
              headStr = '';
          } else if(dateStr.length === 8) {
              // strip off seconds if they're zero (zero fractional seconds
              // are already omitted)
              // but we never remove minutes and leave just hours
              dateStr = dateStr.replace(/:00$/, '');
          }
      }
  
      if(headStr) {
          if(hover) {
              // hover puts it all on one line, so headPart works best up front
              // except for year headPart: turn this into "Jan 1, 2000" etc.
              if(tr === 'd') dateStr += ', ' + headStr;
              else dateStr = headStr + (dateStr ? ', ' + dateStr : '');
          } else if(!ax._inCalcTicks || (headStr !== ax._prevDateHead)) {
              dateStr += '<br>' + headStr;
              ax._prevDateHead = headStr;
          }
      }
  
      out.text = dateStr;
  }
  
  function formatLog(ax, out, hover, extraPrecision, hideexp) {
      var dtick = ax.dtick;
      var x = out.x;
      var tickformat = ax.tickformat;
      var dtChar0 = typeof dtick === 'string' && dtick.charAt(0);
  
      if(hideexp === 'never') {
          // If this is a hover label, then we must *never* hide the exponent
          // for the sake of display, which could give the wrong value by
          // potentially many orders of magnitude. If hideexp was 'never', then
          // it's now succeeded by preventing the other condition from automating
          // this choice. Thus we can unset it so that the axis formatting takes
          // precedence.
          hideexp = '';
      }
  
      if(extraPrecision && (dtChar0 !== 'L')) {
          dtick = 'L3';
          dtChar0 = 'L';
      }
  
      if(tickformat || (dtChar0 === 'L')) {
          out.text = numFormat(Math.pow(10, x), ax, hideexp, extraPrecision);
      } else if(isNumeric(dtick) || ((dtChar0 === 'D') && (Lib.mod(x + 0.01, 1) < 0.1))) {
          var p = Math.round(x);
          var absP = Math.abs(p);
          var exponentFormat = ax.exponentformat;
          if(exponentFormat === 'power' || (isSIFormat(exponentFormat) && beyondSI(p))) {
              if(p === 0) out.text = 1;
              else if(p === 1) out.text = '10';
              else out.text = '10<sup>' + (p > 1 ? '' : MINUS_SIGN) + absP + '</sup>';
  
              out.fontSize *= 1.25;
          } else if((exponentFormat === 'e' || exponentFormat === 'E') && absP > 2) {
              out.text = '1' + exponentFormat + (p > 0 ? '+' : MINUS_SIGN) + absP;
          } else {
              out.text = numFormat(Math.pow(10, x), ax, '', 'fakehover');
              if(dtick === 'D1' && ax._id.charAt(0) === 'y') {
                  out.dy -= out.fontSize / 6;
              }
          }
      } else if(dtChar0 === 'D') {
          out.text = String(Math.round(Math.pow(10, Lib.mod(x, 1))));
          out.fontSize *= 0.75;
      } else throw 'unrecognized dtick ' + String(dtick);
  
      // if 9's are printed on log scale, move the 10's away a bit
      if(ax.dtick === 'D1') {
          var firstChar = String(out.text).charAt(0);
          if(firstChar === '0' || firstChar === '1') {
              if(ax._id.charAt(0) === 'y') {
                  out.dx -= out.fontSize / 4;
              } else {
                  out.dy += out.fontSize / 2;
                  out.dx += (ax.range[1] > ax.range[0] ? 1 : -1) *
                      out.fontSize * (x < 0 ? 0.5 : 0.25);
              }
          }
      }
  }
  
  function formatCategory(ax, out) {
      var tt = ax._categories[Math.round(out.x)];
      if(tt === undefined) tt = '';
      out.text = String(tt);
  }
  
  function formatMultiCategory(ax, out, hover) {
      var v = Math.round(out.x);
      var cats = ax._categories[v] || [];
      var tt = cats[1] === undefined ? '' : String(cats[1]);
      var tt2 = cats[0] === undefined ? '' : String(cats[0]);
  
      if(hover) {
          // TODO is this what we want?
          out.text = tt2 + ' - ' + tt;
      } else {
          // setup for secondary labels
          out.text = tt;
          out.text2 = tt2;
      }
  }
  
  function formatLinear(ax, out, hover, extraPrecision, hideexp) {
      if(hideexp === 'never') {
          // If this is a hover label, then we must *never* hide the exponent
          // for the sake of display, which could give the wrong value by
          // potentially many orders of magnitude. If hideexp was 'never', then
          // it's now succeeded by preventing the other condition from automating
          // this choice. Thus we can unset it so that the axis formatting takes
          // precedence.
          hideexp = '';
      } else if(ax.showexponent === 'all' && Math.abs(out.x / ax.dtick) < 1e-6) {
          // don't add an exponent to zero if we're showing all exponents
          // so the only reason you'd show an exponent on zero is if it's the
          // ONLY tick to get an exponent (first or last)
          hideexp = 'hide';
      }
      out.text = numFormat(out.x, ax, hideexp, extraPrecision);
  }
  
  function formatAngle(ax, out, hover, extraPrecision, hideexp) {
      if(ax.thetaunit === 'radians' && !hover) {
          var num = out.x / 180;
  
          if(num === 0) {
              out.text = '0';
          } else {
              var frac = num2frac(num);
  
              if(frac[1] >= 100) {
                  out.text = numFormat(Lib.deg2rad(out.x), ax, hideexp, extraPrecision);
              } else {
                  var isNeg = out.x < 0;
  
                  if(frac[1] === 1) {
                      if(frac[0] === 1) out.text = 'π';
                      else out.text = frac[0] + 'π';
                  } else {
                      out.text = [
                          '<sup>', frac[0], '</sup>',
                          '⁄',
                          '<sub>', frac[1], '</sub>',
                          'π'
                      ].join('');
                  }
  
                  if(isNeg) out.text = MINUS_SIGN + out.text;
              }
          }
      } else {
          out.text = numFormat(out.x, ax, hideexp, extraPrecision);
      }
  }
  
  // inspired by
  // https://github.com/yisibl/num2fraction/blob/master/index.js
  function num2frac(num) {
      function almostEq(a, b) {
          return Math.abs(a - b) <= 1e-6;
      }
  
      function findGCD(a, b) {
          return almostEq(b, 0) ? a : findGCD(b, a % b);
      }
  
      function findPrecision(n) {
          var e = 1;
          while(!almostEq(Math.round(n * e) / e, n)) {
              e *= 10;
          }
          return e;
      }
  
      var precision = findPrecision(num);
      var number = num * precision;
      var gcd = Math.abs(findGCD(number, precision));
  
      return [
          // numerator
          Math.round(number / gcd),
          // denominator
          Math.round(precision / gcd)
      ];
  }
  
  // format a number (tick value) according to the axis settings
  // new, more reliable procedure than d3.round or similar:
  // add half the rounding increment, then stringify and truncate
  // also automatically switch to sci. notation
  var SIPREFIXES = ['f', 'p', 'n', 'μ', 'm', '', 'k', 'M', 'G', 'T'];
  
  function isSIFormat(exponentFormat) {
      return exponentFormat === 'SI' || exponentFormat === 'B';
  }
  
  // are we beyond the range of common SI prefixes?
  // 10^-16 -> 1x10^-16
  // 10^-15 -> 1f
  // ...
  // 10^14 -> 100T
  // 10^15 -> 1x10^15
  // 10^16 -> 1x10^16
  function beyondSI(exponent) {
      return exponent > 14 || exponent < -15;
  }
  
  function numFormat(v, ax, fmtoverride, hover) {
      var isNeg = v < 0;
      // max number of digits past decimal point to show
      var tickRound = ax._tickround;
      var exponentFormat = fmtoverride || ax.exponentformat || 'B';
      var exponent = ax._tickexponent;
      var tickformat = axes.getTickFormat(ax);
      var separatethousands = ax.separatethousands;
  
      // special case for hover: set exponent just for this value, and
      // add a couple more digits of precision over tick labels
      if(hover) {
          // make a dummy axis obj to get the auto rounding and exponent
          var ah = {
              exponentformat: exponentFormat,
              minexponent: ax.minexponent,
              dtick: ax.showexponent === 'none' ? ax.dtick :
                  (isNumeric(v) ? Math.abs(v) || 1 : 1),
              // if not showing any exponents, don't change the exponent
              // from what we calculate
              range: ax.showexponent === 'none' ? ax.range.map(ax.r2d) : [0, v || 1]
          };
          autoTickRound(ah);
          tickRound = (Number(ah._tickround) || 0) + 4;
          exponent = ah._tickexponent;
          if(ax.hoverformat) tickformat = ax.hoverformat;
      }
  
      if(tickformat) return ax._numFormat(tickformat)(v).replace(/-/g, MINUS_SIGN);
  
      // 'epsilon' - rounding increment
      var e = Math.pow(10, -tickRound) / 2;
  
      // exponentFormat codes:
      // 'e' (1.2e+6, default)
      // 'E' (1.2E+6)
      // 'SI' (1.2M)
      // 'B' (same as SI except 10^9=B not G)
      // 'none' (1200000)
      // 'power' (1.2x10^6)
      // 'hide' (1.2, use 3rd argument=='hide' to eg
      //      only show exponent on last tick)
      if(exponentFormat === 'none') exponent = 0;
  
      // take the sign out, put it back manually at the end
      // - makes cases easier
      v = Math.abs(v);
      if(v < e) {
          // 0 is just 0, but may get exponent if it's the last tick
          v = '0';
          isNeg = false;
      } else {
          v += e;
          // take out a common exponent, if any
          if(exponent) {
              v *= Math.pow(10, -exponent);
              tickRound += exponent;
          }
          // round the mantissa
          if(tickRound === 0) v = String(Math.floor(v));
          else if(tickRound < 0) {
              v = String(Math.round(v));
              v = v.substr(0, v.length + tickRound);
              for(var i = tickRound; i < 0; i++) v += '0';
          } else {
              v = String(v);
              var dp = v.indexOf('.') + 1;
              if(dp) v = v.substr(0, dp + tickRound).replace(/\.?0+$/, '');
          }
          // insert appropriate decimal point and thousands separator
          v = Lib.numSeparate(v, ax._separators, separatethousands);
      }
  
      // add exponent
      if(exponent && exponentFormat !== 'hide') {
          if(isSIFormat(exponentFormat) && beyondSI(exponent)) exponentFormat = 'power';
  
          var signedExponent;
          if(exponent < 0) signedExponent = MINUS_SIGN + -exponent;
          else if(exponentFormat !== 'power') signedExponent = '+' + exponent;
          else signedExponent = String(exponent);
  
          if(exponentFormat === 'e' || exponentFormat === 'E') {
              v += exponentFormat + signedExponent;
          } else if(exponentFormat === 'power') {
              v += '×10<sup>' + signedExponent + '</sup>';
          } else if(exponentFormat === 'B' && exponent === 9) {
              v += 'B';
          } else if(isSIFormat(exponentFormat)) {
              v += SIPREFIXES[exponent / 3 + 5];
          }
      }
  
      // put sign back in and return
      // replace standard minus character (which is technically a hyphen)
      // with a true minus sign
      if(isNeg) return MINUS_SIGN + v;
      return v;
  }
  
  axes.getTickFormat = function(ax) {
      var i;
  
      function convertToMs(dtick) {
          return typeof dtick !== 'string' ? dtick : Number(dtick.replace('M', '')) * ONEAVGMONTH;
      }
  
      function compareLogTicks(left, right) {
          var priority = ['L', 'D'];
          if(typeof left === typeof right) {
              if(typeof left === 'number') {
                  return left - right;
              } else {
                  var leftPriority = priority.indexOf(left.charAt(0));
                  var rightPriority = priority.indexOf(right.charAt(0));
                  if(leftPriority === rightPriority) {
                      return Number(left.replace(/(L|D)/g, '')) - Number(right.replace(/(L|D)/g, ''));
                  } else {
                      return leftPriority - rightPriority;
                  }
              }
          } else {
              return typeof left === 'number' ? 1 : -1;
          }
      }
  
      function isProperStop(dtick, range, convert) {
          var convertFn = convert || function(x) { return x;};
          var leftDtick = range[0];
          var rightDtick = range[1];
          return ((!leftDtick && typeof leftDtick !== 'number') || convertFn(leftDtick) <= convertFn(dtick)) &&
                 ((!rightDtick && typeof rightDtick !== 'number') || convertFn(rightDtick) >= convertFn(dtick));
      }
  
      function isProperLogStop(dtick, range) {
          var isLeftDtickNull = range[0] === null;
          var isRightDtickNull = range[1] === null;
          var isDtickInRangeLeft = compareLogTicks(dtick, range[0]) >= 0;
          var isDtickInRangeRight = compareLogTicks(dtick, range[1]) <= 0;
          return (isLeftDtickNull || isDtickInRangeLeft) && (isRightDtickNull || isDtickInRangeRight);
      }
  
      var tickstop, stopi;
      if(ax.tickformatstops && ax.tickformatstops.length > 0) {
          switch(ax.type) {
              case 'date':
              case 'linear': {
                  for(i = 0; i < ax.tickformatstops.length; i++) {
                      stopi = ax.tickformatstops[i];
                      if(stopi.enabled && isProperStop(ax.dtick, stopi.dtickrange, convertToMs)) {
                          tickstop = stopi;
                          break;
                      }
                  }
                  break;
              }
              case 'log': {
                  for(i = 0; i < ax.tickformatstops.length; i++) {
                      stopi = ax.tickformatstops[i];
                      if(stopi.enabled && isProperLogStop(ax.dtick, stopi.dtickrange)) {
                          tickstop = stopi;
                          break;
                      }
                  }
                  break;
              }
              default:
          }
      }
      return tickstop ? tickstop.value : ax.tickformat;
  };
  
  // getSubplots - extract all subplot IDs we need
  // as an array of items like 'xy', 'x2y', 'x2y2'...
  // sorted by x (x,x2,x3...) then y
  // optionally restrict to only subplots containing axis object ax
  //
  // NOTE: this is currently only used OUTSIDE plotly.js (toolpanel, webapp)
  // ideally we get rid of it there (or just copy this there) and remove it here
  axes.getSubplots = function(gd, ax) {
      var subplotObj = gd._fullLayout._subplots;
      var allSubplots = subplotObj.cartesian.concat(subplotObj.gl2d || []);
  
      var out = ax ? axes.findSubplotsWithAxis(allSubplots, ax) : allSubplots;
  
      out.sort(function(a, b) {
          var aParts = a.substr(1).split('y');
          var bParts = b.substr(1).split('y');
  
          if(aParts[0] === bParts[0]) return +aParts[1] - +bParts[1];
          return +aParts[0] - +bParts[0];
      });
  
      return out;
  };
  
  // find all subplots with axis 'ax'
  // NOTE: this is only used in axes.getSubplots (only used outside plotly.js) and
  // gl2d/convert (where it restricts axis subplots to only those with gl2d)
  axes.findSubplotsWithAxis = function(subplots, ax) {
      var axMatch = new RegExp(
          (ax._id.charAt(0) === 'x') ? ('^' + ax._id + 'y') : (ax._id + '$')
      );
      var subplotsWithAx = [];
  
      for(var i = 0; i < subplots.length; i++) {
          var sp = subplots[i];
          if(axMatch.test(sp)) subplotsWithAx.push(sp);
      }
  
      return subplotsWithAx;
  };
  
  // makeClipPaths: prepare clipPaths for all single axes and all possible xy pairings
  axes.makeClipPaths = function(gd) {
      var fullLayout = gd._fullLayout;
  
      // for more info: https://github.com/plotly/plotly.js/issues/2595
      if(fullLayout._hasOnlyLargeSploms) return;
  
      var fullWidth = {_offset: 0, _length: fullLayout.width, _id: ''};
      var fullHeight = {_offset: 0, _length: fullLayout.height, _id: ''};
      var xaList = axes.list(gd, 'x', true);
      var yaList = axes.list(gd, 'y', true);
      var clipList = [];
      var i, j;
  
      for(i = 0; i < xaList.length; i++) {
          clipList.push({x: xaList[i], y: fullHeight});
          for(j = 0; j < yaList.length; j++) {
              if(i === 0) clipList.push({x: fullWidth, y: yaList[j]});
              clipList.push({x: xaList[i], y: yaList[j]});
          }
      }
  
      // selectors don't work right with camelCase tags,
      // have to use class instead
      // https://groups.google.com/forum/#!topic/d3-js/6EpAzQ2gU9I
      var axClips = fullLayout._clips.selectAll('.axesclip')
          .data(clipList, function(d) { return d.x._id + d.y._id; });
  
      axClips.enter().append('clipPath')
          .classed('axesclip', true)
          .attr('id', function(d) { return 'clip' + fullLayout._uid + d.x._id + d.y._id; })
        .append('rect');
  
      axClips.exit().remove();
  
      axClips.each(function(d) {
          d3.select(this).select('rect').attr({
              x: d.x._offset || 0,
              y: d.y._offset || 0,
              width: d.x._length || 1,
              height: d.y._length || 1
          });
      });
  };
  
  /**
   * Main multi-axis drawing routine!
   *
   * @param {DOM element} gd : graph div
   * @param {string or array of strings} arg : polymorphic argument
   * @param {object} opts:
   * - @param {boolean} skipTitle : optional flag to skip axis title draw/update
   *
   * Signature 1: Axes.draw(gd, 'redraw')
   *   use this to clear and redraw all axes on graph
   *
   * Signature 2: Axes.draw(gd, '')
   *   use this to draw all axes on graph w/o the selectAll().remove()
   *   of the 'redraw' signature
   *
   * Signature 3: Axes.draw(gd, [axId, axId2, ...])
   *   where the items are axis id string,
   *   use this to update multiple axes in one call
   *
   * N.B draw updates:
   * - ax._r (stored range for use by zoom/pan)
   * - ax._rl (stored linearized range for use by zoom/pan)
   */
  axes.draw = function(gd, arg, opts) {
      var fullLayout = gd._fullLayout;
  
      if(arg === 'redraw') {
          fullLayout._paper.selectAll('g.subplot').each(function(d) {
              var id = d[0];
              var plotinfo = fullLayout._plots[id];
              var xa = plotinfo.xaxis;
              var ya = plotinfo.yaxis;
  
              plotinfo.xaxislayer.selectAll('.' + xa._id + 'tick').remove();
              plotinfo.yaxislayer.selectAll('.' + ya._id + 'tick').remove();
              plotinfo.xaxislayer.selectAll('.' + xa._id + 'tick2').remove();
              plotinfo.yaxislayer.selectAll('.' + ya._id + 'tick2').remove();
              plotinfo.xaxislayer.selectAll('.' + xa._id + 'divider').remove();
              plotinfo.yaxislayer.selectAll('.' + ya._id + 'divider').remove();
  
              if(plotinfo.gridlayer) plotinfo.gridlayer.selectAll('path').remove();
              if(plotinfo.zerolinelayer) plotinfo.zerolinelayer.selectAll('path').remove();
  
              fullLayout._infolayer.select('.g-' + xa._id + 'title').remove();
              fullLayout._infolayer.select('.g-' + ya._id + 'title').remove();
          });
      }
  
      var axList = (!arg || arg === 'redraw') ? axes.listIds(gd) : arg;
  
      return Lib.syncOrAsync(axList.map(function(axId) {
          return function() {
              if(!axId) return;
  
              var ax = axes.getFromId(gd, axId);
              var axDone = axes.drawOne(gd, ax, opts);
  
              ax._r = ax.range.slice();
              ax._rl = Lib.simpleMap(ax._r, ax.r2l);
  
              return axDone;
          };
      }));
  };
  
  /**
   * Draw one cartesian axis
   *
   * @param {DOM element} gd
   * @param {object} ax (full) axis object
   * @param {object} opts
   * - @param {boolean} skipTitle (set to true to skip axis title draw call)
   *
   * Depends on:
   * - ax._mainSubplot (from linkSubplots)
   * - ax._mainAxis
   * - ax._anchorAxis
   * - ax._subplotsWith
   * - ax._counterDomainMin, ax._counterDomainMax (optionally, from linkSubplots)
   * - ax._tickAngles (on redraw only, old value relinked during supplyDefaults)
   * - ax._mainLinePosition (from lsInner)
   * - ax._mainMirrorPosition
   * - ax._linepositions
   *
   * Fills in:
   * - ax._vals:
   * - ax._gridVals:
   * - ax._selections:
   * - ax._tickAngles:
   * - ax._depth (when required only):
   * - and calls ax.setScale
   */
  axes.drawOne = function(gd, ax, opts) {
      opts = opts || {};
  
      var i, sp, plotinfo;
  
      ax.setScale();
  
      var fullLayout = gd._fullLayout;
      var axId = ax._id;
      var axLetter = axId.charAt(0);
      var counterLetter = axes.counterLetter(axId);
      var mainPlotinfo = fullLayout._plots[ax._mainSubplot];
  
      // this happens when updating matched group with 'missing' axes
      if(!mainPlotinfo) return;
  
      var mainAxLayer = mainPlotinfo[axLetter + 'axislayer'];
      var mainLinePosition = ax._mainLinePosition;
      var mainMirrorPosition = ax._mainMirrorPosition;
  
      var vals = ax._vals = axes.calcTicks(ax);
  
      // Add a couple of axis properties that should cause us to recreate
      // elements. Used in d3 data function.
      var axInfo = [ax.mirror, mainLinePosition, mainMirrorPosition].join('_');
      for(i = 0; i < vals.length; i++) {
          vals[i].axInfo = axInfo;
      }
  
      // stash selections to avoid DOM queries e.g.
      // - stash tickLabels selection, so that drawTitle can use it to scoot title
      ax._selections = {};
      // stash tick angle (including the computed 'auto' values) per tick-label class
      // linkup 'previous' tick angles on redraws
      if(ax._tickAngles) ax._prevTickAngles = ax._tickAngles;
      ax._tickAngles = {};
      // measure [in px] between axis position and outward-most part of bounding box
      // (touching either the tick label or ticks)
      // depth can be expansive to compute, so we only do so when required
      ax._depth = null;
  
      // calcLabelLevelBbox can be expensive,
      // so make sure to not call it twice during the same Axes.drawOne call
      // by stashing label-level bounding boxes per tick-label class
      var llbboxes = {};
      function getLabelLevelBbox(suffix) {
          var cls = axId + (suffix || 'tick');
          if(!llbboxes[cls]) llbboxes[cls] = calcLabelLevelBbox(ax, cls);
          return llbboxes[cls];
      }
  
      if(!ax.visible) return;
  
      var transFn = axes.makeTransFn(ax);
      var transTickLabelFn = ax.ticklabelmode === 'period' ?
          axes.makeTransPeriodFn(ax) :
          axes.makeTransFn(ax);
  
      var tickVals;
      // We remove zero lines, grid lines, and inside ticks if they're within 1px of the end
      // The key case here is removing zero lines when the axis bound is zero
      var valsClipped;
  
      if(ax.tickson === 'boundaries') {
          var boundaryVals = getBoundaryVals(ax, vals);
          valsClipped = axes.clipEnds(ax, boundaryVals);
          tickVals = ax.ticks === 'inside' ? valsClipped : boundaryVals;
      } else {
          valsClipped = axes.clipEnds(ax, vals);
          tickVals = ax.ticks === 'inside' ? valsClipped : vals;
      }
  
      var gridVals = ax._gridVals = valsClipped;
      var dividerVals = getDividerVals(ax, vals);
  
      if(!fullLayout._hasOnlyLargeSploms) {
          var subplotsWithAx = ax._subplotsWith;
  
          // keep track of which subplots (by main counter axis) we've already
          // drawn grids for, so we don't overdraw overlaying subplots
          var finishedGrids = {};
  
          for(i = 0; i < subplotsWithAx.length; i++) {
              sp = subplotsWithAx[i];
              plotinfo = fullLayout._plots[sp];
  
              var counterAxis = plotinfo[counterLetter + 'axis'];
              var mainCounterID = counterAxis._mainAxis._id;
              if(finishedGrids[mainCounterID]) continue;
              finishedGrids[mainCounterID] = 1;
  
              var gridPath = axLetter === 'x' ?
                  'M0,' + counterAxis._offset + 'v' + counterAxis._length :
                  'M' + counterAxis._offset + ',0h' + counterAxis._length;
  
              axes.drawGrid(gd, ax, {
                  vals: gridVals,
                  counterAxis: counterAxis,
                  layer: plotinfo.gridlayer.select('.' + axId),
                  path: gridPath,
                  transFn: transFn
              });
              axes.drawZeroLine(gd, ax, {
                  counterAxis: counterAxis,
                  layer: plotinfo.zerolinelayer,
                  path: gridPath,
                  transFn: transFn
              });
          }
      }
  
      var tickSigns = axes.getTickSigns(ax);
      var tickSubplots = [];
  
      if(ax.ticks) {
          var mainTickPath = axes.makeTickPath(ax, mainLinePosition, tickSigns[2]);
          var mirrorTickPath;
          var fullTickPath;
          if(ax._anchorAxis && ax.mirror && ax.mirror !== true) {
              mirrorTickPath = axes.makeTickPath(ax, mainMirrorPosition, tickSigns[3]);
              fullTickPath = mainTickPath + mirrorTickPath;
          } else {
              mirrorTickPath = '';
              fullTickPath = mainTickPath;
          }
  
          var tickPath;
          if(ax.showdividers && ax.ticks === 'outside' && ax.tickson === 'boundaries') {
              var dividerLookup = {};
              for(i = 0; i < dividerVals.length; i++) {
                  dividerLookup[dividerVals[i].x] = 1;
              }
              tickPath = function(d) {
                  return dividerLookup[d.x] ? mirrorTickPath : fullTickPath;
              };
          } else {
              tickPath = fullTickPath;
          }
  
          axes.drawTicks(gd, ax, {
              vals: tickVals,
              layer: mainAxLayer,
              path: tickPath,
              transFn: transFn
          });
  
          if(ax.mirror === 'allticks') {
              tickSubplots = Object.keys(ax._linepositions || {});
          }
      }
  
      for(i = 0; i < tickSubplots.length; i++) {
          sp = tickSubplots[i];
          plotinfo = fullLayout._plots[sp];
          // [bottom or left, top or right], free and main are handled above
          var linepositions = ax._linepositions[sp] || [];
          var spTickPath = axes.makeTickPath(ax, linepositions[0], tickSigns[0]) +
              axes.makeTickPath(ax, linepositions[1], tickSigns[1]);
  
          axes.drawTicks(gd, ax, {
              vals: tickVals,
              layer: plotinfo[axLetter + 'axislayer'],
              path: spTickPath,
              transFn: transFn
          });
      }
  
      var seq = [];
  
      // tick labels - for now just the main labels.
      // TODO: mirror labels, esp for subplots
  
      seq.push(function() {
          return axes.drawLabels(gd, ax, {
              vals: vals,
              layer: mainAxLayer,
              transFn: transTickLabelFn,
              labelFns: axes.makeLabelFns(ax, mainLinePosition)
          });
      });
  
      if(ax.type === 'multicategory') {
          var pad = {x: 2, y: 10}[axLetter];
  
          seq.push(function() {
              var bboxKey = {x: 'height', y: 'width'}[axLetter];
              var standoff = getLabelLevelBbox()[bboxKey] + pad +
                  (ax._tickAngles[axId + 'tick'] ? ax.tickfont.size * LINE_SPACING : 0);
  
              return axes.drawLabels(gd, ax, {
                  vals: getSecondaryLabelVals(ax, vals),
                  layer: mainAxLayer,
                  cls: axId + 'tick2',
                  repositionOnUpdate: true,
                  secondary: true,
                  transFn: transFn,
                  labelFns: axes.makeLabelFns(ax, mainLinePosition + standoff * tickSigns[4])
              });
          });
  
          seq.push(function() {
              ax._depth = tickSigns[4] * (getLabelLevelBbox('tick2')[ax.side] - mainLinePosition);
  
              return drawDividers(gd, ax, {
                  vals: dividerVals,
                  layer: mainAxLayer,
                  path: axes.makeTickPath(ax, mainLinePosition, tickSigns[4], ax._depth),
                  transFn: transFn
              });
          });
      } else if(ax.title.hasOwnProperty('standoff')) {
          seq.push(function() {
              ax._depth = tickSigns[4] * (getLabelLevelBbox()[ax.side] - mainLinePosition);
          });
      }
  
      var hasRangeSlider = Registry.getComponentMethod('rangeslider', 'isVisible')(ax);
  
      seq.push(function() {
          var s = ax.side.charAt(0);
          var sMirror = OPPOSITE_SIDE[ax.side].charAt(0);
          var pos = axes.getPxPosition(gd, ax);
          var outsideTickLen = ax.ticks === 'outside' ? ax.ticklen : 0;
          var llbbox;
  
          var push;
          var mirrorPush;
          var rangeSliderPush;
  
          if(ax.automargin || hasRangeSlider) {
              if(ax.type === 'multicategory') {
                  llbbox = getLabelLevelBbox('tick2');
              } else {
                  llbbox = getLabelLevelBbox();
                  if(axLetter === 'x' && s === 'b') {
                      ax._depth = Math.max(llbbox.width > 0 ? llbbox.bottom - pos : 0, outsideTickLen);
                  }
              }
          }
  
          if(ax.automargin) {
              push = {x: 0, y: 0, r: 0, l: 0, t: 0, b: 0};
              var domainIndices = [0, 1];
  
              if(axLetter === 'x') {
                  if(s === 'b') {
                      push[s] = ax._depth;
                  } else {
                      push[s] = ax._depth = Math.max(llbbox.width > 0 ? pos - llbbox.top : 0, outsideTickLen);
                      domainIndices.reverse();
                  }
  
                  if(llbbox.width > 0) {
                      var rExtra = llbbox.right - (ax._offset + ax._length);
                      if(rExtra > 0) {
                          push.xr = 1;
                          push.r = rExtra;
                      }
                      var lExtra = ax._offset - llbbox.left;
                      if(lExtra > 0) {
                          push.xl = 0;
                          push.l = lExtra;
                      }
                  }
              } else {
                  if(s === 'l') {
                      push[s] = ax._depth = Math.max(llbbox.height > 0 ? pos - llbbox.left : 0, outsideTickLen);
                  } else {
                      push[s] = ax._depth = Math.max(llbbox.height > 0 ? llbbox.right - pos : 0, outsideTickLen);
                      domainIndices.reverse();
                  }
  
                  if(llbbox.height > 0) {
                      var bExtra = llbbox.bottom - (ax._offset + ax._length);
                      if(bExtra > 0) {
                          push.yb = 0;
                          push.b = bExtra;
                      }
                      var tExtra = ax._offset - llbbox.top;
                      if(tExtra > 0) {
                          push.yt = 1;
                          push.t = tExtra;
                      }
                  }
              }
  
              push[counterLetter] = ax.anchor === 'free' ?
                  ax.position :
                  ax._anchorAxis.domain[domainIndices[0]];
  
              if(ax.title.text !== fullLayout._dfltTitle[axLetter]) {
                  push[s] += approxTitleDepth(ax) + (ax.title.standoff || 0);
              }
  
              if(ax.mirror && ax.anchor !== 'free') {
                  mirrorPush = {x: 0, y: 0, r: 0, l: 0, t: 0, b: 0};
  
                  mirrorPush[sMirror] = ax.linewidth;
                  if(ax.mirror && ax.mirror !== true) mirrorPush[sMirror] += outsideTickLen;
  
                  if(ax.mirror === true || ax.mirror === 'ticks') {
                      mirrorPush[counterLetter] = ax._anchorAxis.domain[domainIndices[1]];
                  } else if(ax.mirror === 'all' || ax.mirror === 'allticks') {
                      mirrorPush[counterLetter] = [ax._counterDomainMin, ax._counterDomainMax][domainIndices[1]];
                  }
              }
          }
  
          if(hasRangeSlider) {
              rangeSliderPush = Registry.getComponentMethod('rangeslider', 'autoMarginOpts')(gd, ax);
          }
  
          Plots.autoMargin(gd, axAutoMarginID(ax), push);
          Plots.autoMargin(gd, axMirrorAutoMarginID(ax), mirrorPush);
          Plots.autoMargin(gd, rangeSliderAutoMarginID(ax), rangeSliderPush);
      });
  
      if(!opts.skipTitle &&
          !(hasRangeSlider && ax.side === 'bottom')
      ) {
          seq.push(function() { return drawTitle(gd, ax); });
      }
  
      return Lib.syncOrAsync(seq);
  };
  
  function getBoundaryVals(ax, vals) {
      var out = [];
      var i;
  
      // boundaryVals are never used for labels;
      // no need to worry about the other tickTextObj keys
      var _push = function(d, bndIndex) {
          var xb = d.xbnd[bndIndex];
          if(xb !== null) {
              out.push(Lib.extendFlat({}, d, {x: xb}));
          }
      };
  
      if(vals.length) {
          for(i = 0; i < vals.length; i++) {
              _push(vals[i], 0);
          }
          _push(vals[i - 1], 1);
      }
  
      return out;
  }
  
  function getSecondaryLabelVals(ax, vals) {
      var out = [];
      var lookup = {};
  
      for(var i = 0; i < vals.length; i++) {
          var d = vals[i];
          if(lookup[d.text2]) {
              lookup[d.text2].push(d.x);
          } else {
              lookup[d.text2] = [d.x];
          }
      }
  
      for(var k in lookup) {
          out.push(tickTextObj(ax, Lib.interp(lookup[k], 0.5), k));
      }
  
      return out;
  }
  
  function getDividerVals(ax, vals) {
      var out = [];
      var i, current;
  
      var reversed = (vals.length && vals[vals.length - 1].x < vals[0].x);
  
      // never used for labels;
      // no need to worry about the other tickTextObj keys
      var _push = function(d, bndIndex) {
          var xb = d.xbnd[bndIndex];
          if(xb !== null) {
              out.push(Lib.extendFlat({}, d, {x: xb}));
          }
      };
  
      if(ax.showdividers && vals.length) {
          for(i = 0; i < vals.length; i++) {
              var d = vals[i];
              if(d.text2 !== current) {
                  _push(d, reversed ? 1 : 0);
              }
              current = d.text2;
          }
          _push(vals[i - 1], reversed ? 0 : 1);
      }
  
      return out;
  }
  
  function calcLabelLevelBbox(ax, cls) {
      var top, bottom;
      var left, right;
  
      if(ax._selections[cls].size()) {
          top = Infinity;
          bottom = -Infinity;
          left = Infinity;
          right = -Infinity;
          ax._selections[cls].each(function() {
              var thisLabel = selectTickLabel(this);
              // Use parent node <g.(x|y)tick>, to make Drawing.bBox
              // retrieve a bbox computed with transform info
              //
              // To improve perf, it would be nice to use `thisLabel.node()`
              // (like in fixLabelOverlaps) instead and use Axes.getPxPosition
              // together with the makeLabelFns outputs and `tickangle`
              // to compute one bbox per (tick value x tick style)
              var bb = Drawing.bBox(thisLabel.node().parentNode);
              top = Math.min(top, bb.top);
              bottom = Math.max(bottom, bb.bottom);
              left = Math.min(left, bb.left);
              right = Math.max(right, bb.right);
          });
      } else {
          top = 0;
          bottom = 0;
          left = 0;
          right = 0;
      }
  
      return {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          height: bottom - top,
          width: right - left
      };
  }
  
  /**
   * Which direction do the 'ax.side' values, and free ticks go?
   *
   * @param {object} ax (full) axis object
   *  - {string} _id (starting with 'x' or 'y')
   *  - {string} side
   *  - {string} ticks
   * @return {array} all entries are either -1 or 1
   *  - [0]: sign for top/right ticks (i.e. negative SVG direction)
   *  - [1]: sign for bottom/left ticks (i.e. positive SVG direction)
   *  - [2]: sign for ticks corresponding to 'ax.side'
   *  - [3]: sign for ticks mirroring 'ax.side'
   *  - [4]: sign of arrow starting at axis pointing towards margin
   */
  axes.getTickSigns = function(ax) {
      var axLetter = ax._id.charAt(0);
      var sideOpposite = {x: 'top', y: 'right'}[axLetter];
      var main = ax.side === sideOpposite ? 1 : -1;
      var out = [-1, 1, main, -main];
      // then we flip if outside XOR y axis
      if((ax.ticks !== 'inside') === (axLetter === 'x')) {
          out = out.map(function(v) { return -v; });
      }
      // independent of `ticks`; do not flip this one
      if(ax.side) {
          out.push({l: -1, t: -1, r: 1, b: 1}[ax.side.charAt(0)]);
      }
      return out;
  };
  
  /**
   * Make axis translate transform function
   *
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {number} _offset
   *  - {fn} l2p
   * @return {fn} function of calcTicks items
   */
  axes.makeTransFn = function(ax) {
      var axLetter = ax._id.charAt(0);
      var offset = ax._offset;
      return axLetter === 'x' ?
          function(d) { return 'translate(' + (offset + ax.l2p(d.x)) + ',0)'; } :
          function(d) { return 'translate(0,' + (offset + ax.l2p(d.x)) + ')'; };
  };
  
  axes.makeTransPeriodFn = function(ax) {
      var axLetter = ax._id.charAt(0);
      var offset = ax._offset;
      return axLetter === 'x' ?
          function(d) { return 'translate(' + (offset + ax.l2p(d.periodX !== undefined ? d.periodX : d.x)) + ',0)'; } :
          function(d) { return 'translate(0,' + (offset + ax.l2p(d.periodX !== undefined ? d.periodX : d.x)) + ')'; };
  };
  
  /**
   * Make axis tick path string
   *
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {number} ticklen
   *  - {number} linewidth
   * @param {number} shift along direction of ticklen
   * @param {1 or -1} sgn tick sign
   * @param {number (optional)} len tick length
   * @return {string}
   */
  axes.makeTickPath = function(ax, shift, sgn, len) {
      len = len !== undefined ? len : ax.ticklen;
  
      var axLetter = ax._id.charAt(0);
      var pad = (ax.linewidth || 1) / 2;
  
      return axLetter === 'x' ?
          'M0,' + (shift + pad * sgn) + 'v' + (len * sgn) :
          'M' + (shift + pad * sgn) + ',0h' + (len * sgn);
  };
  
  /**
   * Make axis tick label x, y and anchor functions
   *
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {string} ticks
   *  - {number} ticklen
   *  - {string} side
   *  - {number} linewidth
   *  - {number} tickfont.size
   *  - {boolean} showline
   * @param {number} shift
   * @param {number} angle [in degrees] ...
   * @return {object}
   *  - {fn} xFn
   *  - {fn} yFn
   *  - {fn} anchorFn
   *  - {fn} heightFn
   *  - {number} labelStandoff (gap parallel to ticks)
   *  - {number} labelShift (gap perpendicular to ticks)
   */
  axes.makeLabelFns = function(ax, shift, angle) {
      var axLetter = ax._id.charAt(0);
      var ticksOnOutsideLabels = ax.tickson !== 'boundaries' && ax.ticks === 'outside';
  
      var labelStandoff = 0;
      var labelShift = 0;
  
      if(ticksOnOutsideLabels) {
          labelStandoff += ax.ticklen;
      }
      if(angle && ax.ticks === 'outside') {
          var rad = Lib.deg2rad(angle);
          labelStandoff = ax.ticklen * Math.cos(rad) + 1;
          labelShift = ax.ticklen * Math.sin(rad);
      }
      if(ax.showticklabels && (ticksOnOutsideLabels || ax.showline)) {
          labelStandoff += 0.2 * ax.tickfont.size;
      }
      labelStandoff += (ax.linewidth || 1) / 2;
  
      var out = {
          labelStandoff: labelStandoff,
          labelShift: labelShift
      };
  
      var x0, y0, ff, flipIt;
  
      if(axLetter === 'x') {
          flipIt = ax.side === 'bottom' ? 1 : -1;
          x0 = labelShift * flipIt;
          y0 = shift + labelStandoff * flipIt;
          ff = ax.side === 'bottom' ? 1 : -0.2;
  
          out.xFn = function(d) { return d.dx + x0; };
          out.yFn = function(d) { return d.dy + y0 + d.fontSize * ff; };
          out.anchorFn = function(d, a) {
              if(!isNumeric(a) || a === 0 || a === 180) {
                  return 'middle';
              }
              return (a * flipIt < 0) ? 'end' : 'start';
          };
          out.heightFn = function(d, a, h) {
              return (a < -60 || a > 60) ? -0.5 * h :
                  ax.side === 'top' ? -h :
                  0;
          };
      } else if(axLetter === 'y') {
          flipIt = ax.side === 'right' ? 1 : -1;
          x0 = labelStandoff;
          y0 = -labelShift * flipIt;
          ff = Math.abs(ax.tickangle) === 90 ? 0.5 : 0;
  
          out.xFn = function(d) { return d.dx + shift + (x0 + d.fontSize * ff) * flipIt; };
          out.yFn = function(d) { return d.dy + y0 + d.fontSize * MID_SHIFT; };
          out.anchorFn = function(d, a) {
              if(isNumeric(a) && Math.abs(a) === 90) {
                  return 'middle';
              }
              return ax.side === 'right' ? 'start' : 'end';
          };
          out.heightFn = function(d, a, h) {
              a *= ax.side === 'left' ? 1 : -1;
              return a < -30 ? -h :
                  a < 30 ? -0.5 * h :
                  0;
          };
      }
  
      return out;
  };
  
  function tickDataFn(d) {
      return [d.text, d.x, d.axInfo, d.font, d.fontSize, d.fontColor].join('_');
  }
  
  /**
   * Draw axis ticks
   *
   * @param {DOM element} gd
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {string} ticks
   *  - {number} linewidth
   *  - {string} tickcolor
   * @param {object} opts
   * - {array of object} vals (calcTicks output-like)
   * - {d3 selection} layer
   * - {string or fn} path
   * - {fn} transFn
   * - {boolean} crisp (set to false to unset crisp-edge SVG rendering)
   */
  axes.drawTicks = function(gd, ax, opts) {
      opts = opts || {};
  
      var cls = ax._id + 'tick';
  
      var vals = opts.vals;
      if(
          ax.ticklabelmode === 'period'
      ) {
          // drop very first tick that we added to handle period
          vals = vals.slice();
          vals.shift();
      }
  
      var ticks = opts.layer.selectAll('path.' + cls)
          .data(ax.ticks ? vals : [], tickDataFn);
  
      ticks.exit().remove();
  
      ticks.enter().append('path')
          .classed(cls, 1)
          .classed('ticks', 1)
          .classed('crisp', opts.crisp !== false)
          .call(Color.stroke, ax.tickcolor)
          .style('stroke-width', Drawing.crispRound(gd, ax.tickwidth, 1) + 'px')
          .attr('d', opts.path);
  
      ticks.attr('transform', opts.transFn);
  };
  
  /**
   * Draw axis grid
   *
   * @param {DOM element} gd
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {boolean} showgrid
   *  - {string} gridcolor
   *  - {string} gridwidth
   *  - {boolean} zeroline
   *  - {string} type
   *  - {string} dtick
   * @param {object} opts
   * - {array of object} vals (calcTicks output-like)
   * - {d3 selection} layer
   * - {object} counterAxis (full axis object corresponding to counter axis)
   *     optional - only required if this axis supports zero lines
   * - {string or fn} path
   * - {fn} transFn
   * - {boolean} crisp (set to false to unset crisp-edge SVG rendering)
   */
  axes.drawGrid = function(gd, ax, opts) {
      opts = opts || {};
  
      var cls = ax._id + 'grid';
      var vals = opts.vals;
      var counterAx = opts.counterAxis;
      if(ax.showgrid === false) {
          vals = [];
      } else if(counterAx && axes.shouldShowZeroLine(gd, ax, counterAx)) {
          var isArrayMode = ax.tickmode === 'array';
          for(var i = 0; i < vals.length; i++) {
              var xi = vals[i].x;
              if(isArrayMode ? !xi : (Math.abs(xi) < ax.dtick / 100)) {
                  vals = vals.slice(0, i).concat(vals.slice(i + 1));
                  // In array mode you can in principle have multiple
                  // ticks at 0, so test them all. Otherwise once we found
                  // one we can stop.
                  if(isArrayMode) i--;
                  else break;
              }
          }
      }
  
      var grid = opts.layer.selectAll('path.' + cls)
          .data(vals, tickDataFn);
  
      grid.exit().remove();
  
      grid.enter().append('path')
          .classed(cls, 1)
          .classed('crisp', opts.crisp !== false);
  
      ax._gw = Drawing.crispRound(gd, ax.gridwidth, 1);
  
      grid.attr('transform', opts.transFn)
          .attr('d', opts.path)
          .call(Color.stroke, ax.gridcolor || '#ddd')
          .style('stroke-width', ax._gw + 'px');
  
      if(typeof opts.path === 'function') grid.attr('d', opts.path);
  };
  
  /**
   * Draw axis zero-line
   *
   * @param {DOM element} gd
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {boolean} zeroline
   *  - {number} zerolinewidth
   *  - {string} zerolinecolor
   *  - {number (optional)} _gridWidthCrispRound
   * @param {object} opts
   * - {d3 selection} layer
   * - {object} counterAxis (full axis object corresponding to counter axis)
   * - {string or fn} path
   * - {fn} transFn
   * - {boolean} crisp (set to false to unset crisp-edge SVG rendering)
   */
  axes.drawZeroLine = function(gd, ax, opts) {
      opts = opts || opts;
  
      var cls = ax._id + 'zl';
      var show = axes.shouldShowZeroLine(gd, ax, opts.counterAxis);
  
      var zl = opts.layer.selectAll('path.' + cls)
          .data(show ? [{x: 0, id: ax._id}] : []);
  
      zl.exit().remove();
  
      zl.enter().append('path')
          .classed(cls, 1)
          .classed('zl', 1)
          .classed('crisp', opts.crisp !== false)
          .each(function() {
              // use the fact that only one element can enter to trigger a sort.
              // If several zerolines enter at the same time we will sort once per,
              // but generally this should be a minimal overhead.
              opts.layer.selectAll('path').sort(function(da, db) {
                  return axisIds.idSort(da.id, db.id);
              });
          });
  
      zl.attr('transform', opts.transFn)
          .attr('d', opts.path)
          .call(Color.stroke, ax.zerolinecolor || Color.defaultLine)
          .style('stroke-width', Drawing.crispRound(gd, ax.zerolinewidth, ax._gw || 1) + 'px');
  };
  
  /**
   * Draw axis tick labels
   *
   * @param {DOM element} gd
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {boolean} showticklabels
   *  - {number} tickangle
   *  - {object (optional)} _selections
   *  - {object} (optional)} _tickAngles
   *  - {object} (optional)} _prevTickAngles
   * @param {object} opts
   * - {array of object} vals (calcTicks output-like)
   * - {d3 selection} layer
   * - {string (optional)} cls (node className)
   * - {boolean} repositionOnUpdate (set to true to reposition update selection)
   * - {boolean} secondary
   * - {fn} transFn
   * - {object} labelFns
   *  + {fn} xFn
   *  + {fn} yFn
   *  + {fn} anchorFn
   *  + {fn} heightFn
   */
  axes.drawLabels = function(gd, ax, opts) {
      opts = opts || {};
  
      var fullLayout = gd._fullLayout;
      var axId = ax._id;
      var axLetter = axId.charAt(0);
      var cls = opts.cls || axId + 'tick';
      var vals = opts.vals;
  
      var labelFns = opts.labelFns;
      var tickAngle = opts.secondary ? 0 : ax.tickangle;
      var prevAngle = (ax._prevTickAngles || {})[cls];
  
      var tickLabels = opts.layer.selectAll('g.' + cls)
          .data(ax.showticklabels ? vals : [], tickDataFn);
  
      var labelsReady = [];
  
      tickLabels.enter().append('g')
          .classed(cls, 1)
          .append('text')
              // only so tex has predictable alignment that we can
              // alter later
              .attr('text-anchor', 'middle')
              .each(function(d) {
                  var thisLabel = d3.select(this);
                  var newPromise = gd._promises.length;
  
                  thisLabel
                      .call(svgTextUtils.positionText, labelFns.xFn(d), labelFns.yFn(d))
                      .call(Drawing.font, d.font, d.fontSize, d.fontColor)
                      .text(d.text)
                      .call(svgTextUtils.convertToTspans, gd);
  
                  if(gd._promises[newPromise]) {
                      // if we have an async label, we'll deal with that
                      // all here so take it out of gd._promises and
                      // instead position the label and promise this in
                      // labelsReady
                      labelsReady.push(gd._promises.pop().then(function() {
                          positionLabels(thisLabel, tickAngle);
                      }));
                  } else {
                      // sync label: just position it now.
                      positionLabels(thisLabel, tickAngle);
                  }
              });
  
      tickLabels.exit().remove();
  
      if(opts.repositionOnUpdate) {
          tickLabels.each(function(d) {
              d3.select(this).select('text')
                  .call(svgTextUtils.positionText, labelFns.xFn(d), labelFns.yFn(d));
          });
      }
  
      function positionLabels(s, angle) {
          s.each(function(d) {
              var thisLabel = d3.select(this);
              var mathjaxGroup = thisLabel.select('.text-math-group');
              var anchor = labelFns.anchorFn(d, angle);
  
              var transform = opts.transFn.call(thisLabel.node(), d) +
                  ((isNumeric(angle) && +angle !== 0) ?
                  (' rotate(' + angle + ',' + labelFns.xFn(d) + ',' +
                      (labelFns.yFn(d) - d.fontSize / 2) + ')') :
                  '');
  
              // how much to shift a multi-line label to center it vertically.
              var nLines = svgTextUtils.lineCount(thisLabel);
              var lineHeight = LINE_SPACING * d.fontSize;
              var anchorHeight = labelFns.heightFn(d, isNumeric(angle) ? +angle : 0, (nLines - 1) * lineHeight);
  
              if(anchorHeight) {
                  transform += ' translate(0, ' + anchorHeight + ')';
              }
  
              if(mathjaxGroup.empty()) {
                  thisLabel.select('text').attr({
                      transform: transform,
                      'text-anchor': anchor
                  });
              } else {
                  var mjWidth = Drawing.bBox(mathjaxGroup.node()).width;
                  var mjShift = mjWidth * {end: -0.5, start: 0.5}[anchor];
                  mathjaxGroup.attr('transform', transform + (mjShift ? 'translate(' + mjShift + ',0)' : ''));
              }
          });
      }
  
      // make sure all labels are correctly positioned at their base angle
      // the positionLabels call above is only for newly drawn labels.
      // do this without waiting, using the last calculated angle to
      // minimize flicker, then do it again when we know all labels are
      // there, putting back the prescribed angle to check for overlaps.
      positionLabels(tickLabels, (prevAngle + 1) ? prevAngle : tickAngle);
  
      function allLabelsReady() {
          return labelsReady.length && Promise.all(labelsReady);
      }
  
      var autoangle = null;
  
      function fixLabelOverlaps() {
          positionLabels(tickLabels, tickAngle);
  
          // check for auto-angling if x labels overlap
          // don't auto-angle at all for log axes with
          // base and digit format
          if(vals.length && axLetter === 'x' && !isNumeric(tickAngle) &&
              (ax.type !== 'log' || String(ax.dtick).charAt(0) !== 'D')
          ) {
              autoangle = 0;
  
              var maxFontSize = 0;
              var lbbArray = [];
              var i;
  
              tickLabels.each(function(d) {
                  maxFontSize = Math.max(maxFontSize, d.fontSize);
  
                  var x = ax.l2p(d.x);
                  var thisLabel = selectTickLabel(this);
                  var bb = Drawing.bBox(thisLabel.node());
  
                  lbbArray.push({
                      // ignore about y, just deal with x overlaps
                      top: 0,
                      bottom: 10,
                      height: 10,
                      left: x - bb.width / 2,
                      // impose a 2px gap
                      right: x + bb.width / 2 + 2,
                      width: bb.width + 2
                  });
              });
  
              if((ax.tickson === 'boundaries' || ax.showdividers) && !opts.secondary) {
                  var gap = 2;
                  if(ax.ticks) gap += ax.tickwidth / 2;
  
                  // TODO should secondary labels also fall into this fix-overlap regime?
  
                  for(i = 0; i < lbbArray.length; i++) {
                      var xbnd = vals[i].xbnd;
                      var lbb = lbbArray[i];
                      if(
                          (xbnd[0] !== null && (lbb.left - ax.l2p(xbnd[0])) < gap) ||
                          (xbnd[1] !== null && (ax.l2p(xbnd[1]) - lbb.right) < gap)
                      ) {
                          autoangle = 90;
                          break;
                      }
                  }
              } else {
                  var vLen = vals.length;
                  var tickSpacing = Math.abs((vals[vLen - 1].x - vals[0].x) * ax._m) / (vLen - 1);
                  var rotate90 = (tickSpacing < maxFontSize * 2.5) || ax.type === 'multicategory';
  
                  // any overlap at all - set 30 degrees or 90 degrees
                  for(i = 0; i < lbbArray.length - 1; i++) {
                      if(Lib.bBoxIntersect(lbbArray[i], lbbArray[i + 1])) {
                          autoangle = rotate90 ? 90 : 30;
                          break;
                      }
                  }
              }
  
              if(autoangle) {
                  positionLabels(tickLabels, autoangle);
              }
          }
      }
  
      if(ax._selections) {
          ax._selections[cls] = tickLabels;
      }
  
      var seq = [allLabelsReady];
  
      // N.B. during auto-margin redraws, if the axis fixed its label overlaps
      // by rotating 90 degrees, do not attempt to re-fix its label overlaps
      // as this can lead to infinite redraw loops!
      if(ax.automargin && fullLayout._redrawFromAutoMarginCount && prevAngle === 90) {
          autoangle = 90;
          seq.push(function() {
              positionLabels(tickLabels, prevAngle);
          });
      } else {
          seq.push(fixLabelOverlaps);
      }
  
      // save current tick angle for future redraws
      if(ax._tickAngles) {
          seq.push(function() {
              ax._tickAngles[cls] = autoangle === null ?
                  (isNumeric(tickAngle) ? tickAngle : 0) :
                  autoangle;
          });
      }
  
      var done = Lib.syncOrAsync(seq);
      if(done && done.then) gd._promises.push(done);
      return done;
  };
  
  /**
   * Draw axis dividers
   *
   * @param {DOM element} gd
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {string} showdividers
   *  - {number} dividerwidth
   *  - {string} dividercolor
   * @param {object} opts
   * - {array of object} vals (calcTicks output-like)
   * - {d3 selection} layer
   * - {fn} path
   * - {fn} transFn
   */
  function drawDividers(gd, ax, opts) {
      var cls = ax._id + 'divider';
      var vals = opts.vals;
  
      var dividers = opts.layer.selectAll('path.' + cls)
          .data(vals, tickDataFn);
  
      dividers.exit().remove();
  
      dividers.enter().insert('path', ':first-child')
          .classed(cls, 1)
          .classed('crisp', 1)
          .call(Color.stroke, ax.dividercolor)
          .style('stroke-width', Drawing.crispRound(gd, ax.dividerwidth, 1) + 'px');
  
      dividers
          .attr('transform', opts.transFn)
          .attr('d', opts.path);
  }
  
  /**
   * Get axis position in px, that is the distance for the graph's
   * top (left) edge for x (y) axes.
   *
   * @param {DOM element} gd
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {string} side
   *  if anchored:
   *  - {object} _anchorAxis
   *  Otherwise:
   *  - {number} position
   * @return {number}
   */
  axes.getPxPosition = function(gd, ax) {
      var gs = gd._fullLayout._size;
      var axLetter = ax._id.charAt(0);
      var side = ax.side;
      var anchorAxis;
  
      if(ax.anchor !== 'free') {
          anchorAxis = ax._anchorAxis;
      } else if(axLetter === 'x') {
          anchorAxis = {
              _offset: gs.t + (1 - (ax.position || 0)) * gs.h,
              _length: 0
          };
      } else if(axLetter === 'y') {
          anchorAxis = {
              _offset: gs.l + (ax.position || 0) * gs.w,
              _length: 0
          };
      }
  
      if(side === 'top' || side === 'left') {
          return anchorAxis._offset;
      } else if(side === 'bottom' || side === 'right') {
          return anchorAxis._offset + anchorAxis._length;
      }
  };
  
  /**
   * Approximate axis title depth (w/o computing its bounding box)
   *
   * @param {object} ax (full) axis object
   *  - {string} title.text
   *  - {number} title.font.size
   *  - {number} title.standoff
   * @return {number} (in px)
   */
  function approxTitleDepth(ax) {
      var fontSize = ax.title.font.size;
      var extraLines = (ax.title.text.match(svgTextUtils.BR_TAG_ALL) || []).length;
      if(ax.title.hasOwnProperty('standoff')) {
          return extraLines ?
              fontSize * (CAP_SHIFT + (extraLines * LINE_SPACING)) :
              fontSize * CAP_SHIFT;
      } else {
          return extraLines ?
              fontSize * (extraLines + 1) * LINE_SPACING :
              fontSize;
      }
  }
  
  /**
   * Draw axis title, compute default standoff if necessary
   *
   * @param {DOM element} gd
   * @param {object} ax (full) axis object
   *  - {string} _id
   *  - {string} _name
   *  - {string} side
   *  - {number} title.font.size
   *  - {object} _selections
   *
   *  - {number} _depth
   *  - {number} title.standoff
   *  OR
   *  - {number} linewidth
   *  - {boolean} showticklabels
   */
  function drawTitle(gd, ax) {
      var fullLayout = gd._fullLayout;
      var axId = ax._id;
      var axLetter = axId.charAt(0);
      var fontSize = ax.title.font.size;
  
      var titleStandoff;
  
      if(ax.title.hasOwnProperty('standoff')) {
          titleStandoff = ax._depth + ax.title.standoff + approxTitleDepth(ax);
      } else {
          if(ax.type === 'multicategory') {
              titleStandoff = ax._depth;
          } else {
              var offsetBase = 1.5;
              titleStandoff = 10 + fontSize * offsetBase + (ax.linewidth ? ax.linewidth - 1 : 0);
          }
  
          if(axLetter === 'x') {
              titleStandoff += ax.side === 'top' ?
                  fontSize * (ax.showticklabels ? 1 : 0) :
                  fontSize * (ax.showticklabels ? 1.5 : 0.5);
          } else {
              titleStandoff += ax.side === 'right' ?
                  fontSize * (ax.showticklabels ? 1 : 0.5) :
                  fontSize * (ax.showticklabels ? 0.5 : 0);
          }
      }
  
      var pos = axes.getPxPosition(gd, ax);
      var transform, x, y;
  
      if(axLetter === 'x') {
          x = ax._offset + ax._length / 2;
          y = (ax.side === 'top') ? pos - titleStandoff : pos + titleStandoff;
      } else {
          y = ax._offset + ax._length / 2;
          x = (ax.side === 'right') ? pos + titleStandoff : pos - titleStandoff;
          transform = {rotate: '-90', offset: 0};
      }
  
      var avoid;
  
      if(ax.type !== 'multicategory') {
          var tickLabels = ax._selections[ax._id + 'tick'];
  
          avoid = {
              selection: tickLabels,
              side: ax.side
          };
  
          if(tickLabels && tickLabels.node() && tickLabels.node().parentNode) {
              var translation = Drawing.getTranslate(tickLabels.node().parentNode);
              avoid.offsetLeft = translation.x;
              avoid.offsetTop = translation.y;
          }
  
          if(ax.title.hasOwnProperty('standoff')) {
              avoid.pad = 0;
          }
      }
  
      return Titles.draw(gd, axId + 'title', {
          propContainer: ax,
          propName: ax._name + '.title.text',
          placeholder: fullLayout._dfltTitle[axLetter],
          avoid: avoid,
          transform: transform,
          attributes: {x: x, y: y, 'text-anchor': 'middle'}
      });
  }
  
  axes.shouldShowZeroLine = function(gd, ax, counterAxis) {
      var rng = Lib.simpleMap(ax.range, ax.r2l);
      return (
          (rng[0] * rng[1] <= 0) &&
          ax.zeroline &&
          (ax.type === 'linear' || ax.type === '-') &&
          !(ax.rangebreaks && ax.maskBreaks(0) === BADNUM) &&
          (
              clipEnds(ax, 0) ||
              !anyCounterAxLineAtZero(gd, ax, counterAxis, rng) ||
              hasBarsOrFill(gd, ax)
          )
      );
  };
  
  axes.clipEnds = function(ax, vals) {
      return vals.filter(function(d) { return clipEnds(ax, d.x); });
  };
  
  function clipEnds(ax, l) {
      var p = ax.l2p(l);
      return (p > 1 && p < ax._length - 1);
  }
  
  function anyCounterAxLineAtZero(gd, ax, counterAxis, rng) {
      var mainCounterAxis = counterAxis._mainAxis;
      if(!mainCounterAxis) return;
  
      var fullLayout = gd._fullLayout;
      var axLetter = ax._id.charAt(0);
      var counterLetter = axes.counterLetter(ax._id);
  
      var zeroPosition = ax._offset + (
          ((Math.abs(rng[0]) < Math.abs(rng[1])) === (axLetter === 'x')) ?
          0 : ax._length
      );
  
      function lineNearZero(ax2) {
          if(!ax2.showline || !ax2.linewidth) return false;
          var tolerance = Math.max((ax2.linewidth + ax.zerolinewidth) / 2, 1);
  
          function closeEnough(pos2) {
              return typeof pos2 === 'number' && Math.abs(pos2 - zeroPosition) < tolerance;
          }
  
          if(closeEnough(ax2._mainLinePosition) || closeEnough(ax2._mainMirrorPosition)) {
              return true;
          }
          var linePositions = ax2._linepositions || {};
          for(var k in linePositions) {
              if(closeEnough(linePositions[k][0]) || closeEnough(linePositions[k][1])) {
                  return true;
              }
          }
      }
  
      var plotinfo = fullLayout._plots[counterAxis._mainSubplot];
      if(!(plotinfo.mainplotinfo || plotinfo).overlays.length) {
          return lineNearZero(counterAxis, zeroPosition);
      }
  
      var counterLetterAxes = axes.list(gd, counterLetter);
      for(var i = 0; i < counterLetterAxes.length; i++) {
          var counterAxis2 = counterLetterAxes[i];
          if(
              counterAxis2._mainAxis === mainCounterAxis &&
              lineNearZero(counterAxis2, zeroPosition)
          ) {
              return true;
          }
      }
  }
  
  function hasBarsOrFill(gd, ax) {
      var fullData = gd._fullData;
      var subplot = ax._mainSubplot;
      var axLetter = ax._id.charAt(0);
  
      for(var i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
  
          if(trace.visible === true && (trace.xaxis + trace.yaxis) === subplot) {
              if(
                  Registry.traceIs(trace, 'bar-like') &&
                  trace.orientation === {x: 'h', y: 'v'}[axLetter]
              ) return true;
  
              if(
                  trace.fill &&
                  trace.fill.charAt(trace.fill.length - 1) === axLetter
              ) return true;
          }
      }
      return false;
  }
  
  function selectTickLabel(gTick) {
      var s = d3.select(gTick);
      var mj = s.select('.text-math-group');
      return mj.empty() ? s.select('text') : mj;
  }
  
  /**
   * Find all margin pushers for 2D axes and reserve them for later use
   * Both label and rangeslider automargin calculations happen later so
   * we need to explicitly allow their ids in order to not delete them.
   *
   * TODO: can we pull the actual automargin calls forward to avoid this hack?
   * We're probably also doing multiple redraws in this case, would be faster
   * if we can just do the whole calculation ahead of time and draw once.
   */
  axes.allowAutoMargin = function(gd) {
      var axList = axes.list(gd, '', true);
      for(var i = 0; i < axList.length; i++) {
          var ax = axList[i];
          if(ax.automargin) {
              Plots.allowAutoMargin(gd, axAutoMarginID(ax));
              if(ax.mirror) {
                  Plots.allowAutoMargin(gd, axMirrorAutoMarginID(ax));
              }
          }
          if(Registry.getComponentMethod('rangeslider', 'isVisible')(ax)) {
              Plots.allowAutoMargin(gd, rangeSliderAutoMarginID(ax));
          }
      }
  };
  
  function axAutoMarginID(ax) { return ax._id + '.automargin'; }
  function axMirrorAutoMarginID(ax) { return axAutoMarginID(ax) + '.mirror'; }
  function rangeSliderAutoMarginID(ax) { return ax._id + '.rangeslider'; }
  
  // swap all the presentation attributes of the axes showing these traces
  axes.swap = function(gd, traces) {
      var axGroups = makeAxisGroups(gd, traces);
  
      for(var i = 0; i < axGroups.length; i++) {
          swapAxisGroup(gd, axGroups[i].x, axGroups[i].y);
      }
  };
  
  function makeAxisGroups(gd, traces) {
      var groups = [];
      var i, j;
  
      for(i = 0; i < traces.length; i++) {
          var groupsi = [];
          var xi = gd._fullData[traces[i]].xaxis;
          var yi = gd._fullData[traces[i]].yaxis;
          if(!xi || !yi) continue; // not a 2D cartesian trace?
  
          for(j = 0; j < groups.length; j++) {
              if(groups[j].x.indexOf(xi) !== -1 || groups[j].y.indexOf(yi) !== -1) {
                  groupsi.push(j);
              }
          }
  
          if(!groupsi.length) {
              groups.push({x: [xi], y: [yi]});
              continue;
          }
  
          var group0 = groups[groupsi[0]];
          var groupj;
  
          if(groupsi.length > 1) {
              for(j = 1; j < groupsi.length; j++) {
                  groupj = groups[groupsi[j]];
                  mergeAxisGroups(group0.x, groupj.x);
                  mergeAxisGroups(group0.y, groupj.y);
              }
          }
          mergeAxisGroups(group0.x, [xi]);
          mergeAxisGroups(group0.y, [yi]);
      }
  
      return groups;
  }
  
  function mergeAxisGroups(intoSet, fromSet) {
      for(var i = 0; i < fromSet.length; i++) {
          if(intoSet.indexOf(fromSet[i]) === -1) intoSet.push(fromSet[i]);
      }
  }
  
  function swapAxisGroup(gd, xIds, yIds) {
      var xFullAxes = [];
      var yFullAxes = [];
      var layout = gd.layout;
      var i, j;
  
      for(i = 0; i < xIds.length; i++) xFullAxes.push(axes.getFromId(gd, xIds[i]));
      for(i = 0; i < yIds.length; i++) yFullAxes.push(axes.getFromId(gd, yIds[i]));
  
      var allAxKeys = Object.keys(axAttrs);
  
      var noSwapAttrs = [
          'anchor', 'domain', 'overlaying', 'position', 'side', 'tickangle', 'editType'
      ];
      var numericTypes = ['linear', 'log'];
  
      for(i = 0; i < allAxKeys.length; i++) {
          var keyi = allAxKeys[i];
          var xVal = xFullAxes[0][keyi];
          var yVal = yFullAxes[0][keyi];
          var allEqual = true;
          var coerceLinearX = false;
          var coerceLinearY = false;
          if(keyi.charAt(0) === '_' || typeof xVal === 'function' ||
                  noSwapAttrs.indexOf(keyi) !== -1) {
              continue;
          }
          for(j = 1; j < xFullAxes.length && allEqual; j++) {
              var xVali = xFullAxes[j][keyi];
              if(keyi === 'type' && numericTypes.indexOf(xVal) !== -1 &&
                      numericTypes.indexOf(xVali) !== -1 && xVal !== xVali) {
                  // type is special - if we find a mixture of linear and log,
                  // coerce them all to linear on flipping
                  coerceLinearX = true;
              } else if(xVali !== xVal) allEqual = false;
          }
          for(j = 1; j < yFullAxes.length && allEqual; j++) {
              var yVali = yFullAxes[j][keyi];
              if(keyi === 'type' && numericTypes.indexOf(yVal) !== -1 &&
                      numericTypes.indexOf(yVali) !== -1 && yVal !== yVali) {
                  // type is special - if we find a mixture of linear and log,
                  // coerce them all to linear on flipping
                  coerceLinearY = true;
              } else if(yFullAxes[j][keyi] !== yVal) allEqual = false;
          }
          if(allEqual) {
              if(coerceLinearX) layout[xFullAxes[0]._name].type = 'linear';
              if(coerceLinearY) layout[yFullAxes[0]._name].type = 'linear';
              swapAxisAttrs(layout, keyi, xFullAxes, yFullAxes, gd._fullLayout._dfltTitle);
          }
      }
  
      // now swap x&y for any annotations anchored to these x & y
      for(i = 0; i < gd._fullLayout.annotations.length; i++) {
          var ann = gd._fullLayout.annotations[i];
          if(xIds.indexOf(ann.xref) !== -1 &&
                  yIds.indexOf(ann.yref) !== -1) {
              Lib.swapAttrs(layout.annotations[i], ['?']);
          }
      }
  }
  
  function swapAxisAttrs(layout, key, xFullAxes, yFullAxes, dfltTitle) {
      // in case the value is the default for either axis,
      // look at the first axis in each list and see if
      // this key's value is undefined
      var np = Lib.nestedProperty;
      var xVal = np(layout[xFullAxes[0]._name], key).get();
      var yVal = np(layout[yFullAxes[0]._name], key).get();
      var i;
  
      if(key === 'title') {
          // special handling of placeholder titles
          if(xVal && xVal.text === dfltTitle.x) {
              xVal.text = dfltTitle.y;
          }
          if(yVal && yVal.text === dfltTitle.y) {
              yVal.text = dfltTitle.x;
          }
      }
  
      for(i = 0; i < xFullAxes.length; i++) {
          np(layout, xFullAxes[i]._name + '.' + key).set(yVal);
      }
      for(i = 0; i < yFullAxes.length; i++) {
          np(layout, yFullAxes[i]._name + '.' + key).set(xVal);
      }
  }
  
  function isAngular(ax) {
      return ax._id === 'angularaxis';
  }
  
  function moveOutsideBreak(v, ax) {
      var len = ax._rangebreaks.length;
      for(var k = 0; k < len; k++) {
          var brk = ax._rangebreaks[k];
          if(v >= brk.min && v < brk.max) {
              return brk.max;
          }
      }
      return v;
  }
  
  },{"../../components/color":615,"../../components/drawing":637,"../../components/titles":710,"../../constants/alignment":717,"../../constants/numerical":725,"../../lib":750,"../../lib/svg_text_utils":774,"../../plots/plots":862,"../../registry":882,"./autorange":798,"./axis_autotype":800,"./axis_ids":802,"./clean_ticks":804,"./layout_attributes":813,"./set_convert":819,"d3":169,"fast-isnumeric":241}],800:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  module.exports = function autoType(array, calendar, opts) {
      opts = opts || {};
  
      if(!opts.noMultiCategory && multiCategory(array)) return 'multicategory';
      if(moreDates(array, calendar)) return 'date';
      if(category(array)) return 'category';
      if(linearOK(array)) return 'linear';
      else return '-';
  };
  
  // is there at least one number in array? If not, we should leave
  // ax.type empty so it can be autoset later
  function linearOK(array) {
      if(!array) return false;
  
      for(var i = 0; i < array.length; i++) {
          if(isNumeric(array[i])) return true;
      }
  
      return false;
  }
  
  // does the array a have mostly dates rather than numbers?
  // note: some values can be neither (such as blanks, text)
  // 2- or 4-digit integers can be both, so require twice as many
  // dates as non-dates, to exclude cases with mostly 2 & 4 digit
  // numbers and a few dates
  // as with categories, consider DISTINCT values only.
  function moreDates(a, calendar) {
      // test at most 1000 points, evenly spaced
      var inc = Math.max(1, (a.length - 1) / 1000);
      var dcnt = 0;
      var ncnt = 0;
      var seen = {};
  
      for(var i = 0; i < a.length; i += inc) {
          var ai = a[Math.round(i)];
          var stri = String(ai);
          if(seen[stri]) continue;
          seen[stri] = 1;
  
          if(Lib.isDateTime(ai, calendar)) dcnt += 1;
          if(isNumeric(ai)) ncnt += 1;
      }
  
      return (dcnt > ncnt * 2);
  }
  
  // are the (x,y)-values in gd.data mostly text?
  // require twice as many DISTINCT categories as distinct numbers
  function category(a) {
      // test at most 1000 points
      var inc = Math.max(1, (a.length - 1) / 1000);
      var curvenums = 0;
      var curvecats = 0;
      var seen = {};
  
      for(var i = 0; i < a.length; i += inc) {
          var ai = a[Math.round(i)];
          var stri = String(ai);
          if(seen[stri]) continue;
          seen[stri] = 1;
  
          if(typeof ai === 'boolean') curvecats++;
          else if(Lib.cleanNumber(ai) !== BADNUM) curvenums++;
          else if(typeof ai === 'string') curvecats++;
      }
  
      return curvecats > curvenums * 2;
  }
  
  // very-loose requirements for multicategory,
  // trace modules that should never auto-type to multicategory
  // should be declared with 'noMultiCategory'
  function multiCategory(a) {
      return Lib.isArrayOrTypedArray(a[0]) && Lib.isArrayOrTypedArray(a[1]);
  }
  
  },{"../../constants/numerical":725,"../../lib":750,"fast-isnumeric":241}],801:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  
  var handleArrayContainerDefaults = _dereq_('../array_container_defaults');
  
  var layoutAttributes = _dereq_('./layout_attributes');
  var handleTickValueDefaults = _dereq_('./tick_value_defaults');
  var handleTickMarkDefaults = _dereq_('./tick_mark_defaults');
  var handleTickLabelDefaults = _dereq_('./tick_label_defaults');
  var handleCategoryOrderDefaults = _dereq_('./category_order_defaults');
  var handleLineGridDefaults = _dereq_('./line_grid_defaults');
  var setConvert = _dereq_('./set_convert');
  
  var DAY_OF_WEEK = _dereq_('./constants').WEEKDAY_PATTERN;
  var HOUR = _dereq_('./constants').HOUR_PATTERN;
  
  /**
   * options: object containing:
   *
   *  letter: 'x' or 'y'
   *  title: name of the axis (ie 'Colorbar') to go in default title
   *  font: the default font to inherit
   *  outerTicks: boolean, should ticks default to outside?
   *  showGrid: boolean, should gridlines be shown by default?
   *  noHover: boolean, this axis doesn't support hover effects?
   *  noTickson: boolean, this axis doesn't support 'tickson'
   *  data: the plot data, used to manage categories
   *  bgColor: the plot background color, to calculate default gridline colors
   *  calendar:
   *  splomStash:
   *  visibleDflt: boolean
   *  reverseDflt: boolean
   *  automargin: boolean
   */
  module.exports = function handleAxisDefaults(containerIn, containerOut, coerce, options, layoutOut) {
      var letter = options.letter;
      var font = options.font || {};
      var splomStash = options.splomStash || {};
  
      var visible = coerce('visible', !options.visibleDflt);
  
      var axTemplate = containerOut._template || {};
      var axType = containerOut.type || axTemplate.type || '-';
  
      if(axType === 'date') {
          var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleDefaults');
          handleCalendarDefaults(containerIn, containerOut, 'calendar', options.calendar);
      }
  
      setConvert(containerOut, layoutOut);
  
      var autorangeDflt = !containerOut.isValidRange(containerIn.range);
      if(autorangeDflt && options.reverseDflt) autorangeDflt = 'reversed';
      var autoRange = coerce('autorange', autorangeDflt);
      if(autoRange && (axType === 'linear' || axType === '-')) coerce('rangemode');
  
      coerce('range');
      containerOut.cleanRange();
  
      handleCategoryOrderDefaults(containerIn, containerOut, coerce, options);
  
      if(axType !== 'category' && !options.noHover) coerce('hoverformat');
  
      var dfltColor = coerce('color');
      // if axis.color was provided, use it for fonts too; otherwise,
      // inherit from global font color in case that was provided.
      // Compare to dflt rather than to containerIn, so we can provide color via
      // template too.
      var dfltFontColor = (dfltColor !== layoutAttributes.color.dflt) ? dfltColor : font.color;
      // try to get default title from splom trace, fallback to graph-wide value
      var dfltTitle = splomStash.label || layoutOut._dfltTitle[letter];
  
      handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options, {pass: 1});
      if(!visible) return containerOut;
  
      coerce('title.text', dfltTitle);
      Lib.coerceFont(coerce, 'title.font', {
          family: font.family,
          size: Math.round(font.size * 1.2),
          color: dfltFontColor
      });
  
      handleTickValueDefaults(containerIn, containerOut, coerce, axType);
      handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options, {pass: 2});
      handleTickMarkDefaults(containerIn, containerOut, coerce, options);
      handleLineGridDefaults(containerIn, containerOut, coerce, {
          dfltColor: dfltColor,
          bgColor: options.bgColor,
          showGrid: options.showGrid,
          attributes: layoutAttributes
      });
  
      if(containerOut.showline || containerOut.ticks) coerce('mirror');
  
      if(options.automargin) coerce('automargin');
  
      var isMultiCategory = axType === 'multicategory';
  
      if(!options.noTickson &&
          (axType === 'category' || isMultiCategory) &&
          (containerOut.ticks || containerOut.showgrid)
      ) {
          var ticksonDflt;
          if(isMultiCategory) ticksonDflt = 'boundaries';
          coerce('tickson', ticksonDflt);
      }
  
      if(isMultiCategory) {
          var showDividers = coerce('showdividers');
          if(showDividers) {
              coerce('dividercolor');
              coerce('dividerwidth');
          }
      }
  
      if(axType === 'date') {
          if(!options.noTicklabelmode) coerce('ticklabelmode');
  
          handleArrayContainerDefaults(containerIn, containerOut, {
              name: 'rangebreaks',
              inclusionAttr: 'enabled',
              handleItemDefaults: rangebreaksDefaults
          });
  
          if(!containerOut.rangebreaks.length) {
              delete containerOut.rangebreaks;
          } else {
              for(var k = 0; k < containerOut.rangebreaks.length; k++) {
                  if(containerOut.rangebreaks[k].pattern === DAY_OF_WEEK) {
                      containerOut._hasDayOfWeekBreaks = true;
                      break;
                  }
              }
  
              setConvert(containerOut, layoutOut);
  
              if(layoutOut._has('scattergl') || layoutOut._has('splom')) {
                  for(var i = 0; i < options.data.length; i++) {
                      var trace = options.data[i];
                      if(trace.type === 'scattergl' || trace.type === 'splom') {
                          trace.visible = false;
                          Lib.warn(trace.type +
                              ' traces do not work on axes with rangebreaks.' +
                              ' Setting trace ' + trace.index + ' to `visible: false`.');
                      }
                  }
              }
          }
      }
  
      return containerOut;
  };
  
  function rangebreaksDefaults(itemIn, itemOut, containerOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(itemIn, itemOut, layoutAttributes.rangebreaks, attr, dflt);
      }
  
      var enabled = coerce('enabled');
  
      if(enabled) {
          var bnds = coerce('bounds');
          if(bnds && bnds.length >= 2) {
              var dfltPattern = '';
              var i, q;
              if(bnds.length === 2) {
                  for(i = 0; i < 2; i++) {
                      q = indexOfDay(bnds[i]);
                      if(q) {
                          dfltPattern = DAY_OF_WEEK;
                          break;
                      }
                  }
              }
              var pattern = coerce('pattern', dfltPattern);
              if(pattern === DAY_OF_WEEK) {
                  for(i = 0; i < 2; i++) {
                      q = indexOfDay(bnds[i]);
                      if(q) {
                          // convert to integers i.e 'Sunday' --> 0
                          itemOut.bounds[i] = bnds[i] = q - 1;
                      }
                  }
              }
              if(pattern) {
                  // ensure types and ranges
                  for(i = 0; i < 2; i++) {
                      q = bnds[i];
                      switch(pattern) {
                          case DAY_OF_WEEK :
                              if(!isNumeric(q)) {
                                  itemOut.enabled = false;
                                  return;
                              }
                              q = +q;
  
                              if(
                                  q !== Math.floor(q) || // don't accept fractional days for mow
                                  q < 0 || q >= 7
                              ) {
                                  itemOut.enabled = false;
                                  return;
                              }
                              // use number
                              itemOut.bounds[i] = bnds[i] = q;
                              break;
  
                          case HOUR :
                              if(!isNumeric(q)) {
                                  itemOut.enabled = false;
                                  return;
                              }
                              q = +q;
  
                              if(q < 0 || q > 24) { // accept 24
                                  itemOut.enabled = false;
                                  return;
                              }
                              // use number
                              itemOut.bounds[i] = bnds[i] = q;
                              break;
                      }
                  }
              }
  
              if(containerOut.autorange === false) {
                  var rng = containerOut.range;
  
                  // if bounds are bigger than the (set) range, disable break
                  if(rng[0] < rng[1]) {
                      if(bnds[0] < rng[0] && bnds[1] > rng[1]) {
                          itemOut.enabled = false;
                          return;
                      }
                  } else if(bnds[0] > rng[0] && bnds[1] < rng[1]) {
                      itemOut.enabled = false;
                      return;
                  }
              }
          } else {
              var values = coerce('values');
  
              if(values && values.length) {
                  coerce('dvalue');
              } else {
                  itemOut.enabled = false;
                  return;
              }
          }
      }
  }
  
  // these numbers are one more than what bounds would be mapped to
  var dayStrToNum = {
      sun: 1,
      mon: 2,
      tue: 3,
      wed: 4,
      thu: 5,
      fri: 6,
      sat: 7
  };
  
  function indexOfDay(v) {
      if(typeof v !== 'string') return;
      return dayStrToNum[
          v.substr(0, 3).toLowerCase()
      ];
  }
  
  },{"../../lib":750,"../../registry":882,"../array_container_defaults":794,"./category_order_defaults":803,"./constants":805,"./layout_attributes":813,"./line_grid_defaults":815,"./set_convert":819,"./tick_label_defaults":820,"./tick_mark_defaults":821,"./tick_value_defaults":822,"fast-isnumeric":241}],802:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  
  var constants = _dereq_('./constants');
  
  
  // convert between axis names (xaxis, xaxis2, etc, elements of gd.layout)
  // and axis id's (x, x2, etc). Would probably have ditched 'xaxis'
  // completely in favor of just 'x' if it weren't ingrained in the API etc.
  exports.id2name = function id2name(id) {
      if(typeof id !== 'string' || !id.match(constants.AX_ID_PATTERN)) return;
      var axNum = id.split(' ')[0].substr(1);
      if(axNum === '1') axNum = '';
      return id.charAt(0) + 'axis' + axNum;
  };
  
  exports.name2id = function name2id(name) {
      if(!name.match(constants.AX_NAME_PATTERN)) return;
      var axNum = name.substr(5);
      if(axNum === '1') axNum = '';
      return name.charAt(0) + axNum;
  };
  
  /*
   * Cleans up the number of an axis, e.g., 'x002'->'x2', 'x0'->'x', 'x1' -> 'x',
   * etc.
   * If domainId is true, then id could be a domain reference and if it is, the
   * ' domain' part is kept at the end of the axis ID string.
   */
  exports.cleanId = function cleanId(id, axLetter, domainId) {
      var domainTest = /( domain)$/.test(id);
      if(typeof id !== 'string' || !id.match(constants.AX_ID_PATTERN)) return;
      if(axLetter && id.charAt(0) !== axLetter) return;
      if(domainTest && (!domainId)) return;
      var axNum = id.split(' ')[0].substr(1).replace(/^0+/, '');
      if(axNum === '1') axNum = '';
      return id.charAt(0) + axNum + (domainTest && domainId ? ' domain' : '');
  };
  
  // get all axis objects, as restricted in listNames
  exports.list = function(gd, axLetter, only2d) {
      var fullLayout = gd._fullLayout;
      if(!fullLayout) return [];
  
      var idList = exports.listIds(gd, axLetter);
      var out = new Array(idList.length);
      var i;
  
      for(i = 0; i < idList.length; i++) {
          var idi = idList[i];
          out[i] = fullLayout[idi.charAt(0) + 'axis' + idi.substr(1)];
      }
  
      if(!only2d) {
          var sceneIds3D = fullLayout._subplots.gl3d || [];
  
          for(i = 0; i < sceneIds3D.length; i++) {
              var scene = fullLayout[sceneIds3D[i]];
  
              if(axLetter) out.push(scene[axLetter + 'axis']);
              else out.push(scene.xaxis, scene.yaxis, scene.zaxis);
          }
      }
  
      return out;
  };
  
  // get all axis ids, optionally restricted by letter
  // this only makes sense for 2d axes
  exports.listIds = function(gd, axLetter) {
      var fullLayout = gd._fullLayout;
      if(!fullLayout) return [];
  
      var subplotLists = fullLayout._subplots;
      if(axLetter) return subplotLists[axLetter + 'axis'];
      return subplotLists.xaxis.concat(subplotLists.yaxis);
  };
  
  // get an axis object from its id 'x','x2' etc
  // optionally, id can be a subplot (ie 'x2y3') and type gets x or y from it
  exports.getFromId = function(gd, id, type) {
      var fullLayout = gd._fullLayout;
      // remove "domain" suffix
      id = ((id === undefined) || (typeof(id) !== 'string')) ? id : id.replace(' domain', '');
  
      if(type === 'x') id = id.replace(/y[0-9]*/, '');
      else if(type === 'y') id = id.replace(/x[0-9]*/, '');
  
      return fullLayout[exports.id2name(id)];
  };
  
  // get an axis object of specified type from the containing trace
  exports.getFromTrace = function(gd, fullTrace, type) {
      var fullLayout = gd._fullLayout;
      var ax = null;
  
      if(Registry.traceIs(fullTrace, 'gl3d')) {
          var scene = fullTrace.scene;
          if(scene.substr(0, 5) === 'scene') {
              ax = fullLayout[scene][type + 'axis'];
          }
      } else {
          ax = exports.getFromId(gd, fullTrace[type + 'axis'] || type);
      }
  
      return ax;
  };
  
  // sort x, x2, x10, y, y2, y10...
  exports.idSort = function(id1, id2) {
      var letter1 = id1.charAt(0);
      var letter2 = id2.charAt(0);
      if(letter1 !== letter2) return letter1 > letter2 ? 1 : -1;
      return +(id1.substr(1) || 1) - +(id2.substr(1) || 1);
  };
  
  exports.getAxisGroup = function getAxisGroup(fullLayout, axId) {
      var matchGroups = fullLayout._axisMatchGroups;
  
      for(var i = 0; i < matchGroups.length; i++) {
          var group = matchGroups[i];
          if(group[axId]) return 'g' + i;
      }
      return axId;
  };
  
  /*
   * An axis reference (e.g., the contents at the 'xref' key of an object) might
   * have extra information appended. Extract the axis ID only.
   *
   * ar: the axis reference string
   *
   */
  exports.ref2id = function(ar) {
      // This assumes ar has been coerced via coerceRef, and uses the shortcut of
      // checking if the first letter matches [xyz] to determine if it should
      // return the axis ID. Otherwise it returns false.
      return (/^[xyz]/.test(ar)) ? ar.split(' ')[0] : false;
  };
  
  },{"../../registry":882,"./constants":805}],803:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  function findCategories(ax, opts) {
      var dataAttr = opts.dataAttr || ax._id.charAt(0);
      var lookup = {};
      var axData;
      var i, j;
  
      if(opts.axData) {
          // non-x/y case
          axData = opts.axData;
      } else {
          // x/y case
          axData = [];
          for(i = 0; i < opts.data.length; i++) {
              var trace = opts.data[i];
              if(trace[dataAttr + 'axis'] === ax._id) {
                  axData.push(trace);
              }
          }
      }
  
      for(i = 0; i < axData.length; i++) {
          var vals = axData[i][dataAttr];
          for(j = 0; j < vals.length; j++) {
              var v = vals[j];
              if(v !== null && v !== undefined) {
                  lookup[v] = 1;
              }
          }
      }
  
      return Object.keys(lookup);
  }
  
  /**
   * Fills in category* default and initial categories.
   *
   * @param {object} containerIn : input axis object
   * @param {object} containerOut : full axis object
   * @param {function} coerce : Lib.coerce fn wrapper
   * @param {object} opts :
   *   - data {array} : (full) data trace
   * OR
   *   - axData {array} : (full) data associated with axis being coerced here
   *   - dataAttr {string} : attribute name corresponding to coordinate array
   */
  module.exports = function handleCategoryOrderDefaults(containerIn, containerOut, coerce, opts) {
      if(containerOut.type !== 'category') return;
  
      var arrayIn = containerIn.categoryarray;
      var isValidArray = (Array.isArray(arrayIn) && arrayIn.length > 0);
  
      // override default 'categoryorder' value when non-empty array is supplied
      var orderDefault;
      if(isValidArray) orderDefault = 'array';
  
      var order = coerce('categoryorder', orderDefault);
      var array;
  
      // coerce 'categoryarray' only in array order case
      if(order === 'array') {
          array = coerce('categoryarray');
      }
  
      // cannot set 'categoryorder' to 'array' with an invalid 'categoryarray'
      if(!isValidArray && order === 'array') {
          order = containerOut.categoryorder = 'trace';
      }
  
      // set up things for makeCalcdata
      if(order === 'trace') {
          containerOut._initialCategories = [];
      } else if(order === 'array') {
          containerOut._initialCategories = array.slice();
      } else {
          array = findCategories(containerOut, opts).sort();
          if(order === 'category ascending') {
              containerOut._initialCategories = array;
          } else if(order === 'category descending') {
              containerOut._initialCategories = array.reverse();
          }
      }
  };
  
  },{}],804:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var Lib = _dereq_('../../lib');
  var constants = _dereq_('../../constants/numerical');
  var ONEDAY = constants.ONEDAY;
  var ONEWEEK = constants.ONEWEEK;
  
  /**
   * Return a validated dtick value for this axis
   *
   * @param {any} dtick: the candidate dtick. valid values are numbers and strings,
   *     and further constrained depending on the axis type.
   * @param {string} axType: the axis type
   */
  exports.dtick = function(dtick, axType) {
      var isLog = axType === 'log';
      var isDate = axType === 'date';
      var isCat = axType === 'category';
      var dtickDflt = isDate ? ONEDAY : 1;
  
      if(!dtick) return dtickDflt;
  
      if(isNumeric(dtick)) {
          dtick = Number(dtick);
          if(dtick <= 0) return dtickDflt;
          if(isCat) {
              // category dtick must be positive integers
              return Math.max(1, Math.round(dtick));
          }
          if(isDate) {
              // date dtick must be at least 0.1ms (our current precision)
              return Math.max(0.1, dtick);
          }
          return dtick;
      }
  
      if(typeof dtick !== 'string' || !(isDate || isLog)) {
          return dtickDflt;
      }
  
      var prefix = dtick.charAt(0);
      var dtickNum = dtick.substr(1);
      dtickNum = isNumeric(dtickNum) ? Number(dtickNum) : 0;
  
      if((dtickNum <= 0) || !(
              // "M<n>" gives ticks every (integer) n months
              (isDate && prefix === 'M' && dtickNum === Math.round(dtickNum)) ||
              // "L<f>" gives ticks linearly spaced in data (not in position) every (float) f
              (isLog && prefix === 'L') ||
              // "D1" gives powers of 10 with all small digits between, "D2" gives only 2 and 5
              (isLog && prefix === 'D' && (dtickNum === 1 || dtickNum === 2))
          )) {
          return dtickDflt;
      }
  
      return dtick;
  };
  
  /**
   * Return a validated tick0 for this axis
   *
   * @param {any} tick0: the candidate tick0. Valid values are numbers and strings,
   *     further constrained depending on the axis type
   * @param {string} axType: the axis type
   * @param {string} calendar: for date axes, the calendar to validate/convert with
   * @param {any} dtick: an already valid dtick. Only used for D1 and D2 log dticks,
   *     which do not support tick0 at all.
   */
  exports.tick0 = function(tick0, axType, calendar, dtick) {
      if(axType === 'date') {
          return Lib.cleanDate(tick0,
              Lib.dateTick0(calendar, (dtick % ONEWEEK === 0) ? 1 : 0)
          );
      }
      if(dtick === 'D1' || dtick === 'D2') {
          // D1 and D2 modes ignore tick0 entirely
          return undefined;
      }
      // Aside from date axes, tick0 must be numeric
      return isNumeric(tick0) ? Number(tick0) : 0;
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"fast-isnumeric":241}],805:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var counterRegex = _dereq_('../../lib/regex').counter;
  
  module.exports = {
      idRegex: {
          x: counterRegex('x', '( domain)?'),
          y: counterRegex('y', '( domain)?')
      },
  
      attrRegex: counterRegex('[xy]axis'),
  
      // axis match regular expression
      xAxisMatch: counterRegex('xaxis'),
      yAxisMatch: counterRegex('yaxis'),
  
      // pattern matching axis ids and names
      // note that this is more permissive than counterRegex, as
      // id2name, name2id, and cleanId accept "x1" etc
      AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
      AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
  
      // and for 2D subplots
      SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
  
      HOUR_PATTERN: 'hour',
      WEEKDAY_PATTERN: 'day of week',
  
      // pixels to move mouse before you stop clamping to starting point
      MINDRAG: 8,
  
      // smallest dimension allowed for a select box
      MINSELECT: 12,
  
      // smallest dimension allowed for a zoombox
      MINZOOM: 20,
  
      // width of axis drag regions
      DRAGGERSIZE: 20,
  
      // max pixels off straight before a lasso select line counts as bent
      BENDPX: 1.5,
  
      // delay before a redraw (relayout) after smooth panning and zooming
      REDRAWDELAY: 50,
  
      // throttling limit (ms) for selectPoints calls
      SELECTDELAY: 100,
  
      // cache ID suffix for throttle
      SELECTID: '-select',
  
      // last resort axis ranges for x and y axes if we have no data
      DFLTRANGEX: [-1, 6],
      DFLTRANGEY: [-1, 4],
  
      // Layers to keep trace types in the right order
      // N.B. each  'unique' plot method must have its own layer
      traceLayerClasses: [
          'imagelayer',
          'heatmaplayer',
          'contourcarpetlayer', 'contourlayer',
          'funnellayer', 'waterfalllayer', 'barlayer',
          'carpetlayer',
          'violinlayer',
          'boxlayer',
          'ohlclayer',
          'scattercarpetlayer', 'scatterlayer'
      ],
  
      clipOnAxisFalseQuery: [
          '.scatterlayer',
          '.barlayer',
          '.funnellayer',
          '.waterfalllayer'
      ],
  
      layerValue2layerClass: {
          'above traces': 'above',
          'below traces': 'below'
      }
  };
  
  },{"../../lib/regex":766}],806:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var id2name = _dereq_('./axis_ids').id2name;
  var scaleZoom = _dereq_('./scale_zoom');
  var makePadFn = _dereq_('./autorange').makePadFn;
  var concatExtremes = _dereq_('./autorange').concatExtremes;
  
  var ALMOST_EQUAL = _dereq_('../../constants/numerical').ALMOST_EQUAL;
  var FROM_BL = _dereq_('../../constants/alignment').FROM_BL;
  
  exports.handleConstraintDefaults = function(containerIn, containerOut, coerce, opts) {
      var allAxisIds = opts.allAxisIds;
      var layoutOut = opts.layoutOut;
      var scaleanchorDflt = opts.scaleanchorDflt;
      var constrainDflt = opts.constrainDflt;
      var constraintGroups = layoutOut._axisConstraintGroups;
      var matchGroups = layoutOut._axisMatchGroups;
      var axId = containerOut._id;
      var axLetter = axId.charAt(0);
      var splomStash = ((layoutOut._splomAxes || {})[axLetter] || {})[axId] || {};
      var thisID = containerOut._id;
      var letter = thisID.charAt(0);
  
      // coerce the constraint mechanics even if this axis has no scaleanchor
      // because it may be the anchor of another axis.
      var constrain = coerce('constrain', constrainDflt);
      Lib.coerce(containerIn, containerOut, {
          constraintoward: {
              valType: 'enumerated',
              values: letter === 'x' ? ['left', 'center', 'right'] : ['bottom', 'middle', 'top'],
              dflt: letter === 'x' ? 'center' : 'middle'
          }
      }, 'constraintoward');
  
      var matches, matchOpts;
  
      if((containerIn.matches || splomStash.matches) && !containerOut.fixedrange) {
          matchOpts = getConstraintOpts(matchGroups, thisID, allAxisIds, layoutOut);
          matches = Lib.coerce(containerIn, containerOut, {
              matches: {
                  valType: 'enumerated',
                  values: matchOpts.linkableAxes || [],
                  dflt: splomStash.matches
              }
          }, 'matches');
      }
  
      // 'matches' wins over 'scaleanchor' (for now)
      var scaleanchor, scaleOpts;
  
      if(!matches &&
         !(containerOut.fixedrange && constrain !== 'domain') &&
         (containerIn.scaleanchor || scaleanchorDflt)
       ) {
          scaleOpts = getConstraintOpts(constraintGroups, thisID, allAxisIds, layoutOut, constrain);
          scaleanchor = Lib.coerce(containerIn, containerOut, {
              scaleanchor: {
                  valType: 'enumerated',
                  values: scaleOpts.linkableAxes || []
              }
          }, 'scaleanchor', scaleanchorDflt);
      }
  
      if(matches) {
          delete containerOut.constrain;
          updateConstraintGroups(matchGroups, matchOpts.thisGroup, thisID, matches, 1);
      } else if(allAxisIds.indexOf(containerIn.matches) !== -1) {
          Lib.warn('ignored ' + containerOut._name + '.matches: "' +
              containerIn.matches + '" to avoid either an infinite loop ' +
              'or because the target axis has fixed range.');
      }
  
      if(scaleanchor) {
          var scaleratio = coerce('scaleratio');
  
          // TODO: I suppose I could do attribute.min: Number.MIN_VALUE to avoid zero,
          // but that seems hacky. Better way to say "must be a positive number"?
          // Of course if you use several super-tiny values you could eventually
          // force a product of these to zero and all hell would break loose...
          // Likewise with super-huge values.
          if(!scaleratio) scaleratio = containerOut.scaleratio = 1;
  
          updateConstraintGroups(constraintGroups, scaleOpts.thisGroup, thisID, scaleanchor, scaleratio);
      } else if(allAxisIds.indexOf(containerIn.scaleanchor) !== -1) {
          Lib.warn('ignored ' + containerOut._name + '.scaleanchor: "' +
              containerIn.scaleanchor + '" to avoid either an infinite loop ' +
              'and possibly inconsistent scaleratios, or because the target ' +
              'axis has fixed range or this axis declares a *matches* constraint.');
      }
  };
  
  // If this axis is already part of a constraint group, we can't
  // scaleanchor any other axis in that group, or we'd make a loop.
  // Filter allAxisIds to enforce this, also matching axis types.
  function getConstraintOpts(groups, thisID, allAxisIds, layoutOut, constrain) {
      var doesNotConstrainRange = constrain !== 'range';
      var thisType = layoutOut[id2name(thisID)].type;
      var i, j, idj, axj;
  
      var linkableAxes = [];
      for(j = 0; j < allAxisIds.length; j++) {
          idj = allAxisIds[j];
          if(idj === thisID) continue;
  
          axj = layoutOut[id2name(idj)];
          if(axj.type === thisType) {
              if(!axj.fixedrange) {
                  linkableAxes.push(idj);
              } else if(doesNotConstrainRange && axj.anchor) {
                  // allow domain constraints on subplots where
                  // BOTH axes have fixedrange:true and constrain:domain
                  var counterAxj = layoutOut[id2name(axj.anchor)];
                  if(counterAxj.fixedrange) {
                      linkableAxes.push(idj);
                  }
              }
          }
      }
  
      for(i = 0; i < groups.length; i++) {
          if(groups[i][thisID]) {
              var thisGroup = groups[i];
  
              var linkableAxesNoLoops = [];
              for(j = 0; j < linkableAxes.length; j++) {
                  idj = linkableAxes[j];
                  if(!thisGroup[idj]) linkableAxesNoLoops.push(idj);
              }
              return {linkableAxes: linkableAxesNoLoops, thisGroup: thisGroup};
          }
      }
  
      return {linkableAxes: linkableAxes, thisGroup: null};
  }
  
  /*
   * Add this axis to the axis constraint groups, which is the collection
   * of axes that are all constrained together on scale.
   *
   * constraintGroups: a list of objects. each object is
   * {axis_id: scale_within_group}, where scale_within_group is
   * only important relative to the rest of the group, and defines
   * the relative scales between all axes in the group
   *
   * thisGroup: the group the current axis is already in
   * thisID: the id if the current axis
   * scaleanchor: the id of the axis to scale it with
   * scaleratio: the ratio of this axis to the scaleanchor axis
   */
  function updateConstraintGroups(constraintGroups, thisGroup, thisID, scaleanchor, scaleratio) {
      var i, j, groupi, keyj, thisGroupIndex;
  
      if(thisGroup === null) {
          thisGroup = {};
          thisGroup[thisID] = 1;
          thisGroupIndex = constraintGroups.length;
          constraintGroups.push(thisGroup);
      } else {
          thisGroupIndex = constraintGroups.indexOf(thisGroup);
      }
  
      var thisGroupKeys = Object.keys(thisGroup);
  
      // we know that this axis isn't in any other groups, but we don't know
      // about the scaleanchor axis. If it is, we need to merge the groups.
      for(i = 0; i < constraintGroups.length; i++) {
          groupi = constraintGroups[i];
          if(i !== thisGroupIndex && groupi[scaleanchor]) {
              var baseScale = groupi[scaleanchor];
              for(j = 0; j < thisGroupKeys.length; j++) {
                  keyj = thisGroupKeys[j];
                  groupi[keyj] = baseScale * scaleratio * thisGroup[keyj];
              }
              constraintGroups.splice(thisGroupIndex, 1);
              return;
          }
      }
  
      // otherwise, we insert the new scaleanchor axis as the base scale (1)
      // in its group, and scale the rest of the group to it
      if(scaleratio !== 1) {
          for(j = 0; j < thisGroupKeys.length; j++) {
              thisGroup[thisGroupKeys[j]] *= scaleratio;
          }
      }
      thisGroup[scaleanchor] = 1;
  }
  
  exports.enforce = function enforce(gd) {
      var fullLayout = gd._fullLayout;
      var constraintGroups = fullLayout._axisConstraintGroups || [];
  
      var i, j, axisID, ax, normScale, mode, factor;
  
      for(i = 0; i < constraintGroups.length; i++) {
          var group = constraintGroups[i];
          var axisIDs = Object.keys(group);
  
          var minScale = Infinity;
          var maxScale = 0;
          // mostly matchScale will be the same as minScale
          // ie we expand axis ranges to encompass *everything*
          // that's currently in any of their ranges, but during
          // autorange of a subset of axes we will ignore other
          // axes for this purpose.
          var matchScale = Infinity;
          var normScales = {};
          var axes = {};
          var hasAnyDomainConstraint = false;
  
          // find the (normalized) scale of each axis in the group
          for(j = 0; j < axisIDs.length; j++) {
              axisID = axisIDs[j];
              axes[axisID] = ax = fullLayout[id2name(axisID)];
  
              if(ax._inputDomain) ax.domain = ax._inputDomain.slice();
              else ax._inputDomain = ax.domain.slice();
  
              if(!ax._inputRange) ax._inputRange = ax.range.slice();
  
              // set axis scale here so we can use _m rather than
              // having to calculate it from length and range
              ax.setScale();
  
              // abs: inverted scales still satisfy the constraint
              normScales[axisID] = normScale = Math.abs(ax._m) / group[axisID];
              minScale = Math.min(minScale, normScale);
              if(ax.constrain === 'domain' || !ax._constraintShrinkable) {
                  matchScale = Math.min(matchScale, normScale);
              }
  
              // this has served its purpose, so remove it
              delete ax._constraintShrinkable;
              maxScale = Math.max(maxScale, normScale);
  
              if(ax.constrain === 'domain') hasAnyDomainConstraint = true;
          }
  
          // Do we have a constraint mismatch? Give a small buffer for rounding errors
          if(minScale > ALMOST_EQUAL * maxScale && !hasAnyDomainConstraint) continue;
  
          // now increase any ranges we need to until all normalized scales are equal
          for(j = 0; j < axisIDs.length; j++) {
              axisID = axisIDs[j];
              normScale = normScales[axisID];
              ax = axes[axisID];
              mode = ax.constrain;
  
              // even if the scale didn't change, if we're shrinking domain
              // we need to recalculate in case `constraintoward` changed
              if(normScale !== matchScale || mode === 'domain') {
                  factor = normScale / matchScale;
  
                  if(mode === 'range') {
                      scaleZoom(ax, factor);
                  } else {
                      // mode === 'domain'
  
                      var inputDomain = ax._inputDomain;
                      var domainShrunk = (ax.domain[1] - ax.domain[0]) /
                          (inputDomain[1] - inputDomain[0]);
                      var rangeShrunk = (ax.r2l(ax.range[1]) - ax.r2l(ax.range[0])) /
                          (ax.r2l(ax._inputRange[1]) - ax.r2l(ax._inputRange[0]));
  
                      factor /= domainShrunk;
  
                      if(factor * rangeShrunk < 1) {
                          // we've asked to magnify the axis more than we can just by
                          // enlarging the domain - so we need to constrict range
                          ax.domain = ax._input.domain = inputDomain.slice();
                          scaleZoom(ax, factor);
                          continue;
                      }
  
                      if(rangeShrunk < 1) {
                          // the range has previously been constricted by ^^, but we've
                          // switched to the domain-constricted regime, so reset range
                          ax.range = ax._input.range = ax._inputRange.slice();
                          factor *= rangeShrunk;
                      }
  
                      if(ax.autorange) {
                          /*
                           * range & factor may need to change because range was
                           * calculated for the larger scaling, so some pixel
                           * paddings may get cut off when we reduce the domain.
                           *
                           * This is easier than the regular autorange calculation
                           * because we already know the scaling `m`, but we still
                           * need to cut out impossible constraints (like
                           * annotations with super-long arrows). That's what
                           * outerMin/Max are for - if the expansion was going to
                           * go beyond the original domain, it must be impossible
                           */
                          var rl0 = ax.r2l(ax.range[0]);
                          var rl1 = ax.r2l(ax.range[1]);
                          var rangeCenter = (rl0 + rl1) / 2;
                          var rangeMin = rangeCenter;
                          var rangeMax = rangeCenter;
                          var halfRange = Math.abs(rl1 - rangeCenter);
                          // extra tiny bit for rounding errors, in case we actually
                          // *are* expanding to the full domain
                          var outerMin = rangeCenter - halfRange * factor * 1.0001;
                          var outerMax = rangeCenter + halfRange * factor * 1.0001;
                          var getPad = makePadFn(ax);
  
                          updateDomain(ax, factor);
                          var m = Math.abs(ax._m);
                          var extremes = concatExtremes(gd, ax);
                          var minArray = extremes.min;
                          var maxArray = extremes.max;
                          var newVal;
                          var k;
  
                          for(k = 0; k < minArray.length; k++) {
                              newVal = minArray[k].val - getPad(minArray[k]) / m;
                              if(newVal > outerMin && newVal < rangeMin) {
                                  rangeMin = newVal;
                              }
                          }
  
                          for(k = 0; k < maxArray.length; k++) {
                              newVal = maxArray[k].val + getPad(maxArray[k]) / m;
                              if(newVal < outerMax && newVal > rangeMax) {
                                  rangeMax = newVal;
                              }
                          }
  
                          var domainExpand = (rangeMax - rangeMin) / (2 * halfRange);
                          factor /= domainExpand;
  
                          rangeMin = ax.l2r(rangeMin);
                          rangeMax = ax.l2r(rangeMax);
                          ax.range = ax._input.range = (rl0 < rl1) ?
                              [rangeMin, rangeMax] : [rangeMax, rangeMin];
                      }
  
                      updateDomain(ax, factor);
                  }
              }
          }
      }
  };
  
  // For use before autoranging, check if this axis was previously constrained
  // by domain but no longer is
  exports.clean = function clean(gd, ax) {
      if(ax._inputDomain) {
          var isConstrained = false;
          var axId = ax._id;
          var constraintGroups = gd._fullLayout._axisConstraintGroups;
          for(var j = 0; j < constraintGroups.length; j++) {
              if(constraintGroups[j][axId]) {
                  isConstrained = true;
                  break;
              }
          }
          if(!isConstrained || ax.constrain !== 'domain') {
              ax._input.domain = ax.domain = ax._inputDomain;
              delete ax._inputDomain;
          }
      }
  };
  
  function updateDomain(ax, factor) {
      var inputDomain = ax._inputDomain;
      var centerFraction = FROM_BL[ax.constraintoward];
      var center = inputDomain[0] + (inputDomain[1] - inputDomain[0]) * centerFraction;
  
      ax.domain = ax._input.domain = [
          center + (inputDomain[0] - center) / factor,
          center + (inputDomain[1] - center) / factor
      ];
      ax.setScale();
  }
  
  },{"../../constants/alignment":717,"../../constants/numerical":725,"../../lib":750,"./autorange":798,"./axis_ids":802,"./scale_zoom":817}],807:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var tinycolor = _dereq_('tinycolor2');
  var supportsPassive = _dereq_('has-passive-events');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  var Fx = _dereq_('../../components/fx');
  var Axes = _dereq_('./axes');
  var setCursor = _dereq_('../../lib/setcursor');
  var dragElement = _dereq_('../../components/dragelement');
  var helpers = _dereq_('../../components/dragelement/helpers');
  var selectingOrDrawing = helpers.selectingOrDrawing;
  var freeMode = helpers.freeMode;
  
  var FROM_TL = _dereq_('../../constants/alignment').FROM_TL;
  var clearGlCanvases = _dereq_('../../lib/clear_gl_canvases');
  var redrawReglTraces = _dereq_('../../plot_api/subroutines').redrawReglTraces;
  
  var Plots = _dereq_('../plots');
  
  var getFromId = _dereq_('./axis_ids').getFromId;
  var prepSelect = _dereq_('./select').prepSelect;
  var clearSelect = _dereq_('./select').clearSelect;
  var selectOnClick = _dereq_('./select').selectOnClick;
  var scaleZoom = _dereq_('./scale_zoom');
  
  var constants = _dereq_('./constants');
  var MINDRAG = constants.MINDRAG;
  var MINZOOM = constants.MINZOOM;
  
  // flag for showing "doubleclick to zoom out" only at the beginning
  var SHOWZOOMOUTTIP = true;
  
  // dragBox: create an element to drag one or more axis ends
  // inputs:
  //      plotinfo - which subplot are we making dragboxes on?
  //      x,y,w,h - left, top, width, height of the box
  //      ns - how does this drag the vertical axis?
  //          'n' - top only
  //          's' - bottom only
  //          'ns' - top and bottom together, difference unchanged
  //      ew - same for horizontal axis
  function makeDragBox(gd, plotinfo, x, y, w, h, ns, ew) {
      // mouseDown stores ms of first mousedown event in the last
      // `gd._context.doubleClickDelay` ms on the drag bars
      // numClicks stores how many mousedowns have been seen
      // within `gd._context.doubleClickDelay` so we can check for click or doubleclick events
      // dragged stores whether a drag has occurred, so we don't have to
      // redraw unnecessarily, ie if no move bigger than MINDRAG or MINZOOM px
      var zoomlayer = gd._fullLayout._zoomlayer;
      var isMainDrag = (ns + ew === 'nsew');
      var singleEnd = (ns + ew).length === 1;
  
      // main subplot x and y (i.e. found in plotinfo - the main ones)
      var xa0, ya0;
      // {ax._id: ax} hash objects
      var xaHash, yaHash;
      // xaHash/yaHash values (arrays)
      var xaxes, yaxes;
      // main axis offsets
      var xs, ys;
      // main axis lengths
      var pw, ph;
      // contains keys 'xaHash', 'yaHash', 'xaxes', and 'yaxes'
      // which are the x/y {ax._id: ax} hash objects and their values
      // for linked axis relative to this subplot
      var links;
      // similar to `links` but for matching axes
      var matches;
      // set to ew/ns val when active, set to '' when inactive
      var xActive, yActive;
      // are all axes in this subplot are fixed?
      var allFixedRanges;
      // do we need to edit x/y ranges?
      var editX, editY;
      // graph-wide optimization flags
      var hasScatterGl, hasSplom, hasSVG;
      // collected changes to be made to the plot by relayout at the end
      var updates;
  
      function recomputeAxisLists() {
          xa0 = plotinfo.xaxis;
          ya0 = plotinfo.yaxis;
          pw = xa0._length;
          ph = ya0._length;
          xs = xa0._offset;
          ys = ya0._offset;
  
          xaHash = {};
          xaHash[xa0._id] = xa0;
          yaHash = {};
          yaHash[ya0._id] = ya0;
  
          // if we're dragging two axes at once, also drag overlays
          if(ns && ew) {
              var overlays = plotinfo.overlays;
              for(var i = 0; i < overlays.length; i++) {
                  var xa = overlays[i].xaxis;
                  xaHash[xa._id] = xa;
                  var ya = overlays[i].yaxis;
                  yaHash[ya._id] = ya;
              }
          }
  
          xaxes = hashValues(xaHash);
          yaxes = hashValues(yaHash);
          xActive = isDirectionActive(xaxes, ew);
          yActive = isDirectionActive(yaxes, ns);
          allFixedRanges = !yActive && !xActive;
  
          links = calcLinks(gd, gd._fullLayout._axisConstraintGroups, xaHash, yaHash);
          matches = calcLinks(gd, gd._fullLayout._axisMatchGroups, xaHash, yaHash);
          editX = ew || links.isSubplotConstrained || matches.isSubplotConstrained;
          editY = ns || links.isSubplotConstrained || matches.isSubplotConstrained;
  
          var fullLayout = gd._fullLayout;
          hasScatterGl = fullLayout._has('scattergl');
          hasSplom = fullLayout._has('splom');
          hasSVG = fullLayout._has('svg');
      }
  
      recomputeAxisLists();
  
      var cursor = getDragCursor(yActive + xActive, gd._fullLayout.dragmode, isMainDrag);
      var dragger = makeRectDragger(plotinfo, ns + ew + 'drag', cursor, x, y, w, h);
  
      // still need to make the element if the axes are disabled
      // but nuke its events (except for maindrag which needs them for hover)
      // and stop there
      if(allFixedRanges && !isMainDrag) {
          dragger.onmousedown = null;
          dragger.style.pointerEvents = 'none';
          return dragger;
      }
  
      var dragOptions = {
          element: dragger,
          gd: gd,
          plotinfo: plotinfo
      };
  
      dragOptions.prepFn = function(e, startX, startY) {
          var dragModePrev = dragOptions.dragmode;
          var dragModeNow = gd._fullLayout.dragmode;
          if(dragModeNow !== dragModePrev) {
              dragOptions.dragmode = dragModeNow;
          }
  
          recomputeAxisLists();
  
          if(!allFixedRanges) {
              if(isMainDrag) {
                  // main dragger handles all drag modes, and changes
                  // to pan (or to zoom if it already is pan) on shift
                  if(e.shiftKey) {
                      if(dragModeNow === 'pan') dragModeNow = 'zoom';
                      else if(!selectingOrDrawing(dragModeNow)) dragModeNow = 'pan';
                  } else if(e.ctrlKey) {
                      dragModeNow = 'pan';
                  }
              } else {
                  // all other draggers just pan
                  dragModeNow = 'pan';
              }
          }
  
          if(freeMode(dragModeNow)) dragOptions.minDrag = 1;
          else dragOptions.minDrag = undefined;
  
          if(selectingOrDrawing(dragModeNow)) {
              dragOptions.xaxes = xaxes;
              dragOptions.yaxes = yaxes;
              // this attaches moveFn, clickFn, doneFn on dragOptions
              prepSelect(e, startX, startY, dragOptions, dragModeNow);
          } else {
              dragOptions.clickFn = clickFn;
              if(selectingOrDrawing(dragModePrev)) {
                  // TODO Fix potential bug
                  // Note: clearing / resetting selection state only happens, when user
                  // triggers at least one interaction in pan/zoom mode. Otherwise, the
                  // select/lasso outlines are deleted (in plots.js.cleanPlot) but the selection
                  // cache isn't cleared. So when the user switches back to select/lasso and
                  // 'adds to a selection' with Shift, the "old", seemingly removed outlines
                  // are redrawn again because the selection cache still holds their coordinates.
                  // However, this isn't easily solved, since plots.js would need
                  // to have a reference to the dragOptions object (which holds the
                  // selection cache).
                  clearAndResetSelect();
              }
  
              if(!allFixedRanges) {
                  if(dragModeNow === 'zoom') {
                      dragOptions.moveFn = zoomMove;
                      dragOptions.doneFn = zoomDone;
  
                      // zoomMove takes care of the threshold, but we need to
                      // minimize this so that constrained zoom boxes will flip
                      // orientation at the right place
                      dragOptions.minDrag = 1;
  
                      zoomPrep(e, startX, startY);
                  } else if(dragModeNow === 'pan') {
                      dragOptions.moveFn = plotDrag;
                      dragOptions.doneFn = dragTail;
                  }
              }
          }
  
          gd._fullLayout._redrag = function() {
              var dragDataNow = gd._dragdata;
  
              if(dragDataNow && dragDataNow.element === dragger) {
                  var dragModeNow = gd._fullLayout.dragmode;
  
                  if(!selectingOrDrawing(dragModeNow)) {
                      recomputeAxisLists();
                      updateSubplots([0, 0, pw, ph]);
                      dragOptions.moveFn(dragDataNow.dx, dragDataNow.dy);
                  }
  
                  // TODO should we try to "re-select" under select/lasso modes?
                  // probably best to wait for https://github.com/plotly/plotly.js/issues/1851
              }
          };
      };
  
      function clearAndResetSelect() {
          // clear selection polygon cache (if any)
          dragOptions.plotinfo.selection = false;
          // clear selection outlines
          clearSelect(gd);
      }
  
      function clickFn(numClicks, evt) {
          var gd = dragOptions.gd;
          if(gd._fullLayout._activeShapeIndex >= 0) {
              gd._fullLayout._deactivateShape(gd);
              return;
          }
  
          var clickmode = gd._fullLayout.clickmode;
  
          removeZoombox(gd);
  
          if(numClicks === 2 && !singleEnd) doubleClick();
  
          if(isMainDrag) {
              if(clickmode.indexOf('select') > -1) {
                  selectOnClick(evt, gd, xaxes, yaxes, plotinfo.id, dragOptions);
              }
  
              if(clickmode.indexOf('event') > -1) {
                  Fx.click(gd, evt, plotinfo.id);
              }
          } else if(numClicks === 1 && singleEnd) {
              var ax = ns ? ya0 : xa0;
              var end = (ns === 's' || ew === 'w') ? 0 : 1;
              var attrStr = ax._name + '.range[' + end + ']';
              var initialText = getEndText(ax, end);
              var hAlign = 'left';
              var vAlign = 'middle';
  
              if(ax.fixedrange) return;
  
              if(ns) {
                  vAlign = (ns === 'n') ? 'top' : 'bottom';
                  if(ax.side === 'right') hAlign = 'right';
              } else if(ew === 'e') hAlign = 'right';
  
              if(gd._context.showAxisRangeEntryBoxes) {
                  d3.select(dragger)
                      .call(svgTextUtils.makeEditable, {
                          gd: gd,
                          immediate: true,
                          background: gd._fullLayout.paper_bgcolor,
                          text: String(initialText),
                          fill: ax.tickfont ? ax.tickfont.color : '#444',
                          horizontalAlign: hAlign,
                          verticalAlign: vAlign
                      })
                      .on('edit', function(text) {
                          var v = ax.d2r(text);
                          if(v !== undefined) {
                              Registry.call('_guiRelayout', gd, attrStr, v);
                          }
                      });
              }
          }
      }
  
      dragElement.init(dragOptions);
  
      // x/y px position at start of drag
      var x0, y0;
      // bbox object of the zoombox
      var box;
      // luminance of bg behind zoombox
      var lum;
      // zoombox path outline
      var path0;
      // is zoombox dimmed (during drag)
      var dimmed;
      // 'x'-only, 'y' or 'xy' zooming
      var zoomMode;
      // zoombox d3 selection
      var zb;
      // zoombox corner d3 selection
      var corners;
      // zoom takes over minDrag, so it also has to take over gd._dragged
      var zoomDragged;
  
      function zoomPrep(e, startX, startY) {
          var dragBBox = dragger.getBoundingClientRect();
          x0 = startX - dragBBox.left;
          y0 = startY - dragBBox.top;
          box = {l: x0, r: x0, w: 0, t: y0, b: y0, h: 0};
          lum = gd._hmpixcount ?
              (gd._hmlumcount / gd._hmpixcount) :
              tinycolor(gd._fullLayout.plot_bgcolor).getLuminance();
          path0 = 'M0,0H' + pw + 'V' + ph + 'H0V0';
          dimmed = false;
          zoomMode = 'xy';
          zoomDragged = false;
          zb = makeZoombox(zoomlayer, lum, xs, ys, path0);
          corners = makeCorners(zoomlayer, xs, ys);
      }
  
      function zoomMove(dx0, dy0) {
          if(gd._transitioningWithDuration) {
              return false;
          }
  
          var x1 = Math.max(0, Math.min(pw, dx0 + x0));
          var y1 = Math.max(0, Math.min(ph, dy0 + y0));
          var dx = Math.abs(x1 - x0);
          var dy = Math.abs(y1 - y0);
  
          box.l = Math.min(x0, x1);
          box.r = Math.max(x0, x1);
          box.t = Math.min(y0, y1);
          box.b = Math.max(y0, y1);
  
          function noZoom() {
              zoomMode = '';
              box.r = box.l;
              box.t = box.b;
              corners.attr('d', 'M0,0Z');
          }
  
          if(links.isSubplotConstrained) {
              if(dx > MINZOOM || dy > MINZOOM) {
                  zoomMode = 'xy';
                  if(dx / pw > dy / ph) {
                      dy = dx * ph / pw;
                      if(y0 > y1) box.t = y0 - dy;
                      else box.b = y0 + dy;
                  } else {
                      dx = dy * pw / ph;
                      if(x0 > x1) box.l = x0 - dx;
                      else box.r = x0 + dx;
                  }
                  corners.attr('d', xyCorners(box));
              } else {
                  noZoom();
              }
          } else if(matches.isSubplotConstrained) {
              if(dx > MINZOOM || dy > MINZOOM) {
                  zoomMode = 'xy';
  
                  var r0 = Math.min(box.l / pw, (ph - box.b) / ph);
                  var r1 = Math.max(box.r / pw, (ph - box.t) / ph);
  
                  box.l = r0 * pw;
                  box.r = r1 * pw;
                  box.b = (1 - r0) * ph;
                  box.t = (1 - r1) * ph;
                  corners.attr('d', xyCorners(box));
              } else {
                  noZoom();
              }
          } else if(!yActive || dy < Math.min(Math.max(dx * 0.6, MINDRAG), MINZOOM)) {
              // look for small drags in one direction or the other,
              // and only drag the other axis
  
              if(dx < MINDRAG || !xActive) {
                  noZoom();
              } else {
                  box.t = 0;
                  box.b = ph;
                  zoomMode = 'x';
                  corners.attr('d', xCorners(box, y0));
              }
          } else if(!xActive || dx < Math.min(dy * 0.6, MINZOOM)) {
              box.l = 0;
              box.r = pw;
              zoomMode = 'y';
              corners.attr('d', yCorners(box, x0));
          } else {
              zoomMode = 'xy';
              corners.attr('d', xyCorners(box));
          }
          box.w = box.r - box.l;
          box.h = box.b - box.t;
  
          if(zoomMode) zoomDragged = true;
          gd._dragged = zoomDragged;
  
          updateZoombox(zb, corners, box, path0, dimmed, lum);
          computeZoomUpdates();
          gd.emit('plotly_relayouting', updates);
          dimmed = true;
      }
  
      function computeZoomUpdates() {
          updates = {};
  
          // TODO: edit linked axes in zoomAxRanges and in dragTail
          if(zoomMode === 'xy' || zoomMode === 'x') {
              zoomAxRanges(xaxes, box.l / pw, box.r / pw, updates, links.xaxes);
              updateMatchedAxRange('x', updates);
          }
          if(zoomMode === 'xy' || zoomMode === 'y') {
              zoomAxRanges(yaxes, (ph - box.b) / ph, (ph - box.t) / ph, updates, links.yaxes);
              updateMatchedAxRange('y', updates);
          }
      }
  
      function zoomDone() {
          computeZoomUpdates();
          removeZoombox(gd);
          dragTail();
          showDoubleClickNotifier(gd);
      }
  
      // scroll zoom, on all draggers except corners
      var scrollViewBox = [0, 0, pw, ph];
      // wait a little after scrolling before redrawing
      var redrawTimer = null;
      var REDRAWDELAY = constants.REDRAWDELAY;
      var mainplot = plotinfo.mainplot ? gd._fullLayout._plots[plotinfo.mainplot] : plotinfo;
  
      function zoomWheel(e) {
          // deactivate mousewheel scrolling on embedded graphs
          // devs can override this with layout._enablescrollzoom,
          // but _ ensures this setting won't leave their page
          if(!gd._context._scrollZoom.cartesian && !gd._fullLayout._enablescrollzoom) {
              return;
          }
  
          clearAndResetSelect();
  
          // If a transition is in progress, then disable any behavior:
          if(gd._transitioningWithDuration) {
              e.preventDefault();
              e.stopPropagation();
              return;
          }
  
          recomputeAxisLists();
  
          clearTimeout(redrawTimer);
  
          var wheelDelta = -e.deltaY;
          if(!isFinite(wheelDelta)) wheelDelta = e.wheelDelta / 10;
          if(!isFinite(wheelDelta)) {
              Lib.log('Did not find wheel motion attributes: ', e);
              return;
          }
  
          var zoom = Math.exp(-Math.min(Math.max(wheelDelta, -20), 20) / 200);
          var gbb = mainplot.draglayer.select('.nsewdrag').node().getBoundingClientRect();
          var xfrac = (e.clientX - gbb.left) / gbb.width;
          var yfrac = (gbb.bottom - e.clientY) / gbb.height;
          var i;
  
          function zoomWheelOneAxis(ax, centerFraction, zoom) {
              if(ax.fixedrange) return;
  
              var axRange = Lib.simpleMap(ax.range, ax.r2l);
              var v0 = axRange[0] + (axRange[1] - axRange[0]) * centerFraction;
              function doZoom(v) { return ax.l2r(v0 + (v - v0) * zoom); }
              ax.range = axRange.map(doZoom);
          }
  
          if(editX) {
              // if we're only zooming this axis because of constraints,
              // zoom it about the center
              if(!ew) xfrac = 0.5;
  
              for(i = 0; i < xaxes.length; i++) {
                  zoomWheelOneAxis(xaxes[i], xfrac, zoom);
              }
              updateMatchedAxRange('x');
  
              scrollViewBox[2] *= zoom;
              scrollViewBox[0] += scrollViewBox[2] * xfrac * (1 / zoom - 1);
          }
          if(editY) {
              if(!ns) yfrac = 0.5;
  
              for(i = 0; i < yaxes.length; i++) {
                  zoomWheelOneAxis(yaxes[i], yfrac, zoom);
              }
              updateMatchedAxRange('y');
  
              scrollViewBox[3] *= zoom;
              scrollViewBox[1] += scrollViewBox[3] * (1 - yfrac) * (1 / zoom - 1);
          }
  
          // viewbox redraw at first
          updateSubplots(scrollViewBox);
          ticksAndAnnotations();
  
          gd.emit('plotly_relayouting', updates);
  
          // then replot after a delay to make sure
          // no more scrolling is coming
          redrawTimer = setTimeout(function() {
              scrollViewBox = [0, 0, pw, ph];
              dragTail();
          }, REDRAWDELAY);
  
          e.preventDefault();
          return;
      }
  
      // everything but the corners gets wheel zoom
      if(ns.length * ew.length !== 1) {
          attachWheelEventHandler(dragger, zoomWheel);
      }
  
      // plotDrag: move the plot in response to a drag
      function plotDrag(dx, dy) {
          // If a transition is in progress, then disable any behavior:
          if(gd._transitioningWithDuration) {
              return;
          }
  
          // prevent axis drawing from monkeying with margins until we're done
          gd._fullLayout._replotting = true;
  
          if(xActive === 'ew' || yActive === 'ns') {
              if(xActive) {
                  dragAxList(xaxes, dx);
                  updateMatchedAxRange('x');
              }
              if(yActive) {
                  dragAxList(yaxes, dy);
                  updateMatchedAxRange('y');
              }
              updateSubplots([xActive ? -dx : 0, yActive ? -dy : 0, pw, ph]);
              ticksAndAnnotations();
              gd.emit('plotly_relayouting', updates);
              return;
          }
  
          // dz: set a new value for one end (0 or 1) of an axis array axArray,
          // and return a pixel shift for that end for the viewbox
          // based on pixel drag distance d
          // TODO: this makes (generally non-fatal) errors when you get
          // near floating point limits
          function dz(axArray, end, d) {
              var otherEnd = 1 - end;
              var movedAx;
              var newLinearizedEnd;
              for(var i = 0; i < axArray.length; i++) {
                  var axi = axArray[i];
                  if(axi.fixedrange) continue;
                  movedAx = axi;
                  newLinearizedEnd = axi._rl[otherEnd] +
                      (axi._rl[end] - axi._rl[otherEnd]) / dZoom(d / axi._length);
                  var newEnd = axi.l2r(newLinearizedEnd);
  
                  // if l2r comes back false or undefined, it means we've dragged off
                  // the end of valid ranges - so stop.
                  if(newEnd !== false && newEnd !== undefined) axi.range[end] = newEnd;
              }
              return movedAx._length * (movedAx._rl[end] - newLinearizedEnd) /
                  (movedAx._rl[end] - movedAx._rl[otherEnd]);
          }
  
          if(links.isSubplotConstrained && xActive && yActive) {
              // dragging a corner of a constrained subplot:
              // respect the fixed corner, but harmonize dx and dy
              var dxySign = ((xActive === 'w') === (yActive === 'n')) ? 1 : -1;
              var dxyFraction = (dx / pw + dxySign * dy / ph) / 2;
              dx = dxyFraction * pw;
              dy = dxySign * dxyFraction * ph;
          }
  
          if(xActive === 'w') dx = dz(xaxes, 0, dx);
          else if(xActive === 'e') dx = dz(xaxes, 1, -dx);
          else if(!xActive) dx = 0;
  
          if(yActive === 'n') dy = dz(yaxes, 1, dy);
          else if(yActive === 's') dy = dz(yaxes, 0, -dy);
          else if(!yActive) dy = 0;
  
          var xStart = (xActive === 'w') ? dx : 0;
          var yStart = (yActive === 'n') ? dy : 0;
  
          if(links.isSubplotConstrained) {
              var i;
              if(!xActive && yActive.length === 1) {
                  // dragging one end of the y axis of a constrained subplot
                  // scale the other axis the same about its middle
                  for(i = 0; i < xaxes.length; i++) {
                      xaxes[i].range = xaxes[i]._r.slice();
                      scaleZoom(xaxes[i], 1 - dy / ph);
                  }
                  dx = dy * pw / ph;
                  xStart = dx / 2;
              }
              if(!yActive && xActive.length === 1) {
                  for(i = 0; i < yaxes.length; i++) {
                      yaxes[i].range = yaxes[i]._r.slice();
                      scaleZoom(yaxes[i], 1 - dx / pw);
                  }
                  dy = dx * ph / pw;
                  yStart = dy / 2;
              }
          }
  
          updateMatchedAxRange('x');
          updateMatchedAxRange('y');
          updateSubplots([xStart, yStart, pw - dx, ph - dy]);
          ticksAndAnnotations();
          gd.emit('plotly_relayouting', updates);
      }
  
      function updateMatchedAxRange(axLetter, out) {
          var matchedAxes = matches.isSubplotConstrained ?
              {x: yaxes, y: xaxes}[axLetter] :
              matches[axLetter + 'axes'];
  
          var constrainedAxes = matches.isSubplotConstrained ?
              {x: xaxes, y: yaxes}[axLetter] :
              [];
  
          for(var i = 0; i < matchedAxes.length; i++) {
              var ax = matchedAxes[i];
              var axId = ax._id;
              var axId2 = matches.xLinks[axId] || matches.yLinks[axId];
              var ax2 = constrainedAxes[0] || xaHash[axId2] || yaHash[axId2];
  
              if(ax2) {
                  if(out) {
                      // zoombox case - don't mutate 'range', just add keys in 'updates'
                      out[ax._name + '.range[0]'] = out[ax2._name + '.range[0]'];
                      out[ax._name + '.range[1]'] = out[ax2._name + '.range[1]'];
                  } else {
                      ax.range = ax2.range.slice();
                  }
              }
          }
      }
  
      // Draw ticks and annotations (and other components) when ranges change.
      // Also records the ranges that have changed for use by update at the end.
      function ticksAndAnnotations() {
          var activeAxIds = [];
          var i;
  
          function pushActiveAxIds(axList) {
              for(i = 0; i < axList.length; i++) {
                  if(!axList[i].fixedrange) activeAxIds.push(axList[i]._id);
              }
          }
  
          if(editX) {
              pushActiveAxIds(xaxes);
              pushActiveAxIds(links.xaxes);
              pushActiveAxIds(matches.xaxes);
          }
          if(editY) {
              pushActiveAxIds(yaxes);
              pushActiveAxIds(links.yaxes);
              pushActiveAxIds(matches.yaxes);
          }
  
          updates = {};
          for(i = 0; i < activeAxIds.length; i++) {
              var axId = activeAxIds[i];
              var ax = getFromId(gd, axId);
              Axes.drawOne(gd, ax, {skipTitle: true});
              updates[ax._name + '.range[0]'] = ax.range[0];
              updates[ax._name + '.range[1]'] = ax.range[1];
          }
  
          Axes.redrawComponents(gd, activeAxIds);
      }
  
      function doubleClick() {
          if(gd._transitioningWithDuration) return;
  
          var doubleClickConfig = gd._context.doubleClick;
  
          var axList = [];
          if(xActive) axList = axList.concat(xaxes);
          if(yActive) axList = axList.concat(yaxes);
          if(matches.xaxes) axList = axList.concat(matches.xaxes);
          if(matches.yaxes) axList = axList.concat(matches.yaxes);
  
          var attrs = {};
          var ax, i, rangeInitial;
  
          // For reset+autosize mode:
          // If *any* of the main axes is not at its initial range
          // (or autoranged, if we have no initial range, to match the logic in
          // doubleClickConfig === 'reset' below), we reset.
          // If they are *all* at their initial ranges, then we autosize.
          if(doubleClickConfig === 'reset+autosize') {
              doubleClickConfig = 'autosize';
  
              for(i = 0; i < axList.length; i++) {
                  ax = axList[i];
                  if((ax._rangeInitial && (
                          ax.range[0] !== ax._rangeInitial[0] ||
                          ax.range[1] !== ax._rangeInitial[1]
                      )) ||
                      (!ax._rangeInitial && !ax.autorange)
                  ) {
                      doubleClickConfig = 'reset';
                      break;
                  }
              }
          }
  
          if(doubleClickConfig === 'autosize') {
              // don't set the linked axes here, so relayout marks them as shrinkable
              // and we autosize just to the requested axis/axes
              for(i = 0; i < axList.length; i++) {
                  ax = axList[i];
                  if(!ax.fixedrange) attrs[ax._name + '.autorange'] = true;
              }
          } else if(doubleClickConfig === 'reset') {
              // when we're resetting, reset all linked axes too, so we get back
              // to the fully-auto-with-constraints situation
              if(xActive || links.isSubplotConstrained) axList = axList.concat(links.xaxes);
              if(yActive && !links.isSubplotConstrained) axList = axList.concat(links.yaxes);
  
              if(links.isSubplotConstrained) {
                  if(!xActive) axList = axList.concat(xaxes);
                  else if(!yActive) axList = axList.concat(yaxes);
              }
  
              for(i = 0; i < axList.length; i++) {
                  ax = axList[i];
  
                  if(!ax.fixedrange) {
                      if(!ax._rangeInitial) {
                          attrs[ax._name + '.autorange'] = true;
                      } else {
                          rangeInitial = ax._rangeInitial;
                          attrs[ax._name + '.range[0]'] = rangeInitial[0];
                          attrs[ax._name + '.range[1]'] = rangeInitial[1];
                      }
                  }
              }
          }
  
          gd.emit('plotly_doubleclick', null);
          Registry.call('_guiRelayout', gd, attrs);
      }
  
      // dragTail - finish a drag event with a redraw
      function dragTail() {
          // put the subplot viewboxes back to default (Because we're going to)
          // be repositioning the data in the relayout. But DON'T call
          // ticksAndAnnotations again - it's unnecessary and would overwrite `updates`
          updateSubplots([0, 0, pw, ph]);
  
          // since we may have been redrawing some things during the drag, we may have
          // accumulated MathJax promises - wait for them before we relayout.
          Lib.syncOrAsync([
              Plots.previousPromises,
              function() {
                  gd._fullLayout._replotting = false;
                  Registry.call('_guiRelayout', gd, updates);
              }
          ], gd);
      }
  
      // updateSubplots - find all plot viewboxes that should be
      // affected by this drag, and update them. look for all plots
      // sharing an affected axis (including the one being dragged),
      // includes also scattergl and splom logic.
      function updateSubplots(viewBox) {
          var fullLayout = gd._fullLayout;
          var plotinfos = fullLayout._plots;
          var subplots = fullLayout._subplots.cartesian;
          var i, sp, xa, ya;
  
          if(hasSplom) {
              Registry.subplotsRegistry.splom.drag(gd);
          }
  
          if(hasScatterGl) {
              for(i = 0; i < subplots.length; i++) {
                  sp = plotinfos[subplots[i]];
                  xa = sp.xaxis;
                  ya = sp.yaxis;
  
                  if(sp._scene) {
                      var xrng = Lib.simpleMap(xa.range, xa.r2l);
                      var yrng = Lib.simpleMap(ya.range, ya.r2l);
                      sp._scene.update({range: [xrng[0], yrng[0], xrng[1], yrng[1]]});
                  }
              }
          }
  
          if(hasSplom || hasScatterGl) {
              clearGlCanvases(gd);
              redrawReglTraces(gd);
          }
  
          if(hasSVG) {
              var xScaleFactor = viewBox[2] / xa0._length;
              var yScaleFactor = viewBox[3] / ya0._length;
  
              for(i = 0; i < subplots.length; i++) {
                  sp = plotinfos[subplots[i]];
                  xa = sp.xaxis;
                  ya = sp.yaxis;
  
                  var editX2 = editX && !xa.fixedrange && xaHash[xa._id];
                  var editY2 = editY && !ya.fixedrange && yaHash[ya._id];
  
                  var xScaleFactor2, yScaleFactor2;
                  var clipDx, clipDy;
  
                  if(editX2) {
                      xScaleFactor2 = xScaleFactor;
                      clipDx = ew ? viewBox[0] : getShift(xa, xScaleFactor2);
                  } else if(matches.xaHash[xa._id]) {
                      xScaleFactor2 = xScaleFactor;
                      clipDx = viewBox[0] * xa._length / xa0._length;
                  } else if(matches.yaHash[xa._id]) {
                      xScaleFactor2 = yScaleFactor;
                      clipDx = yActive === 'ns' ?
                          -viewBox[1] * xa._length / ya0._length :
                          getShift(xa, xScaleFactor2, {n: 'top', s: 'bottom'}[yActive]);
                  } else {
                      xScaleFactor2 = getLinkedScaleFactor(xa, xScaleFactor, yScaleFactor);
                      clipDx = scaleAndGetShift(xa, xScaleFactor2);
                  }
  
                  if(editY2) {
                      yScaleFactor2 = yScaleFactor;
                      clipDy = ns ? viewBox[1] : getShift(ya, yScaleFactor2);
                  } else if(matches.yaHash[ya._id]) {
                      yScaleFactor2 = yScaleFactor;
                      clipDy = viewBox[1] * ya._length / ya0._length;
                  } else if(matches.xaHash[ya._id]) {
                      yScaleFactor2 = xScaleFactor;
                      clipDy = xActive === 'ew' ?
                          -viewBox[0] * ya._length / xa0._length :
                          getShift(ya, yScaleFactor2, {e: 'right', w: 'left'}[xActive]);
                  } else {
                      yScaleFactor2 = getLinkedScaleFactor(ya, xScaleFactor, yScaleFactor);
                      clipDy = scaleAndGetShift(ya, yScaleFactor2);
                  }
  
                  // don't scale at all if neither axis is scalable here
                  if(!xScaleFactor2 && !yScaleFactor2) {
                      continue;
                  }
  
                  // but if only one is, reset the other axis scaling
                  if(!xScaleFactor2) xScaleFactor2 = 1;
                  if(!yScaleFactor2) yScaleFactor2 = 1;
  
                  var plotDx = xa._offset - clipDx / xScaleFactor2;
                  var plotDy = ya._offset - clipDy / yScaleFactor2;
  
                  // TODO could be more efficient here:
                  // setTranslate and setScale do a lot of extra work
                  // when working independently, should perhaps combine
                  // them into a single routine.
                  sp.clipRect
                      .call(Drawing.setTranslate, clipDx, clipDy)
                      .call(Drawing.setScale, xScaleFactor2, yScaleFactor2);
  
                  sp.plot
                      .call(Drawing.setTranslate, plotDx, plotDy)
                      .call(Drawing.setScale, 1 / xScaleFactor2, 1 / yScaleFactor2);
  
                  // apply an inverse scale to individual points to counteract
                  // the scale of the trace group.
                  // apply only when scale changes, as adjusting the scale of
                  // all the points can be expansive.
                  if(xScaleFactor2 !== sp.xScaleFactor || yScaleFactor2 !== sp.yScaleFactor) {
                      Drawing.setPointGroupScale(sp.zoomScalePts, xScaleFactor2, yScaleFactor2);
                      Drawing.setTextPointsScale(sp.zoomScaleTxt, xScaleFactor2, yScaleFactor2);
                  }
  
                  Drawing.hideOutsideRangePoints(sp.clipOnAxisFalseTraces, sp);
  
                  // update x/y scaleFactor stash
                  sp.xScaleFactor = xScaleFactor2;
                  sp.yScaleFactor = yScaleFactor2;
              }
          }
      }
  
      // Find the appropriate scaling for this axis, if it's linked to the
      // dragged axes by constraints. 0 is special, it means this axis shouldn't
      // ever be scaled (will be converted to 1 if the other axis is scaled)
      function getLinkedScaleFactor(ax, xScaleFactor, yScaleFactor) {
          if(ax.fixedrange) return 0;
  
          if(editX && links.xaHash[ax._id]) {
              return xScaleFactor;
          }
          if(editY && (links.isSubplotConstrained ? links.xaHash : links.yaHash)[ax._id]) {
              return yScaleFactor;
          }
          return 0;
      }
  
      function scaleAndGetShift(ax, scaleFactor) {
          if(scaleFactor) {
              ax.range = ax._r.slice();
              scaleZoom(ax, scaleFactor);
              return getShift(ax, scaleFactor);
          }
          return 0;
      }
  
      function getShift(ax, scaleFactor, from) {
          return ax._length * (1 - scaleFactor) * FROM_TL[from || ax.constraintoward || 'middle'];
      }
  
      return dragger;
  }
  
  function makeDragger(plotinfo, nodeName, dragClass, cursor) {
      var dragger3 = Lib.ensureSingle(plotinfo.draglayer, nodeName, dragClass, function(s) {
          s.classed('drag', true)
              .style({fill: 'transparent', 'stroke-width': 0})
              .attr('data-subplot', plotinfo.id);
      });
  
      dragger3.call(setCursor, cursor);
  
      return dragger3.node();
  }
  
  function makeRectDragger(plotinfo, dragClass, cursor, x, y, w, h) {
      var dragger = makeDragger(plotinfo, 'rect', dragClass, cursor);
      d3.select(dragger).call(Drawing.setRect, x, y, w, h);
      return dragger;
  }
  
  function isDirectionActive(axList, activeVal) {
      for(var i = 0; i < axList.length; i++) {
          if(!axList[i].fixedrange) return activeVal;
      }
      return '';
  }
  
  function getEndText(ax, end) {
      var initialVal = ax.range[end];
      var diff = Math.abs(initialVal - ax.range[1 - end]);
      var dig;
  
      // TODO: this should basically be ax.r2d but we're doing extra
      // rounding here... can we clean up at all?
      if(ax.type === 'date') {
          return initialVal;
      } else if(ax.type === 'log') {
          dig = Math.ceil(Math.max(0, -Math.log(diff) / Math.LN10)) + 3;
          return d3.format('.' + dig + 'g')(Math.pow(10, initialVal));
      } else { // linear numeric (or category... but just show numbers here)
          dig = Math.floor(Math.log(Math.abs(initialVal)) / Math.LN10) -
              Math.floor(Math.log(diff) / Math.LN10) + 4;
          return d3.format('.' + String(dig) + 'g')(initialVal);
      }
  }
  
  function zoomAxRanges(axList, r0Fraction, r1Fraction, updates, linkedAxes) {
      for(var i = 0; i < axList.length; i++) {
          var axi = axList[i];
          if(axi.fixedrange) continue;
  
          if(axi.rangebreaks) {
              var isY = axi._id.charAt(0) === 'y';
              var r0F = isY ? (1 - r0Fraction) : r0Fraction;
              var r1F = isY ? (1 - r1Fraction) : r1Fraction;
  
              updates[axi._name + '.range[0]'] = axi.l2r(axi.p2l(r0F * axi._length));
              updates[axi._name + '.range[1]'] = axi.l2r(axi.p2l(r1F * axi._length));
          } else {
              var axRangeLinear0 = axi._rl[0];
              var axRangeLinearSpan = axi._rl[1] - axRangeLinear0;
              updates[axi._name + '.range[0]'] = axi.l2r(axRangeLinear0 + axRangeLinearSpan * r0Fraction);
              updates[axi._name + '.range[1]'] = axi.l2r(axRangeLinear0 + axRangeLinearSpan * r1Fraction);
          }
      }
  
      // zoom linked axes about their centers
      if(linkedAxes && linkedAxes.length) {
          var linkedR0Fraction = (r0Fraction + (1 - r1Fraction)) / 2;
          zoomAxRanges(linkedAxes, linkedR0Fraction, 1 - linkedR0Fraction, updates, []);
      }
  }
  
  function dragAxList(axList, pix) {
      for(var i = 0; i < axList.length; i++) {
          var axi = axList[i];
          if(!axi.fixedrange) {
              if(axi.rangebreaks) {
                  var p0 = 0;
                  var p1 = axi._length;
                  var d0 = axi.p2l(p0 + pix) - axi.p2l(p0);
                  var d1 = axi.p2l(p1 + pix) - axi.p2l(p1);
                  var delta = (d0 + d1) / 2;
  
                  axi.range = [
                      axi.l2r(axi._rl[0] - delta),
                      axi.l2r(axi._rl[1] - delta)
                  ];
              } else {
                  axi.range = [
                      axi.l2r(axi._rl[0] - pix / axi._m),
                      axi.l2r(axi._rl[1] - pix / axi._m)
                  ];
              }
          }
      }
  }
  
  // common transform for dragging one end of an axis
  // d>0 is compressing scale (cursor is over the plot,
  //  the axis end should move with the cursor)
  // d<0 is expanding (cursor is off the plot, axis end moves
  //  nonlinearly so you can expand far)
  function dZoom(d) {
      return 1 - ((d >= 0) ? Math.min(d, 0.9) :
          1 / (1 / Math.max(d, -0.3) + 3.222));
  }
  
  function getDragCursor(nsew, dragmode, isMainDrag) {
      if(!nsew) return 'pointer';
      if(nsew === 'nsew') {
          // in this case here, clear cursor and
          // use the cursor style set on <g .draglayer>
          if(isMainDrag) return '';
          if(dragmode === 'pan') return 'move';
          return 'crosshair';
      }
      return nsew.toLowerCase() + '-resize';
  }
  
  function makeZoombox(zoomlayer, lum, xs, ys, path0) {
      return zoomlayer.append('path')
          .attr('class', 'zoombox')
          .style({
              'fill': lum > 0.2 ? 'rgba(0,0,0,0)' : 'rgba(255,255,255,0)',
              'stroke-width': 0
          })
          .attr('transform', 'translate(' + xs + ', ' + ys + ')')
          .attr('d', path0 + 'Z');
  }
  
  function makeCorners(zoomlayer, xs, ys) {
      return zoomlayer.append('path')
          .attr('class', 'zoombox-corners')
          .style({
              fill: Color.background,
              stroke: Color.defaultLine,
              'stroke-width': 1,
              opacity: 0
          })
          .attr('transform', 'translate(' + xs + ', ' + ys + ')')
          .attr('d', 'M0,0Z');
  }
  
  function updateZoombox(zb, corners, box, path0, dimmed, lum) {
      zb.attr('d',
          path0 + 'M' + (box.l) + ',' + (box.t) + 'v' + (box.h) +
          'h' + (box.w) + 'v-' + (box.h) + 'h-' + (box.w) + 'Z');
      transitionZoombox(zb, corners, dimmed, lum);
  }
  
  function transitionZoombox(zb, corners, dimmed, lum) {
      if(!dimmed) {
          zb.transition()
              .style('fill', lum > 0.2 ? 'rgba(0,0,0,0.4)' :
                  'rgba(255,255,255,0.3)')
              .duration(200);
          corners.transition()
              .style('opacity', 1)
              .duration(200);
      }
  }
  
  function removeZoombox(gd) {
      d3.select(gd)
          .selectAll('.zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners')
          .remove();
  }
  
  function showDoubleClickNotifier(gd) {
      if(SHOWZOOMOUTTIP && gd.data && gd._context.showTips) {
          Lib.notifier(Lib._(gd, 'Double-click to zoom back out'), 'long');
          SHOWZOOMOUTTIP = false;
      }
  }
  
  function xCorners(box, y0) {
      return 'M' +
          (box.l - 0.5) + ',' + (y0 - MINZOOM - 0.5) +
          'h-3v' + (2 * MINZOOM + 1) + 'h3ZM' +
          (box.r + 0.5) + ',' + (y0 - MINZOOM - 0.5) +
          'h3v' + (2 * MINZOOM + 1) + 'h-3Z';
  }
  
  function yCorners(box, x0) {
      return 'M' +
          (x0 - MINZOOM - 0.5) + ',' + (box.t - 0.5) +
          'v-3h' + (2 * MINZOOM + 1) + 'v3ZM' +
          (x0 - MINZOOM - 0.5) + ',' + (box.b + 0.5) +
          'v3h' + (2 * MINZOOM + 1) + 'v-3Z';
  }
  
  function xyCorners(box) {
      var clen = Math.floor(Math.min(box.b - box.t, box.r - box.l, MINZOOM) / 2);
      return 'M' +
          (box.l - 3.5) + ',' + (box.t - 0.5 + clen) + 'h3v' + (-clen) +
              'h' + clen + 'v-3h-' + (clen + 3) + 'ZM' +
          (box.r + 3.5) + ',' + (box.t - 0.5 + clen) + 'h-3v' + (-clen) +
              'h' + (-clen) + 'v-3h' + (clen + 3) + 'ZM' +
          (box.r + 3.5) + ',' + (box.b + 0.5 - clen) + 'h-3v' + clen +
              'h' + (-clen) + 'v3h' + (clen + 3) + 'ZM' +
          (box.l - 3.5) + ',' + (box.b + 0.5 - clen) + 'h3v' + clen +
              'h' + clen + 'v3h-' + (clen + 3) + 'Z';
  }
  
  function calcLinks(gd, groups, xaHash, yaHash) {
      var isSubplotConstrained = false;
      var xLinks = {};
      var yLinks = {};
      var xID, yID, xLinkID, yLinkID;
  
      for(var i = 0; i < groups.length; i++) {
          var group = groups[i];
          // check if any of the x axes we're dragging is in this constraint group
          for(xID in xaHash) {
              if(group[xID]) {
                  // put the rest of these axes into xLinks, if we're not already
                  // dragging them, so we know to scale these axes automatically too
                  // to match the changes in the dragged x axes
                  for(xLinkID in group) {
                      if(!(xLinkID.charAt(0) === 'x' ? xaHash : yaHash)[xLinkID]) {
                          xLinks[xLinkID] = xID;
                      }
                  }
  
                  // check if the x and y axes of THIS drag are linked
                  for(yID in yaHash) {
                      if(group[yID]) isSubplotConstrained = true;
                  }
              }
          }
  
          // now check if any of the y axes we're dragging is in this constraint group
          // only look for outside links, as we've already checked for links within the dragger
          for(yID in yaHash) {
              if(group[yID]) {
                  for(yLinkID in group) {
                      if(!(yLinkID.charAt(0) === 'x' ? xaHash : yaHash)[yLinkID]) {
                          yLinks[yLinkID] = yID;
                      }
                  }
              }
          }
      }
  
      if(isSubplotConstrained) {
          // merge xLinks and yLinks if the subplot is constrained,
          // since we'll always apply both anyway and the two will contain
          // duplicates
          Lib.extendFlat(xLinks, yLinks);
          yLinks = {};
      }
  
      var xaHashLinked = {};
      var xaxesLinked = [];
      for(xLinkID in xLinks) {
          var xa = getFromId(gd, xLinkID);
          xaxesLinked.push(xa);
          xaHashLinked[xa._id] = xa;
      }
  
      var yaHashLinked = {};
      var yaxesLinked = [];
      for(yLinkID in yLinks) {
          var ya = getFromId(gd, yLinkID);
          yaxesLinked.push(ya);
          yaHashLinked[ya._id] = ya;
      }
  
      return {
          xaHash: xaHashLinked,
          yaHash: yaHashLinked,
          xaxes: xaxesLinked,
          yaxes: yaxesLinked,
          xLinks: xLinks,
          yLinks: yLinks,
          isSubplotConstrained: isSubplotConstrained
      };
  }
  
  // still seems to be some confusion about onwheel vs onmousewheel...
  function attachWheelEventHandler(element, handler) {
      if(!supportsPassive) {
          if(element.onwheel !== undefined) element.onwheel = handler;
          else if(element.onmousewheel !== undefined) element.onmousewheel = handler;
          else if(!element.isAddedWheelEvent) {
              element.isAddedWheelEvent = true;
              element.addEventListener('wheel', handler, {passive: false});
          }
      } else {
          var wheelEventName = element.onwheel !== undefined ? 'wheel' : 'mousewheel';
  
          if(element._onwheel) {
              element.removeEventListener(wheelEventName, element._onwheel);
          }
          element._onwheel = handler;
  
          element.addEventListener(wheelEventName, handler, {passive: false});
      }
  }
  
  function hashValues(hash) {
      var out = [];
      for(var k in hash) out.push(hash[k]);
      return out;
  }
  
  module.exports = {
      makeDragBox: makeDragBox,
  
      makeDragger: makeDragger,
      makeRectDragger: makeRectDragger,
      makeZoombox: makeZoombox,
      makeCorners: makeCorners,
  
      updateZoombox: updateZoombox,
      xyCorners: xyCorners,
      transitionZoombox: transitionZoombox,
      removeZoombox: removeZoombox,
      showDoubleClickNotifier: showDoubleClickNotifier,
  
      attachWheelEventHandler: attachWheelEventHandler
  };
  
  },{"../../components/color":615,"../../components/dragelement":634,"../../components/dragelement/helpers":633,"../../components/drawing":637,"../../components/fx":655,"../../constants/alignment":717,"../../lib":750,"../../lib/clear_gl_canvases":734,"../../lib/setcursor":770,"../../lib/svg_text_utils":774,"../../plot_api/subroutines":789,"../../registry":882,"../plots":862,"./axes":799,"./axis_ids":802,"./constants":805,"./scale_zoom":817,"./select":818,"d3":169,"has-passive-events":415,"tinycolor2":548}],808:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Fx = _dereq_('../../components/fx');
  var dragElement = _dereq_('../../components/dragelement');
  var setCursor = _dereq_('../../lib/setcursor');
  
  var makeDragBox = _dereq_('./dragbox').makeDragBox;
  var DRAGGERSIZE = _dereq_('./constants').DRAGGERSIZE;
  
  exports.initInteractions = function initInteractions(gd) {
      var fullLayout = gd._fullLayout;
  
      if(gd._context.staticPlot) {
          // this sweeps up more than just cartesian drag elements...
          d3.select(gd).selectAll('.drag').remove();
          return;
      }
  
      if(!fullLayout._has('cartesian') && !fullLayout._has('splom')) return;
  
      var subplots = Object.keys(fullLayout._plots || {}).sort(function(a, b) {
          // sort overlays last, then by x axis number, then y axis number
          if((fullLayout._plots[a].mainplot && true) ===
              (fullLayout._plots[b].mainplot && true)) {
              var aParts = a.split('y');
              var bParts = b.split('y');
              return (aParts[0] === bParts[0]) ?
                  (Number(aParts[1] || 1) - Number(bParts[1] || 1)) :
                  (Number(aParts[0] || 1) - Number(bParts[0] || 1));
          }
          return fullLayout._plots[a].mainplot ? 1 : -1;
      });
  
      subplots.forEach(function(subplot) {
          var plotinfo = fullLayout._plots[subplot];
          var xa = plotinfo.xaxis;
          var ya = plotinfo.yaxis;
  
          // main and corner draggers need not be repeated for
          // overlaid subplots - these draggers drag them all
          if(!plotinfo.mainplot) {
              // main dragger goes over the grids and data, so we use its
              // mousemove events for all data hover effects
              var maindrag = makeDragBox(gd, plotinfo, xa._offset, ya._offset,
                  xa._length, ya._length, 'ns', 'ew');
  
              maindrag.onmousemove = function(evt) {
                  // This is on `gd._fullLayout`, *not* fullLayout because the reference
                  // changes by the time this is called again.
                  gd._fullLayout._rehover = function() {
                      if((gd._fullLayout._hoversubplot === subplot) && gd._fullLayout._plots[subplot]) {
                          Fx.hover(gd, evt, subplot);
                      }
                  };
  
                  Fx.hover(gd, evt, subplot);
  
                  // Note that we have *not* used the cached fullLayout variable here
                  // since that may be outdated when this is called as a callback later on
                  gd._fullLayout._lasthover = maindrag;
                  gd._fullLayout._hoversubplot = subplot;
              };
  
              /*
               * IMPORTANT:
               * We must check for the presence of the drag cover here.
               * If we don't, a 'mouseout' event is triggered on the
               * maindrag before each 'click' event, which has the effect
               * of clearing the hoverdata; thus, cancelling the click event.
               */
              maindrag.onmouseout = function(evt) {
                  if(gd._dragging) return;
  
                  // When the mouse leaves this maindrag, unset the hovered subplot.
                  // This may cause problems if it leaves the subplot directly *onto*
                  // another subplot, but that's a tiny corner case at the moment.
                  gd._fullLayout._hoversubplot = null;
  
                  dragElement.unhover(gd, evt);
              };
  
              // corner draggers
              if(gd._context.showAxisDragHandles) {
                  makeDragBox(gd, plotinfo, xa._offset - DRAGGERSIZE, ya._offset - DRAGGERSIZE,
                      DRAGGERSIZE, DRAGGERSIZE, 'n', 'w');
                  makeDragBox(gd, plotinfo, xa._offset + xa._length, ya._offset - DRAGGERSIZE,
                      DRAGGERSIZE, DRAGGERSIZE, 'n', 'e');
                  makeDragBox(gd, plotinfo, xa._offset - DRAGGERSIZE, ya._offset + ya._length,
                      DRAGGERSIZE, DRAGGERSIZE, 's', 'w');
                  makeDragBox(gd, plotinfo, xa._offset + xa._length, ya._offset + ya._length,
                      DRAGGERSIZE, DRAGGERSIZE, 's', 'e');
              }
          }
          if(gd._context.showAxisDragHandles) {
              // x axis draggers - if you have overlaid plots,
              // these drag each axis separately
              if(subplot === xa._mainSubplot) {
                  // the y position of the main x axis line
                  var y0 = xa._mainLinePosition;
                  if(xa.side === 'top') y0 -= DRAGGERSIZE;
                  makeDragBox(gd, plotinfo, xa._offset + xa._length * 0.1, y0,
                      xa._length * 0.8, DRAGGERSIZE, '', 'ew');
                  makeDragBox(gd, plotinfo, xa._offset, y0,
                      xa._length * 0.1, DRAGGERSIZE, '', 'w');
                  makeDragBox(gd, plotinfo, xa._offset + xa._length * 0.9, y0,
                      xa._length * 0.1, DRAGGERSIZE, '', 'e');
              }
              // y axis draggers
              if(subplot === ya._mainSubplot) {
                  // the x position of the main y axis line
                  var x0 = ya._mainLinePosition;
                  if(ya.side !== 'right') x0 -= DRAGGERSIZE;
                  makeDragBox(gd, plotinfo, x0, ya._offset + ya._length * 0.1,
                      DRAGGERSIZE, ya._length * 0.8, 'ns', '');
                  makeDragBox(gd, plotinfo, x0, ya._offset + ya._length * 0.9,
                      DRAGGERSIZE, ya._length * 0.1, 's', '');
                  makeDragBox(gd, plotinfo, x0, ya._offset,
                      DRAGGERSIZE, ya._length * 0.1, 'n', '');
              }
          }
      });
  
      // In case you mousemove over some hovertext, send it to Fx.hover too
      // we do this so that we can put the hover text in front of everything,
      // but still be able to interact with everything as if it isn't there
      var hoverLayer = fullLayout._hoverlayer.node();
  
      hoverLayer.onmousemove = function(evt) {
          evt.target = gd._fullLayout._lasthover;
          Fx.hover(gd, evt, fullLayout._hoversubplot);
      };
  
      hoverLayer.onclick = function(evt) {
          evt.target = gd._fullLayout._lasthover;
          Fx.click(gd, evt);
      };
  
      // also delegate mousedowns... TODO: does this actually work?
      hoverLayer.onmousedown = function(evt) {
          gd._fullLayout._lasthover.onmousedown(evt);
      };
  
      exports.updateFx(gd);
  };
  
  // Minimal set of update needed on 'modebar' edits.
  // We only need to update the <g .draglayer> cursor style.
  //
  // Note that changing the axis configuration and/or the fixedrange attribute
  // should trigger a full initInteractions.
  exports.updateFx = function(gd) {
      var fullLayout = gd._fullLayout;
      var cursor = fullLayout.dragmode === 'pan' ? 'move' : 'crosshair';
      setCursor(fullLayout._draggers, cursor);
  };
  
  },{"../../components/dragelement":634,"../../components/fx":655,"../../lib/setcursor":770,"./constants":805,"./dragbox":807,"d3":169}],809:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  function clearOutlineControllers(gd) {
      var zoomLayer = gd._fullLayout._zoomlayer;
      if(zoomLayer) {
          zoomLayer.selectAll('.outline-controllers').remove();
      }
  }
  
  function clearSelect(gd) {
      var zoomLayer = gd._fullLayout._zoomlayer;
      if(zoomLayer) {
          // until we get around to persistent selections, remove the outline
          // here. The selection itself will be removed when the plot redraws
          // at the end.
          zoomLayer.selectAll('.select-outline').remove();
      }
  
      gd._fullLayout._drawing = false;
  }
  
  module.exports = {
      clearOutlineControllers: clearOutlineControllers,
      clearSelect: clearSelect
  };
  
  },{}],810:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  // in v2 (once log ranges are fixed),
  // we'll be able to p2r here for all axis types
  function p2r(ax, v) {
      switch(ax.type) {
          case 'log':
              return ax.p2d(v);
          case 'date':
              return ax.p2r(v, 0, ax.calendar);
          default:
              return ax.p2r(v);
      }
  }
  
  function r2p(ax, v) {
      switch(ax.type) {
          case 'log':
              return ax.d2p(v);
          case 'date':
              return ax.r2p(v, 0, ax.calendar);
          default:
              return ax.r2p(v);
      }
  }
  
  function axValue(ax) {
      var index = (ax._id.charAt(0) === 'y') ? 1 : 0;
      return function(v) { return p2r(ax, v[index]); };
  }
  
  function getTransform(plotinfo) {
      return 'translate(' +
          plotinfo.xaxis._offset + ',' +
          plotinfo.yaxis._offset + ')';
  }
  
  module.exports = {
      p2r: p2r,
      r2p: r2p,
      axValue: axValue,
      getTransform: getTransform
  };
  
  },{}],811:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var axisIds = _dereq_('./axis_ids');
  
  /**
   * Factory function for checking component arrays for subplot references.
   *
   * @param {string} containerArrayName: the top-level array in gd.layout to check
   *   If an item in this container is found that references a cartesian x and/or y axis,
   *   ensure cartesian is marked as a base plot module and record the axes (and subplot
   *   if both refs are axes) in gd._fullLayout
   *
   * @return {function}: with args layoutIn (gd.layout) and layoutOut (gd._fullLayout)
   * as expected of a component includeBasePlot method
   */
  module.exports = function makeIncludeComponents(containerArrayName) {
      return function includeComponents(layoutIn, layoutOut) {
          var array = layoutIn[containerArrayName];
          if(!Array.isArray(array)) return;
  
          var Cartesian = Registry.subplotsRegistry.cartesian;
          var idRegex = Cartesian.idRegex;
          var subplots = layoutOut._subplots;
          var xaList = subplots.xaxis;
          var yaList = subplots.yaxis;
          var cartesianList = subplots.cartesian;
          var hasCartesianOrGL2D = layoutOut._has('cartesian') || layoutOut._has('gl2d');
  
          for(var i = 0; i < array.length; i++) {
              var itemi = array[i];
              if(!Lib.isPlainObject(itemi)) continue;
  
              // call cleanId because if xref, or yref has something appended
              // (e.g., ' domain') this will get removed.
              var xref = axisIds.cleanId(itemi.xref, 'x', false);
              var yref = axisIds.cleanId(itemi.yref, 'y', false);
  
              var hasXref = idRegex.x.test(xref);
              var hasYref = idRegex.y.test(yref);
              if(hasXref || hasYref) {
                  if(!hasCartesianOrGL2D) Lib.pushUnique(layoutOut._basePlotModules, Cartesian);
  
                  var newAxis = false;
                  if(hasXref && xaList.indexOf(xref) === -1) {
                      xaList.push(xref);
                      newAxis = true;
                  }
                  if(hasYref && yaList.indexOf(yref) === -1) {
                      yaList.push(yref);
                      newAxis = true;
                  }
  
                  /*
                   * Notice the logic here: only add a subplot for a component if
                   * it's referencing both x and y axes AND it's creating a new axis
                   * so for example if your plot already has xy and x2y2, an annotation
                   * on x2y or xy2 will not create a new subplot.
                   */
                  if(newAxis && hasXref && hasYref) {
                      cartesianList.push(xref + yref);
                  }
              }
          }
      };
  };
  
  },{"../../lib":750,"../../registry":882,"./axis_ids":802}],812:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Plots = _dereq_('../plots');
  var Drawing = _dereq_('../../components/drawing');
  
  var getModuleCalcData = _dereq_('../get_data').getModuleCalcData;
  var axisIds = _dereq_('./axis_ids');
  var constants = _dereq_('./constants');
  var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
  
  var ensureSingle = Lib.ensureSingle;
  
  function ensureSingleAndAddDatum(parent, nodeType, className) {
      return Lib.ensureSingle(parent, nodeType, className, function(s) {
          s.datum(className);
      });
  }
  
  exports.name = 'cartesian';
  
  exports.attr = ['xaxis', 'yaxis'];
  
  exports.idRoot = ['x', 'y'];
  
  exports.idRegex = constants.idRegex;
  
  exports.attrRegex = constants.attrRegex;
  
  exports.attributes = _dereq_('./attributes');
  
  exports.layoutAttributes = _dereq_('./layout_attributes');
  
  exports.supplyLayoutDefaults = _dereq_('./layout_defaults');
  
  exports.transitionAxes = _dereq_('./transition_axes');
  
  exports.finalizeSubplots = function(layoutIn, layoutOut) {
      var subplots = layoutOut._subplots;
      var xList = subplots.xaxis;
      var yList = subplots.yaxis;
      var spSVG = subplots.cartesian;
      var spAll = spSVG.concat(subplots.gl2d || []);
      var allX = {};
      var allY = {};
      var i, xi, yi;
  
      for(i = 0; i < spAll.length; i++) {
          var parts = spAll[i].split('y');
          allX[parts[0]] = 1;
          allY['y' + parts[1]] = 1;
      }
  
      // check for x axes with no subplot, and make one from the anchor of that x axis
      for(i = 0; i < xList.length; i++) {
          xi = xList[i];
          if(!allX[xi]) {
              yi = (layoutIn[axisIds.id2name(xi)] || {}).anchor;
              if(!constants.idRegex.y.test(yi)) yi = 'y';
              spSVG.push(xi + yi);
              spAll.push(xi + yi);
  
              if(!allY[yi]) {
                  allY[yi] = 1;
                  Lib.pushUnique(yList, yi);
              }
          }
      }
  
      // same for y axes with no subplot
      for(i = 0; i < yList.length; i++) {
          yi = yList[i];
          if(!allY[yi]) {
              xi = (layoutIn[axisIds.id2name(yi)] || {}).anchor;
              if(!constants.idRegex.x.test(xi)) xi = 'x';
              spSVG.push(xi + yi);
              spAll.push(xi + yi);
  
              if(!allX[xi]) {
                  allX[xi] = 1;
                  Lib.pushUnique(xList, xi);
              }
          }
      }
  
      // finally, if we've gotten here we're supposed to show cartesian...
      // so if there are NO subplots at all, make one from the first
      // x & y axes in the input layout
      if(!spAll.length) {
          xi = '';
          yi = '';
          for(var ki in layoutIn) {
              if(constants.attrRegex.test(ki)) {
                  var axLetter = ki.charAt(0);
                  if(axLetter === 'x') {
                      if(!xi || (+ki.substr(5) < +xi.substr(5))) {
                          xi = ki;
                      }
                  } else if(!yi || (+ki.substr(5) < +yi.substr(5))) {
                      yi = ki;
                  }
              }
          }
          xi = xi ? axisIds.name2id(xi) : 'x';
          yi = yi ? axisIds.name2id(yi) : 'y';
          xList.push(xi);
          yList.push(yi);
          spSVG.push(xi + yi);
      }
  };
  
  /**
   * Cartesian.plot
   *
   * @param {DOM div | object} gd
   * @param {array (optional)} traces
   *  array of traces indices to plot
   *  if undefined, plots all cartesian traces,
   * @param {object} (optional) transitionOpts
   *  transition option object
   * @param {function} (optional) makeOnCompleteCallback
   *  transition make callback function from Plots.transition
   */
  exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
      var fullLayout = gd._fullLayout;
      var subplots = fullLayout._subplots.cartesian;
      var calcdata = gd.calcdata;
      var i;
  
      if(!Array.isArray(traces)) {
          // If traces is not provided, then it's a complete replot and missing
          // traces are removed
          traces = [];
          for(i = 0; i < calcdata.length; i++) traces.push(i);
      }
  
      for(i = 0; i < subplots.length; i++) {
          var subplot = subplots[i];
          var subplotInfo = fullLayout._plots[subplot];
  
          // Get all calcdata for this subplot:
          var cdSubplot = [];
          var pcd;
  
          for(var j = 0; j < calcdata.length; j++) {
              var cd = calcdata[j];
              var trace = cd[0].trace;
  
              // Skip trace if whitelist provided and it's not whitelisted:
              // if (Array.isArray(traces) && traces.indexOf(i) === -1) continue;
              if(trace.xaxis + trace.yaxis === subplot) {
                  // XXX: Should trace carpet dependencies. Only replot all carpet plots if the carpet
                  // axis has actually changed:
                  //
                  // If this trace is specifically requested, add it to the list:
                  if(traces.indexOf(trace.index) !== -1 || trace.carpet) {
                      // Okay, so example: traces 0, 1, and 2 have fill = tonext. You animate
                      // traces 0 and 2. Trace 1 also needs to be updated, otherwise its fill
                      // is outdated. So this retroactively adds the previous trace if the
                      // traces are interdependent.
                      if(
                          pcd &&
                          pcd[0].trace.xaxis + pcd[0].trace.yaxis === subplot &&
                          ['tonextx', 'tonexty', 'tonext'].indexOf(trace.fill) !== -1 &&
                          cdSubplot.indexOf(pcd) === -1
                      ) {
                          cdSubplot.push(pcd);
                      }
  
                      cdSubplot.push(cd);
                  }
  
                  // Track the previous trace on this subplot for the retroactive-add step
                  // above:
                  pcd = cd;
              }
          }
  
          plotOne(gd, subplotInfo, cdSubplot, transitionOpts, makeOnCompleteCallback);
      }
  };
  
  function plotOne(gd, plotinfo, cdSubplot, transitionOpts, makeOnCompleteCallback) {
      var traceLayerClasses = constants.traceLayerClasses;
      var fullLayout = gd._fullLayout;
      var modules = fullLayout._modules;
      var _module, cdModuleAndOthers, cdModule;
  
      var layerData = [];
      var zoomScaleQueryParts = [];
  
      for(var i = 0; i < modules.length; i++) {
          _module = modules[i];
          var name = _module.name;
          var categories = Registry.modules[name].categories;
  
          if(categories.svg) {
              var className = (_module.layerName || name + 'layer');
              var plotMethod = _module.plot;
  
              // plot all visible traces of this type on this subplot at once
              cdModuleAndOthers = getModuleCalcData(cdSubplot, plotMethod);
              cdModule = cdModuleAndOthers[0];
              // don't need to search the found traces again - in fact we need to NOT
              // so that if two modules share the same plotter we don't double-plot
              cdSubplot = cdModuleAndOthers[1];
  
              if(cdModule.length) {
                  layerData.push({
                      i: traceLayerClasses.indexOf(className),
                      className: className,
                      plotMethod: plotMethod,
                      cdModule: cdModule
                  });
              }
  
              if(categories.zoomScale) {
                  zoomScaleQueryParts.push('.' + className);
              }
          }
      }
  
      layerData.sort(function(a, b) { return a.i - b.i; });
  
      var layers = plotinfo.plot.selectAll('g.mlayer')
          .data(layerData, function(d) { return d.className; });
  
      layers.enter().append('g')
          .attr('class', function(d) { return d.className; })
          .classed('mlayer', true)
          .classed('rangeplot', plotinfo.isRangePlot);
  
      layers.exit().remove();
  
      layers.order();
  
      layers.each(function(d) {
          var sel = d3.select(this);
          var className = d.className;
  
          d.plotMethod(
              gd, plotinfo, d.cdModule, sel,
              transitionOpts, makeOnCompleteCallback
          );
  
          // layers that allow `cliponaxis: false`
          if(constants.clipOnAxisFalseQuery.indexOf('.' + className) === -1) {
              Drawing.setClipUrl(sel, plotinfo.layerClipId, gd);
          }
      });
  
      // call Scattergl.plot separately
      if(fullLayout._has('scattergl')) {
          _module = Registry.getModule('scattergl');
          cdModule = getModuleCalcData(cdSubplot, _module)[0];
          _module.plot(gd, plotinfo, cdModule);
      }
  
      // stash "hot" selections for faster interaction on drag and scroll
      if(!gd._context.staticPlot) {
          if(plotinfo._hasClipOnAxisFalse) {
              plotinfo.clipOnAxisFalseTraces = plotinfo.plot
                  .selectAll(constants.clipOnAxisFalseQuery.join(','))
                  .selectAll('.trace');
          }
  
          if(zoomScaleQueryParts.length) {
              var traces = plotinfo.plot
                  .selectAll(zoomScaleQueryParts.join(','))
                  .selectAll('.trace');
  
              plotinfo.zoomScalePts = traces.selectAll('path.point');
              plotinfo.zoomScaleTxt = traces.selectAll('.textpoint');
          }
      }
  }
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var oldPlots = oldFullLayout._plots || {};
      var newPlots = newFullLayout._plots || {};
      var oldSubplotList = oldFullLayout._subplots || {};
      var plotinfo;
      var i, k;
  
      // when going from a large splom graph to something else,
      // we need to clear <g subplot> so that the new cartesian subplot
      // can have the correct layer ordering
      if(oldFullLayout._hasOnlyLargeSploms && !newFullLayout._hasOnlyLargeSploms) {
          for(k in oldPlots) {
              plotinfo = oldPlots[k];
              if(plotinfo.plotgroup) plotinfo.plotgroup.remove();
          }
      }
  
      var hadGl = (oldFullLayout._has && oldFullLayout._has('gl'));
      var hasGl = (newFullLayout._has && newFullLayout._has('gl'));
  
      if(hadGl && !hasGl) {
          for(k in oldPlots) {
              plotinfo = oldPlots[k];
              if(plotinfo._scene) plotinfo._scene.destroy();
          }
      }
  
      // delete any titles we don't need anymore
      // check if axis list has changed, and if so clear old titles
      if(oldSubplotList.xaxis && oldSubplotList.yaxis) {
          var oldAxIDs = axisIds.listIds({_fullLayout: oldFullLayout});
          for(i = 0; i < oldAxIDs.length; i++) {
              var oldAxId = oldAxIDs[i];
              if(!newFullLayout[axisIds.id2name(oldAxId)]) {
                  oldFullLayout._infolayer.selectAll('.g-' + oldAxId + 'title').remove();
              }
          }
      }
  
      var hadCartesian = (oldFullLayout._has && oldFullLayout._has('cartesian'));
      var hasCartesian = (newFullLayout._has && newFullLayout._has('cartesian'));
  
      if(hadCartesian && !hasCartesian) {
          // if we've gotten rid of all cartesian traces, remove all the subplot svg items
  
          purgeSubplotLayers(oldFullLayout._cartesianlayer.selectAll('.subplot'), oldFullLayout);
          oldFullLayout._defs.selectAll('.axesclip').remove();
          delete oldFullLayout._axisConstraintGroups;
      } else if(oldSubplotList.cartesian) {
          // otherwise look for subplots we need to remove
  
          for(i = 0; i < oldSubplotList.cartesian.length; i++) {
              var oldSubplotId = oldSubplotList.cartesian[i];
              if(!newPlots[oldSubplotId]) {
                  var selector = '.' + oldSubplotId + ',.' + oldSubplotId + '-x,.' + oldSubplotId + '-y';
                  oldFullLayout._cartesianlayer.selectAll(selector).remove();
                  removeSubplotExtras(oldSubplotId, oldFullLayout);
              }
          }
      }
  };
  
  exports.drawFramework = function(gd) {
      var fullLayout = gd._fullLayout;
      var subplotData = makeSubplotData(gd);
  
      var subplotLayers = fullLayout._cartesianlayer.selectAll('.subplot')
          .data(subplotData, String);
  
      subplotLayers.enter().append('g')
          .attr('class', function(d) { return 'subplot ' + d[0]; });
  
      subplotLayers.order();
  
      subplotLayers.exit()
          .call(purgeSubplotLayers, fullLayout);
  
      subplotLayers.each(function(d) {
          var id = d[0];
          var plotinfo = fullLayout._plots[id];
  
          plotinfo.plotgroup = d3.select(this);
          makeSubplotLayer(gd, plotinfo);
  
          // make separate drag layers for each subplot,
          // but append them to paper rather than the plot groups,
          // so they end up on top of the rest
          plotinfo.draglayer = ensureSingle(fullLayout._draggers, 'g', id);
      });
  };
  
  exports.rangePlot = function(gd, plotinfo, cdSubplot) {
      makeSubplotLayer(gd, plotinfo);
      plotOne(gd, plotinfo, cdSubplot);
      Plots.style(gd);
  };
  
  function makeSubplotData(gd) {
      var fullLayout = gd._fullLayout;
      var ids = fullLayout._subplots.cartesian;
      var len = ids.length;
      var i, j, id, plotinfo, xa, ya;
  
      // split 'regular' and 'overlaying' subplots
      var regulars = [];
      var overlays = [];
  
      for(i = 0; i < len; i++) {
          id = ids[i];
          plotinfo = fullLayout._plots[id];
          xa = plotinfo.xaxis;
          ya = plotinfo.yaxis;
  
          var xa2 = xa._mainAxis;
          var ya2 = ya._mainAxis;
          var mainplot = xa2._id + ya2._id;
          var mainplotinfo = fullLayout._plots[mainplot];
          plotinfo.overlays = [];
  
          if(mainplot !== id && mainplotinfo) {
              plotinfo.mainplot = mainplot;
              plotinfo.mainplotinfo = mainplotinfo;
              overlays.push(id);
          } else {
              plotinfo.mainplot = undefined;
              plotinfo.mainplotinfo = undefined;
              regulars.push(id);
          }
      }
  
      // fill in list of overlaying subplots in 'main plot'
      for(i = 0; i < overlays.length; i++) {
          id = overlays[i];
          plotinfo = fullLayout._plots[id];
          plotinfo.mainplotinfo.overlays.push(plotinfo);
      }
  
      // put 'regular' subplot data before 'overlaying'
      var subplotIds = regulars.concat(overlays);
      var subplotData = new Array(len);
  
      for(i = 0; i < len; i++) {
          id = subplotIds[i];
          plotinfo = fullLayout._plots[id];
          xa = plotinfo.xaxis;
          ya = plotinfo.yaxis;
  
          // use info about axis layer and overlaying pattern
          // to clean what need to be cleaned up in exit selection
          var d = [id, xa.layer, ya.layer, xa.overlaying || '', ya.overlaying || ''];
          for(j = 0; j < plotinfo.overlays.length; j++) {
              d.push(plotinfo.overlays[j].id);
          }
          subplotData[i] = d;
      }
  
      return subplotData;
  }
  
  function makeSubplotLayer(gd, plotinfo) {
      var plotgroup = plotinfo.plotgroup;
      var id = plotinfo.id;
      var xLayer = constants.layerValue2layerClass[plotinfo.xaxis.layer];
      var yLayer = constants.layerValue2layerClass[plotinfo.yaxis.layer];
      var hasOnlyLargeSploms = gd._fullLayout._hasOnlyLargeSploms;
  
      if(!plotinfo.mainplot) {
          if(hasOnlyLargeSploms) {
              // TODO could do even better
              // - we don't need plot (but we would have to mock it in lsInner
              //   and other places
              // - we don't (x|y)lines and (x|y)axislayer for most subplots
              //   usually just the bottom x and left y axes.
              plotinfo.xlines = ensureSingle(plotgroup, 'path', 'xlines-above');
              plotinfo.ylines = ensureSingle(plotgroup, 'path', 'ylines-above');
              plotinfo.xaxislayer = ensureSingle(plotgroup, 'g', 'xaxislayer-above');
              plotinfo.yaxislayer = ensureSingle(plotgroup, 'g', 'yaxislayer-above');
          } else {
              var backLayer = ensureSingle(plotgroup, 'g', 'layer-subplot');
              plotinfo.shapelayer = ensureSingle(backLayer, 'g', 'shapelayer');
              plotinfo.imagelayer = ensureSingle(backLayer, 'g', 'imagelayer');
  
              plotinfo.gridlayer = ensureSingle(plotgroup, 'g', 'gridlayer');
              plotinfo.zerolinelayer = ensureSingle(plotgroup, 'g', 'zerolinelayer');
  
              ensureSingle(plotgroup, 'path', 'xlines-below');
              ensureSingle(plotgroup, 'path', 'ylines-below');
              plotinfo.overlinesBelow = ensureSingle(plotgroup, 'g', 'overlines-below');
  
              ensureSingle(plotgroup, 'g', 'xaxislayer-below');
              ensureSingle(plotgroup, 'g', 'yaxislayer-below');
              plotinfo.overaxesBelow = ensureSingle(plotgroup, 'g', 'overaxes-below');
  
              plotinfo.plot = ensureSingle(plotgroup, 'g', 'plot');
              plotinfo.overplot = ensureSingle(plotgroup, 'g', 'overplot');
  
              plotinfo.xlines = ensureSingle(plotgroup, 'path', 'xlines-above');
              plotinfo.ylines = ensureSingle(plotgroup, 'path', 'ylines-above');
              plotinfo.overlinesAbove = ensureSingle(plotgroup, 'g', 'overlines-above');
  
              ensureSingle(plotgroup, 'g', 'xaxislayer-above');
              ensureSingle(plotgroup, 'g', 'yaxislayer-above');
              plotinfo.overaxesAbove = ensureSingle(plotgroup, 'g', 'overaxes-above');
  
              // set refs to correct layers as determined by 'axis.layer'
              plotinfo.xlines = plotgroup.select('.xlines-' + xLayer);
              plotinfo.ylines = plotgroup.select('.ylines-' + yLayer);
              plotinfo.xaxislayer = plotgroup.select('.xaxislayer-' + xLayer);
              plotinfo.yaxislayer = plotgroup.select('.yaxislayer-' + yLayer);
          }
      } else {
          var mainplotinfo = plotinfo.mainplotinfo;
          var mainplotgroup = mainplotinfo.plotgroup;
          var xId = id + '-x';
          var yId = id + '-y';
  
          // now make the components of overlaid subplots
          // overlays don't have backgrounds, and append all
          // their other components to the corresponding
          // extra groups of their main plots.
  
          plotinfo.gridlayer = mainplotinfo.gridlayer;
          plotinfo.zerolinelayer = mainplotinfo.zerolinelayer;
  
          ensureSingle(mainplotinfo.overlinesBelow, 'path', xId);
          ensureSingle(mainplotinfo.overlinesBelow, 'path', yId);
          ensureSingle(mainplotinfo.overaxesBelow, 'g', xId);
          ensureSingle(mainplotinfo.overaxesBelow, 'g', yId);
  
          plotinfo.plot = ensureSingle(mainplotinfo.overplot, 'g', id);
  
          ensureSingle(mainplotinfo.overlinesAbove, 'path', xId);
          ensureSingle(mainplotinfo.overlinesAbove, 'path', yId);
          ensureSingle(mainplotinfo.overaxesAbove, 'g', xId);
          ensureSingle(mainplotinfo.overaxesAbove, 'g', yId);
  
          // set refs to correct layers as determined by 'abovetraces'
          plotinfo.xlines = mainplotgroup.select('.overlines-' + xLayer).select('.' + xId);
          plotinfo.ylines = mainplotgroup.select('.overlines-' + yLayer).select('.' + yId);
          plotinfo.xaxislayer = mainplotgroup.select('.overaxes-' + xLayer).select('.' + xId);
          plotinfo.yaxislayer = mainplotgroup.select('.overaxes-' + yLayer).select('.' + yId);
      }
  
      // common attributes for all subplots, overlays or not
  
      if(!hasOnlyLargeSploms) {
          ensureSingleAndAddDatum(plotinfo.gridlayer, 'g', plotinfo.xaxis._id);
          ensureSingleAndAddDatum(plotinfo.gridlayer, 'g', plotinfo.yaxis._id);
          plotinfo.gridlayer.selectAll('g')
              .map(function(d) { return d[0]; })
              .sort(axisIds.idSort);
      }
  
      plotinfo.xlines
          .style('fill', 'none')
          .classed('crisp', true);
  
      plotinfo.ylines
          .style('fill', 'none')
          .classed('crisp', true);
  }
  
  function purgeSubplotLayers(layers, fullLayout) {
      if(!layers) return;
  
      var overlayIdsToRemove = {};
  
      layers.each(function(d) {
          var id = d[0];
          var plotgroup = d3.select(this);
  
          plotgroup.remove();
          removeSubplotExtras(id, fullLayout);
          overlayIdsToRemove[id] = true;
  
          // do not remove individual axis <clipPath>s here
          // as other subplots may need them
      });
  
      // must remove overlaid subplot trace layers 'manually'
  
      for(var k in fullLayout._plots) {
          var subplotInfo = fullLayout._plots[k];
          var overlays = subplotInfo.overlays || [];
  
          for(var j = 0; j < overlays.length; j++) {
              var overlayInfo = overlays[j];
  
              if(overlayIdsToRemove[overlayInfo.id]) {
                  overlayInfo.plot.selectAll('.trace').remove();
              }
          }
      }
  }
  
  function removeSubplotExtras(subplotId, fullLayout) {
      fullLayout._draggers.selectAll('g.' + subplotId).remove();
      fullLayout._defs.select('#clip' + fullLayout._uid + subplotId + 'plot').remove();
  }
  
  exports.toSVG = function(gd) {
      var imageRoot = gd._fullLayout._glimages;
      var root = d3.select(gd).selectAll('.svg-container');
      var canvases = root.filter(function(d, i) {return i === root.size() - 1;})
          .selectAll('.gl-canvas-context, .gl-canvas-focus');
  
      function canvasToImage() {
          var canvas = this;
          var imageData = canvas.toDataURL('image/png');
          var image = imageRoot.append('svg:image');
  
          image.attr({
              xmlns: xmlnsNamespaces.svg,
              'xlink:href': imageData,
              preserveAspectRatio: 'none',
              x: 0,
              y: 0,
              width: canvas.width,
              height: canvas.height
          });
      }
  
      canvases.each(canvasToImage);
  };
  
  exports.updateFx = _dereq_('./graph_interact').updateFx;
  
  },{"../../components/drawing":637,"../../constants/xmlns_namespaces":726,"../../lib":750,"../../registry":882,"../get_data":836,"../plots":862,"./attributes":797,"./axis_ids":802,"./constants":805,"./graph_interact":808,"./layout_attributes":813,"./layout_defaults":814,"./transition_axes":823,"d3":169}],813:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('../font_attributes');
  var colorAttrs = _dereq_('../../components/color/attributes');
  var dash = _dereq_('../../components/drawing/attributes').dash;
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  
  var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
  var DATE_FORMAT_LINK = _dereq_('../../constants/docs').DATE_FORMAT_LINK;
  var ONEDAY = _dereq_('../../constants/numerical').ONEDAY;
  var constants = _dereq_('./constants');
  var HOUR = constants.HOUR_PATTERN;
  var DAY_OF_WEEK = constants.WEEKDAY_PATTERN;
  
  module.exports = {
      visible: {
          valType: 'boolean',
          
          editType: 'plot',
          
      },
      color: {
          valType: 'color',
          dflt: colorAttrs.defaultLine,
          
          editType: 'ticks',
          
      },
      title: {
          text: {
              valType: 'string',
              
              editType: 'ticks',
              
          },
          font: fontAttrs({
              editType: 'ticks',
              
          }),
          standoff: {
              valType: 'number',
              
              min: 0,
              editType: 'ticks',
              
          },
          editType: 'ticks'
      },
      type: {
          valType: 'enumerated',
          // '-' means we haven't yet run autotype or couldn't find any data
          // it gets turned into linear in gd._fullLayout but not copied back
          // to gd.data like the others are.
          values: ['-', 'linear', 'log', 'date', 'category', 'multicategory'],
          dflt: '-',
          
          editType: 'calc',
          // we forget when an axis has been autotyped, just writing the auto
          // value back to the input - so it doesn't make sense to template this.
          // Note: we do NOT prohibit this in `coerce`, so if someone enters a
          // type in the template explicitly it will be honored as the default.
          _noTemplating: true,
          
      },
      autorange: {
          valType: 'enumerated',
          values: [true, false, 'reversed'],
          dflt: true,
          
          editType: 'axrange',
          impliedEdits: {'range[0]': undefined, 'range[1]': undefined},
          
      },
      rangemode: {
          valType: 'enumerated',
          values: ['normal', 'tozero', 'nonnegative'],
          dflt: 'normal',
          
          editType: 'plot',
          
      },
      range: {
          valType: 'info_array',
          
          items: [
              {valType: 'any', editType: 'axrange', impliedEdits: {'^autorange': false}, anim: true},
              {valType: 'any', editType: 'axrange', impliedEdits: {'^autorange': false}, anim: true}
          ],
          editType: 'axrange',
          impliedEdits: {'autorange': false},
          anim: true,
          
      },
      fixedrange: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'calc',
          
      },
      // scaleanchor: not used directly, just put here for reference
      // values are any opposite-letter axis id
      scaleanchor: {
          valType: 'enumerated',
          values: [
              constants.idRegex.x.toString(),
              constants.idRegex.y.toString()
          ],
          
          editType: 'plot',
          
      },
      scaleratio: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'plot',
          
      },
      constrain: {
          valType: 'enumerated',
          values: ['range', 'domain'],
          dflt: 'range',
          
          editType: 'plot',
          
      },
      // constraintoward: not used directly, just put here for reference
      constraintoward: {
          valType: 'enumerated',
          values: ['left', 'center', 'right', 'top', 'middle', 'bottom'],
          
          editType: 'plot',
          
      },
      matches: {
          valType: 'enumerated',
          values: [
              constants.idRegex.x.toString(),
              constants.idRegex.y.toString()
          ],
          
          editType: 'calc',
          
      },
  
      rangebreaks: templatedArray('rangebreak', {
          enabled: {
              valType: 'boolean',
              
              dflt: true,
              editType: 'calc',
              
          },
  
          bounds: {
              valType: 'info_array',
              
              items: [
                  {valType: 'any', editType: 'calc'},
                  {valType: 'any', editType: 'calc'}
              ],
              editType: 'calc',
              
          },
  
          pattern: {
              valType: 'enumerated',
              values: [DAY_OF_WEEK, HOUR, ''],
              
              editType: 'calc',
              
          },
  
          values: {
              valType: 'info_array',
              freeLength: true,
              
              editType: 'calc',
              items: {
                  valType: 'any',
                  editType: 'calc'
              },
              
          },
          dvalue: {
              // TODO could become 'any' to add support for 'months', 'years'
              valType: 'number',
              
              editType: 'calc',
              min: 0,
              dflt: ONEDAY,
              
          },
  
          /*
          gap: {
              valType: 'number',
              min: 0,
              dflt: 0, // for *date* axes, maybe something else for *linear*
              editType: 'calc',
              
              
          },
          gapmode: {
              valType: 'enumerated',
              values: ['pixels', 'fraction'],
              dflt: 'pixels',
              editType: 'calc',
              
              
          },
          */
  
          // To complete https://github.com/plotly/plotly.js/issues/4210
          // we additionally need `gap` and make this work on *linear*, and
          // possibly all other cartesian axis types. We possibly would also need
          // some style attributes controlling the zig-zag on the corresponding
          // axis.
  
          editType: 'calc'
      }),
  
      // ticks
      tickmode: {
          valType: 'enumerated',
          values: ['auto', 'linear', 'array'],
          
          editType: 'ticks',
          impliedEdits: {tick0: undefined, dtick: undefined},
          
      },
      nticks: {
          valType: 'integer',
          min: 0,
          dflt: 0,
          
          editType: 'ticks',
          
      },
      tick0: {
          valType: 'any',
          
          editType: 'ticks',
          impliedEdits: {tickmode: 'linear'},
          
      },
      dtick: {
          valType: 'any',
          
          editType: 'ticks',
          impliedEdits: {tickmode: 'linear'},
          
      },
      tickvals: {
          valType: 'data_array',
          editType: 'ticks',
          
      },
      ticktext: {
          valType: 'data_array',
          editType: 'ticks',
          
      },
      ticks: {
          valType: 'enumerated',
          values: ['outside', 'inside', ''],
          
          editType: 'ticks',
          
      },
      tickson: {
          valType: 'enumerated',
          values: ['labels', 'boundaries'],
          
          dflt: 'labels',
          editType: 'ticks',
          
      },
      ticklabelmode: {
          valType: 'enumerated',
          values: ['instant', 'period'],
          dflt: 'instant',
          
          editType: 'ticks',
          
      },
      mirror: {
          valType: 'enumerated',
          values: [true, 'ticks', false, 'all', 'allticks'],
          dflt: false,
          
          editType: 'ticks+layoutstyle',
          
      },
      ticklen: {
          valType: 'number',
          min: 0,
          dflt: 5,
          
          editType: 'ticks',
          
      },
      tickwidth: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'ticks',
          
      },
      tickcolor: {
          valType: 'color',
          dflt: colorAttrs.defaultLine,
          
          editType: 'ticks',
          
      },
      showticklabels: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'ticks',
          
      },
      automargin: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'ticks',
          
      },
      showspikes: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'modebar',
          
      },
      spikecolor: {
          valType: 'color',
          dflt: null,
          
          editType: 'none',
          
      },
      spikethickness: {
          valType: 'number',
          dflt: 3,
          
          editType: 'none',
          
      },
      spikedash: extendFlat({}, dash, {dflt: 'dash', editType: 'none'}),
      spikemode: {
          valType: 'flaglist',
          flags: ['toaxis', 'across', 'marker'],
          
          dflt: 'toaxis',
          editType: 'none',
          
      },
      spikesnap: {
          valType: 'enumerated',
          values: ['data', 'cursor', 'hovered data'],
          dflt: 'data',
          
          editType: 'none',
          
      },
      tickfont: fontAttrs({
          editType: 'ticks',
          
      }),
      tickangle: {
          valType: 'angle',
          dflt: 'auto',
          
          editType: 'ticks',
          
      },
      tickprefix: {
          valType: 'string',
          dflt: '',
          
          editType: 'ticks',
          
      },
      showtickprefix: {
          valType: 'enumerated',
          values: ['all', 'first', 'last', 'none'],
          dflt: 'all',
          
          editType: 'ticks',
          
      },
      ticksuffix: {
          valType: 'string',
          dflt: '',
          
          editType: 'ticks',
          
      },
      showticksuffix: {
          valType: 'enumerated',
          values: ['all', 'first', 'last', 'none'],
          dflt: 'all',
          
          editType: 'ticks',
          
      },
      showexponent: {
          valType: 'enumerated',
          values: ['all', 'first', 'last', 'none'],
          dflt: 'all',
          
          editType: 'ticks',
          
      },
      exponentformat: {
          valType: 'enumerated',
          values: ['none', 'e', 'E', 'power', 'SI', 'B'],
          dflt: 'B',
          
          editType: 'ticks',
          
      },
      minexponent: {
          valType: 'number',
          dflt: 3,
          min: 0,
          
          editType: 'ticks',
          
      },
      separatethousands: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'ticks',
          
      },
      tickformat: {
          valType: 'string',
          dflt: '',
          
          editType: 'ticks',
          
      },
      tickformatstops: templatedArray('tickformatstop', {
          enabled: {
              valType: 'boolean',
              
              dflt: true,
              editType: 'ticks',
              
          },
          dtickrange: {
              valType: 'info_array',
              
              items: [
                  {valType: 'any', editType: 'ticks'},
                  {valType: 'any', editType: 'ticks'}
              ],
              editType: 'ticks',
              
          },
          value: {
              valType: 'string',
              dflt: '',
              
              editType: 'ticks',
              
          },
          editType: 'ticks'
      }),
      hoverformat: {
          valType: 'string',
          dflt: '',
          
          editType: 'none',
          
      },
      // lines and grids
      showline: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'ticks+layoutstyle',
          
      },
      linecolor: {
          valType: 'color',
          dflt: colorAttrs.defaultLine,
          
          editType: 'layoutstyle',
          
      },
      linewidth: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'ticks+layoutstyle',
          
      },
      showgrid: {
          valType: 'boolean',
          
          editType: 'ticks',
          
      },
      gridcolor: {
          valType: 'color',
          dflt: colorAttrs.lightLine,
          
          editType: 'ticks',
          
      },
      gridwidth: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'ticks',
          
      },
      zeroline: {
          valType: 'boolean',
          
          editType: 'ticks',
          
      },
      zerolinecolor: {
          valType: 'color',
          dflt: colorAttrs.defaultLine,
          
          editType: 'ticks',
          
      },
      zerolinewidth: {
          valType: 'number',
          dflt: 1,
          
          editType: 'ticks',
          
      },
  
      showdividers: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'ticks',
          
      },
      dividercolor: {
          valType: 'color',
          dflt: colorAttrs.defaultLine,
          
          editType: 'ticks',
          
      },
      dividerwidth: {
          valType: 'number',
          dflt: 1,
          
          editType: 'ticks',
          
      },
      // TODO dividerlen: that would override "to label base" length?
  
      // positioning attributes
      // anchor: not used directly, just put here for reference
      // values are any opposite-letter axis id
      anchor: {
          valType: 'enumerated',
          values: [
              'free',
              constants.idRegex.x.toString(),
              constants.idRegex.y.toString()
          ],
          
          editType: 'plot',
          
      },
      // side: not used directly, as values depend on direction
      // values are top, bottom for x axes, and left, right for y
      side: {
          valType: 'enumerated',
          values: ['top', 'bottom', 'left', 'right'],
          
          editType: 'plot',
          
      },
      // overlaying: not used directly, just put here for reference
      // values are false and any other same-letter axis id that's not
      // itself overlaying anything
      overlaying: {
          valType: 'enumerated',
          values: [
              'free',
              constants.idRegex.x.toString(),
              constants.idRegex.y.toString()
          ],
          
          editType: 'plot',
          
      },
      layer: {
          valType: 'enumerated',
          values: ['above traces', 'below traces'],
          dflt: 'above traces',
          
          editType: 'plot',
          
      },
      domain: {
          valType: 'info_array',
          
          items: [
              {valType: 'number', min: 0, max: 1, editType: 'plot'},
              {valType: 'number', min: 0, max: 1, editType: 'plot'}
          ],
          dflt: [0, 1],
          editType: 'plot',
          
      },
      position: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 0,
          
          editType: 'plot',
          
      },
      categoryorder: {
          valType: 'enumerated',
          values: [
              'trace', 'category ascending', 'category descending', 'array',
              'total ascending', 'total descending',
              'min ascending', 'min descending',
              'max ascending', 'max descending',
              'sum ascending', 'sum descending',
              'mean ascending', 'mean descending',
              'median ascending', 'median descending'
          ],
          dflt: 'trace',
          
          editType: 'calc',
          
      },
      categoryarray: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
      uirevision: {
          valType: 'any',
          
          editType: 'none',
          
      },
      editType: 'calc',
  
      _deprecated: {
          autotick: {
              valType: 'boolean',
              
              editType: 'ticks',
              
          },
          title: {
              valType: 'string',
              
              editType: 'ticks',
              
          },
          titlefont: fontAttrs({
              editType: 'ticks',
              
          })
      }
  };
  
  },{"../../components/color/attributes":614,"../../components/drawing/attributes":636,"../../constants/docs":720,"../../constants/numerical":725,"../../lib/extend":740,"../../plot_api/plot_template":788,"../font_attributes":827,"./constants":805}],814:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  var isUnifiedHover = _dereq_('../../components/fx/helpers').isUnifiedHover;
  var handleHoverModeDefaults = _dereq_('../../components/fx/hovermode_defaults');
  var Template = _dereq_('../../plot_api/plot_template');
  var basePlotLayoutAttributes = _dereq_('../layout_attributes');
  
  var layoutAttributes = _dereq_('./layout_attributes');
  var handleTypeDefaults = _dereq_('./type_defaults');
  var handleAxisDefaults = _dereq_('./axis_defaults');
  var handleConstraintDefaults = _dereq_('./constraints').handleConstraintDefaults;
  var handlePositionDefaults = _dereq_('./position_defaults');
  
  var axisIds = _dereq_('./axis_ids');
  var id2name = axisIds.id2name;
  var name2id = axisIds.name2id;
  
  var AX_ID_PATTERN = _dereq_('./constants').AX_ID_PATTERN;
  
  var Registry = _dereq_('../../registry');
  var traceIs = Registry.traceIs;
  var getComponentMethod = Registry.getComponentMethod;
  
  function appendList(cont, k, item) {
      if(Array.isArray(cont[k])) cont[k].push(item);
      else cont[k] = [item];
  }
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
      var ax2traces = {};
      var xaMayHide = {};
      var yaMayHide = {};
      var xaMustDisplay = {};
      var yaMustDisplay = {};
      var yaMustNotReverse = {};
      var yaMayReverse = {};
      var axHasImage = {};
      var outerTicks = {};
      var noGrids = {};
      var i, j;
  
      // look for axes in the data
      for(i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
          if(!traceIs(trace, 'cartesian') && !traceIs(trace, 'gl2d')) continue;
  
          var xaName;
          if(trace.xaxis) {
              xaName = id2name(trace.xaxis);
              appendList(ax2traces, xaName, trace);
          } else if(trace.xaxes) {
              for(j = 0; j < trace.xaxes.length; j++) {
                  appendList(ax2traces, id2name(trace.xaxes[j]), trace);
              }
          }
  
          var yaName;
          if(trace.yaxis) {
              yaName = id2name(trace.yaxis);
              appendList(ax2traces, yaName, trace);
          } else if(trace.yaxes) {
              for(j = 0; j < trace.yaxes.length; j++) {
                  appendList(ax2traces, id2name(trace.yaxes[j]), trace);
              }
          }
  
          // logic for funnels
          if(trace.type === 'funnel') {
              if(trace.orientation === 'h') {
                  if(xaName) xaMayHide[xaName] = true;
                  if(yaName) yaMayReverse[yaName] = true;
              } else {
                  if(yaName) yaMayHide[yaName] = true;
              }
          } else if(trace.type === 'image') {
              if(yaName) axHasImage[yaName] = true;
              if(xaName) axHasImage[xaName] = true;
          } else {
              if(yaName) {
                  yaMustDisplay[yaName] = true;
                  yaMustNotReverse[yaName] = true;
              }
  
              if(!traceIs(trace, 'carpet') || (trace.type === 'carpet' && !trace._cheater)) {
                  if(xaName) xaMustDisplay[xaName] = true;
              }
          }
  
          // Two things trigger axis visibility:
          // 1. is not carpet
          // 2. carpet that's not cheater
  
          // The above check for definitely-not-cheater is not adequate. This
          // second list tracks which axes *could* be a cheater so that the
          // full condition triggering hiding is:
          //   *could* be a cheater and *is not definitely visible*
          if(trace.type === 'carpet' && trace._cheater) {
              if(xaName) xaMayHide[xaName] = true;
          }
  
          // check for default formatting tweaks
          if(traceIs(trace, '2dMap')) {
              outerTicks[xaName] = true;
              outerTicks[yaName] = true;
          }
  
          if(traceIs(trace, 'oriented')) {
              var positionAxis = trace.orientation === 'h' ? yaName : xaName;
              noGrids[positionAxis] = true;
          }
      }
  
      var subplots = layoutOut._subplots;
      var xIds = subplots.xaxis;
      var yIds = subplots.yaxis;
      var xNames = Lib.simpleMap(xIds, id2name);
      var yNames = Lib.simpleMap(yIds, id2name);
      var axNames = xNames.concat(yNames);
  
      // plot_bgcolor only makes sense if there's a (2D) plot!
      // TODO: bgcolor for each subplot, to inherit from the main one
      var plotBgColor = Color.background;
      if(xIds.length && yIds.length) {
          plotBgColor = Lib.coerce(layoutIn, layoutOut, basePlotLayoutAttributes, 'plot_bgcolor');
      }
  
      var bgColor = Color.combine(plotBgColor, layoutOut.paper_bgcolor);
  
      // name of single axis (e.g. 'xaxis', 'yaxis2')
      var axName;
      // id of single axis (e.g. 'y', 'x5')
      var axId;
      // 'x' or 'y'
      var axLetter;
      // input layout axis container
      var axLayoutIn;
      // full layout axis container
      var axLayoutOut;
  
      function newAxLayoutOut() {
          var traces = ax2traces[axName] || [];
          axLayoutOut._traceIndices = traces.map(function(t) { return t._expandedIndex; });
          axLayoutOut._annIndices = [];
          axLayoutOut._shapeIndices = [];
          axLayoutOut._imgIndices = [];
          axLayoutOut._subplotsWith = [];
          axLayoutOut._counterAxes = [];
          axLayoutOut._name = axLayoutOut._attr = axName;
          axLayoutOut._id = axId;
      }
  
      function coerce(attr, dflt) {
          return Lib.coerce(axLayoutIn, axLayoutOut, layoutAttributes, attr, dflt);
      }
  
      function coerce2(attr, dflt) {
          return Lib.coerce2(axLayoutIn, axLayoutOut, layoutAttributes, attr, dflt);
      }
  
      function getCounterAxes(axLetter) {
          return (axLetter === 'x') ? yIds : xIds;
      }
  
      function getOverlayableAxes(axLetter, axName) {
          var list = (axLetter === 'x') ? xNames : yNames;
          var out = [];
  
          for(var j = 0; j < list.length; j++) {
              var axName2 = list[j];
  
              if(axName2 !== axName && !(layoutIn[axName2] || {}).overlaying) {
                  out.push(name2id(axName2));
              }
          }
  
          return out;
      }
  
      // list of available counter axis names
      var counterAxes = {x: getCounterAxes('x'), y: getCounterAxes('y')};
      // list of all x AND y axis ids
      var allAxisIds = counterAxes.x.concat(counterAxes.y);
      // lookup and list of axis ids that axes in axNames have a reference to,
      // even though they are missing from allAxisIds
      var missingMatchedAxisIdsLookup = {};
      var missingMatchedAxisIds = [];
  
      // fill in 'missing' axis lookup when an axis is set to match an axis
      // not part of the allAxisIds list, save axis type so that we can propagate
      // it to the missing axes
      function addMissingMatchedAxis() {
          var matchesIn = axLayoutIn.matches;
          if(AX_ID_PATTERN.test(matchesIn) && allAxisIds.indexOf(matchesIn) === -1) {
              missingMatchedAxisIdsLookup[matchesIn] = axLayoutIn.type;
              missingMatchedAxisIds = Object.keys(missingMatchedAxisIdsLookup);
          }
      }
  
      var hovermode = handleHoverModeDefaults(layoutIn, layoutOut, fullData);
      var unifiedHover = isUnifiedHover(hovermode);
  
      // first pass creates the containers, determines types, and handles most of the settings
      for(i = 0; i < axNames.length; i++) {
          axName = axNames[i];
          axId = name2id(axName);
          axLetter = axName.charAt(0);
  
          if(!Lib.isPlainObject(layoutIn[axName])) {
              layoutIn[axName] = {};
          }
  
          axLayoutIn = layoutIn[axName];
          axLayoutOut = Template.newContainer(layoutOut, axName, axLetter + 'axis');
          newAxLayoutOut();
  
          var visibleDflt =
              (axLetter === 'x' && !xaMustDisplay[axName] && xaMayHide[axName]) ||
              (axLetter === 'y' && !yaMustDisplay[axName] && yaMayHide[axName]);
  
          var reverseDflt =
              (axLetter === 'y' &&
                (
                  (!yaMustNotReverse[axName] && yaMayReverse[axName]) ||
                  axHasImage[axName]
                ));
  
          var defaultOptions = {
              letter: axLetter,
              font: layoutOut.font,
              outerTicks: outerTicks[axName],
              showGrid: !noGrids[axName],
              data: ax2traces[axName] || [],
              bgColor: bgColor,
              calendar: layoutOut.calendar,
              automargin: true,
              visibleDflt: visibleDflt,
              reverseDflt: reverseDflt,
              splomStash: ((layoutOut._splomAxes || {})[axLetter] || {})[axId]
          };
  
          coerce('uirevision', layoutOut.uirevision);
  
          handleTypeDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions);
          handleAxisDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions, layoutOut);
  
          var unifiedSpike = unifiedHover && axLetter === hovermode.charAt(0);
          var spikecolor = coerce2('spikecolor', unifiedHover ? axLayoutOut.color : undefined);
          var spikethickness = coerce2('spikethickness', unifiedHover ? 1.5 : undefined);
          var spikedash = coerce2('spikedash', unifiedHover ? 'dot' : undefined);
          var spikemode = coerce2('spikemode', unifiedHover ? 'across' : undefined);
          var spikesnap = coerce2('spikesnap', unifiedHover ? 'hovered data' : undefined);
          var showSpikes = coerce('showspikes', !!unifiedSpike || !!spikecolor || !!spikethickness || !!spikedash || !!spikemode || !!spikesnap);
  
          if(!showSpikes) {
              delete axLayoutOut.spikecolor;
              delete axLayoutOut.spikethickness;
              delete axLayoutOut.spikedash;
              delete axLayoutOut.spikemode;
              delete axLayoutOut.spikesnap;
          }
  
          handlePositionDefaults(axLayoutIn, axLayoutOut, coerce, {
              letter: axLetter,
              counterAxes: counterAxes[axLetter],
              overlayableAxes: getOverlayableAxes(axLetter, axName),
              grid: layoutOut.grid
          });
  
          coerce('title.standoff');
  
          addMissingMatchedAxis();
  
          axLayoutOut._input = axLayoutIn;
      }
  
      // coerce the 'missing' axes
      i = 0;
      while(i < missingMatchedAxisIds.length) {
          axId = missingMatchedAxisIds[i++];
          axName = id2name(axId);
          axLetter = axName.charAt(0);
  
          if(!Lib.isPlainObject(layoutIn[axName])) {
              layoutIn[axName] = {};
          }
  
          axLayoutIn = layoutIn[axName];
          axLayoutOut = Template.newContainer(layoutOut, axName, axLetter + 'axis');
          newAxLayoutOut();
  
          var defaultOptions2 = {
              letter: axLetter,
              font: layoutOut.font,
              outerTicks: outerTicks[axName],
              showGrid: !noGrids[axName],
              data: [],
              bgColor: bgColor,
              calendar: layoutOut.calendar,
              automargin: true,
              visibleDflt: false,
              reverseDflt: false,
              splomStash: ((layoutOut._splomAxes || {})[axLetter] || {})[axId]
          };
  
          coerce('uirevision', layoutOut.uirevision);
  
          axLayoutOut.type = missingMatchedAxisIdsLookup[axId] || 'linear';
  
          handleAxisDefaults(axLayoutIn, axLayoutOut, coerce, defaultOptions2, layoutOut);
  
          handlePositionDefaults(axLayoutIn, axLayoutOut, coerce, {
              letter: axLetter,
              counterAxes: counterAxes[axLetter],
              overlayableAxes: getOverlayableAxes(axLetter, axName),
              grid: layoutOut.grid
          });
  
          coerce('fixedrange');
  
          addMissingMatchedAxis();
  
          axLayoutOut._input = axLayoutIn;
      }
  
      // quick second pass for range slider and selector defaults
      var rangeSliderDefaults = getComponentMethod('rangeslider', 'handleDefaults');
      var rangeSelectorDefaults = getComponentMethod('rangeselector', 'handleDefaults');
  
      for(i = 0; i < xNames.length; i++) {
          axName = xNames[i];
          axLayoutIn = layoutIn[axName];
          axLayoutOut = layoutOut[axName];
  
          rangeSliderDefaults(layoutIn, layoutOut, axName);
  
          if(axLayoutOut.type === 'date') {
              rangeSelectorDefaults(
                  axLayoutIn,
                  axLayoutOut,
                  layoutOut,
                  yNames,
                  axLayoutOut.calendar
              );
          }
  
          coerce('fixedrange');
      }
  
      for(i = 0; i < yNames.length; i++) {
          axName = yNames[i];
          axLayoutIn = layoutIn[axName];
          axLayoutOut = layoutOut[axName];
  
          var anchoredAxis = layoutOut[id2name(axLayoutOut.anchor)];
  
          var fixedRangeDflt = getComponentMethod('rangeslider', 'isVisible')(anchoredAxis);
  
          coerce('fixedrange', fixedRangeDflt);
      }
  
      // Finally, handle scale constraints and matching axes.
      //
      // We need to do this after all axes have coerced both `type`
      // (so we link only axes of the same type) and
      // `fixedrange` (so we can avoid linking from OR TO a fixed axis).
  
      // sets of axes linked by `scaleanchor` along with the scaleratios compounded
      // together, populated in handleConstraintDefaults
      var constraintGroups = layoutOut._axisConstraintGroups = [];
      // similar to _axisConstraintGroups, but for matching axes
      var matchGroups = layoutOut._axisMatchGroups = [];
      // make sure to include 'missing' axes here
      var allAxisIdsIncludingMissing = allAxisIds.concat(missingMatchedAxisIds);
      var axNamesIncludingMissing = axNames.concat(Lib.simpleMap(missingMatchedAxisIds, id2name));
  
      for(i = 0; i < axNamesIncludingMissing.length; i++) {
          axName = axNamesIncludingMissing[i];
          axLetter = axName.charAt(0);
          axLayoutIn = layoutIn[axName];
          axLayoutOut = layoutOut[axName];
  
          var scaleanchorDflt;
          if(axLetter === 'y' && !axLayoutIn.hasOwnProperty('scaleanchor') && axHasImage[axName]) {
              scaleanchorDflt = axLayoutOut.anchor;
          } else {
              scaleanchorDflt = undefined;
          }
  
          var constrainDflt;
          if(!axLayoutIn.hasOwnProperty('constrain') && axHasImage[axName]) {
              constrainDflt = 'domain';
          } else {
              constrainDflt = undefined;
          }
  
          handleConstraintDefaults(axLayoutIn, axLayoutOut, coerce, {
              allAxisIds: allAxisIdsIncludingMissing,
              layoutOut: layoutOut,
              scaleanchorDflt: scaleanchorDflt,
              constrainDflt: constrainDflt
          });
      }
  
      for(i = 0; i < matchGroups.length; i++) {
          var group = matchGroups[i];
          var rng = null;
          var autorange = null;
  
          // find 'matching' range attrs
          for(axId in group) {
              axLayoutOut = layoutOut[id2name(axId)];
              if(!axLayoutOut.matches) {
                  rng = axLayoutOut.range;
                  autorange = axLayoutOut.autorange;
              }
          }
          // if `ax.matches` values are reciprocal,
          // pick values of first axis in group
          if(rng === null || autorange === null) {
              for(axId in group) {
                  axLayoutOut = layoutOut[id2name(axId)];
                  rng = axLayoutOut.range;
                  autorange = axLayoutOut.autorange;
                  break;
              }
          }
          // apply matching range attrs
          for(axId in group) {
              axLayoutOut = layoutOut[id2name(axId)];
              if(axLayoutOut.matches) {
                  axLayoutOut.range = rng.slice();
                  axLayoutOut.autorange = autorange;
              }
              axLayoutOut._matchGroup = group;
          }
  
          // remove matching axis from scaleanchor constraint groups (for now)
          if(constraintGroups.length) {
              for(axId in group) {
                  for(j = 0; j < constraintGroups.length; j++) {
                      var group2 = constraintGroups[j];
                      for(var axId2 in group2) {
                          if(axId === axId2) {
                              Lib.warn('Axis ' + axId2 + ' is set with both ' +
                                  'a *scaleanchor* and *matches* constraint; ' +
                                  'ignoring the scale constraint.');
  
                              delete group2[axId2];
                              if(Object.keys(group2).length < 2) {
                                  constraintGroups.splice(j, 1);
                              }
                          }
                      }
                  }
              }
          }
      }
  };
  
  },{"../../components/color":615,"../../components/fx/helpers":651,"../../components/fx/hovermode_defaults":654,"../../lib":750,"../../plot_api/plot_template":788,"../../registry":882,"../layout_attributes":853,"./axis_defaults":801,"./axis_ids":802,"./constants":805,"./constraints":806,"./layout_attributes":813,"./position_defaults":816,"./type_defaults":824}],815:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorMix = _dereq_('tinycolor2').mix;
  var lightFraction = _dereq_('../../components/color/attributes').lightFraction;
  var Lib = _dereq_('../../lib');
  
  /**
   * @param {object} opts :
   *   - dfltColor {string} : default axis color
   *   - bgColor {string} : combined subplot bg color
   *   - blend {number, optional} : blend percentage (to compute dflt grid color)
   *   - showLine {boolean} : show line by default
   *   - showGrid {boolean} : show grid by default
   *   - noZeroLine {boolean} : don't coerce zeroline* attributes
   *   - attributes {object} : attribute object associated with input containers
   */
  module.exports = function handleLineGridDefaults(containerIn, containerOut, coerce, opts) {
      opts = opts || {};
  
      var dfltColor = opts.dfltColor;
  
      function coerce2(attr, dflt) {
          return Lib.coerce2(containerIn, containerOut, opts.attributes, attr, dflt);
      }
  
      var lineColor = coerce2('linecolor', dfltColor);
      var lineWidth = coerce2('linewidth');
      var showLine = coerce('showline', opts.showLine || !!lineColor || !!lineWidth);
  
      if(!showLine) {
          delete containerOut.linecolor;
          delete containerOut.linewidth;
      }
  
      var gridColorDflt = colorMix(dfltColor, opts.bgColor, opts.blend || lightFraction).toRgbString();
      var gridColor = coerce2('gridcolor', gridColorDflt);
      var gridWidth = coerce2('gridwidth');
      var showGridLines = coerce('showgrid', opts.showGrid || !!gridColor || !!gridWidth);
  
      if(!showGridLines) {
          delete containerOut.gridcolor;
          delete containerOut.gridwidth;
      }
  
      if(!opts.noZeroLine) {
          var zeroLineColor = coerce2('zerolinecolor', dfltColor);
          var zeroLineWidth = coerce2('zerolinewidth');
          var showZeroLine = coerce('zeroline', opts.showGrid || !!zeroLineColor || !!zeroLineWidth);
  
          if(!showZeroLine) {
              delete containerOut.zerolinecolor;
              delete containerOut.zerolinewidth;
          }
      }
  };
  
  },{"../../components/color/attributes":614,"../../lib":750,"tinycolor2":548}],816:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  
  
  module.exports = function handlePositionDefaults(containerIn, containerOut, coerce, options) {
      var counterAxes = options.counterAxes || [];
      var overlayableAxes = options.overlayableAxes || [];
      var letter = options.letter;
      var grid = options.grid;
  
      var dfltAnchor, dfltDomain, dfltSide, dfltPosition;
  
      if(grid) {
          dfltDomain = grid._domains[letter][grid._axisMap[containerOut._id]];
          dfltAnchor = grid._anchors[containerOut._id];
          if(dfltDomain) {
              dfltSide = grid[letter + 'side'].split(' ')[0];
              dfltPosition = grid.domain[letter][dfltSide === 'right' || dfltSide === 'top' ? 1 : 0];
          }
      }
  
      // Even if there's a grid, this axis may not be in it - fall back on non-grid defaults
      dfltDomain = dfltDomain || [0, 1];
      dfltAnchor = dfltAnchor || (isNumeric(containerIn.position) ? 'free' : (counterAxes[0] || 'free'));
      dfltSide = dfltSide || (letter === 'x' ? 'bottom' : 'left');
      dfltPosition = dfltPosition || 0;
  
      var anchor = Lib.coerce(containerIn, containerOut, {
          anchor: {
              valType: 'enumerated',
              values: ['free'].concat(counterAxes),
              dflt: dfltAnchor
          }
      }, 'anchor');
  
      if(anchor === 'free') coerce('position', dfltPosition);
  
      Lib.coerce(containerIn, containerOut, {
          side: {
              valType: 'enumerated',
              values: letter === 'x' ? ['bottom', 'top'] : ['left', 'right'],
              dflt: dfltSide
          }
      }, 'side');
  
      var overlaying = false;
      if(overlayableAxes.length) {
          overlaying = Lib.coerce(containerIn, containerOut, {
              overlaying: {
                  valType: 'enumerated',
                  values: [false].concat(overlayableAxes),
                  dflt: false
              }
          }, 'overlaying');
      }
  
      if(!overlaying) {
          // TODO: right now I'm copying this domain over to overlaying axes
          // in ax.setscale()... but this means we still need (imperfect) logic
          // in the axes popover to hide domain for the overlaying axis.
          // perhaps I should make a private version _domain that all axes get???
          var domain = coerce('domain', dfltDomain);
  
          // according to https://www.npmjs.com/package/canvas-size
          // the minimum value of max canvas width across browsers and devices is 4096
          // which applied in the calculation below:
          if(domain[0] > domain[1] - 1 / 4096) containerOut.domain = dfltDomain;
          Lib.noneOrAll(containerIn.domain, containerOut.domain, dfltDomain);
      }
  
      coerce('layer');
  
      return containerOut;
  };
  
  },{"../../lib":750,"fast-isnumeric":241}],817:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var FROM_BL = _dereq_('../../constants/alignment').FROM_BL;
  
  module.exports = function scaleZoom(ax, factor, centerFraction) {
      if(centerFraction === undefined) {
          centerFraction = FROM_BL[ax.constraintoward || 'center'];
      }
  
      var rangeLinear = [ax.r2l(ax.range[0]), ax.r2l(ax.range[1])];
      var center = rangeLinear[0] + (rangeLinear[1] - rangeLinear[0]) * centerFraction;
  
      ax.range = ax._input.range = [
          ax.l2r(center + (rangeLinear[0] - center) * factor),
          ax.l2r(center + (rangeLinear[1] - center) * factor)
      ];
  };
  
  },{"../../constants/alignment":717}],818:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var polybool = _dereq_('polybooljs');
  
  var Registry = _dereq_('../../registry');
  var dashStyle = _dereq_('../../components/drawing').dashStyle;
  var Color = _dereq_('../../components/color');
  var Fx = _dereq_('../../components/fx');
  var makeEventData = _dereq_('../../components/fx/helpers').makeEventData;
  var dragHelpers = _dereq_('../../components/dragelement/helpers');
  var freeMode = dragHelpers.freeMode;
  var rectMode = dragHelpers.rectMode;
  var drawMode = dragHelpers.drawMode;
  var openMode = dragHelpers.openMode;
  var selectMode = dragHelpers.selectMode;
  
  var displayOutlines = _dereq_('../../components/shapes/draw_newshape/display_outlines');
  var handleEllipse = _dereq_('../../components/shapes/draw_newshape/helpers').handleEllipse;
  var newShapes = _dereq_('../../components/shapes/draw_newshape/newshapes');
  
  var Lib = _dereq_('../../lib');
  var polygon = _dereq_('../../lib/polygon');
  var throttle = _dereq_('../../lib/throttle');
  var getFromId = _dereq_('./axis_ids').getFromId;
  var clearGlCanvases = _dereq_('../../lib/clear_gl_canvases');
  
  var redrawReglTraces = _dereq_('../../plot_api/subroutines').redrawReglTraces;
  
  var constants = _dereq_('./constants');
  var MINSELECT = constants.MINSELECT;
  
  var filteredPolygon = polygon.filter;
  var polygonTester = polygon.tester;
  
  var clearSelect = _dereq_('./handle_outline').clearSelect;
  
  var helpers = _dereq_('./helpers');
  var p2r = helpers.p2r;
  var axValue = helpers.axValue;
  var getTransform = helpers.getTransform;
  
  function prepSelect(e, startX, startY, dragOptions, mode) {
      var isFreeMode = freeMode(mode);
      var isRectMode = rectMode(mode);
      var isOpenMode = openMode(mode);
      var isDrawMode = drawMode(mode);
      var isSelectMode = selectMode(mode);
  
      var isLine = mode === 'drawline';
      var isEllipse = mode === 'drawcircle';
      var isLineOrEllipse = isLine || isEllipse; // cases with two start & end positions
  
      var gd = dragOptions.gd;
      var fullLayout = gd._fullLayout;
      var zoomLayer = fullLayout._zoomlayer;
      var dragBBox = dragOptions.element.getBoundingClientRect();
      var plotinfo = dragOptions.plotinfo;
      var transform = getTransform(plotinfo);
      var x0 = startX - dragBBox.left;
      var y0 = startY - dragBBox.top;
      var x1 = x0;
      var y1 = y0;
      var path0 = 'M' + x0 + ',' + y0;
      var pw = dragOptions.xaxes[0]._length;
      var ph = dragOptions.yaxes[0]._length;
      var allAxes = dragOptions.xaxes.concat(dragOptions.yaxes);
      var subtract = e.altKey &&
          !(drawMode(mode) && isOpenMode);
  
      var filterPoly, selectionTester, mergedPolygons, currentPolygon;
      var i, searchInfo, eventData;
  
      coerceSelectionsCache(e, gd, dragOptions);
  
      if(isFreeMode) {
          filterPoly = filteredPolygon([[x0, y0]], constants.BENDPX);
      }
  
      var outlines = zoomLayer.selectAll('path.select-outline-' + plotinfo.id).data(isDrawMode ? [0] : [1, 2]);
      var drwStyle = fullLayout.newshape;
  
      outlines.enter()
          .append('path')
          .attr('class', function(d) { return 'select-outline select-outline-' + d + ' select-outline-' + plotinfo.id; })
          .style(isDrawMode ? {
              opacity: drwStyle.opacity / 2,
              fill: isOpenMode ? undefined : drwStyle.fillcolor,
              stroke: drwStyle.line.color,
              'stroke-dasharray': dashStyle(drwStyle.line.dash, drwStyle.line.width),
              'stroke-width': drwStyle.line.width + 'px'
          } : {})
          .attr('fill-rule', drwStyle.fillrule)
          .classed('cursor-move', isDrawMode ? true : false)
          .attr('transform', transform)
          .attr('d', path0 + 'Z');
  
      var corners = zoomLayer.append('path')
          .attr('class', 'zoombox-corners')
          .style({
              fill: Color.background,
              stroke: Color.defaultLine,
              'stroke-width': 1
          })
          .attr('transform', transform)
          .attr('d', 'M0,0Z');
  
  
      var throttleID = fullLayout._uid + constants.SELECTID;
      var selection = [];
  
      // find the traces to search for selection points
      var searchTraces = determineSearchTraces(gd, dragOptions.xaxes,
        dragOptions.yaxes, dragOptions.subplot);
  
      function ascending(a, b) { return a - b; }
  
      // allow subplots to override fillRangeItems routine
      var fillRangeItems;
  
      if(plotinfo.fillRangeItems) {
          fillRangeItems = plotinfo.fillRangeItems;
      } else {
          if(isRectMode) {
              fillRangeItems = function(eventData, poly) {
                  var ranges = eventData.range = {};
  
                  for(i = 0; i < allAxes.length; i++) {
                      var ax = allAxes[i];
                      var axLetter = ax._id.charAt(0);
  
                      ranges[ax._id] = [
                          p2r(ax, poly[axLetter + 'min']),
                          p2r(ax, poly[axLetter + 'max'])
                      ].sort(ascending);
                  }
              };
          } else { // case of isFreeMode
              fillRangeItems = function(eventData, poly, filterPoly) {
                  var dataPts = eventData.lassoPoints = {};
  
                  for(i = 0; i < allAxes.length; i++) {
                      var ax = allAxes[i];
                      dataPts[ax._id] = filterPoly.filtered.map(axValue(ax));
                  }
              };
          }
      }
  
      dragOptions.moveFn = function(dx0, dy0) {
          x1 = Math.max(0, Math.min(pw, dx0 + x0));
          y1 = Math.max(0, Math.min(ph, dy0 + y0));
  
          var dx = Math.abs(x1 - x0);
          var dy = Math.abs(y1 - y0);
  
          if(isRectMode) {
              var direction;
              var start, end;
  
              if(isSelectMode) {
                  var q = fullLayout.selectdirection;
  
                  if(q === 'any') {
                      if(dy < Math.min(dx * 0.6, MINSELECT)) {
                          direction = 'h';
                      } else if(dx < Math.min(dy * 0.6, MINSELECT)) {
                          direction = 'v';
                      } else {
                          direction = 'd';
                      }
                  } else {
                      direction = q;
                  }
  
                  switch(direction) {
                      case 'h':
                          start = isEllipse ? ph / 2 : 0;
                          end = ph;
                          break;
                      case 'v':
                          start = isEllipse ? pw / 2 : 0;
                          end = pw;
                          break;
                  }
              }
  
              if(isDrawMode) {
                  switch(fullLayout.newshape.drawdirection) {
                      case 'vertical':
                          direction = 'h';
                          start = isEllipse ? ph / 2 : 0;
                          end = ph;
                          break;
                      case 'horizontal':
                          direction = 'v';
                          start = isEllipse ? pw / 2 : 0;
                          end = pw;
                          break;
                      case 'ortho':
                          if(dx < dy) {
                              direction = 'h';
                              start = y0;
                              end = y1;
                          } else {
                              direction = 'v';
                              start = x0;
                              end = x1;
                          }
                          break;
                      default: // i.e. case of 'diagonal'
                          direction = 'd';
                  }
              }
  
              if(direction === 'h') {
                  // horizontal motion
                  currentPolygon = isLineOrEllipse ?
                      handleEllipse(isEllipse, [x1, start], [x1, end]) : // using x1 instead of x0 allows adjusting the line while drawing
                      [[x0, start], [x0, end], [x1, end], [x1, start]]; // make a vertical box
  
                  currentPolygon.xmin = isLineOrEllipse ? x1 : Math.min(x0, x1);
                  currentPolygon.xmax = isLineOrEllipse ? x1 : Math.max(x0, x1);
                  currentPolygon.ymin = Math.min(start, end);
                  currentPolygon.ymax = Math.max(start, end);
                  // extras to guide users in keeping a straight selection
                  corners.attr('d', 'M' + currentPolygon.xmin + ',' + (y0 - MINSELECT) +
                      'h-4v' + (2 * MINSELECT) + 'h4Z' +
                      'M' + (currentPolygon.xmax - 1) + ',' + (y0 - MINSELECT) +
                      'h4v' + (2 * MINSELECT) + 'h-4Z');
              } else if(direction === 'v') {
                  // vertical motion
                  currentPolygon = isLineOrEllipse ?
                      handleEllipse(isEllipse, [start, y1], [end, y1]) : // using y1 instead of y0 allows adjusting the line while drawing
                      [[start, y0], [start, y1], [end, y1], [end, y0]]; // make a horizontal box
  
                  currentPolygon.xmin = Math.min(start, end);
                  currentPolygon.xmax = Math.max(start, end);
                  currentPolygon.ymin = isLineOrEllipse ? y1 : Math.min(y0, y1);
                  currentPolygon.ymax = isLineOrEllipse ? y1 : Math.max(y0, y1);
                  corners.attr('d', 'M' + (x0 - MINSELECT) + ',' + currentPolygon.ymin +
                      'v-4h' + (2 * MINSELECT) + 'v4Z' +
                      'M' + (x0 - MINSELECT) + ',' + (currentPolygon.ymax - 1) +
                      'v4h' + (2 * MINSELECT) + 'v-4Z');
              } else if(direction === 'd') {
                  // diagonal motion
                  currentPolygon = isLineOrEllipse ?
                      handleEllipse(isEllipse, [x0, y0], [x1, y1]) :
                      [[x0, y0], [x0, y1], [x1, y1], [x1, y0]];
  
                  currentPolygon.xmin = Math.min(x0, x1);
                  currentPolygon.xmax = Math.max(x0, x1);
                  currentPolygon.ymin = Math.min(y0, y1);
                  currentPolygon.ymax = Math.max(y0, y1);
                  corners.attr('d', 'M0,0Z');
              }
          } else if(isFreeMode) {
              filterPoly.addPt([x1, y1]);
              currentPolygon = filterPoly.filtered;
          }
  
          // create outline & tester
          if(dragOptions.selectionDefs && dragOptions.selectionDefs.length) {
              mergedPolygons = mergePolygons(dragOptions.mergedPolygons, currentPolygon, subtract);
              currentPolygon.subtract = subtract;
              selectionTester = multiTester(dragOptions.selectionDefs.concat([currentPolygon]));
          } else {
              mergedPolygons = [currentPolygon];
              selectionTester = polygonTester(currentPolygon);
          }
  
          // display polygons on the screen
          displayOutlines(convertPoly(mergedPolygons, isOpenMode), outlines, dragOptions);
  
          if(isSelectMode) {
              throttle.throttle(
                  throttleID,
                  constants.SELECTDELAY,
                  function() {
                      selection = [];
  
                      var thisSelection;
                      var traceSelections = [];
                      var traceSelection;
                      for(i = 0; i < searchTraces.length; i++) {
                          searchInfo = searchTraces[i];
  
                          traceSelection = searchInfo._module.selectPoints(searchInfo, selectionTester);
                          traceSelections.push(traceSelection);
  
                          thisSelection = fillSelectionItem(traceSelection, searchInfo);
  
                          if(selection.length) {
                              for(var j = 0; j < thisSelection.length; j++) {
                                  selection.push(thisSelection[j]);
                              }
                          } else selection = thisSelection;
                      }
  
                      eventData = {points: selection};
                      updateSelectedState(gd, searchTraces, eventData);
                      fillRangeItems(eventData, currentPolygon, filterPoly);
                      dragOptions.gd.emit('plotly_selecting', eventData);
                  }
              );
          }
      };
  
      dragOptions.clickFn = function(numClicks, evt) {
          corners.remove();
  
          if(gd._fullLayout._activeShapeIndex >= 0) {
              gd._fullLayout._deactivateShape(gd);
              return;
          }
          if(isDrawMode) return;
  
          var clickmode = fullLayout.clickmode;
  
          throttle.done(throttleID).then(function() {
              throttle.clear(throttleID);
              if(numClicks === 2) {
                  // clear selection on doubleclick
                  outlines.remove();
                  for(i = 0; i < searchTraces.length; i++) {
                      searchInfo = searchTraces[i];
                      searchInfo._module.selectPoints(searchInfo, false);
                  }
  
                  updateSelectedState(gd, searchTraces);
  
                  clearSelectionsCache(dragOptions);
  
                  gd.emit('plotly_deselect', null);
              } else {
                  if(clickmode.indexOf('select') > -1) {
                      selectOnClick(evt, gd, dragOptions.xaxes, dragOptions.yaxes,
                        dragOptions.subplot, dragOptions, outlines);
                  }
  
                  if(clickmode === 'event') {
                      // TODO: remove in v2 - this was probably never intended to work as it does,
                      // but in case anyone depends on it we don't want to break it now.
                      // Note that click-to-select introduced pre v2 also emitts proper
                      // event data when clickmode is having 'select' in its flag list.
                      gd.emit('plotly_selected', undefined);
                  }
              }
  
              Fx.click(gd, evt);
          }).catch(Lib.error);
      };
  
      dragOptions.doneFn = function() {
          corners.remove();
  
          throttle.done(throttleID).then(function() {
              throttle.clear(throttleID);
              dragOptions.gd.emit('plotly_selected', eventData);
  
              if(currentPolygon && dragOptions.selectionDefs) {
                  // save last polygons
                  currentPolygon.subtract = subtract;
                  dragOptions.selectionDefs.push(currentPolygon);
  
                  // we have to keep reference to arrays container
                  dragOptions.mergedPolygons.length = 0;
                  [].push.apply(dragOptions.mergedPolygons, mergedPolygons);
              }
  
              if(dragOptions.doneFnCompleted) {
                  dragOptions.doneFnCompleted(selection);
              }
          }).catch(Lib.error);
  
          if(isDrawMode) {
              clearSelectionsCache(dragOptions);
          }
      };
  }
  
  function selectOnClick(evt, gd, xAxes, yAxes, subplot, dragOptions, polygonOutlines) {
      var hoverData = gd._hoverdata;
      var fullLayout = gd._fullLayout;
      var clickmode = fullLayout.clickmode;
      var sendEvents = clickmode.indexOf('event') > -1;
      var selection = [];
      var searchTraces, searchInfo, currentSelectionDef, selectionTester, traceSelection;
      var thisTracesSelection, pointOrBinSelected, subtract, eventData, i;
  
      if(isHoverDataSet(hoverData)) {
          coerceSelectionsCache(evt, gd, dragOptions);
          searchTraces = determineSearchTraces(gd, xAxes, yAxes, subplot);
          var clickedPtInfo = extractClickedPtInfo(hoverData, searchTraces);
          var isBinnedTrace = clickedPtInfo.pointNumbers.length > 0;
  
  
          // Note: potentially costly operation isPointOrBinSelected is
          // called as late as possible through the use of an assignment
          // in an if condition.
          if(isBinnedTrace ?
              isOnlyThisBinSelected(searchTraces, clickedPtInfo) :
              isOnlyOnePointSelected(searchTraces) &&
                  (pointOrBinSelected = isPointOrBinSelected(clickedPtInfo))) {
              if(polygonOutlines) polygonOutlines.remove();
              for(i = 0; i < searchTraces.length; i++) {
                  searchInfo = searchTraces[i];
                  searchInfo._module.selectPoints(searchInfo, false);
              }
  
              updateSelectedState(gd, searchTraces);
  
              clearSelectionsCache(dragOptions);
  
              if(sendEvents) {
                  gd.emit('plotly_deselect', null);
              }
          } else {
              subtract = evt.shiftKey &&
                (pointOrBinSelected !== undefined ?
                  pointOrBinSelected :
                  isPointOrBinSelected(clickedPtInfo));
              currentSelectionDef = newPointSelectionDef(clickedPtInfo.pointNumber, clickedPtInfo.searchInfo, subtract);
  
              var allSelectionDefs = dragOptions.selectionDefs.concat([currentSelectionDef]);
              selectionTester = multiTester(allSelectionDefs);
  
              for(i = 0; i < searchTraces.length; i++) {
                  traceSelection = searchTraces[i]._module.selectPoints(searchTraces[i], selectionTester);
                  thisTracesSelection = fillSelectionItem(traceSelection, searchTraces[i]);
  
                  if(selection.length) {
                      for(var j = 0; j < thisTracesSelection.length; j++) {
                          selection.push(thisTracesSelection[j]);
                      }
                  } else selection = thisTracesSelection;
              }
  
              eventData = {points: selection};
              updateSelectedState(gd, searchTraces, eventData);
  
              if(currentSelectionDef && dragOptions) {
                  dragOptions.selectionDefs.push(currentSelectionDef);
              }
  
              if(polygonOutlines) {
                  var polygons = dragOptions.mergedPolygons;
                  var isOpenMode = openMode(dragOptions.dragmode);
  
                  // display polygons on the screen
                  displayOutlines(convertPoly(polygons, isOpenMode), polygonOutlines, dragOptions);
              }
  
              if(sendEvents) {
                  gd.emit('plotly_selected', eventData);
              }
          }
      }
  }
  
  /**
   * Constructs a new point selection definition object.
   */
  function newPointSelectionDef(pointNumber, searchInfo, subtract) {
      return {
          pointNumber: pointNumber,
          searchInfo: searchInfo,
          subtract: subtract
      };
  }
  
  function isPointSelectionDef(o) {
      return 'pointNumber' in o && 'searchInfo' in o;
  }
  
  /*
   * Constructs a new point number tester.
   */
  function newPointNumTester(pointSelectionDef) {
      return {
          xmin: 0,
          xmax: 0,
          ymin: 0,
          ymax: 0,
          pts: [],
          contains: function(pt, omitFirstEdge, pointNumber, searchInfo) {
              var idxWantedTrace = pointSelectionDef.searchInfo.cd[0].trace._expandedIndex;
              var idxActualTrace = searchInfo.cd[0].trace._expandedIndex;
              return idxActualTrace === idxWantedTrace &&
                pointNumber === pointSelectionDef.pointNumber;
          },
          isRect: false,
          degenerate: false,
          subtract: pointSelectionDef.subtract
      };
  }
  
  /**
   * Wraps multiple selection testers.
   *
   * @param {Array} list - An array of selection testers.
   *
   * @return a selection tester object with a contains function
   * that can be called to evaluate a point against all wrapped
   * selection testers that were passed in list.
   */
  function multiTester(list) {
      var testers = [];
      var xmin = isPointSelectionDef(list[0]) ? 0 : list[0][0][0];
      var xmax = xmin;
      var ymin = isPointSelectionDef(list[0]) ? 0 : list[0][0][1];
      var ymax = ymin;
  
      for(var i = 0; i < list.length; i++) {
          if(isPointSelectionDef(list[i])) {
              testers.push(newPointNumTester(list[i]));
          } else {
              var tester = polygon.tester(list[i]);
              tester.subtract = list[i].subtract;
              testers.push(tester);
              xmin = Math.min(xmin, tester.xmin);
              xmax = Math.max(xmax, tester.xmax);
              ymin = Math.min(ymin, tester.ymin);
              ymax = Math.max(ymax, tester.ymax);
          }
      }
  
      /**
       * Tests if the given point is within this tester.
       *
       * @param {Array} pt - [0] is the x coordinate, [1] is the y coordinate of the point.
       * @param {*} arg - An optional parameter to pass down to wrapped testers.
       * @param {number} pointNumber - The point number of the point within the underlying data array.
       * @param {number} searchInfo - An object identifying the trace the point is contained in.
       *
       * @return {boolean} true if point is considered to be selected, false otherwise.
       */
      function contains(pt, arg, pointNumber, searchInfo) {
          var contained = false;
          for(var i = 0; i < testers.length; i++) {
              if(testers[i].contains(pt, arg, pointNumber, searchInfo)) {
                  // if contained by subtract tester - exclude the point
                  contained = testers[i].subtract === false;
              }
          }
  
          return contained;
      }
  
      return {
          xmin: xmin,
          xmax: xmax,
          ymin: ymin,
          ymax: ymax,
          pts: [],
          contains: contains,
          isRect: false,
          degenerate: false
      };
  }
  
  function coerceSelectionsCache(evt, gd, dragOptions) {
      gd._fullLayout._drawing = false;
  
      var fullLayout = gd._fullLayout;
      var plotinfo = dragOptions.plotinfo;
      var dragmode = dragOptions.dragmode;
  
      var selectingOnSameSubplot = (
          fullLayout._lastSelectedSubplot &&
          fullLayout._lastSelectedSubplot === plotinfo.id
      );
  
      var hasModifierKey = (evt.shiftKey || evt.altKey) &&
          !(drawMode(dragmode) && openMode(dragmode));
  
      if(selectingOnSameSubplot && hasModifierKey &&
        (plotinfo.selection && plotinfo.selection.selectionDefs) && !dragOptions.selectionDefs) {
          // take over selection definitions from prev mode, if any
          dragOptions.selectionDefs = plotinfo.selection.selectionDefs;
          dragOptions.mergedPolygons = plotinfo.selection.mergedPolygons;
      } else if(!hasModifierKey || !plotinfo.selection) {
          clearSelectionsCache(dragOptions);
      }
  
      // clear selection outline when selecting a different subplot
      if(!selectingOnSameSubplot) {
          clearSelect(gd);
          fullLayout._lastSelectedSubplot = plotinfo.id;
      }
  }
  
  function clearSelectionsCache(dragOptions) {
      var dragmode = dragOptions.dragmode;
      var plotinfo = dragOptions.plotinfo;
  
      var gd = dragOptions.gd;
      if(gd._fullLayout._activeShapeIndex >= 0) {
          gd._fullLayout._deactivateShape(gd);
      }
  
      if(drawMode(dragmode)) {
          var fullLayout = gd._fullLayout;
          var zoomLayer = fullLayout._zoomlayer;
  
          var outlines = zoomLayer.selectAll('.select-outline-' + plotinfo.id);
          if(outlines && gd._fullLayout._drawing) {
              // add shape
              var shapes = newShapes(outlines, dragOptions);
              if(shapes) {
                  Registry.call('_guiRelayout', gd, {
                      shapes: shapes
                  });
              }
  
              gd._fullLayout._drawing = false;
          }
      }
  
      plotinfo.selection = {};
      plotinfo.selection.selectionDefs = dragOptions.selectionDefs = [];
      plotinfo.selection.mergedPolygons = dragOptions.mergedPolygons = [];
  }
  
  function determineSearchTraces(gd, xAxes, yAxes, subplot) {
      var searchTraces = [];
      var xAxisIds = xAxes.map(function(ax) { return ax._id; });
      var yAxisIds = yAxes.map(function(ax) { return ax._id; });
      var cd, trace, i;
  
      for(i = 0; i < gd.calcdata.length; i++) {
          cd = gd.calcdata[i];
          trace = cd[0].trace;
  
          if(trace.visible !== true || !trace._module || !trace._module.selectPoints) continue;
  
          if(subplot && (trace.subplot === subplot || trace.geo === subplot)) {
              searchTraces.push(createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]));
          } else if(
            trace.type === 'splom' &&
            // FIXME: make sure we don't have more than single axis for splom
            trace._xaxes[xAxisIds[0]] && trace._yaxes[yAxisIds[0]]
          ) {
              var info = createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]);
              info.scene = gd._fullLayout._splomScenes[trace.uid];
              searchTraces.push(info);
          } else if(
            trace.type === 'sankey'
          ) {
              var sankeyInfo = createSearchInfo(trace._module, cd, xAxes[0], yAxes[0]);
              searchTraces.push(sankeyInfo);
          } else {
              if(xAxisIds.indexOf(trace.xaxis) === -1) continue;
              if(yAxisIds.indexOf(trace.yaxis) === -1) continue;
  
              searchTraces.push(createSearchInfo(trace._module, cd,
                getFromId(gd, trace.xaxis), getFromId(gd, trace.yaxis)));
          }
      }
  
      return searchTraces;
  
      function createSearchInfo(module, calcData, xaxis, yaxis) {
          return {
              _module: module,
              cd: calcData,
              xaxis: xaxis,
              yaxis: yaxis
          };
      }
  }
  
  function isHoverDataSet(hoverData) {
      return hoverData &&
        Array.isArray(hoverData) &&
        hoverData[0].hoverOnBox !== true;
  }
  
  function extractClickedPtInfo(hoverData, searchTraces) {
      var hoverDatum = hoverData[0];
      var pointNumber = -1;
      var pointNumbers = [];
      var searchInfo, i;
  
      for(i = 0; i < searchTraces.length; i++) {
          searchInfo = searchTraces[i];
          if(hoverDatum.fullData._expandedIndex === searchInfo.cd[0].trace._expandedIndex) {
              // Special case for box (and violin)
              if(hoverDatum.hoverOnBox === true) {
                  break;
              }
  
              // Hint: in some traces like histogram, one graphical element
              // doesn't correspond to one particular data point, but to
              // bins of data points. Thus, hoverDatum can have a binNumber
              // property instead of pointNumber.
              if(hoverDatum.pointNumber !== undefined) {
                  pointNumber = hoverDatum.pointNumber;
              } else if(hoverDatum.binNumber !== undefined) {
                  pointNumber = hoverDatum.binNumber;
                  pointNumbers = hoverDatum.pointNumbers;
              }
  
              break;
          }
      }
  
      return {
          pointNumber: pointNumber,
          pointNumbers: pointNumbers,
          searchInfo: searchInfo
      };
  }
  
  function isPointOrBinSelected(clickedPtInfo) {
      var trace = clickedPtInfo.searchInfo.cd[0].trace;
      var ptNum = clickedPtInfo.pointNumber;
      var ptNums = clickedPtInfo.pointNumbers;
      var ptNumsSet = ptNums.length > 0;
  
      // When pointsNumbers is set (e.g. histogram's binning),
      // it is assumed that when the first point of
      // a bin is selected, all others are as well
      var ptNumToTest = ptNumsSet ? ptNums[0] : ptNum;
  
      // TODO potential performance improvement
      // Primarily we need this function to determine if a click adds
      // or subtracts from a selection.
      // In cases `trace.selectedpoints` is a huge array, indexOf
      // might be slow. One remedy would be to introduce a hash somewhere.
      return trace.selectedpoints ? trace.selectedpoints.indexOf(ptNumToTest) > -1 : false;
  }
  
  function isOnlyThisBinSelected(searchTraces, clickedPtInfo) {
      var tracesWithSelectedPts = [];
      var searchInfo, trace, isSameTrace, i;
  
      for(i = 0; i < searchTraces.length; i++) {
          searchInfo = searchTraces[i];
          if(searchInfo.cd[0].trace.selectedpoints && searchInfo.cd[0].trace.selectedpoints.length > 0) {
              tracesWithSelectedPts.push(searchInfo);
          }
      }
  
      if(tracesWithSelectedPts.length === 1) {
          isSameTrace = tracesWithSelectedPts[0] === clickedPtInfo.searchInfo;
          if(isSameTrace) {
              trace = clickedPtInfo.searchInfo.cd[0].trace;
              if(trace.selectedpoints.length === clickedPtInfo.pointNumbers.length) {
                  for(i = 0; i < clickedPtInfo.pointNumbers.length; i++) {
                      if(trace.selectedpoints.indexOf(clickedPtInfo.pointNumbers[i]) < 0) {
                          return false;
                      }
                  }
                  return true;
              }
          }
      }
  
      return false;
  }
  
  function isOnlyOnePointSelected(searchTraces) {
      var len = 0;
      var searchInfo, trace, i;
  
      for(i = 0; i < searchTraces.length; i++) {
          searchInfo = searchTraces[i];
          trace = searchInfo.cd[0].trace;
          if(trace.selectedpoints) {
              if(trace.selectedpoints.length > 1) return false;
  
              len += trace.selectedpoints.length;
              if(len > 1) return false;
          }
      }
  
      return len === 1;
  }
  
  function updateSelectedState(gd, searchTraces, eventData) {
      var i, searchInfo, cd, trace;
  
      // before anything else, update preGUI if necessary
      for(i = 0; i < searchTraces.length; i++) {
          var fullInputTrace = searchTraces[i].cd[0].trace._fullInput;
          var tracePreGUI = gd._fullLayout._tracePreGUI[fullInputTrace.uid] || {};
          if(tracePreGUI.selectedpoints === undefined) {
              tracePreGUI.selectedpoints = fullInputTrace._input.selectedpoints || null;
          }
      }
  
      if(eventData) {
          var pts = eventData.points || [];
  
          for(i = 0; i < searchTraces.length; i++) {
              trace = searchTraces[i].cd[0].trace;
              trace._input.selectedpoints = trace._fullInput.selectedpoints = [];
              if(trace._fullInput !== trace) trace.selectedpoints = [];
          }
  
          for(i = 0; i < pts.length; i++) {
              var pt = pts[i];
              var data = pt.data;
              var fullData = pt.fullData;
  
              if(pt.pointIndices) {
                  [].push.apply(data.selectedpoints, pt.pointIndices);
                  if(trace._fullInput !== trace) {
                      [].push.apply(fullData.selectedpoints, pt.pointIndices);
                  }
              } else {
                  data.selectedpoints.push(pt.pointIndex);
                  if(trace._fullInput !== trace) {
                      fullData.selectedpoints.push(pt.pointIndex);
                  }
              }
          }
      } else {
          for(i = 0; i < searchTraces.length; i++) {
              trace = searchTraces[i].cd[0].trace;
              delete trace.selectedpoints;
              delete trace._input.selectedpoints;
              if(trace._fullInput !== trace) {
                  delete trace._fullInput.selectedpoints;
              }
          }
      }
  
      var hasRegl = false;
  
      for(i = 0; i < searchTraces.length; i++) {
          searchInfo = searchTraces[i];
          cd = searchInfo.cd;
          trace = cd[0].trace;
  
          if(Registry.traceIs(trace, 'regl')) {
              hasRegl = true;
          }
  
          var _module = searchInfo._module;
          var fn = _module.styleOnSelect || _module.style;
          if(fn) {
              fn(gd, cd, cd[0].node3);
              if(cd[0].nodeRangePlot3) fn(gd, cd, cd[0].nodeRangePlot3);
          }
      }
  
      if(hasRegl) {
          clearGlCanvases(gd);
          redrawReglTraces(gd);
      }
  }
  
  function mergePolygons(list, poly, subtract) {
      var res;
  
      if(subtract) {
          res = polybool.difference({
              regions: list,
              inverted: false
          }, {
              regions: [poly],
              inverted: false
          });
  
          return res.regions;
      }
  
      res = polybool.union({
          regions: list,
          inverted: false
      }, {
          regions: [poly],
          inverted: false
      });
  
      return res.regions;
  }
  
  function fillSelectionItem(selection, searchInfo) {
      if(Array.isArray(selection)) {
          var cd = searchInfo.cd;
          var trace = searchInfo.cd[0].trace;
  
          for(var i = 0; i < selection.length; i++) {
              selection[i] = makeEventData(selection[i], trace, cd);
          }
      }
  
      return selection;
  }
  
  function convertPoly(polygonsIn, isOpenMode) { // add M and L command to draft positions
      var polygonsOut = [];
      for(var i = 0; i < polygonsIn.length; i++) {
          polygonsOut[i] = [];
          for(var j = 0; j < polygonsIn[i].length; j++) {
              polygonsOut[i][j] = [];
              polygonsOut[i][j][0] = j ? 'L' : 'M';
              for(var k = 0; k < polygonsIn[i][j].length; k++) {
                  polygonsOut[i][j].push(
                      polygonsIn[i][j][k]
                  );
              }
          }
  
          if(!isOpenMode) {
              polygonsOut[i].push([
                  'Z',
                  polygonsOut[i][0][1], // initial x
                  polygonsOut[i][0][2]  // initial y
              ]);
          }
      }
  
      return polygonsOut;
  }
  
  module.exports = {
      prepSelect: prepSelect,
      clearSelect: clearSelect,
      clearSelectionsCache: clearSelectionsCache,
      selectOnClick: selectOnClick
  };
  
  },{"../../components/color":615,"../../components/dragelement/helpers":633,"../../components/drawing":637,"../../components/fx":655,"../../components/fx/helpers":651,"../../components/shapes/draw_newshape/display_outlines":700,"../../components/shapes/draw_newshape/helpers":701,"../../components/shapes/draw_newshape/newshapes":702,"../../lib":750,"../../lib/clear_gl_canvases":734,"../../lib/polygon":762,"../../lib/throttle":775,"../../plot_api/subroutines":789,"../../registry":882,"./axis_ids":802,"./constants":805,"./handle_outline":809,"./helpers":810,"polybooljs":491}],819:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var utcFormat = _dereq_('d3-time-format').utcFormat;
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var cleanNumber = Lib.cleanNumber;
  var ms2DateTime = Lib.ms2DateTime;
  var dateTime2ms = Lib.dateTime2ms;
  var ensureNumber = Lib.ensureNumber;
  var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
  
  var numConstants = _dereq_('../../constants/numerical');
  var FP_SAFE = numConstants.FP_SAFE;
  var BADNUM = numConstants.BADNUM;
  var LOG_CLIP = numConstants.LOG_CLIP;
  var ONEWEEK = numConstants.ONEWEEK;
  var ONEDAY = numConstants.ONEDAY;
  var ONEHOUR = numConstants.ONEHOUR;
  var ONEMIN = numConstants.ONEMIN;
  var ONESEC = numConstants.ONESEC;
  
  var axisIds = _dereq_('./axis_ids');
  var constants = _dereq_('./constants');
  var HOUR_PATTERN = constants.HOUR_PATTERN;
  var WEEKDAY_PATTERN = constants.WEEKDAY_PATTERN;
  
  function fromLog(v) {
      return Math.pow(10, v);
  }
  
  function isValidCategory(v) {
      return v !== null && v !== undefined;
  }
  
  /**
   * Define the conversion functions for an axis data is used in 5 ways:
   *
   *  d: data, in whatever form it's provided
   *  c: calcdata: turned into numbers, but not linearized
   *  l: linearized - same as c except for log axes (and other nonlinear
   *      mappings later?) this is used when we need to know if it's
   *      *possible* to show some data on this axis, without caring about
   *      the current range
   *  p: pixel value - mapped to the screen with current size and zoom
   *  r: ranges, tick0, and annotation positions match one of the above
   *     but are handled differently for different types:
   *     - linear and date: data format (d)
   *     - category: calcdata format (c), and will stay that way because
   *       the data format has no continuous mapping
   *     - log: linearized (l) format
   *       TODO: in v2.0 we plan to change it to data format. At that point
   *       shapes will work the same way as ranges, tick0, and annotations
   *       so they can use this conversion too.
   *
   * Creates/updates these conversion functions, and a few more utilities
   * like cleanRange, and makeCalcdata
   *
   * also clears the autotick constraints ._minDtick, ._forceTick0
   */
  module.exports = function setConvert(ax, fullLayout) {
      fullLayout = fullLayout || {};
  
      var axId = (ax._id || 'x');
      var axLetter = axId.charAt(0);
  
      function toLog(v, clip) {
          if(v > 0) return Math.log(v) / Math.LN10;
  
          else if(v <= 0 && clip && ax.range && ax.range.length === 2) {
              // clip NaN (ie past negative infinity) to LOG_CLIP axis
              // length past the negative edge
              var r0 = ax.range[0];
              var r1 = ax.range[1];
              return 0.5 * (r0 + r1 - 2 * LOG_CLIP * Math.abs(r0 - r1));
          } else return BADNUM;
      }
  
      /*
       * wrapped dateTime2ms that:
       * - accepts ms numbers for backward compatibility
       * - inserts a dummy arg so calendar is the 3rd arg (see notes below).
       * - defaults to ax.calendar
       */
      function dt2ms(v, _, calendar, opts) {
          if((opts || {}).msUTC && isNumeric(v)) {
              // For now it is only used
              // to fix bar length in milliseconds & gl3d ticks
              // It could be applied in other places in v2
              return +v;
          }
  
          // NOTE: Changed this behavior: previously we took any numeric value
          // to be a ms, even if it was a string that could be a bare year.
          // Now we convert it as a date if at all possible, and only try
          // as (local) ms if that fails.
          var ms = dateTime2ms(v, calendar || ax.calendar);
          if(ms === BADNUM) {
              if(isNumeric(v)) {
                  v = +v;
                  // keep track of tenths of ms, that `new Date` will drop
                  // same logic as in Lib.ms2DateTime
                  var msecTenths = Math.floor(Lib.mod(v + 0.05, 1) * 10);
                  var msRounded = Math.round(v - msecTenths / 10);
                  ms = dateTime2ms(new Date(msRounded)) + msecTenths / 10;
              } else return BADNUM;
          }
          return ms;
      }
  
      // wrapped ms2DateTime to insert default ax.calendar
      function ms2dt(v, r, calendar) {
          return ms2DateTime(v, r, calendar || ax.calendar);
      }
  
      function getCategoryName(v) {
          return ax._categories[Math.round(v)];
      }
  
      /*
       * setCategoryIndex: return the index of category v,
       * inserting it in the list if it's not already there
       *
       * this will enter the categories in the order it
       * encounters them, ie all the categories from the
       * first data set, then all the ones from the second
       * that aren't in the first etc.
       *
       * it is assumed that this function is being invoked in the
       * already sorted category order; otherwise there would be
       * a disconnect between the array and the index returned
       */
      function setCategoryIndex(v) {
          if(isValidCategory(v)) {
              if(ax._categoriesMap === undefined) {
                  ax._categoriesMap = {};
              }
  
              if(ax._categoriesMap[v] !== undefined) {
                  return ax._categoriesMap[v];
              } else {
                  ax._categories.push(typeof v === 'number' ? String(v) : v);
  
                  var curLength = ax._categories.length - 1;
                  ax._categoriesMap[v] = curLength;
  
                  return curLength;
              }
          }
          return BADNUM;
      }
  
      function setMultiCategoryIndex(arrayIn, len) {
          var arrayOut = new Array(len);
  
          for(var i = 0; i < len; i++) {
              var v0 = (arrayIn[0] || [])[i];
              var v1 = (arrayIn[1] || [])[i];
              arrayOut[i] = getCategoryIndex([v0, v1]);
          }
  
          return arrayOut;
      }
  
      function getCategoryIndex(v) {
          if(ax._categoriesMap) {
              return ax._categoriesMap[v];
          }
      }
  
      function getCategoryPosition(v) {
          // d2l/d2c variant that that won't add categories but will also
          // allow numbers to be mapped to the linearized axis positions
          var index = getCategoryIndex(v);
          if(index !== undefined) return index;
          if(isNumeric(v)) return +v;
      }
  
      function getRangePosition(v) {
          return isNumeric(v) ? +v : getCategoryIndex(v);
      }
  
      // include 2 fractional digits on pixel, for PDF zooming etc
      function _l2p(v, m, b) { return d3.round(b + m * v, 2); }
  
      function _p2l(px, m, b) { return (px - b) / m; }
  
      var l2p = function l2p(v) {
          if(!isNumeric(v)) return BADNUM;
          return _l2p(v, ax._m, ax._b);
      };
  
      var p2l = function(px) {
          return _p2l(px, ax._m, ax._b);
      };
  
      if(ax.rangebreaks) {
          var isY = axLetter === 'y';
  
          l2p = function(v) {
              if(!isNumeric(v)) return BADNUM;
              var len = ax._rangebreaks.length;
              if(!len) return _l2p(v, ax._m, ax._b);
  
              var flip = isY;
              if(ax.range[0] > ax.range[1]) flip = !flip;
              var signAx = flip ? -1 : 1;
              var pos = signAx * v;
  
              var q = 0;
              for(var i = 0; i < len; i++) {
                  var min = signAx * ax._rangebreaks[i].min;
                  var max = signAx * ax._rangebreaks[i].max;
  
                  if(pos < min) break;
                  if(pos > max) q = i + 1;
                  else {
                      // when falls into break, pick 'closest' offset
                      q = pos < (min + max) / 2 ? i : i + 1;
                      break;
                  }
              }
              var b2 = ax._B[q] || 0;
              if(!isFinite(b2)) return 0; // avoid NaN translate e.g. in positionLabels if one keep zooming exactly into a break
              return _l2p(v, ax._m2, b2);
          };
  
          p2l = function(px) {
              var len = ax._rangebreaks.length;
              if(!len) return _p2l(px, ax._m, ax._b);
  
              var q = 0;
              for(var i = 0; i < len; i++) {
                  if(px < ax._rangebreaks[i].pmin) break;
                  if(px > ax._rangebreaks[i].pmax) q = i + 1;
              }
              return _p2l(px, ax._m2, ax._B[q]);
          };
      }
  
      // conversions among c/l/p are fairly simple - do them together for all axis types
      ax.c2l = (ax.type === 'log') ? toLog : ensureNumber;
      ax.l2c = (ax.type === 'log') ? fromLog : ensureNumber;
  
      ax.l2p = l2p;
      ax.p2l = p2l;
  
      ax.c2p = (ax.type === 'log') ? function(v, clip) { return l2p(toLog(v, clip)); } : l2p;
      ax.p2c = (ax.type === 'log') ? function(px) { return fromLog(p2l(px)); } : p2l;
  
      /*
       * now type-specific conversions for **ALL** other combinations
       * they're all written out, instead of being combinations of each other, for
       * both clarity and speed.
       */
      if(['linear', '-'].indexOf(ax.type) !== -1) {
          // all are data vals, but d and r need cleaning
          ax.d2r = ax.r2d = ax.d2c = ax.r2c = ax.d2l = ax.r2l = cleanNumber;
          ax.c2d = ax.c2r = ax.l2d = ax.l2r = ensureNumber;
  
          ax.d2p = ax.r2p = function(v) { return ax.l2p(cleanNumber(v)); };
          ax.p2d = ax.p2r = p2l;
  
          ax.cleanPos = ensureNumber;
      } else if(ax.type === 'log') {
          // d and c are data vals, r and l are logged (but d and r need cleaning)
          ax.d2r = ax.d2l = function(v, clip) { return toLog(cleanNumber(v), clip); };
          ax.r2d = ax.r2c = function(v) { return fromLog(cleanNumber(v)); };
  
          ax.d2c = ax.r2l = cleanNumber;
          ax.c2d = ax.l2r = ensureNumber;
  
          ax.c2r = toLog;
          ax.l2d = fromLog;
  
          ax.d2p = function(v, clip) { return ax.l2p(ax.d2r(v, clip)); };
          ax.p2d = function(px) { return fromLog(p2l(px)); };
  
          ax.r2p = function(v) { return ax.l2p(cleanNumber(v)); };
          ax.p2r = p2l;
  
          ax.cleanPos = ensureNumber;
      } else if(ax.type === 'date') {
          // r and d are date strings, l and c are ms
  
          /*
           * Any of these functions with r and d on either side, calendar is the
           * **3rd** argument. log has reserved the second argument.
           *
           * Unless you need the special behavior of the second arg (ms2DateTime
           * uses this to limit precision, toLog uses true to clip negatives
           * to offscreen low rather than undefined), it's safe to pass 0.
           */
          ax.d2r = ax.r2d = Lib.identity;
  
          ax.d2c = ax.r2c = ax.d2l = ax.r2l = dt2ms;
          ax.c2d = ax.c2r = ax.l2d = ax.l2r = ms2dt;
  
          ax.d2p = ax.r2p = function(v, _, calendar) { return ax.l2p(dt2ms(v, 0, calendar)); };
          ax.p2d = ax.p2r = function(px, r, calendar) { return ms2dt(p2l(px), r, calendar); };
  
          ax.cleanPos = function(v) { return Lib.cleanDate(v, BADNUM, ax.calendar); };
      } else if(ax.type === 'category') {
          // d is categories (string)
          // c and l are indices (numbers)
          // r is categories or numbers
  
          ax.d2c = ax.d2l = setCategoryIndex;
          ax.r2d = ax.c2d = ax.l2d = getCategoryName;
  
          ax.d2r = ax.d2l_noadd = getCategoryPosition;
  
          ax.r2c = function(v) {
              var index = getRangePosition(v);
              return index !== undefined ? index : ax.fraction2r(0.5);
          };
  
          ax.l2r = ax.c2r = ensureNumber;
          ax.r2l = getRangePosition;
  
          ax.d2p = function(v) { return ax.l2p(ax.r2c(v)); };
          ax.p2d = function(px) { return getCategoryName(p2l(px)); };
          ax.r2p = ax.d2p;
          ax.p2r = p2l;
  
          ax.cleanPos = function(v) {
              if(typeof v === 'string' && v !== '') return v;
              return ensureNumber(v);
          };
      } else if(ax.type === 'multicategory') {
          // N.B. multicategory axes don't define d2c and d2l,
          // as 'data-to-calcdata' conversion needs to take into
          // account all data array items as in ax.makeCalcdata.
  
          ax.r2d = ax.c2d = ax.l2d = getCategoryName;
          ax.d2r = ax.d2l_noadd = getCategoryPosition;
  
          ax.r2c = function(v) {
              var index = getCategoryPosition(v);
              return index !== undefined ? index : ax.fraction2r(0.5);
          };
  
          ax.r2c_just_indices = getCategoryIndex;
  
          ax.l2r = ax.c2r = ensureNumber;
          ax.r2l = getCategoryPosition;
  
          ax.d2p = function(v) { return ax.l2p(ax.r2c(v)); };
          ax.p2d = function(px) { return getCategoryName(p2l(px)); };
          ax.r2p = ax.d2p;
          ax.p2r = p2l;
  
          ax.cleanPos = function(v) {
              if(Array.isArray(v) || (typeof v === 'string' && v !== '')) return v;
              return ensureNumber(v);
          };
  
          ax.setupMultiCategory = function(fullData) {
              var traceIndices = ax._traceIndices;
              var i, j;
  
              var matchGroups = fullLayout._axisMatchGroups;
              if(matchGroups && matchGroups.length && ax._categories.length === 0) {
                  for(i = 0; i < matchGroups.length; i++) {
                      var group = matchGroups[i];
                      if(group[axId]) {
                          for(var axId2 in group) {
                              if(axId2 !== axId) {
                                  var ax2 = fullLayout[axisIds.id2name(axId2)];
                                  traceIndices = traceIndices.concat(ax2._traceIndices);
                              }
                          }
                      }
                  }
              }
  
              // [ [cnt, {$cat: index}], for 1,2 ]
              var seen = [[0, {}], [0, {}]];
              // [ [arrayIn[0][i], arrayIn[1][i]], for i .. N ]
              var list = [];
  
              for(i = 0; i < traceIndices.length; i++) {
                  var trace = fullData[traceIndices[i]];
  
                  if(axLetter in trace) {
                      var arrayIn = trace[axLetter];
                      var len = trace._length || Lib.minRowLength(arrayIn);
  
                      if(isArrayOrTypedArray(arrayIn[0]) && isArrayOrTypedArray(arrayIn[1])) {
                          for(j = 0; j < len; j++) {
                              var v0 = arrayIn[0][j];
                              var v1 = arrayIn[1][j];
  
                              if(isValidCategory(v0) && isValidCategory(v1)) {
                                  list.push([v0, v1]);
  
                                  if(!(v0 in seen[0][1])) {
                                      seen[0][1][v0] = seen[0][0]++;
                                  }
                                  if(!(v1 in seen[1][1])) {
                                      seen[1][1][v1] = seen[1][0]++;
                                  }
                              }
                          }
                      }
                  }
              }
  
              list.sort(function(a, b) {
                  var ind0 = seen[0][1];
                  var d = ind0[a[0]] - ind0[b[0]];
                  if(d) return d;
  
                  var ind1 = seen[1][1];
                  return ind1[a[1]] - ind1[b[1]];
              });
  
              for(i = 0; i < list.length; i++) {
                  setCategoryIndex(list[i]);
              }
          };
      }
  
      // find the range value at the specified (linear) fraction of the axis
      ax.fraction2r = function(v) {
          var rl0 = ax.r2l(ax.range[0]);
          var rl1 = ax.r2l(ax.range[1]);
          return ax.l2r(rl0 + v * (rl1 - rl0));
      };
  
      // find the fraction of the range at the specified range value
      ax.r2fraction = function(v) {
          var rl0 = ax.r2l(ax.range[0]);
          var rl1 = ax.r2l(ax.range[1]);
          return (ax.r2l(v) - rl0) / (rl1 - rl0);
      };
  
      /*
       * cleanRange: make sure range is a couplet of valid & distinct values
       * keep numbers away from the limits of floating point numbers,
       * and dates away from the ends of our date system (+/- 9999 years)
       *
       * optional param rangeAttr: operate on a different attribute, like
       * ax._r, rather than ax.range
       */
      ax.cleanRange = function(rangeAttr, opts) {
          if(!opts) opts = {};
          if(!rangeAttr) rangeAttr = 'range';
  
          var range = Lib.nestedProperty(ax, rangeAttr).get();
          var i, dflt;
  
          if(ax.type === 'date') dflt = Lib.dfltRange(ax.calendar);
          else if(axLetter === 'y') dflt = constants.DFLTRANGEY;
          else dflt = opts.dfltRange || constants.DFLTRANGEX;
  
          // make sure we don't later mutate the defaults
          dflt = dflt.slice();
  
          if(ax.rangemode === 'tozero' || ax.rangemode === 'nonnegative') {
              dflt[0] = 0;
          }
  
          if(!range || range.length !== 2) {
              Lib.nestedProperty(ax, rangeAttr).set(dflt);
              return;
          }
  
          if(ax.type === 'date' && !ax.autorange) {
              // check if milliseconds or js date objects are provided for range
              // and convert to date strings
              range[0] = Lib.cleanDate(range[0], BADNUM, ax.calendar);
              range[1] = Lib.cleanDate(range[1], BADNUM, ax.calendar);
          }
  
          for(i = 0; i < 2; i++) {
              if(ax.type === 'date') {
                  if(!Lib.isDateTime(range[i], ax.calendar)) {
                      ax[rangeAttr] = dflt;
                      break;
                  }
  
                  if(ax.r2l(range[0]) === ax.r2l(range[1])) {
                      // split by +/- 1 second
                      var linCenter = Lib.constrain(ax.r2l(range[0]),
                          Lib.MIN_MS + 1000, Lib.MAX_MS - 1000);
                      range[0] = ax.l2r(linCenter - 1000);
                      range[1] = ax.l2r(linCenter + 1000);
                      break;
                  }
              } else {
                  if(!isNumeric(range[i])) {
                      if(isNumeric(range[1 - i])) {
                          range[i] = range[1 - i] * (i ? 10 : 0.1);
                      } else {
                          ax[rangeAttr] = dflt;
                          break;
                      }
                  }
  
                  if(range[i] < -FP_SAFE) range[i] = -FP_SAFE;
                  else if(range[i] > FP_SAFE) range[i] = FP_SAFE;
  
                  if(range[0] === range[1]) {
                      // somewhat arbitrary: split by 1 or 1ppm, whichever is bigger
                      var inc = Math.max(1, Math.abs(range[0] * 1e-6));
                      range[0] -= inc;
                      range[1] += inc;
                  }
              }
          }
      };
  
      // set scaling to pixels
      ax.setScale = function(usePrivateRange) {
          var gs = fullLayout._size;
  
          // make sure we have a domain (pull it in from the axis
          // this one is overlaying if necessary)
          if(ax.overlaying) {
              var ax2 = axisIds.getFromId({ _fullLayout: fullLayout }, ax.overlaying);
              ax.domain = ax2.domain;
          }
  
          // While transitions are occurring, we get a double-transform
          // issue if we transform the drawn layer *and* use the new axis range to
          // draw the data. This allows us to construct setConvert using the pre-
          // interaction values of the range:
          var rangeAttr = (usePrivateRange && ax._r) ? '_r' : 'range';
          var calendar = ax.calendar;
          ax.cleanRange(rangeAttr);
  
          var rl0 = ax.r2l(ax[rangeAttr][0], calendar);
          var rl1 = ax.r2l(ax[rangeAttr][1], calendar);
  
          var isY = axLetter === 'y';
          if(isY) {
              ax._offset = gs.t + (1 - ax.domain[1]) * gs.h;
              ax._length = gs.h * (ax.domain[1] - ax.domain[0]);
              ax._m = ax._length / (rl0 - rl1);
              ax._b = -ax._m * rl1;
          } else {
              ax._offset = gs.l + ax.domain[0] * gs.w;
              ax._length = gs.w * (ax.domain[1] - ax.domain[0]);
              ax._m = ax._length / (rl1 - rl0);
              ax._b = -ax._m * rl0;
          }
  
          // set of "N" disjoint rangebreaks inside the range
          ax._rangebreaks = [];
          // length of these rangebreaks in value space - negative on reversed axes
          ax._lBreaks = 0;
          // l2p slope (same for all intervals)
          ax._m2 = 0;
          // set of l2p offsets (one for each of the (N+1) piecewise intervals)
          ax._B = [];
  
          if(ax.rangebreaks) {
              var i, brk;
  
              ax._rangebreaks = ax.locateBreaks(
                  Math.min(rl0, rl1),
                  Math.max(rl0, rl1)
              );
  
              if(ax._rangebreaks.length) {
                  for(i = 0; i < ax._rangebreaks.length; i++) {
                      brk = ax._rangebreaks[i];
                      ax._lBreaks += Math.abs(brk.max - brk.min);
                  }
  
                  var flip = isY;
                  if(rl0 > rl1) flip = !flip;
                  if(flip) ax._rangebreaks.reverse();
                  var sign = flip ? -1 : 1;
  
                  ax._m2 = sign * ax._length / (Math.abs(rl1 - rl0) - ax._lBreaks);
                  ax._B.push(-ax._m2 * (isY ? rl1 : rl0));
                  for(i = 0; i < ax._rangebreaks.length; i++) {
                      brk = ax._rangebreaks[i];
                      ax._B.push(
                          ax._B[ax._B.length - 1] -
                          sign * ax._m2 * (brk.max - brk.min)
                      );
                  }
  
                  // fill pixel (i.e. 'p') min/max here,
                  // to not have to loop through the _rangebreaks twice during `p2l`
                  for(i = 0; i < ax._rangebreaks.length; i++) {
                      brk = ax._rangebreaks[i];
                      brk.pmin = l2p(brk.min);
                      brk.pmax = l2p(brk.max);
                  }
              }
          }
  
          if(!isFinite(ax._m) || !isFinite(ax._b) || ax._length < 0) {
              fullLayout._replotting = false;
              throw new Error('Something went wrong with axis scaling');
          }
      };
  
      ax.maskBreaks = function(v) {
          var rangebreaksIn = ax.rangebreaks || [];
          var bnds, b0, b1, vb, vDate;
  
          for(var i = 0; i < rangebreaksIn.length; i++) {
              var brk = rangebreaksIn[i];
  
              if(brk.enabled) {
                  if(brk.bounds) {
                      var pattern = brk.pattern;
                      bnds = Lib.simpleMap(brk.bounds, pattern ?
                          cleanNumber :
                          ax.d2c // case of pattern: ''
                      );
                      b0 = bnds[0];
                      b1 = bnds[1];
  
                      switch(pattern) {
                          case WEEKDAY_PATTERN:
                              vDate = new Date(v);
                              vb = vDate.getUTCDay();
  
                              if(b0 > b1) {
                                  b1 += 7;
                                  if(vb < b0) vb += 7;
                              }
  
                              break;
                          case HOUR_PATTERN:
                              vDate = new Date(v);
                              var hours = vDate.getUTCHours();
                              var minutes = vDate.getUTCMinutes();
                              var seconds = vDate.getUTCSeconds();
                              var milliseconds = vDate.getUTCMilliseconds();
  
                              vb = hours + (
                                  minutes / 60 +
                                  seconds / 3600 +
                                  milliseconds / 3600000
                              );
  
                              if(b0 > b1) {
                                  b1 += 24;
                                  if(vb < b0) vb += 24;
                              }
  
                              break;
                          case '':
                              // N.B. should work on date axes as well!
                              // e.g. { bounds: ['2020-01-04', '2020-01-05 23:59'] }
                              // TODO should work with reversed-range axes
                              vb = v;
                              break;
                      }
  
                      if(vb >= b0 && vb < b1) return BADNUM;
                  } else {
                      var vals = Lib.simpleMap(brk.values, ax.d2c).sort(Lib.sorterAsc);
                      for(var j = 0; j < vals.length; j++) {
                          b0 = vals[j];
                          b1 = b0 + brk.dvalue;
                          if(v >= b0 && v < b1) return BADNUM;
                      }
                  }
              }
          }
          return v;
      };
  
      ax.locateBreaks = function(r0, r1) {
          var i, bnds, b0, b1;
  
          var rangebreaksOut = [];
          if(!ax.rangebreaks) return rangebreaksOut;
  
          var rangebreaksIn = ax.rangebreaks.slice().sort(function(a, b) {
              if(a.pattern === WEEKDAY_PATTERN && b.pattern === HOUR_PATTERN) return -1;
              if(b.pattern === WEEKDAY_PATTERN && a.pattern === HOUR_PATTERN) return 1;
              return 0;
          });
  
          var addBreak = function(min, max) {
              min = Lib.constrain(min, r0, r1);
              max = Lib.constrain(max, r0, r1);
              if(min === max) return;
  
              var isNewBreak = true;
              for(var j = 0; j < rangebreaksOut.length; j++) {
                  var brkj = rangebreaksOut[j];
                  if(min < brkj.max && max >= brkj.min) {
                      if(min < brkj.min) {
                          brkj.min = min;
                      }
                      if(max > brkj.max) {
                          brkj.max = max;
                      }
                      isNewBreak = false;
                  }
              }
              if(isNewBreak) {
                  rangebreaksOut.push({min: min, max: max});
              }
          };
  
          for(i = 0; i < rangebreaksIn.length; i++) {
              var brk = rangebreaksIn[i];
  
              if(brk.enabled) {
                  if(brk.bounds) {
                      var t0 = r0;
                      var t1 = r1;
                      if(brk.pattern) {
                          // to remove decimal (most often found in auto ranges)
                          t0 = Math.floor(t0);
                      }
  
                      bnds = Lib.simpleMap(brk.bounds, brk.pattern ? cleanNumber : ax.r2l);
                      b0 = bnds[0];
                      b1 = bnds[1];
  
                      // r0 value as date
                      var t0Date = new Date(t0);
                      // r0 value for break pattern
                      var bndDelta;
                      // step in ms between rangebreaks
                      var step;
  
                      switch(brk.pattern) {
                          case WEEKDAY_PATTERN:
                              step = ONEWEEK;
  
                              bndDelta = (
                                  (b1 < b0 ? 7 : 0) +
                                  (b1 - b0)
                              ) * ONEDAY;
  
                              t0 += b0 * ONEDAY - (
                                  t0Date.getUTCDay() * ONEDAY +
                                  t0Date.getUTCHours() * ONEHOUR +
                                  t0Date.getUTCMinutes() * ONEMIN +
                                  t0Date.getUTCSeconds() * ONESEC +
                                  t0Date.getUTCMilliseconds()
                              );
                              break;
                          case HOUR_PATTERN:
                              step = ONEDAY;
  
                              bndDelta = (
                                  (b1 < b0 ? 24 : 0) +
                                  (b1 - b0)
                              ) * ONEHOUR;
  
                              t0 += b0 * ONEHOUR - (
                                  t0Date.getUTCHours() * ONEHOUR +
                                  t0Date.getUTCMinutes() * ONEMIN +
                                  t0Date.getUTCSeconds() * ONESEC +
                                  t0Date.getUTCMilliseconds()
                              );
                              break;
                          default:
                              t0 = Math.min(bnds[0], bnds[1]);
                              t1 = Math.max(bnds[0], bnds[1]);
                              step = t1 - t0;
                              bndDelta = step;
                      }
  
                      for(var t = t0; t < t1; t += step) {
                          addBreak(t, t + bndDelta);
                      }
                  } else {
                      var vals = Lib.simpleMap(brk.values, ax.d2c);
                      for(var j = 0; j < vals.length; j++) {
                          b0 = vals[j];
                          b1 = b0 + brk.dvalue;
                          addBreak(b0, b1);
                      }
                  }
              }
          }
  
          rangebreaksOut.sort(function(a, b) { return a.min - b.min; });
  
          return rangebreaksOut;
      };
  
      // makeCalcdata: takes an x or y array and converts it
      // to a position on the axis object "ax"
      // inputs:
      //      trace - a data object from gd.data
      //      axLetter - a string, either 'x' or 'y', for which item
      //          to convert (TODO: is this now always the same as
      //          the first letter of ax._id?)
      // in case the expected data isn't there, make a list of
      // integers based on the opposite data
      ax.makeCalcdata = function(trace, axLetter, opts) {
          var arrayIn, arrayOut, i, len;
  
          var axType = ax.type;
          var cal = axType === 'date' && trace[axLetter + 'calendar'];
  
          if(axLetter in trace) {
              arrayIn = trace[axLetter];
              len = trace._length || Lib.minRowLength(arrayIn);
  
              if(Lib.isTypedArray(arrayIn) && (axType === 'linear' || axType === 'log')) {
                  if(len === arrayIn.length) {
                      return arrayIn;
                  } else if(arrayIn.subarray) {
                      return arrayIn.subarray(0, len);
                  }
              }
  
              if(axType === 'multicategory') {
                  return setMultiCategoryIndex(arrayIn, len);
              }
  
              arrayOut = new Array(len);
              for(i = 0; i < len; i++) {
                  arrayOut[i] = ax.d2c(arrayIn[i], 0, cal, opts);
              }
          } else {
              var v0 = ((axLetter + '0') in trace) ? ax.d2c(trace[axLetter + '0'], 0, cal) : 0;
              var dv = (trace['d' + axLetter]) ? Number(trace['d' + axLetter]) : 1;
  
              // the opposing data, for size if we have x and dx etc
              arrayIn = trace[{x: 'y', y: 'x'}[axLetter]];
              len = trace._length || arrayIn.length;
              arrayOut = new Array(len);
  
              for(i = 0; i < len; i++) {
                  arrayOut[i] = v0 + i * dv;
              }
          }
  
          // mask (i.e. set to BADNUM) coords that fall inside rangebreaks
          if(ax.rangebreaks) {
              for(i = 0; i < len; i++) {
                  arrayOut[i] = ax.maskBreaks(arrayOut[i]);
              }
          }
  
          return arrayOut;
      };
  
      ax.isValidRange = function(range) {
          return (
              Array.isArray(range) &&
              range.length === 2 &&
              isNumeric(ax.r2l(range[0])) &&
              isNumeric(ax.r2l(range[1]))
          );
      };
  
      ax.isPtWithinRange = function(d, calendar) {
          var coord = ax.c2l(d[axLetter], null, calendar);
          var r0 = ax.r2l(ax.range[0]);
          var r1 = ax.r2l(ax.range[1]);
  
          if(r0 < r1) {
              return r0 <= coord && coord <= r1;
          } else {
              // Reversed axis case.
              return r1 <= coord && coord <= r0;
          }
      };
  
      ax._emptyCategories = function() {
          ax._categories = [];
          ax._categoriesMap = {};
      };
  
      // should skip if not category nor multicategory
      ax.clearCalc = function() {
          var matchGroups = fullLayout._axisMatchGroups;
  
          if(matchGroups && matchGroups.length) {
              var found = false;
  
              for(var i = 0; i < matchGroups.length; i++) {
                  var group = matchGroups[i];
  
                  if(group[axId]) {
                      found = true;
                      var categories = null;
                      var categoriesMap = null;
  
                      for(var axId2 in group) {
                          var ax2 = fullLayout[axisIds.id2name(axId2)];
                          if(ax2._categories) {
                              categories = ax2._categories;
                              categoriesMap = ax2._categoriesMap;
                              break;
                          }
                      }
  
                      if(categories && categoriesMap) {
                          ax._categories = categories;
                          ax._categoriesMap = categoriesMap;
                      } else {
                          ax._emptyCategories();
                      }
                      break;
                  }
              }
              if(!found) ax._emptyCategories();
          } else {
              ax._emptyCategories();
          }
  
          if(ax._initialCategories) {
              for(var j = 0; j < ax._initialCategories.length; j++) {
                  setCategoryIndex(ax._initialCategories[j]);
              }
          }
      };
  
      // sort the axis (and all the matching ones) by _initialCategories
      // returns the indices of the traces affected by the reordering
      ax.sortByInitialCategories = function() {
          var affectedTraces = [];
  
          ax._emptyCategories();
  
          if(ax._initialCategories) {
              for(var j = 0; j < ax._initialCategories.length; j++) {
                  setCategoryIndex(ax._initialCategories[j]);
              }
          }
  
          affectedTraces = affectedTraces.concat(ax._traceIndices);
  
          // Propagate to matching axes
          var group = ax._matchGroup;
          for(var axId2 in group) {
              if(axId === axId2) continue;
              var ax2 = fullLayout[axisIds.id2name(axId2)];
              ax2._categories = ax._categories;
              ax2._categoriesMap = ax._categoriesMap;
              affectedTraces = affectedTraces.concat(ax2._traceIndices);
          }
          return affectedTraces;
      };
  
      // Propagate localization into the axis so that
      // methods in Axes can use it w/o having to pass fullLayout
      // Default (non-d3) number formatting uses separators directly
      // dates and d3-formatted numbers use the d3 locale
      // Fall back on default format for dummy axes that don't care about formatting
      var locale = fullLayout._d3locale;
      if(ax.type === 'date') {
          ax._dateFormat = locale ? locale.timeFormat : utcFormat;
          ax._extraFormat = fullLayout._extraFormat;
      }
      // occasionally we need _numFormat to pass through
      // even though it won't be needed by this axis
      ax._separators = fullLayout.separators;
      ax._numFormat = locale ? locale.numberFormat : d3.format;
  
      // and for bar charts and box plots: reset forced minimum tick spacing
      delete ax._minDtick;
      delete ax._forceTick0;
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"./axis_ids":802,"./constants":805,"d3":169,"d3-time-format":166,"fast-isnumeric":241}],820:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var layoutAttributes = _dereq_('./layout_attributes');
  var handleArrayContainerDefaults = _dereq_('../array_container_defaults');
  
  module.exports = function handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options, config) {
      if(!config || config.pass === 1) {
          handlePrefixSuffix(containerIn, containerOut, coerce, axType, options);
      }
  
      if(!config || config.pass === 2) {
          handleOtherDefaults(containerIn, containerOut, coerce, axType, options);
      }
  };
  
  function handlePrefixSuffix(containerIn, containerOut, coerce, axType, options) {
      var showAttrDflt = getShowAttrDflt(containerIn);
  
      var tickPrefix = coerce('tickprefix');
      if(tickPrefix) coerce('showtickprefix', showAttrDflt);
  
      var tickSuffix = coerce('ticksuffix', options.tickSuffixDflt);
      if(tickSuffix) coerce('showticksuffix', showAttrDflt);
  }
  
  function handleOtherDefaults(containerIn, containerOut, coerce, axType, options) {
      var showAttrDflt = getShowAttrDflt(containerIn);
  
      var tickPrefix = coerce('tickprefix');
      if(tickPrefix) coerce('showtickprefix', showAttrDflt);
  
      var tickSuffix = coerce('ticksuffix', options.tickSuffixDflt);
      if(tickSuffix) coerce('showticksuffix', showAttrDflt);
  
      var showTickLabels = coerce('showticklabels');
      if(showTickLabels) {
          var font = options.font || {};
          var contColor = containerOut.color;
          // as with titlefont.color, inherit axis.color only if one was
          // explicitly provided
          var dfltFontColor = (contColor && contColor !== layoutAttributes.color.dflt) ?
              contColor : font.color;
          Lib.coerceFont(coerce, 'tickfont', {
              family: font.family,
              size: font.size,
              color: dfltFontColor
          });
          coerce('tickangle');
  
          if(axType !== 'category') {
              var tickFormat = coerce('tickformat');
  
              handleArrayContainerDefaults(containerIn, containerOut, {
                  name: 'tickformatstops',
                  inclusionAttr: 'enabled',
                  handleItemDefaults: tickformatstopDefaults
              });
              if(!containerOut.tickformatstops.length) {
                  delete containerOut.tickformatstops;
              }
  
              if(!tickFormat && axType !== 'date') {
                  coerce('showexponent', showAttrDflt);
                  coerce('exponentformat');
                  coerce('minexponent');
                  coerce('separatethousands');
              }
          }
      }
  }
  
  /*
   * Attributes 'showexponent', 'showtickprefix' and 'showticksuffix'
   * share values.
   *
   * If only 1 attribute is set,
   * the remaining attributes inherit that value.
   *
   * If 2 attributes are set to the same value,
   * the remaining attribute inherits that value.
   *
   * If 2 attributes are set to different values,
   * the remaining is set to its dflt value.
   *
   */
  function getShowAttrDflt(containerIn) {
      var showAttrsAll = ['showexponent', 'showtickprefix', 'showticksuffix'];
      var showAttrs = showAttrsAll.filter(function(a) {
          return containerIn[a] !== undefined;
      });
      var sameVal = function(a) {
          return containerIn[a] === containerIn[showAttrs[0]];
      };
  
      if(showAttrs.every(sameVal) || showAttrs.length === 1) {
          return containerIn[showAttrs[0]];
      }
  }
  
  function tickformatstopDefaults(valueIn, valueOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(valueIn, valueOut, layoutAttributes.tickformatstops, attr, dflt);
      }
  
      var enabled = coerce('enabled');
      if(enabled) {
          coerce('dtickrange');
          coerce('value');
      }
  }
  
  },{"../../lib":750,"../array_container_defaults":794,"./layout_attributes":813}],821:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var layoutAttributes = _dereq_('./layout_attributes');
  
  
  /**
   * options: inherits outerTicks from axes.handleAxisDefaults
   */
  module.exports = function handleTickDefaults(containerIn, containerOut, coerce, options) {
      var tickLen = Lib.coerce2(containerIn, containerOut, layoutAttributes, 'ticklen');
      var tickWidth = Lib.coerce2(containerIn, containerOut, layoutAttributes, 'tickwidth');
      var tickColor = Lib.coerce2(containerIn, containerOut, layoutAttributes, 'tickcolor', containerOut.color);
      var showTicks = coerce('ticks', (options.outerTicks || tickLen || tickWidth || tickColor) ? 'outside' : '');
  
      if(!showTicks) {
          delete containerOut.ticklen;
          delete containerOut.tickwidth;
          delete containerOut.tickcolor;
      }
  };
  
  },{"../../lib":750,"./layout_attributes":813}],822:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var cleanTicks = _dereq_('./clean_ticks');
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  
  module.exports = function handleTickValueDefaults(containerIn, containerOut, coerce, axType) {
      function readInput(attr) {
          var v = containerIn[attr];
          return (
              v !== undefined
          ) ? v : (containerOut._template || {})[attr];
      }
  
      var _tick0 = readInput('tick0');
      var _dtick = readInput('dtick');
      var _tickvals = readInput('tickvals');
  
      var tickmodeDefault = isArrayOrTypedArray(_tickvals) ? 'array' :
          _dtick ? 'linear' :
          'auto';
      var tickmode = coerce('tickmode', tickmodeDefault);
  
      if(tickmode === 'auto') coerce('nticks');
      else if(tickmode === 'linear') {
          // dtick is usually a positive number, but there are some
          // special strings available for log or date axes
          // tick0 also has special logic
          var dtick = containerOut.dtick = cleanTicks.dtick(
              _dtick, axType);
          containerOut.tick0 = cleanTicks.tick0(
              _tick0, axType, containerOut.calendar, dtick);
      } else if(axType !== 'multicategory') {
          var tickvals = coerce('tickvals');
          if(tickvals === undefined) containerOut.tickmode = 'auto';
          else coerce('ticktext');
      }
  };
  
  },{"../../lib":750,"./clean_ticks":804}],823:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  var Axes = _dereq_('./axes');
  
  /**
   * transitionAxes
   *
   * transition axes from one set of ranges to another, using a svg
   * transformations, similar to during panning.
   *
   * @param {DOM element | object} gd
   * @param {array} edits : array of 'edits', each item with
   * - plotinfo {object} subplot object
   * - xr0 {array} initial x-range
   * - xr1 {array} end x-range
   * - yr0 {array} initial y-range
   * - yr1 {array} end y-range
   * @param {object} transitionOpts
   * @param {function} makeOnCompleteCallback
   */
  module.exports = function transitionAxes(gd, edits, transitionOpts, makeOnCompleteCallback) {
      var fullLayout = gd._fullLayout;
  
      // special case for redraw:false Plotly.animate that relies on this
      // to update axis-referenced layout components
      if(edits.length === 0) {
          Axes.redrawComponents(gd);
          return;
      }
  
      function unsetSubplotTransform(subplot) {
          var xa = subplot.xaxis;
          var ya = subplot.yaxis;
  
          fullLayout._defs.select('#' + subplot.clipId + '> rect')
              .call(Drawing.setTranslate, 0, 0)
              .call(Drawing.setScale, 1, 1);
  
          subplot.plot
              .call(Drawing.setTranslate, xa._offset, ya._offset)
              .call(Drawing.setScale, 1, 1);
  
          var traceGroups = subplot.plot.selectAll('.scatterlayer .trace');
  
          // This is specifically directed at scatter traces, applying an inverse
          // scale to individual points to counteract the scale of the trace
          // as a whole:
          traceGroups.selectAll('.point')
              .call(Drawing.setPointGroupScale, 1, 1);
          traceGroups.selectAll('.textpoint')
              .call(Drawing.setTextPointsScale, 1, 1);
          traceGroups
              .call(Drawing.hideOutsideRangePoints, subplot);
      }
  
      function updateSubplot(edit, progress) {
          var plotinfo = edit.plotinfo;
          var xa = plotinfo.xaxis;
          var ya = plotinfo.yaxis;
          var xlen = xa._length;
          var ylen = ya._length;
          var editX = !!edit.xr1;
          var editY = !!edit.yr1;
          var viewBox = [];
  
          if(editX) {
              var xr0 = Lib.simpleMap(edit.xr0, xa.r2l);
              var xr1 = Lib.simpleMap(edit.xr1, xa.r2l);
              var dx0 = xr0[1] - xr0[0];
              var dx1 = xr1[1] - xr1[0];
              viewBox[0] = (xr0[0] * (1 - progress) + progress * xr1[0] - xr0[0]) / (xr0[1] - xr0[0]) * xlen;
              viewBox[2] = xlen * ((1 - progress) + progress * dx1 / dx0);
              xa.range[0] = xa.l2r(xr0[0] * (1 - progress) + progress * xr1[0]);
              xa.range[1] = xa.l2r(xr0[1] * (1 - progress) + progress * xr1[1]);
          } else {
              viewBox[0] = 0;
              viewBox[2] = xlen;
          }
  
          if(editY) {
              var yr0 = Lib.simpleMap(edit.yr0, ya.r2l);
              var yr1 = Lib.simpleMap(edit.yr1, ya.r2l);
              var dy0 = yr0[1] - yr0[0];
              var dy1 = yr1[1] - yr1[0];
              viewBox[1] = (yr0[1] * (1 - progress) + progress * yr1[1] - yr0[1]) / (yr0[0] - yr0[1]) * ylen;
              viewBox[3] = ylen * ((1 - progress) + progress * dy1 / dy0);
              ya.range[0] = xa.l2r(yr0[0] * (1 - progress) + progress * yr1[0]);
              ya.range[1] = ya.l2r(yr0[1] * (1 - progress) + progress * yr1[1]);
          } else {
              viewBox[1] = 0;
              viewBox[3] = ylen;
          }
  
          Axes.drawOne(gd, xa, {skipTitle: true});
          Axes.drawOne(gd, ya, {skipTitle: true});
          Axes.redrawComponents(gd, [xa._id, ya._id]);
  
          var xScaleFactor = editX ? xlen / viewBox[2] : 1;
          var yScaleFactor = editY ? ylen / viewBox[3] : 1;
          var clipDx = editX ? viewBox[0] : 0;
          var clipDy = editY ? viewBox[1] : 0;
          var fracDx = editX ? (viewBox[0] / viewBox[2] * xlen) : 0;
          var fracDy = editY ? (viewBox[1] / viewBox[3] * ylen) : 0;
          var plotDx = xa._offset - fracDx;
          var plotDy = ya._offset - fracDy;
  
          plotinfo.clipRect
              .call(Drawing.setTranslate, clipDx, clipDy)
              .call(Drawing.setScale, 1 / xScaleFactor, 1 / yScaleFactor);
  
          plotinfo.plot
              .call(Drawing.setTranslate, plotDx, plotDy)
              .call(Drawing.setScale, xScaleFactor, yScaleFactor);
  
          // apply an inverse scale to individual points to counteract
          // the scale of the trace group.
          Drawing.setPointGroupScale(plotinfo.zoomScalePts, 1 / xScaleFactor, 1 / yScaleFactor);
          Drawing.setTextPointsScale(plotinfo.zoomScaleTxt, 1 / xScaleFactor, 1 / yScaleFactor);
      }
  
      var onComplete;
      if(makeOnCompleteCallback) {
          // This module makes the choice whether or not it notifies Plotly.transition
          // about completion:
          onComplete = makeOnCompleteCallback();
      }
  
      function transitionComplete() {
          var aobj = {};
  
          for(var i = 0; i < edits.length; i++) {
              var edit = edits[i];
              var xa = edit.plotinfo.xaxis;
              var ya = edit.plotinfo.yaxis;
              if(edit.xr1) aobj[xa._name + '.range'] = edit.xr1.slice();
              if(edit.yr1) aobj[ya._name + '.range'] = edit.yr1.slice();
          }
  
          // Signal that this transition has completed:
          onComplete && onComplete();
  
          return Registry.call('relayout', gd, aobj).then(function() {
              for(var i = 0; i < edits.length; i++) {
                  unsetSubplotTransform(edits[i].plotinfo);
              }
          });
      }
  
      function transitionInterrupt() {
          var aobj = {};
  
          for(var i = 0; i < edits.length; i++) {
              var edit = edits[i];
              var xa = edit.plotinfo.xaxis;
              var ya = edit.plotinfo.yaxis;
              if(edit.xr0) aobj[xa._name + '.range'] = edit.xr0.slice();
              if(edit.yr0) aobj[ya._name + '.range'] = edit.yr0.slice();
          }
  
          return Registry.call('relayout', gd, aobj).then(function() {
              for(var i = 0; i < edits.length; i++) {
                  unsetSubplotTransform(edits[i].plotinfo);
              }
          });
      }
  
      var t1, t2, raf;
      var easeFn = d3.ease(transitionOpts.easing);
  
      gd._transitionData._interruptCallbacks.push(function() {
          window.cancelAnimationFrame(raf);
          raf = null;
          return transitionInterrupt();
      });
  
      function doFrame() {
          t2 = Date.now();
  
          var tInterp = Math.min(1, (t2 - t1) / transitionOpts.duration);
          var progress = easeFn(tInterp);
  
          for(var i = 0; i < edits.length; i++) {
              updateSubplot(edits[i], progress);
          }
  
          if(t2 - t1 > transitionOpts.duration) {
              transitionComplete();
              raf = window.cancelAnimationFrame(doFrame);
          } else {
              raf = window.requestAnimationFrame(doFrame);
          }
      }
  
      t1 = Date.now();
      raf = window.requestAnimationFrame(doFrame);
  
      return Promise.resolve();
  };
  
  },{"../../components/drawing":637,"../../lib":750,"../../registry":882,"./axes":799,"d3":169}],824:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var traceIs = _dereq_('../../registry').traceIs;
  var autoType = _dereq_('./axis_autotype');
  
  /*
   *  data: the plot data to use in choosing auto type
   *  name: axis object name (ie 'xaxis') if one should be stored
   */
  module.exports = function handleTypeDefaults(containerIn, containerOut, coerce, options) {
      var axType = coerce('type', (options.splomStash || {}).type);
  
      if(axType === '-') {
          setAutoType(containerOut, options.data);
  
          if(containerOut.type === '-') {
              containerOut.type = 'linear';
          } else {
              // copy autoType back to input axis
              // note that if this object didn't exist
              // in the input layout, we have to put it in
              // this happens in the main supplyDefaults function
              containerIn.type = containerOut.type;
          }
      }
  };
  
  function setAutoType(ax, data) {
      // new logic: let people specify any type they want,
      // only autotype if type is '-'
      if(ax.type !== '-') return;
  
      var id = ax._id;
      var axLetter = id.charAt(0);
      var i;
  
      // support 3d
      if(id.indexOf('scene') !== -1) id = axLetter;
  
      var d0 = getFirstNonEmptyTrace(data, id, axLetter);
      if(!d0) return;
  
      // first check for histograms, as the count direction
      // should always default to a linear axis
      if(d0.type === 'histogram' &&
          axLetter === {v: 'y', h: 'x'}[d0.orientation || 'v']
      ) {
          ax.type = 'linear';
          return;
      }
  
      var calAttr = axLetter + 'calendar';
      var calendar = d0[calAttr];
      var opts = {noMultiCategory: !traceIs(d0, 'cartesian') || traceIs(d0, 'noMultiCategory')};
  
      // To not confuse 2D x/y used for per-box sample points for multicategory coordinates
      if(d0.type === 'box' && d0._hasPreCompStats &&
          axLetter === {h: 'x', v: 'y'}[d0.orientation || 'v']
      ) {
          opts.noMultiCategory = true;
      }
  
      // check all boxes on this x axis to see
      // if they're dates, numbers, or categories
      if(isBoxWithoutPositionCoords(d0, axLetter)) {
          var posLetter = getBoxPosLetter(d0);
          var boxPositions = [];
  
          for(i = 0; i < data.length; i++) {
              var trace = data[i];
              if(!traceIs(trace, 'box-violin') || (trace[axLetter + 'axis'] || axLetter) !== id) continue;
  
              if(trace[posLetter] !== undefined) boxPositions.push(trace[posLetter][0]);
              else if(trace.name !== undefined) boxPositions.push(trace.name);
              else boxPositions.push('text');
  
              if(trace[calAttr] !== calendar) calendar = undefined;
          }
  
          ax.type = autoType(boxPositions, calendar, opts);
      } else if(d0.type === 'splom') {
          var dimensions = d0.dimensions;
          var dim = dimensions[d0._axesDim[id]];
          if(dim.visible) ax.type = autoType(dim.values, calendar, opts);
      } else {
          ax.type = autoType(d0[axLetter] || [d0[axLetter + '0']], calendar, opts);
      }
  }
  
  function getFirstNonEmptyTrace(data, id, axLetter) {
      for(var i = 0; i < data.length; i++) {
          var trace = data[i];
  
          if(trace.type === 'splom' &&
                  trace._length > 0 &&
                  (trace['_' + axLetter + 'axes'] || {})[id]
          ) {
              return trace;
          }
  
          if((trace[axLetter + 'axis'] || axLetter) === id) {
              if(isBoxWithoutPositionCoords(trace, axLetter)) {
                  return trace;
              } else if((trace[axLetter] || []).length || trace[axLetter + '0']) {
                  return trace;
              }
          }
      }
  }
  
  function getBoxPosLetter(trace) {
      return {v: 'x', h: 'y'}[trace.orientation || 'v'];
  }
  
  function isBoxWithoutPositionCoords(trace, axLetter) {
      var posLetter = getBoxPosLetter(trace);
      var isBox = traceIs(trace, 'box-violin');
      var isCandlestick = traceIs(trace._fullInput || {}, 'candlestick');
  
      return (
          isBox &&
          !isCandlestick &&
          axLetter === posLetter &&
          trace[posLetter] === undefined &&
          trace[posLetter + '0'] === undefined
      );
  }
  
  },{"../../registry":882,"./axis_autotype":800}],825:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../registry');
  var Lib = _dereq_('../lib');
  
  /*
   * Create or update an observer. This function is designed to be
   * idempotent so that it can be called over and over as the component
   * updates, and will attach and detach listeners as needed.
   *
   * @param {optional object} container
   *      An object on which the observer is stored. This is the mechanism
   *      by which it is idempotent. If it already exists, another won't be
   *      added. Each time it's called, the value lookup table is updated.
   * @param {array} commandList
   *      An array of commands, following either `buttons` of `updatemenus`
   *      or `steps` of `sliders`.
   * @param {function} onchange
   *      A listener called when the value is changed. Receives data object
   *      with information about the new state.
   */
  exports.manageCommandObserver = function(gd, container, commandList, onchange) {
      var ret = {};
      var enabled = true;
  
      if(container && container._commandObserver) {
          ret = container._commandObserver;
      }
  
      if(!ret.cache) {
          ret.cache = {};
      }
  
      // Either create or just recompute this:
      ret.lookupTable = {};
  
      var binding = exports.hasSimpleAPICommandBindings(gd, commandList, ret.lookupTable);
  
      if(container && container._commandObserver) {
          if(!binding) {
              // If container exists and there are no longer any bindings,
              // remove existing:
              if(container._commandObserver.remove) {
                  container._commandObserver.remove();
                  container._commandObserver = null;
                  return ret;
              }
          } else {
              // If container exists and there *are* bindings, then the lookup
              // table should have been updated and check is already attached,
              // so there's nothing to be done:
              return ret;
          }
      }
  
      // Determine whether there's anything to do for this binding:
  
      if(binding) {
          // Build the cache:
          bindingValueHasChanged(gd, binding, ret.cache);
  
          ret.check = function check() {
              if(!enabled) return;
  
              var update = bindingValueHasChanged(gd, binding, ret.cache);
  
              if(update.changed && onchange) {
                  // Disable checks for the duration of this command in order to avoid
                  // infinite loops:
                  if(ret.lookupTable[update.value] !== undefined) {
                      ret.disable();
                      Promise.resolve(onchange({
                          value: update.value,
                          type: binding.type,
                          prop: binding.prop,
                          traces: binding.traces,
                          index: ret.lookupTable[update.value]
                      })).then(ret.enable, ret.enable);
                  }
              }
  
              return update.changed;
          };
  
          var checkEvents = [
              'plotly_relayout',
              'plotly_redraw',
              'plotly_restyle',
              'plotly_update',
              'plotly_animatingframe',
              'plotly_afterplot'
          ];
  
          for(var i = 0; i < checkEvents.length; i++) {
              gd._internalOn(checkEvents[i], ret.check);
          }
  
          ret.remove = function() {
              for(var i = 0; i < checkEvents.length; i++) {
                  gd._removeInternalListener(checkEvents[i], ret.check);
              }
          };
      } else {
          // TODO: It'd be really neat to actually give a *reason* for this, but at least a warning
          // is a start
          Lib.log('Unable to automatically bind plot updates to API command');
  
          ret.lookupTable = {};
          ret.remove = function() {};
      }
  
      ret.disable = function disable() {
          enabled = false;
      };
  
      ret.enable = function enable() {
          enabled = true;
      };
  
      if(container) {
          container._commandObserver = ret;
      }
  
      return ret;
  };
  
  /*
   * This function checks to see if an array of objects containing
   * method and args properties is compatible with automatic two-way
   * binding. The criteria right now are that
   *
   *   1. multiple traces may be affected
   *   2. only one property may be affected
   *   3. the same property must be affected by all commands
   */
  exports.hasSimpleAPICommandBindings = function(gd, commandList, bindingsByValue) {
      var i;
      var n = commandList.length;
  
      var refBinding;
  
      for(i = 0; i < n; i++) {
          var binding;
          var command = commandList[i];
          var method = command.method;
          var args = command.args;
  
          if(!Array.isArray(args)) args = [];
  
          // If any command has no method, refuse to bind:
          if(!method) {
              return false;
          }
          var bindings = exports.computeAPICommandBindings(gd, method, args);
  
          // Right now, handle one and *only* one property being set:
          if(bindings.length !== 1) {
              return false;
          }
  
          if(!refBinding) {
              refBinding = bindings[0];
              if(Array.isArray(refBinding.traces)) {
                  refBinding.traces.sort();
              }
          } else {
              binding = bindings[0];
              if(binding.type !== refBinding.type) {
                  return false;
              }
              if(binding.prop !== refBinding.prop) {
                  return false;
              }
              if(Array.isArray(refBinding.traces)) {
                  if(Array.isArray(binding.traces)) {
                      binding.traces.sort();
                      for(var j = 0; j < refBinding.traces.length; j++) {
                          if(refBinding.traces[j] !== binding.traces[j]) {
                              return false;
                          }
                      }
                  } else {
                      return false;
                  }
              } else {
                  if(binding.prop !== refBinding.prop) {
                      return false;
                  }
              }
          }
  
          binding = bindings[0];
          var value = binding.value;
          if(Array.isArray(value)) {
              if(value.length === 1) {
                  value = value[0];
              } else {
                  return false;
              }
          }
          if(bindingsByValue) {
              bindingsByValue[value] = i;
          }
      }
  
      return refBinding;
  };
  
  function bindingValueHasChanged(gd, binding, cache) {
      var container, value, obj;
      var changed = false;
  
      if(binding.type === 'data') {
          // If it's data, we need to get a trace. Based on the limited scope
          // of what we cover, we can just take the first trace from the list,
          // or otherwise just the first trace:
          container = gd._fullData[binding.traces !== null ? binding.traces[0] : 0];
      } else if(binding.type === 'layout') {
          container = gd._fullLayout;
      } else {
          return false;
      }
  
      value = Lib.nestedProperty(container, binding.prop).get();
  
      obj = cache[binding.type] = cache[binding.type] || {};
  
      if(obj.hasOwnProperty(binding.prop)) {
          if(obj[binding.prop] !== value) {
              changed = true;
          }
      }
  
      obj[binding.prop] = value;
  
      return {
          changed: changed,
          value: value
      };
  }
  
  /*
   * Execute an API command. There's really not much to this; it just provides
   * a common hook so that implementations don't need to be synchronized across
   * multiple components with the ability to invoke API commands.
   *
   * @param {string} method
   *      The name of the plotly command to execute. Must be one of 'animate',
   *      'restyle', 'relayout', 'update'.
   * @param {array} args
   *      A list of arguments passed to the API command
   */
  exports.executeAPICommand = function(gd, method, args) {
      if(method === 'skip') return Promise.resolve();
  
      var _method = Registry.apiMethodRegistry[method];
      var allArgs = [gd];
      if(!Array.isArray(args)) args = [];
  
      for(var i = 0; i < args.length; i++) {
          allArgs.push(args[i]);
      }
  
      return _method.apply(null, allArgs).catch(function(err) {
          Lib.warn('API call to Plotly.' + method + ' rejected.', err);
          return Promise.reject(err);
      });
  };
  
  exports.computeAPICommandBindings = function(gd, method, args) {
      var bindings;
  
      if(!Array.isArray(args)) args = [];
  
      switch(method) {
          case 'restyle':
              bindings = computeDataBindings(gd, args);
              break;
          case 'relayout':
              bindings = computeLayoutBindings(gd, args);
              break;
          case 'update':
              bindings = computeDataBindings(gd, [args[0], args[2]])
                  .concat(computeLayoutBindings(gd, [args[1]]));
              break;
          case 'animate':
              bindings = computeAnimateBindings(gd, args);
              break;
          default:
              // This is the case where intelligent logic about what affects
              // this command is not implemented. It causes no ill effects.
              // For example, addFrames simply won't bind to a control component.
              bindings = [];
      }
      return bindings;
  };
  
  function computeAnimateBindings(gd, args) {
      // We'll assume that the only relevant modification an animation
      // makes that's meaningfully tracked is the frame:
      if(Array.isArray(args[0]) && args[0].length === 1 && ['string', 'number'].indexOf(typeof args[0][0]) !== -1) {
          return [{type: 'layout', prop: '_currentFrame', value: args[0][0].toString()}];
      } else {
          return [];
      }
  }
  
  function computeLayoutBindings(gd, args) {
      var bindings = [];
  
      var astr = args[0];
      var aobj = {};
      if(typeof astr === 'string') {
          aobj[astr] = args[1];
      } else if(Lib.isPlainObject(astr)) {
          aobj = astr;
      } else {
          return bindings;
      }
  
      crawl(aobj, function(path, attrName, attr) {
          bindings.push({type: 'layout', prop: path, value: attr});
      }, '', 0);
  
      return bindings;
  }
  
  function computeDataBindings(gd, args) {
      var traces, astr, val, aobj;
      var bindings = [];
  
      // Logic copied from Plotly.restyle:
      astr = args[0];
      val = args[1];
      traces = args[2];
      aobj = {};
      if(typeof astr === 'string') {
          aobj[astr] = val;
      } else if(Lib.isPlainObject(astr)) {
          // the 3-arg form
          aobj = astr;
  
          if(traces === undefined) {
              traces = val;
          }
      } else {
          return bindings;
      }
  
      if(traces === undefined) {
          // Explicitly assign this to null instead of undefined:
          traces = null;
      }
  
      crawl(aobj, function(path, attrName, _attr) {
          var thisTraces;
          var attr;
  
          if(Array.isArray(_attr)) {
              attr = _attr.slice();
  
              var nAttr = Math.min(attr.length, gd.data.length);
              if(traces) {
                  nAttr = Math.min(nAttr, traces.length);
              }
              thisTraces = [];
              for(var j = 0; j < nAttr; j++) {
                  thisTraces[j] = traces ? traces[j] : j;
              }
          } else {
              attr = _attr;
              thisTraces = traces ? traces.slice() : null;
          }
  
          // Convert [7] to just 7 when traces is null:
          if(thisTraces === null) {
              if(Array.isArray(attr)) {
                  attr = attr[0];
              }
          } else if(Array.isArray(thisTraces)) {
              if(!Array.isArray(attr)) {
                  var tmp = attr;
                  attr = [];
                  for(var i = 0; i < thisTraces.length; i++) {
                      attr[i] = tmp;
                  }
              }
              attr.length = Math.min(thisTraces.length, attr.length);
          }
  
          bindings.push({
              type: 'data',
              prop: path,
              traces: thisTraces,
              value: attr
          });
      }, '', 0);
  
      return bindings;
  }
  
  function crawl(attrs, callback, path, depth) {
      Object.keys(attrs).forEach(function(attrName) {
          var attr = attrs[attrName];
  
          if(attrName[0] === '_') return;
  
          var thisPath = path + (depth > 0 ? '.' : '') + attrName;
  
          if(Lib.isPlainObject(attr)) {
              crawl(attr, callback, thisPath, depth + 1);
          } else {
              // Only execute the callback on leaf nodes:
              callback(thisPath, attrName, attr);
          }
      });
  }
  
  },{"../lib":750,"../registry":882}],826:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var extendFlat = _dereq_('../lib/extend').extendFlat;
  
  /**
   * Make a xy domain attribute group
   *
   * @param {object} opts
   *   @param {string}
   *     opts.name: name to be inserted in the default description
   *   @param {boolean}
   *     opts.trace: set to true for trace containers
   *   @param {string}
   *     opts.editType: editType for all pieces
   *   @param {boolean}
   *     opts.noGridCell: set to true to omit `row` and `column`
   *
   * @param {object} extra
   *   @param {string}
   *     extra.description: extra description. N.B we use
   *     a separate extra container to make it compatible with
   *     the compress_attributes transform.
   *
   * @return {object} attributes object containing {x,y} as specified
   */
  exports.attributes = function(opts, extra) {
      opts = opts || {};
      extra = extra || {};
  
      var base = {
          valType: 'info_array',
          
          editType: opts.editType,
          items: [
              {valType: 'number', min: 0, max: 1, editType: opts.editType},
              {valType: 'number', min: 0, max: 1, editType: opts.editType}
          ],
          dflt: [0, 1]
      };
  
      var namePart = opts.name ? opts.name + ' ' : '';
      var contPart = opts.trace ? 'trace ' : 'subplot ';
      var descPart = extra.description ? ' ' + extra.description : '';
  
      var out = {
          x: extendFlat({}, base, {
              
          }),
          y: extendFlat({}, base, {
              
          }),
          editType: opts.editType
      };
  
      if(!opts.noGridCell) {
          out.row = {
              valType: 'integer',
              min: 0,
              dflt: 0,
              
              editType: opts.editType,
              
          };
          out.column = {
              valType: 'integer',
              min: 0,
              dflt: 0,
              
              editType: opts.editType,
              
          };
      }
  
      return out;
  };
  
  exports.defaults = function(containerOut, layout, coerce, dfltDomains) {
      var dfltX = (dfltDomains && dfltDomains.x) || [0, 1];
      var dfltY = (dfltDomains && dfltDomains.y) || [0, 1];
  
      var grid = layout.grid;
      if(grid) {
          var column = coerce('domain.column');
          if(column !== undefined) {
              if(column < grid.columns) dfltX = grid._domains.x[column];
              else delete containerOut.domain.column;
          }
  
          var row = coerce('domain.row');
          if(row !== undefined) {
              if(row < grid.rows) dfltY = grid._domains.y[row];
              else delete containerOut.domain.row;
          }
      }
  
      var x = coerce('domain.x', dfltX);
      var y = coerce('domain.y', dfltY);
  
      // don't accept bad input data
      if(!(x[0] < x[1])) containerOut.domain.x = dfltX.slice();
      if(!(y[0] < y[1])) containerOut.domain.y = dfltY.slice();
  };
  
  },{"../lib/extend":740}],827:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /*
   * make a font attribute group
   *
   * @param {object} opts
   *   @param {string}
   *     opts.description: where & how this font is used
   *   @param {optional bool} arrayOk:
   *     should each part (family, size, color) be arrayOk? default false.
   *   @param {string} editType:
   *     the editType for all pieces of this font
   *   @param {optional string} colorEditType:
   *     a separate editType just for color
   *
   * @return {object} attributes object containing {family, size, color} as specified
   */
  module.exports = function(opts) {
      var editType = opts.editType;
      var colorEditType = opts.colorEditType;
      if(colorEditType === undefined) colorEditType = editType;
      var attrs = {
          family: {
              valType: 'string',
              
              noBlank: true,
              strict: true,
              editType: editType,
              
          },
          size: {
              valType: 'number',
              
              min: 1,
              editType: editType
          },
          color: {
              valType: 'color',
              
              editType: colorEditType
          },
          editType: editType,
          // blank strings so compress_attributes can remove
          // TODO - that's uber hacky... better solution?
          
      };
  
      if(opts.arrayOk) {
          attrs.family.arrayOk = true;
          attrs.size.arrayOk = true;
          attrs.color.arrayOk = true;
      }
  
      return attrs;
  };
  
  },{}],828:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      _isLinkedToArray: 'frames_entry',
  
      group: {
          valType: 'string',
          
          
      },
      name: {
          valType: 'string',
          
          
      },
      traces: {
          valType: 'any',
          
          
      },
      baseframe: {
          valType: 'string',
          
          
      },
      data: {
          valType: 'any',
          
          
      },
      layout: {
          valType: 'any',
          
          
      }
  };
  
  },{}],829:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  // projection names to d3 function name
  exports.projNames = {
      // d3.geo.projection
      'equirectangular': 'equirectangular',
      'mercator': 'mercator',
      'orthographic': 'orthographic',
      'natural earth': 'naturalEarth',
      'kavrayskiy7': 'kavrayskiy7',
      'miller': 'miller',
      'robinson': 'robinson',
      'eckert4': 'eckert4',
      'azimuthal equal area': 'azimuthalEqualArea',
      'azimuthal equidistant': 'azimuthalEquidistant',
      'conic equal area': 'conicEqualArea',
      'conic conformal': 'conicConformal',
      'conic equidistant': 'conicEquidistant',
      'gnomonic': 'gnomonic',
      'stereographic': 'stereographic',
      'mollweide': 'mollweide',
      'hammer': 'hammer',
      'transverse mercator': 'transverseMercator',
      'albers usa': 'albersUsa',
      'winkel tripel': 'winkel3',
      'aitoff': 'aitoff',
      'sinusoidal': 'sinusoidal'
  };
  
  // name of the axes
  exports.axesNames = ['lonaxis', 'lataxis'];
  
  // max longitudinal angular span (EXPERIMENTAL)
  exports.lonaxisSpan = {
      'orthographic': 180,
      'azimuthal equal area': 360,
      'azimuthal equidistant': 360,
      'conic conformal': 180,
      'gnomonic': 160,
      'stereographic': 180,
      'transverse mercator': 180,
      '*': 360
  };
  
  // max latitudinal angular span (EXPERIMENTAL)
  exports.lataxisSpan = {
      'conic conformal': 150,
      'stereographic': 179.5,
      '*': 180
  };
  
  // defaults for each scope
  exports.scopeDefaults = {
      world: {
          lonaxisRange: [-180, 180],
          lataxisRange: [-90, 90],
          projType: 'equirectangular',
          projRotate: [0, 0, 0]
      },
      usa: {
          lonaxisRange: [-180, -50],
          lataxisRange: [15, 80],
          projType: 'albers usa'
      },
      europe: {
          lonaxisRange: [-30, 60],
          lataxisRange: [30, 85],
          projType: 'conic conformal',
          projRotate: [15, 0, 0],
          projParallels: [0, 60]
      },
      asia: {
          lonaxisRange: [22, 160],
          lataxisRange: [-15, 55],
          projType: 'mercator',
          projRotate: [0, 0, 0]
      },
      africa: {
          lonaxisRange: [-30, 60],
          lataxisRange: [-40, 40],
          projType: 'mercator',
          projRotate: [0, 0, 0]
      },
      'north america': {
          lonaxisRange: [-180, -45],
          lataxisRange: [5, 85],
          projType: 'conic conformal',
          projRotate: [-100, 0, 0],
          projParallels: [29.5, 45.5]
      },
      'south america': {
          lonaxisRange: [-100, -30],
          lataxisRange: [-60, 15],
          projType: 'mercator',
          projRotate: [0, 0, 0]
      }
  };
  
  // angular pad to avoid rounding error around clip angles
  exports.clipPad = 1e-3;
  
  // map projection precision
  exports.precision = 0.1;
  
  // default land and water fill colors
  exports.landColor = '#F0DC82';
  exports.waterColor = '#3399FF';
  
  // locationmode to layer name
  exports.locationmodeToLayer = {
      'ISO-3': 'countries',
      'USA-states': 'subunits',
      'country names': 'countries'
  };
  
  // SVG element for a sphere (use to frame maps)
  exports.sphereSVG = {type: 'Sphere'};
  
  // N.B. base layer names must be the same as in the topojson files
  
  // base layer with a fill color
  exports.fillLayers = {
      ocean: 1,
      land: 1,
      lakes: 1
  };
  
  // base layer with a only a line color
  exports.lineLayers = {
      subunits: 1,
      countries: 1,
      coastlines: 1,
      rivers: 1,
      frame: 1
  };
  
  exports.layers = [
      'bg',
      'ocean', 'land', 'lakes',
      'subunits', 'countries', 'coastlines', 'rivers',
      'lataxis', 'lonaxis', 'frame',
      'backplot',
      'frontplot'
  ];
  
  exports.layersForChoropleth = [
      'bg',
      'ocean', 'land',
      'subunits', 'countries', 'coastlines',
      'lataxis', 'lonaxis', 'frame',
      'backplot',
      'rivers', 'lakes',
      'frontplot'
  ];
  
  exports.layerNameToAdjective = {
      ocean: 'ocean',
      land: 'land',
      lakes: 'lake',
      subunits: 'subunit',
      countries: 'country',
      coastlines: 'coastline',
      rivers: 'river',
      frame: 'frame'
  };
  
  },{}],830:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /* global PlotlyGeoAssets:false */
  
  var d3 = _dereq_('d3');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  var Fx = _dereq_('../../components/fx');
  var Plots = _dereq_('../plots');
  var Axes = _dereq_('../cartesian/axes');
  var getAutoRange = _dereq_('../cartesian/autorange').getAutoRange;
  var dragElement = _dereq_('../../components/dragelement');
  var prepSelect = _dereq_('../cartesian/select').prepSelect;
  var clearSelect = _dereq_('../cartesian/select').clearSelect;
  var selectOnClick = _dereq_('../cartesian/select').selectOnClick;
  
  var createGeoZoom = _dereq_('./zoom');
  var constants = _dereq_('./constants');
  
  var geoUtils = _dereq_('../../lib/geo_location_utils');
  var topojsonUtils = _dereq_('../../lib/topojson_utils');
  var topojsonFeature = _dereq_('topojson-client').feature;
  
  _dereq_('./projections')(d3);
  
  function Geo(opts) {
      this.id = opts.id;
      this.graphDiv = opts.graphDiv;
      this.container = opts.container;
      this.topojsonURL = opts.topojsonURL;
      this.isStatic = opts.staticPlot;
  
      this.topojsonName = null;
      this.topojson = null;
  
      this.projection = null;
      this.scope = null;
      this.viewInitial = null;
      this.fitScale = null;
      this.bounds = null;
      this.midPt = null;
  
      this.hasChoropleth = false;
      this.traceHash = {};
  
      this.layers = {};
      this.basePaths = {};
      this.dataPaths = {};
      this.dataPoints = {};
  
      this.clipDef = null;
      this.clipRect = null;
      this.bgRect = null;
  
      this.makeFramework();
  }
  
  var proto = Geo.prototype;
  
  module.exports = function createGeo(opts) {
      return new Geo(opts);
  };
  
  proto.plot = function(geoCalcData, fullLayout, promises) {
      var _this = this;
      var geoLayout = fullLayout[this.id];
      var geoPromises = [];
  
      var needsTopojson = false;
      for(var k in constants.layerNameToAdjective) {
          if(k !== 'frame' && geoLayout['show' + k]) {
              needsTopojson = true;
              break;
          }
      }
      for(var i = 0; i < geoCalcData.length; i++) {
          if(geoCalcData[0][0].trace.locationmode) {
              needsTopojson = true;
              break;
          }
      }
  
      if(needsTopojson) {
          var topojsonNameNew = topojsonUtils.getTopojsonName(geoLayout);
          if(_this.topojson === null || topojsonNameNew !== _this.topojsonName) {
              _this.topojsonName = topojsonNameNew;
  
              if(PlotlyGeoAssets.topojson[_this.topojsonName] === undefined) {
                  geoPromises.push(_this.fetchTopojson());
              }
          }
      }
  
      geoPromises = geoPromises.concat(geoUtils.fetchTraceGeoData(geoCalcData));
  
      promises.push(new Promise(function(resolve, reject) {
          Promise.all(geoPromises).then(function() {
              _this.topojson = PlotlyGeoAssets.topojson[_this.topojsonName];
              _this.update(geoCalcData, fullLayout);
              resolve();
          })
          .catch(reject);
      }));
  };
  
  proto.fetchTopojson = function() {
      var _this = this;
      var topojsonPath = topojsonUtils.getTopojsonPath(_this.topojsonURL, _this.topojsonName);
  
      return new Promise(function(resolve, reject) {
          d3.json(topojsonPath, function(err, topojson) {
              if(err) {
                  if(err.status === 404) {
                      return reject(new Error([
                          'plotly.js could not find topojson file at',
                          topojsonPath, '.',
                          'Make sure the *topojsonURL* plot config option',
                          'is set properly.'
                      ].join(' ')));
                  } else {
                      return reject(new Error([
                          'unexpected error while fetching topojson file at',
                          topojsonPath
                      ].join(' ')));
                  }
              }
  
              PlotlyGeoAssets.topojson[_this.topojsonName] = topojson;
              resolve();
          });
      });
  };
  
  proto.update = function(geoCalcData, fullLayout) {
      var geoLayout = fullLayout[this.id];
  
      // important: maps with choropleth traces have a different layer order
      this.hasChoropleth = false;
  
      for(var i = 0; i < geoCalcData.length; i++) {
          var calcTrace = geoCalcData[i];
          var trace = calcTrace[0].trace;
  
          if(trace.type === 'choropleth') {
              this.hasChoropleth = true;
          }
          if(trace.visible === true && trace._length > 0) {
              trace._module.calcGeoJSON(calcTrace, fullLayout);
          }
      }
  
      var hasInvalidBounds = this.updateProjection(geoCalcData, fullLayout);
      if(hasInvalidBounds) return;
  
      if(!this.viewInitial || this.scope !== geoLayout.scope) {
          this.saveViewInitial(geoLayout);
      }
      this.scope = geoLayout.scope;
  
      this.updateBaseLayers(fullLayout, geoLayout);
      this.updateDims(fullLayout, geoLayout);
      this.updateFx(fullLayout, geoLayout);
  
      Plots.generalUpdatePerTraceModule(this.graphDiv, this, geoCalcData, geoLayout);
  
      var scatterLayer = this.layers.frontplot.select('.scatterlayer');
      this.dataPoints.point = scatterLayer.selectAll('.point');
      this.dataPoints.text = scatterLayer.selectAll('text');
      this.dataPaths.line = scatterLayer.selectAll('.js-line');
  
      var choroplethLayer = this.layers.backplot.select('.choroplethlayer');
      this.dataPaths.choropleth = choroplethLayer.selectAll('path');
  
      this.render();
  };
  
  proto.updateProjection = function(geoCalcData, fullLayout) {
      var gd = this.graphDiv;
      var geoLayout = fullLayout[this.id];
      var gs = fullLayout._size;
      var domain = geoLayout.domain;
      var projLayout = geoLayout.projection;
  
      var lonaxis = geoLayout.lonaxis;
      var lataxis = geoLayout.lataxis;
      var axLon = lonaxis._ax;
      var axLat = lataxis._ax;
  
      var projection = this.projection = getProjection(geoLayout);
  
      // setup subplot extent [[x0,y0], [x1,y1]]
      var extent = [[
          gs.l + gs.w * domain.x[0],
          gs.t + gs.h * (1 - domain.y[1])
      ], [
          gs.l + gs.w * domain.x[1],
          gs.t + gs.h * (1 - domain.y[0])
      ]];
  
      var center = geoLayout.center || {};
      var rotation = projLayout.rotation || {};
      var lonaxisRange = lonaxis.range || [];
      var lataxisRange = lataxis.range || [];
  
      if(geoLayout.fitbounds) {
          axLon._length = extent[1][0] - extent[0][0];
          axLat._length = extent[1][1] - extent[0][1];
          axLon.range = getAutoRange(gd, axLon);
          axLat.range = getAutoRange(gd, axLat);
  
          var midLon = (axLon.range[0] + axLon.range[1]) / 2;
          var midLat = (axLat.range[0] + axLat.range[1]) / 2;
  
          if(geoLayout._isScoped) {
              center = {lon: midLon, lat: midLat};
          } else if(geoLayout._isClipped) {
              center = {lon: midLon, lat: midLat};
              rotation = {lon: midLon, lat: midLat, roll: rotation.roll};
  
              var projType = projLayout.type;
              var lonHalfSpan = (constants.lonaxisSpan[projType] / 2) || 180;
              var latHalfSpan = (constants.lataxisSpan[projType] / 2) || 90;
  
              lonaxisRange = [midLon - lonHalfSpan, midLon + lonHalfSpan];
              lataxisRange = [midLat - latHalfSpan, midLat + latHalfSpan];
          } else {
              center = {lon: midLon, lat: midLat};
              rotation = {lon: midLon, lat: rotation.lat, roll: rotation.roll};
          }
      }
  
      // set 'pre-fit' projection
      projection
          .center([center.lon - rotation.lon, center.lat - rotation.lat])
          .rotate([-rotation.lon, -rotation.lat, rotation.roll])
          .parallels(projLayout.parallels);
  
      // fit projection 'scale' and 'translate' to set lon/lat ranges
      var rangeBox = makeRangeBox(lonaxisRange, lataxisRange);
      projection.fitExtent(extent, rangeBox);
  
      var b = this.bounds = projection.getBounds(rangeBox);
      var s = this.fitScale = projection.scale();
      var t = projection.translate();
  
      if(
          !isFinite(b[0][0]) || !isFinite(b[0][1]) ||
          !isFinite(b[1][0]) || !isFinite(b[1][1]) ||
          isNaN(t[0]) || isNaN(t[0])
      ) {
          var attrToUnset = ['fitbounds', 'projection.rotation', 'center', 'lonaxis.range', 'lataxis.range'];
          var msg = 'Invalid geo settings, relayout\'ing to default view.';
          var updateObj = {};
  
          // clear all attributes that could cause invalid bounds,
          // clear viewInitial to update reset-view behavior
  
          for(var i = 0; i < attrToUnset.length; i++) {
              updateObj[this.id + '.' + attrToUnset[i]] = null;
          }
  
          this.viewInitial = null;
  
          Lib.warn(msg);
          gd._promises.push(Registry.call('relayout', gd, updateObj));
          return msg;
      }
  
      if(geoLayout.fitbounds) {
          var b2 = projection.getBounds(makeRangeBox(axLon.range, axLat.range));
          var k2 = Math.min(
              (b[1][0] - b[0][0]) / (b2[1][0] - b2[0][0]),
              (b[1][1] - b[0][1]) / (b2[1][1] - b2[0][1])
          );
  
          if(isFinite(k2)) {
              projection.scale(k2 * s);
          } else {
              Lib.warn('Something went wrong during' + this.id + 'fitbounds computations.');
          }
      } else {
          // adjust projection to user setting
          projection.scale(projLayout.scale * s);
      }
  
      // px coordinates of view mid-point,
      // useful to update `geo.center` after interactions
      var midPt = this.midPt = [
          (b[0][0] + b[1][0]) / 2,
          (b[0][1] + b[1][1]) / 2
      ];
  
      projection
          .translate([t[0] + (midPt[0] - t[0]), t[1] + (midPt[1] - t[1])])
          .clipExtent(b);
  
      // the 'albers usa' projection does not expose a 'center' method
      // so here's this hack to make it respond to 'geoLayout.center'
      if(geoLayout._isAlbersUsa) {
          var centerPx = projection([center.lon, center.lat]);
          var tt = projection.translate();
  
          projection.translate([
              tt[0] - (centerPx[0] - tt[0]),
              tt[1] - (centerPx[1] - tt[1])
          ]);
      }
  };
  
  proto.updateBaseLayers = function(fullLayout, geoLayout) {
      var _this = this;
      var topojson = _this.topojson;
      var layers = _this.layers;
      var basePaths = _this.basePaths;
  
      function isAxisLayer(d) {
          return (d === 'lonaxis' || d === 'lataxis');
      }
  
      function isLineLayer(d) {
          return Boolean(constants.lineLayers[d]);
      }
  
      function isFillLayer(d) {
          return Boolean(constants.fillLayers[d]);
      }
  
      var allLayers = this.hasChoropleth ?
          constants.layersForChoropleth :
          constants.layers;
  
      var layerData = allLayers.filter(function(d) {
          return (isLineLayer(d) || isFillLayer(d)) ? geoLayout['show' + d] :
              isAxisLayer(d) ? geoLayout[d].showgrid :
              true;
      });
  
      var join = _this.framework.selectAll('.layer')
          .data(layerData, String);
  
      join.exit().each(function(d) {
          delete layers[d];
          delete basePaths[d];
          d3.select(this).remove();
      });
  
      join.enter().append('g')
          .attr('class', function(d) { return 'layer ' + d; })
          .each(function(d) {
              var layer = layers[d] = d3.select(this);
  
              if(d === 'bg') {
                  _this.bgRect = layer.append('rect')
                      .style('pointer-events', 'all');
              } else if(isAxisLayer(d)) {
                  basePaths[d] = layer.append('path')
                      .style('fill', 'none');
              } else if(d === 'backplot') {
                  layer.append('g')
                      .classed('choroplethlayer', true);
              } else if(d === 'frontplot') {
                  layer.append('g')
                      .classed('scatterlayer', true);
              } else if(isLineLayer(d)) {
                  basePaths[d] = layer.append('path')
                      .style('fill', 'none')
                      .style('stroke-miterlimit', 2);
              } else if(isFillLayer(d)) {
                  basePaths[d] = layer.append('path')
                      .style('stroke', 'none');
              }
          });
  
      join.order();
  
      join.each(function(d) {
          var path = basePaths[d];
          var adj = constants.layerNameToAdjective[d];
  
          if(d === 'frame') {
              path.datum(constants.sphereSVG);
          } else if(isLineLayer(d) || isFillLayer(d)) {
              path.datum(topojsonFeature(topojson, topojson.objects[d]));
          } else if(isAxisLayer(d)) {
              path.datum(makeGraticule(d, geoLayout, fullLayout))
                  .call(Color.stroke, geoLayout[d].gridcolor)
                  .call(Drawing.dashLine, '', geoLayout[d].gridwidth);
          }
  
          if(isLineLayer(d)) {
              path.call(Color.stroke, geoLayout[adj + 'color'])
                  .call(Drawing.dashLine, '', geoLayout[adj + 'width']);
          } else if(isFillLayer(d)) {
              path.call(Color.fill, geoLayout[adj + 'color']);
          }
      });
  };
  
  proto.updateDims = function(fullLayout, geoLayout) {
      var b = this.bounds;
      var hFrameWidth = (geoLayout.framewidth || 0) / 2;
  
      var l = b[0][0] - hFrameWidth;
      var t = b[0][1] - hFrameWidth;
      var w = b[1][0] - l + hFrameWidth;
      var h = b[1][1] - t + hFrameWidth;
  
      Drawing.setRect(this.clipRect, l, t, w, h);
  
      this.bgRect
          .call(Drawing.setRect, l, t, w, h)
          .call(Color.fill, geoLayout.bgcolor);
  
      this.xaxis._offset = l;
      this.xaxis._length = w;
  
      this.yaxis._offset = t;
      this.yaxis._length = h;
  };
  
  proto.updateFx = function(fullLayout, geoLayout) {
      var _this = this;
      var gd = _this.graphDiv;
      var bgRect = _this.bgRect;
      var dragMode = fullLayout.dragmode;
      var clickMode = fullLayout.clickmode;
  
      if(_this.isStatic) return;
  
      function zoomReset() {
          var viewInitial = _this.viewInitial;
          var updateObj = {};
  
          for(var k in viewInitial) {
              updateObj[_this.id + '.' + k] = viewInitial[k];
          }
  
          Registry.call('_guiRelayout', gd, updateObj);
          gd.emit('plotly_doubleclick', null);
      }
  
      function invert(lonlat) {
          return _this.projection.invert([
              lonlat[0] + _this.xaxis._offset,
              lonlat[1] + _this.yaxis._offset
          ]);
      }
  
      var fillRangeItems;
  
      if(dragMode === 'select') {
          fillRangeItems = function(eventData, poly) {
              var ranges = eventData.range = {};
              ranges[_this.id] = [
                  invert([poly.xmin, poly.ymin]),
                  invert([poly.xmax, poly.ymax])
              ];
          };
      } else if(dragMode === 'lasso') {
          fillRangeItems = function(eventData, poly, pts) {
              var dataPts = eventData.lassoPoints = {};
              dataPts[_this.id] = pts.filtered.map(invert);
          };
      }
  
      // Note: dragOptions is needed to be declared for all dragmodes because
      // it's the object that holds persistent selection state.
      var dragOptions = {
          element: _this.bgRect.node(),
          gd: gd,
          plotinfo: {
              id: _this.id,
              xaxis: _this.xaxis,
              yaxis: _this.yaxis,
              fillRangeItems: fillRangeItems
          },
          xaxes: [_this.xaxis],
          yaxes: [_this.yaxis],
          subplot: _this.id,
          clickFn: function(numClicks) {
              if(numClicks === 2) {
                  clearSelect(gd);
              }
          }
      };
  
      if(dragMode === 'pan') {
          bgRect.node().onmousedown = null;
          bgRect.call(createGeoZoom(_this, geoLayout));
          bgRect.on('dblclick.zoom', zoomReset);
          if(!gd._context._scrollZoom.geo) {
              bgRect.on('wheel.zoom', null);
          }
      } else if(dragMode === 'select' || dragMode === 'lasso') {
          bgRect.on('.zoom', null);
  
          dragOptions.prepFn = function(e, startX, startY) {
              prepSelect(e, startX, startY, dragOptions, dragMode);
          };
  
          dragElement.init(dragOptions);
      }
  
      bgRect.on('mousemove', function() {
          var lonlat = _this.projection.invert(d3.mouse(this));
  
          if(!lonlat || isNaN(lonlat[0]) || isNaN(lonlat[1])) {
              return dragElement.unhover(gd, d3.event);
          }
  
          _this.xaxis.p2c = function() { return lonlat[0]; };
          _this.yaxis.p2c = function() { return lonlat[1]; };
  
          Fx.hover(gd, d3.event, _this.id);
      });
  
      bgRect.on('mouseout', function() {
          if(gd._dragging) return;
          dragElement.unhover(gd, d3.event);
      });
  
      bgRect.on('click', function() {
          // For select and lasso the dragElement is handling clicks
          if(dragMode !== 'select' && dragMode !== 'lasso') {
              if(clickMode.indexOf('select') > -1) {
                  selectOnClick(d3.event, gd, [_this.xaxis], [_this.yaxis],
                    _this.id, dragOptions);
              }
  
              if(clickMode.indexOf('event') > -1) {
                  // TODO: like pie and mapbox, this doesn't support right-click
                  // actually this one is worse, as right-click starts a pan, or leaves
                  // select in a weird state.
                  // Also, only tangentially related, we should cancel hover during pan
                  Fx.click(gd, d3.event);
              }
          }
      });
  };
  
  proto.makeFramework = function() {
      var _this = this;
      var gd = _this.graphDiv;
      var fullLayout = gd._fullLayout;
      var clipId = 'clip' + fullLayout._uid + _this.id;
  
      _this.clipDef = fullLayout._clips.append('clipPath')
          .attr('id', clipId);
  
      _this.clipRect = _this.clipDef.append('rect');
  
      _this.framework = d3.select(_this.container).append('g')
          .attr('class', 'geo ' + _this.id)
          .call(Drawing.setClipUrl, clipId, gd);
  
      // sane lonlat to px
      _this.project = function(v) {
          var px = _this.projection(v);
          return px ?
              [px[0] - _this.xaxis._offset, px[1] - _this.yaxis._offset] :
              [null, null];
      };
  
      _this.xaxis = {
          _id: 'x',
          c2p: function(v) { return _this.project(v)[0]; }
      };
  
      _this.yaxis = {
          _id: 'y',
          c2p: function(v) { return _this.project(v)[1]; }
      };
  
      // mock axis for hover formatting
      _this.mockAxis = {
          type: 'linear',
          showexponent: 'all',
          exponentformat: 'B'
      };
      Axes.setConvert(_this.mockAxis, fullLayout);
  };
  
  proto.saveViewInitial = function(geoLayout) {
      var center = geoLayout.center || {};
      var projLayout = geoLayout.projection;
      var rotation = projLayout.rotation || {};
  
      this.viewInitial = {
          'fitbounds': geoLayout.fitbounds,
          'projection.scale': projLayout.scale
      };
  
      var extra;
      if(geoLayout._isScoped) {
          extra = {
              'center.lon': center.lon,
              'center.lat': center.lat,
          };
      } else if(geoLayout._isClipped) {
          extra = {
              'projection.rotation.lon': rotation.lon,
              'projection.rotation.lat': rotation.lat
          };
      } else {
          extra = {
              'center.lon': center.lon,
              'center.lat': center.lat,
              'projection.rotation.lon': rotation.lon
          };
      }
  
      Lib.extendFlat(this.viewInitial, extra);
  };
  
  // [hot code path] (re)draw all paths which depend on the projection
  proto.render = function() {
      var projection = this.projection;
      var pathFn = projection.getPath();
      var k;
  
      function translatePoints(d) {
          var lonlatPx = projection(d.lonlat);
          return lonlatPx ?
              'translate(' + lonlatPx[0] + ',' + lonlatPx[1] + ')' :
               null;
      }
  
      function hideShowPoints(d) {
          return projection.isLonLatOverEdges(d.lonlat) ? 'none' : null;
      }
  
      for(k in this.basePaths) {
          this.basePaths[k].attr('d', pathFn);
      }
  
      for(k in this.dataPaths) {
          this.dataPaths[k].attr('d', function(d) { return pathFn(d.geojson); });
      }
  
      for(k in this.dataPoints) {
          this.dataPoints[k]
              .attr('display', hideShowPoints)
              .attr('transform', translatePoints);
      }
  };
  
  // Helper that wraps d3.geo[/* projection name /*]() which:
  //
  // - adds 'fitExtent' (available in d3 v4)
  // - adds 'getPath', 'getBounds' convenience methods
  // - scopes logic related to 'clipAngle'
  // - adds 'isLonLatOverEdges' method
  // - sets projection precision
  // - sets methods that aren't always defined depending
  //   on the projection type to a dummy 'd3-esque' function,
  //
  // This wrapper alleviates subsequent code of (many) annoying if-statements.
  function getProjection(geoLayout) {
      var projLayout = geoLayout.projection;
      var projType = projLayout.type;
  
      var projection = d3.geo[constants.projNames[projType]]();
  
      var clipAngle = geoLayout._isClipped ?
          constants.lonaxisSpan[projType] / 2 :
          null;
  
      var methods = ['center', 'rotate', 'parallels', 'clipExtent'];
      var dummyFn = function(_) { return _ ? projection : []; };
  
      for(var i = 0; i < methods.length; i++) {
          var m = methods[i];
          if(typeof projection[m] !== 'function') {
              projection[m] = dummyFn;
          }
      }
  
      projection.isLonLatOverEdges = function(lonlat) {
          if(projection(lonlat) === null) {
              return true;
          }
  
          if(clipAngle) {
              var r = projection.rotate();
              var angle = d3.geo.distance(lonlat, [-r[0], -r[1]]);
              var maxAngle = clipAngle * Math.PI / 180;
              return angle > maxAngle;
          } else {
              return false;
          }
      };
  
      projection.getPath = function() {
          return d3.geo.path().projection(projection);
      };
  
      projection.getBounds = function(object) {
          return projection.getPath().bounds(object);
      };
  
      // adapted from d3 v4:
      // https://github.com/d3/d3-geo/blob/master/src/projection/fit.js
      projection.fitExtent = function(extent, object) {
          var w = extent[1][0] - extent[0][0];
          var h = extent[1][1] - extent[0][1];
          var clip = projection.clipExtent && projection.clipExtent();
  
          projection
              .scale(150)
              .translate([0, 0]);
  
          if(clip) projection.clipExtent(null);
  
          var b = projection.getBounds(object);
          var k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1]));
          var x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2;
          var y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
  
          if(clip) projection.clipExtent(clip);
  
          return projection
              .scale(k * 150)
              .translate([x, y]);
      };
  
      projection.precision(constants.precision);
  
      if(clipAngle) {
          projection.clipAngle(clipAngle - constants.clipPad);
      }
  
      return projection;
  }
  
  function makeGraticule(axisName, geoLayout, fullLayout) {
      // equivalent to the d3 "ε"
      var epsilon = 1e-6;
      // same as the geoGraticule default
      var precision = 2.5;
  
      var axLayout = geoLayout[axisName];
      var scopeDefaults = constants.scopeDefaults[geoLayout.scope];
      var rng;
      var oppRng;
      var coordFn;
  
      if(axisName === 'lonaxis') {
          rng = scopeDefaults.lonaxisRange;
          oppRng = scopeDefaults.lataxisRange;
          coordFn = function(v, l) { return [v, l]; };
      } else if(axisName === 'lataxis') {
          rng = scopeDefaults.lataxisRange;
          oppRng = scopeDefaults.lonaxisRange;
          coordFn = function(v, l) { return [l, v]; };
      }
  
      var dummyAx = {
          type: 'linear',
          range: [rng[0], rng[1] - epsilon],
          tick0: axLayout.tick0,
          dtick: axLayout.dtick
      };
  
      Axes.setConvert(dummyAx, fullLayout);
      var vals = Axes.calcTicks(dummyAx);
  
      // remove duplicate on antimeridian
      if(!geoLayout.isScoped && axisName === 'lonaxis') {
          vals.pop();
      }
  
      var len = vals.length;
      var coords = new Array(len);
  
      for(var i = 0; i < len; i++) {
          var v = vals[i].x;
          var line = coords[i] = [];
          for(var l = oppRng[0]; l < oppRng[1] + precision; l += precision) {
              line.push(coordFn(v, l));
          }
      }
  
      return {
          type: 'MultiLineString',
          coordinates: coords
      };
  }
  
  // Returns polygon GeoJSON corresponding to lon/lat range box
  // with well-defined direction
  //
  // Note that clipPad padding is added around range to avoid aliasing.
  function makeRangeBox(lon, lat) {
      var clipPad = constants.clipPad;
      var lon0 = lon[0] + clipPad;
      var lon1 = lon[1] - clipPad;
      var lat0 = lat[0] + clipPad;
      var lat1 = lat[1] - clipPad;
  
      // to cross antimeridian w/o ambiguity
      if(lon0 > 0 && lon1 < 0) lon1 += 360;
  
      var dlon4 = (lon1 - lon0) / 4;
  
      return {
          type: 'Polygon',
          coordinates: [[
              [lon0, lat0],
              [lon0, lat1],
              [lon0 + dlon4, lat1],
              [lon0 + 2 * dlon4, lat1],
              [lon0 + 3 * dlon4, lat1],
              [lon1, lat1],
              [lon1, lat0],
              [lon1 - dlon4, lat0],
              [lon1 - 2 * dlon4, lat0],
              [lon1 - 3 * dlon4, lat0],
              [lon0, lat0]
          ]]
      };
  }
  
  },{"../../components/color":615,"../../components/dragelement":634,"../../components/drawing":637,"../../components/fx":655,"../../lib":750,"../../lib/geo_location_utils":743,"../../lib/topojson_utils":777,"../../registry":882,"../cartesian/autorange":798,"../cartesian/axes":799,"../cartesian/select":818,"../plots":862,"./constants":829,"./projections":834,"./zoom":835,"d3":169,"topojson-client":551}],831:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var getSubplotCalcData = _dereq_('../../plots/get_data').getSubplotCalcData;
  var counterRegex = _dereq_('../../lib').counterRegex;
  
  var createGeo = _dereq_('./geo');
  
  var GEO = 'geo';
  var counter = counterRegex(GEO);
  
  var attributes = {};
  attributes[GEO] = {
      valType: 'subplotid',
      
      dflt: GEO,
      editType: 'calc',
      
  };
  
  function plotGeo(gd) {
      var fullLayout = gd._fullLayout;
      var calcData = gd.calcdata;
      var geoIds = fullLayout._subplots[GEO];
  
      for(var i = 0; i < geoIds.length; i++) {
          var geoId = geoIds[i];
          var geoCalcData = getSubplotCalcData(calcData, GEO, geoId);
          var geoLayout = fullLayout[geoId];
          var geo = geoLayout._subplot;
  
          if(!geo) {
              geo = createGeo({
                  id: geoId,
                  graphDiv: gd,
                  container: fullLayout._geolayer.node(),
                  topojsonURL: gd._context.topojsonURL,
                  staticPlot: gd._context.staticPlot
              });
  
              fullLayout[geoId]._subplot = geo;
          }
  
          geo.plot(geoCalcData, fullLayout, gd._promises);
      }
  }
  
  function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var oldGeoKeys = oldFullLayout._subplots[GEO] || [];
  
      for(var i = 0; i < oldGeoKeys.length; i++) {
          var oldGeoKey = oldGeoKeys[i];
          var oldGeo = oldFullLayout[oldGeoKey]._subplot;
  
          if(!newFullLayout[oldGeoKey] && !!oldGeo) {
              oldGeo.framework.remove();
              oldGeo.clipDef.remove();
          }
      }
  }
  
  function updateFx(gd) {
      var fullLayout = gd._fullLayout;
      var subplotIds = fullLayout._subplots[GEO];
  
      for(var i = 0; i < subplotIds.length; i++) {
          var subplotLayout = fullLayout[subplotIds[i]];
          var subplotObj = subplotLayout._subplot;
          subplotObj.updateFx(fullLayout, subplotLayout);
      }
  }
  
  module.exports = {
      attr: GEO,
      name: GEO,
      idRoot: GEO,
      idRegex: counter,
      attrRegex: counter,
      attributes: attributes,
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
      plot: plotGeo,
      updateFx: updateFx,
      clean: clean
  };
  
  },{"../../lib":750,"../../plots/get_data":836,"./geo":830,"./layout_attributes":832,"./layout_defaults":833}],832:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorAttrs = _dereq_('../../components/color/attributes');
  var domainAttrs = _dereq_('../domain').attributes;
  var constants = _dereq_('./constants');
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var geoAxesAttrs = {
      range: {
          valType: 'info_array',
          
          items: [
              {valType: 'number'},
              {valType: 'number'}
          ],
          
      },
      showgrid: {
          valType: 'boolean',
          
          dflt: false,
          
      },
      tick0: {
          valType: 'number',
          
          dflt: 0,
          
      },
      dtick: {
          valType: 'number',
          
          
      },
      gridcolor: {
          valType: 'color',
          
          dflt: colorAttrs.lightLine,
          
      },
      gridwidth: {
          valType: 'number',
          
          min: 0,
          dflt: 1,
          
      }
  };
  
  var attrs = module.exports = overrideAll({
      domain: domainAttrs({name: 'geo'}, {
          
      }),
  
      fitbounds: {
          valType: 'enumerated',
          values: [false, 'locations', 'geojson'],
          dflt: false,
          
          editType: 'plot',
          
      },
  
      resolution: {
          valType: 'enumerated',
          values: [110, 50],
          
          dflt: 110,
          coerceNumber: true,
          
      },
      scope: {
          valType: 'enumerated',
          
          values: Object.keys(constants.scopeDefaults),
          dflt: 'world',
          
      },
      projection: {
          type: {
              valType: 'enumerated',
              
              values: Object.keys(constants.projNames),
              
          },
          rotation: {
              lon: {
                  valType: 'number',
                  
                  
              },
              lat: {
                  valType: 'number',
                  
                  
              },
              roll: {
                  valType: 'number',
                  
                  
              }
          },
          parallels: {
              valType: 'info_array',
              
              items: [
                  {valType: 'number'},
                  {valType: 'number'}
              ],
              
          },
          scale: {
              valType: 'number',
              
              min: 0,
              dflt: 1,
              
          },
      },
      center: {
          lon: {
              valType: 'number',
              
              
          },
          lat: {
              valType: 'number',
              
              
          }
      },
      visible: {
          valType: 'boolean',
          
          dflt: true,
          
      },
      showcoastlines: {
          valType: 'boolean',
          
          
      },
      coastlinecolor: {
          valType: 'color',
          
          dflt: colorAttrs.defaultLine,
          
      },
      coastlinewidth: {
          valType: 'number',
          
          min: 0,
          dflt: 1,
          
      },
      showland: {
          valType: 'boolean',
          
          dflt: false,
          
      },
      landcolor: {
          valType: 'color',
          
          dflt: constants.landColor,
          
      },
      showocean: {
          valType: 'boolean',
          
          dflt: false,
          
      },
      oceancolor: {
          valType: 'color',
          
          dflt: constants.waterColor,
          
      },
      showlakes: {
          valType: 'boolean',
          
          dflt: false,
          
      },
      lakecolor: {
          valType: 'color',
          
          dflt: constants.waterColor,
          
      },
      showrivers: {
          valType: 'boolean',
          
          dflt: false,
          
      },
      rivercolor: {
          valType: 'color',
          
          dflt: constants.waterColor,
          
      },
      riverwidth: {
          valType: 'number',
          
          min: 0,
          dflt: 1,
          
      },
      showcountries: {
          valType: 'boolean',
          
          
      },
      countrycolor: {
          valType: 'color',
          
          dflt: colorAttrs.defaultLine,
          
      },
      countrywidth: {
          valType: 'number',
          
          min: 0,
          dflt: 1,
          
      },
      showsubunits: {
          valType: 'boolean',
          
          
      },
      subunitcolor: {
          valType: 'color',
          
          dflt: colorAttrs.defaultLine,
          
      },
      subunitwidth: {
          valType: 'number',
          
          min: 0,
          dflt: 1,
          
      },
      showframe: {
          valType: 'boolean',
          
          
      },
      framecolor: {
          valType: 'color',
          
          dflt: colorAttrs.defaultLine,
          
      },
      framewidth: {
          valType: 'number',
          
          min: 0,
          dflt: 1,
          
      },
      bgcolor: {
          valType: 'color',
          
          dflt: colorAttrs.background,
          
      },
      lonaxis: geoAxesAttrs,
      lataxis: geoAxesAttrs
  }, 'plot', 'from-root');
  
  // set uirevision outside of overrideAll so it can be `editType: 'none'`
  attrs.uirevision = {
      valType: 'any',
      
      editType: 'none',
      
  };
  
  },{"../../components/color/attributes":614,"../../plot_api/edit_types":781,"../domain":826,"./constants":829}],833:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var handleSubplotDefaults = _dereq_('../subplot_defaults');
  var getSubplotData = _dereq_('../get_data').getSubplotData;
  
  var constants = _dereq_('./constants');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  var axesNames = constants.axesNames;
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
      handleSubplotDefaults(layoutIn, layoutOut, fullData, {
          type: 'geo',
          attributes: layoutAttributes,
          handleDefaults: handleGeoDefaults,
          fullData: fullData,
          partition: 'y'
      });
  };
  
  function handleGeoDefaults(geoLayoutIn, geoLayoutOut, coerce, opts) {
      var subplotData = getSubplotData(opts.fullData, 'geo', opts.id);
      var traceIndices = subplotData.map(function(t) { return t._expandedIndex; });
  
      var resolution = coerce('resolution');
      var scope = coerce('scope');
      var scopeParams = constants.scopeDefaults[scope];
  
      var projType = coerce('projection.type', scopeParams.projType);
      var isAlbersUsa = geoLayoutOut._isAlbersUsa = projType === 'albers usa';
  
      // no other scopes are allowed for 'albers usa' projection
      if(isAlbersUsa) scope = geoLayoutOut.scope = 'usa';
  
      var isScoped = geoLayoutOut._isScoped = (scope !== 'world');
      var isConic = geoLayoutOut._isConic = projType.indexOf('conic') !== -1;
      var isClipped = geoLayoutOut._isClipped = !!constants.lonaxisSpan[projType];
  
      if(geoLayoutIn.visible === false) {
          // should override template.layout.geo.show* - see issue 4482
  
          // make a copy
          var newTemplate = Lib.extendDeep({}, geoLayoutOut._template);
  
          // override show*
          newTemplate.showcoastlines = false;
          newTemplate.showcountries = false;
          newTemplate.showframe = false;
          newTemplate.showlakes = false;
          newTemplate.showland = false;
          newTemplate.showocean = false;
          newTemplate.showrivers = false;
          newTemplate.showsubunits = false;
          if(newTemplate.lonaxis) newTemplate.lonaxis.showgrid = false;
          if(newTemplate.lataxis) newTemplate.lataxis.showgrid = false;
  
          // set ref to copy
          geoLayoutOut._template = newTemplate;
      }
      var visible = coerce('visible');
  
      var show;
      for(var i = 0; i < axesNames.length; i++) {
          var axisName = axesNames[i];
          var dtickDflt = [30, 10][i];
          var rangeDflt;
  
          if(isScoped) {
              rangeDflt = scopeParams[axisName + 'Range'];
          } else {
              var dfltSpans = constants[axisName + 'Span'];
              var hSpan = (dfltSpans[projType] || dfltSpans['*']) / 2;
              var rot = coerce(
                  'projection.rotation.' + axisName.substr(0, 3),
                  scopeParams.projRotate[i]
              );
              rangeDflt = [rot - hSpan, rot + hSpan];
          }
  
          var range = coerce(axisName + '.range', rangeDflt);
          coerce(axisName + '.tick0');
          coerce(axisName + '.dtick', dtickDflt);
  
          show = coerce(axisName + '.showgrid', !visible ? false : undefined);
          if(show) {
              coerce(axisName + '.gridcolor');
              coerce(axisName + '.gridwidth');
          }
  
          // mock axis for autorange computations
          geoLayoutOut[axisName]._ax = {
              type: 'linear',
              _id: axisName.slice(0, 3),
              _traceIndices: traceIndices,
              setScale: Lib.identity,
              c2l: Lib.identity,
              r2l: Lib.identity,
              autorange: true,
              range: range.slice(),
              _m: 1,
              _input: {}
          };
      }
  
      var lonRange = geoLayoutOut.lonaxis.range;
      var latRange = geoLayoutOut.lataxis.range;
  
      // to cross antimeridian w/o ambiguity
      var lon0 = lonRange[0];
      var lon1 = lonRange[1];
      if(lon0 > 0 && lon1 < 0) lon1 += 360;
  
      var centerLon = (lon0 + lon1) / 2;
      var projLon;
  
      if(!isAlbersUsa) {
          var dfltProjRotate = isScoped ? scopeParams.projRotate : [centerLon, 0, 0];
  
          projLon = coerce('projection.rotation.lon', dfltProjRotate[0]);
          coerce('projection.rotation.lat', dfltProjRotate[1]);
          coerce('projection.rotation.roll', dfltProjRotate[2]);
  
          show = coerce('showcoastlines', !isScoped && visible);
          if(show) {
              coerce('coastlinecolor');
              coerce('coastlinewidth');
          }
  
          show = coerce('showocean', !visible ? false : undefined);
          if(show) coerce('oceancolor');
      }
  
      var centerLonDflt;
      var centerLatDflt;
  
      if(isAlbersUsa) {
          // 'albers usa' does not have a 'center',
          // these values were found using via:
          //   projection.invert([geoLayout.center.lon, geoLayoutIn.center.lat])
          centerLonDflt = -96.6;
          centerLatDflt = 38.7;
      } else {
          centerLonDflt = isScoped ? centerLon : projLon;
          centerLatDflt = (latRange[0] + latRange[1]) / 2;
      }
  
      coerce('center.lon', centerLonDflt);
      coerce('center.lat', centerLatDflt);
  
      if(isConic) {
          var dfltProjParallels = scopeParams.projParallels || [0, 60];
          coerce('projection.parallels', dfltProjParallels);
      }
  
      coerce('projection.scale');
  
      show = coerce('showland', !visible ? false : undefined);
      if(show) coerce('landcolor');
  
      show = coerce('showlakes', !visible ? false : undefined);
      if(show) coerce('lakecolor');
  
      show = coerce('showrivers', !visible ? false : undefined);
      if(show) {
          coerce('rivercolor');
          coerce('riverwidth');
      }
  
      show = coerce('showcountries', isScoped && scope !== 'usa' && visible);
      if(show) {
          coerce('countrycolor');
          coerce('countrywidth');
      }
  
      if(scope === 'usa' || (scope === 'north america' && resolution === 50)) {
          // Only works for:
          //   USA states at 110m
          //   USA states + Canada provinces at 50m
          coerce('showsubunits', visible);
          coerce('subunitcolor');
          coerce('subunitwidth');
      }
  
      if(!isScoped) {
          // Does not work in non-world scopes
          show = coerce('showframe', visible);
          if(show) {
              coerce('framecolor');
              coerce('framewidth');
          }
      }
  
      coerce('bgcolor');
  
      var fitBounds = coerce('fitbounds');
  
      // clear attributes that will get auto-filled later
      if(fitBounds) {
          delete geoLayoutOut.projection.scale;
  
          if(isScoped) {
              delete geoLayoutOut.center.lon;
              delete geoLayoutOut.center.lat;
          } else if(isClipped) {
              delete geoLayoutOut.center.lon;
              delete geoLayoutOut.center.lat;
              delete geoLayoutOut.projection.rotation.lon;
              delete geoLayoutOut.projection.rotation.lat;
              delete geoLayoutOut.lonaxis.range;
              delete geoLayoutOut.lataxis.range;
          } else {
              delete geoLayoutOut.center.lon;
              delete geoLayoutOut.center.lat;
              delete geoLayoutOut.projection.rotation.lon;
          }
      }
  }
  
  },{"../../lib":750,"../get_data":836,"../subplot_defaults":876,"./constants":829,"./layout_attributes":832}],834:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  /*
   * Generated by https://github.com/etpinard/d3-geo-projection-picker
   *
   * which is hand-picks projection from https://github.com/d3/d3-geo-projection
   *
   * into a CommonJS require-able module.
   */
  
  'use strict';
  
  /* eslint-disable */
  
  function addProjectionsToD3(d3) {
    d3.geo.project = function(object, projection) {
      var stream = projection.stream;
      if (!stream) throw new Error("not yet supported");
      return (object && d3_geo_projectObjectType.hasOwnProperty(object.type) ? d3_geo_projectObjectType[object.type] : d3_geo_projectGeometry)(object, stream);
    };
    function d3_geo_projectFeature(object, stream) {
      return {
        type: "Feature",
        id: object.id,
        properties: object.properties,
        geometry: d3_geo_projectGeometry(object.geometry, stream)
      };
    }
    function d3_geo_projectGeometry(geometry, stream) {
      if (!geometry) return null;
      if (geometry.type === "GeometryCollection") return {
        type: "GeometryCollection",
        geometries: object.geometries.map(function(geometry) {
          return d3_geo_projectGeometry(geometry, stream);
        })
      };
      if (!d3_geo_projectGeometryType.hasOwnProperty(geometry.type)) return null;
      var sink = d3_geo_projectGeometryType[geometry.type];
      d3.geo.stream(geometry, stream(sink));
      return sink.result();
    }
    var d3_geo_projectObjectType = {
      Feature: d3_geo_projectFeature,
      FeatureCollection: function(object, stream) {
        return {
          type: "FeatureCollection",
          features: object.features.map(function(feature) {
            return d3_geo_projectFeature(feature, stream);
          })
        };
      }
    };
    var d3_geo_projectPoints = [], d3_geo_projectLines = [];
    var d3_geo_projectPoint = {
      point: function(x, y) {
        d3_geo_projectPoints.push([ x, y ]);
      },
      result: function() {
        var result = !d3_geo_projectPoints.length ? null : d3_geo_projectPoints.length < 2 ? {
          type: "Point",
          coordinates: d3_geo_projectPoints[0]
        } : {
          type: "MultiPoint",
          coordinates: d3_geo_projectPoints
        };
        d3_geo_projectPoints = [];
        return result;
      }
    };
    var d3_geo_projectLine = {
      lineStart: d3_geo_projectNoop,
      point: function(x, y) {
        d3_geo_projectPoints.push([ x, y ]);
      },
      lineEnd: function() {
        if (d3_geo_projectPoints.length) d3_geo_projectLines.push(d3_geo_projectPoints),
        d3_geo_projectPoints = [];
      },
      result: function() {
        var result = !d3_geo_projectLines.length ? null : d3_geo_projectLines.length < 2 ? {
          type: "LineString",
          coordinates: d3_geo_projectLines[0]
        } : {
          type: "MultiLineString",
          coordinates: d3_geo_projectLines
        };
        d3_geo_projectLines = [];
        return result;
      }
    };
    var d3_geo_projectPolygon = {
      polygonStart: d3_geo_projectNoop,
      lineStart: d3_geo_projectNoop,
      point: function(x, y) {
        d3_geo_projectPoints.push([ x, y ]);
      },
      lineEnd: function() {
        var n = d3_geo_projectPoints.length;
        if (n) {
          do d3_geo_projectPoints.push(d3_geo_projectPoints[0].slice()); while (++n < 4);
          d3_geo_projectLines.push(d3_geo_projectPoints), d3_geo_projectPoints = [];
        }
      },
      polygonEnd: d3_geo_projectNoop,
      result: function() {
        if (!d3_geo_projectLines.length) return null;
        var polygons = [], holes = [];
        d3_geo_projectLines.forEach(function(ring) {
          if (d3_geo_projectClockwise(ring)) polygons.push([ ring ]); else holes.push(ring);
        });
        holes.forEach(function(hole) {
          var point = hole[0];
          polygons.some(function(polygon) {
            if (d3_geo_projectContains(polygon[0], point)) {
              polygon.push(hole);
              return true;
            }
          }) || polygons.push([ hole ]);
        });
        d3_geo_projectLines = [];
        return !polygons.length ? null : polygons.length > 1 ? {
          type: "MultiPolygon",
          coordinates: polygons
        } : {
          type: "Polygon",
          coordinates: polygons[0]
        };
      }
    };
    var d3_geo_projectGeometryType = {
      Point: d3_geo_projectPoint,
      MultiPoint: d3_geo_projectPoint,
      LineString: d3_geo_projectLine,
      MultiLineString: d3_geo_projectLine,
      Polygon: d3_geo_projectPolygon,
      MultiPolygon: d3_geo_projectPolygon,
      Sphere: d3_geo_projectPolygon
    };
    function d3_geo_projectNoop() {}
    function d3_geo_projectClockwise(ring) {
      if ((n = ring.length) < 4) return false;
      var i = 0, n, area = ring[n - 1][1] * ring[0][0] - ring[n - 1][0] * ring[0][1];
      while (++i < n) area += ring[i - 1][1] * ring[i][0] - ring[i - 1][0] * ring[i][1];
      return area <= 0;
    }
    function d3_geo_projectContains(ring, point) {
      var x = point[0], y = point[1], contains = false;
      for (var i = 0, n = ring.length, j = n - 1; i < n; j = i++) {
        var pi = ring[i], xi = pi[0], yi = pi[1], pj = ring[j], xj = pj[0], yj = pj[1];
        if (yi > y ^ yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi) contains = !contains;
      }
      return contains;
    }
    var ε = 1e-6, ε2 = ε * ε, π = Math.PI, halfπ = π / 2, sqrtπ = Math.sqrt(π), radians = π / 180, degrees = 180 / π;
    function sinci(x) {
      return x ? x / Math.sin(x) : 1;
    }
    function sgn(x) {
      return x > 0 ? 1 : x < 0 ? -1 : 0;
    }
    function asin(x) {
      return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
    }
    function acos(x) {
      return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
    }
    function asqrt(x) {
      return x > 0 ? Math.sqrt(x) : 0;
    }
    var projection = d3.geo.projection, projectionMutator = d3.geo.projectionMutator;
    d3.geo.interrupt = function(project) {
      var lobes = [ [ [ [ -π, 0 ], [ 0, halfπ ], [ π, 0 ] ] ], [ [ [ -π, 0 ], [ 0, -halfπ ], [ π, 0 ] ] ] ];
      var bounds;
      function forward(λ, φ) {
        var sign = φ < 0 ? -1 : +1, hemilobes = lobes[+(φ < 0)];
        for (var i = 0, n = hemilobes.length - 1; i < n && λ > hemilobes[i][2][0]; ++i) ;
        var coordinates = project(λ - hemilobes[i][1][0], φ);
        coordinates[0] += project(hemilobes[i][1][0], sign * φ > sign * hemilobes[i][0][1] ? hemilobes[i][0][1] : φ)[0];
        return coordinates;
      }
      function reset() {
        bounds = lobes.map(function(hemilobes) {
          return hemilobes.map(function(lobe) {
            var x0 = project(lobe[0][0], lobe[0][1])[0], x1 = project(lobe[2][0], lobe[2][1])[0], y0 = project(lobe[1][0], lobe[0][1])[1], y1 = project(lobe[1][0], lobe[1][1])[1], t;
            if (y0 > y1) t = y0, y0 = y1, y1 = t;
            return [ [ x0, y0 ], [ x1, y1 ] ];
          });
        });
      }
      if (project.invert) forward.invert = function(x, y) {
        var hemibounds = bounds[+(y < 0)], hemilobes = lobes[+(y < 0)];
        for (var i = 0, n = hemibounds.length; i < n; ++i) {
          var b = hemibounds[i];
          if (b[0][0] <= x && x < b[1][0] && b[0][1] <= y && y < b[1][1]) {
            var coordinates = project.invert(x - project(hemilobes[i][1][0], 0)[0], y);
            coordinates[0] += hemilobes[i][1][0];
            return pointEqual(forward(coordinates[0], coordinates[1]), [ x, y ]) ? coordinates : null;
          }
        }
      };
      var projection = d3.geo.projection(forward), stream_ = projection.stream;
      projection.stream = function(stream) {
        var rotate = projection.rotate(), rotateStream = stream_(stream), sphereStream = (projection.rotate([ 0, 0 ]),
        stream_(stream));
        projection.rotate(rotate);
        rotateStream.sphere = function() {
          d3.geo.stream(sphere(), sphereStream);
        };
        return rotateStream;
      };
      projection.lobes = function(_) {
        if (!arguments.length) return lobes.map(function(lobes) {
          return lobes.map(function(lobe) {
            return [ [ lobe[0][0] * 180 / π, lobe[0][1] * 180 / π ], [ lobe[1][0] * 180 / π, lobe[1][1] * 180 / π ], [ lobe[2][0] * 180 / π, lobe[2][1] * 180 / π ] ];
          });
        });
        lobes = _.map(function(lobes) {
          return lobes.map(function(lobe) {
            return [ [ lobe[0][0] * π / 180, lobe[0][1] * π / 180 ], [ lobe[1][0] * π / 180, lobe[1][1] * π / 180 ], [ lobe[2][0] * π / 180, lobe[2][1] * π / 180 ] ];
          });
        });
        reset();
        return projection;
      };
      function sphere() {
        var ε = 1e-6, coordinates = [];
        for (var i = 0, n = lobes[0].length; i < n; ++i) {
          var lobe = lobes[0][i], λ0 = lobe[0][0] * 180 / π, φ0 = lobe[0][1] * 180 / π, φ1 = lobe[1][1] * 180 / π, λ2 = lobe[2][0] * 180 / π, φ2 = lobe[2][1] * 180 / π;
          coordinates.push(resample([ [ λ0 + ε, φ0 + ε ], [ λ0 + ε, φ1 - ε ], [ λ2 - ε, φ1 - ε ], [ λ2 - ε, φ2 + ε ] ], 30));
        }
        for (var i = lobes[1].length - 1; i >= 0; --i) {
          var lobe = lobes[1][i], λ0 = lobe[0][0] * 180 / π, φ0 = lobe[0][1] * 180 / π, φ1 = lobe[1][1] * 180 / π, λ2 = lobe[2][0] * 180 / π, φ2 = lobe[2][1] * 180 / π;
          coordinates.push(resample([ [ λ2 - ε, φ2 - ε ], [ λ2 - ε, φ1 + ε ], [ λ0 + ε, φ1 + ε ], [ λ0 + ε, φ0 - ε ] ], 30));
        }
        return {
          type: "Polygon",
          coordinates: [ d3.merge(coordinates) ]
        };
      }
      function resample(coordinates, m) {
        var i = -1, n = coordinates.length, p0 = coordinates[0], p1, dx, dy, resampled = [];
        while (++i < n) {
          p1 = coordinates[i];
          dx = (p1[0] - p0[0]) / m;
          dy = (p1[1] - p0[1]) / m;
          for (var j = 0; j < m; ++j) resampled.push([ p0[0] + j * dx, p0[1] + j * dy ]);
          p0 = p1;
        }
        resampled.push(p1);
        return resampled;
      }
      function pointEqual(a, b) {
        return Math.abs(a[0] - b[0]) < ε && Math.abs(a[1] - b[1]) < ε;
      }
      return projection;
    };
    function eckert4(λ, φ) {
      var k = (2 + halfπ) * Math.sin(φ);
      φ /= 2;
      for (var i = 0, δ = Infinity; i < 10 && Math.abs(δ) > ε; i++) {
        var cosφ = Math.cos(φ);
        φ -= δ = (φ + Math.sin(φ) * (cosφ + 2) - k) / (2 * cosφ * (1 + cosφ));
      }
      return [ 2 / Math.sqrt(π * (4 + π)) * λ * (1 + Math.cos(φ)), 2 * Math.sqrt(π / (4 + π)) * Math.sin(φ) ];
    }
    eckert4.invert = function(x, y) {
      var A = .5 * y * Math.sqrt((4 + π) / π), k = asin(A), c = Math.cos(k);
      return [ x / (2 / Math.sqrt(π * (4 + π)) * (1 + c)), asin((k + A * (c + 2)) / (2 + halfπ)) ];
    };
    (d3.geo.eckert4 = function() {
      return projection(eckert4);
    }).raw = eckert4;
    var hammerAzimuthalEqualArea = d3.geo.azimuthalEqualArea.raw;
    function hammer(A, B) {
      if (arguments.length < 2) B = A;
      if (B === 1) return hammerAzimuthalEqualArea;
      if (B === Infinity) return hammerQuarticAuthalic;
      function forward(λ, φ) {
        var coordinates = hammerAzimuthalEqualArea(λ / B, φ);
        coordinates[0] *= A;
        return coordinates;
      }
      forward.invert = function(x, y) {
        var coordinates = hammerAzimuthalEqualArea.invert(x / A, y);
        coordinates[0] *= B;
        return coordinates;
      };
      return forward;
    }
    function hammerProjection() {
      var B = 2, m = projectionMutator(hammer), p = m(B);
      p.coefficient = function(_) {
        if (!arguments.length) return B;
        return m(B = +_);
      };
      return p;
    }
    function hammerQuarticAuthalic(λ, φ) {
      return [ λ * Math.cos(φ) / Math.cos(φ /= 2), 2 * Math.sin(φ) ];
    }
    hammerQuarticAuthalic.invert = function(x, y) {
      var φ = 2 * asin(y / 2);
      return [ x * Math.cos(φ / 2) / Math.cos(φ), φ ];
    };
    (d3.geo.hammer = hammerProjection).raw = hammer;
    function kavrayskiy7(λ, φ) {
      return [ 3 * λ / (2 * π) * Math.sqrt(π * π / 3 - φ * φ), φ ];
    }
    kavrayskiy7.invert = function(x, y) {
      return [ 2 / 3 * π * x / Math.sqrt(π * π / 3 - y * y), y ];
    };
    (d3.geo.kavrayskiy7 = function() {
      return projection(kavrayskiy7);
    }).raw = kavrayskiy7;
    function miller(λ, φ) {
      return [ λ, 1.25 * Math.log(Math.tan(π / 4 + .4 * φ)) ];
    }
    miller.invert = function(x, y) {
      return [ x, 2.5 * Math.atan(Math.exp(.8 * y)) - .625 * π ];
    };
    (d3.geo.miller = function() {
      return projection(miller);
    }).raw = miller;
    function mollweideBromleyθ(Cp) {
      return function(θ) {
        var Cpsinθ = Cp * Math.sin(θ), i = 30, δ;
        do θ -= δ = (θ + Math.sin(θ) - Cpsinθ) / (1 + Math.cos(θ)); while (Math.abs(δ) > ε && --i > 0);
        return θ / 2;
      };
    }
    function mollweideBromley(Cx, Cy, Cp) {
      var θ = mollweideBromleyθ(Cp);
      function forward(λ, φ) {
        return [ Cx * λ * Math.cos(φ = θ(φ)), Cy * Math.sin(φ) ];
      }
      forward.invert = function(x, y) {
        var θ = asin(y / Cy);
        return [ x / (Cx * Math.cos(θ)), asin((2 * θ + Math.sin(2 * θ)) / Cp) ];
      };
      return forward;
    }
    var mollweideθ = mollweideBromleyθ(π), mollweide = mollweideBromley(Math.SQRT2 / halfπ, Math.SQRT2, π);
    (d3.geo.mollweide = function() {
      return projection(mollweide);
    }).raw = mollweide;
    function naturalEarth(λ, φ) {
      var φ2 = φ * φ, φ4 = φ2 * φ2;
      return [ λ * (.8707 - .131979 * φ2 + φ4 * (-.013791 + φ4 * (.003971 * φ2 - .001529 * φ4))), φ * (1.007226 + φ2 * (.015085 + φ4 * (-.044475 + .028874 * φ2 - .005916 * φ4))) ];
    }
    naturalEarth.invert = function(x, y) {
      var φ = y, i = 25, δ;
      do {
        var φ2 = φ * φ, φ4 = φ2 * φ2;
        φ -= δ = (φ * (1.007226 + φ2 * (.015085 + φ4 * (-.044475 + .028874 * φ2 - .005916 * φ4))) - y) / (1.007226 + φ2 * (.015085 * 3 + φ4 * (-.044475 * 7 + .028874 * 9 * φ2 - .005916 * 11 * φ4)));
      } while (Math.abs(δ) > ε && --i > 0);
      return [ x / (.8707 + (φ2 = φ * φ) * (-.131979 + φ2 * (-.013791 + φ2 * φ2 * φ2 * (.003971 - .001529 * φ2)))), φ ];
    };
    (d3.geo.naturalEarth = function() {
      return projection(naturalEarth);
    }).raw = naturalEarth;
    var robinsonConstants = [ [ .9986, -.062 ], [ 1, 0 ], [ .9986, .062 ], [ .9954, .124 ], [ .99, .186 ], [ .9822, .248 ], [ .973, .31 ], [ .96, .372 ], [ .9427, .434 ], [ .9216, .4958 ], [ .8962, .5571 ], [ .8679, .6176 ], [ .835, .6769 ], [ .7986, .7346 ], [ .7597, .7903 ], [ .7186, .8435 ], [ .6732, .8936 ], [ .6213, .9394 ], [ .5722, .9761 ], [ .5322, 1 ] ];
    robinsonConstants.forEach(function(d) {
      d[1] *= 1.0144;
    });
    function robinson(λ, φ) {
      var i = Math.min(18, Math.abs(φ) * 36 / π), i0 = Math.floor(i), di = i - i0, ax = (k = robinsonConstants[i0])[0], ay = k[1], bx = (k = robinsonConstants[++i0])[0], by = k[1], cx = (k = robinsonConstants[Math.min(19, ++i0)])[0], cy = k[1], k;
      return [ λ * (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2), (φ > 0 ? halfπ : -halfπ) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) ];
    }
    robinson.invert = function(x, y) {
      var yy = y / halfπ, φ = yy * 90, i = Math.min(18, Math.abs(φ / 5)), i0 = Math.max(0, Math.floor(i));
      do {
        var ay = robinsonConstants[i0][1], by = robinsonConstants[i0 + 1][1], cy = robinsonConstants[Math.min(19, i0 + 2)][1], u = cy - ay, v = cy - 2 * by + ay, t = 2 * (Math.abs(yy) - by) / u, c = v / u, di = t * (1 - c * t * (1 - 2 * c * t));
        if (di >= 0 || i0 === 1) {
          φ = (y >= 0 ? 5 : -5) * (di + i);
          var j = 50, δ;
          do {
            i = Math.min(18, Math.abs(φ) / 5);
            i0 = Math.floor(i);
            di = i - i0;
            ay = robinsonConstants[i0][1];
            by = robinsonConstants[i0 + 1][1];
            cy = robinsonConstants[Math.min(19, i0 + 2)][1];
            φ -= (δ = (y >= 0 ? halfπ : -halfπ) * (by + di * (cy - ay) / 2 + di * di * (cy - 2 * by + ay) / 2) - y) * degrees;
          } while (Math.abs(δ) > ε2 && --j > 0);
          break;
        }
      } while (--i0 >= 0);
      var ax = robinsonConstants[i0][0], bx = robinsonConstants[i0 + 1][0], cx = robinsonConstants[Math.min(19, i0 + 2)][0];
      return [ x / (bx + di * (cx - ax) / 2 + di * di * (cx - 2 * bx + ax) / 2), φ * radians ];
    };
    (d3.geo.robinson = function() {
      return projection(robinson);
    }).raw = robinson;
    function sinusoidal(λ, φ) {
      return [ λ * Math.cos(φ), φ ];
    }
    sinusoidal.invert = function(x, y) {
      return [ x / Math.cos(y), y ];
    };
    (d3.geo.sinusoidal = function() {
      return projection(sinusoidal);
    }).raw = sinusoidal;
    function aitoff(λ, φ) {
      var cosφ = Math.cos(φ), sinciα = sinci(acos(cosφ * Math.cos(λ /= 2)));
      return [ 2 * cosφ * Math.sin(λ) * sinciα, Math.sin(φ) * sinciα ];
    }
    aitoff.invert = function(x, y) {
      if (x * x + 4 * y * y > π * π + ε) return;
      var λ = x, φ = y, i = 25;
      do {
        var sinλ = Math.sin(λ), sinλ_2 = Math.sin(λ / 2), cosλ_2 = Math.cos(λ / 2), sinφ = Math.sin(φ), cosφ = Math.cos(φ), sin_2φ = Math.sin(2 * φ), sin2φ = sinφ * sinφ, cos2φ = cosφ * cosφ, sin2λ_2 = sinλ_2 * sinλ_2, C = 1 - cos2φ * cosλ_2 * cosλ_2, E = C ? acos(cosφ * cosλ_2) * Math.sqrt(F = 1 / C) : F = 0, F, fx = 2 * E * cosφ * sinλ_2 - x, fy = E * sinφ - y, δxδλ = F * (cos2φ * sin2λ_2 + E * cosφ * cosλ_2 * sin2φ), δxδφ = F * (.5 * sinλ * sin_2φ - E * 2 * sinφ * sinλ_2), δyδλ = F * .25 * (sin_2φ * sinλ_2 - E * sinφ * cos2φ * sinλ), δyδφ = F * (sin2φ * cosλ_2 + E * sin2λ_2 * cosφ), denominator = δxδφ * δyδλ - δyδφ * δxδλ;
        if (!denominator) break;
        var δλ = (fy * δxδφ - fx * δyδφ) / denominator, δφ = (fx * δyδλ - fy * δxδλ) / denominator;
        λ -= δλ, φ -= δφ;
      } while ((Math.abs(δλ) > ε || Math.abs(δφ) > ε) && --i > 0);
      return [ λ, φ ];
    };
    (d3.geo.aitoff = function() {
      return projection(aitoff);
    }).raw = aitoff;
    function winkel3(λ, φ) {
      var coordinates = aitoff(λ, φ);
      return [ (coordinates[0] + λ / halfπ) / 2, (coordinates[1] + φ) / 2 ];
    }
    winkel3.invert = function(x, y) {
      var λ = x, φ = y, i = 25;
      do {
        var cosφ = Math.cos(φ), sinφ = Math.sin(φ), sin_2φ = Math.sin(2 * φ), sin2φ = sinφ * sinφ, cos2φ = cosφ * cosφ, sinλ = Math.sin(λ), cosλ_2 = Math.cos(λ / 2), sinλ_2 = Math.sin(λ / 2), sin2λ_2 = sinλ_2 * sinλ_2, C = 1 - cos2φ * cosλ_2 * cosλ_2, E = C ? acos(cosφ * cosλ_2) * Math.sqrt(F = 1 / C) : F = 0, F, fx = .5 * (2 * E * cosφ * sinλ_2 + λ / halfπ) - x, fy = .5 * (E * sinφ + φ) - y, δxδλ = .5 * F * (cos2φ * sin2λ_2 + E * cosφ * cosλ_2 * sin2φ) + .5 / halfπ, δxδφ = F * (sinλ * sin_2φ / 4 - E * sinφ * sinλ_2), δyδλ = .125 * F * (sin_2φ * sinλ_2 - E * sinφ * cos2φ * sinλ), δyδφ = .5 * F * (sin2φ * cosλ_2 + E * sin2λ_2 * cosφ) + .5, denominator = δxδφ * δyδλ - δyδφ * δxδλ, δλ = (fy * δxδφ - fx * δyδφ) / denominator, δφ = (fx * δyδλ - fy * δxδλ) / denominator;
        λ -= δλ, φ -= δφ;
      } while ((Math.abs(δλ) > ε || Math.abs(δφ) > ε) && --i > 0);
      return [ λ, φ ];
    };
    (d3.geo.winkel3 = function() {
      return projection(winkel3);
    }).raw = winkel3;
  }
  
  module.exports = addProjectionsToD3;
  
  },{}],835:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  
  var radians = Math.PI / 180;
  var degrees = 180 / Math.PI;
  var zoomstartStyle = {cursor: 'pointer'};
  var zoomendStyle = {cursor: 'auto'};
  
  function createGeoZoom(geo, geoLayout) {
      var projection = geo.projection;
      var zoomConstructor;
  
      if(geoLayout._isScoped) {
          zoomConstructor = zoomScoped;
      } else if(geoLayout._isClipped) {
          zoomConstructor = zoomClipped;
      } else {
          zoomConstructor = zoomNonClipped;
      }
  
      // TODO add a conic-specific zoom
  
      return zoomConstructor(geo, projection);
  }
  
  module.exports = createGeoZoom;
  
  // common to all zoom types
  function initZoom(geo, projection) {
      return d3.behavior.zoom()
          .translate(projection.translate())
          .scale(projection.scale());
  }
  
  // sync zoom updates with user & full layout
  function sync(geo, projection, cb) {
      var id = geo.id;
      var gd = geo.graphDiv;
      var layout = gd.layout;
      var userOpts = layout[id];
      var fullLayout = gd._fullLayout;
      var fullOpts = fullLayout[id];
  
      var preGUI = {};
      var eventData = {};
  
      function set(propStr, val) {
          preGUI[id + '.' + propStr] = Lib.nestedProperty(userOpts, propStr).get();
          Registry.call('_storeDirectGUIEdit', layout, fullLayout._preGUI, preGUI);
  
          var fullNp = Lib.nestedProperty(fullOpts, propStr);
          if(fullNp.get() !== val) {
              fullNp.set(val);
              Lib.nestedProperty(userOpts, propStr).set(val);
              eventData[id + '.' + propStr] = val;
          }
      }
  
      cb(set);
      set('projection.scale', projection.scale() / geo.fitScale);
      set('fitbounds', false);
      gd.emit('plotly_relayout', eventData);
  }
  
  // zoom for scoped projections
  function zoomScoped(geo, projection) {
      var zoom = initZoom(geo, projection);
  
      function handleZoomstart() {
          d3.select(this).style(zoomstartStyle);
      }
  
      function handleZoom() {
          projection
              .scale(d3.event.scale)
              .translate(d3.event.translate);
          geo.render();
  
          var center = projection.invert(geo.midPt);
          geo.graphDiv.emit('plotly_relayouting', {
              'geo.projection.scale': projection.scale() / geo.fitScale,
              'geo.center.lon': center[0],
              'geo.center.lat': center[1]
          });
      }
  
      function syncCb(set) {
          var center = projection.invert(geo.midPt);
  
          set('center.lon', center[0]);
          set('center.lat', center[1]);
      }
  
      function handleZoomend() {
          d3.select(this).style(zoomendStyle);
          sync(geo, projection, syncCb);
      }
  
      zoom
          .on('zoomstart', handleZoomstart)
          .on('zoom', handleZoom)
          .on('zoomend', handleZoomend);
  
      return zoom;
  }
  
  // zoom for non-clipped projections
  function zoomNonClipped(geo, projection) {
      var zoom = initZoom(geo, projection);
  
      var INSIDETOLORANCEPXS = 2;
  
      var mouse0, rotate0, translate0, lastRotate, zoomPoint,
          mouse1, rotate1, point1, didZoom;
  
      function position(x) { return projection.invert(x); }
  
      function outside(x) {
          var pos = position(x);
          if(!pos) return true;
  
          var pt = projection(pos);
          return (
              Math.abs(pt[0] - x[0]) > INSIDETOLORANCEPXS ||
              Math.abs(pt[1] - x[1]) > INSIDETOLORANCEPXS
          );
      }
  
      function handleZoomstart() {
          d3.select(this).style(zoomstartStyle);
  
          mouse0 = d3.mouse(this);
          rotate0 = projection.rotate();
          translate0 = projection.translate();
          lastRotate = rotate0;
          zoomPoint = position(mouse0);
      }
  
      function handleZoom() {
          mouse1 = d3.mouse(this);
  
          if(outside(mouse0)) {
              zoom.scale(projection.scale());
              zoom.translate(projection.translate());
              return;
          }
  
          projection.scale(d3.event.scale);
          projection.translate([translate0[0], d3.event.translate[1]]);
  
          if(!zoomPoint) {
              mouse0 = mouse1;
              zoomPoint = position(mouse0);
          } else if(position(mouse1)) {
              point1 = position(mouse1);
              rotate1 = [lastRotate[0] + (point1[0] - zoomPoint[0]), rotate0[1], rotate0[2]];
              projection.rotate(rotate1);
              lastRotate = rotate1;
          }
  
          didZoom = true;
          geo.render();
  
          var rotate = projection.rotate();
          var center = projection.invert(geo.midPt);
          geo.graphDiv.emit('plotly_relayouting', {
              'geo.projection.scale': projection.scale() / geo.fitScale,
              'geo.center.lon': center[0],
              'geo.center.lat': center[1],
              'geo.projection.rotation.lon': -rotate[0]
          });
      }
  
      function handleZoomend() {
          d3.select(this).style(zoomendStyle);
          if(didZoom) sync(geo, projection, syncCb);
      }
  
      function syncCb(set) {
          var rotate = projection.rotate();
          var center = projection.invert(geo.midPt);
  
          set('projection.rotation.lon', -rotate[0]);
          set('center.lon', center[0]);
          set('center.lat', center[1]);
      }
  
      zoom
          .on('zoomstart', handleZoomstart)
          .on('zoom', handleZoom)
          .on('zoomend', handleZoomend);
  
      return zoom;
  }
  
  // zoom for clipped projections
  // inspired by https://www.jasondavies.com/maps/d3.geo.zoom.js
  function zoomClipped(geo, projection) {
      var view = {r: projection.rotate(), k: projection.scale()};
      var zoom = initZoom(geo, projection);
      var event = d3eventDispatch(zoom, 'zoomstart', 'zoom', 'zoomend');
      var zooming = 0;
      var zoomOn = zoom.on;
  
      var zoomPoint;
  
      zoom.on('zoomstart', function() {
          d3.select(this).style(zoomstartStyle);
  
          var mouse0 = d3.mouse(this);
          var rotate0 = projection.rotate();
          var lastRotate = rotate0;
          var translate0 = projection.translate();
          var q = quaternionFromEuler(rotate0);
  
          zoomPoint = position(projection, mouse0);
  
          zoomOn.call(zoom, 'zoom', function() {
              var mouse1 = d3.mouse(this);
  
              projection.scale(view.k = d3.event.scale);
  
              if(!zoomPoint) {
                  // if no zoomPoint, the mouse wasn't over the actual geography yet
                  // maybe this point is the start... we'll find out next time!
                  mouse0 = mouse1;
                  zoomPoint = position(projection, mouse0);
              } else if(position(projection, mouse1)) {
                  // check if the point is on the map
                  // if not, don't do anything new but scale
                  // if it is, then we can assume between will exist below
                  // so we don't need the 'bank' function, whatever that is.
  
                  // go back to original projection temporarily
                  // except for scale... that's kind of independent?
                  projection
                      .rotate(rotate0)
                      .translate(translate0);
  
                  // calculate the new params
                  var point1 = position(projection, mouse1);
                  var between = rotateBetween(zoomPoint, point1);
                  var newEuler = eulerFromQuaternion(multiply(q, between));
                  var rotateAngles = view.r = unRoll(newEuler, zoomPoint, lastRotate);
  
                  if(!isFinite(rotateAngles[0]) || !isFinite(rotateAngles[1]) ||
                     !isFinite(rotateAngles[2])) {
                      rotateAngles = lastRotate;
                  }
  
                  // update the projection
                  projection.rotate(rotateAngles);
                  lastRotate = rotateAngles;
              }
  
              zoomed(event.of(this, arguments));
          });
  
          zoomstarted(event.of(this, arguments));
      })
      .on('zoomend', function() {
          d3.select(this).style(zoomendStyle);
          zoomOn.call(zoom, 'zoom', null);
          zoomended(event.of(this, arguments));
          sync(geo, projection, syncCb);
      })
      .on('zoom.redraw', function() {
          geo.render();
  
          var _rotate = projection.rotate();
          geo.graphDiv.emit('plotly_relayouting', {
              'geo.projection.scale': projection.scale() / geo.fitScale,
              'geo.projection.rotation.lon': -_rotate[0],
              'geo.projection.rotation.lat': -_rotate[1]
          });
      });
  
      function zoomstarted(dispatch) {
          if(!zooming++) dispatch({type: 'zoomstart'});
      }
  
      function zoomed(dispatch) {
          dispatch({type: 'zoom'});
      }
  
      function zoomended(dispatch) {
          if(!--zooming) dispatch({type: 'zoomend'});
      }
  
      function syncCb(set) {
          var _rotate = projection.rotate();
          set('projection.rotation.lon', -_rotate[0]);
          set('projection.rotation.lat', -_rotate[1]);
      }
  
      return d3.rebind(zoom, event, 'on');
  }
  
  // -- helper functions for zoomClipped
  
  function position(projection, point) {
      var spherical = projection.invert(point);
      return spherical && isFinite(spherical[0]) && isFinite(spherical[1]) && cartesian(spherical);
  }
  
  function quaternionFromEuler(euler) {
      var lambda = 0.5 * euler[0] * radians;
      var phi = 0.5 * euler[1] * radians;
      var gamma = 0.5 * euler[2] * radians;
      var sinLambda = Math.sin(lambda);
      var cosLambda = Math.cos(lambda);
      var sinPhi = Math.sin(phi);
      var cosPhi = Math.cos(phi);
      var sinGamma = Math.sin(gamma);
      var cosGamma = Math.cos(gamma);
      return [
          cosLambda * cosPhi * cosGamma + sinLambda * sinPhi * sinGamma,
          sinLambda * cosPhi * cosGamma - cosLambda * sinPhi * sinGamma,
          cosLambda * sinPhi * cosGamma + sinLambda * cosPhi * sinGamma,
          cosLambda * cosPhi * sinGamma - sinLambda * sinPhi * cosGamma
      ];
  }
  
  function multiply(a, b) {
      var a0 = a[0];
      var a1 = a[1];
      var a2 = a[2];
      var a3 = a[3];
      var b0 = b[0];
      var b1 = b[1];
      var b2 = b[2];
      var b3 = b[3];
      return [
          a0 * b0 - a1 * b1 - a2 * b2 - a3 * b3,
          a0 * b1 + a1 * b0 + a2 * b3 - a3 * b2,
          a0 * b2 - a1 * b3 + a2 * b0 + a3 * b1,
          a0 * b3 + a1 * b2 - a2 * b1 + a3 * b0
      ];
  }
  
  function rotateBetween(a, b) {
      if(!a || !b) return;
      var axis = cross(a, b);
      var norm = Math.sqrt(dot(axis, axis));
      var halfgamma = 0.5 * Math.acos(Math.max(-1, Math.min(1, dot(a, b))));
      var k = Math.sin(halfgamma) / norm;
      return norm && [Math.cos(halfgamma), axis[2] * k, -axis[1] * k, axis[0] * k];
  }
  
  // input:
  //   rotateAngles: a calculated set of Euler angles
  //   pt: a point (cartesian in 3-space) to keep fixed
  //   roll0: an initial roll, to be preserved
  // output:
  //   a set of Euler angles that preserve the projection of pt
  //     but set roll (output[2]) equal to roll0
  //     note that this doesn't depend on the particular projection,
  //     just on the rotation angles
  function unRoll(rotateAngles, pt, lastRotate) {
      // calculate the fixed point transformed by these Euler angles
      // but with the desired roll undone
      var ptRotated = rotateCartesian(pt, 2, rotateAngles[0]);
      ptRotated = rotateCartesian(ptRotated, 1, rotateAngles[1]);
      ptRotated = rotateCartesian(ptRotated, 0, rotateAngles[2] - lastRotate[2]);
  
      var x = pt[0];
      var y = pt[1];
      var z = pt[2];
      var f = ptRotated[0];
      var g = ptRotated[1];
      var h = ptRotated[2];
  
      // the following essentially solves:
      // ptRotated = rotateCartesian(rotateCartesian(pt, 2, newYaw), 1, newPitch)
      // for newYaw and newPitch, as best it can
      var theta = Math.atan2(y, x) * degrees;
      var a = Math.sqrt(x * x + y * y);
      var b;
      var newYaw1;
  
      if(Math.abs(g) > a) {
          newYaw1 = (g > 0 ? 90 : -90) - theta;
          b = 0;
      } else {
          newYaw1 = Math.asin(g / a) * degrees - theta;
          b = Math.sqrt(a * a - g * g);
      }
  
      var newYaw2 = 180 - newYaw1 - 2 * theta;
      var newPitch1 = (Math.atan2(h, f) - Math.atan2(z, b)) * degrees;
      var newPitch2 = (Math.atan2(h, f) - Math.atan2(z, -b)) * degrees;
  
      // which is closest to lastRotate[0,1]: newYaw/Pitch or newYaw2/Pitch2?
      var dist1 = angleDistance(lastRotate[0], lastRotate[1], newYaw1, newPitch1);
      var dist2 = angleDistance(lastRotate[0], lastRotate[1], newYaw2, newPitch2);
  
      if(dist1 <= dist2) return [newYaw1, newPitch1, lastRotate[2]];
      else return [newYaw2, newPitch2, lastRotate[2]];
  }
  
  function angleDistance(yaw0, pitch0, yaw1, pitch1) {
      var dYaw = angleMod(yaw1 - yaw0);
      var dPitch = angleMod(pitch1 - pitch0);
      return Math.sqrt(dYaw * dYaw + dPitch * dPitch);
  }
  
  // reduce an angle in degrees to [-180,180]
  function angleMod(angle) {
      return (angle % 360 + 540) % 360 - 180;
  }
  
  // rotate a cartesian vector
  // axis is 0 (x), 1 (y), or 2 (z)
  // angle is in degrees
  function rotateCartesian(vector, axis, angle) {
      var angleRads = angle * radians;
      var vectorOut = vector.slice();
      var ax1 = (axis === 0) ? 1 : 0;
      var ax2 = (axis === 2) ? 1 : 2;
      var cosa = Math.cos(angleRads);
      var sina = Math.sin(angleRads);
  
      vectorOut[ax1] = vector[ax1] * cosa - vector[ax2] * sina;
      vectorOut[ax2] = vector[ax2] * cosa + vector[ax1] * sina;
  
      return vectorOut;
  }
  function eulerFromQuaternion(q) {
      return [
          Math.atan2(2 * (q[0] * q[1] + q[2] * q[3]), 1 - 2 * (q[1] * q[1] + q[2] * q[2])) * degrees,
          Math.asin(Math.max(-1, Math.min(1, 2 * (q[0] * q[2] - q[3] * q[1])))) * degrees,
          Math.atan2(2 * (q[0] * q[3] + q[1] * q[2]), 1 - 2 * (q[2] * q[2] + q[3] * q[3])) * degrees
      ];
  }
  
  function cartesian(spherical) {
      var lambda = spherical[0] * radians;
      var phi = spherical[1] * radians;
      var cosPhi = Math.cos(phi);
      return [
          cosPhi * Math.cos(lambda),
          cosPhi * Math.sin(lambda),
          Math.sin(phi)
      ];
  }
  
  function dot(a, b) {
      var s = 0;
      for(var i = 0, n = a.length; i < n; ++i) s += a[i] * b[i];
      return s;
  }
  
  function cross(a, b) {
      return [
          a[1] * b[2] - a[2] * b[1],
          a[2] * b[0] - a[0] * b[2],
          a[0] * b[1] - a[1] * b[0]
      ];
  }
  
  // Like d3.dispatch, but for custom events abstracting native UI events. These
  // events have a target component (such as a brush), a target element (such as
  // the svg:g element containing the brush) and the standard arguments `d` (the
  // target element's data) and `i` (the selection index of the target element).
  function d3eventDispatch(target) {
      var i = 0;
      var n = arguments.length;
      var argumentz = [];
  
      while(++i < n) argumentz.push(arguments[i]);
  
      var dispatch = d3.dispatch.apply(null, argumentz);
  
      // Creates a dispatch context for the specified `thiz` (typically, the target
      // DOM element that received the source event) and `argumentz` (typically, the
      // data `d` and index `i` of the target element). The returned function can be
      // used to dispatch an event to any registered listeners; the function takes a
      // single argument as input, being the event to dispatch. The event must have
      // a "type" attribute which corresponds to a type registered in the
      // constructor. This context will automatically populate the "sourceEvent" and
      // "target" attributes of the event, as well as setting the `d3.event` global
      // for the duration of the notification.
      dispatch.of = function(thiz, argumentz) {
          return function(e1) {
              var e0;
              try {
                  e0 = e1.sourceEvent = d3.event;
                  e1.target = target;
                  d3.event = e1;
                  dispatch[e1.type].apply(thiz, argumentz);
              } finally {
                  d3.event = e0;
              }
          };
      };
  
      return dispatch;
  }
  
  },{"../../lib":750,"../../registry":882,"d3":169}],836:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../registry');
  var SUBPLOT_PATTERN = _dereq_('./cartesian/constants').SUBPLOT_PATTERN;
  
  /**
   * Get calcdata trace(s) associated with a given subplot
   *
   * @param {array} calcData: as in gd.calcdata
   * @param {string} type: subplot type
   * @param {string} subplotId: subplot id to look for
   *
   * @return {array} array of calcdata traces
   */
  exports.getSubplotCalcData = function(calcData, type, subplotId) {
      var basePlotModule = Registry.subplotsRegistry[type];
      if(!basePlotModule) return [];
  
      var attr = basePlotModule.attr;
      var subplotCalcData = [];
  
      for(var i = 0; i < calcData.length; i++) {
          var calcTrace = calcData[i];
          var trace = calcTrace[0].trace;
  
          if(trace[attr] === subplotId) subplotCalcData.push(calcTrace);
      }
  
      return subplotCalcData;
  };
  /**
   * Get calcdata trace(s) that can be plotted with a given module
   * NOTE: this isn't necessarily just exactly matching trace type,
   * if multiple trace types use the same plotting routine, they will be
   * collected here.
   * In order to not plot the same thing multiple times, we return two arrays,
   * the calcdata we *will* plot with this module, and the ones we *won't*
   *
   * @param {array} calcdata: as in gd.calcdata
   * @param {object|string|fn} arg1:
   *  the plotting module, or its name, or its plot method
   *
   * @return {array[array]} [foundCalcdata, remainingCalcdata]
   */
  exports.getModuleCalcData = function(calcdata, arg1) {
      var moduleCalcData = [];
      var remainingCalcData = [];
  
      var plotMethod;
      if(typeof arg1 === 'string') {
          plotMethod = Registry.getModule(arg1).plot;
      } else if(typeof arg1 === 'function') {
          plotMethod = arg1;
      } else {
          plotMethod = arg1.plot;
      }
      if(!plotMethod) {
          return [moduleCalcData, calcdata];
      }
  
      for(var i = 0; i < calcdata.length; i++) {
          var cd = calcdata[i];
          var trace = cd[0].trace;
          // N.B.
          // - 'legendonly' traces do not make it past here
          // - skip over 'visible' traces that got trimmed completely during calc transforms
          if(trace.visible !== true || trace._length === 0) continue;
  
          // group calcdata trace not by 'module' (as the name of this function
          // would suggest), but by 'module plot method' so that if some traces
          // share the same module plot method (e.g. bar and histogram), we
          // only call it one!
          if(trace._module.plot === plotMethod) {
              moduleCalcData.push(cd);
          } else {
              remainingCalcData.push(cd);
          }
      }
  
      return [moduleCalcData, remainingCalcData];
  };
  
  /**
   * Get the data trace(s) associated with a given subplot.
   *
   * @param {array} data  plotly full data array.
   * @param {string} type subplot type to look for.
   * @param {string} subplotId subplot id to look for.
   *
   * @return {array} list of trace objects.
   *
   */
  exports.getSubplotData = function getSubplotData(data, type, subplotId) {
      if(!Registry.subplotsRegistry[type]) return [];
  
      var attr = Registry.subplotsRegistry[type].attr;
      var subplotData = [];
      var trace, subplotX, subplotY;
  
      if(type === 'gl2d') {
          var spmatch = subplotId.match(SUBPLOT_PATTERN);
          subplotX = 'x' + spmatch[1];
          subplotY = 'y' + spmatch[2];
      }
  
      for(var i = 0; i < data.length; i++) {
          trace = data[i];
  
          if(type === 'gl2d' && Registry.traceIs(trace, 'gl2d')) {
              if(trace[attr[0]] === subplotX && trace[attr[1]] === subplotY) {
                  subplotData.push(trace);
              }
          } else {
              if(trace[attr] === subplotId) subplotData.push(trace);
          }
      }
  
      return subplotData;
  };
  
  },{"../registry":882,"./cartesian/constants":805}],837:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var mouseChange = _dereq_('mouse-change');
  var mouseWheel = _dereq_('mouse-wheel');
  var mouseOffset = _dereq_('mouse-event-offset');
  var cartesianConstants = _dereq_('../cartesian/constants');
  var hasPassive = _dereq_('has-passive-events');
  
  module.exports = createCamera;
  
  function Camera2D(element, plot) {
      this.element = element;
      this.plot = plot;
      this.mouseListener = null;
      this.wheelListener = null;
      this.lastInputTime = Date.now();
      this.lastPos = [0, 0];
      this.boxEnabled = false;
      this.boxInited = false;
      this.boxStart = [0, 0];
      this.boxEnd = [0, 0];
      this.dragStart = [0, 0];
  }
  
  
  function createCamera(scene) {
      var element = scene.mouseContainer;
      var plot = scene.glplot;
      var result = new Camera2D(element, plot);
  
      function unSetAutoRange() {
          scene.xaxis.autorange = false;
          scene.yaxis.autorange = false;
      }
  
      function getSubplotConstraint() {
          // note: this assumes we only have one x and one y axis on this subplot
          // when this constraint is lifted this block won't make sense
          var constraints = scene.graphDiv._fullLayout._axisConstraintGroups;
          var xaId = scene.xaxis._id;
          var yaId = scene.yaxis._id;
          for(var i = 0; i < constraints.length; i++) {
              if(constraints[i][xaId] !== -1) {
                  if(constraints[i][yaId] !== -1) return true;
                  break;
              }
          }
          return false;
      }
  
      result.mouseListener = mouseChange(element, handleInteraction);
  
      // enable simple touch interactions
      element.addEventListener('touchstart', function(ev) {
          var xy = mouseOffset(ev.changedTouches[0], element);
          handleInteraction(0, xy[0], xy[1]);
          handleInteraction(1, xy[0], xy[1]);
  
          ev.preventDefault();
      }, hasPassive ? {passive: false} : false);
      element.addEventListener('touchmove', function(ev) {
          ev.preventDefault();
          var xy = mouseOffset(ev.changedTouches[0], element);
          handleInteraction(1, xy[0], xy[1]);
  
          ev.preventDefault();
      }, hasPassive ? {passive: false} : false);
      element.addEventListener('touchend', function(ev) {
          handleInteraction(0, result.lastPos[0], result.lastPos[1]);
  
          ev.preventDefault();
      }, hasPassive ? {passive: false} : false);
  
      function handleInteraction(buttons, x, y) {
          var dataBox = scene.calcDataBox();
          var viewBox = plot.viewBox;
  
          var lastX = result.lastPos[0];
          var lastY = result.lastPos[1];
  
          var MINDRAG = cartesianConstants.MINDRAG * plot.pixelRatio;
          var MINZOOM = cartesianConstants.MINZOOM * plot.pixelRatio;
  
          var dx, dy;
  
          x *= plot.pixelRatio;
          y *= plot.pixelRatio;
  
          // mouseChange gives y about top; convert to about bottom
          y = (viewBox[3] - viewBox[1]) - y;
  
          function updateRange(i0, start, end) {
              var range0 = Math.min(start, end);
              var range1 = Math.max(start, end);
  
              if(range0 !== range1) {
                  dataBox[i0] = range0;
                  dataBox[i0 + 2] = range1;
                  result.dataBox = dataBox;
                  scene.setRanges(dataBox);
              } else {
                  scene.selectBox.selectBox = [0, 0, 1, 1];
                  scene.glplot.setDirty();
              }
          }
  
          switch(scene.fullLayout.dragmode) {
              case 'zoom':
                  if(buttons) {
                      var dataX = x /
                              (viewBox[2] - viewBox[0]) * (dataBox[2] - dataBox[0]) +
                          dataBox[0];
                      var dataY = y /
                              (viewBox[3] - viewBox[1]) * (dataBox[3] - dataBox[1]) +
                          dataBox[1];
  
                      if(!result.boxInited) {
                          result.boxStart[0] = dataX;
                          result.boxStart[1] = dataY;
                          result.dragStart[0] = x;
                          result.dragStart[1] = y;
                      }
  
                      result.boxEnd[0] = dataX;
                      result.boxEnd[1] = dataY;
  
                      // we need to mark the box as initialized right away
                      // so that we can tell the start and end points apart
                      result.boxInited = true;
  
                      // but don't actually enable the box until the cursor moves
                      if(!result.boxEnabled && (
                          result.boxStart[0] !== result.boxEnd[0] ||
                          result.boxStart[1] !== result.boxEnd[1])
                      ) {
                          result.boxEnabled = true;
                      }
  
                      // constrain aspect ratio if the axes require it
                      var smallDx = Math.abs(result.dragStart[0] - x) < MINZOOM;
                      var smallDy = Math.abs(result.dragStart[1] - y) < MINZOOM;
                      if(getSubplotConstraint() && !(smallDx && smallDy)) {
                          dx = result.boxEnd[0] - result.boxStart[0];
                          dy = result.boxEnd[1] - result.boxStart[1];
                          var dydx = (dataBox[3] - dataBox[1]) / (dataBox[2] - dataBox[0]);
  
                          if(Math.abs(dx * dydx) > Math.abs(dy)) {
                              result.boxEnd[1] = result.boxStart[1] +
                                  Math.abs(dx) * dydx * (dy >= 0 ? 1 : -1);
  
                              // gl-select-box clips to the plot area bounds,
                              // which breaks the axis constraint, so don't allow
                              // this box to go out of bounds
                              if(result.boxEnd[1] < dataBox[1]) {
                                  result.boxEnd[1] = dataBox[1];
                                  result.boxEnd[0] = result.boxStart[0] +
                                      (dataBox[1] - result.boxStart[1]) / Math.abs(dydx);
                              } else if(result.boxEnd[1] > dataBox[3]) {
                                  result.boxEnd[1] = dataBox[3];
                                  result.boxEnd[0] = result.boxStart[0] +
                                      (dataBox[3] - result.boxStart[1]) / Math.abs(dydx);
                              }
                          } else {
                              result.boxEnd[0] = result.boxStart[0] +
                                  Math.abs(dy) / dydx * (dx >= 0 ? 1 : -1);
  
                              if(result.boxEnd[0] < dataBox[0]) {
                                  result.boxEnd[0] = dataBox[0];
                                  result.boxEnd[1] = result.boxStart[1] +
                                      (dataBox[0] - result.boxStart[0]) * Math.abs(dydx);
                              } else if(result.boxEnd[0] > dataBox[2]) {
                                  result.boxEnd[0] = dataBox[2];
                                  result.boxEnd[1] = result.boxStart[1] +
                                      (dataBox[2] - result.boxStart[0]) * Math.abs(dydx);
                              }
                          }
                      } else {
                          // otherwise clamp small changes to the origin so we get 1D zoom
  
                          if(smallDx) result.boxEnd[0] = result.boxStart[0];
                          if(smallDy) result.boxEnd[1] = result.boxStart[1];
                      }
                  } else if(result.boxEnabled) {
                      dx = result.boxStart[0] !== result.boxEnd[0];
                      dy = result.boxStart[1] !== result.boxEnd[1];
                      if(dx || dy) {
                          if(dx) {
                              updateRange(0, result.boxStart[0], result.boxEnd[0]);
                              scene.xaxis.autorange = false;
                          }
                          if(dy) {
                              updateRange(1, result.boxStart[1], result.boxEnd[1]);
                              scene.yaxis.autorange = false;
                          }
                          scene.relayoutCallback();
                      } else {
                          scene.glplot.setDirty();
                      }
                      result.boxEnabled = false;
                      result.boxInited = false;
                  } else if(result.boxInited) {
                      // if box was inited but button released then - reset the box
  
                      result.boxInited = false;
                  }
                  break;
  
              case 'pan':
                  result.boxEnabled = false;
                  result.boxInited = false;
  
                  if(buttons) {
                      if(!result.panning) {
                          result.dragStart[0] = x;
                          result.dragStart[1] = y;
                      }
  
                      if(Math.abs(result.dragStart[0] - x) < MINDRAG) x = result.dragStart[0];
                      if(Math.abs(result.dragStart[1] - y) < MINDRAG) y = result.dragStart[1];
  
                      dx = (lastX - x) * (dataBox[2] - dataBox[0]) /
                          (plot.viewBox[2] - plot.viewBox[0]);
                      dy = (lastY - y) * (dataBox[3] - dataBox[1]) /
                          (plot.viewBox[3] - plot.viewBox[1]);
  
                      dataBox[0] += dx;
                      dataBox[2] += dx;
                      dataBox[1] += dy;
                      dataBox[3] += dy;
  
                      scene.setRanges(dataBox);
  
                      result.panning = true;
                      result.lastInputTime = Date.now();
                      unSetAutoRange();
                      scene.cameraChanged();
                      scene.handleAnnotations();
                  } else if(result.panning) {
                      result.panning = false;
                      scene.relayoutCallback();
                  }
                  break;
          }
  
          result.lastPos[0] = x;
          result.lastPos[1] = y;
      }
  
      result.wheelListener = mouseWheel(element, function(dx, dy) {
          if(!scene.scrollZoom) return false;
  
          var dataBox = scene.calcDataBox();
          var viewBox = plot.viewBox;
  
          var lastX = result.lastPos[0];
          var lastY = result.lastPos[1];
  
          var scale = Math.exp(5.0 * dy / (viewBox[3] - viewBox[1]));
  
          var cx = lastX /
                  (viewBox[2] - viewBox[0]) * (dataBox[2] - dataBox[0]) +
              dataBox[0];
          var cy = lastY /
                  (viewBox[3] - viewBox[1]) * (dataBox[3] - dataBox[1]) +
              dataBox[1];
  
          dataBox[0] = (dataBox[0] - cx) * scale + cx;
          dataBox[2] = (dataBox[2] - cx) * scale + cx;
          dataBox[1] = (dataBox[1] - cy) * scale + cy;
          dataBox[3] = (dataBox[3] - cy) * scale + cy;
  
          scene.setRanges(dataBox);
  
          result.lastInputTime = Date.now();
          unSetAutoRange();
          scene.cameraChanged();
          scene.handleAnnotations();
          scene.relayoutCallback();
  
          return true;
      }, true);
  
      return result;
  }
  
  },{"../cartesian/constants":805,"has-passive-events":415,"mouse-change":457,"mouse-event-offset":458,"mouse-wheel":460}],838:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Axes = _dereq_('../cartesian/axes');
  
  var str2RGBArray = _dereq_('../../lib/str2rgbarray');
  
  function Axes2DOptions(scene) {
      this.scene = scene;
      this.gl = scene.gl;
      this.pixelRatio = scene.pixelRatio;
  
      this.screenBox = [0, 0, 1, 1];
      this.viewBox = [0, 0, 1, 1];
      this.dataBox = [-1, -1, 1, 1];
  
      this.borderLineEnable = [false, false, false, false];
      this.borderLineWidth = [1, 1, 1, 1];
      this.borderLineColor = [
          [0, 0, 0, 1],
          [0, 0, 0, 1],
          [0, 0, 0, 1],
          [0, 0, 0, 1]
      ];
  
      this.ticks = [[], []];
      this.tickEnable = [true, true, false, false];
      this.tickPad = [15, 15, 15, 15];
      this.tickAngle = [0, 0, 0, 0];
      this.tickColor = [
          [0, 0, 0, 1],
          [0, 0, 0, 1],
          [0, 0, 0, 1],
          [0, 0, 0, 1]
      ];
      this.tickMarkLength = [0, 0, 0, 0];
      this.tickMarkWidth = [0, 0, 0, 0];
      this.tickMarkColor = [
          [0, 0, 0, 1],
          [0, 0, 0, 1],
          [0, 0, 0, 1],
          [0, 0, 0, 1]
      ];
  
      this.labels = ['x', 'y'];
      this.labelEnable = [true, true, false, false];
      this.labelAngle = [0, Math.PI / 2, 0, 3.0 * Math.PI / 2];
      this.labelPad = [15, 15, 15, 15];
      this.labelSize = [12, 12];
      this.labelFont = ['sans-serif', 'sans-serif'];
      this.labelColor = [
          [0, 0, 0, 1],
          [0, 0, 0, 1],
          [0, 0, 0, 1],
          [0, 0, 0, 1]
      ];
  
      this.title = '';
      this.titleEnable = true;
      this.titleCenter = [0, 0, 0, 0];
      this.titleAngle = 0;
      this.titleColor = [0, 0, 0, 1];
      this.titleFont = 'sans-serif';
      this.titleSize = 18;
  
      this.gridLineEnable = [true, true];
      this.gridLineColor = [
          [0, 0, 0, 0.5],
          [0, 0, 0, 0.5]
      ];
      this.gridLineWidth = [1, 1];
  
      this.zeroLineEnable = [true, true];
      this.zeroLineWidth = [1, 1];
      this.zeroLineColor = [
          [0, 0, 0, 1],
          [0, 0, 0, 1]
      ];
  
      this.borderColor = [0, 0, 0, 0];
      this.backgroundColor = [0, 0, 0, 0];
  
      this.static = this.scene.staticPlot;
  }
  
  var proto = Axes2DOptions.prototype;
  
  var AXES = ['xaxis', 'yaxis'];
  
  proto.merge = function(options) {
      // titles are rendered in SVG
      this.titleEnable = false;
      this.backgroundColor = str2RGBArray(options.plot_bgcolor);
  
      var axisName, ax, axTitle, axMirror;
      var hasAxisInDfltPos, hasAxisInAltrPos, hasSharedAxis, mirrorLines, mirrorTicks;
      var i, j;
  
      for(i = 0; i < 2; ++i) {
          axisName = AXES[i];
          var axisLetter = axisName.charAt(0);
  
          // get options relevant to this subplot,
          // '_name' is e.g. xaxis, xaxis2, yaxis, yaxis4 ...
          ax = options[this.scene[axisName]._name];
  
          axTitle = ax.title.text === this.scene.fullLayout._dfltTitle[axisLetter] ? '' : ax.title.text;
  
          for(j = 0; j <= 2; j += 2) {
              this.labelEnable[i + j] = false;
              this.labels[i + j] = axTitle;
              this.labelColor[i + j] = str2RGBArray(ax.title.font.color);
              this.labelFont[i + j] = ax.title.font.family;
              this.labelSize[i + j] = ax.title.font.size;
              this.labelPad[i + j] = this.getLabelPad(axisName, ax);
  
              this.tickEnable[i + j] = false;
              this.tickColor[i + j] = str2RGBArray((ax.tickfont || {}).color);
              this.tickAngle[i + j] = (ax.tickangle === 'auto') ?
                  0 :
                  Math.PI * -ax.tickangle / 180;
              this.tickPad[i + j] = this.getTickPad(ax);
  
              this.tickMarkLength[i + j] = 0;
              this.tickMarkWidth[i + j] = ax.tickwidth || 0;
              this.tickMarkColor[i + j] = str2RGBArray(ax.tickcolor);
  
              this.borderLineEnable[i + j] = false;
              this.borderLineColor[i + j] = str2RGBArray(ax.linecolor);
              this.borderLineWidth[i + j] = ax.linewidth || 0;
          }
  
          hasSharedAxis = this.hasSharedAxis(ax);
          hasAxisInDfltPos = this.hasAxisInDfltPos(axisName, ax) && !hasSharedAxis;
          hasAxisInAltrPos = this.hasAxisInAltrPos(axisName, ax) && !hasSharedAxis;
  
          axMirror = ax.mirror || false;
          mirrorLines = hasSharedAxis ?
              (String(axMirror).indexOf('all') !== -1) :  // 'all' or 'allticks'
              !!axMirror;                                 // all but false
          mirrorTicks = hasSharedAxis ?
              (axMirror === 'allticks') :
              (String(axMirror).indexOf('ticks') !== -1); // 'ticks' or 'allticks'
  
          // Axis titles and tick labels can only appear of one side of the scene
          //  and are never show on subplots that share existing axes.
  
          if(hasAxisInDfltPos) this.labelEnable[i] = true;
          else if(hasAxisInAltrPos) this.labelEnable[i + 2] = true;
  
          if(hasAxisInDfltPos) this.tickEnable[i] = ax.showticklabels;
          else if(hasAxisInAltrPos) this.tickEnable[i + 2] = ax.showticklabels;
  
          // Grid lines and ticks can appear on both sides of the scene
          //  and can appear on subplot that share existing axes via `ax.mirror`.
  
          if(hasAxisInDfltPos || mirrorLines) this.borderLineEnable[i] = ax.showline;
          if(hasAxisInAltrPos || mirrorLines) this.borderLineEnable[i + 2] = ax.showline;
  
          if(hasAxisInDfltPos || mirrorTicks) this.tickMarkLength[i] = this.getTickMarkLength(ax);
          if(hasAxisInAltrPos || mirrorTicks) this.tickMarkLength[i + 2] = this.getTickMarkLength(ax);
  
          this.gridLineEnable[i] = ax.showgrid;
          this.gridLineColor[i] = str2RGBArray(ax.gridcolor);
          this.gridLineWidth[i] = ax.gridwidth;
  
          this.zeroLineEnable[i] = ax.zeroline;
          this.zeroLineColor[i] = str2RGBArray(ax.zerolinecolor);
          this.zeroLineWidth[i] = ax.zerolinewidth;
      }
  };
  
  // is an axis shared with an already-drawn subplot ?
  proto.hasSharedAxis = function(ax) {
      var scene = this.scene;
      var subplotIds = scene.fullLayout._subplots.gl2d;
      var list = Axes.findSubplotsWithAxis(subplotIds, ax);
  
      // if index === 0, then the subplot is already drawn as subplots
      // are drawn in order.
      return (list.indexOf(scene.id) !== 0);
  };
  
  // has an axis in default position (i.e. bottom/left) ?
  proto.hasAxisInDfltPos = function(axisName, ax) {
      var axSide = ax.side;
  
      if(axisName === 'xaxis') return (axSide === 'bottom');
      else if(axisName === 'yaxis') return (axSide === 'left');
  };
  
  // has an axis in alternate position (i.e. top/right) ?
  proto.hasAxisInAltrPos = function(axisName, ax) {
      var axSide = ax.side;
  
      if(axisName === 'xaxis') return (axSide === 'top');
      else if(axisName === 'yaxis') return (axSide === 'right');
  };
  
  proto.getLabelPad = function(axisName, ax) {
      var offsetBase = 1.5;
      var fontSize = ax.title.font.size;
      var showticklabels = ax.showticklabels;
  
      if(axisName === 'xaxis') {
          return (ax.side === 'top') ?
              -10 + fontSize * (offsetBase + (showticklabels ? 1 : 0)) :
              -10 + fontSize * (offsetBase + (showticklabels ? 0.5 : 0));
      } else if(axisName === 'yaxis') {
          return (ax.side === 'right') ?
              10 + fontSize * (offsetBase + (showticklabels ? 1 : 0.5)) :
              10 + fontSize * (offsetBase + (showticklabels ? 0.5 : 0));
      }
  };
  
  proto.getTickPad = function(ax) {
      return (ax.ticks === 'outside') ? 10 + ax.ticklen : 15;
  };
  
  proto.getTickMarkLength = function(ax) {
      if(!ax.ticks) return 0;
  
      var ticklen = ax.ticklen;
  
      return (ax.ticks === 'inside') ? -ticklen : ticklen;
  };
  
  
  function createAxes2D(scene) {
      return new Axes2DOptions(scene);
  }
  
  module.exports = createAxes2D;
  
  },{"../../lib/str2rgbarray":773,"../cartesian/axes":799}],839:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var Scene2D = _dereq_('./scene2d');
  var layoutGlobalAttrs = _dereq_('../layout_attributes');
  var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
  var constants = _dereq_('../cartesian/constants');
  var Cartesian = _dereq_('../cartesian');
  var fxAttrs = _dereq_('../../components/fx/layout_attributes');
  var getSubplotData = _dereq_('../get_data').getSubplotData;
  
  exports.name = 'gl2d';
  
  exports.attr = ['xaxis', 'yaxis'];
  
  exports.idRoot = ['x', 'y'];
  
  exports.idRegex = constants.idRegex;
  
  exports.attrRegex = constants.attrRegex;
  
  exports.attributes = _dereq_('../cartesian/attributes');
  
  exports.supplyLayoutDefaults = function(layoutIn, layoutOut, fullData) {
      if(!layoutOut._has('cartesian')) {
          Cartesian.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
      }
  };
  
  // gl2d uses svg axis attributes verbatim, but overrides editType
  // this could potentially be just `layoutAttributes` but it would
  // still need special handling somewhere to give it precedence over
  // the svg version when both are in use on one plot
  exports.layoutAttrOverrides = overrideAll(Cartesian.layoutAttributes, 'plot', 'from-root');
  
  // similar overrides for base plot attributes (and those added by components)
  exports.baseLayoutAttrOverrides = overrideAll({
      plot_bgcolor: layoutGlobalAttrs.plot_bgcolor,
      hoverlabel: fxAttrs.hoverlabel
      // dragmode needs calc but only when transitioning TO lasso or select
      // so for now it's left inside _relayout
      // dragmode: fxAttrs.dragmode
  }, 'plot', 'nested');
  
  exports.plot = function plot(gd) {
      var fullLayout = gd._fullLayout;
      var fullData = gd._fullData;
      var subplotIds = fullLayout._subplots.gl2d;
  
      for(var i = 0; i < subplotIds.length; i++) {
          var subplotId = subplotIds[i];
          var subplotObj = fullLayout._plots[subplotId];
          var fullSubplotData = getSubplotData(fullData, 'gl2d', subplotId);
  
          // ref. to corresp. Scene instance
          var scene = subplotObj._scene2d;
  
          // If Scene is not instantiated, create one!
          if(scene === undefined) {
              scene = new Scene2D({
                  id: subplotId,
                  graphDiv: gd,
                  container: gd.querySelector('.gl-container'),
                  staticPlot: gd._context.staticPlot,
                  plotGlPixelRatio: gd._context.plotGlPixelRatio
              },
                  fullLayout
              );
  
              // set ref to Scene instance
              subplotObj._scene2d = scene;
          }
  
          scene.plot(fullSubplotData, gd.calcdata, fullLayout, gd.layout);
      }
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var oldSceneKeys = oldFullLayout._subplots.gl2d || [];
  
      for(var i = 0; i < oldSceneKeys.length; i++) {
          var id = oldSceneKeys[i];
          var oldSubplot = oldFullLayout._plots[id];
  
          // old subplot wasn't gl2d; nothing to do
          if(!oldSubplot._scene2d) continue;
  
          // if no traces are present, delete gl2d subplot
          var subplotData = getSubplotData(newFullData, 'gl2d', id);
          if(subplotData.length === 0) {
              oldSubplot._scene2d.destroy();
              delete oldFullLayout._plots[id];
          }
      }
  
      // since we use cartesian interactions, do cartesian clean
      Cartesian.clean.apply(this, arguments);
  };
  
  exports.drawFramework = function(gd) {
      if(!gd._context.staticPlot) {
          Cartesian.drawFramework(gd);
      }
  };
  
  exports.toSVG = function(gd) {
      var fullLayout = gd._fullLayout;
      var subplotIds = fullLayout._subplots.gl2d;
  
      for(var i = 0; i < subplotIds.length; i++) {
          var subplot = fullLayout._plots[subplotIds[i]];
          var scene = subplot._scene2d;
  
          var imageData = scene.toImage('png');
          var image = fullLayout._glimages.append('svg:image');
  
          image.attr({
              xmlns: xmlnsNamespaces.svg,
              'xlink:href': imageData,
              x: 0,
              y: 0,
              width: '100%',
              height: '100%',
              preserveAspectRatio: 'none'
          });
  
          scene.destroy();
      }
  };
  
  exports.updateFx = function(gd) {
      var fullLayout = gd._fullLayout;
      var subplotIds = fullLayout._subplots.gl2d;
  
      for(var i = 0; i < subplotIds.length; i++) {
          var subplotObj = fullLayout._plots[subplotIds[i]]._scene2d;
          subplotObj.updateFx(fullLayout.dragmode);
      }
  };
  
  },{"../../components/fx/layout_attributes":656,"../../constants/xmlns_namespaces":726,"../../plot_api/edit_types":781,"../cartesian":812,"../cartesian/attributes":797,"../cartesian/constants":805,"../get_data":836,"../layout_attributes":853,"./scene2d":840}],840:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Fx = _dereq_('../../components/fx');
  
  var createPlot2D = _dereq_('gl-plot2d');
  var createSpikes = _dereq_('gl-spikes2d');
  var createSelectBox = _dereq_('gl-select-box');
  var getContext = _dereq_('webgl-context');
  
  var createOptions = _dereq_('./convert');
  var createCamera = _dereq_('./camera');
  var showNoWebGlMsg = _dereq_('../../lib/show_no_webgl_msg');
  var axisConstraints = _dereq_('../cartesian/constraints');
  var enforceAxisConstraints = axisConstraints.enforce;
  var cleanAxisConstraints = axisConstraints.clean;
  var doAutoRange = _dereq_('../cartesian/autorange').doAutoRange;
  
  var dragHelpers = _dereq_('../../components/dragelement/helpers');
  var drawMode = dragHelpers.drawMode;
  var selectMode = dragHelpers.selectMode;
  
  var AXES = ['xaxis', 'yaxis'];
  var STATIC_CANVAS, STATIC_CONTEXT;
  
  var SUBPLOT_PATTERN = _dereq_('../cartesian/constants').SUBPLOT_PATTERN;
  
  
  function Scene2D(options, fullLayout) {
      this.container = options.container;
      this.graphDiv = options.graphDiv;
      this.pixelRatio = options.plotGlPixelRatio || window.devicePixelRatio;
      this.id = options.id;
      this.staticPlot = !!options.staticPlot;
      this.scrollZoom = this.graphDiv._context._scrollZoom.cartesian;
  
      this.fullData = null;
      this.updateRefs(fullLayout);
  
      this.makeFramework();
      if(this.stopped) return;
  
      // update options
      this.glplotOptions = createOptions(this);
      this.glplotOptions.merge(fullLayout);
  
      // create the plot
      this.glplot = createPlot2D(this.glplotOptions);
  
      // create camera
      this.camera = createCamera(this);
  
      // trace set
      this.traces = {};
  
      // create axes spikes
      this.spikes = createSpikes(this.glplot);
  
      this.selectBox = createSelectBox(this.glplot, {
          innerFill: false,
          outerFill: true
      });
  
      // last button state
      this.lastButtonState = 0;
  
      // last pick result
      this.pickResult = null;
  
      // is the mouse over the plot?
      // it's OK if this says true when it's not, so long as
      // when we get a mouseout we set it to false before handling
      this.isMouseOver = true;
  
      // flag to stop render loop
      this.stopped = false;
  
      // redraw the plot
      this.redraw = this.draw.bind(this);
      this.redraw();
  }
  
  module.exports = Scene2D;
  
  var proto = Scene2D.prototype;
  
  proto.makeFramework = function() {
      // create canvas and gl context
      if(this.staticPlot) {
          if(!STATIC_CONTEXT) {
              STATIC_CANVAS = document.createElement('canvas');
  
              STATIC_CONTEXT = getContext({
                  canvas: STATIC_CANVAS,
                  preserveDrawingBuffer: false,
                  premultipliedAlpha: true,
                  antialias: true
              });
  
              if(!STATIC_CONTEXT) {
                  throw new Error('Error creating static canvas/context for image server');
              }
          }
  
          this.canvas = STATIC_CANVAS;
          this.gl = STATIC_CONTEXT;
      } else {
          var liveCanvas = this.container.querySelector('.gl-canvas-focus');
  
          var gl = getContext({
              canvas: liveCanvas,
              preserveDrawingBuffer: true,
              premultipliedAlpha: true
          });
  
          if(!gl) {
              showNoWebGlMsg(this);
              this.stopped = true;
              return;
          }
  
          this.canvas = liveCanvas;
          this.gl = gl;
      }
  
      // position the canvas
      var canvas = this.canvas;
  
      canvas.style.width = '100%';
      canvas.style.height = '100%';
      canvas.style.position = 'absolute';
      canvas.style.top = '0px';
      canvas.style.left = '0px';
      canvas.style['pointer-events'] = 'none';
  
      this.updateSize(canvas);
  
      // create SVG container for hover text
      var svgContainer = this.svgContainer = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'svg');
      svgContainer.style.position = 'absolute';
      svgContainer.style.top = svgContainer.style.left = '0px';
      svgContainer.style.width = svgContainer.style.height = '100%';
      svgContainer.style['z-index'] = 20;
      svgContainer.style['pointer-events'] = 'none';
  
      // create div to catch the mouse event
      var mouseContainer = this.mouseContainer = document.createElement('div');
      mouseContainer.style.position = 'absolute';
      mouseContainer.style['pointer-events'] = 'auto';
  
      this.pickCanvas = this.container.querySelector('.gl-canvas-pick');
  
  
      // append canvas, hover svg and mouse div to container
      var container = this.container;
      container.appendChild(svgContainer);
      container.appendChild(mouseContainer);
  
      var self = this;
      mouseContainer.addEventListener('mouseout', function() {
          self.isMouseOver = false;
          self.unhover();
      });
      mouseContainer.addEventListener('mouseover', function() {
          self.isMouseOver = true;
      });
  };
  
  proto.toImage = function(format) {
      if(!format) format = 'png';
  
      this.stopped = true;
  
      if(this.staticPlot) this.container.appendChild(STATIC_CANVAS);
  
      // update canvas size
      this.updateSize(this.canvas);
  
  
      // grab context and yank out pixels
      var gl = this.glplot.gl;
      var w = gl.drawingBufferWidth;
      var h = gl.drawingBufferHeight;
  
      // force redraw
      gl.clearColor(1, 1, 1, 0);
      gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
      this.glplot.setDirty();
      this.glplot.draw();
  
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  
      var pixels = new Uint8Array(w * h * 4);
      gl.readPixels(0, 0, w, h, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
  
      // flip pixels
      for(var j = 0, k = h - 1; j < k; ++j, --k) {
          for(var i = 0; i < w; ++i) {
              for(var l = 0; l < 4; ++l) {
                  var tmp = pixels[4 * (w * j + i) + l];
                  pixels[4 * (w * j + i) + l] = pixels[4 * (w * k + i) + l];
                  pixels[4 * (w * k + i) + l] = tmp;
              }
          }
      }
  
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
  
      var context = canvas.getContext('2d');
      var imageData = context.createImageData(w, h);
      imageData.data.set(pixels);
      context.putImageData(imageData, 0, 0);
  
      var dataURL;
  
      switch(format) {
          case 'jpeg':
              dataURL = canvas.toDataURL('image/jpeg');
              break;
          case 'webp':
              dataURL = canvas.toDataURL('image/webp');
              break;
          default:
              dataURL = canvas.toDataURL('image/png');
      }
  
      if(this.staticPlot) this.container.removeChild(STATIC_CANVAS);
  
      return dataURL;
  };
  
  proto.updateSize = function(canvas) {
      if(!canvas) canvas = this.canvas;
  
      var pixelRatio = this.pixelRatio;
      var fullLayout = this.fullLayout;
  
      var width = fullLayout.width;
      var height = fullLayout.height;
      var pixelWidth = Math.ceil(pixelRatio * width) |0;
      var pixelHeight = Math.ceil(pixelRatio * height) |0;
  
      // check for resize
      if(canvas.width !== pixelWidth || canvas.height !== pixelHeight) {
          canvas.width = pixelWidth;
          canvas.height = pixelHeight;
      }
  
      return canvas;
  };
  
  proto.computeTickMarks = function() {
      this.xaxis.setScale();
      this.yaxis.setScale();
  
      var nextTicks = [
          Axes.calcTicks(this.xaxis),
          Axes.calcTicks(this.yaxis)
      ];
  
      for(var j = 0; j < 2; ++j) {
          for(var i = 0; i < nextTicks[j].length; ++i) {
              // coercing tick value (may not be a string) to a string
              nextTicks[j][i].text = nextTicks[j][i].text + '';
          }
      }
  
      return nextTicks;
  };
  
  function compareTicks(a, b) {
      for(var i = 0; i < 2; ++i) {
          var aticks = a[i];
          var bticks = b[i];
  
          if(aticks.length !== bticks.length) return true;
  
          for(var j = 0; j < aticks.length; ++j) {
              if(aticks[j].x !== bticks[j].x) return true;
          }
      }
  
      return false;
  }
  
  proto.updateRefs = function(newFullLayout) {
      this.fullLayout = newFullLayout;
  
      var spmatch = this.id.match(SUBPLOT_PATTERN);
      var xaxisName = 'xaxis' + spmatch[1];
      var yaxisName = 'yaxis' + spmatch[2];
  
      this.xaxis = this.fullLayout[xaxisName];
      this.yaxis = this.fullLayout[yaxisName];
  };
  
  proto.relayoutCallback = function() {
      var graphDiv = this.graphDiv;
      var xaxis = this.xaxis;
      var yaxis = this.yaxis;
      var layout = graphDiv.layout;
  
      // make a meaningful value to be passed on to possible 'plotly_relayout' subscriber(s)
      var update = {};
      var xrange = update[xaxis._name + '.range'] = xaxis.range.slice();
      var yrange = update[yaxis._name + '.range'] = yaxis.range.slice();
      update[xaxis._name + '.autorange'] = xaxis.autorange;
      update[yaxis._name + '.autorange'] = yaxis.autorange;
  
      Registry.call('_storeDirectGUIEdit', graphDiv.layout, graphDiv._fullLayout._preGUI, update);
  
      // update the input layout
      var xaIn = layout[xaxis._name];
      xaIn.range = xrange;
      xaIn.autorange = xaxis.autorange;
  
      var yaIn = layout[yaxis._name];
      yaIn.range = yrange;
      yaIn.autorange = yaxis.autorange;
  
      // lastInputTime helps determine which one is the latest input (if async)
      update.lastInputTime = this.camera.lastInputTime;
      graphDiv.emit('plotly_relayout', update);
  };
  
  proto.cameraChanged = function() {
      var camera = this.camera;
  
      this.glplot.setDataBox(this.calcDataBox());
  
      var nextTicks = this.computeTickMarks();
      var curTicks = this.glplotOptions.ticks;
  
      if(compareTicks(nextTicks, curTicks)) {
          this.glplotOptions.ticks = nextTicks;
          this.glplotOptions.dataBox = camera.dataBox;
          this.glplot.update(this.glplotOptions);
          this.handleAnnotations();
      }
  };
  
  proto.handleAnnotations = function() {
      var gd = this.graphDiv;
      var annotations = this.fullLayout.annotations;
  
      for(var i = 0; i < annotations.length; i++) {
          var ann = annotations[i];
  
          if(ann.xref === this.xaxis._id && ann.yref === this.yaxis._id) {
              Registry.getComponentMethod('annotations', 'drawOne')(gd, i);
          }
      }
  };
  
  proto.destroy = function() {
      if(!this.glplot) return;
  
      var traces = this.traces;
  
      if(traces) {
          Object.keys(traces).map(function(key) {
              traces[key].dispose();
              delete traces[key];
          });
      }
  
      this.glplot.dispose();
  
      this.container.removeChild(this.svgContainer);
      this.container.removeChild(this.mouseContainer);
  
      this.fullData = null;
      this.glplot = null;
      this.stopped = true;
      this.camera.mouseListener.enabled = false;
      this.mouseContainer.removeEventListener('wheel', this.camera.wheelListener);
      this.camera = null;
  };
  
  proto.plot = function(fullData, calcData, fullLayout) {
      var glplot = this.glplot;
  
      this.updateRefs(fullLayout);
      this.xaxis.clearCalc();
      this.yaxis.clearCalc();
      this.updateTraces(fullData, calcData);
      this.updateFx(fullLayout.dragmode);
  
      var width = fullLayout.width;
      var height = fullLayout.height;
  
      this.updateSize(this.canvas);
  
      var options = this.glplotOptions;
      options.merge(fullLayout);
      options.screenBox = [0, 0, width, height];
  
      var mockGraphDiv = {_fullLayout: {
          _axisConstraintGroups: this.graphDiv._fullLayout._axisConstraintGroups,
          xaxis: this.xaxis,
          yaxis: this.yaxis
      }};
  
      cleanAxisConstraints(mockGraphDiv, this.xaxis);
      cleanAxisConstraints(mockGraphDiv, this.yaxis);
  
      var size = fullLayout._size;
      var domainX = this.xaxis.domain;
      var domainY = this.yaxis.domain;
  
      options.viewBox = [
          size.l + domainX[0] * size.w,
          size.b + domainY[0] * size.h,
          (width - size.r) - (1 - domainX[1]) * size.w,
          (height - size.t) - (1 - domainY[1]) * size.h
      ];
  
      this.mouseContainer.style.width = size.w * (domainX[1] - domainX[0]) + 'px';
      this.mouseContainer.style.height = size.h * (domainY[1] - domainY[0]) + 'px';
      this.mouseContainer.height = size.h * (domainY[1] - domainY[0]);
      this.mouseContainer.style.left = size.l + domainX[0] * size.w + 'px';
      this.mouseContainer.style.top = size.t + (1 - domainY[1]) * size.h + 'px';
  
      var ax, i;
  
      for(i = 0; i < 2; ++i) {
          ax = this[AXES[i]];
          ax._length = options.viewBox[i + 2] - options.viewBox[i];
  
          doAutoRange(this.graphDiv, ax);
          ax.setScale();
      }
  
      enforceAxisConstraints(mockGraphDiv);
  
      options.ticks = this.computeTickMarks();
  
      options.dataBox = this.calcDataBox();
  
      options.merge(fullLayout);
      glplot.update(options);
  
      // force redraw so that promise is returned when rendering is completed
      this.glplot.draw();
  };
  
  proto.calcDataBox = function() {
      var xaxis = this.xaxis;
      var yaxis = this.yaxis;
      var xrange = xaxis.range;
      var yrange = yaxis.range;
      var xr2l = xaxis.r2l;
      var yr2l = yaxis.r2l;
  
      return [xr2l(xrange[0]), yr2l(yrange[0]), xr2l(xrange[1]), yr2l(yrange[1])];
  };
  
  proto.setRanges = function(dataBox) {
      var xaxis = this.xaxis;
      var yaxis = this.yaxis;
      var xl2r = xaxis.l2r;
      var yl2r = yaxis.l2r;
  
      xaxis.range = [xl2r(dataBox[0]), xl2r(dataBox[2])];
      yaxis.range = [yl2r(dataBox[1]), yl2r(dataBox[3])];
  };
  
  proto.updateTraces = function(fullData, calcData) {
      var traceIds = Object.keys(this.traces);
      var i, j, fullTrace;
  
      this.fullData = fullData;
  
      // remove empty traces
      traceIdLoop:
      for(i = 0; i < traceIds.length; i++) {
          var oldUid = traceIds[i];
          var oldTrace = this.traces[oldUid];
  
          for(j = 0; j < fullData.length; j++) {
              fullTrace = fullData[j];
  
              if(fullTrace.uid === oldUid && fullTrace.type === oldTrace.type) {
                  continue traceIdLoop;
              }
          }
  
          oldTrace.dispose();
          delete this.traces[oldUid];
      }
  
      // update / create trace objects
      for(i = 0; i < fullData.length; i++) {
          fullTrace = fullData[i];
          var calcTrace = calcData[i];
          var traceObj = this.traces[fullTrace.uid];
  
          if(traceObj) traceObj.update(fullTrace, calcTrace);
          else {
              traceObj = fullTrace._module.plot(this, fullTrace, calcTrace);
              this.traces[fullTrace.uid] = traceObj;
          }
      }
  
      // order object per traces
      this.glplot.objects.sort(function(a, b) {
          return a._trace.index - b._trace.index;
      });
  };
  
  proto.updateFx = function(dragmode) {
      // switch to svg interactions in lasso/select mode & shape drawing
      if(selectMode(dragmode) || drawMode(dragmode)) {
          this.pickCanvas.style['pointer-events'] = 'none';
          this.mouseContainer.style['pointer-events'] = 'none';
      } else {
          this.pickCanvas.style['pointer-events'] = 'auto';
          this.mouseContainer.style['pointer-events'] = 'auto';
      }
  
      // set proper cursor
      if(dragmode === 'pan') {
          this.mouseContainer.style.cursor = 'move';
      } else if(dragmode === 'zoom') {
          this.mouseContainer.style.cursor = 'crosshair';
      } else {
          this.mouseContainer.style.cursor = null;
      }
  };
  
  proto.emitPointAction = function(nextSelection, eventType) {
      var uid = nextSelection.trace.uid;
      var ptNumber = nextSelection.pointIndex;
      var trace;
  
      for(var i = 0; i < this.fullData.length; i++) {
          if(this.fullData[i].uid === uid) {
              trace = this.fullData[i];
          }
      }
  
      var pointData = {
          x: nextSelection.traceCoord[0],
          y: nextSelection.traceCoord[1],
          curveNumber: trace.index,
          pointNumber: ptNumber,
          data: trace._input,
          fullData: this.fullData,
          xaxis: this.xaxis,
          yaxis: this.yaxis
      };
  
      Fx.appendArrayPointValue(pointData, trace, ptNumber);
  
      this.graphDiv.emit(eventType, {points: [pointData]});
  };
  
  proto.draw = function() {
      if(this.stopped) return;
  
      requestAnimationFrame(this.redraw);
  
      var glplot = this.glplot;
      var camera = this.camera;
      var mouseListener = camera.mouseListener;
      var mouseUp = this.lastButtonState === 1 && mouseListener.buttons === 0;
      var fullLayout = this.fullLayout;
  
      this.lastButtonState = mouseListener.buttons;
  
      this.cameraChanged();
  
      var x = mouseListener.x * glplot.pixelRatio;
      var y = this.canvas.height - glplot.pixelRatio * mouseListener.y;
  
      var result;
  
      if(camera.boxEnabled && fullLayout.dragmode === 'zoom') {
          this.selectBox.enabled = true;
  
          var selectBox = this.selectBox.selectBox = [
              Math.min(camera.boxStart[0], camera.boxEnd[0]),
              Math.min(camera.boxStart[1], camera.boxEnd[1]),
              Math.max(camera.boxStart[0], camera.boxEnd[0]),
              Math.max(camera.boxStart[1], camera.boxEnd[1])
          ];
  
          // 1D zoom
          for(var i = 0; i < 2; i++) {
              if(camera.boxStart[i] === camera.boxEnd[i]) {
                  selectBox[i] = glplot.dataBox[i];
                  selectBox[i + 2] = glplot.dataBox[i + 2];
              }
          }
  
          glplot.setDirty();
      } else if(!camera.panning && this.isMouseOver) {
          this.selectBox.enabled = false;
  
          var size = fullLayout._size;
          var domainX = this.xaxis.domain;
          var domainY = this.yaxis.domain;
  
          result = glplot.pick(
              (x / glplot.pixelRatio) + size.l + domainX[0] * size.w,
              (y / glplot.pixelRatio) - (size.t + (1 - domainY[1]) * size.h)
          );
  
          var nextSelection = result && result.object._trace.handlePick(result);
  
          if(nextSelection && mouseUp) {
              this.emitPointAction(nextSelection, 'plotly_click');
          }
  
          if(result && result.object._trace.hoverinfo !== 'skip' && fullLayout.hovermode) {
              if(nextSelection && (
                  !this.lastPickResult ||
                  this.lastPickResult.traceUid !== nextSelection.trace.uid ||
                  this.lastPickResult.dataCoord[0] !== nextSelection.dataCoord[0] ||
                  this.lastPickResult.dataCoord[1] !== nextSelection.dataCoord[1])
              ) {
                  var selection = nextSelection;
  
                  this.lastPickResult = {
                      traceUid: nextSelection.trace ? nextSelection.trace.uid : null,
                      dataCoord: nextSelection.dataCoord.slice()
                  };
                  this.spikes.update({ center: result.dataCoord });
  
                  selection.screenCoord = [
                      ((glplot.viewBox[2] - glplot.viewBox[0]) *
                      (result.dataCoord[0] - glplot.dataBox[0]) /
                          (glplot.dataBox[2] - glplot.dataBox[0]) + glplot.viewBox[0]) /
                              glplot.pixelRatio,
                      (this.canvas.height - (glplot.viewBox[3] - glplot.viewBox[1]) *
                      (result.dataCoord[1] - glplot.dataBox[1]) /
                          (glplot.dataBox[3] - glplot.dataBox[1]) - glplot.viewBox[1]) /
                              glplot.pixelRatio
                  ];
  
                  // this needs to happen before the next block that deletes traceCoord data
                  // also it's important to copy, otherwise data is lost by the time event data is read
                  this.emitPointAction(nextSelection, 'plotly_hover');
  
                  var trace = this.fullData[selection.trace.index] || {};
                  var ptNumber = selection.pointIndex;
                  var hoverinfo = Fx.castHoverinfo(trace, fullLayout, ptNumber);
  
                  if(hoverinfo && hoverinfo !== 'all') {
                      var parts = hoverinfo.split('+');
                      if(parts.indexOf('x') === -1) selection.traceCoord[0] = undefined;
                      if(parts.indexOf('y') === -1) selection.traceCoord[1] = undefined;
                      if(parts.indexOf('z') === -1) selection.traceCoord[2] = undefined;
                      if(parts.indexOf('text') === -1) selection.textLabel = undefined;
                      if(parts.indexOf('name') === -1) selection.name = undefined;
                  }
  
                  Fx.loneHover({
                      x: selection.screenCoord[0],
                      y: selection.screenCoord[1],
                      xLabel: this.hoverFormatter('xaxis', selection.traceCoord[0]),
                      yLabel: this.hoverFormatter('yaxis', selection.traceCoord[1]),
                      zLabel: selection.traceCoord[2],
                      text: selection.textLabel,
                      name: selection.name,
                      color: Fx.castHoverOption(trace, ptNumber, 'bgcolor') || selection.color,
                      borderColor: Fx.castHoverOption(trace, ptNumber, 'bordercolor'),
                      fontFamily: Fx.castHoverOption(trace, ptNumber, 'font.family'),
                      fontSize: Fx.castHoverOption(trace, ptNumber, 'font.size'),
                      fontColor: Fx.castHoverOption(trace, ptNumber, 'font.color'),
                      nameLength: Fx.castHoverOption(trace, ptNumber, 'namelength'),
                      textAlign: Fx.castHoverOption(trace, ptNumber, 'align')
                  }, {
                      container: this.svgContainer,
                      gd: this.graphDiv
                  });
              }
          }
      }
  
      // Remove hover effects if we're not over a point OR
      // if we're zooming or panning (in which case result is not set)
      if(!result) {
          this.unhover();
      }
  
      glplot.draw();
  };
  
  proto.unhover = function() {
      if(this.lastPickResult) {
          this.spikes.update({});
          this.lastPickResult = null;
          this.graphDiv.emit('plotly_unhover');
          Fx.loneUnhover(this.svgContainer);
      }
  };
  
  proto.hoverFormatter = function(axisName, val) {
      if(val === undefined) return undefined;
  
      var axis = this[axisName];
      return Axes.tickText(axis, axis.c2l(val), 'hover').text;
  };
  
  },{"../../components/dragelement/helpers":633,"../../components/fx":655,"../../lib/show_no_webgl_msg":771,"../../plots/cartesian/axes":799,"../../registry":882,"../cartesian/autorange":798,"../cartesian/constants":805,"../cartesian/constraints":806,"./camera":837,"./convert":838,"gl-plot2d":298,"gl-select-box":310,"gl-spikes2d":319,"webgl-context":578}],841:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var fxAttrs = _dereq_('../../components/fx/layout_attributes');
  
  var Scene = _dereq_('./scene');
  var getSubplotData = _dereq_('../get_data').getSubplotData;
  var Lib = _dereq_('../../lib');
  var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
  
  var GL3D = 'gl3d';
  var SCENE = 'scene';
  
  
  exports.name = GL3D;
  
  exports.attr = SCENE;
  
  exports.idRoot = SCENE;
  
  exports.idRegex = exports.attrRegex = Lib.counterRegex('scene');
  
  exports.attributes = _dereq_('./layout/attributes');
  
  exports.layoutAttributes = _dereq_('./layout/layout_attributes');
  
  exports.baseLayoutAttrOverrides = overrideAll({
      hoverlabel: fxAttrs.hoverlabel
  }, 'plot', 'nested');
  
  exports.supplyLayoutDefaults = _dereq_('./layout/defaults');
  
  exports.plot = function plot(gd) {
      var fullLayout = gd._fullLayout;
      var fullData = gd._fullData;
      var sceneIds = fullLayout._subplots[GL3D];
  
      for(var i = 0; i < sceneIds.length; i++) {
          var sceneId = sceneIds[i];
          var fullSceneData = getSubplotData(fullData, GL3D, sceneId);
          var sceneLayout = fullLayout[sceneId];
          var camera = sceneLayout.camera;
          var scene = sceneLayout._scene;
  
          if(!scene) {
              scene = new Scene({
                  id: sceneId,
                  graphDiv: gd,
                  container: gd.querySelector('.gl-container'),
                  staticPlot: gd._context.staticPlot,
                  plotGlPixelRatio: gd._context.plotGlPixelRatio,
                  camera: camera
              },
                  fullLayout
              );
  
              // set ref to Scene instance
              sceneLayout._scene = scene;
          }
  
          // save 'initial' camera view settings for modebar button
          if(!scene.viewInitial) {
              scene.viewInitial = {
                  up: {
                      x: camera.up.x,
                      y: camera.up.y,
                      z: camera.up.z
                  },
                  eye: {
                      x: camera.eye.x,
                      y: camera.eye.y,
                      z: camera.eye.z
                  },
                  center: {
                      x: camera.center.x,
                      y: camera.center.y,
                      z: camera.center.z
                  }
              };
          }
  
          scene.plot(fullSceneData, fullLayout, gd.layout);
      }
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var oldSceneKeys = oldFullLayout._subplots[GL3D] || [];
  
      for(var i = 0; i < oldSceneKeys.length; i++) {
          var oldSceneKey = oldSceneKeys[i];
  
          if(!newFullLayout[oldSceneKey] && !!oldFullLayout[oldSceneKey]._scene) {
              oldFullLayout[oldSceneKey]._scene.destroy();
  
              if(oldFullLayout._infolayer) {
                  oldFullLayout._infolayer
                      .selectAll('.annotation-' + oldSceneKey)
                      .remove();
              }
          }
      }
  };
  
  exports.toSVG = function(gd) {
      var fullLayout = gd._fullLayout;
      var sceneIds = fullLayout._subplots[GL3D];
      var size = fullLayout._size;
  
      for(var i = 0; i < sceneIds.length; i++) {
          var sceneLayout = fullLayout[sceneIds[i]];
          var domain = sceneLayout.domain;
          var scene = sceneLayout._scene;
  
          var imageData = scene.toImage('png');
          var image = fullLayout._glimages.append('svg:image');
  
          image.attr({
              xmlns: xmlnsNamespaces.svg,
              'xlink:href': imageData,
              x: size.l + size.w * domain.x[0],
              y: size.t + size.h * (1 - domain.y[1]),
              width: size.w * (domain.x[1] - domain.x[0]),
              height: size.h * (domain.y[1] - domain.y[0]),
              preserveAspectRatio: 'none'
          });
  
          scene.destroy();
      }
  };
  
  // clean scene ids, 'scene1' -> 'scene'
  exports.cleanId = function cleanId(id) {
      if(!id.match(/^scene[0-9]*$/)) return;
  
      var sceneNum = id.substr(5);
      if(sceneNum === '1') sceneNum = '';
  
      return SCENE + sceneNum;
  };
  
  exports.updateFx = function(gd) {
      var fullLayout = gd._fullLayout;
      var subplotIds = fullLayout._subplots[GL3D];
  
      for(var i = 0; i < subplotIds.length; i++) {
          var subplotObj = fullLayout[subplotIds[i]]._scene;
          subplotObj.updateFx(fullLayout.dragmode, fullLayout.hovermode);
      }
  };
  
  },{"../../components/fx/layout_attributes":656,"../../constants/xmlns_namespaces":726,"../../lib":750,"../../plot_api/edit_types":781,"../get_data":836,"./layout/attributes":842,"./layout/defaults":846,"./layout/layout_attributes":847,"./scene":851}],842:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  module.exports = {
      scene: {
          valType: 'subplotid',
          
          dflt: 'scene',
          editType: 'calc+clearAxisTypes',
          
      }
  };
  
  },{}],843:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Color = _dereq_('../../../components/color');
  var axesAttrs = _dereq_('../../cartesian/layout_attributes');
  var extendFlat = _dereq_('../../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../../plot_api/edit_types').overrideAll;
  
  module.exports = overrideAll({
      visible: axesAttrs.visible,
      showspikes: {
          valType: 'boolean',
          
          dflt: true,
          
      },
      spikesides: {
          valType: 'boolean',
          
          dflt: true,
          
      },
      spikethickness: {
          valType: 'number',
          
          min: 0,
          dflt: 2,
          
      },
      spikecolor: {
          valType: 'color',
          
          dflt: Color.defaultLine,
          
      },
      showbackground: {
          valType: 'boolean',
          
          dflt: false,
          
      },
      backgroundcolor: {
          valType: 'color',
          
          dflt: 'rgba(204, 204, 204, 0.5)',
          
      },
      showaxeslabels: {
          valType: 'boolean',
          
          dflt: true,
          
      },
      color: axesAttrs.color,
      categoryorder: axesAttrs.categoryorder,
      categoryarray: axesAttrs.categoryarray,
      title: {
          text: axesAttrs.title.text,
          font: axesAttrs.title.font
      },
      type: extendFlat({}, axesAttrs.type, {
          values: ['-', 'linear', 'log', 'date', 'category']
      }),
      autorange: axesAttrs.autorange,
      rangemode: axesAttrs.rangemode,
      range: extendFlat({}, axesAttrs.range, {
          items: [
              {valType: 'any', editType: 'plot', impliedEdits: {'^autorange': false}},
              {valType: 'any', editType: 'plot', impliedEdits: {'^autorange': false}}
          ],
          anim: false
      }),
      // ticks
      tickmode: axesAttrs.tickmode,
      nticks: axesAttrs.nticks,
      tick0: axesAttrs.tick0,
      dtick: axesAttrs.dtick,
      tickvals: axesAttrs.tickvals,
      ticktext: axesAttrs.ticktext,
      ticks: axesAttrs.ticks,
      mirror: axesAttrs.mirror,
      ticklen: axesAttrs.ticklen,
      tickwidth: axesAttrs.tickwidth,
      tickcolor: axesAttrs.tickcolor,
      showticklabels: axesAttrs.showticklabels,
      tickfont: axesAttrs.tickfont,
      tickangle: axesAttrs.tickangle,
      tickprefix: axesAttrs.tickprefix,
      showtickprefix: axesAttrs.showtickprefix,
      ticksuffix: axesAttrs.ticksuffix,
      showticksuffix: axesAttrs.showticksuffix,
      showexponent: axesAttrs.showexponent,
      exponentformat: axesAttrs.exponentformat,
      minexponent: axesAttrs.minexponent,
      separatethousands: axesAttrs.separatethousands,
      tickformat: axesAttrs.tickformat,
      tickformatstops: axesAttrs.tickformatstops,
      hoverformat: axesAttrs.hoverformat,
      // lines and grids
      showline: axesAttrs.showline,
      linecolor: axesAttrs.linecolor,
      linewidth: axesAttrs.linewidth,
      showgrid: axesAttrs.showgrid,
      gridcolor: extendFlat({}, axesAttrs.gridcolor,  // shouldn't this be on-par with 2D?
          {dflt: 'rgb(204, 204, 204)'}),
      gridwidth: axesAttrs.gridwidth,
      zeroline: axesAttrs.zeroline,
      zerolinecolor: axesAttrs.zerolinecolor,
      zerolinewidth: axesAttrs.zerolinewidth,
      _deprecated: {
          title: axesAttrs._deprecated.title,
          titlefont: axesAttrs._deprecated.titlefont
      }
  }, 'plot', 'from-root');
  
  },{"../../../components/color":615,"../../../lib/extend":740,"../../../plot_api/edit_types":781,"../../cartesian/layout_attributes":813}],844:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var colorMix = _dereq_('tinycolor2').mix;
  
  var Lib = _dereq_('../../../lib');
  var Template = _dereq_('../../../plot_api/plot_template');
  
  var layoutAttributes = _dereq_('./axis_attributes');
  var handleTypeDefaults = _dereq_('../../cartesian/type_defaults');
  var handleAxisDefaults = _dereq_('../../cartesian/axis_defaults');
  
  var axesNames = ['xaxis', 'yaxis', 'zaxis'];
  
  // TODO: hard-coded lightness fraction based on gridline default colors
  // that differ from other subplot types.
  var gridLightness = 100 * (204 - 0x44) / (255 - 0x44);
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, options) {
      var containerIn, containerOut;
  
      function coerce(attr, dflt) {
          return Lib.coerce(containerIn, containerOut, layoutAttributes, attr, dflt);
      }
  
      for(var j = 0; j < axesNames.length; j++) {
          var axName = axesNames[j];
          containerIn = layoutIn[axName] || {};
  
          containerOut = Template.newContainer(layoutOut, axName);
          containerOut._id = axName[0] + options.scene;
          containerOut._name = axName;
  
          handleTypeDefaults(containerIn, containerOut, coerce, options);
  
          handleAxisDefaults(
              containerIn,
              containerOut,
              coerce,
              {
                  font: options.font,
                  letter: axName[0],
                  data: options.data,
                  showGrid: true,
                  noTickson: true,
                  noTicklabelmode: true,
                  bgColor: options.bgColor,
                  calendar: options.calendar
              },
              options.fullLayout);
  
          coerce('gridcolor', colorMix(containerOut.color, options.bgColor, gridLightness).toRgbString());
          coerce('title.text', axName[0]);  // shouldn't this be on-par with 2D?
  
          containerOut.setScale = Lib.noop;
  
          if(coerce('showspikes')) {
              coerce('spikesides');
              coerce('spikethickness');
              coerce('spikecolor', containerOut.color);
          }
  
          coerce('showaxeslabels');
          if(coerce('showbackground')) coerce('backgroundcolor');
      }
  };
  
  },{"../../../lib":750,"../../../plot_api/plot_template":788,"../../cartesian/axis_defaults":801,"../../cartesian/type_defaults":824,"./axis_attributes":843,"tinycolor2":548}],845:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var str2RgbaArray = _dereq_('../../../lib/str2rgbarray');
  var Lib = _dereq_('../../../lib');
  
  var AXES_NAMES = ['xaxis', 'yaxis', 'zaxis'];
  
  function AxesOptions() {
      this.bounds = [
          [-10, -10, -10],
          [10, 10, 10]
      ];
  
      this.ticks = [ [], [], [] ];
      this.tickEnable = [ true, true, true ];
      this.tickFont = [ 'sans-serif', 'sans-serif', 'sans-serif' ];
      this.tickSize = [ 12, 12, 12 ];
      this.tickAngle = [ 0, 0, 0 ];
      this.tickColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
      this.tickPad = [ 18, 18, 18 ];
  
      this.labels = [ 'x', 'y', 'z' ];
      this.labelEnable = [ true, true, true ];
      this.labelFont = ['Open Sans', 'Open Sans', 'Open Sans'];
      this.labelSize = [ 20, 20, 20 ];
      this.labelColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
      this.labelPad = [ 30, 30, 30 ];
  
      this.lineEnable = [ true, true, true ];
      this.lineMirror = [ false, false, false ];
      this.lineWidth = [ 1, 1, 1 ];
      this.lineColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
  
      this.lineTickEnable = [ true, true, true ];
      this.lineTickMirror = [ false, false, false ];
      this.lineTickLength = [ 10, 10, 10 ];
      this.lineTickWidth = [ 1, 1, 1 ];
      this.lineTickColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
  
      this.gridEnable = [ true, true, true ];
      this.gridWidth = [ 1, 1, 1 ];
      this.gridColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
  
      this.zeroEnable = [ true, true, true ];
      this.zeroLineColor = [ [0, 0, 0, 1], [0, 0, 0, 1], [0, 0, 0, 1] ];
      this.zeroLineWidth = [ 2, 2, 2 ];
  
      this.backgroundEnable = [ true, true, true ];
      this.backgroundColor = [ [0.8, 0.8, 0.8, 0.5],
                                [0.8, 0.8, 0.8, 0.5],
                                [0.8, 0.8, 0.8, 0.5] ];
  
      // some default values are stored for applying model transforms
      this._defaultTickPad = this.tickPad.slice();
      this._defaultLabelPad = this.labelPad.slice();
      this._defaultLineTickLength = this.lineTickLength.slice();
  }
  
  var proto = AxesOptions.prototype;
  
  proto.merge = function(fullLayout, sceneLayout) {
      var opts = this;
      for(var i = 0; i < 3; ++i) {
          var axes = sceneLayout[AXES_NAMES[i]];
  
          if(!axes.visible) {
              opts.tickEnable[i] = false;
              opts.labelEnable[i] = false;
              opts.lineEnable[i] = false;
              opts.lineTickEnable[i] = false;
              opts.gridEnable[i] = false;
              opts.zeroEnable[i] = false;
              opts.backgroundEnable[i] = false;
              continue;
          }
  
          // Axes labels
          opts.labels[i] = fullLayout._meta ?
              Lib.templateString(axes.title.text, fullLayout._meta) :
              axes.title.text;
  
          if('font' in axes.title) {
              if(axes.title.font.color) opts.labelColor[i] = str2RgbaArray(axes.title.font.color);
              if(axes.title.font.family) opts.labelFont[i] = axes.title.font.family;
              if(axes.title.font.size) opts.labelSize[i] = axes.title.font.size;
          }
  
          // Lines
          if('showline' in axes) opts.lineEnable[i] = axes.showline;
          if('linecolor' in axes) opts.lineColor[i] = str2RgbaArray(axes.linecolor);
          if('linewidth' in axes) opts.lineWidth[i] = axes.linewidth;
  
          if('showgrid' in axes) opts.gridEnable[i] = axes.showgrid;
          if('gridcolor' in axes) opts.gridColor[i] = str2RgbaArray(axes.gridcolor);
          if('gridwidth' in axes) opts.gridWidth[i] = axes.gridwidth;
  
          // Remove zeroline if axis type is log
          // otherwise the zeroline is incorrectly drawn at 1 on log axes
          if(axes.type === 'log') opts.zeroEnable[i] = false;
          else if('zeroline' in axes) opts.zeroEnable[i] = axes.zeroline;
          if('zerolinecolor' in axes) opts.zeroLineColor[i] = str2RgbaArray(axes.zerolinecolor);
          if('zerolinewidth' in axes) opts.zeroLineWidth[i] = axes.zerolinewidth;
  
          // tick lines
          if('ticks' in axes && !!axes.ticks) opts.lineTickEnable[i] = true;
          else opts.lineTickEnable[i] = false;
  
          if('ticklen' in axes) {
              opts.lineTickLength[i] = opts._defaultLineTickLength[i] = axes.ticklen;
          }
          if('tickcolor' in axes) opts.lineTickColor[i] = str2RgbaArray(axes.tickcolor);
          if('tickwidth' in axes) opts.lineTickWidth[i] = axes.tickwidth;
          if('tickangle' in axes) {
              opts.tickAngle[i] = (axes.tickangle === 'auto') ?
                  -3600 : // i.e. special number to set auto option
                  Math.PI * -axes.tickangle / 180;
          }
  
          // tick labels
          if('showticklabels' in axes) opts.tickEnable[i] = axes.showticklabels;
          if('tickfont' in axes) {
              if(axes.tickfont.color) opts.tickColor[i] = str2RgbaArray(axes.tickfont.color);
              if(axes.tickfont.family) opts.tickFont[i] = axes.tickfont.family;
              if(axes.tickfont.size) opts.tickSize[i] = axes.tickfont.size;
          }
  
          if('mirror' in axes) {
              if(['ticks', 'all', 'allticks'].indexOf(axes.mirror) !== -1) {
                  opts.lineTickMirror[i] = true;
                  opts.lineMirror[i] = true;
              } else if(axes.mirror === true) {
                  opts.lineTickMirror[i] = false;
                  opts.lineMirror[i] = true;
              } else {
                  opts.lineTickMirror[i] = false;
                  opts.lineMirror[i] = false;
              }
          } else opts.lineMirror[i] = false;
  
          // grid background
          if('showbackground' in axes && axes.showbackground !== false) {
              opts.backgroundEnable[i] = true;
              opts.backgroundColor[i] = str2RgbaArray(axes.backgroundcolor);
          } else opts.backgroundEnable[i] = false;
      }
  };
  
  
  function createAxesOptions(fullLayout, sceneLayout) {
      var result = new AxesOptions();
      result.merge(fullLayout, sceneLayout);
      return result;
  }
  
  module.exports = createAxesOptions;
  
  },{"../../../lib":750,"../../../lib/str2rgbarray":773}],846:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../../lib');
  var Color = _dereq_('../../../components/color');
  var Registry = _dereq_('../../../registry');
  
  var handleSubplotDefaults = _dereq_('../../subplot_defaults');
  var supplyGl3dAxisLayoutDefaults = _dereq_('./axis_defaults');
  var layoutAttributes = _dereq_('./layout_attributes');
  var getSubplotData = _dereq_('../../get_data').getSubplotData;
  
  var GL3D = 'gl3d';
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
      var hasNon3D = layoutOut._basePlotModules.length > 1;
  
      // some layout-wide attribute are used in all scenes
      // if 3D is the only visible plot type
      function getDfltFromLayout(attr) {
          if(hasNon3D) return;
  
          var isValid = Lib.validate(layoutIn[attr], layoutAttributes[attr]);
          if(isValid) return layoutIn[attr];
      }
  
      handleSubplotDefaults(layoutIn, layoutOut, fullData, {
          type: GL3D,
          attributes: layoutAttributes,
          handleDefaults: handleGl3dDefaults,
          fullLayout: layoutOut,
          font: layoutOut.font,
          fullData: fullData,
          getDfltFromLayout: getDfltFromLayout,
          paper_bgcolor: layoutOut.paper_bgcolor,
          calendar: layoutOut.calendar
      });
  };
  
  function handleGl3dDefaults(sceneLayoutIn, sceneLayoutOut, coerce, opts) {
      /*
       * Scene numbering proceeds as follows
       * scene
       * scene2
       * scene3
       *
       * and d.scene will be undefined or some number or number string
       *
       * Also write back a blank scene object to user layout so that some
       * attributes like aspectratio can be written back dynamically.
       */
  
      var bgcolor = coerce('bgcolor');
      var bgColorCombined = Color.combine(bgcolor, opts.paper_bgcolor);
  
      var cameraKeys = ['up', 'center', 'eye'];
  
      for(var j = 0; j < cameraKeys.length; j++) {
          coerce('camera.' + cameraKeys[j] + '.x');
          coerce('camera.' + cameraKeys[j] + '.y');
          coerce('camera.' + cameraKeys[j] + '.z');
      }
  
      coerce('camera.projection.type');
  
      /*
       * coerce to positive number (min 0) but also do not accept 0 (>0 not >=0)
       * note that 0's go false with the !! call
       */
      var hasAspect = !!coerce('aspectratio.x') &&
                      !!coerce('aspectratio.y') &&
                      !!coerce('aspectratio.z');
  
      var defaultAspectMode = hasAspect ? 'manual' : 'auto';
      var aspectMode = coerce('aspectmode', defaultAspectMode);
  
      /*
       * We need aspectratio object in all the Layouts as it is dynamically set
       * in the calculation steps, ie, we cant set the correct data now, it happens later.
       * We must also account for the case the user sends bad ratio data with 'manual' set
       * for the mode. In this case we must force change it here as the default coerce
       * misses it above.
       */
      if(!hasAspect) {
          sceneLayoutIn.aspectratio = sceneLayoutOut.aspectratio = {x: 1, y: 1, z: 1};
  
          if(aspectMode === 'manual') sceneLayoutOut.aspectmode = 'auto';
  
          /*
           * kind of like autorange - we need the calculated aspectmode back in
           * the input layout or relayout can cause problems later
           */
          sceneLayoutIn.aspectmode = sceneLayoutOut.aspectmode;
      }
  
      var fullGl3dData = getSubplotData(opts.fullData, GL3D, opts.id);
  
      supplyGl3dAxisLayoutDefaults(sceneLayoutIn, sceneLayoutOut, {
          font: opts.font,
          scene: opts.id,
          data: fullGl3dData,
          bgColor: bgColorCombined,
          calendar: opts.calendar,
          fullLayout: opts.fullLayout
      });
  
      Registry.getComponentMethod('annotations3d', 'handleDefaults')(
          sceneLayoutIn, sceneLayoutOut, opts
      );
  
      var dragmode = opts.getDfltFromLayout('dragmode');
  
      if(dragmode !== false) {
          if(!dragmode) {
              dragmode = 'orbit';
  
              if(sceneLayoutIn.camera &&
                  sceneLayoutIn.camera.up) {
                  var x = sceneLayoutIn.camera.up.x;
                  var y = sceneLayoutIn.camera.up.y;
                  var z = sceneLayoutIn.camera.up.z;
  
                  if(z !== 0) {
                      if(!x || !y || !z) {
                          dragmode = 'turntable';
                      } else if(z / Math.sqrt(x * x + y * y + z * z) > 0.999) {
                          dragmode = 'turntable';
                      }
                  }
              } else {
                  dragmode = 'turntable';
              }
          }
      }
  
      coerce('dragmode', dragmode);
      coerce('hovermode', opts.getDfltFromLayout('hovermode'));
  }
  
  },{"../../../components/color":615,"../../../lib":750,"../../../registry":882,"../../get_data":836,"../../subplot_defaults":876,"./axis_defaults":844,"./layout_attributes":847}],847:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var gl3dAxisAttrs = _dereq_('./axis_attributes');
  var domainAttrs = _dereq_('../../domain').attributes;
  var extendFlat = _dereq_('../../../lib/extend').extendFlat;
  var counterRegex = _dereq_('../../../lib').counterRegex;
  
  function makeCameraVector(x, y, z) {
      return {
          x: {
              valType: 'number',
              
              dflt: x,
              editType: 'camera'
          },
          y: {
              valType: 'number',
              
              dflt: y,
              editType: 'camera'
          },
          z: {
              valType: 'number',
              
              dflt: z,
              editType: 'camera'
          },
          editType: 'camera'
      };
  }
  
  module.exports = {
      _arrayAttrRegexps: [counterRegex('scene', '.annotations', true)],
  
      bgcolor: {
          valType: 'color',
          
          dflt: 'rgba(0,0,0,0)',
          editType: 'plot'
      },
      camera: {
          up: extendFlat(makeCameraVector(0, 0, 1), {
              
          }),
          center: extendFlat(makeCameraVector(0, 0, 0), {
              
          }),
          eye: extendFlat(makeCameraVector(1.25, 1.25, 1.25), {
              
          }),
          projection: {
              type: {
                  valType: 'enumerated',
                  
                  values: ['perspective', 'orthographic'],
                  dflt: 'perspective',
                  editType: 'calc',
                  
              },
              editType: 'calc'
          },
          editType: 'camera'
      },
      domain: domainAttrs({name: 'scene', editType: 'plot'}),
      aspectmode: {
          valType: 'enumerated',
          
          values: ['auto', 'cube', 'data', 'manual'],
          dflt: 'auto',
          editType: 'plot',
          impliedEdits: {
              'aspectratio.x': undefined,
              'aspectratio.y': undefined,
              'aspectratio.z': undefined
          },
          
      },
      aspectratio: { // must be positive (0's are coerced to 1)
          x: {
              valType: 'number',
              
              min: 0,
              editType: 'plot',
              impliedEdits: {'^aspectmode': 'manual'}
          },
          y: {
              valType: 'number',
              
              min: 0,
              editType: 'plot',
              impliedEdits: {'^aspectmode': 'manual'}
          },
          z: {
              valType: 'number',
              
              min: 0,
              editType: 'plot',
              impliedEdits: {'^aspectmode': 'manual'}
          },
          editType: 'plot',
          impliedEdits: {aspectmode: 'manual'},
          
      },
  
      xaxis: gl3dAxisAttrs,
      yaxis: gl3dAxisAttrs,
      zaxis: gl3dAxisAttrs,
  
      dragmode: {
          valType: 'enumerated',
          
          values: ['orbit', 'turntable', 'zoom', 'pan', false],
          editType: 'plot',
          
      },
      hovermode: {
          valType: 'enumerated',
          
          values: ['closest', false],
          dflt: 'closest',
          editType: 'modebar',
          
      },
      uirevision: {
          valType: 'any',
          
          editType: 'none',
          
      },
      editType: 'plot',
  
      _deprecated: {
          cameraposition: {
              valType: 'info_array',
              
              editType: 'camera',
              
          }
      }
  };
  
  },{"../../../lib":750,"../../../lib/extend":740,"../../domain":826,"./axis_attributes":843}],848:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var str2RGBArray = _dereq_('../../../lib/str2rgbarray');
  
  var AXES_NAMES = ['xaxis', 'yaxis', 'zaxis'];
  
  function SpikeOptions() {
      this.enabled = [true, true, true];
      this.colors = [[0, 0, 0, 1],
                     [0, 0, 0, 1],
                     [0, 0, 0, 1]];
      this.drawSides = [true, true, true];
      this.lineWidth = [1, 1, 1];
  }
  
  var proto = SpikeOptions.prototype;
  
  proto.merge = function(sceneLayout) {
      for(var i = 0; i < 3; ++i) {
          var axes = sceneLayout[AXES_NAMES[i]];
  
          if(!axes.visible) {
              this.enabled[i] = false;
              this.drawSides[i] = false;
              continue;
          }
  
          this.enabled[i] = axes.showspikes;
          this.colors[i] = str2RGBArray(axes.spikecolor);
          this.drawSides[i] = axes.spikesides;
          this.lineWidth[i] = axes.spikethickness;
      }
  };
  
  function createSpikeOptions(layout) {
      var result = new SpikeOptions();
      result.merge(layout);
      return result;
  }
  
  module.exports = createSpikeOptions;
  
  },{"../../../lib/str2rgbarray":773}],849:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  /* eslint block-scoped-var: 0*/
  /* eslint no-redeclare: 0*/
  
  'use strict';
  
  module.exports = computeTickMarks;
  
  var Axes = _dereq_('../../cartesian/axes');
  var Lib = _dereq_('../../../lib');
  
  var AXES_NAMES = ['xaxis', 'yaxis', 'zaxis'];
  
  var centerPoint = [0, 0, 0];
  
  function contourLevelsFromTicks(ticks) {
      var result = new Array(3);
      for(var i = 0; i < 3; ++i) {
          var tlevel = ticks[i];
          var clevel = new Array(tlevel.length);
          for(var j = 0; j < tlevel.length; ++j) {
              clevel[j] = tlevel[j].x;
          }
          result[i] = clevel;
      }
      return result;
  }
  
  function computeTickMarks(scene) {
      var axesOptions = scene.axesOptions;
      var glRange = scene.glplot.axesPixels;
      var sceneLayout = scene.fullSceneLayout;
  
      var ticks = [[], [], []];
  
      for(var i = 0; i < 3; ++i) {
          var axes = sceneLayout[AXES_NAMES[i]];
  
          axes._length = (glRange[i].hi - glRange[i].lo) *
              glRange[i].pixelsPerDataUnit / scene.dataScale[i];
  
          if(Math.abs(axes._length) === Infinity ||
             isNaN(axes._length)) {
              ticks[i] = [];
          } else {
              axes._input_range = axes.range.slice();
              axes.range[0] = (glRange[i].lo) / scene.dataScale[i];
              axes.range[1] = (glRange[i].hi) / scene.dataScale[i];
              axes._m = 1.0 / (scene.dataScale[i] * glRange[i].pixelsPerDataUnit);
  
              if(axes.range[0] === axes.range[1]) {
                  axes.range[0] -= 1;
                  axes.range[1] += 1;
              }
              // this is necessary to short-circuit the 'y' handling
              // in autotick part of calcTicks... Treating all axes as 'y' in this case
              // running the autoticks here, then setting
              // autoticks to false to get around the 2D handling in calcTicks.
              var tickModeCached = axes.tickmode;
              if(axes.tickmode === 'auto') {
                  axes.tickmode = 'linear';
                  var nticks = axes.nticks || Lib.constrain((axes._length / 40), 4, 9);
                  Axes.autoTicks(axes, Math.abs(axes.range[1] - axes.range[0]) / nticks);
              }
              var dataTicks = Axes.calcTicks(axes, { msUTC: true });
              for(var j = 0; j < dataTicks.length; ++j) {
                  dataTicks[j].x = dataTicks[j].x * scene.dataScale[i];
  
                  if(axes.type === 'date') {
                      dataTicks[j].text =
                      dataTicks[j].text.replace(/\<br\>/g, ' ');
                  }
              }
              ticks[i] = dataTicks;
  
  
              axes.tickmode = tickModeCached;
          }
      }
  
      axesOptions.ticks = ticks;
  
      // Calculate tick lengths dynamically
      for(var i = 0; i < 3; ++i) {
          centerPoint[i] = 0.5 * (scene.glplot.bounds[0][i] + scene.glplot.bounds[1][i]);
          for(var j = 0; j < 2; ++j) {
              axesOptions.bounds[j][i] = scene.glplot.bounds[j][i];
          }
      }
  
      scene.contourLevels = contourLevelsFromTicks(ticks);
  }
  
  },{"../../../lib":750,"../../cartesian/axes":799}],850:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  function xformMatrix(m, v) {
      var out = [0, 0, 0, 0];
      var i, j;
  
      for(i = 0; i < 4; ++i) {
          for(j = 0; j < 4; ++j) {
              out[j] += m[4 * i + j] * v[i];
          }
      }
  
      return out;
  }
  
  function project(camera, v) {
      var p = xformMatrix(camera.projection,
          xformMatrix(camera.view,
          xformMatrix(camera.model, [v[0], v[1], v[2], 1])));
      return p;
  }
  
  module.exports = project;
  
  },{}],851:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var glPlot3d = _dereq_('gl-plot3d');
  var createCamera = glPlot3d.createCamera;
  var createPlot = glPlot3d.createScene;
  
  var getContext = _dereq_('webgl-context');
  var passiveSupported = _dereq_('has-passive-events');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Fx = _dereq_('../../components/fx');
  
  var str2RGBAarray = _dereq_('../../lib/str2rgbarray');
  var showNoWebGlMsg = _dereq_('../../lib/show_no_webgl_msg');
  
  var project = _dereq_('./project');
  var createAxesOptions = _dereq_('./layout/convert');
  var createSpikeOptions = _dereq_('./layout/spikes');
  var computeTickMarks = _dereq_('./layout/tick_marks');
  
  var isMobile = _dereq_('is-mobile')({ tablet: true, featureDetect: true });
  
  
  var STATIC_CANVAS, STATIC_CONTEXT;
  
  function Scene(options, fullLayout) {
      // create sub container for plot
      var sceneContainer = document.createElement('div');
      var plotContainer = options.container;
  
      // keep a ref to the graph div to fire hover+click events
      this.graphDiv = options.graphDiv;
  
      // create SVG container for hover text
      var svgContainer = document.createElementNS(
          'http://www.w3.org/2000/svg',
          'svg');
      svgContainer.style.position = 'absolute';
      svgContainer.style.top = svgContainer.style.left = '0px';
      svgContainer.style.width = svgContainer.style.height = '100%';
      svgContainer.style['z-index'] = 20;
      svgContainer.style['pointer-events'] = 'none';
      sceneContainer.appendChild(svgContainer);
      this.svgContainer = svgContainer;
  
      // Tag the container with the sceneID
      sceneContainer.id = options.id;
      sceneContainer.style.position = 'absolute';
      sceneContainer.style.top = sceneContainer.style.left = '0px';
      sceneContainer.style.width = sceneContainer.style.height = '100%';
      plotContainer.appendChild(sceneContainer);
  
      this.fullLayout = fullLayout;
      this.id = options.id || 'scene';
      this.fullSceneLayout = fullLayout[this.id];
  
      // Saved from last call to plot()
      this.plotArgs = [ [], {}, {} ];
  
      /*
       * Move this to calc step? Why does it work here?
       */
      this.axesOptions = createAxesOptions(fullLayout, fullLayout[this.id]);
      this.spikeOptions = createSpikeOptions(fullLayout[this.id]);
      this.container = sceneContainer;
      this.staticMode = !!options.staticPlot;
      this.pixelRatio = this.pixelRatio || options.plotGlPixelRatio || 2;
  
      // Coordinate rescaling
      this.dataScale = [1, 1, 1];
  
      this.contourLevels = [ [], [], [] ];
  
      this.convertAnnotations = Registry.getComponentMethod('annotations3d', 'convert');
      this.drawAnnotations = Registry.getComponentMethod('annotations3d', 'draw');
  
      this.initializeGLPlot();
  }
  
  var proto = Scene.prototype;
  
  proto.prepareOptions = function() {
      var scene = this;
  
      var opts = {
          canvas: scene.canvas,
          gl: scene.gl,
          glOptions: {
              preserveDrawingBuffer: isMobile,
              premultipliedAlpha: true,
              antialias: true
          },
          container: scene.container,
          axes: scene.axesOptions,
          spikes: scene.spikeOptions,
          pickRadius: 10,
          snapToData: true,
          autoScale: true,
          autoBounds: false,
          cameraObject: scene.camera,
          pixelRatio: scene.pixelRatio
      };
  
      // for static plots, we reuse the WebGL context
      //  as WebKit doesn't collect them reliably
      if(scene.staticMode) {
          if(!STATIC_CONTEXT) {
              STATIC_CANVAS = document.createElement('canvas');
              STATIC_CONTEXT = getContext({
                  canvas: STATIC_CANVAS,
                  preserveDrawingBuffer: true,
                  premultipliedAlpha: true,
                  antialias: true
              });
              if(!STATIC_CONTEXT) {
                  throw new Error('error creating static canvas/context for image server');
              }
          }
  
          opts.gl = STATIC_CONTEXT;
          opts.canvas = STATIC_CANVAS;
      }
  
      return opts;
  };
  
  proto.tryCreatePlot = function() {
      var scene = this;
  
      var opts = scene.prepareOptions();
  
      var success = true;
  
      try {
          scene.glplot = createPlot(opts);
      } catch(e) {
          if(scene.staticMode) {
              success = false;
          } else { // try second time
              try {
                  // invert preserveDrawingBuffer setup which could be resulted from is-mobile not detecting the right device
                  Lib.warn([
                      'webgl setup failed possibly due to',
                      isMobile ? 'disabling' : 'enabling',
                      'preserveDrawingBuffer config.',
                      'The device may not be supported by is-mobile module!',
                      'Inverting preserveDrawingBuffer option in second attempt to create webgl scene.'
                  ].join(' '));
                  isMobile = opts.glOptions.preserveDrawingBuffer = !opts.glOptions.preserveDrawingBuffer;
  
                  scene.glplot = createPlot(opts);
              } catch(e) {
                  success = false;
              }
          }
      }
  
      return success;
  };
  
  proto.initializeGLCamera = function() {
      var scene = this;
      var cameraData = scene.fullSceneLayout.camera;
      var isOrtho = (cameraData.projection.type === 'orthographic');
  
      scene.camera = createCamera(scene.container, {
          center: [cameraData.center.x, cameraData.center.y, cameraData.center.z],
          eye: [cameraData.eye.x, cameraData.eye.y, cameraData.eye.z],
          up: [cameraData.up.x, cameraData.up.y, cameraData.up.z],
          _ortho: isOrtho,
          zoomMin: 0.01,
          zoomMax: 100,
          mode: 'orbit'
      });
  };
  
  proto.initializeGLPlot = function() {
      var scene = this;
  
      scene.initializeGLCamera();
  
      var success = scene.tryCreatePlot();
      /*
      * createPlot will throw when webgl is not enabled in the client.
      * Lets return an instance of the module with all functions noop'd.
      * The destroy method - which will remove the container from the DOM
      * is overridden with a function that removes the container only.
      */
      if(!success) return showNoWebGlMsg(scene);
  
      // List of scene objects
      scene.traces = {};
  
      scene.make4thDimension();
  
      var gd = scene.graphDiv;
      var layout = gd.layout;
  
      var makeUpdate = function() {
          var update = {};
  
          if(scene.isCameraChanged(layout)) {
              // camera updates
              update[scene.id + '.camera'] = scene.getCamera();
          }
  
          if(scene.isAspectChanged(layout)) {
              // scene updates
              update[scene.id + '.aspectratio'] = scene.glplot.getAspectratio();
  
              if(layout[scene.id].aspectmode !== 'manual') {
                  scene.fullSceneLayout.aspectmode =
                  layout[scene.id].aspectmode =
                  update[scene.id + '.aspectmode'] = 'manual';
              }
          }
  
          return update;
      };
  
      var relayoutCallback = function(scene) {
          if(scene.fullSceneLayout.dragmode === false) return;
  
          var update = makeUpdate();
          scene.saveLayout(layout);
          scene.graphDiv.emit('plotly_relayout', update);
      };
  
      scene.glplot.canvas.addEventListener('mouseup', function() {
          relayoutCallback(scene);
      });
  
      scene.glplot.canvas.addEventListener('wheel', function(e) {
          if(gd._context._scrollZoom.gl3d) {
              if(scene.camera._ortho) {
                  var s = (e.deltaX > e.deltaY) ? 1.1 : 1.0 / 1.1;
                  var o = scene.glplot.getAspectratio();
                  scene.glplot.setAspectratio({
                      x: s * o.x,
                      y: s * o.y,
                      z: s * o.z
                  });
              }
  
              relayoutCallback(scene);
          }
      }, passiveSupported ? {passive: false} : false);
  
      scene.glplot.canvas.addEventListener('mousemove', function() {
          if(scene.fullSceneLayout.dragmode === false) return;
          if(scene.camera.mouseListener.buttons === 0) return;
  
          var update = makeUpdate();
          scene.graphDiv.emit('plotly_relayouting', update);
      });
  
      if(!scene.staticMode) {
          scene.glplot.canvas.addEventListener('webglcontextlost', function(event) {
              if(gd && gd.emit) {
                  gd.emit('plotly_webglcontextlost', {
                      event: event,
                      layer: scene.id
                  });
              }
          }, false);
      }
  
      scene.glplot.oncontextloss = function() {
          scene.recoverContext();
      };
  
      scene.glplot.onrender = function() {
          scene.render();
      };
  
      return true;
  };
  
  proto.render = function() {
      var scene = this;
      var gd = scene.graphDiv;
      var trace;
  
      // update size of svg container
      var svgContainer = scene.svgContainer;
      var clientRect = scene.container.getBoundingClientRect();
      var width = clientRect.width;
      var height = clientRect.height;
      svgContainer.setAttributeNS(null, 'viewBox', '0 0 ' + width + ' ' + height);
      svgContainer.setAttributeNS(null, 'width', width);
      svgContainer.setAttributeNS(null, 'height', height);
  
      computeTickMarks(scene);
      scene.glplot.axes.update(scene.axesOptions);
  
      // check if pick has changed
      var keys = Object.keys(scene.traces);
      var lastPicked = null;
      var selection = scene.glplot.selection;
      for(var i = 0; i < keys.length; ++i) {
          trace = scene.traces[keys[i]];
          if(trace.data.hoverinfo !== 'skip' && trace.handlePick(selection)) {
              lastPicked = trace;
          }
  
          if(trace.setContourLevels) trace.setContourLevels();
      }
  
      function formatter(axisName, val) {
          var axis = scene.fullSceneLayout[axisName];
  
          return Axes.tickText(axis, axis.d2l(val), 'hover').text;
      }
  
      var oldEventData;
  
      if(lastPicked !== null) {
          var pdata = project(scene.glplot.cameraParams, selection.dataCoordinate);
          trace = lastPicked.data;
          var traceNow = gd._fullData[trace.index];
          var ptNumber = selection.index;
  
          var labels = {
              xLabel: formatter('xaxis', selection.traceCoordinate[0]),
              yLabel: formatter('yaxis', selection.traceCoordinate[1]),
              zLabel: formatter('zaxis', selection.traceCoordinate[2])
          };
  
          var hoverinfo = Fx.castHoverinfo(traceNow, scene.fullLayout, ptNumber);
          var hoverinfoParts = (hoverinfo || '').split('+');
          var isHoverinfoAll = hoverinfo && hoverinfo === 'all';
  
          if(!traceNow.hovertemplate && !isHoverinfoAll) {
              if(hoverinfoParts.indexOf('x') === -1) labels.xLabel = undefined;
              if(hoverinfoParts.indexOf('y') === -1) labels.yLabel = undefined;
              if(hoverinfoParts.indexOf('z') === -1) labels.zLabel = undefined;
              if(hoverinfoParts.indexOf('text') === -1) selection.textLabel = undefined;
              if(hoverinfoParts.indexOf('name') === -1) lastPicked.name = undefined;
          }
  
          var tx;
          var vectorTx = [];
  
          if(trace.type === 'cone' || trace.type === 'streamtube') {
              labels.uLabel = formatter('xaxis', selection.traceCoordinate[3]);
              if(isHoverinfoAll || hoverinfoParts.indexOf('u') !== -1) {
                  vectorTx.push('u: ' + labels.uLabel);
              }
  
              labels.vLabel = formatter('yaxis', selection.traceCoordinate[4]);
              if(isHoverinfoAll || hoverinfoParts.indexOf('v') !== -1) {
                  vectorTx.push('v: ' + labels.vLabel);
              }
  
              labels.wLabel = formatter('zaxis', selection.traceCoordinate[5]);
              if(isHoverinfoAll || hoverinfoParts.indexOf('w') !== -1) {
                  vectorTx.push('w: ' + labels.wLabel);
              }
  
              labels.normLabel = selection.traceCoordinate[6].toPrecision(3);
              if(isHoverinfoAll || hoverinfoParts.indexOf('norm') !== -1) {
                  vectorTx.push('norm: ' + labels.normLabel);
              }
              if(trace.type === 'streamtube') {
                  labels.divergenceLabel = selection.traceCoordinate[7].toPrecision(3);
                  if(isHoverinfoAll || hoverinfoParts.indexOf('divergence') !== -1) {
                      vectorTx.push('divergence: ' + labels.divergenceLabel);
                  }
              }
              if(selection.textLabel) {
                  vectorTx.push(selection.textLabel);
              }
              tx = vectorTx.join('<br>');
          } else if(trace.type === 'isosurface' || trace.type === 'volume') {
              labels.valueLabel = Axes.tickText(scene._mockAxis, scene._mockAxis.d2l(selection.traceCoordinate[3]), 'hover').text;
              vectorTx.push('value: ' + labels.valueLabel);
              if(selection.textLabel) {
                  vectorTx.push(selection.textLabel);
              }
              tx = vectorTx.join('<br>');
          } else {
              tx = selection.textLabel;
          }
  
          var pointData = {
              x: selection.traceCoordinate[0],
              y: selection.traceCoordinate[1],
              z: selection.traceCoordinate[2],
              data: traceNow._input,
              fullData: traceNow,
              curveNumber: traceNow.index,
              pointNumber: ptNumber
          };
  
          Fx.appendArrayPointValue(pointData, traceNow, ptNumber);
  
          if(trace._module.eventData) {
              pointData = traceNow._module.eventData(pointData, selection, traceNow, {}, ptNumber);
          }
  
          var eventData = {points: [pointData]};
  
          if(scene.fullSceneLayout.hovermode) {
              Fx.loneHover({
                  trace: traceNow,
                  x: (0.5 + 0.5 * pdata[0] / pdata[3]) * width,
                  y: (0.5 - 0.5 * pdata[1] / pdata[3]) * height,
                  xLabel: labels.xLabel,
                  yLabel: labels.yLabel,
                  zLabel: labels.zLabel,
                  text: tx,
                  name: lastPicked.name,
                  color: Fx.castHoverOption(traceNow, ptNumber, 'bgcolor') || lastPicked.color,
                  borderColor: Fx.castHoverOption(traceNow, ptNumber, 'bordercolor'),
                  fontFamily: Fx.castHoverOption(traceNow, ptNumber, 'font.family'),
                  fontSize: Fx.castHoverOption(traceNow, ptNumber, 'font.size'),
                  fontColor: Fx.castHoverOption(traceNow, ptNumber, 'font.color'),
                  nameLength: Fx.castHoverOption(traceNow, ptNumber, 'namelength'),
                  textAlign: Fx.castHoverOption(traceNow, ptNumber, 'align'),
                  hovertemplate: Lib.castOption(traceNow, ptNumber, 'hovertemplate'),
                  hovertemplateLabels: Lib.extendFlat({}, pointData, labels),
                  eventData: [pointData]
              }, {
                  container: svgContainer,
                  gd: gd
              });
          }
  
          if(selection.buttons && selection.distance < 5) {
              gd.emit('plotly_click', eventData);
          } else {
              gd.emit('plotly_hover', eventData);
          }
  
          oldEventData = eventData;
      } else {
          Fx.loneUnhover(svgContainer);
          gd.emit('plotly_unhover', oldEventData);
      }
  
      scene.drawAnnotations(scene);
  };
  
  proto.recoverContext = function() {
      var scene = this;
  
      scene.glplot.dispose();
  
      var tryRecover = function() {
          if(scene.glplot.gl.isContextLost()) {
              requestAnimationFrame(tryRecover);
              return;
          }
          if(!scene.initializeGLPlot()) {
              Lib.error('Catastrophic and unrecoverable WebGL error. Context lost.');
              return;
          }
          scene.plot.apply(scene, scene.plotArgs);
      };
  
      requestAnimationFrame(tryRecover);
  };
  
  var axisProperties = [ 'xaxis', 'yaxis', 'zaxis' ];
  
  function computeTraceBounds(scene, trace, bounds) {
      var fullSceneLayout = scene.fullSceneLayout;
  
      for(var d = 0; d < 3; d++) {
          var axisName = axisProperties[d];
          var axLetter = axisName.charAt(0);
          var ax = fullSceneLayout[axisName];
          var coords = trace[axLetter];
          var calendar = trace[axLetter + 'calendar'];
          var len = trace['_' + axLetter + 'length'];
  
          if(!Lib.isArrayOrTypedArray(coords)) {
              bounds[0][d] = Math.min(bounds[0][d], 0);
              bounds[1][d] = Math.max(bounds[1][d], len - 1);
          } else {
              var v;
  
              for(var i = 0; i < (len || coords.length); i++) {
                  if(Lib.isArrayOrTypedArray(coords[i])) {
                      for(var j = 0; j < coords[i].length; ++j) {
                          v = ax.d2l(coords[i][j], 0, calendar);
                          if(!isNaN(v) && isFinite(v)) {
                              bounds[0][d] = Math.min(bounds[0][d], v);
                              bounds[1][d] = Math.max(bounds[1][d], v);
                          }
                      }
                  } else {
                      v = ax.d2l(coords[i], 0, calendar);
                      if(!isNaN(v) && isFinite(v)) {
                          bounds[0][d] = Math.min(bounds[0][d], v);
                          bounds[1][d] = Math.max(bounds[1][d], v);
                      }
                  }
              }
          }
      }
  }
  
  function computeAnnotationBounds(scene, bounds) {
      var fullSceneLayout = scene.fullSceneLayout;
      var annotations = fullSceneLayout.annotations || [];
  
      for(var d = 0; d < 3; d++) {
          var axisName = axisProperties[d];
          var axLetter = axisName.charAt(0);
          var ax = fullSceneLayout[axisName];
  
          for(var j = 0; j < annotations.length; j++) {
              var ann = annotations[j];
  
              if(ann.visible) {
                  var pos = ax.r2l(ann[axLetter]);
                  if(!isNaN(pos) && isFinite(pos)) {
                      bounds[0][d] = Math.min(bounds[0][d], pos);
                      bounds[1][d] = Math.max(bounds[1][d], pos);
                  }
              }
          }
      }
  }
  
  proto.plot = function(sceneData, fullLayout, layout) {
      var scene = this;
  
      // Save parameters
      scene.plotArgs = [sceneData, fullLayout, layout];
  
      if(scene.glplot.contextLost) return;
  
      var data, trace;
      var i, j, axis, axisType;
      var fullSceneLayout = fullLayout[scene.id];
      var sceneLayout = layout[scene.id];
  
      // Update layout
      scene.fullLayout = fullLayout;
      scene.fullSceneLayout = fullSceneLayout;
  
      scene.axesOptions.merge(fullLayout, fullSceneLayout);
      scene.spikeOptions.merge(fullSceneLayout);
  
      // Update camera and camera mode
      scene.setViewport(fullSceneLayout);
      scene.updateFx(fullSceneLayout.dragmode, fullSceneLayout.hovermode);
      scene.camera.enableWheel = scene.graphDiv._context._scrollZoom.gl3d;
  
      // Update scene background
      scene.glplot.setClearColor(str2RGBAarray(fullSceneLayout.bgcolor));
  
      // Update axes functions BEFORE updating traces
      scene.setConvert(axis);
  
      // Convert scene data
      if(!sceneData) sceneData = [];
      else if(!Array.isArray(sceneData)) sceneData = [sceneData];
  
      // Compute trace bounding box
      var dataBounds = [
          [Infinity, Infinity, Infinity],
          [-Infinity, -Infinity, -Infinity]
      ];
  
      for(i = 0; i < sceneData.length; ++i) {
          data = sceneData[i];
          if(data.visible !== true || data._length === 0) continue;
  
          computeTraceBounds(this, data, dataBounds);
      }
      computeAnnotationBounds(this, dataBounds);
  
      var dataScale = [1, 1, 1];
      for(j = 0; j < 3; ++j) {
          if(dataBounds[1][j] === dataBounds[0][j]) {
              dataScale[j] = 1.0;
          } else {
              dataScale[j] = 1.0 / (dataBounds[1][j] - dataBounds[0][j]);
          }
      }
  
      // Save scale
      scene.dataScale = dataScale;
  
      // after computeTraceBounds where ax._categories are filled in
      scene.convertAnnotations(this);
  
      // Update traces
      for(i = 0; i < sceneData.length; ++i) {
          data = sceneData[i];
          if(data.visible !== true || data._length === 0) {
              continue;
          }
          trace = scene.traces[data.uid];
          if(trace) {
              if(trace.data.type === data.type) {
                  trace.update(data);
              } else {
                  trace.dispose();
                  trace = data._module.plot(this, data);
                  scene.traces[data.uid] = trace;
              }
          } else {
              trace = data._module.plot(this, data);
              scene.traces[data.uid] = trace;
          }
          trace.name = data.name;
      }
  
      // Remove empty traces
      var traceIds = Object.keys(scene.traces);
  
      traceIdLoop:
      for(i = 0; i < traceIds.length; ++i) {
          for(j = 0; j < sceneData.length; ++j) {
              if(sceneData[j].uid === traceIds[i] &&
                  (sceneData[j].visible === true && sceneData[j]._length !== 0)) {
                  continue traceIdLoop;
              }
          }
          trace = scene.traces[traceIds[i]];
          trace.dispose();
          delete scene.traces[traceIds[i]];
      }
  
      // order object per trace index
      scene.glplot.objects.sort(function(a, b) {
          return a._trace.data.index - b._trace.data.index;
      });
  
      // Update ranges (needs to be called *after* objects are added due to updates)
      var sceneBounds = [[0, 0, 0], [0, 0, 0]];
      var axisDataRange = [];
      var axisTypeRatios = {};
  
      for(i = 0; i < 3; ++i) {
          axis = fullSceneLayout[axisProperties[i]];
          axisType = axis.type;
  
          if(axisType in axisTypeRatios) {
              axisTypeRatios[axisType].acc *= dataScale[i];
              axisTypeRatios[axisType].count += 1;
          } else {
              axisTypeRatios[axisType] = {
                  acc: dataScale[i],
                  count: 1
              };
          }
  
          if(axis.autorange) {
              sceneBounds[0][i] = Infinity;
              sceneBounds[1][i] = -Infinity;
  
              var objects = scene.glplot.objects;
              var annotations = scene.fullSceneLayout.annotations || [];
              var axLetter = axis._name.charAt(0);
  
              for(j = 0; j < objects.length; j++) {
                  var obj = objects[j];
                  var objBounds = obj.bounds;
                  var pad = obj._trace.data._pad || 0;
  
                  if(obj.constructor.name === 'ErrorBars' && axis._lowerLogErrorBound) {
                      sceneBounds[0][i] = Math.min(sceneBounds[0][i], axis._lowerLogErrorBound);
                  } else {
                      sceneBounds[0][i] = Math.min(sceneBounds[0][i], objBounds[0][i] / dataScale[i] - pad);
                  }
                  sceneBounds[1][i] = Math.max(sceneBounds[1][i], objBounds[1][i] / dataScale[i] + pad);
              }
  
              for(j = 0; j < annotations.length; j++) {
                  var ann = annotations[j];
  
                  // N.B. not taking into consideration the arrowhead
                  if(ann.visible) {
                      var pos = axis.r2l(ann[axLetter]);
                      sceneBounds[0][i] = Math.min(sceneBounds[0][i], pos);
                      sceneBounds[1][i] = Math.max(sceneBounds[1][i], pos);
                  }
              }
  
              if('rangemode' in axis && axis.rangemode === 'tozero') {
                  sceneBounds[0][i] = Math.min(sceneBounds[0][i], 0);
                  sceneBounds[1][i] = Math.max(sceneBounds[1][i], 0);
              }
              if(sceneBounds[0][i] > sceneBounds[1][i]) {
                  sceneBounds[0][i] = -1;
                  sceneBounds[1][i] = 1;
              } else {
                  var d = sceneBounds[1][i] - sceneBounds[0][i];
                  sceneBounds[0][i] -= d / 32.0;
                  sceneBounds[1][i] += d / 32.0;
              }
  
              if(axis.autorange === 'reversed') {
                  // swap bounds:
                  var tmp = sceneBounds[0][i];
                  sceneBounds[0][i] = sceneBounds[1][i];
                  sceneBounds[1][i] = tmp;
              }
          } else {
              var range = axis.range;
              sceneBounds[0][i] = axis.r2l(range[0]);
              sceneBounds[1][i] = axis.r2l(range[1]);
          }
          if(sceneBounds[0][i] === sceneBounds[1][i]) {
              sceneBounds[0][i] -= 1;
              sceneBounds[1][i] += 1;
          }
          axisDataRange[i] = sceneBounds[1][i] - sceneBounds[0][i];
  
          // Update plot bounds
          scene.glplot.setBounds(i, {
              min: sceneBounds[0][i] * dataScale[i],
              max: sceneBounds[1][i] * dataScale[i]
          });
      }
  
      /*
       * Dynamically set the aspect ratio depending on the users aspect settings
       */
      var aspectRatio;
      var aspectmode = fullSceneLayout.aspectmode;
      if(aspectmode === 'cube') {
          aspectRatio = [1, 1, 1];
      } else if(aspectmode === 'manual') {
          var userRatio = fullSceneLayout.aspectratio;
          aspectRatio = [userRatio.x, userRatio.y, userRatio.z];
      } else if(aspectmode === 'auto' || aspectmode === 'data') {
          var axesScaleRatio = [1, 1, 1];
          // Compute axis scale per category
          for(i = 0; i < 3; ++i) {
              axis = fullSceneLayout[axisProperties[i]];
              axisType = axis.type;
              var axisRatio = axisTypeRatios[axisType];
              axesScaleRatio[i] = Math.pow(axisRatio.acc, 1.0 / axisRatio.count) / dataScale[i];
          }
  
          if(aspectmode === 'data') {
              aspectRatio = axesScaleRatio;
          } else { // i.e. 'auto' option
              if(
                  Math.max.apply(null, axesScaleRatio) /
                  Math.min.apply(null, axesScaleRatio) <= 4
              ) {
                  // USE DATA MODE WHEN AXIS RANGE DIMENSIONS ARE RELATIVELY EQUAL
                  aspectRatio = axesScaleRatio;
              } else {
                  // USE EQUAL MODE WHEN AXIS RANGE DIMENSIONS ARE HIGHLY UNEQUAL
                  aspectRatio = [1, 1, 1];
              }
          }
      } else {
          throw new Error('scene.js aspectRatio was not one of the enumerated types');
      }
  
      /*
       * Write aspect Ratio back to user data and fullLayout so that it is modifies as user
       * manipulates the aspectmode settings and the fullLayout is up-to-date.
       */
      fullSceneLayout.aspectratio.x = sceneLayout.aspectratio.x = aspectRatio[0];
      fullSceneLayout.aspectratio.y = sceneLayout.aspectratio.y = aspectRatio[1];
      fullSceneLayout.aspectratio.z = sceneLayout.aspectratio.z = aspectRatio[2];
  
      /*
       * Finally assign the computed aspecratio to the glplot module. This will have an effect
       * on the next render cycle.
       */
      scene.glplot.setAspectratio(fullSceneLayout.aspectratio);
  
      // save 'initial' aspectratio & aspectmode view settings for modebar buttons
      if(!scene.viewInitial.aspectratio) {
          scene.viewInitial.aspectratio = {
              x: fullSceneLayout.aspectratio.x,
              y: fullSceneLayout.aspectratio.y,
              z: fullSceneLayout.aspectratio.z
          };
      }
      if(!scene.viewInitial.aspectmode) {
          scene.viewInitial.aspectmode = fullSceneLayout.aspectmode;
      }
  
      // Update frame position for multi plots
      var domain = fullSceneLayout.domain || null;
      var size = fullLayout._size || null;
  
      if(domain && size) {
          var containerStyle = scene.container.style;
          containerStyle.position = 'absolute';
          containerStyle.left = (size.l + domain.x[0] * size.w) + 'px';
          containerStyle.top = (size.t + (1 - domain.y[1]) * size.h) + 'px';
          containerStyle.width = (size.w * (domain.x[1] - domain.x[0])) + 'px';
          containerStyle.height = (size.h * (domain.y[1] - domain.y[0])) + 'px';
      }
  
      // force redraw so that promise is returned when rendering is completed
      scene.glplot.redraw();
  };
  
  proto.destroy = function() {
      var scene = this;
  
      if(!scene.glplot) return;
      scene.camera.mouseListener.enabled = false;
      scene.container.removeEventListener('wheel', scene.camera.wheelListener);
      scene.camera = null;
      scene.glplot.dispose();
      scene.container.parentNode.removeChild(scene.container);
      scene.glplot = null;
  };
  
  // getCameraArrays :: plotly_coords -> gl-plot3d_coords
  // inverse of getLayoutCamera
  function getCameraArrays(camera) {
      return [
          [camera.eye.x, camera.eye.y, camera.eye.z],
          [camera.center.x, camera.center.y, camera.center.z],
          [camera.up.x, camera.up.y, camera.up.z]
      ];
  }
  
  // getLayoutCamera :: gl-plot3d_coords -> plotly_coords
  // inverse of getCameraArrays
  function getLayoutCamera(camera) {
      return {
          up: {x: camera.up[0], y: camera.up[1], z: camera.up[2]},
          center: {x: camera.center[0], y: camera.center[1], z: camera.center[2]},
          eye: {x: camera.eye[0], y: camera.eye[1], z: camera.eye[2]},
          projection: {type: (camera._ortho === true) ? 'orthographic' : 'perspective'}
      };
  }
  
  // get camera position in plotly coords from 'gl-plot3d' coords
  proto.getCamera = function() {
      var scene = this;
      scene.camera.view.recalcMatrix(scene.camera.view.lastT());
      return getLayoutCamera(scene.camera);
  };
  
  // set gl-plot3d camera position and scene aspects with a set of plotly coords
  proto.setViewport = function(sceneLayout) {
      var scene = this;
      var cameraData = sceneLayout.camera;
  
      scene.camera.lookAt.apply(this, getCameraArrays(cameraData));
      scene.glplot.setAspectratio(sceneLayout.aspectratio);
  
      var newOrtho = (cameraData.projection.type === 'orthographic');
      var oldOrtho = scene.camera._ortho;
  
      if(newOrtho !== oldOrtho) {
          scene.glplot.redraw(); // TODO: figure out why we need to redraw here?
          scene.glplot.clearRGBA();
          scene.glplot.dispose();
          scene.initializeGLPlot();
      }
  };
  
  proto.isCameraChanged = function(layout) {
      var scene = this;
      var cameraData = scene.getCamera();
      var cameraNestedProp = Lib.nestedProperty(layout, scene.id + '.camera');
      var cameraDataLastSave = cameraNestedProp.get();
  
      function same(x, y, i, j) {
          var vectors = ['up', 'center', 'eye'];
          var components = ['x', 'y', 'z'];
          return y[vectors[i]] && (x[vectors[i]][components[j]] === y[vectors[i]][components[j]]);
      }
  
      var changed = false;
      if(cameraDataLastSave === undefined) {
          changed = true;
      } else {
          for(var i = 0; i < 3; i++) {
              for(var j = 0; j < 3; j++) {
                  if(!same(cameraData, cameraDataLastSave, i, j)) {
                      changed = true;
                      break;
                  }
              }
          }
  
          if(!cameraDataLastSave.projection || (
              cameraData.projection &&
              cameraData.projection.type !== cameraDataLastSave.projection.type)) {
              changed = true;
          }
      }
  
      return changed;
  };
  
  proto.isAspectChanged = function(layout) {
      var scene = this;
      var aspectData = scene.glplot.getAspectratio();
      var aspectNestedProp = Lib.nestedProperty(layout, scene.id + '.aspectratio');
      var aspectDataLastSave = aspectNestedProp.get();
  
      return (
          aspectDataLastSave === undefined || (
          aspectDataLastSave.x !== aspectData.x ||
          aspectDataLastSave.y !== aspectData.y ||
          aspectDataLastSave.z !== aspectData.z
      ));
  };
  
  // save camera to user layout (i.e. gd.layout)
  proto.saveLayout = function(layout) {
      var scene = this;
      var fullLayout = scene.fullLayout;
  
      var cameraData;
      var cameraNestedProp;
      var cameraDataLastSave;
  
      var aspectData;
      var aspectNestedProp;
      var aspectDataLastSave;
  
      var cameraChanged = scene.isCameraChanged(layout);
      var aspectChanged = scene.isAspectChanged(layout);
  
      var hasChanged = cameraChanged || aspectChanged;
      if(hasChanged) {
          var preGUI = {};
          if(cameraChanged) {
              cameraData = scene.getCamera();
              cameraNestedProp = Lib.nestedProperty(layout, scene.id + '.camera');
              cameraDataLastSave = cameraNestedProp.get();
  
              preGUI[scene.id + '.camera'] = cameraDataLastSave;
          }
          if(aspectChanged) {
              aspectData = scene.glplot.getAspectratio();
              aspectNestedProp = Lib.nestedProperty(layout, scene.id + '.aspectratio');
              aspectDataLastSave = aspectNestedProp.get();
  
              preGUI[scene.id + '.aspectratio'] = aspectDataLastSave;
          }
          Registry.call('_storeDirectGUIEdit', layout, fullLayout._preGUI, preGUI);
  
          if(cameraChanged) {
              cameraNestedProp.set(cameraData);
  
              var cameraFullNP = Lib.nestedProperty(fullLayout, scene.id + '.camera');
              cameraFullNP.set(cameraData);
          }
  
          if(aspectChanged) {
              aspectNestedProp.set(aspectData);
  
              var aspectFullNP = Lib.nestedProperty(fullLayout, scene.id + '.aspectratio');
              aspectFullNP.set(aspectData);
  
              scene.glplot.redraw();
          }
      }
  
      return hasChanged;
  };
  
  proto.updateFx = function(dragmode, hovermode) {
      var scene = this;
      var camera = scene.camera;
      if(camera) {
          // rotate and orbital are synonymous
          if(dragmode === 'orbit') {
              camera.mode = 'orbit';
              camera.keyBindingMode = 'rotate';
          } else if(dragmode === 'turntable') {
              camera.up = [0, 0, 1];
              camera.mode = 'turntable';
              camera.keyBindingMode = 'rotate';
  
              // The setter for camera.mode animates the transition to z-up,
              // but only if we *don't* explicitly set z-up earlier via the
              // relayout. So push `up` back to layout & fullLayout manually now.
              var gd = scene.graphDiv;
              var fullLayout = gd._fullLayout;
              var fullCamera = scene.fullSceneLayout.camera;
              var x = fullCamera.up.x;
              var y = fullCamera.up.y;
              var z = fullCamera.up.z;
              // only push `up` back to (full)layout if it's going to change
              if(z / Math.sqrt(x * x + y * y + z * z) < 0.999) {
                  var attr = scene.id + '.camera.up';
                  var zUp = {x: 0, y: 0, z: 1};
                  var edits = {};
                  edits[attr] = zUp;
                  var layout = gd.layout;
                  Registry.call('_storeDirectGUIEdit', layout, fullLayout._preGUI, edits);
                  fullCamera.up = zUp;
                  Lib.nestedProperty(layout, attr).set(zUp);
              }
          } else {
              // none rotation modes [pan or zoom]
              camera.keyBindingMode = dragmode;
          }
      }
  
      // to put dragmode and hovermode on the same grounds from relayout
      scene.fullSceneLayout.hovermode = hovermode;
  };
  
  function flipPixels(pixels, w, h) {
      for(var i = 0, q = h - 1; i < q; ++i, --q) {
          for(var j = 0; j < w; ++j) {
              for(var k = 0; k < 4; ++k) {
                  var a = 4 * (w * i + j) + k;
                  var b = 4 * (w * q + j) + k;
                  var tmp = pixels[a];
                  pixels[a] = pixels[b];
                  pixels[b] = tmp;
              }
          }
      }
  }
  
  function correctRGB(pixels, w, h) {
      for(var i = 0; i < h; ++i) {
          for(var j = 0; j < w; ++j) {
              var k = 4 * (w * i + j);
  
              var a = pixels[k + 3]; // alpha
              if(a > 0) {
                  var q = 255 / a;
  
                  for(var l = 0; l < 3; ++l) { // RGB
                      pixels[k + l] = Math.min(q * pixels[k + l], 255);
                  }
              }
          }
      }
  }
  
  proto.toImage = function(format) {
      var scene = this;
  
      if(!format) format = 'png';
      if(scene.staticMode) scene.container.appendChild(STATIC_CANVAS);
  
      // Force redraw
      scene.glplot.redraw();
  
      // Grab context and yank out pixels
      var gl = scene.glplot.gl;
      var w = gl.drawingBufferWidth;
      var h = gl.drawingBufferHeight;
  
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
  
      var pixels = new Uint8Array(w * h * 4);
      gl.readPixels(0, 0, w, h, gl.RGBA, gl.UNSIGNED_BYTE, pixels);
      flipPixels(pixels, w, h);
      correctRGB(pixels, w, h);
  
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var context = canvas.getContext('2d');
      var imageData = context.createImageData(w, h);
      imageData.data.set(pixels);
      context.putImageData(imageData, 0, 0);
  
      var dataURL;
  
      switch(format) {
          case 'jpeg':
              dataURL = canvas.toDataURL('image/jpeg');
              break;
          case 'webp':
              dataURL = canvas.toDataURL('image/webp');
              break;
          default:
              dataURL = canvas.toDataURL('image/png');
      }
  
      if(scene.staticMode) scene.container.removeChild(STATIC_CANVAS);
  
      return dataURL;
  };
  
  proto.setConvert = function() {
      var scene = this;
      for(var i = 0; i < 3; i++) {
          var ax = scene.fullSceneLayout[axisProperties[i]];
          Axes.setConvert(ax, scene.fullLayout);
          ax.setScale = Lib.noop;
      }
  };
  
  proto.make4thDimension = function() {
      var scene = this;
      var gd = scene.graphDiv;
      var fullLayout = gd._fullLayout;
  
      // mock axis for hover formatting
      scene._mockAxis = {
          type: 'linear',
          showexponent: 'all',
          exponentformat: 'B'
      };
      Axes.setConvert(scene._mockAxis, fullLayout);
  };
  
  module.exports = Scene;
  
  },{"../../components/fx":655,"../../lib":750,"../../lib/show_no_webgl_msg":771,"../../lib/str2rgbarray":773,"../../plots/cartesian/axes":799,"../../registry":882,"./layout/convert":845,"./layout/spikes":848,"./layout/tick_marks":849,"./project":850,"gl-plot3d":301,"has-passive-events":415,"is-mobile":441,"webgl-context":578}],852:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function zip3(x, y, z, len) {
      len = len || x.length;
  
      var result = new Array(len);
      for(var i = 0; i < len; i++) {
          result[i] = [x[i], y[i], z[i]];
      }
      return result;
  };
  
  },{}],853:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('./font_attributes');
  var animationAttrs = _dereq_('./animation_attributes');
  var colorAttrs = _dereq_('../components/color/attributes');
  var drawNewShapeAttrs = _dereq_('../components/shapes/draw_newshape/attributes');
  var padAttrs = _dereq_('./pad_attributes');
  var extendFlat = _dereq_('../lib/extend').extendFlat;
  
  var globalFont = fontAttrs({
      editType: 'calc',
      
  });
  globalFont.family.dflt = '"Open Sans", verdana, arial, sans-serif';
  globalFont.size.dflt = 12;
  globalFont.color.dflt = colorAttrs.defaultLine;
  
  module.exports = {
      font: globalFont,
      title: {
          text: {
              valType: 'string',
              
              editType: 'layoutstyle',
              
          },
          font: fontAttrs({
              editType: 'layoutstyle',
              
          }),
          xref: {
              valType: 'enumerated',
              dflt: 'container',
              values: ['container', 'paper'],
              
              editType: 'layoutstyle',
              
          },
          yref: {
              valType: 'enumerated',
              dflt: 'container',
              values: ['container', 'paper'],
              
              editType: 'layoutstyle',
              
          },
          x: {
              valType: 'number',
              min: 0,
              max: 1,
              dflt: 0.5,
              
              editType: 'layoutstyle',
              
          },
          y: {
              valType: 'number',
              min: 0,
              max: 1,
              dflt: 'auto',
              
              editType: 'layoutstyle',
              
          },
          xanchor: {
              valType: 'enumerated',
              dflt: 'auto',
              values: ['auto', 'left', 'center', 'right'],
              
              editType: 'layoutstyle',
              
          },
          yanchor: {
              valType: 'enumerated',
              dflt: 'auto',
              values: ['auto', 'top', 'middle', 'bottom'],
              
              editType: 'layoutstyle',
              
          },
          pad: extendFlat(padAttrs({editType: 'layoutstyle'}), {
              
          }),
          editType: 'layoutstyle'
      },
      uniformtext: {
          mode: {
              valType: 'enumerated',
              values: [false, 'hide', 'show'],
              dflt: false,
              
              editType: 'plot',
              
          },
          minsize: {
              valType: 'number',
              min: 0,
              dflt: 0,
              
              editType: 'plot',
              
          },
          editType: 'plot'
      },
      autosize: {
          valType: 'boolean',
          
          dflt: false,
          // autosize, width, and height get special editType treatment in _relayout
          // so we can handle noop resizes more efficiently
          editType: 'none',
          
      },
      width: {
          valType: 'number',
          
          min: 10,
          dflt: 700,
          editType: 'plot',
          
      },
      height: {
          valType: 'number',
          
          min: 10,
          dflt: 450,
          editType: 'plot',
          
      },
      margin: {
          l: {
              valType: 'number',
              
              min: 0,
              dflt: 80,
              editType: 'plot',
              
          },
          r: {
              valType: 'number',
              
              min: 0,
              dflt: 80,
              editType: 'plot',
              
          },
          t: {
              valType: 'number',
              
              min: 0,
              dflt: 100,
              editType: 'plot',
              
          },
          b: {
              valType: 'number',
              
              min: 0,
              dflt: 80,
              editType: 'plot',
              
          },
          pad: {
              valType: 'number',
              
              min: 0,
              dflt: 0,
              editType: 'plot',
              
          },
          autoexpand: {
              valType: 'boolean',
              
              dflt: true,
              editType: 'plot',
              
          },
          editType: 'plot'
      },
      computed: {
          valType: 'any',
          
          editType: 'none',
          
      },
      paper_bgcolor: {
          valType: 'color',
          
          dflt: colorAttrs.background,
          editType: 'plot',
          
      },
      plot_bgcolor: {
          // defined here, but set in cartesian.supplyLayoutDefaults
          // because it needs to know if there are (2D) axes or not
          valType: 'color',
          
          dflt: colorAttrs.background,
          editType: 'layoutstyle',
          
      },
      separators: {
          valType: 'string',
          
          editType: 'plot',
          
      },
      hidesources: {
          valType: 'boolean',
          
          dflt: false,
          editType: 'plot',
          
      },
      showlegend: {
          // handled in legend.supplyLayoutDefaults
          // but included here because it's not in the legend object
          valType: 'boolean',
          
          editType: 'legend',
          
      },
      colorway: {
          valType: 'colorlist',
          dflt: colorAttrs.defaults,
          
          editType: 'calc',
          
      },
      datarevision: {
          valType: 'any',
          
          editType: 'calc',
          
      },
      uirevision: {
          valType: 'any',
          
          editType: 'none',
          
      },
      editrevision: {
          valType: 'any',
          
          editType: 'none',
          
      },
      selectionrevision: {
          valType: 'any',
          
          editType: 'none',
          
      },
      template: {
          valType: 'any',
          
          editType: 'calc',
          
      },
      modebar: {
          orientation: {
              valType: 'enumerated',
              values: ['v', 'h'],
              dflt: 'h',
              
              editType: 'modebar',
              
          },
          bgcolor: {
              valType: 'color',
              
              editType: 'modebar',
              
          },
          color: {
              valType: 'color',
              
              editType: 'modebar',
              
          },
          activecolor: {
              valType: 'color',
              
              editType: 'modebar',
              
          },
          uirevision: {
              valType: 'any',
              
              editType: 'none',
              
          },
          editType: 'modebar'
      },
  
      newshape: drawNewShapeAttrs.newshape,
      activeshape: drawNewShapeAttrs.activeshape,
  
      meta: {
          valType: 'any',
          arrayOk: true,
          
          editType: 'plot',
          
      },
  
      transition: extendFlat({}, animationAttrs.transition, {
          
          editType: 'none'
      }),
      _deprecated: {
          title: {
              valType: 'string',
              
              editType: 'layoutstyle',
              
          },
          titlefont: fontAttrs({
              editType: 'layoutstyle',
              
          })
      }
  };
  
  },{"../components/color/attributes":614,"../components/shapes/draw_newshape/attributes":697,"../lib/extend":740,"./animation_attributes":793,"./font_attributes":827,"./pad_attributes":861}],854:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var requiredVersion = '1.10.1';
  
  var stylesNonMapbox = {
      'open-street-map': {
          id: 'osm',
          version: 8,
          sources: {
              'plotly-osm-tiles': {
                  type: 'raster',
                  attribution: '<a href="http://www.openstreetmap.org/about/" target="_blank">© OpenStreetMap</a>',
                  tiles: [
                      'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
                      'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png'
                  ],
                  tileSize: 256
              }
          },
          layers: [{
              id: 'plotly-osm-tiles',
              type: 'raster',
              source: 'plotly-osm-tiles',
              minzoom: 0,
              maxzoom: 22
          }]
      },
      'white-bg': {
          id: 'white-bg',
          version: 8,
          sources: {},
          layers: [{
              id: 'white-bg',
              type: 'background',
              paint: {'background-color': '#FFFFFF'},
              minzoom: 0,
              maxzoom: 22
          }]
      },
      'carto-positron': {
          id: 'carto-positron',
          version: 8,
          sources: {
              'plotly-carto-positron': {
                  type: 'raster',
                  attribution: '<a href="https://carto.com/" target="_blank">© CARTO</a>',
                  tiles: ['https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'],
                  tileSize: 256
              }
          },
          layers: [{
              id: 'plotly-carto-positron',
              type: 'raster',
              source: 'plotly-carto-positron',
              minzoom: 0,
              maxzoom: 22
          }]
      },
      'carto-darkmatter': {
          id: 'carto-darkmatter',
          version: 8,
          sources: {
              'plotly-carto-darkmatter': {
                  type: 'raster',
                  attribution: '<a href="https://carto.com/" target="_blank">© CARTO</a>',
                  tiles: ['https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png'],
                  tileSize: 256
              }
          },
          layers: [{
              id: 'plotly-carto-darkmatter',
              type: 'raster',
              source: 'plotly-carto-darkmatter',
              minzoom: 0,
              maxzoom: 22
          }]
      },
      'stamen-terrain': {
          id: 'stamen-terrain',
          version: 8,
          sources: {
              'plotly-stamen-terrain': {
                  type: 'raster',
                  attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> | Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright">ODbL</a>.',
                  tiles: ['https://stamen-tiles.a.ssl.fastly.net/terrain/{z}/{x}/{y}.png'],
                  tileSize: 256
              }
          },
          layers: [{
              id: 'plotly-stamen-terrain',
              type: 'raster',
              source: 'plotly-stamen-terrain',
              minzoom: 0,
              maxzoom: 22
          }]
      },
      'stamen-toner': {
          id: 'stamen-toner',
          version: 8,
          sources: {
              'plotly-stamen-toner': {
                  type: 'raster',
                  attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> | Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://www.openstreetmap.org/copyright">ODbL</a>.',
                  tiles: ['https://stamen-tiles.a.ssl.fastly.net/toner/{z}/{x}/{y}.png'],
                  tileSize: 256
              }
          },
          layers: [{
              id: 'plotly-stamen-toner',
              type: 'raster',
              source: 'plotly-stamen-toner',
              minzoom: 0,
              maxzoom: 22
          }]
      },
      'stamen-watercolor': {
          id: 'stamen-watercolor',
          version: 8,
          sources: {
              'plotly-stamen-watercolor': {
                  type: 'raster',
                  attribution: 'Map tiles by <a href="http://stamen.com">Stamen Design</a>, under <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> | Data by <a href="http://openstreetmap.org">OpenStreetMap</a>, under <a href="http://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>.',
                  tiles: ['https://stamen-tiles.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.png'],
                  tileSize: 256
              }
          },
          layers: [{
              id: 'plotly-stamen-watercolor',
              type: 'raster',
              source: 'plotly-stamen-watercolor',
              minzoom: 0,
              maxzoom: 22
          }]
      }
  };
  
  var styleValuesNonMapbox = Object.keys(stylesNonMapbox);
  
  module.exports = {
      requiredVersion: requiredVersion,
  
      styleUrlPrefix: 'mapbox://styles/mapbox/',
      styleUrlSuffix: 'v9',
  
      styleValuesMapbox: ['basic', 'streets', 'outdoors', 'light', 'dark', 'satellite', 'satellite-streets'],
      styleValueDflt: 'basic',
      stylesNonMapbox: stylesNonMapbox,
      styleValuesNonMapbox: styleValuesNonMapbox,
  
      traceLayerPrefix: 'plotly-trace-layer-',
      layoutLayerPrefix: 'plotly-layout-layer-',
  
      wrongVersionErrorMsg: [
          'Your custom plotly.js bundle is not using the correct mapbox-gl version',
          'Please install mapbox-gl@' + requiredVersion + '.'
      ].join('\n'),
  
      noAccessTokenErrorMsg: [
          'Missing Mapbox access token.',
          'Mapbox trace type require a Mapbox access token to be registered.',
          'For example:',
          '  Plotly.plot(gd, data, layout, { mapboxAccessToken: \'my-access-token\' });',
          'More info here: https://www.mapbox.com/help/define-access-token/'
      ].join('\n'),
  
      missingStyleErrorMsg: [
          'No valid mapbox style found, please set `mapbox.style` to one of:',
          styleValuesNonMapbox.join(', '),
          'or register a Mapbox access token to use a Mapbox-served style.'
      ].join('\n'),
  
      multipleTokensErrorMsg: [
          'Set multiple mapbox access token across different mapbox subplot,',
          'using first token found as mapbox-gl does not allow multiple' +
          'access tokens on the same page.'
      ].join('\n'),
  
      mapOnErrorMsg: 'Mapbox error.',
  
      // Mapbox logo for static export
      mapboxLogo: {
          path0: 'm 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z',
          path1: 'M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z',
          path2: 'M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z',
          polygon: '11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34'
      },
  
      // a subset of node_modules/mapbox-gl/dist/mapbox-gl.css
      styleRules: {
          map: 'overflow:hidden;position:relative;',
          'missing-css': 'display:none;',
          'canary': 'background-color:salmon;',
  
          // Reusing CSS directives from: https://api.tiles.mapbox.com/mapbox-gl-js/v1.1.1/mapbox-gl.css
          'ctrl-bottom-left': 'position: absolute; pointer-events: none; z-index: 2; bottom: 0; left: 0;',
          'ctrl-bottom-right': 'position: absolute; pointer-events: none; z-index: 2; right: 0; bottom: 0;',
          'ctrl': 'clear: both; pointer-events: auto; transform: translate(0, 0);',
  
          // Compact ctrl
          'ctrl-attrib.mapboxgl-compact .mapboxgl-ctrl-attrib-inner': 'display: none;',
          'ctrl-attrib.mapboxgl-compact:hover .mapboxgl-ctrl-attrib-inner': 'display: block; margin-top:2px',
          'ctrl-attrib.mapboxgl-compact:hover': 'padding: 2px 24px 2px 4px; visibility: visible; margin-top: 6px;',
          'ctrl-attrib.mapboxgl-compact::after': 'content: ""; cursor: pointer; position: absolute; background-image: url(\'data:image/svg+xml;charset=utf-8,%3Csvg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"%3E %3Cpath fill="%23333333" fill-rule="evenodd" d="M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0"/%3E %3C/svg%3E\'); background-color: rgba(255, 255, 255, 0.5); width: 24px; height: 24px; box-sizing: border-box; border-radius: 12px;',
          'ctrl-attrib.mapboxgl-compact': 'min-height: 20px; padding: 0; margin: 10px; position: relative; background-color: #fff; border-radius: 3px 12px 12px 3px;',
          'ctrl-bottom-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after': 'bottom: 0; right: 0',
          'ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after': 'bottom: 0; left: 0',
  
          'ctrl-bottom-left .mapboxgl-ctrl': 'margin: 0 0 10px 10px; float: left;',
          'ctrl-bottom-right .mapboxgl-ctrl': 'margin: 0 10px 10px 0; float: right;',
  
          'ctrl-attrib': 'color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px',
          'ctrl-attrib a': 'color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px',
          'ctrl-attrib a:hover': 'color: inherit; text-decoration: underline;',
  
          'ctrl-attrib .mapbox-improve-map': 'font-weight: bold; margin-left: 2px;',
          'attrib-empty': 'display: none;',
  
          // Compact Mapbox logo without text
          'ctrl-logo': 'display:block; width: 21px; height: 21px; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E %3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 21" style="enable-background:new 0 0 21 21;" xml:space="preserve"%3E%3Cg transform="translate(0,0.01)"%3E%3Cpath d="m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z" style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3Cpath d="M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpath d="M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpolygon points="11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34 " style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3C/g%3E%3C/svg%3E\')'
  
          // Mapbox logo WITH text below (commented out for now)
          // 'ctrl-logo': 'width: 85px; height: 21px; margin: 0 0 -3px -3px; display: block; background-repeat: no-repeat; cursor: pointer; background-image: url(\'data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E%3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 84.49 21" style="enable-background:new 0 0 84.49 21;" xml:space="preserve"%3E%3Cg%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M83.25,14.26c0,0.12-0.09,0.21-0.21,0.21h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39l-1.44,2.39 c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68L76.2,6.84 c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.4-2.35 c0.06-0.11,0.18-0.17,0.3-0.17H83c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.37,3.63l2.43,3.67 C83.24,14.18,83.25,14.22,83.25,14.26z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M66.24,9.59c-0.39-1.88-1.96-3.28-3.84-3.28c-1.03,0-2.03,0.42-2.73,1.18V3.51c0-0.13-0.1-0.23-0.23-0.23h-1.4 c-0.13,0-0.23,0.11-0.23,0.23v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.11,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.73,1.18 c1.88,0,3.45-1.41,3.84-3.29C66.37,10.79,66.37,10.18,66.24,9.59L66.24,9.59z M62.08,13c-1.32,0-2.39-1.11-2.41-2.48v-0.06 c0.02-1.38,1.09-2.48,2.41-2.48s2.42,1.12,2.42,2.51S63.41,13,62.08,13z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M71.67,6.32c-1.98-0.01-3.72,1.35-4.16,3.29c-0.13,0.59-0.13,1.19,0,1.77c0.44,1.94,2.17,3.32,4.17,3.3 c2.35,0,4.26-1.87,4.26-4.19S74.04,6.32,71.67,6.32z M71.65,13.01c-1.33,0-2.42-1.12-2.42-2.51s1.08-2.52,2.42-2.52 c1.33,0,2.42,1.12,2.42,2.51S72.99,13,71.65,13.01L71.65,13.01z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M62.08,7.98c-1.32,0-2.39,1.11-2.41,2.48v0.06C59.68,11.9,60.75,13,62.08,13s2.42-1.12,2.42-2.51 S63.41,7.98,62.08,7.98z M62.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25 c0.63,0,1.17,0.57,1.17,1.27C63.24,11.2,62.73,11.76,62.08,11.76z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M71.65,7.98c-1.33,0-2.42,1.12-2.42,2.51S70.32,13,71.65,13s2.42-1.12,2.42-2.51S72.99,7.98,71.65,7.98z M71.65,11.76c-0.64,0-1.17-0.57-1.17-1.27c0-0.7,0.53-1.26,1.17-1.26s1.17,0.57,1.17,1.27C72.82,11.21,72.29,11.76,71.65,11.76z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M45.74,6.53h-1.4c-0.13,0-0.23,0.11-0.23,0.23v0.73c-0.71-0.75-1.7-1.18-2.73-1.18 c-2.17,0-3.94,1.87-3.94,4.19s1.77,4.19,3.94,4.19c1.04,0,2.03-0.43,2.73-1.19v0.73c0,0.13,0.1,0.23,0.23,0.23h1.4 c0.13,0,0.23-0.11,0.23-0.23V6.74c0-0.12-0.09-0.22-0.22-0.22C45.75,6.53,45.75,6.53,45.74,6.53z M44.12,10.53 C44.11,11.9,43.03,13,41.71,13s-2.42-1.12-2.42-2.51s1.08-2.52,2.4-2.52c1.33,0,2.39,1.11,2.41,2.48L44.12,10.53z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M41.71,7.98c-1.33,0-2.42,1.12-2.42,2.51S40.37,13,41.71,13s2.39-1.11,2.41-2.48v-0.06 C44.1,9.09,43.03,7.98,41.71,7.98z M40.55,10.49c0-0.7,0.52-1.27,1.17-1.27c0.64,0,1.14,0.56,1.17,1.25v0.04 c-0.01,0.68-0.53,1.24-1.17,1.24C41.08,11.75,40.55,11.19,40.55,10.49z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M52.41,6.32c-1.03,0-2.03,0.42-2.73,1.18V6.75c0-0.13-0.1-0.23-0.23-0.23h-1.4c-0.13,0-0.23,0.11-0.23,0.23 v10.72c0,0.13,0.1,0.23,0.23,0.23h1.4c0.13,0,0.23-0.1,0.23-0.23V13.5c0.71,0.75,1.7,1.18,2.74,1.18c2.17,0,3.94-1.87,3.94-4.19 S54.58,6.32,52.41,6.32z M52.08,13.01c-1.32,0-2.39-1.11-2.42-2.48v-0.07c0.02-1.38,1.09-2.49,2.4-2.49c1.32,0,2.41,1.12,2.41,2.51 S53.4,13,52.08,13.01L52.08,13.01z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M52.08,7.98c-1.32,0-2.39,1.11-2.42,2.48v0.06c0.03,1.38,1.1,2.48,2.42,2.48s2.41-1.12,2.41-2.51 S53.4,7.98,52.08,7.98z M52.08,11.76c-0.63,0-1.14-0.56-1.17-1.25v-0.04c0.01-0.69,0.54-1.25,1.17-1.25c0.63,0,1.17,0.58,1.17,1.27 S52.72,11.76,52.08,11.76z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M36.08,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68c0-0.98-0.74-1.71-1.62-1.71 c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.11,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V6.74 c0.01-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03c1.09,0,2.09,0.6,2.6,1.55 c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78L36.08,14.24z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M84.34,13.59l-0.07-0.13l-1.96-2.99l1.94-2.95c0.44-0.67,0.26-1.56-0.41-2.02c-0.02,0-0.03,0-0.04-0.01 c-0.23-0.15-0.5-0.22-0.78-0.22h-1.61c-0.56,0-1.08,0.29-1.37,0.78L79.72,6.6l-0.34-0.56C79.09,5.56,78.57,5.27,78,5.27h-1.6 c-0.6,0-1.13,0.37-1.35,0.92c-2.19-1.66-5.28-1.47-7.26,0.45c-0.35,0.34-0.65,0.72-0.89,1.14c-0.9-1.62-2.58-2.72-4.5-2.72 c-0.5,0-1.01,0.07-1.48,0.23V3.51c0-0.82-0.66-1.48-1.47-1.48h-1.4c-0.81,0-1.47,0.66-1.47,1.47v3.75 c-0.95-1.36-2.5-2.18-4.17-2.19c-0.74,0-1.46,0.16-2.12,0.47c-0.24-0.17-0.54-0.26-0.84-0.26h-1.4c-0.45,0-0.87,0.21-1.15,0.56 c-0.02-0.03-0.04-0.05-0.07-0.08c-0.28-0.3-0.68-0.47-1.09-0.47h-1.39c-0.3,0-0.6,0.09-0.84,0.26c-0.67-0.3-1.39-0.46-2.12-0.46 c-1.83,0-3.43,1-4.37,2.5c-0.2-0.46-0.48-0.89-0.83-1.25c-0.8-0.81-1.89-1.25-3.02-1.25h-0.01c-0.89,0.01-1.75,0.33-2.46,0.88 c-0.74-0.57-1.64-0.88-2.57-0.88H28.1c-0.29,0-0.58,0.03-0.86,0.11c-0.28,0.06-0.56,0.16-0.82,0.28c-0.21-0.12-0.45-0.18-0.7-0.18 h-1.4c-0.82,0-1.47,0.66-1.47,1.47v7.5c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.48-0.66,1.48-1.48l0,0V9.79 c0.03-0.36,0.23-0.59,0.36-0.59c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41c0.82,0,1.47-0.66,1.47-1.47 l-0.01-4.57c0.06-0.32,0.25-0.47,0.35-0.47c0.18,0,0.38,0.18,0.38,0.47v4.57c0,0.82,0.66,1.47,1.47,1.47h1.41 c0.82,0,1.47-0.66,1.47-1.47v-0.38c0.96,1.29,2.46,2.06,4.06,2.06c0.74,0,1.46-0.16,2.12-0.47c0.24,0.17,0.54,0.26,0.84,0.26h1.39 c0.3,0,0.6-0.09,0.84-0.26v2.01c0,0.82,0.66,1.47,1.47,1.47h1.4c0.82,0,1.47-0.66,1.47-1.47v-1.77c0.48,0.15,0.99,0.23,1.49,0.22 c1.7,0,3.22-0.87,4.17-2.2v0.52c0,0.82,0.66,1.47,1.47,1.47h1.4c0.3,0,0.6-0.09,0.84-0.26c0.66,0.31,1.39,0.47,2.12,0.47 c1.92,0,3.6-1.1,4.49-2.73c1.54,2.65,4.95,3.53,7.58,1.98c0.18-0.11,0.36-0.22,0.53-0.36c0.22,0.55,0.76,0.91,1.35,0.9H78 c0.56,0,1.08-0.29,1.37-0.78l0.37-0.61l0.37,0.61c0.29,0.48,0.81,0.78,1.38,0.78h1.6c0.81,0,1.46-0.66,1.45-1.46 C84.49,14.02,84.44,13.8,84.34,13.59L84.34,13.59z M35.86,14.47h-1.41c-0.13,0-0.23-0.11-0.23-0.23V9.68 c0-0.98-0.74-1.71-1.62-1.71c-0.8,0-1.46,0.7-1.59,1.62l0.01,4.66c0,0.13-0.1,0.23-0.23,0.23h-1.41c-0.13,0-0.23-0.11-0.23-0.23 V9.68c0-0.98-0.74-1.71-1.62-1.71c-0.85,0-1.54,0.79-1.6,1.8v4.48c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23 V6.74c0.01-0.13,0.11-0.22,0.23-0.22h1.4c0.13,0,0.22,0.11,0.23,0.22V7.4c0.5-0.68,1.3-1.09,2.16-1.1h0.03 c1.09,0,2.09,0.6,2.6,1.55c0.45-0.95,1.4-1.55,2.44-1.56c1.62,0,2.93,1.25,2.9,2.78l0.01,5.16C36.09,14.36,35.98,14.46,35.86,14.47 L35.86,14.47z M45.97,14.24c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V13.5c-0.7,0.76-1.69,1.18-2.72,1.18 c-2.17,0-3.94-1.87-3.94-4.19s1.77-4.19,3.94-4.19c1.03,0,2.02,0.43,2.73,1.18V6.74c0-0.13,0.1-0.23,0.23-0.23h1.4 c0.12-0.01,0.22,0.08,0.23,0.21c0,0.01,0,0.01,0,0.02v7.51h-0.01V14.24z M52.41,14.67c-1.03,0-2.02-0.43-2.73-1.18v3.97 c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.1-0.23-0.23V6.75c0-0.13,0.1-0.22,0.23-0.22h1.4c0.13,0,0.23,0.11,0.23,0.23v0.73 c0.71-0.76,1.7-1.18,2.73-1.18c2.17,0,3.94,1.86,3.94,4.18S54.58,14.67,52.41,14.67z M66.24,11.39c-0.39,1.87-1.96,3.29-3.84,3.29 c-1.03,0-2.02-0.43-2.73-1.18v0.73c0,0.13-0.1,0.23-0.23,0.23h-1.4c-0.13,0-0.23-0.11-0.23-0.23V3.51c0-0.13,0.1-0.23,0.23-0.23 h1.4c0.13,0,0.23,0.11,0.23,0.23v3.97c0.71-0.75,1.7-1.18,2.73-1.17c1.88,0,3.45,1.4,3.84,3.28C66.37,10.19,66.37,10.8,66.24,11.39 L66.24,11.39L66.24,11.39z M71.67,14.68c-2,0.01-3.73-1.35-4.17-3.3c-0.13-0.59-0.13-1.19,0-1.77c0.44-1.94,2.17-3.31,4.17-3.3 c2.36,0,4.26,1.87,4.26,4.19S74.03,14.68,71.67,14.68L71.67,14.68z M83.04,14.47h-1.61c-0.13,0-0.24-0.06-0.3-0.17l-1.44-2.39 l-1.44,2.39c-0.06,0.11-0.18,0.17-0.3,0.17h-1.61c-0.04,0-0.08-0.01-0.12-0.03c-0.09-0.06-0.13-0.19-0.06-0.28l0,0l2.43-3.68 L76.2,6.84c-0.02-0.03-0.03-0.07-0.03-0.12c0-0.12,0.09-0.21,0.21-0.21h1.61c0.13,0,0.24,0.06,0.3,0.17l1.41,2.36l1.41-2.36 c0.06-0.11,0.18-0.17,0.3-0.17h1.61c0.04,0,0.08,0.01,0.12,0.03c0.09,0.06,0.13,0.19,0.06,0.28l0,0l-2.38,3.64l2.43,3.67 c0.02,0.03,0.03,0.07,0.03,0.12C83.25,14.38,83.16,14.47,83.04,14.47L83.04,14.47L83.04,14.47z"/%3E %3Cpath class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" d="M10.5,1.24c-5.11,0-9.25,4.15-9.25,9.25s4.15,9.25,9.25,9.25s9.25-4.15,9.25-9.25 C19.75,5.38,15.61,1.24,10.5,1.24z M14.89,12.77c-1.93,1.93-4.78,2.31-6.7,2.31c-0.7,0-1.41-0.05-2.1-0.16c0,0-1.02-5.64,2.14-8.81 c0.83-0.83,1.95-1.28,3.13-1.28c1.27,0,2.49,0.51,3.39,1.42C16.59,8.09,16.64,11,14.89,12.77z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M10.5-0.01C4.7-0.01,0,4.7,0,10.49s4.7,10.5,10.5,10.5S21,16.29,21,10.49C20.99,4.7,16.3-0.01,10.5-0.01z M10.5,19.74c-5.11,0-9.25-4.15-9.25-9.25s4.14-9.26,9.25-9.26s9.25,4.15,9.25,9.25C19.75,15.61,15.61,19.74,10.5,19.74z"/%3E %3Cpath class="st1" style="opacity:0.35; enable-background:new;" d="M14.74,6.25C12.9,4.41,9.98,4.35,8.23,6.1c-3.16,3.17-2.14,8.81-2.14,8.81s5.64,1.02,8.81-2.14 C16.64,11,16.59,8.09,14.74,6.25z M12.47,10.34l-0.91,1.87l-0.9-1.87L8.8,9.43l1.86-0.9l0.9-1.87l0.91,1.87l1.86,0.9L12.47,10.34z"/%3E %3Cpolygon class="st0" style="opacity:0.9; fill: %23FFFFFF; enable-background: new;" points="14.33,9.43 12.47,10.34 11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 "/%3E%3C/g%3E%3C/svg%3E\');'
      }
  };
  
  },{}],855:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  /**
   * Convert plotly.js 'textposition' to mapbox-gl 'anchor' and 'offset'
   * (with the help of the icon size).
   *
   * @param {string} textpostion : plotly.js textposition value
   * @param {number} iconSize : plotly.js icon size (e.g. marker.size for traces)
   *
   * @return {object}
   *      - anchor
   *      - offset
   */
  module.exports = function convertTextOpts(textposition, iconSize) {
      var parts = textposition.split(' ');
      var vPos = parts[0];
      var hPos = parts[1];
  
      // ballpack values
      var factor = Lib.isArrayOrTypedArray(iconSize) ? Lib.mean(iconSize) : iconSize;
      var xInc = 0.5 + (factor / 100);
      var yInc = 1.5 + (factor / 100);
  
      var anchorVals = ['', ''];
      var offset = [0, 0];
  
      switch(vPos) {
          case 'top':
              anchorVals[0] = 'top';
              offset[1] = -yInc;
              break;
          case 'bottom':
              anchorVals[0] = 'bottom';
              offset[1] = yInc;
              break;
      }
  
      switch(hPos) {
          case 'left':
              anchorVals[1] = 'right';
              offset[0] = -xInc;
              break;
          case 'right':
              anchorVals[1] = 'left';
              offset[0] = xInc;
              break;
      }
  
      // Mapbox text-anchor must be one of:
      //  center, left, right, top, bottom,
      //  top-left, top-right, bottom-left, bottom-right
  
      var anchor;
      if(anchorVals[0] && anchorVals[1]) anchor = anchorVals.join('-');
      else if(anchorVals[0]) anchor = anchorVals[0];
      else if(anchorVals[1]) anchor = anchorVals[1];
      else anchor = 'center';
  
      return { anchor: anchor, offset: offset };
  };
  
  },{"../../lib":750}],856:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var mapboxgl = _dereq_('mapbox-gl');
  
  var Lib = _dereq_('../../lib');
  var getSubplotCalcData = _dereq_('../../plots/get_data').getSubplotCalcData;
  var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
  var d3 = _dereq_('d3');
  var Drawing = _dereq_('../../components/drawing');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  
  var Mapbox = _dereq_('./mapbox');
  
  var MAPBOX = 'mapbox';
  
  var constants = exports.constants = _dereq_('./constants');
  
  exports.name = MAPBOX;
  
  exports.attr = 'subplot';
  
  exports.idRoot = MAPBOX;
  
  exports.idRegex = exports.attrRegex = Lib.counterRegex(MAPBOX);
  
  exports.attributes = {
      subplot: {
          valType: 'subplotid',
          
          dflt: 'mapbox',
          editType: 'calc',
          
      }
  };
  
  exports.layoutAttributes = _dereq_('./layout_attributes');
  
  exports.supplyLayoutDefaults = _dereq_('./layout_defaults');
  
  exports.plot = function plot(gd) {
      var fullLayout = gd._fullLayout;
      var calcData = gd.calcdata;
      var mapboxIds = fullLayout._subplots[MAPBOX];
  
      if(mapboxgl.version !== constants.requiredVersion) {
          throw new Error(constants.wrongVersionErrorMsg);
      }
  
      var accessToken = findAccessToken(gd, mapboxIds);
      mapboxgl.accessToken = accessToken;
  
      for(var i = 0; i < mapboxIds.length; i++) {
          var id = mapboxIds[i];
          var subplotCalcData = getSubplotCalcData(calcData, MAPBOX, id);
          var opts = fullLayout[id];
          var mapbox = opts._subplot;
  
          if(!mapbox) {
              mapbox = new Mapbox(gd, id);
              fullLayout[id]._subplot = mapbox;
          }
  
          if(!mapbox.viewInitial) {
              mapbox.viewInitial = {
                  center: Lib.extendFlat({}, opts.center),
                  zoom: opts.zoom,
                  bearing: opts.bearing,
                  pitch: opts.pitch
              };
          }
  
          mapbox.plot(subplotCalcData, fullLayout, gd._promises);
      }
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var oldMapboxKeys = oldFullLayout._subplots[MAPBOX] || [];
  
      for(var i = 0; i < oldMapboxKeys.length; i++) {
          var oldMapboxKey = oldMapboxKeys[i];
  
          if(!newFullLayout[oldMapboxKey] && !!oldFullLayout[oldMapboxKey]._subplot) {
              oldFullLayout[oldMapboxKey]._subplot.destroy();
          }
      }
  };
  
  exports.toSVG = function(gd) {
      var fullLayout = gd._fullLayout;
      var subplotIds = fullLayout._subplots[MAPBOX];
      var size = fullLayout._size;
  
      for(var i = 0; i < subplotIds.length; i++) {
          var opts = fullLayout[subplotIds[i]];
          var domain = opts.domain;
          var mapbox = opts._subplot;
  
          var imageData = mapbox.toImage('png');
          var image = fullLayout._glimages.append('svg:image');
  
          image.attr({
              xmlns: xmlnsNamespaces.svg,
              'xlink:href': imageData,
              x: size.l + size.w * domain.x[0],
              y: size.t + size.h * (1 - domain.y[1]),
              width: size.w * (domain.x[1] - domain.x[0]),
              height: size.h * (domain.y[1] - domain.y[0]),
              preserveAspectRatio: 'none'
          });
  
          var subplotDiv = d3.select(opts._subplot.div);
  
          // Append logo if visible
          var hidden = subplotDiv.select('.mapboxgl-ctrl-logo').node().offsetParent === null;
          if(!hidden) {
              var logo = fullLayout._glimages.append('g');
              logo.attr('transform', 'translate(' + (size.l + size.w * domain.x[0] + 10) + ', ' + (size.t + size.h * (1 - domain.y[0]) - 31) + ')');
              logo.append('path')
                .attr('d', constants.mapboxLogo.path0)
                .style({
                    opacity: 0.9,
                    fill: '#ffffff',
                    'enable-background': 'new'
                });
  
              logo.append('path')
                .attr('d', constants.mapboxLogo.path1)
                .style('opacity', 0.35)
                .style('enable-background', 'new');
  
              logo.append('path')
                .attr('d', constants.mapboxLogo.path2)
                .style('opacity', 0.35)
                .style('enable-background', 'new');
  
              logo.append('polygon')
                .attr('points', constants.mapboxLogo.polygon)
                .style({
                    opacity: 0.9,
                    fill: '#ffffff',
                    'enable-background': 'new'
                });
          }
  
          // Add attributions
          var attributions = subplotDiv
                                .select('.mapboxgl-ctrl-attrib').text()
                                .replace('Improve this map', '');
  
          var attributionGroup = fullLayout._glimages.append('g');
  
          var attributionText = attributionGroup.append('text');
          attributionText
            .text(attributions)
            .classed('static-attribution', true)
            .attr({
                'font-size': 12,
                'font-family': 'Arial',
                'color': 'rgba(0, 0, 0, 0.75)',
                'text-anchor': 'end',
                'data-unformatted': attributions
            });
  
          var bBox = Drawing.bBox(attributionText.node());
  
          // Break into multiple lines twice larger than domain
          var maxWidth = size.w * (domain.x[1] - domain.x[0]);
          if((bBox.width > maxWidth / 2)) {
              var multilineAttributions = attributions.split('|').join('<br>');
              attributionText
                .text(multilineAttributions)
                .attr('data-unformatted', multilineAttributions)
                .call(svgTextUtils.convertToTspans, gd);
  
              bBox = Drawing.bBox(attributionText.node());
          }
          attributionText.attr('transform', 'translate(-3, ' + (-bBox.height + 8) + ')');
  
          // Draw white rectangle behind text
          attributionGroup
            .insert('rect', '.static-attribution')
            .attr({
                x: -bBox.width - 6,
                y: -bBox.height - 3,
                width: bBox.width + 6,
                height: bBox.height + 3,
                fill: 'rgba(255, 255, 255, 0.75)'
            });
  
          // Scale down if larger than domain
          var scaleRatio = 1;
          if((bBox.width + 6) > maxWidth) scaleRatio = maxWidth / (bBox.width + 6);
  
          var offset = [(size.l + size.w * domain.x[1]), (size.t + size.h * (1 - domain.y[0]))];
          attributionGroup.attr('transform', 'translate(' + offset[0] + ',' + offset[1] + ') scale(' + scaleRatio + ')');
      }
  };
  
  // N.B. mapbox-gl only allows one accessToken to be set per page:
  // https://github.com/mapbox/mapbox-gl-js/issues/6331
  function findAccessToken(gd, mapboxIds) {
      var fullLayout = gd._fullLayout;
      var context = gd._context;
  
      // special case for Mapbox Atlas users
      if(context.mapboxAccessToken === '') return '';
  
      var tokensUseful = [];
      var tokensListed = [];
      var hasOneSetMapboxStyle = false;
      var wontWork = false;
  
      // Take the first token we find in a mapbox subplot.
      // These default to the context value but may be overridden.
      for(var i = 0; i < mapboxIds.length; i++) {
          var opts = fullLayout[mapboxIds[i]];
          var token = opts.accesstoken;
  
          if(isMapboxStyle(opts.style)) {
              if(token) {
                  Lib.pushUnique(tokensUseful, token);
              } else {
                  if(isMapboxStyle(opts._input.style)) {
                      Lib.error('Uses Mapbox map style, but did not set an access token.');
                      hasOneSetMapboxStyle = true;
                  }
                  wontWork = true;
              }
          }
  
          if(token) {
              Lib.pushUnique(tokensListed, token);
          }
      }
  
      if(wontWork) {
          var msg = hasOneSetMapboxStyle ?
              constants.noAccessTokenErrorMsg :
              constants.missingStyleErrorMsg;
          Lib.error(msg);
          throw new Error(msg);
      }
  
      if(tokensUseful.length) {
          if(tokensUseful.length > 1) {
              Lib.warn(constants.multipleTokensErrorMsg);
          }
          return tokensUseful[0];
      } else {
          if(tokensListed.length) {
              Lib.log([
                  'Listed mapbox access token(s)', tokensListed.join(','),
                  'but did not use a Mapbox map style, ignoring token(s).'
              ].join(' '));
          }
          return '';
      }
  }
  
  function isMapboxStyle(s) {
      return typeof s === 'string' && (
          constants.styleValuesMapbox.indexOf(s) !== -1 ||
          s.indexOf('mapbox://') === 0
      );
  }
  
  exports.updateFx = function(gd) {
      var fullLayout = gd._fullLayout;
      var subplotIds = fullLayout._subplots[MAPBOX];
  
      for(var i = 0; i < subplotIds.length; i++) {
          var subplotObj = fullLayout[subplotIds[i]]._subplot;
          subplotObj.updateFx(fullLayout);
      }
  };
  
  },{"../../components/drawing":637,"../../constants/xmlns_namespaces":726,"../../lib":750,"../../lib/svg_text_utils":774,"../../plots/get_data":836,"./constants":854,"./layout_attributes":858,"./layout_defaults":859,"./mapbox":860,"d3":169,"mapbox-gl":447}],857:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var sanitizeHTML = _dereq_('../../lib/svg_text_utils').sanitizeHTML;
  var convertTextOpts = _dereq_('./convert_text_opts');
  var constants = _dereq_('./constants');
  
  function MapboxLayer(subplot, index) {
      this.subplot = subplot;
  
      this.uid = subplot.uid + '-' + index;
      this.index = index;
  
      this.idSource = 'source-' + this.uid;
      this.idLayer = constants.layoutLayerPrefix + this.uid;
  
      // some state variable to check if a remove/add step is needed
      this.sourceType = null;
      this.source = null;
      this.layerType = null;
      this.below = null;
  
      // is layer currently visible
      this.visible = false;
  }
  
  var proto = MapboxLayer.prototype;
  
  proto.update = function update(opts) {
      if(!this.visible) {
          // IMPORTANT: must create source before layer to not cause errors
          this.updateSource(opts);
          this.updateLayer(opts);
      } else if(this.needsNewImage(opts)) {
          this.updateImage(opts);
      } else if(this.needsNewSource(opts)) {
          // IMPORTANT: must delete layer before source to not cause errors
          this.removeLayer();
          this.updateSource(opts);
          this.updateLayer(opts);
      } else if(this.needsNewLayer(opts)) {
          this.updateLayer(opts);
      } else {
          this.updateStyle(opts);
      }
  
      this.visible = isVisible(opts);
  };
  
  proto.needsNewImage = function(opts) {
      var map = this.subplot.map;
      return (
          map.getSource(this.idSource) &&
          this.sourceType === 'image' &&
          opts.sourcetype === 'image' &&
          (this.source !== opts.source ||
              JSON.stringify(this.coordinates) !==
              JSON.stringify(opts.coordinates))
      );
  };
  
  proto.needsNewSource = function(opts) {
      // for some reason changing layer to 'fill' or 'symbol'
      // w/o changing the source throws an exception in mapbox-gl 0.18 ;
      // stay safe and make new source on type changes
      return (
          this.sourceType !== opts.sourcetype ||
          this.source !== opts.source ||
          this.layerType !== opts.type
      );
  };
  
  proto.needsNewLayer = function(opts) {
      return (
          this.layerType !== opts.type ||
          this.below !== this.subplot.belowLookup['layout-' + this.index]
      );
  };
  
  proto.updateImage = function(opts) {
      var map = this.subplot.map;
      map.getSource(this.idSource).updateImage({
          url: opts.source, coordinates: opts.coordinates
      });
  };
  
  proto.updateSource = function(opts) {
      var map = this.subplot.map;
  
      if(map.getSource(this.idSource)) map.removeSource(this.idSource);
  
      this.sourceType = opts.sourcetype;
      this.source = opts.source;
  
      if(!isVisible(opts)) return;
  
      var sourceOpts = convertSourceOpts(opts);
  
      map.addSource(this.idSource, sourceOpts);
  };
  
  proto.updateLayer = function(opts) {
      var subplot = this.subplot;
      var convertedOpts = convertOpts(opts);
  
      var below = this.subplot.belowLookup['layout-' + this.index];
      var _below;
  
      if(below === 'traces') {
          var mapLayers = subplot.getMapLayers();
  
          // find id of first plotly trace layer
          for(var i = 0; i < mapLayers.length; i++) {
              var layerId = mapLayers[i].id;
              if(typeof layerId === 'string' &&
                  layerId.indexOf(constants.traceLayerPrefix) === 0
              ) {
                  _below = layerId;
                  break;
              }
          }
      } else {
          _below = below;
      }
  
      this.removeLayer();
  
      if(isVisible(opts)) {
          subplot.addLayer({
              id: this.idLayer,
              source: this.idSource,
              'source-layer': opts.sourcelayer || '',
              type: opts.type,
              minzoom: opts.minzoom,
              maxzoom: opts.maxzoom,
              layout: convertedOpts.layout,
              paint: convertedOpts.paint
          }, _below);
      }
  
      this.layerType = opts.type;
      this.below = below;
  };
  
  proto.updateStyle = function(opts) {
      if(isVisible(opts)) {
          var convertedOpts = convertOpts(opts);
          this.subplot.setOptions(this.idLayer, 'setLayoutProperty', convertedOpts.layout);
          this.subplot.setOptions(this.idLayer, 'setPaintProperty', convertedOpts.paint);
      }
  };
  
  proto.removeLayer = function() {
      var map = this.subplot.map;
      if(map.getLayer(this.idLayer)) {
          map.removeLayer(this.idLayer);
      }
  };
  
  proto.dispose = function() {
      var map = this.subplot.map;
      if(map.getLayer(this.idLayer)) map.removeLayer(this.idLayer);
      if(map.getSource(this.idSource)) map.removeSource(this.idSource);
  };
  
  function isVisible(opts) {
      if(!opts.visible) return false;
  
      var source = opts.source;
  
      if(Array.isArray(source) && source.length > 0) {
          for(var i = 0; i < source.length; i++) {
              if(typeof source[i] !== 'string' || source[i].length === 0) {
                  return false;
              }
          }
          return true;
      }
  
      return Lib.isPlainObject(source) ||
          (typeof source === 'string' && source.length > 0);
  }
  
  function convertOpts(opts) {
      var layout = {};
      var paint = {};
  
      switch(opts.type) {
          case 'circle':
              Lib.extendFlat(paint, {
                  'circle-radius': opts.circle.radius,
                  'circle-color': opts.color,
                  'circle-opacity': opts.opacity
              });
              break;
  
          case 'line':
              Lib.extendFlat(paint, {
                  'line-width': opts.line.width,
                  'line-color': opts.color,
                  'line-opacity': opts.opacity,
                  'line-dasharray': opts.line.dash
              });
              break;
  
          case 'fill':
              Lib.extendFlat(paint, {
                  'fill-color': opts.color,
                  'fill-outline-color': opts.fill.outlinecolor,
                  'fill-opacity': opts.opacity
  
                  // no way to pass specify outline width at the moment
              });
              break;
  
          case 'symbol':
              var symbol = opts.symbol;
              var textOpts = convertTextOpts(symbol.textposition, symbol.iconsize);
  
              Lib.extendFlat(layout, {
                  'icon-image': symbol.icon + '-15',
                  'icon-size': symbol.iconsize / 10,
  
                  'text-field': symbol.text,
                  'text-size': symbol.textfont.size,
                  'text-anchor': textOpts.anchor,
                  'text-offset': textOpts.offset,
                  'symbol-placement': symbol.placement,
  
                  // TODO font family
                  // 'text-font': symbol.textfont.family.split(', '),
              });
  
              Lib.extendFlat(paint, {
                  'icon-color': opts.color,
                  'text-color': symbol.textfont.color,
                  'text-opacity': opts.opacity
              });
              break;
          case 'raster':
              Lib.extendFlat(paint, {
                  'raster-fade-duration': 0,
                  'raster-opacity': opts.opacity
              });
              break;
      }
  
      return {
          layout: layout,
          paint: paint
      };
  }
  
  function convertSourceOpts(opts) {
      var sourceType = opts.sourcetype;
      var source = opts.source;
      var sourceOpts = {type: sourceType};
      var field;
  
      if(sourceType === 'geojson') {
          field = 'data';
      } else if(sourceType === 'vector') {
          field = typeof source === 'string' ? 'url' : 'tiles';
      } else if(sourceType === 'raster') {
          field = 'tiles';
          sourceOpts.tileSize = 256;
      } else if(sourceType === 'image') {
          field = 'url';
          sourceOpts.coordinates = opts.coordinates;
      }
  
      sourceOpts[field] = source;
  
      if(opts.sourceattribution) {
          sourceOpts.attribution = sanitizeHTML(opts.sourceattribution);
      }
  
      return sourceOpts;
  }
  
  module.exports = function createMapboxLayer(subplot, index, opts) {
      var mapboxLayer = new MapboxLayer(subplot, index);
  
      mapboxLayer.update(opts);
  
      return mapboxLayer;
  };
  
  },{"../../lib":750,"../../lib/svg_text_utils":774,"./constants":854,"./convert_text_opts":855}],858:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var defaultLine = _dereq_('../../components/color').defaultLine;
  var domainAttrs = _dereq_('../domain').attributes;
  var fontAttrs = _dereq_('../font_attributes');
  var textposition = _dereq_('../../traces/scatter/attributes').textposition;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  
  var constants = _dereq_('./constants');
  
  var fontAttr = fontAttrs({
      
  });
  fontAttr.family.dflt = 'Open Sans Regular, Arial Unicode MS Regular';
  
  var attrs = module.exports = overrideAll({
      _arrayAttrRegexps: [Lib.counterRegex('mapbox', '.layers', true)],
  
      domain: domainAttrs({name: 'mapbox'}),
  
      accesstoken: {
          valType: 'string',
          noBlank: true,
          strict: true,
          
          
      },
      style: {
          valType: 'any',
          values: constants.styleValuesMapbox.concat(constants.styleValuesNonMapbox),
          dflt: constants.styleValueDflt,
          
          
      },
  
      center: {
          lon: {
              valType: 'number',
              dflt: 0,
              
              
          },
          lat: {
              valType: 'number',
              dflt: 0,
              
              
          }
      },
      zoom: {
          valType: 'number',
          dflt: 1,
          
          
      },
      bearing: {
          valType: 'number',
          dflt: 0,
          
          
      },
      pitch: {
          valType: 'number',
          dflt: 0,
          
          
      },
  
      layers: templatedArray('layer', {
          visible: {
              valType: 'boolean',
              
              dflt: true,
              
          },
          sourcetype: {
              valType: 'enumerated',
              values: ['geojson', 'vector', 'raster', 'image'],
              dflt: 'geojson',
              
              
          },
  
          source: {
              valType: 'any',
              
              
          },
  
          sourcelayer: {
              valType: 'string',
              dflt: '',
              
              
          },
  
          sourceattribution: {
              valType: 'string',
              
              
          },
  
          type: {
              valType: 'enumerated',
              values: ['circle', 'line', 'fill', 'symbol', 'raster'],
              dflt: 'circle',
              
              
          },
  
          coordinates: {
              valType: 'any',
              
              
          },
  
          // attributes shared between all types
          below: {
              valType: 'string',
              
              
          },
          color: {
              valType: 'color',
              dflt: defaultLine,
              
              
          },
          opacity: {
              valType: 'number',
              min: 0,
              max: 1,
              dflt: 1,
              
              
          },
          minzoom: {
              valType: 'number',
              min: 0,
              max: 24,
              dflt: 0,
              
              
          },
          maxzoom: {
              valType: 'number',
              min: 0,
              max: 24,
              dflt: 24,
              
              
          },
  
          // type-specific style attributes
          circle: {
              radius: {
                  valType: 'number',
                  dflt: 15,
                  
                  
              }
          },
  
          line: {
              width: {
                  valType: 'number',
                  dflt: 2,
                  
                  
              },
              dash: {
                  valType: 'data_array',
                  
                  
              }
          },
  
          fill: {
              outlinecolor: {
                  valType: 'color',
                  dflt: defaultLine,
                  
                  
              }
          },
  
          symbol: {
              icon: {
                  valType: 'string',
                  dflt: 'marker',
                  
                  
              },
              iconsize: {
                  valType: 'number',
                  dflt: 10,
                  
                  
              },
              text: {
                  valType: 'string',
                  dflt: '',
                  
                  
              },
              placement: {
                  valType: 'enumerated',
                  values: ['point', 'line', 'line-center'],
                  dflt: 'point',
                  
                  
              },
              textfont: fontAttr,
              textposition: Lib.extendFlat({}, textposition, { arrayOk: false })
          }
      })
  }, 'plot', 'from-root');
  
  // set uirevision outside of overrideAll so it can be `editType: 'none'`
  attrs.uirevision = {
      valType: 'any',
      
      editType: 'none',
      
  };
  
  },{"../../components/color":615,"../../lib":750,"../../plot_api/edit_types":781,"../../plot_api/plot_template":788,"../../traces/scatter/attributes":1158,"../domain":826,"../font_attributes":827,"./constants":854}],859:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleSubplotDefaults = _dereq_('../subplot_defaults');
  var handleArrayContainerDefaults = _dereq_('../array_container_defaults');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
      handleSubplotDefaults(layoutIn, layoutOut, fullData, {
          type: 'mapbox',
          attributes: layoutAttributes,
          handleDefaults: handleDefaults,
          partition: 'y',
          accessToken: layoutOut._mapboxAccessToken
      });
  };
  
  function handleDefaults(containerIn, containerOut, coerce, opts) {
      coerce('accesstoken', opts.accessToken);
      coerce('style');
      coerce('center.lon');
      coerce('center.lat');
      coerce('zoom');
      coerce('bearing');
      coerce('pitch');
  
      handleArrayContainerDefaults(containerIn, containerOut, {
          name: 'layers',
          handleItemDefaults: handleLayerDefaults
      });
  
      // copy ref to input container to update 'center' and 'zoom' on map move
      containerOut._input = containerIn;
  }
  
  function handleLayerDefaults(layerIn, layerOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(layerIn, layerOut, layoutAttributes.layers, attr, dflt);
      }
  
      var visible = coerce('visible');
      if(visible) {
          var sourceType = coerce('sourcetype');
          var mustBeRasterLayer = sourceType === 'raster' || sourceType === 'image';
  
          coerce('source');
          coerce('sourceattribution');
  
          if(sourceType === 'vector') {
              coerce('sourcelayer');
          }
  
          if(sourceType === 'image') {
              coerce('coordinates');
          }
  
          var typeDflt;
          if(mustBeRasterLayer) typeDflt = 'raster';
  
          var type = coerce('type', typeDflt);
  
          if(mustBeRasterLayer && type !== 'raster') {
              type = layerOut.type = 'raster';
              Lib.log('Source types *raster* and *image* must drawn *raster* layer type.');
          }
  
          coerce('below');
          coerce('color');
          coerce('opacity');
          coerce('minzoom');
          coerce('maxzoom');
  
          if(type === 'circle') {
              coerce('circle.radius');
          }
  
          if(type === 'line') {
              coerce('line.width');
              coerce('line.dash');
          }
  
          if(type === 'fill') {
              coerce('fill.outlinecolor');
          }
  
          if(type === 'symbol') {
              coerce('symbol.icon');
              coerce('symbol.iconsize');
  
              coerce('symbol.text');
              Lib.coerceFont(coerce, 'symbol.textfont');
              coerce('symbol.textposition');
              coerce('symbol.placement');
          }
      }
  }
  
  },{"../../lib":750,"../array_container_defaults":794,"../subplot_defaults":876,"./layout_attributes":858}],860:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var mapboxgl = _dereq_('mapbox-gl');
  
  var Lib = _dereq_('../../lib');
  var geoUtils = _dereq_('../../lib/geo_location_utils');
  var Registry = _dereq_('../../registry');
  var Axes = _dereq_('../cartesian/axes');
  var dragElement = _dereq_('../../components/dragelement');
  
  var Fx = _dereq_('../../components/fx');
  var dragHelpers = _dereq_('../../components/dragelement/helpers');
  var rectMode = dragHelpers.rectMode;
  var drawMode = dragHelpers.drawMode;
  var selectMode = dragHelpers.selectMode;
  
  var prepSelect = _dereq_('../cartesian/select').prepSelect;
  var clearSelect = _dereq_('../cartesian/select').clearSelect;
  var clearSelectionsCache = _dereq_('../cartesian/select').clearSelectionsCache;
  var selectOnClick = _dereq_('../cartesian/select').selectOnClick;
  
  var constants = _dereq_('./constants');
  var createMapboxLayer = _dereq_('./layers');
  
  function Mapbox(gd, id) {
      this.id = id;
      this.gd = gd;
  
      var fullLayout = gd._fullLayout;
      var context = gd._context;
  
      this.container = fullLayout._glcontainer.node();
      this.isStatic = context.staticPlot;
  
      // unique id for this Mapbox instance
      this.uid = fullLayout._uid + '-' + this.id;
  
      // create framework on instantiation for a smoother first plot call
      this.div = null;
      this.xaxis = null;
      this.yaxis = null;
      this.createFramework(fullLayout);
  
      // state variables used to infer how and what to update
      this.map = null;
      this.accessToken = null;
      this.styleObj = null;
      this.traceHash = {};
      this.layerList = [];
      this.belowLookup = {};
      this.dragging = false;
      this.wheeling = false;
  }
  
  var proto = Mapbox.prototype;
  
  proto.plot = function(calcData, fullLayout, promises) {
      var self = this;
      var opts = fullLayout[self.id];
  
      // remove map and create a new map if access token has change
      if(self.map && (opts.accesstoken !== self.accessToken)) {
          self.map.remove();
          self.map = null;
          self.styleObj = null;
          self.traceHash = {};
          self.layerList = [];
      }
  
      var promise;
  
      if(!self.map) {
          promise = new Promise(function(resolve, reject) {
              self.createMap(calcData, fullLayout, resolve, reject);
          });
      } else {
          promise = new Promise(function(resolve, reject) {
              self.updateMap(calcData, fullLayout, resolve, reject);
          });
      }
  
      promises.push(promise);
  };
  
  proto.createMap = function(calcData, fullLayout, resolve, reject) {
      var self = this;
      var opts = fullLayout[self.id];
  
      // store style id and URL or object
      var styleObj = self.styleObj = getStyleObj(opts.style);
  
      // store access token associated with this map
      self.accessToken = opts.accesstoken;
  
      // create the map!
      var map = self.map = new mapboxgl.Map({
          container: self.div,
  
          style: styleObj.style,
          center: convertCenter(opts.center),
          zoom: opts.zoom,
          bearing: opts.bearing,
          pitch: opts.pitch,
  
          interactive: !self.isStatic,
          preserveDrawingBuffer: self.isStatic,
  
          doubleClickZoom: false,
          boxZoom: false,
  
          attributionControl: false
      })
      .addControl(new mapboxgl.AttributionControl({
          compact: true
      }));
  
  
      // make sure canvas does not inherit left and top css
      map._canvas.style.left = '0px';
      map._canvas.style.top = '0px';
  
      self.rejectOnError(reject);
  
      if(!self.isStatic) {
          self.initFx(calcData, fullLayout);
      }
  
      var promises = [];
  
      promises.push(new Promise(function(resolve) {
          map.once('load', resolve);
      }));
  
      promises = promises.concat(geoUtils.fetchTraceGeoData(calcData));
  
      Promise.all(promises).then(function() {
          self.fillBelowLookup(calcData, fullLayout);
          self.updateData(calcData);
          self.updateLayout(fullLayout);
          self.resolveOnRender(resolve);
      }).catch(reject);
  };
  
  proto.updateMap = function(calcData, fullLayout, resolve, reject) {
      var self = this;
      var map = self.map;
      var opts = fullLayout[this.id];
  
      self.rejectOnError(reject);
  
      var promises = [];
      var styleObj = getStyleObj(opts.style);
  
      if(JSON.stringify(self.styleObj) !== JSON.stringify(styleObj)) {
          self.styleObj = styleObj;
          map.setStyle(styleObj.style);
  
          // need to rebuild trace layers on reload
          // to avoid 'lost event' errors
          self.traceHash = {};
  
          promises.push(new Promise(function(resolve) {
              map.once('styledata', resolve);
          }));
      }
  
      promises = promises.concat(geoUtils.fetchTraceGeoData(calcData));
  
      Promise.all(promises).then(function() {
          self.fillBelowLookup(calcData, fullLayout);
          self.updateData(calcData);
          self.updateLayout(fullLayout);
          self.resolveOnRender(resolve);
      }).catch(reject);
  };
  
  proto.fillBelowLookup = function(calcData, fullLayout) {
      var opts = fullLayout[this.id];
      var layers = opts.layers;
      var i, val;
  
      var belowLookup = this.belowLookup = {};
      var hasTraceAtTop = false;
  
      for(i = 0; i < calcData.length; i++) {
          var trace = calcData[i][0].trace;
          var _module = trace._module;
  
          if(typeof trace.below === 'string') {
              val = trace.below;
          } else if(_module.getBelow) {
              // 'smart' default that depend the map's base layers
              val = _module.getBelow(trace, this);
          }
  
          if(val === '') {
              hasTraceAtTop = true;
          }
  
          belowLookup['trace-' + trace.uid] = val || '';
      }
  
      for(i = 0; i < layers.length; i++) {
          var item = layers[i];
  
          if(typeof item.below === 'string') {
              val = item.below;
          } else if(hasTraceAtTop) {
              // if one or more trace(s) set `below:''` and
              // layers[i].below is unset,
              // place layer below traces
              val = 'traces';
          } else {
              val = '';
          }
  
          belowLookup['layout-' + i] = val;
      }
  
      // N.B. If multiple layers have the 'below' value,
      // we must clear the stashed 'below' field in order
      // to make `traceHash[k].update()` and `layerList[i].update()`
      // remove/add the all those layers to have preserve
      // the correct layer ordering
      var val2list = {};
      var k, id;
  
      for(k in belowLookup) {
          val = belowLookup[k];
          if(val2list[val]) {
              val2list[val].push(k);
          } else {
              val2list[val] = [k];
          }
      }
  
      for(val in val2list) {
          var list = val2list[val];
          if(list.length > 1) {
              for(i = 0; i < list.length; i++) {
                  k = list[i];
                  if(k.indexOf('trace-') === 0) {
                      id = k.split('trace-')[1];
                      if(this.traceHash[id]) {
                          this.traceHash[id].below = null;
                      }
                  } else if(k.indexOf('layout-') === 0) {
                      id = k.split('layout-')[1];
                      if(this.layerList[id]) {
                          this.layerList[id].below = null;
                      }
                  }
              }
          }
      }
  };
  
  var traceType2orderIndex = {
      choroplethmapbox: 0,
      densitymapbox: 1,
      scattermapbox: 2
  };
  
  proto.updateData = function(calcData) {
      var traceHash = this.traceHash;
      var traceObj, trace, i, j;
  
      // Need to sort here by trace type here,
      // in case traces with different `type` have the same
      // below value, but sorting we ensure that
      // e.g. choroplethmapbox traces will be below scattermapbox traces
      var calcDataSorted = calcData.slice().sort(function(a, b) {
          return (
              traceType2orderIndex[a[0].trace.type] -
              traceType2orderIndex[b[0].trace.type]
          );
      });
  
      // update or create trace objects
      for(i = 0; i < calcDataSorted.length; i++) {
          var calcTrace = calcDataSorted[i];
  
          trace = calcTrace[0].trace;
          traceObj = traceHash[trace.uid];
  
          var didUpdate = false;
          if(traceObj) {
              if(traceObj.type === trace.type) {
                  traceObj.update(calcTrace);
                  didUpdate = true;
              } else {
                  traceObj.dispose();
              }
          }
          if(!didUpdate && trace._module) {
              traceHash[trace.uid] = trace._module.plot(this, calcTrace);
          }
      }
  
      // remove empty trace objects
      var ids = Object.keys(traceHash);
      idLoop:
      for(i = 0; i < ids.length; i++) {
          var id = ids[i];
  
          for(j = 0; j < calcData.length; j++) {
              trace = calcData[j][0].trace;
              if(id === trace.uid) continue idLoop;
          }
  
          traceObj = traceHash[id];
          traceObj.dispose();
          delete traceHash[id];
      }
  };
  
  proto.updateLayout = function(fullLayout) {
      var map = this.map;
      var opts = fullLayout[this.id];
  
      if(!this.dragging && !this.wheeling) {
          map.setCenter(convertCenter(opts.center));
          map.setZoom(opts.zoom);
          map.setBearing(opts.bearing);
          map.setPitch(opts.pitch);
      }
  
      this.updateLayers(fullLayout);
      this.updateFramework(fullLayout);
      this.updateFx(fullLayout);
      this.map.resize();
  
      if(this.gd._context._scrollZoom.mapbox) {
          map.scrollZoom.enable();
      } else {
          map.scrollZoom.disable();
      }
  };
  
  proto.resolveOnRender = function(resolve) {
      var map = this.map;
  
      map.on('render', function onRender() {
          if(map.loaded()) {
              map.off('render', onRender);
              // resolve at end of render loop
              //
              // Need a 10ms delay (0ms should suffice to skip a thread in the
              // render loop) to workaround mapbox-gl bug introduced in v1.3.0
              setTimeout(resolve, 10);
          }
      });
  };
  
  proto.rejectOnError = function(reject) {
      var map = this.map;
  
      function handler() {
          reject(new Error(constants.mapOnErrorMsg));
      }
  
      map.once('error', handler);
      map.once('style.error', handler);
      map.once('source.error', handler);
      map.once('tile.error', handler);
      map.once('layer.error', handler);
  };
  
  proto.createFramework = function(fullLayout) {
      var self = this;
  
      var div = self.div = document.createElement('div');
      div.id = self.uid;
      div.style.position = 'absolute';
      self.container.appendChild(div);
  
      // create mock x/y axes for hover routine
      self.xaxis = {
          _id: 'x',
          c2p: function(v) { return self.project(v).x; }
      };
      self.yaxis = {
          _id: 'y',
          c2p: function(v) { return self.project(v).y; }
      };
  
      self.updateFramework(fullLayout);
  
      // mock axis for hover formatting
      self.mockAxis = {
          type: 'linear',
          showexponent: 'all',
          exponentformat: 'B'
      };
      Axes.setConvert(self.mockAxis, fullLayout);
  };
  
  proto.initFx = function(calcData, fullLayout) {
      var self = this;
      var gd = self.gd;
      var map = self.map;
  
      // keep track of pan / zoom in user layout and emit relayout event
      map.on('moveend', function(evt) {
          if(!self.map) return;
  
          var fullLayoutNow = gd._fullLayout;
  
          // 'moveend' gets triggered by map.setCenter, map.setZoom,
          // map.setBearing and map.setPitch.
          //
          // Here, we make sure that state updates amd 'plotly_relayout'
          // are triggered only when the 'moveend' originates from a
          // mouse target (filtering out API calls) to not
          // duplicate 'plotly_relayout' events.
  
          if(evt.originalEvent || self.wheeling) {
              var optsNow = fullLayoutNow[self.id];
              Registry.call('_storeDirectGUIEdit', gd.layout, fullLayoutNow._preGUI, self.getViewEdits(optsNow));
  
              var viewNow = self.getView();
              optsNow._input.center = optsNow.center = viewNow.center;
              optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
              optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
              optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
              gd.emit('plotly_relayout', self.getViewEditsWithDerived(viewNow));
          }
          if(evt.originalEvent && evt.originalEvent.type === 'mouseup') {
              self.dragging = false;
          } else if(self.wheeling) {
              self.wheeling = false;
          }
  
          if(fullLayoutNow._rehover) {
              fullLayoutNow._rehover();
          }
      });
  
      map.on('wheel', function() {
          self.wheeling = true;
      });
  
      map.on('mousemove', function(evt) {
          var bb = self.div.getBoundingClientRect();
  
          // some hackery to get Fx.hover to work
          evt.clientX = evt.point.x + bb.left;
          evt.clientY = evt.point.y + bb.top;
  
          evt.target.getBoundingClientRect = function() { return bb; };
  
          self.xaxis.p2c = function() { return evt.lngLat.lng; };
          self.yaxis.p2c = function() { return evt.lngLat.lat; };
  
          gd._fullLayout._rehover = function() {
              if(gd._fullLayout._hoversubplot === self.id && gd._fullLayout[self.id]) {
                  Fx.hover(gd, evt, self.id);
              }
          };
  
          Fx.hover(gd, evt, self.id);
          gd._fullLayout._hoversubplot = self.id;
      });
  
      function unhover() {
          Fx.loneUnhover(fullLayout._hoverlayer);
      }
  
      map.on('dragstart', function() {
          self.dragging = true;
          unhover();
      });
      map.on('zoomstart', unhover);
  
      map.on('mouseout', function() {
          gd._fullLayout._hoversubplot = null;
      });
  
      function emitUpdate() {
          var viewNow = self.getView();
          gd.emit('plotly_relayouting', self.getViewEditsWithDerived(viewNow));
      }
  
      map.on('drag', emitUpdate);
      map.on('zoom', emitUpdate);
  
      map.on('dblclick', function() {
          var optsNow = gd._fullLayout[self.id];
          Registry.call('_storeDirectGUIEdit', gd.layout, gd._fullLayout._preGUI, self.getViewEdits(optsNow));
  
          var viewInitial = self.viewInitial;
          map.setCenter(convertCenter(viewInitial.center));
          map.setZoom(viewInitial.zoom);
          map.setBearing(viewInitial.bearing);
          map.setPitch(viewInitial.pitch);
  
          var viewNow = self.getView();
          optsNow._input.center = optsNow.center = viewNow.center;
          optsNow._input.zoom = optsNow.zoom = viewNow.zoom;
          optsNow._input.bearing = optsNow.bearing = viewNow.bearing;
          optsNow._input.pitch = optsNow.pitch = viewNow.pitch;
  
          gd.emit('plotly_doubleclick', null);
          gd.emit('plotly_relayout', self.getViewEditsWithDerived(viewNow));
      });
  
      // define event handlers on map creation, to keep one ref per map,
      // so that map.on / map.off in updateFx works as expected
      self.clearSelect = function() {
          clearSelectionsCache(self.dragOptions);
          clearSelect(self.dragOptions.gd);
      };
  
      /**
       * Returns a click handler function that is supposed
       * to handle clicks in pan mode.
       */
      self.onClickInPanFn = function(dragOptions) {
          return function(evt) {
              var clickMode = gd._fullLayout.clickmode;
  
              if(clickMode.indexOf('select') > -1) {
                  selectOnClick(evt.originalEvent, gd, [self.xaxis], [self.yaxis], self.id, dragOptions);
              }
  
              if(clickMode.indexOf('event') > -1) {
                  // TODO: this does not support right-click. If we want to support it, we
                  // would likely need to change mapbox to use dragElement instead of straight
                  // mapbox event binding. Or perhaps better, make a simple wrapper with the
                  // right mousedown, mousemove, and mouseup handlers just for a left/right click
                  // pie would use this too.
                  Fx.click(gd, evt.originalEvent);
              }
          };
      };
  };
  
  proto.updateFx = function(fullLayout) {
      var self = this;
      var map = self.map;
      var gd = self.gd;
  
      if(self.isStatic) return;
  
      function invert(pxpy) {
          var obj = self.map.unproject(pxpy);
          return [obj.lng, obj.lat];
      }
  
      var dragMode = fullLayout.dragmode;
      var fillRangeItems;
  
      if(rectMode(dragMode)) {
          fillRangeItems = function(eventData, poly) {
              var ranges = eventData.range = {};
              ranges[self.id] = [
                  invert([poly.xmin, poly.ymin]),
                  invert([poly.xmax, poly.ymax])
              ];
          };
      } else {
          fillRangeItems = function(eventData, poly, pts) {
              var dataPts = eventData.lassoPoints = {};
              dataPts[self.id] = pts.filtered.map(invert);
          };
      }
  
      // Note: dragOptions is needed to be declared for all dragmodes because
      // it's the object that holds persistent selection state.
      // Merge old dragOptions with new to keep possibly initialized
      // persistent selection state.
      var oldDragOptions = self.dragOptions;
      self.dragOptions = Lib.extendDeep(oldDragOptions || {}, {
          dragmode: fullLayout.dragmode,
          element: self.div,
          gd: gd,
          plotinfo: {
              id: self.id,
              domain: fullLayout[self.id].domain,
              xaxis: self.xaxis,
              yaxis: self.yaxis,
              fillRangeItems: fillRangeItems
          },
          xaxes: [self.xaxis],
          yaxes: [self.yaxis],
          subplot: self.id
      });
  
      // Unregister the old handler before potentially registering
      // a new one. Otherwise multiple click handlers might
      // be registered resulting in unwanted behavior.
      map.off('click', self.onClickInPanHandler);
      if(selectMode(dragMode) || drawMode(dragMode)) {
          map.dragPan.disable();
          map.on('zoomstart', self.clearSelect);
  
          self.dragOptions.prepFn = function(e, startX, startY) {
              prepSelect(e, startX, startY, self.dragOptions, dragMode);
          };
  
          dragElement.init(self.dragOptions);
      } else {
          map.dragPan.enable();
          map.off('zoomstart', self.clearSelect);
          self.div.onmousedown = null;
  
          // TODO: this does not support right-click. If we want to support it, we
          // would likely need to change mapbox to use dragElement instead of straight
          // mapbox event binding. Or perhaps better, make a simple wrapper with the
          // right mousedown, mousemove, and mouseup handlers just for a left/right click
          // pie would use this too.
          self.onClickInPanHandler = self.onClickInPanFn(self.dragOptions);
          map.on('click', self.onClickInPanHandler);
      }
  };
  
  proto.updateFramework = function(fullLayout) {
      var domain = fullLayout[this.id].domain;
      var size = fullLayout._size;
  
      var style = this.div.style;
      style.width = size.w * (domain.x[1] - domain.x[0]) + 'px';
      style.height = size.h * (domain.y[1] - domain.y[0]) + 'px';
      style.left = size.l + domain.x[0] * size.w + 'px';
      style.top = size.t + (1 - domain.y[1]) * size.h + 'px';
  
      this.xaxis._offset = size.l + domain.x[0] * size.w;
      this.xaxis._length = size.w * (domain.x[1] - domain.x[0]);
  
      this.yaxis._offset = size.t + (1 - domain.y[1]) * size.h;
      this.yaxis._length = size.h * (domain.y[1] - domain.y[0]);
  };
  
  proto.updateLayers = function(fullLayout) {
      var opts = fullLayout[this.id];
      var layers = opts.layers;
      var layerList = this.layerList;
      var i;
  
      // if the layer arrays don't match,
      // don't try to be smart,
      // delete them all, and start all over.
  
      if(layers.length !== layerList.length) {
          for(i = 0; i < layerList.length; i++) {
              layerList[i].dispose();
          }
  
          layerList = this.layerList = [];
  
          for(i = 0; i < layers.length; i++) {
              layerList.push(createMapboxLayer(this, i, layers[i]));
          }
      } else {
          for(i = 0; i < layers.length; i++) {
              layerList[i].update(layers[i]);
          }
      }
  };
  
  proto.destroy = function() {
      if(this.map) {
          this.map.remove();
          this.map = null;
          this.container.removeChild(this.div);
      }
  };
  
  proto.toImage = function() {
      this.map.stop();
      return this.map.getCanvas().toDataURL();
  };
  
  // convenience wrapper to create set multiple layer
  // 'layout' or 'paint options at once.
  proto.setOptions = function(id, methodName, opts) {
      for(var k in opts) {
          this.map[methodName](id, k, opts[k]);
      }
  };
  
  proto.getMapLayers = function() {
      return this.map.getStyle().layers;
  };
  
  // convenience wrapper that first check in 'below' references
  // a layer that exist and then add the layer to the map,
  proto.addLayer = function(opts, below) {
      var map = this.map;
  
      if(typeof below === 'string') {
          if(below === '') {
              map.addLayer(opts, below);
              return;
          }
  
          var mapLayers = this.getMapLayers();
          for(var i = 0; i < mapLayers.length; i++) {
              if(below === mapLayers[i].id) {
                  map.addLayer(opts, below);
                  return;
              }
          }
  
          Lib.warn([
              'Trying to add layer with *below* value',
              below,
              'referencing a layer that does not exist',
              'or that does not yet exist.'
          ].join(' '));
      }
  
      map.addLayer(opts);
  };
  
  // convenience method to project a [lon, lat] array to pixel coords
  proto.project = function(v) {
      return this.map.project(new mapboxgl.LngLat(v[0], v[1]));
  };
  
  // get map's current view values in plotly.js notation
  proto.getView = function() {
      var map = this.map;
      var mapCenter = map.getCenter();
      var center = { lon: mapCenter.lng, lat: mapCenter.lat };
  
      var canvas = map.getCanvas();
      var w = canvas.width;
      var h = canvas.height;
      return {
          center: center,
          zoom: map.getZoom(),
          bearing: map.getBearing(),
          pitch: map.getPitch(),
          _derived: {
              coordinates: [
                  map.unproject([0, 0]).toArray(),
                  map.unproject([w, 0]).toArray(),
                  map.unproject([w, h]).toArray(),
                  map.unproject([0, h]).toArray()
              ]
          }
      };
  };
  
  proto.getViewEdits = function(cont) {
      var id = this.id;
      var keys = ['center', 'zoom', 'bearing', 'pitch'];
      var obj = {};
  
      for(var i = 0; i < keys.length; i++) {
          var k = keys[i];
          obj[id + '.' + k] = cont[k];
      }
  
      return obj;
  };
  
  proto.getViewEditsWithDerived = function(cont) {
      var id = this.id;
      var obj = this.getViewEdits(cont);
      obj[id + '._derived'] = cont._derived;
      return obj;
  };
  
  function getStyleObj(val) {
      var styleObj = {};
  
      if(Lib.isPlainObject(val)) {
          styleObj.id = val.id;
          styleObj.style = val;
      } else if(typeof val === 'string') {
          styleObj.id = val;
  
          if(constants.styleValuesMapbox.indexOf(val) !== -1) {
              styleObj.style = convertStyleVal(val);
          } else if(constants.stylesNonMapbox[val]) {
              styleObj.style = constants.stylesNonMapbox[val];
          } else {
              styleObj.style = val;
          }
      } else {
          styleObj.id = constants.styleValueDflt;
          styleObj.style = convertStyleVal(constants.styleValueDflt);
      }
  
      styleObj.transition = {duration: 0, delay: 0};
  
      return styleObj;
  }
  
  // if style is part of the 'official' mapbox values, add URL prefix and suffix
  function convertStyleVal(val) {
      return constants.styleUrlPrefix + val + '-' + constants.styleUrlSuffix;
  }
  
  function convertCenter(center) {
      return [center.lon, center.lat];
  }
  
  module.exports = Mapbox;
  
  },{"../../components/dragelement":634,"../../components/dragelement/helpers":633,"../../components/fx":655,"../../lib":750,"../../lib/geo_location_utils":743,"../../registry":882,"../cartesian/axes":799,"../cartesian/select":818,"./constants":854,"./layers":857,"mapbox-gl":447}],861:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /**
   * Creates a set of padding attributes.
   *
   * @param {object} opts
   *   @param {string} editType:
   *     the editType for all pieces of this padding definition
   *
   * @return {object} attributes object containing {t, r, b, l} as specified
   */
  module.exports = function(opts) {
      var editType = opts.editType;
      return {
          t: {
              valType: 'number',
              dflt: 0,
              
              editType: editType,
              
          },
          r: {
              valType: 'number',
              dflt: 0,
              
              editType: editType,
              
          },
          b: {
              valType: 'number',
              dflt: 0,
              
              editType: editType,
              
          },
          l: {
              valType: 'number',
              dflt: 0,
              
              editType: editType,
              
          },
          editType: editType
      };
  };
  
  },{}],862:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var timeFormatLocale = _dereq_('d3-time-format').timeFormatLocale;
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Registry = _dereq_('../registry');
  var PlotSchema = _dereq_('../plot_api/plot_schema');
  var Template = _dereq_('../plot_api/plot_template');
  var Lib = _dereq_('../lib');
  var Color = _dereq_('../components/color');
  var BADNUM = _dereq_('../constants/numerical').BADNUM;
  
  var axisIDs = _dereq_('./cartesian/axis_ids');
  var clearSelect = _dereq_('./cartesian/handle_outline').clearSelect;
  
  var animationAttrs = _dereq_('./animation_attributes');
  var frameAttrs = _dereq_('./frame_attributes');
  
  var getModuleCalcData = _dereq_('../plots/get_data').getModuleCalcData;
  
  var relinkPrivateKeys = Lib.relinkPrivateKeys;
  var _ = Lib._;
  
  var plots = module.exports = {};
  
  // Expose registry methods on Plots for backward-compatibility
  Lib.extendFlat(plots, Registry);
  
  plots.attributes = _dereq_('./attributes');
  plots.attributes.type.values = plots.allTypes;
  plots.fontAttrs = _dereq_('./font_attributes');
  plots.layoutAttributes = _dereq_('./layout_attributes');
  
  // TODO make this a plot attribute?
  plots.fontWeight = 'normal';
  
  var transformsRegistry = plots.transformsRegistry;
  
  var commandModule = _dereq_('./command');
  plots.executeAPICommand = commandModule.executeAPICommand;
  plots.computeAPICommandBindings = commandModule.computeAPICommandBindings;
  plots.manageCommandObserver = commandModule.manageCommandObserver;
  plots.hasSimpleAPICommandBindings = commandModule.hasSimpleAPICommandBindings;
  
  // in some cases the browser doesn't seem to know how big
  // the text is at first, so it needs to draw it,
  // then wait a little, then draw it again
  plots.redrawText = function(gd) {
      gd = Lib.getGraphDiv(gd);
  
      var fullLayout = gd._fullLayout || {};
      var hasPolar = fullLayout._has && fullLayout._has('polar');
      var hasLegacyPolar = !hasPolar && gd.data && gd.data[0] && gd.data[0].r;
  
      // do not work if polar is present
      if(hasLegacyPolar) return;
  
      return new Promise(function(resolve) {
          setTimeout(function() {
              Registry.getComponentMethod('annotations', 'draw')(gd);
              Registry.getComponentMethod('legend', 'draw')(gd);
              Registry.getComponentMethod('colorbar', 'draw')(gd);
              resolve(plots.previousPromises(gd));
          }, 300);
      });
  };
  
  // resize plot about the container size
  plots.resize = function(gd) {
      gd = Lib.getGraphDiv(gd);
  
      var resolveLastResize;
      var p = new Promise(function(resolve, reject) {
          if(!gd || Lib.isHidden(gd)) {
              reject(new Error('Resize must be passed a displayed plot div element.'));
          }
  
          if(gd._redrawTimer) clearTimeout(gd._redrawTimer);
          if(gd._resolveResize) resolveLastResize = gd._resolveResize;
          gd._resolveResize = resolve;
  
          gd._redrawTimer = setTimeout(function() {
              // return if there is nothing to resize or is hidden
              if(!gd.layout || (gd.layout.width && gd.layout.height) || Lib.isHidden(gd)) {
                  resolve(gd);
                  return;
              }
  
              delete gd.layout.width;
              delete gd.layout.height;
  
              // autosizing doesn't count as a change that needs saving
              var oldchanged = gd.changed;
  
              // nor should it be included in the undo queue
              gd.autoplay = true;
  
              Registry.call('relayout', gd, {autosize: true}).then(function() {
                  gd.changed = oldchanged;
                  // Only resolve if a new call hasn't been made!
                  if(gd._resolveResize === resolve) {
                      delete gd._resolveResize;
                      resolve(gd);
                  }
              });
          }, 100);
      });
  
      if(resolveLastResize) resolveLastResize(p);
      return p;
  };
  
  
  // for use in Lib.syncOrAsync, check if there are any
  // pending promises in this plot and wait for them
  plots.previousPromises = function(gd) {
      if((gd._promises || []).length) {
          return Promise.all(gd._promises)
              .then(function() { gd._promises = []; });
      }
  };
  
  /**
   * Adds the 'Edit chart' link.
   * Note that now Plotly.plot() calls this so it can regenerate whenever it replots
   *
   * Add source links to your graph inside the 'showSources' config argument.
   */
  plots.addLinks = function(gd) {
      // Do not do anything if showLink and showSources are not set to true in config
      if(!gd._context.showLink && !gd._context.showSources) return;
  
      var fullLayout = gd._fullLayout;
  
      var linkContainer = Lib.ensureSingle(fullLayout._paper, 'text', 'js-plot-link-container', function(s) {
          s.style({
              'font-family': '"Open Sans", Arial, sans-serif',
              'font-size': '12px',
              'fill': Color.defaultLine,
              'pointer-events': 'all'
          })
          .each(function() {
              var links = d3.select(this);
              links.append('tspan').classed('js-link-to-tool', true);
              links.append('tspan').classed('js-link-spacer', true);
              links.append('tspan').classed('js-sourcelinks', true);
          });
      });
  
      // The text node inside svg
      var text = linkContainer.node();
      var attrs = {y: fullLayout._paper.attr('height') - 9};
  
      // If text's width is bigger than the layout
      // Check that text is a child node or document.body
      // because otherwise IE/Edge might throw an exception
      // when calling getComputedTextLength().
      // Apparently offsetParent is null for invisibles.
      if(document.body.contains(text) && text.getComputedTextLength() >= (fullLayout.width - 20)) {
          // Align the text at the left
          attrs['text-anchor'] = 'start';
          attrs.x = 5;
      } else {
          // Align the text at the right
          attrs['text-anchor'] = 'end';
          attrs.x = fullLayout._paper.attr('width') - 7;
      }
  
      linkContainer.attr(attrs);
  
      var toolspan = linkContainer.select('.js-link-to-tool');
      var spacespan = linkContainer.select('.js-link-spacer');
      var sourcespan = linkContainer.select('.js-sourcelinks');
  
      if(gd._context.showSources) gd._context.showSources(gd);
  
      // 'view in plotly' link for embedded plots
      if(gd._context.showLink) positionPlayWithData(gd, toolspan);
  
      // separator if we have both sources and tool link
      spacespan.text((toolspan.text() && sourcespan.text()) ? ' - ' : '');
  };
  
  // note that now this function is only adding the brand in
  // iframes and 3rd-party apps
  function positionPlayWithData(gd, container) {
      container.text('');
      var link = container.append('a')
          .attr({
              'xlink:xlink:href': '#',
              'class': 'link--impt link--embedview',
              'font-weight': 'bold'
          })
          .text(gd._context.linkText + ' ' + String.fromCharCode(187));
  
      if(gd._context.sendData) {
          link.on('click', function() {
              plots.sendDataToCloud(gd);
          });
      } else {
          var path = window.location.pathname.split('/');
          var query = window.location.search;
          link.attr({
              'xlink:xlink:show': 'new',
              'xlink:xlink:href': '/' + path[2].split('.')[0] + '/' + path[1] + query
          });
      }
  }
  
  plots.sendDataToCloud = function(gd) {
      var baseUrl = (window.PLOTLYENV || {}).BASE_URL || gd._context.plotlyServerURL;
      if(!baseUrl) return;
  
      gd.emit('plotly_beforeexport');
  
      var hiddenformDiv = d3.select(gd)
          .append('div')
          .attr('id', 'hiddenform')
          .style('display', 'none');
  
      var hiddenform = hiddenformDiv
          .append('form')
          .attr({
              action: baseUrl + '/external',
              method: 'post',
              target: '_blank'
          });
  
      var hiddenformInput = hiddenform
          .append('input')
          .attr({
              type: 'text',
              name: 'data'
          });
  
      hiddenformInput.node().value = plots.graphJson(gd, false, 'keepdata');
      hiddenform.node().submit();
      hiddenformDiv.remove();
  
      gd.emit('plotly_afterexport');
      return false;
  };
  
  var d3FormatKeys = [
      'days', 'shortDays', 'months', 'shortMonths', 'periods',
      'dateTime', 'date', 'time',
      'decimal', 'thousands', 'grouping', 'currency'
  ];
  
  var extraFormatKeys = [
      'year', 'month', 'dayMonth', 'dayMonthYear'
  ];
  
  /*
   * Fill in default values
   * @param {DOM element} gd
   * @param {object} opts
   * @param {boolean} opts.skipUpdateCalc: normally if the existing gd.calcdata looks
   *   compatible with the new gd._fullData we finish by linking the new _fullData traces
   *   to the old gd.calcdata, so it's correctly set if we're not going to recalc. But also,
   *   if there are calcTransforms on the trace, we first remap data arrays from the old full
   *   trace into the new one. Use skipUpdateCalc to defer this (needed by Plotly.react)
   *
   * gd.data, gd.layout:
   *   are precisely what the user specified (except as modified by cleanData/cleanLayout),
   *   these fields shouldn't be modified (except for filling in some auto values)
   *   nor used directly after the supply defaults step.
   *
   * gd._fullData, gd._fullLayout:
   *   are complete descriptions of how to draw the plot,
   *   use these fields in all required computations.
   *
   * gd._fullLayout._modules
   *   is a list of all the trace modules required to draw the plot.
   *
   * gd._fullLayout._visibleModules
   *   subset of _modules, a list of modules corresponding to visible:true traces.
   *
   * gd._fullLayout._basePlotModules
   *   is a list of all the plot modules required to draw the plot.
   *
   * gd._fullLayout._transformModules
   *   is a list of all the transform modules invoked.
   *
   */
  plots.supplyDefaults = function(gd, opts) {
      var skipUpdateCalc = opts && opts.skipUpdateCalc;
      var oldFullLayout = gd._fullLayout || {};
  
      if(oldFullLayout._skipDefaults) {
          delete oldFullLayout._skipDefaults;
          return;
      }
  
      var newFullLayout = gd._fullLayout = {};
      var newLayout = gd.layout || {};
  
      var oldFullData = gd._fullData || [];
      var newFullData = gd._fullData = [];
      var newData = gd.data || [];
  
      var oldCalcdata = gd.calcdata || [];
  
      var context = gd._context || {};
  
      var i;
  
      // Create all the storage space for frames, but only if doesn't already exist
      if(!gd._transitionData) plots.createTransitionData(gd);
  
      // So we only need to do this once (and since we have gd here)
      // get the translated placeholder titles.
      // These ones get used as default values so need to be known at supplyDefaults
      // others keep their blank defaults but render the placeholder as desired later
      // TODO: make these work the same way, only inserting the placeholder text at draw time?
      // The challenge is that this has slightly different behavior right now in editable mode:
      // using the placeholder as default makes this text permanently (but lightly) visible,
      // but explicit '' for these titles gives you a placeholder that's hidden until you mouse
      // over it - so you're not distracted by it if you really don't want a title, but if you do
      // and you're new to plotly you may not be able to find it.
      // When editable=false the two behave the same, no title is drawn.
      newFullLayout._dfltTitle = {
          plot: _(gd, 'Click to enter Plot title'),
          x: _(gd, 'Click to enter X axis title'),
          y: _(gd, 'Click to enter Y axis title'),
          colorbar: _(gd, 'Click to enter Colorscale title'),
          annotation: _(gd, 'new text')
      };
      newFullLayout._traceWord = _(gd, 'trace');
  
      var formatObj = getFormatObj(gd, d3FormatKeys);
  
      // stash the token from context so mapbox subplots can use it as default
      newFullLayout._mapboxAccessToken = context.mapboxAccessToken;
  
      // first fill in what we can of layout without looking at data
      // because fullData needs a few things from layout
      if(oldFullLayout._initialAutoSizeIsDone) {
          // coerce the updated layout while preserving width and height
          var oldWidth = oldFullLayout.width;
          var oldHeight = oldFullLayout.height;
  
          plots.supplyLayoutGlobalDefaults(newLayout, newFullLayout, formatObj);
  
          if(!newLayout.width) newFullLayout.width = oldWidth;
          if(!newLayout.height) newFullLayout.height = oldHeight;
          plots.sanitizeMargins(newFullLayout);
      } else {
          // coerce the updated layout and autosize if needed
          plots.supplyLayoutGlobalDefaults(newLayout, newFullLayout, formatObj);
  
          var missingWidthOrHeight = (!newLayout.width || !newLayout.height);
          var autosize = newFullLayout.autosize;
          var autosizable = context.autosizable;
          var initialAutoSize = missingWidthOrHeight && (autosize || autosizable);
  
          if(initialAutoSize) plots.plotAutoSize(gd, newLayout, newFullLayout);
          else if(missingWidthOrHeight) plots.sanitizeMargins(newFullLayout);
  
          // for backwards-compatibility with Plotly v1.x.x
          if(!autosize && missingWidthOrHeight) {
              newLayout.width = newFullLayout.width;
              newLayout.height = newFullLayout.height;
          }
      }
  
      newFullLayout._d3locale = getFormatter(formatObj, newFullLayout.separators);
      newFullLayout._extraFormat = getFormatObj(gd, extraFormatKeys);
  
      newFullLayout._initialAutoSizeIsDone = true;
  
      // keep track of how many traces are inputted
      newFullLayout._dataLength = newData.length;
  
      // clear the lists of trace and baseplot modules, and subplots
      newFullLayout._modules = [];
      newFullLayout._visibleModules = [];
      newFullLayout._basePlotModules = [];
      var subplots = newFullLayout._subplots = emptySubplotLists();
  
      // initialize axis and subplot hash objects for splom-generated grids
      var splomAxes = newFullLayout._splomAxes = {x: {}, y: {}};
      var splomSubplots = newFullLayout._splomSubplots = {};
      // initialize splom grid defaults
      newFullLayout._splomGridDflt = {};
  
      // for stacked area traces to share config across traces
      newFullLayout._scatterStackOpts = {};
      // for the first scatter trace on each subplot (so it knows tonext->tozero)
      newFullLayout._firstScatter = {};
      // for grouped bar/box/violin trace to share config across traces
      newFullLayout._alignmentOpts = {};
      // track color axes referenced in the data
      newFullLayout._colorAxes = {};
  
      // for traces to request a default rangeslider on their x axes
      // eg set `_requestRangeslider.x2 = true` for xaxis2
      newFullLayout._requestRangeslider = {};
  
      // pull uids from old data to use as new defaults
      newFullLayout._traceUids = getTraceUids(oldFullData, newData);
  
      // then do the data
      newFullLayout._globalTransforms = (gd._context || {}).globalTransforms;
      plots.supplyDataDefaults(newData, newFullData, newLayout, newFullLayout);
  
      // redo grid size defaults with info about splom x/y axes,
      // and fill in generated cartesian axes and subplots
      var splomXa = Object.keys(splomAxes.x);
      var splomYa = Object.keys(splomAxes.y);
      if(splomXa.length > 1 && splomYa.length > 1) {
          Registry.getComponentMethod('grid', 'sizeDefaults')(newLayout, newFullLayout);
  
          for(i = 0; i < splomXa.length; i++) {
              Lib.pushUnique(subplots.xaxis, splomXa[i]);
          }
          for(i = 0; i < splomYa.length; i++) {
              Lib.pushUnique(subplots.yaxis, splomYa[i]);
          }
          for(var k in splomSubplots) {
              Lib.pushUnique(subplots.cartesian, k);
          }
      }
  
      // attach helper method to check whether a plot type is present on graph
      newFullLayout._has = plots._hasPlotType.bind(newFullLayout);
  
      if(oldFullData.length === newFullData.length) {
          for(i = 0; i < newFullData.length; i++) {
              relinkPrivateKeys(newFullData[i], oldFullData[i]);
          }
      }
  
      // finally, fill in the pieces of layout that may need to look at data
      plots.supplyLayoutModuleDefaults(newLayout, newFullLayout, newFullData, gd._transitionData);
  
      // Special cases that introduce interactions between traces.
      // This is after relinkPrivateKeys so we can use those in crossTraceDefaults
      // and after layout module defaults, so we can use eg barmode
      var _modules = newFullLayout._visibleModules;
      var crossTraceDefaultsFuncs = [];
      for(i = 0; i < _modules.length; i++) {
          var funci = _modules[i].crossTraceDefaults;
          // some trace types share crossTraceDefaults (ie histogram2d, histogram2dcontour)
          if(funci) Lib.pushUnique(crossTraceDefaultsFuncs, funci);
      }
      for(i = 0; i < crossTraceDefaultsFuncs.length; i++) {
          crossTraceDefaultsFuncs[i](newFullData, newFullLayout);
      }
  
      // turn on flag to optimize large splom-only graphs
      // mostly by omitting SVG layers during Cartesian.drawFramework
      newFullLayout._hasOnlyLargeSploms = (
          newFullLayout._basePlotModules.length === 1 &&
          newFullLayout._basePlotModules[0].name === 'splom' &&
          splomXa.length > 15 &&
          splomYa.length > 15 &&
          newFullLayout.shapes.length === 0 &&
          newFullLayout.images.length === 0
      );
  
      // TODO remove in v2.0.0
      // add has-plot-type refs to fullLayout for backward compatibility
      newFullLayout._hasCartesian = newFullLayout._has('cartesian');
      newFullLayout._hasGeo = newFullLayout._has('geo');
      newFullLayout._hasGL3D = newFullLayout._has('gl3d');
      newFullLayout._hasGL2D = newFullLayout._has('gl2d');
      newFullLayout._hasTernary = newFullLayout._has('ternary');
      newFullLayout._hasPie = newFullLayout._has('pie');
  
      // relink / initialize subplot axis objects
      plots.linkSubplots(newFullData, newFullLayout, oldFullData, oldFullLayout);
  
      // clean subplots and other artifacts from previous plot calls
      plots.cleanPlot(newFullData, newFullLayout, oldFullData, oldFullLayout);
  
      var hadGL2D = !!(oldFullLayout._has && oldFullLayout._has('gl2d'));
      var hasGL2D = !!(newFullLayout._has && newFullLayout._has('gl2d'));
      var hadCartesian = !!(oldFullLayout._has && oldFullLayout._has('cartesian'));
      var hasCartesian = !!(newFullLayout._has && newFullLayout._has('cartesian'));
      var hadBgLayer = hadCartesian || hadGL2D;
      var hasBgLayer = hasCartesian || hasGL2D;
      if(hadBgLayer && !hasBgLayer) {
          // remove bgLayer
          oldFullLayout._bgLayer.remove();
      } else if(hasBgLayer && !hadBgLayer) {
          // create bgLayer
          newFullLayout._shouldCreateBgLayer = true;
      }
  
      // clear selection outline until we implement persistent selection,
      // don't clear them though when drag handlers (e.g. listening to
      // `plotly_selecting`) update the graph.
      // we should try to come up with a better solution when implementing
      // https://github.com/plotly/plotly.js/issues/1851
      if(oldFullLayout._zoomlayer && !gd._dragging) {
          clearSelect({ // mock old gd
              _fullLayout: oldFullLayout
          });
      }
  
  
      // fill in meta helpers
      fillMetaTextHelpers(newFullData, newFullLayout);
  
      // relink functions and _ attributes to promote consistency between plots
      relinkPrivateKeys(newFullLayout, oldFullLayout);
  
      // colorscale crossTraceDefaults needs newFullLayout with relinked keys
      Registry.getComponentMethod('colorscale', 'crossTraceDefaults')(newFullData, newFullLayout);
  
      // For persisting GUI-driven changes in layout
      // _preGUI and _tracePreGUI were already copied over in relinkPrivateKeys
      if(!newFullLayout._preGUI) newFullLayout._preGUI = {};
      // track trace GUI changes by uid rather than by trace index
      if(!newFullLayout._tracePreGUI) newFullLayout._tracePreGUI = {};
      var tracePreGUI = newFullLayout._tracePreGUI;
      var uids = {};
      var uid;
      for(uid in tracePreGUI) uids[uid] = 'old';
      for(i = 0; i < newFullData.length; i++) {
          uid = newFullData[i]._fullInput.uid;
          if(!uids[uid]) tracePreGUI[uid] = {};
          uids[uid] = 'new';
      }
      for(uid in uids) {
          if(uids[uid] === 'old') delete tracePreGUI[uid];
      }
  
      // set up containers for margin calculations
      initMargins(newFullLayout);
  
      // collect and do some initial calculations for rangesliders
      Registry.getComponentMethod('rangeslider', 'makeData')(newFullLayout);
  
      // update object references in calcdata
      if(!skipUpdateCalc && oldCalcdata.length === newFullData.length) {
          plots.supplyDefaultsUpdateCalc(oldCalcdata, newFullData);
      }
  };
  
  plots.supplyDefaultsUpdateCalc = function(oldCalcdata, newFullData) {
      for(var i = 0; i < newFullData.length; i++) {
          var newTrace = newFullData[i];
          var cd0 = (oldCalcdata[i] || [])[0];
          if(cd0 && cd0.trace) {
              var oldTrace = cd0.trace;
              if(oldTrace._hasCalcTransform) {
                  var arrayAttrs = oldTrace._arrayAttrs;
                  var j, astr, oldArrayVal;
  
                  for(j = 0; j < arrayAttrs.length; j++) {
                      astr = arrayAttrs[j];
                      oldArrayVal = Lib.nestedProperty(oldTrace, astr).get().slice();
                      Lib.nestedProperty(newTrace, astr).set(oldArrayVal);
                  }
              }
              cd0.trace = newTrace;
          }
      }
  };
  
  /**
   * Create a list of uid strings satisfying (in this order of importance):
   * 1. all unique, all strings
   * 2. matches input uids if provided
   * 3. matches previous data uids
   */
  function getTraceUids(oldFullData, newData) {
      var len = newData.length;
      var oldFullInput = [];
      var i, prevFullInput;
      for(i = 0; i < oldFullData.length; i++) {
          var thisFullInput = oldFullData[i]._fullInput;
          if(thisFullInput !== prevFullInput) oldFullInput.push(thisFullInput);
          prevFullInput = thisFullInput;
      }
      var oldLen = oldFullInput.length;
      var out = new Array(len);
      var seenUids = {};
  
      function setUid(uid, i) {
          out[i] = uid;
          seenUids[uid] = 1;
      }
  
      function tryUid(uid, i) {
          if(uid && typeof uid === 'string' && !seenUids[uid]) {
              setUid(uid, i);
              return true;
          }
      }
  
      for(i = 0; i < len; i++) {
          var newUid = newData[i].uid;
          if(typeof newUid === 'number') newUid = String(newUid);
  
          if(tryUid(newUid, i)) continue;
          if(i < oldLen && tryUid(oldFullInput[i].uid, i)) continue;
          setUid(Lib.randstr(seenUids), i);
      }
  
      return out;
  }
  
  /**
   * Make a container for collecting subplots we need to display.
   *
   * Finds all subplot types we need to enumerate once and caches it,
   * but makes a new output object each time.
   * Single-trace subplots (which have no `id`) such as pie, table, etc
   * do not need to be collected because we just draw all visible traces.
   */
  function emptySubplotLists() {
      var collectableSubplotTypes = Registry.collectableSubplotTypes;
      var out = {};
      var i, j;
  
      if(!collectableSubplotTypes) {
          collectableSubplotTypes = [];
  
          var subplotsRegistry = Registry.subplotsRegistry;
  
          for(var subplotType in subplotsRegistry) {
              var subplotModule = subplotsRegistry[subplotType];
              var subplotAttr = subplotModule.attr;
  
              if(subplotAttr) {
                  collectableSubplotTypes.push(subplotType);
  
                  // special case, currently just for cartesian:
                  // we need to enumerate axes, not just subplots
                  if(Array.isArray(subplotAttr)) {
                      for(j = 0; j < subplotAttr.length; j++) {
                          Lib.pushUnique(collectableSubplotTypes, subplotAttr[j]);
                      }
                  }
              }
          }
      }
  
      for(i = 0; i < collectableSubplotTypes.length; i++) {
          out[collectableSubplotTypes[i]] = [];
      }
      return out;
  }
  
  /**
   * getFormatObj: use _context to get the format object from locale.
   * Used to get d3.locale argument object and extraFormat argument object
   *
   * Regarding d3.locale argument :
   * decimal and thousands can be overridden later by layout.separators
   * grouping and currency are not presently used by our automatic number
   * formatting system but can be used by custom formats.
   *
   * @returns {object} d3.locale format object
   */
  function getFormatObj(gd, formatKeys) {
      var locale = gd._context.locale;
      if(!locale) locale === 'en-US';
  
      var formatDone = false;
      var formatObj = {};
  
      function includeFormat(newFormat) {
          var formatFinished = true;
          for(var i = 0; i < formatKeys.length; i++) {
              var formatKey = formatKeys[i];
              if(!formatObj[formatKey]) {
                  if(newFormat[formatKey]) {
                      formatObj[formatKey] = newFormat[formatKey];
                  } else formatFinished = false;
              }
          }
          if(formatFinished) formatDone = true;
      }
  
      // same as localize, look for format parts in each format spec in the chain
      for(var i = 0; i < 2; i++) {
          var locales = gd._context.locales;
          for(var j = 0; j < 2; j++) {
              var formatj = (locales[locale] || {}).format;
              if(formatj) {
                  includeFormat(formatj);
                  if(formatDone) break;
              }
              locales = Registry.localeRegistry;
          }
  
          var baseLocale = locale.split('-')[0];
          if(formatDone || baseLocale === locale) break;
          locale = baseLocale;
      }
  
      // lastly pick out defaults from english (non-US, as DMY is so much more common)
      if(!formatDone) includeFormat(Registry.localeRegistry.en.format);
  
      return formatObj;
  }
  
  /**
   * getFormatter: combine the final separators with the locale formatting object
   * we pulled earlier to generate number and time formatters
   * TODO: remove separators in v2, only use locale, so we don't need this step?
   *
   * @param {object} formatObj: d3.locale format object
   * @param {string} separators: length-2 string to override decimal and thousands
   *   separators in number formatting
   *
   * @returns {object} {numberFormat, timeFormat} d3 formatter factory functions
   *   for numbers and time
   */
  function getFormatter(formatObj, separators) {
      formatObj.decimal = separators.charAt(0);
      formatObj.thousands = separators.charAt(1);
  
      return {
          numberFormat: d3.locale(formatObj).numberFormat,
          timeFormat: timeFormatLocale(formatObj).utcFormat
      };
  }
  
  function fillMetaTextHelpers(newFullData, newFullLayout) {
      var _meta;
      var meta4data = [];
  
      if(newFullLayout.meta) {
          _meta = newFullLayout._meta = {
              meta: newFullLayout.meta,
              layout: {meta: newFullLayout.meta}
          };
      }
  
      for(var i = 0; i < newFullData.length; i++) {
          var trace = newFullData[i];
  
          if(trace.meta) {
              meta4data[trace.index] = trace._meta = {meta: trace.meta};
          } else if(newFullLayout.meta) {
              trace._meta = {meta: newFullLayout.meta};
          }
          if(newFullLayout.meta) {
              trace._meta.layout = {meta: newFullLayout.meta};
          }
      }
  
      if(meta4data.length) {
          if(!_meta) {
              _meta = newFullLayout._meta = {};
          }
          _meta.data = meta4data;
      }
  }
  
  // Create storage for all of the data related to frames and transitions:
  plots.createTransitionData = function(gd) {
      // Set up the default keyframe if it doesn't exist:
      if(!gd._transitionData) {
          gd._transitionData = {};
      }
  
      if(!gd._transitionData._frames) {
          gd._transitionData._frames = [];
      }
  
      if(!gd._transitionData._frameHash) {
          gd._transitionData._frameHash = {};
      }
  
      if(!gd._transitionData._counter) {
          gd._transitionData._counter = 0;
      }
  
      if(!gd._transitionData._interruptCallbacks) {
          gd._transitionData._interruptCallbacks = [];
      }
  };
  
  // helper function to be bound to fullLayout to check
  // whether a certain plot type is present on plot
  // or trace has a category
  plots._hasPlotType = function(category) {
      var i;
  
      // check base plot modules
      var basePlotModules = this._basePlotModules || [];
      for(i = 0; i < basePlotModules.length; i++) {
          if(basePlotModules[i].name === category) return true;
      }
  
      // check trace modules (including non-visible:true)
      var modules = this._modules || [];
      for(i = 0; i < modules.length; i++) {
          var name = modules[i].name;
          if(name === category) return true;
          // N.B. this is modules[i] along with 'categories' as a hash object
          var _module = Registry.modules[name];
          if(_module && _module.categories[category]) return true;
      }
  
      return false;
  };
  
  plots.cleanPlot = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var i, j;
  
      var basePlotModules = oldFullLayout._basePlotModules || [];
      for(i = 0; i < basePlotModules.length; i++) {
          var _module = basePlotModules[i];
  
          if(_module.clean) {
              _module.clean(newFullData, newFullLayout, oldFullData, oldFullLayout);
          }
      }
  
      var hadGl = oldFullLayout._has && oldFullLayout._has('gl');
      var hasGl = newFullLayout._has && newFullLayout._has('gl');
  
      if(hadGl && !hasGl) {
          if(oldFullLayout._glcontainer !== undefined) {
              oldFullLayout._glcontainer.selectAll('.gl-canvas').remove();
              oldFullLayout._glcontainer.selectAll('.no-webgl').remove();
              oldFullLayout._glcanvas = null;
          }
      }
  
      var hasInfoLayer = !!oldFullLayout._infolayer;
  
      oldLoop:
      for(i = 0; i < oldFullData.length; i++) {
          var oldTrace = oldFullData[i];
          var oldUid = oldTrace.uid;
  
          for(j = 0; j < newFullData.length; j++) {
              var newTrace = newFullData[j];
  
              if(oldUid === newTrace.uid) continue oldLoop;
          }
  
          // clean old colorbars
          if(hasInfoLayer) {
              oldFullLayout._infolayer.select('.cb' + oldUid).remove();
          }
      }
  };
  
  plots.linkSubplots = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var i, j;
  
      var oldSubplots = oldFullLayout._plots || {};
      var newSubplots = newFullLayout._plots = {};
      var newSubplotList = newFullLayout._subplots;
  
      var mockGd = {
          _fullData: newFullData,
          _fullLayout: newFullLayout
      };
  
      var ids = newSubplotList.cartesian.concat(newSubplotList.gl2d || []);
  
      for(i = 0; i < ids.length; i++) {
          var id = ids[i];
          var oldSubplot = oldSubplots[id];
          var xaxis = axisIDs.getFromId(mockGd, id, 'x');
          var yaxis = axisIDs.getFromId(mockGd, id, 'y');
          var plotinfo;
  
          // link or create subplot object
          if(oldSubplot) {
              plotinfo = newSubplots[id] = oldSubplot;
          } else {
              plotinfo = newSubplots[id] = {};
              plotinfo.id = id;
          }
  
          // add these axis ids to each others' subplot lists
          xaxis._counterAxes.push(yaxis._id);
          yaxis._counterAxes.push(xaxis._id);
          xaxis._subplotsWith.push(id);
          yaxis._subplotsWith.push(id);
  
          // update x and y axis layout object refs
          plotinfo.xaxis = xaxis;
          plotinfo.yaxis = yaxis;
  
          // By default, we clip at the subplot level,
          // but if one trace on a given subplot has *cliponaxis* set to false,
          // we need to clip at the trace module layer level;
          // find this out here, once of for all.
          plotinfo._hasClipOnAxisFalse = false;
  
          for(j = 0; j < newFullData.length; j++) {
              var trace = newFullData[j];
  
              if(
                  trace.xaxis === plotinfo.xaxis._id &&
                  trace.yaxis === plotinfo.yaxis._id &&
                  trace.cliponaxis === false
              ) {
                  plotinfo._hasClipOnAxisFalse = true;
                  break;
              }
          }
      }
  
      // while we're at it, link overlaying axes to their main axes and
      // anchored axes to the axes they're anchored to
      var axList = axisIDs.list(mockGd, null, true);
      var ax;
      for(i = 0; i < axList.length; i++) {
          ax = axList[i];
          var mainAx = null;
  
          if(ax.overlaying) {
              mainAx = axisIDs.getFromId(mockGd, ax.overlaying);
  
              // you cannot overlay an axis that's already overlaying another
              if(mainAx && mainAx.overlaying) {
                  ax.overlaying = false;
                  mainAx = null;
              }
          }
          ax._mainAxis = mainAx || ax;
  
          /*
           * For now force overlays to overlay completely... so they
           * can drag together correctly and share backgrounds.
           * Later perhaps we make separate axis domain and
           * tick/line domain or something, so they can still share
           * the (possibly larger) dragger and background but don't
           * have to both be drawn over that whole domain
           */
          if(mainAx) ax.domain = mainAx.domain.slice();
  
          ax._anchorAxis = ax.anchor === 'free' ?
              null :
              axisIDs.getFromId(mockGd, ax.anchor);
      }
  
      // finally, we can find the main subplot for each axis
      // (on which the ticks & labels are drawn)
      for(i = 0; i < axList.length; i++) {
          ax = axList[i];
          ax._counterAxes.sort(axisIDs.idSort);
          ax._subplotsWith.sort(Lib.subplotSort);
          ax._mainSubplot = findMainSubplot(ax, newFullLayout);
  
          // find "full" domain span of counter axes,
          // this loop can be costly, so only compute it when required
          if(ax._counterAxes.length && (
              (ax.spikemode && ax.spikemode.indexOf('across') !== -1) ||
              (ax.automargin && ax.mirror && ax.anchor !== 'free') ||
              Registry.getComponentMethod('rangeslider', 'isVisible')(ax)
          )) {
              var min = 1;
              var max = 0;
              for(j = 0; j < ax._counterAxes.length; j++) {
                  var ax2 = axisIDs.getFromId(mockGd, ax._counterAxes[j]);
                  min = Math.min(min, ax2.domain[0]);
                  max = Math.max(max, ax2.domain[1]);
              }
              if(min < max) {
                  ax._counterDomainMin = min;
                  ax._counterDomainMax = max;
              }
          }
      }
  };
  
  function findMainSubplot(ax, fullLayout) {
      var mockGd = {_fullLayout: fullLayout};
  
      var isX = ax._id.charAt(0) === 'x';
      var anchorAx = ax._mainAxis._anchorAxis;
      var mainSubplotID = '';
      var nextBestMainSubplotID = '';
      var anchorID = '';
  
      // First try the main ID with the anchor
      if(anchorAx) {
          anchorID = anchorAx._mainAxis._id;
          mainSubplotID = isX ? (ax._id + anchorID) : (anchorID + ax._id);
      }
  
      // Then look for a subplot with the counteraxis overlaying the anchor
      // If that fails just use the first subplot including this axis
      if(!mainSubplotID || !fullLayout._plots[mainSubplotID]) {
          mainSubplotID = '';
  
          var counterIDs = ax._counterAxes;
          for(var j = 0; j < counterIDs.length; j++) {
              var counterPart = counterIDs[j];
              var id = isX ? (ax._id + counterPart) : (counterPart + ax._id);
              if(!nextBestMainSubplotID) nextBestMainSubplotID = id;
              var counterAx = axisIDs.getFromId(mockGd, counterPart);
              if(anchorID && counterAx.overlaying === anchorID) {
                  mainSubplotID = id;
                  break;
              }
          }
      }
  
      return mainSubplotID || nextBestMainSubplotID;
  }
  
  // This function clears any trace attributes with valType: color and
  // no set dflt filed in the plot schema. This is needed because groupby (which
  // is the only transform for which this currently applies) supplies parent
  // trace defaults, then expanded trace defaults. The result is that `null`
  // colors are default-supplied and inherited as a color instead of a null.
  // The result is that expanded trace default colors have no effect, with
  // the final result that groups are indistinguishable. This function clears
  // those colors so that individual groupby groups get unique colors.
  plots.clearExpandedTraceDefaultColors = function(trace) {
      var colorAttrs, path, i;
  
      // This uses weird closure state in order to satisfy the linter rule
      // that we can't create functions in a loop.
      function locateColorAttrs(attr, attrName, attrs, level) {
          path[level] = attrName;
          path.length = level + 1;
          if(attr.valType === 'color' && attr.dflt === undefined) {
              colorAttrs.push(path.join('.'));
          }
      }
  
      path = [];
  
      // Get the cached colorAttrs:
      colorAttrs = trace._module._colorAttrs;
  
      // Or else compute and cache the colorAttrs on the module:
      if(!colorAttrs) {
          trace._module._colorAttrs = colorAttrs = [];
          PlotSchema.crawl(
              trace._module.attributes,
              locateColorAttrs
          );
      }
  
      for(i = 0; i < colorAttrs.length; i++) {
          var origprop = Lib.nestedProperty(trace, '_input.' + colorAttrs[i]);
  
          if(!origprop.get()) {
              Lib.nestedProperty(trace, colorAttrs[i]).set(null);
          }
      }
  };
  
  
  plots.supplyDataDefaults = function(dataIn, dataOut, layout, fullLayout) {
      var modules = fullLayout._modules;
      var visibleModules = fullLayout._visibleModules;
      var basePlotModules = fullLayout._basePlotModules;
      var cnt = 0;
      var colorCnt = 0;
  
      var i, fullTrace, trace;
  
      fullLayout._transformModules = [];
  
      function pushModule(fullTrace) {
          dataOut.push(fullTrace);
  
          var _module = fullTrace._module;
          if(!_module) return;
  
          Lib.pushUnique(modules, _module);
          if(fullTrace.visible === true) Lib.pushUnique(visibleModules, _module);
          Lib.pushUnique(basePlotModules, fullTrace._module.basePlotModule);
          cnt++;
  
          // TODO: do we really want color not to increment for explicitly invisible traces?
          // This logic is weird, but matches previous behavior: traces that you explicitly
          // set to visible:false do not increment the color, but traces WE determine to be
          // empty or invalid (and thus set to visible:false) DO increment color.
          // I kind of think we should just let all traces increment color, visible or not.
          // see mock: axes-autotype-empty vs. a test of restyling visible: false that
          // I can't find right now...
          if(fullTrace._input.visible !== false) colorCnt++;
      }
  
      var carpetIndex = {};
      var carpetDependents = [];
      var dataTemplate = (layout.template || {}).data || {};
      var templater = Template.traceTemplater(dataTemplate);
  
      for(i = 0; i < dataIn.length; i++) {
          trace = dataIn[i];
  
          // reuse uid we may have pulled out of oldFullData
          // Note: templater supplies trace type
          fullTrace = templater.newTrace(trace);
          fullTrace.uid = fullLayout._traceUids[i];
          plots.supplyTraceDefaults(trace, fullTrace, colorCnt, fullLayout, i);
  
          fullTrace.index = i;
          fullTrace._input = trace;
          fullTrace._expandedIndex = cnt;
  
          if(fullTrace.transforms && fullTrace.transforms.length) {
              var sdInvisible = trace.visible !== false && fullTrace.visible === false;
  
              var expandedTraces = applyTransforms(fullTrace, dataOut, layout, fullLayout);
  
              for(var j = 0; j < expandedTraces.length; j++) {
                  var expandedTrace = expandedTraces[j];
  
                  // No further templating during transforms.
                  var fullExpandedTrace = {
                      _template: fullTrace._template,
                      type: fullTrace.type,
                      // set uid using parent uid and expanded index
                      // to promote consistency between update calls
                      uid: fullTrace.uid + j
                  };
  
                  // If the first supplyDefaults created `visible: false`,
                  // clear it before running supplyDefaults a second time,
                  // because sometimes there are items we still want to coerce
                  // inside trace modules before determining that the trace is
                  // again `visible: false`, for example partial visibilities
                  // in `splom` traces.
                  if(sdInvisible && expandedTrace.visible === false) {
                      delete expandedTrace.visible;
                  }
  
                  plots.supplyTraceDefaults(expandedTrace, fullExpandedTrace, cnt, fullLayout, i);
  
                  // relink private (i.e. underscore) keys expanded trace to full expanded trace so
                  // that transform supply-default methods can set _ keys for future use.
                  relinkPrivateKeys(fullExpandedTrace, expandedTrace);
  
                  // add info about parent data trace
                  fullExpandedTrace.index = i;
                  fullExpandedTrace._input = trace;
                  fullExpandedTrace._fullInput = fullTrace;
  
                  // add info about the expanded data
                  fullExpandedTrace._expandedIndex = cnt;
                  fullExpandedTrace._expandedInput = expandedTrace;
  
                  pushModule(fullExpandedTrace);
              }
          } else {
              // add identify refs for consistency with transformed traces
              fullTrace._fullInput = fullTrace;
              fullTrace._expandedInput = fullTrace;
  
              pushModule(fullTrace);
          }
  
          if(Registry.traceIs(fullTrace, 'carpetAxis')) {
              carpetIndex[fullTrace.carpet] = fullTrace;
          }
  
          if(Registry.traceIs(fullTrace, 'carpetDependent')) {
              carpetDependents.push(i);
          }
      }
  
      for(i = 0; i < carpetDependents.length; i++) {
          fullTrace = dataOut[carpetDependents[i]];
  
          if(!fullTrace.visible) continue;
  
          var carpetAxis = carpetIndex[fullTrace.carpet];
          fullTrace._carpet = carpetAxis;
  
          if(!carpetAxis || !carpetAxis.visible) {
              fullTrace.visible = false;
              continue;
          }
  
          fullTrace.xaxis = carpetAxis.xaxis;
          fullTrace.yaxis = carpetAxis.yaxis;
      }
  };
  
  plots.supplyAnimationDefaults = function(opts) {
      opts = opts || {};
      var i;
      var optsOut = {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(opts || {}, optsOut, animationAttrs, attr, dflt);
      }
  
      coerce('mode');
      coerce('direction');
      coerce('fromcurrent');
  
      if(Array.isArray(opts.frame)) {
          optsOut.frame = [];
          for(i = 0; i < opts.frame.length; i++) {
              optsOut.frame[i] = plots.supplyAnimationFrameDefaults(opts.frame[i] || {});
          }
      } else {
          optsOut.frame = plots.supplyAnimationFrameDefaults(opts.frame || {});
      }
  
      if(Array.isArray(opts.transition)) {
          optsOut.transition = [];
          for(i = 0; i < opts.transition.length; i++) {
              optsOut.transition[i] = plots.supplyAnimationTransitionDefaults(opts.transition[i] || {});
          }
      } else {
          optsOut.transition = plots.supplyAnimationTransitionDefaults(opts.transition || {});
      }
  
      return optsOut;
  };
  
  plots.supplyAnimationFrameDefaults = function(opts) {
      var optsOut = {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(opts || {}, optsOut, animationAttrs.frame, attr, dflt);
      }
  
      coerce('duration');
      coerce('redraw');
  
      return optsOut;
  };
  
  plots.supplyAnimationTransitionDefaults = function(opts) {
      var optsOut = {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(opts || {}, optsOut, animationAttrs.transition, attr, dflt);
      }
  
      coerce('duration');
      coerce('easing');
  
      return optsOut;
  };
  
  plots.supplyFrameDefaults = function(frameIn) {
      var frameOut = {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(frameIn, frameOut, frameAttrs, attr, dflt);
      }
  
      coerce('group');
      coerce('name');
      coerce('traces');
      coerce('baseframe');
      coerce('data');
      coerce('layout');
  
      return frameOut;
  };
  
  plots.supplyTraceDefaults = function(traceIn, traceOut, colorIndex, layout, traceInIndex) {
      var colorway = layout.colorway || Color.defaults;
      var defaultColor = colorway[colorIndex % colorway.length];
  
      var i;
  
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, plots.attributes, attr, dflt);
      }
  
      var visible = coerce('visible');
  
      coerce('type');
      coerce('name', layout._traceWord + ' ' + traceInIndex);
  
      coerce('uirevision', layout.uirevision);
  
      // we want even invisible traces to make their would-be subplots visible
      // so coerce the subplot id(s) now no matter what
      var _module = plots.getModule(traceOut);
  
      traceOut._module = _module;
      if(_module) {
          var basePlotModule = _module.basePlotModule;
          var subplotAttr = basePlotModule.attr;
          var subplotAttrs = basePlotModule.attributes;
          if(subplotAttr && subplotAttrs) {
              var subplots = layout._subplots;
              var subplotId = '';
  
              if(
                  visible ||
                  basePlotModule.name !== 'gl2d' // for now just drop empty gl2d subplots
                  // TODO - currently if we draw an empty gl2d subplot, it draws
                  // nothing then gets stuck and you can't get it back without newPlot
                  // sort this out in the regl refactor?
              ) {
                  if(Array.isArray(subplotAttr)) {
                      for(i = 0; i < subplotAttr.length; i++) {
                          var attri = subplotAttr[i];
                          var vali = Lib.coerce(traceIn, traceOut, subplotAttrs, attri);
  
                          if(subplots[attri]) Lib.pushUnique(subplots[attri], vali);
                          subplotId += vali;
                      }
                  } else {
                      subplotId = Lib.coerce(traceIn, traceOut, subplotAttrs, subplotAttr);
                  }
  
                  if(subplots[basePlotModule.name]) {
                      Lib.pushUnique(subplots[basePlotModule.name], subplotId);
                  }
              }
          }
      }
  
      if(visible) {
          coerce('customdata');
          coerce('ids');
          coerce('meta');
  
          if(Registry.traceIs(traceOut, 'showLegend')) {
              Lib.coerce(traceIn, traceOut,
                  _module.attributes.showlegend ? _module.attributes : plots.attributes,
                  'showlegend'
              );
  
              coerce('legendgroup');
  
              traceOut._dfltShowLegend = true;
          } else {
              traceOut._dfltShowLegend = false;
          }
  
          if(_module) {
              _module.supplyDefaults(traceIn, traceOut, defaultColor, layout);
          }
  
          if(!Registry.traceIs(traceOut, 'noOpacity')) {
              coerce('opacity');
          }
  
          if(Registry.traceIs(traceOut, 'notLegendIsolatable')) {
              // This clears out the legendonly state for traces like carpet that
              // cannot be isolated in the legend
              traceOut.visible = !!traceOut.visible;
          }
  
          if(!Registry.traceIs(traceOut, 'noHover')) {
              if(!traceOut.hovertemplate) Lib.coerceHoverinfo(traceIn, traceOut, layout);
  
              // parcats support hover, but not hoverlabel stylings (yet)
              if(traceOut.type !== 'parcats') {
                  Registry.getComponentMethod('fx', 'supplyDefaults')(traceIn, traceOut, defaultColor, layout);
              }
          }
  
          if(_module && _module.selectPoints) {
              coerce('selectedpoints');
          }
  
          plots.supplyTransformDefaults(traceIn, traceOut, layout);
      }
  
      return traceOut;
  };
  
  /**
   * hasMakesDataTransform: does this trace have a transform that makes its own
   * data, either by grabbing it from somewhere else or by creating it from input
   * parameters? If so, we should still keep going with supplyDefaults
   * even if the trace is invisible, which may just be because it has no data yet.
   */
  function hasMakesDataTransform(trace) {
      var transforms = trace.transforms;
      if(Array.isArray(transforms) && transforms.length) {
          for(var i = 0; i < transforms.length; i++) {
              var ti = transforms[i];
              var _module = ti._module || transformsRegistry[ti.type];
              if(_module && _module.makesData) return true;
          }
      }
      return false;
  }
  
  plots.hasMakesDataTransform = hasMakesDataTransform;
  
  plots.supplyTransformDefaults = function(traceIn, traceOut, layout) {
      // For now we only allow transforms on 1D traces, ie those that specify a _length.
      // If we were to implement 2D transforms, we'd need to have each transform
      // describe its own applicability and disable itself when it doesn't apply.
      // Also allow transforms that make their own data, but not in globalTransforms
      if(!(traceOut._length || hasMakesDataTransform(traceIn))) return;
  
      var globalTransforms = layout._globalTransforms || [];
      var transformModules = layout._transformModules || [];
  
      if(!Array.isArray(traceIn.transforms) && globalTransforms.length === 0) return;
  
      var containerIn = traceIn.transforms || [];
      var transformList = globalTransforms.concat(containerIn);
      var containerOut = traceOut.transforms = [];
  
      for(var i = 0; i < transformList.length; i++) {
          var transformIn = transformList[i];
          var type = transformIn.type;
          var _module = transformsRegistry[type];
          var transformOut;
  
          /*
           * Supply defaults may run twice. First pass runs all supply defaults steps
           * and adds the _module to any output transforms.
           * If transforms exist another pass is run so that any generated traces also
           * go through supply defaults. This has the effect of rerunning
           * supplyTransformDefaults. If the transform does not have a `transform`
           * function it could not have generated any new traces and the second stage
           * is unnecessary. We detect this case with the following variables.
           */
          var isFirstStage = !(transformIn._module && transformIn._module === _module);
          var doLaterStages = _module && typeof _module.transform === 'function';
  
          if(!_module) Lib.warn('Unrecognized transform type ' + type + '.');
  
          if(_module && _module.supplyDefaults && (isFirstStage || doLaterStages)) {
              transformOut = _module.supplyDefaults(transformIn, traceOut, layout, traceIn);
              transformOut.type = type;
              transformOut._module = _module;
  
              Lib.pushUnique(transformModules, _module);
          } else {
              transformOut = Lib.extendFlat({}, transformIn);
          }
  
          containerOut.push(transformOut);
      }
  };
  
  function applyTransforms(fullTrace, fullData, layout, fullLayout) {
      var container = fullTrace.transforms;
      var dataOut = [fullTrace];
  
      for(var i = 0; i < container.length; i++) {
          var transform = container[i];
          var _module = transformsRegistry[transform.type];
  
          if(_module && _module.transform) {
              dataOut = _module.transform(dataOut, {
                  transform: transform,
                  fullTrace: fullTrace,
                  fullData: fullData,
                  layout: layout,
                  fullLayout: fullLayout,
                  transformIndex: i
              });
          }
      }
  
      return dataOut;
  }
  
  plots.supplyLayoutGlobalDefaults = function(layoutIn, layoutOut, formatObj) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, plots.layoutAttributes, attr, dflt);
      }
  
      var template = layoutIn.template;
      if(Lib.isPlainObject(template)) {
          layoutOut.template = template;
          layoutOut._template = template.layout;
          layoutOut._dataTemplate = template.data;
      }
  
      var globalFont = Lib.coerceFont(coerce, 'font');
  
      coerce('title.text', layoutOut._dfltTitle.plot);
  
      Lib.coerceFont(coerce, 'title.font', {
          family: globalFont.family,
          size: Math.round(globalFont.size * 1.4),
          color: globalFont.color
      });
  
      coerce('title.xref');
      coerce('title.yref');
      coerce('title.x');
      coerce('title.y');
      coerce('title.xanchor');
      coerce('title.yanchor');
      coerce('title.pad.t');
      coerce('title.pad.r');
      coerce('title.pad.b');
      coerce('title.pad.l');
  
      var uniformtextMode = coerce('uniformtext.mode');
      if(uniformtextMode) {
          coerce('uniformtext.minsize');
      }
  
      // Make sure that autosize is defaulted to *true*
      // on layouts with no set width and height for backward compatibly,
      // in particular https://plotly.com/javascript/responsive-fluid-layout/
      //
      // Before https://github.com/plotly/plotly.js/pull/635 ,
      // layouts with no set width and height were set temporary set to 'initial'
      // to pass through the autosize routine
      //
      // This behavior is subject to change in v2.
      coerce('autosize', !(layoutIn.width && layoutIn.height));
  
      coerce('width');
      coerce('height');
      coerce('margin.l');
      coerce('margin.r');
      coerce('margin.t');
      coerce('margin.b');
      coerce('margin.pad');
      coerce('margin.autoexpand');
  
      if(layoutIn.width && layoutIn.height) plots.sanitizeMargins(layoutOut);
  
      Registry.getComponentMethod('grid', 'sizeDefaults')(layoutIn, layoutOut);
  
      coerce('paper_bgcolor');
  
      coerce('separators', formatObj.decimal + formatObj.thousands);
      coerce('hidesources');
  
      coerce('colorway');
  
      coerce('datarevision');
      var uirevision = coerce('uirevision');
      coerce('editrevision', uirevision);
      coerce('selectionrevision', uirevision);
  
      coerce('modebar.orientation');
      coerce('modebar.bgcolor', Color.addOpacity(layoutOut.paper_bgcolor, 0.5));
      var modebarDefaultColor = Color.contrast(Color.rgb(layoutOut.modebar.bgcolor));
      coerce('modebar.color', Color.addOpacity(modebarDefaultColor, 0.3));
      coerce('modebar.activecolor', Color.addOpacity(modebarDefaultColor, 0.7));
      coerce('modebar.uirevision', uirevision);
  
      Registry.getComponentMethod(
          'shapes',
          'supplyDrawNewShapeDefaults'
      )(layoutIn, layoutOut, coerce);
  
      coerce('meta');
  
      // do not include defaults in fullLayout when users do not set transition
      if(Lib.isPlainObject(layoutIn.transition)) {
          coerce('transition.duration');
          coerce('transition.easing');
          coerce('transition.ordering');
      }
  
      Registry.getComponentMethod(
          'calendars',
          'handleDefaults'
      )(layoutIn, layoutOut, 'calendar');
  
      Registry.getComponentMethod(
          'fx',
          'supplyLayoutGlobalDefaults'
      )(layoutIn, layoutOut, coerce);
  };
  
  function getComputedSize(attr) {
      return (
          (typeof attr === 'string') &&
          (attr.substr(attr.length - 2) === 'px') &&
          parseFloat(attr)
      );
  }
  
  
  plots.plotAutoSize = function plotAutoSize(gd, layout, fullLayout) {
      var context = gd._context || {};
      var frameMargins = context.frameMargins;
      var newWidth;
      var newHeight;
  
      var isPlotDiv = Lib.isPlotDiv(gd);
  
      if(isPlotDiv) gd.emit('plotly_autosize');
  
      // embedded in an iframe - just take the full iframe size
      // if we get to this point, with no aspect ratio restrictions
      if(context.fillFrame) {
          newWidth = window.innerWidth;
          newHeight = window.innerHeight;
  
          // somehow we get a few extra px height sometimes...
          // just hide it
          document.body.style.overflow = 'hidden';
      } else {
          // plotly.js - let the developers do what they want, either
          // provide height and width for the container div,
          // specify size in layout, or take the defaults,
          // but don't enforce any ratio restrictions
          var computedStyle = isPlotDiv ? window.getComputedStyle(gd) : {};
  
          newWidth = getComputedSize(computedStyle.width) || getComputedSize(computedStyle.maxWidth) || fullLayout.width;
          newHeight = getComputedSize(computedStyle.height) || getComputedSize(computedStyle.maxHeight) || fullLayout.height;
  
          if(isNumeric(frameMargins) && frameMargins > 0) {
              var factor = 1 - 2 * frameMargins;
              newWidth = Math.round(factor * newWidth);
              newHeight = Math.round(factor * newHeight);
          }
      }
  
      var minWidth = plots.layoutAttributes.width.min;
      var minHeight = plots.layoutAttributes.height.min;
      if(newWidth < minWidth) newWidth = minWidth;
      if(newHeight < minHeight) newHeight = minHeight;
  
      var widthHasChanged = !layout.width &&
          (Math.abs(fullLayout.width - newWidth) > 1);
      var heightHasChanged = !layout.height &&
          (Math.abs(fullLayout.height - newHeight) > 1);
  
      if(heightHasChanged || widthHasChanged) {
          if(widthHasChanged) fullLayout.width = newWidth;
          if(heightHasChanged) fullLayout.height = newHeight;
      }
  
      // cache initial autosize value, used in relayout when
      // width or height values are set to null
      if(!gd._initialAutoSize) {
          gd._initialAutoSize = { width: newWidth, height: newHeight };
      }
  
      plots.sanitizeMargins(fullLayout);
  };
  
  plots.supplyLayoutModuleDefaults = function(layoutIn, layoutOut, fullData, transitionData) {
      var componentsRegistry = Registry.componentsRegistry;
      var basePlotModules = layoutOut._basePlotModules;
      var component, i, _module;
  
      var Cartesian = Registry.subplotsRegistry.cartesian;
  
      // check if any components need to add more base plot modules
      // that weren't captured by traces
      for(component in componentsRegistry) {
          _module = componentsRegistry[component];
  
          if(_module.includeBasePlot) {
              _module.includeBasePlot(layoutIn, layoutOut);
          }
      }
  
      // make sure we *at least* have some cartesian axes
      if(!basePlotModules.length) {
          basePlotModules.push(Cartesian);
      }
  
      // ensure all cartesian axes have at least one subplot
      if(layoutOut._has('cartesian')) {
          Registry.getComponentMethod('grid', 'contentDefaults')(layoutIn, layoutOut);
          Cartesian.finalizeSubplots(layoutIn, layoutOut);
      }
  
      // sort subplot lists
      for(var subplotType in layoutOut._subplots) {
          layoutOut._subplots[subplotType].sort(Lib.subplotSort);
      }
  
      // base plot module layout defaults
      for(i = 0; i < basePlotModules.length; i++) {
          _module = basePlotModules[i];
  
          // e.g. pie does not have a layout-defaults step
          if(_module.supplyLayoutDefaults) {
              _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
          }
      }
  
      // trace module layout defaults
      // use _modules rather than _visibleModules so that even
      // legendonly traces can include settings - eg barmode, which affects
      // legend.traceorder default value.
      var modules = layoutOut._modules;
      for(i = 0; i < modules.length; i++) {
          _module = modules[i];
  
          if(_module.supplyLayoutDefaults) {
              _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
          }
      }
  
      // transform module layout defaults
      var transformModules = layoutOut._transformModules;
      for(i = 0; i < transformModules.length; i++) {
          _module = transformModules[i];
  
          if(_module.supplyLayoutDefaults) {
              _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData, transitionData);
          }
      }
  
      for(component in componentsRegistry) {
          _module = componentsRegistry[component];
  
          if(_module.supplyLayoutDefaults) {
              _module.supplyLayoutDefaults(layoutIn, layoutOut, fullData);
          }
      }
  };
  
  // Remove all plotly attributes from a div so it can be replotted fresh
  // TODO: these really need to be encapsulated into a much smaller set...
  plots.purge = function(gd) {
      // note: we DO NOT remove _context because it doesn't change when we insert
      // a new plot, and may have been set outside of our scope.
  
      var fullLayout = gd._fullLayout || {};
      if(fullLayout._glcontainer !== undefined) {
          fullLayout._glcontainer.selectAll('.gl-canvas').remove();
          fullLayout._glcontainer.remove();
          fullLayout._glcanvas = null;
      }
  
      // remove modebar
      if(fullLayout._modeBar) fullLayout._modeBar.destroy();
  
      if(gd._transitionData) {
          // Ensure any dangling callbacks are simply dropped if the plot is purged.
          // This is more or less only actually important for testing.
          if(gd._transitionData._interruptCallbacks) {
              gd._transitionData._interruptCallbacks.length = 0;
          }
  
          if(gd._transitionData._animationRaf) {
              window.cancelAnimationFrame(gd._transitionData._animationRaf);
          }
      }
  
      // remove any planned throttles
      Lib.clearThrottle();
  
      // remove responsive handler
      Lib.clearResponsive(gd);
  
      // data and layout
      delete gd.data;
      delete gd.layout;
      delete gd._fullData;
      delete gd._fullLayout;
      delete gd.calcdata;
      delete gd.framework;
      delete gd.empty;
  
      delete gd.fid;
  
      delete gd.undoqueue; // action queue
      delete gd.undonum;
      delete gd.autoplay; // are we doing an action that doesn't go in undo queue?
      delete gd.changed;
  
      // these get recreated on Plotly.plot anyway, but just to be safe
      // (and to have a record of them...)
      delete gd._promises;
      delete gd._redrawTimer;
      delete gd._hmlumcount;
      delete gd._hmpixcount;
      delete gd._transitionData;
      delete gd._transitioning;
      delete gd._initialAutoSize;
      delete gd._transitioningWithDuration;
  
      // created during certain events, that *should* clean them up
      // themselves, but may not if there was an error
      delete gd._dragging;
      delete gd._dragged;
      delete gd._dragdata;
      delete gd._hoverdata;
      delete gd._snapshotInProgress;
      delete gd._editing;
      delete gd._mouseDownTime;
      delete gd._legendMouseDownTime;
  
      // remove all event listeners
      if(gd.removeAllListeners) gd.removeAllListeners();
  };
  
  plots.style = function(gd) {
      var _modules = gd._fullLayout._visibleModules;
      var styleModules = [];
      var i;
  
      // some trace modules reuse the same style method,
      // make sure to not unnecessary call them multiple times.
  
      for(i = 0; i < _modules.length; i++) {
          var _module = _modules[i];
          if(_module.style) {
              Lib.pushUnique(styleModules, _module.style);
          }
      }
  
      for(i = 0; i < styleModules.length; i++) {
          styleModules[i](gd);
      }
  };
  
  plots.sanitizeMargins = function(fullLayout) {
      // polar doesn't do margins...
      if(!fullLayout || !fullLayout.margin) return;
  
      var width = fullLayout.width;
      var height = fullLayout.height;
      var margin = fullLayout.margin;
      var plotWidth = width - (margin.l + margin.r);
      var plotHeight = height - (margin.t + margin.b);
      var correction;
  
      // if margin.l + margin.r = 0 then plotWidth > 0
      // as width >= 10 by supplyDefaults
      // similarly for margin.t + margin.b
  
      if(plotWidth < 0) {
          correction = (width - 1) / (margin.l + margin.r);
          margin.l = Math.floor(correction * margin.l);
          margin.r = Math.floor(correction * margin.r);
      }
  
      if(plotHeight < 0) {
          correction = (height - 1) / (margin.t + margin.b);
          margin.t = Math.floor(correction * margin.t);
          margin.b = Math.floor(correction * margin.b);
      }
  };
  
  plots.clearAutoMarginIds = function(gd) {
      gd._fullLayout._pushmarginIds = {};
  };
  
  plots.allowAutoMargin = function(gd, id) {
      gd._fullLayout._pushmarginIds[id] = 1;
  };
  
  function initMargins(fullLayout) {
      var margin = fullLayout.margin;
  
      if(!fullLayout._size) {
          var gs = fullLayout._size = {
              l: Math.round(margin.l),
              r: Math.round(margin.r),
              t: Math.round(margin.t),
              b: Math.round(margin.b),
              p: Math.round(margin.pad)
          };
          gs.w = Math.round(fullLayout.width) - gs.l - gs.r;
          gs.h = Math.round(fullLayout.height) - gs.t - gs.b;
      }
      if(!fullLayout._pushmargin) fullLayout._pushmargin = {};
      if(!fullLayout._pushmarginIds) fullLayout._pushmarginIds = {};
  }
  
  /**
   * autoMargin: called by components that may need to expand the margins to
   * be rendered on-plot.
   *
   * @param {DOM element} gd
   * @param {string} id - an identifier unique (within this plot) to this object,
   *     so we can remove a previous margin expansion from the same object.
   * @param {object} o - the margin requirements of this object, or omit to delete
   *     this entry (like if it's hidden). Keys are:
   *     x, y: plot fraction of the anchor point.
   *     xl, xr, yt, yb: if the object has an extent defined in plot fraction,
   *         you can specify both edges as plot fractions in each dimension
   *     l, r, t, b: the pixels to pad past the plot fraction x[l|r] and y[t|b]
   *     pad: extra pixels to add in all directions, default 12 (why?)
   */
  plots.autoMargin = function(gd, id, o) {
      var fullLayout = gd._fullLayout;
  
      var pushMargin = fullLayout._pushmargin;
      var pushMarginIds = fullLayout._pushmarginIds;
  
      if(fullLayout.margin.autoexpand !== false) {
          if(!o) {
              delete pushMargin[id];
              delete pushMarginIds[id];
          } else {
              var pad = o.pad;
              if(pad === undefined) {
                  var margin = fullLayout.margin;
                  // if no explicit pad is given, use 12px unless there's a
                  // specified margin that's smaller than that
                  pad = Math.min(12, margin.l, margin.r, margin.t, margin.b);
              }
  
              // if the item is too big, just give it enough automargin to
              // make sure you can still grab it and bring it back
              if(o.l + o.r > fullLayout.width * 0.5) {
                  Lib.log('Margin push', id, 'is too big in x, dropping');
                  o.l = o.r = 0;
              }
              if(o.b + o.t > fullLayout.height * 0.5) {
                  Lib.log('Margin push', id, 'is too big in y, dropping');
                  o.b = o.t = 0;
              }
  
              var xl = o.xl !== undefined ? o.xl : o.x;
              var xr = o.xr !== undefined ? o.xr : o.x;
              var yt = o.yt !== undefined ? o.yt : o.y;
              var yb = o.yb !== undefined ? o.yb : o.y;
  
              pushMargin[id] = {
                  l: {val: xl, size: o.l + pad},
                  r: {val: xr, size: o.r + pad},
                  b: {val: yb, size: o.b + pad},
                  t: {val: yt, size: o.t + pad}
              };
              pushMarginIds[id] = 1;
          }
  
          if(!fullLayout._replotting) {
              return plots.doAutoMargin(gd);
          }
      }
  };
  
  plots.doAutoMargin = function(gd) {
      var fullLayout = gd._fullLayout;
      if(!fullLayout._size) fullLayout._size = {};
      initMargins(fullLayout);
  
      var gs = fullLayout._size;
      var margin = fullLayout.margin;
      var oldMargins = Lib.extendFlat({}, gs);
  
      // adjust margins for outside components
      // fullLayout.margin is the requested margin,
      // fullLayout._size has margins and plotsize after adjustment
      var ml = margin.l;
      var mr = margin.r;
      var mt = margin.t;
      var mb = margin.b;
      var width = fullLayout.width;
      var height = fullLayout.height;
      var pushMargin = fullLayout._pushmargin;
      var pushMarginIds = fullLayout._pushmarginIds;
  
      if(fullLayout.margin.autoexpand !== false) {
          for(var k in pushMargin) {
              if(!pushMarginIds[k]) delete pushMargin[k];
          }
  
          // fill in the requested margins
          pushMargin.base = {
              l: {val: 0, size: ml},
              r: {val: 1, size: mr},
              t: {val: 1, size: mt},
              b: {val: 0, size: mb}
          };
  
          // now cycle through all the combinations of l and r
          // (and t and b) to find the required margins
  
          for(var k1 in pushMargin) {
              var pushleft = pushMargin[k1].l || {};
              var pushbottom = pushMargin[k1].b || {};
              var fl = pushleft.val;
              var pl = pushleft.size;
              var fb = pushbottom.val;
              var pb = pushbottom.size;
  
              for(var k2 in pushMargin) {
                  if(isNumeric(pl) && pushMargin[k2].r) {
                      var fr = pushMargin[k2].r.val;
                      var pr = pushMargin[k2].r.size;
  
                      if(fr > fl) {
                          var newL = (pl * fr + (pr - width) * fl) / (fr - fl);
                          var newR = (pr * (1 - fl) + (pl - width) * (1 - fr)) / (fr - fl);
                          if(newL >= 0 && newR >= 0 && width - (newL + newR) > 0 && newL + newR > ml + mr) {
                              ml = newL;
                              mr = newR;
                          }
                      }
                  }
  
                  if(isNumeric(pb) && pushMargin[k2].t) {
                      var ft = pushMargin[k2].t.val;
                      var pt = pushMargin[k2].t.size;
  
                      if(ft > fb) {
                          var newB = (pb * ft + (pt - height) * fb) / (ft - fb);
                          var newT = (pt * (1 - fb) + (pb - height) * (1 - ft)) / (ft - fb);
                          if(newB >= 0 && newT >= 0 && height - (newT + newB) > 0 && newB + newT > mb + mt) {
                              mb = newB;
                              mt = newT;
                          }
                      }
                  }
              }
          }
      }
  
      gs.l = Math.round(ml);
      gs.r = Math.round(mr);
      gs.t = Math.round(mt);
      gs.b = Math.round(mb);
      gs.p = Math.round(margin.pad);
      gs.w = Math.round(width) - gs.l - gs.r;
      gs.h = Math.round(height) - gs.t - gs.b;
  
      // if things changed and we're not already redrawing, trigger a redraw
      if(!fullLayout._replotting && plots.didMarginChange(oldMargins, gs)) {
          if('_redrawFromAutoMarginCount' in fullLayout) {
              fullLayout._redrawFromAutoMarginCount++;
          } else {
              fullLayout._redrawFromAutoMarginCount = 1;
          }
  
          // Always allow at least one redraw and give each margin-push
          // call 3 loops to converge. Of course, for most cases this way too many,
          // but let's keep things on the safe side until we fix our
          // auto-margin pipeline problems:
          // https://github.com/plotly/plotly.js/issues/2704
          var maxNumberOfRedraws = 3 * (1 + Object.keys(pushMarginIds).length);
  
          if(fullLayout._redrawFromAutoMarginCount < maxNumberOfRedraws) {
              return Registry.call('plot', gd);
          } else {
              fullLayout._size = oldMargins;
              Lib.warn('Too many auto-margin redraws.');
          }
      }
  };
  
  var marginKeys = ['l', 'r', 't', 'b', 'p', 'w', 'h'];
  
  plots.didMarginChange = function(margin0, margin1) {
      for(var i = 0; i < marginKeys.length; i++) {
          var k = marginKeys[i];
          var m0 = margin0[k];
          var m1 = margin1[k];
          // use 1px tolerance in case we old/new differ only
          // by rounding errors, which can lead to infinite loops
          if(!isNumeric(m0) || Math.abs(m1 - m0) > 1) {
              return true;
          }
      }
      return false;
  };
  
  /**
   * JSONify the graph data and layout
   *
   * This function needs to recurse because some src can be inside
   * sub-objects.
   *
   * It also strips out functions and private (starts with _) elements.
   * Therefore, we can add temporary things to data and layout that don't
   * get saved.
   *
   * @param gd The graphDiv
   * @param {Boolean} dataonly If true, don't return layout.
   * @param {'keepref'|'keepdata'|'keepall'} [mode='keepref'] Filter what's kept
   *      keepref: remove data for which there's a src present
   *          eg if there's xsrc present (and xsrc is well-formed,
   *          ie has : and some chars before it), strip out x
   *      keepdata: remove all src tags, don't remove the data itself
   *      keepall: keep data and src
   * @param {String} output If you specify 'object', the result will not be stringified
   * @param {Boolean} useDefaults If truthy, use _fullLayout and _fullData
   * @param {Boolean} includeConfig If truthy, include _context
   * @returns {Object|String}
   */
  plots.graphJson = function(gd, dataonly, mode, output, useDefaults, includeConfig) {
      // if the defaults aren't supplied yet, we need to do that...
      if((useDefaults && dataonly && !gd._fullData) ||
              (useDefaults && !dataonly && !gd._fullLayout)) {
          plots.supplyDefaults(gd);
      }
  
      var data = (useDefaults) ? gd._fullData : gd.data;
      var layout = (useDefaults) ? gd._fullLayout : gd.layout;
      var frames = (gd._transitionData || {})._frames;
  
      function stripObj(d, keepFunction) {
          if(typeof d === 'function') {
              return keepFunction ? '_function_' : null;
          }
          if(Lib.isPlainObject(d)) {
              var o = {};
              var src;
              Object.keys(d).sort().forEach(function(v) {
                  // remove private elements and functions
                  // _ is for private, [ is a mistake ie [object Object]
                  if(['_', '['].indexOf(v.charAt(0)) !== -1) return;
  
                  // if a function, add if necessary then move on
                  if(typeof d[v] === 'function') {
                      if(keepFunction) o[v] = '_function';
                      return;
                  }
  
                  // look for src/data matches and remove the appropriate one
                  if(mode === 'keepdata') {
                      // keepdata: remove all ...src tags
                      if(v.substr(v.length - 3) === 'src') {
                          return;
                      }
                  } else if(mode === 'keepstream') {
                      // keep sourced data if it's being streamed.
                      // similar to keepref, but if the 'stream' object exists
                      // in a trace, we will keep the data array.
                      src = d[v + 'src'];
                      if(typeof src === 'string' && src.indexOf(':') > 0) {
                          if(!Lib.isPlainObject(d.stream)) {
                              return;
                          }
                      }
                  } else if(mode !== 'keepall') {
                      // keepref: remove sourced data but only
                      // if the source tag is well-formed
                      src = d[v + 'src'];
                      if(typeof src === 'string' && src.indexOf(':') > 0) {
                          return;
                      }
                  }
  
                  // OK, we're including this... recurse into it
                  o[v] = stripObj(d[v], keepFunction);
              });
              return o;
          }
  
          if(Array.isArray(d)) {
              return d.map(function(x) {return stripObj(x, keepFunction);});
          }
  
          if(Lib.isTypedArray(d)) {
              return Lib.simpleMap(d, Lib.identity);
          }
  
          // convert native dates to date strings...
          // mostly for external users exporting to plotly
          if(Lib.isJSDate(d)) return Lib.ms2DateTimeLocal(+d);
  
          return d;
      }
  
      var obj = {
          data: (data || []).map(function(v) {
              var d = stripObj(v);
              // fit has some little arrays in it that don't contain data,
              // just fit params and meta
              if(dataonly) { delete d.fit; }
              return d;
          })
      };
      if(!dataonly) {
          obj.layout = stripObj(layout);
          if(useDefaults) {
              var gs = layout._size;
              obj.layout.computed = {
                  margin: {
                      b: gs.b,
                      l: gs.l,
                      r: gs.r,
                      t: gs.t
                  }
              };
          }
      }
  
      if(gd.framework && gd.framework.isPolar) obj = gd.framework.getConfig();
  
      if(frames) obj.frames = stripObj(frames);
  
      if(includeConfig) obj.config = stripObj(gd._context, true);
  
      return (output === 'object') ? obj : JSON.stringify(obj);
  };
  
  /**
   * Modify a keyframe using a list of operations:
   *
   * @param {array of objects} operations
   *      Sequence of operations to be performed on the keyframes
   */
  plots.modifyFrames = function(gd, operations) {
      var i, op, frame;
      var _frames = gd._transitionData._frames;
      var _frameHash = gd._transitionData._frameHash;
  
      for(i = 0; i < operations.length; i++) {
          op = operations[i];
  
          switch(op.type) {
              // No reason this couldn't exist, but is currently unused/untested:
              /* case 'rename':
                  frame = _frames[op.index];
                  delete _frameHash[frame.name];
                  _frameHash[op.name] = frame;
                  frame.name = op.name;
                  break;*/
              case 'replace':
                  frame = op.value;
                  var oldName = (_frames[op.index] || {}).name;
                  var newName = frame.name;
                  _frames[op.index] = _frameHash[newName] = frame;
  
                  if(newName !== oldName) {
                      // If name has changed in addition to replacement, then update
                      // the lookup table:
                      delete _frameHash[oldName];
                      _frameHash[newName] = frame;
                  }
  
                  break;
              case 'insert':
                  frame = op.value;
                  _frameHash[frame.name] = frame;
                  _frames.splice(op.index, 0, frame);
                  break;
              case 'delete':
                  frame = _frames[op.index];
                  delete _frameHash[frame.name];
                  _frames.splice(op.index, 1);
                  break;
          }
      }
  
      return Promise.resolve();
  };
  
  /*
   * Compute a keyframe. Merge a keyframe into its base frame(s) and
   * expand properties.
   *
   * @param {object} frameLookup
   *      An object containing frames keyed by name (i.e. gd._transitionData._frameHash)
   * @param {string} frame
   *      The name of the keyframe to be computed
   *
   * Returns: a new object with the merged content
   */
  plots.computeFrame = function(gd, frameName) {
      var frameLookup = gd._transitionData._frameHash;
      var i, traceIndices, traceIndex, destIndex;
  
      // Null or undefined will fail on .toString(). We'll allow numbers since we
      // make it clear frames must be given string names, but we'll allow numbers
      // here since they're otherwise fine for looking up frames as long as they're
      // properly cast to strings. We really just want to ensure here that this
      // 1) doesn't fail, and
      // 2) doens't give an incorrect answer (which String(frameName) would)
      if(!frameName) {
          throw new Error('computeFrame must be given a string frame name');
      }
  
      var framePtr = frameLookup[frameName.toString()];
  
      // Return false if the name is invalid:
      if(!framePtr) {
          return false;
      }
  
      var frameStack = [framePtr];
      var frameNameStack = [framePtr.name];
  
      // Follow frame pointers:
      while(framePtr.baseframe && (framePtr = frameLookup[framePtr.baseframe.toString()])) {
          // Avoid infinite loops:
          if(frameNameStack.indexOf(framePtr.name) !== -1) break;
  
          frameStack.push(framePtr);
          frameNameStack.push(framePtr.name);
      }
  
      // A new object for the merged result:
      var result = {};
  
      // Merge, starting with the last and ending with the desired frame:
      while((framePtr = frameStack.pop())) {
          if(framePtr.layout) {
              result.layout = plots.extendLayout(result.layout, framePtr.layout);
          }
  
          if(framePtr.data) {
              if(!result.data) {
                  result.data = [];
              }
              traceIndices = framePtr.traces;
  
              if(!traceIndices) {
                  // If not defined, assume serial order starting at zero
                  traceIndices = [];
                  for(i = 0; i < framePtr.data.length; i++) {
                      traceIndices[i] = i;
                  }
              }
  
              if(!result.traces) {
                  result.traces = [];
              }
  
              for(i = 0; i < framePtr.data.length; i++) {
                  // Loop through this frames data, find out where it should go,
                  // and merge it!
                  traceIndex = traceIndices[i];
                  if(traceIndex === undefined || traceIndex === null) {
                      continue;
                  }
  
                  destIndex = result.traces.indexOf(traceIndex);
                  if(destIndex === -1) {
                      destIndex = result.data.length;
                      result.traces[destIndex] = traceIndex;
                  }
  
                  result.data[destIndex] = plots.extendTrace(result.data[destIndex], framePtr.data[i]);
              }
          }
      }
  
      return result;
  };
  
  /*
   * Recompute the lookup table that maps frame name -> frame object. addFrames/
   * deleteFrames already manages this data one at a time, so the only time this
   * is necessary is if you poke around manually in `gd._transitionData._frames`
   * and create and haven't updated the lookup table.
   */
  plots.recomputeFrameHash = function(gd) {
      var hash = gd._transitionData._frameHash = {};
      var frames = gd._transitionData._frames;
      for(var i = 0; i < frames.length; i++) {
          var frame = frames[i];
          if(frame && frame.name) {
              hash[frame.name] = frame;
          }
      }
  };
  
  /**
   * Extend an object, treating container arrays very differently by extracting
   * their contents and merging them separately.
   *
   * This exists so that we can extendDeepNoArrays and avoid stepping into data
   * arrays without knowledge of the plot schema, but so that we may also manually
   * recurse into known container arrays, such as transforms.
   *
   * See extendTrace and extendLayout below for usage.
   */
  plots.extendObjectWithContainers = function(dest, src, containerPaths) {
      var containerProp, containerVal, i, j, srcProp, destProp, srcContainer, destContainer;
      var copy = Lib.extendDeepNoArrays({}, src || {});
      var expandedObj = Lib.expandObjectPaths(copy);
      var containerObj = {};
  
      // Step through and extract any container properties. Otherwise extendDeepNoArrays
      // will clobber any existing properties with an empty array and then supplyDefaults
      // will reset everything to defaults.
      if(containerPaths && containerPaths.length) {
          for(i = 0; i < containerPaths.length; i++) {
              containerProp = Lib.nestedProperty(expandedObj, containerPaths[i]);
              containerVal = containerProp.get();
  
              if(containerVal === undefined) {
                  Lib.nestedProperty(containerObj, containerPaths[i]).set(null);
              } else {
                  containerProp.set(null);
                  Lib.nestedProperty(containerObj, containerPaths[i]).set(containerVal);
              }
          }
      }
  
      dest = Lib.extendDeepNoArrays(dest || {}, expandedObj);
  
      if(containerPaths && containerPaths.length) {
          for(i = 0; i < containerPaths.length; i++) {
              srcProp = Lib.nestedProperty(containerObj, containerPaths[i]);
              srcContainer = srcProp.get();
  
              if(!srcContainer) continue;
  
              destProp = Lib.nestedProperty(dest, containerPaths[i]);
              destContainer = destProp.get();
  
              if(!Array.isArray(destContainer)) {
                  destContainer = [];
                  destProp.set(destContainer);
              }
  
              for(j = 0; j < srcContainer.length; j++) {
                  var srcObj = srcContainer[j];
  
                  if(srcObj === null) destContainer[j] = null;
                  else {
                      destContainer[j] = plots.extendObjectWithContainers(destContainer[j], srcObj);
                  }
              }
  
              destProp.set(destContainer);
          }
      }
  
      return dest;
  };
  
  plots.dataArrayContainers = ['transforms', 'dimensions'];
  plots.layoutArrayContainers = Registry.layoutArrayContainers;
  
  /*
   * Extend a trace definition. This method:
   *
   *  1. directly transfers any array references
   *  2. manually recurses into container arrays like transforms
   *
   * The result is the original object reference with the new contents merged in.
   */
  plots.extendTrace = function(destTrace, srcTrace) {
      return plots.extendObjectWithContainers(destTrace, srcTrace, plots.dataArrayContainers);
  };
  
  /*
   * Extend a layout definition. This method:
   *
   *  1. directly transfers any array references (not critically important for
   *     layout since there aren't really data arrays)
   *  2. manually recurses into container arrays like annotations
   *
   * The result is the original object reference with the new contents merged in.
   */
  plots.extendLayout = function(destLayout, srcLayout) {
      return plots.extendObjectWithContainers(destLayout, srcLayout, plots.layoutArrayContainers);
  };
  
  /**
   * Transition to a set of new data and layout properties from Plotly.animate
   *
   * @param {DOM element} gd
   * @param {Object[]} data
   *      an array of data objects following the normal Plotly data definition format
   * @param {Object} layout
   *      a layout object, following normal Plotly layout format
   * @param {Number[]} traces
   *      indices of the corresponding traces specified in `data`
   * @param {Object} frameOpts
   *      options for the frame (i.e. whether to redraw post-transition)
   * @param {Object} transitionOpts
   *      options for the transition
   */
  plots.transition = function(gd, data, layout, traces, frameOpts, transitionOpts) {
      var opts = {redraw: frameOpts.redraw};
      var transitionedTraces = {};
      var axEdits = [];
  
      opts.prepareFn = function() {
          var dataLength = Array.isArray(data) ? data.length : 0;
          var traceIndices = traces.slice(0, dataLength);
  
          for(var i = 0; i < traceIndices.length; i++) {
              var traceIdx = traceIndices[i];
              var trace = gd._fullData[traceIdx];
              var _module = trace._module;
  
              // There's nothing to do if this module is not defined:
              if(!_module) continue;
  
              // Don't register the trace as transitioned if it doesn't know what to do.
              // If it *is* registered, it will receive a callback that it's responsible
              // for calling in order to register the transition as having completed.
              if(_module.animatable) {
                  var n = _module.basePlotModule.name;
                  if(!transitionedTraces[n]) transitionedTraces[n] = [];
                  transitionedTraces[n].push(traceIdx);
              }
  
              gd.data[traceIndices[i]] = plots.extendTrace(gd.data[traceIndices[i]], data[i]);
          }
  
          // Follow the same procedure. Clone it so we don't mangle the input, then
          // expand any object paths so we can merge deep into gd.layout:
          var layoutUpdate = Lib.expandObjectPaths(Lib.extendDeepNoArrays({}, layout));
  
          // Before merging though, we need to modify the incoming layout. We only
          // know how to *transition* layout ranges, so it's imperative that a new
          // range not be sent to the layout before the transition has started. So
          // we must remove the things we can transition:
          var axisAttrRe = /^[xy]axis[0-9]*$/;
          for(var attr in layoutUpdate) {
              if(!axisAttrRe.test(attr)) continue;
              delete layoutUpdate[attr].range;
          }
  
          plots.extendLayout(gd.layout, layoutUpdate);
  
          // Supply defaults after applying the incoming properties. Note that any attempt
          // to simplify this step and reduce the amount of work resulted in the reconstruction
          // of essentially the whole supplyDefaults step, so that it seems sensible to just use
          // supplyDefaults even though it's heavier than would otherwise be desired for
          // transitions:
  
          // first delete calcdata so supplyDefaults knows a calc step is coming
          delete gd.calcdata;
  
          plots.supplyDefaults(gd);
          plots.doCalcdata(gd);
  
          var newLayout = Lib.expandObjectPaths(layout);
  
          if(newLayout) {
              var subplots = gd._fullLayout._plots;
  
              for(var k in subplots) {
                  var plotinfo = subplots[k];
                  var xa = plotinfo.xaxis;
                  var ya = plotinfo.yaxis;
                  var xr0 = xa.range.slice();
                  var yr0 = ya.range.slice();
  
                  var xr1 = null;
                  var yr1 = null;
                  var editX = null;
                  var editY = null;
  
                  if(Array.isArray(newLayout[xa._name + '.range'])) {
                      xr1 = newLayout[xa._name + '.range'].slice();
                  } else if(Array.isArray((newLayout[xa._name] || {}).range)) {
                      xr1 = newLayout[xa._name].range.slice();
                  }
                  if(Array.isArray(newLayout[ya._name + '.range'])) {
                      yr1 = newLayout[ya._name + '.range'].slice();
                  } else if(Array.isArray((newLayout[ya._name] || {}).range)) {
                      yr1 = newLayout[ya._name].range.slice();
                  }
  
                  if(xr0 && xr1 &&
                      (xa.r2l(xr0[0]) !== xa.r2l(xr1[0]) || xa.r2l(xr0[1]) !== xa.r2l(xr1[1]))
                  ) {
                      editX = {xr0: xr0, xr1: xr1};
                  }
                  if(yr0 && yr1 &&
                      (ya.r2l(yr0[0]) !== ya.r2l(yr1[0]) || ya.r2l(yr0[1]) !== ya.r2l(yr1[1]))
                  ) {
                      editY = {yr0: yr0, yr1: yr1};
                  }
  
                  if(editX || editY) {
                      axEdits.push(Lib.extendFlat({plotinfo: plotinfo}, editX, editY));
                  }
              }
          }
  
          return Promise.resolve();
      };
  
      opts.runFn = function(makeCallback) {
          var traceTransitionOpts;
          var basePlotModules = gd._fullLayout._basePlotModules;
          var hasAxisTransition = axEdits.length;
          var i;
  
          if(layout) {
              for(i = 0; i < basePlotModules.length; i++) {
                  if(basePlotModules[i].transitionAxes) {
                      basePlotModules[i].transitionAxes(gd, axEdits, transitionOpts, makeCallback);
                  }
              }
          }
  
          // Here handle the exception that we refuse to animate scales and axes at the same
          // time. In other words, if there's an axis transition, then set the data transition
          // to instantaneous.
          if(hasAxisTransition) {
              traceTransitionOpts = Lib.extendFlat({}, transitionOpts);
              traceTransitionOpts.duration = 0;
              // This means do not transition cartesian traces,
              // this happens on layout-only (e.g. axis range) animations
              delete transitionedTraces.cartesian;
          } else {
              traceTransitionOpts = transitionOpts;
          }
  
          // Note that we pass a callback to *create* the callback that must be invoked on completion.
          // This is since not all traces know about transitions, so it greatly simplifies matters if
          // the trace is responsible for creating a callback, if needed, and then executing it when
          // the time is right.
          for(var n in transitionedTraces) {
              var traceIndices = transitionedTraces[n];
              var _module = gd._fullData[traceIndices[0]]._module;
              _module.basePlotModule.plot(gd, traceIndices, traceTransitionOpts, makeCallback);
          }
      };
  
      return _transition(gd, transitionOpts, opts);
  };
  
  /**
   * Transition to a set of new data and layout properties from Plotly.react
   *
   * @param {DOM element} gd
   * @param {object} restyleFlags
   * - anim {'all'|'some'}
   * @param {object} relayoutFlags
   * - anim {'all'|'some'}
   * @param {object} oldFullLayout : old (pre Plotly.react) fullLayout
   */
  plots.transitionFromReact = function(gd, restyleFlags, relayoutFlags, oldFullLayout) {
      var fullLayout = gd._fullLayout;
      var transitionOpts = fullLayout.transition;
      var opts = {};
      var axEdits = [];
  
      opts.prepareFn = function() {
          var subplots = fullLayout._plots;
  
          // no need to redraw at end of transition,
          // if all changes are animatable
          opts.redraw = false;
          if(restyleFlags.anim === 'some') opts.redraw = true;
          if(relayoutFlags.anim === 'some') opts.redraw = true;
  
          for(var k in subplots) {
              var plotinfo = subplots[k];
              var xa = plotinfo.xaxis;
              var ya = plotinfo.yaxis;
              var xr0 = oldFullLayout[xa._name].range.slice();
              var yr0 = oldFullLayout[ya._name].range.slice();
              var xr1 = xa.range.slice();
              var yr1 = ya.range.slice();
  
              xa.setScale();
              ya.setScale();
  
              var editX = null;
              var editY = null;
  
              if(xa.r2l(xr0[0]) !== xa.r2l(xr1[0]) || xa.r2l(xr0[1]) !== xa.r2l(xr1[1])) {
                  editX = {xr0: xr0, xr1: xr1};
              }
              if(ya.r2l(yr0[0]) !== ya.r2l(yr1[0]) || ya.r2l(yr0[1]) !== ya.r2l(yr1[1])) {
                  editY = {yr0: yr0, yr1: yr1};
              }
  
              if(editX || editY) {
                  axEdits.push(Lib.extendFlat({plotinfo: plotinfo}, editX, editY));
              }
          }
  
          return Promise.resolve();
      };
  
      opts.runFn = function(makeCallback) {
          var fullData = gd._fullData;
          var fullLayout = gd._fullLayout;
          var basePlotModules = fullLayout._basePlotModules;
  
          var axisTransitionOpts;
          var traceTransitionOpts;
          var transitionedTraces;
  
          var allTraceIndices = [];
          for(var i = 0; i < fullData.length; i++) {
              allTraceIndices.push(i);
          }
  
          function transitionAxes() {
              for(var j = 0; j < basePlotModules.length; j++) {
                  if(basePlotModules[j].transitionAxes) {
                      basePlotModules[j].transitionAxes(gd, axEdits, axisTransitionOpts, makeCallback);
                  }
              }
          }
  
          function transitionTraces() {
              for(var j = 0; j < basePlotModules.length; j++) {
                  basePlotModules[j].plot(gd, transitionedTraces, traceTransitionOpts, makeCallback);
              }
          }
  
          if(axEdits.length && restyleFlags.anim) {
              if(transitionOpts.ordering === 'traces first') {
                  axisTransitionOpts = Lib.extendFlat({}, transitionOpts, {duration: 0});
                  transitionedTraces = allTraceIndices;
                  traceTransitionOpts = transitionOpts;
                  setTimeout(transitionAxes, transitionOpts.duration);
                  transitionTraces();
              } else {
                  axisTransitionOpts = transitionOpts;
                  transitionedTraces = null;
                  traceTransitionOpts = Lib.extendFlat({}, transitionOpts, {duration: 0});
                  setTimeout(transitionTraces, axisTransitionOpts.duration);
                  transitionAxes();
              }
          } else if(axEdits.length) {
              axisTransitionOpts = transitionOpts;
              transitionAxes();
          } else if(restyleFlags.anim) {
              transitionedTraces = allTraceIndices;
              traceTransitionOpts = transitionOpts;
              transitionTraces();
          }
      };
  
      return _transition(gd, transitionOpts, opts);
  };
  
  /**
   * trace/layout transition wrapper that works
   * for transitions initiated by Plotly.animate and Plotly.react.
   *
   * @param {DOM element} gd
   * @param {object} transitionOpts
   * @param {object} opts
   * - redraw {boolean}
   * - prepareFn {function} *should return a Promise*
   * - runFn {function} ran inside executeTransitions
   */
  function _transition(gd, transitionOpts, opts) {
      var aborted = false;
  
      function executeCallbacks(list) {
          var p = Promise.resolve();
          if(!list) return p;
          while(list.length) {
              p = p.then((list.shift()));
          }
          return p;
      }
  
      function flushCallbacks(list) {
          if(!list) return;
          while(list.length) {
              list.shift();
          }
      }
  
      function executeTransitions() {
          gd.emit('plotly_transitioning', []);
  
          return new Promise(function(resolve) {
              // This flag is used to disabled things like autorange:
              gd._transitioning = true;
  
              // When instantaneous updates are coming through quickly, it's too much to simply disable
              // all interaction, so store this flag so we can disambiguate whether mouse interactions
              // should be fully disabled or not:
              if(transitionOpts.duration > 0) {
                  gd._transitioningWithDuration = true;
              }
  
              // If another transition is triggered, this callback will be executed simply because it's
              // in the interruptCallbacks queue. If this transition completes, it will instead flush
              // that queue and forget about this callback.
              gd._transitionData._interruptCallbacks.push(function() {
                  aborted = true;
              });
  
              if(opts.redraw) {
                  gd._transitionData._interruptCallbacks.push(function() {
                      return Registry.call('redraw', gd);
                  });
              }
  
              // Emit this and make sure it happens last:
              gd._transitionData._interruptCallbacks.push(function() {
                  gd.emit('plotly_transitioninterrupted', []);
              });
  
              // Construct callbacks that are executed on transition end. This ensures the d3 transitions
              // are *complete* before anything else is done.
              var numCallbacks = 0;
              var numCompleted = 0;
              function makeCallback() {
                  numCallbacks++;
                  return function() {
                      numCompleted++;
                      // When all are complete, perform a redraw:
                      if(!aborted && numCompleted === numCallbacks) {
                          completeTransition(resolve);
                      }
                  };
              }
  
              opts.runFn(makeCallback);
  
              // If nothing else creates a callback, then this will trigger the completion in the next tick:
              setTimeout(makeCallback());
          });
      }
  
      function completeTransition(callback) {
          // This a simple workaround for tests which purge the graph before animations
          // have completed. That's not a very common case, so this is the simplest
          // fix.
          if(!gd._transitionData) return;
  
          flushCallbacks(gd._transitionData._interruptCallbacks);
  
          return Promise.resolve().then(function() {
              if(opts.redraw) {
                  return Registry.call('redraw', gd);
              }
          }).then(function() {
              // Set transitioning false again once the redraw has occurred. This is used, for example,
              // to prevent the trailing redraw from autoranging:
              gd._transitioning = false;
              gd._transitioningWithDuration = false;
  
              gd.emit('plotly_transitioned', []);
          }).then(callback);
      }
  
      function interruptPreviousTransitions() {
          // Fail-safe against purged plot:
          if(!gd._transitionData) return;
  
          // If a transition is interrupted, set this to false. At the moment, the only thing that would
          // interrupt a transition is another transition, so that it will momentarily be set to true
          // again, but this determines whether autorange or dragbox work, so it's for the sake of
          // cleanliness:
          gd._transitioning = false;
  
          return executeCallbacks(gd._transitionData._interruptCallbacks);
      }
  
      var seq = [
          plots.previousPromises,
          interruptPreviousTransitions,
          opts.prepareFn,
          plots.rehover,
          executeTransitions
      ];
  
      var transitionStarting = Lib.syncOrAsync(seq, gd);
  
      if(!transitionStarting || !transitionStarting.then) {
          transitionStarting = Promise.resolve();
      }
  
      return transitionStarting.then(function() { return gd; });
  }
  
  plots.doCalcdata = function(gd, traces) {
      var axList = axisIDs.list(gd);
      var fullData = gd._fullData;
      var fullLayout = gd._fullLayout;
  
      var trace, _module, i, j;
  
      // XXX: Is this correct? Needs a closer look so that *some* traces can be recomputed without
      // *all* needing doCalcdata:
      var calcdata = new Array(fullData.length);
      var oldCalcdata = (gd.calcdata || []).slice();
      gd.calcdata = calcdata;
  
      // extra helper variables
  
      // how many box/violins plots do we have (in case they're grouped)
      fullLayout._numBoxes = 0;
      fullLayout._numViolins = 0;
  
      // initialize violin per-scale-group stats container
      fullLayout._violinScaleGroupStats = {};
  
      // for calculating avg luminosity of heatmaps
      gd._hmpixcount = 0;
      gd._hmlumcount = 0;
  
      // for sharing colors across pies / sunbursts / treemap / funnelarea (and for legend)
      fullLayout._piecolormap = {};
      fullLayout._sunburstcolormap = {};
      fullLayout._treemapcolormap = {};
      fullLayout._funnelareacolormap = {};
  
      // If traces were specified and this trace was not included,
      // then transfer it over from the old calcdata:
      for(i = 0; i < fullData.length; i++) {
          if(Array.isArray(traces) && traces.indexOf(i) === -1) {
              calcdata[i] = oldCalcdata[i];
              continue;
          }
      }
  
      for(i = 0; i < fullData.length; i++) {
          trace = fullData[i];
  
          trace._arrayAttrs = PlotSchema.findArrayAttributes(trace);
  
          // keep track of trace extremes (for autorange) in here
          trace._extremes = {};
      }
  
      // add polar axes to axis list
      var polarIds = fullLayout._subplots.polar || [];
      for(i = 0; i < polarIds.length; i++) {
          axList.push(
              fullLayout[polarIds[i]].radialaxis,
              fullLayout[polarIds[i]].angularaxis
          );
      }
  
      // clear relinked cmin/cmax values in shared axes to start aggregation from scratch
      for(var k in fullLayout._colorAxes) {
          var cOpts = fullLayout[k];
          if(cOpts.cauto !== false) {
              delete cOpts.cmin;
              delete cOpts.cmax;
          }
      }
  
      var hasCalcTransform = false;
  
      function transformCalci(i) {
          trace = fullData[i];
          _module = trace._module;
  
          if(trace.visible === true && trace.transforms) {
              // we need one round of trace module calc before
              // the calc transform to 'fill in' the categories list
              // used for example in the data-to-coordinate method
              if(_module && _module.calc) {
                  var cdi = _module.calc(gd, trace);
  
                  // must clear scene 'batches', so that 2nd
                  // _module.calc call starts from scratch
                  if(cdi[0] && cdi[0].t && cdi[0].t._scene) {
                      delete cdi[0].t._scene.dirty;
                  }
              }
  
              for(j = 0; j < trace.transforms.length; j++) {
                  var transform = trace.transforms[j];
  
                  _module = transformsRegistry[transform.type];
                  if(_module && _module.calcTransform) {
                      trace._hasCalcTransform = true;
                      hasCalcTransform = true;
                      _module.calcTransform(gd, trace, transform);
                  }
              }
          }
      }
  
      function calci(i, isContainer) {
          trace = fullData[i];
          _module = trace._module;
  
          if(!!_module.isContainer !== isContainer) return;
  
          var cd = [];
  
          if(trace.visible === true && trace._length !== 0) {
              // clear existing ref in case it got relinked
              delete trace._indexToPoints;
              // keep ref of index-to-points map object of the *last* enabled transform,
              // this index-to-points map object is required to determine the calcdata indices
              // that correspond to input indices (e.g. from 'selectedpoints')
              var transforms = trace.transforms || [];
              for(j = transforms.length - 1; j >= 0; j--) {
                  if(transforms[j].enabled) {
                      trace._indexToPoints = transforms[j]._indexToPoints;
                      break;
                  }
              }
  
              if(_module && _module.calc) {
                  cd = _module.calc(gd, trace);
              }
          }
  
          // Make sure there is a first point.
          //
          // This ensures there is a calcdata item for every trace,
          // even if cartesian logic doesn't handle it (for things like legends).
          if(!Array.isArray(cd) || !cd[0]) {
              cd = [{x: BADNUM, y: BADNUM}];
          }
  
          // add the trace-wide properties to the first point,
          // per point properties to every point
          // t is the holder for trace-wide properties
          if(!cd[0].t) cd[0].t = {};
          cd[0].trace = trace;
  
          calcdata[i] = cd;
      }
  
      setupAxisCategories(axList, fullData, fullLayout);
  
      // 'transform' loop - must calc container traces first
      // so that if their dependent traces can get transform properly
      for(i = 0; i < fullData.length; i++) calci(i, true);
      for(i = 0; i < fullData.length; i++) transformCalci(i);
  
      // clear stuff that should recomputed in 'regular' loop
      if(hasCalcTransform) setupAxisCategories(axList, fullData, fullLayout);
  
      // 'regular' loop - make sure container traces (eg carpet) calc before
      // contained traces (eg contourcarpet)
      for(i = 0; i < fullData.length; i++) calci(i, true);
      for(i = 0; i < fullData.length; i++) calci(i, false);
  
      doCrossTraceCalc(gd);
  
      // Sort axis categories per value if specified
      var sorted = sortAxisCategoriesByValue(axList, gd);
      if(sorted.length) {
          // how many box/violins plots do we have (in case they're grouped)
          fullLayout._numBoxes = 0;
          fullLayout._numViolins = 0;
          // If a sort operation was performed, run calc() again
          for(i = 0; i < sorted.length; i++) calci(sorted[i], true);
          for(i = 0; i < sorted.length; i++) calci(sorted[i], false);
          doCrossTraceCalc(gd);
      }
  
      Registry.getComponentMethod('fx', 'calc')(gd);
      Registry.getComponentMethod('errorbars', 'calc')(gd);
  };
  
  var sortAxisCategoriesByValueRegex = /(total|sum|min|max|mean|median) (ascending|descending)/;
  
  function sortAxisCategoriesByValue(axList, gd) {
      var affectedTraces = [];
      var i, j, k, l, o;
  
      function zMapCategory(type, ax, value) {
          var axLetter = ax._id.charAt(0);
          if(type === 'histogram2dcontour') {
              var counterAxLetter = ax._counterAxes[0];
              var counterAx = axisIDs.getFromId(gd, counterAxLetter);
  
              var xCategorical = axLetter === 'x' || (counterAxLetter === 'x' && counterAx.type === 'category');
              var yCategorical = axLetter === 'y' || (counterAxLetter === 'y' && counterAx.type === 'category');
  
              return function(o, l) {
                  if(o === 0 || l === 0) return -1; // Skip first row and column
                  if(xCategorical && o === value[l].length - 1) return -1;
                  if(yCategorical && l === value.length - 1) return -1;
  
                  return (axLetter === 'y' ? l : o) - 1;
              };
          } else {
              return function(o, l) {
                  return axLetter === 'y' ? l : o;
              };
          }
      }
  
      var aggFn = {
          'min': function(values) {return Lib.aggNums(Math.min, null, values);},
          'max': function(values) {return Lib.aggNums(Math.max, null, values);},
          'sum': function(values) {return Lib.aggNums(function(a, b) { return a + b;}, null, values);},
          'total': function(values) {return Lib.aggNums(function(a, b) { return a + b;}, null, values);},
          'mean': function(values) {return Lib.mean(values);},
          'median': function(values) {return Lib.median(values);}
      };
  
      for(i = 0; i < axList.length; i++) {
          var ax = axList[i];
          if(ax.type !== 'category') continue;
  
          // Order by value
          var match = ax.categoryorder.match(sortAxisCategoriesByValueRegex);
          if(match) {
              var aggregator = match[1];
              var order = match[2];
  
              // Store values associated with each category
              var categoriesValue = [];
              for(j = 0; j < ax._categories.length; j++) {
                  categoriesValue.push([ax._categories[j], []]);
              }
  
              // Collect values across traces
              for(j = 0; j < ax._traceIndices.length; j++) {
                  var traceIndex = ax._traceIndices[j];
                  var fullTrace = gd._fullData[traceIndex];
                  var axLetter = ax._id.charAt(0);
  
                  // Skip over invisible traces
                  if(fullTrace.visible !== true) continue;
  
                  var type = fullTrace.type;
                  if(Registry.traceIs(fullTrace, 'histogram')) {
                      delete fullTrace._xautoBinFinished;
                      delete fullTrace._yautoBinFinished;
                  }
  
                  var cd = gd.calcdata[traceIndex];
                  for(k = 0; k < cd.length; k++) {
                      var cdi = cd[k];
                      var cat, catIndex, value;
  
                      if(type === 'splom') {
                          // If `splom`, collect values across dimensions
                          // Find which dimension the current axis is representing
                          var currentDimensionIndex = fullTrace._axesDim[ax._id];
  
                          // Apply logic to associated x axis if it's defined
                          if(axLetter === 'y') {
                              var associatedXAxisID = fullTrace._diag[currentDimensionIndex][0];
                              if(associatedXAxisID) ax = gd._fullLayout[axisIDs.id2name(associatedXAxisID)];
                          }
  
                          var categories = cdi.trace.dimensions[currentDimensionIndex].values;
                          for(l = 0; l < categories.length; l++) {
                              cat = categories[l];
                              catIndex = ax._categoriesMap[cat];
  
                              // Collect associated values at index `l` over all other dimensions
                              for(o = 0; o < cdi.trace.dimensions.length; o++) {
                                  if(o === currentDimensionIndex) continue;
                                  var dimension = cdi.trace.dimensions[o];
                                  categoriesValue[catIndex][1].push(dimension.values[l]);
                              }
                          }
                      } else if(type === 'scattergl') {
                          // If `scattergl`, collect all values stashed under cdi.t
                          for(l = 0; l < cdi.t.x.length; l++) {
                              if(axLetter === 'x') {
                                  cat = cdi.t.x[l];
                                  catIndex = cat;
                                  value = cdi.t.y[l];
                              }
  
                              if(axLetter === 'y') {
                                  cat = cdi.t.y[l];
                                  catIndex = cat;
                                  value = cdi.t.x[l];
                              }
                              categoriesValue[catIndex][1].push(value);
                          }
                          // must clear scene 'batches', so that 2nd
                          // _module.calc call starts from scratch
                          if(cdi.t && cdi.t._scene) {
                              delete cdi.t._scene.dirty;
                          }
                      } else if(cdi.hasOwnProperty('z')) {
                          // If 2dMap, collect values in `z`
                          value = cdi.z;
                          var mapping = zMapCategory(fullTrace.type, ax, value);
  
                          for(l = 0; l < value.length; l++) {
                              for(o = 0; o < value[l].length; o++) {
                                  catIndex = mapping(o, l);
                                  if(catIndex + 1) categoriesValue[catIndex][1].push(value[l][o]);
                              }
                          }
                      } else {
                          // For all other 2d cartesian traces
                          if(axLetter === 'x') {
                              cat = cdi.p + 1 ? cdi.p : cdi.x;
                              value = cdi.s || cdi.v || cdi.y;
                          } else if(axLetter === 'y') {
                              cat = cdi.p + 1 ? cdi.p : cdi.y;
                              value = cdi.s || cdi.v || cdi.x;
                          }
                          if(!Array.isArray(value)) value = [value];
                          for(l = 0; l < value.length; l++) {
                              categoriesValue[cat][1].push(value[l]);
                          }
                      }
                  }
              }
  
              ax._categoriesValue = categoriesValue;
  
              var categoriesAggregatedValue = [];
              for(j = 0; j < categoriesValue.length; j++) {
                  categoriesAggregatedValue.push([
                      categoriesValue[j][0],
                      aggFn[aggregator](categoriesValue[j][1])
                  ]);
              }
  
              // Sort by aggregated value
              categoriesAggregatedValue.sort(function(a, b) {
                  return a[1] - b[1];
              });
  
              ax._categoriesAggregatedValue = categoriesAggregatedValue;
  
              // Set new category order
              ax._initialCategories = categoriesAggregatedValue.map(function(c) {
                  return c[0];
              });
  
              // Reverse if descending
              if(order === 'descending') {
                  ax._initialCategories.reverse();
              }
  
              // Sort all matching axes
              affectedTraces = affectedTraces.concat(ax.sortByInitialCategories());
          }
      }
      return affectedTraces;
  }
  
  function setupAxisCategories(axList, fullData, fullLayout) {
      var axLookup = {};
      var i, ax, axId;
  
      for(i = 0; i < axList.length; i++) {
          ax = axList[i];
          axId = ax._id;
  
          ax.clearCalc();
          if(ax.type === 'multicategory') {
              ax.setupMultiCategory(fullData);
          }
  
          axLookup[ax._id] = 1;
      }
  
      // look into match groups for 'missing' axes
      var matchGroups = fullLayout._axisMatchGroups || [];
      for(i = 0; i < matchGroups.length; i++) {
          for(axId in matchGroups[i]) {
              if(!axLookup[axId]) {
                  ax = fullLayout[axisIDs.id2name(axId)];
                  ax.clearCalc();
              }
          }
      }
  }
  
  function doCrossTraceCalc(gd) {
      var fullLayout = gd._fullLayout;
      var modules = fullLayout._visibleModules;
      var hash = {};
      var i, j, k;
  
      // position and range calculations for traces that
      // depend on each other ie bars (stacked or grouped)
      // and boxes (grouped) push each other out of the way
  
      for(j = 0; j < modules.length; j++) {
          var _module = modules[j];
          var fn = _module.crossTraceCalc;
          if(fn) {
              var spType = _module.basePlotModule.name;
              if(hash[spType]) {
                  Lib.pushUnique(hash[spType], fn);
              } else {
                  hash[spType] = [fn];
              }
          }
      }
  
      for(k in hash) {
          var methods = hash[k];
          var subplots = fullLayout._subplots[k];
  
          if(Array.isArray(subplots)) {
              for(i = 0; i < subplots.length; i++) {
                  var sp = subplots[i];
                  var spInfo = k === 'cartesian' ?
                      fullLayout._plots[sp] :
                      fullLayout[sp];
  
                  for(j = 0; j < methods.length; j++) {
                      methods[j](gd, spInfo, sp);
                  }
              }
          } else {
              for(j = 0; j < methods.length; j++) {
                  methods[j](gd);
              }
          }
      }
  }
  
  plots.rehover = function(gd) {
      if(gd._fullLayout._rehover) {
          gd._fullLayout._rehover();
      }
  };
  
  plots.redrag = function(gd) {
      if(gd._fullLayout._redrag) {
          gd._fullLayout._redrag();
      }
  };
  
  plots.generalUpdatePerTraceModule = function(gd, subplot, subplotCalcData, subplotLayout) {
      var traceHashOld = subplot.traceHash;
      var traceHash = {};
      var i;
  
      // build up moduleName -> calcData hash
      for(i = 0; i < subplotCalcData.length; i++) {
          var calcTraces = subplotCalcData[i];
          var trace = calcTraces[0].trace;
  
          // skip over visible === false traces
          // as they don't have `_module` ref
          if(trace.visible) {
              traceHash[trace.type] = traceHash[trace.type] || [];
              traceHash[trace.type].push(calcTraces);
          }
      }
  
      // when a trace gets deleted, make sure that its module's
      // plot method is called so that it is properly
      // removed from the DOM.
      for(var moduleNameOld in traceHashOld) {
          if(!traceHash[moduleNameOld]) {
              var fakeCalcTrace = traceHashOld[moduleNameOld][0];
              var fakeTrace = fakeCalcTrace[0].trace;
  
              fakeTrace.visible = false;
              traceHash[moduleNameOld] = [fakeCalcTrace];
          }
      }
  
      // call module plot method
      for(var moduleName in traceHash) {
          var moduleCalcData = traceHash[moduleName];
          var _module = moduleCalcData[0][0].trace._module;
  
          _module.plot(gd, subplot, Lib.filterVisible(moduleCalcData), subplotLayout);
      }
  
      // update moduleName -> calcData hash
      subplot.traceHash = traceHash;
  };
  
  plots.plotBasePlot = function(desiredType, gd, traces, transitionOpts, makeOnCompleteCallback) {
      var _module = Registry.getModule(desiredType);
      var cdmodule = getModuleCalcData(gd.calcdata, _module)[0];
      _module.plot(gd, cdmodule, transitionOpts, makeOnCompleteCallback);
  };
  
  plots.cleanBasePlot = function(desiredType, newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var had = (oldFullLayout._has && oldFullLayout._has(desiredType));
      var has = (newFullLayout._has && newFullLayout._has(desiredType));
  
      if(had && !has) {
          oldFullLayout['_' + desiredType + 'layer'].selectAll('g.trace').remove();
      }
  };
  
  },{"../components/color":615,"../constants/numerical":725,"../lib":750,"../plot_api/plot_schema":787,"../plot_api/plot_template":788,"../plots/get_data":836,"../registry":882,"./animation_attributes":793,"./attributes":795,"./cartesian/axis_ids":802,"./cartesian/handle_outline":809,"./command":825,"./font_attributes":827,"./frame_attributes":828,"./layout_attributes":853,"d3":169,"d3-time-format":166,"fast-isnumeric":241}],863:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attr: 'subplot',
      name: 'polar',
  
      axisNames: ['angularaxis', 'radialaxis'],
      axisName2dataArray: {angularaxis: 'theta', radialaxis: 'r'},
  
      layerNames: [
          'draglayer',
          'plotbg',
          'backplot',
          'angular-grid',
          'radial-grid',
          'frontplot',
          'angular-line',
          'radial-line',
          'angular-axis',
          'radial-axis'
      ],
  
      radialDragBoxSize: 50,
      angularDragBoxSize: 30,
      cornerLen: 25,
      cornerHalfWidth: 2,
  
      // pixels to move mouse before you stop clamping to starting point
      MINDRAG: 8,
      // smallest radial distance [px] allowed for a zoombox
      MINZOOM: 20,
      // distance [px] off (r=0) or (r=radius) where we transition
      // from single-sided to two-sided radial zoom
      OFFEDGE: 20
  };
  
  },{}],864:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var polygonTester = _dereq_('../../lib/polygon').tester;
  
  var findIndexOfMin = Lib.findIndexOfMin;
  var isAngleInsideSector = Lib.isAngleInsideSector;
  var angleDelta = Lib.angleDelta;
  var angleDist = Lib.angleDist;
  
  /**
   * is pt (r,a) inside polygon made up vertices at angles 'vangles'
   * inside a given polar sector
   *
   * @param {number} r : pt's radial coordinate
   * @param {number} a : pt's angular coordinate in *radians*
   * @param {2-item array} rBnds : sector's radial bounds
   * @param {2-item array} aBnds : sector's angular bounds *radians*
   * @param {array} vangles : angles of polygon vertices in *radians*
   * @return {boolean}
   */
  function isPtInsidePolygon(r, a, rBnds, aBnds, vangles) {
      if(!isAngleInsideSector(a, aBnds)) return false;
  
      var r0, r1;
  
      if(rBnds[0] < rBnds[1]) {
          r0 = rBnds[0];
          r1 = rBnds[1];
      } else {
          r0 = rBnds[1];
          r1 = rBnds[0];
      }
  
      var polygonIn = polygonTester(makePolygon(r0, aBnds[0], aBnds[1], vangles));
      var polygonOut = polygonTester(makePolygon(r1, aBnds[0], aBnds[1], vangles));
      var xy = [r * Math.cos(a), r * Math.sin(a)];
      return polygonOut.contains(xy) && !polygonIn.contains(xy);
  }
  
  // find intersection of 'v0' <-> 'v1' edge with a ray at angle 'a'
  // (i.e. a line that starts from the origin at angle 'a')
  // given an (xp,yp) pair on the 'v0' <-> 'v1' line
  // (N.B. 'v0' and 'v1' are angles in radians)
  function findIntersectionXY(v0, v1, a, xpyp) {
      var xstar, ystar;
  
      var xp = xpyp[0];
      var yp = xpyp[1];
      var dsin = clampTiny(Math.sin(v1) - Math.sin(v0));
      var dcos = clampTiny(Math.cos(v1) - Math.cos(v0));
      var tanA = Math.tan(a);
      var cotanA = clampTiny(1 / tanA);
      var m = dsin / dcos;
      var b = yp - m * xp;
  
      if(cotanA) {
          if(dsin && dcos) {
              // given
              //  g(x) := v0 -> v1 line = m*x + b
              //  h(x) := ray at angle 'a' = m*x = tanA*x
              // solve g(xstar) = h(xstar)
              xstar = b / (tanA - m);
              ystar = tanA * xstar;
          } else if(dcos) {
              // horizontal v0 -> v1
              xstar = yp * cotanA;
              ystar = yp;
          } else {
              // vertical v0 -> v1
              xstar = xp;
              ystar = xp * tanA;
          }
      } else {
          // vertical ray
          if(dsin && dcos) {
              xstar = 0;
              ystar = b;
          } else if(dcos) {
              xstar = 0;
              ystar = yp;
          } else {
              // does this case exists?
              xstar = ystar = NaN;
          }
      }
  
      return [xstar, ystar];
  }
  
  // solves l^2 = (f(x)^2 - yp)^2 + (x - xp)^2
  // rearranged into 0 = a*x^2 + b * x + c
  //
  // where f(x) = m*x + t + yp
  // and   (x0, x1) = (-b +/- del) / (2*a)
  function findXYatLength(l, m, xp, yp) {
      var t = -m * xp;
      var a = m * m + 1;
      var b = 2 * (m * t - xp);
      var c = t * t + xp * xp - l * l;
      var del = Math.sqrt(b * b - 4 * a * c);
      var x0 = (-b + del) / (2 * a);
      var x1 = (-b - del) / (2 * a);
      return [
          [x0, m * x0 + t + yp],
          [x1, m * x1 + t + yp]
      ];
  }
  
  function makeRegularPolygon(r, vangles) {
      var len = vangles.length;
      var vertices = new Array(len + 1);
      var i;
      for(i = 0; i < len; i++) {
          var va = vangles[i];
          vertices[i] = [r * Math.cos(va), r * Math.sin(va)];
      }
      vertices[i] = vertices[0].slice();
      return vertices;
  }
  
  function makeClippedPolygon(r, a0, a1, vangles) {
      var len = vangles.length;
      var vertices = [];
      var i, j;
  
      function a2xy(a) {
          return [r * Math.cos(a), r * Math.sin(a)];
      }
  
      function findXY(va0, va1, s) {
          return findIntersectionXY(va0, va1, s, a2xy(va0));
      }
  
      function cycleIndex(ind) {
          return Lib.mod(ind, len);
      }
  
      function isInside(v) {
          return isAngleInsideSector(v, [a0, a1]);
      }
  
      // find index in sector closest to a0
      // use it to find intersection of v[i0] <-> v[i0-1] edge with sector radius
      var i0 = findIndexOfMin(vangles, function(v) {
          return isInside(v) ? angleDist(v, a0) : Infinity;
      });
      var xy0 = findXY(vangles[i0], vangles[cycleIndex(i0 - 1)], a0);
      vertices.push(xy0);
  
      // fill in in-sector vertices
      for(i = i0, j = 0; j < len; i++, j++) {
          var va = vangles[cycleIndex(i)];
          if(!isInside(va)) break;
          vertices.push(a2xy(va));
      }
  
      // find index in sector closest to a1,
      // use it to find intersection of v[iN] <-> v[iN+1] edge with sector radius
      var iN = findIndexOfMin(vangles, function(v) {
          return isInside(v) ? angleDist(v, a1) : Infinity;
      });
      var xyN = findXY(vangles[iN], vangles[cycleIndex(iN + 1)], a1);
      vertices.push(xyN);
  
      vertices.push([0, 0]);
      vertices.push(vertices[0].slice());
  
      return vertices;
  }
  
  function makePolygon(r, a0, a1, vangles) {
      return Lib.isFullCircle([a0, a1]) ?
          makeRegularPolygon(r, vangles) :
          makeClippedPolygon(r, a0, a1, vangles);
  }
  
  function findPolygonOffset(r, a0, a1, vangles) {
      var minX = Infinity;
      var minY = Infinity;
      var vertices = makePolygon(r, a0, a1, vangles);
  
      for(var i = 0; i < vertices.length; i++) {
          var v = vertices[i];
          minX = Math.min(minX, v[0]);
          minY = Math.min(minY, -v[1]);
      }
      return [minX, minY];
  }
  
  /**
   * find vertex angles (in 'vangles') the enclose angle 'a'
   *
   * @param {number} a : angle in *radians*
   * @param {array} vangles : angles of polygon vertices in *radians*
   * @return {2-item array}
   */
  function findEnclosingVertexAngles(a, vangles) {
      var minFn = function(v) {
          var adelta = angleDelta(v, a);
          return adelta > 0 ? adelta : Infinity;
      };
      var i0 = findIndexOfMin(vangles, minFn);
      var i1 = Lib.mod(i0 + 1, vangles.length);
      return [vangles[i0], vangles[i1]];
  }
  
  // to more easily catch 'almost zero' numbers in if-else blocks
  function clampTiny(v) {
      return Math.abs(v) > 1e-10 ? v : 0;
  }
  
  function transformForSVG(pts0, cx, cy) {
      cx = cx || 0;
      cy = cy || 0;
  
      var len = pts0.length;
      var pts1 = new Array(len);
  
      for(var i = 0; i < len; i++) {
          var pt = pts0[i];
          pts1[i] = [cx + pt[0], cy - pt[1]];
      }
      return pts1;
  }
  
  /**
   * path polygon
   *
   * @param {number} r : polygon 'radius'
   * @param {number} a0 : first angular coordinate in *radians*
   * @param {number} a1 : second angular coordinate in *radians*
   * @param {array} vangles : angles of polygon vertices in *radians*
   * @param {number (optional)} cx : x coordinate of center
   * @param {number (optional)} cy : y coordinate of center
   * @return {string} svg path
   *
   */
  function pathPolygon(r, a0, a1, vangles, cx, cy) {
      var poly = makePolygon(r, a0, a1, vangles);
      return 'M' + transformForSVG(poly, cx, cy).join('L');
  }
  
  /**
   * path a polygon 'annulus'
   * i.e. a polygon with a concentric hole
   *
   * N.B. this routine uses the evenodd SVG rule
   *
   * @param {number} r0 : first radial coordinate
   * @param {number} r1 : second radial coordinate
   * @param {number} a0 : first angular coordinate in *radians*
   * @param {number} a1 : second angular coordinate in *radians*
   * @param {array} vangles : angles of polygon vertices in *radians*
   * @param {number (optional)} cx : x coordinate of center
   * @param {number (optional)} cy : y coordinate of center
   * @return {string} svg path
   *
   */
  function pathPolygonAnnulus(r0, r1, a0, a1, vangles, cx, cy) {
      var rStart, rEnd;
  
      if(r0 < r1) {
          rStart = r0;
          rEnd = r1;
      } else {
          rStart = r1;
          rEnd = r0;
      }
  
      var inner = transformForSVG(makePolygon(rStart, a0, a1, vangles), cx, cy);
      var outer = transformForSVG(makePolygon(rEnd, a0, a1, vangles), cx, cy);
      return 'M' + outer.reverse().join('L') + 'M' + inner.join('L');
  }
  
  module.exports = {
      isPtInsidePolygon: isPtInsidePolygon,
      findPolygonOffset: findPolygonOffset,
      findEnclosingVertexAngles: findEnclosingVertexAngles,
      findIntersectionXY: findIntersectionXY,
      findXYatLength: findXYatLength,
      clampTiny: clampTiny,
      pathPolygon: pathPolygon,
      pathPolygonAnnulus: pathPolygonAnnulus
  };
  
  },{"../../lib":750,"../../lib/polygon":762}],865:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var getSubplotCalcData = _dereq_('../get_data').getSubplotCalcData;
  var counterRegex = _dereq_('../../lib').counterRegex;
  
  var createPolar = _dereq_('./polar');
  var constants = _dereq_('./constants');
  
  var attr = constants.attr;
  var name = constants.name;
  var counter = counterRegex(name);
  
  var attributes = {};
  attributes[attr] = {
      valType: 'subplotid',
      
      dflt: name,
      editType: 'calc',
      
  };
  
  function plot(gd) {
      var fullLayout = gd._fullLayout;
      var calcData = gd.calcdata;
      var subplotIds = fullLayout._subplots[name];
  
      for(var i = 0; i < subplotIds.length; i++) {
          var id = subplotIds[i];
          var subplotCalcData = getSubplotCalcData(calcData, name, id);
          var subplot = fullLayout[id]._subplot;
  
          if(!subplot) {
              subplot = createPolar(gd, id);
              fullLayout[id]._subplot = subplot;
          }
  
          subplot.plot(subplotCalcData, fullLayout, gd._promises);
      }
  }
  
  function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var oldIds = oldFullLayout._subplots[name] || [];
      var hadGl = (oldFullLayout._has && oldFullLayout._has('gl'));
      var hasGl = (newFullLayout._has && newFullLayout._has('gl'));
      var mustCleanScene = hadGl && !hasGl;
  
      for(var i = 0; i < oldIds.length; i++) {
          var id = oldIds[i];
          var oldSubplot = oldFullLayout[id]._subplot;
  
          if(!newFullLayout[id] && !!oldSubplot) {
              oldSubplot.framework.remove();
              oldSubplot.layers['radial-axis-title'].remove();
  
              for(var k in oldSubplot.clipPaths) {
                  oldSubplot.clipPaths[k].remove();
              }
          }
  
          if(mustCleanScene && oldSubplot._scene) {
              oldSubplot._scene.destroy();
              oldSubplot._scene = null;
          }
      }
  }
  
  module.exports = {
      attr: attr,
      name: name,
      idRoot: name,
      idRegex: counter,
      attrRegex: counter,
      attributes: attributes,
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
      plot: plot,
      clean: clean,
      toSVG: _dereq_('../cartesian').toSVG
  };
  
  },{"../../lib":750,"../cartesian":812,"../get_data":836,"./constants":863,"./layout_attributes":866,"./layout_defaults":867,"./polar":874}],866:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorAttrs = _dereq_('../../components/color/attributes');
  var axesAttrs = _dereq_('../cartesian/layout_attributes');
  var domainAttrs = _dereq_('../domain').attributes;
  var extendFlat = _dereq_('../../lib').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var axisLineGridAttr = overrideAll({
      color: axesAttrs.color,
      showline: extendFlat({}, axesAttrs.showline, {dflt: true}),
      linecolor: axesAttrs.linecolor,
      linewidth: axesAttrs.linewidth,
      showgrid: extendFlat({}, axesAttrs.showgrid, {dflt: true}),
      gridcolor: axesAttrs.gridcolor,
      gridwidth: axesAttrs.gridwidth
  
      // TODO add spike* attributes down the road
  
      // should we add zeroline* attributes?
  
  }, 'plot', 'from-root');
  
  var axisTickAttrs = overrideAll({
      tickmode: axesAttrs.tickmode,
      nticks: axesAttrs.nticks,
      tick0: axesAttrs.tick0,
      dtick: axesAttrs.dtick,
      tickvals: axesAttrs.tickvals,
      ticktext: axesAttrs.ticktext,
      ticks: axesAttrs.ticks,
      ticklen: axesAttrs.ticklen,
      tickwidth: axesAttrs.tickwidth,
      tickcolor: axesAttrs.tickcolor,
      showticklabels: axesAttrs.showticklabels,
      showtickprefix: axesAttrs.showtickprefix,
      tickprefix: axesAttrs.tickprefix,
      showticksuffix: axesAttrs.showticksuffix,
      ticksuffix: axesAttrs.ticksuffix,
      showexponent: axesAttrs.showexponent,
      exponentformat: axesAttrs.exponentformat,
      minexponent: axesAttrs.minexponent,
      separatethousands: axesAttrs.separatethousands,
      tickfont: axesAttrs.tickfont,
      tickangle: axesAttrs.tickangle,
      tickformat: axesAttrs.tickformat,
      tickformatstops: axesAttrs.tickformatstops,
      layer: axesAttrs.layer
  }, 'plot', 'from-root');
  
  var radialAxisAttrs = {
      visible: extendFlat({}, axesAttrs.visible, {dflt: true}),
      type: extendFlat({}, axesAttrs.type, {
          values: ['-', 'linear', 'log', 'date', 'category']
      }),
  
      autorange: extendFlat({}, axesAttrs.autorange, {editType: 'plot'}),
      rangemode: {
          valType: 'enumerated',
          values: ['tozero', 'nonnegative', 'normal'],
          dflt: 'tozero',
          
          editType: 'calc',
          
      },
      range: extendFlat({}, axesAttrs.range, {
          items: [
              {valType: 'any', editType: 'plot', impliedEdits: {'^autorange': false}},
              {valType: 'any', editType: 'plot', impliedEdits: {'^autorange': false}}
          ],
          editType: 'plot'
      }),
  
      categoryorder: axesAttrs.categoryorder,
      categoryarray: axesAttrs.categoryarray,
  
      angle: {
          valType: 'angle',
          editType: 'plot',
          
          
      },
  
      side: {
          valType: 'enumerated',
          // TODO add 'center' for `showline: false` radial axes
          values: ['clockwise', 'counterclockwise'],
          dflt: 'clockwise',
          editType: 'plot',
          
          
      },
  
  
      title: {
          // radial title is not gui-editable at the moment,
          // so it needs dflt: '', similar to carpet axes.
          text: extendFlat({}, axesAttrs.title.text, {editType: 'plot', dflt: ''}),
          font: extendFlat({}, axesAttrs.title.font, {editType: 'plot'}),
  
          // TODO
          // - might need a 'titleside' and even 'titledirection' down the road
          // - what about standoff ??
  
          editType: 'plot'
      },
  
      hoverformat: axesAttrs.hoverformat,
  
      uirevision: {
          valType: 'any',
          
          editType: 'none',
          
      },
  
      editType: 'calc',
  
      _deprecated: {
          title: axesAttrs._deprecated.title,
          titlefont: axesAttrs._deprecated.titlefont
      }
  };
  
  extendFlat(
      radialAxisAttrs,
  
      // N.B. radialaxis grid lines are circular,
      // but radialaxis lines are straight from circle center to outer bound
      axisLineGridAttr,
      axisTickAttrs
  );
  
  var angularAxisAttrs = {
      visible: extendFlat({}, axesAttrs.visible, {dflt: true}),
      type: {
          valType: 'enumerated',
          // 'linear' should maybe be called 'angle' or 'angular' here
          // to make clear that axis here is periodic and more tightly match
          // `thetaunit`?
          //
          // skip 'date' for first push
          // no 'log' for now
          values: ['-', 'linear', 'category'],
          dflt: '-',
          
          editType: 'calc',
          _noTemplating: true,
          
      },
  
      categoryorder: axesAttrs.categoryorder,
      categoryarray: axesAttrs.categoryarray,
  
      thetaunit: {
          valType: 'enumerated',
          values: ['radians', 'degrees'],
          dflt: 'degrees',
          
          editType: 'calc',
          
      },
  
      period: {
          valType: 'number',
          editType: 'calc',
          min: 0,
          
          
          // Examples for date axes:
          //
          // - period that equals the timeseries length
          //  http://flowingdata.com/2017/01/24/one-dataset-visualized-25-ways/18-polar-coordinates/
          // - and 1-year periods (focusing on seasonal change0
          //  http://otexts.org/fpp2/seasonal-plots.html
          //  https://blogs.scientificamerican.com/sa-visual/why-are-so-many-babies-born-around-8-00-a-m/
          //  http://www.seasonaladjustment.com/2012/09/05/clock-plot-visualising-seasonality-using-r-and-ggplot2-part-3/
          //  https://i.pinimg.com/736x/49/b9/72/49b972ccb3206a1a6d6f870dac543280.jpg
          //  https://www.climate-lab-book.ac.uk/spirals/
      },
  
      direction: {
          valType: 'enumerated',
          values: ['counterclockwise', 'clockwise'],
          dflt: 'counterclockwise',
          
          editType: 'calc',
          
      },
  
      rotation: {
          valType: 'angle',
          editType: 'calc',
          
          
      },
  
      hoverformat: axesAttrs.hoverformat,
  
      uirevision: {
          valType: 'any',
          
          editType: 'none',
          
      },
  
      editType: 'calc'
  };
  
  extendFlat(
      angularAxisAttrs,
  
      // N.B. angular grid lines are straight lines from circle center to outer bound
      // the angular line is circular bounding the polar plot area.
      axisLineGridAttr,
  
      // N.B. ticksuffix defaults to '°' for angular axes with `thetaunit: 'degrees'`
      axisTickAttrs
  );
  
  module.exports = {
      // TODO for x/y/zoom system for paper-based zooming:
      // x: {},
      // y: {},
      // zoom: {},
  
      domain: domainAttrs({name: 'polar', editType: 'plot'}),
  
      sector: {
          valType: 'info_array',
          items: [
              {valType: 'number', editType: 'plot'},
              {valType: 'number', editType: 'plot'}
          ],
          dflt: [0, 360],
          
          editType: 'plot',
          
      },
      hole: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 0,
          editType: 'plot',
          
          
      },
  
      bgcolor: {
          valType: 'color',
          
          editType: 'plot',
          dflt: colorAttrs.background,
          
      },
  
      radialaxis: radialAxisAttrs,
      angularaxis: angularAxisAttrs,
  
      gridshape: {
          valType: 'enumerated',
          values: ['circular', 'linear'],
          dflt: 'circular',
          
          editType: 'plot',
          
      },
  
      // TODO maybe?
      // annotations:
  
      uirevision: {
          valType: 'any',
          
          editType: 'none',
          
      },
  
      editType: 'calc'
  };
  
  },{"../../components/color/attributes":614,"../../lib":750,"../../plot_api/edit_types":781,"../cartesian/layout_attributes":813,"../domain":826}],867:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  var Template = _dereq_('../../plot_api/plot_template');
  
  var handleSubplotDefaults = _dereq_('../subplot_defaults');
  var getSubplotData = _dereq_('../get_data').getSubplotData;
  
  var handleTickValueDefaults = _dereq_('../cartesian/tick_value_defaults');
  var handleTickMarkDefaults = _dereq_('../cartesian/tick_mark_defaults');
  var handleTickLabelDefaults = _dereq_('../cartesian/tick_label_defaults');
  var handleCategoryOrderDefaults = _dereq_('../cartesian/category_order_defaults');
  var handleLineGridDefaults = _dereq_('../cartesian/line_grid_defaults');
  var autoType = _dereq_('../cartesian/axis_autotype');
  
  var layoutAttributes = _dereq_('./layout_attributes');
  var setConvert = _dereq_('./set_convert');
  var constants = _dereq_('./constants');
  var axisNames = constants.axisNames;
  
  function handleDefaults(contIn, contOut, coerce, opts) {
      var bgColor = coerce('bgcolor');
      opts.bgColor = Color.combine(bgColor, opts.paper_bgcolor);
  
      var sector = coerce('sector');
      coerce('hole');
  
      // could optimize, subplotData is not always needed!
      var subplotData = getSubplotData(opts.fullData, constants.name, opts.id);
      var layoutOut = opts.layoutOut;
      var axName;
  
      function coerceAxis(attr, dflt) {
          return coerce(axName + '.' + attr, dflt);
      }
  
      for(var i = 0; i < axisNames.length; i++) {
          axName = axisNames[i];
  
          if(!Lib.isPlainObject(contIn[axName])) {
              contIn[axName] = {};
          }
  
          var axIn = contIn[axName];
          var axOut = Template.newContainer(contOut, axName);
          axOut._id = axOut._name = axName;
          axOut._attr = opts.id + '.' + axName;
          axOut._traceIndices = subplotData.map(function(t) { return t._expandedIndex; });
  
          var dataAttr = constants.axisName2dataArray[axName];
          var axType = handleAxisTypeDefaults(axIn, axOut, coerceAxis, subplotData, dataAttr);
  
          handleCategoryOrderDefaults(axIn, axOut, coerceAxis, {
              axData: subplotData,
              dataAttr: dataAttr
          });
  
          var visible = coerceAxis('visible');
          setConvert(axOut, contOut, layoutOut);
  
          coerceAxis('uirevision', contOut.uirevision);
  
          var dfltColor;
          var dfltFontColor;
  
          if(visible) {
              dfltColor = coerceAxis('color');
              dfltFontColor = (dfltColor === axIn.color) ? dfltColor : opts.font.color;
          }
  
          // We don't want to make downstream code call ax.setScale,
          // as both radial and angular axes don't have a set domain.
          // Furthermore, angular axes don't have a set range.
          //
          // Mocked domains and ranges are set by the polar subplot instances,
          // but Axes.findExtremes uses the sign of _m to determine which padding value
          // to use.
          //
          // By setting, _m to 1 here, we make Axes.findExtremes think that
          // range[1] > range[0], and vice-versa for `autorange: 'reversed'` below.
          axOut._m = 1;
  
          switch(axName) {
              case 'radialaxis':
                  var autoRange = coerceAxis('autorange', !axOut.isValidRange(axIn.range));
                  axIn.autorange = autoRange;
                  if(autoRange && (axType === 'linear' || axType === '-')) coerceAxis('rangemode');
                  if(autoRange === 'reversed') axOut._m = -1;
  
                  coerceAxis('range');
                  axOut.cleanRange('range', {dfltRange: [0, 1]});
  
                  if(visible) {
                      coerceAxis('side');
                      coerceAxis('angle', sector[0]);
  
                      coerceAxis('title.text');
                      Lib.coerceFont(coerceAxis, 'title.font', {
                          family: opts.font.family,
                          size: Math.round(opts.font.size * 1.2),
                          color: dfltFontColor
                      });
                  }
                  break;
  
              case 'angularaxis':
                  // We do not support 'true' date angular axes yet,
                  // users can still plot dates on angular axes by setting
                  // `angularaxis.type: 'category'`.
                  //
                  // Here, if a date angular axes is detected, we make
                  // all its corresponding traces invisible, so that
                  // when we do add support for data angular axes, the new
                  // behavior won't conflict with existing behavior
                  if(axType === 'date') {
                      Lib.log('Polar plots do not support date angular axes yet.');
  
                      for(var j = 0; j < subplotData.length; j++) {
                          subplotData[j].visible = false;
                      }
  
                      // turn this into a 'dummy' linear axis so that
                      // the subplot still renders ok
                      axType = axIn.type = axOut.type = 'linear';
                  }
  
                  if(axType === 'linear') {
                      coerceAxis('thetaunit');
                  } else {
                      coerceAxis('period');
                  }
  
                  var direction = coerceAxis('direction');
                  coerceAxis('rotation', {counterclockwise: 0, clockwise: 90}[direction]);
                  break;
          }
  
          if(visible) {
              handleTickValueDefaults(axIn, axOut, coerceAxis, axOut.type);
              handleTickLabelDefaults(axIn, axOut, coerceAxis, axOut.type, {
                  tickSuffixDflt: axOut.thetaunit === 'degrees' ? '°' : undefined
              });
              handleTickMarkDefaults(axIn, axOut, coerceAxis, {outerTicks: true});
  
              var showTickLabels = coerceAxis('showticklabels');
              if(showTickLabels) {
                  Lib.coerceFont(coerceAxis, 'tickfont', {
                      family: opts.font.family,
                      size: opts.font.size,
                      color: dfltFontColor
                  });
                  coerceAxis('tickangle');
                  coerceAxis('tickformat');
              }
  
              handleLineGridDefaults(axIn, axOut, coerceAxis, {
                  dfltColor: dfltColor,
                  bgColor: opts.bgColor,
                  // default grid color is darker here (60%, vs cartesian default ~91%)
                  // because the grid is not square so the eye needs heavier cues to follow
                  blend: 60,
                  showLine: true,
                  showGrid: true,
                  noZeroLine: true,
                  attributes: layoutAttributes[axName]
              });
  
              coerceAxis('layer');
          }
  
          if(axType !== 'category') coerceAxis('hoverformat');
  
          axOut._input = axIn;
      }
  
      if(contOut.angularaxis.type === 'category') {
          coerce('gridshape');
      }
  }
  
  function handleAxisTypeDefaults(axIn, axOut, coerce, subplotData, dataAttr) {
      var axType = coerce('type');
  
      if(axType === '-') {
          var trace;
  
          for(var i = 0; i < subplotData.length; i++) {
              if(subplotData[i].visible) {
                  trace = subplotData[i];
                  break;
              }
          }
  
          if(trace && trace[dataAttr]) {
              axOut.type = autoType(trace[dataAttr], 'gregorian');
          }
  
          if(axOut.type === '-') {
              axOut.type = 'linear';
          } else {
              // copy autoType back to input axis
              // note that if this object didn't exist
              // in the input layout, we have to put it in
              // this happens in the main supplyDefaults function
              axIn.type = axOut.type;
          }
      }
  
      return axOut.type;
  }
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
      handleSubplotDefaults(layoutIn, layoutOut, fullData, {
          type: constants.name,
          attributes: layoutAttributes,
          handleDefaults: handleDefaults,
          font: layoutOut.font,
          paper_bgcolor: layoutOut.paper_bgcolor,
          fullData: fullData,
          layoutOut: layoutOut
      });
  };
  
  },{"../../components/color":615,"../../lib":750,"../../plot_api/plot_template":788,"../cartesian/axis_autotype":800,"../cartesian/category_order_defaults":803,"../cartesian/line_grid_defaults":815,"../cartesian/tick_label_defaults":820,"../cartesian/tick_mark_defaults":821,"../cartesian/tick_value_defaults":822,"../get_data":836,"../subplot_defaults":876,"./constants":863,"./layout_attributes":866,"./set_convert":875}],868:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterAttrs = _dereq_('../../../traces/scatter/attributes');
  var scatterMarkerAttrs = scatterAttrs.marker;
  var extendFlat = _dereq_('../../../lib/extend').extendFlat;
  
  var deprecationWarning = [
      'Area traces are deprecated!',
      'Please switch to the *barpolar* trace type.'
  ].join(' ');
  
  module.exports = {
      r: extendFlat({}, scatterAttrs.r, {
          
      }),
      t: extendFlat({}, scatterAttrs.t, {
          
      }),
      marker: {
          color: extendFlat({}, scatterMarkerAttrs.color, {
              
          }),
          size: extendFlat({}, scatterMarkerAttrs.size, {
              
          }),
          symbol: extendFlat({}, scatterMarkerAttrs.symbol, {
              
          }),
          opacity: extendFlat({}, scatterMarkerAttrs.opacity, {
              
          }),
          editType: 'calc'
      }
  };
  
  },{"../../../lib/extend":740,"../../../traces/scatter/attributes":1158}],869:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var axesAttrs = _dereq_('../../cartesian/layout_attributes');
  var extendFlat = _dereq_('../../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../../plot_api/edit_types').overrideAll;
  
  var deprecationWarning = [
      'Legacy polar charts are deprecated!',
      'Please switch to *polar* subplots.'
  ].join(' ');
  
  var domainAttr = extendFlat({}, axesAttrs.domain, {
      
  });
  
  function mergeAttrs(axisName, nonCommonAttrs) {
      var commonAttrs = {
          showline: {
              valType: 'boolean',
              
              
          },
          showticklabels: {
              valType: 'boolean',
              
              
          },
          tickorientation: {
              valType: 'enumerated',
              values: ['horizontal', 'vertical'],
              
              
          },
          ticklen: {
              valType: 'number',
              min: 0,
              
              
          },
          tickcolor: {
              valType: 'color',
              
              
          },
          ticksuffix: {
              valType: 'string',
              
              
          },
          endpadding: {
              valType: 'number',
              
              description: deprecationWarning,
          },
          visible: {
              valType: 'boolean',
              
              
          }
      };
  
      return extendFlat({}, nonCommonAttrs, commonAttrs);
  }
  
  module.exports = overrideAll({
      radialaxis: mergeAttrs('radial', {
          range: {
              valType: 'info_array',
              
              items: [
                  { valType: 'number' },
                  { valType: 'number' }
              ],
              
          },
          domain: domainAttr,
          orientation: {
              valType: 'number',
              
              
          }
      }),
  
      angularaxis: mergeAttrs('angular', {
          range: {
              valType: 'info_array',
              
              items: [
                  { valType: 'number', dflt: 0 },
                  { valType: 'number', dflt: 360 }
              ],
              
          },
          domain: domainAttr
      }),
  
      // attributes that appear at layout root
      layout: {
          direction: {
              valType: 'enumerated',
              values: ['clockwise', 'counterclockwise'],
              
              
          },
          orientation: {
              valType: 'angle',
              
              
          }
      }
  }, 'plot', 'nested');
  
  },{"../../../lib/extend":740,"../../../plot_api/edit_types":781,"../../cartesian/layout_attributes":813}],870:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Polar = module.exports = _dereq_('./micropolar');
  
  Polar.manager = _dereq_('./micropolar_manager');
  
  },{"./micropolar":871,"./micropolar_manager":872}],871:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../../lib');
  var extendDeepAll = Lib.extendDeepAll;
  var MID_SHIFT = _dereq_('../../../constants/alignment').MID_SHIFT;
  
  var µ = module.exports = { version: '0.2.2' };
  
  µ.Axis = function module() {
      var config = {
          data: [],
          layout: {}
      }, inputConfig = {}, liveConfig = {};
      var svg, container, dispatch = d3.dispatch('hover'), radialScale, angularScale;
      var exports = {};
      function render(_container) {
          container = _container || container;
          var data = config.data;
          var axisConfig = config.layout;
          if (typeof container == 'string' || container.nodeName) container = d3.select(container);
          container.datum(data).each(function(_data, _index) {
              var dataOriginal = _data.slice();
              liveConfig = {
                  data: µ.util.cloneJson(dataOriginal),
                  layout: µ.util.cloneJson(axisConfig)
              };
              var colorIndex = 0;
              dataOriginal.forEach(function(d, i) {
                  if (!d.color) {
                      d.color = axisConfig.defaultColorRange[colorIndex];
                      colorIndex = (colorIndex + 1) % axisConfig.defaultColorRange.length;
                  }
                  if (!d.strokeColor) {
                      d.strokeColor = d.geometry === 'LinePlot' ? d.color : d3.rgb(d.color).darker().toString();
                  }
                  liveConfig.data[i].color = d.color;
                  liveConfig.data[i].strokeColor = d.strokeColor;
                  liveConfig.data[i].strokeDash = d.strokeDash;
                  liveConfig.data[i].strokeSize = d.strokeSize;
              });
              var data = dataOriginal.filter(function(d, i) {
                  var visible = d.visible;
                  return typeof visible === 'undefined' || visible === true;
              });
              var isStacked = false;
              var dataWithGroupId = data.map(function(d, i) {
                  isStacked = isStacked || typeof d.groupId !== 'undefined';
                  return d;
              });
              if (isStacked) {
                  var grouped = d3.nest().key(function(d, i) {
                      return typeof d.groupId != 'undefined' ? d.groupId : 'unstacked';
                  }).entries(dataWithGroupId);
                  var dataYStack = [];
                  var stacked = grouped.map(function(d, i) {
                      if (d.key === 'unstacked') return d.values; else {
                          var prevArray = d.values[0].r.map(function(d, i) {
                              return 0;
                          });
                          d.values.forEach(function(d, i, a) {
                              d.yStack = [ prevArray ];
                              dataYStack.push(prevArray);
                              prevArray = µ.util.sumArrays(d.r, prevArray);
                          });
                          return d.values;
                      }
                  });
                  data = d3.merge(stacked);
              }
              data.forEach(function(d, i) {
                  d.t = Array.isArray(d.t[0]) ? d.t : [ d.t ];
                  d.r = Array.isArray(d.r[0]) ? d.r : [ d.r ];
              });
              var radius = Math.min(axisConfig.width - axisConfig.margin.left - axisConfig.margin.right, axisConfig.height - axisConfig.margin.top - axisConfig.margin.bottom) / 2;
              radius = Math.max(10, radius);
              var chartCenter = [ axisConfig.margin.left + radius, axisConfig.margin.top + radius ];
              var extent;
              if (isStacked) {
                  var highestStackedValue = d3.max(µ.util.sumArrays(µ.util.arrayLast(data).r[0], µ.util.arrayLast(dataYStack)));
                  extent = [ 0, highestStackedValue ];
              } else extent = d3.extent(µ.util.flattenArray(data.map(function(d, i) {
                  return d.r;
              })));
              if (axisConfig.radialAxis.domain != µ.DATAEXTENT) extent[0] = 0;
              radialScale = d3.scale.linear().domain(axisConfig.radialAxis.domain != µ.DATAEXTENT && axisConfig.radialAxis.domain ? axisConfig.radialAxis.domain : extent).range([ 0, radius ]);
              liveConfig.layout.radialAxis.domain = radialScale.domain();
              var angularDataMerged = µ.util.flattenArray(data.map(function(d, i) {
                  return d.t;
              }));
              var isOrdinal = typeof angularDataMerged[0] === 'string';
              var ticks;
              if (isOrdinal) {
                  angularDataMerged = µ.util.deduplicate(angularDataMerged);
                  ticks = angularDataMerged.slice();
                  angularDataMerged = d3.range(angularDataMerged.length);
                  data = data.map(function(d, i) {
                      var result = d;
                      d.t = [ angularDataMerged ];
                      if (isStacked) result.yStack = d.yStack;
                      return result;
                  });
              }
              var hasOnlyLineOrDotPlot = data.filter(function(d, i) {
                  return d.geometry === 'LinePlot' || d.geometry === 'DotPlot';
              }).length === data.length;
              var needsEndSpacing = axisConfig.needsEndSpacing === null ? isOrdinal || !hasOnlyLineOrDotPlot : axisConfig.needsEndSpacing;
              var useProvidedDomain = axisConfig.angularAxis.domain && axisConfig.angularAxis.domain != µ.DATAEXTENT && !isOrdinal && axisConfig.angularAxis.domain[0] >= 0;
              var angularDomain = useProvidedDomain ? axisConfig.angularAxis.domain : d3.extent(angularDataMerged);
              var angularDomainStep = Math.abs(angularDataMerged[1] - angularDataMerged[0]);
              if (hasOnlyLineOrDotPlot && !isOrdinal) angularDomainStep = 0;
              var angularDomainWithPadding = angularDomain.slice();
              if (needsEndSpacing && isOrdinal) angularDomainWithPadding[1] += angularDomainStep;
              var tickCount = axisConfig.angularAxis.ticksCount || 4;
              if (tickCount > 8) tickCount = tickCount / (tickCount / 8) + tickCount % 8;
              if (axisConfig.angularAxis.ticksStep) {
                  tickCount = (angularDomainWithPadding[1] - angularDomainWithPadding[0]) / tickCount;
              }
              var angularTicksStep = axisConfig.angularAxis.ticksStep || (angularDomainWithPadding[1] - angularDomainWithPadding[0]) / (tickCount * (axisConfig.minorTicks + 1));
              if (ticks) angularTicksStep = Math.max(Math.round(angularTicksStep), 1);
              if (!angularDomainWithPadding[2]) angularDomainWithPadding[2] = angularTicksStep;
              var angularAxisRange = d3.range.apply(this, angularDomainWithPadding);
              angularAxisRange = angularAxisRange.map(function(d, i) {
                  return parseFloat(d.toPrecision(12));
              });
              angularScale = d3.scale.linear().domain(angularDomainWithPadding.slice(0, 2)).range(axisConfig.direction === 'clockwise' ? [ 0, 360 ] : [ 360, 0 ]);
              liveConfig.layout.angularAxis.domain = angularScale.domain();
              liveConfig.layout.angularAxis.endPadding = needsEndSpacing ? angularDomainStep : 0;
              svg = d3.select(this).select('svg.chart-root');
              if (typeof svg === 'undefined' || svg.empty()) {
                  var skeleton = "<svg xmlns='http://www.w3.org/2000/svg' class='chart-root'>' + '<g class='outer-group'>' + '<g class='chart-group'>' + '<circle class='background-circle'></circle>' + '<g class='geometry-group'></g>' + '<g class='radial axis-group'>' + '<circle class='outside-circle'></circle>' + '</g>' + '<g class='angular axis-group'></g>' + '<g class='guides-group'><line></line><circle r='0'></circle></g>' + '</g>' + '<g class='legend-group'></g>' + '<g class='tooltips-group'></g>' + '<g class='title-group'><text></text></g>' + '</g>' + '</svg>";
                  var doc = new DOMParser().parseFromString(skeleton, 'application/xml');
                  var newSvg = this.appendChild(this.ownerDocument.importNode(doc.documentElement, true));
                  svg = d3.select(newSvg);
              }
              svg.select('.guides-group').style({
                  'pointer-events': 'none'
              });
              svg.select('.angular.axis-group').style({
                  'pointer-events': 'none'
              });
              svg.select('.radial.axis-group').style({
                  'pointer-events': 'none'
              });
              var chartGroup = svg.select('.chart-group');
              var lineStyle = {
                  fill: 'none',
                  stroke: axisConfig.tickColor
              };
              var fontStyle = {
                  'font-size': axisConfig.font.size,
                  'font-family': axisConfig.font.family,
                  fill: axisConfig.font.color,
                  'text-shadow': [ '-1px 0px', '1px -1px', '-1px 1px', '1px 1px' ].map(function(d, i) {
                      return ' ' + d + ' 0 ' + axisConfig.font.outlineColor;
                  }).join(',')
              };
              var legendContainer;
              if (axisConfig.showLegend) {
                  legendContainer = svg.select('.legend-group').attr({
                      transform: 'translate(' + [ radius, axisConfig.margin.top ] + ')'
                  }).style({
                      display: 'block'
                  });
                  var elements = data.map(function(d, i) {
                      var datumClone = µ.util.cloneJson(d);
                      datumClone.symbol = d.geometry === 'DotPlot' ? d.dotType || 'circle' : d.geometry != 'LinePlot' ? 'square' : 'line';
                      datumClone.visibleInLegend = typeof d.visibleInLegend === 'undefined' || d.visibleInLegend;
                      datumClone.color = d.geometry === 'LinePlot' ? d.strokeColor : d.color;
                      return datumClone;
                  });
  
                  µ.Legend().config({
                      data: data.map(function(d, i) {
                          return d.name || 'Element' + i;
                      }),
                      legendConfig: extendDeepAll({},
                          µ.Legend.defaultConfig().legendConfig,
                          {
                              container: legendContainer,
                              elements: elements,
                              reverseOrder: axisConfig.legend.reverseOrder
                          }
                      )
                  })();
  
                  var legendBBox = legendContainer.node().getBBox();
                  radius = Math.min(axisConfig.width - legendBBox.width - axisConfig.margin.left - axisConfig.margin.right, axisConfig.height - axisConfig.margin.top - axisConfig.margin.bottom) / 2;
                  radius = Math.max(10, radius);
                  chartCenter = [ axisConfig.margin.left + radius, axisConfig.margin.top + radius ];
                  radialScale.range([ 0, radius ]);
                  liveConfig.layout.radialAxis.domain = radialScale.domain();
                  legendContainer.attr('transform', 'translate(' + [ chartCenter[0] + radius, chartCenter[1] - radius ] + ')');
              } else {
                  legendContainer = svg.select('.legend-group').style({
                      display: 'none'
                  });
              }
              svg.attr({
                  width: axisConfig.width,
                  height: axisConfig.height
              }).style({
                  opacity: axisConfig.opacity
              });
              chartGroup.attr('transform', 'translate(' + chartCenter + ')').style({
                  cursor: 'crosshair'
              });
              var centeringOffset = [ (axisConfig.width - (axisConfig.margin.left + axisConfig.margin.right + radius * 2 + (legendBBox ? legendBBox.width : 0))) / 2, (axisConfig.height - (axisConfig.margin.top + axisConfig.margin.bottom + radius * 2)) / 2 ];
              centeringOffset[0] = Math.max(0, centeringOffset[0]);
              centeringOffset[1] = Math.max(0, centeringOffset[1]);
              svg.select('.outer-group').attr('transform', 'translate(' + centeringOffset + ')');
              if (axisConfig.title && axisConfig.title.text) {
                  var title = svg.select('g.title-group text').style(fontStyle).text(axisConfig.title.text);
                  var titleBBox = title.node().getBBox();
                  title.attr({
                      x: chartCenter[0] - titleBBox.width / 2,
                      y: chartCenter[1] - radius - 20
                  });
              }
              var radialAxis = svg.select('.radial.axis-group');
              if (axisConfig.radialAxis.gridLinesVisible) {
                  var gridCircles = radialAxis.selectAll('circle.grid-circle').data(radialScale.ticks(5));
                  gridCircles.enter().append('circle').attr({
                      'class': 'grid-circle'
                  }).style(lineStyle);
                  gridCircles.attr('r', radialScale);
                  gridCircles.exit().remove();
              }
              radialAxis.select('circle.outside-circle').attr({
                  r: radius
              }).style(lineStyle);
              var backgroundCircle = svg.select('circle.background-circle').attr({
                  r: radius
              }).style({
                  fill: axisConfig.backgroundColor,
                  stroke: axisConfig.stroke
              });
              function currentAngle(d, i) {
                  return angularScale(d) % 360 + axisConfig.orientation;
              }
              if (axisConfig.radialAxis.visible) {
                  var axis = d3.svg.axis().scale(radialScale).ticks(5).tickSize(5);
                  radialAxis.call(axis).attr({
                      transform: 'rotate(' + axisConfig.radialAxis.orientation + ')'
                  });
                  radialAxis.selectAll('.domain').style(lineStyle);
                  radialAxis.selectAll('g>text').text(function(d, i) {
                      return this.textContent + axisConfig.radialAxis.ticksSuffix;
                  }).style(fontStyle).style({
                      'text-anchor': 'start'
                  }).attr({
                      x: 0,
                      y: 0,
                      dx: 0,
                      dy: 0,
                      transform: function(d, i) {
                          if (axisConfig.radialAxis.tickOrientation === 'horizontal') {
                              return 'rotate(' + -axisConfig.radialAxis.orientation + ') translate(' + [ 0, fontStyle['font-size'] ] + ')';
                          } else return 'translate(' + [ 0, fontStyle['font-size'] ] + ')';
                      }
                  });
                  radialAxis.selectAll('g>line').style({
                      stroke: 'black'
                  });
              }
              var angularAxis = svg.select('.angular.axis-group').selectAll('g.angular-tick').data(angularAxisRange);
              var angularAxisEnter = angularAxis.enter().append('g').classed('angular-tick', true);
              angularAxis.attr({
                  transform: function(d, i) {
                      return 'rotate(' + currentAngle(d, i) + ')';
                  }
              }).style({
                  display: axisConfig.angularAxis.visible ? 'block' : 'none'
              });
              angularAxis.exit().remove();
              angularAxisEnter.append('line').classed('grid-line', true).classed('major', function(d, i) {
                  return i % (axisConfig.minorTicks + 1) == 0;
              }).classed('minor', function(d, i) {
                  return !(i % (axisConfig.minorTicks + 1) == 0);
              }).style(lineStyle);
              angularAxisEnter.selectAll('.minor').style({
                  stroke: axisConfig.minorTickColor
              });
              angularAxis.select('line.grid-line').attr({
                  x1: axisConfig.tickLength ? radius - axisConfig.tickLength : 0,
                  x2: radius
              }).style({
                  display: axisConfig.angularAxis.gridLinesVisible ? 'block' : 'none'
              });
              angularAxisEnter.append('text').classed('axis-text', true).style(fontStyle);
              var ticksText = angularAxis.select('text.axis-text').attr({
                  x: radius + axisConfig.labelOffset,
                  dy: MID_SHIFT + 'em',
                  transform: function(d, i) {
                      var angle = currentAngle(d, i);
                      var rad = radius + axisConfig.labelOffset;
                      var orient = axisConfig.angularAxis.tickOrientation;
                      if (orient == 'horizontal') return 'rotate(' + -angle + ' ' + rad + ' 0)'; else if (orient == 'radial') return angle < 270 && angle > 90 ? 'rotate(180 ' + rad + ' 0)' : null; else return 'rotate(' + (angle <= 180 && angle > 0 ? -90 : 90) + ' ' + rad + ' 0)';
                  }
              }).style({
                  'text-anchor': 'middle',
                  display: axisConfig.angularAxis.labelsVisible ? 'block' : 'none'
              }).text(function(d, i) {
                  if (i % (axisConfig.minorTicks + 1) != 0) return '';
                  if (ticks) {
                      return ticks[d] + axisConfig.angularAxis.ticksSuffix;
                  } else return d + axisConfig.angularAxis.ticksSuffix;
              }).style(fontStyle);
              if (axisConfig.angularAxis.rewriteTicks) ticksText.text(function(d, i) {
                  if (i % (axisConfig.minorTicks + 1) != 0) return '';
                  return axisConfig.angularAxis.rewriteTicks(this.textContent, i);
              });
              var rightmostTickEndX = d3.max(chartGroup.selectAll('.angular-tick text')[0].map(function(d, i) {
                  return d.getCTM().e + d.getBBox().width;
              }));
              legendContainer.attr({
                  transform: 'translate(' + [ radius + rightmostTickEndX, axisConfig.margin.top ] + ')'
              });
              var hasGeometry = svg.select('g.geometry-group').selectAll('g').size() > 0;
              var geometryContainer = svg.select('g.geometry-group').selectAll('g.geometry').data(data);
              geometryContainer.enter().append('g').attr({
                  'class': function(d, i) {
                      return 'geometry geometry' + i;
                  }
              });
              geometryContainer.exit().remove();
              if (data[0] || hasGeometry) {
                  var geometryConfigs = [];
                  data.forEach(function(d, i) {
                      var geometryConfig = {};
                      geometryConfig.radialScale = radialScale;
                      geometryConfig.angularScale = angularScale;
                      geometryConfig.container = geometryContainer.filter(function(dB, iB) {
                          return iB == i;
                      });
                      geometryConfig.geometry = d.geometry;
                      geometryConfig.orientation = axisConfig.orientation;
                      geometryConfig.direction = axisConfig.direction;
                      geometryConfig.index = i;
                      geometryConfigs.push({
                          data: d,
                          geometryConfig: geometryConfig
                      });
                  });
                  var geometryConfigsGrouped = d3.nest().key(function(d, i) {
                      return typeof d.data.groupId != 'undefined' || 'unstacked';
                  }).entries(geometryConfigs);
                  var geometryConfigsGrouped2 = [];
                  geometryConfigsGrouped.forEach(function(d, i) {
                      if (d.key === 'unstacked') geometryConfigsGrouped2 = geometryConfigsGrouped2.concat(d.values.map(function(d, i) {
                          return [ d ];
                      })); else geometryConfigsGrouped2.push(d.values);
                  });
                  geometryConfigsGrouped2.forEach(function(d, i) {
                      var geometry;
                      if (Array.isArray(d)) geometry = d[0].geometryConfig.geometry; else geometry = d.geometryConfig.geometry;
                      var finalGeometryConfig = d.map(function(dB, iB) {
                          return extendDeepAll(µ[geometry].defaultConfig(), dB);
                      });
                      µ[geometry]().config(finalGeometryConfig)();
                  });
              }
              var guides = svg.select('.guides-group');
              var tooltipContainer = svg.select('.tooltips-group');
              var angularTooltip = µ.tooltipPanel().config({
                  container: tooltipContainer,
                  fontSize: 8
              })();
              var radialTooltip = µ.tooltipPanel().config({
                  container: tooltipContainer,
                  fontSize: 8
              })();
              var geometryTooltip = µ.tooltipPanel().config({
                  container: tooltipContainer,
                  hasTick: true
              })();
              var angularValue, radialValue;
              if (!isOrdinal) {
                  var angularGuideLine = guides.select('line').attr({
                      x1: 0,
                      y1: 0,
                      y2: 0
                  }).style({
                      stroke: 'grey',
                      'pointer-events': 'none'
                  });
                  chartGroup.on('mousemove.angular-guide', function(d, i) {
                      var mouseAngle = µ.util.getMousePos(backgroundCircle).angle;
                      angularGuideLine.attr({
                          x2: -radius,
                          transform: 'rotate(' + mouseAngle + ')'
                      }).style({
                          opacity: .5
                      });
                      var angleWithOriginOffset = (mouseAngle + 180 + 360 - axisConfig.orientation) % 360;
                      angularValue = angularScale.invert(angleWithOriginOffset);
                      var pos = µ.util.convertToCartesian(radius + 12, mouseAngle + 180);
                      angularTooltip.text(µ.util.round(angularValue)).move([ pos[0] + chartCenter[0], pos[1] + chartCenter[1] ]);
                  }).on('mouseout.angular-guide', function(d, i) {
                      guides.select('line').style({
                          opacity: 0
                      });
                  });
              }
              var angularGuideCircle = guides.select('circle').style({
                  stroke: 'grey',
                  fill: 'none'
              });
              chartGroup.on('mousemove.radial-guide', function(d, i) {
                  var r = µ.util.getMousePos(backgroundCircle).radius;
                  angularGuideCircle.attr({
                      r: r
                  }).style({
                      opacity: .5
                  });
                  radialValue = radialScale.invert(µ.util.getMousePos(backgroundCircle).radius);
                  var pos = µ.util.convertToCartesian(r, axisConfig.radialAxis.orientation);
                  radialTooltip.text(µ.util.round(radialValue)).move([ pos[0] + chartCenter[0], pos[1] + chartCenter[1] ]);
              }).on('mouseout.radial-guide', function(d, i) {
                  angularGuideCircle.style({
                      opacity: 0
                  });
                  geometryTooltip.hide();
                  angularTooltip.hide();
                  radialTooltip.hide();
              });
              svg.selectAll('.geometry-group .mark').on('mouseover.tooltip', function(d, i) {
                  var el = d3.select(this);
                  var color = this.style.fill;
                  var newColor = 'black';
                  var opacity = this.style.opacity || 1;
                  el.attr({
                      'data-opacity': opacity
                  });
                  if (color && color !== 'none') {
                      el.attr({
                          'data-fill': color
                      });
                      newColor = d3.hsl(color).darker().toString();
                      el.style({
                          fill: newColor,
                          opacity: 1
                      });
                      var textData = {
                          t: µ.util.round(d[0]),
                          r: µ.util.round(d[1])
                      };
                      if (isOrdinal) textData.t = ticks[d[0]];
                      var text = 't: ' + textData.t + ', r: ' + textData.r;
                      var bbox = this.getBoundingClientRect();
                      var svgBBox = svg.node().getBoundingClientRect();
                      var pos = [ bbox.left + bbox.width / 2 - centeringOffset[0] - svgBBox.left, bbox.top + bbox.height / 2 - centeringOffset[1] - svgBBox.top ];
                      geometryTooltip.config({
                          color: newColor
                      }).text(text);
                      geometryTooltip.move(pos);
                  } else {
                      color = this.style.stroke || 'black';
                      el.attr({
                          'data-stroke': color
                      });
                      newColor = d3.hsl(color).darker().toString();
                      el.style({
                          stroke: newColor,
                          opacity: 1
                      });
                  }
              }).on('mousemove.tooltip', function(d, i) {
                  if (d3.event.which != 0) return false;
                  if (d3.select(this).attr('data-fill')) geometryTooltip.show();
              }).on('mouseout.tooltip', function(d, i) {
                  geometryTooltip.hide();
                  var el = d3.select(this);
                  var fillColor = el.attr('data-fill');
                  if (fillColor) el.style({
                      fill: fillColor,
                      opacity: el.attr('data-opacity')
                  }); else el.style({
                      stroke: el.attr('data-stroke'),
                      opacity: el.attr('data-opacity')
                  });
              });
          });
          return exports;
      }
      exports.render = function(_container) {
          render(_container);
          return this;
      };
      exports.config = function(_x) {
          if (!arguments.length) return config;
          var xClone = µ.util.cloneJson(_x);
          xClone.data.forEach(function(d, i) {
              if (!config.data[i]) config.data[i] = {};
              extendDeepAll(config.data[i], µ.Axis.defaultConfig().data[0]);
              extendDeepAll(config.data[i], d);
          });
          extendDeepAll(config.layout, µ.Axis.defaultConfig().layout);
          extendDeepAll(config.layout, xClone.layout);
          return this;
      };
      exports.getLiveConfig = function() {
          return liveConfig;
      };
      exports.getinputConfig = function() {
          return inputConfig;
      };
      exports.radialScale = function(_x) {
          return radialScale;
      };
      exports.angularScale = function(_x) {
          return angularScale;
      };
      exports.svg = function() {
          return svg;
      };
      d3.rebind(exports, dispatch, 'on');
      return exports;
  };
  
  µ.Axis.defaultConfig = function(d, i) {
      var config = {
          data: [ {
              t: [ 1, 2, 3, 4 ],
              r: [ 10, 11, 12, 13 ],
              name: 'Line1',
              geometry: 'LinePlot',
              color: null,
              strokeDash: 'solid',
              strokeColor: null,
              strokeSize: '1',
              visibleInLegend: true,
              opacity: 1
          } ],
          layout: {
              defaultColorRange: d3.scale.category10().range(),
              title: null,
              height: 450,
              width: 500,
              margin: {
                  top: 40,
                  right: 40,
                  bottom: 40,
                  left: 40
              },
              font: {
                  size: 12,
                  color: 'gray',
                  outlineColor: 'white',
                  family: 'Tahoma, sans-serif'
              },
              direction: 'clockwise',
              orientation: 0,
              labelOffset: 10,
              radialAxis: {
                  domain: null,
                  orientation: -45,
                  ticksSuffix: '',
                  visible: true,
                  gridLinesVisible: true,
                  tickOrientation: 'horizontal',
                  rewriteTicks: null
              },
              angularAxis: {
                  domain: [ 0, 360 ],
                  ticksSuffix: '',
                  visible: true,
                  gridLinesVisible: true,
                  labelsVisible: true,
                  tickOrientation: 'horizontal',
                  rewriteTicks: null,
                  ticksCount: null,
                  ticksStep: null
              },
              minorTicks: 0,
              tickLength: null,
              tickColor: 'silver',
              minorTickColor: '#eee',
              backgroundColor: 'none',
              needsEndSpacing: null,
              showLegend: true,
              legend: {
                  reverseOrder: false
              },
              opacity: 1
          }
      };
      return config;
  };
  
  µ.util = {};
  
  µ.DATAEXTENT = 'dataExtent';
  
  µ.AREA = 'AreaChart';
  
  µ.LINE = 'LinePlot';
  
  µ.DOT = 'DotPlot';
  
  µ.BAR = 'BarChart';
  
  µ.util._override = function(_objA, _objB) {
      for (var x in _objA) if (x in _objB) _objB[x] = _objA[x];
  };
  
  µ.util._extend = function(_objA, _objB) {
      for (var x in _objA) _objB[x] = _objA[x];
  };
  
  µ.util._rndSnd = function() {
      return Math.random() * 2 - 1 + (Math.random() * 2 - 1) + (Math.random() * 2 - 1);
  };
  
  µ.util.dataFromEquation2 = function(_equation, _step) {
      var step = _step || 6;
      var data = d3.range(0, 360 + step, step).map(function(deg, index) {
          var theta = deg * Math.PI / 180;
          var radius = _equation(theta);
          return [ deg, radius ];
      });
      return data;
  };
  
  µ.util.dataFromEquation = function(_equation, _step, _name) {
      var step = _step || 6;
      var t = [], r = [];
      d3.range(0, 360 + step, step).forEach(function(deg, index) {
          var theta = deg * Math.PI / 180;
          var radius = _equation(theta);
          t.push(deg);
          r.push(radius);
      });
      var result = {
          t: t,
          r: r
      };
      if (_name) result.name = _name;
      return result;
  };
  
  µ.util.ensureArray = function(_val, _count) {
      if (typeof _val === 'undefined') return null;
      var arr = [].concat(_val);
      return d3.range(_count).map(function(d, i) {
          return arr[i] || arr[0];
      });
  };
  
  µ.util.fillArrays = function(_obj, _valueNames, _count) {
      _valueNames.forEach(function(d, i) {
          _obj[d] = µ.util.ensureArray(_obj[d], _count);
      });
      return _obj;
  };
  
  µ.util.cloneJson = function(json) {
      return JSON.parse(JSON.stringify(json));
  };
  
  µ.util.validateKeys = function(obj, keys) {
      if (typeof keys === 'string') keys = keys.split('.');
      var next = keys.shift();
      return obj[next] && (!keys.length || objHasKeys(obj[next], keys));
  };
  
  µ.util.sumArrays = function(a, b) {
      return d3.zip(a, b).map(function(d, i) {
          return d3.sum(d);
      });
  };
  
  µ.util.arrayLast = function(a) {
      return a[a.length - 1];
  };
  
  µ.util.arrayEqual = function(a, b) {
      var i = Math.max(a.length, b.length, 1);
      while (i-- >= 0 && a[i] === b[i]) ;
      return i === -2;
  };
  
  µ.util.flattenArray = function(arr) {
      var r = [];
      while (!µ.util.arrayEqual(r, arr)) {
          r = arr;
          arr = [].concat.apply([], arr);
      }
      return arr;
  };
  
  µ.util.deduplicate = function(arr) {
      return arr.filter(function(v, i, a) {
          return a.indexOf(v) == i;
      });
  };
  
  µ.util.convertToCartesian = function(radius, theta) {
      var thetaRadians = theta * Math.PI / 180;
      var x = radius * Math.cos(thetaRadians);
      var y = radius * Math.sin(thetaRadians);
      return [ x, y ];
  };
  
  µ.util.round = function(_value, _digits) {
      var digits = _digits || 2;
      var mult = Math.pow(10, digits);
      return Math.round(_value * mult) / mult;
  };
  
  µ.util.getMousePos = function(_referenceElement) {
      var mousePos = d3.mouse(_referenceElement.node());
      var mouseX = mousePos[0];
      var mouseY = mousePos[1];
      var mouse = {};
      mouse.x = mouseX;
      mouse.y = mouseY;
      mouse.pos = mousePos;
      mouse.angle = (Math.atan2(mouseY, mouseX) + Math.PI) * 180 / Math.PI;
      mouse.radius = Math.sqrt(mouseX * mouseX + mouseY * mouseY);
      return mouse;
  };
  
  µ.util.duplicatesCount = function(arr) {
      var uniques = {}, val;
      var dups = {};
      for (var i = 0, len = arr.length; i < len; i++) {
          val = arr[i];
          if (val in uniques) {
              uniques[val]++;
              dups[val] = uniques[val];
          } else {
              uniques[val] = 1;
          }
      }
      return dups;
  };
  
  µ.util.duplicates = function(arr) {
      return Object.keys(µ.util.duplicatesCount(arr));
  };
  
  µ.util.translator = function(obj, sourceBranch, targetBranch, reverse) {
      if (reverse) {
          var targetBranchCopy = targetBranch.slice();
          targetBranch = sourceBranch;
          sourceBranch = targetBranchCopy;
      }
      var value = sourceBranch.reduce(function(previousValue, currentValue) {
          if (typeof previousValue != 'undefined') return previousValue[currentValue];
      }, obj);
      if (typeof value === 'undefined') return;
      sourceBranch.reduce(function(previousValue, currentValue, index) {
          if (typeof previousValue == 'undefined') return;
          if (index === sourceBranch.length - 1) delete previousValue[currentValue];
          return previousValue[currentValue];
      }, obj);
      targetBranch.reduce(function(previousValue, currentValue, index) {
          if (typeof previousValue[currentValue] === 'undefined') previousValue[currentValue] = {};
          if (index === targetBranch.length - 1) previousValue[currentValue] = value;
          return previousValue[currentValue];
      }, obj);
  };
  
  µ.PolyChart = function module() {
      var config = [ µ.PolyChart.defaultConfig() ];
      var dispatch = d3.dispatch('hover');
      var dashArray = {
          solid: 'none',
          dash: [ 5, 2 ],
          dot: [ 2, 5 ]
      };
      var colorScale;
      function exports() {
          var geometryConfig = config[0].geometryConfig;
          var container = geometryConfig.container;
          if (typeof container == 'string') container = d3.select(container);
          container.datum(config).each(function(_config, _index) {
              var isStack = !!_config[0].data.yStack;
              var data = _config.map(function(d, i) {
                  if (isStack) return d3.zip(d.data.t[0], d.data.r[0], d.data.yStack[0]); else return d3.zip(d.data.t[0], d.data.r[0]);
              });
              var angularScale = geometryConfig.angularScale;
              var domainMin = geometryConfig.radialScale.domain()[0];
              var generator = {};
              generator.bar = function(d, i, pI) {
                  var dataConfig = _config[pI].data;
                  var h = geometryConfig.radialScale(d[1]) - geometryConfig.radialScale(0);
                  var stackTop = geometryConfig.radialScale(d[2] || 0);
                  var w = dataConfig.barWidth;
                  d3.select(this).attr({
                      'class': 'mark bar',
                      d: 'M' + [ [ h + stackTop, -w / 2 ], [ h + stackTop, w / 2 ], [ stackTop, w / 2 ], [ stackTop, -w / 2 ] ].join('L') + 'Z',
                      transform: function(d, i) {
                          return 'rotate(' + (geometryConfig.orientation + angularScale(d[0])) + ')';
                      }
                  });
              };
              generator.dot = function(d, i, pI) {
                  var stackedData = d[2] ? [ d[0], d[1] + d[2] ] : d;
                  var symbol = d3.svg.symbol().size(_config[pI].data.dotSize).type(_config[pI].data.dotType)(d, i);
                  d3.select(this).attr({
                      'class': 'mark dot',
                      d: symbol,
                      transform: function(d, i) {
                          var coord = convertToCartesian(getPolarCoordinates(stackedData));
                          return 'translate(' + [ coord.x, coord.y ] + ')';
                      }
                  });
              };
              var line = d3.svg.line.radial().interpolate(_config[0].data.lineInterpolation).radius(function(d) {
                  return geometryConfig.radialScale(d[1]);
              }).angle(function(d) {
                  return geometryConfig.angularScale(d[0]) * Math.PI / 180;
              });
              generator.line = function(d, i, pI) {
                  var lineData = d[2] ? data[pI].map(function(d, i) {
                      return [ d[0], d[1] + d[2] ];
                  }) : data[pI];
                  d3.select(this).each(generator['dot']).style({
                      opacity: function(dB, iB) {
                          return +_config[pI].data.dotVisible;
                      },
                      fill: markStyle.stroke(d, i, pI)
                  }).attr({
                      'class': 'mark dot'
                  });
                  if (i > 0) return;
                  var lineSelection = d3.select(this.parentNode).selectAll('path.line').data([ 0 ]);
                  lineSelection.enter().insert('path');
                  lineSelection.attr({
                      'class': 'line',
                      d: line(lineData),
                      transform: function(dB, iB) {
                          return 'rotate(' + (geometryConfig.orientation + 90) + ')';
                      },
                      'pointer-events': 'none'
                  }).style({
                      fill: function(dB, iB) {
                          return markStyle.fill(d, i, pI);
                      },
                      'fill-opacity': 0,
                      stroke: function(dB, iB) {
                          return markStyle.stroke(d, i, pI);
                      },
                      'stroke-width': function(dB, iB) {
                          return markStyle['stroke-width'](d, i, pI);
                      },
                      'stroke-dasharray': function(dB, iB) {
                          return markStyle['stroke-dasharray'](d, i, pI);
                      },
                      opacity: function(dB, iB) {
                          return markStyle.opacity(d, i, pI);
                      },
                      display: function(dB, iB) {
                          return markStyle.display(d, i, pI);
                      }
                  });
              };
              var angularRange = geometryConfig.angularScale.range();
              var triangleAngle = Math.abs(angularRange[1] - angularRange[0]) / data[0].length * Math.PI / 180;
              var arc = d3.svg.arc().startAngle(function(d) {
                  return -triangleAngle / 2;
              }).endAngle(function(d) {
                  return triangleAngle / 2;
              }).innerRadius(function(d) {
                  return geometryConfig.radialScale(domainMin + (d[2] || 0));
              }).outerRadius(function(d) {
                  return geometryConfig.radialScale(domainMin + (d[2] || 0)) + geometryConfig.radialScale(d[1]);
              });
              generator.arc = function(d, i, pI) {
                  d3.select(this).attr({
                      'class': 'mark arc',
                      d: arc,
                      transform: function(d, i) {
                          return 'rotate(' + (geometryConfig.orientation + angularScale(d[0]) + 90) + ')';
                      }
                  });
              };
              var markStyle = {
                  fill: function(d, i, pI) {
                      return _config[pI].data.color;
                  },
                  stroke: function(d, i, pI) {
                      return _config[pI].data.strokeColor;
                  },
                  'stroke-width': function(d, i, pI) {
                      return _config[pI].data.strokeSize + 'px';
                  },
                  'stroke-dasharray': function(d, i, pI) {
                      return dashArray[_config[pI].data.strokeDash];
                  },
                  opacity: function(d, i, pI) {
                      return _config[pI].data.opacity;
                  },
                  display: function(d, i, pI) {
                      return typeof _config[pI].data.visible === 'undefined' || _config[pI].data.visible ? 'block' : 'none';
                  }
              };
              var geometryLayer = d3.select(this).selectAll('g.layer').data(data);
              geometryLayer.enter().append('g').attr({
                  'class': 'layer'
              });
              var geometry = geometryLayer.selectAll('path.mark').data(function(d, i) {
                  return d;
              });
              geometry.enter().append('path').attr({
                  'class': 'mark'
              });
              geometry.style(markStyle).each(generator[geometryConfig.geometryType]);
              geometry.exit().remove();
              geometryLayer.exit().remove();
              function getPolarCoordinates(d, i) {
                  var r = geometryConfig.radialScale(d[1]);
                  var t = (geometryConfig.angularScale(d[0]) + geometryConfig.orientation) * Math.PI / 180;
                  return {
                      r: r,
                      t: t
                  };
              }
              function convertToCartesian(polarCoordinates) {
                  var x = polarCoordinates.r * Math.cos(polarCoordinates.t);
                  var y = polarCoordinates.r * Math.sin(polarCoordinates.t);
                  return {
                      x: x,
                      y: y
                  };
              }
          });
      }
      exports.config = function(_x) {
          if (!arguments.length) return config;
          _x.forEach(function(d, i) {
              if (!config[i]) config[i] = {};
              extendDeepAll(config[i], µ.PolyChart.defaultConfig());
              extendDeepAll(config[i], d);
          });
          return this;
      };
      exports.getColorScale = function() {
          return colorScale;
      };
      d3.rebind(exports, dispatch, 'on');
      return exports;
  };
  
  µ.PolyChart.defaultConfig = function() {
      var config = {
          data: {
              name: 'geom1',
              t: [ [ 1, 2, 3, 4 ] ],
              r: [ [ 1, 2, 3, 4 ] ],
              dotType: 'circle',
              dotSize: 64,
              dotVisible: false,
              barWidth: 20,
              color: '#ffa500',
              strokeSize: 1,
              strokeColor: 'silver',
              strokeDash: 'solid',
              opacity: 1,
              index: 0,
              visible: true,
              visibleInLegend: true
          },
          geometryConfig: {
              geometry: 'LinePlot',
              geometryType: 'arc',
              direction: 'clockwise',
              orientation: 0,
              container: 'body',
              radialScale: null,
              angularScale: null,
              colorScale: d3.scale.category20()
          }
      };
      return config;
  };
  
  µ.BarChart = function module() {
      return µ.PolyChart();
  };
  
  µ.BarChart.defaultConfig = function() {
      var config = {
          geometryConfig: {
              geometryType: 'bar'
          }
      };
      return config;
  };
  
  µ.AreaChart = function module() {
      return µ.PolyChart();
  };
  
  µ.AreaChart.defaultConfig = function() {
      var config = {
          geometryConfig: {
              geometryType: 'arc'
          }
      };
      return config;
  };
  
  µ.DotPlot = function module() {
      return µ.PolyChart();
  };
  
  µ.DotPlot.defaultConfig = function() {
      var config = {
          geometryConfig: {
              geometryType: 'dot',
              dotType: 'circle'
          }
      };
      return config;
  };
  
  µ.LinePlot = function module() {
      return µ.PolyChart();
  };
  
  µ.LinePlot.defaultConfig = function() {
      var config = {
          geometryConfig: {
              geometryType: 'line'
          }
      };
      return config;
  };
  
  µ.Legend = function module() {
      var config = µ.Legend.defaultConfig();
      var dispatch = d3.dispatch('hover');
      function exports() {
          var legendConfig = config.legendConfig;
          var flattenData = config.data.map(function(d, i) {
              return [].concat(d).map(function(dB, iB) {
                  var element = extendDeepAll({}, legendConfig.elements[i]);
                  element.name = dB;
                  element.color = [].concat(legendConfig.elements[i].color)[iB];
                  return element;
              });
          });
          var data = d3.merge(flattenData);
          data = data.filter(function(d, i) {
              return legendConfig.elements[i] && (legendConfig.elements[i].visibleInLegend || typeof legendConfig.elements[i].visibleInLegend === 'undefined');
          });
          if (legendConfig.reverseOrder) data = data.reverse();
          var container = legendConfig.container;
          if (typeof container == 'string' || container.nodeName) container = d3.select(container);
          var colors = data.map(function(d, i) {
              return d.color;
          });
          var lineHeight = legendConfig.fontSize;
          var isContinuous = legendConfig.isContinuous == null ? typeof data[0] === 'number' : legendConfig.isContinuous;
          var height = isContinuous ? legendConfig.height : lineHeight * data.length;
          var legendContainerGroup = container.classed('legend-group', true);
          var svg = legendContainerGroup.selectAll('svg').data([ 0 ]);
          var svgEnter = svg.enter().append('svg').attr({
              width: 300,
              height: height + lineHeight,
              xmlns: 'http://www.w3.org/2000/svg',
              'xmlns:xlink': 'http://www.w3.org/1999/xlink',
              version: '1.1'
          });
          svgEnter.append('g').classed('legend-axis', true);
          svgEnter.append('g').classed('legend-marks', true);
          var dataNumbered = d3.range(data.length);
          var colorScale = d3.scale[isContinuous ? 'linear' : 'ordinal']().domain(dataNumbered).range(colors);
          var dataScale = d3.scale[isContinuous ? 'linear' : 'ordinal']().domain(dataNumbered)[isContinuous ? 'range' : 'rangePoints']([ 0, height ]);
          var shapeGenerator = function(_type, _size) {
              var squareSize = _size * 3;
              if (_type === 'line') {
                  return 'M' + [ [ -_size / 2, -_size / 12 ], [ _size / 2, -_size / 12 ], [ _size / 2, _size / 12 ], [ -_size / 2, _size / 12 ] ] + 'Z';
              } else if (d3.svg.symbolTypes.indexOf(_type) != -1) return d3.svg.symbol().type(_type).size(squareSize)(); else return d3.svg.symbol().type('square').size(squareSize)();
          };
          if (isContinuous) {
              var gradient = svg.select('.legend-marks').append('defs').append('linearGradient').attr({
                  id: 'grad1',
                  x1: '0%',
                  y1: '0%',
                  x2: '0%',
                  y2: '100%'
              }).selectAll('stop').data(colors);
              gradient.enter().append('stop');
              gradient.attr({
                  offset: function(d, i) {
                      return i / (colors.length - 1) * 100 + '%';
                  }
              }).style({
                  'stop-color': function(d, i) {
                      return d;
                  }
              });
              svg.append('rect').classed('legend-mark', true).attr({
                  height: legendConfig.height,
                  width: legendConfig.colorBandWidth,
                  fill: 'url(#grad1)'
              });
          } else {
              var legendElement = svg.select('.legend-marks').selectAll('path.legend-mark').data(data);
              legendElement.enter().append('path').classed('legend-mark', true);
              legendElement.attr({
                  transform: function(d, i) {
                      return 'translate(' + [ lineHeight / 2, dataScale(i) + lineHeight / 2 ] + ')';
                  },
                  d: function(d, i) {
                      var symbolType = d.symbol;
                      return shapeGenerator(symbolType, lineHeight);
                  },
                  fill: function(d, i) {
                      return colorScale(i);
                  }
              });
              legendElement.exit().remove();
          }
          var legendAxis = d3.svg.axis().scale(dataScale).orient('right');
          var axis = svg.select('g.legend-axis').attr({
              transform: 'translate(' + [ isContinuous ? legendConfig.colorBandWidth : lineHeight, lineHeight / 2 ] + ')'
          }).call(legendAxis);
          axis.selectAll('.domain').style({
              fill: 'none',
              stroke: 'none'
          });
          axis.selectAll('line').style({
              fill: 'none',
              stroke: isContinuous ? legendConfig.textColor : 'none'
          });
          axis.selectAll('text').style({
              fill: legendConfig.textColor,
              'font-size': legendConfig.fontSize
          }).text(function(d, i) {
              return data[i].name;
          });
          return exports;
      }
      exports.config = function(_x) {
          if (!arguments.length) return config;
          extendDeepAll(config, _x);
          return this;
      };
      d3.rebind(exports, dispatch, 'on');
      return exports;
  };
  
  µ.Legend.defaultConfig = function(d, i) {
      var config = {
          data: [ 'a', 'b', 'c' ],
          legendConfig: {
              elements: [ {
                  symbol: 'line',
                  color: 'red'
              }, {
                  symbol: 'square',
                  color: 'yellow'
              }, {
                  symbol: 'diamond',
                  color: 'limegreen'
              } ],
              height: 150,
              colorBandWidth: 30,
              fontSize: 12,
              container: 'body',
              isContinuous: null,
              textColor: 'grey',
              reverseOrder: false
          }
      };
      return config;
  };
  
  µ.tooltipPanel = function() {
      var tooltipEl, tooltipTextEl, backgroundEl;
      var config = {
          container: null,
          hasTick: false,
          fontSize: 12,
          color: 'white',
          padding: 5
      };
      var id = 'tooltip-' + µ.tooltipPanel.uid++;
      var tickSize = 10;
      var exports = function() {
          tooltipEl = config.container.selectAll('g.' + id).data([ 0 ]);
          var tooltipEnter = tooltipEl.enter().append('g').classed(id, true).style({
              'pointer-events': 'none',
              display: 'none'
          });
          backgroundEl = tooltipEnter.append('path').style({
              fill: 'white',
              'fill-opacity': .9
          }).attr({
              d: 'M0 0'
          });
          tooltipTextEl = tooltipEnter.append('text').attr({
              dx: config.padding + tickSize,
              dy: +config.fontSize * .3
          });
          return exports;
      };
      exports.text = function(_text) {
          var l = d3.hsl(config.color).l;
          var strokeColor = l >= .5 ? '#aaa' : 'white';
          var fillColor = l >= .5 ? 'black' : 'white';
          var text = _text || '';
          tooltipTextEl.style({
              fill: fillColor,
              'font-size': config.fontSize + 'px'
          }).text(text);
          var padding = config.padding;
          var bbox = tooltipTextEl.node().getBBox();
          var boxStyle = {
              fill: config.color,
              stroke: strokeColor,
              'stroke-width': '2px'
          };
          var backGroundW = bbox.width + padding * 2 + tickSize;
          var backGroundH = bbox.height + padding * 2;
          backgroundEl.attr({
              d: 'M' + [ [ tickSize, -backGroundH / 2 ], [ tickSize, -backGroundH / 4 ], [ config.hasTick ? 0 : tickSize, 0 ], [ tickSize, backGroundH / 4 ], [ tickSize, backGroundH / 2 ], [ backGroundW, backGroundH / 2 ], [ backGroundW, -backGroundH / 2 ] ].join('L') + 'Z'
          }).style(boxStyle);
          tooltipEl.attr({
              transform: 'translate(' + [ tickSize, -backGroundH / 2 + padding * 2 ] + ')'
          });
          tooltipEl.style({
              display: 'block'
          });
          return exports;
      };
      exports.move = function(_pos) {
          if (!tooltipEl) return;
          tooltipEl.attr({
              transform: 'translate(' + [ _pos[0], _pos[1] ] + ')'
          }).style({
              display: 'block'
          });
          return exports;
      };
      exports.hide = function() {
          if (!tooltipEl) return;
          tooltipEl.style({
              display: 'none'
          });
          return exports;
      };
      exports.show = function() {
          if (!tooltipEl) return;
          tooltipEl.style({
              display: 'block'
          });
          return exports;
      };
      exports.config = function(_x) {
          extendDeepAll(config, _x);
          return exports;
      };
      return exports;
  };
  
  µ.tooltipPanel.uid = 1;
  
  µ.adapter = {};
  
  µ.adapter.plotly = function module() {
      var exports = {};
      exports.convert = function(_inputConfig, reverse) {
          var outputConfig = {};
          if (_inputConfig.data) {
              outputConfig.data = _inputConfig.data.map(function(d, i) {
                  var r = extendDeepAll({}, d);
                  var toTranslate = [
                      [ r, [ 'marker', 'color' ], [ 'color' ] ],
                      [ r, [ 'marker', 'opacity' ], [ 'opacity' ] ],
                      [ r, [ 'marker', 'line', 'color' ], [ 'strokeColor' ] ],
                      [ r, [ 'marker', 'line', 'dash' ], [ 'strokeDash' ] ],
                      [ r, [ 'marker', 'line', 'width' ], [ 'strokeSize' ] ],
                      [ r, [ 'marker', 'symbol' ], [ 'dotType' ] ],
                      [ r, [ 'marker', 'size' ], [ 'dotSize' ] ],
                      [ r, [ 'marker', 'barWidth' ], [ 'barWidth' ] ],
                      [ r, [ 'line', 'interpolation' ], [ 'lineInterpolation' ] ],
                      [ r, [ 'showlegend' ], [ 'visibleInLegend' ] ]
                  ];
                  toTranslate.forEach(function(d, i) {
                      µ.util.translator.apply(null, d.concat(reverse));
                  });
  
                  if (!reverse) delete r.marker;
                  if (reverse) delete r.groupId;
                  if (!reverse) {
                      if (r.type === 'scatter') {
                          if (r.mode === 'lines') r.geometry = 'LinePlot'; else if (r.mode === 'markers') r.geometry = 'DotPlot'; else if (r.mode === 'lines+markers') {
                              r.geometry = 'LinePlot';
                              r.dotVisible = true;
                          }
                      } else if (r.type === 'area') r.geometry = 'AreaChart'; else if (r.type === 'bar') r.geometry = 'BarChart';
                      delete r.mode;
                      delete r.type;
                  } else {
                      if (r.geometry === 'LinePlot') {
                          r.type = 'scatter';
                          if (r.dotVisible === true) {
                              delete r.dotVisible;
                              r.mode = 'lines+markers';
                          } else r.mode = 'lines';
                      } else if (r.geometry === 'DotPlot') {
                          r.type = 'scatter';
                          r.mode = 'markers';
                      } else if (r.geometry === 'AreaChart') r.type = 'area'; else if (r.geometry === 'BarChart') r.type = 'bar';
                      delete r.geometry;
                  }
                  return r;
              });
              if (!reverse && _inputConfig.layout && _inputConfig.layout.barmode === 'stack') {
                  var duplicates = µ.util.duplicates(outputConfig.data.map(function(d, i) {
                      return d.geometry;
                  }));
                  outputConfig.data.forEach(function(d, i) {
                      var idx = duplicates.indexOf(d.geometry);
                      if (idx != -1) outputConfig.data[i].groupId = idx;
                  });
              }
          }
          if (_inputConfig.layout) {
              var r = extendDeepAll({}, _inputConfig.layout);
              var toTranslate = [
                  [ r, [ 'plot_bgcolor' ], [ 'backgroundColor' ] ],
                  [ r, [ 'showlegend' ], [ 'showLegend' ] ],
                  [ r, [ 'radialaxis' ], [ 'radialAxis' ] ],
                  [ r, [ 'angularaxis' ], [ 'angularAxis' ] ],
                  [ r.angularaxis, [ 'showline' ], [ 'gridLinesVisible' ] ],
                  [ r.angularaxis, [ 'showticklabels' ], [ 'labelsVisible' ] ],
                  [ r.angularaxis, [ 'nticks' ], [ 'ticksCount' ] ],
                  [ r.angularaxis, [ 'tickorientation' ], [ 'tickOrientation' ] ],
                  [ r.angularaxis, [ 'ticksuffix' ], [ 'ticksSuffix' ] ],
                  [ r.angularaxis, [ 'range' ], [ 'domain' ] ],
                  [ r.angularaxis, [ 'endpadding' ], [ 'endPadding' ] ],
                  [ r.radialaxis, [ 'showline' ], [ 'gridLinesVisible' ] ],
                  [ r.radialaxis, [ 'tickorientation' ], [ 'tickOrientation' ] ],
                  [ r.radialaxis, [ 'ticksuffix' ], [ 'ticksSuffix' ] ],
                  [ r.radialaxis, [ 'range' ], [ 'domain' ] ],
                  [ r.angularAxis, [ 'showline' ], [ 'gridLinesVisible' ] ],
                  [ r.angularAxis, [ 'showticklabels' ], [ 'labelsVisible' ] ],
                  [ r.angularAxis, [ 'nticks' ], [ 'ticksCount' ] ],
                  [ r.angularAxis, [ 'tickorientation' ], [ 'tickOrientation' ] ],
                  [ r.angularAxis, [ 'ticksuffix' ], [ 'ticksSuffix' ] ],
                  [ r.angularAxis, [ 'range' ], [ 'domain' ] ],
                  [ r.angularAxis, [ 'endpadding' ], [ 'endPadding' ] ],
                  [ r.radialAxis, [ 'showline' ], [ 'gridLinesVisible' ] ],
                  [ r.radialAxis, [ 'tickorientation' ], [ 'tickOrientation' ] ],
                  [ r.radialAxis, [ 'ticksuffix' ], [ 'ticksSuffix' ] ],
                  [ r.radialAxis, [ 'range' ], [ 'domain' ] ],
                  [ r.font, [ 'outlinecolor' ], [ 'outlineColor' ] ],
                  [ r.legend, [ 'traceorder' ], [ 'reverseOrder' ] ],
                  [ r, [ 'labeloffset' ], [ 'labelOffset' ] ],
                  [ r, [ 'defaultcolorrange' ], [ 'defaultColorRange' ] ]
              ];
              toTranslate.forEach(function(d, i) {
                  µ.util.translator.apply(null, d.concat(reverse));
              });
  
              if (!reverse) {
                  if (r.angularAxis && typeof r.angularAxis.ticklen !== 'undefined') r.tickLength = r.angularAxis.ticklen;
                  if (r.angularAxis && typeof r.angularAxis.tickcolor !== 'undefined') r.tickColor = r.angularAxis.tickcolor;
              } else {
                  if (typeof r.tickLength !== 'undefined') {
                      r.angularaxis.ticklen = r.tickLength;
                      delete r.tickLength;
                  }
                  if (r.tickColor) {
                      r.angularaxis.tickcolor = r.tickColor;
                      delete r.tickColor;
                  }
              }
              if (r.legend && typeof r.legend.reverseOrder != 'boolean') {
                  r.legend.reverseOrder = r.legend.reverseOrder != 'normal';
              }
              if (r.legend && typeof r.legend.traceorder == 'boolean') {
                  r.legend.traceorder = r.legend.traceorder ? 'reversed' : 'normal';
                  delete r.legend.reverseOrder;
              }
              if (r.margin && typeof r.margin.t != 'undefined') {
                  var source = [ 't', 'r', 'b', 'l', 'pad' ];
                  var target = [ 'top', 'right', 'bottom', 'left', 'pad' ];
                  var margin = {};
                  d3.entries(r.margin).forEach(function(dB, iB) {
                      margin[target[source.indexOf(dB.key)]] = dB.value;
                  });
                  r.margin = margin;
              }
              if (reverse) {
                  delete r.needsEndSpacing;
                  delete r.minorTickColor;
                  delete r.minorTicks;
                  delete r.angularaxis.ticksCount;
                  delete r.angularaxis.ticksCount;
                  delete r.angularaxis.ticksStep;
                  delete r.angularaxis.rewriteTicks;
                  delete r.angularaxis.nticks;
                  delete r.radialaxis.ticksCount;
                  delete r.radialaxis.ticksCount;
                  delete r.radialaxis.ticksStep;
                  delete r.radialaxis.rewriteTicks;
                  delete r.radialaxis.nticks;
              }
              outputConfig.layout = r;
          }
          return outputConfig;
      };
      return exports;
  };
  
  },{"../../../constants/alignment":717,"../../../lib":750,"d3":169}],872:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  /* eslint-disable new-cap */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../../lib');
  var Color = _dereq_('../../../components/color');
  
  var micropolar = _dereq_('./micropolar');
  var UndoManager = _dereq_('./undo_manager');
  var extendDeepAll = Lib.extendDeepAll;
  
  var manager = module.exports = {};
  
  manager.framework = function(_gd) {
      var config, previousConfigClone, plot, convertedInput, container;
      var undoManager = new UndoManager();
  
      function exports(_inputConfig, _container) {
          if(_container) container = _container;
          d3.select(d3.select(container).node().parentNode).selectAll('.svg-container>*:not(.chart-root)').remove();
  
          config = (!config) ?
              _inputConfig :
              extendDeepAll(config, _inputConfig);
  
          if(!plot) plot = micropolar.Axis();
          convertedInput = micropolar.adapter.plotly().convert(config);
          plot.config(convertedInput).render(container);
          _gd.data = config.data;
          _gd.layout = config.layout;
          manager.fillLayout(_gd);
          return config;
      }
      exports.isPolar = true;
      exports.svg = function() { return plot.svg(); };
      exports.getConfig = function() { return config; };
      exports.getLiveConfig = function() {
          return micropolar.adapter.plotly().convert(plot.getLiveConfig(), true);
      };
      exports.getLiveScales = function() { return {t: plot.angularScale(), r: plot.radialScale()}; };
      exports.setUndoPoint = function() {
          var that = this;
          var configClone = micropolar.util.cloneJson(config);
          (function(_configClone, _previousConfigClone) {
              undoManager.add({
                  undo: function() {
                      if(_previousConfigClone) that(_previousConfigClone);
                  },
                  redo: function() {
                      that(_configClone);
                  }
              });
          })(configClone, previousConfigClone);
          previousConfigClone = micropolar.util.cloneJson(configClone);
      };
      exports.undo = function() { undoManager.undo(); };
      exports.redo = function() { undoManager.redo(); };
      return exports;
  };
  
  manager.fillLayout = function(_gd) {
      var container = d3.select(_gd).selectAll('.plot-container');
      var paperDiv = container.selectAll('.svg-container');
      var paper = _gd.framework && _gd.framework.svg && _gd.framework.svg();
      var dflts = {
          width: 800,
          height: 600,
          paper_bgcolor: Color.background,
          _container: container,
          _paperdiv: paperDiv,
          _paper: paper
      };
  
      _gd._fullLayout = extendDeepAll(dflts, _gd.layout);
  };
  
  },{"../../../components/color":615,"../../../lib":750,"./micropolar":871,"./undo_manager":873,"d3":169}],873:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  // Modified from https://github.com/ArthurClemens/Javascript-Undo-Manager
  // Copyright (c) 2010-2013 Arthur Clemens, arthur@visiblearea.com
  module.exports = function UndoManager() {
      var undoCommands = [];
      var index = -1;
      var isExecuting = false;
      var callback;
  
      function execute(command, action) {
          if(!command) return this;
  
          isExecuting = true;
          command[action]();
          isExecuting = false;
  
          return this;
      }
  
      return {
          add: function(command) {
              if(isExecuting) return this;
              undoCommands.splice(index + 1, undoCommands.length - index);
              undoCommands.push(command);
              index = undoCommands.length - 1;
              return this;
          },
          setCallback: function(callbackFunc) { callback = callbackFunc; },
          undo: function() {
              var command = undoCommands[index];
              if(!command) return this;
              execute(command, 'undo');
              index -= 1;
              if(callback) callback(command.undo);
              return this;
          },
          redo: function() {
              var command = undoCommands[index + 1];
              if(!command) return this;
              execute(command, 'redo');
              index += 1;
              if(callback) callback(command.redo);
              return this;
          },
          clear: function() {
              undoCommands = [];
              index = -1;
          },
          hasUndo: function() { return index !== -1; },
          hasRedo: function() { return index < (undoCommands.length - 1); },
          getCommands: function() { return undoCommands; },
          getPreviousCommand: function() { return undoCommands[index - 1]; },
          getIndex: function() { return index; }
      };
  };
  
  },{}],874:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var tinycolor = _dereq_('tinycolor2');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  var Plots = _dereq_('../plots');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var setConvertCartesian = _dereq_('../cartesian/set_convert');
  var setConvertPolar = _dereq_('./set_convert');
  var doAutoRange = _dereq_('../cartesian/autorange').doAutoRange;
  var dragBox = _dereq_('../cartesian/dragbox');
  var dragElement = _dereq_('../../components/dragelement');
  var Fx = _dereq_('../../components/fx');
  var Titles = _dereq_('../../components/titles');
  var prepSelect = _dereq_('../cartesian/select').prepSelect;
  var selectOnClick = _dereq_('../cartesian/select').selectOnClick;
  var clearSelect = _dereq_('../cartesian/select').clearSelect;
  var setCursor = _dereq_('../../lib/setcursor');
  var clearGlCanvases = _dereq_('../../lib/clear_gl_canvases');
  var redrawReglTraces = _dereq_('../../plot_api/subroutines').redrawReglTraces;
  
  var MID_SHIFT = _dereq_('../../constants/alignment').MID_SHIFT;
  var constants = _dereq_('./constants');
  var helpers = _dereq_('./helpers');
  
  var _ = Lib._;
  var mod = Lib.mod;
  var deg2rad = Lib.deg2rad;
  var rad2deg = Lib.rad2deg;
  
  function Polar(gd, id) {
      this.id = id;
      this.gd = gd;
  
      this._hasClipOnAxisFalse = null;
      this.vangles = null;
      this.radialAxisAngle = null;
      this.traceHash = {};
      this.layers = {};
      this.clipPaths = {};
      this.clipIds = {};
      this.viewInitial = {};
  
      var fullLayout = gd._fullLayout;
      var clipIdBase = 'clip' + fullLayout._uid + id;
  
      this.clipIds.forTraces = clipIdBase + '-for-traces';
      this.clipPaths.forTraces = fullLayout._clips.append('clipPath')
          .attr('id', this.clipIds.forTraces);
      this.clipPaths.forTraces.append('path');
  
      this.framework = fullLayout._polarlayer.append('g')
          .attr('class', id);
  
      // unfortunately, we have to keep track of some axis tick settings
      // as polar subplots do not implement the 'ticks' editType
      this.radialTickLayout = null;
      this.angularTickLayout = null;
  }
  
  var proto = Polar.prototype;
  
  module.exports = function createPolar(gd, id) {
      return new Polar(gd, id);
  };
  
  proto.plot = function(polarCalcData, fullLayout) {
      var _this = this;
      var polarLayout = fullLayout[_this.id];
  
      _this._hasClipOnAxisFalse = false;
      for(var i = 0; i < polarCalcData.length; i++) {
          var trace = polarCalcData[i][0].trace;
          if(trace.cliponaxis === false) {
              _this._hasClipOnAxisFalse = true;
              break;
          }
      }
  
      _this.updateLayers(fullLayout, polarLayout);
      _this.updateLayout(fullLayout, polarLayout);
      Plots.generalUpdatePerTraceModule(_this.gd, _this, polarCalcData, polarLayout);
      _this.updateFx(fullLayout, polarLayout);
  };
  
  proto.updateLayers = function(fullLayout, polarLayout) {
      var _this = this;
      var layers = _this.layers;
      var radialLayout = polarLayout.radialaxis;
      var angularLayout = polarLayout.angularaxis;
      var layerNames = constants.layerNames;
  
      var frontPlotIndex = layerNames.indexOf('frontplot');
      var layerData = layerNames.slice(0, frontPlotIndex);
      var isAngularAxisBelowTraces = angularLayout.layer === 'below traces';
      var isRadialAxisBelowTraces = radialLayout.layer === 'below traces';
  
      if(isAngularAxisBelowTraces) layerData.push('angular-line');
      if(isRadialAxisBelowTraces) layerData.push('radial-line');
      if(isAngularAxisBelowTraces) layerData.push('angular-axis');
      if(isRadialAxisBelowTraces) layerData.push('radial-axis');
  
      layerData.push('frontplot');
  
      if(!isAngularAxisBelowTraces) layerData.push('angular-line');
      if(!isRadialAxisBelowTraces) layerData.push('radial-line');
      if(!isAngularAxisBelowTraces) layerData.push('angular-axis');
      if(!isRadialAxisBelowTraces) layerData.push('radial-axis');
  
      var join = _this.framework.selectAll('.polarsublayer')
          .data(layerData, String);
  
      join.enter().append('g')
          .attr('class', function(d) { return 'polarsublayer ' + d;})
          .each(function(d) {
              var sel = layers[d] = d3.select(this);
  
              switch(d) {
                  case 'frontplot':
                      // TODO add option to place in 'backplot' layer??
                      sel.append('g').classed('barlayer', true);
                      sel.append('g').classed('scatterlayer', true);
                      break;
                  case 'backplot':
                      sel.append('g').classed('maplayer', true);
                      break;
                  case 'plotbg':
                      layers.bg = sel.append('path');
                      break;
                  case 'radial-grid':
                      sel.style('fill', 'none');
                      break;
                  case 'angular-grid':
                      sel.style('fill', 'none');
                      break;
                  case 'radial-line':
                      sel.append('line').style('fill', 'none');
                      break;
                  case 'angular-line':
                      sel.append('path').style('fill', 'none');
                      break;
              }
          });
  
      join.order();
  };
  
  /* Polar subplots juggle with 6 'axis objects' (!), these are:
   *
   * - polarLayout.radialaxis (aka radialLayout in this file):
   * - polarLayout.angularaxis (aka angularLayout in this file):
   *   used for data -> calcdata conversions (aka d2c) during the calc step
   *
   * - this.radialAxis
   *   extends polarLayout.radialaxis, adds mocked 'domain' and
   *   few other keys in order to reuse Cartesian doAutoRange and the Axes
   *   drawing routines.
   *   used for calcdata -> geometric conversions (aka c2g) during the plot step
   *   + setGeometry setups ax.c2g for given ax.range
   *   + setScale setups ax._m,ax._b for given ax.range
   *
   * - this.angularAxis
   *   extends polarLayout.angularaxis, adds mocked 'range' and 'domain' and
   *   a few other keys in order to reuse the Axes drawing routines.
   *   used for calcdata -> geometric conversions (aka c2g) during the plot step
   *   + setGeometry setups ax.c2g given ax.rotation, ax.direction & ax._categories,
   *                 and mocks ax.range
   *   + setScale setups ax._m,ax._b with that mocked ax.range
   *
   * - this.xaxis
   * - this.yaxis
   *   setup so that polar traces can reuse plot methods of Cartesian traces
   *   which mostly rely on 2pixel methods (e.g ax.c2p)
   */
  proto.updateLayout = function(fullLayout, polarLayout) {
      var _this = this;
      var layers = _this.layers;
      var gs = fullLayout._size;
  
      // axis attributes
      var radialLayout = polarLayout.radialaxis;
      var angularLayout = polarLayout.angularaxis;
      // layout domains
      var xDomain = polarLayout.domain.x;
      var yDomain = polarLayout.domain.y;
      // offsets from paper edge to layout domain box
      _this.xOffset = gs.l + gs.w * xDomain[0];
      _this.yOffset = gs.t + gs.h * (1 - yDomain[1]);
      // lengths of the layout domain box
      var xLength = _this.xLength = gs.w * (xDomain[1] - xDomain[0]);
      var yLength = _this.yLength = gs.h * (yDomain[1] - yDomain[0]);
      // sector to plot
      var sector = polarLayout.sector;
      _this.sectorInRad = sector.map(deg2rad);
      var sectorBBox = _this.sectorBBox = computeSectorBBox(sector);
      var dxSectorBBox = sectorBBox[2] - sectorBBox[0];
      var dySectorBBox = sectorBBox[3] - sectorBBox[1];
      // aspect ratios
      var arDomain = yLength / xLength;
      var arSector = Math.abs(dySectorBBox / dxSectorBBox);
      // actual lengths and domains of subplot box
      var xLength2, yLength2;
      var xDomain2, yDomain2;
      var gap;
      if(arDomain > arSector) {
          xLength2 = xLength;
          yLength2 = xLength * arSector;
          gap = (yLength - yLength2) / gs.h / 2;
          xDomain2 = [xDomain[0], xDomain[1]];
          yDomain2 = [yDomain[0] + gap, yDomain[1] - gap];
      } else {
          xLength2 = yLength / arSector;
          yLength2 = yLength;
          gap = (xLength - xLength2) / gs.w / 2;
          xDomain2 = [xDomain[0] + gap, xDomain[1] - gap];
          yDomain2 = [yDomain[0], yDomain[1]];
      }
      _this.xLength2 = xLength2;
      _this.yLength2 = yLength2;
      _this.xDomain2 = xDomain2;
      _this.yDomain2 = yDomain2;
      // actual offsets from paper edge to the subplot box top-left corner
      var xOffset2 = _this.xOffset2 = gs.l + gs.w * xDomain2[0];
      var yOffset2 = _this.yOffset2 = gs.t + gs.h * (1 - yDomain2[1]);
      // circle radius in px
      var radius = _this.radius = xLength2 / dxSectorBBox;
      // 'inner' radius in px (when polar.hole is set)
      var innerRadius = _this.innerRadius = polarLayout.hole * radius;
      // circle center position in px
      var cx = _this.cx = xOffset2 - radius * sectorBBox[0];
      var cy = _this.cy = yOffset2 + radius * sectorBBox[3];
      // circle center in the coordinate system of plot area
      var cxx = _this.cxx = cx - xOffset2;
      var cyy = _this.cyy = cy - yOffset2;
  
      _this.radialAxis = _this.mockAxis(fullLayout, polarLayout, radialLayout, {
          // make this an 'x' axis to make positioning (especially rotation) easier
          _id: 'x',
          // convert to 'x' axis equivalent
          side: {
              counterclockwise: 'top',
              clockwise: 'bottom'
          }[radialLayout.side],
          // spans length 1 radius
          domain: [innerRadius / gs.w, radius / gs.w]
      });
  
      _this.angularAxis = _this.mockAxis(fullLayout, polarLayout, angularLayout, {
          side: 'right',
          // to get auto nticks right
          domain: [0, Math.PI],
          // don't pass through autorange logic
          autorange: false
      });
  
      _this.doAutoRange(fullLayout, polarLayout);
      // N.B. this sets _this.vangles
      _this.updateAngularAxis(fullLayout, polarLayout);
      // N.B. this sets _this.radialAxisAngle
      _this.updateRadialAxis(fullLayout, polarLayout);
      _this.updateRadialAxisTitle(fullLayout, polarLayout);
  
      _this.xaxis = _this.mockCartesianAxis(fullLayout, polarLayout, {
          _id: 'x',
          domain: xDomain2
      });
  
      _this.yaxis = _this.mockCartesianAxis(fullLayout, polarLayout, {
          _id: 'y',
          domain: yDomain2
      });
  
      var dPath = _this.pathSubplot();
  
      _this.clipPaths.forTraces.select('path')
          .attr('d', dPath)
          .attr('transform', strTranslate(cxx, cyy));
  
      layers.frontplot
          .attr('transform', strTranslate(xOffset2, yOffset2))
          .call(Drawing.setClipUrl, _this._hasClipOnAxisFalse ? null : _this.clipIds.forTraces, _this.gd);
  
      layers.bg
          .attr('d', dPath)
          .attr('transform', strTranslate(cx, cy))
          .call(Color.fill, polarLayout.bgcolor);
  };
  
  proto.mockAxis = function(fullLayout, polarLayout, axLayout, opts) {
      var ax = Lib.extendFlat({}, axLayout, opts);
      setConvertPolar(ax, polarLayout, fullLayout);
      return ax;
  };
  
  proto.mockCartesianAxis = function(fullLayout, polarLayout, opts) {
      var _this = this;
      var axId = opts._id;
  
      var ax = Lib.extendFlat({type: 'linear'}, opts);
      setConvertCartesian(ax, fullLayout);
  
      var bboxIndices = {
          x: [0, 2],
          y: [1, 3]
      };
  
      ax.setRange = function() {
          var sectorBBox = _this.sectorBBox;
          var ind = bboxIndices[axId];
          var rl = _this.radialAxis._rl;
          var drl = (rl[1] - rl[0]) / (1 - polarLayout.hole);
          ax.range = [sectorBBox[ind[0]] * drl, sectorBBox[ind[1]] * drl];
      };
  
      ax.isPtWithinRange = axId === 'x' ?
          function(d) { return _this.isPtInside(d); } :
          function() { return true; };
  
      ax.setRange();
      ax.setScale();
      return ax;
  };
  
  proto.doAutoRange = function(fullLayout, polarLayout) {
      var gd = this.gd;
      var radialAxis = this.radialAxis;
      var radialLayout = polarLayout.radialaxis;
  
      radialAxis.setScale();
      doAutoRange(gd, radialAxis);
  
      var rng = radialAxis.range;
      radialLayout.range = rng.slice();
      radialLayout._input.range = rng.slice();
  
      radialAxis._rl = [
          radialAxis.r2l(rng[0], null, 'gregorian'),
          radialAxis.r2l(rng[1], null, 'gregorian')
      ];
  };
  
  proto.updateRadialAxis = function(fullLayout, polarLayout) {
      var _this = this;
      var gd = _this.gd;
      var layers = _this.layers;
      var radius = _this.radius;
      var innerRadius = _this.innerRadius;
      var cx = _this.cx;
      var cy = _this.cy;
      var radialLayout = polarLayout.radialaxis;
      var a0 = mod(polarLayout.sector[0], 360);
      var ax = _this.radialAxis;
      var hasRoomForIt = innerRadius < radius;
  
      _this.fillViewInitialKey('radialaxis.angle', radialLayout.angle);
      _this.fillViewInitialKey('radialaxis.range', ax.range.slice());
  
      ax.setGeometry();
  
      // rotate auto tick labels by 180 if in quadrant II and III to make them
      // readable from left-to-right
      //
      // TODO try moving deeper in Axes.drawLabels for better results?
      if(ax.tickangle === 'auto' && (a0 > 90 && a0 <= 270)) {
          ax.tickangle = 180;
      }
  
      // easier to set rotate angle with custom translate function
      var transFn = function(d) {
          return 'translate(' + (ax.l2p(d.x) + innerRadius) + ',0)';
      };
  
      // set special grid path function
      var gridPathFn = function(d) {
          return _this.pathArc(ax.r2p(d.x) + innerRadius);
      };
  
      var newTickLayout = strTickLayout(radialLayout);
      if(_this.radialTickLayout !== newTickLayout) {
          layers['radial-axis'].selectAll('.xtick').remove();
          _this.radialTickLayout = newTickLayout;
      }
  
      if(hasRoomForIt) {
          ax.setScale();
  
          var vals = Axes.calcTicks(ax);
          var valsClipped = Axes.clipEnds(ax, vals);
          var tickSign = Axes.getTickSigns(ax)[2];
  
          Axes.drawTicks(gd, ax, {
              vals: vals,
              layer: layers['radial-axis'],
              path: Axes.makeTickPath(ax, 0, tickSign),
              transFn: transFn,
              crisp: false
          });
  
          Axes.drawGrid(gd, ax, {
              vals: valsClipped,
              layer: layers['radial-grid'],
              path: gridPathFn,
              transFn: Lib.noop,
              crisp: false
          });
  
          Axes.drawLabels(gd, ax, {
              vals: vals,
              layer: layers['radial-axis'],
              transFn: transFn,
              labelFns: Axes.makeLabelFns(ax, 0)
          });
      }
  
      // stash 'actual' radial axis angle for drag handlers (in degrees)
      var angle = _this.radialAxisAngle = _this.vangles ?
          rad2deg(snapToVertexAngle(deg2rad(radialLayout.angle), _this.vangles)) :
          radialLayout.angle;
  
      var tLayer = strTranslate(cx, cy);
      var tLayer2 = tLayer + strRotate(-angle);
  
      updateElement(
          layers['radial-axis'],
          hasRoomForIt && (radialLayout.showticklabels || radialLayout.ticks),
          {transform: tLayer2}
      );
  
      updateElement(
          layers['radial-grid'],
          hasRoomForIt && radialLayout.showgrid,
          {transform: tLayer}
      );
  
      updateElement(
          layers['radial-line'].select('line'),
          hasRoomForIt && radialLayout.showline,
          {
              x1: innerRadius,
              y1: 0,
              x2: radius,
              y2: 0,
              transform: tLayer2
          }
      )
      .attr('stroke-width', radialLayout.linewidth)
      .call(Color.stroke, radialLayout.linecolor);
  };
  
  proto.updateRadialAxisTitle = function(fullLayout, polarLayout, _angle) {
      var _this = this;
      var gd = _this.gd;
      var radius = _this.radius;
      var cx = _this.cx;
      var cy = _this.cy;
      var radialLayout = polarLayout.radialaxis;
      var titleClass = _this.id + 'title';
  
      var angle = _angle !== undefined ? _angle : _this.radialAxisAngle;
      var angleRad = deg2rad(angle);
      var cosa = Math.cos(angleRad);
      var sina = Math.sin(angleRad);
  
      var pad = 0;
  
      // Hint: no need to check if there is in fact a title.text set
      // because if plot is editable, pad needs to be calculated anyways
      // to properly show placeholder text when title is empty.
      if(radialLayout.title) {
          var h = Drawing.bBox(_this.layers['radial-axis'].node()).height;
          var ts = radialLayout.title.font.size;
          pad = radialLayout.side === 'counterclockwise' ?
              -h - ts * 0.4 :
              h + ts * 0.8;
      }
  
      _this.layers['radial-axis-title'] = Titles.draw(gd, titleClass, {
          propContainer: radialLayout,
          propName: _this.id + '.radialaxis.title',
          placeholder: _(gd, 'Click to enter radial axis title'),
          attributes: {
              x: cx + (radius / 2) * cosa + pad * sina,
              y: cy - (radius / 2) * sina + pad * cosa,
              'text-anchor': 'middle'
          },
          transform: {rotate: -angle}
      });
  };
  
  proto.updateAngularAxis = function(fullLayout, polarLayout) {
      var _this = this;
      var gd = _this.gd;
      var layers = _this.layers;
      var radius = _this.radius;
      var innerRadius = _this.innerRadius;
      var cx = _this.cx;
      var cy = _this.cy;
      var angularLayout = polarLayout.angularaxis;
      var ax = _this.angularAxis;
  
      _this.fillViewInitialKey('angularaxis.rotation', angularLayout.rotation);
  
      ax.setGeometry();
      ax.setScale();
  
      // 't'ick to 'g'eometric radians is used all over the place here
      var t2g = function(d) { return ax.t2g(d.x); };
  
      // run rad2deg on tick0 and ditck for thetaunit: 'radians' axes
      if(ax.type === 'linear' && ax.thetaunit === 'radians') {
          ax.tick0 = rad2deg(ax.tick0);
          ax.dtick = rad2deg(ax.dtick);
      }
  
      var _transFn = function(rad) {
          return strTranslate(cx + radius * Math.cos(rad), cy - radius * Math.sin(rad));
      };
  
      var transFn = function(d) {
          return _transFn(t2g(d));
      };
  
      var transFn2 = function(d) {
          var rad = t2g(d);
          return _transFn(rad) + strRotate(-rad2deg(rad));
      };
  
      var gridPathFn = function(d) {
          var rad = t2g(d);
          var cosRad = Math.cos(rad);
          var sinRad = Math.sin(rad);
          return 'M' + [cx + innerRadius * cosRad, cy - innerRadius * sinRad] +
              'L' + [cx + radius * cosRad, cy - radius * sinRad];
      };
  
      var out = Axes.makeLabelFns(ax, 0);
      var labelStandoff = out.labelStandoff;
      var labelFns = {};
  
      labelFns.xFn = function(d) {
          var rad = t2g(d);
          return Math.cos(rad) * labelStandoff;
      };
  
      labelFns.yFn = function(d) {
          var rad = t2g(d);
          var ff = Math.sin(rad) > 0 ? 0.2 : 1;
          return -Math.sin(rad) * (labelStandoff + d.fontSize * ff) +
              Math.abs(Math.cos(rad)) * (d.fontSize * MID_SHIFT);
      };
  
      labelFns.anchorFn = function(d) {
          var rad = t2g(d);
          var cos = Math.cos(rad);
          return Math.abs(cos) < 0.1 ?
              'middle' :
              (cos > 0 ? 'start' : 'end');
      };
  
      labelFns.heightFn = function(d, a, h) {
          var rad = t2g(d);
          return -0.5 * (1 + Math.sin(rad)) * h;
      };
  
      var newTickLayout = strTickLayout(angularLayout);
      if(_this.angularTickLayout !== newTickLayout) {
          layers['angular-axis'].selectAll('.' + ax._id + 'tick').remove();
          _this.angularTickLayout = newTickLayout;
      }
  
      var vals = Axes.calcTicks(ax);
  
      // angle of polygon vertices in geometric radians (null means circles)
      // TODO what to do when ax.period > ax._categories ??
      var vangles;
      if(polarLayout.gridshape === 'linear') {
          vangles = vals.map(t2g);
  
          // ax._vals should be always ordered, make them
          // always turn counterclockwise for convenience here
          if(Lib.angleDelta(vangles[0], vangles[1]) < 0) {
              vangles = vangles.slice().reverse();
          }
      } else {
          vangles = null;
      }
      _this.vangles = vangles;
  
      // Use tickval filter for category axes instead of tweaking
      // the range w.r.t sector, so that sectors that cross 360 can
      // show all their ticks.
      if(ax.type === 'category') {
          vals = vals.filter(function(d) {
              return Lib.isAngleInsideSector(t2g(d), _this.sectorInRad);
          });
      }
  
      if(ax.visible) {
          var tickSign = ax.ticks === 'inside' ? -1 : 1;
          var pad = (ax.linewidth || 1) / 2;
  
          Axes.drawTicks(gd, ax, {
              vals: vals,
              layer: layers['angular-axis'],
              path: 'M' + (tickSign * pad) + ',0h' + (tickSign * ax.ticklen),
              transFn: transFn2,
              crisp: false
          });
  
          Axes.drawGrid(gd, ax, {
              vals: vals,
              layer: layers['angular-grid'],
              path: gridPathFn,
              transFn: Lib.noop,
              crisp: false
          });
  
          Axes.drawLabels(gd, ax, {
              vals: vals,
              layer: layers['angular-axis'],
              repositionOnUpdate: true,
              transFn: transFn,
              labelFns: labelFns
          });
      }
  
      // TODO maybe two arcs is better here?
      // maybe split style attributes between inner and outer angular axes?
  
      updateElement(layers['angular-line'].select('path'), angularLayout.showline, {
          d: _this.pathSubplot(),
          transform: strTranslate(cx, cy)
      })
      .attr('stroke-width', angularLayout.linewidth)
      .call(Color.stroke, angularLayout.linecolor);
  };
  
  proto.updateFx = function(fullLayout, polarLayout) {
      if(!this.gd._context.staticPlot) {
          this.updateAngularDrag(fullLayout);
          this.updateRadialDrag(fullLayout, polarLayout, 0);
          this.updateRadialDrag(fullLayout, polarLayout, 1);
          this.updateMainDrag(fullLayout);
      }
  };
  
  proto.updateMainDrag = function(fullLayout) {
      var _this = this;
      var gd = _this.gd;
      var layers = _this.layers;
      var zoomlayer = fullLayout._zoomlayer;
      var MINZOOM = constants.MINZOOM;
      var OFFEDGE = constants.OFFEDGE;
      var radius = _this.radius;
      var innerRadius = _this.innerRadius;
      var cx = _this.cx;
      var cy = _this.cy;
      var cxx = _this.cxx;
      var cyy = _this.cyy;
      var sectorInRad = _this.sectorInRad;
      var vangles = _this.vangles;
      var radialAxis = _this.radialAxis;
      var clampTiny = helpers.clampTiny;
      var findXYatLength = helpers.findXYatLength;
      var findEnclosingVertexAngles = helpers.findEnclosingVertexAngles;
      var chw = constants.cornerHalfWidth;
      var chl = constants.cornerLen / 2;
  
      var mainDrag = dragBox.makeDragger(layers, 'path', 'maindrag', 'crosshair');
  
      d3.select(mainDrag)
          .attr('d', _this.pathSubplot())
          .attr('transform', strTranslate(cx, cy));
  
      var dragOpts = {
          element: mainDrag,
          gd: gd,
          subplot: _this.id,
          plotinfo: {
              id: _this.id,
              xaxis: _this.xaxis,
              yaxis: _this.yaxis
          },
          xaxes: [_this.xaxis],
          yaxes: [_this.yaxis]
      };
  
      // mouse px position at drag start (0), move (1)
      var x0, y0;
      // radial distance from circle center at drag start (0), move (1)
      var r0, r1;
      // zoombox persistent quantities
      var path0, dimmed, lum;
      // zoombox, corners elements
      var zb, corners;
  
      function norm(x, y) {
          return Math.sqrt(x * x + y * y);
      }
  
      function xy2r(x, y) {
          return norm(x - cxx, y - cyy);
      }
  
      function xy2a(x, y) {
          return Math.atan2(cyy - y, x - cxx);
      }
  
      function ra2xy(r, a) {
          return [r * Math.cos(a), r * Math.sin(-a)];
      }
  
      function pathCorner(r, a) {
          if(r === 0) return _this.pathSector(2 * chw);
  
          var da = chl / r;
          var am = a - da;
          var ap = a + da;
          var rb = Math.max(0, Math.min(r, radius));
          var rm = rb - chw;
          var rp = rb + chw;
  
          return 'M' + ra2xy(rm, am) +
              'A' + [rm, rm] + ' 0,0,0 ' + ra2xy(rm, ap) +
              'L' + ra2xy(rp, ap) +
              'A' + [rp, rp] + ' 0,0,1 ' + ra2xy(rp, am) +
              'Z';
      }
  
      // (x,y) is the pt at middle of the va0 <-> va1 edge
      //
      // ... we could eventually add another mode for cursor
      // angles 'close to' enough to a particular vertex.
      function pathCornerForPolygons(r, va0, va1) {
          if(r === 0) return _this.pathSector(2 * chw);
  
          var xy0 = ra2xy(r, va0);
          var xy1 = ra2xy(r, va1);
          var x = clampTiny((xy0[0] + xy1[0]) / 2);
          var y = clampTiny((xy0[1] + xy1[1]) / 2);
          var innerPts, outerPts;
  
          if(x && y) {
              var m = y / x;
              var mperp = -1 / m;
              var midPts = findXYatLength(chw, m, x, y);
              innerPts = findXYatLength(chl, mperp, midPts[0][0], midPts[0][1]);
              outerPts = findXYatLength(chl, mperp, midPts[1][0], midPts[1][1]);
          } else {
              var dx, dy;
              if(y) {
                  // horizontal handles
                  dx = chl;
                  dy = chw;
              } else {
                  // vertical handles
                  dx = chw;
                  dy = chl;
              }
              innerPts = [[x - dx, y - dy], [x + dx, y - dy]];
              outerPts = [[x - dx, y + dy], [x + dx, y + dy]];
          }
  
          return 'M' + innerPts.join('L') +
              'L' + outerPts.reverse().join('L') + 'Z';
      }
  
      function zoomPrep() {
          r0 = null;
          r1 = null;
          path0 = _this.pathSubplot();
          dimmed = false;
  
          var polarLayoutNow = gd._fullLayout[_this.id];
          lum = tinycolor(polarLayoutNow.bgcolor).getLuminance();
  
          zb = dragBox.makeZoombox(zoomlayer, lum, cx, cy, path0);
          zb.attr('fill-rule', 'evenodd');
          corners = dragBox.makeCorners(zoomlayer, cx, cy);
          clearSelect(gd);
      }
  
      // N.B. this sets scoped 'r0' and 'r1'
      // return true if 'valid' zoom distance, false otherwise
      function clampAndSetR0R1(rr0, rr1) {
          rr1 = Math.max(Math.min(rr1, radius), innerRadius);
  
          // starting or ending drag near center (outer edge),
          // clamps radial distance at origin (at r=radius)
          if(rr0 < OFFEDGE) rr0 = 0;
          else if((radius - rr0) < OFFEDGE) rr0 = radius;
          else if(rr1 < OFFEDGE) rr1 = 0;
          else if((radius - rr1) < OFFEDGE) rr1 = radius;
  
          // make sure r0 < r1,
          // to get correct fill pattern in path1 below
          if(Math.abs(rr1 - rr0) > MINZOOM) {
              if(rr0 < rr1) {
                  r0 = rr0;
                  r1 = rr1;
              } else {
                  r0 = rr1;
                  r1 = rr0;
              }
              return true;
          } else {
              r0 = null;
              r1 = null;
              return false;
          }
      }
  
      function applyZoomMove(path1, cpath) {
          path1 = path1 || path0;
          cpath = cpath || 'M0,0Z';
  
          zb.attr('d', path1);
          corners.attr('d', cpath);
          dragBox.transitionZoombox(zb, corners, dimmed, lum);
          dimmed = true;
  
          var updateObj = {};
          computeZoomUpdates(updateObj);
          gd.emit('plotly_relayouting', updateObj);
      }
  
      function zoomMove(dx, dy) {
          var x1 = x0 + dx;
          var y1 = y0 + dy;
          var rr0 = xy2r(x0, y0);
          var rr1 = Math.min(xy2r(x1, y1), radius);
          var a0 = xy2a(x0, y0);
          var path1;
          var cpath;
  
          if(clampAndSetR0R1(rr0, rr1)) {
              path1 = path0 + _this.pathSector(r1);
              if(r0) path1 += _this.pathSector(r0);
              // keep 'starting' angle
              cpath = pathCorner(r0, a0) + pathCorner(r1, a0);
          }
          applyZoomMove(path1, cpath);
      }
  
      function findPolygonRadius(x, y, va0, va1) {
          var xy = helpers.findIntersectionXY(va0, va1, va0, [x - cxx, cyy - y]);
          return norm(xy[0], xy[1]);
      }
  
      function zoomMoveForPolygons(dx, dy) {
          var x1 = x0 + dx;
          var y1 = y0 + dy;
          var a0 = xy2a(x0, y0);
          var a1 = xy2a(x1, y1);
          var vangles0 = findEnclosingVertexAngles(a0, vangles);
          var vangles1 = findEnclosingVertexAngles(a1, vangles);
          var rr0 = findPolygonRadius(x0, y0, vangles0[0], vangles0[1]);
          var rr1 = Math.min(findPolygonRadius(x1, y1, vangles1[0], vangles1[1]), radius);
          var path1;
          var cpath;
  
          if(clampAndSetR0R1(rr0, rr1)) {
              path1 = path0 + _this.pathSector(r1);
              if(r0) path1 += _this.pathSector(r0);
              // keep 'starting' angle here too
              cpath = [
                  pathCornerForPolygons(r0, vangles0[0], vangles0[1]),
                  pathCornerForPolygons(r1, vangles0[0], vangles0[1])
              ].join(' ');
          }
          applyZoomMove(path1, cpath);
      }
  
      function zoomDone() {
          dragBox.removeZoombox(gd);
  
          if(r0 === null || r1 === null) return;
          var updateObj = {};
          computeZoomUpdates(updateObj);
  
          dragBox.showDoubleClickNotifier(gd);
  
          Registry.call('_guiRelayout', gd, updateObj);
      }
  
      function computeZoomUpdates(update) {
          var rl = radialAxis._rl;
          var m = (rl[1] - rl[0]) / (1 - innerRadius / radius) / radius;
          var newRng = [
              rl[0] + (r0 - innerRadius) * m,
              rl[0] + (r1 - innerRadius) * m
          ];
          update[_this.id + '.radialaxis.range'] = newRng;
      }
  
      function zoomClick(numClicks, evt) {
          var clickMode = gd._fullLayout.clickmode;
  
          dragBox.removeZoombox(gd);
  
          // TODO double once vs twice logic (autorange vs fixed range)
          if(numClicks === 2) {
              var updateObj = {};
              for(var k in _this.viewInitial) {
                  updateObj[_this.id + '.' + k] = _this.viewInitial[k];
              }
  
              gd.emit('plotly_doubleclick', null);
              Registry.call('_guiRelayout', gd, updateObj);
          }
  
          if(clickMode.indexOf('select') > -1 && numClicks === 1) {
              selectOnClick(evt, gd, [_this.xaxis], [_this.yaxis], _this.id, dragOpts);
          }
  
          if(clickMode.indexOf('event') > -1) {
              Fx.click(gd, evt, _this.id);
          }
      }
  
      dragOpts.prepFn = function(evt, startX, startY) {
          var dragModeNow = gd._fullLayout.dragmode;
  
          var bbox = mainDrag.getBoundingClientRect();
          x0 = startX - bbox.left;
          y0 = startY - bbox.top;
  
          // need to offset x/y as bbox center does not
          // match origin for asymmetric polygons
          if(vangles) {
              var offset = helpers.findPolygonOffset(radius, sectorInRad[0], sectorInRad[1], vangles);
              x0 += cxx + offset[0];
              y0 += cyy + offset[1];
          }
  
          switch(dragModeNow) {
              case 'zoom':
                  if(vangles) {
                      dragOpts.moveFn = zoomMoveForPolygons;
                  } else {
                      dragOpts.moveFn = zoomMove;
                  }
                  dragOpts.clickFn = zoomClick;
                  dragOpts.doneFn = zoomDone;
                  zoomPrep(evt, startX, startY);
                  break;
              case 'select':
              case 'lasso':
                  prepSelect(evt, startX, startY, dragOpts, dragModeNow);
                  break;
          }
      };
  
      mainDrag.onmousemove = function(evt) {
          Fx.hover(gd, evt, _this.id);
          gd._fullLayout._lasthover = mainDrag;
          gd._fullLayout._hoversubplot = _this.id;
      };
  
      mainDrag.onmouseout = function(evt) {
          if(gd._dragging) return;
          dragElement.unhover(gd, evt);
      };
  
      dragElement.init(dragOpts);
  };
  
  proto.updateRadialDrag = function(fullLayout, polarLayout, rngIndex) {
      var _this = this;
      var gd = _this.gd;
      var layers = _this.layers;
      var radius = _this.radius;
      var innerRadius = _this.innerRadius;
      var cx = _this.cx;
      var cy = _this.cy;
      var radialAxis = _this.radialAxis;
      var bl = constants.radialDragBoxSize;
      var bl2 = bl / 2;
  
      if(!radialAxis.visible) return;
  
      var angle0 = deg2rad(_this.radialAxisAngle);
      var rl = radialAxis._rl;
      var rl0 = rl[0];
      var rl1 = rl[1];
      var rbase = rl[rngIndex];
      var m = 0.75 * (rl[1] - rl[0]) / (1 - polarLayout.hole) / radius;
  
      var tx, ty, className;
      if(rngIndex) {
          tx = cx + (radius + bl2) * Math.cos(angle0);
          ty = cy - (radius + bl2) * Math.sin(angle0);
          className = 'radialdrag';
      } else {
          // the 'inner' box can get called:
          // - when polar.hole>0
          // - when polar.sector isn't a full circle
          // otherwise it is hidden behind the main drag.
          tx = cx + (innerRadius - bl2) * Math.cos(angle0);
          ty = cy - (innerRadius - bl2) * Math.sin(angle0);
          className = 'radialdrag-inner';
      }
  
      var radialDrag = dragBox.makeRectDragger(layers, className, 'crosshair', -bl2, -bl2, bl, bl);
      var dragOpts = {element: radialDrag, gd: gd};
  
      updateElement(d3.select(radialDrag), radialAxis.visible && innerRadius < radius, {
          transform: strTranslate(tx, ty)
      });
  
      // move function (either rotate or re-range flavor)
      var moveFn2;
      // rotate angle on done
      var angle1;
      // re-range range[1] (or range[0]) on done
      var rprime;
  
      function moveFn(dx, dy) {
          if(moveFn2) {
              moveFn2(dx, dy);
          } else {
              var dvec = [dx, -dy];
              var rvec = [Math.cos(angle0), Math.sin(angle0)];
              var comp = Math.abs(Lib.dot(dvec, rvec) / Math.sqrt(Lib.dot(dvec, dvec)));
  
              // mostly perpendicular motions rotate,
              // mostly parallel motions re-range
              if(!isNaN(comp)) {
                  moveFn2 = comp < 0.5 ? rotateMove : rerangeMove;
              }
          }
  
          var update = {};
          computeRadialAxisUpdates(update);
          gd.emit('plotly_relayouting', update);
      }
  
      function computeRadialAxisUpdates(update) {
          if(angle1 !== null) {
              update[_this.id + '.radialaxis.angle'] = angle1;
          } else if(rprime !== null) {
              update[_this.id + '.radialaxis.range[' + rngIndex + ']'] = rprime;
          }
      }
  
      function doneFn() {
          if(angle1 !== null) {
              Registry.call('_guiRelayout', gd, _this.id + '.radialaxis.angle', angle1);
          } else if(rprime !== null) {
              Registry.call('_guiRelayout', gd, _this.id + '.radialaxis.range[' + rngIndex + ']', rprime);
          }
      }
  
      function rotateMove(dx, dy) {
          // disable for inner drag boxes
          if(rngIndex === 0) return;
  
          var x1 = tx + dx;
          var y1 = ty + dy;
  
          angle1 = Math.atan2(cy - y1, x1 - cx);
          if(_this.vangles) angle1 = snapToVertexAngle(angle1, _this.vangles);
          angle1 = rad2deg(angle1);
  
          var transform = strTranslate(cx, cy) + strRotate(-angle1);
          layers['radial-axis'].attr('transform', transform);
          layers['radial-line'].select('line').attr('transform', transform);
  
          var fullLayoutNow = _this.gd._fullLayout;
          var polarLayoutNow = fullLayoutNow[_this.id];
          _this.updateRadialAxisTitle(fullLayoutNow, polarLayoutNow, angle1);
      }
  
      function rerangeMove(dx, dy) {
          // project (dx, dy) unto unit radial axis vector
          var dr = Lib.dot([dx, -dy], [Math.cos(angle0), Math.sin(angle0)]);
          rprime = rbase - m * dr;
  
          // make sure rprime does not change the range[0] -> range[1] sign
          if((m > 0) !== (rngIndex ? rprime > rl0 : rprime < rl1)) {
              rprime = null;
              return;
          }
  
          var fullLayoutNow = gd._fullLayout;
          var polarLayoutNow = fullLayoutNow[_this.id];
  
          // update radial range -> update c2g -> update _m,_b
          radialAxis.range[rngIndex] = rprime;
          radialAxis._rl[rngIndex] = rprime;
          _this.updateRadialAxis(fullLayoutNow, polarLayoutNow);
  
          _this.xaxis.setRange();
          _this.xaxis.setScale();
          _this.yaxis.setRange();
          _this.yaxis.setScale();
  
          var hasRegl = false;
  
          for(var traceType in _this.traceHash) {
              var moduleCalcData = _this.traceHash[traceType];
              var moduleCalcDataVisible = Lib.filterVisible(moduleCalcData);
              var _module = moduleCalcData[0][0].trace._module;
              _module.plot(gd, _this, moduleCalcDataVisible, polarLayoutNow);
              if(Registry.traceIs(traceType, 'gl') && moduleCalcDataVisible.length) hasRegl = true;
          }
  
          if(hasRegl) {
              clearGlCanvases(gd);
              redrawReglTraces(gd);
          }
      }
  
      dragOpts.prepFn = function() {
          moveFn2 = null;
          angle1 = null;
          rprime = null;
  
          dragOpts.moveFn = moveFn;
          dragOpts.doneFn = doneFn;
  
          clearSelect(gd);
      };
  
      dragOpts.clampFn = function(dx, dy) {
          if(Math.sqrt(dx * dx + dy * dy) < constants.MINDRAG) {
              dx = 0;
              dy = 0;
          }
          return [dx, dy];
      };
  
      dragElement.init(dragOpts);
  };
  
  proto.updateAngularDrag = function(fullLayout) {
      var _this = this;
      var gd = _this.gd;
      var layers = _this.layers;
      var radius = _this.radius;
      var angularAxis = _this.angularAxis;
      var cx = _this.cx;
      var cy = _this.cy;
      var cxx = _this.cxx;
      var cyy = _this.cyy;
      var dbs = constants.angularDragBoxSize;
  
      var angularDrag = dragBox.makeDragger(layers, 'path', 'angulardrag', 'move');
      var dragOpts = {element: angularDrag, gd: gd};
  
      d3.select(angularDrag)
          .attr('d', _this.pathAnnulus(radius, radius + dbs))
          .attr('transform', strTranslate(cx, cy))
          .call(setCursor, 'move');
  
      function xy2a(x, y) {
          return Math.atan2(cyy + dbs - y, x - cxx - dbs);
      }
  
      // scatter trace, points and textpoints selections
      var scatterTraces = layers.frontplot.select('.scatterlayer').selectAll('.trace');
      var scatterPoints = scatterTraces.selectAll('.point');
      var scatterTextPoints = scatterTraces.selectAll('.textpoint');
  
      // mouse px position at drag start (0), move (1)
      var x0, y0;
      // angular axis angle rotation at drag start (0), move (1)
      var rot0, rot1;
      // induced radial axis rotation (only used on polygon grids)
      var rrot1;
      // angle about circle center at drag start
      var a0;
  
      function moveFn(dx, dy) {
          var fullLayoutNow = _this.gd._fullLayout;
          var polarLayoutNow = fullLayoutNow[_this.id];
  
          var x1 = x0 + dx;
          var y1 = y0 + dy;
          var a1 = xy2a(x1, y1);
          var da = rad2deg(a1 - a0);
          rot1 = rot0 + da;
  
          layers.frontplot.attr('transform',
              strTranslate(_this.xOffset2, _this.yOffset2) + strRotate([-da, cxx, cyy])
          );
  
          if(_this.vangles) {
              rrot1 = _this.radialAxisAngle + da;
  
              var trans = strTranslate(cx, cy) + strRotate(-da);
              var trans2 = strTranslate(cx, cy) + strRotate(-rrot1);
  
              layers.bg.attr('transform', trans);
              layers['radial-grid'].attr('transform', trans);
              layers['radial-axis'].attr('transform', trans2);
              layers['radial-line'].select('line').attr('transform', trans2);
              _this.updateRadialAxisTitle(fullLayoutNow, polarLayoutNow, rrot1);
          } else {
              _this.clipPaths.forTraces.select('path').attr('transform',
                  strTranslate(cxx, cyy) + strRotate(da)
              );
          }
  
          // 'un-rotate' marker and text points
          scatterPoints.each(function() {
              var sel = d3.select(this);
              var xy = Drawing.getTranslate(sel);
              sel.attr('transform', strTranslate(xy.x, xy.y) + strRotate([da]));
          });
          scatterTextPoints.each(function() {
              var sel = d3.select(this);
              var tx = sel.select('text');
              var xy = Drawing.getTranslate(sel);
              // N.B rotate -> translate ordering matters
              sel.attr('transform', strRotate([da, tx.attr('x'), tx.attr('y')]) + strTranslate(xy.x, xy.y));
          });
  
          // update rotation -> range -> _m,_b
          angularAxis.rotation = Lib.modHalf(rot1, 360);
          _this.updateAngularAxis(fullLayoutNow, polarLayoutNow);
  
          if(_this._hasClipOnAxisFalse && !Lib.isFullCircle(_this.sectorInRad)) {
              scatterTraces.call(Drawing.hideOutsideRangePoints, _this);
          }
  
          var hasRegl = false;
  
          for(var traceType in _this.traceHash) {
              if(Registry.traceIs(traceType, 'gl')) {
                  var moduleCalcData = _this.traceHash[traceType];
                  var moduleCalcDataVisible = Lib.filterVisible(moduleCalcData);
                  var _module = moduleCalcData[0][0].trace._module;
                  _module.plot(gd, _this, moduleCalcDataVisible, polarLayoutNow);
                  if(moduleCalcDataVisible.length) hasRegl = true;
              }
          }
  
          if(hasRegl) {
              clearGlCanvases(gd);
              redrawReglTraces(gd);
          }
  
          var update = {};
          computeRotationUpdates(update);
          gd.emit('plotly_relayouting', update);
      }
  
      function computeRotationUpdates(updateObj) {
          updateObj[_this.id + '.angularaxis.rotation'] = rot1;
  
          if(_this.vangles) {
              updateObj[_this.id + '.radialaxis.angle'] = rrot1;
          }
      }
  
      function doneFn() {
          scatterTextPoints.select('text').attr('transform', null);
  
          var updateObj = {};
          computeRotationUpdates(updateObj);
          Registry.call('_guiRelayout', gd, updateObj);
      }
  
      dragOpts.prepFn = function(evt, startX, startY) {
          var polarLayoutNow = fullLayout[_this.id];
          rot0 = polarLayoutNow.angularaxis.rotation;
  
          var bbox = angularDrag.getBoundingClientRect();
          x0 = startX - bbox.left;
          y0 = startY - bbox.top;
          a0 = xy2a(x0, y0);
  
          dragOpts.moveFn = moveFn;
          dragOpts.doneFn = doneFn;
  
          clearSelect(gd);
      };
  
      // I don't what we should do in this case, skip we now
      if(_this.vangles && !Lib.isFullCircle(_this.sectorInRad)) {
          dragOpts.prepFn = Lib.noop;
          setCursor(d3.select(angularDrag), null);
      }
  
      dragElement.init(dragOpts);
  };
  
  proto.isPtInside = function(d) {
      var sectorInRad = this.sectorInRad;
      var vangles = this.vangles;
      var thetag = this.angularAxis.c2g(d.theta);
      var radialAxis = this.radialAxis;
      var r = radialAxis.c2l(d.r);
      var rl = radialAxis._rl;
  
      var fn = vangles ? helpers.isPtInsidePolygon : Lib.isPtInsideSector;
      return fn(r, thetag, rl, sectorInRad, vangles);
  };
  
  proto.pathArc = function(r) {
      var sectorInRad = this.sectorInRad;
      var vangles = this.vangles;
      var fn = vangles ? helpers.pathPolygon : Lib.pathArc;
      return fn(r, sectorInRad[0], sectorInRad[1], vangles);
  };
  
  proto.pathSector = function(r) {
      var sectorInRad = this.sectorInRad;
      var vangles = this.vangles;
      var fn = vangles ? helpers.pathPolygon : Lib.pathSector;
      return fn(r, sectorInRad[0], sectorInRad[1], vangles);
  };
  
  proto.pathAnnulus = function(r0, r1) {
      var sectorInRad = this.sectorInRad;
      var vangles = this.vangles;
      var fn = vangles ? helpers.pathPolygonAnnulus : Lib.pathAnnulus;
      return fn(r0, r1, sectorInRad[0], sectorInRad[1], vangles);
  };
  
  proto.pathSubplot = function() {
      var r0 = this.innerRadius;
      var r1 = this.radius;
      return r0 ? this.pathAnnulus(r0, r1) : this.pathSector(r1);
  };
  
  proto.fillViewInitialKey = function(key, val) {
      if(!(key in this.viewInitial)) {
          this.viewInitial[key] = val;
      }
  };
  
  function strTickLayout(axLayout) {
      var out = axLayout.ticks + String(axLayout.ticklen) + String(axLayout.showticklabels);
      if('side' in axLayout) out += axLayout.side;
      return out;
  }
  
  // Finds the bounding box of a given circle sector,
  // inspired by https://math.stackexchange.com/q/1852703
  //
  // assumes:
  // - sector[0] < sector[1]
  // - counterclockwise rotation
  function computeSectorBBox(sector) {
      var s0 = sector[0];
      var s1 = sector[1];
      var arc = s1 - s0;
      var a0 = mod(s0, 360);
      var a1 = a0 + arc;
  
      var ax0 = Math.cos(deg2rad(a0));
      var ay0 = Math.sin(deg2rad(a0));
      var ax1 = Math.cos(deg2rad(a1));
      var ay1 = Math.sin(deg2rad(a1));
  
      var x0, y0, x1, y1;
  
      if((a0 <= 90 && a1 >= 90) || (a0 > 90 && a1 >= 450)) {
          y1 = 1;
      } else if(ay0 <= 0 && ay1 <= 0) {
          y1 = 0;
      } else {
          y1 = Math.max(ay0, ay1);
      }
  
      if((a0 <= 180 && a1 >= 180) || (a0 > 180 && a1 >= 540)) {
          x0 = -1;
      } else if(ax0 >= 0 && ax1 >= 0) {
          x0 = 0;
      } else {
          x0 = Math.min(ax0, ax1);
      }
  
      if((a0 <= 270 && a1 >= 270) || (a0 > 270 && a1 >= 630)) {
          y0 = -1;
      } else if(ay0 >= 0 && ay1 >= 0) {
          y0 = 0;
      } else {
          y0 = Math.min(ay0, ay1);
      }
  
      if(a1 >= 360) {
          x1 = 1;
      } else if(ax0 <= 0 && ax1 <= 0) {
          x1 = 0;
      } else {
          x1 = Math.max(ax0, ax1);
      }
  
      return [x0, y0, x1, y1];
  }
  
  function snapToVertexAngle(a, vangles) {
      var fn = function(v) { return Lib.angleDist(a, v); };
      var ind = Lib.findIndexOfMin(vangles, fn);
      return vangles[ind];
  }
  
  function updateElement(sel, showAttr, attrs) {
      if(showAttr) {
          sel.attr('display', null);
          sel.attr(attrs);
      } else if(sel) {
          sel.attr('display', 'none');
      }
      return sel;
  }
  
  function strTranslate(x, y) {
      return 'translate(' + x + ',' + y + ')';
  }
  
  function strRotate(angle) {
      return 'rotate(' + angle + ')';
  }
  
  },{"../../components/color":615,"../../components/dragelement":634,"../../components/drawing":637,"../../components/fx":655,"../../components/titles":710,"../../constants/alignment":717,"../../lib":750,"../../lib/clear_gl_canvases":734,"../../lib/setcursor":770,"../../plot_api/subroutines":789,"../../plots/cartesian/axes":799,"../../registry":882,"../cartesian/autorange":798,"../cartesian/dragbox":807,"../cartesian/select":818,"../cartesian/set_convert":819,"../plots":862,"./constants":863,"./helpers":864,"./set_convert":875,"d3":169,"tinycolor2":548}],875:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var setConvertCartesian = _dereq_('../cartesian/set_convert');
  
  var deg2rad = Lib.deg2rad;
  var rad2deg = Lib.rad2deg;
  
  /**
   * setConvert for polar axes!
   *
   * @param {object} ax
   *   axis in question (works for both radial and angular axes)
   * @param {object} polarLayout
   *   full polar layout of the subplot associated with 'ax'
   * @param {object} fullLayout
   *   full layout
   *
   * Here, reuse some of the Cartesian setConvert logic,
   * but we must extend some of it, as both radial and angular axes
   * don't have domains and angular axes don't have _true_ ranges.
   *
   * Moreover, we introduce two new coordinate systems:
   * - 'g' for geometric coordinates and
   * - 't' for angular ticks
   *
   * Radial axis coordinate systems:
   * - d, c and l: same as for cartesian axes
   * - g: like calcdata but translated about `radialaxis.range[0]` & `polar.hole`
   *
   * Angular axis coordinate systems:
   * - d: data, in whatever form it's provided
   * - c: calcdata, turned into radians (for linear axes)
   *      or category indices (category axes)
   * - t: tick calcdata, just like 'c' but in degrees for linear axes
   * - g: geometric calcdata, radians coordinates that take into account
   *      axis rotation and direction
   *
   * Then, 'g'eometric data is ready to be converted to (x,y).
   */
  module.exports = function setConvert(ax, polarLayout, fullLayout) {
      setConvertCartesian(ax, fullLayout);
  
      switch(ax._id) {
          case 'x':
          case 'radialaxis':
              setConvertRadial(ax, polarLayout);
              break;
          case 'angularaxis':
              setConvertAngular(ax, polarLayout);
              break;
      }
  };
  
  function setConvertRadial(ax, polarLayout) {
      var subplot = polarLayout._subplot;
  
      ax.setGeometry = function() {
          var rl0 = ax._rl[0];
          var rl1 = ax._rl[1];
  
          var b = subplot.innerRadius;
          var m = (subplot.radius - b) / (rl1 - rl0);
          var b2 = b / m;
  
          var rFilter = rl0 > rl1 ?
              function(v) { return v <= 0; } :
              function(v) { return v >= 0; };
  
          ax.c2g = function(v) {
              var r = ax.c2l(v) - rl0;
              return (rFilter(r) ? r : 0) + b2;
          };
  
          ax.g2c = function(v) {
              return ax.l2c(v + rl0 - b2);
          };
  
          ax.g2p = function(v) { return v * m; };
          ax.c2p = function(v) { return ax.g2p(ax.c2g(v)); };
      };
  }
  
  function toRadians(v, unit) {
      return unit === 'degrees' ? deg2rad(v) : v;
  }
  
  function fromRadians(v, unit) {
      return unit === 'degrees' ? rad2deg(v) : v;
  }
  
  function setConvertAngular(ax, polarLayout) {
      var axType = ax.type;
  
      if(axType === 'linear') {
          var _d2c = ax.d2c;
          var _c2d = ax.c2d;
  
          ax.d2c = function(v, unit) { return toRadians(_d2c(v), unit); };
          ax.c2d = function(v, unit) { return _c2d(fromRadians(v, unit)); };
      }
  
      // override makeCalcdata to handle thetaunit and special theta0/dtheta logic
      ax.makeCalcdata = function(trace, coord) {
          var arrayIn = trace[coord];
          var len = trace._length;
          var arrayOut, i;
  
          var _d2c = function(v) { return ax.d2c(v, trace.thetaunit); };
  
          if(arrayIn) {
              if(Lib.isTypedArray(arrayIn) && axType === 'linear') {
                  if(len === arrayIn.length) {
                      return arrayIn;
                  } else if(arrayIn.subarray) {
                      return arrayIn.subarray(0, len);
                  }
              }
  
              arrayOut = new Array(len);
              for(i = 0; i < len; i++) {
                  arrayOut[i] = _d2c(arrayIn[i]);
              }
          } else {
              var coord0 = coord + '0';
              var dcoord = 'd' + coord;
              var v0 = (coord0 in trace) ? _d2c(trace[coord0]) : 0;
              var dv = (trace[dcoord]) ? _d2c(trace[dcoord]) : (ax.period || 2 * Math.PI) / len;
  
              arrayOut = new Array(len);
              for(i = 0; i < len; i++) {
                  arrayOut[i] = v0 + i * dv;
              }
          }
  
          return arrayOut;
      };
  
      // N.B. we mock the axis 'range' here
      ax.setGeometry = function() {
          var sector = polarLayout.sector;
          var sectorInRad = sector.map(deg2rad);
          var dir = {clockwise: -1, counterclockwise: 1}[ax.direction];
          var rot = deg2rad(ax.rotation);
  
          var rad2g = function(v) { return dir * v + rot; };
          var g2rad = function(v) { return (v - rot) / dir; };
  
          var rad2c, c2rad;
          var rad2t, t2rad;
  
          switch(axType) {
              case 'linear':
                  c2rad = rad2c = Lib.identity;
                  t2rad = deg2rad;
                  rad2t = rad2deg;
  
                  // Set the angular range in degrees to make auto-tick computation cleaner,
                  // changing rotation/direction should not affect the angular tick value.
                  ax.range = Lib.isFullCircle(sectorInRad) ?
                      [sector[0], sector[0] + 360] :
                      sectorInRad.map(g2rad).map(rad2deg);
                  break;
  
              case 'category':
                  var catLen = ax._categories.length;
                  var _period = ax.period ? Math.max(ax.period, catLen) : catLen;
  
                  // fallback in case all categories have been filtered out
                  if(_period === 0) _period = 1;
  
                  c2rad = t2rad = function(v) { return v * 2 * Math.PI / _period; };
                  rad2c = rad2t = function(v) { return v * _period / Math.PI / 2; };
  
                  ax.range = [0, _period];
                  break;
          }
  
          ax.c2g = function(v) { return rad2g(c2rad(v)); };
          ax.g2c = function(v) { return rad2c(g2rad(v)); };
  
          ax.t2g = function(v) { return rad2g(t2rad(v)); };
          ax.g2t = function(v) { return rad2t(g2rad(v)); };
      };
  }
  
  },{"../../lib":750,"../cartesian/set_convert":819}],876:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var Template = _dereq_('../plot_api/plot_template');
  var handleDomainDefaults = _dereq_('./domain').defaults;
  
  
  /**
   * Find and supply defaults to all subplots of a given type
   * This handles subplots that are contained within one container - so
   * gl3d, geo, ternary... but not 2d axes which have separate x and y axes
   * finds subplots, coerces their `domain` attributes, then calls the
   * given handleDefaults function to fill in everything else.
   *
   * layoutIn: the complete user-supplied input layout
   * layoutOut: the complete finished layout
   * fullData: the finished data array, used only to find subplots
   * opts: {
   *  type: subplot type string
   *  attributes: subplot attributes object
   *  partition: 'x' or 'y', which direction to divide domain space by default
   *      (default 'x', ie side-by-side subplots)
   *      TODO: this option is only here because 3D and geo made opposite
   *      choices in this regard previously and I didn't want to change it.
   *      Instead we should do:
   *      - something consistent
   *      - something more square (4 cuts 2x2, 5/6 cuts 2x3, etc.)
   *      - something that includes all subplot types in one arrangement,
   *        now that we can have them together!
   *  handleDefaults: function of (subplotLayoutIn, subplotLayoutOut, coerce, opts)
   *      this opts object is passed through to handleDefaults, so attach any
   *      additional items needed by this function here as well
   * }
   */
  module.exports = function handleSubplotDefaults(layoutIn, layoutOut, fullData, opts) {
      var subplotType = opts.type;
      var subplotAttributes = opts.attributes;
      var handleDefaults = opts.handleDefaults;
      var partition = opts.partition || 'x';
  
      var ids = layoutOut._subplots[subplotType];
      var idsLength = ids.length;
  
      var baseId = idsLength && ids[0].replace(/\d+$/, '');
  
      var subplotLayoutIn, subplotLayoutOut;
  
      function coerce(attr, dflt) {
          return Lib.coerce(subplotLayoutIn, subplotLayoutOut, subplotAttributes, attr, dflt);
      }
  
      for(var i = 0; i < idsLength; i++) {
          var id = ids[i];
  
          // ternary traces get a layout ternary for free!
          if(layoutIn[id]) subplotLayoutIn = layoutIn[id];
          else subplotLayoutIn = layoutIn[id] = {};
  
          subplotLayoutOut = Template.newContainer(layoutOut, id, baseId);
  
          // All subplot containers get a `uirevision` inheriting from the base.
          // Currently all subplots containers have some user interaction
          // attributes, but if we ever add one that doesn't, we would need an
          // option to skip this step.
          coerce('uirevision', layoutOut.uirevision);
  
          var dfltDomains = {};
          dfltDomains[partition] = [i / idsLength, (i + 1) / idsLength];
          handleDomainDefaults(subplotLayoutOut, layoutOut, coerce, dfltDomains);
  
          opts.id = id;
          handleDefaults(subplotLayoutIn, subplotLayoutOut, coerce, opts);
      }
  };
  
  },{"../lib":750,"../plot_api/plot_template":788,"./domain":826}],877:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var FORMAT_LINK = _dereq_('../constants/docs').FORMAT_LINK;
  var DATE_FORMAT_LINK = _dereq_('../constants/docs').DATE_FORMAT_LINK;
  
  var templateFormatStringDescription = [
      'Variables are inserted using %{variable}, for example "y: %{y}".',
      'Numbers are formatted using d3-format\'s syntax %{variable:d3-format}, for example "Price: %{y:$.2f}".',
      FORMAT_LINK,
      'for details on the formatting syntax.',
      'Dates are formatted using d3-time-format\'s syntax %{variable|d3-time-format}, for example "Day: %{2019-01-01|%A}".',
      DATE_FORMAT_LINK,
      'for details on the date formatting syntax.'
  ].join(' ');
  
  function describeVariables(extra) {
      var descPart = extra.description ? ' ' + extra.description : '';
      var keys = extra.keys || [];
      if(keys.length > 0) {
          var quotedKeys = [];
          for(var i = 0; i < keys.length; i++) {
              quotedKeys[i] = '`' + keys[i] + '`';
          }
          descPart = descPart + 'Finally, the template string has access to ';
          if(keys.length === 1) {
              descPart = 'variable ' + quotedKeys[0];
          } else {
              descPart = 'variables ' + quotedKeys.slice(0, -1).join(', ') + ' and ' + quotedKeys.slice(-1) + '.';
          }
      }
      return descPart;
  }
  
  exports.hovertemplateAttrs = function(opts, extra) {
      opts = opts || {};
      extra = extra || {};
  
      var descPart = describeVariables(extra);
  
      var hovertemplate = {
          valType: 'string',
          
          dflt: '',
          editType: opts.editType || 'none',
          
      };
  
      if(opts.arrayOk !== false) {
          hovertemplate.arrayOk = true;
      }
  
      return hovertemplate;
  };
  
  exports.texttemplateAttrs = function(opts, extra) {
      opts = opts || {};
      extra = extra || {};
  
      var descPart = describeVariables(extra);
  
      var texttemplate = {
          valType: 'string',
          
          dflt: '',
          editType: opts.editType || 'calc',
          
      };
  
      if(opts.arrayOk !== false) {
          texttemplate.arrayOk = true;
      }
      return texttemplate;
  };
  
  },{"../constants/docs":720}],878:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Ternary = _dereq_('./ternary');
  
  var getSubplotCalcData = _dereq_('../../plots/get_data').getSubplotCalcData;
  var counterRegex = _dereq_('../../lib').counterRegex;
  var TERNARY = 'ternary';
  
  exports.name = TERNARY;
  
  var attr = exports.attr = 'subplot';
  
  exports.idRoot = TERNARY;
  
  exports.idRegex = exports.attrRegex = counterRegex(TERNARY);
  
  var attributes = exports.attributes = {};
  attributes[attr] = {
      valType: 'subplotid',
      
      dflt: 'ternary',
      editType: 'calc',
      
  };
  
  exports.layoutAttributes = _dereq_('./layout_attributes');
  
  exports.supplyLayoutDefaults = _dereq_('./layout_defaults');
  
  exports.plot = function plot(gd) {
      var fullLayout = gd._fullLayout;
      var calcData = gd.calcdata;
      var ternaryIds = fullLayout._subplots[TERNARY];
  
      for(var i = 0; i < ternaryIds.length; i++) {
          var ternaryId = ternaryIds[i];
          var ternaryCalcData = getSubplotCalcData(calcData, TERNARY, ternaryId);
          var ternary = fullLayout[ternaryId]._subplot;
  
          // If ternary is not instantiated, create one!
          if(!ternary) {
              ternary = new Ternary({
                  id: ternaryId,
                  graphDiv: gd,
                  container: fullLayout._ternarylayer.node()
              },
                  fullLayout
              );
  
              fullLayout[ternaryId]._subplot = ternary;
          }
  
          ternary.plot(ternaryCalcData, fullLayout, gd._promises);
      }
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var oldTernaryKeys = oldFullLayout._subplots[TERNARY] || [];
  
      for(var i = 0; i < oldTernaryKeys.length; i++) {
          var oldTernaryKey = oldTernaryKeys[i];
          var oldTernary = oldFullLayout[oldTernaryKey]._subplot;
  
          if(!newFullLayout[oldTernaryKey] && !!oldTernary) {
              oldTernary.plotContainer.remove();
              oldTernary.clipDef.remove();
              oldTernary.clipDefRelative.remove();
              oldTernary.layers['a-title'].remove();
              oldTernary.layers['b-title'].remove();
              oldTernary.layers['c-title'].remove();
          }
      }
  };
  
  },{"../../lib":750,"../../plots/get_data":836,"./layout_attributes":879,"./layout_defaults":880,"./ternary":881}],879:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorAttrs = _dereq_('../../components/color/attributes');
  var domainAttrs = _dereq_('../domain').attributes;
  var axesAttrs = _dereq_('../cartesian/layout_attributes');
  
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var ternaryAxesAttrs = {
      title: {
          text: axesAttrs.title.text,
          font: axesAttrs.title.font
          // TODO does standoff here make sense?
      },
      color: axesAttrs.color,
      // ticks
      tickmode: axesAttrs.tickmode,
      nticks: extendFlat({}, axesAttrs.nticks, {dflt: 6, min: 1}),
      tick0: axesAttrs.tick0,
      dtick: axesAttrs.dtick,
      tickvals: axesAttrs.tickvals,
      ticktext: axesAttrs.ticktext,
      ticks: axesAttrs.ticks,
      ticklen: axesAttrs.ticklen,
      tickwidth: axesAttrs.tickwidth,
      tickcolor: axesAttrs.tickcolor,
      showticklabels: axesAttrs.showticklabels,
      showtickprefix: axesAttrs.showtickprefix,
      tickprefix: axesAttrs.tickprefix,
      showticksuffix: axesAttrs.showticksuffix,
      ticksuffix: axesAttrs.ticksuffix,
      showexponent: axesAttrs.showexponent,
      exponentformat: axesAttrs.exponentformat,
      minexponent: axesAttrs.minexponent,
      separatethousands: axesAttrs.separatethousands,
      tickfont: axesAttrs.tickfont,
      tickangle: axesAttrs.tickangle,
      tickformat: axesAttrs.tickformat,
      tickformatstops: axesAttrs.tickformatstops,
      hoverformat: axesAttrs.hoverformat,
      // lines and grids
      showline: extendFlat({}, axesAttrs.showline, {dflt: true}),
      linecolor: axesAttrs.linecolor,
      linewidth: axesAttrs.linewidth,
      showgrid: extendFlat({}, axesAttrs.showgrid, {dflt: true}),
      gridcolor: axesAttrs.gridcolor,
      gridwidth: axesAttrs.gridwidth,
      layer: axesAttrs.layer,
      // range
      min: {
          valType: 'number',
          dflt: 0,
          
          min: 0,
          
      },
      _deprecated: {
          title: axesAttrs._deprecated.title,
          titlefont: axesAttrs._deprecated.titlefont
      }
  };
  
  var attrs = module.exports = overrideAll({
      domain: domainAttrs({name: 'ternary'}),
  
      bgcolor: {
          valType: 'color',
          
          dflt: colorAttrs.background,
          
      },
      sum: {
          valType: 'number',
          
          dflt: 1,
          min: 0,
          
      },
      aaxis: ternaryAxesAttrs,
      baxis: ternaryAxesAttrs,
      caxis: ternaryAxesAttrs
  }, 'plot', 'from-root');
  
  // set uirevisions outside of `overrideAll` so we can get `editType: none`
  attrs.uirevision = {
      valType: 'any',
      
      editType: 'none',
      
  };
  
  attrs.aaxis.uirevision = attrs.baxis.uirevision = attrs.caxis.uirevision = {
      valType: 'any',
      
      editType: 'none',
      
  };
  
  },{"../../components/color/attributes":614,"../../lib/extend":740,"../../plot_api/edit_types":781,"../cartesian/layout_attributes":813,"../domain":826}],880:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Color = _dereq_('../../components/color');
  var Template = _dereq_('../../plot_api/plot_template');
  var Lib = _dereq_('../../lib');
  
  var handleSubplotDefaults = _dereq_('../subplot_defaults');
  var handleTickLabelDefaults = _dereq_('../cartesian/tick_label_defaults');
  var handleTickMarkDefaults = _dereq_('../cartesian/tick_mark_defaults');
  var handleTickValueDefaults = _dereq_('../cartesian/tick_value_defaults');
  var handleLineGridDefaults = _dereq_('../cartesian/line_grid_defaults');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  var axesNames = ['aaxis', 'baxis', 'caxis'];
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
      handleSubplotDefaults(layoutIn, layoutOut, fullData, {
          type: 'ternary',
          attributes: layoutAttributes,
          handleDefaults: handleTernaryDefaults,
          font: layoutOut.font,
          paper_bgcolor: layoutOut.paper_bgcolor
      });
  };
  
  function handleTernaryDefaults(ternaryLayoutIn, ternaryLayoutOut, coerce, options) {
      var bgColor = coerce('bgcolor');
      var sum = coerce('sum');
      options.bgColor = Color.combine(bgColor, options.paper_bgcolor);
      var axName, containerIn, containerOut;
  
      // TODO: allow most (if not all) axis attributes to be set
      // in the outer container and used as defaults in the individual axes?
  
      for(var j = 0; j < axesNames.length; j++) {
          axName = axesNames[j];
          containerIn = ternaryLayoutIn[axName] || {};
          containerOut = Template.newContainer(ternaryLayoutOut, axName);
          containerOut._name = axName;
  
          handleAxisDefaults(containerIn, containerOut, options, ternaryLayoutOut);
      }
  
      // if the min values contradict each other, set them all to default (0)
      // and delete *all* the inputs so the user doesn't get confused later by
      // changing one and having them all change.
      var aaxis = ternaryLayoutOut.aaxis;
      var baxis = ternaryLayoutOut.baxis;
      var caxis = ternaryLayoutOut.caxis;
      if(aaxis.min + baxis.min + caxis.min >= sum) {
          aaxis.min = 0;
          baxis.min = 0;
          caxis.min = 0;
          if(ternaryLayoutIn.aaxis) delete ternaryLayoutIn.aaxis.min;
          if(ternaryLayoutIn.baxis) delete ternaryLayoutIn.baxis.min;
          if(ternaryLayoutIn.caxis) delete ternaryLayoutIn.caxis.min;
      }
  }
  
  function handleAxisDefaults(containerIn, containerOut, options, ternaryLayoutOut) {
      var axAttrs = layoutAttributes[containerOut._name];
  
      function coerce(attr, dflt) {
          return Lib.coerce(containerIn, containerOut, axAttrs, attr, dflt);
      }
  
      coerce('uirevision', ternaryLayoutOut.uirevision);
  
      containerOut.type = 'linear'; // no other types allowed for ternary
  
      var dfltColor = coerce('color');
      // if axis.color was provided, use it for fonts too; otherwise,
      // inherit from global font color in case that was provided.
      var dfltFontColor = (dfltColor !== axAttrs.color.dflt) ? dfltColor : options.font.color;
  
      var axName = containerOut._name;
      var letterUpper = axName.charAt(0).toUpperCase();
      var dfltTitle = 'Component ' + letterUpper;
  
      var title = coerce('title.text', dfltTitle);
      containerOut._hovertitle = title === dfltTitle ? title : letterUpper;
  
      Lib.coerceFont(coerce, 'title.font', {
          family: options.font.family,
          size: Math.round(options.font.size * 1.2),
          color: dfltFontColor
      });
  
      // range is just set by 'min' - max is determined by the other axes mins
      coerce('min');
  
      handleTickValueDefaults(containerIn, containerOut, coerce, 'linear');
      handleTickLabelDefaults(containerIn, containerOut, coerce, 'linear', {});
      handleTickMarkDefaults(containerIn, containerOut, coerce,
          { outerTicks: true });
  
      var showTickLabels = coerce('showticklabels');
      if(showTickLabels) {
          Lib.coerceFont(coerce, 'tickfont', {
              family: options.font.family,
              size: options.font.size,
              color: dfltFontColor
          });
          coerce('tickangle');
          coerce('tickformat');
      }
  
      handleLineGridDefaults(containerIn, containerOut, coerce, {
          dfltColor: dfltColor,
          bgColor: options.bgColor,
          // default grid color is darker here (60%, vs cartesian default ~91%)
          // because the grid is not square so the eye needs heavier cues to follow
          blend: 60,
          showLine: true,
          showGrid: true,
          noZeroLine: true,
          attributes: axAttrs
      });
  
      coerce('hoverformat');
      coerce('layer');
  }
  
  },{"../../components/color":615,"../../lib":750,"../../plot_api/plot_template":788,"../cartesian/line_grid_defaults":815,"../cartesian/tick_label_defaults":820,"../cartesian/tick_mark_defaults":821,"../cartesian/tick_value_defaults":822,"../subplot_defaults":876,"./layout_attributes":879}],881:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var tinycolor = _dereq_('tinycolor2');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var _ = Lib._;
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  var setConvert = _dereq_('../cartesian/set_convert');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var Plots = _dereq_('../plots');
  var Axes = _dereq_('../cartesian/axes');
  var dragElement = _dereq_('../../components/dragelement');
  var Fx = _dereq_('../../components/fx');
  var dragHelpers = _dereq_('../../components/dragelement/helpers');
  var freeMode = dragHelpers.freeMode;
  var rectMode = dragHelpers.rectMode;
  var Titles = _dereq_('../../components/titles');
  var prepSelect = _dereq_('../cartesian/select').prepSelect;
  var selectOnClick = _dereq_('../cartesian/select').selectOnClick;
  var clearSelect = _dereq_('../cartesian/select').clearSelect;
  var clearSelectionsCache = _dereq_('../cartesian/select').clearSelectionsCache;
  var constants = _dereq_('../cartesian/constants');
  
  function Ternary(options, fullLayout) {
      this.id = options.id;
      this.graphDiv = options.graphDiv;
      this.init(fullLayout);
      this.makeFramework(fullLayout);
  
      // unfortunately, we have to keep track of some axis tick settings
      // as ternary subplots do not implement the 'ticks' editType
      this.aTickLayout = null;
      this.bTickLayout = null;
      this.cTickLayout = null;
  }
  
  module.exports = Ternary;
  
  var proto = Ternary.prototype;
  
  proto.init = function(fullLayout) {
      this.container = fullLayout._ternarylayer;
      this.defs = fullLayout._defs;
      this.layoutId = fullLayout._uid;
      this.traceHash = {};
      this.layers = {};
  };
  
  proto.plot = function(ternaryCalcData, fullLayout) {
      var _this = this;
      var ternaryLayout = fullLayout[_this.id];
      var graphSize = fullLayout._size;
  
      _this._hasClipOnAxisFalse = false;
      for(var i = 0; i < ternaryCalcData.length; i++) {
          var trace = ternaryCalcData[i][0].trace;
  
          if(trace.cliponaxis === false) {
              _this._hasClipOnAxisFalse = true;
              break;
          }
      }
  
      _this.updateLayers(ternaryLayout);
      _this.adjustLayout(ternaryLayout, graphSize);
      Plots.generalUpdatePerTraceModule(_this.graphDiv, _this, ternaryCalcData, ternaryLayout);
      _this.layers.plotbg.select('path').call(Color.fill, ternaryLayout.bgcolor);
  };
  
  proto.makeFramework = function(fullLayout) {
      var _this = this;
      var gd = _this.graphDiv;
      var ternaryLayout = fullLayout[_this.id];
  
      var clipId = _this.clipId = 'clip' + _this.layoutId + _this.id;
      var clipIdRelative = _this.clipIdRelative = 'clip-relative' + _this.layoutId + _this.id;
  
      // clippath for this ternary subplot
      _this.clipDef = Lib.ensureSingleById(fullLayout._clips, 'clipPath', clipId, function(s) {
          s.append('path').attr('d', 'M0,0Z');
      });
  
      // 'relative' clippath (i.e. no translation) for this ternary subplot
      _this.clipDefRelative = Lib.ensureSingleById(fullLayout._clips, 'clipPath', clipIdRelative, function(s) {
          s.append('path').attr('d', 'M0,0Z');
      });
  
      // container for everything in this ternary subplot
      _this.plotContainer = Lib.ensureSingle(_this.container, 'g', _this.id);
      _this.updateLayers(ternaryLayout);
  
      Drawing.setClipUrl(_this.layers.backplot, clipId, gd);
      Drawing.setClipUrl(_this.layers.grids, clipId, gd);
  };
  
  proto.updateLayers = function(ternaryLayout) {
      var _this = this;
      var layers = _this.layers;
  
      // inside that container, we have one container for the data, and
      // one each for the three axes around it.
  
      var plotLayers = ['draglayer', 'plotbg', 'backplot', 'grids'];
  
      if(ternaryLayout.aaxis.layer === 'below traces') {
          plotLayers.push('aaxis', 'aline');
      }
      if(ternaryLayout.baxis.layer === 'below traces') {
          plotLayers.push('baxis', 'bline');
      }
      if(ternaryLayout.caxis.layer === 'below traces') {
          plotLayers.push('caxis', 'cline');
      }
  
      plotLayers.push('frontplot');
  
      if(ternaryLayout.aaxis.layer === 'above traces') {
          plotLayers.push('aaxis', 'aline');
      }
      if(ternaryLayout.baxis.layer === 'above traces') {
          plotLayers.push('baxis', 'bline');
      }
      if(ternaryLayout.caxis.layer === 'above traces') {
          plotLayers.push('caxis', 'cline');
      }
  
      var toplevel = _this.plotContainer.selectAll('g.toplevel')
          .data(plotLayers, String);
  
      var grids = ['agrid', 'bgrid', 'cgrid'];
  
      toplevel.enter().append('g')
          .attr('class', function(d) { return 'toplevel ' + d; })
          .each(function(d) {
              var s = d3.select(this);
              layers[d] = s;
  
              // containers for different trace types.
              // NOTE - this is different from cartesian, where all traces
              // are in front of grids. Here I'm putting maps behind the grids
              // so the grids will always be visible if they're requested.
              // Perhaps we want that for cartesian too?
              if(d === 'frontplot') {
                  s.append('g').classed('scatterlayer', true);
              } else if(d === 'backplot') {
                  s.append('g').classed('maplayer', true);
              } else if(d === 'plotbg') {
                  s.append('path').attr('d', 'M0,0Z');
              } else if(d === 'aline' || d === 'bline' || d === 'cline') {
                  s.append('path');
              } else if(d === 'grids') {
                  grids.forEach(function(d) {
                      layers[d] = s.append('g').classed('grid ' + d, true);
                  });
              }
          });
  
      toplevel.order();
  };
  
  var whRatio = Math.sqrt(4 / 3);
  
  proto.adjustLayout = function(ternaryLayout, graphSize) {
      var _this = this;
      var domain = ternaryLayout.domain;
      var xDomainCenter = (domain.x[0] + domain.x[1]) / 2;
      var yDomainCenter = (domain.y[0] + domain.y[1]) / 2;
      var xDomain = domain.x[1] - domain.x[0];
      var yDomain = domain.y[1] - domain.y[0];
      var wmax = xDomain * graphSize.w;
      var hmax = yDomain * graphSize.h;
      var sum = ternaryLayout.sum;
      var amin = ternaryLayout.aaxis.min;
      var bmin = ternaryLayout.baxis.min;
      var cmin = ternaryLayout.caxis.min;
  
      var x0, y0, w, h, xDomainFinal, yDomainFinal;
  
      if(wmax > whRatio * hmax) {
          h = hmax;
          w = h * whRatio;
      } else {
          w = wmax;
          h = w / whRatio;
      }
  
      xDomainFinal = xDomain * w / wmax;
      yDomainFinal = yDomain * h / hmax;
  
      x0 = graphSize.l + graphSize.w * xDomainCenter - w / 2;
      y0 = graphSize.t + graphSize.h * (1 - yDomainCenter) - h / 2;
  
      _this.x0 = x0;
      _this.y0 = y0;
      _this.w = w;
      _this.h = h;
      _this.sum = sum;
  
      // set up the x and y axis objects we'll use to lay out the points
      _this.xaxis = {
          type: 'linear',
          range: [amin + 2 * cmin - sum, sum - amin - 2 * bmin],
          domain: [
              xDomainCenter - xDomainFinal / 2,
              xDomainCenter + xDomainFinal / 2
          ],
          _id: 'x'
      };
      setConvert(_this.xaxis, _this.graphDiv._fullLayout);
      _this.xaxis.setScale();
      _this.xaxis.isPtWithinRange = function(d) {
          return (
              d.a >= _this.aaxis.range[0] &&
              d.a <= _this.aaxis.range[1] &&
              d.b >= _this.baxis.range[1] &&
              d.b <= _this.baxis.range[0] &&
              d.c >= _this.caxis.range[1] &&
              d.c <= _this.caxis.range[0]
          );
      };
  
      _this.yaxis = {
          type: 'linear',
          range: [amin, sum - bmin - cmin],
          domain: [
              yDomainCenter - yDomainFinal / 2,
              yDomainCenter + yDomainFinal / 2
          ],
          _id: 'y'
      };
      setConvert(_this.yaxis, _this.graphDiv._fullLayout);
      _this.yaxis.setScale();
      _this.yaxis.isPtWithinRange = function() { return true; };
  
      // set up the modified axes for tick drawing
      var yDomain0 = _this.yaxis.domain[0];
  
      // aaxis goes up the left side. Set it up as a y axis, but with
      // fictitious angles and domain, but then rotate and translate
      // it into place at the end
      var aaxis = _this.aaxis = extendFlat({}, ternaryLayout.aaxis, {
          range: [amin, sum - bmin - cmin],
          side: 'left',
          // tickangle = 'auto' means 0 anyway for a y axis, need to coerce to 0 here
          // so we can shift by 30.
          tickangle: (+ternaryLayout.aaxis.tickangle || 0) - 30,
          domain: [yDomain0, yDomain0 + yDomainFinal * whRatio],
          anchor: 'free',
          position: 0,
          _id: 'y',
          _length: w
      });
      setConvert(aaxis, _this.graphDiv._fullLayout);
      aaxis.setScale();
  
      // baxis goes across the bottom (backward). We can set it up as an x axis
      // without any enclosing transformation.
      var baxis = _this.baxis = extendFlat({}, ternaryLayout.baxis, {
          range: [sum - amin - cmin, bmin],
          side: 'bottom',
          domain: _this.xaxis.domain,
          anchor: 'free',
          position: 0,
          _id: 'x',
          _length: w
      });
      setConvert(baxis, _this.graphDiv._fullLayout);
      baxis.setScale();
  
      // caxis goes down the right side. Set it up as a y axis, with
      // post-transformation similar to aaxis
      var caxis = _this.caxis = extendFlat({}, ternaryLayout.caxis, {
          range: [sum - amin - bmin, cmin],
          side: 'right',
          tickangle: (+ternaryLayout.caxis.tickangle || 0) + 30,
          domain: [yDomain0, yDomain0 + yDomainFinal * whRatio],
          anchor: 'free',
          position: 0,
          _id: 'y',
          _length: w
      });
      setConvert(caxis, _this.graphDiv._fullLayout);
      caxis.setScale();
  
      var triangleClip = 'M' + x0 + ',' + (y0 + h) + 'h' + w + 'l-' + (w / 2) + ',-' + h + 'Z';
      _this.clipDef.select('path').attr('d', triangleClip);
      _this.layers.plotbg.select('path').attr('d', triangleClip);
  
      var triangleClipRelative = 'M0,' + h + 'h' + w + 'l-' + (w / 2) + ',-' + h + 'Z';
      _this.clipDefRelative.select('path').attr('d', triangleClipRelative);
  
      var plotTransform = 'translate(' + x0 + ',' + y0 + ')';
      _this.plotContainer.selectAll('.scatterlayer,.maplayer')
          .attr('transform', plotTransform);
  
      _this.clipDefRelative.select('path').attr('transform', null);
  
      // TODO: shift axes to accommodate linewidth*sin(30) tick mark angle
  
      // TODO: there's probably an easier way to handle these translations/offsets now...
      var bTransform = 'translate(' + (x0 - baxis._offset) + ',' + (y0 + h) + ')';
  
      _this.layers.baxis.attr('transform', bTransform);
      _this.layers.bgrid.attr('transform', bTransform);
  
      var aTransform = 'translate(' + (x0 + w / 2) + ',' + y0 +
          ')rotate(30)translate(0,' + -aaxis._offset + ')';
      _this.layers.aaxis.attr('transform', aTransform);
      _this.layers.agrid.attr('transform', aTransform);
  
      var cTransform = 'translate(' + (x0 + w / 2) + ',' + y0 +
          ')rotate(-30)translate(0,' + -caxis._offset + ')';
      _this.layers.caxis.attr('transform', cTransform);
      _this.layers.cgrid.attr('transform', cTransform);
  
      _this.drawAxes(true);
  
      _this.layers.aline.select('path')
          .attr('d', aaxis.showline ?
              'M' + x0 + ',' + (y0 + h) + 'l' + (w / 2) + ',-' + h : 'M0,0')
          .call(Color.stroke, aaxis.linecolor || '#000')
          .style('stroke-width', (aaxis.linewidth || 0) + 'px');
      _this.layers.bline.select('path')
          .attr('d', baxis.showline ?
              'M' + x0 + ',' + (y0 + h) + 'h' + w : 'M0,0')
          .call(Color.stroke, baxis.linecolor || '#000')
          .style('stroke-width', (baxis.linewidth || 0) + 'px');
      _this.layers.cline.select('path')
          .attr('d', caxis.showline ?
              'M' + (x0 + w / 2) + ',' + y0 + 'l' + (w / 2) + ',' + h : 'M0,0')
          .call(Color.stroke, caxis.linecolor || '#000')
          .style('stroke-width', (caxis.linewidth || 0) + 'px');
  
      if(!_this.graphDiv._context.staticPlot) {
          _this.initInteractions();
      }
  
      Drawing.setClipUrl(
          _this.layers.frontplot,
          _this._hasClipOnAxisFalse ? null : _this.clipId,
          _this.graphDiv
      );
  };
  
  proto.drawAxes = function(doTitles) {
      var _this = this;
      var gd = _this.graphDiv;
      var titlesuffix = _this.id.substr(7) + 'title';
      var layers = _this.layers;
      var aaxis = _this.aaxis;
      var baxis = _this.baxis;
      var caxis = _this.caxis;
  
      _this.drawAx(aaxis);
      _this.drawAx(baxis);
      _this.drawAx(caxis);
  
      if(doTitles) {
          var apad = Math.max(aaxis.showticklabels ? aaxis.tickfont.size / 2 : 0,
              (caxis.showticklabels ? caxis.tickfont.size * 0.75 : 0) +
              (caxis.ticks === 'outside' ? caxis.ticklen * 0.87 : 0));
          var bpad = (baxis.showticklabels ? baxis.tickfont.size : 0) +
              (baxis.ticks === 'outside' ? baxis.ticklen : 0) + 3;
  
          layers['a-title'] = Titles.draw(gd, 'a' + titlesuffix, {
              propContainer: aaxis,
              propName: _this.id + '.aaxis.title',
              placeholder: _(gd, 'Click to enter Component A title'),
              attributes: {
                  x: _this.x0 + _this.w / 2,
                  y: _this.y0 - aaxis.title.font.size / 3 - apad,
                  'text-anchor': 'middle'
              }
          });
          layers['b-title'] = Titles.draw(gd, 'b' + titlesuffix, {
              propContainer: baxis,
              propName: _this.id + '.baxis.title',
              placeholder: _(gd, 'Click to enter Component B title'),
              attributes: {
                  x: _this.x0 - bpad,
                  y: _this.y0 + _this.h + baxis.title.font.size * 0.83 + bpad,
                  'text-anchor': 'middle'
              }
          });
          layers['c-title'] = Titles.draw(gd, 'c' + titlesuffix, {
              propContainer: caxis,
              propName: _this.id + '.caxis.title',
              placeholder: _(gd, 'Click to enter Component C title'),
              attributes: {
                  x: _this.x0 + _this.w + bpad,
                  y: _this.y0 + _this.h + caxis.title.font.size * 0.83 + bpad,
                  'text-anchor': 'middle'
              }
          });
      }
  };
  
  proto.drawAx = function(ax) {
      var _this = this;
      var gd = _this.graphDiv;
      var axName = ax._name;
      var axLetter = axName.charAt(0);
      var axId = ax._id;
      var axLayer = _this.layers[axName];
      var counterAngle = 30;
  
      var stashKey = axLetter + 'tickLayout';
      var newTickLayout = strTickLayout(ax);
      if(_this[stashKey] !== newTickLayout) {
          axLayer.selectAll('.' + axId + 'tick').remove();
          _this[stashKey] = newTickLayout;
      }
  
      ax.setScale();
  
      var vals = Axes.calcTicks(ax);
      var valsClipped = Axes.clipEnds(ax, vals);
      var transFn = Axes.makeTransFn(ax);
      var tickSign = Axes.getTickSigns(ax)[2];
  
      var caRad = Lib.deg2rad(counterAngle);
      var pad = tickSign * (ax.linewidth || 1) / 2;
      var len = tickSign * ax.ticklen;
      var w = _this.w;
      var h = _this.h;
  
      var tickPath = axLetter === 'b' ?
          'M0,' + pad + 'l' + (Math.sin(caRad) * len) + ',' + (Math.cos(caRad) * len) :
          'M' + pad + ',0l' + (Math.cos(caRad) * len) + ',' + (-Math.sin(caRad) * len);
  
      var gridPath = {
          a: 'M0,0l' + h + ',-' + (w / 2),
          b: 'M0,0l-' + (w / 2) + ',-' + h,
          c: 'M0,0l-' + h + ',' + (w / 2)
      }[axLetter];
  
      Axes.drawTicks(gd, ax, {
          vals: ax.ticks === 'inside' ? valsClipped : vals,
          layer: axLayer,
          path: tickPath,
          transFn: transFn,
          crisp: false
      });
  
      Axes.drawGrid(gd, ax, {
          vals: valsClipped,
          layer: _this.layers[axLetter + 'grid'],
          path: gridPath,
          transFn: transFn,
          crisp: false
      });
  
      Axes.drawLabels(gd, ax, {
          vals: vals,
          layer: axLayer,
          transFn: transFn,
          labelFns: Axes.makeLabelFns(ax, 0, counterAngle)
      });
  };
  
  function strTickLayout(axLayout) {
      return axLayout.ticks + String(axLayout.ticklen) + String(axLayout.showticklabels);
  }
  
  // hard coded paths for zoom corners
  // uses the same sizing as cartesian, length is MINZOOM/2, width is 3px
  var CLEN = constants.MINZOOM / 2 + 0.87;
  var BLPATH = 'm-0.87,.5h' + CLEN + 'v3h-' + (CLEN + 5.2) +
      'l' + (CLEN / 2 + 2.6) + ',-' + (CLEN * 0.87 + 4.5) +
      'l2.6,1.5l-' + (CLEN / 2) + ',' + (CLEN * 0.87) + 'Z';
  var BRPATH = 'm0.87,.5h-' + CLEN + 'v3h' + (CLEN + 5.2) +
      'l-' + (CLEN / 2 + 2.6) + ',-' + (CLEN * 0.87 + 4.5) +
      'l-2.6,1.5l' + (CLEN / 2) + ',' + (CLEN * 0.87) + 'Z';
  var TOPPATH = 'm0,1l' + (CLEN / 2) + ',' + (CLEN * 0.87) +
      'l2.6,-1.5l-' + (CLEN / 2 + 2.6) + ',-' + (CLEN * 0.87 + 4.5) +
      'l-' + (CLEN / 2 + 2.6) + ',' + (CLEN * 0.87 + 4.5) +
      'l2.6,1.5l' + (CLEN / 2) + ',-' + (CLEN * 0.87) + 'Z';
  var STARTMARKER = 'm0.5,0.5h5v-2h-5v-5h-2v5h-5v2h5v5h2Z';
  
  // I guess this could be shared with cartesian... but for now it's separate.
  var SHOWZOOMOUTTIP = true;
  
  proto.clearSelect = function() {
      clearSelectionsCache(this.dragOptions);
      clearSelect(this.dragOptions.gd);
  };
  
  proto.initInteractions = function() {
      var _this = this;
      var dragger = _this.layers.plotbg.select('path').node();
      var gd = _this.graphDiv;
      var zoomLayer = gd._fullLayout._zoomlayer;
  
      // use plotbg for the main interactions
      this.dragOptions = {
          element: dragger,
          gd: gd,
          plotinfo: {
              id: _this.id,
              domain: gd._fullLayout[_this.id].domain,
              xaxis: _this.xaxis,
              yaxis: _this.yaxis
          },
          subplot: _this.id,
          prepFn: function(e, startX, startY) {
              // these aren't available yet when initInteractions
              // is called
              _this.dragOptions.xaxes = [_this.xaxis];
              _this.dragOptions.yaxes = [_this.yaxis];
  
              var dragModeNow = _this.dragOptions.dragmode = gd._fullLayout.dragmode;
  
              if(freeMode(dragModeNow)) _this.dragOptions.minDrag = 1;
              else _this.dragOptions.minDrag = undefined;
  
              if(dragModeNow === 'zoom') {
                  _this.dragOptions.moveFn = zoomMove;
                  _this.dragOptions.clickFn = clickZoomPan;
                  _this.dragOptions.doneFn = zoomDone;
                  zoomPrep(e, startX, startY);
              } else if(dragModeNow === 'pan') {
                  _this.dragOptions.moveFn = plotDrag;
                  _this.dragOptions.clickFn = clickZoomPan;
                  _this.dragOptions.doneFn = dragDone;
                  panPrep();
                  _this.clearSelect(gd);
              } else if(rectMode(dragModeNow) || freeMode(dragModeNow)) {
                  prepSelect(e, startX, startY, _this.dragOptions, dragModeNow);
              }
          }
      };
  
      var x0, y0, mins0, span0, mins, lum, path0, dimmed, zb, corners;
  
      function makeUpdate(_mins) {
          var attrs = {};
          attrs[_this.id + '.aaxis.min'] = _mins.a;
          attrs[_this.id + '.baxis.min'] = _mins.b;
          attrs[_this.id + '.caxis.min'] = _mins.c;
          return attrs;
      }
  
      function clickZoomPan(numClicks, evt) {
          var clickMode = gd._fullLayout.clickmode;
  
          removeZoombox(gd);
  
          if(numClicks === 2) {
              gd.emit('plotly_doubleclick', null);
              Registry.call('_guiRelayout', gd, makeUpdate({a: 0, b: 0, c: 0}));
          }
  
          if(clickMode.indexOf('select') > -1 && numClicks === 1) {
              selectOnClick(evt, gd, [_this.xaxis], [_this.yaxis], _this.id, _this.dragOptions);
          }
  
          if(clickMode.indexOf('event') > -1) {
              Fx.click(gd, evt, _this.id);
          }
      }
  
      function zoomPrep(e, startX, startY) {
          var dragBBox = dragger.getBoundingClientRect();
          x0 = startX - dragBBox.left;
          y0 = startY - dragBBox.top;
          mins0 = {
              a: _this.aaxis.range[0],
              b: _this.baxis.range[1],
              c: _this.caxis.range[1]
          };
          mins = mins0;
          span0 = _this.aaxis.range[1] - mins0.a;
          lum = tinycolor(_this.graphDiv._fullLayout[_this.id].bgcolor).getLuminance();
          path0 = 'M0,' + _this.h + 'L' + (_this.w / 2) + ', 0L' + _this.w + ',' + _this.h + 'Z';
          dimmed = false;
  
          zb = zoomLayer.append('path')
              .attr('class', 'zoombox')
              .attr('transform', 'translate(' + _this.x0 + ', ' + _this.y0 + ')')
              .style({
                  'fill': lum > 0.2 ? 'rgba(0,0,0,0)' : 'rgba(255,255,255,0)',
                  'stroke-width': 0
              })
              .attr('d', path0);
  
          corners = zoomLayer.append('path')
              .attr('class', 'zoombox-corners')
              .attr('transform', 'translate(' + _this.x0 + ', ' + _this.y0 + ')')
              .style({
                  fill: Color.background,
                  stroke: Color.defaultLine,
                  'stroke-width': 1,
                  opacity: 0
              })
              .attr('d', 'M0,0Z');
  
          _this.clearSelect(gd);
      }
  
      function getAFrac(x, y) { return 1 - (y / _this.h); }
      function getBFrac(x, y) { return 1 - ((x + (_this.h - y) / Math.sqrt(3)) / _this.w); }
      function getCFrac(x, y) { return ((x - (_this.h - y) / Math.sqrt(3)) / _this.w); }
  
      function zoomMove(dx0, dy0) {
          var x1 = x0 + dx0;
          var y1 = y0 + dy0;
          var afrac = Math.max(0, Math.min(1, getAFrac(x0, y0), getAFrac(x1, y1)));
          var bfrac = Math.max(0, Math.min(1, getBFrac(x0, y0), getBFrac(x1, y1)));
          var cfrac = Math.max(0, Math.min(1, getCFrac(x0, y0), getCFrac(x1, y1)));
          var xLeft = ((afrac / 2) + cfrac) * _this.w;
          var xRight = (1 - (afrac / 2) - bfrac) * _this.w;
          var xCenter = (xLeft + xRight) / 2;
          var xSpan = xRight - xLeft;
          var yBottom = (1 - afrac) * _this.h;
          var yTop = yBottom - xSpan / whRatio;
  
          if(xSpan < constants.MINZOOM) {
              mins = mins0;
              zb.attr('d', path0);
              corners.attr('d', 'M0,0Z');
          } else {
              mins = {
                  a: mins0.a + afrac * span0,
                  b: mins0.b + bfrac * span0,
                  c: mins0.c + cfrac * span0
              };
              zb.attr('d', path0 + 'M' + xLeft + ',' + yBottom +
                  'H' + xRight + 'L' + xCenter + ',' + yTop +
                  'L' + xLeft + ',' + yBottom + 'Z');
              corners.attr('d', 'M' + x0 + ',' + y0 + STARTMARKER +
                  'M' + xLeft + ',' + yBottom + BLPATH +
                  'M' + xRight + ',' + yBottom + BRPATH +
                  'M' + xCenter + ',' + yTop + TOPPATH);
          }
  
          if(!dimmed) {
              zb.transition()
                  .style('fill', lum > 0.2 ? 'rgba(0,0,0,0.4)' :
                      'rgba(255,255,255,0.3)')
                  .duration(200);
              corners.transition()
                  .style('opacity', 1)
                  .duration(200);
              dimmed = true;
          }
  
          gd.emit('plotly_relayouting', makeUpdate(mins));
      }
  
      function zoomDone() {
          removeZoombox(gd);
  
          if(mins === mins0) return;
  
          Registry.call('_guiRelayout', gd, makeUpdate(mins));
  
          if(SHOWZOOMOUTTIP && gd.data && gd._context.showTips) {
              Lib.notifier(_(gd, 'Double-click to zoom back out'), 'long');
              SHOWZOOMOUTTIP = false;
          }
      }
  
      function panPrep() {
          mins0 = {
              a: _this.aaxis.range[0],
              b: _this.baxis.range[1],
              c: _this.caxis.range[1]
          };
          mins = mins0;
      }
  
      function plotDrag(dx, dy) {
          var dxScaled = dx / _this.xaxis._m;
          var dyScaled = dy / _this.yaxis._m;
          mins = {
              a: mins0.a - dyScaled,
              b: mins0.b + (dxScaled + dyScaled) / 2,
              c: mins0.c - (dxScaled - dyScaled) / 2
          };
          var minsorted = [mins.a, mins.b, mins.c].sort(Lib.sorterAsc);
          var minindices = {
              a: minsorted.indexOf(mins.a),
              b: minsorted.indexOf(mins.b),
              c: minsorted.indexOf(mins.c)
          };
          if(minsorted[0] < 0) {
              if(minsorted[1] + minsorted[0] / 2 < 0) {
                  minsorted[2] += minsorted[0] + minsorted[1];
                  minsorted[0] = minsorted[1] = 0;
              } else {
                  minsorted[2] += minsorted[0] / 2;
                  minsorted[1] += minsorted[0] / 2;
                  minsorted[0] = 0;
              }
              mins = {
                  a: minsorted[minindices.a],
                  b: minsorted[minindices.b],
                  c: minsorted[minindices.c]
              };
              dy = (mins0.a - mins.a) * _this.yaxis._m;
              dx = (mins0.c - mins.c - mins0.b + mins.b) * _this.xaxis._m;
          }
  
          // move the data (translate, don't redraw)
          var plotTransform = 'translate(' + (_this.x0 + dx) + ',' + (_this.y0 + dy) + ')';
          _this.plotContainer.selectAll('.scatterlayer,.maplayer')
              .attr('transform', plotTransform);
  
          var plotTransform2 = 'translate(' + -dx + ',' + -dy + ')';
          _this.clipDefRelative.select('path').attr('transform', plotTransform2);
  
          // move the ticks
          _this.aaxis.range = [mins.a, _this.sum - mins.b - mins.c];
          _this.baxis.range = [_this.sum - mins.a - mins.c, mins.b];
          _this.caxis.range = [_this.sum - mins.a - mins.b, mins.c];
  
          _this.drawAxes(false);
  
          if(_this._hasClipOnAxisFalse) {
              _this.plotContainer
                  .select('.scatterlayer').selectAll('.trace')
                  .call(Drawing.hideOutsideRangePoints, _this);
          }
  
          gd.emit('plotly_relayouting', makeUpdate(mins));
      }
  
      function dragDone() {
          Registry.call('_guiRelayout', gd, makeUpdate(mins));
      }
  
      // finally, set up hover and click
      // these event handlers must already be set before dragElement.init
      // so it can stash them and override them.
      dragger.onmousemove = function(evt) {
          Fx.hover(gd, evt, _this.id);
          gd._fullLayout._lasthover = dragger;
          gd._fullLayout._hoversubplot = _this.id;
      };
  
      dragger.onmouseout = function(evt) {
          if(gd._dragging) return;
  
          dragElement.unhover(gd, evt);
      };
  
      dragElement.init(this.dragOptions);
  };
  
  function removeZoombox(gd) {
      d3.select(gd)
          .selectAll('.zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners')
          .remove();
  }
  
  },{"../../components/color":615,"../../components/dragelement":634,"../../components/dragelement/helpers":633,"../../components/drawing":637,"../../components/fx":655,"../../components/titles":710,"../../lib":750,"../../lib/extend":740,"../../registry":882,"../cartesian/axes":799,"../cartesian/constants":805,"../cartesian/select":818,"../cartesian/set_convert":819,"../plots":862,"d3":169,"tinycolor2":548}],882:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Loggers = _dereq_('./lib/loggers');
  var noop = _dereq_('./lib/noop');
  var pushUnique = _dereq_('./lib/push_unique');
  var isPlainObject = _dereq_('./lib/is_plain_object');
  var addStyleRule = _dereq_('./lib/dom').addStyleRule;
  var ExtendModule = _dereq_('./lib/extend');
  
  var basePlotAttributes = _dereq_('./plots/attributes');
  var baseLayoutAttributes = _dereq_('./plots/layout_attributes');
  
  var extendFlat = ExtendModule.extendFlat;
  var extendDeepAll = ExtendModule.extendDeepAll;
  
  exports.modules = {};
  exports.allCategories = {};
  exports.allTypes = [];
  exports.subplotsRegistry = {};
  exports.transformsRegistry = {};
  exports.componentsRegistry = {};
  exports.layoutArrayContainers = [];
  exports.layoutArrayRegexes = [];
  exports.traceLayoutAttributes = {};
  exports.localeRegistry = {};
  exports.apiMethodRegistry = {};
  exports.collectableSubplotTypes = null;
  
  /**
   * Top-level register routine, exported as Plotly.register
   *
   * @param {object array or array of objects} _modules :
   *  module object or list of module object to register.
   *
   *  A valid `moduleType: 'trace'` module has fields:
   *  - name {string} : the trace type
   *  - categories {array} : categories associated with this trace type,
   *                         tested with Register.traceIs()
   *  - meta {object} : meta info (mostly for plot-schema)
   *
   *  A valid `moduleType: 'locale'` module has fields:
   *  - name {string} : the locale name. Should be a 2-digit language string ('en', 'de')
   *                    optionally with a country/region code ('en-GB', 'de-CH'). If a country
   *                    code is used but the base language locale has not yet been supplied,
   *                    we will use this locale for the base as well.
   *  - dictionary {object} : the dictionary mapping input strings to localized strings
   *                          generally the keys should be the literal input strings, but
   *                          if default translations are provided you can use any string as a key.
   *  - format {object} : a `d3.locale` format specifier for this locale
   *                      any omitted keys we'll fall back on en-US.
   *
   *  A valid `moduleType: 'transform'` module has fields:
   *  - name {string} : transform name
   *  - transform {function} : default-level transform function
   *  - calcTransform {function} : calc-level transform function
   *  - attributes {object} : transform attributes declarations
   *  - supplyDefaults {function} : attributes default-supply function
   *
   *  A valid `moduleType: 'component'` module has fields:
   *  - name {string} : the component name, used it with Register.getComponentMethod()
   *                    to employ component method.
   *
   *  A valid `moduleType: 'apiMethod'` module has fields:
   *  - name {string} : the api method name.
   *  - fn {function} : the api method called with Register.call();
   *
   */
  exports.register = function register(_modules) {
      exports.collectableSubplotTypes = null;
  
      if(!_modules) {
          throw new Error('No argument passed to Plotly.register.');
      } else if(_modules && !Array.isArray(_modules)) {
          _modules = [_modules];
      }
  
      for(var i = 0; i < _modules.length; i++) {
          var newModule = _modules[i];
  
          if(!newModule) {
              throw new Error('Invalid module was attempted to be registered!');
          }
  
          switch(newModule.moduleType) {
              case 'trace':
                  registerTraceModule(newModule);
                  break;
              case 'transform':
                  registerTransformModule(newModule);
                  break;
              case 'component':
                  registerComponentModule(newModule);
                  break;
              case 'locale':
                  registerLocale(newModule);
                  break;
              case 'apiMethod':
                  var name = newModule.name;
                  exports.apiMethodRegistry[name] = newModule.fn;
                  break;
              default:
                  throw new Error('Invalid module was attempted to be registered!');
          }
      }
  };
  
  /**
   * Get registered module using trace object or trace type
   *
   * @param {object||string} trace
   *  trace object with prop 'type' or trace type as a string
   * @return {object}
   *  module object corresponding to trace type
   */
  exports.getModule = function(trace) {
      var _module = exports.modules[getTraceType(trace)];
      if(!_module) return false;
      return _module._module;
  };
  
  /**
   * Determine if this trace type is in a given category
   *
   * @param {object||string} traceType
   *  a trace (object) or trace type (string)
   * @param {string} category
   *  category in question
   * @return {boolean}
   */
  exports.traceIs = function(traceType, category) {
      traceType = getTraceType(traceType);
  
      // old Chart Studio Cloud workspace hack, nothing to see here
      if(traceType === 'various') return false;
  
      var _module = exports.modules[traceType];
  
      if(!_module) {
          if(traceType && traceType !== 'area') {
              Loggers.log('Unrecognized trace type ' + traceType + '.');
          }
  
          _module = exports.modules[basePlotAttributes.type.dflt];
      }
  
      return !!_module.categories[category];
  };
  
  /**
   * Determine if this trace has a transform of the given type and return
   * array of matching indices.
   *
   * @param {object} data
   *  a trace object (member of data or fullData)
   * @param {string} type
   *  type of trace to test
   * @return {array}
   *  array of matching indices. If none found, returns []
   */
  exports.getTransformIndices = function(data, type) {
      var indices = [];
      var transforms = data.transforms || [];
      for(var i = 0; i < transforms.length; i++) {
          if(transforms[i].type === type) {
              indices.push(i);
          }
      }
      return indices;
  };
  
  /**
   * Determine if this trace has a transform of the given type
   *
   * @param {object} data
   *  a trace object (member of data or fullData)
   * @param {string} type
   *  type of trace to test
   * @return {boolean}
   */
  exports.hasTransform = function(data, type) {
      var transforms = data.transforms || [];
      for(var i = 0; i < transforms.length; i++) {
          if(transforms[i].type === type) {
              return true;
          }
      }
      return false;
  };
  
  /**
   * Retrieve component module method. Falls back on noop if either the
   * module or the method is missing, so the result can always be safely called
   *
   * @param {string} name
   *  name of component (as declared in component module)
   * @param {string} method
   *  name of component module method
   * @return {function}
   */
  exports.getComponentMethod = function(name, method) {
      var _module = exports.componentsRegistry[name];
  
      if(!_module) return noop;
      return _module[method] || noop;
  };
  
  /**
   * Call registered api method.
   *
   * @param {string} name : api method name
   * @param {...array} args : arguments passed to api method
   * @return {any} : returns api method output
   */
  exports.call = function() {
      var name = arguments[0];
      var args = [].slice.call(arguments, 1);
      return exports.apiMethodRegistry[name].apply(null, args);
  };
  
  function registerTraceModule(_module) {
      var thisType = _module.name;
      var categoriesIn = _module.categories;
      var meta = _module.meta;
  
      if(exports.modules[thisType]) {
          Loggers.log('Type ' + thisType + ' already registered');
          return;
      }
  
      if(!exports.subplotsRegistry[_module.basePlotModule.name]) {
          registerSubplot(_module.basePlotModule);
      }
  
      var categoryObj = {};
      for(var i = 0; i < categoriesIn.length; i++) {
          categoryObj[categoriesIn[i]] = true;
          exports.allCategories[categoriesIn[i]] = true;
      }
  
      exports.modules[thisType] = {
          _module: _module,
          categories: categoryObj
      };
  
      if(meta && Object.keys(meta).length) {
          exports.modules[thisType].meta = meta;
      }
  
      exports.allTypes.push(thisType);
  
      for(var componentName in exports.componentsRegistry) {
          mergeComponentAttrsToTrace(componentName, thisType);
      }
  
      /*
       * Collect all trace layout attributes in one place for easier lookup later
       * but don't merge them into the base schema as it would confuse the docs
       * (at least after https://github.com/plotly/documentation/issues/202 gets done!)
       */
      if(_module.layoutAttributes) {
          extendFlat(exports.traceLayoutAttributes, _module.layoutAttributes);
      }
  
      var basePlotModule = _module.basePlotModule;
      var bpmName = basePlotModule.name;
  
      // add mapbox-gl CSS here to avoid console warning on instantiation
      if(bpmName === 'mapbox') {
          var styleRules = basePlotModule.constants.styleRules;
          for(var k in styleRules) {
              addStyleRule('.js-plotly-plot .plotly .mapboxgl-' + k, styleRules[k]);
          }
      }
  
      // if `plotly-geo-assets.js` is not included,
      // add `PlotlyGeoAssets` global to stash references to all fetched
      // topojson / geojson data
      if((bpmName === 'geo' || bpmName === 'mapbox') &&
          (typeof window !== undefined && window.PlotlyGeoAssets === undefined)
      ) {
          window.PlotlyGeoAssets = {topojson: {}};
      }
  }
  
  function registerSubplot(_module) {
      var plotType = _module.name;
  
      if(exports.subplotsRegistry[plotType]) {
          Loggers.log('Plot type ' + plotType + ' already registered.');
          return;
      }
  
      // relayout array handling will look for component module methods with this
      // name and won't find them because this is a subplot module... but that
      // should be fine, it will just fall back on redrawing the plot.
      findArrayRegexps(_module);
  
      // not sure what's best for the 'cartesian' type at this point
      exports.subplotsRegistry[plotType] = _module;
  
      for(var componentName in exports.componentsRegistry) {
          mergeComponentAttrsToSubplot(componentName, _module.name);
      }
  }
  
  function registerComponentModule(_module) {
      if(typeof _module.name !== 'string') {
          throw new Error('Component module *name* must be a string.');
      }
  
      var name = _module.name;
      exports.componentsRegistry[name] = _module;
  
      if(_module.layoutAttributes) {
          if(_module.layoutAttributes._isLinkedToArray) {
              pushUnique(exports.layoutArrayContainers, name);
          }
          findArrayRegexps(_module);
      }
  
      for(var traceType in exports.modules) {
          mergeComponentAttrsToTrace(name, traceType);
      }
  
      for(var subplotName in exports.subplotsRegistry) {
          mergeComponentAttrsToSubplot(name, subplotName);
      }
  
      for(var transformType in exports.transformsRegistry) {
          mergeComponentAttrsToTransform(name, transformType);
      }
  
      if(_module.schema && _module.schema.layout) {
          extendDeepAll(baseLayoutAttributes, _module.schema.layout);
      }
  }
  
  function registerTransformModule(_module) {
      if(typeof _module.name !== 'string') {
          throw new Error('Transform module *name* must be a string.');
      }
  
      var prefix = 'Transform module ' + _module.name;
      var hasTransform = typeof _module.transform === 'function';
      var hasCalcTransform = typeof _module.calcTransform === 'function';
  
      if(!hasTransform && !hasCalcTransform) {
          throw new Error(prefix + ' is missing a *transform* or *calcTransform* method.');
      }
      if(hasTransform && hasCalcTransform) {
          Loggers.log([
              prefix + ' has both a *transform* and *calcTransform* methods.',
              'Please note that all *transform* methods are executed',
              'before all *calcTransform* methods.'
          ].join(' '));
      }
      if(!isPlainObject(_module.attributes)) {
          Loggers.log(prefix + ' registered without an *attributes* object.');
      }
      if(typeof _module.supplyDefaults !== 'function') {
          Loggers.log(prefix + ' registered without a *supplyDefaults* method.');
      }
  
      exports.transformsRegistry[_module.name] = _module;
  
      for(var componentName in exports.componentsRegistry) {
          mergeComponentAttrsToTransform(componentName, _module.name);
      }
  }
  
  function registerLocale(_module) {
      var locale = _module.name;
      var baseLocale = locale.split('-')[0];
  
      var newDict = _module.dictionary;
      var newFormat = _module.format;
      var hasDict = newDict && Object.keys(newDict).length;
      var hasFormat = newFormat && Object.keys(newFormat).length;
  
      var locales = exports.localeRegistry;
  
      var localeObj = locales[locale];
      if(!localeObj) locales[locale] = localeObj = {};
  
      // Should we use this dict for the base locale?
      // In case we're overwriting a previous dict for this locale, check
      // whether the base matches the full locale dict now. If we're not
      // overwriting, locales[locale] is undefined so this just checks if
      // baseLocale already had a dict or not.
      // Same logic for dateFormats
      if(baseLocale !== locale) {
          var baseLocaleObj = locales[baseLocale];
          if(!baseLocaleObj) locales[baseLocale] = baseLocaleObj = {};
  
          if(hasDict && baseLocaleObj.dictionary === localeObj.dictionary) {
              baseLocaleObj.dictionary = newDict;
          }
          if(hasFormat && baseLocaleObj.format === localeObj.format) {
              baseLocaleObj.format = newFormat;
          }
      }
  
      if(hasDict) localeObj.dictionary = newDict;
      if(hasFormat) localeObj.format = newFormat;
  }
  
  function findArrayRegexps(_module) {
      if(_module.layoutAttributes) {
          var arrayAttrRegexps = _module.layoutAttributes._arrayAttrRegexps;
          if(arrayAttrRegexps) {
              for(var i = 0; i < arrayAttrRegexps.length; i++) {
                  pushUnique(exports.layoutArrayRegexes, arrayAttrRegexps[i]);
              }
          }
      }
  }
  
  function mergeComponentAttrsToTrace(componentName, traceType) {
      var componentSchema = exports.componentsRegistry[componentName].schema;
      if(!componentSchema || !componentSchema.traces) return;
  
      var traceAttrs = componentSchema.traces[traceType];
      if(traceAttrs) {
          extendDeepAll(exports.modules[traceType]._module.attributes, traceAttrs);
      }
  }
  
  function mergeComponentAttrsToTransform(componentName, transformType) {
      var componentSchema = exports.componentsRegistry[componentName].schema;
      if(!componentSchema || !componentSchema.transforms) return;
  
      var transformAttrs = componentSchema.transforms[transformType];
      if(transformAttrs) {
          extendDeepAll(exports.transformsRegistry[transformType].attributes, transformAttrs);
      }
  }
  
  function mergeComponentAttrsToSubplot(componentName, subplotName) {
      var componentSchema = exports.componentsRegistry[componentName].schema;
      if(!componentSchema || !componentSchema.subplots) return;
  
      var subplotModule = exports.subplotsRegistry[subplotName];
      var subplotAttrs = subplotModule.layoutAttributes;
      var subplotAttr = subplotModule.attr === 'subplot' ? subplotModule.name : subplotModule.attr;
      if(Array.isArray(subplotAttr)) subplotAttr = subplotAttr[0];
  
      var componentLayoutAttrs = componentSchema.subplots[subplotAttr];
      if(subplotAttrs && componentLayoutAttrs) {
          extendDeepAll(subplotAttrs, componentLayoutAttrs);
      }
  }
  
  function getTraceType(traceType) {
      if(typeof traceType === 'object') traceType = traceType.type;
      return traceType;
  }
  
  },{"./lib/dom":738,"./lib/extend":740,"./lib/is_plain_object":751,"./lib/loggers":754,"./lib/noop":759,"./lib/push_unique":764,"./plots/attributes":795,"./plots/layout_attributes":853}],883:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../registry');
  var Lib = _dereq_('../lib');
  
  var extendFlat = Lib.extendFlat;
  var extendDeep = Lib.extendDeep;
  
  // Put default plotTile layouts here
  function cloneLayoutOverride(tileClass) {
      var override;
  
      switch(tileClass) {
          case 'themes__thumb':
              override = {
                  autosize: true,
                  width: 150,
                  height: 150,
                  title: {text: ''},
                  showlegend: false,
                  margin: {l: 5, r: 5, t: 5, b: 5, pad: 0},
                  annotations: []
              };
              break;
  
          case 'thumbnail':
              override = {
                  title: {text: ''},
                  hidesources: true,
                  showlegend: false,
                  borderwidth: 0,
                  bordercolor: '',
                  margin: {l: 1, r: 1, t: 1, b: 1, pad: 0},
                  annotations: []
              };
              break;
  
          default:
              override = {};
      }
  
  
      return override;
  }
  
  function keyIsAxis(keyName) {
      var types = ['xaxis', 'yaxis', 'zaxis'];
      return (types.indexOf(keyName.slice(0, 5)) > -1);
  }
  
  
  module.exports = function clonePlot(graphObj, options) {
      // Polar plot compatibility
      if(graphObj.framework && graphObj.framework.isPolar) {
          graphObj = graphObj.framework.getConfig();
      }
  
      var i;
      var oldData = graphObj.data;
      var oldLayout = graphObj.layout;
      var newData = extendDeep([], oldData);
      var newLayout = extendDeep({}, oldLayout, cloneLayoutOverride(options.tileClass));
      var context = graphObj._context || {};
  
      if(options.width) newLayout.width = options.width;
      if(options.height) newLayout.height = options.height;
  
      if(options.tileClass === 'thumbnail' || options.tileClass === 'themes__thumb') {
          // kill annotations
          newLayout.annotations = [];
          var keys = Object.keys(newLayout);
  
          for(i = 0; i < keys.length; i++) {
              if(keyIsAxis(keys[i])) {
                  newLayout[keys[i]].title = {text: ''};
              }
          }
  
          // kill colorbar and pie labels
          for(i = 0; i < newData.length; i++) {
              var trace = newData[i];
              trace.showscale = false;
              if(trace.marker) trace.marker.showscale = false;
              if(Registry.traceIs(trace, 'pie-like')) trace.textposition = 'none';
          }
      }
  
      if(Array.isArray(options.annotations)) {
          for(i = 0; i < options.annotations.length; i++) {
              newLayout.annotations.push(options.annotations[i]);
          }
      }
  
      // TODO: does this scene modification really belong here?
      // If we still need it, can it move into the gl3d module?
      var sceneIds = Object.keys(newLayout).filter(function(key) {
          return key.match(/^scene\d*$/);
      });
      if(sceneIds.length) {
          var axesImageOverride = {};
          if(options.tileClass === 'thumbnail') {
              axesImageOverride = {
                  title: {text: ''},
                  showaxeslabels: false,
                  showticklabels: false,
                  linetickenable: false
              };
          }
          for(i = 0; i < sceneIds.length; i++) {
              var scene = newLayout[sceneIds[i]];
  
              if(!scene.xaxis) {
                  scene.xaxis = {};
              }
  
              if(!scene.yaxis) {
                  scene.yaxis = {};
              }
  
              if(!scene.zaxis) {
                  scene.zaxis = {};
              }
  
              extendFlat(scene.xaxis, axesImageOverride);
              extendFlat(scene.yaxis, axesImageOverride);
              extendFlat(scene.zaxis, axesImageOverride);
  
              // TODO what does this do?
              scene._scene = null;
          }
      }
  
      var gd = document.createElement('div');
      if(options.tileClass) gd.className = options.tileClass;
  
      var plotTile = {
          gd: gd,
          td: gd, // for external (image server) compatibility
          layout: newLayout,
          data: newData,
          config: {
              staticPlot: (options.staticPlot === undefined) ?
                  true :
                  options.staticPlot,
              plotGlPixelRatio: (options.plotGlPixelRatio === undefined) ?
                  2 :
                  options.plotGlPixelRatio,
              displaylogo: options.displaylogo || false,
              showLink: options.showLink || false,
              showTips: options.showTips || false,
              mapboxAccessToken: context.mapboxAccessToken
          }
      };
  
      if(options.setBackground !== 'transparent') {
          plotTile.config.setBackground = options.setBackground || 'opaque';
      }
  
      // attaching the default Layout the gd, so you can grab it later
      plotTile.gd.defaultLayout = cloneLayoutOverride(options.tileClass);
  
      return plotTile;
  };
  
  },{"../lib":750,"../registry":882}],884:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  
  var toImage = _dereq_('../plot_api/to_image');
  
  var fileSaver = _dereq_('./filesaver');
  var helpers = _dereq_('./helpers');
  
  /**
   * Plotly.downloadImage
   *
   * @param {object | string | HTML div} gd
   *   can either be a data/layout/config object
   *   or an existing graph <div>
   *   or an id to an existing graph <div>
   * @param {object} opts (see Plotly.toImage in ../plot_api/to_image)
   * @return {promise}
   */
  function downloadImage(gd, opts) {
      var _gd;
      if(!Lib.isPlainObject(gd)) _gd = Lib.getGraphDiv(gd);
  
      opts = opts || {};
      opts.format = opts.format || 'png';
      opts.width = opts.width || null;
      opts.height = opts.height || null;
      opts.imageDataOnly = true;
  
      return new Promise(function(resolve, reject) {
          if(_gd && _gd._snapshotInProgress) {
              reject(new Error('Snapshotting already in progress.'));
          }
  
          // see comments within svgtoimg for additional
          //   discussion of problems with IE
          //   can now draw to canvas, but CORS tainted canvas
          //   does not allow toDataURL
          //   svg format will work though
          if(Lib.isIE() && opts.format !== 'svg') {
              reject(new Error(helpers.MSG_IE_BAD_FORMAT));
          }
  
          if(_gd) _gd._snapshotInProgress = true;
          var promise = toImage(gd, opts);
  
          var filename = opts.filename || gd.fn || 'newplot';
          filename += '.' + opts.format.replace('-', '.');
  
          promise.then(function(result) {
              if(_gd) _gd._snapshotInProgress = false;
              return fileSaver(result, filename, opts.format);
          }).then(function(name) {
              resolve(name);
          }).catch(function(err) {
              if(_gd) _gd._snapshotInProgress = false;
              reject(err);
          });
      });
  }
  
  module.exports = downloadImage;
  
  },{"../lib":750,"../plot_api/to_image":791,"./filesaver":885,"./helpers":886}],885:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var helpers = _dereq_('./helpers');
  
  /*
  * substantial portions of this code from FileSaver.js
  * https://github.com/eligrey/FileSaver.js
  * License: https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
  * FileSaver.js
  * A saveAs() FileSaver implementation.
  * 1.1.20160328
  *
  * By Eli Grey, http://eligrey.com
  * License: MIT
  *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
  */
  function fileSaver(url, name, format) {
      var saveLink = document.createElement('a');
      var canUseSaveLink = 'download' in saveLink;
  
      var promise = new Promise(function(resolve, reject) {
          var blob;
          var objectUrl;
  
          if(Lib.isIE9orBelow()) {
              reject(new Error('IE < 10 unsupported'));
          }
  
          // Safari doesn't allow downloading of blob urls
          if(Lib.isSafari()) {
              var prefix = format === 'svg' ? ',' : ';base64,';
              helpers.octetStream(prefix + encodeURIComponent(url));
              return resolve(name);
          }
  
          // IE 10+ (native saveAs)
          if(Lib.isIE()) {
              // At this point we are only dealing with a decoded SVG as
              // a data URL (since IE only supports SVG)
              blob = helpers.createBlob(url, 'svg');
              window.navigator.msSaveBlob(blob, name);
              blob = null;
              return resolve(name);
          }
  
          if(canUseSaveLink) {
              blob = helpers.createBlob(url, format);
              objectUrl = helpers.createObjectURL(blob);
  
              saveLink.href = objectUrl;
              saveLink.download = name;
              document.body.appendChild(saveLink);
              saveLink.click();
  
              document.body.removeChild(saveLink);
              helpers.revokeObjectURL(objectUrl);
              blob = null;
  
              return resolve(name);
          }
  
          reject(new Error('download error'));
      });
  
      return promise;
  }
  
  
  module.exports = fileSaver;
  
  },{"../lib":750,"./helpers":886}],886:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../registry');
  
  exports.getDelay = function(fullLayout) {
      if(!fullLayout._has) return 0;
  
      return (
          fullLayout._has('gl3d') ||
          fullLayout._has('gl2d') ||
          fullLayout._has('mapbox')
      ) ? 500 : 0;
  };
  
  exports.getRedrawFunc = function(gd) {
      return function() {
          var fullLayout = gd._fullLayout || {};
          var hasPolar = fullLayout._has && fullLayout._has('polar');
          var hasLegacyPolar = !hasPolar && gd.data && gd.data[0] && gd.data[0].r;
  
          if(!hasLegacyPolar) {
              Registry.getComponentMethod('colorbar', 'draw')(gd);
          }
      };
  };
  
  exports.encodeSVG = function(svg) {
      return 'data:image/svg+xml,' + encodeURIComponent(svg);
  };
  
  exports.encodeJSON = function(json) {
      return 'data:application/json,' + encodeURIComponent(json);
  };
  
  var DOM_URL = window.URL || window.webkitURL;
  
  exports.createObjectURL = function(blob) {
      return DOM_URL.createObjectURL(blob);
  };
  
  exports.revokeObjectURL = function(url) {
      return DOM_URL.revokeObjectURL(url);
  };
  
  exports.createBlob = function(url, format) {
      if(format === 'svg') {
          return new window.Blob([url], {type: 'image/svg+xml;charset=utf-8'});
      } else if(format === 'full-json') {
          return new window.Blob([url], {type: 'application/json;charset=utf-8'});
      } else {
          var binary = fixBinary(window.atob(url));
          return new window.Blob([binary], {type: 'image/' + format});
      }
  };
  
  exports.octetStream = function(s) {
      document.location.href = 'data:application/octet-stream' + s;
  };
  
  // Taken from https://bl.ocks.org/nolanlawson/0eac306e4dac2114c752
  function fixBinary(b) {
      var len = b.length;
      var buf = new ArrayBuffer(len);
      var arr = new Uint8Array(buf);
      for(var i = 0; i < len; i++) {
          arr[i] = b.charCodeAt(i);
      }
      return buf;
  }
  
  exports.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/;
  
  exports.MSG_IE_BAD_FORMAT = 'Sorry IE does not support downloading from canvas. Try {format:\'svg\'} instead.';
  
  },{"../registry":882}],887:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var helpers = _dereq_('./helpers');
  
  var Snapshot = {
      getDelay: helpers.getDelay,
      getRedrawFunc: helpers.getRedrawFunc,
      clone: _dereq_('./cloneplot'),
      toSVG: _dereq_('./tosvg'),
      svgToImg: _dereq_('./svgtoimg'),
      toImage: _dereq_('./toimage'),
      downloadImage: _dereq_('./download')
  };
  
  module.exports = Snapshot;
  
  },{"./cloneplot":883,"./download":884,"./helpers":886,"./svgtoimg":888,"./toimage":889,"./tosvg":890}],888:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var EventEmitter = _dereq_('events').EventEmitter;
  
  var helpers = _dereq_('./helpers');
  
  function svgToImg(opts) {
      var ev = opts.emitter || new EventEmitter();
  
      var promise = new Promise(function(resolve, reject) {
          var Image = window.Image;
          var svg = opts.svg;
          var format = opts.format || 'png';
  
          // IE only support svg
          if(Lib.isIE() && format !== 'svg') {
              var ieSvgError = new Error(helpers.MSG_IE_BAD_FORMAT);
              reject(ieSvgError);
              // eventually remove the ev
              //  in favor of promises
              if(!opts.promise) {
                  return ev.emit('error', ieSvgError);
              } else {
                  return promise;
              }
          }
  
          var canvas = opts.canvas;
          var scale = opts.scale || 1;
          var w0 = opts.width || 300;
          var h0 = opts.height || 150;
          var w1 = scale * w0;
          var h1 = scale * h0;
  
          var ctx = canvas.getContext('2d');
          var img = new Image();
          var svgBlob, url;
  
          if(format === 'svg' || Lib.isIE9orBelow() || Lib.isSafari()) {
              url = helpers.encodeSVG(svg);
          } else {
              svgBlob = helpers.createBlob(svg, 'svg');
              url = helpers.createObjectURL(svgBlob);
          }
  
          canvas.width = w1;
          canvas.height = h1;
  
          img.onload = function() {
              var imgData;
  
              svgBlob = null;
              helpers.revokeObjectURL(url);
  
              // don't need to draw to canvas if svg
              //  save some time and also avoid failure on IE
              if(format !== 'svg') {
                  ctx.drawImage(img, 0, 0, w1, h1);
              }
  
              switch(format) {
                  case 'jpeg':
                      imgData = canvas.toDataURL('image/jpeg');
                      break;
                  case 'png':
                      imgData = canvas.toDataURL('image/png');
                      break;
                  case 'webp':
                      imgData = canvas.toDataURL('image/webp');
                      break;
                  case 'svg':
                      imgData = url;
                      break;
                  default:
                      var errorMsg = 'Image format is not jpeg, png, svg or webp.';
                      reject(new Error(errorMsg));
                      // eventually remove the ev
                      //  in favor of promises
                      if(!opts.promise) {
                          return ev.emit('error', errorMsg);
                      }
              }
              resolve(imgData);
              // eventually remove the ev
              //  in favor of promises
              if(!opts.promise) {
                  ev.emit('success', imgData);
              }
          };
  
          img.onerror = function(err) {
              svgBlob = null;
              helpers.revokeObjectURL(url);
  
              reject(err);
              // eventually remove the ev
              //  in favor of promises
              if(!opts.promise) {
                  return ev.emit('error', err);
              }
          };
  
          img.src = url;
      });
  
      // temporary for backward compatibility
      //  move to only Promise in 2.0.0
      //  and eliminate the EventEmitter
      if(opts.promise) {
          return promise;
      }
  
      return ev;
  }
  
  module.exports = svgToImg;
  
  },{"../lib":750,"./helpers":886,"events":110}],889:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var EventEmitter = _dereq_('events').EventEmitter;
  
  var Registry = _dereq_('../registry');
  var Lib = _dereq_('../lib');
  
  var helpers = _dereq_('./helpers');
  var clonePlot = _dereq_('./cloneplot');
  var toSVG = _dereq_('./tosvg');
  var svgToImg = _dereq_('./svgtoimg');
  
  /**
   * @param {object} gd figure Object
   * @param {object} opts option object
   * @param opts.format 'jpeg' | 'png' | 'webp' | 'svg'
   */
  function toImage(gd, opts) {
      // first clone the GD so we can operate in a clean environment
      var ev = new EventEmitter();
  
      var clone = clonePlot(gd, {format: 'png'});
      var clonedGd = clone.gd;
  
      // put the cloned div somewhere off screen before attaching to DOM
      clonedGd.style.position = 'absolute';
      clonedGd.style.left = '-5000px';
      document.body.appendChild(clonedGd);
  
      function wait() {
          var delay = helpers.getDelay(clonedGd._fullLayout);
  
          setTimeout(function() {
              var svg = toSVG(clonedGd);
  
              var canvas = document.createElement('canvas');
              canvas.id = Lib.randstr();
  
              ev = svgToImg({
                  format: opts.format,
                  width: clonedGd._fullLayout.width,
                  height: clonedGd._fullLayout.height,
                  canvas: canvas,
                  emitter: ev,
                  svg: svg
              });
  
              ev.clean = function() {
                  if(clonedGd) document.body.removeChild(clonedGd);
              };
          }, delay);
      }
  
      var redrawFunc = helpers.getRedrawFunc(clonedGd);
  
      Registry.call('plot', clonedGd, clone.data, clone.layout, clone.config)
          .then(redrawFunc)
          .then(wait)
          .catch(function(err) {
              ev.emit('error', err);
          });
  
  
      return ev;
  }
  
  module.exports = toImage;
  
  },{"../lib":750,"../registry":882,"./cloneplot":883,"./helpers":886,"./svgtoimg":888,"./tosvg":890,"events":110}],890:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Lib = _dereq_('../lib');
  var Drawing = _dereq_('../components/drawing');
  var Color = _dereq_('../components/color');
  
  var xmlnsNamespaces = _dereq_('../constants/xmlns_namespaces');
  var DOUBLEQUOTE_REGEX = /"/g;
  var DUMMY_SUB = 'TOBESTRIPPED';
  var DUMMY_REGEX = new RegExp('("' + DUMMY_SUB + ')|(' + DUMMY_SUB + '")', 'g');
  
  function htmlEntityDecode(s) {
      var hiddenDiv = d3.select('body').append('div').style({display: 'none'}).html('');
      var replaced = s.replace(/(&[^;]*;)/gi, function(d) {
          if(d === '&lt;') { return '&#60;'; } // special handling for brackets
          if(d === '&rt;') { return '&#62;'; }
          if(d.indexOf('<') !== -1 || d.indexOf('>') !== -1) { return ''; }
          return hiddenDiv.html(d).text(); // everything else, let the browser decode it to unicode
      });
      hiddenDiv.remove();
      return replaced;
  }
  
  function xmlEntityEncode(str) {
      return str.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, '&amp;');
  }
  
  module.exports = function toSVG(gd, format, scale) {
      var fullLayout = gd._fullLayout;
      var svg = fullLayout._paper;
      var toppaper = fullLayout._toppaper;
      var width = fullLayout.width;
      var height = fullLayout.height;
      var i;
  
      // make background color a rect in the svg, then revert after scraping
      // all other alterations have been dealt with by properly preparing the svg
      // in the first place... like setting cursors with css classes so we don't
      // have to remove them, and providing the right namespaces in the svg to
      // begin with
      svg.insert('rect', ':first-child')
          .call(Drawing.setRect, 0, 0, width, height)
          .call(Color.fill, fullLayout.paper_bgcolor);
  
      // subplot-specific to-SVG methods
      // which notably add the contents of the gl-container
      // into the main svg node
      var basePlotModules = fullLayout._basePlotModules || [];
      for(i = 0; i < basePlotModules.length; i++) {
          var _module = basePlotModules[i];
  
          if(_module.toSVG) _module.toSVG(gd);
      }
  
      // add top items above them assumes everything in toppaper is either
      // a group or a defs, and if it's empty (like hoverlayer) we can ignore it.
      if(toppaper) {
          var nodes = toppaper.node().childNodes;
  
          // make copy of nodes as childNodes prop gets mutated in loop below
          var topGroups = Array.prototype.slice.call(nodes);
  
          for(i = 0; i < topGroups.length; i++) {
              var topGroup = topGroups[i];
  
              if(topGroup.childNodes.length) svg.node().appendChild(topGroup);
          }
      }
  
      // remove draglayer for Adobe Illustrator compatibility
      if(fullLayout._draggers) {
          fullLayout._draggers.remove();
      }
  
      // in case the svg element had an explicit background color, remove this
      // we want the rect to get the color so it's the right size; svg bg will
      // fill whatever container it's displayed in regardless of plot size.
      svg.node().style.background = '';
  
      svg.selectAll('text')
          .attr({'data-unformatted': null, 'data-math': null})
          .each(function() {
              var txt = d3.select(this);
  
              // hidden text is pre-formatting mathjax, the browser ignores it
              // but in a static plot it's useless and it can confuse batik
              // we've tried to standardize on display:none but make sure we still
              // catch visibility:hidden if it ever arises
              if(this.style.visibility === 'hidden' || this.style.display === 'none') {
                  txt.remove();
                  return;
              } else {
                  // clear other visibility/display values to default
                  // to not potentially confuse non-browser SVG implementations
                  txt.style({visibility: null, display: null});
              }
  
              // Font family styles break things because of quotation marks,
              // so we must remove them *after* the SVG DOM has been serialized
              // to a string (browsers convert singles back)
              var ff = this.style.fontFamily;
              if(ff && ff.indexOf('"') !== -1) {
                  txt.style('font-family', ff.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
              }
          });
  
  
      if(fullLayout._gradientUrlQueryParts) {
          var queryParts = [];
          for(var k in fullLayout._gradientUrlQueryParts) queryParts.push(k);
  
          if(queryParts.length) {
              svg.selectAll(queryParts.join(',')).each(function() {
                  var pt = d3.select(this);
  
                  // similar to font family styles above,
                  // we must remove " after the SVG DOM has been serialized
                  var fill = this.style.fill;
                  if(fill && fill.indexOf('url(') !== -1) {
                      pt.style('fill', fill.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
                  }
  
                  var stroke = this.style.stroke;
                  if(stroke && stroke.indexOf('url(') !== -1) {
                      pt.style('stroke', stroke.replace(DOUBLEQUOTE_REGEX, DUMMY_SUB));
                  }
              });
          }
      }
  
      if(format === 'pdf' || format === 'eps') {
          // these formats make the extra line MathJax adds around symbols look super thick in some cases
          // it looks better if this is removed entirely.
          svg.selectAll('#MathJax_SVG_glyphs path')
              .attr('stroke-width', 0);
      }
  
      // fix for IE namespacing quirk?
      // http://stackoverflow.com/questions/19610089/unwanted-namespaces-on-svg-markup-when-using-xmlserializer-in-javascript-with-ie
      svg.node().setAttributeNS(xmlnsNamespaces.xmlns, 'xmlns', xmlnsNamespaces.svg);
      svg.node().setAttributeNS(xmlnsNamespaces.xmlns, 'xmlns:xlink', xmlnsNamespaces.xlink);
  
      if(format === 'svg' && scale) {
          svg.attr('width', scale * width);
          svg.attr('height', scale * height);
          svg.attr('viewBox', '0 0 ' + width + ' ' + height);
      }
  
      var s = new window.XMLSerializer().serializeToString(svg.node());
      s = htmlEntityDecode(s);
      s = xmlEntityEncode(s);
  
      // Fix quotations around font strings and gradient URLs
      s = s.replace(DUMMY_REGEX, '\'');
  
      // IE is very strict, so we will need to clean
      //  svg with the following regex
      //  yes this is messy, but do not know a better way
      // Even with this IE will not work due to tainted canvas
      //  see https://github.com/kangax/fabric.js/issues/1957
      //      http://stackoverflow.com/questions/18112047/canvas-todataurl-working-in-all-browsers-except-ie10
      // Leave here just in case the CORS/tainted IE issue gets resolved
      if(Lib.isIE()) {
          // replace double quote with single quote
          s = s.replace(/"/gi, '\'');
          // url in svg are single quoted
          //   since we changed double to single
          //   we'll need to change these to double-quoted
          s = s.replace(/(\('#)([^']*)('\))/gi, '(\"#$2\")');
          // font names with spaces will be escaped single-quoted
          //   we'll need to change these to double-quoted
          s = s.replace(/(\\')/gi, '\"');
      }
  
      return s;
  };
  
  },{"../components/color":615,"../components/drawing":637,"../constants/xmlns_namespaces":726,"../lib":750,"d3":169}],891:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  // arrayOk attributes, merge them into calcdata array
  module.exports = function arraysToCalcdata(cd, trace) {
      for(var i = 0; i < cd.length; i++) cd[i].i = i;
  
      Lib.mergeArray(trace.text, cd, 'tx');
      Lib.mergeArray(trace.hovertext, cd, 'htx');
  
      var marker = trace.marker;
      if(marker) {
          Lib.mergeArray(marker.opacity, cd, 'mo', true);
          Lib.mergeArray(marker.color, cd, 'mc');
  
          var markerLine = marker.line;
          if(markerLine) {
              Lib.mergeArray(markerLine.color, cd, 'mlc');
              Lib.mergeArrayCastPositive(markerLine.width, cd, 'mlw');
          }
      }
  };
  
  },{"../../lib":750}],892:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterAttrs = _dereq_('../scatter/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var constants = _dereq_('./constants');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var textFontAttrs = fontAttrs({
      editType: 'calc',
      arrayOk: true,
      colorEditType: 'style',
      
  });
  
  var scatterMarkerAttrs = scatterAttrs.marker;
  var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
  
  var markerLineWidth = extendFlat({},
      scatterMarkerLineAttrs.width, { dflt: 0 });
  
  var markerLine = extendFlat({
      width: markerLineWidth,
      editType: 'calc'
  }, colorScaleAttrs('marker.line'));
  
  var marker = extendFlat({
      line: markerLine,
      editType: 'calc'
  }, colorScaleAttrs('marker'), {
      opacity: {
          valType: 'number',
          arrayOk: true,
          dflt: 1,
          min: 0,
          max: 1,
          
          editType: 'style',
          
      }
  });
  
  module.exports = {
      x: scatterAttrs.x,
      x0: scatterAttrs.x0,
      dx: scatterAttrs.dx,
      y: scatterAttrs.y,
      y0: scatterAttrs.y0,
      dy: scatterAttrs.dy,
  
      xperiod: scatterAttrs.xperiod,
      yperiod: scatterAttrs.yperiod,
      xperiod0: scatterAttrs.xperiod0,
      yperiod0: scatterAttrs.yperiod0,
      xperiodalignment: scatterAttrs.xperiodalignment,
      yperiodalignment: scatterAttrs.yperiodalignment,
  
      text: scatterAttrs.text,
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: constants.eventDataKeys
      }),
      hovertext: scatterAttrs.hovertext,
      hovertemplate: hovertemplateAttrs({}, {
          keys: constants.eventDataKeys
      }),
  
      textposition: {
          valType: 'enumerated',
          
          values: ['inside', 'outside', 'auto', 'none'],
          dflt: 'none',
          arrayOk: true,
          editType: 'calc',
          
      },
  
      insidetextanchor: {
          valType: 'enumerated',
          values: ['end', 'middle', 'start'],
          dflt: 'end',
          
          editType: 'plot',
          
      },
  
      textangle: {
          valType: 'angle',
          dflt: 'auto',
          
          editType: 'plot',
          
      },
  
      textfont: extendFlat({}, textFontAttrs, {
          
      }),
  
      insidetextfont: extendFlat({}, textFontAttrs, {
          
      }),
  
      outsidetextfont: extendFlat({}, textFontAttrs, {
          
      }),
  
      constraintext: {
          valType: 'enumerated',
          values: ['inside', 'outside', 'both', 'none'],
          
          dflt: 'both',
          editType: 'calc',
          
      },
  
      cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {
          
      }),
  
      orientation: {
          valType: 'enumerated',
          
          values: ['v', 'h'],
          editType: 'calc+clearAxisTypes',
          
      },
  
      base: {
          valType: 'any',
          dflt: null,
          arrayOk: true,
          
          editType: 'calc',
          
      },
  
      offset: {
          valType: 'number',
          dflt: null,
          arrayOk: true,
          
          editType: 'calc',
          
      },
  
      width: {
          valType: 'number',
          dflt: null,
          min: 0,
          arrayOk: true,
          
          editType: 'calc',
          
      },
  
      marker: marker,
  
      offsetgroup: {
          valType: 'string',
          
          dflt: '',
          editType: 'calc',
          
      },
      alignmentgroup: {
          valType: 'string',
          
          dflt: '',
          editType: 'calc',
          
      },
  
      selected: {
          marker: {
              opacity: scatterAttrs.selected.marker.opacity,
              color: scatterAttrs.selected.marker.color,
              editType: 'style'
          },
          textfont: scatterAttrs.selected.textfont,
          editType: 'style'
      },
      unselected: {
          marker: {
              opacity: scatterAttrs.unselected.marker.opacity,
              color: scatterAttrs.unselected.marker.color,
              editType: 'style'
          },
          textfont: scatterAttrs.unselected.textfont,
          editType: 'style'
      },
  
      r: scatterAttrs.r,
      t: scatterAttrs.t,
  
      _deprecated: {
          bardir: {
              valType: 'enumerated',
              
              editType: 'calc',
              values: ['v', 'h'],
              
          }
      }
  };
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/font_attributes":827,"../../plots/template_attributes":877,"../scatter/attributes":1158,"./constants":894}],893:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  var arraysToCalcdata = _dereq_('./arrays_to_calcdata');
  var calcSelection = _dereq_('../scatter/calc_selection');
  
  module.exports = function calc(gd, trace) {
      var xa = Axes.getFromId(gd, trace.xaxis || 'x');
      var ya = Axes.getFromId(gd, trace.yaxis || 'y');
      var size, pos, origPos;
  
      var sizeOpts = {
          msUTC: !!(trace.base || trace.base === 0)
      };
  
      var hasPeriod;
      if(trace.orientation === 'h') {
          size = xa.makeCalcdata(trace, 'x', sizeOpts);
          origPos = ya.makeCalcdata(trace, 'y');
          pos = alignPeriod(trace, ya, 'y', origPos);
          hasPeriod = !!trace.yperiodalignment;
      } else {
          size = ya.makeCalcdata(trace, 'y', sizeOpts);
          origPos = xa.makeCalcdata(trace, 'x');
          pos = alignPeriod(trace, xa, 'x', origPos);
          hasPeriod = !!trace.xperiodalignment;
      }
  
      // create the "calculated data" to plot
      var serieslen = Math.min(pos.length, size.length);
      var cd = new Array(serieslen);
  
      // set position and size
      for(var i = 0; i < serieslen; i++) {
          cd[i] = { p: pos[i], s: size[i] };
  
          if(hasPeriod) {
              cd[i].orig_p = origPos[i]; // used by hover
          }
  
          if(trace.ids) {
              cd[i].id = String(trace.ids[i]);
          }
      }
  
      // auto-z and autocolorscale if applicable
      if(hasColorscale(trace, 'marker')) {
          colorscaleCalc(gd, trace, {
              vals: trace.marker.color,
              containerStr: 'marker',
              cLetter: 'c'
          });
      }
      if(hasColorscale(trace, 'marker.line')) {
          colorscaleCalc(gd, trace, {
              vals: trace.marker.line.color,
              containerStr: 'marker.line',
              cLetter: 'c'
          });
      }
  
      arraysToCalcdata(cd, trace);
      calcSelection(cd, trace);
  
      return cd;
  };
  
  },{"../../components/colorscale/calc":623,"../../components/colorscale/helpers":626,"../../plots/cartesian/align_period":796,"../../plots/cartesian/axes":799,"../scatter/calc_selection":1160,"./arrays_to_calcdata":891}],894:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = {
      // padding in pixels around text
      TEXTPAD: 3,
      // 'value' and 'label' are not really necessary for bar traces,
      // but they were made available to `texttemplate` (maybe by accident)
      // via tokens `%{value}` and `%{label}` starting in 1.50.0,
      // so let's include them in the event data also.
      eventDataKeys: ['value', 'label']
  };
  
  },{}],895:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  var Registry = _dereq_('../../registry');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var getAxisGroup = _dereq_('../../plots/cartesian/axis_ids').getAxisGroup;
  var Sieve = _dereq_('./sieve.js');
  
  /*
   * Bar chart stacking/grouping positioning and autoscaling calculations
   * for each direction separately calculate the ranges and positions
   * note that this handles histograms too
   * now doing this one subplot at a time
   */
  
  function crossTraceCalc(gd, plotinfo) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      var fullLayout = gd._fullLayout;
      var fullTraces = gd._fullData;
      var calcTraces = gd.calcdata;
      var calcTracesHorz = [];
      var calcTracesVert = [];
  
      for(var i = 0; i < fullTraces.length; i++) {
          var fullTrace = fullTraces[i];
          if(
              fullTrace.visible === true &&
              Registry.traceIs(fullTrace, 'bar') &&
              fullTrace.xaxis === xa._id &&
              fullTrace.yaxis === ya._id
          ) {
              if(fullTrace.orientation === 'h') {
                  calcTracesHorz.push(calcTraces[i]);
              } else {
                  calcTracesVert.push(calcTraces[i]);
              }
  
              if(fullTrace._computePh) {
                  var cd = gd.calcdata[i];
                  for(var j = 0; j < cd.length; j++) {
                      if(typeof cd[j].ph0 === 'function') cd[j].ph0 = cd[j].ph0();
                      if(typeof cd[j].ph1 === 'function') cd[j].ph1 = cd[j].ph1();
                  }
              }
          }
      }
  
      var opts = {
          xCat: xa.type === 'category' || xa.type === 'multicategory',
          yCat: ya.type === 'category' || ya.type === 'multicategory',
  
          mode: fullLayout.barmode,
          norm: fullLayout.barnorm,
          gap: fullLayout.bargap,
          groupgap: fullLayout.bargroupgap
      };
  
      setGroupPositions(gd, xa, ya, calcTracesVert, opts);
      setGroupPositions(gd, ya, xa, calcTracesHorz, opts);
  }
  
  function setGroupPositions(gd, pa, sa, calcTraces, opts) {
      if(!calcTraces.length) return;
  
      var excluded;
      var included;
      var i, calcTrace, fullTrace;
  
      initBase(sa, calcTraces);
  
      switch(opts.mode) {
          case 'overlay':
              setGroupPositionsInOverlayMode(pa, sa, calcTraces, opts);
              break;
  
          case 'group':
              // exclude from the group those traces for which the user set an offset
              excluded = [];
              included = [];
              for(i = 0; i < calcTraces.length; i++) {
                  calcTrace = calcTraces[i];
                  fullTrace = calcTrace[0].trace;
  
                  if(fullTrace.offset === undefined) included.push(calcTrace);
                  else excluded.push(calcTrace);
              }
  
              if(included.length) {
                  setGroupPositionsInGroupMode(gd, pa, sa, included, opts);
              }
              if(excluded.length) {
                  setGroupPositionsInOverlayMode(pa, sa, excluded, opts);
              }
              break;
  
          case 'stack':
          case 'relative':
              // exclude from the stack those traces for which the user set a base
              excluded = [];
              included = [];
              for(i = 0; i < calcTraces.length; i++) {
                  calcTrace = calcTraces[i];
                  fullTrace = calcTrace[0].trace;
  
                  if(fullTrace.base === undefined) included.push(calcTrace);
                  else excluded.push(calcTrace);
              }
  
              if(included.length) {
                  setGroupPositionsInStackOrRelativeMode(gd, pa, sa, included, opts);
              }
              if(excluded.length) {
                  setGroupPositionsInOverlayMode(pa, sa, excluded, opts);
              }
              break;
      }
  
      collectExtents(calcTraces, pa);
  }
  
  function initBase(sa, calcTraces) {
      var i, j;
  
      for(i = 0; i < calcTraces.length; i++) {
          var cd = calcTraces[i];
          var trace = cd[0].trace;
          var base = (trace.type === 'funnel') ? trace._base : trace.base;
          var b;
  
          // not sure if it really makes sense to have dates for bar size data...
          // ideally if we want to make gantt charts or something we'd treat
          // the actual size (trace.x or y) as time delta but base as absolute
          // time. But included here for completeness.
          var scalendar = trace.orientation === 'h' ? trace.xcalendar : trace.ycalendar;
  
          // 'base' on categorical axes makes no sense
          var d2c = sa.type === 'category' || sa.type === 'multicategory' ?
              function() { return null; } :
              sa.d2c;
  
          if(isArrayOrTypedArray(base)) {
              for(j = 0; j < Math.min(base.length, cd.length); j++) {
                  b = d2c(base[j], 0, scalendar);
                  if(isNumeric(b)) {
                      cd[j].b = +b;
                      cd[j].hasB = 1;
                  } else cd[j].b = 0;
              }
              for(; j < cd.length; j++) {
                  cd[j].b = 0;
              }
          } else {
              b = d2c(base, 0, scalendar);
              var hasBase = isNumeric(b);
              b = hasBase ? b : 0;
              for(j = 0; j < cd.length; j++) {
                  cd[j].b = b;
                  if(hasBase) cd[j].hasB = 1;
              }
          }
      }
  }
  
  function setGroupPositionsInOverlayMode(pa, sa, calcTraces, opts) {
      // update position axis and set bar offsets and widths
      for(var i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
  
          var sieve = new Sieve([calcTrace], {
              unitMinDiff: opts.xCat || opts.yCat,
              sepNegVal: false,
              overlapNoMerge: !opts.norm
          });
  
          // set bar offsets and widths, and update position axis
          setOffsetAndWidth(pa, sieve, opts);
  
          // set bar bases and sizes, and update size axis
          //
          // (note that `setGroupPositionsInOverlayMode` handles the case barnorm
          // is defined, because this function is also invoked for traces that
          // can't be grouped or stacked)
          if(opts.norm) {
              sieveBars(sieve);
              normalizeBars(sa, sieve, opts);
          } else {
              setBaseAndTop(sa, sieve);
          }
      }
  }
  
  function setGroupPositionsInGroupMode(gd, pa, sa, calcTraces, opts) {
      var sieve = new Sieve(calcTraces, {
          sepNegVal: false,
          overlapNoMerge: !opts.norm
      });
  
      // set bar offsets and widths, and update position axis
      setOffsetAndWidthInGroupMode(gd, pa, sieve, opts);
  
      // relative-stack bars within the same trace that would otherwise
      // be hidden
      unhideBarsWithinTrace(sieve);
  
      // set bar bases and sizes, and update size axis
      if(opts.norm) {
          sieveBars(sieve);
          normalizeBars(sa, sieve, opts);
      } else {
          setBaseAndTop(sa, sieve);
      }
  }
  
  function setGroupPositionsInStackOrRelativeMode(gd, pa, sa, calcTraces, opts) {
      var sieve = new Sieve(calcTraces, {
          sepNegVal: opts.mode === 'relative',
          overlapNoMerge: !(opts.norm || opts.mode === 'stack' || opts.mode === 'relative')
      });
  
      // set bar offsets and widths, and update position axis
      setOffsetAndWidth(pa, sieve, opts);
  
      // set bar bases and sizes, and update size axis
      stackBars(sa, sieve, opts);
  
      // flag the outmost bar (for text display purposes)
      for(var i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
  
          for(var j = 0; j < calcTrace.length; j++) {
              var bar = calcTrace[j];
  
              if(bar.s !== BADNUM) {
                  var isOutmostBar = ((bar.b + bar.s) === sieve.get(bar.p, bar.s));
                  if(isOutmostBar) bar._outmost = true;
              }
          }
      }
  
      // Note that marking the outmost bars has to be done
      // before `normalizeBars` changes `bar.b` and `bar.s`.
      if(opts.norm) normalizeBars(sa, sieve, opts);
  }
  
  function setOffsetAndWidth(pa, sieve, opts) {
      var minDiff = sieve.minDiff;
      var calcTraces = sieve.traces;
  
      // set bar offsets and widths
      var barGroupWidth = minDiff * (1 - opts.gap);
      var barWidthPlusGap = barGroupWidth;
      var barWidth = barWidthPlusGap * (1 - (opts.groupgap || 0));
  
      // computer bar group center and bar offset
      var offsetFromCenter = -barWidth / 2;
  
      for(var i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
          var t = calcTrace[0].t;
  
          // store bar width and offset for this trace
          t.barwidth = barWidth;
          t.poffset = offsetFromCenter;
          t.bargroupwidth = barGroupWidth;
          t.bardelta = minDiff;
      }
  
      // stack bars that only differ by rounding
      sieve.binWidth = calcTraces[0][0].t.barwidth / 100;
  
      // if defined, apply trace offset and width
      applyAttributes(sieve);
  
      // store the bar center in each calcdata item
      setBarCenterAndWidth(pa, sieve);
  
      // update position axes
      updatePositionAxis(pa, sieve);
  }
  
  function setOffsetAndWidthInGroupMode(gd, pa, sieve, opts) {
      var fullLayout = gd._fullLayout;
      var positions = sieve.positions;
      var distinctPositions = sieve.distinctPositions;
      var minDiff = sieve.minDiff;
      var calcTraces = sieve.traces;
      var nTraces = calcTraces.length;
  
      // if there aren't any overlapping positions,
      // let them have full width even if mode is group
      var overlap = (positions.length !== distinctPositions.length);
      var barGroupWidth = minDiff * (1 - opts.gap);
  
      var groupId = getAxisGroup(fullLayout, pa._id) + calcTraces[0][0].trace.orientation;
      var alignmentGroups = fullLayout._alignmentOpts[groupId] || {};
  
      for(var i = 0; i < nTraces; i++) {
          var calcTrace = calcTraces[i];
          var trace = calcTrace[0].trace;
  
          var alignmentGroupOpts = alignmentGroups[trace.alignmentgroup] || {};
          var nOffsetGroups = Object.keys(alignmentGroupOpts.offsetGroups || {}).length;
  
          var barWidthPlusGap;
          if(nOffsetGroups) {
              barWidthPlusGap = barGroupWidth / nOffsetGroups;
          } else {
              barWidthPlusGap = overlap ? barGroupWidth / nTraces : barGroupWidth;
          }
  
          var barWidth = barWidthPlusGap * (1 - (opts.groupgap || 0));
  
          var offsetFromCenter;
          if(nOffsetGroups) {
              offsetFromCenter = ((2 * trace._offsetIndex + 1 - nOffsetGroups) * barWidthPlusGap - barWidth) / 2;
          } else {
              offsetFromCenter = overlap ?
                  ((2 * i + 1 - nTraces) * barWidthPlusGap - barWidth) / 2 :
                  -barWidth / 2;
          }
  
          var t = calcTrace[0].t;
          t.barwidth = barWidth;
          t.poffset = offsetFromCenter;
          t.bargroupwidth = barGroupWidth;
          t.bardelta = minDiff;
      }
  
      // stack bars that only differ by rounding
      sieve.binWidth = calcTraces[0][0].t.barwidth / 100;
  
      // if defined, apply trace width
      applyAttributes(sieve);
  
      // store the bar center in each calcdata item
      setBarCenterAndWidth(pa, sieve);
  
      // update position axes
      updatePositionAxis(pa, sieve, overlap);
  }
  
  function applyAttributes(sieve) {
      var calcTraces = sieve.traces;
      var i, j;
  
      for(i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
          var calcTrace0 = calcTrace[0];
          var fullTrace = calcTrace0.trace;
          var t = calcTrace0.t;
          var offset = fullTrace._offset || fullTrace.offset;
          var initialPoffset = t.poffset;
          var newPoffset;
  
          if(isArrayOrTypedArray(offset)) {
              // if offset is an array, then clone it into t.poffset.
              newPoffset = Array.prototype.slice.call(offset, 0, calcTrace.length);
  
              // guard against non-numeric items
              for(j = 0; j < newPoffset.length; j++) {
                  if(!isNumeric(newPoffset[j])) {
                      newPoffset[j] = initialPoffset;
                  }
              }
  
              // if the length of the array is too short,
              // then extend it with the initial value of t.poffset
              for(j = newPoffset.length; j < calcTrace.length; j++) {
                  newPoffset.push(initialPoffset);
              }
  
              t.poffset = newPoffset;
          } else if(offset !== undefined) {
              t.poffset = offset;
          }
  
          var width = fullTrace._width || fullTrace.width;
          var initialBarwidth = t.barwidth;
  
          if(isArrayOrTypedArray(width)) {
              // if width is an array, then clone it into t.barwidth.
              var newBarwidth = Array.prototype.slice.call(width, 0, calcTrace.length);
  
              // guard against non-numeric items
              for(j = 0; j < newBarwidth.length; j++) {
                  if(!isNumeric(newBarwidth[j])) newBarwidth[j] = initialBarwidth;
              }
  
              // if the length of the array is too short,
              // then extend it with the initial value of t.barwidth
              for(j = newBarwidth.length; j < calcTrace.length; j++) {
                  newBarwidth.push(initialBarwidth);
              }
  
              t.barwidth = newBarwidth;
  
              // if user didn't set offset,
              // then correct t.poffset to ensure bars remain centered
              if(offset === undefined) {
                  newPoffset = [];
                  for(j = 0; j < calcTrace.length; j++) {
                      newPoffset.push(
                          initialPoffset + (initialBarwidth - newBarwidth[j]) / 2
                      );
                  }
                  t.poffset = newPoffset;
              }
          } else if(width !== undefined) {
              t.barwidth = width;
  
              // if user didn't set offset,
              // then correct t.poffset to ensure bars remain centered
              if(offset === undefined) {
                  t.poffset = initialPoffset + (initialBarwidth - width) / 2;
              }
          }
      }
  }
  
  function setBarCenterAndWidth(pa, sieve) {
      var calcTraces = sieve.traces;
      var pLetter = getAxisLetter(pa);
  
      for(var i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
          var t = calcTrace[0].t;
          var poffset = t.poffset;
          var poffsetIsArray = Array.isArray(poffset);
          var barwidth = t.barwidth;
          var barwidthIsArray = Array.isArray(barwidth);
  
          for(var j = 0; j < calcTrace.length; j++) {
              var calcBar = calcTrace[j];
  
              // store the actual bar width and position, for use by hover
              var width = calcBar.w = barwidthIsArray ? barwidth[j] : barwidth;
              calcBar[pLetter] = calcBar.p + (poffsetIsArray ? poffset[j] : poffset) + width / 2;
          }
      }
  }
  
  function updatePositionAxis(pa, sieve, allowMinDtick) {
      var calcTraces = sieve.traces;
      var minDiff = sieve.minDiff;
      var vpad = minDiff / 2;
  
      Axes.minDtick(pa, sieve.minDiff, sieve.distinctPositions[0], allowMinDtick);
  
      for(var i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
          var calcTrace0 = calcTrace[0];
          var fullTrace = calcTrace0.trace;
          var pts = [];
          var bar, l, r, j;
  
          for(j = 0; j < calcTrace.length; j++) {
              bar = calcTrace[j];
              l = bar.p - vpad;
              r = bar.p + vpad;
              pts.push(l, r);
          }
  
          if(fullTrace.width || fullTrace.offset) {
              var t = calcTrace0.t;
              var poffset = t.poffset;
              var barwidth = t.barwidth;
              var poffsetIsArray = Array.isArray(poffset);
              var barwidthIsArray = Array.isArray(barwidth);
  
              for(j = 0; j < calcTrace.length; j++) {
                  bar = calcTrace[j];
                  var calcBarOffset = poffsetIsArray ? poffset[j] : poffset;
                  var calcBarWidth = barwidthIsArray ? barwidth[j] : barwidth;
                  l = bar.p + calcBarOffset;
                  r = l + calcBarWidth;
                  pts.push(l, r);
              }
          }
  
          fullTrace._extremes[pa._id] = Axes.findExtremes(pa, pts, {padded: false});
      }
  }
  
  // store these bar bases and tops in calcdata
  // and make sure the size axis includes zero,
  // along with the bases and tops of each bar.
  function setBaseAndTop(sa, sieve) {
      var calcTraces = sieve.traces;
      var sLetter = getAxisLetter(sa);
  
      for(var i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
          var fullTrace = calcTrace[0].trace;
          var pts = [];
          var tozero = false;
  
          for(var j = 0; j < calcTrace.length; j++) {
              var bar = calcTrace[j];
              var base = bar.b;
              var top = base + bar.s;
  
              bar[sLetter] = top;
              pts.push(top);
              if(bar.hasB) pts.push(base);
  
              if(!bar.hasB || !bar.b) {
                  tozero = true;
              }
          }
  
          fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
              tozero: tozero,
              padded: true
          });
      }
  }
  
  function stackBars(sa, sieve, opts) {
      var sLetter = getAxisLetter(sa);
      var calcTraces = sieve.traces;
      var calcTrace;
      var fullTrace;
      var isFunnel;
      var i, j;
      var bar;
  
      for(i = 0; i < calcTraces.length; i++) {
          calcTrace = calcTraces[i];
          fullTrace = calcTrace[0].trace;
  
          if(fullTrace.type === 'funnel') {
              for(j = 0; j < calcTrace.length; j++) {
                  bar = calcTrace[j];
  
                  if(bar.s !== BADNUM) {
                      // create base of funnels
                      sieve.put(bar.p, -0.5 * bar.s);
                  }
              }
          }
      }
  
      for(i = 0; i < calcTraces.length; i++) {
          calcTrace = calcTraces[i];
          fullTrace = calcTrace[0].trace;
  
          isFunnel = (fullTrace.type === 'funnel');
  
          var pts = [];
  
          for(j = 0; j < calcTrace.length; j++) {
              bar = calcTrace[j];
  
              if(bar.s !== BADNUM) {
                  // stack current bar and get previous sum
                  var value;
                  if(isFunnel) {
                      value = bar.s;
                  } else {
                      value = bar.s + bar.b;
                  }
  
                  var base = sieve.put(bar.p, value);
  
                  var top = base + value;
  
                  // store the bar base and top in each calcdata item
                  bar.b = base;
                  bar[sLetter] = top;
  
                  if(!opts.norm) {
                      pts.push(top);
                      if(bar.hasB) {
                          pts.push(base);
                      }
                  }
              }
          }
  
          // if barnorm is set, let normalizeBars update the axis range
          if(!opts.norm) {
              fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
                  // N.B. we don't stack base with 'base',
                  // so set tozero:true always!
                  tozero: true,
                  padded: true
              });
          }
      }
  }
  
  function sieveBars(sieve) {
      var calcTraces = sieve.traces;
  
      for(var i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
  
          for(var j = 0; j < calcTrace.length; j++) {
              var bar = calcTrace[j];
  
              if(bar.s !== BADNUM) {
                  sieve.put(bar.p, bar.b + bar.s);
              }
          }
      }
  }
  
  function unhideBarsWithinTrace(sieve) {
      var calcTraces = sieve.traces;
  
      for(var i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
          var fullTrace = calcTrace[0].trace;
  
          if(fullTrace.base === undefined) {
              var inTraceSieve = new Sieve([calcTrace], {
                  sepNegVal: true,
                  overlapNoMerge: true
              });
  
              for(var j = 0; j < calcTrace.length; j++) {
                  var bar = calcTrace[j];
  
                  if(bar.p !== BADNUM) {
                      // stack current bar and get previous sum
                      var base = inTraceSieve.put(bar.p, bar.b + bar.s);
  
                      // if previous sum if non-zero, this means:
                      // multiple bars have same starting point are potentially hidden,
                      // shift them vertically so that all bars are visible by default
                      if(base) bar.b = base;
                  }
              }
          }
      }
  }
  
  // Note:
  //
  // normalizeBars requires that either sieveBars or stackBars has been
  // previously invoked.
  function normalizeBars(sa, sieve, opts) {
      var calcTraces = sieve.traces;
      var sLetter = getAxisLetter(sa);
      var sTop = opts.norm === 'fraction' ? 1 : 100;
      var sTiny = sTop / 1e9; // in case of rounding error in sum
      var sMin = sa.l2c(sa.c2l(0));
      var sMax = opts.mode === 'stack' ? sTop : sMin;
  
      function needsPadding(v) {
          return (
              isNumeric(sa.c2l(v)) &&
              ((v < sMin - sTiny) || (v > sMax + sTiny) || !isNumeric(sMin))
          );
      }
  
      for(var i = 0; i < calcTraces.length; i++) {
          var calcTrace = calcTraces[i];
          var fullTrace = calcTrace[0].trace;
          var pts = [];
          var tozero = false;
          var padded = false;
  
          for(var j = 0; j < calcTrace.length; j++) {
              var bar = calcTrace[j];
  
              if(bar.s !== BADNUM) {
                  var scale = Math.abs(sTop / sieve.get(bar.p, bar.s));
                  bar.b *= scale;
                  bar.s *= scale;
  
                  var base = bar.b;
                  var top = base + bar.s;
  
                  bar[sLetter] = top;
                  pts.push(top);
                  padded = padded || needsPadding(top);
  
                  if(bar.hasB) {
                      pts.push(base);
                      padded = padded || needsPadding(base);
                  }
  
                  if(!bar.hasB || !bar.b) {
                      tozero = true;
                  }
              }
          }
  
          fullTrace._extremes[sa._id] = Axes.findExtremes(sa, pts, {
              tozero: tozero,
              padded: padded
          });
      }
  }
  
  // find the full position span of bars at each position
  // for use by hover, to ensure labels move in if bars are
  // narrower than the space they're in.
  // run once per trace group (subplot & direction) and
  // the same mapping is attached to all calcdata traces
  function collectExtents(calcTraces, pa) {
      var pLetter = getAxisLetter(pa);
      var extents = {};
      var i, j, cd;
  
      var pMin = Infinity;
      var pMax = -Infinity;
  
      for(i = 0; i < calcTraces.length; i++) {
          cd = calcTraces[i];
          for(j = 0; j < cd.length; j++) {
              var p = cd[j].p;
              if(isNumeric(p)) {
                  pMin = Math.min(pMin, p);
                  pMax = Math.max(pMax, p);
              }
          }
      }
  
      // this is just for positioning of hover labels, and nobody will care if
      // the label is 1px too far out; so round positions to 1/10K in case
      // position values don't exactly match from trace to trace
      var roundFactor = 10000 / (pMax - pMin);
      var round = extents.round = function(p) {
          return String(Math.round(roundFactor * (p - pMin)));
      };
  
      for(i = 0; i < calcTraces.length; i++) {
          cd = calcTraces[i];
          cd[0].t.extents = extents;
  
          var poffset = cd[0].t.poffset;
          var poffsetIsArray = Array.isArray(poffset);
  
          for(j = 0; j < cd.length; j++) {
              var di = cd[j];
              var p0 = di[pLetter] - di.w / 2;
  
              if(isNumeric(p0)) {
                  var p1 = di[pLetter] + di.w / 2;
                  var pVal = round(di.p);
                  if(extents[pVal]) {
                      extents[pVal] = [Math.min(p0, extents[pVal][0]), Math.max(p1, extents[pVal][1])];
                  } else {
                      extents[pVal] = [p0, p1];
                  }
              }
  
              di.p0 = di.p + (poffsetIsArray ? poffset[j] : poffset);
              di.p1 = di.p0 + di.w;
              di.s0 = di.b;
              di.s1 = di.s0 + di.s;
          }
      }
  }
  
  function getAxisLetter(ax) {
      return ax._id.charAt(0);
  }
  
  module.exports = {
      crossTraceCalc: crossTraceCalc,
      setGroupPositions: setGroupPositions
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/axes":799,"../../plots/cartesian/axis_ids":802,"../../registry":882,"./sieve.js":905,"fast-isnumeric":241}],896:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  var Registry = _dereq_('../../registry');
  
  var handleXYDefaults = _dereq_('../scatter/xy_defaults');
  var handlePeriodDefaults = _dereq_('../scatter/period_defaults');
  var handleStyleDefaults = _dereq_('./style_defaults');
  var getAxisGroup = _dereq_('../../plots/cartesian/axis_ids').getAxisGroup;
  var attributes = _dereq_('./attributes');
  
  var coerceFont = Lib.coerceFont;
  
  function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  
      coerce('orientation', (traceOut.x && !traceOut.y) ? 'h' : 'v');
      coerce('base');
      coerce('offset');
      coerce('width');
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      var textposition = coerce('textposition');
      handleText(traceIn, traceOut, layout, coerce, textposition, {
          moduleHasSelected: true,
          moduleHasUnselected: true,
          moduleHasConstrain: true,
          moduleHasCliponaxis: true,
          moduleHasTextangle: true,
          moduleHasInsideanchor: true
      });
  
      handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
  
      var lineColor = (traceOut.marker.line || {}).color;
  
      // override defaultColor for error bars with defaultLine
      var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {axis: 'y'});
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {axis: 'x', inherit: 'y'});
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  }
  
  function handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce) {
      var orientation = traceOut.orientation;
      // N.B. grouping is done across all trace types that support it
      var posAxId = traceOut[{v: 'x', h: 'y'}[orientation] + 'axis'];
      var groupId = getAxisGroup(fullLayout, posAxId) + orientation;
  
      var alignmentOpts = fullLayout._alignmentOpts || {};
      var alignmentgroup = coerce('alignmentgroup');
  
      var alignmentGroups = alignmentOpts[groupId];
      if(!alignmentGroups) alignmentGroups = alignmentOpts[groupId] = {};
  
      var alignmentGroupOpts = alignmentGroups[alignmentgroup];
  
      if(alignmentGroupOpts) {
          alignmentGroupOpts.traces.push(traceOut);
      } else {
          alignmentGroupOpts = alignmentGroups[alignmentgroup] = {
              traces: [traceOut],
              alignmentIndex: Object.keys(alignmentGroups).length,
              offsetGroups: {}
          };
      }
  
      var offsetgroup = coerce('offsetgroup');
      var offsetGroups = alignmentGroupOpts.offsetGroups;
      var offsetGroupOpts = offsetGroups[offsetgroup];
  
      if(offsetgroup) {
          if(!offsetGroupOpts) {
              offsetGroupOpts = offsetGroups[offsetgroup] = {
                  offsetIndex: Object.keys(offsetGroups).length
              };
          }
  
          traceOut._offsetIndex = offsetGroupOpts.offsetIndex;
      }
  }
  
  function crossTraceDefaults(fullData, fullLayout) {
      var traceIn, traceOut;
  
      function coerce(attr) {
          return Lib.coerce(traceOut._input, traceOut, attributes, attr);
      }
  
      if(fullLayout.barmode === 'group') {
          for(var i = 0; i < fullData.length; i++) {
              traceOut = fullData[i];
  
              if(traceOut.type === 'bar') {
                  traceIn = traceOut._input;
                  handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
              }
          }
      }
  }
  
  function handleText(traceIn, traceOut, layout, coerce, textposition, opts) {
      opts = opts || {};
      var moduleHasSelected = !(opts.moduleHasSelected === false);
      var moduleHasUnselected = !(opts.moduleHasUnselected === false);
      var moduleHasConstrain = !(opts.moduleHasConstrain === false);
      var moduleHasCliponaxis = !(opts.moduleHasCliponaxis === false);
      var moduleHasTextangle = !(opts.moduleHasTextangle === false);
      var moduleHasInsideanchor = !(opts.moduleHasInsideanchor === false);
      var hasPathbar = !!opts.hasPathbar;
  
      var hasBoth = Array.isArray(textposition) || textposition === 'auto';
      var hasInside = hasBoth || textposition === 'inside';
      var hasOutside = hasBoth || textposition === 'outside';
  
      if(hasInside || hasOutside) {
          var dfltFont = coerceFont(coerce, 'textfont', layout.font);
  
          // Note that coercing `insidetextfont` is always needed –
          // even if `textposition` is `outside` for each trace – since
          // an outside label can become an inside one, for example because
          // of a bar being stacked on top of it.
          var insideTextFontDefault = Lib.extendFlat({}, dfltFont);
          var isTraceTextfontColorSet = traceIn.textfont && traceIn.textfont.color;
          var isColorInheritedFromLayoutFont = !isTraceTextfontColorSet;
          if(isColorInheritedFromLayoutFont) {
              delete insideTextFontDefault.color;
          }
          coerceFont(coerce, 'insidetextfont', insideTextFontDefault);
  
          if(hasPathbar) {
              var pathbarTextFontDefault = Lib.extendFlat({}, dfltFont);
              if(isColorInheritedFromLayoutFont) {
                  delete pathbarTextFontDefault.color;
              }
              coerceFont(coerce, 'pathbar.textfont', pathbarTextFontDefault);
          }
  
          if(hasOutside) coerceFont(coerce, 'outsidetextfont', dfltFont);
  
          if(moduleHasSelected) coerce('selected.textfont.color');
          if(moduleHasUnselected) coerce('unselected.textfont.color');
          if(moduleHasConstrain) coerce('constraintext');
          if(moduleHasCliponaxis) coerce('cliponaxis');
          if(moduleHasTextangle) coerce('textangle');
  
          coerce('texttemplate');
      }
  
      if(hasInside) {
          if(moduleHasInsideanchor) coerce('insidetextanchor');
      }
  }
  
  module.exports = {
      supplyDefaults: supplyDefaults,
      crossTraceDefaults: crossTraceDefaults,
      handleGroupingDefaults: handleGroupingDefaults,
      handleText: handleText
  };
  
  },{"../../components/color":615,"../../lib":750,"../../plots/cartesian/axis_ids":802,"../../registry":882,"../scatter/period_defaults":1178,"../scatter/xy_defaults":1185,"./attributes":892,"./style_defaults":907}],897:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt, trace) {
      // standard cartesian event data
      out.x = 'xVal' in pt ? pt.xVal : pt.x;
      out.y = 'yVal' in pt ? pt.yVal : pt.y;
      if(pt.xa) out.xaxis = pt.xa;
      if(pt.ya) out.yaxis = pt.ya;
  
      if(trace.orientation === 'h') {
          out.label = out.y;
          out.value = out.x;
      } else {
          out.label = out.x;
          out.value = out.y;
      }
  
      return out;
  };
  
  },{}],898:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var tinycolor = _dereq_('tinycolor2');
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  
  exports.coerceString = function(attributeDefinition, value, defaultValue) {
      if(typeof value === 'string') {
          if(value || !attributeDefinition.noBlank) return value;
      } else if(typeof value === 'number' || value === true) {
          if(!attributeDefinition.strict) return String(value);
      }
  
      return (defaultValue !== undefined) ?
        defaultValue :
        attributeDefinition.dflt;
  };
  
  exports.coerceNumber = function(attributeDefinition, value, defaultValue) {
      if(isNumeric(value)) {
          value = +value;
  
          var min = attributeDefinition.min;
          var max = attributeDefinition.max;
          var isOutOfBounds = (min !== undefined && value < min) ||
                (max !== undefined && value > max);
  
          if(!isOutOfBounds) return value;
      }
  
      return (defaultValue !== undefined) ?
        defaultValue :
        attributeDefinition.dflt;
  };
  
  exports.coerceColor = function(attributeDefinition, value, defaultValue) {
      if(tinycolor(value).isValid()) return value;
  
      return (defaultValue !== undefined) ?
        defaultValue :
        attributeDefinition.dflt;
  };
  
  exports.coerceEnumerated = function(attributeDefinition, value, defaultValue) {
      if(attributeDefinition.coerceNumber) value = +value;
  
      if(attributeDefinition.values.indexOf(value) !== -1) return value;
  
      return (defaultValue !== undefined) ?
        defaultValue :
        attributeDefinition.dflt;
  };
  
  exports.getValue = function(arrayOrScalar, index) {
      var value;
      if(!Array.isArray(arrayOrScalar)) value = arrayOrScalar;
      else if(index < arrayOrScalar.length) value = arrayOrScalar[index];
      return value;
  };
  
  exports.getLineWidth = function(trace, di) {
      var w =
          (0 < di.mlw) ? di.mlw :
          !isArrayOrTypedArray(trace.marker.line.width) ? trace.marker.line.width :
          0;
  
      return w;
  };
  
  },{"../../lib":750,"fast-isnumeric":241,"tinycolor2":548}],899:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Fx = _dereq_('../../components/fx');
  var Registry = _dereq_('../../registry');
  var Color = _dereq_('../../components/color');
  
  var fillText = _dereq_('../../lib').fillText;
  var getLineWidth = _dereq_('./helpers').getLineWidth;
  var hoverLabelText = _dereq_('../../plots/cartesian/axes').hoverLabelText;
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  function hoverPoints(pointData, xval, yval, hovermode) {
      var barPointData = hoverOnBars(pointData, xval, yval, hovermode);
  
      if(barPointData) {
          var cd = barPointData.cd;
          var trace = cd[0].trace;
          var di = cd[barPointData.index];
  
          barPointData.color = getTraceColor(trace, di);
          Registry.getComponentMethod('errorbars', 'hoverInfo')(di, trace, barPointData);
  
          return [barPointData];
      }
  }
  
  function hoverOnBars(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
      var t = cd[0].t;
      var isClosest = (hovermode === 'closest');
      var isWaterfall = (trace.type === 'waterfall');
      var maxHoverDistance = pointData.maxHoverDistance;
  
      var posVal, sizeVal, posLetter, sizeLetter, dx, dy, pRangeCalc;
  
      function thisBarMinPos(di) { return di[posLetter] - di.w / 2; }
      function thisBarMaxPos(di) { return di[posLetter] + di.w / 2; }
  
      var minPos = isClosest ?
          thisBarMinPos :
          function(di) {
              /*
               * In compare mode, accept a bar if you're on it *or* its group.
               * Nearly always it's the group that matters, but in case the bar
               * was explicitly set wider than its group we'd better accept the
               * whole bar.
               *
               * use `bardelta` instead of `bargroupwidth` so we accept hover
               * in the gap. That way hover doesn't flash on and off as you
               * mouse over the plot in compare modes.
               * In 'closest' mode though the flashing seems inevitable,
               * without far more complex logic
               */
              return Math.min(thisBarMinPos(di), di.p - t.bardelta / 2);
          };
  
      var maxPos = isClosest ?
          thisBarMaxPos :
          function(di) {
              return Math.max(thisBarMaxPos(di), di.p + t.bardelta / 2);
          };
  
      function _positionFn(_minPos, _maxPos) {
          // add a little to the pseudo-distance for wider bars, so that like scatter,
          // if you are over two overlapping bars, the narrower one wins.
          return Fx.inbox(_minPos - posVal, _maxPos - posVal,
              maxHoverDistance + Math.min(1, Math.abs(_maxPos - _minPos) / pRangeCalc) - 1);
      }
  
      function positionFn(di) {
          return _positionFn(minPos(di), maxPos(di));
      }
  
      function thisBarPositionFn(di) {
          return _positionFn(thisBarMinPos(di), thisBarMaxPos(di));
      }
  
      function sizeFn(di) {
          var v = sizeVal;
          var b = di.b;
          var s = di[sizeLetter];
  
          if(isWaterfall) {
              var rawS = Math.abs(di.rawS) || 0;
              if(v > 0) {
                  s += rawS;
              } else if(v < 0) {
                  s -= rawS;
              }
          }
  
          // add a gradient so hovering near the end of a
          // bar makes it a little closer match
          return Fx.inbox(b - v, s - v, maxHoverDistance + (s - v) / (s - b) - 1);
      }
  
      if(trace.orientation === 'h') {
          posVal = yval;
          sizeVal = xval;
          posLetter = 'y';
          sizeLetter = 'x';
          dx = sizeFn;
          dy = positionFn;
      } else {
          posVal = xval;
          sizeVal = yval;
          posLetter = 'x';
          sizeLetter = 'y';
          dy = sizeFn;
          dx = positionFn;
      }
  
      var pa = pointData[posLetter + 'a'];
      var sa = pointData[sizeLetter + 'a'];
  
      pRangeCalc = Math.abs(pa.r2c(pa.range[1]) - pa.r2c(pa.range[0]));
  
      function dxy(di) { return (dx(di) + dy(di)) / 2; }
      var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
      Fx.getClosest(cd, distfn, pointData);
  
      // skip the rest (for this trace) if we didn't find a close point
      if(pointData.index === false) return;
  
      // skip points inside axis rangebreaks
      if(cd[pointData.index].p === BADNUM) return;
  
      // if we get here and we're not in 'closest' mode, push min/max pos back
      // onto the group - even though that means occasionally the mouse will be
      // over the hover label.
      if(!isClosest) {
          minPos = function(di) {
              return Math.min(thisBarMinPos(di), di.p - t.bargroupwidth / 2);
          };
          maxPos = function(di) {
              return Math.max(thisBarMaxPos(di), di.p + t.bargroupwidth / 2);
          };
      }
  
      // the closest data point
      var index = pointData.index;
      var di = cd[index];
  
      var size = (trace.base) ? di.b + di.s : di.s;
      pointData[sizeLetter + '0'] = pointData[sizeLetter + '1'] = sa.c2p(di[sizeLetter], true);
      pointData[sizeLetter + 'LabelVal'] = size;
  
      var extent = t.extents[t.extents.round(di.p)];
      pointData[posLetter + '0'] = pa.c2p(isClosest ? minPos(di) : extent[0], true);
      pointData[posLetter + '1'] = pa.c2p(isClosest ? maxPos(di) : extent[1], true);
  
      var hasPeriod = di.orig_p !== undefined;
      pointData[posLetter + 'LabelVal'] = hasPeriod ? di.orig_p : di.p;
  
      pointData.labelLabel = hoverLabelText(pa, pointData[posLetter + 'LabelVal']);
      pointData.valueLabel = hoverLabelText(sa, pointData[sizeLetter + 'LabelVal']);
      pointData.baseLabel = hoverLabelText(sa, di.b);
  
      // spikelines always want "closest" distance regardless of hovermode
      pointData.spikeDistance = (sizeFn(di) + thisBarPositionFn(di)) / 2 - maxHoverDistance;
      // they also want to point to the data value, regardless of where the label goes
      // in case of bars shifted within groups
      pointData[posLetter + 'Spike'] = pa.c2p(di.p, true);
  
      fillText(di, trace, pointData);
      pointData.hovertemplate = trace.hovertemplate;
  
      return pointData;
  }
  
  function getTraceColor(trace, di) {
      var mc = di.mcc || trace.marker.color;
      var mlc = di.mlcc || trace.marker.line.color;
      var mlw = getLineWidth(trace, di);
  
      if(Color.opacity(mc)) return mc;
      else if(Color.opacity(mlc) && mlw) return mlc;
  }
  
  module.exports = {
      hoverPoints: hoverPoints,
      hoverOnBars: hoverOnBars,
      getTraceColor: getTraceColor
  };
  
  },{"../../components/color":615,"../../components/fx":655,"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/axes":799,"../../registry":882,"./helpers":898}],900:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyDefaults: _dereq_('./defaults').supplyDefaults,
      crossTraceDefaults: _dereq_('./defaults').crossTraceDefaults,
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
      calc: _dereq_('./calc'),
      crossTraceCalc: _dereq_('./cross_trace_calc').crossTraceCalc,
      colorbar: _dereq_('../scatter/marker_colorbar'),
      arraysToCalcdata: _dereq_('./arrays_to_calcdata'),
      plot: _dereq_('./plot').plot,
      style: _dereq_('./style').style,
      styleOnSelect: _dereq_('./style').styleOnSelect,
      hoverPoints: _dereq_('./hover').hoverPoints,
      eventData: _dereq_('./event_data'),
      selectPoints: _dereq_('./select'),
  
      moduleType: 'trace',
      name: 'bar',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['bar-like', 'cartesian', 'svg', 'bar', 'oriented', 'errorBarsOK', 'showLegend', 'zoomScale'],
      animatable: true,
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"../scatter/marker_colorbar":1176,"./arrays_to_calcdata":891,"./attributes":892,"./calc":893,"./cross_trace_calc":895,"./defaults":896,"./event_data":897,"./hover":899,"./layout_attributes":901,"./layout_defaults":902,"./plot":903,"./select":904,"./style":906}],901:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  module.exports = {
      barmode: {
          valType: 'enumerated',
          values: ['stack', 'group', 'overlay', 'relative'],
          dflt: 'group',
          
          editType: 'calc',
          
      },
      barnorm: {
          valType: 'enumerated',
          values: ['', 'fraction', 'percent'],
          dflt: '',
          
          editType: 'calc',
          
      },
      bargap: {
          valType: 'number',
          min: 0,
          max: 1,
          
          editType: 'calc',
          
      },
      bargroupgap: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 0,
          
          editType: 'calc',
          
      }
  };
  
  },{}],902:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Lib = _dereq_('../../lib');
  
  var layoutAttributes = _dereq_('./layout_attributes');
  
  module.exports = function(layoutIn, layoutOut, fullData) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
  
      var hasBars = false;
      var shouldBeGapless = false;
      var gappedAnyway = false;
      var usedSubplots = {};
  
      var mode = coerce('barmode');
  
      for(var i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
          if(Registry.traceIs(trace, 'bar') && trace.visible) hasBars = true;
          else continue;
  
          // if we have at least 2 grouped bar traces on the same subplot,
          // we should default to a gap anyway, even if the data is histograms
          if(mode === 'group') {
              var subploti = trace.xaxis + trace.yaxis;
              if(usedSubplots[subploti]) gappedAnyway = true;
              usedSubplots[subploti] = true;
          }
  
          if(trace.visible && trace.type === 'histogram') {
              var pa = Axes.getFromId({_fullLayout: layoutOut},
                          trace[trace.orientation === 'v' ? 'xaxis' : 'yaxis']);
              if(pa.type !== 'category') shouldBeGapless = true;
          }
      }
  
      if(!hasBars) {
          delete layoutOut.barmode;
          return;
      }
  
      if(mode !== 'overlay') coerce('barnorm');
  
      coerce('bargap', (shouldBeGapless && !gappedAnyway) ? 0 : 0.2);
      coerce('bargroupgap');
  };
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"../../registry":882,"./layout_attributes":901}],903:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  var Registry = _dereq_('../../registry');
  var tickText = _dereq_('../../plots/cartesian/axes').tickText;
  
  var uniformText = _dereq_('./uniform_text');
  var recordMinTextSize = uniformText.recordMinTextSize;
  var clearMinTextSize = uniformText.clearMinTextSize;
  
  var style = _dereq_('./style');
  var helpers = _dereq_('./helpers');
  var constants = _dereq_('./constants');
  var attributes = _dereq_('./attributes');
  
  var attributeText = attributes.text;
  var attributeTextPosition = attributes.textposition;
  
  var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
  
  var TEXTPAD = constants.TEXTPAD;
  
  function keyFunc(d) {return d.id;}
  function getKeyFunc(trace) {
      if(trace.ids) {
          return keyFunc;
      }
  }
  
  function dirSign(a, b) {
      return (a < b) ? 1 : -1;
  }
  
  function getXY(di, xa, ya, isHorizontal) {
      var s = [];
      var p = [];
  
      var sAxis = isHorizontal ? xa : ya;
      var pAxis = isHorizontal ? ya : xa;
  
      s[0] = sAxis.c2p(di.s0, true);
      p[0] = pAxis.c2p(di.p0, true);
  
      s[1] = sAxis.c2p(di.s1, true);
      p[1] = pAxis.c2p(di.p1, true);
  
      return isHorizontal ? [s, p] : [p, s];
  }
  
  function transition(selection, fullLayout, opts, makeOnCompleteCallback) {
      if(!fullLayout.uniformtext.mode && hasTransition(opts)) {
          var onComplete;
          if(makeOnCompleteCallback) {
              onComplete = makeOnCompleteCallback();
          }
          return selection
            .transition()
            .duration(opts.duration)
            .ease(opts.easing)
            .each('end', function() { onComplete && onComplete(); })
            .each('interrupt', function() { onComplete && onComplete(); });
      } else {
          return selection;
      }
  }
  
  function hasTransition(transitionOpts) {
      return transitionOpts && transitionOpts.duration > 0;
  }
  
  function plot(gd, plotinfo, cdModule, traceLayer, opts, makeOnCompleteCallback) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
      var fullLayout = gd._fullLayout;
  
      if(!opts) {
          opts = {
              mode: fullLayout.barmode,
              norm: fullLayout.barmode,
              gap: fullLayout.bargap,
              groupgap: fullLayout.bargroupgap
          };
  
          // don't clear bar when this is called from waterfall or funnel
          clearMinTextSize('bar', fullLayout);
      }
  
      var bartraces = Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function(cd) {
          var plotGroup = d3.select(this);
          var trace = cd[0].trace;
          var isWaterfall = (trace.type === 'waterfall');
          var isFunnel = (trace.type === 'funnel');
          var isBar = (trace.type === 'bar');
          var shouldDisplayZeros = (isBar || isFunnel);
  
          var adjustPixel = 0;
          if(isWaterfall && trace.connector.visible && trace.connector.mode === 'between') {
              adjustPixel = trace.connector.line.width / 2;
          }
  
          var isHorizontal = (trace.orientation === 'h');
          var withTransition = hasTransition(opts);
  
          var pointGroup = Lib.ensureSingle(plotGroup, 'g', 'points');
  
          var keyFunc = getKeyFunc(trace);
          var bars = pointGroup.selectAll('g.point').data(Lib.identity, keyFunc);
  
          bars.enter().append('g')
              .classed('point', true);
  
          bars.exit().remove();
  
          bars.each(function(di, i) {
              var bar = d3.select(this);
  
              // now display the bar
              // clipped xf/yf (2nd arg true): non-positive
              // log values go off-screen by plotwidth
              // so you see them continue if you drag the plot
              var xy = getXY(di, xa, ya, isHorizontal);
  
              var x0 = xy[0][0];
              var x1 = xy[0][1];
              var y0 = xy[1][0];
              var y1 = xy[1][1];
  
              // empty bars
              var isBlank = (isHorizontal ? x1 - x0 : y1 - y0) === 0;
  
              // display zeros if line.width > 0
              if(isBlank && shouldDisplayZeros && helpers.getLineWidth(trace, di)) {
                  isBlank = false;
              }
  
              // skip nulls
              if(!isBlank) {
                  isBlank = (
                      !isNumeric(x0) ||
                      !isNumeric(x1) ||
                      !isNumeric(y0) ||
                      !isNumeric(y1)
                  );
              }
  
              // record isBlank
              di.isBlank = isBlank;
  
              // for blank bars, ensure start and end positions are equal - important for smooth transitions
              if(isBlank) {
                  if(isHorizontal) {
                      x1 = x0;
                  } else {
                      y1 = y0;
                  }
              }
  
              // in waterfall mode `between` we need to adjust bar end points to match the connector width
              if(adjustPixel && !isBlank) {
                  if(isHorizontal) {
                      x0 -= dirSign(x0, x1) * adjustPixel;
                      x1 += dirSign(x0, x1) * adjustPixel;
                  } else {
                      y0 -= dirSign(y0, y1) * adjustPixel;
                      y1 += dirSign(y0, y1) * adjustPixel;
                  }
              }
  
              var lw;
              var mc;
  
              if(trace.type === 'waterfall') {
                  if(!isBlank) {
                      var cont = trace[di.dir].marker;
                      lw = cont.line.width;
                      mc = cont.color;
                  }
              } else {
                  lw = helpers.getLineWidth(trace, di);
                  mc = di.mc || trace.marker.color;
              }
  
              function roundWithLine(v) {
                  var offset = d3.round((lw / 2) % 1, 2);
  
                  // if there are explicit gaps, don't round,
                  // it can make the gaps look crappy
                  return (opts.gap === 0 && opts.groupgap === 0) ?
                      d3.round(Math.round(v) - offset, 2) : v;
              }
  
              function expandToVisible(v, vc, hideZeroSpan) {
                  if(hideZeroSpan && v === vc) {
                      // should not expand zero span bars
                      // when start and end positions are identical
                      // i.e. for vertical when y0 === y1
                      // and for horizontal when x0 === x1
                      return v;
                  }
  
                  // if it's not in danger of disappearing entirely,
                  // round more precisely
                  return Math.abs(v - vc) >= 2 ? roundWithLine(v) :
                  // but if it's very thin, expand it so it's
                  // necessarily visible, even if it might overlap
                  // its neighbor
                  (v > vc ? Math.ceil(v) : Math.floor(v));
              }
  
              if(!gd._context.staticPlot) {
                  // if bars are not fully opaque or they have a line
                  // around them, round to integer pixels, mainly for
                  // safari so we prevent overlaps from its expansive
                  // pixelation. if the bars ARE fully opaque and have
                  // no line, expand to a full pixel to make sure we
                  // can see them
  
                  var op = Color.opacity(mc);
                  var fixpx = (op < 1 || lw > 0.01) ? roundWithLine : expandToVisible;
  
                  x0 = fixpx(x0, x1, isHorizontal);
                  x1 = fixpx(x1, x0, isHorizontal);
                  y0 = fixpx(y0, y1, !isHorizontal);
                  y1 = fixpx(y1, y0, !isHorizontal);
              }
  
              var sel = transition(Lib.ensureSingle(bar, 'path'), fullLayout, opts, makeOnCompleteCallback);
              sel
                  .style('vector-effect', 'non-scaling-stroke')
                  .attr('d', isNaN((x1 - x0) * (y1 - y0)) ? 'M0,0Z' : 'M' + x0 + ',' + y0 + 'V' + y1 + 'H' + x1 + 'V' + y0 + 'Z')
                  .call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
  
              if(!fullLayout.uniformtext.mode && withTransition) {
                  var styleFns = Drawing.makePointStyleFns(trace);
                  Drawing.singlePointStyle(di, sel, trace, styleFns, gd);
              }
  
              appendBarText(gd, plotinfo, bar, cd, i, x0, x1, y0, y1, opts, makeOnCompleteCallback);
  
              if(plotinfo.layerClipId) {
                  Drawing.hideOutsideRangePoint(di, bar.select('text'), xa, ya, trace.xcalendar, trace.ycalendar);
              }
          });
  
          // lastly, clip points groups of `cliponaxis !== false` traces
          // on `plotinfo._hasClipOnAxisFalse === true` subplots
          var hasClipOnAxisFalse = trace.cliponaxis === false;
          Drawing.setClipUrl(plotGroup, hasClipOnAxisFalse ? null : plotinfo.layerClipId, gd);
      });
  
      // error bars are on the top
      Registry.getComponentMethod('errorbars', 'plot')(gd, bartraces, plotinfo, opts);
  }
  
  function appendBarText(gd, plotinfo, bar, cd, i, x0, x1, y0, y1, opts, makeOnCompleteCallback) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      var fullLayout = gd._fullLayout;
      var textPosition;
  
      function appendTextNode(bar, text, font) {
          var textSelection = Lib.ensureSingle(bar, 'text')
              .text(text)
              .attr({
                  'class': 'bartext bartext-' + textPosition,
                  'text-anchor': 'middle',
                  // prohibit tex interpretation until we can handle
                  // tex and regular text together
                  'data-notex': 1
              })
              .call(Drawing.font, font)
              .call(svgTextUtils.convertToTspans, gd);
  
          return textSelection;
      }
  
      // get trace attributes
      var trace = cd[0].trace;
      var isHorizontal = (trace.orientation === 'h');
  
      var text = getText(fullLayout, cd, i, xa, ya);
      textPosition = getTextPosition(trace, i);
  
      // compute text position
      var inStackOrRelativeMode =
          opts.mode === 'stack' ||
          opts.mode === 'relative';
  
      var calcBar = cd[i];
      var isOutmostBar = !inStackOrRelativeMode || calcBar._outmost;
  
      if(!text ||
          textPosition === 'none' ||
          ((calcBar.isBlank || x0 === x1 || y0 === y1) && (
              textPosition === 'auto' ||
              textPosition === 'inside'))) {
          bar.select('text').remove();
          return;
      }
  
      var layoutFont = fullLayout.font;
      var barColor = style.getBarColor(cd[i], trace);
      var insideTextFont = style.getInsideTextFont(trace, i, layoutFont, barColor);
      var outsideTextFont = style.getOutsideTextFont(trace, i, layoutFont);
  
      // Special case: don't use the c2p(v, true) value on log size axes,
      // so that we can get correctly inside text scaling
      var di = bar.datum();
      if(isHorizontal) {
          if(xa.type === 'log' && di.s0 <= 0) {
              if(xa.range[0] < xa.range[1]) {
                  x0 = 0;
              } else {
                  x0 = xa._length;
              }
          }
      } else {
          if(ya.type === 'log' && di.s0 <= 0) {
              if(ya.range[0] < ya.range[1]) {
                  y0 = ya._length;
              } else {
                  y0 = 0;
              }
          }
      }
  
      // padding excluded
      var barWidth = Math.abs(x1 - x0) - 2 * TEXTPAD;
      var barHeight = Math.abs(y1 - y0) - 2 * TEXTPAD;
  
      var textSelection;
      var textBB;
      var textWidth;
      var textHeight;
      var font;
  
      if(textPosition === 'outside') {
          if(!isOutmostBar && !calcBar.hasB) textPosition = 'inside';
      }
  
      if(textPosition === 'auto') {
          if(isOutmostBar) {
              // draw text using insideTextFont and check if it fits inside bar
              textPosition = 'inside';
  
              font = Lib.ensureUniformFontSize(gd, insideTextFont);
  
              textSelection = appendTextNode(bar, text, font);
  
              textBB = Drawing.bBox(textSelection.node()),
              textWidth = textBB.width,
              textHeight = textBB.height;
  
              var textHasSize = (textWidth > 0 && textHeight > 0);
              var fitsInside = (textWidth <= barWidth && textHeight <= barHeight);
              var fitsInsideIfRotated = (textWidth <= barHeight && textHeight <= barWidth);
              var fitsInsideIfShrunk = (isHorizontal) ?
                  (barWidth >= textWidth * (barHeight / textHeight)) :
                  (barHeight >= textHeight * (barWidth / textWidth));
  
              if(textHasSize && (
                  fitsInside ||
                  fitsInsideIfRotated ||
                  fitsInsideIfShrunk)
              ) {
                  textPosition = 'inside';
              } else {
                  textPosition = 'outside';
                  textSelection.remove();
                  textSelection = null;
              }
          } else {
              textPosition = 'inside';
          }
      }
  
      if(!textSelection) {
          font = Lib.ensureUniformFontSize(gd, (textPosition === 'outside') ? outsideTextFont : insideTextFont);
  
          textSelection = appendTextNode(bar, text, font);
  
          var currentTransform = textSelection.attr('transform');
          textSelection.attr('transform', '');
          textBB = Drawing.bBox(textSelection.node()),
          textWidth = textBB.width,
          textHeight = textBB.height;
          textSelection.attr('transform', currentTransform);
  
          if(textWidth <= 0 || textHeight <= 0) {
              textSelection.remove();
              return;
          }
      }
  
      var angle = trace.textangle;
  
      // compute text transform
      var transform, constrained;
      if(textPosition === 'outside') {
          constrained =
              trace.constraintext === 'both' ||
              trace.constraintext === 'outside';
  
          transform = toMoveOutsideBar(x0, x1, y0, y1, textBB, {
              isHorizontal: isHorizontal,
              constrained: constrained,
              angle: angle
          });
      } else {
          constrained =
              trace.constraintext === 'both' ||
              trace.constraintext === 'inside';
  
          transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
              isHorizontal: isHorizontal,
              constrained: constrained,
              angle: angle,
              anchor: trace.insidetextanchor
          });
      }
  
      transform.fontSize = font.size;
      recordMinTextSize(trace.type, transform, fullLayout);
      calcBar.transform = transform;
  
      transition(textSelection, fullLayout, opts, makeOnCompleteCallback)
          .attr('transform', Lib.getTextTransform(transform));
  }
  
  function getRotateFromAngle(angle) {
      return (angle === 'auto') ? 0 : angle;
  }
  
  function getRotatedTextSize(textBB, rotate) {
      var a = Math.PI / 180 * rotate;
      var absSin = Math.abs(Math.sin(a));
      var absCos = Math.abs(Math.cos(a));
  
      return {
          x: textBB.width * absCos + textBB.height * absSin,
          y: textBB.width * absSin + textBB.height * absCos
      };
  }
  
  function toMoveInsideBar(x0, x1, y0, y1, textBB, opts) {
      var isHorizontal = !!opts.isHorizontal;
      var constrained = !!opts.constrained;
      var angle = opts.angle || 0;
      var anchor = opts.anchor || 'end';
      var isEnd = anchor === 'end';
      var isStart = anchor === 'start';
      var leftToRight = opts.leftToRight || 0; // left: -1, center: 0, right: 1
      var toRight = (leftToRight + 1) / 2;
      var toLeft = 1 - toRight;
  
      var textWidth = textBB.width;
      var textHeight = textBB.height;
      var lx = Math.abs(x1 - x0);
      var ly = Math.abs(y1 - y0);
  
      // compute remaining space
      var textpad = (
          lx > (2 * TEXTPAD) &&
          ly > (2 * TEXTPAD)
      ) ? TEXTPAD : 0;
  
      lx -= 2 * textpad;
      ly -= 2 * textpad;
  
      var rotate = getRotateFromAngle(angle);
      if((angle === 'auto') &&
          !(textWidth <= lx && textHeight <= ly) &&
          (textWidth > lx || textHeight > ly) && (
          !(textWidth > ly || textHeight > lx) ||
          ((textWidth < textHeight) !== (lx < ly))
      )) {
          rotate += 90;
      }
  
      var t = getRotatedTextSize(textBB, rotate);
  
      var scale = 1;
      if(constrained) {
          scale = Math.min(
              1,
              lx / t.x,
              ly / t.y
          );
      }
  
      // compute text and target positions
      var textX = (
          textBB.left * toLeft +
          textBB.right * toRight
      );
      var textY = (textBB.top + textBB.bottom) / 2;
      var targetX = (
          (x0 + TEXTPAD) * toLeft +
          (x1 - TEXTPAD) * toRight
      );
      var targetY = (y0 + y1) / 2;
      var anchorX = 0;
      var anchorY = 0;
      if(isStart || isEnd) {
          var extrapad = (isHorizontal ? t.x : t.y) / 2;
          var dir = isHorizontal ? dirSign(x0, x1) : dirSign(y0, y1);
  
          if(isHorizontal) {
              if(isStart) {
                  targetX = x0 + dir * textpad;
                  anchorX = -dir * extrapad;
              } else {
                  targetX = x1 - dir * textpad;
                  anchorX = dir * extrapad;
              }
          } else {
              if(isStart) {
                  targetY = y0 + dir * textpad;
                  anchorY = -dir * extrapad;
              } else {
                  targetY = y1 - dir * textpad;
                  anchorY = dir * extrapad;
              }
          }
      }
  
      return {
          textX: textX,
          textY: textY,
          targetX: targetX,
          targetY: targetY,
          anchorX: anchorX,
          anchorY: anchorY,
          scale: scale,
          rotate: rotate
      };
  }
  
  function toMoveOutsideBar(x0, x1, y0, y1, textBB, opts) {
      var isHorizontal = !!opts.isHorizontal;
      var constrained = !!opts.constrained;
      var angle = opts.angle || 0;
  
      var textWidth = textBB.width;
      var textHeight = textBB.height;
      var lx = Math.abs(x1 - x0);
      var ly = Math.abs(y1 - y0);
  
      var textpad;
      // Keep the padding so the text doesn't sit right against
      // the bars, but don't factor it into barWidth
      if(isHorizontal) {
          textpad = (ly > 2 * TEXTPAD) ? TEXTPAD : 0;
      } else {
          textpad = (lx > 2 * TEXTPAD) ? TEXTPAD : 0;
      }
  
      // compute rotate and scale
      var scale = 1;
      if(constrained) {
          scale = (isHorizontal) ?
              Math.min(1, ly / textHeight) :
              Math.min(1, lx / textWidth);
      }
  
      var rotate = getRotateFromAngle(angle);
      var t = getRotatedTextSize(textBB, rotate);
  
      // compute text and target positions
      var extrapad = (isHorizontal ? t.x : t.y) / 2;
      var textX = (textBB.left + textBB.right) / 2;
      var textY = (textBB.top + textBB.bottom) / 2;
      var targetX = (x0 + x1) / 2;
      var targetY = (y0 + y1) / 2;
      var anchorX = 0;
      var anchorY = 0;
  
      var dir = isHorizontal ? dirSign(x1, x0) : dirSign(y0, y1);
      if(isHorizontal) {
          targetX = x1 - dir * textpad;
          anchorX = dir * extrapad;
      } else {
          targetY = y1 + dir * textpad;
          anchorY = -dir * extrapad;
      }
  
      return {
          textX: textX,
          textY: textY,
          targetX: targetX,
          targetY: targetY,
          anchorX: anchorX,
          anchorY: anchorY,
          scale: scale,
          rotate: rotate
      };
  }
  
  function getText(fullLayout, cd, index, xa, ya) {
      var trace = cd[0].trace;
      var texttemplate = trace.texttemplate;
  
      var value;
      if(texttemplate) {
          value = calcTexttemplate(fullLayout, cd, index, xa, ya);
      } else if(trace.textinfo) {
          value = calcTextinfo(cd, index, xa, ya);
      } else {
          value = helpers.getValue(trace.text, index);
      }
  
      return helpers.coerceString(attributeText, value);
  }
  
  function getTextPosition(trace, index) {
      var value = helpers.getValue(trace.textposition, index);
      return helpers.coerceEnumerated(attributeTextPosition, value);
  }
  
  function calcTexttemplate(fullLayout, cd, index, xa, ya) {
      var trace = cd[0].trace;
      var texttemplate = Lib.castOption(trace, index, 'texttemplate');
      if(!texttemplate) return '';
      var isWaterfall = (trace.type === 'waterfall');
      var isFunnel = (trace.type === 'funnel');
  
      var pLetter, pAxis;
      var vLetter, vAxis;
      if(trace.orientation === 'h') {
          pLetter = 'y';
          pAxis = ya;
          vLetter = 'x';
          vAxis = xa;
      } else {
          pLetter = 'x';
          pAxis = xa;
          vLetter = 'y';
          vAxis = ya;
      }
  
      function formatLabel(u) {
          return tickText(pAxis, u, true).text;
      }
  
      function formatNumber(v) {
          return tickText(vAxis, +v, true).text;
      }
  
      var cdi = cd[index];
      var obj = {};
  
      obj.label = cdi.p;
      obj.labelLabel = obj[pLetter + 'Label'] = formatLabel(cdi.p);
  
      var tx = Lib.castOption(trace, cdi.i, 'text');
      if(tx === 0 || tx) obj.text = tx;
  
      obj.value = cdi.s;
      obj.valueLabel = obj[vLetter + 'Label'] = formatNumber(cdi.s);
  
      var pt = {};
      appendArrayPointValue(pt, trace, cdi.i);
  
      if(isWaterfall) {
          obj.delta = +cdi.rawS || cdi.s;
          obj.deltaLabel = formatNumber(obj.delta);
          obj.final = cdi.v;
          obj.finalLabel = formatNumber(obj.final);
          obj.initial = obj.final - obj.delta;
          obj.initialLabel = formatNumber(obj.initial);
      }
  
      if(isFunnel) {
          obj.value = cdi.s;
          obj.valueLabel = formatNumber(obj.value);
  
          obj.percentInitial = cdi.begR;
          obj.percentInitialLabel = Lib.formatPercent(cdi.begR);
          obj.percentPrevious = cdi.difR;
          obj.percentPreviousLabel = Lib.formatPercent(cdi.difR);
          obj.percentTotal = cdi.sumR;
          obj.percenTotalLabel = Lib.formatPercent(cdi.sumR);
      }
  
      var customdata = Lib.castOption(trace, cdi.i, 'customdata');
      if(customdata) obj.customdata = customdata;
      return Lib.texttemplateString(texttemplate, obj, fullLayout._d3locale, pt, obj, trace._meta || {});
  }
  
  function calcTextinfo(cd, index, xa, ya) {
      var trace = cd[0].trace;
      var isHorizontal = (trace.orientation === 'h');
      var isWaterfall = (trace.type === 'waterfall');
      var isFunnel = (trace.type === 'funnel');
  
      function formatLabel(u) {
          var pAxis = isHorizontal ? ya : xa;
          return tickText(pAxis, u, true).text;
      }
  
      function formatNumber(v) {
          var sAxis = isHorizontal ? xa : ya;
          return tickText(sAxis, +v, true).text;
      }
  
      var textinfo = trace.textinfo;
      var cdi = cd[index];
  
      var parts = textinfo.split('+');
      var text = [];
      var tx;
  
      var hasFlag = function(flag) { return parts.indexOf(flag) !== -1; };
  
      if(hasFlag('label')) {
          text.push(formatLabel(cd[index].p));
      }
  
      if(hasFlag('text')) {
          tx = Lib.castOption(trace, cdi.i, 'text');
          if(tx === 0 || tx) text.push(tx);
      }
  
      if(isWaterfall) {
          var delta = +cdi.rawS || cdi.s;
          var final = cdi.v;
          var initial = final - delta;
  
          if(hasFlag('initial')) text.push(formatNumber(initial));
          if(hasFlag('delta')) text.push(formatNumber(delta));
          if(hasFlag('final')) text.push(formatNumber(final));
      }
  
      if(isFunnel) {
          if(hasFlag('value')) text.push(formatNumber(cdi.s));
  
          var nPercent = 0;
          if(hasFlag('percent initial')) nPercent++;
          if(hasFlag('percent previous')) nPercent++;
          if(hasFlag('percent total')) nPercent++;
  
          var hasMultiplePercents = nPercent > 1;
  
          if(hasFlag('percent initial')) {
              tx = Lib.formatPercent(cdi.begR);
              if(hasMultiplePercents) tx += ' of initial';
              text.push(tx);
          }
          if(hasFlag('percent previous')) {
              tx = Lib.formatPercent(cdi.difR);
              if(hasMultiplePercents) tx += ' of previous';
              text.push(tx);
          }
          if(hasFlag('percent total')) {
              tx = Lib.formatPercent(cdi.sumR);
              if(hasMultiplePercents) tx += ' of total';
              text.push(tx);
          }
      }
  
      return text.join('<br>');
  }
  
  module.exports = {
      plot: plot,
      toMoveInsideBar: toMoveInsideBar
  };
  
  },{"../../components/color":615,"../../components/drawing":637,"../../components/fx/helpers":651,"../../lib":750,"../../lib/svg_text_utils":774,"../../plots/cartesian/axes":799,"../../registry":882,"./attributes":892,"./constants":894,"./helpers":898,"./style":906,"./uniform_text":908,"d3":169,"fast-isnumeric":241}],904:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function selectPoints(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var xa = searchInfo.xaxis;
      var ya = searchInfo.yaxis;
      var trace = cd[0].trace;
      var isFunnel = (trace.type === 'funnel');
      var isHorizontal = (trace.orientation === 'h');
      var selection = [];
      var i;
  
      if(selectionTester === false) {
          // clear selection
          for(i = 0; i < cd.length; i++) {
              cd[i].selected = 0;
          }
      } else {
          for(i = 0; i < cd.length; i++) {
              var di = cd[i];
              var ct = 'ct' in di ? di.ct : getCentroid(di, xa, ya, isHorizontal, isFunnel);
  
              if(selectionTester.contains(ct, false, i, searchInfo)) {
                  selection.push({
                      pointNumber: i,
                      x: xa.c2d(di.x),
                      y: ya.c2d(di.y)
                  });
                  di.selected = 1;
              } else {
                  di.selected = 0;
              }
          }
      }
  
      return selection;
  };
  
  function getCentroid(d, xa, ya, isHorizontal, isFunnel) {
      var x0 = xa.c2p(isHorizontal ? d.s0 : d.p0, true);
      var x1 = xa.c2p(isHorizontal ? d.s1 : d.p1, true);
      var y0 = ya.c2p(isHorizontal ? d.p0 : d.s0, true);
      var y1 = ya.c2p(isHorizontal ? d.p1 : d.s1, true);
  
      if(isFunnel) {
          return [(x0 + x1) / 2, (y0 + y1) / 2];
      } else {
          if(isHorizontal) {
              return [x1, (y0 + y1) / 2];
          } else {
              return [(x0 + x1) / 2, y1];
          }
      }
  }
  
  },{}],905:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = Sieve;
  
  var distinctVals = _dereq_('../../lib').distinctVals;
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  /**
   * Helper class to sieve data from traces into bins
   *
   * @class
   *
   * @param {Array} traces
  *   Array of calculated traces
   * @param {object} opts
   *  - @param {boolean} [sepNegVal]
   *      If true, then split data at the same position into a bar
   *      for positive values and another for negative values
   *  - @param {boolean} [overlapNoMerge]
   *     If true, then don't merge overlapping bars into a single bar
   */
  function Sieve(traces, opts) {
      this.traces = traces;
      this.sepNegVal = opts.sepNegVal;
      this.overlapNoMerge = opts.overlapNoMerge;
  
      // for single-bin histograms - see histogram/calc
      var width1 = Infinity;
  
      var positions = [];
      for(var i = 0; i < traces.length; i++) {
          var trace = traces[i];
          for(var j = 0; j < trace.length; j++) {
              var bar = trace[j];
              if(bar.p !== BADNUM) positions.push(bar.p);
          }
          if(trace[0] && trace[0].width1) {
              width1 = Math.min(trace[0].width1, width1);
          }
      }
      this.positions = positions;
  
      var dv = distinctVals(positions, {
          unitMinDiff: opts.unitMinDiff
      });
  
      this.distinctPositions = dv.vals;
      if(dv.vals.length === 1 && width1 !== Infinity) this.minDiff = width1;
      else this.minDiff = Math.min(dv.minDiff, width1);
  
      this.binWidth = this.minDiff;
  
      this.bins = {};
  }
  
  /**
   * Sieve datum
   *
   * @method
   * @param {number} position
   * @param {number} value
   * @returns {number} Previous bin value
   */
  Sieve.prototype.put = function put(position, value) {
      var label = this.getLabel(position, value);
      var oldValue = this.bins[label] || 0;
  
      this.bins[label] = oldValue + value;
  
      return oldValue;
  };
  
  /**
   * Get current bin value for a given datum
   *
   * @method
   * @param {number} position  Position of datum
   * @param {number} [value]   Value of datum
   *                           (required if this.sepNegVal is true)
   * @returns {number} Current bin value
   */
  Sieve.prototype.get = function get(position, value) {
      var label = this.getLabel(position, value);
      return this.bins[label] || 0;
  };
  
  /**
   * Get bin label for a given datum
   *
   * @method
   * @param {number} position  Position of datum
   * @param {number} [value]   Value of datum
   *                           (required if this.sepNegVal is true)
   * @returns {string} Bin label
   * (prefixed with a 'v' if value is negative and this.sepNegVal is
   * true; otherwise prefixed with '^')
   */
  Sieve.prototype.getLabel = function getLabel(position, value) {
      var prefix = (value < 0 && this.sepNegVal) ? 'v' : '^';
      var label = (this.overlapNoMerge) ?
          position :
          Math.round(position / this.binWidth);
      return prefix + label;
  };
  
  },{"../../constants/numerical":725,"../../lib":750}],906:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  
  var resizeText = _dereq_('./uniform_text').resizeText;
  var attributes = _dereq_('./attributes');
  var attributeTextFont = attributes.textfont;
  var attributeInsideTextFont = attributes.insidetextfont;
  var attributeOutsideTextFont = attributes.outsidetextfont;
  var helpers = _dereq_('./helpers');
  
  function style(gd) {
      var s = d3.select(gd).selectAll('g.barlayer').selectAll('g.trace');
      resizeText(gd, s, 'bar');
  
      var barcount = s.size();
      var fullLayout = gd._fullLayout;
  
      // trace styling
      s.style('opacity', function(d) { return d[0].trace.opacity; })
  
      // for gapless (either stacked or neighboring grouped) bars use
      // crispEdges to turn off antialiasing so an artificial gap
      // isn't introduced.
      .each(function(d) {
          if((fullLayout.barmode === 'stack' && barcount > 1) ||
                  (fullLayout.bargap === 0 &&
                   fullLayout.bargroupgap === 0 &&
                   !d[0].trace.marker.line.width)) {
              d3.select(this).attr('shape-rendering', 'crispEdges');
          }
      });
  
      s.selectAll('g.points').each(function(d) {
          var sel = d3.select(this);
          var trace = d[0].trace;
          stylePoints(sel, trace, gd);
      });
  
      Registry.getComponentMethod('errorbars', 'style')(s);
  }
  
  function stylePoints(sel, trace, gd) {
      Drawing.pointStyle(sel.selectAll('path'), trace, gd);
      styleTextPoints(sel, trace, gd);
  }
  
  function styleTextPoints(sel, trace, gd) {
      sel.selectAll('text').each(function(d) {
          var tx = d3.select(this);
          var font = Lib.ensureUniformFontSize(gd, determineFont(tx, d, trace, gd));
  
          Drawing.font(tx, font);
      });
  }
  
  function styleOnSelect(gd, cd, sel) {
      var trace = cd[0].trace;
  
      if(trace.selectedpoints) {
          stylePointsInSelectionMode(sel, trace, gd);
      } else {
          stylePoints(sel, trace, gd);
          Registry.getComponentMethod('errorbars', 'style')(sel);
      }
  }
  
  function stylePointsInSelectionMode(s, trace, gd) {
      Drawing.selectedPointStyle(s.selectAll('path'), trace);
      styleTextInSelectionMode(s.selectAll('text'), trace, gd);
  }
  
  function styleTextInSelectionMode(txs, trace, gd) {
      txs.each(function(d) {
          var tx = d3.select(this);
          var font;
  
          if(d.selected) {
              font = Lib.ensureUniformFontSize(gd, determineFont(tx, d, trace, gd));
  
              var selectedFontColor = trace.selected.textfont && trace.selected.textfont.color;
              if(selectedFontColor) {
                  font.color = selectedFontColor;
              }
  
              Drawing.font(tx, font);
          } else {
              Drawing.selectedTextStyle(tx, trace);
          }
      });
  }
  
  function determineFont(tx, d, trace, gd) {
      var layoutFont = gd._fullLayout.font;
      var textFont = trace.textfont;
  
      if(tx.classed('bartext-inside')) {
          var barColor = getBarColor(d, trace);
          textFont = getInsideTextFont(trace, d.i, layoutFont, barColor);
      } else if(tx.classed('bartext-outside')) {
          textFont = getOutsideTextFont(trace, d.i, layoutFont);
      }
  
      return textFont;
  }
  
  function getTextFont(trace, index, defaultValue) {
      return getFontValue(
        attributeTextFont, trace.textfont, index, defaultValue);
  }
  
  function getInsideTextFont(trace, index, layoutFont, barColor) {
      var defaultFont = getTextFont(trace, index, layoutFont);
  
      var wouldFallBackToLayoutFont =
        (trace._input.textfont === undefined || trace._input.textfont.color === undefined) ||
        (Array.isArray(trace.textfont.color) && trace.textfont.color[index] === undefined);
      if(wouldFallBackToLayoutFont) {
          defaultFont = {
              color: Color.contrast(barColor),
              family: defaultFont.family,
              size: defaultFont.size
          };
      }
  
      return getFontValue(
        attributeInsideTextFont, trace.insidetextfont, index, defaultFont);
  }
  
  function getOutsideTextFont(trace, index, layoutFont) {
      var defaultFont = getTextFont(trace, index, layoutFont);
      return getFontValue(
        attributeOutsideTextFont, trace.outsidetextfont, index, defaultFont);
  }
  
  function getFontValue(attributeDefinition, attributeValue, index, defaultValue) {
      attributeValue = attributeValue || {};
  
      var familyValue = helpers.getValue(attributeValue.family, index);
      var sizeValue = helpers.getValue(attributeValue.size, index);
      var colorValue = helpers.getValue(attributeValue.color, index);
  
      return {
          family: helpers.coerceString(
            attributeDefinition.family, familyValue, defaultValue.family),
          size: helpers.coerceNumber(
            attributeDefinition.size, sizeValue, defaultValue.size),
          color: helpers.coerceColor(
            attributeDefinition.color, colorValue, defaultValue.color)
      };
  }
  
  function getBarColor(cd, trace) {
      if(trace.type === 'waterfall') {
          return trace[cd.dir].marker.color;
      }
      return cd.mc || trace.marker.color;
  }
  
  module.exports = {
      style: style,
      styleTextPoints: styleTextPoints,
      styleOnSelect: styleOnSelect,
      getInsideTextFont: getInsideTextFont,
      getOutsideTextFont: getOutsideTextFont,
      getBarColor: getBarColor,
      resizeText: resizeText
  };
  
  },{"../../components/color":615,"../../components/drawing":637,"../../lib":750,"../../registry":882,"./attributes":892,"./helpers":898,"./uniform_text":908,"d3":169}],907:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Color = _dereq_('../../components/color');
  var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  
  module.exports = function handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout) {
      coerce('marker.color', defaultColor);
  
      if(hasColorscale(traceIn, 'marker')) {
          colorscaleDefaults(
              traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'}
          );
      }
  
      coerce('marker.line.color', Color.defaultLine);
  
      if(hasColorscale(traceIn, 'marker.line')) {
          colorscaleDefaults(
              traceIn, traceOut, layout, coerce, {prefix: 'marker.line.', cLetter: 'c'}
          );
      }
  
      coerce('marker.line.width');
      coerce('marker.opacity');
      coerce('selected.marker.color');
      coerce('unselected.marker.color');
  };
  
  },{"../../components/color":615,"../../components/colorscale/defaults":625,"../../components/colorscale/helpers":626}],908:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../lib');
  
  function resizeText(gd, gTrace, traceType) {
      var fullLayout = gd._fullLayout;
      var minSize = fullLayout['_' + traceType + 'Text_minsize'];
      if(minSize) {
          var shouldHide = fullLayout.uniformtext.mode === 'hide';
  
          var selector;
          switch(traceType) {
              case 'funnelarea' :
              case 'pie' :
              case 'sunburst' :
                  selector = 'g.slice';
                  break;
              case 'treemap' :
                  selector = 'g.slice, g.pathbar';
                  break;
              default :
                  selector = 'g.points > g.point';
          }
  
          gTrace.selectAll(selector).each(function(d) {
              var transform = d.transform;
              if(transform) {
                  transform.scale = (shouldHide && transform.hide) ? 0 : minSize / transform.fontSize;
  
                  var el = d3.select(this).select('text');
                  el.attr('transform', Lib.getTextTransform(transform));
              }
          });
      }
  }
  
  function recordMinTextSize(
      traceType, // in
      transform, // inout
      fullLayout // inout
  ) {
      if(fullLayout.uniformtext.mode) {
          var minKey = getMinKey(traceType);
          var minSize = fullLayout.uniformtext.minsize;
          var size = transform.scale * transform.fontSize;
  
          transform.hide = size < minSize;
  
          fullLayout[minKey] = fullLayout[minKey] || Infinity;
          if(!transform.hide) {
              fullLayout[minKey] = Math.min(
                  fullLayout[minKey],
                  Math.max(size, minSize)
              );
          }
      }
  }
  
  function clearMinTextSize(
      traceType, // in
      fullLayout // inout
  ) {
      var minKey = getMinKey(traceType);
      fullLayout[minKey] = undefined;
  }
  
  function getMinKey(traceType) {
      return '_' + traceType + 'Text_minsize';
  }
  
  module.exports = {
      recordMinTextSize: recordMinTextSize,
      clearMinTextSize: clearMinTextSize,
      resizeText: resizeText
  };
  
  },{"../../lib":750,"d3":169}],909:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var scatterPolarAttrs = _dereq_('../scatterpolar/attributes');
  var barAttrs = _dereq_('../bar/attributes');
  
  module.exports = {
      r: scatterPolarAttrs.r,
      theta: scatterPolarAttrs.theta,
      r0: scatterPolarAttrs.r0,
      dr: scatterPolarAttrs.dr,
      theta0: scatterPolarAttrs.theta0,
      dtheta: scatterPolarAttrs.dtheta,
      thetaunit: scatterPolarAttrs.thetaunit,
  
      // orientation: {
      //     valType: 'enumerated',
      //     
      //     values: ['radial', 'angular'],
      //     editType: 'calc+clearAxisTypes',
      //     
      // },
  
      base: extendFlat({}, barAttrs.base, {
          
      }),
      offset: extendFlat({}, barAttrs.offset, {
          
      }),
      width: extendFlat({}, barAttrs.width, {
          
      }),
  
      text: extendFlat({}, barAttrs.text, {
          
      }),
      hovertext: extendFlat({}, barAttrs.hovertext, {
          
      }),
  
      // textposition: {},
      // textfont: {},
      // insidetextfont: {},
      // outsidetextfont: {},
      // constraintext: {},
      // cliponaxis: extendFlat({}, barAttrs.cliponaxis, {dflt: false}),
  
      marker: barAttrs.marker,
  
      hoverinfo: scatterPolarAttrs.hoverinfo,
      hovertemplate: hovertemplateAttrs(),
  
      selected: barAttrs.selected,
      unselected: barAttrs.unselected
  
      // error_x (error_r, error_theta)
      // error_y
  };
  
  },{"../../lib/extend":740,"../../plots/template_attributes":877,"../bar/attributes":892,"../scatterpolar/attributes":1232}],910:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  var arraysToCalcdata = _dereq_('../bar/arrays_to_calcdata');
  var setGroupPositions = _dereq_('../bar/cross_trace_calc').setGroupPositions;
  var calcSelection = _dereq_('../scatter/calc_selection');
  var traceIs = _dereq_('../../registry').traceIs;
  var extendFlat = _dereq_('../../lib').extendFlat;
  
  function calc(gd, trace) {
      var fullLayout = gd._fullLayout;
      var subplotId = trace.subplot;
      var radialAxis = fullLayout[subplotId].radialaxis;
      var angularAxis = fullLayout[subplotId].angularaxis;
      var rArray = radialAxis.makeCalcdata(trace, 'r');
      var thetaArray = angularAxis.makeCalcdata(trace, 'theta');
      var len = trace._length;
      var cd = new Array(len);
  
      // 'size' axis variables
      var sArray = rArray;
      // 'pos' axis variables
      var pArray = thetaArray;
  
      for(var i = 0; i < len; i++) {
          cd[i] = {p: pArray[i], s: sArray[i]};
      }
  
      // convert width and offset in 'c' coordinate,
      // set 'c' value(s) in trace._width and trace._offset,
      // to make Bar.crossTraceCalc "just work"
      function d2c(attr) {
          var val = trace[attr];
          if(val !== undefined) {
              trace['_' + attr] = Array.isArray(val) ?
                  angularAxis.makeCalcdata(trace, attr) :
                  angularAxis.d2c(val, trace.thetaunit);
          }
      }
  
      if(angularAxis.type === 'linear') {
          d2c('width');
          d2c('offset');
      }
  
      if(hasColorscale(trace, 'marker')) {
          colorscaleCalc(gd, trace, {
              vals: trace.marker.color,
              containerStr: 'marker',
              cLetter: 'c'
          });
      }
      if(hasColorscale(trace, 'marker.line')) {
          colorscaleCalc(gd, trace, {
              vals: trace.marker.line.color,
              containerStr: 'marker.line',
              cLetter: 'c'
          });
      }
  
      arraysToCalcdata(cd, trace);
      calcSelection(cd, trace);
  
      return cd;
  }
  
  function crossTraceCalc(gd, polarLayout, subplotId) {
      var calcdata = gd.calcdata;
      var barPolarCd = [];
  
      for(var i = 0; i < calcdata.length; i++) {
          var cdi = calcdata[i];
          var trace = cdi[0].trace;
  
          if(trace.visible === true && traceIs(trace, 'bar') &&
              trace.subplot === subplotId
          ) {
              barPolarCd.push(cdi);
          }
      }
  
      // to make _extremes is filled in correctly so that
      // polar._subplot.radialAxis can get auotrange'd
      // TODO clean up!
      // I think we want to call getAutorange on polar.radialaxis
      // NOT on polar._subplot.radialAxis
      var rAxis = extendFlat({}, polarLayout.radialaxis, {_id: 'x'});
      var aAxis = polarLayout.angularaxis;
  
      setGroupPositions(gd, aAxis, rAxis, barPolarCd, {
          mode: polarLayout.barmode,
          norm: polarLayout.barnorm,
          gap: polarLayout.bargap,
          groupgap: polarLayout.bargroupgap
      });
  }
  
  module.exports = {
      calc: calc,
      crossTraceCalc: crossTraceCalc
  };
  
  },{"../../components/colorscale/calc":623,"../../components/colorscale/helpers":626,"../../lib":750,"../../registry":882,"../bar/arrays_to_calcdata":891,"../bar/cross_trace_calc":895,"../scatter/calc_selection":1160}],911:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleRThetaDefaults = _dereq_('../scatterpolar/defaults').handleRThetaDefaults;
  var handleStyleDefaults = _dereq_('../bar/style_defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      // coerce('orientation', (traceOut.theta && !traceOut.r) ? 'angular' : 'radial');
  
      coerce('thetaunit');
      coerce('base');
      coerce('offset');
      coerce('width');
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      // var textPosition = coerce('textposition');
      // var hasBoth = Array.isArray(textPosition) || textPosition === 'auto';
      // var hasInside = hasBoth || textPosition === 'inside';
      // var hasOutside = hasBoth || textPosition === 'outside';
  
      // if(hasInside || hasOutside) {
      //     var textFont = coerceFont(coerce, 'textfont', layout.font);
      //     if(hasInside) coerceFont(coerce, 'insidetextfont', textFont);
      //     if(hasOutside) coerceFont(coerce, 'outsidetextfont', textFont);
      //     coerce('constraintext');
      //     coerce('selected.textfont.color');
      //     coerce('unselected.textfont.color');
      //     coerce('cliponaxis');
      // }
  
      handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  },{"../../lib":750,"../bar/style_defaults":907,"../scatterpolar/defaults":1234,"./attributes":909}],912:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Fx = _dereq_('../../components/fx');
  var Lib = _dereq_('../../lib');
  var getTraceColor = _dereq_('../bar/hover').getTraceColor;
  var fillText = Lib.fillText;
  var makeHoverPointText = _dereq_('../scatterpolar/hover').makeHoverPointText;
  var isPtInsidePolygon = _dereq_('../../plots/polar/helpers').isPtInsidePolygon;
  
  module.exports = function hoverPoints(pointData, xval, yval) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
  
      var subplot = pointData.subplot;
      var radialAxis = subplot.radialAxis;
      var angularAxis = subplot.angularAxis;
      var vangles = subplot.vangles;
      var inboxFn = vangles ? isPtInsidePolygon : Lib.isPtInsideSector;
      var maxHoverDistance = pointData.maxHoverDistance;
      var period = angularAxis._period || 2 * Math.PI;
  
      var rVal = Math.abs(radialAxis.g2p(Math.sqrt(xval * xval + yval * yval)));
      var thetaVal = Math.atan2(yval, xval);
  
      // polar.(x|y)axis.p2c doesn't get the reversed radial axis range case right
      if(radialAxis.range[0] > radialAxis.range[1]) {
          thetaVal += Math.PI;
      }
  
      var distFn = function(di) {
          if(inboxFn(rVal, thetaVal, [di.rp0, di.rp1], [di.thetag0, di.thetag1], vangles)) {
              return maxHoverDistance +
                  // add a little to the pseudo-distance for wider bars, so that like scatter,
                  // if you are over two overlapping bars, the narrower one wins.
                  Math.min(1, Math.abs(di.thetag1 - di.thetag0) / period) - 1 +
                  // add a gradient so hovering near the end of a
                  // bar makes it a little closer match
                  (di.rp1 - rVal) / (di.rp1 - di.rp0) - 1;
          } else {
              return Infinity;
          }
      };
  
      Fx.getClosest(cd, distFn, pointData);
      if(pointData.index === false) return;
  
      var index = pointData.index;
      var cdi = cd[index];
  
      pointData.x0 = pointData.x1 = cdi.ct[0];
      pointData.y0 = pointData.y1 = cdi.ct[1];
  
      var _cdi = Lib.extendFlat({}, cdi, {r: cdi.s, theta: cdi.p});
      fillText(cdi, trace, pointData);
      makeHoverPointText(_cdi, trace, subplot, pointData);
      pointData.hovertemplate = trace.hovertemplate;
      pointData.color = getTraceColor(trace, cdi);
      pointData.xLabelVal = pointData.yLabelVal = undefined;
  
      if(cdi.s < 0) {
          pointData.idealAlign = 'left';
      }
  
      return [pointData];
  };
  
  },{"../../components/fx":655,"../../lib":750,"../../plots/polar/helpers":864,"../bar/hover":899,"../scatterpolar/hover":1236}],913:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'barpolar',
      basePlotModule: _dereq_('../../plots/polar'),
      categories: ['polar', 'bar', 'showLegend'],
  
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyDefaults: _dereq_('./defaults'),
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
  
      calc: _dereq_('./calc').calc,
      crossTraceCalc: _dereq_('./calc').crossTraceCalc,
  
      plot: _dereq_('./plot'),
      colorbar: _dereq_('../scatter/marker_colorbar'),
      formatLabels: _dereq_('../scatterpolar/format_labels'),
  
      style: _dereq_('../bar/style').style,
      styleOnSelect: _dereq_('../bar/style').styleOnSelect,
  
      hoverPoints: _dereq_('./hover'),
      selectPoints: _dereq_('../bar/select'),
  
      meta: {
          
          
      }
  };
  
  },{"../../plots/polar":865,"../bar/select":904,"../bar/style":906,"../scatter/marker_colorbar":1176,"../scatterpolar/format_labels":1235,"./attributes":909,"./calc":910,"./defaults":911,"./hover":912,"./layout_attributes":914,"./layout_defaults":915,"./plot":916}],914:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      barmode: {
          valType: 'enumerated',
          values: ['stack', 'overlay'],
          dflt: 'stack',
          
          editType: 'calc',
          
      },
      bargap: {
          valType: 'number',
          dflt: 0.1,
          min: 0,
          max: 1,
          
          editType: 'calc',
          
      }
  };
  
  },{}],915:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attrs = _dereq_('./layout_attributes');
  
  module.exports = function(layoutIn, layoutOut, fullData) {
      var subplotsDone = {};
      var sp;
  
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn[sp] || {}, layoutOut[sp], attrs, attr, dflt);
      }
  
      for(var i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
          if(trace.type === 'barpolar' && trace.visible === true) {
              sp = trace.subplot;
              if(!subplotsDone[sp]) {
                  coerce('barmode');
                  coerce('bargap');
                  subplotsDone[sp] = 1;
              }
          }
      }
  };
  
  },{"../../lib":750,"./layout_attributes":914}],916:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  var helpers = _dereq_('../../plots/polar/helpers');
  
  module.exports = function plot(gd, subplot, cdbar) {
      var xa = subplot.xaxis;
      var ya = subplot.yaxis;
      var radialAxis = subplot.radialAxis;
      var angularAxis = subplot.angularAxis;
      var pathFn = makePathFn(subplot);
      var barLayer = subplot.layers.frontplot.select('g.barlayer');
  
      Lib.makeTraceGroups(barLayer, cdbar, 'trace bars').each(function() {
          var plotGroup = d3.select(this);
          var pointGroup = Lib.ensureSingle(plotGroup, 'g', 'points');
          var bars = pointGroup.selectAll('g.point').data(Lib.identity);
  
          bars.enter().append('g')
              .style('vector-effect', 'non-scaling-stroke')
              .style('stroke-miterlimit', 2)
              .classed('point', true);
  
          bars.exit().remove();
  
          bars.each(function(di) {
              var bar = d3.select(this);
  
              var rp0 = di.rp0 = radialAxis.c2p(di.s0);
              var rp1 = di.rp1 = radialAxis.c2p(di.s1);
              var thetag0 = di.thetag0 = angularAxis.c2g(di.p0);
              var thetag1 = di.thetag1 = angularAxis.c2g(di.p1);
  
              var dPath;
  
              if(!isNumeric(rp0) || !isNumeric(rp1) ||
                  !isNumeric(thetag0) || !isNumeric(thetag1) ||
                  rp0 === rp1 || thetag0 === thetag1
              ) {
                  // do not remove blank bars, to keep data-to-node
                  // mapping intact during radial drag, that we
                  // can skip calling _module.style during interactions
                  dPath = 'M0,0Z';
              } else {
                  // this 'center' pt is used for selections and hover labels
                  var rg1 = radialAxis.c2g(di.s1);
                  var thetagMid = (thetag0 + thetag1) / 2;
                  di.ct = [
                      xa.c2p(rg1 * Math.cos(thetagMid)),
                      ya.c2p(rg1 * Math.sin(thetagMid))
                  ];
  
                  dPath = pathFn(rp0, rp1, thetag0, thetag1);
              }
  
              Lib.ensureSingle(bar, 'path').attr('d', dPath);
          });
  
          // clip plotGroup, when trace layer isn't clipped
          Drawing.setClipUrl(
              plotGroup,
              subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null,
              gd
          );
      });
  };
  
  function makePathFn(subplot) {
      var cxx = subplot.cxx;
      var cyy = subplot.cyy;
  
      if(subplot.vangles) {
          return function(r0, r1, _a0, _a1) {
              var a0, a1;
  
              if(Lib.angleDelta(_a0, _a1) > 0) {
                  a0 = _a0;
                  a1 = _a1;
              } else {
                  a0 = _a1;
                  a1 = _a0;
              }
  
              var va0 = helpers.findEnclosingVertexAngles(a0, subplot.vangles)[0];
              var va1 = helpers.findEnclosingVertexAngles(a1, subplot.vangles)[1];
              var vaBar = [va0, (a0 + a1) / 2, va1];
              return helpers.pathPolygonAnnulus(r0, r1, a0, a1, vaBar, cxx, cyy);
          };
      }
  
      return function(r0, r1, a0, a1) {
          return Lib.pathAnnulus(r0, r1, a0, a1, cxx, cyy);
      };
  }
  
  },{"../../components/drawing":637,"../../lib":750,"../../plots/polar/helpers":864,"d3":169,"fast-isnumeric":241}],917:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterAttrs = _dereq_('../scatter/attributes');
  var barAttrs = _dereq_('../bar/attributes');
  var colorAttrs = _dereq_('../../components/color/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var scatterMarkerAttrs = scatterAttrs.marker;
  var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
  
  module.exports = {
      y: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
      x: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
      x0: {
          valType: 'any',
          
          editType: 'calc+clearAxisTypes',
          
      },
      y0: {
          valType: 'any',
          
          editType: 'calc+clearAxisTypes',
          
      },
  
      dx: {
          valType: 'number',
          
          editType: 'calc',
          
      },
      dy: {
          valType: 'number',
          
          editType: 'calc',
          
      },
  
      xperiod: scatterAttrs.xperiod,
      yperiod: scatterAttrs.yperiod,
      xperiod0: scatterAttrs.xperiod0,
      yperiod0: scatterAttrs.yperiod0,
      xperiodalignment: scatterAttrs.xperiodalignment,
      yperiodalignment: scatterAttrs.yperiodalignment,
  
      name: {
          valType: 'string',
          
          editType: 'calc+clearAxisTypes',
          
      },
  
      q1: {
          valType: 'data_array',
          
          editType: 'calc+clearAxisTypes',
          
      },
      median: {
          valType: 'data_array',
          
          editType: 'calc+clearAxisTypes',
          
      },
      q3: {
          valType: 'data_array',
          
          editType: 'calc+clearAxisTypes',
          
      },
      lowerfence: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
      upperfence: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
  
      notched: {
          valType: 'boolean',
          
          editType: 'calc',
          
      },
      notchwidth: {
          valType: 'number',
          min: 0,
          max: 0.5,
          dflt: 0.25,
          
          editType: 'calc',
          
      },
      notchspan: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
  
      // TODO
      // maybe add
      // - loweroutlierbound / upperoutlierbound
      // - lowersuspectedoutlierbound / uppersuspectedoutlierbound
  
      boxpoints: {
          valType: 'enumerated',
          values: ['all', 'outliers', 'suspectedoutliers', false],
          
          editType: 'calc',
          
      },
      jitter: {
          valType: 'number',
          min: 0,
          max: 1,
          
          editType: 'calc',
          
      },
      pointpos: {
          valType: 'number',
          min: -2,
          max: 2,
          
          editType: 'calc',
          
      },
  
      boxmean: {
          valType: 'enumerated',
          values: [true, 'sd', false],
          
          editType: 'calc',
          
      },
      mean: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
      sd: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
  
      orientation: {
          valType: 'enumerated',
          values: ['v', 'h'],
          
          editType: 'calc+clearAxisTypes',
          
      },
  
      quartilemethod: {
          valType: 'enumerated',
          values: ['linear', 'exclusive', 'inclusive'],
          dflt: 'linear',
          
          editType: 'calc',
          
      },
  
      width: {
          valType: 'number',
          min: 0,
          
          dflt: 0,
          editType: 'calc',
          
      },
  
      marker: {
          outliercolor: {
              valType: 'color',
              dflt: 'rgba(0, 0, 0, 0)',
              
              editType: 'style',
              
          },
          symbol: extendFlat({}, scatterMarkerAttrs.symbol,
              {arrayOk: false, editType: 'plot'}),
          opacity: extendFlat({}, scatterMarkerAttrs.opacity,
              {arrayOk: false, dflt: 1, editType: 'style'}),
          size: extendFlat({}, scatterMarkerAttrs.size,
              {arrayOk: false, editType: 'calc'}),
          color: extendFlat({}, scatterMarkerAttrs.color,
              {arrayOk: false, editType: 'style'}),
          line: {
              color: extendFlat({}, scatterMarkerLineAttrs.color,
                  {arrayOk: false, dflt: colorAttrs.defaultLine, editType: 'style'}
              ),
              width: extendFlat({}, scatterMarkerLineAttrs.width,
                  {arrayOk: false, dflt: 0, editType: 'style'}
              ),
              outliercolor: {
                  valType: 'color',
                  
                  editType: 'style',
                  
              },
              outlierwidth: {
                  valType: 'number',
                  min: 0,
                  dflt: 1,
                  
                  editType: 'style',
                  
              },
              editType: 'style'
          },
          editType: 'plot'
      },
  
      line: {
          color: {
              valType: 'color',
              
              editType: 'style',
              
          },
          width: {
              valType: 'number',
              
              min: 0,
              dflt: 2,
              editType: 'style',
              
          },
          editType: 'plot'
      },
  
      fillcolor: scatterAttrs.fillcolor,
  
      whiskerwidth: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 0.5,
          
          editType: 'calc',
          
      },
  
      offsetgroup: barAttrs.offsetgroup,
      alignmentgroup: barAttrs.alignmentgroup,
  
      selected: {
          marker: scatterAttrs.selected.marker,
          editType: 'style'
      },
      unselected: {
          marker: scatterAttrs.unselected.marker,
          editType: 'style'
      },
  
      text: extendFlat({}, scatterAttrs.text, {
          
      }),
      hovertext: extendFlat({}, scatterAttrs.hovertext, {
          
      }),
      hovertemplate: hovertemplateAttrs({
          
      }),
  
      hoveron: {
          valType: 'flaglist',
          flags: ['boxes', 'points'],
          dflt: 'boxes+points',
          
          editType: 'style',
          
      }
  };
  
  },{"../../components/color/attributes":614,"../../lib/extend":740,"../../plots/template_attributes":877,"../bar/attributes":892,"../scatter/attributes":1158}],918:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  var Lib = _dereq_('../../lib');
  
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  var _ = Lib._;
  
  module.exports = function calc(gd, trace) {
      var fullLayout = gd._fullLayout;
      var xa = Axes.getFromId(gd, trace.xaxis || 'x');
      var ya = Axes.getFromId(gd, trace.yaxis || 'y');
      var cd = [];
  
      // N.B. violin reuses same Box.calc
      var numKey = trace.type === 'violin' ? '_numViolins' : '_numBoxes';
  
      var i, j;
      var valAxis, valLetter;
      var posAxis, posLetter;
  
      var hasPeriod;
      if(trace.orientation === 'h') {
          valAxis = xa;
          valLetter = 'x';
          posAxis = ya;
          posLetter = 'y';
          hasPeriod = !!trace.yperiodalignment;
      } else {
          valAxis = ya;
          valLetter = 'y';
          posAxis = xa;
          posLetter = 'x';
          hasPeriod = !!trace.xperiodalignment;
      }
  
      var allPosArrays = getPosArrays(trace, posLetter, posAxis, fullLayout[numKey]);
      var posArray = allPosArrays[0];
      var origPos = allPosArrays[1];
      var dv = Lib.distinctVals(posArray);
      var posDistinct = dv.vals;
      var dPos = dv.minDiff / 2;
  
      // item in trace calcdata
      var cdi;
      // array of {v: v, i, i} sample pts
      var pts;
      // values of the `pts` array of objects
      var boxVals;
      // length of sample
      var N;
      // single sample point
      var pt;
      // single sample value
      var v;
  
      // filter function for outlier pts
      // outlier definition based on http://www.physics.csbsju.edu/stats/box2.html
      var ptFilterFn = (trace.boxpoints || trace.points) === 'all' ?
          Lib.identity :
          function(pt) { return (pt.v < cdi.lf || pt.v > cdi.uf); };
  
      if(trace._hasPreCompStats) {
          var valArrayRaw = trace[valLetter];
          var d2c = function(k) { return valAxis.d2c((trace[k] || [])[i]); };
          var minVal = Infinity;
          var maxVal = -Infinity;
  
          for(i = 0; i < trace._length; i++) {
              var posi = posArray[i];
              if(!isNumeric(posi)) continue;
  
              cdi = {};
              cdi.pos = cdi[posLetter] = posi;
              if(hasPeriod && origPos) {
                  cdi.orig_p = origPos[i]; // used by hover
              }
  
              cdi.q1 = d2c('q1');
              cdi.med = d2c('median');
              cdi.q3 = d2c('q3');
  
              pts = [];
              if(valArrayRaw && Lib.isArrayOrTypedArray(valArrayRaw[i])) {
                  for(j = 0; j < valArrayRaw[i].length; j++) {
                      v = valAxis.d2c(valArrayRaw[i][j]);
                      if(v !== BADNUM) {
                          pt = {v: v, i: [i, j]};
                          arraysToCalcdata(pt, trace, [i, j]);
                          pts.push(pt);
                      }
                  }
              }
              cdi.pts = pts.sort(sortByVal);
              boxVals = cdi[valLetter] = pts.map(extractVal);
              N = boxVals.length;
  
              if(cdi.med !== BADNUM && cdi.q1 !== BADNUM && cdi.q3 !== BADNUM &&
                  cdi.med >= cdi.q1 && cdi.q3 >= cdi.med
              ) {
                  var lf = d2c('lowerfence');
                  cdi.lf = (lf !== BADNUM && lf <= cdi.q1) ?
                      lf :
                      computeLowerFence(cdi, boxVals, N);
  
                  var uf = d2c('upperfence');
                  cdi.uf = (uf !== BADNUM && uf >= cdi.q3) ?
                      uf :
                      computeUpperFence(cdi, boxVals, N);
  
                  var mean = d2c('mean');
                  cdi.mean = (mean !== BADNUM) ?
                      mean :
                      (N ? Lib.mean(boxVals, N) : (cdi.q1 + cdi.q3) / 2);
  
                  var sd = d2c('sd');
                  cdi.sd = (mean !== BADNUM && sd >= 0) ?
                      sd :
                      (N ? Lib.stdev(boxVals, N, cdi.mean) : (cdi.q3 - cdi.q1));
  
                  cdi.lo = computeLowerOutlierBound(cdi);
                  cdi.uo = computeUpperOutlierBound(cdi);
  
                  var ns = d2c('notchspan');
                  ns = (ns !== BADNUM && ns > 0) ? ns : computeNotchSpan(cdi, N);
                  cdi.ln = cdi.med - ns;
                  cdi.un = cdi.med + ns;
  
                  var imin = cdi.lf;
                  var imax = cdi.uf;
                  if(trace.boxpoints && boxVals.length) {
                      imin = Math.min(imin, boxVals[0]);
                      imax = Math.max(imax, boxVals[N - 1]);
                  }
                  if(trace.notched) {
                      imin = Math.min(imin, cdi.ln);
                      imax = Math.max(imax, cdi.un);
                  }
                  cdi.min = imin;
                  cdi.max = imax;
              } else {
                  Lib.warn([
                      'Invalid input - make sure that q1 <= median <= q3',
                      'q1 = ' + cdi.q1,
                      'median = ' + cdi.med,
                      'q3 = ' + cdi.q3
                  ].join('\n'));
  
                  var v0;
                  if(cdi.med !== BADNUM) {
                      v0 = cdi.med;
                  } else if(cdi.q1 !== BADNUM) {
                      if(cdi.q3 !== BADNUM) v0 = (cdi.q1 + cdi.q3) / 2;
                      else v0 = cdi.q1;
                  } else if(cdi.q3 !== BADNUM) {
                      v0 = cdi.q3;
                  } else {
                      v0 = 0;
                  }
  
                  // draw box as line segment
                  cdi.med = v0;
                  cdi.q1 = cdi.q3 = v0;
                  cdi.lf = cdi.uf = v0;
                  cdi.mean = cdi.sd = v0;
                  cdi.ln = cdi.un = v0;
                  cdi.min = cdi.max = v0;
              }
  
              minVal = Math.min(minVal, cdi.min);
              maxVal = Math.max(maxVal, cdi.max);
  
              cdi.pts2 = pts.filter(ptFilterFn);
  
              cd.push(cdi);
          }
  
          trace._extremes[valAxis._id] = Axes.findExtremes(valAxis,
              [minVal, maxVal],
              {padded: true}
          );
      } else {
          var valArray = valAxis.makeCalcdata(trace, valLetter);
          var posBins = makeBins(posDistinct, dPos);
          var pLen = posDistinct.length;
          var ptsPerBin = initNestedArray(pLen);
  
          // bin pts info per position bins
          for(i = 0; i < trace._length; i++) {
              v = valArray[i];
              if(!isNumeric(v)) continue;
  
              var n = Lib.findBin(posArray[i], posBins);
              if(n >= 0 && n < pLen) {
                  pt = {v: v, i: i};
                  arraysToCalcdata(pt, trace, i);
                  ptsPerBin[n].push(pt);
              }
          }
  
          var minLowerNotch = Infinity;
          var maxUpperNotch = -Infinity;
  
          var quartilemethod = trace.quartilemethod;
          var usesExclusive = quartilemethod === 'exclusive';
          var usesInclusive = quartilemethod === 'inclusive';
  
          // build calcdata trace items, one item per distinct position
          for(i = 0; i < pLen; i++) {
              if(ptsPerBin[i].length > 0) {
                  cdi = {};
                  cdi.pos = cdi[posLetter] = posDistinct[i];
  
                  pts = cdi.pts = ptsPerBin[i].sort(sortByVal);
                  boxVals = cdi[valLetter] = pts.map(extractVal);
                  N = boxVals.length;
  
                  cdi.min = boxVals[0];
                  cdi.max = boxVals[N - 1];
                  cdi.mean = Lib.mean(boxVals, N);
                  cdi.sd = Lib.stdev(boxVals, N, cdi.mean);
                  cdi.med = Lib.interp(boxVals, 0.5);
  
                  if((N % 2) && (usesExclusive || usesInclusive)) {
                      var lower;
                      var upper;
  
                      if(usesExclusive) {
                          // do NOT include the median in either half
                          lower = boxVals.slice(0, N / 2);
                          upper = boxVals.slice(N / 2 + 1);
                      } else if(usesInclusive) {
                          // include the median in either half
                          lower = boxVals.slice(0, N / 2 + 1);
                          upper = boxVals.slice(N / 2);
                      }
  
                      cdi.q1 = Lib.interp(lower, 0.5);
                      cdi.q3 = Lib.interp(upper, 0.5);
                  } else {
                      cdi.q1 = Lib.interp(boxVals, 0.25);
                      cdi.q3 = Lib.interp(boxVals, 0.75);
                  }
  
                  // lower and upper fences
                  cdi.lf = computeLowerFence(cdi, boxVals, N);
                  cdi.uf = computeUpperFence(cdi, boxVals, N);
  
                  // lower and upper outliers bounds
                  cdi.lo = computeLowerOutlierBound(cdi);
                  cdi.uo = computeUpperOutlierBound(cdi);
  
                  // lower and upper notches
                  var mci = computeNotchSpan(cdi, N);
                  cdi.ln = cdi.med - mci;
                  cdi.un = cdi.med + mci;
                  minLowerNotch = Math.min(minLowerNotch, cdi.ln);
                  maxUpperNotch = Math.max(maxUpperNotch, cdi.un);
  
                  cdi.pts2 = pts.filter(ptFilterFn);
  
                  cd.push(cdi);
              }
          }
  
          trace._extremes[valAxis._id] = Axes.findExtremes(valAxis,
              trace.notched ? valArray.concat([minLowerNotch, maxUpperNotch]) : valArray,
              {padded: true}
          );
      }
  
      calcSelection(cd, trace);
  
      if(cd.length > 0) {
          cd[0].t = {
              num: fullLayout[numKey],
              dPos: dPos,
              posLetter: posLetter,
              valLetter: valLetter,
              labels: {
                  med: _(gd, 'median:'),
                  min: _(gd, 'min:'),
                  q1: _(gd, 'q1:'),
                  q3: _(gd, 'q3:'),
                  max: _(gd, 'max:'),
                  mean: trace.boxmean === 'sd' ? _(gd, 'mean ± σ:') : _(gd, 'mean:'),
                  lf: _(gd, 'lower fence:'),
                  uf: _(gd, 'upper fence:')
              }
          };
  
          fullLayout[numKey]++;
          return cd;
      } else {
          return [{t: {empty: true}}];
      }
  };
  
  // In vertical (horizontal) box plots:
  // if no x (y) data, use x0 (y0), or name
  // so if you want one box
  // per trace, set x0 (y0) to the x (y) value or category for this trace
  // (or set x (y) to a constant array matching y (x))
  function getPosArrays(trace, posLetter, posAxis, num) {
      var hasPosArray = posLetter in trace;
      var hasPos0 = posLetter + '0' in trace;
      var hasPosStep = 'd' + posLetter in trace;
  
      if(hasPosArray || (hasPos0 && hasPosStep)) {
          var origPos = posAxis.makeCalcdata(trace, posLetter);
          var pos = alignPeriod(trace, posAxis, posLetter, origPos);
          return [pos, origPos];
      }
  
      var pos0;
      if(hasPos0) {
          pos0 = trace[posLetter + '0'];
      } else if('name' in trace && (
          posAxis.type === 'category' || (
              isNumeric(trace.name) &&
              ['linear', 'log'].indexOf(posAxis.type) !== -1
          ) || (
              Lib.isDateTime(trace.name) &&
              posAxis.type === 'date'
          )
      )) {
          pos0 = trace.name;
      } else {
          pos0 = num;
      }
  
      var pos0c = posAxis.type === 'multicategory' ?
          posAxis.r2c_just_indices(pos0) :
          posAxis.d2c(pos0, 0, trace[posLetter + 'calendar']);
  
      var len = trace._length;
      var out = new Array(len);
      for(var i = 0; i < len; i++) out[i] = pos0c;
  
      return [out];
  }
  
  function makeBins(x, dx) {
      var len = x.length;
      var bins = new Array(len + 1);
  
      for(var i = 0; i < len; i++) {
          bins[i] = x[i] - dx;
      }
      bins[len] = x[len - 1] + dx;
  
      return bins;
  }
  
  function initNestedArray(len) {
      var arr = new Array(len);
      for(var i = 0; i < len; i++) {
          arr[i] = [];
      }
      return arr;
  }
  
  var TRACE_TO_CALC = {
      text: 'tx',
      hovertext: 'htx'
  };
  
  function arraysToCalcdata(pt, trace, ptNumber) {
      for(var k in TRACE_TO_CALC) {
          if(Lib.isArrayOrTypedArray(trace[k])) {
              if(Array.isArray(ptNumber)) {
                  if(Lib.isArrayOrTypedArray(trace[k][ptNumber[0]])) {
                      pt[TRACE_TO_CALC[k]] = trace[k][ptNumber[0]][ptNumber[1]];
                  }
              } else {
                  pt[TRACE_TO_CALC[k]] = trace[k][ptNumber];
              }
          }
      }
  }
  
  function calcSelection(cd, trace) {
      if(Lib.isArrayOrTypedArray(trace.selectedpoints)) {
          for(var i = 0; i < cd.length; i++) {
              var pts = cd[i].pts || [];
              var ptNumber2cdIndex = {};
  
              for(var j = 0; j < pts.length; j++) {
                  ptNumber2cdIndex[pts[j].i] = j;
              }
  
              Lib.tagSelected(pts, trace, ptNumber2cdIndex);
          }
      }
  }
  
  function sortByVal(a, b) { return a.v - b.v; }
  
  function extractVal(o) { return o.v; }
  
  // last point below 1.5 * IQR
  function computeLowerFence(cdi, boxVals, N) {
      if(N === 0) return cdi.q1;
      return Math.min(
          cdi.q1,
          boxVals[Math.min(
              Lib.findBin(2.5 * cdi.q1 - 1.5 * cdi.q3, boxVals, true) + 1,
              N - 1
          )]
      );
  }
  
  // last point above 1.5 * IQR
  function computeUpperFence(cdi, boxVals, N) {
      if(N === 0) return cdi.q3;
      return Math.max(
          cdi.q3,
          boxVals[Math.max(
              Lib.findBin(2.5 * cdi.q3 - 1.5 * cdi.q1, boxVals),
              0
          )]
      );
  }
  
  // 3 IQR below (don't clip to max/min,
  // this is only for discriminating suspected & far outliers)
  function computeLowerOutlierBound(cdi) {
      return 4 * cdi.q1 - 3 * cdi.q3;
  }
  
  // 3 IQR above (don't clip to max/min,
  // this is only for discriminating suspected & far outliers)
  function computeUpperOutlierBound(cdi) {
      return 4 * cdi.q3 - 3 * cdi.q1;
  }
  
  // 95% confidence intervals for median
  function computeNotchSpan(cdi, N) {
      if(N === 0) return 0;
      return 1.57 * (cdi.q3 - cdi.q1) / Math.sqrt(N);
  }
  
  },{"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/align_period":796,"../../plots/cartesian/axes":799,"fast-isnumeric":241}],919:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Lib = _dereq_('../../lib');
  var getAxisGroup = _dereq_('../../plots/cartesian/axis_ids').getAxisGroup;
  
  var orientations = ['v', 'h'];
  
  function crossTraceCalc(gd, plotinfo) {
      var calcdata = gd.calcdata;
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      for(var i = 0; i < orientations.length; i++) {
          var orientation = orientations[i];
          var posAxis = orientation === 'h' ? ya : xa;
          var boxList = [];
  
          // make list of boxes / candlesticks
          // For backward compatibility, candlesticks are treated as if they *are* box traces here
          for(var j = 0; j < calcdata.length; j++) {
              var cd = calcdata[j];
              var t = cd[0].t;
              var trace = cd[0].trace;
  
              if(trace.visible === true &&
                      (trace.type === 'box' || trace.type === 'candlestick') &&
                      !t.empty &&
                      (trace.orientation || 'v') === orientation &&
                      trace.xaxis === xa._id &&
                      trace.yaxis === ya._id
                ) {
                  boxList.push(j);
              }
          }
  
          setPositionOffset('box', gd, boxList, posAxis);
      }
  }
  
  function setPositionOffset(traceType, gd, boxList, posAxis) {
      var calcdata = gd.calcdata;
      var fullLayout = gd._fullLayout;
      var axId = posAxis._id;
      var axLetter = axId.charAt(0);
  
      var i, j, calcTrace;
      var pointList = [];
      var shownPts = 0;
  
      // make list of box points
      for(i = 0; i < boxList.length; i++) {
          calcTrace = calcdata[boxList[i]];
          for(j = 0; j < calcTrace.length; j++) {
              pointList.push(posAxis.c2l(calcTrace[j].pos, true));
              shownPts += (calcTrace[j].pts2 || []).length;
          }
      }
  
      if(!pointList.length) return;
  
      // box plots - update dPos based on multiple traces
      var boxdv = Lib.distinctVals(pointList, {
          unitMinDiff: posAxis.type === 'category' || posAxis.type === 'multicategory'
      });
  
      var dPos0 = boxdv.minDiff / 2;
  
      // check for forced minimum dtick
      Axes.minDtick(posAxis, boxdv.minDiff, boxdv.vals[0], true);
  
      var numKey = traceType === 'violin' ? '_numViolins' : '_numBoxes';
      var numTotal = fullLayout[numKey];
      var group = fullLayout[traceType + 'mode'] === 'group' && numTotal > 1;
      var groupFraction = 1 - fullLayout[traceType + 'gap'];
      var groupGapFraction = 1 - fullLayout[traceType + 'groupgap'];
  
      for(i = 0; i < boxList.length; i++) {
          calcTrace = calcdata[boxList[i]];
  
          var trace = calcTrace[0].trace;
          var t = calcTrace[0].t;
          var width = trace.width;
          var side = trace.side;
  
          // position coordinate delta
          var dPos;
          // box half width;
          var bdPos;
          // box center offset
          var bPos;
          // half-width within which to accept hover for this box/violin
          // always split the distance to the closest box/violin
          var wHover;
  
          if(width) {
              dPos = bdPos = wHover = width / 2;
              bPos = 0;
          } else {
              dPos = dPos0;
  
              if(group) {
                  var groupId = getAxisGroup(fullLayout, posAxis._id) + trace.orientation;
                  var alignmentGroups = fullLayout._alignmentOpts[groupId] || {};
                  var alignmentGroupOpts = alignmentGroups[trace.alignmentgroup] || {};
                  var nOffsetGroups = Object.keys(alignmentGroupOpts.offsetGroups || {}).length;
                  var num = nOffsetGroups || numTotal;
                  var shift = nOffsetGroups ? trace._offsetIndex : t.num;
  
                  bdPos = dPos * groupFraction * groupGapFraction / num;
                  bPos = 2 * dPos * (-0.5 + (shift + 0.5) / num) * groupFraction;
                  wHover = dPos * groupFraction / num;
              } else {
                  bdPos = dPos * groupFraction * groupGapFraction;
                  bPos = 0;
                  wHover = dPos;
              }
          }
          t.dPos = dPos;
          t.bPos = bPos;
          t.bdPos = bdPos;
          t.wHover = wHover;
  
          // box/violin-only value-space push value
          var pushplus;
          var pushminus;
          // edge of box/violin
          var edge = bPos + bdPos;
          var edgeplus;
          var edgeminus;
          // value-space padding
          var vpadplus;
          var vpadminus;
          // pixel-space padding
          var ppadplus;
          var ppadminus;
          // do we add 5% of both sides (more logic for points beyond box/violin below)
          var padded = Boolean(width);
          // does this trace show points?
          var hasPts = (trace.boxpoints || trace.points) && (shownPts > 0);
  
          if(side === 'positive') {
              pushplus = dPos * (width ? 1 : 0.5);
              edgeplus = edge;
              pushminus = edgeplus = bPos;
          } else if(side === 'negative') {
              pushplus = edgeplus = bPos;
              pushminus = dPos * (width ? 1 : 0.5);
              edgeminus = edge;
          } else {
              pushplus = pushminus = dPos;
              edgeplus = edgeminus = edge;
          }
  
          if(hasPts) {
              var pointpos = trace.pointpos;
              var jitter = trace.jitter;
              var ms = trace.marker.size / 2;
  
              var pp = 0;
              if((pointpos + jitter) >= 0) {
                  pp = edge * (pointpos + jitter);
                  if(pp > pushplus) {
                      // (++) beyond plus-value, use pp
                      padded = true;
                      ppadplus = ms;
                      vpadplus = pp;
                  } else if(pp > edgeplus) {
                      // (+), use push-value (it's bigger), but add px-pad
                      ppadplus = ms;
                      vpadplus = pushplus;
                  }
              }
              if(pp <= pushplus) {
                  // (->) fallback to push value
                  vpadplus = pushplus;
              }
  
              var pm = 0;
              if((pointpos - jitter) <= 0) {
                  pm = -edge * (pointpos - jitter);
                  if(pm > pushminus) {
                      // (--) beyond plus-value, use pp
                      padded = true;
                      ppadminus = ms;
                      vpadminus = pm;
                  } else if(pm > edgeminus) {
                      // (-), use push-value (it's bigger), but add px-pad
                      ppadminus = ms;
                      vpadminus = pushminus;
                  }
              }
              if(pm <= pushminus) {
                  // (<-) fallback to push value
                  vpadminus = pushminus;
              }
          } else {
              vpadplus = pushplus;
              vpadminus = pushminus;
          }
  
          var pos = new Array(calcTrace.length);
          for(j = 0; j < calcTrace.length; j++) {
              pos[j] = calcTrace[j].pos;
          }
  
          trace._extremes[axId] = Axes.findExtremes(posAxis, pos, {
              padded: padded,
              vpadminus: vpadminus,
              vpadplus: vpadplus,
              vpadLinearized: true,
              // N.B. SVG px-space positive/negative
              ppadminus: {x: ppadminus, y: ppadplus}[axLetter],
              ppadplus: {x: ppadplus, y: ppadminus}[axLetter],
          });
      }
  }
  
  module.exports = {
      crossTraceCalc: crossTraceCalc,
      setPositionOffset: setPositionOffset
  };
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"../../plots/cartesian/axis_ids":802}],920:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  var Color = _dereq_('../../components/color');
  var handlePeriodDefaults = _dereq_('../scatter/period_defaults');
  var handleGroupingDefaults = _dereq_('../bar/defaults').handleGroupingDefaults;
  var autoType = _dereq_('../../plots/cartesian/axis_autotype');
  var attributes = _dereq_('./attributes');
  
  function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      handleSampleDefaults(traceIn, traceOut, coerce, layout);
      if(traceOut.visible === false) return;
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  
      var hasPreCompStats = traceOut._hasPreCompStats;
  
      if(hasPreCompStats) {
          coerce('lowerfence');
          coerce('upperfence');
      }
  
      coerce('line.color', (traceIn.marker || {}).color || defaultColor);
      coerce('line.width');
      coerce('fillcolor', Color.addOpacity(traceOut.line.color, 0.5));
  
      var boxmeanDflt = false;
      if(hasPreCompStats) {
          var mean = coerce('mean');
          var sd = coerce('sd');
          if(mean && mean.length) {
              boxmeanDflt = true;
              if(sd && sd.length) boxmeanDflt = 'sd';
          }
      }
      coerce('boxmean', boxmeanDflt);
  
      coerce('whiskerwidth');
      coerce('width');
      coerce('quartilemethod');
  
      var notchedDflt = false;
      if(hasPreCompStats) {
          var notchspan = coerce('notchspan');
          if(notchspan && notchspan.length) {
              notchedDflt = true;
          }
      } else if(Lib.validate(traceIn.notchwidth, attributes.notchwidth)) {
          notchedDflt = true;
      }
      var notched = coerce('notched', notchedDflt);
      if(notched) coerce('notchwidth');
  
      handlePointsDefaults(traceIn, traceOut, coerce, {prefix: 'box'});
  }
  
  function handleSampleDefaults(traceIn, traceOut, coerce, layout) {
      function getDims(arr) {
          var dims = 0;
          if(arr && arr.length) {
              dims += 1;
              if(Lib.isArrayOrTypedArray(arr[0]) && arr[0].length) {
                  dims += 1;
              }
          }
          return dims;
      }
  
      function valid(astr) {
          return Lib.validate(traceIn[astr], attributes[astr]);
      }
  
      var y = coerce('y');
      var x = coerce('x');
  
      var sLen;
      if(traceOut.type === 'box') {
          var q1 = coerce('q1');
          var median = coerce('median');
          var q3 = coerce('q3');
  
          traceOut._hasPreCompStats = (
              q1 && q1.length &&
              median && median.length &&
              q3 && q3.length
          );
          sLen = Math.min(
              Lib.minRowLength(q1),
              Lib.minRowLength(median),
              Lib.minRowLength(q3)
          );
      }
  
      var yDims = getDims(y);
      var xDims = getDims(x);
      var yLen = yDims && Lib.minRowLength(y);
      var xLen = xDims && Lib.minRowLength(x);
  
      var defaultOrientation, len;
      if(traceOut._hasPreCompStats) {
          switch(String(xDims) + String(yDims)) {
              // no x / no y
              case '00':
                  var setInX = valid('x0') || valid('dx');
                  var setInY = valid('y0') || valid('dy');
  
                  if(setInY && !setInX) {
                      defaultOrientation = 'h';
                  } else {
                      defaultOrientation = 'v';
                  }
  
                  len = sLen;
                  break;
              // just x
              case '10':
                  defaultOrientation = 'v';
                  len = Math.min(sLen, xLen);
                  break;
              case '20':
                  defaultOrientation = 'h';
                  len = Math.min(sLen, x.length);
                  break;
              // just y
              case '01':
                  defaultOrientation = 'h';
                  len = Math.min(sLen, yLen);
                  break;
              case '02':
                  defaultOrientation = 'v';
                  len = Math.min(sLen, y.length);
                  break;
              // both
              case '12':
                  defaultOrientation = 'v';
                  len = Math.min(sLen, xLen, y.length);
                  break;
              case '21':
                  defaultOrientation = 'h';
                  len = Math.min(sLen, x.length, yLen);
                  break;
              case '11':
                  // this one is ill-defined
                  len = 0;
                  break;
              case '22':
                  var hasCategories = false;
                  var i;
                  for(i = 0; i < x.length; i++) {
                      if(autoType(x[i]) === 'category') {
                          hasCategories = true;
                          break;
                      }
                  }
  
                  if(hasCategories) {
                      defaultOrientation = 'v';
                      len = Math.min(sLen, xLen, y.length);
                  } else {
                      for(i = 0; i < y.length; i++) {
                          if(autoType(y[i]) === 'category') {
                              hasCategories = true;
                              break;
                          }
                      }
  
                      if(hasCategories) {
                          defaultOrientation = 'h';
                          len = Math.min(sLen, x.length, yLen);
                      } else {
                          defaultOrientation = 'v';
                          len = Math.min(sLen, xLen, y.length);
                      }
                  }
                  break;
          }
      } else if(yDims > 0) {
          defaultOrientation = 'v';
          if(xDims > 0) {
              len = Math.min(xLen, yLen);
          } else {
              len = Math.min(yLen);
          }
      } else if(xDims > 0) {
          defaultOrientation = 'h';
          len = Math.min(xLen);
      } else {
          len = 0;
      }
  
      if(!len) {
          traceOut.visible = false;
          return;
      }
      traceOut._length = len;
  
      var orientation = coerce('orientation', defaultOrientation);
  
      // these are just used for positioning, they never define the sample
      if(traceOut._hasPreCompStats) {
          if(orientation === 'v' && xDims === 0) {
              coerce('x0', 0);
              coerce('dx', 1);
          } else if(orientation === 'h' && yDims === 0) {
              coerce('y0', 0);
              coerce('dy', 1);
          }
      } else {
          if(orientation === 'v' && xDims === 0) {
              coerce('x0');
          } else if(orientation === 'h' && yDims === 0) {
              coerce('y0');
          }
      }
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
  }
  
  function handlePointsDefaults(traceIn, traceOut, coerce, opts) {
      var prefix = opts.prefix;
  
      var outlierColorDflt = Lib.coerce2(traceIn, traceOut, attributes, 'marker.outliercolor');
      var lineoutliercolor = coerce('marker.line.outliercolor');
  
      var modeDflt = 'outliers';
      if(traceOut._hasPreCompStats) {
          modeDflt = 'all';
      } else if(outlierColorDflt || lineoutliercolor) {
          modeDflt = 'suspectedoutliers';
      }
  
      var mode = coerce(prefix + 'points', modeDflt);
  
      if(mode) {
          coerce('jitter', mode === 'all' ? 0.3 : 0);
          coerce('pointpos', mode === 'all' ? -1.5 : 0);
  
          coerce('marker.symbol');
          coerce('marker.opacity');
          coerce('marker.size');
          coerce('marker.color', traceOut.line.color);
          coerce('marker.line.color');
          coerce('marker.line.width');
  
          if(mode === 'suspectedoutliers') {
              coerce('marker.line.outliercolor', traceOut.marker.color);
              coerce('marker.line.outlierwidth');
          }
  
          coerce('selected.marker.color');
          coerce('unselected.marker.color');
          coerce('selected.marker.size');
          coerce('unselected.marker.size');
  
          coerce('text');
          coerce('hovertext');
      } else {
          delete traceOut.marker;
      }
  
      var hoveron = coerce('hoveron');
      if(hoveron === 'all' || hoveron.indexOf('points') !== -1) {
          coerce('hovertemplate');
      }
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  }
  
  function crossTraceDefaults(fullData, fullLayout) {
      var traceIn, traceOut;
  
      function coerce(attr) {
          return Lib.coerce(traceOut._input, traceOut, attributes, attr);
      }
  
      for(var i = 0; i < fullData.length; i++) {
          traceOut = fullData[i];
          var traceType = traceOut.type;
  
          if(traceType === 'box' || traceType === 'violin') {
              traceIn = traceOut._input;
              if(fullLayout[traceType + 'mode'] === 'group') {
                  handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
              }
          }
      }
  }
  
  module.exports = {
      supplyDefaults: supplyDefaults,
      crossTraceDefaults: crossTraceDefaults,
  
      handleSampleDefaults: handleSampleDefaults,
      handlePointsDefaults: handlePointsDefaults
  };
  
  },{"../../components/color":615,"../../lib":750,"../../plots/cartesian/axis_autotype":800,"../../registry":882,"../bar/defaults":896,"../scatter/period_defaults":1178,"./attributes":917}],921:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt) {
      // Note: hoverOnBox property is needed for click-to-select
      // to ignore when a box was clicked. This is the reason box
      // implements this custom eventData function.
      if(pt.hoverOnBox) out.hoverOnBox = pt.hoverOnBox;
  
      if('xVal' in pt) out.x = pt.xVal;
      if('yVal' in pt) out.y = pt.yVal;
      if(pt.xa) out.xaxis = pt.xa;
      if(pt.ya) out.yaxis = pt.ya;
  
      return out;
  };
  
  },{}],922:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Lib = _dereq_('../../lib');
  var Fx = _dereq_('../../components/fx');
  var Color = _dereq_('../../components/color');
  var fillText = Lib.fillText;
  
  function hoverPoints(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
      var hoveron = trace.hoveron;
      var closeBoxData = [];
      var closePtData;
  
      if(hoveron.indexOf('boxes') !== -1) {
          closeBoxData = closeBoxData.concat(hoverOnBoxes(pointData, xval, yval, hovermode));
      }
  
      if(hoveron.indexOf('points') !== -1) {
          closePtData = hoverOnPoints(pointData, xval, yval);
      }
  
      // If there's a point in range and hoveron has points, show the best single point only.
      // If hoveron has boxes and there's no point in range (or hoveron doesn't have points), show the box stats.
      if(hovermode === 'closest') {
          if(closePtData) return [closePtData];
          return closeBoxData;
      }
  
      // Otherwise in compare mode, allow a point AND the box stats to be labeled
      // If there are multiple boxes in range (ie boxmode = 'overlay') we'll see stats for all of them.
      if(closePtData) {
          closeBoxData.push(closePtData);
          return closeBoxData;
      }
      return closeBoxData;
  }
  
  function hoverOnBoxes(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var xa = pointData.xa;
      var ya = pointData.ya;
      var trace = cd[0].trace;
      var t = cd[0].t;
      var isViolin = trace.type === 'violin';
      var closeBoxData = [];
  
      var pLetter, vLetter, pAxis, vAxis, vVal, pVal, dx, dy, dPos,
          hoverPseudoDistance, spikePseudoDistance;
  
      var boxDelta = t.bdPos;
      var boxDeltaPos, boxDeltaNeg;
      var posAcceptance = t.wHover;
      var shiftPos = function(di) { return pAxis.c2l(di.pos) + t.bPos - pAxis.c2l(pVal); };
  
      if(isViolin && trace.side !== 'both') {
          if(trace.side === 'positive') {
              dPos = function(di) {
                  var pos = shiftPos(di);
                  return Fx.inbox(pos, pos + posAcceptance, hoverPseudoDistance);
              };
              boxDeltaPos = boxDelta;
              boxDeltaNeg = 0;
          }
          if(trace.side === 'negative') {
              dPos = function(di) {
                  var pos = shiftPos(di);
                  return Fx.inbox(pos - posAcceptance, pos, hoverPseudoDistance);
              };
              boxDeltaPos = 0;
              boxDeltaNeg = boxDelta;
          }
      } else {
          dPos = function(di) {
              var pos = shiftPos(di);
              return Fx.inbox(pos - posAcceptance, pos + posAcceptance, hoverPseudoDistance);
          };
          boxDeltaPos = boxDeltaNeg = boxDelta;
      }
  
      var dVal;
  
      if(isViolin) {
          dVal = function(di) {
              return Fx.inbox(di.span[0] - vVal, di.span[1] - vVal, hoverPseudoDistance);
          };
      } else {
          dVal = function(di) {
              return Fx.inbox(di.min - vVal, di.max - vVal, hoverPseudoDistance);
          };
      }
  
      if(trace.orientation === 'h') {
          vVal = xval;
          pVal = yval;
          dx = dVal;
          dy = dPos;
          pLetter = 'y';
          pAxis = ya;
          vLetter = 'x';
          vAxis = xa;
      } else {
          vVal = yval;
          pVal = xval;
          dx = dPos;
          dy = dVal;
          pLetter = 'x';
          pAxis = xa;
          vLetter = 'y';
          vAxis = ya;
      }
  
      // if two boxes are overlaying, let the narrowest one win
      var pseudoDistance = Math.min(1, boxDelta / Math.abs(pAxis.r2c(pAxis.range[1]) - pAxis.r2c(pAxis.range[0])));
      hoverPseudoDistance = pointData.maxHoverDistance - pseudoDistance;
      spikePseudoDistance = pointData.maxSpikeDistance - pseudoDistance;
  
      function dxy(di) { return (dx(di) + dy(di)) / 2; }
      var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
      Fx.getClosest(cd, distfn, pointData);
  
      // skip the rest (for this trace) if we didn't find a close point
      // and create the item(s) in closedata for this point
      if(pointData.index === false) return [];
  
      var di = cd[pointData.index];
      var lc = trace.line.color;
      var mc = (trace.marker || {}).color;
  
      if(Color.opacity(lc) && trace.line.width) pointData.color = lc;
      else if(Color.opacity(mc) && trace.boxpoints) pointData.color = mc;
      else pointData.color = trace.fillcolor;
  
      pointData[pLetter + '0'] = pAxis.c2p(di.pos + t.bPos - boxDeltaNeg, true);
      pointData[pLetter + '1'] = pAxis.c2p(di.pos + t.bPos + boxDeltaPos, true);
  
      pointData[pLetter + 'LabelVal'] = di.orig_p !== undefined ? di.orig_p : di.pos;
  
      var spikePosAttr = pLetter + 'Spike';
      pointData.spikeDistance = dxy(di) * spikePseudoDistance / hoverPseudoDistance;
      pointData[spikePosAttr] = pAxis.c2p(di.pos, true);
  
      // box plots: each "point" gets many labels
      var usedVals = {};
      var attrs = ['med', 'q1', 'q3', 'min', 'max'];
  
      if(trace.boxmean || (trace.meanline || {}).visible) {
          attrs.push('mean');
      }
      if(trace.boxpoints || trace.points) {
          attrs.push('lf', 'uf');
      }
  
      for(var i = 0; i < attrs.length; i++) {
          var attr = attrs[i];
  
          if(!(attr in di) || (di[attr] in usedVals)) continue;
          usedVals[di[attr]] = true;
  
          // copy out to a new object for each value to label
          var val = di[attr];
          var valPx = vAxis.c2p(val, true);
          var pointData2 = Lib.extendFlat({}, pointData);
  
          pointData2.attr = attr;
          pointData2[vLetter + '0'] = pointData2[vLetter + '1'] = valPx;
          pointData2[vLetter + 'LabelVal'] = val;
          pointData2[vLetter + 'Label'] = (t.labels ? t.labels[attr] + ' ' : '') + Axes.hoverLabelText(vAxis, val);
  
          // Note: introduced to be able to distinguish a
          // clicked point from a box during click-to-select
          pointData2.hoverOnBox = true;
  
          if(attr === 'mean' && ('sd' in di) && trace.boxmean === 'sd') {
              pointData2[vLetter + 'err'] = di.sd;
          }
  
          // only keep name and spikes on the first item (median)
          pointData.name = '';
          pointData.spikeDistance = undefined;
          pointData[spikePosAttr] = undefined;
  
          // no hovertemplate support yet
          pointData2.hovertemplate = false;
  
          closeBoxData.push(pointData2);
      }
  
      return closeBoxData;
  }
  
  function hoverOnPoints(pointData, xval, yval) {
      var cd = pointData.cd;
      var xa = pointData.xa;
      var ya = pointData.ya;
      var trace = cd[0].trace;
      var xPx = xa.c2p(xval);
      var yPx = ya.c2p(yval);
      var closePtData;
  
      var dx = function(di) {
          var rad = Math.max(3, di.mrc || 0);
          return Math.max(Math.abs(xa.c2p(di.x) - xPx) - rad, 1 - 3 / rad);
      };
      var dy = function(di) {
          var rad = Math.max(3, di.mrc || 0);
          return Math.max(Math.abs(ya.c2p(di.y) - yPx) - rad, 1 - 3 / rad);
      };
      var distfn = Fx.quadrature(dx, dy);
  
      // show one point per trace
      var ijClosest = false;
      var di, pt;
  
      for(var i = 0; i < cd.length; i++) {
          di = cd[i];
  
          for(var j = 0; j < (di.pts || []).length; j++) {
              pt = di.pts[j];
  
              var newDistance = distfn(pt);
              if(newDistance <= pointData.distance) {
                  pointData.distance = newDistance;
                  ijClosest = [i, j];
              }
          }
      }
  
      if(!ijClosest) return false;
  
      di = cd[ijClosest[0]];
      pt = di.pts[ijClosest[1]];
  
      var xc = xa.c2p(pt.x, true);
      var yc = ya.c2p(pt.y, true);
      var rad = pt.mrc || 1;
  
      closePtData = Lib.extendFlat({}, pointData, {
          // corresponds to index in x/y input data array
          index: pt.i,
          color: (trace.marker || {}).color,
          name: trace.name,
          x0: xc - rad,
          x1: xc + rad,
          y0: yc - rad,
          y1: yc + rad,
          spikeDistance: pointData.distance,
          hovertemplate: trace.hovertemplate
      });
  
      var origPos = di.orig_p;
      var pos = origPos !== undefined ? origPos : di.pos;
      var pa;
      if(trace.orientation === 'h') {
          pa = ya;
          closePtData.xLabelVal = pt.x;
          closePtData.yLabelVal = pos;
      } else {
          pa = xa;
          closePtData.xLabelVal = pos;
          closePtData.yLabelVal = pt.y;
      }
  
      var pLetter = pa._id.charAt(0);
      closePtData[pLetter + 'Spike'] = pa.c2p(di.pos, true);
  
      fillText(pt, trace, closePtData);
  
      return closePtData;
  }
  
  module.exports = {
      hoverPoints: hoverPoints,
      hoverOnBoxes: hoverOnBoxes,
      hoverOnPoints: hoverOnPoints
  };
  
  },{"../../components/color":615,"../../components/fx":655,"../../lib":750,"../../plots/cartesian/axes":799}],923:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyDefaults: _dereq_('./defaults').supplyDefaults,
      crossTraceDefaults: _dereq_('./defaults').crossTraceDefaults,
      supplyLayoutDefaults: _dereq_('./layout_defaults').supplyLayoutDefaults,
      calc: _dereq_('./calc'),
      crossTraceCalc: _dereq_('./cross_trace_calc').crossTraceCalc,
      plot: _dereq_('./plot').plot,
      style: _dereq_('./style').style,
      styleOnSelect: _dereq_('./style').styleOnSelect,
      hoverPoints: _dereq_('./hover').hoverPoints,
      eventData: _dereq_('./event_data'),
      selectPoints: _dereq_('./select'),
  
      moduleType: 'trace',
      name: 'box',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', 'symbols', 'oriented', 'box-violin', 'showLegend', 'boxLayout', 'zoomScale'],
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"./attributes":917,"./calc":918,"./cross_trace_calc":919,"./defaults":920,"./event_data":921,"./hover":922,"./layout_attributes":924,"./layout_defaults":925,"./plot":926,"./select":927,"./style":928}],924:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  module.exports = {
      boxmode: {
          valType: 'enumerated',
          values: ['group', 'overlay'],
          dflt: 'overlay',
          
          editType: 'calc',
          
      },
      boxgap: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 0.3,
          
          editType: 'calc',
          
      },
      boxgroupgap: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 0.3,
          
          editType: 'calc',
          
      }
  };
  
  },{}],925:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  function _supply(layoutIn, layoutOut, fullData, coerce, traceType) {
      var category = traceType + 'Layout';
      var hasTraceType = false;
  
      for(var i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
  
          if(Registry.traceIs(trace, category)) {
              hasTraceType = true;
              break;
          }
      }
      if(!hasTraceType) return;
  
      coerce(traceType + 'mode');
      coerce(traceType + 'gap');
      coerce(traceType + 'groupgap');
  }
  
  function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
      _supply(layoutIn, layoutOut, fullData, coerce, 'box');
  }
  
  module.exports = {
      supplyLayoutDefaults: supplyLayoutDefaults,
      _supply: _supply
  };
  
  },{"../../lib":750,"../../registry":882,"./layout_attributes":924}],926:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  
  // constants for dynamic jitter (ie less jitter for sparser points)
  var JITTERCOUNT = 5; // points either side of this to include
  var JITTERSPREAD = 0.01; // fraction of IQR to count as "dense"
  
  function plot(gd, plotinfo, cdbox, boxLayer) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      Lib.makeTraceGroups(boxLayer, cdbox, 'trace boxes').each(function(cd) {
          var plotGroup = d3.select(this);
          var cd0 = cd[0];
          var t = cd0.t;
          var trace = cd0.trace;
  
          // whisker width
          t.wdPos = t.bdPos * trace.whiskerwidth;
  
          if(trace.visible !== true || t.empty) {
              plotGroup.remove();
              return;
          }
  
          var posAxis, valAxis;
  
          if(trace.orientation === 'h') {
              posAxis = ya;
              valAxis = xa;
          } else {
              posAxis = xa;
              valAxis = ya;
          }
  
          plotBoxAndWhiskers(plotGroup, {pos: posAxis, val: valAxis}, trace, t);
          plotPoints(plotGroup, {x: xa, y: ya}, trace, t);
          plotBoxMean(plotGroup, {pos: posAxis, val: valAxis}, trace, t);
      });
  }
  
  function plotBoxAndWhiskers(sel, axes, trace, t) {
      var isHorizontal = trace.orientation === 'h';
      var valAxis = axes.val;
      var posAxis = axes.pos;
      var posHasRangeBreaks = !!posAxis.rangebreaks;
  
      var bPos = t.bPos;
      var wdPos = t.wdPos || 0;
      var bPosPxOffset = t.bPosPxOffset || 0;
      var whiskerWidth = trace.whiskerwidth || 0;
      var notched = trace.notched || false;
      var nw = notched ? 1 - 2 * trace.notchwidth : 1;
  
      // to support for one-sided box
      var bdPos0;
      var bdPos1;
      if(Array.isArray(t.bdPos)) {
          bdPos0 = t.bdPos[0];
          bdPos1 = t.bdPos[1];
      } else {
          bdPos0 = t.bdPos;
          bdPos1 = t.bdPos;
      }
  
      var paths = sel.selectAll('path.box').data((
          trace.type !== 'violin' ||
          trace.box.visible
      ) ? Lib.identity : []);
  
      paths.enter().append('path')
          .style('vector-effect', 'non-scaling-stroke')
          .attr('class', 'box');
  
      paths.exit().remove();
  
      paths.each(function(d) {
          if(d.empty) return 'M0,0Z';
  
          var lcenter = posAxis.c2l(d.pos + bPos, true);
  
          var pos0 = posAxis.l2p(lcenter - bdPos0) + bPosPxOffset;
          var pos1 = posAxis.l2p(lcenter + bdPos1) + bPosPxOffset;
          var posc = posHasRangeBreaks ? (pos0 + pos1) / 2 : posAxis.l2p(lcenter) + bPosPxOffset;
  
          var r = trace.whiskerwidth;
          var posw0 = posHasRangeBreaks ? pos0 * r + (1 - r) * posc : posAxis.l2p(lcenter - wdPos) + bPosPxOffset;
          var posw1 = posHasRangeBreaks ? pos1 * r + (1 - r) * posc : posAxis.l2p(lcenter + wdPos) + bPosPxOffset;
  
          var posm0 = posAxis.l2p(lcenter - bdPos0 * nw) + bPosPxOffset;
          var posm1 = posAxis.l2p(lcenter + bdPos1 * nw) + bPosPxOffset;
          var q1 = valAxis.c2p(d.q1, true);
          var q3 = valAxis.c2p(d.q3, true);
          // make sure median isn't identical to either of the
          // quartiles, so we can see it
          var m = Lib.constrain(
              valAxis.c2p(d.med, true),
              Math.min(q1, q3) + 1, Math.max(q1, q3) - 1
          );
  
          // for compatibility with box, violin, and candlestick
          // perhaps we should put this into cd0.t instead so it's more explicit,
          // but what we have now is:
          // - box always has d.lf, but boxpoints can be anything
          // - violin has d.lf and should always use it (boxpoints is undefined)
          // - candlestick has only min/max
          var useExtremes = (d.lf === undefined) || (trace.boxpoints === false);
          var lf = valAxis.c2p(useExtremes ? d.min : d.lf, true);
          var uf = valAxis.c2p(useExtremes ? d.max : d.uf, true);
          var ln = valAxis.c2p(d.ln, true);
          var un = valAxis.c2p(d.un, true);
  
          if(isHorizontal) {
              d3.select(this).attr('d',
                  'M' + m + ',' + posm0 + 'V' + posm1 + // median line
                  'M' + q1 + ',' + pos0 + 'V' + pos1 + // left edge
                  (notched ?
                      'H' + ln + 'L' + m + ',' + posm1 + 'L' + un + ',' + pos1 :
                      ''
                  ) + // top notched edge
                  'H' + q3 + // end of the top edge
                  'V' + pos0 + // right edge
                  (notched ? 'H' + un + 'L' + m + ',' + posm0 + 'L' + ln + ',' + pos0 : '') + // bottom notched edge
                  'Z' + // end of the box
                  'M' + q1 + ',' + posc + 'H' + lf + 'M' + q3 + ',' + posc + 'H' + uf + // whiskers
                  (whiskerWidth === 0 ?
                      '' : // whisker caps
                      'M' + lf + ',' + posw0 + 'V' + posw1 + 'M' + uf + ',' + posw0 + 'V' + posw1
                  )
              );
          } else {
              d3.select(this).attr('d',
                  'M' + posm0 + ',' + m + 'H' + posm1 + // median line
                  'M' + pos0 + ',' + q1 + 'H' + pos1 + // top of the box
                  (notched ?
                      'V' + ln + 'L' + posm1 + ',' + m + 'L' + pos1 + ',' + un :
                      ''
                  ) + // notched right edge
                  'V' + q3 + // end of the right edge
                  'H' + pos0 + // bottom of the box
                  (notched ?
                      'V' + un + 'L' + posm0 + ',' + m + 'L' + pos0 + ',' + ln :
                      ''
                  ) + // notched left edge
                  'Z' + // end of the box
                  'M' + posc + ',' + q1 + 'V' + lf + 'M' + posc + ',' + q3 + 'V' + uf + // whiskers
                  (whiskerWidth === 0 ?
                      '' : // whisker caps
                      'M' + posw0 + ',' + lf + 'H' + posw1 + 'M' + posw0 + ',' + uf + 'H' + posw1
                  )
              );
          }
      });
  }
  
  function plotPoints(sel, axes, trace, t) {
      var xa = axes.x;
      var ya = axes.y;
      var bdPos = t.bdPos;
      var bPos = t.bPos;
  
      // to support violin points
      var mode = trace.boxpoints || trace.points;
  
      // repeatable pseudo-random number generator
      Lib.seedPseudoRandom();
  
      // since box plot points get an extra level of nesting, each
      // box needs the trace styling info
      var fn = function(d) {
          d.forEach(function(v) {
              v.t = t;
              v.trace = trace;
          });
          return d;
      };
  
      var gPoints = sel.selectAll('g.points')
          .data(mode ? fn : []);
  
      gPoints.enter().append('g')
          .attr('class', 'points');
  
      gPoints.exit().remove();
  
      var paths = gPoints.selectAll('path')
          .data(function(d) {
              var i;
              var pts = d.pts2;
  
              // normally use IQR, but if this is 0 or too small, use max-min
              var typicalSpread = Math.max((d.max - d.min) / 10, d.q3 - d.q1);
              var minSpread = typicalSpread * 1e-9;
              var spreadLimit = typicalSpread * JITTERSPREAD;
              var jitterFactors = [];
              var maxJitterFactor = 0;
              var newJitter;
  
              // dynamic jitter
              if(trace.jitter) {
                  if(typicalSpread === 0) {
                      // edge case of no spread at all: fall back to max jitter
                      maxJitterFactor = 1;
                      jitterFactors = new Array(pts.length);
                      for(i = 0; i < pts.length; i++) {
                          jitterFactors[i] = 1;
                      }
                  } else {
                      for(i = 0; i < pts.length; i++) {
                          var i0 = Math.max(0, i - JITTERCOUNT);
                          var pmin = pts[i0].v;
                          var i1 = Math.min(pts.length - 1, i + JITTERCOUNT);
                          var pmax = pts[i1].v;
  
                          if(mode !== 'all') {
                              if(pts[i].v < d.lf) pmax = Math.min(pmax, d.lf);
                              else pmin = Math.max(pmin, d.uf);
                          }
  
                          var jitterFactor = Math.sqrt(spreadLimit * (i1 - i0) / (pmax - pmin + minSpread)) || 0;
                          jitterFactor = Lib.constrain(Math.abs(jitterFactor), 0, 1);
  
                          jitterFactors.push(jitterFactor);
                          maxJitterFactor = Math.max(jitterFactor, maxJitterFactor);
                      }
                  }
                  newJitter = trace.jitter * 2 / (maxJitterFactor || 1);
              }
  
              // fills in 'x' and 'y' in calcdata 'pts' item
              for(i = 0; i < pts.length; i++) {
                  var pt = pts[i];
                  var v = pt.v;
  
                  var jitterOffset = trace.jitter ?
                      (newJitter * jitterFactors[i] * (Lib.pseudoRandom() - 0.5)) :
                      0;
  
                  var posPx = d.pos + bPos + bdPos * (trace.pointpos + jitterOffset);
  
                  if(trace.orientation === 'h') {
                      pt.y = posPx;
                      pt.x = v;
                  } else {
                      pt.x = posPx;
                      pt.y = v;
                  }
  
                  // tag suspected outliers
                  if(mode === 'suspectedoutliers' && v < d.uo && v > d.lo) {
                      pt.so = true;
                  }
              }
  
              return pts;
          });
  
      paths.enter().append('path')
          .classed('point', true);
  
      paths.exit().remove();
  
      paths.call(Drawing.translatePoints, xa, ya);
  }
  
  function plotBoxMean(sel, axes, trace, t) {
      var valAxis = axes.val;
      var posAxis = axes.pos;
      var posHasRangeBreaks = !!posAxis.rangebreaks;
  
      var bPos = t.bPos;
      var bPosPxOffset = t.bPosPxOffset || 0;
  
      // to support violin mean lines
      var mode = trace.boxmean || (trace.meanline || {}).visible;
  
      // to support for one-sided box
      var bdPos0;
      var bdPos1;
      if(Array.isArray(t.bdPos)) {
          bdPos0 = t.bdPos[0];
          bdPos1 = t.bdPos[1];
      } else {
          bdPos0 = t.bdPos;
          bdPos1 = t.bdPos;
      }
  
      var paths = sel.selectAll('path.mean').data((
          (trace.type === 'box' && trace.boxmean) ||
          (trace.type === 'violin' && trace.box.visible && trace.meanline.visible)
      ) ? Lib.identity : []);
  
      paths.enter().append('path')
          .attr('class', 'mean')
          .style({
              fill: 'none',
              'vector-effect': 'non-scaling-stroke'
          });
  
      paths.exit().remove();
  
      paths.each(function(d) {
          var lcenter = posAxis.c2l(d.pos + bPos, true);
  
          var pos0 = posAxis.l2p(lcenter - bdPos0) + bPosPxOffset;
          var pos1 = posAxis.l2p(lcenter + bdPos1) + bPosPxOffset;
          var posc = posHasRangeBreaks ? (pos0 + pos1) / 2 : posAxis.l2p(lcenter) + bPosPxOffset;
  
          var m = valAxis.c2p(d.mean, true);
          var sl = valAxis.c2p(d.mean - d.sd, true);
          var sh = valAxis.c2p(d.mean + d.sd, true);
  
          if(trace.orientation === 'h') {
              d3.select(this).attr('d',
                  'M' + m + ',' + pos0 + 'V' + pos1 +
                  (mode === 'sd' ?
                      'm0,0L' + sl + ',' + posc + 'L' + m + ',' + pos0 + 'L' + sh + ',' + posc + 'Z' :
                      '')
              );
          } else {
              d3.select(this).attr('d',
                  'M' + pos0 + ',' + m + 'H' + pos1 +
                  (mode === 'sd' ?
                      'm0,0L' + posc + ',' + sl + 'L' + pos0 + ',' + m + 'L' + posc + ',' + sh + 'Z' :
                      '')
              );
          }
      });
  }
  
  module.exports = {
      plot: plot,
      plotBoxAndWhiskers: plotBoxAndWhiskers,
      plotPoints: plotPoints,
      plotBoxMean: plotBoxMean
  };
  
  },{"../../components/drawing":637,"../../lib":750,"d3":169}],927:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function selectPoints(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var xa = searchInfo.xaxis;
      var ya = searchInfo.yaxis;
      var selection = [];
      var i, j;
  
      if(selectionTester === false) {
          for(i = 0; i < cd.length; i++) {
              for(j = 0; j < (cd[i].pts || []).length; j++) {
                  // clear selection
                  cd[i].pts[j].selected = 0;
              }
          }
      } else {
          for(i = 0; i < cd.length; i++) {
              for(j = 0; j < (cd[i].pts || []).length; j++) {
                  var pt = cd[i].pts[j];
                  var x = xa.c2p(pt.x);
                  var y = ya.c2p(pt.y);
  
                  if(selectionTester.contains([x, y], null, pt.i, searchInfo)) {
                      selection.push({
                          pointNumber: pt.i,
                          x: xa.c2d(pt.x),
                          y: ya.c2d(pt.y)
                      });
                      pt.selected = 1;
                  } else {
                      pt.selected = 0;
                  }
              }
          }
      }
  
      return selection;
  };
  
  },{}],928:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  
  function style(gd, cd, sel) {
      var s = sel ? sel : d3.select(gd).selectAll('g.trace.boxes');
  
      s.style('opacity', function(d) { return d[0].trace.opacity; });
  
      s.each(function(d) {
          var el = d3.select(this);
          var trace = d[0].trace;
          var lineWidth = trace.line.width;
  
          function styleBox(boxSel, lineWidth, lineColor, fillColor) {
              boxSel.style('stroke-width', lineWidth + 'px')
                  .call(Color.stroke, lineColor)
                  .call(Color.fill, fillColor);
          }
  
          var allBoxes = el.selectAll('path.box');
  
          if(trace.type === 'candlestick') {
              allBoxes.each(function(boxData) {
                  if(boxData.empty) return;
  
                  var thisBox = d3.select(this);
                  var container = trace[boxData.dir]; // dir = 'increasing' or 'decreasing'
                  styleBox(thisBox, container.line.width, container.line.color, container.fillcolor);
                  // TODO: custom selection style for candlesticks
                  thisBox.style('opacity', trace.selectedpoints && !boxData.selected ? 0.3 : 1);
              });
          } else {
              styleBox(allBoxes, lineWidth, trace.line.color, trace.fillcolor);
              el.selectAll('path.mean')
                  .style({
                      'stroke-width': lineWidth,
                      'stroke-dasharray': (2 * lineWidth) + 'px,' + lineWidth + 'px'
                  })
                  .call(Color.stroke, trace.line.color);
  
              var pts = el.selectAll('path.point');
              Drawing.pointStyle(pts, trace, gd);
          }
      });
  }
  
  function styleOnSelect(gd, cd, sel) {
      var trace = cd[0].trace;
      var pts = sel.selectAll('path.point');
  
      if(trace.selectedpoints) {
          Drawing.selectedPointStyle(pts, trace);
      } else {
          Drawing.pointStyle(pts, trace, gd);
      }
  }
  
  module.exports = {
      style: style,
      styleOnSelect: styleOnSelect
  };
  
  },{"../../components/color":615,"../../components/drawing":637,"d3":169}],929:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var extendFlat = _dereq_('../../lib').extendFlat;
  var OHLCattrs = _dereq_('../ohlc/attributes');
  var boxAttrs = _dereq_('../box/attributes');
  
  function directionAttrs(lineColorDefault) {
      return {
          line: {
              color: extendFlat({}, boxAttrs.line.color, {dflt: lineColorDefault}),
              width: boxAttrs.line.width,
              editType: 'style'
          },
  
          fillcolor: boxAttrs.fillcolor,
          editType: 'style'
      };
  }
  
  module.exports = {
      xperiod: OHLCattrs.xperiod,
      xperiod0: OHLCattrs.xperiod0,
      xperiodalignment: OHLCattrs.xperiodalignment,
  
      x: OHLCattrs.x,
      open: OHLCattrs.open,
      high: OHLCattrs.high,
      low: OHLCattrs.low,
      close: OHLCattrs.close,
  
      line: {
          width: extendFlat({}, boxAttrs.line.width, {
              
          }),
          editType: 'style'
      },
  
      increasing: directionAttrs(OHLCattrs.increasing.line.color.dflt),
  
      decreasing: directionAttrs(OHLCattrs.decreasing.line.color.dflt),
  
      text: OHLCattrs.text,
      hovertext: OHLCattrs.hovertext,
      whiskerwidth: extendFlat({}, boxAttrs.whiskerwidth, { dflt: 0 }),
  
      hoverlabel: OHLCattrs.hoverlabel,
  };
  
  },{"../../lib":750,"../box/attributes":917,"../ohlc/attributes":1104}],930:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  
  var calcCommon = _dereq_('../ohlc/calc').calcCommon;
  
  module.exports = function(gd, trace) {
      var fullLayout = gd._fullLayout;
      var xa = Axes.getFromId(gd, trace.xaxis);
      var ya = Axes.getFromId(gd, trace.yaxis);
  
      var origX = xa.makeCalcdata(trace, 'x');
      var x = alignPeriod(trace, xa, 'x', origX);
  
      var cd = calcCommon(gd, trace, origX, x, ya, ptFunc);
  
      if(cd.length) {
          Lib.extendFlat(cd[0].t, {
              num: fullLayout._numBoxes,
              dPos: Lib.distinctVals(x).minDiff / 2,
              posLetter: 'x',
              valLetter: 'y',
          });
  
          fullLayout._numBoxes++;
          return cd;
      } else {
          return [{t: {empty: true}}];
      }
  };
  
  function ptFunc(o, h, l, c) {
      return {
          min: l,
          q1: Math.min(o, c),
          med: c,
          q3: Math.max(o, c),
          max: h,
      };
  }
  
  },{"../../lib":750,"../../plots/cartesian/align_period":796,"../../plots/cartesian/axes":799,"../ohlc/calc":1105}],931:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  var handleOHLC = _dereq_('../ohlc/ohlc_defaults');
  var handlePeriodDefaults = _dereq_('../scatter/period_defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleOHLC(traceIn, traceOut, coerce, layout);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce, {x: true});
  
      coerce('line.width');
  
      handleDirection(traceIn, traceOut, coerce, 'increasing');
      handleDirection(traceIn, traceOut, coerce, 'decreasing');
  
      coerce('text');
      coerce('hovertext');
      coerce('whiskerwidth');
  
      layout._requestRangeslider[traceOut.xaxis] = true;
  };
  
  function handleDirection(traceIn, traceOut, coerce, direction) {
      var lineColor = coerce(direction + '.line.color');
      coerce(direction + '.line.width', traceOut.line.width);
      coerce(direction + '.fillcolor', Color.addOpacity(lineColor, 0.5));
  }
  
  },{"../../components/color":615,"../../lib":750,"../ohlc/ohlc_defaults":1109,"../scatter/period_defaults":1178,"./attributes":929}],932:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'candlestick',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', 'showLegend', 'candlestick', 'boxLayout'],
      meta: {
          
      },
  
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('../box/layout_attributes'),
      supplyLayoutDefaults: _dereq_('../box/layout_defaults').supplyLayoutDefaults,
      crossTraceCalc: _dereq_('../box/cross_trace_calc').crossTraceCalc,
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc'),
      plot: _dereq_('../box/plot').plot,
      layerName: 'boxlayer',
      style: _dereq_('../box/style').style,
      hoverPoints: _dereq_('../ohlc/hover').hoverPoints,
      selectPoints: _dereq_('../ohlc/select')
  };
  
  },{"../../plots/cartesian":812,"../box/cross_trace_calc":919,"../box/layout_attributes":924,"../box/layout_defaults":925,"../box/plot":926,"../box/style":928,"../ohlc/hover":1107,"../ohlc/select":1111,"./attributes":929,"./calc":930,"./defaults":931}],933:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var handleAxisDefaults = _dereq_('./axis_defaults');
  var Template = _dereq_('../../plot_api/plot_template');
  
  module.exports = function handleABDefaults(traceIn, traceOut, fullLayout, coerce, dfltColor) {
      var a = coerce('a');
  
      if(!a) {
          coerce('da');
          coerce('a0');
      }
  
      var b = coerce('b');
  
      if(!b) {
          coerce('db');
          coerce('b0');
      }
  
      mimickAxisDefaults(traceIn, traceOut, fullLayout, dfltColor);
  };
  
  function mimickAxisDefaults(traceIn, traceOut, fullLayout, dfltColor) {
      var axesList = ['aaxis', 'baxis'];
  
      axesList.forEach(function(axName) {
          var axLetter = axName.charAt(0);
          var axIn = traceIn[axName] || {};
          var axOut = Template.newContainer(traceOut, axName);
  
          var defaultOptions = {
              tickfont: 'x',
              id: axLetter + 'axis',
              letter: axLetter,
              font: traceOut.font,
              name: axName,
              data: traceIn[axLetter],
              calendar: traceOut.calendar,
              dfltColor: dfltColor,
              bgColor: fullLayout.paper_bgcolor,
              fullLayout: fullLayout
          };
  
          handleAxisDefaults(axIn, axOut, defaultOptions);
          axOut._categories = axOut._categories || [];
  
          // so we don't have to repeat autotype unnecessarily,
          // copy an autotype back to traceIn
          if(!traceIn[axName] && axIn.type !== '-') {
              traceIn[axName] = {type: axIn.type};
          }
      });
  }
  
  },{"../../plot_api/plot_template":788,"./axis_defaults":938}],934:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  
  module.exports = function(a) {
      return minMax(a, 0);
  };
  
  function minMax(a, depth) {
      // Limit to ten dimensional datasets. This seems *exceedingly* unlikely to
      // ever cause problems or even be a concern. It's include strictly so that
      // circular arrays could never cause this to loop.
      if(!isArrayOrTypedArray(a) || depth >= 10) {
          return null;
      }
  
      var min = Infinity;
      var max = -Infinity;
      var n = a.length;
      for(var i = 0; i < n; i++) {
          var datum = a[i];
  
          if(isArrayOrTypedArray(datum)) {
              var result = minMax(datum, depth + 1);
  
              if(result) {
                  min = Math.min(result[0], min);
                  max = Math.max(result[1], max);
              }
          } else {
              min = Math.min(datum, min);
              max = Math.max(datum, max);
          }
      }
  
      return [min, max];
  }
  
  },{"../../lib":750}],935:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var axisAttrs = _dereq_('./axis_attributes');
  var colorAttrs = _dereq_('../../components/color/attributes');
  
  var carpetFont = fontAttrs({
      editType: 'calc',
      
  });
  // TODO: inherit from global font
  carpetFont.family.dflt = '"Open Sans", verdana, arial, sans-serif';
  carpetFont.size.dflt = 12;
  carpetFont.color.dflt = colorAttrs.defaultLine;
  
  module.exports = {
      carpet: {
          valType: 'string',
          
          editType: 'calc',
          
      },
      x: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
      y: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
      a: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      a0: {
          valType: 'number',
          dflt: 0,
          
          editType: 'calc',
          
      },
      da: {
          valType: 'number',
          dflt: 1,
          
          editType: 'calc',
          
      },
      b: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      b0: {
          valType: 'number',
          dflt: 0,
          
          editType: 'calc',
          
      },
      db: {
          valType: 'number',
          dflt: 1,
          
          editType: 'calc',
          
      },
      cheaterslope: {
          valType: 'number',
          
          dflt: 1,
          editType: 'calc',
          
      },
      aaxis: axisAttrs,
      baxis: axisAttrs,
      font: carpetFont,
      color: {
          valType: 'color',
          dflt: colorAttrs.defaultLine,
          
          editType: 'plot',
          
      },
      transforms: undefined
  };
  
  },{"../../components/color/attributes":614,"../../plots/font_attributes":827,"./axis_attributes":937}],936:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  
  /* This function retrns a set of control points that define a curve aligned along
   * either the a or b axis. Exactly one of a or b must be an array defining the range
   * spanned.
   *
   * Honestly this is the most complicated function I've implemente here so far because
   * of the way it handles knot insertion and direction/axis-agnostic slices.
   */
  module.exports = function(carpet, carpetcd, a, b) {
      var idx, tangent, tanIsoIdx, tanIsoPar, segment, refidx;
      var p0, p1, v0, v1, start, end, range;
  
      var axis = isArrayOrTypedArray(a) ? 'a' : 'b';
      var ax = axis === 'a' ? carpet.aaxis : carpet.baxis;
      var smoothing = ax.smoothing;
      var toIdx = axis === 'a' ? carpet.a2i : carpet.b2j;
      var pt = axis === 'a' ? a : b;
      var iso = axis === 'a' ? b : a;
      var n = axis === 'a' ? carpetcd.a.length : carpetcd.b.length;
      var m = axis === 'a' ? carpetcd.b.length : carpetcd.a.length;
      var isoIdx = Math.floor(axis === 'a' ? carpet.b2j(iso) : carpet.a2i(iso));
  
      var xy = axis === 'a' ? function(value) {
          return carpet.evalxy([], value, isoIdx);
      } : function(value) {
          return carpet.evalxy([], isoIdx, value);
      };
  
      if(smoothing) {
          tanIsoIdx = Math.max(0, Math.min(m - 2, isoIdx));
          tanIsoPar = isoIdx - tanIsoIdx;
          tangent = axis === 'a' ? function(i, ti) {
              return carpet.dxydi([], i, tanIsoIdx, ti, tanIsoPar);
          } : function(j, tj) {
              return carpet.dxydj([], tanIsoIdx, j, tanIsoPar, tj);
          };
      }
  
      var vstart = toIdx(pt[0]);
      var vend = toIdx(pt[1]);
  
      // So that we can make this work in two directions, flip all of the
      // math functions if the direction is from higher to lower indices:
      //
      // Note that the tolerance is directional!
      var dir = vstart < vend ? 1 : -1;
      var tol = (vend - vstart) * 1e-8;
      var dirfloor = dir > 0 ? Math.floor : Math.ceil;
      var dirceil = dir > 0 ? Math.ceil : Math.floor;
      var dirmin = dir > 0 ? Math.min : Math.max;
      var dirmax = dir > 0 ? Math.max : Math.min;
  
      var idx0 = dirfloor(vstart + tol);
      var idx1 = dirceil(vend - tol);
  
      p0 = xy(vstart);
      var segments = [[p0]];
  
      for(idx = idx0; idx * dir < idx1 * dir; idx += dir) {
          segment = [];
          start = dirmax(vstart, idx);
          end = dirmin(vend, idx + dir);
          range = end - start;
  
          // In order to figure out which cell we're in for the derivative (remember,
          // the derivatives are *not* constant across grid lines), let's just average
          // the start and end points. This cuts out just a tiny bit of logic and
          // there's really no computational difference:
          refidx = Math.max(0, Math.min(n - 2, Math.floor(0.5 * (start + end))));
  
          p1 = xy(end);
          if(smoothing) {
              v0 = tangent(refidx, start - refidx);
              v1 = tangent(refidx, end - refidx);
  
              segment.push([
                  p0[0] + v0[0] / 3 * range,
                  p0[1] + v0[1] / 3 * range
              ]);
  
              segment.push([
                  p1[0] - v1[0] / 3 * range,
                  p1[1] - v1[1] / 3 * range
              ]);
          }
  
          segment.push(p1);
  
          segments.push(segment);
          p0 = p1;
      }
  
      return segments;
  };
  
  },{"../../lib":750}],937:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var colorAttrs = _dereq_('../../components/color/attributes');
  var axesAttrs = _dereq_('../../plots/cartesian/layout_attributes');
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
  var DATE_FORMAT_LINK = _dereq_('../../constants/docs').TIME_FORMAT_LINK;
  
  module.exports = {
      color: {
          valType: 'color',
          
          editType: 'calc',
          
      },
      smoothing: {
          valType: 'number',
          dflt: 1,
          min: 0,
          max: 1.3,
          
          editType: 'calc'
      },
      title: {
          text: {
              valType: 'string',
              dflt: '',
              
              editType: 'calc',
              
          },
          font: fontAttrs({
              editType: 'calc',
              
          }),
          // TODO how is this different than `title.standoff`
          offset: {
              valType: 'number',
              
              dflt: 10,
              editType: 'calc',
              
          },
          editType: 'calc',
      },
      type: {
          valType: 'enumerated',
          // '-' means we haven't yet run autotype or couldn't find any data
          // it gets turned into linear in gd._fullLayout but not copied back
          // to gd.data like the others are.
          values: ['-', 'linear', 'date', 'category'],
          dflt: '-',
          
          editType: 'calc',
          
      },
      autorange: {
          valType: 'enumerated',
          values: [true, false, 'reversed'],
          dflt: true,
          
          editType: 'calc',
          
      },
      rangemode: {
          valType: 'enumerated',
          values: ['normal', 'tozero', 'nonnegative'],
          dflt: 'normal',
          
          editType: 'calc',
          
      },
      range: {
          valType: 'info_array',
          
          editType: 'calc',
          items: [
              {valType: 'any', editType: 'calc'},
              {valType: 'any', editType: 'calc'}
          ],
          
      },
  
      fixedrange: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'calc',
          
      },
      cheatertype: {
          valType: 'enumerated',
          values: ['index', 'value'],
          dflt: 'value',
          
          editType: 'calc'
      },
      tickmode: {
          valType: 'enumerated',
          values: ['linear', 'array'],
          dflt: 'array',
          
          editType: 'calc'
      },
      nticks: {
          valType: 'integer',
          min: 0,
          dflt: 0,
          
          editType: 'calc',
          
      },
      tickvals: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      ticktext: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      showticklabels: {
          valType: 'enumerated',
          values: ['start', 'end', 'both', 'none'],
          dflt: 'start',
          
          editType: 'calc',
          
      },
      tickfont: fontAttrs({
          editType: 'calc',
          
      }),
      tickangle: {
          valType: 'angle',
          dflt: 'auto',
          
          editType: 'calc',
          
      },
      tickprefix: {
          valType: 'string',
          dflt: '',
          
          editType: 'calc',
          
      },
      showtickprefix: {
          valType: 'enumerated',
          values: ['all', 'first', 'last', 'none'],
          dflt: 'all',
          
          editType: 'calc',
          
      },
      ticksuffix: {
          valType: 'string',
          dflt: '',
          
          editType: 'calc',
          
      },
      showticksuffix: {
          valType: 'enumerated',
          values: ['all', 'first', 'last', 'none'],
          dflt: 'all',
          
          editType: 'calc',
          
      },
      showexponent: {
          valType: 'enumerated',
          values: ['all', 'first', 'last', 'none'],
          dflt: 'all',
          
          editType: 'calc',
          
      },
      exponentformat: {
          valType: 'enumerated',
          values: ['none', 'e', 'E', 'power', 'SI', 'B'],
          dflt: 'B',
          
          editType: 'calc',
          
      },
      minexponent: {
          valType: 'number',
          dflt: 3,
          min: 0,
          
          editType: 'calc',
          
      },
      separatethousands: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'calc',
          
      },
      tickformat: {
          valType: 'string',
          dflt: '',
          
          editType: 'calc',
          
      },
      tickformatstops: overrideAll(axesAttrs.tickformatstops, 'calc', 'from-root'),
      categoryorder: {
          valType: 'enumerated',
          values: [
              'trace', 'category ascending', 'category descending', 'array'
              /* , 'value ascending', 'value descending'*/ // value ascending / descending to be implemented later
          ],
          dflt: 'trace',
          
          editType: 'calc',
          
      },
      categoryarray: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
      labelpadding: {
          valType: 'integer',
          
          dflt: 10,
          editType: 'calc',
          
      },
      labelprefix: {
          valType: 'string',
          
          editType: 'calc',
          
      },
      labelsuffix: {
          valType: 'string',
          dflt: '',
          
          editType: 'calc',
          
      },
      // lines and grids
      showline: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'calc',
          
      },
      linecolor: {
          valType: 'color',
          dflt: colorAttrs.defaultLine,
          
          editType: 'calc',
          
      },
      linewidth: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'calc',
          
      },
      gridcolor: {
          valType: 'color',
          
          editType: 'calc',
          
      },
      gridwidth: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'calc',
          
      },
      showgrid: {
          valType: 'boolean',
          
          dflt: true,
          editType: 'calc',
          
      },
      minorgridcount: {
          valType: 'integer',
          min: 0,
          dflt: 0,
          
          editType: 'calc',
          
      },
      minorgridwidth: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'calc',
          
      },
      minorgridcolor: {
          valType: 'color',
          dflt: colorAttrs.lightLine,
          
          editType: 'calc',
          
      },
      startline: {
          valType: 'boolean',
          
          editType: 'calc',
          
      },
      startlinecolor: {
          valType: 'color',
          
          editType: 'calc',
          
      },
      startlinewidth: {
          valType: 'number',
          dflt: 1,
          
          editType: 'calc',
          
      },
      endline: {
          valType: 'boolean',
          
          editType: 'calc',
          
      },
      endlinewidth: {
          valType: 'number',
          dflt: 1,
          
          editType: 'calc',
          
      },
      endlinecolor: {
          valType: 'color',
          
          editType: 'calc',
          
      },
      tick0: {
          valType: 'number',
          min: 0,
          dflt: 0,
          
          editType: 'calc',
          
      },
      dtick: {
          valType: 'number',
          min: 0,
          dflt: 1,
          
          editType: 'calc',
          
      },
      arraytick0: {
          valType: 'integer',
          min: 0,
          dflt: 0,
          
          editType: 'calc',
          
      },
      arraydtick: {
          valType: 'integer',
          min: 1,
          dflt: 1,
          
          editType: 'calc',
          
      },
  
      _deprecated: {
          title: {
              valType: 'string',
              
              editType: 'calc',
              
          },
          titlefont: fontAttrs({
              editType: 'calc',
              
          }),
          titleoffset: {
              valType: 'number',
              
              dflt: 10,
              editType: 'calc',
              
          }
      },
  
      editType: 'calc'
  };
  
  },{"../../components/color/attributes":614,"../../constants/docs":720,"../../plot_api/edit_types":781,"../../plots/cartesian/layout_attributes":813,"../../plots/font_attributes":827}],938:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var carpetAttrs = _dereq_('./attributes');
  
  var addOpacity = _dereq_('../../components/color').addOpacity;
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var handleTickValueDefaults = _dereq_('../../plots/cartesian/tick_value_defaults');
  var handleTickLabelDefaults = _dereq_('../../plots/cartesian/tick_label_defaults');
  var handleCategoryOrderDefaults = _dereq_('../../plots/cartesian/category_order_defaults');
  var setConvert = _dereq_('../../plots/cartesian/set_convert');
  var autoType = _dereq_('../../plots/cartesian/axis_autotype');
  
  /**
   * options: object containing:
   *
   *  letter: 'a' or 'b'
   *  title: name of the axis (ie 'Colorbar') to go in default title
   *  name: axis object name (ie 'xaxis') if one should be stored
   *  font: the default font to inherit
   *  outerTicks: boolean, should ticks default to outside?
   *  showGrid: boolean, should gridlines be shown by default?
   *  data: the plot data to use in choosing auto type
   *  bgColor: the plot background color, to calculate default gridline colors
   */
  module.exports = function handleAxisDefaults(containerIn, containerOut, options) {
      var letter = options.letter;
      var font = options.font || {};
      var attributes = carpetAttrs[letter + 'axis'];
  
      function coerce(attr, dflt) {
          return Lib.coerce(containerIn, containerOut, attributes, attr, dflt);
      }
  
      function coerce2(attr, dflt) {
          return Lib.coerce2(containerIn, containerOut, attributes, attr, dflt);
      }
  
      // set up some private properties
      if(options.name) {
          containerOut._name = options.name;
          containerOut._id = options.name;
      }
  
      // now figure out type and do some more initialization
      var axType = coerce('type');
      if(axType === '-') {
          if(options.data) setAutoType(containerOut, options.data);
  
          if(containerOut.type === '-') {
              containerOut.type = 'linear';
          } else {
              // copy autoType back to input axis
              // note that if this object didn't exist
              // in the input layout, we have to put it in
              // this happens in the main supplyDefaults function
              axType = containerIn.type = containerOut.type;
          }
      }
  
      coerce('smoothing');
      coerce('cheatertype');
  
      coerce('showticklabels');
      coerce('labelprefix', letter + ' = ');
      coerce('labelsuffix');
      coerce('showtickprefix');
      coerce('showticksuffix');
  
      coerce('separatethousands');
      coerce('tickformat');
      coerce('exponentformat');
      coerce('minexponent');
      coerce('showexponent');
      coerce('categoryorder');
  
      coerce('tickmode');
      coerce('tickvals');
      coerce('ticktext');
      coerce('tick0');
      coerce('dtick');
  
      if(containerOut.tickmode === 'array') {
          coerce('arraytick0');
          coerce('arraydtick');
      }
  
      coerce('labelpadding');
  
      containerOut._hovertitle = letter;
  
  
      if(axType === 'date') {
          var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleDefaults');
          handleCalendarDefaults(containerIn, containerOut, 'calendar', options.calendar);
      }
  
      // we need some of the other functions setConvert attaches, but for
      // path finding, override pixel scaling to simple passthrough (identity)
      setConvert(containerOut, options.fullLayout);
      containerOut.c2p = Lib.identity;
  
      var dfltColor = coerce('color', options.dfltColor);
      // if axis.color was provided, use it for fonts too; otherwise,
      // inherit from global font color in case that was provided.
      var dfltFontColor = (dfltColor === containerIn.color) ? dfltColor : font.color;
  
      var title = coerce('title.text');
      if(title) {
          Lib.coerceFont(coerce, 'title.font', {
              family: font.family,
              size: Math.round(font.size * 1.2),
              color: dfltFontColor
          });
          coerce('title.offset');
      }
  
      coerce('tickangle');
  
      var autoRange = coerce('autorange', !containerOut.isValidRange(containerIn.range));
  
      if(autoRange) coerce('rangemode');
  
      coerce('range');
      containerOut.cleanRange();
  
      coerce('fixedrange');
  
      handleTickValueDefaults(containerIn, containerOut, coerce, axType);
      handleTickLabelDefaults(containerIn, containerOut, coerce, axType, options);
      handleCategoryOrderDefaults(containerIn, containerOut, coerce, {
          data: options.data,
          dataAttr: letter
      });
  
      var gridColor = coerce2('gridcolor', addOpacity(dfltColor, 0.3));
      var gridWidth = coerce2('gridwidth');
      var showGrid = coerce('showgrid');
  
      if(!showGrid) {
          delete containerOut.gridcolor;
          delete containerOut.gridwidth;
      }
  
      var startLineColor = coerce2('startlinecolor', dfltColor);
      var startLineWidth = coerce2('startlinewidth', gridWidth);
      var showStartLine = coerce('startline', containerOut.showgrid || !!startLineColor || !!startLineWidth);
  
      if(!showStartLine) {
          delete containerOut.startlinecolor;
          delete containerOut.startlinewidth;
      }
  
      var endLineColor = coerce2('endlinecolor', dfltColor);
      var endLineWidth = coerce2('endlinewidth', gridWidth);
      var showEndLine = coerce('endline', containerOut.showgrid || !!endLineColor || !!endLineWidth);
  
      if(!showEndLine) {
          delete containerOut.endlinecolor;
          delete containerOut.endlinewidth;
      }
  
      if(!showGrid) {
          delete containerOut.gridcolor;
          delete containerOut.gridWidth;
      } else {
          coerce('minorgridcount');
          coerce('minorgridwidth', gridWidth);
          coerce('minorgridcolor', addOpacity(gridColor, 0.06));
  
          if(!containerOut.minorgridcount) {
              delete containerOut.minorgridwidth;
              delete containerOut.minorgridcolor;
          }
      }
  
      if(containerOut.showticklabels === 'none') {
          delete containerOut.tickfont;
          delete containerOut.tickangle;
          delete containerOut.showexponent;
          delete containerOut.exponentformat;
          delete containerOut.minexponent;
          delete containerOut.tickformat;
          delete containerOut.showticksuffix;
          delete containerOut.showtickprefix;
      }
  
      if(!containerOut.showticksuffix) {
          delete containerOut.ticksuffix;
      }
  
      if(!containerOut.showtickprefix) {
          delete containerOut.tickprefix;
      }
  
      // It needs to be coerced, then something above overrides this deep in the axis code,
      // but no, we *actually* want to coerce this.
      coerce('tickmode');
  
      return containerOut;
  };
  
  function setAutoType(ax, data) {
      // new logic: let people specify any type they want,
      // only autotype if type is '-'
      if(ax.type !== '-') return;
  
      var id = ax._id;
      var axLetter = id.charAt(0);
  
      var calAttr = axLetter + 'calendar';
      var calendar = ax[calAttr];
  
      ax.type = autoType(data, calendar);
  }
  
  },{"../../components/color":615,"../../lib":750,"../../plots/cartesian/axis_autotype":800,"../../plots/cartesian/category_order_defaults":803,"../../plots/cartesian/set_convert":819,"../../plots/cartesian/tick_label_defaults":820,"../../plots/cartesian/tick_value_defaults":822,"../../registry":882,"./attributes":935}],939:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var isArray1D = _dereq_('../../lib').isArray1D;
  var cheaterBasis = _dereq_('./cheater_basis');
  var arrayMinmax = _dereq_('./array_minmax');
  var calcGridlines = _dereq_('./calc_gridlines');
  var calcLabels = _dereq_('./calc_labels');
  var calcClipPath = _dereq_('./calc_clippath');
  var clean2dArray = _dereq_('../heatmap/clean_2d_array');
  var smoothFill2dArray = _dereq_('./smooth_fill_2d_array');
  var convertColumnData = _dereq_('../heatmap/convert_column_xyz');
  var setConvert = _dereq_('./set_convert');
  
  module.exports = function calc(gd, trace) {
      var xa = Axes.getFromId(gd, trace.xaxis);
      var ya = Axes.getFromId(gd, trace.yaxis);
      var aax = trace.aaxis;
      var bax = trace.baxis;
  
      var x = trace.x;
      var y = trace.y;
      var cols = [];
      if(x && isArray1D(x)) cols.push('x');
      if(y && isArray1D(y)) cols.push('y');
  
      if(cols.length) {
          convertColumnData(trace, aax, bax, 'a', 'b', cols);
      }
  
      var a = trace._a = trace._a || trace.a;
      var b = trace._b = trace._b || trace.b;
      x = trace._x || trace.x;
      y = trace._y || trace.y;
  
      var t = {};
  
      if(trace._cheater) {
          var avals = aax.cheatertype === 'index' ? a.length : a;
          var bvals = bax.cheatertype === 'index' ? b.length : b;
          x = cheaterBasis(avals, bvals, trace.cheaterslope);
      }
  
      trace._x = x = clean2dArray(x);
      trace._y = y = clean2dArray(y);
  
      // Fill in any undefined values with elliptic smoothing. This doesn't take
      // into account the spacing of the values. That is, the derivatives should
      // be modified to use a and b values. It's not that hard, but this is already
      // moderate overkill for just filling in missing values.
      smoothFill2dArray(x, a, b);
      smoothFill2dArray(y, a, b);
  
      setConvert(trace);
  
      // create conversion functions that depend on the data
      trace.setScale();
  
      // This is a rather expensive scan. Nothing guarantees monotonicity,
      // so we need to scan through all data to get proper ranges:
      var xrange = arrayMinmax(x);
      var yrange = arrayMinmax(y);
  
      var dx = 0.5 * (xrange[1] - xrange[0]);
      var xc = 0.5 * (xrange[1] + xrange[0]);
  
      var dy = 0.5 * (yrange[1] - yrange[0]);
      var yc = 0.5 * (yrange[1] + yrange[0]);
  
      // Expand the axes to fit the plot, except just grow it by a factor of 1.3
      // because the labels should be taken into account except that's difficult
      // hence 1.3.
      var grow = 1.3;
      xrange = [xc - dx * grow, xc + dx * grow];
      yrange = [yc - dy * grow, yc + dy * grow];
  
      trace._extremes[xa._id] = Axes.findExtremes(xa, xrange, {padded: true});
      trace._extremes[ya._id] = Axes.findExtremes(ya, yrange, {padded: true});
  
      // Enumerate the gridlines, both major and minor, and store them on the trace
      // object:
      calcGridlines(trace, 'a', 'b');
      calcGridlines(trace, 'b', 'a');
  
      // Calculate the text labels for each major gridline and store them on the
      // trace object:
      calcLabels(trace, aax);
      calcLabels(trace, bax);
  
      // Tabulate points for the four segments that bound the axes so that we can
      // map to pixel coordinates in the plot function and create a clip rect:
      t.clipsegments = calcClipPath(trace._xctrl, trace._yctrl, aax, bax);
  
      t.x = x;
      t.y = y;
      t.a = a;
      t.b = b;
  
      return [t];
  };
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"../heatmap/clean_2d_array":1038,"../heatmap/convert_column_xyz":1040,"./array_minmax":934,"./calc_clippath":940,"./calc_gridlines":941,"./calc_labels":942,"./cheater_basis":944,"./set_convert":957,"./smooth_fill_2d_array":958}],940:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = function makeClipPath(xctrl, yctrl, aax, bax) {
      var i, x, y;
      var segments = [];
  
      var asmoothing = !!aax.smoothing;
      var bsmoothing = !!bax.smoothing;
      var nea1 = xctrl[0].length - 1;
      var neb1 = xctrl.length - 1;
  
      // Along the lower a axis:
      for(i = 0, x = [], y = []; i <= nea1; i++) {
          x[i] = xctrl[0][i];
          y[i] = yctrl[0][i];
      }
      segments.push({x: x, y: y, bicubic: asmoothing});
  
      // Along the upper b axis:
      for(i = 0, x = [], y = []; i <= neb1; i++) {
          x[i] = xctrl[i][nea1];
          y[i] = yctrl[i][nea1];
      }
      segments.push({x: x, y: y, bicubic: bsmoothing});
  
      // Backwards along the upper a axis:
      for(i = nea1, x = [], y = []; i >= 0; i--) {
          x[nea1 - i] = xctrl[neb1][i];
          y[nea1 - i] = yctrl[neb1][i];
      }
      segments.push({x: x, y: y, bicubic: asmoothing});
  
      // Backwards along the lower b axis:
      for(i = neb1, x = [], y = []; i >= 0; i--) {
          x[neb1 - i] = xctrl[i][0];
          y[neb1 - i] = yctrl[i][0];
      }
      segments.push({x: x, y: y, bicubic: bsmoothing});
  
      return segments;
  };
  
  },{}],941:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = function calcGridlines(trace, axisLetter, crossAxisLetter) {
      var i, j, j0;
      var eps, bounds, n1, n2, n, value, v;
      var j1, v0, v1, d;
  
      var data = trace['_' + axisLetter];
      var axis = trace[axisLetter + 'axis'];
  
      var gridlines = axis._gridlines = [];
      var minorgridlines = axis._minorgridlines = [];
      var boundarylines = axis._boundarylines = [];
  
      var crossData = trace['_' + crossAxisLetter];
      var crossAxis = trace[crossAxisLetter + 'axis'];
  
      if(axis.tickmode === 'array') {
          axis.tickvals = data.slice();
      }
  
      var xcp = trace._xctrl;
      var ycp = trace._yctrl;
      var nea = xcp[0].length;
      var neb = xcp.length;
      var na = trace._a.length;
      var nb = trace._b.length;
  
      Axes.prepTicks(axis);
  
      // don't leave tickvals in axis looking like an attribute
      if(axis.tickmode === 'array') delete axis.tickvals;
  
      // The default is an empty array that will cause the join to remove the gridline if
      // it's just disappeared:
      // axis._startline = axis._endline = [];
  
      // If the cross axis uses bicubic interpolation, then the grid
      // lines fall once every three expanded grid row/cols:
      var stride = axis.smoothing ? 3 : 1;
  
      function constructValueGridline(value) {
          var i, j, j0, tj, pxy, i0, ti, xy, dxydi0, dxydi1, dxydj0, dxydj1;
          var xpoints = [];
          var ypoints = [];
          var ret = {};
          // Search for the fractional grid index giving this line:
          if(axisLetter === 'b') {
              // For the position we use just the i-j coordinates:
              j = trace.b2j(value);
  
              // The derivatives for catmull-rom splines are discontinuous across cell
              // boundaries though, so we need to provide both the cell and the position
              // within the cell separately:
              j0 = Math.floor(Math.max(0, Math.min(nb - 2, j)));
              tj = j - j0;
  
              ret.length = nb;
              ret.crossLength = na;
  
              ret.xy = function(i) {
                  return trace.evalxy([], i, j);
              };
  
              ret.dxy = function(i0, ti) {
                  return trace.dxydi([], i0, j0, ti, tj);
              };
  
              for(i = 0; i < na; i++) {
                  i0 = Math.min(na - 2, i);
                  ti = i - i0;
                  xy = trace.evalxy([], i, j);
  
                  if(crossAxis.smoothing && i > 0) {
                      // First control point:
                      dxydi0 = trace.dxydi([], i - 1, j0, 0, tj);
                      xpoints.push(pxy[0] + dxydi0[0] / 3);
                      ypoints.push(pxy[1] + dxydi0[1] / 3);
  
                      // Second control point:
                      dxydi1 = trace.dxydi([], i - 1, j0, 1, tj);
                      xpoints.push(xy[0] - dxydi1[0] / 3);
                      ypoints.push(xy[1] - dxydi1[1] / 3);
                  }
  
                  xpoints.push(xy[0]);
                  ypoints.push(xy[1]);
  
                  pxy = xy;
              }
          } else {
              i = trace.a2i(value);
              i0 = Math.floor(Math.max(0, Math.min(na - 2, i)));
              ti = i - i0;
  
              ret.length = na;
              ret.crossLength = nb;
  
              ret.xy = function(j) {
                  return trace.evalxy([], i, j);
              };
  
              ret.dxy = function(j0, tj) {
                  return trace.dxydj([], i0, j0, ti, tj);
              };
  
              for(j = 0; j < nb; j++) {
                  j0 = Math.min(nb - 2, j);
                  tj = j - j0;
                  xy = trace.evalxy([], i, j);
  
                  if(crossAxis.smoothing && j > 0) {
                      // First control point:
                      dxydj0 = trace.dxydj([], i0, j - 1, ti, 0);
                      xpoints.push(pxy[0] + dxydj0[0] / 3);
                      ypoints.push(pxy[1] + dxydj0[1] / 3);
  
                      // Second control point:
                      dxydj1 = trace.dxydj([], i0, j - 1, ti, 1);
                      xpoints.push(xy[0] - dxydj1[0] / 3);
                      ypoints.push(xy[1] - dxydj1[1] / 3);
                  }
  
                  xpoints.push(xy[0]);
                  ypoints.push(xy[1]);
  
                  pxy = xy;
              }
          }
  
          ret.axisLetter = axisLetter;
          ret.axis = axis;
          ret.crossAxis = crossAxis;
          ret.value = value;
          ret.constvar = crossAxisLetter;
          ret.index = n;
          ret.x = xpoints;
          ret.y = ypoints;
          ret.smoothing = crossAxis.smoothing;
  
          return ret;
      }
  
      function constructArrayGridline(idx) {
          var j, i0, j0, ti, tj;
          var xpoints = [];
          var ypoints = [];
          var ret = {};
          ret.length = data.length;
          ret.crossLength = crossData.length;
  
          if(axisLetter === 'b') {
              j0 = Math.max(0, Math.min(nb - 2, idx));
              tj = Math.min(1, Math.max(0, idx - j0));
  
              ret.xy = function(i) {
                  return trace.evalxy([], i, idx);
              };
  
              ret.dxy = function(i0, ti) {
                  return trace.dxydi([], i0, j0, ti, tj);
              };
  
              // In the tickmode: array case, this operation is a simple
              // transfer of data:
              for(j = 0; j < nea; j++) {
                  xpoints[j] = xcp[idx * stride][j];
                  ypoints[j] = ycp[idx * stride][j];
              }
          } else {
              i0 = Math.max(0, Math.min(na - 2, idx));
              ti = Math.min(1, Math.max(0, idx - i0));
  
              ret.xy = function(j) {
                  return trace.evalxy([], idx, j);
              };
  
              ret.dxy = function(j0, tj) {
                  return trace.dxydj([], i0, j0, ti, tj);
              };
  
              // In the tickmode: array case, this operation is a simple
              // transfer of data:
              for(j = 0; j < neb; j++) {
                  xpoints[j] = xcp[j][idx * stride];
                  ypoints[j] = ycp[j][idx * stride];
              }
          }
  
          ret.axisLetter = axisLetter;
          ret.axis = axis;
          ret.crossAxis = crossAxis;
          ret.value = data[idx];
          ret.constvar = crossAxisLetter;
          ret.index = idx;
          ret.x = xpoints;
          ret.y = ypoints;
          ret.smoothing = crossAxis.smoothing;
  
          return ret;
      }
  
      if(axis.tickmode === 'array') {
          // var j0 = axis.startline ? 1 : 0;
          // var j1 = data.length - (axis.endline ? 1 : 0);
  
          eps = 5e-15;
          bounds = [
              Math.floor(((data.length - 1) - axis.arraytick0) / axis.arraydtick * (1 + eps)),
              Math.ceil((- axis.arraytick0) / axis.arraydtick / (1 + eps))
          ].sort(function(a, b) {return a - b;});
  
          // Unpack sorted values so we can be sure to avoid infinite loops if something
          // is backwards:
          n1 = bounds[0] - 1;
          n2 = bounds[1] + 1;
  
          // If the axes fall along array lines, then this is a much simpler process since
          // we already have all the control points we need
          for(n = n1; n < n2; n++) {
              j = axis.arraytick0 + axis.arraydtick * n;
              if(j < 0 || j > data.length - 1) continue;
              gridlines.push(extendFlat(constructArrayGridline(j), {
                  color: axis.gridcolor,
                  width: axis.gridwidth
              }));
          }
  
          for(n = n1; n < n2; n++) {
              j0 = axis.arraytick0 + axis.arraydtick * n;
              j1 = Math.min(j0 + axis.arraydtick, data.length - 1);
  
              // TODO: fix the bounds computation so we don't have to do a large range and then throw
              // out unneeded numbers
              if(j0 < 0 || j0 > data.length - 1) continue;
              if(j1 < 0 || j1 > data.length - 1) continue;
  
              v0 = data[j0];
              v1 = data[j1];
  
              for(i = 0; i < axis.minorgridcount; i++) {
                  d = j1 - j0;
  
                  // TODO: fix the bounds computation so we don't have to do a large range and then throw
                  // out unneeded numbers
                  if(d <= 0) continue;
  
                  // XXX: This calculation isn't quite right. Off by one somewhere?
                  v = v0 + (v1 - v0) * (i + 1) / (axis.minorgridcount + 1) * (axis.arraydtick / d);
  
                  // TODO: fix the bounds computation so we don't have to do a large range and then throw
                  // out unneeded numbers
                  if(v < data[0] || v > data[data.length - 1]) continue;
                  minorgridlines.push(extendFlat(constructValueGridline(v), {
                      color: axis.minorgridcolor,
                      width: axis.minorgridwidth
                  }));
              }
          }
  
          if(axis.startline) {
              boundarylines.push(extendFlat(constructArrayGridline(0), {
                  color: axis.startlinecolor,
                  width: axis.startlinewidth
              }));
          }
  
          if(axis.endline) {
              boundarylines.push(extendFlat(constructArrayGridline(data.length - 1), {
                  color: axis.endlinecolor,
                  width: axis.endlinewidth
              }));
          }
      } else {
          // If the lines do not fall along the axes, then we have to interpolate
          // the contro points and so some math to figure out where the lines are
          // in the first place.
  
          // Compute the integer boudns of tick0 + n * dtick that fall within the range
          // (roughly speaking):
          // Give this a nice generous epsilon. We use at as * (1 + eps) in order to make
          // inequalities a little tolerant in a more or less correct manner:
          eps = 5e-15;
          bounds = [
              Math.floor((data[data.length - 1] - axis.tick0) / axis.dtick * (1 + eps)),
              Math.ceil((data[0] - axis.tick0) / axis.dtick / (1 + eps))
          ].sort(function(a, b) {return a - b;});
  
          // Unpack sorted values so we can be sure to avoid infinite loops if something
          // is backwards:
          n1 = bounds[0];
          n2 = bounds[1];
  
          for(n = n1; n <= n2; n++) {
              value = axis.tick0 + axis.dtick * n;
  
              gridlines.push(extendFlat(constructValueGridline(value), {
                  color: axis.gridcolor,
                  width: axis.gridwidth
              }));
          }
  
          for(n = n1 - 1; n < n2 + 1; n++) {
              value = axis.tick0 + axis.dtick * n;
  
              for(i = 0; i < axis.minorgridcount; i++) {
                  v = value + axis.dtick * (i + 1) / (axis.minorgridcount + 1);
                  if(v < data[0] || v > data[data.length - 1]) continue;
                  minorgridlines.push(extendFlat(constructValueGridline(v), {
                      color: axis.minorgridcolor,
                      width: axis.minorgridwidth
                  }));
              }
          }
  
          if(axis.startline) {
              boundarylines.push(extendFlat(constructValueGridline(data[0]), {
                  color: axis.startlinecolor,
                  width: axis.startlinewidth
              }));
          }
  
          if(axis.endline) {
              boundarylines.push(extendFlat(constructValueGridline(data[data.length - 1]), {
                  color: axis.endlinecolor,
                  width: axis.endlinewidth
              }));
          }
      }
  };
  
  },{"../../lib/extend":740,"../../plots/cartesian/axes":799}],942:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = function calcLabels(trace, axis) {
      var i, tobj, prefix, suffix, gridline;
  
      var labels = axis._labels = [];
      var gridlines = axis._gridlines;
  
      for(i = 0; i < gridlines.length; i++) {
          gridline = gridlines[i];
  
          if(['start', 'both'].indexOf(axis.showticklabels) !== -1) {
              tobj = Axes.tickText(axis, gridline.value);
  
              extendFlat(tobj, {
                  prefix: prefix,
                  suffix: suffix,
                  endAnchor: true,
                  xy: gridline.xy(0),
                  dxy: gridline.dxy(0, 0),
                  axis: gridline.axis,
                  length: gridline.crossAxis.length,
                  font: gridline.axis.tickfont,
                  isFirst: i === 0,
                  isLast: i === gridlines.length - 1
              });
  
              labels.push(tobj);
          }
  
          if(['end', 'both'].indexOf(axis.showticklabels) !== -1) {
              tobj = Axes.tickText(axis, gridline.value);
  
              extendFlat(tobj, {
                  endAnchor: false,
                  xy: gridline.xy(gridline.crossLength - 1),
                  dxy: gridline.dxy(gridline.crossLength - 2, 1),
                  axis: gridline.axis,
                  length: gridline.crossAxis.length,
                  font: gridline.axis.tickfont,
                  isFirst: i === 0,
                  isLast: i === gridlines.length - 1
              });
  
              labels.push(tobj);
          }
      }
  };
  
  },{"../../lib/extend":740,"../../plots/cartesian/axes":799}],943:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /*
   * Compute the tangent vector according to catmull-rom cubic splines (centripetal,
   * I think). That differs from the control point in two ways:
   *   1. It is a vector, not a position relative to the point
   *   2. the vector is longer than the position relative to p1 by a factor of 3
   *
   * Close to the boundaries, we'll use these as *quadratic control points, so that
   * to make a nice grid, we'll need to divide the tangent by 2 instead of 3. (The
   * math works out this way if you work through the bezier derivatives)
   */
  var CatmullRomExp = 0.5;
  module.exports = function makeControlPoints(p0, p1, p2, smoothness) {
      var d1x = p0[0] - p1[0];
      var d1y = p0[1] - p1[1];
      var d2x = p2[0] - p1[0];
      var d2y = p2[1] - p1[1];
      var d1a = Math.pow(d1x * d1x + d1y * d1y, CatmullRomExp / 2);
      var d2a = Math.pow(d2x * d2x + d2y * d2y, CatmullRomExp / 2);
      var numx = (d2a * d2a * d1x - d1a * d1a * d2x) * smoothness;
      var numy = (d2a * d2a * d1y - d1a * d1a * d2y) * smoothness;
      var denom1 = d2a * (d1a + d2a) * 3;
      var denom2 = d1a * (d1a + d2a) * 3;
  
      return [[
          p1[0] + (denom1 && numx / denom1),
          p1[1] + (denom1 && numy / denom1)
      ], [
          p1[0] - (denom2 && numx / denom2),
          p1[1] - (denom2 && numy / denom2)
      ]];
  };
  
  },{}],944:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  
  /*
   * Construct a 2D array of cheater values given a, b, and a slope.
   * If
   */
  module.exports = function(a, b, cheaterslope) {
      var i, j, ascal, bscal, aval, bval;
      var data = [];
  
      var na = isArrayOrTypedArray(a) ? a.length : a;
      var nb = isArrayOrTypedArray(b) ? b.length : b;
      var adata = isArrayOrTypedArray(a) ? a : null;
      var bdata = isArrayOrTypedArray(b) ? b : null;
  
      // If we're using data, scale it so that for data that's just barely
      // not evenly spaced, the switch to value-based indexing is continuous.
      // This means evenly spaced data should look the same whether value
      // or index cheatertype.
      if(adata) {
          ascal = (adata.length - 1) / (adata[adata.length - 1] - adata[0]) / (na - 1);
      }
  
      if(bdata) {
          bscal = (bdata.length - 1) / (bdata[bdata.length - 1] - bdata[0]) / (nb - 1);
      }
  
      var xval;
      var xmin = Infinity;
      var xmax = -Infinity;
      for(j = 0; j < nb; j++) {
          data[j] = [];
          bval = bdata ? (bdata[j] - bdata[0]) * bscal : j / (nb - 1);
          for(i = 0; i < na; i++) {
              aval = adata ? (adata[i] - adata[0]) * ascal : i / (na - 1);
              xval = aval - bval * cheaterslope;
              xmin = Math.min(xval, xmin);
              xmax = Math.max(xval, xmax);
              data[j][i] = xval;
          }
      }
  
      // Normalize cheater values to the 0-1 range. This comes into play when you have
      // multiple cheater plots. After careful consideration, it seems better if cheater
      // values are normalized to a consistent range. Otherwise one cheater affects the
      // layout of other cheaters on the same axis.
      var slope = 1.0 / (xmax - xmin);
      var offset = -xmin * slope;
      for(j = 0; j < nb; j++) {
          for(i = 0; i < na; i++) {
              data[j][i] = slope * data[j][i] + offset;
          }
      }
  
      return data;
  };
  
  },{"../../lib":750}],945:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var makeControlPoints = _dereq_('./catmull_rom');
  var ensureArray = _dereq_('../../lib').ensureArray;
  
  /*
   * Turns a coarse grid into a fine grid with control points.
   *
   * Here's an ASCII representation:
   *
   *       o ----- o ----- o ----- o
   *       |       |       |       |
   *       |       |       |       |
   *       |       |       |       |
   *       o ----- o ----- o ----- o
   *       |       |       |       |
   *       |       |       |       |
   *    ^  |       |       |       |
   *    |  o ----- o ----- o ----- o
   *  b |  |       |       |       |
   *    |  |       |       |       |
   *    |  |       |       |       |
   *       o ----- o ----- o ----- o
   *         ------>
   *           a
   *
   * First of all, note that we want to do this in *cartesian* space. This means
   * we might run into problems when there are extreme differences in x/y scaling,
   * but the alternative is that the topology of the contours might actually be
   * view-dependent, which seems worse. As a fallback, the only parameter that
   * actually affects the result is the *aspect ratio*, so that we can at least
   * improve the situation a bit without going all the way to screen coordinates.
   *
   * This function flattens the points + tangents  into a slightly denser grid of
   * *control points*. The resulting grid looks like this:
   *
   *       9 +--o-o--+ -o-o--+--o-o--+
   *       8 o  o o  o  o o  o  o o  o
   *         |       |       |       |
   *       7 o  o o  o  o o  o  o o  o
   *       6 +--o-o--+ -o-o--+--o-o--+
   *       5 o  o o  o  o o  o  o o  o
   *         |       |       |       |
   *    ^  4 o  o o  o  o o  o  o o  o
   *    |  3 +--o-o--+ -o-o--+--o-o--+
   *  b |  2 o  o o  o  o o  o  o o  o
   *    |    |       |       |       |
   *    |  1 o  o o  o  o o  o  o o  o
   *       0 +--o-o--+ -o-o--+--o-o--+
   *         0  1 2  3  4 5  6  7 8  9
   *         ------>
   *           a
   *
   * where `o`s represent newly-computed control points. the resulting dimension is
   *
   *     (m - 1) * 3 + 1
   *   = 3 * m - 2
   *
   * We could simply store the tangents separately, but that's a nightmare to organize
   * in two dimensions since we'll be slicing grid lines in both directions and since
   * that basically requires very nearly just as much storage as just storing the dense
   * grid.
   *
   * Wow!
   */
  
  
  /*
   * Catmull-rom is biased at the boundaries toward the interior and we actually
   * can't use catmull-rom to compute the control point closest to (but inside)
   * the boundary.
   *
   * A note on plotly's spline interpolation. It uses the catmull rom control point
   * closest to the boundary *as* a quadratic control point. This seems incorrect,
   * so I've elected not to follow that. Given control points 0 and 1, regular plotly
   * splines give *equivalent* cubic control points:
   *
   * Input:
   *
   *   boundary
   *     |                    |
   *     p0           p2      p3    --> interior
   *     0.0          0.667   1.0
   *     |                    |
   *
   * Cubic-equivalent of what plotly splines draw::
   *
   *   boundary
   *     |                    |
   *     p0   p1      p2      p3    --> interior
   *     0.0  0.4444  0.8888  1.0
   *     |                    |
   *
   * What this function fills in:
   *
   *   boundary
   *     |                    |
   *     p0    p1     p2      p3    --> interior
   *     0.0   0.333  0.667   1.0
   *     |                    |
   *
   * Parameters:
   *   p0: boundary point
   *   p2: catmull rom point based on computation at p3
   *   p3: first grid point
   *
   * Of course it works whichever way it's oriented; you just need to interpret the
   * input/output accordingly.
   */
  function inferCubicControlPoint(p0, p2, p3) {
      // Extend p1 away from p0 by 50%. This is the equivalent quadratic point that
      // would give the same slope as catmull rom at p0.
      var p2e0 = -0.5 * p3[0] + 1.5 * p2[0];
      var p2e1 = -0.5 * p3[1] + 1.5 * p2[1];
  
      return [
          (2 * p2e0 + p0[0]) / 3,
          (2 * p2e1 + p0[1]) / 3,
      ];
  }
  
  module.exports = function computeControlPoints(xe, ye, x, y, asmoothing, bsmoothing) {
      var i, j, ie, je, xej, yej, xj, yj, cp, p1;
      // At this point, we know these dimensions are correct and representative of
      // the whole 2D arrays:
      var na = x[0].length;
      var nb = x.length;
  
      // (n)umber of (e)xpanded points:
      var nea = asmoothing ? 3 * na - 2 : na;
      var neb = bsmoothing ? 3 * nb - 2 : nb;
  
      xe = ensureArray(xe, neb);
      ye = ensureArray(ye, neb);
  
      for(ie = 0; ie < neb; ie++) {
          xe[ie] = ensureArray(xe[ie], nea);
          ye[ie] = ensureArray(ye[ie], nea);
      }
  
      // This loop fills in the X'd points:
      //
      //    .       .       .       .
      //    .       .       .       .
      //    |       |       |       |
      //    |       |       |       |
      //    X ----- X ----- X ----- X
      //    |       |       |       |
      //    |       |       |       |
      //    |       |       |       |
      //    X ----- X ----- X ----- X
      //
      //
      // ie = (i) (e)xpanded:
      for(j = 0, je = 0; j < nb; j++, je += bsmoothing ? 3 : 1) {
          xej = xe[je];
          yej = ye[je];
          xj = x[j];
          yj = y[j];
  
          // je = (j) (e)xpanded:
          for(i = 0, ie = 0; i < na; i++, ie += asmoothing ? 3 : 1) {
              xej[ie] = xj[i];
              yej[ie] = yj[i];
          }
      }
  
      if(asmoothing) {
          // If there's a-smoothing, this loop fills in the X'd points with catmull-rom
          // control points computed along the a-axis:
          //     .       .       .       .
          //     .       .       .       .
          //     |       |       |       |
          //     |       |       |       |
          //     o -Y-X- o -X-X- o -X-Y- o
          //     |       |       |       |
          //     |       |       |       |
          //     |       |       |       |
          //     o -Y-X- o -X-X- o -X-Y- o
          //
          // i:  0       1       2       3
          // ie: 0  1 3  3  4 5  6  7 8  9
          //
          //           ------>
          //             a
          //
          for(j = 0, je = 0; j < nb; j++, je += bsmoothing ? 3 : 1) {
              // Fill in the points marked X for this a-row:
              for(i = 1, ie = 3; i < na - 1; i++, ie += 3) {
                  cp = makeControlPoints(
                      [x[j][i - 1], y[j][i - 1]],
                      [x[j][i ], y[j][i]],
                      [x[j][i + 1], y[j][i + 1]],
                      asmoothing
                  );
  
                  xe[je][ie - 1] = cp[0][0];
                  ye[je][ie - 1] = cp[0][1];
                  xe[je][ie + 1] = cp[1][0];
                  ye[je][ie + 1] = cp[1][1];
              }
  
              // The very first cubic interpolation point (to the left for i = 1 above) is
              // used as a *quadratic* interpolation point by the spline drawing function
              // which isn't really correct. But for the sake of consistency, we'll use it
              // as such. Since we're using cubic splines, that means we need to shorten the
              // tangent by 1/3 and also construct a new cubic spline control point 1/3 from
              // the original to the i = 0 point.
              p1 = inferCubicControlPoint(
                  [xe[je][0], ye[je][0]],
                  [xe[je][2], ye[je][2]],
                  [xe[je][3], ye[je][3]]
              );
              xe[je][1] = p1[0];
              ye[je][1] = p1[1];
  
              // Ditto last points, sans explanation:
              p1 = inferCubicControlPoint(
                  [xe[je][nea - 1], ye[je][nea - 1]],
                  [xe[je][nea - 3], ye[je][nea - 3]],
                  [xe[je][nea - 4], ye[je][nea - 4]]
              );
              xe[je][nea - 2] = p1[0];
              ye[je][nea - 2] = p1[1];
          }
      }
  
      if(bsmoothing) {
          // If there's a-smoothing, this loop fills in the X'd points with catmull-rom
          // control points computed along the b-axis:
          //     .       .       .       .
          //     X  X X  X  X X  X  X X  X
          //     |       |       |       |
          //     X  X X  X  X X  X  X X  X
          //     o -o-o- o -o-o- o -o-o- o
          //     X  X X  X  X X  X  X X  X
          //     |       |       |       |
          //     Y  Y Y  Y  Y Y  Y  Y Y  Y
          //     o -o-o- o -o-o- o -o-o- o
          //
          // i:  0       1       2       3
          // ie: 0  1 3  3  4 5  6  7 8  9
          //
          //           ------>
          //             a
          //
          for(ie = 0; ie < nea; ie++) {
              for(je = 3; je < neb - 3; je += 3) {
                  cp = makeControlPoints(
                      [xe[je - 3][ie], ye[je - 3][ie]],
                      [xe[je][ie], ye[je][ie]],
                      [xe[je + 3][ie], ye[je + 3][ie]],
                      bsmoothing
                  );
  
                  xe[je - 1][ie] = cp[0][0];
                  ye[je - 1][ie] = cp[0][1];
                  xe[je + 1][ie] = cp[1][0];
                  ye[je + 1][ie] = cp[1][1];
              }
              // Do the same boundary condition magic for these control points marked Y above:
              p1 = inferCubicControlPoint(
                  [xe[0][ie], ye[0][ie]],
                  [xe[2][ie], ye[2][ie]],
                  [xe[3][ie], ye[3][ie]]
              );
              xe[1][ie] = p1[0];
              ye[1][ie] = p1[1];
  
              p1 = inferCubicControlPoint(
                  [xe[neb - 1][ie], ye[neb - 1][ie]],
                  [xe[neb - 3][ie], ye[neb - 3][ie]],
                  [xe[neb - 4][ie], ye[neb - 4][ie]]
              );
              xe[neb - 2][ie] = p1[0];
              ye[neb - 2][ie] = p1[1];
          }
      }
  
      if(asmoothing && bsmoothing) {
          // Do one more pass, this time recomputing exactly what we just computed.
          // It's overdetermined since we're peforming catmull-rom in two directions,
          // so we'll just average the overdetermined. These points don't lie along the
          // grid lines, so note that only grid lines will follow normal plotly spline
          // interpolation.
          //
          // Unless of course there was no b smoothing. Then these intermediate points
          // don't actually exist and this section is bypassed.
          //     .       .       .       .
          //     o  X X  o  X X  o  X X  o
          //     |       |       |       |
          //     o  X X  o  X X  o  X X  o
          //     o -o-o- o -o-o- o -o-o- o
          //     o  X X  o  X X  o  X X  o
          //     |       |       |       |
          //     o  Y Y  o  Y Y  o  Y Y  o
          //     o -o-o- o -o-o- o -o-o- o
          //
          // i:  0       1       2       3
          // ie: 0  1 3  3  4 5  6  7 8  9
          //
          //           ------>
          //             a
          //
          for(je = 1; je < neb; je += (je + 1) % 3 === 0 ? 2 : 1) {
              // Fill in the points marked X for this a-row:
              for(ie = 3; ie < nea - 3; ie += 3) {
                  cp = makeControlPoints(
                      [xe[je][ie - 3], ye[je][ie - 3]],
                      [xe[je][ie], ye[je][ie]],
                      [xe[je][ie + 3], ye[je][ie + 3]],
                      asmoothing
                  );
  
                  xe[je][ie - 1] = 0.5 * (xe[je][ie - 1] + cp[0][0]);
                  ye[je][ie - 1] = 0.5 * (ye[je][ie - 1] + cp[0][1]);
                  xe[je][ie + 1] = 0.5 * (xe[je][ie + 1] + cp[1][0]);
                  ye[je][ie + 1] = 0.5 * (ye[je][ie + 1] + cp[1][1]);
              }
  
              // This case is just slightly different. The computation is the same,
              // but having computed this, we'll average with the existing result.
              p1 = inferCubicControlPoint(
                  [xe[je][0], ye[je][0]],
                  [xe[je][2], ye[je][2]],
                  [xe[je][3], ye[je][3]]
              );
              xe[je][1] = 0.5 * (xe[je][1] + p1[0]);
              ye[je][1] = 0.5 * (ye[je][1] + p1[1]);
  
              p1 = inferCubicControlPoint(
                  [xe[je][nea - 1], ye[je][nea - 1]],
                  [xe[je][nea - 3], ye[je][nea - 3]],
                  [xe[je][nea - 4], ye[je][nea - 4]]
              );
              xe[je][nea - 2] = 0.5 * (xe[je][nea - 2] + p1[0]);
              ye[je][nea - 2] = 0.5 * (ye[je][nea - 2] + p1[1]);
          }
      }
  
      return [xe, ye];
  };
  
  },{"../../lib":750,"./catmull_rom":943}],946:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = {
      RELATIVE_CULL_TOLERANCE: 1e-6
  };
  
  },{}],947:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /*
   * Evaluates the derivative of a list of control point arrays. That is, it expects an array or arrays
   * that are expanded relative to the raw data to include the bicubic control points, if applicable. If
   * only linear interpolation is desired, then the data points correspond 1-1 along that axis to the
   * data itself. Since it's catmull-rom splines in either direction note in particular that the
   * derivatives are discontinuous across cell boundaries. That's the reason you need both the *cell*
   * and the *point within the cell*.
   *
   * Also note that the discontinuity of the derivative is in magnitude only. The direction *is*
   * continuous across cell boundaries.
   *
   * For example, to compute the derivative of the xcoordinate halfway betwen the 7 and 8th i-gridpoints
   * and the 10th and 11th j-gridpoints given bicubic smoothing in both dimensions, you'd write:
   *
   *     var deriv = createIDerivativeEvaluator([x], 1, 1);
   *
   *     var dxdi = deriv([], 7, 10, 0.5, 0.5);
   *     // => [0.12345]
   *
   * Since there'd be a bunch of duplicate computation to compute multiple derivatives, you can double
   * this up by providing more arrays:
   *
   *     var deriv = createIDerivativeEvaluator([x, y], 1, 1);
   *
   *     var dxdi = deriv([], 7, 10, 0.5, 0.5);
   *     // => [0.12345, 0.78910]
   *
   * NB: It's presumed that at this point all data has been sanitized and is valid numerical data arrays
   * of the correct dimension.
   */
  module.exports = function(arrays, asmoothing, bsmoothing) {
      if(asmoothing && bsmoothing) {
          return function(out, i0, j0, u, v) {
              if(!out) out = [];
              var f0, f1, f2, f3, ak, k;
  
              // Since it's a grid of control points, the actual indices are * 3:
              i0 *= 3;
              j0 *= 3;
  
              // Precompute some numbers:
              var u2 = u * u;
              var ou = 1 - u;
              var ou2 = ou * ou;
              var ouu2 = ou * u * 2;
              var a = -3 * ou2;
              var b = 3 * (ou2 - ouu2);
              var c = 3 * (ouu2 - u2);
              var d = 3 * u2;
  
              var v2 = v * v;
              var v3 = v2 * v;
              var ov = 1 - v;
              var ov2 = ov * ov;
              var ov3 = ov2 * ov;
  
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  // Compute the derivatives in the u-direction:
                  f0 = a * ak[j0 ][i0] + b * ak[j0 ][i0 + 1] + c * ak[j0 ][i0 + 2] + d * ak[j0 ][i0 + 3];
                  f1 = a * ak[j0 + 1][i0] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 1][i0 + 2] + d * ak[j0 + 1][i0 + 3];
                  f2 = a * ak[j0 + 2][i0] + b * ak[j0 + 2][i0 + 1] + c * ak[j0 + 2][i0 + 2] + d * ak[j0 + 2][i0 + 3];
                  f3 = a * ak[j0 + 3][i0] + b * ak[j0 + 3][i0 + 1] + c * ak[j0 + 3][i0 + 2] + d * ak[j0 + 3][i0 + 3];
  
                  // Now just interpolate in the v-direction since it's all separable:
                  out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
              }
  
              return out;
          };
      } else if(asmoothing) {
          // Handle smooth in the a-direction but linear in the b-direction by performing four
          // linear interpolations followed by one cubic interpolation of the result
          return function(out, i0, j0, u, v) {
              if(!out) out = [];
              var f0, f1, k, ak;
              i0 *= 3;
              var u2 = u * u;
              var ou = 1 - u;
              var ou2 = ou * ou;
              var ouu2 = ou * u * 2;
              var a = -3 * ou2;
              var b = 3 * (ou2 - ouu2);
              var c = 3 * (ouu2 - u2);
              var d = 3 * u2;
              var ov = 1 - v;
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  f0 = a * ak[j0 ][i0] + b * ak[j0 ][i0 + 1] + c * ak[j0 ][i0 + 2] + d * ak[j0 ][i0 + 3];
                  f1 = a * ak[j0 + 1][i0] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 1][i0 + 2] + d * ak[j0 + 1][i0 + 3];
  
                  out[k] = ov * f0 + v * f1;
              }
              return out;
          };
      } else if(bsmoothing) {
          // Same as the above case, except reversed. I've disabled the no-unused vars rule
          // so that this function is fully interpolation-agnostic. Otherwise it would need
          // to be called differently in different cases. Which wouldn't be the worst, but
          /* eslint-disable no-unused-vars */
          return function(out, i0, j0, u, v) {
          /* eslint-enable no-unused-vars */
              if(!out) out = [];
              var f0, f1, f2, f3, k, ak;
              j0 *= 3;
              var v2 = v * v;
              var v3 = v2 * v;
              var ov = 1 - v;
              var ov2 = ov * ov;
              var ov3 = ov2 * ov;
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  f0 = ak[j0][i0 + 1] - ak[j0][i0];
                  f1 = ak[j0 + 1][i0 + 1] - ak[j0 + 1][i0];
                  f2 = ak[j0 + 2][i0 + 1] - ak[j0 + 2][i0];
                  f3 = ak[j0 + 3][i0 + 1] - ak[j0 + 3][i0];
  
                  out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
              }
              return out;
          };
      } else {
          // Finally, both directions are linear:
          /* eslint-disable no-unused-vars */
          return function(out, i0, j0, u, v) {
          /* eslint-enable no-unused-vars */
              if(!out) out = [];
              var f0, f1, k, ak;
              var ov = 1 - v;
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  f0 = ak[j0][i0 + 1] - ak[j0][i0];
                  f1 = ak[j0 + 1][i0 + 1] - ak[j0 + 1][i0];
  
                  out[k] = ov * f0 + v * f1;
              }
              return out;
          };
      }
  };
  
  },{}],948:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function(arrays, asmoothing, bsmoothing) {
      if(asmoothing && bsmoothing) {
          return function(out, i0, j0, u, v) {
              if(!out) out = [];
              var f0, f1, f2, f3, ak, k;
  
              // Since it's a grid of control points, the actual indices are * 3:
              i0 *= 3;
              j0 *= 3;
  
              // Precompute some numbers:
              var u2 = u * u;
              var u3 = u2 * u;
              var ou = 1 - u;
              var ou2 = ou * ou;
              var ou3 = ou2 * ou;
  
              var v2 = v * v;
              var ov = 1 - v;
              var ov2 = ov * ov;
              var ovv2 = ov * v * 2;
              var a = -3 * ov2;
              var b = 3 * (ov2 - ovv2);
              var c = 3 * (ovv2 - v2);
              var d = 3 * v2;
  
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
  
                  // Compute the derivatives in the v-direction:
                  f0 = a * ak[j0][i0] + b * ak[j0 + 1][i0] + c * ak[j0 + 2][i0] + d * ak[j0 + 3][i0];
                  f1 = a * ak[j0][i0 + 1] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 2][i0 + 1] + d * ak[j0 + 3][i0 + 1];
                  f2 = a * ak[j0][i0 + 2] + b * ak[j0 + 1][i0 + 2] + c * ak[j0 + 2][i0 + 2] + d * ak[j0 + 3][i0 + 2];
                  f3 = a * ak[j0][i0 + 3] + b * ak[j0 + 1][i0 + 3] + c * ak[j0 + 2][i0 + 3] + d * ak[j0 + 3][i0 + 3];
  
                  // Now just interpolate in the v-direction since it's all separable:
                  out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
              }
  
              return out;
          };
      } else if(asmoothing) {
          // Handle smooth in the a-direction but linear in the b-direction by performing four
          // linear interpolations followed by one cubic interpolation of the result
          return function(out, i0, j0, v, u) {
              if(!out) out = [];
              var f0, f1, f2, f3, k, ak;
              i0 *= 3;
              var u2 = u * u;
              var u3 = u2 * u;
              var ou = 1 - u;
              var ou2 = ou * ou;
              var ou3 = ou2 * ou;
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
  
                  f0 = ak[j0 + 1][i0] - ak[j0][i0];
                  f1 = ak[j0 + 1][i0 + 1] - ak[j0][i0 + 1];
                  f2 = ak[j0 + 1][i0 + 2] - ak[j0][i0 + 2];
                  f3 = ak[j0 + 1][i0 + 3] - ak[j0][i0 + 3];
  
                  out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
  
                  // mathematically equivalent:
                  // f0 = ou3 * ak[j0    ][i0] + 3 * (ou2 * u * ak[j0    ][i0 + 1] + ou * u2 * ak[j0    ][i0 + 2]) + u3 * ak[j0    ][i0 + 3];
                  // f1 = ou3 * ak[j0 + 1][i0] + 3 * (ou2 * u * ak[j0 + 1][i0 + 1] + ou * u2 * ak[j0 + 1][i0 + 2]) + u3 * ak[j0 + 1][i0 + 3];
                  // out[k] = f1 - f0;
              }
              return out;
          };
      } else if(bsmoothing) {
          // Same as the above case, except reversed:
          /* eslint-disable no-unused-vars */
          return function(out, i0, j0, u, v) {
          /* eslint-enable no-unused-vars */
              if(!out) out = [];
              var f0, f1, k, ak;
              j0 *= 3;
              var ou = 1 - u;
              var v2 = v * v;
              var ov = 1 - v;
              var ov2 = ov * ov;
              var ovv2 = ov * v * 2;
              var a = -3 * ov2;
              var b = 3 * (ov2 - ovv2);
              var c = 3 * (ovv2 - v2);
              var d = 3 * v2;
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  f0 = a * ak[j0][i0] + b * ak[j0 + 1][i0] + c * ak[j0 + 2][i0] + d * ak[j0 + 3][i0];
                  f1 = a * ak[j0][i0 + 1] + b * ak[j0 + 1][i0 + 1] + c * ak[j0 + 2][i0 + 1] + d * ak[j0 + 3][i0 + 1];
  
                  out[k] = ou * f0 + u * f1;
              }
              return out;
          };
      } else {
          // Finally, both directions are linear:
          /* eslint-disable no-unused-vars */
          return function(out, i0, j0, v, u) {
          /* eslint-enable no-unused-vars */
              if(!out) out = [];
              var f0, f1, k, ak;
              var ov = 1 - v;
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  f0 = ak[j0 + 1][i0] - ak[j0][i0];
                  f1 = ak[j0 + 1][i0 + 1] - ak[j0][i0 + 1];
  
                  out[k] = ov * f0 + v * f1;
              }
              return out;
          };
      }
  };
  
  },{}],949:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /*
   * Return a function that evaluates a set of linear or bicubic control points.
   * This will get evaluated a lot, so we'll at least do a bit of extra work to
   * flatten some of the choices. In particular, we'll unroll the linear/bicubic
   * combinations and we'll allow computing results in parallel to cut down
   * on repeated arithmetic.
   *
   * Take note that we don't search for the correct range in this function. The
   * reason is for consistency due to the corrresponding derivative function. In
   * particular, the derivatives aren't continuous across cells, so it's important
   * to be able control whether the derivative at a cell boundary is approached
   * from one side or the other.
   */
  module.exports = function(arrays, na, nb, asmoothing, bsmoothing) {
      var imax = na - 2;
      var jmax = nb - 2;
  
      if(asmoothing && bsmoothing) {
          return function(out, i, j) {
              if(!out) out = [];
              var f0, f1, f2, f3, ak, k;
  
              var i0 = Math.max(0, Math.min(Math.floor(i), imax));
              var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
              var u = Math.max(0, Math.min(1, i - i0));
              var v = Math.max(0, Math.min(1, j - j0));
  
              // Since it's a grid of control points, the actual indices are * 3:
              i0 *= 3;
              j0 *= 3;
  
              // Precompute some numbers:
              var u2 = u * u;
              var u3 = u2 * u;
              var ou = 1 - u;
              var ou2 = ou * ou;
              var ou3 = ou2 * ou;
  
              var v2 = v * v;
              var v3 = v2 * v;
              var ov = 1 - v;
              var ov2 = ov * ov;
              var ov3 = ov2 * ov;
  
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  f0 = ou3 * ak[j0][i0] + 3 * (ou2 * u * ak[j0][i0 + 1] + ou * u2 * ak[j0][i0 + 2]) + u3 * ak[j0][i0 + 3];
                  f1 = ou3 * ak[j0 + 1][i0] + 3 * (ou2 * u * ak[j0 + 1][i0 + 1] + ou * u2 * ak[j0 + 1][i0 + 2]) + u3 * ak[j0 + 1][i0 + 3];
                  f2 = ou3 * ak[j0 + 2][i0] + 3 * (ou2 * u * ak[j0 + 2][i0 + 1] + ou * u2 * ak[j0 + 2][i0 + 2]) + u3 * ak[j0 + 2][i0 + 3];
                  f3 = ou3 * ak[j0 + 3][i0] + 3 * (ou2 * u * ak[j0 + 3][i0 + 1] + ou * u2 * ak[j0 + 3][i0 + 2]) + u3 * ak[j0 + 3][i0 + 3];
                  out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
              }
  
              return out;
          };
      } else if(asmoothing) {
          // Handle smooth in the a-direction but linear in the b-direction by performing four
          // linear interpolations followed by one cubic interpolation of the result
          return function(out, i, j) {
              if(!out) out = [];
  
              var i0 = Math.max(0, Math.min(Math.floor(i), imax));
              var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
              var u = Math.max(0, Math.min(1, i - i0));
              var v = Math.max(0, Math.min(1, j - j0));
  
              var f0, f1, f2, f3, k, ak;
              i0 *= 3;
              var u2 = u * u;
              var u3 = u2 * u;
              var ou = 1 - u;
              var ou2 = ou * ou;
              var ou3 = ou2 * ou;
              var ov = 1 - v;
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  f0 = ov * ak[j0][i0] + v * ak[j0 + 1][i0];
                  f1 = ov * ak[j0][i0 + 1] + v * ak[j0 + 1][i0 + 1];
                  f2 = ov * ak[j0][i0 + 2] + v * ak[j0 + 1][i0 + 1];
                  f3 = ov * ak[j0][i0 + 3] + v * ak[j0 + 1][i0 + 1];
  
                  out[k] = ou3 * f0 + 3 * (ou2 * u * f1 + ou * u2 * f2) + u3 * f3;
              }
              return out;
          };
      } else if(bsmoothing) {
          // Same as the above case, except reversed:
          return function(out, i, j) {
              if(!out) out = [];
  
              var i0 = Math.max(0, Math.min(Math.floor(i), imax));
              var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
              var u = Math.max(0, Math.min(1, i - i0));
              var v = Math.max(0, Math.min(1, j - j0));
  
              var f0, f1, f2, f3, k, ak;
              j0 *= 3;
              var v2 = v * v;
              var v3 = v2 * v;
              var ov = 1 - v;
              var ov2 = ov * ov;
              var ov3 = ov2 * ov;
              var ou = 1 - u;
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  f0 = ou * ak[j0][i0] + u * ak[j0][i0 + 1];
                  f1 = ou * ak[j0 + 1][i0] + u * ak[j0 + 1][i0 + 1];
                  f2 = ou * ak[j0 + 2][i0] + u * ak[j0 + 2][i0 + 1];
                  f3 = ou * ak[j0 + 3][i0] + u * ak[j0 + 3][i0 + 1];
  
                  out[k] = ov3 * f0 + 3 * (ov2 * v * f1 + ov * v2 * f2) + v3 * f3;
              }
              return out;
          };
      } else {
          // Finally, both directions are linear:
          return function(out, i, j) {
              if(!out) out = [];
  
              var i0 = Math.max(0, Math.min(Math.floor(i), imax));
              var j0 = Math.max(0, Math.min(Math.floor(j), jmax));
              var u = Math.max(0, Math.min(1, i - i0));
              var v = Math.max(0, Math.min(1, j - j0));
  
              var f0, f1, k, ak;
              var ov = 1 - v;
              var ou = 1 - u;
              for(k = 0; k < arrays.length; k++) {
                  ak = arrays[k];
                  f0 = ou * ak[j0][i0] + u * ak[j0][i0 + 1];
                  f1 = ou * ak[j0 + 1][i0] + u * ak[j0 + 1][i0 + 1];
  
                  out[k] = ov * f0 + v * f1;
              }
              return out;
          };
      }
  };
  
  },{}],950:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var handleXYDefaults = _dereq_('./xy_defaults');
  var handleABDefaults = _dereq_('./ab_defaults');
  var attributes = _dereq_('./attributes');
  var colorAttrs = _dereq_('../../components/color/attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, dfltColor, fullLayout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      traceOut._clipPathId = 'clip' + traceOut.uid + 'carpet';
  
      var defaultColor = coerce('color', colorAttrs.defaultLine);
      Lib.coerceFont(coerce, 'font');
  
      coerce('carpet');
  
      handleABDefaults(traceIn, traceOut, fullLayout, coerce, defaultColor);
  
      if(!traceOut.a || !traceOut.b) {
          traceOut.visible = false;
          return;
      }
  
      if(traceOut.a.length < 3) {
          traceOut.aaxis.smoothing = 0;
      }
  
      if(traceOut.b.length < 3) {
          traceOut.baxis.smoothing = 0;
      }
  
      // NB: the input is x/y arrays. You should know that the *first* dimension of x and y
      // corresponds to b and the second to a. This sounds backwards but ends up making sense
      // the important part to know is that when you write y[j][i], j goes from 0 to b.length - 1
      // and i goes from 0 to a.length - 1.
      var validData = handleXYDefaults(traceIn, traceOut, coerce);
      if(!validData) {
          traceOut.visible = false;
      }
  
      if(traceOut._cheater) {
          coerce('cheaterslope');
      }
  };
  
  },{"../../components/color/attributes":614,"../../lib":750,"./ab_defaults":933,"./attributes":935,"./xy_defaults":959}],951:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      plot: _dereq_('./plot'),
      calc: _dereq_('./calc'),
      animatable: true,
      isContainer: true, // so carpet traces get `calc` before other traces
  
      moduleType: 'trace',
      name: 'carpet',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', 'carpet', 'carpetAxis', 'notLegendIsolatable', 'noMultiCategory', 'noHover', 'noSortingByValue'],
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"./attributes":935,"./calc":939,"./defaults":950,"./plot":956}],952:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /*
   * Given a trace, look up the carpet axis by carpet.
   */
  module.exports = function(gd, trace) {
      var n = gd._fullData.length;
      var firstAxis;
      for(var i = 0; i < n; i++) {
          var maybeCarpet = gd._fullData[i];
  
          if(maybeCarpet.index === trace.index) continue;
  
          if(maybeCarpet.type === 'carpet') {
              if(!firstAxis) {
                  firstAxis = maybeCarpet;
              }
  
              if(maybeCarpet.carpet === trace.carpet) {
                  return maybeCarpet;
              }
          }
      }
  
      return firstAxis;
  };
  
  },{}],953:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function makePath(xp, yp, isBicubic) {
      // Prevent d3 errors that would result otherwise:
      if(xp.length === 0) return '';
  
      var i;
      var path = [];
      var stride = isBicubic ? 3 : 1;
      for(i = 0; i < xp.length; i += stride) {
          path.push(xp[i] + ',' + yp[i]);
  
          if(isBicubic && i < xp.length - stride) {
              path.push('C');
              path.push([
                  xp[i + 1] + ',' + yp[i + 1],
                  xp[i + 2] + ',' + yp[i + 2] + ' ',
              ].join(' '));
          }
      }
      return path.join(isBicubic ? '' : 'L');
  };
  
  },{}],954:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  
  /*
   * Map an array of x or y coordinates (c) to screen-space pixel coordinates (p).
   * The output array is optional, but if provided, it will be reused without
   * reallocation to the extent possible.
   */
  module.exports = function mapArray(out, data, func) {
      var i;
  
      if(!isArrayOrTypedArray(out)) {
          // If not an array, make it an array:
          out = [];
      } else if(out.length > data.length) {
          // If too long, truncate. (If too short, it will grow
          // automatically so we don't care about that case)
          out = out.slice(0, data.length);
      }
  
      for(i = 0; i < data.length; i++) {
          out[i] = func(data[i]);
      }
  
      return out;
  };
  
  },{"../../lib":750}],955:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = function orientText(trace, xaxis, yaxis, xy, dxy, refDxy) {
      var dx = dxy[0] * trace.dpdx(xaxis);
      var dy = dxy[1] * trace.dpdy(yaxis);
      var flip = 1;
  
      var offsetMultiplier = 1.0;
      if(refDxy) {
          var l1 = Math.sqrt(dxy[0] * dxy[0] + dxy[1] * dxy[1]);
          var l2 = Math.sqrt(refDxy[0] * refDxy[0] + refDxy[1] * refDxy[1]);
          var dot = (dxy[0] * refDxy[0] + dxy[1] * refDxy[1]) / l1 / l2;
          offsetMultiplier = Math.max(0.0, dot);
      }
  
      var angle = Math.atan2(dy, dx) * 180 / Math.PI;
      if(angle < -90) {
          angle += 180;
          flip = -flip;
      } else if(angle > 90) {
          angle -= 180;
          flip = -flip;
      }
  
      return {
          angle: angle,
          flip: flip,
          p: trace.c2p(xy, xaxis, yaxis),
          offsetMultplier: offsetMultiplier
      };
  };
  
  },{}],956:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Drawing = _dereq_('../../components/drawing');
  var map1dArray = _dereq_('./map_1d_array');
  var makepath = _dereq_('./makepath');
  var orientText = _dereq_('./orient_text');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var Lib = _dereq_('../../lib');
  var alignmentConstants = _dereq_('../../constants/alignment');
  
  module.exports = function plot(gd, plotinfo, cdcarpet, carpetLayer) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
      var fullLayout = gd._fullLayout;
      var clipLayer = fullLayout._clips;
  
      Lib.makeTraceGroups(carpetLayer, cdcarpet, 'trace').each(function(cd) {
          var axisLayer = d3.select(this);
          var cd0 = cd[0];
          var trace = cd0.trace;
          var aax = trace.aaxis;
          var bax = trace.baxis;
  
          var minorLayer = Lib.ensureSingle(axisLayer, 'g', 'minorlayer');
          var majorLayer = Lib.ensureSingle(axisLayer, 'g', 'majorlayer');
          var boundaryLayer = Lib.ensureSingle(axisLayer, 'g', 'boundarylayer');
          var labelLayer = Lib.ensureSingle(axisLayer, 'g', 'labellayer');
  
          axisLayer.style('opacity', trace.opacity);
  
          drawGridLines(xa, ya, majorLayer, aax, 'a', aax._gridlines, true);
          drawGridLines(xa, ya, majorLayer, bax, 'b', bax._gridlines, true);
          drawGridLines(xa, ya, minorLayer, aax, 'a', aax._minorgridlines, true);
          drawGridLines(xa, ya, minorLayer, bax, 'b', bax._minorgridlines, true);
  
          // NB: These are not ommitted if the lines are not active. The joins must be executed
          // in order for them to get cleaned up without a full redraw
          drawGridLines(xa, ya, boundaryLayer, aax, 'a-boundary', aax._boundarylines);
          drawGridLines(xa, ya, boundaryLayer, bax, 'b-boundary', bax._boundarylines);
  
          var labelOrientationA = drawAxisLabels(gd, xa, ya, trace, cd0, labelLayer, aax._labels, 'a-label');
          var labelOrientationB = drawAxisLabels(gd, xa, ya, trace, cd0, labelLayer, bax._labels, 'b-label');
  
          drawAxisTitles(gd, labelLayer, trace, cd0, xa, ya, labelOrientationA, labelOrientationB);
  
          drawClipPath(trace, cd0, clipLayer, xa, ya);
      });
  };
  
  function drawClipPath(trace, t, layer, xaxis, yaxis) {
      var seg, xp, yp, i;
  
      var clip = layer.select('#' + trace._clipPathId);
  
      if(!clip.size()) {
          clip = layer.append('clipPath')
              .classed('carpetclip', true);
      }
  
      var path = Lib.ensureSingle(clip, 'path', 'carpetboundary');
      var segments = t.clipsegments;
      var segs = [];
  
      for(i = 0; i < segments.length; i++) {
          seg = segments[i];
          xp = map1dArray([], seg.x, xaxis.c2p);
          yp = map1dArray([], seg.y, yaxis.c2p);
          segs.push(makepath(xp, yp, seg.bicubic));
      }
  
      // This could be optimized ever so slightly to avoid no-op L segments
      // at the corners, but it's so negligible that I don't think it's worth
      // the extra complexity
      var clipPathData = 'M' + segs.join('L') + 'Z';
      clip.attr('id', trace._clipPathId);
      path.attr('d', clipPathData);
  }
  
  function drawGridLines(xaxis, yaxis, layer, axis, axisLetter, gridlines) {
      var lineClass = 'const-' + axisLetter + '-lines';
      var gridJoin = layer.selectAll('.' + lineClass).data(gridlines);
  
      gridJoin.enter().append('path')
          .classed(lineClass, true)
          .style('vector-effect', 'non-scaling-stroke');
  
      gridJoin.each(function(d) {
          var gridline = d;
          var x = gridline.x;
          var y = gridline.y;
  
          var xp = map1dArray([], x, xaxis.c2p);
          var yp = map1dArray([], y, yaxis.c2p);
  
          var path = 'M' + makepath(xp, yp, gridline.smoothing);
  
          var el = d3.select(this);
  
          el.attr('d', path)
              .style('stroke-width', gridline.width)
              .style('stroke', gridline.color)
              .style('fill', 'none');
      });
  
      gridJoin.exit().remove();
  }
  
  function drawAxisLabels(gd, xaxis, yaxis, trace, t, layer, labels, labelClass) {
      var labelJoin = layer.selectAll('text.' + labelClass).data(labels);
  
      labelJoin.enter().append('text')
          .classed(labelClass, true);
  
      var maxExtent = 0;
      var labelOrientation = {};
  
      labelJoin.each(function(label, i) {
          // Most of the positioning is done in calc_labels. Only the parts that depend upon
          // the screen space representation of the x and y axes are here:
          var orientation;
          if(label.axis.tickangle === 'auto') {
              orientation = orientText(trace, xaxis, yaxis, label.xy, label.dxy);
          } else {
              var angle = (label.axis.tickangle + 180.0) * Math.PI / 180.0;
              orientation = orientText(trace, xaxis, yaxis, label.xy, [Math.cos(angle), Math.sin(angle)]);
          }
  
          if(!i) {
              // TODO: offsetMultiplier? Not currently used anywhere...
              labelOrientation = {angle: orientation.angle, flip: orientation.flip};
          }
          var direction = (label.endAnchor ? -1 : 1) * orientation.flip;
  
          var labelEl = d3.select(this)
              .attr({
                  'text-anchor': direction > 0 ? 'start' : 'end',
                  'data-notex': 1
              })
              .call(Drawing.font, label.font)
              .text(label.text)
              .call(svgTextUtils.convertToTspans, gd);
  
          var bbox = Drawing.bBox(this);
  
          labelEl.attr('transform',
                  // Translate to the correct point:
                  'translate(' + orientation.p[0] + ',' + orientation.p[1] + ') ' +
                  // Rotate to line up with grid line tangent:
                  'rotate(' + orientation.angle + ')' +
                  // Adjust the baseline and indentation:
                  'translate(' + label.axis.labelpadding * direction + ',' + bbox.height * 0.3 + ')'
              );
  
          maxExtent = Math.max(maxExtent, bbox.width + label.axis.labelpadding);
      });
  
      labelJoin.exit().remove();
  
      labelOrientation.maxExtent = maxExtent;
      return labelOrientation;
  }
  
  function drawAxisTitles(gd, layer, trace, t, xa, ya, labelOrientationA, labelOrientationB) {
      var a, b, xy, dxy;
  
      var aMin = Lib.aggNums(Math.min, null, trace.a);
      var aMax = Lib.aggNums(Math.max, null, trace.a);
      var bMin = Lib.aggNums(Math.min, null, trace.b);
      var bMax = Lib.aggNums(Math.max, null, trace.b);
  
      a = 0.5 * (aMin + aMax);
      b = bMin;
      xy = trace.ab2xy(a, b, true);
      dxy = trace.dxyda_rough(a, b);
      if(labelOrientationA.angle === undefined) {
          Lib.extendFlat(labelOrientationA, orientText(trace, xa, ya, xy, trace.dxydb_rough(a, b)));
      }
      drawAxisTitle(gd, layer, trace, t, xy, dxy, trace.aaxis, xa, ya, labelOrientationA, 'a-title');
  
      a = aMin;
      b = 0.5 * (bMin + bMax);
      xy = trace.ab2xy(a, b, true);
      dxy = trace.dxydb_rough(a, b);
      if(labelOrientationB.angle === undefined) {
          Lib.extendFlat(labelOrientationB, orientText(trace, xa, ya, xy, trace.dxyda_rough(a, b)));
      }
      drawAxisTitle(gd, layer, trace, t, xy, dxy, trace.baxis, xa, ya, labelOrientationB, 'b-title');
  }
  
  var lineSpacing = alignmentConstants.LINE_SPACING;
  var midShift = ((1 - alignmentConstants.MID_SHIFT) / lineSpacing) + 1;
  
  function drawAxisTitle(gd, layer, trace, t, xy, dxy, axis, xa, ya, labelOrientation, labelClass) {
      var data = [];
      if(axis.title.text) data.push(axis.title.text);
      var titleJoin = layer.selectAll('text.' + labelClass).data(data);
      var offset = labelOrientation.maxExtent;
  
      titleJoin.enter().append('text')
          .classed(labelClass, true);
  
      // There's only one, but we'll do it as a join so it's updated nicely:
      titleJoin.each(function() {
          var orientation = orientText(trace, xa, ya, xy, dxy);
  
          if(['start', 'both'].indexOf(axis.showticklabels) === -1) {
              offset = 0;
          }
  
          // In addition to the size of the labels, add on some extra padding:
          var titleSize = axis.title.font.size;
          offset += titleSize + axis.title.offset;
  
          var labelNorm = labelOrientation.angle + (labelOrientation.flip < 0 ? 180 : 0);
          var angleDiff = (labelNorm - orientation.angle + 450) % 360;
          var reverseTitle = angleDiff > 90 && angleDiff < 270;
  
          var el = d3.select(this);
  
          el.text(axis.title.text)
              .call(svgTextUtils.convertToTspans, gd);
  
          if(reverseTitle) {
              offset = (-svgTextUtils.lineCount(el) + midShift) * lineSpacing * titleSize - offset;
          }
  
          el.attr('transform',
                  'translate(' + orientation.p[0] + ',' + orientation.p[1] + ') ' +
                  'rotate(' + orientation.angle + ') ' +
                  'translate(0,' + offset + ')'
              )
              .attr('text-anchor', 'middle')
              .call(Drawing.font, axis.title.font);
      });
  
      titleJoin.exit().remove();
  }
  
  },{"../../components/drawing":637,"../../constants/alignment":717,"../../lib":750,"../../lib/svg_text_utils":774,"./makepath":953,"./map_1d_array":954,"./orient_text":955,"d3":169}],957:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var constants = _dereq_('./constants');
  var search = _dereq_('../../lib/search').findBin;
  var computeControlPoints = _dereq_('./compute_control_points');
  var createSplineEvaluator = _dereq_('./create_spline_evaluator');
  var createIDerivativeEvaluator = _dereq_('./create_i_derivative_evaluator');
  var createJDerivativeEvaluator = _dereq_('./create_j_derivative_evaluator');
  
  /*
   * Create conversion functions to go from one basis to another. In particular the letter
   * abbreviations are:
   *
   *   i: i/j coordinates along the grid. Integer values correspond to data points
   *   a: real-valued coordinates along the a/b axes
   *   c: cartesian x-y coordinates
   *   p: screen-space pixel coordinates
   */
  module.exports = function setConvert(trace) {
      var a = trace._a;
      var b = trace._b;
      var na = a.length;
      var nb = b.length;
      var aax = trace.aaxis;
      var bax = trace.baxis;
  
      // Grab the limits once rather than recomputing the bounds for every point
      // independently:
      var amin = a[0];
      var amax = a[na - 1];
      var bmin = b[0];
      var bmax = b[nb - 1];
      var arange = a[a.length - 1] - a[0];
      var brange = b[b.length - 1] - b[0];
  
      // Compute the tolerance so that points are visible slightly outside the
      // defined carpet axis:
      var atol = arange * constants.RELATIVE_CULL_TOLERANCE;
      var btol = brange * constants.RELATIVE_CULL_TOLERANCE;
  
      // Expand the limits to include the relative tolerance:
      amin -= atol;
      amax += atol;
      bmin -= btol;
      bmax += btol;
  
      trace.isVisible = function(a, b) {
          return a > amin && a < amax && b > bmin && b < bmax;
      };
  
      trace.isOccluded = function(a, b) {
          return a < amin || a > amax || b < bmin || b > bmax;
      };
  
      trace.setScale = function() {
          var x = trace._x;
          var y = trace._y;
  
          // This is potentially a very expensive step! It does the bulk of the work of constructing
          // an expanded basis of control points. Note in particular that it overwrites the existing
          // basis without creating a new array since that would potentially thrash the garbage
          // collector.
          var result = computeControlPoints(trace._xctrl, trace._yctrl, x, y, aax.smoothing, bax.smoothing);
          trace._xctrl = result[0];
          trace._yctrl = result[1];
  
          // This step is the second step in the process, but it's somewhat simpler. It just unrolls
          // some logic since it would be unnecessarily expensive to compute both interpolations
          // nearly identically but separately and to include a bunch of linear vs. bicubic logic in
          // every single call.
          trace.evalxy = createSplineEvaluator([trace._xctrl, trace._yctrl], na, nb, aax.smoothing, bax.smoothing);
  
          trace.dxydi = createIDerivativeEvaluator([trace._xctrl, trace._yctrl], aax.smoothing, bax.smoothing);
          trace.dxydj = createJDerivativeEvaluator([trace._xctrl, trace._yctrl], aax.smoothing, bax.smoothing);
      };
  
      /*
       * Convert from i/j data grid coordinates to a/b values. Note in particular that this
       * is *linear* interpolation, even if the data is interpolated bicubically.
       */
      trace.i2a = function(i) {
          var i0 = Math.max(0, Math.floor(i[0]), na - 2);
          var ti = i[0] - i0;
          return (1 - ti) * a[i0] + ti * a[i0 + 1];
      };
  
      trace.j2b = function(j) {
          var j0 = Math.max(0, Math.floor(j[1]), na - 2);
          var tj = j[1] - j0;
          return (1 - tj) * b[j0] + tj * b[j0 + 1];
      };
  
      trace.ij2ab = function(ij) {
          return [trace.i2a(ij[0]), trace.j2b(ij[1])];
      };
  
      /*
       * Convert from a/b coordinates to i/j grid-numbered coordinates. This requires searching
       * through the a/b data arrays and assumes they are monotonic, which is presumed to have
       * been enforced already.
       */
      trace.a2i = function(aval) {
          var i0 = Math.max(0, Math.min(search(aval, a), na - 2));
          var a0 = a[i0];
          var a1 = a[i0 + 1];
          return Math.max(0, Math.min(na - 1, i0 + (aval - a0) / (a1 - a0)));
      };
  
      trace.b2j = function(bval) {
          var j0 = Math.max(0, Math.min(search(bval, b), nb - 2));
          var b0 = b[j0];
          var b1 = b[j0 + 1];
          return Math.max(0, Math.min(nb - 1, j0 + (bval - b0) / (b1 - b0)));
      };
  
      trace.ab2ij = function(ab) {
          return [trace.a2i(ab[0]), trace.b2j(ab[1])];
      };
  
      /*
       * Convert from i/j coordinates to x/y caretesian coordinates. This means either bilinear
       * or bicubic spline evaluation, but the hard part is already done at this point.
       */
      trace.i2c = function(i, j) {
          return trace.evalxy([], i, j);
      };
  
      trace.ab2xy = function(aval, bval, extrapolate) {
          if(!extrapolate && (aval < a[0] || aval > a[na - 1] | bval < b[0] || bval > b[nb - 1])) {
              return [false, false];
          }
          var i = trace.a2i(aval);
          var j = trace.b2j(bval);
  
          var pt = trace.evalxy([], i, j);
  
          if(extrapolate) {
              // This section uses the boundary derivatives to extrapolate linearly outside
              // the defined range. Consider a scatter line with one point inside the carpet
              // axis and one point outside. If we don't extrapolate, we can't draw the line
              // at all.
              var iex = 0;
              var jex = 0;
              var der = [];
  
              var i0, ti, j0, tj;
              if(aval < a[0]) {
                  i0 = 0;
                  ti = 0;
                  iex = (aval - a[0]) / (a[1] - a[0]);
              } else if(aval > a[na - 1]) {
                  i0 = na - 2;
                  ti = 1;
                  iex = (aval - a[na - 1]) / (a[na - 1] - a[na - 2]);
              } else {
                  i0 = Math.max(0, Math.min(na - 2, Math.floor(i)));
                  ti = i - i0;
              }
  
              if(bval < b[0]) {
                  j0 = 0;
                  tj = 0;
                  jex = (bval - b[0]) / (b[1] - b[0]);
              } else if(bval > b[nb - 1]) {
                  j0 = nb - 2;
                  tj = 1;
                  jex = (bval - b[nb - 1]) / (b[nb - 1] - b[nb - 2]);
              } else {
                  j0 = Math.max(0, Math.min(nb - 2, Math.floor(j)));
                  tj = j - j0;
              }
  
              if(iex) {
                  trace.dxydi(der, i0, j0, ti, tj);
                  pt[0] += der[0] * iex;
                  pt[1] += der[1] * iex;
              }
  
              if(jex) {
                  trace.dxydj(der, i0, j0, ti, tj);
                  pt[0] += der[0] * jex;
                  pt[1] += der[1] * jex;
              }
          }
  
          return pt;
      };
  
  
      trace.c2p = function(xy, xa, ya) {
          return [xa.c2p(xy[0]), ya.c2p(xy[1])];
      };
  
      trace.p2x = function(p, xa, ya) {
          return [xa.p2c(p[0]), ya.p2c(p[1])];
      };
  
      trace.dadi = function(i /* , u*/) {
          // Right now only a piecewise linear a or b basis is permitted since smoother interpolation
          // would cause monotonicity problems. As a retult, u is entirely disregarded in this
          // computation, though we'll specify it as a parameter for the sake of completeness and
          // future-proofing. It would be possible to use monotonic cubic interpolation, for example.
          //
          // See: https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
  
          // u = u || 0;
  
          var i0 = Math.max(0, Math.min(a.length - 2, i));
  
          // The step (demoninator) is implicitly 1 since that's the grid spacing.
          return a[i0 + 1] - a[i0];
      };
  
      trace.dbdj = function(j /* , v*/) {
          // See above caveats for dadi which also apply here
          var j0 = Math.max(0, Math.min(b.length - 2, j));
  
          // The step (demoninator) is implicitly 1 since that's the grid spacing.
          return b[j0 + 1] - b[j0];
      };
  
      // Takes: grid cell coordinate (i, j) and fractional grid cell coordinates (u, v)
      // Returns: (dx/da, dy/db)
      //
      // NB: separate grid cell + fractional grid cell coordinate format is due to the discontinuous
      // derivative, as described better in create_i_derivative_evaluator.js
      trace.dxyda = function(i0, j0, u, v) {
          var dxydi = trace.dxydi(null, i0, j0, u, v);
          var dadi = trace.dadi(i0, u);
  
          return [dxydi[0] / dadi, dxydi[1] / dadi];
      };
  
      trace.dxydb = function(i0, j0, u, v) {
          var dxydj = trace.dxydj(null, i0, j0, u, v);
          var dbdj = trace.dbdj(j0, v);
  
          return [dxydj[0] / dbdj, dxydj[1] / dbdj];
      };
  
      // Sometimes we don't care about precision and all we really want is decent rough
      // directions (as is the case with labels). In that case, we can do a very rough finite
      // difference and spare having to worry about precise grid coordinates:
      trace.dxyda_rough = function(a, b, reldiff) {
          var h = arange * (reldiff || 0.1);
          var plus = trace.ab2xy(a + h, b, true);
          var minus = trace.ab2xy(a - h, b, true);
  
          return [
              (plus[0] - minus[0]) * 0.5 / h,
              (plus[1] - minus[1]) * 0.5 / h
          ];
      };
  
      trace.dxydb_rough = function(a, b, reldiff) {
          var h = brange * (reldiff || 0.1);
          var plus = trace.ab2xy(a, b + h, true);
          var minus = trace.ab2xy(a, b - h, true);
  
          return [
              (plus[0] - minus[0]) * 0.5 / h,
              (plus[1] - minus[1]) * 0.5 / h
          ];
      };
  
      trace.dpdx = function(xa) {
          return xa._m;
      };
  
      trace.dpdy = function(ya) {
          return ya._m;
      };
  };
  
  },{"../../lib/search":769,"./compute_control_points":945,"./constants":946,"./create_i_derivative_evaluator":947,"./create_j_derivative_evaluator":948,"./create_spline_evaluator":949}],958:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  /*
   * Given a 2D array as well as a basis in either direction, this function fills in the
   * 2D array using a combination of smoothing and extrapolation. This is rather important
   * for carpet plots since it's used for layout so that we can't simply omit or blank out
   * points. We need a reasonable guess so that the interpolation puts points somewhere
   * even if we were to somehow represent that the data was missing later on.
   *
   * input:
   *  - data: 2D array of arrays
   *  - a: array such that a.length === data[0].length
   *  - b: array such that b.length === data.length
   */
  module.exports = function smoothFill2dArray(data, a, b) {
      var i, j, k;
      var ip = [];
      var jp = [];
      // var neighborCnts = [];
  
      var ni = data[0].length;
      var nj = data.length;
  
      function avgSurrounding(i, j) {
          // As a low-quality start, we can simply average surrounding points (in a not
          // non-uniform grid aware manner):
          var sum = 0.0;
          var val;
          var cnt = 0;
          if(i > 0 && (val = data[j][i - 1]) !== undefined) {
              cnt++;
              sum += val;
          }
          if(i < ni - 1 && (val = data[j][i + 1]) !== undefined) {
              cnt++;
              sum += val;
          }
          if(j > 0 && (val = data[j - 1][i]) !== undefined) {
              cnt++;
              sum += val;
          }
          if(j < nj - 1 && (val = data[j + 1][i]) !== undefined) {
              cnt++;
              sum += val;
          }
          return sum / Math.max(1, cnt);
      }
  
      // This loop iterates over all cells. Any cells that are null will be noted and those
      // are the only points we will loop over and update via laplace's equation. Points with
      // any neighbors will receive the average. If there are no neighboring points, then they
      // will be set to zero. Also as we go, track the maximum magnitude so that we can scale
      // our tolerance accordingly.
      var dmax = 0.0;
      for(i = 0; i < ni; i++) {
          for(j = 0; j < nj; j++) {
              if(data[j][i] === undefined) {
                  ip.push(i);
                  jp.push(j);
  
                  data[j][i] = avgSurrounding(i, j);
                  // neighborCnts.push(result.neighbors);
              }
              dmax = Math.max(dmax, Math.abs(data[j][i]));
          }
      }
  
      if(!ip.length) return data;
  
      // The tolerance doesn't need to be excessive. It's just for display positioning
      var dxp, dxm, dap, dam, dbp, dbm, c, d, diff, reldiff, overrelaxation;
      var tol = 1e-5;
      var resid = 0;
      var itermax = 100;
      var iter = 0;
      var n = ip.length;
      do {
          resid = 0;
          // Normally we'd loop in two dimensions, but not all points are blank and need
          // an update, so we instead loop only over the points that were tabulated above
          for(k = 0; k < n; k++) {
              i = ip[k];
              j = jp[k];
              // neighborCnt = neighborCnts[k];
  
              // Track a counter for how many contributions there are. We'll use this counter
              // to average at the end, which reduces to laplace's equation with neumann boundary
              // conditions on the first derivative (second derivative is zero so that we get
              // a nice linear extrapolation at the boundaries).
              var boundaryCnt = 0;
              var newVal = 0;
  
              var d0, d1, x0, x1, i0, j0;
              if(i === 0) {
                  // If this lies along the i = 0 boundary, extrapolate from the two points
                  // to the right of this point. Note that the finite differences take into
                  // account non-uniform grid spacing:
                  i0 = Math.min(ni - 1, 2);
                  x0 = a[i0];
                  x1 = a[1];
                  d0 = data[j][i0];
                  d1 = data[j][1];
                  newVal += d1 + (d1 - d0) * (a[0] - x1) / (x1 - x0);
                  boundaryCnt++;
              } else if(i === ni - 1) {
                  // If along the high i boundary, extrapolate from the two points to the
                  // left of this point
                  i0 = Math.max(0, ni - 3);
                  x0 = a[i0];
                  x1 = a[ni - 2];
                  d0 = data[j][i0];
                  d1 = data[j][ni - 2];
                  newVal += d1 + (d1 - d0) * (a[ni - 1] - x1) / (x1 - x0);
                  boundaryCnt++;
              }
  
              if((i === 0 || i === ni - 1) && (j > 0 && j < nj - 1)) {
                  // If along the min(i) or max(i) boundaries, also smooth vertically as long
                  // as we're not in a corner. Note that the finite differences used here
                  // are also aware of nonuniform grid spacing:
                  dxp = b[j + 1] - b[j];
                  dxm = b[j] - b[j - 1];
                  newVal += (dxm * data[j + 1][i] + dxp * data[j - 1][i]) / (dxm + dxp);
                  boundaryCnt++;
              }
  
              if(j === 0) {
                  // If along the j = 0 boundary, extrpolate this point from the two points
                  // above it
                  j0 = Math.min(nj - 1, 2);
                  x0 = b[j0];
                  x1 = b[1];
                  d0 = data[j0][i];
                  d1 = data[1][i];
                  newVal += d1 + (d1 - d0) * (b[0] - x1) / (x1 - x0);
                  boundaryCnt++;
              } else if(j === nj - 1) {
                  // Same for the max j boundary from the cells below it:
                  j0 = Math.max(0, nj - 3);
                  x0 = b[j0];
                  x1 = b[nj - 2];
                  d0 = data[j0][i];
                  d1 = data[nj - 2][i];
                  newVal += d1 + (d1 - d0) * (b[nj - 1] - x1) / (x1 - x0);
                  boundaryCnt++;
              }
  
              if((j === 0 || j === nj - 1) && (i > 0 && i < ni - 1)) {
                  // Now average points to the left/right as long as not in a corner:
                  dxp = a[i + 1] - a[i];
                  dxm = a[i] - a[i - 1];
                  newVal += (dxm * data[j][i + 1] + dxp * data[j][i - 1]) / (dxm + dxp);
                  boundaryCnt++;
              }
  
              if(!boundaryCnt) {
                  // If none of the above conditions were triggered, then this is an interior
                  // point and we can just do a laplace equation update. As above, these differences
                  // are aware of nonuniform grid spacing:
                  dap = a[i + 1] - a[i];
                  dam = a[i] - a[i - 1];
                  dbp = b[j + 1] - b[j];
                  dbm = b[j] - b[j - 1];
  
                  // These are just some useful constants for the iteration, which is perfectly
                  // straightforward but a little long to derive from f_xx + f_yy = 0.
                  c = dap * dam * (dap + dam);
                  d = dbp * dbm * (dbp + dbm);
  
                  newVal = (c * (dbm * data[j + 1][i] + dbp * data[j - 1][i]) +
                            d * (dam * data[j][i + 1] + dap * data[j][i - 1])) /
                            (d * (dam + dap) + c * (dbm + dbp));
              } else {
                  // If we did have contributions from the boundary conditions, then average
                  // the result from the various contributions:
                  newVal /= boundaryCnt;
              }
  
              // Jacobi updates are ridiculously slow to converge, so this approach uses a
              // Gauss-seidel iteration which is dramatically faster.
              diff = newVal - data[j][i];
              reldiff = diff / dmax;
              resid += reldiff * reldiff;
  
              // Gauss-Seidel-ish iteration, omega chosen based on heuristics and some
              // quick tests.
              //
              // NB: Don't overrelax the boundarie. Otherwise set an overrelaxation factor
              // which is a little low but safely optimal-ish:
              overrelaxation = boundaryCnt ? 0 : 0.85;
  
              // If there are four non-null neighbors, then we want a simple average without
              // overrelaxation. If all the surrouding points are null, then we want the full
              // overrelaxation
              //
              // Based on experiments, this actually seems to slow down convergence just a bit.
              // I'll leave it here for reference in case this needs to be revisited, but
              // it seems to work just fine without this.
              // if (overrelaxation) overrelaxation *= (4 - neighborCnt) / 4;
  
              data[j][i] += diff * (1 + overrelaxation);
          }
  
          resid = Math.sqrt(resid);
      } while(iter++ < itermax && resid > tol);
  
      Lib.log('Smoother converged to', resid, 'after', iter, 'iterations');
  
      return data;
  };
  
  },{"../../lib":750}],959:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isArray1D = _dereq_('../../lib').isArray1D;
  
  module.exports = function handleXYDefaults(traceIn, traceOut, coerce) {
      var x = coerce('x');
      var hasX = x && x.length;
      var y = coerce('y');
      var hasY = y && y.length;
      if(!hasX && !hasY) return false;
  
      traceOut._cheater = !x;
  
      if((!hasX || isArray1D(x)) && (!hasY || isArray1D(y))) {
          var len = hasX ? x.length : Infinity;
          if(hasY) len = Math.min(len, y.length);
          if(traceOut.a && traceOut.a.length) len = Math.min(len, traceOut.a.length);
          if(traceOut.b && traceOut.b.length) len = Math.min(len, traceOut.b.length);
          traceOut._length = len;
      } else traceOut._length = null;
  
      return true;
  };
  
  },{"../../lib":750}],960:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var scatterGeoAttrs = _dereq_('../scattergeo/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var defaultLine = _dereq_('../../components/color/attributes').defaultLine;
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var scatterGeoMarkerLineAttrs = scatterGeoAttrs.marker.line;
  
  module.exports = extendFlat({
      locations: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      locationmode: scatterGeoAttrs.locationmode,
      z: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      geojson: extendFlat({}, scatterGeoAttrs.geojson, {
          
      }),
      featureidkey: scatterGeoAttrs.featureidkey,
  
      text: extendFlat({}, scatterGeoAttrs.text, {
          
      }),
      hovertext: extendFlat({}, scatterGeoAttrs.hovertext, {
          
      }),
      marker: {
          line: {
              color: extendFlat({}, scatterGeoMarkerLineAttrs.color, {dflt: defaultLine}),
              width: extendFlat({}, scatterGeoMarkerLineAttrs.width, {dflt: 1}),
              editType: 'calc'
          },
          opacity: {
              valType: 'number',
              arrayOk: true,
              min: 0,
              max: 1,
              dflt: 1,
              
              editType: 'style',
              
          },
          editType: 'calc'
      },
  
      selected: {
          marker: {
              opacity: scatterGeoAttrs.selected.marker.opacity,
              editType: 'plot'
          },
          editType: 'plot'
      },
      unselected: {
          marker: {
              opacity: scatterGeoAttrs.unselected.marker.opacity,
              editType: 'plot'
          },
          editType: 'plot'
      },
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          editType: 'calc',
          flags: ['location', 'z', 'text', 'name']
      }),
      hovertemplate: hovertemplateAttrs(),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
  },
  
      colorScaleAttrs('', {
          cLetter: 'z',
          editTypeOverride: 'calc'
      })
  );
  
  },{"../../components/color/attributes":614,"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../scattergeo/attributes":1200}],961:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
  var calcSelection = _dereq_('../scatter/calc_selection');
  
  function isNonBlankString(v) {
      return v && typeof v === 'string';
  }
  
  module.exports = function calc(gd, trace) {
      var len = trace._length;
      var calcTrace = new Array(len);
  
      var isValidLoc;
  
      if(trace.geojson) {
          isValidLoc = function(v) { return isNonBlankString(v) || isNumeric(v); };
      } else {
          isValidLoc = isNonBlankString;
      }
  
      for(var i = 0; i < len; i++) {
          var calcPt = calcTrace[i] = {};
          var loc = trace.locations[i];
          var z = trace.z[i];
  
          if(isValidLoc(loc) && isNumeric(z)) {
              calcPt.loc = loc;
              calcPt.z = z;
          } else {
              calcPt.loc = null;
              calcPt.z = BADNUM;
          }
  
          calcPt.index = i;
      }
  
      arraysToCalcdata(calcTrace, trace);
      colorscaleCalc(gd, trace, {
          vals: trace.z,
          containerStr: '',
          cLetter: 'z'
      });
      calcSelection(calcTrace, trace);
  
      return calcTrace;
  };
  
  },{"../../components/colorscale/calc":623,"../../constants/numerical":725,"../scatter/arrays_to_calcdata":1157,"../scatter/calc_selection":1160,"fast-isnumeric":241}],962:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var locations = coerce('locations');
      var z = coerce('z');
  
      if(!(locations && locations.length && Lib.isArrayOrTypedArray(z) && z.length)) {
          traceOut.visible = false;
          return;
      }
  
      traceOut._length = Math.min(locations.length, z.length);
  
      var geojson = coerce('geojson');
  
      var locationmodeDflt;
      if((typeof geojson === 'string' && geojson !== '') || Lib.isPlainObject(geojson)) {
          locationmodeDflt = 'geojson-id';
      }
  
      var locationMode = coerce('locationmode', locationmodeDflt);
  
      if(locationMode === 'geojson-id') {
          coerce('featureidkey');
      }
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      var mlw = coerce('marker.line.width');
      if(mlw) coerce('marker.line.color');
      coerce('marker.opacity');
  
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"./attributes":960}],963:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt, trace, cd, pointNumber) {
      out.location = pt.location;
      out.z = pt.z;
  
      // include feature properties from input geojson
      var cdi = cd[pointNumber];
      if(cdi.fIn && cdi.fIn.properties) {
          out.properties = cdi.fIn.properties;
      }
      out.ct = cdi.ct;
  
      return out;
  };
  
  },{}],964:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var attributes = _dereq_('./attributes');
  var fillText = _dereq_('../../lib').fillText;
  
  module.exports = function hoverPoints(pointData, xval, yval) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
      var geo = pointData.subplot;
  
      var pt, i, j, isInside;
  
      for(i = 0; i < cd.length; i++) {
          pt = cd[i];
          isInside = false;
  
          if(pt._polygons) {
              for(j = 0; j < pt._polygons.length; j++) {
                  if(pt._polygons[j].contains([xval, yval])) {
                      isInside = !isInside;
                  }
                  // for polygons that cross antimeridian as xval is in [-180, 180]
                  if(pt._polygons[j].contains([xval + 360, yval])) {
                      isInside = !isInside;
                  }
              }
  
              if(isInside) break;
          }
      }
  
      if(!isInside || !pt) return;
  
      pointData.x0 = pointData.x1 = pointData.xa.c2p(pt.ct);
      pointData.y0 = pointData.y1 = pointData.ya.c2p(pt.ct);
  
      pointData.index = pt.index;
      pointData.location = pt.loc;
      pointData.z = pt.z;
      pointData.zLabel = Axes.tickText(geo.mockAxis, geo.mockAxis.c2l(pt.z), 'hover').text;
      pointData.hovertemplate = pt.hovertemplate;
  
      makeHoverInfo(pointData, trace, pt, geo.mockAxis);
  
      return [pointData];
  };
  
  function makeHoverInfo(pointData, trace, pt) {
      if(trace.hovertemplate) return;
  
      var hoverinfo = pt.hi || trace.hoverinfo;
      var loc = String(pt.loc);
  
      var parts = (hoverinfo === 'all') ?
          attributes.hoverinfo.flags :
          hoverinfo.split('+');
  
      var hasName = (parts.indexOf('name') !== -1);
      var hasLocation = (parts.indexOf('location') !== -1);
      var hasZ = (parts.indexOf('z') !== -1);
      var hasText = (parts.indexOf('text') !== -1);
      var hasIdAsNameLabel = !hasName && hasLocation;
  
      var text = [];
  
      if(hasIdAsNameLabel) {
          pointData.nameOverride = loc;
      } else {
          if(hasName) pointData.nameOverride = trace.name;
          if(hasLocation) text.push(loc);
      }
  
      if(hasZ) {
          text.push(pointData.zLabel);
      }
      if(hasText) {
          fillText(pt, trace, text);
      }
  
      pointData.extraText = text.join('<br>');
  }
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"./attributes":960}],965:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../heatmap/colorbar'),
      calc: _dereq_('./calc'),
      calcGeoJSON: _dereq_('./plot').calcGeoJSON,
      plot: _dereq_('./plot').plot,
      style: _dereq_('./style').style,
      styleOnSelect: _dereq_('./style').styleOnSelect,
      hoverPoints: _dereq_('./hover'),
      eventData: _dereq_('./event_data'),
      selectPoints: _dereq_('./select'),
  
      moduleType: 'trace',
      name: 'choropleth',
      basePlotModule: _dereq_('../../plots/geo'),
      categories: ['geo', 'noOpacity', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"../../plots/geo":831,"../heatmap/colorbar":1039,"./attributes":960,"./calc":961,"./defaults":962,"./event_data":963,"./hover":964,"./plot":966,"./select":967,"./style":968}],966:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Lib = _dereq_('../../lib');
  var geoUtils = _dereq_('../../lib/geo_location_utils');
  var getTopojsonFeatures = _dereq_('../../lib/topojson_utils').getTopojsonFeatures;
  var findExtremes = _dereq_('../../plots/cartesian/autorange').findExtremes;
  
  var style = _dereq_('./style').style;
  
  function plot(gd, geo, calcData) {
      var choroplethLayer = geo.layers.backplot.select('.choroplethlayer');
  
      Lib.makeTraceGroups(choroplethLayer, calcData, 'trace choropleth').each(function(calcTrace) {
          var sel = d3.select(this);
  
          var paths = sel.selectAll('path.choroplethlocation')
              .data(Lib.identity);
  
          paths.enter().append('path')
              .classed('choroplethlocation', true);
  
          paths.exit().remove();
  
          // call style here within topojson request callback
          style(gd, calcTrace);
      });
  }
  
  function calcGeoJSON(calcTrace, fullLayout) {
      var trace = calcTrace[0].trace;
      var geoLayout = fullLayout[trace.geo];
      var geo = geoLayout._subplot;
      var locationmode = trace.locationmode;
      var len = trace._length;
  
      var features = locationmode === 'geojson-id' ?
          geoUtils.extractTraceFeature(calcTrace) :
          getTopojsonFeatures(trace, geo.topojson);
  
      var lonArray = [];
      var latArray = [];
  
      for(var i = 0; i < len; i++) {
          var calcPt = calcTrace[i];
          var feature = locationmode === 'geojson-id' ?
              calcPt.fOut :
              geoUtils.locationToFeature(locationmode, calcPt.loc, features);
  
          if(feature) {
              calcPt.geojson = feature;
              calcPt.ct = feature.properties.ct;
              calcPt._polygons = geoUtils.feature2polygons(feature);
  
              var bboxFeature = geoUtils.computeBbox(feature);
              lonArray.push(bboxFeature[0], bboxFeature[2]);
              latArray.push(bboxFeature[1], bboxFeature[3]);
          } else {
              calcPt.geojson = null;
          }
      }
  
      if(geoLayout.fitbounds === 'geojson' && locationmode === 'geojson-id') {
          var bboxGeojson = geoUtils.computeBbox(geoUtils.getTraceGeojson(trace));
          lonArray = [bboxGeojson[0], bboxGeojson[2]];
          latArray = [bboxGeojson[1], bboxGeojson[3]];
      }
  
      var opts = {padded: true};
      trace._extremes.lon = findExtremes(geoLayout.lonaxis._ax, lonArray, opts);
      trace._extremes.lat = findExtremes(geoLayout.lataxis._ax, latArray, opts);
  }
  
  module.exports = {
      calcGeoJSON: calcGeoJSON,
      plot: plot
  };
  
  },{"../../lib":750,"../../lib/geo_location_utils":743,"../../lib/topojson_utils":777,"../../plots/cartesian/autorange":798,"./style":968,"d3":169}],967:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function selectPoints(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var xa = searchInfo.xaxis;
      var ya = searchInfo.yaxis;
      var selection = [];
  
      var i, di, ct, x, y;
  
      if(selectionTester === false) {
          for(i = 0; i < cd.length; i++) {
              cd[i].selected = 0;
          }
      } else {
          for(i = 0; i < cd.length; i++) {
              di = cd[i];
              ct = di.ct;
  
              if(!ct) continue;
  
              x = xa.c2p(ct);
              y = ya.c2p(ct);
  
              if(selectionTester.contains([x, y], null, i, searchInfo)) {
                  selection.push({
                      pointNumber: i,
                      lon: ct[0],
                      lat: ct[1]
                  });
                  di.selected = 1;
              } else {
                  di.selected = 0;
              }
          }
      }
  
      return selection;
  };
  
  },{}],968:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  var Colorscale = _dereq_('../../components/colorscale');
  
  function style(gd, calcTrace) {
      if(calcTrace) styleTrace(gd, calcTrace);
  }
  
  function styleTrace(gd, calcTrace) {
      var trace = calcTrace[0].trace;
      var s = calcTrace[0].node3;
      var locs = s.selectAll('.choroplethlocation');
      var marker = trace.marker || {};
      var markerLine = marker.line || {};
  
      var sclFunc = Colorscale.makeColorScaleFuncFromTrace(trace);
  
      locs.each(function(d) {
          d3.select(this)
              .attr('fill', sclFunc(d.z))
              .call(Color.stroke, d.mlc || markerLine.color)
              .call(Drawing.dashLine, '', d.mlw || markerLine.width || 0)
              .style('opacity', marker.opacity);
      });
  
      Drawing.selectedPointStyle(locs, trace, gd);
  }
  
  function styleOnSelect(gd, calcTrace) {
      var s = calcTrace[0].node3;
      var trace = calcTrace[0].trace;
  
      if(trace.selectedpoints) {
          Drawing.selectedPointStyle(s.selectAll('.choroplethlocation'), trace, gd);
      } else {
          styleTrace(gd, calcTrace);
      }
  }
  
  module.exports = {
      style: style,
      styleOnSelect: styleOnSelect
  };
  
  },{"../../components/color":615,"../../components/colorscale":627,"../../components/drawing":637,"d3":169}],969:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var choroplethAttrs = _dereq_('../choropleth/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var baseAttrs = _dereq_('../../plots/attributes');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = extendFlat({
      locations: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      // TODO
      // Maybe start with only one value (that we could name e.g. 'geojson-id'),
      // but eventually:
      // - we could also support for our own dist/topojson/*
      //   .. and locationmode: choroplethAttrs.locationmode,
  
      z: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      // TODO maybe we could also set a "key" to dig out values out of the
      // GeoJSON feature `properties` fields?
  
      geojson: {
          valType: 'any',
          
          editType: 'calc',
          
      },
      featureidkey: extendFlat({}, choroplethAttrs.featureidkey, {
          
      }),
  
      // TODO agree on name / behaviour
      //
      // 'below' is used currently for layout.mapbox.layers,
      // even though it's not very plotly-esque.
      //
      // Note also, that the mapbox-gl style don't all have the same layers,
      // see https://codepen.io/etpinard/pen/ydVMwM for full list
      below: {
          valType: 'string',
          
          editType: 'plot',
          
      },
  
      text: choroplethAttrs.text,
      hovertext: choroplethAttrs.hovertext,
  
      marker: {
          line: {
              color: extendFlat({}, choroplethAttrs.marker.line.color, {editType: 'plot'}),
              width: extendFlat({}, choroplethAttrs.marker.line.width, {editType: 'plot'}),
              editType: 'calc'
          },
          // TODO maybe having a dflt less than 1, together with `below:''` would be better?
          opacity: extendFlat({}, choroplethAttrs.marker.opacity, {editType: 'plot'}),
          editType: 'calc'
      },
  
      selected: {
          marker: {
              opacity: extendFlat({}, choroplethAttrs.selected.marker.opacity, {editType: 'plot'}),
              editType: 'plot'
          },
          editType: 'plot'
      },
      unselected: {
          marker: {
              opacity: extendFlat({}, choroplethAttrs.unselected.marker.opacity, {editType: 'plot'}),
              editType: 'plot'
          },
          editType: 'plot'
      },
  
      hoverinfo: choroplethAttrs.hoverinfo,
      hovertemplate: hovertemplateAttrs({}, {keys: ['properties']}),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
  },
  
      colorScaleAttrs('', {
          cLetter: 'z',
          editTypeOverride: 'calc'
      })
  );
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../choropleth/attributes":960}],970:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var Colorscale = _dereq_('../../components/colorscale');
  var Drawing = _dereq_('../../components/drawing');
  
  var makeBlank = _dereq_('../../lib/geojson_utils').makeBlank;
  var geoUtils = _dereq_('../../lib/geo_location_utils');
  
  /* N.B.
   *
   * We fetch the GeoJSON files "ourselves" (during
   * mapbox.prototype.fetchMapData) where they are stored in a global object
   * named `PlotlyGeoAssets` (same as for topojson files in `geo` subplots).
   *
   * Mapbox does allow using URLs as geojson sources, but does NOT allow filtering
   * features by feature `id` that are not numbers (more info in:
   * https://github.com/mapbox/mapbox-gl-js/issues/8088).
   */
  
  function convert(calcTrace) {
      var trace = calcTrace[0].trace;
      var isVisible = trace.visible === true && trace._length !== 0;
  
      var fill = {
          layout: {visibility: 'none'},
          paint: {}
      };
  
      var line = {
          layout: {visibility: 'none'},
          paint: {}
      };
  
      var opts = trace._opts = {
          fill: fill,
          line: line,
          geojson: makeBlank()
      };
  
      if(!isVisible) return opts;
  
      var features = geoUtils.extractTraceFeature(calcTrace);
  
      if(!features) return opts;
  
      var sclFunc = Colorscale.makeColorScaleFuncFromTrace(trace);
      var marker = trace.marker;
      var markerLine = marker.line || {};
  
      var opacityFn;
      if(Lib.isArrayOrTypedArray(marker.opacity)) {
          opacityFn = function(d) {
              var mo = d.mo;
              return isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
          };
      }
  
      var lineColorFn;
      if(Lib.isArrayOrTypedArray(markerLine.color)) {
          lineColorFn = function(d) { return d.mlc; };
      }
  
      var lineWidthFn;
      if(Lib.isArrayOrTypedArray(markerLine.width)) {
          lineWidthFn = function(d) { return d.mlw; };
      }
  
      for(var i = 0; i < calcTrace.length; i++) {
          var cdi = calcTrace[i];
          var fOut = cdi.fOut;
  
          if(fOut) {
              var props = fOut.properties;
              props.fc = sclFunc(cdi.z);
              if(opacityFn) props.mo = opacityFn(cdi);
              if(lineColorFn) props.mlc = lineColorFn(cdi);
              if(lineWidthFn) props.mlw = lineWidthFn(cdi);
              cdi.ct = props.ct;
              cdi._polygons = geoUtils.feature2polygons(fOut);
          }
      }
  
      var opacitySetting = opacityFn ?
          {type: 'identity', property: 'mo'} :
          marker.opacity;
  
      Lib.extendFlat(fill.paint, {
          'fill-color': {type: 'identity', property: 'fc'},
          'fill-opacity': opacitySetting
      });
  
      Lib.extendFlat(line.paint, {
          'line-color': lineColorFn ?
              {type: 'identity', property: 'mlc'} :
              markerLine.color,
          'line-width': lineWidthFn ?
              {type: 'identity', property: 'mlw'} :
              markerLine.width,
          'line-opacity': opacitySetting
      });
  
      fill.layout.visibility = 'visible';
      line.layout.visibility = 'visible';
  
      opts.geojson = {type: 'FeatureCollection', features: features};
  
      convertOnSelect(calcTrace);
  
      return opts;
  }
  
  function convertOnSelect(calcTrace) {
      var trace = calcTrace[0].trace;
      var opts = trace._opts;
      var opacitySetting;
  
      if(trace.selectedpoints) {
          var fns = Drawing.makeSelectedPointStyleFns(trace);
  
          for(var i = 0; i < calcTrace.length; i++) {
              var cdi = calcTrace[i];
              if(cdi.fOut) {
                  cdi.fOut.properties.mo2 = fns.selectedOpacityFn(cdi);
              }
          }
  
          opacitySetting = {type: 'identity', property: 'mo2'};
      } else {
          opacitySetting = Lib.isArrayOrTypedArray(trace.marker.opacity) ?
              {type: 'identity', property: 'mo'} :
              trace.marker.opacity;
      }
  
      Lib.extendFlat(opts.fill.paint, {'fill-opacity': opacitySetting});
      Lib.extendFlat(opts.line.paint, {'line-opacity': opacitySetting});
  
      return opts;
  }
  
  module.exports = {
      convert: convert,
      convertOnSelect: convertOnSelect
  };
  
  },{"../../components/colorscale":627,"../../components/drawing":637,"../../lib":750,"../../lib/geo_location_utils":743,"../../lib/geojson_utils":744,"fast-isnumeric":241}],971:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var locations = coerce('locations');
      var z = coerce('z');
      var geojson = coerce('geojson');
  
      if(!Lib.isArrayOrTypedArray(locations) || !locations.length ||
          !Lib.isArrayOrTypedArray(z) || !z.length ||
          !((typeof geojson === 'string' && geojson !== '') || Lib.isPlainObject(geojson))
      ) {
          traceOut.visible = false;
          return;
      }
  
      coerce('featureidkey');
  
      traceOut._length = Math.min(locations.length, z.length);
  
      coerce('below');
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      var mlw = coerce('marker.line.width');
      if(mlw) coerce('marker.line.color');
      coerce('marker.opacity');
  
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"./attributes":969}],972:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../heatmap/colorbar'),
      calc: _dereq_('../choropleth/calc'),
      plot: _dereq_('./plot'),
      hoverPoints: _dereq_('../choropleth/hover'),
      eventData: _dereq_('../choropleth/event_data'),
      selectPoints: _dereq_('../choropleth/select'),
  
      styleOnSelect: function(_, cd) {
          if(cd) {
              var trace = cd[0].trace;
              trace._glTrace.updateOnSelect(cd);
          }
      },
  
      getBelow: function(trace, subplot) {
          var mapLayers = subplot.getMapLayers();
  
          // find layer just above top-most "water" layer
          // that is not a plotly layer
          for(var i = mapLayers.length - 2; i >= 0; i--) {
              var layerId = mapLayers[i].id;
  
              if(typeof layerId === 'string' &&
                  layerId.indexOf('water') === 0
               ) {
                  for(var j = i + 1; j < mapLayers.length; j++) {
                      layerId = mapLayers[j].id;
  
                      if(typeof layerId === 'string' &&
                          layerId.indexOf('plotly-') === -1
                      ) {
                          return layerId;
                      }
                  }
              }
          }
      },
  
      moduleType: 'trace',
      name: 'choroplethmapbox',
      basePlotModule: _dereq_('../../plots/mapbox'),
      categories: ['mapbox', 'gl', 'noOpacity', 'showLegend'],
      meta: {
          hr_name: 'choropleth_mapbox',
          
      }
  };
  
  },{"../../plots/mapbox":856,"../choropleth/calc":961,"../choropleth/event_data":963,"../choropleth/hover":964,"../choropleth/select":967,"../heatmap/colorbar":1039,"./attributes":969,"./defaults":971,"./plot":973}],973:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var convert = _dereq_('./convert').convert;
  var convertOnSelect = _dereq_('./convert').convertOnSelect;
  var LAYER_PREFIX = _dereq_('../../plots/mapbox/constants').traceLayerPrefix;
  
  function ChoroplethMapbox(subplot, uid) {
      this.type = 'choroplethmapbox';
      this.subplot = subplot;
      this.uid = uid;
  
      // N.B. fill and line layers share same source
      this.sourceId = 'source-' + uid;
  
      this.layerList = [
          ['fill', LAYER_PREFIX + uid + '-fill'],
          ['line', LAYER_PREFIX + uid + '-line']
      ];
  
      // previous 'below' value,
      // need this to update it properly
      this.below = null;
  }
  
  var proto = ChoroplethMapbox.prototype;
  
  proto.update = function(calcTrace) {
      this._update(convert(calcTrace));
  };
  
  proto.updateOnSelect = function(calcTrace) {
      this._update(convertOnSelect(calcTrace));
  };
  
  proto._update = function(optsAll) {
      var subplot = this.subplot;
      var layerList = this.layerList;
      var below = subplot.belowLookup['trace-' + this.uid];
  
      subplot.map
          .getSource(this.sourceId)
          .setData(optsAll.geojson);
  
      if(below !== this.below) {
          this._removeLayers();
          this._addLayers(optsAll, below);
          this.below = below;
      }
  
      for(var i = 0; i < layerList.length; i++) {
          var item = layerList[i];
          var k = item[0];
          var id = item[1];
          var opts = optsAll[k];
  
          subplot.setOptions(id, 'setLayoutProperty', opts.layout);
  
          if(opts.layout.visibility === 'visible') {
              subplot.setOptions(id, 'setPaintProperty', opts.paint);
          }
      }
  };
  
  proto._addLayers = function(optsAll, below) {
      var subplot = this.subplot;
      var layerList = this.layerList;
      var sourceId = this.sourceId;
  
      for(var i = 0; i < layerList.length; i++) {
          var item = layerList[i];
          var k = item[0];
          var opts = optsAll[k];
  
          subplot.addLayer({
              type: k,
              id: item[1],
              source: sourceId,
              layout: opts.layout,
              paint: opts.paint
          }, below);
      }
  };
  
  proto._removeLayers = function() {
      var map = this.subplot.map;
      var layerList = this.layerList;
  
      for(var i = layerList.length - 1; i >= 0; i--) {
          map.removeLayer(layerList[i][1]);
      }
  };
  
  proto.dispose = function() {
      var map = this.subplot.map;
      this._removeLayers();
      map.removeSource(this.sourceId);
  };
  
  module.exports = function createChoroplethMapbox(subplot, calcTrace) {
      var trace = calcTrace[0].trace;
      var choroplethMapbox = new ChoroplethMapbox(subplot, trace.uid);
      var sourceId = choroplethMapbox.sourceId;
      var optsAll = convert(calcTrace);
      var below = choroplethMapbox.below = subplot.belowLookup['trace-' + trace.uid];
  
      subplot.map.addSource(sourceId, {
          type: 'geojson',
          data: optsAll.geojson
      });
  
      choroplethMapbox._addLayers(optsAll, below);
  
      // link ref for quick update during selections
      calcTrace[0].trace._glTrace = choroplethMapbox;
  
      return choroplethMapbox;
  };
  
  },{"../../plots/mapbox/constants":854,"./convert":970}],974:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var mesh3dAttrs = _dereq_('../mesh3d/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var attrs = {
      x: {
          valType: 'data_array',
          
          editType: 'calc+clearAxisTypes',
          
      },
      y: {
          valType: 'data_array',
          
          editType: 'calc+clearAxisTypes',
          
      },
      z: {
          valType: 'data_array',
          
          editType: 'calc+clearAxisTypes',
          
      },
  
      u: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      v: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      w: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      // TODO add way to specify cone positions independently of the vector field
      // provided, similar to MATLAB's coneplot Cx/Cy/Cz meshgrids,
      // see https://www.mathworks.com/help/matlab/ref/coneplot.html
      //
      // Alternatively, if our goal is only to 'fill in gaps' in the vector data,
      // we could try to extend the heatmap 'connectgaps' algorithm to 3D.
      // From AJ: this particular algorithm which amounts to a Poisson equation,
      // both for interpolation and extrapolation - is the right one to use for
      // cones too.  It makes a field with zero divergence, which is a good
      // baseline assumption for vector fields.
      //
      // cones: {
      //     // potential attributes to add:
      //     //
      //     // - meshmode: 'cartesian-product', 'pts', 'grid'
      //     //
      //     // under `meshmode: 'grid'`
      //     // - (x|y|z)grid.start
      //     // - (x|y|z)grid.end
      //     // - (x|y|z)grid.size
      //
      //     x: {
      //         valType: 'data_array',
      //         editType: 'calc',
      //         
      //     },
      //     y: {
      //         valType: 'data_array',
      //         editType: 'calc',
      //         
      //     },
      //     z: {
      //         valType: 'data_array',
      //         editType: 'calc',
      //         
      //     },
      //
      //     editType: 'calc',
      //     
      // },
  
      sizemode: {
          valType: 'enumerated',
          values: ['scaled', 'absolute'],
          
          editType: 'calc',
          dflt: 'scaled',
          
      },
      sizeref: {
          valType: 'number',
          
          editType: 'calc',
          min: 0,
          
      },
  
      anchor: {
          valType: 'enumerated',
          
          editType: 'calc',
          values: ['tip', 'tail', 'cm', 'center'],
          dflt: 'cm',
          
      },
  
      text: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          editType: 'calc',
          
      },
      hovertext: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          editType: 'calc',
          
      },
  
      hovertemplate: hovertemplateAttrs({editType: 'calc'}, {keys: ['norm']}),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
  };
  
  extendFlat(attrs, colorScaleAttrs('', {
      colorAttr: 'u/v/w norm',
      showScaleDflt: true,
      editTypeOverride: 'calc'
  }));
  
  var fromMesh3d = ['opacity', 'lightposition', 'lighting'];
  
  fromMesh3d.forEach(function(k) {
      attrs[k] = mesh3dAttrs[k];
  });
  
  attrs.hoverinfo = extendFlat({}, baseAttrs.hoverinfo, {
      editType: 'calc',
      flags: ['x', 'y', 'z', 'u', 'v', 'w', 'norm', 'text', 'name'],
      dflt: 'x+y+z+norm+text+name'
  });
  
  attrs.transforms = undefined;
  
  module.exports = attrs;
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../mesh3d/attributes":1099}],975:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  
  module.exports = function calc(gd, trace) {
      var u = trace.u;
      var v = trace.v;
      var w = trace.w;
      var len = Math.min(
          trace.x.length, trace.y.length, trace.z.length,
          u.length, v.length, w.length
      );
      var normMax = -Infinity;
      var normMin = Infinity;
  
      for(var i = 0; i < len; i++) {
          var uu = u[i];
          var vv = v[i];
          var ww = w[i];
          var norm = Math.sqrt(uu * uu + vv * vv + ww * ww);
  
          normMax = Math.max(normMax, norm);
          normMin = Math.min(normMin, norm);
      }
  
      trace._len = len;
      trace._normMax = normMax;
  
      colorscaleCalc(gd, trace, {
          vals: [normMin, normMax],
          containerStr: '',
          cLetter: 'c'
      });
  };
  
  },{"../../components/colorscale/calc":623}],976:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var conePlot = _dereq_('gl-cone3d');
  var createConeMesh = _dereq_('gl-cone3d').createConeMesh;
  
  var simpleMap = _dereq_('../../lib').simpleMap;
  var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
  var extractOpts = _dereq_('../../components/colorscale').extractOpts;
  var zip3 = _dereq_('../../plots/gl3d/zip3');
  
  function Cone(scene, uid) {
      this.scene = scene;
      this.uid = uid;
      this.mesh = null;
      this.data = null;
  }
  
  var proto = Cone.prototype;
  
  proto.handlePick = function(selection) {
      if(selection.object === this.mesh) {
          var selectIndex = selection.index = selection.data.index;
          var xx = this.data.x[selectIndex];
          var yy = this.data.y[selectIndex];
          var zz = this.data.z[selectIndex];
          var uu = this.data.u[selectIndex];
          var vv = this.data.v[selectIndex];
          var ww = this.data.w[selectIndex];
  
          selection.traceCoordinate = [
              xx, yy, zz,
              uu, vv, ww,
              Math.sqrt(uu * uu + vv * vv + ww * ww)
          ];
  
          var text = this.data.hovertext || this.data.text;
          if(Array.isArray(text) && text[selectIndex] !== undefined) {
              selection.textLabel = text[selectIndex];
          } else if(text) {
              selection.textLabel = text;
          }
  
          return true;
      }
  };
  
  var axisName2scaleIndex = {xaxis: 0, yaxis: 1, zaxis: 2};
  var anchor2coneOffset = {tip: 1, tail: 0, cm: 0.25, center: 0.5};
  var anchor2coneSpan = {tip: 1, tail: 1, cm: 0.75, center: 0.5};
  
  function convert(scene, trace) {
      var sceneLayout = scene.fullSceneLayout;
      var dataScale = scene.dataScale;
      var coneOpts = {};
  
      function toDataCoords(arr, axisName) {
          var ax = sceneLayout[axisName];
          var scale = dataScale[axisName2scaleIndex[axisName]];
          return simpleMap(arr, function(v) { return ax.d2l(v) * scale; });
      }
  
      coneOpts.vectors = zip3(
          toDataCoords(trace.u, 'xaxis'),
          toDataCoords(trace.v, 'yaxis'),
          toDataCoords(trace.w, 'zaxis'),
          trace._len
      );
  
      coneOpts.positions = zip3(
          toDataCoords(trace.x, 'xaxis'),
          toDataCoords(trace.y, 'yaxis'),
          toDataCoords(trace.z, 'zaxis'),
          trace._len
      );
  
      var cOpts = extractOpts(trace);
      coneOpts.colormap = parseColorScale(trace);
      coneOpts.vertexIntensityBounds = [cOpts.min / trace._normMax, cOpts.max / trace._normMax];
      coneOpts.coneOffset = anchor2coneOffset[trace.anchor];
  
      if(trace.sizemode === 'scaled') {
          // unitless sizeref
          coneOpts.coneSize = trace.sizeref || 0.5;
      } else {
          // sizeref here has unit of velocity
          coneOpts.coneSize = trace.sizeref && trace._normMax ?
              trace.sizeref / trace._normMax :
              0.5;
      }
  
      var meshData = conePlot(coneOpts);
  
      // pass gl-mesh3d lighting attributes
      var lp = trace.lightposition;
      meshData.lightPosition = [lp.x, lp.y, lp.z];
      meshData.ambient = trace.lighting.ambient;
      meshData.diffuse = trace.lighting.diffuse;
      meshData.specular = trace.lighting.specular;
      meshData.roughness = trace.lighting.roughness;
      meshData.fresnel = trace.lighting.fresnel;
      meshData.opacity = trace.opacity;
  
      // stash autorange pad value
      trace._pad = anchor2coneSpan[trace.anchor] * meshData.vectorScale * meshData.coneScale * trace._normMax;
  
      return meshData;
  }
  
  proto.update = function(data) {
      this.data = data;
  
      var meshData = convert(this.scene, data);
      this.mesh.update(meshData);
  };
  
  proto.dispose = function() {
      this.scene.glplot.remove(this.mesh);
      this.mesh.dispose();
  };
  
  function createConeTrace(scene, data) {
      var gl = scene.glplot.gl;
  
      var meshData = convert(scene, data);
      var mesh = createConeMesh(gl, meshData);
  
      var cone = new Cone(scene, data.uid);
      cone.mesh = mesh;
      cone.data = data;
      mesh._trace = cone;
  
      scene.glplot.add(mesh);
  
      return cone;
  }
  
  module.exports = createConeTrace;
  
  },{"../../components/colorscale":627,"../../lib":750,"../../lib/gl_format_color":746,"../../plots/gl3d/zip3":852,"gl-cone3d":259}],977:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var u = coerce('u');
      var v = coerce('v');
      var w = coerce('w');
  
      var x = coerce('x');
      var y = coerce('y');
      var z = coerce('z');
  
      if(
          !u || !u.length || !v || !v.length || !w || !w.length ||
          !x || !x.length || !y || !y.length || !z || !z.length
      ) {
          traceOut.visible = false;
          return;
      }
  
      coerce('sizeref');
      coerce('sizemode');
  
      coerce('anchor');
  
      coerce('lighting.ambient');
      coerce('lighting.diffuse');
      coerce('lighting.specular');
      coerce('lighting.roughness');
      coerce('lighting.fresnel');
      coerce('lightposition.x');
      coerce('lightposition.y');
      coerce('lightposition.z');
  
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'});
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      // disable 1D transforms (for now)
      traceOut._length = null;
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"./attributes":974}],978:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'cone',
      basePlotModule: _dereq_('../../plots/gl3d'),
      categories: ['gl3d', 'showLegend'],
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: {
          min: 'cmin',
          max: 'cmax'
      },
      calc: _dereq_('./calc'),
      plot: _dereq_('./convert'),
      eventData: function(out, pt) {
          out.norm = pt.traceCoordinate[6];
          return out;
      },
  
      meta: {
          
      }
  };
  
  },{"../../plots/gl3d":841,"./attributes":974,"./calc":975,"./convert":976,"./defaults":977}],979:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var heatmapAttrs = _dereq_('../heatmap/attributes');
  var scatterAttrs = _dereq_('../scatter/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var dash = _dereq_('../../components/drawing/attributes').dash;
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var filterOps = _dereq_('../../constants/filter_ops');
  var COMPARISON_OPS2 = filterOps.COMPARISON_OPS2;
  var INTERVAL_OPS = filterOps.INTERVAL_OPS;
  
  var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
  
  var scatterLineAttrs = scatterAttrs.line;
  
  module.exports = extendFlat({
      z: heatmapAttrs.z,
      x: heatmapAttrs.x,
      x0: heatmapAttrs.x0,
      dx: heatmapAttrs.dx,
      y: heatmapAttrs.y,
      y0: heatmapAttrs.y0,
      dy: heatmapAttrs.dy,
  
      xperiod: heatmapAttrs.xperiod,
      yperiod: heatmapAttrs.yperiod,
      xperiod0: scatterAttrs.xperiod0,
      yperiod0: scatterAttrs.yperiod0,
      xperiodalignment: heatmapAttrs.xperiodalignment,
      yperiodalignment: heatmapAttrs.yperiodalignment,
  
      text: heatmapAttrs.text,
      hovertext: heatmapAttrs.hovertext,
      transpose: heatmapAttrs.transpose,
      xtype: heatmapAttrs.xtype,
      ytype: heatmapAttrs.ytype,
      zhoverformat: heatmapAttrs.zhoverformat,
      hovertemplate: heatmapAttrs.hovertemplate,
      hoverongaps: heatmapAttrs.hoverongaps,
      connectgaps: extendFlat({}, heatmapAttrs.connectgaps, {
          
      }),
  
      fillcolor: {
          valType: 'color',
          
          editType: 'calc',
          
      },
  
      autocontour: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          impliedEdits: {
              'contours.start': undefined,
              'contours.end': undefined,
              'contours.size': undefined
          },
          
      },
      ncontours: {
          valType: 'integer',
          dflt: 15,
          min: 1,
          
          editType: 'calc',
          
      },
  
      contours: {
          type: {
              valType: 'enumerated',
              values: ['levels', 'constraint'],
              dflt: 'levels',
              
              editType: 'calc',
              
          },
          start: {
              valType: 'number',
              dflt: null,
              
              editType: 'plot',
              impliedEdits: {'^autocontour': false},
              
          },
          end: {
              valType: 'number',
              dflt: null,
              
              editType: 'plot',
              impliedEdits: {'^autocontour': false},
              
          },
          size: {
              valType: 'number',
              dflt: null,
              min: 0,
              
              editType: 'plot',
              impliedEdits: {'^autocontour': false},
              
          },
          coloring: {
              valType: 'enumerated',
              values: ['fill', 'heatmap', 'lines', 'none'],
              dflt: 'fill',
              
              editType: 'calc',
              
          },
          showlines: {
              valType: 'boolean',
              dflt: true,
              
              editType: 'plot',
              
          },
          showlabels: {
              valType: 'boolean',
              dflt: false,
              
              editType: 'plot',
              
          },
          labelfont: fontAttrs({
              editType: 'plot',
              colorEditType: 'style',
              
          }),
          labelformat: {
              valType: 'string',
              dflt: '',
              
              editType: 'plot',
              
          },
          operation: {
              valType: 'enumerated',
              values: [].concat(COMPARISON_OPS2).concat(INTERVAL_OPS),
              
              dflt: '=',
              editType: 'calc',
              
          },
          value: {
              valType: 'any',
              dflt: 0,
              
              editType: 'calc',
              
          },
          editType: 'calc',
          impliedEdits: {'autocontour': false}
      },
  
      line: {
          color: extendFlat({}, scatterLineAttrs.color, {
              editType: 'style+colorbars',
              
          }),
          width: {
              valType: 'number',
              min: 0,
              
              editType: 'style+colorbars',
              
          },
          dash: dash,
          smoothing: extendFlat({}, scatterLineAttrs.smoothing, {
              
          }),
          editType: 'plot'
      }
  },
      colorScaleAttrs('', {
          cLetter: 'z',
          autoColorDflt: false,
          editTypeOverride: 'calc'
      })
  );
  
  },{"../../components/colorscale/attributes":622,"../../components/drawing/attributes":636,"../../constants/docs":720,"../../constants/filter_ops":721,"../../lib/extend":740,"../../plots/font_attributes":827,"../heatmap/attributes":1036,"../scatter/attributes":1158}],980:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Colorscale = _dereq_('../../components/colorscale');
  
  var heatmapCalc = _dereq_('../heatmap/calc');
  var setContours = _dereq_('./set_contours');
  var endPlus = _dereq_('./end_plus');
  
  // most is the same as heatmap calc, then adjust it
  // though a few things inside heatmap calc still look for
  // contour maps, because the makeBoundArray calls are too entangled
  module.exports = function calc(gd, trace) {
      var cd = heatmapCalc(gd, trace);
  
      var zOut = cd[0].z;
      setContours(trace, zOut);
  
      var contours = trace.contours;
      var cOpts = Colorscale.extractOpts(trace);
      var cVals;
  
      if(contours.coloring === 'heatmap' && cOpts.auto && trace.autocontour === false) {
          var start = contours.start;
          var end = endPlus(contours);
          var cs = contours.size || 1;
          var nc = Math.floor((end - start) / cs) + 1;
  
          if(!isFinite(cs)) {
              cs = 1;
              nc = 1;
          }
  
          var min0 = start - cs / 2;
          var max0 = min0 + nc * cs;
          cVals = [min0, max0];
      } else {
          cVals = zOut;
      }
  
      Colorscale.calc(gd, trace, {vals: cVals, cLetter: 'z'});
  
      return cd;
  };
  
  },{"../../components/colorscale":627,"../heatmap/calc":1037,"./end_plus":990,"./set_contours":998}],981:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function(pathinfo, contours) {
      var pi0 = pathinfo[0];
      var z = pi0.z;
      var i;
  
      switch(contours.type) {
          case 'levels':
              // Why (just) use z[0][0] and z[0][1]?
              //
              // N.B. using boundaryMin instead of edgeVal2 here makes the
              //      `contour_scatter` mock fail
              var edgeVal2 = Math.min(z[0][0], z[0][1]);
  
              for(i = 0; i < pathinfo.length; i++) {
                  var pi = pathinfo[i];
                  pi.prefixBoundary = !pi.edgepaths.length &&
                      (edgeVal2 > pi.level || pi.starts.length && edgeVal2 === pi.level);
              }
              break;
          case 'constraint':
              // after convertToConstraints, pathinfo has length=0
              pi0.prefixBoundary = false;
  
              // joinAllPaths does enough already when edgepaths are present
              if(pi0.edgepaths.length) return;
  
              var na = pi0.x.length;
              var nb = pi0.y.length;
              var boundaryMax = -Infinity;
              var boundaryMin = Infinity;
  
              for(i = 0; i < nb; i++) {
                  boundaryMin = Math.min(boundaryMin, z[i][0]);
                  boundaryMin = Math.min(boundaryMin, z[i][na - 1]);
                  boundaryMax = Math.max(boundaryMax, z[i][0]);
                  boundaryMax = Math.max(boundaryMax, z[i][na - 1]);
              }
              for(i = 1; i < na - 1; i++) {
                  boundaryMin = Math.min(boundaryMin, z[0][i]);
                  boundaryMin = Math.min(boundaryMin, z[nb - 1][i]);
                  boundaryMax = Math.max(boundaryMax, z[0][i]);
                  boundaryMax = Math.max(boundaryMax, z[nb - 1][i]);
              }
  
              var contoursValue = contours.value;
              var v1, v2;
  
              switch(contours._operation) {
                  case '>':
                      if(contoursValue > boundaryMax) {
                          pi0.prefixBoundary = true;
                      }
                      break;
                  case '<':
                      if(contoursValue < boundaryMin ||
                          (pi0.starts.length && contoursValue === boundaryMin)) {
                          pi0.prefixBoundary = true;
                      }
                      break;
                  case '[]':
                      v1 = Math.min(contoursValue[0], contoursValue[1]);
                      v2 = Math.max(contoursValue[0], contoursValue[1]);
                      if(v2 < boundaryMin || v1 > boundaryMax ||
                          (pi0.starts.length && v2 === boundaryMin)) {
                          pi0.prefixBoundary = true;
                      }
                      break;
                  case '][':
                      v1 = Math.min(contoursValue[0], contoursValue[1]);
                      v2 = Math.max(contoursValue[0], contoursValue[1]);
                      if(v1 < boundaryMin && v2 > boundaryMax) {
                          pi0.prefixBoundary = true;
                      }
                      break;
              }
              break;
      }
  };
  
  },{}],982:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Colorscale = _dereq_('../../components/colorscale');
  var makeColorMap = _dereq_('./make_color_map');
  var endPlus = _dereq_('./end_plus');
  
  function calc(gd, trace, opts) {
      var contours = trace.contours;
      var line = trace.line;
      var cs = contours.size || 1;
      var coloring = contours.coloring;
      var colorMap = makeColorMap(trace, {isColorbar: true});
  
      if(coloring === 'heatmap') {
          var cOpts = Colorscale.extractOpts(trace);
          opts._fillgradient = cOpts.reversescale ?
              Colorscale.flipScale(cOpts.colorscale) :
              cOpts.colorscale;
          opts._zrange = [cOpts.min, cOpts.max];
      } else if(coloring === 'fill') {
          opts._fillcolor = colorMap;
      }
  
      opts._line = {
          color: coloring === 'lines' ? colorMap : line.color,
          width: contours.showlines !== false ? line.width : 0,
          dash: line.dash
      };
  
      opts._levels = {
          start: contours.start,
          end: endPlus(contours),
          size: cs
      };
  }
  
  module.exports = {
      min: 'zmin',
      max: 'zmax',
      calc: calc
  };
  
  },{"../../components/colorscale":627,"./end_plus":990,"./make_color_map":995}],983:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  module.exports = {
      // some constants to help with marching squares algorithm
      // where does the path start for each index?
      BOTTOMSTART: [1, 9, 13, 104, 713],
      TOPSTART: [4, 6, 7, 104, 713],
      LEFTSTART: [8, 12, 14, 208, 1114],
      RIGHTSTART: [2, 3, 11, 208, 1114],
  
      // which way [dx,dy] do we leave a given index?
      // saddles are already disambiguated
      NEWDELTA: [
          null, [-1, 0], [0, -1], [-1, 0],
          [1, 0], null, [0, -1], [-1, 0],
          [0, 1], [0, 1], null, [0, 1],
          [1, 0], [1, 0], [0, -1]
      ],
  
      // for each saddle, the first index here is used
      // for dx||dy<0, the second for dx||dy>0
      CHOOSESADDLE: {
          104: [4, 1],
          208: [2, 8],
          713: [7, 13],
          1114: [11, 14]
      },
  
      // after one index has been used for a saddle, which do we
      // substitute to be used up later?
      SADDLEREMAINDER: {1: 4, 2: 8, 4: 1, 7: 13, 8: 2, 11: 14, 13: 7, 14: 11},
  
      // length of a contour, as a multiple of the plot area diagonal, per label
      LABELDISTANCE: 2,
  
      // number of contour levels after which we start increasing the number of
      // labels we draw. Many contours means they will generally be close
      // together, so it will be harder to follow a long way to find a label
      LABELINCREASE: 10,
  
      // minimum length of a contour line, as a multiple of the label length,
      // at which we draw *any* labels
      LABELMIN: 3,
  
      // max number of labels to draw on a single contour path, no matter how long
      LABELMAX: 10,
  
      // constants for the label position cost function
      LABELOPTIMIZER: {
          // weight given to edge proximity
          EDGECOST: 1,
          // weight given to the angle off horizontal
          ANGLECOST: 1,
          // weight given to distance from already-placed labels
          NEIGHBORCOST: 5,
          // cost multiplier for labels on the same level
          SAMELEVELFACTOR: 10,
          // minimum distance (as a multiple of the label length)
          // for labels on the same level
          SAMELEVELDISTANCE: 5,
          // maximum cost before we won't even place the label
          MAXCOST: 100,
          // number of evenly spaced points to look at in the first
          // iteration of the search
          INITIALSEARCHPOINTS: 10,
          // number of binary search iterations after the initial wide search
          ITERATIONS: 5
      }
  };
  
  },{}],984:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  var isNumeric = _dereq_('fast-isnumeric');
  
  var handleLabelDefaults = _dereq_('./label_defaults');
  
  var Color = _dereq_('../../components/color');
  var addOpacity = Color.addOpacity;
  var opacity = Color.opacity;
  
  var filterOps = _dereq_('../../constants/filter_ops');
  var CONSTRAINT_REDUCTION = filterOps.CONSTRAINT_REDUCTION;
  var COMPARISON_OPS2 = filterOps.COMPARISON_OPS2;
  
  module.exports = function handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor, opts) {
      var contours = traceOut.contours;
      var showLines, lineColor, fillColor;
  
      var operation = coerce('contours.operation');
      contours._operation = CONSTRAINT_REDUCTION[operation];
  
      handleConstraintValueDefaults(coerce, contours);
  
      if(operation === '=') {
          showLines = contours.showlines = true;
      } else {
          showLines = coerce('contours.showlines');
          fillColor = coerce('fillcolor', addOpacity(
              (traceIn.line || {}).color || defaultColor, 0.5
          ));
      }
  
      if(showLines) {
          var lineDfltColor = fillColor && opacity(fillColor) ?
              addOpacity(traceOut.fillcolor, 1) :
              defaultColor;
          lineColor = coerce('line.color', lineDfltColor);
          coerce('line.width', 2);
          coerce('line.dash');
      }
  
      coerce('line.smoothing');
  
      handleLabelDefaults(coerce, layout, lineColor, opts);
  };
  
  function handleConstraintValueDefaults(coerce, contours) {
      var zvalue;
  
      if(COMPARISON_OPS2.indexOf(contours.operation) === -1) {
          // Requires an array of two numbers:
          coerce('contours.value', [0, 1]);
  
          if(!Array.isArray(contours.value)) {
              if(isNumeric(contours.value)) {
                  zvalue = parseFloat(contours.value);
                  contours.value = [zvalue, zvalue + 1];
              }
          } else if(contours.value.length > 2) {
              contours.value = contours.value.slice(2);
          } else if(contours.length === 0) {
              contours.value = [0, 1];
          } else if(contours.length < 2) {
              zvalue = parseFloat(contours.value[0]);
              contours.value = [zvalue, zvalue + 1];
          } else {
              contours.value = [
                  parseFloat(contours.value[0]),
                  parseFloat(contours.value[1])
              ];
          }
      } else {
          // Requires a single scalar:
          coerce('contours.value', 0);
  
          if(!isNumeric(contours.value)) {
              if(Array.isArray(contours.value)) {
                  contours.value = parseFloat(contours.value[0]);
              } else {
                  contours.value = 0;
              }
          }
      }
  }
  
  },{"../../components/color":615,"../../constants/filter_ops":721,"./label_defaults":994,"fast-isnumeric":241}],985:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var filterOps = _dereq_('../../constants/filter_ops');
  var isNumeric = _dereq_('fast-isnumeric');
  
  // This syntax conforms to the existing filter transform syntax, but we don't care
  // about open vs. closed intervals for simply drawing contours constraints:
  module.exports = {
      '[]': makeRangeSettings('[]'),
      '][': makeRangeSettings(']['),
      '>': makeInequalitySettings('>'),
      '<': makeInequalitySettings('<'),
      '=': makeInequalitySettings('=')
  };
  
  // This does not in any way shape or form support calendars. It's adapted from
  // transforms/filter.js.
  function coerceValue(operation, value) {
      var hasArrayValue = Array.isArray(value);
  
      var coercedValue;
  
      function coerce(value) {
          return isNumeric(value) ? (+value) : null;
      }
  
      if(filterOps.COMPARISON_OPS2.indexOf(operation) !== -1) {
          coercedValue = hasArrayValue ? coerce(value[0]) : coerce(value);
      } else if(filterOps.INTERVAL_OPS.indexOf(operation) !== -1) {
          coercedValue = hasArrayValue ?
              [coerce(value[0]), coerce(value[1])] :
              [coerce(value), coerce(value)];
      } else if(filterOps.SET_OPS.indexOf(operation) !== -1) {
          coercedValue = hasArrayValue ? value.map(coerce) : [coerce(value)];
      }
  
      return coercedValue;
  }
  
  // Returns a parabola scaled so that the min/max is either +/- 1 and zero at the two values
  // provided. The data is mapped by this function when constructing intervals so that it's
  // very easy to construct contours as normal.
  function makeRangeSettings(operation) {
      return function(value) {
          value = coerceValue(operation, value);
  
          // Ensure proper ordering:
          var min = Math.min(value[0], value[1]);
          var max = Math.max(value[0], value[1]);
  
          return {
              start: min,
              end: max,
              size: max - min
          };
      };
  }
  
  function makeInequalitySettings(operation) {
      return function(value) {
          value = coerceValue(operation, value);
  
          return {
              start: value,
              end: Infinity,
              size: Infinity
          };
      };
  }
  
  },{"../../constants/filter_ops":721,"fast-isnumeric":241}],986:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function handleContourDefaults(traceIn, traceOut, coerce, coerce2) {
      var contourStart = coerce2('contours.start');
      var contourEnd = coerce2('contours.end');
      var missingEnd = (contourStart === false) || (contourEnd === false);
  
      // normally we only need size if autocontour is off. But contour.calc
      // pushes its calculated contour size back to the input trace, so for
      // things like restyle that can call supplyDefaults without calc
      // after the initial draw, we can just reuse the previous calculation
      var contourSize = coerce('contours.size');
      var autoContour;
  
      if(missingEnd) autoContour = traceOut.autocontour = true;
      else autoContour = coerce('autocontour', false);
  
      if(autoContour || !contourSize) coerce('ncontours');
  };
  
  },{}],987:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  // The contour extraction is great, except it totally fails for constraints because we
  // need weird range loops and flipped contours instead of the usual format. This function
  // does some weird manipulation of the extracted pathinfo data such that it magically
  // draws contours correctly *as* constraints.
  //
  // ** I do not know which "weird range loops" the comment above is referring to.
  module.exports = function(pathinfo, operation) {
      var i, pi0, pi1;
  
      var op0 = function(arr) { return arr.reverse(); };
      var op1 = function(arr) { return arr; };
  
      switch(operation) {
          case '=':
          case '<':
              return pathinfo;
          case '>':
              if(pathinfo.length !== 1) {
                  Lib.warn('Contour data invalid for the specified inequality operation.');
              }
  
              // In this case there should be exactly one contour levels in pathinfo.
              // We flip all of the data. This will draw the contour as closed.
              pi0 = pathinfo[0];
  
              for(i = 0; i < pi0.edgepaths.length; i++) {
                  pi0.edgepaths[i] = op0(pi0.edgepaths[i]);
              }
              for(i = 0; i < pi0.paths.length; i++) {
                  pi0.paths[i] = op0(pi0.paths[i]);
              }
              for(i = 0; i < pi0.starts.length; i++) {
                  pi0.starts[i] = op0(pi0.starts[i]);
              }
  
              return pathinfo;
          case '][':
              var tmp = op0;
              op0 = op1;
              op1 = tmp;
              // It's a nice rule, except this definitely *is* what's intended here.
              /* eslint-disable: no-fallthrough */
          case '[]':
              /* eslint-enable: no-fallthrough */
              if(pathinfo.length !== 2) {
                  Lib.warn('Contour data invalid for the specified inequality range operation.');
              }
  
              // In this case there should be exactly two contour levels in pathinfo.
              // - We concatenate the info into one pathinfo.
              // - We must also flip all of the data in the `[]` case.
              // This will draw the contours as closed.
              pi0 = copyPathinfo(pathinfo[0]);
              pi1 = copyPathinfo(pathinfo[1]);
  
              for(i = 0; i < pi0.edgepaths.length; i++) {
                  pi0.edgepaths[i] = op0(pi0.edgepaths[i]);
              }
              for(i = 0; i < pi0.paths.length; i++) {
                  pi0.paths[i] = op0(pi0.paths[i]);
              }
              for(i = 0; i < pi0.starts.length; i++) {
                  pi0.starts[i] = op0(pi0.starts[i]);
              }
  
              while(pi1.edgepaths.length) {
                  pi0.edgepaths.push(op1(pi1.edgepaths.shift()));
              }
              while(pi1.paths.length) {
                  pi0.paths.push(op1(pi1.paths.shift()));
              }
              while(pi1.starts.length) {
                  pi0.starts.push(op1(pi1.starts.shift()));
              }
  
              return [pi0];
      }
  };
  
  function copyPathinfo(pi) {
      return Lib.extendFlat({}, pi, {
          edgepaths: Lib.extendDeep([], pi.edgepaths),
          paths: Lib.extendDeep([], pi.paths),
          starts: Lib.extendDeep([], pi.starts)
      });
  }
  
  },{"../../lib":750}],988:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleXYZDefaults = _dereq_('../heatmap/xyz_defaults');
  var handlePeriodDefaults = _dereq_('../scatter/period_defaults');
  var handleConstraintDefaults = _dereq_('./constraint_defaults');
  var handleContoursDefaults = _dereq_('./contours_defaults');
  var handleStyleDefaults = _dereq_('./style_defaults');
  var attributes = _dereq_('./attributes');
  
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      function coerce2(attr) {
          return Lib.coerce2(traceIn, traceOut, attributes, attr);
      }
  
      var len = handleXYZDefaults(traceIn, traceOut, coerce, layout);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
      coerce('hoverongaps');
  
      var isConstraint = (coerce('contours.type') === 'constraint');
      coerce('connectgaps', Lib.isArray1D(traceOut.z));
  
      if(isConstraint) {
          handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor);
      } else {
          handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
          handleStyleDefaults(traceIn, traceOut, coerce, layout);
      }
  };
  
  },{"../../lib":750,"../heatmap/xyz_defaults":1050,"../scatter/period_defaults":1178,"./attributes":979,"./constraint_defaults":984,"./contours_defaults":986,"./style_defaults":1000}],989:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var constraintMapping = _dereq_('./constraint_mapping');
  var endPlus = _dereq_('./end_plus');
  
  module.exports = function emptyPathinfo(contours, plotinfo, cd0) {
      var contoursFinal = (contours.type === 'constraint') ?
          constraintMapping[contours._operation](contours.value) :
          contours;
  
      var cs = contoursFinal.size;
      var pathinfo = [];
      var end = endPlus(contoursFinal);
  
      var carpet = cd0.trace._carpetTrace;
  
      var basePathinfo = carpet ? {
          // store axes so we can convert to px
          xaxis: carpet.aaxis,
          yaxis: carpet.baxis,
          // full data arrays to use for interpolation
          x: cd0.a,
          y: cd0.b
      } : {
          xaxis: plotinfo.xaxis,
          yaxis: plotinfo.yaxis,
          x: cd0.x,
          y: cd0.y
      };
  
      for(var ci = contoursFinal.start; ci < end; ci += cs) {
          pathinfo.push(Lib.extendFlat({
              level: ci,
              // all the cells with nontrivial marching index
              crossings: {},
              // starting points on the edges of the lattice for each contour
              starts: [],
              // all unclosed paths (may have less items than starts,
              // if a path is closed by rounding)
              edgepaths: [],
              // all closed paths
              paths: [],
              z: cd0.z,
              smoothing: cd0.trace.line.smoothing
          }, basePathinfo));
  
          if(pathinfo.length > 1000) {
              Lib.warn('Too many contours, clipping at 1000', contours);
              break;
          }
      }
      return pathinfo;
  };
  
  },{"../../lib":750,"./constraint_mapping":985,"./end_plus":990}],990:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  /*
   * tiny helper to move the end of the contours a little to prevent
   * losing the last contour to rounding errors
   */
  module.exports = function endPlus(contours) {
      return contours.end + contours.size / 1e6;
  };
  
  },{}],991:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var constants = _dereq_('./constants');
  
  module.exports = function findAllPaths(pathinfo, xtol, ytol) {
      var cnt,
          startLoc,
          i,
          pi,
          j;
  
      // Default just passes these values through as they were before:
      xtol = xtol || 0.01;
      ytol = ytol || 0.01;
  
      for(i = 0; i < pathinfo.length; i++) {
          pi = pathinfo[i];
  
          for(j = 0; j < pi.starts.length; j++) {
              startLoc = pi.starts[j];
              makePath(pi, startLoc, 'edge', xtol, ytol);
          }
  
          cnt = 0;
          while(Object.keys(pi.crossings).length && cnt < 10000) {
              cnt++;
              startLoc = Object.keys(pi.crossings)[0].split(',').map(Number);
              makePath(pi, startLoc, undefined, xtol, ytol);
          }
          if(cnt === 10000) Lib.log('Infinite loop in contour?');
      }
  };
  
  function equalPts(pt1, pt2, xtol, ytol) {
      return Math.abs(pt1[0] - pt2[0]) < xtol &&
             Math.abs(pt1[1] - pt2[1]) < ytol;
  }
  
  // distance in index units - uses the 3rd and 4th items in points
  function ptDist(pt1, pt2) {
      var dx = pt1[2] - pt2[2];
      var dy = pt1[3] - pt2[3];
      return Math.sqrt(dx * dx + dy * dy);
  }
  
  function makePath(pi, loc, edgeflag, xtol, ytol) {
      var locStr = loc.join(',');
      var mi = pi.crossings[locStr];
      var marchStep = getStartStep(mi, edgeflag, loc);
      // start by going backward a half step and finding the crossing point
      var pts = [getInterpPx(pi, loc, [-marchStep[0], -marchStep[1]])];
      var m = pi.z.length;
      var n = pi.z[0].length;
      var startLoc = loc.slice();
      var startStep = marchStep.slice();
      var cnt;
  
      // now follow the path
      for(cnt = 0; cnt < 10000; cnt++) { // just to avoid infinite loops
          if(mi > 20) {
              mi = constants.CHOOSESADDLE[mi][(marchStep[0] || marchStep[1]) < 0 ? 0 : 1];
              pi.crossings[locStr] = constants.SADDLEREMAINDER[mi];
          } else {
              delete pi.crossings[locStr];
          }
  
          marchStep = constants.NEWDELTA[mi];
          if(!marchStep) {
              Lib.log('Found bad marching index:', mi, loc, pi.level);
              break;
          }
  
          // find the crossing a half step forward, and then take the full step
          pts.push(getInterpPx(pi, loc, marchStep));
          loc[0] += marchStep[0];
          loc[1] += marchStep[1];
          locStr = loc.join(',');
  
          // don't include the same point multiple times
          if(equalPts(pts[pts.length - 1], pts[pts.length - 2], xtol, ytol)) pts.pop();
  
          var atEdge = (marchStep[0] && (loc[0] < 0 || loc[0] > n - 2)) ||
                  (marchStep[1] && (loc[1] < 0 || loc[1] > m - 2));
  
          var closedLoop = loc[0] === startLoc[0] && loc[1] === startLoc[1] &&
                  marchStep[0] === startStep[0] && marchStep[1] === startStep[1];
  
          // have we completed a loop, or reached an edge?
          if((closedLoop) || (edgeflag && atEdge)) break;
  
          mi = pi.crossings[locStr];
      }
  
      if(cnt === 10000) {
          Lib.log('Infinite loop in contour?');
      }
      var closedpath = equalPts(pts[0], pts[pts.length - 1], xtol, ytol);
      var totaldist = 0;
      var distThresholdFactor = 0.2 * pi.smoothing;
      var alldists = [];
      var cropstart = 0;
      var distgroup, cnt2, cnt3, newpt, ptcnt, ptavg, thisdist,
          i, j, edgepathi, edgepathj;
  
      /*
       * Check for points that are too close together (<1/5 the average dist
       * *in grid index units* (important for log axes and nonuniform grids),
       * less if less smoothed) and just take the center (or avg of center 2).
       * This cuts down on funny behavior when a point is very close to a
       * contour level.
       */
      for(cnt = 1; cnt < pts.length; cnt++) {
          thisdist = ptDist(pts[cnt], pts[cnt - 1]);
          totaldist += thisdist;
          alldists.push(thisdist);
      }
  
      var distThreshold = totaldist / alldists.length * distThresholdFactor;
  
      function getpt(i) { return pts[i % pts.length]; }
  
      for(cnt = pts.length - 2; cnt >= cropstart; cnt--) {
          distgroup = alldists[cnt];
          if(distgroup < distThreshold) {
              cnt3 = 0;
              for(cnt2 = cnt - 1; cnt2 >= cropstart; cnt2--) {
                  if(distgroup + alldists[cnt2] < distThreshold) {
                      distgroup += alldists[cnt2];
                  } else break;
              }
  
              // closed path with close points wrapping around the boundary?
              if(closedpath && cnt === pts.length - 2) {
                  for(cnt3 = 0; cnt3 < cnt2; cnt3++) {
                      if(distgroup + alldists[cnt3] < distThreshold) {
                          distgroup += alldists[cnt3];
                      } else break;
                  }
              }
              ptcnt = cnt - cnt2 + cnt3 + 1;
              ptavg = Math.floor((cnt + cnt2 + cnt3 + 2) / 2);
  
              // either endpoint included: keep the endpoint
              if(!closedpath && cnt === pts.length - 2) newpt = pts[pts.length - 1];
              else if(!closedpath && cnt2 === -1) newpt = pts[0];
  
              // odd # of points - just take the central one
              else if(ptcnt % 2) newpt = getpt(ptavg);
  
              // even # of pts - average central two
              else {
                  newpt = [(getpt(ptavg)[0] + getpt(ptavg + 1)[0]) / 2,
                      (getpt(ptavg)[1] + getpt(ptavg + 1)[1]) / 2];
              }
  
              pts.splice(cnt2 + 1, cnt - cnt2 + 1, newpt);
              cnt = cnt2 + 1;
              if(cnt3) cropstart = cnt3;
              if(closedpath) {
                  if(cnt === pts.length - 2) pts[cnt3] = pts[pts.length - 1];
                  else if(cnt === 0) pts[pts.length - 1] = pts[0];
              }
          }
      }
      pts.splice(0, cropstart);
  
      // done with the index parts - remove them so path generation works right
      // because it depends on only having [xpx, ypx]
      for(cnt = 0; cnt < pts.length; cnt++) pts[cnt].length = 2;
  
      // don't return single-point paths (ie all points were the same
      // so they got deleted?)
      if(pts.length < 2) return;
      else if(closedpath) {
          pts.pop();
          pi.paths.push(pts);
      } else {
          if(!edgeflag) {
              Lib.log('Unclosed interior contour?',
                  pi.level, startLoc.join(','), pts.join('L'));
          }
  
          // edge path - does it start where an existing edge path ends, or vice versa?
          var merged = false;
          for(i = 0; i < pi.edgepaths.length; i++) {
              edgepathi = pi.edgepaths[i];
              if(!merged && equalPts(edgepathi[0], pts[pts.length - 1], xtol, ytol)) {
                  pts.pop();
                  merged = true;
  
                  // now does it ALSO meet the end of another (or the same) path?
                  var doublemerged = false;
                  for(j = 0; j < pi.edgepaths.length; j++) {
                      edgepathj = pi.edgepaths[j];
                      if(equalPts(edgepathj[edgepathj.length - 1], pts[0], xtol, ytol)) {
                          doublemerged = true;
                          pts.shift();
                          pi.edgepaths.splice(i, 1);
                          if(j === i) {
                              // the path is now closed
                              pi.paths.push(pts.concat(edgepathj));
                          } else {
                              if(j > i) j--;
                              pi.edgepaths[j] = edgepathj.concat(pts, edgepathi);
                          }
                          break;
                      }
                  }
                  if(!doublemerged) {
                      pi.edgepaths[i] = pts.concat(edgepathi);
                  }
              }
          }
          for(i = 0; i < pi.edgepaths.length; i++) {
              if(merged) break;
              edgepathi = pi.edgepaths[i];
              if(equalPts(edgepathi[edgepathi.length - 1], pts[0], xtol, ytol)) {
                  pts.shift();
                  pi.edgepaths[i] = edgepathi.concat(pts);
                  merged = true;
              }
          }
  
          if(!merged) pi.edgepaths.push(pts);
      }
  }
  
  // special function to get the marching step of the
  // first point in the path (leading to loc)
  function getStartStep(mi, edgeflag, loc) {
      var dx = 0;
      var dy = 0;
      if(mi > 20 && edgeflag) {
          // these saddles start at +/- x
          if(mi === 208 || mi === 1114) {
              // if we're starting at the left side, we must be going right
              dx = loc[0] === 0 ? 1 : -1;
          } else {
              // if we're starting at the bottom, we must be going up
              dy = loc[1] === 0 ? 1 : -1;
          }
      } else if(constants.BOTTOMSTART.indexOf(mi) !== -1) dy = 1;
      else if(constants.LEFTSTART.indexOf(mi) !== -1) dx = 1;
      else if(constants.TOPSTART.indexOf(mi) !== -1) dy = -1;
      else dx = -1;
      return [dx, dy];
  }
  
  /*
   * Find the pixel coordinates of a particular crossing
   *
   * @param {object} pi: the pathinfo object at this level
   * @param {array} loc: the grid index [x, y] of the crossing
   * @param {array} step: the direction [dx, dy] we're moving on the grid
   *
   * @return {array} [xpx, ypx, xi, yi]: the first two are the pixel location,
   *   the next two are the interpolated grid indices, which we use for
   *   distance calculations to delete points that are too close together.
   *   This is important when the grid is nonuniform (and most dramatically when
   *   we're on log axes and include invalid (0 or negative) values.
   *   It's crucial to delete these extra two before turning an array of these
   *   points into a path, because those routines require length-2 points.
   */
  function getInterpPx(pi, loc, step) {
      var locx = loc[0] + Math.max(step[0], 0);
      var locy = loc[1] + Math.max(step[1], 0);
      var zxy = pi.z[locy][locx];
      var xa = pi.xaxis;
      var ya = pi.yaxis;
  
      if(step[1]) {
          var dx = (pi.level - zxy) / (pi.z[locy][locx + 1] - zxy);
  
          return [xa.c2p((1 - dx) * pi.x[locx] + dx * pi.x[locx + 1], true),
              ya.c2p(pi.y[locy], true),
              locx + dx, locy];
      } else {
          var dy = (pi.level - zxy) / (pi.z[locy + 1][locx] - zxy);
          return [xa.c2p(pi.x[locx], true),
              ya.c2p((1 - dy) * pi.y[locy] + dy * pi.y[locy + 1], true),
              locx, locy + dy];
      }
  }
  
  },{"../../lib":750,"./constants":983}],992:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Color = _dereq_('../../components/color');
  
  var heatmapHoverPoints = _dereq_('../heatmap/hover');
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode, hoverLayer) {
      var hoverData = heatmapHoverPoints(pointData, xval, yval, hovermode, hoverLayer, true);
  
      if(hoverData) {
          hoverData.forEach(function(hoverPt) {
              var trace = hoverPt.trace;
              if(trace.contours.type === 'constraint') {
                  if(trace.fillcolor && Color.opacity(trace.fillcolor)) {
                      hoverPt.color = Color.addOpacity(trace.fillcolor, 1);
                  } else if(trace.contours.showlines && Color.opacity(trace.line.color)) {
                      hoverPt.color = Color.addOpacity(trace.line.color, 1);
                  }
              }
          });
      }
  
      return hoverData;
  };
  
  },{"../../components/color":615,"../heatmap/hover":1043}],993:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot').plot,
      style: _dereq_('./style'),
      colorbar: _dereq_('./colorbar'),
      hoverPoints: _dereq_('./hover'),
  
      moduleType: 'trace',
      name: 'contour',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', '2dMap', 'contour', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"./attributes":979,"./calc":980,"./colorbar":982,"./defaults":988,"./hover":992,"./plot":997,"./style":999}],994:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  module.exports = function handleLabelDefaults(coerce, layout, lineColor, opts) {
      if(!opts) opts = {};
      var showLabels = coerce('contours.showlabels');
      if(showLabels) {
          var globalFont = layout.font;
          Lib.coerceFont(coerce, 'contours.labelfont', {
              family: globalFont.family,
              size: globalFont.size,
              color: lineColor
          });
          coerce('contours.labelformat');
      }
  
      if(opts.hasHover !== false) coerce('zhoverformat');
  };
  
  },{"../../lib":750}],995:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Colorscale = _dereq_('../../components/colorscale');
  var endPlus = _dereq_('./end_plus');
  
  module.exports = function makeColorMap(trace) {
      var contours = trace.contours;
      var start = contours.start;
      var end = endPlus(contours);
      var cs = contours.size || 1;
      var nc = Math.floor((end - start) / cs) + 1;
      var extra = contours.coloring === 'lines' ? 0 : 1;
      var cOpts = Colorscale.extractOpts(trace);
  
      if(!isFinite(cs)) {
          cs = 1;
          nc = 1;
      }
  
      var scl = cOpts.reversescale ?
          Colorscale.flipScale(cOpts.colorscale) :
          cOpts.colorscale;
  
      var len = scl.length;
      var domain = new Array(len);
      var range = new Array(len);
  
      var si, i;
  
      if(contours.coloring === 'heatmap') {
          var zmin0 = cOpts.min;
          var zmax0 = cOpts.max;
  
          for(i = 0; i < len; i++) {
              si = scl[i];
              domain[i] = si[0] * (zmax0 - zmin0) + zmin0;
              range[i] = si[1];
          }
  
          // do the contours extend beyond the colorscale?
          // if so, extend the colorscale with constants
          var zRange = d3.extent([
              zmin0,
              zmax0,
              contours.start,
              contours.start + cs * (nc - 1)
          ]);
          var zmin = zRange[zmin0 < zmax0 ? 0 : 1];
          var zmax = zRange[zmin0 < zmax0 ? 1 : 0];
  
          if(zmin !== zmin0) {
              domain.splice(0, 0, zmin);
              range.splice(0, 0, range[0]);
          }
  
          if(zmax !== zmax0) {
              domain.push(zmax);
              range.push(range[range.length - 1]);
          }
      } else {
          for(i = 0; i < len; i++) {
              si = scl[i];
              domain[i] = (si[0] * (nc + extra - 1) - (extra / 2)) * cs + start;
              range[i] = si[1];
          }
      }
  
      return Colorscale.makeColorScaleFunc(
          {domain: domain, range: range},
          {noNumericCheck: true}
      );
  };
  
  },{"../../components/colorscale":627,"./end_plus":990,"d3":169}],996:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var constants = _dereq_('./constants');
  
  // Calculate all the marching indices, for ALL levels at once.
  // since we want to be exhaustive we'll check for contour crossings
  // at every intersection, rather than just following a path
  // TODO: shorten the inner loop to only the relevant levels
  module.exports = function makeCrossings(pathinfo) {
      var z = pathinfo[0].z;
      var m = z.length;
      var n = z[0].length; // we already made sure z isn't ragged in interp2d
      var twoWide = m === 2 || n === 2;
      var xi;
      var yi;
      var startIndices;
      var ystartIndices;
      var label;
      var corners;
      var mi;
      var pi;
      var i;
  
      for(yi = 0; yi < m - 1; yi++) {
          ystartIndices = [];
          if(yi === 0) ystartIndices = ystartIndices.concat(constants.BOTTOMSTART);
          if(yi === m - 2) ystartIndices = ystartIndices.concat(constants.TOPSTART);
  
          for(xi = 0; xi < n - 1; xi++) {
              startIndices = ystartIndices.slice();
              if(xi === 0) startIndices = startIndices.concat(constants.LEFTSTART);
              if(xi === n - 2) startIndices = startIndices.concat(constants.RIGHTSTART);
  
              label = xi + ',' + yi;
              corners = [[z[yi][xi], z[yi][xi + 1]],
                         [z[yi + 1][xi], z[yi + 1][xi + 1]]];
              for(i = 0; i < pathinfo.length; i++) {
                  pi = pathinfo[i];
                  mi = getMarchingIndex(pi.level, corners);
                  if(!mi) continue;
  
                  pi.crossings[label] = mi;
                  if(startIndices.indexOf(mi) !== -1) {
                      pi.starts.push([xi, yi]);
                      if(twoWide && startIndices.indexOf(mi,
                              startIndices.indexOf(mi) + 1) !== -1) {
                          // the same square has starts from opposite sides
                          // it's not possible to have starts on opposite edges
                          // of a corner, only a start and an end...
                          // but if the array is only two points wide (either way)
                          // you can have starts on opposite sides.
                          pi.starts.push([xi, yi]);
                      }
                  }
              }
          }
      }
  };
  
  // modified marching squares algorithm,
  // so we disambiguate the saddle points from the start
  // and we ignore the cases with no crossings
  // the index I'm using is based on:
  // http://en.wikipedia.org/wiki/Marching_squares
  // except that the saddles bifurcate and I represent them
  // as the decimal combination of the two appropriate
  // non-saddle indices
  function getMarchingIndex(val, corners) {
      var mi = (corners[0][0] > val ? 0 : 1) +
               (corners[0][1] > val ? 0 : 2) +
               (corners[1][1] > val ? 0 : 4) +
               (corners[1][0] > val ? 0 : 8);
      if(mi === 5 || mi === 10) {
          var avg = (corners[0][0] + corners[0][1] +
                     corners[1][0] + corners[1][1]) / 4;
          // two peaks with a big valley
          if(val > avg) return (mi === 5) ? 713 : 1114;
          // two valleys with a big ridge
          return (mi === 5) ? 104 : 208;
      }
      return (mi === 15) ? 0 : mi;
  }
  
  },{"./constants":983}],997:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  var Colorscale = _dereq_('../../components/colorscale');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var setConvert = _dereq_('../../plots/cartesian/set_convert');
  
  var heatmapPlot = _dereq_('../heatmap/plot');
  var makeCrossings = _dereq_('./make_crossings');
  var findAllPaths = _dereq_('./find_all_paths');
  var emptyPathinfo = _dereq_('./empty_pathinfo');
  var convertToConstraints = _dereq_('./convert_to_constraints');
  var closeBoundaries = _dereq_('./close_boundaries');
  var constants = _dereq_('./constants');
  var costConstants = constants.LABELOPTIMIZER;
  
  exports.plot = function plot(gd, plotinfo, cdcontours, contourLayer) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      Lib.makeTraceGroups(contourLayer, cdcontours, 'contour').each(function(cd) {
          var plotGroup = d3.select(this);
          var cd0 = cd[0];
          var trace = cd0.trace;
          var x = cd0.x;
          var y = cd0.y;
          var contours = trace.contours;
          var pathinfo = emptyPathinfo(contours, plotinfo, cd0);
  
          // use a heatmap to fill - draw it behind the lines
          var heatmapColoringLayer = Lib.ensureSingle(plotGroup, 'g', 'heatmapcoloring');
          var cdheatmaps = [];
          if(contours.coloring === 'heatmap') {
              cdheatmaps = [cd];
          }
          heatmapPlot(gd, plotinfo, cdheatmaps, heatmapColoringLayer);
  
          makeCrossings(pathinfo);
          findAllPaths(pathinfo);
  
          var leftedge = xa.c2p(x[0], true);
          var rightedge = xa.c2p(x[x.length - 1], true);
          var bottomedge = ya.c2p(y[0], true);
          var topedge = ya.c2p(y[y.length - 1], true);
          var perimeter = [
              [leftedge, topedge],
              [rightedge, topedge],
              [rightedge, bottomedge],
              [leftedge, bottomedge]
          ];
  
          var fillPathinfo = pathinfo;
          if(contours.type === 'constraint') {
              // N.B. this also mutates pathinfo
              fillPathinfo = convertToConstraints(pathinfo, contours._operation);
          }
  
          // draw everything
          makeBackground(plotGroup, perimeter, contours);
          makeFills(plotGroup, fillPathinfo, perimeter, contours);
          makeLinesAndLabels(plotGroup, pathinfo, gd, cd0, contours);
          clipGaps(plotGroup, plotinfo, gd, cd0, perimeter);
      });
  };
  
  function makeBackground(plotgroup, perimeter, contours) {
      var bggroup = Lib.ensureSingle(plotgroup, 'g', 'contourbg');
  
      var bgfill = bggroup.selectAll('path')
          .data(contours.coloring === 'fill' ? [0] : []);
      bgfill.enter().append('path');
      bgfill.exit().remove();
      bgfill
          .attr('d', 'M' + perimeter.join('L') + 'Z')
          .style('stroke', 'none');
  }
  
  function makeFills(plotgroup, pathinfo, perimeter, contours) {
      var hasFills = contours.coloring === 'fill' || (contours.type === 'constraint' && contours._operation !== '=');
      var boundaryPath = 'M' + perimeter.join('L') + 'Z';
  
      // fills prefixBoundary in pathinfo items
      if(hasFills) {
          closeBoundaries(pathinfo, contours);
      }
  
      var fillgroup = Lib.ensureSingle(plotgroup, 'g', 'contourfill');
  
      var fillitems = fillgroup.selectAll('path').data(hasFills ? pathinfo : []);
      fillitems.enter().append('path');
      fillitems.exit().remove();
      fillitems.each(function(pi) {
          // join all paths for this level together into a single path
          // first follow clockwise around the perimeter to close any open paths
          // if the whole perimeter is above this level, start with a path
          // enclosing the whole thing. With all that, the parity should mean
          // that we always fill everything above the contour, nothing below
          var fullpath = (pi.prefixBoundary ? boundaryPath : '') +
              joinAllPaths(pi, perimeter);
  
          if(!fullpath) {
              d3.select(this).remove();
          } else {
              d3.select(this)
                  .attr('d', fullpath)
                  .style('stroke', 'none');
          }
      });
  }
  
  function joinAllPaths(pi, perimeter) {
      var fullpath = '';
      var i = 0;
      var startsleft = pi.edgepaths.map(function(v, i) { return i; });
      var newloop = true;
      var endpt;
      var newendpt;
      var cnt;
      var nexti;
      var possiblei;
      var addpath;
  
      function istop(pt) { return Math.abs(pt[1] - perimeter[0][1]) < 0.01; }
      function isbottom(pt) { return Math.abs(pt[1] - perimeter[2][1]) < 0.01; }
      function isleft(pt) { return Math.abs(pt[0] - perimeter[0][0]) < 0.01; }
      function isright(pt) { return Math.abs(pt[0] - perimeter[2][0]) < 0.01; }
  
      while(startsleft.length) {
          addpath = Drawing.smoothopen(pi.edgepaths[i], pi.smoothing);
          fullpath += newloop ? addpath : addpath.replace(/^M/, 'L');
          startsleft.splice(startsleft.indexOf(i), 1);
          endpt = pi.edgepaths[i][pi.edgepaths[i].length - 1];
          nexti = -1;
  
          // now loop through sides, moving our endpoint until we find a new start
          for(cnt = 0; cnt < 4; cnt++) { // just to prevent infinite loops
              if(!endpt) {
                  Lib.log('Missing end?', i, pi);
                  break;
              }
  
              if(istop(endpt) && !isright(endpt)) newendpt = perimeter[1]; // right top
              else if(isleft(endpt)) newendpt = perimeter[0]; // left top
              else if(isbottom(endpt)) newendpt = perimeter[3]; // right bottom
              else if(isright(endpt)) newendpt = perimeter[2]; // left bottom
  
              for(possiblei = 0; possiblei < pi.edgepaths.length; possiblei++) {
                  var ptNew = pi.edgepaths[possiblei][0];
                  // is ptNew on the (horz. or vert.) segment from endpt to newendpt?
                  if(Math.abs(endpt[0] - newendpt[0]) < 0.01) {
                      if(Math.abs(endpt[0] - ptNew[0]) < 0.01 &&
                              (ptNew[1] - endpt[1]) * (newendpt[1] - ptNew[1]) >= 0) {
                          newendpt = ptNew;
                          nexti = possiblei;
                      }
                  } else if(Math.abs(endpt[1] - newendpt[1]) < 0.01) {
                      if(Math.abs(endpt[1] - ptNew[1]) < 0.01 &&
                              (ptNew[0] - endpt[0]) * (newendpt[0] - ptNew[0]) >= 0) {
                          newendpt = ptNew;
                          nexti = possiblei;
                      }
                  } else {
                      Lib.log('endpt to newendpt is not vert. or horz.',
                          endpt, newendpt, ptNew);
                  }
              }
  
              endpt = newendpt;
  
              if(nexti >= 0) break;
              fullpath += 'L' + newendpt;
          }
  
          if(nexti === pi.edgepaths.length) {
              Lib.log('unclosed perimeter path');
              break;
          }
  
          i = nexti;
  
          // if we closed back on a loop we already included,
          // close it and start a new loop
          newloop = (startsleft.indexOf(i) === -1);
          if(newloop) {
              i = startsleft[0];
              fullpath += 'Z';
          }
      }
  
      // finally add the interior paths
      for(i = 0; i < pi.paths.length; i++) {
          fullpath += Drawing.smoothclosed(pi.paths[i], pi.smoothing);
      }
  
      return fullpath;
  }
  
  function makeLinesAndLabels(plotgroup, pathinfo, gd, cd0, contours) {
      var lineContainer = Lib.ensureSingle(plotgroup, 'g', 'contourlines');
      var showLines = contours.showlines !== false;
      var showLabels = contours.showlabels;
      var clipLinesForLabels = showLines && showLabels;
  
      // Even if we're not going to show lines, we need to create them
      // if we're showing labels, because the fill paths include the perimeter
      // so can't be used to position the labels correctly.
      // In this case we'll remove the lines after making the labels.
      var linegroup = exports.createLines(lineContainer, showLines || showLabels, pathinfo);
  
      var lineClip = exports.createLineClip(lineContainer, clipLinesForLabels, gd, cd0.trace.uid);
  
      var labelGroup = plotgroup.selectAll('g.contourlabels')
          .data(showLabels ? [0] : []);
  
      labelGroup.exit().remove();
  
      labelGroup.enter().append('g')
          .classed('contourlabels', true);
  
      if(showLabels) {
          var labelClipPathData = [];
          var labelData = [];
  
          // invalidate the getTextLocation cache in case paths changed
          Lib.clearLocationCache();
  
          var contourFormat = exports.labelFormatter(gd, cd0);
  
          var dummyText = Drawing.tester.append('text')
              .attr('data-notex', 1)
              .call(Drawing.font, contours.labelfont);
  
          var xa = pathinfo[0].xaxis;
          var ya = pathinfo[0].yaxis;
          var xLen = xa._length;
          var yLen = ya._length;
          var xRng = xa.range;
          var yRng = ya.range;
          var xMin = Lib.aggNums(Math.min, null, cd0.x);
          var xMax = Lib.aggNums(Math.max, null, cd0.x);
          var yMin = Lib.aggNums(Math.min, null, cd0.y);
          var yMax = Lib.aggNums(Math.max, null, cd0.y);
          var x0 = Math.max(xa.c2p(xMin, true), 0);
          var x1 = Math.min(xa.c2p(xMax, true), xLen);
          var y0 = Math.max(ya.c2p(yMax, true), 0);
          var y1 = Math.min(ya.c2p(yMin, true), yLen);
  
          // visible bounds of the contour trace (and the midpoints, to
          // help with cost calculations)
          var bounds = {};
  
          if(xRng[0] < xRng[1]) {
              bounds.left = x0;
              bounds.right = x1;
          } else {
              bounds.left = x1;
              bounds.right = x0;
          }
  
          if(yRng[0] < yRng[1]) {
              bounds.top = y0;
              bounds.bottom = y1;
          } else {
              bounds.top = y1;
              bounds.bottom = y0;
          }
  
          bounds.middle = (bounds.top + bounds.bottom) / 2;
          bounds.center = (bounds.left + bounds.right) / 2;
  
          labelClipPathData.push([
              [bounds.left, bounds.top],
              [bounds.right, bounds.top],
              [bounds.right, bounds.bottom],
              [bounds.left, bounds.bottom]
          ]);
  
          var plotDiagonal = Math.sqrt(xLen * xLen + yLen * yLen);
  
          // the path length to use to scale the number of labels to draw:
          var normLength = constants.LABELDISTANCE * plotDiagonal /
              Math.max(1, pathinfo.length / constants.LABELINCREASE);
  
          linegroup.each(function(d) {
              var textOpts = exports.calcTextOpts(d.level, contourFormat, dummyText, gd);
  
              d3.select(this).selectAll('path').each(function() {
                  var path = this;
                  var pathBounds = Lib.getVisibleSegment(path, bounds, textOpts.height / 2);
                  if(!pathBounds) return;
  
                  if(pathBounds.len < (textOpts.width + textOpts.height) * constants.LABELMIN) return;
  
                  var maxLabels = Math.min(Math.ceil(pathBounds.len / normLength),
                      constants.LABELMAX);
  
                  for(var i = 0; i < maxLabels; i++) {
                      var loc = exports.findBestTextLocation(path, pathBounds, textOpts,
                          labelData, bounds);
  
                      if(!loc) break;
  
                      exports.addLabelData(loc, textOpts, labelData, labelClipPathData);
                  }
              });
          });
  
          dummyText.remove();
  
          exports.drawLabels(labelGroup, labelData, gd, lineClip,
              clipLinesForLabels ? labelClipPathData : null);
      }
  
      if(showLabels && !showLines) linegroup.remove();
  }
  
  exports.createLines = function(lineContainer, makeLines, pathinfo) {
      var smoothing = pathinfo[0].smoothing;
  
      var linegroup = lineContainer.selectAll('g.contourlevel')
          .data(makeLines ? pathinfo : []);
  
      linegroup.exit().remove();
      linegroup.enter().append('g')
          .classed('contourlevel', true);
  
      if(makeLines) {
          // pedgepaths / ppaths are used by contourcarpet, for the paths transformed from a/b to x/y
          // edgepaths / paths are used by contour since it's in x/y from the start
          var opencontourlines = linegroup.selectAll('path.openline')
              .data(function(d) { return d.pedgepaths || d.edgepaths; });
  
          opencontourlines.exit().remove();
          opencontourlines.enter().append('path')
              .classed('openline', true);
  
          opencontourlines
              .attr('d', function(d) {
                  return Drawing.smoothopen(d, smoothing);
              })
              .style('stroke-miterlimit', 1)
              .style('vector-effect', 'non-scaling-stroke');
  
          var closedcontourlines = linegroup.selectAll('path.closedline')
              .data(function(d) { return d.ppaths || d.paths; });
  
          closedcontourlines.exit().remove();
          closedcontourlines.enter().append('path')
              .classed('closedline', true);
  
          closedcontourlines
              .attr('d', function(d) {
                  return Drawing.smoothclosed(d, smoothing);
              })
              .style('stroke-miterlimit', 1)
              .style('vector-effect', 'non-scaling-stroke');
      }
  
      return linegroup;
  };
  
  exports.createLineClip = function(lineContainer, clipLinesForLabels, gd, uid) {
      var clips = gd._fullLayout._clips;
      var clipId = clipLinesForLabels ? ('clipline' + uid) : null;
  
      var lineClip = clips.selectAll('#' + clipId)
          .data(clipLinesForLabels ? [0] : []);
      lineClip.exit().remove();
  
      lineClip.enter().append('clipPath')
          .classed('contourlineclip', true)
          .attr('id', clipId);
  
      Drawing.setClipUrl(lineContainer, clipId, gd);
  
      return lineClip;
  };
  
  exports.labelFormatter = function(gd, cd0) {
      var fullLayout = gd._fullLayout;
      var trace = cd0.trace;
      var contours = trace.contours;
  
      var formatAxis = {
          type: 'linear',
          _id: 'ycontour',
          showexponent: 'all',
          exponentformat: 'B'
      };
  
      if(contours.labelformat) {
          formatAxis.tickformat = contours.labelformat;
          setConvert(formatAxis, fullLayout);
      } else {
          var cOpts = Colorscale.extractOpts(trace);
          if(cOpts && cOpts.colorbar && cOpts.colorbar._axis) {
              formatAxis = cOpts.colorbar._axis;
          } else {
              if(contours.type === 'constraint') {
                  var value = contours.value;
                  if(Array.isArray(value)) {
                      formatAxis.range = [value[0], value[value.length - 1]];
                  } else formatAxis.range = [value, value];
              } else {
                  formatAxis.range = [contours.start, contours.end];
                  formatAxis.nticks = (contours.end - contours.start) / contours.size;
              }
  
              if(formatAxis.range[0] === formatAxis.range[1]) {
                  formatAxis.range[1] += formatAxis.range[0] || 1;
              }
              if(!formatAxis.nticks) formatAxis.nticks = 1000;
  
              setConvert(formatAxis, fullLayout);
              Axes.prepTicks(formatAxis);
              formatAxis._tmin = null;
              formatAxis._tmax = null;
          }
      }
  
      return function(v) { return Axes.tickText(formatAxis, v).text; };
  };
  
  exports.calcTextOpts = function(level, contourFormat, dummyText, gd) {
      var text = contourFormat(level);
      dummyText.text(text)
          .call(svgTextUtils.convertToTspans, gd);
  
      var el = dummyText.node();
      var bBox = Drawing.bBox(el, true);
  
      return {
          text: text,
          width: bBox.width,
          height: bBox.height,
          fontSize: +(el.style['font-size'].replace('px', '')),
          level: level,
          dy: (bBox.top + bBox.bottom) / 2
      };
  };
  
  exports.findBestTextLocation = function(path, pathBounds, textOpts, labelData, plotBounds) {
      var textWidth = textOpts.width;
  
      var p0, dp, pMax, pMin, loc;
      if(pathBounds.isClosed) {
          dp = pathBounds.len / costConstants.INITIALSEARCHPOINTS;
          p0 = pathBounds.min + dp / 2;
          pMax = pathBounds.max;
      } else {
          dp = (pathBounds.len - textWidth) / (costConstants.INITIALSEARCHPOINTS + 1);
          p0 = pathBounds.min + dp + textWidth / 2;
          pMax = pathBounds.max - (dp + textWidth) / 2;
      }
  
      var cost = Infinity;
      for(var j = 0; j < costConstants.ITERATIONS; j++) {
          for(var p = p0; p < pMax; p += dp) {
              var newLocation = Lib.getTextLocation(path, pathBounds.total, p, textWidth);
              var newCost = locationCost(newLocation, textOpts, labelData, plotBounds);
              if(newCost < cost) {
                  cost = newCost;
                  loc = newLocation;
                  pMin = p;
              }
          }
          if(cost > costConstants.MAXCOST * 2) break;
  
          // subsequent iterations just look half steps away from the
          // best we found in the previous iteration
          if(j) dp /= 2;
          p0 = pMin - dp / 2;
          pMax = p0 + dp * 1.5;
      }
      if(cost <= costConstants.MAXCOST) return loc;
  };
  
  /*
   * locationCost: a cost function for label locations
   * composed of three kinds of penalty:
   * - for open paths, being close to the end of the path
   * - the angle away from horizontal
   * - being too close to already placed neighbors
   */
  function locationCost(loc, textOpts, labelData, bounds) {
      var halfWidth = textOpts.width / 2;
      var halfHeight = textOpts.height / 2;
      var x = loc.x;
      var y = loc.y;
      var theta = loc.theta;
      var dx = Math.cos(theta) * halfWidth;
      var dy = Math.sin(theta) * halfWidth;
  
      // cost for being near an edge
      var normX = ((x > bounds.center) ? (bounds.right - x) : (x - bounds.left)) /
          (dx + Math.abs(Math.sin(theta) * halfHeight));
      var normY = ((y > bounds.middle) ? (bounds.bottom - y) : (y - bounds.top)) /
          (Math.abs(dy) + Math.cos(theta) * halfHeight);
      if(normX < 1 || normY < 1) return Infinity;
      var cost = costConstants.EDGECOST * (1 / (normX - 1) + 1 / (normY - 1));
  
      // cost for not being horizontal
      cost += costConstants.ANGLECOST * theta * theta;
  
      // cost for being close to other labels
      var x1 = x - dx;
      var y1 = y - dy;
      var x2 = x + dx;
      var y2 = y + dy;
      for(var i = 0; i < labelData.length; i++) {
          var labeli = labelData[i];
          var dxd = Math.cos(labeli.theta) * labeli.width / 2;
          var dyd = Math.sin(labeli.theta) * labeli.width / 2;
          var dist = Lib.segmentDistance(
              x1, y1,
              x2, y2,
              labeli.x - dxd, labeli.y - dyd,
              labeli.x + dxd, labeli.y + dyd
          ) * 2 / (textOpts.height + labeli.height);
  
          var sameLevel = labeli.level === textOpts.level;
          var distOffset = sameLevel ? costConstants.SAMELEVELDISTANCE : 1;
  
          if(dist <= distOffset) return Infinity;
  
          var distFactor = costConstants.NEIGHBORCOST *
              (sameLevel ? costConstants.SAMELEVELFACTOR : 1);
  
          cost += distFactor / (dist - distOffset);
      }
  
      return cost;
  }
  
  exports.addLabelData = function(loc, textOpts, labelData, labelClipPathData) {
      var fontSize = textOpts.fontSize;
      var w = textOpts.width + fontSize / 3;
      var h = Math.max(0, textOpts.height - fontSize / 3);
  
      var x = loc.x;
      var y = loc.y;
      var theta = loc.theta;
  
      var sin = Math.sin(theta);
      var cos = Math.cos(theta);
  
      var rotateXY = function(dx, dy) {
          return [
              x + dx * cos - dy * sin,
              y + dx * sin + dy * cos
          ];
      };
  
      var bBoxPts = [
          rotateXY(-w / 2, -h / 2),
          rotateXY(-w / 2, h / 2),
          rotateXY(w / 2, h / 2),
          rotateXY(w / 2, -h / 2)
      ];
  
      labelData.push({
          text: textOpts.text,
          x: x,
          y: y,
          dy: textOpts.dy,
          theta: theta,
          level: textOpts.level,
          width: w,
          height: h
      });
  
      labelClipPathData.push(bBoxPts);
  };
  
  exports.drawLabels = function(labelGroup, labelData, gd, lineClip, labelClipPathData) {
      var labels = labelGroup.selectAll('text')
          .data(labelData, function(d) {
              return d.text + ',' + d.x + ',' + d.y + ',' + d.theta;
          });
  
      labels.exit().remove();
  
      labels.enter().append('text')
          .attr({
              'data-notex': 1,
              'text-anchor': 'middle'
          })
          .each(function(d) {
              var x = d.x + Math.sin(d.theta) * d.dy;
              var y = d.y - Math.cos(d.theta) * d.dy;
              d3.select(this)
                  .text(d.text)
                  .attr({
                      x: x,
                      y: y,
                      transform: 'rotate(' + (180 * d.theta / Math.PI) + ' ' + x + ' ' + y + ')'
                  })
                  .call(svgTextUtils.convertToTspans, gd);
          });
  
      if(labelClipPathData) {
          var clipPath = '';
          for(var i = 0; i < labelClipPathData.length; i++) {
              clipPath += 'M' + labelClipPathData[i].join('L') + 'Z';
          }
  
          var lineClipPath = Lib.ensureSingle(lineClip, 'path', '');
          lineClipPath.attr('d', clipPath);
      }
  };
  
  function clipGaps(plotGroup, plotinfo, gd, cd0, perimeter) {
      var trace = cd0.trace;
      var clips = gd._fullLayout._clips;
      var clipId = 'clip' + trace.uid;
  
      var clipPath = clips.selectAll('#' + clipId)
          .data(trace.connectgaps ? [] : [0]);
      clipPath.enter().append('clipPath')
          .classed('contourclip', true)
          .attr('id', clipId);
      clipPath.exit().remove();
  
      if(trace.connectgaps === false) {
          var clipPathInfo = {
              // fraction of the way from missing to present point
              // to draw the boundary.
              // if you make this 1 (or 1-epsilon) then a point in
              // a sea of missing data will disappear entirely.
              level: 0.9,
              crossings: {},
              starts: [],
              edgepaths: [],
              paths: [],
              xaxis: plotinfo.xaxis,
              yaxis: plotinfo.yaxis,
              x: cd0.x,
              y: cd0.y,
              // 0 = no data, 1 = data
              z: makeClipMask(cd0),
              smoothing: 0
          };
  
          makeCrossings([clipPathInfo]);
          findAllPaths([clipPathInfo]);
          closeBoundaries([clipPathInfo], {type: 'levels'});
  
          var path = Lib.ensureSingle(clipPath, 'path', '');
          path.attr('d',
              (clipPathInfo.prefixBoundary ? 'M' + perimeter.join('L') + 'Z' : '') +
              joinAllPaths(clipPathInfo, perimeter)
          );
      } else clipId = null;
  
      Drawing.setClipUrl(plotGroup, clipId, gd);
  }
  
  function makeClipMask(cd0) {
      var empties = cd0.trace._emptypoints;
      var z = [];
      var m = cd0.z.length;
      var n = cd0.z[0].length;
      var i;
      var row = [];
      var emptyPoint;
  
      for(i = 0; i < n; i++) row.push(1);
      for(i = 0; i < m; i++) z.push(row.slice());
      for(i = 0; i < empties.length; i++) {
          emptyPoint = empties[i];
          z[emptyPoint[0]][emptyPoint[1]] = 0;
      }
      // save this mask to determine whether to show this data in hover
      cd0.zmask = z;
      return z;
  }
  
  },{"../../components/colorscale":627,"../../components/drawing":637,"../../lib":750,"../../lib/svg_text_utils":774,"../../plots/cartesian/axes":799,"../../plots/cartesian/set_convert":819,"../heatmap/plot":1047,"./close_boundaries":981,"./constants":983,"./convert_to_constraints":987,"./empty_pathinfo":989,"./find_all_paths":991,"./make_crossings":996,"d3":169}],998:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Lib = _dereq_('../../lib');
  
  module.exports = function setContours(trace, vals) {
      var contours = trace.contours;
  
      // check if we need to auto-choose contour levels
      if(trace.autocontour) {
          // N.B. do not try to use coloraxis cmin/cmax,
          // these values here are meant to remain "per-trace" for now
          var zmin = trace.zmin;
          var zmax = trace.zmax;
          if(trace.zauto || zmin === undefined) {
              zmin = Lib.aggNums(Math.min, null, vals);
          }
          if(trace.zauto || zmax === undefined) {
              zmax = Lib.aggNums(Math.max, null, vals);
          }
  
          var dummyAx = autoContours(zmin, zmax, trace.ncontours);
          contours.size = dummyAx.dtick;
          contours.start = Axes.tickFirst(dummyAx);
          dummyAx.range.reverse();
          contours.end = Axes.tickFirst(dummyAx);
  
          if(contours.start === zmin) contours.start += contours.size;
          if(contours.end === zmax) contours.end -= contours.size;
  
          // if you set a small ncontours, *and* the ends are exactly on zmin/zmax
          // there's an edge case where start > end now. Make sure there's at least
          // one meaningful contour, put it midway between the crossed values
          if(contours.start > contours.end) {
              contours.start = contours.end = (contours.start + contours.end) / 2;
          }
  
          // copy auto-contour info back to the source data.
          // previously we copied the whole contours object back, but that had
          // other info (coloring, showlines) that should be left to supplyDefaults
          if(!trace._input.contours) trace._input.contours = {};
          Lib.extendFlat(trace._input.contours, {
              start: contours.start,
              end: contours.end,
              size: contours.size
          });
          trace._input.autocontour = true;
      } else if(contours.type !== 'constraint') {
          // sanity checks on manually-supplied start/end/size
          var start = contours.start;
          var end = contours.end;
          var inputContours = trace._input.contours;
  
          if(start > end) {
              contours.start = inputContours.start = end;
              end = contours.end = inputContours.end = start;
              start = contours.start;
          }
  
          if(!(contours.size > 0)) {
              var sizeOut;
              if(start === end) sizeOut = 1;
              else sizeOut = autoContours(start, end, trace.ncontours).dtick;
  
              inputContours.size = contours.size = sizeOut;
          }
      }
  };
  
  
  /*
   * autoContours: make a dummy axis object with dtick we can use
   * as contours.size, and if needed we can use Axes.tickFirst
   * with this axis object to calculate the start and end too
   *
   * start: the value to start the contours at
   * end: the value to end at (must be > start)
   * ncontours: max number of contours to make, like roughDTick
   *
   * returns: an axis object
   */
  function autoContours(start, end, ncontours) {
      var dummyAx = {
          type: 'linear',
          range: [start, end]
      };
  
      Axes.autoTicks(
          dummyAx,
          (end - start) / (ncontours || 15)
      );
  
      return dummyAx;
  }
  
  },{"../../lib":750,"../../plots/cartesian/axes":799}],999:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Drawing = _dereq_('../../components/drawing');
  var heatmapStyle = _dereq_('../heatmap/style');
  
  var makeColorMap = _dereq_('./make_color_map');
  
  
  module.exports = function style(gd) {
      var contours = d3.select(gd).selectAll('g.contour');
  
      contours.style('opacity', function(d) {
          return d[0].trace.opacity;
      });
  
      contours.each(function(d) {
          var c = d3.select(this);
          var trace = d[0].trace;
          var contours = trace.contours;
          var line = trace.line;
          var cs = contours.size || 1;
          var start = contours.start;
  
          // for contourcarpet only - is this a constraint-type contour trace?
          var isConstraintType = contours.type === 'constraint';
          var colorLines = !isConstraintType && contours.coloring === 'lines';
          var colorFills = !isConstraintType && contours.coloring === 'fill';
  
          var colorMap = (colorLines || colorFills) ? makeColorMap(trace) : null;
  
          c.selectAll('g.contourlevel').each(function(d) {
              d3.select(this).selectAll('path')
                  .call(Drawing.lineGroupStyle,
                      line.width,
                      colorLines ? colorMap(d.level) : line.color,
                      line.dash);
          });
  
          var labelFont = contours.labelfont;
          c.selectAll('g.contourlabels text').each(function(d) {
              Drawing.font(d3.select(this), {
                  family: labelFont.family,
                  size: labelFont.size,
                  color: labelFont.color || (colorLines ? colorMap(d.level) : line.color)
              });
          });
  
          if(isConstraintType) {
              c.selectAll('g.contourfill path')
                  .style('fill', trace.fillcolor);
          } else if(colorFills) {
              var firstFill;
  
              c.selectAll('g.contourfill path')
                  .style('fill', function(d) {
                      if(firstFill === undefined) firstFill = d.level;
                      return colorMap(d.level + 0.5 * cs);
                  });
  
              if(firstFill === undefined) firstFill = start;
  
              c.selectAll('g.contourbg path')
                  .style('fill', colorMap(firstFill - 0.5 * cs));
          }
      });
  
      heatmapStyle(gd);
  };
  
  },{"../../components/drawing":637,"../heatmap/style":1048,"./make_color_map":995,"d3":169}],1000:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var handleLabelDefaults = _dereq_('./label_defaults');
  
  
  module.exports = function handleStyleDefaults(traceIn, traceOut, coerce, layout, opts) {
      var coloring = coerce('contours.coloring');
  
      var showLines;
      var lineColor = '';
      if(coloring === 'fill') showLines = coerce('contours.showlines');
  
      if(showLines !== false) {
          if(coloring !== 'lines') lineColor = coerce('line.color', '#000');
          coerce('line.width', 0.5);
          coerce('line.dash');
      }
  
      if(coloring !== 'none') {
          // plots/plots always coerces showlegend to true, but in this case
          // we default to false and (by default) show a colorbar instead
          if(traceIn.showlegend !== true) traceOut.showlegend = false;
          traceOut._dfltShowLegend = false;
  
          colorscaleDefaults(
              traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'}
          );
      }
  
      coerce('line.smoothing');
  
      handleLabelDefaults(coerce, layout, lineColor, opts);
  };
  
  },{"../../components/colorscale/defaults":625,"./label_defaults":994}],1001:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var heatmapAttrs = _dereq_('../heatmap/attributes');
  var contourAttrs = _dereq_('../contour/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var contourContourAttrs = contourAttrs.contours;
  
  module.exports = extendFlat({
      carpet: {
          valType: 'string',
          
          editType: 'calc',
          
      },
      z: heatmapAttrs.z,
      a: heatmapAttrs.x,
      a0: heatmapAttrs.x0,
      da: heatmapAttrs.dx,
      b: heatmapAttrs.y,
      b0: heatmapAttrs.y0,
      db: heatmapAttrs.dy,
      text: heatmapAttrs.text,
      hovertext: heatmapAttrs.hovertext,
      transpose: heatmapAttrs.transpose,
      atype: heatmapAttrs.xtype,
      btype: heatmapAttrs.ytype,
  
      fillcolor: contourAttrs.fillcolor,
  
      autocontour: contourAttrs.autocontour,
      ncontours: contourAttrs.ncontours,
  
      contours: {
          type: contourContourAttrs.type,
          start: contourContourAttrs.start,
          end: contourContourAttrs.end,
          size: contourContourAttrs.size,
          coloring: {
              // from contourAttrs.contours.coloring but no 'heatmap' option
              valType: 'enumerated',
              values: ['fill', 'lines', 'none'],
              dflt: 'fill',
              
              editType: 'calc',
              
          },
          showlines: contourContourAttrs.showlines,
          showlabels: contourContourAttrs.showlabels,
          labelfont: contourContourAttrs.labelfont,
          labelformat: contourContourAttrs.labelformat,
          operation: contourContourAttrs.operation,
          value: contourContourAttrs.value,
          editType: 'calc',
          impliedEdits: {'autocontour': false}
      },
  
      line: {
          color: contourAttrs.line.color,
          width: contourAttrs.line.width,
          dash: contourAttrs.line.dash,
          smoothing: contourAttrs.line.smoothing,
          editType: 'plot'
      },
  
      transforms: undefined
  },
  
      colorScaleAttrs('', {
          cLetter: 'z',
          autoColorDflt: false
      })
  );
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../contour/attributes":979,"../heatmap/attributes":1036}],1002:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  var Lib = _dereq_('../../lib');
  
  var convertColumnData = _dereq_('../heatmap/convert_column_xyz');
  var clean2dArray = _dereq_('../heatmap/clean_2d_array');
  var interp2d = _dereq_('../heatmap/interp2d');
  var findEmpties = _dereq_('../heatmap/find_empties');
  var makeBoundArray = _dereq_('../heatmap/make_bound_array');
  var supplyDefaults = _dereq_('./defaults');
  var lookupCarpet = _dereq_('../carpet/lookup_carpetid');
  var setContours = _dereq_('../contour/set_contours');
  
  // most is the same as heatmap calc, then adjust it
  // though a few things inside heatmap calc still look for
  // contour maps, because the makeBoundArray calls are too entangled
  module.exports = function calc(gd, trace) {
      var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
      if(!carpet || !carpet.visible || carpet.visible === 'legendonly') return;
  
      if(!trace.a || !trace.b) {
          // Look up the original incoming carpet data:
          var carpetdata = gd.data[carpet.index];
  
          // Look up the incoming trace data, *except* perform a shallow
          // copy so that we're not actually modifying it when we use it
          // to supply defaults:
          var tracedata = gd.data[trace.index];
          // var tracedata = extendFlat({}, gd.data[trace.index]);
  
          // If the data is not specified
          if(!tracedata.a) tracedata.a = carpetdata.a;
          if(!tracedata.b) tracedata.b = carpetdata.b;
  
          supplyDefaults(tracedata, trace, trace._defaultColor, gd._fullLayout);
      }
  
      var cd = heatmappishCalc(gd, trace);
      setContours(trace, trace._z);
  
      return cd;
  };
  
  function heatmappishCalc(gd, trace) {
      // prepare the raw data
      // run makeCalcdata on x and y even for heatmaps, in case of category mappings
      var carpet = trace._carpetTrace;
      var aax = carpet.aaxis;
      var bax = carpet.baxis;
      var a,
          a0,
          da,
          b,
          b0,
          db,
          z;
  
      // cancel minimum tick spacings (only applies to bars and boxes)
      aax._minDtick = 0;
      bax._minDtick = 0;
  
      if(Lib.isArray1D(trace.z)) convertColumnData(trace, aax, bax, 'a', 'b', ['z']);
      a = trace._a = trace._a || trace.a;
      b = trace._b = trace._b || trace.b;
  
      a = a ? aax.makeCalcdata(trace, '_a') : [];
      b = b ? bax.makeCalcdata(trace, '_b') : [];
      a0 = trace.a0 || 0;
      da = trace.da || 1;
      b0 = trace.b0 || 0;
      db = trace.db || 1;
  
      z = trace._z = clean2dArray(trace._z || trace.z, trace.transpose);
  
      trace._emptypoints = findEmpties(z);
      interp2d(z, trace._emptypoints);
  
      // create arrays of brick boundaries, to be used by autorange and heatmap.plot
      var xlen = Lib.maxRowLength(z);
      var xIn = trace.xtype === 'scaled' ? '' : a;
      var xArray = makeBoundArray(trace, xIn, a0, da, xlen, aax);
      var yIn = trace.ytype === 'scaled' ? '' : b;
      var yArray = makeBoundArray(trace, yIn, b0, db, z.length, bax);
  
      var cd0 = {
          a: xArray,
          b: yArray,
          z: z,
      };
  
      if(trace.contours.type === 'levels' && trace.contours.coloring !== 'none') {
          // auto-z and autocolorscale if applicable
          colorscaleCalc(gd, trace, {
              vals: z,
              containerStr: '',
              cLetter: 'z'
          });
      }
  
      return [cd0];
  }
  
  },{"../../components/colorscale/calc":623,"../../lib":750,"../carpet/lookup_carpetid":952,"../contour/set_contours":998,"../heatmap/clean_2d_array":1038,"../heatmap/convert_column_xyz":1040,"../heatmap/find_empties":1042,"../heatmap/interp2d":1045,"../heatmap/make_bound_array":1046,"./defaults":1003}],1003:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleXYZDefaults = _dereq_('../heatmap/xyz_defaults');
  var attributes = _dereq_('./attributes');
  var handleConstraintDefaults = _dereq_('../contour/constraint_defaults');
  var handleContoursDefaults = _dereq_('../contour/contours_defaults');
  var handleStyleDefaults = _dereq_('../contour/style_defaults');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      function coerce2(attr) {
          return Lib.coerce2(traceIn, traceOut, attributes, attr);
      }
  
      coerce('carpet');
  
      // If either a or b is not present, then it's not a valid trace *unless* the carpet
      // axis has the a or b values we're looking for. So if these are not found, just defer
      // that decision until the calc step.
      //
      // NB: the calc step will modify the original data input by assigning whichever of
      // a or b are missing. This is necessary because panning goes right from supplyDefaults
      // to plot (skipping calc). That means on subsequent updates, this *will* need to be
      // able to find a and b.
      //
      // The long-term proper fix is that this should perhaps use underscored attributes to
      // at least modify the user input to a slightly lesser extent. Fully removing the
      // input mutation is challenging. The underscore approach is not currently taken since
      // it requires modification to all of the functions below that expect the coerced
      // attribute name to match the property name -- except '_a' !== 'a' so that is not
      // straightforward.
      if(traceIn.a && traceIn.b) {
          var len = handleXYZDefaults(traceIn, traceOut, coerce, layout, 'a', 'b');
  
          if(!len) {
              traceOut.visible = false;
              return;
          }
  
          coerce('text');
          var isConstraint = (coerce('contours.type') === 'constraint');
  
          if(isConstraint) {
              handleConstraintDefaults(traceIn, traceOut, coerce, layout, defaultColor, {hasHover: false});
          } else {
              handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
              handleStyleDefaults(traceIn, traceOut, coerce, layout, {hasHover: false});
          }
      } else {
          traceOut._defaultColor = defaultColor;
          traceOut._length = null;
      }
  };
  
  },{"../../lib":750,"../contour/constraint_defaults":984,"../contour/contours_defaults":986,"../contour/style_defaults":1000,"../heatmap/xyz_defaults":1050,"./attributes":1001}],1004:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../contour/colorbar'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      style: _dereq_('../contour/style'),
  
      moduleType: 'trace',
      name: 'contourcarpet',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', 'carpet', 'contour', 'symbols', 'showLegend', 'hasLines', 'carpetDependent', 'noHover', 'noSortingByValue'],
      meta: {
          
          
      }
  };
  
  },{"../../plots/cartesian":812,"../contour/colorbar":982,"../contour/style":999,"./attributes":1001,"./calc":1002,"./defaults":1003,"./plot":1005}],1005:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var map1dArray = _dereq_('../carpet/map_1d_array');
  var makepath = _dereq_('../carpet/makepath');
  var Drawing = _dereq_('../../components/drawing');
  var Lib = _dereq_('../../lib');
  
  var makeCrossings = _dereq_('../contour/make_crossings');
  var findAllPaths = _dereq_('../contour/find_all_paths');
  var contourPlot = _dereq_('../contour/plot');
  var constants = _dereq_('../contour/constants');
  var convertToConstraints = _dereq_('../contour/convert_to_constraints');
  var emptyPathinfo = _dereq_('../contour/empty_pathinfo');
  var closeBoundaries = _dereq_('../contour/close_boundaries');
  var lookupCarpet = _dereq_('../carpet/lookup_carpetid');
  var axisAlignedLine = _dereq_('../carpet/axis_aligned_line');
  
  module.exports = function plot(gd, plotinfo, cdcontours, contourcarpetLayer) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      Lib.makeTraceGroups(contourcarpetLayer, cdcontours, 'contour').each(function(cd) {
          var plotGroup = d3.select(this);
          var cd0 = cd[0];
          var trace = cd0.trace;
  
          var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
          var carpetcd = gd.calcdata[carpet.index][0];
  
          if(!carpet.visible || carpet.visible === 'legendonly') return;
  
          var a = cd0.a;
          var b = cd0.b;
          var contours = trace.contours;
          var pathinfo = emptyPathinfo(contours, plotinfo, cd0);
          var isConstraint = contours.type === 'constraint';
          var operation = contours._operation;
          var coloring = isConstraint ? (operation === '=' ? 'lines' : 'fill') : contours.coloring;
  
          // Map [a, b] (data) --> [i, j] (pixels)
          function ab2p(ab) {
              var pt = carpet.ab2xy(ab[0], ab[1], true);
              return [xa.c2p(pt[0]), ya.c2p(pt[1])];
          }
  
          // Define the perimeter in a/b coordinates:
          var perimeter = [
              [a[0], b[b.length - 1]],
              [a[a.length - 1], b[b.length - 1]],
              [a[a.length - 1], b[0]],
              [a[0], b[0]]
          ];
  
          // Extract the contour levels:
          makeCrossings(pathinfo);
          var atol = (a[a.length - 1] - a[0]) * 1e-8;
          var btol = (b[b.length - 1] - b[0]) * 1e-8;
          findAllPaths(pathinfo, atol, btol);
  
          // Constraints might need to be draw inverted, which is not something contours
          // handle by default since they're assumed fully opaque so that they can be
          // drawn overlapping. This function flips the paths as necessary so that they're
          // drawn correctly.
          //
          // TODO: Perhaps this should be generalized and *all* paths should be drawn as
          // closed regions so that translucent contour levels would be valid.
          // See: https://github.com/plotly/plotly.js/issues/1356
          var fillPathinfo = pathinfo;
          if(contours.type === 'constraint') {
              fillPathinfo = convertToConstraints(pathinfo, operation);
          }
  
          // Map the paths in a/b coordinates to pixel coordinates:
          mapPathinfo(pathinfo, ab2p);
  
          // draw everything
  
          // Compute the boundary path
          var seg, xp, yp, i;
          var segs = [];
          for(i = carpetcd.clipsegments.length - 1; i >= 0; i--) {
              seg = carpetcd.clipsegments[i];
              xp = map1dArray([], seg.x, xa.c2p);
              yp = map1dArray([], seg.y, ya.c2p);
              xp.reverse();
              yp.reverse();
              segs.push(makepath(xp, yp, seg.bicubic));
          }
  
          var boundaryPath = 'M' + segs.join('L') + 'Z';
  
          // Draw the baseline background fill that fills in the space behind any other
          // contour levels:
          makeBackground(plotGroup, carpetcd.clipsegments, xa, ya, isConstraint, coloring);
  
          // Draw the specific contour fills. As a simplification, they're assumed to be
          // fully opaque so that it's easy to draw them simply overlapping. The alternative
          // would be to flip adjacent paths and draw closed paths for each level instead.
          makeFills(trace, plotGroup, xa, ya, fillPathinfo, perimeter, ab2p, carpet, carpetcd, coloring, boundaryPath);
  
          // Draw contour lines:
          makeLinesAndLabels(plotGroup, pathinfo, gd, cd0, contours, plotinfo, carpet);
  
          // Clip the boundary of the plot
          Drawing.setClipUrl(plotGroup, carpet._clipPathId, gd);
      });
  };
  
  function mapPathinfo(pathinfo, map) {
      var i, j, k, pi, pedgepaths, ppaths, pedgepath, ppath, path;
  
      for(i = 0; i < pathinfo.length; i++) {
          pi = pathinfo[i];
          pedgepaths = pi.pedgepaths = [];
          ppaths = pi.ppaths = [];
          for(j = 0; j < pi.edgepaths.length; j++) {
              path = pi.edgepaths[j];
              pedgepath = [];
              for(k = 0; k < path.length; k++) {
                  pedgepath[k] = map(path[k]);
              }
              pedgepaths.push(pedgepath);
          }
          for(j = 0; j < pi.paths.length; j++) {
              path = pi.paths[j];
              ppath = [];
              for(k = 0; k < path.length; k++) {
                  ppath[k] = map(path[k]);
              }
              ppaths.push(ppath);
          }
      }
  }
  
  function makeLinesAndLabels(plotgroup, pathinfo, gd, cd0, contours, plotinfo, carpet) {
      var lineContainer = Lib.ensureSingle(plotgroup, 'g', 'contourlines');
      var showLines = contours.showlines !== false;
      var showLabels = contours.showlabels;
      var clipLinesForLabels = showLines && showLabels;
  
      // Even if we're not going to show lines, we need to create them
      // if we're showing labels, because the fill paths include the perimeter
      // so can't be used to position the labels correctly.
      // In this case we'll remove the lines after making the labels.
      var linegroup = contourPlot.createLines(lineContainer, showLines || showLabels, pathinfo);
  
      var lineClip = contourPlot.createLineClip(lineContainer, clipLinesForLabels, gd, cd0.trace.uid);
  
      var labelGroup = plotgroup.selectAll('g.contourlabels')
          .data(showLabels ? [0] : []);
  
      labelGroup.exit().remove();
  
      labelGroup.enter().append('g')
          .classed('contourlabels', true);
  
      if(showLabels) {
          var xa = plotinfo.xaxis;
          var ya = plotinfo.yaxis;
          var xLen = xa._length;
          var yLen = ya._length;
          // for simplicity use the xy box for label clipping outline.
          var labelClipPathData = [[
              [0, 0],
              [xLen, 0],
              [xLen, yLen],
              [0, yLen]
          ]];
  
  
          var labelData = [];
  
          // invalidate the getTextLocation cache in case paths changed
          Lib.clearLocationCache();
  
          var contourFormat = contourPlot.labelFormatter(gd, cd0);
  
          var dummyText = Drawing.tester.append('text')
              .attr('data-notex', 1)
              .call(Drawing.font, contours.labelfont);
  
          // use `bounds` only to keep labels away from the x/y boundaries
          // `constrainToCarpet` below ensures labels don't go off the
          // carpet edges
          var bounds = {
              left: 0,
              right: xLen,
              center: xLen / 2,
              top: 0,
              bottom: yLen,
              middle: yLen / 2
          };
  
          var plotDiagonal = Math.sqrt(xLen * xLen + yLen * yLen);
  
          // the path length to use to scale the number of labels to draw:
          var normLength = constants.LABELDISTANCE * plotDiagonal /
              Math.max(1, pathinfo.length / constants.LABELINCREASE);
  
          linegroup.each(function(d) {
              var textOpts = contourPlot.calcTextOpts(d.level, contourFormat, dummyText, gd);
  
              d3.select(this).selectAll('path').each(function(pathData) {
                  var path = this;
                  var pathBounds = Lib.getVisibleSegment(path, bounds, textOpts.height / 2);
                  if(!pathBounds) return;
  
                  constrainToCarpet(path, pathData, d, pathBounds, carpet, textOpts.height);
  
                  if(pathBounds.len < (textOpts.width + textOpts.height) * constants.LABELMIN) return;
  
                  var maxLabels = Math.min(Math.ceil(pathBounds.len / normLength),
                      constants.LABELMAX);
  
                  for(var i = 0; i < maxLabels; i++) {
                      var loc = contourPlot.findBestTextLocation(path, pathBounds, textOpts,
                          labelData, bounds);
  
                      if(!loc) break;
  
                      contourPlot.addLabelData(loc, textOpts, labelData, labelClipPathData);
                  }
              });
          });
  
          dummyText.remove();
  
          contourPlot.drawLabels(labelGroup, labelData, gd, lineClip,
              clipLinesForLabels ? labelClipPathData : null);
      }
  
      if(showLabels && !showLines) linegroup.remove();
  }
  
  // figure out if this path goes off the edge of the carpet
  // and shorten the part we call visible to keep labels away from the edge
  function constrainToCarpet(path, pathData, levelData, pathBounds, carpet, textHeight) {
      var pathABData;
      for(var i = 0; i < levelData.pedgepaths.length; i++) {
          if(pathData === levelData.pedgepaths[i]) {
              pathABData = levelData.edgepaths[i];
          }
      }
      if(!pathABData) return;
  
      var aMin = carpet.a[0];
      var aMax = carpet.a[carpet.a.length - 1];
      var bMin = carpet.b[0];
      var bMax = carpet.b[carpet.b.length - 1];
  
      function getOffset(abPt, pathVector) {
          var offset = 0;
          var edgeVector;
          var dAB = 0.1;
          if(Math.abs(abPt[0] - aMin) < dAB || Math.abs(abPt[0] - aMax) < dAB) {
              edgeVector = normalizeVector(carpet.dxydb_rough(abPt[0], abPt[1], dAB));
              offset = Math.max(offset, textHeight * vectorTan(pathVector, edgeVector) / 2);
          }
  
          if(Math.abs(abPt[1] - bMin) < dAB || Math.abs(abPt[1] - bMax) < dAB) {
              edgeVector = normalizeVector(carpet.dxyda_rough(abPt[0], abPt[1], dAB));
              offset = Math.max(offset, textHeight * vectorTan(pathVector, edgeVector) / 2);
          }
          return offset;
      }
  
      var startVector = getUnitVector(path, 0, 1);
      var endVector = getUnitVector(path, pathBounds.total, pathBounds.total - 1);
      var minStart = getOffset(pathABData[0], startVector);
      var maxEnd = pathBounds.total - getOffset(pathABData[pathABData.length - 1], endVector);
  
      if(pathBounds.min < minStart) pathBounds.min = minStart;
      if(pathBounds.max > maxEnd) pathBounds.max = maxEnd;
  
      pathBounds.len = pathBounds.max - pathBounds.min;
  }
  
  function getUnitVector(path, p0, p1) {
      var pt0 = path.getPointAtLength(p0);
      var pt1 = path.getPointAtLength(p1);
      var dx = pt1.x - pt0.x;
      var dy = pt1.y - pt0.y;
      var len = Math.sqrt(dx * dx + dy * dy);
      return [dx / len, dy / len];
  }
  
  function normalizeVector(v) {
      var len = Math.sqrt(v[0] * v[0] + v[1] * v[1]);
      return [v[0] / len, v[1] / len];
  }
  
  function vectorTan(v0, v1) {
      var cos = Math.abs(v0[0] * v1[0] + v0[1] * v1[1]);
      var sin = Math.sqrt(1 - cos * cos);
      return sin / cos;
  }
  
  function makeBackground(plotgroup, clipsegments, xaxis, yaxis, isConstraint, coloring) {
      var seg, xp, yp, i;
      var bggroup = Lib.ensureSingle(plotgroup, 'g', 'contourbg');
  
      var bgfill = bggroup.selectAll('path')
          .data((coloring === 'fill' && !isConstraint) ? [0] : []);
      bgfill.enter().append('path');
      bgfill.exit().remove();
  
      var segs = [];
      for(i = 0; i < clipsegments.length; i++) {
          seg = clipsegments[i];
          xp = map1dArray([], seg.x, xaxis.c2p);
          yp = map1dArray([], seg.y, yaxis.c2p);
          segs.push(makepath(xp, yp, seg.bicubic));
      }
  
      bgfill
          .attr('d', 'M' + segs.join('L') + 'Z')
          .style('stroke', 'none');
  }
  
  function makeFills(trace, plotgroup, xa, ya, pathinfo, perimeter, ab2p, carpet, carpetcd, coloring, boundaryPath) {
      var hasFills = coloring === 'fill';
  
      // fills prefixBoundary in pathinfo items
      if(hasFills) {
          closeBoundaries(pathinfo, trace.contours);
      }
  
      var fillgroup = Lib.ensureSingle(plotgroup, 'g', 'contourfill');
      var fillitems = fillgroup.selectAll('path').data(hasFills ? pathinfo : []);
      fillitems.enter().append('path');
      fillitems.exit().remove();
      fillitems.each(function(pi) {
          // join all paths for this level together into a single path
          // first follow clockwise around the perimeter to close any open paths
          // if the whole perimeter is above this level, start with a path
          // enclosing the whole thing. With all that, the parity should mean
          // that we always fill everything above the contour, nothing below
          var fullpath = (pi.prefixBoundary ? boundaryPath : '') +
              joinAllPaths(trace, pi, perimeter, ab2p, carpet, carpetcd, xa, ya);
  
          if(!fullpath) {
              d3.select(this).remove();
          } else {
              d3.select(this)
                  .attr('d', fullpath)
                  .style('stroke', 'none');
          }
      });
  }
  
  function joinAllPaths(trace, pi, perimeter, ab2p, carpet, carpetcd, xa, ya) {
      var i;
      var fullpath = '';
  
      var startsleft = pi.edgepaths.map(function(v, i) { return i; });
      var newloop = true;
      var endpt, newendpt, cnt, nexti, possiblei, addpath;
  
      var atol = Math.abs(perimeter[0][0] - perimeter[2][0]) * 1e-4;
      var btol = Math.abs(perimeter[0][1] - perimeter[2][1]) * 1e-4;
  
      function istop(pt) { return Math.abs(pt[1] - perimeter[0][1]) < btol; }
      function isbottom(pt) { return Math.abs(pt[1] - perimeter[2][1]) < btol; }
      function isleft(pt) { return Math.abs(pt[0] - perimeter[0][0]) < atol; }
      function isright(pt) { return Math.abs(pt[0] - perimeter[2][0]) < atol; }
  
      function pathto(pt0, pt1) {
          var i, j, segments, axis;
          var path = '';
  
          if((istop(pt0) && !isright(pt0)) || (isbottom(pt0) && !isleft(pt0))) {
              axis = carpet.aaxis;
              segments = axisAlignedLine(carpet, carpetcd, [pt0[0], pt1[0]], 0.5 * (pt0[1] + pt1[1]));
          } else {
              axis = carpet.baxis;
              segments = axisAlignedLine(carpet, carpetcd, 0.5 * (pt0[0] + pt1[0]), [pt0[1], pt1[1]]);
          }
  
          for(i = 1; i < segments.length; i++) {
              path += axis.smoothing ? 'C' : 'L';
              for(j = 0; j < segments[i].length; j++) {
                  var pt = segments[i][j];
                  path += [xa.c2p(pt[0]), ya.c2p(pt[1])] + ' ';
              }
          }
  
          return path;
      }
  
      i = 0;
      endpt = null;
      while(startsleft.length) {
          var startpt = pi.edgepaths[i][0];
  
          if(endpt) {
              fullpath += pathto(endpt, startpt);
          }
  
          addpath = Drawing.smoothopen(pi.edgepaths[i].map(ab2p), pi.smoothing);
          fullpath += newloop ? addpath : addpath.replace(/^M/, 'L');
          startsleft.splice(startsleft.indexOf(i), 1);
          endpt = pi.edgepaths[i][pi.edgepaths[i].length - 1];
          nexti = -1;
  
          // now loop through sides, moving our endpoint until we find a new start
          for(cnt = 0; cnt < 4; cnt++) { // just to prevent infinite loops
              if(!endpt) {
                  Lib.log('Missing end?', i, pi);
                  break;
              }
  
              if(istop(endpt) && !isright(endpt)) {
                  newendpt = perimeter[1]; // left top ---> right top
              } else if(isleft(endpt)) {
                  newendpt = perimeter[0]; // left bottom ---> left top
              } else if(isbottom(endpt)) {
                  newendpt = perimeter[3]; // right bottom
              } else if(isright(endpt)) {
                  newendpt = perimeter[2]; // left bottom
              }
  
              for(possiblei = 0; possiblei < pi.edgepaths.length; possiblei++) {
                  var ptNew = pi.edgepaths[possiblei][0];
                  // is ptNew on the (horz. or vert.) segment from endpt to newendpt?
                  if(Math.abs(endpt[0] - newendpt[0]) < atol) {
                      if(Math.abs(endpt[0] - ptNew[0]) < atol &&
                              (ptNew[1] - endpt[1]) * (newendpt[1] - ptNew[1]) >= 0) {
                          newendpt = ptNew;
                          nexti = possiblei;
                      }
                  } else if(Math.abs(endpt[1] - newendpt[1]) < btol) {
                      if(Math.abs(endpt[1] - ptNew[1]) < btol &&
                              (ptNew[0] - endpt[0]) * (newendpt[0] - ptNew[0]) >= 0) {
                          newendpt = ptNew;
                          nexti = possiblei;
                      }
                  } else {
                      Lib.log('endpt to newendpt is not vert. or horz.', endpt, newendpt, ptNew);
                  }
              }
  
              if(nexti >= 0) break;
              fullpath += pathto(endpt, newendpt);
              endpt = newendpt;
          }
  
          if(nexti === pi.edgepaths.length) {
              Lib.log('unclosed perimeter path');
              break;
          }
  
          i = nexti;
  
          // if we closed back on a loop we already included,
          // close it and start a new loop
          newloop = (startsleft.indexOf(i) === -1);
          if(newloop) {
              i = startsleft[0];
              fullpath += pathto(endpt, newendpt) + 'Z';
              endpt = null;
          }
      }
  
      // finally add the interior paths
      for(i = 0; i < pi.paths.length; i++) {
          fullpath += Drawing.smoothclosed(pi.paths[i].map(ab2p), pi.smoothing);
      }
  
      return fullpath;
  }
  
  },{"../../components/drawing":637,"../../lib":750,"../carpet/axis_aligned_line":936,"../carpet/lookup_carpetid":952,"../carpet/makepath":953,"../carpet/map_1d_array":954,"../contour/close_boundaries":981,"../contour/constants":983,"../contour/convert_to_constraints":987,"../contour/empty_pathinfo":989,"../contour/find_all_paths":991,"../contour/make_crossings":996,"../contour/plot":997,"d3":169}],1006:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var baseAttrs = _dereq_('../../plots/attributes');
  var scatterMapboxAttrs = _dereq_('../scattermapbox/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  /*
   * - https://docs.mapbox.com/help/tutorials/make-a-heatmap-with-mapbox-gl-js/
   * - https://docs.mapbox.com/mapbox-gl-js/example/heatmap-layer/
   * - https://docs.mapbox.com/mapbox-gl-js/style-spec/#layers-heatmap
   * - https://blog.mapbox.com/introducing-heatmaps-in-mapbox-gl-js-71355ada9e6c
   *
   * Gotchas:
   * - https://github.com/mapbox/mapbox-gl-js/issues/6463
   * - https://github.com/mapbox/mapbox-gl-js/issues/6112
   */
  
  /*
   *
   * In mathematical terms, Mapbox GL heatmaps are a bivariate (2D) kernel density
   * estimation with a Gaussian kernel. It means that each data point has an area
   * of “influence” around it (called a kernel) where the numerical value of
   * influence (which we call density) decreases as you go further from the point.
   * If we sum density values of all points in every pixel of the screen, we get a
   * combined density value which we then map to a heatmap color.
   *
   */
  
  module.exports = extendFlat({
      lon: scatterMapboxAttrs.lon,
      lat: scatterMapboxAttrs.lat,
  
      z: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      radius: {
          valType: 'number',
          
          editType: 'plot',
          arrayOk: true,
          min: 1,
          dflt: 30,
          
      },
  
      below: {
          valType: 'string',
          
          editType: 'plot',
          
      },
  
      text: scatterMapboxAttrs.text,
      hovertext: scatterMapboxAttrs.hovertext,
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['lon', 'lat', 'z', 'text', 'name']
      }),
      hovertemplate: hovertemplateAttrs(),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
  },
      colorScaleAttrs('', {
          cLetter: 'z',
          editTypeOverride: 'calc'
      })
  );
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../scattermapbox/attributes":1223}],1007:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  var _ = _dereq_('../../lib')._;
  
  module.exports = function calc(gd, trace) {
      var len = trace._length;
      var calcTrace = new Array(len);
      var z = trace.z;
      var hasZ = isArrayOrTypedArray(z) && z.length;
  
      for(var i = 0; i < len; i++) {
          var cdi = calcTrace[i] = {};
  
          var lon = trace.lon[i];
          var lat = trace.lat[i];
  
          cdi.lonlat = isNumeric(lon) && isNumeric(lat) ?
              [+lon, +lat] :
              [BADNUM, BADNUM];
  
          if(hasZ) {
              var zi = z[i];
              cdi.z = isNumeric(zi) ? zi : BADNUM;
          }
      }
  
      colorscaleCalc(gd, trace, {
          vals: hasZ ? z : [0, 1],
          containerStr: '',
          cLetter: 'z'
      });
  
      if(len) {
          calcTrace[0].t = {
              labels: {
                  lat: _(gd, 'lat:') + ' ',
                  lon: _(gd, 'lon:') + ' '
              }
          };
      }
  
      return calcTrace;
  };
  
  },{"../../components/colorscale/calc":623,"../../constants/numerical":725,"../../lib":750,"fast-isnumeric":241}],1008:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  var Colorscale = _dereq_('../../components/colorscale');
  
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  var makeBlank = _dereq_('../../lib/geojson_utils').makeBlank;
  
  module.exports = function convert(calcTrace) {
      var trace = calcTrace[0].trace;
      var isVisible = (trace.visible === true && trace._length !== 0);
  
      var heatmap = {
          layout: {visibility: 'none'},
          paint: {}
      };
  
      var opts = trace._opts = {
          heatmap: heatmap,
          geojson: makeBlank()
      };
  
      // early return if not visible or placeholder
      if(!isVisible) return opts;
  
      var features = [];
      var i;
  
      var z = trace.z;
      var radius = trace.radius;
      var hasZ = Lib.isArrayOrTypedArray(z) && z.length;
      var hasArrayRadius = Lib.isArrayOrTypedArray(radius);
  
      for(i = 0; i < calcTrace.length; i++) {
          var cdi = calcTrace[i];
          var lonlat = cdi.lonlat;
  
          if(lonlat[0] !== BADNUM) {
              var props = {};
  
              if(hasZ) {
                  var zi = cdi.z;
                  props.z = zi !== BADNUM ? zi : 0;
              }
              if(hasArrayRadius) {
                  props.r = (isNumeric(radius[i]) && radius[i] > 0) ? +radius[i] : 0;
              }
  
              features.push({
                  type: 'Feature',
                  geometry: {type: 'Point', coordinates: lonlat},
                  properties: props
              });
          }
      }
  
      var cOpts = Colorscale.extractOpts(trace);
      var scl = cOpts.reversescale ?
          Colorscale.flipScale(cOpts.colorscale) :
          cOpts.colorscale;
  
      // Add alpha channel to first colorscale step.
      // If not, we would essentially color the entire map.
      // See https://docs.mapbox.com/mapbox-gl-js/example/heatmap-layer/
      var scl01 = scl[0][1];
      var color0 = Color.opacity(scl01) < 1 ? scl01 : Color.addOpacity(scl01, 0);
  
      var heatmapColor = [
          'interpolate', ['linear'],
          ['heatmap-density'],
          0, color0
      ];
      for(i = 1; i < scl.length; i++) {
          heatmapColor.push(scl[i][0], scl[i][1]);
      }
  
      // Those "weights" have to be in [0, 1], we can do this either:
      // - as here using a mapbox-gl expression
      // - or, scale the 'z' property in the feature loop
      var zExp = [
          'interpolate', ['linear'],
          ['get', 'z'],
          cOpts.min, 0,
          cOpts.max, 1
      ];
  
      Lib.extendFlat(opts.heatmap.paint, {
          'heatmap-weight': hasZ ? zExp : 1 / (cOpts.max - cOpts.min),
  
          'heatmap-color': heatmapColor,
  
          'heatmap-radius': hasArrayRadius ?
              {type: 'identity', property: 'r'} :
              trace.radius,
  
          'heatmap-opacity': trace.opacity
      });
  
      opts.geojson = {type: 'FeatureCollection', features: features};
      opts.heatmap.layout.visibility = 'visible';
  
      return opts;
  };
  
  },{"../../components/color":615,"../../components/colorscale":627,"../../constants/numerical":725,"../../lib":750,"../../lib/geojson_utils":744,"fast-isnumeric":241}],1009:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var lon = coerce('lon') || [];
      var lat = coerce('lat') || [];
  
      var len = Math.min(lon.length, lat.length);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      traceOut._length = len;
  
      coerce('z');
      coerce('radius');
      coerce('below');
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"./attributes":1006}],1010:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt) {
      out.lon = pt.lon;
      out.lat = pt.lat;
      out.z = pt.z;
      return out;
  };
  
  },{}],1011:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var scatterMapboxHoverPoints = _dereq_('../scattermapbox/hover');
  
  module.exports = function hoverPoints(pointData, xval, yval) {
      var pts = scatterMapboxHoverPoints(pointData, xval, yval);
      if(!pts) return;
  
      var newPointData = pts[0];
      var cd = newPointData.cd;
      var trace = cd[0].trace;
      var di = cd[newPointData.index];
  
      // let Fx.hover pick the color
      delete newPointData.color;
  
      if('z' in di) {
          var ax = newPointData.subplot.mockAxis;
          newPointData.z = di.z;
          newPointData.zLabel = Axes.tickText(ax, ax.c2l(di.z), 'hover').text;
      }
  
      newPointData.extraText = getExtraText(trace, di, cd[0].t.labels);
  
      return [newPointData];
  };
  
  function getExtraText(trace, di, labels) {
      if(trace.hovertemplate) return;
  
      var hoverinfo = di.hi || trace.hoverinfo;
      var parts = hoverinfo.split('+');
      var isAll = parts.indexOf('all') !== -1;
      var hasLon = parts.indexOf('lon') !== -1;
      var hasLat = parts.indexOf('lat') !== -1;
      var lonlat = di.lonlat;
      var text = [];
  
      function format(v) {
          return v + '\u00B0';
      }
  
      if(isAll || (hasLon && hasLat)) {
          text.push('(' + format(lonlat[0]) + ', ' + format(lonlat[1]) + ')');
      } else if(hasLon) {
          text.push(labels.lon + format(lonlat[0]));
      } else if(hasLat) {
          text.push(labels.lat + format(lonlat[1]));
      }
  
      if(isAll || parts.indexOf('text') !== -1) {
          Lib.fillText(di, trace, text);
      }
  
      return text.join('<br>');
  }
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"../scattermapbox/hover":1228}],1012:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../heatmap/colorbar'),
      formatLabels: _dereq_('../scattermapbox/format_labels'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      hoverPoints: _dereq_('./hover'),
      eventData: _dereq_('./event_data'),
  
      getBelow: function(trace, subplot) {
          var mapLayers = subplot.getMapLayers();
  
          // find first layer with `type: 'symbol'`,
          // that is not a plotly layer
          for(var i = 0; i < mapLayers.length; i++) {
              var layer = mapLayers[i];
              var layerId = layer.id;
              if(layer.type === 'symbol' &&
                  typeof layerId === 'string' && layerId.indexOf('plotly-') === -1
              ) {
                  return layerId;
              }
          }
      },
  
      moduleType: 'trace',
      name: 'densitymapbox',
      basePlotModule: _dereq_('../../plots/mapbox'),
      categories: ['mapbox', 'gl', 'showLegend'],
      meta: {
          hr_name: 'density_mapbox',
          
      }
  };
  
  },{"../../plots/mapbox":856,"../heatmap/colorbar":1039,"../scattermapbox/format_labels":1227,"./attributes":1006,"./calc":1007,"./defaults":1009,"./event_data":1010,"./hover":1011,"./plot":1013}],1013:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var convert = _dereq_('./convert');
  var LAYER_PREFIX = _dereq_('../../plots/mapbox/constants').traceLayerPrefix;
  
  function DensityMapbox(subplot, uid) {
      this.type = 'densitymapbox';
      this.subplot = subplot;
      this.uid = uid;
  
      this.sourceId = 'source-' + uid;
  
      this.layerList = [
          ['heatmap', LAYER_PREFIX + uid + '-heatmap']
      ];
  
      // previous 'below' value,
      // need this to update it properly
      this.below = null;
  }
  
  var proto = DensityMapbox.prototype;
  
  proto.update = function(calcTrace) {
      var subplot = this.subplot;
      var layerList = this.layerList;
      var optsAll = convert(calcTrace);
      var below = subplot.belowLookup['trace-' + this.uid];
  
      subplot.map
          .getSource(this.sourceId)
          .setData(optsAll.geojson);
  
      if(below !== this.below) {
          this._removeLayers();
          this._addLayers(optsAll, below);
          this.below = below;
      }
  
      for(var i = 0; i < layerList.length; i++) {
          var item = layerList[i];
          var k = item[0];
          var id = item[1];
          var opts = optsAll[k];
  
          subplot.setOptions(id, 'setLayoutProperty', opts.layout);
  
          if(opts.layout.visibility === 'visible') {
              subplot.setOptions(id, 'setPaintProperty', opts.paint);
          }
      }
  };
  
  proto._addLayers = function(optsAll, below) {
      var subplot = this.subplot;
      var layerList = this.layerList;
      var sourceId = this.sourceId;
  
      for(var i = 0; i < layerList.length; i++) {
          var item = layerList[i];
          var k = item[0];
          var opts = optsAll[k];
  
          subplot.addLayer({
              type: k,
              id: item[1],
              source: sourceId,
              layout: opts.layout,
              paint: opts.paint
          }, below);
      }
  };
  
  proto._removeLayers = function() {
      var map = this.subplot.map;
      var layerList = this.layerList;
  
      for(var i = layerList.length - 1; i >= 0; i--) {
          map.removeLayer(layerList[i][1]);
      }
  };
  
  proto.dispose = function() {
      var map = this.subplot.map;
      this._removeLayers();
      map.removeSource(this.sourceId);
  };
  
  module.exports = function createDensityMapbox(subplot, calcTrace) {
      var trace = calcTrace[0].trace;
      var densityMapbox = new DensityMapbox(subplot, trace.uid);
      var sourceId = densityMapbox.sourceId;
      var optsAll = convert(calcTrace);
      var below = densityMapbox.below = subplot.belowLookup['trace-' + trace.uid];
  
      subplot.map.addSource(sourceId, {
          type: 'geojson',
          data: optsAll.geojson
      });
  
      densityMapbox._addLayers(optsAll, below);
  
      return densityMapbox;
  };
  
  },{"../../plots/mapbox/constants":854,"./convert":1008}],1014:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  // arrayOk attributes, merge them into calcdata array
  module.exports = function arraysToCalcdata(cd, trace) {
      for(var i = 0; i < cd.length; i++) cd[i].i = i;
  
      Lib.mergeArray(trace.text, cd, 'tx');
      Lib.mergeArray(trace.hovertext, cd, 'htx');
  
      var marker = trace.marker;
      if(marker) {
          Lib.mergeArray(marker.opacity, cd, 'mo');
          Lib.mergeArray(marker.color, cd, 'mc');
  
          var markerLine = marker.line;
          if(markerLine) {
              Lib.mergeArray(markerLine.color, cd, 'mlc');
              Lib.mergeArrayCastPositive(markerLine.width, cd, 'mlw');
          }
      }
  };
  
  },{"../../lib":750}],1015:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var barAttrs = _dereq_('../bar/attributes');
  var lineAttrs = _dereq_('../scatter/attributes').line;
  var baseAttrs = _dereq_('../../plots/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var constants = _dereq_('./constants');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var Color = _dereq_('../../components/color');
  
  module.exports = {
      x: barAttrs.x,
      x0: barAttrs.x0,
      dx: barAttrs.dx,
      y: barAttrs.y,
      y0: barAttrs.y0,
      dy: barAttrs.dy,
  
      xperiod: barAttrs.xperiod,
      yperiod: barAttrs.yperiod,
      xperiod0: barAttrs.xperiod0,
      yperiod0: barAttrs.yperiod0,
      xperiodalignment: barAttrs.xperiodalignment,
      yperiodalignment: barAttrs.yperiodalignment,
  
      hovertext: barAttrs.hovertext,
      hovertemplate: hovertemplateAttrs({}, {
          keys: constants.eventDataKeys
      }),
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['name', 'x', 'y', 'text', 'percent initial', 'percent previous', 'percent total']
      }),
  
      textinfo: {
          valType: 'flaglist',
          flags: ['label', 'text', 'percent initial', 'percent previous', 'percent total', 'value'],
          extras: ['none'],
          
          editType: 'plot',
          arrayOk: false,
          
      },
      // TODO: incorporate `label` and `value` in the eventData
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: constants.eventDataKeys.concat(['label', 'value'])
      }),
  
      text: barAttrs.text,
      textposition: extendFlat({}, barAttrs.textposition, {dflt: 'auto'}),
      insidetextanchor: extendFlat({}, barAttrs.insidetextanchor, {dflt: 'middle'}),
      textangle: extendFlat({}, barAttrs.textangle, {dflt: 0}),
      textfont: barAttrs.textfont,
      insidetextfont: barAttrs.insidetextfont,
      outsidetextfont: barAttrs.outsidetextfont,
      constraintext: barAttrs.constraintext,
      cliponaxis: barAttrs.cliponaxis,
  
      orientation: extendFlat({}, barAttrs.orientation, {
          
      }),
  
      offset: extendFlat({}, barAttrs.offset, {arrayOk: false}),
      width: extendFlat({}, barAttrs.width, {arrayOk: false}),
  
      marker: barAttrs.marker,
  
      connector: {
          fillcolor: {
              valType: 'color',
              
              editType: 'style',
              
          },
          line: {
              color: extendFlat({}, lineAttrs.color, {dflt: Color.defaultLine}),
              width: extendFlat({}, lineAttrs.width, {
                  dflt: 0,
                  editType: 'plot',
              }),
              dash: lineAttrs.dash,
              editType: 'style'
          },
          visible: {
              valType: 'boolean',
              dflt: true,
              
              editType: 'plot',
              
          },
          editType: 'plot'
      },
  
      offsetgroup: barAttrs.offsetgroup,
      alignmentgroup: barAttrs.alignmentgroup
  };
  
  },{"../../components/color":615,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../bar/attributes":892,"../scatter/attributes":1158,"./constants":1017}],1016:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  var arraysToCalcdata = _dereq_('./arrays_to_calcdata');
  var calcSelection = _dereq_('../scatter/calc_selection');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  module.exports = function calc(gd, trace) {
      var xa = Axes.getFromId(gd, trace.xaxis || 'x');
      var ya = Axes.getFromId(gd, trace.yaxis || 'y');
      var size, pos, origPos, i, cdi;
  
      var hasPeriod;
      if(trace.orientation === 'h') {
          size = xa.makeCalcdata(trace, 'x');
          origPos = ya.makeCalcdata(trace, 'y');
          pos = alignPeriod(trace, ya, 'y', origPos);
          hasPeriod = !!trace.yperiodalignment;
      } else {
          size = ya.makeCalcdata(trace, 'y');
          origPos = xa.makeCalcdata(trace, 'x');
          pos = alignPeriod(trace, xa, 'x', origPos);
          hasPeriod = !!trace.xperiodalignment;
      }
  
      // create the "calculated data" to plot
      var serieslen = Math.min(pos.length, size.length);
      var cd = new Array(serieslen);
  
      // Unlike other bar-like traces funnels do not support base attribute.
      // bases for funnels are computed internally in a way that
      // the mid-point of each bar are located on the axis line.
      trace._base = [];
  
      // set position and size
      for(i = 0; i < serieslen; i++) {
          // treat negative values as bad numbers
          if(size[i] < 0) size[i] = BADNUM;
  
          var connectToNext = false;
          if(size[i] !== BADNUM) {
              if(i + 1 < serieslen && size[i + 1] !== BADNUM) {
                  connectToNext = true;
              }
          }
  
          cdi = cd[i] = {
              p: pos[i],
              s: size[i],
              cNext: connectToNext
          };
  
          trace._base[i] = -0.5 * cdi.s;
  
          if(hasPeriod) {
              cd[i].orig_p = origPos[i]; // used by hover
          }
  
          if(trace.ids) {
              cdi.id = String(trace.ids[i]);
          }
  
          // calculate total values
          if(i === 0) cd[0].vTotal = 0;
          cd[0].vTotal += fixNum(cdi.s);
  
          // ratio from initial value
          cdi.begR = fixNum(cdi.s) / fixNum(cd[0].s);
      }
  
      var prevGoodNum;
      for(i = 0; i < serieslen; i++) {
          cdi = cd[i];
          if(cdi.s === BADNUM) continue;
  
          // ratio of total value
          cdi.sumR = cdi.s / cd[0].vTotal;
  
          // ratio of previous (good) value
          cdi.difR = (prevGoodNum !== undefined) ? cdi.s / prevGoodNum : 1;
  
          prevGoodNum = cdi.s;
      }
  
      arraysToCalcdata(cd, trace);
      calcSelection(cd, trace);
  
      return cd;
  };
  
  function fixNum(a) {
      return (a === BADNUM) ? 0 : a;
  }
  
  },{"../../constants/numerical":725,"../../plots/cartesian/align_period":796,"../../plots/cartesian/axes":799,"../scatter/calc_selection":1160,"./arrays_to_calcdata":1014}],1017:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      eventDataKeys: [
          'percentInitial',
          'percentPrevious',
          'percentTotal'
      ]
  };
  
  },{}],1018:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var setGroupPositions = _dereq_('../bar/cross_trace_calc').setGroupPositions;
  
  module.exports = function crossTraceCalc(gd, plotinfo) {
      var fullLayout = gd._fullLayout;
      var fullData = gd._fullData;
      var calcdata = gd.calcdata;
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
      var funnels = [];
      var funnelsVert = [];
      var funnelsHorz = [];
      var cd, i;
  
      for(i = 0; i < fullData.length; i++) {
          var fullTrace = fullData[i];
          var isHorizontal = (fullTrace.orientation === 'h');
  
          if(
              fullTrace.visible === true &&
              fullTrace.xaxis === xa._id &&
              fullTrace.yaxis === ya._id &&
              fullTrace.type === 'funnel'
          ) {
              cd = calcdata[i];
  
              if(isHorizontal) {
                  funnelsHorz.push(cd);
              } else {
                  funnelsVert.push(cd);
              }
  
              funnels.push(cd);
          }
      }
  
      var opts = {
          mode: fullLayout.funnelmode,
          norm: fullLayout.funnelnorm,
          gap: fullLayout.funnelgap,
          groupgap: fullLayout.funnelgroupgap
      };
  
      setGroupPositions(gd, xa, ya, funnelsVert, opts);
      setGroupPositions(gd, ya, xa, funnelsHorz, opts);
  
      for(i = 0; i < funnels.length; i++) {
          cd = funnels[i];
  
          for(var j = 0; j < cd.length; j++) {
              if(j + 1 < cd.length) {
                  cd[j].nextP0 = cd[j + 1].p0;
                  cd[j].nextS0 = cd[j + 1].s0;
  
                  cd[j].nextP1 = cd[j + 1].p1;
                  cd[j].nextS1 = cd[j + 1].s1;
              }
          }
      }
  };
  
  },{"../bar/cross_trace_calc":895}],1019:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleGroupingDefaults = _dereq_('../bar/defaults').handleGroupingDefaults;
  var handleText = _dereq_('../bar/defaults').handleText;
  var handleXYDefaults = _dereq_('../scatter/xy_defaults');
  var handlePeriodDefaults = _dereq_('../scatter/period_defaults');
  var attributes = _dereq_('./attributes');
  var Color = _dereq_('../../components/color');
  
  function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  
      coerce('orientation', (traceOut.y && !traceOut.x) ? 'v' : 'h');
      coerce('offset');
      coerce('width');
  
      var text = coerce('text');
  
      coerce('hovertext');
      coerce('hovertemplate');
  
      var textposition = coerce('textposition');
      handleText(traceIn, traceOut, layout, coerce, textposition, {
          moduleHasSelected: false,
          moduleHasUnselected: false,
          moduleHasConstrain: true,
          moduleHasCliponaxis: true,
          moduleHasTextangle: true,
          moduleHasInsideanchor: true
      });
  
      if(traceOut.textposition !== 'none' && !traceOut.texttemplate) {
          coerce('textinfo', Array.isArray(text) ? 'text+value' : 'value');
      }
  
      var markerColor = coerce('marker.color', defaultColor);
      coerce('marker.line.color', Color.defaultLine);
      coerce('marker.line.width');
  
      var connectorVisible = coerce('connector.visible');
      if(connectorVisible) {
          coerce('connector.fillcolor', defaultFillColor(markerColor));
  
          var connectorLineWidth = coerce('connector.line.width');
          if(connectorLineWidth) {
              coerce('connector.line.color');
              coerce('connector.line.dash');
          }
      }
  }
  
  function defaultFillColor(markerColor) {
      var cBase = Lib.isArrayOrTypedArray(markerColor) ? '#000' : markerColor;
  
      return Color.addOpacity(cBase, 0.5 * Color.opacity(cBase));
  }
  
  function crossTraceDefaults(fullData, fullLayout) {
      var traceIn, traceOut;
  
      function coerce(attr) {
          return Lib.coerce(traceOut._input, traceOut, attributes, attr);
      }
  
      if(fullLayout.funnelmode === 'group') {
          for(var i = 0; i < fullData.length; i++) {
              traceOut = fullData[i];
              traceIn = traceOut._input;
  
              handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
          }
      }
  }
  
  module.exports = {
      supplyDefaults: supplyDefaults,
      crossTraceDefaults: crossTraceDefaults
  };
  
  },{"../../components/color":615,"../../lib":750,"../bar/defaults":896,"../scatter/period_defaults":1178,"../scatter/xy_defaults":1185,"./attributes":1015}],1020:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt /* , trace, cd, pointNumber */) {
      // standard cartesian event data
      out.x = 'xVal' in pt ? pt.xVal : pt.x;
      out.y = 'yVal' in pt ? pt.yVal : pt.y;
  
      // for funnel
      if('percentInitial' in pt) out.percentInitial = pt.percentInitial;
      if('percentPrevious' in pt) out.percentPrevious = pt.percentPrevious;
      if('percentTotal' in pt) out.percentTotal = pt.percentTotal;
  
      if(pt.xa) out.xaxis = pt.xa;
      if(pt.ya) out.yaxis = pt.ya;
  
      return out;
  };
  
  },{}],1021:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var opacity = _dereq_('../../components/color').opacity;
  var hoverOnBars = _dereq_('../bar/hover').hoverOnBars;
  var formatPercent = _dereq_('../../lib').formatPercent;
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
      var point = hoverOnBars(pointData, xval, yval, hovermode);
      if(!point) return;
  
      var cd = point.cd;
      var trace = cd[0].trace;
      var isHorizontal = (trace.orientation === 'h');
  
      // the closest data point
      var index = point.index;
      var di = cd[index];
  
      var sizeLetter = isHorizontal ? 'x' : 'y';
      point[sizeLetter + 'LabelVal'] = di.s;
  
      point.percentInitial = di.begR;
      point.percentInitialLabel = formatPercent(di.begR, 1);
  
      point.percentPrevious = di.difR;
      point.percentPreviousLabel = formatPercent(di.difR, 1);
  
      point.percentTotal = di.sumR;
      point.percentTotalLabel = formatPercent(di.sumR, 1);
  
      var hoverinfo = di.hi || trace.hoverinfo;
      var text = [];
      if(hoverinfo && hoverinfo !== 'none' && hoverinfo !== 'skip') {
          var isAll = (hoverinfo === 'all');
          var parts = hoverinfo.split('+');
  
          var hasFlag = function(flag) { return isAll || parts.indexOf(flag) !== -1; };
  
          if(hasFlag('percent initial')) {
              text.push(point.percentInitialLabel + ' of initial');
          }
          if(hasFlag('percent previous')) {
              text.push(point.percentPreviousLabel + ' of previous');
          }
          if(hasFlag('percent total')) {
              text.push(point.percentTotalLabel + ' of total');
          }
      }
      point.extraText = text.join('<br>');
  
      point.color = getTraceColor(trace, di);
  
      return [point];
  };
  
  function getTraceColor(trace, di) {
      var cont = trace.marker;
      var mc = di.mc || cont.color;
      var mlc = di.mlc || cont.line.color;
      var mlw = di.mlw || cont.line.width;
      if(opacity(mc)) return mc;
      else if(opacity(mlc) && mlw) return mlc;
  }
  
  },{"../../components/color":615,"../../lib":750,"../bar/hover":899}],1022:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyDefaults: _dereq_('./defaults').supplyDefaults,
      crossTraceDefaults: _dereq_('./defaults').crossTraceDefaults,
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
      calc: _dereq_('./calc'),
      crossTraceCalc: _dereq_('./cross_trace_calc'),
      plot: _dereq_('./plot'),
      style: _dereq_('./style').style,
      hoverPoints: _dereq_('./hover'),
      eventData: _dereq_('./event_data'),
  
      selectPoints: _dereq_('../bar/select'),
  
      moduleType: 'trace',
      name: 'funnel',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['bar-like', 'cartesian', 'svg', 'oriented', 'showLegend', 'zoomScale'],
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"../bar/select":904,"./attributes":1015,"./calc":1016,"./cross_trace_calc":1018,"./defaults":1019,"./event_data":1020,"./hover":1021,"./layout_attributes":1023,"./layout_defaults":1024,"./plot":1025,"./style":1026}],1023:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      funnelmode: {
          valType: 'enumerated',
          values: ['stack', 'group', 'overlay'],
          dflt: 'stack',
          
          editType: 'calc',
          
      },
      funnelgap: {
          valType: 'number',
          min: 0,
          max: 1,
          
          editType: 'calc',
          
      },
      funnelgroupgap: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 0,
          
          editType: 'calc',
          
      }
  };
  
  },{}],1024:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  module.exports = function(layoutIn, layoutOut, fullData) {
      var hasTraceType = false;
  
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
  
      for(var i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
  
          if(trace.visible && trace.type === 'funnel') {
              hasTraceType = true;
              break;
          }
      }
  
      if(hasTraceType) {
          coerce('funnelmode');
          coerce('funnelgap', 0.2);
          coerce('funnelgroupgap');
      }
  };
  
  },{"../../lib":750,"./layout_attributes":1023}],1025:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  var barPlot = _dereq_('../bar/plot');
  var clearMinTextSize = _dereq_('../bar/uniform_text').clearMinTextSize;
  
  module.exports = function plot(gd, plotinfo, cdModule, traceLayer) {
      var fullLayout = gd._fullLayout;
  
      clearMinTextSize('funnel', fullLayout);
  
      plotConnectorRegions(gd, plotinfo, cdModule, traceLayer);
      plotConnectorLines(gd, plotinfo, cdModule, traceLayer);
  
      barPlot.plot(gd, plotinfo, cdModule, traceLayer, {
          mode: fullLayout.funnelmode,
          norm: fullLayout.funnelmode,
          gap: fullLayout.funnelgap,
          groupgap: fullLayout.funnelgroupgap
      });
  };
  
  function plotConnectorRegions(gd, plotinfo, cdModule, traceLayer) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function(cd) {
          var plotGroup = d3.select(this);
          var trace = cd[0].trace;
  
          var group = Lib.ensureSingle(plotGroup, 'g', 'regions');
  
          if(!trace.connector || !trace.connector.visible) {
              group.remove();
              return;
          }
  
          var isHorizontal = (trace.orientation === 'h');
  
          var connectors = group.selectAll('g.region').data(Lib.identity);
  
          connectors.enter().append('g')
              .classed('region', true);
  
          connectors.exit().remove();
  
          var len = connectors.size();
  
          connectors.each(function(di, i) {
              // don't draw lines between nulls
              if(i !== len - 1 && !di.cNext) return;
  
              var xy = getXY(di, xa, ya, isHorizontal);
              var x = xy[0];
              var y = xy[1];
  
              var shape = '';
  
              if(
                  x[0] !== BADNUM && y[0] !== BADNUM &&
                  x[1] !== BADNUM && y[1] !== BADNUM &&
                  x[2] !== BADNUM && y[2] !== BADNUM &&
                  x[3] !== BADNUM && y[3] !== BADNUM
              ) {
                  if(isHorizontal) {
                      shape += 'M' + x[0] + ',' + y[1] + 'L' + x[2] + ',' + y[2] + 'H' + x[3] + 'L' + x[1] + ',' + y[1] + 'Z';
                  } else {
                      shape += 'M' + x[1] + ',' + y[1] + 'L' + x[2] + ',' + y[3] + 'V' + y[2] + 'L' + x[1] + ',' + y[0] + 'Z';
                  }
              }
  
              if(shape === '') shape = 'M0,0Z';
  
              Lib.ensureSingle(d3.select(this), 'path')
                  .attr('d', shape)
                  .call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
          });
      });
  }
  
  function plotConnectorLines(gd, plotinfo, cdModule, traceLayer) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function(cd) {
          var plotGroup = d3.select(this);
          var trace = cd[0].trace;
  
          var group = Lib.ensureSingle(plotGroup, 'g', 'lines');
  
          if(!trace.connector || !trace.connector.visible || !trace.connector.line.width) {
              group.remove();
              return;
          }
  
          var isHorizontal = (trace.orientation === 'h');
  
          var connectors = group.selectAll('g.line').data(Lib.identity);
  
          connectors.enter().append('g')
              .classed('line', true);
  
          connectors.exit().remove();
  
          var len = connectors.size();
  
          connectors.each(function(di, i) {
              // don't draw lines between nulls
              if(i !== len - 1 && !di.cNext) return;
  
              var xy = getXY(di, xa, ya, isHorizontal);
              var x = xy[0];
              var y = xy[1];
  
              var shape = '';
  
              if(x[3] !== undefined && y[3] !== undefined) {
                  if(isHorizontal) {
                      shape += 'M' + x[0] + ',' + y[1] + 'L' + x[2] + ',' + y[2];
                      shape += 'M' + x[1] + ',' + y[1] + 'L' + x[3] + ',' + y[2];
                  } else {
                      shape += 'M' + x[1] + ',' + y[1] + 'L' + x[2] + ',' + y[3];
                      shape += 'M' + x[1] + ',' + y[0] + 'L' + x[2] + ',' + y[2];
                  }
              }
  
              if(shape === '') shape = 'M0,0Z';
  
              Lib.ensureSingle(d3.select(this), 'path')
                  .attr('d', shape)
                  .call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
          });
      });
  }
  
  function getXY(di, xa, ya, isHorizontal) {
      var s = [];
      var p = [];
  
      var sAxis = isHorizontal ? xa : ya;
      var pAxis = isHorizontal ? ya : xa;
  
      s[0] = sAxis.c2p(di.s0, true);
      p[0] = pAxis.c2p(di.p0, true);
  
      s[1] = sAxis.c2p(di.s1, true);
      p[1] = pAxis.c2p(di.p1, true);
  
      s[2] = sAxis.c2p(di.nextS0, true);
      p[2] = pAxis.c2p(di.nextP0, true);
  
      s[3] = sAxis.c2p(di.nextS1, true);
      p[3] = pAxis.c2p(di.nextP1, true);
  
      return isHorizontal ? [s, p] : [p, s];
  }
  
  },{"../../components/drawing":637,"../../constants/numerical":725,"../../lib":750,"../bar/plot":903,"../bar/uniform_text":908,"d3":169}],1026:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Drawing = _dereq_('../../components/drawing');
  var Color = _dereq_('../../components/color');
  var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
  var barStyle = _dereq_('../bar/style');
  var resizeText = _dereq_('../bar/uniform_text').resizeText;
  var styleTextPoints = barStyle.styleTextPoints;
  
  function style(gd, cd, sel) {
      var s = sel ? sel : d3.select(gd).selectAll('g.funnellayer').selectAll('g.trace');
      resizeText(gd, s, 'funnel');
  
      s.style('opacity', function(d) { return d[0].trace.opacity; });
  
      s.each(function(d) {
          var gTrace = d3.select(this);
          var trace = d[0].trace;
  
          gTrace.selectAll('.point > path').each(function(di) {
              if(!di.isBlank) {
                  var cont = trace.marker;
  
                  d3.select(this)
                      .call(Color.fill, di.mc || cont.color)
                      .call(Color.stroke, di.mlc || cont.line.color)
                      .call(Drawing.dashLine, cont.line.dash, di.mlw || cont.line.width)
                      .style('opacity', trace.selectedpoints && !di.selected ? DESELECTDIM : 1);
              }
          });
  
          styleTextPoints(gTrace, trace, gd);
  
          gTrace.selectAll('.regions').each(function() {
              d3.select(this).selectAll('path').style('stroke-width', 0).call(Color.fill, trace.connector.fillcolor);
          });
  
          gTrace.selectAll('.lines').each(function() {
              var cont = trace.connector.line;
  
              Drawing.lineGroupStyle(
                  d3.select(this).selectAll('path'),
                  cont.width,
                  cont.color,
                  cont.dash
              );
          });
      });
  }
  
  module.exports = {
      style: style
  };
  
  },{"../../components/color":615,"../../components/drawing":637,"../../constants/interactions":724,"../bar/style":906,"../bar/uniform_text":908,"d3":169}],1027:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var pieAttrs = _dereq_('../pie/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = {
      labels: pieAttrs.labels,
      // equivalent of x0 and dx, if label is missing
      label0: pieAttrs.label0,
      dlabel: pieAttrs.dlabel,
      values: pieAttrs.values,
  
      marker: {
          colors: pieAttrs.marker.colors,
          line: {
              color: extendFlat({}, pieAttrs.marker.line.color, {
                  dflt: null,
                  
              }),
              width: extendFlat({}, pieAttrs.marker.line.width, {dflt: 1}),
              editType: 'calc'
          },
          editType: 'calc'
      },
  
      text: pieAttrs.text,
      hovertext: pieAttrs.hovertext,
  
      scalegroup: extendFlat({}, pieAttrs.scalegroup, {
          
      }),
  
      textinfo: extendFlat({}, pieAttrs.textinfo, {
          flags: ['label', 'text', 'value', 'percent']
      }),
  
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: ['label', 'color', 'value', 'text', 'percent']
      }),
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['label', 'text', 'value', 'percent', 'name']
      }),
  
      hovertemplate: hovertemplateAttrs({}, {
          keys: ['label', 'color', 'value', 'text', 'percent']
      }),
  
      textposition: extendFlat({}, pieAttrs.textposition, {
          values: ['inside', 'none'],
          dflt: 'inside'
      }),
  
      textfont: pieAttrs.textfont,
      insidetextfont: pieAttrs.insidetextfont,
  
      title: {
          text: pieAttrs.title.text,
          font: pieAttrs.title.font,
          position: extendFlat({}, pieAttrs.title.position, {
              values: ['top left', 'top center', 'top right'],
              dflt: 'top center'
          }),
          editType: 'plot'
      },
  
      domain: domainAttrs({name: 'funnelarea', trace: true, editType: 'calc'}),
  
      aspectratio: {
          valType: 'number',
          
          min: 0,
          dflt: 1,
          editType: 'plot',
          
      },
  
      baseratio: {
          valType: 'number',
          
          min: 0,
          max: 1,
          dflt: 0.333,
          editType: 'plot',
          
      }
  };
  
  },{"../../lib/extend":740,"../../plots/attributes":795,"../../plots/domain":826,"../../plots/template_attributes":877,"../pie/attributes":1132}],1028:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var plots = _dereq_('../../plots/plots');
  
  exports.name = 'funnelarea';
  
  exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
      plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
  };
  
  },{"../../plots/plots":862}],1029:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var pieCalc = _dereq_('../pie/calc');
  
  function calc(gd, trace) {
      return pieCalc.calc(gd, trace);
  }
  
  function crossTraceCalc(gd) {
      pieCalc.crossTraceCalc(gd, { type: 'funnelarea' });
  }
  
  module.exports = {
      calc: calc,
      crossTraceCalc: crossTraceCalc
  };
  
  },{"../pie/calc":1134}],1030:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
  var handleText = _dereq_('../bar/defaults').handleText;
  var handleLabelsAndValues = _dereq_('../pie/defaults').handleLabelsAndValues;
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var labels = coerce('labels');
      var values = coerce('values');
  
      var res = handleLabelsAndValues(labels, values);
      var len = res.len;
      traceOut._hasLabels = res.hasLabels;
      traceOut._hasValues = res.hasValues;
  
      if(!traceOut._hasLabels &&
          traceOut._hasValues
      ) {
          coerce('label0');
          coerce('dlabel');
      }
  
      if(!len) {
          traceOut.visible = false;
          return;
      }
      traceOut._length = len;
  
      var lineWidth = coerce('marker.line.width');
      if(lineWidth) coerce('marker.line.color', layout.paper_bgcolor);
  
      coerce('marker.colors');
  
      coerce('scalegroup');
  
      var textData = coerce('text');
      var textTemplate = coerce('texttemplate');
      var textInfo;
      if(!textTemplate) textInfo = coerce('textinfo', Array.isArray(textData) ? 'text+percent' : 'percent');
  
      coerce('hovertext');
      coerce('hovertemplate');
  
      if(textTemplate || (textInfo && textInfo !== 'none')) {
          var textposition = coerce('textposition');
          handleText(traceIn, traceOut, layout, coerce, textposition, {
              moduleHasSelected: false,
              moduleHasUnselected: false,
              moduleHasConstrain: false,
              moduleHasCliponaxis: false,
              moduleHasTextangle: false,
              moduleHasInsideanchor: false
          });
      }
  
      handleDomainDefaults(traceOut, layout, coerce);
  
      var title = coerce('title.text');
      if(title) {
          coerce('title.position');
          Lib.coerceFont(coerce, 'title.font', layout.font);
      }
  
      coerce('aspectratio');
      coerce('baseratio');
  };
  
  },{"../../lib":750,"../../plots/domain":826,"../bar/defaults":896,"../pie/defaults":1135,"./attributes":1027}],1031:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'funnelarea',
      basePlotModule: _dereq_('./base_plot'),
      categories: ['pie-like', 'funnelarea', 'showLegend'],
  
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyDefaults: _dereq_('./defaults'),
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
  
      calc: _dereq_('./calc').calc,
      crossTraceCalc: _dereq_('./calc').crossTraceCalc,
  
      plot: _dereq_('./plot'),
      style: _dereq_('./style'),
      styleOne: _dereq_('../pie/style_one'),
  
      meta: {
          
      }
  };
  
  },{"../pie/style_one":1143,"./attributes":1027,"./base_plot":1028,"./calc":1029,"./defaults":1030,"./layout_attributes":1032,"./layout_defaults":1033,"./plot":1034,"./style":1035}],1032:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hiddenlabels = _dereq_('../pie/layout_attributes').hiddenlabels;
  
  module.exports = {
      hiddenlabels: hiddenlabels,
  
      funnelareacolorway: {
          valType: 'colorlist',
          
          editType: 'calc',
          
      },
      extendfunnelareacolors: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          
      }
  };
  
  },{"../pie/layout_attributes":1139}],1033:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var layoutAttributes = _dereq_('./layout_attributes');
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
  
      coerce('hiddenlabels');
      coerce('funnelareacolorway', layoutOut.colorway);
      coerce('extendfunnelareacolors');
  };
  
  },{"../../lib":750,"./layout_attributes":1032}],1034:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Drawing = _dereq_('../../components/drawing');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  
  var barPlot = _dereq_('../bar/plot');
  var toMoveInsideBar = barPlot.toMoveInsideBar;
  var uniformText = _dereq_('../bar/uniform_text');
  var recordMinTextSize = uniformText.recordMinTextSize;
  var clearMinTextSize = uniformText.clearMinTextSize;
  var pieHelpers = _dereq_('../pie/helpers');
  var piePlot = _dereq_('../pie/plot');
  
  var attachFxHandlers = piePlot.attachFxHandlers;
  var determineInsideTextFont = piePlot.determineInsideTextFont;
  
  var layoutAreas = piePlot.layoutAreas;
  var prerenderTitles = piePlot.prerenderTitles;
  var positionTitleOutside = piePlot.positionTitleOutside;
  var formatSliceLabel = piePlot.formatSliceLabel;
  
  module.exports = function plot(gd, cdModule) {
      var fullLayout = gd._fullLayout;
  
      clearMinTextSize('funnelarea', fullLayout);
  
      prerenderTitles(cdModule, gd);
      layoutAreas(cdModule, fullLayout._size);
  
      Lib.makeTraceGroups(fullLayout._funnelarealayer, cdModule, 'trace').each(function(cd) {
          var plotGroup = d3.select(this);
          var cd0 = cd[0];
          var trace = cd0.trace;
  
          setCoords(cd);
  
          plotGroup.each(function() {
              var slices = d3.select(this).selectAll('g.slice').data(cd);
  
              slices.enter().append('g')
                  .classed('slice', true);
              slices.exit().remove();
  
              slices.each(function(pt, i) {
                  if(pt.hidden) {
                      d3.select(this).selectAll('path,g').remove();
                      return;
                  }
  
                  // to have consistent event data compared to other traces
                  pt.pointNumber = pt.i;
                  pt.curveNumber = trace.index;
  
                  var cx = cd0.cx;
                  var cy = cd0.cy;
                  var sliceTop = d3.select(this);
                  var slicePath = sliceTop.selectAll('path.surface').data([pt]);
  
                  slicePath.enter().append('path')
                      .classed('surface', true)
                      .style({'pointer-events': 'all'});
  
                  sliceTop.call(attachFxHandlers, gd, cd);
  
                  var shape =
                      'M' + (cx + pt.TR[0]) + ',' + (cy + pt.TR[1]) +
                      line(pt.TR, pt.BR) +
                      line(pt.BR, pt.BL) +
                      line(pt.BL, pt.TL) +
                      'Z';
  
                  slicePath.attr('d', shape);
  
                  // add text
                  formatSliceLabel(gd, pt, cd0);
                  var textPosition = pieHelpers.castOption(trace.textposition, pt.pts);
                  var sliceTextGroup = sliceTop.selectAll('g.slicetext')
                      .data(pt.text && (textPosition !== 'none') ? [0] : []);
  
                  sliceTextGroup.enter().append('g')
                      .classed('slicetext', true);
                  sliceTextGroup.exit().remove();
  
                  sliceTextGroup.each(function() {
                      var sliceText = Lib.ensureSingle(d3.select(this), 'text', '', function(s) {
                          // prohibit tex interpretation until we can handle
                          // tex and regular text together
                          s.attr('data-notex', 1);
                      });
  
                      var font = Lib.ensureUniformFontSize(gd, determineInsideTextFont(trace, pt, fullLayout.font));
  
                      sliceText.text(pt.text)
                          .attr({
                              'class': 'slicetext',
                              transform: '',
                              'text-anchor': 'middle'
                          })
                          .call(Drawing.font, font)
                          .call(svgTextUtils.convertToTspans, gd);
  
                      // position the text relative to the slice
                      var textBB = Drawing.bBox(sliceText.node());
                      var transform;
  
                      var x0, x1;
                      var y0 = Math.min(pt.BL[1], pt.BR[1]) + cy;
                      var y1 = Math.max(pt.TL[1], pt.TR[1]) + cy;
  
                      x0 = Math.max(pt.TL[0], pt.BL[0]) + cx;
                      x1 = Math.min(pt.TR[0], pt.BR[0]) + cx;
  
                      transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
                          isHorizontal: true,
                          constrained: true,
                          angle: 0,
                          anchor: 'middle'
                      });
  
                      transform.fontSize = font.size;
                      recordMinTextSize(trace.type, transform, fullLayout);
                      cd[i].transform = transform;
  
                      sliceText.attr('transform', Lib.getTextTransform(transform));
                  });
              });
  
              // add the title
              var titleTextGroup = d3.select(this).selectAll('g.titletext')
                  .data(trace.title.text ? [0] : []);
  
              titleTextGroup.enter().append('g')
                  .classed('titletext', true);
              titleTextGroup.exit().remove();
  
              titleTextGroup.each(function() {
                  var titleText = Lib.ensureSingle(d3.select(this), 'text', '', function(s) {
                      // prohibit tex interpretation as above
                      s.attr('data-notex', 1);
                  });
  
                  var txt = trace.title.text;
                  if(trace._meta) {
                      txt = Lib.templateString(txt, trace._meta);
                  }
  
                  titleText.text(txt)
                      .attr({
                          'class': 'titletext',
                          transform: '',
                          'text-anchor': 'middle',
                      })
                  .call(Drawing.font, trace.title.font)
                  .call(svgTextUtils.convertToTspans, gd);
  
                  var transform = positionTitleOutside(cd0, fullLayout._size);
  
                  titleText.attr('transform',
                      'translate(' + transform.x + ',' + transform.y + ')' +
                      (transform.scale < 1 ? ('scale(' + transform.scale + ')') : '') +
                      'translate(' + transform.tx + ',' + transform.ty + ')');
              });
          });
      });
  };
  
  function line(a, b) {
      var dx = b[0] - a[0];
      var dy = b[1] - a[1];
  
      return 'l' + dx + ',' + dy;
  }
  
  function getBetween(a, b) {
      return [
          0.5 * (a[0] + b[0]),
          0.5 * (a[1] + b[1])
      ];
  }
  
  function setCoords(cd) {
      if(!cd.length) return;
  
      var cd0 = cd[0];
      var trace = cd0.trace;
  
      var aspectratio = trace.aspectratio;
  
      var h = trace.baseratio;
      if(h > 0.999) h = 0.999; // TODO: may handle this case separately
      var h2 = Math.pow(h, 2);
  
      var v1 = cd0.vTotal;
      var v0 = v1 * h2 / (1 - h2);
  
      var totalValues = v1;
      var sumSteps = v0 / v1;
  
      function calcPos() {
          var q = Math.sqrt(sumSteps);
          return {
              x: q,
              y: -q
          };
      }
  
      function getPoint() {
          var pos = calcPos();
          return [pos.x, pos.y];
      }
  
      var p;
      var allPoints = [];
      allPoints.push(getPoint());
  
      var i, cdi;
      for(i = cd.length - 1; i > -1; i--) {
          cdi = cd[i];
          if(cdi.hidden) continue;
  
          var step = cdi.v / totalValues;
          sumSteps += step;
  
          allPoints.push(getPoint());
      }
  
      var minY = Infinity;
      var maxY = -Infinity;
      for(i = 0; i < allPoints.length; i++) {
          p = allPoints[i];
          minY = Math.min(minY, p[1]);
          maxY = Math.max(maxY, p[1]);
      }
  
      // center the shape
      for(i = 0; i < allPoints.length; i++) {
          allPoints[i][1] -= (maxY + minY) / 2;
      }
  
      var lastX = allPoints[allPoints.length - 1][0];
  
      // get pie r
      var r = cd0.r;
  
      var rY = (maxY - minY) / 2;
      var scaleX = r / lastX;
      var scaleY = r / rY * aspectratio;
  
      // set funnelarea r
      cd0.r = scaleY * rY;
  
      // scale the shape
      for(i = 0; i < allPoints.length; i++) {
          allPoints[i][0] *= scaleX;
          allPoints[i][1] *= scaleY;
      }
  
      // record first position
      p = allPoints[0];
      var prevLeft = [-p[0], p[1]];
      var prevRight = [p[0], p[1]];
  
      var n = 0; // note we skip the very first point.
      for(i = cd.length - 1; i > -1; i--) {
          cdi = cd[i];
          if(cdi.hidden) continue;
  
          n += 1;
          var x = allPoints[n][0];
          var y = allPoints[n][1];
  
          cdi.TL = [-x, y];
          cdi.TR = [x, y];
  
          cdi.BL = prevLeft;
          cdi.BR = prevRight;
  
          cdi.pxmid = getBetween(cdi.TR, cdi.BR);
  
          prevLeft = cdi.TL;
          prevRight = cdi.TR;
      }
  }
  
  },{"../../components/drawing":637,"../../lib":750,"../../lib/svg_text_utils":774,"../bar/plot":903,"../bar/uniform_text":908,"../pie/helpers":1137,"../pie/plot":1141,"d3":169}],1035:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var styleOne = _dereq_('../pie/style_one');
  var resizeText = _dereq_('../bar/uniform_text').resizeText;
  
  module.exports = function style(gd) {
      var s = gd._fullLayout._funnelarealayer.selectAll('.trace');
      resizeText(gd, s, 'funnelarea');
  
      s.each(function(cd) {
          var cd0 = cd[0];
          var trace = cd0.trace;
          var traceSelection = d3.select(this);
  
          traceSelection.style({opacity: trace.opacity});
  
          traceSelection.selectAll('path.surface').each(function(pt) {
              d3.select(this).call(styleOne, pt, trace);
          });
      });
  };
  
  },{"../bar/uniform_text":908,"../pie/style_one":1143,"d3":169}],1036:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterAttrs = _dereq_('../scatter/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = extendFlat({
      z: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      x: extendFlat({}, scatterAttrs.x, {impliedEdits: {xtype: 'array'}}),
      x0: extendFlat({}, scatterAttrs.x0, {impliedEdits: {xtype: 'scaled'}}),
      dx: extendFlat({}, scatterAttrs.dx, {impliedEdits: {xtype: 'scaled'}}),
      y: extendFlat({}, scatterAttrs.y, {impliedEdits: {ytype: 'array'}}),
      y0: extendFlat({}, scatterAttrs.y0, {impliedEdits: {ytype: 'scaled'}}),
      dy: extendFlat({}, scatterAttrs.dy, {impliedEdits: {ytype: 'scaled'}}),
  
      xperiod: extendFlat({}, scatterAttrs.xperiod, {impliedEdits: {xtype: 'scaled'}}),
      yperiod: extendFlat({}, scatterAttrs.yperiod, {impliedEdits: {ytype: 'scaled'}}),
      xperiod0: extendFlat({}, scatterAttrs.xperiod0, {impliedEdits: {xtype: 'scaled'}}),
      yperiod0: extendFlat({}, scatterAttrs.yperiod0, {impliedEdits: {ytype: 'scaled'}}),
      xperiodalignment: extendFlat({}, scatterAttrs.xperiodalignment, {impliedEdits: {xtype: 'scaled'}}),
      yperiodalignment: extendFlat({}, scatterAttrs.yperiodalignment, {impliedEdits: {ytype: 'scaled'}}),
  
      text: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      hovertext: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      transpose: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'calc',
          
      },
      xtype: {
          valType: 'enumerated',
          values: ['array', 'scaled'],
          
          editType: 'calc+clearAxisTypes',
          
      },
      ytype: {
          valType: 'enumerated',
          values: ['array', 'scaled'],
          
          editType: 'calc+clearAxisTypes',
          
      },
      zsmooth: {
          valType: 'enumerated',
          values: ['fast', 'best', false],
          dflt: false,
          
          editType: 'calc',
          
      },
      hoverongaps: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'none',
          
      },
      connectgaps: {
          valType: 'boolean',
          
          editType: 'calc',
          
      },
      xgap: {
          valType: 'number',
          dflt: 0,
          min: 0,
          
          editType: 'plot',
          
      },
      ygap: {
          valType: 'number',
          dflt: 0,
          min: 0,
          
          editType: 'plot',
          
      },
      zhoverformat: {
          valType: 'string',
          dflt: '',
          
          editType: 'none',
          
      },
      hovertemplate: hovertemplateAttrs(),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
  }, {
      transforms: undefined
  },
      colorScaleAttrs('', {cLetter: 'z', autoColorDflt: false})
  );
  
  },{"../../components/colorscale/attributes":622,"../../constants/docs":720,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../scatter/attributes":1158}],1037:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  
  var histogram2dCalc = _dereq_('../histogram2d/calc');
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  var convertColumnData = _dereq_('./convert_column_xyz');
  var clean2dArray = _dereq_('./clean_2d_array');
  var interp2d = _dereq_('./interp2d');
  var findEmpties = _dereq_('./find_empties');
  var makeBoundArray = _dereq_('./make_bound_array');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  module.exports = function calc(gd, trace) {
      // prepare the raw data
      // run makeCalcdata on x and y even for heatmaps, in case of category mappings
      var xa = Axes.getFromId(gd, trace.xaxis || 'x');
      var ya = Axes.getFromId(gd, trace.yaxis || 'y');
      var isContour = Registry.traceIs(trace, 'contour');
      var isHist = Registry.traceIs(trace, 'histogram');
      var isGL2D = Registry.traceIs(trace, 'gl2d');
      var zsmooth = isContour ? 'best' : trace.zsmooth;
      var x, x0, dx, origX;
      var y, y0, dy, origY;
      var z, i, binned;
  
      // cancel minimum tick spacings (only applies to bars and boxes)
      xa._minDtick = 0;
      ya._minDtick = 0;
  
      if(isHist) {
          binned = histogram2dCalc(gd, trace);
          origX = binned.orig_x;
          x = binned.x;
          x0 = binned.x0;
          dx = binned.dx;
  
          origY = binned.orig_y;
          y = binned.y;
          y0 = binned.y0;
          dy = binned.dy;
  
          z = binned.z;
      } else {
          var zIn = trace.z;
          if(Lib.isArray1D(zIn)) {
              convertColumnData(trace, xa, ya, 'x', 'y', ['z']);
              x = trace._x;
              y = trace._y;
              zIn = trace._z;
          } else {
              origX = trace.x ? xa.makeCalcdata(trace, 'x') : [];
              origY = trace.y ? ya.makeCalcdata(trace, 'y') : [];
              x = alignPeriod(trace, xa, 'x', origX);
              y = alignPeriod(trace, ya, 'y', origY);
              trace._x = x;
              trace._y = y;
          }
  
          x0 = trace.x0;
          dx = trace.dx;
          y0 = trace.y0;
          dy = trace.dy;
  
          z = clean2dArray(zIn, trace, xa, ya);
      }
  
      if(xa.rangebreaks || ya.rangebreaks) {
          z = dropZonBreaks(x, y, z);
  
          if(!isHist) {
              x = skipBreaks(x);
              y = skipBreaks(y);
  
              trace._x = x;
              trace._y = y;
          }
      }
  
      if(!isHist && (isContour || trace.connectgaps)) {
          trace._emptypoints = findEmpties(z);
          interp2d(z, trace._emptypoints);
      }
  
      function noZsmooth(msg) {
          zsmooth = trace._input.zsmooth = trace.zsmooth = false;
          Lib.warn('cannot use zsmooth: "fast": ' + msg);
      }
  
      // check whether we really can smooth (ie all boxes are about the same size)
      if(zsmooth === 'fast') {
          if(xa.type === 'log' || ya.type === 'log') {
              noZsmooth('log axis found');
          } else if(!isHist) {
              if(x.length) {
                  var avgdx = (x[x.length - 1] - x[0]) / (x.length - 1);
                  var maxErrX = Math.abs(avgdx / 100);
                  for(i = 0; i < x.length - 1; i++) {
                      if(Math.abs(x[i + 1] - x[i] - avgdx) > maxErrX) {
                          noZsmooth('x scale is not linear');
                          break;
                      }
                  }
              }
              if(y.length && zsmooth === 'fast') {
                  var avgdy = (y[y.length - 1] - y[0]) / (y.length - 1);
                  var maxErrY = Math.abs(avgdy / 100);
                  for(i = 0; i < y.length - 1; i++) {
                      if(Math.abs(y[i + 1] - y[i] - avgdy) > maxErrY) {
                          noZsmooth('y scale is not linear');
                          break;
                      }
                  }
              }
          }
      }
  
      // create arrays of brick boundaries, to be used by autorange and heatmap.plot
      var xlen = Lib.maxRowLength(z);
      var xIn = trace.xtype === 'scaled' ? '' : x;
      var xArray = makeBoundArray(trace, xIn, x0, dx, xlen, xa);
      var yIn = trace.ytype === 'scaled' ? '' : y;
      var yArray = makeBoundArray(trace, yIn, y0, dy, z.length, ya);
  
      // handled in gl2d convert step
      if(!isGL2D) {
          trace._extremes[xa._id] = Axes.findExtremes(xa, xArray);
          trace._extremes[ya._id] = Axes.findExtremes(ya, yArray);
      }
  
      var cd0 = {
          x: xArray,
          y: yArray,
          z: z,
          text: trace._text || trace.text,
          hovertext: trace._hovertext || trace.hovertext
      };
  
      if(trace.xperiodalignment && origX) {
          cd0.orig_x = origX;
      }
      if(trace.yperiodalignment && origY) {
          cd0.orig_y = origY;
      }
  
      if(xIn && xIn.length === xArray.length - 1) cd0.xCenter = xIn;
      if(yIn && yIn.length === yArray.length - 1) cd0.yCenter = yIn;
  
      if(isHist) {
          cd0.xRanges = binned.xRanges;
          cd0.yRanges = binned.yRanges;
          cd0.pts = binned.pts;
      }
  
      if(!isContour) {
          colorscaleCalc(gd, trace, {vals: z, cLetter: 'z'});
      }
  
      if(isContour && trace.contours && trace.contours.coloring === 'heatmap') {
          var dummyTrace = {
              type: trace.type === 'contour' ? 'heatmap' : 'histogram2d',
              xcalendar: trace.xcalendar,
              ycalendar: trace.ycalendar
          };
          cd0.xfill = makeBoundArray(dummyTrace, xIn, x0, dx, xlen, xa);
          cd0.yfill = makeBoundArray(dummyTrace, yIn, y0, dy, z.length, ya);
      }
  
      return [cd0];
  };
  
  function skipBreaks(a) {
      var b = [];
      var len = a.length;
      for(var i = 0; i < len; i++) {
          var v = a[i];
          if(v !== BADNUM) b.push(v);
      }
      return b;
  }
  
  function dropZonBreaks(x, y, z) {
      var newZ = [];
      var k = -1;
      for(var i = 0; i < z.length; i++) {
          if(y[i] === BADNUM) continue;
          k++;
          newZ[k] = [];
          for(var j = 0; j < z[i].length; j++) {
              if(x[j] === BADNUM) continue;
  
              newZ[k].push(z[i][j]);
          }
      }
      return newZ;
  }
  
  },{"../../components/colorscale/calc":623,"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/align_period":796,"../../plots/cartesian/axes":799,"../../registry":882,"../histogram2d/calc":1069,"./clean_2d_array":1038,"./convert_column_xyz":1040,"./find_empties":1042,"./interp2d":1045,"./make_bound_array":1046}],1038:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var Lib = _dereq_('../../lib');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  module.exports = function clean2dArray(zOld, trace, xa, ya) {
      var rowlen, collen, getCollen, old2new, i, j;
  
      function cleanZvalue(v) {
          if(!isNumeric(v)) return undefined;
          return +v;
      }
  
      if(trace && trace.transpose) {
          rowlen = 0;
          for(i = 0; i < zOld.length; i++) rowlen = Math.max(rowlen, zOld[i].length);
          if(rowlen === 0) return false;
          getCollen = function(zOld) { return zOld.length; };
          old2new = function(zOld, i, j) { return (zOld[j] || [])[i]; };
      } else {
          rowlen = zOld.length;
          getCollen = function(zOld, i) { return zOld[i].length; };
          old2new = function(zOld, i, j) { return (zOld[i] || [])[j]; };
      }
  
      var padOld2new = function(zOld, i, j) {
          if(i === BADNUM || j === BADNUM) return BADNUM;
          return old2new(zOld, i, j);
      };
  
      function axisMapping(ax) {
          if(trace && trace.type !== 'carpet' && trace.type !== 'contourcarpet' &&
              ax && ax.type === 'category' && trace['_' + ax._id.charAt(0)].length) {
              var axLetter = ax._id.charAt(0);
              var axMapping = {};
              var traceCategories = trace['_' + axLetter + 'CategoryMap'] || trace[axLetter];
              for(i = 0; i < traceCategories.length; i++) {
                  axMapping[traceCategories[i]] = i;
              }
              return function(i) {
                  var ind = axMapping[ax._categories[i]];
                  return ind + 1 ? ind : BADNUM;
              };
          } else {
              return Lib.identity;
          }
      }
  
      var xMap = axisMapping(xa);
      var yMap = axisMapping(ya);
  
      if(ya && ya.type === 'category') rowlen = ya._categories.length;
      var zNew = new Array(rowlen);
  
      for(i = 0; i < rowlen; i++) {
          if(xa && xa.type === 'category') {
              collen = xa._categories.length;
          } else {
              collen = getCollen(zOld, i);
          }
          zNew[i] = new Array(collen);
          for(j = 0; j < collen; j++) zNew[i][j] = cleanZvalue(padOld2new(zOld, yMap(i), xMap(j)));
      }
  
      return zNew;
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"fast-isnumeric":241}],1039:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      min: 'zmin',
      max: 'zmax'
  };
  
  },{}],1040:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  
  module.exports = function convertColumnData(trace, ax1, ax2, var1Name, var2Name, arrayVarNames) {
      var colLen = trace._length;
      var col1 = ax1.makeCalcdata(trace, var1Name);
      var col2 = ax2.makeCalcdata(trace, var2Name);
      col1 = alignPeriod(trace, ax1, var1Name, col1);
      col2 = alignPeriod(trace, ax2, var2Name, col2);
  
      var textCol = trace.text;
      var hasColumnText = (textCol !== undefined && Lib.isArray1D(textCol));
      var hoverTextCol = trace.hovertext;
      var hasColumnHoverText = (hoverTextCol !== undefined && Lib.isArray1D(hoverTextCol));
      var i, j;
  
      var col1dv = Lib.distinctVals(col1);
      var col1vals = col1dv.vals;
      var col2dv = Lib.distinctVals(col2);
      var col2vals = col2dv.vals;
      var newArrays = [];
      var text;
      var hovertext;
  
      var nI = col2vals.length;
      var nJ = col1vals.length;
  
      for(i = 0; i < arrayVarNames.length; i++) {
          newArrays[i] = Lib.init2dArray(nI, nJ);
      }
  
      if(hasColumnText) {
          text = Lib.init2dArray(nI, nJ);
      }
      if(hasColumnHoverText) {
          hovertext = Lib.init2dArray(nI, nJ);
      }
  
      var after2before = Lib.init2dArray(nI, nJ);
  
      for(i = 0; i < colLen; i++) {
          if(col1[i] !== BADNUM && col2[i] !== BADNUM) {
              var i1 = Lib.findBin(col1[i] + col1dv.minDiff / 2, col1vals);
              var i2 = Lib.findBin(col2[i] + col2dv.minDiff / 2, col2vals);
  
              for(j = 0; j < arrayVarNames.length; j++) {
                  var arrayVarName = arrayVarNames[j];
                  var arrayVar = trace[arrayVarName];
                  var newArray = newArrays[j];
                  newArray[i2][i1] = arrayVar[i];
                  after2before[i2][i1] = i;
              }
  
              if(hasColumnText) text[i2][i1] = textCol[i];
              if(hasColumnHoverText) hovertext[i2][i1] = hoverTextCol[i];
          }
      }
  
      trace['_' + var1Name] = col1vals;
      trace['_' + var2Name] = col2vals;
      for(j = 0; j < arrayVarNames.length; j++) {
          trace['_' + arrayVarNames[j]] = newArrays[j];
      }
      if(hasColumnText) trace._text = text;
      if(hasColumnHoverText) trace._hovertext = hovertext;
  
      if(ax1 && ax1.type === 'category') {
          trace['_' + var1Name + 'CategoryMap'] = col1vals.map(function(v) { return ax1._categories[v];});
      }
  
      if(ax2 && ax2.type === 'category') {
          trace['_' + var2Name + 'CategoryMap'] = col2vals.map(function(v) { return ax2._categories[v];});
      }
  
      trace._after2before = after2before;
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/align_period":796}],1041:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleXYZDefaults = _dereq_('./xyz_defaults');
  var handlePeriodDefaults = _dereq_('../scatter/period_defaults');
  var handleStyleDefaults = _dereq_('./style_defaults');
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var validData = handleXYZDefaults(traceIn, traceOut, coerce, layout);
      if(!validData) {
          traceOut.visible = false;
          return;
      }
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      handleStyleDefaults(traceIn, traceOut, coerce, layout);
  
      coerce('hoverongaps');
      coerce('connectgaps', Lib.isArray1D(traceOut.z) && (traceOut.zsmooth !== false));
  
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"../scatter/period_defaults":1178,"./attributes":1036,"./style_defaults":1049,"./xyz_defaults":1050}],1042:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var maxRowLength = _dereq_('../../lib').maxRowLength;
  
  /* Return a list of empty points in 2D array z
   * each empty point z[i][j] gives an array [i, j, neighborCount]
   * neighborCount is the count of 4 nearest neighbors that DO exist
   * this is to give us an order of points to evaluate for interpolation.
   * if no neighbors exist, we iteratively look for neighbors that HAVE
   * neighbors, and add a fractional neighborCount
   */
  module.exports = function findEmpties(z) {
      var empties = [];
      var neighborHash = {};
      var noNeighborList = [];
      var nextRow = z[0];
      var row = [];
      var blank = [0, 0, 0];
      var rowLength = maxRowLength(z);
      var prevRow;
      var i;
      var j;
      var thisPt;
      var p;
      var neighborCount;
      var newNeighborHash;
      var foundNewNeighbors;
  
      for(i = 0; i < z.length; i++) {
          prevRow = row;
          row = nextRow;
          nextRow = z[i + 1] || [];
          for(j = 0; j < rowLength; j++) {
              if(row[j] === undefined) {
                  neighborCount = (row[j - 1] !== undefined ? 1 : 0) +
                      (row[j + 1] !== undefined ? 1 : 0) +
                      (prevRow[j] !== undefined ? 1 : 0) +
                      (nextRow[j] !== undefined ? 1 : 0);
  
                  if(neighborCount) {
                      // for this purpose, don't count off-the-edge points
                      // as undefined neighbors
                      if(i === 0) neighborCount++;
                      if(j === 0) neighborCount++;
                      if(i === z.length - 1) neighborCount++;
                      if(j === row.length - 1) neighborCount++;
  
                      // if all neighbors that could exist do, we don't
                      // need this for finding farther neighbors
                      if(neighborCount < 4) {
                          neighborHash[[i, j]] = [i, j, neighborCount];
                      }
  
                      empties.push([i, j, neighborCount]);
                  } else noNeighborList.push([i, j]);
              }
          }
      }
  
      while(noNeighborList.length) {
          newNeighborHash = {};
          foundNewNeighbors = false;
  
          // look for cells that now have neighbors but didn't before
          for(p = noNeighborList.length - 1; p >= 0; p--) {
              thisPt = noNeighborList[p];
              i = thisPt[0];
              j = thisPt[1];
  
              neighborCount = ((neighborHash[[i - 1, j]] || blank)[2] +
                  (neighborHash[[i + 1, j]] || blank)[2] +
                  (neighborHash[[i, j - 1]] || blank)[2] +
                  (neighborHash[[i, j + 1]] || blank)[2]) / 20;
  
              if(neighborCount) {
                  newNeighborHash[thisPt] = [i, j, neighborCount];
                  noNeighborList.splice(p, 1);
                  foundNewNeighbors = true;
              }
          }
  
          if(!foundNewNeighbors) {
              throw 'findEmpties iterated with no new neighbors';
          }
  
          // put these new cells into the main neighbor list
          for(thisPt in newNeighborHash) {
              neighborHash[thisPt] = newNeighborHash[thisPt];
              empties.push(newNeighborHash[thisPt]);
          }
      }
  
      // sort the full list in descending order of neighbor count
      return empties.sort(function(a, b) { return b[2] - a[2]; });
  };
  
  },{"../../lib":750}],1043:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Fx = _dereq_('../../components/fx');
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var extractOpts = _dereq_('../../components/colorscale').extractOpts;
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode, hoverLayer, contour) {
      var cd0 = pointData.cd[0];
      var trace = cd0.trace;
      var xa = pointData.xa;
      var ya = pointData.ya;
      var x = cd0.x;
      var y = cd0.y;
      var z = cd0.z;
      var xc = cd0.xCenter;
      var yc = cd0.yCenter;
      var zmask = cd0.zmask;
      var zhoverformat = trace.zhoverformat;
      var x2 = x;
      var y2 = y;
  
      var xl, yl, nx, ny;
  
      if(pointData.index !== false) {
          try {
              nx = Math.round(pointData.index[1]);
              ny = Math.round(pointData.index[0]);
          } catch(e) {
              Lib.error('Error hovering on heatmap, ' +
                  'pointNumber must be [row,col], found:', pointData.index);
              return;
          }
          if(nx < 0 || nx >= z[0].length || ny < 0 || ny > z.length) {
              return;
          }
      } else if(Fx.inbox(xval - x[0], xval - x[x.length - 1], 0) > 0 ||
              Fx.inbox(yval - y[0], yval - y[y.length - 1], 0) > 0) {
          return;
      } else {
          if(contour) {
              var i2;
              x2 = [2 * x[0] - x[1]];
  
              for(i2 = 1; i2 < x.length; i2++) {
                  x2.push((x[i2] + x[i2 - 1]) / 2);
              }
              x2.push([2 * x[x.length - 1] - x[x.length - 2]]);
  
              y2 = [2 * y[0] - y[1]];
              for(i2 = 1; i2 < y.length; i2++) {
                  y2.push((y[i2] + y[i2 - 1]) / 2);
              }
              y2.push([2 * y[y.length - 1] - y[y.length - 2]]);
          }
          nx = Math.max(0, Math.min(x2.length - 2, Lib.findBin(xval, x2)));
          ny = Math.max(0, Math.min(y2.length - 2, Lib.findBin(yval, y2)));
      }
  
      var x0 = xa.c2p(x[nx]);
      var x1 = xa.c2p(x[nx + 1]);
      var y0 = ya.c2p(y[ny]);
      var y1 = ya.c2p(y[ny + 1]);
  
      var _x, _y;
      if(contour) {
          _x = cd0.orig_x || x;
          _y = cd0.orig_y || y;
  
          x1 = x0;
          xl = _x[nx];
          y1 = y0;
          yl = _y[ny];
      } else {
          _x = cd0.orig_x || xc || x;
          _y = cd0.orig_y || yc || y;
  
          xl = xc ? _x[nx] : ((_x[nx] + _x[nx + 1]) / 2);
          yl = yc ? _y[ny] : ((_y[ny] + _y[ny + 1]) / 2);
  
          if(xa && xa.type === 'category') xl = x[nx];
          if(ya && ya.type === 'category') yl = y[ny];
  
          if(trace.zsmooth) {
              x0 = x1 = xa.c2p(xl);
              y0 = y1 = ya.c2p(yl);
          }
      }
  
      var zVal = z[ny][nx];
      if(zmask && !zmask[ny][nx]) zVal = undefined;
  
      if(zVal === undefined && !trace.hoverongaps) return;
  
      var text;
      if(Array.isArray(cd0.hovertext) && Array.isArray(cd0.hovertext[ny])) {
          text = cd0.hovertext[ny][nx];
      } else if(Array.isArray(cd0.text) && Array.isArray(cd0.text[ny])) {
          text = cd0.text[ny][nx];
      }
  
      // dummy axis for formatting the z value
      var cOpts = extractOpts(trace);
      var dummyAx = {
          type: 'linear',
          range: [cOpts.min, cOpts.max],
          hoverformat: zhoverformat,
          _separators: xa._separators,
          _numFormat: xa._numFormat
      };
      var zLabel = Axes.tickText(dummyAx, zVal, 'hover').text;
  
      return [Lib.extendFlat(pointData, {
          index: trace._after2before ? trace._after2before[ny][nx] : [ny, nx],
          // never let a 2D override 1D type as closest point
          distance: pointData.maxHoverDistance,
          spikeDistance: pointData.maxSpikeDistance,
          x0: x0,
          x1: x1,
          y0: y0,
          y1: y1,
          xLabelVal: xl,
          yLabelVal: yl,
          zLabelVal: zVal,
          zLabel: zLabel,
          text: text
      })];
  };
  
  },{"../../components/colorscale":627,"../../components/fx":655,"../../lib":750,"../../plots/cartesian/axes":799}],1044:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      colorbar: _dereq_('./colorbar'),
      style: _dereq_('./style'),
      hoverPoints: _dereq_('./hover'),
  
      moduleType: 'trace',
      name: 'heatmap',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', '2dMap', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"./attributes":1036,"./calc":1037,"./colorbar":1039,"./defaults":1041,"./hover":1043,"./plot":1047,"./style":1048}],1045:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var INTERPTHRESHOLD = 1e-2;
  var NEIGHBORSHIFTS = [[-1, 0], [1, 0], [0, -1], [0, 1]];
  
  function correctionOvershoot(maxFractionalChange) {
      // start with less overshoot, until we know it's converging,
      // then ramp up the overshoot for faster convergence
      return 0.5 - 0.25 * Math.min(1, maxFractionalChange * 0.5);
  }
  
  /*
   * interp2d: Fill in missing data from a 2D array using an iterative
   *   poisson equation solver with zero-derivative BC at edges.
   *   Amazingly, this just amounts to repeatedly averaging all the existing
   *   nearest neighbors, at least if we don't take x/y scaling into account,
   *   which is the right approach here where x and y may not even have the
   *   same units.
   *
   * @param {array of arrays} z
   *      The 2D array to fill in. Will be mutated here. Assumed to already be
   *      cleaned, so all entries are numbers except gaps, which are `undefined`.
   * @param {array of arrays} emptyPoints
   *      Each entry [i, j, neighborCount] for empty points z[i][j] and the number
   *      of neighbors that are *not* missing. Assumed to be sorted from most to
   *      least neighbors, as produced by heatmap/find_empties.
   */
  module.exports = function interp2d(z, emptyPoints) {
      var maxFractionalChange = 1;
      var i;
  
      // one pass to fill in a starting value for all the empties
      iterateInterp2d(z, emptyPoints);
  
      // we're don't need to iterate lone empties - remove them
      for(i = 0; i < emptyPoints.length; i++) {
          if(emptyPoints[i][2] < 4) break;
      }
      // but don't remove these points from the original array,
      // we'll use them for masking, so make a copy.
      emptyPoints = emptyPoints.slice(i);
  
      for(i = 0; i < 100 && maxFractionalChange > INTERPTHRESHOLD; i++) {
          maxFractionalChange = iterateInterp2d(z, emptyPoints,
              correctionOvershoot(maxFractionalChange));
      }
      if(maxFractionalChange > INTERPTHRESHOLD) {
          Lib.log('interp2d didn\'t converge quickly', maxFractionalChange);
      }
  
      return z;
  };
  
  function iterateInterp2d(z, emptyPoints, overshoot) {
      var maxFractionalChange = 0;
      var thisPt;
      var i;
      var j;
      var p;
      var q;
      var neighborShift;
      var neighborRow;
      var neighborVal;
      var neighborCount;
      var neighborSum;
      var initialVal;
      var minNeighbor;
      var maxNeighbor;
  
      for(p = 0; p < emptyPoints.length; p++) {
          thisPt = emptyPoints[p];
          i = thisPt[0];
          j = thisPt[1];
          initialVal = z[i][j];
          neighborSum = 0;
          neighborCount = 0;
  
          for(q = 0; q < 4; q++) {
              neighborShift = NEIGHBORSHIFTS[q];
              neighborRow = z[i + neighborShift[0]];
              if(!neighborRow) continue;
              neighborVal = neighborRow[j + neighborShift[1]];
              if(neighborVal !== undefined) {
                  if(neighborSum === 0) {
                      minNeighbor = maxNeighbor = neighborVal;
                  } else {
                      minNeighbor = Math.min(minNeighbor, neighborVal);
                      maxNeighbor = Math.max(maxNeighbor, neighborVal);
                  }
                  neighborCount++;
                  neighborSum += neighborVal;
              }
          }
  
          if(neighborCount === 0) {
              throw 'iterateInterp2d order is wrong: no defined neighbors';
          }
  
          // this is the laplace equation interpolation:
          // each point is just the average of its neighbors
          // note that this ignores differential x/y scaling
          // which I think is the right approach, since we
          // don't know what that scaling means
          z[i][j] = neighborSum / neighborCount;
  
          if(initialVal === undefined) {
              if(neighborCount < 4) maxFractionalChange = 1;
          } else {
              // we can make large empty regions converge faster
              // if we overshoot the change vs the previous value
              z[i][j] = (1 + overshoot) * z[i][j] - overshoot * initialVal;
  
              if(maxNeighbor > minNeighbor) {
                  maxFractionalChange = Math.max(maxFractionalChange,
                      Math.abs(z[i][j] - initialVal) / (maxNeighbor - minNeighbor));
              }
          }
      }
  
      return maxFractionalChange;
  }
  
  },{"../../lib":750}],1046:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  
  module.exports = function makeBoundArray(trace, arrayIn, v0In, dvIn, numbricks, ax) {
      var arrayOut = [];
      var isContour = Registry.traceIs(trace, 'contour');
      var isHist = Registry.traceIs(trace, 'histogram');
      var isGL2D = Registry.traceIs(trace, 'gl2d');
      var v0;
      var dv;
      var i;
  
      var isArrayOfTwoItemsOrMore = isArrayOrTypedArray(arrayIn) && arrayIn.length > 1;
  
      if(isArrayOfTwoItemsOrMore && !isHist && (ax.type !== 'category')) {
          var len = arrayIn.length;
  
          // given vals are brick centers
          // hopefully length === numbricks, but use this method even if too few are supplied
          // and extend it linearly based on the last two points
          if(len <= numbricks) {
              // contour plots only want the centers
              if(isContour || isGL2D) arrayOut = arrayIn.slice(0, numbricks);
              else if(numbricks === 1) {
                  arrayOut = [arrayIn[0] - 0.5, arrayIn[0] + 0.5];
              } else {
                  arrayOut = [1.5 * arrayIn[0] - 0.5 * arrayIn[1]];
  
                  for(i = 1; i < len; i++) {
                      arrayOut.push((arrayIn[i - 1] + arrayIn[i]) * 0.5);
                  }
  
                  arrayOut.push(1.5 * arrayIn[len - 1] - 0.5 * arrayIn[len - 2]);
              }
  
              if(len < numbricks) {
                  var lastPt = arrayOut[arrayOut.length - 1];
                  var delta = lastPt - arrayOut[arrayOut.length - 2];
  
                  for(i = len; i < numbricks; i++) {
                      lastPt += delta;
                      arrayOut.push(lastPt);
                  }
              }
          } else {
              // hopefully length === numbricks+1, but do something regardless:
              // given vals are brick boundaries
              return isContour ?
                  arrayIn.slice(0, numbricks) :  // we must be strict for contours
                  arrayIn.slice(0, numbricks + 1);
          }
      } else {
          var calendar = trace[ax._id.charAt(0) + 'calendar'];
  
          if(isHist) {
              v0 = ax.r2c(v0In, 0, calendar);
          } else {
              if(isArrayOrTypedArray(arrayIn) && arrayIn.length === 1) {
                  v0 = arrayIn[0];
              } else if(v0In === undefined) {
                  v0 = 0;
              } else {
                  var fn = ax.type === 'log' ? ax.d2c : ax.r2c;
                  v0 = fn(v0In, 0, calendar);
              }
          }
  
          dv = dvIn || 1;
  
          for(i = (isContour || isGL2D) ? 0 : -0.5; i < numbricks; i++) {
              arrayOut.push(v0 + dv * i);
          }
      }
  
      return arrayOut;
  };
  
  },{"../../lib":750,"../../registry":882}],1047:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var tinycolor = _dereq_('tinycolor2');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var makeColorScaleFuncFromTrace = _dereq_('../../components/colorscale').makeColorScaleFuncFromTrace;
  var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
  
  module.exports = function(gd, plotinfo, cdheatmaps, heatmapLayer) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      Lib.makeTraceGroups(heatmapLayer, cdheatmaps, 'hm').each(function(cd) {
          var plotGroup = d3.select(this);
          var cd0 = cd[0];
          var trace = cd0.trace;
  
          var z = cd0.z;
          var x = cd0.x;
          var y = cd0.y;
          var xc = cd0.xCenter;
          var yc = cd0.yCenter;
          var isContour = Registry.traceIs(trace, 'contour');
          var zsmooth = isContour ? 'best' : trace.zsmooth;
  
          // get z dims
          var m = z.length;
          var n = Lib.maxRowLength(z);
          var xrev = false;
          var yrev = false;
  
          var left, right, temp, top, bottom, i;
  
          // TODO: if there are multiple overlapping categorical heatmaps,
          // or if we allow category sorting, then the categories may not be
          // sequential... may need to reorder and/or expand z
  
          // Get edges of png in pixels (xa.c2p() maps axes coordinates to pixel coordinates)
          // figure out if either axis is reversed (y is usually reversed, in pixel coords)
          // also clip the image to maximum 50% outside the visible plot area
          // bigger image lets you pan more naturally, but slows performance.
          // TODO: use low-resolution images outside the visible plot for panning
          // these while loops find the first and last brick bounds that are defined
          // (in case of log of a negative)
          i = 0;
          while(left === undefined && i < x.length - 1) {
              left = xa.c2p(x[i]);
              i++;
          }
          i = x.length - 1;
          while(right === undefined && i > 0) {
              right = xa.c2p(x[i]);
              i--;
          }
  
          if(right < left) {
              temp = right;
              right = left;
              left = temp;
              xrev = true;
          }
  
          i = 0;
          while(top === undefined && i < y.length - 1) {
              top = ya.c2p(y[i]);
              i++;
          }
          i = y.length - 1;
          while(bottom === undefined && i > 0) {
              bottom = ya.c2p(y[i]);
              i--;
          }
  
          if(bottom < top) {
              temp = top;
              top = bottom;
              bottom = temp;
              yrev = true;
          }
  
          // for contours with heatmap fill, we generate the boundaries based on
          // brick centers but then use the brick edges for drawing the bricks
          if(isContour) {
              xc = x;
              yc = y;
              x = cd0.xfill;
              y = cd0.yfill;
          }
  
          // make an image that goes at most half a screen off either side, to keep
          // time reasonable when you zoom in. if zsmooth is true/fast, don't worry
          // about this, because zooming doesn't increase number of pixels
          // if zsmooth is best, don't include anything off screen because it takes too long
          if(zsmooth !== 'fast') {
              var extra = zsmooth === 'best' ? 0 : 0.5;
              left = Math.max(-extra * xa._length, left);
              right = Math.min((1 + extra) * xa._length, right);
              top = Math.max(-extra * ya._length, top);
              bottom = Math.min((1 + extra) * ya._length, bottom);
          }
  
          var imageWidth = Math.round(right - left);
          var imageHeight = Math.round(bottom - top);
  
          // setup image nodes
  
          // if image is entirely off-screen, don't even draw it
          var isOffScreen = (imageWidth <= 0 || imageHeight <= 0);
  
          if(isOffScreen) {
              var noImage = plotGroup.selectAll('image').data([]);
              noImage.exit().remove();
              return;
          }
  
          // generate image data
  
          var canvasW, canvasH;
          if(zsmooth === 'fast') {
              canvasW = n;
              canvasH = m;
          } else {
              canvasW = imageWidth;
              canvasH = imageHeight;
          }
  
          var canvas = document.createElement('canvas');
          canvas.width = canvasW;
          canvas.height = canvasH;
          var context = canvas.getContext('2d');
  
          var sclFunc = makeColorScaleFuncFromTrace(trace, {noNumericCheck: true, returnArray: true});
  
          // map brick boundaries to image pixels
          var xpx,
              ypx;
          if(zsmooth === 'fast') {
              xpx = xrev ?
                  function(index) { return n - 1 - index; } :
                  Lib.identity;
              ypx = yrev ?
                  function(index) { return m - 1 - index; } :
                  Lib.identity;
          } else {
              xpx = function(index) {
                  return Lib.constrain(Math.round(xa.c2p(x[index]) - left),
                      0, imageWidth);
              };
              ypx = function(index) {
                  return Lib.constrain(Math.round(ya.c2p(y[index]) - top),
                      0, imageHeight);
              };
          }
  
          // build the pixel map brick-by-brick
          // cruise through z-matrix row-by-row
          // build a brick at each z-matrix value
          var yi = ypx(0);
          var yb = [yi, yi];
          var xbi = xrev ? 0 : 1;
          var ybi = yrev ? 0 : 1;
          // for collecting an average luminosity of the heatmap
          var pixcount = 0;
          var rcount = 0;
          var gcount = 0;
          var bcount = 0;
  
          var xb, j, xi, v, row, c;
  
          function setColor(v, pixsize) {
              if(v !== undefined) {
                  var c = sclFunc(v);
                  c[0] = Math.round(c[0]);
                  c[1] = Math.round(c[1]);
                  c[2] = Math.round(c[2]);
  
                  pixcount += pixsize;
                  rcount += c[0] * pixsize;
                  gcount += c[1] * pixsize;
                  bcount += c[2] * pixsize;
                  return c;
              }
              return [0, 0, 0, 0];
          }
  
          function interpColor(r0, r1, xinterp, yinterp) {
              var z00 = r0[xinterp.bin0];
              if(z00 === undefined) return setColor(undefined, 1);
  
              var z01 = r0[xinterp.bin1];
              var z10 = r1[xinterp.bin0];
              var z11 = r1[xinterp.bin1];
              var dx = (z01 - z00) || 0;
              var dy = (z10 - z00) || 0;
              var dxy;
  
              // the bilinear interpolation term needs different calculations
              // for all the different permutations of missing data
              // among the neighbors of the main point, to ensure
              // continuity across brick boundaries.
              if(z01 === undefined) {
                  if(z11 === undefined) dxy = 0;
                  else if(z10 === undefined) dxy = 2 * (z11 - z00);
                  else dxy = (2 * z11 - z10 - z00) * 2 / 3;
              } else if(z11 === undefined) {
                  if(z10 === undefined) dxy = 0;
                  else dxy = (2 * z00 - z01 - z10) * 2 / 3;
              } else if(z10 === undefined) dxy = (2 * z11 - z01 - z00) * 2 / 3;
              else dxy = (z11 + z00 - z01 - z10);
  
              return setColor(z00 + xinterp.frac * dx + yinterp.frac * (dy + xinterp.frac * dxy));
          }
  
          if(zsmooth) { // best or fast, works fastest with imageData
              var pxIndex = 0;
              var pixels;
  
              try {
                  pixels = new Uint8Array(imageWidth * imageHeight * 4);
              } catch(e) {
                  pixels = new Array(imageWidth * imageHeight * 4);
              }
  
              if(zsmooth === 'best') {
                  var xForPx = xc || x;
                  var yForPx = yc || y;
                  var xPixArray = new Array(xForPx.length);
                  var yPixArray = new Array(yForPx.length);
                  var xinterpArray = new Array(imageWidth);
                  var findInterpX = xc ? findInterpFromCenters : findInterp;
                  var findInterpY = yc ? findInterpFromCenters : findInterp;
                  var yinterp, r0, r1;
  
                  // first make arrays of x and y pixel locations of brick boundaries
                  for(i = 0; i < xForPx.length; i++) xPixArray[i] = Math.round(xa.c2p(xForPx[i]) - left);
                  for(i = 0; i < yForPx.length; i++) yPixArray[i] = Math.round(ya.c2p(yForPx[i]) - top);
  
                  // then make arrays of interpolations
                  // (bin0=closest, bin1=next, frac=fractional dist.)
                  for(i = 0; i < imageWidth; i++) xinterpArray[i] = findInterpX(i, xPixArray);
  
                  // now do the interpolations and fill the png
                  for(j = 0; j < imageHeight; j++) {
                      yinterp = findInterpY(j, yPixArray);
                      r0 = z[yinterp.bin0];
                      r1 = z[yinterp.bin1];
                      for(i = 0; i < imageWidth; i++, pxIndex += 4) {
                          c = interpColor(r0, r1, xinterpArray[i], yinterp);
                          putColor(pixels, pxIndex, c);
                      }
                  }
              } else { // zsmooth = fast
                  for(j = 0; j < m; j++) {
                      row = z[j];
                      yb = ypx(j);
                      for(i = 0; i < imageWidth; i++) {
                          c = setColor(row[i], 1);
                          pxIndex = (yb * imageWidth + xpx(i)) * 4;
                          putColor(pixels, pxIndex, c);
                      }
                  }
              }
  
              var imageData = context.createImageData(imageWidth, imageHeight);
              try {
                  imageData.data.set(pixels);
              } catch(e) {
                  var pxArray = imageData.data;
                  var dlen = pxArray.length;
                  for(j = 0; j < dlen; j ++) {
                      pxArray[j] = pixels[j];
                  }
              }
  
              context.putImageData(imageData, 0, 0);
          } else { // zsmooth = false -> filling potentially large bricks works fastest with fillRect
              // gaps do not need to be exact integers, but if they *are* we will get
              // cleaner edges by rounding at least one edge
              var xGap = trace.xgap;
              var yGap = trace.ygap;
              var xGapLeft = Math.floor(xGap / 2);
              var yGapTop = Math.floor(yGap / 2);
  
              for(j = 0; j < m; j++) {
                  row = z[j];
                  yb.reverse();
                  yb[ybi] = ypx(j + 1);
                  if(yb[0] === yb[1] || yb[0] === undefined || yb[1] === undefined) {
                      continue;
                  }
                  xi = xpx(0);
                  xb = [xi, xi];
                  for(i = 0; i < n; i++) {
                      // build one color brick!
                      xb.reverse();
                      xb[xbi] = xpx(i + 1);
                      if(xb[0] === xb[1] || xb[0] === undefined || xb[1] === undefined) {
                          continue;
                      }
                      v = row[i];
                      c = setColor(v, (xb[1] - xb[0]) * (yb[1] - yb[0]));
                      context.fillStyle = 'rgba(' + c.join(',') + ')';
  
                      context.fillRect(xb[0] + xGapLeft, yb[0] + yGapTop,
                          xb[1] - xb[0] - xGap, yb[1] - yb[0] - yGap);
                  }
              }
          }
  
          rcount = Math.round(rcount / pixcount);
          gcount = Math.round(gcount / pixcount);
          bcount = Math.round(bcount / pixcount);
          var avgColor = tinycolor('rgb(' + rcount + ',' + gcount + ',' + bcount + ')');
  
          gd._hmpixcount = (gd._hmpixcount||0) + pixcount;
          gd._hmlumcount = (gd._hmlumcount||0) + pixcount * avgColor.getLuminance();
  
          var image3 = plotGroup.selectAll('image')
              .data(cd);
  
          image3.enter().append('svg:image').attr({
              xmlns: xmlnsNamespaces.svg,
              preserveAspectRatio: 'none'
          });
  
          image3.attr({
              height: imageHeight,
              width: imageWidth,
              x: left,
              y: top,
              'xlink:href': canvas.toDataURL('image/png')
          });
      });
  };
  
  // get interpolated bin value. Returns {bin0:closest bin, frac:fractional dist to next, bin1:next bin}
  function findInterp(pixel, pixArray) {
      var maxBin = pixArray.length - 2;
      var bin = Lib.constrain(Lib.findBin(pixel, pixArray), 0, maxBin);
      var pix0 = pixArray[bin];
      var pix1 = pixArray[bin + 1];
      var interp = Lib.constrain(bin + (pixel - pix0) / (pix1 - pix0) - 0.5, 0, maxBin);
      var bin0 = Math.round(interp);
      var frac = Math.abs(interp - bin0);
  
      if(!interp || interp === maxBin || !frac) {
          return {
              bin0: bin0,
              bin1: bin0,
              frac: 0
          };
      }
      return {
          bin0: bin0,
          frac: frac,
          bin1: Math.round(bin0 + frac / (interp - bin0))
      };
  }
  
  function findInterpFromCenters(pixel, centerPixArray) {
      var maxBin = centerPixArray.length - 1;
      var bin = Lib.constrain(Lib.findBin(pixel, centerPixArray), 0, maxBin);
      var pix0 = centerPixArray[bin];
      var pix1 = centerPixArray[bin + 1];
      var frac = ((pixel - pix0) / (pix1 - pix0)) || 0;
      if(frac <= 0) {
          return {
              bin0: bin,
              bin1: bin,
              frac: 0
          };
      }
      if(frac < 0.5) {
          return {
              bin0: bin,
              bin1: bin + 1,
              frac: frac
          };
      }
      return {
          bin0: bin + 1,
          bin1: bin,
          frac: 1 - frac
      };
  }
  
  function putColor(pixels, pxIndex, c) {
      pixels[pxIndex] = c[0];
      pixels[pxIndex + 1] = c[1];
      pixels[pxIndex + 2] = c[2];
      pixels[pxIndex + 3] = Math.round(c[3] * 255);
  }
  
  },{"../../components/colorscale":627,"../../constants/xmlns_namespaces":726,"../../lib":750,"../../registry":882,"d3":169,"tinycolor2":548}],1048:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  module.exports = function style(gd) {
      d3.select(gd).selectAll('.hm image')
          .style('opacity', function(d) {
              return d.trace.opacity;
          });
  };
  
  },{"d3":169}],1049:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = function handleStyleDefaults(traceIn, traceOut, coerce) {
      var zsmooth = coerce('zsmooth');
      if(zsmooth === false) {
          // ensure that xgap and ygap are coerced only when zsmooth allows them to have an effect.
          coerce('xgap');
          coerce('ygap');
      }
  
      coerce('zhoverformat');
  };
  
  },{}],1050:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var Lib = _dereq_('../../lib');
  
  var Registry = _dereq_('../../registry');
  
  module.exports = function handleXYZDefaults(traceIn, traceOut, coerce, layout, xName, yName) {
      var z = coerce('z');
      xName = xName || 'x';
      yName = yName || 'y';
      var x, y;
  
      if(z === undefined || !z.length) return 0;
  
      if(Lib.isArray1D(traceIn.z)) {
          x = coerce(xName);
          y = coerce(yName);
  
          var xlen = Lib.minRowLength(x);
          var ylen = Lib.minRowLength(y);
  
          // column z must be accompanied by xName and yName arrays
          if(xlen === 0 || ylen === 0) return 0;
  
          traceOut._length = Math.min(xlen, ylen, z.length);
      } else {
          x = coordDefaults(xName, coerce);
          y = coordDefaults(yName, coerce);
  
          // TODO put z validation elsewhere
          if(!isValidZ(z)) return 0;
  
          coerce('transpose');
  
          traceOut._length = null;
      }
  
      if(
          traceIn.type === 'heatmapgl' ||
          traceIn.type === 'contourgl'
      ) return true; // skip calendars until we handle them in those traces
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, [xName, yName], layout);
  
      return true;
  };
  
  function coordDefaults(coordStr, coerce) {
      var coord = coerce(coordStr);
      var coordType = coord ? coerce(coordStr + 'type', 'array') : 'scaled';
  
      if(coordType === 'scaled') {
          coerce(coordStr + '0');
          coerce('d' + coordStr);
      }
  
      return coord;
  }
  
  function isValidZ(z) {
      var allRowsAreArrays = true;
      var oneRowIsFilled = false;
      var hasOneNumber = false;
      var zi;
  
      /*
       * Without this step:
       *
       * hasOneNumber = false breaks contour but not heatmap
       * allRowsAreArrays = false breaks contour but not heatmap
       * oneRowIsFilled = false breaks both
       */
  
      for(var i = 0; i < z.length; i++) {
          zi = z[i];
          if(!Lib.isArrayOrTypedArray(zi)) {
              allRowsAreArrays = false;
              break;
          }
          if(zi.length > 0) oneRowIsFilled = true;
          for(var j = 0; j < zi.length; j++) {
              if(isNumeric(zi[j])) {
                  hasOneNumber = true;
                  break;
              }
          }
      }
  
      return (allRowsAreArrays && oneRowIsFilled && hasOneNumber);
  }
  
  },{"../../lib":750,"../../registry":882,"fast-isnumeric":241}],1051:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var heatmapAttrs = _dereq_('../heatmap/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var commonList = [
      'z',
      'x', 'x0', 'dx',
      'y', 'y0', 'dy',
      'text', 'transpose',
      'xtype', 'ytype'
  ];
  
  var attrs = {};
  
  for(var i = 0; i < commonList.length; i++) {
      var k = commonList[i];
      attrs[k] = heatmapAttrs[k];
  }
  
  attrs.zsmooth = {
      valType: 'enumerated',
      values: ['fast', false],
      dflt: 'fast',
      
      editType: 'calc',
      
  };
  
  extendFlat(
      attrs,
      colorScaleAttrs('', {cLetter: 'z', autoColorDflt: false})
  );
  
  module.exports = overrideAll(attrs, 'calc', 'nested');
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plot_api/edit_types":781,"../heatmap/attributes":1036}],1052:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var createHeatmap2D = _dereq_('gl-heatmap2d');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var str2RGBArray = _dereq_('../../lib/str2rgbarray');
  
  
  function Heatmap(scene, uid) {
      this.scene = scene;
      this.uid = uid;
      this.type = 'heatmapgl';
  
      this.name = '';
      this.hoverinfo = 'all';
  
      this.xData = [];
      this.yData = [];
      this.zData = [];
      this.textLabels = [];
  
      this.idToIndex = [];
      this.bounds = [0, 0, 0, 0];
  
      this.options = {
          zsmooth: 'fast',
          z: [],
          x: [],
          y: [],
          shape: [0, 0],
          colorLevels: [0],
          colorValues: [0, 0, 0, 1]
      };
  
      this.heatmap = createHeatmap2D(scene.glplot, this.options);
      this.heatmap._trace = this;
  }
  
  var proto = Heatmap.prototype;
  
  proto.handlePick = function(pickResult) {
      var options = this.options;
      var shape = options.shape;
      var index = pickResult.pointId;
      var xIndex = index % shape[0];
      var yIndex = Math.floor(index / shape[0]);
      var zIndex = index;
  
      return {
          trace: this,
          dataCoord: pickResult.dataCoord,
          traceCoord: [
              options.x[xIndex],
              options.y[yIndex],
              options.z[zIndex]
          ],
          textLabel: this.textLabels[index],
          name: this.name,
          pointIndex: [yIndex, xIndex],
          hoverinfo: this.hoverinfo
      };
  };
  
  proto.update = function(fullTrace, calcTrace) {
      var calcPt = calcTrace[0];
  
      this.index = fullTrace.index;
      this.name = fullTrace.name;
      this.hoverinfo = fullTrace.hoverinfo;
  
      // convert z from 2D -> 1D
      var z = calcPt.z;
      this.options.z = [].concat.apply([], z);
  
      var rowLen = z[0].length;
      var colLen = z.length;
      this.options.shape = [rowLen, colLen];
  
      this.options.x = calcPt.x;
      this.options.y = calcPt.y;
      this.options.zsmooth = fullTrace.zsmooth;
  
      var colorOptions = convertColorscale(fullTrace);
      this.options.colorLevels = colorOptions.colorLevels;
      this.options.colorValues = colorOptions.colorValues;
  
      // convert text from 2D -> 1D
      this.textLabels = [].concat.apply([], fullTrace.text);
  
      this.heatmap.update(this.options);
  
      var xa = this.scene.xaxis;
      var ya = this.scene.yaxis;
  
      var xOpts, yOpts;
      if(fullTrace.zsmooth === false) {
          // increase padding for discretised heatmap as suggested by Louise Ord
          xOpts = { ppad: calcPt.x[1] - calcPt.x[0] };
          yOpts = { ppad: calcPt.y[1] - calcPt.y[0] };
      }
  
      fullTrace._extremes[xa._id] = Axes.findExtremes(xa, calcPt.x, xOpts);
      fullTrace._extremes[ya._id] = Axes.findExtremes(ya, calcPt.y, yOpts);
  };
  
  proto.dispose = function() {
      this.heatmap.dispose();
  };
  
  function convertColorscale(fullTrace) {
      var scl = fullTrace.colorscale;
      var zmin = fullTrace.zmin;
      var zmax = fullTrace.zmax;
  
      var N = scl.length;
      var domain = new Array(N);
      var range = new Array(4 * N);
  
      for(var i = 0; i < N; i++) {
          var si = scl[i];
          var color = str2RGBArray(si[1]);
  
          domain[i] = zmin + si[0] * (zmax - zmin);
  
          for(var j = 0; j < 4; j++) {
              range[(4 * i) + j] = color[j];
          }
      }
  
      return {
          colorLevels: domain,
          colorValues: range
      };
  }
  
  function createHeatmap(scene, fullTrace, calcTrace) {
      var plot = new Heatmap(scene, fullTrace.uid);
      plot.update(fullTrace, calcTrace);
      return plot;
  }
  
  module.exports = createHeatmap;
  
  },{"../../lib/str2rgbarray":773,"../../plots/cartesian/axes":799,"gl-heatmap2d":268}],1053:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleXYZDefaults = _dereq_('../heatmap/xyz_defaults');
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var validData = handleXYZDefaults(traceIn, traceOut, coerce, layout);
      if(!validData) {
          traceOut.visible = false;
          return;
      }
  
      coerce('text');
      coerce('zsmooth');
  
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"../heatmap/xyz_defaults":1050,"./attributes":1051}],1054:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../heatmap/colorbar'),
  
      calc: _dereq_('../heatmap/calc'),
      plot: _dereq_('./convert'),
  
      moduleType: 'trace',
      name: 'heatmapgl',
      basePlotModule: _dereq_('../../plots/gl2d'),
      categories: ['gl', 'gl2d', '2dMap'],
      meta: {
          
      }
  };
  
  },{"../../plots/gl2d":839,"../heatmap/calc":1037,"../heatmap/colorbar":1039,"./attributes":1051,"./convert":1052,"./defaults":1053}],1055:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var barAttrs = _dereq_('../bar/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var makeBinAttrs = _dereq_('./bin_attributes');
  var constants = _dereq_('./constants');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = {
      x: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
      y: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
  
      text: extendFlat({}, barAttrs.text, {
          
      }),
      hovertext: extendFlat({}, barAttrs.hovertext, {
          
      }),
      orientation: barAttrs.orientation,
  
      histfunc: {
          valType: 'enumerated',
          values: ['count', 'sum', 'avg', 'min', 'max'],
          
          dflt: 'count',
          editType: 'calc',
          
      },
      histnorm: {
          valType: 'enumerated',
          values: ['', 'percent', 'probability', 'density', 'probability density'],
          dflt: '',
          
          editType: 'calc',
          
      },
  
      cumulative: {
          enabled: {
              valType: 'boolean',
              dflt: false,
              
              editType: 'calc',
              
          },
  
          direction: {
              valType: 'enumerated',
              values: ['increasing', 'decreasing'],
              dflt: 'increasing',
              
              editType: 'calc',
              
          },
  
          currentbin: {
              valType: 'enumerated',
              values: ['include', 'exclude', 'half'],
              dflt: 'include',
              
              editType: 'calc',
              
          },
          editType: 'calc'
      },
      nbinsx: {
          valType: 'integer',
          min: 0,
          dflt: 0,
          
          editType: 'calc',
          
      },
      xbins: makeBinAttrs('x', true),
  
      nbinsy: {
          valType: 'integer',
          min: 0,
          dflt: 0,
          
          editType: 'calc',
          
      },
      ybins: makeBinAttrs('y', true),
      autobinx: {
          valType: 'boolean',
          dflt: null,
          
          editType: 'calc',
          
      },
      autobiny: {
          valType: 'boolean',
          dflt: null,
          
          editType: 'calc',
          
      },
  
      bingroup: {
          valType: 'string',
          
          dflt: '',
          editType: 'calc',
          
      },
  
      hovertemplate: hovertemplateAttrs({}, {
          keys: constants.eventDataKeys
      }),
  
      marker: barAttrs.marker,
  
      offsetgroup: barAttrs.offsetgroup,
      alignmentgroup: barAttrs.alignmentgroup,
  
      selected: barAttrs.selected,
      unselected: barAttrs.unselected,
  
      _deprecated: {
          bardir: barAttrs._deprecated.bardir
      }
  };
  
  },{"../../lib/extend":740,"../../plots/template_attributes":877,"../bar/attributes":892,"./bin_attributes":1057,"./constants":1061}],1056:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  module.exports = function doAvg(size, counts) {
      var nMax = size.length;
      var total = 0;
      for(var i = 0; i < nMax; i++) {
          if(counts[i]) {
              size[i] /= counts[i];
              total += size[i];
          } else size[i] = null;
      }
      return total;
  };
  
  },{}],1057:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function makeBinAttrs(axLetter, match) {
      return {
          start: {
              valType: 'any', // for date axes
              
              editType: 'calc',
              
          },
          end: {
              valType: 'any', // for date axes
              
              editType: 'calc',
              
          },
          size: {
              valType: 'any', // for date axes
              
              editType: 'calc',
              
          },
          editType: 'calc'
      };
  };
  
  },{}],1058:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  
  module.exports = {
      count: function(n, i, size) {
          size[n]++;
          return 1;
      },
  
      sum: function(n, i, size, counterData) {
          var v = counterData[i];
          if(isNumeric(v)) {
              v = Number(v);
              size[n] += v;
              return v;
          }
          return 0;
      },
  
      avg: function(n, i, size, counterData, counts) {
          var v = counterData[i];
          if(isNumeric(v)) {
              v = Number(v);
              size[n] += v;
              counts[n]++;
          }
          return 0;
      },
  
      min: function(n, i, size, counterData) {
          var v = counterData[i];
          if(isNumeric(v)) {
              v = Number(v);
              if(!isNumeric(size[n])) {
                  size[n] = v;
                  return v;
              } else if(size[n] > v) {
                  var delta = v - size[n];
                  size[n] = v;
                  return delta;
              }
          }
          return 0;
      },
  
      max: function(n, i, size, counterData) {
          var v = counterData[i];
          if(isNumeric(v)) {
              v = Number(v);
              if(!isNumeric(size[n])) {
                  size[n] = v;
                  return v;
              } else if(size[n] < v) {
                  var delta = v - size[n];
                  size[n] = v;
                  return delta;
              }
          }
          return 0;
      }
  };
  
  },{"fast-isnumeric":241}],1059:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var numConstants = _dereq_('../../constants/numerical');
  var oneYear = numConstants.ONEAVGYEAR;
  var oneMonth = numConstants.ONEAVGMONTH;
  var oneDay = numConstants.ONEDAY;
  var oneHour = numConstants.ONEHOUR;
  var oneMin = numConstants.ONEMIN;
  var oneSec = numConstants.ONESEC;
  var tickIncrement = _dereq_('../../plots/cartesian/axes').tickIncrement;
  
  
  /*
   * make a function that will find rounded bin edges
   * @param {number} leftGap: how far from the left edge of any bin is the closest data value?
   * @param {number} rightGap: how far from the right edge of any bin is the closest data value?
   * @param {Array[number]} binEdges: the actual edge values used in binning
   * @param {object} pa: the position axis
   * @param {string} calendar: the data calendar
   *
   * @return {function(v, isRightEdge)}:
   *   find the start (isRightEdge is falsy) or end (truthy) label value for a bin edge `v`
   */
  module.exports = function getBinSpanLabelRound(leftGap, rightGap, binEdges, pa, calendar) {
      // the rounding digit is the largest digit that changes in *all* of 4 regions:
      // - inside the rightGap before binEdges[0] (shifted 10% to the left)
      // - inside the leftGap after binEdges[0] (expanded by 10% of rightGap on each end)
      // - same for binEdges[1]
      var dv0 = -1.1 * rightGap;
      var dv1 = -0.1 * rightGap;
      var dv2 = leftGap - dv1;
      var edge0 = binEdges[0];
      var edge1 = binEdges[1];
      var leftDigit = Math.min(
          biggestDigitChanged(edge0 + dv1, edge0 + dv2, pa, calendar),
          biggestDigitChanged(edge1 + dv1, edge1 + dv2, pa, calendar)
      );
      var rightDigit = Math.min(
          biggestDigitChanged(edge0 + dv0, edge0 + dv1, pa, calendar),
          biggestDigitChanged(edge1 + dv0, edge1 + dv1, pa, calendar)
      );
  
      // normally we try to make the label for the right edge different from
      // the left edge label, so it's unambiguous which bin gets data on the edge.
      // but if this results in more than 3 extra digits (or for dates, more than
      // 2 fields ie hr&min or min&sec, which is 3600x), it'll be more clutter than
      // useful so keep the label cleaner instead
      var digit, disambiguateEdges;
      if(leftDigit > rightDigit && rightDigit < Math.abs(edge1 - edge0) / 4000) {
          digit = leftDigit;
          disambiguateEdges = false;
      } else {
          digit = Math.min(leftDigit, rightDigit);
          disambiguateEdges = true;
      }
  
      if(pa.type === 'date' && digit > oneDay) {
          var dashExclude = (digit === oneYear) ? 1 : 6;
          var increment = (digit === oneYear) ? 'M12' : 'M1';
  
          return function(v, isRightEdge) {
              var dateStr = pa.c2d(v, oneYear, calendar);
              var dashPos = dateStr.indexOf('-', dashExclude);
              if(dashPos > 0) dateStr = dateStr.substr(0, dashPos);
              var roundedV = pa.d2c(dateStr, 0, calendar);
  
              if(roundedV < v) {
                  var nextV = tickIncrement(roundedV, increment, false, calendar);
                  if((roundedV + nextV) / 2 < v + leftGap) roundedV = nextV;
              }
  
              if(isRightEdge && disambiguateEdges) {
                  return tickIncrement(roundedV, increment, true, calendar);
              }
  
              return roundedV;
          };
      }
  
      return function(v, isRightEdge) {
          var roundedV = digit * Math.round(v / digit);
          // if we rounded down and we could round up and still be < leftGap
          // (or what leftGap values round to), do that
          if(roundedV + (digit / 10) < v && roundedV + (digit * 0.9) < v + leftGap) {
              roundedV += digit;
          }
          // finally for the right edge back off one digit - but only if we can do that
          // and not clip off any data that's potentially in the bin
          if(isRightEdge && disambiguateEdges) {
              roundedV -= digit;
          }
          return roundedV;
      };
  };
  
  /*
   * Find the largest digit that changes within a (calcdata) region [v1, v2]
   * if dates, "digit" means date/time part when it's bigger than a second
   * returns the unit value to round to this digit, eg 0.01 to round to hundredths, or
   * 100 to round to hundreds. returns oneMonth or oneYear for month or year rounding,
   * so that Math.min will work, rather than 'M1' and 'M12'
   */
  function biggestDigitChanged(v1, v2, pa, calendar) {
      // are we crossing zero? can't say anything.
      // in principle this doesn't apply to dates but turns out this doesn't matter.
      if(v1 * v2 <= 0) return Infinity;
  
      var dv = Math.abs(v2 - v1);
      var isDate = pa.type === 'date';
      var digit = biggestGuaranteedDigitChanged(dv, isDate);
      // see if a larger digit also changed
      for(var i = 0; i < 10; i++) {
          // numbers: next digit needs to be >10x but <100x then gets rounded down.
          // dates: next digit can be as much as 60x (then rounded down)
          var nextDigit = biggestGuaranteedDigitChanged(digit * 80, isDate);
          // if we get to years, the chain stops
          if(digit === nextDigit) break;
          if(didDigitChange(nextDigit, v1, v2, isDate, pa, calendar)) digit = nextDigit;
          else break;
      }
      return digit;
  }
  
  /*
   * Find the largest digit that *definitely* changes in a region [v, v + dv] for any v
   * for nonuniform date regions (months/years) pick the largest
   */
  function biggestGuaranteedDigitChanged(dv, isDate) {
      if(isDate && dv > oneSec) {
          // this is supposed to be the biggest *guaranteed* change
          // so compare to the longest month and year across any calendar,
          // and we'll iterate back up later
          // note: does not support rounding larger than one year. We could add
          // that if anyone wants it, but seems unusual and not strictly necessary.
          if(dv > oneDay) {
              if(dv > oneYear * 1.1) return oneYear;
              if(dv > oneMonth * 1.1) return oneMonth;
              return oneDay;
          }
  
          if(dv > oneHour) return oneHour;
          if(dv > oneMin) return oneMin;
          return oneSec;
      }
      return Math.pow(10, Math.floor(Math.log(dv) / Math.LN10));
  }
  
  function didDigitChange(digit, v1, v2, isDate, pa, calendar) {
      if(isDate && digit > oneDay) {
          var dateParts1 = dateParts(v1, pa, calendar);
          var dateParts2 = dateParts(v2, pa, calendar);
          var parti = (digit === oneYear) ? 0 : 1;
          return dateParts1[parti] !== dateParts2[parti];
      }
      return Math.floor(v2 / digit) - Math.floor(v1 / digit) > 0.1;
  }
  
  function dateParts(v, pa, calendar) {
      var parts = pa.c2d(v, oneYear, calendar).split('-');
      if(parts[0] === '') {
          parts.unshift();
          parts[0] = '-' + parts[0];
      }
      return parts;
  }
  
  },{"../../constants/numerical":725,"../../plots/cartesian/axes":799}],1060:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  var arraysToCalcdata = _dereq_('../bar/arrays_to_calcdata');
  var binFunctions = _dereq_('./bin_functions');
  var normFunctions = _dereq_('./norm_functions');
  var doAvg = _dereq_('./average');
  var getBinSpanLabelRound = _dereq_('./bin_label_vals');
  
  function calc(gd, trace) {
      var pos = [];
      var size = [];
      var pa = Axes.getFromId(gd, trace.orientation === 'h' ? trace.yaxis : trace.xaxis);
      var mainData = trace.orientation === 'h' ? 'y' : 'x';
      var counterData = {x: 'y', y: 'x'}[mainData];
      var calendar = trace[mainData + 'calendar'];
      var cumulativeSpec = trace.cumulative;
      var i;
  
      var binsAndPos = calcAllAutoBins(gd, trace, pa, mainData);
      var binSpec = binsAndPos[0];
      var pos0 = binsAndPos[1];
  
      var nonuniformBins = typeof binSpec.size === 'string';
      var binEdges = [];
      var bins = nonuniformBins ? binEdges : binSpec;
      // make the empty bin array
      var inc = [];
      var counts = [];
      var inputPoints = [];
      var total = 0;
      var norm = trace.histnorm;
      var func = trace.histfunc;
      var densityNorm = norm.indexOf('density') !== -1;
      var i2, binEnd, n;
  
      if(cumulativeSpec.enabled && densityNorm) {
          // we treat "cumulative" like it means "integral" if you use a density norm,
          // which in the end means it's the same as without "density"
          norm = norm.replace(/ ?density$/, '');
          densityNorm = false;
      }
  
      var extremeFunc = func === 'max' || func === 'min';
      var sizeInit = extremeFunc ? null : 0;
      var binFunc = binFunctions.count;
      var normFunc = normFunctions[norm];
      var isAvg = false;
      var pr2c = function(v) { return pa.r2c(v, 0, calendar); };
      var rawCounterData;
  
      if(Lib.isArrayOrTypedArray(trace[counterData]) && func !== 'count') {
          rawCounterData = trace[counterData];
          isAvg = func === 'avg';
          binFunc = binFunctions[func];
      }
  
      // create the bins (and any extra arrays needed)
      // assume more than 1e6 bins is an error, so we don't crash the browser
      i = pr2c(binSpec.start);
  
      // decrease end a little in case of rounding errors
      binEnd = pr2c(binSpec.end) + (i - Axes.tickIncrement(i, binSpec.size, false, calendar)) / 1e6;
  
      while(i < binEnd && pos.length < 1e6) {
          i2 = Axes.tickIncrement(i, binSpec.size, false, calendar);
          pos.push((i + i2) / 2);
          size.push(sizeInit);
          inputPoints.push([]);
          // nonuniform bins (like months) we need to search,
          // rather than straight calculate the bin we're in
          binEdges.push(i);
          // nonuniform bins also need nonuniform normalization factors
          if(densityNorm) inc.push(1 / (i2 - i));
          if(isAvg) counts.push(0);
          // break to avoid infinite loops
          if(i2 <= i) break;
          i = i2;
      }
      binEdges.push(i);
  
      // for date axes we need bin bounds to be calcdata. For nonuniform bins
      // we already have this, but uniform with start/end/size they're still strings.
      if(!nonuniformBins && pa.type === 'date') {
          bins = {
              start: pr2c(bins.start),
              end: pr2c(bins.end),
              size: bins.size
          };
      }
  
      // stash left and right gaps by group
      if(!gd._fullLayout._roundFnOpts) gd._fullLayout._roundFnOpts = {};
      var groupName = trace['_' + mainData + 'bingroup'];
      var roundFnOpts = {leftGap: Infinity, rightGap: Infinity};
      if(groupName) {
          if(!gd._fullLayout._roundFnOpts[groupName]) gd._fullLayout._roundFnOpts[groupName] = roundFnOpts;
          roundFnOpts = gd._fullLayout._roundFnOpts[groupName];
      }
  
      // bin the data
      // and make histogram-specific pt-number-to-cd-index map object
      var nMax = size.length;
      var uniqueValsPerBin = true;
      var leftGap = roundFnOpts.leftGap;
      var rightGap = roundFnOpts.rightGap;
      var ptNumber2cdIndex = {};
      for(i = 0; i < pos0.length; i++) {
          var posi = pos0[i];
          n = Lib.findBin(posi, bins);
          if(n >= 0 && n < nMax) {
              total += binFunc(n, i, size, rawCounterData, counts);
              if(uniqueValsPerBin && inputPoints[n].length && posi !== pos0[inputPoints[n][0]]) {
                  uniqueValsPerBin = false;
              }
              inputPoints[n].push(i);
              ptNumber2cdIndex[i] = n;
  
              leftGap = Math.min(leftGap, posi - binEdges[n]);
              rightGap = Math.min(rightGap, binEdges[n + 1] - posi);
          }
      }
      roundFnOpts.leftGap = leftGap;
      roundFnOpts.rightGap = rightGap;
  
      var roundFn;
      if(!uniqueValsPerBin) {
          roundFn = function(v, isRightEdge) {
              return function() {
                  var roundFnOpts = gd._fullLayout._roundFnOpts[groupName];
                  return getBinSpanLabelRound(
                      roundFnOpts.leftGap,
                      roundFnOpts.rightGap,
                      binEdges, pa, calendar
                  )(v, isRightEdge);
              };
          };
      }
  
      // average and/or normalize the data, if needed
      if(isAvg) total = doAvg(size, counts);
      if(normFunc) normFunc(size, total, inc);
  
      // after all normalization etc, now we can accumulate if desired
      if(cumulativeSpec.enabled) cdf(size, cumulativeSpec.direction, cumulativeSpec.currentbin);
  
      var seriesLen = Math.min(pos.length, size.length);
      var cd = [];
      var firstNonzero = 0;
      var lastNonzero = seriesLen - 1;
  
      // look for empty bins at the ends to remove, so autoscale omits them
      for(i = 0; i < seriesLen; i++) {
          if(size[i]) {
              firstNonzero = i;
              break;
          }
      }
      for(i = seriesLen - 1; i >= firstNonzero; i--) {
          if(size[i]) {
              lastNonzero = i;
              break;
          }
      }
  
      // create the "calculated data" to plot
      for(i = firstNonzero; i <= lastNonzero; i++) {
          if((isNumeric(pos[i]) && isNumeric(size[i]))) {
              var cdi = {
                  p: pos[i],
                  s: size[i],
                  b: 0
              };
  
              // setup hover and event data fields,
              // N.B. pts and "hover" positions ph0/ph1 don't seem to make much sense
              // for cumulative distributions
              if(!cumulativeSpec.enabled) {
                  cdi.pts = inputPoints[i];
                  if(uniqueValsPerBin) {
                      cdi.ph0 = cdi.ph1 = (inputPoints[i].length) ? pos0[inputPoints[i][0]] : pos[i];
                  } else {
                      // Defer evaluation of ph(0|1) in crossTraceCalc
                      trace._computePh = true;
                      cdi.ph0 = roundFn(binEdges[i]);
                      cdi.ph1 = roundFn(binEdges[i + 1], true);
                  }
              }
              cd.push(cdi);
          }
      }
  
      if(cd.length === 1) {
          // when we collapse to a single bin, calcdata no longer describes bin size
          // so we need to explicitly specify it
          cd[0].width1 = Axes.tickIncrement(cd[0].p, binSpec.size, false, calendar) - cd[0].p;
      }
  
      arraysToCalcdata(cd, trace);
  
      if(Lib.isArrayOrTypedArray(trace.selectedpoints)) {
          Lib.tagSelected(cd, trace, ptNumber2cdIndex);
      }
  
      return cd;
  }
  
  /*
   * calcAllAutoBins: we want all histograms inside the same bingroup
   * (see logic in Histogram.crossTraceDefaults) to share bin specs
   *
   * If the user has explicitly specified differing
   * bin specs, there's nothing we can do, but if possible we will try to use the
   * smallest bins of any of the auto values for all histograms inside the same
   * bingroup.
   */
  function calcAllAutoBins(gd, trace, pa, mainData, _overlayEdgeCase) {
      var binAttr = mainData + 'bins';
      var fullLayout = gd._fullLayout;
      var groupName = trace['_' + mainData + 'bingroup'];
      var binOpts = fullLayout._histogramBinOpts[groupName];
      var isOverlay = fullLayout.barmode === 'overlay';
      var i, traces, tracei, calendar, pos0, autoVals, cumulativeSpec;
  
      var r2c = function(v) { return pa.r2c(v, 0, calendar); };
      var c2r = function(v) { return pa.c2r(v, 0, calendar); };
  
      var cleanBound = pa.type === 'date' ?
          function(v) { return (v || v === 0) ? Lib.cleanDate(v, null, calendar) : null; } :
          function(v) { return isNumeric(v) ? Number(v) : null; };
  
      function setBound(attr, bins, newBins) {
          if(bins[attr + 'Found']) {
              bins[attr] = cleanBound(bins[attr]);
              if(bins[attr] === null) bins[attr] = newBins[attr];
          } else {
              autoVals[attr] = bins[attr] = newBins[attr];
              Lib.nestedProperty(traces[0], binAttr + '.' + attr).set(newBins[attr]);
          }
      }
  
      // all but the first trace in this group has already been marked finished
      // clear this flag, so next time we run calc we will run autobin again
      if(trace['_' + mainData + 'autoBinFinished']) {
          delete trace['_' + mainData + 'autoBinFinished'];
      } else {
          traces = binOpts.traces;
          var allPos = [];
  
          // Note: we're including `legendonly` traces here for autobin purposes,
          // so that showing & hiding from the legend won't affect bins.
          // But this complicates things a bit since those traces don't `calc`,
          // hence `isFirstVisible`.
          var isFirstVisible = true;
          var has2dMap = false;
          var hasHist2dContour = false;
          for(i = 0; i < traces.length; i++) {
              tracei = traces[i];
  
              if(tracei.visible) {
                  var mainDatai = binOpts.dirs[i];
                  pos0 = tracei['_' + mainDatai + 'pos0'] = pa.makeCalcdata(tracei, mainDatai);
  
                  allPos = Lib.concat(allPos, pos0);
                  delete tracei['_' + mainData + 'autoBinFinished'];
  
                  if(trace.visible === true) {
                      if(isFirstVisible) {
                          isFirstVisible = false;
                      } else {
                          delete tracei._autoBin;
                          tracei['_' + mainData + 'autoBinFinished'] = 1;
                      }
                      if(Registry.traceIs(tracei, '2dMap')) {
                          has2dMap = true;
                      }
                      if(tracei.type === 'histogram2dcontour') {
                          hasHist2dContour = true;
                      }
                  }
              }
          }
  
          calendar = traces[0][mainData + 'calendar'];
          var newBinSpec = Axes.autoBin(allPos, pa, binOpts.nbins, has2dMap, calendar, binOpts.sizeFound && binOpts.size);
  
          var autoBin = traces[0]._autoBin = {};
          autoVals = autoBin[binOpts.dirs[0]] = {};
  
          if(hasHist2dContour) {
              // the "true" 2nd argument reverses the tick direction (which we can't
              // just do with a minus sign because of month bins)
              if(!binOpts.size) {
                  newBinSpec.start = c2r(Axes.tickIncrement(
                      r2c(newBinSpec.start), newBinSpec.size, true, calendar));
              }
              if(binOpts.end === undefined) {
                  newBinSpec.end = c2r(Axes.tickIncrement(
                      r2c(newBinSpec.end), newBinSpec.size, false, calendar));
              }
          }
  
          // Edge case: single-valued histogram overlaying others
          // Use them all together to calculate the bin size for the single-valued one
          if(isOverlay && !Registry.traceIs(trace, '2dMap') && newBinSpec._dataSpan === 0 &&
              pa.type !== 'category' && pa.type !== 'multicategory') {
              // Several single-valued histograms! Stop infinite recursion,
              // just return an extra flag that tells handleSingleValueOverlays
              // to sort out this trace too
              if(_overlayEdgeCase) return [newBinSpec, pos0, true];
  
              newBinSpec = handleSingleValueOverlays(gd, trace, pa, mainData, binAttr);
          }
  
          // adjust for CDF edge cases
          cumulativeSpec = tracei.cumulative || {};
          if(cumulativeSpec.enabled && (cumulativeSpec.currentbin !== 'include')) {
              if(cumulativeSpec.direction === 'decreasing') {
                  newBinSpec.start = c2r(Axes.tickIncrement(
                      r2c(newBinSpec.start), newBinSpec.size, true, calendar));
              } else {
                  newBinSpec.end = c2r(Axes.tickIncrement(
                      r2c(newBinSpec.end), newBinSpec.size, false, calendar));
              }
          }
  
          binOpts.size = newBinSpec.size;
          if(!binOpts.sizeFound) {
              autoVals.size = newBinSpec.size;
              Lib.nestedProperty(traces[0], binAttr + '.size').set(newBinSpec.size);
          }
  
          setBound('start', binOpts, newBinSpec);
          setBound('end', binOpts, newBinSpec);
      }
  
      pos0 = trace['_' + mainData + 'pos0'];
      delete trace['_' + mainData + 'pos0'];
  
      // Each trace can specify its own start/end, or if omitted
      // we ensure they're beyond the bounds of this trace's data,
      // and we need to make sure start is aligned with the main start
      var traceInputBins = trace._input[binAttr] || {};
      var traceBinOptsCalc = Lib.extendFlat({}, binOpts);
      var mainStart = binOpts.start;
      var startIn = pa.r2l(traceInputBins.start);
      var hasStart = startIn !== undefined;
      if((binOpts.startFound || hasStart) && startIn !== pa.r2l(mainStart)) {
          // We have an explicit start to reconcile across traces
          // if this trace has an explicit start, shift it down to a bin edge
          // if another trace had an explicit start, shift it down to a
          // bin edge past our data
          var traceStart = hasStart ?
              startIn :
              Lib.aggNums(Math.min, null, pos0);
  
          var dummyAx = {
              type: (pa.type === 'category' || pa.type === 'multicategory') ? 'linear' : pa.type,
              r2l: pa.r2l,
              dtick: binOpts.size,
              tick0: mainStart,
              calendar: calendar,
              range: ([traceStart, Axes.tickIncrement(traceStart, binOpts.size, false, calendar)]).map(pa.l2r)
          };
          var newStart = Axes.tickFirst(dummyAx);
          if(newStart > pa.r2l(traceStart)) {
              newStart = Axes.tickIncrement(newStart, binOpts.size, true, calendar);
          }
          traceBinOptsCalc.start = pa.l2r(newStart);
          if(!hasStart) Lib.nestedProperty(trace, binAttr + '.start').set(traceBinOptsCalc.start);
      }
  
      var mainEnd = binOpts.end;
      var endIn = pa.r2l(traceInputBins.end);
      var hasEnd = endIn !== undefined;
      if((binOpts.endFound || hasEnd) && endIn !== pa.r2l(mainEnd)) {
          // Reconciling an explicit end is easier, as it doesn't need to
          // match bin edges
          var traceEnd = hasEnd ?
              endIn :
              Lib.aggNums(Math.max, null, pos0);
  
          traceBinOptsCalc.end = pa.l2r(traceEnd);
          if(!hasEnd) Lib.nestedProperty(trace, binAttr + '.start').set(traceBinOptsCalc.end);
      }
  
      // Backward compatibility for one-time autobinning.
      // autobin: true is handled in cleanData, but autobin: false
      // needs to be here where we have determined the values.
      var autoBinAttr = 'autobin' + mainData;
      if(trace._input[autoBinAttr] === false) {
          trace._input[binAttr] = Lib.extendFlat({}, trace[binAttr] || {});
          delete trace._input[autoBinAttr];
          delete trace[autoBinAttr];
      }
  
      return [traceBinOptsCalc, pos0];
  }
  
  /*
   * Adjust single-value histograms in overlay mode to make as good a
   * guess as we can at autobin values the user would like.
   *
   * Returns the binSpec for the trace that sparked all this
   */
  function handleSingleValueOverlays(gd, trace, pa, mainData, binAttr) {
      var fullLayout = gd._fullLayout;
      var overlaidTraceGroup = getConnectedHistograms(gd, trace);
      var pastThisTrace = false;
      var minSize = Infinity;
      var singleValuedTraces = [trace];
      var i, tracei, binOpts;
  
      // first collect all the:
      // - min bin size from all multi-valued traces
      // - single-valued traces
      for(i = 0; i < overlaidTraceGroup.length; i++) {
          tracei = overlaidTraceGroup[i];
  
          if(tracei === trace) {
              pastThisTrace = true;
          } else if(!pastThisTrace) {
              // This trace has already had its autobins calculated, so either:
              // - it is part of a bingroup
              // - it is NOT a single-valued trace
              binOpts = fullLayout._histogramBinOpts[tracei['_' + mainData + 'bingroup']];
              minSize = Math.min(minSize, binOpts.size || tracei[binAttr].size);
          } else {
              var resulti = calcAllAutoBins(gd, tracei, pa, mainData, true);
              var binSpeci = resulti[0];
              var isSingleValued = resulti[2];
  
              // so we can use this result when we get to tracei in the normal
              // course of events, mark it as done and put _pos0 back
              tracei['_' + mainData + 'autoBinFinished'] = 1;
              tracei['_' + mainData + 'pos0'] = resulti[1];
  
              if(isSingleValued) {
                  singleValuedTraces.push(tracei);
              } else {
                  minSize = Math.min(minSize, binSpeci.size);
              }
          }
      }
  
      // find the real data values for each single-valued trace
      // hunt through pos0 for the first valid value
      var dataVals = new Array(singleValuedTraces.length);
      for(i = 0; i < singleValuedTraces.length; i++) {
          var pos0 = singleValuedTraces[i]['_' + mainData + 'pos0'];
          for(var j = 0; j < pos0.length; j++) {
              if(pos0[j] !== undefined) {
                  dataVals[i] = pos0[j];
                  break;
              }
          }
      }
  
      // are ALL traces are single-valued? use the min difference between
      // all of their values (which defaults to 1 if there's still only one)
      if(!isFinite(minSize)) {
          minSize = Lib.distinctVals(dataVals).minDiff;
      }
  
      // now apply the min size we found to all single-valued traces
      for(i = 0; i < singleValuedTraces.length; i++) {
          tracei = singleValuedTraces[i];
          var calendar = tracei[mainData + 'calendar'];
  
          var newBins = {
              start: pa.c2r(dataVals[i] - minSize / 2, 0, calendar),
              end: pa.c2r(dataVals[i] + minSize / 2, 0, calendar),
              size: minSize
          };
  
          tracei._input[binAttr] = tracei[binAttr] = newBins;
  
          binOpts = fullLayout._histogramBinOpts[tracei['_' + mainData + 'bingroup']];
          if(binOpts) Lib.extendFlat(binOpts, newBins);
      }
  
      return trace[binAttr];
  }
  
  /*
   * Return an array of histograms that share axes and orientation.
   *
   * Only considers histograms. In principle we could include bars in a
   * similar way to how we do manually binned histograms, though this
   * would have tons of edge cases and value judgments to make.
   */
  function getConnectedHistograms(gd, trace) {
      var xid = trace.xaxis;
      var yid = trace.yaxis;
      var orientation = trace.orientation;
  
      var out = [];
      var fullData = gd._fullData;
      for(var i = 0; i < fullData.length; i++) {
          var tracei = fullData[i];
          if(tracei.type === 'histogram' &&
              tracei.visible === true &&
              tracei.orientation === orientation &&
              tracei.xaxis === xid && tracei.yaxis === yid
          ) {
              out.push(tracei);
          }
      }
  
      return out;
  }
  
  function cdf(size, direction, currentBin) {
      var i, vi, prevSum;
  
      function firstHalfPoint(i) {
          prevSum = size[i];
          size[i] /= 2;
      }
  
      function nextHalfPoint(i) {
          vi = size[i];
          size[i] = prevSum + vi / 2;
          prevSum += vi;
      }
  
      if(currentBin === 'half') {
          if(direction === 'increasing') {
              firstHalfPoint(0);
              for(i = 1; i < size.length; i++) {
                  nextHalfPoint(i);
              }
          } else {
              firstHalfPoint(size.length - 1);
              for(i = size.length - 2; i >= 0; i--) {
                  nextHalfPoint(i);
              }
          }
      } else if(direction === 'increasing') {
          for(i = 1; i < size.length; i++) {
              size[i] += size[i - 1];
          }
  
          // 'exclude' is identical to 'include' just shifted one bin over
          if(currentBin === 'exclude') {
              size.unshift(0);
              size.pop();
          }
      } else {
          for(i = size.length - 2; i >= 0; i--) {
              size[i] += size[i + 1];
          }
  
          if(currentBin === 'exclude') {
              size.push(0);
              size.shift();
          }
      }
  }
  
  module.exports = {
      calc: calc,
      calcAllAutoBins: calcAllAutoBins
  };
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"../../registry":882,"../bar/arrays_to_calcdata":891,"./average":1056,"./bin_functions":1058,"./bin_label_vals":1059,"./norm_functions":1067,"fast-isnumeric":241}],1061:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = {
      eventDataKeys: ['binNumber']
  };
  
  },{}],1062:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var axisIds = _dereq_('../../plots/cartesian/axis_ids');
  
  var traceIs = _dereq_('../../registry').traceIs;
  var handleGroupingDefaults = _dereq_('../bar/defaults').handleGroupingDefaults;
  
  var nestedProperty = Lib.nestedProperty;
  var getAxisGroup = axisIds.getAxisGroup;
  
  var BINATTRS = [
      {aStr: {x: 'xbins.start', y: 'ybins.start'}, name: 'start'},
      {aStr: {x: 'xbins.end', y: 'ybins.end'}, name: 'end'},
      {aStr: {x: 'xbins.size', y: 'ybins.size'}, name: 'size'},
      {aStr: {x: 'nbinsx', y: 'nbinsy'}, name: 'nbins'}
  ];
  
  var BINDIRECTIONS = ['x', 'y'];
  
  // handle bin attrs and relink auto-determined values so fullData is complete
  module.exports = function crossTraceDefaults(fullData, fullLayout) {
      var allBinOpts = fullLayout._histogramBinOpts = {};
      var histTraces = [];
      var mustMatchTracesLookup = {};
      var otherTracesList = [];
  
      var traceOut, traces, groupName, binDir;
      var i, j, k;
  
      function coerce(attr, dflt) {
          return Lib.coerce(traceOut._input, traceOut, traceOut._module.attributes, attr, dflt);
      }
  
      function orientation2binDir(traceOut) {
          return traceOut.orientation === 'v' ? 'x' : 'y';
      }
  
      function getAxisType(traceOut, binDir) {
          var ax = axisIds.getFromTrace({_fullLayout: fullLayout}, traceOut, binDir);
          return ax.type;
      }
  
      function fillBinOpts(traceOut, groupName, binDir) {
          // N.B. group traces that don't have a bingroup with themselves
          var fallbackGroupName = traceOut.uid + '__' + binDir;
          if(!groupName) groupName = fallbackGroupName;
  
          var axType = getAxisType(traceOut, binDir);
          var calendar = traceOut[binDir + 'calendar'] || '';
          var binOpts = allBinOpts[groupName];
          var needsNewItem = true;
  
          if(binOpts) {
              if(axType === binOpts.axType && calendar === binOpts.calendar) {
                  needsNewItem = false;
                  binOpts.traces.push(traceOut);
                  binOpts.dirs.push(binDir);
              } else {
                  groupName = fallbackGroupName;
  
                  if(axType !== binOpts.axType) {
                      Lib.warn([
                          'Attempted to group the bins of trace', traceOut.index,
                          'set on a', 'type:' + axType, 'axis',
                          'with bins on', 'type:' + binOpts.axType, 'axis.'
                      ].join(' '));
                  }
                  if(calendar !== binOpts.calendar) {
                      // prohibit bingroup for traces using different calendar,
                      // there's probably a way to make this work, but skip for now
                      Lib.warn([
                          'Attempted to group the bins of trace', traceOut.index,
                          'set with a', calendar, 'calendar',
                          'with bins',
                          (binOpts.calendar ? 'on a ' + binOpts.calendar + ' calendar' : 'w/o a set calendar')
                      ].join(' '));
                  }
              }
          }
  
          if(needsNewItem) {
              allBinOpts[groupName] = {
                  traces: [traceOut],
                  dirs: [binDir],
                  axType: axType,
                  calendar: traceOut[binDir + 'calendar'] || ''
              };
          }
          traceOut['_' + binDir + 'bingroup'] = groupName;
      }
  
      for(i = 0; i < fullData.length; i++) {
          traceOut = fullData[i];
  
          if(traceIs(traceOut, 'histogram')) {
              histTraces.push(traceOut);
  
              // TODO: this shouldn't be relinked as it's only used within calc
              // https://github.com/plotly/plotly.js/issues/749
              delete traceOut._xautoBinFinished;
              delete traceOut._yautoBinFinished;
  
              // N.B. need to coerce *alignmentgroup* before *bingroup*, as traces
              // in same alignmentgroup "have to match"
              if(!traceIs(traceOut, '2dMap')) {
                  handleGroupingDefaults(traceOut._input, traceOut, fullLayout, coerce);
              }
          }
      }
  
      var alignmentOpts = fullLayout._alignmentOpts || {};
  
      // Look for traces that "have to match", that is:
      // - 1d histogram traces on the same subplot with same orientation under barmode:stack,
      // - 1d histogram traces on the same subplot with same orientation under barmode:group
      // - 1d histogram traces on the same position axis with the same orientation
      //   and the same *alignmentgroup* (coerced under barmode:group)
      // - Once `stackgroup` gets implemented (see https://github.com/plotly/plotly.js/issues/3614),
      //   traces within the same stackgroup will also "have to match"
      for(i = 0; i < histTraces.length; i++) {
          traceOut = histTraces[i];
          groupName = '';
  
          if(!traceIs(traceOut, '2dMap')) {
              binDir = orientation2binDir(traceOut);
  
              if(fullLayout.barmode === 'group' && traceOut.alignmentgroup) {
                  var pa = traceOut[binDir + 'axis'];
                  var aGroupId = getAxisGroup(fullLayout, pa) + traceOut.orientation;
                  if((alignmentOpts[aGroupId] || {})[traceOut.alignmentgroup]) {
                      groupName = aGroupId;
                  }
              }
  
              if(!groupName && fullLayout.barmode !== 'overlay') {
                  groupName = (
                      getAxisGroup(fullLayout, traceOut.xaxis) +
                      getAxisGroup(fullLayout, traceOut.yaxis) +
                      orientation2binDir(traceOut)
                  );
              }
          }
  
          if(groupName) {
              if(!mustMatchTracesLookup[groupName]) {
                  mustMatchTracesLookup[groupName] = [];
              }
              mustMatchTracesLookup[groupName].push(traceOut);
          } else {
              otherTracesList.push(traceOut);
          }
      }
  
      // Setup binOpts for traces that have to match,
      // if the traces have a valid bingroup, use that
      // if not use axis+binDir groupName
      for(groupName in mustMatchTracesLookup) {
          traces = mustMatchTracesLookup[groupName];
  
          // no need to 'force' anything when a single
          // trace is detected as "must match"
          if(traces.length === 1) {
              otherTracesList.push(traces[0]);
              continue;
          }
  
          var binGroupFound = false;
          for(i = 0; i < traces.length; i++) {
              traceOut = traces[i];
              binGroupFound = coerce('bingroup');
              break;
          }
  
          groupName = binGroupFound || groupName;
  
          for(i = 0; i < traces.length; i++) {
              traceOut = traces[i];
              var bingroupIn = traceOut._input.bingroup;
              if(bingroupIn && bingroupIn !== groupName) {
                  Lib.warn([
                      'Trace', traceOut.index, 'must match',
                      'within bingroup', groupName + '.',
                      'Ignoring its bingroup:', bingroupIn, 'setting.'
                  ].join(' '));
              }
              traceOut.bingroup = groupName;
  
              // N.B. no need to worry about 2dMap case
              // (where both bin direction are set in each trace)
              // as 2dMap trace never "have to match"
              fillBinOpts(traceOut, groupName, orientation2binDir(traceOut));
          }
      }
  
      // setup binOpts for traces that can but don't have to match,
      // notice that these traces can be matched with traces that have to match
      for(i = 0; i < otherTracesList.length; i++) {
          traceOut = otherTracesList[i];
  
          var binGroup = coerce('bingroup');
  
          if(traceIs(traceOut, '2dMap')) {
              for(k = 0; k < 2; k++) {
                  binDir = BINDIRECTIONS[k];
                  var binGroupInDir = coerce(binDir + 'bingroup',
                      binGroup ? binGroup + '__' + binDir : null
                  );
                  fillBinOpts(traceOut, binGroupInDir, binDir);
              }
          } else {
              fillBinOpts(traceOut, binGroup, orientation2binDir(traceOut));
          }
      }
  
      // coerce bin attrs!
      for(groupName in allBinOpts) {
          var binOpts = allBinOpts[groupName];
          traces = binOpts.traces;
  
          for(j = 0; j < BINATTRS.length; j++) {
              var attrSpec = BINATTRS[j];
              var attr = attrSpec.name;
              var aStr;
              var autoVals;
  
              // nbins(x|y) is moot if we have a size. This depends on
              // nbins coming after size in binAttrs.
              if(attr === 'nbins' && binOpts.sizeFound) continue;
  
              for(i = 0; i < traces.length; i++) {
                  traceOut = traces[i];
                  binDir = binOpts.dirs[i];
                  aStr = attrSpec.aStr[binDir];
  
                  if(nestedProperty(traceOut._input, aStr).get() !== undefined) {
                      binOpts[attr] = coerce(aStr);
                      binOpts[attr + 'Found'] = true;
                      break;
                  }
  
                  autoVals = (traceOut._autoBin || {})[binDir] || {};
                  if(autoVals[attr]) {
                      // if this is the *first* autoval
                      nestedProperty(traceOut, aStr).set(autoVals[attr]);
                  }
              }
  
              // start and end we need to coerce anyway, after having collected the
              // first of each into binOpts, in case a trace wants to restrict its
              // data to a certain range
              if(attr === 'start' || attr === 'end') {
                  for(; i < traces.length; i++) {
                      traceOut = traces[i];
                      if(traceOut['_' + binDir + 'bingroup']) {
                          autoVals = (traceOut._autoBin || {})[binDir] || {};
                          coerce(aStr, autoVals[attr]);
                      }
                  }
              }
  
              if(attr === 'nbins' && !binOpts.sizeFound && !binOpts.nbinsFound) {
                  traceOut = traces[0];
                  binOpts[attr] = coerce(aStr);
              }
          }
      }
  };
  
  },{"../../lib":750,"../../plots/cartesian/axis_ids":802,"../../registry":882,"../bar/defaults":896}],1063:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  
  var handleStyleDefaults = _dereq_('../bar/style_defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var x = coerce('x');
      var y = coerce('y');
  
      var cumulative = coerce('cumulative.enabled');
      if(cumulative) {
          coerce('cumulative.direction');
          coerce('cumulative.currentbin');
      }
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      var orientation = coerce('orientation', (y && !x) ? 'h' : 'v');
      var sampleLetter = orientation === 'v' ? 'x' : 'y';
      var aggLetter = orientation === 'v' ? 'y' : 'x';
  
      var len = (x && y) ?
          Math.min(Lib.minRowLength(x) && Lib.minRowLength(y)) :
          Lib.minRowLength(traceOut[sampleLetter] || []);
  
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      traceOut._length = len;
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
  
      var hasAggregationData = traceOut[aggLetter];
      if(hasAggregationData) coerce('histfunc');
      coerce('histnorm');
  
      // Note: bin defaults are now handled in Histogram.crossTraceDefaults
      // autobin(x|y) are only included here to appease Plotly.validate
      coerce('autobin' + sampleLetter);
  
      handleStyleDefaults(traceIn, traceOut, coerce, defaultColor, layout);
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  
      var lineColor = (traceOut.marker.line || {}).color;
  
      // override defaultColor for error bars with defaultLine
      var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {axis: 'y'});
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || Color.defaultLine, {axis: 'x', inherit: 'y'});
  };
  
  },{"../../components/color":615,"../../lib":750,"../../registry":882,"../bar/style_defaults":907,"./attributes":1055}],1064:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt, trace, cd, pointNumber) {
      // standard cartesian event data
      out.x = 'xVal' in pt ? pt.xVal : pt.x;
      out.y = 'yVal' in pt ? pt.yVal : pt.y;
  
      // for 2d histograms
      if('zLabelVal' in pt) out.z = pt.zLabelVal;
  
      if(pt.xa) out.xaxis = pt.xa;
      if(pt.ya) out.yaxis = pt.ya;
  
      // specific to histogram - CDFs do not have pts (yet?)
      if(!(trace.cumulative || {}).enabled) {
          var pts = Array.isArray(pointNumber) ?
              cd[0].pts[pointNumber[0]][pointNumber[1]] :
              cd[pointNumber].pts;
  
          out.pointNumbers = pts;
          out.binNumber = out.pointNumber;
          delete out.pointNumber;
          delete out.pointIndex;
  
          var pointIndices;
          if(trace._indexToPoints) {
              pointIndices = [];
              for(var i = 0; i < pts.length; i++) {
                  pointIndices = pointIndices.concat(trace._indexToPoints[pts[i]]);
              }
          } else {
              pointIndices = pts;
          }
  
          out.pointIndices = pointIndices;
      }
  
      return out;
  };
  
  },{}],1065:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var barHover = _dereq_('../bar/hover').hoverPoints;
  var hoverLabelText = _dereq_('../../plots/cartesian/axes').hoverLabelText;
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
      var pts = barHover(pointData, xval, yval, hovermode);
  
      if(!pts) return;
  
      pointData = pts[0];
      var di = pointData.cd[pointData.index];
      var trace = pointData.cd[0].trace;
  
      if(!trace.cumulative.enabled) {
          var posLetter = trace.orientation === 'h' ? 'y' : 'x';
  
          pointData[posLetter + 'Label'] = hoverLabelText(pointData[posLetter + 'a'], di.ph0, di.ph1);
      }
  
      return pts;
  };
  
  },{"../../plots/cartesian/axes":799,"../bar/hover":899}],1066:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /**
   * Histogram has its own attribute, defaults and calc steps,
   * but uses bar's plot to display
   * and bar's crossTraceCalc (formerly known as setPositions) for stacking and grouping
   */
  
  /**
   * histogram errorBarsOK is debatable, but it's put in for backward compat.
   * there are use cases for it - sqrt for a simple histogram works right now,
   * constant and % work but they're not so meaningful. I guess it could be cool
   * to allow quadrature combination of errors in summed histograms...
   */
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('../bar/layout_attributes'),
      supplyDefaults: _dereq_('./defaults'),
      crossTraceDefaults: _dereq_('./cross_trace_defaults'),
      supplyLayoutDefaults: _dereq_('../bar/layout_defaults'),
      calc: _dereq_('./calc').calc,
      crossTraceCalc: _dereq_('../bar/cross_trace_calc').crossTraceCalc,
      plot: _dereq_('../bar/plot').plot,
      layerName: 'barlayer',
      style: _dereq_('../bar/style').style,
      styleOnSelect: _dereq_('../bar/style').styleOnSelect,
      colorbar: _dereq_('../scatter/marker_colorbar'),
      hoverPoints: _dereq_('./hover'),
      selectPoints: _dereq_('../bar/select'),
      eventData: _dereq_('./event_data'),
  
      moduleType: 'trace',
      name: 'histogram',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['bar-like', 'cartesian', 'svg', 'bar', 'histogram', 'oriented', 'errorBarsOK', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"../bar/cross_trace_calc":895,"../bar/layout_attributes":901,"../bar/layout_defaults":902,"../bar/plot":903,"../bar/select":904,"../bar/style":906,"../scatter/marker_colorbar":1176,"./attributes":1055,"./calc":1060,"./cross_trace_defaults":1062,"./defaults":1063,"./event_data":1064,"./hover":1065}],1067:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  module.exports = {
      percent: function(size, total) {
          var nMax = size.length;
          var norm = 100 / total;
          for(var n = 0; n < nMax; n++) size[n] *= norm;
      },
      probability: function(size, total) {
          var nMax = size.length;
          for(var n = 0; n < nMax; n++) size[n] /= total;
      },
      density: function(size, total, inc, yinc) {
          var nMax = size.length;
          yinc = yinc || 1;
          for(var n = 0; n < nMax; n++) size[n] *= inc[n] * yinc;
      },
      'probability density': function(size, total, inc, yinc) {
          var nMax = size.length;
          if(yinc) total /= yinc;
          for(var n = 0; n < nMax; n++) size[n] *= inc[n] / total;
      }
  };
  
  },{}],1068:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var histogramAttrs = _dereq_('../histogram/attributes');
  var makeBinAttrs = _dereq_('../histogram/bin_attributes');
  var heatmapAttrs = _dereq_('../heatmap/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = extendFlat(
      {
          x: histogramAttrs.x,
          y: histogramAttrs.y,
  
          z: {
              valType: 'data_array',
              editType: 'calc',
              
          },
          marker: {
              color: {
                  valType: 'data_array',
                  editType: 'calc',
                  
              },
              editType: 'calc'
          },
  
          histnorm: histogramAttrs.histnorm,
          histfunc: histogramAttrs.histfunc,
          nbinsx: histogramAttrs.nbinsx,
          xbins: makeBinAttrs('x'),
          nbinsy: histogramAttrs.nbinsy,
          ybins: makeBinAttrs('y'),
          autobinx: histogramAttrs.autobinx,
          autobiny: histogramAttrs.autobiny,
  
          bingroup: extendFlat({}, histogramAttrs.bingroup, {
              
          }),
          xbingroup: extendFlat({}, histogramAttrs.bingroup, {
              
          }),
          ybingroup: extendFlat({}, histogramAttrs.bingroup, {
              
          }),
  
          xgap: heatmapAttrs.xgap,
          ygap: heatmapAttrs.ygap,
          zsmooth: heatmapAttrs.zsmooth,
          zhoverformat: heatmapAttrs.zhoverformat,
          hovertemplate: hovertemplateAttrs({}, {keys: 'z'}),
          showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
      },
      colorScaleAttrs('', {cLetter: 'z', autoColorDflt: false})
  );
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../heatmap/attributes":1036,"../histogram/attributes":1055,"../histogram/bin_attributes":1057}],1069:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  var binFunctions = _dereq_('../histogram/bin_functions');
  var normFunctions = _dereq_('../histogram/norm_functions');
  var doAvg = _dereq_('../histogram/average');
  var getBinSpanLabelRound = _dereq_('../histogram/bin_label_vals');
  var calcAllAutoBins = _dereq_('../histogram/calc').calcAllAutoBins;
  
  module.exports = function calc(gd, trace) {
      var xa = Axes.getFromId(gd, trace.xaxis);
      var ya = Axes.getFromId(gd, trace.yaxis);
  
      var xcalendar = trace.xcalendar;
      var ycalendar = trace.ycalendar;
      var xr2c = function(v) { return xa.r2c(v, 0, xcalendar); };
      var yr2c = function(v) { return ya.r2c(v, 0, ycalendar); };
      var xc2r = function(v) { return xa.c2r(v, 0, xcalendar); };
      var yc2r = function(v) { return ya.c2r(v, 0, ycalendar); };
  
      var i, j, n, m;
  
      // calculate the bins
      var xBinsAndPos = calcAllAutoBins(gd, trace, xa, 'x');
      var xBinSpec = xBinsAndPos[0];
      var xPos0 = xBinsAndPos[1];
      var yBinsAndPos = calcAllAutoBins(gd, trace, ya, 'y');
      var yBinSpec = yBinsAndPos[0];
      var yPos0 = yBinsAndPos[1];
  
      var serieslen = trace._length;
      if(xPos0.length > serieslen) xPos0.splice(serieslen, xPos0.length - serieslen);
      if(yPos0.length > serieslen) yPos0.splice(serieslen, yPos0.length - serieslen);
  
      // make the empty bin array & scale the map
      var z = [];
      var onecol = [];
      var zerocol = [];
      var nonuniformBinsX = typeof xBinSpec.size === 'string';
      var nonuniformBinsY = typeof yBinSpec.size === 'string';
      var xEdges = [];
      var yEdges = [];
      var xbins = nonuniformBinsX ? xEdges : xBinSpec;
      var ybins = nonuniformBinsY ? yEdges : yBinSpec;
      var total = 0;
      var counts = [];
      var inputPoints = [];
      var norm = trace.histnorm;
      var func = trace.histfunc;
      var densitynorm = norm.indexOf('density') !== -1;
      var extremefunc = func === 'max' || func === 'min';
      var sizeinit = extremefunc ? null : 0;
      var binfunc = binFunctions.count;
      var normfunc = normFunctions[norm];
      var doavg = false;
      var xinc = [];
      var yinc = [];
  
      // set a binning function other than count?
      // for binning functions: check first for 'z',
      // then 'mc' in case we had a colored scatter plot
      // and want to transfer these colors to the 2D histo
      // TODO: axe this, make it the responsibility of the app changing type? or an impliedEdit?
      var rawCounterData = ('z' in trace) ?
          trace.z :
          (('marker' in trace && Array.isArray(trace.marker.color)) ?
              trace.marker.color : '');
      if(rawCounterData && func !== 'count') {
          doavg = func === 'avg';
          binfunc = binFunctions[func];
      }
  
      // decrease end a little in case of rounding errors
      var xBinSize = xBinSpec.size;
      var xBinStart = xr2c(xBinSpec.start);
      var xBinEnd = xr2c(xBinSpec.end) +
          (xBinStart - Axes.tickIncrement(xBinStart, xBinSize, false, xcalendar)) / 1e6;
  
      for(i = xBinStart; i < xBinEnd; i = Axes.tickIncrement(i, xBinSize, false, xcalendar)) {
          onecol.push(sizeinit);
          xEdges.push(i);
          if(doavg) zerocol.push(0);
      }
      xEdges.push(i);
  
      var nx = onecol.length;
      var dx = (i - xBinStart) / nx;
      var x0 = xc2r(xBinStart + dx / 2);
  
      var yBinSize = yBinSpec.size;
      var yBinStart = yr2c(yBinSpec.start);
      var yBinEnd = yr2c(yBinSpec.end) +
          (yBinStart - Axes.tickIncrement(yBinStart, yBinSize, false, ycalendar)) / 1e6;
  
      for(i = yBinStart; i < yBinEnd; i = Axes.tickIncrement(i, yBinSize, false, ycalendar)) {
          z.push(onecol.slice());
          yEdges.push(i);
          var ipCol = new Array(nx);
          for(j = 0; j < nx; j++) ipCol[j] = [];
          inputPoints.push(ipCol);
          if(doavg) counts.push(zerocol.slice());
      }
      yEdges.push(i);
  
      var ny = z.length;
      var dy = (i - yBinStart) / ny;
      var y0 = yc2r(yBinStart + dy / 2);
  
      if(densitynorm) {
          xinc = makeIncrements(onecol.length, xbins, dx, nonuniformBinsX);
          yinc = makeIncrements(z.length, ybins, dy, nonuniformBinsY);
      }
  
      // for date axes we need bin bounds to be calcdata. For nonuniform bins
      // we already have this, but uniform with start/end/size they're still strings.
      if(!nonuniformBinsX && xa.type === 'date') xbins = binsToCalc(xr2c, xbins);
      if(!nonuniformBinsY && ya.type === 'date') ybins = binsToCalc(yr2c, ybins);
  
      // put data into bins
      var uniqueValsPerX = true;
      var uniqueValsPerY = true;
      var xVals = new Array(nx);
      var yVals = new Array(ny);
      var xGapLow = Infinity;
      var xGapHigh = Infinity;
      var yGapLow = Infinity;
      var yGapHigh = Infinity;
      for(i = 0; i < serieslen; i++) {
          var xi = xPos0[i];
          var yi = yPos0[i];
          n = Lib.findBin(xi, xbins);
          m = Lib.findBin(yi, ybins);
          if(n >= 0 && n < nx && m >= 0 && m < ny) {
              total += binfunc(n, i, z[m], rawCounterData, counts[m]);
              inputPoints[m][n].push(i);
  
              if(uniqueValsPerX) {
                  if(xVals[n] === undefined) xVals[n] = xi;
                  else if(xVals[n] !== xi) uniqueValsPerX = false;
              }
              if(uniqueValsPerY) {
                  if(yVals[m] === undefined) yVals[m] = yi;
                  else if(yVals[m] !== yi) uniqueValsPerY = false;
              }
  
              xGapLow = Math.min(xGapLow, xi - xEdges[n]);
              xGapHigh = Math.min(xGapHigh, xEdges[n + 1] - xi);
              yGapLow = Math.min(yGapLow, yi - yEdges[m]);
              yGapHigh = Math.min(yGapHigh, yEdges[m + 1] - yi);
          }
      }
      // normalize, if needed
      if(doavg) {
          for(m = 0; m < ny; m++) total += doAvg(z[m], counts[m]);
      }
      if(normfunc) {
          for(m = 0; m < ny; m++) normfunc(z[m], total, xinc, yinc[m]);
      }
  
      return {
          x: xPos0,
          xRanges: getRanges(xEdges, uniqueValsPerX && xVals, xGapLow, xGapHigh, xa, xcalendar),
          x0: x0,
          dx: dx,
          y: yPos0,
          yRanges: getRanges(yEdges, uniqueValsPerY && yVals, yGapLow, yGapHigh, ya, ycalendar),
          y0: y0,
          dy: dy,
          z: z,
          pts: inputPoints
      };
  };
  
  function makeIncrements(len, bins, dv, nonuniform) {
      var out = new Array(len);
      var i;
      if(nonuniform) {
          for(i = 0; i < len; i++) out[i] = 1 / (bins[i + 1] - bins[i]);
      } else {
          var inc = 1 / dv;
          for(i = 0; i < len; i++) out[i] = inc;
      }
      return out;
  }
  
  function binsToCalc(r2c, bins) {
      return {
          start: r2c(bins.start),
          end: r2c(bins.end),
          size: bins.size
      };
  }
  
  function getRanges(edges, uniqueVals, gapLow, gapHigh, ax, calendar) {
      var i;
      var len = edges.length - 1;
      var out = new Array(len);
      var roundFn = getBinSpanLabelRound(gapLow, gapHigh, edges, ax, calendar);
  
      for(i = 0; i < len; i++) {
          var v = (uniqueVals || [])[i];
          out[i] = v === undefined ?
              [roundFn(edges[i]), roundFn(edges[i + 1], true)] :
              [v, v];
      }
      return out;
  }
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"../histogram/average":1056,"../histogram/bin_functions":1058,"../histogram/bin_label_vals":1059,"../histogram/calc":1060,"../histogram/norm_functions":1067}],1070:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleSampleDefaults = _dereq_('./sample_defaults');
  var handleStyleDefaults = _dereq_('../heatmap/style_defaults');
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      handleSampleDefaults(traceIn, traceOut, coerce, layout);
      if(traceOut.visible === false) return;
  
      handleStyleDefaults(traceIn, traceOut, coerce, layout);
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'z'});
      coerce('hovertemplate');
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"../heatmap/style_defaults":1049,"./attributes":1068,"./sample_defaults":1073}],1071:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var heatmapHover = _dereq_('../heatmap/hover');
  var hoverLabelText = _dereq_('../../plots/cartesian/axes').hoverLabelText;
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode, hoverLayer, contour) {
      var pts = heatmapHover(pointData, xval, yval, hovermode, hoverLayer, contour);
  
      if(!pts) return;
  
      pointData = pts[0];
      var indices = pointData.index;
      var ny = indices[0];
      var nx = indices[1];
      var cd0 = pointData.cd[0];
      var xRange = cd0.xRanges[nx];
      var yRange = cd0.yRanges[ny];
  
      pointData.xLabel = hoverLabelText(pointData.xa, xRange[0], xRange[1]);
      pointData.yLabel = hoverLabelText(pointData.ya, yRange[0], yRange[1]);
  
      return pts;
  };
  
  },{"../../plots/cartesian/axes":799,"../heatmap/hover":1043}],1072:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      crossTraceDefaults: _dereq_('../histogram/cross_trace_defaults'),
      calc: _dereq_('../heatmap/calc'),
      plot: _dereq_('../heatmap/plot'),
      layerName: 'heatmaplayer',
      colorbar: _dereq_('../heatmap/colorbar'),
      style: _dereq_('../heatmap/style'),
      hoverPoints: _dereq_('./hover'),
      eventData: _dereq_('../histogram/event_data'),
  
      moduleType: 'trace',
      name: 'histogram2d',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', '2dMap', 'histogram', 'showLegend'],
      meta: {
          
          
      }
  };
  
  },{"../../plots/cartesian":812,"../heatmap/calc":1037,"../heatmap/colorbar":1039,"../heatmap/plot":1047,"../heatmap/style":1048,"../histogram/cross_trace_defaults":1062,"../histogram/event_data":1064,"./attributes":1068,"./defaults":1070,"./hover":1071}],1073:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  
  module.exports = function handleSampleDefaults(traceIn, traceOut, coerce, layout) {
      var x = coerce('x');
      var y = coerce('y');
      var xlen = Lib.minRowLength(x);
      var ylen = Lib.minRowLength(y);
  
      // we could try to accept x0 and dx, etc...
      // but that's a pretty weird use case.
      // for now require both x and y explicitly specified.
      if(!xlen || !ylen) {
          traceOut.visible = false;
          return;
      }
  
      traceOut._length = Math.min(xlen, ylen);
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
  
      // if marker.color is an array, we can use it in aggregation instead of z
      var hasAggregationData = coerce('z') || coerce('marker.color');
  
      if(hasAggregationData) coerce('histfunc');
      coerce('histnorm');
  
      // Note: bin defaults are now handled in Histogram2D.crossTraceDefaults
      // autobin(x|y) are only included here to appease Plotly.validate
      coerce('autobinx');
      coerce('autobiny');
  };
  
  },{"../../lib":750,"../../registry":882}],1074:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var histogram2dAttrs = _dereq_('../histogram2d/attributes');
  var contourAttrs = _dereq_('../contour/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = extendFlat({
      x: histogram2dAttrs.x,
      y: histogram2dAttrs.y,
      z: histogram2dAttrs.z,
      marker: histogram2dAttrs.marker,
  
      histnorm: histogram2dAttrs.histnorm,
      histfunc: histogram2dAttrs.histfunc,
      nbinsx: histogram2dAttrs.nbinsx,
      xbins: histogram2dAttrs.xbins,
      nbinsy: histogram2dAttrs.nbinsy,
      ybins: histogram2dAttrs.ybins,
      autobinx: histogram2dAttrs.autobinx,
      autobiny: histogram2dAttrs.autobiny,
  
      bingroup: histogram2dAttrs.bingroup,
      xbingroup: histogram2dAttrs.xbingroup,
      ybingroup: histogram2dAttrs.ybingroup,
  
      autocontour: contourAttrs.autocontour,
      ncontours: contourAttrs.ncontours,
      contours: contourAttrs.contours,
      line: {
          color: contourAttrs.line.color,
          width: extendFlat({}, contourAttrs.line.width, {
              dflt: 0.5,
              
          }),
          dash: contourAttrs.line.dash,
          smoothing: contourAttrs.line.smoothing,
          editType: 'plot'
      },
      zhoverformat: histogram2dAttrs.zhoverformat,
      hovertemplate: histogram2dAttrs.hovertemplate
  },
      colorScaleAttrs('', {
          cLetter: 'z',
          editTypeOverride: 'calc'
      })
  );
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../contour/attributes":979,"../histogram2d/attributes":1068}],1075:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleSampleDefaults = _dereq_('../histogram2d/sample_defaults');
  var handleContoursDefaults = _dereq_('../contour/contours_defaults');
  var handleStyleDefaults = _dereq_('../contour/style_defaults');
  var attributes = _dereq_('./attributes');
  
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      function coerce2(attr) {
          return Lib.coerce2(traceIn, traceOut, attributes, attr);
      }
  
      handleSampleDefaults(traceIn, traceOut, coerce, layout);
      if(traceOut.visible === false) return;
  
      handleContoursDefaults(traceIn, traceOut, coerce, coerce2);
      handleStyleDefaults(traceIn, traceOut, coerce, layout);
      coerce('hovertemplate');
  };
  
  },{"../../lib":750,"../contour/contours_defaults":986,"../contour/style_defaults":1000,"../histogram2d/sample_defaults":1073,"./attributes":1074}],1076:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      crossTraceDefaults: _dereq_('../histogram/cross_trace_defaults'),
      calc: _dereq_('../contour/calc'),
      plot: _dereq_('../contour/plot').plot,
      layerName: 'contourlayer',
      style: _dereq_('../contour/style'),
      colorbar: _dereq_('../contour/colorbar'),
      hoverPoints: _dereq_('../contour/hover'),
  
      moduleType: 'trace',
      name: 'histogram2dcontour',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', '2dMap', 'contour', 'histogram', 'showLegend'],
      meta: {
          
          
      }
  };
  
  },{"../../plots/cartesian":812,"../contour/calc":980,"../contour/colorbar":982,"../contour/hover":992,"../contour/plot":997,"../contour/style":999,"../histogram/cross_trace_defaults":1062,"./attributes":1074,"./defaults":1075}],1077:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var baseAttrs = _dereq_('../../plots/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var colormodel = _dereq_('./constants').colormodel;
  
  var cm = ['rgb', 'rgba', 'rgba256', 'hsl', 'hsla'];
  var zminDesc = [];
  var zmaxDesc = [];
  for(var i = 0; i < cm.length; i++) {
      var cr = colormodel[cm[i]];
      zminDesc.push('For the `' + cm[i] + '` colormodel, it is [' + (cr.zminDflt || cr.min).join(', ') + '].');
      zmaxDesc.push('For the `' + cm[i] + '` colormodel, it is [' + (cr.zmaxDflt || cr.max).join(', ') + '].');
  }
  
  module.exports = extendFlat({
      source: {
          valType: 'string',
          
          editType: 'calc',
          
      },
      z: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
      colormodel: {
          valType: 'enumerated',
          values: cm,
          
          editType: 'calc',
          
      },
      zmin: {
          valType: 'info_array',
          items: [
              {valType: 'number', editType: 'calc'},
              {valType: 'number', editType: 'calc'},
              {valType: 'number', editType: 'calc'},
              {valType: 'number', editType: 'calc'}
          ],
          
          editType: 'calc',
          
      },
      zmax: {
          valType: 'info_array',
          items: [
              {valType: 'number', editType: 'calc'},
              {valType: 'number', editType: 'calc'},
              {valType: 'number', editType: 'calc'},
              {valType: 'number', editType: 'calc'}
          ],
          
          editType: 'calc',
          
      },
      x0: {
          valType: 'any',
          dflt: 0,
          
          editType: 'calc+clearAxisTypes',
          
      },
      y0: {
          valType: 'any',
          dflt: 0,
          
          editType: 'calc+clearAxisTypes',
          
      },
      dx: {
          valType: 'number',
          dflt: 1,
          
          editType: 'calc',
          
      },
      dy: {
          valType: 'number',
          dflt: 1,
          
          editType: 'calc',
          
      },
      text: {
          valType: 'data_array',
          editType: 'plot',
          
      },
      hovertext: {
          valType: 'data_array',
          editType: 'plot',
          
      },
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['x', 'y', 'z', 'color', 'name', 'text'],
          dflt: 'x+y+z+text+name'
      }),
      hovertemplate: hovertemplateAttrs({}, {
          keys: ['z', 'color', 'colormodel']
      }),
  
      transforms: undefined
  });
  
  },{"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"./constants":1079}],1078:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var constants = _dereq_('./constants');
  var isNumeric = _dereq_('fast-isnumeric');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var maxRowLength = _dereq_('../../lib').maxRowLength;
  var getImageSize = _dereq_('./helpers').getImageSize;
  
  module.exports = function calc(gd, trace) {
      var h;
      var w;
      if(trace._hasZ) {
          h = trace.z.length;
          w = maxRowLength(trace.z);
      } else if(trace._hasSource) {
          var size = getImageSize(trace.source);
          h = size.height;
          w = size.width;
      }
  
      var xa = Axes.getFromId(gd, trace.xaxis || 'x');
      var ya = Axes.getFromId(gd, trace.yaxis || 'y');
  
      var x0 = xa.d2c(trace.x0) - trace.dx / 2;
      var y0 = ya.d2c(trace.y0) - trace.dy / 2;
  
      // Set axis range
      var i;
      var xrange = [x0, x0 + w * trace.dx];
      var yrange = [y0, y0 + h * trace.dy];
      if(xa && xa.type === 'log') for(i = 0; i < w; i++) xrange.push(x0 + i * trace.dx);
      if(ya && ya.type === 'log') for(i = 0; i < h; i++) yrange.push(y0 + i * trace.dy);
      trace._extremes[xa._id] = Axes.findExtremes(xa, xrange);
      trace._extremes[ya._id] = Axes.findExtremes(ya, yrange);
      trace._scaler = makeScaler(trace);
  
      var cd0 = {
          x0: x0,
          y0: y0,
          z: trace.z,
          w: w,
          h: h
      };
      return [cd0];
  };
  
  function scale(zero, ratio, min, max) {
      return function(c) {
          return Lib.constrain((c - zero) * ratio, min, max);
      };
  }
  
  function constrain(min, max) {
      return function(c) { return Lib.constrain(c, min, max);};
  }
  
  // Generate a function to scale color components according to zmin/zmax and the colormodel
  function makeScaler(trace) {
      var cr = constants.colormodel[trace.colormodel];
      var colormodel = (cr.colormodel || trace.colormodel);
      var n = colormodel.length;
  
      trace._sArray = [];
      // Loop over all color components
      for(var k = 0; k < n; k++) {
          if(cr.min[k] !== trace.zmin[k] || cr.max[k] !== trace.zmax[k]) {
              trace._sArray.push(scale(
                  trace.zmin[k],
                  (cr.max[k] - cr.min[k]) / (trace.zmax[k] - trace.zmin[k]),
                  cr.min[k],
                  cr.max[k]
              ));
          } else {
              trace._sArray.push(constrain(cr.min[k], cr.max[k]));
          }
      }
  
      return function(pixel) {
          var c = pixel.slice(0, n);
          for(var k = 0; k < n; k++) {
              var ck = c[k];
              if(!isNumeric(ck)) return false;
              c[k] = trace._sArray[k](ck);
          }
          return c;
      };
  }
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"./constants":1079,"./helpers":1082,"fast-isnumeric":241}],1079:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      colormodel: {
          // min and max define the numerical range accepted in CSS
          // If z(min|max)Dflt are not defined, z(min|max) will default to min/max
          rgb: {
              min: [0, 0, 0],
              max: [255, 255, 255],
              fmt: function(c) {return c.slice(0, 3);},
              suffix: ['', '', '']
          },
          rgba: {
              min: [0, 0, 0, 0],
              max: [255, 255, 255, 1],
              fmt: function(c) {return c.slice(0, 4);},
              suffix: ['', '', '', '']
          },
          rgba256: {
              colormodel: 'rgba', // because rgba256 is not an accept colormodel in CSS
              zminDflt: [0, 0, 0, 0],
              zmaxDflt: [255, 255, 255, 255],
              min: [0, 0, 0, 0],
              max: [255, 255, 255, 1],
              fmt: function(c) {return c.slice(0, 4);},
              suffix: ['', '', '', '']
          },
          hsl: {
              min: [0, 0, 0],
              max: [360, 100, 100],
              fmt: function(c) {
                  var p = c.slice(0, 3);
                  p[1] = p[1] + '%';
                  p[2] = p[2] + '%';
                  return p;
              },
              suffix: ['°', '%', '%']
          },
          hsla: {
              min: [0, 0, 0, 0],
              max: [360, 100, 100, 1],
              fmt: function(c) {
                  var p = c.slice(0, 4);
                  p[1] = p[1] + '%';
                  p[2] = p[2] + '%';
                  return p;
              },
              suffix: ['°', '%', '%', '']
          }
      }
  };
  
  },{}],1080:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var constants = _dereq_('./constants');
  var dataUri = _dereq_('../../snapshot/helpers').IMAGE_URL_PREFIX;
  
  module.exports = function supplyDefaults(traceIn, traceOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
      coerce('source');
      // sanitize source to only allow for data URI representing images
      if(traceOut.source && !traceOut.source.match(dataUri)) delete traceOut.source;
      traceOut._hasSource = !!traceOut.source;
  
      var z = coerce('z');
      traceOut._hasZ = !(z === undefined || !z.length || !z[0] || !z[0].length);
      if(!traceOut._hasZ && !traceOut._hasSource) {
          traceOut.visible = false;
          return;
      }
  
      coerce('x0');
      coerce('y0');
      coerce('dx');
      coerce('dy');
  
      var cm;
      if(traceOut._hasZ) {
          coerce('colormodel', 'rgb');
          cm = constants.colormodel[traceOut.colormodel];
          coerce('zmin', (cm.zminDflt || cm.min));
          coerce('zmax', (cm.zmaxDflt || cm.max));
      } else if(traceOut._hasSource) {
          traceOut.colormodel = 'rgba256';
          cm = constants.colormodel[traceOut.colormodel];
          traceOut.zmin = cm.zminDflt;
          traceOut.zmax = cm.zmaxDflt;
      }
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      traceOut._length = null;
  };
  
  },{"../../lib":750,"../../snapshot/helpers":886,"./attributes":1077,"./constants":1079}],1081:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt) {
      if('xVal' in pt) out.x = pt.xVal;
      if('yVal' in pt) out.y = pt.yVal;
      if(pt.xa) out.xaxis = pt.xa;
      if(pt.ya) out.yaxis = pt.ya;
      out.color = pt.color;
      out.colormodel = pt.trace.colormodel;
      if(!out.z) out.z = pt.color;
      return out;
  };
  
  },{}],1082:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var sizeOf = _dereq_('image-size');
  var dataUri = _dereq_('../../snapshot/helpers').IMAGE_URL_PREFIX;
  var Buffer = _dereq_('buffer/').Buffer;  // note: the trailing slash is important!
  
  exports.getImageSize = function(src) {
      var data = src.replace(dataUri, '');
      var buff = new Buffer(data, 'base64');
      return sizeOf(buff);
  };
  
  },{"../../snapshot/helpers":886,"buffer/":111,"image-size":418}],1083:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Fx = _dereq_('../../components/fx');
  var Lib = _dereq_('../../lib');
  var constants = _dereq_('./constants');
  
  module.exports = function hoverPoints(pointData, xval, yval) {
      var cd0 = pointData.cd[0];
      var trace = cd0.trace;
      var xa = pointData.xa;
      var ya = pointData.ya;
  
      // Return early if not on image
      if(Fx.inbox(xval - cd0.x0, xval - (cd0.x0 + cd0.w * trace.dx), 0) > 0 ||
              Fx.inbox(yval - cd0.y0, yval - (cd0.y0 + cd0.h * trace.dy), 0) > 0) {
          return;
      }
  
      // Find nearest pixel's index
      var nx = Math.floor((xval - cd0.x0) / trace.dx);
      var ny = Math.floor(Math.abs(yval - cd0.y0) / trace.dy);
  
      var pixel;
      if(trace._hasZ) {
          pixel = cd0.z[ny][nx];
      } else if(trace._hasSource) {
          pixel = trace._canvas.el.getContext('2d').getImageData(nx, ny, 1, 1).data;
      }
  
      // return early if pixel is undefined
      if(!pixel) return;
  
      var hoverinfo = cd0.hi || trace.hoverinfo;
      var fmtColor;
      if(hoverinfo) {
          var parts = hoverinfo.split('+');
          if(parts.indexOf('all') !== -1) parts = ['color'];
          if(parts.indexOf('color') !== -1) fmtColor = true;
      }
  
      var cr = constants.colormodel[trace.colormodel];
      var colormodel = cr.colormodel || trace.colormodel;
      var dims = colormodel.length;
      var c = trace._scaler(pixel);
      var s = cr.suffix;
  
      var colorstring = [];
      if(trace.hovertemplate || fmtColor) {
          colorstring.push('[' + [c[0] + s[0], c[1] + s[1], c[2] + s[2]].join(', '));
          if(dims === 4) colorstring.push(', ' + c[3] + s[3]);
          colorstring.push(']');
          colorstring = colorstring.join('');
          pointData.extraText = colormodel.toUpperCase() + ': ' + colorstring;
      }
  
      var text;
      if(Array.isArray(trace.hovertext) && Array.isArray(trace.hovertext[ny])) {
          text = trace.hovertext[ny][nx];
      } else if(Array.isArray(trace.text) && Array.isArray(trace.text[ny])) {
          text = trace.text[ny][nx];
      }
  
      // TODO: for color model with 3 dims, display something useful for hovertemplate `%{color[3]}`
      var py = ya.c2p(cd0.y0 + (ny + 0.5) * trace.dy);
      var xVal = cd0.x0 + (nx + 0.5) * trace.dx;
      var yVal = cd0.y0 + (ny + 0.5) * trace.dy;
      var zLabel = '[' + pixel.slice(0, trace.colormodel.length).join(', ') + ']';
      return [Lib.extendFlat(pointData, {
          index: [ny, nx],
          x0: xa.c2p(cd0.x0 + nx * trace.dx),
          x1: xa.c2p(cd0.x0 + (nx + 1) * trace.dx),
          y0: py,
          y1: py,
          color: c,
          xVal: xVal,
          xLabelVal: xVal,
          yVal: yVal,
          yLabelVal: yVal,
          zLabelVal: zLabel,
          text: text,
          hovertemplateLabels: {
              'zLabel': zLabel,
              'colorLabel': colorstring,
              'color[0]Label': c[0] + s[0],
              'color[1]Label': c[1] + s[1],
              'color[2]Label': c[2] + s[2],
              'color[3]Label': c[3] + s[3]
          }
      })];
  };
  
  },{"../../components/fx":655,"../../lib":750,"./constants":1079}],1084:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      style: _dereq_('./style'),
      hoverPoints: _dereq_('./hover'),
      eventData: _dereq_('./event_data'),
  
      moduleType: 'trace',
      name: 'image',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', '2dMap', 'noSortingByValue'],
      animatable: false,
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"./attributes":1077,"./calc":1078,"./defaults":1080,"./event_data":1081,"./hover":1083,"./plot":1085,"./style":1086}],1085:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../lib');
  var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
  var constants = _dereq_('./constants');
  
  var unsupportedBrowsers = Lib.isIOS() || Lib.isSafari() || Lib.isIE();
  
  function compatibleAxis(ax) {
      return ax.type === 'linear' &&
          // y axis must be reversed but x axis mustn't be
          ((ax.range[1] > ax.range[0]) === (ax._id.charAt(0) === 'x'));
  }
  
  module.exports = function plot(gd, plotinfo, cdimage, imageLayer) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      var supportsPixelatedImage = !(unsupportedBrowsers || gd._context._exportedPlot);
  
      Lib.makeTraceGroups(imageLayer, cdimage, 'im').each(function(cd) {
          var plotGroup = d3.select(this);
          var cd0 = cd[0];
          var trace = cd0.trace;
          var fastImage = supportsPixelatedImage && !trace._hasZ && trace._hasSource && compatibleAxis(xa) && compatibleAxis(ya);
          trace._fastImage = fastImage;
  
          var z = cd0.z;
          var x0 = cd0.x0;
          var y0 = cd0.y0;
          var w = cd0.w;
          var h = cd0.h;
          var dx = trace.dx;
          var dy = trace.dy;
  
          var left, right, temp, top, bottom, i;
          // in case of log of a negative
          i = 0;
          while(left === undefined && i < w) {
              left = xa.c2p(x0 + i * dx);
              i++;
          }
          i = w;
          while(right === undefined && i > 0) {
              right = xa.c2p(x0 + i * dx);
              i--;
          }
          i = 0;
          while(top === undefined && i < h) {
              top = ya.c2p(y0 + i * dy);
              i++;
          }
          i = h;
          while(bottom === undefined && i > 0) {
              bottom = ya.c2p(y0 + i * dy);
              i--;
          }
  
          if(right < left) {
              temp = right;
              right = left;
              left = temp;
          }
  
          if(bottom < top) {
              temp = top;
              top = bottom;
              bottom = temp;
          }
  
          // Reduce image size when zoomed in to save memory
          if(!fastImage) {
              var extra = 0.5; // half the axis size
              left = Math.max(-extra * xa._length, left);
              right = Math.min((1 + extra) * xa._length, right);
              top = Math.max(-extra * ya._length, top);
              bottom = Math.min((1 + extra) * ya._length, bottom);
          }
  
          var imageWidth = Math.round(right - left);
          var imageHeight = Math.round(bottom - top);
  
          // if image is entirely off-screen, don't even draw it
          var isOffScreen = (imageWidth <= 0 || imageHeight <= 0);
          if(isOffScreen) {
              var noImage = plotGroup.selectAll('image').data([]);
              noImage.exit().remove();
              return;
          }
  
          // Create a new canvas and draw magnified pixels on it
          function drawMagnifiedPixelsOnCanvas(readPixel) {
              var canvas = document.createElement('canvas');
              canvas.width = imageWidth;
              canvas.height = imageHeight;
              var context = canvas.getContext('2d');
  
              var ipx = function(i) {return Lib.constrain(Math.round(xa.c2p(x0 + i * dx) - left), 0, imageWidth);};
              var jpx = function(j) {return Lib.constrain(Math.round(ya.c2p(y0 + j * dy) - top), 0, imageHeight);};
  
              var cr = constants.colormodel[trace.colormodel];
              var colormodel = (cr.colormodel || trace.colormodel);
              var fmt = cr.fmt;
              var c;
              for(i = 0; i < cd0.w; i++) {
                  var ipx0 = ipx(i); var ipx1 = ipx(i + 1);
                  if(ipx1 === ipx0 || isNaN(ipx1) || isNaN(ipx0)) continue;
                  for(var j = 0; j < cd0.h; j++) {
                      var jpx0 = jpx(j); var jpx1 = jpx(j + 1);
                      if(jpx1 === jpx0 || isNaN(jpx1) || isNaN(jpx0) || !readPixel(i, j)) continue;
                      c = trace._scaler(readPixel(i, j));
                      if(c) {
                          context.fillStyle = colormodel + '(' + fmt(c).join(',') + ')';
                      } else {
                          // Return a transparent pixel
                          context.fillStyle = 'rgba(0,0,0,0)';
                      }
                      context.fillRect(ipx0, jpx0, ipx1 - ipx0, jpx1 - jpx0);
                  }
              }
  
              return canvas;
          }
  
          var image3 = plotGroup.selectAll('image')
              .data([cd]);
  
          image3.enter().append('svg:image').attr({
              xmlns: xmlnsNamespaces.svg,
              preserveAspectRatio: 'none'
          });
  
          image3.exit().remove();
  
          // Pixelated image rendering
          // http://phrogz.net/tmp/canvas_image_zoom.html
          // https://developer.mozilla.org/en-US/docs/Web/CSS/image-rendering
          image3
              .attr('style', 'image-rendering: optimizeSpeed; image-rendering: -moz-crisp-edges; image-rendering: -o-crisp-edges; image-rendering: -webkit-optimize-contrast; image-rendering: optimize-contrast; image-rendering: crisp-edges; image-rendering: pixelated;');
  
          var p = new Promise(function(resolve) {
              if(trace._hasZ) {
                  resolve();
              } else if(trace._hasSource) {
                  // Check if canvas already exists and has the right data
                  if(
                      trace._canvas &&
                      trace._canvas.el.width === w &&
                      trace._canvas.el.height === h &&
                      trace._canvas.source === trace.source
                  ) {
                      resolve();
                  } else {
                      // Create a canvas and transfer image onto it to access pixel information
                      var canvas = document.createElement('canvas');
                      canvas.width = w;
                      canvas.height = h;
                      var context = canvas.getContext('2d');
  
                      trace._image = trace._image || new Image();
                      var image = trace._image;
                      image.onload = function() {
                          context.drawImage(image, 0, 0);
                          trace._canvas = {
                              el: canvas,
                              source: trace.source
                          };
                          resolve();
                      };
                      image.setAttribute('src', trace.source);
                  }
              }
          })
          .then(function() {
              var href, canvas;
              if(trace._hasZ) {
                  canvas = drawMagnifiedPixelsOnCanvas(function(i, j) {return z[j][i];});
                  href = canvas.toDataURL('image/png');
              } else if(trace._hasSource) {
                  if(fastImage) {
                      href = trace.source;
                  } else {
                      var context = trace._canvas.el.getContext('2d');
                      var data = context.getImageData(0, 0, w, h).data;
                      canvas = drawMagnifiedPixelsOnCanvas(function(i, j) {
                          var index = 4 * (j * w + i);
                          return [
                              data[index],
                              data[index + 1],
                              data[index + 2],
                              data[index + 3]
                          ];
                      });
                      href = canvas.toDataURL('image/png');
                  }
              }
  
              image3.attr({
                  'xlink:href': href,
                  height: imageHeight,
                  width: imageWidth,
                  x: left,
                  y: top
              });
          });
  
          gd._promises.push(p);
      });
  };
  
  },{"../../constants/xmlns_namespaces":726,"../../lib":750,"./constants":1079,"d3":169}],1086:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  module.exports = function style(gd) {
      d3.select(gd).selectAll('.im image')
          .style('opacity', function(d) {
              return d[0].trace.opacity;
          });
  };
  
  },{"d3":169}],1087:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var extendDeep = _dereq_('../../lib/extend').extendDeep;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var colorAttrs = _dereq_('../../components/color/attributes');
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  var axesAttrs = _dereq_('../../plots/cartesian/layout_attributes');
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  var delta = _dereq_('../../constants/delta.js');
  var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
  
  var textFontAttrs = fontAttrs({
      editType: 'plot',
      colorEditType: 'plot'
  });
  
  var gaugeBarAttrs = {
      color: {
          valType: 'color',
          editType: 'plot',
          
          
      },
      line: {
          color: {
              valType: 'color',
              
              dflt: colorAttrs.defaultLine,
              editType: 'plot',
              
          },
          width: {
              valType: 'number',
              
              min: 0,
              dflt: 0,
              editType: 'plot',
              
          },
          editType: 'calc'
      },
      thickness: {
          valType: 'number',
          
          min: 0,
          max: 1,
          dflt: 1,
          editType: 'plot',
          
      },
      editType: 'calc'
  };
  
  var rangeAttr = {
      valType: 'info_array',
      
      items: [
              {valType: 'number', editType: 'plot'},
              {valType: 'number', editType: 'plot'}
      ],
      editType: 'plot',
      
  };
  
  var stepsAttrs = templatedArray('step', extendDeep({}, gaugeBarAttrs, {
      range: rangeAttr
  }));
  
  module.exports = {
      mode: {
          valType: 'flaglist',
          editType: 'calc',
          
          flags: ['number', 'delta', 'gauge'],
          dflt: 'number',
          
      },
      value: {
          valType: 'number',
          editType: 'calc',
          
          anim: true,
          
      },
      align: {
          valType: 'enumerated',
          values: ['left', 'center', 'right'],
          
          editType: 'plot',
          
      },
      // position
      domain: domainAttrs({name: 'indicator', trace: true, editType: 'calc'}),
  
      title: {
          text: {
              valType: 'string',
              
              editType: 'plot',
              
          },
          align: {
              valType: 'enumerated',
              values: ['left', 'center', 'right'],
              
              editType: 'plot',
              
          },
          font: extendFlat({}, textFontAttrs, {
              
          }),
          editType: 'plot'
      },
      number: {
          valueformat: {
              valType: 'string',
              dflt: '',
              
              editType: 'plot',
              
          },
          font: extendFlat({}, textFontAttrs, {
              
          }),
          prefix: {
              valType: 'string',
              dflt: '',
              
              editType: 'plot',
              
          },
          suffix: {
              valType: 'string',
              dflt: '',
              
              editType: 'plot',
              
          },
          editType: 'plot'
      },
      delta: {
          reference: {
              valType: 'number',
              
              editType: 'calc',
              
          },
          position: {
              valType: 'enumerated',
              values: ['top', 'bottom', 'left', 'right'],
              
              dflt: 'bottom',
              editType: 'plot',
              
          },
          relative: {
              valType: 'boolean',
              editType: 'plot',
              
              dflt: false,
              
          },
          valueformat: {
              valType: 'string',
              
              editType: 'plot',
              
          },
          increasing: {
              symbol: {
                  valType: 'string',
                  
                  dflt: delta.INCREASING.SYMBOL,
                  editType: 'plot',
                  
              },
              color: {
                  valType: 'color',
                  
                  dflt: delta.INCREASING.COLOR,
                  editType: 'plot',
                  
              },
              // TODO: add attribute to show sign
              editType: 'plot'
          },
          decreasing: {
              symbol: {
                  valType: 'string',
                  
                  dflt: delta.DECREASING.SYMBOL,
                  editType: 'plot',
                  
              },
              color: {
                  valType: 'color',
                  
                  dflt: delta.DECREASING.COLOR,
                  editType: 'plot',
                  
              },
              // TODO: add attribute to hide sign
              editType: 'plot'
          },
          font: extendFlat({}, textFontAttrs, {
              
          }),
          editType: 'calc'
      },
      gauge: {
          shape: {
              valType: 'enumerated',
              editType: 'plot',
              
              dflt: 'angular',
              values: ['angular', 'bullet'],
              
          },
          bar: extendDeep({}, gaugeBarAttrs, {
              color: {dflt: 'green'},
              
          }),
          // Background of the gauge
          bgcolor: {
              valType: 'color',
              
              editType: 'plot',
              
          },
          bordercolor: {
              valType: 'color',
              dflt: colorAttrs.defaultLine,
              
              editType: 'plot',
              
          },
          borderwidth: {
              valType: 'number',
              min: 0,
              dflt: 1,
              
              editType: 'plot',
              
          },
          axis: overrideAll({
              range: rangeAttr,
              visible: extendFlat({}, axesAttrs.visible, {
                  dflt: true
              }),
              // tick and title properties named and function exactly as in axes
              tickmode: axesAttrs.tickmode,
              nticks: axesAttrs.nticks,
              tick0: axesAttrs.tick0,
              dtick: axesAttrs.dtick,
              tickvals: axesAttrs.tickvals,
              ticktext: axesAttrs.ticktext,
              ticks: extendFlat({}, axesAttrs.ticks, {dflt: 'outside'}),
              ticklen: axesAttrs.ticklen,
              tickwidth: axesAttrs.tickwidth,
              tickcolor: axesAttrs.tickcolor,
              showticklabels: axesAttrs.showticklabels,
              tickfont: fontAttrs({
                  
              }),
              tickangle: axesAttrs.tickangle,
              tickformat: axesAttrs.tickformat,
              tickformatstops: axesAttrs.tickformatstops,
              tickprefix: axesAttrs.tickprefix,
              showtickprefix: axesAttrs.showtickprefix,
              ticksuffix: axesAttrs.ticksuffix,
              showticksuffix: axesAttrs.showticksuffix,
              separatethousands: axesAttrs.separatethousands,
              exponentformat: axesAttrs.exponentformat,
              minexponent: axesAttrs.minexponent,
              showexponent: axesAttrs.showexponent,
              editType: 'plot'
          }, 'plot'),
          // Steps (or ranges) and thresholds
          steps: stepsAttrs,
          threshold: {
              line: {
                  color: extendFlat({}, gaugeBarAttrs.line.color, {
                      
                  }),
                  width: extendFlat({}, gaugeBarAttrs.line.width, {
                      dflt: 1,
                      
                  }),
                  editType: 'plot'
              },
              thickness: extendFlat({}, gaugeBarAttrs.thickness, {
                  dflt: 0.85,
                  
              }),
              value: {
                  valType: 'number',
                  editType: 'calc',
                  dflt: false,
                  
                  
              },
              editType: 'plot'
          },
          
          editType: 'plot'
          // TODO: in future version, add marker: (bar|needle)
      }
  };
  
  },{"../../components/color/attributes":614,"../../constants/delta.js":719,"../../constants/docs":720,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plot_api/plot_template":788,"../../plots/cartesian/layout_attributes":813,"../../plots/domain":826,"../../plots/font_attributes":827}],1088:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var plots = _dereq_('../../plots/plots');
  
  exports.name = 'indicator';
  
  exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
      plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
  };
  
  },{"../../plots/plots":862}],1089:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  // var Lib = require('../../lib');
  
  function calc(gd, trace) {
      var cd = [];
  
      var lastReading = trace.value;
      if(!(typeof trace._lastValue === 'number')) trace._lastValue = trace.value;
      var secondLastReading = trace._lastValue;
      var deltaRef = secondLastReading;
      if(trace._hasDelta && typeof trace.delta.reference === 'number') {
          deltaRef = trace.delta.reference;
      }
      cd[0] = {
          y: lastReading,
          lastY: secondLastReading,
  
          delta: lastReading - deltaRef,
          relativeDelta: (lastReading - deltaRef) / deltaRef,
      };
      return cd;
  }
  
  module.exports = {
      calc: calc
  };
  
  },{}],1090:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      // Defaults for delta
      defaultNumberFontSize: 80,
      bulletNumberDomainSize: 0.25,
      bulletPadding: 0.025,
      innerRadius: 0.75,
      valueThickness: 0.5, // thickness of value bars relative to full thickness,
      titlePadding: 5,
      horizontalPadding: 10
  };
  
  },{}],1091:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
  var Template = _dereq_('../../plot_api/plot_template');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  var cn = _dereq_('./constants.js');
  
  var handleTickValueDefaults = _dereq_('../../plots/cartesian/tick_value_defaults');
  var handleTickMarkDefaults = _dereq_('../../plots/cartesian/tick_mark_defaults');
  var handleTickLabelDefaults = _dereq_('../../plots/cartesian/tick_label_defaults');
  
  function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      handleDomainDefaults(traceOut, layout, coerce);
  
      // Mode
      coerce('mode');
      traceOut._hasNumber = traceOut.mode.indexOf('number') !== -1;
      traceOut._hasDelta = traceOut.mode.indexOf('delta') !== -1;
      traceOut._hasGauge = traceOut.mode.indexOf('gauge') !== -1;
  
      var value = coerce('value');
      traceOut._range = [0, (typeof value === 'number' ? 1.5 * value : 1)];
  
      // Number attributes
      var auto = new Array(2);
      var bignumberFontSize;
      if(traceOut._hasNumber) {
          coerce('number.valueformat');
          coerce('number.font.color', layout.font.color);
          coerce('number.font.family', layout.font.family);
          coerce('number.font.size');
          if(traceOut.number.font.size === undefined) {
              traceOut.number.font.size = cn.defaultNumberFontSize;
              auto[0] = true;
          }
          coerce('number.prefix');
          coerce('number.suffix');
          bignumberFontSize = traceOut.number.font.size;
      }
  
      // delta attributes
      var deltaFontSize;
      if(traceOut._hasDelta) {
          coerce('delta.font.color', layout.font.color);
          coerce('delta.font.family', layout.font.family);
          coerce('delta.font.size');
          if(traceOut.delta.font.size === undefined) {
              traceOut.delta.font.size = (traceOut._hasNumber ? 0.5 : 1) * (bignumberFontSize || cn.defaultNumberFontSize);
              auto[1] = true;
          }
          coerce('delta.reference', traceOut.value);
          coerce('delta.relative');
          coerce('delta.valueformat', traceOut.delta.relative ? '2%' : '');
          coerce('delta.increasing.symbol');
          coerce('delta.increasing.color');
          coerce('delta.decreasing.symbol');
          coerce('delta.decreasing.color');
          coerce('delta.position');
          deltaFontSize = traceOut.delta.font.size;
      }
      traceOut._scaleNumbers = (!traceOut._hasNumber || auto[0]) && (!traceOut._hasDelta || auto[1]) || false;
  
      // Title attributes
      coerce('title.font.color', layout.font.color);
      coerce('title.font.family', layout.font.family);
      coerce('title.font.size', 0.25 * (bignumberFontSize || deltaFontSize || cn.defaultNumberFontSize));
      coerce('title.text');
  
      // Gauge attributes
      var gaugeIn, gaugeOut, axisIn, axisOut;
      function coerceGauge(attr, dflt) {
          return Lib.coerce(gaugeIn, gaugeOut, attributes.gauge, attr, dflt);
      }
      function coerceGaugeAxis(attr, dflt) {
          return Lib.coerce(axisIn, axisOut, attributes.gauge.axis, attr, dflt);
      }
  
      if(traceOut._hasGauge) {
          gaugeIn = traceIn.gauge;
          if(!gaugeIn) gaugeIn = {};
          gaugeOut = Template.newContainer(traceOut, 'gauge');
          coerceGauge('shape');
          var isBullet = traceOut._isBullet = traceOut.gauge.shape === 'bullet';
          if(!isBullet) {
              coerce('title.align', 'center');
          }
          var isAngular = traceOut._isAngular = traceOut.gauge.shape === 'angular';
          if(!isAngular) {
              coerce('align', 'center');
          }
  
          // gauge background
          coerceGauge('bgcolor', layout.paper_bgcolor);
          coerceGauge('borderwidth');
          coerceGauge('bordercolor');
  
          // gauge bar indicator
          coerceGauge('bar.color');
          coerceGauge('bar.line.color');
          coerceGauge('bar.line.width');
          var defaultBarThickness = cn.valueThickness * (traceOut.gauge.shape === 'bullet' ? 0.5 : 1);
          coerceGauge('bar.thickness', defaultBarThickness);
  
          // Gauge steps
          handleArrayContainerDefaults(gaugeIn, gaugeOut, {
              name: 'steps',
              handleItemDefaults: stepDefaults
          });
  
          // Gauge threshold
          coerceGauge('threshold.value');
          coerceGauge('threshold.thickness');
          coerceGauge('threshold.line.width');
          coerceGauge('threshold.line.color');
  
          // Gauge axis
          axisIn = {};
          if(gaugeIn) axisIn = gaugeIn.axis || {};
          axisOut = Template.newContainer(gaugeOut, 'axis');
          coerceGaugeAxis('visible');
          traceOut._range = coerceGaugeAxis('range', traceOut._range);
  
          var opts = {outerTicks: true};
          handleTickValueDefaults(axisIn, axisOut, coerceGaugeAxis, 'linear');
          handleTickLabelDefaults(axisIn, axisOut, coerceGaugeAxis, 'linear', opts);
          handleTickMarkDefaults(axisIn, axisOut, coerceGaugeAxis, opts);
      } else {
          coerce('title.align', 'center');
          coerce('align', 'center');
          traceOut._isAngular = traceOut._isBullet = false;
      }
  
      // disable 1D transforms
      traceOut._length = null;
  }
  
  function stepDefaults(stepIn, stepOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(stepIn, stepOut, attributes.gauge.steps, attr, dflt);
      }
  
      coerce('color');
      coerce('line.color');
      coerce('line.width');
      coerce('range');
      coerce('thickness');
  }
  
  module.exports = {
      supplyDefaults: supplyDefaults
  };
  
  },{"../../lib":750,"../../plot_api/plot_template":788,"../../plots/array_container_defaults":794,"../../plots/cartesian/tick_label_defaults":820,"../../plots/cartesian/tick_mark_defaults":821,"../../plots/cartesian/tick_value_defaults":822,"../../plots/domain":826,"./attributes":1087,"./constants.js":1090}],1092:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'indicator',
      basePlotModule: _dereq_('./base_plot'),
      categories: ['svg', 'noOpacity', 'noHover'],
      animatable: true,
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults').supplyDefaults,
  
      calc: _dereq_('./calc').calc,
  
      plot: _dereq_('./plot'),
  
      meta: {
          
      }
  };
  
  },{"./attributes":1087,"./base_plot":1088,"./calc":1089,"./defaults":1091,"./plot":1093}],1093:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Lib = _dereq_('../../lib');
  var rad2deg = Lib.rad2deg;
  var MID_SHIFT = _dereq_('../../constants/alignment').MID_SHIFT;
  var Drawing = _dereq_('../../components/drawing');
  var cn = _dereq_('./constants');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var handleAxisDefaults = _dereq_('../../plots/cartesian/axis_defaults');
  var handleAxisPositionDefaults = _dereq_('../../plots/cartesian/position_defaults');
  var axisLayoutAttrs = _dereq_('../../plots/cartesian/layout_attributes');
  
  var Color = _dereq_('../../components/color');
  var anchor = {
      'left': 'start',
      'center': 'middle',
      'right': 'end'
  };
  var position = {
      'left': 0,
      'center': 0.5,
      'right': 1
  };
  
  var SI_PREFIX = /[yzafpnµmkMGTPEZY]/;
  
  function hasTransition(transitionOpts) {
      // If transition config is provided, then it is only a partial replot and traces not
      // updated are removed.
      return transitionOpts && transitionOpts.duration > 0;
  }
  
  module.exports = function plot(gd, cdModule, transitionOpts, makeOnCompleteCallback) {
      var fullLayout = gd._fullLayout;
      var onComplete;
  
      if(hasTransition(transitionOpts)) {
          if(makeOnCompleteCallback) {
              // If it was passed a callback to register completion, make a callback. If
              // this is created, then it must be executed on completion, otherwise the
              // pos-transition redraw will not execute:
              onComplete = makeOnCompleteCallback();
          }
      }
  
      Lib.makeTraceGroups(fullLayout._indicatorlayer, cdModule, 'trace').each(function(cd) {
          var cd0 = cd[0];
          var trace = cd0.trace;
  
          var plotGroup = d3.select(this);
  
          // Elements in trace
          var hasGauge = trace._hasGauge;
          var isAngular = trace._isAngular;
          var isBullet = trace._isBullet;
  
          // Domain size
          var domain = trace.domain;
          var size = {
              w: fullLayout._size.w * (domain.x[1] - domain.x[0]),
              h: fullLayout._size.h * (domain.y[1] - domain.y[0]),
              l: fullLayout._size.l + fullLayout._size.w * domain.x[0],
              r: fullLayout._size.r + fullLayout._size.w * (1 - domain.x[1]),
              t: fullLayout._size.t + fullLayout._size.h * (1 - domain.y[1]),
              b: fullLayout._size.b + fullLayout._size.h * (domain.y[0])
          };
          var centerX = size.l + size.w / 2;
          var centerY = size.t + size.h / 2;
  
          // Angular gauge size
          var radius = Math.min(size.w / 2, size.h); // fill domain
          var innerRadius = cn.innerRadius * radius;
  
          // Position numbers based on mode and set the scaling logic
          var numbersX, numbersY, numbersScaler;
          var numbersAlign = trace.align || 'center';
  
          numbersY = centerY;
          if(!hasGauge) {
              numbersX = size.l + position[numbersAlign] * size.w;
              numbersScaler = function(el) {
                  return fitTextInsideBox(el, size.w, size.h);
              };
          } else {
              if(isAngular) {
                  numbersX = centerX;
                  numbersY = centerY + radius / 2;
                  numbersScaler = function(el) {
                      return fitTextInsideCircle(el, 0.9 * innerRadius);
                  };
              }
              if(isBullet) {
                  var padding = cn.bulletPadding;
                  var p = (1 - cn.bulletNumberDomainSize) + padding;
                  numbersX = size.l + (p + (1 - p) * position[numbersAlign]) * size.w;
                  numbersScaler = function(el) {
                      return fitTextInsideBox(el, (cn.bulletNumberDomainSize - padding) * size.w, size.h);
                  };
              }
          }
  
          // Draw numbers
          drawNumbers(gd, plotGroup, cd, {
              numbersX: numbersX,
              numbersY: numbersY,
              numbersScaler: numbersScaler,
              transitionOpts: transitionOpts,
              onComplete: onComplete
          });
  
          // Reexpress our gauge background attributes for drawing
          var gaugeBg, gaugeOutline;
          if(hasGauge) {
              gaugeBg = {
                  range: trace.gauge.axis.range,
                  color: trace.gauge.bgcolor,
                  line: {
                      color: trace.gauge.bordercolor,
                      width: 0
                  },
                  thickness: 1
              };
  
              gaugeOutline = {
                  range: trace.gauge.axis.range,
                  color: 'rgba(0, 0, 0, 0)',
                  line: {
                      color: trace.gauge.bordercolor,
                      width: trace.gauge.borderwidth
                  },
                  thickness: 1
              };
          }
  
          // Prepare angular gauge layers
          var angularGauge = plotGroup.selectAll('g.angular').data(isAngular ? cd : []);
          angularGauge.exit().remove();
          var angularaxisLayer = plotGroup.selectAll('g.angularaxis').data(isAngular ? cd : []);
          angularaxisLayer.exit().remove();
  
          if(isAngular) {
              drawAngularGauge(gd, plotGroup, cd, {
                  radius: radius,
                  innerRadius: innerRadius,
  
                  gauge: angularGauge,
                  layer: angularaxisLayer,
                  size: size,
                  gaugeBg: gaugeBg,
                  gaugeOutline: gaugeOutline,
                  transitionOpts: transitionOpts,
                  onComplete: onComplete
              });
          }
  
          // Prepare bullet layers
          var bulletGauge = plotGroup.selectAll('g.bullet').data(isBullet ? cd : []);
          bulletGauge.exit().remove();
          var bulletaxisLayer = plotGroup.selectAll('g.bulletaxis').data(isBullet ? cd : []);
          bulletaxisLayer.exit().remove();
  
          if(isBullet) {
              drawBulletGauge(gd, plotGroup, cd, {
                  gauge: bulletGauge,
                  layer: bulletaxisLayer,
                  size: size,
                  gaugeBg: gaugeBg,
                  gaugeOutline: gaugeOutline,
                  transitionOpts: transitionOpts,
                  onComplete: onComplete
              });
          }
  
          // title
          var title = plotGroup.selectAll('text.title').data(cd);
          title.exit().remove();
          title.enter().append('text').classed('title', true);
          title
              .attr('text-anchor', function() {
                  return isBullet ? anchor.right : anchor[trace.title.align];
              })
              .text(trace.title.text)
              .call(Drawing.font, trace.title.font)
              .call(svgTextUtils.convertToTspans, gd);
  
          // Position title
          title.attr('transform', function() {
              var titleX = size.l + size.w * position[trace.title.align];
              var titleY;
              var titlePadding = cn.titlePadding;
              var titlebBox = Drawing.bBox(title.node());
              if(hasGauge) {
                  if(isAngular) {
                      // position above axis ticks/labels
                      if(trace.gauge.axis.visible) {
                          var bBox = Drawing.bBox(angularaxisLayer.node());
                          titleY = (bBox.top - titlePadding) - titlebBox.bottom;
                      } else {
                          titleY = size.t + size.h / 2 - radius / 2 - titlebBox.bottom - titlePadding;
                      }
                  }
                  if(isBullet) {
                      // position outside domain
                      titleY = numbersY - (titlebBox.top + titlebBox.bottom) / 2;
                      titleX = size.l - cn.bulletPadding * size.w; // Outside domain, on the left
                  }
              } else {
                  // position above numbers
                  titleY = (trace._numbersTop - titlePadding) - titlebBox.bottom;
              }
              return strTranslate(titleX, titleY);
          });
      });
  };
  
  function drawBulletGauge(gd, plotGroup, cd, opts) {
      var trace = cd[0].trace;
  
      var bullet = opts.gauge;
      var axisLayer = opts.layer;
      var gaugeBg = opts.gaugeBg;
      var gaugeOutline = opts.gaugeOutline;
      var size = opts.size;
      var domain = trace.domain;
  
      var transitionOpts = opts.transitionOpts;
      var onComplete = opts.onComplete;
  
      // preparing axis
      var ax, vals, transFn, tickSign, shift;
  
      // Enter bullet, axis
      bullet.enter().append('g').classed('bullet', true);
      bullet.attr('transform', 'translate(' + size.l + ', ' + size.t + ')');
  
      axisLayer.enter().append('g')
          .classed('bulletaxis', true)
          .classed('crisp', true);
      axisLayer.selectAll('g.' + 'xbulletaxis' + 'tick,path,text').remove();
  
      // Draw bullet
      var bulletHeight = size.h; // use all vertical domain
      var innerBulletHeight = trace.gauge.bar.thickness * bulletHeight;
      var bulletLeft = domain.x[0];
      var bulletRight = domain.x[0] + (domain.x[1] - domain.x[0]) * ((trace._hasNumber || trace._hasDelta) ? (1 - cn.bulletNumberDomainSize) : 1);
  
      ax = mockAxis(gd, trace.gauge.axis);
      ax._id = 'xbulletaxis';
      ax.domain = [bulletLeft, bulletRight];
      ax.setScale();
  
      vals = Axes.calcTicks(ax);
      transFn = Axes.makeTransFn(ax);
      tickSign = Axes.getTickSigns(ax)[2];
  
      shift = size.t + size.h;
      if(ax.visible) {
          Axes.drawTicks(gd, ax, {
              vals: ax.ticks === 'inside' ? Axes.clipEnds(ax, vals) : vals,
              layer: axisLayer,
              path: Axes.makeTickPath(ax, shift, tickSign),
              transFn: transFn
          });
  
          Axes.drawLabels(gd, ax, {
              vals: vals,
              layer: axisLayer,
              transFn: transFn,
              labelFns: Axes.makeLabelFns(ax, shift)
          });
      }
  
      function drawRect(s) {
          s
              .attr('width', function(d) { return Math.max(0, ax.c2p(d.range[1]) - ax.c2p(d.range[0]));})
              .attr('x', function(d) { return ax.c2p(d.range[0]);})
              .attr('y', function(d) { return 0.5 * (1 - d.thickness) * bulletHeight;})
              .attr('height', function(d) { return d.thickness * bulletHeight; });
      }
  
      // Draw bullet background, steps
      var boxes = [gaugeBg].concat(trace.gauge.steps);
      var bgBullet = bullet.selectAll('g.bg-bullet').data(boxes);
      bgBullet.enter().append('g').classed('bg-bullet', true).append('rect');
      bgBullet.select('rect')
          .call(drawRect)
          .call(styleShape);
      bgBullet.exit().remove();
  
      // Draw value bar with transitions
      var fgBullet = bullet.selectAll('g.value-bullet').data([trace.gauge.bar]);
      fgBullet.enter().append('g').classed('value-bullet', true).append('rect');
      fgBullet.select('rect')
          .attr('height', innerBulletHeight)
          .attr('y', (bulletHeight - innerBulletHeight) / 2)
          .call(styleShape);
      if(hasTransition(transitionOpts)) {
          fgBullet.select('rect')
              .transition()
              .duration(transitionOpts.duration)
              .ease(transitionOpts.easing)
              .each('end', function() { onComplete && onComplete(); })
              .each('interrupt', function() { onComplete && onComplete(); })
              .attr('width', Math.max(0, ax.c2p(Math.min(trace.gauge.axis.range[1], cd[0].y))));
      } else {
          fgBullet.select('rect')
              .attr('width', typeof cd[0].y === 'number' ?
                  Math.max(0, ax.c2p(Math.min(trace.gauge.axis.range[1], cd[0].y))) :
                  0);
      }
      fgBullet.exit().remove();
  
      var data = cd.filter(function() {return trace.gauge.threshold.value;});
      var threshold = bullet.selectAll('g.threshold-bullet').data(data);
      threshold.enter().append('g').classed('threshold-bullet', true).append('line');
      threshold.select('line')
          .attr('x1', ax.c2p(trace.gauge.threshold.value))
          .attr('x2', ax.c2p(trace.gauge.threshold.value))
          .attr('y1', (1 - trace.gauge.threshold.thickness) / 2 * bulletHeight)
          .attr('y2', (1 - (1 - trace.gauge.threshold.thickness) / 2) * bulletHeight)
          .call(Color.stroke, trace.gauge.threshold.line.color)
          .style('stroke-width', trace.gauge.threshold.line.width);
      threshold.exit().remove();
  
      var bulletOutline = bullet.selectAll('g.gauge-outline').data([gaugeOutline]);
      bulletOutline.enter().append('g').classed('gauge-outline', true).append('rect');
      bulletOutline.select('rect')
          .call(drawRect)
          .call(styleShape);
      bulletOutline.exit().remove();
  }
  
  function drawAngularGauge(gd, plotGroup, cd, opts) {
      var trace = cd[0].trace;
  
      var size = opts.size;
      var radius = opts.radius;
      var innerRadius = opts.innerRadius;
      var gaugeBg = opts.gaugeBg;
      var gaugeOutline = opts.gaugeOutline;
      var gaugePosition = [size.l + size.w / 2, size.t + size.h / 2 + radius / 2];
      var gauge = opts.gauge;
      var axisLayer = opts.layer;
  
      var transitionOpts = opts.transitionOpts;
      var onComplete = opts.onComplete;
  
      // circular gauge
      var theta = Math.PI / 2;
      function valueToAngle(v) {
          var min = trace.gauge.axis.range[0];
          var max = trace.gauge.axis.range[1];
          var angle = (v - min) / (max - min) * Math.PI - theta;
          if(angle < -theta) return -theta;
          if(angle > theta) return theta;
          return angle;
      }
  
      function arcPathGenerator(size) {
          return d3.svg.arc()
                    .innerRadius((innerRadius + radius) / 2 - size / 2 * (radius - innerRadius))
                    .outerRadius((innerRadius + radius) / 2 + size / 2 * (radius - innerRadius))
                    .startAngle(-theta);
      }
  
      function drawArc(p) {
          p
              .attr('d', function(d) {
                  return arcPathGenerator(d.thickness)
                    .startAngle(valueToAngle(d.range[0]))
                    .endAngle(valueToAngle(d.range[1]))();
              });
      }
  
      // preparing axis
      var ax, vals, transFn, tickSign;
  
      // Enter gauge and axis
      gauge.enter().append('g').classed('angular', true);
      gauge.attr('transform', strTranslate(gaugePosition[0], gaugePosition[1]));
  
      axisLayer.enter().append('g')
          .classed('angularaxis', true)
          .classed('crisp', true);
      axisLayer.selectAll('g.' + 'xangularaxis' + 'tick,path,text').remove();
  
      ax = mockAxis(gd, trace.gauge.axis);
      ax.type = 'linear';
      ax.range = trace.gauge.axis.range;
      ax._id = 'xangularaxis'; // or 'y', but I don't think this makes a difference here
      ax.setScale();
  
      // 't'ick to 'g'eometric radians is used all over the place here
      var t2g = function(d) {
          return (ax.range[0] - d.x) / (ax.range[1] - ax.range[0]) * Math.PI + Math.PI;
      };
  
      var labelFns = {};
      var out = Axes.makeLabelFns(ax, 0);
      var labelStandoff = out.labelStandoff;
      labelFns.xFn = function(d) {
          var rad = t2g(d);
          return Math.cos(rad) * labelStandoff;
      };
      labelFns.yFn = function(d) {
          var rad = t2g(d);
          var ff = Math.sin(rad) > 0 ? 0.2 : 1;
          return -Math.sin(rad) * (labelStandoff + d.fontSize * ff) +
                  Math.abs(Math.cos(rad)) * (d.fontSize * MID_SHIFT);
      };
      labelFns.anchorFn = function(d) {
          var rad = t2g(d);
          var cos = Math.cos(rad);
          return Math.abs(cos) < 0.1 ?
                  'middle' :
                  (cos > 0 ? 'start' : 'end');
      };
      labelFns.heightFn = function(d, a, h) {
          var rad = t2g(d);
          return -0.5 * (1 + Math.sin(rad)) * h;
      };
      var _transFn = function(rad) {
          return strTranslate(
              gaugePosition[0] + radius * Math.cos(rad),
              gaugePosition[1] - radius * Math.sin(rad)
          );
      };
      transFn = function(d) {
          return _transFn(t2g(d));
      };
      var transFn2 = function(d) {
          var rad = t2g(d);
          return _transFn(rad) + 'rotate(' + -rad2deg(rad) + ')';
      };
      vals = Axes.calcTicks(ax);
      tickSign = Axes.getTickSigns(ax)[2];
      if(ax.visible) {
          tickSign = ax.ticks === 'inside' ? -1 : 1;
          var pad = (ax.linewidth || 1) / 2;
          Axes.drawTicks(gd, ax, {
              vals: vals,
              layer: axisLayer,
              path: 'M' + (tickSign * pad) + ',0h' + (tickSign * ax.ticklen),
              transFn: transFn2
          });
          Axes.drawLabels(gd, ax, {
              vals: vals,
              layer: axisLayer,
              transFn: transFn,
              labelFns: labelFns
          });
      }
  
      // Draw background + steps
      var arcs = [gaugeBg].concat(trace.gauge.steps);
      var bgArc = gauge.selectAll('g.bg-arc').data(arcs);
      bgArc.enter().append('g').classed('bg-arc', true).append('path');
      bgArc.select('path').call(drawArc).call(styleShape);
      bgArc.exit().remove();
  
      // Draw foreground with transition
      var valueArcPathGenerator = arcPathGenerator(trace.gauge.bar.thickness);
      var valueArc = gauge.selectAll('g.value-arc').data([trace.gauge.bar]);
      valueArc.enter().append('g').classed('value-arc', true).append('path');
      var valueArcPath = valueArc.select('path');
      if(hasTransition(transitionOpts)) {
          valueArcPath
              .transition()
              .duration(transitionOpts.duration)
              .ease(transitionOpts.easing)
              .each('end', function() { onComplete && onComplete(); })
              .each('interrupt', function() { onComplete && onComplete(); })
              .attrTween('d', arcTween(valueArcPathGenerator, valueToAngle(cd[0].lastY), valueToAngle(cd[0].y)));
          trace._lastValue = cd[0].y;
      } else {
          valueArcPath.attr('d', typeof cd[0].y === 'number' ?
              valueArcPathGenerator.endAngle(valueToAngle(cd[0].y)) :
              'M0,0Z');
      }
      valueArcPath.call(styleShape);
      valueArc.exit().remove();
  
      // Draw threshold
      arcs = [];
      var v = trace.gauge.threshold.value;
      if(v) {
          arcs.push({
              range: [v, v],
              color: trace.gauge.threshold.color,
              line: {
                  color: trace.gauge.threshold.line.color,
                  width: trace.gauge.threshold.line.width
              },
              thickness: trace.gauge.threshold.thickness
          });
      }
      var thresholdArc = gauge.selectAll('g.threshold-arc').data(arcs);
      thresholdArc.enter().append('g').classed('threshold-arc', true).append('path');
      thresholdArc.select('path').call(drawArc).call(styleShape);
      thresholdArc.exit().remove();
  
      // Draw border last
      var gaugeBorder = gauge.selectAll('g.gauge-outline').data([gaugeOutline]);
      gaugeBorder.enter().append('g').classed('gauge-outline', true).append('path');
      gaugeBorder.select('path').call(drawArc).call(styleShape);
      gaugeBorder.exit().remove();
  }
  
  function drawNumbers(gd, plotGroup, cd, opts) {
      var trace = cd[0].trace;
  
      var numbersX = opts.numbersX;
      var numbersY = opts.numbersY;
      var numbersAlign = trace.align || 'center';
      var numbersAnchor = anchor[numbersAlign];
  
      var transitionOpts = opts.transitionOpts;
      var onComplete = opts.onComplete;
  
      var numbers = Lib.ensureSingle(plotGroup, 'g', 'numbers');
      var bignumberbBox, deltabBox;
      var numbersbBox;
  
      var data = [];
      if(trace._hasNumber) data.push('number');
      if(trace._hasDelta) {
          data.push('delta');
          if(trace.delta.position === 'left') data.reverse();
      }
      var sel = numbers.selectAll('text').data(data);
      sel.enter().append('text');
      sel
          .attr('text-anchor', function() {return numbersAnchor;})
          .attr('class', function(d) { return d;})
          .attr('x', null)
          .attr('y', null)
          .attr('dx', null)
          .attr('dy', null);
      sel.exit().remove();
  
      // Function to override the number formatting used during transitions
      function transitionFormat(valueformat, fmt, from, to) {
          // For now, do not display SI prefix if start and end value do not have any
          if(valueformat.match('s') && // If using SI prefix
              (from >= 0 !== to >= 0) && // If sign change
              (!fmt(from).slice(-1).match(SI_PREFIX) && !fmt(to).slice(-1).match(SI_PREFIX)) // Has no SI prefix
          ) {
              var transitionValueFormat = valueformat.slice().replace('s', 'f').replace(/\d+/, function(m) { return parseInt(m) - 1;});
              var transitionAx = mockAxis(gd, {tickformat: transitionValueFormat});
              return function(v) {
                  // Switch to fixed precision if number is smaller than one
                  if(Math.abs(v) < 1) return Axes.tickText(transitionAx, v).text;
                  return fmt(v);
              };
          } else {
              return fmt;
          }
      }
  
      function drawBignumber() {
          var bignumberAx = mockAxis(gd, {tickformat: trace.number.valueformat}, trace._range);
          bignumberAx.setScale();
          Axes.prepTicks(bignumberAx);
  
          var fmt = function(v) { return Axes.tickText(bignumberAx, v).text;};
          var bignumberSuffix = trace.number.suffix;
          var bignumberPrefix = trace.number.prefix;
  
          var number = numbers.select('text.number');
  
          function writeNumber() {
              var txt = typeof cd[0].y === 'number' ?
                  bignumberPrefix + fmt(cd[0].y) + bignumberSuffix :
                  '-';
              number.text(txt)
                  .call(Drawing.font, trace.number.font)
                  .call(svgTextUtils.convertToTspans, gd);
          }
  
          if(hasTransition(transitionOpts)) {
              number
                  .transition()
                  .duration(transitionOpts.duration)
                  .ease(transitionOpts.easing)
                  .each('end', function() { writeNumber(); onComplete && onComplete(); })
                  .each('interrupt', function() { writeNumber(); onComplete && onComplete(); })
                  .attrTween('text', function() {
                      var that = d3.select(this);
                      var interpolator = d3.interpolateNumber(cd[0].lastY, cd[0].y);
                      trace._lastValue = cd[0].y;
  
                      var transitionFmt = transitionFormat(trace.number.valueformat, fmt, cd[0].lastY, cd[0].y);
                      return function(t) {
                          that.text(bignumberPrefix + transitionFmt(interpolator(t)) + bignumberSuffix);
                      };
                  });
          } else {
              writeNumber();
          }
  
          bignumberbBox = measureText(bignumberPrefix + fmt(cd[0].y) + bignumberSuffix, trace.number.font, numbersAnchor, gd);
          return number;
      }
  
      function drawDelta() {
          var deltaAx = mockAxis(gd, {tickformat: trace.delta.valueformat}, trace._range);
          deltaAx.setScale();
          Axes.prepTicks(deltaAx);
  
          var deltaFmt = function(v) { return Axes.tickText(deltaAx, v).text;};
          var deltaValue = function(d) {
              var value = trace.delta.relative ? d.relativeDelta : d.delta;
              return value;
          };
          var deltaFormatText = function(value, numberFmt) {
              if(value === 0 || typeof value !== 'number' || isNaN(value)) return '-';
              return (value > 0 ? trace.delta.increasing.symbol : trace.delta.decreasing.symbol) + numberFmt(value);
          };
          var deltaFill = function(d) {
              return d.delta >= 0 ? trace.delta.increasing.color : trace.delta.decreasing.color;
          };
          if(trace._deltaLastValue === undefined) {
              trace._deltaLastValue = deltaValue(cd[0]);
          }
          var delta = numbers.select('text.delta');
          delta
              .call(Drawing.font, trace.delta.font)
              .call(Color.fill, deltaFill({delta: trace._deltaLastValue}));
  
          function writeDelta() {
              delta.text(deltaFormatText(deltaValue(cd[0]), deltaFmt))
                  .call(Color.fill, deltaFill(cd[0]))
                  .call(svgTextUtils.convertToTspans, gd);
          }
  
          if(hasTransition(transitionOpts)) {
              delta
                  .transition()
                  .duration(transitionOpts.duration)
                  .ease(transitionOpts.easing)
                  .tween('text', function() {
                      var that = d3.select(this);
                      var to = deltaValue(cd[0]);
                      var from = trace._deltaLastValue;
                      var transitionFmt = transitionFormat(trace.delta.valueformat, deltaFmt, from, to);
                      var interpolator = d3.interpolateNumber(from, to);
                      trace._deltaLastValue = to;
                      return function(t) {
                          that.text(deltaFormatText(interpolator(t), transitionFmt));
                          that.call(Color.fill, deltaFill({delta: interpolator(t)}));
                      };
                  })
                  .each('end', function() { writeDelta(); onComplete && onComplete(); })
                  .each('interrupt', function() { writeDelta(); onComplete && onComplete(); });
          } else {
              writeDelta();
          }
  
          deltabBox = measureText(deltaFormatText(deltaValue(cd[0]), deltaFmt), trace.delta.font, numbersAnchor, gd);
          return delta;
      }
  
      var key = trace.mode + trace.align;
      var delta;
      if(trace._hasDelta) {
          delta = drawDelta();
          key += trace.delta.position + trace.delta.font.size + trace.delta.font.family + trace.delta.valueformat;
          key += trace.delta.increasing.symbol + trace.delta.decreasing.symbol;
          numbersbBox = deltabBox;
      }
      if(trace._hasNumber) {
          drawBignumber();
          key += trace.number.font.size + trace.number.font.family + trace.number.valueformat + trace.number.suffix + trace.number.prefix;
          numbersbBox = bignumberbBox;
      }
  
      // Position delta relative to bignumber
      if(trace._hasDelta && trace._hasNumber) {
          var bignumberCenter = [
              (bignumberbBox.left + bignumberbBox.right) / 2,
              (bignumberbBox.top + bignumberbBox.bottom) / 2
          ];
          var deltaCenter = [
              (deltabBox.left + deltabBox.right) / 2,
              (deltabBox.top + deltabBox.bottom) / 2
          ];
  
          var dx, dy;
          var padding = 0.75 * trace.delta.font.size;
          if(trace.delta.position === 'left') {
              dx = cache(trace, 'deltaPos', 0, -1 * (bignumberbBox.width * (position[trace.align]) + deltabBox.width * (1 - position[trace.align]) + padding), key, Math.min);
              dy = bignumberCenter[1] - deltaCenter[1];
  
              numbersbBox = {
                  width: bignumberbBox.width + deltabBox.width + padding,
                  height: Math.max(bignumberbBox.height, deltabBox.height),
                  left: deltabBox.left + dx,
                  right: bignumberbBox.right,
                  top: Math.min(bignumberbBox.top, deltabBox.top + dy),
                  bottom: Math.max(bignumberbBox.bottom, deltabBox.bottom + dy)
              };
          }
          if(trace.delta.position === 'right') {
              dx = cache(trace, 'deltaPos', 0, bignumberbBox.width * (1 - position[trace.align]) + deltabBox.width * position[trace.align] + padding, key, Math.max);
              dy = bignumberCenter[1] - deltaCenter[1];
  
              numbersbBox = {
                  width: bignumberbBox.width + deltabBox.width + padding,
                  height: Math.max(bignumberbBox.height, deltabBox.height),
                  left: bignumberbBox.left,
                  right: deltabBox.right + dx,
                  top: Math.min(bignumberbBox.top, deltabBox.top + dy),
                  bottom: Math.max(bignumberbBox.bottom, deltabBox.bottom + dy)
              };
          }
          if(trace.delta.position === 'bottom') {
              dx = null;
              dy = deltabBox.height;
  
              numbersbBox = {
                  width: Math.max(bignumberbBox.width, deltabBox.width),
                  height: bignumberbBox.height + deltabBox.height,
                  left: Math.min(bignumberbBox.left, deltabBox.left),
                  right: Math.max(bignumberbBox.right, deltabBox.right),
                  top: bignumberbBox.bottom - bignumberbBox.height,
                  bottom: bignumberbBox.bottom + deltabBox.height
              };
          }
          if(trace.delta.position === 'top') {
              dx = null;
              dy = bignumberbBox.top;
  
              numbersbBox = {
                  width: Math.max(bignumberbBox.width, deltabBox.width),
                  height: bignumberbBox.height + deltabBox.height,
                  left: Math.min(bignumberbBox.left, deltabBox.left),
                  right: Math.max(bignumberbBox.right, deltabBox.right),
                  top: bignumberbBox.bottom - bignumberbBox.height - deltabBox.height,
                  bottom: bignumberbBox.bottom
              };
          }
  
          delta.attr({dx: dx, dy: dy});
      }
  
      // Resize numbers to fit within space and position
      if(trace._hasNumber || trace._hasDelta) {
          numbers.attr('transform', function() {
              var m = opts.numbersScaler(numbersbBox);
              key += m[2];
              var scaleRatio = cache(trace, 'numbersScale', 1, m[0], key, Math.min);
              var translateY;
              if(!trace._scaleNumbers) scaleRatio = 1;
              if(trace._isAngular) {
                  // align vertically to bottom
                  translateY = numbersY - scaleRatio * numbersbBox.bottom;
              } else {
                  // align vertically to center
                  translateY = numbersY - scaleRatio * (numbersbBox.top + numbersbBox.bottom) / 2;
              }
  
              // Stash the top position of numbersbBox for title positioning
              trace._numbersTop = scaleRatio * (numbersbBox.top) + translateY;
  
              var ref = numbersbBox[numbersAlign];
              if(numbersAlign === 'center') ref = (numbersbBox.left + numbersbBox.right) / 2;
              var translateX = numbersX - scaleRatio * ref;
  
              // Stash translateX
              translateX = cache(trace, 'numbersTranslate', 0, translateX, key, Math.max);
              return strTranslate(translateX, translateY) + ' scale(' + scaleRatio + ')';
          });
      }
  }
  
  // Apply fill, stroke, stroke-width to SVG shape
  function styleShape(p) {
      p
          .each(function(d) { Color.stroke(d3.select(this), d.line.color);})
          .each(function(d) { Color.fill(d3.select(this), d.color);})
          .style('stroke-width', function(d) { return d.line.width;});
  }
  
  // Returns a tween for a transition’s "d" attribute, transitioning any selected
  // arcs from their current angle to the specified new angle.
  function arcTween(arc, endAngle, newAngle) {
      return function() {
          var interpolate = d3.interpolate(endAngle, newAngle);
          return function(t) {
              return arc.endAngle(interpolate(t))();
          };
      };
  }
  
  // mocks our axis
  function mockAxis(gd, opts, zrange) {
      var fullLayout = gd._fullLayout;
  
      var axisIn = Lib.extendFlat({
          type: 'linear',
          ticks: 'outside',
          range: zrange,
          showline: true
      }, opts);
  
      var axisOut = {
          type: 'linear',
          _id: 'x' + opts._id
      };
  
      var axisOptions = {
          letter: 'x',
          font: fullLayout.font,
          noHover: true,
          noTickson: true
      };
  
      function coerce(attr, dflt) {
          return Lib.coerce(axisIn, axisOut, axisLayoutAttrs, attr, dflt);
      }
  
      handleAxisDefaults(axisIn, axisOut, coerce, axisOptions, fullLayout);
      handleAxisPositionDefaults(axisIn, axisOut, coerce, axisOptions);
  
      return axisOut;
  }
  
  function strTranslate(x, y) {
      return 'translate(' + x + ',' + y + ')';
  }
  
  function fitTextInsideBox(textBB, width, height) {
      // compute scaling ratio to have text fit within specified width and height
      var ratio = Math.min(width / textBB.width, height / textBB.height);
      return [ratio, textBB, width + 'x' + height];
  }
  
  function fitTextInsideCircle(textBB, radius) {
      // compute scaling ratio to have text fit within specified radius
      var elRadius = Math.sqrt((textBB.width / 2) * (textBB.width / 2) + textBB.height * textBB.height);
      var ratio = radius / elRadius;
      return [ratio, textBB, radius];
  }
  
  function measureText(txt, font, textAnchor, gd) {
      var element = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      var sel = d3.select(element);
      sel.text(txt)
        .attr('x', 0)
        .attr('y', 0)
        .attr('text-anchor', textAnchor)
        .attr('data-unformatted', txt)
        .call(svgTextUtils.convertToTspans, gd)
        .call(Drawing.font, font);
      return Drawing.bBox(sel.node());
  }
  
  function cache(trace, name, initialValue, value, key, fn) {
      var objName = '_cache' + name;
      if(!(trace[objName] && trace[objName].key === key)) {
          trace[objName] = {key: key, value: initialValue};
      }
      var v = Lib.aggNums(fn, null, [trace[objName].value, value], 2);
      trace[objName].value = v;
  
      return v;
  }
  
  },{"../../components/color":615,"../../components/drawing":637,"../../constants/alignment":717,"../../lib":750,"../../lib/svg_text_utils":774,"../../plots/cartesian/axes":799,"../../plots/cartesian/axis_defaults":801,"../../plots/cartesian/layout_attributes":813,"../../plots/cartesian/position_defaults":816,"./constants":1090,"d3":169}],1094:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var meshAttrs = _dereq_('../mesh3d/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  function makeSliceAttr(axLetter) {
      return {
          show: {
              valType: 'boolean',
              
              dflt: false,
              
          },
          locations: {
              valType: 'data_array',
              dflt: [],
              
              
          },
          fill: {
              valType: 'number',
              
              min: 0,
              max: 1,
              dflt: 1,
              
          }
      };
  }
  
  function makeCapAttr(axLetter) {
      return {
          show: {
              valType: 'boolean',
              
              dflt: true,
              
          },
          fill: {
              valType: 'number',
              
              min: 0,
              max: 1,
              dflt: 1,
              
          }
      };
  }
  
  var attrs = module.exports = overrideAll(extendFlat({
      x: {
          valType: 'data_array',
          
          
      },
      y: {
          valType: 'data_array',
          
          
      },
      z: {
          valType: 'data_array',
          
          
      },
      value: {
          valType: 'data_array',
          
          
      },
      isomin: {
          valType: 'number',
          
          
      },
      isomax: {
          valType: 'number',
          
          
      },
  
      surface: {
          show: {
              valType: 'boolean',
              
              dflt: true,
              
          },
          count: {
              valType: 'integer',
              
              dflt: 2,
              min: 1,
              
          },
          fill: {
              valType: 'number',
              
              min: 0,
              max: 1,
              dflt: 1,
              
          },
          pattern: {
              valType: 'flaglist',
              flags: ['A', 'B', 'C', 'D', 'E'],
              extras: ['all', 'odd', 'even'],
              dflt: 'all',
              
              
          }
      },
  
      spaceframe: {
          show: {
              valType: 'boolean',
              
              dflt: false,
              
          },
          fill: {
              valType: 'number',
              
              min: 0,
              max: 1,
              dflt: 0.15,
              
          }
      },
  
      slices: {
          x: makeSliceAttr('x'),
          y: makeSliceAttr('y'),
          z: makeSliceAttr('z')
      },
  
      caps: {
          x: makeCapAttr('x'),
          y: makeCapAttr('y'),
          z: makeCapAttr('z')
      },
  
      text: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          
      },
      hovertext: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          
      },
      hovertemplate: hovertemplateAttrs(),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
  },
  
  colorScaleAttrs('', {
      colorAttr: '`value`',
      showScaleDflt: true,
      editTypeOverride: 'calc'
  }), {
      opacity: meshAttrs.opacity,
      lightposition: meshAttrs.lightposition,
      lighting: meshAttrs.lighting,
      flatshading: meshAttrs.flatshading,
      contour: meshAttrs.contour,
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
  }), 'calc', 'nested');
  
  // required defaults to speed up surface normal calculations
  attrs.flatshading.dflt = true; attrs.lighting.facenormalsepsilon.dflt = 0;
  
  attrs.x.editType = attrs.y.editType = attrs.z.editType = attrs.value.editType = 'calc+clearAxisTypes';
  attrs.transforms = undefined;
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plots/attributes":795,"../../plots/template_attributes":877,"../mesh3d/attributes":1099}],1095:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  var processGrid = _dereq_('../streamtube/calc').processGrid;
  var filter = _dereq_('../streamtube/calc').filter;
  
  module.exports = function calc(gd, trace) {
      trace._len = Math.min(
          trace.x.length,
          trace.y.length,
          trace.z.length,
          trace.value.length
      );
  
      trace._x = filter(trace.x, trace._len);
      trace._y = filter(trace.y, trace._len);
      trace._z = filter(trace.z, trace._len);
      trace._value = filter(trace.value, trace._len);
  
      var grid = processGrid(trace);
      trace._gridFill = grid.fill;
      trace._Xs = grid.Xs;
      trace._Ys = grid.Ys;
      trace._Zs = grid.Zs;
      trace._len = grid.len;
  
      var min = Infinity;
      var max = -Infinity;
      for(var i = 0; i < trace._len; i++) {
          var v = trace._value[i];
          min = Math.min(min, v);
          max = Math.max(max, v);
      }
  
      trace._minValues = min;
      trace._maxValues = max;
      trace._vMin = (trace.isomin === undefined || trace.isomin === null) ? min : trace.isomin;
      trace._vMax = (trace.isomax === undefined || trace.isomin === null) ? max : trace.isomax;
  
      colorscaleCalc(gd, trace, {
          vals: [trace._vMin, trace._vMax],
          containerStr: '',
          cLetter: 'c'
      });
  };
  
  },{"../../components/colorscale/calc":623,"../streamtube/calc":1266}],1096:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var createMesh = _dereq_('gl-mesh3d');
  var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
  var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
  var extractOpts = _dereq_('../../components/colorscale').extractOpts;
  var zip3 = _dereq_('../../plots/gl3d/zip3');
  
  var findNearestOnAxis = function(w, arr) {
      for(var q = arr.length - 1; q > 0; q--) {
          var min = Math.min(arr[q], arr[q - 1]);
          var max = Math.max(arr[q], arr[q - 1]);
          if(max > min && min < w && w <= max) {
              return {
                  id: q,
                  distRatio: (max - w) / (max - min)
              };
          }
      }
      return {
          id: 0,
          distRatio: 0
      };
  };
  
  function IsosurfaceTrace(scene, mesh, uid) {
      this.scene = scene;
      this.uid = uid;
      this.mesh = mesh;
      this.name = '';
      this.data = null;
      this.showContour = false;
  }
  
  var proto = IsosurfaceTrace.prototype;
  
  proto.handlePick = function(selection) {
      if(selection.object === this.mesh) {
          var rawId = selection.data.index;
  
          var x = this.data._meshX[rawId];
          var y = this.data._meshY[rawId];
          var z = this.data._meshZ[rawId];
  
          var height = this.data._Ys.length;
          var depth = this.data._Zs.length;
  
          var i = findNearestOnAxis(x, this.data._Xs).id;
          var j = findNearestOnAxis(y, this.data._Ys).id;
          var k = findNearestOnAxis(z, this.data._Zs).id;
  
          var selectIndex = selection.index = k + depth * j + depth * height * i;
  
          selection.traceCoordinate = [
              this.data._meshX[selectIndex],
              this.data._meshY[selectIndex],
              this.data._meshZ[selectIndex],
              this.data._value[selectIndex]
          ];
  
          var text = this.data.hovertext || this.data.text;
          if(Array.isArray(text) && text[selectIndex] !== undefined) {
              selection.textLabel = text[selectIndex];
          } else if(text) {
              selection.textLabel = text;
          }
  
          return true;
      }
  };
  
  proto.update = function(data) {
      var scene = this.scene;
      var layout = scene.fullSceneLayout;
  
      this.data = generateIsoMeshes(data);
  
      // Unpack position data
      function toDataCoords(axis, coord, scale, calendar) {
          return coord.map(function(x) {
              return axis.d2l(x, 0, calendar) * scale;
          });
      }
  
      var positions = zip3(
          toDataCoords(layout.xaxis, data._meshX, scene.dataScale[0], data.xcalendar),
          toDataCoords(layout.yaxis, data._meshY, scene.dataScale[1], data.ycalendar),
          toDataCoords(layout.zaxis, data._meshZ, scene.dataScale[2], data.zcalendar));
  
      var cells = zip3(data._meshI, data._meshJ, data._meshK);
  
      var config = {
          positions: positions,
          cells: cells,
          lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
          ambient: data.lighting.ambient,
          diffuse: data.lighting.diffuse,
          specular: data.lighting.specular,
          roughness: data.lighting.roughness,
          fresnel: data.lighting.fresnel,
          vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
          faceNormalsEpsilon: data.lighting.facenormalsepsilon,
          opacity: data.opacity,
          contourEnable: data.contour.show,
          contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
          contourWidth: data.contour.width,
          useFacetNormals: data.flatshading
      };
  
      var cOpts = extractOpts(data);
      config.vertexIntensity = data._meshIntensity;
      config.vertexIntensityBounds = [cOpts.min, cOpts.max];
      config.colormap = parseColorScale(data);
  
      // Update mesh
      this.mesh.update(config);
  };
  
  proto.dispose = function() {
      this.scene.glplot.remove(this.mesh);
      this.mesh.dispose();
  };
  
  var GRID_TYPES = ['xyz', 'xzy', 'yxz', 'yzx', 'zxy', 'zyx'];
  
  function generateIsoMeshes(data) {
      data._meshI = [];
      data._meshJ = [];
      data._meshK = [];
  
      var showSurface = data.surface.show;
      var showSpaceframe = data.spaceframe.show;
  
      var surfaceFill = data.surface.fill;
      var spaceframeFill = data.spaceframe.fill;
  
      var drawingSurface = false;
      var drawingSpaceframe = false;
  
      var numFaces = 0;
      var numVertices;
      var beginVertextLength;
  
      var Xs = data._Xs;
      var Ys = data._Ys;
      var Zs = data._Zs;
  
      var width = Xs.length;
      var height = Ys.length;
      var depth = Zs.length;
  
      var filled = GRID_TYPES.indexOf(data._gridFill.replace(/-/g, '').replace(/\+/g, ''));
  
      var getIndex = function(i, j, k) {
          switch(filled) {
              case 5: // 'zyx'
                  return k + depth * j + depth * height * i;
              case 4: // 'zxy'
                  return k + depth * i + depth * width * j;
              case 3: // 'yzx'
                  return j + height * k + height * depth * i;
              case 2: // 'yxz'
                  return j + height * i + height * width * k;
              case 1: // 'xzy'
                  return i + width * k + width * depth * j;
              default: // case 0: // 'xyz'
                  return i + width * j + width * height * k;
          }
      };
  
      var minValues = data._minValues;
      var maxValues = data._maxValues;
  
      var vMin = data._vMin;
      var vMax = data._vMax;
  
      var allXs;
      var allYs;
      var allZs;
      var allVs;
  
      function findVertexId(x, y, z) {
          // could be used to find the vertex id of previously generated vertex within the group
  
          var len = allVs.length;
          for(var f = beginVertextLength; f < len; f++) {
              if(
                  x === allXs[f] &&
                  y === allYs[f] &&
                  z === allZs[f]
              ) {
                  return f;
              }
          }
          return -1;
      }
  
      function beginGroup() {
          beginVertextLength = numVertices;
      }
  
      function emptyVertices() {
          allXs = [];
          allYs = [];
          allZs = [];
          allVs = [];
          numVertices = 0;
  
          beginGroup();
      }
  
      function addVertex(x, y, z, v) {
          allXs.push(x);
          allYs.push(y);
          allZs.push(z);
          allVs.push(v);
          numVertices++;
  
          return numVertices - 1;
      }
  
      function addFace(a, b, c) {
          data._meshI.push(a);
          data._meshJ.push(b);
          data._meshK.push(c);
          numFaces++;
  
          return numFaces - 1;
      }
  
      function getCenter(A, B, C) {
          var M = [];
          for(var i = 0; i < A.length; i++) {
              M[i] = (A[i] + B[i] + C[i]) / 3.0;
          }
          return M;
      }
  
      function getBetween(A, B, r) {
          var M = [];
          for(var i = 0; i < A.length; i++) {
              M[i] = A[i] * (1 - r) + r * B[i];
          }
          return M;
      }
  
      var activeFill;
      function setFill(fill) {
          activeFill = fill;
      }
  
      function createOpenTri(xyzv, abc) {
          var A = xyzv[0];
          var B = xyzv[1];
          var C = xyzv[2];
          var G = getCenter(A, B, C);
  
          var r = Math.sqrt(1 - activeFill);
          var p1 = getBetween(G, A, r);
          var p2 = getBetween(G, B, r);
          var p3 = getBetween(G, C, r);
  
          var a = abc[0];
          var b = abc[1];
          var c = abc[2];
  
          return {
              xyzv: [
                  [A, B, p2], [p2, p1, A],
                  [B, C, p3], [p3, p2, B],
                  [C, A, p1], [p1, p3, C]
              ],
              abc: [
                  [a, b, -1], [-1, -1, a],
                  [b, c, -1], [-1, -1, b],
                  [c, a, -1], [-1, -1, c]
              ]
          };
      }
  
      function styleIncludes(style, char) {
          if(style === 'all' || style === null) return true;
          return (style.indexOf(char) > -1);
      }
  
      function mapValue(style, value) {
          if(style === null) return value;
          return style;
      }
  
      function drawTri(style, xyzv, abc) {
          beginGroup();
  
          var allXYZVs = [xyzv];
          var allABCs = [abc];
          if(activeFill >= 1) {
              allXYZVs = [xyzv];
              allABCs = [abc];
          } else if(activeFill > 0) {
              var openTri = createOpenTri(xyzv, abc);
              allXYZVs = openTri.xyzv;
              allABCs = openTri.abc;
          }
  
          for(var f = 0; f < allXYZVs.length; f++) {
              xyzv = allXYZVs[f];
              abc = allABCs[f];
  
              var pnts = [];
              for(var i = 0; i < 3; i++) {
                  var x = xyzv[i][0];
                  var y = xyzv[i][1];
                  var z = xyzv[i][2];
                  var v = xyzv[i][3];
  
                  var id = (abc[i] > -1) ? abc[i] : findVertexId(x, y, z);
                  if(id > -1) {
                      pnts[i] = id;
                  } else {
                      pnts[i] = addVertex(x, y, z, mapValue(style, v));
                  }
              }
  
              addFace(pnts[0], pnts[1], pnts[2]);
          }
      }
  
      function drawQuad(style, xyzv, abcd) {
          var makeTri = function(i, j, k) {
              drawTri(style, [xyzv[i], xyzv[j], xyzv[k]], [abcd[i], abcd[j], abcd[k]]);
          };
  
          makeTri(0, 1, 2);
          makeTri(2, 3, 0);
      }
  
      function drawTetra(style, xyzv, abcd) {
          var makeTri = function(i, j, k) {
              drawTri(style, [xyzv[i], xyzv[j], xyzv[k]], [abcd[i], abcd[j], abcd[k]]);
          };
  
          makeTri(0, 1, 2);
          makeTri(3, 0, 1);
          makeTri(2, 3, 0);
          makeTri(1, 2, 3);
      }
  
      function calcIntersection(pointOut, pointIn, min, max) {
          var value = pointOut[3];
  
          if(value < min) value = min;
          if(value > max) value = max;
  
          var ratio = (pointOut[3] - value) / (pointOut[3] - pointIn[3] + 0.000000001); // we had to add this error to force solve the tiny caps
  
          var result = [];
          for(var s = 0; s < 4; s++) {
              result[s] = (1 - ratio) * pointOut[s] + ratio * pointIn[s];
          }
          return result;
      }
  
      function inRange(value, min, max) {
          return (
              value >= min &&
              value <= max
          );
      }
  
      function almostInFinalRange(value) {
          var vErr = 0.001 * (vMax - vMin);
          return (
              value >= vMin - vErr &&
              value <= vMax + vErr
          );
      }
  
      function getXYZV(indecies) {
          var xyzv = [];
          for(var q = 0; q < 4; q++) {
              var index = indecies[q];
              xyzv.push(
                  [
                      data._x[index],
                      data._y[index],
                      data._z[index],
                      data._value[index]
                  ]
              );
          }
  
          return xyzv;
      }
  
      var MAX_PASS = 3;
  
      function tryCreateTri(style, xyzv, abc, min, max, nPass) {
          if(!nPass) nPass = 1;
  
          abc = [-1, -1, -1]; // Note: for the moment we override indices
          // to run faster! But it is possible to comment this line
          // to reduce the number of vertices.
  
          var result = false;
  
          var ok = [
              inRange(xyzv[0][3], min, max),
              inRange(xyzv[1][3], min, max),
              inRange(xyzv[2][3], min, max)
          ];
  
          if(!ok[0] && !ok[1] && !ok[2]) {
              return false;
          }
  
          var tryDrawTri = function(style, xyzv, abc) {
              if( // we check here if the points are in `real` iso-min/max range
                  almostInFinalRange(xyzv[0][3]) &&
                  almostInFinalRange(xyzv[1][3]) &&
                  almostInFinalRange(xyzv[2][3])
              ) {
                  drawTri(style, xyzv, abc);
                  return true;
              } else if(nPass < MAX_PASS) {
                  return tryCreateTri(style, xyzv, abc, vMin, vMax, ++nPass); // i.e. second pass using actual vMin vMax bounds
              }
              return false;
          };
  
          if(ok[0] && ok[1] && ok[2]) {
              return tryDrawTri(style, xyzv, abc) || result;
          }
  
          var interpolated = false;
  
          [
              [0, 1, 2],
              [2, 0, 1],
              [1, 2, 0]
          ].forEach(function(e) {
              if(ok[e[0]] && ok[e[1]] && !ok[e[2]]) {
                  var A = xyzv[e[0]];
                  var B = xyzv[e[1]];
                  var C = xyzv[e[2]];
  
                  var p1 = calcIntersection(C, A, min, max);
                  var p2 = calcIntersection(C, B, min, max);
  
                  result = tryDrawTri(style, [p2, p1, A], [-1, -1, abc[e[0]]]) || result;
                  result = tryDrawTri(style, [A, B, p2], [abc[e[0]], abc[e[1]], -1]) || result;
  
                  interpolated = true;
              }
          });
          if(interpolated) return result;
  
          [
              [0, 1, 2],
              [1, 2, 0],
              [2, 0, 1]
          ].forEach(function(e) {
              if(ok[e[0]] && !ok[e[1]] && !ok[e[2]]) {
                  var A = xyzv[e[0]];
                  var B = xyzv[e[1]];
                  var C = xyzv[e[2]];
  
                  var p1 = calcIntersection(B, A, min, max);
                  var p2 = calcIntersection(C, A, min, max);
  
                  result = tryDrawTri(style, [p2, p1, A], [-1, -1, abc[e[0]]]) || result;
  
                  interpolated = true;
              }
          });
          return result;
      }
  
      function tryCreateTetra(style, abcd, min, max) {
          var result = false;
  
          var xyzv = getXYZV(abcd);
  
          var ok = [
              inRange(xyzv[0][3], min, max),
              inRange(xyzv[1][3], min, max),
              inRange(xyzv[2][3], min, max),
              inRange(xyzv[3][3], min, max)
          ];
  
          if(!ok[0] && !ok[1] && !ok[2] && !ok[3]) {
              return result;
          }
  
          if(ok[0] && ok[1] && ok[2] && ok[3]) {
              if(drawingSpaceframe) {
                  result = drawTetra(style, xyzv, abcd) || result;
              }
              return result;
          }
  
          var interpolated = false;
  
          [
              [0, 1, 2, 3],
              [3, 0, 1, 2],
              [2, 3, 0, 1],
              [1, 2, 3, 0]
          ].forEach(function(e) {
              if(ok[e[0]] && ok[e[1]] && ok[e[2]] && !ok[e[3]]) {
                  var A = xyzv[e[0]];
                  var B = xyzv[e[1]];
                  var C = xyzv[e[2]];
                  var D = xyzv[e[3]];
  
                  if(drawingSpaceframe) {
                      result = drawTri(style, [A, B, C], [abcd[e[0]], abcd[e[1]], abcd[e[2]]]) || result;
                  } else {
                      var p1 = calcIntersection(D, A, min, max);
                      var p2 = calcIntersection(D, B, min, max);
                      var p3 = calcIntersection(D, C, min, max);
  
                      result = drawTri(null, [p1, p2, p3], [-1, -1, -1]) || result;
                  }
  
                  interpolated = true;
              }
          });
          if(interpolated) return result;
  
          [
              [0, 1, 2, 3],
              [1, 2, 3, 0],
              [2, 3, 0, 1],
              [3, 0, 1, 2],
              [0, 2, 3, 1],
              [1, 3, 2, 0]
          ].forEach(function(e) {
              if(ok[e[0]] && ok[e[1]] && !ok[e[2]] && !ok[e[3]]) {
                  var A = xyzv[e[0]];
                  var B = xyzv[e[1]];
                  var C = xyzv[e[2]];
                  var D = xyzv[e[3]];
  
                  var p1 = calcIntersection(C, A, min, max);
                  var p2 = calcIntersection(C, B, min, max);
                  var p3 = calcIntersection(D, B, min, max);
                  var p4 = calcIntersection(D, A, min, max);
  
                  if(drawingSpaceframe) {
                      result = drawTri(style, [A, p4, p1], [abcd[e[0]], -1, -1]) || result;
                      result = drawTri(style, [B, p2, p3], [abcd[e[1]], -1, -1]) || result;
                  } else {
                      result = drawQuad(null, [p1, p2, p3, p4], [-1, -1, -1, -1]) || result;
                  }
  
                  interpolated = true;
              }
          });
          if(interpolated) return result;
  
          [
              [0, 1, 2, 3],
              [1, 2, 3, 0],
              [2, 3, 0, 1],
              [3, 0, 1, 2]
          ].forEach(function(e) {
              if(ok[e[0]] && !ok[e[1]] && !ok[e[2]] && !ok[e[3]]) {
                  var A = xyzv[e[0]];
                  var B = xyzv[e[1]];
                  var C = xyzv[e[2]];
                  var D = xyzv[e[3]];
  
                  var p1 = calcIntersection(B, A, min, max);
                  var p2 = calcIntersection(C, A, min, max);
                  var p3 = calcIntersection(D, A, min, max);
  
                  if(drawingSpaceframe) {
                      result = drawTri(style, [A, p1, p2], [abcd[e[0]], -1, -1]) || result;
                      result = drawTri(style, [A, p2, p3], [abcd[e[0]], -1, -1]) || result;
                      result = drawTri(style, [A, p3, p1], [abcd[e[0]], -1, -1]) || result;
                  } else {
                      result = drawTri(null, [p1, p2, p3], [-1, -1, -1]) || result;
                  }
  
                  interpolated = true;
              }
          });
          return result;
      }
  
      function addCube(style, p000, p001, p010, p011, p100, p101, p110, p111, min, max) {
          var result = false;
  
          if(drawingSurface) {
              if(styleIncludes(style, 'A')) {
                  result = tryCreateTetra(null, [p000, p001, p010, p100], min, max) || result;
              }
              if(styleIncludes(style, 'B')) {
                  result = tryCreateTetra(null, [p001, p010, p011, p111], min, max) || result;
              }
              if(styleIncludes(style, 'C')) {
                  result = tryCreateTetra(null, [p001, p100, p101, p111], min, max) || result;
              }
              if(styleIncludes(style, 'D')) {
                  result = tryCreateTetra(null, [p010, p100, p110, p111], min, max) || result;
              }
              if(styleIncludes(style, 'E')) {
                  result = tryCreateTetra(null, [p001, p010, p100, p111], min, max) || result;
              }
          }
  
          if(drawingSpaceframe) {
              result = tryCreateTetra(style, [p001, p010, p100, p111], min, max) || result;
          }
  
          return result;
      }
  
      function addRect(style, a, b, c, d, min, max, previousResult) {
          return [
              (previousResult[0] === true) ? true :
              tryCreateTri(style, getXYZV([a, b, c]), [a, b, c], min, max),
              (previousResult[1] === true) ? true :
              tryCreateTri(style, getXYZV([c, d, a]), [c, d, a], min, max)
          ];
      }
  
      function begin2dCell(style, p00, p01, p10, p11, min, max, isEven, previousResult) {
          // used to create caps and/or slices on exact axis points
          if(isEven) {
              return addRect(style, p00, p01, p11, p10, min, max, previousResult);
          } else {
              return addRect(style, p01, p11, p10, p00, min, max, previousResult);
          }
      }
  
      function beginSection(style, i, j, k, min, max, distRatios) {
          // used to create slices between axis points
  
          var result = false;
          var A, B, C, D;
  
          var makeSection = function() {
              result = tryCreateTri(style, [A, B, C], [-1, -1, -1], min, max) || result;
              result = tryCreateTri(style, [C, D, A], [-1, -1, -1], min, max) || result;
          };
  
          var rX = distRatios[0];
          var rY = distRatios[1];
          var rZ = distRatios[2];
  
          if(rX) {
              A = getBetween(getXYZV([getIndex(i, j - 0, k - 0)])[0], getXYZV([getIndex(i - 1, j - 0, k - 0)])[0], rX);
              B = getBetween(getXYZV([getIndex(i, j - 0, k - 1)])[0], getXYZV([getIndex(i - 1, j - 0, k - 1)])[0], rX);
              C = getBetween(getXYZV([getIndex(i, j - 1, k - 1)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rX);
              D = getBetween(getXYZV([getIndex(i, j - 1, k - 0)])[0], getXYZV([getIndex(i - 1, j - 1, k - 0)])[0], rX);
              makeSection();
          }
  
          if(rY) {
              A = getBetween(getXYZV([getIndex(i - 0, j, k - 0)])[0], getXYZV([getIndex(i - 0, j - 1, k - 0)])[0], rY);
              B = getBetween(getXYZV([getIndex(i - 0, j, k - 1)])[0], getXYZV([getIndex(i - 0, j - 1, k - 1)])[0], rY);
              C = getBetween(getXYZV([getIndex(i - 1, j, k - 1)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rY);
              D = getBetween(getXYZV([getIndex(i - 1, j, k - 0)])[0], getXYZV([getIndex(i - 1, j - 1, k - 0)])[0], rY);
              makeSection();
          }
  
          if(rZ) {
              A = getBetween(getXYZV([getIndex(i - 0, j - 0, k)])[0], getXYZV([getIndex(i - 0, j - 0, k - 1)])[0], rZ);
              B = getBetween(getXYZV([getIndex(i - 0, j - 1, k)])[0], getXYZV([getIndex(i - 0, j - 1, k - 1)])[0], rZ);
              C = getBetween(getXYZV([getIndex(i - 1, j - 1, k)])[0], getXYZV([getIndex(i - 1, j - 1, k - 1)])[0], rZ);
              D = getBetween(getXYZV([getIndex(i - 1, j - 0, k)])[0], getXYZV([getIndex(i - 1, j - 0, k - 1)])[0], rZ);
              makeSection();
          }
  
          return result;
      }
  
      function begin3dCell(style, p000, p001, p010, p011, p100, p101, p110, p111, min, max, isEven) {
          // used to create spaceframe and/or iso-surfaces
  
          var cellStyle = style;
          if(isEven) {
              if(drawingSurface && style === 'even') cellStyle = null;
              return addCube(cellStyle, p000, p001, p010, p011, p100, p101, p110, p111, min, max);
          } else {
              if(drawingSurface && style === 'odd') cellStyle = null;
              return addCube(cellStyle, p111, p110, p101, p100, p011, p010, p001, p000, min, max);
          }
      }
  
      function draw2dX(style, items, min, max, previousResult) {
          var result = [];
          var n = 0;
          for(var q = 0; q < items.length; q++) {
              var i = items[q];
              for(var k = 1; k < depth; k++) {
                  for(var j = 1; j < height; j++) {
                      result.push(
                          begin2dCell(style,
                              getIndex(i, j - 1, k - 1),
                              getIndex(i, j - 1, k),
                              getIndex(i, j, k - 1),
                              getIndex(i, j, k),
                              min,
                              max,
                              (i + j + k) % 2,
                              (previousResult && previousResult[n]) ? previousResult[n] : []
                          )
                      );
                      n++;
                  }
              }
          }
          return result;
      }
  
      function draw2dY(style, items, min, max, previousResult) {
          var result = [];
          var n = 0;
          for(var q = 0; q < items.length; q++) {
              var j = items[q];
              for(var i = 1; i < width; i++) {
                  for(var k = 1; k < depth; k++) {
                      result.push(
                          begin2dCell(style,
                              getIndex(i - 1, j, k - 1),
                              getIndex(i, j, k - 1),
                              getIndex(i - 1, j, k),
                              getIndex(i, j, k),
                              min,
                              max,
                              (i + j + k) % 2,
                              (previousResult && previousResult[n]) ? previousResult[n] : []
                          )
                      );
                      n++;
                  }
              }
          }
          return result;
      }
  
      function draw2dZ(style, items, min, max, previousResult) {
          var result = [];
          var n = 0;
          for(var q = 0; q < items.length; q++) {
              var k = items[q];
              for(var j = 1; j < height; j++) {
                  for(var i = 1; i < width; i++) {
                      result.push(
                          begin2dCell(style,
                              getIndex(i - 1, j - 1, k),
                              getIndex(i - 1, j, k),
                              getIndex(i, j - 1, k),
                              getIndex(i, j, k),
                              min,
                              max,
                              (i + j + k) % 2,
                              (previousResult && previousResult[n]) ? previousResult[n] : []
                          )
                      );
                      n++;
                  }
              }
          }
          return result;
      }
  
      function draw3d(style, min, max) {
          for(var k = 1; k < depth; k++) {
              for(var j = 1; j < height; j++) {
                  for(var i = 1; i < width; i++) {
                      begin3dCell(style,
                          getIndex(i - 1, j - 1, k - 1),
                          getIndex(i - 1, j - 1, k),
                          getIndex(i - 1, j, k - 1),
                          getIndex(i - 1, j, k),
                          getIndex(i, j - 1, k - 1),
                          getIndex(i, j - 1, k),
                          getIndex(i, j, k - 1),
                          getIndex(i, j, k),
                          min,
                          max,
                          (i + j + k) % 2
                      );
                  }
              }
          }
      }
  
      function drawSpaceframe(style, min, max) {
          drawingSpaceframe = true;
          draw3d(style, min, max);
          drawingSpaceframe = false;
      }
  
      function drawSurface(style, min, max) {
          drawingSurface = true;
          draw3d(style, min, max);
          drawingSurface = false;
      }
  
      function drawSectionX(style, items, min, max, distRatios, previousResult) {
          var result = [];
          var n = 0;
          for(var q = 0; q < items.length; q++) {
              var i = items[q];
              for(var k = 1; k < depth; k++) {
                  for(var j = 1; j < height; j++) {
                      result.push(
                          beginSection(style, i, j, k, min, max, distRatios[q],
                              (previousResult && previousResult[n]) ? previousResult[n] : []
                          )
                      );
                      n++;
                  }
              }
          }
          return result;
      }
  
      function drawSectionY(style, items, min, max, distRatios, previousResult) {
          var result = [];
          var n = 0;
          for(var q = 0; q < items.length; q++) {
              var j = items[q];
              for(var i = 1; i < width; i++) {
                  for(var k = 1; k < depth; k++) {
                      result.push(
                          beginSection(style, i, j, k, min, max, distRatios[q],
                              (previousResult && previousResult[n]) ? previousResult[n] : []
                          )
                      );
                      n++;
                  }
              }
          }
          return result;
      }
  
      function drawSectionZ(style, items, min, max, distRatios, previousResult) {
          var result = [];
          var n = 0;
          for(var q = 0; q < items.length; q++) {
              var k = items[q];
              for(var j = 1; j < height; j++) {
                  for(var i = 1; i < width; i++) {
                      result.push(
                          beginSection(style, i, j, k, min, max, distRatios[q],
                              (previousResult && previousResult[n]) ? previousResult[n] : []
                          )
                      );
                      n++;
                  }
              }
          }
          return result;
      }
  
      function createRange(a, b) {
          var range = [];
          for(var q = a; q < b; q++) {
              range.push(q);
          }
          return range;
      }
  
      function insertGridPoints() {
          for(var i = 0; i < width; i++) {
              for(var j = 0; j < height; j++) {
                  for(var k = 0; k < depth; k++) {
                      var index = getIndex(i, j, k);
                      addVertex(
                          data._x[index],
                          data._y[index],
                          data._z[index],
                          data._value[index]
                      );
                  }
              }
          }
      }
  
      function drawAll() {
          emptyVertices();
  
          // insert grid points
          insertGridPoints();
  
          var activeStyle = null;
  
          // draw spaceframes
          if(showSpaceframe && spaceframeFill) {
              setFill(spaceframeFill);
  
              drawSpaceframe(activeStyle, vMin, vMax);
          }
  
          // draw iso-surfaces
          if(showSurface && surfaceFill) {
              setFill(surfaceFill);
  
              var surfacePattern = data.surface.pattern;
              var surfaceCount = data.surface.count;
              for(var q = 0; q < surfaceCount; q++) {
                  var ratio = (surfaceCount === 1) ? 0.5 : q / (surfaceCount - 1);
                  var level = (1 - ratio) * vMin + ratio * vMax;
  
                  var d1 = Math.abs(level - minValues);
                  var d2 = Math.abs(level - maxValues);
                  var ranges = (d1 > d2) ?
                      [minValues, level] :
                      [level, maxValues];
  
                  drawSurface(surfacePattern, ranges[0], ranges[1]);
              }
          }
  
          var setupMinMax = [
              [ Math.min(vMin, maxValues), Math.max(vMin, maxValues) ],
              [ Math.min(minValues, vMax), Math.max(minValues, vMax) ]
          ];
  
          ['x', 'y', 'z'].forEach(function(e) {
              var preRes = [];
              for(var s = 0; s < setupMinMax.length; s++) {
                  var count = 0;
  
                  var activeMin = setupMinMax[s][0];
                  var activeMax = setupMinMax[s][1];
  
                  // draw slices
                  var slice = data.slices[e];
                  if(slice.show && slice.fill) {
                      setFill(slice.fill);
  
                      var exactIndices = [];
                      var ceilIndices = [];
                      var distRatios = [];
                      if(slice.locations.length) {
                          for(var q = 0; q < slice.locations.length; q++) {
                              var near = findNearestOnAxis(
                                  slice.locations[q],
                                  (e === 'x') ? Xs :
                                  (e === 'y') ? Ys : Zs
                              );
  
                              if(near.distRatio === 0) {
                                  exactIndices.push(near.id);
                              } else if(near.id > 0) {
                                  ceilIndices.push(near.id);
                                  if(e === 'x') {
                                      distRatios.push([near.distRatio, 0, 0]);
                                  } else if(e === 'y') {
                                      distRatios.push([0, near.distRatio, 0]);
                                  } else {
                                      distRatios.push([0, 0, near.distRatio]);
                                  }
                              }
                          }
                      } else {
                          if(e === 'x') {
                              exactIndices = createRange(1, width - 1);
                          } else if(e === 'y') {
                              exactIndices = createRange(1, height - 1);
                          } else {
                              exactIndices = createRange(1, depth - 1);
                          }
                      }
  
                      if(ceilIndices.length > 0) {
                          if(e === 'x') {
                              preRes[count] = drawSectionX(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
                          } else if(e === 'y') {
                              preRes[count] = drawSectionY(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
                          } else {
                              preRes[count] = drawSectionZ(activeStyle, ceilIndices, activeMin, activeMax, distRatios, preRes[count]);
                          }
                          count++;
                      }
  
                      if(exactIndices.length > 0) {
                          if(e === 'x') {
                              preRes[count] = draw2dX(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
                          } else if(e === 'y') {
                              preRes[count] = draw2dY(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
                          } else {
                              preRes[count] = draw2dZ(activeStyle, exactIndices, activeMin, activeMax, preRes[count]);
                          }
                          count++;
                      }
                  }
  
                  // draw caps
                  var cap = data.caps[e];
                  if(cap.show && cap.fill) {
                      setFill(cap.fill);
                      if(e === 'x') {
                          preRes[count] = draw2dX(activeStyle, [0, width - 1], activeMin, activeMax, preRes[count]);
                      } else if(e === 'y') {
                          preRes[count] = draw2dY(activeStyle, [0, height - 1], activeMin, activeMax, preRes[count]);
                      } else {
                          preRes[count] = draw2dZ(activeStyle, [0, depth - 1], activeMin, activeMax, preRes[count]);
                      }
                      count++;
                  }
              }
          });
  
          // remove vertices arrays (i.e. grid points) in case no face was created.
          if(numFaces === 0) {
              emptyVertices();
          }
  
          data._meshX = allXs;
          data._meshY = allYs;
          data._meshZ = allZs;
          data._meshIntensity = allVs;
  
          data._Xs = Xs;
          data._Ys = Ys;
          data._Zs = Zs;
      }
  
      drawAll();
  
      return data;
  }
  
  function createIsosurfaceTrace(scene, data) {
      var gl = scene.glplot.gl;
      var mesh = createMesh({gl: gl});
      var result = new IsosurfaceTrace(scene, mesh, data.uid);
  
      mesh._trace = result;
      result.update(data);
      scene.glplot.add(mesh);
      return result;
  }
  
  module.exports = {
      findNearestOnAxis: findNearestOnAxis,
      generateIsoMeshes: generateIsoMeshes,
      createIsosurfaceTrace: createIsosurfaceTrace,
  };
  
  },{"../../components/colorscale":627,"../../lib/gl_format_color":746,"../../lib/str2rgbarray":773,"../../plots/gl3d/zip3":852,"gl-mesh3d":292}],1097:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  var attributes = _dereq_('./attributes');
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  
  function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce);
  }
  
  function supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
      var isomin = coerce('isomin');
      var isomax = coerce('isomax');
  
      if(isomax !== undefined && isomax !== null &&
          isomin !== undefined && isomin !== null &&
           isomin > isomax) {
          // applying default values in this case:
          traceOut.isomin = null;
          traceOut.isomax = null;
      }
  
      var x = coerce('x');
      var y = coerce('y');
      var z = coerce('z');
      var value = coerce('value');
  
      if(
          !x || !x.length ||
          !y || !y.length ||
          !z || !z.length ||
          !value || !value.length
      ) {
          traceOut.visible = false;
          return;
      }
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
  
      ['x', 'y', 'z'].forEach(function(dim) {
          var capDim = 'caps.' + dim;
          var showCap = coerce(capDim + '.show');
          if(showCap) {
              coerce(capDim + '.fill');
          }
  
          var sliceDim = 'slices.' + dim;
          var showSlice = coerce(sliceDim + '.show');
          if(showSlice) {
              coerce(sliceDim + '.fill');
              coerce(sliceDim + '.locations');
          }
      });
  
      var showSpaceframe = coerce('spaceframe.show');
      if(showSpaceframe) {
          coerce('spaceframe.fill');
      }
  
      var showSurface = coerce('surface.show');
      if(showSurface) {
          coerce('surface.count');
          coerce('surface.fill');
          coerce('surface.pattern');
      }
  
      var showContour = coerce('contour.show');
      if(showContour) {
          coerce('contour.color');
          coerce('contour.width');
      }
  
      // Coerce remaining properties
      [
          'text',
          'hovertext',
          'hovertemplate',
          'lighting.ambient',
          'lighting.diffuse',
          'lighting.specular',
          'lighting.roughness',
          'lighting.fresnel',
          'lighting.vertexnormalsepsilon',
          'lighting.facenormalsepsilon',
          'lightposition.x',
          'lightposition.y',
          'lightposition.z',
          'flatshading',
          'opacity'
      ].forEach(function(x) { coerce(x); });
  
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'});
  
      // disable 1D transforms (for now)
      traceOut._length = null;
  }
  
  module.exports = {
      supplyDefaults: supplyDefaults,
      supplyIsoDefaults: supplyIsoDefaults
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"../../registry":882,"./attributes":1094}],1098:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults').supplyDefaults,
      calc: _dereq_('./calc'),
      colorbar: {
          min: 'cmin',
          max: 'cmax'
      },
      plot: _dereq_('./convert').createIsosurfaceTrace,
  
      moduleType: 'trace',
      name: 'isosurface',
      basePlotModule: _dereq_('../../plots/gl3d'),
      categories: ['gl3d', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"../../plots/gl3d":841,"./attributes":1094,"./calc":1095,"./convert":1096,"./defaults":1097}],1099:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var surfaceAttrs = _dereq_('../surface/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = extendFlat({
      x: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
      y: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
      z: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
  
      i: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      j: {
          valType: 'data_array',
          editType: 'calc',
          
  
      },
      k: {
          valType: 'data_array',
          editType: 'calc',
          
  
      },
  
      text: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          editType: 'calc',
          
      },
      hovertext: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          editType: 'calc',
          
      },
      hovertemplate: hovertemplateAttrs({editType: 'calc'}),
  
      delaunayaxis: {
          valType: 'enumerated',
          
          values: [ 'x', 'y', 'z' ],
          dflt: 'z',
          editType: 'calc',
          
      },
  
      alphahull: {
          valType: 'number',
          
          dflt: -1,
          editType: 'calc',
          
      },
  
      intensity: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      intensitymode: {
          valType: 'enumerated',
          values: ['vertex', 'cell'],
          dflt: 'vertex',
          editType: 'calc',
          
          
      },
  
      // Color field
      color: {
          valType: 'color',
          
          editType: 'calc',
          
      },
      vertexcolor: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
      facecolor: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
      transforms: undefined
  },
  
  colorScaleAttrs('', {
      colorAttr: '`intensity`',
      showScaleDflt: true,
      editTypeOverride: 'calc'
  }), {
      opacity: surfaceAttrs.opacity,
  
      // Flat shaded mode
      flatshading: {
          valType: 'boolean',
          
          dflt: false,
          editType: 'calc',
          
      },
  
      contour: {
          show: extendFlat({}, surfaceAttrs.contours.x.show, {
              
          }),
          color: surfaceAttrs.contours.x.color,
          width: surfaceAttrs.contours.x.width,
          editType: 'calc'
      },
  
      lightposition: {
          x: extendFlat({}, surfaceAttrs.lightposition.x, {dflt: 1e5}),
          y: extendFlat({}, surfaceAttrs.lightposition.y, {dflt: 1e5}),
          z: extendFlat({}, surfaceAttrs.lightposition.z, {dflt: 0}),
          editType: 'calc'
      },
      lighting: extendFlat({
          vertexnormalsepsilon: {
              valType: 'number',
              
              min: 0.00,
              max: 1,
              dflt: 1e-12, // otherwise finely tessellated things eg. the brain will have no specular light reflection
              editType: 'calc',
              
          },
          facenormalsepsilon: {
              valType: 'number',
              
              min: 0.00,
              max: 1,
              dflt: 1e-6, // even the brain model doesn't appear to need finer than this
              editType: 'calc',
              
          },
          editType: 'calc'
      }, surfaceAttrs.lighting),
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {editType: 'calc'}),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
  });
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../surface/attributes":1282}],1100:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  
  module.exports = function calc(gd, trace) {
      if(trace.intensity) {
          colorscaleCalc(gd, trace, {
              vals: trace.intensity,
              containerStr: '',
              cLetter: 'c'
          });
      }
  };
  
  },{"../../components/colorscale/calc":623}],1101:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var createMesh = _dereq_('gl-mesh3d');
  var triangulate = _dereq_('delaunay-triangulate');
  var alphaShape = _dereq_('alpha-shape');
  var convexHull = _dereq_('convex-hull');
  
  var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
  var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
  var extractOpts = _dereq_('../../components/colorscale').extractOpts;
  var zip3 = _dereq_('../../plots/gl3d/zip3');
  
  function Mesh3DTrace(scene, mesh, uid) {
      this.scene = scene;
      this.uid = uid;
      this.mesh = mesh;
      this.name = '';
      this.color = '#fff';
      this.data = null;
      this.showContour = false;
  }
  
  var proto = Mesh3DTrace.prototype;
  
  proto.handlePick = function(selection) {
      if(selection.object === this.mesh) {
          var selectIndex = selection.index = selection.data.index;
  
          if(selection.data._cellCenter) {
              selection.traceCoordinate = selection.data.dataCoordinate;
          } else {
              selection.traceCoordinate = [
                  this.data.x[selectIndex],
                  this.data.y[selectIndex],
                  this.data.z[selectIndex]
              ];
          }
  
          var text = this.data.hovertext || this.data.text;
          if(Array.isArray(text) && text[selectIndex] !== undefined) {
              selection.textLabel = text[selectIndex];
          } else if(text) {
              selection.textLabel = text;
          }
  
          return true;
      }
  };
  
  function parseColorArray(colors) {
      var b = [];
      var len = colors.length;
      for(var i = 0; i < len; i++) {
          b[i] = str2RgbaArray(colors[i]);
      }
      return b;
  }
  
  // Unpack position data
  function toDataCoords(axis, coord, scale, calendar) {
      var b = [];
      var len = coord.length;
      for(var i = 0; i < len; i++) {
          b[i] = axis.d2l(coord[i], 0, calendar) * scale;
      }
      return b;
  }
  
  // Round indices if passed as floats
  function toRoundIndex(a) {
      var b = [];
      var len = a.length;
      for(var i = 0; i < len; i++) {
          b[i] = Math.round(a[i]);
      }
      return b;
  }
  
  function delaunayCells(delaunayaxis, positions) {
      var d = ['x', 'y', 'z'].indexOf(delaunayaxis);
      var b = [];
      var len = positions.length;
      for(var i = 0; i < len; i++) {
          b[i] = [positions[i][(d + 1) % 3], positions[i][(d + 2) % 3]];
      }
      return triangulate(b);
  }
  
  // Validate indices
  function hasValidIndices(list, numVertices) {
      var len = list.length;
      for(var i = 0; i < len; i++) {
          if(list[i] <= -0.5 || list[i] >= numVertices - 0.5) { // Note: the indices would be rounded -0.49 is valid.
              return false;
          }
      }
      return true;
  }
  
  proto.update = function(data) {
      var scene = this.scene;
      var layout = scene.fullSceneLayout;
  
      this.data = data;
  
      var numVertices = data.x.length;
  
      var positions = zip3(
          toDataCoords(layout.xaxis, data.x, scene.dataScale[0], data.xcalendar),
          toDataCoords(layout.yaxis, data.y, scene.dataScale[1], data.ycalendar),
          toDataCoords(layout.zaxis, data.z, scene.dataScale[2], data.zcalendar)
      );
  
      var cells;
      if(data.i && data.j && data.k) {
          if(
              data.i.length !== data.j.length ||
              data.j.length !== data.k.length ||
              !hasValidIndices(data.i, numVertices) ||
              !hasValidIndices(data.j, numVertices) ||
              !hasValidIndices(data.k, numVertices)
          ) {
              return;
          }
          cells = zip3(
              toRoundIndex(data.i),
              toRoundIndex(data.j),
              toRoundIndex(data.k)
          );
      } else if(data.alphahull === 0) {
          cells = convexHull(positions);
      } else if(data.alphahull > 0) {
          cells = alphaShape(data.alphahull, positions);
      } else {
          cells = delaunayCells(data.delaunayaxis, positions);
      }
  
      var config = {
          positions: positions,
          cells: cells,
          lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
          ambient: data.lighting.ambient,
          diffuse: data.lighting.diffuse,
          specular: data.lighting.specular,
          roughness: data.lighting.roughness,
          fresnel: data.lighting.fresnel,
          vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
          faceNormalsEpsilon: data.lighting.facenormalsepsilon,
          opacity: data.opacity,
          contourEnable: data.contour.show,
          contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
          contourWidth: data.contour.width,
          useFacetNormals: data.flatshading
      };
  
      if(data.intensity) {
          var cOpts = extractOpts(data);
          this.color = '#fff';
          var mode = data.intensitymode;
          config[mode + 'Intensity'] = data.intensity;
          config[mode + 'IntensityBounds'] = [cOpts.min, cOpts.max];
          config.colormap = parseColorScale(data);
      } else if(data.vertexcolor) {
          this.color = data.vertexcolor[0];
          config.vertexColors = parseColorArray(data.vertexcolor);
      } else if(data.facecolor) {
          this.color = data.facecolor[0];
          config.cellColors = parseColorArray(data.facecolor);
      } else {
          this.color = data.color;
          config.meshColor = str2RgbaArray(data.color);
      }
  
      // Update mesh
      this.mesh.update(config);
  };
  
  proto.dispose = function() {
      this.scene.glplot.remove(this.mesh);
      this.mesh.dispose();
  };
  
  function createMesh3DTrace(scene, data) {
      var gl = scene.glplot.gl;
      var mesh = createMesh({gl: gl});
      var result = new Mesh3DTrace(scene, mesh, data.uid);
      mesh._trace = result;
      result.update(data);
      scene.glplot.add(mesh);
      return result;
  }
  
  module.exports = createMesh3DTrace;
  
  },{"../../components/colorscale":627,"../../lib/gl_format_color":746,"../../lib/str2rgbarray":773,"../../plots/gl3d/zip3":852,"alpha-shape":69,"convex-hull":135,"delaunay-triangulate":171,"gl-mesh3d":292}],1102:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      // read in face/vertex properties
      function readComponents(array) {
          var ret = array.map(function(attr) {
              var result = coerce(attr);
  
              if(result && Lib.isArrayOrTypedArray(result)) return result;
              return null;
          });
  
          return ret.every(function(x) {
              return x && x.length === ret[0].length;
          }) && ret;
      }
  
      var coords = readComponents(['x', 'y', 'z']);
      if(!coords) {
          traceOut.visible = false;
          return;
      }
  
      readComponents(['i', 'j', 'k']);
      // three indices should be all provided or not
      if(
          (traceOut.i && (!traceOut.j || !traceOut.k)) ||
          (traceOut.j && (!traceOut.k || !traceOut.i)) ||
          (traceOut.k && (!traceOut.i || !traceOut.j))
      ) {
          traceOut.visible = false;
          return;
      }
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
  
      // Coerce remaining properties
      [
          'lighting.ambient',
          'lighting.diffuse',
          'lighting.specular',
          'lighting.roughness',
          'lighting.fresnel',
          'lighting.vertexnormalsepsilon',
          'lighting.facenormalsepsilon',
          'lightposition.x',
          'lightposition.y',
          'lightposition.z',
          'flatshading',
          'alphahull',
          'delaunayaxis',
          'opacity'
      ].forEach(function(x) { coerce(x); });
  
      var showContour = coerce('contour.show');
      if(showContour) {
          coerce('contour.color');
          coerce('contour.width');
      }
  
      if('intensity' in traceIn) {
          coerce('intensity');
          coerce('intensitymode');
          colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'});
      } else {
          traceOut.showscale = false;
  
          if('facecolor' in traceIn) coerce('facecolor');
          else if('vertexcolor' in traceIn) coerce('vertexcolor');
          else coerce('color', defaultColor);
      }
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      // disable 1D transforms
      // x/y/z should match lengths, and i/j/k should match as well, but
      // the two sets have different lengths so transforms wouldn't work.
      traceOut._length = null;
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"../../registry":882,"./attributes":1099}],1103:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc'),
      colorbar: {
          min: 'cmin',
          max: 'cmax'
      },
      plot: _dereq_('./convert'),
  
      moduleType: 'trace',
      name: 'mesh3d',
      basePlotModule: _dereq_('../../plots/gl3d'),
      categories: ['gl3d', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"../../plots/gl3d":841,"./attributes":1099,"./calc":1100,"./convert":1101,"./defaults":1102}],1104:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var extendFlat = _dereq_('../../lib').extendFlat;
  var scatterAttrs = _dereq_('../scatter/attributes');
  var dash = _dereq_('../../components/drawing/attributes').dash;
  var fxAttrs = _dereq_('../../components/fx/attributes');
  var delta = _dereq_('../../constants/delta.js');
  
  var INCREASING_COLOR = delta.INCREASING.COLOR;
  var DECREASING_COLOR = delta.DECREASING.COLOR;
  
  var lineAttrs = scatterAttrs.line;
  
  function directionAttrs(lineColorDefault) {
      return {
          line: {
              color: extendFlat({}, lineAttrs.color, {dflt: lineColorDefault}),
              width: lineAttrs.width,
              dash: dash,
              editType: 'style'
          },
          editType: 'style'
      };
  }
  
  module.exports = {
  
      xperiod: scatterAttrs.xperiod,
      xperiod0: scatterAttrs.xperiod0,
      xperiodalignment: scatterAttrs.xperiodalignment,
  
      x: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
  
      open: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      high: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      low: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      close: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      line: {
          width: extendFlat({}, lineAttrs.width, {
              
          }),
          dash: extendFlat({}, dash, {
              
          }),
          editType: 'style'
      },
  
      increasing: directionAttrs(INCREASING_COLOR),
  
      decreasing: directionAttrs(DECREASING_COLOR),
  
      text: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          editType: 'calc',
          
      },
      hovertext: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          editType: 'calc',
          
      },
  
      tickwidth: {
          valType: 'number',
          min: 0,
          max: 0.5,
          dflt: 0.3,
          
          editType: 'calc',
          
      },
  
      hoverlabel: extendFlat({}, fxAttrs.hoverlabel, {
          split: {
              valType: 'boolean',
              
              dflt: false,
              editType: 'style',
              
          }
      }),
  };
  
  },{"../../components/drawing/attributes":636,"../../components/fx/attributes":646,"../../constants/delta.js":719,"../../lib":750,"../scatter/attributes":1158}],1105:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var _ = Lib._;
  var Axes = _dereq_('../../plots/cartesian/axes');
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  function calc(gd, trace) {
      var xa = Axes.getFromId(gd, trace.xaxis);
      var ya = Axes.getFromId(gd, trace.yaxis);
  
      var tickLen = convertTickWidth(gd, xa, trace);
      var minDiff = trace._minDiff;
      trace._minDiff = null;
      var origX = trace._origX;
      trace._origX = null;
      var x = trace._xcalc;
      trace._xcalc = null;
  
      var cd = calcCommon(gd, trace, origX, x, ya, ptFunc);
  
      trace._extremes[xa._id] = Axes.findExtremes(xa, x, {vpad: minDiff / 2});
      if(cd.length) {
          Lib.extendFlat(cd[0].t, {
              wHover: minDiff / 2,
              tickLen: tickLen
          });
          return cd;
      } else {
          return [{t: {empty: true}}];
      }
  }
  
  function ptFunc(o, h, l, c) {
      return {
          o: o,
          h: h,
          l: l,
          c: c
      };
  }
  
  
  // shared between OHLC and candlestick
  // ptFunc makes a calcdata point specific to each trace type, from oi, hi, li, ci
  function calcCommon(gd, trace, origX, x, ya, ptFunc) {
      var o = ya.makeCalcdata(trace, 'open');
      var h = ya.makeCalcdata(trace, 'high');
      var l = ya.makeCalcdata(trace, 'low');
      var c = ya.makeCalcdata(trace, 'close');
  
      var hasTextArray = Array.isArray(trace.text);
      var hasHovertextArray = Array.isArray(trace.hovertext);
  
      // we're optimists - before we have any changing data, assume increasing
      var increasing = true;
      var cPrev = null;
  
      var hasPeriod = !!trace.xperiodalignment;
  
      var cd = [];
      for(var i = 0; i < x.length; i++) {
          var xi = x[i];
          var oi = o[i];
          var hi = h[i];
          var li = l[i];
          var ci = c[i];
  
          if(xi !== BADNUM && oi !== BADNUM && hi !== BADNUM && li !== BADNUM && ci !== BADNUM) {
              if(ci === oi) {
                  // if open == close, look for a change from the previous close
                  if(cPrev !== null && ci !== cPrev) increasing = ci > cPrev;
                  // else (c === cPrev or cPrev is null) no change
              } else increasing = ci > oi;
  
              cPrev = ci;
  
              var pt = ptFunc(oi, hi, li, ci);
  
              pt.pos = xi;
              pt.yc = (oi + ci) / 2;
              pt.i = i;
              pt.dir = increasing ? 'increasing' : 'decreasing';
  
              // For categoryorder, store low and high
              pt.x = pt.pos;
              pt.y = [li, hi];
  
              if(hasPeriod) pt.orig_p = origX[i]; // used by hover
              if(hasTextArray) pt.tx = trace.text[i];
              if(hasHovertextArray) pt.htx = trace.hovertext[i];
  
              cd.push(pt);
          } else {
              cd.push({pos: xi, empty: true});
          }
      }
  
      trace._extremes[ya._id] = Axes.findExtremes(ya, Lib.concat(l, h), {padded: true});
  
      if(cd.length) {
          cd[0].t = {
              labels: {
                  open: _(gd, 'open:') + ' ',
                  high: _(gd, 'high:') + ' ',
                  low: _(gd, 'low:') + ' ',
                  close: _(gd, 'close:') + ' '
              }
          };
      }
  
      return cd;
  }
  
  /*
   * find min x-coordinates difference of all traces
   * attached to this x-axis and stash the result in _minDiff
   * in all traces; when a trace uses this in its
   * calc step it deletes _minDiff, so that next calc this is
   * done again in case the data changed.
   * also since we need it here, stash _xcalc (and _origX) on the trace
   */
  function convertTickWidth(gd, xa, trace) {
      var minDiff = trace._minDiff;
  
      if(!minDiff) {
          var fullData = gd._fullData;
          var ohlcTracesOnThisXaxis = [];
  
          minDiff = Infinity;
  
          var i;
  
          for(i = 0; i < fullData.length; i++) {
              var tracei = fullData[i];
  
              if(tracei.type === 'ohlc' &&
                  tracei.visible === true &&
                  tracei.xaxis === xa._id
              ) {
                  ohlcTracesOnThisXaxis.push(tracei);
  
                  var origX = xa.makeCalcdata(tracei, 'x');
                  tracei._origX = origX;
  
                  var xcalc = alignPeriod(trace, xa, 'x', origX);
                  tracei._xcalc = xcalc;
  
                  var _minDiff = Lib.distinctVals(xcalc).minDiff;
                  if(_minDiff && isFinite(_minDiff)) {
                      minDiff = Math.min(minDiff, _minDiff);
                  }
              }
          }
  
          // if minDiff is still Infinity here, set it to 1
          if(minDiff === Infinity) minDiff = 1;
  
          for(i = 0; i < ohlcTracesOnThisXaxis.length; i++) {
              ohlcTracesOnThisXaxis[i]._minDiff = minDiff;
          }
      }
  
      return minDiff * trace.tickwidth;
  }
  
  module.exports = {
      calc: calc,
      calcCommon: calcCommon
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/align_period":796,"../../plots/cartesian/axes":799}],1106:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var handleOHLC = _dereq_('./ohlc_defaults');
  var handlePeriodDefaults = _dereq_('../scatter/period_defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleOHLC(traceIn, traceOut, coerce, layout);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce, {x: true});
  
      coerce('line.width');
      coerce('line.dash');
  
      handleDirection(traceIn, traceOut, coerce, 'increasing');
      handleDirection(traceIn, traceOut, coerce, 'decreasing');
  
      coerce('text');
      coerce('hovertext');
      coerce('tickwidth');
  
      layout._requestRangeslider[traceOut.xaxis] = true;
  };
  
  function handleDirection(traceIn, traceOut, coerce, direction) {
      coerce(direction + '.line.color');
      coerce(direction + '.line.width', traceOut.line.width);
      coerce(direction + '.line.dash', traceOut.line.dash);
  }
  
  },{"../../lib":750,"../scatter/period_defaults":1178,"./attributes":1104,"./ohlc_defaults":1109}],1107:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Lib = _dereq_('../../lib');
  var Fx = _dereq_('../../components/fx');
  var Color = _dereq_('../../components/color');
  var fillText = _dereq_('../../lib').fillText;
  var delta = _dereq_('../../constants/delta.js');
  
  var DIRSYMBOL = {
      increasing: delta.INCREASING.SYMBOL,
      decreasing: delta.DECREASING.SYMBOL
  };
  
  function hoverPoints(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
  
      if(trace.hoverlabel.split) {
          return hoverSplit(pointData, xval, yval, hovermode);
      }
  
      return hoverOnPoints(pointData, xval, yval, hovermode);
  }
  
  function getClosestPoint(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var xa = pointData.xa;
      var trace = cd[0].trace;
      var t = cd[0].t;
  
      var type = trace.type;
      var minAttr = type === 'ohlc' ? 'l' : 'min';
      var maxAttr = type === 'ohlc' ? 'h' : 'max';
  
      var hoverPseudoDistance, spikePseudoDistance;
  
      // potentially shift xval for grouped candlesticks
      var centerShift = t.bPos || 0;
      var shiftPos = function(di) { return di.pos + centerShift - xval; };
  
      // ohlc and candlestick call displayHalfWidth different things...
      var displayHalfWidth = t.bdPos || t.tickLen;
      var hoverHalfWidth = t.wHover;
  
      // if two figures are overlaying, let the narrowest one win
      var pseudoDistance = Math.min(1, displayHalfWidth / Math.abs(xa.r2c(xa.range[1]) - xa.r2c(xa.range[0])));
      hoverPseudoDistance = pointData.maxHoverDistance - pseudoDistance;
      spikePseudoDistance = pointData.maxSpikeDistance - pseudoDistance;
  
      function dx(di) {
          var pos = shiftPos(di);
          return Fx.inbox(pos - hoverHalfWidth, pos + hoverHalfWidth, hoverPseudoDistance);
      }
  
      function dy(di) {
          var min = di[minAttr];
          var max = di[maxAttr];
          return min === max || Fx.inbox(min - yval, max - yval, hoverPseudoDistance);
      }
  
      function dxy(di) { return (dx(di) + dy(di)) / 2; }
  
      var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
      Fx.getClosest(cd, distfn, pointData);
  
      if(pointData.index === false) return null;
  
      var di = cd[pointData.index];
  
      if(di.empty) return null;
  
      var dir = di.dir;
      var container = trace[dir];
      var lc = container.line.color;
  
      if(Color.opacity(lc) && container.line.width) pointData.color = lc;
      else pointData.color = container.fillcolor;
  
      pointData.x0 = xa.c2p(di.pos + centerShift - displayHalfWidth, true);
      pointData.x1 = xa.c2p(di.pos + centerShift + displayHalfWidth, true);
  
      pointData.xLabelVal = di.orig_p !== undefined ? di.orig_p : di.pos;
  
      pointData.spikeDistance = dxy(di) * spikePseudoDistance / hoverPseudoDistance;
      pointData.xSpike = xa.c2p(di.pos, true);
  
      return pointData;
  }
  
  function hoverSplit(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var ya = pointData.ya;
      var trace = cd[0].trace;
      var t = cd[0].t;
      var closeBoxData = [];
  
      var closestPoint = getClosestPoint(pointData, xval, yval, hovermode);
      // skip the rest (for this trace) if we didn't find a close point
      if(!closestPoint) return [];
  
      var cdIndex = closestPoint.index;
      var di = cd[cdIndex];
      var hoverinfo = di.hi || trace.hoverinfo;
      var hoverParts = hoverinfo.split('+');
      var isAll = hoverinfo === 'all';
      var hasY = isAll || hoverParts.indexOf('y') !== -1;
  
      // similar to hoverOnPoints, we return nothing
      // if all or y is not present.
      if(!hasY) return [];
  
      var attrs = ['high', 'open', 'close', 'low'];
  
      // several attributes can have the same y-coordinate. We will
      // bunch them together in a single text block. For this, we keep
      // a dictionary mapping y-coord -> point data.
      var usedVals = {};
  
      for(var i = 0; i < attrs.length; i++) {
          var attr = attrs[i];
  
          var val = trace[attr][closestPoint.index];
          var valPx = ya.c2p(val, true);
          var pointData2;
          if(val in usedVals) {
              pointData2 = usedVals[val];
              pointData2.yLabel += '<br>' + t.labels[attr] + Axes.hoverLabelText(ya, val);
          } else {
              // copy out to a new object for each new y-value to label
              pointData2 = Lib.extendFlat({}, closestPoint);
  
              pointData2.y0 = pointData2.y1 = valPx;
              pointData2.yLabelVal = val;
              pointData2.yLabel = t.labels[attr] + Axes.hoverLabelText(ya, val);
  
              pointData2.name = '';
  
              closeBoxData.push(pointData2);
              usedVals[val] = pointData2;
          }
      }
  
      return closeBoxData;
  }
  
  function hoverOnPoints(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var ya = pointData.ya;
      var trace = cd[0].trace;
      var t = cd[0].t;
  
      var closestPoint = getClosestPoint(pointData, xval, yval, hovermode);
      // skip the rest (for this trace) if we didn't find a close point
      if(!closestPoint) return [];
  
      // we don't make a calcdata point if we're missing any piece (x/o/h/l/c)
      // so we need to fix the index here to point to the data arrays
      var cdIndex = closestPoint.index;
      var di = cd[cdIndex];
      var i = closestPoint.index = di.i;
      var dir = di.dir;
  
      function getLabelLine(attr) {
          return t.labels[attr] + Axes.hoverLabelText(ya, trace[attr][i]);
      }
  
      var hoverinfo = di.hi || trace.hoverinfo;
      var hoverParts = hoverinfo.split('+');
      var isAll = hoverinfo === 'all';
      var hasY = isAll || hoverParts.indexOf('y') !== -1;
      var hasText = isAll || hoverParts.indexOf('text') !== -1;
  
      var textParts = hasY ? [
          getLabelLine('open'),
          getLabelLine('high'),
          getLabelLine('low'),
          getLabelLine('close') + '  ' + DIRSYMBOL[dir]
      ] : [];
      if(hasText) fillText(di, trace, textParts);
  
      // don't make .yLabelVal or .text, since we're managing hoverinfo
      // put it all in .extraText
      closestPoint.extraText = textParts.join('<br>');
  
      // this puts the label *and the spike* at the midpoint of the box, ie
      // halfway between open and close, not between high and low.
      closestPoint.y0 = closestPoint.y1 = ya.c2p(di.yc, true);
  
      return [closestPoint];
  }
  
  module.exports = {
      hoverPoints: hoverPoints,
      hoverSplit: hoverSplit,
      hoverOnPoints: hoverOnPoints
  };
  
  },{"../../components/color":615,"../../components/fx":655,"../../constants/delta.js":719,"../../lib":750,"../../plots/cartesian/axes":799}],1108:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'ohlc',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', 'showLegend'],
      meta: {
          
      },
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc').calc,
      plot: _dereq_('./plot'),
      style: _dereq_('./style'),
      hoverPoints: _dereq_('./hover').hoverPoints,
      selectPoints: _dereq_('./select')
  };
  
  },{"../../plots/cartesian":812,"./attributes":1104,"./calc":1105,"./defaults":1106,"./hover":1107,"./plot":1110,"./select":1111,"./style":1112}],1109:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  
  module.exports = function handleOHLC(traceIn, traceOut, coerce, layout) {
      var x = coerce('x');
      var open = coerce('open');
      var high = coerce('high');
      var low = coerce('low');
      var close = coerce('close');
  
      coerce('hoverlabel.split');
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, ['x'], layout);
  
      if(!(open && high && low && close)) return;
  
      var len = Math.min(open.length, high.length, low.length, close.length);
      if(x) len = Math.min(len, Lib.minRowLength(x));
      traceOut._length = len;
  
      return len;
  };
  
  },{"../../lib":750,"../../registry":882}],1110:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Lib = _dereq_('../../lib');
  
  module.exports = function plot(gd, plotinfo, cdOHLC, ohlcLayer) {
      var ya = plotinfo.yaxis;
      var xa = plotinfo.xaxis;
      var posHasRangeBreaks = !!xa.rangebreaks;
  
      Lib.makeTraceGroups(ohlcLayer, cdOHLC, 'trace ohlc').each(function(cd) {
          var plotGroup = d3.select(this);
          var cd0 = cd[0];
          var t = cd0.t;
          var trace = cd0.trace;
  
          if(trace.visible !== true || t.empty) {
              plotGroup.remove();
              return;
          }
  
          var tickLen = t.tickLen;
  
          var paths = plotGroup.selectAll('path').data(Lib.identity);
  
          paths.enter().append('path');
  
          paths.exit().remove();
  
          paths.attr('d', function(d) {
              if(d.empty) return 'M0,0Z';
  
              var xo = xa.c2p(d.pos - tickLen, true);
              var xc = xa.c2p(d.pos + tickLen, true);
              var x = posHasRangeBreaks ? (xo + xc) / 2 : xa.c2p(d.pos, true);
  
              var yo = ya.c2p(d.o, true);
              var yh = ya.c2p(d.h, true);
              var yl = ya.c2p(d.l, true);
              var yc = ya.c2p(d.c, true);
  
              return 'M' + xo + ',' + yo + 'H' + x +
                  'M' + x + ',' + yh + 'V' + yl +
                  'M' + xc + ',' + yc + 'H' + x;
          });
      });
  };
  
  },{"../../lib":750,"d3":169}],1111:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function selectPoints(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var xa = searchInfo.xaxis;
      var ya = searchInfo.yaxis;
      var selection = [];
      var i;
      // for (potentially grouped) candlesticks
      var posOffset = cd[0].t.bPos || 0;
  
      if(selectionTester === false) {
          // clear selection
          for(i = 0; i < cd.length; i++) {
              cd[i].selected = 0;
          }
      } else {
          for(i = 0; i < cd.length; i++) {
              var di = cd[i];
  
              if(selectionTester.contains([xa.c2p(di.pos + posOffset), ya.c2p(di.yc)], null, di.i, searchInfo)) {
                  selection.push({
                      pointNumber: di.i,
                      x: xa.c2d(di.pos),
                      y: ya.c2d(di.yc)
                  });
                  di.selected = 1;
              } else {
                  di.selected = 0;
              }
          }
      }
  
      return selection;
  };
  
  },{}],1112:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Drawing = _dereq_('../../components/drawing');
  var Color = _dereq_('../../components/color');
  
  module.exports = function style(gd, cd, sel) {
      var s = sel ? sel : d3.select(gd).selectAll('g.ohlclayer').selectAll('g.trace');
  
      s.style('opacity', function(d) {
          return d[0].trace.opacity;
      });
  
      s.each(function(d) {
          var trace = d[0].trace;
  
          d3.select(this).selectAll('path').each(function(di) {
              if(di.empty) return;
  
              var dirLine = trace[di.dir].line;
              d3.select(this)
                  .style('fill', 'none')
                  .call(Color.stroke, dirLine.color)
                  .call(Drawing.dashLine, dirLine.dash, dirLine.width)
                  // TODO: custom selection style for OHLC
                  .style('opacity', trace.selectedpoints && !di.selected ? 0.3 : 1);
          });
      });
  };
  
  },{"../../components/color":615,"../../components/drawing":637,"d3":169}],1113:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var baseAttrs = _dereq_('../../plots/attributes');
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  
  var line = extendFlat(
      {editType: 'calc'},
      colorScaleAttrs('line', {editTypeOverride: 'calc'}),
      {
          shape: {
              valType: 'enumerated',
              values: ['linear', 'hspline'],
              dflt: 'linear',
              
              editType: 'plot',
              
          },
  
          hovertemplate: hovertemplateAttrs({
              editType: 'plot',
              arrayOk: false
          }, {
              keys: ['count', 'probability'],
              
          })
      }
  );
  
  module.exports = {
      domain: domainAttrs({name: 'parcats', trace: true, editType: 'calc'}),
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['count', 'probability'],
          editType: 'plot',
          arrayOk: false
      }),
      hoveron: {
          valType: 'enumerated',
          values: ['category', 'color', 'dimension'],
          dflt: 'category',
          
          editType: 'plot',
          
      },
      hovertemplate: hovertemplateAttrs({
          editType: 'plot',
          arrayOk: false
      }, {
          keys: [
              'count', 'probability', 'category',
              'categorycount', 'colorcount', 'bandcolorcount'
          ],
          
      }),
  
      arrangement: {
          valType: 'enumerated',
          values: ['perpendicular', 'freeform', 'fixed'],
          dflt: 'perpendicular',
          
          editType: 'plot',
          
      },
      bundlecolors: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'plot',
          
      },
      sortpaths: {
          valType: 'enumerated',
          values: ['forward', 'backward'],
          dflt: 'forward',
          
          editType: 'plot',
          
      },
      labelfont: fontAttrs({
          editType: 'calc',
          
      }),
  
      tickfont: fontAttrs({
          editType: 'calc',
          
      }),
  
      dimensions: {
          _isLinkedToArray: 'dimension',
          label: {
              valType: 'string',
              
              editType: 'calc',
              
          },
          categoryorder: {
              valType: 'enumerated',
              values: [
                  'trace', 'category ascending', 'category descending', 'array'
              ],
              dflt: 'trace',
              
              editType: 'calc',
              
          },
          categoryarray: {
              valType: 'data_array',
              
              editType: 'calc',
              
          },
          ticktext: {
              valType: 'data_array',
              
              editType: 'calc',
              
          },
          values: {
              valType: 'data_array',
              
              dflt: [],
              editType: 'calc',
              
          },
          displayindex: {
              valType: 'integer',
              
              editType: 'calc',
              
          },
          editType: 'calc',
          
          visible: {
              valType: 'boolean',
              dflt: true,
              
              editType: 'calc',
              
          }
      },
  
      line: line,
      counts: {
          valType: 'number',
          min: 0,
          dflt: 1,
          arrayOk: true,
          
          editType: 'calc',
          
      },
  
      // Hide unsupported top-level properties from plot-schema
      customdata: undefined,
      hoverlabel: undefined,
      ids: undefined,
      legendgroup: undefined,
      opacity: undefined,
      selectedpoints: undefined,
      showlegend: undefined
  };
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/domain":826,"../../plots/font_attributes":827,"../../plots/template_attributes":877}],1114:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
  var parcatsPlot = _dereq_('./plot');
  
  var PARCATS = 'parcats';
  exports.name = PARCATS;
  
  exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
      var cdModuleAndOthers = getModuleCalcData(gd.calcdata, PARCATS);
  
      if(cdModuleAndOthers.length) {
          var calcData = cdModuleAndOthers[0];
          parcatsPlot(gd, calcData, transitionOpts, makeOnCompleteCallback);
      }
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var hadTable = (oldFullLayout._has && oldFullLayout._has('parcats'));
      var hasTable = (newFullLayout._has && newFullLayout._has('parcats'));
  
      if(hadTable && !hasTable) {
          oldFullLayout._paperdiv.selectAll('.parcats').remove();
      }
  };
  
  },{"../../plots/get_data":836,"./plot":1119}],1115:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  // Requirements
  // ============
  var wrap = _dereq_('../../lib/gup').wrap;
  var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  var filterUnique = _dereq_('../../lib/filter_unique.js');
  var Drawing = _dereq_('../../components/drawing');
  var Lib = _dereq_('../../lib');
  var isNumeric = _dereq_('fast-isnumeric');
  
  /**
   * Create a wrapped ParcatsModel object from trace
   *
   * Note: trace defaults have already been applied
   * @param {Object} gd
   * @param {Object} trace
   * @return {Array.<ParcatsModel>}
   */
  module.exports = function calc(gd, trace) {
      var visibleDims = Lib.filterVisible(trace.dimensions);
  
      if(visibleDims.length === 0) return [];
  
      var uniqueInfoDims = visibleDims.map(function(dim) {
          var categoryValues;
          if(dim.categoryorder === 'trace') {
              // Use order of first occurrence in trace
              categoryValues = null;
          } else if(dim.categoryorder === 'array') {
              // Use categories specified in `categoryarray` first,
              // then add extra to the end in trace order
              categoryValues = dim.categoryarray;
          } else {
              // Get all categories up front
              categoryValues = filterUnique(dim.values);
  
              // order them
              var allNumeric = true;
              for(var i = 0; i < categoryValues.length; i++) {
                  if(!isNumeric(categoryValues[i])) {
                      allNumeric = false;
                      break;
                  }
              }
              categoryValues.sort(allNumeric ? Lib.sorterAsc : undefined);
  
              if(dim.categoryorder === 'category descending') {
                  categoryValues = categoryValues.reverse();
              }
          }
          return getUniqueInfo(dim.values, categoryValues);
      });
  
      var counts,
          count,
          totalCount;
      if(Lib.isArrayOrTypedArray(trace.counts)) {
          counts = trace.counts;
      } else {
          counts = [trace.counts];
      }
  
      validateDimensionDisplayInds(visibleDims);
  
      visibleDims.forEach(function(dim, dimInd) {
          validateCategoryProperties(dim, uniqueInfoDims[dimInd]);
      });
  
      // Handle path colors
      // ------------------
      var line = trace.line;
      var markerColorscale;
  
      // Process colorscale
      if(line) {
          if(hasColorscale(trace, 'line')) {
              colorscaleCalc(gd, trace, {
                  vals: trace.line.color,
                  containerStr: 'line',
                  cLetter: 'c'
              });
          }
          markerColorscale = Drawing.tryColorscale(line);
      } else {
          markerColorscale = Lib.identity;
      }
  
      // Build color generation function
      function getMarkerColorInfo(index) {
          var value, rawColor;
          if(Lib.isArrayOrTypedArray(line.color)) {
              value = line.color[index % line.color.length];
              rawColor = value;
          } else {
              value = line.color;
          }
  
          return {color: markerColorscale(value), rawColor: rawColor};
      }
  
      // Number of values and counts
      // ---------------------------
      var numValues = visibleDims[0].values.length;
  
      // Build path info
      // ---------------
      // Mapping from category inds to PathModel objects
      var pathModels = {};
  
      // Category inds array for each dimension
      var categoryIndsDims = uniqueInfoDims.map(function(di) {return di.inds;});
  
      // Initialize total count
      totalCount = 0;
      var valueInd;
      var d;
  
      for(valueInd = 0; valueInd < numValues; valueInd++) {
          // Category inds for this input value across dimensions
          var categoryIndsPath = [];
          for(d = 0; d < categoryIndsDims.length; d++) {
              categoryIndsPath.push(categoryIndsDims[d][valueInd]);
          }
  
          // Count
          count = counts[valueInd % counts.length];
  
          // Update total count
          totalCount += count;
  
          // Path color
          var pathColorInfo = getMarkerColorInfo(valueInd);
  
          // path key
          var pathKey = categoryIndsPath + '-' + pathColorInfo.rawColor;
  
          // Create / Update PathModel
          if(pathModels[pathKey] === undefined) {
              pathModels[pathKey] = createPathModel(categoryIndsPath,
                  pathColorInfo.color,
                  pathColorInfo.rawColor);
          }
          updatePathModel(pathModels[pathKey], valueInd, count);
      }
  
      var dimensionModels = visibleDims.map(function(di, i) {
          return createDimensionModel(i, di._index, di._displayindex, di.label, totalCount);
      });
  
  
      for(valueInd = 0; valueInd < numValues; valueInd++) {
          count = counts[valueInd % counts.length];
  
          for(d = 0; d < dimensionModels.length; d++) {
              var containerInd = dimensionModels[d].containerInd;
              var catInd = uniqueInfoDims[d].inds[valueInd];
              var cats = dimensionModels[d].categories;
  
              if(cats[catInd] === undefined) {
                  var catValue = trace.dimensions[containerInd]._categoryarray[catInd];
                  var catLabel = trace.dimensions[containerInd]._ticktext[catInd];
                  cats[catInd] = createCategoryModel(d, catInd, catValue, catLabel);
              }
  
              updateCategoryModel(cats[catInd], valueInd, count);
          }
      }
  
      // Compute unique
      return wrap(createParcatsModel(dimensionModels, pathModels, totalCount));
  };
  
  // Models
  // ======
  
  // Parcats Model
  // -------------
  /**
   * @typedef {Object} ParcatsModel
   *  Object containing calculated information about a parcats trace
   *
   * @property {Array.<DimensionModel>} dimensions
   *  Array of dimension models
   * @property {Object.<string,PathModel>} paths
   *  Dictionary from category inds string (e.g. "1,2,1,1") to path model
   * @property {Number} maxCats
   *  The maximum number of categories of any dimension in the diagram
   * @property {Number} count
   *  Total number of input values
   * @property {Object} trace
   */
  
  /**
   * Create and new ParcatsModel object
   * @param {Array.<DimensionModel>} dimensions
   * @param {Object.<string,PathModel>} paths
   * @param {Number} count
   * @return {ParcatsModel}
   */
  function createParcatsModel(dimensions, paths, count) {
      var maxCats = dimensions
          .map(function(d) {return d.categories.length;})
          .reduce(function(v1, v2) {return Math.max(v1, v2);});
      return {dimensions: dimensions, paths: paths, trace: undefined, maxCats: maxCats, count: count};
  }
  
  // Dimension Model
  // ---------------
  /**
   * @typedef {Object} DimensionModel
   *  Object containing calculated information about a single dimension
   *
   * @property {Number} dimensionInd
   *  The index of this dimension among the *visible* dimensions
   * @property {Number} containerInd
   *  The index of this dimension in the original dimensions container,
   *  irrespective of dimension visibility
   * @property {Number} displayInd
   *  The display index of this dimension (where 0 is the left most dimension)
   * @property {String} dimensionLabel
   *  The label of this dimension
   * @property {Number} count
   *  Total number of input values
   * @property {Array.<CategoryModel>} categories
   * @property {Number|null} dragX
   *  The x position of dimension that is currently being dragged. null if not being dragged
   */
  
  /**
   * Create and new DimensionModel object with an empty categories array
   * @param {Number} dimensionInd
   * @param {Number} containerInd
   * @param {Number} displayInd
   * @param {String} dimensionLabel
   * @param {Number} count
   *  Total number of input values
   * @return {DimensionModel}
   */
  function createDimensionModel(dimensionInd, containerInd, displayInd, dimensionLabel, count) {
      return {
          dimensionInd: dimensionInd,
          containerInd: containerInd,
          displayInd: displayInd,
          dimensionLabel: dimensionLabel,
          count: count,
          categories: [],
          dragX: null
      };
  }
  
  // Category Model
  // --------------
  /**
   * @typedef {Object} CategoryModel
   *  Object containing calculated information about a single category.
   *
   * @property {Number} dimensionInd
   *  The index of this categories dimension
   * @property {Number} categoryInd
   *  The index of this category
   * @property {Number} displayInd
   *  The display index of this category (where 0 is the topmost category)
   * @property {String} categoryLabel
   *  The name of this category
   * @property categoryValue: Raw value of the category
   * @property {Array} valueInds
   *  Array of indices (into the original value array) of all samples in this category
   * @property {Number} count
   *  The number of elements from the original array in this path
   * @property {Number|null} dragY
   *  The y position of category that is currently being dragged. null if not being dragged
   */
  
  /**
   * Create and return a new CategoryModel object
   * @param {Number} dimensionInd
   * @param {Number} categoryInd
   *  The display index of this category (where 0 is the topmost category)
   * @param {String} categoryValue
   * @param {String} categoryLabel
   * @return {CategoryModel}
   */
  function createCategoryModel(dimensionInd, categoryInd, categoryValue, categoryLabel) {
      return {
          dimensionInd: dimensionInd,
          categoryInd: categoryInd,
          categoryValue: categoryValue,
          displayInd: categoryInd,
          categoryLabel: categoryLabel,
          valueInds: [],
          count: 0,
          dragY: null
      };
  }
  
  /**
   * Update a CategoryModel object with a new value index
   * Note: The calling parameter is modified in place.
   *
   * @param {CategoryModel} categoryModel
   * @param {Number} valueInd
   * @param {Number} count
   */
  function updateCategoryModel(categoryModel, valueInd, count) {
      categoryModel.valueInds.push(valueInd);
      categoryModel.count += count;
  }
  
  
  // Path Model
  // ----------
  /**
   * @typedef {Object} PathModel
   *  Object containing calculated information about the samples in a path.
   *
   * @property {Array} categoryInds
   *  Array of category indices for each dimension (length `numDimensions`)
   * @param {String} pathColor
   *  Color of this path. (Note: Any colorscaling has already taken place)
   * @property {Array} valueInds
   *  Array of indices (into the original value array) of all samples in this path
   * @property {Number} count
   *  The number of elements from the original array in this path
   * @property {String} color
   *  The path's color (ass CSS color string)
   * @property rawColor
   *  The raw color value specified by the user. May be a CSS color string or a Number
   */
  
  /**
   * Create and return a new PathModel object
   * @param {Array} categoryInds
   * @param color
   * @param rawColor
   * @return {PathModel}
   */
  function createPathModel(categoryInds, color, rawColor) {
      return {
          categoryInds: categoryInds,
          color: color,
          rawColor: rawColor,
          valueInds: [],
          count: 0
      };
  }
  
  /**
   * Update a PathModel object with a new value index
   * Note: The calling parameter is modified in place.
   *
   * @param {PathModel} pathModel
   * @param {Number} valueInd
   * @param {Number} count
   */
  function updatePathModel(pathModel, valueInd, count) {
      pathModel.valueInds.push(valueInd);
      pathModel.count += count;
  }
  
  // Unique calculations
  // ===================
  /**
   * @typedef {Object} UniqueInfo
   *  Object containing information about the unique values of an input array
   *
   * @property {Array} uniqueValues
   *  The unique values in the input array
   * @property {Array} uniqueCounts
   *  The number of times each entry in uniqueValues occurs in input array.
   *  This has the same length as `uniqueValues`
   * @property {Array} inds
   *  Indices into uniqueValues that would reproduce original input array
   */
  
  /**
   * Compute unique value information for an array
   *
   * IMPORTANT: Note that values are considered unique
   * if their string representations are unique.
   *
   * @param {Array} values
   * @param {Array|undefined} uniqueValues
   *  Array of expected unique values. The uniqueValues property of the resulting UniqueInfo object will begin with
   *  these entries. Entries are included even if there are zero occurrences in the values array. Entries found in
   *  the values array that are not present in uniqueValues will be included at the end of the array in the
   *  UniqueInfo object.
   * @return {UniqueInfo}
   */
  function getUniqueInfo(values, uniqueValues) {
      // Initialize uniqueValues if not specified
      if(uniqueValues === undefined || uniqueValues === null) {
          uniqueValues = [];
      } else {
          // Shallow copy so append below doesn't alter input array
          uniqueValues = uniqueValues.map(function(e) {return e;});
      }
  
      // Initialize Variables
      var uniqueValueCounts = {};
      var uniqueValueInds = {};
      var inds = [];
  
      // Initialize uniqueValueCounts and
      uniqueValues.forEach(function(uniqueVal, valInd) {
          uniqueValueCounts[uniqueVal] = 0;
          uniqueValueInds[uniqueVal] = valInd;
      });
  
      // Compute the necessary unique info in a single pass
      for(var i = 0; i < values.length; i++) {
          var item = values[i];
          var itemInd;
  
          if(uniqueValueCounts[item] === undefined) {
              // This item has a previously unseen value
              uniqueValueCounts[item] = 1;
              itemInd = uniqueValues.push(item) - 1;
              uniqueValueInds[item] = itemInd;
          } else {
              // Increment count for this item
              uniqueValueCounts[item]++;
              itemInd = uniqueValueInds[item];
          }
          inds.push(itemInd);
      }
  
      // Build UniqueInfo
      var uniqueCounts = uniqueValues.map(function(v) { return uniqueValueCounts[v]; });
  
      return {
          uniqueValues: uniqueValues,
          uniqueCounts: uniqueCounts,
          inds: inds
      };
  }
  
  
  /**
   * Validate the requested display order for the dimensions.
   * If the display order is a permutation of 0 through dimensions.length - 1, link to _displayindex
   * Otherwise, replace the display order with the dimension order
   * @param {Object} trace
   */
  function validateDimensionDisplayInds(visibleDims) {
      var displayInds = visibleDims.map(function(d) { return d.displayindex; });
      var i;
  
      if(isRangePermutation(displayInds)) {
          for(i = 0; i < visibleDims.length; i++) {
              visibleDims[i]._displayindex = visibleDims[i].displayindex;
          }
      } else {
          for(i = 0; i < visibleDims.length; i++) {
              visibleDims[i]._displayindex = i;
          }
      }
  }
  
  
  /**
   * Update category properties based on the unique values found for this dimension
   * @param {Object} dim
   * @param {UniqueInfo} uniqueInfoDim
   */
  function validateCategoryProperties(dim, uniqueInfoDim) {
      // Update categoryarray
      dim._categoryarray = uniqueInfoDim.uniqueValues;
  
      // Handle ticktext
      if(dim.ticktext === null || dim.ticktext === undefined) {
          dim._ticktext = [];
      } else {
          // Shallow copy to avoid modifying input array
          dim._ticktext = dim.ticktext.slice();
      }
  
      // Extend ticktext with elements from uniqueInfoDim.uniqueValues
      for(var i = dim._ticktext.length; i < uniqueInfoDim.uniqueValues.length; i++) {
          dim._ticktext.push(uniqueInfoDim.uniqueValues[i]);
      }
  }
  
  /**
   * Determine whether an array contains a permutation of the integers from 0 to the array's length - 1
   * @param {Array} inds
   * @return {boolean}
   */
  function isRangePermutation(inds) {
      var indsSpecified = new Array(inds.length);
  
      for(var i = 0; i < inds.length; i++) {
          // Check for out of bounds
          if(inds[i] < 0 || inds[i] >= inds.length) {
              return false;
          }
  
          // Check for collisions with already specified index
          if(indsSpecified[inds[i]] !== undefined) {
              return false;
          }
  
          indsSpecified[inds[i]] = true;
      }
  
      // Nothing out of bounds and no collisions. We have a permutation
      return true;
  }
  
  },{"../../components/colorscale/calc":623,"../../components/colorscale/helpers":626,"../../components/drawing":637,"../../lib":750,"../../lib/filter_unique.js":741,"../../lib/gup":747,"fast-isnumeric":241}],1116:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  
  var attributes = _dereq_('./attributes');
  var mergeLength = _dereq_('../parcoords/merge_length');
  
  function handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
      coerce('line.shape');
      coerce('line.hovertemplate');
  
      var lineColor = coerce('line.color', layout.colorway[0]);
      if(hasColorscale(traceIn, 'line') && Lib.isArrayOrTypedArray(lineColor)) {
          if(lineColor.length) {
              coerce('line.colorscale');
              colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'line.', cLetter: 'c'});
              return lineColor.length;
          } else {
              traceOut.line.color = defaultColor;
          }
      }
      return Infinity;
  }
  
  function dimensionDefaults(dimensionIn, dimensionOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(dimensionIn, dimensionOut, attributes.dimensions, attr, dflt);
      }
  
      var values = coerce('values');
      var visible = coerce('visible');
      if(!(values && values.length)) {
          visible = dimensionOut.visible = false;
      }
  
      if(visible) {
          // Dimension level
          coerce('label');
          coerce('displayindex', dimensionOut._index);
  
          // Category level
          var arrayIn = dimensionIn.categoryarray;
          var isValidArray = (Array.isArray(arrayIn) && arrayIn.length > 0);
  
          var orderDefault;
          if(isValidArray) orderDefault = 'array';
          var order = coerce('categoryorder', orderDefault);
  
          // coerce 'categoryarray' only in array order case
          if(order === 'array') {
              coerce('categoryarray');
              coerce('ticktext');
          } else {
              delete dimensionIn.categoryarray;
              delete dimensionIn.ticktext;
          }
  
          // cannot set 'categoryorder' to 'array' with an invalid 'categoryarray'
          if(!isValidArray && order === 'array') {
              dimensionOut.categoryorder = 'trace';
          }
      }
  }
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
          name: 'dimensions',
          handleItemDefaults: dimensionDefaults
      });
  
      var len = handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
  
      handleDomainDefaults(traceOut, layout, coerce);
  
      if(!Array.isArray(dimensions) || !dimensions.length) {
          traceOut.visible = false;
      }
  
      mergeLength(traceOut, dimensions, 'values', len);
  
      coerce('hoveron');
      coerce('hovertemplate');
      coerce('arrangement');
      coerce('bundlecolors');
      coerce('sortpaths');
      coerce('counts');
  
      var labelfontDflt = {
          family: layout.font.family,
          size: Math.round(layout.font.size),
          color: layout.font.color
      };
  
      Lib.coerceFont(coerce, 'labelfont', labelfontDflt);
  
      var categoryfontDefault = {
          family: layout.font.family,
          size: Math.round(layout.font.size / 1.2),
          color: layout.font.color
      };
  
      Lib.coerceFont(coerce, 'tickfont', categoryfontDefault);
  };
  
  },{"../../components/colorscale/defaults":625,"../../components/colorscale/helpers":626,"../../lib":750,"../../plots/array_container_defaults":794,"../../plots/domain":826,"../parcoords/merge_length":1129,"./attributes":1113}],1117:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      colorbar: {
          container: 'line',
          min: 'cmin',
          max: 'cmax'
      },
  
      moduleType: 'trace',
      name: 'parcats',
      basePlotModule: _dereq_('./base_plot'),
      categories: ['noOpacity'],
      meta: {
          
      }
  };
  
  },{"./attributes":1113,"./base_plot":1114,"./calc":1115,"./defaults":1116,"./plot":1119}],1118:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Plotly = _dereq_('../../plot_api/plot_api');
  var Fx = _dereq_('../../components/fx');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  var tinycolor = _dereq_('tinycolor2');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  
  function performPlot(parcatsModels, graphDiv, layout, svg) {
      var viewModels = parcatsModels.map(createParcatsViewModel.bind(0, graphDiv, layout));
  
      // Get (potentially empty) parcatslayer selection with bound data to single element array
      var layerSelection = svg.selectAll('g.parcatslayer').data([null]);
  
      // Initialize single parcatslayer group if it doesn't exist
      layerSelection.enter()
          .append('g')
          .attr('class', 'parcatslayer')
          .style('pointer-events', 'all');
  
      // Bind data to children of layerSelection and get reference to traceSelection
      var traceSelection = layerSelection
          .selectAll('g.trace.parcats')
          .data(viewModels, key);
  
      // Initialize group for each trace/dimensions
      var traceEnter = traceSelection.enter()
          .append('g')
          .attr('class', 'trace parcats');
  
      // Update properties for each trace
      traceSelection
          .attr('transform', function(d) {
              return 'translate(' + d.x + ', ' + d.y + ')';
          });
  
      // Initialize paths group
      traceEnter
          .append('g')
          .attr('class', 'paths');
  
      // Update paths transform
      var pathsSelection = traceSelection
          .select('g.paths');
  
      // Get paths selection
      var pathSelection = pathsSelection
          .selectAll('path.path')
          .data(function(d) {
              return d.paths;
          }, key);
  
      // Update existing path colors
      pathSelection
          .attr('fill', function(d) {
              return d.model.color;
          });
  
      // Create paths
      var pathSelectionEnter = pathSelection
          .enter()
          .append('path')
          .attr('class', 'path')
          .attr('stroke-opacity', 0)
          .attr('fill', function(d) {
              return d.model.color;
          })
          .attr('fill-opacity', 0);
  
      stylePathsNoHover(pathSelectionEnter);
  
      // Set path geometry
      pathSelection
          .attr('d', function(d) {
              return d.svgD;
          });
  
      // sort paths
      if(!pathSelectionEnter.empty()) {
          // Only sort paths if there has been a change.
          // Otherwise paths are already sorted or a hover operation may be in progress
          pathSelection.sort(compareRawColor);
      }
  
      // Remove any old paths
      pathSelection.exit().remove();
  
      // Path hover
      pathSelection
          .on('mouseover', mouseoverPath)
          .on('mouseout', mouseoutPath)
          .on('click', clickPath);
  
      // Initialize dimensions group
      traceEnter.append('g').attr('class', 'dimensions');
  
      // Update dimensions transform
      var dimensionsSelection = traceSelection
          .select('g.dimensions');
  
      // Get dimension selection
      var dimensionSelection = dimensionsSelection
          .selectAll('g.dimension')
          .data(function(d) {
              return d.dimensions;
          }, key);
  
      // Create dimension groups
      dimensionSelection.enter()
          .append('g')
          .attr('class', 'dimension');
  
      // Update dimension group transforms
      dimensionSelection.attr('transform', function(d) {
          return 'translate(' + d.x + ', 0)';
      });
  
      // Remove any old dimensions
      dimensionSelection.exit().remove();
  
      // Get category selection
      var categorySelection = dimensionSelection
          .selectAll('g.category')
          .data(function(d) {
              return d.categories;
          }, key);
  
      // Initialize category groups
      var categoryGroupEnterSelection = categorySelection
          .enter()
          .append('g')
          .attr('class', 'category');
  
      // Update category transforms
      categorySelection
          .attr('transform', function(d) {
              return 'translate(0, ' + d.y + ')';
          });
  
  
      // Initialize rectangle
      categoryGroupEnterSelection
          .append('rect')
          .attr('class', 'catrect')
          .attr('pointer-events', 'none');
  
  
      // Update rectangle
      categorySelection.select('rect.catrect')
          .attr('fill', 'none')
          .attr('width', function(d) {
              return d.width;
          })
          .attr('height', function(d) {
              return d.height;
          });
  
      styleCategoriesNoHover(categoryGroupEnterSelection);
  
      // Initialize color band rects
      var bandSelection = categorySelection
          .selectAll('rect.bandrect')
          .data(
              /** @param {CategoryViewModel} catViewModel*/
              function(catViewModel) {
                  return catViewModel.bands;
              }, key);
  
      // Raise all update bands to the top so that fading enter/exit bands will be behind
      bandSelection.each(function() {Lib.raiseToTop(this);});
  
      // Update band color
      bandSelection
          .attr('fill', function(d) {
              return d.color;
          });
  
      var bandsSelectionEnter = bandSelection.enter()
          .append('rect')
          .attr('class', 'bandrect')
          .attr('stroke-opacity', 0)
          .attr('fill', function(d) {
              return d.color;
          })
          .attr('fill-opacity', 0);
  
      bandSelection
          .attr('fill', function(d) {
              return d.color;
          })
          .attr('width', function(d) {
              return d.width;
          })
          .attr('height', function(d) {
              return d.height;
          })
          .attr('y', function(d) {
              return d.y;
          })
          .attr('cursor',
              /** @param {CategoryBandViewModel} bandModel*/
              function(bandModel) {
                  if(bandModel.parcatsViewModel.arrangement === 'fixed') {
                      return 'default';
                  } else if(bandModel.parcatsViewModel.arrangement === 'perpendicular') {
                      return 'ns-resize';
                  } else {
                      return 'move';
                  }
              });
  
      styleBandsNoHover(bandsSelectionEnter);
  
      bandSelection.exit().remove();
  
      // Initialize category label
      categoryGroupEnterSelection
          .append('text')
          .attr('class', 'catlabel')
          .attr('pointer-events', 'none');
  
      var paperColor = graphDiv._fullLayout.paper_bgcolor;
  
      // Update category label
      categorySelection.select('text.catlabel')
          .attr('text-anchor',
              function(d) {
                  if(catInRightDim(d)) {
                      // Place label to the right of category
                      return 'start';
                  } else {
                      // Place label to the left of category
                      return 'end';
                  }
              })
          .attr('alignment-baseline', 'middle')
  
          .style('text-shadow',
              paperColor + ' -1px  1px 2px, ' +
              paperColor + ' 1px  1px 2px, ' +
              paperColor + '  1px -1px 2px, ' +
              paperColor + ' -1px -1px 2px')
          .style('fill', 'rgb(0, 0, 0)')
          .attr('x',
              function(d) {
                  if(catInRightDim(d)) {
                      // Place label to the right of category
                      return d.width + 5;
                  } else {
                      // Place label to the left of category
                      return -5;
                  }
              })
          .attr('y', function(d) {
              return d.height / 2;
          })
          .text(function(d) {
              return d.model.categoryLabel;
          })
          .each(
              /** @param {CategoryViewModel} catModel*/
              function(catModel) {
                  Drawing.font(d3.select(this), catModel.parcatsViewModel.categorylabelfont);
                  svgTextUtils.convertToTspans(d3.select(this), graphDiv);
              });
  
      // Initialize dimension label
      categoryGroupEnterSelection
          .append('text')
          .attr('class', 'dimlabel');
  
      // Update dimension label
      categorySelection.select('text.dimlabel')
          .attr('text-anchor', 'middle')
          .attr('alignment-baseline', 'baseline')
          .attr('cursor',
               /** @param {CategoryViewModel} catModel*/
              function(catModel) {
                  if(catModel.parcatsViewModel.arrangement === 'fixed') {
                      return 'default';
                  } else {
                      return 'ew-resize';
                  }
              })
          .attr('x', function(d) {
              return d.width / 2;
          })
          .attr('y', -5)
          .text(function(d, i) {
              if(i === 0) {
                  // Add dimension label above topmost category
                  return d.parcatsViewModel.model.dimensions[d.model.dimensionInd].dimensionLabel;
              } else {
                  return null;
              }
          })
          .each(
              /** @param {CategoryViewModel} catModel*/
              function(catModel) {
                  Drawing.font(d3.select(this), catModel.parcatsViewModel.labelfont);
              });
  
      // Category hover
      // categorySelection.select('rect.catrect')
      categorySelection.selectAll('rect.bandrect')
          .on('mouseover', mouseoverCategoryBand)
          .on('mouseout', mouseoutCategory);
  
      // Remove unused categories
      categorySelection.exit().remove();
  
      // Setup drag
      dimensionSelection.call(d3.behavior.drag()
          .origin(function(d) {
              return {x: d.x, y: 0};
          })
          .on('dragstart', dragDimensionStart)
          .on('drag', dragDimension)
          .on('dragend', dragDimensionEnd));
  
  
      // Save off selections to view models
      traceSelection.each(function(d) {
          d.traceSelection = d3.select(this);
          d.pathSelection = d3.select(this).selectAll('g.paths').selectAll('path.path');
          d.dimensionSelection = d3.select(this).selectAll('g.dimensions').selectAll('g.dimension');
      });
  
      // Remove any orphan traces
      traceSelection.exit().remove();
  }
  
  /**
   * Create / update parcat traces
   *
   * @param {Object} graphDiv
   * @param {Object} svg
   * @param {Array.<ParcatsModel>} parcatsModels
   * @param {Layout} layout
   */
  module.exports = function(graphDiv, svg, parcatsModels, layout) {
      performPlot(parcatsModels, graphDiv, layout, svg);
  };
  
  /**
   * Function the returns the key property of an object for use with as D3 join function
   * @param d
   */
  function key(d) {
      return d.key;
  }
  
   /** True if a category view model is in the right-most display dimension
    * @param {CategoryViewModel} d */
  function catInRightDim(d) {
      var numDims = d.parcatsViewModel.dimensions.length;
      var leftDimInd = d.parcatsViewModel.dimensions[numDims - 1].model.dimensionInd;
      return d.model.dimensionInd === leftDimInd;
  }
  
  /**
   * @param {PathViewModel} a
   * @param {PathViewModel} b
   */
  function compareRawColor(a, b) {
      if(a.model.rawColor > b.model.rawColor) {
          return 1;
      } else if(a.model.rawColor < b.model.rawColor) {
          return -1;
      } else {
          return 0;
      }
  }
  
  /**
   * Handle path mouseover
   * @param {PathViewModel} d
   */
  function mouseoverPath(d) {
      if(!d.parcatsViewModel.dragDimension) {
          // We're not currently dragging
  
          if(d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
              // hoverinfo is not skip, so we at least style the paths and emit interaction events
  
              // Raise path to top
              Lib.raiseToTop(this);
  
              stylePathsHover(d3.select(this));
  
              // Emit hover event
              var points = buildPointsArrayForPath(d);
              var constraints = buildConstraintsForPath(d);
              d.parcatsViewModel.graphDiv.emit('plotly_hover', {
                  points: points, event: d3.event, constraints: constraints
              });
  
              // Handle hover label
              if(d.parcatsViewModel.hoverinfoItems.indexOf('none') === -1) {
                  // hoverinfo is a combination of 'count' and 'probability'
  
                  // Mouse
                  var hoverX = d3.mouse(this)[0];
  
                  // Label
                  var gd = d.parcatsViewModel.graphDiv;
                  var trace = d.parcatsViewModel.trace;
                  var fullLayout = gd._fullLayout;
                  var rootBBox = fullLayout._paperdiv.node().getBoundingClientRect();
                  var graphDivBBox = d.parcatsViewModel.graphDiv.getBoundingClientRect();
  
                  // Find path center in path coordinates
                  var pathCenterX,
                      pathCenterY,
                      dimInd;
  
                  for(dimInd = 0; dimInd < (d.leftXs.length - 1); dimInd++) {
                      if(d.leftXs[dimInd] + d.dimWidths[dimInd] - 2 <= hoverX && hoverX <= d.leftXs[dimInd + 1] + 2) {
                          var leftDim = d.parcatsViewModel.dimensions[dimInd];
                          var rightDim = d.parcatsViewModel.dimensions[dimInd + 1];
                          pathCenterX = (leftDim.x + leftDim.width + rightDim.x) / 2;
                          pathCenterY = (d.topYs[dimInd] + d.topYs[dimInd + 1] + d.height) / 2;
                          break;
                      }
                  }
  
                  // Find path center in root coordinates
                  var hoverCenterX = d.parcatsViewModel.x + pathCenterX;
                  var hoverCenterY = d.parcatsViewModel.y + pathCenterY;
  
                  var textColor = tinycolor.mostReadable(d.model.color, ['black', 'white']);
  
                  var count = d.model.count;
                  var prob = count / d.parcatsViewModel.model.count;
                  var labels = {
                      countLabel: count,
                      probabilityLabel: prob.toFixed(3)
                  };
  
                  // Build hover text
                  var hovertextParts = [];
                  if(d.parcatsViewModel.hoverinfoItems.indexOf('count') !== -1) {
                      hovertextParts.push(['Count:', labels.countLabel].join(' '));
                  }
                  if(d.parcatsViewModel.hoverinfoItems.indexOf('probability') !== -1) {
                      hovertextParts.push(['P:', labels.probabilityLabel].join(' '));
                  }
  
                  var hovertext = hovertextParts.join('<br>');
                  var mouseX = d3.mouse(gd)[0];
  
                  Fx.loneHover({
                      trace: trace,
                      x: hoverCenterX - rootBBox.left + graphDivBBox.left,
                      y: hoverCenterY - rootBBox.top + graphDivBBox.top,
                      text: hovertext,
                      color: d.model.color,
                      borderColor: 'black',
                      fontFamily: 'Monaco, "Courier New", monospace',
                      fontSize: 10,
                      fontColor: textColor,
                      idealAlign: mouseX < hoverCenterX ? 'right' : 'left',
                      hovertemplate: (trace.line || {}).hovertemplate,
                      hovertemplateLabels: labels,
                      eventData: [{
                          data: trace._input,
                          fullData: trace,
                          count: count,
                          probability: prob
                      }]
                  }, {
                      container: fullLayout._hoverlayer.node(),
                      outerContainer: fullLayout._paper.node(),
                      gd: gd
                  });
              }
          }
      }
  }
  
  /**
   * Handle path mouseout
   * @param {PathViewModel} d
   */
  function mouseoutPath(d) {
      if(!d.parcatsViewModel.dragDimension) {
          // We're not currently dragging
          stylePathsNoHover(d3.select(this));
  
          // Remove and hover label
          Fx.loneUnhover(d.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
  
          // Restore path order
          d.parcatsViewModel.pathSelection.sort(compareRawColor);
  
          // Emit unhover event
          if(d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
              var points = buildPointsArrayForPath(d);
              var constraints = buildConstraintsForPath(d);
              d.parcatsViewModel.graphDiv.emit('plotly_unhover', {
                  points: points, event: d3.event, constraints: constraints
              });
          }
      }
  }
  
  /**
   * Build array of point objects for a path
   *
   * For use in click/hover events
   * @param {PathViewModel} d
   */
  function buildPointsArrayForPath(d) {
      var points = [];
      var curveNumber = getTraceIndex(d.parcatsViewModel);
  
      for(var i = 0; i < d.model.valueInds.length; i++) {
          var pointNumber = d.model.valueInds[i];
          points.push({
              curveNumber: curveNumber,
              pointNumber: pointNumber
          });
      }
      return points;
  }
  
  /**
   * Build constraints object for a path
   *
   * For use in click/hover events
   * @param {PathViewModel} d
   */
  function buildConstraintsForPath(d) {
      var constraints = {};
      var dimensions = d.parcatsViewModel.model.dimensions;
  
      // dimensions
      for(var i = 0; i < dimensions.length; i++) {
          var dimension = dimensions[i];
          var category = dimension.categories[d.model.categoryInds[i]];
          constraints[dimension.containerInd] = category.categoryValue;
      }
  
      // color
      if(d.model.rawColor !== undefined) {
          constraints.color = d.model.rawColor;
      }
      return constraints;
  }
  
  /**
   * Handle path click
   * @param {PathViewModel} d
   */
  function clickPath(d) {
      if(d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
          // hoverinfo it's skip, so interaction events aren't disabled
          var points = buildPointsArrayForPath(d);
          var constraints = buildConstraintsForPath(d);
          d.parcatsViewModel.graphDiv.emit('plotly_click', {
              points: points, event: d3.event, constraints: constraints
          });
      }
  }
  
  function stylePathsNoHover(pathSelection) {
      pathSelection
          .attr('fill', function(d) {
              return d.model.color;
          })
          .attr('fill-opacity', 0.6)
          .attr('stroke', 'lightgray')
          .attr('stroke-width', 0.2)
          .attr('stroke-opacity', 1.0);
  }
  
  function stylePathsHover(pathSelection) {
      pathSelection
          .attr('fill-opacity', 0.8)
          .attr('stroke', function(d) {
              return tinycolor.mostReadable(d.model.color, ['black', 'white']);
          })
          .attr('stroke-width', 0.3);
  }
  
  function styleCategoryHover(categorySelection) {
      categorySelection
          .select('rect.catrect')
          .attr('stroke', 'black')
          .attr('stroke-width', 2.5);
  }
  
  function styleCategoriesNoHover(categorySelection) {
      categorySelection
          .select('rect.catrect')
          .attr('stroke', 'black')
          .attr('stroke-width', 1)
          .attr('stroke-opacity', 1);
  }
  
  function styleBandsHover(bandsSelection) {
      bandsSelection
          .attr('stroke', 'black')
          .attr('stroke-width', 1.5);
  }
  
  function styleBandsNoHover(bandsSelection) {
      bandsSelection
          .attr('stroke', 'black')
          .attr('stroke-width', 0.2)
          .attr('stroke-opacity', 1.0)
          .attr('fill-opacity', 1.0);
  }
  
  /**
   * Return selection of all paths that pass through the specified category
   * @param {CategoryBandViewModel} catBandViewModel
   */
  function selectPathsThroughCategoryBandColor(catBandViewModel) {
      var allPaths = catBandViewModel.parcatsViewModel.pathSelection;
      var dimInd = catBandViewModel.categoryViewModel.model.dimensionInd;
      var catInd = catBandViewModel.categoryViewModel.model.categoryInd;
  
      return allPaths
          .filter(
              /** @param {PathViewModel} pathViewModel */
              function(pathViewModel) {
                  return pathViewModel.model.categoryInds[dimInd] === catInd &&
                      pathViewModel.model.color === catBandViewModel.color;
              });
  }
  
  
  /**
   * Perform hover styling for all paths that pass though the specified band element's category
   *
   * @param {HTMLElement} bandElement
   *  HTML element for band
   *
   */
  function styleForCategoryHovermode(bandElement) {
      // Get all bands in the current category
      var bandSel = d3.select(bandElement.parentNode).selectAll('rect.bandrect');
  
      // Raise and style paths
      bandSel.each(function(bvm) {
          var paths = selectPathsThroughCategoryBandColor(bvm);
          stylePathsHover(paths);
          paths.each(function() {
              // Raise path to top
              Lib.raiseToTop(this);
          });
      });
  
      // Style category
      styleCategoryHover(d3.select(bandElement.parentNode));
  }
  
  /**
   * Perform hover styling for all paths that pass though the category of the specified band element and share the
   * same color
   *
   * @param {HTMLElement} bandElement
   *  HTML element for band
   *
   */
  function styleForColorHovermode(bandElement) {
      var bandViewModel = d3.select(bandElement).datum();
      var catPaths = selectPathsThroughCategoryBandColor(bandViewModel);
      stylePathsHover(catPaths);
      catPaths.each(function() {
          // Raise path to top
          Lib.raiseToTop(this);
      });
  
      // Style category for drag
      d3.select(bandElement.parentNode)
          .selectAll('rect.bandrect')
          .filter(function(b) {return b.color === bandViewModel.color;})
          .each(function() {
              Lib.raiseToTop(this);
              styleBandsHover(d3.select(this));
          });
  }
  
  
  /**
   * @param {HTMLElement} bandElement
   *  HTML element for band
   * @param eventName
   *  Event name (plotly_hover or plotly_click)
   * @param event
   *  Mouse Event
   */
  function emitPointsEventCategoryHovermode(bandElement, eventName, event) {
      // Get all bands in the current category
      var bandViewModel = d3.select(bandElement).datum();
      var categoryModel = bandViewModel.categoryViewModel.model;
      var gd = bandViewModel.parcatsViewModel.graphDiv;
      var bandSel = d3.select(bandElement.parentNode).selectAll('rect.bandrect');
  
      var points = [];
      bandSel.each(function(bvm) {
          var paths = selectPathsThroughCategoryBandColor(bvm);
          paths.each(function(pathViewModel) {
              // Extend points array
              Array.prototype.push.apply(points, buildPointsArrayForPath(pathViewModel));
          });
      });
  
      var constraints = {};
      constraints[categoryModel.dimensionInd] = categoryModel.categoryValue;
      gd.emit(eventName, {
          points: points, event: event, constraints: constraints
      });
  }
  
  /**
   * @param {HTMLElement} bandElement
   *  HTML element for band
   * @param eventName
   *  Event name (plotly_hover or plotly_click)
   * @param event
   *  Mouse Event
   */
  function emitPointsEventColorHovermode(bandElement, eventName, event) {
      var bandViewModel = d3.select(bandElement).datum();
      var categoryModel = bandViewModel.categoryViewModel.model;
      var gd = bandViewModel.parcatsViewModel.graphDiv;
      var paths = selectPathsThroughCategoryBandColor(bandViewModel);
  
      var points = [];
      paths.each(function(pathViewModel) {
          // Extend points array
          Array.prototype.push.apply(points, buildPointsArrayForPath(pathViewModel));
      });
  
      var constraints = {};
      constraints[categoryModel.dimensionInd] = categoryModel.categoryValue;
      // color
      if(bandViewModel.rawColor !== undefined) {
          constraints.color = bandViewModel.rawColor;
      }
      gd.emit(eventName, {
          points: points, event: event, constraints: constraints
      });
  }
  
  /**
   * Create hover label for a band element's category (for use when hoveron === 'category')
   *
   * @param {ClientRect} rootBBox
   *  Client bounding box for root of figure
   * @param {HTMLElement} bandElement
   *  HTML element for band
   *
   */
  function createHoverLabelForCategoryHovermode(rootBBox, bandElement) {
      // Selections
      var rectSelection = d3.select(bandElement.parentNode).select('rect.catrect');
      var rectBoundingBox = rectSelection.node().getBoundingClientRect();
  
      // Models
      /** @type {CategoryViewModel} */
      var catViewModel = rectSelection.datum();
      var parcatsViewModel = catViewModel.parcatsViewModel;
      var dimensionModel = parcatsViewModel.model.dimensions[catViewModel.model.dimensionInd];
      var trace = parcatsViewModel.trace;
  
      // Positions
      var hoverCenterY = rectBoundingBox.top + rectBoundingBox.height / 2;
      var hoverCenterX,
          hoverLabelIdealAlign;
  
      if(parcatsViewModel.dimensions.length > 1 &&
          dimensionModel.displayInd === parcatsViewModel.dimensions.length - 1) {
          // right most dimension
          hoverCenterX = rectBoundingBox.left;
          hoverLabelIdealAlign = 'left';
      } else {
          hoverCenterX = rectBoundingBox.left + rectBoundingBox.width;
          hoverLabelIdealAlign = 'right';
      }
  
      var count = catViewModel.model.count;
      var catLabel = catViewModel.model.categoryLabel;
      var prob = count / catViewModel.parcatsViewModel.model.count;
      var labels = {
          countLabel: count,
          categoryLabel: catLabel,
          probabilityLabel: prob.toFixed(3)
      };
  
      // Hover label text
      var hoverinfoParts = [];
      if(catViewModel.parcatsViewModel.hoverinfoItems.indexOf('count') !== -1) {
          hoverinfoParts.push(['Count:', labels.countLabel].join(' '));
      }
      if(catViewModel.parcatsViewModel.hoverinfoItems.indexOf('probability') !== -1) {
          hoverinfoParts.push(['P(' + labels.categoryLabel + '):', labels.probabilityLabel].join(' '));
      }
  
      var hovertext = hoverinfoParts.join('<br>');
      return {
          trace: trace,
          x: hoverCenterX - rootBBox.left,
          y: hoverCenterY - rootBBox.top,
          text: hovertext,
          color: 'lightgray',
          borderColor: 'black',
          fontFamily: 'Monaco, "Courier New", monospace',
          fontSize: 12,
          fontColor: 'black',
          idealAlign: hoverLabelIdealAlign,
          hovertemplate: trace.hovertemplate,
          hovertemplateLabels: labels,
          eventData: [{
              data: trace._input,
              fullData: trace,
              count: count,
              category: catLabel,
              probability: prob
          }]
      };
  }
  
  /**
   * Create hover label for a band element's category (for use when hoveron === 'category')
   *
   * @param {ClientRect} rootBBox
   *  Client bounding box for root of figure
   * @param {HTMLElement} bandElement
   *  HTML element for band
   *
   */
  function createHoverLabelForDimensionHovermode(rootBBox, bandElement) {
      var allHoverlabels = [];
  
      d3.select(bandElement.parentNode.parentNode)
          .selectAll('g.category')
          .select('rect.catrect')
          .each(function() {
              var bandNode = this;
              allHoverlabels.push(createHoverLabelForCategoryHovermode(rootBBox, bandNode));
          });
  
      return allHoverlabels;
  }
  
  /**
   * Create hover labels for a band element's category (for use when hoveron === 'dimension')
   *
   * @param {ClientRect} rootBBox
   *  Client bounding box for root of figure
   * @param {HTMLElement} bandElement
   *  HTML element for band
   *
   */
  function createHoverLabelForColorHovermode(rootBBox, bandElement) {
      var bandBoundingBox = bandElement.getBoundingClientRect();
  
      // Models
      /** @type {CategoryBandViewModel} */
      var bandViewModel = d3.select(bandElement).datum();
      var catViewModel = bandViewModel.categoryViewModel;
      var parcatsViewModel = catViewModel.parcatsViewModel;
      var dimensionModel = parcatsViewModel.model.dimensions[catViewModel.model.dimensionInd];
      var trace = parcatsViewModel.trace;
  
      // positions
      var hoverCenterY = bandBoundingBox.y + bandBoundingBox.height / 2;
  
      var hoverCenterX,
          hoverLabelIdealAlign;
      if(parcatsViewModel.dimensions.length > 1 &&
          dimensionModel.displayInd === parcatsViewModel.dimensions.length - 1) {
          // right most dimension
          hoverCenterX = bandBoundingBox.left;
          hoverLabelIdealAlign = 'left';
      } else {
          hoverCenterX = bandBoundingBox.left + bandBoundingBox.width;
          hoverLabelIdealAlign = 'right';
      }
  
      // Labels
      var catLabel = catViewModel.model.categoryLabel;
  
      // Counts
      var totalCount = bandViewModel.parcatsViewModel.model.count;
  
      var bandColorCount = 0;
      bandViewModel.categoryViewModel.bands.forEach(function(b) {
          if(b.color === bandViewModel.color) {
              bandColorCount += b.count;
          }
      });
  
      var catCount = catViewModel.model.count;
  
      var colorCount = 0;
      parcatsViewModel.pathSelection.each(
          /** @param {PathViewModel} pathViewModel */
          function(pathViewModel) {
              if(pathViewModel.model.color === bandViewModel.color) {
                  colorCount += pathViewModel.model.count;
              }
          });
  
      var pColorAndCat = bandColorCount / totalCount;
      var pCatGivenColor = bandColorCount / colorCount;
      var pColorGivenCat = bandColorCount / catCount;
  
      var labels = {
          countLabel: totalCount,
          categoryLabel: catLabel,
          probabilityLabel: pColorAndCat.toFixed(3)
      };
  
      // Hover label text
      var hoverinfoParts = [];
      if(catViewModel.parcatsViewModel.hoverinfoItems.indexOf('count') !== -1) {
          hoverinfoParts.push(['Count:', labels.countLabel].join(' '));
      }
      if(catViewModel.parcatsViewModel.hoverinfoItems.indexOf('probability') !== -1) {
          hoverinfoParts.push('P(color ∩ ' + catLabel + '): ' + labels.probabilityLabel);
          hoverinfoParts.push('P(' + catLabel + ' | color): ' + pCatGivenColor.toFixed(3));
          hoverinfoParts.push('P(color | ' + catLabel + '): ' + pColorGivenCat.toFixed(3));
      }
  
      var hovertext = hoverinfoParts.join('<br>');
  
      // Compute text color
      var textColor = tinycolor.mostReadable(bandViewModel.color, ['black', 'white']);
  
      return {
          trace: trace,
          x: hoverCenterX - rootBBox.left,
          y: hoverCenterY - rootBBox.top,
          // name: 'NAME',
          text: hovertext,
          color: bandViewModel.color,
          borderColor: 'black',
          fontFamily: 'Monaco, "Courier New", monospace',
          fontColor: textColor,
          fontSize: 10,
          idealAlign: hoverLabelIdealAlign,
          hovertemplate: trace.hovertemplate,
          hovertemplateLabels: labels,
          eventData: [{
              data: trace._input,
              fullData: trace,
              category: catLabel,
              count: totalCount,
              probability: pColorAndCat,
              categorycount: catCount,
              colorcount: colorCount,
              bandcolorcount: bandColorCount
          }]
      };
  }
  
  /**
   * Handle dimension mouseover
   * @param {CategoryBandViewModel} bandViewModel
   */
  function mouseoverCategoryBand(bandViewModel) {
      if(!bandViewModel.parcatsViewModel.dragDimension) {
          // We're not currently dragging
  
          if(bandViewModel.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
              // hoverinfo is not skip, so we at least style the bands and emit interaction events
  
              // Mouse
              var mouseY = d3.mouse(this)[1];
              if(mouseY < -1) {
                  // Hover is above above the category rectangle (probably the dimension title text)
                  return;
              }
  
              var gd = bandViewModel.parcatsViewModel.graphDiv;
              var fullLayout = gd._fullLayout;
              var rootBBox = fullLayout._paperdiv.node().getBoundingClientRect();
              var hoveron = bandViewModel.parcatsViewModel.hoveron;
  
              /** @type {HTMLElement} */
              var bandElement = this;
  
              // Handle style and events
              if(hoveron === 'color') {
                  styleForColorHovermode(bandElement);
                  emitPointsEventColorHovermode(bandElement, 'plotly_hover', d3.event);
              } else {
                  styleForCategoryHovermode(bandElement);
                  emitPointsEventCategoryHovermode(bandElement, 'plotly_hover', d3.event);
              }
  
              // Handle hover label
              if(bandViewModel.parcatsViewModel.hoverinfoItems.indexOf('none') === -1) {
                  var hoverItems;
                  if(hoveron === 'category') {
                      hoverItems = createHoverLabelForCategoryHovermode(rootBBox, bandElement);
                  } else if(hoveron === 'color') {
                      hoverItems = createHoverLabelForColorHovermode(rootBBox, bandElement);
                  } else if(hoveron === 'dimension') {
                      hoverItems = createHoverLabelForDimensionHovermode(rootBBox, bandElement);
                  }
  
                  if(hoverItems) {
                      Fx.loneHover(hoverItems, {
                          container: fullLayout._hoverlayer.node(),
                          outerContainer: fullLayout._paper.node(),
                          gd: gd
                      });
                  }
              }
          }
      }
  }
  
  
  /**
   * Handle dimension mouseover
   * @param {CategoryBandViewModel} bandViewModel
   */
  function mouseoutCategory(bandViewModel) {
      var parcatsViewModel = bandViewModel.parcatsViewModel;
  
      if(!parcatsViewModel.dragDimension) {
          // We're not dragging anything
  
          // Reset unhovered styles
          stylePathsNoHover(parcatsViewModel.pathSelection);
          styleCategoriesNoHover(parcatsViewModel.dimensionSelection.selectAll('g.category'));
          styleBandsNoHover(parcatsViewModel.dimensionSelection.selectAll('g.category').selectAll('rect.bandrect'));
  
          // Remove hover label
          Fx.loneUnhover(parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
  
          // Restore path order
          parcatsViewModel.pathSelection.sort(compareRawColor);
  
          // Emit unhover event
          if(parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
              var hoveron = bandViewModel.parcatsViewModel.hoveron;
              var bandElement = this;
  
              // Handle style and events
              if(hoveron === 'color') {
                  emitPointsEventColorHovermode(bandElement, 'plotly_unhover', d3.event);
              } else {
                  emitPointsEventCategoryHovermode(bandElement, 'plotly_unhover', d3.event);
              }
          }
      }
  }
  
  
  /**
   * Handle dimension drag start
   * @param {DimensionViewModel} d
   */
  function dragDimensionStart(d) {
      // Check if dragging is supported
      if(d.parcatsViewModel.arrangement === 'fixed') {
          return;
      }
  
      // Save off initial drag indexes for dimension
      d.dragDimensionDisplayInd = d.model.displayInd;
      d.initialDragDimensionDisplayInds = d.parcatsViewModel.model.dimensions.map(function(d) {return d.displayInd;});
      d.dragHasMoved = false;
  
      // Check for category hit
      d.dragCategoryDisplayInd = null;
      d3.select(this)
          .selectAll('g.category')
          .select('rect.catrect')
          .each(
              /** @param {CategoryViewModel} catViewModel */
              function(catViewModel) {
                  var catMouseX = d3.mouse(this)[0];
                  var catMouseY = d3.mouse(this)[1];
  
  
                  if(-2 <= catMouseX && catMouseX <= catViewModel.width + 2 &&
                      -2 <= catMouseY && catMouseY <= catViewModel.height + 2) {
                      // Save off initial drag indexes for categories
                      d.dragCategoryDisplayInd = catViewModel.model.displayInd;
                      d.initialDragCategoryDisplayInds = d.model.categories.map(function(c) {
                          return c.displayInd;
                      });
  
                      // Initialize categories dragY to be the current y position
                      catViewModel.model.dragY = catViewModel.y;
  
                      // Raise category
                      Lib.raiseToTop(this.parentNode);
  
                      // Get band element
                      d3.select(this.parentNode)
                          .selectAll('rect.bandrect')
                          /** @param {CategoryBandViewModel} bandViewModel */
                          .each(function(bandViewModel) {
                              if(bandViewModel.y < catMouseY && catMouseY <= bandViewModel.y + bandViewModel.height) {
                                  d.potentialClickBand = this;
                              }
                          });
                  }
              });
  
      // Update toplevel drag dimension
      d.parcatsViewModel.dragDimension = d;
  
      // Remove hover label if any
      Fx.loneUnhover(d.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node());
  }
  
  /**
   * Handle dimension drag
   * @param {DimensionViewModel} d
   */
  function dragDimension(d) {
      // Check if dragging is supported
      if(d.parcatsViewModel.arrangement === 'fixed') {
          return;
      }
  
      d.dragHasMoved = true;
  
      if(d.dragDimensionDisplayInd === null) {
          return;
      }
  
      var dragDimInd = d.dragDimensionDisplayInd;
      var prevDimInd = dragDimInd - 1;
      var nextDimInd = dragDimInd + 1;
  
      var dragDimension = d.parcatsViewModel
          .dimensions[dragDimInd];
  
      // Update category
      if(d.dragCategoryDisplayInd !== null) {
          var dragCategory = dragDimension.categories[d.dragCategoryDisplayInd];
  
          // Update dragY by dy
          dragCategory.model.dragY += d3.event.dy;
          var categoryY = dragCategory.model.dragY;
  
          // Check for category drag swaps
          var catDisplayInd = dragCategory.model.displayInd;
          var dimCategoryViews = dragDimension.categories;
  
          var catAbove = dimCategoryViews[catDisplayInd - 1];
          var catBelow = dimCategoryViews[catDisplayInd + 1];
  
          // Check for overlap above
          if(catAbove !== undefined) {
              if(categoryY < (catAbove.y + catAbove.height / 2.0)) {
                  // Swap display inds
                  dragCategory.model.displayInd = catAbove.model.displayInd;
                  catAbove.model.displayInd = catDisplayInd;
              }
          }
  
          if(catBelow !== undefined) {
              if((categoryY + dragCategory.height) > (catBelow.y + catBelow.height / 2.0)) {
                  // Swap display inds
                  dragCategory.model.displayInd = catBelow.model.displayInd;
                  catBelow.model.displayInd = catDisplayInd;
              }
          }
  
          // Update category drag display index
          d.dragCategoryDisplayInd = dragCategory.model.displayInd;
      }
  
      // Update dimension position
      if(d.dragCategoryDisplayInd === null || d.parcatsViewModel.arrangement === 'freeform') {
          dragDimension.model.dragX = d3.event.x;
  
          // Check for dimension swaps
          var prevDimension = d.parcatsViewModel.dimensions[prevDimInd];
          var nextDimension = d.parcatsViewModel.dimensions[nextDimInd];
  
          if(prevDimension !== undefined) {
              if(dragDimension.model.dragX < (prevDimension.x + prevDimension.width)) {
                  // Swap display inds
                  dragDimension.model.displayInd = prevDimension.model.displayInd;
                  prevDimension.model.displayInd = dragDimInd;
              }
          }
  
          if(nextDimension !== undefined) {
              if((dragDimension.model.dragX + dragDimension.width) > nextDimension.x) {
                  // Swap display inds
                  dragDimension.model.displayInd = nextDimension.model.displayInd;
                  nextDimension.model.displayInd = d.dragDimensionDisplayInd;
              }
          }
  
          // Update drag display index
          d.dragDimensionDisplayInd = dragDimension.model.displayInd;
      }
  
      // Update view models
      updateDimensionViewModels(d.parcatsViewModel);
      updatePathViewModels(d.parcatsViewModel);
  
      // Update svg geometry
      updateSvgCategories(d.parcatsViewModel);
      updateSvgPaths(d.parcatsViewModel);
  }
  
  
  /**
   * Handle dimension drag end
   * @param {DimensionViewModel} d
   */
  function dragDimensionEnd(d) {
      // Check if dragging is supported
      if(d.parcatsViewModel.arrangement === 'fixed') {
          return;
      }
  
      if(d.dragDimensionDisplayInd === null) {
          return;
      }
  
      d3.select(this).selectAll('text').attr('font-weight', 'normal');
  
      // Compute restyle command
      // -----------------------
      var restyleData = {};
      var traceInd = getTraceIndex(d.parcatsViewModel);
  
      // ### Handle dimension reordering ###
      var finalDragDimensionDisplayInds = d.parcatsViewModel.model.dimensions.map(function(d) {return d.displayInd;});
      var anyDimsReordered = d.initialDragDimensionDisplayInds.some(function(initDimDisplay, dimInd) {
          return initDimDisplay !== finalDragDimensionDisplayInds[dimInd];
      });
  
      if(anyDimsReordered) {
          finalDragDimensionDisplayInds.forEach(function(finalDimDisplay, dimInd) {
              var containerInd = d.parcatsViewModel.model.dimensions[dimInd].containerInd;
              restyleData['dimensions[' + containerInd + '].displayindex'] = finalDimDisplay;
          });
      }
  
      // ### Handle category reordering ###
      var anyCatsReordered = false;
      if(d.dragCategoryDisplayInd !== null) {
          var finalDragCategoryDisplayInds = d.model.categories.map(function(c) {
              return c.displayInd;
          });
  
          anyCatsReordered = d.initialDragCategoryDisplayInds.some(function(initCatDisplay, catInd) {
              return initCatDisplay !== finalDragCategoryDisplayInds[catInd];
          });
  
          if(anyCatsReordered) {
              // Sort a shallow copy of the category models by display index
              var sortedCategoryModels = d.model.categories.slice().sort(
                  function(a, b) { return a.displayInd - b.displayInd; });
  
              // Get new categoryarray and ticktext values
              var newCategoryArray = sortedCategoryModels.map(function(v) { return v.categoryValue; });
              var newCategoryLabels = sortedCategoryModels.map(function(v) { return v.categoryLabel; });
  
              restyleData['dimensions[' + d.model.containerInd + '].categoryarray'] = [newCategoryArray];
              restyleData['dimensions[' + d.model.containerInd + '].ticktext'] = [newCategoryLabels];
              restyleData['dimensions[' + d.model.containerInd + '].categoryorder'] = 'array';
          }
      }
  
      // Handle potential click event
      // ----------------------------
      if(d.parcatsViewModel.hoverinfoItems.indexOf('skip') === -1) {
          if(!d.dragHasMoved && d.potentialClickBand) {
              if(d.parcatsViewModel.hoveron === 'color') {
                  emitPointsEventColorHovermode(d.potentialClickBand, 'plotly_click', d3.event.sourceEvent);
              } else {
                  emitPointsEventCategoryHovermode(d.potentialClickBand, 'plotly_click', d3.event.sourceEvent);
              }
          }
      }
  
      // Nullify drag states
      // -------------------
      d.model.dragX = null;
      if(d.dragCategoryDisplayInd !== null) {
          var dragCategory = d.parcatsViewModel
              .dimensions[d.dragDimensionDisplayInd]
              .categories[d.dragCategoryDisplayInd];
  
          dragCategory.model.dragY = null;
          d.dragCategoryDisplayInd = null;
      }
  
      d.dragDimensionDisplayInd = null;
      d.parcatsViewModel.dragDimension = null;
      d.dragHasMoved = null;
      d.potentialClickBand = null;
  
      // Update view models
      // ------------------
      updateDimensionViewModels(d.parcatsViewModel);
      updatePathViewModels(d.parcatsViewModel);
  
      // Perform transition
      // ------------------
      var transition = d3.transition()
          .duration(300)
          .ease('cubic-in-out');
  
      transition
          .each(function() {
              updateSvgCategories(d.parcatsViewModel, true);
              updateSvgPaths(d.parcatsViewModel, true);
          })
          .each('end', function() {
              if(anyDimsReordered || anyCatsReordered) {
                  // Perform restyle if the order of categories or dimensions changed
                  Plotly.restyle(d.parcatsViewModel.graphDiv, restyleData, [traceInd]);
              }
          });
  }
  
  /**
   *
   * @param {ParcatsViewModel} parcatsViewModel
   */
  function getTraceIndex(parcatsViewModel) {
      var traceInd;
      var allTraces = parcatsViewModel.graphDiv._fullData;
      for(var i = 0; i < allTraces.length; i++) {
          if(parcatsViewModel.key === allTraces[i].uid) {
              traceInd = i;
              break;
          }
      }
      return traceInd;
  }
  
  /** Update the svg paths for view model
   * @param {ParcatsViewModel} parcatsViewModel
   * @param {boolean} hasTransition Whether to update element with transition
   */
  function updateSvgPaths(parcatsViewModel, hasTransition) {
      if(hasTransition === undefined) {
          hasTransition = false;
      }
  
      function transition(selection) {
          return hasTransition ? selection.transition() : selection;
      }
  
      // Update binding
      parcatsViewModel.pathSelection.data(function(d) {
          return d.paths;
      }, key);
  
      // Update paths
      transition(parcatsViewModel.pathSelection).attr('d', function(d) {
          return d.svgD;
      });
  }
  
  /** Update the svg paths for view model
   * @param {ParcatsViewModel} parcatsViewModel
   * @param {boolean} hasTransition Whether to update element with transition
   */
  function updateSvgCategories(parcatsViewModel, hasTransition) {
      if(hasTransition === undefined) {
          hasTransition = false;
      }
  
      function transition(selection) {
          return hasTransition ? selection.transition() : selection;
      }
  
      // Update binding
      parcatsViewModel.dimensionSelection
          .data(function(d) {
              return d.dimensions;
          }, key);
  
      var categorySelection = parcatsViewModel.dimensionSelection
          .selectAll('g.category')
          .data(function(d) {return d.categories;}, key);
  
      // Update dimension position
      transition(parcatsViewModel.dimensionSelection)
          .attr('transform', function(d) {
              return 'translate(' + d.x + ', 0)';
          });
  
      // Update category position
      transition(categorySelection)
          .attr('transform', function(d) {
              return 'translate(0, ' + d.y + ')';
          });
  
      var dimLabelSelection = categorySelection.select('.dimlabel');
  
      // ### Update dimension label
      // Only the top-most display category should have the dimension label
      dimLabelSelection
          .text(function(d, i) {
              if(i === 0) {
                  // Add dimension label above topmost category
                  return d.parcatsViewModel.model.dimensions[d.model.dimensionInd].dimensionLabel;
              } else {
                  return null;
              }
          });
  
      // Update category label
      // Categories in the right-most display dimension have their labels on
      // the right, all others on the left
      var catLabelSelection = categorySelection.select('.catlabel');
      catLabelSelection
          .attr('text-anchor',
              function(d) {
                  if(catInRightDim(d)) {
                      // Place label to the right of category
                      return 'start';
                  } else {
                      // Place label to the left of category
                      return 'end';
                  }
              })
          .attr('x',
              function(d) {
                  if(catInRightDim(d)) {
                      // Place label to the right of category
                      return d.width + 5;
                  } else {
                      // Place label to the left of category
                      return -5;
                  }
              })
          .each(function(d) {
              // Update attriubutes of <tspan> elements
              var newX;
              var newAnchor;
              if(catInRightDim(d)) {
                  // Place label to the right of category
                  newX = d.width + 5;
                  newAnchor = 'start';
              } else {
                  // Place label to the left of category
                  newX = -5;
                  newAnchor = 'end';
              }
              d3.select(this)
                  .selectAll('tspan')
                  .attr('x', newX)
                  .attr('text-anchor', newAnchor);
          });
  
      // Update bands
      // Initialize color band rects
      var bandSelection = categorySelection
          .selectAll('rect.bandrect')
          .data(
              /** @param {CategoryViewModel} catViewModel*/
              function(catViewModel) {
                  return catViewModel.bands;
              }, key);
  
      var bandsSelectionEnter = bandSelection.enter()
          .append('rect')
          .attr('class', 'bandrect')
          .attr('cursor', 'move')
          .attr('stroke-opacity', 0)
          .attr('fill', function(d) {
              return d.color;
          })
          .attr('fill-opacity', 0);
  
      bandSelection
          .attr('fill', function(d) {
              return d.color;
          })
          .attr('width', function(d) {
              return d.width;
          })
          .attr('height', function(d) {
              return d.height;
          })
          .attr('y', function(d) {
              return d.y;
          });
  
      styleBandsNoHover(bandsSelectionEnter);
  
      // Raise bands to the top
      bandSelection.each(function() {Lib.raiseToTop(this);});
  
      // Remove unused bands
      bandSelection.exit().remove();
  }
  
  /**
   * Create a ParcatsViewModel traces
   * @param {Object} graphDiv
   *  Top-level graph div element
   * @param {Layout} layout
   *  SVG layout object
   * @param {Array.<ParcatsModel>} wrappedParcatsModel
   *  Wrapped ParcatsModel for this trace
   * @return {ParcatsViewModel}
   */
  function createParcatsViewModel(graphDiv, layout, wrappedParcatsModel) {
      // Unwrap model
      var parcatsModel = wrappedParcatsModel[0];
  
      // Compute margin
      var margin = layout.margin || {l: 80, r: 80, t: 100, b: 80};
  
      // Compute pixel position/extents
      var trace = parcatsModel.trace;
      var domain = trace.domain;
      var figureWidth = layout.width;
      var figureHeight = layout.height;
      var traceWidth = Math.floor(figureWidth * (domain.x[1] - domain.x[0]));
      var traceHeight = Math.floor(figureHeight * (domain.y[1] - domain.y[0]));
      var traceX = domain.x[0] * figureWidth + margin.l;
      var traceY = layout.height - domain.y[1] * layout.height + margin.t;
  
      // Handle path shape
      // -----------------
      var pathShape = trace.line.shape;
  
      // Handle hover info
      // -----------------
      var hoverinfoItems;
      if(trace.hoverinfo === 'all') {
          hoverinfoItems = ['count', 'probability'];
      } else {
          hoverinfoItems = (trace.hoverinfo || '').split('+');
      }
  
      // Construct parcatsViewModel
      // --------------------------
      var parcatsViewModel = {
          trace: trace,
          key: trace.uid,
          model: parcatsModel,
          x: traceX,
          y: traceY,
          width: traceWidth,
          height: traceHeight,
          hoveron: trace.hoveron,
          hoverinfoItems: hoverinfoItems,
          arrangement: trace.arrangement,
          bundlecolors: trace.bundlecolors,
          sortpaths: trace.sortpaths,
          labelfont: trace.labelfont,
          categorylabelfont: trace.tickfont,
          pathShape: pathShape,
          dragDimension: null,
          margin: margin,
          paths: [],
          dimensions: [],
          graphDiv: graphDiv,
          traceSelection: null,
          pathSelection: null,
          dimensionSelection: null
      };
  
      // Update dimension view models if we have at least 1 dimension
      if(parcatsModel.dimensions) {
          updateDimensionViewModels(parcatsViewModel);
  
          // Update path view models if we have at least 2 dimensions
          updatePathViewModels(parcatsViewModel);
      }
      // Inside a categories view model
      return parcatsViewModel;
  }
  
  /**
   * Build the SVG string to represents a parallel categories path
   * @param {Array.<Number>} leftXPositions
   *  Array of the x positions of the left edge of each dimension (in display order)
   * @param {Array.<Number>} pathYs
   *  Array of the y positions of the top of the path at each dimension (in display order)
   * @param {Array.<Number>} dimWidths
   *  Array of the widths of each dimension in display order
   * @param {Number} pathHeight
   *  The height of the path in pixels
   * @param {Number} curvature
   *  The curvature factor for the path. 0 results in a straight line and values greater than zero result in curved paths
   * @return {string}
   */
  function buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, curvature) {
      // Compute the x midpoint of each path segment
      var xRefPoints1 = [];
      var xRefPoints2 = [];
      var refInterpolator;
      var d;
  
      for(d = 0; d < dimWidths.length - 1; d++) {
          refInterpolator = d3.interpolateNumber(dimWidths[d] + leftXPositions[d], leftXPositions[d + 1]);
          xRefPoints1.push(refInterpolator(curvature));
          xRefPoints2.push(refInterpolator(1 - curvature));
      }
  
      // Move to top of path on left edge of left-most category
      var svgD = 'M ' + leftXPositions[0] + ',' + pathYs[0];
  
      // Horizontal line to right edge
      svgD += 'l' + dimWidths[0] + ',0 ';
  
      // Horizontal line to right edge
      for(d = 1; d < dimWidths.length; d++) {
          // Curve to left edge of category
          svgD += 'C' + xRefPoints1[d - 1] + ',' + pathYs[d - 1] +
                ' ' + xRefPoints2[d - 1] + ',' + pathYs[d] +
                ' ' + leftXPositions[d] + ',' + pathYs[d];
  
          // svgD += 'L' + leftXPositions[d] + ',' + pathYs[d];
  
          // Horizontal line to right edge
          svgD += 'l' + dimWidths[d] + ',0 ';
      }
  
      // Line down
      svgD += 'l' + '0,' + pathHeight + ' ';
  
      // Line to left edge of right-most category
      svgD += 'l -' + dimWidths[dimWidths.length - 1] + ',0 ';
  
      for(d = dimWidths.length - 2; d >= 0; d--) {
          // Curve to right edge of category
          svgD += 'C' + xRefPoints2[d] + ',' + (pathYs[d + 1] + pathHeight) +
               ' ' + xRefPoints1[d] + ',' + (pathYs[d] + pathHeight) +
               ' ' + (leftXPositions[d] + dimWidths[d]) + ',' + (pathYs[d] + pathHeight);
  
          // svgD += 'L' + (leftXPositions[d] + dimWidths[d]) + ',' + (pathYs[d] + pathHeight);
  
          // Horizontal line to right edge
          svgD += 'l-' + dimWidths[d] + ',0 ';
      }
  
      // Close path
      svgD += 'Z';
      return svgD;
  }
  
  /**
   * Update the path view models based on the dimension view models in a ParcatsViewModel
   *
   * @param {ParcatsViewModel} parcatsViewModel
   *  View model for trace
   */
  function updatePathViewModels(parcatsViewModel) {
      // Initialize an array of the y position of the top of the next path to be added to each category.
      //
      // nextYPositions[d][c] is the y position of the next path through category with index c of dimension with index d
      var dimensionViewModels = parcatsViewModel.dimensions;
      var parcatsModel = parcatsViewModel.model;
      var nextYPositions = dimensionViewModels.map(
          function(d) {
              return d.categories.map(
                  function(c) {
                      return c.y;
                  });
          });
  
      // Array from category index to category display index for each true dimension index
      var catToDisplayIndPerDim = parcatsViewModel.model.dimensions.map(
          function(d) {
              return d.categories.map(function(c) {return c.displayInd;});
          });
  
      // Array from true dimension index to dimension display index
      var dimToDisplayInd = parcatsViewModel.model.dimensions.map(function(d) {return d.displayInd;});
      var displayToDimInd = parcatsViewModel.dimensions.map(function(d) {return d.model.dimensionInd;});
  
      // Array of the x position of the left edge of the rectangles for each dimension
      var leftXPositions = dimensionViewModels.map(
          function(d) {
              return d.x;
          });
  
      // Compute dimension widths
      var dimWidths = dimensionViewModels.map(function(d) {return d.width;});
  
      // Build sorted Array of PathModel objects
      var pathModels = [];
      for(var p in parcatsModel.paths) {
          if(parcatsModel.paths.hasOwnProperty(p)) {
              pathModels.push(parcatsModel.paths[p]);
          }
      }
  
      // Compute category display inds to use for sorting paths
      function pathDisplayCategoryInds(pathModel) {
          var dimensionInds = pathModel.categoryInds.map(function(catInd, dimInd) {return catToDisplayIndPerDim[dimInd][catInd];});
          var displayInds = displayToDimInd.map(function(dimInd) {
              return dimensionInds[dimInd];
          });
          return displayInds;
      }
  
      // Sort in ascending order by display index array
      pathModels.sort(function(v1, v2) {
          // Build display inds for each path
          var sortArray1 = pathDisplayCategoryInds(v1);
          var sortArray2 = pathDisplayCategoryInds(v2);
  
          // Handle path sort order
          if(parcatsViewModel.sortpaths === 'backward') {
              sortArray1.reverse();
              sortArray2.reverse();
          }
  
          // Append the first value index of the path to break ties
          sortArray1.push(v1.valueInds[0]);
          sortArray2.push(v2.valueInds[0]);
  
          // Handle color bundling
          if(parcatsViewModel.bundlecolors) {
              // Prepend sort array with the raw color value
              sortArray1.unshift(v1.rawColor);
              sortArray2.unshift(v2.rawColor);
          }
  
          // colors equal, sort by display categories
          if(sortArray1 < sortArray2) {
              return -1;
          }
          if(sortArray1 > sortArray2) {
              return 1;
          }
  
          return 0;
      });
  
      // Create path models
      var pathViewModels = new Array(pathModels.length);
      var totalCount = dimensionViewModels[0].model.count;
      var totalHeight = dimensionViewModels[0].categories
          .map(function(c) { return c.height; })
          .reduce(function(v1, v2) { return v1 + v2; });
  
  
      for(var pathNumber = 0; pathNumber < pathModels.length; pathNumber++) {
          var pathModel = pathModels[pathNumber];
  
          var pathHeight;
          if(totalCount > 0) {
              pathHeight = totalHeight * (pathModel.count / totalCount);
          } else {
              pathHeight = 0;
          }
  
          // Build path y coords
          var pathYs = new Array(nextYPositions.length);
          for(var d = 0; d < pathModel.categoryInds.length; d++) {
              var catInd = pathModel.categoryInds[d];
              var catDisplayInd = catToDisplayIndPerDim[d][catInd];
              var dimDisplayInd = dimToDisplayInd[d];
  
              // Update next y position
              pathYs[dimDisplayInd] = nextYPositions[dimDisplayInd][catDisplayInd];
              nextYPositions[dimDisplayInd][catDisplayInd] += pathHeight;
  
              // Update category color information
              var catViewModle = parcatsViewModel.dimensions[dimDisplayInd].categories[catDisplayInd];
              var numBands = catViewModle.bands.length;
              var lastCatBand = catViewModle.bands[numBands - 1];
  
              if(lastCatBand === undefined || pathModel.rawColor !== lastCatBand.rawColor) {
                  // Create a new band
                  var bandY = lastCatBand === undefined ? 0 : lastCatBand.y + lastCatBand.height;
                  catViewModle.bands.push({
                      key: bandY,
                      color: pathModel.color,
                      rawColor: pathModel.rawColor,
                      height: pathHeight,
                      width: catViewModle.width,
                      count: pathModel.count,
                      y: bandY,
                      categoryViewModel: catViewModle,
                      parcatsViewModel: parcatsViewModel
                  });
              } else {
                  // Extend current band
                  var currentBand = catViewModle.bands[numBands - 1];
                  currentBand.height += pathHeight;
                  currentBand.count += pathModel.count;
              }
          }
  
          // build svg path
          var svgD;
          if(parcatsViewModel.pathShape === 'hspline') {
              svgD = buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, 0.5);
          } else {
              svgD = buildSvgPath(leftXPositions, pathYs, dimWidths, pathHeight, 0);
          }
  
          pathViewModels[pathNumber] = {
              key: pathModel.valueInds[0],
              model: pathModel,
              height: pathHeight,
              leftXs: leftXPositions,
              topYs: pathYs,
              dimWidths: dimWidths,
              svgD: svgD,
              parcatsViewModel: parcatsViewModel
          };
      }
  
      parcatsViewModel.paths = pathViewModels;
  
   // * @property key
   // *  Unique key for this model
   // * @property {PathModel} model
   // *  Source path model
   // * @property {Number} height
   // *  Height of this path (pixels)
   // * @property {String} svgD
   // *  SVG path "d" attribute string
  }
  
  /**
   * Update the dimension view models based on the dimension models in a ParcatsViewModel
   *
   * @param {ParcatsViewModel} parcatsViewModel
   *  View model for trace
   */
  function updateDimensionViewModels(parcatsViewModel) {
      // Compute dimension ordering
      var dimensionsIndInfo = parcatsViewModel.model.dimensions.map(function(d) {
          return {displayInd: d.displayInd, dimensionInd: d.dimensionInd};
      });
  
      dimensionsIndInfo.sort(function(a, b) {
          return a.displayInd - b.displayInd;
      });
  
      var dimensions = [];
      for(var displayInd in dimensionsIndInfo) {
          var dimensionInd = dimensionsIndInfo[displayInd].dimensionInd;
          var dimModel = parcatsViewModel.model.dimensions[dimensionInd];
          dimensions.push(createDimensionViewModel(parcatsViewModel, dimModel));
      }
  
      parcatsViewModel.dimensions = dimensions;
  }
  
  /**
   * Create a parcats DimensionViewModel
   *
   * @param {ParcatsViewModel} parcatsViewModel
   *  View model for trace
   * @param {DimensionModel} dimensionModel
   * @return {DimensionViewModel}
   */
  function createDimensionViewModel(parcatsViewModel, dimensionModel) {
      // Compute dimension x position
      var categoryLabelPad = 40;
      var dimWidth = 16;
      var numDimensions = parcatsViewModel.model.dimensions.length;
      var displayInd = dimensionModel.displayInd;
  
      // Compute x coordinate values
      var dimDx;
      var dimX0;
      var dimX;
  
      if(numDimensions > 1) {
          dimDx = (parcatsViewModel.width - 2 * categoryLabelPad - dimWidth) / (numDimensions - 1);
      } else {
          dimDx = 0;
      }
      dimX0 = categoryLabelPad;
      dimX = dimX0 + dimDx * displayInd;
  
      // Compute categories
      var categories = [];
      var maxCats = parcatsViewModel.model.maxCats;
      var numCats = dimensionModel.categories.length;
      var catSpacing = 8;
      var totalCount = dimensionModel.count;
      var totalHeight = parcatsViewModel.height - catSpacing * (maxCats - 1);
      var nextCatHeight;
      var nextCatModel;
      var nextCat;
      var catInd;
      var catDisplayInd;
  
      // Compute starting Y offset
      var nextCatY = (maxCats - numCats) * catSpacing / 2.0;
  
      // Compute category ordering
      var categoryIndInfo = dimensionModel.categories.map(function(c) {
          return {displayInd: c.displayInd, categoryInd: c.categoryInd};
      });
  
      categoryIndInfo.sort(function(a, b) {
          return a.displayInd - b.displayInd;
      });
  
      for(catDisplayInd = 0; catDisplayInd < numCats; catDisplayInd++) {
          catInd = categoryIndInfo[catDisplayInd].categoryInd;
          nextCatModel = dimensionModel.categories[catInd];
  
          if(totalCount > 0) {
              nextCatHeight = (nextCatModel.count / totalCount) * totalHeight;
          } else {
              nextCatHeight = 0;
          }
  
          nextCat = {
              key: nextCatModel.valueInds[0],
              model: nextCatModel,
              width: dimWidth,
              height: nextCatHeight,
              y: nextCatModel.dragY !== null ? nextCatModel.dragY : nextCatY,
              bands: [],
              parcatsViewModel: parcatsViewModel
          };
  
          nextCatY = nextCatY + nextCatHeight + catSpacing;
          categories.push(nextCat);
      }
  
      return {
          key: dimensionModel.dimensionInd,
          x: dimensionModel.dragX !== null ? dimensionModel.dragX : dimX,
          y: 0,
          width: dimWidth,
          model: dimensionModel,
          categories: categories,
          parcatsViewModel: parcatsViewModel,
          dragCategoryDisplayInd: null,
          dragDimensionDisplayInd: null,
          initialDragDimensionDisplayInds: null,
          initialDragCategoryDisplayInds: null,
          dragHasMoved: null,
          potentialClickBand: null
      };
  }
  
  // JSDoc typedefs
  // ==============
  /**
   * @typedef {Object} Layout
   *  Object containing svg layout information
   *
   * @property {Number} width (pixels)
   *  Usable width for Figure (after margins are removed)
   * @property {Number} height (pixels)
   *  Usable height for Figure (after margins are removed)
   * @property {Margin} margin
   *  Margin around the Figure (pixels)
   */
  
  /**
   * @typedef {Object} Margin
   *  Object containing padding information in pixels
   *
   * @property {Number} t
   *  Top margin
   * @property {Number} r
   *  Right margin
   * @property {Number} b
   *  Bottom margin
   * @property {Number} l
   *  Left margin
   */
  
  /**
   * @typedef {Object} Font
   *  Object containing font information
   *
   * @property {Number} size: Font size
   * @property {String} color: Font color
   * @property {String} family: Font family
   */
  
  /**
   * @typedef {Object} ParcatsViewModel
   *  Object containing calculated parcats view information
   *
   *  These are quantities that require Layout information to calculate
   * @property key
   *  Unique key for this model
   * @property {ParcatsModel} model
   *  Source parcats model
   * @property {Array.<DimensionViewModel>} dimensions
   *  Array of dimension view models
   * @property {Number} width
   *  Width for this trace (pixels)
   * @property {Number} height
   *  Height for this trace (pixels)
   * @property {Number} x
   *  X position of this trace with respect to the Figure (pixels)
   * @property {Number} y
   *  Y position of this trace with respect to the Figure (pixels)
   * @property {String} hoveron
   *  Hover interaction mode. One of: 'category', 'color', or 'dimension'
   * @property {Array.<String>} hoverinfoItems
   *  Info to display on hover. Array with a combination of 'counts' and/or 'probabilities', or 'none', or 'skip'
   * @property {String} arrangement
   *  Category arrangement. One of: 'perpendicular', 'freeform', or 'fixed'
   * @property {Boolean} bundlecolors
   *  Whether paths should be sorted so that like colors are bundled together as they pass through categories
   * @property {String} sortpaths
   *  If 'forward' then sort paths based on dimensions from left to right. If 'backward' sort based on dimensions
   *  from right to left
   * @property {Font} labelfont
   *  Font for the dimension labels
   * @property {Font} categorylabelfont
   *  Font for the category labels
   * @property {String} pathShape
   *  The shape of the paths. Either 'linear' or 'hspline'.
   * @property {DimensionViewModel|null} dragDimension
   *  Dimension currently being dragged. Null if no drag in progress
   * @property {Margin} margin
   *  Margin around the Figure
   * @property {Object} graphDiv
   *  Top-level graph div element
   * @property {Object} traceSelection
   *  D3 selection of this view models trace group element
   * @property {Object} pathSelection
   *  D3 selection of this view models path elements
   * @property {Object} dimensionSelection
   *  D3 selection of this view models dimension group element
   */
  
  /**
   * @typedef {Object} DimensionViewModel
   *  Object containing calculated parcats dimension view information
   *
   *  These are quantities that require Layout information to calculate
   * @property key
   *  Unique key for this model
   * @property {DimensionModel} model
   *  Source dimension model
   * @property {Number} x
   *  X position of the center of this dimension with respect to the Figure (pixels)
   * @property {Number} y
   *  Y position of the top of this dimension with respect to the Figure (pixels)
   * @property {Number} width
   *  Width of categories in this dimension (pixels)
   * @property {ParcatsViewModel} parcatsViewModel
   *  The parent trace's view model
   * @property {Array.<CategoryViewModel>} categories
   *  Dimensions category view models
   * @property {Number|null} dragCategoryDisplayInd
   *  Display index of category currently being dragged. null if no category is being dragged
   * @property {Number|null} dragDimensionDisplayInd
   *  Display index of the dimension being dragged. null if no dimension is being dragged
   * @property {Array.<Number>|null} initialDragDimensionDisplayInds
   *  Dimensions display indexes at the beginning of the current drag. null if no dimension is being dragged
   * @property {Array.<Number>|null} initialDragCategoryDisplayInds
   *  Category display indexes for the at the beginning of the current drag. null if no category is being dragged
   * @property {HTMLElement} potentialClickBand
   *  Band under mouse when current drag began. If no drag movement takes place then a click will be emitted for this
   *  band. Null if not drag in progress.
   * @property {Boolean} dragHasMoved
   *  True if there is an active drag and the drag has moved. If drag doesn't move before being ended then
   *  this may be interpreted as a click. Null if no drag in progress
   */
  
  /**
   * @typedef {Object} CategoryViewModel
   *  Object containing calculated parcats category view information
   *
   *  These are quantities that require Layout information to calculate
   * @property key
   *  Unique key for this model
   * @property {CategoryModel} model
   *  Source category model
   * @property {Number} width
   *  Width for this category (pixels)
   * @property {Number} height
   *  Height for this category (pixels)
   * @property {Number} y
   *  Y position of this cateogry with respect to the Figure (pixels)
   * @property {Array.<CategoryBandViewModel>} bands
   *  Array of color bands inside the category
   * @property {ParcatsViewModel} parcatsViewModel
   *  The parent trace's view model
   */
  
  /**
   * @typedef {Object} CategoryBandViewModel
   *  Object containing calculated category band information. A category band is a region inside a category covering
   *  paths of a single color
   *
   * @property key
   *  Unique key for this model
   * @property color
   *  Band color
   * @property rawColor
   *  Raw color value for band
   * @property {Number} width
   *  Band width
   * @property {Number} height
   *  Band height
   * @property {Number} y
   *  Y position of top of the band with respect to the category
   * @property {Number} count
   *  The number of samples represented by the band
   * @property {CategoryViewModel} categoryViewModel
   *  The parent categorie's view model
   * @property {ParcatsViewModel} parcatsViewModel
   *  The parent trace's view model
   */
  
  /**
   * @typedef {Object} PathViewModel
   *  Object containing calculated parcats path view information
   *
   *  These are quantities that require Layout information to calculate
   * @property key
   *  Unique key for this model
   * @property {PathModel} model
   *  Source path model
   * @property {Number} height
   *  Height of this path (pixels)
   * @property {Array.<Number>} leftXs
   *  The x position of the left edge of each display dimension
   * @property {Array.<Number>} topYs
   *  The y position of the top of the path for each display dimension
   * @property {Array.<Number>} dimWidths
   *  The width of each display dimension
   * @property {String} svgD
   *  SVG path "d" attribute string
   * @property {ParcatsViewModel} parcatsViewModel
   *  The parent trace's view model
   */
  
  },{"../../components/drawing":637,"../../components/fx":655,"../../lib":750,"../../lib/svg_text_utils":774,"../../plot_api/plot_api":785,"d3":169,"tinycolor2":548}],1119:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  var parcats = _dereq_('./parcats');
  
  /**
   * Create / update parcat traces
   *
   * @param {Object} graphDiv
   * @param {Array.<ParcatsModel>} parcatsModels
   */
  module.exports = function plot(graphDiv, parcatsModels, transitionOpts, makeOnCompleteCallback) {
      var fullLayout = graphDiv._fullLayout;
      var svg = fullLayout._paper;
      var size = fullLayout._size;
  
      parcats(
          graphDiv,
          svg,
          parcatsModels,
          {
              width: size.w,
              height: size.h,
              margin: {
                  t: size.t,
                  r: size.r,
                  b: size.b,
                  l: size.l
              }
          },
          transitionOpts,
          makeOnCompleteCallback
      );
  };
  
  },{"./parcats":1118}],1120:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var axesAttrs = _dereq_('../../plots/cartesian/layout_attributes');
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  
  module.exports = {
      domain: domainAttrs({name: 'parcoords', trace: true, editType: 'plot'}),
  
      labelangle: {
          valType: 'angle',
          dflt: 0,
          
          editType: 'plot',
          
      },
  
      labelside: {
          valType: 'enumerated',
          
          values: ['top', 'bottom'],
          dflt: 'top',
          editType: 'plot',
          
      },
  
      labelfont: fontAttrs({
          editType: 'plot',
          
      }),
      tickfont: fontAttrs({
          editType: 'plot',
          
      }),
      rangefont: fontAttrs({
          editType: 'plot',
          
      }),
  
      dimensions: templatedArray('dimension', {
          label: {
              valType: 'string',
              
              editType: 'plot',
              
          },
          // TODO: better way to determine ordinal vs continuous axes,
          // so users can use tickvals/ticktext with a continuous axis.
          tickvals: extendFlat({}, axesAttrs.tickvals, {
              editType: 'plot',
              
          }),
          ticktext: extendFlat({}, axesAttrs.ticktext, {
              editType: 'plot',
              
          }),
          tickformat: extendFlat({}, axesAttrs.tickformat, {
              editType: 'plot'
          }),
          visible: {
              valType: 'boolean',
              dflt: true,
              
              editType: 'plot',
              
          },
          range: {
              valType: 'info_array',
              
              items: [
                  {valType: 'number', editType: 'plot'},
                  {valType: 'number', editType: 'plot'}
              ],
              editType: 'plot',
              
          },
          constraintrange: {
              valType: 'info_array',
              
              freeLength: true,
              dimensions: '1-2',
              items: [
                  {valType: 'number', editType: 'plot'},
                  {valType: 'number', editType: 'plot'}
              ],
              editType: 'plot',
              
          },
          multiselect: {
              valType: 'boolean',
              dflt: true,
              
              editType: 'plot',
              
          },
          values: {
              valType: 'data_array',
              
              editType: 'calc',
              
          },
          editType: 'calc',
          
      }),
  
      line: extendFlat({editType: 'calc'},
          colorScaleAttrs('line', {
              // the default autocolorscale isn't quite usable for parcoords due to context ambiguity around 0 (grey, off-white)
              // autocolorscale therefore defaults to false too, to avoid being overridden by the blue-white-red autocolor palette
              colorscaleDflt: 'Viridis',
              autoColorDflt: false,
              editTypeOverride: 'calc'
          })
      )
  };
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plot_api/plot_template":788,"../../plots/cartesian/layout_attributes":813,"../../plots/domain":826,"../../plots/font_attributes":827}],1121:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var c = _dereq_('./constants');
  var d3 = _dereq_('d3');
  var keyFun = _dereq_('../../lib/gup').keyFun;
  var repeat = _dereq_('../../lib/gup').repeat;
  var sortAsc = _dereq_('../../lib').sorterAsc;
  
  var snapRatio = c.bar.snapRatio;
  function snapOvershoot(v, vAdjacent) { return v * (1 - snapRatio) + vAdjacent * snapRatio; }
  
  var snapClose = c.bar.snapClose;
  function closeToCovering(v, vAdjacent) { return v * (1 - snapClose) + vAdjacent * snapClose; }
  
  // snap for the low end of a range on an ordinal scale
  // on an ordinal scale, always show some overshoot from the exact value,
  // so it's clear we're covering it
  // find the interval we're in, and snap to 1/4 the distance to the next
  // these two could be unified at a slight loss of readability / perf
  function ordinalScaleSnap(isHigh, a, v, existingRanges) {
      if(overlappingExisting(v, existingRanges)) return v;
  
      var dir = isHigh ? -1 : 1;
  
      var first = 0;
      var last = a.length - 1;
      if(dir < 0) {
          var tmp = first;
          first = last;
          last = tmp;
      }
  
      var aHere = a[first];
      var aPrev = aHere;
      for(var i = first; dir * i < dir * last; i += dir) {
          var nextI = i + dir;
          var aNext = a[nextI];
  
          // very close to the previous - snap down to it
          if(dir * v < dir * closeToCovering(aHere, aNext)) return snapOvershoot(aHere, aPrev);
          if(dir * v < dir * aNext || nextI === last) return snapOvershoot(aNext, aHere);
  
          aPrev = aHere;
          aHere = aNext;
      }
  }
  
  function overlappingExisting(v, existingRanges) {
      for(var i = 0; i < existingRanges.length; i++) {
          if(v >= existingRanges[i][0] && v <= existingRanges[i][1]) return true;
      }
      return false;
  }
  
  function barHorizontalSetup(selection) {
      selection
          .attr('x', -c.bar.captureWidth / 2)
          .attr('width', c.bar.captureWidth);
  }
  
  function backgroundBarHorizontalSetup(selection) {
      selection
          .attr('visibility', 'visible')
          .style('visibility', 'visible')
          .attr('fill', 'yellow')
          .attr('opacity', 0);
  }
  
  function setHighlight(d) {
      if(!d.brush.filterSpecified) {
          return '0,' + d.height;
      }
  
      var pixelRanges = unitToPx(d.brush.filter.getConsolidated(), d.height);
      var dashArray = [0]; // we start with a 0 length selection as filter ranges are inclusive, not exclusive
      var p, sectionHeight, iNext;
      var currentGap = pixelRanges.length ? pixelRanges[0][0] : null;
      for(var i = 0; i < pixelRanges.length; i++) {
          p = pixelRanges[i];
          sectionHeight = p[1] - p[0];
          dashArray.push(currentGap);
          dashArray.push(sectionHeight);
          iNext = i + 1;
          if(iNext < pixelRanges.length) {
              currentGap = pixelRanges[iNext][0] - p[1];
          }
      }
      dashArray.push(d.height);
      // d.height is added at the end to ensure that (1) we have an even number of dasharray points, MDN page says
      // "If an odd number of values is provided, then the list of values is repeated to yield an even number of values."
      // and (2) it's _at least_ as long as the full height (even if range is minuscule and at the bottom) though this
      // may not be necessary, maybe duplicating the last point would do too. But no harm in a longer dasharray than line.
      return dashArray;
  }
  
  function unitToPx(unitRanges, height) {
      return unitRanges.map(function(pr) {
          return pr.map(function(v) { return Math.max(0, v * height); }).sort(sortAsc);
      });
  }
  
  // is the cursor over the north, middle, or south of a bar?
  // the end handles extend over the last 10% of the bar
  function getRegion(fPix, y) {
      var pad = c.bar.handleHeight;
      if(y > fPix[1] + pad || y < fPix[0] - pad) return;
      if(y >= 0.9 * fPix[1] + 0.1 * fPix[0]) return 'n';
      if(y <= 0.9 * fPix[0] + 0.1 * fPix[1]) return 's';
      return 'ns';
  }
  
  function clearCursor() {
      d3.select(document.body)
          .style('cursor', null);
  }
  
  function styleHighlight(selection) {
      // stroke-dasharray is used to minimize the number of created DOM nodes, because the requirement calls for up to
      // 1000 individual selections on an axis, and there can be 60 axes per parcoords, and multiple parcoords per
      // dashboard. The technique is similar to https://codepen.io/monfera/pen/rLYqWR and using a `polyline` with
      // multiple sections, or a `path` element via its `d` attribute would also be DOM-sparing alternatives.
      selection.attr('stroke-dasharray', setHighlight);
  }
  
  function renderHighlight(root, tweenCallback) {
      var bar = d3.select(root).selectAll('.highlight, .highlight-shadow');
      var barToStyle = tweenCallback ? bar.transition().duration(c.bar.snapDuration).each('end', tweenCallback) : bar;
      styleHighlight(barToStyle);
  }
  
  function getInterval(d, y) {
      var b = d.brush;
      var active = b.filterSpecified;
      var closestInterval = NaN;
      var out = {};
      var i;
  
      if(active) {
          var height = d.height;
          var intervals = b.filter.getConsolidated();
          var pixIntervals = unitToPx(intervals, height);
          var hoveredInterval = NaN;
          var previousInterval = NaN;
          var nextInterval = NaN;
          for(i = 0; i <= pixIntervals.length; i++) {
              var p = pixIntervals[i];
              if(p && p[0] <= y && y <= p[1]) {
                  // over a bar
                  hoveredInterval = i;
                  break;
              } else {
                  // between bars, or before/after the first/last bar
                  previousInterval = i ? i - 1 : NaN;
                  if(p && p[0] > y) {
                      nextInterval = i;
                      break; // no point continuing as intervals are non-overlapping and sorted; could use log search
                  }
              }
          }
  
          closestInterval = hoveredInterval;
          if(isNaN(closestInterval)) {
              if(isNaN(previousInterval) || isNaN(nextInterval)) {
                  closestInterval = isNaN(previousInterval) ? nextInterval : previousInterval;
              } else {
                  closestInterval = (y - pixIntervals[previousInterval][1] < pixIntervals[nextInterval][0] - y) ?
                      previousInterval : nextInterval;
              }
          }
  
          if(!isNaN(closestInterval)) {
              var fPix = pixIntervals[closestInterval];
              var region = getRegion(fPix, y);
  
              if(region) {
                  out.interval = intervals[closestInterval];
                  out.intervalPix = fPix;
                  out.region = region;
              }
          }
      }
  
      if(d.ordinal && !out.region) {
          var a = d.unitTickvals;
          var unitLocation = d.unitToPaddedPx.invert(y);
          for(i = 0; i < a.length; i++) {
              var rangei = [
                  a[Math.max(i - 1, 0)] * 0.25 + a[i] * 0.75,
                  a[Math.min(i + 1, a.length - 1)] * 0.25 + a[i] * 0.75
              ];
              if(unitLocation >= rangei[0] && unitLocation <= rangei[1]) {
                  out.clickableOrdinalRange = rangei;
                  break;
              }
          }
      }
  
      return out;
  }
  
  function dragstart(lThis, d) {
      d3.event.sourceEvent.stopPropagation();
      var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
      var unitLocation = d.unitToPaddedPx.invert(y);
      var b = d.brush;
      var interval = getInterval(d, y);
      var unitRange = interval.interval;
      var s = b.svgBrush;
      s.wasDragged = false; // we start assuming there won't be a drag - useful for reset
      s.grabbingBar = interval.region === 'ns';
      if(s.grabbingBar) {
          var pixelRange = unitRange.map(d.unitToPaddedPx);
          s.grabPoint = y - pixelRange[0] - c.verticalPadding;
          s.barLength = pixelRange[1] - pixelRange[0];
      }
      s.clickableOrdinalRange = interval.clickableOrdinalRange;
      s.stayingIntervals = (d.multiselect && b.filterSpecified) ? b.filter.getConsolidated() : [];
      if(unitRange) {
          s.stayingIntervals = s.stayingIntervals.filter(function(int2) {
              return int2[0] !== unitRange[0] && int2[1] !== unitRange[1];
          });
      }
      s.startExtent = interval.region ? unitRange[interval.region === 's' ? 1 : 0] : unitLocation;
      d.parent.inBrushDrag = true;
      s.brushStartCallback();
  }
  
  function drag(lThis, d) {
      d3.event.sourceEvent.stopPropagation();
      var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
      var s = d.brush.svgBrush;
      s.wasDragged = true;
      s._dragging = true;
  
      if(s.grabbingBar) { // moving the bar
          s.newExtent = [y - s.grabPoint, y + s.barLength - s.grabPoint].map(d.unitToPaddedPx.invert);
      } else { // south/north drag or new bar creation
          s.newExtent = [s.startExtent, d.unitToPaddedPx.invert(y)].sort(sortAsc);
      }
  
      d.brush.filterSpecified = true;
      s.extent = s.stayingIntervals.concat([s.newExtent]);
      s.brushCallback(d);
      renderHighlight(lThis.parentNode);
  }
  
  function dragend(lThis, d) {
      var brush = d.brush;
      var filter = brush.filter;
      var s = brush.svgBrush;
  
      if(!s._dragging) { // i.e. click
          // mock zero drag
          mousemove(lThis, d);
          drag(lThis, d);
          // remember it is a click not a drag
          d.brush.svgBrush.wasDragged = false;
      }
      s._dragging = false;
  
      var e = d3.event;
      e.sourceEvent.stopPropagation();
      var grabbingBar = s.grabbingBar;
      s.grabbingBar = false;
      s.grabLocation = undefined;
      d.parent.inBrushDrag = false;
      clearCursor(); // instead of clearing, a nicer thing would be to set it according to current location
      if(!s.wasDragged) { // a click+release on the same spot (ie. w/o dragging) means a bar or full reset
          s.wasDragged = undefined; // logic-wise unneeded, just shows `wasDragged` has no longer a meaning
          if(s.clickableOrdinalRange) {
              if(brush.filterSpecified && d.multiselect) {
                  s.extent.push(s.clickableOrdinalRange);
              } else {
                  s.extent = [s.clickableOrdinalRange];
                  brush.filterSpecified = true;
              }
          } else if(grabbingBar) {
              s.extent = s.stayingIntervals;
              if(s.extent.length === 0) {
                  brushClear(brush);
              }
          } else {
              brushClear(brush);
          }
          s.brushCallback(d);
          renderHighlight(lThis.parentNode);
          s.brushEndCallback(brush.filterSpecified ? filter.getConsolidated() : []);
          return; // no need to fuse intervals or snap to ordinals, so we can bail early
      }
  
      var mergeIntervals = function() {
          // Key piece of logic: once the button is released, possibly overlapping intervals will be fused:
          // Here it's done immediately on click release while on ordinal snap transition it's done at the end
          filter.set(filter.getConsolidated());
      };
  
      if(d.ordinal) {
          var a = d.unitTickvals;
          if(a[a.length - 1] < a[0]) a.reverse();
          s.newExtent = [
              ordinalScaleSnap(0, a, s.newExtent[0], s.stayingIntervals),
              ordinalScaleSnap(1, a, s.newExtent[1], s.stayingIntervals)
          ];
          var hasNewExtent = s.newExtent[1] > s.newExtent[0];
          s.extent = s.stayingIntervals.concat(hasNewExtent ? [s.newExtent] : []);
          if(!s.extent.length) {
              brushClear(brush);
          }
          s.brushCallback(d);
          if(hasNewExtent) {
              // merging intervals post the snap tween
              renderHighlight(lThis.parentNode, mergeIntervals);
          } else {
              // if no new interval, don't animate, just redraw the highlight immediately
              mergeIntervals();
              renderHighlight(lThis.parentNode);
          }
      } else {
          mergeIntervals(); // merging intervals immediately
      }
      s.brushEndCallback(brush.filterSpecified ? filter.getConsolidated() : []);
  }
  
  function mousemove(lThis, d) {
      var y = d.height - d3.mouse(lThis)[1] - 2 * c.verticalPadding;
      var interval = getInterval(d, y);
  
      var cursor = 'crosshair';
      if(interval.clickableOrdinalRange) cursor = 'pointer';
      else if(interval.region) cursor = interval.region + '-resize';
      d3.select(document.body)
          .style('cursor', cursor);
  }
  
  function attachDragBehavior(selection) {
      // There's some fiddling with pointer cursor styling so that the cursor preserves its shape while dragging a brush
      // even if the cursor strays from the interacting bar, which is bound to happen as bars are thin and the user
      // will inevitably leave the hotspot strip. In this regard, it does something similar to what the D3 brush would do.
      selection
          .on('mousemove', function(d) {
              d3.event.preventDefault();
              if(!d.parent.inBrushDrag) mousemove(this, d);
          })
          .on('mouseleave', function(d) {
              if(!d.parent.inBrushDrag) clearCursor();
          })
          .call(d3.behavior.drag()
              .on('dragstart', function(d) { dragstart(this, d); })
              .on('drag', function(d) { drag(this, d); })
              .on('dragend', function(d) { dragend(this, d); })
          );
  }
  
  function startAsc(a, b) { return a[0] - b[0]; }
  
  function renderAxisBrush(axisBrush) {
      var background = axisBrush.selectAll('.background').data(repeat);
  
      background.enter()
          .append('rect')
          .classed('background', true)
          .call(barHorizontalSetup)
          .call(backgroundBarHorizontalSetup)
          .style('pointer-events', 'auto') // parent pointer events are disabled; we must have it to register events
          .attr('transform', 'translate(0 ' + c.verticalPadding + ')');
  
      background
          .call(attachDragBehavior)
          .attr('height', function(d) {
              return d.height - c.verticalPadding;
          });
  
      var highlightShadow = axisBrush.selectAll('.highlight-shadow').data(repeat); // we have a set here, can't call it `extent`
  
      highlightShadow.enter()
          .append('line')
          .classed('highlight-shadow', true)
          .attr('x', -c.bar.width / 2)
          .attr('stroke-width', c.bar.width + c.bar.strokeWidth)
          .attr('stroke', c.bar.strokeColor)
          .attr('opacity', c.bar.strokeOpacity)
          .attr('stroke-linecap', 'butt');
  
      highlightShadow
          .attr('y1', function(d) { return d.height; })
          .call(styleHighlight);
  
      var highlight = axisBrush.selectAll('.highlight').data(repeat); // we have a set here, can't call it `extent`
  
      highlight.enter()
          .append('line')
          .classed('highlight', true)
          .attr('x', -c.bar.width / 2)
          .attr('stroke-width', c.bar.width - c.bar.strokeWidth)
          .attr('stroke', c.bar.fillColor)
          .attr('opacity', c.bar.fillOpacity)
          .attr('stroke-linecap', 'butt');
  
      highlight
          .attr('y1', function(d) { return d.height; })
          .call(styleHighlight);
  }
  
  function ensureAxisBrush(axisOverlays) {
      var axisBrush = axisOverlays.selectAll('.' + c.cn.axisBrush)
          .data(repeat, keyFun);
  
      axisBrush.enter()
          .append('g')
          .classed(c.cn.axisBrush, true);
  
      renderAxisBrush(axisBrush);
  }
  
  function getBrushExtent(brush) {
      return brush.svgBrush.extent.map(function(e) {return e.slice();});
  }
  
  function brushClear(brush) {
      brush.filterSpecified = false;
      brush.svgBrush.extent = [[-Infinity, Infinity]];
  }
  
  function axisBrushMoved(callback) {
      return function axisBrushMoved(dimension) {
          var brush = dimension.brush;
          var extent = getBrushExtent(brush);
          var newExtent = extent.slice();
          brush.filter.set(newExtent);
          callback();
      };
  }
  
  function dedupeRealRanges(intervals) {
      // Fuses elements of intervals if they overlap, yielding discontiguous intervals, results.length <= intervals.length
      // Currently uses closed intervals, ie. dedupeRealRanges([[400, 800], [300, 400]]) -> [300, 800]
      var queue = intervals.slice();
      var result = [];
      var currentInterval;
      var current = queue.shift();
      while(current) { // [].shift === undefined, so we don't descend into an empty array
          currentInterval = current.slice();
          while((current = queue.shift()) && current[0] <= /* right-open interval would need `<` */ currentInterval[1]) {
              currentInterval[1] = Math.max(currentInterval[1], current[1]);
          }
          result.push(currentInterval);
      }
  
      if(
          result.length === 1 &&
          result[0][0] > result[0][1]
      ) {
          // discard result
          result = [];
      }
  
      return result;
  }
  
  function makeFilter() {
      var filter = [];
      var consolidated;
      var bounds;
      return {
          set: function(a) {
              filter = a
                  .map(function(d) { return d.slice().sort(sortAsc); })
                  .sort(startAsc);
  
              // handle unselected case
              if(filter.length === 1 &&
                  filter[0][0] === -Infinity &&
                  filter[0][1] === Infinity) {
                  filter = [[0, -1]];
              }
  
              consolidated = dedupeRealRanges(filter);
              bounds = filter.reduce(function(p, n) {
                  return [Math.min(p[0], n[0]), Math.max(p[1], n[1])];
              }, [Infinity, -Infinity]);
          },
          get: function() { return filter.slice(); },
          getConsolidated: function() { return consolidated; },
          getBounds: function() { return bounds; }
      };
  }
  
  function makeBrush(state, rangeSpecified, initialRange, brushStartCallback, brushCallback, brushEndCallback) {
      var filter = makeFilter();
      filter.set(initialRange);
      return {
          filter: filter,
          filterSpecified: rangeSpecified, // there's a difference between not filtering and filtering a non-proper subset
          svgBrush: {
              extent: [], // this is where the svgBrush writes contents into
              brushStartCallback: brushStartCallback,
              brushCallback: axisBrushMoved(brushCallback),
              brushEndCallback: brushEndCallback
          }
      };
  }
  
  // for use by supplyDefaults, but it needed tons of pieces from here so
  // seemed to make more sense just to put the whole routine here
  function cleanRanges(ranges, dimension) {
      if(Array.isArray(ranges[0])) {
          ranges = ranges.map(function(ri) { return ri.sort(sortAsc); });
  
          if(!dimension.multiselect) ranges = [ranges[0]];
          else ranges = dedupeRealRanges(ranges.sort(startAsc));
      } else ranges = [ranges.sort(sortAsc)];
  
      // ordinal snapping
      if(dimension.tickvals) {
          var sortedTickVals = dimension.tickvals.slice().sort(sortAsc);
          ranges = ranges.map(function(ri) {
              var rSnapped = [
                  ordinalScaleSnap(0, sortedTickVals, ri[0], []),
                  ordinalScaleSnap(1, sortedTickVals, ri[1], [])
              ];
              if(rSnapped[1] > rSnapped[0]) return rSnapped;
          })
          .filter(function(ri) { return ri; });
  
          if(!ranges.length) return;
      }
      return ranges.length > 1 ? ranges : ranges[0];
  }
  
  module.exports = {
      makeBrush: makeBrush,
      ensureAxisBrush: ensureAxisBrush,
      cleanRanges: cleanRanges
  };
  
  },{"../../lib":750,"../../lib/gup":747,"./constants":1124,"d3":169}],1122:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
  var parcoordsPlot = _dereq_('./plot');
  var xmlnsNamespaces = _dereq_('../../constants/xmlns_namespaces');
  
  exports.name = 'parcoords';
  
  exports.plot = function(gd) {
      var calcData = getModuleCalcData(gd.calcdata, 'parcoords')[0];
      if(calcData.length) parcoordsPlot(gd, calcData);
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var hadParcoords = (oldFullLayout._has && oldFullLayout._has('parcoords'));
      var hasParcoords = (newFullLayout._has && newFullLayout._has('parcoords'));
  
      if(hadParcoords && !hasParcoords) {
          oldFullLayout._paperdiv.selectAll('.parcoords').remove();
          oldFullLayout._glimages.selectAll('*').remove();
      }
  };
  
  exports.toSVG = function(gd) {
      var imageRoot = gd._fullLayout._glimages;
      var root = d3.select(gd).selectAll('.svg-container');
      var canvases = root.filter(function(d, i) {return i === root.size() - 1;})
          .selectAll('.gl-canvas-context, .gl-canvas-focus');
  
      function canvasToImage() {
          var canvas = this;
          var imageData = canvas.toDataURL('image/png');
          var image = imageRoot.append('svg:image');
  
          image.attr({
              xmlns: xmlnsNamespaces.svg,
              'xlink:href': imageData,
              preserveAspectRatio: 'none',
              x: 0,
              y: 0,
              width: canvas.width,
              height: canvas.height
          });
      }
  
      canvases.each(canvasToImage);
  
      // Chrome / Safari bug workaround - browser apparently loses connection to the defined pattern
      // Without the workaround, these browsers 'lose' the filter brush styling (color etc.) after a snapshot
      // on a subsequent interaction.
      // Firefox works fine without this workaround
      window.setTimeout(function() {
          d3.selectAll('#filterBarPattern')
              .attr('id', 'filterBarPattern');
      }, 60);
  };
  
  },{"../../constants/xmlns_namespaces":726,"../../plots/get_data":836,"./plot":1131,"d3":169}],1123:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  var Colorscale = _dereq_('../../components/colorscale');
  var wrap = _dereq_('../../lib/gup').wrap;
  
  module.exports = function calc(gd, trace) {
      var lineColor;
      var cscale;
  
      if(Colorscale.hasColorscale(trace, 'line') && isArrayOrTypedArray(trace.line.color)) {
          lineColor = trace.line.color;
          cscale = Colorscale.extractOpts(trace.line).colorscale;
  
          Colorscale.calc(gd, trace, {
              vals: lineColor,
              containerStr: 'line',
              cLetter: 'c'
          });
      } else {
          lineColor = constHalf(trace._length);
          cscale = [[0, trace.line.color], [1, trace.line.color]];
      }
  
      return wrap({lineColor: lineColor, cscale: cscale});
  };
  
  function constHalf(len) {
      var out = new Array(len);
      for(var i = 0; i < len; i++) {
          out[i] = 0.5;
      }
      return out;
  }
  
  },{"../../components/colorscale":627,"../../lib":750,"../../lib/gup":747}],1124:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  
  module.exports = {
      maxDimensionCount: 60, // this cannot be increased without WebGL code refactoring
      overdrag: 45,
      verticalPadding: 2, // otherwise, horizontal lines on top or bottom are of lower width
      tickDistance: 50,
      canvasPixelRatio: 1,
      blockLineCount: 5000,
      layers: ['contextLineLayer', 'focusLineLayer', 'pickLineLayer'],
      axisTitleOffset: 28,
      axisExtentOffset: 10,
      deselectedLineColor: '#777',
      bar: {
          width: 4, // Visible width of the filter bar
          captureWidth: 10, // Mouse-sensitive width for interaction (Fitts law)
          fillColor: 'magenta', // Color of the filter bar fill
          fillOpacity: 1, // Filter bar fill opacity
          snapDuration: 150, // tween duration in ms for brush snap for ordinal axes
          snapRatio: 0.25, // ratio of bar extension relative to the distance between two adjacent ordinal values
          snapClose: 0.01, // fraction of inter-value distance to snap to the closer one, even if you're not over it
          strokeColor: 'white', // Color of the filter bar side lines
          strokeOpacity: 1, // Filter bar side stroke opacity
          strokeWidth: 1, // Filter bar side stroke width in pixels
          handleHeight: 8, // Height of the filter bar vertical resize areas on top and bottom
          handleOpacity: 1, // Opacity of the filter bar vertical resize areas on top and bottom
          handleOverlap: 0 // A larger than 0 value causes overlaps with the filter bar, represented as pixels
      },
      cn: {
          axisExtentText: 'axis-extent-text',
          parcoordsLineLayers: 'parcoords-line-layers',
          parcoordsLineLayer: 'parcoords-lines',
          parcoords: 'parcoords',
          parcoordsControlView: 'parcoords-control-view',
          yAxis: 'y-axis',
          axisOverlays: 'axis-overlays',
          axis: 'axis',
          axisHeading: 'axis-heading',
          axisTitle: 'axis-title',
          axisExtent: 'axis-extent',
          axisExtentTop: 'axis-extent-top',
          axisExtentTopText: 'axis-extent-top-text',
          axisExtentBottom: 'axis-extent-bottom',
          axisExtentBottomText: 'axis-extent-bottom-text',
          axisBrush: 'axis-brush'
      },
      id: {
          filterBarPattern: 'filter-bar-pattern'
  
      }
  };
  
  },{}],1125:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  var attributes = _dereq_('./attributes');
  var axisBrush = _dereq_('./axisbrush');
  var maxDimensionCount = _dereq_('./constants').maxDimensionCount;
  var mergeLength = _dereq_('./merge_length');
  
  function handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce) {
      var lineColor = coerce('line.color', defaultColor);
  
      if(hasColorscale(traceIn, 'line') && Lib.isArrayOrTypedArray(lineColor)) {
          if(lineColor.length) {
              coerce('line.colorscale');
              colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'line.', cLetter: 'c'});
              // TODO: I think it would be better to keep showing lines beyond the last line color
              // but I'm not sure what color to give these lines - probably black or white
              // depending on the background color?
              return lineColor.length;
          } else {
              traceOut.line.color = defaultColor;
          }
      }
      return Infinity;
  }
  
  function dimensionDefaults(dimensionIn, dimensionOut, parentOut, opts) {
      function coerce(attr, dflt) {
          return Lib.coerce(dimensionIn, dimensionOut, attributes.dimensions, attr, dflt);
      }
  
      var values = coerce('values');
      var visible = coerce('visible');
      if(!(values && values.length)) {
          visible = dimensionOut.visible = false;
      }
  
      if(visible) {
          coerce('label');
          coerce('tickvals');
          coerce('ticktext');
          coerce('tickformat');
          var range = coerce('range');
  
          dimensionOut._ax = {
              _id: 'y',
              type: 'linear',
              showexponent: 'all',
              exponentformat: 'B',
              range: range
          };
  
          Axes.setConvert(dimensionOut._ax, opts.layout);
  
          coerce('multiselect');
          var constraintRange = coerce('constraintrange');
          if(constraintRange) {
              dimensionOut.constraintrange = axisBrush.cleanRanges(constraintRange, dimensionOut);
          }
      }
  }
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var dimensionsIn = traceIn.dimensions;
      if(Array.isArray(dimensionsIn) && dimensionsIn.length > maxDimensionCount) {
          Lib.log('parcoords traces support up to ' + maxDimensionCount + ' dimensions at the moment');
          dimensionsIn.splice(maxDimensionCount);
      }
  
      var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
          name: 'dimensions',
          layout: layout,
          handleItemDefaults: dimensionDefaults
      });
  
      var len = handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
  
      handleDomainDefaults(traceOut, layout, coerce);
  
      if(!Array.isArray(dimensions) || !dimensions.length) {
          traceOut.visible = false;
      }
  
      mergeLength(traceOut, dimensions, 'values', len);
  
      // make default font size 10px (default is 12),
      // scale linearly with global font size
      var fontDflt = {
          family: layout.font.family,
          size: Math.round(layout.font.size / 1.2),
          color: layout.font.color
      };
  
      Lib.coerceFont(coerce, 'labelfont', fontDflt);
      Lib.coerceFont(coerce, 'tickfont', fontDflt);
      Lib.coerceFont(coerce, 'rangefont', fontDflt);
  
      coerce('labelangle');
      coerce('labelside');
  };
  
  },{"../../components/colorscale/defaults":625,"../../components/colorscale/helpers":626,"../../lib":750,"../../plots/array_container_defaults":794,"../../plots/cartesian/axes":799,"../../plots/domain":826,"./attributes":1120,"./axisbrush":1121,"./constants":1124,"./merge_length":1129}],1126:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isTypedArray = _dereq_('../../lib').isTypedArray;
  
  exports.convertTypedArray = function(a) {
      return isTypedArray(a) ? Array.prototype.slice.call(a) : a;
  };
  
  exports.isOrdinal = function(dimension) {
      return !!dimension.tickvals;
  };
  
  exports.isVisible = function(dimension) {
      return dimension.visible || !('visible' in dimension);
  };
  
  },{"../../lib":750}],1127:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      colorbar: {
          container: 'line',
          min: 'cmin',
          max: 'cmax'
      },
  
      moduleType: 'trace',
      name: 'parcoords',
      basePlotModule: _dereq_('./base_plot'),
      categories: ['gl', 'regl', 'noOpacity', 'noHover'],
      meta: {
          
      }
  };
  
  },{"./attributes":1120,"./base_plot":1122,"./calc":1123,"./defaults":1125,"./plot":1131}],1128:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var glslify = _dereq_('glslify');
  var vertexShaderSource = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nattribute vec4 p01_04, p05_08, p09_12, p13_16,\n               p17_20, p21_24, p25_28, p29_32,\n               p33_36, p37_40, p41_44, p45_48,\n               p49_52, p53_56, p57_60, colors;\n\nuniform mat4 dim0A, dim1A, dim0B, dim1B, dim0C, dim1C, dim0D, dim1D,\n             loA, hiA, loB, hiB, loC, hiC, loD, hiD;\n\nuniform vec2 resolution, viewBoxPos, viewBoxSize;\nuniform sampler2D mask, palette;\nuniform float maskHeight;\nuniform float drwLayer; // 0: context, 1: focus, 2: pick\nuniform vec4 contextColor;\n\nbool isPick    = (drwLayer > 1.5);\nbool isContext = (drwLayer < 0.5);\n\nconst vec4 ZEROS = vec4(0.0, 0.0, 0.0, 0.0);\nconst vec4 UNITS = vec4(1.0, 1.0, 1.0, 1.0);\n\nfloat val(mat4 p, mat4 v) {\n    return dot(matrixCompMult(p, v) * UNITS, UNITS);\n}\n\nfloat axisY(float ratio, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float y1 = val(A, dim0A) + val(B, dim0B) + val(C, dim0C) + val(D, dim0D);\n    float y2 = val(A, dim1A) + val(B, dim1B) + val(C, dim1C) + val(D, dim1D);\n    return y1 * (1.0 - ratio) + y2 * ratio;\n}\n\nint iMod(int a, int b) {\n    return a - b * (a / b);\n}\n\nbool fOutside(float p, float lo, float hi) {\n    return (lo < hi) && (lo > p || p > hi);\n}\n\nbool vOutside(vec4 p, vec4 lo, vec4 hi) {\n    return (\n        fOutside(p[0], lo[0], hi[0]) ||\n        fOutside(p[1], lo[1], hi[1]) ||\n        fOutside(p[2], lo[2], hi[2]) ||\n        fOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool mOutside(mat4 p, mat4 lo, mat4 hi) {\n    return (\n        vOutside(p[0], lo[0], hi[0]) ||\n        vOutside(p[1], lo[1], hi[1]) ||\n        vOutside(p[2], lo[2], hi[2]) ||\n        vOutside(p[3], lo[3], hi[3])\n    );\n}\n\nbool outsideBoundingBox(mat4 A, mat4 B, mat4 C, mat4 D) {\n    return mOutside(A, loA, hiA) ||\n           mOutside(B, loB, hiB) ||\n           mOutside(C, loC, hiC) ||\n           mOutside(D, loD, hiD);\n}\n\nbool outsideRasterMask(mat4 A, mat4 B, mat4 C, mat4 D) {\n    mat4 pnts[4];\n    pnts[0] = A;\n    pnts[1] = B;\n    pnts[2] = C;\n    pnts[3] = D;\n\n    for(int i = 0; i < 4; ++i) {\n        for(int j = 0; j < 4; ++j) {\n            for(int k = 0; k < 4; ++k) {\n                if(0 == iMod(\n                    int(255.0 * texture2D(mask,\n                        vec2(\n                            (float(i * 2 + j / 2) + 0.5) / 8.0,\n                            (pnts[i][j][k] * (maskHeight - 1.0) + 1.0) / maskHeight\n                        ))[3]\n                    ) / int(pow(2.0, float(iMod(j * 4 + k, 8)))),\n                    2\n                )) return true;\n            }\n        }\n    }\n    return false;\n}\n\nvec4 position(bool isContext, float v, mat4 A, mat4 B, mat4 C, mat4 D) {\n    float x = 0.5 * sign(v) + 0.5;\n    float y = axisY(x, A, B, C, D);\n    float z = 1.0 - abs(v);\n\n    z += isContext ? 0.0 : 2.0 * float(\n        outsideBoundingBox(A, B, C, D) ||\n        outsideRasterMask(A, B, C, D)\n    );\n\n    return vec4(\n        2.0 * (vec2(x, y) * viewBoxSize + viewBoxPos) / resolution - 1.0,\n        z,\n        1.0\n    );\n}\n\nvoid main() {\n    mat4 A = mat4(p01_04, p05_08, p09_12, p13_16);\n    mat4 B = mat4(p17_20, p21_24, p25_28, p29_32);\n    mat4 C = mat4(p33_36, p37_40, p41_44, p45_48);\n    mat4 D = mat4(p49_52, p53_56, p57_60, ZEROS);\n\n    float v = colors[3];\n\n    gl_Position = position(isContext, v, A, B, C, D);\n\n    fragColor =\n        isContext ? vec4(contextColor) :\n        isPick ? vec4(colors.rgb, 1.0) : texture2D(palette, vec2(abs(v), 0.5));\n}\n"]);
  var fragmentShaderSource = glslify(["precision highp float;\n#define GLSLIFY 1\n\nvarying vec4 fragColor;\n\nvoid main() {\n    gl_FragColor = fragColor;\n}\n"]);
  var maxDim = _dereq_('./constants').maxDimensionCount;
  
  var Lib = _dereq_('../../lib');
  
  // don't change; otherwise near/far plane lines are lost
  var depthLimitEpsilon = 1e-6;
  
  // precision of multiselect is the full range divided into this many parts
  var maskHeight = 2048;
  
  var dummyPixel = new Uint8Array(4);
  var dataPixel = new Uint8Array(4);
  
  var paletteTextureConfig = {
      shape: [256, 1],
      format: 'rgba',
      type: 'uint8',
      mag: 'nearest',
      min: 'nearest'
  };
  
  function ensureDraw(regl) {
      regl.read({
          x: 0,
          y: 0,
          width: 1,
          height: 1,
          data: dummyPixel
      });
  }
  
  function clear(regl, x, y, width, height) {
      var gl = regl._gl;
      gl.enable(gl.SCISSOR_TEST);
      gl.scissor(x, y, width, height);
      regl.clear({color: [0, 0, 0, 0], depth: 1}); // clearing is done in scissored panel only
  }
  
  function renderBlock(regl, glAes, renderState, blockLineCount, sampleCount, item) {
      var rafKey = item.key;
  
      function render(blockNumber) {
          var count = Math.min(blockLineCount, sampleCount - blockNumber * blockLineCount);
  
          if(blockNumber === 0) {
              // stop drawing possibly stale glyphs before clearing
              window.cancelAnimationFrame(renderState.currentRafs[rafKey]);
              delete renderState.currentRafs[rafKey];
              clear(regl, item.scissorX, item.scissorY, item.scissorWidth, item.viewBoxSize[1]);
          }
  
          if(renderState.clearOnly) {
              return;
          }
  
          item.count = 2 * count;
          item.offset = 2 * blockNumber * blockLineCount;
          glAes(item);
  
          if(blockNumber * blockLineCount + count < sampleCount) {
              renderState.currentRafs[rafKey] = window.requestAnimationFrame(function() {
                  render(blockNumber + 1);
              });
          }
  
          renderState.drawCompleted = false;
      }
  
      if(!renderState.drawCompleted) {
          ensureDraw(regl);
          renderState.drawCompleted = true;
      }
  
      // start with rendering item 0; recursion handles the rest
      render(0);
  }
  
  function adjustDepth(d) {
      // WebGL matrix operations use floats with limited precision, potentially causing a number near a border of [0, 1]
      // to end up slightly outside the border. With an epsilon, we reduce the chance that a line gets clipped by the
      // near or the far plane.
      return Math.max(depthLimitEpsilon, Math.min(1 - depthLimitEpsilon, d));
  }
  
  function palette(unitToColor, opacity) {
      var result = new Array(256);
      for(var i = 0; i < 256; i++) {
          result[i] = unitToColor(i / 255).concat(opacity);
      }
      return result;
  }
  
  // Maps the sample index [0...sampleCount - 1] to a range of [0, 1] as the shader expects colors in the [0, 1] range.
  // but first it shifts the sample index by 0, 8 or 16 bits depending on rgbIndex [0..2]
  // with the end result that each line will be of a unique color, making it possible for the pick handler
  // to uniquely identify which line is hovered over (bijective mapping).
  // The inverse, i.e. readPixel is invoked from 'parcoords.js'
  function calcPickColor(i, rgbIndex) {
      return (i >>> 8 * rgbIndex) % 256 / 255;
  }
  
  function makePoints(sampleCount, dims, color) {
      var points = new Array(sampleCount * (maxDim + 4));
      var n = 0;
      for(var i = 0; i < sampleCount; i++) {
          for(var k = 0; k < maxDim; k++) {
              points[n++] = (k < dims.length) ? dims[k].paddedUnitValues[i] : 0.5;
          }
          points[n++] = calcPickColor(i, 2);
          points[n++] = calcPickColor(i, 1);
          points[n++] = calcPickColor(i, 0);
          points[n++] = adjustDepth(color[i]);
      }
      return points;
  }
  
  function makeVecAttr(vecIndex, sampleCount, points) {
      var pointPairs = new Array(sampleCount * 8);
      var n = 0;
      for(var i = 0; i < sampleCount; i++) {
          for(var j = 0; j < 2; j++) {
              for(var k = 0; k < 4; k++) {
                  var q = vecIndex * 4 + k;
                  var v = points[i * 64 + q];
                  if(q === 63 && j === 0) {
                      v *= -1;
                  }
                  pointPairs[n++] = v;
              }
          }
      }
      return pointPairs;
  }
  
  function pad2(num) {
      var s = '0' + num;
      return s.substr(s.length - 2);
  }
  
  function getAttrName(i) {
      return (i < maxDim) ? 'p' + pad2(i + 1) + '_' + pad2(i + 4) : 'colors';
  }
  
  function setAttributes(attributes, sampleCount, points) {
      for(var i = 0; i <= maxDim; i += 4) {
          attributes[getAttrName(i)](makeVecAttr(i / 4, sampleCount, points));
      }
  }
  
  function emptyAttributes(regl) {
      var attributes = {};
      for(var i = 0; i <= maxDim; i += 4) {
          attributes[getAttrName(i)] = regl.buffer({usage: 'dynamic', type: 'float', data: new Uint8Array(0)});
      }
      return attributes;
  }
  
  function makeItem(model, leftmost, rightmost, itemNumber, i0, i1, x, y, panelSizeX, panelSizeY, crossfilterDimensionIndex, drwLayer, constraints) {
      var dims = [[], []];
      for(var k = 0; k < 64; k++) {
          dims[0][k] = (k === i0) ? 1 : 0;
          dims[1][k] = (k === i1) ? 1 : 0;
      }
  
      var overdrag = model.lines.canvasOverdrag;
      var domain = model.domain;
      var canvasWidth = model.canvasWidth;
      var canvasHeight = model.canvasHeight;
  
      var deselectedLinesColor = model.deselectedLines.color;
  
      var itemModel = Lib.extendFlat({
          key: crossfilterDimensionIndex,
          resolution: [canvasWidth, canvasHeight],
          viewBoxPos: [x + overdrag, y],
          viewBoxSize: [panelSizeX, panelSizeY],
          i0: i0,
          i1: i1,
  
          dim0A: dims[0].slice(0, 16),
          dim0B: dims[0].slice(16, 32),
          dim0C: dims[0].slice(32, 48),
          dim0D: dims[0].slice(48, 64),
          dim1A: dims[1].slice(0, 16),
          dim1B: dims[1].slice(16, 32),
          dim1C: dims[1].slice(32, 48),
          dim1D: dims[1].slice(48, 64),
  
          drwLayer: drwLayer,
          contextColor: [
              deselectedLinesColor[0] / 255,
              deselectedLinesColor[1] / 255,
              deselectedLinesColor[2] / 255,
              deselectedLinesColor[3] < 1 ?
                  deselectedLinesColor[3] :
                  Math.max(1 / 255, Math.pow(1 / model.lines.color.length, 1 / 3))
          ],
  
          scissorX: (itemNumber === leftmost ? 0 : x + overdrag) + (model.pad.l - overdrag) + model.layoutWidth * domain.x[0],
          scissorWidth: (itemNumber === rightmost ? canvasWidth - x + overdrag : panelSizeX + 0.5) + (itemNumber === leftmost ? x + overdrag : 0),
          scissorY: y + model.pad.b + model.layoutHeight * domain.y[0],
          scissorHeight: panelSizeY,
  
          viewportX: model.pad.l - overdrag + model.layoutWidth * domain.x[0],
          viewportY: model.pad.b + model.layoutHeight * domain.y[0],
          viewportWidth: canvasWidth,
          viewportHeight: canvasHeight
      }, constraints);
  
      return itemModel;
  }
  
  function expandedPixelRange(bounds) {
      var dh = maskHeight - 1;
      var a = Math.max(0, Math.floor(bounds[0] * dh), 0);
      var b = Math.min(dh, Math.ceil(bounds[1] * dh), dh);
      return [
          Math.min(a, b),
          Math.max(a, b)
      ];
  }
  
  module.exports = function(canvasGL, d) {
      // context & pick describe which canvas we're talking about - won't change with new data
      var isContext = d.context;
      var isPick = d.pick;
  
      var regl = d.regl;
  
      var renderState = {
          currentRafs: {},
          drawCompleted: true,
          clearOnly: false
      };
  
      // state to be set by update and used later
      var model;
      var vm;
      var initialDims;
      var sampleCount;
      var attributes = emptyAttributes(regl);
      var maskTexture;
      var paletteTexture = regl.texture(paletteTextureConfig);
  
      var prevAxisOrder = [];
  
      update(d);
  
      var glAes = regl({
  
          profile: false,
  
          blend: {
              enable: isContext,
              func: {
                  srcRGB: 'src alpha',
                  dstRGB: 'one minus src alpha',
                  srcAlpha: 1,
                  dstAlpha: 1 // 'one minus src alpha'
              },
              equation: {
                  rgb: 'add',
                  alpha: 'add'
              },
              color: [0, 0, 0, 0]
          },
  
          depth: {
              enable: !isContext,
              mask: true,
              func: 'less',
              range: [0, 1]
          },
  
          // for polygons
          cull: {
              enable: true,
              face: 'back'
          },
  
          scissor: {
              enable: true,
              box: {
                  x: regl.prop('scissorX'),
                  y: regl.prop('scissorY'),
                  width: regl.prop('scissorWidth'),
                  height: regl.prop('scissorHeight')
              }
          },
  
          viewport: {
              x: regl.prop('viewportX'),
              y: regl.prop('viewportY'),
              width: regl.prop('viewportWidth'),
              height: regl.prop('viewportHeight')
          },
  
          dither: false,
  
          vert: vertexShaderSource,
  
          frag: fragmentShaderSource,
  
          primitive: 'lines',
          lineWidth: 1,
          attributes: attributes,
          uniforms: {
              resolution: regl.prop('resolution'),
              viewBoxPos: regl.prop('viewBoxPos'),
              viewBoxSize: regl.prop('viewBoxSize'),
              dim0A: regl.prop('dim0A'),
              dim1A: regl.prop('dim1A'),
              dim0B: regl.prop('dim0B'),
              dim1B: regl.prop('dim1B'),
              dim0C: regl.prop('dim0C'),
              dim1C: regl.prop('dim1C'),
              dim0D: regl.prop('dim0D'),
              dim1D: regl.prop('dim1D'),
              loA: regl.prop('loA'),
              hiA: regl.prop('hiA'),
              loB: regl.prop('loB'),
              hiB: regl.prop('hiB'),
              loC: regl.prop('loC'),
              hiC: regl.prop('hiC'),
              loD: regl.prop('loD'),
              hiD: regl.prop('hiD'),
              palette: paletteTexture,
              contextColor: regl.prop('contextColor'),
              mask: regl.prop('maskTexture'),
              drwLayer: regl.prop('drwLayer'),
              maskHeight: regl.prop('maskHeight')
          },
          offset: regl.prop('offset'),
          count: regl.prop('count')
      });
  
      function update(dNew) {
          model = dNew.model;
          vm = dNew.viewModel;
          initialDims = vm.dimensions.slice();
          sampleCount = initialDims[0] ? initialDims[0].values.length : 0;
  
          var lines = model.lines;
          var color = isPick ? lines.color.map(function(_, i) {return i / lines.color.length;}) : lines.color;
  
          var points = makePoints(sampleCount, initialDims, color);
          setAttributes(attributes, sampleCount, points);
  
          if(!isContext && !isPick) {
              paletteTexture = regl.texture(Lib.extendFlat({
                  data: palette(model.unitToColor, 255)
              }, paletteTextureConfig));
          }
      }
  
      function makeConstraints(isContext) {
          var i, j, k;
  
          var limits = [[], []];
          for(k = 0; k < 64; k++) {
              var p = (!isContext && k < initialDims.length) ?
                  initialDims[k].brush.filter.getBounds() : [-Infinity, Infinity];
  
              limits[0][k] = p[0];
              limits[1][k] = p[1];
          }
  
          var len = maskHeight * 8;
          var mask = new Array(len);
          for(i = 0; i < len; i++) {
              mask[i] = 255;
          }
          if(!isContext) {
              for(i = 0; i < initialDims.length; i++) {
                  var u = i % 8;
                  var v = (i - u) / 8;
                  var bitMask = Math.pow(2, u);
                  var dim = initialDims[i];
                  var ranges = dim.brush.filter.get();
                  if(ranges.length < 2) continue; // bail if the bounding box based filter is sufficient
  
                  var prevEnd = expandedPixelRange(ranges[0])[1];
                  for(j = 1; j < ranges.length; j++) {
                      var nextRange = expandedPixelRange(ranges[j]);
                      for(k = prevEnd + 1; k < nextRange[0]; k++) {
                          mask[k * 8 + v] &= ~bitMask;
                      }
                      prevEnd = Math.max(prevEnd, nextRange[1]);
                  }
              }
          }
  
          var textureData = {
              // 8 units x 8 bits = 64 bits, just sufficient for the almost 64 dimensions we support
              shape: [8, maskHeight],
              format: 'alpha',
              type: 'uint8',
              mag: 'nearest',
              min: 'nearest',
              data: mask
          };
          if(maskTexture) maskTexture(textureData);
          else maskTexture = regl.texture(textureData);
  
          return {
              maskTexture: maskTexture,
              maskHeight: maskHeight,
              loA: limits[0].slice(0, 16),
              loB: limits[0].slice(16, 32),
              loC: limits[0].slice(32, 48),
              loD: limits[0].slice(48, 64),
              hiA: limits[1].slice(0, 16),
              hiB: limits[1].slice(16, 32),
              hiC: limits[1].slice(32, 48),
              hiD: limits[1].slice(48, 64),
          };
      }
  
      function renderGLParcoords(panels, setChanged, clearOnly) {
          var panelCount = panels.length;
          var i;
  
          var leftmost;
          var rightmost;
          var lowestX = Infinity;
          var highestX = -Infinity;
  
          for(i = 0; i < panelCount; i++) {
              if(panels[i].dim0.canvasX < lowestX) {
                  lowestX = panels[i].dim0.canvasX;
                  leftmost = i;
              }
              if(panels[i].dim1.canvasX > highestX) {
                  highestX = panels[i].dim1.canvasX;
                  rightmost = i;
              }
          }
  
          if(panelCount === 0) {
              // clear canvas here, as the panel iteration below will not enter the loop body
              clear(regl, 0, 0, model.canvasWidth, model.canvasHeight);
          }
          var constraints = makeConstraints(isContext);
  
          for(i = 0; i < panelCount; i++) {
              var p = panels[i];
              var i0 = p.dim0.crossfilterDimensionIndex;
              var i1 = p.dim1.crossfilterDimensionIndex;
              var x = p.canvasX;
              var y = p.canvasY;
              var nextX = x + p.panelSizeX;
              if(setChanged ||
                  !prevAxisOrder[i0] ||
                  prevAxisOrder[i0][0] !== x ||
                  prevAxisOrder[i0][1] !== nextX
              ) {
                  prevAxisOrder[i0] = [x, nextX];
  
                  var item = makeItem(
                      model,
                      leftmost, rightmost, i, i0, i1, x, y,
                      p.panelSizeX, p.panelSizeY,
                      p.dim0.crossfilterDimensionIndex,
                      isContext ? 0 : isPick ? 2 : 1,
                      constraints
                  );
  
                  renderState.clearOnly = clearOnly;
  
                  var blockLineCount = setChanged ? model.lines.blockLineCount : sampleCount;
                  renderBlock(
                      regl, glAes, renderState, blockLineCount, sampleCount, item
                  );
              }
          }
      }
  
      function readPixel(canvasX, canvasY) {
          regl.read({
              x: canvasX,
              y: canvasY,
              width: 1,
              height: 1,
              data: dataPixel
          });
          return dataPixel;
      }
  
      function readPixels(canvasX, canvasY, width, height) {
          var pixelArray = new Uint8Array(4 * width * height);
          regl.read({
              x: canvasX,
              y: canvasY,
              width: width,
              height: height,
              data: pixelArray
          });
          return pixelArray;
      }
  
      function destroy() {
          canvasGL.style['pointer-events'] = 'none';
          paletteTexture.destroy();
          if(maskTexture) maskTexture.destroy();
          for(var k in attributes) attributes[k].destroy();
      }
  
      return {
          render: renderGLParcoords,
          readPixel: readPixel,
          readPixels: readPixels,
          destroy: destroy,
          update: update
      };
  };
  
  },{"../../lib":750,"./constants":1124,"glslify":413}],1129:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  /**
   * mergeLength: set trace length as the minimum of all dimension data lengths
   *     and propagates this length into each dimension
   *
   * @param {object} traceOut: the fullData trace
   * @param {Array(object)} dimensions: array of dimension objects
   * @param {string} dataAttr: the attribute of each dimension containing the data
   * @param {integer} len: an already-existing length from other attributes
   */
  module.exports = function(traceOut, dimensions, dataAttr, len) {
      if(!len) len = Infinity;
      var i, dimi;
      for(i = 0; i < dimensions.length; i++) {
          dimi = dimensions[i];
          if(dimi.visible) len = Math.min(len, dimi[dataAttr].length);
      }
      if(len === Infinity) len = 0;
  
      traceOut._length = len;
      for(i = 0; i < dimensions.length; i++) {
          dimi = dimensions[i];
          if(dimi.visible) dimi._length = len;
      }
  
      return len;
  };
  
  },{}],1130:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var rgba = _dereq_('color-rgba');
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var Drawing = _dereq_('../../components/drawing');
  var Colorscale = _dereq_('../../components/colorscale');
  
  var gup = _dereq_('../../lib/gup');
  var keyFun = gup.keyFun;
  var repeat = gup.repeat;
  var unwrap = gup.unwrap;
  
  var helpers = _dereq_('./helpers');
  var c = _dereq_('./constants');
  var brush = _dereq_('./axisbrush');
  var lineLayerMaker = _dereq_('./lines');
  
  function findExtreme(fn, values, len) {
      return Lib.aggNums(fn, null, values, len);
  }
  
  function findExtremes(values, len) {
      return fixExtremes(
          findExtreme(Math.min, values, len),
          findExtreme(Math.max, values, len)
      );
  }
  
  function dimensionExtent(dimension) {
      var range = dimension.range;
      return range ?
          fixExtremes(range[0], range[1]) :
          findExtremes(dimension.values, dimension._length);
  }
  
  function fixExtremes(lo, hi) {
      if(isNaN(lo) || !isFinite(lo)) {
          lo = 0;
      }
  
      if(isNaN(hi) || !isFinite(hi)) {
          hi = 0;
      }
  
      // avoid a degenerate (zero-width) domain
      if(lo === hi) {
          if(lo === 0) {
              // no use to multiplying zero, so add/subtract in this case
              lo -= 1;
              hi += 1;
          } else {
              // this keeps the range in the order of magnitude of the data
              lo *= 0.9;
              hi *= 1.1;
          }
      }
  
      return [lo, hi];
  }
  
  function toText(formatter, texts) {
      if(texts) {
          return function(v, i) {
              var text = texts[i];
              if(text === null || text === undefined) return formatter(v);
              return text;
          };
      }
      return formatter;
  }
  
  function domainScale(height, padding, dimension, tickvals, ticktext) {
      var extent = dimensionExtent(dimension);
      if(tickvals) {
          return d3.scale.ordinal()
              .domain(tickvals.map(toText(d3.format(dimension.tickformat), ticktext)))
              .range(tickvals
                  .map(function(d) {
                      var unitVal = (d - extent[0]) / (extent[1] - extent[0]);
                      return (height - padding + unitVal * (2 * padding - height));
                  })
              );
      }
      return d3.scale.linear()
          .domain(extent)
          .range([height - padding, padding]);
  }
  
  function unitToPaddedPx(height, padding) {
      return d3.scale.linear().range([padding, height - padding]);
  }
  
  function domainToPaddedUnitScale(dimension, padFraction) {
      return d3.scale.linear()
          .domain(dimensionExtent(dimension))
          .range([padFraction, 1 - padFraction]);
  }
  
  function ordinalScale(dimension) {
      if(!dimension.tickvals) return;
  
      var extent = dimensionExtent(dimension);
      return d3.scale.ordinal()
          .domain(dimension.tickvals)
          .range(dimension.tickvals.map(function(d) {
              return (d - extent[0]) / (extent[1] - extent[0]);
          }));
  }
  
  function unitToColorScale(cscale) {
      var colorStops = cscale.map(function(d) { return d[0]; });
      var colorTuples = cscale.map(function(d) {
          var RGBA = rgba(d[1]);
          return d3.rgb('rgb(' + RGBA[0] + ',' + RGBA[1] + ',' + RGBA[2] + ')');
      });
      var prop = function(n) { return function(o) { return o[n]; }; };
  
      // We can't use d3 color interpolation as we may have non-uniform color palette raster
      // (various color stop distances).
      var polylinearUnitScales = 'rgb'.split('').map(function(key) {
          return d3.scale.linear()
              .clamp(true)
              .domain(colorStops)
              .range(colorTuples.map(prop(key)));
      });
  
      return function(d) {
          return polylinearUnitScales.map(function(s) {
              return s(d);
          });
      };
  }
  
  function someFiltersActive(view) {
      return view.dimensions.some(function(p) {
          return p.brush.filterSpecified;
      });
  }
  
  function model(layout, d, i) {
      var cd0 = unwrap(d);
      var trace = cd0.trace;
      var lineColor = helpers.convertTypedArray(cd0.lineColor);
      var line = trace.line;
      var deselectedLines = {color: rgba(c.deselectedLineColor)};
      var cOpts = Colorscale.extractOpts(line);
      var cscale = cOpts.reversescale ? Colorscale.flipScale(cd0.cscale) : cd0.cscale;
      var domain = trace.domain;
      var dimensions = trace.dimensions;
      var width = layout.width;
      var labelAngle = trace.labelangle;
      var labelSide = trace.labelside;
      var labelFont = trace.labelfont;
      var tickFont = trace.tickfont;
      var rangeFont = trace.rangefont;
  
      var lines = Lib.extendDeepNoArrays({}, line, {
          color: lineColor.map(d3.scale.linear().domain(
              dimensionExtent({
                  values: lineColor,
                  range: [cOpts.min, cOpts.max],
                  _length: trace._length
              })
          )),
          blockLineCount: c.blockLineCount,
          canvasOverdrag: c.overdrag * c.canvasPixelRatio
      });
  
      var groupWidth = Math.floor(width * (domain.x[1] - domain.x[0]));
      var groupHeight = Math.floor(layout.height * (domain.y[1] - domain.y[0]));
  
      var pad = layout.margin || {l: 80, r: 80, t: 100, b: 80};
      var rowContentWidth = groupWidth;
      var rowHeight = groupHeight;
  
      return {
          key: i,
          colCount: dimensions.filter(helpers.isVisible).length,
          dimensions: dimensions,
          tickDistance: c.tickDistance,
          unitToColor: unitToColorScale(cscale),
          lines: lines,
          deselectedLines: deselectedLines,
          labelAngle: labelAngle,
          labelSide: labelSide,
          labelFont: labelFont,
          tickFont: tickFont,
          rangeFont: rangeFont,
          layoutWidth: width,
          layoutHeight: layout.height,
          domain: domain,
          translateX: domain.x[0] * width,
          translateY: layout.height - domain.y[1] * layout.height,
          pad: pad,
          canvasWidth: rowContentWidth * c.canvasPixelRatio + 2 * lines.canvasOverdrag,
          canvasHeight: rowHeight * c.canvasPixelRatio,
          width: rowContentWidth,
          height: rowHeight,
          canvasPixelRatio: c.canvasPixelRatio
      };
  }
  
  function viewModel(state, callbacks, model) {
      var width = model.width;
      var height = model.height;
      var dimensions = model.dimensions;
      var canvasPixelRatio = model.canvasPixelRatio;
  
      var xScale = function(d) {return width * d / Math.max(1, model.colCount - 1);};
  
      var unitPad = c.verticalPadding / height;
      var _unitToPaddedPx = unitToPaddedPx(height, c.verticalPadding);
  
      var vm = {
          key: model.key,
          xScale: xScale,
          model: model,
          inBrushDrag: false // consider factoring it out and putting it in a centralized global-ish gesture state object
      };
  
      var uniqueKeys = {};
  
      vm.dimensions = dimensions.filter(helpers.isVisible).map(function(dimension, i) {
          var domainToPaddedUnit = domainToPaddedUnitScale(dimension, unitPad);
          var foundKey = uniqueKeys[dimension.label];
          uniqueKeys[dimension.label] = (foundKey || 0) + 1;
          var key = dimension.label + (foundKey ? '__' + foundKey : '');
          var specifiedConstraint = dimension.constraintrange;
          var filterRangeSpecified = specifiedConstraint && specifiedConstraint.length;
          if(filterRangeSpecified && !Array.isArray(specifiedConstraint[0])) {
              specifiedConstraint = [specifiedConstraint];
          }
          var filterRange = filterRangeSpecified ?
              specifiedConstraint.map(function(d) { return d.map(domainToPaddedUnit); }) :
              [[-Infinity, Infinity]];
          var brushMove = function() {
              var p = vm;
              p.focusLayer && p.focusLayer.render(p.panels, true);
              var filtersActive = someFiltersActive(p);
              if(!state.contextShown() && filtersActive) {
                  p.contextLayer && p.contextLayer.render(p.panels, true);
                  state.contextShown(true);
              } else if(state.contextShown() && !filtersActive) {
                  p.contextLayer && p.contextLayer.render(p.panels, true, true);
                  state.contextShown(false);
              }
          };
  
          var truncatedValues = dimension.values;
          if(truncatedValues.length > dimension._length) {
              truncatedValues = truncatedValues.slice(0, dimension._length);
          }
  
          var tickvals = dimension.tickvals;
          var ticktext;
          function makeTickItem(v, i) { return {val: v, text: ticktext[i]}; }
          function sortTickItem(a, b) { return a.val - b.val; }
          if(Array.isArray(tickvals) && tickvals.length) {
              ticktext = dimension.ticktext;
  
              // ensure ticktext and tickvals have same length
              if(!Array.isArray(ticktext) || !ticktext.length) {
                  ticktext = tickvals.map(d3.format(dimension.tickformat));
              } else if(ticktext.length > tickvals.length) {
                  ticktext = ticktext.slice(0, tickvals.length);
              } else if(tickvals.length > ticktext.length) {
                  tickvals = tickvals.slice(0, ticktext.length);
              }
  
              // check if we need to sort tickvals/ticktext
              for(var j = 1; j < tickvals.length; j++) {
                  if(tickvals[j] < tickvals[j - 1]) {
                      var tickItems = tickvals.map(makeTickItem).sort(sortTickItem);
                      for(var k = 0; k < tickvals.length; k++) {
                          tickvals[k] = tickItems[k].val;
                          ticktext[k] = tickItems[k].text;
                      }
                      break;
                  }
              }
          } else tickvals = undefined;
  
          truncatedValues = helpers.convertTypedArray(truncatedValues);
  
          return {
              key: key,
              label: dimension.label,
              tickFormat: dimension.tickformat,
              tickvals: tickvals,
              ticktext: ticktext,
              ordinal: helpers.isOrdinal(dimension),
              multiselect: dimension.multiselect,
              xIndex: i,
              crossfilterDimensionIndex: i,
              visibleIndex: dimension._index,
              height: height,
              values: truncatedValues,
              paddedUnitValues: truncatedValues.map(domainToPaddedUnit),
              unitTickvals: tickvals && tickvals.map(domainToPaddedUnit),
              xScale: xScale,
              x: xScale(i),
              canvasX: xScale(i) * canvasPixelRatio,
              unitToPaddedPx: _unitToPaddedPx,
              domainScale: domainScale(height, c.verticalPadding, dimension, tickvals, ticktext),
              ordinalScale: ordinalScale(dimension),
              parent: vm,
              model: model,
              brush: brush.makeBrush(
                  state,
                  filterRangeSpecified,
                  filterRange,
                  function() {
                      state.linePickActive(false);
                  },
                  brushMove,
                  function(f) {
                      vm.focusLayer.render(vm.panels, true);
                      vm.pickLayer && vm.pickLayer.render(vm.panels, true);
                      state.linePickActive(true);
                      if(callbacks && callbacks.filterChanged) {
                          var invScale = domainToPaddedUnit.invert;
  
                          // update gd.data as if a Plotly.restyle were fired
                          var newRanges = f.map(function(r) {
                              return r.map(invScale).sort(Lib.sorterAsc);
                          }).sort(function(a, b) { return a[0] - b[0]; });
                          callbacks.filterChanged(vm.key, dimension._index, newRanges);
                      }
                  }
              )
          };
      });
  
      return vm;
  }
  
  function styleExtentTexts(selection) {
      selection
          .classed(c.cn.axisExtentText, true)
          .attr('text-anchor', 'middle')
          .style('cursor', 'default');
  }
  
  function parcoordsInteractionState() {
      var linePickActive = true;
      var contextShown = false;
      return {
          linePickActive: function(val) {return arguments.length ? linePickActive = !!val : linePickActive;},
          contextShown: function(val) {return arguments.length ? contextShown = !!val : contextShown;}
      };
  }
  
  function calcTilt(angle, position) {
      var dir = (position === 'top') ? 1 : -1;
      var radians = angle * Math.PI / 180;
      var dx = Math.sin(radians);
      var dy = Math.cos(radians);
      return {
          dir: dir,
          dx: dx,
          dy: dy,
          degrees: angle
      };
  }
  
  function updatePanelLayout(yAxis, vm) {
      var panels = vm.panels || (vm.panels = []);
      var data = yAxis.data();
      for(var i = 0; i < data.length - 1; i++) {
          var p = panels[i] || (panels[i] = {});
          var dim0 = data[i];
          var dim1 = data[i + 1];
          p.dim0 = dim0;
          p.dim1 = dim1;
          p.canvasX = dim0.canvasX;
          p.panelSizeX = dim1.canvasX - dim0.canvasX;
          p.panelSizeY = vm.model.canvasHeight;
          p.y = 0;
          p.canvasY = 0;
      }
  }
  
  function calcAllTicks(cd) {
      for(var i = 0; i < cd.length; i++) {
          for(var j = 0; j < cd[i].length; j++) {
              var trace = cd[i][j].trace;
              var dimensions = trace.dimensions;
  
              for(var k = 0; k < dimensions.length; k++) {
                  var values = dimensions[k].values;
                  var dim = dimensions[k]._ax;
  
                  if(dim) {
                      if(!dim.range) {
                          dim.range = findExtremes(values, trace._length);
                      } else {
                          dim.range = fixExtremes(dim.range[0], dim.range[1]);
                      }
  
                      if(!dim.dtick) {
                          dim.dtick = 0.01 * (Math.abs(dim.range[1] - dim.range[0]) || 1);
                      }
  
                      dim.tickformat = dimensions[k].tickformat;
                      Axes.calcTicks(dim);
                      dim.cleanRange();
                  }
              }
          }
      }
  }
  
  function linearFormat(dim, v) {
      return Axes.tickText(dim._ax, v, false).text;
  }
  
  function extremeText(d, isTop) {
      if(d.ordinal) return '';
      var domain = d.domainScale.domain();
      var v = (domain[isTop ? domain.length - 1 : 0]);
  
      return linearFormat(d.model.dimensions[d.visibleIndex], v);
  }
  
  
  module.exports = function parcoords(gd, cdModule, layout, callbacks) {
      var fullLayout = gd._fullLayout;
      var svg = fullLayout._toppaper;
      var glContainer = fullLayout._glcontainer;
  
      calcAllTicks(cdModule);
  
      var state = parcoordsInteractionState();
  
      var vm = cdModule
          .filter(function(d) { return unwrap(d).trace.visible; })
          .map(model.bind(0, layout))
          .map(viewModel.bind(0, state, callbacks));
  
      glContainer.each(function(d, i) {
          return Lib.extendFlat(d, vm[i]);
      });
  
      var glLayers = glContainer.selectAll('.gl-canvas')
          .each(function(d) {
              // FIXME: figure out how to handle multiple instances
              d.viewModel = vm[0];
              d.model = d.viewModel ? d.viewModel.model : null;
          });
  
      var lastHovered = null;
  
      var pickLayer = glLayers.filter(function(d) {return d.pick;});
  
      // emit hover / unhover event
      pickLayer
          .style('pointer-events', 'auto')
          .on('mousemove', function(d) {
              if(state.linePickActive() && d.lineLayer && callbacks && callbacks.hover) {
                  var event = d3.event;
                  var cw = this.width;
                  var ch = this.height;
                  var pointer = d3.mouse(this);
                  var x = pointer[0];
                  var y = pointer[1];
  
                  if(x < 0 || y < 0 || x >= cw || y >= ch) {
                      return;
                  }
                  var pixel = d.lineLayer.readPixel(x, ch - 1 - y);
                  var found = pixel[3] !== 0;
                  // inverse of the calcPickColor in `lines.js`; detailed comment there
                  var curveNumber = found ? pixel[2] + 256 * (pixel[1] + 256 * pixel[0]) : null;
                  var eventData = {
                      x: x,
                      y: y,
                      clientX: event.clientX,
                      clientY: event.clientY,
                      dataIndex: d.model.key,
                      curveNumber: curveNumber
                  };
                  if(curveNumber !== lastHovered) { // don't unnecessarily repeat the same hit (or miss)
                      if(found) {
                          callbacks.hover(eventData);
                      } else if(callbacks.unhover) {
                          callbacks.unhover(eventData);
                      }
                      lastHovered = curveNumber;
                  }
              }
          });
  
      glLayers
          .style('opacity', function(d) {return d.pick ? 0 : 1;});
  
      svg.style('background', 'rgba(255, 255, 255, 0)');
      var controlOverlay = svg.selectAll('.' + c.cn.parcoords)
          .data(vm, keyFun);
  
      controlOverlay.exit().remove();
  
      controlOverlay.enter()
          .append('g')
          .classed(c.cn.parcoords, true)
          .style('shape-rendering', 'crispEdges')
          .style('pointer-events', 'none');
  
      controlOverlay.attr('transform', function(d) {
          return 'translate(' + d.model.translateX + ',' + d.model.translateY + ')';
      });
  
      var parcoordsControlView = controlOverlay.selectAll('.' + c.cn.parcoordsControlView)
          .data(repeat, keyFun);
  
      parcoordsControlView.enter()
          .append('g')
          .classed(c.cn.parcoordsControlView, true);
  
      parcoordsControlView.attr('transform', function(d) {
          return 'translate(' + d.model.pad.l + ',' + d.model.pad.t + ')';
      });
  
      var yAxis = parcoordsControlView.selectAll('.' + c.cn.yAxis)
          .data(function(p) { return p.dimensions; }, keyFun);
  
      yAxis.enter()
          .append('g')
          .classed(c.cn.yAxis, true);
  
      parcoordsControlView.each(function(p) {
          updatePanelLayout(yAxis, p);
      });
  
      glLayers
          .each(function(d) {
              if(d.viewModel) {
                  if(!d.lineLayer || callbacks) { // recreate in case of having callbacks e.g. restyle. Should we test for callback to be a restyle?
                      d.lineLayer = lineLayerMaker(this, d);
                  } else d.lineLayer.update(d);
  
                  if(d.key || d.key === 0) d.viewModel[d.key] = d.lineLayer;
  
                  var setChanged = (!d.context || // don't update background
                                    callbacks);   // unless there is a callback on the context layer. Should we test the callback?
  
                  d.lineLayer.render(d.viewModel.panels, setChanged);
              }
          });
  
      yAxis.attr('transform', function(d) {
          return 'translate(' + d.xScale(d.xIndex) + ', 0)';
      });
  
      // drag column for reordering columns
      yAxis.call(d3.behavior.drag()
          .origin(function(d) { return d; })
          .on('drag', function(d) {
              var p = d.parent;
              state.linePickActive(false);
              d.x = Math.max(-c.overdrag, Math.min(d.model.width + c.overdrag, d3.event.x));
              d.canvasX = d.x * d.model.canvasPixelRatio;
              yAxis
                  .sort(function(a, b) { return a.x - b.x; })
                  .each(function(e, i) {
                      e.xIndex = i;
                      e.x = d === e ? e.x : e.xScale(e.xIndex);
                      e.canvasX = e.x * e.model.canvasPixelRatio;
                  });
  
              updatePanelLayout(yAxis, p);
  
              yAxis.filter(function(e) { return Math.abs(d.xIndex - e.xIndex) !== 0; })
                  .attr('transform', function(d) { return 'translate(' + d.xScale(d.xIndex) + ', 0)'; });
              d3.select(this).attr('transform', 'translate(' + d.x + ', 0)');
              yAxis.each(function(e, i0, i1) { if(i1 === d.parent.key) p.dimensions[i0] = e; });
              p.contextLayer && p.contextLayer.render(p.panels, false, !someFiltersActive(p));
              p.focusLayer.render && p.focusLayer.render(p.panels);
          })
          .on('dragend', function(d) {
              var p = d.parent;
              d.x = d.xScale(d.xIndex);
              d.canvasX = d.x * d.model.canvasPixelRatio;
              updatePanelLayout(yAxis, p);
              d3.select(this)
                  .attr('transform', function(d) { return 'translate(' + d.x + ', 0)'; });
              p.contextLayer && p.contextLayer.render(p.panels, false, !someFiltersActive(p));
              p.focusLayer && p.focusLayer.render(p.panels);
              p.pickLayer && p.pickLayer.render(p.panels, true);
              state.linePickActive(true);
  
              if(callbacks && callbacks.axesMoved) {
                  callbacks.axesMoved(p.key, p.dimensions.map(function(e) {return e.crossfilterDimensionIndex;}));
              }
          })
      );
  
      yAxis.exit()
          .remove();
  
      var axisOverlays = yAxis.selectAll('.' + c.cn.axisOverlays)
          .data(repeat, keyFun);
  
      axisOverlays.enter()
          .append('g')
          .classed(c.cn.axisOverlays, true);
  
      axisOverlays.selectAll('.' + c.cn.axis).remove();
  
      var axis = axisOverlays.selectAll('.' + c.cn.axis)
          .data(repeat, keyFun);
  
      axis.enter()
          .append('g')
          .classed(c.cn.axis, true);
  
      axis
          .each(function(d) {
              var wantedTickCount = d.model.height / d.model.tickDistance;
              var scale = d.domainScale;
              var sdom = scale.domain();
              d3.select(this)
                  .call(d3.svg.axis()
                      .orient('left')
                      .tickSize(4)
                      .outerTickSize(2)
                      .ticks(wantedTickCount, d.tickFormat) // works for continuous scales only...
                      .tickValues(d.ordinal ? // and this works for ordinal scales
                          sdom :
                          null)
                      .tickFormat(function(v) {
                          return helpers.isOrdinal(d) ? v : linearFormat(d.model.dimensions[d.visibleIndex], v);
                      })
                      .scale(scale));
              Drawing.font(axis.selectAll('text'), d.model.tickFont);
          });
  
      axis.selectAll('.domain, .tick>line')
          .attr('fill', 'none')
          .attr('stroke', 'black')
          .attr('stroke-opacity', 0.25)
          .attr('stroke-width', '1px');
  
      axis.selectAll('text')
          .style('text-shadow', '1px 1px 1px #fff, -1px -1px 1px #fff, 1px -1px 1px #fff, -1px 1px 1px #fff')
          .style('cursor', 'default');
  
      var axisHeading = axisOverlays.selectAll('.' + c.cn.axisHeading)
          .data(repeat, keyFun);
  
      axisHeading.enter()
          .append('g')
          .classed(c.cn.axisHeading, true);
  
      var axisTitle = axisHeading.selectAll('.' + c.cn.axisTitle)
          .data(repeat, keyFun);
  
      axisTitle.enter()
          .append('text')
          .classed(c.cn.axisTitle, true)
          .attr('text-anchor', 'middle')
          .style('cursor', 'ew-resize')
          .style('pointer-events', 'auto');
  
      axisTitle
          .text(function(d) { return d.label; })
          .each(function(d) {
              var e = d3.select(this);
              Drawing.font(e, d.model.labelFont);
              svgTextUtils.convertToTspans(e, gd);
          })
          .attr('transform', function(d) {
              var tilt = calcTilt(d.model.labelAngle, d.model.labelSide);
              var r = c.axisTitleOffset;
              return (
                  (tilt.dir > 0 ? '' : 'translate(0,' + (2 * r + d.model.height) + ')') +
                  'rotate(' + tilt.degrees + ')' +
                  'translate(' + (-r * tilt.dx) + ',' + (-r * tilt.dy) + ')'
              );
          })
          .attr('text-anchor', function(d) {
              var tilt = calcTilt(d.model.labelAngle, d.model.labelSide);
              var adx = Math.abs(tilt.dx);
              var ady = Math.abs(tilt.dy);
  
              if(2 * adx > ady) {
                  return (tilt.dir * tilt.dx < 0) ? 'start' : 'end';
              } else {
                  return 'middle';
              }
          });
  
      var axisExtent = axisOverlays.selectAll('.' + c.cn.axisExtent)
          .data(repeat, keyFun);
  
      axisExtent.enter()
          .append('g')
          .classed(c.cn.axisExtent, true);
  
      var axisExtentTop = axisExtent.selectAll('.' + c.cn.axisExtentTop)
          .data(repeat, keyFun);
  
      axisExtentTop.enter()
          .append('g')
          .classed(c.cn.axisExtentTop, true);
  
      axisExtentTop
          .attr('transform', 'translate(' + 0 + ',' + -c.axisExtentOffset + ')');
  
      var axisExtentTopText = axisExtentTop.selectAll('.' + c.cn.axisExtentTopText)
          .data(repeat, keyFun);
  
      axisExtentTopText.enter()
          .append('text')
          .classed(c.cn.axisExtentTopText, true)
          .call(styleExtentTexts);
  
      axisExtentTopText
          .text(function(d) { return extremeText(d, true); })
          .each(function(d) { Drawing.font(d3.select(this), d.model.rangeFont); });
  
      var axisExtentBottom = axisExtent.selectAll('.' + c.cn.axisExtentBottom)
          .data(repeat, keyFun);
  
      axisExtentBottom.enter()
          .append('g')
          .classed(c.cn.axisExtentBottom, true);
  
      axisExtentBottom
          .attr('transform', function(d) {
              return 'translate(' + 0 + ',' + (d.model.height + c.axisExtentOffset) + ')';
          });
  
      var axisExtentBottomText = axisExtentBottom.selectAll('.' + c.cn.axisExtentBottomText)
          .data(repeat, keyFun);
  
      axisExtentBottomText.enter()
          .append('text')
          .classed(c.cn.axisExtentBottomText, true)
          .attr('dy', '0.75em')
          .call(styleExtentTexts);
  
      axisExtentBottomText
          .text(function(d) { return extremeText(d, false); })
          .each(function(d) { Drawing.font(d3.select(this), d.model.rangeFont); });
  
      brush.ensureAxisBrush(axisOverlays);
  };
  
  },{"../../components/colorscale":627,"../../components/drawing":637,"../../lib":750,"../../lib/gup":747,"../../lib/svg_text_utils":774,"../../plots/cartesian/axes":799,"./axisbrush":1121,"./constants":1124,"./helpers":1126,"./lines":1128,"color-rgba":127,"d3":169}],1131:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var parcoords = _dereq_('./parcoords');
  var prepareRegl = _dereq_('../../lib/prepare_regl');
  var isVisible = _dereq_('./helpers').isVisible;
  
  function newIndex(visibleIndices, orig, dim) {
      var origIndex = orig.indexOf(dim);
      var currentIndex = visibleIndices.indexOf(origIndex);
      if(currentIndex === -1) {
          // invisible dimensions initially go to the end
          currentIndex += orig.length;
      }
      return currentIndex;
  }
  
  function sorter(visibleIndices, orig) {
      return function sorter(d1, d2) {
          return (
              newIndex(visibleIndices, orig, d1) -
              newIndex(visibleIndices, orig, d2)
          );
      };
  }
  
  module.exports = function plot(gd, cdModule) {
      var fullLayout = gd._fullLayout;
  
      var success = prepareRegl(gd);
      if(!success) return;
  
      var currentDims = {};
      var initialDims = {};
      var fullIndices = {};
      var inputIndices = {};
  
      var size = fullLayout._size;
  
      cdModule.forEach(function(d, i) {
          var trace = d[0].trace;
          fullIndices[i] = trace.index;
          var iIn = inputIndices[i] = trace._fullInput.index;
          currentDims[i] = gd.data[iIn].dimensions;
          initialDims[i] = gd.data[iIn].dimensions.slice();
      });
  
      var filterChanged = function(i, initialDimIndex, newRanges) {
          // Have updated `constraintrange` data on `gd.data` and raise `Plotly.restyle` event
          // without having to incur heavy UI blocking due to an actual `Plotly.restyle` call
  
          var dim = initialDims[i][initialDimIndex];
          var newConstraints = newRanges.map(function(r) { return r.slice(); });
  
          // Store constraint range in preGUI
          // This one doesn't work if it's stored in pieces in _storeDirectGUIEdit
          // because it's an array of variable dimensionality. So store the whole
          // thing at once manually.
          var aStr = 'dimensions[' + initialDimIndex + '].constraintrange';
          var preGUI = fullLayout._tracePreGUI[gd._fullData[fullIndices[i]]._fullInput.uid];
          if(preGUI[aStr] === undefined) {
              var initialVal = dim.constraintrange;
              preGUI[aStr] = initialVal || null;
          }
  
          var fullDimension = gd._fullData[fullIndices[i]].dimensions[initialDimIndex];
  
          if(!newConstraints.length) {
              delete dim.constraintrange;
              delete fullDimension.constraintrange;
              newConstraints = null;
          } else {
              if(newConstraints.length === 1) newConstraints = newConstraints[0];
              dim.constraintrange = newConstraints;
              fullDimension.constraintrange = newConstraints.slice();
              // wrap in another array for restyle event data
              newConstraints = [newConstraints];
          }
  
          var restyleData = {};
          restyleData[aStr] = newConstraints;
          gd.emit('plotly_restyle', [restyleData, [inputIndices[i]]]);
      };
  
      var hover = function(eventData) {
          gd.emit('plotly_hover', eventData);
      };
  
      var unhover = function(eventData) {
          gd.emit('plotly_unhover', eventData);
      };
  
      var axesMoved = function(i, visibleIndices) {
          // Have updated order data on `gd.data` and raise `Plotly.restyle` event
          // without having to incur heavy UI blocking due to an actual `Plotly.restyle` call
  
          // drag&drop sorting of the visible dimensions
          var orig = sorter(visibleIndices, initialDims[i].filter(isVisible));
          currentDims[i].sort(orig);
  
          // invisible dimensions are not interpreted in the context of drag&drop sorting as an invisible dimension
          // cannot be dragged; they're interspersed into their original positions by this subsequent merging step
          initialDims[i].filter(function(d) {return !isVisible(d);})
               .sort(function(d) {
                   // subsequent splicing to be done left to right, otherwise indices may be incorrect
                   return initialDims[i].indexOf(d);
               })
              .forEach(function(d) {
                  currentDims[i].splice(currentDims[i].indexOf(d), 1); // remove from the end
                  currentDims[i].splice(initialDims[i].indexOf(d), 0, d); // insert at original index
              });
  
          // TODO: we can't really store this part of the interaction state
          // directly as below, since it incudes data arrays. If we want to
          // persist column order we may have to do something special for this
          // case to just store the order itself.
          // Registry.call('_storeDirectGUIEdit',
          //     gd.data[inputIndices[i]],
          //     fullLayout._tracePreGUI[gd._fullData[fullIndices[i]]._fullInput.uid],
          //     {dimensions: currentDims[i]}
          // );
  
          gd.emit('plotly_restyle', [{dimensions: [currentDims[i]]}, [inputIndices[i]]]);
      };
  
      parcoords(
          gd,
          cdModule,
          { // layout
              width: size.w,
              height: size.h,
              margin: {
                  t: size.t,
                  r: size.r,
                  b: size.b,
                  l: size.l
              }
          },
          { // callbacks
              filterChanged: filterChanged,
              hover: hover,
              unhover: unhover,
              axesMoved: axesMoved
          }
      );
  };
  
  },{"../../lib/prepare_regl":763,"./helpers":1126,"./parcoords":1130}],1132:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var baseAttrs = _dereq_('../../plots/attributes');
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var colorAttrs = _dereq_('../../components/color/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var textFontAttrs = fontAttrs({
      editType: 'plot',
      arrayOk: true,
      colorEditType: 'plot',
      
  });
  
  module.exports = {
      labels: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      // equivalent of x0 and dx, if label is missing
      label0: {
          valType: 'number',
          
          dflt: 0,
          editType: 'calc',
          
      },
      dlabel: {
          valType: 'number',
          
          dflt: 1,
          editType: 'calc',
          
      },
  
      values: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      marker: {
          colors: {
              valType: 'data_array',  // TODO 'color_array' ?
              editType: 'calc',
              
          },
  
          line: {
              color: {
                  valType: 'color',
                  
                  dflt: colorAttrs.defaultLine,
                  arrayOk: true,
                  editType: 'style',
                  
              },
              width: {
                  valType: 'number',
                  
                  min: 0,
                  dflt: 0,
                  arrayOk: true,
                  editType: 'style',
                  
              },
              editType: 'calc'
          },
          editType: 'calc'
      },
  
      text: {
          valType: 'data_array',
          editType: 'plot',
          
      },
      hovertext: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          editType: 'style',
          
      },
  
  // 'see eg:'
  // 'https://www.e-education.psu.edu/natureofgeoinfo/sites/www.e-education.psu.edu.natureofgeoinfo/files/image/hisp_pies.gif',
  // '(this example involves a map too - may someday be a whole trace type',
  // 'of its own. but the point is the size of the whole pie is important.)'
      scalegroup: {
          valType: 'string',
          
          dflt: '',
          editType: 'calc',
          
      },
  
      // labels (legend is handled by plots.attributes.showlegend and layout.hiddenlabels)
      textinfo: {
          valType: 'flaglist',
          
          flags: ['label', 'text', 'value', 'percent'],
          extras: ['none'],
          editType: 'calc',
          
      },
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['label', 'text', 'value', 'percent', 'name']
      }),
      hovertemplate: hovertemplateAttrs({}, {
          keys: ['label', 'color', 'value', 'percent', 'text']
      }),
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: ['label', 'color', 'value', 'percent', 'text']
      }),
      textposition: {
          valType: 'enumerated',
          
          values: ['inside', 'outside', 'auto', 'none'],
          dflt: 'auto',
          arrayOk: true,
          editType: 'plot',
          
      },
      textfont: extendFlat({}, textFontAttrs, {
          
      }),
      insidetextorientation: {
          valType: 'enumerated',
          
          values: ['horizontal', 'radial', 'tangential', 'auto'],
          dflt: 'auto',
          editType: 'plot',
          
      },
      insidetextfont: extendFlat({}, textFontAttrs, {
          
      }),
      outsidetextfont: extendFlat({}, textFontAttrs, {
          
      }),
      automargin: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'plot',
          
      },
  
      title: {
          text: {
              valType: 'string',
              dflt: '',
              
              editType: 'plot',
              
          },
          font: extendFlat({}, textFontAttrs, {
              
          }),
          position: {
              valType: 'enumerated',
              values: [
                  'top left', 'top center', 'top right',
                  'middle center',
                  'bottom left', 'bottom center', 'bottom right'
              ],
              
              editType: 'plot',
              
          },
  
          editType: 'plot'
      },
  
      // position and shape
      domain: domainAttrs({name: 'pie', trace: true, editType: 'calc'}),
  
      hole: {
          valType: 'number',
          
          min: 0,
          max: 1,
          dflt: 0,
          editType: 'calc',
          
      },
  
      // ordering and direction
      sort: {
          valType: 'boolean',
          
          dflt: true,
          editType: 'calc',
          
      },
      direction: {
          /**
           * there are two common conventions, both of which place the first
           * (largest, if sorted) slice with its left edge at 12 o'clock but
           * succeeding slices follow either cw or ccw from there.
           *
           * see http://visage.co/data-visualization-101-pie-charts/
           */
          valType: 'enumerated',
          values: ['clockwise', 'counterclockwise'],
          
          dflt: 'counterclockwise',
          editType: 'calc',
          
      },
      rotation: {
          valType: 'number',
          
          min: -360,
          max: 360,
          dflt: 0,
          editType: 'calc',
          
      },
  
      pull: {
          valType: 'number',
          
          min: 0,
          max: 1,
          dflt: 0,
          arrayOk: true,
          editType: 'calc',
          
      },
  
      _deprecated: {
          title: {
              valType: 'string',
              dflt: '',
              
              editType: 'calc',
              
          },
          titlefont: extendFlat({}, textFontAttrs, {
              
          }),
          titleposition: {
              valType: 'enumerated',
              values: [
                  'top left', 'top center', 'top right',
                  'middle center',
                  'bottom left', 'bottom center', 'bottom right'
              ],
              
              editType: 'calc',
              
          }
      }
  };
  
  },{"../../components/color/attributes":614,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/domain":826,"../../plots/font_attributes":827,"../../plots/template_attributes":877}],1133:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var plots = _dereq_('../../plots/plots');
  
  exports.name = 'pie';
  
  exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
      plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
  };
  
  },{"../../plots/plots":862}],1134:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var tinycolor = _dereq_('tinycolor2');
  
  var Color = _dereq_('../../components/color');
  
  var extendedColorWayList = {};
  
  function calc(gd, trace) {
      var cd = [];
  
      var fullLayout = gd._fullLayout;
      var hiddenLabels = fullLayout.hiddenlabels || [];
  
      var labels = trace.labels;
      var colors = trace.marker.colors || [];
      var vals = trace.values;
      var len = trace._length;
      var hasValues = trace._hasValues && len;
  
      var i, pt;
  
      if(trace.dlabel) {
          labels = new Array(len);
          for(i = 0; i < len; i++) {
              labels[i] = String(trace.label0 + i * trace.dlabel);
          }
      }
  
      var allThisTraceLabels = {};
      var pullColor = makePullColorFn(fullLayout['_' + trace.type + 'colormap']);
      var vTotal = 0;
      var isAggregated = false;
  
      for(i = 0; i < len; i++) {
          var v, label, hidden;
          if(hasValues) {
              v = vals[i];
              if(!isNumeric(v)) continue;
              v = +v;
              if(v < 0) continue;
          } else v = 1;
  
          label = labels[i];
          if(label === undefined || label === '') label = i;
          label = String(label);
  
          var thisLabelIndex = allThisTraceLabels[label];
          if(thisLabelIndex === undefined) {
              allThisTraceLabels[label] = cd.length;
  
              hidden = hiddenLabels.indexOf(label) !== -1;
  
              if(!hidden) vTotal += v;
  
              cd.push({
                  v: v,
                  label: label,
                  color: pullColor(colors[i], label),
                  i: i,
                  pts: [i],
                  hidden: hidden
              });
          } else {
              isAggregated = true;
  
              pt = cd[thisLabelIndex];
              pt.v += v;
              pt.pts.push(i);
              if(!pt.hidden) vTotal += v;
  
              if(pt.color === false && colors[i]) {
                  pt.color = pullColor(colors[i], label);
              }
          }
      }
  
      var shouldSort = (trace.type === 'funnelarea') ? isAggregated : trace.sort;
      if(shouldSort) cd.sort(function(a, b) { return b.v - a.v; });
  
      // include the sum of all values in the first point
      if(cd[0]) cd[0].vTotal = vTotal;
  
      return cd;
  }
  
  function makePullColorFn(colorMap) {
      return function pullColor(color, id) {
          if(!color) return false;
  
          color = tinycolor(color);
          if(!color.isValid()) return false;
  
          color = Color.addOpacity(color, color.getAlpha());
          if(!colorMap[id]) colorMap[id] = color;
  
          return color;
      };
  }
  
  /*
   * `calc` filled in (and collated) explicit colors.
   * Now we need to propagate these explicit colors to other traces,
   * and fill in default colors.
   * This is done after sorting, so we pick defaults
   * in the order slices will be displayed
   */
  function crossTraceCalc(gd, plotinfo) { // TODO: should we name the second argument opts?
      var desiredType = (plotinfo || {}).type;
      if(!desiredType) desiredType = 'pie';
  
      var fullLayout = gd._fullLayout;
      var calcdata = gd.calcdata;
      var colorWay = fullLayout[desiredType + 'colorway'];
      var colorMap = fullLayout['_' + desiredType + 'colormap'];
  
      if(fullLayout['extend' + desiredType + 'colors']) {
          colorWay = generateExtendedColors(colorWay, extendedColorWayList);
      }
      var dfltColorCount = 0;
  
      for(var i = 0; i < calcdata.length; i++) {
          var cd = calcdata[i];
          var traceType = cd[0].trace.type;
          if(traceType !== desiredType) continue;
  
          for(var j = 0; j < cd.length; j++) {
              var pt = cd[j];
              if(pt.color === false) {
                  // have we seen this label and assigned a color to it in a previous trace?
                  if(colorMap[pt.label]) {
                      pt.color = colorMap[pt.label];
                  } else {
                      colorMap[pt.label] = pt.color = colorWay[dfltColorCount % colorWay.length];
                      dfltColorCount++;
                  }
              }
          }
      }
  }
  
  /**
   * pick a default color from the main default set, augmented by
   * itself lighter then darker before repeating
   */
  function generateExtendedColors(colorList, extendedColorWays) {
      var i;
      var colorString = JSON.stringify(colorList);
      var colors = extendedColorWays[colorString];
      if(!colors) {
          colors = colorList.slice();
  
          for(i = 0; i < colorList.length; i++) {
              colors.push(tinycolor(colorList[i]).lighten(20).toHexString());
          }
  
          for(i = 0; i < colorList.length; i++) {
              colors.push(tinycolor(colorList[i]).darken(20).toHexString());
          }
          extendedColorWays[colorString] = colors;
      }
  
      return colors;
  }
  
  module.exports = {
      calc: calc,
      crossTraceCalc: crossTraceCalc,
  
      makePullColorFn: makePullColorFn,
      generateExtendedColors: generateExtendedColors
  };
  
  },{"../../components/color":615,"fast-isnumeric":241,"tinycolor2":548}],1135:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
  var handleText = _dereq_('../bar/defaults').handleText;
  
  function handleLabelsAndValues(labels, values) {
      var hasLabels = Array.isArray(labels);
      var hasValues = Lib.isArrayOrTypedArray(values);
      var len = Math.min(
          hasLabels ? labels.length : Infinity,
          hasValues ? values.length : Infinity
      );
  
      if(!isFinite(len)) len = 0;
  
      if(len && hasValues) {
          var hasPositive;
          for(var i = 0; i < len; i++) {
              var v = values[i];
              if(isNumeric(v) && v > 0) {
                  hasPositive = true;
                  break;
              }
          }
          if(!hasPositive) len = 0;
      }
  
      return {
          hasLabels: hasLabels,
          hasValues: hasValues,
          len: len
      };
  }
  
  function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var labels = coerce('labels');
      var values = coerce('values');
  
      var res = handleLabelsAndValues(labels, values);
      var len = res.len;
      traceOut._hasLabels = res.hasLabels;
      traceOut._hasValues = res.hasValues;
  
      if(!traceOut._hasLabels &&
          traceOut._hasValues
      ) {
          coerce('label0');
          coerce('dlabel');
      }
  
      if(!len) {
          traceOut.visible = false;
          return;
      }
      traceOut._length = len;
  
      var lineWidth = coerce('marker.line.width');
      if(lineWidth) coerce('marker.line.color');
  
      coerce('marker.colors');
  
      coerce('scalegroup');
      // TODO: hole needs to be coerced to the same value within a scaleegroup
  
      var textData = coerce('text');
      var textTemplate = coerce('texttemplate');
      var textInfo;
      if(!textTemplate) textInfo = coerce('textinfo', Array.isArray(textData) ? 'text+percent' : 'percent');
  
      coerce('hovertext');
      coerce('hovertemplate');
  
      if(textTemplate || (textInfo && textInfo !== 'none')) {
          var textposition = coerce('textposition');
          handleText(traceIn, traceOut, layout, coerce, textposition, {
              moduleHasSelected: false,
              moduleHasUnselected: false,
              moduleHasConstrain: false,
              moduleHasCliponaxis: false,
              moduleHasTextangle: false,
              moduleHasInsideanchor: false
          });
  
          var hasBoth = Array.isArray(textposition) || textposition === 'auto';
          var hasOutside = hasBoth || textposition === 'outside';
          if(hasOutside) {
              coerce('automargin');
          }
  
          if(textposition === 'inside' || textposition === 'auto' || Array.isArray(textposition)) {
              coerce('insidetextorientation');
          }
      }
  
      handleDomainDefaults(traceOut, layout, coerce);
  
      var hole = coerce('hole');
      var title = coerce('title.text');
      if(title) {
          var titlePosition = coerce('title.position', hole ? 'middle center' : 'top center');
          if(!hole && titlePosition === 'middle center') traceOut.title.position = 'top center';
          Lib.coerceFont(coerce, 'title.font', layout.font);
      }
  
      coerce('sort');
      coerce('direction');
      coerce('rotation');
      coerce('pull');
  }
  
  module.exports = {
      handleLabelsAndValues: handleLabelsAndValues,
      supplyDefaults: supplyDefaults
  };
  
  },{"../../lib":750,"../../plots/domain":826,"../bar/defaults":896,"./attributes":1132,"fast-isnumeric":241}],1136:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var appendArrayMultiPointValues = _dereq_('../../components/fx/helpers').appendArrayMultiPointValues;
  
  // Note: like other eventData routines, this creates the data for hover/unhover/click events
  // but it has a different API and goes through a totally different pathway.
  // So to ensure it doesn't get misused, it's not attached to the Pie module.
  module.exports = function eventData(pt, trace) {
      var out = {
          curveNumber: trace.index,
          pointNumbers: pt.pts,
          data: trace._input,
          fullData: trace,
          label: pt.label,
          color: pt.color,
          value: pt.v,
          percent: pt.percent,
          text: pt.text,
  
          // pt.v (and pt.i below) for backward compatibility
          v: pt.v
      };
  
      // Only include pointNumber if it's unambiguous
      if(pt.pts.length === 1) out.pointNumber = out.i = pt.pts[0];
  
      // Add extra data arrays to the output
      // notice that this is the multi-point version ('s' on the end!)
      // so added data will be arrays matching the pointNumbers array.
      appendArrayMultiPointValues(out, trace, pt.pts);
  
      // don't include obsolete fields in new funnelarea traces
      if(trace.type === 'funnelarea') {
          delete out.v;
          delete out.i;
      }
  
      return out;
  };
  
  },{"../../components/fx/helpers":651}],1137:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  function format(vRounded) {
      return (
          vRounded.indexOf('e') !== -1 ? vRounded.replace(/[.]?0+e/, 'e') :
          vRounded.indexOf('.') !== -1 ? vRounded.replace(/[.]?0+$/, '') :
          vRounded
      );
  }
  
  exports.formatPiePercent = function formatPiePercent(v, separators) {
      var vRounded = format((v * 100).toPrecision(3));
      return Lib.numSeparate(vRounded, separators) + '%';
  };
  
  exports.formatPieValue = function formatPieValue(v, separators) {
      var vRounded = format(v.toPrecision(10));
      return Lib.numSeparate(vRounded, separators);
  };
  
  exports.getFirstFilled = function getFirstFilled(array, indices) {
      if(!Array.isArray(array)) return;
      for(var i = 0; i < indices.length; i++) {
          var v = array[indices[i]];
          if(v || v === 0 || v === '') return v;
      }
  };
  
  exports.castOption = function castOption(item, indices) {
      if(Array.isArray(item)) return exports.getFirstFilled(item, indices);
      else if(item) return item;
  };
  
  exports.getRotationAngle = function(rotation) {
      return (rotation === 'auto' ? 0 : rotation) * Math.PI / 180;
  };
  
  },{"../../lib":750}],1138:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults').supplyDefaults,
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
      layoutAttributes: _dereq_('./layout_attributes'),
  
      calc: _dereq_('./calc').calc,
      crossTraceCalc: _dereq_('./calc').crossTraceCalc,
  
      plot: _dereq_('./plot').plot,
      style: _dereq_('./style'),
      styleOne: _dereq_('./style_one'),
  
      moduleType: 'trace',
      name: 'pie',
      basePlotModule: _dereq_('./base_plot'),
      categories: ['pie-like', 'pie', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"./attributes":1132,"./base_plot":1133,"./calc":1134,"./defaults":1135,"./layout_attributes":1139,"./layout_defaults":1140,"./plot":1141,"./style":1142,"./style_one":1143}],1139:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      hiddenlabels: {
          valType: 'data_array',
          
          editType: 'calc',
          
      },
      piecolorway: {
          valType: 'colorlist',
          
          editType: 'calc',
          
      },
      extendpiecolors: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          
      }
  };
  
  },{}],1140:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var layoutAttributes = _dereq_('./layout_attributes');
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
  
      coerce('hiddenlabels');
      coerce('piecolorway', layoutOut.colorway);
      coerce('extendpiecolors');
  };
  
  },{"../../lib":750,"./layout_attributes":1139}],1141:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Plots = _dereq_('../../plots/plots');
  var Fx = _dereq_('../../components/fx');
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var uniformText = _dereq_('../bar/uniform_text');
  var recordMinTextSize = uniformText.recordMinTextSize;
  var clearMinTextSize = uniformText.clearMinTextSize;
  var TEXTPAD = _dereq_('../bar/constants').TEXTPAD;
  
  var helpers = _dereq_('./helpers');
  var eventData = _dereq_('./event_data');
  var isValidTextValue = _dereq_('../../lib').isValidTextValue;
  
  function plot(gd, cdModule) {
      var fullLayout = gd._fullLayout;
      var gs = fullLayout._size;
  
      clearMinTextSize('pie', fullLayout);
  
      prerenderTitles(cdModule, gd);
      layoutAreas(cdModule, gs);
  
      var plotGroups = Lib.makeTraceGroups(fullLayout._pielayer, cdModule, 'trace').each(function(cd) {
          var plotGroup = d3.select(this);
          var cd0 = cd[0];
          var trace = cd0.trace;
  
          setCoords(cd);
  
          // TODO: miter might look better but can sometimes cause problems
          // maybe miter with a small-ish stroke-miterlimit?
          plotGroup.attr('stroke-linejoin', 'round');
  
          plotGroup.each(function() {
              var slices = d3.select(this).selectAll('g.slice').data(cd);
  
              slices.enter().append('g')
                  .classed('slice', true);
              slices.exit().remove();
  
              var quadrants = [
                  [[], []], // y<0: x<0, x>=0
                  [[], []] // y>=0: x<0, x>=0
              ];
              var hasOutsideText = false;
  
              slices.each(function(pt, i) {
                  if(pt.hidden) {
                      d3.select(this).selectAll('path,g').remove();
                      return;
                  }
  
                  // to have consistent event data compared to other traces
                  pt.pointNumber = pt.i;
                  pt.curveNumber = trace.index;
  
                  quadrants[pt.pxmid[1] < 0 ? 0 : 1][pt.pxmid[0] < 0 ? 0 : 1].push(pt);
  
                  var cx = cd0.cx;
                  var cy = cd0.cy;
                  var sliceTop = d3.select(this);
                  var slicePath = sliceTop.selectAll('path.surface').data([pt]);
  
                  slicePath.enter().append('path')
                      .classed('surface', true)
                      .style({'pointer-events': 'all'});
  
                  sliceTop.call(attachFxHandlers, gd, cd);
  
                  if(trace.pull) {
                      var pull = +helpers.castOption(trace.pull, pt.pts) || 0;
                      if(pull > 0) {
                          cx += pull * pt.pxmid[0];
                          cy += pull * pt.pxmid[1];
                      }
                  }
  
                  pt.cxFinal = cx;
                  pt.cyFinal = cy;
  
                  function arc(start, finish, cw, scale) {
                      var dx = scale * (finish[0] - start[0]);
                      var dy = scale * (finish[1] - start[1]);
  
                      return 'a' +
                          (scale * cd0.r) + ',' + (scale * cd0.r) + ' 0 ' +
                          pt.largeArc + (cw ? ' 1 ' : ' 0 ') + dx + ',' + dy;
                  }
  
                  var hole = trace.hole;
                  if(pt.v === cd0.vTotal) { // 100% fails bcs arc start and end are identical
                      var outerCircle = 'M' + (cx + pt.px0[0]) + ',' + (cy + pt.px0[1]) +
                          arc(pt.px0, pt.pxmid, true, 1) +
                          arc(pt.pxmid, pt.px0, true, 1) + 'Z';
                      if(hole) {
                          slicePath.attr('d',
                              'M' + (cx + hole * pt.px0[0]) + ',' + (cy + hole * pt.px0[1]) +
                              arc(pt.px0, pt.pxmid, false, hole) +
                              arc(pt.pxmid, pt.px0, false, hole) +
                              'Z' + outerCircle);
                      } else slicePath.attr('d', outerCircle);
                  } else {
                      var outerArc = arc(pt.px0, pt.px1, true, 1);
  
                      if(hole) {
                          var rim = 1 - hole;
                          slicePath.attr('d',
                              'M' + (cx + hole * pt.px1[0]) + ',' + (cy + hole * pt.px1[1]) +
                              arc(pt.px1, pt.px0, false, hole) +
                              'l' + (rim * pt.px0[0]) + ',' + (rim * pt.px0[1]) +
                              outerArc +
                              'Z');
                      } else {
                          slicePath.attr('d',
                              'M' + cx + ',' + cy +
                              'l' + pt.px0[0] + ',' + pt.px0[1] +
                              outerArc +
                              'Z');
                      }
                  }
  
                  // add text
                  formatSliceLabel(gd, pt, cd0);
                  var textPosition = helpers.castOption(trace.textposition, pt.pts);
                  var sliceTextGroup = sliceTop.selectAll('g.slicetext')
                      .data(pt.text && (textPosition !== 'none') ? [0] : []);
  
                  sliceTextGroup.enter().append('g')
                      .classed('slicetext', true);
                  sliceTextGroup.exit().remove();
  
                  sliceTextGroup.each(function() {
                      var sliceText = Lib.ensureSingle(d3.select(this), 'text', '', function(s) {
                          // prohibit tex interpretation until we can handle
                          // tex and regular text together
                          s.attr('data-notex', 1);
                      });
  
                      var font = Lib.ensureUniformFontSize(gd, textPosition === 'outside' ?
                          determineOutsideTextFont(trace, pt, fullLayout.font) :
                          determineInsideTextFont(trace, pt, fullLayout.font)
                      );
  
                      sliceText.text(pt.text)
                          .attr({
                              'class': 'slicetext',
                              transform: '',
                              'text-anchor': 'middle'
                          })
                          .call(Drawing.font, font)
                          .call(svgTextUtils.convertToTspans, gd);
  
                      // position the text relative to the slice
                      var textBB = Drawing.bBox(sliceText.node());
                      var transform;
  
                      if(textPosition === 'outside') {
                          transform = transformOutsideText(textBB, pt);
                      } else {
                          transform = transformInsideText(textBB, pt, cd0);
                          if(textPosition === 'auto' && transform.scale < 1) {
                              var newFont = Lib.ensureUniformFontSize(gd, trace.outsidetextfont);
  
                              sliceText.call(Drawing.font, newFont);
                              textBB = Drawing.bBox(sliceText.node());
  
                              transform = transformOutsideText(textBB, pt);
                          }
                      }
  
                      var textPosAngle = transform.textPosAngle;
                      var textXY = textPosAngle === undefined ? pt.pxmid : getCoords(cd0.r, textPosAngle);
                      transform.targetX = cx + textXY[0] * transform.rCenter + (transform.x || 0);
                      transform.targetY = cy + textXY[1] * transform.rCenter + (transform.y || 0);
                      computeTransform(transform, textBB);
  
                      // save some stuff to use later ensure no labels overlap
                      if(transform.outside) {
                          var targetY = transform.targetY;
                          pt.yLabelMin = targetY - textBB.height / 2;
                          pt.yLabelMid = targetY;
                          pt.yLabelMax = targetY + textBB.height / 2;
                          pt.labelExtraX = 0;
                          pt.labelExtraY = 0;
                          hasOutsideText = true;
                      }
  
                      transform.fontSize = font.size;
                      recordMinTextSize(trace.type, transform, fullLayout);
                      cd[i].transform = transform;
  
                      sliceText.attr('transform', Lib.getTextTransform(transform));
                  });
              });
  
              // add the title
              var titleTextGroup = d3.select(this).selectAll('g.titletext')
                  .data(trace.title.text ? [0] : []);
  
              titleTextGroup.enter().append('g')
                  .classed('titletext', true);
              titleTextGroup.exit().remove();
  
              titleTextGroup.each(function() {
                  var titleText = Lib.ensureSingle(d3.select(this), 'text', '', function(s) {
                      // prohibit tex interpretation as above
                      s.attr('data-notex', 1);
                  });
  
                  var txt = trace.title.text;
                  if(trace._meta) {
                      txt = Lib.templateString(txt, trace._meta);
                  }
  
                  titleText.text(txt)
                      .attr({
                          'class': 'titletext',
                          transform: '',
                          'text-anchor': 'middle',
                      })
                  .call(Drawing.font, trace.title.font)
                  .call(svgTextUtils.convertToTspans, gd);
  
                  var transform;
  
                  if(trace.title.position === 'middle center') {
                      transform = positionTitleInside(cd0);
                  } else {
                      transform = positionTitleOutside(cd0, gs);
                  }
  
                  titleText.attr('transform',
                      'translate(' + transform.x + ',' + transform.y + ')' +
                      (transform.scale < 1 ? ('scale(' + transform.scale + ')') : '') +
                      'translate(' + transform.tx + ',' + transform.ty + ')');
              });
  
              // now make sure no labels overlap (at least within one pie)
              if(hasOutsideText) scootLabels(quadrants, trace);
  
              plotTextLines(slices, trace);
  
              if(hasOutsideText && trace.automargin) {
                  // TODO if we ever want to improve perf,
                  // we could reuse the textBB computed above together
                  // with the sliceText transform info
                  var traceBbox = Drawing.bBox(plotGroup.node());
  
                  var domain = trace.domain;
                  var vpw = gs.w * (domain.x[1] - domain.x[0]);
                  var vph = gs.h * (domain.y[1] - domain.y[0]);
                  var xgap = (0.5 * vpw - cd0.r) / gs.w;
                  var ygap = (0.5 * vph - cd0.r) / gs.h;
  
                  Plots.autoMargin(gd, 'pie.' + trace.uid + '.automargin', {
                      xl: domain.x[0] - xgap,
                      xr: domain.x[1] + xgap,
                      yb: domain.y[0] - ygap,
                      yt: domain.y[1] + ygap,
                      l: Math.max(cd0.cx - cd0.r - traceBbox.left, 0),
                      r: Math.max(traceBbox.right - (cd0.cx + cd0.r), 0),
                      b: Math.max(traceBbox.bottom - (cd0.cy + cd0.r), 0),
                      t: Math.max(cd0.cy - cd0.r - traceBbox.top, 0),
                      pad: 5
                  });
              }
          });
      });
  
      // This is for a bug in Chrome (as of 2015-07-22, and does not affect FF)
      // if insidetextfont and outsidetextfont are different sizes, sometimes the size
      // of an "em" gets taken from the wrong element at first so lines are
      // spaced wrong. You just have to tell it to try again later and it gets fixed.
      // I have no idea why we haven't seen this in other contexts. Also, sometimes
      // it gets the initial draw correct but on redraw it gets confused.
      setTimeout(function() {
          plotGroups.selectAll('tspan').each(function() {
              var s = d3.select(this);
              if(s.attr('dy')) s.attr('dy', s.attr('dy'));
          });
      }, 0);
  }
  
  // TODO add support for transition
  function plotTextLines(slices, trace) {
      slices.each(function(pt) {
          var sliceTop = d3.select(this);
  
          if(!pt.labelExtraX && !pt.labelExtraY) {
              sliceTop.select('path.textline').remove();
              return;
          }
  
          // first move the text to its new location
          var sliceText = sliceTop.select('g.slicetext text');
  
          pt.transform.targetX += pt.labelExtraX;
          pt.transform.targetY += pt.labelExtraY;
  
          sliceText.attr('transform', Lib.getTextTransform(pt.transform));
  
          // then add a line to the new location
          var lineStartX = pt.cxFinal + pt.pxmid[0];
          var lineStartY = pt.cyFinal + pt.pxmid[1];
          var textLinePath = 'M' + lineStartX + ',' + lineStartY;
          var finalX = (pt.yLabelMax - pt.yLabelMin) * (pt.pxmid[0] < 0 ? -1 : 1) / 4;
  
          if(pt.labelExtraX) {
              var yFromX = pt.labelExtraX * pt.pxmid[1] / pt.pxmid[0];
              var yNet = pt.yLabelMid + pt.labelExtraY - (pt.cyFinal + pt.pxmid[1]);
  
              if(Math.abs(yFromX) > Math.abs(yNet)) {
                  textLinePath +=
                      'l' + (yNet * pt.pxmid[0] / pt.pxmid[1]) + ',' + yNet +
                      'H' + (lineStartX + pt.labelExtraX + finalX);
              } else {
                  textLinePath += 'l' + pt.labelExtraX + ',' + yFromX +
                      'v' + (yNet - yFromX) +
                      'h' + finalX;
              }
          } else {
              textLinePath +=
                  'V' + (pt.yLabelMid + pt.labelExtraY) +
                  'h' + finalX;
          }
  
          Lib.ensureSingle(sliceTop, 'path', 'textline')
              .call(Color.stroke, trace.outsidetextfont.color)
              .attr({
                  'stroke-width': Math.min(2, trace.outsidetextfont.size / 8),
                  d: textLinePath,
                  fill: 'none'
              });
      });
  }
  
  function attachFxHandlers(sliceTop, gd, cd) {
      var cd0 = cd[0];
      var trace = cd0.trace;
      var cx = cd0.cx;
      var cy = cd0.cy;
  
      // hover state vars
      // have we drawn a hover label, so it should be cleared later
      if(!('_hasHoverLabel' in trace)) trace._hasHoverLabel = false;
      // have we emitted a hover event, so later an unhover event should be emitted
      // note that click events do not depend on this - you can still get them
      // with hovermode: false or if you were earlier dragging, then clicked
      // in the same slice that you moused up in
      if(!('_hasHoverEvent' in trace)) trace._hasHoverEvent = false;
  
      sliceTop.on('mouseover', function(pt) {
          // in case fullLayout or fullData has changed without a replot
          var fullLayout2 = gd._fullLayout;
          var trace2 = gd._fullData[trace.index];
  
          if(gd._dragging || fullLayout2.hovermode === false) return;
  
          var hoverinfo = trace2.hoverinfo;
          if(Array.isArray(hoverinfo)) {
              // super hacky: we need to pull out the *first* hoverinfo from
              // pt.pts, then put it back into an array in a dummy trace
              // and call castHoverinfo on that.
              // TODO: do we want to have Fx.castHoverinfo somehow handle this?
              // it already takes an array for index, for 2D, so this seems tricky.
              hoverinfo = Fx.castHoverinfo({
                  hoverinfo: [helpers.castOption(hoverinfo, pt.pts)],
                  _module: trace._module
              }, fullLayout2, 0);
          }
  
          if(hoverinfo === 'all') hoverinfo = 'label+text+value+percent+name';
  
          // in case we dragged over the pie from another subplot,
          // or if hover is turned off
          if(trace2.hovertemplate || (hoverinfo !== 'none' && hoverinfo !== 'skip' && hoverinfo)) {
              var rInscribed = pt.rInscribed || 0;
              var hoverCenterX = cx + pt.pxmid[0] * (1 - rInscribed);
              var hoverCenterY = cy + pt.pxmid[1] * (1 - rInscribed);
              var separators = fullLayout2.separators;
              var text = [];
  
              if(hoverinfo && hoverinfo.indexOf('label') !== -1) text.push(pt.label);
              pt.text = helpers.castOption(trace2.hovertext || trace2.text, pt.pts);
              if(hoverinfo && hoverinfo.indexOf('text') !== -1) {
                  var tx = pt.text;
                  if(Lib.isValidTextValue(tx)) text.push(tx);
              }
              pt.value = pt.v;
              pt.valueLabel = helpers.formatPieValue(pt.v, separators);
              if(hoverinfo && hoverinfo.indexOf('value') !== -1) text.push(pt.valueLabel);
              pt.percent = pt.v / cd0.vTotal;
              pt.percentLabel = helpers.formatPiePercent(pt.percent, separators);
              if(hoverinfo && hoverinfo.indexOf('percent') !== -1) text.push(pt.percentLabel);
  
              var hoverLabel = trace2.hoverlabel;
              var hoverFont = hoverLabel.font;
  
              Fx.loneHover({
                  trace: trace,
                  x0: hoverCenterX - rInscribed * cd0.r,
                  x1: hoverCenterX + rInscribed * cd0.r,
                  y: hoverCenterY,
                  text: text.join('<br>'),
                  name: (trace2.hovertemplate || hoverinfo.indexOf('name') !== -1) ? trace2.name : undefined,
                  idealAlign: pt.pxmid[0] < 0 ? 'left' : 'right',
                  color: helpers.castOption(hoverLabel.bgcolor, pt.pts) || pt.color,
                  borderColor: helpers.castOption(hoverLabel.bordercolor, pt.pts),
                  fontFamily: helpers.castOption(hoverFont.family, pt.pts),
                  fontSize: helpers.castOption(hoverFont.size, pt.pts),
                  fontColor: helpers.castOption(hoverFont.color, pt.pts),
                  nameLength: helpers.castOption(hoverLabel.namelength, pt.pts),
                  textAlign: helpers.castOption(hoverLabel.align, pt.pts),
                  hovertemplate: helpers.castOption(trace2.hovertemplate, pt.pts),
                  hovertemplateLabels: pt,
                  eventData: [eventData(pt, trace2)]
              }, {
                  container: fullLayout2._hoverlayer.node(),
                  outerContainer: fullLayout2._paper.node(),
                  gd: gd
              });
  
              trace._hasHoverLabel = true;
          }
  
          trace._hasHoverEvent = true;
          gd.emit('plotly_hover', {
              points: [eventData(pt, trace2)],
              event: d3.event
          });
      });
  
      sliceTop.on('mouseout', function(evt) {
          var fullLayout2 = gd._fullLayout;
          var trace2 = gd._fullData[trace.index];
          var pt = d3.select(this).datum();
  
          if(trace._hasHoverEvent) {
              evt.originalEvent = d3.event;
              gd.emit('plotly_unhover', {
                  points: [eventData(pt, trace2)],
                  event: d3.event
              });
              trace._hasHoverEvent = false;
          }
  
          if(trace._hasHoverLabel) {
              Fx.loneUnhover(fullLayout2._hoverlayer.node());
              trace._hasHoverLabel = false;
          }
      });
  
      sliceTop.on('click', function(pt) {
          // TODO: this does not support right-click. If we want to support it, we
          // would likely need to change pie to use dragElement instead of straight
          // mapbox event binding. Or perhaps better, make a simple wrapper with the
          // right mousedown, mousemove, and mouseup handlers just for a left/right click
          // mapbox would use this too.
          var fullLayout2 = gd._fullLayout;
          var trace2 = gd._fullData[trace.index];
  
          if(gd._dragging || fullLayout2.hovermode === false) return;
  
          gd._hoverdata = [eventData(pt, trace2)];
          Fx.click(gd, d3.event);
      });
  }
  
  function determineOutsideTextFont(trace, pt, layoutFont) {
      var color =
          helpers.castOption(trace.outsidetextfont.color, pt.pts) ||
          helpers.castOption(trace.textfont.color, pt.pts) ||
          layoutFont.color;
  
      var family =
          helpers.castOption(trace.outsidetextfont.family, pt.pts) ||
          helpers.castOption(trace.textfont.family, pt.pts) ||
          layoutFont.family;
  
      var size =
          helpers.castOption(trace.outsidetextfont.size, pt.pts) ||
          helpers.castOption(trace.textfont.size, pt.pts) ||
          layoutFont.size;
  
      return {
          color: color,
          family: family,
          size: size
      };
  }
  
  function determineInsideTextFont(trace, pt, layoutFont) {
      var customColor = helpers.castOption(trace.insidetextfont.color, pt.pts);
      if(!customColor && trace._input.textfont) {
          // Why not simply using trace.textfont? Because if not set, it
          // defaults to layout.font which has a default color. But if
          // textfont.color and insidetextfont.color don't supply a value,
          // a contrasting color shall be used.
          customColor = helpers.castOption(trace._input.textfont.color, pt.pts);
      }
  
      var family =
          helpers.castOption(trace.insidetextfont.family, pt.pts) ||
          helpers.castOption(trace.textfont.family, pt.pts) ||
          layoutFont.family;
  
      var size =
          helpers.castOption(trace.insidetextfont.size, pt.pts) ||
          helpers.castOption(trace.textfont.size, pt.pts) ||
          layoutFont.size;
  
      return {
          color: customColor || Color.contrast(pt.color),
          family: family,
          size: size
      };
  }
  
  function prerenderTitles(cdModule, gd) {
      var cd0, trace;
  
      // Determine the width and height of the title for each pie.
      for(var i = 0; i < cdModule.length; i++) {
          cd0 = cdModule[i][0];
          trace = cd0.trace;
  
          if(trace.title.text) {
              var txt = trace.title.text;
              if(trace._meta) {
                  txt = Lib.templateString(txt, trace._meta);
              }
  
              var dummyTitle = Drawing.tester.append('text')
                .attr('data-notex', 1)
                .text(txt)
                .call(Drawing.font, trace.title.font)
                .call(svgTextUtils.convertToTspans, gd);
              var bBox = Drawing.bBox(dummyTitle.node(), true);
              cd0.titleBox = {
                  width: bBox.width,
                  height: bBox.height,
              };
              dummyTitle.remove();
          }
      }
  }
  
  function transformInsideText(textBB, pt, cd0) {
      var r = cd0.r || pt.rpx1;
      var rInscribed = pt.rInscribed;
  
      var isEmpty = pt.startangle === pt.stopangle;
      if(isEmpty) {
          return {
              rCenter: 1 - rInscribed,
              scale: 0,
              rotate: 0,
              textPosAngle: 0
          };
      }
  
      var ring = pt.ring;
      var isCircle = (ring === 1) && (Math.abs(pt.startangle - pt.stopangle) === Math.PI * 2);
  
      var halfAngle = pt.halfangle;
      var midAngle = pt.midangle;
  
      var orientation = cd0.trace.insidetextorientation;
      var isHorizontal = orientation === 'horizontal';
      var isTangential = orientation === 'tangential';
      var isRadial = orientation === 'radial';
      var isAuto = orientation === 'auto';
  
      var allTransforms = [];
      var newT;
  
      if(!isAuto) {
          // max size if text is placed (horizontally) at the top or bottom of the arc
  
          var considerCrossing = function(angle, key) {
              if(isCrossing(pt, angle)) {
                  var dStart = Math.abs(angle - pt.startangle);
                  var dStop = Math.abs(angle - pt.stopangle);
  
                  var closestEdge = dStart < dStop ? dStart : dStop;
  
                  if(key === 'tan') {
                      newT = calcTanTransform(textBB, r, ring, closestEdge, 0);
                  } else { // case of 'rad'
                      newT = calcRadTransform(textBB, r, ring, closestEdge, Math.PI / 2);
                  }
                  newT.textPosAngle = angle;
  
                  allTransforms.push(newT);
              }
          };
  
          // to cover all cases with trace.rotation added
          var i;
          if(isHorizontal || isTangential) {
              // top
              for(i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * i, 'tan');
              // bottom
              for(i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * (i + 1), 'tan');
          }
          if(isHorizontal || isRadial) {
              // left
              for(i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * (i + 1.5), 'rad');
              // right
              for(i = 4; i >= -4; i -= 2) considerCrossing(Math.PI * (i + 0.5), 'rad');
          }
      }
  
      if(isCircle || isAuto || isHorizontal) {
          // max size text can be inserted inside without rotating it
          // this inscribes the text rectangle in a circle, which is then inscribed
          // in the slice, so it will be an underestimate, which some day we may want
          // to improve so this case can get more use
          var textDiameter = Math.sqrt(textBB.width * textBB.width + textBB.height * textBB.height);
  
          newT = {
              scale: rInscribed * r * 2 / textDiameter,
  
              // and the center position and rotation in this case
              rCenter: 1 - rInscribed,
              rotate: 0
          };
  
          newT.textPosAngle = (pt.startangle + pt.stopangle) / 2;
          if(newT.scale >= 1) return newT;
  
          allTransforms.push(newT);
      }
  
      if(isAuto || isRadial) {
          newT = calcRadTransform(textBB, r, ring, halfAngle, midAngle);
          newT.textPosAngle = (pt.startangle + pt.stopangle) / 2;
          allTransforms.push(newT);
      }
  
      if(isAuto || isTangential) {
          newT = calcTanTransform(textBB, r, ring, halfAngle, midAngle);
          newT.textPosAngle = (pt.startangle + pt.stopangle) / 2;
          allTransforms.push(newT);
      }
  
      var id = 0;
      var maxScale = 0;
      for(var k = 0; k < allTransforms.length; k++) {
          var s = allTransforms[k].scale;
          if(maxScale < s) {
              maxScale = s;
              id = k;
          }
  
          if(!isAuto && maxScale >= 1) {
              // respect test order for non-auto options
              break;
          }
      }
      return allTransforms[id];
  }
  
  function isCrossing(pt, angle) {
      var start = pt.startangle;
      var stop = pt.stopangle;
      return (
          (start > angle && angle > stop) ||
          (start < angle && angle < stop)
      );
  }
  
  function calcRadTransform(textBB, r, ring, halfAngle, midAngle) {
      r = Math.max(0, r - 2 * TEXTPAD);
  
      // max size if text is rotated radially
      var a = textBB.width / textBB.height;
      var s = calcMaxHalfSize(a, halfAngle, r, ring);
      return {
          scale: s * 2 / textBB.height,
          rCenter: calcRCenter(a, s / r),
          rotate: calcRotate(midAngle)
      };
  }
  
  function calcTanTransform(textBB, r, ring, halfAngle, midAngle) {
      r = Math.max(0, r - 2 * TEXTPAD);
  
      // max size if text is rotated tangentially
      var a = textBB.height / textBB.width;
      var s = calcMaxHalfSize(a, halfAngle, r, ring);
      return {
          scale: s * 2 / textBB.width,
          rCenter: calcRCenter(a, s / r),
          rotate: calcRotate(midAngle + Math.PI / 2)
      };
  }
  
  function calcRCenter(a, b) {
      return Math.cos(b) - a * b;
  }
  
  function calcRotate(t) {
      return (180 / Math.PI * t + 720) % 180 - 90;
  }
  
  function calcMaxHalfSize(a, halfAngle, r, ring) {
      var q = a + 1 / (2 * Math.tan(halfAngle));
      return r * Math.min(
          1 / (Math.sqrt(q * q + 0.5) + q),
          ring / (Math.sqrt(a * a + ring / 2) + a)
      );
  }
  
  function getInscribedRadiusFraction(pt, cd0) {
      if(pt.v === cd0.vTotal && !cd0.trace.hole) return 1;// special case of 100% with no hole
  
      return Math.min(1 / (1 + 1 / Math.sin(pt.halfangle)), pt.ring / 2);
  }
  
  function transformOutsideText(textBB, pt) {
      var x = pt.pxmid[0];
      var y = pt.pxmid[1];
      var dx = textBB.width / 2;
      var dy = textBB.height / 2;
  
      if(x < 0) dx *= -1;
      if(y < 0) dy *= -1;
  
      return {
          scale: 1,
          rCenter: 1,
          rotate: 0,
          x: dx + Math.abs(dy) * (dx > 0 ? 1 : -1) / 2,
          y: dy / (1 + x * x / (y * y)),
          outside: true
      };
  }
  
  function positionTitleInside(cd0) {
      var textDiameter =
          Math.sqrt(cd0.titleBox.width * cd0.titleBox.width + cd0.titleBox.height * cd0.titleBox.height);
      return {
          x: cd0.cx,
          y: cd0.cy,
          scale: cd0.trace.hole * cd0.r * 2 / textDiameter,
          tx: 0,
          ty: - cd0.titleBox.height / 2 + cd0.trace.title.font.size
      };
  }
  
  function positionTitleOutside(cd0, plotSize) {
      var scaleX = 1;
      var scaleY = 1;
      var maxPull;
  
      var trace = cd0.trace;
      // position of the baseline point of the text box in the plot, before scaling.
      // we anchored the text in the middle, so the baseline is on the bottom middle
      // of the first line of text.
      var topMiddle = {
          x: cd0.cx,
          y: cd0.cy
      };
      // relative translation of the text box after scaling
      var translate = {
          tx: 0,
          ty: 0
      };
  
      // we reason below as if the baseline is the top middle point of the text box.
      // so we must add the font size to approximate the y-coord. of the top.
      // note that this correction must happen after scaling.
      translate.ty += trace.title.font.size;
      maxPull = getMaxPull(trace);
  
      if(trace.title.position.indexOf('top') !== -1) {
          topMiddle.y -= (1 + maxPull) * cd0.r;
          translate.ty -= cd0.titleBox.height;
      } else if(trace.title.position.indexOf('bottom') !== -1) {
          topMiddle.y += (1 + maxPull) * cd0.r;
      }
  
      var rx = applyAspectRatio(cd0.r, cd0.trace.aspectratio);
  
      var maxWidth = plotSize.w * (trace.domain.x[1] - trace.domain.x[0]) / 2;
      if(trace.title.position.indexOf('left') !== -1) {
          // we start the text at the left edge of the pie
          maxWidth = maxWidth + rx;
          topMiddle.x -= (1 + maxPull) * rx;
          translate.tx += cd0.titleBox.width / 2;
      } else if(trace.title.position.indexOf('center') !== -1) {
          maxWidth *= 2;
      } else if(trace.title.position.indexOf('right') !== -1) {
          maxWidth = maxWidth + rx;
          topMiddle.x += (1 + maxPull) * rx;
          translate.tx -= cd0.titleBox.width / 2;
      }
      scaleX = maxWidth / cd0.titleBox.width;
      scaleY = getTitleSpace(cd0, plotSize) / cd0.titleBox.height;
      return {
          x: topMiddle.x,
          y: topMiddle.y,
          scale: Math.min(scaleX, scaleY),
          tx: translate.tx,
          ty: translate.ty
      };
  }
  
  function applyAspectRatio(x, aspectratio) {
      return x / ((aspectratio === undefined) ? 1 : aspectratio);
  }
  
  function getTitleSpace(cd0, plotSize) {
      var trace = cd0.trace;
      var pieBoxHeight = plotSize.h * (trace.domain.y[1] - trace.domain.y[0]);
      // use at most half of the plot for the title
      return Math.min(cd0.titleBox.height, pieBoxHeight / 2);
  }
  
  function getMaxPull(trace) {
      var maxPull = trace.pull;
      if(!maxPull) return 0;
  
      var j;
      if(Array.isArray(maxPull)) {
          maxPull = 0;
          for(j = 0; j < trace.pull.length; j++) {
              if(trace.pull[j] > maxPull) maxPull = trace.pull[j];
          }
      }
      return maxPull;
  }
  
  function scootLabels(quadrants, trace) {
      var xHalf, yHalf, equatorFirst, farthestX, farthestY,
          xDiffSign, yDiffSign, thisQuad, oppositeQuad,
          wholeSide, i, thisQuadOutside, firstOppositeOutsidePt;
  
      function topFirst(a, b) { return a.pxmid[1] - b.pxmid[1]; }
      function bottomFirst(a, b) { return b.pxmid[1] - a.pxmid[1]; }
  
      function scootOneLabel(thisPt, prevPt) {
          if(!prevPt) prevPt = {};
  
          var prevOuterY = prevPt.labelExtraY + (yHalf ? prevPt.yLabelMax : prevPt.yLabelMin);
          var thisInnerY = yHalf ? thisPt.yLabelMin : thisPt.yLabelMax;
          var thisOuterY = yHalf ? thisPt.yLabelMax : thisPt.yLabelMin;
          var thisSliceOuterY = thisPt.cyFinal + farthestY(thisPt.px0[1], thisPt.px1[1]);
          var newExtraY = prevOuterY - thisInnerY;
  
          var xBuffer, i, otherPt, otherOuterY, otherOuterX, newExtraX;
  
          // make sure this label doesn't overlap other labels
          // this *only* has us move these labels vertically
          if(newExtraY * yDiffSign > 0) thisPt.labelExtraY = newExtraY;
  
          // make sure this label doesn't overlap any slices
          if(!Array.isArray(trace.pull)) return; // this can only happen with array pulls
  
          for(i = 0; i < wholeSide.length; i++) {
              otherPt = wholeSide[i];
  
              // overlap can only happen if the other point is pulled more than this one
              if(otherPt === thisPt || (
                  (helpers.castOption(trace.pull, thisPt.pts) || 0) >=
                  (helpers.castOption(trace.pull, otherPt.pts) || 0))
              ) {
                  continue;
              }
  
              if((thisPt.pxmid[1] - otherPt.pxmid[1]) * yDiffSign > 0) {
                  // closer to the equator - by construction all of these happen first
                  // move the text vertically to get away from these slices
                  otherOuterY = otherPt.cyFinal + farthestY(otherPt.px0[1], otherPt.px1[1]);
                  newExtraY = otherOuterY - thisInnerY - thisPt.labelExtraY;
  
                  if(newExtraY * yDiffSign > 0) thisPt.labelExtraY += newExtraY;
              } else if((thisOuterY + thisPt.labelExtraY - thisSliceOuterY) * yDiffSign > 0) {
                  // farther from the equator - happens after we've done all the
                  // vertical moving we're going to do
                  // move horizontally to get away from these more polar slices
  
                  // if we're moving horz. based on a slice that's several slices away from this one
                  // then we need some extra space for the lines to labels between them
                  xBuffer = 3 * xDiffSign * Math.abs(i - wholeSide.indexOf(thisPt));
  
                  otherOuterX = otherPt.cxFinal + farthestX(otherPt.px0[0], otherPt.px1[0]);
                  newExtraX = otherOuterX + xBuffer - (thisPt.cxFinal + thisPt.pxmid[0]) - thisPt.labelExtraX;
  
                  if(newExtraX * xDiffSign > 0) thisPt.labelExtraX += newExtraX;
              }
          }
      }
  
      for(yHalf = 0; yHalf < 2; yHalf++) {
          equatorFirst = yHalf ? topFirst : bottomFirst;
          farthestY = yHalf ? Math.max : Math.min;
          yDiffSign = yHalf ? 1 : -1;
  
          for(xHalf = 0; xHalf < 2; xHalf++) {
              farthestX = xHalf ? Math.max : Math.min;
              xDiffSign = xHalf ? 1 : -1;
  
              // first sort the array
              // note this is a copy of cd, so cd itself doesn't get sorted
              // but we can still modify points in place.
              thisQuad = quadrants[yHalf][xHalf];
              thisQuad.sort(equatorFirst);
  
              oppositeQuad = quadrants[1 - yHalf][xHalf];
              wholeSide = oppositeQuad.concat(thisQuad);
  
              thisQuadOutside = [];
              for(i = 0; i < thisQuad.length; i++) {
                  if(thisQuad[i].yLabelMid !== undefined) thisQuadOutside.push(thisQuad[i]);
              }
  
              firstOppositeOutsidePt = false;
              for(i = 0; yHalf && i < oppositeQuad.length; i++) {
                  if(oppositeQuad[i].yLabelMid !== undefined) {
                      firstOppositeOutsidePt = oppositeQuad[i];
                      break;
                  }
              }
  
              // each needs to avoid the previous
              for(i = 0; i < thisQuadOutside.length; i++) {
                  var prevPt = i && thisQuadOutside[i - 1];
                  // bottom half needs to avoid the first label of the top half
                  // top half we still need to call scootOneLabel on the first slice
                  // so we can avoid other slices, but we don't pass a prevPt
                  if(firstOppositeOutsidePt && !i) prevPt = firstOppositeOutsidePt;
                  scootOneLabel(thisQuadOutside[i], prevPt);
              }
          }
      }
  }
  
  function layoutAreas(cdModule, plotSize) {
      var scaleGroups = [];
  
      // figure out the center and maximum radius
      for(var i = 0; i < cdModule.length; i++) {
          var cd0 = cdModule[i][0];
          var trace = cd0.trace;
  
          var domain = trace.domain;
          var width = plotSize.w * (domain.x[1] - domain.x[0]);
          var height = plotSize.h * (domain.y[1] - domain.y[0]);
          // leave some space for the title, if it will be displayed outside
          if(trace.title.text && trace.title.position !== 'middle center') {
              height -= getTitleSpace(cd0, plotSize);
          }
  
          var rx = width / 2;
          var ry = height / 2;
          if(trace.type === 'funnelarea' && !trace.scalegroup) {
              ry /= trace.aspectratio;
          }
  
          cd0.r = Math.min(rx, ry) / (1 + getMaxPull(trace));
  
          cd0.cx = plotSize.l + plotSize.w * (trace.domain.x[1] + trace.domain.x[0]) / 2;
          cd0.cy = plotSize.t + plotSize.h * (1 - trace.domain.y[0]) - height / 2;
          if(trace.title.text && trace.title.position.indexOf('bottom') !== -1) {
              cd0.cy -= getTitleSpace(cd0, plotSize);
          }
  
          if(trace.scalegroup && scaleGroups.indexOf(trace.scalegroup) === -1) {
              scaleGroups.push(trace.scalegroup);
          }
      }
  
      groupScale(cdModule, scaleGroups);
  }
  
  function groupScale(cdModule, scaleGroups) {
      var cd0, i, trace;
  
      // scale those that are grouped
      for(var k = 0; k < scaleGroups.length; k++) {
          var min = Infinity;
          var g = scaleGroups[k];
  
          for(i = 0; i < cdModule.length; i++) {
              cd0 = cdModule[i][0];
              trace = cd0.trace;
  
              if(trace.scalegroup === g) {
                  var area;
                  if(trace.type === 'pie') {
                      area = cd0.r * cd0.r;
                  } else if(trace.type === 'funnelarea') {
                      var rx, ry;
  
                      if(trace.aspectratio > 1) {
                          rx = cd0.r;
                          ry = rx / trace.aspectratio;
                      } else {
                          ry = cd0.r;
                          rx = ry * trace.aspectratio;
                      }
  
                      rx *= (1 + trace.baseratio) / 2;
  
                      area = rx * ry;
                  }
  
                  min = Math.min(min, area / cd0.vTotal);
              }
          }
  
          for(i = 0; i < cdModule.length; i++) {
              cd0 = cdModule[i][0];
              trace = cd0.trace;
              if(trace.scalegroup === g) {
                  var v = min * cd0.vTotal;
                  if(trace.type === 'funnelarea') {
                      v /= (1 + trace.baseratio) / 2;
                      v /= trace.aspectratio;
                  }
  
                  cd0.r = Math.sqrt(v);
              }
          }
      }
  }
  
  function setCoords(cd) {
      var cd0 = cd[0];
      var r = cd0.r;
      var trace = cd0.trace;
      var currentAngle = helpers.getRotationAngle(trace.rotation);
      var angleFactor = 2 * Math.PI / cd0.vTotal;
      var firstPt = 'px0';
      var lastPt = 'px1';
  
      var i, cdi, currentCoords;
  
      if(trace.direction === 'counterclockwise') {
          for(i = 0; i < cd.length; i++) {
              if(!cd[i].hidden) break; // find the first non-hidden slice
          }
          if(i === cd.length) return; // all slices hidden
  
          currentAngle += angleFactor * cd[i].v;
          angleFactor *= -1;
          firstPt = 'px1';
          lastPt = 'px0';
      }
  
      currentCoords = getCoords(r, currentAngle);
  
      for(i = 0; i < cd.length; i++) {
          cdi = cd[i];
          if(cdi.hidden) continue;
  
          cdi[firstPt] = currentCoords;
  
          cdi.startangle = currentAngle;
          currentAngle += angleFactor * cdi.v / 2;
          cdi.pxmid = getCoords(r, currentAngle);
          cdi.midangle = currentAngle;
          currentAngle += angleFactor * cdi.v / 2;
          currentCoords = getCoords(r, currentAngle);
          cdi.stopangle = currentAngle;
  
          cdi[lastPt] = currentCoords;
  
          cdi.largeArc = (cdi.v > cd0.vTotal / 2) ? 1 : 0;
  
          cdi.halfangle = Math.PI * Math.min(cdi.v / cd0.vTotal, 0.5);
          cdi.ring = 1 - trace.hole;
          cdi.rInscribed = getInscribedRadiusFraction(cdi, cd0);
      }
  }
  
  function getCoords(r, angle) {
      return [r * Math.sin(angle), -r * Math.cos(angle)];
  }
  
  function formatSliceLabel(gd, pt, cd0) {
      var fullLayout = gd._fullLayout;
      var trace = cd0.trace;
      // look for textemplate
      var texttemplate = trace.texttemplate;
  
      // now insert text
      var textinfo = trace.textinfo;
      if(!texttemplate && textinfo && textinfo !== 'none') {
          var parts = textinfo.split('+');
          var hasFlag = function(flag) { return parts.indexOf(flag) !== -1; };
          var hasLabel = hasFlag('label');
          var hasText = hasFlag('text');
          var hasValue = hasFlag('value');
          var hasPercent = hasFlag('percent');
  
          var separators = fullLayout.separators;
          var text;
  
          text = hasLabel ? [pt.label] : [];
          if(hasText) {
              var tx = helpers.getFirstFilled(trace.text, pt.pts);
              if(isValidTextValue(tx)) text.push(tx);
          }
          if(hasValue) text.push(helpers.formatPieValue(pt.v, separators));
          if(hasPercent) text.push(helpers.formatPiePercent(pt.v / cd0.vTotal, separators));
          pt.text = text.join('<br>');
      }
  
      function makeTemplateVariables(pt) {
          return {
              label: pt.label,
              value: pt.v,
              valueLabel: helpers.formatPieValue(pt.v, fullLayout.separators),
              percent: pt.v / cd0.vTotal,
              percentLabel: helpers.formatPiePercent(pt.v / cd0.vTotal, fullLayout.separators),
              color: pt.color,
              text: pt.text,
              customdata: Lib.castOption(trace, pt.i, 'customdata')
          };
      }
  
      if(texttemplate) {
          var txt = Lib.castOption(trace, pt.i, 'texttemplate');
          if(!txt) {
              pt.text = '';
          } else {
              var obj = makeTemplateVariables(pt);
              var ptTx = helpers.getFirstFilled(trace.text, pt.pts);
              if(isValidTextValue(ptTx) || ptTx === '') obj.text = ptTx;
              pt.text = Lib.texttemplateString(txt, obj, gd._fullLayout._d3locale, obj, trace._meta || {});
          }
      }
  }
  
  function computeTransform(
      transform,  // inout
      textBB      // in
  ) {
      var a = transform.rotate * Math.PI / 180;
      var cosA = Math.cos(a);
      var sinA = Math.sin(a);
      var midX = (textBB.left + textBB.right) / 2;
      var midY = (textBB.top + textBB.bottom) / 2;
      transform.textX = midX * cosA - midY * sinA;
      transform.textY = midX * sinA + midY * cosA;
      transform.noCenter = true;
  }
  
  module.exports = {
      plot: plot,
      formatSliceLabel: formatSliceLabel,
      transformInsideText: transformInsideText,
      determineInsideTextFont: determineInsideTextFont,
      positionTitleOutside: positionTitleOutside,
      prerenderTitles: prerenderTitles,
      layoutAreas: layoutAreas,
      attachFxHandlers: attachFxHandlers,
      computeTransform: computeTransform
  };
  
  },{"../../components/color":615,"../../components/drawing":637,"../../components/fx":655,"../../lib":750,"../../lib/svg_text_utils":774,"../../plots/plots":862,"../bar/constants":894,"../bar/uniform_text":908,"./event_data":1136,"./helpers":1137,"d3":169}],1142:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var styleOne = _dereq_('./style_one');
  var resizeText = _dereq_('../bar/uniform_text').resizeText;
  
  module.exports = function style(gd) {
      var s = gd._fullLayout._pielayer.selectAll('.trace');
      resizeText(gd, s, 'pie');
  
      s.each(function(cd) {
          var cd0 = cd[0];
          var trace = cd0.trace;
          var traceSelection = d3.select(this);
  
          traceSelection.style({opacity: trace.opacity});
  
          traceSelection.selectAll('path.surface').each(function(pt) {
              d3.select(this).call(styleOne, pt, trace);
          });
      });
  };
  
  },{"../bar/uniform_text":908,"./style_one":1143,"d3":169}],1143:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Color = _dereq_('../../components/color');
  var castOption = _dereq_('./helpers').castOption;
  
  module.exports = function styleOne(s, pt, trace) {
      var line = trace.marker.line;
      var lineColor = castOption(line.color, pt.pts) || Color.defaultLine;
      var lineWidth = castOption(line.width, pt.pts) || 0;
  
      s.style('stroke-width', lineWidth)
          .call(Color.fill, pt.color)
          .call(Color.stroke, lineColor);
  };
  
  },{"../../components/color":615,"./helpers":1137}],1144:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterglAttrs = _dereq_('../scatter/attributes');
  
  module.exports = {
      x: scatterglAttrs.x,
      y: scatterglAttrs.y,
      xy: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      indices: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      xbounds: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      ybounds: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      text: scatterglAttrs.text,
      marker: {
          color: {
              valType: 'color',
              arrayOk: false,
              
              editType: 'calc',
              
          },
          opacity: {
              valType: 'number',
              min: 0,
              max: 1,
              dflt: 1,
              arrayOk: false,
              
              editType: 'calc',
              
          },
          blend: {
              valType: 'boolean',
              dflt: null,
              
              editType: 'calc',
              
          },
          sizemin: {
              valType: 'number',
              min: 0.1,
              max: 2,
              dflt: 0.5,
              
              editType: 'calc',
              
          },
          sizemax: {
              valType: 'number',
              min: 0.1,
              dflt: 20,
              
              editType: 'calc',
              
          },
          border: {
              color: {
                  valType: 'color',
                  arrayOk: false,
                  
                  editType: 'calc',
                  
              },
              arearatio: {
                  valType: 'number',
                  min: 0,
                  max: 1,
                  dflt: 0,
                  
                  editType: 'calc',
                  
              },
              editType: 'calc'
          },
          editType: 'calc'
      },
      transforms: undefined
  };
  
  },{"../scatter/attributes":1158}],1145:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var createPointCloudRenderer = _dereq_('gl-pointcloud2d');
  
  var str2RGBArray = _dereq_('../../lib/str2rgbarray');
  var findExtremes = _dereq_('../../plots/cartesian/autorange').findExtremes;
  var getTraceColor = _dereq_('../scatter/get_trace_color');
  
  function Pointcloud(scene, uid) {
      this.scene = scene;
      this.uid = uid;
      this.type = 'pointcloud';
  
      this.pickXData = [];
      this.pickYData = [];
      this.xData = [];
      this.yData = [];
      this.textLabels = [];
      this.color = 'rgb(0, 0, 0)';
      this.name = '';
      this.hoverinfo = 'all';
  
      this.idToIndex = new Int32Array(0);
      this.bounds = [0, 0, 0, 0];
  
      this.pointcloudOptions = {
          positions: new Float32Array(0),
          idToIndex: this.idToIndex,
          sizemin: 0.5,
          sizemax: 12,
          color: [0, 0, 0, 1],
          areaRatio: 1,
          borderColor: [0, 0, 0, 1]
      };
      this.pointcloud = createPointCloudRenderer(scene.glplot, this.pointcloudOptions);
      this.pointcloud._trace = this; // scene2d requires this prop
  }
  
  var proto = Pointcloud.prototype;
  
  proto.handlePick = function(pickResult) {
      var index = this.idToIndex[pickResult.pointId];
  
      // prefer the readout from XY, if present
      return {
          trace: this,
          dataCoord: pickResult.dataCoord,
          traceCoord: this.pickXYData ?
              [this.pickXYData[index * 2], this.pickXYData[index * 2 + 1]] :
              [this.pickXData[index], this.pickYData[index]],
          textLabel: Array.isArray(this.textLabels) ?
              this.textLabels[index] :
              this.textLabels,
          color: this.color,
          name: this.name,
          pointIndex: index,
          hoverinfo: this.hoverinfo
      };
  };
  
  proto.update = function(options) {
      this.index = options.index;
      this.textLabels = options.text;
      this.name = options.name;
      this.hoverinfo = options.hoverinfo;
      this.bounds = [Infinity, Infinity, -Infinity, -Infinity];
  
      this.updateFast(options);
  
      this.color = getTraceColor(options, {});
  };
  
  proto.updateFast = function(options) {
      var x = this.xData = this.pickXData = options.x;
      var y = this.yData = this.pickYData = options.y;
      var xy = this.pickXYData = options.xy;
  
      var userBounds = options.xbounds && options.ybounds;
      var index = options.indices;
  
      var len;
      var idToIndex;
      var positions;
      var bounds = this.bounds;
  
      var xx, yy, i;
  
      if(xy) {
          positions = xy;
  
          // dividing xy.length by 2 and truncating to integer if xy.length was not even
          len = xy.length >>> 1;
  
          if(userBounds) {
              bounds[0] = options.xbounds[0];
              bounds[2] = options.xbounds[1];
              bounds[1] = options.ybounds[0];
              bounds[3] = options.ybounds[1];
          } else {
              for(i = 0; i < len; i++) {
                  xx = positions[i * 2];
                  yy = positions[i * 2 + 1];
  
                  if(xx < bounds[0]) bounds[0] = xx;
                  if(xx > bounds[2]) bounds[2] = xx;
                  if(yy < bounds[1]) bounds[1] = yy;
                  if(yy > bounds[3]) bounds[3] = yy;
              }
          }
  
          if(index) {
              idToIndex = index;
          } else {
              idToIndex = new Int32Array(len);
  
              for(i = 0; i < len; i++) {
                  idToIndex[i] = i;
              }
          }
      } else {
          len = x.length;
  
          positions = new Float32Array(2 * len);
          idToIndex = new Int32Array(len);
  
          for(i = 0; i < len; i++) {
              xx = x[i];
              yy = y[i];
  
              idToIndex[i] = i;
  
              positions[i * 2] = xx;
              positions[i * 2 + 1] = yy;
  
              if(xx < bounds[0]) bounds[0] = xx;
              if(xx > bounds[2]) bounds[2] = xx;
              if(yy < bounds[1]) bounds[1] = yy;
              if(yy > bounds[3]) bounds[3] = yy;
          }
      }
  
      this.idToIndex = idToIndex;
      this.pointcloudOptions.idToIndex = idToIndex;
  
      this.pointcloudOptions.positions = positions;
  
      var markerColor = str2RGBArray(options.marker.color);
      var borderColor = str2RGBArray(options.marker.border.color);
      var opacity = options.opacity * options.marker.opacity;
  
      markerColor[3] *= opacity;
      this.pointcloudOptions.color = markerColor;
  
      // detect blending from the number of points, if undefined
      // because large data with blending hits performance
      var blend = options.marker.blend;
      if(blend === null) {
          var maxPoints = 100;
          blend = x.length < maxPoints || y.length < maxPoints;
      }
      this.pointcloudOptions.blend = blend;
  
      borderColor[3] *= opacity;
      this.pointcloudOptions.borderColor = borderColor;
  
      var markerSizeMin = options.marker.sizemin;
      var markerSizeMax = Math.max(options.marker.sizemax, options.marker.sizemin);
      this.pointcloudOptions.sizeMin = markerSizeMin;
      this.pointcloudOptions.sizeMax = markerSizeMax;
      this.pointcloudOptions.areaRatio = options.marker.border.arearatio;
  
      this.pointcloud.update(this.pointcloudOptions);
  
      // add item for autorange routine
      var xa = this.scene.xaxis;
      var ya = this.scene.yaxis;
      var pad = markerSizeMax / 2 || 0.5;
      options._extremes[xa._id] = findExtremes(xa, [bounds[0], bounds[2]], {ppad: pad});
      options._extremes[ya._id] = findExtremes(ya, [bounds[1], bounds[3]], {ppad: pad});
  };
  
  proto.dispose = function() {
      this.pointcloud.dispose();
  };
  
  function createPointcloud(scene, data) {
      var plot = new Pointcloud(scene, data.uid);
      plot.update(data);
      return plot;
  }
  
  module.exports = createPointcloud;
  
  },{"../../lib/str2rgbarray":773,"../../plots/cartesian/autorange":798,"../scatter/get_trace_color":1168,"gl-pointcloud2d":303}],1146:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      coerce('x');
      coerce('y');
  
      coerce('xbounds');
      coerce('ybounds');
  
      if(traceIn.xy && traceIn.xy instanceof Float32Array) {
          traceOut.xy = traceIn.xy;
      }
  
      if(traceIn.indices && traceIn.indices instanceof Int32Array) {
          traceOut.indices = traceIn.indices;
      }
  
      coerce('text');
      coerce('marker.color', defaultColor);
      coerce('marker.opacity');
      coerce('marker.blend');
      coerce('marker.sizemin');
      coerce('marker.sizemax');
      coerce('marker.border.color', defaultColor);
      coerce('marker.border.arearatio');
  
      // disable 1D transforms - that would defeat the purpose of this trace type, performance!
      traceOut._length = null;
  };
  
  },{"../../lib":750,"./attributes":1144}],1147:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
  
      // reuse the Scatter3D 'dummy' calc step so that legends know what to do
      calc: _dereq_('../scatter3d/calc'),
      plot: _dereq_('./convert'),
  
      moduleType: 'trace',
      name: 'pointcloud',
      basePlotModule: _dereq_('../../plots/gl2d'),
      categories: ['gl', 'gl2d', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"../../plots/gl2d":839,"../scatter3d/calc":1187,"./attributes":1144,"./convert":1145,"./defaults":1146}],1148:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var colorAttrs = _dereq_('../../components/color/attributes');
  var fxAttrs = _dereq_('../../components/fx/attributes');
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var colorAttributes = _dereq_('../../components/colorscale/attributes');
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
  
  var attrs = module.exports = overrideAll({
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: [],
          arrayOk: false,
          
      }),
      hoverlabel: fxAttrs.hoverlabel,
      domain: domainAttrs({name: 'sankey', trace: true}),
  
      orientation: {
          valType: 'enumerated',
          values: ['v', 'h'],
          dflt: 'h',
          
          
      },
  
      valueformat: {
          valType: 'string',
          dflt: '.3s',
          
          
      },
  
      valuesuffix: {
          valType: 'string',
          dflt: '',
          
          
      },
  
      arrangement: {
          valType: 'enumerated',
          values: ['snap', 'perpendicular', 'freeform', 'fixed'],
          dflt: 'snap',
          
          
      },
  
      textfont: fontAttrs({
          
      }),
  
      // Remove top-level customdata
      customdata: undefined,
  
      node: {
          label: {
              valType: 'data_array',
              dflt: [],
              
              
          },
          groups: {
              valType: 'info_array',
              impliedEdits: {'x': [], 'y': []},
              dimensions: 2,
              freeLength: true,
              dflt: [],
              items: {valType: 'number', editType: 'calc'},
              
              
          },
          x: {
              valType: 'data_array',
              dflt: [],
              
              
          },
          y: {
              valType: 'data_array',
              dflt: [],
              
              
          },
          color: {
              valType: 'color',
              
              arrayOk: true,
              
          },
          customdata: {
              valType: 'data_array',
              editType: 'calc',
              
          },
          line: {
              color: {
                  valType: 'color',
                  
                  dflt: colorAttrs.defaultLine,
                  arrayOk: true,
                  
              },
              width: {
                  valType: 'number',
                  
                  min: 0,
                  dflt: 0.5,
                  arrayOk: true,
                  
              }
          },
          pad: {
              valType: 'number',
              arrayOk: false,
              min: 0,
              dflt: 20,
              
              
          },
          thickness: {
              valType: 'number',
              arrayOk: false,
              min: 1,
              dflt: 20,
              
              
          },
          hoverinfo: {
              valType: 'enumerated',
              values: ['all', 'none', 'skip'],
              dflt: 'all',
              
              
          },
          hoverlabel: fxAttrs.hoverlabel, // needs editType override,
          hovertemplate: hovertemplateAttrs({}, {
              
              keys: ['value', 'label']
          }),
          
      },
  
      link: {
          label: {
              valType: 'data_array',
              dflt: [],
              
              
          },
          color: {
              valType: 'color',
              
              arrayOk: true,
              
          },
          customdata: {
              valType: 'data_array',
              editType: 'calc',
              
          },
          line: {
              color: {
                  valType: 'color',
                  
                  dflt: colorAttrs.defaultLine,
                  arrayOk: true,
                  
              },
              width: {
                  valType: 'number',
                  
                  min: 0,
                  dflt: 0,
                  arrayOk: true,
                  
              }
          },
          source: {
              valType: 'data_array',
              
              dflt: [],
              
          },
          target: {
              valType: 'data_array',
              
              dflt: [],
              
          },
          value: {
              valType: 'data_array',
              dflt: [],
              
              
          },
          hoverinfo: {
              valType: 'enumerated',
              values: ['all', 'none', 'skip'],
              dflt: 'all',
              
              
          },
          hoverlabel: fxAttrs.hoverlabel, // needs editType override,
          hovertemplate: hovertemplateAttrs({}, {
              
              keys: ['value', 'label']
          }),
          colorscales: templatedArray('concentrationscales', {
              editType: 'calc',
              label: {
                  valType: 'string',
                  
                  editType: 'calc',
                  
                  dflt: ''
              },
              cmax: {
                  valType: 'number',
                  
                  editType: 'calc',
                  dflt: 1,
                  
              },
              cmin: {
                  valType: 'number',
                  
                  editType: 'calc',
                  dflt: 0,
                  
              },
              colorscale: extendFlat(colorAttributes().colorscale, {dflt: [[0, 'white'], [1, 'black']]})
          }),
          
          
      }
  }, 'calc', 'nested');
  attrs.transforms = undefined;
  
  },{"../../components/color/attributes":614,"../../components/colorscale/attributes":622,"../../components/fx/attributes":646,"../../constants/docs":720,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plot_api/plot_template":788,"../../plots/attributes":795,"../../plots/domain":826,"../../plots/font_attributes":827,"../../plots/template_attributes":877}],1149:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
  var plot = _dereq_('./plot');
  var fxAttrs = _dereq_('../../components/fx/layout_attributes');
  
  var setCursor = _dereq_('../../lib/setcursor');
  var dragElement = _dereq_('../../components/dragelement');
  var prepSelect = _dereq_('../../plots/cartesian/select').prepSelect;
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  
  var SANKEY = 'sankey';
  
  exports.name = SANKEY;
  
  exports.baseLayoutAttrOverrides = overrideAll({
      hoverlabel: fxAttrs.hoverlabel
  }, 'plot', 'nested');
  
  exports.plot = function(gd) {
      var calcData = getModuleCalcData(gd.calcdata, SANKEY)[0];
      plot(gd, calcData);
      exports.updateFx(gd);
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var hadPlot = (oldFullLayout._has && oldFullLayout._has(SANKEY));
      var hasPlot = (newFullLayout._has && newFullLayout._has(SANKEY));
  
      if(hadPlot && !hasPlot) {
          oldFullLayout._paperdiv.selectAll('.sankey').remove();
          oldFullLayout._paperdiv.selectAll('.bgsankey').remove();
      }
  };
  
  exports.updateFx = function(gd) {
      for(var i = 0; i < gd._fullData.length; i++) {
          subplotUpdateFx(gd, i);
      }
  };
  
  function subplotUpdateFx(gd, index) {
      var trace = gd._fullData[index];
      var fullLayout = gd._fullLayout;
  
      var dragMode = fullLayout.dragmode;
      var cursor = fullLayout.dragmode === 'pan' ? 'move' : 'crosshair';
      var bgRect = trace._bgRect;
  
      if(dragMode === 'pan' || dragMode === 'zoom') return;
  
      setCursor(bgRect, cursor);
  
      var xaxis = {
          _id: 'x',
          c2p: Lib.identity,
          _offset: trace._sankey.translateX,
          _length: trace._sankey.width
      };
      var yaxis = {
          _id: 'y',
          c2p: Lib.identity,
          _offset: trace._sankey.translateY,
          _length: trace._sankey.height
      };
  
      // Note: dragOptions is needed to be declared for all dragmodes because
      // it's the object that holds persistent selection state.
      var dragOptions = {
          gd: gd,
          element: bgRect.node(),
          plotinfo: {
              id: index,
              xaxis: xaxis,
              yaxis: yaxis,
              fillRangeItems: Lib.noop
          },
          subplot: index,
          // create mock x/y axes for hover routine
          xaxes: [xaxis],
          yaxes: [yaxis],
          doneFnCompleted: function(selection) {
              var traceNow = gd._fullData[index];
              var newGroups;
              var oldGroups = traceNow.node.groups.slice();
              var newGroup = [];
  
              function findNode(pt) {
                  var nodes = traceNow._sankey.graph.nodes;
                  for(var i = 0; i < nodes.length; i++) {
                      if(nodes[i].pointNumber === pt) return nodes[i];
                  }
              }
  
              for(var j = 0; j < selection.length; j++) {
                  var node = findNode(selection[j].pointNumber);
                  if(!node) continue;
  
                  // If the node represents a group
                  if(node.group) {
                      // Add all its children to the current selection
                      for(var k = 0; k < node.childrenNodes.length; k++) {
                          newGroup.push(node.childrenNodes[k].pointNumber);
                      }
                      // Flag group for removal from existing list of groups
                      oldGroups[node.pointNumber - traceNow.node._count] = false;
                  } else {
                      newGroup.push(node.pointNumber);
                  }
              }
  
              newGroups = oldGroups
                  .filter(Boolean)
                  .concat([newGroup]);
  
              Registry.call('_guiRestyle', gd, {
                  'node.groups': [ newGroups ]
              }, index);
          }
      };
  
      dragOptions.prepFn = function(e, startX, startY) {
          prepSelect(e, startX, startY, dragOptions, dragMode);
      };
  
      dragElement.init(dragOptions);
  }
  
  },{"../../components/dragelement":634,"../../components/fx/layout_attributes":656,"../../lib":750,"../../lib/setcursor":770,"../../plot_api/edit_types":781,"../../plots/cartesian/select":818,"../../plots/get_data":836,"../../registry":882,"./plot":1154}],1150:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var tarjan = _dereq_('strongly-connected-components');
  var Lib = _dereq_('../../lib');
  var wrap = _dereq_('../../lib/gup').wrap;
  
  var isArrayOrTypedArray = Lib.isArrayOrTypedArray;
  var isIndex = Lib.isIndex;
  var Colorscale = _dereq_('../../components/colorscale');
  
  function convertToD3Sankey(trace) {
      var nodeSpec = trace.node;
      var linkSpec = trace.link;
  
      var links = [];
      var hasLinkColorArray = isArrayOrTypedArray(linkSpec.color);
      var hasLinkCustomdataArray = isArrayOrTypedArray(linkSpec.customdata);
      var linkedNodes = {};
  
      var components = {};
      var componentCount = linkSpec.colorscales.length;
      var i;
      for(i = 0; i < componentCount; i++) {
          var cscale = linkSpec.colorscales[i];
          var specs = Colorscale.extractScale(cscale, {cLetter: 'c'});
          var scale = Colorscale.makeColorScaleFunc(specs);
          components[cscale.label] = scale;
      }
  
      var maxNodeId = 0;
      for(i = 0; i < linkSpec.value.length; i++) {
          if(linkSpec.source[i] > maxNodeId) maxNodeId = linkSpec.source[i];
          if(linkSpec.target[i] > maxNodeId) maxNodeId = linkSpec.target[i];
      }
      var nodeCount = maxNodeId + 1;
      trace.node._count = nodeCount;
  
      // Group nodes
      var j;
      var groups = trace.node.groups;
      var groupLookup = {};
      for(i = 0; i < groups.length; i++) {
          var group = groups[i];
          // Build a lookup table to quickly find in which group a node is
          for(j = 0; j < group.length; j++) {
              var nodeIndex = group[j];
              var groupIndex = nodeCount + i;
              if(groupLookup.hasOwnProperty(nodeIndex)) {
                  Lib.warn('Node ' + nodeIndex + ' is already part of a group.');
              } else {
                  groupLookup[nodeIndex] = groupIndex;
              }
          }
      }
  
      // Process links
      var groupedLinks = {
          source: [],
          target: []
      };
      for(i = 0; i < linkSpec.value.length; i++) {
          var val = linkSpec.value[i];
          // remove negative values, but keep zeros with special treatment
          var source = linkSpec.source[i];
          var target = linkSpec.target[i];
          if(!(val > 0 && isIndex(source, nodeCount) && isIndex(target, nodeCount))) {
              continue;
          }
  
          // Remove links that are within the same group
          if(groupLookup.hasOwnProperty(source) && groupLookup.hasOwnProperty(target) && groupLookup[source] === groupLookup[target]) {
              continue;
          }
  
          // if link targets a node in the group, relink target to that group
          if(groupLookup.hasOwnProperty(target)) {
              target = groupLookup[target];
          }
  
          // if link originates from a node in a group, relink source to that group
          if(groupLookup.hasOwnProperty(source)) {
              source = groupLookup[source];
          }
  
          source = +source;
          target = +target;
          linkedNodes[source] = linkedNodes[target] = true;
  
          var label = '';
          if(linkSpec.label && linkSpec.label[i]) label = linkSpec.label[i];
  
          var concentrationscale = null;
          if(label && components.hasOwnProperty(label)) concentrationscale = components[label];
  
          links.push({
              pointNumber: i,
              label: label,
              color: hasLinkColorArray ? linkSpec.color[i] : linkSpec.color,
              customdata: hasLinkCustomdataArray ? linkSpec.customdata[i] : linkSpec.customdata,
              concentrationscale: concentrationscale,
              source: source,
              target: target,
              value: +val
          });
  
          groupedLinks.source.push(source);
          groupedLinks.target.push(target);
      }
  
      // Process nodes
      var totalCount = nodeCount + groups.length;
      var hasNodeColorArray = isArrayOrTypedArray(nodeSpec.color);
      var hasNodeCustomdataArray = isArrayOrTypedArray(nodeSpec.customdata);
      var nodes = [];
      for(i = 0; i < totalCount; i++) {
          if(!linkedNodes[i]) continue;
          var l = nodeSpec.label[i];
  
          nodes.push({
              group: (i > nodeCount - 1),
              childrenNodes: [],
              pointNumber: i,
              label: l,
              color: hasNodeColorArray ? nodeSpec.color[i] : nodeSpec.color,
              customdata: hasNodeCustomdataArray ? nodeSpec.customdata[i] : nodeSpec.customdata
          });
      }
  
      // Check if we have circularity on the resulting graph
      var circular = false;
      if(circularityPresent(totalCount, groupedLinks.source, groupedLinks.target)) {
          circular = true;
      }
  
      return {
          circular: circular,
          links: links,
          nodes: nodes,
  
          // Data structure for groups
          groups: groups,
          groupLookup: groupLookup
      };
  }
  
  function circularityPresent(nodeLen, sources, targets) {
      var nodes = Lib.init2dArray(nodeLen, 0);
  
      for(var i = 0; i < Math.min(sources.length, targets.length); i++) {
          if(Lib.isIndex(sources[i], nodeLen) && Lib.isIndex(targets[i], nodeLen)) {
              if(sources[i] === targets[i]) {
                  return true; // self-link which is also a scc of one
              }
              nodes[sources[i]].push(targets[i]);
          }
      }
  
      var scc = tarjan(nodes);
  
      // Tarján's strongly connected components algorithm coded by Mikola Lysenko
      // returns at least one non-singular component if there's circularity in the graph
      return scc.components.some(function(c) {
          return c.length > 1;
      });
  }
  
  module.exports = function calc(gd, trace) {
      var result = convertToD3Sankey(trace);
  
      return wrap({
          circular: result.circular,
          _nodes: result.nodes,
          _links: result.links,
  
          // Data structure for grouping
          _groups: result.groups,
          _groupLookup: result.groupLookup,
      });
  };
  
  },{"../../components/colorscale":627,"../../lib":750,"../../lib/gup":747,"strongly-connected-components":541}],1151:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      nodeTextOffsetHorizontal: 4,
      nodeTextOffsetVertical: 3,
      nodePadAcross: 10,
      sankeyIterations: 50,
      forceIterations: 5,
      forceTicksPerFrame: 10,
      duration: 500,
      ease: 'linear',
      cn: {
          sankey: 'sankey',
          sankeyLinks: 'sankey-links',
          sankeyLink: 'sankey-link',
          sankeyNodeSet: 'sankey-node-set',
          sankeyNode: 'sankey-node',
          nodeRect: 'node-rect',
          nodeCapture: 'node-capture',
          nodeCentered: 'node-entered',
          nodeLabelGuide: 'node-label-guide',
          nodeLabel: 'node-label',
          nodeLabelTextPath: 'node-label-text-path'
      }
  };
  
  },{}],1152:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var Color = _dereq_('../../components/color');
  var tinycolor = _dereq_('tinycolor2');
  var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
  var handleHoverLabelDefaults = _dereq_('../../components/fx/hoverlabel_defaults');
  var Template = _dereq_('../../plot_api/plot_template');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var hoverlabelDefault = Lib.extendDeep(layout.hoverlabel, traceIn.hoverlabel);
  
      // node attributes
      var nodeIn = traceIn.node;
      var nodeOut = Template.newContainer(traceOut, 'node');
  
      function coerceNode(attr, dflt) {
          return Lib.coerce(nodeIn, nodeOut, attributes.node, attr, dflt);
      }
      coerceNode('label');
      coerceNode('groups');
      coerceNode('x');
      coerceNode('y');
      coerceNode('pad');
      coerceNode('thickness');
      coerceNode('line.color');
      coerceNode('line.width');
      coerceNode('hoverinfo', traceIn.hoverinfo);
      handleHoverLabelDefaults(nodeIn, nodeOut, coerceNode, hoverlabelDefault);
      coerceNode('hovertemplate');
  
      var colors = layout.colorway;
  
      var defaultNodePalette = function(i) {return colors[i % colors.length];};
  
      coerceNode('color', nodeOut.label.map(function(d, i) {
          return Color.addOpacity(defaultNodePalette(i), 0.8);
      }));
      coerceNode('customdata');
  
      // link attributes
      var linkIn = traceIn.link || {};
      var linkOut = Template.newContainer(traceOut, 'link');
  
      function coerceLink(attr, dflt) {
          return Lib.coerce(linkIn, linkOut, attributes.link, attr, dflt);
      }
      coerceLink('label');
      coerceLink('source');
      coerceLink('target');
      coerceLink('value');
      coerceLink('line.color');
      coerceLink('line.width');
      coerceLink('hoverinfo', traceIn.hoverinfo);
      handleHoverLabelDefaults(linkIn, linkOut, coerceLink, hoverlabelDefault);
      coerceLink('hovertemplate');
  
      var defaultLinkColor = tinycolor(layout.paper_bgcolor).getLuminance() < 0.333 ?
                  'rgba(255, 255, 255, 0.6)' :
                  'rgba(0, 0, 0, 0.2)';
  
      coerceLink('color', Lib.repeat(defaultLinkColor, linkOut.value.length));
      coerceLink('customdata');
  
      handleArrayContainerDefaults(linkIn, linkOut, {
          name: 'colorscales',
          handleItemDefaults: concentrationscalesDefaults
      });
  
      handleDomainDefaults(traceOut, layout, coerce);
  
      coerce('orientation');
      coerce('valueformat');
      coerce('valuesuffix');
  
      var dfltArrangement;
      if(nodeOut.x.length && nodeOut.y.length) {
          dfltArrangement = 'freeform';
      }
      coerce('arrangement', dfltArrangement);
  
      Lib.coerceFont(coerce, 'textfont', Lib.extendFlat({}, layout.font));
  
      // disable 1D transforms - arrays here are 1D but their lengths/meanings
      // don't match, between nodes and links
      traceOut._length = null;
  };
  
  function concentrationscalesDefaults(In, Out) {
      function coerce(attr, dflt) {
          return Lib.coerce(In, Out, attributes.link.colorscales, attr, dflt);
      }
  
      coerce('label');
      coerce('cmin');
      coerce('cmax');
      coerce('colorscale');
  }
  
  },{"../../components/color":615,"../../components/fx/hoverlabel_defaults":653,"../../lib":750,"../../plot_api/plot_template":788,"../../plots/array_container_defaults":794,"../../plots/domain":826,"./attributes":1148,"tinycolor2":548}],1153:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
  
      moduleType: 'trace',
      name: 'sankey',
      basePlotModule: _dereq_('./base_plot'),
      selectPoints: _dereq_('./select.js'),
      categories: ['noOpacity'],
      meta: {
          
      }
  };
  
  },{"./attributes":1148,"./base_plot":1149,"./calc":1150,"./defaults":1152,"./plot":1154,"./select.js":1156}],1154:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var render = _dereq_('./render');
  var Fx = _dereq_('../../components/fx');
  var Color = _dereq_('../../components/color');
  var Lib = _dereq_('../../lib');
  var cn = _dereq_('./constants').cn;
  
  var _ = Lib._;
  
  function renderableValuePresent(d) {return d !== '';}
  
  function ownTrace(selection, d) {
      return selection.filter(function(s) {return s.key === d.traceId;});
  }
  
  function makeTranslucent(element, alpha) {
      d3.select(element)
          .select('path')
          .style('fill-opacity', alpha);
      d3.select(element)
          .select('rect')
          .style('fill-opacity', alpha);
  }
  
  function makeTextContrasty(element) {
      d3.select(element)
          .select('text.name')
          .style('fill', 'black');
  }
  
  function relatedLinks(d) {
      return function(l) {
          return d.node.sourceLinks.indexOf(l.link) !== -1 || d.node.targetLinks.indexOf(l.link) !== -1;
      };
  }
  
  function relatedNodes(l) {
      return function(d) {
          return d.node.sourceLinks.indexOf(l.link) !== -1 || d.node.targetLinks.indexOf(l.link) !== -1;
      };
  }
  
  function nodeHoveredStyle(sankeyNode, d, sankey) {
      if(d && sankey) {
          ownTrace(sankey, d)
              .selectAll('.' + cn.sankeyLink)
              .filter(relatedLinks(d))
              .call(linkHoveredStyle.bind(0, d, sankey, false));
      }
  }
  
  function nodeNonHoveredStyle(sankeyNode, d, sankey) {
      if(d && sankey) {
          ownTrace(sankey, d)
              .selectAll('.' + cn.sankeyLink)
              .filter(relatedLinks(d))
              .call(linkNonHoveredStyle.bind(0, d, sankey, false));
      }
  }
  
  function linkHoveredStyle(d, sankey, visitNodes, sankeyLink) {
      var label = sankeyLink.datum().link.label;
  
      sankeyLink.style('fill-opacity', function(l) {
          if(!l.link.concentrationscale) {
              return 0.4;
          }
      });
  
      if(label) {
          ownTrace(sankey, d)
              .selectAll('.' + cn.sankeyLink)
              .filter(function(l) {return l.link.label === label;})
              .style('fill-opacity', function(l) {
                  if(!l.link.concentrationscale) {
                      return 0.4;
                  }
              });
      }
  
      if(visitNodes) {
          ownTrace(sankey, d)
              .selectAll('.' + cn.sankeyNode)
              .filter(relatedNodes(d))
              .call(nodeHoveredStyle);
      }
  }
  
  function linkNonHoveredStyle(d, sankey, visitNodes, sankeyLink) {
      var label = sankeyLink.datum().link.label;
  
      sankeyLink.style('fill-opacity', function(d) {return d.tinyColorAlpha;});
      if(label) {
          ownTrace(sankey, d)
              .selectAll('.' + cn.sankeyLink)
              .filter(function(l) {return l.link.label === label;})
              .style('fill-opacity', function(d) {return d.tinyColorAlpha;});
      }
  
      if(visitNodes) {
          ownTrace(sankey, d)
              .selectAll(cn.sankeyNode)
              .filter(relatedNodes(d))
              .call(nodeNonHoveredStyle);
      }
  }
  
  // does not support array values for now
  function castHoverOption(trace, attr) {
      var labelOpts = trace.hoverlabel || {};
      var val = Lib.nestedProperty(labelOpts, attr).get();
      return Array.isArray(val) ? false : val;
  }
  
  module.exports = function plot(gd, calcData) {
      var fullLayout = gd._fullLayout;
      var svg = fullLayout._paper;
      var size = fullLayout._size;
  
      // stash initial view
      for(var i = 0; i < gd._fullData.length; i++) {
          if(!gd._fullData[i].visible) continue;
          if(gd._fullData[i].type !== cn.sankey) continue;
          if(!gd._fullData[i]._viewInitial) {
              var node = gd._fullData[i].node;
              gd._fullData[i]._viewInitial = {
                  node: {
                      groups: node.groups.slice(),
                      x: node.x.slice(),
                      y: node.y.slice()
                  }
              };
          }
      }
  
      var linkSelect = function(element, d) {
          var evt = d.link;
          evt.originalEvent = d3.event;
          gd._hoverdata = [evt];
          Fx.click(gd, { target: true });
      };
  
      var linkHover = function(element, d, sankey) {
          if(gd._fullLayout.hovermode === false) return;
          d3.select(element).call(linkHoveredStyle.bind(0, d, sankey, true));
          if(d.link.trace.link.hoverinfo !== 'skip') {
              d.link.fullData = d.link.trace;
              gd.emit('plotly_hover', {
                  event: d3.event,
                  points: [d.link]
              });
          }
      };
  
      var sourceLabel = _(gd, 'source:') + ' ';
      var targetLabel = _(gd, 'target:') + ' ';
      var concentrationLabel = _(gd, 'concentration:') + ' ';
      var incomingLabel = _(gd, 'incoming flow count:') + ' ';
      var outgoingLabel = _(gd, 'outgoing flow count:') + ' ';
  
      var linkHoverFollow = function(element, d) {
          if(gd._fullLayout.hovermode === false) return;
          var obj = d.link.trace.link;
          if(obj.hoverinfo === 'none' || obj.hoverinfo === 'skip') return;
  
          var hoverItems = [];
  
          function hoverCenterPosition(link) {
              var hoverCenterX, hoverCenterY;
              if(link.circular) {
                  hoverCenterX = (link.circularPathData.leftInnerExtent + link.circularPathData.rightInnerExtent) / 2;
                  hoverCenterY = link.circularPathData.verticalFullExtent;
              } else {
                  hoverCenterX = (link.source.x1 + link.target.x0) / 2;
                  hoverCenterY = (link.y0 + link.y1) / 2;
              }
              var center = [hoverCenterX, hoverCenterY];
              if(link.trace.orientation === 'v') center.reverse();
              center[0] += d.parent.translateX;
              center[1] += d.parent.translateY;
              return center;
          }
  
          // For each related links, create a hoverItem
          var anchorIndex = 0;
          for(var i = 0; i < d.flow.links.length; i++) {
              var link = d.flow.links[i];
              if(gd._fullLayout.hovermode === 'closest' && d.link.pointNumber !== link.pointNumber) continue;
              if(d.link.pointNumber === link.pointNumber) anchorIndex = i;
              link.fullData = link.trace;
              obj = d.link.trace.link;
              var hoverCenter = hoverCenterPosition(link);
              var hovertemplateLabels = {valueLabel: d3.format(d.valueFormat)(link.value) + d.valueSuffix};
  
              hoverItems.push({
                  x: hoverCenter[0],
                  y: hoverCenter[1],
                  name: hovertemplateLabels.valueLabel,
                  text: [
                      link.label || '',
                      sourceLabel + link.source.label,
                      targetLabel + link.target.label,
                      link.concentrationscale ? concentrationLabel + d3.format('%0.2f')(link.flow.labelConcentration) : ''
                  ].filter(renderableValuePresent).join('<br>'),
                  color: castHoverOption(obj, 'bgcolor') || Color.addOpacity(link.color, 1),
                  borderColor: castHoverOption(obj, 'bordercolor'),
                  fontFamily: castHoverOption(obj, 'font.family'),
                  fontSize: castHoverOption(obj, 'font.size'),
                  fontColor: castHoverOption(obj, 'font.color'),
                  nameLength: castHoverOption(obj, 'namelength'),
                  textAlign: castHoverOption(obj, 'align'),
                  idealAlign: d3.event.x < hoverCenter[0] ? 'right' : 'left',
  
                  hovertemplate: obj.hovertemplate,
                  hovertemplateLabels: hovertemplateLabels,
                  eventData: [link]
              });
          }
  
          var tooltips = Fx.loneHover(hoverItems, {
              container: fullLayout._hoverlayer.node(),
              outerContainer: fullLayout._paper.node(),
              gd: gd,
              anchorIndex: anchorIndex
          });
  
          tooltips.each(function() {
              var tooltip = this;
              if(!d.link.concentrationscale) {
                  makeTranslucent(tooltip, 0.65);
              }
              makeTextContrasty(tooltip);
          });
      };
  
      var linkUnhover = function(element, d, sankey) {
          if(gd._fullLayout.hovermode === false) return;
          d3.select(element).call(linkNonHoveredStyle.bind(0, d, sankey, true));
          if(d.link.trace.link.hoverinfo !== 'skip') {
              d.link.fullData = d.link.trace;
              gd.emit('plotly_unhover', {
                  event: d3.event,
                  points: [d.link]
              });
          }
  
          Fx.loneUnhover(fullLayout._hoverlayer.node());
      };
  
      var nodeSelect = function(element, d, sankey) {
          var evt = d.node;
          evt.originalEvent = d3.event;
          gd._hoverdata = [evt];
          d3.select(element).call(nodeNonHoveredStyle, d, sankey);
          Fx.click(gd, { target: true });
      };
  
      var nodeHover = function(element, d, sankey) {
          if(gd._fullLayout.hovermode === false) return;
          d3.select(element).call(nodeHoveredStyle, d, sankey);
          if(d.node.trace.node.hoverinfo !== 'skip') {
              d.node.fullData = d.node.trace;
              gd.emit('plotly_hover', {
                  event: d3.event,
                  points: [d.node]
              });
          }
      };
  
      var nodeHoverFollow = function(element, d) {
          if(gd._fullLayout.hovermode === false) return;
  
          var obj = d.node.trace.node;
          if(obj.hoverinfo === 'none' || obj.hoverinfo === 'skip') return;
          var nodeRect = d3.select(element).select('.' + cn.nodeRect);
          var rootBBox = gd._fullLayout._paperdiv.node().getBoundingClientRect();
          var boundingBox = nodeRect.node().getBoundingClientRect();
          var hoverCenterX0 = boundingBox.left - 2 - rootBBox.left;
          var hoverCenterX1 = boundingBox.right + 2 - rootBBox.left;
          var hoverCenterY = boundingBox.top + boundingBox.height / 4 - rootBBox.top;
  
          var hovertemplateLabels = {valueLabel: d3.format(d.valueFormat)(d.node.value) + d.valueSuffix};
          d.node.fullData = d.node.trace;
  
          var tooltip = Fx.loneHover({
              x0: hoverCenterX0,
              x1: hoverCenterX1,
              y: hoverCenterY,
              name: d3.format(d.valueFormat)(d.node.value) + d.valueSuffix,
              text: [
                  d.node.label,
                  incomingLabel + d.node.targetLinks.length,
                  outgoingLabel + d.node.sourceLinks.length
              ].filter(renderableValuePresent).join('<br>'),
              color: castHoverOption(obj, 'bgcolor') || d.tinyColorHue,
              borderColor: castHoverOption(obj, 'bordercolor'),
              fontFamily: castHoverOption(obj, 'font.family'),
              fontSize: castHoverOption(obj, 'font.size'),
              fontColor: castHoverOption(obj, 'font.color'),
              nameLength: castHoverOption(obj, 'namelength'),
              textAlign: castHoverOption(obj, 'align'),
              idealAlign: 'left',
  
              hovertemplate: obj.hovertemplate,
              hovertemplateLabels: hovertemplateLabels,
              eventData: [d.node]
          }, {
              container: fullLayout._hoverlayer.node(),
              outerContainer: fullLayout._paper.node(),
              gd: gd
          });
  
          makeTranslucent(tooltip, 0.85);
          makeTextContrasty(tooltip);
      };
  
      var nodeUnhover = function(element, d, sankey) {
          if(gd._fullLayout.hovermode === false) return;
          d3.select(element).call(nodeNonHoveredStyle, d, sankey);
          if(d.node.trace.node.hoverinfo !== 'skip') {
              d.node.fullData = d.node.trace;
              gd.emit('plotly_unhover', {
                  event: d3.event,
                  points: [d.node]
              });
          }
  
          Fx.loneUnhover(fullLayout._hoverlayer.node());
      };
  
      render(
          gd,
          svg,
          calcData,
          {
              width: size.w,
              height: size.h,
              margin: {
                  t: size.t,
                  r: size.r,
                  b: size.b,
                  l: size.l
              }
          },
          {
              linkEvents: {
                  hover: linkHover,
                  follow: linkHoverFollow,
                  unhover: linkUnhover,
                  select: linkSelect
              },
              nodeEvents: {
                  hover: nodeHover,
                  follow: nodeHoverFollow,
                  unhover: nodeUnhover,
                  select: nodeSelect
              }
          }
      );
  };
  
  },{"../../components/color":615,"../../components/fx":655,"../../lib":750,"./constants":1151,"./render":1155,"d3":169}],1155:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var c = _dereq_('./constants');
  var d3 = _dereq_('d3');
  var tinycolor = _dereq_('tinycolor2');
  var Color = _dereq_('../../components/color');
  var Drawing = _dereq_('../../components/drawing');
  var d3Sankey = _dereq_('@plotly/d3-sankey');
  var d3SankeyCircular = _dereq_('@plotly/d3-sankey-circular');
  var d3Force = _dereq_('d3-force');
  var Lib = _dereq_('../../lib');
  var gup = _dereq_('../../lib/gup');
  var keyFun = gup.keyFun;
  var repeat = gup.repeat;
  var unwrap = gup.unwrap;
  var interpolateNumber = _dereq_('d3-interpolate').interpolateNumber;
  
  var Registry = _dereq_('../../registry');
  
  // view models
  
  function sankeyModel(layout, d, traceIndex) {
      var calcData = unwrap(d);
      var trace = calcData.trace;
      var domain = trace.domain;
      var horizontal = trace.orientation === 'h';
      var nodePad = trace.node.pad;
      var nodeThickness = trace.node.thickness;
  
      var width = layout.width * (domain.x[1] - domain.x[0]);
      var height = layout.height * (domain.y[1] - domain.y[0]);
  
      var nodes = calcData._nodes;
      var links = calcData._links;
      var circular = calcData.circular;
  
      // Select Sankey generator
      var sankey;
      if(circular) {
          sankey = d3SankeyCircular
              .sankeyCircular()
              .circularLinkGap(0);
      } else {
          sankey = d3Sankey.sankey();
      }
  
      sankey
        .iterations(c.sankeyIterations)
        .size(horizontal ? [width, height] : [height, width])
        .nodeWidth(nodeThickness)
        .nodePadding(nodePad)
        .nodeId(function(d) {
            return d.pointNumber;
        })
        .nodes(nodes)
        .links(links);
  
      var graph = sankey();
  
      if(sankey.nodePadding() < nodePad) {
          Lib.warn('node.pad was reduced to ', sankey.nodePadding(), ' to fit within the figure.');
      }
  
      // Counters for nested loops
      var i, j, k;
  
      // Create transient nodes for animations
      for(var nodePointNumber in calcData._groupLookup) {
          var groupIndex = parseInt(calcData._groupLookup[nodePointNumber]);
  
          // Find node representing groupIndex
          var groupingNode;
  
          for(i = 0; i < graph.nodes.length; i++) {
              if(graph.nodes[i].pointNumber === groupIndex) {
                  groupingNode = graph.nodes[i];
                  break;
              }
          }
          // If groupinNode is undefined, no links are targeting this group
          if(!groupingNode) continue;
  
          var child = {
              pointNumber: parseInt(nodePointNumber),
              x0: groupingNode.x0,
              x1: groupingNode.x1,
              y0: groupingNode.y0,
              y1: groupingNode.y1,
              partOfGroup: true,
              sourceLinks: [],
              targetLinks: []
          };
  
          graph.nodes.unshift(child);
          groupingNode.childrenNodes.unshift(child);
      }
  
      function computeLinkConcentrations() {
          for(i = 0; i < graph.nodes.length; i++) {
              var node = graph.nodes[i];
              // Links connecting the same two nodes are part of a flow
              var flows = {};
              var flowKey;
              var link;
              for(j = 0; j < node.targetLinks.length; j++) {
                  link = node.targetLinks[j];
                  flowKey = link.source.pointNumber + ':' + link.target.pointNumber;
                  if(!flows.hasOwnProperty(flowKey)) flows[flowKey] = [];
                  flows[flowKey].push(link);
              }
  
              // Compute statistics for each flow
              var keys = Object.keys(flows);
              for(j = 0; j < keys.length; j++) {
                  flowKey = keys[j];
                  var flowLinks = flows[flowKey];
  
                  // Find the total size of the flow and total size per label
                  var total = 0;
                  var totalPerLabel = {};
                  for(k = 0; k < flowLinks.length; k++) {
                      link = flowLinks[k];
                      if(!totalPerLabel[link.label]) totalPerLabel[link.label] = 0;
                      totalPerLabel[link.label] += link.value;
                      total += link.value;
                  }
  
                  // Find the ratio of the link's value and the size of the flow
                  for(k = 0; k < flowLinks.length; k++) {
                      link = flowLinks[k];
                      link.flow = {
                          value: total,
                          labelConcentration: totalPerLabel[link.label] / total,
                          concentration: link.value / total,
                          links: flowLinks
                      };
                      if(link.concentrationscale) {
                          link.color = tinycolor(link.concentrationscale(link.flow.labelConcentration));
                      }
                  }
              }
  
              // Gather statistics of all links at current node
              var totalOutflow = 0;
              for(j = 0; j < node.sourceLinks.length; j++) {
                  totalOutflow += node.sourceLinks[j].value;
              }
              for(j = 0; j < node.sourceLinks.length; j++) {
                  link = node.sourceLinks[j];
                  link.concentrationOut = link.value / totalOutflow;
              }
  
              var totalInflow = 0;
              for(j = 0; j < node.targetLinks.length; j++) {
                  totalInflow += node.targetLinks[j].value;
              }
  
              for(j = 0; j < node.targetLinks.length; j++) {
                  link = node.targetLinks[j];
                  link.concenrationIn = link.value / totalInflow;
              }
          }
      }
      computeLinkConcentrations();
  
      // Push any overlapping nodes down.
      function resolveCollisionsTopToBottom(columns) {
          columns.forEach(function(nodes) {
              var node;
              var dy;
              var y = 0;
              var n = nodes.length;
              var i;
              nodes.sort(function(a, b) {
                  return a.y0 - b.y0;
              });
              for(i = 0; i < n; ++i) {
                  node = nodes[i];
                  if(node.y0 >= y) {
                      // No overlap
                  } else {
                      dy = (y - node.y0);
                      if(dy > 1e-6) node.y0 += dy, node.y1 += dy;
                  }
                  y = node.y1 + nodePad;
              }
          });
      }
  
      // Group nodes into columns based on their x position
      function snapToColumns(nodes) {
          // Sort nodes by x position
          var orderedNodes = nodes.map(function(n, i) {
              return {
                  x0: n.x0,
                  index: i
              };
          })
          .sort(function(a, b) {
              return a.x0 - b.x0;
          });
  
          var columns = [];
          var colNumber = -1;
          var colX; // Position of column
          var lastX = -Infinity; // Position of last node
          var dx;
          for(i = 0; i < orderedNodes.length; i++) {
              var node = nodes[orderedNodes[i].index];
              // If the node does not overlap with the last one
              if(node.x0 > lastX + nodeThickness) {
                  // Start a new column
                  colNumber += 1;
                  colX = node.x0;
              }
              lastX = node.x0;
  
              // Add node to its associated column
              if(!columns[colNumber]) columns[colNumber] = [];
              columns[colNumber].push(node);
  
              // Change node's x position to align it with its column
              dx = colX - node.x0;
              node.x0 += dx, node.x1 += dx;
          }
          return columns;
      }
  
      // Force node position
      if(trace.node.x.length && trace.node.y.length) {
          for(i = 0; i < Math.min(trace.node.x.length, trace.node.y.length, graph.nodes.length); i++) {
              if(trace.node.x[i] && trace.node.y[i]) {
                  var pos = [trace.node.x[i] * width, trace.node.y[i] * height];
                  graph.nodes[i].x0 = pos[0] - nodeThickness / 2;
                  graph.nodes[i].x1 = pos[0] + nodeThickness / 2;
  
                  var nodeHeight = graph.nodes[i].y1 - graph.nodes[i].y0;
                  graph.nodes[i].y0 = pos[1] - nodeHeight / 2;
                  graph.nodes[i].y1 = pos[1] + nodeHeight / 2;
              }
          }
          if(trace.arrangement === 'snap') {
              nodes = graph.nodes;
              var columns = snapToColumns(nodes);
              resolveCollisionsTopToBottom(columns);
          }
          // Update links
          sankey.update(graph);
      }
  
  
      return {
          circular: circular,
          key: traceIndex,
          trace: trace,
          guid: Lib.randstr(),
          horizontal: horizontal,
          width: width,
          height: height,
          nodePad: trace.node.pad,
          nodeLineColor: trace.node.line.color,
          nodeLineWidth: trace.node.line.width,
          linkLineColor: trace.link.line.color,
          linkLineWidth: trace.link.line.width,
          valueFormat: trace.valueformat,
          valueSuffix: trace.valuesuffix,
          textFont: trace.textfont,
          translateX: domain.x[0] * layout.width + layout.margin.l,
          translateY: layout.height - domain.y[1] * layout.height + layout.margin.t,
          dragParallel: horizontal ? height : width,
          dragPerpendicular: horizontal ? width : height,
          arrangement: trace.arrangement,
          sankey: sankey,
          graph: graph,
          forceLayouts: {},
          interactionState: {
              dragInProgress: false,
              hovered: false
          }
      };
  }
  
  function linkModel(d, l, i) {
      var tc = tinycolor(l.color);
      var basicKey = l.source.label + '|' + l.target.label;
      var key = basicKey + '__' + i;
  
      // for event data
      l.trace = d.trace;
      l.curveNumber = d.trace.index;
  
      return {
          circular: d.circular,
          key: key,
          traceId: d.key,
          pointNumber: l.pointNumber,
          link: l,
          tinyColorHue: Color.tinyRGB(tc),
          tinyColorAlpha: tc.getAlpha(),
          linkPath: linkPath,
          linkLineColor: d.linkLineColor,
          linkLineWidth: d.linkLineWidth,
          valueFormat: d.valueFormat,
          valueSuffix: d.valueSuffix,
          sankey: d.sankey,
          parent: d,
          interactionState: d.interactionState,
          flow: l.flow
      };
  }
  
  function createCircularClosedPathString(link) {
      // Using coordinates computed by d3-sankey-circular
      var pathString = '';
      var offset = link.width / 2;
      var coords = link.circularPathData;
      if(link.circularLinkType === 'top') {
          // Top path
          pathString =
            // start at the left of the target node
            'M ' +
            coords.targetX + ' ' + (coords.targetY + offset) + ' ' +
            'L' +
            coords.rightInnerExtent + ' ' + (coords.targetY + offset) +
            'A' +
            (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightSmallArcRadius + offset) + ' 0 0 1 ' +
            (coords.rightFullExtent - offset) + ' ' + (coords.targetY - coords.rightSmallArcRadius) +
            'L' +
            (coords.rightFullExtent - offset) + ' ' + coords.verticalRightInnerExtent +
            'A' +
            (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightLargeArcRadius + offset) + ' 0 0 1 ' +
            coords.rightInnerExtent + ' ' + (coords.verticalFullExtent - offset) +
            'L' +
            coords.leftInnerExtent + ' ' + (coords.verticalFullExtent - offset) +
            'A' +
            (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftLargeArcRadius + offset) + ' 0 0 1 ' +
            (coords.leftFullExtent + offset) + ' ' + coords.verticalLeftInnerExtent +
            'L' +
            (coords.leftFullExtent + offset) + ' ' + (coords.sourceY - coords.leftSmallArcRadius) +
            'A' +
            (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftSmallArcRadius + offset) + ' 0 0 1 ' +
            coords.leftInnerExtent + ' ' + (coords.sourceY + offset) +
            'L' +
            coords.sourceX + ' ' + (coords.sourceY + offset) +
  
            // Walking back
            'L' +
            coords.sourceX + ' ' + (coords.sourceY - offset) +
            'L' +
            coords.leftInnerExtent + ' ' + (coords.sourceY - offset) +
            'A' +
            (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftSmallArcRadius - offset) + ' 0 0 0 ' +
            (coords.leftFullExtent - offset) + ' ' + (coords.sourceY - coords.leftSmallArcRadius) +
            'L' +
            (coords.leftFullExtent - offset) + ' ' + coords.verticalLeftInnerExtent +
            'A' +
            (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftLargeArcRadius - offset) + ' 0 0 0 ' +
            coords.leftInnerExtent + ' ' + (coords.verticalFullExtent + offset) +
            'L' +
            coords.rightInnerExtent + ' ' + (coords.verticalFullExtent + offset) +
            'A' +
            (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightLargeArcRadius - offset) + ' 0 0 0 ' +
            (coords.rightFullExtent + offset) + ' ' + coords.verticalRightInnerExtent +
            'L' +
            (coords.rightFullExtent + offset) + ' ' + (coords.targetY - coords.rightSmallArcRadius) +
            'A' +
            (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightSmallArcRadius - offset) + ' 0 0 0 ' +
            coords.rightInnerExtent + ' ' + (coords.targetY - offset) +
            'L' +
            coords.targetX + ' ' + (coords.targetY - offset) +
            'Z';
      } else {
          // Bottom path
          pathString =
            // start at the left of the target node
            'M ' +
            coords.targetX + ' ' + (coords.targetY - offset) + ' ' +
            'L' +
            coords.rightInnerExtent + ' ' + (coords.targetY - offset) +
            'A' +
            (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightSmallArcRadius + offset) + ' 0 0 0 ' +
            (coords.rightFullExtent - offset) + ' ' + (coords.targetY + coords.rightSmallArcRadius) +
            'L' +
            (coords.rightFullExtent - offset) + ' ' + coords.verticalRightInnerExtent +
            'A' +
            (coords.rightLargeArcRadius + offset) + ' ' + (coords.rightLargeArcRadius + offset) + ' 0 0 0 ' +
            coords.rightInnerExtent + ' ' + (coords.verticalFullExtent + offset) +
            'L' +
            coords.leftInnerExtent + ' ' + (coords.verticalFullExtent + offset) +
            'A' +
            (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftLargeArcRadius + offset) + ' 0 0 0 ' +
            (coords.leftFullExtent + offset) + ' ' + coords.verticalLeftInnerExtent +
            'L' +
            (coords.leftFullExtent + offset) + ' ' + (coords.sourceY + coords.leftSmallArcRadius) +
            'A' +
            (coords.leftLargeArcRadius + offset) + ' ' + (coords.leftSmallArcRadius + offset) + ' 0 0 0 ' +
            coords.leftInnerExtent + ' ' + (coords.sourceY - offset) +
            'L' +
            coords.sourceX + ' ' + (coords.sourceY - offset) +
  
            // Walking back
            'L' +
            coords.sourceX + ' ' + (coords.sourceY + offset) +
            'L' +
            coords.leftInnerExtent + ' ' + (coords.sourceY + offset) +
            'A' +
            (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftSmallArcRadius - offset) + ' 0 0 1 ' +
            (coords.leftFullExtent - offset) + ' ' + (coords.sourceY + coords.leftSmallArcRadius) +
            'L' +
            (coords.leftFullExtent - offset) + ' ' + coords.verticalLeftInnerExtent +
            'A' +
            (coords.leftLargeArcRadius - offset) + ' ' + (coords.leftLargeArcRadius - offset) + ' 0 0 1 ' +
            coords.leftInnerExtent + ' ' + (coords.verticalFullExtent - offset) +
            'L' +
            coords.rightInnerExtent + ' ' + (coords.verticalFullExtent - offset) +
            'A' +
            (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightLargeArcRadius - offset) + ' 0 0 1 ' +
            (coords.rightFullExtent + offset) + ' ' + coords.verticalRightInnerExtent +
            'L' +
            (coords.rightFullExtent + offset) + ' ' + (coords.targetY + coords.rightSmallArcRadius) +
            'A' +
            (coords.rightLargeArcRadius - offset) + ' ' + (coords.rightSmallArcRadius - offset) + ' 0 0 1 ' +
            coords.rightInnerExtent + ' ' + (coords.targetY + offset) +
            'L' +
            coords.targetX + ' ' + (coords.targetY + offset) +
            'Z';
      }
      return pathString;
  }
  
  function linkPath() {
      var curvature = 0.5;
      function path(d) {
          if(d.link.circular) {
              return createCircularClosedPathString(d.link);
          } else {
              var x0 = d.link.source.x1;
              var x1 = d.link.target.x0;
              var xi = interpolateNumber(x0, x1);
              var x2 = xi(curvature);
              var x3 = xi(1 - curvature);
              var y0a = d.link.y0 - d.link.width / 2;
              var y0b = d.link.y0 + d.link.width / 2;
              var y1a = d.link.y1 - d.link.width / 2;
              var y1b = d.link.y1 + d.link.width / 2;
              return 'M' + x0 + ',' + y0a +
                   'C' + x2 + ',' + y0a +
                   ' ' + x3 + ',' + y1a +
                   ' ' + x1 + ',' + y1a +
                   'L' + x1 + ',' + y1b +
                   'C' + x3 + ',' + y1b +
                   ' ' + x2 + ',' + y0b +
                   ' ' + x0 + ',' + y0b +
                   'Z';
          }
      }
      return path;
  }
  
  function nodeModel(d, n) {
      var tc = tinycolor(n.color);
      var zoneThicknessPad = c.nodePadAcross;
      var zoneLengthPad = d.nodePad / 2;
      n.dx = n.x1 - n.x0;
      n.dy = n.y1 - n.y0;
      var visibleThickness = n.dx;
      var visibleLength = Math.max(0.5, n.dy);
  
      var key = 'node_' + n.pointNumber;
      // If it's a group, it's mutable and should be unique
      if(n.group) {
          key = Lib.randstr();
      }
  
      // for event data
      n.trace = d.trace;
      n.curveNumber = d.trace.index;
  
      return {
          index: n.pointNumber,
          key: key,
          partOfGroup: n.partOfGroup || false,
          group: n.group,
          traceId: d.key,
          trace: d.trace,
          node: n,
          nodePad: d.nodePad,
          nodeLineColor: d.nodeLineColor,
          nodeLineWidth: d.nodeLineWidth,
          textFont: d.textFont,
          size: d.horizontal ? d.height : d.width,
          visibleWidth: Math.ceil(visibleThickness),
          visibleHeight: visibleLength,
          zoneX: -zoneThicknessPad,
          zoneY: -zoneLengthPad,
          zoneWidth: visibleThickness + 2 * zoneThicknessPad,
          zoneHeight: visibleLength + 2 * zoneLengthPad,
          labelY: d.horizontal ? n.dy / 2 + 1 : n.dx / 2 + 1,
          left: n.originalLayer === 1,
          sizeAcross: d.width,
          forceLayouts: d.forceLayouts,
          horizontal: d.horizontal,
          darkBackground: tc.getBrightness() <= 128,
          tinyColorHue: Color.tinyRGB(tc),
          tinyColorAlpha: tc.getAlpha(),
          valueFormat: d.valueFormat,
          valueSuffix: d.valueSuffix,
          sankey: d.sankey,
          graph: d.graph,
          arrangement: d.arrangement,
          uniqueNodeLabelPathId: [d.guid, d.key, key].join('_'),
          interactionState: d.interactionState,
          figure: d
      };
  }
  
  // rendering snippets
  
  function updateNodePositions(sankeyNode) {
      sankeyNode
          .attr('transform', function(d) {
              return 'translate(' + d.node.x0.toFixed(3) + ', ' + (d.node.y0).toFixed(3) + ')';
          });
  }
  
  function updateNodeShapes(sankeyNode) {
      sankeyNode.call(updateNodePositions);
  }
  
  function updateShapes(sankeyNode, sankeyLink) {
      sankeyNode.call(updateNodeShapes);
      sankeyLink.attr('d', linkPath());
  }
  
  function sizeNode(rect) {
      rect
        .attr('width', function(d) {return d.node.x1 - d.node.x0;})
        .attr('height', function(d) {return d.visibleHeight;});
  }
  
  function salientEnough(d) {return (d.link.width > 1 || d.linkLineWidth > 0);}
  
  function sankeyTransform(d) {
      var offset = 'translate(' + d.translateX + ',' + d.translateY + ')';
      return offset + (d.horizontal ? 'matrix(1 0 0 1 0 0)' : 'matrix(0 1 1 0 0 0)');
  }
  
  function nodeCentering(d) {
      return 'translate(' + (d.horizontal ? 0 : d.labelY) + ' ' + (d.horizontal ? d.labelY : 0) + ')';
  }
  
  function textGuidePath(d) {
      return d3.svg.line()([
          [d.horizontal ? (d.left ? -d.sizeAcross : d.visibleWidth + c.nodeTextOffsetHorizontal) : c.nodeTextOffsetHorizontal, 0],
          [d.horizontal ? (d.left ? - c.nodeTextOffsetHorizontal : d.sizeAcross) : d.visibleHeight - c.nodeTextOffsetHorizontal, 0]
      ]);
  }
  
  function sankeyInverseTransform(d) {return d.horizontal ? 'matrix(1 0 0 1 0 0)' : 'matrix(0 1 1 0 0 0)';}
  function textFlip(d) {return d.horizontal ? 'scale(1 1)' : 'scale(-1 1)';}
  function nodeTextColor(d) {return d.darkBackground && !d.horizontal ? 'rgb(255,255,255)' : 'rgb(0,0,0)';}
  function nodeTextOffset(d) {return d.horizontal && d.left ? '100%' : '0%';}
  
  // event handling
  
  function attachPointerEvents(selection, sankey, eventSet) {
      selection
          .on('.basic', null) // remove any preexisting handlers
          .on('mouseover.basic', function(d) {
              if(!d.interactionState.dragInProgress && !d.partOfGroup) {
                  eventSet.hover(this, d, sankey);
                  d.interactionState.hovered = [this, d];
              }
          })
          .on('mousemove.basic', function(d) {
              if(!d.interactionState.dragInProgress && !d.partOfGroup) {
                  eventSet.follow(this, d);
                  d.interactionState.hovered = [this, d];
              }
          })
          .on('mouseout.basic', function(d) {
              if(!d.interactionState.dragInProgress && !d.partOfGroup) {
                  eventSet.unhover(this, d, sankey);
                  d.interactionState.hovered = false;
              }
          })
          .on('click.basic', function(d) {
              if(d.interactionState.hovered) {
                  eventSet.unhover(this, d, sankey);
                  d.interactionState.hovered = false;
              }
              if(!d.interactionState.dragInProgress && !d.partOfGroup) {
                  eventSet.select(this, d, sankey);
              }
          });
  }
  
  function attachDragHandler(sankeyNode, sankeyLink, callbacks, gd) {
      var dragBehavior = d3.behavior.drag()
          .origin(function(d) {
              return {
                  x: d.node.x0 + d.visibleWidth / 2,
                  y: d.node.y0 + d.visibleHeight / 2
              };
          })
  
          .on('dragstart', function(d) {
              if(d.arrangement === 'fixed') return;
              Lib.ensureSingle(gd._fullLayout._infolayer, 'g', 'dragcover', function(s) {
                  gd._fullLayout._dragCover = s;
              });
              Lib.raiseToTop(this);
              d.interactionState.dragInProgress = d.node;
  
              saveCurrentDragPosition(d.node);
              if(d.interactionState.hovered) {
                  callbacks.nodeEvents.unhover.apply(0, d.interactionState.hovered);
                  d.interactionState.hovered = false;
              }
              if(d.arrangement === 'snap') {
                  var forceKey = d.traceId + '|' + d.key;
                  if(d.forceLayouts[forceKey]) {
                      d.forceLayouts[forceKey].alpha(1);
                  } else { // make a forceLayout if needed
                      attachForce(sankeyNode, forceKey, d, gd);
                  }
                  startForce(sankeyNode, sankeyLink, d, forceKey, gd);
              }
          })
  
          .on('drag', function(d) {
              if(d.arrangement === 'fixed') return;
              var x = d3.event.x;
              var y = d3.event.y;
              if(d.arrangement === 'snap') {
                  d.node.x0 = x - d.visibleWidth / 2;
                  d.node.x1 = x + d.visibleWidth / 2;
                  d.node.y0 = y - d.visibleHeight / 2;
                  d.node.y1 = y + d.visibleHeight / 2;
              } else {
                  if(d.arrangement === 'freeform') {
                      d.node.x0 = x - d.visibleWidth / 2;
                      d.node.x1 = x + d.visibleWidth / 2;
                  }
                  y = Math.max(0, Math.min(d.size - d.visibleHeight / 2, y));
                  d.node.y0 = y - d.visibleHeight / 2;
                  d.node.y1 = y + d.visibleHeight / 2;
              }
  
              saveCurrentDragPosition(d.node);
              if(d.arrangement !== 'snap') {
                  d.sankey.update(d.graph);
                  updateShapes(sankeyNode.filter(sameLayer(d)), sankeyLink);
              }
          })
  
          .on('dragend', function(d) {
              if(d.arrangement === 'fixed') return;
              d.interactionState.dragInProgress = false;
              for(var i = 0; i < d.node.childrenNodes.length; i++) {
                  d.node.childrenNodes[i].x = d.node.x;
                  d.node.childrenNodes[i].y = d.node.y;
              }
              if(d.arrangement !== 'snap') persistFinalNodePositions(d, gd);
          });
  
      sankeyNode
          .on('.drag', null) // remove possible previous handlers
          .call(dragBehavior);
  }
  
  function attachForce(sankeyNode, forceKey, d, gd) {
      // Attach force to nodes in the same column (same x coordinate)
      switchToForceFormat(d.graph.nodes);
      var nodes = d.graph.nodes
          .filter(function(n) {return n.originalX === d.node.originalX;})
          // Filter out children
          .filter(function(n) {return !n.partOfGroup;});
      d.forceLayouts[forceKey] = d3Force.forceSimulation(nodes)
          .alphaDecay(0)
          .force('collide', d3Force.forceCollide()
              .radius(function(n) {return n.dy / 2 + d.nodePad / 2;})
              .strength(1)
              .iterations(c.forceIterations))
          .force('constrain', snappingForce(sankeyNode, forceKey, nodes, d, gd))
          .stop();
  }
  
  function startForce(sankeyNode, sankeyLink, d, forceKey, gd) {
      window.requestAnimationFrame(function faster() {
          var i;
          for(i = 0; i < c.forceTicksPerFrame; i++) {
              d.forceLayouts[forceKey].tick();
          }
  
          var nodes = d.graph.nodes;
          switchToSankeyFormat(nodes);
  
          d.sankey.update(d.graph);
          updateShapes(sankeyNode.filter(sameLayer(d)), sankeyLink);
  
          if(d.forceLayouts[forceKey].alpha() > 0) {
              window.requestAnimationFrame(faster);
          } else {
              // Make sure the final x position is equal to its original value
              // because the force simulation will have numerical error
              var x = d.node.originalX;
              d.node.x0 = x - d.visibleWidth / 2;
              d.node.x1 = x + d.visibleWidth / 2;
  
              persistFinalNodePositions(d, gd);
          }
      });
  }
  
  function snappingForce(sankeyNode, forceKey, nodes, d) {
      return function _snappingForce() {
          var maxVelocity = 0;
          for(var i = 0; i < nodes.length; i++) {
              var n = nodes[i];
              if(n === d.interactionState.dragInProgress) { // constrain node position to the dragging pointer
                  n.x = n.lastDraggedX;
                  n.y = n.lastDraggedY;
              } else {
                  n.vx = (n.originalX - n.x) / c.forceTicksPerFrame; // snap to layer
                  n.y = Math.min(d.size - n.dy / 2, Math.max(n.dy / 2, n.y)); // constrain to extent
              }
              maxVelocity = Math.max(maxVelocity, Math.abs(n.vx), Math.abs(n.vy));
          }
          if(!d.interactionState.dragInProgress && maxVelocity < 0.1 && d.forceLayouts[forceKey].alpha() > 0) {
              d.forceLayouts[forceKey].alpha(0); // This will stop the animation loop
          }
      };
  }
  
  // basic data utilities
  
  function persistFinalNodePositions(d, gd) {
      var x = [];
      var y = [];
      for(var i = 0; i < d.graph.nodes.length; i++) {
          var nodeX = (d.graph.nodes[i].x0 + d.graph.nodes[i].x1) / 2;
          var nodeY = (d.graph.nodes[i].y0 + d.graph.nodes[i].y1) / 2;
          x.push(nodeX / d.figure.width);
          y.push(nodeY / d.figure.height);
      }
      Registry.call('_guiRestyle', gd, {
          'node.x': [x],
          'node.y': [y]
      }, d.trace.index)
      .then(function() {
          if(gd._fullLayout._dragCover) gd._fullLayout._dragCover.remove();
      });
  }
  
  function persistOriginalPlace(nodes) {
      var distinctLayerPositions = [];
      var i;
      for(i = 0; i < nodes.length; i++) {
          nodes[i].originalX = (nodes[i].x0 + nodes[i].x1) / 2;
          nodes[i].originalY = (nodes[i].y0 + nodes[i].y1) / 2;
          if(distinctLayerPositions.indexOf(nodes[i].originalX) === -1) {
              distinctLayerPositions.push(nodes[i].originalX);
          }
      }
      distinctLayerPositions.sort(function(a, b) {return a - b;});
      for(i = 0; i < nodes.length; i++) {
          nodes[i].originalLayerIndex = distinctLayerPositions.indexOf(nodes[i].originalX);
          nodes[i].originalLayer = nodes[i].originalLayerIndex / (distinctLayerPositions.length - 1);
      }
  }
  
  function saveCurrentDragPosition(d) {
      d.lastDraggedX = d.x0 + d.dx / 2;
      d.lastDraggedY = d.y0 + d.dy / 2;
  }
  
  function sameLayer(d) {
      return function(n) {return n.node.originalX === d.node.originalX;};
  }
  
  function switchToForceFormat(nodes) {
      // force uses x, y as centers
      for(var i = 0; i < nodes.length; i++) {
          nodes[i].y = (nodes[i].y0 + nodes[i].y1) / 2;
          nodes[i].x = (nodes[i].x0 + nodes[i].x1) / 2;
      }
  }
  
  function switchToSankeyFormat(nodes) {
      // sankey uses x0, x1, y0, y1
      for(var i = 0; i < nodes.length; i++) {
          nodes[i].y0 = nodes[i].y - nodes[i].dy / 2;
          nodes[i].y1 = nodes[i].y0 + nodes[i].dy;
  
          nodes[i].x0 = nodes[i].x - nodes[i].dx / 2;
          nodes[i].x1 = nodes[i].x0 + nodes[i].dx;
      }
  }
  
  // scene graph
  module.exports = function(gd, svg, calcData, layout, callbacks) {
      // To prevent animation on first render
      var firstRender = false;
      Lib.ensureSingle(gd._fullLayout._infolayer, 'g', 'first-render', function() {
          firstRender = true;
      });
  
      // To prevent animation on dragging
      var dragcover = gd._fullLayout._dragCover;
  
      var styledData = calcData
              .filter(function(d) {return unwrap(d).trace.visible;})
              .map(sankeyModel.bind(null, layout));
  
      var sankey = svg.selectAll('.' + c.cn.sankey)
          .data(styledData, keyFun);
  
      sankey.exit()
          .remove();
  
      sankey.enter()
          .append('g')
          .classed(c.cn.sankey, true)
          .style('box-sizing', 'content-box')
          .style('position', 'absolute')
          .style('left', 0)
          .style('shape-rendering', 'geometricPrecision')
          .style('pointer-events', 'auto')
          .attr('transform', sankeyTransform);
  
      sankey.each(function(d, i) {
          gd._fullData[i]._sankey = d;
          // Create dragbox if missing
          var dragboxClassName = 'bgsankey-' + d.trace.uid + '-' + i;
          Lib.ensureSingle(gd._fullLayout._draggers, 'rect', dragboxClassName);
  
          gd._fullData[i]._bgRect = d3.select('.' + dragboxClassName);
  
          // Style dragbox
          gd._fullData[i]._bgRect
            .style('pointer-events', 'all')
            .attr('width', d.width)
            .attr('height', d.height)
            .attr('x', d.translateX)
            .attr('y', d.translateY)
            .classed('bgsankey', true)
            .style({fill: 'transparent', 'stroke-width': 0});
      });
  
      sankey.transition()
          .ease(c.ease).duration(c.duration)
          .attr('transform', sankeyTransform);
  
      var sankeyLinks = sankey.selectAll('.' + c.cn.sankeyLinks)
          .data(repeat, keyFun);
  
      sankeyLinks.enter()
          .append('g')
          .classed(c.cn.sankeyLinks, true)
          .style('fill', 'none');
  
      var sankeyLink = sankeyLinks.selectAll('.' + c.cn.sankeyLink)
            .data(function(d) {
                var links = d.graph.links;
                return links
                  .filter(function(l) {return l.value;})
                  .map(linkModel.bind(null, d));
            }, keyFun);
  
      sankeyLink
            .enter().append('path')
            .classed(c.cn.sankeyLink, true)
            .call(attachPointerEvents, sankey, callbacks.linkEvents);
  
      sankeyLink
          .style('stroke', function(d) {
              return salientEnough(d) ? Color.tinyRGB(tinycolor(d.linkLineColor)) : d.tinyColorHue;
          })
          .style('stroke-opacity', function(d) {
              return salientEnough(d) ? Color.opacity(d.linkLineColor) : d.tinyColorAlpha;
          })
          .style('fill', function(d) {
              return d.tinyColorHue;
          })
          .style('fill-opacity', function(d) {
              return d.tinyColorAlpha;
          })
          .style('stroke-width', function(d) {
              return salientEnough(d) ? d.linkLineWidth : 1;
          })
          .attr('d', linkPath());
  
      sankeyLink
          .style('opacity', function() { return (gd._context.staticPlot || firstRender || dragcover) ? 1 : 0;})
          .transition()
          .ease(c.ease).duration(c.duration)
          .style('opacity', 1);
  
      sankeyLink.exit()
          .transition()
          .ease(c.ease).duration(c.duration)
          .style('opacity', 0)
          .remove();
  
      var sankeyNodeSet = sankey.selectAll('.' + c.cn.sankeyNodeSet)
          .data(repeat, keyFun);
  
      sankeyNodeSet.enter()
          .append('g')
          .classed(c.cn.sankeyNodeSet, true);
  
      sankeyNodeSet
          .style('cursor', function(d) {
              switch(d.arrangement) {
                  case 'fixed': return 'default';
                  case 'perpendicular': return 'ns-resize';
                  default: return 'move';
              }
          });
  
      var sankeyNode = sankeyNodeSet.selectAll('.' + c.cn.sankeyNode)
          .data(function(d) {
              var nodes = d.graph.nodes;
              persistOriginalPlace(nodes);
              return nodes
                .map(nodeModel.bind(null, d));
          }, keyFun);
  
      sankeyNode.enter()
          .append('g')
          .classed(c.cn.sankeyNode, true)
          .call(updateNodePositions)
          .style('opacity', function(n) { return ((gd._context.staticPlot || firstRender) && !n.partOfGroup) ? 1 : 0;});
  
      sankeyNode
          .call(attachPointerEvents, sankey, callbacks.nodeEvents)
          .call(attachDragHandler, sankeyLink, callbacks, gd); // has to be here as it binds sankeyLink
  
      sankeyNode
          .transition()
          .ease(c.ease).duration(c.duration)
          .call(updateNodePositions)
          .style('opacity', function(n) { return n.partOfGroup ? 0 : 1;});
  
      sankeyNode.exit()
          .transition()
          .ease(c.ease).duration(c.duration)
          .style('opacity', 0)
          .remove();
  
      var nodeRect = sankeyNode.selectAll('.' + c.cn.nodeRect)
          .data(repeat);
  
      nodeRect.enter()
          .append('rect')
          .classed(c.cn.nodeRect, true)
          .call(sizeNode);
  
      nodeRect
          .style('stroke-width', function(d) {return d.nodeLineWidth;})
          .style('stroke', function(d) {return Color.tinyRGB(tinycolor(d.nodeLineColor));})
          .style('stroke-opacity', function(d) {return Color.opacity(d.nodeLineColor);})
          .style('fill', function(d) {return d.tinyColorHue;})
          .style('fill-opacity', function(d) {return d.tinyColorAlpha;});
  
      nodeRect.transition()
          .ease(c.ease).duration(c.duration)
          .call(sizeNode);
  
      var nodeCapture = sankeyNode.selectAll('.' + c.cn.nodeCapture)
          .data(repeat);
  
      nodeCapture.enter()
          .append('rect')
          .classed(c.cn.nodeCapture, true)
          .style('fill-opacity', 0);
  
      nodeCapture
          .attr('x', function(d) {return d.zoneX;})
          .attr('y', function(d) {return d.zoneY;})
          .attr('width', function(d) {return d.zoneWidth;})
          .attr('height', function(d) {return d.zoneHeight;});
  
      var nodeCentered = sankeyNode.selectAll('.' + c.cn.nodeCentered)
          .data(repeat);
  
      nodeCentered.enter()
          .append('g')
          .classed(c.cn.nodeCentered, true)
          .attr('transform', nodeCentering);
  
      nodeCentered
          .transition()
          .ease(c.ease).duration(c.duration)
          .attr('transform', nodeCentering);
  
      var nodeLabelGuide = nodeCentered.selectAll('.' + c.cn.nodeLabelGuide)
          .data(repeat);
  
      nodeLabelGuide.enter()
          .append('path')
          .classed(c.cn.nodeLabelGuide, true)
          .attr('id', function(d) {return d.uniqueNodeLabelPathId;})
          .attr('d', textGuidePath)
          .attr('transform', sankeyInverseTransform);
  
      nodeLabelGuide
          .transition()
          .ease(c.ease).duration(c.duration)
          .attr('d', textGuidePath)
          .attr('transform', sankeyInverseTransform);
  
      var nodeLabel = nodeCentered.selectAll('.' + c.cn.nodeLabel)
          .data(repeat);
  
      nodeLabel.enter()
          .append('text')
          .classed(c.cn.nodeLabel, true)
          .attr('transform', textFlip)
          .style('cursor', 'default')
          .style('fill', 'black');
  
      nodeLabel
          .style('text-shadow', function(d) {
              return d.horizontal ? '-1px 1px 1px #fff, 1px 1px 1px #fff, 1px -1px 1px #fff, -1px -1px 1px #fff' : 'none';
          })
          .each(function(d) {Drawing.font(nodeLabel, d.textFont);});
  
      nodeLabel
          .transition()
          .ease(c.ease).duration(c.duration)
          .attr('transform', textFlip);
  
      var nodeLabelTextPath = nodeLabel.selectAll('.' + c.cn.nodeLabelTextPath)
          .data(repeat);
  
      nodeLabelTextPath.enter()
          .append('textPath')
          .classed(c.cn.nodeLabelTextPath, true)
          .attr('alignment-baseline', 'middle')
          .attr('xlink:href', function(d) {return '#' + d.uniqueNodeLabelPathId;})
          .attr('startOffset', nodeTextOffset)
          .style('fill', nodeTextColor);
  
      nodeLabelTextPath
          .text(function(d) {return d.horizontal || d.node.dy > 5 ? d.node.label : '';})
          .attr('text-anchor', function(d) {return d.horizontal && d.left ? 'end' : 'start';});
  
      nodeLabelTextPath
          .transition()
          .ease(c.ease).duration(c.duration)
          .attr('startOffset', nodeTextOffset)
          .style('fill', nodeTextColor);
  };
  
  },{"../../components/color":615,"../../components/drawing":637,"../../lib":750,"../../lib/gup":747,"../../registry":882,"./constants":1151,"@plotly/d3-sankey":56,"@plotly/d3-sankey-circular":55,"d3":169,"d3-force":160,"d3-interpolate":162,"tinycolor2":548}],1156:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function selectPoints(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var selection = [];
      var fullData = cd[0].trace;
  
      var nodes = fullData._sankey.graph.nodes;
  
      for(var i = 0; i < nodes.length; i++) {
          var node = nodes[i];
          if(node.partOfGroup) continue; // Those are invisible
  
          // Position of node's centroid
          var pos = [(node.x0 + node.x1) / 2, (node.y0 + node.y1) / 2];
  
          // Swap x and y if trace is vertical
          if(fullData.orientation === 'v') pos.reverse();
  
          if(selectionTester && selectionTester.contains(pos, false, i, searchInfo)) {
              selection.push({
                  pointNumber: node.pointNumber
                  // TODO: add eventData
              });
          }
      }
      return selection;
  };
  
  },{}],1157:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  
  // arrayOk attributes, merge them into calcdata array
  module.exports = function arraysToCalcdata(cd, trace) {
      // so each point knows which index it originally came from
      for(var i = 0; i < cd.length; i++) cd[i].i = i;
  
      Lib.mergeArray(trace.text, cd, 'tx');
      Lib.mergeArray(trace.texttemplate, cd, 'txt');
      Lib.mergeArray(trace.hovertext, cd, 'htx');
      Lib.mergeArray(trace.customdata, cd, 'data');
      Lib.mergeArray(trace.textposition, cd, 'tp');
      if(trace.textfont) {
          Lib.mergeArrayCastPositive(trace.textfont.size, cd, 'ts');
          Lib.mergeArray(trace.textfont.color, cd, 'tc');
          Lib.mergeArray(trace.textfont.family, cd, 'tf');
      }
  
      var marker = trace.marker;
      if(marker) {
          Lib.mergeArrayCastPositive(marker.size, cd, 'ms');
          Lib.mergeArrayCastPositive(marker.opacity, cd, 'mo');
          Lib.mergeArray(marker.symbol, cd, 'mx');
          Lib.mergeArray(marker.color, cd, 'mc');
  
          var markerLine = marker.line;
          if(marker.line) {
              Lib.mergeArray(markerLine.color, cd, 'mlc');
              Lib.mergeArrayCastPositive(markerLine.width, cd, 'mlw');
          }
  
          var markerGradient = marker.gradient;
          if(markerGradient && markerGradient.type !== 'none') {
              Lib.mergeArray(markerGradient.type, cd, 'mgt');
              Lib.mergeArray(markerGradient.color, cd, 'mgc');
          }
      }
  };
  
  },{"../../lib":750}],1158:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var dash = _dereq_('../../components/drawing/attributes').dash;
  
  var Drawing = _dereq_('../../components/drawing');
  var constants = _dereq_('./constants');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  function axisPeriod(axis) {
      return {
          valType: 'any',
          dflt: 0,
          
          editType: 'calc',
          
      };
  }
  
  function axisPeriod0(axis) {
      return {
          valType: 'any',
          
          editType: 'calc',
          
      };
  }
  
  function axisPeriodAlignment(axis) {
      return {
          valType: 'enumerated',
          values: [
              'start', 'middle', 'end'
          ],
          dflt: 'middle',
          
          editType: 'calc',
          
      };
  }
  
  module.exports = {
      x: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          anim: true,
          
      },
      x0: {
          valType: 'any',
          dflt: 0,
          
          editType: 'calc+clearAxisTypes',
          anim: true,
          
      },
      dx: {
          valType: 'number',
          dflt: 1,
          
          editType: 'calc',
          anim: true,
          
      },
      y: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          anim: true,
          
      },
      y0: {
          valType: 'any',
          dflt: 0,
          
          editType: 'calc+clearAxisTypes',
          anim: true,
          
      },
      dy: {
          valType: 'number',
          dflt: 1,
          
          editType: 'calc',
          anim: true,
          
      },
  
      xperiod: axisPeriod('x'),
      yperiod: axisPeriod('y'),
      xperiod0: axisPeriod0('x0'),
      yperiod0: axisPeriod0('y0'),
      xperiodalignment: axisPeriodAlignment('x'),
      yperiodalignment: axisPeriodAlignment('y'),
  
      stackgroup: {
          valType: 'string',
          
          dflt: '',
          editType: 'calc',
          
      },
      orientation: {
          valType: 'enumerated',
          
          values: ['v', 'h'],
          editType: 'calc',
          
      },
      groupnorm: {
          valType: 'enumerated',
          values: ['', 'fraction', 'percent'],
          dflt: '',
          
          editType: 'calc',
          
      },
      stackgaps: {
          valType: 'enumerated',
          values: ['infer zero', 'interpolate'],
          dflt: 'infer zero',
          
          editType: 'calc',
          
      },
  
      text: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          editType: 'calc',
          
      },
  
      texttemplate: texttemplateAttrs({}, {
  
      }),
      hovertext: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          editType: 'style',
          
      },
      mode: {
          valType: 'flaglist',
          flags: ['lines', 'markers', 'text'],
          extras: ['none'],
          
          editType: 'calc',
          
      },
      hoveron: {
          valType: 'flaglist',
          flags: ['points', 'fills'],
          
          editType: 'style',
          
      },
      hovertemplate: hovertemplateAttrs({}, {
          keys: constants.eventDataKeys
      }),
      line: {
          color: {
              valType: 'color',
              
              editType: 'style',
              anim: true,
              
          },
          width: {
              valType: 'number',
              min: 0,
              dflt: 2,
              
              editType: 'style',
              anim: true,
              
          },
          shape: {
              valType: 'enumerated',
              values: ['linear', 'spline', 'hv', 'vh', 'hvh', 'vhv'],
              dflt: 'linear',
              
              editType: 'plot',
              
          },
          smoothing: {
              valType: 'number',
              min: 0,
              max: 1.3,
              dflt: 1,
              
              editType: 'plot',
              
          },
          dash: extendFlat({}, dash, {editType: 'style'}),
          simplify: {
              valType: 'boolean',
              dflt: true,
              
              editType: 'plot',
              
          },
          editType: 'plot'
      },
  
      connectgaps: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'calc',
          
      },
      cliponaxis: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'plot',
          
      },
  
      fill: {
          valType: 'enumerated',
          values: ['none', 'tozeroy', 'tozerox', 'tonexty', 'tonextx', 'toself', 'tonext'],
          
          editType: 'calc',
          
      },
      fillcolor: {
          valType: 'color',
          
          editType: 'style',
          anim: true,
          
      },
      marker: extendFlat({
          symbol: {
              valType: 'enumerated',
              values: Drawing.symbolList,
              dflt: 'circle',
              arrayOk: true,
              
              editType: 'style',
              
          },
          opacity: {
              valType: 'number',
              min: 0,
              max: 1,
              arrayOk: true,
              
              editType: 'style',
              anim: true,
              
          },
          size: {
              valType: 'number',
              min: 0,
              dflt: 6,
              arrayOk: true,
              
              editType: 'calc',
              anim: true,
              
          },
          maxdisplayed: {
              valType: 'number',
              min: 0,
              dflt: 0,
              
              editType: 'plot',
              
          },
          sizeref: {
              valType: 'number',
              dflt: 1,
              
              editType: 'calc',
              
          },
          sizemin: {
              valType: 'number',
              min: 0,
              dflt: 0,
              
              editType: 'calc',
              
          },
          sizemode: {
              valType: 'enumerated',
              values: ['diameter', 'area'],
              dflt: 'diameter',
              
              editType: 'calc',
              
          },
  
          line: extendFlat({
              width: {
                  valType: 'number',
                  min: 0,
                  arrayOk: true,
                  
                  editType: 'style',
                  anim: true,
                  
              },
              editType: 'calc'
          },
              colorScaleAttrs('marker.line', {anim: true})
          ),
          gradient: {
              type: {
                  valType: 'enumerated',
                  values: ['radial', 'horizontal', 'vertical', 'none'],
                  arrayOk: true,
                  dflt: 'none',
                  
                  editType: 'calc',
                  
              },
              color: {
                  valType: 'color',
                  arrayOk: true,
                  
                  editType: 'calc',
                  
              },
              editType: 'calc'
          },
          editType: 'calc'
      },
          colorScaleAttrs('marker', {anim: true})
      ),
      selected: {
          marker: {
              opacity: {
                  valType: 'number',
                  min: 0,
                  max: 1,
                  
                  editType: 'style',
                  
              },
              color: {
                  valType: 'color',
                  
                  editType: 'style',
                  
              },
              size: {
                  valType: 'number',
                  min: 0,
                  
                  editType: 'style',
                  
              },
              editType: 'style'
          },
          textfont: {
              color: {
                  valType: 'color',
                  
                  editType: 'style',
                  
              },
              editType: 'style'
          },
          editType: 'style'
      },
      unselected: {
          marker: {
              opacity: {
                  valType: 'number',
                  min: 0,
                  max: 1,
                  
                  editType: 'style',
                  
              },
              color: {
                  valType: 'color',
                  
                  editType: 'style',
                  
              },
              size: {
                  valType: 'number',
                  min: 0,
                  
                  editType: 'style',
                  
              },
              editType: 'style'
          },
          textfont: {
              color: {
                  valType: 'color',
                  
                  editType: 'style',
                  
              },
              editType: 'style'
          },
          editType: 'style'
      },
  
      textposition: {
          valType: 'enumerated',
          values: [
              'top left', 'top center', 'top right',
              'middle left', 'middle center', 'middle right',
              'bottom left', 'bottom center', 'bottom right'
          ],
          dflt: 'middle center',
          arrayOk: true,
          
          editType: 'calc',
          
      },
      textfont: fontAttrs({
          editType: 'calc',
          colorEditType: 'style',
          arrayOk: true,
          
      }),
  
      r: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      t: {
          valType: 'data_array',
          editType: 'calc',
          
      }
  };
  
  },{"../../components/colorscale/attributes":622,"../../components/drawing":637,"../../components/drawing/attributes":636,"../../lib/extend":740,"../../plots/font_attributes":827,"../../plots/template_attributes":877,"./constants":1162}],1159:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var Lib = _dereq_('../../lib');
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  var subTypes = _dereq_('./subtypes');
  var calcColorscale = _dereq_('./colorscale_calc');
  var arraysToCalcdata = _dereq_('./arrays_to_calcdata');
  var calcSelection = _dereq_('./calc_selection');
  
  function calc(gd, trace) {
      var fullLayout = gd._fullLayout;
      var xa = Axes.getFromId(gd, trace.xaxis || 'x');
      var ya = Axes.getFromId(gd, trace.yaxis || 'y');
      var origX = xa.makeCalcdata(trace, 'x');
      var origY = ya.makeCalcdata(trace, 'y');
      var x = alignPeriod(trace, xa, 'x', origX);
      var y = alignPeriod(trace, ya, 'y', origY);
  
      var serieslen = trace._length;
      var cd = new Array(serieslen);
      var ids = trace.ids;
      var stackGroupOpts = getStackOpts(trace, fullLayout, xa, ya);
      var interpolateGaps = false;
      var isV, i, j, k, interpolate, vali;
  
      setFirstScatter(fullLayout, trace);
  
      var xAttr = 'x';
      var yAttr = 'y';
      var posAttr;
      if(stackGroupOpts) {
          Lib.pushUnique(stackGroupOpts.traceIndices, trace._expandedIndex);
          isV = stackGroupOpts.orientation === 'v';
  
          // size, like we use for bar
          if(isV) {
              yAttr = 's';
              posAttr = 'x';
          } else {
              xAttr = 's';
              posAttr = 'y';
          }
          interpolate = stackGroupOpts.stackgaps === 'interpolate';
      } else {
          var ppad = calcMarkerSize(trace, serieslen);
          calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
      }
  
      var hasPeriodX = !!trace.xperiodalignment;
      var hasPeriodY = !!trace.yperiodalignment;
  
      for(i = 0; i < serieslen; i++) {
          var cdi = cd[i] = {};
          var xValid = isNumeric(x[i]);
          var yValid = isNumeric(y[i]);
          if(xValid && yValid) {
              cdi[xAttr] = x[i];
              cdi[yAttr] = y[i];
  
              if(hasPeriodX) {
                  cdi.orig_x = origX[i]; // used by hover
              }
              if(hasPeriodY) {
                  cdi.orig_y = origY[i]; // used by hover
              }
          } else if(stackGroupOpts && (isV ? xValid : yValid)) {
              // if we're stacking we need to hold on to all valid positions
              // even with invalid sizes
  
              cdi[posAttr] = isV ? x[i] : y[i];
              cdi.gap = true;
              if(interpolate) {
                  cdi.s = BADNUM;
                  interpolateGaps = true;
              } else {
                  cdi.s = 0;
              }
          } else {
              cdi[xAttr] = cdi[yAttr] = BADNUM;
          }
  
          if(ids) {
              cdi.id = String(ids[i]);
          }
      }
  
      arraysToCalcdata(cd, trace);
      calcColorscale(gd, trace);
      calcSelection(cd, trace);
  
      if(stackGroupOpts) {
          // remove bad positions and sort
          // note that original indices get added to cd in arraysToCalcdata
          i = 0;
          while(i < cd.length) {
              if(cd[i][posAttr] === BADNUM) {
                  cd.splice(i, 1);
              } else i++;
          }
  
          Lib.sort(cd, function(a, b) {
              return (a[posAttr] - b[posAttr]) || (a.i - b.i);
          });
  
          if(interpolateGaps) {
              // first fill the beginning with constant from the first point
              i = 0;
              while(i < cd.length - 1 && cd[i].gap) {
                  i++;
              }
              vali = cd[i].s;
              if(!vali) vali = cd[i].s = 0; // in case of no data AT ALL in this trace - use 0
              for(j = 0; j < i; j++) {
                  cd[j].s = vali;
              }
              // then fill the end with constant from the last point
              k = cd.length - 1;
              while(k > i && cd[k].gap) {
                  k--;
              }
              vali = cd[k].s;
              for(j = cd.length - 1; j > k; j--) {
                  cd[j].s = vali;
              }
              // now interpolate internal gaps linearly
              while(i < k) {
                  i++;
                  if(cd[i].gap) {
                      j = i + 1;
                      while(cd[j].gap) {
                          j++;
                      }
                      var pos0 = cd[i - 1][posAttr];
                      var size0 = cd[i - 1].s;
                      var m = (cd[j].s - size0) / (cd[j][posAttr] - pos0);
                      while(i < j) {
                          cd[i].s = size0 + (cd[i][posAttr] - pos0) * m;
                          i++;
                      }
                  }
              }
          }
      }
  
      return cd;
  }
  
  function calcAxisExpansion(gd, trace, xa, ya, x, y, ppad) {
      var serieslen = trace._length;
      var fullLayout = gd._fullLayout;
      var xId = xa._id;
      var yId = ya._id;
      var firstScatter = fullLayout._firstScatter[firstScatterGroup(trace)] === trace.uid;
      var stackOrientation = (getStackOpts(trace, fullLayout, xa, ya) || {}).orientation;
      var fill = trace.fill;
  
      // cancel minimum tick spacings (only applies to bars and boxes)
      xa._minDtick = 0;
      ya._minDtick = 0;
  
      // check whether bounds should be tight, padded, extended to zero...
      // most cases both should be padded on both ends, so start with that.
      var xOptions = {padded: true};
      var yOptions = {padded: true};
  
      if(ppad) {
          xOptions.ppad = yOptions.ppad = ppad;
      }
  
      // TODO: text size
  
      var openEnded = serieslen < 2 || (x[0] !== x[serieslen - 1]) || (y[0] !== y[serieslen - 1]);
  
      if(openEnded && (
          (fill === 'tozerox') ||
          ((fill === 'tonextx') && (firstScatter || stackOrientation === 'h'))
      )) {
          // include zero (tight) and extremes (padded) if fill to zero
          // (unless the shape is closed, then it's just filling the shape regardless)
  
          xOptions.tozero = true;
      } else if(!(trace.error_y || {}).visible && (
          // if no error bars, markers or text, or fill to y=0 remove x padding
  
              (fill === 'tonexty' || fill === 'tozeroy') ||
              (!subTypes.hasMarkers(trace) && !subTypes.hasText(trace))
          )) {
          xOptions.padded = false;
          xOptions.ppad = 0;
      }
  
      if(openEnded && (
          (fill === 'tozeroy') ||
          ((fill === 'tonexty') && (firstScatter || stackOrientation === 'v'))
      )) {
          // now check for y - rather different logic, though still mostly padded both ends
          // include zero (tight) and extremes (padded) if fill to zero
          // (unless the shape is closed, then it's just filling the shape regardless)
  
          yOptions.tozero = true;
      } else if(fill === 'tonextx' || fill === 'tozerox') {
          // tight y: any x fill
  
          yOptions.padded = false;
      }
  
      // N.B. asymmetric splom traces call this with blank {} xa or ya
      if(xId) trace._extremes[xId] = Axes.findExtremes(xa, x, xOptions);
      if(yId) trace._extremes[yId] = Axes.findExtremes(ya, y, yOptions);
  }
  
  function calcMarkerSize(trace, serieslen) {
      if(!subTypes.hasMarkers(trace)) return;
  
      // Treat size like x or y arrays --- Run d2c
      // this needs to go before ppad computation
      var marker = trace.marker;
      var sizeref = 1.6 * (trace.marker.sizeref || 1);
      var markerTrans;
  
      if(trace.marker.sizemode === 'area') {
          markerTrans = function(v) {
              return Math.max(Math.sqrt((v || 0) / sizeref), 3);
          };
      } else {
          markerTrans = function(v) {
              return Math.max((v || 0) / sizeref, 3);
          };
      }
  
      if(Lib.isArrayOrTypedArray(marker.size)) {
          // I tried auto-type but category and dates dont make much sense.
          var ax = {type: 'linear'};
          Axes.setConvert(ax);
  
          var s = ax.makeCalcdata(trace.marker, 'size');
  
          var sizeOut = new Array(serieslen);
          for(var i = 0; i < serieslen; i++) {
              sizeOut[i] = markerTrans(s[i]);
          }
          return sizeOut;
      } else {
          return markerTrans(marker.size);
      }
  }
  
  /**
   * mark the first scatter trace for each subplot
   * note that scatter and scattergl each get their own first trace
   * note also that I'm doing this during calc rather than supplyDefaults
   * so I don't need to worry about transforms, but if we ever do
   * per-trace calc this will get confused.
   */
  function setFirstScatter(fullLayout, trace) {
      var group = firstScatterGroup(trace);
      var firstScatter = fullLayout._firstScatter;
      if(!firstScatter[group]) firstScatter[group] = trace.uid;
  }
  
  function firstScatterGroup(trace) {
      var stackGroup = trace.stackgroup;
      return trace.xaxis + trace.yaxis + trace.type +
          (stackGroup ? '-' + stackGroup : '');
  }
  
  function getStackOpts(trace, fullLayout, xa, ya) {
      var stackGroup = trace.stackgroup;
      if(!stackGroup) return;
      var stackOpts = fullLayout._scatterStackOpts[xa._id + ya._id][stackGroup];
      var stackAx = stackOpts.orientation === 'v' ? ya : xa;
      // Allow stacking only on numeric axes
      // calc is a little late to be figuring this out, but during supplyDefaults
      // we don't know the axis type yet
      if(stackAx.type === 'linear' || stackAx.type === 'log') return stackOpts;
  }
  
  module.exports = {
      calc: calc,
      calcMarkerSize: calcMarkerSize,
      calcAxisExpansion: calcAxisExpansion,
      setFirstScatter: setFirstScatter,
      getStackOpts: getStackOpts
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/align_period":796,"../../plots/cartesian/axes":799,"./arrays_to_calcdata":1157,"./calc_selection":1160,"./colorscale_calc":1161,"./subtypes":1183,"fast-isnumeric":241}],1160:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  module.exports = function calcSelection(cd, trace) {
      if(Lib.isArrayOrTypedArray(trace.selectedpoints)) {
          Lib.tagSelected(cd, trace);
      }
  };
  
  },{"../../lib":750}],1161:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
  var calcColorscale = _dereq_('../../components/colorscale/calc');
  
  var subTypes = _dereq_('./subtypes');
  
  module.exports = function calcMarkerColorscale(gd, trace) {
      if(subTypes.hasLines(trace) && hasColorscale(trace, 'line')) {
          calcColorscale(gd, trace, {
              vals: trace.line.color,
              containerStr: 'line',
              cLetter: 'c'
          });
      }
  
      if(subTypes.hasMarkers(trace)) {
          if(hasColorscale(trace, 'marker')) {
              calcColorscale(gd, trace, {
                  vals: trace.marker.color,
                  containerStr: 'marker',
                  cLetter: 'c'
              });
          }
          if(hasColorscale(trace, 'marker.line')) {
              calcColorscale(gd, trace, {
                  vals: trace.marker.line.color,
                  containerStr: 'marker.line',
                  cLetter: 'c'
              });
          }
      }
  };
  
  },{"../../components/colorscale/calc":623,"../../components/colorscale/helpers":626,"./subtypes":1183}],1162:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = {
      PTS_LINESONLY: 20,
  
      // fixed parameters of clustering and clipping algorithms
  
      // fraction of clustering tolerance "so close we don't even consider it a new point"
      minTolerance: 0.2,
      // how fast does clustering tolerance increase as you get away from the visible region
      toleranceGrowth: 10,
  
      // number of viewport sizes away from the visible region
      // at which we clip all lines to the perimeter
      maxScreensAway: 20,
  
      eventDataKeys: []
  };
  
  },{}],1163:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var calc = _dereq_('./calc');
  
  /*
   * Scatter stacking & normalization calculations
   * runs per subplot, and can handle multiple stacking groups
   */
  
  module.exports = function crossTraceCalc(gd, plotinfo) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
      var subplot = xa._id + ya._id;
  
      var subplotStackOpts = gd._fullLayout._scatterStackOpts[subplot];
      if(!subplotStackOpts) return;
  
      var calcTraces = gd.calcdata;
  
      var i, j, k, i2, cd, cd0, posj, sumj, norm;
      var groupOpts, interpolate, groupnorm, posAttr, valAttr;
      var hasAnyBlanks;
  
      for(var stackGroup in subplotStackOpts) {
          groupOpts = subplotStackOpts[stackGroup];
          var indices = groupOpts.traceIndices;
  
          // can get here with no indices if the stack axis is non-numeric
          if(!indices.length) continue;
  
          interpolate = groupOpts.stackgaps === 'interpolate';
          groupnorm = groupOpts.groupnorm;
          if(groupOpts.orientation === 'v') {
              posAttr = 'x';
              valAttr = 'y';
          } else {
              posAttr = 'y';
              valAttr = 'x';
          }
          hasAnyBlanks = new Array(indices.length);
          for(i = 0; i < hasAnyBlanks.length; i++) {
              hasAnyBlanks[i] = false;
          }
  
          // Collect the complete set of all positions across ALL traces.
          // Start with the first trace, then interleave items from later traces
          // as needed.
          // Fill in mising items as we go.
          cd0 = calcTraces[indices[0]];
          var allPositions = new Array(cd0.length);
          for(i = 0; i < cd0.length; i++) {
              allPositions[i] = cd0[i][posAttr];
          }
  
          for(i = 1; i < indices.length; i++) {
              cd = calcTraces[indices[i]];
  
              for(j = k = 0; j < cd.length; j++) {
                  posj = cd[j][posAttr];
                  for(; posj > allPositions[k] && k < allPositions.length; k++) {
                      // the current trace is missing a position from some previous trace(s)
                      insertBlank(cd, j, allPositions[k], i, hasAnyBlanks, interpolate, posAttr);
                      j++;
                  }
                  if(posj !== allPositions[k]) {
                      // previous trace(s) are missing a position from the current trace
                      for(i2 = 0; i2 < i; i2++) {
                          insertBlank(calcTraces[indices[i2]], k, posj, i2, hasAnyBlanks, interpolate, posAttr);
                      }
                      allPositions.splice(k, 0, posj);
                  }
                  k++;
              }
              for(; k < allPositions.length; k++) {
                  insertBlank(cd, j, allPositions[k], i, hasAnyBlanks, interpolate, posAttr);
                  j++;
              }
          }
  
          var serieslen = allPositions.length;
  
          // stack (and normalize)!
          for(j = 0; j < cd0.length; j++) {
              sumj = cd0[j][valAttr] = cd0[j].s;
              for(i = 1; i < indices.length; i++) {
                  cd = calcTraces[indices[i]];
                  cd[0].trace._rawLength = cd[0].trace._length;
                  cd[0].trace._length = serieslen;
                  sumj += cd[j].s;
                  cd[j][valAttr] = sumj;
              }
  
              if(groupnorm) {
                  norm = ((groupnorm === 'fraction') ? sumj : (sumj / 100)) || 1;
                  for(i = 0; i < indices.length; i++) {
                      var cdj = calcTraces[indices[i]][j];
                      cdj[valAttr] /= norm;
                      cdj.sNorm = cdj.s / norm;
                  }
              }
          }
  
          // autorange
          for(i = 0; i < indices.length; i++) {
              cd = calcTraces[indices[i]];
              var trace = cd[0].trace;
              var ppad = calc.calcMarkerSize(trace, trace._rawLength);
              var arrayPad = Array.isArray(ppad);
              if((ppad && hasAnyBlanks[i]) || arrayPad) {
                  var ppadRaw = ppad;
                  ppad = new Array(serieslen);
                  for(j = 0; j < serieslen; j++) {
                      ppad[j] = cd[j].gap ? 0 : (arrayPad ? ppadRaw[cd[j].i] : ppadRaw);
                  }
              }
              var x = new Array(serieslen);
              var y = new Array(serieslen);
              for(j = 0; j < serieslen; j++) {
                  x[j] = cd[j].x;
                  y[j] = cd[j].y;
              }
              calc.calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
  
              // while we're here (in a loop over all traces in the stack)
              // record the orientation, so hover can find it easily
              cd[0].t.orientation = groupOpts.orientation;
          }
      }
  };
  
  function insertBlank(calcTrace, index, position, traceIndex, hasAnyBlanks, interpolate, posAttr) {
      hasAnyBlanks[traceIndex] = true;
      var newEntry = {
          i: null,
          gap: true,
          s: 0
      };
      newEntry[posAttr] = position;
      calcTrace.splice(index, 0, newEntry);
      // Even if we're not interpolating, if one trace has multiple
      // values at the same position and this trace only has one value there,
      // we just duplicate that one value rather than insert a zero.
      // We also make it look like a real point - because it's ambiguous which
      // one really is the real one!
      if(index && position === calcTrace[index - 1][posAttr]) {
          var prevEntry = calcTrace[index - 1];
          newEntry.s = prevEntry.s;
          // TODO is it going to cause any problems to have multiple
          // calcdata points with the same index?
          newEntry.i = prevEntry.i;
          newEntry.gap = prevEntry.gap;
      } else if(interpolate) {
          newEntry.s = getInterp(calcTrace, index, position, posAttr);
      }
      if(!index) {
          // t and trace need to stay on the first cd entry
          calcTrace[0].t = calcTrace[1].t;
          calcTrace[0].trace = calcTrace[1].trace;
          delete calcTrace[1].t;
          delete calcTrace[1].trace;
      }
  }
  
  function getInterp(calcTrace, index, position, posAttr) {
      var pt0 = calcTrace[index - 1];
      var pt1 = calcTrace[index + 1];
      if(!pt1) return pt0.s;
      if(!pt0) return pt1.s;
      return pt0.s + (pt1.s - pt0.s) * (position - pt0[posAttr]) / (pt1[posAttr] - pt0[posAttr]);
  }
  
  },{"./calc":1159}],1164:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  // remove opacity for any trace that has a fill or is filled to
  module.exports = function crossTraceDefaults(fullData) {
      for(var i = 0; i < fullData.length; i++) {
          var tracei = fullData[i];
          if(tracei.type !== 'scatter') continue;
  
          var filli = tracei.fill;
          if(filli === 'none' || filli === 'toself') continue;
  
          tracei.opacity = undefined;
  
          if(filli === 'tonexty' || filli === 'tonextx') {
              for(var j = i - 1; j >= 0; j--) {
                  var tracej = fullData[j];
  
                  if((tracej.type === 'scatter') &&
                          (tracej.xaxis === tracei.xaxis) &&
                          (tracej.yaxis === tracei.yaxis)) {
                      tracej.opacity = undefined;
                      break;
                  }
              }
          }
      }
  };
  
  },{}],1165:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  
  var attributes = _dereq_('./attributes');
  var constants = _dereq_('./constants');
  var subTypes = _dereq_('./subtypes');
  var handleXYDefaults = _dereq_('./xy_defaults');
  var handlePeriodDefaults = _dereq_('./period_defaults');
  var handleStackDefaults = _dereq_('./stack_defaults');
  var handleMarkerDefaults = _dereq_('./marker_defaults');
  var handleLineDefaults = _dereq_('./line_defaults');
  var handleLineShapeDefaults = _dereq_('./line_shape_defaults');
  var handleTextDefaults = _dereq_('./text_defaults');
  var handleFillColorDefaults = _dereq_('./fillcolor_defaults');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
      if(!len) traceOut.visible = false;
  
      if(!traceOut.visible) return;
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  
      var stackGroupOpts = handleStackDefaults(traceIn, traceOut, layout, coerce);
  
      var defaultMode = !stackGroupOpts && (len < constants.PTS_LINESONLY) ?
          'lines+markers' : 'lines';
      coerce('text');
      coerce('hovertext');
      coerce('mode', defaultMode);
  
      if(subTypes.hasLines(traceOut)) {
          handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
          handleLineShapeDefaults(traceIn, traceOut, coerce);
          coerce('connectgaps');
          coerce('line.simplify');
      }
  
      if(subTypes.hasMarkers(traceOut)) {
          handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
      }
  
      if(subTypes.hasText(traceOut)) {
          coerce('texttemplate');
          handleTextDefaults(traceIn, traceOut, layout, coerce);
      }
  
      var dfltHoverOn = [];
  
      if(subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
          coerce('cliponaxis');
          coerce('marker.maxdisplayed');
          dfltHoverOn.push('points');
      }
  
      // It's possible for this default to be changed by a later trace.
      // We handle that case in some hacky code inside handleStackDefaults.
      coerce('fill', stackGroupOpts ? stackGroupOpts.fillDflt : 'none');
      if(traceOut.fill !== 'none') {
          handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
          if(!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
      }
  
      var lineColor = (traceOut.line || {}).color;
      var markerColor = (traceOut.marker || {}).color;
  
      if(traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
          dfltHoverOn.push('fills');
      }
      coerce('hoveron', dfltHoverOn.join('+') || 'points');
      if(traceOut.hoveron !== 'fills') coerce('hovertemplate');
      var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'y'});
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'x', inherit: 'y'});
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  },{"../../lib":750,"../../registry":882,"./attributes":1158,"./constants":1162,"./fillcolor_defaults":1166,"./line_defaults":1171,"./line_shape_defaults":1173,"./marker_defaults":1177,"./period_defaults":1178,"./stack_defaults":1181,"./subtypes":1183,"./text_defaults":1184,"./xy_defaults":1185}],1166:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Color = _dereq_('../../components/color');
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  
  module.exports = function fillColorDefaults(traceIn, traceOut, defaultColor, coerce) {
      var inheritColorFromMarker = false;
  
      if(traceOut.marker) {
          // don't try to inherit a color array
          var markerColor = traceOut.marker.color;
          var markerLineColor = (traceOut.marker.line || {}).color;
  
          if(markerColor && !isArrayOrTypedArray(markerColor)) {
              inheritColorFromMarker = markerColor;
          } else if(markerLineColor && !isArrayOrTypedArray(markerLineColor)) {
              inheritColorFromMarker = markerLineColor;
          }
      }
  
      coerce('fillcolor', Color.addOpacity(
          (traceOut.line || {}).color ||
          inheritColorFromMarker ||
          defaultColor, 0.5
      ));
  };
  
  },{"../../components/color":615,"../../lib":750}],1167:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  module.exports = function formatLabels(cdi, trace, fullLayout) {
      var labels = {};
  
      var mockGd = {_fullLayout: fullLayout};
      var xa = Axes.getFromTrace(mockGd, trace, 'x');
      var ya = Axes.getFromTrace(mockGd, trace, 'y');
  
      labels.xLabel = Axes.tickText(xa, cdi.x, true).text;
      labels.yLabel = Axes.tickText(ya, cdi.y, true).text;
  
      return labels;
  };
  
  },{"../../plots/cartesian/axes":799}],1168:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Color = _dereq_('../../components/color');
  var subtypes = _dereq_('./subtypes');
  
  
  module.exports = function getTraceColor(trace, di) {
      var lc, tc;
  
      // TODO: text modes
  
      if(trace.mode === 'lines') {
          lc = trace.line.color;
          return (lc && Color.opacity(lc)) ?
              lc : trace.fillcolor;
      } else if(trace.mode === 'none') {
          return trace.fill ? trace.fillcolor : '';
      } else {
          var mc = di.mcc || (trace.marker || {}).color;
          var mlc = di.mlcc || ((trace.marker || {}).line || {}).color;
  
          tc = (mc && Color.opacity(mc)) ? mc :
              (mlc && Color.opacity(mlc) &&
                  (di.mlw || ((trace.marker || {}).line || {}).width)) ? mlc : '';
  
          if(tc) {
              // make sure the points aren't TOO transparent
              if(Color.opacity(tc) < 0.3) {
                  return Color.addOpacity(tc, 0.3);
              } else return tc;
          } else {
              lc = (trace.line || {}).color;
              return (lc && Color.opacity(lc) &&
                  subtypes.hasLines(trace) && trace.line.width) ?
                      lc : trace.fillcolor;
          }
      }
  };
  
  },{"../../components/color":615,"./subtypes":1183}],1169:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Fx = _dereq_('../../components/fx');
  var Registry = _dereq_('../../registry');
  var getTraceColor = _dereq_('./get_trace_color');
  var Color = _dereq_('../../components/color');
  var fillText = Lib.fillText;
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
      var xa = pointData.xa;
      var ya = pointData.ya;
      var xpx = xa.c2p(xval);
      var ypx = ya.c2p(yval);
      var pt = [xpx, ypx];
      var hoveron = trace.hoveron || '';
      var minRad = (trace.mode.indexOf('markers') !== -1) ? 3 : 0.5;
  
      // look for points to hover on first, then take fills only if we
      // didn't find a point
      if(hoveron.indexOf('points') !== -1) {
          var dx = function(di) {
              // dx and dy are used in compare modes - here we want to always
              // prioritize the closest data point, at least as long as markers are
              // the same size or nonexistent, but still try to prioritize small markers too.
              var rad = Math.max(3, di.mrc || 0);
              var kink = 1 - 1 / rad;
              var dxRaw = Math.abs(xa.c2p(di.x) - xpx);
              var d = (dxRaw < rad) ? (kink * dxRaw / rad) : (dxRaw - rad + kink);
              return d;
          };
          var dy = function(di) {
              var rad = Math.max(3, di.mrc || 0);
              var kink = 1 - 1 / rad;
              var dyRaw = Math.abs(ya.c2p(di.y) - ypx);
              return (dyRaw < rad) ? (kink * dyRaw / rad) : (dyRaw - rad + kink);
          };
          var dxy = function(di) {
              // scatter points: d.mrc is the calculated marker radius
              // adjust the distance so if you're inside the marker it
              // always will show up regardless of point size, but
              // prioritize smaller points
              var rad = Math.max(minRad, di.mrc || 0);
              var dx = xa.c2p(di.x) - xpx;
              var dy = ya.c2p(di.y) - ypx;
              return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - minRad / rad);
          };
          var distfn = Fx.getDistanceFunction(hovermode, dx, dy, dxy);
  
          Fx.getClosest(cd, distfn, pointData);
  
          // skip the rest (for this trace) if we didn't find a close point
          if(pointData.index !== false) {
              // the closest data point
              var di = cd[pointData.index];
              var xc = xa.c2p(di.x, true);
              var yc = ya.c2p(di.y, true);
              var rad = di.mrc || 1;
  
              // now we're done using the whole `calcdata` array, replace the
              // index with the original index (in case of inserted point from
              // stacked area)
              pointData.index = di.i;
  
              var orientation = cd[0].t.orientation;
              // TODO: for scatter and bar, option to show (sub)totals and
              // raw data? Currently stacked and/or normalized bars just show
              // the normalized individual sizes, so that's what I'm doing here
              // for now.
              var sizeVal = orientation && (di.sNorm || di.s);
              var xLabelVal = (orientation === 'h') ? sizeVal : di.orig_x !== undefined ? di.orig_x : di.x;
              var yLabelVal = (orientation === 'v') ? sizeVal : di.orig_y !== undefined ? di.orig_y : di.y;
  
              Lib.extendFlat(pointData, {
                  color: getTraceColor(trace, di),
  
                  x0: xc - rad,
                  x1: xc + rad,
                  xLabelVal: xLabelVal,
  
                  y0: yc - rad,
                  y1: yc + rad,
                  yLabelVal: yLabelVal,
  
                  spikeDistance: dxy(di),
                  hovertemplate: trace.hovertemplate
              });
  
              fillText(di, trace, pointData);
              Registry.getComponentMethod('errorbars', 'hoverInfo')(di, trace, pointData);
  
              return [pointData];
          }
      }
  
      // even if hoveron is 'fills', only use it if we have polygons too
      if(hoveron.indexOf('fills') !== -1 && trace._polygons) {
          var polygons = trace._polygons;
          var polygonsIn = [];
          var inside = false;
          var xmin = Infinity;
          var xmax = -Infinity;
          var ymin = Infinity;
          var ymax = -Infinity;
  
          var i, j, polygon, pts, xCross, x0, x1, y0, y1;
  
          for(i = 0; i < polygons.length; i++) {
              polygon = polygons[i];
              // TODO: this is not going to work right for curved edges, it will
              // act as though they're straight. That's probably going to need
              // the elements themselves to capture the events. Worth it?
              if(polygon.contains(pt)) {
                  inside = !inside;
                  // TODO: need better than just the overall bounding box
                  polygonsIn.push(polygon);
                  ymin = Math.min(ymin, polygon.ymin);
                  ymax = Math.max(ymax, polygon.ymax);
              }
          }
  
          if(inside) {
              // constrain ymin/max to the visible plot, so the label goes
              // at the middle of the piece you can see
              ymin = Math.max(ymin, 0);
              ymax = Math.min(ymax, ya._length);
  
              // find the overall left-most and right-most points of the
              // polygon(s) we're inside at their combined vertical midpoint.
              // This is where we will draw the hover label.
              // Note that this might not be the vertical midpoint of the
              // whole trace, if it's disjoint.
              var yAvg = (ymin + ymax) / 2;
              for(i = 0; i < polygonsIn.length; i++) {
                  pts = polygonsIn[i].pts;
                  for(j = 1; j < pts.length; j++) {
                      y0 = pts[j - 1][1];
                      y1 = pts[j][1];
                      if((y0 > yAvg) !== (y1 >= yAvg)) {
                          x0 = pts[j - 1][0];
                          x1 = pts[j][0];
                          if(y1 - y0) {
                              xCross = x0 + (x1 - x0) * (yAvg - y0) / (y1 - y0);
                              xmin = Math.min(xmin, xCross);
                              xmax = Math.max(xmax, xCross);
                          }
                      }
                  }
              }
  
              // constrain xmin/max to the visible plot now too
              xmin = Math.max(xmin, 0);
              xmax = Math.min(xmax, xa._length);
  
              // get only fill or line color for the hover color
              var color = Color.defaultLine;
              if(Color.opacity(trace.fillcolor)) color = trace.fillcolor;
              else if(Color.opacity((trace.line || {}).color)) {
                  color = trace.line.color;
              }
  
              Lib.extendFlat(pointData, {
                  // never let a 2D override 1D type as closest point
                  // also: no spikeDistance, it's not allowed for fills
                  distance: pointData.maxHoverDistance,
                  x0: xmin,
                  x1: xmax,
                  y0: yAvg,
                  y1: yAvg,
                  color: color,
                  hovertemplate: false
              });
  
              delete pointData.index;
  
              if(trace.text && !Array.isArray(trace.text)) {
                  pointData.text = String(trace.text);
              } else pointData.text = trace.name;
  
              return [pointData];
          }
      }
  };
  
  },{"../../components/color":615,"../../components/fx":655,"../../lib":750,"../../registry":882,"./get_trace_color":1168}],1170:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var subtypes = _dereq_('./subtypes');
  
  module.exports = {
      hasLines: subtypes.hasLines,
      hasMarkers: subtypes.hasMarkers,
      hasText: subtypes.hasText,
      isBubble: subtypes.isBubble,
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      crossTraceDefaults: _dereq_('./cross_trace_defaults'),
      calc: _dereq_('./calc').calc,
      crossTraceCalc: _dereq_('./cross_trace_calc'),
      arraysToCalcdata: _dereq_('./arrays_to_calcdata'),
      plot: _dereq_('./plot'),
      colorbar: _dereq_('./marker_colorbar'),
      formatLabels: _dereq_('./format_labels'),
      style: _dereq_('./style').style,
      styleOnSelect: _dereq_('./style').styleOnSelect,
      hoverPoints: _dereq_('./hover'),
      selectPoints: _dereq_('./select'),
      animatable: true,
  
      moduleType: 'trace',
      name: 'scatter',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: [
          'cartesian', 'svg', 'symbols', 'errorBarsOK', 'showLegend', 'scatter-like',
          'zoomScale'
      ],
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"./arrays_to_calcdata":1157,"./attributes":1158,"./calc":1159,"./cross_trace_calc":1163,"./cross_trace_defaults":1164,"./defaults":1165,"./format_labels":1167,"./hover":1169,"./marker_colorbar":1176,"./plot":1179,"./select":1180,"./style":1182,"./subtypes":1183}],1171:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  
  module.exports = function lineDefaults(traceIn, traceOut, defaultColor, layout, coerce, opts) {
      var markerColor = (traceIn.marker || {}).color;
  
      coerce('line.color', defaultColor);
  
      if(hasColorscale(traceIn, 'line')) {
          colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'line.', cLetter: 'c'});
      } else {
          var lineColorDflt = (isArrayOrTypedArray(markerColor) ? false : markerColor) || defaultColor;
          coerce('line.color', lineColorDflt);
      }
  
      coerce('line.width');
      if(!(opts || {}).noDash) coerce('line.dash');
  };
  
  },{"../../components/colorscale/defaults":625,"../../components/colorscale/helpers":626,"../../lib":750}],1172:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var numConstants = _dereq_('../../constants/numerical');
  var BADNUM = numConstants.BADNUM;
  var LOG_CLIP = numConstants.LOG_CLIP;
  var LOG_CLIP_PLUS = LOG_CLIP + 0.5;
  var LOG_CLIP_MINUS = LOG_CLIP - 0.5;
  var Lib = _dereq_('../../lib');
  var segmentsIntersect = Lib.segmentsIntersect;
  var constrain = Lib.constrain;
  var constants = _dereq_('./constants');
  
  
  module.exports = function linePoints(d, opts) {
      var xa = opts.xaxis;
      var ya = opts.yaxis;
      var xLog = xa.type === 'log';
      var yLog = ya.type === 'log';
      var xLen = xa._length;
      var yLen = ya._length;
      var connectGaps = opts.connectGaps;
      var baseTolerance = opts.baseTolerance;
      var shape = opts.shape;
      var linear = shape === 'linear';
      var fill = opts.fill && opts.fill !== 'none';
      var segments = [];
      var minTolerance = constants.minTolerance;
      var len = d.length;
      var pts = new Array(len);
      var pti = 0;
  
      var i;
  
      // pt variables are pixel coordinates [x,y] of one point
      // these four are the outputs of clustering on a line
      var clusterStartPt, clusterEndPt, clusterHighPt, clusterLowPt;
  
      // "this" is the next point we're considering adding to the cluster
      var thisPt;
  
      // did we encounter the high point first, then a low point, or vice versa?
      var clusterHighFirst;
  
      // the first two points in the cluster determine its unit vector
      // so the second is always in the "High" direction
      var clusterUnitVector;
  
      // the pixel delta from clusterStartPt
      var thisVector;
  
      // val variables are (signed) pixel distances along the cluster vector
      var clusterRefDist, clusterHighVal, clusterLowVal, thisVal;
  
      // deviation variables are (signed) pixel distances normal to the cluster vector
      var clusterMinDeviation, clusterMaxDeviation, thisDeviation;
  
      // turn one calcdata point into pixel coordinates
      function getPt(index) {
          var di = d[index];
          if(!di) return false;
          var x = opts.linearized ? xa.l2p(di.x) : xa.c2p(di.x);
          var y = opts.linearized ? ya.l2p(di.y) : ya.c2p(di.y);
  
          // if non-positive log values, set them VERY far off-screen
          // so the line looks essentially straight from the previous point.
          if(x === BADNUM) {
              if(xLog) x = xa.c2p(di.x, true);
              if(x === BADNUM) return false;
              // If BOTH were bad log values, make the line follow a constant
              // exponent rather than a constant slope
              if(yLog && y === BADNUM) {
                  x *= Math.abs(xa._m * yLen * (xa._m > 0 ? LOG_CLIP_PLUS : LOG_CLIP_MINUS) /
                      (ya._m * xLen * (ya._m > 0 ? LOG_CLIP_PLUS : LOG_CLIP_MINUS)));
              }
              x *= 1000;
          }
          if(y === BADNUM) {
              if(yLog) y = ya.c2p(di.y, true);
              if(y === BADNUM) return false;
              y *= 1000;
          }
          return [x, y];
      }
  
      function crossesViewport(xFrac0, yFrac0, xFrac1, yFrac1) {
          var dx = xFrac1 - xFrac0;
          var dy = yFrac1 - yFrac0;
          var dx0 = 0.5 - xFrac0;
          var dy0 = 0.5 - yFrac0;
          var norm2 = dx * dx + dy * dy;
          var dot = dx * dx0 + dy * dy0;
          if(dot > 0 && dot < norm2) {
              var cross = dx0 * dy - dy0 * dx;
              if(cross * cross < norm2) return true;
          }
      }
  
      var latestXFrac, latestYFrac;
      // if we're off-screen, increase tolerance over baseTolerance
      function getTolerance(pt, nextPt) {
          var xFrac = pt[0] / xLen;
          var yFrac = pt[1] / yLen;
          var offScreenFraction = Math.max(0, -xFrac, xFrac - 1, -yFrac, yFrac - 1);
          if(offScreenFraction && (latestXFrac !== undefined) &&
              crossesViewport(xFrac, yFrac, latestXFrac, latestYFrac)
          ) {
              offScreenFraction = 0;
          }
          if(offScreenFraction && nextPt &&
              crossesViewport(xFrac, yFrac, nextPt[0] / xLen, nextPt[1] / yLen)
          ) {
              offScreenFraction = 0;
          }
  
          return (1 + constants.toleranceGrowth * offScreenFraction) * baseTolerance;
      }
  
      function ptDist(pt1, pt2) {
          var dx = pt1[0] - pt2[0];
          var dy = pt1[1] - pt2[1];
          return Math.sqrt(dx * dx + dy * dy);
      }
  
      // last bit of filtering: clip paths that are VERY far off-screen
      // so we don't get near the browser's hard limit (+/- 2^29 px in Chrome and FF)
  
      var maxScreensAway = constants.maxScreensAway;
  
      // find the intersections between the segment from pt1 to pt2
      // and the large rectangle maxScreensAway around the viewport
      // if one of pt1 and pt2 is inside and the other outside, there
      // will be only one intersection.
      // if both are outside there will be 0 or 2 intersections
      // (or 1 if it's right at a corner - we'll treat that like 0)
      // returns an array of intersection pts
      var xEdge0 = -xLen * maxScreensAway;
      var xEdge1 = xLen * (1 + maxScreensAway);
      var yEdge0 = -yLen * maxScreensAway;
      var yEdge1 = yLen * (1 + maxScreensAway);
      var edges = [
          [xEdge0, yEdge0, xEdge1, yEdge0],
          [xEdge1, yEdge0, xEdge1, yEdge1],
          [xEdge1, yEdge1, xEdge0, yEdge1],
          [xEdge0, yEdge1, xEdge0, yEdge0]
      ];
      var xEdge, yEdge, lastXEdge, lastYEdge, lastFarPt, edgePt;
  
      // for linear line shape, edge intersections should be linearly interpolated
      // spline uses this too, which isn't precisely correct but is actually pretty
      // good, because Catmull-Rom weights far-away points less in creating the curvature
      function getLinearEdgeIntersections(pt1, pt2) {
          var out = [];
          var ptCount = 0;
          for(var i = 0; i < 4; i++) {
              var edge = edges[i];
              var ptInt = segmentsIntersect(
                  pt1[0], pt1[1], pt2[0], pt2[1],
                  edge[0], edge[1], edge[2], edge[3]
              );
              if(ptInt && (!ptCount ||
                  Math.abs(ptInt.x - out[0][0]) > 1 ||
                  Math.abs(ptInt.y - out[0][1]) > 1
              )) {
                  ptInt = [ptInt.x, ptInt.y];
                  // if we have 2 intersections, make sure the closest one to pt1 comes first
                  if(ptCount && ptDist(ptInt, pt1) < ptDist(out[0], pt1)) out.unshift(ptInt);
                  else out.push(ptInt);
                  ptCount++;
              }
          }
          return out;
      }
  
      function onlyConstrainedPoint(pt) {
          if(pt[0] < xEdge0 || pt[0] > xEdge1 || pt[1] < yEdge0 || pt[1] > yEdge1) {
              return [constrain(pt[0], xEdge0, xEdge1), constrain(pt[1], yEdge0, yEdge1)];
          }
      }
  
      function sameEdge(pt1, pt2) {
          if(pt1[0] === pt2[0] && (pt1[0] === xEdge0 || pt1[0] === xEdge1)) return true;
          if(pt1[1] === pt2[1] && (pt1[1] === yEdge0 || pt1[1] === yEdge1)) return true;
      }
  
      // for line shapes hv and vh, movement in the two dimensions is decoupled,
      // so all we need to do is constrain each dimension independently
      function getHVEdgeIntersections(pt1, pt2) {
          var out = [];
          var ptInt1 = onlyConstrainedPoint(pt1);
          var ptInt2 = onlyConstrainedPoint(pt2);
          if(ptInt1 && ptInt2 && sameEdge(ptInt1, ptInt2)) return out;
  
          if(ptInt1) out.push(ptInt1);
          if(ptInt2) out.push(ptInt2);
          return out;
      }
  
      // hvh and vhv we sometimes have to move one of the intersection points
      // out BEYOND the clipping rect, by a maximum of a factor of 2, so that
      // the midpoint line is drawn in the right place
      function getABAEdgeIntersections(dim, limit0, limit1) {
          return function(pt1, pt2) {
              var ptInt1 = onlyConstrainedPoint(pt1);
              var ptInt2 = onlyConstrainedPoint(pt2);
  
              var out = [];
              if(ptInt1 && ptInt2 && sameEdge(ptInt1, ptInt2)) return out;
  
              if(ptInt1) out.push(ptInt1);
              if(ptInt2) out.push(ptInt2);
  
              var midShift = 2 * Lib.constrain((pt1[dim] + pt2[dim]) / 2, limit0, limit1) -
                  ((ptInt1 || pt1)[dim] + (ptInt2 || pt2)[dim]);
              if(midShift) {
                  var ptToAlter;
                  if(ptInt1 && ptInt2) {
                      ptToAlter = (midShift > 0 === ptInt1[dim] > ptInt2[dim]) ? ptInt1 : ptInt2;
                  } else ptToAlter = ptInt1 || ptInt2;
  
                  ptToAlter[dim] += midShift;
              }
  
              return out;
          };
      }
  
      var getEdgeIntersections;
      if(shape === 'linear' || shape === 'spline') {
          getEdgeIntersections = getLinearEdgeIntersections;
      } else if(shape === 'hv' || shape === 'vh') {
          getEdgeIntersections = getHVEdgeIntersections;
      } else if(shape === 'hvh') getEdgeIntersections = getABAEdgeIntersections(0, xEdge0, xEdge1);
      else if(shape === 'vhv') getEdgeIntersections = getABAEdgeIntersections(1, yEdge0, yEdge1);
  
      // a segment pt1->pt2 entirely outside the nearby region:
      // find the corner it gets closest to touching
      function getClosestCorner(pt1, pt2) {
          var dx = pt2[0] - pt1[0];
          var m = (pt2[1] - pt1[1]) / dx;
          var b = (pt1[1] * pt2[0] - pt2[1] * pt1[0]) / dx;
  
          if(b > 0) return [m > 0 ? xEdge0 : xEdge1, yEdge1];
          else return [m > 0 ? xEdge1 : xEdge0, yEdge0];
      }
  
      function updateEdge(pt) {
          var x = pt[0];
          var y = pt[1];
          var xSame = x === pts[pti - 1][0];
          var ySame = y === pts[pti - 1][1];
          // duplicate point?
          if(xSame && ySame) return;
          if(pti > 1) {
              // backtracking along an edge?
              var xSame2 = x === pts[pti - 2][0];
              var ySame2 = y === pts[pti - 2][1];
              if(xSame && (x === xEdge0 || x === xEdge1) && xSame2) {
                  if(ySame2) pti--; // backtracking exactly - drop prev pt and don't add
                  else pts[pti - 1] = pt; // not exact: replace the prev pt
              } else if(ySame && (y === yEdge0 || y === yEdge1) && ySame2) {
                  if(xSame2) pti--;
                  else pts[pti - 1] = pt;
              } else pts[pti++] = pt;
          } else pts[pti++] = pt;
      }
  
      function updateEdgesForReentry(pt) {
          // if we're outside the nearby region and going back in,
          // we may need to loop around a corner point
          if(pts[pti - 1][0] !== pt[0] && pts[pti - 1][1] !== pt[1]) {
              updateEdge([lastXEdge, lastYEdge]);
          }
          updateEdge(pt);
          lastFarPt = null;
          lastXEdge = lastYEdge = 0;
      }
  
      function addPt(pt) {
          latestXFrac = pt[0] / xLen;
          latestYFrac = pt[1] / yLen;
          // Are we more than maxScreensAway off-screen any direction?
          // if so, clip to this box, but in such a way that on-screen
          // drawing is unchanged
          xEdge = (pt[0] < xEdge0) ? xEdge0 : (pt[0] > xEdge1) ? xEdge1 : 0;
          yEdge = (pt[1] < yEdge0) ? yEdge0 : (pt[1] > yEdge1) ? yEdge1 : 0;
          if(xEdge || yEdge) {
              if(!pti) {
                  // to get fills right - if first point is far, push it toward the
                  // screen in whichever direction(s) are far
  
                  pts[pti++] = [xEdge || pt[0], yEdge || pt[1]];
              } else if(lastFarPt) {
                  // both this point and the last are outside the nearby region
                  // check if we're crossing the nearby region
                  var intersections = getEdgeIntersections(lastFarPt, pt);
                  if(intersections.length > 1) {
                      updateEdgesForReentry(intersections[0]);
                      pts[pti++] = intersections[1];
                  }
              } else {
                  // we're leaving the nearby region - add the point where we left it
  
                  edgePt = getEdgeIntersections(pts[pti - 1], pt)[0];
                  pts[pti++] = edgePt;
              }
  
              var lastPt = pts[pti - 1];
              if(xEdge && yEdge && (lastPt[0] !== xEdge || lastPt[1] !== yEdge)) {
                  // we've gone out beyond a new corner: add the corner too
                  // so that the next point will take the right winding
                  if(lastFarPt) {
                      if(lastXEdge !== xEdge && lastYEdge !== yEdge) {
                          if(lastXEdge && lastYEdge) {
                              // we've gone around to an opposite corner - we
                              // need to add the correct extra corner
                              // in order to get the right winding
                              updateEdge(getClosestCorner(lastFarPt, pt));
                          } else {
                              // we're coming from a far edge - the extra corner
                              // we need is determined uniquely by the sectors
                              updateEdge([lastXEdge || xEdge, lastYEdge || yEdge]);
                          }
                      } else if(lastXEdge && lastYEdge) {
                          updateEdge([lastXEdge, lastYEdge]);
                      }
                  }
                  updateEdge([xEdge, yEdge]);
              } else if((lastXEdge - xEdge) && (lastYEdge - yEdge)) {
                  // we're coming from an edge or far corner to an edge - again the
                  // extra corner we need is uniquely determined by the sectors
                  updateEdge([xEdge || lastXEdge, yEdge || lastYEdge]);
              }
              lastFarPt = pt;
              lastXEdge = xEdge;
              lastYEdge = yEdge;
          } else {
              if(lastFarPt) {
                  // this point is in range but the previous wasn't: add its entry pt first
                  updateEdgesForReentry(getEdgeIntersections(lastFarPt, pt)[0]);
              }
  
              pts[pti++] = pt;
          }
      }
  
      // loop over ALL points in this trace
      for(i = 0; i < len; i++) {
          clusterStartPt = getPt(i);
          if(!clusterStartPt) continue;
  
          pti = 0;
          lastFarPt = null;
          addPt(clusterStartPt);
  
          // loop over one segment of the trace
          for(i++; i < len; i++) {
              clusterHighPt = getPt(i);
              if(!clusterHighPt) {
                  if(connectGaps) continue;
                  else break;
              }
  
              // can't decimate if nonlinear line shape
              // TODO: we *could* decimate [hv]{2,3} shapes if we restricted clusters to horz or vert again
              // but spline would be verrry awkward to decimate
              if(!linear || !opts.simplify) {
                  addPt(clusterHighPt);
                  continue;
              }
  
              var nextPt = getPt(i + 1);
  
              clusterRefDist = ptDist(clusterHighPt, clusterStartPt);
  
              // #3147 - always include the very first and last points for fills
              if(!(fill && (pti === 0 || pti === len - 1)) &&
                  clusterRefDist < getTolerance(clusterHighPt, nextPt) * minTolerance) continue;
  
              clusterUnitVector = [
                  (clusterHighPt[0] - clusterStartPt[0]) / clusterRefDist,
                  (clusterHighPt[1] - clusterStartPt[1]) / clusterRefDist
              ];
  
              clusterLowPt = clusterStartPt;
              clusterHighVal = clusterRefDist;
              clusterLowVal = clusterMinDeviation = clusterMaxDeviation = 0;
              clusterHighFirst = false;
              clusterEndPt = clusterHighPt;
  
              // loop over one cluster of points that collapse onto one line
              for(i++; i < d.length; i++) {
                  thisPt = nextPt;
                  nextPt = getPt(i + 1);
                  if(!thisPt) {
                      if(connectGaps) continue;
                      else break;
                  }
                  thisVector = [
                      thisPt[0] - clusterStartPt[0],
                      thisPt[1] - clusterStartPt[1]
                  ];
                  // cross product (or dot with normal to the cluster vector)
                  thisDeviation = thisVector[0] * clusterUnitVector[1] - thisVector[1] * clusterUnitVector[0];
                  clusterMinDeviation = Math.min(clusterMinDeviation, thisDeviation);
                  clusterMaxDeviation = Math.max(clusterMaxDeviation, thisDeviation);
  
                  if(clusterMaxDeviation - clusterMinDeviation > getTolerance(thisPt, nextPt)) break;
  
                  clusterEndPt = thisPt;
                  thisVal = thisVector[0] * clusterUnitVector[0] + thisVector[1] * clusterUnitVector[1];
  
                  if(thisVal > clusterHighVal) {
                      clusterHighVal = thisVal;
                      clusterHighPt = thisPt;
                      clusterHighFirst = false;
                  } else if(thisVal < clusterLowVal) {
                      clusterLowVal = thisVal;
                      clusterLowPt = thisPt;
                      clusterHighFirst = true;
                  }
              }
  
              // insert this cluster into pts
              // we've already inserted the start pt, now check if we have high and low pts
              if(clusterHighFirst) {
                  addPt(clusterHighPt);
                  if(clusterEndPt !== clusterLowPt) addPt(clusterLowPt);
              } else {
                  if(clusterLowPt !== clusterStartPt) addPt(clusterLowPt);
                  if(clusterEndPt !== clusterHighPt) addPt(clusterHighPt);
              }
              // and finally insert the end pt
              addPt(clusterEndPt);
  
              // have we reached the end of this segment?
              if(i >= d.length || !thisPt) break;
  
              // otherwise we have an out-of-cluster point to insert as next clusterStartPt
              addPt(thisPt);
              clusterStartPt = thisPt;
          }
  
          // to get fills right - repeat what we did at the start
          if(lastFarPt) updateEdge([lastXEdge || lastFarPt[0], lastYEdge || lastFarPt[1]]);
  
          segments.push(pts.slice(0, pti));
      }
  
      return segments;
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"./constants":1162}],1173:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  // common to 'scatter' and 'scatterternary'
  module.exports = function handleLineShapeDefaults(traceIn, traceOut, coerce) {
      var shape = coerce('line.shape');
      if(shape === 'spline') coerce('line.smoothing');
  };
  
  },{}],1174:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var LINKEDFILLS = {tonextx: 1, tonexty: 1, tonext: 1};
  
  module.exports = function linkTraces(gd, plotinfo, cdscatter) {
      var trace, i, group, prevtrace, groupIndex;
  
      // first sort traces to keep stacks & filled-together groups together
      var groupIndices = {};
      var needsSort = false;
      var prevGroupIndex = -1;
      var nextGroupIndex = 0;
      var prevUnstackedGroupIndex = -1;
      for(i = 0; i < cdscatter.length; i++) {
          trace = cdscatter[i][0].trace;
          group = trace.stackgroup || '';
          if(group) {
              if(group in groupIndices) {
                  groupIndex = groupIndices[group];
              } else {
                  groupIndex = groupIndices[group] = nextGroupIndex;
                  nextGroupIndex++;
              }
          } else if(trace.fill in LINKEDFILLS && prevUnstackedGroupIndex >= 0) {
              groupIndex = prevUnstackedGroupIndex;
          } else {
              groupIndex = prevUnstackedGroupIndex = nextGroupIndex;
              nextGroupIndex++;
          }
  
          if(groupIndex < prevGroupIndex) needsSort = true;
          trace._groupIndex = prevGroupIndex = groupIndex;
      }
  
      var cdscatterSorted = cdscatter.slice();
      if(needsSort) {
          cdscatterSorted.sort(function(a, b) {
              var traceA = a[0].trace;
              var traceB = b[0].trace;
              return (traceA._groupIndex - traceB._groupIndex) ||
                  (traceA.index - traceB.index);
          });
      }
  
      // now link traces to each other
      var prevtraces = {};
      for(i = 0; i < cdscatterSorted.length; i++) {
          trace = cdscatterSorted[i][0].trace;
          group = trace.stackgroup || '';
  
          // Note: The check which ensures all cdscatter here are for the same axis and
          // are either cartesian or scatterternary has been removed. This code assumes
          // the passed scattertraces have been filtered to the proper plot types and
          // the proper subplots.
          if(trace.visible === true) {
              trace._nexttrace = null;
  
              if(trace.fill in LINKEDFILLS) {
                  prevtrace = prevtraces[group];
                  trace._prevtrace = prevtrace || null;
  
                  if(prevtrace) {
                      prevtrace._nexttrace = trace;
                  }
              }
  
              trace._ownfill = (trace.fill && (
                  trace.fill.substr(0, 6) === 'tozero' ||
                  trace.fill === 'toself' ||
                  (trace.fill.substr(0, 2) === 'to' && !trace._prevtrace)
              ));
  
              prevtraces[group] = trace;
          } else {
              trace._prevtrace = trace._nexttrace = trace._ownfill = null;
          }
      }
  
      return cdscatterSorted;
  };
  
  },{}],1175:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  
  // used in the drawing step for 'scatter' and 'scattegeo' and
  // in the convert step for 'scatter3d'
  module.exports = function makeBubbleSizeFn(trace) {
      var marker = trace.marker;
      var sizeRef = marker.sizeref || 1;
      var sizeMin = marker.sizemin || 0;
  
      // for bubble charts, allow scaling the provided value linearly
      // and by area or diameter.
      // Note this only applies to the array-value sizes
  
      var baseFn = (marker.sizemode === 'area') ?
          function(v) { return Math.sqrt(v / sizeRef); } :
          function(v) { return v / sizeRef; };
  
      // TODO add support for position/negative bubbles?
      // TODO add 'sizeoffset' attribute?
      return function(v) {
          var baseSize = baseFn(v / 2);
  
          // don't show non-numeric and negative sizes
          return (isNumeric(baseSize) && (baseSize > 0)) ?
              Math.max(baseSize, sizeMin) :
              0;
      };
  };
  
  },{"fast-isnumeric":241}],1176:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  module.exports = {
      container: 'marker',
      min: 'cmin',
      max: 'cmax'
  };
  
  },{}],1177:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Color = _dereq_('../../components/color');
  var hasColorscale = _dereq_('../../components/colorscale/helpers').hasColorscale;
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  
  var subTypes = _dereq_('./subtypes');
  
  /*
   * opts: object of flags to control features not all marker users support
   *   noLine: caller does not support marker lines
   *   gradient: caller supports gradients
   *   noSelect: caller does not support selected/unselected attribute containers
   */
  module.exports = function markerDefaults(traceIn, traceOut, defaultColor, layout, coerce, opts) {
      var isBubble = subTypes.isBubble(traceIn);
      var lineColor = (traceIn.line || {}).color;
      var defaultMLC;
  
      opts = opts || {};
  
      // marker.color inherit from line.color (even if line.color is an array)
      if(lineColor) defaultColor = lineColor;
  
      coerce('marker.symbol');
      coerce('marker.opacity', isBubble ? 0.7 : 1);
      coerce('marker.size');
  
      coerce('marker.color', defaultColor);
      if(hasColorscale(traceIn, 'marker')) {
          colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'});
      }
  
      if(!opts.noSelect) {
          coerce('selected.marker.color');
          coerce('unselected.marker.color');
          coerce('selected.marker.size');
          coerce('unselected.marker.size');
      }
  
      if(!opts.noLine) {
          // if there's a line with a different color than the marker, use
          // that line color as the default marker line color
          // (except when it's an array)
          // mostly this is for transparent markers to behave nicely
          if(lineColor && !Array.isArray(lineColor) && (traceOut.marker.color !== lineColor)) {
              defaultMLC = lineColor;
          } else if(isBubble) defaultMLC = Color.background;
          else defaultMLC = Color.defaultLine;
  
          coerce('marker.line.color', defaultMLC);
          if(hasColorscale(traceIn, 'marker.line')) {
              colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.line.', cLetter: 'c'});
          }
  
          coerce('marker.line.width', isBubble ? 1 : 0);
      }
  
      if(isBubble) {
          coerce('marker.sizeref');
          coerce('marker.sizemin');
          coerce('marker.sizemode');
      }
  
      if(opts.gradient) {
          var gradientType = coerce('marker.gradient.type');
          if(gradientType !== 'none') {
              coerce('marker.gradient.color');
          }
      }
  };
  
  },{"../../components/color":615,"../../components/colorscale/defaults":625,"../../components/colorscale/helpers":626,"./subtypes":1183}],1178:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var dateTick0 = _dereq_('../../lib').dateTick0;
  var numConstants = _dereq_('../../constants/numerical');
  var ONEWEEK = numConstants.ONEWEEK;
  
  function getPeriod0Dflt(period, calendar) {
      if(period % ONEWEEK === 0) {
          return dateTick0(calendar, 1); // Sunday
      }
      return dateTick0(calendar, 0);
  }
  
  module.exports = function handlePeriodDefaults(traceIn, traceOut, layout, coerce, opts) {
      if(!opts) {
          opts = {
              x: true,
              y: true
          };
      }
  
      if(opts.x) {
          var xperiod = coerce('xperiod');
          if(xperiod) {
              coerce('xperiod0', getPeriod0Dflt(xperiod, traceOut.xcalendar));
              coerce('xperiodalignment');
          }
      }
  
      if(opts.y) {
          var yperiod = coerce('yperiod');
          if(yperiod) {
              coerce('yperiod0', getPeriod0Dflt(yperiod, traceOut.ycalendar));
              coerce('yperiodalignment');
          }
      }
  };
  
  },{"../../constants/numerical":725,"../../lib":750}],1179:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var ensureSingle = Lib.ensureSingle;
  var identity = Lib.identity;
  var Drawing = _dereq_('../../components/drawing');
  
  var subTypes = _dereq_('./subtypes');
  var linePoints = _dereq_('./line_points');
  var linkTraces = _dereq_('./link_traces');
  var polygonTester = _dereq_('../../lib/polygon').tester;
  
  module.exports = function plot(gd, plotinfo, cdscatter, scatterLayer, transitionOpts, makeOnCompleteCallback) {
      var join, onComplete;
  
      // If transition config is provided, then it is only a partial replot and traces not
      // updated are removed.
      var isFullReplot = !transitionOpts;
      var hasTransition = !!transitionOpts && transitionOpts.duration > 0;
  
      // Link traces so the z-order of fill layers is correct
      var cdscatterSorted = linkTraces(gd, plotinfo, cdscatter);
  
      join = scatterLayer.selectAll('g.trace')
          .data(cdscatterSorted, function(d) { return d[0].trace.uid; });
  
      // Append new traces:
      join.enter().append('g')
          .attr('class', function(d) {
              return 'trace scatter trace' + d[0].trace.uid;
          })
          .style('stroke-miterlimit', 2);
      join.order();
  
      createFills(gd, join, plotinfo);
  
      if(hasTransition) {
          if(makeOnCompleteCallback) {
              // If it was passed a callback to register completion, make a callback. If
              // this is created, then it must be executed on completion, otherwise the
              // pos-transition redraw will not execute:
              onComplete = makeOnCompleteCallback();
          }
  
          var transition = d3.transition()
              .duration(transitionOpts.duration)
              .ease(transitionOpts.easing)
              .each('end', function() {
                  onComplete && onComplete();
              })
              .each('interrupt', function() {
                  onComplete && onComplete();
              });
  
          transition.each(function() {
              // Must run the selection again since otherwise enters/updates get grouped together
              // and these get executed out of order. Except we need them in order!
              scatterLayer.selectAll('g.trace').each(function(d, i) {
                  plotOne(gd, i, plotinfo, d, cdscatterSorted, this, transitionOpts);
              });
          });
      } else {
          join.each(function(d, i) {
              plotOne(gd, i, plotinfo, d, cdscatterSorted, this, transitionOpts);
          });
      }
  
      if(isFullReplot) {
          join.exit().remove();
      }
  
      // remove paths that didn't get used
      scatterLayer.selectAll('path:not([d])').remove();
  };
  
  function createFills(gd, traceJoin, plotinfo) {
      traceJoin.each(function(d) {
          var fills = ensureSingle(d3.select(this), 'g', 'fills');
          Drawing.setClipUrl(fills, plotinfo.layerClipId, gd);
  
          var trace = d[0].trace;
  
          var fillData = [];
          if(trace._ownfill) fillData.push('_ownFill');
          if(trace._nexttrace) fillData.push('_nextFill');
  
          var fillJoin = fills.selectAll('g').data(fillData, identity);
  
          fillJoin.enter().append('g');
  
          fillJoin.exit()
              .each(function(d) { trace[d] = null; })
              .remove();
  
          fillJoin.order().each(function(d) {
              // make a path element inside the fill group, just so
              // we can give it its own data later on and the group can
              // keep its simple '_*Fill' data
              trace[d] = ensureSingle(d3.select(this), 'path', 'js-fill');
          });
      });
  }
  
  function plotOne(gd, idx, plotinfo, cdscatter, cdscatterAll, element, transitionOpts) {
      var i;
  
      // Since this has been reorganized and we're executing this on individual traces,
      // we need to pass it the full list of cdscatter as well as this trace's index (idx)
      // since it does an internal n^2 loop over comparisons with other traces:
      selectMarkers(gd, idx, plotinfo, cdscatter, cdscatterAll);
  
      var hasTransition = !!transitionOpts && transitionOpts.duration > 0;
  
      function transition(selection) {
          return hasTransition ? selection.transition() : selection;
      }
  
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      var trace = cdscatter[0].trace;
      var line = trace.line;
      var tr = d3.select(element);
  
      var errorBarGroup = ensureSingle(tr, 'g', 'errorbars');
      var lines = ensureSingle(tr, 'g', 'lines');
      var points = ensureSingle(tr, 'g', 'points');
      var text = ensureSingle(tr, 'g', 'text');
  
      // error bars are at the bottom
      Registry.getComponentMethod('errorbars', 'plot')(gd, errorBarGroup, plotinfo, transitionOpts);
  
      if(trace.visible !== true) return;
  
      transition(tr).style('opacity', trace.opacity);
  
      // BUILD LINES AND FILLS
      var ownFillEl3, tonext;
      var ownFillDir = trace.fill.charAt(trace.fill.length - 1);
      if(ownFillDir !== 'x' && ownFillDir !== 'y') ownFillDir = '';
  
      // store node for tweaking by selectPoints
      cdscatter[0][plotinfo.isRangePlot ? 'nodeRangePlot3' : 'node3'] = tr;
  
      var prevRevpath = '';
      var prevPolygons = [];
      var prevtrace = trace._prevtrace;
  
      if(prevtrace) {
          prevRevpath = prevtrace._prevRevpath || '';
          tonext = prevtrace._nextFill;
          prevPolygons = prevtrace._polygons;
      }
  
      var thispath;
      var thisrevpath;
      // fullpath is all paths for this curve, joined together straight
      // across gaps, for filling
      var fullpath = '';
      // revpath is fullpath reversed, for fill-to-next
      var revpath = '';
      // functions for converting a point array to a path
      var pathfn, revpathbase, revpathfn;
      // variables used before and after the data join
      var pt0, lastSegment, pt1, thisPolygons;
  
      // initialize line join data / method
      var segments = [];
      var makeUpdate = Lib.noop;
  
      ownFillEl3 = trace._ownFill;
  
      if(subTypes.hasLines(trace) || trace.fill !== 'none') {
          if(tonext) {
              // This tells .style which trace to use for fill information:
              tonext.datum(cdscatter);
          }
  
          if(['hv', 'vh', 'hvh', 'vhv'].indexOf(line.shape) !== -1) {
              pathfn = Drawing.steps(line.shape);
              revpathbase = Drawing.steps(
                  line.shape.split('').reverse().join('')
              );
          } else if(line.shape === 'spline') {
              pathfn = revpathbase = function(pts) {
                  var pLast = pts[pts.length - 1];
                  if(pts.length > 1 && pts[0][0] === pLast[0] && pts[0][1] === pLast[1]) {
                      // identical start and end points: treat it as a
                      // closed curve so we don't get a kink
                      return Drawing.smoothclosed(pts.slice(1), line.smoothing);
                  } else {
                      return Drawing.smoothopen(pts, line.smoothing);
                  }
              };
          } else {
              pathfn = revpathbase = function(pts) {
                  return 'M' + pts.join('L');
              };
          }
  
          revpathfn = function(pts) {
              // note: this is destructive (reverses pts in place) so can't use pts after this
              return revpathbase(pts.reverse());
          };
  
          segments = linePoints(cdscatter, {
              xaxis: xa,
              yaxis: ya,
              connectGaps: trace.connectgaps,
              baseTolerance: Math.max(line.width || 1, 3) / 4,
              shape: line.shape,
              simplify: line.simplify,
              fill: trace.fill
          });
  
          // since we already have the pixel segments here, use them to make
          // polygons for hover on fill
          // TODO: can we skip this if hoveron!=fills? That would mean we
          // need to redraw when you change hoveron...
          thisPolygons = trace._polygons = new Array(segments.length);
          for(i = 0; i < segments.length; i++) {
              trace._polygons[i] = polygonTester(segments[i]);
          }
  
          if(segments.length) {
              pt0 = segments[0][0];
              lastSegment = segments[segments.length - 1];
              pt1 = lastSegment[lastSegment.length - 1];
          }
  
          makeUpdate = function(isEnter) {
              return function(pts) {
                  thispath = pathfn(pts);
                  thisrevpath = revpathfn(pts);
                  if(!fullpath) {
                      fullpath = thispath;
                      revpath = thisrevpath;
                  } else if(ownFillDir) {
                      fullpath += 'L' + thispath.substr(1);
                      revpath = thisrevpath + ('L' + revpath.substr(1));
                  } else {
                      fullpath += 'Z' + thispath;
                      revpath = thisrevpath + 'Z' + revpath;
                  }
  
                  if(subTypes.hasLines(trace) && pts.length > 1) {
                      var el = d3.select(this);
  
                      // This makes the coloring work correctly:
                      el.datum(cdscatter);
  
                      if(isEnter) {
                          transition(el.style('opacity', 0)
                              .attr('d', thispath)
                              .call(Drawing.lineGroupStyle))
                                  .style('opacity', 1);
                      } else {
                          var sel = transition(el);
                          sel.attr('d', thispath);
                          Drawing.singleLineStyle(cdscatter, sel);
                      }
                  }
              };
          };
      }
  
      var lineJoin = lines.selectAll('.js-line').data(segments);
  
      transition(lineJoin.exit())
          .style('opacity', 0)
          .remove();
  
      lineJoin.each(makeUpdate(false));
  
      lineJoin.enter().append('path')
          .classed('js-line', true)
          .style('vector-effect', 'non-scaling-stroke')
          .call(Drawing.lineGroupStyle)
          .each(makeUpdate(true));
  
      Drawing.setClipUrl(lineJoin, plotinfo.layerClipId, gd);
  
      function clearFill(selection) {
          transition(selection).attr('d', 'M0,0Z');
      }
  
      if(segments.length) {
          if(ownFillEl3) {
              ownFillEl3.datum(cdscatter);
              if(pt0 && pt1) {
                  if(ownFillDir) {
                      if(ownFillDir === 'y') {
                          pt0[1] = pt1[1] = ya.c2p(0, true);
                      } else if(ownFillDir === 'x') {
                          pt0[0] = pt1[0] = xa.c2p(0, true);
                      }
  
                      // fill to zero: full trace path, plus extension of
                      // the endpoints to the appropriate axis
                      // For the sake of animations, wrap the points around so that
                      // the points on the axes are the first two points. Otherwise
                      // animations get a little crazy if the number of points changes.
                      transition(ownFillEl3).attr('d', 'M' + pt1 + 'L' + pt0 + 'L' + fullpath.substr(1))
                          .call(Drawing.singleFillStyle);
                  } else {
                      // fill to self: just join the path to itself
                      transition(ownFillEl3).attr('d', fullpath + 'Z')
                          .call(Drawing.singleFillStyle);
                  }
              }
          } else if(tonext) {
              if(trace.fill.substr(0, 6) === 'tonext' && fullpath && prevRevpath) {
                  // fill to next: full trace path, plus the previous path reversed
                  if(trace.fill === 'tonext') {
                      // tonext: for use by concentric shapes, like manually constructed
                      // contours, we just add the two paths closed on themselves.
                      // This makes strange results if one path is *not* entirely
                      // inside the other, but then that is a strange usage.
                      transition(tonext).attr('d', fullpath + 'Z' + prevRevpath + 'Z')
                          .call(Drawing.singleFillStyle);
                  } else {
                      // tonextx/y: for now just connect endpoints with lines. This is
                      // the correct behavior if the endpoints are at the same value of
                      // y/x, but if they *aren't*, we should ideally do more complicated
                      // things depending on whether the new endpoint projects onto the
                      // existing curve or off the end of it
                      transition(tonext).attr('d', fullpath + 'L' + prevRevpath.substr(1) + 'Z')
                          .call(Drawing.singleFillStyle);
                  }
                  trace._polygons = trace._polygons.concat(prevPolygons);
              } else {
                  clearFill(tonext);
                  trace._polygons = null;
              }
          }
          trace._prevRevpath = revpath;
          trace._prevPolygons = thisPolygons;
      } else {
          if(ownFillEl3) clearFill(ownFillEl3);
          else if(tonext) clearFill(tonext);
          trace._polygons = trace._prevRevpath = trace._prevPolygons = null;
      }
  
  
      function visFilter(d) {
          return d.filter(function(v) { return !v.gap && v.vis; });
      }
  
      function visFilterWithGaps(d) {
          return d.filter(function(v) { return v.vis; });
      }
  
      function gapFilter(d) {
          return d.filter(function(v) { return !v.gap; });
      }
  
      function keyFunc(d) {
          return d.id;
      }
  
      // Returns a function if the trace is keyed, otherwise returns undefined
      function getKeyFunc(trace) {
          if(trace.ids) {
              return keyFunc;
          }
      }
  
      function hideFilter() {
          return false;
      }
  
      function makePoints(points, text, cdscatter) {
          var join, selection, hasNode;
  
          var trace = cdscatter[0].trace;
          var showMarkers = subTypes.hasMarkers(trace);
          var showText = subTypes.hasText(trace);
  
          var keyFunc = getKeyFunc(trace);
          var markerFilter = hideFilter;
          var textFilter = hideFilter;
  
          if(showMarkers || showText) {
              var showFilter = identity;
              // if we're stacking, "infer zero" gap mode gets markers in the
              // gap points - because we've inferred a zero there - but other
              // modes (currently "interpolate", later "interrupt" hopefully)
              // we don't draw generated markers
              var stackGroup = trace.stackgroup;
              var isInferZero = stackGroup && (
                  gd._fullLayout._scatterStackOpts[xa._id + ya._id][stackGroup].stackgaps === 'infer zero');
              if(trace.marker.maxdisplayed || trace._needsCull) {
                  showFilter = isInferZero ? visFilterWithGaps : visFilter;
              } else if(stackGroup && !isInferZero) {
                  showFilter = gapFilter;
              }
  
              if(showMarkers) markerFilter = showFilter;
              if(showText) textFilter = showFilter;
          }
  
          // marker points
  
          selection = points.selectAll('path.point');
  
          join = selection.data(markerFilter, keyFunc);
  
          var enter = join.enter().append('path')
              .classed('point', true);
  
          if(hasTransition) {
              enter
                  .call(Drawing.pointStyle, trace, gd)
                  .call(Drawing.translatePoints, xa, ya)
                  .style('opacity', 0)
                  .transition()
                  .style('opacity', 1);
          }
  
          join.order();
  
          var styleFns;
          if(showMarkers) {
              styleFns = Drawing.makePointStyleFns(trace);
          }
  
          join.each(function(d) {
              var el = d3.select(this);
              var sel = transition(el);
              hasNode = Drawing.translatePoint(d, sel, xa, ya);
  
              if(hasNode) {
                  Drawing.singlePointStyle(d, sel, trace, styleFns, gd);
  
                  if(plotinfo.layerClipId) {
                      Drawing.hideOutsideRangePoint(d, sel, xa, ya, trace.xcalendar, trace.ycalendar);
                  }
  
                  if(trace.customdata) {
                      el.classed('plotly-customdata', d.data !== null && d.data !== undefined);
                  }
              } else {
                  sel.remove();
              }
          });
  
          if(hasTransition) {
              join.exit().transition()
                  .style('opacity', 0)
                  .remove();
          } else {
              join.exit().remove();
          }
  
          // text points
          selection = text.selectAll('g');
          join = selection.data(textFilter, keyFunc);
  
          // each text needs to go in its own 'g' in case
          // it gets converted to mathjax
          join.enter().append('g').classed('textpoint', true).append('text');
  
          join.order();
  
          join.each(function(d) {
              var g = d3.select(this);
              var sel = transition(g.select('text'));
              hasNode = Drawing.translatePoint(d, sel, xa, ya);
  
              if(hasNode) {
                  if(plotinfo.layerClipId) {
                      Drawing.hideOutsideRangePoint(d, g, xa, ya, trace.xcalendar, trace.ycalendar);
                  }
              } else {
                  g.remove();
              }
          });
  
          join.selectAll('text')
              .call(Drawing.textPointStyle, trace, gd)
              .each(function(d) {
                  // This just *has* to be totally custom becuase of SVG text positioning :(
                  // It's obviously copied from translatePoint; we just can't use that
                  var x = xa.c2p(d.x);
                  var y = ya.c2p(d.y);
  
                  d3.select(this).selectAll('tspan.line').each(function() {
                      transition(d3.select(this)).attr({x: x, y: y});
                  });
              });
  
          join.exit().remove();
      }
  
      points.datum(cdscatter);
      text.datum(cdscatter);
      makePoints(points, text, cdscatter);
  
      // lastly, clip points groups of `cliponaxis !== false` traces
      // on `plotinfo._hasClipOnAxisFalse === true` subplots
      var hasClipOnAxisFalse = trace.cliponaxis === false;
      var clipUrl = hasClipOnAxisFalse ? null : plotinfo.layerClipId;
      Drawing.setClipUrl(points, clipUrl, gd);
      Drawing.setClipUrl(text, clipUrl, gd);
  }
  
  function selectMarkers(gd, idx, plotinfo, cdscatter, cdscatterAll) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
      var xr = d3.extent(Lib.simpleMap(xa.range, xa.r2c));
      var yr = d3.extent(Lib.simpleMap(ya.range, ya.r2c));
  
      var trace = cdscatter[0].trace;
      if(!subTypes.hasMarkers(trace)) return;
      // if marker.maxdisplayed is used, select a maximum of
      // mnum markers to show, from the set that are in the viewport
      var mnum = trace.marker.maxdisplayed;
  
      // TODO: remove some as we get away from the viewport?
      if(mnum === 0) return;
  
      var cd = cdscatter.filter(function(v) {
          return v.x >= xr[0] && v.x <= xr[1] && v.y >= yr[0] && v.y <= yr[1];
      });
      var inc = Math.ceil(cd.length / mnum);
      var tnum = 0;
      cdscatterAll.forEach(function(cdj, j) {
          var tracei = cdj[0].trace;
          if(subTypes.hasMarkers(tracei) &&
                  tracei.marker.maxdisplayed > 0 && j < idx) {
              tnum++;
          }
      });
  
      // if multiple traces use maxdisplayed, stagger which markers we
      // display this formula offsets successive traces by 1/3 of the
      // increment, adding an extra small amount after each triplet so
      // it's not quite periodic
      var i0 = Math.round(tnum * inc / 3 + Math.floor(tnum / 3) * inc / 7.1);
  
      // for error bars: save in cd which markers to show
      // so we don't have to repeat this
      cdscatter.forEach(function(v) { delete v.vis; });
      cd.forEach(function(v, i) {
          if(Math.round((i + i0) % inc) === 0) v.vis = true;
      });
  }
  
  },{"../../components/drawing":637,"../../lib":750,"../../lib/polygon":762,"../../registry":882,"./line_points":1172,"./link_traces":1174,"./subtypes":1183,"d3":169}],1180:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var subtypes = _dereq_('./subtypes');
  
  module.exports = function selectPoints(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var xa = searchInfo.xaxis;
      var ya = searchInfo.yaxis;
      var selection = [];
      var trace = cd[0].trace;
      var i;
      var di;
      var x;
      var y;
  
      var hasOnlyLines = (!subtypes.hasMarkers(trace) && !subtypes.hasText(trace));
      if(hasOnlyLines) return [];
  
      if(selectionTester === false) { // clear selection
          for(i = 0; i < cd.length; i++) {
              cd[i].selected = 0;
          }
      } else {
          for(i = 0; i < cd.length; i++) {
              di = cd[i];
              x = xa.c2p(di.x);
              y = ya.c2p(di.y);
  
              if((di.i !== null) && selectionTester.contains([x, y], false, i, searchInfo)) {
                  selection.push({
                      pointNumber: di.i,
                      x: xa.c2d(di.x),
                      y: ya.c2d(di.y)
                  });
                  di.selected = 1;
              } else {
                  di.selected = 0;
              }
          }
      }
  
      return selection;
  };
  
  },{"./subtypes":1183}],1181:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var perStackAttrs = ['orientation', 'groupnorm', 'stackgaps'];
  
  module.exports = function handleStackDefaults(traceIn, traceOut, layout, coerce) {
      var stackOpts = layout._scatterStackOpts;
  
      var stackGroup = coerce('stackgroup');
      if(stackGroup) {
          // use independent stacking options per subplot
          var subplot = traceOut.xaxis + traceOut.yaxis;
          var subplotStackOpts = stackOpts[subplot];
          if(!subplotStackOpts) subplotStackOpts = stackOpts[subplot] = {};
  
          var groupOpts = subplotStackOpts[stackGroup];
          var firstTrace = false;
          if(groupOpts) {
              groupOpts.traces.push(traceOut);
          } else {
              groupOpts = subplotStackOpts[stackGroup] = {
                  // keep track of trace indices for use during stacking calculations
                  // this will be filled in during `calc` and used during `crossTraceCalc`
                  // so it's OK if we don't recreate it during a non-calc edit
                  traceIndices: [],
                  // Hold on to the whole set of prior traces
                  // First one is most important, so we can clear defaults
                  // there if we find explicit values only in later traces.
                  // We're only going to *use* the values stored in groupOpts,
                  // but for the editor and validate we want things self-consistent
                  // The full set of traces is used only to fix `fill` default if
                  // we find `orientation: 'h'` beyond the first trace
                  traces: [traceOut]
              };
              firstTrace = true;
          }
          // TODO: how is this going to work with groupby transforms?
          // in principle it should be OK I guess, as long as explicit group styles
          // don't override explicit base-trace styles?
  
          var dflts = {
              orientation: (traceOut.x && !traceOut.y) ? 'h' : 'v'
          };
  
          for(var i = 0; i < perStackAttrs.length; i++) {
              var attr = perStackAttrs[i];
              var attrFound = attr + 'Found';
              if(!groupOpts[attrFound]) {
                  var traceHasAttr = traceIn[attr] !== undefined;
                  var isOrientation = attr === 'orientation';
                  if(traceHasAttr || firstTrace) {
                      groupOpts[attr] = coerce(attr, dflts[attr]);
  
                      if(isOrientation) {
                          groupOpts.fillDflt = groupOpts[attr] === 'h' ?
                              'tonextx' : 'tonexty';
                      }
  
                      if(traceHasAttr) {
                          // Note: this will show a value here even if it's invalid
                          // in which case it will revert to default.
                          groupOpts[attrFound] = true;
  
                          // Note: only one trace in the stack will get a _fullData
                          // entry for a given stack-wide attribute. If no traces
                          // (or the first trace) specify that attribute, the
                          // first trace will get it. If the first trace does NOT
                          // specify it but some later trace does, then it gets
                          // removed from the first trace and only included in the
                          // one that specified it. This is mostly important for
                          // editors (that want to see the full values to know
                          // what settings are available) and Plotly.react diffing.
                          // Editors may want to use fullLayout._scatterStackOpts
                          // directly and make these settings available from all
                          // traces in the stack... then set the new value into
                          // the first trace, and clear all later traces.
                          if(!firstTrace) {
                              delete groupOpts.traces[0][attr];
  
                              // orientation can affect default fill of previous traces
                              if(isOrientation) {
                                  for(var j = 0; j < groupOpts.traces.length - 1; j++) {
                                      var trace2 = groupOpts.traces[j];
                                      if(trace2._input.fill !== trace2.fill) {
                                          trace2.fill = groupOpts.fillDflt;
                                      }
                                  }
                              }
                          }
                      }
                  }
              }
          }
          return groupOpts;
      }
  };
  
  },{}],1182:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Drawing = _dereq_('../../components/drawing');
  var Registry = _dereq_('../../registry');
  
  function style(gd) {
      var s = d3.select(gd).selectAll('g.trace.scatter');
  
      s.style('opacity', function(d) {
          return d[0].trace.opacity;
      });
  
      s.selectAll('g.points').each(function(d) {
          var sel = d3.select(this);
          var trace = d.trace || d[0].trace;
          stylePoints(sel, trace, gd);
      });
  
      s.selectAll('g.text').each(function(d) {
          var sel = d3.select(this);
          var trace = d.trace || d[0].trace;
          styleText(sel, trace, gd);
      });
  
      s.selectAll('g.trace path.js-line')
          .call(Drawing.lineGroupStyle);
  
      s.selectAll('g.trace path.js-fill')
          .call(Drawing.fillGroupStyle);
  
      Registry.getComponentMethod('errorbars', 'style')(s);
  }
  
  function stylePoints(sel, trace, gd) {
      Drawing.pointStyle(sel.selectAll('path.point'), trace, gd);
  }
  
  function styleText(sel, trace, gd) {
      Drawing.textPointStyle(sel.selectAll('text'), trace, gd);
  }
  
  function styleOnSelect(gd, cd, sel) {
      var trace = cd[0].trace;
  
      if(trace.selectedpoints) {
          Drawing.selectedPointStyle(sel.selectAll('path.point'), trace);
          Drawing.selectedTextStyle(sel.selectAll('text'), trace);
      } else {
          stylePoints(sel, trace, gd);
          styleText(sel, trace, gd);
      }
  }
  
  module.exports = {
      style: style,
      stylePoints: stylePoints,
      styleText: styleText,
      styleOnSelect: styleOnSelect
  };
  
  },{"../../components/drawing":637,"../../registry":882,"d3":169}],1183:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  module.exports = {
      hasLines: function(trace) {
          return trace.visible && trace.mode &&
              trace.mode.indexOf('lines') !== -1;
      },
  
      hasMarkers: function(trace) {
          return trace.visible && (
              (trace.mode && trace.mode.indexOf('markers') !== -1) ||
              // until splom implements 'mode'
              trace.type === 'splom'
          );
      },
  
      hasText: function(trace) {
          return trace.visible && trace.mode &&
              trace.mode.indexOf('text') !== -1;
      },
  
      isBubble: function(trace) {
          return Lib.isPlainObject(trace.marker) &&
              Lib.isArrayOrTypedArray(trace.marker.size);
      }
  };
  
  },{"../../lib":750}],1184:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  /*
   * opts: object of flags to control features not all text users support
   *   noSelect: caller does not support selected/unselected attribute containers
   */
  module.exports = function(traceIn, traceOut, layout, coerce, opts) {
      opts = opts || {};
  
      coerce('textposition');
      Lib.coerceFont(coerce, 'textfont', layout.font);
  
      if(!opts.noSelect) {
          coerce('selected.textfont.color');
          coerce('unselected.textfont.color');
      }
  };
  
  },{"../../lib":750}],1185:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  
  module.exports = function handleXYDefaults(traceIn, traceOut, layout, coerce) {
      var x = coerce('x');
      var y = coerce('y');
      var len;
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, ['x', 'y'], layout);
  
      if(x) {
          var xlen = Lib.minRowLength(x);
          if(y) {
              len = Math.min(xlen, Lib.minRowLength(y));
          } else {
              len = xlen;
              coerce('y0');
              coerce('dy');
          }
      } else {
          if(!y) return 0;
  
          len = Lib.minRowLength(y);
          coerce('x0');
          coerce('dx');
      }
  
      traceOut._length = len;
  
      return len;
  };
  
  },{"../../lib":750,"../../registry":882}],1186:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterAttrs = _dereq_('../scatter/attributes');
  var colorAttributes = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var baseAttrs = _dereq_('../../plots/attributes');
  var DASHES = _dereq_('../../constants/gl3d_dashes');
  
  var MARKER_SYMBOLS = _dereq_('../../constants/gl3d_markers');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var scatterLineAttrs = scatterAttrs.line;
  var scatterMarkerAttrs = scatterAttrs.marker;
  var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
  
  var lineAttrs = extendFlat({
      width: scatterLineAttrs.width,
      dash: {
          valType: 'enumerated',
          values: Object.keys(DASHES),
          dflt: 'solid',
          
          
      }
  }, colorAttributes('line'));
  
  function makeProjectionAttr(axLetter) {
      return {
          show: {
              valType: 'boolean',
              
              dflt: false,
              
          },
          opacity: {
              valType: 'number',
              
              min: 0,
              max: 1,
              dflt: 1,
              
          },
          scale: {
              valType: 'number',
              
              min: 0,
              max: 10,
              dflt: 2 / 3,
              
          }
      };
  }
  
  var attrs = module.exports = overrideAll({
      x: scatterAttrs.x,
      y: scatterAttrs.y,
      z: {
          valType: 'data_array',
          
      },
  
      text: extendFlat({}, scatterAttrs.text, {
          
      }),
      texttemplate: texttemplateAttrs({}, {
  
      }),
      hovertext: extendFlat({}, scatterAttrs.hovertext, {
          
      }),
      hovertemplate: hovertemplateAttrs(),
  
      mode: extendFlat({}, scatterAttrs.mode,  // shouldn't this be on-par with 2D?
          {dflt: 'lines+markers'}),
      surfaceaxis: {
          valType: 'enumerated',
          
          values: [-1, 0, 1, 2],
          dflt: -1,
          
      },
      surfacecolor: {
          valType: 'color',
          
          
      },
      projection: {
          x: makeProjectionAttr('x'),
          y: makeProjectionAttr('y'),
          z: makeProjectionAttr('z')
      },
  
      connectgaps: scatterAttrs.connectgaps,
      line: lineAttrs,
  
      marker: extendFlat({  // Parity with scatter.js?
          symbol: {
              valType: 'enumerated',
              values: Object.keys(MARKER_SYMBOLS),
              
              dflt: 'circle',
              arrayOk: true,
              
          },
          size: extendFlat({}, scatterMarkerAttrs.size, {dflt: 8}),
          sizeref: scatterMarkerAttrs.sizeref,
          sizemin: scatterMarkerAttrs.sizemin,
          sizemode: scatterMarkerAttrs.sizemode,
          opacity: extendFlat({}, scatterMarkerAttrs.opacity, {
              arrayOk: false,
              
          }),
          colorbar: scatterMarkerAttrs.colorbar,
  
          line: extendFlat({
              width: extendFlat({}, scatterMarkerLineAttrs.width, {arrayOk: false})
          },
              colorAttributes('marker.line')
          )
      },
          colorAttributes('marker')
      ),
  
      textposition: extendFlat({}, scatterAttrs.textposition, {dflt: 'top center'}),
      textfont: {
          color: scatterAttrs.textfont.color,
          size: scatterAttrs.textfont.size,
          family: extendFlat({}, scatterAttrs.textfont.family, {arrayOk: false})
      },
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo)
  }, 'calc', 'nested');
  
  attrs.x.editType = attrs.y.editType = attrs.z.editType = 'calc+clearAxisTypes';
  
  },{"../../components/colorscale/attributes":622,"../../constants/gl3d_dashes":722,"../../constants/gl3d_markers":723,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plots/attributes":795,"../../plots/template_attributes":877,"../scatter/attributes":1158}],1187:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
  var calcColorscale = _dereq_('../scatter/colorscale_calc');
  
  /**
   * This is a kludge to put the array attributes into
   * calcdata the way Scatter.plot does, so that legends and
   * popovers know what to do with them.
   */
  module.exports = function calc(gd, trace) {
      var cd = [{x: false, y: false, trace: trace, t: {}}];
  
      arraysToCalcdata(cd, trace);
      calcColorscale(gd, trace);
  
      return cd;
  };
  
  },{"../scatter/arrays_to_calcdata":1157,"../scatter/colorscale_calc":1161}],1188:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  
  function calculateAxisErrors(data, params, scaleFactor, axis) {
      if(!params || !params.visible) return null;
  
      var computeError = Registry.getComponentMethod('errorbars', 'makeComputeError')(params);
      var result = new Array(data.length);
  
      for(var i = 0; i < data.length; i++) {
          var errors = computeError(+data[i], i);
  
          if(axis.type === 'log') {
              var point = axis.c2l(data[i]);
              var min = data[i] - errors[0];
              var max = data[i] + errors[1];
  
              result[i] = [
                  (axis.c2l(min, true) - point) * scaleFactor,
                  (axis.c2l(max, true) - point) * scaleFactor
              ];
  
              // Keep track of the lower error bound which isn't negative!
              if(min > 0) {
                  var lower = axis.c2l(min);
                  if(!axis._lowerLogErrorBound) axis._lowerLogErrorBound = lower;
                  axis._lowerErrorBound = Math.min(axis._lowerLogErrorBound, lower);
              }
          } else {
              result[i] = [
                  -errors[0] * scaleFactor,
                  errors[1] * scaleFactor
              ];
          }
      }
  
      return result;
  }
  
  function dataLength(array) {
      for(var i = 0; i < array.length; i++) {
          if(array[i]) return array[i].length;
      }
      return 0;
  }
  
  function calculateErrors(data, scaleFactor, sceneLayout) {
      var errors = [
          calculateAxisErrors(data.x, data.error_x, scaleFactor[0], sceneLayout.xaxis),
          calculateAxisErrors(data.y, data.error_y, scaleFactor[1], sceneLayout.yaxis),
          calculateAxisErrors(data.z, data.error_z, scaleFactor[2], sceneLayout.zaxis)
      ];
  
      var n = dataLength(errors);
      if(n === 0) return null;
  
      var errorBounds = new Array(n);
  
      for(var i = 0; i < n; i++) {
          var bound = [[0, 0, 0], [0, 0, 0]];
  
          for(var j = 0; j < 3; j++) {
              if(errors[j]) {
                  for(var k = 0; k < 2; k++) {
                      bound[k][j] = errors[j][i][k];
                  }
              }
          }
  
          errorBounds[i] = bound;
      }
  
      return errorBounds;
  }
  
  module.exports = calculateErrors;
  
  },{"../../registry":882}],1189:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var createLinePlot = _dereq_('gl-line3d');
  var createScatterPlot = _dereq_('gl-scatter3d');
  var createErrorBars = _dereq_('gl-error3d');
  var createMesh = _dereq_('gl-mesh3d');
  var triangulate = _dereq_('delaunay-triangulate');
  
  var Lib = _dereq_('../../lib');
  var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
  var formatColor = _dereq_('../../lib/gl_format_color').formatColor;
  var makeBubbleSizeFn = _dereq_('../scatter/make_bubble_size_func');
  var DASH_PATTERNS = _dereq_('../../constants/gl3d_dashes');
  var MARKER_SYMBOLS = _dereq_('../../constants/gl3d_markers');
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
  
  var calculateError = _dereq_('./calc_errors');
  
  function LineWithMarkers(scene, uid) {
      this.scene = scene;
      this.uid = uid;
      this.linePlot = null;
      this.scatterPlot = null;
      this.errorBars = null;
      this.textMarkers = null;
      this.delaunayMesh = null;
      this.color = null;
      this.mode = '';
      this.dataPoints = [];
      this.axesBounds = [
          [-Infinity, -Infinity, -Infinity],
          [Infinity, Infinity, Infinity]
      ];
      this.textLabels = null;
      this.data = null;
  }
  
  var proto = LineWithMarkers.prototype;
  
  proto.handlePick = function(selection) {
      if(selection.object &&
          (selection.object === this.linePlot ||
           selection.object === this.delaunayMesh ||
           selection.object === this.textMarkers ||
           selection.object === this.scatterPlot)
      ) {
          var ind = selection.index = selection.data.index;
  
          if(selection.object.highlight) {
              selection.object.highlight(null);
          }
          if(this.scatterPlot) {
              selection.object = this.scatterPlot;
              this.scatterPlot.highlight(selection.data);
          }
  
          selection.textLabel = '';
          if(this.textLabels) {
              if(Array.isArray(this.textLabels)) {
                  if(this.textLabels[ind] || this.textLabels[ind] === 0) {
                      selection.textLabel = this.textLabels[ind];
                  }
              } else {
                  selection.textLabel = this.textLabels;
              }
          }
  
          selection.traceCoordinate = [
              this.data.x[ind],
              this.data.y[ind],
              this.data.z[ind]
          ];
  
          return true;
      }
  };
  
  function constructDelaunay(points, color, axis) {
      var u = (axis + 1) % 3;
      var v = (axis + 2) % 3;
      var filteredPoints = [];
      var filteredIds = [];
      var i;
  
      for(i = 0; i < points.length; ++i) {
          var p = points[i];
          if(isNaN(p[u]) || !isFinite(p[u]) ||
             isNaN(p[v]) || !isFinite(p[v])) {
              continue;
          }
          filteredPoints.push([p[u], p[v]]);
          filteredIds.push(i);
      }
      var cells = triangulate(filteredPoints);
      for(i = 0; i < cells.length; ++i) {
          var c = cells[i];
          for(var j = 0; j < c.length; ++j) {
              c[j] = filteredIds[c[j]];
          }
      }
      return {
          positions: points,
          cells: cells,
          meshColor: color
      };
  }
  
  function calculateErrorParams(errors) {
      var capSize = [0.0, 0.0, 0.0];
      var color = [[0, 0, 0], [0, 0, 0], [0, 0, 0]];
      var lineWidth = [1.0, 1.0, 1.0];
  
      for(var i = 0; i < 3; i++) {
          var e = errors[i];
  
          if(e && e.copy_zstyle !== false && errors[2].visible !== false) e = errors[2];
          if(!e || !e.visible) continue;
  
          capSize[i] = e.width / 2;  // ballpark rescaling
          color[i] = str2RgbaArray(e.color);
          lineWidth[i] = e.thickness;
      }
  
      return {capSize: capSize, color: color, lineWidth: lineWidth};
  }
  
  function parseAlignmentX(a) {
      if(a === null || a === undefined) return 0;
  
      return (a.indexOf('left') > -1) ? -1 :
             (a.indexOf('right') > -1) ? 1 : 0;
  }
  
  function parseAlignmentY(a) {
      if(a === null || a === undefined) return 0;
  
      return (a.indexOf('top') > -1) ? -1 :
             (a.indexOf('bottom') > -1) ? 1 : 0;
  }
  
  function calculateTextOffset(tp) {
      // Read out text properties
  
      var defaultAlignmentX = 0;
      var defaultAlignmentY = 0;
  
      var textOffset = [
          defaultAlignmentX,
          defaultAlignmentY
      ];
  
      if(Array.isArray(tp)) {
          for(var i = 0; i < tp.length; i++) {
              textOffset[i] = [
                  defaultAlignmentX,
                  defaultAlignmentY
              ];
              if(tp[i]) {
                  textOffset[i][0] = parseAlignmentX(tp[i]);
                  textOffset[i][1] = parseAlignmentY(tp[i]);
              }
          }
      } else {
          textOffset[0] = parseAlignmentX(tp);
          textOffset[1] = parseAlignmentY(tp);
      }
  
      return textOffset;
  }
  
  
  function calculateSize(sizeIn, sizeFn) {
      // rough parity with Plotly 2D markers
      return sizeFn(sizeIn * 4);
  }
  
  function calculateSymbol(symbolIn) {
      return MARKER_SYMBOLS[symbolIn];
  }
  
  function formatParam(paramIn, len, calculate, dflt, extraFn) {
      var paramOut = null;
  
      if(Lib.isArrayOrTypedArray(paramIn)) {
          paramOut = [];
  
          for(var i = 0; i < len; i++) {
              if(paramIn[i] === undefined) paramOut[i] = dflt;
              else paramOut[i] = calculate(paramIn[i], extraFn);
          }
      } else paramOut = calculate(paramIn, Lib.identity);
  
      return paramOut;
  }
  
  
  function convertPlotlyOptions(scene, data) {
      var points = [];
      var sceneLayout = scene.fullSceneLayout;
      var scaleFactor = scene.dataScale;
      var xaxis = sceneLayout.xaxis;
      var yaxis = sceneLayout.yaxis;
      var zaxis = sceneLayout.zaxis;
      var marker = data.marker;
      var line = data.line;
      var x = data.x || [];
      var y = data.y || [];
      var z = data.z || [];
      var len = x.length;
      var xcalendar = data.xcalendar;
      var ycalendar = data.ycalendar;
      var zcalendar = data.zcalendar;
      var xc, yc, zc;
      var params, i;
      var text;
  
      // Convert points
      for(i = 0; i < len; i++) {
          // sanitize numbers and apply transforms based on axes.type
          xc = xaxis.d2l(x[i], 0, xcalendar) * scaleFactor[0];
          yc = yaxis.d2l(y[i], 0, ycalendar) * scaleFactor[1];
          zc = zaxis.d2l(z[i], 0, zcalendar) * scaleFactor[2];
  
          points[i] = [xc, yc, zc];
      }
  
      // convert text
      if(Array.isArray(data.text)) text = data.text;
      else if(data.text !== undefined) {
          text = new Array(len);
          for(i = 0; i < len; i++) text[i] = data.text;
      }
  
      function formatter(axName, val) {
          var ax = sceneLayout[axName];
          return Axes.tickText(ax, ax.d2l(val), true).text;
      }
  
      // check texttemplate
      var texttemplate = data.texttemplate;
      if(texttemplate) {
          var fullLayout = scene.fullLayout;
          var d3locale = fullLayout._d3locale;
          var isArray = Array.isArray(texttemplate);
          var N = isArray ? Math.min(texttemplate.length, len) : len;
          var txt = isArray ?
              function(i) { return texttemplate[i]; } :
              function() { return texttemplate; };
  
          text = new Array(N);
  
          for(i = 0; i < N; i++) {
              var d = {x: x[i], y: y[i], z: z[i]};
              var labels = {
                  xLabel: formatter('xaxis', x[i]),
                  yLabel: formatter('yaxis', y[i]),
                  zLabel: formatter('zaxis', z[i])
              };
              var pointValues = {};
              appendArrayPointValue(pointValues, data, i);
              var meta = data._meta || {};
              text[i] = Lib.texttemplateString(txt(i), labels, d3locale, pointValues, d, meta);
          }
      }
  
      // Build object parameters
      params = {
          position: points,
          mode: data.mode,
          text: text
      };
  
      if('line' in data) {
          params.lineColor = formatColor(line, 1, len);
          params.lineWidth = line.width;
          params.lineDashes = line.dash;
      }
  
      if('marker' in data) {
          var sizeFn = makeBubbleSizeFn(data);
  
          params.scatterColor = formatColor(marker, 1, len);
          params.scatterSize = formatParam(marker.size, len, calculateSize, 20, sizeFn);
          params.scatterMarker = formatParam(marker.symbol, len, calculateSymbol, '●');
          params.scatterLineWidth = marker.line.width;  // arrayOk === false
          params.scatterLineColor = formatColor(marker.line, 1, len);
          params.scatterAngle = 0;
      }
  
      if('textposition' in data) {
          params.textOffset = calculateTextOffset(data.textposition);
          params.textColor = formatColor(data.textfont, 1, len);
          params.textSize = formatParam(data.textfont.size, len, Lib.identity, 12);
          params.textFont = data.textfont.family;  // arrayOk === false
          params.textAngle = 0;
      }
  
      var dims = ['x', 'y', 'z'];
      params.project = [false, false, false];
      params.projectScale = [1, 1, 1];
      params.projectOpacity = [1, 1, 1];
      for(i = 0; i < 3; ++i) {
          var projection = data.projection[dims[i]];
          if((params.project[i] = projection.show)) {
              params.projectOpacity[i] = projection.opacity;
              params.projectScale[i] = projection.scale;
          }
      }
  
      params.errorBounds = calculateError(data, scaleFactor, sceneLayout);
  
      var errorParams = calculateErrorParams([data.error_x, data.error_y, data.error_z]);
      params.errorColor = errorParams.color;
      params.errorLineWidth = errorParams.lineWidth;
      params.errorCapSize = errorParams.capSize;
  
      params.delaunayAxis = data.surfaceaxis;
      params.delaunayColor = str2RgbaArray(data.surfacecolor);
  
      return params;
  }
  
  function _arrayToColor(color) {
      if(Lib.isArrayOrTypedArray(color)) {
          var c = color[0];
  
          if(Lib.isArrayOrTypedArray(c)) color = c;
  
          return 'rgb(' + color.slice(0, 3).map(function(x) {
              return Math.round(x * 255);
          }) + ')';
      }
  
      return null;
  }
  
  function arrayToColor(colors) {
      if(!Lib.isArrayOrTypedArray(colors)) {
          return null;
      }
  
      if((colors.length === 4) && (typeof colors[0] === 'number')) {
          return _arrayToColor(colors);
      }
  
      return colors.map(_arrayToColor);
  }
  
  proto.update = function(data) {
      var gl = this.scene.glplot.gl;
      var lineOptions;
      var scatterOptions;
      var errorOptions;
      var textOptions;
      var dashPattern = DASH_PATTERNS.solid;
  
      // Save data
      this.data = data;
  
      // Run data conversion
      var options = convertPlotlyOptions(this.scene, data);
  
      if('mode' in options) {
          this.mode = options.mode;
      }
      if('lineDashes' in options) {
          if(options.lineDashes in DASH_PATTERNS) {
              dashPattern = DASH_PATTERNS[options.lineDashes];
          }
      }
  
      this.color = arrayToColor(options.scatterColor) ||
                   arrayToColor(options.lineColor);
  
      // Save data points
      this.dataPoints = options.position;
  
      lineOptions = {
          gl: this.scene.glplot.gl,
          position: options.position,
          color: options.lineColor,
          lineWidth: options.lineWidth || 1,
          dashes: dashPattern[0],
          dashScale: dashPattern[1],
          opacity: data.opacity,
          connectGaps: data.connectgaps
      };
  
      if(this.mode.indexOf('lines') !== -1) {
          if(this.linePlot) this.linePlot.update(lineOptions);
          else {
              this.linePlot = createLinePlot(lineOptions);
              this.linePlot._trace = this;
              this.scene.glplot.add(this.linePlot);
          }
      } else if(this.linePlot) {
          this.scene.glplot.remove(this.linePlot);
          this.linePlot.dispose();
          this.linePlot = null;
      }
  
      // N.B. marker.opacity must be a scalar for performance
      var scatterOpacity = data.opacity;
      if(data.marker && data.marker.opacity) scatterOpacity *= data.marker.opacity;
  
      scatterOptions = {
          gl: this.scene.glplot.gl,
          position: options.position,
          color: options.scatterColor,
          size: options.scatterSize,
          glyph: options.scatterMarker,
          opacity: scatterOpacity,
          orthographic: true,
          lineWidth: options.scatterLineWidth,
          lineColor: options.scatterLineColor,
          project: options.project,
          projectScale: options.projectScale,
          projectOpacity: options.projectOpacity
      };
  
      if(this.mode.indexOf('markers') !== -1) {
          if(this.scatterPlot) this.scatterPlot.update(scatterOptions);
          else {
              this.scatterPlot = createScatterPlot(scatterOptions);
              this.scatterPlot._trace = this;
              this.scatterPlot.highlightScale = 1;
              this.scene.glplot.add(this.scatterPlot);
          }
      } else if(this.scatterPlot) {
          this.scene.glplot.remove(this.scatterPlot);
          this.scatterPlot.dispose();
          this.scatterPlot = null;
      }
  
      textOptions = {
          gl: this.scene.glplot.gl,
          position: options.position,
          glyph: options.text,
          color: options.textColor,
          size: options.textSize,
          angle: options.textAngle,
          alignment: options.textOffset,
          font: options.textFont,
          orthographic: true,
          lineWidth: 0,
          project: false,
          opacity: data.opacity
      };
  
      this.textLabels = data.hovertext || data.text;
  
      if(this.mode.indexOf('text') !== -1) {
          if(this.textMarkers) this.textMarkers.update(textOptions);
          else {
              this.textMarkers = createScatterPlot(textOptions);
              this.textMarkers._trace = this;
              this.textMarkers.highlightScale = 1;
              this.scene.glplot.add(this.textMarkers);
          }
      } else if(this.textMarkers) {
          this.scene.glplot.remove(this.textMarkers);
          this.textMarkers.dispose();
          this.textMarkers = null;
      }
  
      errorOptions = {
          gl: this.scene.glplot.gl,
          position: options.position,
          color: options.errorColor,
          error: options.errorBounds,
          lineWidth: options.errorLineWidth,
          capSize: options.errorCapSize,
          opacity: data.opacity
      };
      if(this.errorBars) {
          if(options.errorBounds) {
              this.errorBars.update(errorOptions);
          } else {
              this.scene.glplot.remove(this.errorBars);
              this.errorBars.dispose();
              this.errorBars = null;
          }
      } else if(options.errorBounds) {
          this.errorBars = createErrorBars(errorOptions);
          this.errorBars._trace = this;
          this.scene.glplot.add(this.errorBars);
      }
  
      if(options.delaunayAxis >= 0) {
          var delaunayOptions = constructDelaunay(
              options.position,
              options.delaunayColor,
              options.delaunayAxis
          );
          delaunayOptions.opacity = data.opacity;
  
          if(this.delaunayMesh) {
              this.delaunayMesh.update(delaunayOptions);
          } else {
              delaunayOptions.gl = gl;
              this.delaunayMesh = createMesh(delaunayOptions);
              this.delaunayMesh._trace = this;
              this.scene.glplot.add(this.delaunayMesh);
          }
      } else if(this.delaunayMesh) {
          this.scene.glplot.remove(this.delaunayMesh);
          this.delaunayMesh.dispose();
          this.delaunayMesh = null;
      }
  };
  
  proto.dispose = function() {
      if(this.linePlot) {
          this.scene.glplot.remove(this.linePlot);
          this.linePlot.dispose();
      }
      if(this.scatterPlot) {
          this.scene.glplot.remove(this.scatterPlot);
          this.scatterPlot.dispose();
      }
      if(this.errorBars) {
          this.scene.glplot.remove(this.errorBars);
          this.errorBars.dispose();
      }
      if(this.textMarkers) {
          this.scene.glplot.remove(this.textMarkers);
          this.textMarkers.dispose();
      }
      if(this.delaunayMesh) {
          this.scene.glplot.remove(this.delaunayMesh);
          this.delaunayMesh.dispose();
      }
  };
  
  function createLineWithMarkers(scene, data) {
      var plot = new LineWithMarkers(scene, data.uid);
      plot.update(data);
      return plot;
  }
  
  module.exports = createLineWithMarkers;
  
  },{"../../components/fx/helpers":651,"../../constants/gl3d_dashes":722,"../../constants/gl3d_markers":723,"../../lib":750,"../../lib/gl_format_color":746,"../../lib/str2rgbarray":773,"../../plots/cartesian/axes":799,"../scatter/make_bubble_size_func":1175,"./calc_errors":1188,"delaunay-triangulate":171,"gl-error3d":264,"gl-line3d":271,"gl-mesh3d":292,"gl-scatter3d":308}],1190:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  
  var subTypes = _dereq_('../scatter/subtypes');
  var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
  var handleLineDefaults = _dereq_('../scatter/line_defaults');
  var handleTextDefaults = _dereq_('../scatter/text_defaults');
  
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleXYZDefaults(traceIn, traceOut, coerce, layout);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
      coerce('mode');
  
      if(subTypes.hasLines(traceOut)) {
          coerce('connectgaps');
          handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
      }
  
      if(subTypes.hasMarkers(traceOut)) {
          handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {noSelect: true});
      }
  
      if(subTypes.hasText(traceOut)) {
          coerce('texttemplate');
          handleTextDefaults(traceIn, traceOut, layout, coerce, {noSelect: true});
      }
  
      var lineColor = (traceOut.line || {}).color;
      var markerColor = (traceOut.marker || {}).color;
      if(coerce('surfaceaxis') >= 0) coerce('surfacecolor', lineColor || markerColor);
  
      var dims = ['x', 'y', 'z'];
      for(var i = 0; i < 3; ++i) {
          var projection = 'projection.' + dims[i];
          if(coerce(projection + '.show')) {
              coerce(projection + '.opacity');
              coerce(projection + '.scale');
          }
      }
  
      var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'z'});
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'y', inherit: 'z'});
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'x', inherit: 'z'});
  };
  
  function handleXYZDefaults(traceIn, traceOut, coerce, layout) {
      var len = 0;
      var x = coerce('x');
      var y = coerce('y');
      var z = coerce('z');
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
  
      if(x && y && z) {
          // TODO: what happens if one is missing?
          len = Math.min(x.length, y.length, z.length);
          traceOut._length = traceOut._xlength = traceOut._ylength = traceOut._zlength = len;
      }
  
      return len;
  }
  
  },{"../../lib":750,"../../registry":882,"../scatter/line_defaults":1171,"../scatter/marker_defaults":1177,"../scatter/subtypes":1183,"../scatter/text_defaults":1184,"./attributes":1186}],1191:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      plot: _dereq_('./convert'),
      attributes: _dereq_('./attributes'),
      markerSymbols: _dereq_('../../constants/gl3d_markers'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: [
          {
              container: 'marker',
              min: 'cmin',
              max: 'cmax'
          }, {
              container: 'line',
              min: 'cmin',
              max: 'cmax'
          }
      ],
      calc: _dereq_('./calc'),
  
      moduleType: 'trace',
      name: 'scatter3d',
      basePlotModule: _dereq_('../../plots/gl3d'),
      categories: ['gl3d', 'symbols', 'showLegend', 'scatter-like'],
      meta: {
          
          
      }
  };
  
  },{"../../constants/gl3d_markers":723,"../../plots/gl3d":841,"./attributes":1186,"./calc":1187,"./convert":1189,"./defaults":1190}],1192:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterAttrs = _dereq_('../scatter/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var scatterMarkerAttrs = scatterAttrs.marker;
  var scatterLineAttrs = scatterAttrs.line;
  var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
  
  module.exports = {
      carpet: {
          valType: 'string',
          
          editType: 'calc',
          
      },
      a: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      b: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      mode: extendFlat({}, scatterAttrs.mode, {dflt: 'markers'}),
      text: extendFlat({}, scatterAttrs.text, {
          
      }),
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: ['a', 'b', 'text']
      }),
      hovertext: extendFlat({}, scatterAttrs.hovertext, {
          
      }),
      line: {
          color: scatterLineAttrs.color,
          width: scatterLineAttrs.width,
          dash: scatterLineAttrs.dash,
          shape: extendFlat({}, scatterLineAttrs.shape,
              {values: ['linear', 'spline']}),
          smoothing: scatterLineAttrs.smoothing,
          editType: 'calc'
      },
      connectgaps: scatterAttrs.connectgaps,
      fill: extendFlat({}, scatterAttrs.fill, {
          values: ['none', 'toself', 'tonext'],
          dflt: 'none',
          
      }),
      fillcolor: scatterAttrs.fillcolor,
      marker: extendFlat({
          symbol: scatterMarkerAttrs.symbol,
          opacity: scatterMarkerAttrs.opacity,
          maxdisplayed: scatterMarkerAttrs.maxdisplayed,
          size: scatterMarkerAttrs.size,
          sizeref: scatterMarkerAttrs.sizeref,
          sizemin: scatterMarkerAttrs.sizemin,
          sizemode: scatterMarkerAttrs.sizemode,
          line: extendFlat({
              width: scatterMarkerLineAttrs.width,
              editType: 'calc'
          },
              colorScaleAttrs('marker.line')
          ),
          gradient: scatterMarkerAttrs.gradient,
          editType: 'calc'
      },
          colorScaleAttrs('marker')
      ),
  
      textfont: scatterAttrs.textfont,
      textposition: scatterAttrs.textposition,
  
      selected: scatterAttrs.selected,
      unselected: scatterAttrs.unselected,
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['a', 'b', 'text', 'name']
      }),
      hoveron: scatterAttrs.hoveron,
      hovertemplate: hovertemplateAttrs()
  };
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../scatter/attributes":1158}],1193:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var calcColorscale = _dereq_('../scatter/colorscale_calc');
  var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
  var calcSelection = _dereq_('../scatter/calc_selection');
  var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
  var lookupCarpet = _dereq_('../carpet/lookup_carpetid');
  
  module.exports = function calc(gd, trace) {
      var carpet = trace._carpetTrace = lookupCarpet(gd, trace);
      if(!carpet || !carpet.visible || carpet.visible === 'legendonly') return;
      var i;
  
      // Transfer this over from carpet before plotting since this is a necessary
      // condition in order for cartesian to actually plot this trace:
      trace.xaxis = carpet.xaxis;
      trace.yaxis = carpet.yaxis;
  
      // make the calcdata array
      var serieslen = trace._length;
      var cd = new Array(serieslen);
      var a, b;
      var needsCull = false;
      for(i = 0; i < serieslen; i++) {
          a = trace.a[i];
          b = trace.b[i];
          if(isNumeric(a) && isNumeric(b)) {
              var xy = carpet.ab2xy(+a, +b, true);
              var visible = carpet.isVisible(+a, +b);
              if(!visible) needsCull = true;
              cd[i] = {x: xy[0], y: xy[1], a: a, b: b, vis: visible};
          } else cd[i] = {x: false, y: false};
      }
  
      trace._needsCull = needsCull;
  
      cd[0].carpet = carpet;
      cd[0].trace = trace;
  
      calcMarkerSize(trace, serieslen);
      calcColorscale(gd, trace);
      arraysToCalcdata(cd, trace);
      calcSelection(cd, trace);
  
      return cd;
  };
  
  },{"../carpet/lookup_carpetid":952,"../scatter/arrays_to_calcdata":1157,"../scatter/calc":1159,"../scatter/calc_selection":1160,"../scatter/colorscale_calc":1161,"fast-isnumeric":241}],1194:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var constants = _dereq_('../scatter/constants');
  var subTypes = _dereq_('../scatter/subtypes');
  var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
  var handleLineDefaults = _dereq_('../scatter/line_defaults');
  var handleLineShapeDefaults = _dereq_('../scatter/line_shape_defaults');
  var handleTextDefaults = _dereq_('../scatter/text_defaults');
  var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
  
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      coerce('carpet');
  
      // XXX: Don't hard code this
      traceOut.xaxis = 'x';
      traceOut.yaxis = 'y';
  
      var a = coerce('a');
      var b = coerce('b');
      var len = Math.min(a.length, b.length);
  
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      traceOut._length = len;
  
      coerce('text');
      coerce('texttemplate');
      coerce('hovertext');
  
      var defaultMode = len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
      coerce('mode', defaultMode);
  
      if(subTypes.hasLines(traceOut)) {
          handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
          handleLineShapeDefaults(traceIn, traceOut, coerce);
          coerce('connectgaps');
      }
  
      if(subTypes.hasMarkers(traceOut)) {
          handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
      }
  
      if(subTypes.hasText(traceOut)) {
          handleTextDefaults(traceIn, traceOut, layout, coerce);
      }
  
      var dfltHoverOn = [];
  
      if(subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
          coerce('marker.maxdisplayed');
          dfltHoverOn.push('points');
      }
  
      coerce('fill');
      if(traceOut.fill !== 'none') {
          handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
          if(!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
      }
  
      if(traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
          dfltHoverOn.push('fills');
      }
  
      var hoverOn = coerce('hoveron', dfltHoverOn.join('+') || 'points');
      if(hoverOn !== 'fills') coerce('hovertemplate');
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  },{"../../lib":750,"../scatter/constants":1162,"../scatter/fillcolor_defaults":1166,"../scatter/line_defaults":1171,"../scatter/line_shape_defaults":1173,"../scatter/marker_defaults":1177,"../scatter/subtypes":1183,"../scatter/text_defaults":1184,"./attributes":1192}],1195:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt, trace, cd, pointNumber) {
      var cdi = cd[pointNumber];
  
      out.a = cdi.a;
      out.b = cdi.b;
      out.y = cdi.y;
  
      return out;
  };
  
  },{}],1196:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function formatLabels(cdi, trace) {
      var labels = {};
  
      var carpet = trace._carpet;
      var ij = carpet.ab2ij([cdi.a, cdi.b]);
      var i0 = Math.floor(ij[0]);
      var ti = ij[0] - i0;
      var j0 = Math.floor(ij[1]);
      var tj = ij[1] - j0;
      var xy = carpet.evalxy([], i0, j0, ti, tj);
  
      labels.yLabel = xy[1].toFixed(3);
  
      return labels;
  };
  
  },{}],1197:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterHover = _dereq_('../scatter/hover');
  var fillText = _dereq_('../../lib').fillText;
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
      var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
      if(!scatterPointData || scatterPointData[0].index === false) return;
  
      var newPointData = scatterPointData[0];
  
      // if hovering on a fill, we don't show any point data so the label is
      // unchanged from what scatter gives us - except that it needs to
      // be constrained to the trianglular plot area, not just the rectangular
      // area defined by the synthetic x and y axes
      // TODO: in some cases the vertical middle of the shape is not within
      // the triangular viewport at all, so the label can become disconnected
      // from the shape entirely. But calculating what portion of the shape
      // is actually visible, as constrained by the diagonal axis lines, is not
      // so easy and anyway we lost the information we would have needed to do
      // this inside scatterHover.
      if(newPointData.index === undefined) {
          var yFracUp = 1 - (newPointData.y0 / pointData.ya._length);
          var xLen = pointData.xa._length;
          var xMin = xLen * yFracUp / 2;
          var xMax = xLen - xMin;
          newPointData.x0 = Math.max(Math.min(newPointData.x0, xMax), xMin);
          newPointData.x1 = Math.max(Math.min(newPointData.x1, xMax), xMin);
          return scatterPointData;
      }
  
      var cdi = newPointData.cd[newPointData.index];
  
      newPointData.a = cdi.a;
      newPointData.b = cdi.b;
  
      newPointData.xLabelVal = undefined;
      newPointData.yLabelVal = undefined;
      // TODO: nice formatting, and label by axis title, for a, b, and c?
  
      var trace = newPointData.trace;
      var carpet = trace._carpet;
  
      var labels = trace._module.formatLabels(cdi, trace);
      newPointData.yLabel = labels.yLabel;
  
      delete newPointData.text;
      var text = [];
  
      function textPart(ax, val) {
          var prefix;
  
          if(ax.labelprefix && ax.labelprefix.length > 0) {
              prefix = ax.labelprefix.replace(/ = $/, '');
          } else {
              prefix = ax._hovertitle;
          }
  
          text.push(prefix + ': ' + val.toFixed(3) + ax.labelsuffix);
      }
  
  
      if(!trace.hovertemplate) {
          var hoverinfo = cdi.hi || trace.hoverinfo;
          var parts = hoverinfo.split('+');
  
          if(parts.indexOf('all') !== -1) parts = ['a', 'b', 'text'];
          if(parts.indexOf('a') !== -1) textPart(carpet.aaxis, cdi.a);
          if(parts.indexOf('b') !== -1) textPart(carpet.baxis, cdi.b);
  
          text.push('y: ' + newPointData.yLabel);
  
          if(parts.indexOf('text') !== -1) {
              fillText(cdi, trace, text);
          }
  
          newPointData.extraText = text.join('<br>');
      }
  
      return scatterPointData;
  };
  
  },{"../../lib":750,"../scatter/hover":1169}],1198:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../scatter/marker_colorbar'),
      formatLabels: _dereq_('./format_labels'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      style: _dereq_('../scatter/style').style,
      styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
      hoverPoints: _dereq_('./hover'),
      selectPoints: _dereq_('../scatter/select'),
      eventData: _dereq_('./event_data'),
  
      moduleType: 'trace',
      name: 'scattercarpet',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['svg', 'carpet', 'symbols', 'showLegend', 'carpetDependent', 'zoomScale'],
      meta: {
          
          
      }
  };
  
  },{"../../plots/cartesian":812,"../scatter/marker_colorbar":1176,"../scatter/select":1180,"../scatter/style":1182,"./attributes":1192,"./calc":1193,"./defaults":1194,"./event_data":1195,"./format_labels":1196,"./hover":1197,"./plot":1199}],1199:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var scatterPlot = _dereq_('../scatter/plot');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var Drawing = _dereq_('../../components/drawing');
  
  module.exports = function plot(gd, plotinfoproxy, data, layer) {
      var i, trace, node;
  
      var carpet = data[0][0].carpet;
      // mimic cartesian plotinfo
      var plotinfo = {
          xaxis: Axes.getFromId(gd, carpet.xaxis || 'x'),
          yaxis: Axes.getFromId(gd, carpet.yaxis || 'y'),
          plot: plotinfoproxy.plot,
      };
  
      scatterPlot(gd, plotinfo, data, layer);
  
      for(i = 0; i < data.length; i++) {
          trace = data[i][0].trace;
  
          // Note: .select is adequate but seems to mutate the node data,
          // which is at least a bit suprising and causes problems elsewhere
          node = layer.selectAll('g.trace' + trace.uid + ' .js-line');
  
          // Note: it would be more efficient if this didn't need to be applied
          // separately to all scattercarpet traces, but that would require
          // lots of reorganization of scatter traces that is otherwise not
          // necessary. That makes this a potential optimization.
          Drawing.setClipUrl(node, data[i][0].carpet._clipPathId, gd);
      }
  };
  
  },{"../../components/drawing":637,"../../plots/cartesian/axes":799,"../scatter/plot":1179}],1200:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var scatterAttrs = _dereq_('../scatter/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var colorAttributes = _dereq_('../../components/colorscale/attributes');
  var dash = _dereq_('../../components/drawing/attributes').dash;
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var scatterMarkerAttrs = scatterAttrs.marker;
  var scatterLineAttrs = scatterAttrs.line;
  var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
  
  module.exports = overrideAll({
      lon: {
          valType: 'data_array',
          
      },
      lat: {
          valType: 'data_array',
          
      },
  
      locations: {
          valType: 'data_array',
          
      },
      locationmode: {
          valType: 'enumerated',
          values: ['ISO-3', 'USA-states', 'country names', 'geojson-id'],
          
          dflt: 'ISO-3',
          
      },
  
      geojson: {
          valType: 'any',
          
          editType: 'calc',
          
      },
      featureidkey: {
          valType: 'string',
          
          editType: 'calc',
          dflt: 'id',
          
      },
  
      mode: extendFlat({}, scatterAttrs.mode, {dflt: 'markers'}),
  
      text: extendFlat({}, scatterAttrs.text, {
          
      }),
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: ['lat', 'lon', 'location', 'text']
      }),
      hovertext: extendFlat({}, scatterAttrs.hovertext, {
          
      }),
  
      textfont: scatterAttrs.textfont,
      textposition: scatterAttrs.textposition,
  
      line: {
          color: scatterLineAttrs.color,
          width: scatterLineAttrs.width,
          dash: dash
      },
      connectgaps: scatterAttrs.connectgaps,
  
      marker: extendFlat({
          symbol: scatterMarkerAttrs.symbol,
          opacity: scatterMarkerAttrs.opacity,
          size: scatterMarkerAttrs.size,
          sizeref: scatterMarkerAttrs.sizeref,
          sizemin: scatterMarkerAttrs.sizemin,
          sizemode: scatterMarkerAttrs.sizemode,
          colorbar: scatterMarkerAttrs.colorbar,
          line: extendFlat({
              width: scatterMarkerLineAttrs.width
          },
              colorAttributes('marker.line')
          ),
          gradient: scatterMarkerAttrs.gradient
      },
          colorAttributes('marker')
      ),
  
      fill: {
          valType: 'enumerated',
          values: ['none', 'toself'],
          dflt: 'none',
          
          
      },
      fillcolor: scatterAttrs.fillcolor,
  
      selected: scatterAttrs.selected,
      unselected: scatterAttrs.unselected,
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['lon', 'lat', 'location', 'text', 'name']
      }),
      hovertemplate: hovertemplateAttrs(),
  }, 'calc', 'nested');
  
  },{"../../components/colorscale/attributes":622,"../../components/drawing/attributes":636,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plots/attributes":795,"../../plots/template_attributes":877,"../scatter/attributes":1158}],1201:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  var calcMarkerColorscale = _dereq_('../scatter/colorscale_calc');
  var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
  var calcSelection = _dereq_('../scatter/calc_selection');
  
  var _ = _dereq_('../../lib')._;
  
  function isNonBlankString(v) {
      return v && typeof v === 'string';
  }
  
  module.exports = function calc(gd, trace) {
      var hasLocationData = Array.isArray(trace.locations);
      var len = hasLocationData ? trace.locations.length : trace._length;
      var calcTrace = new Array(len);
  
      var isValidLoc;
      if(trace.geojson) {
          isValidLoc = function(v) { return isNonBlankString(v) || isNumeric(v); };
      } else {
          isValidLoc = isNonBlankString;
      }
  
      for(var i = 0; i < len; i++) {
          var calcPt = calcTrace[i] = {};
  
          if(hasLocationData) {
              var loc = trace.locations[i];
              calcPt.loc = isValidLoc(loc) ? loc : null;
          } else {
              var lon = trace.lon[i];
              var lat = trace.lat[i];
  
              if(isNumeric(lon) && isNumeric(lat)) calcPt.lonlat = [+lon, +lat];
              else calcPt.lonlat = [BADNUM, BADNUM];
          }
      }
  
      arraysToCalcdata(calcTrace, trace);
      calcMarkerColorscale(gd, trace);
      calcSelection(calcTrace, trace);
  
      if(len) {
          calcTrace[0].t = {
              labels: {
                  lat: _(gd, 'lat:') + ' ',
                  lon: _(gd, 'lon:') + ' '
              }
          };
      }
  
      return calcTrace;
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"../scatter/arrays_to_calcdata":1157,"../scatter/calc_selection":1160,"../scatter/colorscale_calc":1161,"fast-isnumeric":241}],1202:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var subTypes = _dereq_('../scatter/subtypes');
  var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
  var handleLineDefaults = _dereq_('../scatter/line_defaults');
  var handleTextDefaults = _dereq_('../scatter/text_defaults');
  var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
  
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var locations = coerce('locations');
      var len;
  
      if(locations && locations.length) {
          var geojson = coerce('geojson');
          var locationmodeDflt;
          if((typeof geojson === 'string' && geojson !== '') || Lib.isPlainObject(geojson)) {
              locationmodeDflt = 'geojson-id';
          }
  
          var locationMode = coerce('locationmode', locationmodeDflt);
  
          if(locationMode === 'geojson-id') {
              coerce('featureidkey');
          }
  
          len = locations.length;
      } else {
          var lon = coerce('lon') || [];
          var lat = coerce('lat') || [];
          len = Math.min(lon.length, lat.length);
      }
  
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      traceOut._length = len;
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
      coerce('mode');
  
      if(subTypes.hasLines(traceOut)) {
          handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
          coerce('connectgaps');
      }
  
      if(subTypes.hasMarkers(traceOut)) {
          handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
      }
  
      if(subTypes.hasText(traceOut)) {
          coerce('texttemplate');
          handleTextDefaults(traceIn, traceOut, layout, coerce);
      }
  
      coerce('fill');
      if(traceOut.fill !== 'none') {
          handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
      }
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  },{"../../lib":750,"../scatter/fillcolor_defaults":1166,"../scatter/line_defaults":1171,"../scatter/marker_defaults":1177,"../scatter/subtypes":1183,"../scatter/text_defaults":1184,"./attributes":1200}],1203:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  module.exports = function eventData(out, pt, trace, cd, pointNumber) {
      out.lon = pt.lon;
      out.lat = pt.lat;
      out.location = pt.loc ? pt.loc : null;
  
      // include feature properties from input geojson
      var cdi = cd[pointNumber];
      if(cdi.fIn && cdi.fIn.properties) {
          out.properties = cdi.fIn.properties;
      }
  
      return out;
  };
  
  },{}],1204:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  module.exports = function formatLabels(cdi, trace, fullLayout) {
      var labels = {};
  
      var geo = fullLayout[trace.geo]._subplot;
      var ax = geo.mockAxis;
      var lonlat = cdi.lonlat;
      labels.lonLabel = Axes.tickText(ax, ax.c2l(lonlat[0]), true).text;
      labels.latLabel = Axes.tickText(ax, ax.c2l(lonlat[1]), true).text;
  
      return labels;
  };
  
  },{"../../plots/cartesian/axes":799}],1205:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Fx = _dereq_('../../components/fx');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  var getTraceColor = _dereq_('../scatter/get_trace_color');
  var fillText = _dereq_('../../lib').fillText;
  var attributes = _dereq_('./attributes');
  
  module.exports = function hoverPoints(pointData, xval, yval) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
      var xa = pointData.xa;
      var ya = pointData.ya;
      var geo = pointData.subplot;
  
      var isLonLatOverEdges = geo.projection.isLonLatOverEdges;
      var project = geo.project;
  
      function distFn(d) {
          var lonlat = d.lonlat;
  
          if(lonlat[0] === BADNUM) return Infinity;
          if(isLonLatOverEdges(lonlat)) return Infinity;
  
          var pt = project(lonlat);
          var px = project([xval, yval]);
          var dx = Math.abs(pt[0] - px[0]);
          var dy = Math.abs(pt[1] - px[1]);
          var rad = Math.max(3, d.mrc || 0);
  
          // N.B. d.mrc is the calculated marker radius
          // which is only set for trace with 'markers' mode.
  
          return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - 3 / rad);
      }
  
      Fx.getClosest(cd, distFn, pointData);
  
      // skip the rest (for this trace) if we didn't find a close point
      if(pointData.index === false) return;
  
      var di = cd[pointData.index];
      var lonlat = di.lonlat;
      var pos = [xa.c2p(lonlat), ya.c2p(lonlat)];
      var rad = di.mrc || 1;
  
      pointData.x0 = pos[0] - rad;
      pointData.x1 = pos[0] + rad;
      pointData.y0 = pos[1] - rad;
      pointData.y1 = pos[1] + rad;
  
      pointData.loc = di.loc;
      pointData.lon = lonlat[0];
      pointData.lat = lonlat[1];
  
      var fullLayout = {};
      fullLayout[trace.geo] = {_subplot: geo};
      var labels = trace._module.formatLabels(di, trace, fullLayout);
      pointData.lonLabel = labels.lonLabel;
      pointData.latLabel = labels.latLabel;
  
      pointData.color = getTraceColor(trace, di);
      pointData.extraText = getExtraText(trace, di, pointData, cd[0].t.labels);
      pointData.hovertemplate = trace.hovertemplate;
  
      return [pointData];
  };
  
  function getExtraText(trace, pt, pointData, labels) {
      if(trace.hovertemplate) return;
  
      var hoverinfo = pt.hi || trace.hoverinfo;
  
      var parts = hoverinfo === 'all' ?
          attributes.hoverinfo.flags :
          hoverinfo.split('+');
  
      var hasLocation = parts.indexOf('location') !== -1 && Array.isArray(trace.locations);
      var hasLon = (parts.indexOf('lon') !== -1);
      var hasLat = (parts.indexOf('lat') !== -1);
      var hasText = (parts.indexOf('text') !== -1);
      var text = [];
  
      function format(val) { return val + '\u00B0'; }
  
      if(hasLocation) {
          text.push(pt.loc);
      } else if(hasLon && hasLat) {
          text.push('(' + format(pointData.lonLabel) + ', ' + format(pointData.latLabel) + ')');
      } else if(hasLon) {
          text.push(labels.lon + format(pointData.lonLabel));
      } else if(hasLat) {
          text.push(labels.lat + format(pointData.latLabel));
      }
  
      if(hasText) {
          fillText(pt, trace, text);
      }
  
      return text.join('<br>');
  }
  
  },{"../../components/fx":655,"../../constants/numerical":725,"../../lib":750,"../scatter/get_trace_color":1168,"./attributes":1200}],1206:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../scatter/marker_colorbar'),
      formatLabels: _dereq_('./format_labels'),
      calc: _dereq_('./calc'),
      calcGeoJSON: _dereq_('./plot').calcGeoJSON,
      plot: _dereq_('./plot').plot,
      style: _dereq_('./style'),
      styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
      hoverPoints: _dereq_('./hover'),
      eventData: _dereq_('./event_data'),
      selectPoints: _dereq_('./select'),
  
      moduleType: 'trace',
      name: 'scattergeo',
      basePlotModule: _dereq_('../../plots/geo'),
      categories: ['geo', 'symbols', 'showLegend', 'scatter-like'],
      meta: {
          
          
      }
  };
  
  },{"../../plots/geo":831,"../scatter/marker_colorbar":1176,"../scatter/style":1182,"./attributes":1200,"./calc":1201,"./defaults":1202,"./event_data":1203,"./format_labels":1204,"./hover":1205,"./plot":1207,"./select":1208,"./style":1209}],1207:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Lib = _dereq_('../../lib');
  var getTopojsonFeatures = _dereq_('../../lib/topojson_utils').getTopojsonFeatures;
  var geoJsonUtils = _dereq_('../../lib/geojson_utils');
  var geoUtils = _dereq_('../../lib/geo_location_utils');
  var findExtremes = _dereq_('../../plots/cartesian/autorange').findExtremes;
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
  var subTypes = _dereq_('../scatter/subtypes');
  var style = _dereq_('./style');
  
  function plot(gd, geo, calcData) {
      var scatterLayer = geo.layers.frontplot.select('.scatterlayer');
      var gTraces = Lib.makeTraceGroups(scatterLayer, calcData, 'trace scattergeo');
  
      function removeBADNUM(d, node) {
          if(d.lonlat[0] === BADNUM) {
              d3.select(node).remove();
          }
      }
  
      // TODO find a way to order the inner nodes on update
      gTraces.selectAll('*').remove();
  
      gTraces.each(function(calcTrace) {
          var s = d3.select(this);
          var trace = calcTrace[0].trace;
  
          if(subTypes.hasLines(trace) || trace.fill !== 'none') {
              var lineCoords = geoJsonUtils.calcTraceToLineCoords(calcTrace);
  
              var lineData = (trace.fill !== 'none') ?
                  geoJsonUtils.makePolygon(lineCoords) :
                  geoJsonUtils.makeLine(lineCoords);
  
              s.selectAll('path.js-line')
                  .data([{geojson: lineData, trace: trace}])
                .enter().append('path')
                  .classed('js-line', true)
                  .style('stroke-miterlimit', 2);
          }
  
          if(subTypes.hasMarkers(trace)) {
              s.selectAll('path.point')
                  .data(Lib.identity)
               .enter().append('path')
                  .classed('point', true)
                  .each(function(calcPt) { removeBADNUM(calcPt, this); });
          }
  
          if(subTypes.hasText(trace)) {
              s.selectAll('g')
                  .data(Lib.identity)
                .enter().append('g')
                  .append('text')
                  .each(function(calcPt) { removeBADNUM(calcPt, this); });
          }
  
          // call style here within topojson request callback
          style(gd, calcTrace);
      });
  }
  
  function calcGeoJSON(calcTrace, fullLayout) {
      var trace = calcTrace[0].trace;
      var geoLayout = fullLayout[trace.geo];
      var geo = geoLayout._subplot;
      var len = trace._length;
      var i, calcPt;
  
      if(Array.isArray(trace.locations)) {
          var locationmode = trace.locationmode;
          var features = locationmode === 'geojson-id' ?
              geoUtils.extractTraceFeature(calcTrace) :
              getTopojsonFeatures(trace, geo.topojson);
  
          for(i = 0; i < len; i++) {
              calcPt = calcTrace[i];
  
              var feature = locationmode === 'geojson-id' ?
                  calcPt.fOut :
                  geoUtils.locationToFeature(locationmode, calcPt.loc, features);
  
              calcPt.lonlat = feature ? feature.properties.ct : [BADNUM, BADNUM];
          }
      }
  
      var opts = {padded: true};
      var lonArray;
      var latArray;
  
      if(geoLayout.fitbounds === 'geojson' && trace.locationmode === 'geojson-id') {
          var bboxGeojson = geoUtils.computeBbox(geoUtils.getTraceGeojson(trace));
          lonArray = [bboxGeojson[0], bboxGeojson[2]];
          latArray = [bboxGeojson[1], bboxGeojson[3]];
      } else {
          lonArray = new Array(len);
          latArray = new Array(len);
          for(i = 0; i < len; i++) {
              calcPt = calcTrace[i];
              lonArray[i] = calcPt.lonlat[0];
              latArray[i] = calcPt.lonlat[1];
          }
  
          opts.ppad = calcMarkerSize(trace, len);
      }
  
      trace._extremes.lon = findExtremes(geoLayout.lonaxis._ax, lonArray, opts);
      trace._extremes.lat = findExtremes(geoLayout.lataxis._ax, latArray, opts);
  }
  
  module.exports = {
      calcGeoJSON: calcGeoJSON,
      plot: plot
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"../../lib/geo_location_utils":743,"../../lib/geojson_utils":744,"../../lib/topojson_utils":777,"../../plots/cartesian/autorange":798,"../scatter/calc":1159,"../scatter/subtypes":1183,"./style":1209,"d3":169}],1208:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var subtypes = _dereq_('../scatter/subtypes');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  module.exports = function selectPoints(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var xa = searchInfo.xaxis;
      var ya = searchInfo.yaxis;
      var selection = [];
      var trace = cd[0].trace;
  
      var di, lonlat, x, y, i;
  
      var hasOnlyLines = (!subtypes.hasMarkers(trace) && !subtypes.hasText(trace));
      if(hasOnlyLines) return [];
  
      if(selectionTester === false) {
          for(i = 0; i < cd.length; i++) {
              cd[i].selected = 0;
          }
      } else {
          for(i = 0; i < cd.length; i++) {
              di = cd[i];
              lonlat = di.lonlat;
  
              // some projection types can't handle BADNUMs
              if(lonlat[0] === BADNUM) continue;
  
              x = xa.c2p(lonlat);
              y = ya.c2p(lonlat);
  
              if(selectionTester.contains([x, y], null, i, searchInfo)) {
                  selection.push({
                      pointNumber: i,
                      lon: lonlat[0],
                      lat: lonlat[1]
                  });
                  di.selected = 1;
              } else {
                  di.selected = 0;
              }
          }
      }
  
      return selection;
  };
  
  },{"../../constants/numerical":725,"../scatter/subtypes":1183}],1209:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Drawing = _dereq_('../../components/drawing');
  var Color = _dereq_('../../components/color');
  
  var scatterStyle = _dereq_('../scatter/style');
  var stylePoints = scatterStyle.stylePoints;
  var styleText = scatterStyle.styleText;
  
  module.exports = function style(gd, calcTrace) {
      if(calcTrace) styleTrace(gd, calcTrace);
  };
  
  function styleTrace(gd, calcTrace) {
      var trace = calcTrace[0].trace;
      var s = calcTrace[0].node3;
  
      s.style('opacity', calcTrace[0].trace.opacity);
  
      stylePoints(s, trace, gd);
      styleText(s, trace, gd);
  
      // this part is incompatible with Drawing.lineGroupStyle
      s.selectAll('path.js-line')
          .style('fill', 'none')
          .each(function(d) {
              var path = d3.select(this);
              var trace = d.trace;
              var line = trace.line || {};
  
              path.call(Color.stroke, line.color)
                  .call(Drawing.dashLine, line.dash || '', line.width || 0);
  
              if(trace.fill !== 'none') {
                  path.call(Color.fill, trace.fillcolor);
              }
          });
  }
  
  },{"../../components/color":615,"../../components/drawing":637,"../scatter/style":1182,"d3":169}],1210:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var baseAttrs = _dereq_('../../plots/attributes');
  var scatterAttrs = _dereq_('../scatter/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var DASHES = _dereq_('./constants').DASHES;
  
  var scatterLineAttrs = scatterAttrs.line;
  var scatterMarkerAttrs = scatterAttrs.marker;
  var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
  
  var attrs = module.exports = overrideAll({
      x: scatterAttrs.x,
      x0: scatterAttrs.x0,
      dx: scatterAttrs.dx,
      y: scatterAttrs.y,
      y0: scatterAttrs.y0,
      dy: scatterAttrs.dy,
  
      xperiod: scatterAttrs.xperiod,
      yperiod: scatterAttrs.yperiod,
      xperiod0: scatterAttrs.xperiod0,
      yperiod0: scatterAttrs.yperiod0,
      xperiodalignment: scatterAttrs.xperiodalignment,
      yperiodalignment: scatterAttrs.yperiodalignment,
  
      text: scatterAttrs.text,
      hovertext: scatterAttrs.hovertext,
  
      textposition: scatterAttrs.textposition,
      textfont: scatterAttrs.textfont,
  
      mode: {
          valType: 'flaglist',
          flags: ['lines', 'markers', 'text'],
          extras: ['none'],
          
          
      },
      line: {
          color: scatterLineAttrs.color,
          width: scatterLineAttrs.width,
          shape: {
              valType: 'enumerated',
              values: ['linear', 'hv', 'vh', 'hvh', 'vhv'],
              dflt: 'linear',
              
              editType: 'plot',
              
          },
          dash: {
              valType: 'enumerated',
              values: Object.keys(DASHES),
              dflt: 'solid',
              
              
          }
      },
      marker: extendFlat({}, colorScaleAttrs('marker'), {
          symbol: scatterMarkerAttrs.symbol,
          size: scatterMarkerAttrs.size,
          sizeref: scatterMarkerAttrs.sizeref,
          sizemin: scatterMarkerAttrs.sizemin,
          sizemode: scatterMarkerAttrs.sizemode,
          opacity: scatterMarkerAttrs.opacity,
          colorbar: scatterMarkerAttrs.colorbar,
          line: extendFlat({}, colorScaleAttrs('marker.line'), {
              width: scatterMarkerLineAttrs.width
          })
      }),
      connectgaps: scatterAttrs.connectgaps,
      fill: extendFlat({}, scatterAttrs.fill, {dflt: 'none'}),
      fillcolor: scatterAttrs.fillcolor,
  
      // no hoveron
  
      selected: {
          marker: scatterAttrs.selected.marker,
          textfont: scatterAttrs.selected.textfont
      },
      unselected: {
          marker: scatterAttrs.unselected.marker,
          textfont: scatterAttrs.unselected.textfont
      },
  
      opacity: baseAttrs.opacity
  
  }, 'calc', 'nested');
  
  attrs.x.editType = attrs.y.editType = attrs.x0.editType = attrs.y0.editType = 'calc+clearAxisTypes';
  attrs.hovertemplate = scatterAttrs.hovertemplate;
  attrs.texttemplate = scatterAttrs.texttemplate;
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plots/attributes":795,"../scatter/attributes":1158,"./constants":1212}],1211:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var cluster = _dereq_('@plotly/point-cluster');
  
  var Lib = _dereq_('../../lib');
  var AxisIDs = _dereq_('../../plots/cartesian/axis_ids');
  var findExtremes = _dereq_('../../plots/cartesian/autorange').findExtremes;
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  
  var scatterCalc = _dereq_('../scatter/calc');
  var calcMarkerSize = scatterCalc.calcMarkerSize;
  var calcAxisExpansion = scatterCalc.calcAxisExpansion;
  var setFirstScatter = scatterCalc.setFirstScatter;
  var calcColorscale = _dereq_('../scatter/colorscale_calc');
  var convert = _dereq_('./convert');
  var sceneUpdate = _dereq_('./scene_update');
  
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  var TOO_MANY_POINTS = _dereq_('./constants').TOO_MANY_POINTS;
  
  module.exports = function calc(gd, trace) {
      var fullLayout = gd._fullLayout;
      var xa = AxisIDs.getFromId(gd, trace.xaxis);
      var ya = AxisIDs.getFromId(gd, trace.yaxis);
      var subplot = fullLayout._plots[trace.xaxis + trace.yaxis];
      var len = trace._length;
      var hasTooManyPoints = len >= TOO_MANY_POINTS;
      var len2 = len * 2;
      var stash = {};
      var i, xx, yy;
  
      var origX = xa.makeCalcdata(trace, 'x');
      var origY = ya.makeCalcdata(trace, 'y');
      var x = alignPeriod(trace, xa, 'x', origX);
      var y = alignPeriod(trace, ya, 'y', origY);
      trace._x = x;
      trace._y = y;
  
      if(trace.xperiodalignment) trace._origX = origX;
      if(trace.yperiodalignment) trace._origY = origY;
  
      // we need hi-precision for scatter2d,
      // regl-scatter2d uses NaNs for bad/missing values
      var positions = new Array(len2);
      for(i = 0; i < len; i++) {
          xx = x[i];
          yy = y[i];
          positions[i * 2] = xx === BADNUM ? NaN : xx;
          positions[i * 2 + 1] = yy === BADNUM ? NaN : yy;
      }
  
      if(xa.type === 'log') {
          for(i = 0; i < len2; i += 2) {
              positions[i] = xa.c2l(positions[i]);
          }
      }
      if(ya.type === 'log') {
          for(i = 1; i < len2; i += 2) {
              positions[i] = ya.c2l(positions[i]);
          }
      }
  
      // we don't build a tree for log axes since it takes long to convert log2px
      // and it is also
      if(hasTooManyPoints && (xa.type !== 'log' && ya.type !== 'log')) {
          // FIXME: delegate this to webworker
          stash.tree = cluster(positions);
      } else {
          var ids = stash.ids = new Array(len);
          for(i = 0; i < len; i++) {
              ids[i] = i;
          }
      }
  
      // create scene options and scene
      calcColorscale(gd, trace);
      var opts = sceneOptions(gd, subplot, trace, positions, x, y);
      var scene = sceneUpdate(gd, subplot);
  
      // Reuse SVG scatter axis expansion routine.
      // For graphs with very large number of points and array marker.size,
      // use average marker size instead to speed things up.
      setFirstScatter(fullLayout, trace);
      var ppad;
      if(!hasTooManyPoints) {
          ppad = calcMarkerSize(trace, len);
      } else if(opts.marker) {
          ppad = 2 * (opts.marker.sizeAvg || Math.max(opts.marker.size, 3));
      }
      calcAxisExpansion(gd, trace, xa, ya, x, y, ppad);
      if(opts.errorX) expandForErrorBars(trace, xa, opts.errorX);
      if(opts.errorY) expandForErrorBars(trace, ya, opts.errorY);
  
      // set flags to create scene renderers
      if(opts.fill && !scene.fill2d) scene.fill2d = true;
      if(opts.marker && !scene.scatter2d) scene.scatter2d = true;
      if(opts.line && !scene.line2d) scene.line2d = true;
      if((opts.errorX || opts.errorY) && !scene.error2d) scene.error2d = true;
      if(opts.text && !scene.glText) scene.glText = true;
      if(opts.marker) opts.marker.snap = len;
  
      scene.lineOptions.push(opts.line);
      scene.errorXOptions.push(opts.errorX);
      scene.errorYOptions.push(opts.errorY);
      scene.fillOptions.push(opts.fill);
      scene.markerOptions.push(opts.marker);
      scene.markerSelectedOptions.push(opts.markerSel);
      scene.markerUnselectedOptions.push(opts.markerUnsel);
      scene.textOptions.push(opts.text);
      scene.textSelectedOptions.push(opts.textSel);
      scene.textUnselectedOptions.push(opts.textUnsel);
      scene.selectBatch.push([]);
      scene.unselectBatch.push([]);
  
      stash._scene = scene;
      stash.index = scene.count;
      stash.x = x;
      stash.y = y;
      stash.positions = positions;
      scene.count++;
  
      return [{x: false, y: false, t: stash, trace: trace}];
  };
  
  function expandForErrorBars(trace, ax, opts) {
      var extremes = trace._extremes[ax._id];
      var errExt = findExtremes(ax, opts._bnds, {padded: true});
      extremes.min = extremes.min.concat(errExt.min);
      extremes.max = extremes.max.concat(errExt.max);
  }
  
  function sceneOptions(gd, subplot, trace, positions, x, y) {
      var opts = convert.style(gd, trace);
  
      if(opts.marker) {
          opts.marker.positions = positions;
      }
  
      if(opts.line && positions.length > 1) {
          Lib.extendFlat(
              opts.line,
              convert.linePositions(gd, trace, positions)
          );
      }
  
      if(opts.errorX || opts.errorY) {
          var errors = convert.errorBarPositions(gd, trace, positions, x, y);
  
          if(opts.errorX) {
              Lib.extendFlat(opts.errorX, errors.x);
          }
          if(opts.errorY) {
              Lib.extendFlat(opts.errorY, errors.y);
          }
      }
  
      if(opts.text) {
          Lib.extendFlat(
              opts.text,
              {positions: positions},
              convert.textPosition(gd, trace, opts.text, opts.marker)
          );
          Lib.extendFlat(
              opts.textSel,
              {positions: positions},
              convert.textPosition(gd, trace, opts.text, opts.markerSel)
          );
          Lib.extendFlat(
              opts.textUnsel,
              {positions: positions},
              convert.textPosition(gd, trace, opts.text, opts.markerUnsel)
          );
      }
  
      return opts;
  }
  
  },{"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/align_period":796,"../../plots/cartesian/autorange":798,"../../plots/cartesian/axis_ids":802,"../scatter/calc":1159,"../scatter/colorscale_calc":1161,"./constants":1212,"./convert":1213,"./scene_update":1221,"@plotly/point-cluster":57}],1212:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var SYMBOL_SIZE = 20;
  
  module.exports = {
      TOO_MANY_POINTS: 1e5,
  
      SYMBOL_SDF_SIZE: 200,
      SYMBOL_SIZE: SYMBOL_SIZE,
      SYMBOL_STROKE: SYMBOL_SIZE / 20,
  
      DOT_RE: /-dot/,
      OPEN_RE: /-open/,
  
      DASHES: {
          solid: [1],
          dot: [1, 1],
          dash: [4, 1],
          longdash: [8, 1],
          dashdot: [4, 1, 1, 1],
          longdashdot: [8, 1, 1, 1]
      }
  };
  
  },{}],1213:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var svgSdf = _dereq_('svg-path-sdf');
  var rgba = _dereq_('color-normalize');
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  var AxisIDs = _dereq_('../../plots/cartesian/axis_ids');
  
  var formatColor = _dereq_('../../lib/gl_format_color').formatColor;
  var subTypes = _dereq_('../scatter/subtypes');
  var makeBubbleSizeFn = _dereq_('../scatter/make_bubble_size_func');
  
  var helpers = _dereq_('./helpers');
  var constants = _dereq_('./constants');
  var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
  
  var TEXTOFFSETSIGN = {
      start: 1, left: 1, end: -1, right: -1, middle: 0, center: 0, bottom: 1, top: -1
  };
  
  var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
  
  function convertStyle(gd, trace) {
      var i;
  
      var opts = {
          marker: undefined,
          markerSel: undefined,
          markerUnsel: undefined,
          line: undefined,
          fill: undefined,
          errorX: undefined,
          errorY: undefined,
          text: undefined,
          textSel: undefined,
          textUnsel: undefined
      };
  
      if(trace.visible !== true) return opts;
  
      if(subTypes.hasText(trace)) {
          opts.text = convertTextStyle(gd, trace);
          opts.textSel = convertTextSelection(gd, trace, trace.selected);
          opts.textUnsel = convertTextSelection(gd, trace, trace.unselected);
      }
  
      if(subTypes.hasMarkers(trace)) {
          opts.marker = convertMarkerStyle(trace);
          opts.markerSel = convertMarkerSelection(trace, trace.selected);
          opts.markerUnsel = convertMarkerSelection(trace, trace.unselected);
  
          if(!trace.unselected && Lib.isArrayOrTypedArray(trace.marker.opacity)) {
              var mo = trace.marker.opacity;
              opts.markerUnsel.opacity = new Array(mo.length);
              for(i = 0; i < mo.length; i++) {
                  opts.markerUnsel.opacity[i] = DESELECTDIM * mo[i];
              }
          }
      }
  
      if(subTypes.hasLines(trace)) {
          opts.line = {
              overlay: true,
              thickness: trace.line.width,
              color: trace.line.color,
              opacity: trace.opacity
          };
  
          var dashes = (constants.DASHES[trace.line.dash] || [1]).slice();
          for(i = 0; i < dashes.length; ++i) {
              dashes[i] *= trace.line.width;
          }
          opts.line.dashes = dashes;
      }
  
      if(trace.error_x && trace.error_x.visible) {
          opts.errorX = convertErrorBarStyle(trace, trace.error_x);
      }
  
      if(trace.error_y && trace.error_y.visible) {
          opts.errorY = convertErrorBarStyle(trace, trace.error_y);
      }
  
      if(!!trace.fill && trace.fill !== 'none') {
          opts.fill = {
              closed: true,
              fill: trace.fillcolor,
              thickness: 0
          };
      }
  
      return opts;
  }
  
  function convertTextStyle(gd, trace) {
      var fullLayout = gd._fullLayout;
      var count = trace._length;
      var textfontIn = trace.textfont;
      var textpositionIn = trace.textposition;
      var textPos = Array.isArray(textpositionIn) ? textpositionIn : [textpositionIn];
      var tfc = textfontIn.color;
      var tfs = textfontIn.size;
      var tff = textfontIn.family;
      var optsOut = {};
      var i;
  
      var texttemplate = trace.texttemplate;
      if(texttemplate) {
          optsOut.text = [];
  
          var d3locale = fullLayout._d3locale;
          var isArray = Array.isArray(texttemplate);
          var N = isArray ? Math.min(texttemplate.length, count) : count;
          var txt = isArray ?
              function(i) { return texttemplate[i]; } :
              function() { return texttemplate; };
  
          for(i = 0; i < N; i++) {
              var d = {i: i};
              var labels = trace._module.formatLabels(d, trace, fullLayout);
              var pointValues = {};
              appendArrayPointValue(pointValues, trace, i);
              var meta = trace._meta || {};
              optsOut.text.push(Lib.texttemplateString(txt(i), labels, d3locale, pointValues, d, meta));
          }
      } else {
          if(Array.isArray(trace.text) && trace.text.length < count) {
              // if text array is shorter, we'll need to append to it, so let's slice to prevent mutating
              optsOut.text = trace.text.slice();
          } else {
              optsOut.text = trace.text;
          }
      }
      // pad text array with empty strings
      if(Array.isArray(optsOut.text)) {
          for(i = optsOut.text.length; i < count; i++) {
              optsOut.text[i] = '';
          }
      }
  
      optsOut.opacity = trace.opacity;
      optsOut.font = {};
      optsOut.align = [];
      optsOut.baseline = [];
  
      for(i = 0; i < textPos.length; i++) {
          var tp = textPos[i].split(/\s+/);
  
          switch(tp[1]) {
              case 'left':
                  optsOut.align.push('right');
                  break;
              case 'right':
                  optsOut.align.push('left');
                  break;
              default:
                  optsOut.align.push(tp[1]);
          }
          switch(tp[0]) {
              case 'top':
                  optsOut.baseline.push('bottom');
                  break;
              case 'bottom':
                  optsOut.baseline.push('top');
                  break;
              default:
                  optsOut.baseline.push(tp[0]);
          }
      }
  
      if(Array.isArray(tfc)) {
          optsOut.color = new Array(count);
          for(i = 0; i < count; i++) {
              optsOut.color[i] = tfc[i];
          }
      } else {
          optsOut.color = tfc;
      }
  
      if(Lib.isArrayOrTypedArray(tfs) || Array.isArray(tff)) {
          // if any textfont param is array - make render a batch
          optsOut.font = new Array(count);
          for(i = 0; i < count; i++) {
              var fonti = optsOut.font[i] = {};
  
              fonti.size = (
                  Lib.isTypedArray(tfs) ? tfs[i] :
                  Array.isArray(tfs) ? (
                      isNumeric(tfs[i]) ? tfs[i] : 0
                  ) : tfs
              );
  
              fonti.family = Array.isArray(tff) ? tff[i] : tff;
          }
      } else {
          // if both are single values, make render fast single-value
          optsOut.font = {size: tfs, family: tff};
      }
  
      return optsOut;
  }
  
  
  function convertMarkerStyle(trace) {
      var count = trace._length;
      var optsIn = trace.marker;
      var optsOut = {};
      var i;
  
      var multiSymbol = Lib.isArrayOrTypedArray(optsIn.symbol);
      var multiColor = Lib.isArrayOrTypedArray(optsIn.color);
      var multiLineColor = Lib.isArrayOrTypedArray(optsIn.line.color);
      var multiOpacity = Lib.isArrayOrTypedArray(optsIn.opacity);
      var multiSize = Lib.isArrayOrTypedArray(optsIn.size);
      var multiLineWidth = Lib.isArrayOrTypedArray(optsIn.line.width);
  
      var isOpen;
      if(!multiSymbol) isOpen = helpers.isOpenSymbol(optsIn.symbol);
  
      // prepare colors
      if(multiSymbol || multiColor || multiLineColor || multiOpacity) {
          optsOut.colors = new Array(count);
          optsOut.borderColors = new Array(count);
  
          var colors = formatColor(optsIn, optsIn.opacity, count);
          var borderColors = formatColor(optsIn.line, optsIn.opacity, count);
  
          if(!Array.isArray(borderColors[0])) {
              var borderColor = borderColors;
              borderColors = Array(count);
              for(i = 0; i < count; i++) {
                  borderColors[i] = borderColor;
              }
          }
          if(!Array.isArray(colors[0])) {
              var color = colors;
              colors = Array(count);
              for(i = 0; i < count; i++) {
                  colors[i] = color;
              }
          }
  
          optsOut.colors = colors;
          optsOut.borderColors = borderColors;
  
          for(i = 0; i < count; i++) {
              if(multiSymbol) {
                  var symbol = optsIn.symbol[i];
                  isOpen = helpers.isOpenSymbol(symbol);
              }
              if(isOpen) {
                  borderColors[i] = colors[i].slice();
                  colors[i] = colors[i].slice();
                  colors[i][3] = 0;
              }
          }
  
          optsOut.opacity = trace.opacity;
      } else {
          if(isOpen) {
              optsOut.color = rgba(optsIn.color, 'uint8');
              optsOut.color[3] = 0;
              optsOut.borderColor = rgba(optsIn.color, 'uint8');
          } else {
              optsOut.color = rgba(optsIn.color, 'uint8');
              optsOut.borderColor = rgba(optsIn.line.color, 'uint8');
          }
  
          optsOut.opacity = trace.opacity * optsIn.opacity;
      }
  
      // prepare symbols
      if(multiSymbol) {
          optsOut.markers = new Array(count);
          for(i = 0; i < count; i++) {
              optsOut.markers[i] = getSymbolSdf(optsIn.symbol[i]);
          }
      } else {
          optsOut.marker = getSymbolSdf(optsIn.symbol);
      }
  
      // prepare sizes
      var markerSizeFunc = makeBubbleSizeFn(trace);
      var s;
  
      if(multiSize || multiLineWidth) {
          var sizes = optsOut.sizes = new Array(count);
          var borderSizes = optsOut.borderSizes = new Array(count);
          var sizeTotal = 0;
          var sizeAvg;
  
          if(multiSize) {
              for(i = 0; i < count; i++) {
                  sizes[i] = markerSizeFunc(optsIn.size[i]);
                  sizeTotal += sizes[i];
              }
              sizeAvg = sizeTotal / count;
          } else {
              s = markerSizeFunc(optsIn.size);
              for(i = 0; i < count; i++) {
                  sizes[i] = s;
              }
          }
  
          // See  https://github.com/plotly/plotly.js/pull/1781#discussion_r121820798
          if(multiLineWidth) {
              for(i = 0; i < count; i++) {
                  borderSizes[i] = optsIn.line.width[i] / 2;
              }
          } else {
              s = optsIn.line.width / 2;
              for(i = 0; i < count; i++) {
                  borderSizes[i] = s;
              }
          }
  
          optsOut.sizeAvg = sizeAvg;
      } else {
          optsOut.size = markerSizeFunc(optsIn && optsIn.size || 10);
          optsOut.borderSizes = markerSizeFunc(optsIn.line.width);
      }
  
      return optsOut;
  }
  
  function convertMarkerSelection(trace, target) {
      var optsIn = trace.marker;
      var optsOut = {};
  
      if(!target) return optsOut;
  
      if(target.marker && target.marker.symbol) {
          optsOut = convertMarkerStyle(Lib.extendFlat({}, optsIn, target.marker));
      } else if(target.marker) {
          if(target.marker.size) optsOut.size = target.marker.size / 2;
          if(target.marker.color) optsOut.colors = target.marker.color;
          if(target.marker.opacity !== undefined) optsOut.opacity = target.marker.opacity;
      }
  
      return optsOut;
  }
  
  function convertTextSelection(gd, trace, target) {
      var optsOut = {};
  
      if(!target) return optsOut;
  
      if(target.textfont) {
          var optsIn = {
              opacity: 1,
              text: trace.text,
              texttemplate: trace.texttemplate,
              textposition: trace.textposition,
              textfont: Lib.extendFlat({}, trace.textfont)
          };
          if(target.textfont) {
              Lib.extendFlat(optsIn.textfont, target.textfont);
          }
          optsOut = convertTextStyle(gd, optsIn);
      }
  
      return optsOut;
  }
  
  function convertErrorBarStyle(trace, target) {
      var optsOut = {
          capSize: target.width * 2,
          lineWidth: target.thickness,
          color: target.color
      };
  
      if(target.copy_ystyle) {
          optsOut = trace.error_y;
      }
  
      return optsOut;
  }
  
  var SYMBOL_SDF_SIZE = constants.SYMBOL_SDF_SIZE;
  var SYMBOL_SIZE = constants.SYMBOL_SIZE;
  var SYMBOL_STROKE = constants.SYMBOL_STROKE;
  var SYMBOL_SDF = {};
  var SYMBOL_SVG_CIRCLE = Drawing.symbolFuncs[0](SYMBOL_SIZE * 0.05);
  
  function getSymbolSdf(symbol) {
      if(symbol === 'circle') return null;
  
      var symbolPath, symbolSdf;
      var symbolNumber = Drawing.symbolNumber(symbol);
      var symbolFunc = Drawing.symbolFuncs[symbolNumber % 100];
      var symbolNoDot = !!Drawing.symbolNoDot[symbolNumber % 100];
      var symbolNoFill = !!Drawing.symbolNoFill[symbolNumber % 100];
  
      var isDot = helpers.isDotSymbol(symbol);
  
      // get symbol sdf from cache or generate it
      if(SYMBOL_SDF[symbol]) return SYMBOL_SDF[symbol];
  
      if(isDot && !symbolNoDot) {
          symbolPath = symbolFunc(SYMBOL_SIZE * 1.1) + SYMBOL_SVG_CIRCLE;
      } else {
          symbolPath = symbolFunc(SYMBOL_SIZE);
      }
  
      symbolSdf = svgSdf(symbolPath, {
          w: SYMBOL_SDF_SIZE,
          h: SYMBOL_SDF_SIZE,
          viewBox: [-SYMBOL_SIZE, -SYMBOL_SIZE, SYMBOL_SIZE, SYMBOL_SIZE],
          stroke: symbolNoFill ? SYMBOL_STROKE : -SYMBOL_STROKE
      });
      SYMBOL_SDF[symbol] = symbolSdf;
  
      return symbolSdf || null;
  }
  
  function convertLinePositions(gd, trace, positions) {
      var len = positions.length;
      var count = len / 2;
      var linePositions;
      var i;
  
      if(subTypes.hasLines(trace) && count) {
          if(trace.line.shape === 'hv') {
              linePositions = [];
              for(i = 0; i < count - 1; i++) {
                  if(isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1])) {
                      linePositions.push(NaN, NaN, NaN, NaN);
                  } else {
                      linePositions.push(positions[i * 2], positions[i * 2 + 1]);
                      if(!isNaN(positions[i * 2 + 2]) && !isNaN(positions[i * 2 + 3])) {
                          linePositions.push(positions[i * 2 + 2], positions[i * 2 + 1]);
                      } else {
                          linePositions.push(NaN, NaN);
                      }
                  }
              }
              linePositions.push(positions[len - 2], positions[len - 1]);
          } else if(trace.line.shape === 'hvh') {
              linePositions = [];
              for(i = 0; i < count - 1; i++) {
                  if(isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1]) || isNaN(positions[i * 2 + 2]) || isNaN(positions[i * 2 + 3])) {
                      if(!isNaN(positions[i * 2]) && !isNaN(positions[i * 2 + 1])) {
                          linePositions.push(positions[i * 2], positions[i * 2 + 1]);
                      } else {
                          linePositions.push(NaN, NaN);
                      }
                      linePositions.push(NaN, NaN);
                  } else {
                      var midPtX = (positions[i * 2] + positions[i * 2 + 2]) / 2;
                      linePositions.push(
                          positions[i * 2],
                          positions[i * 2 + 1],
                          midPtX,
                          positions[i * 2 + 1],
                          midPtX,
                          positions[i * 2 + 3]
                      );
                  }
              }
              linePositions.push(positions[len - 2], positions[len - 1]);
          } else if(trace.line.shape === 'vhv') {
              linePositions = [];
              for(i = 0; i < count - 1; i++) {
                  if(isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1]) || isNaN(positions[i * 2 + 2]) || isNaN(positions[i * 2 + 3])) {
                      if(!isNaN(positions[i * 2]) && !isNaN(positions[i * 2 + 1])) {
                          linePositions.push(positions[i * 2], positions[i * 2 + 1]);
                      } else {
                          linePositions.push(NaN, NaN);
                      }
                      linePositions.push(NaN, NaN);
                  } else {
                      var midPtY = (positions[i * 2 + 1] + positions[i * 2 + 3]) / 2;
                      linePositions.push(
                          positions[i * 2],
                          positions[i * 2 + 1],
                          positions[i * 2],
                          midPtY,
                          positions[i * 2 + 2],
                          midPtY
                      );
                  }
              }
              linePositions.push(positions[len - 2], positions[len - 1]);
          } else if(trace.line.shape === 'vh') {
              linePositions = [];
              for(i = 0; i < count - 1; i++) {
                  if(isNaN(positions[i * 2]) || isNaN(positions[i * 2 + 1])) {
                      linePositions.push(NaN, NaN, NaN, NaN);
                  } else {
                      linePositions.push(positions[i * 2], positions[i * 2 + 1]);
                      if(!isNaN(positions[i * 2 + 2]) && !isNaN(positions[i * 2 + 3])) {
                          linePositions.push(positions[i * 2], positions[i * 2 + 3]);
                      } else {
                          linePositions.push(NaN, NaN);
                      }
                  }
              }
              linePositions.push(positions[len - 2], positions[len - 1]);
          } else {
              linePositions = positions;
          }
      }
  
      // If we have data with gaps, we ought to use rect joins
      // FIXME: get rid of this
      var hasNaN = false;
      for(i = 0; i < linePositions.length; i++) {
          if(isNaN(linePositions[i])) {
              hasNaN = true;
              break;
          }
      }
  
      var join = (hasNaN || linePositions.length > constants.TOO_MANY_POINTS) ? 'rect' :
          subTypes.hasMarkers(trace) ? 'rect' : 'round';
  
      // fill gaps
      if(hasNaN && trace.connectgaps) {
          var lastX = linePositions[0];
          var lastY = linePositions[1];
  
          for(i = 0; i < linePositions.length; i += 2) {
              if(isNaN(linePositions[i]) || isNaN(linePositions[i + 1])) {
                  linePositions[i] = lastX;
                  linePositions[i + 1] = lastY;
              } else {
                  lastX = linePositions[i];
                  lastY = linePositions[i + 1];
              }
          }
      }
  
      return {
          join: join,
          positions: linePositions
      };
  }
  
  function convertErrorBarPositions(gd, trace, positions, x, y) {
      var makeComputeError = Registry.getComponentMethod('errorbars', 'makeComputeError');
      var xa = AxisIDs.getFromId(gd, trace.xaxis);
      var ya = AxisIDs.getFromId(gd, trace.yaxis);
      var count = positions.length / 2;
      var out = {};
  
      function convertOneAxis(coords, ax) {
          var axLetter = ax._id.charAt(0);
          var opts = trace['error_' + axLetter];
  
          if(opts && opts.visible && (ax.type === 'linear' || ax.type === 'log')) {
              var computeError = makeComputeError(opts);
              var pOffset = {x: 0, y: 1}[axLetter];
              var eOffset = {x: [0, 1, 2, 3], y: [2, 3, 0, 1]}[axLetter];
              var errors = new Float64Array(4 * count);
              var minShoe = Infinity;
              var maxHat = -Infinity;
  
              for(var i = 0, j = 0; i < count; i++, j += 4) {
                  var dc = coords[i];
  
                  if(isNumeric(dc)) {
                      var dl = positions[i * 2 + pOffset];
                      var vals = computeError(dc, i);
                      var lv = vals[0];
                      var hv = vals[1];
  
                      if(isNumeric(lv) && isNumeric(hv)) {
                          var shoe = dc - lv;
                          var hat = dc + hv;
  
                          errors[j + eOffset[0]] = dl - ax.c2l(shoe);
                          errors[j + eOffset[1]] = ax.c2l(hat) - dl;
                          errors[j + eOffset[2]] = 0;
                          errors[j + eOffset[3]] = 0;
  
                          minShoe = Math.min(minShoe, dc - lv);
                          maxHat = Math.max(maxHat, dc + hv);
                      }
                  }
              }
  
              out[axLetter] = {
                  positions: positions,
                  errors: errors,
                  _bnds: [minShoe, maxHat]
              };
          }
      }
  
      convertOneAxis(x, xa);
      convertOneAxis(y, ya);
      return out;
  }
  
  function convertTextPosition(gd, trace, textOpts, markerOpts) {
      var count = trace._length;
      var out = {};
      var i;
  
      // corresponds to textPointPosition from component.drawing
      if(subTypes.hasMarkers(trace)) {
          var fontOpts = textOpts.font;
          var align = textOpts.align;
          var baseline = textOpts.baseline;
          out.offset = new Array(count);
  
          for(i = 0; i < count; i++) {
              var ms = markerOpts.sizes ? markerOpts.sizes[i] : markerOpts.size;
              var fs = Array.isArray(fontOpts) ? fontOpts[i].size : fontOpts.size;
  
              var a = Array.isArray(align) ?
                  (align.length > 1 ? align[i] : align[0]) :
                  align;
              var b = Array.isArray(baseline) ?
                  (baseline.length > 1 ? baseline[i] : baseline[0]) :
                  baseline;
  
              var hSign = TEXTOFFSETSIGN[a];
              var vSign = TEXTOFFSETSIGN[b];
              var xPad = ms ? ms / 0.8 + 1 : 0;
              var yPad = -vSign * xPad - vSign * 0.5;
              out.offset[i] = [hSign * xPad / fs, yPad / fs];
          }
      }
  
      return out;
  }
  
  module.exports = {
      style: convertStyle,
  
      markerStyle: convertMarkerStyle,
      markerSelection: convertMarkerSelection,
  
      linePositions: convertLinePositions,
      errorBarPositions: convertErrorBarPositions,
      textPosition: convertTextPosition
  };
  
  },{"../../components/drawing":637,"../../components/fx/helpers":651,"../../constants/interactions":724,"../../lib":750,"../../lib/gl_format_color":746,"../../plots/cartesian/axis_ids":802,"../../registry":882,"../scatter/make_bubble_size_func":1175,"../scatter/subtypes":1183,"./constants":1212,"./helpers":1217,"color-normalize":125,"fast-isnumeric":241,"svg-path-sdf":546}],1214:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Registry = _dereq_('../../registry');
  
  var helpers = _dereq_('./helpers');
  var attributes = _dereq_('./attributes');
  var constants = _dereq_('../scatter/constants');
  var subTypes = _dereq_('../scatter/subtypes');
  var handleXYDefaults = _dereq_('../scatter/xy_defaults');
  var handlePeriodDefaults = _dereq_('../scatter/period_defaults');
  var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
  var handleLineDefaults = _dereq_('../scatter/line_defaults');
  var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
  var handleTextDefaults = _dereq_('../scatter/text_defaults');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var isOpen = traceIn.marker ? helpers.isOpenSymbol(traceIn.marker.symbol) : false;
      var isBubble = subTypes.isBubble(traceIn);
  
      var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  
      var defaultMode = len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
      coerce('mode', defaultMode);
  
      if(subTypes.hasLines(traceOut)) {
          coerce('connectgaps');
          handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
          coerce('line.shape');
      }
  
      if(subTypes.hasMarkers(traceOut)) {
          handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce);
          coerce('marker.line.width', isOpen || isBubble ? 1 : 0);
      }
  
      if(subTypes.hasText(traceOut)) {
          coerce('texttemplate');
          handleTextDefaults(traceIn, traceOut, layout, coerce);
      }
  
      var lineColor = (traceOut.line || {}).color;
      var markerColor = (traceOut.marker || {}).color;
  
      coerce('fill');
      if(traceOut.fill !== 'none') {
          handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
      }
  
      var errorBarsSupplyDefaults = Registry.getComponentMethod('errorbars', 'supplyDefaults');
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'y'});
      errorBarsSupplyDefaults(traceIn, traceOut, lineColor || markerColor || defaultColor, {axis: 'x', inherit: 'y'});
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  },{"../../lib":750,"../../registry":882,"../scatter/constants":1162,"../scatter/fillcolor_defaults":1166,"../scatter/line_defaults":1171,"../scatter/marker_defaults":1177,"../scatter/period_defaults":1178,"../scatter/subtypes":1183,"../scatter/text_defaults":1184,"../scatter/xy_defaults":1185,"./attributes":1210,"./helpers":1217}],1215:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  
  var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
  
  function styleTextSelection(cd) {
      var cd0 = cd[0];
      var trace = cd0.trace;
      var stash = cd0.t;
      var scene = stash._scene;
      var index = stash.index;
      var els = scene.selectBatch[index];
      var unels = scene.unselectBatch[index];
      var baseOpts = scene.textOptions[index];
      var selOpts = scene.textSelectedOptions[index] || {};
      var unselOpts = scene.textUnselectedOptions[index] || {};
      var opts = Lib.extendFlat({}, baseOpts);
      var i, j;
  
      if(els.length || unels.length) {
          var stc = selOpts.color;
          var utc = unselOpts.color;
          var base = baseOpts.color;
          var hasArrayBase = Array.isArray(base);
          opts.color = new Array(trace._length);
  
          for(i = 0; i < els.length; i++) {
              j = els[i];
              opts.color[j] = stc || (hasArrayBase ? base[j] : base);
          }
          for(i = 0; i < unels.length; i++) {
              j = unels[i];
              var basej = hasArrayBase ? base[j] : base;
              opts.color[j] = utc ? utc :
                  stc ? basej : Color.addOpacity(basej, DESELECTDIM);
          }
      }
  
      scene.glText[index].update(opts);
  }
  
  module.exports = {
      styleTextSelection: styleTextSelection
  };
  
  },{"../../components/color":615,"../../constants/interactions":724,"../../lib":750}],1216:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterFormatLabels = _dereq_('../scatter/format_labels');
  
  module.exports = function formatLabels(cdi, trace, fullLayout) {
      var i = cdi.i;
      if(!('x' in cdi)) cdi.x = trace._x[i];
      if(!('y' in cdi)) cdi.y = trace._y[i];
      return scatterFormatLabels(cdi, trace, fullLayout);
  };
  
  },{"../scatter/format_labels":1167}],1217:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var constants = _dereq_('./constants');
  
  exports.isOpenSymbol = function(symbol) {
      return (typeof symbol === 'string') ?
          constants.OPEN_RE.test(symbol) :
          symbol % 200 > 100;
  };
  
  exports.isDotSymbol = function(symbol) {
      return (typeof symbol === 'string') ?
          constants.DOT_RE.test(symbol) :
          symbol > 200;
  };
  
  },{"./constants":1212}],1218:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  var getTraceColor = _dereq_('../scatter/get_trace_color');
  
  function hoverPoints(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var stash = cd[0].t;
      var trace = cd[0].trace;
      var xa = pointData.xa;
      var ya = pointData.ya;
      var x = stash.x;
      var y = stash.y;
      var xpx = xa.c2p(xval);
      var ypx = ya.c2p(yval);
      var maxDistance = pointData.distance;
      var ids;
  
      // FIXME: make sure this is a proper way to calc search radius
      if(stash.tree) {
          var xl = xa.p2c(xpx - maxDistance);
          var xr = xa.p2c(xpx + maxDistance);
          var yl = ya.p2c(ypx - maxDistance);
          var yr = ya.p2c(ypx + maxDistance);
  
          if(hovermode === 'x') {
              ids = stash.tree.range(
                  Math.min(xl, xr), Math.min(ya._rl[0], ya._rl[1]),
                  Math.max(xl, xr), Math.max(ya._rl[0], ya._rl[1])
              );
          } else {
              ids = stash.tree.range(
                  Math.min(xl, xr), Math.min(yl, yr),
                  Math.max(xl, xr), Math.max(yl, yr)
              );
          }
      } else {
          ids = stash.ids;
      }
  
      // pick the id closest to the point
      // note that point possibly may not be found
      var id, ptx, pty, i, dx, dy, dist, dxy;
  
      var minDist = maxDistance;
      if(hovermode === 'x') {
          for(i = 0; i < ids.length; i++) {
              ptx = x[ids[i]];
              dx = Math.abs(xa.c2p(ptx) - xpx);
              if(dx < minDist) {
                  minDist = dx;
                  dy = ya.c2p(y[ids[i]]) - ypx;
                  dxy = Math.sqrt(dx * dx + dy * dy);
                  id = ids[i];
              }
          }
      } else {
          for(i = ids.length - 1; i > -1; i--) {
              ptx = x[ids[i]];
              pty = y[ids[i]];
              dx = xa.c2p(ptx) - xpx;
              dy = ya.c2p(pty) - ypx;
  
              dist = Math.sqrt(dx * dx + dy * dy);
              if(dist < minDist) {
                  minDist = dxy = dist;
                  id = ids[i];
              }
          }
      }
  
      pointData.index = id;
      pointData.distance = minDist;
      pointData.dxy = dxy;
  
      if(id === undefined) return [pointData];
  
      return [calcHover(pointData, x, y, trace)];
  }
  
  function calcHover(pointData, x, y, trace) {
      var xa = pointData.xa;
      var ya = pointData.ya;
      var minDist = pointData.distance;
      var dxy = pointData.dxy;
      var id = pointData.index;
  
      // the closest data point
      var di = {
          pointNumber: id,
          x: x[id],
          y: y[id]
      };
  
      // that is single-item arrays_to_calcdata excerpt, since we are doing it for a single point and we don't have to do it beforehead for 1e6 points
      di.tx = Array.isArray(trace.text) ? trace.text[id] : trace.text;
      di.htx = Array.isArray(trace.hovertext) ? trace.hovertext[id] : trace.hovertext;
      di.data = Array.isArray(trace.customdata) ? trace.customdata[id] : trace.customdata;
      di.tp = Array.isArray(trace.textposition) ? trace.textposition[id] : trace.textposition;
  
      var font = trace.textfont;
      if(font) {
          di.ts = Lib.isArrayOrTypedArray(font.size) ? font.size[id] : font.size;
          di.tc = Array.isArray(font.color) ? font.color[id] : font.color;
          di.tf = Array.isArray(font.family) ? font.family[id] : font.family;
      }
  
      var marker = trace.marker;
      if(marker) {
          di.ms = Lib.isArrayOrTypedArray(marker.size) ? marker.size[id] : marker.size;
          di.mo = Lib.isArrayOrTypedArray(marker.opacity) ? marker.opacity[id] : marker.opacity;
          di.mx = Lib.isArrayOrTypedArray(marker.symbol) ? marker.symbol[id] : marker.symbol;
          di.mc = Lib.isArrayOrTypedArray(marker.color) ? marker.color[id] : marker.color;
      }
  
      var line = marker && marker.line;
      if(line) {
          di.mlc = Array.isArray(line.color) ? line.color[id] : line.color;
          di.mlw = Lib.isArrayOrTypedArray(line.width) ? line.width[id] : line.width;
      }
  
      var grad = marker && marker.gradient;
      if(grad && grad.type !== 'none') {
          di.mgt = Array.isArray(grad.type) ? grad.type[id] : grad.type;
          di.mgc = Array.isArray(grad.color) ? grad.color[id] : grad.color;
      }
  
      var xp = xa.c2p(di.x, true);
      var yp = ya.c2p(di.y, true);
      var rad = di.mrc || 1;
  
      var hoverlabel = trace.hoverlabel;
  
      if(hoverlabel) {
          di.hbg = Array.isArray(hoverlabel.bgcolor) ? hoverlabel.bgcolor[id] : hoverlabel.bgcolor;
          di.hbc = Array.isArray(hoverlabel.bordercolor) ? hoverlabel.bordercolor[id] : hoverlabel.bordercolor;
          di.hts = Lib.isArrayOrTypedArray(hoverlabel.font.size) ? hoverlabel.font.size[id] : hoverlabel.font.size;
          di.htc = Array.isArray(hoverlabel.font.color) ? hoverlabel.font.color[id] : hoverlabel.font.color;
          di.htf = Array.isArray(hoverlabel.font.family) ? hoverlabel.font.family[id] : hoverlabel.font.family;
          di.hnl = Lib.isArrayOrTypedArray(hoverlabel.namelength) ? hoverlabel.namelength[id] : hoverlabel.namelength;
      }
      var hoverinfo = trace.hoverinfo;
      if(hoverinfo) {
          di.hi = Array.isArray(hoverinfo) ? hoverinfo[id] : hoverinfo;
      }
  
      var hovertemplate = trace.hovertemplate;
      if(hovertemplate) {
          di.ht = Array.isArray(hovertemplate) ? hovertemplate[id] : hovertemplate;
      }
  
      var fakeCd = {};
      fakeCd[pointData.index] = di;
  
      var origX = trace._origX;
      var origY = trace._origY;
  
      var pointData2 = Lib.extendFlat({}, pointData, {
          color: getTraceColor(trace, di),
  
          x0: xp - rad,
          x1: xp + rad,
          xLabelVal: origX ? origX[id] : di.x,
  
          y0: yp - rad,
          y1: yp + rad,
          yLabelVal: origY ? origY[id] : di.y,
  
          cd: fakeCd,
          distance: minDist,
          spikeDistance: dxy,
  
          hovertemplate: di.ht
      });
  
      if(di.htx) pointData2.text = di.htx;
      else if(di.tx) pointData2.text = di.tx;
      else if(trace.text) pointData2.text = trace.text;
  
      Lib.fillText(di, trace, pointData2);
      Registry.getComponentMethod('errorbars', 'hoverInfo')(di, trace, pointData2);
  
      return pointData2;
  }
  
  module.exports = {
      hoverPoints: hoverPoints,
      calcHover: calcHover
  };
  
  },{"../../lib":750,"../../registry":882,"../scatter/get_trace_color":1168}],1219:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hover = _dereq_('./hover');
  
  module.exports = {
      moduleType: 'trace',
      name: 'scattergl',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['gl', 'regl', 'cartesian', 'symbols', 'errorBarsOK', 'showLegend', 'scatter-like'],
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      crossTraceDefaults: _dereq_('../scatter/cross_trace_defaults'),
      colorbar: _dereq_('../scatter/marker_colorbar'),
      formatLabels: _dereq_('./format_labels'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      hoverPoints: hover.hoverPoints,
      selectPoints: _dereq_('./select'),
  
      meta: {
          
          
      }
  };
  
  },{"../../plots/cartesian":812,"../scatter/cross_trace_defaults":1164,"../scatter/marker_colorbar":1176,"./attributes":1210,"./calc":1211,"./defaults":1214,"./format_labels":1216,"./hover":1218,"./plot":1220,"./select":1222}],1220:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var createScatter = _dereq_('regl-scatter2d');
  var createLine = _dereq_('regl-line2d');
  var createError = _dereq_('regl-error2d');
  var Text = _dereq_('gl-text');
  
  var Lib = _dereq_('../../lib');
  var selectMode = _dereq_('../../components/dragelement/helpers').selectMode;
  var prepareRegl = _dereq_('../../lib/prepare_regl');
  
  var subTypes = _dereq_('../scatter/subtypes');
  var linkTraces = _dereq_('../scatter/link_traces');
  
  var styleTextSelection = _dereq_('./edit_style').styleTextSelection;
  
  function getViewport(fullLayout, xaxis, yaxis) {
      var gs = fullLayout._size;
      var width = fullLayout.width;
      var height = fullLayout.height;
      return [
          gs.l + xaxis.domain[0] * gs.w,
          gs.b + yaxis.domain[0] * gs.h,
          (width - gs.r) - (1 - xaxis.domain[1]) * gs.w,
          (height - gs.t) - (1 - yaxis.domain[1]) * gs.h
      ];
  }
  
  module.exports = function plot(gd, subplot, cdata) {
      if(!cdata.length) return;
  
      var fullLayout = gd._fullLayout;
      var scene = subplot._scene;
      var xaxis = subplot.xaxis;
      var yaxis = subplot.yaxis;
      var i, j;
  
      // we may have more subplots than initialized data due to Axes.getSubplots method
      if(!scene) return;
  
      var success = prepareRegl(gd, ['ANGLE_instanced_arrays', 'OES_element_index_uint']);
      if(!success) {
          scene.init();
          return;
      }
  
      var count = scene.count;
      var regl = fullLayout._glcanvas.data()[0].regl;
  
      // that is needed for fills
      linkTraces(gd, subplot, cdata);
  
      if(scene.dirty) {
          // make sure scenes are created
          if(scene.error2d === true) {
              scene.error2d = createError(regl);
          }
          if(scene.line2d === true) {
              scene.line2d = createLine(regl);
          }
          if(scene.scatter2d === true) {
              scene.scatter2d = createScatter(regl, { constPointSize: true });
          }
          if(scene.fill2d === true) {
              scene.fill2d = createLine(regl);
          }
          if(scene.glText === true) {
              scene.glText = new Array(count);
              for(i = 0; i < count; i++) {
                  scene.glText[i] = new Text(regl);
              }
          }
  
          // update main marker options
          if(scene.glText) {
              if(count > scene.glText.length) {
                  // add gl text marker
                  var textsToAdd = count - scene.glText.length;
                  for(i = 0; i < textsToAdd; i++) {
                      scene.glText.push(new Text(regl));
                  }
              } else if(count < scene.glText.length) {
                  // remove gl text marker
                  var textsToRemove = scene.glText.length - count;
                  var removedTexts = scene.glText.splice(count, textsToRemove);
                  removedTexts.forEach(function(text) { text.destroy(); });
              }
  
              for(i = 0; i < count; i++) {
                  scene.glText[i].update(scene.textOptions[i]);
              }
          }
          if(scene.line2d) {
              scene.line2d.update(scene.lineOptions);
              scene.lineOptions = scene.lineOptions.map(function(lineOptions) {
                  if(lineOptions && lineOptions.positions) {
                      var srcPos = lineOptions.positions;
  
                      var firstptdef = 0;
                      while(firstptdef < srcPos.length && (isNaN(srcPos[firstptdef]) || isNaN(srcPos[firstptdef + 1]))) {
                          firstptdef += 2;
                      }
                      var lastptdef = srcPos.length - 2;
                      while(lastptdef > firstptdef && (isNaN(srcPos[lastptdef]) || isNaN(srcPos[lastptdef + 1]))) {
                          lastptdef -= 2;
                      }
                      lineOptions.positions = srcPos.slice(firstptdef, lastptdef + 2);
                  }
                  return lineOptions;
              });
              scene.line2d.update(scene.lineOptions);
          }
          if(scene.error2d) {
              var errorBatch = (scene.errorXOptions || []).concat(scene.errorYOptions || []);
              scene.error2d.update(errorBatch);
          }
          if(scene.scatter2d) {
              scene.scatter2d.update(scene.markerOptions);
          }
  
          // fill requires linked traces, so we generate it's positions here
          scene.fillOrder = Lib.repeat(null, count);
          if(scene.fill2d) {
              scene.fillOptions = scene.fillOptions.map(function(fillOptions, i) {
                  var cdscatter = cdata[i];
                  if(!fillOptions || !cdscatter || !cdscatter[0] || !cdscatter[0].trace) return;
                  var cd = cdscatter[0];
                  var trace = cd.trace;
                  var stash = cd.t;
                  var lineOptions = scene.lineOptions[i];
                  var last, j;
  
                  var fillData = [];
                  if(trace._ownfill) fillData.push(i);
                  if(trace._nexttrace) fillData.push(i + 1);
                  if(fillData.length) scene.fillOrder[i] = fillData;
  
                  var pos = [];
                  var srcPos = (lineOptions && lineOptions.positions) || stash.positions;
                  var firstptdef, lastptdef;
  
                  if(trace.fill === 'tozeroy') {
                      firstptdef = 0;
                      while(firstptdef < srcPos.length && isNaN(srcPos[firstptdef + 1])) {
                          firstptdef += 2;
                      }
                      lastptdef = srcPos.length - 2;
                      while(lastptdef > firstptdef && isNaN(srcPos[lastptdef + 1])) {
                          lastptdef -= 2;
                      }
                      if(srcPos[firstptdef + 1] !== 0) {
                          pos = [srcPos[firstptdef], 0];
                      }
                      pos = pos.concat(srcPos.slice(firstptdef, lastptdef + 2));
                      if(srcPos[lastptdef + 1] !== 0) {
                          pos = pos.concat([srcPos[lastptdef], 0]);
                      }
                  } else if(trace.fill === 'tozerox') {
                      firstptdef = 0;
                      while(firstptdef < srcPos.length && isNaN(srcPos[firstptdef])) {
                          firstptdef += 2;
                      }
                      lastptdef = srcPos.length - 2;
                      while(lastptdef > firstptdef && isNaN(srcPos[lastptdef])) {
                          lastptdef -= 2;
                      }
                      if(srcPos[firstptdef] !== 0) {
                          pos = [0, srcPos[firstptdef + 1]];
                      }
                      pos = pos.concat(srcPos.slice(firstptdef, lastptdef + 2));
                      if(srcPos[lastptdef] !== 0) {
                          pos = pos.concat([ 0, srcPos[lastptdef + 1]]);
                      }
                  } else if(trace.fill === 'toself' || trace.fill === 'tonext') {
                      pos = [];
                      last = 0;
                      for(j = 0; j < srcPos.length; j += 2) {
                          if(isNaN(srcPos[j]) || isNaN(srcPos[j + 1])) {
                              pos = pos.concat(srcPos.slice(last, j));
                              pos.push(srcPos[last], srcPos[last + 1]);
                              last = j + 2;
                          }
                      }
                      pos = pos.concat(srcPos.slice(last));
                      if(last) {
                          pos.push(srcPos[last], srcPos[last + 1]);
                      }
                  } else {
                      var nextTrace = trace._nexttrace;
  
                      if(nextTrace) {
                          var nextOptions = scene.lineOptions[i + 1];
  
                          if(nextOptions) {
                              var nextPos = nextOptions.positions;
                              if(trace.fill === 'tonexty') {
                                  pos = srcPos.slice();
  
                                  for(i = Math.floor(nextPos.length / 2); i--;) {
                                      var xx = nextPos[i * 2];
                                      var yy = nextPos[i * 2 + 1];
                                      if(isNaN(xx) || isNaN(yy)) continue;
                                      pos.push(xx, yy);
                                  }
                                  fillOptions.fill = nextTrace.fillcolor;
                              }
                          }
                      }
                  }
  
                  // detect prev trace positions to exclude from current fill
                  if(trace._prevtrace && trace._prevtrace.fill === 'tonext') {
                      var prevLinePos = scene.lineOptions[i - 1].positions;
  
                      // FIXME: likely this logic should be tested better
                      var offset = pos.length / 2;
                      last = offset;
                      var hole = [last];
                      for(j = 0; j < prevLinePos.length; j += 2) {
                          if(isNaN(prevLinePos[j]) || isNaN(prevLinePos[j + 1])) {
                              hole.push(j / 2 + offset + 1);
                              last = j + 2;
                          }
                      }
  
                      pos = pos.concat(prevLinePos);
                      fillOptions.hole = hole;
                  }
                  fillOptions.fillmode = trace.fill;
                  fillOptions.opacity = trace.opacity;
                  fillOptions.positions = pos;
  
                  return fillOptions;
              });
  
              scene.fill2d.update(scene.fillOptions);
          }
      }
  
      // form batch arrays, and check for selected points
      var dragmode = fullLayout.dragmode;
      var isSelectMode = selectMode(dragmode);
      var clickSelectEnabled = fullLayout.clickmode.indexOf('select') > -1;
  
      for(i = 0; i < count; i++) {
          var cd0 = cdata[i][0];
          var trace = cd0.trace;
          var stash = cd0.t;
          var index = stash.index;
          var len = trace._length;
          var x = stash.x;
          var y = stash.y;
  
          if(trace.selectedpoints || isSelectMode || clickSelectEnabled) {
              if(!isSelectMode) isSelectMode = true;
  
              // regenerate scene batch, if traces number changed during selection
              if(trace.selectedpoints) {
                  var selPts = scene.selectBatch[index] = Lib.selIndices2selPoints(trace);
  
                  var selDict = {};
                  for(j = 0; j < selPts.length; j++) {
                      selDict[selPts[j]] = 1;
                  }
                  var unselPts = [];
                  for(j = 0; j < len; j++) {
                      if(!selDict[j]) unselPts.push(j);
                  }
                  scene.unselectBatch[index] = unselPts;
              }
  
              // precalculate px coords since we are not going to pan during select
              // TODO, could do better here e.g.
              // - spin that in a webworker
              // - compute selection from polygons in data coordinates
              //   (maybe just for linear axes)
              var xpx = stash.xpx = new Array(len);
              var ypx = stash.ypx = new Array(len);
              for(j = 0; j < len; j++) {
                  xpx[j] = xaxis.c2p(x[j]);
                  ypx[j] = yaxis.c2p(y[j]);
              }
          } else {
              stash.xpx = stash.ypx = null;
          }
      }
  
      if(isSelectMode) {
          // create scatter instance by cloning scatter2d
          if(!scene.select2d) {
              scene.select2d = createScatter(fullLayout._glcanvas.data()[1].regl);
          }
  
          // use unselected styles on 'context' canvas
          if(scene.scatter2d) {
              var unselOpts = new Array(count);
              for(i = 0; i < count; i++) {
                  unselOpts[i] = scene.selectBatch[i].length || scene.unselectBatch[i].length ?
                      scene.markerUnselectedOptions[i] :
                      {};
              }
              scene.scatter2d.update(unselOpts);
          }
  
          // use selected style on 'focus' canvas
          if(scene.select2d) {
              scene.select2d.update(scene.markerOptions);
              scene.select2d.update(scene.markerSelectedOptions);
          }
  
          if(scene.glText) {
              cdata.forEach(function(cdscatter) {
                  var trace = ((cdscatter || [])[0] || {}).trace || {};
                  if(subTypes.hasText(trace)) {
                      styleTextSelection(cdscatter);
                  }
              });
          }
      } else {
          // reset 'context' scatter2d opts to base opts,
          // thus unsetting markerUnselectedOptions from selection
          if(scene.scatter2d) {
              scene.scatter2d.update(scene.markerOptions);
          }
      }
  
      // provide viewport and range
      var vpRange0 = {
          viewport: getViewport(fullLayout, xaxis, yaxis),
          // TODO do we need those fallbacks?
          range: [
              (xaxis._rl || xaxis.range)[0],
              (yaxis._rl || yaxis.range)[0],
              (xaxis._rl || xaxis.range)[1],
              (yaxis._rl || yaxis.range)[1]
          ]
      };
      var vpRange = Lib.repeat(vpRange0, scene.count);
  
      // upload viewport/range data to GPU
      if(scene.fill2d) {
          scene.fill2d.update(vpRange);
      }
      if(scene.line2d) {
          scene.line2d.update(vpRange);
      }
      if(scene.error2d) {
          scene.error2d.update(vpRange.concat(vpRange));
      }
      if(scene.scatter2d) {
          scene.scatter2d.update(vpRange);
      }
      if(scene.select2d) {
          scene.select2d.update(vpRange);
      }
      if(scene.glText) {
          scene.glText.forEach(function(text) { text.update(vpRange0); });
      }
  };
  
  },{"../../components/dragelement/helpers":633,"../../lib":750,"../../lib/prepare_regl":763,"../scatter/link_traces":1174,"../scatter/subtypes":1183,"./edit_style":1215,"gl-text":326,"regl-error2d":508,"regl-line2d":509,"regl-scatter2d":510}],1221:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  // make sure scene exists on subplot, return it
  module.exports = function sceneUpdate(gd, subplot) {
      var scene = subplot._scene;
  
      var resetOpts = {
          // number of traces in subplot, since scene:subplot -> 1:1
          count: 0,
          // whether scene requires init hook in plot call (dirty plot call)
          dirty: true,
          // last used options
          lineOptions: [],
          fillOptions: [],
          markerOptions: [],
          markerSelectedOptions: [],
          markerUnselectedOptions: [],
          errorXOptions: [],
          errorYOptions: [],
          textOptions: [],
          textSelectedOptions: [],
          textUnselectedOptions: [],
          // selection batches
          selectBatch: [],
          unselectBatch: []
      };
  
      // regl- component stubs, initialized in dirty plot call
      var initOpts = {
          fill2d: false,
          scatter2d: false,
          error2d: false,
          line2d: false,
          glText: false,
          select2d: false
      };
  
      if(!subplot._scene) {
          scene = subplot._scene = {};
  
          scene.init = function init() {
              Lib.extendFlat(scene, initOpts, resetOpts);
          };
  
          scene.init();
  
          // apply new option to all regl components (used on drag)
          scene.update = function update(opt) {
              var opts = Lib.repeat(opt, scene.count);
  
              if(scene.fill2d) scene.fill2d.update(opts);
              if(scene.scatter2d) scene.scatter2d.update(opts);
              if(scene.line2d) scene.line2d.update(opts);
              if(scene.error2d) scene.error2d.update(opts.concat(opts));
              if(scene.select2d) scene.select2d.update(opts);
              if(scene.glText) {
                  for(var i = 0; i < scene.count; i++) {
                      scene.glText[i].update(opt);
                  }
              }
          };
  
          // draw traces in proper order
          scene.draw = function draw() {
              var count = scene.count;
              var fill2d = scene.fill2d;
              var error2d = scene.error2d;
              var line2d = scene.line2d;
              var scatter2d = scene.scatter2d;
              var glText = scene.glText;
              var select2d = scene.select2d;
              var selectBatch = scene.selectBatch;
              var unselectBatch = scene.unselectBatch;
  
              for(var i = 0; i < count; i++) {
                  if(fill2d && scene.fillOrder[i]) {
                      fill2d.draw(scene.fillOrder[i]);
                  }
                  if(line2d && scene.lineOptions[i]) {
                      line2d.draw(i);
                  }
                  if(error2d) {
                      if(scene.errorXOptions[i]) error2d.draw(i);
                      if(scene.errorYOptions[i]) error2d.draw(i + count);
                  }
                  if(scatter2d && scene.markerOptions[i]) {
                      if(unselectBatch[i].length) {
                          var arg = Lib.repeat([], scene.count);
                          arg[i] = unselectBatch[i];
                          scatter2d.draw(arg);
                      } else if(!selectBatch[i].length) {
                          scatter2d.draw(i);
                      }
                  }
                  if(glText[i] && scene.textOptions[i]) {
                      glText[i].render();
                  }
              }
  
              if(select2d) {
                  select2d.draw(selectBatch);
              }
  
              scene.dirty = false;
          };
  
          // remove scene resources
          scene.destroy = function destroy() {
              if(scene.fill2d && scene.fill2d.destroy) scene.fill2d.destroy();
              if(scene.scatter2d && scene.scatter2d.destroy) scene.scatter2d.destroy();
              if(scene.error2d && scene.error2d.destroy) scene.error2d.destroy();
              if(scene.line2d && scene.line2d.destroy) scene.line2d.destroy();
              if(scene.select2d && scene.select2d.destroy) scene.select2d.destroy();
              if(scene.glText) {
                  scene.glText.forEach(function(text) {
                      if(text.destroy) text.destroy();
                  });
              }
  
              scene.lineOptions = null;
              scene.fillOptions = null;
              scene.markerOptions = null;
              scene.markerSelectedOptions = null;
              scene.markerUnselectedOptions = null;
              scene.errorXOptions = null;
              scene.errorYOptions = null;
              scene.textOptions = null;
              scene.textSelectedOptions = null;
              scene.textUnselectedOptions = null;
  
              scene.selectBatch = null;
              scene.unselectBatch = null;
  
              // we can't just delete _scene, because `destroy` is called in the
              // middle of supplyDefaults, before relinkPrivateKeys which will put it back.
              subplot._scene = null;
          };
      }
  
      // in case if we have scene from the last calc - reset data
      if(!scene.dirty) {
          Lib.extendFlat(scene, resetOpts);
      }
  
      return scene;
  };
  
  },{"../../lib":750}],1222:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var subTypes = _dereq_('../scatter/subtypes');
  var styleTextSelection = _dereq_('./edit_style').styleTextSelection;
  
  module.exports = function select(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var selection = [];
      var trace = cd[0].trace;
      var stash = cd[0].t;
      var len = trace._length;
      var x = stash.x;
      var y = stash.y;
      var scene = stash._scene;
      var index = stash.index;
  
      if(!scene) return selection;
  
      var hasText = subTypes.hasText(trace);
      var hasMarkers = subTypes.hasMarkers(trace);
      var hasOnlyLines = !hasMarkers && !hasText;
  
      if(trace.visible !== true || hasOnlyLines) return selection;
  
      var els = [];
      var unels = [];
  
      // degenerate polygon does not enable selection
      // filter out points by visible scatter ones
      if(selectionTester !== false && !selectionTester.degenerate) {
          for(var i = 0; i < len; i++) {
              if(selectionTester.contains([stash.xpx[i], stash.ypx[i]], false, i, searchInfo)) {
                  els.push(i);
                  selection.push({
                      pointNumber: i,
                      x: x[i],
                      y: y[i]
                  });
              } else {
                  unels.push(i);
              }
          }
      }
  
      if(hasMarkers) {
          var scatter2d = scene.scatter2d;
  
          if(!els.length && !unels.length) {
              // reset to base styles when clearing
              var baseOpts = new Array(scene.count);
              baseOpts[index] = scene.markerOptions[index];
              scatter2d.update.apply(scatter2d, baseOpts);
          } else if(!scene.selectBatch[index].length && !scene.unselectBatch[index].length) {
              // set unselected styles on 'context' canvas (if not done already)
              var unselOpts = new Array(scene.count);
              unselOpts[index] = scene.markerUnselectedOptions[index];
              scatter2d.update.apply(scatter2d, unselOpts);
          }
      }
  
      scene.selectBatch[index] = els;
      scene.unselectBatch[index] = unels;
  
      if(hasText) {
          styleTextSelection(cd);
      }
  
      return selection;
  };
  
  },{"../scatter/subtypes":1183,"./edit_style":1215}],1223:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var scatterGeoAttrs = _dereq_('../scattergeo/attributes');
  var scatterAttrs = _dereq_('../scatter/attributes');
  var mapboxAttrs = _dereq_('../../plots/mapbox/layout_attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var lineAttrs = scatterGeoAttrs.line;
  var markerAttrs = scatterGeoAttrs.marker;
  
  module.exports = overrideAll({
      lon: scatterGeoAttrs.lon,
      lat: scatterGeoAttrs.lat,
  
      // locations
      // locationmode
  
      mode: extendFlat({}, scatterAttrs.mode, {
          dflt: 'markers',
          
      }),
  
      text: extendFlat({}, scatterAttrs.text, {
          
      }),
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: ['lat', 'lon', 'text']
      }),
      hovertext: extendFlat({}, scatterAttrs.hovertext, {
          
      }),
  
      line: {
          color: lineAttrs.color,
          width: lineAttrs.width
  
          // TODO
          // dash: dash
      },
  
      connectgaps: scatterAttrs.connectgaps,
  
      marker: extendFlat({
          symbol: {
              valType: 'string',
              dflt: 'circle',
              
              arrayOk: true,
              
          },
          angle: {
              valType: 'number',
              dflt: 'auto',
              
              arrayOk: true,
              
          },
          allowoverlap: {
              valType: 'boolean',
              dflt: false,
              
              
          },
          opacity: markerAttrs.opacity,
          size: markerAttrs.size,
          sizeref: markerAttrs.sizeref,
          sizemin: markerAttrs.sizemin,
          sizemode: markerAttrs.sizemode
      },
          colorScaleAttrs('marker')
          // line
      ),
  
      fill: scatterGeoAttrs.fill,
      fillcolor: scatterAttrs.fillcolor,
  
      textfont: mapboxAttrs.layers.symbol.textfont,
      textposition: mapboxAttrs.layers.symbol.textposition,
  
      below: {
          valType: 'string',
          
          
      },
  
      selected: {
          marker: scatterAttrs.selected.marker
      },
      unselected: {
          marker: scatterAttrs.unselected.marker
      },
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['lon', 'lat', 'text', 'name']
      }),
      hovertemplate: hovertemplateAttrs(),
  }, 'calc', 'nested');
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plots/attributes":795,"../../plots/mapbox/layout_attributes":858,"../../plots/template_attributes":877,"../scatter/attributes":1158,"../scattergeo/attributes":1200}],1224:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  var geoJsonUtils = _dereq_('../../lib/geojson_utils');
  
  var Colorscale = _dereq_('../../components/colorscale');
  var Drawing = _dereq_('../../components/drawing');
  var makeBubbleSizeFn = _dereq_('../scatter/make_bubble_size_func');
  var subTypes = _dereq_('../scatter/subtypes');
  var convertTextOpts = _dereq_('../../plots/mapbox/convert_text_opts');
  var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
  
  var NEWLINES = _dereq_('../../lib/svg_text_utils').NEWLINES;
  var BR_TAG_ALL = _dereq_('../../lib/svg_text_utils').BR_TAG_ALL;
  
  module.exports = function convert(gd, calcTrace) {
      var trace = calcTrace[0].trace;
  
      var isVisible = (trace.visible === true && trace._length !== 0);
      var hasFill = (trace.fill !== 'none');
      var hasLines = subTypes.hasLines(trace);
      var hasMarkers = subTypes.hasMarkers(trace);
      var hasText = subTypes.hasText(trace);
      var hasCircles = (hasMarkers && trace.marker.symbol === 'circle');
      var hasSymbols = (hasMarkers && trace.marker.symbol !== 'circle');
  
      var fill = initContainer();
      var line = initContainer();
      var circle = initContainer();
      var symbol = initContainer();
  
      var opts = {
          fill: fill,
          line: line,
          circle: circle,
          symbol: symbol
      };
  
      // early return if not visible or placeholder
      if(!isVisible) return opts;
  
      // fill layer and line layer use the same coords
      var lineCoords;
      if(hasFill || hasLines) {
          lineCoords = geoJsonUtils.calcTraceToLineCoords(calcTrace);
      }
  
      if(hasFill) {
          fill.geojson = geoJsonUtils.makePolygon(lineCoords);
          fill.layout.visibility = 'visible';
  
          Lib.extendFlat(fill.paint, {
              'fill-color': trace.fillcolor
          });
      }
  
      if(hasLines) {
          line.geojson = geoJsonUtils.makeLine(lineCoords);
          line.layout.visibility = 'visible';
  
          Lib.extendFlat(line.paint, {
              'line-width': trace.line.width,
              'line-color': trace.line.color,
              'line-opacity': trace.opacity
          });
  
          // TODO convert line.dash into line-dasharray
      }
  
      if(hasCircles) {
          var circleOpts = makeCircleOpts(calcTrace);
          circle.geojson = circleOpts.geojson;
          circle.layout.visibility = 'visible';
  
          Lib.extendFlat(circle.paint, {
              'circle-color': circleOpts.mcc,
              'circle-radius': circleOpts.mrc,
              'circle-opacity': circleOpts.mo
          });
      }
  
      if(hasSymbols || hasText) {
          symbol.geojson = makeSymbolGeoJSON(calcTrace, gd);
  
          Lib.extendFlat(symbol.layout, {
              visibility: 'visible',
              'icon-image': '{symbol}-15',
              'text-field': '{text}'
          });
  
          if(hasSymbols) {
              Lib.extendFlat(symbol.layout, {
                  'icon-size': trace.marker.size / 10
              });
  
              if('angle' in trace.marker && trace.marker.angle !== 'auto') {
                  Lib.extendFlat(symbol.layout, {
                  // unfortunately cant use {angle} do to this issue:
                  // https://github.com/mapbox/mapbox-gl-js/issues/873
                      'icon-rotate': {
                          type: 'identity', property: 'angle'
                      },
                      'icon-rotation-alignment': 'map'
                  });
              }
  
              symbol.layout['icon-allow-overlap'] = trace.marker.allowoverlap;
  
              Lib.extendFlat(symbol.paint, {
                  'icon-opacity': trace.opacity * trace.marker.opacity,
  
                  // TODO does not work ??
                  'icon-color': trace.marker.color
              });
          }
  
          if(hasText) {
              var iconSize = (trace.marker || {}).size;
              var textOpts = convertTextOpts(trace.textposition, iconSize);
  
              // all data-driven below !!
  
              Lib.extendFlat(symbol.layout, {
                  'text-size': trace.textfont.size,
                  'text-anchor': textOpts.anchor,
                  'text-offset': textOpts.offset
  
                  // TODO font family
                  // 'text-font': symbol.textfont.family.split(', '),
              });
  
              Lib.extendFlat(symbol.paint, {
                  'text-color': trace.textfont.color,
                  'text-opacity': trace.opacity
              });
          }
      }
  
      return opts;
  };
  
  function initContainer() {
      return {
          geojson: geoJsonUtils.makeBlank(),
          layout: { visibility: 'none' },
          paint: {}
      };
  }
  
  function makeCircleOpts(calcTrace) {
      var trace = calcTrace[0].trace;
      var marker = trace.marker;
      var selectedpoints = trace.selectedpoints;
      var arrayColor = Lib.isArrayOrTypedArray(marker.color);
      var arraySize = Lib.isArrayOrTypedArray(marker.size);
      var arrayOpacity = Lib.isArrayOrTypedArray(marker.opacity);
      var i;
  
      function addTraceOpacity(o) { return trace.opacity * o; }
  
      function size2radius(s) { return s / 2; }
  
      var colorFn;
      if(arrayColor) {
          if(Colorscale.hasColorscale(trace, 'marker')) {
              colorFn = Colorscale.makeColorScaleFuncFromTrace(marker);
          } else {
              colorFn = Lib.identity;
          }
      }
  
      var sizeFn;
      if(arraySize) {
          sizeFn = makeBubbleSizeFn(trace);
      }
  
      var opacityFn;
      if(arrayOpacity) {
          opacityFn = function(mo) {
              var mo2 = isNumeric(mo) ? +Lib.constrain(mo, 0, 1) : 0;
              return addTraceOpacity(mo2);
          };
      }
  
      var features = [];
      for(i = 0; i < calcTrace.length; i++) {
          var calcPt = calcTrace[i];
          var lonlat = calcPt.lonlat;
  
          if(isBADNUM(lonlat)) continue;
  
          var props = {};
          if(colorFn) props.mcc = calcPt.mcc = colorFn(calcPt.mc);
          if(sizeFn) props.mrc = calcPt.mrc = sizeFn(calcPt.ms);
          if(opacityFn) props.mo = opacityFn(calcPt.mo);
          if(selectedpoints) props.selected = calcPt.selected || 0;
  
          features.push({
              type: 'Feature',
              geometry: {type: 'Point', coordinates: lonlat},
              properties: props
          });
      }
  
      var fns;
      if(selectedpoints) {
          fns = Drawing.makeSelectedPointStyleFns(trace);
  
          for(i = 0; i < features.length; i++) {
              var d = features[i].properties;
  
              if(fns.selectedOpacityFn) {
                  d.mo = addTraceOpacity(fns.selectedOpacityFn(d));
              }
              if(fns.selectedColorFn) {
                  d.mcc = fns.selectedColorFn(d);
              }
              if(fns.selectedSizeFn) {
                  d.mrc = fns.selectedSizeFn(d);
              }
          }
      }
  
      return {
          geojson: {type: 'FeatureCollection', features: features},
          mcc: arrayColor || (fns && fns.selectedColorFn) ?
              {type: 'identity', property: 'mcc'} :
              marker.color,
          mrc: arraySize || (fns && fns.selectedSizeFn) ?
              {type: 'identity', property: 'mrc'} :
              size2radius(marker.size),
          mo: arrayOpacity || (fns && fns.selectedOpacityFn) ?
              {type: 'identity', property: 'mo'} :
              addTraceOpacity(marker.opacity)
      };
  }
  
  function makeSymbolGeoJSON(calcTrace, gd) {
      var fullLayout = gd._fullLayout;
      var trace = calcTrace[0].trace;
  
      var marker = trace.marker || {};
      var symbol = marker.symbol;
      var angle = marker.angle;
  
      var fillSymbol = (symbol !== 'circle') ?
          getFillFunc(symbol) :
          blankFillFunc;
  
      var fillAngle = (angle !== 'auto') ?
          getFillFunc(angle, true) :
          blankFillFunc;
  
      var fillText = subTypes.hasText(trace) ?
          getFillFunc(trace.text) :
          blankFillFunc;
  
  
      var features = [];
  
      for(var i = 0; i < calcTrace.length; i++) {
          var calcPt = calcTrace[i];
  
          if(isBADNUM(calcPt.lonlat)) continue;
  
          var texttemplate = trace.texttemplate;
          var text;
  
          if(texttemplate) {
              var tt = Array.isArray(texttemplate) ? (texttemplate[i] || '') : texttemplate;
              var labels = trace._module.formatLabels(calcPt, trace, fullLayout);
              var pointValues = {};
              appendArrayPointValue(pointValues, trace, calcPt.i);
              var meta = trace._meta || {};
              text = Lib.texttemplateString(tt, labels, fullLayout._d3locale, pointValues, calcPt, meta);
          } else {
              text = fillText(i);
          }
  
          if(text) {
              text = text.replace(NEWLINES, '').replace(BR_TAG_ALL, '\n');
          }
  
          features.push({
              type: 'Feature',
              geometry: {
                  type: 'Point',
                  coordinates: calcPt.lonlat
              },
              properties: {
                  symbol: fillSymbol(i),
                  angle: fillAngle(i),
                  text: text
              }
          });
      }
  
      return {
          type: 'FeatureCollection',
          features: features
      };
  }
  
  function getFillFunc(attr, numeric) {
      if(Lib.isArrayOrTypedArray(attr)) {
          if(numeric) {
              return function(i) { return isNumeric(attr[i]) ? +attr[i] : 0; };
          }
          return function(i) { return attr[i]; };
      } else if(attr) {
          return function() { return attr; };
      } else {
          return blankFillFunc;
      }
  }
  
  function blankFillFunc() { return ''; }
  
  // only need to check lon (OR lat)
  function isBADNUM(lonlat) {
      return lonlat[0] === BADNUM;
  }
  
  },{"../../components/colorscale":627,"../../components/drawing":637,"../../components/fx/helpers":651,"../../constants/numerical":725,"../../lib":750,"../../lib/geojson_utils":744,"../../lib/svg_text_utils":774,"../../plots/mapbox/convert_text_opts":855,"../scatter/make_bubble_size_func":1175,"../scatter/subtypes":1183,"fast-isnumeric":241}],1225:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var subTypes = _dereq_('../scatter/subtypes');
  var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
  var handleLineDefaults = _dereq_('../scatter/line_defaults');
  var handleTextDefaults = _dereq_('../scatter/text_defaults');
  var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleLonLatDefaults(traceIn, traceOut, coerce);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      coerce('text');
      coerce('texttemplate');
      coerce('hovertext');
      coerce('hovertemplate');
      coerce('mode');
      coerce('below');
  
      if(subTypes.hasLines(traceOut)) {
          handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce, {noDash: true});
          coerce('connectgaps');
      }
  
      if(subTypes.hasMarkers(traceOut)) {
          handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {noLine: true});
  
          coerce('marker.allowoverlap');
          coerce('marker.angle');
  
          // array marker.size and marker.color are only supported with circles
          var marker = traceOut.marker;
          if(marker.symbol !== 'circle') {
              if(Lib.isArrayOrTypedArray(marker.size)) marker.size = marker.size[0];
              if(Lib.isArrayOrTypedArray(marker.color)) marker.color = marker.color[0];
          }
      }
  
      if(subTypes.hasText(traceOut)) {
          handleTextDefaults(traceIn, traceOut, layout, coerce, {noSelect: true});
      }
  
      coerce('fill');
      if(traceOut.fill !== 'none') {
          handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
      }
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  function handleLonLatDefaults(traceIn, traceOut, coerce) {
      var lon = coerce('lon') || [];
      var lat = coerce('lat') || [];
      var len = Math.min(lon.length, lat.length);
      traceOut._length = len;
  
      return len;
  }
  
  },{"../../lib":750,"../scatter/fillcolor_defaults":1166,"../scatter/line_defaults":1171,"../scatter/marker_defaults":1177,"../scatter/subtypes":1183,"../scatter/text_defaults":1184,"./attributes":1223}],1226:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  
  module.exports = function eventData(out, pt) {
      out.lon = pt.lon;
      out.lat = pt.lat;
  
      return out;
  };
  
  },{}],1227:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  module.exports = function formatLabels(cdi, trace, fullLayout) {
      var labels = {};
  
      var subplot = fullLayout[trace.subplot]._subplot;
      var ax = subplot.mockAxis;
  
      var lonlat = cdi.lonlat;
      labels.lonLabel = Axes.tickText(ax, ax.c2l(lonlat[0]), true).text;
      labels.latLabel = Axes.tickText(ax, ax.c2l(lonlat[1]), true).text;
  
      return labels;
  };
  
  },{"../../plots/cartesian/axes":799}],1228:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Fx = _dereq_('../../components/fx');
  var Lib = _dereq_('../../lib');
  var getTraceColor = _dereq_('../scatter/get_trace_color');
  var fillText = Lib.fillText;
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  module.exports = function hoverPoints(pointData, xval, yval) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
      var xa = pointData.xa;
      var ya = pointData.ya;
      var subplot = pointData.subplot;
  
      // compute winding number about [-180, 180] globe
      var winding = (xval >= 0) ?
          Math.floor((xval + 180) / 360) :
          Math.ceil((xval - 180) / 360);
  
      // shift longitude to [-180, 180] to determine closest point
      var lonShift = winding * 360;
      var xval2 = xval - lonShift;
  
      function distFn(d) {
          var lonlat = d.lonlat;
          if(lonlat[0] === BADNUM) return Infinity;
  
          var lon = Lib.modHalf(lonlat[0], 360);
          var lat = lonlat[1];
          var pt = subplot.project([lon, lat]);
          var dx = pt.x - xa.c2p([xval2, lat]);
          var dy = pt.y - ya.c2p([lon, yval]);
          var rad = Math.max(3, d.mrc || 0);
  
          return Math.max(Math.sqrt(dx * dx + dy * dy) - rad, 1 - 3 / rad);
      }
  
      Fx.getClosest(cd, distFn, pointData);
  
      // skip the rest (for this trace) if we didn't find a close point
      if(pointData.index === false) return;
  
      var di = cd[pointData.index];
      var lonlat = di.lonlat;
      var lonlatShifted = [Lib.modHalf(lonlat[0], 360) + lonShift, lonlat[1]];
  
      // shift labels back to original winded globe
      var xc = xa.c2p(lonlatShifted);
      var yc = ya.c2p(lonlatShifted);
      var rad = di.mrc || 1;
  
      pointData.x0 = xc - rad;
      pointData.x1 = xc + rad;
      pointData.y0 = yc - rad;
      pointData.y1 = yc + rad;
  
      var fullLayout = {};
      fullLayout[trace.subplot] = {_subplot: subplot};
      var labels = trace._module.formatLabels(di, trace, fullLayout);
      pointData.lonLabel = labels.lonLabel;
      pointData.latLabel = labels.latLabel;
  
      pointData.color = getTraceColor(trace, di);
      pointData.extraText = getExtraText(trace, di, cd[0].t.labels);
      pointData.hovertemplate = trace.hovertemplate;
  
      return [pointData];
  };
  
  function getExtraText(trace, di, labels) {
      if(trace.hovertemplate) return;
  
      var hoverinfo = di.hi || trace.hoverinfo;
      var parts = hoverinfo.split('+');
      var isAll = parts.indexOf('all') !== -1;
      var hasLon = parts.indexOf('lon') !== -1;
      var hasLat = parts.indexOf('lat') !== -1;
      var lonlat = di.lonlat;
      var text = [];
  
      // TODO should we use a mock axis to format hover?
      // If so, we'll need to make precision be zoom-level dependent
      function format(v) {
          return v + '\u00B0';
      }
  
      if(isAll || (hasLon && hasLat)) {
          text.push('(' + format(lonlat[0]) + ', ' + format(lonlat[1]) + ')');
      } else if(hasLon) {
          text.push(labels.lon + format(lonlat[0]));
      } else if(hasLat) {
          text.push(labels.lat + format(lonlat[1]));
      }
  
      if(isAll || parts.indexOf('text') !== -1) {
          fillText(di, trace, text);
      }
  
      return text.join('<br>');
  }
  
  },{"../../components/fx":655,"../../constants/numerical":725,"../../lib":750,"../scatter/get_trace_color":1168}],1229:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../scatter/marker_colorbar'),
      formatLabels: _dereq_('./format_labels'),
      calc: _dereq_('../scattergeo/calc'),
      plot: _dereq_('./plot'),
      hoverPoints: _dereq_('./hover'),
      eventData: _dereq_('./event_data'),
      selectPoints: _dereq_('./select'),
  
      styleOnSelect: function(_, cd) {
          if(cd) {
              var trace = cd[0].trace;
              trace._glTrace.update(cd);
          }
      },
  
      moduleType: 'trace',
      name: 'scattermapbox',
      basePlotModule: _dereq_('../../plots/mapbox'),
      categories: ['mapbox', 'gl', 'symbols', 'showLegend', 'scatter-like'],
      meta: {
          
          
      }
  };
  
  },{"../../plots/mapbox":856,"../scatter/marker_colorbar":1176,"../scattergeo/calc":1201,"./attributes":1223,"./defaults":1225,"./event_data":1226,"./format_labels":1227,"./hover":1228,"./plot":1230,"./select":1231}],1230:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var convert = _dereq_('./convert');
  var LAYER_PREFIX = _dereq_('../../plots/mapbox/constants').traceLayerPrefix;
  var ORDER = ['fill', 'line', 'circle', 'symbol'];
  
  function ScatterMapbox(subplot, uid) {
      this.type = 'scattermapbox';
      this.subplot = subplot;
      this.uid = uid;
  
      this.sourceIds = {
          fill: 'source-' + uid + '-fill',
          line: 'source-' + uid + '-line',
          circle: 'source-' + uid + '-circle',
          symbol: 'source-' + uid + '-symbol'
      };
  
      this.layerIds = {
          fill: LAYER_PREFIX + uid + '-fill',
          line: LAYER_PREFIX + uid + '-line',
          circle: LAYER_PREFIX + uid + '-circle',
          symbol: LAYER_PREFIX + uid + '-symbol'
      };
  
      // We could merge the 'fill' source with the 'line' source and
      // the 'circle' source with the 'symbol' source if ever having
      // for up-to 4 sources per 'scattermapbox' traces becomes a problem.
  
      // previous 'below' value,
      // need this to update it properly
      this.below = null;
  }
  
  var proto = ScatterMapbox.prototype;
  
  proto.addSource = function(k, opts) {
      this.subplot.map.addSource(this.sourceIds[k], {
          type: 'geojson',
          data: opts.geojson
      });
  };
  
  proto.setSourceData = function(k, opts) {
      this.subplot.map
          .getSource(this.sourceIds[k])
          .setData(opts.geojson);
  };
  
  proto.addLayer = function(k, opts, below) {
      this.subplot.addLayer({
          type: k,
          id: this.layerIds[k],
          source: this.sourceIds[k],
          layout: opts.layout,
          paint: opts.paint
      }, below);
  };
  
  proto.update = function update(calcTrace) {
      var subplot = this.subplot;
      var map = subplot.map;
      var optsAll = convert(subplot.gd, calcTrace);
      var below = subplot.belowLookup['trace-' + this.uid];
      var i, k, opts;
  
      if(below !== this.below) {
          for(i = ORDER.length - 1; i >= 0; i--) {
              k = ORDER[i];
              map.removeLayer(this.layerIds[k]);
          }
          for(i = 0; i < ORDER.length; i++) {
              k = ORDER[i];
              opts = optsAll[k];
              this.addLayer(k, opts, below);
          }
          this.below = below;
      }
  
      for(i = 0; i < ORDER.length; i++) {
          k = ORDER[i];
          opts = optsAll[k];
  
          subplot.setOptions(this.layerIds[k], 'setLayoutProperty', opts.layout);
  
          if(opts.layout.visibility === 'visible') {
              this.setSourceData(k, opts);
              subplot.setOptions(this.layerIds[k], 'setPaintProperty', opts.paint);
          }
      }
  
      // link ref for quick update during selections
      calcTrace[0].trace._glTrace = this;
  };
  
  proto.dispose = function dispose() {
      var map = this.subplot.map;
  
      for(var i = ORDER.length - 1; i >= 0; i--) {
          var k = ORDER[i];
          map.removeLayer(this.layerIds[k]);
          map.removeSource(this.sourceIds[k]);
      }
  };
  
  module.exports = function createScatterMapbox(subplot, calcTrace) {
      var trace = calcTrace[0].trace;
      var scatterMapbox = new ScatterMapbox(subplot, trace.uid);
      var optsAll = convert(subplot.gd, calcTrace);
      var below = scatterMapbox.below = subplot.belowLookup['trace-' + trace.uid];
  
      for(var i = 0; i < ORDER.length; i++) {
          var k = ORDER[i];
          var opts = optsAll[k];
          scatterMapbox.addSource(k, opts);
          scatterMapbox.addLayer(k, opts, below);
      }
  
      // link ref for quick update during selections
      calcTrace[0].trace._glTrace = scatterMapbox;
  
      return scatterMapbox;
  };
  
  },{"../../plots/mapbox/constants":854,"./convert":1224}],1231:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var subtypes = _dereq_('../scatter/subtypes');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  module.exports = function selectPoints(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var xa = searchInfo.xaxis;
      var ya = searchInfo.yaxis;
      var selection = [];
      var trace = cd[0].trace;
      var i;
  
      if(!subtypes.hasMarkers(trace)) return [];
  
      if(selectionTester === false) {
          for(i = 0; i < cd.length; i++) {
              cd[i].selected = 0;
          }
      } else {
          for(i = 0; i < cd.length; i++) {
              var di = cd[i];
              var lonlat = di.lonlat;
  
              if(lonlat[0] !== BADNUM) {
                  var lonlat2 = [Lib.modHalf(lonlat[0], 360), lonlat[1]];
                  var xy = [xa.c2p(lonlat2), ya.c2p(lonlat2)];
  
                  if(selectionTester.contains(xy, null, i, searchInfo)) {
                      selection.push({
                          pointNumber: i,
                          lon: lonlat[0],
                          lat: lonlat[1]
                      });
                      di.selected = 1;
                  } else {
                      di.selected = 0;
                  }
              }
          }
      }
  
      return selection;
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"../scatter/subtypes":1183}],1232:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var scatterAttrs = _dereq_('../scatter/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var lineAttrs = scatterAttrs.line;
  
  module.exports = {
      mode: scatterAttrs.mode,
  
      r: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
  
      theta: {
          valType: 'data_array',
          editType: 'calc+clearAxisTypes',
          
      },
  
      r0: {
          valType: 'any',
          dflt: 0,
          
          editType: 'calc+clearAxisTypes',
          
      },
      dr: {
          valType: 'number',
          dflt: 1,
          
          editType: 'calc',
          
      },
  
      theta0: {
          valType: 'any',
          dflt: 0,
          
          editType: 'calc+clearAxisTypes',
          
      },
      dtheta: {
          valType: 'number',
          
          editType: 'calc',
          
      },
  
      thetaunit: {
          valType: 'enumerated',
          values: ['radians', 'degrees', 'gradians'],
          dflt: 'degrees',
          
          editType: 'calc+clearAxisTypes',
          
      },
  
      text: scatterAttrs.text,
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: ['r', 'theta', 'text']
      }),
      hovertext: scatterAttrs.hovertext,
  
      line: {
          color: lineAttrs.color,
          width: lineAttrs.width,
          dash: lineAttrs.dash,
          shape: extendFlat({}, lineAttrs.shape, {
              values: ['linear', 'spline']
          }),
          smoothing: lineAttrs.smoothing,
          editType: 'calc'
      },
      connectgaps: scatterAttrs.connectgaps,
  
      marker: scatterAttrs.marker,
      cliponaxis: extendFlat({}, scatterAttrs.cliponaxis, {dflt: false}),
  
      textposition: scatterAttrs.textposition,
      textfont: scatterAttrs.textfont,
  
      fill: extendFlat({}, scatterAttrs.fill, {
          values: ['none', 'toself', 'tonext'],
          dflt: 'none',
          
      }),
      fillcolor: scatterAttrs.fillcolor,
  
      // TODO error bars
      // https://stackoverflow.com/a/26597487/4068492
      // error_x (error_r, error_theta)
      // error_y
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['r', 'theta', 'text', 'name']
      }),
      hoveron: scatterAttrs.hoveron,
      hovertemplate: hovertemplateAttrs(),
  
      selected: scatterAttrs.selected,
      unselected: scatterAttrs.unselected
  };
  
  },{"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../scatter/attributes":1158}],1233:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  var calcColorscale = _dereq_('../scatter/colorscale_calc');
  var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
  var calcSelection = _dereq_('../scatter/calc_selection');
  var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
  
  module.exports = function calc(gd, trace) {
      var fullLayout = gd._fullLayout;
      var subplotId = trace.subplot;
      var radialAxis = fullLayout[subplotId].radialaxis;
      var angularAxis = fullLayout[subplotId].angularaxis;
      var rArray = radialAxis.makeCalcdata(trace, 'r');
      var thetaArray = angularAxis.makeCalcdata(trace, 'theta');
      var len = trace._length;
      var cd = new Array(len);
  
      for(var i = 0; i < len; i++) {
          var r = rArray[i];
          var theta = thetaArray[i];
          var cdi = cd[i] = {};
  
          if(isNumeric(r) && isNumeric(theta)) {
              cdi.r = r;
              cdi.theta = theta;
          } else {
              cdi.r = BADNUM;
          }
      }
  
      var ppad = calcMarkerSize(trace, len);
      trace._extremes.x = Axes.findExtremes(radialAxis, rArray, {ppad: ppad});
  
      calcColorscale(gd, trace);
      arraysToCalcdata(cd, trace);
      calcSelection(cd, trace);
  
      return cd;
  };
  
  },{"../../constants/numerical":725,"../../plots/cartesian/axes":799,"../scatter/arrays_to_calcdata":1157,"../scatter/calc":1159,"../scatter/calc_selection":1160,"../scatter/colorscale_calc":1161,"fast-isnumeric":241}],1234:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var subTypes = _dereq_('../scatter/subtypes');
  var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
  var handleLineDefaults = _dereq_('../scatter/line_defaults');
  var handleLineShapeDefaults = _dereq_('../scatter/line_shape_defaults');
  var handleTextDefaults = _dereq_('../scatter/text_defaults');
  var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
  var PTS_LINESONLY = _dereq_('../scatter/constants').PTS_LINESONLY;
  
  var attributes = _dereq_('./attributes');
  
  function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      coerce('thetaunit');
      coerce('mode', len < PTS_LINESONLY ? 'lines+markers' : 'lines');
      coerce('text');
      coerce('hovertext');
      if(traceOut.hoveron !== 'fills') coerce('hovertemplate');
  
      if(subTypes.hasLines(traceOut)) {
          handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
          handleLineShapeDefaults(traceIn, traceOut, coerce);
          coerce('connectgaps');
      }
  
      if(subTypes.hasMarkers(traceOut)) {
          handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
      }
  
      if(subTypes.hasText(traceOut)) {
          coerce('texttemplate');
          handleTextDefaults(traceIn, traceOut, layout, coerce);
      }
  
      var dfltHoverOn = [];
  
      if(subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
          coerce('cliponaxis');
          coerce('marker.maxdisplayed');
          dfltHoverOn.push('points');
      }
  
      coerce('fill');
  
      if(traceOut.fill !== 'none') {
          handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
          if(!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
      }
  
      if(traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
          dfltHoverOn.push('fills');
      }
      coerce('hoveron', dfltHoverOn.join('+') || 'points');
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  }
  
  function handleRThetaDefaults(traceIn, traceOut, layout, coerce) {
      var r = coerce('r');
      var theta = coerce('theta');
      var len;
  
      if(r) {
          if(theta) {
              len = Math.min(r.length, theta.length);
          } else {
              len = r.length;
              coerce('theta0');
              coerce('dtheta');
          }
      } else {
          if(!theta) return 0;
          len = traceOut.theta.length;
          coerce('r0');
          coerce('dr');
      }
  
      traceOut._length = len;
      return len;
  }
  
  module.exports = {
      handleRThetaDefaults: handleRThetaDefaults,
      supplyDefaults: supplyDefaults
  };
  
  },{"../../lib":750,"../scatter/constants":1162,"../scatter/fillcolor_defaults":1166,"../scatter/line_defaults":1171,"../scatter/line_shape_defaults":1173,"../scatter/marker_defaults":1177,"../scatter/subtypes":1183,"../scatter/text_defaults":1184,"./attributes":1232}],1235:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  module.exports = function formatLabels(cdi, trace, fullLayout) {
      var labels = {};
  
      var subplot = fullLayout[trace.subplot]._subplot;
      var radialAxis;
      var angularAxis;
  
      // for scatterpolargl texttemplate, _subplot is NOT defined, this takes part during the convert step
      // TODO we should consider moving the texttemplate formatting logic to the plot step
      if(!subplot) {
          subplot = fullLayout[trace.subplot];
          radialAxis = subplot.radialaxis;
          angularAxis = subplot.angularaxis;
      } else {
          radialAxis = subplot.radialAxis;
          angularAxis = subplot.angularAxis;
      }
  
      var rVal = radialAxis.c2l(cdi.r);
      labels.rLabel = Axes.tickText(radialAxis, rVal, true).text;
  
      // N.B here the ° sign is part of the formatted value for thetaunit:'degrees'
      var thetaVal = angularAxis.thetaunit === 'degrees' ? Lib.rad2deg(cdi.theta) : cdi.theta;
      labels.thetaLabel = Axes.tickText(angularAxis, thetaVal, true).text;
  
      return labels;
  };
  
  },{"../../lib":750,"../../plots/cartesian/axes":799}],1236:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterHover = _dereq_('../scatter/hover');
  
  function hoverPoints(pointData, xval, yval, hovermode) {
      var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
      if(!scatterPointData || scatterPointData[0].index === false) return;
  
      var newPointData = scatterPointData[0];
  
      // hovering on fill case
      if(newPointData.index === undefined) {
          return scatterPointData;
      }
  
      var subplot = pointData.subplot;
      var cdi = newPointData.cd[newPointData.index];
      var trace = newPointData.trace;
  
      if(!subplot.isPtInside(cdi)) return;
  
      newPointData.xLabelVal = undefined;
      newPointData.yLabelVal = undefined;
      makeHoverPointText(cdi, trace, subplot, newPointData);
      newPointData.hovertemplate = trace.hovertemplate;
      return scatterPointData;
  }
  
  function makeHoverPointText(cdi, trace, subplot, pointData) {
      var radialAxis = subplot.radialAxis;
      var angularAxis = subplot.angularAxis;
      radialAxis._hovertitle = 'r';
      angularAxis._hovertitle = 'θ';
  
      var fullLayout = {};
      fullLayout[trace.subplot] = {_subplot: subplot};
      var labels = trace._module.formatLabels(cdi, trace, fullLayout);
      pointData.rLabel = labels.rLabel;
      pointData.thetaLabel = labels.thetaLabel;
  
      var hoverinfo = cdi.hi || trace.hoverinfo;
      var text = [];
      function textPart(ax, val) {
          text.push(ax._hovertitle + ': ' + val);
      }
  
      if(!trace.hovertemplate) {
          var parts = hoverinfo.split('+');
  
          if(parts.indexOf('all') !== -1) parts = ['r', 'theta', 'text'];
          if(parts.indexOf('r') !== -1) textPart(radialAxis, pointData.rLabel);
          if(parts.indexOf('theta') !== -1) textPart(angularAxis, pointData.thetaLabel);
  
          if(parts.indexOf('text') !== -1 && pointData.text) {
              text.push(pointData.text);
              delete pointData.text;
          }
  
          pointData.extraText = text.join('<br>');
      }
  }
  
  module.exports = {
      hoverPoints: hoverPoints,
      makeHoverPointText: makeHoverPointText
  };
  
  },{"../scatter/hover":1169}],1237:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'scatterpolar',
      basePlotModule: _dereq_('../../plots/polar'),
      categories: ['polar', 'symbols', 'showLegend', 'scatter-like'],
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults').supplyDefaults,
      colorbar: _dereq_('../scatter/marker_colorbar'),
      formatLabels: _dereq_('./format_labels'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      style: _dereq_('../scatter/style').style,
      styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
      hoverPoints: _dereq_('./hover').hoverPoints,
      selectPoints: _dereq_('../scatter/select'),
  
      meta: {
          
          
      }
  };
  
  },{"../../plots/polar":865,"../scatter/marker_colorbar":1176,"../scatter/select":1180,"../scatter/style":1182,"./attributes":1232,"./calc":1233,"./defaults":1234,"./format_labels":1235,"./hover":1236,"./plot":1238}],1238:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterPlot = _dereq_('../scatter/plot');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  module.exports = function plot(gd, subplot, moduleCalcData) {
      var mlayer = subplot.layers.frontplot.select('g.scatterlayer');
  
      var plotinfo = {
          xaxis: subplot.xaxis,
          yaxis: subplot.yaxis,
          plot: subplot.framework,
          layerClipId: subplot._hasClipOnAxisFalse ? subplot.clipIds.forTraces : null
      };
  
      var radialAxis = subplot.radialAxis;
      var angularAxis = subplot.angularAxis;
  
      // convert:
      // 'c' (r,theta) -> 'geometric' (r,theta) -> (x,y)
      for(var i = 0; i < moduleCalcData.length; i++) {
          var cdi = moduleCalcData[i];
  
          for(var j = 0; j < cdi.length; j++) {
              var cd = cdi[j];
              var r = cd.r;
  
              if(r === BADNUM) {
                  cd.x = cd.y = BADNUM;
              } else {
                  var rg = radialAxis.c2g(r);
                  var thetag = angularAxis.c2g(cd.theta);
                  cd.x = rg * Math.cos(thetag);
                  cd.y = rg * Math.sin(thetag);
              }
          }
      }
  
      scatterPlot(gd, plotinfo, moduleCalcData, mlayer);
  };
  
  },{"../../constants/numerical":725,"../scatter/plot":1179}],1239:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterPolarAttrs = _dereq_('../scatterpolar/attributes');
  var scatterGlAttrs = _dereq_('../scattergl/attributes');
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  
  module.exports = {
      mode: scatterPolarAttrs.mode,
      r: scatterPolarAttrs.r,
      theta: scatterPolarAttrs.theta,
      r0: scatterPolarAttrs.r0,
      dr: scatterPolarAttrs.dr,
      theta0: scatterPolarAttrs.theta0,
      dtheta: scatterPolarAttrs.dtheta,
      thetaunit: scatterPolarAttrs.thetaunit,
  
      text: scatterPolarAttrs.text,
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: ['r', 'theta', 'text']
      }),
      hovertext: scatterPolarAttrs.hovertext,
      hovertemplate: scatterPolarAttrs.hovertemplate,
  
      line: scatterGlAttrs.line,
      connectgaps: scatterGlAttrs.connectgaps,
  
      marker: scatterGlAttrs.marker,
      // no cliponaxis
  
      fill: scatterGlAttrs.fill,
      fillcolor: scatterGlAttrs.fillcolor,
  
      textposition: scatterGlAttrs.textposition,
      textfont: scatterGlAttrs.textfont,
  
      hoverinfo: scatterPolarAttrs.hoverinfo,
      // no hoveron
  
      selected: scatterPolarAttrs.selected,
      unselected: scatterPolarAttrs.unselected
  };
  
  },{"../../plots/template_attributes":877,"../scattergl/attributes":1210,"../scatterpolar/attributes":1232}],1240:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var calcColorscale = _dereq_('../scatter/colorscale_calc');
  var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
  var convert = _dereq_('../scattergl/convert');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var TOO_MANY_POINTS = _dereq_('../scattergl/constants').TOO_MANY_POINTS;
  
  module.exports = function calc(gd, trace) {
      var fullLayout = gd._fullLayout;
      var subplotId = trace.subplot;
      var radialAxis = fullLayout[subplotId].radialaxis;
      var angularAxis = fullLayout[subplotId].angularaxis;
      var rArray = trace._r = radialAxis.makeCalcdata(trace, 'r');
      var thetaArray = trace._theta = angularAxis.makeCalcdata(trace, 'theta');
      var len = trace._length;
      var stash = {};
  
      if(len < rArray.length) rArray = rArray.slice(0, len);
      if(len < thetaArray.length) thetaArray = thetaArray.slice(0, len);
  
      stash.r = rArray;
      stash.theta = thetaArray;
  
      calcColorscale(gd, trace);
  
      // only compute 'style' options in calc, as position options
      // depend on the radial range and must be set in plot
      var opts = stash.opts = convert.style(gd, trace);
  
      // For graphs with very large number of points and array marker.size,
      // use average marker size instead to speed things up.
      var ppad;
      if(len < TOO_MANY_POINTS) {
          ppad = calcMarkerSize(trace, len);
      } else if(opts.marker) {
          ppad = 2 * (opts.marker.sizeAvg || Math.max(opts.marker.size, 3));
      }
      trace._extremes.x = Axes.findExtremes(radialAxis, rArray, {ppad: ppad});
  
      return [{x: false, y: false, t: stash, trace: trace}];
  };
  
  },{"../../plots/cartesian/axes":799,"../scatter/calc":1159,"../scatter/colorscale_calc":1161,"../scattergl/constants":1212,"../scattergl/convert":1213}],1241:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var subTypes = _dereq_('../scatter/subtypes');
  var handleRThetaDefaults = _dereq_('../scatterpolar/defaults').handleRThetaDefaults;
  var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
  var handleLineDefaults = _dereq_('../scatter/line_defaults');
  var handleTextDefaults = _dereq_('../scatter/text_defaults');
  var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
  var PTS_LINESONLY = _dereq_('../scatter/constants').PTS_LINESONLY;
  
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleRThetaDefaults(traceIn, traceOut, layout, coerce);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      coerce('thetaunit');
      coerce('mode', len < PTS_LINESONLY ? 'lines+markers' : 'lines');
      coerce('text');
      coerce('hovertext');
      if(traceOut.hoveron !== 'fills') coerce('hovertemplate');
  
      if(subTypes.hasLines(traceOut)) {
          handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
          coerce('connectgaps');
      }
  
      if(subTypes.hasMarkers(traceOut)) {
          handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce);
      }
  
      if(subTypes.hasText(traceOut)) {
          coerce('texttemplate');
          handleTextDefaults(traceIn, traceOut, layout, coerce);
      }
  
      coerce('fill');
      if(traceOut.fill !== 'none') {
          handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
      }
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  },{"../../lib":750,"../scatter/constants":1162,"../scatter/fillcolor_defaults":1166,"../scatter/line_defaults":1171,"../scatter/marker_defaults":1177,"../scatter/subtypes":1183,"../scatter/text_defaults":1184,"../scatterpolar/defaults":1234,"./attributes":1239}],1242:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterPolarFormatLabels = _dereq_('../scatterpolar/format_labels');
  
  module.exports = function formatLabels(cdi, trace, fullLayout) {
      var i = cdi.i;
      if(!('r' in cdi)) cdi.r = trace._r[i];
      if(!('theta' in cdi)) cdi.theta = trace._theta[i];
      return scatterPolarFormatLabels(cdi, trace, fullLayout);
  };
  
  },{"../scatterpolar/format_labels":1235}],1243:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hover = _dereq_('../scattergl/hover');
  var makeHoverPointText = _dereq_('../scatterpolar/hover').makeHoverPointText;
  
  function hoverPoints(pointData, xval, yval, hovermode) {
      var cd = pointData.cd;
      var stash = cd[0].t;
      var rArray = stash.r;
      var thetaArray = stash.theta;
  
      var scatterPointData = hover.hoverPoints(pointData, xval, yval, hovermode);
      if(!scatterPointData || scatterPointData[0].index === false) return;
  
      var newPointData = scatterPointData[0];
  
      if(newPointData.index === undefined) {
          return scatterPointData;
      }
  
      var subplot = pointData.subplot;
      var cdi = newPointData.cd[newPointData.index];
      var trace = newPointData.trace;
  
      // augment pointData with r/theta param
      cdi.r = rArray[newPointData.index];
      cdi.theta = thetaArray[newPointData.index];
  
      if(!subplot.isPtInside(cdi)) return;
  
      newPointData.xLabelVal = undefined;
      newPointData.yLabelVal = undefined;
      makeHoverPointText(cdi, trace, subplot, newPointData);
  
      return scatterPointData;
  }
  
  module.exports = {
      hoverPoints: hoverPoints
  };
  
  },{"../scattergl/hover":1218,"../scatterpolar/hover":1236}],1244:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'scatterpolargl',
      basePlotModule: _dereq_('../../plots/polar'),
      categories: ['gl', 'regl', 'polar', 'symbols', 'showLegend', 'scatter-like'],
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../scatter/marker_colorbar'),
      formatLabels: _dereq_('./format_labels'),
  
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      hoverPoints: _dereq_('./hover').hoverPoints,
      selectPoints: _dereq_('../scattergl/select'),
  
      meta: {
          
          
      }
  };
  
  },{"../../plots/polar":865,"../scatter/marker_colorbar":1176,"../scattergl/select":1222,"./attributes":1239,"./calc":1240,"./defaults":1241,"./format_labels":1242,"./hover":1243,"./plot":1245}],1245:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var cluster = _dereq_('@plotly/point-cluster');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var scatterglPlot = _dereq_('../scattergl/plot');
  var sceneUpdate = _dereq_('../scattergl/scene_update');
  var convert = _dereq_('../scattergl/convert');
  
  var Lib = _dereq_('../../lib');
  
  var TOO_MANY_POINTS = _dereq_('../scattergl/constants').TOO_MANY_POINTS;
  
  module.exports = function plot(gd, subplot, cdata) {
      if(!cdata.length) return;
  
      var radialAxis = subplot.radialAxis;
      var angularAxis = subplot.angularAxis;
      var scene = sceneUpdate(gd, subplot);
  
      cdata.forEach(function(cdscatter) {
          if(!cdscatter || !cdscatter[0] || !cdscatter[0].trace) return;
          var cd = cdscatter[0];
          var trace = cd.trace;
          var stash = cd.t;
          var len = trace._length;
          var rArray = stash.r;
          var thetaArray = stash.theta;
          var opts = stash.opts;
          var i;
  
          var subRArray = rArray.slice();
          var subThetaArray = thetaArray.slice();
  
          // filter out by range
          for(i = 0; i < rArray.length; i++) {
              if(!subplot.isPtInside({r: rArray[i], theta: thetaArray[i]})) {
                  subRArray[i] = NaN;
                  subThetaArray[i] = NaN;
              }
          }
  
          var positions = new Array(len * 2);
          var x = Array(len);
          var y = Array(len);
  
          for(i = 0; i < len; i++) {
              var r = subRArray[i];
              var xx, yy;
  
              if(isNumeric(r)) {
                  var rg = radialAxis.c2g(r);
                  var thetag = angularAxis.c2g(subThetaArray[i], trace.thetaunit);
                  xx = rg * Math.cos(thetag);
                  yy = rg * Math.sin(thetag);
              } else {
                  xx = yy = NaN;
              }
              x[i] = positions[i * 2] = xx;
              y[i] = positions[i * 2 + 1] = yy;
          }
  
          stash.tree = cluster(positions);
  
          // FIXME: see scattergl.js#109
          if(opts.marker && len >= TOO_MANY_POINTS) {
              opts.marker.cluster = stash.tree;
          }
  
          if(opts.marker) {
              opts.markerSel.positions = opts.markerUnsel.positions = opts.marker.positions = positions;
          }
  
          if(opts.line && positions.length > 1) {
              Lib.extendFlat(
                  opts.line,
                  convert.linePositions(gd, trace, positions)
              );
          }
  
          if(opts.text) {
              Lib.extendFlat(
                  opts.text,
                  {positions: positions},
                  convert.textPosition(gd, trace, opts.text, opts.marker)
              );
              Lib.extendFlat(
                  opts.textSel,
                  {positions: positions},
                  convert.textPosition(gd, trace, opts.text, opts.markerSel)
              );
              Lib.extendFlat(
                  opts.textUnsel,
                  {positions: positions},
                  convert.textPosition(gd, trace, opts.text, opts.markerUnsel)
              );
          }
  
          if(opts.fill && !scene.fill2d) scene.fill2d = true;
          if(opts.marker && !scene.scatter2d) scene.scatter2d = true;
          if(opts.line && !scene.line2d) scene.line2d = true;
          if(opts.text && !scene.glText) scene.glText = true;
  
          scene.lineOptions.push(opts.line);
          scene.fillOptions.push(opts.fill);
          scene.markerOptions.push(opts.marker);
          scene.markerSelectedOptions.push(opts.markerSel);
          scene.markerUnselectedOptions.push(opts.markerUnsel);
          scene.textOptions.push(opts.text);
          scene.textSelectedOptions.push(opts.textSel);
          scene.textUnselectedOptions.push(opts.textUnsel);
          scene.selectBatch.push([]);
          scene.unselectBatch.push([]);
  
          stash.x = x;
          stash.y = y;
          stash.rawx = x;
          stash.rawy = y;
          stash.r = rArray;
          stash.theta = thetaArray;
          stash.positions = positions;
          stash._scene = scene;
          stash.index = scene.count;
          scene.count++;
      });
  
      return scatterglPlot(gd, subplot, cdata);
  };
  
  },{"../../lib":750,"../scattergl/constants":1212,"../scattergl/convert":1213,"../scattergl/plot":1220,"../scattergl/scene_update":1221,"@plotly/point-cluster":57,"fast-isnumeric":241}],1246:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var scatterAttrs = _dereq_('../scatter/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var dash = _dereq_('../../components/drawing/attributes').dash;
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var scatterMarkerAttrs = scatterAttrs.marker;
  var scatterLineAttrs = scatterAttrs.line;
  var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
  
  module.exports = {
      a: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      b: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      c: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      sum: {
          valType: 'number',
          
          dflt: 0,
          min: 0,
          editType: 'calc',
          
      },
      mode: extendFlat({}, scatterAttrs.mode, {dflt: 'markers'}),
      text: extendFlat({}, scatterAttrs.text, {
          
      }),
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: ['a', 'b', 'c', 'text']
      }),
      hovertext: extendFlat({}, scatterAttrs.hovertext, {
          
      }),
      line: {
          color: scatterLineAttrs.color,
          width: scatterLineAttrs.width,
          dash: dash,
          shape: extendFlat({}, scatterLineAttrs.shape,
              {values: ['linear', 'spline']}),
          smoothing: scatterLineAttrs.smoothing,
          editType: 'calc'
      },
      connectgaps: scatterAttrs.connectgaps,
      cliponaxis: scatterAttrs.cliponaxis,
      fill: extendFlat({}, scatterAttrs.fill, {
          values: ['none', 'toself', 'tonext'],
          dflt: 'none',
          
      }),
      fillcolor: scatterAttrs.fillcolor,
      marker: extendFlat({
          symbol: scatterMarkerAttrs.symbol,
          opacity: scatterMarkerAttrs.opacity,
          maxdisplayed: scatterMarkerAttrs.maxdisplayed,
          size: scatterMarkerAttrs.size,
          sizeref: scatterMarkerAttrs.sizeref,
          sizemin: scatterMarkerAttrs.sizemin,
          sizemode: scatterMarkerAttrs.sizemode,
          line: extendFlat({
              width: scatterMarkerLineAttrs.width,
              editType: 'calc'
          },
              colorScaleAttrs('marker.line')
          ),
          gradient: scatterMarkerAttrs.gradient,
          editType: 'calc'
      },
          colorScaleAttrs('marker')
      ),
  
      textfont: scatterAttrs.textfont,
      textposition: scatterAttrs.textposition,
  
      selected: scatterAttrs.selected,
      unselected: scatterAttrs.unselected,
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['a', 'b', 'c', 'text', 'name']
      }),
      hoveron: scatterAttrs.hoveron,
      hovertemplate: hovertemplateAttrs(),
  };
  
  },{"../../components/colorscale/attributes":622,"../../components/drawing/attributes":636,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../scatter/attributes":1158}],1247:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var isNumeric = _dereq_('fast-isnumeric');
  
  var calcColorscale = _dereq_('../scatter/colorscale_calc');
  var arraysToCalcdata = _dereq_('../scatter/arrays_to_calcdata');
  var calcSelection = _dereq_('../scatter/calc_selection');
  var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
  
  var dataArrays = ['a', 'b', 'c'];
  var arraysToFill = {a: ['b', 'c'], b: ['a', 'c'], c: ['a', 'b']};
  
  module.exports = function calc(gd, trace) {
      var ternary = gd._fullLayout[trace.subplot];
      var displaySum = ternary.sum;
      var normSum = trace.sum || displaySum;
      var arrays = {a: trace.a, b: trace.b, c: trace.c};
  
      var i, j, dataArray, newArray, fillArray1, fillArray2;
  
      // fill in one missing component
      for(i = 0; i < dataArrays.length; i++) {
          dataArray = dataArrays[i];
          if(arrays[dataArray]) continue;
  
          fillArray1 = arrays[arraysToFill[dataArray][0]];
          fillArray2 = arrays[arraysToFill[dataArray][1]];
          newArray = new Array(fillArray1.length);
          for(j = 0; j < fillArray1.length; j++) {
              newArray[j] = normSum - fillArray1[j] - fillArray2[j];
          }
          arrays[dataArray] = newArray;
      }
  
      // make the calcdata array
      var serieslen = trace._length;
      var cd = new Array(serieslen);
      var a, b, c, norm, x, y;
      for(i = 0; i < serieslen; i++) {
          a = arrays.a[i];
          b = arrays.b[i];
          c = arrays.c[i];
          if(isNumeric(a) && isNumeric(b) && isNumeric(c)) {
              a = +a;
              b = +b;
              c = +c;
              norm = displaySum / (a + b + c);
              if(norm !== 1) {
                  a *= norm;
                  b *= norm;
                  c *= norm;
              }
              // map a, b, c onto x and y where the full scale of y
              // is [0, sum], and x is [-sum, sum]
              // TODO: this makes `a` always the top, `b` the bottom left,
              // and `c` the bottom right. Do we want options to rearrange
              // these?
              y = a;
              x = c - b;
              cd[i] = {x: x, y: y, a: a, b: b, c: c};
          } else cd[i] = {x: false, y: false};
      }
  
      calcMarkerSize(trace, serieslen);
      calcColorscale(gd, trace);
      arraysToCalcdata(cd, trace);
      calcSelection(cd, trace);
  
      return cd;
  };
  
  },{"../scatter/arrays_to_calcdata":1157,"../scatter/calc":1159,"../scatter/calc_selection":1160,"../scatter/colorscale_calc":1161,"fast-isnumeric":241}],1248:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var constants = _dereq_('../scatter/constants');
  var subTypes = _dereq_('../scatter/subtypes');
  var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
  var handleLineDefaults = _dereq_('../scatter/line_defaults');
  var handleLineShapeDefaults = _dereq_('../scatter/line_shape_defaults');
  var handleTextDefaults = _dereq_('../scatter/text_defaults');
  var handleFillColorDefaults = _dereq_('../scatter/fillcolor_defaults');
  
  var attributes = _dereq_('./attributes');
  
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var a = coerce('a');
      var b = coerce('b');
      var c = coerce('c');
      var len;
  
      // allow any one array to be missing, len is the minimum length of those
      // present. Note that after coerce data_array's are either Arrays (which
      // are truthy even if empty) or undefined. As in scatter, an empty array
      // is different from undefined, because it can signify that this data is
      // not known yet but expected in the future
      if(a) {
          len = a.length;
          if(b) {
              len = Math.min(len, b.length);
              if(c) len = Math.min(len, c.length);
          } else if(c) len = Math.min(len, c.length);
          else len = 0;
      } else if(b && c) {
          len = Math.min(b.length, c.length);
      }
  
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      traceOut._length = len;
  
      coerce('sum');
  
      coerce('text');
      coerce('hovertext');
      if(traceOut.hoveron !== 'fills') coerce('hovertemplate');
  
      var defaultMode = len < constants.PTS_LINESONLY ? 'lines+markers' : 'lines';
      coerce('mode', defaultMode);
  
      if(subTypes.hasLines(traceOut)) {
          handleLineDefaults(traceIn, traceOut, defaultColor, layout, coerce);
          handleLineShapeDefaults(traceIn, traceOut, coerce);
          coerce('connectgaps');
      }
  
      if(subTypes.hasMarkers(traceOut)) {
          handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce, {gradient: true});
      }
  
      if(subTypes.hasText(traceOut)) {
          coerce('texttemplate');
          handleTextDefaults(traceIn, traceOut, layout, coerce);
      }
  
      var dfltHoverOn = [];
  
      if(subTypes.hasMarkers(traceOut) || subTypes.hasText(traceOut)) {
          coerce('cliponaxis');
          coerce('marker.maxdisplayed');
          dfltHoverOn.push('points');
      }
  
      coerce('fill');
      if(traceOut.fill !== 'none') {
          handleFillColorDefaults(traceIn, traceOut, defaultColor, coerce);
          if(!subTypes.hasLines(traceOut)) handleLineShapeDefaults(traceIn, traceOut, coerce);
      }
  
      if(traceOut.fill === 'tonext' || traceOut.fill === 'toself') {
          dfltHoverOn.push('fills');
      }
      coerce('hoveron', dfltHoverOn.join('+') || 'points');
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  },{"../../lib":750,"../scatter/constants":1162,"../scatter/fillcolor_defaults":1166,"../scatter/line_defaults":1171,"../scatter/line_shape_defaults":1173,"../scatter/marker_defaults":1177,"../scatter/subtypes":1183,"../scatter/text_defaults":1184,"./attributes":1246}],1249:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt, trace, cd, pointNumber) {
      if(pt.xa) out.xaxis = pt.xa;
      if(pt.ya) out.yaxis = pt.ya;
  
      if(cd[pointNumber]) {
          var cdi = cd[pointNumber];
  
          // N.B. These are the normalized coordinates.
          out.a = cdi.a;
          out.b = cdi.b;
          out.c = cdi.c;
      } else {
          // for fill-hover only
          out.a = pt.a;
          out.b = pt.b;
          out.c = pt.c;
      }
  
      return out;
  };
  
  },{}],1250:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  
  module.exports = function formatLabels(cdi, trace, fullLayout) {
      var labels = {};
  
      var subplot = fullLayout[trace.subplot]._subplot;
      labels.aLabel = Axes.tickText(subplot.aaxis, cdi.a, true).text;
      labels.bLabel = Axes.tickText(subplot.baxis, cdi.b, true).text;
      labels.cLabel = Axes.tickText(subplot.caxis, cdi.c, true).text;
  
      return labels;
  };
  
  },{"../../plots/cartesian/axes":799}],1251:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterHover = _dereq_('../scatter/hover');
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
      var scatterPointData = scatterHover(pointData, xval, yval, hovermode);
      if(!scatterPointData || scatterPointData[0].index === false) return;
  
      var newPointData = scatterPointData[0];
  
      // if hovering on a fill, we don't show any point data so the label is
      // unchanged from what scatter gives us - except that it needs to
      // be constrained to the trianglular plot area, not just the rectangular
      // area defined by the synthetic x and y axes
      // TODO: in some cases the vertical middle of the shape is not within
      // the triangular viewport at all, so the label can become disconnected
      // from the shape entirely. But calculating what portion of the shape
      // is actually visible, as constrained by the diagonal axis lines, is not
      // so easy and anyway we lost the information we would have needed to do
      // this inside scatterHover.
      if(newPointData.index === undefined) {
          var yFracUp = 1 - (newPointData.y0 / pointData.ya._length);
          var xLen = pointData.xa._length;
          var xMin = xLen * yFracUp / 2;
          var xMax = xLen - xMin;
          newPointData.x0 = Math.max(Math.min(newPointData.x0, xMax), xMin);
          newPointData.x1 = Math.max(Math.min(newPointData.x1, xMax), xMin);
          return scatterPointData;
      }
  
      var cdi = newPointData.cd[newPointData.index];
      var trace = newPointData.trace;
      var subplot = newPointData.subplot;
  
      newPointData.a = cdi.a;
      newPointData.b = cdi.b;
      newPointData.c = cdi.c;
  
      newPointData.xLabelVal = undefined;
      newPointData.yLabelVal = undefined;
  
      var fullLayout = {};
      fullLayout[trace.subplot] = {_subplot: subplot};
      var labels = trace._module.formatLabels(cdi, trace, fullLayout);
      newPointData.aLabel = labels.aLabel;
      newPointData.bLabel = labels.bLabel;
      newPointData.cLabel = labels.cLabel;
  
      var hoverinfo = cdi.hi || trace.hoverinfo;
      var text = [];
      function textPart(ax, val) {
          text.push(ax._hovertitle + ': ' + val);
      }
      if(!trace.hovertemplate) {
          var parts = hoverinfo.split('+');
          if(parts.indexOf('all') !== -1) parts = ['a', 'b', 'c'];
          if(parts.indexOf('a') !== -1) textPart(subplot.aaxis, newPointData.aLabel);
          if(parts.indexOf('b') !== -1) textPart(subplot.baxis, newPointData.bLabel);
          if(parts.indexOf('c') !== -1) textPart(subplot.caxis, newPointData.cLabel);
      }
      newPointData.extraText = text.join('<br>');
      newPointData.hovertemplate = trace.hovertemplate;
      return scatterPointData;
  };
  
  },{"../scatter/hover":1169}],1252:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../scatter/marker_colorbar'),
      formatLabels: _dereq_('./format_labels'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      style: _dereq_('../scatter/style').style,
      styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
      hoverPoints: _dereq_('./hover'),
      selectPoints: _dereq_('../scatter/select'),
      eventData: _dereq_('./event_data'),
  
      moduleType: 'trace',
      name: 'scatterternary',
      basePlotModule: _dereq_('../../plots/ternary'),
      categories: ['ternary', 'symbols', 'showLegend', 'scatter-like'],
      meta: {
          
          
      }
  };
  
  },{"../../plots/ternary":878,"../scatter/marker_colorbar":1176,"../scatter/select":1180,"../scatter/style":1182,"./attributes":1246,"./calc":1247,"./defaults":1248,"./event_data":1249,"./format_labels":1250,"./hover":1251,"./plot":1253}],1253:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var scatterPlot = _dereq_('../scatter/plot');
  
  module.exports = function plot(gd, ternary, moduleCalcData) {
      var plotContainer = ternary.plotContainer;
  
      // remove all nodes inside the scatter layer
      plotContainer.select('.scatterlayer').selectAll('*').remove();
  
      // mimic cartesian plotinfo
      var plotinfo = {
          xaxis: ternary.xaxis,
          yaxis: ternary.yaxis,
          plot: plotContainer,
          layerClipId: ternary._hasClipOnAxisFalse ? ternary.clipIdRelative : null
      };
  
      var scatterLayer = ternary.layers.frontplot.select('g.scatterlayer');
  
      scatterPlot(gd, plotinfo, moduleCalcData, scatterLayer);
  };
  
  },{"../scatter/plot":1179}],1254:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var scatterAttrs = _dereq_('../scatter/attributes');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var scatterGlAttrs = _dereq_('../scattergl/attributes');
  var cartesianIdRegex = _dereq_('../../plots/cartesian/constants').idRegex;
  var templatedArray = _dereq_('../../plot_api/plot_template').templatedArray;
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var scatterMarkerAttrs = scatterAttrs.marker;
  var scatterMarkerLineAttrs = scatterMarkerAttrs.line;
  
  var markerLineAttrs = extendFlat(colorScaleAttrs('marker.line', {editTypeOverride: 'calc'}), {
      width: extendFlat({}, scatterMarkerLineAttrs.width, {editType: 'calc'}),
      editType: 'calc'
  });
  
  var markerAttrs = extendFlat(colorScaleAttrs('marker'), {
      symbol: scatterMarkerAttrs.symbol,
      size: extendFlat({}, scatterMarkerAttrs.size, {editType: 'markerSize'}),
      sizeref: scatterMarkerAttrs.sizeref,
      sizemin: scatterMarkerAttrs.sizemin,
      sizemode: scatterMarkerAttrs.sizemode,
      opacity: scatterMarkerAttrs.opacity,
      colorbar: scatterMarkerAttrs.colorbar,
      line: markerLineAttrs,
      editType: 'calc'
  });
  
  markerAttrs.color.editType = markerAttrs.cmin.editType = markerAttrs.cmax.editType = 'style';
  
  function makeAxesValObject(axLetter) {
      return {
          valType: 'info_array',
          freeLength: true,
          
          editType: 'calc',
          items: {
              valType: 'subplotid',
              regex: cartesianIdRegex[axLetter],
              editType: 'plot'
          },
          
      };
  }
  
  module.exports = {
      dimensions: templatedArray('dimension', {
          visible: {
              valType: 'boolean',
              
              dflt: true,
              editType: 'calc',
              
          },
          label: {
              valType: 'string',
              
              editType: 'calc',
              
          },
          values: {
              valType: 'data_array',
              
              editType: 'calc+clearAxisTypes',
              
          },
  
          axis: {
              type: {
                  valType: 'enumerated',
                  values: ['linear', 'log', 'date', 'category'],
                  
                  editType: 'calc+clearAxisTypes',
                  
              },
  
              // TODO make 'true' the default in v2?
              matches: {
                  valType: 'boolean',
                  dflt: false,
                  
                  editType: 'calc',
                  
              },
  
              editType: 'calc+clearAxisTypes'
          },
  
          // TODO should add an attribute to pin down x only vars and y only vars
          // like https://seaborn.pydata.org/generated/seaborn.pairplot.html
          // x_vars and y_vars
  
          // maybe more axis defaulting option e.g. `showgrid: false`
  
          editType: 'calc+clearAxisTypes'
      }),
  
      // mode: {}, (only 'markers' for now)
  
      text: extendFlat({}, scatterGlAttrs.text, {
          
      }),
      hovertext: extendFlat({}, scatterGlAttrs.hovertext, {
          
      }),
  
      hovertemplate: hovertemplateAttrs(),
  
      marker: markerAttrs,
  
      xaxes: makeAxesValObject('x'),
      yaxes: makeAxesValObject('y'),
  
      diagonal: {
          visible: {
              valType: 'boolean',
              
              dflt: true,
              editType: 'calc',
              
          },
  
          // type: 'scattergl' | 'histogram' | 'box' | 'violin'
          // ...
          // more options
  
          editType: 'calc'
      },
  
      showupperhalf: {
          valType: 'boolean',
          
          dflt: true,
          editType: 'calc',
          
      },
      showlowerhalf: {
          valType: 'boolean',
          
          dflt: true,
          editType: 'calc',
          
      },
  
      selected: {
          marker: scatterGlAttrs.selected.marker,
          editType: 'calc'
      },
      unselected: {
          marker: scatterGlAttrs.unselected.marker,
          editType: 'calc'
      },
  
      opacity: scatterGlAttrs.opacity
  };
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plot_api/plot_template":788,"../../plots/cartesian/constants":805,"../../plots/template_attributes":877,"../scatter/attributes":1158,"../scattergl/attributes":1210}],1255:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var createLine = _dereq_('regl-line2d');
  
  var Registry = _dereq_('../../registry');
  var prepareRegl = _dereq_('../../lib/prepare_regl');
  var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
  var Cartesian = _dereq_('../../plots/cartesian');
  var getFromId = _dereq_('../../plots/cartesian/axis_ids').getFromId;
  var shouldShowZeroLine = _dereq_('../../plots/cartesian/axes').shouldShowZeroLine;
  
  var SPLOM = 'splom';
  
  function plot(gd) {
      var fullLayout = gd._fullLayout;
      var _module = Registry.getModule(SPLOM);
      var splomCalcData = getModuleCalcData(gd.calcdata, _module)[0];
  
      var success = prepareRegl(gd, ['ANGLE_instanced_arrays', 'OES_element_index_uint']);
      if(!success) return;
  
      if(fullLayout._hasOnlyLargeSploms) {
          updateGrid(gd);
      }
  
      _module.plot(gd, {}, splomCalcData);
  }
  
  function drag(gd) {
      var cd = gd.calcdata;
      var fullLayout = gd._fullLayout;
  
      if(fullLayout._hasOnlyLargeSploms) {
          updateGrid(gd);
      }
  
      for(var i = 0; i < cd.length; i++) {
          var cd0 = cd[i][0];
          var trace = cd0.trace;
          var scene = fullLayout._splomScenes[trace.uid];
  
          if(trace.type === 'splom' && scene && scene.matrix) {
              dragOne(gd, trace, scene);
          }
      }
  }
  
  function dragOne(gd, trace, scene) {
      var visibleLength = scene.matrixOptions.data.length;
      var visibleDims = trace._visibleDims;
      var ranges = scene.viewOpts.ranges = new Array(visibleLength);
  
      for(var k = 0; k < visibleDims.length; k++) {
          var i = visibleDims[k];
          var rng = ranges[k] = new Array(4);
  
          var xa = getFromId(gd, trace._diag[i][0]);
          if(xa) {
              rng[0] = xa.r2l(xa.range[0]);
              rng[2] = xa.r2l(xa.range[1]);
          }
  
          var ya = getFromId(gd, trace._diag[i][1]);
          if(ya) {
              rng[1] = ya.r2l(ya.range[0]);
              rng[3] = ya.r2l(ya.range[1]);
          }
      }
  
      if(scene.selectBatch.length || scene.unselectBatch.length) {
          scene.matrix.update({ranges: ranges}, {ranges: ranges});
      } else {
          scene.matrix.update({ranges: ranges});
      }
  }
  
  function updateGrid(gd) {
      var fullLayout = gd._fullLayout;
      var regl = fullLayout._glcanvas.data()[0].regl;
      var splomGrid = fullLayout._splomGrid;
  
      if(!splomGrid) {
          splomGrid = fullLayout._splomGrid = createLine(regl);
      }
      splomGrid.update(makeGridData(gd));
  }
  
  function makeGridData(gd) {
      var fullLayout = gd._fullLayout;
      var gs = fullLayout._size;
      var fullView = [0, 0, fullLayout.width, fullLayout.height];
      var lookup = {};
      var k;
  
      function push(prefix, ax, x0, x1, y0, y1) {
          var lcolor = ax[prefix + 'color'];
          var lwidth = ax[prefix + 'width'];
          var key = String(lcolor + lwidth);
  
          if(key in lookup) {
              lookup[key].data.push(NaN, NaN, x0, x1, y0, y1);
          } else {
              lookup[key] = {
                  data: [x0, x1, y0, y1],
                  join: 'rect',
                  thickness: lwidth,
                  color: lcolor,
                  viewport: fullView,
                  range: fullView,
                  overlay: false
              };
          }
      }
  
      for(k in fullLayout._splomSubplots) {
          var sp = fullLayout._plots[k];
          var xa = sp.xaxis;
          var ya = sp.yaxis;
          var xVals = xa._gridVals;
          var yVals = ya._gridVals;
          // ya.l2p assumes top-to-bottom coordinate system (a la SVG),
          // we need to compute bottom-to-top offsets and slopes:
          var yOffset = gs.b + ya.domain[0] * gs.h;
          var ym = -ya._m;
          var yb = -ym * ya.r2l(ya.range[0], ya.calendar);
          var x, y;
  
          if(xa.showgrid) {
              for(k = 0; k < xVals.length; k++) {
                  x = xa._offset + xa.l2p(xVals[k].x);
                  push('grid', xa, x, yOffset, x, yOffset + ya._length);
              }
          }
          if(ya.showgrid) {
              for(k = 0; k < yVals.length; k++) {
                  y = yOffset + yb + ym * yVals[k].x;
                  push('grid', ya, xa._offset, y, xa._offset + xa._length, y);
              }
          }
          if(shouldShowZeroLine(gd, xa, ya)) {
              x = xa._offset + xa.l2p(0);
              push('zeroline', xa, x, yOffset, x, yOffset + ya._length);
          }
          if(shouldShowZeroLine(gd, ya, xa)) {
              y = yOffset + yb + 0;
              push('zeroline', ya, xa._offset, y, xa._offset + xa._length, y);
          }
      }
  
      var gridBatches = [];
      for(k in lookup) {
          gridBatches.push(lookup[k]);
      }
  
      return gridBatches;
  }
  
  function clean(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var lookup = {};
      var i;
  
      if(oldFullLayout._splomScenes) {
          for(i = 0; i < newFullData.length; i++) {
              var newTrace = newFullData[i];
              if(newTrace.type === 'splom') {
                  lookup[newTrace.uid] = 1;
              }
          }
          for(i = 0; i < oldFullData.length; i++) {
              var oldTrace = oldFullData[i];
              if(!lookup[oldTrace.uid]) {
                  var scene = oldFullLayout._splomScenes[oldTrace.uid];
                  if(scene && scene.destroy) scene.destroy();
                  // must first set scene to null in order to get garbage collected
                  oldFullLayout._splomScenes[oldTrace.uid] = null;
                  delete oldFullLayout._splomScenes[oldTrace.uid];
              }
          }
      }
  
      if(Object.keys(oldFullLayout._splomScenes || {}).length === 0) {
          delete oldFullLayout._splomScenes;
      }
  
      if(oldFullLayout._splomGrid &&
          (!newFullLayout._hasOnlyLargeSploms && oldFullLayout._hasOnlyLargeSploms)) {
          // must first set scene to null in order to get garbage collected
          oldFullLayout._splomGrid.destroy();
          oldFullLayout._splomGrid = null;
          delete oldFullLayout._splomGrid;
      }
  
      Cartesian.clean(newFullData, newFullLayout, oldFullData, oldFullLayout);
  }
  
  module.exports = {
      name: SPLOM,
      attr: Cartesian.attr,
      attrRegex: Cartesian.attrRegex,
      layoutAttributes: Cartesian.layoutAttributes,
      supplyLayoutDefaults: Cartesian.supplyLayoutDefaults,
      drawFramework: Cartesian.drawFramework,
      plot: plot,
      drag: drag,
      updateGrid: updateGrid,
      clean: clean,
      updateFx: Cartesian.updateFx,
      toSVG: Cartesian.toSVG
  };
  
  },{"../../lib/prepare_regl":763,"../../plots/cartesian":812,"../../plots/cartesian/axes":799,"../../plots/cartesian/axis_ids":802,"../../plots/get_data":836,"../../registry":882,"regl-line2d":509}],1256:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var AxisIDs = _dereq_('../../plots/cartesian/axis_ids');
  
  var calcMarkerSize = _dereq_('../scatter/calc').calcMarkerSize;
  var calcAxisExpansion = _dereq_('../scatter/calc').calcAxisExpansion;
  var calcColorscale = _dereq_('../scatter/colorscale_calc');
  var convertMarkerSelection = _dereq_('../scattergl/convert').markerSelection;
  var convertMarkerStyle = _dereq_('../scattergl/convert').markerStyle;
  var sceneUpdate = _dereq_('./scene_update');
  
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  var TOO_MANY_POINTS = _dereq_('../scattergl/constants').TOO_MANY_POINTS;
  
  module.exports = function calc(gd, trace) {
      var dimensions = trace.dimensions;
      var commonLength = trace._length;
      var opts = {};
      // 'c' for calculated, 'l' for linear,
      // only differ here for log axes, pass ldata to createMatrix as 'data'
      var cdata = opts.cdata = [];
      var ldata = opts.data = [];
      // keep track of visible dimensions
      var visibleDims = trace._visibleDims = [];
      var i, k, dim, xa, ya;
  
      function makeCalcdata(ax, dim) {
          // call makeCalcdata with fake input
          var ccol = ax.makeCalcdata({
              v: dim.values,
              vcalendar: trace.calendar
          }, 'v');
  
          for(var j = 0; j < ccol.length; j++) {
              ccol[j] = ccol[j] === BADNUM ? NaN : ccol[j];
          }
          cdata.push(ccol);
          ldata.push(ax.type === 'log' ? Lib.simpleMap(ccol, ax.c2l) : ccol);
      }
  
      for(i = 0; i < dimensions.length; i++) {
          dim = dimensions[i];
  
          if(dim.visible) {
              xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
              ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
  
              // if corresponding x & y axes don't have matching types, skip dim
              if(xa && ya && xa.type !== ya.type) {
                  Lib.log('Skipping splom dimension ' + i + ' with conflicting axis types');
                  continue;
              }
  
              if(xa) {
                  makeCalcdata(xa, dim);
                  if(ya && ya.type === 'category') {
                      ya._categories = xa._categories.slice();
                  }
              } else {
                  // should not make it here, if both xa and ya undefined
                  makeCalcdata(ya, dim);
              }
  
              visibleDims.push(i);
          }
      }
  
      calcColorscale(gd, trace);
      Lib.extendFlat(opts, convertMarkerStyle(trace));
  
      var visibleLength = cdata.length;
      var hasTooManyPoints = (visibleLength * commonLength) > TOO_MANY_POINTS;
  
      // Reuse SVG scatter axis expansion routine.
      // For graphs with very large number of points and array marker.size,
      // use average marker size instead to speed things up.
      var ppad;
      if(hasTooManyPoints) {
          ppad = 2 * (opts.sizeAvg || Math.max(opts.size, 3));
      } else {
          ppad = calcMarkerSize(trace, commonLength);
      }
  
      for(k = 0; k < visibleDims.length; k++) {
          i = visibleDims[k];
          dim = dimensions[i];
          xa = AxisIDs.getFromId(gd, trace._diag[i][0]) || {};
          ya = AxisIDs.getFromId(gd, trace._diag[i][1]) || {};
          calcAxisExpansion(gd, trace, xa, ya, cdata[k], cdata[k], ppad);
      }
  
      var scene = sceneUpdate(gd, trace);
      if(!scene.matrix) scene.matrix = true;
      scene.matrixOptions = opts;
  
      scene.selectedOptions = convertMarkerSelection(trace, trace.selected);
      scene.unselectedOptions = convertMarkerSelection(trace, trace.unselected);
  
      return [{x: false, y: false, t: {}, trace: trace}];
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/axis_ids":802,"../scatter/calc":1159,"../scatter/colorscale_calc":1161,"../scattergl/constants":1212,"../scattergl/convert":1213,"./scene_update":1263}],1257:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var handleArrayContainerDefaults = _dereq_('../../plots/array_container_defaults');
  
  var attributes = _dereq_('./attributes');
  var subTypes = _dereq_('../scatter/subtypes');
  var handleMarkerDefaults = _dereq_('../scatter/marker_defaults');
  var mergeLength = _dereq_('../parcoords/merge_length');
  var isOpenSymbol = _dereq_('../scattergl/helpers').isOpenSymbol;
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var dimensions = handleArrayContainerDefaults(traceIn, traceOut, {
          name: 'dimensions',
          handleItemDefaults: dimensionDefaults
      });
  
      var showDiag = coerce('diagonal.visible');
      var showUpper = coerce('showupperhalf');
      var showLower = coerce('showlowerhalf');
  
      var dimLength = mergeLength(traceOut, dimensions, 'values');
  
      if(!dimLength || (!showDiag && !showUpper && !showLower)) {
          traceOut.visible = false;
          return;
      }
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      handleMarkerDefaults(traceIn, traceOut, defaultColor, layout, coerce);
  
      var isOpen = isOpenSymbol(traceOut.marker.symbol);
      var isBubble = subTypes.isBubble(traceOut);
      coerce('marker.line.width', isOpen || isBubble ? 1 : 0);
  
      handleAxisDefaults(traceIn, traceOut, layout, coerce);
  
      Lib.coerceSelectionMarkerOpacity(traceOut, coerce);
  };
  
  function dimensionDefaults(dimIn, dimOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(dimIn, dimOut, attributes.dimensions, attr, dflt);
      }
  
      coerce('label');
      var values = coerce('values');
  
      if(!(values && values.length)) dimOut.visible = false;
      else coerce('visible');
  
      coerce('axis.type');
      coerce('axis.matches');
  }
  
  function handleAxisDefaults(traceIn, traceOut, layout, coerce) {
      var dimensions = traceOut.dimensions;
      var dimLength = dimensions.length;
      var showUpper = traceOut.showupperhalf;
      var showLower = traceOut.showlowerhalf;
      var showDiag = traceOut.diagonal.visible;
      var i, j;
  
      var xAxesDflt = new Array(dimLength);
      var yAxesDflt = new Array(dimLength);
  
      for(i = 0; i < dimLength; i++) {
          var suffix = i ? i + 1 : '';
          xAxesDflt[i] = 'x' + suffix;
          yAxesDflt[i] = 'y' + suffix;
      }
  
      var xaxes = coerce('xaxes', xAxesDflt);
      var yaxes = coerce('yaxes', yAxesDflt);
  
      // build list of [x,y] axis corresponding to each dimensions[i],
      // very useful for passing options to regl-splom
      var diag = traceOut._diag = new Array(dimLength);
  
      // lookup for 'drawn' x|y axes, to avoid costly indexOf downstream
      traceOut._xaxes = {};
      traceOut._yaxes = {};
  
      // list of 'drawn' x|y axes, use to generate list of subplots
      var xList = [];
      var yList = [];
  
      function fillAxisStashes(axId, counterAxId, dim, list) {
          if(!axId) return;
  
          var axLetter = axId.charAt(0);
          var stash = layout._splomAxes[axLetter];
  
          traceOut['_' + axLetter + 'axes'][axId] = 1;
          list.push(axId);
  
          if(!(axId in stash)) {
              var s = stash[axId] = {};
              if(dim) {
                  s.label = dim.label || '';
                  if(dim.visible && dim.axis) {
                      if(dim.axis.type) s.type = dim.axis.type;
                      if(dim.axis.matches) s.matches = counterAxId;
                  }
              }
          }
      }
  
      // cases where showDiag and showLower or showUpper are false
      // no special treatment as the 'drawn' x-axes and y-axes no longer match
      // the dimensions items and xaxes|yaxes 1-to-1
      var mustShiftX = !showDiag && !showLower;
      var mustShiftY = !showDiag && !showUpper;
  
      traceOut._axesDim = {};
      for(i = 0; i < dimLength; i++) {
          var dim = dimensions[i];
          var i0 = i === 0;
          var iN = i === dimLength - 1;
  
          var xaId = (i0 && mustShiftX) || (iN && mustShiftY) ?
              undefined :
              xaxes[i];
  
          var yaId = (i0 && mustShiftY) || (iN && mustShiftX) ?
              undefined :
              yaxes[i];
  
          fillAxisStashes(xaId, yaId, dim, xList);
          fillAxisStashes(yaId, xaId, dim, yList);
          diag[i] = [xaId, yaId];
          traceOut._axesDim[xaId] = i;
          traceOut._axesDim[yaId] = i;
      }
  
      // fill in splom subplot keys
      for(i = 0; i < xList.length; i++) {
          for(j = 0; j < yList.length; j++) {
              var id = xList[i] + yList[j];
  
              if(i > j && showUpper) {
                  layout._splomSubplots[id] = 1;
              } else if(i < j && showLower) {
                  layout._splomSubplots[id] = 1;
              } else if(i === j && (showDiag || !showLower || !showUpper)) {
                  // need to include diagonal subplots when
                  // hiding one half and the diagonal
                  layout._splomSubplots[id] = 1;
              }
          }
      }
  
      // when lower half is omitted, or when just the diagonal is gone,
      // override grid default to make sure axes remain on
      // the left/bottom of the plot area
      if(!showLower || (!showDiag && showUpper && showLower)) {
          layout._splomGridDflt.xside = 'bottom';
          layout._splomGridDflt.yside = 'left';
      }
  }
  
  },{"../../lib":750,"../../plots/array_container_defaults":794,"../parcoords/merge_length":1129,"../scatter/marker_defaults":1177,"../scatter/subtypes":1183,"../scattergl/helpers":1217,"./attributes":1254}],1258:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var calcColorscale = _dereq_('../scatter/colorscale_calc');
  var convertMarkerStyle = _dereq_('../scattergl/convert').markerStyle;
  
  module.exports = function editStyle(gd, cd0) {
      var trace = cd0.trace;
      var scene = gd._fullLayout._splomScenes[trace.uid];
  
      if(scene) {
          calcColorscale(gd, trace);
  
          Lib.extendFlat(scene.matrixOptions, convertMarkerStyle(trace));
          // TODO [un]selected styles?
  
          var opts = Lib.extendFlat({}, scene.matrixOptions, scene.viewOpts);
  
          // TODO this is too long for arrayOk attributes!
          scene.matrix.update(opts, null);
      }
  };
  
  },{"../../lib":750,"../scatter/colorscale_calc":1161,"../scattergl/convert":1213}],1259:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  exports.getDimIndex = function getDimIndex(trace, ax) {
      var axId = ax._id;
      var axLetter = axId.charAt(0);
      var ind = {x: 0, y: 1}[axLetter];
      var visibleDims = trace._visibleDims;
  
      for(var k = 0; k < visibleDims.length; k++) {
          var i = visibleDims[k];
          if(trace._diag[i][ind] === axId) return k;
      }
      return false;
  };
  
  },{}],1260:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var helpers = _dereq_('./helpers');
  var calcHover = _dereq_('../scattergl/hover').calcHover;
  
  function hoverPoints(pointData, xval, yval) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
      var scene = pointData.scene;
      var cdata = scene.matrixOptions.cdata;
      var xa = pointData.xa;
      var ya = pointData.ya;
      var xpx = xa.c2p(xval);
      var ypx = ya.c2p(yval);
      var maxDistance = pointData.distance;
  
      var xi = helpers.getDimIndex(trace, xa);
      var yi = helpers.getDimIndex(trace, ya);
      if(xi === false || yi === false) return [pointData];
  
      var x = cdata[xi];
      var y = cdata[yi];
  
      var id, dxy;
      var minDist = maxDistance;
  
      for(var i = 0; i < x.length; i++) {
          var ptx = x[i];
          var pty = y[i];
          var dx = xa.c2p(ptx) - xpx;
          var dy = ya.c2p(pty) - ypx;
          var dist = Math.sqrt(dx * dx + dy * dy);
  
          if(dist < minDist) {
              minDist = dxy = dist;
              id = i;
          }
      }
  
      pointData.index = id;
      pointData.distance = minDist;
      pointData.dxy = dxy;
  
      if(id === undefined) return [pointData];
  
      return [calcHover(pointData, x, y, trace)];
  }
  
  module.exports = {
      hoverPoints: hoverPoints
  };
  
  },{"../scattergl/hover":1218,"./helpers":1259}],1261:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Grid = _dereq_('../../components/grid');
  
  module.exports = {
      moduleType: 'trace',
      name: 'splom',
  
      basePlotModule: _dereq_('./base_plot'),
      categories: ['gl', 'regl', 'cartesian', 'symbols', 'showLegend', 'scatter-like'],
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: _dereq_('../scatter/marker_colorbar'),
  
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
      hoverPoints: _dereq_('./hover').hoverPoints,
      selectPoints: _dereq_('./select'),
      editStyle: _dereq_('./edit_style'),
  
      meta: {
          
      }
  };
  
  // splom traces use the 'grid' component to generate their axes,
  // register it here
  Registry.register(Grid);
  
  },{"../../components/grid":659,"../../registry":882,"../scatter/marker_colorbar":1176,"./attributes":1254,"./base_plot":1255,"./calc":1256,"./defaults":1257,"./edit_style":1258,"./hover":1260,"./plot":1262,"./select":1264}],1262:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var createMatrix = _dereq_('regl-splom');
  
  var Lib = _dereq_('../../lib');
  var AxisIDs = _dereq_('../../plots/cartesian/axis_ids');
  var selectMode = _dereq_('../../components/dragelement/helpers').selectMode;
  
  module.exports = function plot(gd, _, splomCalcData) {
      if(!splomCalcData.length) return;
  
      for(var i = 0; i < splomCalcData.length; i++) {
          plotOne(gd, splomCalcData[i][0]);
      }
  };
  
  function plotOne(gd, cd0) {
      var fullLayout = gd._fullLayout;
      var gs = fullLayout._size;
      var trace = cd0.trace;
      var stash = cd0.t;
      var scene = fullLayout._splomScenes[trace.uid];
      var matrixOpts = scene.matrixOptions;
      var cdata = matrixOpts.cdata;
      var regl = fullLayout._glcanvas.data()[0].regl;
      var dragmode = fullLayout.dragmode;
      var xa, ya;
      var i, j, k;
  
      if(cdata.length === 0) return;
  
      // augment options with proper upper/lower halves
      // regl-splom's default grid starts from bottom-left
      matrixOpts.lower = trace.showupperhalf;
      matrixOpts.upper = trace.showlowerhalf;
      matrixOpts.diagonal = trace.diagonal.visible;
  
      var visibleDims = trace._visibleDims;
      var visibleLength = cdata.length;
      var viewOpts = scene.viewOpts = {};
      viewOpts.ranges = new Array(visibleLength);
      viewOpts.domains = new Array(visibleLength);
  
      for(k = 0; k < visibleDims.length; k++) {
          i = visibleDims[k];
  
          var rng = viewOpts.ranges[k] = new Array(4);
          var dmn = viewOpts.domains[k] = new Array(4);
  
          xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
          if(xa) {
              rng[0] = xa._rl[0];
              rng[2] = xa._rl[1];
              dmn[0] = xa.domain[0];
              dmn[2] = xa.domain[1];
          }
  
          ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
          if(ya) {
              rng[1] = ya._rl[0];
              rng[3] = ya._rl[1];
              dmn[1] = ya.domain[0];
              dmn[3] = ya.domain[1];
          }
      }
  
      viewOpts.viewport = [gs.l, gs.b, gs.w + gs.l, gs.h + gs.b];
  
      if(scene.matrix === true) {
          scene.matrix = createMatrix(regl);
      }
  
      var clickSelectEnabled = fullLayout.clickmode.indexOf('select') > -1;
      var isSelectMode = selectMode(dragmode) ||
        !!trace.selectedpoints || clickSelectEnabled;
      var needsBaseUpdate = true;
  
      if(isSelectMode) {
          var commonLength = trace._length;
  
          // regenerate scene batch, if traces number changed during selection
          if(trace.selectedpoints) {
              scene.selectBatch = trace.selectedpoints;
  
              var selPts = trace.selectedpoints;
              var selDict = {};
              for(i = 0; i < selPts.length; i++) {
                  selDict[selPts[i]] = true;
              }
              var unselPts = [];
              for(i = 0; i < commonLength; i++) {
                  if(!selDict[i]) unselPts.push(i);
              }
              scene.unselectBatch = unselPts;
          }
  
          // precalculate px coords since we are not going to pan during select
          var xpx = stash.xpx = new Array(visibleLength);
          var ypx = stash.ypx = new Array(visibleLength);
  
          for(k = 0; k < visibleDims.length; k++) {
              i = visibleDims[k];
  
              xa = AxisIDs.getFromId(gd, trace._diag[i][0]);
              if(xa) {
                  xpx[k] = new Array(commonLength);
                  for(j = 0; j < commonLength; j++) {
                      xpx[k][j] = xa.c2p(cdata[k][j]);
                  }
              }
  
              ya = AxisIDs.getFromId(gd, trace._diag[i][1]);
              if(ya) {
                  ypx[k] = new Array(commonLength);
                  for(j = 0; j < commonLength; j++) {
                      ypx[k][j] = ya.c2p(cdata[k][j]);
                  }
              }
          }
  
          if(scene.selectBatch.length || scene.unselectBatch.length) {
              var unselOpts = Lib.extendFlat({}, matrixOpts, scene.unselectedOptions, viewOpts);
              var selOpts = Lib.extendFlat({}, matrixOpts, scene.selectedOptions, viewOpts);
              scene.matrix.update(unselOpts, selOpts);
              needsBaseUpdate = false;
          }
      } else {
          stash.xpx = stash.ypx = null;
      }
  
      if(needsBaseUpdate) {
          var opts = Lib.extendFlat({}, matrixOpts, viewOpts);
          scene.matrix.update(opts, null);
      }
  }
  
  },{"../../components/dragelement/helpers":633,"../../lib":750,"../../plots/cartesian/axis_ids":802,"regl-splom":511}],1263:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  module.exports = function sceneUpdate(gd, trace) {
      var fullLayout = gd._fullLayout;
      var uid = trace.uid;
  
      // must place ref to 'scene' in fullLayout, so that:
      // - it can be relinked properly on updates
      // - it can be destroyed properly when needed
      var splomScenes = fullLayout._splomScenes;
      if(!splomScenes) splomScenes = fullLayout._splomScenes = {};
  
      var reset = {
          dirty: true,
          selectBatch: [],
          unselectBatch: []
      };
  
      var first = {
          matrix: false,
          selectBatch: [],
          unselectBatch: []
      };
  
      var scene = splomScenes[trace.uid];
  
      if(!scene) {
          scene = splomScenes[uid] = Lib.extendFlat({}, reset, first);
  
          scene.draw = function draw() {
              if(scene.matrix && scene.matrix.draw) {
                  if(scene.selectBatch.length || scene.unselectBatch.length) {
                      scene.matrix.draw(scene.unselectBatch, scene.selectBatch);
                  } else {
                      scene.matrix.draw();
                  }
              }
  
              scene.dirty = false;
          };
  
          // remove scene resources
          scene.destroy = function destroy() {
              if(scene.matrix && scene.matrix.destroy) {
                  scene.matrix.destroy();
              }
              scene.matrixOptions = null;
              scene.selectBatch = null;
              scene.unselectBatch = null;
              scene = null;
          };
      }
  
      // In case if we have scene from the last calc - reset data
      if(!scene.dirty) {
          Lib.extendFlat(scene, reset);
      }
  
      return scene;
  };
  
  },{"../../lib":750}],1264:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var subTypes = _dereq_('../scatter/subtypes');
  var helpers = _dereq_('./helpers');
  
  module.exports = function select(searchInfo, selectionTester) {
      var cd = searchInfo.cd;
      var trace = cd[0].trace;
      var stash = cd[0].t;
      var scene = searchInfo.scene;
      var cdata = scene.matrixOptions.cdata;
      var xa = searchInfo.xaxis;
      var ya = searchInfo.yaxis;
      var selection = [];
  
      if(!scene) return selection;
  
      var hasOnlyLines = (!subTypes.hasMarkers(trace) && !subTypes.hasText(trace));
      if(trace.visible !== true || hasOnlyLines) return selection;
  
      var xi = helpers.getDimIndex(trace, xa);
      var yi = helpers.getDimIndex(trace, ya);
      if(xi === false || yi === false) return selection;
  
      var xpx = stash.xpx[xi];
      var ypx = stash.ypx[yi];
      var x = cdata[xi];
      var y = cdata[yi];
      var els = [];
      var unels = [];
  
      // degenerate polygon does not enable selection
      // filter out points by visible scatter ones
      if(selectionTester !== false && !selectionTester.degenerate) {
          for(var i = 0; i < x.length; i++) {
              if(selectionTester.contains([xpx[i], ypx[i]], null, i, searchInfo)) {
                  els.push(i);
                  selection.push({
                      pointNumber: i,
                      x: x[i],
                      y: y[i]
                  });
              } else {
                  unels.push(i);
              }
          }
      }
  
      var matrixOpts = scene.matrixOptions;
  
      if(!els.length && !unels.length) {
          scene.matrix.update(matrixOpts, null);
      } else if(!scene.selectBatch.length && !scene.unselectBatch.length) {
          scene.matrix.update(
              scene.unselectedOptions,
              Lib.extendFlat({}, matrixOpts, scene.selectedOptions, scene.viewOpts)
          );
      }
  
      scene.selectBatch = els;
      scene.unselectBatch = unels;
  
      return selection;
  };
  
  },{"../../lib":750,"../scatter/subtypes":1183,"./helpers":1259}],1265:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var mesh3dAttrs = _dereq_('../mesh3d/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  var attrs = {
      x: {
          valType: 'data_array',
          
          editType: 'calc+clearAxisTypes',
          
      },
      y: {
          valType: 'data_array',
          
          editType: 'calc+clearAxisTypes',
          
      },
      z: {
          valType: 'data_array',
          
          editType: 'calc+clearAxisTypes',
          
      },
  
      u: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      v: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      w: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      starts: {
          x: {
              valType: 'data_array',
              editType: 'calc',
              
          },
          y: {
              valType: 'data_array',
              editType: 'calc',
              
          },
          z: {
              valType: 'data_array',
              editType: 'calc',
              
          },
          editType: 'calc'
      },
  
      maxdisplayed: {
          valType: 'integer',
          min: 0,
          dflt: 1000,
          
          editType: 'calc',
          
      },
  
      // TODO
      //
      // Should add 'absolute' (like cone traces have), but currently gl-streamtube3d's
      // `absoluteTubeSize` doesn't behave well enough for our needs.
      //
      // 'fixed' would be a nice addition to plot stream 'lines', see
      // https://github.com/plotly/plotly.js/commit/812be20750e21e0a1831975001c248d365850f73#r29129877
      //
      // sizemode: {
      //     valType: 'enumerated',
      //     values: ['scaled', 'absolute', 'fixed'],
      //     dflt: 'scaled',
      //     
      //     editType: 'calc',
      //     
      // },
  
      sizeref: {
          valType: 'number',
          
          editType: 'calc',
          min: 0,
          dflt: 1,
          
      },
  
      text: {
          valType: 'string',
          
          dflt: '',
          editType: 'calc',
          
      },
      hovertext: {
          valType: 'string',
          
          dflt: '',
          editType: 'calc',
          
      },
      hovertemplate: hovertemplateAttrs({editType: 'calc'}, {
          keys: [
              'tubex', 'tubey', 'tubez',
              'tubeu', 'tubev', 'tubew',
              'norm', 'divergence'
          ]
      }),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
  };
  
  extendFlat(attrs, colorScaleAttrs('', {
      colorAttr: 'u/v/w norm',
      showScaleDflt: true,
      editTypeOverride: 'calc'
  }));
  
  var fromMesh3d = ['opacity', 'lightposition', 'lighting'];
  fromMesh3d.forEach(function(k) {
      attrs[k] = mesh3dAttrs[k];
  });
  
  attrs.hoverinfo = extendFlat({}, baseAttrs.hoverinfo, {
      editType: 'calc',
      flags: ['x', 'y', 'z', 'u', 'v', 'w', 'norm', 'divergence', 'text', 'name'],
      dflt: 'x+y+z+norm+text+name'
  });
  
  attrs.transforms = undefined;
  
  module.exports = attrs;
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../mesh3d/attributes":1099}],1266:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  
  function calc(gd, trace) {
      trace._len = Math.min(
          trace.u.length,
          trace.v.length,
          trace.w.length,
          trace.x.length,
          trace.y.length,
          trace.z.length
      );
  
      trace._u = filter(trace.u, trace._len);
      trace._v = filter(trace.v, trace._len);
      trace._w = filter(trace.w, trace._len);
      trace._x = filter(trace.x, trace._len);
      trace._y = filter(trace.y, trace._len);
      trace._z = filter(trace.z, trace._len);
  
      var grid = processGrid(trace);
      trace._gridFill = grid.fill;
      trace._Xs = grid.Xs;
      trace._Ys = grid.Ys;
      trace._Zs = grid.Zs;
      trace._len = grid.len;
  
      var slen = 0;
      var startx, starty, startz;
      if(trace.starts) {
          startx = filter(trace.starts.x || []);
          starty = filter(trace.starts.y || []);
          startz = filter(trace.starts.z || []);
          slen = Math.min(startx.length, starty.length, startz.length);
      }
      trace._startsX = startx || [];
      trace._startsY = starty || [];
      trace._startsZ = startz || [];
  
      var normMax = 0;
      var normMin = Infinity;
      var i;
      for(i = 0; i < trace._len; i++) {
          var u = trace._u[i];
          var v = trace._v[i];
          var w = trace._w[i];
          var norm = Math.sqrt(u * u + v * v + w * w);
  
          normMax = Math.max(normMax, norm);
          normMin = Math.min(normMin, norm);
      }
  
      colorscaleCalc(gd, trace, {
          vals: [normMin, normMax],
          containerStr: '',
          cLetter: 'c'
      });
  
      for(i = 0; i < slen; i++) {
          var sx = startx[i];
          grid.xMax = Math.max(grid.xMax, sx);
          grid.xMin = Math.min(grid.xMin, sx);
  
          var sy = starty[i];
          grid.yMax = Math.max(grid.yMax, sy);
          grid.yMin = Math.min(grid.yMin, sy);
  
          var sz = startz[i];
          grid.zMax = Math.max(grid.zMax, sz);
          grid.zMin = Math.min(grid.zMin, sz);
      }
  
      trace._slen = slen;
      trace._normMax = normMax;
      trace._xbnds = [grid.xMin, grid.xMax];
      trace._ybnds = [grid.yMin, grid.yMax];
      trace._zbnds = [grid.zMin, grid.zMax];
  }
  
  function processGrid(trace) {
      var x = trace._x;
      var y = trace._y;
      var z = trace._z;
      var len = trace._len;
  
      var i, j, k;
  
      var xMax = -Infinity;
      var xMin = Infinity;
      var yMax = -Infinity;
      var yMin = Infinity;
      var zMax = -Infinity;
      var zMin = Infinity;
  
      var gridFill = '';
      var filledX;
      var filledY;
      var filledZ;
      var firstX, lastX;
      var firstY, lastY;
      var firstZ, lastZ;
      if(len) {
          firstX = x[0];
          firstY = y[0];
          firstZ = z[0];
      }
      if(len > 1) {
          lastX = x[len - 1];
          lastY = y[len - 1];
          lastZ = z[len - 1];
      }
  
      for(i = 0; i < len; i++) {
          xMax = Math.max(xMax, x[i]);
          xMin = Math.min(xMin, x[i]);
  
          yMax = Math.max(yMax, y[i]);
          yMin = Math.min(yMin, y[i]);
  
          zMax = Math.max(zMax, z[i]);
          zMin = Math.min(zMin, z[i]);
  
          if(!filledX && x[i] !== firstX) {
              filledX = true;
              gridFill += 'x';
          }
          if(!filledY && y[i] !== firstY) {
              filledY = true;
              gridFill += 'y';
          }
          if(!filledZ && z[i] !== firstZ) {
              filledZ = true;
              gridFill += 'z';
          }
      }
      // fill if not filled - case of having dimension(s) with one item
      if(!filledX) gridFill += 'x';
      if(!filledY) gridFill += 'y';
      if(!filledZ) gridFill += 'z';
  
      var Xs = distinctVals(trace._x);
      var Ys = distinctVals(trace._y);
      var Zs = distinctVals(trace._z);
  
      gridFill = gridFill.replace('x', (firstX > lastX ? '-' : '+') + 'x');
      gridFill = gridFill.replace('y', (firstY > lastY ? '-' : '+') + 'y');
      gridFill = gridFill.replace('z', (firstZ > lastZ ? '-' : '+') + 'z');
  
      var empty = function() {
          len = 0;
          Xs = [];
          Ys = [];
          Zs = [];
      };
  
      // Over-specified mesh case, this would error in tube2mesh
      if(!len || len < Xs.length * Ys.length * Zs.length) empty();
  
      var getArray = function(c) { return c === 'x' ? x : c === 'y' ? y : z; };
      var getVals = function(c) { return c === 'x' ? Xs : c === 'y' ? Ys : Zs; };
      var getDir = function(c) { return c[len - 1] < c[0] ? -1 : 1; };
  
      var arrK = getArray(gridFill[1]);
      var arrJ = getArray(gridFill[3]);
      var arrI = getArray(gridFill[5]);
      var nk = getVals(gridFill[1]).length;
      var nj = getVals(gridFill[3]).length;
      var ni = getVals(gridFill[5]).length;
  
      var arbitrary = false;
  
      var getIndex = function(_i, _j, _k) {
          return nk * (nj * _i + _j) + _k;
      };
  
      var dirK = getDir(getArray(gridFill[1]));
      var dirJ = getDir(getArray(gridFill[3]));
      var dirI = getDir(getArray(gridFill[5]));
  
      for(i = 0; i < ni - 1; i++) {
          for(j = 0; j < nj - 1; j++) {
              for(k = 0; k < nk - 1; k++) {
                  var q000 = getIndex(i, j, k);
                  var q001 = getIndex(i, j, k + 1);
                  var q010 = getIndex(i, j + 1, k);
                  var q100 = getIndex(i + 1, j, k);
  
                  if(
                      !(arrK[q000] * dirK < arrK[q001] * dirK) ||
                      !(arrJ[q000] * dirJ < arrJ[q010] * dirJ) ||
                      !(arrI[q000] * dirI < arrI[q100] * dirI)
                  ) {
                      arbitrary = true;
                  }
  
                  if(arbitrary) break;
              }
              if(arbitrary) break;
          }
          if(arbitrary) break;
      }
  
      if(arbitrary) {
          Lib.warn('Encountered arbitrary coordinates! Unable to input data grid.');
          empty();
      }
  
      return {
          xMin: xMin,
          yMin: yMin,
          zMin: zMin,
          xMax: xMax,
          yMax: yMax,
          zMax: zMax,
          Xs: Xs,
          Ys: Ys,
          Zs: Zs,
          len: len,
          fill: gridFill
      };
  }
  
  function distinctVals(col) {
      return Lib.distinctVals(col).vals;
  }
  
  function filter(arr, len) {
      if(len === undefined) len = arr.length;
  
      // no need for casting typed arrays to numbers
      if(Lib.isTypedArray(arr)) return arr.subarray(0, len);
  
      var values = [];
      for(var i = 0; i < len; i++) {
          values[i] = +arr[i];
      }
      return values;
  }
  
  module.exports = {
      calc: calc,
      filter: filter,
      processGrid: processGrid
  };
  
  },{"../../components/colorscale/calc":623,"../../lib":750}],1267:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var tube2mesh = _dereq_('gl-streamtube3d');
  var createTubeMesh = tube2mesh.createTubeMesh;
  
  var Lib = _dereq_('../../lib');
  var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
  var extractOpts = _dereq_('../../components/colorscale').extractOpts;
  var zip3 = _dereq_('../../plots/gl3d/zip3');
  
  var axisName2scaleIndex = {xaxis: 0, yaxis: 1, zaxis: 2};
  
  function Streamtube(scene, uid) {
      this.scene = scene;
      this.uid = uid;
      this.mesh = null;
      this.data = null;
  }
  
  var proto = Streamtube.prototype;
  
  proto.handlePick = function(selection) {
      var sceneLayout = this.scene.fullSceneLayout;
      var dataScale = this.scene.dataScale;
  
      function fromDataScale(v, axisName) {
          var ax = sceneLayout[axisName];
          var scale = dataScale[axisName2scaleIndex[axisName]];
          return ax.l2c(v) / scale;
      }
  
      if(selection.object === this.mesh) {
          var pos = selection.data.position;
          var uvx = selection.data.velocity;
  
          selection.traceCoordinate = [
              fromDataScale(pos[0], 'xaxis'),
              fromDataScale(pos[1], 'yaxis'),
              fromDataScale(pos[2], 'zaxis'),
  
              fromDataScale(uvx[0], 'xaxis'),
              fromDataScale(uvx[1], 'yaxis'),
              fromDataScale(uvx[2], 'zaxis'),
  
              // u/v/w norm
              selection.data.intensity * this.data._normMax,
              // divergence
              selection.data.divergence
          ];
  
          selection.textLabel = this.data.hovertext || this.data.text;
  
          return true;
      }
  };
  
  function getDfltStartingPositions(vec) {
      var len = vec.length;
      var s;
  
      if(len > 2) {
          s = vec.slice(1, len - 1);
      } else if(len === 2) {
          s = [(vec[0] + vec[1]) / 2];
      } else {
          s = vec;
      }
      return s;
  }
  
  function getBoundPads(vec) {
      var len = vec.length;
      if(len === 1) {
          return [0.5, 0.5];
      } else {
          return [vec[1] - vec[0], vec[len - 1] - vec[len - 2]];
      }
  }
  
  function convert(scene, trace) {
      var sceneLayout = scene.fullSceneLayout;
      var dataScale = scene.dataScale;
      var len = trace._len;
      var tubeOpts = {};
  
      function toDataCoords(arr, axisName) {
          var ax = sceneLayout[axisName];
          var scale = dataScale[axisName2scaleIndex[axisName]];
          return Lib.simpleMap(arr, function(v) { return ax.d2l(v) * scale; });
      }
  
      tubeOpts.vectors = zip3(
          toDataCoords(trace._u, 'xaxis'),
          toDataCoords(trace._v, 'yaxis'),
          toDataCoords(trace._w, 'zaxis'),
          len
      );
  
      // Over-specified mesh case, this would error in tube2mesh
      if(!len) {
          return {
              positions: [],
              cells: []
          };
      }
  
      var meshx = toDataCoords(trace._Xs, 'xaxis');
      var meshy = toDataCoords(trace._Ys, 'yaxis');
      var meshz = toDataCoords(trace._Zs, 'zaxis');
  
      tubeOpts.meshgrid = [meshx, meshy, meshz];
      tubeOpts.gridFill = trace._gridFill;
  
      var slen = trace._slen;
      if(slen) {
          tubeOpts.startingPositions = zip3(
              toDataCoords(trace._startsX, 'xaxis'),
              toDataCoords(trace._startsY, 'yaxis'),
              toDataCoords(trace._startsZ, 'zaxis')
          );
      } else {
          // Default starting positions:
          //
          // if len>2, cut xz plane at min-y,
          // takes all x/y/z pts on that plane except those on the edges
          // to generate "well-defined" tubes,
          //
          // if len=2, take position halfway between two the pts,
          //
          // if len=1, take that pt
          var sy0 = meshy[0];
          var sx = getDfltStartingPositions(meshx);
          var sz = getDfltStartingPositions(meshz);
          var startingPositions = new Array(sx.length * sz.length);
          var m = 0;
  
          for(var i = 0; i < sx.length; i++) {
              for(var k = 0; k < sz.length; k++) {
                  startingPositions[m++] = [sx[i], sy0, sz[k]];
              }
          }
          tubeOpts.startingPositions = startingPositions;
      }
  
      tubeOpts.colormap = parseColorScale(trace);
      tubeOpts.tubeSize = trace.sizeref;
      tubeOpts.maxLength = trace.maxdisplayed;
  
      // add some padding around the bounds
      // to e.g. allow tubes starting from a slice of the x/y/z mesh
      // to go beyond bounds a little bit w/o getting clipped
      var xbnds = toDataCoords(trace._xbnds, 'xaxis');
      var ybnds = toDataCoords(trace._ybnds, 'yaxis');
      var zbnds = toDataCoords(trace._zbnds, 'zaxis');
      var xpads = getBoundPads(meshx);
      var ypads = getBoundPads(meshy);
      var zpads = getBoundPads(meshz);
  
      var bounds = [
          [xbnds[0] - xpads[0], ybnds[0] - ypads[0], zbnds[0] - zpads[0]],
          [xbnds[1] + xpads[1], ybnds[1] + ypads[1], zbnds[1] + zpads[1]]
      ];
  
      var meshData = tube2mesh(tubeOpts, bounds);
  
      // N.B. cmin/cmax correspond to the min/max vector norm
      // in the u/v/w arrays, which in general is NOT equal to max
      // intensity that colors the tubes.
      var cOpts = extractOpts(trace);
      meshData.vertexIntensityBounds = [cOpts.min / trace._normMax, cOpts.max / trace._normMax];
  
      // pass gl-mesh3d lighting attributes
      var lp = trace.lightposition;
      meshData.lightPosition = [lp.x, lp.y, lp.z];
      meshData.ambient = trace.lighting.ambient;
      meshData.diffuse = trace.lighting.diffuse;
      meshData.specular = trace.lighting.specular;
      meshData.roughness = trace.lighting.roughness;
      meshData.fresnel = trace.lighting.fresnel;
      meshData.opacity = trace.opacity;
  
      // stash autorange pad value
      trace._pad = meshData.tubeScale * trace.sizeref * 2;
  
      return meshData;
  }
  
  proto.update = function(data) {
      this.data = data;
  
      var meshData = convert(this.scene, data);
      this.mesh.update(meshData);
  };
  
  proto.dispose = function() {
      this.scene.glplot.remove(this.mesh);
      this.mesh.dispose();
  };
  
  function createStreamtubeTrace(scene, data) {
      var gl = scene.glplot.gl;
  
      var meshData = convert(scene, data);
      var mesh = createTubeMesh(gl, meshData);
  
      var streamtube = new Streamtube(scene, data.uid);
      streamtube.mesh = mesh;
      streamtube.data = data;
      mesh._trace = streamtube;
  
      scene.glplot.add(mesh);
  
      return streamtube;
  }
  
  module.exports = createStreamtubeTrace;
  
  },{"../../components/colorscale":627,"../../lib":750,"../../lib/gl_format_color":746,"../../plots/gl3d/zip3":852,"gl-streamtube3d":323}],1268:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var u = coerce('u');
      var v = coerce('v');
      var w = coerce('w');
  
      var x = coerce('x');
      var y = coerce('y');
      var z = coerce('z');
  
      if(
          !u || !u.length || !v || !v.length || !w || !w.length ||
          !x || !x.length || !y || !y.length || !z || !z.length
      ) {
          traceOut.visible = false;
          return;
      }
  
      coerce('starts.x');
      coerce('starts.y');
      coerce('starts.z');
  
      coerce('maxdisplayed');
      coerce('sizeref');
  
      coerce('lighting.ambient');
      coerce('lighting.diffuse');
      coerce('lighting.specular');
      coerce('lighting.roughness');
      coerce('lighting.fresnel');
      coerce('lightposition.x');
      coerce('lightposition.y');
      coerce('lightposition.z');
  
      colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'});
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      // disable 1D transforms (for now)
      // x/y/z and u/v/w have matching lengths,
      // but they don't have to match with starts.(x|y|z)
      traceOut._length = null;
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"./attributes":1265}],1269:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'streamtube',
      basePlotModule: _dereq_('../../plots/gl3d'),
      categories: ['gl3d', 'showLegend'],
  
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      colorbar: {
          min: 'cmin',
          max: 'cmax'
      },
      calc: _dereq_('./calc').calc,
      plot: _dereq_('./convert'),
      eventData: function(out, pt) {
          out.tubex = out.x;
          out.tubey = out.y;
          out.tubez = out.z;
  
          out.tubeu = pt.traceCoordinate[3];
          out.tubev = pt.traceCoordinate[4];
          out.tubew = pt.traceCoordinate[5];
  
          out.norm = pt.traceCoordinate[6];
          out.divergence = pt.traceCoordinate[7];
  
          // Does not correspond to input x/y/z, so delete them
          delete out.x;
          delete out.y;
          delete out.z;
  
          return out;
      },
  
      meta: {
          
      }
  };
  
  },{"../../plots/gl3d":841,"./attributes":1265,"./calc":1266,"./convert":1267,"./defaults":1268}],1270:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var baseAttrs = _dereq_('../../plots/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  var pieAttrs = _dereq_('../pie/attributes');
  var constants = _dereq_('./constants');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = {
      labels: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      parents: {
          valType: 'data_array',
          editType: 'calc',
          
      },
  
      values: {
          valType: 'data_array',
          editType: 'calc',
          
      },
      branchvalues: {
          valType: 'enumerated',
          values: ['remainder', 'total'],
          dflt: 'remainder',
          editType: 'calc',
          
          
      },
      count: {
          valType: 'flaglist',
          flags: [
              'branches',
              'leaves'
          ],
          dflt: 'leaves',
          editType: 'calc',
          
          
      },
  
      level: {
          valType: 'any',
          editType: 'plot',
          anim: true,
          
          
      },
      maxdepth: {
          valType: 'integer',
          editType: 'plot',
          
          dflt: -1,
          
      },
  
      marker: extendFlat({
          colors: {
              valType: 'data_array',
              editType: 'calc',
              
          },
  
          // colorinheritance: {
          //     valType: 'enumerated',
          //     values: ['per-branch', 'per-label', false]
          // },
  
          line: {
              color: extendFlat({}, pieAttrs.marker.line.color, {
                  dflt: null,
                  
              }),
              width: extendFlat({}, pieAttrs.marker.line.width, {dflt: 1}),
              editType: 'calc'
          },
          editType: 'calc'
      },
          colorScaleAttrs('marker', {
              colorAttr: 'colors',
              anim: false // TODO: set to anim: true?
          })
      ),
  
      leaf: {
          opacity: {
              valType: 'number',
              editType: 'style',
              
              min: 0,
              max: 1,
              
          },
          editType: 'plot'
      },
  
      text: pieAttrs.text,
      textinfo: {
          valType: 'flaglist',
          
          flags: [
              'label',
              'text',
              'value',
              'current path',
              'percent root',
              'percent entry',
              'percent parent'
          ],
          extras: ['none'],
          editType: 'plot',
          
      },
  
      // TODO: incorporate `label` and `value` in the eventData
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: constants.eventDataKeys.concat(['label', 'value'])
      }),
  
      hovertext: pieAttrs.hovertext,
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: [
              'label',
              'text',
              'value',
              'name',
              'current path',
              'percent root',
              'percent entry',
              'percent parent'
          ],
          dflt: 'label+text+value+name'
      }),
      hovertemplate: hovertemplateAttrs({}, {
          keys: constants.eventDataKeys
      }),
  
      textfont: pieAttrs.textfont,
      insidetextorientation: pieAttrs.insidetextorientation,
      insidetextfont: pieAttrs.insidetextfont,
      outsidetextfont: extendFlat({}, pieAttrs.outsidetextfont, {
          
      }),
      rotation: {
          valType: 'angle',
          
          dflt: 0,
          editType: 'plot',
          
      },
      sort: pieAttrs.sort,
  
      domain: domainAttrs({name: 'sunburst', trace: true, editType: 'calc'})
  };
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/domain":826,"../../plots/template_attributes":877,"../pie/attributes":1132,"./constants":1273}],1271:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var plots = _dereq_('../../plots/plots');
  
  exports.name = 'sunburst';
  
  exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
      plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
  };
  
  },{"../../plots/plots":862}],1272:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3Hierarchy = _dereq_('d3-hierarchy');
  var isNumeric = _dereq_('fast-isnumeric');
  
  var Lib = _dereq_('../../lib');
  var makeColorScaleFn = _dereq_('../../components/colorscale').makeColorScaleFuncFromTrace;
  var makePullColorFn = _dereq_('../pie/calc').makePullColorFn;
  var generateExtendedColors = _dereq_('../pie/calc').generateExtendedColors;
  var colorscaleCalc = _dereq_('../../components/colorscale').calc;
  
  var ALMOST_EQUAL = _dereq_('../../constants/numerical').ALMOST_EQUAL;
  
  var sunburstExtendedColorWays = {};
  var treemapExtendedColorWays = {};
  
  exports.calc = function(gd, trace) {
      var fullLayout = gd._fullLayout;
      var ids = trace.ids;
      var hasIds = Lib.isArrayOrTypedArray(ids);
      var labels = trace.labels;
      var parents = trace.parents;
      var values = trace.values;
      var hasValues = Lib.isArrayOrTypedArray(values);
      var cd = [];
  
      var parent2children = {};
      var refs = {};
      var addToLookup = function(parent, v) {
          if(parent2children[parent]) parent2children[parent].push(v);
          else parent2children[parent] = [v];
          refs[v] = 1;
      };
  
      // treat number `0` as valid
      var isValidKey = function(k) {
          return k || typeof k === 'number';
      };
  
      var isValidVal = function(i) {
          return !hasValues || (isNumeric(values[i]) && values[i] >= 0);
      };
  
      var len;
      var isValid;
      var getId;
  
      if(hasIds) {
          len = Math.min(ids.length, parents.length);
          isValid = function(i) { return isValidKey(ids[i]) && isValidVal(i); };
          getId = function(i) { return String(ids[i]); };
      } else {
          len = Math.min(labels.length, parents.length);
          isValid = function(i) { return isValidKey(labels[i]) && isValidVal(i); };
          // TODO We could allow some label / parent duplication
          //
          // From AJ:
          //  It would work OK for one level
          //  (multiple rows with the same name and different parents -
          //  or even the same parent) but if that name is then used as a parent
          //  which one is it?
          getId = function(i) { return String(labels[i]); };
      }
  
      if(hasValues) len = Math.min(len, values.length);
  
      for(var i = 0; i < len; i++) {
          if(isValid(i)) {
              var id = getId(i);
              var pid = isValidKey(parents[i]) ? String(parents[i]) : '';
  
              var cdi = {
                  i: i,
                  id: id,
                  pid: pid,
                  label: isValidKey(labels[i]) ? String(labels[i]) : ''
              };
  
              if(hasValues) cdi.v = +values[i];
              cd.push(cdi);
              addToLookup(pid, id);
          }
      }
  
      if(!parent2children['']) {
          var impliedRoots = [];
          var k;
          for(k in parent2children) {
              if(!refs[k]) {
                  impliedRoots.push(k);
              }
          }
  
          // if an `id` has no ref in the `parents` array,
          // take it as being the root node
  
          if(impliedRoots.length === 1) {
              k = impliedRoots[0];
              cd.unshift({
                  hasImpliedRoot: true,
                  id: k,
                  pid: '',
                  label: k
              });
          } else {
              return Lib.warn([
                  'Multiple implied roots, cannot build', trace.type, 'hierarchy of', trace.name + '.',
                  'These roots include:', impliedRoots.join(', ')
              ].join(' '));
          }
      } else if(parent2children[''].length > 1) {
          var dummyId = Lib.randstr();
  
          // if multiple rows linked to the root node,
          // add dummy "root of roots" node to make d3 build the hierarchy successfully
  
          for(var j = 0; j < cd.length; j++) {
              if(cd[j].pid === '') {
                  cd[j].pid = dummyId;
              }
          }
  
          cd.unshift({
              hasMultipleRoots: true,
              id: dummyId,
              pid: '',
              label: ''
          });
      }
  
      // TODO might be better to replace stratify() with our own algorithm
      var root;
      try {
          root = d3Hierarchy.stratify()
              .id(function(d) { return d.id; })
              .parentId(function(d) { return d.pid; })(cd);
      } catch(e) {
          return Lib.warn([
              'Failed to build', trace.type, 'hierarchy of', trace.name + '.',
              'Error:', e.message
          ].join(' '));
      }
  
      var hierarchy = d3Hierarchy.hierarchy(root);
      var failed = false;
  
      if(hasValues) {
          switch(trace.branchvalues) {
              case 'remainder':
                  hierarchy.sum(function(d) { return d.data.v; });
                  break;
              case 'total':
                  hierarchy.each(function(d) {
                      var cdi = d.data.data;
                      var v = cdi.v;
  
                      if(d.children) {
                          var partialSum = d.children.reduce(function(a, c) {
                              return a + c.data.data.v;
                          }, 0);
  
                          // N.B. we must fill in `value` for generated sectors
                          // with the partialSum to compute the correct partition
                          if(cdi.hasImpliedRoot || cdi.hasMultipleRoots) {
                              v = partialSum;
                          }
  
                          if(v < partialSum * ALMOST_EQUAL) {
                              failed = true;
                              return Lib.warn([
                                  'Total value for node', d.data.data.id, 'of', trace.name,
                                  'is smaller than the sum of its children.',
                                  '\nparent value =', v,
                                  '\nchildren sum =', partialSum
                              ].join(' '));
                          }
                      }
  
                      d.value = v;
                  });
                  break;
          }
      } else {
          countDescendants(hierarchy, trace, {
              branches: trace.count.indexOf('branches') !== -1,
              leaves: trace.count.indexOf('leaves') !== -1
          });
      }
  
      if(failed) return;
  
      // TODO add way to sort by height also?
      if(trace.sort) {
          hierarchy.sort(function(a, b) { return b.value - a.value; });
      }
  
      var pullColor;
      var scaleColor;
      var colors = trace.marker.colors || [];
      var hasColors = !!colors.length;
  
      if(trace._hasColorscale) {
          if(!hasColors) {
              colors = hasValues ? trace.values : trace._values;
          }
  
          colorscaleCalc(gd, trace, {
              vals: colors,
              containerStr: 'marker',
              cLetter: 'c'
          });
  
          scaleColor = makeColorScaleFn(trace.marker);
      } else {
          pullColor = makePullColorFn(fullLayout['_' + trace.type + 'colormap']);
      }
  
      // TODO keep track of 'root-children' (i.e. branch) for hover info etc.
  
      hierarchy.each(function(d) {
          var cdi = d.data.data;
          // N.B. this mutates items in `cd`
          cdi.color = trace._hasColorscale ?
              scaleColor(colors[cdi.i]) :
              pullColor(colors[cdi.i], cdi.id);
      });
  
      cd[0].hierarchy = hierarchy;
  
      return cd;
  };
  
  /*
   * `calc` filled in (and collated) explicit colors.
   * Now we need to propagate these explicit colors to other traces,
   * and fill in default colors.
   * This is done after sorting, so we pick defaults
   * in the order slices will be displayed
   */
  exports._runCrossTraceCalc = function(desiredType, gd) {
      var fullLayout = gd._fullLayout;
      var calcdata = gd.calcdata;
      var colorWay = fullLayout[desiredType + 'colorway'];
      var colorMap = fullLayout['_' + desiredType + 'colormap'];
  
      if(fullLayout['extend' + desiredType + 'colors']) {
          colorWay = generateExtendedColors(colorWay,
              desiredType === 'treemap' ? treemapExtendedColorWays : sunburstExtendedColorWays
          );
      }
      var dfltColorCount = 0;
  
      function pickColor(d) {
          var cdi = d.data.data;
          var id = cdi.id;
  
          if(cdi.color === false) {
              if(colorMap[id]) {
                  // have we seen this label and assigned a color to it in a previous trace?
                  cdi.color = colorMap[id];
              } else if(d.parent) {
                  if(d.parent.parent) {
                      // from third-level on, inherit from parent
                      cdi.color = d.parent.data.data.color;
                  } else {
                      // pick new color for second level
                      colorMap[id] = cdi.color = colorWay[dfltColorCount % colorWay.length];
                      dfltColorCount++;
                  }
              } else {
                  // root gets no coloring by default
                  cdi.color = 'rgba(0,0,0,0)';
              }
          }
      }
  
      for(var i = 0; i < calcdata.length; i++) {
          var cd = calcdata[i];
          var cd0 = cd[0];
          if(cd0.trace.type === desiredType && cd0.hierarchy) {
              cd0.hierarchy.each(pickColor);
          }
      }
  };
  
  exports.crossTraceCalc = function(gd) {
      return exports._runCrossTraceCalc('sunburst', gd);
  };
  
  function countDescendants(node, trace, opts) {
      var nChild = 0;
  
      var children = node.children;
      if(children) {
          var len = children.length;
  
          for(var i = 0; i < len; i++) {
              nChild += countDescendants(children[i], trace, opts);
          }
  
          if(opts.branches) nChild++; // count this branch
      } else {
          if(opts.leaves) nChild++; // count this leaf
      }
  
      // save to the node
      node.value = node.data.data.value = nChild;
  
      // save to the trace
      if(!trace._values) trace._values = [];
      trace._values[node.data.data.i] = nChild;
  
      return nChild;
  }
  
  },{"../../components/colorscale":627,"../../constants/numerical":725,"../../lib":750,"../pie/calc":1134,"d3-hierarchy":161,"fast-isnumeric":241}],1273:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      CLICK_TRANSITION_TIME: 750,
      CLICK_TRANSITION_EASING: 'linear',
      eventDataKeys: [
          // string
          'currentPath',
          'root',
          'entry',
          // no need to add 'parent' here
  
          // percentages i.e. ratios
          'percentRoot',
          'percentEntry',
          'percentParent'
      ]
  };
  
  },{}],1274:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
  var handleText = _dereq_('../bar/defaults').handleText;
  
  var Colorscale = _dereq_('../../components/colorscale');
  var hasColorscale = Colorscale.hasColorscale;
  var colorscaleDefaults = Colorscale.handleDefaults;
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var labels = coerce('labels');
      var parents = coerce('parents');
  
      if(!labels || !labels.length || !parents || !parents.length) {
          traceOut.visible = false;
          return;
      }
  
      var vals = coerce('values');
      if(vals && vals.length) {
          coerce('branchvalues');
      } else {
          coerce('count');
      }
  
      coerce('level');
      coerce('maxdepth');
  
      var lineWidth = coerce('marker.line.width');
      if(lineWidth) coerce('marker.line.color', layout.paper_bgcolor);
  
      coerce('marker.colors');
      var withColorscale = traceOut._hasColorscale = (
          hasColorscale(traceIn, 'marker', 'colors') ||
          (traceIn.marker || {}).coloraxis // N.B. special logic to consider "values" colorscales
      );
      if(withColorscale) {
          colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'});
      }
  
      coerce('leaf.opacity', withColorscale ? 1 : 0.7);
  
      var text = coerce('text');
      coerce('texttemplate');
      if(!traceOut.texttemplate) coerce('textinfo', Array.isArray(text) ? 'text+label' : 'label');
  
      coerce('hovertext');
      coerce('hovertemplate');
  
      var textposition = 'auto';
      handleText(traceIn, traceOut, layout, coerce, textposition, {
          moduleHasSelected: false,
          moduleHasUnselected: false,
          moduleHasConstrain: false,
          moduleHasCliponaxis: false,
          moduleHasTextangle: false,
          moduleHasInsideanchor: false
      });
  
      coerce('insidetextorientation');
  
      coerce('sort');
  
      coerce('rotation');
  
      handleDomainDefaults(traceOut, layout, coerce);
  
      // do not support transforms for now
      traceOut._length = null;
  };
  
  },{"../../components/colorscale":627,"../../lib":750,"../../plots/domain":826,"../bar/defaults":896,"./attributes":1270}],1275:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Registry = _dereq_('../../registry');
  var appendArrayPointValue = _dereq_('../../components/fx/helpers').appendArrayPointValue;
  var Fx = _dereq_('../../components/fx');
  var Lib = _dereq_('../../lib');
  var Events = _dereq_('../../lib/events');
  
  var helpers = _dereq_('./helpers');
  var pieHelpers = _dereq_('../pie/helpers');
  
  var formatValue = pieHelpers.formatPieValue;
  
  module.exports = function attachFxHandlers(sliceTop, entry, gd, cd, opts) {
      var cd0 = cd[0];
      var trace = cd0.trace;
      var hierarchy = cd0.hierarchy;
  
      var isSunburst = trace.type === 'sunburst';
      var isTreemap = trace.type === 'treemap';
  
      // hover state vars
      // have we drawn a hover label, so it should be cleared later
      if(!('_hasHoverLabel' in trace)) trace._hasHoverLabel = false;
      // have we emitted a hover event, so later an unhover event should be emitted
      // note that click events do not depend on this - you can still get them
      // with hovermode: false or if you were earlier dragging, then clicked
      // in the same slice that you moused up in
      if(!('_hasHoverEvent' in trace)) trace._hasHoverEvent = false;
  
      var onMouseOver = function(pt) {
          var fullLayoutNow = gd._fullLayout;
  
          if(gd._dragging || fullLayoutNow.hovermode === false) return;
  
          var traceNow = gd._fullData[trace.index];
          var cdi = pt.data.data;
          var ptNumber = cdi.i;
          var isRoot = helpers.isHierarchyRoot(pt);
          var parent = helpers.getParent(hierarchy, pt);
  
          var val = helpers.getValue(pt);
  
          var _cast = function(astr) {
              return Lib.castOption(traceNow, ptNumber, astr);
          };
  
          var hovertemplate = _cast('hovertemplate');
          var hoverinfo = Fx.castHoverinfo(traceNow, fullLayoutNow, ptNumber);
          var separators = fullLayoutNow.separators;
  
          if(hovertemplate || (hoverinfo && hoverinfo !== 'none' && hoverinfo !== 'skip')) {
              var hoverCenterX;
              var hoverCenterY;
              if(isSunburst) {
                  hoverCenterX = cd0.cx + pt.pxmid[0] * (1 - pt.rInscribed);
                  hoverCenterY = cd0.cy + pt.pxmid[1] * (1 - pt.rInscribed);
              }
              if(isTreemap) {
                  hoverCenterX = pt._hoverX;
                  hoverCenterY = pt._hoverY;
              }
  
              var hoverPt = {};
              var parts = [];
              var thisText = [];
              var hasFlag = function(flag) { return parts.indexOf(flag) !== -1; };
  
              if(hoverinfo) {
                  parts = hoverinfo === 'all' ?
                      traceNow._module.attributes.hoverinfo.flags :
                      hoverinfo.split('+');
              }
  
              hoverPt.label = cdi.label;
              if(hasFlag('label') && hoverPt.label) thisText.push(hoverPt.label);
  
              if(cdi.hasOwnProperty('v')) {
                  hoverPt.value = cdi.v;
                  hoverPt.valueLabel = formatValue(hoverPt.value, separators);
                  if(hasFlag('value')) thisText.push(hoverPt.valueLabel);
              }
  
              hoverPt.currentPath = pt.currentPath = helpers.getPath(pt.data);
              if(hasFlag('current path') && !isRoot) {
                  thisText.push(hoverPt.currentPath);
              }
  
              var tx;
              var allPercents = [];
              var insertPercent = function() {
                  if(allPercents.indexOf(tx) === -1) { // no need to add redundant info
                      thisText.push(tx);
                      allPercents.push(tx);
                  }
              };
  
              hoverPt.percentParent = pt.percentParent = val / helpers.getValue(parent);
              hoverPt.parent = pt.parentString = helpers.getPtLabel(parent);
              if(hasFlag('percent parent')) {
                  tx = helpers.formatPercent(hoverPt.percentParent, separators) + ' of ' + hoverPt.parent;
                  insertPercent();
              }
  
              hoverPt.percentEntry = pt.percentEntry = val / helpers.getValue(entry);
              hoverPt.entry = pt.entry = helpers.getPtLabel(entry);
              if(hasFlag('percent entry') && !isRoot && !pt.onPathbar) {
                  tx = helpers.formatPercent(hoverPt.percentEntry, separators) + ' of ' + hoverPt.entry;
                  insertPercent();
              }
  
              hoverPt.percentRoot = pt.percentRoot = val / helpers.getValue(hierarchy);
              hoverPt.root = pt.root = helpers.getPtLabel(hierarchy);
              if(hasFlag('percent root') && !isRoot) {
                  tx = helpers.formatPercent(hoverPt.percentRoot, separators) + ' of ' + hoverPt.root;
                  insertPercent();
              }
  
              hoverPt.text = _cast('hovertext') || _cast('text');
              if(hasFlag('text')) {
                  tx = hoverPt.text;
                  if(Lib.isValidTextValue(tx)) thisText.push(tx);
              }
  
              var hoverItems = {
                  trace: traceNow,
                  y: hoverCenterY,
                  text: thisText.join('<br>'),
                  name: (hovertemplate || hasFlag('name')) ? traceNow.name : undefined,
                  color: _cast('hoverlabel.bgcolor') || cdi.color,
                  borderColor: _cast('hoverlabel.bordercolor'),
                  fontFamily: _cast('hoverlabel.font.family'),
                  fontSize: _cast('hoverlabel.font.size'),
                  fontColor: _cast('hoverlabel.font.color'),
                  nameLength: _cast('hoverlabel.namelength'),
                  textAlign: _cast('hoverlabel.align'),
                  hovertemplate: hovertemplate,
                  hovertemplateLabels: hoverPt,
                  eventData: [makeEventData(pt, traceNow, opts.eventDataKeys)]
              };
  
              if(isSunburst) {
                  hoverItems.x0 = hoverCenterX - pt.rInscribed * pt.rpx1;
                  hoverItems.x1 = hoverCenterX + pt.rInscribed * pt.rpx1;
                  hoverItems.idealAlign = pt.pxmid[0] < 0 ? 'left' : 'right';
              }
              if(isTreemap) {
                  hoverItems.x = hoverCenterX;
                  hoverItems.idealAlign = hoverCenterX < 0 ? 'left' : 'right';
              }
  
              Fx.loneHover(hoverItems, {
                  container: fullLayoutNow._hoverlayer.node(),
                  outerContainer: fullLayoutNow._paper.node(),
                  gd: gd
              });
  
              trace._hasHoverLabel = true;
          }
  
          if(isTreemap) {
              var slice = sliceTop.select('path.surface');
              opts.styleOne(slice, pt, traceNow, {
                  hovered: true
              });
          }
  
          trace._hasHoverEvent = true;
          gd.emit('plotly_hover', {
              points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
              event: d3.event
          });
      };
  
      var onMouseOut = function(evt) {
          var fullLayoutNow = gd._fullLayout;
          var traceNow = gd._fullData[trace.index];
          var pt = d3.select(this).datum();
  
          if(trace._hasHoverEvent) {
              evt.originalEvent = d3.event;
              gd.emit('plotly_unhover', {
                  points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
                  event: d3.event
              });
              trace._hasHoverEvent = false;
          }
  
          if(trace._hasHoverLabel) {
              Fx.loneUnhover(fullLayoutNow._hoverlayer.node());
              trace._hasHoverLabel = false;
          }
  
          if(isTreemap) {
              var slice = sliceTop.select('path.surface');
              opts.styleOne(slice, pt, traceNow, {
                  hovered: false
              });
          }
      };
  
      var onClick = function(pt) {
          // TODO: this does not support right-click. If we want to support it, we
          // would likely need to change pie to use dragElement instead of straight
          // mapbox event binding. Or perhaps better, make a simple wrapper with the
          // right mousedown, mousemove, and mouseup handlers just for a left/right click
          // mapbox would use this too.
          var fullLayoutNow = gd._fullLayout;
          var traceNow = gd._fullData[trace.index];
  
          var noTransition = isSunburst && (helpers.isHierarchyRoot(pt) || helpers.isLeaf(pt));
  
          var id = helpers.getPtId(pt);
          var nextEntry = helpers.isEntry(pt) ?
              helpers.findEntryWithChild(hierarchy, id) :
              helpers.findEntryWithLevel(hierarchy, id);
          var nextLevel = helpers.getPtId(nextEntry);
  
          var typeClickEvtData = {
              points: [makeEventData(pt, traceNow, opts.eventDataKeys)],
              event: d3.event
          };
          if(!noTransition) typeClickEvtData.nextLevel = nextLevel;
  
          var clickVal = Events.triggerHandler(gd, 'plotly_' + trace.type + 'click', typeClickEvtData);
  
          if(clickVal !== false && fullLayoutNow.hovermode) {
              gd._hoverdata = [makeEventData(pt, traceNow, opts.eventDataKeys)];
              Fx.click(gd, d3.event);
          }
  
          // if click does not trigger a transition, we're done!
          if(noTransition) return;
  
          // if custom handler returns false, we're done!
          if(clickVal === false) return;
  
          // skip if triggered from dragging a nearby cartesian subplot
          if(gd._dragging) return;
  
          // skip during transitions, to avoid potential bugs
          // we could remove this check later
          if(gd._transitioning) return;
  
          // store 'old' level in guiEdit stash, so that subsequent Plotly.react
          // calls with the same uirevision can start from the same entry
          Registry.call('_storeDirectGUIEdit', traceNow, fullLayoutNow._tracePreGUI[traceNow.uid], {
              level: traceNow.level
          });
  
          var frame = {
              data: [{level: nextLevel}],
              traces: [trace.index]
          };
  
          var animOpts = {
              frame: {
                  redraw: false,
                  duration: opts.transitionTime
              },
              transition: {
                  duration: opts.transitionTime,
                  easing: opts.transitionEasing
              },
              mode: 'immediate',
              fromcurrent: true
          };
  
          Fx.loneUnhover(fullLayoutNow._hoverlayer.node());
          Registry.call('animate', gd, frame, animOpts);
      };
  
      sliceTop.on('mouseover', onMouseOver);
      sliceTop.on('mouseout', onMouseOut);
      sliceTop.on('click', onClick);
  };
  
  function makeEventData(pt, trace, keys) {
      var cdi = pt.data.data;
  
      var out = {
          curveNumber: trace.index,
          pointNumber: cdi.i,
          data: trace._input,
          fullData: trace,
  
          // TODO more things like 'children', 'siblings', 'hierarchy?
      };
  
      for(var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if(key in pt) out[key] = pt[key];
      }
      // handle special case of parent
      if('parentString' in pt && !helpers.isHierarchyRoot(pt)) out.parent = pt.parentString;
  
      appendArrayPointValue(out, trace, cdi.i);
  
      return out;
  }
  
  },{"../../components/fx":655,"../../components/fx/helpers":651,"../../lib":750,"../../lib/events":739,"../../registry":882,"../pie/helpers":1137,"./helpers":1276,"d3":169}],1276:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  var setCursor = _dereq_('../../lib/setcursor');
  var pieHelpers = _dereq_('../pie/helpers');
  
  exports.findEntryWithLevel = function(hierarchy, level) {
      var out;
      if(level) {
          hierarchy.eachAfter(function(pt) {
              if(exports.getPtId(pt) === level) {
                  return out = pt.copy();
              }
          });
      }
      return out || hierarchy;
  };
  
  exports.findEntryWithChild = function(hierarchy, childId) {
      var out;
      hierarchy.eachAfter(function(pt) {
          var children = pt.children || [];
          for(var i = 0; i < children.length; i++) {
              var child = children[i];
              if(exports.getPtId(child) === childId) {
                  return out = pt.copy();
              }
          }
      });
      return out || hierarchy;
  };
  
  exports.isEntry = function(pt) {
      return !pt.parent;
  };
  
  exports.isLeaf = function(pt) {
      return !pt.children;
  };
  
  exports.getPtId = function(pt) {
      return pt.data.data.id;
  };
  
  exports.getPtLabel = function(pt) {
      return pt.data.data.label;
  };
  
  exports.getValue = function(d) {
      return d.value;
  };
  
  exports.isHierarchyRoot = function(pt) {
      return getParentId(pt) === '';
  };
  
  exports.setSliceCursor = function(sliceTop, gd, opts) {
      var hide = opts.isTransitioning;
      if(!hide) {
          var pt = sliceTop.datum();
          hide = (
              (opts.hideOnRoot && exports.isHierarchyRoot(pt)) ||
              (opts.hideOnLeaves && exports.isLeaf(pt))
          );
      }
      setCursor(sliceTop, hide ? null : 'pointer');
  };
  
  function determineOutsideTextFont(trace, pt, layoutFont) {
      return {
          color: exports.getOutsideTextFontKey('color', trace, pt, layoutFont),
          family: exports.getOutsideTextFontKey('family', trace, pt, layoutFont),
          size: exports.getOutsideTextFontKey('size', trace, pt, layoutFont)
      };
  }
  
  function determineInsideTextFont(trace, pt, layoutFont, opts) {
      var onPathbar = (opts || {}).onPathbar;
  
      var cdi = pt.data.data;
      var ptNumber = cdi.i;
  
      var customColor = Lib.castOption(trace, ptNumber,
          (onPathbar ? 'pathbar.textfont' : 'insidetextfont') + '.color'
      );
  
      if(!customColor && trace._input.textfont) {
          // Why not simply using trace.textfont? Because if not set, it
          // defaults to layout.font which has a default color. But if
          // textfont.color and insidetextfont.color don't supply a value,
          // a contrasting color shall be used.
          customColor = Lib.castOption(trace._input, ptNumber, 'textfont.color');
      }
  
      return {
          color: customColor || Color.contrast(cdi.color),
          family: exports.getInsideTextFontKey('family', trace, pt, layoutFont, opts),
          size: exports.getInsideTextFontKey('size', trace, pt, layoutFont, opts)
      };
  }
  
  exports.getInsideTextFontKey = function(keyStr, trace, pt, layoutFont, opts) {
      var onPathbar = (opts || {}).onPathbar;
      var cont = onPathbar ? 'pathbar.textfont' : 'insidetextfont';
      var ptNumber = pt.data.data.i;
  
      return (
          Lib.castOption(trace, ptNumber, cont + '.' + keyStr) ||
          Lib.castOption(trace, ptNumber, 'textfont.' + keyStr) ||
          layoutFont.size
      );
  };
  
  exports.getOutsideTextFontKey = function(keyStr, trace, pt, layoutFont) {
      var ptNumber = pt.data.data.i;
  
      return (
          Lib.castOption(trace, ptNumber, 'outsidetextfont.' + keyStr) ||
          Lib.castOption(trace, ptNumber, 'textfont.' + keyStr) ||
          layoutFont.size
      );
  };
  
  exports.isOutsideText = function(trace, pt) {
      return !trace._hasColorscale && exports.isHierarchyRoot(pt);
  };
  
  exports.determineTextFont = function(trace, pt, layoutFont, opts) {
      return exports.isOutsideText(trace, pt) ?
          determineOutsideTextFont(trace, pt, layoutFont) :
          determineInsideTextFont(trace, pt, layoutFont, opts);
  };
  
  exports.hasTransition = function(transitionOpts) {
      // We could optimize hasTransition per trace,
      // as sunburst & treemap have no cross-trace logic!
      return !!(transitionOpts && transitionOpts.duration > 0);
  };
  
  exports.getMaxDepth = function(trace) {
      return trace.maxdepth >= 0 ? trace.maxdepth : Infinity;
  };
  
  exports.isHeader = function(pt, trace) { // it is only used in treemap.
      return !(exports.isLeaf(pt) || pt.depth === trace._maxDepth - 1);
  };
  
  function getParentId(pt) {
      return pt.data.data.pid;
  }
  
  exports.getParent = function(hierarchy, pt) {
      return exports.findEntryWithLevel(hierarchy, getParentId(pt));
  };
  
  exports.listPath = function(d, keyStr) {
      var parent = d.parent;
      if(!parent) return [];
      var list = keyStr ? [parent.data[keyStr]] : [parent];
      return exports.listPath(parent, keyStr).concat(list);
  };
  
  exports.getPath = function(d) {
      return exports.listPath(d, 'label').join('/') + '/';
  };
  
  exports.formatValue = pieHelpers.formatPieValue;
  
  // TODO: should combine the two in a separate PR - Also please note Lib.formatPercent should support separators.
  exports.formatPercent = function(v, separators) {
      var tx = Lib.formatPercent(v, 0); // use funnel(area) version
      if(tx === '0%') tx = pieHelpers.formatPiePercent(v, separators); // use pie version
      return tx;
  };
  
  },{"../../components/color":615,"../../lib":750,"../../lib/setcursor":770,"../pie/helpers":1137}],1277:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'sunburst',
      basePlotModule: _dereq_('./base_plot'),
      categories: [],
      animatable: true,
  
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyDefaults: _dereq_('./defaults'),
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
  
      calc: _dereq_('./calc').calc,
      crossTraceCalc: _dereq_('./calc').crossTraceCalc,
  
      plot: _dereq_('./plot').plot,
      style: _dereq_('./style').style,
  
      colorbar: _dereq_('../scatter/marker_colorbar'),
  
      meta: {
          
      }
  };
  
  },{"../scatter/marker_colorbar":1176,"./attributes":1270,"./base_plot":1271,"./calc":1272,"./defaults":1274,"./layout_attributes":1278,"./layout_defaults":1279,"./plot":1280,"./style":1281}],1278:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      sunburstcolorway: {
          valType: 'colorlist',
          
          editType: 'calc',
          
      },
      extendsunburstcolors: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          
      }
  };
  
  },{}],1279:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
      coerce('sunburstcolorway', layoutOut.colorway);
      coerce('extendsunburstcolors');
  };
  
  },{"../../lib":750,"./layout_attributes":1278}],1280:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var d3Hierarchy = _dereq_('d3-hierarchy');
  
  var Drawing = _dereq_('../../components/drawing');
  var Lib = _dereq_('../../lib');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  var uniformText = _dereq_('../bar/uniform_text');
  var recordMinTextSize = uniformText.recordMinTextSize;
  var clearMinTextSize = uniformText.clearMinTextSize;
  var piePlot = _dereq_('../pie/plot');
  var getRotationAngle = _dereq_('../pie/helpers').getRotationAngle;
  var computeTransform = piePlot.computeTransform;
  var transformInsideText = piePlot.transformInsideText;
  var styleOne = _dereq_('./style').styleOne;
  var resizeText = _dereq_('../bar/style').resizeText;
  var attachFxHandlers = _dereq_('./fx');
  var constants = _dereq_('./constants');
  var helpers = _dereq_('./helpers');
  
  exports.plot = function(gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
      var fullLayout = gd._fullLayout;
      var layer = fullLayout._sunburstlayer;
      var join, onComplete;
  
      // If transition config is provided, then it is only a partial replot and traces not
      // updated are removed.
      var isFullReplot = !transitionOpts;
      var hasTransition = !fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts);
  
      clearMinTextSize('sunburst', fullLayout);
  
      join = layer.selectAll('g.trace.sunburst')
          .data(cdmodule, function(cd) { return cd[0].trace.uid; });
  
      // using same 'stroke-linejoin' as pie traces
      join.enter().append('g')
          .classed('trace', true)
          .classed('sunburst', true)
          .attr('stroke-linejoin', 'round');
  
      join.order();
  
      if(hasTransition) {
          if(makeOnCompleteCallback) {
              // If it was passed a callback to register completion, make a callback. If
              // this is created, then it must be executed on completion, otherwise the
              // pos-transition redraw will not execute:
              onComplete = makeOnCompleteCallback();
          }
  
          var transition = d3.transition()
              .duration(transitionOpts.duration)
              .ease(transitionOpts.easing)
              .each('end', function() { onComplete && onComplete(); })
              .each('interrupt', function() { onComplete && onComplete(); });
  
          transition.each(function() {
              // Must run the selection again since otherwise enters/updates get grouped together
              // and these get executed out of order. Except we need them in order!
              layer.selectAll('g.trace').each(function(cd) {
                  plotOne(gd, cd, this, transitionOpts);
              });
          });
      } else {
          join.each(function(cd) {
              plotOne(gd, cd, this, transitionOpts);
          });
  
          if(fullLayout.uniformtext.mode) {
              resizeText(gd, fullLayout._sunburstlayer.selectAll('.trace'), 'sunburst');
          }
      }
  
      if(isFullReplot) {
          join.exit().remove();
      }
  };
  
  function plotOne(gd, cd, element, transitionOpts) {
      var fullLayout = gd._fullLayout;
      var hasTransition = !fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts);
  
      var gTrace = d3.select(element);
      var slices = gTrace.selectAll('g.slice');
  
      var cd0 = cd[0];
      var trace = cd0.trace;
      var hierarchy = cd0.hierarchy;
      var entry = helpers.findEntryWithLevel(hierarchy, trace.level);
      var maxDepth = helpers.getMaxDepth(trace);
  
      var gs = fullLayout._size;
      var domain = trace.domain;
      var vpw = gs.w * (domain.x[1] - domain.x[0]);
      var vph = gs.h * (domain.y[1] - domain.y[0]);
      var rMax = 0.5 * Math.min(vpw, vph);
      var cx = cd0.cx = gs.l + gs.w * (domain.x[1] + domain.x[0]) / 2;
      var cy = cd0.cy = gs.t + gs.h * (1 - domain.y[0]) - vph / 2;
  
      if(!entry) {
          return slices.remove();
      }
  
      // previous root 'pt' (can be empty)
      var prevEntry = null;
      // stash of 'previous' position data used by tweening functions
      var prevLookup = {};
  
      if(hasTransition) {
          // Important: do this before binding new sliceData!
          slices.each(function(pt) {
              prevLookup[helpers.getPtId(pt)] = {
                  rpx0: pt.rpx0,
                  rpx1: pt.rpx1,
                  x0: pt.x0,
                  x1: pt.x1,
                  transform: pt.transform
              };
  
              if(!prevEntry && helpers.isEntry(pt)) {
                  prevEntry = pt;
              }
          });
      }
  
      // N.B. slice data isn't the calcdata,
      // grab corresponding calcdata item in sliceData[i].data.data
      var sliceData = partition(entry).descendants();
  
      var maxHeight = entry.height + 1;
      var yOffset = 0;
      var cutoff = maxDepth;
      // N.B. handle multiple-root special case
      if(cd0.hasMultipleRoots && helpers.isHierarchyRoot(entry)) {
          sliceData = sliceData.slice(1);
          maxHeight -= 1;
          yOffset = 1;
          cutoff += 1;
      }
  
      // filter out slices that won't show up on graph
      sliceData = sliceData.filter(function(pt) { return pt.y1 <= cutoff; });
  
      var baseX = getRotationAngle(trace.rotation);
      if(baseX) {
          sliceData.forEach(function(pt) {
              pt.x0 += baseX;
              pt.x1 += baseX;
          });
      }
  
      // partition span ('y') to sector radial px value
      var maxY = Math.min(maxHeight, maxDepth);
      var y2rpx = function(y) { return (y - yOffset) / maxY * rMax; };
      // (radial px value, partition angle ('x'))  to px [x,y]
      var rx2px = function(r, x) { return [r * Math.cos(x), -r * Math.sin(x)]; };
      // slice path generation fn
      var pathSlice = function(d) { return Lib.pathAnnulus(d.rpx0, d.rpx1, d.x0, d.x1, cx, cy); };
      // slice text translate x/y
  
      var getTargetX = function(d) { return cx + getTextXY(d)[0] * (d.transform.rCenter || 0) + (d.transform.x || 0); };
      var getTargetY = function(d) { return cy + getTextXY(d)[1] * (d.transform.rCenter || 0) + (d.transform.y || 0); };
  
      slices = slices.data(sliceData, helpers.getPtId);
  
      slices.enter().append('g')
          .classed('slice', true);
  
      if(hasTransition) {
          slices.exit().transition()
              .each(function() {
                  var sliceTop = d3.select(this);
  
                  var slicePath = sliceTop.select('path.surface');
                  slicePath.transition().attrTween('d', function(pt2) {
                      var interp = makeExitSliceInterpolator(pt2);
                      return function(t) { return pathSlice(interp(t)); };
                  });
  
                  var sliceTextGroup = sliceTop.select('g.slicetext');
                  sliceTextGroup.attr('opacity', 0);
              })
              .remove();
      } else {
          slices.exit().remove();
      }
  
      slices.order();
  
      // next x1 (i.e. sector end angle) of previous entry
      var nextX1ofPrevEntry = null;
      if(hasTransition && prevEntry) {
          var prevEntryId = helpers.getPtId(prevEntry);
          slices.each(function(pt) {
              if(nextX1ofPrevEntry === null && (helpers.getPtId(pt) === prevEntryId)) {
                  nextX1ofPrevEntry = pt.x1;
              }
          });
      }
  
      var updateSlices = slices;
      if(hasTransition) {
          updateSlices = updateSlices.transition().each('end', function() {
              // N.B. gd._transitioning is (still) *true* by the time
              // transition updates get here
              var sliceTop = d3.select(this);
              helpers.setSliceCursor(sliceTop, gd, {
                  hideOnRoot: true,
                  hideOnLeaves: true,
                  isTransitioning: false
              });
          });
      }
  
      updateSlices.each(function(pt) {
          var sliceTop = d3.select(this);
  
          var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function(s) {
              s.style('pointer-events', 'all');
          });
  
          pt.rpx0 = y2rpx(pt.y0);
          pt.rpx1 = y2rpx(pt.y1);
          pt.xmid = (pt.x0 + pt.x1) / 2;
          pt.pxmid = rx2px(pt.rpx1, pt.xmid);
          pt.midangle = -(pt.xmid - Math.PI / 2);
          pt.startangle = -(pt.x0 - Math.PI / 2);
          pt.stopangle = -(pt.x1 - Math.PI / 2);
          pt.halfangle = 0.5 * Math.min(Lib.angleDelta(pt.x0, pt.x1) || Math.PI, Math.PI);
          pt.ring = 1 - (pt.rpx0 / pt.rpx1);
          pt.rInscribed = getInscribedRadiusFraction(pt, trace);
  
          if(hasTransition) {
              slicePath.transition().attrTween('d', function(pt2) {
                  var interp = makeUpdateSliceInterpolator(pt2);
                  return function(t) { return pathSlice(interp(t)); };
              });
          } else {
              slicePath.attr('d', pathSlice);
          }
  
          sliceTop
              .call(attachFxHandlers, entry, gd, cd, {
                  eventDataKeys: constants.eventDataKeys,
                  transitionTime: constants.CLICK_TRANSITION_TIME,
                  transitionEasing: constants.CLICK_TRANSITION_EASING
              })
              .call(helpers.setSliceCursor, gd, {
                  hideOnRoot: true,
                  hideOnLeaves: true,
                  isTransitioning: gd._transitioning
              });
  
          slicePath.call(styleOne, pt, trace);
  
          var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
          var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function(s) {
              // prohibit tex interpretation until we can handle
              // tex and regular text together
              s.attr('data-notex', 1);
          });
  
          var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font));
  
          sliceText.text(exports.formatSliceLabel(pt, entry, trace, cd, fullLayout))
              .classed('slicetext', true)
              .attr('text-anchor', 'middle')
              .call(Drawing.font, font)
              .call(svgTextUtils.convertToTspans, gd);
  
          // position the text relative to the slice
          var textBB = Drawing.bBox(sliceText.node());
          pt.transform = transformInsideText(textBB, pt, cd0);
          pt.transform.targetX = getTargetX(pt);
          pt.transform.targetY = getTargetY(pt);
  
          var strTransform = function(d, textBB) {
              var transform = d.transform;
              computeTransform(transform, textBB);
  
              transform.fontSize = font.size;
              recordMinTextSize(trace.type, transform, fullLayout);
  
              return Lib.getTextTransform(transform);
          };
  
          if(hasTransition) {
              sliceText.transition().attrTween('transform', function(pt2) {
                  var interp = makeUpdateTextInterpolator(pt2);
                  return function(t) { return strTransform(interp(t), textBB); };
              });
          } else {
              sliceText.attr('transform', strTransform(pt, textBB));
          }
      });
  
      function makeExitSliceInterpolator(pt) {
          var id = helpers.getPtId(pt);
          var prev = prevLookup[id];
          var entryPrev = prevLookup[helpers.getPtId(entry)];
          var next;
  
          if(entryPrev) {
              var a = (pt.x1 > entryPrev.x1 ? 2 * Math.PI : 0) + baseX;
              // if pt to remove:
              // - if 'below' where the root-node used to be: shrink it radially inward
              // - otherwise, collapse it clockwise or counterclockwise which ever is shortest to theta=0
              next = pt.rpx1 < entryPrev.rpx1 ? {rpx0: 0, rpx1: 0} : {x0: a, x1: a};
          } else {
              // this happens when maxdepth is set, when leaves must
              // be removed and the rootPt is new (i.e. does not have a 'prev' object)
              var parent;
              var parentId = helpers.getPtId(pt.parent);
              slices.each(function(pt2) {
                  if(helpers.getPtId(pt2) === parentId) {
                      return parent = pt2;
                  }
              });
              var parentChildren = parent.children;
              var ci;
              parentChildren.forEach(function(pt2, i) {
                  if(helpers.getPtId(pt2) === id) {
                      return ci = i;
                  }
              });
              var n = parentChildren.length;
              var interp = d3.interpolate(parent.x0, parent.x1);
              next = {
                  rpx0: rMax, rpx1: rMax,
                  x0: interp(ci / n), x1: interp((ci + 1) / n)
              };
          }
  
          return d3.interpolate(prev, next);
      }
  
      function makeUpdateSliceInterpolator(pt) {
          var prev0 = prevLookup[helpers.getPtId(pt)];
          var prev;
          var next = {x0: pt.x0, x1: pt.x1, rpx0: pt.rpx0, rpx1: pt.rpx1};
  
          if(prev0) {
              // if pt already on graph, this is easy
              prev = prev0;
          } else {
              // for new pts:
              if(prevEntry) {
                  // if trace was visible before
                  if(pt.parent) {
                      if(nextX1ofPrevEntry) {
                          // if new branch, twist it in clockwise or
                          // counterclockwise which ever is shorter to
                          // its final angle
                          var a = (pt.x1 > nextX1ofPrevEntry ? 2 * Math.PI : 0) + baseX;
                          prev = {x0: a, x1: a};
                      } else {
                          // if new leaf (when maxdepth is set),
                          // grow it radially and angularly from
                          // its parent node
                          prev = {rpx0: rMax, rpx1: rMax};
                          Lib.extendFlat(prev, interpX0X1FromParent(pt));
                      }
                  } else {
                      // if new root-node, grow it radially
                      prev = {rpx0: 0, rpx1: 0};
                  }
              } else {
                  // start sector of new traces from theta=0
                  prev = {x0: baseX, x1: baseX};
              }
          }
  
          return d3.interpolate(prev, next);
      }
  
      function makeUpdateTextInterpolator(pt) {
          var prev0 = prevLookup[helpers.getPtId(pt)];
          var prev;
          var transform = pt.transform;
  
          if(prev0) {
              prev = prev0;
          } else {
              prev = {
                  rpx1: pt.rpx1,
                  transform: {
                      textPosAngle: transform.textPosAngle,
                      scale: 0,
                      rotate: transform.rotate,
                      rCenter: transform.rCenter,
                      x: transform.x,
                      y: transform.y
                  }
              };
  
              // for new pts:
              if(prevEntry) {
                  // if trace was visible before
                  if(pt.parent) {
                      if(nextX1ofPrevEntry) {
                          // if new branch, twist it in clockwise or
                          // counterclockwise which ever is shorter to
                          // its final angle
                          var a = pt.x1 > nextX1ofPrevEntry ? 2 * Math.PI : 0;
                          prev.x0 = prev.x1 = a;
                      } else {
                          // if leaf
                          Lib.extendFlat(prev, interpX0X1FromParent(pt));
                      }
                  } else {
                      // if new root-node
                      prev.x0 = prev.x1 = baseX;
                  }
              } else {
                  // on new traces
                  prev.x0 = prev.x1 = baseX;
              }
          }
  
          var textPosAngleFn = d3.interpolate(prev.transform.textPosAngle, pt.transform.textPosAngle);
          var rpx1Fn = d3.interpolate(prev.rpx1, pt.rpx1);
          var x0Fn = d3.interpolate(prev.x0, pt.x0);
          var x1Fn = d3.interpolate(prev.x1, pt.x1);
          var scaleFn = d3.interpolate(prev.transform.scale, transform.scale);
          var rotateFn = d3.interpolate(prev.transform.rotate, transform.rotate);
  
          // smooth out start/end from entry, to try to keep text inside sector
          // while keeping transition smooth
          var pow = transform.rCenter === 0 ? 3 :
              prev.transform.rCenter === 0 ? 1 / 3 :
              1;
          var _rCenterFn = d3.interpolate(prev.transform.rCenter, transform.rCenter);
          var rCenterFn = function(t) { return _rCenterFn(Math.pow(t, pow)); };
  
          return function(t) {
              var rpx1 = rpx1Fn(t);
              var x0 = x0Fn(t);
              var x1 = x1Fn(t);
              var rCenter = rCenterFn(t);
              var pxmid = rx2px(rpx1, (x0 + x1) / 2);
              var textPosAngle = textPosAngleFn(t);
  
              var d = {
                  pxmid: pxmid,
                  rpx1: rpx1,
                  transform: {
                      textPosAngle: textPosAngle,
                      rCenter: rCenter,
                      x: transform.x,
                      y: transform.y
                  }
              };
  
              recordMinTextSize(trace.type, transform, fullLayout);
              return {
                  transform: {
                      targetX: getTargetX(d),
                      targetY: getTargetY(d),
                      scale: scaleFn(t),
                      rotate: rotateFn(t),
                      rCenter: rCenter
                  }
              };
          };
      }
  
      function interpX0X1FromParent(pt) {
          var parent = pt.parent;
          var parentPrev = prevLookup[helpers.getPtId(parent)];
          var out = {};
  
          if(parentPrev) {
              // if parent is visible
              var parentChildren = parent.children;
              var ci = parentChildren.indexOf(pt);
              var n = parentChildren.length;
              var interp = d3.interpolate(parentPrev.x0, parentPrev.x1);
              out.x0 = interp(ci / n);
              out.x1 = interp(ci / n);
          } else {
              // w/o visible parent
              // TODO !!! HOW ???
              out.x0 = out.x1 = 0;
          }
  
          return out;
      }
  }
  
  // x[0-1] keys are angles [radians]
  // y[0-1] keys are hierarchy heights [integers]
  function partition(entry) {
      return d3Hierarchy.partition()
          .size([2 * Math.PI, entry.height + 1])(entry);
  }
  
  exports.formatSliceLabel = function(pt, entry, trace, cd, fullLayout) {
      var texttemplate = trace.texttemplate;
      var textinfo = trace.textinfo;
  
      if(!texttemplate && (!textinfo || textinfo === 'none')) {
          return '';
      }
  
      var separators = fullLayout.separators;
      var cd0 = cd[0];
      var cdi = pt.data.data;
      var hierarchy = cd0.hierarchy;
      var isRoot = helpers.isHierarchyRoot(pt);
      var parent = helpers.getParent(hierarchy, pt);
      var val = helpers.getValue(pt);
  
      if(!texttemplate) {
          var parts = textinfo.split('+');
          var hasFlag = function(flag) { return parts.indexOf(flag) !== -1; };
          var thisText = [];
          var tx;
  
          if(hasFlag('label') && cdi.label) {
              thisText.push(cdi.label);
          }
  
          if(cdi.hasOwnProperty('v') && hasFlag('value')) {
              thisText.push(helpers.formatValue(cdi.v, separators));
          }
  
          if(!isRoot) {
              if(hasFlag('current path')) {
                  thisText.push(helpers.getPath(pt.data));
              }
  
              var nPercent = 0;
              if(hasFlag('percent parent')) nPercent++;
              if(hasFlag('percent entry')) nPercent++;
              if(hasFlag('percent root')) nPercent++;
              var hasMultiplePercents = nPercent > 1;
  
              if(nPercent) {
                  var percent;
                  var addPercent = function(key) {
                      tx = helpers.formatPercent(percent, separators);
  
                      if(hasMultiplePercents) tx += ' of ' + key;
                      thisText.push(tx);
                  };
  
                  if(hasFlag('percent parent') && !isRoot) {
                      percent = val / helpers.getValue(parent);
                      addPercent('parent');
                  }
                  if(hasFlag('percent entry')) {
                      percent = val / helpers.getValue(entry);
                      addPercent('entry');
                  }
                  if(hasFlag('percent root')) {
                      percent = val / helpers.getValue(hierarchy);
                      addPercent('root');
                  }
              }
          }
  
          if(hasFlag('text')) {
              tx = Lib.castOption(trace, cdi.i, 'text');
              if(Lib.isValidTextValue(tx)) thisText.push(tx);
          }
  
          return thisText.join('<br>');
      }
  
      var txt = Lib.castOption(trace, cdi.i, 'texttemplate');
      if(!txt) return '';
      var obj = {};
      if(cdi.label) obj.label = cdi.label;
      if(cdi.hasOwnProperty('v')) {
          obj.value = cdi.v;
          obj.valueLabel = helpers.formatValue(cdi.v, separators);
      }
  
      obj.currentPath = helpers.getPath(pt.data);
  
      if(!isRoot) {
          obj.percentParent = val / helpers.getValue(parent);
          obj.percentParentLabel = helpers.formatPercent(
              obj.percentParent, separators
          );
          obj.parent = helpers.getPtLabel(parent);
      }
  
      obj.percentEntry = val / helpers.getValue(entry);
      obj.percentEntryLabel = helpers.formatPercent(
          obj.percentEntry, separators
      );
      obj.entry = helpers.getPtLabel(entry);
  
      obj.percentRoot = val / helpers.getValue(hierarchy);
      obj.percentRootLabel = helpers.formatPercent(
          obj.percentRoot, separators
      );
      obj.root = helpers.getPtLabel(hierarchy);
  
      if(cdi.hasOwnProperty('color')) {
          obj.color = cdi.color;
      }
      var ptTx = Lib.castOption(trace, cdi.i, 'text');
      if(Lib.isValidTextValue(ptTx) || ptTx === '') obj.text = ptTx;
      obj.customdata = Lib.castOption(trace, cdi.i, 'customdata');
      return Lib.texttemplateString(txt, obj, fullLayout._d3locale, obj, trace._meta || {});
  };
  
  function getInscribedRadiusFraction(pt) {
      if(pt.rpx0 === 0 && Lib.isFullCircle([pt.x0, pt.x1])) {
          // special case of 100% with no hole
          return 1;
      } else {
          return Math.max(0, Math.min(
              1 / (1 + 1 / Math.sin(pt.halfangle)),
              pt.ring / 2
          ));
      }
  }
  
  function getTextXY(d) {
      return getCoords(d.rpx1, d.transform.textPosAngle);
  }
  
  function getCoords(r, angle) {
      return [r * Math.sin(angle), -r * Math.cos(angle)];
  }
  
  },{"../../components/drawing":637,"../../lib":750,"../../lib/svg_text_utils":774,"../bar/style":906,"../bar/uniform_text":908,"../pie/helpers":1137,"../pie/plot":1141,"./constants":1273,"./fx":1275,"./helpers":1276,"./style":1281,"d3":169,"d3-hierarchy":161}],1281:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Color = _dereq_('../../components/color');
  var Lib = _dereq_('../../lib');
  var resizeText = _dereq_('../bar/uniform_text').resizeText;
  
  function style(gd) {
      var s = gd._fullLayout._sunburstlayer.selectAll('.trace');
      resizeText(gd, s, 'sunburst');
  
      s.each(function(cd) {
          var gTrace = d3.select(this);
          var cd0 = cd[0];
          var trace = cd0.trace;
  
          gTrace.style('opacity', trace.opacity);
  
          gTrace.selectAll('path.surface').each(function(pt) {
              d3.select(this).call(styleOne, pt, trace);
          });
      });
  }
  
  function styleOne(s, pt, trace) {
      var cdi = pt.data.data;
      var isLeaf = !pt.children;
      var ptNumber = cdi.i;
      var lineColor = Lib.castOption(trace, ptNumber, 'marker.line.color') || Color.defaultLine;
      var lineWidth = Lib.castOption(trace, ptNumber, 'marker.line.width') || 0;
  
      s.style('stroke-width', lineWidth)
          .call(Color.fill, cdi.color)
          .call(Color.stroke, lineColor)
          .style('opacity', isLeaf ? trace.leaf.opacity : null);
  }
  
  module.exports = {
      style: style,
      styleOne: styleOne
  };
  
  },{"../../components/color":615,"../../lib":750,"../bar/uniform_text":908,"d3":169}],1282:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Color = _dereq_('../../components/color');
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var baseAttrs = _dereq_('../../plots/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  function makeContourProjAttr(axLetter) {
      return {
          valType: 'boolean',
          
          dflt: false,
          
      };
  }
  
  function makeContourAttr(axLetter) {
      return {
          show: {
              valType: 'boolean',
              
              dflt: false,
              
          },
          start: {
              valType: 'number',
              dflt: null,
              
              editType: 'plot',
           // impliedEdits: {'^autocontour': false},
              
          },
          end: {
              valType: 'number',
              dflt: null,
              
              editType: 'plot',
           // impliedEdits: {'^autocontour': false},
              
          },
          size: {
              valType: 'number',
              dflt: null,
              min: 0,
              
              editType: 'plot',
           // impliedEdits: {'^autocontour': false},
              
          },
          project: {
              x: makeContourProjAttr('x'),
              y: makeContourProjAttr('y'),
              z: makeContourProjAttr('z')
          },
          color: {
              valType: 'color',
              
              dflt: Color.defaultLine,
              
          },
          usecolormap: {
              valType: 'boolean',
              
              dflt: false,
              
          },
          width: {
              valType: 'number',
              
              min: 1,
              max: 16,
              dflt: 2,
              
          },
          highlight: {
              valType: 'boolean',
              
              dflt: true,
              
          },
          highlightcolor: {
              valType: 'color',
              
              dflt: Color.defaultLine,
              
          },
          highlightwidth: {
              valType: 'number',
              
              min: 1,
              max: 16,
              dflt: 2,
              
          }
      };
  }
  
  var attrs = module.exports = overrideAll(extendFlat({
      z: {
          valType: 'data_array',
          
      },
      x: {
          valType: 'data_array',
          
      },
      y: {
          valType: 'data_array',
          
      },
  
      text: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          
      },
      hovertext: {
          valType: 'string',
          
          dflt: '',
          arrayOk: true,
          
      },
      hovertemplate: hovertemplateAttrs(),
  
      connectgaps: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'calc',
          
      },
  
      surfacecolor: {
          valType: 'data_array',
          
      },
  },
  
  colorScaleAttrs('', {
      colorAttr: 'z or surfacecolor',
      showScaleDflt: true,
      autoColorDflt: false,
      editTypeOverride: 'calc'
  }), {
      contours: {
          x: makeContourAttr('x'),
          y: makeContourAttr('y'),
          z: makeContourAttr('z')
      },
      hidesurface: {
          valType: 'boolean',
          
          dflt: false,
          
      },
  
      lightposition: {
          x: {
              valType: 'number',
              
              min: -1e5,
              max: 1e5,
              dflt: 10,
              
          },
          y: {
              valType: 'number',
              
              min: -1e5,
              max: 1e5,
              dflt: 1e4,
              
          },
          z: {
              valType: 'number',
              
              min: -1e5,
              max: 1e5,
              dflt: 0,
              
          }
      },
  
      lighting: {
          ambient: {
              valType: 'number',
              
              min: 0.00,
              max: 1.0,
              dflt: 0.8,
              
          },
          diffuse: {
              valType: 'number',
              
              min: 0.00,
              max: 1.00,
              dflt: 0.8,
              
          },
          specular: {
              valType: 'number',
              
              min: 0.00,
              max: 2.00,
              dflt: 0.05,
              
          },
          roughness: {
              valType: 'number',
              
              min: 0.00,
              max: 1.00,
              dflt: 0.5,
              
          },
          fresnel: {
              valType: 'number',
              
              min: 0.00,
              max: 5.00,
              dflt: 0.2,
              
          }
      },
  
      opacity: {
          valType: 'number',
          
          min: 0,
          max: 1,
          dflt: 1,
          
      },
  
      opacityscale: {
          valType: 'any',
          
          editType: 'calc',
          
      },
  
      _deprecated: {
          zauto: extendFlat({}, colorScaleAttrs.zauto, {
              
          }),
          zmin: extendFlat({}, colorScaleAttrs.zmin, {
              
          }),
          zmax: extendFlat({}, colorScaleAttrs.zmax, {
              
          })
      },
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false}),
  }), 'calc', 'nested');
  
  attrs.x.editType = attrs.y.editType = attrs.z.editType = 'calc+clearAxisTypes';
  attrs.transforms = undefined;
  
  },{"../../components/color":615,"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plots/attributes":795,"../../plots/template_attributes":877}],1283:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var colorscaleCalc = _dereq_('../../components/colorscale/calc');
  
  
  // Compute auto-z and autocolorscale if applicable
  module.exports = function calc(gd, trace) {
      if(trace.surfacecolor) {
          colorscaleCalc(gd, trace, {
              vals: trace.surfacecolor,
              containerStr: '',
              cLetter: 'c'
          });
      } else {
          colorscaleCalc(gd, trace, {
              vals: trace.z,
              containerStr: '',
              cLetter: 'c'
          });
      }
  };
  
  },{"../../components/colorscale/calc":623}],1284:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  
  'use strict';
  
  var createSurface = _dereq_('gl-surface3d');
  
  var ndarray = _dereq_('ndarray');
  var ndarrayInterp2d = _dereq_('ndarray-linear-interpolate').d2;
  
  var interp2d = _dereq_('../heatmap/interp2d');
  var findEmpties = _dereq_('../heatmap/find_empties');
  
  var isArrayOrTypedArray = _dereq_('../../lib').isArrayOrTypedArray;
  var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
  var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
  var extractOpts = _dereq_('../../components/colorscale').extractOpts;
  
  function SurfaceTrace(scene, surface, uid) {
      this.scene = scene;
      this.uid = uid;
      this.surface = surface;
      this.data = null;
      this.showContour = [false, false, false];
      this.contourStart = [null, null, null];
      this.contourEnd = [null, null, null];
      this.contourSize = [0, 0, 0];
      this.minValues = [Infinity, Infinity, Infinity];
      this.maxValues = [-Infinity, -Infinity, -Infinity];
      this.dataScaleX = 1.0;
      this.dataScaleY = 1.0;
      this.refineData = true;
      this.objectOffset = [0, 0, 0];
  }
  
  var proto = SurfaceTrace.prototype;
  
  proto.getXat = function(a, b, calendar, axis) {
      var v = (
         (!isArrayOrTypedArray(this.data.x)) ?
              a :
         (isArrayOrTypedArray(this.data.x[0])) ?
              this.data.x[b][a] :
              this.data.x[a]
      );
  
      return (calendar === undefined) ? v : axis.d2l(v, 0, calendar);
  };
  
  proto.getYat = function(a, b, calendar, axis) {
      var v = (
         (!isArrayOrTypedArray(this.data.y)) ?
              b :
         (isArrayOrTypedArray(this.data.y[0])) ?
              this.data.y[b][a] :
              this.data.y[b]
      );
  
      return (calendar === undefined) ? v : axis.d2l(v, 0, calendar);
  };
  
  proto.getZat = function(a, b, calendar, axis) {
      var v = this.data.z[b][a];
  
      if(v === null && this.data.connectgaps && this.data._interpolatedZ) {
          v = this.data._interpolatedZ[b][a];
      }
  
      return (calendar === undefined) ? v : axis.d2l(v, 0, calendar);
  };
  
  proto.handlePick = function(selection) {
      if(selection.object === this.surface) {
          var xRatio = (selection.data.index[0] - 1) / this.dataScaleX - 1;
          var yRatio = (selection.data.index[1] - 1) / this.dataScaleY - 1;
  
          var j = Math.max(Math.min(Math.round(xRatio), this.data.z[0].length - 1), 0);
          var k = Math.max(Math.min(Math.round(yRatio), this.data._ylength - 1), 0);
  
          selection.index = [j, k];
  
          selection.traceCoordinate = [
              this.getXat(j, k),
              this.getYat(j, k),
              this.getZat(j, k)
          ];
  
          selection.dataCoordinate = [
              this.getXat(j, k, this.data.xcalendar, this.scene.fullSceneLayout.xaxis),
              this.getYat(j, k, this.data.ycalendar, this.scene.fullSceneLayout.yaxis),
              this.getZat(j, k, this.data.zcalendar, this.scene.fullSceneLayout.zaxis)
          ];
  
          for(var i = 0; i < 3; i++) {
              var v = selection.dataCoordinate[i];
              if(v !== null && v !== undefined) {
                  selection.dataCoordinate[i] *= this.scene.dataScale[i];
              }
          }
  
          var text = this.data.hovertext || this.data.text;
          if(Array.isArray(text) && text[k] && text[k][j] !== undefined) {
              selection.textLabel = text[k][j];
          } else if(text) {
              selection.textLabel = text;
          } else {
              selection.textLabel = '';
          }
  
          selection.data.dataCoordinate = selection.dataCoordinate.slice();
  
          this.surface.highlight(selection.data);
  
          // Snap spikes to data coordinate
          this.scene.glplot.spikes.position = selection.dataCoordinate;
  
          return true;
      }
  };
  
  function isColormapCircular(colormap) {
      var first = colormap[0].rgb;
      var last = colormap[colormap.length - 1].rgb;
  
      return (
          first[0] === last[0] &&
          first[1] === last[1] &&
          first[2] === last[2] &&
          first[3] === last[3]
      );
  }
  
  var shortPrimes = [
      2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97,
      101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199,
      211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293,
      307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397,
      401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499,
      503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599,
      601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691,
      701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797,
      809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887,
      907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997,
      1009, 1013, 1019, 1021, 1031, 1033, 1039, 1049, 1051, 1061, 1063, 1069, 1087, 1091, 1093, 1097,
      1103, 1109, 1117, 1123, 1129, 1151, 1153, 1163, 1171, 1181, 1187, 1193,
      1201, 1213, 1217, 1223, 1229, 1231, 1237, 1249, 1259, 1277, 1279, 1283, 1289, 1291, 1297,
      1301, 1303, 1307, 1319, 1321, 1327, 1361, 1367, 1373, 1381, 1399,
      1409, 1423, 1427, 1429, 1433, 1439, 1447, 1451, 1453, 1459, 1471, 1481, 1483, 1487, 1489, 1493, 1499,
      1511, 1523, 1531, 1543, 1549, 1553, 1559, 1567, 1571, 1579, 1583, 1597,
      1601, 1607, 1609, 1613, 1619, 1621, 1627, 1637, 1657, 1663, 1667, 1669, 1693, 1697, 1699,
      1709, 1721, 1723, 1733, 1741, 1747, 1753, 1759, 1777, 1783, 1787, 1789,
      1801, 1811, 1823, 1831, 1847, 1861, 1867, 1871, 1873, 1877, 1879, 1889,
      1901, 1907, 1913, 1931, 1933, 1949, 1951, 1973, 1979, 1987, 1993, 1997, 1999,
      2003, 2011, 2017, 2027, 2029, 2039, 2053, 2063, 2069, 2081, 2083, 2087, 2089, 2099,
      2111, 2113, 2129, 2131, 2137, 2141, 2143, 2153, 2161, 2179,
      2203, 2207, 2213, 2221, 2237, 2239, 2243, 2251, 2267, 2269, 2273, 2281, 2287, 2293, 2297,
      2309, 2311, 2333, 2339, 2341, 2347, 2351, 2357, 2371, 2377, 2381, 2383, 2389, 2393, 2399,
      2411, 2417, 2423, 2437, 2441, 2447, 2459, 2467, 2473, 2477,
      2503, 2521, 2531, 2539, 2543, 2549, 2551, 2557, 2579, 2591, 2593,
      2609, 2617, 2621, 2633, 2647, 2657, 2659, 2663, 2671, 2677, 2683, 2687, 2689, 2693, 2699,
      2707, 2711, 2713, 2719, 2729, 2731, 2741, 2749, 2753, 2767, 2777, 2789, 2791, 2797,
      2801, 2803, 2819, 2833, 2837, 2843, 2851, 2857, 2861, 2879, 2887, 2897,
      2903, 2909, 2917, 2927, 2939, 2953, 2957, 2963, 2969, 2971, 2999
  ];
  
  function getPow(a, b) {
      if(a < b) return 0;
      var n = 0;
      while(Math.floor(a % b) === 0) {
          a /= b;
          n++;
      }
      return n;
  }
  
  function getFactors(a) {
      var powers = [];
      for(var i = 0; i < shortPrimes.length; i++) {
          var b = shortPrimes[i];
          powers.push(
              getPow(a, b)
          );
      }
      return powers;
  }
  
  function smallestDivisor(a) {
      var A = getFactors(a);
      var result = a;
      for(var i = 0; i < shortPrimes.length; i++) {
          if(A[i] > 0) {
              result = shortPrimes[i];
              break;
          }
      }
      return result;
  }
  
  function leastCommonMultiple(a, b) {
      if(a < 1 || b < 1) return undefined;
      var A = getFactors(a);
      var B = getFactors(b);
      var n = 1;
      for(var i = 0; i < shortPrimes.length; i++) {
          n *= Math.pow(
              shortPrimes[i], Math.max(A[i], B[i])
          );
      }
      return n;
  }
  
  function arrayLCM(A) {
      if(A.length === 0) return undefined;
      var n = 1;
      for(var i = 0; i < A.length; i++) {
          n = leastCommonMultiple(n, A[i]);
      }
      return n;
  }
  
  proto.calcXnums = function(xlen) {
      var i;
      var nums = [];
      for(i = 1; i < xlen; i++) {
          var a = this.getXat(i - 1, 0);
          var b = this.getXat(i, 0);
  
          if(b !== a &&
              a !== undefined && a !== null &&
              b !== undefined && b !== null) {
              nums[i - 1] = Math.abs(b - a);
          } else {
              nums[i - 1] = 0;
          }
      }
  
      var totalDist = 0;
      for(i = 1; i < xlen; i++) {
          totalDist += nums[i - 1];
      }
  
      for(i = 1; i < xlen; i++) {
          if(nums[i - 1] === 0) {
              nums[i - 1] = 1;
          } else {
              nums[i - 1] = Math.round(totalDist / nums[i - 1]);
          }
      }
  
      return nums;
  };
  
  proto.calcYnums = function(ylen) {
      var i;
      var nums = [];
      for(i = 1; i < ylen; i++) {
          var a = this.getYat(0, i - 1);
          var b = this.getYat(0, i);
  
          if(b !== a &&
              a !== undefined && a !== null &&
              b !== undefined && b !== null) {
              nums[i - 1] = Math.abs(b - a);
          } else {
              nums[i - 1] = 0;
          }
      }
  
      var totalDist = 0;
      for(i = 1; i < ylen; i++) {
          totalDist += nums[i - 1];
      }
  
      for(i = 1; i < ylen; i++) {
          if(nums[i - 1] === 0) {
              nums[i - 1] = 1;
          } else {
              nums[i - 1] = Math.round(totalDist / nums[i - 1]);
          }
      }
  
      return nums;
  };
  
  var highlyComposites = [1, 2, 4, 6, 12, 24, 36, 48, 60, 120, 180, 240, 360, 720, 840, 1260];
  
  var MIN_RESOLUTION = highlyComposites[9];
  var MAX_RESOLUTION = highlyComposites[13];
  
  proto.estimateScale = function(resSrc, axis) {
      var nums = (axis === 0) ?
          this.calcXnums(resSrc) :
          this.calcYnums(resSrc);
  
      var resDst = 1 + arrayLCM(nums);
  
      while(resDst < MIN_RESOLUTION) {
          resDst *= 2;
      }
  
      while(resDst > MAX_RESOLUTION) {
          resDst--;
          resDst /= smallestDivisor(resDst);
          resDst++;
  
          if(resDst < MIN_RESOLUTION) {
           // resDst = MIN_RESOLUTION; // option 1: use min resolution
              resDst = MAX_RESOLUTION; // option 2: use max resolution
          }
      }
  
      var scale = Math.round(resDst / resSrc);
      return (scale > 1) ? scale : 1;
  };
  
  // based on Mikola Lysenko's ndarray-homography
  // see https://github.com/scijs/ndarray-homography
  
  function fnHomography(out, inp, X) {
      var w = X[8] + X[2] * inp[0] + X[5] * inp[1];
      out[0] = (X[6] + X[0] * inp[0] + X[3] * inp[1]) / w;
      out[1] = (X[7] + X[1] * inp[0] + X[4] * inp[1]) / w;
      return out;
  }
  
  function homography(dest, src, X) {
      warp(dest, src, fnHomography, X);
      return dest;
  }
  
  // based on Mikola Lysenko's ndarray-warp
  // see https://github.com/scijs/ndarray-warp
  
  function warp(dest, src, func, X) {
      var warped = [0, 0];
      var ni = dest.shape[0];
      var nj = dest.shape[1];
      for(var i = 0; i < ni; i++) {
          for(var j = 0; j < nj; j++) {
              func(warped, [i, j], X);
              dest.set(i, j, ndarrayInterp2d(src, warped[0], warped[1]));
          }
      }
      return dest;
  }
  
  proto.refineCoords = function(coords) {
      var scaleW = this.dataScaleX;
      var scaleH = this.dataScaleY;
  
      var width = coords[0].shape[0];
      var height = coords[0].shape[1];
  
      var newWidth = Math.floor(coords[0].shape[0] * scaleW + 1) | 0;
      var newHeight = Math.floor(coords[0].shape[1] * scaleH + 1) | 0;
  
      // Pad coords by +1
      var padWidth = 1 + width + 1;
      var padHeight = 1 + height + 1;
      var padImg = ndarray(new Float32Array(padWidth * padHeight), [padWidth, padHeight]);
      var X = [
          1 / scaleW, 0, 0,
          0, 1 / scaleH, 0,
          0, 0, 1
      ];
  
      for(var i = 0; i < coords.length; ++i) {
          this.surface.padField(padImg, coords[i]);
  
          var scaledImg = ndarray(new Float32Array(newWidth * newHeight), [newWidth, newHeight]);
          homography(scaledImg, padImg, X);
          coords[i] = scaledImg;
      }
  };
  
  function insertIfNewLevel(arr, newValue) {
      var found = false;
      for(var k = 0; k < arr.length; k++) {
          if(newValue === arr[k]) {
              found = true;
              break;
          }
      }
      if(found === false) arr.push(newValue);
  }
  
  proto.setContourLevels = function() {
      var newLevels = [[], [], []];
      var useNewLevels = [false, false, false];
      var needsUpdate = false;
  
      var i, j, value;
  
      for(i = 0; i < 3; ++i) {
          if(this.showContour[i]) {
              needsUpdate = true;
  
              if(
                  this.contourSize[i] > 0 &&
                  this.contourStart[i] !== null &&
                  this.contourEnd[i] !== null &&
                  this.contourEnd[i] > this.contourStart[i]
              ) {
                  useNewLevels[i] = true;
  
                  for(j = this.contourStart[i]; j < this.contourEnd[i]; j += this.contourSize[i]) {
                      value = j * this.scene.dataScale[i];
  
                      insertIfNewLevel(newLevels[i], value);
                  }
              }
          }
      }
  
      if(needsUpdate) {
          var allLevels = [[], [], []];
          for(i = 0; i < 3; ++i) {
              if(this.showContour[i]) {
                  allLevels[i] = useNewLevels[i] ? newLevels[i] : this.scene.contourLevels[i];
              }
          }
          this.surface.update({ levels: allLevels });
      }
  };
  
  proto.update = function(data) {
      var scene = this.scene;
      var sceneLayout = scene.fullSceneLayout;
      var surface = this.surface;
      var colormap = parseColorScale(data);
      var scaleFactor = scene.dataScale;
      var xlen = data.z[0].length;
      var ylen = data._ylength;
      var contourLevels = scene.contourLevels;
  
      // Save data
      this.data = data;
  
      /*
       * Fill and transpose zdata.
       * Consistent with 'heatmap' and 'contour', plotly 'surface'
       * 'z' are such that sub-arrays correspond to y-coords
       * and that the sub-array entries correspond to a x-coords,
       * which is the transpose of 'gl-surface-plot'.
       */
  
      var i, j, k, v;
      var rawCoords = [];
      for(i = 0; i < 3; i++) {
          rawCoords[i] = [];
          for(j = 0; j < xlen; j++) {
              rawCoords[i][j] = [];
              /*
              for(k = 0; k < ylen; k++) {
                  rawCoords[i][j][k] = undefined;
              }
              */
          }
      }
  
      // coords x, y & z
      for(j = 0; j < xlen; j++) {
          for(k = 0; k < ylen; k++) {
              rawCoords[0][j][k] = this.getXat(j, k, data.xcalendar, sceneLayout.xaxis);
              rawCoords[1][j][k] = this.getYat(j, k, data.ycalendar, sceneLayout.yaxis);
              rawCoords[2][j][k] = this.getZat(j, k, data.zcalendar, sceneLayout.zaxis);
          }
      }
  
      if(data.connectgaps) {
          data._emptypoints = findEmpties(rawCoords[2]);
          interp2d(rawCoords[2], data._emptypoints);
  
          data._interpolatedZ = [];
          for(j = 0; j < xlen; j++) {
              data._interpolatedZ[j] = [];
              for(k = 0; k < ylen; k++) {
                  data._interpolatedZ[j][k] = rawCoords[2][j][k];
              }
          }
      }
  
      // Note: log axes are not defined in surfaces yet.
      // but they could be defined here...
  
      for(i = 0; i < 3; i++) {
          for(j = 0; j < xlen; j++) {
              for(k = 0; k < ylen; k++) {
                  v = rawCoords[i][j][k];
                  if(v === null || v === undefined) {
                      rawCoords[i][j][k] = NaN;
                  } else {
                      v = rawCoords[i][j][k] *= scaleFactor[i];
                  }
              }
          }
      }
  
      for(i = 0; i < 3; i++) {
          for(j = 0; j < xlen; j++) {
              for(k = 0; k < ylen; k++) {
                  v = rawCoords[i][j][k];
                  if(v !== null && v !== undefined) {
                      if(this.minValues[i] > v) {
                          this.minValues[i] = v;
                      }
                      if(this.maxValues[i] < v) {
                          this.maxValues[i] = v;
                      }
                  }
              }
          }
      }
  
      for(i = 0; i < 3; i++) {
          this.objectOffset[i] = 0.5 * (this.minValues[i] + this.maxValues[i]);
      }
  
      for(i = 0; i < 3; i++) {
          for(j = 0; j < xlen; j++) {
              for(k = 0; k < ylen; k++) {
                  v = rawCoords[i][j][k];
                  if(v !== null && v !== undefined) {
                      rawCoords[i][j][k] -= this.objectOffset[i];
                  }
              }
          }
      }
  
      // convert processed raw data to Float32 matrices
      var coords = [
          ndarray(new Float32Array(xlen * ylen), [xlen, ylen]),
          ndarray(new Float32Array(xlen * ylen), [xlen, ylen]),
          ndarray(new Float32Array(xlen * ylen), [xlen, ylen])
      ];
      for(i = 0; i < 3; i++) {
          for(j = 0; j < xlen; j++) {
              for(k = 0; k < ylen; k++) {
                  coords[i].set(j, k, rawCoords[i][j][k]);
              }
          }
      }
      rawCoords = []; // free memory
  
      var params = {
          colormap: colormap,
          levels: [[], [], []],
          showContour: [true, true, true],
          showSurface: !data.hidesurface,
          contourProject: [
              [false, false, false],
              [false, false, false],
              [false, false, false]
          ],
          contourWidth: [1, 1, 1],
          contourColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
          contourTint: [1, 1, 1],
          dynamicColor: [[1, 1, 1, 1], [1, 1, 1, 1], [1, 1, 1, 1]],
          dynamicWidth: [1, 1, 1],
          dynamicTint: [1, 1, 1],
          opacityscale: data.opacityscale,
          opacity: data.opacity
      };
  
      var cOpts = extractOpts(data);
      params.intensityBounds = [cOpts.min, cOpts.max];
  
      // Refine surface color if necessary
      if(data.surfacecolor) {
          var intensity = ndarray(new Float32Array(xlen * ylen), [xlen, ylen]);
  
          for(j = 0; j < xlen; j++) {
              for(k = 0; k < ylen; k++) {
                  intensity.set(j, k, data.surfacecolor[k][j]);
              }
          }
  
          coords.push(intensity);
      } else {
          // when 'z' is used as 'intensity',
          // we must scale its value
          params.intensityBounds[0] *= scaleFactor[2];
          params.intensityBounds[1] *= scaleFactor[2];
      }
  
      if(MAX_RESOLUTION < coords[0].shape[0] ||
          MAX_RESOLUTION < coords[0].shape[1]) {
          this.refineData = false;
      }
  
      if(this.refineData === true) {
          this.dataScaleX = this.estimateScale(coords[0].shape[0], 0);
          this.dataScaleY = this.estimateScale(coords[0].shape[1], 1);
          if(this.dataScaleX !== 1 || this.dataScaleY !== 1) {
              this.refineCoords(coords);
          }
      }
  
      if(data.surfacecolor) {
          params.intensity = coords.pop();
      }
  
      var highlightEnable = [true, true, true];
      var axis = ['x', 'y', 'z'];
  
      for(i = 0; i < 3; ++i) {
          var contourParams = data.contours[axis[i]];
          highlightEnable[i] = contourParams.highlight;
  
          params.showContour[i] = contourParams.show || contourParams.highlight;
          if(!params.showContour[i]) continue;
  
          params.contourProject[i] = [
              contourParams.project.x,
              contourParams.project.y,
              contourParams.project.z
          ];
  
          if(contourParams.show) {
              this.showContour[i] = true;
              params.levels[i] = contourLevels[i];
              surface.highlightColor[i] = params.contourColor[i] = str2RgbaArray(contourParams.color);
  
              if(contourParams.usecolormap) {
                  surface.highlightTint[i] = params.contourTint[i] = 0;
              } else {
                  surface.highlightTint[i] = params.contourTint[i] = 1;
              }
              params.contourWidth[i] = contourParams.width;
  
              this.contourStart[i] = contourParams.start;
              this.contourEnd[i] = contourParams.end;
              this.contourSize[i] = contourParams.size;
          } else {
              this.showContour[i] = false;
  
              this.contourStart[i] = null;
              this.contourEnd[i] = null;
              this.contourSize[i] = 0;
          }
  
          if(contourParams.highlight) {
              params.dynamicColor[i] = str2RgbaArray(contourParams.highlightcolor);
              params.dynamicWidth[i] = contourParams.highlightwidth;
          }
      }
  
      // see https://github.com/plotly/plotly.js/issues/940
      if(isColormapCircular(colormap)) {
          params.vertexColor = true;
      }
  
      params.objectOffset = this.objectOffset;
  
      params.coords = coords;
      surface.update(params);
  
      surface.visible = data.visible;
      surface.enableDynamic = highlightEnable;
      surface.enableHighlight = highlightEnable;
  
      surface.snapToData = true;
  
      if('lighting' in data) {
          surface.ambientLight = data.lighting.ambient;
          surface.diffuseLight = data.lighting.diffuse;
          surface.specularLight = data.lighting.specular;
          surface.roughness = data.lighting.roughness;
          surface.fresnel = data.lighting.fresnel;
      }
  
      if('lightposition' in data) {
          surface.lightPosition = [data.lightposition.x, data.lightposition.y, data.lightposition.z];
      }
  };
  
  proto.dispose = function() {
      this.scene.glplot.remove(this.surface);
      this.surface.dispose();
  };
  
  function createSurfaceTrace(scene, data) {
      var gl = scene.glplot.gl;
      var surface = createSurface({ gl: gl });
      var result = new SurfaceTrace(scene, surface, data.uid);
      surface._trace = result;
      result.update(data);
      scene.glplot.add(surface);
      return result;
  }
  
  module.exports = createSurfaceTrace;
  
  },{"../../components/colorscale":627,"../../lib":750,"../../lib/gl_format_color":746,"../../lib/str2rgbarray":773,"../heatmap/find_empties":1042,"../heatmap/interp2d":1045,"gl-surface3d":325,"ndarray":469,"ndarray-linear-interpolate":463}],1285:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Registry = _dereq_('../../registry');
  var Lib = _dereq_('../../lib');
  
  var colorscaleDefaults = _dereq_('../../components/colorscale/defaults');
  var attributes = _dereq_('./attributes');
  
  var MIN = 0.1; // Note: often we don't want the data cube to be disappeared
  
  function createWave(n, minOpacity) {
      var arr = [];
      var steps = 32; // Max: 256
      for(var i = 0; i < steps; i++) {
          var u = i / (steps - 1);
          var v = minOpacity + (1 - minOpacity) * (1 - Math.pow(Math.sin(n * u * Math.PI), 2));
          arr.push([
              u,
              Math.max(0, Math.min(1, v))
          ]);
      }
      return arr;
  }
  
  function isValidScaleArray(scl) {
      var highestVal = 0;
  
      if(!Array.isArray(scl) || scl.length < 2) return false;
  
      if(!scl[0] || !scl[scl.length - 1]) return false;
  
      if(+scl[0][0] !== 0 || +scl[scl.length - 1][0] !== 1) return false;
  
      for(var i = 0; i < scl.length; i++) {
          var si = scl[i];
  
          if(si.length !== 2 || +si[0] < highestVal) {
              return false;
          }
  
          highestVal = +si[0];
      }
  
      return true;
  }
  
  function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      var i, j;
  
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var x = coerce('x');
      var y = coerce('y');
  
      var z = coerce('z');
      if(!z || !z.length ||
         (x ? (x.length < 1) : false) ||
         (y ? (y.length < 1) : false)
      ) {
          traceOut.visible = false;
          return;
      }
  
      traceOut._xlength = (Array.isArray(x) && Lib.isArrayOrTypedArray(x[0])) ? z.length : z[0].length;
      traceOut._ylength = z.length;
  
      var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleTraceDefaults');
      handleCalendarDefaults(traceIn, traceOut, ['x', 'y', 'z'], layout);
  
      coerce('text');
      coerce('hovertext');
      coerce('hovertemplate');
  
      // Coerce remaining properties
      [
          'lighting.ambient',
          'lighting.diffuse',
          'lighting.specular',
          'lighting.roughness',
          'lighting.fresnel',
          'lightposition.x',
          'lightposition.y',
          'lightposition.z',
          'hidesurface',
          'connectgaps',
          'opacity'
      ].forEach(function(x) { coerce(x); });
  
      var surfaceColor = coerce('surfacecolor');
  
      var dims = ['x', 'y', 'z'];
      for(i = 0; i < 3; ++i) {
          var contourDim = 'contours.' + dims[i];
          var show = coerce(contourDim + '.show');
          var highlight = coerce(contourDim + '.highlight');
  
          if(show || highlight) {
              for(j = 0; j < 3; ++j) {
                  coerce(contourDim + '.project.' + dims[j]);
              }
          }
  
          if(show) {
              coerce(contourDim + '.color');
              coerce(contourDim + '.width');
              coerce(contourDim + '.usecolormap');
          }
  
          if(highlight) {
              coerce(contourDim + '.highlightcolor');
              coerce(contourDim + '.highlightwidth');
          }
  
          coerce(contourDim + '.start');
          coerce(contourDim + '.end');
          coerce(contourDim + '.size');
      }
  
      // backward compatibility block
      if(!surfaceColor) {
          mapLegacy(traceIn, 'zmin', 'cmin');
          mapLegacy(traceIn, 'zmax', 'cmax');
          mapLegacy(traceIn, 'zauto', 'cauto');
      }
  
      // TODO if contours.?.usecolormap are false and hidesurface is true
      // the colorbar shouldn't be shown by default
  
      colorscaleDefaults(
          traceIn, traceOut, layout, coerce, {prefix: '', cLetter: 'c'}
      );
  
      opacityscaleDefaults(traceIn, traceOut, layout, coerce);
  
      // disable 1D transforms - currently surface does NOT support column data like heatmap does
      // you can use mesh3d for this use case, but not surface
      traceOut._length = null;
  }
  
  function opacityscaleDefaults(traceIn, traceOut, layout, coerce) {
      var opacityscale = coerce('opacityscale');
      if(opacityscale === 'max') {
          traceOut.opacityscale = [[0, MIN], [1, 1]];
      } else if(opacityscale === 'min') {
          traceOut.opacityscale = [[0, 1], [1, MIN]];
      } else if(opacityscale === 'extremes') {
          traceOut.opacityscale = createWave(1, MIN);
      } else if(!isValidScaleArray(opacityscale)) {
          traceOut.opacityscale = undefined;
      }
  }
  
  function mapLegacy(traceIn, oldAttr, newAttr) {
      if(oldAttr in traceIn && !(newAttr in traceIn)) {
          traceIn[newAttr] = traceIn[oldAttr];
      }
  }
  
  module.exports = {
      supplyDefaults: supplyDefaults,
      opacityscaleDefaults: opacityscaleDefaults
  };
  
  },{"../../components/colorscale/defaults":625,"../../lib":750,"../../registry":882,"./attributes":1282}],1286:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults').supplyDefaults,
      colorbar: {
          min: 'cmin',
          max: 'cmax'
      },
      calc: _dereq_('./calc'),
      plot: _dereq_('./convert'),
  
      moduleType: 'trace',
      name: 'surface',
      basePlotModule: _dereq_('../../plots/gl3d'),
      categories: ['gl3d', '2dMap', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"../../plots/gl3d":841,"./attributes":1282,"./calc":1283,"./convert":1284,"./defaults":1285}],1287:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var annAttrs = _dereq_('../../components/annotations/attributes');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  var fontAttrs = _dereq_('../../plots/font_attributes');
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  
  var FORMAT_LINK = _dereq_('../../constants/docs').FORMAT_LINK;
  
  var attrs = module.exports = overrideAll({
      domain: domainAttrs({name: 'table', trace: true}),
  
      columnwidth: {
          valType: 'number',
          arrayOk: true,
          dflt: null,
          
          
      },
  
      columnorder: {
          valType: 'data_array',
          
          
      },
  
      header: {
  
          values: {
              valType: 'data_array',
              
              dflt: [],
              
          },
  
          format: {
              valType: 'data_array',
              
              dflt: [],
              
          },
  
          prefix: {
              valType: 'string',
              arrayOk: true,
              dflt: null,
              
              
          },
  
          suffix: {
              valType: 'string',
              arrayOk: true,
              dflt: null,
              
              
          },
  
          height: {
              valType: 'number',
              dflt: 28,
              
              
          },
  
          align: extendFlat({}, annAttrs.align, {arrayOk: true}),
  
          line: {
              width: {
                  valType: 'number',
                  arrayOk: true,
                  dflt: 1,
                  
              },
              color: {
                  valType: 'color',
                  arrayOk: true,
                  dflt: 'grey',
                  
              }
          },
  
          fill: {
              color: {
                  valType: 'color',
                  arrayOk: true,
                  dflt: 'white',
                  
                  
              }
          },
  
          font: extendFlat({}, fontAttrs({arrayOk: true}))
      },
  
      cells: {
  
          values: {
              valType: 'data_array',
              
              dflt: [],
              
          },
  
          format: {
              valType: 'data_array',
              
              dflt: [],
              
          },
  
          prefix: {
              valType: 'string',
              arrayOk: true,
              dflt: null,
              
              
          },
  
          suffix: {
              valType: 'string',
              arrayOk: true,
              dflt: null,
              
              
          },
  
          height: {
              valType: 'number',
              dflt: 20,
              
              
          },
  
          align: extendFlat({}, annAttrs.align, {arrayOk: true}),
  
          line: {
              width: {
                  valType: 'number',
                  arrayOk: true,
                  dflt: 1,
                  
              },
              color: {
                  valType: 'color',
                  arrayOk: true,
                  dflt: 'grey',
                  
              }
          },
  
          fill: {
              color: {
                  valType: 'color',
                  arrayOk: true,
                  
                  dflt: 'white',
                  
              }
          },
  
          font: extendFlat({}, fontAttrs({arrayOk: true}))
      }
  }, 'calc', 'from-root');
  attrs.transforms = undefined;
  
  },{"../../components/annotations/attributes":598,"../../constants/docs":720,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plots/domain":826,"../../plots/font_attributes":827}],1288:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var getModuleCalcData = _dereq_('../../plots/get_data').getModuleCalcData;
  var tablePlot = _dereq_('./plot');
  
  var TABLE = 'table';
  
  exports.name = TABLE;
  
  exports.plot = function(gd) {
      var calcData = getModuleCalcData(gd.calcdata, TABLE)[0];
      if(calcData.length) tablePlot(gd, calcData);
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      var hadTable = (oldFullLayout._has && oldFullLayout._has(TABLE));
      var hasTable = (newFullLayout._has && newFullLayout._has(TABLE));
  
      if(hadTable && !hasTable) {
          oldFullLayout._paperdiv.selectAll('.table').remove();
      }
  };
  
  },{"../../plots/get_data":836,"./plot":1295}],1289:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var wrap = _dereq_('../../lib/gup').wrap;
  
  module.exports = function calc() {
      // we don't actually need to include the trace here, since that will be added
      // by Plots.doCalcdata, and that's all we actually need later.
      return wrap({});
  };
  
  },{"../../lib/gup":747}],1290:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      cellPad: 8,
      columnExtentOffset: 10,
      columnTitleOffset: 28,
      emptyHeaderHeight: 16,
      latexCheck: /^\$.*\$$/,
      goldenRatio: 1.618,
      lineBreaker: '<br>',
      maxDimensionCount: 60,
      overdrag: 45,
      releaseTransitionDuration: 120,
      releaseTransitionEase: 'cubic-out',
      scrollbarCaptureWidth: 18,
      scrollbarHideDelay: 1000,
      scrollbarHideDuration: 1000,
      scrollbarOffset: 5,
      scrollbarWidth: 8,
      transitionDuration: 100,
      transitionEase: 'cubic-out',
      uplift: 5,
      wrapSpacer: ' ',
      wrapSplitCharacter: ' ',
      cn: {
          // general class names
          table: 'table',
          tableControlView: 'table-control-view',
          scrollBackground: 'scroll-background',
          yColumn: 'y-column',
          columnBlock: 'column-block',
          scrollAreaClip: 'scroll-area-clip',
          scrollAreaClipRect: 'scroll-area-clip-rect',
          columnBoundary: 'column-boundary',
          columnBoundaryClippath: 'column-boundary-clippath',
          columnBoundaryRect: 'column-boundary-rect',
          columnCells: 'column-cells',
          columnCell: 'column-cell',
          cellRect: 'cell-rect',
          cellText: 'cell-text',
          cellTextHolder: 'cell-text-holder',
  
          // scroll related class names
          scrollbarKit: 'scrollbar-kit',
          scrollbar: 'scrollbar',
          scrollbarSlider: 'scrollbar-slider',
          scrollbarGlyph: 'scrollbar-glyph',
          scrollbarCaptureZone: 'scrollbar-capture-zone'
      }
  };
  
  },{}],1291:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var c = _dereq_('./constants');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var isNumeric = _dereq_('fast-isnumeric');
  
  // pure functions, don't alter but passes on `gd` and parts of `trace` without deep copying
  module.exports = function calc(gd, trace) {
      var cellsValues = squareStringMatrix(trace.cells.values);
      var slicer = function(a) {
          return a.slice(trace.header.values.length, a.length);
      };
      var headerValuesIn = squareStringMatrix(trace.header.values);
      if(headerValuesIn.length && !headerValuesIn[0].length) {
          headerValuesIn[0] = [''];
          headerValuesIn = squareStringMatrix(headerValuesIn);
      }
      var headerValues = headerValuesIn
          .concat(slicer(cellsValues).map(function() {
              return emptyStrings((headerValuesIn[0] || ['']).length);
          }));
  
      var domain = trace.domain;
      var groupWidth = Math.floor(gd._fullLayout._size.w * (domain.x[1] - domain.x[0]));
      var groupHeight = Math.floor(gd._fullLayout._size.h * (domain.y[1] - domain.y[0]));
      var headerRowHeights = trace.header.values.length ?
          headerValues[0].map(function() { return trace.header.height; }) :
          [c.emptyHeaderHeight];
      var rowHeights = cellsValues.length ? cellsValues[0].map(function() { return trace.cells.height; }) : [];
      var headerHeight = headerRowHeights.reduce(sum, 0);
      var scrollHeight = groupHeight - headerHeight;
      var minimumFillHeight = scrollHeight + c.uplift;
      var anchorToRowBlock = makeAnchorToRowBlock(rowHeights, minimumFillHeight);
      var anchorToHeaderRowBlock = makeAnchorToRowBlock(headerRowHeights, headerHeight);
      var headerRowBlocks = makeRowBlock(anchorToHeaderRowBlock, []);
      var rowBlocks = makeRowBlock(anchorToRowBlock, headerRowBlocks);
      var uniqueKeys = {};
      var columnOrder = trace._fullInput.columnorder.concat(slicer(cellsValues.map(function(d, i) {return i;})));
      var columnWidths = headerValues.map(function(d, i) {
          var value = Array.isArray(trace.columnwidth) ?
              trace.columnwidth[Math.min(i, trace.columnwidth.length - 1)] :
              trace.columnwidth;
          return isNumeric(value) ? Number(value) : 1;
      });
      var totalColumnWidths = columnWidths.reduce(sum, 0);
  
      // fit columns in the available vertical space as there's no vertical scrolling now
      columnWidths = columnWidths.map(function(d) { return d / totalColumnWidths * groupWidth; });
  
      var maxLineWidth = Math.max(arrayMax(trace.header.line.width), arrayMax(trace.cells.line.width));
  
      var calcdata = {
          // include staticPlot in the key so if it changes we delete and redraw
          key: trace.uid + gd._context.staticPlot,
          translateX: domain.x[0] * gd._fullLayout._size.w,
          translateY: gd._fullLayout._size.h * (1 - domain.y[1]),
          size: gd._fullLayout._size,
          width: groupWidth,
          maxLineWidth: maxLineWidth,
          height: groupHeight,
          columnOrder: columnOrder, // will be mutated on column move, todo use in callback
          groupHeight: groupHeight,
          rowBlocks: rowBlocks,
          headerRowBlocks: headerRowBlocks,
          scrollY: 0, // will be mutated on scroll
          cells: extendFlat({}, trace.cells, {values: cellsValues}),
          headerCells: extendFlat({}, trace.header, {values: headerValues}),
          gdColumns: headerValues.map(function(d) {return d[0];}),
          gdColumnsOriginalOrder: headerValues.map(function(d) {return d[0];}),
          prevPages: [0, 0],
          scrollbarState: {scrollbarScrollInProgress: false},
          columns: headerValues.map(function(label, i) {
              var foundKey = uniqueKeys[label];
              uniqueKeys[label] = (foundKey || 0) + 1;
              var key = label + '__' + uniqueKeys[label];
              return {
                  key: key,
                  label: label,
                  specIndex: i,
                  xIndex: columnOrder[i],
                  xScale: xScale,
                  x: undefined, // initialized below
                  calcdata: undefined, // initialized below
                  columnWidth: columnWidths[i]
              };
          })
      };
  
      calcdata.columns.forEach(function(col) {
          col.calcdata = calcdata;
          col.x = xScale(col);
      });
  
      return calcdata;
  };
  
  function arrayMax(maybeArray) {
      if(Array.isArray(maybeArray)) {
          var max = 0;
          for(var i = 0; i < maybeArray.length; i++) {
              max = Math.max(max, arrayMax(maybeArray[i]));
          }
          return max;
      }
      return maybeArray;
  }
  
  function sum(a, b) { return a + b; }
  
  // fill matrix in place to equal lengths
  // and ensure it's uniformly 2D
  function squareStringMatrix(matrixIn) {
      var matrix = matrixIn.slice();
      var minLen = Infinity;
      var maxLen = 0;
      var i;
      for(i = 0; i < matrix.length; i++) {
          if(!Array.isArray(matrix[i])) matrix[i] = [matrix[i]];
          minLen = Math.min(minLen, matrix[i].length);
          maxLen = Math.max(maxLen, matrix[i].length);
      }
  
      if(minLen !== maxLen) {
          for(i = 0; i < matrix.length; i++) {
              var padLen = maxLen - matrix[i].length;
              if(padLen) matrix[i] = matrix[i].concat(emptyStrings(padLen));
          }
      }
      return matrix;
  }
  
  function emptyStrings(len) {
      var padArray = new Array(len);
      for(var j = 0; j < len; j++) padArray[j] = '';
      return padArray;
  }
  
  function xScale(d) {
      return d.calcdata.columns.reduce(function(prev, next) {
          return next.xIndex < d.xIndex ? prev + next.columnWidth : prev;
      }, 0);
  }
  
  function makeRowBlock(anchorToRowBlock, auxiliary) {
      var blockAnchorKeys = Object.keys(anchorToRowBlock);
      return blockAnchorKeys.map(function(k) {return extendFlat({}, anchorToRowBlock[k], {auxiliaryBlocks: auxiliary});});
  }
  
  function makeAnchorToRowBlock(rowHeights, minimumFillHeight) {
      var anchorToRowBlock = {};
      var currentRowHeight;
      var currentAnchor = 0;
      var currentBlockHeight = 0;
      var currentBlock = makeIdentity();
      var currentFirstRowIndex = 0;
      var blockCounter = 0;
      for(var i = 0; i < rowHeights.length; i++) {
          currentRowHeight = rowHeights[i];
          currentBlock.rows.push({
              rowIndex: i,
              rowHeight: currentRowHeight
          });
          currentBlockHeight += currentRowHeight;
          if(currentBlockHeight >= minimumFillHeight || i === rowHeights.length - 1) {
              anchorToRowBlock[currentAnchor] = currentBlock;
              currentBlock.key = blockCounter++;
              currentBlock.firstRowIndex = currentFirstRowIndex;
              currentBlock.lastRowIndex = i;
              currentBlock = makeIdentity();
              currentAnchor += currentBlockHeight;
              currentFirstRowIndex = i + 1;
              currentBlockHeight = 0;
          }
      }
  
      return anchorToRowBlock;
  }
  
  function makeIdentity() {
      return {
          firstRowIndex: null,
          lastRowIndex: null,
          rows: []
      };
  }
  
  },{"../../lib/extend":740,"./constants":1290,"fast-isnumeric":241}],1292:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  // pure functions, don't alter but passes on `gd` and parts of `trace` without deep copying
  
  exports.splitToPanels = function(d) {
      var prevPages = [0, 0];
      var headerPanel = extendFlat({}, d, {
          key: 'header',
          type: 'header',
          page: 0,
          prevPages: prevPages,
          currentRepaint: [null, null],
          dragHandle: true,
          values: d.calcdata.headerCells.values[d.specIndex],
          rowBlocks: d.calcdata.headerRowBlocks,
          calcdata: extendFlat({}, d.calcdata, {cells: d.calcdata.headerCells})
      });
      var revolverPanel1 = extendFlat({}, d, {
          key: 'cells1',
          type: 'cells',
          page: 0,
          prevPages: prevPages,
          currentRepaint: [null, null],
          dragHandle: false,
          values: d.calcdata.cells.values[d.specIndex],
          rowBlocks: d.calcdata.rowBlocks
      });
      var revolverPanel2 = extendFlat({}, d, {
          key: 'cells2',
          type: 'cells',
          page: 1,
          prevPages: prevPages,
          currentRepaint: [null, null],
          dragHandle: false,
          values: d.calcdata.cells.values[d.specIndex],
          rowBlocks: d.calcdata.rowBlocks
      });
      // order due to SVG using painter's algo:
      return [revolverPanel1, revolverPanel2, headerPanel];
  };
  
  exports.splitToCells = function(d) {
      var fromTo = rowFromTo(d);
      return (d.values || []).slice(fromTo[0], fromTo[1]).map(function(v, i) {
          // By keeping identical key, a DOM node removal, creation and addition is spared, important when visible
          // grid has a lot of elements (quadratic with xcol/ycol count).
          // But it has to be busted when `svgUtil.convertToTspans` is used as it reshapes cell subtrees asynchronously,
          // and by that time the user may have scrolled away, resulting in stale overwrites. The real solution will be
          // to turn `svgUtil.convertToTspans` into a cancelable request, in which case no key busting is needed.
          var buster = (typeof v === 'string') && v.match(/[<$&> ]/) ? '_keybuster_' + Math.random() : '';
          return {
              // keyWithinBlock: /*fromTo[0] + */i, // optimized future version - no busting
              // keyWithinBlock: fromTo[0] + i, // initial always-unoptimized version - janky scrolling with 5+ columns
              keyWithinBlock: i + buster, // current compromise: regular content is very fast; async content is possible
              key: fromTo[0] + i,
              column: d,
              calcdata: d.calcdata,
              page: d.page,
              rowBlocks: d.rowBlocks,
              value: v
          };
      });
  };
  
  function rowFromTo(d) {
      var rowBlock = d.rowBlocks[d.page];
      // fixme rowBlock truthiness check is due to ugly hack of placing 2nd panel as d.page = -1
      var rowFrom = rowBlock ? rowBlock.rows[0].rowIndex : 0;
      var rowTo = rowBlock ? rowFrom + rowBlock.rows.length : 0;
      return [rowFrom, rowTo];
  }
  
  },{"../../lib/extend":740}],1293:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
  
  function defaultColumnOrder(traceOut, coerce) {
      var specifiedColumnOrder = traceOut.columnorder || [];
      var commonLength = traceOut.header.values.length;
      var truncated = specifiedColumnOrder.slice(0, commonLength);
      var sorted = truncated.slice().sort(function(a, b) {return a - b;});
      var oneStepped = truncated.map(function(d) {return sorted.indexOf(d);});
      for(var i = oneStepped.length; i < commonLength; i++) {
          oneStepped.push(i);
      }
      coerce('columnorder', oneStepped);
  }
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      handleDomainDefaults(traceOut, layout, coerce);
  
      coerce('columnwidth');
  
      coerce('header.values');
      coerce('header.format');
      coerce('header.align');
  
      coerce('header.prefix');
      coerce('header.suffix');
      coerce('header.height');
      coerce('header.line.width');
      coerce('header.line.color');
      coerce('header.fill.color');
      Lib.coerceFont(coerce, 'header.font', Lib.extendFlat({}, layout.font));
  
      defaultColumnOrder(traceOut, coerce);
  
      coerce('cells.values');
      coerce('cells.format');
      coerce('cells.align');
      coerce('cells.prefix');
      coerce('cells.suffix');
      coerce('cells.height');
      coerce('cells.line.width');
      coerce('cells.line.color');
      coerce('cells.fill.color');
      Lib.coerceFont(coerce, 'cells.font', Lib.extendFlat({}, layout.font));
  
      // disable 1D transforms
      traceOut._length = null;
  };
  
  },{"../../lib":750,"../../plots/domain":826,"./attributes":1287}],1294:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('./calc'),
      plot: _dereq_('./plot'),
  
      moduleType: 'trace',
      name: 'table',
      basePlotModule: _dereq_('./base_plot'),
      categories: ['noOpacity'],
      meta: {
          
      }
  };
  
  },{"./attributes":1287,"./base_plot":1288,"./calc":1289,"./defaults":1293,"./plot":1295}],1295:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var c = _dereq_('./constants');
  var d3 = _dereq_('d3');
  var gup = _dereq_('../../lib/gup');
  var Drawing = _dereq_('../../components/drawing');
  var svgUtil = _dereq_('../../lib/svg_text_utils');
  var raiseToTop = _dereq_('../../lib').raiseToTop;
  var cancelEeaseColumn = _dereq_('../../lib').cancelTransition;
  var prepareData = _dereq_('./data_preparation_helper');
  var splitData = _dereq_('./data_split_helpers');
  var Color = _dereq_('../../components/color');
  
  module.exports = function plot(gd, wrappedTraceHolders) {
      var dynamic = !gd._context.staticPlot;
  
      var table = gd._fullLayout._paper.selectAll('.' + c.cn.table)
          .data(wrappedTraceHolders.map(function(wrappedTraceHolder) {
              var traceHolder = gup.unwrap(wrappedTraceHolder);
              var trace = traceHolder.trace;
              return prepareData(gd, trace);
          }), gup.keyFun);
  
      table.exit().remove();
  
      table.enter()
          .append('g')
          .classed(c.cn.table, true)
          .attr('overflow', 'visible')
          .style('box-sizing', 'content-box')
          .style('position', 'absolute')
          .style('left', 0)
          .style('overflow', 'visible')
          .style('shape-rendering', 'crispEdges')
          .style('pointer-events', 'all');
  
      table
          .attr('width', function(d) {return d.width + d.size.l + d.size.r;})
          .attr('height', function(d) {return d.height + d.size.t + d.size.b;})
          .attr('transform', function(d) {
              return 'translate(' + d.translateX + ',' + d.translateY + ')';
          });
  
      var tableControlView = table.selectAll('.' + c.cn.tableControlView)
          .data(gup.repeat, gup.keyFun);
  
      var cvEnter = tableControlView.enter()
          .append('g')
          .classed(c.cn.tableControlView, true)
          .style('box-sizing', 'content-box');
      if(dynamic) {
          var wheelEvent = 'onwheel' in document ? 'wheel' : 'mousewheel';
          cvEnter
              .on('mousemove', function(d) {
                  tableControlView
                      .filter(function(dd) {return d === dd;})
                      .call(renderScrollbarKit, gd);
              })
              .on(wheelEvent, function(d) {
                  if(d.scrollbarState.wheeling) return;
                  d.scrollbarState.wheeling = true;
                  var newY = d.scrollY + d3.event.deltaY;
                  var noChange = makeDragRow(gd, tableControlView, null, newY)(d);
                  if(!noChange) {
                      d3.event.stopPropagation();
                      d3.event.preventDefault();
                  }
                  d.scrollbarState.wheeling = false;
              })
              .call(renderScrollbarKit, gd, true);
      }
  
      tableControlView
          .attr('transform', function(d) {return 'translate(' + d.size.l + ' ' + d.size.t + ')';});
  
      // scrollBackground merely ensures that mouse events are captured even on crazy fast scrollwheeling
      // otherwise rendering glitches may occur
      var scrollBackground = tableControlView.selectAll('.' + c.cn.scrollBackground)
          .data(gup.repeat, gup.keyFun);
  
      scrollBackground.enter()
          .append('rect')
          .classed(c.cn.scrollBackground, true)
          .attr('fill', 'none');
  
      scrollBackground
          .attr('width', function(d) {return d.width;})
          .attr('height', function(d) {return d.height;});
  
      tableControlView.each(function(d) {
          Drawing.setClipUrl(d3.select(this), scrollAreaBottomClipKey(gd, d), gd);
      });
  
      var yColumn = tableControlView.selectAll('.' + c.cn.yColumn)
          .data(function(vm) {return vm.columns;}, gup.keyFun);
  
      yColumn.enter()
          .append('g')
          .classed(c.cn.yColumn, true);
  
      yColumn.exit().remove();
  
      yColumn.attr('transform', function(d) {return 'translate(' + d.x + ' 0)';});
  
      if(dynamic) {
          yColumn.call(d3.behavior.drag()
              .origin(function(d) {
                  var movedColumn = d3.select(this);
                  easeColumn(movedColumn, d, -c.uplift);
                  raiseToTop(this);
                  d.calcdata.columnDragInProgress = true;
                  renderScrollbarKit(tableControlView.filter(function(dd) {return d.calcdata.key === dd.key;}), gd);
                  return d;
              })
              .on('drag', function(d) {
                  var movedColumn = d3.select(this);
                  var getter = function(dd) {return (d === dd ? d3.event.x : dd.x) + dd.columnWidth / 2;};
                  d.x = Math.max(-c.overdrag, Math.min(d.calcdata.width + c.overdrag - d.columnWidth, d3.event.x));
  
                  var sortableColumns = flatData(yColumn).filter(function(dd) {return dd.calcdata.key === d.calcdata.key;});
                  var newOrder = sortableColumns.sort(function(a, b) {return getter(a) - getter(b);});
                  newOrder.forEach(function(dd, i) {
                      dd.xIndex = i;
                      dd.x = d === dd ? dd.x : dd.xScale(dd);
                  });
  
                  yColumn.filter(function(dd) {return d !== dd;})
                      .transition()
                      .ease(c.transitionEase)
                      .duration(c.transitionDuration)
                      .attr('transform', function(d) {return 'translate(' + d.x + ' 0)';});
                  movedColumn
                      .call(cancelEeaseColumn)
                      .attr('transform', 'translate(' + d.x + ' -' + c.uplift + ' )');
              })
              .on('dragend', function(d) {
                  var movedColumn = d3.select(this);
                  var p = d.calcdata;
                  d.x = d.xScale(d);
                  d.calcdata.columnDragInProgress = false;
                  easeColumn(movedColumn, d, 0);
                  columnMoved(gd, p, p.columns.map(function(dd) {return dd.xIndex;}));
              })
          );
      }
  
      yColumn.each(function(d) {
          Drawing.setClipUrl(d3.select(this), columnBoundaryClipKey(gd, d), gd);
      });
  
      var columnBlock = yColumn.selectAll('.' + c.cn.columnBlock)
          .data(splitData.splitToPanels, gup.keyFun);
  
      columnBlock.enter()
          .append('g')
          .classed(c.cn.columnBlock, true)
          .attr('id', function(d) {return d.key;});
  
      columnBlock
          .style('cursor', function(d) {
              return d.dragHandle ? 'ew-resize' : d.calcdata.scrollbarState.barWiggleRoom ? 'ns-resize' : 'default';
          });
  
      var headerColumnBlock = columnBlock.filter(headerBlock);
      var cellsColumnBlock = columnBlock.filter(cellsBlock);
  
      if(dynamic) {
          cellsColumnBlock.call(d3.behavior.drag()
              .origin(function(d) {
                  d3.event.stopPropagation();
                  return d;
              })
              .on('drag', makeDragRow(gd, tableControlView, -1))
              .on('dragend', function() {
                  // fixme emit plotly notification
              })
          );
      }
  
      // initial rendering: header is rendered first, as it may may have async LaTeX (show header first)
      // but blocks are _entered_ the way they are due to painter's algo (header on top)
      renderColumnCellTree(gd, tableControlView, headerColumnBlock, columnBlock);
      renderColumnCellTree(gd, tableControlView, cellsColumnBlock, columnBlock);
  
      var scrollAreaClip = tableControlView.selectAll('.' + c.cn.scrollAreaClip)
          .data(gup.repeat, gup.keyFun);
  
      scrollAreaClip.enter()
          .append('clipPath')
          .classed(c.cn.scrollAreaClip, true)
          .attr('id', function(d) {return scrollAreaBottomClipKey(gd, d);});
  
      var scrollAreaClipRect = scrollAreaClip.selectAll('.' + c.cn.scrollAreaClipRect)
          .data(gup.repeat, gup.keyFun);
  
      scrollAreaClipRect.enter()
          .append('rect')
          .classed(c.cn.scrollAreaClipRect, true)
          .attr('x', -c.overdrag)
          .attr('y', -c.uplift)
          .attr('fill', 'none');
  
      scrollAreaClipRect
          .attr('width', function(d) {return d.width + 2 * c.overdrag;})
          .attr('height', function(d) {return d.height + c.uplift;});
  
      var columnBoundary = yColumn.selectAll('.' + c.cn.columnBoundary)
          .data(gup.repeat, gup.keyFun);
  
      columnBoundary.enter()
          .append('g')
          .classed(c.cn.columnBoundary, true);
  
      var columnBoundaryClippath = yColumn.selectAll('.' + c.cn.columnBoundaryClippath)
          .data(gup.repeat, gup.keyFun);
  
      // SVG spec doesn't mandate wrapping into a <defs> and doesn't seem to cause a speed difference
      columnBoundaryClippath.enter()
          .append('clipPath')
          .classed(c.cn.columnBoundaryClippath, true);
  
      columnBoundaryClippath
          .attr('id', function(d) {return columnBoundaryClipKey(gd, d);});
  
      var columnBoundaryRect = columnBoundaryClippath.selectAll('.' + c.cn.columnBoundaryRect)
          .data(gup.repeat, gup.keyFun);
  
      columnBoundaryRect.enter()
          .append('rect')
          .classed(c.cn.columnBoundaryRect, true)
          .attr('fill', 'none');
  
      columnBoundaryRect
          .attr('width', function(d) { return d.columnWidth + 2 * roundHalfWidth(d); })
          .attr('height', function(d) {return d.calcdata.height + 2 * roundHalfWidth(d) + c.uplift;})
          .attr('x', function(d) { return -roundHalfWidth(d); })
          .attr('y', function(d) { return -roundHalfWidth(d); });
  
      updateBlockYPosition(null, cellsColumnBlock, tableControlView);
  };
  
  function roundHalfWidth(d) {
      return Math.ceil(d.calcdata.maxLineWidth / 2);
  }
  
  function scrollAreaBottomClipKey(gd, d) {
      return 'clip' + gd._fullLayout._uid + '_scrollAreaBottomClip_' + d.key;
  }
  
  function columnBoundaryClipKey(gd, d) {
      return 'clip' + gd._fullLayout._uid + '_columnBoundaryClippath_' + d.calcdata.key + '_' + d.specIndex;
  }
  
  function flatData(selection) {
      return [].concat.apply([], selection.map(function(g) {return g;}))
          .map(function(g) {return g.__data__;});
  }
  
  function renderScrollbarKit(tableControlView, gd, bypassVisibleBar) {
      function calcTotalHeight(d) {
          var blocks = d.rowBlocks;
          return firstRowAnchor(blocks, blocks.length - 1) + (blocks.length ? rowsHeight(blocks[blocks.length - 1], Infinity) : 1);
      }
  
      var scrollbarKit = tableControlView.selectAll('.' + c.cn.scrollbarKit)
          .data(gup.repeat, gup.keyFun);
  
      scrollbarKit.enter()
          .append('g')
          .classed(c.cn.scrollbarKit, true)
          .style('shape-rendering', 'geometricPrecision');
  
      scrollbarKit
          .each(function(d) {
              var s = d.scrollbarState;
              s.totalHeight = calcTotalHeight(d);
              s.scrollableAreaHeight = d.groupHeight - headerHeight(d);
              s.currentlyVisibleHeight = Math.min(s.totalHeight, s.scrollableAreaHeight);
              s.ratio = s.currentlyVisibleHeight / s.totalHeight;
              s.barLength = Math.max(s.ratio * s.currentlyVisibleHeight, c.goldenRatio * c.scrollbarWidth);
              s.barWiggleRoom = s.currentlyVisibleHeight - s.barLength;
              s.wiggleRoom = Math.max(0, s.totalHeight - s.scrollableAreaHeight);
              s.topY = s.barWiggleRoom === 0 ? 0 : (d.scrollY / s.wiggleRoom) * s.barWiggleRoom;
              s.bottomY = s.topY + s.barLength;
              s.dragMultiplier = s.wiggleRoom / s.barWiggleRoom;
          })
          .attr('transform', function(d) {
              var xPosition = d.width + c.scrollbarWidth / 2 + c.scrollbarOffset;
              return 'translate(' + xPosition + ' ' + headerHeight(d) + ')';
          });
  
      var scrollbar = scrollbarKit.selectAll('.' + c.cn.scrollbar)
          .data(gup.repeat, gup.keyFun);
  
      scrollbar.enter()
          .append('g')
          .classed(c.cn.scrollbar, true);
  
      var scrollbarSlider = scrollbar.selectAll('.' + c.cn.scrollbarSlider)
          .data(gup.repeat, gup.keyFun);
  
      scrollbarSlider.enter()
          .append('g')
          .classed(c.cn.scrollbarSlider, true);
  
      scrollbarSlider
          .attr('transform', function(d) {
              return 'translate(0 ' + (d.scrollbarState.topY || 0) + ')';
          });
  
      var scrollbarGlyph = scrollbarSlider.selectAll('.' + c.cn.scrollbarGlyph)
          .data(gup.repeat, gup.keyFun);
  
      scrollbarGlyph.enter()
          .append('line')
          .classed(c.cn.scrollbarGlyph, true)
          .attr('stroke', 'black')
          .attr('stroke-width', c.scrollbarWidth)
          .attr('stroke-linecap', 'round')
          .attr('y1', c.scrollbarWidth / 2);
  
      scrollbarGlyph
          .attr('y2', function(d) {
              return d.scrollbarState.barLength - c.scrollbarWidth / 2;
          })
          .attr('stroke-opacity', function(d) {
              return d.columnDragInProgress || !d.scrollbarState.barWiggleRoom || bypassVisibleBar ? 0 : 0.4;
          });
  
      // cancel transition: possible pending (also, delayed) transition
      scrollbarGlyph
          .transition().delay(0).duration(0);
  
      scrollbarGlyph
          .transition().delay(c.scrollbarHideDelay).duration(c.scrollbarHideDuration)
          .attr('stroke-opacity', 0);
  
      var scrollbarCaptureZone = scrollbar.selectAll('.' + c.cn.scrollbarCaptureZone)
          .data(gup.repeat, gup.keyFun);
  
      scrollbarCaptureZone.enter()
          .append('line')
          .classed(c.cn.scrollbarCaptureZone, true)
          .attr('stroke', 'white')
          .attr('stroke-opacity', 0.01) // some browser might get rid of a 0 opacity element
          .attr('stroke-width', c.scrollbarCaptureWidth)
          .attr('stroke-linecap', 'butt')
          .attr('y1', 0)
          .on('mousedown', function(d) {
              var y = d3.event.y;
              var bbox = this.getBoundingClientRect();
              var s = d.scrollbarState;
              var pixelVal = y - bbox.top;
              var inverseScale = d3.scale.linear().domain([0, s.scrollableAreaHeight]).range([0, s.totalHeight]).clamp(true);
              if(!(s.topY <= pixelVal && pixelVal <= s.bottomY)) {
                  makeDragRow(gd, tableControlView, null, inverseScale(pixelVal - s.barLength / 2))(d);
              }
          })
          .call(d3.behavior.drag()
              .origin(function(d) {
                  d3.event.stopPropagation();
                  d.scrollbarState.scrollbarScrollInProgress = true;
                  return d;
              })
              .on('drag', makeDragRow(gd, tableControlView))
              .on('dragend', function() {
                  // fixme emit Plotly event
              })
          );
  
      scrollbarCaptureZone
          .attr('y2', function(d) {
              return d.scrollbarState.scrollableAreaHeight;
          });
  
      // Remove scroll glyph and capture zone on static plots
      // as they don't render properly when converted to PDF
      // in the Chrome PDF viewer
      // https://github.com/plotly/streambed/issues/11618
      if(gd._context.staticPlot) {
          scrollbarGlyph.remove();
          scrollbarCaptureZone.remove();
      }
  }
  
  function renderColumnCellTree(gd, tableControlView, columnBlock, allColumnBlock) {
      // fixme this perf hotspot
      // this is performance critical code as scrolling calls it on every revolver switch
      // it appears sufficiently fast but there are plenty of low-hanging fruits for performance optimization
  
      var columnCells = renderColumnCells(columnBlock);
  
      var columnCell = renderColumnCell(columnCells);
  
      supplyStylingValues(columnCell);
  
      var cellRect = renderCellRect(columnCell);
  
      sizeAndStyleRect(cellRect);
  
      var cellTextHolder = renderCellTextHolder(columnCell);
  
      var cellText = renderCellText(cellTextHolder);
  
      setFont(cellText);
      populateCellText(cellText, tableControlView, allColumnBlock, gd);
  
      // doing this at the end when text, and text stlying are set
      setCellHeightAndPositionY(columnCell);
  }
  
  function renderColumnCells(columnBlock) {
      var columnCells = columnBlock.selectAll('.' + c.cn.columnCells)
          .data(gup.repeat, gup.keyFun);
  
      columnCells.enter()
          .append('g')
          .classed(c.cn.columnCells, true);
  
      columnCells.exit()
          .remove();
  
      return columnCells;
  }
  
  function renderColumnCell(columnCells) {
      var columnCell = columnCells.selectAll('.' + c.cn.columnCell)
          .data(splitData.splitToCells, function(d) {return d.keyWithinBlock;});
  
      columnCell.enter()
          .append('g')
          .classed(c.cn.columnCell, true);
  
      columnCell.exit()
          .remove();
  
      return columnCell;
  }
  
  function renderCellRect(columnCell) {
      var cellRect = columnCell.selectAll('.' + c.cn.cellRect)
          .data(gup.repeat, function(d) {return d.keyWithinBlock;});
  
      cellRect.enter()
          .append('rect')
          .classed(c.cn.cellRect, true);
  
      return cellRect;
  }
  
  function renderCellText(cellTextHolder) {
      var cellText = cellTextHolder.selectAll('.' + c.cn.cellText)
          .data(gup.repeat, function(d) {return d.keyWithinBlock;});
  
      cellText.enter()
          .append('text')
          .classed(c.cn.cellText, true)
          .style('cursor', function() {return 'auto';})
          .on('mousedown', function() {d3.event.stopPropagation();});
  
      return cellText;
  }
  
  function renderCellTextHolder(columnCell) {
      var cellTextHolder = columnCell.selectAll('.' + c.cn.cellTextHolder)
          .data(gup.repeat, function(d) {return d.keyWithinBlock;});
  
      cellTextHolder.enter()
          .append('g')
          .classed(c.cn.cellTextHolder, true)
          .style('shape-rendering', 'geometricPrecision');
  
      return cellTextHolder;
  }
  
  function supplyStylingValues(columnCell) {
      columnCell
          .each(function(d, i) {
              var spec = d.calcdata.cells.font;
              var col = d.column.specIndex;
              var font = {
                  size: gridPick(spec.size, col, i),
                  color: gridPick(spec.color, col, i),
                  family: gridPick(spec.family, col, i)
              };
              d.rowNumber = d.key;
              d.align = gridPick(d.calcdata.cells.align, col, i);
              d.cellBorderWidth = gridPick(d.calcdata.cells.line.width, col, i);
              d.font = font;
          });
  }
  
  function setFont(cellText) {
      cellText
          .each(function(d) {
              Drawing.font(d3.select(this), d.font);
          });
  }
  
  function sizeAndStyleRect(cellRect) {
      cellRect
          .attr('width', function(d) {return d.column.columnWidth;})
          .attr('stroke-width', function(d) {return d.cellBorderWidth;})
          .each(function(d) {
              var atomicSelection = d3.select(this);
              Color.stroke(atomicSelection, gridPick(d.calcdata.cells.line.color, d.column.specIndex, d.rowNumber));
              Color.fill(atomicSelection, gridPick(d.calcdata.cells.fill.color, d.column.specIndex, d.rowNumber));
          });
  }
  
  function populateCellText(cellText, tableControlView, allColumnBlock, gd) {
      cellText
          .text(function(d) {
              var col = d.column.specIndex;
              var row = d.rowNumber;
  
              var userSuppliedContent = d.value;
              var stringSupplied = (typeof userSuppliedContent === 'string');
              var hasBreaks = stringSupplied && userSuppliedContent.match(/<br>/i);
              var userBrokenText = !stringSupplied || hasBreaks;
              d.mayHaveMarkup = stringSupplied && userSuppliedContent.match(/[<&>]/);
  
              var latex = isLatex(userSuppliedContent);
              d.latex = latex;
  
              var prefix = latex ? '' : gridPick(d.calcdata.cells.prefix, col, row) || '';
              var suffix = latex ? '' : gridPick(d.calcdata.cells.suffix, col, row) || '';
              var format = latex ? null : gridPick(d.calcdata.cells.format, col, row) || null;
  
              var prefixSuffixedText = prefix + (format ? d3.format(format)(d.value) : d.value) + suffix;
  
              var hasWrapSplitCharacter;
              d.wrappingNeeded = !d.wrapped && !userBrokenText && !latex && (hasWrapSplitCharacter = hasWrapCharacter(prefixSuffixedText));
              d.cellHeightMayIncrease = hasBreaks || latex || d.mayHaveMarkup || (hasWrapSplitCharacter === void(0) ? hasWrapCharacter(prefixSuffixedText) : hasWrapSplitCharacter);
              d.needsConvertToTspans = d.mayHaveMarkup || d.wrappingNeeded || d.latex;
  
              var textToRender;
              if(d.wrappingNeeded) {
                  var hrefPreservedText = c.wrapSplitCharacter === ' ' ? prefixSuffixedText.replace(/<a href=/ig, '<a_href=') : prefixSuffixedText;
                  var fragments = hrefPreservedText.split(c.wrapSplitCharacter);
                  var hrefRestoredFragments = c.wrapSplitCharacter === ' ' ? fragments.map(function(frag) {return frag.replace(/<a_href=/ig, '<a href=');}) : fragments;
                  d.fragments = hrefRestoredFragments.map(function(f) {return {text: f, width: null};});
                  d.fragments.push({fragment: c.wrapSpacer, width: null});
                  textToRender = hrefRestoredFragments.join(c.lineBreaker) + c.lineBreaker + c.wrapSpacer;
              } else {
                  delete d.fragments;
                  textToRender = prefixSuffixedText;
              }
  
              return textToRender;
          })
          .attr('dy', function(d) {
              return d.needsConvertToTspans ? 0 : '0.75em';
          })
          .each(function(d) {
              var element = this;
              var selection = d3.select(element);
  
              // finalize what's in the DOM
  
              var renderCallback = d.wrappingNeeded ? wrapTextMaker : updateYPositionMaker;
              if(d.needsConvertToTspans) {
                  svgUtil.convertToTspans(selection, gd, renderCallback(allColumnBlock, element, tableControlView, gd, d));
              } else {
                  d3.select(element.parentNode)
                      // basic cell adjustment - compliance with `cellPad`
                      .attr('transform', function(d) {return 'translate(' + xPosition(d) + ' ' + c.cellPad + ')';})
                      .attr('text-anchor', function(d) {
                          return ({
                              left: 'start',
                              center: 'middle',
                              right: 'end'
                          })[d.align];
                      });
              }
          });
  }
  
  function isLatex(content) {
      return typeof content === 'string' && content.match(c.latexCheck);
  }
  
  function hasWrapCharacter(text) {return text.indexOf(c.wrapSplitCharacter) !== -1;}
  
  function columnMoved(gd, calcdata, indices) {
      var o = calcdata.gdColumnsOriginalOrder;
      calcdata.gdColumns.sort(function(a, b) {
          return indices[o.indexOf(a)] - indices[o.indexOf(b)];
      });
  
      calcdata.columnorder = indices;
  
      // TODO: there's no data here, but also this reordering is not reflected
      // in gd.data or even gd._fullData.
      // For now I will not attempt to persist this in _preGUI
      gd.emit('plotly_restyle');
  }
  
  function gridPick(spec, col, row) {
      if(Array.isArray(spec)) {
          var column = spec[Math.min(col, spec.length - 1)];
          if(Array.isArray(column)) {
              return column[Math.min(row, column.length - 1)];
          } else {
              return column;
          }
      } else {
          return spec;
      }
  }
  
  function easeColumn(selection, d, y) {
      selection
          .transition()
          .ease(c.releaseTransitionEase)
          .duration(c.releaseTransitionDuration)
          .attr('transform', 'translate(' + d.x + ' ' + y + ')');
  }
  
  function cellsBlock(d) {return d.type === 'cells';}
  function headerBlock(d) {return d.type === 'header';}
  
  /**
   * Revolver panel and cell contents layouting
   */
  
  function headerHeight(d) {
      var headerBlocks = d.rowBlocks.length ? d.rowBlocks[0].auxiliaryBlocks : [];
      return headerBlocks.reduce(function(p, n) {return p + rowsHeight(n, Infinity);}, 0);
  }
  
  function findPagesAndCacheHeights(blocks, scrollY, scrollHeight) {
      var pages = [];
      var pTop = 0;
  
      for(var blockIndex = 0; blockIndex < blocks.length; blockIndex++) {
          var block = blocks[blockIndex];
          var blockRows = block.rows;
          var rowsHeight = 0;
          for(var i = 0; i < blockRows.length; i++) {
              rowsHeight += blockRows[i].rowHeight;
          }
  
          // caching allRowsHeight on the block - it's safe as this function is always called from within the code part
          // that handles increases to row heights
          block.allRowsHeight = rowsHeight;
  
          var pBottom = pTop + rowsHeight;
          var windowTop = scrollY;
          var windowBottom = windowTop + scrollHeight;
          if(windowTop < pBottom && windowBottom > pTop) {
              pages.push(blockIndex);
          }
          pTop += rowsHeight;
  
          // consider this nice final optimization; put it in `for` condition - caveat, currently the
          // block.allRowsHeight relies on being invalidated, so enabling this opt may not be safe
          // if(pages.length > 1) break;
      }
  
      return pages;
  }
  
  function updateBlockYPosition(gd, cellsColumnBlock, tableControlView) {
      var d = flatData(cellsColumnBlock)[0];
      if(d === undefined) return;
      var blocks = d.rowBlocks;
      var calcdata = d.calcdata;
  
      var bottom = firstRowAnchor(blocks, blocks.length);
      var scrollHeight = d.calcdata.groupHeight - headerHeight(d);
      var scrollY = calcdata.scrollY = Math.max(0, Math.min(bottom - scrollHeight, calcdata.scrollY));
  
      var pages = findPagesAndCacheHeights(blocks, scrollY, scrollHeight);
      if(pages.length === 1) {
          if(pages[0] === blocks.length - 1) {
              pages.unshift(pages[0] - 1);
          } else {
              pages.push(pages[0] + 1);
          }
      }
  
      // make phased out page jump by 2 while leaving stationary page intact
      if(pages[0] % 2) {
          pages.reverse();
      }
  
      cellsColumnBlock
          .each(function(d, i) {
              // these values will also be needed when a block is translated again due to growing cell height
              d.page = pages[i];
              d.scrollY = scrollY;
          });
  
      cellsColumnBlock
          .attr('transform', function(d) {
              var yTranslate = firstRowAnchor(d.rowBlocks, d.page) - d.scrollY;
              return 'translate(0 ' + yTranslate + ')';
          });
  
      // conditionally rerendering panel 0 and 1
      if(gd) {
          conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, d.prevPages, d, 0);
          conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, d.prevPages, d, 1);
          renderScrollbarKit(tableControlView, gd);
      }
  }
  
  function makeDragRow(gd, allTableControlView, optionalMultiplier, optionalPosition) {
      return function dragRow(eventD) {
          // may come from whichever DOM event target: drag, wheel, bar... eventD corresponds to event target
          var d = eventD.calcdata ? eventD.calcdata : eventD;
          var tableControlView = allTableControlView.filter(function(dd) {return d.key === dd.key;});
          var multiplier = optionalMultiplier || d.scrollbarState.dragMultiplier;
  
          var initialScrollY = d.scrollY;
  
          d.scrollY = optionalPosition === void(0) ? d.scrollY + multiplier * d3.event.dy : optionalPosition;
          var cellsColumnBlock = tableControlView.selectAll('.' + c.cn.yColumn).selectAll('.' + c.cn.columnBlock).filter(cellsBlock);
          updateBlockYPosition(gd, cellsColumnBlock, tableControlView);
  
          // return false if we've "used" the scroll, ie it did something,
          // so the event shouldn't bubble (if appropriate)
          return d.scrollY === initialScrollY;
      };
  }
  
  function conditionalPanelRerender(gd, tableControlView, cellsColumnBlock, pages, prevPages, d, revolverIndex) {
      var shouldComponentUpdate = pages[revolverIndex] !== prevPages[revolverIndex];
      if(shouldComponentUpdate) {
          clearTimeout(d.currentRepaint[revolverIndex]);
          d.currentRepaint[revolverIndex] = setTimeout(function() {
              // setTimeout might lag rendering but yields a smoother scroll, because fast scrolling makes
              // some repaints invisible ie. wasteful (DOM work blocks the main thread)
              var toRerender = cellsColumnBlock.filter(function(d, i) {return i === revolverIndex && pages[i] !== prevPages[i];});
              renderColumnCellTree(gd, tableControlView, toRerender, cellsColumnBlock);
              prevPages[revolverIndex] = pages[revolverIndex];
          });
      }
  }
  
  function wrapTextMaker(columnBlock, element, tableControlView, gd) {
      return function wrapText() {
          var cellTextHolder = d3.select(element.parentNode);
          cellTextHolder
              .each(function(d) {
                  var fragments = d.fragments;
                  cellTextHolder.selectAll('tspan.line').each(function(dd, i) {
                      fragments[i].width = this.getComputedTextLength();
                  });
                  // last element is only for measuring the separator character, so it's ignored:
                  var separatorLength = fragments[fragments.length - 1].width;
                  var rest = fragments.slice(0, -1);
                  var currentRow = [];
                  var currentAddition, currentAdditionLength;
                  var currentRowLength = 0;
                  var rowLengthLimit = d.column.columnWidth - 2 * c.cellPad;
                  d.value = '';
                  while(rest.length) {
                      currentAddition = rest.shift();
                      currentAdditionLength = currentAddition.width + separatorLength;
                      if(currentRowLength + currentAdditionLength > rowLengthLimit) {
                          d.value += currentRow.join(c.wrapSpacer) + c.lineBreaker;
                          currentRow = [];
                          currentRowLength = 0;
                      }
                      currentRow.push(currentAddition.text);
                      currentRowLength += currentAdditionLength;
                  }
                  if(currentRowLength) {
                      d.value += currentRow.join(c.wrapSpacer);
                  }
                  d.wrapped = true;
              });
  
          // the pre-wrapped text was rendered only for the text measurements
          cellTextHolder.selectAll('tspan.line').remove();
  
          // resupply text, now wrapped
          populateCellText(cellTextHolder.select('.' + c.cn.cellText), tableControlView, columnBlock, gd);
          d3.select(element.parentNode.parentNode).call(setCellHeightAndPositionY);
      };
  }
  
  function updateYPositionMaker(columnBlock, element, tableControlView, gd, d) {
      return function updateYPosition() {
          if(d.settledY) return;
          var cellTextHolder = d3.select(element.parentNode);
          var l = getBlock(d);
          var rowIndex = d.key - l.firstRowIndex;
  
          var declaredRowHeight = l.rows[rowIndex].rowHeight;
  
          var requiredHeight = d.cellHeightMayIncrease ? element.parentNode.getBoundingClientRect().height + 2 * c.cellPad : declaredRowHeight;
  
          var finalHeight = Math.max(requiredHeight, declaredRowHeight);
          var increase = finalHeight - l.rows[rowIndex].rowHeight;
  
          if(increase) {
              // current row height increased
              l.rows[rowIndex].rowHeight = finalHeight;
  
              columnBlock
                  .selectAll('.' + c.cn.columnCell)
                  .call(setCellHeightAndPositionY);
  
              updateBlockYPosition(null, columnBlock.filter(cellsBlock), 0);
  
              // if d.column.type === 'header', then the scrollbar has to be pushed downward to the scrollable area
              // if d.column.type === 'cells', it can still be relevant if total scrolling content height is less than the
              //                               scrollable window, as increases to row heights may need scrollbar updates
              renderScrollbarKit(tableControlView, gd, true);
          }
  
          cellTextHolder
              .attr('transform', function() {
                  // this code block is only invoked for items where d.cellHeightMayIncrease is truthy
                  var element = this;
                  var columnCellElement = element.parentNode;
                  var box = columnCellElement.getBoundingClientRect();
                  var rectBox = d3.select(element.parentNode).select('.' + c.cn.cellRect).node().getBoundingClientRect();
                  var currentTransform = element.transform.baseVal.consolidate();
                  var yPosition = rectBox.top - box.top + (currentTransform ? currentTransform.matrix.f : c.cellPad);
                  return 'translate(' + xPosition(d, d3.select(element.parentNode).select('.' + c.cn.cellTextHolder).node().getBoundingClientRect().width) + ' ' + yPosition + ')';
              });
  
          d.settledY = true;
      };
  }
  
  function xPosition(d, optionalWidth) {
      switch(d.align) {
          case 'left': return c.cellPad;
          case 'right': return d.column.columnWidth - (optionalWidth || 0) - c.cellPad;
          case 'center': return (d.column.columnWidth - (optionalWidth || 0)) / 2;
          default: return c.cellPad;
      }
  }
  
  function setCellHeightAndPositionY(columnCell) {
      columnCell
          .attr('transform', function(d) {
              var headerHeight = d.rowBlocks[0].auxiliaryBlocks.reduce(function(p, n) {return p + rowsHeight(n, Infinity);}, 0);
              var l = getBlock(d);
              var rowAnchor = rowsHeight(l, d.key);
              var yOffset = rowAnchor + headerHeight;
              return 'translate(0 ' + yOffset + ')';
          })
          .selectAll('.' + c.cn.cellRect)
          .attr('height', function(d) {return getRow(getBlock(d), d.key).rowHeight;});
  }
  
  function firstRowAnchor(blocks, page) {
      var total = 0;
      for(var i = page - 1; i >= 0; i--) {
          total += allRowsHeight(blocks[i]);
      }
      return total;
  }
  
  function rowsHeight(rowBlock, key) {
      var total = 0;
      for(var i = 0; i < rowBlock.rows.length && rowBlock.rows[i].rowIndex < key; i++) {
          total += rowBlock.rows[i].rowHeight;
      }
      return total;
  }
  
  function allRowsHeight(rowBlock) {
      var cached = rowBlock.allRowsHeight;
  
      if(cached !== void(0)) {
          return cached;
      }
  
      var total = 0;
      for(var i = 0; i < rowBlock.rows.length; i++) {
          total += rowBlock.rows[i].rowHeight;
      }
      rowBlock.allRowsHeight = total;
  
      return total;
  }
  
  function getBlock(d) {return d.rowBlocks[d.page];}
  function getRow(l, i) {return l.rows[i - l.firstRowIndex];}
  
  },{"../../components/color":615,"../../components/drawing":637,"../../lib":750,"../../lib/gup":747,"../../lib/svg_text_utils":774,"./constants":1290,"./data_preparation_helper":1291,"./data_split_helpers":1292,"d3":169}],1296:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var domainAttrs = _dereq_('../../plots/domain').attributes;
  var pieAttrs = _dereq_('../pie/attributes');
  var sunburstAttrs = _dereq_('../sunburst/attributes');
  var constants = _dereq_('./constants');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = {
      labels: sunburstAttrs.labels,
      parents: sunburstAttrs.parents,
  
      values: sunburstAttrs.values,
      branchvalues: sunburstAttrs.branchvalues,
      count: sunburstAttrs.count,
  
      level: sunburstAttrs.level,
      maxdepth: sunburstAttrs.maxdepth,
  
      tiling: {
          packing: {
              valType: 'enumerated',
              values: [
                  'squarify',
                  'binary',
                  'dice',
                  'slice',
                  'slice-dice',
                  'dice-slice'
              ],
              dflt: 'squarify',
              
              editType: 'plot',
              
          },
  
          squarifyratio: {
              valType: 'number',
              
              min: 1,
              dflt: 1,
              editType: 'plot',
              
          },
  
          flip: {
              valType: 'flaglist',
              
              flags: [
                  'x',
                  'y'
              ],
              dflt: '',
              editType: 'plot',
              
          },
  
          pad: {
              valType: 'number',
              
              min: 0,
              dflt: 3,
              editType: 'plot',
              
          },
  
          editType: 'calc',
      },
  
      marker: extendFlat({
          pad: {
              t: {
                  valType: 'number',
                  
                  min: 0,
                  editType: 'plot',
                  
              },
              l: {
                  valType: 'number',
                  
                  min: 0,
                  editType: 'plot',
                  
              },
              r: {
                  valType: 'number',
                  
                  min: 0,
                  editType: 'plot',
                  
              },
              b: {
                  valType: 'number',
                  
                  min: 0,
                  editType: 'plot',
                  
              },
  
              editType: 'calc'
          },
  
          colors: sunburstAttrs.marker.colors,
  
          depthfade: {
              valType: 'enumerated',
              values: [true, false, 'reversed'],
              editType: 'style',
              
              
          },
  
          line: sunburstAttrs.marker.line,
  
          editType: 'calc'
      },
          colorScaleAttrs('marker', {
              colorAttr: 'colors',
              anim: false // TODO: set to anim: true?
          })
      ),
  
      pathbar: {
          visible: {
              valType: 'boolean',
              dflt: true,
              
              editType: 'plot',
              
          },
  
          side: {
              valType: 'enumerated',
              values: [
                  'top',
                  'bottom'
              ],
              dflt: 'top',
              
              editType: 'plot',
              
          },
  
          edgeshape: {
              valType: 'enumerated',
              values: [
                  '>',
                  '<',
                  '|',
                  '/',
                  '\\'
              ],
              dflt: '>',
              
              editType: 'plot',
              
          },
  
          thickness: {
              valType: 'number',
              min: 12,
              
              editType: 'plot',
              
          },
  
          textfont: extendFlat({}, pieAttrs.textfont, {
              
          }),
  
          editType: 'calc'
      },
  
      text: pieAttrs.text,
      textinfo: sunburstAttrs.textinfo,
      // TODO: incorporate `label` and `value` in the eventData
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: constants.eventDataKeys.concat(['label', 'value'])
      }),
  
      hovertext: pieAttrs.hovertext,
      hoverinfo: sunburstAttrs.hoverinfo,
      hovertemplate: hovertemplateAttrs({}, {
          keys: constants.eventDataKeys
      }),
  
      textfont: pieAttrs.textfont,
      insidetextfont: pieAttrs.insidetextfont,
      outsidetextfont: extendFlat({}, pieAttrs.outsidetextfont, {
          
      }),
  
      textposition: {
          valType: 'enumerated',
          values: [
              'top left', 'top center', 'top right',
              'middle left', 'middle center', 'middle right',
              'bottom left', 'bottom center', 'bottom right'
          ],
          dflt: 'top left',
          
          editType: 'plot',
          
      },
      sort: pieAttrs.sort,
  
      domain: domainAttrs({name: 'treemap', trace: true, editType: 'calc'}),
  };
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plots/domain":826,"../../plots/template_attributes":877,"../pie/attributes":1132,"../sunburst/attributes":1270,"./constants":1299}],1297:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var plots = _dereq_('../../plots/plots');
  
  exports.name = 'treemap';
  
  exports.plot = function(gd, traces, transitionOpts, makeOnCompleteCallback) {
      plots.plotBasePlot(exports.name, gd, traces, transitionOpts, makeOnCompleteCallback);
  };
  
  exports.clean = function(newFullData, newFullLayout, oldFullData, oldFullLayout) {
      plots.cleanBasePlot(exports.name, newFullData, newFullLayout, oldFullData, oldFullLayout);
  };
  
  },{"../../plots/plots":862}],1298:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var calc = _dereq_('../sunburst/calc');
  
  exports.calc = function(gd, trace) {
      return calc.calc(gd, trace);
  };
  
  exports.crossTraceCalc = function(gd) {
      return calc._runCrossTraceCalc('treemap', gd);
  };
  
  },{"../sunburst/calc":1272}],1299:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      CLICK_TRANSITION_TIME: 750,
      CLICK_TRANSITION_EASING: 'poly',
      eventDataKeys: [
          // string
          'currentPath',
          'root',
          'entry',
          // no need to add 'parent' here
  
          // percentages i.e. ratios
          'percentRoot',
          'percentEntry',
          'percentParent'
      ],
      gapWithPathbar: 1 // i.e. one pixel
  };
  
  },{}],1300:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var Color = _dereq_('../../components/color');
  var handleDomainDefaults = _dereq_('../../plots/domain').defaults;
  var handleText = _dereq_('../bar/defaults').handleText;
  var TEXTPAD = _dereq_('../bar/constants').TEXTPAD;
  
  var Colorscale = _dereq_('../../components/colorscale');
  var hasColorscale = Colorscale.hasColorscale;
  var colorscaleDefaults = Colorscale.handleDefaults;
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var labels = coerce('labels');
      var parents = coerce('parents');
  
      if(!labels || !labels.length || !parents || !parents.length) {
          traceOut.visible = false;
          return;
      }
  
      var vals = coerce('values');
      if(vals && vals.length) {
          coerce('branchvalues');
      } else {
          coerce('count');
      }
  
      coerce('level');
      coerce('maxdepth');
  
      var packing = coerce('tiling.packing');
      if(packing === 'squarify') {
          coerce('tiling.squarifyratio');
      }
  
      coerce('tiling.flip');
      coerce('tiling.pad');
  
      var text = coerce('text');
      coerce('texttemplate');
      if(!traceOut.texttemplate) coerce('textinfo', Array.isArray(text) ? 'text+label' : 'label');
  
      coerce('hovertext');
      coerce('hovertemplate');
  
      var hasPathbar = coerce('pathbar.visible');
  
      var textposition = 'auto';
      handleText(traceIn, traceOut, layout, coerce, textposition, {
          hasPathbar: hasPathbar,
          moduleHasSelected: false,
          moduleHasUnselected: false,
          moduleHasConstrain: false,
          moduleHasCliponaxis: false,
          moduleHasTextangle: false,
          moduleHasInsideanchor: false
      });
      coerce('textposition');
      var bottomText = traceOut.textposition.indexOf('bottom') !== -1;
  
      var lineWidth = coerce('marker.line.width');
      if(lineWidth) coerce('marker.line.color', layout.paper_bgcolor);
  
      var colors = coerce('marker.colors');
      var withColorscale = traceOut._hasColorscale = (
          hasColorscale(traceIn, 'marker', 'colors') ||
          (traceIn.marker || {}).coloraxis // N.B. special logic to consider "values" colorscales
      );
      if(withColorscale) {
          colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'});
      } else {
          coerce('marker.depthfade', !(colors || []).length);
      }
  
      var headerSize = traceOut.textfont.size * 2;
  
      coerce('marker.pad.t', bottomText ? headerSize / 4 : headerSize);
      coerce('marker.pad.l', headerSize / 4);
      coerce('marker.pad.r', headerSize / 4);
      coerce('marker.pad.b', bottomText ? headerSize : headerSize / 4);
  
      if(withColorscale) {
          colorscaleDefaults(traceIn, traceOut, layout, coerce, {prefix: 'marker.', cLetter: 'c'});
      }
  
      traceOut._hovered = {
          marker: {
              line: {
                  width: 2,
                  color: Color.contrast(layout.paper_bgcolor)
              }
          }
      };
  
      if(hasPathbar) {
          // This works even for multi-line labels as treemap pathbar trim out line breaks
          coerce('pathbar.thickness', traceOut.pathbar.textfont.size + 2 * TEXTPAD);
  
          coerce('pathbar.side');
          coerce('pathbar.edgeshape');
      }
  
      coerce('sort');
  
      handleDomainDefaults(traceOut, layout, coerce);
  
      // do not support transforms for now
      traceOut._length = null;
  };
  
  },{"../../components/color":615,"../../components/colorscale":627,"../../lib":750,"../../plots/domain":826,"../bar/constants":894,"../bar/defaults":896,"./attributes":1296}],1301:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  
  var partition = _dereq_('./partition');
  var styleOne = _dereq_('./style').styleOne;
  var constants = _dereq_('./constants');
  var helpers = _dereq_('../sunburst/helpers');
  var attachFxHandlers = _dereq_('../sunburst/fx');
  
  var onPathbar = true; // for Ancestors
  
  module.exports = function drawAncestors(gd, cd, entry, slices, opts) {
      var barDifY = opts.barDifY;
      var width = opts.width;
      var height = opts.height;
      var viewX = opts.viewX;
      var viewY = opts.viewY;
      var pathSlice = opts.pathSlice;
      var toMoveInsideSlice = opts.toMoveInsideSlice;
      var strTransform = opts.strTransform;
      var hasTransition = opts.hasTransition;
      var handleSlicesExit = opts.handleSlicesExit;
      var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
      var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
      var refRect = {};
  
      var fullLayout = gd._fullLayout;
      var cd0 = cd[0];
      var trace = cd0.trace;
      var hierarchy = cd0.hierarchy;
  
      var eachWidth = width / trace._entryDepth;
  
      var pathIds = helpers.listPath(entry.data, 'id');
  
      var sliceData = partition(hierarchy.copy(), [width, height], {
          packing: 'dice',
          pad: {
              inner: 0,
              top: 0,
              left: 0,
              right: 0,
              bottom: 0
          }
      }).descendants();
  
      // edit slices that show up on graph
      sliceData = sliceData.filter(function(pt) {
          var level = pathIds.indexOf(pt.data.id);
          if(level === -1) return false;
  
          pt.x0 = eachWidth * level;
          pt.x1 = eachWidth * (level + 1);
          pt.y0 = barDifY;
          pt.y1 = barDifY + height;
  
          pt.onPathbar = true;
  
          return true;
      });
  
      sliceData.reverse();
  
      slices = slices.data(sliceData, helpers.getPtId);
  
      slices.enter().append('g')
          .classed('pathbar', true);
  
      handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
  
      slices.order();
  
      var updateSlices = slices;
      if(hasTransition) {
          updateSlices = updateSlices.transition().each('end', function() {
              // N.B. gd._transitioning is (still) *true* by the time
              // transition updates get here
              var sliceTop = d3.select(this);
              helpers.setSliceCursor(sliceTop, gd, {
                  hideOnRoot: false,
                  hideOnLeaves: false,
                  isTransitioning: false
              });
          });
      }
  
      updateSlices.each(function(pt) {
          pt._hoverX = viewX(pt.x1 - Math.min(width, height) / 2);
          pt._hoverY = viewY(pt.y1 - height / 2);
  
          var sliceTop = d3.select(this);
  
          var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function(s) {
              s.style('pointer-events', 'all');
          });
  
          if(hasTransition) {
              slicePath.transition().attrTween('d', function(pt2) {
                  var interp = makeUpdateSliceInterpolator(pt2, onPathbar, refRect, [width, height]);
                  return function(t) { return pathSlice(interp(t)); };
              });
          } else {
              slicePath.attr('d', pathSlice);
          }
  
          sliceTop
              .call(attachFxHandlers, entry, gd, cd, {
                  styleOne: styleOne,
                  eventDataKeys: constants.eventDataKeys,
                  transitionTime: constants.CLICK_TRANSITION_TIME,
                  transitionEasing: constants.CLICK_TRANSITION_EASING
              })
              .call(helpers.setSliceCursor, gd, {
                  hideOnRoot: false,
                  hideOnLeaves: false,
                  isTransitioning: gd._transitioning
              });
  
          slicePath.call(styleOne, pt, trace, {
              hovered: false
          });
  
          pt._text = (helpers.getPtLabel(pt) || '').split('<br>').join(' ') || '';
  
          var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
          var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function(s) {
              // prohibit tex interpretation until we can handle
              // tex and regular text together
              s.attr('data-notex', 1);
          });
  
          var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font, {
              onPathbar: true
          }));
  
          sliceText.text(pt._text || ' ') // use one space character instead of a blank string to avoid jumps during transition
              .classed('slicetext', true)
              .attr('text-anchor', 'start')
              .call(Drawing.font, font)
              .call(svgTextUtils.convertToTspans, gd);
  
          pt.textBB = Drawing.bBox(sliceText.node());
          pt.transform = toMoveInsideSlice(pt, {
              fontSize: font.size,
              onPathbar: true
          });
          pt.transform.fontSize = font.size;
  
          if(hasTransition) {
              sliceText.transition().attrTween('transform', function(pt2) {
                  var interp = makeUpdateTextInterpolator(pt2, onPathbar, refRect, [width, height]);
                  return function(t) { return strTransform(interp(t)); };
              });
          } else {
              sliceText.attr('transform', strTransform(pt));
          }
      });
  };
  
  },{"../../components/drawing":637,"../../lib":750,"../../lib/svg_text_utils":774,"../sunburst/fx":1275,"../sunburst/helpers":1276,"./constants":1299,"./partition":1306,"./style":1308,"d3":169}],1302:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  var svgTextUtils = _dereq_('../../lib/svg_text_utils');
  
  var partition = _dereq_('./partition');
  var styleOne = _dereq_('./style').styleOne;
  var constants = _dereq_('./constants');
  var helpers = _dereq_('../sunburst/helpers');
  var attachFxHandlers = _dereq_('../sunburst/fx');
  var formatSliceLabel = _dereq_('../sunburst/plot').formatSliceLabel;
  
  var onPathbar = false; // for Descendants
  
  module.exports = function drawDescendants(gd, cd, entry, slices, opts) {
      var width = opts.width;
      var height = opts.height;
      var viewX = opts.viewX;
      var viewY = opts.viewY;
      var pathSlice = opts.pathSlice;
      var toMoveInsideSlice = opts.toMoveInsideSlice;
      var strTransform = opts.strTransform;
      var hasTransition = opts.hasTransition;
      var handleSlicesExit = opts.handleSlicesExit;
      var makeUpdateSliceInterpolator = opts.makeUpdateSliceInterpolator;
      var makeUpdateTextInterpolator = opts.makeUpdateTextInterpolator;
      var prevEntry = opts.prevEntry;
      var refRect = {};
  
      var fullLayout = gd._fullLayout;
      var cd0 = cd[0];
      var trace = cd0.trace;
  
      var hasLeft = trace.textposition.indexOf('left') !== -1;
      var hasRight = trace.textposition.indexOf('right') !== -1;
      var hasBottom = trace.textposition.indexOf('bottom') !== -1;
  
      var noRoomForHeader = (!hasBottom && !trace.marker.pad.t) || (hasBottom && !trace.marker.pad.b);
  
      // N.B. slice data isn't the calcdata,
      // grab corresponding calcdata item in sliceData[i].data.data
      var allData = partition(entry, [width, height], {
          packing: trace.tiling.packing,
          squarifyratio: trace.tiling.squarifyratio,
          flipX: trace.tiling.flip.indexOf('x') > -1,
          flipY: trace.tiling.flip.indexOf('y') > -1,
          pad: {
              inner: trace.tiling.pad,
              top: trace.marker.pad.t,
              left: trace.marker.pad.l,
              right: trace.marker.pad.r,
              bottom: trace.marker.pad.b,
          }
      });
  
      var sliceData = allData.descendants();
  
      var minVisibleDepth = Infinity;
      var maxVisibleDepth = -Infinity;
      sliceData.forEach(function(pt) {
          var depth = pt.depth;
          if(depth >= trace._maxDepth) {
              // hide slices that won't show up on graph
              pt.x0 = pt.x1 = (pt.x0 + pt.x1) / 2;
              pt.y0 = pt.y1 = (pt.y0 + pt.y1) / 2;
          } else {
              minVisibleDepth = Math.min(minVisibleDepth, depth);
              maxVisibleDepth = Math.max(maxVisibleDepth, depth);
          }
      });
  
      slices = slices.data(sliceData, helpers.getPtId);
  
      trace._maxVisibleLayers = isFinite(maxVisibleDepth) ? maxVisibleDepth - minVisibleDepth + 1 : 0;
  
      slices.enter().append('g')
          .classed('slice', true);
  
      handleSlicesExit(slices, onPathbar, refRect, [width, height], pathSlice);
  
      slices.order();
  
      // next coords of previous entry
      var nextOfPrevEntry = null;
      if(hasTransition && prevEntry) {
          var prevEntryId = helpers.getPtId(prevEntry);
          slices.each(function(pt) {
              if(nextOfPrevEntry === null && (helpers.getPtId(pt) === prevEntryId)) {
                  nextOfPrevEntry = {
                      x0: pt.x0,
                      x1: pt.x1,
                      y0: pt.y0,
                      y1: pt.y1
                  };
              }
          });
      }
  
      var getRefRect = function() {
          return nextOfPrevEntry || {
              x0: 0,
              x1: width,
              y0: 0,
              y1: height
          };
      };
  
      var updateSlices = slices;
      if(hasTransition) {
          updateSlices = updateSlices.transition().each('end', function() {
              // N.B. gd._transitioning is (still) *true* by the time
              // transition updates get here
              var sliceTop = d3.select(this);
              helpers.setSliceCursor(sliceTop, gd, {
                  hideOnRoot: true,
                  hideOnLeaves: false,
                  isTransitioning: false
              });
          });
      }
  
      updateSlices.each(function(pt) {
          var isHeader = helpers.isHeader(pt, trace);
  
          pt._hoverX = viewX(pt.x1 - trace.marker.pad.r),
          pt._hoverY = hasBottom ?
                  viewY(pt.y1 - trace.marker.pad.b / 2) :
                  viewY(pt.y0 + trace.marker.pad.t / 2);
  
          var sliceTop = d3.select(this);
  
          var slicePath = Lib.ensureSingle(sliceTop, 'path', 'surface', function(s) {
              s.style('pointer-events', 'all');
          });
  
          if(hasTransition) {
              slicePath.transition().attrTween('d', function(pt2) {
                  var interp = makeUpdateSliceInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
                  return function(t) { return pathSlice(interp(t)); };
              });
          } else {
              slicePath.attr('d', pathSlice);
          }
  
          sliceTop
              .call(attachFxHandlers, entry, gd, cd, {
                  styleOne: styleOne,
                  eventDataKeys: constants.eventDataKeys,
                  transitionTime: constants.CLICK_TRANSITION_TIME,
                  transitionEasing: constants.CLICK_TRANSITION_EASING
              })
              .call(helpers.setSliceCursor, gd, { isTransitioning: gd._transitioning });
  
          slicePath.call(styleOne, pt, trace, {
              hovered: false
          });
  
          if(pt.x0 === pt.x1 || pt.y0 === pt.y1) {
              pt._text = '';
          } else {
              if(isHeader) {
                  pt._text = noRoomForHeader ? '' : helpers.getPtLabel(pt) || '';
              } else {
                  pt._text = formatSliceLabel(pt, entry, trace, cd, fullLayout) || '';
              }
          }
  
          var sliceTextGroup = Lib.ensureSingle(sliceTop, 'g', 'slicetext');
          var sliceText = Lib.ensureSingle(sliceTextGroup, 'text', '', function(s) {
              // prohibit tex interpretation until we can handle
              // tex and regular text together
              s.attr('data-notex', 1);
          });
  
          var font = Lib.ensureUniformFontSize(gd, helpers.determineTextFont(trace, pt, fullLayout.font));
  
          sliceText.text(pt._text || ' ') // use one space character instead of a blank string to avoid jumps during transition
              .classed('slicetext', true)
              .attr('text-anchor', hasRight ? 'end' : (hasLeft || isHeader) ? 'start' : 'middle')
              .call(Drawing.font, font)
              .call(svgTextUtils.convertToTspans, gd);
  
          pt.textBB = Drawing.bBox(sliceText.node());
          pt.transform = toMoveInsideSlice(pt, {
              fontSize: font.size,
              isHeader: isHeader
          });
          pt.transform.fontSize = font.size;
  
          if(hasTransition) {
              sliceText.transition().attrTween('transform', function(pt2) {
                  var interp = makeUpdateTextInterpolator(pt2, onPathbar, getRefRect(), [width, height]);
                  return function(t) { return strTransform(interp(t)); };
              });
          } else {
              sliceText.attr('transform', strTransform(pt));
          }
      });
  
      return nextOfPrevEntry;
  };
  
  },{"../../components/drawing":637,"../../lib":750,"../../lib/svg_text_utils":774,"../sunburst/fx":1275,"../sunburst/helpers":1276,"../sunburst/plot":1280,"./constants":1299,"./partition":1306,"./style":1308,"d3":169}],1303:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      moduleType: 'trace',
      name: 'treemap',
      basePlotModule: _dereq_('./base_plot'),
      categories: [],
      animatable: true,
  
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyDefaults: _dereq_('./defaults'),
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
  
      calc: _dereq_('./calc').calc,
      crossTraceCalc: _dereq_('./calc').crossTraceCalc,
  
      plot: _dereq_('./plot'),
      style: _dereq_('./style').style,
  
      colorbar: _dereq_('../scatter/marker_colorbar'),
  
      meta: {
          
      }
  };
  
  },{"../scatter/marker_colorbar":1176,"./attributes":1296,"./base_plot":1297,"./calc":1298,"./defaults":1300,"./layout_attributes":1304,"./layout_defaults":1305,"./plot":1307,"./style":1308}],1304:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      treemapcolorway: {
          valType: 'colorlist',
          
          editType: 'calc',
          
      },
      extendtreemapcolors: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          
      }
  };
  
  },{}],1305:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
      coerce('treemapcolorway', layoutOut.colorway);
      coerce('extendtreemapcolors');
  };
  
  },{"../../lib":750,"./layout_attributes":1304}],1306:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3Hierarchy = _dereq_('d3-hierarchy');
  
  module.exports = function partition(entry, size, opts) {
      var flipX = opts.flipX;
      var flipY = opts.flipY;
      var swapXY = opts.packing === 'dice-slice';
  
      var top = opts.pad[flipY ? 'bottom' : 'top'];
      var left = opts.pad[flipX ? 'right' : 'left'];
      var right = opts.pad[flipX ? 'left' : 'right'];
      var bottom = opts.pad[flipY ? 'top' : 'bottom'];
  
      var tmp;
      if(swapXY) {
          tmp = left;
          left = top;
          top = tmp;
  
          tmp = right;
          right = bottom;
          bottom = tmp;
      }
  
      var result = d3Hierarchy
          .treemap()
          .tile(getTilingMethod(opts.packing, opts.squarifyratio))
          .paddingInner(opts.pad.inner)
          .paddingLeft(left)
          .paddingRight(right)
          .paddingTop(top)
          .paddingBottom(bottom)
          .size(
              swapXY ? [size[1], size[0]] : size
          )(entry);
  
      if(swapXY || flipX || flipY) {
          flipTree(result, size, {
              swapXY: swapXY,
              flipX: flipX,
              flipY: flipY
          });
      }
      return result;
  };
  
  function getTilingMethod(key, squarifyratio) {
      switch(key) {
          case 'squarify':
              return d3Hierarchy.treemapSquarify.ratio(squarifyratio);
          case 'binary':
              return d3Hierarchy.treemapBinary;
          case 'dice':
              return d3Hierarchy.treemapDice;
          case 'slice':
              return d3Hierarchy.treemapSlice;
          default: // i.e. 'slice-dice' | 'dice-slice'
              return d3Hierarchy.treemapSliceDice;
      }
  }
  
  function flipTree(node, size, opts) {
      var tmp;
  
      if(opts.swapXY) {
          // swap x0 and y0
          tmp = node.x0;
          node.x0 = node.y0;
          node.y0 = tmp;
  
          // swap x1 and y1
          tmp = node.x1;
          node.x1 = node.y1;
          node.y1 = tmp;
      }
  
      if(opts.flipX) {
          tmp = node.x0;
          node.x0 = size[0] - node.x1;
          node.x1 = size[0] - tmp;
      }
  
      if(opts.flipY) {
          tmp = node.y0;
          node.y0 = size[1] - node.y1;
          node.y1 = size[1] - tmp;
      }
  
      var children = node.children;
      if(children) {
          for(var i = 0; i < children.length; i++) {
              flipTree(children[i], size, opts);
          }
      }
  }
  
  },{"d3-hierarchy":161}],1307:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var helpers = _dereq_('../sunburst/helpers');
  
  var Lib = _dereq_('../../lib');
  var TEXTPAD = _dereq_('../bar/constants').TEXTPAD;
  var barPlot = _dereq_('../bar/plot');
  var toMoveInsideBar = barPlot.toMoveInsideBar;
  var uniformText = _dereq_('../bar/uniform_text');
  var recordMinTextSize = uniformText.recordMinTextSize;
  var clearMinTextSize = uniformText.clearMinTextSize;
  var resizeText = _dereq_('../bar/style').resizeText;
  var constants = _dereq_('./constants');
  var drawDescendants = _dereq_('./draw_descendants');
  var drawAncestors = _dereq_('./draw_ancestors');
  
  module.exports = function(gd, cdmodule, transitionOpts, makeOnCompleteCallback) {
      var fullLayout = gd._fullLayout;
      var layer = fullLayout._treemaplayer;
      var join, onComplete;
  
      // If transition config is provided, then it is only a partial replot and traces not
      // updated are removed.
      var isFullReplot = !transitionOpts;
  
      clearMinTextSize('treemap', fullLayout);
  
      join = layer.selectAll('g.trace.treemap')
          .data(cdmodule, function(cd) { return cd[0].trace.uid; });
  
      join.enter().append('g')
          .classed('trace', true)
          .classed('treemap', true);
  
      join.order();
  
      if(!fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts)) {
          if(makeOnCompleteCallback) {
              // If it was passed a callback to register completion, make a callback. If
              // this is created, then it must be executed on completion, otherwise the
              // pos-transition redraw will not execute:
              onComplete = makeOnCompleteCallback();
          }
  
          var transition = d3.transition()
              .duration(transitionOpts.duration)
              .ease(transitionOpts.easing)
              .each('end', function() { onComplete && onComplete(); })
              .each('interrupt', function() { onComplete && onComplete(); });
  
          transition.each(function() {
              // Must run the selection again since otherwise enters/updates get grouped together
              // and these get executed out of order. Except we need them in order!
              layer.selectAll('g.trace').each(function(cd) {
                  plotOne(gd, cd, this, transitionOpts);
              });
          });
      } else {
          join.each(function(cd) {
              plotOne(gd, cd, this, transitionOpts);
          });
  
          if(fullLayout.uniformtext.mode) {
              resizeText(gd, fullLayout._treemaplayer.selectAll('.trace'), 'treemap');
          }
      }
  
      if(isFullReplot) {
          join.exit().remove();
      }
  };
  
  function getKey(pt) {
      return helpers.isHierarchyRoot(pt) ?
          '' : // don't use the dummyId
          helpers.getPtId(pt);
  }
  
  function plotOne(gd, cd, element, transitionOpts) {
      var fullLayout = gd._fullLayout;
      var cd0 = cd[0];
      var trace = cd0.trace;
      var hierarchy = cd0.hierarchy;
      var entry = helpers.findEntryWithLevel(hierarchy, trace.level);
  
      var gTrace = d3.select(element);
      var selAncestors = gTrace.selectAll('g.pathbar');
      var selDescendants = gTrace.selectAll('g.slice');
  
      if(!entry) {
          selAncestors.remove();
          selDescendants.remove();
          return;
      }
  
      var isRoot = helpers.isHierarchyRoot(entry);
      var hasTransition = !fullLayout.uniformtext.mode && helpers.hasTransition(transitionOpts);
  
      var maxDepth = helpers.getMaxDepth(trace);
      var hasVisibleDepth = function(pt) {
          return pt.data.depth - entry.data.depth < maxDepth;
      };
  
      var gs = fullLayout._size;
      var domain = trace.domain;
  
      var vpw = gs.w * (domain.x[1] - domain.x[0]);
      var vph = gs.h * (domain.y[1] - domain.y[0]);
      var barW = vpw;
      var barH = trace.pathbar.thickness;
      var barPad = trace.marker.line.width + constants.gapWithPathbar;
      var barDifY = !trace.pathbar.visible ? 0 :
          trace.pathbar.side.indexOf('bottom') > -1 ? vph + barPad : -(barH + barPad);
  
      var pathbarOrigin = {
          x0: barW, // slide to the right
          x1: barW,
          y0: barDifY,
          y1: barDifY + barH
      };
  
      var findClosestEdge = function(pt, ref, size) {
          var e = trace.tiling.pad;
          var isLeftOfRect = function(x) { return x - e <= ref.x0; };
          var isRightOfRect = function(x) { return x + e >= ref.x1; };
          var isBottomOfRect = function(y) { return y - e <= ref.y0; };
          var isTopOfRect = function(y) { return y + e >= ref.y1; };
  
          return {
              x0: isLeftOfRect(pt.x0 - e) ? 0 : isRightOfRect(pt.x0 - e) ? size[0] : pt.x0,
              x1: isLeftOfRect(pt.x1 + e) ? 0 : isRightOfRect(pt.x1 + e) ? size[0] : pt.x1,
              y0: isBottomOfRect(pt.y0 - e) ? 0 : isTopOfRect(pt.y0 - e) ? size[1] : pt.y0,
              y1: isBottomOfRect(pt.y1 + e) ? 0 : isTopOfRect(pt.y1 + e) ? size[1] : pt.y1
          };
      };
  
      // stash of 'previous' position data used by tweening functions
      var prevEntry = null;
      var prevLookupPathbar = {};
      var prevLookupSlices = {};
      var nextOfPrevEntry = null;
      var getPrev = function(pt, onPathbar) {
          return onPathbar ?
              prevLookupPathbar[getKey(pt)] :
              prevLookupSlices[getKey(pt)];
      };
  
      var getOrigin = function(pt, onPathbar, refRect, size) {
          if(onPathbar) {
              return prevLookupPathbar[getKey(hierarchy)] || pathbarOrigin;
          } else {
              var ref = prevLookupSlices[trace.level] || refRect;
  
              if(hasVisibleDepth(pt)) { // case of an empty object - happens when maxdepth is set
                  return findClosestEdge(pt, ref, size);
              }
          }
          return {};
      };
  
      // N.B. handle multiple-root special case
      if(cd0.hasMultipleRoots && isRoot) {
          maxDepth++;
      }
  
      trace._maxDepth = maxDepth;
      trace._backgroundColor = fullLayout.paper_bgcolor;
      trace._entryDepth = entry.data.depth;
      trace._atRootLevel = isRoot;
  
      var cenX = -vpw / 2 + gs.l + gs.w * (domain.x[1] + domain.x[0]) / 2;
      var cenY = -vph / 2 + gs.t + gs.h * (1 - (domain.y[1] + domain.y[0]) / 2);
  
      var viewMapX = function(x) { return cenX + x; };
      var viewMapY = function(y) { return cenY + y; };
  
      var barY0 = viewMapY(0);
      var barX0 = viewMapX(0);
  
      var viewBarX = function(x) { return barX0 + x; };
      var viewBarY = function(y) { return barY0 + y; };
  
      function pos(x, y) {
          return x + ',' + y;
      }
  
      var xStart = viewBarX(0);
      var limitX0 = function(p) { p.x = Math.max(xStart, p.x); };
  
      var edgeshape = trace.pathbar.edgeshape;
  
      // pathbar(directory) path generation fn
      var pathAncestor = function(d) {
          var _x0 = viewBarX(Math.max(Math.min(d.x0, d.x0), 0));
          var _x1 = viewBarX(Math.min(Math.max(d.x1, d.x1), barW));
          var _y0 = viewBarY(d.y0);
          var _y1 = viewBarY(d.y1);
  
          var halfH = barH / 2;
  
          var pL = {};
          var pR = {};
  
          pL.x = _x0;
          pR.x = _x1;
  
          pL.y = pR.y = (_y0 + _y1) / 2;
  
          var pA = {x: _x0, y: _y0};
          var pB = {x: _x1, y: _y0};
          var pC = {x: _x1, y: _y1};
          var pD = {x: _x0, y: _y1};
  
          if(edgeshape === '>') {
              pA.x -= halfH;
              pB.x -= halfH;
              pC.x -= halfH;
              pD.x -= halfH;
          } else if(edgeshape === '/') {
              pC.x -= halfH;
              pD.x -= halfH;
              pL.x -= halfH / 2;
              pR.x -= halfH / 2;
          } else if(edgeshape === '\\') {
              pA.x -= halfH;
              pB.x -= halfH;
              pL.x -= halfH / 2;
              pR.x -= halfH / 2;
          } else if(edgeshape === '<') {
              pL.x -= halfH;
              pR.x -= halfH;
          }
  
          limitX0(pA);
          limitX0(pD);
          limitX0(pL);
  
          limitX0(pB);
          limitX0(pC);
          limitX0(pR);
  
          return (
             'M' + pos(pA.x, pA.y) +
             'L' + pos(pB.x, pB.y) +
             'L' + pos(pR.x, pR.y) +
             'L' + pos(pC.x, pC.y) +
             'L' + pos(pD.x, pD.y) +
             'L' + pos(pL.x, pL.y) +
             'Z'
          );
      };
  
      // slice path generation fn
      var pathDescendant = function(d) {
          var _x0 = viewMapX(d.x0);
          var _x1 = viewMapX(d.x1);
          var _y0 = viewMapY(d.y0);
          var _y1 = viewMapY(d.y1);
  
          var dx = _x1 - _x0;
          var dy = _y1 - _y0;
          if(!dx || !dy) return '';
  
          var FILLET = 0; // TODO: may expose this constant
  
          var r = (
              dx > 2 * FILLET &&
              dy > 2 * FILLET
          ) ? FILLET : 0;
  
          var arc = function(rx, ry) { return r ? 'a' + pos(r, r) + ' 0 0 1 ' + pos(rx, ry) : ''; };
  
          return (
             'M' + pos(_x0, _y0 + r) +
             arc(r, -r) +
             'L' + pos(_x1 - r, _y0) +
             arc(r, r) +
             'L' + pos(_x1, _y1 - r) +
             arc(-r, r) +
             'L' + pos(_x0 + r, _y1) +
             arc(-r, -r) + 'Z'
          );
      };
  
      var toMoveInsideSlice = function(pt, opts) {
          var x0 = pt.x0;
          var x1 = pt.x1;
          var y0 = pt.y0;
          var y1 = pt.y1;
          var textBB = pt.textBB;
  
          var hasFlag = function(f) { return trace.textposition.indexOf(f) !== -1; };
  
          var hasBottom = hasFlag('bottom');
          var hasTop = hasFlag('top') || (opts.isHeader && !hasBottom);
  
          var anchor =
              hasTop ? 'start' :
              hasBottom ? 'end' : 'middle';
  
          var hasRight = hasFlag('right');
          var hasLeft = hasFlag('left') || opts.onPathbar;
  
          var leftToRight =
              hasLeft ? -1 :
              hasRight ? 1 : 0;
  
          var pad = trace.marker.pad;
          if(opts.isHeader) {
              x0 += pad.l - TEXTPAD;
              x1 -= pad.r - TEXTPAD;
              if(x0 >= x1) {
                  var mid = (x0 + x1) / 2;
                  x0 = mid;
                  x1 = mid;
              }
  
              // limit the drawing area for headers
              var limY;
              if(hasBottom) {
                  limY = y1 - pad.b;
                  if(y0 < limY && limY < y1) y0 = limY;
              } else {
                  limY = y0 + pad.t;
                  if(y0 < limY && limY < y1) y1 = limY;
              }
          }
  
          // position the text relative to the slice
          var transform = toMoveInsideBar(x0, x1, y0, y1, textBB, {
              isHorizontal: false,
              constrained: true,
              angle: 0,
              anchor: anchor,
              leftToRight: leftToRight
          });
          transform.fontSize = opts.fontSize;
  
          transform.targetX = viewMapX(transform.targetX);
          transform.targetY = viewMapY(transform.targetY);
  
          if(isNaN(transform.targetX) || isNaN(transform.targetY)) {
              return {};
          }
  
          if(x0 !== x1 && y0 !== y1) {
              recordMinTextSize(trace.type, transform, fullLayout);
          }
  
          return {
              scale: transform.scale,
              rotate: transform.rotate,
              textX: transform.textX,
              textY: transform.textY,
              anchorX: transform.anchorX,
              anchorY: transform.anchorY,
              targetX: transform.targetX,
              targetY: transform.targetY
          };
      };
  
      var interpFromParent = function(pt, onPathbar) {
          var parentPrev;
          var i = 0;
          var Q = pt;
          while(!parentPrev && i < maxDepth) { // loop to find a parent/grandParent on the previous graph
              i++;
              Q = Q.parent;
              if(Q) {
                  parentPrev = getPrev(Q, onPathbar);
              } else i = maxDepth;
          }
          return parentPrev || {};
      };
  
      var makeExitSliceInterpolator = function(pt, onPathbar, refRect, size) {
          var prev = getPrev(pt, onPathbar);
          var next;
  
          if(onPathbar) {
              next = pathbarOrigin;
          } else {
              var entryPrev = getPrev(entry, onPathbar);
              if(entryPrev) {
                  // 'entryPrev' is here has the previous coordinates of the entry
                  // node, which corresponds to the last "clicked" node when zooming in
                  next = findClosestEdge(pt, entryPrev, size);
              } else {
                  // this happens when maxdepth is set, when leaves must
                  // be removed and the entry is new (i.e. does not have a 'prev' object)
                  next = {};
              }
          }
  
          return d3.interpolate(prev, next);
      };
  
      var makeUpdateSliceInterpolator = function(pt, onPathbar, refRect, size) {
          var prev0 = getPrev(pt, onPathbar);
          var prev;
  
          if(prev0) {
              // if pt already on graph, this is easy
              prev = prev0;
          } else {
              // for new pts:
              if(onPathbar) {
                  prev = pathbarOrigin;
              } else {
                  if(prevEntry) {
                      // if trace was visible before
                      if(pt.parent) {
                          var ref = nextOfPrevEntry || refRect;
  
                          if(ref && !onPathbar) {
                              prev = findClosestEdge(pt, ref, size);
                          } else {
                              // if new leaf (when maxdepth is set),
                              // grow it from its parent node
                              prev = {};
                              Lib.extendFlat(prev, interpFromParent(pt, onPathbar));
                          }
                      } else {
                          prev = pt;
                      }
                  } else {
                      prev = {};
                  }
              }
          }
  
          return d3.interpolate(prev, {
              x0: pt.x0,
              x1: pt.x1,
              y0: pt.y0,
              y1: pt.y1
          });
      };
  
      var makeUpdateTextInterpolator = function(pt, onPathbar, refRect, size) {
          var prev0 = getPrev(pt, onPathbar);
          var prev = {};
          var origin = getOrigin(pt, onPathbar, refRect, size);
  
          Lib.extendFlat(prev, {
              transform: toMoveInsideSlice({
                  x0: origin.x0,
                  x1: origin.x1,
                  y0: origin.y0,
                  y1: origin.y1,
                  textBB: pt.textBB,
                  _text: pt._text
              }, {
                  isHeader: helpers.isHeader(pt, trace)
              })
          });
  
          if(prev0) {
              // if pt already on graph, this is easy
              prev = prev0;
          } else {
              // for new pts:
              if(pt.parent) {
                  Lib.extendFlat(prev, interpFromParent(pt, onPathbar));
              }
          }
  
          var transform = pt.transform;
          if(pt.x0 !== pt.x1 && pt.y0 !== pt.y1) {
              recordMinTextSize(trace.type, transform, fullLayout);
          }
  
          return d3.interpolate(prev, {
              transform: {
                  scale: transform.scale,
                  rotate: transform.rotate,
                  textX: transform.textX,
                  textY: transform.textY,
                  anchorX: transform.anchorX,
                  anchorY: transform.anchorY,
                  targetX: transform.targetX,
                  targetY: transform.targetY
              }
          });
      };
  
      var handleSlicesExit = function(slices, onPathbar, refRect, size, pathSlice) {
          var width = size[0];
          var height = size[1];
  
          if(hasTransition) {
              slices.exit().transition()
                  .each(function() {
                      var sliceTop = d3.select(this);
  
                      var slicePath = sliceTop.select('path.surface');
                      slicePath.transition().attrTween('d', function(pt2) {
                          var interp = makeExitSliceInterpolator(pt2, onPathbar, refRect, [width, height]);
                          return function(t) { return pathSlice(interp(t)); };
                      });
  
                      var sliceTextGroup = sliceTop.select('g.slicetext');
                      sliceTextGroup.attr('opacity', 0);
                  })
                  .remove();
          } else {
              slices.exit().remove();
          }
      };
  
      var strTransform = function(d) {
          var transform = d.transform;
  
          if(d.x0 !== d.x1 && d.y0 !== d.y1) {
              recordMinTextSize(trace.type, transform, fullLayout);
          }
  
          return Lib.getTextTransform({
              textX: transform.textX,
              textY: transform.textY,
              anchorX: transform.anchorX,
              anchorY: transform.anchorY,
              targetX: transform.targetX,
              targetY: transform.targetY,
              scale: transform.scale,
              rotate: transform.rotate
          });
      };
  
      if(hasTransition) {
          // Important: do this before binding new sliceData!
  
          selAncestors.each(function(pt) {
              prevLookupPathbar[getKey(pt)] = {
                  x0: pt.x0,
                  x1: pt.x1,
                  y0: pt.y0,
                  y1: pt.y1
              };
  
              if(pt.transform) {
                  prevLookupPathbar[getKey(pt)].transform = {
                      textX: pt.transform.textX,
                      textY: pt.transform.textY,
                      anchorX: pt.transform.anchorX,
                      anchorY: pt.transform.anchorY,
                      targetX: pt.transform.targetX,
                      targetY: pt.transform.targetY,
                      scale: pt.transform.scale,
                      rotate: pt.transform.rotate
                  };
              }
          });
  
          selDescendants.each(function(pt) {
              prevLookupSlices[getKey(pt)] = {
                  x0: pt.x0,
                  x1: pt.x1,
                  y0: pt.y0,
                  y1: pt.y1
              };
  
              if(pt.transform) {
                  prevLookupSlices[getKey(pt)].transform = {
                      textX: pt.transform.textX,
                      textY: pt.transform.textY,
                      anchorX: pt.transform.anchorX,
                      anchorY: pt.transform.anchorY,
                      targetX: pt.transform.targetX,
                      targetY: pt.transform.targetY,
                      scale: pt.transform.scale,
                      rotate: pt.transform.rotate
                  };
              }
  
              if(!prevEntry && helpers.isEntry(pt)) {
                  prevEntry = pt;
              }
          });
      }
  
      nextOfPrevEntry = drawDescendants(gd, cd, entry, selDescendants, {
          width: vpw,
          height: vph,
  
          viewX: viewMapX,
          viewY: viewMapY,
  
          pathSlice: pathDescendant,
          toMoveInsideSlice: toMoveInsideSlice,
  
          prevEntry: prevEntry,
          makeUpdateSliceInterpolator: makeUpdateSliceInterpolator,
          makeUpdateTextInterpolator: makeUpdateTextInterpolator,
  
          handleSlicesExit: handleSlicesExit,
          hasTransition: hasTransition,
          strTransform: strTransform
      });
  
      if(trace.pathbar.visible) {
          drawAncestors(gd, cd, entry, selAncestors, {
              barDifY: barDifY,
              width: barW,
              height: barH,
  
              viewX: viewBarX,
              viewY: viewBarY,
  
              pathSlice: pathAncestor,
              toMoveInsideSlice: toMoveInsideSlice,
  
              makeUpdateSliceInterpolator: makeUpdateSliceInterpolator,
              makeUpdateTextInterpolator: makeUpdateTextInterpolator,
  
              handleSlicesExit: handleSlicesExit,
              hasTransition: hasTransition,
              strTransform: strTransform
          });
      } else {
          selAncestors.remove();
      }
  }
  
  },{"../../lib":750,"../bar/constants":894,"../bar/plot":903,"../bar/style":906,"../bar/uniform_text":908,"../sunburst/helpers":1276,"./constants":1299,"./draw_ancestors":1301,"./draw_descendants":1302,"d3":169}],1308:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Color = _dereq_('../../components/color');
  var Lib = _dereq_('../../lib');
  var helpers = _dereq_('../sunburst/helpers');
  var resizeText = _dereq_('../bar/uniform_text').resizeText;
  
  function style(gd) {
      var s = gd._fullLayout._treemaplayer.selectAll('.trace');
      resizeText(gd, s, 'treemap');
  
      s.each(function(cd) {
          var gTrace = d3.select(this);
          var cd0 = cd[0];
          var trace = cd0.trace;
  
          gTrace.style('opacity', trace.opacity);
  
          gTrace.selectAll('path.surface').each(function(pt) {
              d3.select(this).call(styleOne, pt, trace, {
                  hovered: false
              });
          });
      });
  }
  
  function styleOne(s, pt, trace, opts) {
      var hovered = (opts || {}).hovered;
      var cdi = pt.data.data;
      var ptNumber = cdi.i;
      var lineColor;
      var lineWidth;
      var fillColor = cdi.color;
      var isRoot = helpers.isHierarchyRoot(pt);
      var opacity = 1;
  
      if(hovered) {
          lineColor = trace._hovered.marker.line.color;
          lineWidth = trace._hovered.marker.line.width;
      } else {
          if(isRoot && fillColor === 'rgba(0,0,0,0)') {
              opacity = 0;
              lineColor = 'rgba(0,0,0,0)';
              lineWidth = 0;
          } else {
              lineColor = Lib.castOption(trace, ptNumber, 'marker.line.color') || Color.defaultLine;
              lineWidth = Lib.castOption(trace, ptNumber, 'marker.line.width') || 0;
  
              if(!trace._hasColorscale && !pt.onPathbar) {
                  var depthfade = trace.marker.depthfade;
                  if(depthfade) {
                      var fadedColor = Color.combine(Color.addOpacity(trace._backgroundColor, 0.75), fillColor);
                      var n;
  
                      if(depthfade === true) {
                          var maxDepth = helpers.getMaxDepth(trace);
                          if(isFinite(maxDepth)) {
                              if(helpers.isLeaf(pt)) {
                                  n = 0;
                              } else {
                                  n = (trace._maxVisibleLayers) - (pt.data.depth - trace._entryDepth);
                              }
                          } else {
                              n = pt.data.height + 1;
                          }
                      } else { // i.e. case of depthfade === 'reversed'
                          n = pt.data.depth - trace._entryDepth;
                          if(!trace._atRootLevel) n++;
                      }
  
                      if(n > 0) {
                          for(var i = 0; i < n; i++) {
                              var ratio = 0.5 * i / n;
                              fillColor = Color.combine(Color.addOpacity(fadedColor, ratio), fillColor);
                          }
                      }
                  }
              }
          }
      }
  
      s.style('stroke-width', lineWidth)
          .call(Color.fill, fillColor)
          .call(Color.stroke, lineColor)
          .style('opacity', opacity);
  }
  
  module.exports = {
      style: style,
      styleOne: styleOne
  };
  
  },{"../../components/color":615,"../../lib":750,"../bar/uniform_text":908,"../sunburst/helpers":1276,"d3":169}],1309:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var boxAttrs = _dereq_('../box/attributes');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  
  module.exports = {
      y: boxAttrs.y,
      x: boxAttrs.x,
      x0: boxAttrs.x0,
      y0: boxAttrs.y0,
  
      name: extendFlat({}, boxAttrs.name, {
          
      }),
      orientation: extendFlat({}, boxAttrs.orientation, {
          
      }),
  
      bandwidth: {
          valType: 'number',
          min: 0,
          
          editType: 'calc',
          
      },
  
      scalegroup: {
          valType: 'string',
          
          dflt: '',
          editType: 'calc',
          
      },
      scalemode: {
          valType: 'enumerated',
          values: ['width', 'count'],
          dflt: 'width',
          
          editType: 'calc',
          
      },
  
      spanmode: {
          valType: 'enumerated',
          values: ['soft', 'hard', 'manual'],
          dflt: 'soft',
          
          editType: 'calc',
          
      },
      span: {
          valType: 'info_array',
          items: [
              {valType: 'any', editType: 'calc'},
              {valType: 'any', editType: 'calc'}
          ],
          
          editType: 'calc',
          
      },
  
      line: {
          color: {
              valType: 'color',
              
              editType: 'style',
              
          },
          width: {
              valType: 'number',
              
              min: 0,
              dflt: 2,
              editType: 'style',
              
          },
          editType: 'plot'
      },
      fillcolor: boxAttrs.fillcolor,
  
      points: extendFlat({}, boxAttrs.boxpoints, {
          
      }),
      jitter: extendFlat({}, boxAttrs.jitter, {
          
      }),
      pointpos: extendFlat({}, boxAttrs.pointpos, {
          
      }),
  
      width: extendFlat({}, boxAttrs.width, {
          
      }),
  
      marker: boxAttrs.marker,
      text: boxAttrs.text,
      hovertext: boxAttrs.hovertext,
      hovertemplate: boxAttrs.hovertemplate,
  
      box: {
          visible: {
              valType: 'boolean',
              dflt: false,
              
              editType: 'plot',
              
          },
          width: {
              valType: 'number',
              min: 0,
              max: 1,
              dflt: 0.25,
              
              editType: 'plot',
              
          },
          fillcolor: {
              valType: 'color',
              
              editType: 'style',
              
          },
          line: {
              color: {
                  valType: 'color',
                  
                  editType: 'style',
                  
              },
              width: {
                  valType: 'number',
                  min: 0,
                  
                  editType: 'style',
                  
              },
              editType: 'style'
          },
          editType: 'plot'
      },
  
      meanline: {
          visible: {
              valType: 'boolean',
              dflt: false,
              
              editType: 'plot',
              
          },
          color: {
              valType: 'color',
              
              editType: 'style',
              
          },
          width: {
              valType: 'number',
              min: 0,
              
              editType: 'style',
              
          },
          editType: 'plot'
      },
  
      side: {
          valType: 'enumerated',
          values: ['both', 'positive', 'negative'],
          dflt: 'both',
          
          editType: 'calc',
          
      },
  
      offsetgroup: boxAttrs.offsetgroup,
      alignmentgroup: boxAttrs.alignmentgroup,
  
      selected: boxAttrs.selected,
      unselected: boxAttrs.unselected,
  
      hoveron: {
          valType: 'flaglist',
          flags: ['violins', 'points', 'kde'],
          dflt: 'violins+points+kde',
          extras: ['all'],
          
          editType: 'style',
          
      }
  };
  
  },{"../../lib/extend":740,"../box/attributes":917}],1310:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var boxCalc = _dereq_('../box/calc');
  var helpers = _dereq_('./helpers');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  module.exports = function calc(gd, trace) {
      var cd = boxCalc(gd, trace);
  
      if(cd[0].t.empty) return cd;
  
      var fullLayout = gd._fullLayout;
      var valAxis = Axes.getFromId(
          gd,
          trace[trace.orientation === 'h' ? 'xaxis' : 'yaxis']
      );
  
      var spanMin = Infinity;
      var spanMax = -Infinity;
      var maxKDE = 0;
      var maxCount = 0;
  
      for(var i = 0; i < cd.length; i++) {
          var cdi = cd[i];
          var vals = cdi.pts.map(helpers.extractVal);
  
          var bandwidth = cdi.bandwidth = calcBandwidth(trace, cdi, vals);
          var span = cdi.span = calcSpan(trace, cdi, valAxis, bandwidth);
  
          if(cdi.min === cdi.max && bandwidth === 0) {
              // if span is zero and bandwidth is zero, we want a violin with zero width
              span = cdi.span = [cdi.min, cdi.max];
              cdi.density = [{v: 1, t: span[0]}];
              cdi.bandwidth = bandwidth;
              maxKDE = Math.max(maxKDE, 1);
          } else {
              // step that well covers the bandwidth and is multiple of span distance
              var dist = span[1] - span[0];
              var n = Math.ceil(dist / (bandwidth / 3));
              var step = dist / n;
  
              if(!isFinite(step) || !isFinite(n)) {
                  Lib.error('Something went wrong with computing the violin span');
                  cd[0].t.empty = true;
                  return cd;
              }
  
              var kde = helpers.makeKDE(cdi, trace, vals);
              cdi.density = new Array(n);
  
              for(var k = 0, t = span[0]; t < (span[1] + step / 2); k++, t += step) {
                  var v = kde(t);
                  cdi.density[k] = {v: v, t: t};
                  maxKDE = Math.max(maxKDE, v);
              }
          }
  
          maxCount = Math.max(maxCount, vals.length);
          spanMin = Math.min(spanMin, span[0]);
          spanMax = Math.max(spanMax, span[1]);
      }
  
      var extremes = Axes.findExtremes(valAxis, [spanMin, spanMax], {padded: true});
      trace._extremes[valAxis._id] = extremes;
  
      if(trace.width) {
          cd[0].t.maxKDE = maxKDE;
      } else {
          var violinScaleGroupStats = fullLayout._violinScaleGroupStats;
          var scaleGroup = trace.scalegroup;
          var groupStats = violinScaleGroupStats[scaleGroup];
  
          if(groupStats) {
              groupStats.maxKDE = Math.max(groupStats.maxKDE, maxKDE);
              groupStats.maxCount = Math.max(groupStats.maxCount, maxCount);
          } else {
              violinScaleGroupStats[scaleGroup] = {
                  maxKDE: maxKDE,
                  maxCount: maxCount
              };
          }
      }
  
      cd[0].t.labels.kde = Lib._(gd, 'kde:');
  
      return cd;
  };
  
  // Default to Silveman's rule of thumb
  // - https://stats.stackexchange.com/a/6671
  // - https://en.wikipedia.org/wiki/Kernel_density_estimation#A_rule-of-thumb_bandwidth_estimator
  // - https://github.com/statsmodels/statsmodels/blob/master/statsmodels/nonparametric/bandwidths.py
  function silvermanRule(len, ssd, iqr) {
      var a = Math.min(ssd, iqr / 1.349);
      return 1.059 * a * Math.pow(len, -0.2);
  }
  
  function calcBandwidth(trace, cdi, vals) {
      var span = cdi.max - cdi.min;
  
      // If span is zero
      if(!span) {
          if(trace.bandwidth) {
              return trace.bandwidth;
          } else {
              // if span is zero and no bandwidth is specified
              // it returns zero bandwidth which is a special case
              return 0;
          }
      }
  
      // Limit how small the bandwidth can be.
      //
      // Silverman's rule of thumb can be "very" small
      // when IQR does a poor job at describing the spread
      // of the distribution.
      // We also want to limit custom bandwidths
      // to not blow up kde computations.
  
      if(trace.bandwidth) {
          return Math.max(trace.bandwidth, span / 1e4);
      } else {
          var len = vals.length;
          var ssd = Lib.stdev(vals, len - 1, cdi.mean);
          return Math.max(
              silvermanRule(len, ssd, cdi.q3 - cdi.q1),
              span / 100
          );
      }
  }
  
  function calcSpan(trace, cdi, valAxis, bandwidth) {
      var spanmode = trace.spanmode;
      var spanIn = trace.span || [];
      var spanTight = [cdi.min, cdi.max];
      var spanLoose = [cdi.min - 2 * bandwidth, cdi.max + 2 * bandwidth];
      var spanOut;
  
      function calcSpanItem(index) {
          var s = spanIn[index];
          var sc = valAxis.type === 'multicategory' ?
              valAxis.r2c(s) :
              valAxis.d2c(s, 0, trace[cdi.valLetter + 'calendar']);
          return sc === BADNUM ? spanLoose[index] : sc;
      }
  
      if(spanmode === 'soft') {
          spanOut = spanLoose;
      } else if(spanmode === 'hard') {
          spanOut = spanTight;
      } else {
          spanOut = [calcSpanItem(0), calcSpanItem(1)];
      }
  
      // to reuse the equal-range-item block
      var dummyAx = {
          type: 'linear',
          range: spanOut
      };
      Axes.setConvert(dummyAx);
      dummyAx.cleanRange();
  
      return spanOut;
  }
  
  },{"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/axes":799,"../box/calc":918,"./helpers":1313}],1311:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var setPositionOffset = _dereq_('../box/cross_trace_calc').setPositionOffset;
  var orientations = ['v', 'h'];
  
  module.exports = function crossTraceCalc(gd, plotinfo) {
      var calcdata = gd.calcdata;
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      for(var i = 0; i < orientations.length; i++) {
          var orientation = orientations[i];
          var posAxis = orientation === 'h' ? ya : xa;
          var violinList = [];
  
          for(var j = 0; j < calcdata.length; j++) {
              var cd = calcdata[j];
              var t = cd[0].t;
              var trace = cd[0].trace;
  
              if(trace.visible === true && trace.type === 'violin' &&
                      !t.empty &&
                      trace.orientation === orientation &&
                      trace.xaxis === xa._id &&
                      trace.yaxis === ya._id
                ) {
                  violinList.push(j);
              }
          }
  
          setPositionOffset('violin', gd, violinList, posAxis);
      }
  };
  
  },{"../box/cross_trace_calc":919}],1312:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Color = _dereq_('../../components/color');
  
  var boxDefaults = _dereq_('../box/defaults');
  var attributes = _dereq_('./attributes');
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
      function coerce2(attr, dflt) {
          return Lib.coerce2(traceIn, traceOut, attributes, attr, dflt);
      }
  
      boxDefaults.handleSampleDefaults(traceIn, traceOut, coerce, layout);
      if(traceOut.visible === false) return;
  
      coerce('bandwidth');
      coerce('side');
  
      var width = coerce('width');
      if(!width) {
          coerce('scalegroup', traceOut.name);
          coerce('scalemode');
      }
  
      var span = coerce('span');
      var spanmodeDflt;
      if(Array.isArray(span)) spanmodeDflt = 'manual';
      coerce('spanmode', spanmodeDflt);
  
      var lineColor = coerce('line.color', (traceIn.marker || {}).color || defaultColor);
      var lineWidth = coerce('line.width');
      var fillColor = coerce('fillcolor', Color.addOpacity(traceOut.line.color, 0.5));
  
      boxDefaults.handlePointsDefaults(traceIn, traceOut, coerce, {prefix: ''});
  
      var boxWidth = coerce2('box.width');
      var boxFillColor = coerce2('box.fillcolor', fillColor);
      var boxLineColor = coerce2('box.line.color', lineColor);
      var boxLineWidth = coerce2('box.line.width', lineWidth);
      var boxVisible = coerce('box.visible', Boolean(boxWidth || boxFillColor || boxLineColor || boxLineWidth));
      if(!boxVisible) traceOut.box = {visible: false};
  
      var meanLineColor = coerce2('meanline.color', lineColor);
      var meanLineWidth = coerce2('meanline.width', lineWidth);
      var meanLineVisible = coerce('meanline.visible', Boolean(meanLineColor || meanLineWidth));
      if(!meanLineVisible) traceOut.meanline = {visible: false};
  };
  
  },{"../../components/color":615,"../../lib":750,"../box/defaults":920,"./attributes":1309}],1313:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  // Maybe add kernels more down the road,
  // but note that the default `spanmode: 'soft'` bounds might have
  // to become kernel-dependent
  var kernels = {
      gaussian: function(v) {
          return (1 / Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * v * v);
      }
  };
  
  exports.makeKDE = function(calcItem, trace, vals) {
      var len = vals.length;
      var kernel = kernels.gaussian;
      var bandwidth = calcItem.bandwidth;
      var factor = 1 / (len * bandwidth);
  
      // don't use Lib.aggNums to skip isNumeric checks
      return function(x) {
          var sum = 0;
          for(var i = 0; i < len; i++) {
              sum += kernel((x - vals[i]) / bandwidth);
          }
          return factor * sum;
      };
  };
  
  exports.getPositionOnKdePath = function(calcItem, trace, valuePx) {
      var posLetter, valLetter;
  
      if(trace.orientation === 'h') {
          posLetter = 'y';
          valLetter = 'x';
      } else {
          posLetter = 'x';
          valLetter = 'y';
      }
  
      var pointOnPath = Lib.findPointOnPath(
          calcItem.path,
          valuePx,
          valLetter,
          {pathLength: calcItem.pathLength}
      );
  
      var posCenterPx = calcItem.posCenterPx;
      var posOnPath0 = pointOnPath[posLetter];
      var posOnPath1 = trace.side === 'both' ?
          2 * posCenterPx - posOnPath0 :
          posCenterPx;
  
      return [posOnPath0, posOnPath1];
  };
  
  exports.getKdeValue = function(calcItem, trace, valueDist) {
      var vals = calcItem.pts.map(exports.extractVal);
      var kde = exports.makeKDE(calcItem, trace, vals);
      return kde(valueDist) / calcItem.posDensityScale;
  };
  
  exports.extractVal = function(o) { return o.v; };
  
  },{"../../lib":750}],1314:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var Axes = _dereq_('../../plots/cartesian/axes');
  var boxHoverPoints = _dereq_('../box/hover');
  var helpers = _dereq_('./helpers');
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode, hoverLayer) {
      var cd = pointData.cd;
      var trace = cd[0].trace;
      var hoveron = trace.hoveron;
      var hasHoveronViolins = hoveron.indexOf('violins') !== -1;
      var hasHoveronKDE = hoveron.indexOf('kde') !== -1;
      var closeData = [];
      var closePtData;
      var violinLineAttrs;
  
      if(hasHoveronViolins || hasHoveronKDE) {
          var closeBoxData = boxHoverPoints.hoverOnBoxes(pointData, xval, yval, hovermode);
  
          if(hasHoveronKDE && closeBoxData.length > 0) {
              var xa = pointData.xa;
              var ya = pointData.ya;
              var pLetter, vLetter, pAxis, vAxis, vVal;
  
              if(trace.orientation === 'h') {
                  vVal = xval;
                  pLetter = 'y';
                  pAxis = ya;
                  vLetter = 'x';
                  vAxis = xa;
              } else {
                  vVal = yval;
                  pLetter = 'x';
                  pAxis = xa;
                  vLetter = 'y';
                  vAxis = ya;
              }
  
              var di = cd[pointData.index];
  
              if(vVal >= di.span[0] && vVal <= di.span[1]) {
                  var kdePointData = Lib.extendFlat({}, pointData);
                  var vValPx = vAxis.c2p(vVal, true);
                  var kdeVal = helpers.getKdeValue(di, trace, vVal);
                  var pOnPath = helpers.getPositionOnKdePath(di, trace, vValPx);
                  var paOffset = pAxis._offset;
                  var paLength = pAxis._length;
  
                  kdePointData[pLetter + '0'] = pOnPath[0];
                  kdePointData[pLetter + '1'] = pOnPath[1];
                  kdePointData[vLetter + '0'] = kdePointData[vLetter + '1'] = vValPx;
                  kdePointData[vLetter + 'Label'] = vLetter + ': ' + Axes.hoverLabelText(vAxis, vVal) + ', ' + cd[0].t.labels.kde + ' ' + kdeVal.toFixed(3);
  
                  // move the spike to the KDE point
                  kdePointData.spikeDistance = closeBoxData[0].spikeDistance;
                  var spikePosAttr = pLetter + 'Spike';
                  kdePointData[spikePosAttr] = closeBoxData[0][spikePosAttr];
                  closeBoxData[0].spikeDistance = undefined;
                  closeBoxData[0][spikePosAttr] = undefined;
  
                  // no hovertemplate support yet
                  kdePointData.hovertemplate = false;
  
                  closeData.push(kdePointData);
  
                  violinLineAttrs = {stroke: pointData.color};
                  violinLineAttrs[pLetter + '1'] = Lib.constrain(paOffset + pOnPath[0], paOffset, paOffset + paLength);
                  violinLineAttrs[pLetter + '2'] = Lib.constrain(paOffset + pOnPath[1], paOffset, paOffset + paLength);
                  violinLineAttrs[vLetter + '1'] = violinLineAttrs[vLetter + '2'] = vAxis._offset + vValPx;
              }
          }
  
          if(hasHoveronViolins) {
              closeData = closeData.concat(closeBoxData);
          }
      }
  
      if(hoveron.indexOf('points') !== -1) {
          closePtData = boxHoverPoints.hoverOnPoints(pointData, xval, yval);
      }
  
      // update violin line (if any)
      var violinLine = hoverLayer.selectAll('.violinline-' + trace.uid)
          .data(violinLineAttrs ? [0] : []);
      violinLine.enter().append('line')
          .classed('violinline-' + trace.uid, true)
          .attr('stroke-width', 1.5);
      violinLine.exit().remove();
      violinLine.attr(violinLineAttrs);
  
      // same combine logic as box hoverPoints
      if(hovermode === 'closest') {
          if(closePtData) return [closePtData];
          return closeData;
      }
      if(closePtData) {
          closeData.push(closePtData);
          return closeData;
      }
      return closeData;
  };
  
  },{"../../lib":750,"../../plots/cartesian/axes":799,"../box/hover":922,"./helpers":1313}],1315:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyDefaults: _dereq_('./defaults'),
      crossTraceDefaults: _dereq_('../box/defaults').crossTraceDefaults,
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
      calc: _dereq_('./calc'),
      crossTraceCalc: _dereq_('./cross_trace_calc'),
      plot: _dereq_('./plot'),
      style: _dereq_('./style'),
      styleOnSelect: _dereq_('../scatter/style').styleOnSelect,
      hoverPoints: _dereq_('./hover'),
      selectPoints: _dereq_('../box/select'),
  
      moduleType: 'trace',
      name: 'violin',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['cartesian', 'svg', 'symbols', 'oriented', 'box-violin', 'showLegend', 'violinLayout', 'zoomScale'],
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"../box/defaults":920,"../box/select":927,"../scatter/style":1182,"./attributes":1309,"./calc":1310,"./cross_trace_calc":1311,"./defaults":1312,"./hover":1314,"./layout_attributes":1316,"./layout_defaults":1317,"./plot":1318,"./style":1319}],1316:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var boxLayoutAttrs = _dereq_('../box/layout_attributes');
  var extendFlat = _dereq_('../../lib').extendFlat;
  
  module.exports = {
      violinmode: extendFlat({}, boxLayoutAttrs.boxmode, {
          
      }),
      violingap: extendFlat({}, boxLayoutAttrs.boxgap, {
          
      }),
      violingroupgap: extendFlat({}, boxLayoutAttrs.boxgroupgap, {
          
      })
  };
  
  },{"../../lib":750,"../box/layout_attributes":924}],1317:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var layoutAttributes = _dereq_('./layout_attributes');
  var boxLayoutDefaults = _dereq_('../box/layout_defaults');
  
  module.exports = function supplyLayoutDefaults(layoutIn, layoutOut, fullData) {
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
      boxLayoutDefaults._supply(layoutIn, layoutOut, fullData, coerce, 'violin');
  };
  
  },{"../../lib":750,"../box/layout_defaults":925,"./layout_attributes":1316}],1318:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  
  var boxPlot = _dereq_('../box/plot');
  var linePoints = _dereq_('../scatter/line_points');
  var helpers = _dereq_('./helpers');
  
  module.exports = function plot(gd, plotinfo, cdViolins, violinLayer) {
      var fullLayout = gd._fullLayout;
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      function makePath(pts) {
          var segments = linePoints(pts, {
              xaxis: xa,
              yaxis: ya,
              connectGaps: true,
              baseTolerance: 0.75,
              shape: 'spline',
              simplify: true,
              linearized: true
          });
          return Drawing.smoothopen(segments[0], 1);
      }
  
      Lib.makeTraceGroups(violinLayer, cdViolins, 'trace violins').each(function(cd) {
          var plotGroup = d3.select(this);
          var cd0 = cd[0];
          var t = cd0.t;
          var trace = cd0.trace;
  
          if(trace.visible !== true || t.empty) {
              plotGroup.remove();
              return;
          }
  
          var bPos = t.bPos;
          var bdPos = t.bdPos;
          var valAxis = plotinfo[t.valLetter + 'axis'];
          var posAxis = plotinfo[t.posLetter + 'axis'];
          var hasBothSides = trace.side === 'both';
          var hasPositiveSide = hasBothSides || trace.side === 'positive';
          var hasNegativeSide = hasBothSides || trace.side === 'negative';
  
          var violins = plotGroup.selectAll('path.violin').data(Lib.identity);
  
          violins.enter().append('path')
              .style('vector-effect', 'non-scaling-stroke')
              .attr('class', 'violin');
  
          violins.exit().remove();
  
          violins.each(function(d) {
              var pathSel = d3.select(this);
              var density = d.density;
              var len = density.length;
              var posCenter = posAxis.c2l(d.pos + bPos, true);
              var posCenterPx = posAxis.l2p(posCenter);
  
              var scale;
              if(trace.width) {
                  scale = t.maxKDE / bdPos;
              } else {
                  var groupStats = fullLayout._violinScaleGroupStats[trace.scalegroup];
                  scale = trace.scalemode === 'count' ?
                      (groupStats.maxKDE / bdPos) * (groupStats.maxCount / d.pts.length) :
                      groupStats.maxKDE / bdPos;
              }
  
              var pathPos, pathNeg, path;
              var i, k, pts, pt;
  
              if(hasPositiveSide) {
                  pts = new Array(len);
                  for(i = 0; i < len; i++) {
                      pt = pts[i] = {};
                      pt[t.posLetter] = posCenter + (density[i].v / scale);
                      pt[t.valLetter] = valAxis.c2l(density[i].t, true);
                  }
                  pathPos = makePath(pts);
              }
  
              if(hasNegativeSide) {
                  pts = new Array(len);
                  for(k = 0, i = len - 1; k < len; k++, i--) {
                      pt = pts[k] = {};
                      pt[t.posLetter] = posCenter - (density[i].v / scale);
                      pt[t.valLetter] = valAxis.c2l(density[i].t, true);
                  }
                  pathNeg = makePath(pts);
              }
  
              if(hasBothSides) {
                  path = pathPos + 'L' + pathNeg.substr(1) + 'Z';
              } else {
                  var startPt = [posCenterPx, valAxis.c2p(density[0].t)];
                  var endPt = [posCenterPx, valAxis.c2p(density[len - 1].t)];
  
                  if(trace.orientation === 'h') {
                      startPt.reverse();
                      endPt.reverse();
                  }
  
                  if(hasPositiveSide) {
                      path = 'M' + startPt + 'L' + pathPos.substr(1) + 'L' + endPt;
                  } else {
                      path = 'M' + endPt + 'L' + pathNeg.substr(1) + 'L' + startPt;
                  }
              }
              pathSel.attr('d', path);
  
              // save a few things used in getPositionOnKdePath, getKdeValue
              // on hover and for meanline draw block below
              d.posCenterPx = posCenterPx;
              d.posDensityScale = scale * bdPos;
              d.path = pathSel.node();
              d.pathLength = d.path.getTotalLength() / (hasBothSides ? 2 : 1);
          });
  
          var boxAttrs = trace.box;
          var boxWidth = boxAttrs.width;
          var boxLineWidth = (boxAttrs.line || {}).width;
          var bdPosScaled;
          var bPosPxOffset;
  
          if(hasBothSides) {
              bdPosScaled = bdPos * boxWidth;
              bPosPxOffset = 0;
          } else if(hasPositiveSide) {
              bdPosScaled = [0, bdPos * boxWidth / 2];
              bPosPxOffset = boxLineWidth * {x: 1, y: -1}[t.posLetter];
          } else {
              bdPosScaled = [bdPos * boxWidth / 2, 0];
              bPosPxOffset = boxLineWidth * {x: -1, y: 1}[t.posLetter];
          }
  
          // inner box
          boxPlot.plotBoxAndWhiskers(plotGroup, {pos: posAxis, val: valAxis}, trace, {
              bPos: bPos,
              bdPos: bdPosScaled,
              bPosPxOffset: bPosPxOffset
          });
  
          // meanline insider box
          boxPlot.plotBoxMean(plotGroup, {pos: posAxis, val: valAxis}, trace, {
              bPos: bPos,
              bdPos: bdPosScaled,
              bPosPxOffset: bPosPxOffset
          });
  
          var fn;
          if(!trace.box.visible && trace.meanline.visible) {
              fn = Lib.identity;
          }
  
          // N.B. use different class name than boxPlot.plotBoxMean,
          // to avoid selectAll conflict
          var meanPaths = plotGroup.selectAll('path.meanline').data(fn || []);
          meanPaths.enter().append('path')
              .attr('class', 'meanline')
              .style('fill', 'none')
              .style('vector-effect', 'non-scaling-stroke');
          meanPaths.exit().remove();
          meanPaths.each(function(d) {
              var v = valAxis.c2p(d.mean, true);
              var p = helpers.getPositionOnKdePath(d, trace, v);
  
              d3.select(this).attr('d',
                  trace.orientation === 'h' ?
                      'M' + v + ',' + p[0] + 'V' + p[1] :
                      'M' + p[0] + ',' + v + 'H' + p[1]
              );
          });
  
          boxPlot.plotPoints(plotGroup, {x: xa, y: ya}, trace, t);
      });
  };
  
  },{"../../components/drawing":637,"../../lib":750,"../box/plot":926,"../scatter/line_points":1172,"./helpers":1313,"d3":169}],1319:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Color = _dereq_('../../components/color');
  var stylePoints = _dereq_('../scatter/style').stylePoints;
  
  module.exports = function style(gd) {
      var s = d3.select(gd).selectAll('g.trace.violins');
  
      s.style('opacity', function(d) { return d[0].trace.opacity; });
  
      s.each(function(d) {
          var trace = d[0].trace;
          var sel = d3.select(this);
          var box = trace.box || {};
          var boxLine = box.line || {};
          var meanline = trace.meanline || {};
          var meanLineWidth = meanline.width;
  
          sel.selectAll('path.violin')
              .style('stroke-width', trace.line.width + 'px')
              .call(Color.stroke, trace.line.color)
              .call(Color.fill, trace.fillcolor);
  
          sel.selectAll('path.box')
              .style('stroke-width', boxLine.width + 'px')
              .call(Color.stroke, boxLine.color)
              .call(Color.fill, box.fillcolor);
  
          var meanLineStyle = {
              'stroke-width': meanLineWidth + 'px',
              'stroke-dasharray': (2 * meanLineWidth) + 'px,' + meanLineWidth + 'px'
          };
  
          sel.selectAll('path.mean')
              .style(meanLineStyle)
              .call(Color.stroke, meanline.color);
  
          sel.selectAll('path.meanline')
              .style(meanLineStyle)
              .call(Color.stroke, meanline.color);
  
          stylePoints(sel, trace, gd);
      });
  };
  
  },{"../../components/color":615,"../scatter/style":1182,"d3":169}],1320:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var colorScaleAttrs = _dereq_('../../components/colorscale/attributes');
  var isosurfaceAttrs = _dereq_('../isosurface/attributes');
  var surfaceAttrs = _dereq_('../surface/attributes');
  var baseAttrs = _dereq_('../../plots/attributes');
  
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var overrideAll = _dereq_('../../plot_api/edit_types').overrideAll;
  
  var attrs = module.exports = overrideAll(extendFlat({
      x: isosurfaceAttrs.x,
      y: isosurfaceAttrs.y,
      z: isosurfaceAttrs.z,
      value: isosurfaceAttrs.value,
      isomin: isosurfaceAttrs.isomin,
      isomax: isosurfaceAttrs.isomax,
      surface: isosurfaceAttrs.surface,
      spaceframe: {
          show: {
              valType: 'boolean',
              
              dflt: false,
              
          },
          fill: {
              valType: 'number',
              
              min: 0,
              max: 1,
              dflt: 1,
              
          }
      },
  
      slices: isosurfaceAttrs.slices,
      caps: isosurfaceAttrs.caps,
      text: isosurfaceAttrs.text,
      hovertext: isosurfaceAttrs.hovertext,
      hovertemplate: isosurfaceAttrs.hovertemplate
  },
  
  colorScaleAttrs('', {
      colorAttr: '`value`',
      showScaleDflt: true,
      editTypeOverride: 'calc'
  }), {
  
      colorbar: isosurfaceAttrs.colorbar,
      opacity: isosurfaceAttrs.opacity,
      opacityscale: surfaceAttrs.opacityscale,
  
      lightposition: isosurfaceAttrs.lightposition,
      lighting: isosurfaceAttrs.lighting,
      flatshading: isosurfaceAttrs.flatshading,
      contour: isosurfaceAttrs.contour,
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo),
      showlegend: extendFlat({}, baseAttrs.showlegend, {dflt: false})
  }), 'calc', 'nested');
  
  attrs.x.editType = attrs.y.editType = attrs.z.editType = attrs.value.editType = 'calc+clearAxisTypes';
  attrs.transforms = undefined;
  
  },{"../../components/colorscale/attributes":622,"../../lib/extend":740,"../../plot_api/edit_types":781,"../../plots/attributes":795,"../isosurface/attributes":1094,"../surface/attributes":1282}],1321:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var createMesh = _dereq_('gl-mesh3d');
  
  var parseColorScale = _dereq_('../../lib/gl_format_color').parseColorScale;
  var str2RgbaArray = _dereq_('../../lib/str2rgbarray');
  var extractOpts = _dereq_('../../components/colorscale').extractOpts;
  var zip3 = _dereq_('../../plots/gl3d/zip3');
  
  var findNearestOnAxis = _dereq_('../isosurface/convert').findNearestOnAxis;
  var generateIsoMeshes = _dereq_('../isosurface/convert').generateIsoMeshes;
  
  function VolumeTrace(scene, mesh, uid) {
      this.scene = scene;
      this.uid = uid;
      this.mesh = mesh;
      this.name = '';
      this.data = null;
      this.showContour = false;
  }
  
  var proto = VolumeTrace.prototype;
  
  proto.handlePick = function(selection) {
      if(selection.object === this.mesh) {
          var rawId = selection.data.index;
  
          var x = this.data._meshX[rawId];
          var y = this.data._meshY[rawId];
          var z = this.data._meshZ[rawId];
  
          var height = this.data._Ys.length;
          var depth = this.data._Zs.length;
  
          var i = findNearestOnAxis(x, this.data._Xs).id;
          var j = findNearestOnAxis(y, this.data._Ys).id;
          var k = findNearestOnAxis(z, this.data._Zs).id;
  
          var selectIndex = selection.index = k + depth * j + depth * height * i;
  
          selection.traceCoordinate = [
              this.data._meshX[selectIndex],
              this.data._meshY[selectIndex],
              this.data._meshZ[selectIndex],
              this.data._value[selectIndex]
          ];
  
          var text = this.data.hovertext || this.data.text;
          if(Array.isArray(text) && text[selectIndex] !== undefined) {
              selection.textLabel = text[selectIndex];
          } else if(text) {
              selection.textLabel = text;
          }
  
          return true;
      }
  };
  
  proto.update = function(data) {
      var scene = this.scene;
      var layout = scene.fullSceneLayout;
  
      this.data = generateIsoMeshes(data);
  
      // Unpack position data
      function toDataCoords(axis, coord, scale, calendar) {
          return coord.map(function(x) {
              return axis.d2l(x, 0, calendar) * scale;
          });
      }
  
      var positions = zip3(
          toDataCoords(layout.xaxis, data._meshX, scene.dataScale[0], data.xcalendar),
          toDataCoords(layout.yaxis, data._meshY, scene.dataScale[1], data.ycalendar),
          toDataCoords(layout.zaxis, data._meshZ, scene.dataScale[2], data.zcalendar));
  
      var cells = zip3(data._meshI, data._meshJ, data._meshK);
  
      var config = {
          positions: positions,
          cells: cells,
          lightPosition: [data.lightposition.x, data.lightposition.y, data.lightposition.z],
          ambient: data.lighting.ambient,
          diffuse: data.lighting.diffuse,
          specular: data.lighting.specular,
          roughness: data.lighting.roughness,
          fresnel: data.lighting.fresnel,
          vertexNormalsEpsilon: data.lighting.vertexnormalsepsilon,
          faceNormalsEpsilon: data.lighting.facenormalsepsilon,
          opacity: data.opacity,
          opacityscale: data.opacityscale,
          contourEnable: data.contour.show,
          contourColor: str2RgbaArray(data.contour.color).slice(0, 3),
          contourWidth: data.contour.width,
          useFacetNormals: data.flatshading
      };
  
      var cOpts = extractOpts(data);
      config.vertexIntensity = data._meshIntensity;
      config.vertexIntensityBounds = [cOpts.min, cOpts.max];
      config.colormap = parseColorScale(data);
  
      // Update mesh
      this.mesh.update(config);
  };
  
  proto.dispose = function() {
      this.scene.glplot.remove(this.mesh);
      this.mesh.dispose();
  };
  
  function createVolumeTrace(scene, data) {
      var gl = scene.glplot.gl;
      var mesh = createMesh({gl: gl});
      var result = new VolumeTrace(scene, mesh, data.uid);
  
      mesh._trace = result;
      result.update(data);
      scene.glplot.add(mesh);
      return result;
  }
  
  module.exports = createVolumeTrace;
  
  },{"../../components/colorscale":627,"../../lib/gl_format_color":746,"../../lib/str2rgbarray":773,"../../plots/gl3d/zip3":852,"../isosurface/convert":1096,"gl-mesh3d":292}],1322:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var attributes = _dereq_('./attributes');
  var supplyIsoDefaults = _dereq_('../isosurface/defaults').supplyIsoDefaults;
  var opacityscaleDefaults = _dereq_('../surface/defaults').opacityscaleDefaults;
  
  module.exports = function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      supplyIsoDefaults(traceIn, traceOut, defaultColor, layout, coerce);
  
      opacityscaleDefaults(traceIn, traceOut, layout, coerce);
  };
  
  },{"../../lib":750,"../isosurface/defaults":1097,"../surface/defaults":1285,"./attributes":1320}],1323:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      supplyDefaults: _dereq_('./defaults'),
      calc: _dereq_('../isosurface/calc'),
      colorbar: {
          min: 'cmin',
          max: 'cmax'
      },
      plot: _dereq_('./convert'),
  
      moduleType: 'trace',
      name: 'volume',
      basePlotModule: _dereq_('../../plots/gl3d'),
      categories: ['gl3d', 'showLegend'],
      meta: {
          
      }
  };
  
  },{"../../plots/gl3d":841,"../isosurface/calc":1095,"./attributes":1320,"./convert":1321,"./defaults":1322}],1324:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var barAttrs = _dereq_('../bar/attributes');
  var lineAttrs = _dereq_('../scatter/attributes').line;
  var baseAttrs = _dereq_('../../plots/attributes');
  var hovertemplateAttrs = _dereq_('../../plots/template_attributes').hovertemplateAttrs;
  var texttemplateAttrs = _dereq_('../../plots/template_attributes').texttemplateAttrs;
  var constants = _dereq_('./constants');
  var extendFlat = _dereq_('../../lib/extend').extendFlat;
  var Color = _dereq_('../../components/color');
  
  function directionAttrs(dirTxt) {
      return {
          marker: {
              color: extendFlat({}, barAttrs.marker.color, {
                  arrayOk: false,
                  editType: 'style',
                  
              }),
              line: {
                  color: extendFlat({}, barAttrs.marker.line.color, {
                      arrayOk: false,
                      editType: 'style',
                      
                  }),
                  width: extendFlat({}, barAttrs.marker.line.width, {
                      arrayOk: false,
                      editType: 'style',
                      
                  }),
                  editType: 'style',
              },
              editType: 'style'
          },
          editType: 'style'
      };
  }
  
  module.exports = {
      measure: {
          valType: 'data_array',
          dflt: [],
          
          editType: 'calc',
          
      },
  
      base: {
          valType: 'number',
          dflt: null,
          arrayOk: false,
          
          editType: 'calc',
          
      },
  
      x: barAttrs.x,
      x0: barAttrs.x0,
      dx: barAttrs.dx,
      y: barAttrs.y,
      y0: barAttrs.y0,
      dy: barAttrs.dy,
  
      xperiod: barAttrs.xperiod,
      yperiod: barAttrs.yperiod,
      xperiod0: barAttrs.xperiod0,
      yperiod0: barAttrs.yperiod0,
      xperiodalignment: barAttrs.xperiodalignment,
      yperiodalignment: barAttrs.yperiodalignment,
  
      hovertext: barAttrs.hovertext,
      hovertemplate: hovertemplateAttrs({}, {
          keys: constants.eventDataKeys
      }),
  
      hoverinfo: extendFlat({}, baseAttrs.hoverinfo, {
          flags: ['name', 'x', 'y', 'text', 'initial', 'delta', 'final']
      }),
  
      textinfo: {
          valType: 'flaglist',
          flags: ['label', 'text', 'initial', 'delta', 'final'],
          extras: ['none'],
          
          editType: 'plot',
          arrayOk: false,
          
      },
      // TODO: incorporate `label` and `value` in the eventData
      texttemplate: texttemplateAttrs({editType: 'plot'}, {
          keys: constants.eventDataKeys.concat(['label'])
      }),
      text: barAttrs.text,
      textposition: barAttrs.textposition,
      insidetextanchor: barAttrs.insidetextanchor,
      textangle: barAttrs.textangle,
      textfont: barAttrs.textfont,
      insidetextfont: barAttrs.insidetextfont,
      outsidetextfont: barAttrs.outsidetextfont,
      constraintext: barAttrs.constraintext,
  
      cliponaxis: barAttrs.cliponaxis,
      orientation: barAttrs.orientation,
  
      offset: barAttrs.offset,
      width: barAttrs.width,
  
      increasing: directionAttrs('increasing'),
      decreasing: directionAttrs('decreasing'),
      totals: directionAttrs('intermediate sums and total'),
  
      connector: {
          line: {
              color: extendFlat({}, lineAttrs.color, {dflt: Color.defaultLine}),
              width: extendFlat({}, lineAttrs.width, {
                  editType: 'plot', // i.e. to adjust bars is mode: 'between'. See https://github.com/plotly/plotly.js/issues/3787
              }),
              dash: lineAttrs.dash,
              editType: 'plot'
          },
          mode: {
              valType: 'enumerated',
              values: ['spanning', 'between'],
              dflt: 'between',
              
              editType: 'plot',
              
          },
          visible: {
              valType: 'boolean',
              dflt: true,
              
              editType: 'plot',
              
          },
          editType: 'plot'
      },
  
      offsetgroup: barAttrs.offsetgroup,
      alignmentgroup: barAttrs.alignmentgroup
  };
  
  },{"../../components/color":615,"../../lib/extend":740,"../../plots/attributes":795,"../../plots/template_attributes":877,"../bar/attributes":892,"../scatter/attributes":1158,"./constants":1326}],1325:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../../plots/cartesian/axes');
  var alignPeriod = _dereq_('../../plots/cartesian/align_period');
  var mergeArray = _dereq_('../../lib').mergeArray;
  var calcSelection = _dereq_('../scatter/calc_selection');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  
  function isAbsolute(a) {
      return (a === 'a' || a === 'absolute');
  }
  
  function isTotal(a) {
      return (a === 't' || a === 'total');
  }
  
  module.exports = function calc(gd, trace) {
      var xa = Axes.getFromId(gd, trace.xaxis || 'x');
      var ya = Axes.getFromId(gd, trace.yaxis || 'y');
      var size, pos, origPos;
  
      var hasPeriod;
      if(trace.orientation === 'h') {
          size = xa.makeCalcdata(trace, 'x');
          origPos = ya.makeCalcdata(trace, 'y');
          pos = alignPeriod(trace, ya, 'y', origPos);
          hasPeriod = !!trace.yperiodalignment;
      } else {
          size = ya.makeCalcdata(trace, 'y');
          origPos = xa.makeCalcdata(trace, 'x');
          pos = alignPeriod(trace, xa, 'x', origPos);
          hasPeriod = !!trace.xperiodalignment;
      }
  
      // create the "calculated data" to plot
      var serieslen = Math.min(pos.length, size.length);
      var cd = new Array(serieslen);
  
      // set position and size (as well as for waterfall total size)
      var previousSum = 0;
      var newSize;
      // trace-wide flags
      var hasTotals = false;
  
      for(var i = 0; i < serieslen; i++) {
          var amount = size[i] || 0;
  
          var connectToNext = false;
          if(size[i] !== BADNUM || isTotal(trace.measure[i]) || isAbsolute(trace.measure[i])) {
              if(i + 1 < serieslen && (size[i + 1] !== BADNUM || isTotal(trace.measure[i + 1]) || isAbsolute(trace.measure[i + 1]))) {
                  connectToNext = true;
              }
          }
  
          var cdi = cd[i] = {
              i: i,
              p: pos[i],
              s: amount,
              rawS: amount,
              cNext: connectToNext
          };
  
          if(isAbsolute(trace.measure[i])) {
              previousSum = cdi.s;
  
              cdi.isSum = true;
              cdi.dir = 'totals';
              cdi.s = previousSum;
          } else if(isTotal(trace.measure[i])) {
              cdi.isSum = true;
              cdi.dir = 'totals';
              cdi.s = previousSum;
          } else {
              // default: relative
              cdi.isSum = false;
              cdi.dir = cdi.rawS < 0 ? 'decreasing' : 'increasing';
              newSize = cdi.s;
              cdi.s = previousSum + newSize;
              previousSum += newSize;
          }
  
          if(cdi.dir === 'totals') {
              hasTotals = true;
          }
  
          if(hasPeriod) {
              cd[i].orig_p = origPos[i]; // used by hover
          }
  
          if(trace.ids) {
              cdi.id = String(trace.ids[i]);
          }
  
          cdi.v = (trace.base || 0) + previousSum;
      }
  
      if(cd.length) cd[0].hasTotals = hasTotals;
  
      mergeArray(trace.text, cd, 'tx');
      mergeArray(trace.hovertext, cd, 'htx');
      calcSelection(cd, trace);
  
      return cd;
  };
  
  },{"../../constants/numerical":725,"../../lib":750,"../../plots/cartesian/align_period":796,"../../plots/cartesian/axes":799,"../scatter/calc_selection":1160}],1326:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      eventDataKeys: [
          'initial',
          'delta',
          'final'
      ]
  };
  
  },{}],1327:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var setGroupPositions = _dereq_('../bar/cross_trace_calc').setGroupPositions;
  
  module.exports = function crossTraceCalc(gd, plotinfo) {
      var fullLayout = gd._fullLayout;
      var fullData = gd._fullData;
      var calcdata = gd.calcdata;
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
      var waterfalls = [];
      var waterfallsVert = [];
      var waterfallsHorz = [];
      var cd, i;
  
      for(i = 0; i < fullData.length; i++) {
          var fullTrace = fullData[i];
  
          if(
              fullTrace.visible === true &&
              fullTrace.xaxis === xa._id &&
              fullTrace.yaxis === ya._id &&
              fullTrace.type === 'waterfall'
          ) {
              cd = calcdata[i];
  
              if(fullTrace.orientation === 'h') {
                  waterfallsHorz.push(cd);
              } else {
                  waterfallsVert.push(cd);
              }
  
              waterfalls.push(cd);
          }
      }
  
      var opts = {
          mode: fullLayout.waterfallmode,
          norm: fullLayout.waterfallnorm,
          gap: fullLayout.waterfallgap,
          groupgap: fullLayout.waterfallgroupgap
      };
  
      setGroupPositions(gd, xa, ya, waterfallsVert, opts);
      setGroupPositions(gd, ya, xa, waterfallsHorz, opts);
  
      for(i = 0; i < waterfalls.length; i++) {
          cd = waterfalls[i];
  
          for(var j = 0; j < cd.length; j++) {
              var di = cd[j];
  
              if(di.isSum === false) {
                  di.s0 += (j === 0) ? 0 : cd[j - 1].s;
              }
  
              if(j + 1 < cd.length) {
                  cd[j].nextP0 = cd[j + 1].p0;
                  cd[j].nextS0 = cd[j + 1].s0;
              }
          }
      }
  };
  
  },{"../bar/cross_trace_calc":895}],1328:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  
  var handleGroupingDefaults = _dereq_('../bar/defaults').handleGroupingDefaults;
  var handleText = _dereq_('../bar/defaults').handleText;
  var handleXYDefaults = _dereq_('../scatter/xy_defaults');
  var handlePeriodDefaults = _dereq_('../scatter/period_defaults');
  var attributes = _dereq_('./attributes');
  var Color = _dereq_('../../components/color');
  var delta = _dereq_('../../constants/delta.js');
  
  var INCREASING_COLOR = delta.INCREASING.COLOR;
  var DECREASING_COLOR = delta.DECREASING.COLOR;
  var TOTALS_COLOR = '#4499FF';
  
  function handleDirection(coerce, direction, defaultColor) {
      coerce(direction + '.marker.color', defaultColor);
      coerce(direction + '.marker.line.color', Color.defaultLine);
      coerce(direction + '.marker.line.width');
  }
  
  function supplyDefaults(traceIn, traceOut, defaultColor, layout) {
      function coerce(attr, dflt) {
          return Lib.coerce(traceIn, traceOut, attributes, attr, dflt);
      }
  
      var len = handleXYDefaults(traceIn, traceOut, layout, coerce);
      if(!len) {
          traceOut.visible = false;
          return;
      }
  
      handlePeriodDefaults(traceIn, traceOut, layout, coerce);
  
      coerce('measure');
  
      coerce('orientation', (traceOut.x && !traceOut.y) ? 'h' : 'v');
      coerce('base');
      coerce('offset');
      coerce('width');
  
      coerce('text');
  
      coerce('hovertext');
      coerce('hovertemplate');
  
      var textposition = coerce('textposition');
      handleText(traceIn, traceOut, layout, coerce, textposition, {
          moduleHasSelected: false,
          moduleHasUnselected: false,
          moduleHasConstrain: true,
          moduleHasCliponaxis: true,
          moduleHasTextangle: true,
          moduleHasInsideanchor: true
      });
  
  
      if(traceOut.textposition !== 'none') {
          coerce('texttemplate');
          if(!traceOut.texttemplate) coerce('textinfo');
      }
  
      handleDirection(coerce, 'increasing', INCREASING_COLOR);
      handleDirection(coerce, 'decreasing', DECREASING_COLOR);
      handleDirection(coerce, 'totals', TOTALS_COLOR);
  
      var connectorVisible = coerce('connector.visible');
      if(connectorVisible) {
          coerce('connector.mode');
          var connectorLineWidth = coerce('connector.line.width');
          if(connectorLineWidth) {
              coerce('connector.line.color');
              coerce('connector.line.dash');
          }
      }
  }
  
  function crossTraceDefaults(fullData, fullLayout) {
      var traceIn, traceOut;
  
      function coerce(attr) {
          return Lib.coerce(traceOut._input, traceOut, attributes, attr);
      }
  
      if(fullLayout.waterfallmode === 'group') {
          for(var i = 0; i < fullData.length; i++) {
              traceOut = fullData[i];
              traceIn = traceOut._input;
  
              handleGroupingDefaults(traceIn, traceOut, fullLayout, coerce);
          }
      }
  }
  
  module.exports = {
      supplyDefaults: supplyDefaults,
      crossTraceDefaults: crossTraceDefaults
  };
  
  },{"../../components/color":615,"../../constants/delta.js":719,"../../lib":750,"../bar/defaults":896,"../scatter/period_defaults":1178,"../scatter/xy_defaults":1185,"./attributes":1324}],1329:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = function eventData(out, pt /* , trace, cd, pointNumber */) {
      // standard cartesian event data
      out.x = 'xVal' in pt ? pt.xVal : pt.x;
      out.y = 'yVal' in pt ? pt.yVal : pt.y;
  
      // for funnel
      if('initial' in pt) out.initial = pt.initial;
      if('delta' in pt) out.delta = pt.delta;
      if('final' in pt) out.final = pt.final;
  
      if(pt.xa) out.xaxis = pt.xa;
      if(pt.ya) out.yaxis = pt.ya;
  
      return out;
  };
  
  },{}],1330:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var hoverLabelText = _dereq_('../../plots/cartesian/axes').hoverLabelText;
  var opacity = _dereq_('../../components/color').opacity;
  var hoverOnBars = _dereq_('../bar/hover').hoverOnBars;
  var delta = _dereq_('../../constants/delta.js');
  
  var DIRSYMBOL = {
      increasing: delta.INCREASING.SYMBOL,
      decreasing: delta.DECREASING.SYMBOL
  };
  
  module.exports = function hoverPoints(pointData, xval, yval, hovermode) {
      var point = hoverOnBars(pointData, xval, yval, hovermode);
      if(!point) return;
  
      var cd = point.cd;
      var trace = cd[0].trace;
      var isHorizontal = (trace.orientation === 'h');
  
      var vAxis = isHorizontal ? pointData.xa : pointData.ya;
  
      function formatNumber(a) {
          return hoverLabelText(vAxis, a);
      }
  
      // the closest data point
      var index = point.index;
      var di = cd[index];
  
      var size = (di.isSum) ? di.b + di.s : di.rawS;
  
      if(!di.isSum) {
          point.initial = di.b + di.s - size;
          point.delta = size;
          point.final = point.initial + point.delta;
  
          var v = formatNumber(Math.abs(point.delta));
          point.deltaLabel = size < 0 ? '(' + v + ')' : v;
          point.finalLabel = formatNumber(point.final);
          point.initialLabel = formatNumber(point.initial);
      }
  
      var hoverinfo = di.hi || trace.hoverinfo;
      var text = [];
      if(hoverinfo && hoverinfo !== 'none' && hoverinfo !== 'skip') {
          var isAll = (hoverinfo === 'all');
          var parts = hoverinfo.split('+');
  
          var hasFlag = function(flag) { return isAll || parts.indexOf(flag) !== -1; };
  
          if(!di.isSum) {
              if(hasFlag('final') &&
                  (isHorizontal ? !hasFlag('x') : !hasFlag('y')) // don't display redundant info.
              ) {
                  text.push(point.finalLabel);
              }
              if(hasFlag('delta')) {
                  if(size < 0) {
                      text.push(point.deltaLabel + ' ' + DIRSYMBOL.decreasing);
                  } else {
                      text.push(point.deltaLabel + ' ' + DIRSYMBOL.increasing);
                  }
              }
              if(hasFlag('initial')) {
                  text.push('Initial: ' + point.initialLabel);
              }
          }
      }
  
      if(text.length) point.extraText = text.join('<br>');
  
      point.color = getTraceColor(trace, di);
  
      return [point];
  };
  
  function getTraceColor(trace, di) {
      var cont = trace[di.dir].marker;
      var mc = cont.color;
      var mlc = cont.line.color;
      var mlw = cont.line.width;
      if(opacity(mc)) return mc;
      else if(opacity(mlc) && mlw) return mlc;
  }
  
  },{"../../components/color":615,"../../constants/delta.js":719,"../../plots/cartesian/axes":799,"../bar/hover":899}],1331:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      attributes: _dereq_('./attributes'),
      layoutAttributes: _dereq_('./layout_attributes'),
      supplyDefaults: _dereq_('./defaults').supplyDefaults,
      crossTraceDefaults: _dereq_('./defaults').crossTraceDefaults,
      supplyLayoutDefaults: _dereq_('./layout_defaults'),
      calc: _dereq_('./calc'),
      crossTraceCalc: _dereq_('./cross_trace_calc'),
      plot: _dereq_('./plot'),
      style: _dereq_('./style').style,
      hoverPoints: _dereq_('./hover'),
      eventData: _dereq_('./event_data'),
  
      selectPoints: _dereq_('../bar/select'),
  
      moduleType: 'trace',
      name: 'waterfall',
      basePlotModule: _dereq_('../../plots/cartesian'),
      categories: ['bar-like', 'cartesian', 'svg', 'oriented', 'showLegend', 'zoomScale'],
      meta: {
          
      }
  };
  
  },{"../../plots/cartesian":812,"../bar/select":904,"./attributes":1324,"./calc":1325,"./cross_trace_calc":1327,"./defaults":1328,"./event_data":1329,"./hover":1330,"./layout_attributes":1332,"./layout_defaults":1333,"./plot":1334,"./style":1335}],1332:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  module.exports = {
      waterfallmode: {
          valType: 'enumerated',
          values: ['group', 'overlay'],
          dflt: 'group',
          
          editType: 'calc',
          
      },
      waterfallgap: {
          valType: 'number',
          min: 0,
          max: 1,
          
          editType: 'calc',
          
      },
      waterfallgroupgap: {
          valType: 'number',
          min: 0,
          max: 1,
          dflt: 0,
          
          editType: 'calc',
          
      }
  };
  
  },{}],1333:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../../lib');
  var layoutAttributes = _dereq_('./layout_attributes');
  
  module.exports = function(layoutIn, layoutOut, fullData) {
      var hasTraceType = false;
  
      function coerce(attr, dflt) {
          return Lib.coerce(layoutIn, layoutOut, layoutAttributes, attr, dflt);
      }
  
      for(var i = 0; i < fullData.length; i++) {
          var trace = fullData[i];
  
          if(trace.visible && trace.type === 'waterfall') {
              hasTraceType = true;
              break;
          }
      }
  
      if(hasTraceType) {
          coerce('waterfallmode');
          coerce('waterfallgap', 0.2);
          coerce('waterfallgroupgap');
      }
  };
  
  },{"../../lib":750,"./layout_attributes":1332}],1334:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  var Lib = _dereq_('../../lib');
  var Drawing = _dereq_('../../components/drawing');
  var BADNUM = _dereq_('../../constants/numerical').BADNUM;
  var barPlot = _dereq_('../bar/plot');
  var clearMinTextSize = _dereq_('../bar/uniform_text').clearMinTextSize;
  
  module.exports = function plot(gd, plotinfo, cdModule, traceLayer) {
      var fullLayout = gd._fullLayout;
  
      clearMinTextSize('waterfall', fullLayout);
  
      barPlot.plot(gd, plotinfo, cdModule, traceLayer, {
          mode: fullLayout.waterfallmode,
          norm: fullLayout.waterfallmode,
          gap: fullLayout.waterfallgap,
          groupgap: fullLayout.waterfallgroupgap
      });
  
      plotConnectors(gd, plotinfo, cdModule, traceLayer);
  };
  
  function plotConnectors(gd, plotinfo, cdModule, traceLayer) {
      var xa = plotinfo.xaxis;
      var ya = plotinfo.yaxis;
  
      Lib.makeTraceGroups(traceLayer, cdModule, 'trace bars').each(function(cd) {
          var plotGroup = d3.select(this);
          var trace = cd[0].trace;
  
          var group = Lib.ensureSingle(plotGroup, 'g', 'lines');
  
          if(!trace.connector || !trace.connector.visible) {
              group.remove();
              return;
          }
  
          var isHorizontal = (trace.orientation === 'h');
          var mode = trace.connector.mode;
  
          var connectors = group.selectAll('g.line').data(Lib.identity);
  
          connectors.enter().append('g')
              .classed('line', true);
  
          connectors.exit().remove();
  
          var len = connectors.size();
  
          connectors.each(function(di, i) {
              // don't draw lines between nulls
              if(i !== len - 1 && !di.cNext) return;
  
              var xy = getXY(di, xa, ya, isHorizontal);
              var x = xy[0];
              var y = xy[1];
  
              var shape = '';
  
              if(
                  x[0] !== BADNUM && y[0] !== BADNUM &&
                  x[1] !== BADNUM && y[1] !== BADNUM
              ) {
                  if(mode === 'spanning') {
                      if(!di.isSum && i > 0) {
                          if(isHorizontal) {
                              shape += 'M' + x[0] + ',' + y[1] + 'V' + y[0];
                          } else {
                              shape += 'M' + x[1] + ',' + y[0] + 'H' + x[0];
                          }
                      }
                  }
  
                  if(mode !== 'between') {
                      if(di.isSum || i < len - 1) {
                          if(isHorizontal) {
                              shape += 'M' + x[1] + ',' + y[0] + 'V' + y[1];
                          } else {
                              shape += 'M' + x[0] + ',' + y[1] + 'H' + x[1];
                          }
                      }
                  }
  
                  if(x[2] !== BADNUM && y[2] !== BADNUM) {
                      if(isHorizontal) {
                          shape += 'M' + x[1] + ',' + y[1] + 'V' + y[2];
                      } else {
                          shape += 'M' + x[1] + ',' + y[1] + 'H' + x[2];
                      }
                  }
              }
  
              if(shape === '') shape = 'M0,0Z';
  
              Lib.ensureSingle(d3.select(this), 'path')
                  .attr('d', shape)
                  .call(Drawing.setClipUrl, plotinfo.layerClipId, gd);
          });
      });
  }
  
  function getXY(di, xa, ya, isHorizontal) {
      var s = [];
      var p = [];
  
      var sAxis = isHorizontal ? xa : ya;
      var pAxis = isHorizontal ? ya : xa;
  
      s[0] = sAxis.c2p(di.s0, true);
      p[0] = pAxis.c2p(di.p0, true);
  
      s[1] = sAxis.c2p(di.s1, true);
      p[1] = pAxis.c2p(di.p1, true);
  
      s[2] = sAxis.c2p(di.nextS0, true);
      p[2] = pAxis.c2p(di.nextP0, true);
  
      return isHorizontal ? [s, p] : [p, s];
  }
  
  },{"../../components/drawing":637,"../../constants/numerical":725,"../../lib":750,"../bar/plot":903,"../bar/uniform_text":908,"d3":169}],1335:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var d3 = _dereq_('d3');
  
  var Drawing = _dereq_('../../components/drawing');
  var Color = _dereq_('../../components/color');
  var DESELECTDIM = _dereq_('../../constants/interactions').DESELECTDIM;
  var barStyle = _dereq_('../bar/style');
  var resizeText = _dereq_('../bar/uniform_text').resizeText;
  var styleTextPoints = barStyle.styleTextPoints;
  
  function style(gd, cd, sel) {
      var s = sel ? sel : d3.select(gd).selectAll('g.waterfalllayer').selectAll('g.trace');
      resizeText(gd, s, 'waterfall');
  
      s.style('opacity', function(d) { return d[0].trace.opacity; });
  
      s.each(function(d) {
          var gTrace = d3.select(this);
          var trace = d[0].trace;
  
          gTrace.selectAll('.point > path').each(function(di) {
              if(!di.isBlank) {
                  var cont = trace[di.dir].marker;
  
                  d3.select(this)
                      .call(Color.fill, cont.color)
                      .call(Color.stroke, cont.line.color)
                      .call(Drawing.dashLine, cont.line.dash, cont.line.width)
                      .style('opacity', trace.selectedpoints && !di.selected ? DESELECTDIM : 1);
              }
          });
  
          styleTextPoints(gTrace, trace, gd);
  
          gTrace.selectAll('.lines').each(function() {
              var cont = trace.connector.line;
  
              Drawing.lineGroupStyle(
                  d3.select(this).selectAll('path'),
                  cont.width,
                  cont.color,
                  cont.dash
              );
          });
      });
  }
  
  module.exports = {
      style: style
  };
  
  },{"../../components/color":615,"../../components/drawing":637,"../../constants/interactions":724,"../bar/style":906,"../bar/uniform_text":908,"d3":169}],1336:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Axes = _dereq_('../plots/cartesian/axes');
  var Lib = _dereq_('../lib');
  var PlotSchema = _dereq_('../plot_api/plot_schema');
  var pointsAccessorFunction = _dereq_('./helpers').pointsAccessorFunction;
  var BADNUM = _dereq_('../constants/numerical').BADNUM;
  
  exports.moduleType = 'transform';
  
  exports.name = 'aggregate';
  
  var attrs = exports.attributes = {
      enabled: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          
      },
      groups: {
          // TODO: groupby should support string or array grouping this way too
          // currently groupby only allows a grouping array
          valType: 'string',
          strict: true,
          noBlank: true,
          arrayOk: true,
          dflt: 'x',
          
          editType: 'calc',
          
      },
      aggregations: {
          _isLinkedToArray: 'aggregation',
          target: {
              valType: 'string',
              
              editType: 'calc',
              
          },
          func: {
              valType: 'enumerated',
              values: ['count', 'sum', 'avg', 'median', 'mode', 'rms', 'stddev', 'min', 'max', 'first', 'last', 'change', 'range'],
              dflt: 'first',
              
              editType: 'calc',
              
          },
          funcmode: {
              valType: 'enumerated',
              values: ['sample', 'population'],
              dflt: 'sample',
              
              editType: 'calc',
              
          },
          enabled: {
              valType: 'boolean',
              dflt: true,
              
              editType: 'calc',
              
          },
          editType: 'calc'
      },
      editType: 'calc'
  };
  
  var aggAttrs = attrs.aggregations;
  
  /**
   * Supply transform attributes defaults
   *
   * @param {object} transformIn
   *  object linked to trace.transforms[i] with 'func' set to exports.name
   * @param {object} traceOut
   *  the _fullData trace this transform applies to
   * @param {object} layout
   *  the plot's (not-so-full) layout
   * @param {object} traceIn
   *  the input data trace this transform applies to
   *
   * @return {object} transformOut
   *  copy of transformIn that contains attribute defaults
   */
  exports.supplyDefaults = function(transformIn, traceOut) {
      var transformOut = {};
      var i;
  
      function coerce(attr, dflt) {
          return Lib.coerce(transformIn, transformOut, attrs, attr, dflt);
      }
  
      var enabled = coerce('enabled');
  
      if(!enabled) return transformOut;
  
      /*
       * Normally _arrayAttrs is calculated during doCalc, but that comes later.
       * Anyway this can change due to *count* aggregations (see below) so it's not
       * necessarily the same set.
       *
       * For performance we turn it into an object of truthy values
       * we'll use 1 for arrays we haven't aggregated yet, 0 for finished arrays,
       * as distinct from undefined which means this array isn't present in the input
       * missing arrays can still be aggregate outputs for *count* aggregations.
       */
      var arrayAttrArray = PlotSchema.findArrayAttributes(traceOut);
      var arrayAttrs = {};
      for(i = 0; i < arrayAttrArray.length; i++) arrayAttrs[arrayAttrArray[i]] = 1;
  
      var groups = coerce('groups');
  
      if(!Array.isArray(groups)) {
          if(!arrayAttrs[groups]) {
              transformOut.enabled = false;
              return transformOut;
          }
          arrayAttrs[groups] = 0;
      }
  
      var aggregationsIn = transformIn.aggregations || [];
      var aggregationsOut = transformOut.aggregations = new Array(aggregationsIn.length);
      var aggregationOut;
  
      function coercei(attr, dflt) {
          return Lib.coerce(aggregationsIn[i], aggregationOut, aggAttrs, attr, dflt);
      }
  
      for(i = 0; i < aggregationsIn.length; i++) {
          aggregationOut = {_index: i};
          var target = coercei('target');
          var func = coercei('func');
          var enabledi = coercei('enabled');
  
          // add this aggregation to the output only if it's the first instance
          // of a valid target attribute - or an unused target attribute with "count"
          if(enabledi && target && (arrayAttrs[target] || (func === 'count' && arrayAttrs[target] === undefined))) {
              if(func === 'stddev') coercei('funcmode');
  
              arrayAttrs[target] = 0;
              aggregationsOut[i] = aggregationOut;
          } else aggregationsOut[i] = {enabled: false, _index: i};
      }
  
      // any array attributes we haven't yet covered, fill them with the default aggregation
      for(i = 0; i < arrayAttrArray.length; i++) {
          if(arrayAttrs[arrayAttrArray[i]]) {
              aggregationsOut.push({
                  target: arrayAttrArray[i],
                  func: aggAttrs.func.dflt,
                  enabled: true,
                  _index: -1
              });
          }
      }
  
      return transformOut;
  };
  
  
  exports.calcTransform = function(gd, trace, opts) {
      if(!opts.enabled) return;
  
      var groups = opts.groups;
  
      var groupArray = Lib.getTargetArray(trace, {target: groups});
      if(!groupArray) return;
  
      var i, vi, groupIndex, newGrouping;
  
      var groupIndices = {};
      var indexToPoints = {};
      var groupings = [];
  
      var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
  
      var len = groupArray.length;
      if(trace._length) len = Math.min(len, trace._length);
  
      for(i = 0; i < len; i++) {
          vi = groupArray[i];
          groupIndex = groupIndices[vi];
          if(groupIndex === undefined) {
              groupIndices[vi] = groupings.length;
              newGrouping = [i];
              groupings.push(newGrouping);
              indexToPoints[groupIndices[vi]] = originalPointsAccessor(i);
          } else {
              groupings[groupIndex].push(i);
              indexToPoints[groupIndices[vi]] = (indexToPoints[groupIndices[vi]] || []).concat(originalPointsAccessor(i));
          }
      }
  
      opts._indexToPoints = indexToPoints;
  
      var aggregations = opts.aggregations;
  
      for(i = 0; i < aggregations.length; i++) {
          aggregateOneArray(gd, trace, groupings, aggregations[i]);
      }
  
      if(typeof groups === 'string') {
          aggregateOneArray(gd, trace, groupings, {
              target: groups,
              func: 'first',
              enabled: true
          });
      }
  
      trace._length = groupings.length;
  };
  
  function aggregateOneArray(gd, trace, groupings, aggregation) {
      if(!aggregation.enabled) return;
  
      var attr = aggregation.target;
      var targetNP = Lib.nestedProperty(trace, attr);
      var arrayIn = targetNP.get();
      var conversions = Axes.getDataConversions(gd, trace, attr, arrayIn);
      var func = getAggregateFunction(aggregation, conversions);
  
      var arrayOut = new Array(groupings.length);
      for(var i = 0; i < groupings.length; i++) {
          arrayOut[i] = func(arrayIn, groupings[i]);
      }
      targetNP.set(arrayOut);
  
      if(aggregation.func === 'count') {
          // count does not depend on an input array, so it's likely not part of _arrayAttrs yet
          // but after this transform it most definitely *is* an array attribute.
          Lib.pushUnique(trace._arrayAttrs, attr);
      }
  }
  
  function getAggregateFunction(opts, conversions) {
      var func = opts.func;
      var d2c = conversions.d2c;
      var c2d = conversions.c2d;
  
      switch(func) {
          // count, first, and last don't depend on anything about the data
          // point back to pure functions for performance
          case 'count':
              return count;
          case 'first':
              return first;
          case 'last':
              return last;
  
          case 'sum':
              // This will produce output in all cases even though it's nonsensical
              // for date or category data.
              return function(array, indices) {
                  var total = 0;
                  for(var i = 0; i < indices.length; i++) {
                      var vi = d2c(array[indices[i]]);
                      if(vi !== BADNUM) total += vi;
                  }
                  return c2d(total);
              };
  
          case 'avg':
              // Generally meaningless for category data but it still does something.
              return function(array, indices) {
                  var total = 0;
                  var cnt = 0;
                  for(var i = 0; i < indices.length; i++) {
                      var vi = d2c(array[indices[i]]);
                      if(vi !== BADNUM) {
                          total += vi;
                          cnt++;
                      }
                  }
                  return cnt ? c2d(total / cnt) : BADNUM;
              };
  
          case 'min':
              return function(array, indices) {
                  var out = Infinity;
                  for(var i = 0; i < indices.length; i++) {
                      var vi = d2c(array[indices[i]]);
                      if(vi !== BADNUM) out = Math.min(out, vi);
                  }
                  return (out === Infinity) ? BADNUM : c2d(out);
              };
  
          case 'max':
              return function(array, indices) {
                  var out = -Infinity;
                  for(var i = 0; i < indices.length; i++) {
                      var vi = d2c(array[indices[i]]);
                      if(vi !== BADNUM) out = Math.max(out, vi);
                  }
                  return (out === -Infinity) ? BADNUM : c2d(out);
              };
  
          case 'range':
              return function(array, indices) {
                  var min = Infinity;
                  var max = -Infinity;
                  for(var i = 0; i < indices.length; i++) {
                      var vi = d2c(array[indices[i]]);
                      if(vi !== BADNUM) {
                          min = Math.min(min, vi);
                          max = Math.max(max, vi);
                      }
                  }
                  return (max === -Infinity || min === Infinity) ? BADNUM : c2d(max - min);
              };
  
          case 'change':
              return function(array, indices) {
                  var first = d2c(array[indices[0]]);
                  var last = d2c(array[indices[indices.length - 1]]);
                  return (first === BADNUM || last === BADNUM) ? BADNUM : c2d(last - first);
              };
  
          case 'median':
              return function(array, indices) {
                  var sortCalc = [];
                  for(var i = 0; i < indices.length; i++) {
                      var vi = d2c(array[indices[i]]);
                      if(vi !== BADNUM) sortCalc.push(vi);
                  }
                  if(!sortCalc.length) return BADNUM;
                  sortCalc.sort(Lib.sorterAsc);
                  var mid = (sortCalc.length - 1) / 2;
                  return c2d((sortCalc[Math.floor(mid)] + sortCalc[Math.ceil(mid)]) / 2);
              };
  
          case 'mode':
              return function(array, indices) {
                  var counts = {};
                  var maxCnt = 0;
                  var out = BADNUM;
                  for(var i = 0; i < indices.length; i++) {
                      var vi = d2c(array[indices[i]]);
                      if(vi !== BADNUM) {
                          var counti = counts[vi] = (counts[vi] || 0) + 1;
                          if(counti > maxCnt) {
                              maxCnt = counti;
                              out = vi;
                          }
                      }
                  }
                  return maxCnt ? c2d(out) : BADNUM;
              };
  
          case 'rms':
              return function(array, indices) {
                  var total = 0;
                  var cnt = 0;
                  for(var i = 0; i < indices.length; i++) {
                      var vi = d2c(array[indices[i]]);
                      if(vi !== BADNUM) {
                          total += vi * vi;
                          cnt++;
                      }
                  }
                  return cnt ? c2d(Math.sqrt(total / cnt)) : BADNUM;
              };
  
          case 'stddev':
              return function(array, indices) {
                  // balance numerical stability with performance:
                  // so that we call d2c once per element but don't need to
                  // store them, reference all to the first element
                  var total = 0;
                  var total2 = 0;
                  var cnt = 1;
                  var v0 = BADNUM;
                  var i;
                  for(i = 0; i < indices.length && v0 === BADNUM; i++) {
                      v0 = d2c(array[indices[i]]);
                  }
                  if(v0 === BADNUM) return BADNUM;
  
                  for(; i < indices.length; i++) {
                      var vi = d2c(array[indices[i]]);
                      if(vi !== BADNUM) {
                          var dv = vi - v0;
                          total += dv;
                          total2 += dv * dv;
                          cnt++;
                      }
                  }
  
                  // This is population std dev, if we want sample std dev
                  // we would need (...) / (cnt - 1)
                  // Also note there's no c2d here - that means for dates the result
                  // is a number of milliseconds, and for categories it's a number
                  // of category differences, which is not generically meaningful but
                  // as in other cases we don't forbid it.
                  var norm = (opts.funcmode === 'sample') ? (cnt - 1) : cnt;
                  // this is debatable: should a count of 1 return sample stddev of
                  // 0 or undefined?
                  if(!norm) return 0;
                  return Math.sqrt((total2 - (total * total / cnt)) / norm);
              };
      }
  }
  
  function count(array, indices) {
      return indices.length;
  }
  
  function first(array, indices) {
      return array[indices[0]];
  }
  
  function last(array, indices) {
      return array[indices[indices.length - 1]];
  }
  
  },{"../constants/numerical":725,"../lib":750,"../plot_api/plot_schema":787,"../plots/cartesian/axes":799,"./helpers":1339}],1337:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var Registry = _dereq_('../registry');
  var Axes = _dereq_('../plots/cartesian/axes');
  var pointsAccessorFunction = _dereq_('./helpers').pointsAccessorFunction;
  
  var filterOps = _dereq_('../constants/filter_ops');
  var COMPARISON_OPS = filterOps.COMPARISON_OPS;
  var INTERVAL_OPS = filterOps.INTERVAL_OPS;
  var SET_OPS = filterOps.SET_OPS;
  
  exports.moduleType = 'transform';
  
  exports.name = 'filter';
  
  exports.attributes = {
      enabled: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          
      },
      target: {
          valType: 'string',
          strict: true,
          noBlank: true,
          arrayOk: true,
          dflt: 'x',
          
          editType: 'calc',
          
      },
      operation: {
          valType: 'enumerated',
          values: []
              .concat(COMPARISON_OPS)
              .concat(INTERVAL_OPS)
              .concat(SET_OPS),
          dflt: '=',
          
          editType: 'calc',
          
      },
      value: {
          valType: 'any',
          dflt: 0,
          
          editType: 'calc',
          
      },
      preservegaps: {
          valType: 'boolean',
          dflt: false,
          
          editType: 'calc',
          
      },
      editType: 'calc'
  };
  
  exports.supplyDefaults = function(transformIn) {
      var transformOut = {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(transformIn, transformOut, exports.attributes, attr, dflt);
      }
  
      var enabled = coerce('enabled');
  
      if(enabled) {
          var target = coerce('target');
  
          if(Lib.isArrayOrTypedArray(target) && target.length === 0) {
              transformOut.enabled = false;
              return transformOut;
          }
  
          coerce('preservegaps');
          coerce('operation');
          coerce('value');
  
          var handleCalendarDefaults = Registry.getComponentMethod('calendars', 'handleDefaults');
          handleCalendarDefaults(transformIn, transformOut, 'valuecalendar', null);
          handleCalendarDefaults(transformIn, transformOut, 'targetcalendar', null);
      }
  
      return transformOut;
  };
  
  exports.calcTransform = function(gd, trace, opts) {
      if(!opts.enabled) return;
  
      var targetArray = Lib.getTargetArray(trace, opts);
      if(!targetArray) return;
  
      var target = opts.target;
  
      var len = targetArray.length;
      if(trace._length) len = Math.min(len, trace._length);
  
      var targetCalendar = opts.targetcalendar;
      var arrayAttrs = trace._arrayAttrs;
      var preservegaps = opts.preservegaps;
  
      // even if you provide targetcalendar, if target is a string and there
      // is a calendar attribute matching target it will get used instead.
      if(typeof target === 'string') {
          var attrTargetCalendar = Lib.nestedProperty(trace, target + 'calendar').get();
          if(attrTargetCalendar) targetCalendar = attrTargetCalendar;
      }
  
      var d2c = Axes.getDataToCoordFunc(gd, trace, target, targetArray);
      var filterFunc = getFilterFunc(opts, d2c, targetCalendar);
      var originalArrays = {};
      var indexToPoints = {};
      var index = 0;
  
      function forAllAttrs(fn, index) {
          for(var j = 0; j < arrayAttrs.length; j++) {
              var np = Lib.nestedProperty(trace, arrayAttrs[j]);
              fn(np, index);
          }
      }
  
      var initFn;
      var fillFn;
      if(preservegaps) {
          initFn = function(np) {
              originalArrays[np.astr] = Lib.extendDeep([], np.get());
              np.set(new Array(len));
          };
          fillFn = function(np, index) {
              var val = originalArrays[np.astr][index];
              np.get()[index] = val;
          };
      } else {
          initFn = function(np) {
              originalArrays[np.astr] = Lib.extendDeep([], np.get());
              np.set([]);
          };
          fillFn = function(np, index) {
              var val = originalArrays[np.astr][index];
              np.get().push(val);
          };
      }
  
      // copy all original array attribute values, and clear arrays in trace
      forAllAttrs(initFn);
  
      var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
  
      // loop through filter array, fill trace arrays if passed
      for(var i = 0; i < len; i++) {
          var passed = filterFunc(targetArray[i]);
          if(passed) {
              forAllAttrs(fillFn, i);
              indexToPoints[index++] = originalPointsAccessor(i);
          } else if(preservegaps) index++;
      }
  
      opts._indexToPoints = indexToPoints;
      trace._length = index;
  };
  
  function getFilterFunc(opts, d2c, targetCalendar) {
      var operation = opts.operation;
      var value = opts.value;
      var hasArrayValue = Array.isArray(value);
  
      function isOperationIn(array) {
          return array.indexOf(operation) !== -1;
      }
  
      var d2cValue = function(v) { return d2c(v, 0, opts.valuecalendar); };
      var d2cTarget = function(v) { return d2c(v, 0, targetCalendar); };
  
      var coercedValue;
  
      if(isOperationIn(COMPARISON_OPS)) {
          coercedValue = hasArrayValue ? d2cValue(value[0]) : d2cValue(value);
      } else if(isOperationIn(INTERVAL_OPS)) {
          coercedValue = hasArrayValue ?
              [d2cValue(value[0]), d2cValue(value[1])] :
              [d2cValue(value), d2cValue(value)];
      } else if(isOperationIn(SET_OPS)) {
          coercedValue = hasArrayValue ? value.map(d2cValue) : [d2cValue(value)];
      }
  
      switch(operation) {
          case '=':
              return function(v) { return d2cTarget(v) === coercedValue; };
  
          case '!=':
              return function(v) { return d2cTarget(v) !== coercedValue; };
  
          case '<':
              return function(v) { return d2cTarget(v) < coercedValue; };
  
          case '<=':
              return function(v) { return d2cTarget(v) <= coercedValue; };
  
          case '>':
              return function(v) { return d2cTarget(v) > coercedValue; };
  
          case '>=':
              return function(v) { return d2cTarget(v) >= coercedValue; };
  
          case '[]':
              return function(v) {
                  var cv = d2cTarget(v);
                  return cv >= coercedValue[0] && cv <= coercedValue[1];
              };
  
          case '()':
              return function(v) {
                  var cv = d2cTarget(v);
                  return cv > coercedValue[0] && cv < coercedValue[1];
              };
  
          case '[)':
              return function(v) {
                  var cv = d2cTarget(v);
                  return cv >= coercedValue[0] && cv < coercedValue[1];
              };
  
          case '(]':
              return function(v) {
                  var cv = d2cTarget(v);
                  return cv > coercedValue[0] && cv <= coercedValue[1];
              };
  
          case '][':
              return function(v) {
                  var cv = d2cTarget(v);
                  return cv <= coercedValue[0] || cv >= coercedValue[1];
              };
  
          case ')(':
              return function(v) {
                  var cv = d2cTarget(v);
                  return cv < coercedValue[0] || cv > coercedValue[1];
              };
  
          case '](':
              return function(v) {
                  var cv = d2cTarget(v);
                  return cv <= coercedValue[0] || cv > coercedValue[1];
              };
  
          case ')[':
              return function(v) {
                  var cv = d2cTarget(v);
                  return cv < coercedValue[0] || cv >= coercedValue[1];
              };
  
          case '{}':
              return function(v) {
                  return coercedValue.indexOf(d2cTarget(v)) !== -1;
              };
  
          case '}{':
              return function(v) {
                  return coercedValue.indexOf(d2cTarget(v)) === -1;
              };
      }
  }
  
  },{"../constants/filter_ops":721,"../lib":750,"../plots/cartesian/axes":799,"../registry":882,"./helpers":1339}],1338:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var PlotSchema = _dereq_('../plot_api/plot_schema');
  var Plots = _dereq_('../plots/plots');
  var pointsAccessorFunction = _dereq_('./helpers').pointsAccessorFunction;
  
  exports.moduleType = 'transform';
  
  exports.name = 'groupby';
  
  exports.attributes = {
      enabled: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          
      },
      groups: {
          valType: 'data_array',
          dflt: [],
          
          editType: 'calc',
          
      },
      nameformat: {
          valType: 'string',
          
          editType: 'calc',
          
      },
      styles: {
          _isLinkedToArray: 'style',
          target: {
              valType: 'string',
              
              editType: 'calc',
              
          },
          value: {
              valType: 'any',
              
              dflt: {},
              editType: 'calc',
              
              _compareAsJSON: true
          },
          editType: 'calc'
      },
      editType: 'calc'
  };
  
  /**
   * Supply transform attributes defaults
   *
   * @param {object} transformIn
   *  object linked to trace.transforms[i] with 'type' set to exports.name
   * @param {object} traceOut
   *  the _fullData trace this transform applies to
   * @param {object} layout
   *  the plot's (not-so-full) layout
   * @param {object} traceIn
   *  the input data trace this transform applies to
   *
   * @return {object} transformOut
   *  copy of transformIn that contains attribute defaults
   */
  exports.supplyDefaults = function(transformIn, traceOut, layout) {
      var i;
      var transformOut = {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(transformIn, transformOut, exports.attributes, attr, dflt);
      }
  
      var enabled = coerce('enabled');
  
      if(!enabled) return transformOut;
  
      coerce('groups');
      coerce('nameformat', layout._dataLength > 1 ? '%{group} (%{trace})' : '%{group}');
  
      var styleIn = transformIn.styles;
      var styleOut = transformOut.styles = [];
  
      if(styleIn) {
          for(i = 0; i < styleIn.length; i++) {
              var thisStyle = styleOut[i] = {};
              Lib.coerce(styleIn[i], styleOut[i], exports.attributes.styles, 'target');
              var value = Lib.coerce(styleIn[i], styleOut[i], exports.attributes.styles, 'value');
  
              // so that you can edit value in place and have Plotly.react notice it, or
              // rebuild it every time and have Plotly.react NOT think it changed:
              // use _compareAsJSON to say we should diff the _JSON_value
              if(Lib.isPlainObject(value)) thisStyle.value = Lib.extendDeep({}, value);
              else if(value) delete thisStyle.value;
          }
      }
  
      return transformOut;
  };
  
  
  /**
   * Apply transform !!!
   *
   * @param {array} data
   *  array of transformed traces (is [fullTrace] upon first transform)
   *
   * @param {object} state
   *  state object which includes:
   *      - transform {object} full transform attributes
   *      - fullTrace {object} full trace object which is being transformed
   *      - fullData {array} full pre-transform(s) data array
   *      - layout {object} the plot's (not-so-full) layout
   *
   * @return {object} newData
   *  array of transformed traces
   */
  exports.transform = function(data, state) {
      var newTraces, i, j;
      var newData = [];
  
      for(i = 0; i < data.length; i++) {
          newTraces = transformOne(data[i], state);
  
          for(j = 0; j < newTraces.length; j++) {
              newData.push(newTraces[j]);
          }
      }
  
      return newData;
  };
  
  function transformOne(trace, state) {
      var i, j, k, attr, srcArray, groupName, newTrace, transforms, arrayLookup;
      var groupNameObj;
  
      var opts = state.transform;
      var transformIndex = state.transformIndex;
      var groups = trace.transforms[transformIndex].groups;
      var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
  
      if(!(Lib.isArrayOrTypedArray(groups)) || groups.length === 0) {
          return [trace];
      }
  
      var groupNames = Lib.filterUnique(groups);
      var newData = new Array(groupNames.length);
      var len = groups.length;
  
      var arrayAttrs = PlotSchema.findArrayAttributes(trace);
  
      var styles = opts.styles || [];
      var styleLookup = {};
      for(i = 0; i < styles.length; i++) {
          styleLookup[styles[i].target] = styles[i].value;
      }
  
      if(opts.styles) {
          groupNameObj = Lib.keyedContainer(opts, 'styles', 'target', 'value.name');
      }
  
      // An index to map group name --> expanded trace index
      var indexLookup = {};
      var indexCnts = {};
  
      for(i = 0; i < groupNames.length; i++) {
          groupName = groupNames[i];
          indexLookup[groupName] = i;
          indexCnts[groupName] = 0;
  
          // Start with a deep extend that just copies array references.
          newTrace = newData[i] = Lib.extendDeepNoArrays({}, trace);
          newTrace._group = groupName;
          newTrace.transforms[transformIndex]._indexToPoints = {};
  
          var suppliedName = null;
          if(groupNameObj) {
              suppliedName = groupNameObj.get(groupName);
          }
  
          if(suppliedName || suppliedName === '') {
              newTrace.name = suppliedName;
          } else {
              newTrace.name = Lib.templateString(opts.nameformat, {
                  trace: trace.name,
                  group: groupName
              });
          }
  
          // In order for groups to apply correctly to other transform data (e.g.
          // a filter transform), we have to break the connection and clone the
          // transforms so that each group writes grouped values into a different
          // destination. This function does not break the array reference
          // connection between the split transforms it creates. That's handled in
          // initialize, which creates a new empty array for each arrayAttr.
          transforms = newTrace.transforms;
          newTrace.transforms = [];
          for(j = 0; j < transforms.length; j++) {
              newTrace.transforms[j] = Lib.extendDeepNoArrays({}, transforms[j]);
          }
  
          // Initialize empty arrays for the arrayAttrs, to be split in the next step
          for(j = 0; j < arrayAttrs.length; j++) {
              Lib.nestedProperty(newTrace, arrayAttrs[j]).set([]);
          }
      }
  
      // For each array attribute including those nested inside this and other
      // transforms (small note that we technically only need to do this for
      // transforms that have not yet been applied):
      for(k = 0; k < arrayAttrs.length; k++) {
          attr = arrayAttrs[k];
  
          // Cache all the arrays to which we'll push:
          for(j = 0, arrayLookup = []; j < groupNames.length; j++) {
              arrayLookup[j] = Lib.nestedProperty(newData[j], attr).get();
          }
  
          // Get the input data:
          srcArray = Lib.nestedProperty(trace, attr).get();
  
          // Send each data point to the appropriate expanded trace:
          for(j = 0; j < len; j++) {
              // Map group data --> trace index --> array and push data onto it
              arrayLookup[indexLookup[groups[j]]].push(srcArray[j]);
          }
      }
  
      for(j = 0; j < len; j++) {
          newTrace = newData[indexLookup[groups[j]]];
  
          var indexToPoints = newTrace.transforms[transformIndex]._indexToPoints;
          indexToPoints[indexCnts[groups[j]]] = originalPointsAccessor(j);
          indexCnts[groups[j]]++;
      }
  
      for(i = 0; i < groupNames.length; i++) {
          groupName = groupNames[i];
          newTrace = newData[i];
  
          Plots.clearExpandedTraceDefaultColors(newTrace);
  
          // there's no need to coerce styleLookup[groupName] here
          // as another round of supplyDefaults is done on the transformed traces
          newTrace = Lib.extendDeepNoArrays(newTrace, styleLookup[groupName] || {});
      }
  
      return newData;
  }
  
  },{"../lib":750,"../plot_api/plot_schema":787,"../plots/plots":862,"./helpers":1339}],1339:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  exports.pointsAccessorFunction = function(transforms, opts) {
      var tr;
      var prevIndexToPoints;
      for(var i = 0; i < transforms.length; i++) {
          tr = transforms[i];
          if(tr === opts) break;
          if(!tr._indexToPoints || tr.enabled === false) continue;
          prevIndexToPoints = tr._indexToPoints;
      }
      var originalPointsAccessor = prevIndexToPoints ?
          function(i) {return prevIndexToPoints[i];} :
          function(i) {return [i];};
      return originalPointsAccessor;
  };
  
  },{}],1340:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  var Lib = _dereq_('../lib');
  var Axes = _dereq_('../plots/cartesian/axes');
  var pointsAccessorFunction = _dereq_('./helpers').pointsAccessorFunction;
  
  var BADNUM = _dereq_('../constants/numerical').BADNUM;
  
  exports.moduleType = 'transform';
  
  exports.name = 'sort';
  
  exports.attributes = {
      enabled: {
          valType: 'boolean',
          dflt: true,
          
          editType: 'calc',
          
      },
      target: {
          valType: 'string',
          strict: true,
          noBlank: true,
          arrayOk: true,
          dflt: 'x',
          
          editType: 'calc',
          
      },
      order: {
          valType: 'enumerated',
          values: ['ascending', 'descending'],
          dflt: 'ascending',
          
          editType: 'calc',
          
      },
      editType: 'calc'
  };
  
  exports.supplyDefaults = function(transformIn) {
      var transformOut = {};
  
      function coerce(attr, dflt) {
          return Lib.coerce(transformIn, transformOut, exports.attributes, attr, dflt);
      }
  
      var enabled = coerce('enabled');
  
      if(enabled) {
          coerce('target');
          coerce('order');
      }
  
      return transformOut;
  };
  
  exports.calcTransform = function(gd, trace, opts) {
      if(!opts.enabled) return;
  
      var targetArray = Lib.getTargetArray(trace, opts);
      if(!targetArray) return;
  
      var target = opts.target;
  
      var len = targetArray.length;
      if(trace._length) len = Math.min(len, trace._length);
  
      var arrayAttrs = trace._arrayAttrs;
      var d2c = Axes.getDataToCoordFunc(gd, trace, target, targetArray);
      var indices = getIndices(opts, targetArray, d2c, len);
      var originalPointsAccessor = pointsAccessorFunction(trace.transforms, opts);
      var indexToPoints = {};
      var i, j;
  
      for(i = 0; i < arrayAttrs.length; i++) {
          var np = Lib.nestedProperty(trace, arrayAttrs[i]);
          var arrayOld = np.get();
          var arrayNew = new Array(len);
  
          for(j = 0; j < len; j++) {
              arrayNew[j] = arrayOld[indices[j]];
          }
  
          np.set(arrayNew);
      }
  
      for(j = 0; j < len; j++) {
          indexToPoints[j] = originalPointsAccessor(indices[j]);
      }
  
      opts._indexToPoints = indexToPoints;
      trace._length = len;
  };
  
  function getIndices(opts, targetArray, d2c, len) {
      var sortedArray = new Array(len);
      var indices = new Array(len);
      var i;
  
      for(i = 0; i < len; i++) {
          sortedArray[i] = {v: targetArray[i], i: i};
      }
  
      sortedArray.sort(getSortFunc(opts, d2c));
  
      for(i = 0; i < len; i++) {
          indices[i] = sortedArray[i].i;
      }
  
      return indices;
  }
  
  function getSortFunc(opts, d2c) {
      switch(opts.order) {
          case 'ascending':
              return function(a, b) {
                  var ac = d2c(a.v);
                  var bc = d2c(b.v);
                  if(ac === BADNUM) {
                      return 1;
                  }
                  if(bc === BADNUM) {
                      return -1;
                  }
                  return ac - bc;
              };
          case 'descending':
              return function(a, b) {
                  var ac = d2c(a.v);
                  var bc = d2c(b.v);
                  if(ac === BADNUM) {
                      return 1;
                  }
                  if(bc === BADNUM) {
                      return -1;
                  }
                  return bc - ac;
              };
      }
  }
  
  },{"../constants/numerical":725,"../lib":750,"../plots/cartesian/axes":799,"./helpers":1339}],1341:[function(_dereq_,module,exports){
  /**
  * Copyright 2012-2020, Plotly, Inc.
  * All rights reserved.
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE file in the root directory of this source tree.
  */
  
  'use strict';
  
  // package version injected by `npm run preprocess`
  exports.version = '1.57.1';
  
  },{}]},{},[26])(26)
  });